(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2d52"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2d52"] = parcelRequire;
}
parcelRequire.register("C7mD2", function(module, exports) {
"use strict";

module.exports = (parcelRequire("bfjub"));

});
parcelRequire.register("bfjub", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $830035e634c3c743$export$ffb0004e005737fa; }, function (v) { return $830035e634c3c743$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $830035e634c3c743$export$34b9dba7ce09269b; }, function (v) { return $830035e634c3c743$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $830035e634c3c743$export$25062201e9e25d76; }, function (v) { return $830035e634c3c743$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $830035e634c3c743$export$ffb0004e005737fa;
var $830035e634c3c743$export$34b9dba7ce09269b;
var $830035e634c3c743$export$25062201e9e25d76;
"use strict";

var $jC8Vy = parcelRequire("jC8Vy");
var $830035e634c3c743$var$k = Symbol.for("react.element"), $830035e634c3c743$var$l = Symbol.for("react.fragment"), $830035e634c3c743$var$m = Object.prototype.hasOwnProperty, $830035e634c3c743$var$n = $jC8Vy.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $830035e634c3c743$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $830035e634c3c743$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$830035e634c3c743$var$m.call(a, b) && !$830035e634c3c743$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $830035e634c3c743$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $830035e634c3c743$var$n.current
    };
}
$830035e634c3c743$export$ffb0004e005737fa = $830035e634c3c743$var$l;
$830035e634c3c743$export$34b9dba7ce09269b = $830035e634c3c743$var$q;
$830035e634c3c743$export$25062201e9e25d76 = $830035e634c3c743$var$q;

});
parcelRequire.register("jC8Vy", function(module, exports) {
"use strict";

module.exports = (parcelRequire("e4nYF"));

});
parcelRequire.register("e4nYF", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $a3e409d5af0940ff$export$dca3b0875bd9a954; }, function (v) { return $a3e409d5af0940ff$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $a3e409d5af0940ff$export$16fa2f45be04daa8; }, function (v) { return $a3e409d5af0940ff$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $a3e409d5af0940ff$export$ffb0004e005737fa; }, function (v) { return $a3e409d5af0940ff$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $a3e409d5af0940ff$export$e2c29f18771995cb; }, function (v) { return $a3e409d5af0940ff$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $a3e409d5af0940ff$export$221d75b3f55bb0bd; }, function (v) { return $a3e409d5af0940ff$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $a3e409d5af0940ff$export$5f8d39834fd61797; }, function (v) { return $a3e409d5af0940ff$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $a3e409d5af0940ff$export$74bf444e3cd11ea5; }, function (v) { return $a3e409d5af0940ff$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $a3e409d5af0940ff$export$ae55be85d98224ed; }, function (v) { return $a3e409d5af0940ff$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $a3e409d5af0940ff$export$e530037191fcd5d7; }, function (v) { return $a3e409d5af0940ff$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $a3e409d5af0940ff$export$fd42f52fd3ae1109; }, function (v) { return $a3e409d5af0940ff$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $a3e409d5af0940ff$export$c8a8987d4410bf2d; }, function (v) { return $a3e409d5af0940ff$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $a3e409d5af0940ff$export$d38cd72104c1f0e9; }, function (v) { return $a3e409d5af0940ff$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $a3e409d5af0940ff$export$7d1e3a5e95ceca43; }, function (v) { return $a3e409d5af0940ff$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $a3e409d5af0940ff$export$257a8862b851cb5b; }, function (v) { return $a3e409d5af0940ff$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $a3e409d5af0940ff$export$a8257692ac88316c; }, function (v) { return $a3e409d5af0940ff$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $a3e409d5af0940ff$export$488013bae63b21da; }, function (v) { return $a3e409d5af0940ff$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $a3e409d5af0940ff$export$7c73462e0d25e514; }, function (v) { return $a3e409d5af0940ff$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $a3e409d5af0940ff$export$7568632d0d33d16d; }, function (v) { return $a3e409d5af0940ff$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $a3e409d5af0940ff$export$88948ce120ea2619; }, function (v) { return $a3e409d5af0940ff$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $a3e409d5af0940ff$export$35808ee640e87ca7; }, function (v) { return $a3e409d5af0940ff$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $a3e409d5af0940ff$export$fae74005e78b1a27; }, function (v) { return $a3e409d5af0940ff$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $a3e409d5af0940ff$export$dc8fbce3eb94dc1e; }, function (v) { return $a3e409d5af0940ff$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $a3e409d5af0940ff$export$6a7bc4e911dc01cf; }, function (v) { return $a3e409d5af0940ff$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $a3e409d5af0940ff$export$6d9c69b0de29b591; }, function (v) { return $a3e409d5af0940ff$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $a3e409d5af0940ff$export$f680877a34711e37; }, function (v) { return $a3e409d5af0940ff$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $a3e409d5af0940ff$export$d5a552a76deda3c2; }, function (v) { return $a3e409d5af0940ff$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $a3e409d5af0940ff$export$aaabe4eda9ed9969; }, function (v) { return $a3e409d5af0940ff$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $a3e409d5af0940ff$export$e5c5a5f917a5871c; }, function (v) { return $a3e409d5af0940ff$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $a3e409d5af0940ff$export$1538c33de8887b59; }, function (v) { return $a3e409d5af0940ff$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $a3e409d5af0940ff$export$13e3392192263954; }, function (v) { return $a3e409d5af0940ff$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $a3e409d5af0940ff$export$b8f5890fc79d6aca; }, function (v) { return $a3e409d5af0940ff$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $a3e409d5af0940ff$export$60241385465d0a34; }, function (v) { return $a3e409d5af0940ff$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $a3e409d5af0940ff$export$306c0aa65ff9ec16; }, function (v) { return $a3e409d5af0940ff$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $a3e409d5af0940ff$export$7b286972b8d8ccbf; }, function (v) { return $a3e409d5af0940ff$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $a3e409d5af0940ff$export$83d89fbfd8236492; }, function (v) { return $a3e409d5af0940ff$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a3e409d5af0940ff$export$dca3b0875bd9a954;
var $a3e409d5af0940ff$export$16fa2f45be04daa8;
var $a3e409d5af0940ff$export$ffb0004e005737fa;
var $a3e409d5af0940ff$export$e2c29f18771995cb;
var $a3e409d5af0940ff$export$221d75b3f55bb0bd;
var $a3e409d5af0940ff$export$5f8d39834fd61797;
var $a3e409d5af0940ff$export$74bf444e3cd11ea5;
var $a3e409d5af0940ff$export$ae55be85d98224ed;
var $a3e409d5af0940ff$export$e530037191fcd5d7;
var $a3e409d5af0940ff$export$fd42f52fd3ae1109;
var $a3e409d5af0940ff$export$c8a8987d4410bf2d;
var $a3e409d5af0940ff$export$d38cd72104c1f0e9;
var $a3e409d5af0940ff$export$7d1e3a5e95ceca43;
var $a3e409d5af0940ff$export$257a8862b851cb5b;
var $a3e409d5af0940ff$export$a8257692ac88316c;
var $a3e409d5af0940ff$export$488013bae63b21da;
var $a3e409d5af0940ff$export$7c73462e0d25e514;
var $a3e409d5af0940ff$export$7568632d0d33d16d;
var $a3e409d5af0940ff$export$88948ce120ea2619;
var $a3e409d5af0940ff$export$35808ee640e87ca7;
var $a3e409d5af0940ff$export$fae74005e78b1a27;
var $a3e409d5af0940ff$export$dc8fbce3eb94dc1e;
var $a3e409d5af0940ff$export$6a7bc4e911dc01cf;
var $a3e409d5af0940ff$export$6d9c69b0de29b591;
var $a3e409d5af0940ff$export$f680877a34711e37;
var $a3e409d5af0940ff$export$d5a552a76deda3c2;
var $a3e409d5af0940ff$export$aaabe4eda9ed9969;
var $a3e409d5af0940ff$export$e5c5a5f917a5871c;
var $a3e409d5af0940ff$export$1538c33de8887b59;
var $a3e409d5af0940ff$export$13e3392192263954;
var $a3e409d5af0940ff$export$b8f5890fc79d6aca;
var $a3e409d5af0940ff$export$60241385465d0a34;
var $a3e409d5af0940ff$export$306c0aa65ff9ec16;
var $a3e409d5af0940ff$export$7b286972b8d8ccbf;
var $a3e409d5af0940ff$export$83d89fbfd8236492;
"use strict";
var $a3e409d5af0940ff$var$l = Symbol.for("react.element"), $a3e409d5af0940ff$var$n = Symbol.for("react.portal"), $a3e409d5af0940ff$var$p = Symbol.for("react.fragment"), $a3e409d5af0940ff$var$q = Symbol.for("react.strict_mode"), $a3e409d5af0940ff$var$r = Symbol.for("react.profiler"), $a3e409d5af0940ff$var$t = Symbol.for("react.provider"), $a3e409d5af0940ff$var$u = Symbol.for("react.context"), $a3e409d5af0940ff$var$v = Symbol.for("react.forward_ref"), $a3e409d5af0940ff$var$w = Symbol.for("react.suspense"), $a3e409d5af0940ff$var$x = Symbol.for("react.memo"), $a3e409d5af0940ff$var$y = Symbol.for("react.lazy"), $a3e409d5af0940ff$var$z = Symbol.iterator;
function $a3e409d5af0940ff$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $a3e409d5af0940ff$var$z && a[$a3e409d5af0940ff$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $a3e409d5af0940ff$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $a3e409d5af0940ff$var$C = Object.assign, $a3e409d5af0940ff$var$D = {};
function $a3e409d5af0940ff$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $a3e409d5af0940ff$var$D;
    this.updater = e || $a3e409d5af0940ff$var$B;
}
$a3e409d5af0940ff$var$E.prototype.isReactComponent = {};
$a3e409d5af0940ff$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$a3e409d5af0940ff$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $a3e409d5af0940ff$var$F() {}
$a3e409d5af0940ff$var$F.prototype = $a3e409d5af0940ff$var$E.prototype;
function $a3e409d5af0940ff$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $a3e409d5af0940ff$var$D;
    this.updater = e || $a3e409d5af0940ff$var$B;
}
var $a3e409d5af0940ff$var$H = $a3e409d5af0940ff$var$G.prototype = new $a3e409d5af0940ff$var$F;
$a3e409d5af0940ff$var$H.constructor = $a3e409d5af0940ff$var$G;
$a3e409d5af0940ff$var$C($a3e409d5af0940ff$var$H, $a3e409d5af0940ff$var$E.prototype);
$a3e409d5af0940ff$var$H.isPureReactComponent = !0;
var $a3e409d5af0940ff$var$I = Array.isArray, $a3e409d5af0940ff$var$J = Object.prototype.hasOwnProperty, $a3e409d5af0940ff$var$K = {
    current: null
}, $a3e409d5af0940ff$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $a3e409d5af0940ff$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$a3e409d5af0940ff$var$J.call(b, d) && !$a3e409d5af0940ff$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $a3e409d5af0940ff$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $a3e409d5af0940ff$var$K.current
    };
}
function $a3e409d5af0940ff$var$N(a, b) {
    return {
        $$typeof: $a3e409d5af0940ff$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $a3e409d5af0940ff$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $a3e409d5af0940ff$var$l;
}
function $a3e409d5af0940ff$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $a3e409d5af0940ff$var$P = /\/+/g;
function $a3e409d5af0940ff$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $a3e409d5af0940ff$var$escape("" + a.key) : b.toString(36);
}
function $a3e409d5af0940ff$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $a3e409d5af0940ff$var$l:
                case $a3e409d5af0940ff$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $a3e409d5af0940ff$var$Q(h, 0) : d, $a3e409d5af0940ff$var$I(c) ? (e = "", null != a && (e = a.replace($a3e409d5af0940ff$var$P, "$&/") + "/"), $a3e409d5af0940ff$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($a3e409d5af0940ff$var$O(c) && (c = $a3e409d5af0940ff$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($a3e409d5af0940ff$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($a3e409d5af0940ff$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $a3e409d5af0940ff$var$Q(k, g);
        h += $a3e409d5af0940ff$var$R(k, b, e, f, c);
    }
    else if (f = $a3e409d5af0940ff$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $a3e409d5af0940ff$var$Q(k, g++), h += $a3e409d5af0940ff$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $a3e409d5af0940ff$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $a3e409d5af0940ff$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $a3e409d5af0940ff$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $a3e409d5af0940ff$var$U = {
    current: null
}, $a3e409d5af0940ff$var$V = {
    transition: null
}, $a3e409d5af0940ff$var$W = {
    ReactCurrentDispatcher: $a3e409d5af0940ff$var$U,
    ReactCurrentBatchConfig: $a3e409d5af0940ff$var$V,
    ReactCurrentOwner: $a3e409d5af0940ff$var$K
};
$a3e409d5af0940ff$export$dca3b0875bd9a954 = {
    map: $a3e409d5af0940ff$var$S,
    forEach: function(a, b, e) {
        $a3e409d5af0940ff$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $a3e409d5af0940ff$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $a3e409d5af0940ff$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$a3e409d5af0940ff$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$a3e409d5af0940ff$export$16fa2f45be04daa8 = $a3e409d5af0940ff$var$E;
$a3e409d5af0940ff$export$ffb0004e005737fa = $a3e409d5af0940ff$var$p;
$a3e409d5af0940ff$export$e2c29f18771995cb = $a3e409d5af0940ff$var$r;
$a3e409d5af0940ff$export$221d75b3f55bb0bd = $a3e409d5af0940ff$var$G;
$a3e409d5af0940ff$export$5f8d39834fd61797 = $a3e409d5af0940ff$var$q;
$a3e409d5af0940ff$export$74bf444e3cd11ea5 = $a3e409d5af0940ff$var$w;
$a3e409d5af0940ff$export$ae55be85d98224ed = $a3e409d5af0940ff$var$W;
$a3e409d5af0940ff$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $a3e409d5af0940ff$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $a3e409d5af0940ff$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$a3e409d5af0940ff$var$J.call(b, f) && !$a3e409d5af0940ff$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $a3e409d5af0940ff$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$a3e409d5af0940ff$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $a3e409d5af0940ff$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $a3e409d5af0940ff$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$a3e409d5af0940ff$export$c8a8987d4410bf2d = $a3e409d5af0940ff$var$M;
$a3e409d5af0940ff$export$d38cd72104c1f0e9 = function(a) {
    var b = $a3e409d5af0940ff$var$M.bind(null, a);
    b.type = a;
    return b;
};
$a3e409d5af0940ff$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$a3e409d5af0940ff$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $a3e409d5af0940ff$var$v,
        render: a
    };
};
$a3e409d5af0940ff$export$a8257692ac88316c = $a3e409d5af0940ff$var$O;
$a3e409d5af0940ff$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $a3e409d5af0940ff$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $a3e409d5af0940ff$var$T
    };
};
$a3e409d5af0940ff$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $a3e409d5af0940ff$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$a3e409d5af0940ff$export$7568632d0d33d16d = function(a) {
    var b = $a3e409d5af0940ff$var$V.transition;
    $a3e409d5af0940ff$var$V.transition = {};
    try {
        a();
    } finally{
        $a3e409d5af0940ff$var$V.transition = b;
    }
};
$a3e409d5af0940ff$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$a3e409d5af0940ff$export$35808ee640e87ca7 = function(a, b) {
    return $a3e409d5af0940ff$var$U.current.useCallback(a, b);
};
$a3e409d5af0940ff$export$fae74005e78b1a27 = function(a) {
    return $a3e409d5af0940ff$var$U.current.useContext(a);
};
$a3e409d5af0940ff$export$dc8fbce3eb94dc1e = function() {};
$a3e409d5af0940ff$export$6a7bc4e911dc01cf = function(a) {
    return $a3e409d5af0940ff$var$U.current.useDeferredValue(a);
};
$a3e409d5af0940ff$export$6d9c69b0de29b591 = function(a, b) {
    return $a3e409d5af0940ff$var$U.current.useEffect(a, b);
};
$a3e409d5af0940ff$export$f680877a34711e37 = function() {
    return $a3e409d5af0940ff$var$U.current.useId();
};
$a3e409d5af0940ff$export$d5a552a76deda3c2 = function(a, b, e) {
    return $a3e409d5af0940ff$var$U.current.useImperativeHandle(a, b, e);
};
$a3e409d5af0940ff$export$aaabe4eda9ed9969 = function(a, b) {
    return $a3e409d5af0940ff$var$U.current.useInsertionEffect(a, b);
};
$a3e409d5af0940ff$export$e5c5a5f917a5871c = function(a, b) {
    return $a3e409d5af0940ff$var$U.current.useLayoutEffect(a, b);
};
$a3e409d5af0940ff$export$1538c33de8887b59 = function(a, b) {
    return $a3e409d5af0940ff$var$U.current.useMemo(a, b);
};
$a3e409d5af0940ff$export$13e3392192263954 = function(a, b, e) {
    return $a3e409d5af0940ff$var$U.current.useReducer(a, b, e);
};
$a3e409d5af0940ff$export$b8f5890fc79d6aca = function(a) {
    return $a3e409d5af0940ff$var$U.current.useRef(a);
};
$a3e409d5af0940ff$export$60241385465d0a34 = function(a) {
    return $a3e409d5af0940ff$var$U.current.useState(a);
};
$a3e409d5af0940ff$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $a3e409d5af0940ff$var$U.current.useSyncExternalStore(a, b, e);
};
$a3e409d5af0940ff$export$7b286972b8d8ccbf = function() {
    return $a3e409d5af0940ff$var$U.current.useTransition();
};
$a3e409d5af0940ff$export$83d89fbfd8236492 = "18.2.0";

});




parcelRequire.register("jH4WR", function(module, exports) {
"use strict";
function $e565df1d659a5e4c$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($e565df1d659a5e4c$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$e565df1d659a5e4c$var$checkDCE();

module.exports = (parcelRequire("2A1pN"));

});
parcelRequire.register("2A1pN", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $1e100a9690d50909$export$ae55be85d98224ed; }, function (v) { return $1e100a9690d50909$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $1e100a9690d50909$export$d39a5bbd09211389; }, function (v) { return $1e100a9690d50909$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $1e100a9690d50909$export$882461b6382ed46c; }, function (v) { return $1e100a9690d50909$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $1e100a9690d50909$export$466bfc07425424d5; }, function (v) { return $1e100a9690d50909$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $1e100a9690d50909$export$cd75ccfd720a3cd4; }, function (v) { return $1e100a9690d50909$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $1e100a9690d50909$export$fa8d919ba61d84db; }, function (v) { return $1e100a9690d50909$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $1e100a9690d50909$export$757ceba2d55c277e; }, function (v) { return $1e100a9690d50909$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $1e100a9690d50909$export$b3890eb0ae9dca99; }, function (v) { return $1e100a9690d50909$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $1e100a9690d50909$export$502457920280e6be; }, function (v) { return $1e100a9690d50909$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $1e100a9690d50909$export$c78a37762a8d58e1; }, function (v) { return $1e100a9690d50909$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $1e100a9690d50909$export$dc54d992c10e8a18; }, function (v) { return $1e100a9690d50909$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $1e100a9690d50909$export$83d89fbfd8236492; }, function (v) { return $1e100a9690d50909$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $1e100a9690d50909$export$ae55be85d98224ed;
var $1e100a9690d50909$export$d39a5bbd09211389;
var $1e100a9690d50909$export$882461b6382ed46c;
var $1e100a9690d50909$export$466bfc07425424d5;
var $1e100a9690d50909$export$cd75ccfd720a3cd4;
var $1e100a9690d50909$export$fa8d919ba61d84db;
var $1e100a9690d50909$export$757ceba2d55c277e;
var $1e100a9690d50909$export$b3890eb0ae9dca99;
var $1e100a9690d50909$export$502457920280e6be;
var $1e100a9690d50909$export$c78a37762a8d58e1;
var $1e100a9690d50909$export$dc54d992c10e8a18;
var $1e100a9690d50909$export$83d89fbfd8236492;
"use strict";

var $jC8Vy = parcelRequire("jC8Vy");

var $bv3Kn = parcelRequire("bv3Kn");
function $1e100a9690d50909$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $1e100a9690d50909$var$da = new Set, $1e100a9690d50909$var$ea = {};
function $1e100a9690d50909$var$fa(a, b) {
    $1e100a9690d50909$var$ha(a, b);
    $1e100a9690d50909$var$ha(a + "Capture", b);
}
function $1e100a9690d50909$var$ha(a, b) {
    $1e100a9690d50909$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$1e100a9690d50909$var$da.add(b[a]);
}
var $1e100a9690d50909$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $1e100a9690d50909$var$ja = Object.prototype.hasOwnProperty, $1e100a9690d50909$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $1e100a9690d50909$var$la = {}, $1e100a9690d50909$var$ma = {};
function $1e100a9690d50909$var$oa(a) {
    if ($1e100a9690d50909$var$ja.call($1e100a9690d50909$var$ma, a)) return !0;
    if ($1e100a9690d50909$var$ja.call($1e100a9690d50909$var$la, a)) return !1;
    if ($1e100a9690d50909$var$ka.test(a)) return $1e100a9690d50909$var$ma[a] = !0;
    $1e100a9690d50909$var$la[a] = !0;
    return !1;
}
function $1e100a9690d50909$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $1e100a9690d50909$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $1e100a9690d50909$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $1e100a9690d50909$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $1e100a9690d50909$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $1e100a9690d50909$var$z[a] = new $1e100a9690d50909$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $1e100a9690d50909$var$z[b] = new $1e100a9690d50909$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $1e100a9690d50909$var$z[a] = new $1e100a9690d50909$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $1e100a9690d50909$var$z[a] = new $1e100a9690d50909$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $1e100a9690d50909$var$z[a] = new $1e100a9690d50909$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $1e100a9690d50909$var$z[a] = new $1e100a9690d50909$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $1e100a9690d50909$var$z[a] = new $1e100a9690d50909$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $1e100a9690d50909$var$z[a] = new $1e100a9690d50909$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $1e100a9690d50909$var$z[a] = new $1e100a9690d50909$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $1e100a9690d50909$var$ra = /[\-:]([a-z])/g;
function $1e100a9690d50909$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($1e100a9690d50909$var$ra, $1e100a9690d50909$var$sa);
    $1e100a9690d50909$var$z[b] = new $1e100a9690d50909$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($1e100a9690d50909$var$ra, $1e100a9690d50909$var$sa);
    $1e100a9690d50909$var$z[b] = new $1e100a9690d50909$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($1e100a9690d50909$var$ra, $1e100a9690d50909$var$sa);
    $1e100a9690d50909$var$z[b] = new $1e100a9690d50909$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $1e100a9690d50909$var$z[a] = new $1e100a9690d50909$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$1e100a9690d50909$var$z.xlinkHref = new $1e100a9690d50909$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $1e100a9690d50909$var$z[a] = new $1e100a9690d50909$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $1e100a9690d50909$var$ta(a, b, c, d) {
    var e = $1e100a9690d50909$var$z.hasOwnProperty(b) ? $1e100a9690d50909$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $1e100a9690d50909$var$qa(b, c, e, d) && (c = null), d || null === e ? $1e100a9690d50909$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $1e100a9690d50909$var$ua = $jC8Vy.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $1e100a9690d50909$var$va = Symbol.for("react.element"), $1e100a9690d50909$var$wa = Symbol.for("react.portal"), $1e100a9690d50909$var$ya = Symbol.for("react.fragment"), $1e100a9690d50909$var$za = Symbol.for("react.strict_mode"), $1e100a9690d50909$var$Aa = Symbol.for("react.profiler"), $1e100a9690d50909$var$Ba = Symbol.for("react.provider"), $1e100a9690d50909$var$Ca = Symbol.for("react.context"), $1e100a9690d50909$var$Da = Symbol.for("react.forward_ref"), $1e100a9690d50909$var$Ea = Symbol.for("react.suspense"), $1e100a9690d50909$var$Fa = Symbol.for("react.suspense_list"), $1e100a9690d50909$var$Ga = Symbol.for("react.memo"), $1e100a9690d50909$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $1e100a9690d50909$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $1e100a9690d50909$var$Ja = Symbol.iterator;
function $1e100a9690d50909$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1e100a9690d50909$var$Ja && a[$1e100a9690d50909$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1e100a9690d50909$var$A = Object.assign, $1e100a9690d50909$var$La;
function $1e100a9690d50909$var$Ma(a) {
    if (void 0 === $1e100a9690d50909$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $1e100a9690d50909$var$La = b && b[1] || "";
    }
    return "\n" + $1e100a9690d50909$var$La + a;
}
var $1e100a9690d50909$var$Na = !1;
function $1e100a9690d50909$var$Oa(a, b) {
    if (!a || $1e100a9690d50909$var$Na) return "";
    $1e100a9690d50909$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $1e100a9690d50909$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $1e100a9690d50909$var$Ma(a) : "";
}
function $1e100a9690d50909$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $1e100a9690d50909$var$Ma(a.type);
        case 16:
            return $1e100a9690d50909$var$Ma("Lazy");
        case 13:
            return $1e100a9690d50909$var$Ma("Suspense");
        case 19:
            return $1e100a9690d50909$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $1e100a9690d50909$var$Oa(a.type, !1), a;
        case 11:
            return a = $1e100a9690d50909$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $1e100a9690d50909$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $1e100a9690d50909$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $1e100a9690d50909$var$ya:
            return "Fragment";
        case $1e100a9690d50909$var$wa:
            return "Portal";
        case $1e100a9690d50909$var$Aa:
            return "Profiler";
        case $1e100a9690d50909$var$za:
            return "StrictMode";
        case $1e100a9690d50909$var$Ea:
            return "Suspense";
        case $1e100a9690d50909$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $1e100a9690d50909$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $1e100a9690d50909$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $1e100a9690d50909$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $1e100a9690d50909$var$Ga:
            return b = a.displayName || null, null !== b ? b : $1e100a9690d50909$var$Qa(a.type) || "Memo";
        case $1e100a9690d50909$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $1e100a9690d50909$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $1e100a9690d50909$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $1e100a9690d50909$var$Qa(b);
        case 8:
            return b === $1e100a9690d50909$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $1e100a9690d50909$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $1e100a9690d50909$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $1e100a9690d50909$var$Ua(a) {
    var b = $1e100a9690d50909$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $1e100a9690d50909$var$Va(a) {
    a._valueTracker || (a._valueTracker = $1e100a9690d50909$var$Ua(a));
}
function $1e100a9690d50909$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $1e100a9690d50909$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $1e100a9690d50909$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $1e100a9690d50909$var$Ya(a, b) {
    var c = b.checked;
    return $1e100a9690d50909$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $1e100a9690d50909$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $1e100a9690d50909$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $1e100a9690d50909$var$ab(a, b) {
    b = b.checked;
    null != b && $1e100a9690d50909$var$ta(a, "checked", b, !1);
}
function $1e100a9690d50909$var$bb(a, b) {
    $1e100a9690d50909$var$ab(a, b);
    var c = $1e100a9690d50909$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $1e100a9690d50909$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $1e100a9690d50909$var$cb(a, b.type, $1e100a9690d50909$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $1e100a9690d50909$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $1e100a9690d50909$var$cb(a, b, c) {
    if ("number" !== b || $1e100a9690d50909$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $1e100a9690d50909$var$eb = Array.isArray;
function $1e100a9690d50909$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $1e100a9690d50909$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $1e100a9690d50909$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($1e100a9690d50909$var$p(91));
    return $1e100a9690d50909$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $1e100a9690d50909$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($1e100a9690d50909$var$p(92));
            if ($1e100a9690d50909$var$eb(c)) {
                if (1 < c.length) throw Error($1e100a9690d50909$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $1e100a9690d50909$var$Sa(c)
    };
}
function $1e100a9690d50909$var$ib(a, b) {
    var c = $1e100a9690d50909$var$Sa(b.value), d = $1e100a9690d50909$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $1e100a9690d50909$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $1e100a9690d50909$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $1e100a9690d50909$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $1e100a9690d50909$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $1e100a9690d50909$var$mb, $1e100a9690d50909$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $1e100a9690d50909$var$mb = $1e100a9690d50909$var$mb || document.createElement("div");
        $1e100a9690d50909$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $1e100a9690d50909$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $1e100a9690d50909$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $1e100a9690d50909$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $1e100a9690d50909$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($1e100a9690d50909$var$pb).forEach(function(a) {
    $1e100a9690d50909$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $1e100a9690d50909$var$pb[b] = $1e100a9690d50909$var$pb[a];
    });
});
function $1e100a9690d50909$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $1e100a9690d50909$var$pb.hasOwnProperty(a) && $1e100a9690d50909$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $1e100a9690d50909$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $1e100a9690d50909$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $1e100a9690d50909$var$tb = $1e100a9690d50909$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $1e100a9690d50909$var$ub(a, b) {
    if (b) {
        if ($1e100a9690d50909$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($1e100a9690d50909$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($1e100a9690d50909$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($1e100a9690d50909$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($1e100a9690d50909$var$p(62));
    }
}
function $1e100a9690d50909$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $1e100a9690d50909$var$wb = null;
function $1e100a9690d50909$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $1e100a9690d50909$var$yb = null, $1e100a9690d50909$var$zb = null, $1e100a9690d50909$var$Ab = null;
function $1e100a9690d50909$var$Bb(a) {
    if (a = $1e100a9690d50909$var$Cb(a)) {
        if ("function" !== typeof $1e100a9690d50909$var$yb) throw Error($1e100a9690d50909$var$p(280));
        var b = a.stateNode;
        b && (b = $1e100a9690d50909$var$Db(b), $1e100a9690d50909$var$yb(a.stateNode, a.type, b));
    }
}
function $1e100a9690d50909$var$Eb(a) {
    $1e100a9690d50909$var$zb ? $1e100a9690d50909$var$Ab ? $1e100a9690d50909$var$Ab.push(a) : $1e100a9690d50909$var$Ab = [
        a
    ] : $1e100a9690d50909$var$zb = a;
}
function $1e100a9690d50909$var$Fb() {
    if ($1e100a9690d50909$var$zb) {
        var a = $1e100a9690d50909$var$zb, b = $1e100a9690d50909$var$Ab;
        $1e100a9690d50909$var$Ab = $1e100a9690d50909$var$zb = null;
        $1e100a9690d50909$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$1e100a9690d50909$var$Bb(b[a]);
    }
}
function $1e100a9690d50909$var$Gb(a, b) {
    return a(b);
}
function $1e100a9690d50909$var$Hb() {}
var $1e100a9690d50909$var$Ib = !1;
function $1e100a9690d50909$var$Jb(a, b, c) {
    if ($1e100a9690d50909$var$Ib) return a(b, c);
    $1e100a9690d50909$var$Ib = !0;
    try {
        return $1e100a9690d50909$var$Gb(a, b, c);
    } finally{
        if ($1e100a9690d50909$var$Ib = !1, null !== $1e100a9690d50909$var$zb || null !== $1e100a9690d50909$var$Ab) $1e100a9690d50909$var$Hb(), $1e100a9690d50909$var$Fb();
    }
}
function $1e100a9690d50909$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $1e100a9690d50909$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($1e100a9690d50909$var$p(231, b, typeof c));
    return c;
}
var $1e100a9690d50909$var$Lb = !1;
if ($1e100a9690d50909$var$ia) try {
    var $1e100a9690d50909$var$Mb = {};
    Object.defineProperty($1e100a9690d50909$var$Mb, "passive", {
        get: function() {
            $1e100a9690d50909$var$Lb = !0;
        }
    });
    window.addEventListener("test", $1e100a9690d50909$var$Mb, $1e100a9690d50909$var$Mb);
    window.removeEventListener("test", $1e100a9690d50909$var$Mb, $1e100a9690d50909$var$Mb);
} catch (a) {
    $1e100a9690d50909$var$Lb = !1;
}
function $1e100a9690d50909$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $1e100a9690d50909$var$Ob = !1, $1e100a9690d50909$var$Pb = null, $1e100a9690d50909$var$Qb = !1, $1e100a9690d50909$var$Rb = null, $1e100a9690d50909$var$Sb = {
    onError: function(a) {
        $1e100a9690d50909$var$Ob = !0;
        $1e100a9690d50909$var$Pb = a;
    }
};
function $1e100a9690d50909$var$Tb(a, b, c, d, e, f, g, h, k) {
    $1e100a9690d50909$var$Ob = !1;
    $1e100a9690d50909$var$Pb = null;
    $1e100a9690d50909$var$Nb.apply($1e100a9690d50909$var$Sb, arguments);
}
function $1e100a9690d50909$var$Ub(a, b, c, d, e, f, g, h, k) {
    $1e100a9690d50909$var$Tb.apply(this, arguments);
    if ($1e100a9690d50909$var$Ob) {
        if ($1e100a9690d50909$var$Ob) {
            var l = $1e100a9690d50909$var$Pb;
            $1e100a9690d50909$var$Ob = !1;
            $1e100a9690d50909$var$Pb = null;
        } else throw Error($1e100a9690d50909$var$p(198));
        $1e100a9690d50909$var$Qb || ($1e100a9690d50909$var$Qb = !0, $1e100a9690d50909$var$Rb = l);
    }
}
function $1e100a9690d50909$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $1e100a9690d50909$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $1e100a9690d50909$var$Xb(a) {
    if ($1e100a9690d50909$var$Vb(a) !== a) throw Error($1e100a9690d50909$var$p(188));
}
function $1e100a9690d50909$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $1e100a9690d50909$var$Vb(a);
        if (null === b) throw Error($1e100a9690d50909$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $1e100a9690d50909$var$Xb(e), a;
                if (f === d) return $1e100a9690d50909$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($1e100a9690d50909$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($1e100a9690d50909$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($1e100a9690d50909$var$p(190));
    }
    if (3 !== c.tag) throw Error($1e100a9690d50909$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $1e100a9690d50909$var$Zb(a) {
    a = $1e100a9690d50909$var$Yb(a);
    return null !== a ? $1e100a9690d50909$var$$b(a) : null;
}
function $1e100a9690d50909$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $1e100a9690d50909$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $1e100a9690d50909$var$ac = $bv3Kn.unstable_scheduleCallback, $1e100a9690d50909$var$bc = $bv3Kn.unstable_cancelCallback, $1e100a9690d50909$var$cc = $bv3Kn.unstable_shouldYield, $1e100a9690d50909$var$dc = $bv3Kn.unstable_requestPaint, $1e100a9690d50909$var$B = $bv3Kn.unstable_now, $1e100a9690d50909$var$ec = $bv3Kn.unstable_getCurrentPriorityLevel, $1e100a9690d50909$var$fc = $bv3Kn.unstable_ImmediatePriority, $1e100a9690d50909$var$gc = $bv3Kn.unstable_UserBlockingPriority, $1e100a9690d50909$var$hc = $bv3Kn.unstable_NormalPriority, $1e100a9690d50909$var$ic = $bv3Kn.unstable_LowPriority, $1e100a9690d50909$var$jc = $bv3Kn.unstable_IdlePriority, $1e100a9690d50909$var$kc = null, $1e100a9690d50909$var$lc = null;
function $1e100a9690d50909$var$mc(a) {
    if ($1e100a9690d50909$var$lc && "function" === typeof $1e100a9690d50909$var$lc.onCommitFiberRoot) try {
        $1e100a9690d50909$var$lc.onCommitFiberRoot($1e100a9690d50909$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $1e100a9690d50909$var$oc = Math.clz32 ? Math.clz32 : $1e100a9690d50909$var$nc, $1e100a9690d50909$var$pc = Math.log, $1e100a9690d50909$var$qc = Math.LN2;
function $1e100a9690d50909$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($1e100a9690d50909$var$pc(a) / $1e100a9690d50909$var$qc | 0) | 0;
}
var $1e100a9690d50909$var$rc = 64, $1e100a9690d50909$var$sc = 4194304;
function $1e100a9690d50909$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $1e100a9690d50909$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $1e100a9690d50909$var$tc(h) : (f &= g, 0 !== f && (d = $1e100a9690d50909$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $1e100a9690d50909$var$tc(g) : 0 !== f && (d = $1e100a9690d50909$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $1e100a9690d50909$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $1e100a9690d50909$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $1e100a9690d50909$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $1e100a9690d50909$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $1e100a9690d50909$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $1e100a9690d50909$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $1e100a9690d50909$var$yc() {
    var a = $1e100a9690d50909$var$rc;
    $1e100a9690d50909$var$rc <<= 1;
    0 === ($1e100a9690d50909$var$rc & 4194240) && ($1e100a9690d50909$var$rc = 64);
    return a;
}
function $1e100a9690d50909$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $1e100a9690d50909$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $1e100a9690d50909$var$oc(b);
    a[b] = c;
}
function $1e100a9690d50909$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $1e100a9690d50909$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $1e100a9690d50909$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $1e100a9690d50909$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $1e100a9690d50909$var$C = 0;
function $1e100a9690d50909$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $1e100a9690d50909$var$Ec, $1e100a9690d50909$var$Fc, $1e100a9690d50909$var$Gc, $1e100a9690d50909$var$Hc, $1e100a9690d50909$var$Ic, $1e100a9690d50909$var$Jc = !1, $1e100a9690d50909$var$Kc = [], $1e100a9690d50909$var$Lc = null, $1e100a9690d50909$var$Mc = null, $1e100a9690d50909$var$Nc = null, $1e100a9690d50909$var$Oc = new Map, $1e100a9690d50909$var$Pc = new Map, $1e100a9690d50909$var$Qc = [], $1e100a9690d50909$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $1e100a9690d50909$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $1e100a9690d50909$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $1e100a9690d50909$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $1e100a9690d50909$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $1e100a9690d50909$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $1e100a9690d50909$var$Pc.delete(b.pointerId);
    }
}
function $1e100a9690d50909$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $1e100a9690d50909$var$Cb(b), null !== b && $1e100a9690d50909$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $1e100a9690d50909$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $1e100a9690d50909$var$Lc = $1e100a9690d50909$var$Tc($1e100a9690d50909$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $1e100a9690d50909$var$Mc = $1e100a9690d50909$var$Tc($1e100a9690d50909$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $1e100a9690d50909$var$Nc = $1e100a9690d50909$var$Tc($1e100a9690d50909$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $1e100a9690d50909$var$Oc.set(f, $1e100a9690d50909$var$Tc($1e100a9690d50909$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $1e100a9690d50909$var$Pc.set(f, $1e100a9690d50909$var$Tc($1e100a9690d50909$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $1e100a9690d50909$var$Vc(a) {
    var b = $1e100a9690d50909$var$Wc(a.target);
    if (null !== b) {
        var c = $1e100a9690d50909$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $1e100a9690d50909$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $1e100a9690d50909$var$Ic(a.priority, function() {
                        $1e100a9690d50909$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $1e100a9690d50909$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $1e100a9690d50909$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $1e100a9690d50909$var$wb = d;
            c.target.dispatchEvent(d);
            $1e100a9690d50909$var$wb = null;
        } else return b = $1e100a9690d50909$var$Cb(c), null !== b && $1e100a9690d50909$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $1e100a9690d50909$var$Zc(a, b, c) {
    $1e100a9690d50909$var$Xc(a) && c.delete(b);
}
function $1e100a9690d50909$var$$c() {
    $1e100a9690d50909$var$Jc = !1;
    null !== $1e100a9690d50909$var$Lc && $1e100a9690d50909$var$Xc($1e100a9690d50909$var$Lc) && ($1e100a9690d50909$var$Lc = null);
    null !== $1e100a9690d50909$var$Mc && $1e100a9690d50909$var$Xc($1e100a9690d50909$var$Mc) && ($1e100a9690d50909$var$Mc = null);
    null !== $1e100a9690d50909$var$Nc && $1e100a9690d50909$var$Xc($1e100a9690d50909$var$Nc) && ($1e100a9690d50909$var$Nc = null);
    $1e100a9690d50909$var$Oc.forEach($1e100a9690d50909$var$Zc);
    $1e100a9690d50909$var$Pc.forEach($1e100a9690d50909$var$Zc);
}
function $1e100a9690d50909$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $1e100a9690d50909$var$Jc || ($1e100a9690d50909$var$Jc = !0, $bv3Kn.unstable_scheduleCallback($bv3Kn.unstable_NormalPriority, $1e100a9690d50909$var$$c)));
}
function $1e100a9690d50909$var$bd(a) {
    function b(b) {
        return $1e100a9690d50909$var$ad(b, a);
    }
    if (0 < $1e100a9690d50909$var$Kc.length) {
        $1e100a9690d50909$var$ad($1e100a9690d50909$var$Kc[0], a);
        for(var c = 1; c < $1e100a9690d50909$var$Kc.length; c++){
            var d = $1e100a9690d50909$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $1e100a9690d50909$var$Lc && $1e100a9690d50909$var$ad($1e100a9690d50909$var$Lc, a);
    null !== $1e100a9690d50909$var$Mc && $1e100a9690d50909$var$ad($1e100a9690d50909$var$Mc, a);
    null !== $1e100a9690d50909$var$Nc && $1e100a9690d50909$var$ad($1e100a9690d50909$var$Nc, a);
    $1e100a9690d50909$var$Oc.forEach(b);
    $1e100a9690d50909$var$Pc.forEach(b);
    for(c = 0; c < $1e100a9690d50909$var$Qc.length; c++)d = $1e100a9690d50909$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $1e100a9690d50909$var$Qc.length && (c = $1e100a9690d50909$var$Qc[0], null === c.blockedOn);)$1e100a9690d50909$var$Vc(c), null === c.blockedOn && $1e100a9690d50909$var$Qc.shift();
}
var $1e100a9690d50909$var$cd = $1e100a9690d50909$var$ua.ReactCurrentBatchConfig, $1e100a9690d50909$var$dd = !0;
function $1e100a9690d50909$var$ed(a, b, c, d) {
    var e = $1e100a9690d50909$var$C, f = $1e100a9690d50909$var$cd.transition;
    $1e100a9690d50909$var$cd.transition = null;
    try {
        $1e100a9690d50909$var$C = 1, $1e100a9690d50909$var$fd(a, b, c, d);
    } finally{
        $1e100a9690d50909$var$C = e, $1e100a9690d50909$var$cd.transition = f;
    }
}
function $1e100a9690d50909$var$gd(a, b, c, d) {
    var e = $1e100a9690d50909$var$C, f = $1e100a9690d50909$var$cd.transition;
    $1e100a9690d50909$var$cd.transition = null;
    try {
        $1e100a9690d50909$var$C = 4, $1e100a9690d50909$var$fd(a, b, c, d);
    } finally{
        $1e100a9690d50909$var$C = e, $1e100a9690d50909$var$cd.transition = f;
    }
}
function $1e100a9690d50909$var$fd(a, b, c, d) {
    if ($1e100a9690d50909$var$dd) {
        var e = $1e100a9690d50909$var$Yc(a, b, c, d);
        if (null === e) $1e100a9690d50909$var$hd(a, b, d, $1e100a9690d50909$var$id, c), $1e100a9690d50909$var$Sc(a, d);
        else if ($1e100a9690d50909$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($1e100a9690d50909$var$Sc(a, d), b & 4 && -1 < $1e100a9690d50909$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $1e100a9690d50909$var$Cb(e);
                null !== f && $1e100a9690d50909$var$Ec(f);
                f = $1e100a9690d50909$var$Yc(a, b, c, d);
                null === f && $1e100a9690d50909$var$hd(a, b, d, $1e100a9690d50909$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $1e100a9690d50909$var$hd(a, b, d, null, c);
    }
}
var $1e100a9690d50909$var$id = null;
function $1e100a9690d50909$var$Yc(a, b, c, d) {
    $1e100a9690d50909$var$id = null;
    a = $1e100a9690d50909$var$xb(d);
    a = $1e100a9690d50909$var$Wc(a);
    if (null !== a) {
        if (b = $1e100a9690d50909$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $1e100a9690d50909$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $1e100a9690d50909$var$id = a;
    return null;
}
function $1e100a9690d50909$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($1e100a9690d50909$var$ec()){
                case $1e100a9690d50909$var$fc:
                    return 1;
                case $1e100a9690d50909$var$gc:
                    return 4;
                case $1e100a9690d50909$var$hc:
                case $1e100a9690d50909$var$ic:
                    return 16;
                case $1e100a9690d50909$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $1e100a9690d50909$var$kd = null, $1e100a9690d50909$var$ld = null, $1e100a9690d50909$var$md = null;
function $1e100a9690d50909$var$nd() {
    if ($1e100a9690d50909$var$md) return $1e100a9690d50909$var$md;
    var a, b = $1e100a9690d50909$var$ld, c = b.length, d, e = "value" in $1e100a9690d50909$var$kd ? $1e100a9690d50909$var$kd.value : $1e100a9690d50909$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $1e100a9690d50909$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $1e100a9690d50909$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $1e100a9690d50909$var$pd() {
    return !0;
}
function $1e100a9690d50909$var$qd() {
    return !1;
}
function $1e100a9690d50909$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $1e100a9690d50909$var$pd : $1e100a9690d50909$var$qd;
        this.isPropagationStopped = $1e100a9690d50909$var$qd;
        return this;
    }
    $1e100a9690d50909$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $1e100a9690d50909$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $1e100a9690d50909$var$pd);
        },
        persist: function() {},
        isPersistent: $1e100a9690d50909$var$pd
    });
    return b;
}
var $1e100a9690d50909$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $1e100a9690d50909$var$td = $1e100a9690d50909$var$rd($1e100a9690d50909$var$sd), $1e100a9690d50909$var$ud = $1e100a9690d50909$var$A({}, $1e100a9690d50909$var$sd, {
    view: 0,
    detail: 0
}), $1e100a9690d50909$var$vd = $1e100a9690d50909$var$rd($1e100a9690d50909$var$ud), $1e100a9690d50909$var$wd, $1e100a9690d50909$var$xd, $1e100a9690d50909$var$yd, $1e100a9690d50909$var$Ad = $1e100a9690d50909$var$A({}, $1e100a9690d50909$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $1e100a9690d50909$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $1e100a9690d50909$var$yd && ($1e100a9690d50909$var$yd && "mousemove" === a.type ? ($1e100a9690d50909$var$wd = a.screenX - $1e100a9690d50909$var$yd.screenX, $1e100a9690d50909$var$xd = a.screenY - $1e100a9690d50909$var$yd.screenY) : $1e100a9690d50909$var$xd = $1e100a9690d50909$var$wd = 0, $1e100a9690d50909$var$yd = a);
        return $1e100a9690d50909$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $1e100a9690d50909$var$xd;
    }
}), $1e100a9690d50909$var$Bd = $1e100a9690d50909$var$rd($1e100a9690d50909$var$Ad), $1e100a9690d50909$var$Cd = $1e100a9690d50909$var$A({}, $1e100a9690d50909$var$Ad, {
    dataTransfer: 0
}), $1e100a9690d50909$var$Dd = $1e100a9690d50909$var$rd($1e100a9690d50909$var$Cd), $1e100a9690d50909$var$Ed = $1e100a9690d50909$var$A({}, $1e100a9690d50909$var$ud, {
    relatedTarget: 0
}), $1e100a9690d50909$var$Fd = $1e100a9690d50909$var$rd($1e100a9690d50909$var$Ed), $1e100a9690d50909$var$Gd = $1e100a9690d50909$var$A({}, $1e100a9690d50909$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $1e100a9690d50909$var$Hd = $1e100a9690d50909$var$rd($1e100a9690d50909$var$Gd), $1e100a9690d50909$var$Id = $1e100a9690d50909$var$A({}, $1e100a9690d50909$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $1e100a9690d50909$var$Jd = $1e100a9690d50909$var$rd($1e100a9690d50909$var$Id), $1e100a9690d50909$var$Kd = $1e100a9690d50909$var$A({}, $1e100a9690d50909$var$sd, {
    data: 0
}), $1e100a9690d50909$var$Ld = $1e100a9690d50909$var$rd($1e100a9690d50909$var$Kd), $1e100a9690d50909$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $1e100a9690d50909$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $1e100a9690d50909$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $1e100a9690d50909$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $1e100a9690d50909$var$Od[a]) ? !!b[a] : !1;
}
function $1e100a9690d50909$var$zd() {
    return $1e100a9690d50909$var$Pd;
}
var $1e100a9690d50909$var$Qd = $1e100a9690d50909$var$A({}, $1e100a9690d50909$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $1e100a9690d50909$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $1e100a9690d50909$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $1e100a9690d50909$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $1e100a9690d50909$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $1e100a9690d50909$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $1e100a9690d50909$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $1e100a9690d50909$var$Rd = $1e100a9690d50909$var$rd($1e100a9690d50909$var$Qd), $1e100a9690d50909$var$Sd = $1e100a9690d50909$var$A({}, $1e100a9690d50909$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $1e100a9690d50909$var$Td = $1e100a9690d50909$var$rd($1e100a9690d50909$var$Sd), $1e100a9690d50909$var$Ud = $1e100a9690d50909$var$A({}, $1e100a9690d50909$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $1e100a9690d50909$var$zd
}), $1e100a9690d50909$var$Vd = $1e100a9690d50909$var$rd($1e100a9690d50909$var$Ud), $1e100a9690d50909$var$Wd = $1e100a9690d50909$var$A({}, $1e100a9690d50909$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $1e100a9690d50909$var$Xd = $1e100a9690d50909$var$rd($1e100a9690d50909$var$Wd), $1e100a9690d50909$var$Yd = $1e100a9690d50909$var$A({}, $1e100a9690d50909$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $1e100a9690d50909$var$Zd = $1e100a9690d50909$var$rd($1e100a9690d50909$var$Yd), $1e100a9690d50909$var$$d = [
    9,
    13,
    27,
    32
], $1e100a9690d50909$var$ae = $1e100a9690d50909$var$ia && "CompositionEvent" in window, $1e100a9690d50909$var$be = null;
$1e100a9690d50909$var$ia && "documentMode" in document && ($1e100a9690d50909$var$be = document.documentMode);
var $1e100a9690d50909$var$ce = $1e100a9690d50909$var$ia && "TextEvent" in window && !$1e100a9690d50909$var$be, $1e100a9690d50909$var$de = $1e100a9690d50909$var$ia && (!$1e100a9690d50909$var$ae || $1e100a9690d50909$var$be && 8 < $1e100a9690d50909$var$be && 11 >= $1e100a9690d50909$var$be), $1e100a9690d50909$var$ee = String.fromCharCode(32), $1e100a9690d50909$var$fe = !1;
function $1e100a9690d50909$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $1e100a9690d50909$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $1e100a9690d50909$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $1e100a9690d50909$var$ie = !1;
function $1e100a9690d50909$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $1e100a9690d50909$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $1e100a9690d50909$var$fe = !0;
            return $1e100a9690d50909$var$ee;
        case "textInput":
            return a = b.data, a === $1e100a9690d50909$var$ee && $1e100a9690d50909$var$fe ? null : a;
        default:
            return null;
    }
}
function $1e100a9690d50909$var$ke(a, b) {
    if ($1e100a9690d50909$var$ie) return "compositionend" === a || !$1e100a9690d50909$var$ae && $1e100a9690d50909$var$ge(a, b) ? (a = $1e100a9690d50909$var$nd(), $1e100a9690d50909$var$md = $1e100a9690d50909$var$ld = $1e100a9690d50909$var$kd = null, $1e100a9690d50909$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $1e100a9690d50909$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $1e100a9690d50909$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $1e100a9690d50909$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$1e100a9690d50909$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $1e100a9690d50909$var$ne(a, b, c, d) {
    $1e100a9690d50909$var$Eb(d);
    b = $1e100a9690d50909$var$oe(b, "onChange");
    0 < b.length && (c = new $1e100a9690d50909$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $1e100a9690d50909$var$pe = null, $1e100a9690d50909$var$qe = null;
function $1e100a9690d50909$var$re(a) {
    $1e100a9690d50909$var$se(a, 0);
}
function $1e100a9690d50909$var$te(a) {
    var b = $1e100a9690d50909$var$ue(a);
    if ($1e100a9690d50909$var$Wa(b)) return a;
}
function $1e100a9690d50909$var$ve(a, b) {
    if ("change" === a) return b;
}
var $1e100a9690d50909$var$we = !1;
if ($1e100a9690d50909$var$ia) {
    var $1e100a9690d50909$var$xe;
    if ($1e100a9690d50909$var$ia) {
        var $1e100a9690d50909$var$ye = "oninput" in document;
        if (!$1e100a9690d50909$var$ye) {
            var $1e100a9690d50909$var$ze = document.createElement("div");
            $1e100a9690d50909$var$ze.setAttribute("oninput", "return;");
            $1e100a9690d50909$var$ye = "function" === typeof $1e100a9690d50909$var$ze.oninput;
        }
        $1e100a9690d50909$var$xe = $1e100a9690d50909$var$ye;
    } else $1e100a9690d50909$var$xe = !1;
    $1e100a9690d50909$var$we = $1e100a9690d50909$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $1e100a9690d50909$var$Ae() {
    $1e100a9690d50909$var$pe && ($1e100a9690d50909$var$pe.detachEvent("onpropertychange", $1e100a9690d50909$var$Be), $1e100a9690d50909$var$qe = $1e100a9690d50909$var$pe = null);
}
function $1e100a9690d50909$var$Be(a) {
    if ("value" === a.propertyName && $1e100a9690d50909$var$te($1e100a9690d50909$var$qe)) {
        var b = [];
        $1e100a9690d50909$var$ne(b, $1e100a9690d50909$var$qe, a, $1e100a9690d50909$var$xb(a));
        $1e100a9690d50909$var$Jb($1e100a9690d50909$var$re, b);
    }
}
function $1e100a9690d50909$var$Ce(a, b, c) {
    "focusin" === a ? ($1e100a9690d50909$var$Ae(), $1e100a9690d50909$var$pe = b, $1e100a9690d50909$var$qe = c, $1e100a9690d50909$var$pe.attachEvent("onpropertychange", $1e100a9690d50909$var$Be)) : "focusout" === a && $1e100a9690d50909$var$Ae();
}
function $1e100a9690d50909$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $1e100a9690d50909$var$te($1e100a9690d50909$var$qe);
}
function $1e100a9690d50909$var$Ee(a, b) {
    if ("click" === a) return $1e100a9690d50909$var$te(b);
}
function $1e100a9690d50909$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $1e100a9690d50909$var$te(b);
}
function $1e100a9690d50909$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $1e100a9690d50909$var$He = "function" === typeof Object.is ? Object.is : $1e100a9690d50909$var$Ge;
function $1e100a9690d50909$var$Ie(a, b) {
    if ($1e100a9690d50909$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$1e100a9690d50909$var$ja.call(b, e) || !$1e100a9690d50909$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $1e100a9690d50909$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $1e100a9690d50909$var$Ke(a, b) {
    var c = $1e100a9690d50909$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $1e100a9690d50909$var$Je(c);
    }
}
function $1e100a9690d50909$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $1e100a9690d50909$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $1e100a9690d50909$var$Me() {
    for(var a = window, b = $1e100a9690d50909$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $1e100a9690d50909$var$Xa(a.document);
    }
    return b;
}
function $1e100a9690d50909$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $1e100a9690d50909$var$Oe(a) {
    var b = $1e100a9690d50909$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $1e100a9690d50909$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $1e100a9690d50909$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $1e100a9690d50909$var$Ke(c, f);
                var g = $1e100a9690d50909$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $1e100a9690d50909$var$Pe = $1e100a9690d50909$var$ia && "documentMode" in document && 11 >= document.documentMode, $1e100a9690d50909$var$Qe = null, $1e100a9690d50909$var$Re = null, $1e100a9690d50909$var$Se = null, $1e100a9690d50909$var$Te = !1;
function $1e100a9690d50909$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $1e100a9690d50909$var$Te || null == $1e100a9690d50909$var$Qe || $1e100a9690d50909$var$Qe !== $1e100a9690d50909$var$Xa(d) || (d = $1e100a9690d50909$var$Qe, "selectionStart" in d && $1e100a9690d50909$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $1e100a9690d50909$var$Se && $1e100a9690d50909$var$Ie($1e100a9690d50909$var$Se, d) || ($1e100a9690d50909$var$Se = d, d = $1e100a9690d50909$var$oe($1e100a9690d50909$var$Re, "onSelect"), 0 < d.length && (b = new $1e100a9690d50909$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $1e100a9690d50909$var$Qe)));
}
function $1e100a9690d50909$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $1e100a9690d50909$var$We = {
    animationend: $1e100a9690d50909$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $1e100a9690d50909$var$Ve("Animation", "AnimationIteration"),
    animationstart: $1e100a9690d50909$var$Ve("Animation", "AnimationStart"),
    transitionend: $1e100a9690d50909$var$Ve("Transition", "TransitionEnd")
}, $1e100a9690d50909$var$Xe = {}, $1e100a9690d50909$var$Ye = {};
$1e100a9690d50909$var$ia && ($1e100a9690d50909$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $1e100a9690d50909$var$We.animationend.animation, delete $1e100a9690d50909$var$We.animationiteration.animation, delete $1e100a9690d50909$var$We.animationstart.animation), "TransitionEvent" in window || delete $1e100a9690d50909$var$We.transitionend.transition);
function $1e100a9690d50909$var$Ze(a) {
    if ($1e100a9690d50909$var$Xe[a]) return $1e100a9690d50909$var$Xe[a];
    if (!$1e100a9690d50909$var$We[a]) return a;
    var b = $1e100a9690d50909$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $1e100a9690d50909$var$Ye) return $1e100a9690d50909$var$Xe[a] = b[c];
    return a;
}
var $1e100a9690d50909$var$$e = $1e100a9690d50909$var$Ze("animationend"), $1e100a9690d50909$var$af = $1e100a9690d50909$var$Ze("animationiteration"), $1e100a9690d50909$var$bf = $1e100a9690d50909$var$Ze("animationstart"), $1e100a9690d50909$var$cf = $1e100a9690d50909$var$Ze("transitionend"), $1e100a9690d50909$var$df = new Map, $1e100a9690d50909$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $1e100a9690d50909$var$ff(a, b) {
    $1e100a9690d50909$var$df.set(a, b);
    $1e100a9690d50909$var$fa(b, [
        a
    ]);
}
for(var $1e100a9690d50909$var$gf = 0; $1e100a9690d50909$var$gf < $1e100a9690d50909$var$ef.length; $1e100a9690d50909$var$gf++){
    var $1e100a9690d50909$var$hf = $1e100a9690d50909$var$ef[$1e100a9690d50909$var$gf], $1e100a9690d50909$var$jf = $1e100a9690d50909$var$hf.toLowerCase(), $1e100a9690d50909$var$kf = $1e100a9690d50909$var$hf[0].toUpperCase() + $1e100a9690d50909$var$hf.slice(1);
    $1e100a9690d50909$var$ff($1e100a9690d50909$var$jf, "on" + $1e100a9690d50909$var$kf);
}
$1e100a9690d50909$var$ff($1e100a9690d50909$var$$e, "onAnimationEnd");
$1e100a9690d50909$var$ff($1e100a9690d50909$var$af, "onAnimationIteration");
$1e100a9690d50909$var$ff($1e100a9690d50909$var$bf, "onAnimationStart");
$1e100a9690d50909$var$ff("dblclick", "onDoubleClick");
$1e100a9690d50909$var$ff("focusin", "onFocus");
$1e100a9690d50909$var$ff("focusout", "onBlur");
$1e100a9690d50909$var$ff($1e100a9690d50909$var$cf, "onTransitionEnd");
$1e100a9690d50909$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$1e100a9690d50909$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$1e100a9690d50909$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$1e100a9690d50909$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$1e100a9690d50909$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$1e100a9690d50909$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$1e100a9690d50909$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$1e100a9690d50909$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$1e100a9690d50909$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$1e100a9690d50909$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $1e100a9690d50909$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $1e100a9690d50909$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($1e100a9690d50909$var$lf));
function $1e100a9690d50909$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $1e100a9690d50909$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $1e100a9690d50909$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $1e100a9690d50909$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $1e100a9690d50909$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($1e100a9690d50909$var$Qb) throw a = $1e100a9690d50909$var$Rb, $1e100a9690d50909$var$Qb = !1, $1e100a9690d50909$var$Rb = null, a;
}
function $1e100a9690d50909$var$D(a, b) {
    var c = b[$1e100a9690d50909$var$of];
    void 0 === c && (c = b[$1e100a9690d50909$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($1e100a9690d50909$var$pf(b, a, 2, !1), c.add(d));
}
function $1e100a9690d50909$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $1e100a9690d50909$var$pf(c, a, d, b);
}
var $1e100a9690d50909$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $1e100a9690d50909$var$sf(a) {
    if (!a[$1e100a9690d50909$var$rf]) {
        a[$1e100a9690d50909$var$rf] = !0;
        $1e100a9690d50909$var$da.forEach(function(b) {
            "selectionchange" !== b && ($1e100a9690d50909$var$mf.has(b) || $1e100a9690d50909$var$qf(b, !1, a), $1e100a9690d50909$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$1e100a9690d50909$var$rf] || (b[$1e100a9690d50909$var$rf] = !0, $1e100a9690d50909$var$qf("selectionchange", !1, b));
    }
}
function $1e100a9690d50909$var$pf(a, b, c, d) {
    switch($1e100a9690d50909$var$jd(b)){
        case 1:
            var e = $1e100a9690d50909$var$ed;
            break;
        case 4:
            e = $1e100a9690d50909$var$gd;
            break;
        default:
            e = $1e100a9690d50909$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$1e100a9690d50909$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $1e100a9690d50909$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $1e100a9690d50909$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $1e100a9690d50909$var$Jb(function() {
        var d = f, e = $1e100a9690d50909$var$xb(c), g = [];
        a: {
            var h = $1e100a9690d50909$var$df.get(a);
            if (void 0 !== h) {
                var k = $1e100a9690d50909$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $1e100a9690d50909$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $1e100a9690d50909$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $1e100a9690d50909$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $1e100a9690d50909$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $1e100a9690d50909$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $1e100a9690d50909$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $1e100a9690d50909$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $1e100a9690d50909$var$Vd;
                        break;
                    case $1e100a9690d50909$var$$e:
                    case $1e100a9690d50909$var$af:
                    case $1e100a9690d50909$var$bf:
                        k = $1e100a9690d50909$var$Hd;
                        break;
                    case $1e100a9690d50909$var$cf:
                        k = $1e100a9690d50909$var$Xd;
                        break;
                    case "scroll":
                        k = $1e100a9690d50909$var$vd;
                        break;
                    case "wheel":
                        k = $1e100a9690d50909$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $1e100a9690d50909$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $1e100a9690d50909$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $1e100a9690d50909$var$Kb(w, x), null != F && t.push($1e100a9690d50909$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $1e100a9690d50909$var$wb && (n = c.relatedTarget || c.fromElement) && ($1e100a9690d50909$var$Wc(n) || n[$1e100a9690d50909$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $1e100a9690d50909$var$Wc(n) : null, null !== n && (J = $1e100a9690d50909$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $1e100a9690d50909$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $1e100a9690d50909$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $1e100a9690d50909$var$ue(k);
                        u = null == n ? h : $1e100a9690d50909$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $1e100a9690d50909$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $1e100a9690d50909$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $1e100a9690d50909$var$vf(F))u++;
                            for(; 0 < w - u;)t = $1e100a9690d50909$var$vf(t), w--;
                            for(; 0 < u - w;)x = $1e100a9690d50909$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $1e100a9690d50909$var$vf(t);
                                x = $1e100a9690d50909$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $1e100a9690d50909$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $1e100a9690d50909$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $1e100a9690d50909$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $1e100a9690d50909$var$ve;
                else if ($1e100a9690d50909$var$me(h)) {
                    if ($1e100a9690d50909$var$we) na = $1e100a9690d50909$var$Fe;
                    else {
                        na = $1e100a9690d50909$var$De;
                        var xa = $1e100a9690d50909$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $1e100a9690d50909$var$Ee);
                if (na && (na = na(a, d))) {
                    $1e100a9690d50909$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $1e100a9690d50909$var$cb(h, "number", h.value);
            }
            xa = d ? $1e100a9690d50909$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($1e100a9690d50909$var$me(xa) || "true" === xa.contentEditable) $1e100a9690d50909$var$Qe = xa, $1e100a9690d50909$var$Re = d, $1e100a9690d50909$var$Se = null;
                    break;
                case "focusout":
                    $1e100a9690d50909$var$Se = $1e100a9690d50909$var$Re = $1e100a9690d50909$var$Qe = null;
                    break;
                case "mousedown":
                    $1e100a9690d50909$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $1e100a9690d50909$var$Te = !1;
                    $1e100a9690d50909$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($1e100a9690d50909$var$Pe) break;
                case "keydown":
                case "keyup":
                    $1e100a9690d50909$var$Ue(g, c, e);
            }
            var $a;
            if ($1e100a9690d50909$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $1e100a9690d50909$var$ie ? $1e100a9690d50909$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($1e100a9690d50909$var$de && "ko" !== c.locale && ($1e100a9690d50909$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $1e100a9690d50909$var$ie && ($a = $1e100a9690d50909$var$nd()) : ($1e100a9690d50909$var$kd = e, $1e100a9690d50909$var$ld = "value" in $1e100a9690d50909$var$kd ? $1e100a9690d50909$var$kd.value : $1e100a9690d50909$var$kd.textContent, $1e100a9690d50909$var$ie = !0)), xa = $1e100a9690d50909$var$oe(d, ba), 0 < xa.length && (ba = new $1e100a9690d50909$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $1e100a9690d50909$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $1e100a9690d50909$var$ce ? $1e100a9690d50909$var$je(a, c) : $1e100a9690d50909$var$ke(a, c)) d = $1e100a9690d50909$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $1e100a9690d50909$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $1e100a9690d50909$var$se(g, b);
    });
}
function $1e100a9690d50909$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $1e100a9690d50909$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $1e100a9690d50909$var$Kb(a, c), null != f && d.unshift($1e100a9690d50909$var$tf(a, f, e)), f = $1e100a9690d50909$var$Kb(a, b), null != f && d.push($1e100a9690d50909$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $1e100a9690d50909$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $1e100a9690d50909$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $1e100a9690d50909$var$Kb(c, f), null != k && g.unshift($1e100a9690d50909$var$tf(c, k, h))) : e || (k = $1e100a9690d50909$var$Kb(c, f), null != k && g.push($1e100a9690d50909$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $1e100a9690d50909$var$xf = /\r\n?/g, $1e100a9690d50909$var$yf = /\u0000|\uFFFD/g;
function $1e100a9690d50909$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($1e100a9690d50909$var$xf, "\n").replace($1e100a9690d50909$var$yf, "");
}
function $1e100a9690d50909$var$Af(a, b, c) {
    b = $1e100a9690d50909$var$zf(b);
    if ($1e100a9690d50909$var$zf(a) !== b && c) throw Error($1e100a9690d50909$var$p(425));
}
function $1e100a9690d50909$var$Bf() {}
var $1e100a9690d50909$var$Cf = null, $1e100a9690d50909$var$Df = null;
function $1e100a9690d50909$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $1e100a9690d50909$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $1e100a9690d50909$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $1e100a9690d50909$var$Hf = "function" === typeof Promise ? Promise : void 0, $1e100a9690d50909$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $1e100a9690d50909$var$Hf ? function(a) {
    return $1e100a9690d50909$var$Hf.resolve(null).then(a).catch($1e100a9690d50909$var$If);
} : $1e100a9690d50909$var$Ff;
function $1e100a9690d50909$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $1e100a9690d50909$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $1e100a9690d50909$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $1e100a9690d50909$var$bd(b);
}
function $1e100a9690d50909$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $1e100a9690d50909$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $1e100a9690d50909$var$Nf = Math.random().toString(36).slice(2), $1e100a9690d50909$var$Of = "__reactFiber$" + $1e100a9690d50909$var$Nf, $1e100a9690d50909$var$Pf = "__reactProps$" + $1e100a9690d50909$var$Nf, $1e100a9690d50909$var$uf = "__reactContainer$" + $1e100a9690d50909$var$Nf, $1e100a9690d50909$var$of = "__reactEvents$" + $1e100a9690d50909$var$Nf, $1e100a9690d50909$var$Qf = "__reactListeners$" + $1e100a9690d50909$var$Nf, $1e100a9690d50909$var$Rf = "__reactHandles$" + $1e100a9690d50909$var$Nf;
function $1e100a9690d50909$var$Wc(a) {
    var b = a[$1e100a9690d50909$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$1e100a9690d50909$var$uf] || c[$1e100a9690d50909$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $1e100a9690d50909$var$Mf(a); null !== a;){
                if (c = a[$1e100a9690d50909$var$Of]) return c;
                a = $1e100a9690d50909$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $1e100a9690d50909$var$Cb(a) {
    a = a[$1e100a9690d50909$var$Of] || a[$1e100a9690d50909$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $1e100a9690d50909$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($1e100a9690d50909$var$p(33));
}
function $1e100a9690d50909$var$Db(a) {
    return a[$1e100a9690d50909$var$Pf] || null;
}
var $1e100a9690d50909$var$Sf = [], $1e100a9690d50909$var$Tf = -1;
function $1e100a9690d50909$var$Uf(a) {
    return {
        current: a
    };
}
function $1e100a9690d50909$var$E(a) {
    0 > $1e100a9690d50909$var$Tf || (a.current = $1e100a9690d50909$var$Sf[$1e100a9690d50909$var$Tf], $1e100a9690d50909$var$Sf[$1e100a9690d50909$var$Tf] = null, $1e100a9690d50909$var$Tf--);
}
function $1e100a9690d50909$var$G(a, b) {
    $1e100a9690d50909$var$Tf++;
    $1e100a9690d50909$var$Sf[$1e100a9690d50909$var$Tf] = a.current;
    a.current = b;
}
var $1e100a9690d50909$var$Vf = {}, $1e100a9690d50909$var$H = $1e100a9690d50909$var$Uf($1e100a9690d50909$var$Vf), $1e100a9690d50909$var$Wf = $1e100a9690d50909$var$Uf(!1), $1e100a9690d50909$var$Xf = $1e100a9690d50909$var$Vf;
function $1e100a9690d50909$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $1e100a9690d50909$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $1e100a9690d50909$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $1e100a9690d50909$var$$f() {
    $1e100a9690d50909$var$E($1e100a9690d50909$var$Wf);
    $1e100a9690d50909$var$E($1e100a9690d50909$var$H);
}
function $1e100a9690d50909$var$ag(a, b, c) {
    if ($1e100a9690d50909$var$H.current !== $1e100a9690d50909$var$Vf) throw Error($1e100a9690d50909$var$p(168));
    $1e100a9690d50909$var$G($1e100a9690d50909$var$H, b);
    $1e100a9690d50909$var$G($1e100a9690d50909$var$Wf, c);
}
function $1e100a9690d50909$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($1e100a9690d50909$var$p(108, $1e100a9690d50909$var$Ra(a) || "Unknown", e));
    return $1e100a9690d50909$var$A({}, c, d);
}
function $1e100a9690d50909$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $1e100a9690d50909$var$Vf;
    $1e100a9690d50909$var$Xf = $1e100a9690d50909$var$H.current;
    $1e100a9690d50909$var$G($1e100a9690d50909$var$H, a);
    $1e100a9690d50909$var$G($1e100a9690d50909$var$Wf, $1e100a9690d50909$var$Wf.current);
    return !0;
}
function $1e100a9690d50909$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($1e100a9690d50909$var$p(169));
    c ? (a = $1e100a9690d50909$var$bg(a, b, $1e100a9690d50909$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $1e100a9690d50909$var$E($1e100a9690d50909$var$Wf), $1e100a9690d50909$var$E($1e100a9690d50909$var$H), $1e100a9690d50909$var$G($1e100a9690d50909$var$H, a)) : $1e100a9690d50909$var$E($1e100a9690d50909$var$Wf);
    $1e100a9690d50909$var$G($1e100a9690d50909$var$Wf, c);
}
var $1e100a9690d50909$var$eg = null, $1e100a9690d50909$var$fg = !1, $1e100a9690d50909$var$gg = !1;
function $1e100a9690d50909$var$hg(a) {
    null === $1e100a9690d50909$var$eg ? $1e100a9690d50909$var$eg = [
        a
    ] : $1e100a9690d50909$var$eg.push(a);
}
function $1e100a9690d50909$var$ig(a) {
    $1e100a9690d50909$var$fg = !0;
    $1e100a9690d50909$var$hg(a);
}
function $1e100a9690d50909$var$jg() {
    if (!$1e100a9690d50909$var$gg && null !== $1e100a9690d50909$var$eg) {
        $1e100a9690d50909$var$gg = !0;
        var a = 0, b = $1e100a9690d50909$var$C;
        try {
            var c = $1e100a9690d50909$var$eg;
            for($1e100a9690d50909$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $1e100a9690d50909$var$eg = null;
            $1e100a9690d50909$var$fg = !1;
        } catch (e) {
            throw null !== $1e100a9690d50909$var$eg && ($1e100a9690d50909$var$eg = $1e100a9690d50909$var$eg.slice(a + 1)), $1e100a9690d50909$var$ac($1e100a9690d50909$var$fc, $1e100a9690d50909$var$jg), e;
        } finally{
            $1e100a9690d50909$var$C = b, $1e100a9690d50909$var$gg = !1;
        }
    }
    return null;
}
var $1e100a9690d50909$var$kg = [], $1e100a9690d50909$var$lg = 0, $1e100a9690d50909$var$mg = null, $1e100a9690d50909$var$ng = 0, $1e100a9690d50909$var$og = [], $1e100a9690d50909$var$pg = 0, $1e100a9690d50909$var$qg = null, $1e100a9690d50909$var$rg = 1, $1e100a9690d50909$var$sg = "";
function $1e100a9690d50909$var$tg(a, b) {
    $1e100a9690d50909$var$kg[$1e100a9690d50909$var$lg++] = $1e100a9690d50909$var$ng;
    $1e100a9690d50909$var$kg[$1e100a9690d50909$var$lg++] = $1e100a9690d50909$var$mg;
    $1e100a9690d50909$var$mg = a;
    $1e100a9690d50909$var$ng = b;
}
function $1e100a9690d50909$var$ug(a, b, c) {
    $1e100a9690d50909$var$og[$1e100a9690d50909$var$pg++] = $1e100a9690d50909$var$rg;
    $1e100a9690d50909$var$og[$1e100a9690d50909$var$pg++] = $1e100a9690d50909$var$sg;
    $1e100a9690d50909$var$og[$1e100a9690d50909$var$pg++] = $1e100a9690d50909$var$qg;
    $1e100a9690d50909$var$qg = a;
    var d = $1e100a9690d50909$var$rg;
    a = $1e100a9690d50909$var$sg;
    var e = 32 - $1e100a9690d50909$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $1e100a9690d50909$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $1e100a9690d50909$var$rg = 1 << 32 - $1e100a9690d50909$var$oc(b) + e | c << e | d;
        $1e100a9690d50909$var$sg = f + a;
    } else $1e100a9690d50909$var$rg = 1 << f | c << e | d, $1e100a9690d50909$var$sg = a;
}
function $1e100a9690d50909$var$vg(a) {
    null !== a.return && ($1e100a9690d50909$var$tg(a, 1), $1e100a9690d50909$var$ug(a, 1, 0));
}
function $1e100a9690d50909$var$wg(a) {
    for(; a === $1e100a9690d50909$var$mg;)$1e100a9690d50909$var$mg = $1e100a9690d50909$var$kg[--$1e100a9690d50909$var$lg], $1e100a9690d50909$var$kg[$1e100a9690d50909$var$lg] = null, $1e100a9690d50909$var$ng = $1e100a9690d50909$var$kg[--$1e100a9690d50909$var$lg], $1e100a9690d50909$var$kg[$1e100a9690d50909$var$lg] = null;
    for(; a === $1e100a9690d50909$var$qg;)$1e100a9690d50909$var$qg = $1e100a9690d50909$var$og[--$1e100a9690d50909$var$pg], $1e100a9690d50909$var$og[$1e100a9690d50909$var$pg] = null, $1e100a9690d50909$var$sg = $1e100a9690d50909$var$og[--$1e100a9690d50909$var$pg], $1e100a9690d50909$var$og[$1e100a9690d50909$var$pg] = null, $1e100a9690d50909$var$rg = $1e100a9690d50909$var$og[--$1e100a9690d50909$var$pg], $1e100a9690d50909$var$og[$1e100a9690d50909$var$pg] = null;
}
var $1e100a9690d50909$var$xg = null, $1e100a9690d50909$var$yg = null, $1e100a9690d50909$var$I = !1, $1e100a9690d50909$var$zg = null;
function $1e100a9690d50909$var$Ag(a, b) {
    var c = $1e100a9690d50909$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $1e100a9690d50909$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $1e100a9690d50909$var$xg = a, $1e100a9690d50909$var$yg = $1e100a9690d50909$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $1e100a9690d50909$var$xg = a, $1e100a9690d50909$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $1e100a9690d50909$var$qg ? {
                id: $1e100a9690d50909$var$rg,
                overflow: $1e100a9690d50909$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $1e100a9690d50909$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $1e100a9690d50909$var$xg = a, $1e100a9690d50909$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $1e100a9690d50909$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $1e100a9690d50909$var$Eg(a) {
    if ($1e100a9690d50909$var$I) {
        var b = $1e100a9690d50909$var$yg;
        if (b) {
            var c = b;
            if (!$1e100a9690d50909$var$Cg(a, b)) {
                if ($1e100a9690d50909$var$Dg(a)) throw Error($1e100a9690d50909$var$p(418));
                b = $1e100a9690d50909$var$Lf(c.nextSibling);
                var d = $1e100a9690d50909$var$xg;
                b && $1e100a9690d50909$var$Cg(a, b) ? $1e100a9690d50909$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $1e100a9690d50909$var$I = !1, $1e100a9690d50909$var$xg = a);
            }
        } else {
            if ($1e100a9690d50909$var$Dg(a)) throw Error($1e100a9690d50909$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $1e100a9690d50909$var$I = !1;
            $1e100a9690d50909$var$xg = a;
        }
    }
}
function $1e100a9690d50909$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $1e100a9690d50909$var$xg = a;
}
function $1e100a9690d50909$var$Gg(a) {
    if (a !== $1e100a9690d50909$var$xg) return !1;
    if (!$1e100a9690d50909$var$I) return $1e100a9690d50909$var$Fg(a), $1e100a9690d50909$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$1e100a9690d50909$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $1e100a9690d50909$var$yg)) {
        if ($1e100a9690d50909$var$Dg(a)) throw $1e100a9690d50909$var$Hg(), Error($1e100a9690d50909$var$p(418));
        for(; b;)$1e100a9690d50909$var$Ag(a, b), b = $1e100a9690d50909$var$Lf(b.nextSibling);
    }
    $1e100a9690d50909$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($1e100a9690d50909$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $1e100a9690d50909$var$yg = $1e100a9690d50909$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $1e100a9690d50909$var$yg = null;
        }
    } else $1e100a9690d50909$var$yg = $1e100a9690d50909$var$xg ? $1e100a9690d50909$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $1e100a9690d50909$var$Hg() {
    for(var a = $1e100a9690d50909$var$yg; a;)a = $1e100a9690d50909$var$Lf(a.nextSibling);
}
function $1e100a9690d50909$var$Ig() {
    $1e100a9690d50909$var$yg = $1e100a9690d50909$var$xg = null;
    $1e100a9690d50909$var$I = !1;
}
function $1e100a9690d50909$var$Jg(a) {
    null === $1e100a9690d50909$var$zg ? $1e100a9690d50909$var$zg = [
        a
    ] : $1e100a9690d50909$var$zg.push(a);
}
var $1e100a9690d50909$var$Kg = $1e100a9690d50909$var$ua.ReactCurrentBatchConfig;
function $1e100a9690d50909$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $1e100a9690d50909$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $1e100a9690d50909$var$Mg = $1e100a9690d50909$var$Uf(null), $1e100a9690d50909$var$Ng = null, $1e100a9690d50909$var$Og = null, $1e100a9690d50909$var$Pg = null;
function $1e100a9690d50909$var$Qg() {
    $1e100a9690d50909$var$Pg = $1e100a9690d50909$var$Og = $1e100a9690d50909$var$Ng = null;
}
function $1e100a9690d50909$var$Rg(a) {
    var b = $1e100a9690d50909$var$Mg.current;
    $1e100a9690d50909$var$E($1e100a9690d50909$var$Mg);
    a._currentValue = b;
}
function $1e100a9690d50909$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $1e100a9690d50909$var$Tg(a, b) {
    $1e100a9690d50909$var$Ng = a;
    $1e100a9690d50909$var$Pg = $1e100a9690d50909$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($1e100a9690d50909$var$Ug = !0), a.firstContext = null);
}
function $1e100a9690d50909$var$Vg(a) {
    var b = a._currentValue;
    if ($1e100a9690d50909$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $1e100a9690d50909$var$Og) {
            if (null === $1e100a9690d50909$var$Ng) throw Error($1e100a9690d50909$var$p(308));
            $1e100a9690d50909$var$Og = a;
            $1e100a9690d50909$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $1e100a9690d50909$var$Og = $1e100a9690d50909$var$Og.next = a;
    }
    return b;
}
var $1e100a9690d50909$var$Wg = null;
function $1e100a9690d50909$var$Xg(a) {
    null === $1e100a9690d50909$var$Wg ? $1e100a9690d50909$var$Wg = [
        a
    ] : $1e100a9690d50909$var$Wg.push(a);
}
function $1e100a9690d50909$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $1e100a9690d50909$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $1e100a9690d50909$var$Zg(a, d);
}
function $1e100a9690d50909$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $1e100a9690d50909$var$$g = !1;
function $1e100a9690d50909$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $1e100a9690d50909$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $1e100a9690d50909$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $1e100a9690d50909$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($1e100a9690d50909$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $1e100a9690d50909$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $1e100a9690d50909$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $1e100a9690d50909$var$Zg(a, c);
}
function $1e100a9690d50909$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $1e100a9690d50909$var$Cc(a, c);
    }
}
function $1e100a9690d50909$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $1e100a9690d50909$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $1e100a9690d50909$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $1e100a9690d50909$var$A({}, q, r);
                            break a;
                        case 2:
                            $1e100a9690d50909$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $1e100a9690d50909$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $1e100a9690d50909$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($1e100a9690d50909$var$p(191, e));
            e.call(d);
        }
    }
}
var $1e100a9690d50909$var$jh = (new $jC8Vy.Component).refs;
function $1e100a9690d50909$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $1e100a9690d50909$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $1e100a9690d50909$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $1e100a9690d50909$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $1e100a9690d50909$var$L(), e = $1e100a9690d50909$var$lh(a), f = $1e100a9690d50909$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $1e100a9690d50909$var$dh(a, f, e);
        null !== b && ($1e100a9690d50909$var$mh(b, a, e, d), $1e100a9690d50909$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $1e100a9690d50909$var$L(), e = $1e100a9690d50909$var$lh(a), f = $1e100a9690d50909$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $1e100a9690d50909$var$dh(a, f, e);
        null !== b && ($1e100a9690d50909$var$mh(b, a, e, d), $1e100a9690d50909$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $1e100a9690d50909$var$L(), d = $1e100a9690d50909$var$lh(a), e = $1e100a9690d50909$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $1e100a9690d50909$var$dh(a, e, d);
        null !== b && ($1e100a9690d50909$var$mh(b, a, d, c), $1e100a9690d50909$var$eh(b, a, d));
    }
};
function $1e100a9690d50909$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$1e100a9690d50909$var$Ie(c, d) || !$1e100a9690d50909$var$Ie(e, f) : !0;
}
function $1e100a9690d50909$var$ph(a, b, c) {
    var d = !1, e = $1e100a9690d50909$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $1e100a9690d50909$var$Vg(f) : (e = $1e100a9690d50909$var$Zf(b) ? $1e100a9690d50909$var$Xf : $1e100a9690d50909$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $1e100a9690d50909$var$Yf(a, e) : $1e100a9690d50909$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $1e100a9690d50909$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $1e100a9690d50909$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $1e100a9690d50909$var$nh.enqueueReplaceState(b, b.state, null);
}
function $1e100a9690d50909$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $1e100a9690d50909$var$jh;
    $1e100a9690d50909$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $1e100a9690d50909$var$Vg(f) : (f = $1e100a9690d50909$var$Zf(b) ? $1e100a9690d50909$var$Xf : $1e100a9690d50909$var$H.current, e.context = $1e100a9690d50909$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($1e100a9690d50909$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $1e100a9690d50909$var$nh.enqueueReplaceState(e, e.state, null), $1e100a9690d50909$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $1e100a9690d50909$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($1e100a9690d50909$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($1e100a9690d50909$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $1e100a9690d50909$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($1e100a9690d50909$var$p(284));
        if (!c._owner) throw Error($1e100a9690d50909$var$p(290, a));
    }
    return a;
}
function $1e100a9690d50909$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($1e100a9690d50909$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $1e100a9690d50909$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $1e100a9690d50909$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $1e100a9690d50909$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $1e100a9690d50909$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $1e100a9690d50909$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $1e100a9690d50909$var$Ha && $1e100a9690d50909$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $1e100a9690d50909$var$sh(a, b, c), d.return = a, d;
        d = $1e100a9690d50909$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $1e100a9690d50909$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $1e100a9690d50909$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $1e100a9690d50909$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $1e100a9690d50909$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $1e100a9690d50909$var$va:
                    return c = $1e100a9690d50909$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $1e100a9690d50909$var$sh(a, null, b), c.return = a, c;
                case $1e100a9690d50909$var$wa:
                    return b = $1e100a9690d50909$var$zh(b, a.mode, c), b.return = a, b;
                case $1e100a9690d50909$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($1e100a9690d50909$var$eb(b) || $1e100a9690d50909$var$Ka(b)) return b = $1e100a9690d50909$var$Ah(b, a.mode, c, null), b.return = a, b;
            $1e100a9690d50909$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $1e100a9690d50909$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $1e100a9690d50909$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $1e100a9690d50909$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($1e100a9690d50909$var$eb(c) || $1e100a9690d50909$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $1e100a9690d50909$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $1e100a9690d50909$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $1e100a9690d50909$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $1e100a9690d50909$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($1e100a9690d50909$var$eb(d) || $1e100a9690d50909$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $1e100a9690d50909$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $1e100a9690d50909$var$I && $1e100a9690d50909$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $1e100a9690d50909$var$I && $1e100a9690d50909$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $1e100a9690d50909$var$I && $1e100a9690d50909$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $1e100a9690d50909$var$Ka(h);
        if ("function" !== typeof l) throw Error($1e100a9690d50909$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($1e100a9690d50909$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $1e100a9690d50909$var$I && $1e100a9690d50909$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $1e100a9690d50909$var$I && $1e100a9690d50909$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $1e100a9690d50909$var$I && $1e100a9690d50909$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $1e100a9690d50909$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $1e100a9690d50909$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $1e100a9690d50909$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $1e100a9690d50909$var$Ha && $1e100a9690d50909$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $1e100a9690d50909$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $1e100a9690d50909$var$ya ? (d = $1e100a9690d50909$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $1e100a9690d50909$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $1e100a9690d50909$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $1e100a9690d50909$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $1e100a9690d50909$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $1e100a9690d50909$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($1e100a9690d50909$var$eb(f)) return n(a, d, f, h);
            if ($1e100a9690d50909$var$Ka(f)) return t(a, d, f, h);
            $1e100a9690d50909$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $1e100a9690d50909$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $1e100a9690d50909$var$Bh = $1e100a9690d50909$var$vh(!0), $1e100a9690d50909$var$Ch = $1e100a9690d50909$var$vh(!1), $1e100a9690d50909$var$Dh = {}, $1e100a9690d50909$var$Eh = $1e100a9690d50909$var$Uf($1e100a9690d50909$var$Dh), $1e100a9690d50909$var$Fh = $1e100a9690d50909$var$Uf($1e100a9690d50909$var$Dh), $1e100a9690d50909$var$Gh = $1e100a9690d50909$var$Uf($1e100a9690d50909$var$Dh);
function $1e100a9690d50909$var$Hh(a) {
    if (a === $1e100a9690d50909$var$Dh) throw Error($1e100a9690d50909$var$p(174));
    return a;
}
function $1e100a9690d50909$var$Ih(a, b) {
    $1e100a9690d50909$var$G($1e100a9690d50909$var$Gh, b);
    $1e100a9690d50909$var$G($1e100a9690d50909$var$Fh, a);
    $1e100a9690d50909$var$G($1e100a9690d50909$var$Eh, $1e100a9690d50909$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $1e100a9690d50909$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $1e100a9690d50909$var$lb(b, a);
    }
    $1e100a9690d50909$var$E($1e100a9690d50909$var$Eh);
    $1e100a9690d50909$var$G($1e100a9690d50909$var$Eh, b);
}
function $1e100a9690d50909$var$Jh() {
    $1e100a9690d50909$var$E($1e100a9690d50909$var$Eh);
    $1e100a9690d50909$var$E($1e100a9690d50909$var$Fh);
    $1e100a9690d50909$var$E($1e100a9690d50909$var$Gh);
}
function $1e100a9690d50909$var$Kh(a) {
    $1e100a9690d50909$var$Hh($1e100a9690d50909$var$Gh.current);
    var b = $1e100a9690d50909$var$Hh($1e100a9690d50909$var$Eh.current);
    var c = $1e100a9690d50909$var$lb(b, a.type);
    b !== c && ($1e100a9690d50909$var$G($1e100a9690d50909$var$Fh, a), $1e100a9690d50909$var$G($1e100a9690d50909$var$Eh, c));
}
function $1e100a9690d50909$var$Lh(a) {
    $1e100a9690d50909$var$Fh.current === a && ($1e100a9690d50909$var$E($1e100a9690d50909$var$Eh), $1e100a9690d50909$var$E($1e100a9690d50909$var$Fh));
}
var $1e100a9690d50909$var$M = $1e100a9690d50909$var$Uf(0);
function $1e100a9690d50909$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $1e100a9690d50909$var$Nh = [];
function $1e100a9690d50909$var$Oh() {
    for(var a = 0; a < $1e100a9690d50909$var$Nh.length; a++)$1e100a9690d50909$var$Nh[a]._workInProgressVersionPrimary = null;
    $1e100a9690d50909$var$Nh.length = 0;
}
var $1e100a9690d50909$var$Ph = $1e100a9690d50909$var$ua.ReactCurrentDispatcher, $1e100a9690d50909$var$Qh = $1e100a9690d50909$var$ua.ReactCurrentBatchConfig, $1e100a9690d50909$var$Rh = 0, $1e100a9690d50909$var$N = null, $1e100a9690d50909$var$O = null, $1e100a9690d50909$var$P = null, $1e100a9690d50909$var$Sh = !1, $1e100a9690d50909$var$Th = !1, $1e100a9690d50909$var$Uh = 0, $1e100a9690d50909$var$Vh = 0;
function $1e100a9690d50909$var$Q() {
    throw Error($1e100a9690d50909$var$p(321));
}
function $1e100a9690d50909$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$1e100a9690d50909$var$He(a[c], b[c])) return !1;
    return !0;
}
function $1e100a9690d50909$var$Xh(a, b, c, d, e, f) {
    $1e100a9690d50909$var$Rh = f;
    $1e100a9690d50909$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $1e100a9690d50909$var$Ph.current = null === a || null === a.memoizedState ? $1e100a9690d50909$var$Yh : $1e100a9690d50909$var$Zh;
    a = c(d, e);
    if ($1e100a9690d50909$var$Th) {
        f = 0;
        do {
            $1e100a9690d50909$var$Th = !1;
            $1e100a9690d50909$var$Uh = 0;
            if (25 <= f) throw Error($1e100a9690d50909$var$p(301));
            f += 1;
            $1e100a9690d50909$var$P = $1e100a9690d50909$var$O = null;
            b.updateQueue = null;
            $1e100a9690d50909$var$Ph.current = $1e100a9690d50909$var$$h;
            a = c(d, e);
        }while ($1e100a9690d50909$var$Th);
    }
    $1e100a9690d50909$var$Ph.current = $1e100a9690d50909$var$ai;
    b = null !== $1e100a9690d50909$var$O && null !== $1e100a9690d50909$var$O.next;
    $1e100a9690d50909$var$Rh = 0;
    $1e100a9690d50909$var$P = $1e100a9690d50909$var$O = $1e100a9690d50909$var$N = null;
    $1e100a9690d50909$var$Sh = !1;
    if (b) throw Error($1e100a9690d50909$var$p(300));
    return a;
}
function $1e100a9690d50909$var$bi() {
    var a = 0 !== $1e100a9690d50909$var$Uh;
    $1e100a9690d50909$var$Uh = 0;
    return a;
}
function $1e100a9690d50909$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $1e100a9690d50909$var$P ? $1e100a9690d50909$var$N.memoizedState = $1e100a9690d50909$var$P = a : $1e100a9690d50909$var$P = $1e100a9690d50909$var$P.next = a;
    return $1e100a9690d50909$var$P;
}
function $1e100a9690d50909$var$di() {
    if (null === $1e100a9690d50909$var$O) {
        var a = $1e100a9690d50909$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $1e100a9690d50909$var$O.next;
    var b = null === $1e100a9690d50909$var$P ? $1e100a9690d50909$var$N.memoizedState : $1e100a9690d50909$var$P.next;
    if (null !== b) $1e100a9690d50909$var$P = b, $1e100a9690d50909$var$O = a;
    else {
        if (null === a) throw Error($1e100a9690d50909$var$p(310));
        $1e100a9690d50909$var$O = a;
        a = {
            memoizedState: $1e100a9690d50909$var$O.memoizedState,
            baseState: $1e100a9690d50909$var$O.baseState,
            baseQueue: $1e100a9690d50909$var$O.baseQueue,
            queue: $1e100a9690d50909$var$O.queue,
            next: null
        };
        null === $1e100a9690d50909$var$P ? $1e100a9690d50909$var$N.memoizedState = $1e100a9690d50909$var$P = a : $1e100a9690d50909$var$P = $1e100a9690d50909$var$P.next = a;
    }
    return $1e100a9690d50909$var$P;
}
function $1e100a9690d50909$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $1e100a9690d50909$var$fi(a) {
    var b = $1e100a9690d50909$var$di(), c = b.queue;
    if (null === c) throw Error($1e100a9690d50909$var$p(311));
    c.lastRenderedReducer = a;
    var d = $1e100a9690d50909$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($1e100a9690d50909$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $1e100a9690d50909$var$N.lanes |= m;
                $1e100a9690d50909$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $1e100a9690d50909$var$He(d, b.memoizedState) || ($1e100a9690d50909$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $1e100a9690d50909$var$N.lanes |= f, $1e100a9690d50909$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $1e100a9690d50909$var$gi(a) {
    var b = $1e100a9690d50909$var$di(), c = b.queue;
    if (null === c) throw Error($1e100a9690d50909$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $1e100a9690d50909$var$He(f, b.memoizedState) || ($1e100a9690d50909$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $1e100a9690d50909$var$hi() {}
function $1e100a9690d50909$var$ii(a, b) {
    var c = $1e100a9690d50909$var$N, d = $1e100a9690d50909$var$di(), e = b(), f = !$1e100a9690d50909$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $1e100a9690d50909$var$Ug = !0);
    d = d.queue;
    $1e100a9690d50909$var$ji($1e100a9690d50909$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $1e100a9690d50909$var$P && $1e100a9690d50909$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $1e100a9690d50909$var$li(9, $1e100a9690d50909$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $1e100a9690d50909$var$R) throw Error($1e100a9690d50909$var$p(349));
        0 !== ($1e100a9690d50909$var$Rh & 30) || $1e100a9690d50909$var$ni(c, b, e);
    }
    return e;
}
function $1e100a9690d50909$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $1e100a9690d50909$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $1e100a9690d50909$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $1e100a9690d50909$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $1e100a9690d50909$var$oi(b) && $1e100a9690d50909$var$pi(a);
}
function $1e100a9690d50909$var$ki(a, b, c) {
    return c(function() {
        $1e100a9690d50909$var$oi(b) && $1e100a9690d50909$var$pi(a);
    });
}
function $1e100a9690d50909$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$1e100a9690d50909$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $1e100a9690d50909$var$pi(a) {
    var b = $1e100a9690d50909$var$Zg(a, 1);
    null !== b && $1e100a9690d50909$var$mh(b, a, 1, -1);
}
function $1e100a9690d50909$var$qi(a) {
    var b = $1e100a9690d50909$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $1e100a9690d50909$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $1e100a9690d50909$var$ri.bind(null, $1e100a9690d50909$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $1e100a9690d50909$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $1e100a9690d50909$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $1e100a9690d50909$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $1e100a9690d50909$var$si() {
    return $1e100a9690d50909$var$di().memoizedState;
}
function $1e100a9690d50909$var$ti(a, b, c, d) {
    var e = $1e100a9690d50909$var$ci();
    $1e100a9690d50909$var$N.flags |= a;
    e.memoizedState = $1e100a9690d50909$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $1e100a9690d50909$var$ui(a, b, c, d) {
    var e = $1e100a9690d50909$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $1e100a9690d50909$var$O) {
        var g = $1e100a9690d50909$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $1e100a9690d50909$var$Wh(d, g.deps)) {
            e.memoizedState = $1e100a9690d50909$var$li(b, c, f, d);
            return;
        }
    }
    $1e100a9690d50909$var$N.flags |= a;
    e.memoizedState = $1e100a9690d50909$var$li(1 | b, c, f, d);
}
function $1e100a9690d50909$var$vi(a, b) {
    return $1e100a9690d50909$var$ti(8390656, 8, a, b);
}
function $1e100a9690d50909$var$ji(a, b) {
    return $1e100a9690d50909$var$ui(2048, 8, a, b);
}
function $1e100a9690d50909$var$wi(a, b) {
    return $1e100a9690d50909$var$ui(4, 2, a, b);
}
function $1e100a9690d50909$var$xi(a, b) {
    return $1e100a9690d50909$var$ui(4, 4, a, b);
}
function $1e100a9690d50909$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $1e100a9690d50909$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $1e100a9690d50909$var$ui(4, 4, $1e100a9690d50909$var$yi.bind(null, b, a), c);
}
function $1e100a9690d50909$var$Ai() {}
function $1e100a9690d50909$var$Bi(a, b) {
    var c = $1e100a9690d50909$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $1e100a9690d50909$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $1e100a9690d50909$var$Ci(a, b) {
    var c = $1e100a9690d50909$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $1e100a9690d50909$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $1e100a9690d50909$var$Di(a, b, c) {
    if (0 === ($1e100a9690d50909$var$Rh & 21)) return a.baseState && (a.baseState = !1, $1e100a9690d50909$var$Ug = !0), a.memoizedState = c;
    $1e100a9690d50909$var$He(c, b) || (c = $1e100a9690d50909$var$yc(), $1e100a9690d50909$var$N.lanes |= c, $1e100a9690d50909$var$hh |= c, a.baseState = !0);
    return b;
}
function $1e100a9690d50909$var$Ei(a, b) {
    var c = $1e100a9690d50909$var$C;
    $1e100a9690d50909$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $1e100a9690d50909$var$Qh.transition;
    $1e100a9690d50909$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $1e100a9690d50909$var$C = c, $1e100a9690d50909$var$Qh.transition = d;
    }
}
function $1e100a9690d50909$var$Fi() {
    return $1e100a9690d50909$var$di().memoizedState;
}
function $1e100a9690d50909$var$Gi(a, b, c) {
    var d = $1e100a9690d50909$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($1e100a9690d50909$var$Hi(a)) $1e100a9690d50909$var$Ii(b, c);
    else if (c = $1e100a9690d50909$var$Yg(a, b, c, d), null !== c) {
        var e = $1e100a9690d50909$var$L();
        $1e100a9690d50909$var$mh(c, a, d, e);
        $1e100a9690d50909$var$Ji(c, b, d);
    }
}
function $1e100a9690d50909$var$ri(a, b, c) {
    var d = $1e100a9690d50909$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($1e100a9690d50909$var$Hi(a)) $1e100a9690d50909$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($1e100a9690d50909$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $1e100a9690d50909$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $1e100a9690d50909$var$Yg(a, b, e, d);
        null !== c && (e = $1e100a9690d50909$var$L(), $1e100a9690d50909$var$mh(c, a, d, e), $1e100a9690d50909$var$Ji(c, b, d));
    }
}
function $1e100a9690d50909$var$Hi(a) {
    var b = a.alternate;
    return a === $1e100a9690d50909$var$N || null !== b && b === $1e100a9690d50909$var$N;
}
function $1e100a9690d50909$var$Ii(a, b) {
    $1e100a9690d50909$var$Th = $1e100a9690d50909$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $1e100a9690d50909$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $1e100a9690d50909$var$Cc(a, c);
    }
}
var $1e100a9690d50909$var$ai = {
    readContext: $1e100a9690d50909$var$Vg,
    useCallback: $1e100a9690d50909$var$Q,
    useContext: $1e100a9690d50909$var$Q,
    useEffect: $1e100a9690d50909$var$Q,
    useImperativeHandle: $1e100a9690d50909$var$Q,
    useInsertionEffect: $1e100a9690d50909$var$Q,
    useLayoutEffect: $1e100a9690d50909$var$Q,
    useMemo: $1e100a9690d50909$var$Q,
    useReducer: $1e100a9690d50909$var$Q,
    useRef: $1e100a9690d50909$var$Q,
    useState: $1e100a9690d50909$var$Q,
    useDebugValue: $1e100a9690d50909$var$Q,
    useDeferredValue: $1e100a9690d50909$var$Q,
    useTransition: $1e100a9690d50909$var$Q,
    useMutableSource: $1e100a9690d50909$var$Q,
    useSyncExternalStore: $1e100a9690d50909$var$Q,
    useId: $1e100a9690d50909$var$Q,
    unstable_isNewReconciler: !1
}, $1e100a9690d50909$var$Yh = {
    readContext: $1e100a9690d50909$var$Vg,
    useCallback: function(a, b) {
        $1e100a9690d50909$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $1e100a9690d50909$var$Vg,
    useEffect: $1e100a9690d50909$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $1e100a9690d50909$var$ti(4194308, 4, $1e100a9690d50909$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $1e100a9690d50909$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $1e100a9690d50909$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $1e100a9690d50909$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $1e100a9690d50909$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $1e100a9690d50909$var$Gi.bind(null, $1e100a9690d50909$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $1e100a9690d50909$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $1e100a9690d50909$var$qi,
    useDebugValue: $1e100a9690d50909$var$Ai,
    useDeferredValue: function(a) {
        return $1e100a9690d50909$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $1e100a9690d50909$var$qi(!1), b = a[0];
        a = $1e100a9690d50909$var$Ei.bind(null, a[1]);
        $1e100a9690d50909$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $1e100a9690d50909$var$N, e = $1e100a9690d50909$var$ci();
        if ($1e100a9690d50909$var$I) {
            if (void 0 === c) throw Error($1e100a9690d50909$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $1e100a9690d50909$var$R) throw Error($1e100a9690d50909$var$p(349));
            0 !== ($1e100a9690d50909$var$Rh & 30) || $1e100a9690d50909$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $1e100a9690d50909$var$vi($1e100a9690d50909$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $1e100a9690d50909$var$li(9, $1e100a9690d50909$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $1e100a9690d50909$var$ci(), b = $1e100a9690d50909$var$R.identifierPrefix;
        if ($1e100a9690d50909$var$I) {
            var c = $1e100a9690d50909$var$sg;
            var d = $1e100a9690d50909$var$rg;
            c = (d & ~(1 << 32 - $1e100a9690d50909$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $1e100a9690d50909$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $1e100a9690d50909$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $1e100a9690d50909$var$Zh = {
    readContext: $1e100a9690d50909$var$Vg,
    useCallback: $1e100a9690d50909$var$Bi,
    useContext: $1e100a9690d50909$var$Vg,
    useEffect: $1e100a9690d50909$var$ji,
    useImperativeHandle: $1e100a9690d50909$var$zi,
    useInsertionEffect: $1e100a9690d50909$var$wi,
    useLayoutEffect: $1e100a9690d50909$var$xi,
    useMemo: $1e100a9690d50909$var$Ci,
    useReducer: $1e100a9690d50909$var$fi,
    useRef: $1e100a9690d50909$var$si,
    useState: function() {
        return $1e100a9690d50909$var$fi($1e100a9690d50909$var$ei);
    },
    useDebugValue: $1e100a9690d50909$var$Ai,
    useDeferredValue: function(a) {
        var b = $1e100a9690d50909$var$di();
        return $1e100a9690d50909$var$Di(b, $1e100a9690d50909$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $1e100a9690d50909$var$fi($1e100a9690d50909$var$ei)[0], b = $1e100a9690d50909$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $1e100a9690d50909$var$hi,
    useSyncExternalStore: $1e100a9690d50909$var$ii,
    useId: $1e100a9690d50909$var$Fi,
    unstable_isNewReconciler: !1
}, $1e100a9690d50909$var$$h = {
    readContext: $1e100a9690d50909$var$Vg,
    useCallback: $1e100a9690d50909$var$Bi,
    useContext: $1e100a9690d50909$var$Vg,
    useEffect: $1e100a9690d50909$var$ji,
    useImperativeHandle: $1e100a9690d50909$var$zi,
    useInsertionEffect: $1e100a9690d50909$var$wi,
    useLayoutEffect: $1e100a9690d50909$var$xi,
    useMemo: $1e100a9690d50909$var$Ci,
    useReducer: $1e100a9690d50909$var$gi,
    useRef: $1e100a9690d50909$var$si,
    useState: function() {
        return $1e100a9690d50909$var$gi($1e100a9690d50909$var$ei);
    },
    useDebugValue: $1e100a9690d50909$var$Ai,
    useDeferredValue: function(a) {
        var b = $1e100a9690d50909$var$di();
        return null === $1e100a9690d50909$var$O ? b.memoizedState = a : $1e100a9690d50909$var$Di(b, $1e100a9690d50909$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $1e100a9690d50909$var$gi($1e100a9690d50909$var$ei)[0], b = $1e100a9690d50909$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $1e100a9690d50909$var$hi,
    useSyncExternalStore: $1e100a9690d50909$var$ii,
    useId: $1e100a9690d50909$var$Fi,
    unstable_isNewReconciler: !1
};
function $1e100a9690d50909$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $1e100a9690d50909$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $1e100a9690d50909$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $1e100a9690d50909$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $1e100a9690d50909$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $1e100a9690d50909$var$Oi(a, b, c) {
    c = $1e100a9690d50909$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $1e100a9690d50909$var$Pi || ($1e100a9690d50909$var$Pi = !0, $1e100a9690d50909$var$Qi = d);
        $1e100a9690d50909$var$Mi(a, b);
    };
    return c;
}
function $1e100a9690d50909$var$Ri(a, b, c) {
    c = $1e100a9690d50909$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $1e100a9690d50909$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $1e100a9690d50909$var$Mi(a, b);
        "function" !== typeof d && (null === $1e100a9690d50909$var$Si ? $1e100a9690d50909$var$Si = new Set([
            this
        ]) : $1e100a9690d50909$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $1e100a9690d50909$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $1e100a9690d50909$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $1e100a9690d50909$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $1e100a9690d50909$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $1e100a9690d50909$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $1e100a9690d50909$var$ch(-1, 1), b.tag = 2, $1e100a9690d50909$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $1e100a9690d50909$var$Xi = $1e100a9690d50909$var$ua.ReactCurrentOwner, $1e100a9690d50909$var$Ug = !1;
function $1e100a9690d50909$var$Yi(a, b, c, d) {
    b.child = null === a ? $1e100a9690d50909$var$Ch(b, null, c, d) : $1e100a9690d50909$var$Bh(b, a.child, c, d);
}
function $1e100a9690d50909$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $1e100a9690d50909$var$Tg(b, e);
    d = $1e100a9690d50909$var$Xh(a, b, c, d, f, e);
    c = $1e100a9690d50909$var$bi();
    if (null !== a && !$1e100a9690d50909$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $1e100a9690d50909$var$$i(a, b, e);
    $1e100a9690d50909$var$I && c && $1e100a9690d50909$var$vg(b);
    b.flags |= 1;
    $1e100a9690d50909$var$Yi(a, b, d, e);
    return b.child;
}
function $1e100a9690d50909$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$1e100a9690d50909$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $1e100a9690d50909$var$cj(a, b, f, d, e);
        a = $1e100a9690d50909$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $1e100a9690d50909$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $1e100a9690d50909$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $1e100a9690d50909$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $1e100a9690d50909$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($1e100a9690d50909$var$Ie(f, d) && a.ref === b.ref) {
            if ($1e100a9690d50909$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($1e100a9690d50909$var$Ug = !0);
            else return b.lanes = a.lanes, $1e100a9690d50909$var$$i(a, b, e);
        }
    }
    return $1e100a9690d50909$var$dj(a, b, c, d, e);
}
function $1e100a9690d50909$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $1e100a9690d50909$var$G($1e100a9690d50909$var$fj, $1e100a9690d50909$var$gj), $1e100a9690d50909$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $1e100a9690d50909$var$G($1e100a9690d50909$var$fj, $1e100a9690d50909$var$gj), $1e100a9690d50909$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $1e100a9690d50909$var$G($1e100a9690d50909$var$fj, $1e100a9690d50909$var$gj);
            $1e100a9690d50909$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $1e100a9690d50909$var$G($1e100a9690d50909$var$fj, $1e100a9690d50909$var$gj), $1e100a9690d50909$var$gj |= d;
    $1e100a9690d50909$var$Yi(a, b, e, c);
    return b.child;
}
function $1e100a9690d50909$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $1e100a9690d50909$var$dj(a, b, c, d, e) {
    var f = $1e100a9690d50909$var$Zf(c) ? $1e100a9690d50909$var$Xf : $1e100a9690d50909$var$H.current;
    f = $1e100a9690d50909$var$Yf(b, f);
    $1e100a9690d50909$var$Tg(b, e);
    c = $1e100a9690d50909$var$Xh(a, b, c, d, f, e);
    d = $1e100a9690d50909$var$bi();
    if (null !== a && !$1e100a9690d50909$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $1e100a9690d50909$var$$i(a, b, e);
    $1e100a9690d50909$var$I && d && $1e100a9690d50909$var$vg(b);
    b.flags |= 1;
    $1e100a9690d50909$var$Yi(a, b, c, e);
    return b.child;
}
function $1e100a9690d50909$var$ij(a, b, c, d, e) {
    if ($1e100a9690d50909$var$Zf(c)) {
        var f = !0;
        $1e100a9690d50909$var$cg(b);
    } else f = !1;
    $1e100a9690d50909$var$Tg(b, e);
    if (null === b.stateNode) $1e100a9690d50909$var$jj(a, b), $1e100a9690d50909$var$ph(b, c, d), $1e100a9690d50909$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $1e100a9690d50909$var$Vg(l) : (l = $1e100a9690d50909$var$Zf(c) ? $1e100a9690d50909$var$Xf : $1e100a9690d50909$var$H.current, l = $1e100a9690d50909$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $1e100a9690d50909$var$qh(b, g, d, l);
        $1e100a9690d50909$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $1e100a9690d50909$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $1e100a9690d50909$var$Wf.current || $1e100a9690d50909$var$$g ? ("function" === typeof m && ($1e100a9690d50909$var$kh(b, c, m, d), k = b.memoizedState), (h = $1e100a9690d50909$var$$g || $1e100a9690d50909$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $1e100a9690d50909$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $1e100a9690d50909$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $1e100a9690d50909$var$Vg(k) : (k = $1e100a9690d50909$var$Zf(c) ? $1e100a9690d50909$var$Xf : $1e100a9690d50909$var$H.current, k = $1e100a9690d50909$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $1e100a9690d50909$var$qh(b, g, d, k);
        $1e100a9690d50909$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $1e100a9690d50909$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $1e100a9690d50909$var$Wf.current || $1e100a9690d50909$var$$g ? ("function" === typeof y && ($1e100a9690d50909$var$kh(b, c, y, d), n = b.memoizedState), (l = $1e100a9690d50909$var$$g || $1e100a9690d50909$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $1e100a9690d50909$var$kj(a, b, c, d, f, e);
}
function $1e100a9690d50909$var$kj(a, b, c, d, e, f) {
    $1e100a9690d50909$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $1e100a9690d50909$var$dg(b, c, !1), $1e100a9690d50909$var$$i(a, b, f);
    d = b.stateNode;
    $1e100a9690d50909$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $1e100a9690d50909$var$Bh(b, a.child, null, f), b.child = $1e100a9690d50909$var$Bh(b, null, h, f)) : $1e100a9690d50909$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $1e100a9690d50909$var$dg(b, c, !0);
    return b.child;
}
function $1e100a9690d50909$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $1e100a9690d50909$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $1e100a9690d50909$var$ag(a, b.context, !1);
    $1e100a9690d50909$var$Ih(a, b.containerInfo);
}
function $1e100a9690d50909$var$mj(a, b, c, d, e) {
    $1e100a9690d50909$var$Ig();
    $1e100a9690d50909$var$Jg(e);
    b.flags |= 256;
    $1e100a9690d50909$var$Yi(a, b, c, d);
    return b.child;
}
var $1e100a9690d50909$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $1e100a9690d50909$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $1e100a9690d50909$var$pj(a, b, c) {
    var d = b.pendingProps, e = $1e100a9690d50909$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $1e100a9690d50909$var$G($1e100a9690d50909$var$M, e & 1);
    if (null === a) {
        $1e100a9690d50909$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $1e100a9690d50909$var$qj(g, d, 0, null), a = $1e100a9690d50909$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $1e100a9690d50909$var$oj(c), b.memoizedState = $1e100a9690d50909$var$nj, a) : $1e100a9690d50909$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $1e100a9690d50909$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $1e100a9690d50909$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $1e100a9690d50909$var$wh(h, f) : (f = $1e100a9690d50909$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $1e100a9690d50909$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $1e100a9690d50909$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $1e100a9690d50909$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $1e100a9690d50909$var$rj(a, b) {
    b = $1e100a9690d50909$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $1e100a9690d50909$var$tj(a, b, c, d) {
    null !== d && $1e100a9690d50909$var$Jg(d);
    $1e100a9690d50909$var$Bh(b, a.child, null, c);
    a = $1e100a9690d50909$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $1e100a9690d50909$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $1e100a9690d50909$var$Li(Error($1e100a9690d50909$var$p(422))), $1e100a9690d50909$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $1e100a9690d50909$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $1e100a9690d50909$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $1e100a9690d50909$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $1e100a9690d50909$var$oj(g);
        b.memoizedState = $1e100a9690d50909$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $1e100a9690d50909$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($1e100a9690d50909$var$p(419));
        d = $1e100a9690d50909$var$Li(f, d, void 0);
        return $1e100a9690d50909$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($1e100a9690d50909$var$Ug || h) {
        d = $1e100a9690d50909$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $1e100a9690d50909$var$Zg(a, e), $1e100a9690d50909$var$mh(d, a, e, -1));
        }
        $1e100a9690d50909$var$uj();
        d = $1e100a9690d50909$var$Li(Error($1e100a9690d50909$var$p(421)));
        return $1e100a9690d50909$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $1e100a9690d50909$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $1e100a9690d50909$var$yg = $1e100a9690d50909$var$Lf(e.nextSibling);
    $1e100a9690d50909$var$xg = b;
    $1e100a9690d50909$var$I = !0;
    $1e100a9690d50909$var$zg = null;
    null !== a && ($1e100a9690d50909$var$og[$1e100a9690d50909$var$pg++] = $1e100a9690d50909$var$rg, $1e100a9690d50909$var$og[$1e100a9690d50909$var$pg++] = $1e100a9690d50909$var$sg, $1e100a9690d50909$var$og[$1e100a9690d50909$var$pg++] = $1e100a9690d50909$var$qg, $1e100a9690d50909$var$rg = a.id, $1e100a9690d50909$var$sg = a.overflow, $1e100a9690d50909$var$qg = b);
    b = $1e100a9690d50909$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $1e100a9690d50909$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $1e100a9690d50909$var$Sg(a.return, b, c);
}
function $1e100a9690d50909$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $1e100a9690d50909$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $1e100a9690d50909$var$Yi(a, b, d.children, c);
    d = $1e100a9690d50909$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $1e100a9690d50909$var$wj(a, c, b);
            else if (19 === a.tag) $1e100a9690d50909$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $1e100a9690d50909$var$G($1e100a9690d50909$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $1e100a9690d50909$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $1e100a9690d50909$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $1e100a9690d50909$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $1e100a9690d50909$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $1e100a9690d50909$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $1e100a9690d50909$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $1e100a9690d50909$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $1e100a9690d50909$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($1e100a9690d50909$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $1e100a9690d50909$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $1e100a9690d50909$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $1e100a9690d50909$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $1e100a9690d50909$var$lj(b);
            $1e100a9690d50909$var$Ig();
            break;
        case 5:
            $1e100a9690d50909$var$Kh(b);
            break;
        case 1:
            $1e100a9690d50909$var$Zf(b.type) && $1e100a9690d50909$var$cg(b);
            break;
        case 4:
            $1e100a9690d50909$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $1e100a9690d50909$var$G($1e100a9690d50909$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $1e100a9690d50909$var$G($1e100a9690d50909$var$M, $1e100a9690d50909$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $1e100a9690d50909$var$pj(a, b, c);
                $1e100a9690d50909$var$G($1e100a9690d50909$var$M, $1e100a9690d50909$var$M.current & 1);
                a = $1e100a9690d50909$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $1e100a9690d50909$var$G($1e100a9690d50909$var$M, $1e100a9690d50909$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $1e100a9690d50909$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $1e100a9690d50909$var$G($1e100a9690d50909$var$M, $1e100a9690d50909$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $1e100a9690d50909$var$ej(a, b, c);
    }
    return $1e100a9690d50909$var$$i(a, b, c);
}
var $1e100a9690d50909$var$Aj, $1e100a9690d50909$var$Bj, $1e100a9690d50909$var$Cj, $1e100a9690d50909$var$Dj;
$1e100a9690d50909$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$1e100a9690d50909$var$Bj = function() {};
$1e100a9690d50909$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $1e100a9690d50909$var$Hh($1e100a9690d50909$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $1e100a9690d50909$var$Ya(a, e);
                d = $1e100a9690d50909$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $1e100a9690d50909$var$A({}, e, {
                    value: void 0
                });
                d = $1e100a9690d50909$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $1e100a9690d50909$var$gb(a, e);
                d = $1e100a9690d50909$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $1e100a9690d50909$var$Bf);
        }
        $1e100a9690d50909$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($1e100a9690d50909$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($1e100a9690d50909$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $1e100a9690d50909$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$1e100a9690d50909$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $1e100a9690d50909$var$Ej(a, b) {
    if (!$1e100a9690d50909$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $1e100a9690d50909$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $1e100a9690d50909$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $1e100a9690d50909$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $1e100a9690d50909$var$S(b), null;
        case 1:
            return $1e100a9690d50909$var$Zf(b.type) && $1e100a9690d50909$var$$f(), $1e100a9690d50909$var$S(b), null;
        case 3:
            d = b.stateNode;
            $1e100a9690d50909$var$Jh();
            $1e100a9690d50909$var$E($1e100a9690d50909$var$Wf);
            $1e100a9690d50909$var$E($1e100a9690d50909$var$H);
            $1e100a9690d50909$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $1e100a9690d50909$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $1e100a9690d50909$var$zg && ($1e100a9690d50909$var$Gj($1e100a9690d50909$var$zg), $1e100a9690d50909$var$zg = null));
            $1e100a9690d50909$var$Bj(a, b);
            $1e100a9690d50909$var$S(b);
            return null;
        case 5:
            $1e100a9690d50909$var$Lh(b);
            var e = $1e100a9690d50909$var$Hh($1e100a9690d50909$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $1e100a9690d50909$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($1e100a9690d50909$var$p(166));
                    $1e100a9690d50909$var$S(b);
                    return null;
                }
                a = $1e100a9690d50909$var$Hh($1e100a9690d50909$var$Eh.current);
                if ($1e100a9690d50909$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$1e100a9690d50909$var$Of] = b;
                    d[$1e100a9690d50909$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $1e100a9690d50909$var$D("cancel", d);
                            $1e100a9690d50909$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $1e100a9690d50909$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $1e100a9690d50909$var$lf.length; e++)$1e100a9690d50909$var$D($1e100a9690d50909$var$lf[e], d);
                            break;
                        case "source":
                            $1e100a9690d50909$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $1e100a9690d50909$var$D("error", d);
                            $1e100a9690d50909$var$D("load", d);
                            break;
                        case "details":
                            $1e100a9690d50909$var$D("toggle", d);
                            break;
                        case "input":
                            $1e100a9690d50909$var$Za(d, f);
                            $1e100a9690d50909$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $1e100a9690d50909$var$D("invalid", d);
                            break;
                        case "textarea":
                            $1e100a9690d50909$var$hb(d, f), $1e100a9690d50909$var$D("invalid", d);
                    }
                    $1e100a9690d50909$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $1e100a9690d50909$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $1e100a9690d50909$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $1e100a9690d50909$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $1e100a9690d50909$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $1e100a9690d50909$var$Va(d);
                            $1e100a9690d50909$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $1e100a9690d50909$var$Va(d);
                            $1e100a9690d50909$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $1e100a9690d50909$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $1e100a9690d50909$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$1e100a9690d50909$var$Of] = b;
                    a[$1e100a9690d50909$var$Pf] = d;
                    $1e100a9690d50909$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $1e100a9690d50909$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $1e100a9690d50909$var$D("cancel", a);
                                $1e100a9690d50909$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $1e100a9690d50909$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $1e100a9690d50909$var$lf.length; e++)$1e100a9690d50909$var$D($1e100a9690d50909$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $1e100a9690d50909$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $1e100a9690d50909$var$D("error", a);
                                $1e100a9690d50909$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $1e100a9690d50909$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $1e100a9690d50909$var$Za(a, d);
                                e = $1e100a9690d50909$var$Ya(a, d);
                                $1e100a9690d50909$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $1e100a9690d50909$var$A({}, d, {
                                    value: void 0
                                });
                                $1e100a9690d50909$var$D("invalid", a);
                                break;
                            case "textarea":
                                $1e100a9690d50909$var$hb(a, d);
                                e = $1e100a9690d50909$var$gb(a, d);
                                $1e100a9690d50909$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $1e100a9690d50909$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $1e100a9690d50909$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $1e100a9690d50909$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $1e100a9690d50909$var$ob(a, k) : "number" === typeof k && $1e100a9690d50909$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($1e100a9690d50909$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $1e100a9690d50909$var$D("scroll", a) : null != k && $1e100a9690d50909$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $1e100a9690d50909$var$Va(a);
                                $1e100a9690d50909$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $1e100a9690d50909$var$Va(a);
                                $1e100a9690d50909$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $1e100a9690d50909$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $1e100a9690d50909$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $1e100a9690d50909$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $1e100a9690d50909$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $1e100a9690d50909$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $1e100a9690d50909$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($1e100a9690d50909$var$p(166));
                c = $1e100a9690d50909$var$Hh($1e100a9690d50909$var$Gh.current);
                $1e100a9690d50909$var$Hh($1e100a9690d50909$var$Eh.current);
                if ($1e100a9690d50909$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$1e100a9690d50909$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $1e100a9690d50909$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $1e100a9690d50909$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $1e100a9690d50909$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$1e100a9690d50909$var$Of] = b, b.stateNode = d;
            }
            $1e100a9690d50909$var$S(b);
            return null;
        case 13:
            $1e100a9690d50909$var$E($1e100a9690d50909$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($1e100a9690d50909$var$I && null !== $1e100a9690d50909$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $1e100a9690d50909$var$Hg(), $1e100a9690d50909$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $1e100a9690d50909$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($1e100a9690d50909$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($1e100a9690d50909$var$p(317));
                        f[$1e100a9690d50909$var$Of] = b;
                    } else $1e100a9690d50909$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $1e100a9690d50909$var$S(b);
                    f = !1;
                } else null !== $1e100a9690d50909$var$zg && ($1e100a9690d50909$var$Gj($1e100a9690d50909$var$zg), $1e100a9690d50909$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($1e100a9690d50909$var$M.current & 1) ? 0 === $1e100a9690d50909$var$T && ($1e100a9690d50909$var$T = 3) : $1e100a9690d50909$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $1e100a9690d50909$var$S(b);
            return null;
        case 4:
            return $1e100a9690d50909$var$Jh(), $1e100a9690d50909$var$Bj(a, b), null === a && $1e100a9690d50909$var$sf(b.stateNode.containerInfo), $1e100a9690d50909$var$S(b), null;
        case 10:
            return $1e100a9690d50909$var$Rg(b.type._context), $1e100a9690d50909$var$S(b), null;
        case 17:
            return $1e100a9690d50909$var$Zf(b.type) && $1e100a9690d50909$var$$f(), $1e100a9690d50909$var$S(b), null;
        case 19:
            $1e100a9690d50909$var$E($1e100a9690d50909$var$M);
            f = b.memoizedState;
            if (null === f) return $1e100a9690d50909$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $1e100a9690d50909$var$Ej(f, !1);
                else {
                    if (0 !== $1e100a9690d50909$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $1e100a9690d50909$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $1e100a9690d50909$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $1e100a9690d50909$var$G($1e100a9690d50909$var$M, $1e100a9690d50909$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $1e100a9690d50909$var$B() > $1e100a9690d50909$var$Hj && (b.flags |= 128, d = !0, $1e100a9690d50909$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $1e100a9690d50909$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $1e100a9690d50909$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$1e100a9690d50909$var$I) return $1e100a9690d50909$var$S(b), null;
                    } else 2 * $1e100a9690d50909$var$B() - f.renderingStartTime > $1e100a9690d50909$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $1e100a9690d50909$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $1e100a9690d50909$var$B(), b.sibling = null, c = $1e100a9690d50909$var$M.current, $1e100a9690d50909$var$G($1e100a9690d50909$var$M, d ? c & 1 | 2 : c & 1), b;
            $1e100a9690d50909$var$S(b);
            return null;
        case 22:
        case 23:
            return $1e100a9690d50909$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($1e100a9690d50909$var$gj & 1073741824) && ($1e100a9690d50909$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $1e100a9690d50909$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($1e100a9690d50909$var$p(156, b.tag));
}
function $1e100a9690d50909$var$Jj(a, b) {
    $1e100a9690d50909$var$wg(b);
    switch(b.tag){
        case 1:
            return $1e100a9690d50909$var$Zf(b.type) && $1e100a9690d50909$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $1e100a9690d50909$var$Jh(), $1e100a9690d50909$var$E($1e100a9690d50909$var$Wf), $1e100a9690d50909$var$E($1e100a9690d50909$var$H), $1e100a9690d50909$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $1e100a9690d50909$var$Lh(b), null;
        case 13:
            $1e100a9690d50909$var$E($1e100a9690d50909$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($1e100a9690d50909$var$p(340));
                $1e100a9690d50909$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $1e100a9690d50909$var$E($1e100a9690d50909$var$M), null;
        case 4:
            return $1e100a9690d50909$var$Jh(), null;
        case 10:
            return $1e100a9690d50909$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $1e100a9690d50909$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $1e100a9690d50909$var$Kj = !1, $1e100a9690d50909$var$U = !1, $1e100a9690d50909$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $1e100a9690d50909$var$V = null;
function $1e100a9690d50909$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $1e100a9690d50909$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $1e100a9690d50909$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $1e100a9690d50909$var$W(a, b, d);
    }
}
var $1e100a9690d50909$var$Oj = !1;
function $1e100a9690d50909$var$Pj(a, b) {
    $1e100a9690d50909$var$Cf = $1e100a9690d50909$var$dd;
    a = $1e100a9690d50909$var$Me();
    if ($1e100a9690d50909$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $1e100a9690d50909$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $1e100a9690d50909$var$dd = !1;
    for($1e100a9690d50909$var$V = b; null !== $1e100a9690d50909$var$V;)if (b = $1e100a9690d50909$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $1e100a9690d50909$var$V = a;
    else for(; null !== $1e100a9690d50909$var$V;){
        b = $1e100a9690d50909$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $1e100a9690d50909$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($1e100a9690d50909$var$p(163));
            }
        } catch (F) {
            $1e100a9690d50909$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $1e100a9690d50909$var$V = a;
            break;
        }
        $1e100a9690d50909$var$V = b.return;
    }
    n = $1e100a9690d50909$var$Oj;
    $1e100a9690d50909$var$Oj = !1;
    return n;
}
function $1e100a9690d50909$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $1e100a9690d50909$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $1e100a9690d50909$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $1e100a9690d50909$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $1e100a9690d50909$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $1e100a9690d50909$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$1e100a9690d50909$var$Of], delete b[$1e100a9690d50909$var$Pf], delete b[$1e100a9690d50909$var$of], delete b[$1e100a9690d50909$var$Qf], delete b[$1e100a9690d50909$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $1e100a9690d50909$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $1e100a9690d50909$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $1e100a9690d50909$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $1e100a9690d50909$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $1e100a9690d50909$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($1e100a9690d50909$var$Wj(a, b, c), a = a.sibling; null !== a;)$1e100a9690d50909$var$Wj(a, b, c), a = a.sibling;
}
function $1e100a9690d50909$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($1e100a9690d50909$var$Xj(a, b, c), a = a.sibling; null !== a;)$1e100a9690d50909$var$Xj(a, b, c), a = a.sibling;
}
var $1e100a9690d50909$var$X = null, $1e100a9690d50909$var$Yj = !1;
function $1e100a9690d50909$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$1e100a9690d50909$var$ak(a, b, c), c = c.sibling;
}
function $1e100a9690d50909$var$ak(a, b, c) {
    if ($1e100a9690d50909$var$lc && "function" === typeof $1e100a9690d50909$var$lc.onCommitFiberUnmount) try {
        $1e100a9690d50909$var$lc.onCommitFiberUnmount($1e100a9690d50909$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $1e100a9690d50909$var$U || $1e100a9690d50909$var$Mj(c, b);
        case 6:
            var d = $1e100a9690d50909$var$X, e = $1e100a9690d50909$var$Yj;
            $1e100a9690d50909$var$X = null;
            $1e100a9690d50909$var$Zj(a, b, c);
            $1e100a9690d50909$var$X = d;
            $1e100a9690d50909$var$Yj = e;
            null !== $1e100a9690d50909$var$X && ($1e100a9690d50909$var$Yj ? (a = $1e100a9690d50909$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $1e100a9690d50909$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $1e100a9690d50909$var$X && ($1e100a9690d50909$var$Yj ? (a = $1e100a9690d50909$var$X, c = c.stateNode, 8 === a.nodeType ? $1e100a9690d50909$var$Kf(a.parentNode, c) : 1 === a.nodeType && $1e100a9690d50909$var$Kf(a, c), $1e100a9690d50909$var$bd(a)) : $1e100a9690d50909$var$Kf($1e100a9690d50909$var$X, c.stateNode));
            break;
        case 4:
            d = $1e100a9690d50909$var$X;
            e = $1e100a9690d50909$var$Yj;
            $1e100a9690d50909$var$X = c.stateNode.containerInfo;
            $1e100a9690d50909$var$Yj = !0;
            $1e100a9690d50909$var$Zj(a, b, c);
            $1e100a9690d50909$var$X = d;
            $1e100a9690d50909$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$1e100a9690d50909$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $1e100a9690d50909$var$Nj(c, b, g) : 0 !== (f & 4) && $1e100a9690d50909$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $1e100a9690d50909$var$Zj(a, b, c);
            break;
        case 1:
            if (!$1e100a9690d50909$var$U && ($1e100a9690d50909$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $1e100a9690d50909$var$W(c, b, h);
            }
            $1e100a9690d50909$var$Zj(a, b, c);
            break;
        case 21:
            $1e100a9690d50909$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($1e100a9690d50909$var$U = (d = $1e100a9690d50909$var$U) || null !== c.memoizedState, $1e100a9690d50909$var$Zj(a, b, c), $1e100a9690d50909$var$U = d) : $1e100a9690d50909$var$Zj(a, b, c);
            break;
        default:
            $1e100a9690d50909$var$Zj(a, b, c);
    }
}
function $1e100a9690d50909$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $1e100a9690d50909$var$Lj);
        b.forEach(function(b) {
            var d = $1e100a9690d50909$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $1e100a9690d50909$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $1e100a9690d50909$var$X = h.stateNode;
                        $1e100a9690d50909$var$Yj = !1;
                        break a;
                    case 3:
                        $1e100a9690d50909$var$X = h.stateNode.containerInfo;
                        $1e100a9690d50909$var$Yj = !0;
                        break a;
                    case 4:
                        $1e100a9690d50909$var$X = h.stateNode.containerInfo;
                        $1e100a9690d50909$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $1e100a9690d50909$var$X) throw Error($1e100a9690d50909$var$p(160));
            $1e100a9690d50909$var$ak(f, g, e);
            $1e100a9690d50909$var$X = null;
            $1e100a9690d50909$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $1e100a9690d50909$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$1e100a9690d50909$var$ek(b, a), b = b.sibling;
}
function $1e100a9690d50909$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $1e100a9690d50909$var$dk(b, a);
            $1e100a9690d50909$var$fk(a);
            if (d & 4) {
                try {
                    $1e100a9690d50909$var$Qj(3, a, a.return), $1e100a9690d50909$var$Rj(3, a);
                } catch (t) {
                    $1e100a9690d50909$var$W(a, a.return, t);
                }
                try {
                    $1e100a9690d50909$var$Qj(5, a, a.return);
                } catch (t) {
                    $1e100a9690d50909$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $1e100a9690d50909$var$dk(b, a);
            $1e100a9690d50909$var$fk(a);
            d & 512 && null !== c && $1e100a9690d50909$var$Mj(c, c.return);
            break;
        case 5:
            $1e100a9690d50909$var$dk(b, a);
            $1e100a9690d50909$var$fk(a);
            d & 512 && null !== c && $1e100a9690d50909$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $1e100a9690d50909$var$ob(e, "");
                } catch (t) {
                    $1e100a9690d50909$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $1e100a9690d50909$var$ab(e, f);
                    $1e100a9690d50909$var$vb(h, g);
                    var l = $1e100a9690d50909$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $1e100a9690d50909$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $1e100a9690d50909$var$nb(e, q) : "children" === m ? $1e100a9690d50909$var$ob(e, q) : $1e100a9690d50909$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $1e100a9690d50909$var$bb(e, f);
                            break;
                        case "textarea":
                            $1e100a9690d50909$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $1e100a9690d50909$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $1e100a9690d50909$var$fb(e, !!f.multiple, f.defaultValue, !0) : $1e100a9690d50909$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$1e100a9690d50909$var$Pf] = f;
                } catch (t) {
                    $1e100a9690d50909$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $1e100a9690d50909$var$dk(b, a);
            $1e100a9690d50909$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($1e100a9690d50909$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $1e100a9690d50909$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $1e100a9690d50909$var$dk(b, a);
            $1e100a9690d50909$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $1e100a9690d50909$var$bd(b.containerInfo);
            } catch (t) {
                $1e100a9690d50909$var$W(a, a.return, t);
            }
            break;
        case 4:
            $1e100a9690d50909$var$dk(b, a);
            $1e100a9690d50909$var$fk(a);
            break;
        case 13:
            $1e100a9690d50909$var$dk(b, a);
            $1e100a9690d50909$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($1e100a9690d50909$var$gk = $1e100a9690d50909$var$B()));
            d & 4 && $1e100a9690d50909$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($1e100a9690d50909$var$U = (l = $1e100a9690d50909$var$U) || m, $1e100a9690d50909$var$dk(b, a), $1e100a9690d50909$var$U = l) : $1e100a9690d50909$var$dk(b, a);
            $1e100a9690d50909$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($1e100a9690d50909$var$V = a, m = a.child; null !== m;){
                    for(q = $1e100a9690d50909$var$V = m; null !== $1e100a9690d50909$var$V;){
                        r = $1e100a9690d50909$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $1e100a9690d50909$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $1e100a9690d50909$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $1e100a9690d50909$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $1e100a9690d50909$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $1e100a9690d50909$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $1e100a9690d50909$var$V = y) : $1e100a9690d50909$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $1e100a9690d50909$var$rb("display", g));
                            } catch (t) {
                                $1e100a9690d50909$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $1e100a9690d50909$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $1e100a9690d50909$var$dk(b, a);
            $1e100a9690d50909$var$fk(a);
            d & 4 && $1e100a9690d50909$var$bk(a);
            break;
        case 21:
            break;
        default:
            $1e100a9690d50909$var$dk(b, a), $1e100a9690d50909$var$fk(a);
    }
}
function $1e100a9690d50909$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($1e100a9690d50909$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($1e100a9690d50909$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($1e100a9690d50909$var$ob(e, ""), d.flags &= -33);
                    var f = $1e100a9690d50909$var$Vj(a);
                    $1e100a9690d50909$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $1e100a9690d50909$var$Vj(a);
                    $1e100a9690d50909$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($1e100a9690d50909$var$p(161));
            }
        } catch (k) {
            $1e100a9690d50909$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $1e100a9690d50909$var$ik(a, b, c) {
    $1e100a9690d50909$var$V = a;
    $1e100a9690d50909$var$jk(a, b, c);
}
function $1e100a9690d50909$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $1e100a9690d50909$var$V;){
        var e = $1e100a9690d50909$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $1e100a9690d50909$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $1e100a9690d50909$var$U;
                h = $1e100a9690d50909$var$Kj;
                var l = $1e100a9690d50909$var$U;
                $1e100a9690d50909$var$Kj = g;
                if (($1e100a9690d50909$var$U = k) && !l) for($1e100a9690d50909$var$V = e; null !== $1e100a9690d50909$var$V;)g = $1e100a9690d50909$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $1e100a9690d50909$var$kk(e) : null !== k ? (k.return = g, $1e100a9690d50909$var$V = k) : $1e100a9690d50909$var$kk(e);
                for(; null !== f;)$1e100a9690d50909$var$V = f, $1e100a9690d50909$var$jk(f, b, c), f = f.sibling;
                $1e100a9690d50909$var$V = e;
                $1e100a9690d50909$var$Kj = h;
                $1e100a9690d50909$var$U = l;
            }
            $1e100a9690d50909$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $1e100a9690d50909$var$V = f) : $1e100a9690d50909$var$lk(a, b, c);
    }
}
function $1e100a9690d50909$var$lk(a) {
    for(; null !== $1e100a9690d50909$var$V;){
        var b = $1e100a9690d50909$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $1e100a9690d50909$var$U || $1e100a9690d50909$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$1e100a9690d50909$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $1e100a9690d50909$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $1e100a9690d50909$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $1e100a9690d50909$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $1e100a9690d50909$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($1e100a9690d50909$var$p(163));
                }
                $1e100a9690d50909$var$U || b.flags & 512 && $1e100a9690d50909$var$Sj(b);
            } catch (r) {
                $1e100a9690d50909$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $1e100a9690d50909$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $1e100a9690d50909$var$V = c;
            break;
        }
        $1e100a9690d50909$var$V = b.return;
    }
}
function $1e100a9690d50909$var$hk(a) {
    for(; null !== $1e100a9690d50909$var$V;){
        var b = $1e100a9690d50909$var$V;
        if (b === a) {
            $1e100a9690d50909$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $1e100a9690d50909$var$V = c;
            break;
        }
        $1e100a9690d50909$var$V = b.return;
    }
}
function $1e100a9690d50909$var$kk(a) {
    for(; null !== $1e100a9690d50909$var$V;){
        var b = $1e100a9690d50909$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $1e100a9690d50909$var$Rj(4, b);
                    } catch (k) {
                        $1e100a9690d50909$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $1e100a9690d50909$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $1e100a9690d50909$var$Sj(b);
                    } catch (k) {
                        $1e100a9690d50909$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $1e100a9690d50909$var$Sj(b);
                    } catch (k) {
                        $1e100a9690d50909$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $1e100a9690d50909$var$W(b, b.return, k);
        }
        if (b === a) {
            $1e100a9690d50909$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $1e100a9690d50909$var$V = h;
            break;
        }
        $1e100a9690d50909$var$V = b.return;
    }
}
var $1e100a9690d50909$var$mk = Math.ceil, $1e100a9690d50909$var$nk = $1e100a9690d50909$var$ua.ReactCurrentDispatcher, $1e100a9690d50909$var$ok = $1e100a9690d50909$var$ua.ReactCurrentOwner, $1e100a9690d50909$var$pk = $1e100a9690d50909$var$ua.ReactCurrentBatchConfig, $1e100a9690d50909$var$K = 0, $1e100a9690d50909$var$R = null, $1e100a9690d50909$var$Y = null, $1e100a9690d50909$var$Z = 0, $1e100a9690d50909$var$gj = 0, $1e100a9690d50909$var$fj = $1e100a9690d50909$var$Uf(0), $1e100a9690d50909$var$T = 0, $1e100a9690d50909$var$qk = null, $1e100a9690d50909$var$hh = 0, $1e100a9690d50909$var$rk = 0, $1e100a9690d50909$var$sk = 0, $1e100a9690d50909$var$tk = null, $1e100a9690d50909$var$uk = null, $1e100a9690d50909$var$gk = 0, $1e100a9690d50909$var$Hj = Infinity, $1e100a9690d50909$var$vk = null, $1e100a9690d50909$var$Pi = !1, $1e100a9690d50909$var$Qi = null, $1e100a9690d50909$var$Si = null, $1e100a9690d50909$var$wk = !1, $1e100a9690d50909$var$xk = null, $1e100a9690d50909$var$yk = 0, $1e100a9690d50909$var$zk = 0, $1e100a9690d50909$var$Ak = null, $1e100a9690d50909$var$Bk = -1, $1e100a9690d50909$var$Ck = 0;
function $1e100a9690d50909$var$L() {
    return 0 !== ($1e100a9690d50909$var$K & 6) ? $1e100a9690d50909$var$B() : -1 !== $1e100a9690d50909$var$Bk ? $1e100a9690d50909$var$Bk : $1e100a9690d50909$var$Bk = $1e100a9690d50909$var$B();
}
function $1e100a9690d50909$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($1e100a9690d50909$var$K & 2) && 0 !== $1e100a9690d50909$var$Z) return $1e100a9690d50909$var$Z & -$1e100a9690d50909$var$Z;
    if (null !== $1e100a9690d50909$var$Kg.transition) return 0 === $1e100a9690d50909$var$Ck && ($1e100a9690d50909$var$Ck = $1e100a9690d50909$var$yc()), $1e100a9690d50909$var$Ck;
    a = $1e100a9690d50909$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $1e100a9690d50909$var$jd(a.type);
    return a;
}
function $1e100a9690d50909$var$mh(a, b, c, d) {
    if (50 < $1e100a9690d50909$var$zk) throw $1e100a9690d50909$var$zk = 0, $1e100a9690d50909$var$Ak = null, Error($1e100a9690d50909$var$p(185));
    $1e100a9690d50909$var$Ac(a, c, d);
    if (0 === ($1e100a9690d50909$var$K & 2) || a !== $1e100a9690d50909$var$R) a === $1e100a9690d50909$var$R && (0 === ($1e100a9690d50909$var$K & 2) && ($1e100a9690d50909$var$rk |= c), 4 === $1e100a9690d50909$var$T && $1e100a9690d50909$var$Dk(a, $1e100a9690d50909$var$Z)), $1e100a9690d50909$var$Ek(a, d), 1 === c && 0 === $1e100a9690d50909$var$K && 0 === (b.mode & 1) && ($1e100a9690d50909$var$Hj = $1e100a9690d50909$var$B() + 500, $1e100a9690d50909$var$fg && $1e100a9690d50909$var$jg());
}
function $1e100a9690d50909$var$Ek(a, b) {
    var c = a.callbackNode;
    $1e100a9690d50909$var$wc(a, b);
    var d = $1e100a9690d50909$var$uc(a, a === $1e100a9690d50909$var$R ? $1e100a9690d50909$var$Z : 0);
    if (0 === d) null !== c && $1e100a9690d50909$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $1e100a9690d50909$var$bc(c);
        if (1 === b) 0 === a.tag ? $1e100a9690d50909$var$ig($1e100a9690d50909$var$Fk.bind(null, a)) : $1e100a9690d50909$var$hg($1e100a9690d50909$var$Fk.bind(null, a)), $1e100a9690d50909$var$Jf(function() {
            0 === ($1e100a9690d50909$var$K & 6) && $1e100a9690d50909$var$jg();
        }), c = null;
        else {
            switch($1e100a9690d50909$var$Dc(d)){
                case 1:
                    c = $1e100a9690d50909$var$fc;
                    break;
                case 4:
                    c = $1e100a9690d50909$var$gc;
                    break;
                case 16:
                    c = $1e100a9690d50909$var$hc;
                    break;
                case 536870912:
                    c = $1e100a9690d50909$var$jc;
                    break;
                default:
                    c = $1e100a9690d50909$var$hc;
            }
            c = $1e100a9690d50909$var$Gk(c, $1e100a9690d50909$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $1e100a9690d50909$var$Hk(a, b) {
    $1e100a9690d50909$var$Bk = -1;
    $1e100a9690d50909$var$Ck = 0;
    if (0 !== ($1e100a9690d50909$var$K & 6)) throw Error($1e100a9690d50909$var$p(327));
    var c = a.callbackNode;
    if ($1e100a9690d50909$var$Ik() && a.callbackNode !== c) return null;
    var d = $1e100a9690d50909$var$uc(a, a === $1e100a9690d50909$var$R ? $1e100a9690d50909$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $1e100a9690d50909$var$Jk(a, d);
    else {
        b = d;
        var e = $1e100a9690d50909$var$K;
        $1e100a9690d50909$var$K |= 2;
        var f = $1e100a9690d50909$var$Kk();
        if ($1e100a9690d50909$var$R !== a || $1e100a9690d50909$var$Z !== b) $1e100a9690d50909$var$vk = null, $1e100a9690d50909$var$Hj = $1e100a9690d50909$var$B() + 500, $1e100a9690d50909$var$Lk(a, b);
        for(;;)try {
            $1e100a9690d50909$var$Mk();
            break;
        } catch (h) {
            $1e100a9690d50909$var$Nk(a, h);
        }
        $1e100a9690d50909$var$Qg();
        $1e100a9690d50909$var$nk.current = f;
        $1e100a9690d50909$var$K = e;
        null !== $1e100a9690d50909$var$Y ? b = 0 : ($1e100a9690d50909$var$R = null, $1e100a9690d50909$var$Z = 0, b = $1e100a9690d50909$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $1e100a9690d50909$var$xc(a), 0 !== e && (d = e, b = $1e100a9690d50909$var$Ok(a, e)));
        if (1 === b) throw c = $1e100a9690d50909$var$qk, $1e100a9690d50909$var$Lk(a, 0), $1e100a9690d50909$var$Dk(a, d), $1e100a9690d50909$var$Ek(a, $1e100a9690d50909$var$B()), c;
        if (6 === b) $1e100a9690d50909$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$1e100a9690d50909$var$Pk(e) && (b = $1e100a9690d50909$var$Jk(a, d), 2 === b && (f = $1e100a9690d50909$var$xc(a), 0 !== f && (d = f, b = $1e100a9690d50909$var$Ok(a, f))), 1 === b)) throw c = $1e100a9690d50909$var$qk, $1e100a9690d50909$var$Lk(a, 0), $1e100a9690d50909$var$Dk(a, d), $1e100a9690d50909$var$Ek(a, $1e100a9690d50909$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($1e100a9690d50909$var$p(345));
                case 2:
                    $1e100a9690d50909$var$Qk(a, $1e100a9690d50909$var$uk, $1e100a9690d50909$var$vk);
                    break;
                case 3:
                    $1e100a9690d50909$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $1e100a9690d50909$var$gk + 500 - $1e100a9690d50909$var$B(), 10 < b)) {
                        if (0 !== $1e100a9690d50909$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $1e100a9690d50909$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $1e100a9690d50909$var$Ff($1e100a9690d50909$var$Qk.bind(null, a, $1e100a9690d50909$var$uk, $1e100a9690d50909$var$vk), b);
                        break;
                    }
                    $1e100a9690d50909$var$Qk(a, $1e100a9690d50909$var$uk, $1e100a9690d50909$var$vk);
                    break;
                case 4:
                    $1e100a9690d50909$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $1e100a9690d50909$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $1e100a9690d50909$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $1e100a9690d50909$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $1e100a9690d50909$var$Ff($1e100a9690d50909$var$Qk.bind(null, a, $1e100a9690d50909$var$uk, $1e100a9690d50909$var$vk), d);
                        break;
                    }
                    $1e100a9690d50909$var$Qk(a, $1e100a9690d50909$var$uk, $1e100a9690d50909$var$vk);
                    break;
                case 5:
                    $1e100a9690d50909$var$Qk(a, $1e100a9690d50909$var$uk, $1e100a9690d50909$var$vk);
                    break;
                default:
                    throw Error($1e100a9690d50909$var$p(329));
            }
        }
    }
    $1e100a9690d50909$var$Ek(a, $1e100a9690d50909$var$B());
    return a.callbackNode === c ? $1e100a9690d50909$var$Hk.bind(null, a) : null;
}
function $1e100a9690d50909$var$Ok(a, b) {
    var c = $1e100a9690d50909$var$tk;
    a.current.memoizedState.isDehydrated && ($1e100a9690d50909$var$Lk(a, b).flags |= 256);
    a = $1e100a9690d50909$var$Jk(a, b);
    2 !== a && (b = $1e100a9690d50909$var$uk, $1e100a9690d50909$var$uk = c, null !== b && $1e100a9690d50909$var$Gj(b));
    return a;
}
function $1e100a9690d50909$var$Gj(a) {
    null === $1e100a9690d50909$var$uk ? $1e100a9690d50909$var$uk = a : $1e100a9690d50909$var$uk.push.apply($1e100a9690d50909$var$uk, a);
}
function $1e100a9690d50909$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$1e100a9690d50909$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $1e100a9690d50909$var$Dk(a, b) {
    b &= ~$1e100a9690d50909$var$sk;
    b &= ~$1e100a9690d50909$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $1e100a9690d50909$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $1e100a9690d50909$var$Fk(a) {
    if (0 !== ($1e100a9690d50909$var$K & 6)) throw Error($1e100a9690d50909$var$p(327));
    $1e100a9690d50909$var$Ik();
    var b = $1e100a9690d50909$var$uc(a, 0);
    if (0 === (b & 1)) return $1e100a9690d50909$var$Ek(a, $1e100a9690d50909$var$B()), null;
    var c = $1e100a9690d50909$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $1e100a9690d50909$var$xc(a);
        0 !== d && (b = d, c = $1e100a9690d50909$var$Ok(a, d));
    }
    if (1 === c) throw c = $1e100a9690d50909$var$qk, $1e100a9690d50909$var$Lk(a, 0), $1e100a9690d50909$var$Dk(a, b), $1e100a9690d50909$var$Ek(a, $1e100a9690d50909$var$B()), c;
    if (6 === c) throw Error($1e100a9690d50909$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $1e100a9690d50909$var$Qk(a, $1e100a9690d50909$var$uk, $1e100a9690d50909$var$vk);
    $1e100a9690d50909$var$Ek(a, $1e100a9690d50909$var$B());
    return null;
}
function $1e100a9690d50909$var$Rk(a, b) {
    var c = $1e100a9690d50909$var$K;
    $1e100a9690d50909$var$K |= 1;
    try {
        return a(b);
    } finally{
        $1e100a9690d50909$var$K = c, 0 === $1e100a9690d50909$var$K && ($1e100a9690d50909$var$Hj = $1e100a9690d50909$var$B() + 500, $1e100a9690d50909$var$fg && $1e100a9690d50909$var$jg());
    }
}
function $1e100a9690d50909$var$Sk(a) {
    null !== $1e100a9690d50909$var$xk && 0 === $1e100a9690d50909$var$xk.tag && 0 === ($1e100a9690d50909$var$K & 6) && $1e100a9690d50909$var$Ik();
    var b = $1e100a9690d50909$var$K;
    $1e100a9690d50909$var$K |= 1;
    var c = $1e100a9690d50909$var$pk.transition, d = $1e100a9690d50909$var$C;
    try {
        if ($1e100a9690d50909$var$pk.transition = null, $1e100a9690d50909$var$C = 1, a) return a();
    } finally{
        $1e100a9690d50909$var$C = d, $1e100a9690d50909$var$pk.transition = c, $1e100a9690d50909$var$K = b, 0 === ($1e100a9690d50909$var$K & 6) && $1e100a9690d50909$var$jg();
    }
}
function $1e100a9690d50909$var$Ij() {
    $1e100a9690d50909$var$gj = $1e100a9690d50909$var$fj.current;
    $1e100a9690d50909$var$E($1e100a9690d50909$var$fj);
}
function $1e100a9690d50909$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $1e100a9690d50909$var$Gf(c));
    if (null !== $1e100a9690d50909$var$Y) for(c = $1e100a9690d50909$var$Y.return; null !== c;){
        var d = c;
        $1e100a9690d50909$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $1e100a9690d50909$var$$f();
                break;
            case 3:
                $1e100a9690d50909$var$Jh();
                $1e100a9690d50909$var$E($1e100a9690d50909$var$Wf);
                $1e100a9690d50909$var$E($1e100a9690d50909$var$H);
                $1e100a9690d50909$var$Oh();
                break;
            case 5:
                $1e100a9690d50909$var$Lh(d);
                break;
            case 4:
                $1e100a9690d50909$var$Jh();
                break;
            case 13:
                $1e100a9690d50909$var$E($1e100a9690d50909$var$M);
                break;
            case 19:
                $1e100a9690d50909$var$E($1e100a9690d50909$var$M);
                break;
            case 10:
                $1e100a9690d50909$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $1e100a9690d50909$var$Ij();
        }
        c = c.return;
    }
    $1e100a9690d50909$var$R = a;
    $1e100a9690d50909$var$Y = a = $1e100a9690d50909$var$wh(a.current, null);
    $1e100a9690d50909$var$Z = $1e100a9690d50909$var$gj = b;
    $1e100a9690d50909$var$T = 0;
    $1e100a9690d50909$var$qk = null;
    $1e100a9690d50909$var$sk = $1e100a9690d50909$var$rk = $1e100a9690d50909$var$hh = 0;
    $1e100a9690d50909$var$uk = $1e100a9690d50909$var$tk = null;
    if (null !== $1e100a9690d50909$var$Wg) {
        for(b = 0; b < $1e100a9690d50909$var$Wg.length; b++)if (c = $1e100a9690d50909$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $1e100a9690d50909$var$Wg = null;
    }
    return a;
}
function $1e100a9690d50909$var$Nk(a, b) {
    do {
        var c = $1e100a9690d50909$var$Y;
        try {
            $1e100a9690d50909$var$Qg();
            $1e100a9690d50909$var$Ph.current = $1e100a9690d50909$var$ai;
            if ($1e100a9690d50909$var$Sh) {
                for(var d = $1e100a9690d50909$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $1e100a9690d50909$var$Sh = !1;
            }
            $1e100a9690d50909$var$Rh = 0;
            $1e100a9690d50909$var$P = $1e100a9690d50909$var$O = $1e100a9690d50909$var$N = null;
            $1e100a9690d50909$var$Th = !1;
            $1e100a9690d50909$var$Uh = 0;
            $1e100a9690d50909$var$ok.current = null;
            if (null === c || null === c.return) {
                $1e100a9690d50909$var$T = 1;
                $1e100a9690d50909$var$qk = b;
                $1e100a9690d50909$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $1e100a9690d50909$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $1e100a9690d50909$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $1e100a9690d50909$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $1e100a9690d50909$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $1e100a9690d50909$var$Ti(f, l, b);
                            $1e100a9690d50909$var$uj();
                            break a;
                        }
                        k = Error($1e100a9690d50909$var$p(426));
                    }
                } else if ($1e100a9690d50909$var$I && h.mode & 1) {
                    var J = $1e100a9690d50909$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $1e100a9690d50909$var$Wi(J, g, h, f, b);
                        $1e100a9690d50909$var$Jg($1e100a9690d50909$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $1e100a9690d50909$var$Ki(k, h);
                4 !== $1e100a9690d50909$var$T && ($1e100a9690d50909$var$T = 2);
                null === $1e100a9690d50909$var$tk ? $1e100a9690d50909$var$tk = [
                    f
                ] : $1e100a9690d50909$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $1e100a9690d50909$var$Oi(f, k, b);
                            $1e100a9690d50909$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $1e100a9690d50909$var$Si || !$1e100a9690d50909$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $1e100a9690d50909$var$Ri(f, h, b);
                                $1e100a9690d50909$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $1e100a9690d50909$var$Tk(c);
        } catch (na) {
            b = na;
            $1e100a9690d50909$var$Y === c && null !== c && ($1e100a9690d50909$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $1e100a9690d50909$var$Kk() {
    var a = $1e100a9690d50909$var$nk.current;
    $1e100a9690d50909$var$nk.current = $1e100a9690d50909$var$ai;
    return null === a ? $1e100a9690d50909$var$ai : a;
}
function $1e100a9690d50909$var$uj() {
    if (0 === $1e100a9690d50909$var$T || 3 === $1e100a9690d50909$var$T || 2 === $1e100a9690d50909$var$T) $1e100a9690d50909$var$T = 4;
    null === $1e100a9690d50909$var$R || 0 === ($1e100a9690d50909$var$hh & 268435455) && 0 === ($1e100a9690d50909$var$rk & 268435455) || $1e100a9690d50909$var$Dk($1e100a9690d50909$var$R, $1e100a9690d50909$var$Z);
}
function $1e100a9690d50909$var$Jk(a, b) {
    var c = $1e100a9690d50909$var$K;
    $1e100a9690d50909$var$K |= 2;
    var d = $1e100a9690d50909$var$Kk();
    if ($1e100a9690d50909$var$R !== a || $1e100a9690d50909$var$Z !== b) $1e100a9690d50909$var$vk = null, $1e100a9690d50909$var$Lk(a, b);
    for(;;)try {
        $1e100a9690d50909$var$Uk();
        break;
    } catch (e) {
        $1e100a9690d50909$var$Nk(a, e);
    }
    $1e100a9690d50909$var$Qg();
    $1e100a9690d50909$var$K = c;
    $1e100a9690d50909$var$nk.current = d;
    if (null !== $1e100a9690d50909$var$Y) throw Error($1e100a9690d50909$var$p(261));
    $1e100a9690d50909$var$R = null;
    $1e100a9690d50909$var$Z = 0;
    return $1e100a9690d50909$var$T;
}
function $1e100a9690d50909$var$Uk() {
    for(; null !== $1e100a9690d50909$var$Y;)$1e100a9690d50909$var$Vk($1e100a9690d50909$var$Y);
}
function $1e100a9690d50909$var$Mk() {
    for(; null !== $1e100a9690d50909$var$Y && !$1e100a9690d50909$var$cc();)$1e100a9690d50909$var$Vk($1e100a9690d50909$var$Y);
}
function $1e100a9690d50909$var$Vk(a) {
    var b = $1e100a9690d50909$var$Wk(a.alternate, a, $1e100a9690d50909$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $1e100a9690d50909$var$Tk(a) : $1e100a9690d50909$var$Y = b;
    $1e100a9690d50909$var$ok.current = null;
}
function $1e100a9690d50909$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $1e100a9690d50909$var$Fj(c, b, $1e100a9690d50909$var$gj), null !== c) {
                $1e100a9690d50909$var$Y = c;
                return;
            }
        } else {
            c = $1e100a9690d50909$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $1e100a9690d50909$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $1e100a9690d50909$var$T = 6;
                $1e100a9690d50909$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $1e100a9690d50909$var$Y = b;
            return;
        }
        $1e100a9690d50909$var$Y = b = a;
    }while (null !== b);
    0 === $1e100a9690d50909$var$T && ($1e100a9690d50909$var$T = 5);
}
function $1e100a9690d50909$var$Qk(a, b, c) {
    var d = $1e100a9690d50909$var$C, e = $1e100a9690d50909$var$pk.transition;
    try {
        $1e100a9690d50909$var$pk.transition = null, $1e100a9690d50909$var$C = 1, $1e100a9690d50909$var$Xk(a, b, c, d);
    } finally{
        $1e100a9690d50909$var$pk.transition = e, $1e100a9690d50909$var$C = d;
    }
    return null;
}
function $1e100a9690d50909$var$Xk(a, b, c, d) {
    do $1e100a9690d50909$var$Ik();
    while (null !== $1e100a9690d50909$var$xk);
    if (0 !== ($1e100a9690d50909$var$K & 6)) throw Error($1e100a9690d50909$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($1e100a9690d50909$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $1e100a9690d50909$var$Bc(a, f);
    a === $1e100a9690d50909$var$R && ($1e100a9690d50909$var$Y = $1e100a9690d50909$var$R = null, $1e100a9690d50909$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $1e100a9690d50909$var$wk || ($1e100a9690d50909$var$wk = !0, $1e100a9690d50909$var$Gk($1e100a9690d50909$var$hc, function() {
        $1e100a9690d50909$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $1e100a9690d50909$var$pk.transition;
        $1e100a9690d50909$var$pk.transition = null;
        var g = $1e100a9690d50909$var$C;
        $1e100a9690d50909$var$C = 1;
        var h = $1e100a9690d50909$var$K;
        $1e100a9690d50909$var$K |= 4;
        $1e100a9690d50909$var$ok.current = null;
        $1e100a9690d50909$var$Pj(a, c);
        $1e100a9690d50909$var$ek(c, a);
        $1e100a9690d50909$var$Oe($1e100a9690d50909$var$Df);
        $1e100a9690d50909$var$dd = !!$1e100a9690d50909$var$Cf;
        $1e100a9690d50909$var$Df = $1e100a9690d50909$var$Cf = null;
        a.current = c;
        $1e100a9690d50909$var$ik(c, a, e);
        $1e100a9690d50909$var$dc();
        $1e100a9690d50909$var$K = h;
        $1e100a9690d50909$var$C = g;
        $1e100a9690d50909$var$pk.transition = f;
    } else a.current = c;
    $1e100a9690d50909$var$wk && ($1e100a9690d50909$var$wk = !1, $1e100a9690d50909$var$xk = a, $1e100a9690d50909$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($1e100a9690d50909$var$Si = null);
    $1e100a9690d50909$var$mc(c.stateNode, d);
    $1e100a9690d50909$var$Ek(a, $1e100a9690d50909$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($1e100a9690d50909$var$Pi) throw $1e100a9690d50909$var$Pi = !1, a = $1e100a9690d50909$var$Qi, $1e100a9690d50909$var$Qi = null, a;
    0 !== ($1e100a9690d50909$var$yk & 1) && 0 !== a.tag && $1e100a9690d50909$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $1e100a9690d50909$var$Ak ? $1e100a9690d50909$var$zk++ : ($1e100a9690d50909$var$zk = 0, $1e100a9690d50909$var$Ak = a) : $1e100a9690d50909$var$zk = 0;
    $1e100a9690d50909$var$jg();
    return null;
}
function $1e100a9690d50909$var$Ik() {
    if (null !== $1e100a9690d50909$var$xk) {
        var a = $1e100a9690d50909$var$Dc($1e100a9690d50909$var$yk), b = $1e100a9690d50909$var$pk.transition, c = $1e100a9690d50909$var$C;
        try {
            $1e100a9690d50909$var$pk.transition = null;
            $1e100a9690d50909$var$C = 16 > a ? 16 : a;
            if (null === $1e100a9690d50909$var$xk) var d = !1;
            else {
                a = $1e100a9690d50909$var$xk;
                $1e100a9690d50909$var$xk = null;
                $1e100a9690d50909$var$yk = 0;
                if (0 !== ($1e100a9690d50909$var$K & 6)) throw Error($1e100a9690d50909$var$p(331));
                var e = $1e100a9690d50909$var$K;
                $1e100a9690d50909$var$K |= 4;
                for($1e100a9690d50909$var$V = a.current; null !== $1e100a9690d50909$var$V;){
                    var f = $1e100a9690d50909$var$V, g = f.child;
                    if (0 !== ($1e100a9690d50909$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($1e100a9690d50909$var$V = l; null !== $1e100a9690d50909$var$V;){
                                    var m = $1e100a9690d50909$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $1e100a9690d50909$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $1e100a9690d50909$var$V = q;
                                    else for(; null !== $1e100a9690d50909$var$V;){
                                        m = $1e100a9690d50909$var$V;
                                        var r = m.sibling, y = m.return;
                                        $1e100a9690d50909$var$Tj(m);
                                        if (m === l) {
                                            $1e100a9690d50909$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $1e100a9690d50909$var$V = r;
                                            break;
                                        }
                                        $1e100a9690d50909$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $1e100a9690d50909$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $1e100a9690d50909$var$V = g;
                    else b: for(; null !== $1e100a9690d50909$var$V;){
                        f = $1e100a9690d50909$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $1e100a9690d50909$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $1e100a9690d50909$var$V = x;
                            break b;
                        }
                        $1e100a9690d50909$var$V = f.return;
                    }
                }
                var w = a.current;
                for($1e100a9690d50909$var$V = w; null !== $1e100a9690d50909$var$V;){
                    g = $1e100a9690d50909$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $1e100a9690d50909$var$V = u;
                    else b: for(g = w; null !== $1e100a9690d50909$var$V;){
                        h = $1e100a9690d50909$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $1e100a9690d50909$var$Rj(9, h);
                            }
                        } catch (na) {
                            $1e100a9690d50909$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $1e100a9690d50909$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $1e100a9690d50909$var$V = F;
                            break b;
                        }
                        $1e100a9690d50909$var$V = h.return;
                    }
                }
                $1e100a9690d50909$var$K = e;
                $1e100a9690d50909$var$jg();
                if ($1e100a9690d50909$var$lc && "function" === typeof $1e100a9690d50909$var$lc.onPostCommitFiberRoot) try {
                    $1e100a9690d50909$var$lc.onPostCommitFiberRoot($1e100a9690d50909$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $1e100a9690d50909$var$C = c, $1e100a9690d50909$var$pk.transition = b;
        }
    }
    return !1;
}
function $1e100a9690d50909$var$Yk(a, b, c) {
    b = $1e100a9690d50909$var$Ki(c, b);
    b = $1e100a9690d50909$var$Oi(a, b, 1);
    a = $1e100a9690d50909$var$dh(a, b, 1);
    b = $1e100a9690d50909$var$L();
    null !== a && ($1e100a9690d50909$var$Ac(a, 1, b), $1e100a9690d50909$var$Ek(a, b));
}
function $1e100a9690d50909$var$W(a, b, c) {
    if (3 === a.tag) $1e100a9690d50909$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $1e100a9690d50909$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $1e100a9690d50909$var$Si || !$1e100a9690d50909$var$Si.has(d))) {
                a = $1e100a9690d50909$var$Ki(c, a);
                a = $1e100a9690d50909$var$Ri(b, a, 1);
                b = $1e100a9690d50909$var$dh(b, a, 1);
                a = $1e100a9690d50909$var$L();
                null !== b && ($1e100a9690d50909$var$Ac(b, 1, a), $1e100a9690d50909$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $1e100a9690d50909$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $1e100a9690d50909$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $1e100a9690d50909$var$R === a && ($1e100a9690d50909$var$Z & c) === c && (4 === $1e100a9690d50909$var$T || 3 === $1e100a9690d50909$var$T && ($1e100a9690d50909$var$Z & 130023424) === $1e100a9690d50909$var$Z && 500 > $1e100a9690d50909$var$B() - $1e100a9690d50909$var$gk ? $1e100a9690d50909$var$Lk(a, 0) : $1e100a9690d50909$var$sk |= c);
    $1e100a9690d50909$var$Ek(a, b);
}
function $1e100a9690d50909$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $1e100a9690d50909$var$sc, $1e100a9690d50909$var$sc <<= 1, 0 === ($1e100a9690d50909$var$sc & 130023424) && ($1e100a9690d50909$var$sc = 4194304)));
    var c = $1e100a9690d50909$var$L();
    a = $1e100a9690d50909$var$Zg(a, b);
    null !== a && ($1e100a9690d50909$var$Ac(a, b, c), $1e100a9690d50909$var$Ek(a, c));
}
function $1e100a9690d50909$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $1e100a9690d50909$var$Zk(a, c);
}
function $1e100a9690d50909$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($1e100a9690d50909$var$p(314));
    }
    null !== d && d.delete(b);
    $1e100a9690d50909$var$Zk(a, c);
}
var $1e100a9690d50909$var$Wk;
$1e100a9690d50909$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $1e100a9690d50909$var$Wf.current) $1e100a9690d50909$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $1e100a9690d50909$var$Ug = !1, $1e100a9690d50909$var$zj(a, b, c);
            $1e100a9690d50909$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $1e100a9690d50909$var$Ug = !1, $1e100a9690d50909$var$I && 0 !== (b.flags & 1048576) && $1e100a9690d50909$var$ug(b, $1e100a9690d50909$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $1e100a9690d50909$var$jj(a, b);
            a = b.pendingProps;
            var e = $1e100a9690d50909$var$Yf(b, $1e100a9690d50909$var$H.current);
            $1e100a9690d50909$var$Tg(b, c);
            e = $1e100a9690d50909$var$Xh(null, b, d, a, e, c);
            var f = $1e100a9690d50909$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $1e100a9690d50909$var$Zf(d) ? (f = !0, $1e100a9690d50909$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $1e100a9690d50909$var$ah(b), e.updater = $1e100a9690d50909$var$nh, b.stateNode = e, e._reactInternals = b, $1e100a9690d50909$var$rh(b, d, a, c), b = $1e100a9690d50909$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $1e100a9690d50909$var$I && f && $1e100a9690d50909$var$vg(b), $1e100a9690d50909$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $1e100a9690d50909$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $1e100a9690d50909$var$$k(d);
                a = $1e100a9690d50909$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $1e100a9690d50909$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $1e100a9690d50909$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $1e100a9690d50909$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $1e100a9690d50909$var$aj(null, b, d, $1e100a9690d50909$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($1e100a9690d50909$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $1e100a9690d50909$var$Lg(d, e), $1e100a9690d50909$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $1e100a9690d50909$var$Lg(d, e), $1e100a9690d50909$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $1e100a9690d50909$var$lj(b);
                if (null === a) throw Error($1e100a9690d50909$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $1e100a9690d50909$var$bh(a, b);
                $1e100a9690d50909$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $1e100a9690d50909$var$Ki(Error($1e100a9690d50909$var$p(423)), b);
                        b = $1e100a9690d50909$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $1e100a9690d50909$var$Ki(Error($1e100a9690d50909$var$p(424)), b);
                        b = $1e100a9690d50909$var$mj(a, b, d, c, e);
                        break a;
                    } else for($1e100a9690d50909$var$yg = $1e100a9690d50909$var$Lf(b.stateNode.containerInfo.firstChild), $1e100a9690d50909$var$xg = b, $1e100a9690d50909$var$I = !0, $1e100a9690d50909$var$zg = null, c = $1e100a9690d50909$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $1e100a9690d50909$var$Ig();
                    if (d === e) {
                        b = $1e100a9690d50909$var$$i(a, b, c);
                        break a;
                    }
                    $1e100a9690d50909$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $1e100a9690d50909$var$Kh(b), null === a && $1e100a9690d50909$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $1e100a9690d50909$var$Ef(d, e) ? g = null : null !== f && $1e100a9690d50909$var$Ef(d, f) && (b.flags |= 32), $1e100a9690d50909$var$hj(a, b), $1e100a9690d50909$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $1e100a9690d50909$var$Eg(b), null;
        case 13:
            return $1e100a9690d50909$var$pj(a, b, c);
        case 4:
            return $1e100a9690d50909$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $1e100a9690d50909$var$Bh(b, null, d, c) : $1e100a9690d50909$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $1e100a9690d50909$var$Lg(d, e), $1e100a9690d50909$var$Zi(a, b, d, e, c);
        case 7:
            return $1e100a9690d50909$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $1e100a9690d50909$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $1e100a9690d50909$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $1e100a9690d50909$var$G($1e100a9690d50909$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($1e100a9690d50909$var$He(f.value, g)) {
                        if (f.children === e.children && !$1e100a9690d50909$var$Wf.current) {
                            b = $1e100a9690d50909$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $1e100a9690d50909$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $1e100a9690d50909$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($1e100a9690d50909$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $1e100a9690d50909$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $1e100a9690d50909$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $1e100a9690d50909$var$Tg(b, c), e = $1e100a9690d50909$var$Vg(e), d = d(e), b.flags |= 1, $1e100a9690d50909$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $1e100a9690d50909$var$Lg(d, b.pendingProps), e = $1e100a9690d50909$var$Lg(d.type, e), $1e100a9690d50909$var$aj(a, b, d, e, c);
        case 15:
            return $1e100a9690d50909$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $1e100a9690d50909$var$Lg(d, e), $1e100a9690d50909$var$jj(a, b), b.tag = 1, $1e100a9690d50909$var$Zf(d) ? (a = !0, $1e100a9690d50909$var$cg(b)) : a = !1, $1e100a9690d50909$var$Tg(b, c), $1e100a9690d50909$var$ph(b, d, e), $1e100a9690d50909$var$rh(b, d, e, c), $1e100a9690d50909$var$kj(null, b, d, !0, a, c);
        case 19:
            return $1e100a9690d50909$var$yj(a, b, c);
        case 22:
            return $1e100a9690d50909$var$ej(a, b, c);
    }
    throw Error($1e100a9690d50909$var$p(156, b.tag));
};
function $1e100a9690d50909$var$Gk(a, b) {
    return $1e100a9690d50909$var$ac(a, b);
}
function $1e100a9690d50909$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $1e100a9690d50909$var$Bg(a, b, c, d) {
    return new $1e100a9690d50909$var$al(a, b, c, d);
}
function $1e100a9690d50909$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $1e100a9690d50909$var$$k(a) {
    if ("function" === typeof a) return $1e100a9690d50909$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $1e100a9690d50909$var$Da) return 11;
        if (a === $1e100a9690d50909$var$Ga) return 14;
    }
    return 2;
}
function $1e100a9690d50909$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $1e100a9690d50909$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $1e100a9690d50909$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $1e100a9690d50909$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $1e100a9690d50909$var$ya:
            return $1e100a9690d50909$var$Ah(c.children, e, f, b);
        case $1e100a9690d50909$var$za:
            g = 8;
            e |= 8;
            break;
        case $1e100a9690d50909$var$Aa:
            return a = $1e100a9690d50909$var$Bg(12, c, b, e | 2), a.elementType = $1e100a9690d50909$var$Aa, a.lanes = f, a;
        case $1e100a9690d50909$var$Ea:
            return a = $1e100a9690d50909$var$Bg(13, c, b, e), a.elementType = $1e100a9690d50909$var$Ea, a.lanes = f, a;
        case $1e100a9690d50909$var$Fa:
            return a = $1e100a9690d50909$var$Bg(19, c, b, e), a.elementType = $1e100a9690d50909$var$Fa, a.lanes = f, a;
        case $1e100a9690d50909$var$Ia:
            return $1e100a9690d50909$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $1e100a9690d50909$var$Ba:
                    g = 10;
                    break a;
                case $1e100a9690d50909$var$Ca:
                    g = 9;
                    break a;
                case $1e100a9690d50909$var$Da:
                    g = 11;
                    break a;
                case $1e100a9690d50909$var$Ga:
                    g = 14;
                    break a;
                case $1e100a9690d50909$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($1e100a9690d50909$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $1e100a9690d50909$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $1e100a9690d50909$var$Ah(a, b, c, d) {
    a = $1e100a9690d50909$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $1e100a9690d50909$var$qj(a, b, c, d) {
    a = $1e100a9690d50909$var$Bg(22, a, d, b);
    a.elementType = $1e100a9690d50909$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $1e100a9690d50909$var$xh(a, b, c) {
    a = $1e100a9690d50909$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $1e100a9690d50909$var$zh(a, b, c) {
    b = $1e100a9690d50909$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $1e100a9690d50909$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $1e100a9690d50909$var$zc(0);
    this.expirationTimes = $1e100a9690d50909$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $1e100a9690d50909$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $1e100a9690d50909$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $1e100a9690d50909$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $1e100a9690d50909$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $1e100a9690d50909$var$ah(f);
    return a;
}
function $1e100a9690d50909$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $1e100a9690d50909$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $1e100a9690d50909$var$el(a) {
    if (!a) return $1e100a9690d50909$var$Vf;
    a = a._reactInternals;
    a: {
        if ($1e100a9690d50909$var$Vb(a) !== a || 1 !== a.tag) throw Error($1e100a9690d50909$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($1e100a9690d50909$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($1e100a9690d50909$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($1e100a9690d50909$var$Zf(c)) return $1e100a9690d50909$var$bg(a, c, b);
    }
    return b;
}
function $1e100a9690d50909$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $1e100a9690d50909$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $1e100a9690d50909$var$el(null);
    c = a.current;
    d = $1e100a9690d50909$var$L();
    e = $1e100a9690d50909$var$lh(c);
    f = $1e100a9690d50909$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $1e100a9690d50909$var$dh(c, f, e);
    a.current.lanes = e;
    $1e100a9690d50909$var$Ac(a, e, d);
    $1e100a9690d50909$var$Ek(a, d);
    return a;
}
function $1e100a9690d50909$var$gl(a, b, c, d) {
    var e = b.current, f = $1e100a9690d50909$var$L(), g = $1e100a9690d50909$var$lh(e);
    c = $1e100a9690d50909$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $1e100a9690d50909$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $1e100a9690d50909$var$dh(e, b, g);
    null !== a && ($1e100a9690d50909$var$mh(a, e, g, f), $1e100a9690d50909$var$eh(a, e, g));
    return g;
}
function $1e100a9690d50909$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $1e100a9690d50909$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $1e100a9690d50909$var$jl(a, b) {
    $1e100a9690d50909$var$il(a, b);
    (a = a.alternate) && $1e100a9690d50909$var$il(a, b);
}
function $1e100a9690d50909$var$kl() {
    return null;
}
var $1e100a9690d50909$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $1e100a9690d50909$var$ml(a) {
    this._internalRoot = a;
}
$1e100a9690d50909$var$nl.prototype.render = $1e100a9690d50909$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($1e100a9690d50909$var$p(409));
    $1e100a9690d50909$var$gl(a, b, null, null);
};
$1e100a9690d50909$var$nl.prototype.unmount = $1e100a9690d50909$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $1e100a9690d50909$var$Sk(function() {
            $1e100a9690d50909$var$gl(null, a, null, null);
        });
        b[$1e100a9690d50909$var$uf] = null;
    }
};
function $1e100a9690d50909$var$nl(a) {
    this._internalRoot = a;
}
$1e100a9690d50909$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $1e100a9690d50909$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $1e100a9690d50909$var$Qc.length && 0 !== b && b < $1e100a9690d50909$var$Qc[c].priority; c++);
        $1e100a9690d50909$var$Qc.splice(c, 0, a);
        0 === c && $1e100a9690d50909$var$Vc(a);
    }
};
function $1e100a9690d50909$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $1e100a9690d50909$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $1e100a9690d50909$var$ql() {}
function $1e100a9690d50909$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $1e100a9690d50909$var$hl(g);
                f.call(a);
            };
        }
        var g = $1e100a9690d50909$var$fl(b, d, a, 0, null, !1, !1, "", $1e100a9690d50909$var$ql);
        a._reactRootContainer = g;
        a[$1e100a9690d50909$var$uf] = g.current;
        $1e100a9690d50909$var$sf(8 === a.nodeType ? a.parentNode : a);
        $1e100a9690d50909$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $1e100a9690d50909$var$hl(k);
            h.call(a);
        };
    }
    var k = $1e100a9690d50909$var$cl(a, 0, !1, null, null, !1, !1, "", $1e100a9690d50909$var$ql);
    a._reactRootContainer = k;
    a[$1e100a9690d50909$var$uf] = k.current;
    $1e100a9690d50909$var$sf(8 === a.nodeType ? a.parentNode : a);
    $1e100a9690d50909$var$Sk(function() {
        $1e100a9690d50909$var$gl(b, k, c, d);
    });
    return k;
}
function $1e100a9690d50909$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $1e100a9690d50909$var$hl(g);
                h.call(a);
            };
        }
        $1e100a9690d50909$var$gl(b, g, a, e);
    } else g = $1e100a9690d50909$var$rl(c, b, a, e, d);
    return $1e100a9690d50909$var$hl(g);
}
$1e100a9690d50909$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $1e100a9690d50909$var$tc(b.pendingLanes);
                0 !== c && ($1e100a9690d50909$var$Cc(b, c | 1), $1e100a9690d50909$var$Ek(b, $1e100a9690d50909$var$B()), 0 === ($1e100a9690d50909$var$K & 6) && ($1e100a9690d50909$var$Hj = $1e100a9690d50909$var$B() + 500, $1e100a9690d50909$var$jg()));
            }
            break;
        case 13:
            $1e100a9690d50909$var$Sk(function() {
                var b = $1e100a9690d50909$var$Zg(a, 1);
                if (null !== b) {
                    var c = $1e100a9690d50909$var$L();
                    $1e100a9690d50909$var$mh(b, a, 1, c);
                }
            }), $1e100a9690d50909$var$jl(a, 1);
    }
};
$1e100a9690d50909$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $1e100a9690d50909$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $1e100a9690d50909$var$L();
            $1e100a9690d50909$var$mh(b, a, 134217728, c);
        }
        $1e100a9690d50909$var$jl(a, 134217728);
    }
};
$1e100a9690d50909$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $1e100a9690d50909$var$lh(a), c = $1e100a9690d50909$var$Zg(a, b);
        if (null !== c) {
            var d = $1e100a9690d50909$var$L();
            $1e100a9690d50909$var$mh(c, a, b, d);
        }
        $1e100a9690d50909$var$jl(a, b);
    }
};
$1e100a9690d50909$var$Hc = function() {
    return $1e100a9690d50909$var$C;
};
$1e100a9690d50909$var$Ic = function(a, b) {
    var c = $1e100a9690d50909$var$C;
    try {
        return $1e100a9690d50909$var$C = a, b();
    } finally{
        $1e100a9690d50909$var$C = c;
    }
};
$1e100a9690d50909$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $1e100a9690d50909$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $1e100a9690d50909$var$Db(d);
                        if (!e) throw Error($1e100a9690d50909$var$p(90));
                        $1e100a9690d50909$var$Wa(d);
                        $1e100a9690d50909$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $1e100a9690d50909$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $1e100a9690d50909$var$fb(a, !!c.multiple, b, !1);
    }
};
$1e100a9690d50909$var$Gb = $1e100a9690d50909$var$Rk;
$1e100a9690d50909$var$Hb = $1e100a9690d50909$var$Sk;
var $1e100a9690d50909$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $1e100a9690d50909$var$Cb,
        $1e100a9690d50909$var$ue,
        $1e100a9690d50909$var$Db,
        $1e100a9690d50909$var$Eb,
        $1e100a9690d50909$var$Fb,
        $1e100a9690d50909$var$Rk
    ]
}, $1e100a9690d50909$var$ul = {
    findFiberByHostInstance: $1e100a9690d50909$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $1e100a9690d50909$var$vl = {
    bundleType: $1e100a9690d50909$var$ul.bundleType,
    version: $1e100a9690d50909$var$ul.version,
    rendererPackageName: $1e100a9690d50909$var$ul.rendererPackageName,
    rendererConfig: $1e100a9690d50909$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $1e100a9690d50909$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $1e100a9690d50909$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $1e100a9690d50909$var$ul.findFiberByHostInstance || $1e100a9690d50909$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $1e100a9690d50909$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$1e100a9690d50909$var$wl.isDisabled && $1e100a9690d50909$var$wl.supportsFiber) try {
        $1e100a9690d50909$var$kc = $1e100a9690d50909$var$wl.inject($1e100a9690d50909$var$vl), $1e100a9690d50909$var$lc = $1e100a9690d50909$var$wl;
    } catch (a) {}
}
$1e100a9690d50909$export$ae55be85d98224ed = $1e100a9690d50909$var$tl;
$1e100a9690d50909$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$1e100a9690d50909$var$ol(b)) throw Error($1e100a9690d50909$var$p(200));
    return $1e100a9690d50909$var$dl(a, b, null, c);
};
$1e100a9690d50909$export$882461b6382ed46c = function(a, b) {
    if (!$1e100a9690d50909$var$ol(a)) throw Error($1e100a9690d50909$var$p(299));
    var c = !1, d = "", e = $1e100a9690d50909$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $1e100a9690d50909$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$1e100a9690d50909$var$uf] = b.current;
    $1e100a9690d50909$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $1e100a9690d50909$var$ml(b);
};
$1e100a9690d50909$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($1e100a9690d50909$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($1e100a9690d50909$var$p(268, a));
    }
    a = $1e100a9690d50909$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$1e100a9690d50909$export$cd75ccfd720a3cd4 = function(a) {
    return $1e100a9690d50909$var$Sk(a);
};
$1e100a9690d50909$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$1e100a9690d50909$var$pl(b)) throw Error($1e100a9690d50909$var$p(200));
    return $1e100a9690d50909$var$sl(null, a, b, !0, c);
};
$1e100a9690d50909$export$757ceba2d55c277e = function(a, b, c) {
    if (!$1e100a9690d50909$var$ol(a)) throw Error($1e100a9690d50909$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $1e100a9690d50909$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $1e100a9690d50909$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$1e100a9690d50909$var$uf] = b.current;
    $1e100a9690d50909$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $1e100a9690d50909$var$nl(b);
};
$1e100a9690d50909$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$1e100a9690d50909$var$pl(b)) throw Error($1e100a9690d50909$var$p(200));
    return $1e100a9690d50909$var$sl(null, a, b, !1, c);
};
$1e100a9690d50909$export$502457920280e6be = function(a) {
    if (!$1e100a9690d50909$var$pl(a)) throw Error($1e100a9690d50909$var$p(40));
    return a._reactRootContainer ? ($1e100a9690d50909$var$Sk(function() {
        $1e100a9690d50909$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$1e100a9690d50909$var$uf] = null;
        });
    }), !0) : !1;
};
$1e100a9690d50909$export$c78a37762a8d58e1 = $1e100a9690d50909$var$Rk;
$1e100a9690d50909$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$1e100a9690d50909$var$pl(c)) throw Error($1e100a9690d50909$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($1e100a9690d50909$var$p(38));
    return $1e100a9690d50909$var$sl(a, b, c, !1, d);
};
$1e100a9690d50909$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("bv3Kn", function(module, exports) {
"use strict";

module.exports = (parcelRequire("j1xYf"));

});
parcelRequire.register("j1xYf", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $dd987638fd92e38f$export$c4744153514ff05d; }, function (v) { return $dd987638fd92e38f$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $dd987638fd92e38f$export$3e506c1ccc9cc1a7; }, function (v) { return $dd987638fd92e38f$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $dd987638fd92e38f$export$e26fe2ed2fa76875; }, function (v) { return $dd987638fd92e38f$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $dd987638fd92e38f$export$502329bbf4b505b1; }, function (v) { return $dd987638fd92e38f$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $dd987638fd92e38f$export$6e3807111c4874c4; }, function (v) { return $dd987638fd92e38f$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $dd987638fd92e38f$export$c27134553091fb3a; }, function (v) { return $dd987638fd92e38f$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $dd987638fd92e38f$export$33ee1acdc04fd2a2; }, function (v) { return $dd987638fd92e38f$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $dd987638fd92e38f$export$b00a404bbd5edef2; }, function (v) { return $dd987638fd92e38f$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $dd987638fd92e38f$export$8352ce38b91d0c62; }, function (v) { return $dd987638fd92e38f$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $dd987638fd92e38f$export$d66a1c1c77bd778b; }, function (v) { return $dd987638fd92e38f$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $dd987638fd92e38f$export$d3dfb8e4810cb555; }, function (v) { return $dd987638fd92e38f$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $dd987638fd92e38f$export$839f9183b0465a69; }, function (v) { return $dd987638fd92e38f$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $dd987638fd92e38f$export$72fdf0e06517287b; }, function (v) { return $dd987638fd92e38f$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $dd987638fd92e38f$export$4b844e58a3e414b4; }, function (v) { return $dd987638fd92e38f$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $dd987638fd92e38f$export$816d2913ae6b83b1; }, function (v) { return $dd987638fd92e38f$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $dd987638fd92e38f$export$61bcfe829111a1d0; }, function (v) { return $dd987638fd92e38f$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $dd987638fd92e38f$export$7ee8c9beb337bc3f; }, function (v) { return $dd987638fd92e38f$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $dd987638fd92e38f$export$b5836b71941fa3ed; }, function (v) { return $dd987638fd92e38f$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $dd987638fd92e38f$export$cf845f2c119da08a; }, function (v) { return $dd987638fd92e38f$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dd987638fd92e38f$export$c4744153514ff05d;
var $dd987638fd92e38f$export$3e506c1ccc9cc1a7;
var $dd987638fd92e38f$export$e26fe2ed2fa76875;
var $dd987638fd92e38f$export$502329bbf4b505b1;
var $dd987638fd92e38f$export$6e3807111c4874c4;
var $dd987638fd92e38f$export$c27134553091fb3a;
var $dd987638fd92e38f$export$33ee1acdc04fd2a2;
var $dd987638fd92e38f$export$b00a404bbd5edef2;
var $dd987638fd92e38f$export$8352ce38b91d0c62;
var $dd987638fd92e38f$export$d66a1c1c77bd778b;
var $dd987638fd92e38f$export$d3dfb8e4810cb555;
var $dd987638fd92e38f$export$839f9183b0465a69;
var $dd987638fd92e38f$export$72fdf0e06517287b;
var $dd987638fd92e38f$export$4b844e58a3e414b4;
var $dd987638fd92e38f$export$816d2913ae6b83b1;
var $dd987638fd92e38f$export$61bcfe829111a1d0;
var $dd987638fd92e38f$export$7ee8c9beb337bc3f;
var $dd987638fd92e38f$export$b5836b71941fa3ed;
var $dd987638fd92e38f$export$cf845f2c119da08a;
"use strict";
function $dd987638fd92e38f$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $dd987638fd92e38f$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $dd987638fd92e38f$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $dd987638fd92e38f$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $dd987638fd92e38f$var$g(C, c)) n < e && 0 > $dd987638fd92e38f$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $dd987638fd92e38f$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $dd987638fd92e38f$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $dd987638fd92e38f$var$l = performance;
    $dd987638fd92e38f$export$c4744153514ff05d = function() {
        return $dd987638fd92e38f$var$l.now();
    };
} else {
    var $dd987638fd92e38f$var$p = Date, $dd987638fd92e38f$var$q = $dd987638fd92e38f$var$p.now();
    $dd987638fd92e38f$export$c4744153514ff05d = function() {
        return $dd987638fd92e38f$var$p.now() - $dd987638fd92e38f$var$q;
    };
}
var $dd987638fd92e38f$var$r = [], $dd987638fd92e38f$var$t = [], $dd987638fd92e38f$var$u = 1, $dd987638fd92e38f$var$v = null, $dd987638fd92e38f$var$y = 3, $dd987638fd92e38f$var$z = !1, $dd987638fd92e38f$var$A = !1, $dd987638fd92e38f$var$B = !1, $dd987638fd92e38f$var$D = "function" === typeof setTimeout ? setTimeout : null, $dd987638fd92e38f$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $dd987638fd92e38f$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $dd987638fd92e38f$var$G(a) {
    for(var b = $dd987638fd92e38f$var$h($dd987638fd92e38f$var$t); null !== b;){
        if (null === b.callback) $dd987638fd92e38f$var$k($dd987638fd92e38f$var$t);
        else if (b.startTime <= a) $dd987638fd92e38f$var$k($dd987638fd92e38f$var$t), b.sortIndex = b.expirationTime, $dd987638fd92e38f$var$f($dd987638fd92e38f$var$r, b);
        else break;
        b = $dd987638fd92e38f$var$h($dd987638fd92e38f$var$t);
    }
}
function $dd987638fd92e38f$var$H(a) {
    $dd987638fd92e38f$var$B = !1;
    $dd987638fd92e38f$var$G(a);
    if (!$dd987638fd92e38f$var$A) {
        if (null !== $dd987638fd92e38f$var$h($dd987638fd92e38f$var$r)) $dd987638fd92e38f$var$A = !0, $dd987638fd92e38f$var$I($dd987638fd92e38f$var$J);
        else {
            var b = $dd987638fd92e38f$var$h($dd987638fd92e38f$var$t);
            null !== b && $dd987638fd92e38f$var$K($dd987638fd92e38f$var$H, b.startTime - a);
        }
    }
}
function $dd987638fd92e38f$var$J(a, b) {
    $dd987638fd92e38f$var$A = !1;
    $dd987638fd92e38f$var$B && ($dd987638fd92e38f$var$B = !1, $dd987638fd92e38f$var$E($dd987638fd92e38f$var$L), $dd987638fd92e38f$var$L = -1);
    $dd987638fd92e38f$var$z = !0;
    var c = $dd987638fd92e38f$var$y;
    try {
        $dd987638fd92e38f$var$G(b);
        for($dd987638fd92e38f$var$v = $dd987638fd92e38f$var$h($dd987638fd92e38f$var$r); null !== $dd987638fd92e38f$var$v && (!($dd987638fd92e38f$var$v.expirationTime > b) || a && !$dd987638fd92e38f$var$M());){
            var d = $dd987638fd92e38f$var$v.callback;
            if ("function" === typeof d) {
                $dd987638fd92e38f$var$v.callback = null;
                $dd987638fd92e38f$var$y = $dd987638fd92e38f$var$v.priorityLevel;
                var e = d($dd987638fd92e38f$var$v.expirationTime <= b);
                b = $dd987638fd92e38f$export$c4744153514ff05d();
                "function" === typeof e ? $dd987638fd92e38f$var$v.callback = e : $dd987638fd92e38f$var$v === $dd987638fd92e38f$var$h($dd987638fd92e38f$var$r) && $dd987638fd92e38f$var$k($dd987638fd92e38f$var$r);
                $dd987638fd92e38f$var$G(b);
            } else $dd987638fd92e38f$var$k($dd987638fd92e38f$var$r);
            $dd987638fd92e38f$var$v = $dd987638fd92e38f$var$h($dd987638fd92e38f$var$r);
        }
        if (null !== $dd987638fd92e38f$var$v) var w = !0;
        else {
            var m = $dd987638fd92e38f$var$h($dd987638fd92e38f$var$t);
            null !== m && $dd987638fd92e38f$var$K($dd987638fd92e38f$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $dd987638fd92e38f$var$v = null, $dd987638fd92e38f$var$y = c, $dd987638fd92e38f$var$z = !1;
    }
}
var $dd987638fd92e38f$var$N = !1, $dd987638fd92e38f$var$O = null, $dd987638fd92e38f$var$L = -1, $dd987638fd92e38f$var$P = 5, $dd987638fd92e38f$var$Q = -1;
function $dd987638fd92e38f$var$M() {
    return $dd987638fd92e38f$export$c4744153514ff05d() - $dd987638fd92e38f$var$Q < $dd987638fd92e38f$var$P ? !1 : !0;
}
function $dd987638fd92e38f$var$R() {
    if (null !== $dd987638fd92e38f$var$O) {
        var a = $dd987638fd92e38f$export$c4744153514ff05d();
        $dd987638fd92e38f$var$Q = a;
        var b = !0;
        try {
            b = $dd987638fd92e38f$var$O(!0, a);
        } finally{
            b ? $dd987638fd92e38f$var$S() : ($dd987638fd92e38f$var$N = !1, $dd987638fd92e38f$var$O = null);
        }
    } else $dd987638fd92e38f$var$N = !1;
}
var $dd987638fd92e38f$var$S;
if ("function" === typeof $dd987638fd92e38f$var$F) $dd987638fd92e38f$var$S = function() {
    $dd987638fd92e38f$var$F($dd987638fd92e38f$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $dd987638fd92e38f$var$T = new MessageChannel, $dd987638fd92e38f$var$U = $dd987638fd92e38f$var$T.port2;
    $dd987638fd92e38f$var$T.port1.onmessage = $dd987638fd92e38f$var$R;
    $dd987638fd92e38f$var$S = function() {
        $dd987638fd92e38f$var$U.postMessage(null);
    };
} else $dd987638fd92e38f$var$S = function() {
    $dd987638fd92e38f$var$D($dd987638fd92e38f$var$R, 0);
};
function $dd987638fd92e38f$var$I(a) {
    $dd987638fd92e38f$var$O = a;
    $dd987638fd92e38f$var$N || ($dd987638fd92e38f$var$N = !0, $dd987638fd92e38f$var$S());
}
function $dd987638fd92e38f$var$K(a, b) {
    $dd987638fd92e38f$var$L = $dd987638fd92e38f$var$D(function() {
        a($dd987638fd92e38f$export$c4744153514ff05d());
    }, b);
}
$dd987638fd92e38f$export$3e506c1ccc9cc1a7 = 5;
$dd987638fd92e38f$export$e26fe2ed2fa76875 = 1;
$dd987638fd92e38f$export$502329bbf4b505b1 = 4;
$dd987638fd92e38f$export$6e3807111c4874c4 = 3;
$dd987638fd92e38f$export$c27134553091fb3a = null;
$dd987638fd92e38f$export$33ee1acdc04fd2a2 = 2;
$dd987638fd92e38f$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$dd987638fd92e38f$export$8352ce38b91d0c62 = function() {
    $dd987638fd92e38f$var$A || $dd987638fd92e38f$var$z || ($dd987638fd92e38f$var$A = !0, $dd987638fd92e38f$var$I($dd987638fd92e38f$var$J));
};
$dd987638fd92e38f$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $dd987638fd92e38f$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$dd987638fd92e38f$export$d3dfb8e4810cb555 = function() {
    return $dd987638fd92e38f$var$y;
};
$dd987638fd92e38f$export$839f9183b0465a69 = function() {
    return $dd987638fd92e38f$var$h($dd987638fd92e38f$var$r);
};
$dd987638fd92e38f$export$72fdf0e06517287b = function(a) {
    switch($dd987638fd92e38f$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $dd987638fd92e38f$var$y;
    }
    var c = $dd987638fd92e38f$var$y;
    $dd987638fd92e38f$var$y = b;
    try {
        return a();
    } finally{
        $dd987638fd92e38f$var$y = c;
    }
};
$dd987638fd92e38f$export$4b844e58a3e414b4 = function() {};
$dd987638fd92e38f$export$816d2913ae6b83b1 = function() {};
$dd987638fd92e38f$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $dd987638fd92e38f$var$y;
    $dd987638fd92e38f$var$y = a;
    try {
        return b();
    } finally{
        $dd987638fd92e38f$var$y = c;
    }
};
$dd987638fd92e38f$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $dd987638fd92e38f$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $dd987638fd92e38f$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $dd987638fd92e38f$var$f($dd987638fd92e38f$var$t, a), null === $dd987638fd92e38f$var$h($dd987638fd92e38f$var$r) && a === $dd987638fd92e38f$var$h($dd987638fd92e38f$var$t) && ($dd987638fd92e38f$var$B ? ($dd987638fd92e38f$var$E($dd987638fd92e38f$var$L), $dd987638fd92e38f$var$L = -1) : $dd987638fd92e38f$var$B = !0, $dd987638fd92e38f$var$K($dd987638fd92e38f$var$H, c - d))) : (a.sortIndex = e, $dd987638fd92e38f$var$f($dd987638fd92e38f$var$r, a), $dd987638fd92e38f$var$A || $dd987638fd92e38f$var$z || ($dd987638fd92e38f$var$A = !0, $dd987638fd92e38f$var$I($dd987638fd92e38f$var$J)));
    return a;
};
$dd987638fd92e38f$export$b5836b71941fa3ed = $dd987638fd92e38f$var$M;
$dd987638fd92e38f$export$cf845f2c119da08a = function(a) {
    var b = $dd987638fd92e38f$var$y;
    return function() {
        var c = $dd987638fd92e38f$var$y;
        $dd987638fd92e38f$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $dd987638fd92e38f$var$y = c;
        }
    };
};

});




parcelRequire.register("bD9Bx", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $877ac97a90a71686$var$ReactIs, $877ac97a90a71686$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("9LxXV"))();

});
parcelRequire.register("9LxXV", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $4sQr7 = parcelRequire("4sQr7");
function $71c2d9ad5bcefd10$var$emptyFunction() {}
function $71c2d9ad5bcefd10$var$emptyFunctionWithReset() {}
$71c2d9ad5bcefd10$var$emptyFunctionWithReset.resetWarningCache = $71c2d9ad5bcefd10$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $4sQr7) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $71c2d9ad5bcefd10$var$emptyFunctionWithReset,
        resetWarningCache: $71c2d9ad5bcefd10$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("4sQr7", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $340273b3e2eb78fc$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $340273b3e2eb78fc$var$ReactPropTypesSecret;

});



parcelRequire.register("ajkVG", function(module, exports) {
$parcel$export(module.exports, "formatToInternationalPhoneNumber", function () { return (parcelRequire("51A9u")).formatToInternationalPhoneNumber; });
$parcel$export(module.exports, "generateStandardId", function () { return (parcelRequire("7WNrO")).generateStandardId; });
$parcel$export(module.exports, "generateStandardSecret", function () { return (parcelRequire("7WNrO")).generateStandardSecret; });
$parcel$export(module.exports, "generateStandardShortId", function () { return (parcelRequire("7WNrO")).generateStandardShortId; });
$parcel$export(module.exports, "getUserDisplayName", function () { return (parcelRequire("clvkc")).getUserDisplayName; });
$parcel$export(module.exports, "isValidSubdomain", function () { return (parcelRequire("1Iqyx")).isValidSubdomain; });
$parcel$export(module.exports, "parsePhoneNumber", function () { return (parcelRequire("51A9u")).parsePhoneNumber; });
parcelRequire("fgzrS");
parcelRequire("bq6JJ");

});
parcelRequire.register("fgzrS", function(module, exports) {
/*
  We does not export `sql.ts` here since it requires slonik which is not universal.
  It will be exported separately in `/src/index.ts`.
*/ parcelRequire("5jr8F");

});
parcelRequire.register("5jr8F", function(module, exports) {

});


parcelRequire.register("bq6JJ", function(module, exports) {
$parcel$export(module.exports, "generateStandardId", function () { return (parcelRequire("7WNrO")).generateStandardId; });
$parcel$export(module.exports, "generateStandardSecret", function () { return (parcelRequire("7WNrO")).generateStandardSecret; });
$parcel$export(module.exports, "generateStandardShortId", function () { return (parcelRequire("7WNrO")).generateStandardShortId; });
$parcel$export(module.exports, "formatToInternationalPhoneNumber", function () { return (parcelRequire("51A9u")).formatToInternationalPhoneNumber; });
$parcel$export(module.exports, "parsePhoneNumber", function () { return (parcelRequire("51A9u")).parsePhoneNumber; });
$parcel$export(module.exports, "isValidSubdomain", function () { return (parcelRequire("1Iqyx")).isValidSubdomain; });
$parcel$export(module.exports, "getUserDisplayName", function () { return (parcelRequire("clvkc")).getUserDisplayName; });
parcelRequire("2Fdl8");
parcelRequire("7WNrO");
parcelRequire("be91k");
parcelRequire("jlYYu");
parcelRequire("51A9u");
parcelRequire("1Iqyx");
parcelRequire("fy1wJ");
parcelRequire("clvkc");

});
parcelRequire.register("2Fdl8", function(module, exports) {
/** The necessary headers for sending a form-urlencoded request. */ const $1f09c21ea4ac6f0f$export$b8439228f8686498 = Object.freeze({
    "content-type": "application/x-www-form-urlencoded"
});

});

parcelRequire.register("7WNrO", function(module, exports) {

$parcel$export(module.exports, "generateStandardId", function () { return $5c944e70e62ef011$export$7e648d54e633633e; });
$parcel$export(module.exports, "generateStandardShortId", function () { return $5c944e70e62ef011$export$8702116b552d3dba; });
$parcel$export(module.exports, "generateStandardSecret", function () { return $5c944e70e62ef011$export$877b6275f1b9e856; });

var $4VIdw = parcelRequire("4VIdw");
const $5c944e70e62ef011$var$lowercaseAlphabet = "0123456789abcdefghijklmnopqrstuvwxyz";
const $5c944e70e62ef011$var$alphabet = `${$5c944e70e62ef011$var$lowercaseAlphabet}ABCDEFGHIJKLMNOPQRSTUVWXYZ`;
const $5c944e70e62ef011$var$buildIdGenerator = (size, includingUppercase = true)=>(0, $4VIdw.customAlphabet)(includingUppercase ? $5c944e70e62ef011$var$alphabet : $5c944e70e62ef011$var$lowercaseAlphabet, size);
const $5c944e70e62ef011$export$7e648d54e633633e = $5c944e70e62ef011$var$buildIdGenerator(21, false);
const $5c944e70e62ef011$export$8702116b552d3dba = $5c944e70e62ef011$var$buildIdGenerator(12, false);
const $5c944e70e62ef011$export$877b6275f1b9e856 = $5c944e70e62ef011$var$buildIdGenerator(32);

});
parcelRequire.register("4VIdw", function(module, exports) {

$parcel$export(module.exports, "customAlphabet", function () { return $396ec8e93be1f87f$export$62e99e5c9f473d7f; });
$parcel$export(module.exports, "nanoid", function () { return $396ec8e93be1f87f$export$ac4959f4f1338dfc; });

let $396ec8e93be1f87f$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $396ec8e93be1f87f$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = "";
        while(true){
            let bytes = getRandom(step);
            let j = step;
            while(j--){
                id += alphabet[bytes[j] & mask] || "";
                if (id.length === size) return id;
            }
        }
    };
};
let $396ec8e93be1f87f$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$396ec8e93be1f87f$export$a5cee9e955a615e5(alphabet, size, $396ec8e93be1f87f$export$4385e60b38654f68);
let $396ec8e93be1f87f$export$ac4959f4f1338dfc = (size = 21)=>crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte)=>{
        byte &= 63;
        if (byte < 36) id += byte.toString(36);
        else if (byte < 62) id += (byte - 26).toString(36).toUpperCase();
        else if (byte > 62) id += "-";
        else id += "_";
        return id;
    }, "");

});


parcelRequire.register("be91k", function(module, exports) {
/* Migrated from @logto/app-insights */ parcelRequire("12bMu");
var $3dBAh = parcelRequire("3dBAh");
const $82c7ffcd33643f5c$var$transformedKey = Symbol("Indicates an object is transformed from an `Error` instance");
const $82c7ffcd33643f5c$var$isObject = (value)=>typeof value === "object" && value !== null;
// Edited from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Cyclic_object_value#circular_references
function $82c7ffcd33643f5c$var$getCircularReplacer() {
    const ancestors = [];
    const transformedMap = new WeakMap();
    const transformErrorValue = (value)=>{
        // Special handling for `Error` instances since they have non-enumerable properties
        if (value instanceof Error) {
            if (!transformedMap.has(value)) {
                const transformed = {};
                for (const key of Object.getOwnPropertyNames(value))// @ts-expect-error getOwnPropertyNames() returns the valid keys
                // eslint-disable-next-line @silverhand/fp/no-mutation
                transformed[key] = value[key];
                // eslint-disable-next-line @silverhand/fp/no-mutation
                transformed[$82c7ffcd33643f5c$var$transformedKey] = true;
                transformedMap.set(value, transformed);
            }
            return transformedMap.get(value);
        }
        return value;
    };
    return function(key, value) {
        // Ignore `stack` property since ApplicationInsights will show it
        if ($82c7ffcd33643f5c$var$isObject(this) && Object.hasOwn(this, $82c7ffcd33643f5c$var$transformedKey) && key === "stack") return;
        if (!$82c7ffcd33643f5c$var$isObject(value)) return value;
        // `this` is the object that value is contained in,
        // i.e., its direct parent.
        while(ancestors.length > 0 && ancestors.at(-1) !== this)// eslint-disable-next-line @silverhand/fp/no-mutating-methods
        ancestors.pop();
        const transformed = transformErrorValue(value);
        if (ancestors.includes(transformed)) return "[Circular ~]";
        // eslint-disable-next-line @silverhand/fp/no-mutating-methods
        ancestors.push(transformed);
        return transformed;
    };
}
const $82c7ffcd33643f5c$export$e7bd538fb0c5db1a = (error)=>{
    /**
     * - Ensure the message if not empty otherwise Application Insights will respond 400
     *   and the error will not be recorded.
     * - We stringify error object here since other error properties won't show on the
     *   ApplicationInsights details page.
     */ const message = (0, $3dBAh.trySafe)(()=>JSON.stringify(error, $82c7ffcd33643f5c$var$getCircularReplacer())) ?? "Unknown error";
    // Ensure we don't mutate the original error
    const normalized = new Error(message);
    if (error instanceof Error) {
        // Manually clone key fields of the error for AppInsights display
        /* eslint-disable @silverhand/fp/no-mutation */ normalized.name = error.name;
        normalized.stack = error.stack;
        normalized.cause = error.cause;
    /* eslint-enable @silverhand/fp/no-mutation */ }
    return normalized;
};

});
parcelRequire.register("12bMu", function(module, exports) {

$parcel$export(module.exports, "deduplicate", function () { return (parcelRequire("6cnHd")).deduplicate; });
$parcel$export(module.exports, "isSameArray", function () { return (parcelRequire("hRw8F")).isSameArray; });
$parcel$export(module.exports, "cond", function () { return (parcelRequire("7oDSS")).cond; });
$parcel$export(module.exports, "condArray", function () { return (parcelRequire("7oDSS")).condArray; });
$parcel$export(module.exports, "condString", function () { return (parcelRequire("7oDSS")).condString; });
$parcel$export(module.exports, "conditional", function () { return (parcelRequire("7oDSS")).conditional; });
$parcel$export(module.exports, "conditionalArray", function () { return (parcelRequire("7oDSS")).conditionalArray; });
$parcel$export(module.exports, "conditionalString", function () { return (parcelRequire("7oDSS")).conditionalString; });
$parcel$export(module.exports, "noop", function () { return (parcelRequire("3dBAh")).noop; });
$parcel$export(module.exports, "trySafe", function () { return (parcelRequire("3dBAh")).trySafe; });
$parcel$export(module.exports, "pick", function () { return (parcelRequire("iS4bq")).pick; });
$parcel$export(module.exports, "urlSafeBase64", function () { return (parcelRequire("l0I3U")).urlSafeBase64; });
$parcel$export(module.exports, "yes", function () { return (parcelRequire("l0I3U")).yes; });
$parcel$export(module.exports, "getSafe", function () { return (parcelRequire("7Pi8O")).getSafe; });
$parcel$export(module.exports, "appendPath", function () { return (parcelRequire("gcHb7")).appendPath; });
$parcel$export(module.exports, "joinPath", function () { return (parcelRequire("gcHb7")).joinPath; });
$parcel$export(module.exports, "isKeyInObject", function () { return (parcelRequire("jMfTG")).isKeyInObject; });

var $6cnHd = parcelRequire("6cnHd");

var $9pAQx = parcelRequire("9pAQx");

var $hRw8F = parcelRequire("hRw8F");

var $7oDSS = parcelRequire("7oDSS");

var $hXtmV = parcelRequire("hXtmV");

var $3dBAh = parcelRequire("3dBAh");

var $iS4bq = parcelRequire("iS4bq");

var $l0I3U = parcelRequire("l0I3U");

var $7Pi8O = parcelRequire("7Pi8O");

var $gcHb7 = parcelRequire("gcHb7");

var $jMfTG = parcelRequire("jMfTG");

var $2rO6k = parcelRequire("2rO6k");

});
parcelRequire.register("6cnHd", function(module, exports) {

$parcel$export(module.exports, "deduplicate", function () { return $48363e98f0ab8dcb$export$6b75200e58bc97d0; });
const $48363e98f0ab8dcb$export$670d48958e84d448 = (value)=>{
    if (value) return Array.isArray(value) ? value : [
        value
    ];
    return [];
};
// Disable FP rules here to use the performant approach while keep the function itself "FP"
/* eslint-disable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ const $48363e98f0ab8dcb$export$76d90c956114f2c2 = (times, initial, iterate)=>{
    let result = initial;
    while(times--)result = iterate(result);
    return result;
};
/* eslint-enable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ const $48363e98f0ab8dcb$export$6b75200e58bc97d0 = (array)=>[
        ...new Set(array)
    ];
/**
 * Deduplicate an array of objects by a specific key.
 *
 * @param array The array of objects to deduplicate.
 * @param key The key to deduplicate by.
 * @example
 * const array = [{ id: 1, name: 'John' }, { id: 2, name: 'Doe' }, { id: 1, name: 'John' }];
 * deduplicateByKey(array, 'id');
 * // Output: [{ id: 1, name: 'John' }, { id: 2, name: 'Doe' }]
 */ const $48363e98f0ab8dcb$export$863d7151f7b1a894 = (array, key)=>[
        ...new Map(array.map((item)=>[
                item[key],
                item
            ])).values()
    ];

});

parcelRequire.register("9pAQx", function(module, exports) {

$parcel$export(module.exports, "assert", function () { return $6da307c744a82e4a$export$a7a9523472993e97; });
// https://github.com/facebook/jest/issues/7547
const $6da307c744a82e4a$export$a7a9523472993e97 = (value, error)=>{
    if (!value) // https://github.com/typescript-eslint/typescript-eslint/issues/3814
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw error;
};

});

parcelRequire.register("hRw8F", function(module, exports) {

$parcel$export(module.exports, "isSameArray", function () { return $d0105104f132eb9b$export$12dc7a11e2f7584e; });
$parcel$export(module.exports, "notFalsy", function () { return $d0105104f132eb9b$export$ccb441c9c5feb3fc; });
// eslint-disable-next-line id-length
const $d0105104f132eb9b$var$compareFunction = (a, b)=>{
    if (typeof a === "string" && typeof b === "string") return a.localeCompare(b);
    if (typeof a === "number" && typeof b === "number") return a - b;
    if (typeof a === "boolean" && typeof b === "boolean") return Number(a) - Number(b);
    throw new Error("Unsupported compare type");
};
const $d0105104f132eb9b$export$12dc7a11e2f7584e = (array1, array2)=>{
    if (array1.length !== array2.length) return false;
    const sortedA = array1.slice().sort($d0105104f132eb9b$var$compareFunction);
    const sortedB = array2.slice().sort($d0105104f132eb9b$var$compareFunction);
    return sortedA.every((value, index)=>value === sortedB[index]);
};
// eslint-disable-next-line unicorn/prefer-native-coercion-functions
const $d0105104f132eb9b$export$ccb441c9c5feb3fc = (value)=>Boolean(value);
const $d0105104f132eb9b$export$b29ea735dcfba3c1 = (value)=>value !== null && value !== undefined;
const $d0105104f132eb9b$export$a4f4bb6b1453fff5 = (data, property)=>Object.prototype.hasOwnProperty.call(data, property);
const $d0105104f132eb9b$export$fb789885f1f64dd7 = (string)=>Boolean(/[\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF]/.test(string));
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ // eslint-disable-next-line @typescript-eslint/ban-types -- this is a utility function
const $d0105104f132eb9b$var$isObject = (object)=>Object.prototype.toString.call(object) === "[object Object]";
/** Returns true if an object was created by the `Object` constructor, or `Object.create(null)`. */ function $d0105104f132eb9b$export$53b83ca8eaab0383(object) {
    if (!$d0105104f132eb9b$var$isObject(object)) return false;
    // If has modified constructor
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (object.constructor === undefined) return true;
    // If has modified prototype
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, prefer-destructuring
    const prototype = object.constructor.prototype;
    if (!$d0105104f132eb9b$var$isObject(prototype)) return false;
    // If constructor does not have an Object-specific method
    if (!$d0105104f132eb9b$export$a4f4bb6b1453fff5(prototype, "isPrototypeOf")) return false;
    // Most likely a plain Object
    return true;
}

});

parcelRequire.register("7oDSS", function(module, exports) {

$parcel$export(module.exports, "conditional", function () { return $5629b6792d75feeb$export$c327da55a124987a; });
$parcel$export(module.exports, "cond", function () { return $5629b6792d75feeb$export$7ffafceb12143143; });
$parcel$export(module.exports, "conditionalString", function () { return $5629b6792d75feeb$export$78aa88a01782ee9d; });
$parcel$export(module.exports, "condString", function () { return $5629b6792d75feeb$export$723fe479c809eebc; });
$parcel$export(module.exports, "conditionalArray", function () { return $5629b6792d75feeb$export$c96eff0e57d59a5e; });
$parcel$export(module.exports, "condArray", function () { return $5629b6792d75feeb$export$68c43792fed28aa6; });

var $hRw8F = parcelRequire("hRw8F");
const $5629b6792d75feeb$export$133fc36489ac9add = (exp)=>(0, $hRw8F.notFalsy)(exp) ? exp : null;
/**
 * Conditional return the expression result when it's not {@link Falsy};
 * otherwise return `undefined`.
 *
 * @example
 * ```ts
 * conditional(1 && '2') // '2'
 * conditional(false && '1') // undefined
 * ```
 */ const $5629b6792d75feeb$export$c327da55a124987a = (exp)=>(0, $hRw8F.notFalsy)(exp) ? exp : undefined;
/** Alias for {@link conditional}. */ const $5629b6792d75feeb$export$7ffafceb12143143 = $5629b6792d75feeb$export$c327da55a124987a;
/**
 * Conditional return the stringified expression result (using `String`) when it's not {@link Falsy};
 * otherwise return an empty string.
 *
 * @example
 * ```ts
 * conditionalString(1 && 2) // '2'
 * conditionalString(false && '1') // ''
 * ```
 */ const $5629b6792d75feeb$export$78aa88a01782ee9d = (exp)=>(0, $hRw8F.notFalsy)(exp) ? String(exp) : "";
/** Alias for {@link conditionalString}. */ const $5629b6792d75feeb$export$723fe479c809eebc = $5629b6792d75feeb$export$78aa88a01782ee9d;
/**
 * Conditional concat multiple expression results into a array by filtering all {@link Falsy} results
 * and flatten 1 level deep if the expression result is an array.
 *
 * @example
 * ```ts
 * conditionalArray(1, [2, 3]) // [1, 2, 3]
 * ```
 */ const $5629b6792d75feeb$export$c96eff0e57d59a5e = (...exps)=>exps.filter((value)=>(0, $hRw8F.notFalsy)(value)).flat();
/** Alias for {@link conditionalArray}. */ const $5629b6792d75feeb$export$68c43792fed28aa6 = $5629b6792d75feeb$export$c96eff0e57d59a5e;
/**
 * Return a new object with all {@link Falsy} values removed.
 * This function only performs a shallow removal, i.e. it does not remove
 * {@link Falsy} values nested in objects.
 *
 * @example
 * ```ts
 * conditionalObject({
 *   foo: 'foo',
 *   bar: undefined,
 *   baz: false,
 * }) // { foo: 'foo' }
 * ```
 */ const $5629b6792d75feeb$export$6d93be478c042166 = (object)=>// eslint-disable-next-line no-restricted-syntax
    Object.fromEntries(Object.entries(object).filter(([, value])=>(0, $hRw8F.notFalsy)(value)));
/** Alias for {@link conditionalObject}. */ const $5629b6792d75feeb$export$48ab0026c89e64fa = $5629b6792d75feeb$export$6d93be478c042166;

});

parcelRequire.register("hXtmV", function(module, exports) {

var $9pAQx = parcelRequire("9pAQx");

var $9fi9T = parcelRequire("9fi9T");
// Browsers don't have `process`
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
const $d12eba609de68c1b$export$4bd44a2aa29d3d6e = (key, fallback = "")=>$9fi9T?.env[key] ?? fallback;
const $d12eba609de68c1b$export$912b126b3b8a9cf1 = (envKey, fallback = [])=>{
    const rawValue = $d12eba609de68c1b$export$4bd44a2aa29d3d6e(envKey);
    if (!rawValue) return fallback;
    return rawValue.split(",").map((value)=>value.trim()).filter(Boolean);
};
const $d12eba609de68c1b$export$9f11f28d727ba39d = (key)=>{
    // Browsers don't have `process`
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const value = $9fi9T?.env[key];
    (0, $9pAQx.assert)(value, new Error(`env variable ${key} not found`));
    return value;
};
const $d12eba609de68c1b$export$8ee0fc9ee280b4ee = ()=>typeof window === "undefined";

});
parcelRequire.register("9fi9T", function(module, exports) {
// shim for using process in browser
var $6bb399a8ed68ad7f$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $6bb399a8ed68ad7f$var$cachedSetTimeout;
var $6bb399a8ed68ad7f$var$cachedClearTimeout;
function $6bb399a8ed68ad7f$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $6bb399a8ed68ad7f$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $6bb399a8ed68ad7f$var$cachedSetTimeout = setTimeout;
        else $6bb399a8ed68ad7f$var$cachedSetTimeout = $6bb399a8ed68ad7f$var$defaultSetTimout;
    } catch (e) {
        $6bb399a8ed68ad7f$var$cachedSetTimeout = $6bb399a8ed68ad7f$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $6bb399a8ed68ad7f$var$cachedClearTimeout = clearTimeout;
        else $6bb399a8ed68ad7f$var$cachedClearTimeout = $6bb399a8ed68ad7f$var$defaultClearTimeout;
    } catch (e) {
        $6bb399a8ed68ad7f$var$cachedClearTimeout = $6bb399a8ed68ad7f$var$defaultClearTimeout;
    }
})();
function $6bb399a8ed68ad7f$var$runTimeout(fun) {
    if ($6bb399a8ed68ad7f$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($6bb399a8ed68ad7f$var$cachedSetTimeout === $6bb399a8ed68ad7f$var$defaultSetTimout || !$6bb399a8ed68ad7f$var$cachedSetTimeout) && setTimeout) {
        $6bb399a8ed68ad7f$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $6bb399a8ed68ad7f$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $6bb399a8ed68ad7f$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $6bb399a8ed68ad7f$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $6bb399a8ed68ad7f$var$runClearTimeout(marker) {
    if ($6bb399a8ed68ad7f$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($6bb399a8ed68ad7f$var$cachedClearTimeout === $6bb399a8ed68ad7f$var$defaultClearTimeout || !$6bb399a8ed68ad7f$var$cachedClearTimeout) && clearTimeout) {
        $6bb399a8ed68ad7f$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $6bb399a8ed68ad7f$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $6bb399a8ed68ad7f$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $6bb399a8ed68ad7f$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $6bb399a8ed68ad7f$var$queue = [];
var $6bb399a8ed68ad7f$var$draining = false;
var $6bb399a8ed68ad7f$var$currentQueue;
var $6bb399a8ed68ad7f$var$queueIndex = -1;
function $6bb399a8ed68ad7f$var$cleanUpNextTick() {
    if (!$6bb399a8ed68ad7f$var$draining || !$6bb399a8ed68ad7f$var$currentQueue) return;
    $6bb399a8ed68ad7f$var$draining = false;
    if ($6bb399a8ed68ad7f$var$currentQueue.length) $6bb399a8ed68ad7f$var$queue = $6bb399a8ed68ad7f$var$currentQueue.concat($6bb399a8ed68ad7f$var$queue);
    else $6bb399a8ed68ad7f$var$queueIndex = -1;
    if ($6bb399a8ed68ad7f$var$queue.length) $6bb399a8ed68ad7f$var$drainQueue();
}
function $6bb399a8ed68ad7f$var$drainQueue() {
    if ($6bb399a8ed68ad7f$var$draining) return;
    var timeout = $6bb399a8ed68ad7f$var$runTimeout($6bb399a8ed68ad7f$var$cleanUpNextTick);
    $6bb399a8ed68ad7f$var$draining = true;
    var len = $6bb399a8ed68ad7f$var$queue.length;
    while(len){
        $6bb399a8ed68ad7f$var$currentQueue = $6bb399a8ed68ad7f$var$queue;
        $6bb399a8ed68ad7f$var$queue = [];
        while(++$6bb399a8ed68ad7f$var$queueIndex < len)if ($6bb399a8ed68ad7f$var$currentQueue) $6bb399a8ed68ad7f$var$currentQueue[$6bb399a8ed68ad7f$var$queueIndex].run();
        $6bb399a8ed68ad7f$var$queueIndex = -1;
        len = $6bb399a8ed68ad7f$var$queue.length;
    }
    $6bb399a8ed68ad7f$var$currentQueue = null;
    $6bb399a8ed68ad7f$var$draining = false;
    $6bb399a8ed68ad7f$var$runClearTimeout(timeout);
}
$6bb399a8ed68ad7f$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $6bb399a8ed68ad7f$var$queue.push(new $6bb399a8ed68ad7f$var$Item(fun, args));
    if ($6bb399a8ed68ad7f$var$queue.length === 1 && !$6bb399a8ed68ad7f$var$draining) $6bb399a8ed68ad7f$var$runTimeout($6bb399a8ed68ad7f$var$drainQueue);
};
// v8 likes predictible objects
function $6bb399a8ed68ad7f$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$6bb399a8ed68ad7f$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$6bb399a8ed68ad7f$var$process.title = "browser";
$6bb399a8ed68ad7f$var$process.browser = true;
$6bb399a8ed68ad7f$var$process.env = {};
$6bb399a8ed68ad7f$var$process.argv = [];
$6bb399a8ed68ad7f$var$process.version = ""; // empty string to avoid regexp issues
$6bb399a8ed68ad7f$var$process.versions = {};
function $6bb399a8ed68ad7f$var$noop() {}
$6bb399a8ed68ad7f$var$process.on = $6bb399a8ed68ad7f$var$noop;
$6bb399a8ed68ad7f$var$process.addListener = $6bb399a8ed68ad7f$var$noop;
$6bb399a8ed68ad7f$var$process.once = $6bb399a8ed68ad7f$var$noop;
$6bb399a8ed68ad7f$var$process.off = $6bb399a8ed68ad7f$var$noop;
$6bb399a8ed68ad7f$var$process.removeListener = $6bb399a8ed68ad7f$var$noop;
$6bb399a8ed68ad7f$var$process.removeAllListeners = $6bb399a8ed68ad7f$var$noop;
$6bb399a8ed68ad7f$var$process.emit = $6bb399a8ed68ad7f$var$noop;
$6bb399a8ed68ad7f$var$process.prependListener = $6bb399a8ed68ad7f$var$noop;
$6bb399a8ed68ad7f$var$process.prependOnceListener = $6bb399a8ed68ad7f$var$noop;
$6bb399a8ed68ad7f$var$process.listeners = function(name) {
    return [];
};
$6bb399a8ed68ad7f$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$6bb399a8ed68ad7f$var$process.cwd = function() {
    return "/";
};
$6bb399a8ed68ad7f$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$6bb399a8ed68ad7f$var$process.umask = function() {
    return 0;
};

});


parcelRequire.register("3dBAh", function(module, exports) {

$parcel$export(module.exports, "noop", function () { return $257fbd66c1e0ce6d$export$8793edee2d425525; });
$parcel$export(module.exports, "trySafe", function () { return $257fbd66c1e0ce6d$export$a3a27526e073307; });
// Intended
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $257fbd66c1e0ce6d$export$8793edee2d425525 = ()=>{};
const $257fbd66c1e0ce6d$export$4369c812aac99591 = (value)=>value !== null && (typeof value === "object" || typeof value === "function") && "then" in value && typeof value.then === "function";
// eslint-disable-next-line @typescript-eslint/promise-function-async
const $257fbd66c1e0ce6d$export$2cb2cb98cc670b59 = (exec, onError)=>{
    const handleError = (error)=>{
        if (onError instanceof Error) throw onError;
        return onError(error);
    };
    try {
        const unwrapped = typeof exec === "function" ? exec() : exec;
        // eslint-disable-next-line promise/prefer-await-to-then
        return $257fbd66c1e0ce6d$export$4369c812aac99591(unwrapped) ? unwrapped.catch(handleError) : unwrapped;
    } catch (error) {
        return handleError(error);
    }
};
// eslint-disable-next-line @typescript-eslint/promise-function-async
const $257fbd66c1e0ce6d$export$a3a27526e073307 = (exec, onError)=>{
    try {
        const unwrapped = typeof exec === "function" ? exec() : exec;
        return $257fbd66c1e0ce6d$export$4369c812aac99591(unwrapped) ? unwrapped.catch((error)=>{
            onError?.(error);
        }) : unwrapped;
    } catch (error) {
        onError?.(error);
    }
};

});

parcelRequire.register("iS4bq", function(module, exports) {

$parcel$export(module.exports, "pick", function () { return $dbd083d419cfe344$export$357523c63a2253b9; });
const $dbd083d419cfe344$export$357523c63a2253b9 = (object, ...keys)=>{
    // eslint-disable-next-line no-restricted-syntax
    return Object.fromEntries(keys.map((key)=>[
            key,
            object[key]
        ]));
};
const $dbd083d419cfe344$export$42fd73f889ee4d63 = (...keys)=>(state)=>$dbd083d419cfe344$export$357523c63a2253b9(state, ...keys);

});

parcelRequire.register("l0I3U", function(module, exports) {

$parcel$export(module.exports, "urlSafeBase64", function () { return $f4bbc6e24cbb719b$export$cf6f352aaefa956f; });
$parcel$export(module.exports, "yes", function () { return $f4bbc6e24cbb719b$export$7a668e70ea2210d9; });
function $f4bbc6e24cbb719b$export$1294308be85b4eca(string) {
    if (typeof string !== "string") throw new TypeError("Expected a string");
    return string.toLowerCase().replaceAll(/(?:^|\s|-)\S/g, (value)=>value.toUpperCase()).replaceAll("-", " ");
}
/**
 * RFC 4648 section 5: base64url (URL- and filename-safe standard)
 * @link https://datatracker.ietf.org/doc/html/rfc4648#section-5
 */ const $f4bbc6e24cbb719b$var$replaceNonUrlSafeCharacters = (base64String)=>base64String.replaceAll("+", "-").replaceAll("/", "_").replaceAll(/=+$/g, "");
const $f4bbc6e24cbb719b$var$restoreNonUrlSafeCharacters = (base64String)=>base64String.replaceAll("-", "+").replaceAll("_", "/");
const $f4bbc6e24cbb719b$export$cf6f352aaefa956f = {
    isSafe: (input)=>/^[\w-]*$/.test(input),
    encode: (rawString)=>{
        const encodedString = btoa(unescape(encodeURIComponent(rawString)));
        return $f4bbc6e24cbb719b$var$replaceNonUrlSafeCharacters(encodedString);
    },
    decode: (encodedString)=>{
        const nonUrlSafeEncodedString = $f4bbc6e24cbb719b$var$restoreNonUrlSafeCharacters(encodedString);
        return decodeURIComponent(escape(atob(nonUrlSafeEncodedString)));
    },
    replaceNonUrlSafeCharacters: $f4bbc6e24cbb719b$var$replaceNonUrlSafeCharacters,
    restoreNonUrlSafeCharacters: $f4bbc6e24cbb719b$var$restoreNonUrlSafeCharacters
};
const $f4bbc6e24cbb719b$export$7a668e70ea2210d9 = (value)=>// eslint-disable-next-line no-implicit-coercion
    !!value && [
        "1",
        "true",
        "y",
        "yes",
        "yep",
        "yeah"
    ].includes(value.toLowerCase());

});

parcelRequire.register("7Pi8O", function(module, exports) {

$parcel$export(module.exports, "getSafe", function () { return $5b2b5e40e85a1ef9$export$fedb900c0ea4e699; });

var $3dBAh = parcelRequire("3dBAh");
const $5b2b5e40e85a1ef9$export$3988ae62b71be9a3 = (object, keySerial)=>{
    if (object === null || typeof object !== "object") throw new TypeError("Non-object received in `get()`.");
    let result = object;
    for (const key of keySerial.split("."))// @ts-expect-error for performance
    result = result[key];
    return result;
};
const $5b2b5e40e85a1ef9$export$fedb900c0ea4e699 = (...args)=>(0, $3dBAh.trySafe)(()=>$5b2b5e40e85a1ef9$export$3988ae62b71be9a3(...args));
/** Same to `get()` but with the strict type definition only to enable IntelliSense. */ const $5b2b5e40e85a1ef9$export$bf7199a9ebcb84a9 = (object, keySerial)=>$5b2b5e40e85a1ef9$export$3988ae62b71be9a3(object, keySerial);

});

parcelRequire.register("gcHb7", function(module, exports) {

$parcel$export(module.exports, "joinPath", function () { return $bcbf42a7598844dd$export$b891921babc70093; });
$parcel$export(module.exports, "appendPath", function () { return $bcbf42a7598844dd$export$c3cef1c0537c0eb2; });
/** Join multiple path segments. This function exists since there's no native implementation in browser. */ const $bcbf42a7598844dd$export$b891921babc70093 = (...segments)=>{
    const result = [];
    for (const segment of segments.join("/").split("/")){
        if (!segment || segment === ".") continue;
        if ([
            ...segment
        ].every((char)=>char === ".")) {
            // eslint-disable-next-line @silverhand/fp/no-mutating-methods
            result.pop();
            continue;
        }
        // eslint-disable-next-line @silverhand/fp/no-mutating-methods
        result.push(segment);
    }
    return "/" + result.join("/");
};
/** Append path segments to the base URL. */ const $bcbf42a7598844dd$export$c3cef1c0537c0eb2 = (baseUrl, ...pathnames)=>new URL($bcbf42a7598844dd$export$b891921babc70093(baseUrl.pathname, ...pathnames), baseUrl);

});

parcelRequire.register("jMfTG", function(module, exports) {

$parcel$export(module.exports, "isKeyInObject", function () { return $e65ed4ddc1bcd4f6$export$dd89c3a817f05bc7; });
// eslint-disable-next-line @typescript-eslint/ban-types
const $e65ed4ddc1bcd4f6$export$a6cdc56e425d0d0a = (object)=>object !== null && typeof object === "object";
const $e65ed4ddc1bcd4f6$export$dd89c3a817f05bc7 = (object, key)=>$e65ed4ddc1bcd4f6$export$a6cdc56e425d0d0a(object) && key in object;
/**
 * Remove all keys with `undefined` values from an object. This function only
 * performs a shallow removal, i.e. it does not remove `undefined` values nested
 * in objects.
 *
 * @param object The object to remove `undefined` keys from.
 * @returns A new object with all `undefined` keys removed.
 */ // eslint-disable-next-line @typescript-eslint/ban-types -- this is a utility function
const $e65ed4ddc1bcd4f6$export$8e7457d724841712 = (object)=>// eslint-disable-next-line no-restricted-syntax
    Object.fromEntries(Object.entries(object).filter(([, value])=>value !== undefined));

});

parcelRequire.register("2rO6k", function(module, exports) {
/* eslint-disable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ function $1c84f76a384994bc$export$d2de3aaeafa91619(function_) {
    let called = false;
    let result;
    return function(...args) {
        if (!called) {
            called = true;
            result = function_.apply(this, args);
        }
        return result;
    };
}

});



parcelRequire.register("jlYYu", function(module, exports) {
const $e16f46c537fc272c$export$dd89c3a817f05bc7 = (object, key)=>object !== null && typeof object === "object" && key in object;

});

parcelRequire.register("51A9u", function(module, exports) {

$parcel$export(module.exports, "parsePhoneNumber", function () { return $3a8916cd2f7d2116$export$da44e4eaa54bc82e; });
$parcel$export(module.exports, "formatToInternationalPhoneNumber", function () { return $3a8916cd2f7d2116$export$d79b62bd58081ca4; });

var $bJ3GU = parcelRequire("bJ3GU");
const $3a8916cd2f7d2116$export$da44e4eaa54bc82e = (phone)=>{
    try {
        return (0, $bJ3GU.parsePhoneNumberWithError)(phone).number.slice(1);
    } catch  {
        console.error(`Invalid phone number: ${phone}`);
        return phone;
    }
};
const $3a8916cd2f7d2116$export$d79b62bd58081ca4 = (phone)=>{
    try {
        const phoneNumber = phone.startsWith("+") ? phone : `+${phone}`;
        return (0, $bJ3GU.parsePhoneNumberWithError)(phoneNumber).formatInternational();
    } catch  {
        console.error(`Invalid phone number: ${phone}`);
        return phone;
    }
};

});
parcelRequire.register("bJ3GU", function(module, exports) {

$parcel$export(module.exports, "parsePhoneNumberWithError", function () { return $8896c2a226dcbaab$export$176bb591929cc9a8; });

var $8gbLp = parcelRequire("8gbLp");

var $5uVQp = parcelRequire("5uVQp");
function $8896c2a226dcbaab$export$176bb591929cc9a8() {
    return (0, $8gbLp.default)((0, $5uVQp.default), arguments);
}

});
parcelRequire.register("8gbLp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6038f15ab9907e69$export$2e2bcd8739ae039; });
// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.

var $9PRWN = parcelRequire("9PRWN");
function $6038f15ab9907e69$export$2e2bcd8739ae039(func, _arguments) {
    var args = Array.prototype.slice.call(_arguments);
    args.push((0, $9PRWN.default));
    return func.apply(this, args);
}

});
parcelRequire.register("9PRWN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01d9138139a5e108$export$2e2bcd8739ae039; });
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var $01d9138139a5e108$export$2e2bcd8739ae039 = {
    "version": 4,
    "country_calling_codes": {
        "1": [
            "US",
            "AG",
            "AI",
            "AS",
            "BB",
            "BM",
            "BS",
            "CA",
            "DM",
            "DO",
            "GD",
            "GU",
            "JM",
            "KN",
            "KY",
            "LC",
            "MP",
            "MS",
            "PR",
            "SX",
            "TC",
            "TT",
            "VC",
            "VG",
            "VI"
        ],
        "7": [
            "RU",
            "KZ"
        ],
        "20": [
            "EG"
        ],
        "27": [
            "ZA"
        ],
        "30": [
            "GR"
        ],
        "31": [
            "NL"
        ],
        "32": [
            "BE"
        ],
        "33": [
            "FR"
        ],
        "34": [
            "ES"
        ],
        "36": [
            "HU"
        ],
        "39": [
            "IT",
            "VA"
        ],
        "40": [
            "RO"
        ],
        "41": [
            "CH"
        ],
        "43": [
            "AT"
        ],
        "44": [
            "GB",
            "GG",
            "IM",
            "JE"
        ],
        "45": [
            "DK"
        ],
        "46": [
            "SE"
        ],
        "47": [
            "NO",
            "SJ"
        ],
        "48": [
            "PL"
        ],
        "49": [
            "DE"
        ],
        "51": [
            "PE"
        ],
        "52": [
            "MX"
        ],
        "53": [
            "CU"
        ],
        "54": [
            "AR"
        ],
        "55": [
            "BR"
        ],
        "56": [
            "CL"
        ],
        "57": [
            "CO"
        ],
        "58": [
            "VE"
        ],
        "60": [
            "MY"
        ],
        "61": [
            "AU",
            "CC",
            "CX"
        ],
        "62": [
            "ID"
        ],
        "63": [
            "PH"
        ],
        "64": [
            "NZ"
        ],
        "65": [
            "SG"
        ],
        "66": [
            "TH"
        ],
        "81": [
            "JP"
        ],
        "82": [
            "KR"
        ],
        "84": [
            "VN"
        ],
        "86": [
            "CN"
        ],
        "90": [
            "TR"
        ],
        "91": [
            "IN"
        ],
        "92": [
            "PK"
        ],
        "93": [
            "AF"
        ],
        "94": [
            "LK"
        ],
        "95": [
            "MM"
        ],
        "98": [
            "IR"
        ],
        "211": [
            "SS"
        ],
        "212": [
            "MA",
            "EH"
        ],
        "213": [
            "DZ"
        ],
        "216": [
            "TN"
        ],
        "218": [
            "LY"
        ],
        "220": [
            "GM"
        ],
        "221": [
            "SN"
        ],
        "222": [
            "MR"
        ],
        "223": [
            "ML"
        ],
        "224": [
            "GN"
        ],
        "225": [
            "CI"
        ],
        "226": [
            "BF"
        ],
        "227": [
            "NE"
        ],
        "228": [
            "TG"
        ],
        "229": [
            "BJ"
        ],
        "230": [
            "MU"
        ],
        "231": [
            "LR"
        ],
        "232": [
            "SL"
        ],
        "233": [
            "GH"
        ],
        "234": [
            "NG"
        ],
        "235": [
            "TD"
        ],
        "236": [
            "CF"
        ],
        "237": [
            "CM"
        ],
        "238": [
            "CV"
        ],
        "239": [
            "ST"
        ],
        "240": [
            "GQ"
        ],
        "241": [
            "GA"
        ],
        "242": [
            "CG"
        ],
        "243": [
            "CD"
        ],
        "244": [
            "AO"
        ],
        "245": [
            "GW"
        ],
        "246": [
            "IO"
        ],
        "247": [
            "AC"
        ],
        "248": [
            "SC"
        ],
        "249": [
            "SD"
        ],
        "250": [
            "RW"
        ],
        "251": [
            "ET"
        ],
        "252": [
            "SO"
        ],
        "253": [
            "DJ"
        ],
        "254": [
            "KE"
        ],
        "255": [
            "TZ"
        ],
        "256": [
            "UG"
        ],
        "257": [
            "BI"
        ],
        "258": [
            "MZ"
        ],
        "260": [
            "ZM"
        ],
        "261": [
            "MG"
        ],
        "262": [
            "RE",
            "YT"
        ],
        "263": [
            "ZW"
        ],
        "264": [
            "NA"
        ],
        "265": [
            "MW"
        ],
        "266": [
            "LS"
        ],
        "267": [
            "BW"
        ],
        "268": [
            "SZ"
        ],
        "269": [
            "KM"
        ],
        "290": [
            "SH",
            "TA"
        ],
        "291": [
            "ER"
        ],
        "297": [
            "AW"
        ],
        "298": [
            "FO"
        ],
        "299": [
            "GL"
        ],
        "350": [
            "GI"
        ],
        "351": [
            "PT"
        ],
        "352": [
            "LU"
        ],
        "353": [
            "IE"
        ],
        "354": [
            "IS"
        ],
        "355": [
            "AL"
        ],
        "356": [
            "MT"
        ],
        "357": [
            "CY"
        ],
        "358": [
            "FI",
            "AX"
        ],
        "359": [
            "BG"
        ],
        "370": [
            "LT"
        ],
        "371": [
            "LV"
        ],
        "372": [
            "EE"
        ],
        "373": [
            "MD"
        ],
        "374": [
            "AM"
        ],
        "375": [
            "BY"
        ],
        "376": [
            "AD"
        ],
        "377": [
            "MC"
        ],
        "378": [
            "SM"
        ],
        "380": [
            "UA"
        ],
        "381": [
            "RS"
        ],
        "382": [
            "ME"
        ],
        "383": [
            "XK"
        ],
        "385": [
            "HR"
        ],
        "386": [
            "SI"
        ],
        "387": [
            "BA"
        ],
        "389": [
            "MK"
        ],
        "420": [
            "CZ"
        ],
        "421": [
            "SK"
        ],
        "423": [
            "LI"
        ],
        "500": [
            "FK"
        ],
        "501": [
            "BZ"
        ],
        "502": [
            "GT"
        ],
        "503": [
            "SV"
        ],
        "504": [
            "HN"
        ],
        "505": [
            "NI"
        ],
        "506": [
            "CR"
        ],
        "507": [
            "PA"
        ],
        "508": [
            "PM"
        ],
        "509": [
            "HT"
        ],
        "590": [
            "GP",
            "BL",
            "MF"
        ],
        "591": [
            "BO"
        ],
        "592": [
            "GY"
        ],
        "593": [
            "EC"
        ],
        "594": [
            "GF"
        ],
        "595": [
            "PY"
        ],
        "596": [
            "MQ"
        ],
        "597": [
            "SR"
        ],
        "598": [
            "UY"
        ],
        "599": [
            "CW",
            "BQ"
        ],
        "670": [
            "TL"
        ],
        "672": [
            "NF"
        ],
        "673": [
            "BN"
        ],
        "674": [
            "NR"
        ],
        "675": [
            "PG"
        ],
        "676": [
            "TO"
        ],
        "677": [
            "SB"
        ],
        "678": [
            "VU"
        ],
        "679": [
            "FJ"
        ],
        "680": [
            "PW"
        ],
        "681": [
            "WF"
        ],
        "682": [
            "CK"
        ],
        "683": [
            "NU"
        ],
        "685": [
            "WS"
        ],
        "686": [
            "KI"
        ],
        "687": [
            "NC"
        ],
        "688": [
            "TV"
        ],
        "689": [
            "PF"
        ],
        "690": [
            "TK"
        ],
        "691": [
            "FM"
        ],
        "692": [
            "MH"
        ],
        "850": [
            "KP"
        ],
        "852": [
            "HK"
        ],
        "853": [
            "MO"
        ],
        "855": [
            "KH"
        ],
        "856": [
            "LA"
        ],
        "880": [
            "BD"
        ],
        "886": [
            "TW"
        ],
        "960": [
            "MV"
        ],
        "961": [
            "LB"
        ],
        "962": [
            "JO"
        ],
        "963": [
            "SY"
        ],
        "964": [
            "IQ"
        ],
        "965": [
            "KW"
        ],
        "966": [
            "SA"
        ],
        "967": [
            "YE"
        ],
        "968": [
            "OM"
        ],
        "970": [
            "PS"
        ],
        "971": [
            "AE"
        ],
        "972": [
            "IL"
        ],
        "973": [
            "BH"
        ],
        "974": [
            "QA"
        ],
        "975": [
            "BT"
        ],
        "976": [
            "MN"
        ],
        "977": [
            "NP"
        ],
        "992": [
            "TJ"
        ],
        "993": [
            "TM"
        ],
        "994": [
            "AZ"
        ],
        "995": [
            "GE"
        ],
        "996": [
            "KG"
        ],
        "998": [
            "UZ"
        ]
    },
    "countries": {
        "AC": [
            "247",
            "00",
            "(?:[01589]\\d|[46])\\d{4}",
            [
                5,
                6
            ]
        ],
        "AD": [
            "376",
            "00",
            "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[135-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ]
        ],
        "AE": [
            "971",
            "00",
            "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{2,9})",
                    "$1 $2",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[236]|[479][2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[479]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AF": [
            "93",
            "00",
            "[2-7]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AG": [
            "1",
            "011",
            "(?:268|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([457]\\d{6})$|1",
            "268$1",
            0,
            "268"
        ],
        "AI": [
            "1",
            "011",
            "(?:264|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2457]\\d{6})$|1",
            "264$1",
            0,
            "264"
        ],
        "AL": [
            "355",
            "00",
            "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "80|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2358][2-5]|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AM": [
            "374",
            "00",
            "(?:[1-489]\\d|55|60|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2|3[12]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "1|47"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[3-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AO": [
            "244",
            "00",
            "[29]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "AR": [
            "54",
            "00",
            "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                        "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[23]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9(?:2[2-469]|3[3-578])",
                        "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                        "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "91"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ]
            ],
            "0",
            0,
            "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
            "9$1"
        ],
        "AS": [
            "1",
            "011",
            "(?:[58]\\d\\d|684|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([267]\\d{6})$|1",
            "684$1",
            0,
            "684"
        ],
        "AT": [
            "43",
            "00",
            "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3,12})",
                    "$1 $2",
                    [
                        "1(?:11|[2-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})",
                    "$1 $2",
                    [
                        "517"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "5[079]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,10})",
                    "$1 $2",
                    [
                        "(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,9})",
                    "$1 $2",
                    [
                        "[2-467]|5[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,7})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AU": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "14|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2378]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:30|[89])"
                    ]
                ]
            ],
            "0",
            0,
            "(183[12])|0",
            0,
            0,
            0,
            [
                [
                    "(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "163\\d{2,6}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "AW": [
            "297",
            "00",
            "(?:[25-79]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-9]"
                    ]
                ]
            ]
        ],
        "AX": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "18",
            0,
            "00"
        ],
        "AZ": [
            "994",
            "00",
            "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[28]|2|365|46",
                        "1[28]|2|365[45]|46",
                        "1[28]|2|365(?:4|5[02])|46"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BA": [
            "387",
            "00",
            "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[1-3]|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "[3-5]|6[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BB": [
            "1",
            "011",
            "(?:246|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "246$1",
            0,
            "246"
        ],
        "BD": [
            "880",
            "00",
            "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1-$2",
                    [
                        "31[5-8]|[459]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1-$2",
                    [
                        "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,6})",
                    "$1-$2",
                    [
                        "[13-9]|22"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{7,8})",
                    "$1-$2",
                    [
                        "2"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BE": [
            "32",
            "00",
            "4\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:80|9)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[239]|4[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[15-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BF": [
            "226",
            "00",
            "[025-7]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[025-7]"
                    ]
                ]
            ]
        ],
        "BG": [
            "359",
            "00",
            "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                12
            ],
            [
                [
                    "(\\d)(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "43[1-6]|70[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:70|8)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "43[1-7]|7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[48]|9[08]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BH": [
            "973",
            "00",
            "[136-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[13679]|8[02-4679]"
                    ]
                ]
            ]
        ],
        "BI": [
            "257",
            "00",
            "(?:[267]\\d|31)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2367]"
                    ]
                ]
            ]
        ],
        "BJ": [
            "229",
            "00",
            "[24-689]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-689]"
                    ]
                ]
            ]
        ],
        "BL": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "BM": [
            "1",
            "011",
            "(?:441|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "441$1",
            0,
            "441"
        ],
        "BN": [
            "673",
            "00",
            "[2-578]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "BO": [
            "591",
            "00(?:1\\d)?",
            "(?:[2-467]\\d\\d|8001)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[23]|4[46]"
                    ]
                ],
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            "0(1\\d)?"
        ],
        "BQ": [
            "599",
            "00",
            "(?:[34]1|7\\d)\\d{5}",
            [
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[347]"
        ],
        "BR": [
            "55",
            "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
            "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "300|4(?:0[02]|37)",
                        "4(?:02|37)0|[34]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:[358]|90)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[16][1-9]|[2-57-9]"
                    ],
                    "($1)"
                ]
            ],
            "0",
            0,
            "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
            "$2"
        ],
        "BS": [
            "1",
            "011",
            "(?:242|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([3-8]\\d{6})$|1",
            "242$1",
            0,
            "242"
        ],
        "BT": [
            "975",
            "00",
            "[17]\\d{7}|[2-8]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-68]|7[246]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[67]|7"
                    ]
                ]
            ]
        ],
        "BW": [
            "267",
            "00",
            "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-6]|3[15-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "BY": [
            "375",
            "810",
            "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                        "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "1(?:[56]|7[467])|2[1-3]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-4]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            "0|80?",
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "BZ": [
            "501",
            "00",
            "(?:0800\\d|[2-8])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CA": [
            "1",
            "011",
            "(?:[2-8]\\d|90)\\d{8}|3\\d{6}",
            [
                7,
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "",
                    [
                        10
                    ]
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "900[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "310\\d{4}",
                    [
                        7
                    ]
                ],
                0,
                [
                    "600[2-9]\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "CC": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CD": [
            "243",
            "00",
            "[189]\\d{8}|[1-68]\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CF": [
            "236",
            "00",
            "(?:[27]\\d{3}|8776)\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[278]"
                    ]
                ]
            ]
        ],
        "CG": [
            "242",
            "00",
            "222\\d{6}|(?:0\\d|80)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02]"
                    ]
                ]
            ]
        ],
        "CH": [
            "41",
            "00",
            "8\\d{11}|[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8[047]|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]|81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CI": [
            "225",
            "00",
            "[02]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CK": [
            "682",
            "00",
            "[2-578]\\d{4}",
            [
                5
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "CL": [
            "56",
            "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
            "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
            [
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "219",
                        "2196"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[1-36]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[2-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "60"
                    ]
                ]
            ]
        ],
        "CM": [
            "237",
            "00",
            "[26]\\d{8}|88\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "88"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[26]|88"
                    ]
                ]
            ]
        ],
        "CN": [
            "86",
            "00|1(?:[12]\\d|79)\\d\\d00",
            "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5,6})",
                    "$1 $2",
                    [
                        "(?:10|2[0-57-9])[19]",
                        "(?:10|2[0-57-9])(?:10|9[56])",
                        "10(?:10|9[56])|2[0-57-9](?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:4|80)0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[3-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "[12]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            "(1(?:[12]\\d|79)\\d\\d)|0",
            0,
            0,
            0,
            0,
            "00"
        ],
        "CO": [
            "57",
            "00(?:4(?:[14]4|56)|[579])",
            "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3[0-357]|91"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{7})",
                    "$1-$2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ]
            ],
            "0",
            0,
            "0([3579]|4(?:[14]4|56))?"
        ],
        "CR": [
            "506",
            "00",
            "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[3-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            "(19(?:0[0-2468]|1[09]|20|66|77|99))"
        ],
        "CU": [
            "53",
            "119",
            "[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}",
            [
                6,
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "2[1-4]|[34]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{6,7})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CV": [
            "238",
            "0",
            "(?:[2-59]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "CW": [
            "599",
            "00",
            "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[3467]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[4-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[69]"
        ],
        "CX": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CY": [
            "357",
            "00",
            "(?:[279]\\d|[58]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[257-9]"
                    ]
                ]
            ]
        ],
        "CZ": [
            "420",
            "00",
            "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]|9[015-7]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "96"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "DE": [
            "49",
            "00",
            "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15
            ],
            [
                [
                    "(\\d{2})(\\d{3,13})",
                    "$1 $2",
                    [
                        "3[02]|40|[68]9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,12})",
                    "$1 $2",
                    [
                        "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                        "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2,11})",
                    "$1 $2",
                    [
                        "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                        "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "138"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{2,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,11})",
                    "$1 $2",
                    [
                        "181"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{4,10})",
                    "$1 $2 $3",
                    [
                        "1(?:3|80)|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,12})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "185",
                        "1850",
                        "18500"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "18[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "15[0568]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "15[1279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{8})",
                    "$1 $2",
                    [
                        "18"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{7,8})",
                    "$1 $2 $3",
                    [
                        "1(?:6[023]|7)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "15[279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{8})",
                    "$1 $2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "DJ": [
            "253",
            "00",
            "(?:2\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[27]"
                    ]
                ]
            ]
        ],
        "DK": [
            "45",
            "00",
            "[2-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "DM": [
            "1",
            "011",
            "(?:[58]\\d\\d|767|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "767$1",
            0,
            "767"
        ],
        "DO": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "8001|8[024]9"
        ],
        "DZ": [
            "213",
            "00",
            "(?:[1-4]|[5-79]\\d|80)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EC": [
            "593",
            "00",
            "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[2-7]"
                    ],
                    "(0$1)",
                    0,
                    "$1-$2-$3"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "EE": [
            "372",
            "00",
            "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                        "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[45]|8(?:00|[1-49])",
                        "[45]|8(?:00[1-9]|[1-49])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "EG": [
            "20",
            "00",
            "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{7,8})",
                    "$1 $2",
                    [
                        "[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,7})",
                    "$1 $2",
                    [
                        "1[35]|[4-6]|8[2468]|9[235-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EH": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "528[89]"
        ],
        "ER": [
            "291",
            "00",
            "[178]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[178]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ES": [
            "34",
            "00",
            "[5-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "ET": [
            "251",
            "00",
            "(?:11|[2-579]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-579]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "FI": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d)(\\d{4,9})",
                    "$1 $2",
                    [
                        "[2568][1-8]|3(?:0[1-9]|[1-9])|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[12]00|[368]|70[07-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,8})",
                    "$1 $2",
                    [
                        "[1245]|7[135]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,10})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "1[03-79]|[2-9]",
            0,
            "00"
        ],
        "FJ": [
            "679",
            "0(?:0|52)",
            "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[235-9]|45"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "FK": [
            "500",
            "00",
            "[2-7]\\d{4}",
            [
                5
            ]
        ],
        "FM": [
            "691",
            "00",
            "(?:[39]\\d\\d|820)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[389]"
                    ]
                ]
            ]
        ],
        "FO": [
            "298",
            "00",
            "[2-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(10(?:01|[12]0|88))"
        ],
        "FR": [
            "33",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[1-79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GA": [
            "241",
            "00",
            "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "11|[67]"
                    ],
                    "0$1"
                ]
            ],
            0,
            0,
            "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
            "$1"
        ],
        "GB": [
            "44",
            "00",
            "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
            [
                7,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "800",
                        "8001",
                        "80011",
                        "800111",
                        "8001111"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "845",
                        "8454",
                        "84546",
                        "845464"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "1(?:38|5[23]|69|76|94)",
                        "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                        "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "1(?:[2-69][02-9]|[78])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[25]|7(?:0|6[02-9])",
                        "[25]|7(?:0|6(?:[03-9]|2[356]))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1389]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-79])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ],
            0,
            " x"
        ],
        "GD": [
            "1",
            "011",
            "(?:473|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "473$1",
            0,
            "473"
        ],
        "GE": [
            "995",
            "00",
            "(?:[3-57]\\d\\d|800)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "32"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[348]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GF": [
            "594",
            "00",
            "[56]94\\d{6}|(?:80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[56]|9[47]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GG": [
            "44",
            "00",
            "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
            [
                7,
                9,
                10
            ],
            0,
            "0",
            0,
            "([25-9]\\d{5})$|0",
            "1481$1",
            0,
            0,
            [
                [
                    "1481[25-9]\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "GH": [
            "233",
            "00",
            "(?:[235]\\d{3}|800)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GI": [
            "350",
            "00",
            "(?:[25]\\d|60)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ]
            ]
        ],
        "GL": [
            "299",
            "00",
            "(?:19|[2-689]\\d|70)\\d{4}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "19|[2-9]"
                    ]
                ]
            ]
        ],
        "GM": [
            "220",
            "00",
            "[2-9]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "GN": [
            "224",
            "00",
            "722\\d{6}|(?:3|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[67]"
                    ]
                ]
            ]
        ],
        "GP": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "GQ": [
            "240",
            "00",
            "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "GR": [
            "30",
            "00",
            "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
            [
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21|7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2689]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "GT": [
            "502",
            "00",
            "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "GU": [
            "1",
            "011",
            "(?:[58]\\d\\d|671|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "671$1",
            0,
            "671"
        ],
        "GW": [
            "245",
            "00",
            "[49]\\d{8}|4\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "40"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ]
                ]
            ]
        ],
        "GY": [
            "592",
            "001",
            "(?:[2-8]\\d{3}|9008)\\d{3}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "HK": [
            "852",
            "00(?:30|5[09]|[126-9]?)",
            "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{2,5})",
                    "$1 $2",
                    [
                        "900",
                        "9003"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "HN": [
            "504",
            "00",
            "8\\d{10}|[237-9]\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[237-9]"
                    ]
                ]
            ]
        ],
        "HR": [
            "385",
            "00",
            "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "6[01]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "HT": [
            "509",
            "00",
            "(?:[2-489]\\d|55)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "HU": [
            "36",
            "00",
            "[235-7]\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "06 $1"
                ]
            ],
            "06"
        ],
        "ID": [
            "62",
            "00[89]",
            "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "15"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,9})",
                    "$1 $2",
                    [
                        "2[124]|[36]1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,7})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,8})",
                    "$1 $2",
                    [
                        "[2-79]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "8[1-35-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6,8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "804"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IE": [
            "353",
            "00",
            "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "2[24-9]|47|58|6[237-9]|9[35-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[45]0"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2569]|4[1-69]|7[14]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IL": [
            "972",
            "0(?:0|1[2-9])",
            "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1-$2",
                    [
                        "125"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "121"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "12"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1-$2",
                    [
                        "159"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "1[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1-$2 $3-$4",
                    [
                        "15"
                    ]
                ]
            ],
            "0"
        ],
        "IM": [
            "44",
            "00",
            "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([25-8]\\d{5})$|0",
            "1624$1",
            0,
            "74576|(?:16|7[56])24"
        ],
        "IN": [
            "91",
            "00",
            "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
            [
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "5(?:0|2[23]|3[03]|[67]1|88)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{4,5})",
                    "$1 $2",
                    [
                        "180",
                        "1800"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "140"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                        "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                        "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "[6-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{2,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:6|8[06])",
                        "1(?:6|8[06]0)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "18"
                    ],
                    0,
                    1
                ]
            ],
            "0"
        ],
        "IO": [
            "246",
            "00",
            "3\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "3"
                    ]
                ]
            ]
        ],
        "IQ": [
            "964",
            "00",
            "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IR": [
            "98",
            "00",
            "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
            [
                4,
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{4,5})",
                    "$1",
                    [
                        "96"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,5})",
                    "$1 $2",
                    [
                        "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IS": [
            "354",
            "00|1(?:0(?:01|[12]0)|100)",
            "(?:38\\d|[4-9])\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "IT": [
            "39",
            "00",
            "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                        "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2,6})",
                    "$1 $2",
                    [
                        "0(?:[13-579][2-46-8]|8[236-8])"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "894"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[26]|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1(?:44|[679])|[378]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[13-57-9][0159]|14"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"
                ],
                [
                    "3[1-9]\\d{8}|3[2-9]\\d{7}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "80(?:0\\d{3}|3)\\d{3}",
                    [
                        6,
                        9
                    ]
                ],
                [
                    "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                    [
                        6,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "1(?:78\\d|99)\\d{6}",
                    [
                        9,
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "55\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "84(?:[08]\\d{3}|[17])\\d{3}",
                    [
                        6,
                        9
                    ]
                ]
            ]
        ],
        "JE": [
            "44",
            "00",
            "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([0-24-8]\\d{5})$|0",
            "1534$1",
            0,
            0,
            [
                [
                    "1534[0-24-8]\\d{5}"
                ],
                [
                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"
                ],
                [
                    "80(?:07(?:35|81)|8901)\\d{4}"
                ],
                [
                    "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"
                ],
                [
                    "701511\\d{4}"
                ],
                0,
                [
                    "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"
                ],
                [
                    "56\\d{8}"
                ]
            ]
        ],
        "JM": [
            "1",
            "011",
            "(?:[58]\\d\\d|658|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "658|876"
        ],
        "JO": [
            "962",
            "00",
            "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2356]|87"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "JP": [
            "81",
            "010",
            "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
            [
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "(?:12|57|99)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]|4(?:2[09]|7[01])",
                        "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[257-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "(000[259]\\d{6})$|(?:(?:003768)0?)|0",
            "$1"
        ],
        "KE": [
            "254",
            "000",
            "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "[24-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[17]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KG": [
            "996",
            "00",
            "8\\d{9}|[235-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3(?:1[346]|[24-79])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-79]|88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KH": [
            "855",
            "00[14-9]",
            "1\\d{9}|[1-9]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "KI": [
            "686",
            "00",
            "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
            [
                5,
                8
            ],
            0,
            "0"
        ],
        "KM": [
            "269",
            "00",
            "[3478]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[3478]"
                    ]
                ]
            ]
        ],
        "KN": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "869$1",
            0,
            "869"
        ],
        "KP": [
            "850",
            "00|99",
            "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KR": [
            "82",
            "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
            "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
            [
                5,
                6,
                8,
                9,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1-$2",
                    [
                        "(?:3[1-3]|[46][1-4]|5[1-5])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[1346]|5[1-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0(8(?:[1-46-8]|5\\d\\d))?"
        ],
        "KW": [
            "965",
            "00",
            "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[169]|2(?:[235]|4[1-35-9])|52"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[245]"
                    ]
                ]
            ]
        ],
        "KY": [
            "1",
            "011",
            "(?:345|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "345$1",
            0,
            "345"
        ],
        "KZ": [
            "7",
            "810",
            "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
            [
                10,
                14
            ],
            0,
            "8",
            0,
            0,
            0,
            0,
            "33|7",
            0,
            "8~10"
        ],
        "LA": [
            "856",
            "00",
            "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2[13]|3[14]|[4-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "30[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LB": [
            "961",
            "00",
            "[27-9]\\d{7}|[13-9]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27-9]"
                    ]
                ]
            ],
            "0"
        ],
        "LC": [
            "1",
            "011",
            "(?:[58]\\d\\d|758|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-8]\\d{6})$|1",
            "758$1",
            0,
            "758"
        ],
        "LI": [
            "423",
            "00",
            "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2379]|8(?:0[09]|7)",
                        "[2379]|8(?:0(?:02|9)|7)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "69"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            "0",
            0,
            "(1001)|0"
        ],
        "LK": [
            "94",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[1-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LR": [
            "231",
            "00",
            "(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[4-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LS": [
            "266",
            "00",
            "(?:[256]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2568]"
                    ]
                ]
            ]
        ],
        "LT": [
            "370",
            "00",
            "(?:[3469]\\d|52|[78]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "52[0-7]"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "8 $1",
                    1
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "37|4(?:[15]|6[1-8])"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "(8-$1)",
                    1
                ]
            ],
            "8",
            0,
            "[08]"
        ],
        "LU": [
            "352",
            "00",
            "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "20[2-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "80[01]|90[015]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "20"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                    "$1 $2 $3 $4",
                    [
                        "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"
        ],
        "LV": [
            "371",
            "00",
            "(?:[268]\\d|90)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[269]|8[01]"
                    ]
                ]
            ]
        ],
        "LY": [
            "218",
            "00",
            "[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MA": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1-$2",
                    [
                        "5(?:2[2-489]|3[5-9]|9)|8(?:0[89]|92)",
                        "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|8(?:0[89]|92)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1-$2",
                    [
                        "[5-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"
                ],
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-2]|5[01]|8[0-3]))\\d{6}"
                ],
                [
                    "80[0-7]\\d{6}"
                ],
                [
                    "89\\d{7}"
                ],
                0,
                0,
                0,
                0,
                [
                    "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"
                ]
            ]
        ],
        "MC": [
            "377",
            "00",
            "(?:[3489]|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[389]"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MD": [
            "373",
            "00",
            "(?:[235-7]\\d|[89]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "22|3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[25-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ME": [
            "382",
            "00",
            "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MF": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "MG": [
            "261",
            "00",
            "[23]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "([24-9]\\d{6})$|0",
            "20$1"
        ],
        "MH": [
            "692",
            "011",
            "329\\d{4}|(?:[256]\\d|45)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-6]"
                    ]
                ]
            ],
            "1"
        ],
        "MK": [
            "389",
            "00",
            "[2-578]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2|34[47]|4(?:[37]7|5[47]|64)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[347]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[58]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ML": [
            "223",
            "00",
            "[24-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ]
                ]
            ]
        ],
        "MM": [
            "95",
            "00",
            "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[4-7]|8[1-35]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4,6})",
                    "$1 $2 $3",
                    [
                        "9(?:2[0-4]|[35-9]|4[137-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "92"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{5})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MN": [
            "976",
            "001",
            "[12]\\d{7,9}|[5-9]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[12]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12]2[1-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "[12]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MO": [
            "853",
            "00",
            "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[268]"
                    ]
                ]
            ]
        ],
        "MP": [
            "1",
            "011",
            "[58]\\d{9}|(?:67|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "670$1",
            0,
            "670"
        ],
        "MQ": [
            "596",
            "00",
            "596\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MR": [
            "222",
            "00",
            "(?:[2-4]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-48]"
                    ]
                ]
            ]
        ],
        "MS": [
            "1",
            "011",
            "(?:[58]\\d\\d|664|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([34]\\d{6})$|1",
            "664$1",
            0,
            "664"
        ],
        "MT": [
            "356",
            "00",
            "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2357-9]"
                    ]
                ]
            ]
        ],
        "MU": [
            "230",
            "0(?:0|[24-7]0|3[03])",
            "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46]|8[013]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "020"
        ],
        "MV": [
            "960",
            "0(?:0|19)",
            "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
            [
                7,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[34679]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MW": [
            "265",
            "00",
            "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[137-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MX": [
            "52",
            "0[09]",
            "1(?:(?:[27]2|44|87|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-69]|9[1-8])|[2-9]\\d)\\d{8}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "33|5[56]|81"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1(?:33|5[56]|81)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1"
                    ],
                    0,
                    1
                ]
            ],
            "01",
            0,
            "0(?:[12]|4[45])|1",
            0,
            0,
            0,
            0,
            "00"
        ],
        "MY": [
            "60",
            "00",
            "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "[4-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1-$2 $3",
                    [
                        "1(?:[02469]|[378][1-9]|53)|8",
                        "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3-$4",
                    [
                        "1(?:[367]|80)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MZ": [
            "258",
            "00",
            "(?:2|8\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2|8[2-79]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NA": [
            "264",
            "00",
            "[68]\\d{7,8}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "87"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NC": [
            "687",
            "00",
            "(?:050|[2-57-9]\\d\\d)\\d{3}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1.$2.$3",
                    [
                        "[02-57-9]"
                    ]
                ]
            ]
        ],
        "NE": [
            "227",
            "00",
            "[027-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "08"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[089]|2[013]|7[047]"
                    ]
                ]
            ]
        ],
        "NF": [
            "672",
            "00",
            "[13]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "1[0-3]"
                    ]
                ],
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "[13]"
                    ]
                ]
            ],
            0,
            0,
            "([0-258]\\d{4})$",
            "3$1"
        ],
        "NG": [
            "234",
            "009",
            "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",
            [
                7,
                8,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "78"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]|9(?:0[3-9]|[1-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NI": [
            "505",
            "00",
            "(?:1800|[25-8]\\d{3})\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[125-8]"
                    ]
                ]
            ]
        ],
        "NL": [
            "31",
            "00",
            "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4,7})",
                    "$1 $2",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "66"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{8})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-578]|91"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NO": [
            "47",
            "00",
            "(?:0|[2-9]\\d{3})\\d{4}",
            [
                5,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[02-689]|7[0-8]"
        ],
        "NP": [
            "977",
            "00",
            "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1-$2",
                    [
                        "1[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1-$2",
                    [
                        "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "NR": [
            "674",
            "00",
            "(?:444|(?:55|8\\d)\\d|666)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-68]"
                    ]
                ]
            ]
        ],
        "NU": [
            "683",
            "00",
            "(?:[4-7]|888\\d)\\d{3}",
            [
                4,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NZ": [
            "64",
            "0(?:0|161)",
            "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,8})",
                    "$1 $2",
                    [
                        "8[1-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "50[036-8]|8|90",
                        "50(?:[0367]|88)|8|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "24|[346]|7[2-57-9]|9[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:10|74)|[589]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1|2[028]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,5})",
                    "$1 $2 $3",
                    [
                        "2(?:[169]|7[0-35-9])|7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "OM": [
            "968",
            "00",
            "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4,6})",
                    "$1 $2",
                    [
                        "[58]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[179]"
                    ]
                ]
            ]
        ],
        "PA": [
            "507",
            "00",
            "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
            [
                7,
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-57-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PE": [
            "51",
            "00|19(?:1[124]|77|90)00",
            "(?:[14-8]|9\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[4-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " Anexo "
        ],
        "PF": [
            "689",
            "00",
            "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4|8[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PG": [
            "675",
            "00|140[1-3]",
            "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "18|[2-69]|85"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[78]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "PH": [
            "63",
            "00",
            "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
            [
                6,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                        "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "346|4(?:27|9[35])|883",
                        "3469|4(?:279|9(?:30|56))|8834"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PK": [
            "92",
            "00",
            "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,7})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6,7})",
                    "$1 $2",
                    [
                        "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                        "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{7,8})",
                    "$1 $2",
                    [
                        "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "58"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "PL": [
            "48",
            "00",
            "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "11|20|64"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "64"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[2-8]|[2-7]|8[1-79]|9[145]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PM": [
            "508",
            "00",
            "[45]\\d{5}|(?:708|80\\d)\\d{6}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "PR": [
            "1",
            "011",
            "(?:[589]\\d\\d|787)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "787|939"
        ],
        "PS": [
            "970",
            "00",
            "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PT": [
            "351",
            "00",
            "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[12]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|[236-9]"
                    ]
                ]
            ]
        ],
        "PW": [
            "680",
            "01[12]",
            "(?:[24-8]\\d\\d|345|900)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "PY": [
            "595",
            "00",
            "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "[2-9]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "9(?:[5-79]|8[1-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "QA": [
            "974",
            "00",
            "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
            [
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "2[16]|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[3-7]"
                    ]
                ]
            ]
        ],
        "RE": [
            "262",
            "00",
            "(?:26|[689]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2689]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"
                ],
                [
                    "69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                [
                    "89[1-37-9]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                [
                    "9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}"
                ],
                [
                    "8(?:1[019]|2[0156]|84|90)\\d{6}"
                ]
            ]
        ],
        "RO": [
            "40",
            "00",
            "(?:[2378]\\d|62|90)\\d{7}|[23]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "2[3-6]",
                        "2[3-6]\\d9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "219|31"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[236-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            " int "
        ],
        "RS": [
            "381",
            "00",
            "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3,9})",
                    "$1 $2",
                    [
                        "(?:2[389]|39)0|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5,10})",
                    "$1 $2",
                    [
                        "[1-36]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "RU": [
            "7",
            "810",
            "8\\d{13}|[347-9]\\d{9}",
            [
                10,
                14
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-8]|2[1-9])",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-68]|2[1-9])",
                        "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                        "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[349]|8(?:[02-7]|1[1-8])"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "8 ($1)"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            "3[04-689]|[489]",
            0,
            "8~10"
        ],
        "RW": [
            "250",
            "00",
            "(?:06|[27]\\d\\d|[89]00)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SA": [
            "966",
            "00",
            "92\\d{7}|(?:[15]|8\\d)\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0"
        ],
        "SB": [
            "677",
            "0[01]",
            "(?:[1-6]|[7-9]\\d\\d)\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7|8[4-9]|9(?:[1-8]|9[0-8])"
                    ]
                ]
            ]
        ],
        "SC": [
            "248",
            "010|0[0-2]",
            "800\\d{4}|(?:[249]\\d|64)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[246]|9[57]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SD": [
            "249",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SE": [
            "46",
            "00",
            "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "20"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "9(?:00|39|44|9)"
                    ],
                    "0$1",
                    0,
                    "$1 $2"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{3})",
                    "$1-$2 $3",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "10|7"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                    "$1-$2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4 $5",
                    [
                        "[26]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4 $5"
                ]
            ],
            "0"
        ],
        "SG": [
            "65",
            "0[0-3]\\d",
            "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|8(?:0[1-8]|[1-9])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "SH": [
            "290",
            "00",
            "(?:[256]\\d|8)\\d{3}",
            [
                4,
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[256]"
        ],
        "SI": [
            "386",
            "00|10(?:22|66|88|99)",
            "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
            [
                5,
                6,
                7,
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3,6})",
                    "$1 $2",
                    [
                        "8[09]|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "59|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37][01]|4[0139]|51|6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-57]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SJ": [
            "47",
            "00",
            "0\\d{4}|(?:[489]\\d|79)\\d{6}",
            [
                5,
                8
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "79"
        ],
        "SK": [
            "421",
            "00",
            "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
            [
                6,
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-5][1-8]1",
                        "[3-5][1-8]1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "[3-5]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SL": [
            "232",
            "00",
            "(?:[237-9]\\d|66)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[236-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "SM": [
            "378",
            "00",
            "(?:0549|[5-7]\\d)\\d{6}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "([89]\\d{5})$",
            "0549$1"
        ],
        "SN": [
            "221",
            "00",
            "(?:[378]\\d|93)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[379]"
                    ]
                ]
            ]
        ],
        "SO": [
            "252",
            "00",
            "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "8[125]"
                    ]
                ],
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[134]"
                    ]
                ],
                [
                    "(\\d)(\\d{6})",
                    "$1 $2",
                    [
                        "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                    ]
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "(?:2|90)4|[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[348]|64|79|90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "1|28|6[0-35-9]|77|9[2-9]"
                    ]
                ]
            ],
            "0"
        ],
        "SR": [
            "597",
            "00",
            "(?:[2-5]|68|[78]\\d)\\d{5}",
            [
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "56"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-5]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[6-8]"
                    ]
                ]
            ]
        ],
        "SS": [
            "211",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ST": [
            "239",
            "00",
            "(?:22|9\\d)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "SV": [
            "503",
            "00",
            "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",
            [
                7,
                8,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[267]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "SX": [
            "1",
            "011",
            "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "(5\\d{6})$|1",
            "721$1",
            0,
            "721"
        ],
        "SY": [
            "963",
            "00",
            "[1-39]\\d{8}|[1-5]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-5]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "SZ": [
            "268",
            "00",
            "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[0237]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "TA": [
            "290",
            "00",
            "8\\d{3}",
            [
                4
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "8"
        ],
        "TC": [
            "1",
            "011",
            "(?:[58]\\d\\d|649|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-479]\\d{6})$|1",
            "649$1",
            0,
            "649"
        ],
        "TD": [
            "235",
            "00|16",
            "(?:22|[69]\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2679]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "TG": [
            "228",
            "00",
            "[279]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[279]"
                    ]
                ]
            ]
        ],
        "TH": [
            "66",
            "00[1-9]",
            "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
            [
                8,
                9,
                10,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "TJ": [
            "992",
            "810",
            "[0-57-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{6})(\\d)(\\d{2})",
                    "$1 $2 $3",
                    [
                        "331",
                        "3317"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44[02-479]|[34]7"
                    ]
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[1-5]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[0-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TK": [
            "690",
            "00",
            "[2-47]\\d{3,6}",
            [
                4,
                5,
                6,
                7
            ]
        ],
        "TL": [
            "670",
            "00",
            "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-489]|70"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TM": [
            "993",
            "810",
            "[1-6]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "12"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-5]"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TN": [
            "216",
            "00",
            "[2-57-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ]
        ],
        "TO": [
            "676",
            "00",
            "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "TR": [
            "90",
            "00",
            "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
            [
                7,
                10,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "512|8[01589]|90"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5(?:[0-59]|61)",
                        "5(?:[0-59]|61[06])",
                        "5(?:[0-59]|61[06]1)"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24][1-8]|3[1-9]"
                    ],
                    "(0$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{6,7})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "TT": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-46-8]\\d{6})$|1",
            "868$1",
            0,
            "868"
        ],
        "TV": [
            "688",
            "00",
            "(?:2|7\\d\\d|90)\\d{4}",
            [
                5,
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TW": [
            "886",
            "0(?:0[25-79]|19)",
            "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
            [
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "202"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[258]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                        "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "#"
        ],
        "TZ": [
            "255",
            "00[056]",
            "(?:[25-8]\\d|41|90)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[24]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "UA": [
            "380",
            "00",
            "[89]\\d{9}|[3-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                        "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|89|9[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "0~0"
        ],
        "UG": [
            "256",
            "00[057]",
            "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "202",
                        "2024"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[27-9]|4(?:6[45]|[7-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[34]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "US": [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "310"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "($1) $2-$3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1,
                    "$1-$2-$3"
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:5056(?:[0-35-9]\\d|4[468])|73020\\d)\\d{4}|(?:4722|505[2-57-9]|983[289])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[0149]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        "UY": [
            "598",
            "0(?:0|1[3-9]\\d)",
            "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[49]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[124]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " int. "
        ],
        "UZ": [
            "998",
            "810",
            "(?:20|33|[5-79]\\d|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[235-9]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "VA": [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "06698"
        ],
        "VC": [
            "1",
            "011",
            "(?:[58]\\d\\d|784|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "784$1",
            0,
            "784"
        ],
        "VE": [
            "58",
            "00",
            "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "[24-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "VG": [
            "1",
            "011",
            "(?:284|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-578]\\d{6})$|1",
            "284$1",
            0,
            "284"
        ],
        "VI": [
            "1",
            "011",
            "[58]\\d{9}|(?:34|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "340$1",
            0,
            "340"
        ],
        "VN": [
            "84",
            "00",
            "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[357-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[48]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "VU": [
            "678",
            "00",
            "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ]
            ]
        ],
        "WF": [
            "681",
            "00",
            "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[478]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "WS": [
            "685",
            "0",
            "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
            [
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "[2-5]|6[1-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "XK": [
            "383",
            "00",
            "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YE": [
            "967",
            "00",
            "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-6]|7(?:[24-6]|8[0-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YT": [
            "262",
            "00",
            "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "269(?:0[0-467]|5[0-4]|6\\d|[78]0)\\d{4}"
                ],
                [
                    "639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39|47)8[01]|769\\d)\\d{4}"
                ]
            ]
        ],
        "ZA": [
            "27",
            "00",
            "[1-79]\\d{8}|8\\d{4,9}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "860"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZM": [
            "260",
            "00",
            "800\\d{6}|(?:21|63|[79]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[28]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZW": [
            "263",
            "00",
            "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3,5})",
                    "$1 $2",
                    [
                        "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                        "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "29[013-9]|39|54"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,5})",
                    "$1 $2",
                    [
                        "(?:25|54)8",
                        "258|5483"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ]
    },
    "nonGeographic": {
        "800": [
            "800",
            0,
            "(?:00|[1-9]\\d)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "\\d"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                [
                    "(?:00|[1-9]\\d)\\d{6}"
                ]
            ]
        ],
        "808": [
            "808",
            0,
            "[1-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "[1-9]\\d{7}"
                ]
            ]
        ],
        "870": [
            "870",
            0,
            "7\\d{11}|[35-7]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[35-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"
                ]
            ]
        ],
        "878": [
            "878",
            0,
            "10\\d{10}",
            [
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "10\\d{10}"
                ]
            ]
        ],
        "881": [
            "881",
            0,
            "6\\d{9}|[0-36-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[0-37-9]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6\\d{9}|[0-36-9]\\d{8}"
                ]
            ]
        ],
        "882": [
            "882",
            0,
            "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "16|342"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "49"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[36]|9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3[23]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|23|3(?:[15]|4[57])|4|51"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4,5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[1-35]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
                    [
                        7,
                        8,
                        9,
                        10,
                        12
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"
                ]
            ]
        ],
        "883": [
            "883",
            0,
            "(?:[1-4]\\d|51)\\d{6,10}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,8})",
                    "$1 $2 $3",
                    [
                        "[14]|2[24-689]|3[02-689]|51[24-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "51[13]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[235]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"
                ]
            ]
        ],
        "888": [
            "888",
            0,
            "\\d{11}",
            [
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3"
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "\\d{11}"
                ]
            ]
        ],
        "979": [
            "979",
            0,
            "[1359]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1359]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                [
                    "[1359]\\d{8}"
                ]
            ]
        ]
    }
};

});


parcelRequire.register("5uVQp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $400c9fc2297de112$export$2e2bcd8739ae039; });

var $aVueY = parcelRequire("aVueY");

var $hmkJ5 = parcelRequire("hmkJ5");
function $400c9fc2297de112$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $hmkJ5.default)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    return (0, $aVueY.default)(text, options, metadata);
}

});
parcelRequire.register("aVueY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f46af60b4774b00$export$2e2bcd8739ae039; });

var $hFtoc = parcelRequire("hFtoc");
function $7f46af60b4774b00$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7f46af60b4774b00$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7f46af60b4774b00$var$ownKeys(Object(source), !0).forEach(function(key) {
            $7f46af60b4774b00$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7f46af60b4774b00$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7f46af60b4774b00$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7f46af60b4774b00$export$2e2bcd8739ae039(text, options, metadata) {
    return (0, $hFtoc.default)(text, $7f46af60b4774b00$var$_objectSpread($7f46af60b4774b00$var$_objectSpread({}, options), {}, {
        v2: true
    }), metadata);
}

});
parcelRequire.register("hFtoc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cdcd101a5fe70785$export$2e2bcd8739ae039; });
// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js

var $8XPDb = parcelRequire("8XPDb");

var $7SnHu = parcelRequire("7SnHu");

var $iFKqc = parcelRequire("iFKqc");

var $kxzbj = parcelRequire("kxzbj");

var $7PrLe = parcelRequire("7PrLe");

var $dEL7b = parcelRequire("dEL7b");

var $iFKqc = parcelRequire("iFKqc");

var $cGAlA = parcelRequire("cGAlA");

var $kwFnR = parcelRequire("kwFnR");

var $4v8FZ = parcelRequire("4v8FZ");

var $jCJVh = parcelRequire("jCJVh");

var $ipav4 = parcelRequire("ipav4");


var $5jaRq = parcelRequire("5jaRq");

var $eoRHm = parcelRequire("eoRHm");
// This prevents malicious input from consuming CPU.
var $cdcd101a5fe70785$var$MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.
var $cdcd101a5fe70785$var$PHONE_NUMBER_START_PATTERN = new RegExp("[" + (0, $8XPDb.PLUS_CHARS) + (0, $8XPDb.VALID_DIGITS) + "]"); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".
var $cdcd101a5fe70785$var$AFTER_PHONE_NUMBER_END_PATTERN = new RegExp("[^" + (0, $8XPDb.VALID_DIGITS) + "#" + "]+$");
var $cdcd101a5fe70785$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // Examples:
function $cdcd101a5fe70785$export$2e2bcd8739ae039(text, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $iFKqc.default)(metadata); // Validate `defaultCountry`.
    if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
        if (options.v2) throw new (0, $7SnHu.default)("INVALID_COUNTRY");
        throw new Error("Unknown country: ".concat(options.defaultCountry));
    } // Parse the phone number.
    var _parseInput = $cdcd101a5fe70785$var$parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error; // If the phone number is not viable then return nothing.
    if (!formattedPhoneNumber) {
        if (options.v2) {
            if (error === "TOO_SHORT") throw new (0, $7SnHu.default)("TOO_SHORT");
            throw new (0, $7SnHu.default)("NOT_A_NUMBER");
        }
        return {};
    }
    var _parsePhoneNumber = $cdcd101a5fe70785$var$parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource, carrierCode = _parsePhoneNumber.carrierCode;
    if (!metadata.hasSelectedNumberingPlan()) {
        if (options.v2) throw new (0, $7SnHu.default)("INVALID_COUNTRY");
        return {};
    } // Validate national (significant) number length.
    if (!nationalNumber || nationalNumber.length < (0, $8XPDb.MIN_LENGTH_FOR_NSN)) {
        // Won't throw here because the regexp already demands length > 1.
        /* istanbul ignore if */ if (options.v2) throw new (0, $7SnHu.default)("TOO_SHORT");
         // Google's demo just throws an error in this case.
        return {};
    } // Validate national (significant) number length.
    //
    // A sidenote:
    //
    // They say that sometimes national (significant) numbers
    // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
    // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
    // Such numbers will just be discarded.
    //
    if (nationalNumber.length > (0, $8XPDb.MAX_LENGTH_FOR_NSN)) {
        if (options.v2) throw new (0, $7SnHu.default)("TOO_LONG");
         // Google's demo just throws an error in this case.
        return {};
    }
    if (options.v2) {
        var phoneNumber = new (0, $kwFnR.default)(countryCallingCode, nationalNumber, metadata.metadata);
        if (country) phoneNumber.country = country;
        if (carrierCode) phoneNumber.carrierCode = carrierCode;
        if (ext) phoneNumber.ext = ext;
        phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
        return phoneNumber;
    } // Check if national phone number pattern matches the number.
    // National number pattern is different for each country,
    // even for those ones which are part of the "NANPA" group.
    var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? (0, $4v8FZ.default)(nationalNumber, metadata.nationalNumberPattern()) : false;
    if (!options.extended) return valid ? $cdcd101a5fe70785$var$result(country, nationalNumber, ext) : {};
     // isInternational: countryCallingCode !== undefined
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        carrierCode: carrierCode,
        valid: valid,
        possible: valid ? true : options.extended === true && metadata.possibleLengths() && (0, $cGAlA.isPossibleNumber)(nationalNumber, metadata) ? true : false,
        phone: nationalNumber,
        ext: ext
    };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */ function $cdcd101a5fe70785$var$_extractFormattedPhoneNumber(text, extract, throwOnError) {
    if (!text) return;
    if (text.length > $cdcd101a5fe70785$var$MAX_INPUT_STRING_LENGTH) {
        if (throwOnError) throw new (0, $7SnHu.default)("TOO_LONG");
        return;
    }
    if (extract === false) return text;
     // Attempt to extract a possible number from the string passed in
    var startsAt = text.search($cdcd101a5fe70785$var$PHONE_NUMBER_START_PATTERN);
    if (startsAt < 0) return;
    return text // Trim everything to the left of the phone number
    .slice(startsAt) // Remove trailing non-numerical characters
    .replace($cdcd101a5fe70785$var$AFTER_PHONE_NUMBER_END_PATTERN, "");
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */ function $cdcd101a5fe70785$var$parseInput(text, v2, extract) {
    // // Parse RFC 3966 phone number URI.
    // if (text && text.indexOf('tel:') === 0) {
    // 	return parseRFC3966(text)
    // }
    // let number = extractFormattedPhoneNumber(text, extract, v2)
    var number = (0, $eoRHm.default)(text, {
        extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text) {
            return $cdcd101a5fe70785$var$_extractFormattedPhoneNumber(text, extract, v2);
        }
    }); // If the phone number is not viable, then abort.
    if (!number) return {};
    if (!(0, $kxzbj.default)(number)) {
        if ((0, $kxzbj.isViablePhoneNumberStart)(number)) return {
            error: "TOO_SHORT"
        };
        return {};
    } // Attempt to parse extension first, since it doesn't require region-specific
    // data and we want to have the non-normalised number here.
    var withExtensionStripped = (0, $7PrLe.default)(number);
    if (withExtensionStripped.ext) return withExtensionStripped;
    return {
        number: number
    };
}
/**
 * Creates `parse()` result object.
 */ function $cdcd101a5fe70785$var$result(country, nationalNumber, ext) {
    var result = {
        country: country,
        phone: nationalNumber
    };
    if (ext) result.ext = ext;
    return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */ function $cdcd101a5fe70785$var$parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
    // Extract calling code from phone number.
    var _extractCountryCallin = (0, $jCJVh.default)((0, $dEL7b.default)(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata), countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource, countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.
    var country;
    if (countryCallingCode) metadata.selectNumberingPlan(countryCallingCode);
    else if (number && (defaultCountry || defaultCallingCode)) {
        metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
        if (defaultCountry) country = defaultCountry;
        else {
            /* istanbul ignore if */ if ($cdcd101a5fe70785$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                if (metadata.isNonGeographicCallingCode(defaultCallingCode)) country = "001";
            }
        }
        countryCallingCode = defaultCallingCode || (0, $iFKqc.getCountryCallingCode)(defaultCountry, metadata.metadata);
    } else return {};
    if (!number) return {
        countryCallingCodeSource: countryCallingCodeSource,
        countryCallingCode: countryCallingCode
    };
    var _extractNationalNumbe = (0, $ipav4.default)((0, $dEL7b.default)(number), metadata), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
    // corresponding to the same country phone code
    // (e.g. NANPA countries all having `1` country phone code).
    // Therefore, to reliably determine the exact country,
    // national (significant) number should have been parsed first.
    //
    // When `metadata.json` is generated, all "ambiguous" country phone codes
    // get their countries populated with the full set of
    // "phone number type" regular expressions.
    //
    var exactCountry = (0, $5jaRq.default)(countryCallingCode, {
        nationalNumber: nationalNumber,
        defaultCountry: defaultCountry,
        metadata: metadata
    });
    if (exactCountry) {
        country = exactCountry;
        /* istanbul ignore if */ if (exactCountry === "001") ;
        else metadata.country(country);
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        countryCallingCodeSource: countryCallingCodeSource,
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
}

});
parcelRequire.register("8XPDb", function(module, exports) {

$parcel$export(module.exports, "MIN_LENGTH_FOR_NSN", function () { return $686be243e369a4b8$export$cd8355bcbe13154; });
$parcel$export(module.exports, "MAX_LENGTH_FOR_NSN", function () { return $686be243e369a4b8$export$85ddd8c9b243679b; });
$parcel$export(module.exports, "MAX_LENGTH_COUNTRY_CODE", function () { return $686be243e369a4b8$export$514717690676fb4a; });
$parcel$export(module.exports, "VALID_DIGITS", function () { return $686be243e369a4b8$export$852d1d4a47329634; });
$parcel$export(module.exports, "VALID_PUNCTUATION", function () { return $686be243e369a4b8$export$7f01587e28f9194; });
$parcel$export(module.exports, "PLUS_CHARS", function () { return $686be243e369a4b8$export$207c99ccf3902df8; });
// The minimum length of the national significant number.
var $686be243e369a4b8$export$cd8355bcbe13154 = 2; // The ITU says the maximum length should be 15,
var $686be243e369a4b8$export$85ddd8c9b243679b = 17; // The maximum length of the country calling code.
var $686be243e369a4b8$export$514717690676fb4a = 3; // Digits accepted in phone numbers
var $686be243e369a4b8$export$852d1d4a47329634 = "0-9０-９٠-٩۰-۹"; // `DASHES` will be right after the opening square bracket of the "character class"
var $686be243e369a4b8$var$DASHES = "-‐-―−ー－";
var $686be243e369a4b8$var$SLASHES = "／/";
var $686be243e369a4b8$var$DOTS = "．.";
var $686be243e369a4b8$export$20542845033f576e = " \xa0\xad​⁠　";
var $686be243e369a4b8$var$BRACKETS = "()（）［］\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
var $686be243e369a4b8$var$TILDES = "~⁓∼～"; // Regular expression of acceptable punctuation found in phone numbers. This
var $686be243e369a4b8$export$7f01587e28f9194 = "".concat($686be243e369a4b8$var$DASHES).concat($686be243e369a4b8$var$SLASHES).concat($686be243e369a4b8$var$DOTS).concat($686be243e369a4b8$export$20542845033f576e).concat($686be243e369a4b8$var$BRACKETS).concat($686be243e369a4b8$var$TILDES);
var $686be243e369a4b8$export$207c99ccf3902df8 = "+＋"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')

});

parcelRequire.register("7SnHu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bbff5f0fde2f664$export$2e2bcd8739ae039; });
function $5bbff5f0fde2f664$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $5bbff5f0fde2f664$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $5bbff5f0fde2f664$var$_typeof(obj);
}
function $5bbff5f0fde2f664$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5bbff5f0fde2f664$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5bbff5f0fde2f664$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5bbff5f0fde2f664$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $5bbff5f0fde2f664$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5bbff5f0fde2f664$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $5bbff5f0fde2f664$var$_setPrototypeOf(subClass, superClass);
}
function $5bbff5f0fde2f664$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5bbff5f0fde2f664$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $5bbff5f0fde2f664$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $5bbff5f0fde2f664$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $5bbff5f0fde2f664$var$_possibleConstructorReturn(this, result);
    };
}
function $5bbff5f0fde2f664$var$_possibleConstructorReturn(self, call) {
    if (call && ($5bbff5f0fde2f664$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $5bbff5f0fde2f664$var$_assertThisInitialized(self);
}
function $5bbff5f0fde2f664$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $5bbff5f0fde2f664$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $5bbff5f0fde2f664$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$5bbff5f0fde2f664$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $5bbff5f0fde2f664$var$_construct(Class, arguments, $5bbff5f0fde2f664$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $5bbff5f0fde2f664$var$_setPrototypeOf(Wrapper, Class);
    };
    return $5bbff5f0fde2f664$var$_wrapNativeSuper(Class);
}
function $5bbff5f0fde2f664$var$_construct(Parent, args, Class) {
    if ($5bbff5f0fde2f664$var$_isNativeReflectConstruct()) $5bbff5f0fde2f664$var$_construct = Reflect.construct;
    else $5bbff5f0fde2f664$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $5bbff5f0fde2f664$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $5bbff5f0fde2f664$var$_construct.apply(null, arguments);
}
function $5bbff5f0fde2f664$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $5bbff5f0fde2f664$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $5bbff5f0fde2f664$var$_setPrototypeOf(o, p) {
    $5bbff5f0fde2f664$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5bbff5f0fde2f664$var$_setPrototypeOf(o, p);
}
function $5bbff5f0fde2f664$var$_getPrototypeOf(o) {
    $5bbff5f0fde2f664$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5bbff5f0fde2f664$var$_getPrototypeOf(o);
}
// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var $5bbff5f0fde2f664$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    $5bbff5f0fde2f664$var$_inherits(ParseError, _Error);
    var _super = $5bbff5f0fde2f664$var$_createSuper(ParseError);
    function ParseError(code) {
        var _this;
        $5bbff5f0fde2f664$var$_classCallCheck(this, ParseError);
        _this = _super.call(this, code); // Set the prototype explicitly.
        // Any subclass of FooError will have to manually set the prototype as well.
        Object.setPrototypeOf($5bbff5f0fde2f664$var$_assertThisInitialized(_this), ParseError.prototype);
        _this.name = _this.constructor.name;
        return _this;
    }
    return $5bbff5f0fde2f664$var$_createClass(ParseError);
}(/*#__PURE__*/ $5bbff5f0fde2f664$var$_wrapNativeSuper(Error));

});

parcelRequire.register("iFKqc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d98010b360223b3c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "getCountryCallingCode", function () { return $d98010b360223b3c$export$32876ca2f1919cf0; });

var $g659Y = parcelRequire("g659Y");

var $6cJfw = parcelRequire("6cJfw");
function $d98010b360223b3c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $d98010b360223b3c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d98010b360223b3c$var$_typeof(obj);
}
function $d98010b360223b3c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d98010b360223b3c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d98010b360223b3c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d98010b360223b3c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d98010b360223b3c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// "country_phone_code_to_countries" to "country_calling_codes".
var $d98010b360223b3c$var$V2 = "1.0.18"; // Added "idd_prefix" and "default_idd_prefix".
var $d98010b360223b3c$var$V3 = "1.2.0"; // Moved `001` country code to "nonGeographic" section of metadata.
var $d98010b360223b3c$var$V4 = "1.7.35";
var $d98010b360223b3c$var$DEFAULT_EXT_PREFIX = " ext. ";
var $d98010b360223b3c$var$CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */ var $d98010b360223b3c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Metadata(metadata) {
        $d98010b360223b3c$var$_classCallCheck(this, Metadata);
        $d98010b360223b3c$export$a0b100d4662a8795(metadata);
        this.metadata = metadata;
        $d98010b360223b3c$var$setVersion.call(this, metadata);
    }
    $d98010b360223b3c$var$_createClass(Metadata, [
        {
            key: "getCountries",
            value: function getCountries() {
                return Object.keys(this.metadata.countries).filter(function(_) {
                    return _ !== "001";
                });
            }
        },
        {
            key: "getCountryMetadata",
            value: function getCountryMetadata(countryCode) {
                return this.metadata.countries[countryCode];
            }
        },
        {
            key: "nonGeographic",
            value: function nonGeographic() {
                if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
                // It's present in metadata generated from `1.7.35` to `1.7.37`.
                // The test case could be found by searching for "nonGeographical".
                return this.metadata.nonGeographic || this.metadata.nonGeographical;
            }
        },
        {
            key: "hasCountry",
            value: function hasCountry(country) {
                return this.getCountryMetadata(country) !== undefined;
            }
        },
        {
            key: "hasCallingCode",
            value: function hasCallingCode(callingCode) {
                if (this.getCountryCodesForCallingCode(callingCode)) return true;
                if (this.nonGeographic()) {
                    if (this.nonGeographic()[callingCode]) return true;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") return true;
                }
            }
        },
        {
            key: "isNonGeographicCallingCode",
            value: function isNonGeographicCallingCode(callingCode) {
                if (this.nonGeographic()) return this.nonGeographic()[callingCode] ? true : false;
                else return this.getCountryCodesForCallingCode(callingCode) ? false : true;
            } // Deprecated.
        },
        {
            key: "country",
            value: function country(countryCode) {
                return this.selectNumberingPlan(countryCode);
            }
        },
        {
            key: "selectNumberingPlan",
            value: function selectNumberingPlan(countryCode, callingCode) {
                // Supports just passing `callingCode` as the first argument.
                if (countryCode && $d98010b360223b3c$var$CALLING_CODE_REG_EXP.test(countryCode)) {
                    callingCode = countryCode;
                    countryCode = null;
                }
                if (countryCode && countryCode !== "001") {
                    if (!this.hasCountry(countryCode)) throw new Error("Unknown country: ".concat(countryCode));
                    this.numberingPlan = new $d98010b360223b3c$var$NumberingPlan(this.getCountryMetadata(countryCode), this);
                } else if (callingCode) {
                    if (!this.hasCallingCode(callingCode)) throw new Error("Unknown calling code: ".concat(callingCode));
                    this.numberingPlan = new $d98010b360223b3c$var$NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
                } else this.numberingPlan = undefined;
                return this;
            }
        },
        {
            key: "getCountryCodesForCallingCode",
            value: function getCountryCodesForCallingCode(callingCode) {
                var countryCodes = this.countryCallingCodes()[callingCode];
                if (countryCodes) {
                    // Metadata before V4 included "non-geographic entity" calling codes
                    // inside `country_calling_codes` (for example, `"881":["001"]`).
                    // Now the semantics of `country_calling_codes` has changed:
                    // it's specifically for "countries" now.
                    // Older versions of custom metadata will simply skip parsing
                    // "non-geographic entity" phone numbers with new versions
                    // of this library: it's not considered a bug,
                    // because such numbers are extremely rare,
                    // and developers extremely rarely use custom metadata.
                    if (countryCodes.length === 1 && countryCodes[0].length === 3) return;
                    return countryCodes;
                }
            }
        },
        {
            key: "getCountryCodeForCallingCode",
            value: function getCountryCodeForCallingCode(callingCode) {
                var countryCodes = this.getCountryCodesForCallingCode(callingCode);
                if (countryCodes) return countryCodes[0];
            }
        },
        {
            key: "getNumberingPlanMetadata",
            value: function getNumberingPlanMetadata(callingCode) {
                var countryCode = this.getCountryCodeForCallingCode(callingCode);
                if (countryCode) return this.getCountryMetadata(countryCode);
                if (this.nonGeographic()) {
                    var metadata = this.nonGeographic()[callingCode];
                    if (metadata) return metadata;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    // In that metadata, there was no concept of "non-geographic" metadata
                    // so metadata for `001` country code was stored along with other countries.
                    // The test case can be found by searching for:
                    // "should work around `nonGeographic` metadata not existing".
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") return this.metadata.countries["001"];
                }
            } // Deprecated.
        },
        {
            key: "countryCallingCode",
            value: function countryCallingCode() {
                return this.numberingPlan.callingCode();
            } // Deprecated.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                return this.numberingPlan.IDDPrefix();
            } // Deprecated.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                return this.numberingPlan.defaultIDDPrefix();
            } // Deprecated.
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                return this.numberingPlan.nationalNumberPattern();
            } // Deprecated.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                return this.numberingPlan.possibleLengths();
            } // Deprecated.
        },
        {
            key: "formats",
            value: function formats() {
                return this.numberingPlan.formats();
            } // Deprecated.
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                return this.numberingPlan.nationalPrefixForParsing();
            } // Deprecated.
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.numberingPlan.nationalPrefixTransformRule();
            } // Deprecated.
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.numberingPlan.leadingDigits();
            } // Deprecated.
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                return this.numberingPlan.hasTypes();
            } // Deprecated.
        },
        {
            key: "type",
            value: function type(_type) {
                return this.numberingPlan.type(_type);
            } // Deprecated.
        },
        {
            key: "ext",
            value: function ext() {
                return this.numberingPlan.ext();
            }
        },
        {
            key: "countryCallingCodes",
            value: function countryCallingCodes() {
                if (this.v1) return this.metadata.country_phone_code_to_countries;
                return this.metadata.country_calling_codes;
            } // Deprecated.
        },
        {
            key: "chooseCountryByCountryCallingCode",
            value: function chooseCountryByCountryCallingCode(callingCode) {
                return this.selectNumberingPlan(callingCode);
            }
        },
        {
            key: "hasSelectedNumberingPlan",
            value: function hasSelectedNumberingPlan() {
                return this.numberingPlan !== undefined;
            }
        }
    ]);
    return Metadata;
}();
var $d98010b360223b3c$var$NumberingPlan = /*#__PURE__*/ function() {
    function NumberingPlan(metadata, globalMetadataObject) {
        $d98010b360223b3c$var$_classCallCheck(this, NumberingPlan);
        this.globalMetadataObject = globalMetadataObject;
        this.metadata = metadata;
        $d98010b360223b3c$var$setVersion.call(this, globalMetadataObject.metadata);
    }
    $d98010b360223b3c$var$_createClass(NumberingPlan, [
        {
            key: "callingCode",
            value: function callingCode() {
                return this.metadata[0];
            } // Formatting information for regions which share
        },
        {
            key: "getDefaultCountryMetadataForRegion",
            value: function getDefaultCountryMetadataForRegion() {
                return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
            } // Is always present.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[1];
            } // Is only present when a country supports multiple IDD prefixes.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[12];
            }
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                if (this.v1 || this.v2) return this.metadata[1];
                return this.metadata[2];
            } // "possible length" data is always present in Google's metadata.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.v1) return;
                return this.metadata[this.v2 ? 2 : 3];
            }
        },
        {
            key: "_getFormats",
            value: function _getFormats(metadata) {
                return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "formats",
            value: function formats() {
                var _this = this;
                var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
                return formats.map(function(_) {
                    return new $d98010b360223b3c$var$Format(_, _this);
                });
            }
        },
        {
            key: "nationalPrefix",
            value: function nationalPrefix() {
                return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
            }
        },
        {
            key: "_getNationalPrefixFormattingRule",
            value: function _getNationalPrefixFormattingRule(metadata) {
                return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "_nationalPrefixForParsing",
            value: function _nationalPrefixForParsing() {
                return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
            }
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                // If `national_prefix_for_parsing` is not set explicitly,
                // then infer it from `national_prefix` (if any)
                return this._nationalPrefixForParsing() || this.nationalPrefix();
            }
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
            }
        },
        {
            key: "_getNationalPrefixIsOptionalWhenFormatting",
            value: function _getNationalPrefixIsOptionalWhenFormatting() {
                return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
            }
        },
        {
            key: "types",
            value: function types() {
                return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
            }
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                // Versions 1.2.0 - 1.2.4: can be `[]`.
                /* istanbul ignore next */ if (this.types() && this.types().length === 0) return false;
                 // Versions <= 1.2.4: can be `undefined`.
                // Version >= 1.2.5: can be `0`.
                return !!this.types();
            }
        },
        {
            key: "type",
            value: function type(_type2) {
                if (this.hasTypes() && $d98010b360223b3c$var$getType(this.types(), _type2)) return new $d98010b360223b3c$var$Type($d98010b360223b3c$var$getType(this.types(), _type2), this);
            }
        },
        {
            key: "ext",
            value: function ext() {
                if (this.v1 || this.v2) return $d98010b360223b3c$var$DEFAULT_EXT_PREFIX;
                return this.metadata[13] || $d98010b360223b3c$var$DEFAULT_EXT_PREFIX;
            }
        }
    ]);
    return NumberingPlan;
}();
var $d98010b360223b3c$var$Format = /*#__PURE__*/ function() {
    function Format(format, metadata) {
        $d98010b360223b3c$var$_classCallCheck(this, Format);
        this._format = format;
        this.metadata = metadata;
    }
    $d98010b360223b3c$var$_createClass(Format, [
        {
            key: "pattern",
            value: function pattern() {
                return this._format[0];
            }
        },
        {
            key: "format",
            value: function format() {
                return this._format[1];
            }
        },
        {
            key: "leadingDigitsPatterns",
            value: function leadingDigitsPatterns() {
                return this._format[2] || [];
            }
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._format[3] || this.metadata.nationalPrefixFormattingRule();
            }
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            }
        },
        {
            key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
            value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
                // National prefix is omitted if there's no national prefix formatting rule
                // set for this country, or when the national prefix formatting rule
                // contains no national prefix itself, or when this rule is set but
                // national prefix is optional for this phone number format
                // (and it is not enforced explicitly)
                return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            } // Checks whether national prefix formatting rule contains national prefix.
        },
        {
            key: "usesNationalPrefix",
            value: function usesNationalPrefix() {
                return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
                !$d98010b360223b3c$var$FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
                 ? true : false;
            }
        },
        {
            key: "internationalFormat",
            value: function internationalFormat() {
                return this._format[5] || this.format();
            }
        }
    ]);
    return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */ var $d98010b360223b3c$var$FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var $d98010b360223b3c$var$Type = /*#__PURE__*/ function() {
    function Type(type, metadata) {
        $d98010b360223b3c$var$_classCallCheck(this, Type);
        this.type = type;
        this.metadata = metadata;
    }
    $d98010b360223b3c$var$_createClass(Type, [
        {
            key: "pattern",
            value: function pattern() {
                if (this.metadata.v1) return this.type;
                return this.type[0];
            }
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.metadata.v1) return;
                return this.type[1] || this.metadata.possibleLengths();
            }
        }
    ]);
    return Type;
}();
function $d98010b360223b3c$var$getType(types, type) {
    switch(type){
        case "FIXED_LINE":
            return types[0];
        case "MOBILE":
            return types[1];
        case "TOLL_FREE":
            return types[2];
        case "PREMIUM_RATE":
            return types[3];
        case "PERSONAL_NUMBER":
            return types[4];
        case "VOICEMAIL":
            return types[5];
        case "UAN":
            return types[6];
        case "PAGER":
            return types[7];
        case "VOIP":
            return types[8];
        case "SHARED_COST":
            return types[9];
    }
}
function $d98010b360223b3c$export$a0b100d4662a8795(metadata) {
    if (!metadata) throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
     // `country_phone_code_to_countries` was renamed to
    // `country_calling_codes` in `1.0.18`.
    if (!(0, $6cJfw.default)(metadata) || !(0, $6cJfw.default)(metadata.countries)) throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat((0, $6cJfw.default)(metadata) ? "an object of shape: { " + Object.keys(metadata).join(", ") + " }" : "a " + $d98010b360223b3c$var$typeOf(metadata) + ": " + metadata, "."));
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */ var $d98010b360223b3c$var$typeOf = function typeOf(_) {
    return $d98010b360223b3c$var$_typeof(_);
};
function $d98010b360223b3c$export$9b48c965eafc2cf6(country, metadata) {
    metadata = new $d98010b360223b3c$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).ext();
    return $d98010b360223b3c$var$DEFAULT_EXT_PREFIX;
}
function $d98010b360223b3c$export$32876ca2f1919cf0(country, metadata) {
    metadata = new $d98010b360223b3c$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).countryCallingCode();
    throw new Error("Unknown country: ".concat(country));
}
function $d98010b360223b3c$export$bd9e113b8b17202a(country, metadata) {
    // metadata = new Metadata(metadata)
    // return metadata.hasCountry(country)
    return metadata.countries.hasOwnProperty(country);
}
function $d98010b360223b3c$var$setVersion(metadata) {
    var version = metadata.version;
    if (typeof version === "number") {
        this.v1 = version === 1;
        this.v2 = version === 2;
        this.v3 = version === 3;
        this.v4 = version === 4;
    } else {
        if (!version) this.v1 = true;
        else if ((0, $g659Y.default)(version, $d98010b360223b3c$var$V3) === -1) this.v2 = true;
        else if ((0, $g659Y.default)(version, $d98010b360223b3c$var$V4) === -1) this.v3 = true;
        else this.v4 = true;
    }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
 // function isCountryCode(countryCode) {
 // 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
 // }

});
parcelRequire.register("g659Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb8135862633ee01$export$2e2bcd8739ae039; });
// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function $bb8135862633ee01$export$2e2bcd8739ae039(a, b) {
    a = a.split("-");
    b = b.split("-");
    var pa = a[0].split(".");
    var pb = b[0].split(".");
    for(var i = 0; i < 3; i++){
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) return 1;
        if (nb > na) return -1;
        if (!isNaN(na) && isNaN(nb)) return 1;
        if (isNaN(na) && !isNaN(nb)) return -1;
    }
    if (a[1] && b[1]) return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
    return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}

});

parcelRequire.register("6cJfw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4846f6aad35b2534$export$2e2bcd8739ae039; });
var $4846f6aad35b2534$var$objectConstructor = {}.constructor;
function $4846f6aad35b2534$export$2e2bcd8739ae039(object) {
    return object !== undefined && object !== null && object.constructor === $4846f6aad35b2534$var$objectConstructor;
}

});


parcelRequire.register("kxzbj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef422dff10d62584$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "isViablePhoneNumberStart", function () { return $ef422dff10d62584$export$4c3f76c95c05197c; });

var $8XPDb = parcelRequire("8XPDb");

var $7ZRkU = parcelRequire("7ZRkU");
//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//
var $ef422dff10d62584$var$MIN_LENGTH_PHONE_NUMBER_PATTERN = "[" + (0, $8XPDb.VALID_DIGITS) + "]{" + (0, $8XPDb.MIN_LENGTH_FOR_NSN) + "}"; //
var $ef422dff10d62584$export$a77dd7471651eee = "[" + (0, $8XPDb.PLUS_CHARS) + "]{0,1}" + "(?:" + "[" + (0, $8XPDb.VALID_PUNCTUATION) + "]*" + "[" + (0, $8XPDb.VALID_DIGITS) + "]" + "){3,}" + "[" + (0, $8XPDb.VALID_PUNCTUATION) + (0, $8XPDb.VALID_DIGITS) + "]*"; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.
var $ef422dff10d62584$var$VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + (0, $8XPDb.PLUS_CHARS) + "]{0,1}" + "(?:" + "[" + (0, $8XPDb.VALID_PUNCTUATION) + "]*" + "[" + (0, $8XPDb.VALID_DIGITS) + "]" + "){1,2}" + "$", "i");
var $ef422dff10d62584$export$a2d12a04749c087d = $ef422dff10d62584$export$a77dd7471651eee + // Phone number extensions
"(?:" + (0, $7ZRkU.default)() + ")?"; // The combined regular expression for valid phone numbers:
//
var $ef422dff10d62584$var$VALID_PHONE_NUMBER_PATTERN = new RegExp("^" + $ef422dff10d62584$var$MIN_LENGTH_PHONE_NUMBER_PATTERN + "$" + "|" + // Or a longer fully parsed phone number (min 3 characters)
"^" + $ef422dff10d62584$export$a2d12a04749c087d + "$", "i"); // Checks to see if the string of characters could possibly be a phone number at
function $ef422dff10d62584$export$2e2bcd8739ae039(number) {
    return number.length >= (0, $8XPDb.MIN_LENGTH_FOR_NSN) && $ef422dff10d62584$var$VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
function $ef422dff10d62584$export$4c3f76c95c05197c(number) {
    return $ef422dff10d62584$var$VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}

});
parcelRequire.register("7ZRkU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d279a5e4d3cbe08$export$2e2bcd8739ae039; });

var $8XPDb = parcelRequire("8XPDb");
var $5d279a5e4d3cbe08$var$RFC3966_EXTN_PREFIX = ";ext=";
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */ var $5d279a5e4d3cbe08$var$getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
    return "([".concat((0, $8XPDb.VALID_DIGITS), "]{1,").concat(maxLength, "})");
};
function $5d279a5e4d3cbe08$export$2e2bcd8739ae039(purpose) {
    // We cap the maximum length of an extension based on the ambiguity of the way
    // the extension is prefixed. As per ITU, the officially allowed length for
    // extensions is actually 40, but we don't support this since we haven't seen real
    // examples and this introduces many false interpretations as the extension labels
    // are not standardized.
    /** @type {string} */ var extLimitAfterExplicitLabel = "20";
    /** @type {string} */ var extLimitAfterLikelyLabel = "15";
    /** @type {string} */ var extLimitAfterAmbiguousChar = "9";
    /** @type {string} */ var extLimitWhenNotSure = "6";
    /** @type {string} */ var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xa0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.
    /** @type {string} */ var possibleCharsAfterExtLabel = "[:\\.．]?[ \xa0\\t,-]*";
    /** @type {string} */ var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
    // patterns like "ext.".
    /** @type {string} */ var explicitExtLabels = "(?:e?xt(?:ensi(?:ó?|\xf3))?n?|ｅ?ｘｔｎ?|доб|anexo)"; // One-character symbols that can be used to indicate an extension, and less
    // commonly used or more ambiguous extension labels.
    /** @type {string} */ var ambiguousExtLabels = "(?:[xｘ#＃~～]|int|ｉｎｔ)"; // When extension is not separated clearly.
    /** @type {string} */ var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
    // comma as extension label may have it.
    /** @type {string} */ var possibleSeparatorsNumberExtLabelNoComma = "[ \xa0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
    // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
    // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
    // button with the extension number following.
    /** @type {string} */ var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
    /** @type {string} */ var rfcExtn = $5d279a5e4d3cbe08$var$RFC3966_EXTN_PREFIX + $5d279a5e4d3cbe08$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel);
    /** @type {string} */ var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + $5d279a5e4d3cbe08$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
    /** @type {string} */ var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + $5d279a5e4d3cbe08$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
    /** @type {string} */ var americanStyleExtnWithSuffix = ambiguousSeparator + $5d279a5e4d3cbe08$var$getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
    /** @type {string} */ var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + $5d279a5e4d3cbe08$var$getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
    /** @type {string} */ var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + $5d279a5e4d3cbe08$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
    // using ";ext=". The second more generic where extension is mentioned with explicit
    // labels like "ext:". In both the above cases we allow more numbers in extension than
    // any other extension labels. The third one captures when single character extension
    // labels or less commonly used labels are used. In such cases we capture fewer
    // extension digits in order to reduce the chance of falsely interpreting two
    // numbers beside each other as a number + extension. The fourth one covers the
    // special case of American numbers where the extension is written with a hash
    // at the end, such as "- 503#". The fifth one is exclusively for extension
    // autodialling formats which are used when dialling and in this case we accept longer
    // extensions. The last one is more liberal on the number of commas that acts as
    // extension labels, so we have a strict cap on the number of digits in such extensions.
    return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}

});


parcelRequire.register("7PrLe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b32d48bec733a96$export$2e2bcd8739ae039; });

var $7ZRkU = parcelRequire("7ZRkU");
// 1 or more valid digits, for use when parsing.
var $5b32d48bec733a96$var$EXTN_PATTERN = new RegExp("(?:" + (0, $7ZRkU.default)() + ")$", "i"); // Strips any extension (as in, the part of the number dialled after the call is
function $5b32d48bec733a96$export$2e2bcd8739ae039(number) {
    var start = number.search($5b32d48bec733a96$var$EXTN_PATTERN);
    if (start < 0) return {};
     // If we find a potential extension, and the number preceding this is a viable
    // number, we assume it is an extension.
    var numberWithoutExtension = number.slice(0, start);
    var matches = number.match($5b32d48bec733a96$var$EXTN_PATTERN);
    var i = 1;
    while(i < matches.length){
        if (matches[i]) return {
            number: numberWithoutExtension,
            ext: matches[i]
        };
        i++;
    }
}

});

parcelRequire.register("dEL7b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f138ed5a16e7880$export$2e2bcd8739ae039; });

var $2rkTW = parcelRequire("2rkTW");
function $9f138ed5a16e7880$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $9f138ed5a16e7880$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9f138ed5a16e7880$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9f138ed5a16e7880$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9f138ed5a16e7880$var$_arrayLikeToArray(o, minLen);
}
function $9f138ed5a16e7880$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9f138ed5a16e7880$export$2e2bcd8739ae039(string) {
    var result = ""; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $9f138ed5a16e7880$var$_createForOfIteratorHelperLoose(string.split("")), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        result += $9f138ed5a16e7880$export$13d8790d7fb84c28(character, result) || "";
    }
    return result;
}
function $9f138ed5a16e7880$export$13d8790d7fb84c28(character, prevParsedCharacters) {
    // Only allow a leading `+`.
    if (character === "+") {
        // If this `+` is not the first parsed character
        // then discard it.
        if (prevParsedCharacters) return;
        return "+";
    } // Allow digits.
    return (0, $2rkTW.parseDigit)(character);
}

});
parcelRequire.register("2rkTW", function(module, exports) {

$parcel$export(module.exports, "parseDigit", function () { return $1c6e50f37d99d3be$export$1d16fddea1437169; });
function $1c6e50f37d99d3be$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $1c6e50f37d99d3be$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1c6e50f37d99d3be$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1c6e50f37d99d3be$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1c6e50f37d99d3be$var$_arrayLikeToArray(o, minLen);
}
function $1c6e50f37d99d3be$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $1c6e50f37d99d3be$export$2848f3d68c08fe69 = {
    "0": "0",
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
    "０": "0",
    // Fullwidth digit 0
    "１": "1",
    // Fullwidth digit 1
    "２": "2",
    // Fullwidth digit 2
    "３": "3",
    // Fullwidth digit 3
    "４": "4",
    // Fullwidth digit 4
    "５": "5",
    // Fullwidth digit 5
    "６": "6",
    // Fullwidth digit 6
    "７": "7",
    // Fullwidth digit 7
    "８": "8",
    // Fullwidth digit 8
    "９": "9",
    // Fullwidth digit 9
    "٠": "0",
    // Arabic-indic digit 0
    "١": "1",
    // Arabic-indic digit 1
    "٢": "2",
    // Arabic-indic digit 2
    "٣": "3",
    // Arabic-indic digit 3
    "٤": "4",
    // Arabic-indic digit 4
    "٥": "5",
    // Arabic-indic digit 5
    "٦": "6",
    // Arabic-indic digit 6
    "٧": "7",
    // Arabic-indic digit 7
    "٨": "8",
    // Arabic-indic digit 8
    "٩": "9",
    // Arabic-indic digit 9
    "۰": "0",
    // Eastern-Arabic digit 0
    "۱": "1",
    // Eastern-Arabic digit 1
    "۲": "2",
    // Eastern-Arabic digit 2
    "۳": "3",
    // Eastern-Arabic digit 3
    "۴": "4",
    // Eastern-Arabic digit 4
    "۵": "5",
    // Eastern-Arabic digit 5
    "۶": "6",
    // Eastern-Arabic digit 6
    "۷": "7",
    // Eastern-Arabic digit 7
    "۸": "8",
    // Eastern-Arabic digit 8
    "۹": "9" // Eastern-Arabic digit 9
};
function $1c6e50f37d99d3be$export$1d16fddea1437169(character) {
    return $1c6e50f37d99d3be$export$2848f3d68c08fe69[character];
}
function $1c6e50f37d99d3be$export$2e2bcd8739ae039(string) {
    var result = ""; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $1c6e50f37d99d3be$var$_createForOfIteratorHelperLoose(string.split("")), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        var digit = $1c6e50f37d99d3be$export$1d16fddea1437169(character);
        if (digit) result += digit;
    }
    return result;
}

});


parcelRequire.register("cGAlA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93c59a0e071e8bac$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "isPossibleNumber", function () { return $93c59a0e071e8bac$export$4f8890cedf1e0497; });

var $iFKqc = parcelRequire("iFKqc");

var $5Cqti = parcelRequire("5Cqti");
function $93c59a0e071e8bac$export$2e2bcd8739ae039(input, options, metadata) {
    /* istanbul ignore if */ if (options === undefined) options = {};
    metadata = new (0, $iFKqc.default)(metadata);
    if (options.v2) {
        if (!input.countryCallingCode) throw new Error("Invalid phone number object passed");
        metadata.selectNumberingPlan(input.countryCallingCode);
    } else {
        if (!input.phone) return false;
        if (input.country) {
            if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
            metadata.country(input.country);
        } else {
            if (!input.countryCallingCode) throw new Error("Invalid phone number object passed");
            metadata.selectNumberingPlan(input.countryCallingCode);
        }
    } // Old metadata (< 1.0.18) had no "possible length" data.
    if (metadata.possibleLengths()) return $93c59a0e071e8bac$export$4f8890cedf1e0497(input.phone || input.nationalNumber, metadata);
    else {
        // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
        // were missing for "non-geographical" numbering plans.
        // Just assume the number is possible in such cases:
        // it's unlikely that anyone generated their custom metadata
        // in that short period of time (one day).
        // This code can be removed in some future major version update.
        if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) // "Non-geographic entities" did't have `possibleLengths`
        // due to a bug in metadata generation process.
        return true;
        else throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
}
function $93c59a0e071e8bac$export$4f8890cedf1e0497(nationalNumber, metadata) {
    //, isInternational) {
    switch((0, $5Cqti.default)(nationalNumber, metadata)){
        case "IS_POSSIBLE":
            return true;
        // This library ignores "local-only" phone numbers (for simplicity).
        // See the readme for more info on what are "local-only" phone numbers.
        // case 'IS_POSSIBLE_LOCAL_ONLY':
        // 	return !isInternational
        default:
            return false;
    }
}

});
parcelRequire.register("5Cqti", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4175090752f5fbd0$export$2e2bcd8739ae039; });

var $gz95y = parcelRequire("gz95y");
function $4175090752f5fbd0$export$2e2bcd8739ae039(nationalNumber, metadata) {
    return $4175090752f5fbd0$export$69333f603c7d5931(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
function $4175090752f5fbd0$export$69333f603c7d5931(nationalNumber, type, metadata) {
    var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
    // This is declared in the XML schema.
    // For size efficiency, where a sub-description (e.g. fixed-line)
    // has the same "<possiblePengths/>" as the "general description", this is missing,
    // so we fall back to the "general description". Where no numbers of the type
    // exist at all, there is one possible length (-1) which is guaranteed
    // not to match the length of any real phone number.
    var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
    // Metadata before version `1.0.18` didn't contain `possible_lengths`.
    if (!possible_lengths) return "IS_POSSIBLE";
    if (type === "FIXED_LINE_OR_MOBILE") {
        // No such country in metadata.
        /* istanbul ignore next */ if (!metadata.type("FIXED_LINE")) // The rare case has been encountered where no fixedLine data is available
        // (true for some non-geographic entities), so we just check mobile.
        return $4175090752f5fbd0$export$69333f603c7d5931(nationalNumber, "MOBILE", metadata);
        var mobile_type = metadata.type("MOBILE");
        if (mobile_type) // Merge the mobile data in if there was any. "Concat" creates a new
        // array, it doesn't edit possible_lengths in place, so we don't need a copy.
        // Note that when adding the possible lengths from mobile, we have
        // to again check they aren't empty since if they are this indicates
        // they are the same as the general desc and should be obtained from there.
        possible_lengths = (0, $gz95y.default)(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
    } else if (type && !type_info) return "INVALID_LENGTH";
    var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
    // // This is safe because there is never an overlap beween the possible lengths
    // // and the local-only lengths; this is checked at build time.
    // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
    // {
    // 	return 'IS_POSSIBLE_LOCAL_ONLY'
    // }
    var minimum_length = possible_lengths[0];
    if (minimum_length === actual_length) return "IS_POSSIBLE";
    if (minimum_length > actual_length) return "TOO_SHORT";
    if (possible_lengths[possible_lengths.length - 1] < actual_length) return "TOO_LONG";
     // We skip the first element since we've already checked it.
    return possible_lengths.indexOf(actual_length, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}

});
parcelRequire.register("gz95y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0f6f70813c87fd7$export$2e2bcd8739ae039; });
function $c0f6f70813c87fd7$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $c0f6f70813c87fd7$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c0f6f70813c87fd7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c0f6f70813c87fd7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c0f6f70813c87fd7$var$_arrayLikeToArray(o, minLen);
}
function $c0f6f70813c87fd7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c0f6f70813c87fd7$export$2e2bcd8739ae039(a, b) {
    var merged = a.slice();
    for(var _iterator = $c0f6f70813c87fd7$var$_createForOfIteratorHelperLoose(b), _step; !(_step = _iterator()).done;){
        var element = _step.value;
        if (a.indexOf(element) < 0) merged.push(element);
    }
    return merged.sort(function(a, b) {
        return a - b;
    }); // ES6 version, requires Set polyfill.
// let merged = new Set(a)
// for (const element of b) {
// 	merged.add(i)
// }
// return Array.from(merged).sort((a, b) => a - b)
}

});



parcelRequire.register("kwFnR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef16e5c65e1bd8d9$export$2e2bcd8739ae039; });

var $iFKqc = parcelRequire("iFKqc");

var $cGAlA = parcelRequire("cGAlA");

var $3nIhA = parcelRequire("3nIhA");

var $2cIol = parcelRequire("2cIol");

var $fQsTV = parcelRequire("fQsTV");

var $7JX5w = parcelRequire("7JX5w");
function $ef16e5c65e1bd8d9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ef16e5c65e1bd8d9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ef16e5c65e1bd8d9$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ef16e5c65e1bd8d9$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ef16e5c65e1bd8d9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ef16e5c65e1bd8d9$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ef16e5c65e1bd8d9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ef16e5c65e1bd8d9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ef16e5c65e1bd8d9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ef16e5c65e1bd8d9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ef16e5c65e1bd8d9$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $ef16e5c65e1bd8d9$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $ef16e5c65e1bd8d9$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param  {string} countryOrCountryCallingCode
   * @param  {string} nationalNumber
   * @param  {object} metadata — Metadata JSON
   * @return {PhoneNumber}
   */ function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
        $ef16e5c65e1bd8d9$var$_classCallCheck(this, PhoneNumber);
        if (!countryOrCountryCallingCode) throw new TypeError("`country` or `countryCallingCode` not passed");
        if (!nationalNumber) throw new TypeError("`nationalNumber` not passed");
        if (!metadata) throw new TypeError("`metadata` not passed");
        var _getCountryAndCountry = $ef16e5c65e1bd8d9$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata), country = _getCountryAndCountry.country, countryCallingCode = _getCountryAndCountry.countryCallingCode;
        this.country = country;
        this.countryCallingCode = countryCallingCode;
        this.nationalNumber = nationalNumber;
        this.number = "+" + this.countryCallingCode + this.nationalNumber; // Exclude `metadata` property output from `PhoneNumber.toString()`
        // so that it doesn't clutter the console output of Node.js.
        // Previously, when Node.js did `console.log(new PhoneNumber(...))`,
        // it would output the whole internal structure of the `metadata` object.
        this.getMetadata = function() {
            return metadata;
        };
    }
    $ef16e5c65e1bd8d9$var$_createClass(PhoneNumber, [
        {
            key: "setExt",
            value: function setExt(ext) {
                this.ext = ext;
            }
        },
        {
            key: "getPossibleCountries",
            value: function getPossibleCountries() {
                if (this.country) return [
                    this.country
                ];
                return (0, $fQsTV.default)(this.countryCallingCode, this.nationalNumber, this.getMetadata());
            }
        },
        {
            key: "isPossible",
            value: function isPossible() {
                return (0, $cGAlA.default)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                return (0, $3nIhA.default)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isNonGeographic",
            value: function isNonGeographic() {
                var metadata = new (0, $iFKqc.default)(this.getMetadata());
                return metadata.isNonGeographicCallingCode(this.countryCallingCode);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(phoneNumber) {
                return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
            } // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
        },
        {
            key: "getType",
            value: function getType() {
                return (0, $2cIol.default)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "format",
            value: function format(_format, options) {
                return (0, $7JX5w.default)(this, _format, options ? $ef16e5c65e1bd8d9$var$_objectSpread($ef16e5c65e1bd8d9$var$_objectSpread({}, options), {}, {
                    v2: true
                }) : {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "formatNational",
            value: function formatNational(options) {
                return this.format("NATIONAL", options);
            }
        },
        {
            key: "formatInternational",
            value: function formatInternational(options) {
                return this.format("INTERNATIONAL", options);
            }
        },
        {
            key: "getURI",
            value: function getURI(options) {
                return this.format("RFC3966", options);
            }
        }
    ]);
    return PhoneNumber;
}();
var $ef16e5c65e1bd8d9$var$isCountryCode = function isCountryCode(value) {
    return /^[A-Z]{2}$/.test(value);
};
function $ef16e5c65e1bd8d9$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
    var country;
    var countryCallingCode;
    var metadata = new (0, $iFKqc.default)(metadataJson); // If country code is passed then derive `countryCallingCode` from it.
    // Also store the country code as `.country`.
    if ($ef16e5c65e1bd8d9$var$isCountryCode(countryOrCountryCallingCode)) {
        country = countryOrCountryCallingCode;
        metadata.selectNumberingPlan(country);
        countryCallingCode = metadata.countryCallingCode();
    } else {
        countryCallingCode = countryOrCountryCallingCode;
        /* istanbul ignore if */ if ($ef16e5c65e1bd8d9$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
            if (metadata.isNonGeographicCallingCode(countryCallingCode)) country = "001";
        }
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode
    };
}

});
parcelRequire.register("3nIhA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2765deb4312b378c$export$2e2bcd8739ae039; });

var $iFKqc = parcelRequire("iFKqc");

var $4v8FZ = parcelRequire("4v8FZ");

var $2cIol = parcelRequire("2cIol");
function $2765deb4312b378c$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $iFKqc.default)(metadata);
    /**
   * Checks if a phone number is "possible" (basically just checks its length).
   *
   * @param  {object|PhoneNumber} input — If `options.v2: true` flag is passed, the `input` should be a `PhoneNumber` instance. Otherwise, it should be an object of shape `{ phone: '...', country: '...' }`.
   * @param  {object} [options]
   * @param  {object} metadata
   * @return {string}
   */ metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
    // distinguishing different countries having the same `countryCallingCode`.
    if (metadata.hasTypes()) return (0, $2cIol.default)(input, options, metadata.metadata) !== undefined;
     // If there are no type regexps for this country in metadata then use
    // `nationalNumberPattern` as a "better than nothing" replacement.
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
    return (0, $4v8FZ.default)(nationalNumber, metadata.nationalNumberPattern());
}

});
parcelRequire.register("4v8FZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3470c998284efbaf$export$2e2bcd8739ae039; });
/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */ function $3470c998284efbaf$export$2e2bcd8739ae039(text, regular_expression) {
    // If assigning the `''` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    text = text || "";
    return new RegExp("^(?:" + regular_expression + ")$").test(text);
}

});

parcelRequire.register("2cIol", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19af23080b4383c5$export$2e2bcd8739ae039; });

var $iFKqc = parcelRequire("iFKqc");

var $4v8FZ = parcelRequire("4v8FZ");
function $19af23080b4383c5$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $19af23080b4383c5$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $19af23080b4383c5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $19af23080b4383c5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $19af23080b4383c5$var$_arrayLikeToArray(o, minLen);
}
function $19af23080b4383c5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $19af23080b4383c5$var$NON_FIXED_LINE_PHONE_TYPES = [
    "MOBILE",
    "PREMIUM_RATE",
    "TOLL_FREE",
    "SHARED_COST",
    "VOIP",
    "PERSONAL_NUMBER",
    "PAGER",
    "UAN",
    "VOICEMAIL"
]; // Finds out national phone number type (fixed line, mobile, etc)
function $19af23080b4383c5$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {}; // When `parse()` returns an empty object — `{}` —
    // that means that the phone number is malformed,
    // so it can't possibly be valid.
    if (!input.country && !input.countryCallingCode) return;
    metadata = new (0, $iFKqc.default)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode);
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
    // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
    // Is this national number even valid for this country
    if (!(0, $4v8FZ.default)(nationalNumber, metadata.nationalNumberPattern())) return;
     // Is it fixed line number
    if ($19af23080b4383c5$export$7bd37b39ade0214d(nationalNumber, "FIXED_LINE", metadata)) {
        // Because duplicate regular expressions are removed
        // to reduce metadata size, if "mobile" pattern is ""
        // then it means it was removed due to being a duplicate of the fixed-line pattern.
        //
        if (metadata.type("MOBILE") && metadata.type("MOBILE").pattern() === "") return "FIXED_LINE_OR_MOBILE";
         // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
        // For example, for "US" country.
        // Old metadata (< `1.0.18`) had a specific "types" data structure
        // that happened to be `undefined` for `MOBILE` in that case.
        // Newer metadata (>= `1.0.18`) has another data structure that is
        // not `undefined` for `MOBILE` in that case (it's just an empty array).
        // So this `if` is just for backwards compatibility with old metadata.
        if (!metadata.type("MOBILE")) return "FIXED_LINE_OR_MOBILE";
         // Check if the number happens to qualify as both fixed line and mobile.
        // (no such country in the minimal metadata set)
        /* istanbul ignore if */ if ($19af23080b4383c5$export$7bd37b39ade0214d(nationalNumber, "MOBILE", metadata)) return "FIXED_LINE_OR_MOBILE";
        return "FIXED_LINE";
    }
    for(var _iterator = $19af23080b4383c5$var$_createForOfIteratorHelperLoose($19af23080b4383c5$var$NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;){
        var type = _step.value;
        if ($19af23080b4383c5$export$7bd37b39ade0214d(nationalNumber, type, metadata)) return type;
    }
}
function $19af23080b4383c5$export$7bd37b39ade0214d(nationalNumber, type, metadata) {
    type = metadata.type(type);
    if (!type || !type.pattern()) return false;
     // Check if any possible number lengths are present;
    // if so, we use them to avoid checking
    // the validation pattern if they don't match.
    // If they are absent, this means they match
    // the general description, which we have
    // already checked before a specific number type.
    if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) return false;
    return (0, $4v8FZ.default)(nationalNumber, type.pattern());
}

});


parcelRequire.register("fQsTV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8922178f1dfc006$export$2e2bcd8739ae039; });

var $iFKqc = parcelRequire("iFKqc");
function $b8922178f1dfc006$export$2e2bcd8739ae039(callingCode, nationalNumber, metadata) {
    var _metadata = new (0, $iFKqc.default)(metadata);
    var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return [];
    return possibleCountries.filter(function(country) {
        return $b8922178f1dfc006$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
    });
}
function $b8922178f1dfc006$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
    var _metadata = new (0, $iFKqc.default)(metadata);
    _metadata.selectNumberingPlan(country);
    if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) return true;
    return false;
}

});

parcelRequire.register("7JX5w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a2a920af0ee0ea7$export$2e2bcd8739ae039; });

var $4v8FZ = parcelRequire("4v8FZ");

var $jhV6S = parcelRequire("jhV6S");

var $iFKqc = parcelRequire("iFKqc");

var $jLSkt = parcelRequire("jLSkt");

var $ek3oA = parcelRequire("ek3oA");
function $5a2a920af0ee0ea7$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $5a2a920af0ee0ea7$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5a2a920af0ee0ea7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5a2a920af0ee0ea7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5a2a920af0ee0ea7$var$_arrayLikeToArray(o, minLen);
}
function $5a2a920af0ee0ea7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5a2a920af0ee0ea7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5a2a920af0ee0ea7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $5a2a920af0ee0ea7$var$ownKeys(Object(source), !0).forEach(function(key) {
            $5a2a920af0ee0ea7$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $5a2a920af0ee0ea7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5a2a920af0ee0ea7$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $5a2a920af0ee0ea7$var$DEFAULT_OPTIONS = {
    formatExtension: function formatExtension(formattedNumber, extension, metadata) {
        return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
    }
};
function $5a2a920af0ee0ea7$export$2e2bcd8739ae039(input, format, options, metadata) {
    // Apply default options.
    if (options) options = $5a2a920af0ee0ea7$var$_objectSpread($5a2a920af0ee0ea7$var$_objectSpread({}, $5a2a920af0ee0ea7$var$DEFAULT_OPTIONS), options);
    else options = $5a2a920af0ee0ea7$var$DEFAULT_OPTIONS;
    metadata = new (0, $iFKqc.default)(metadata);
    if (input.country && input.country !== "001") {
        // Validate `input.country`.
        if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
        metadata.country(input.country);
    } else if (input.countryCallingCode) metadata.selectNumberingPlan(input.countryCallingCode);
    else return input.phone || "";
    var countryCallingCode = metadata.countryCallingCode();
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
    // but Babel has a bug and it says "duplicate variable declaration".
    var number;
    switch(format){
        case "NATIONAL":
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "";
            number = $5a2a920af0ee0ea7$var$formatNationalNumber(nationalNumber, input.carrierCode, "NATIONAL", metadata, options);
            return $5a2a920af0ee0ea7$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case "INTERNATIONAL":
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "+".concat(countryCallingCode);
            number = $5a2a920af0ee0ea7$var$formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata, options);
            number = "+".concat(countryCallingCode, " ").concat(number);
            return $5a2a920af0ee0ea7$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case "E.164":
            // `E.164` doesn't define "phone number extensions".
            return "+".concat(countryCallingCode).concat(nationalNumber);
        case "RFC3966":
            return (0, $ek3oA.formatRFC3966)({
                number: "+".concat(countryCallingCode).concat(nationalNumber),
                ext: input.ext
            });
        // For reference, here's Google's IDD formatter:
        // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
        // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
        // Who would even need to format phone numbers in IDD format anyway?
        case "IDD":
            if (!options.fromCountry) return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
            var formattedNumber = $5a2a920af0ee0ea7$var$formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
            return $5a2a920af0ee0ea7$var$addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
        default:
            throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(format, '"'));
    }
}
function $5a2a920af0ee0ea7$var$formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
    var format = $5a2a920af0ee0ea7$export$a4ff939d1245121e(metadata.formats(), number);
    if (!format) return number;
    return (0, $jhV6S.default)(number, format, {
        useInternationalFormat: formatAs === "INTERNATIONAL",
        withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
        carrierCode: carrierCode,
        metadata: metadata
    });
}
function $5a2a920af0ee0ea7$export$a4ff939d1245121e(availableFormats, nationalNnumber) {
    for(var _iterator = $5a2a920af0ee0ea7$var$_createForOfIteratorHelperLoose(availableFormats), _step; !(_step = _iterator()).done;){
        var format = _step.value;
        // Validate leading digits.
        // The test case for "else path" could be found by searching for
        // "format.leadingDigitsPatterns().length === 0".
        if (format.leadingDigitsPatterns().length > 0) {
            // The last leading_digits_pattern is used here, as it is the most detailed
            var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format
            if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) continue;
        } // Check that the national number matches the phone number format regular expression
        if ((0, $4v8FZ.default)(nationalNnumber, format.pattern())) return format;
    }
}
function $5a2a920af0ee0ea7$var$addExtension(formattedNumber, ext, metadata, formatExtension) {
    return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}
function $5a2a920af0ee0ea7$var$formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
    var fromCountryCallingCode = (0, $iFKqc.getCountryCallingCode)(fromCountry, metadata.metadata); // When calling within the same country calling code.
    if (fromCountryCallingCode === countryCallingCode) {
        var formattedNumber = $5a2a920af0ee0ea7$var$formatNationalNumber(nationalNumber, carrierCode, "NATIONAL", metadata); // For NANPA regions, return the national format for these regions
        // but prefix it with the country calling code.
        if (countryCallingCode === "1") return countryCallingCode + " " + formattedNumber;
         // If regions share a country calling code, the country calling code need
        // not be dialled. This also applies when dialling within a region, so this
        // if clause covers both these cases. Technically this is the case for
        // dialling from La Reunion to other overseas departments of France (French
        // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
        // this edge case for now and for those cases return the version including
        // country calling code. Details here:
        // http://www.petitfute.com/voyage/225-info-pratiques-reunion
        //
        return formattedNumber;
    }
    var iddPrefix = (0, $jLSkt.default)(fromCountry, undefined, metadata.metadata);
    if (iddPrefix) return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat($5a2a920af0ee0ea7$var$formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata));
}

});
parcelRequire.register("jhV6S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0abe7ad0609f827$export$2e2bcd8739ae039; });

var $esId8 = parcelRequire("esId8");
var $e0abe7ad0609f827$export$4f32ad1c51a7a6be = /(\$\d)/;
function $e0abe7ad0609f827$export$2e2bcd8739ae039(number, format, _ref) {
    var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix, carrierCode = _ref.carrierCode, metadata = _ref.metadata;
    var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace($e0abe7ad0609f827$export$4f32ad1c51a7a6be, format.nationalPrefixFormattingRule()) : format.format());
    if (useInternationalFormat) return (0, $esId8.default)(formattedNumber);
    return formattedNumber;
}

});
parcelRequire.register("esId8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a875f997852798ec$export$2e2bcd8739ae039; });

var $8XPDb = parcelRequire("8XPDb");
function $a875f997852798ec$export$2e2bcd8739ae039(formattedNumber) {
    return formattedNumber.replace(new RegExp("[".concat((0, $8XPDb.VALID_PUNCTUATION), "]+"), "g"), " ").trim();
}

});


parcelRequire.register("jLSkt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03b6e97f07c9d6c3$export$2e2bcd8739ae039; });

var $iFKqc = parcelRequire("iFKqc");
/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */ var $03b6e97f07c9d6c3$var$SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
function $03b6e97f07c9d6c3$export$2e2bcd8739ae039(country, callingCode, metadata) {
    var countryMetadata = new (0, $iFKqc.default)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    if (countryMetadata.defaultIDDPrefix()) return countryMetadata.defaultIDDPrefix();
    if ($03b6e97f07c9d6c3$var$SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) return countryMetadata.IDDPrefix();
}

});

parcelRequire.register("ek3oA", function(module, exports) {

$parcel$export(module.exports, "formatRFC3966", function () { return $a6d5914119178fef$export$d4f2d2bc1159d115; });

var $kxzbj = parcelRequire("kxzbj");
function $a6d5914119178fef$var$_slicedToArray(arr, i) {
    return $a6d5914119178fef$var$_arrayWithHoles(arr) || $a6d5914119178fef$var$_iterableToArrayLimit(arr, i) || $a6d5914119178fef$var$_unsupportedIterableToArray(arr, i) || $a6d5914119178fef$var$_nonIterableRest();
}
function $a6d5914119178fef$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a6d5914119178fef$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a6d5914119178fef$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $a6d5914119178fef$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $a6d5914119178fef$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a6d5914119178fef$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a6d5914119178fef$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a6d5914119178fef$var$_arrayLikeToArray(o, minLen);
}
function $a6d5914119178fef$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a6d5914119178fef$export$26fe644d7d92bb13(text) {
    var number;
    var ext; // Replace "tel:" with "tel=" for parsing convenience.
    text = text.replace(/^tel:/, "tel=");
    for(var _iterator = $a6d5914119178fef$var$_createForOfIteratorHelperLoose(text.split(";")), _step; !(_step = _iterator()).done;){
        var part = _step.value;
        var _part$split = part.split("="), _part$split2 = $a6d5914119178fef$var$_slicedToArray(_part$split, 2), name = _part$split2[0], value = _part$split2[1];
        switch(name){
            case "tel":
                number = value;
                break;
            case "ext":
                ext = value;
                break;
            case "phone-context":
                // Only "country contexts" are supported.
                // "Domain contexts" are ignored.
                if (value[0] === "+") number = value + number;
                break;
        }
    } // If the phone number is not viable, then abort.
    if (!(0, $kxzbj.default)(number)) return {};
    var result = {
        number: number
    };
    if (ext) result.ext = ext;
    return result;
}
function $a6d5914119178fef$export$d4f2d2bc1159d115(_ref) {
    var number = _ref.number, ext = _ref.ext;
    if (!number) return "";
    if (number[0] !== "+") throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
    return "tel:".concat(number).concat(ext ? ";ext=" + ext : "");
}

});



parcelRequire.register("jCJVh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e495303d8c3f4e31$export$2e2bcd8739ae039; });

var $4AgjR = parcelRequire("4AgjR");

var $kAWqu = parcelRequire("kAWqu");

var $iFKqc = parcelRequire("iFKqc");

var $8XPDb = parcelRequire("8XPDb");
function $e495303d8c3f4e31$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!number) return {};
    var isNumberWithIddPrefix; // If this is not an international phone number,
    // then either extract an "IDD" prefix, or extract a
    // country calling code from a number by autocorrecting it
    // by prepending a leading `+` in cases when it starts
    // with the country calling code.
    // https://wikitravel.org/en/International_dialling_prefix
    // https://github.com/catamphetamine/libphonenumber-js/issues/376
    if (number[0] !== "+") {
        // Convert an "out-of-country" dialing phone number
        // to a proper international phone number.
        var numberWithoutIDD = (0, $4AgjR.default)(number, country, callingCode, metadata); // If an IDD prefix was stripped then
        // convert the number to international one
        // for subsequent parsing.
        if (numberWithoutIDD && numberWithoutIDD !== number) {
            isNumberWithIddPrefix = true;
            number = "+" + numberWithoutIDD;
        } else {
            // Check to see if the number starts with the country calling code
            // for the default country. If so, we remove the country calling code,
            // and do some checks on the validity of the number before and after.
            // https://github.com/catamphetamine/libphonenumber-js/issues/376
            if (country || callingCode) {
                var _extractCountryCallin = (0, $kAWqu.default)(number, country, callingCode, metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
                if (countryCallingCode) return {
                    countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
                    countryCallingCode: countryCallingCode,
                    number: shorterNumber
                };
            }
            return {
                // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
                // countryCallingCodeSource: 'UNSPECIFIED',
                number: number
            };
        }
    } // Fast abortion: country codes do not begin with a '0'
    if (number[1] === "0") return {};
    metadata = new (0, $iFKqc.default)(metadata); // The thing with country phone codes
    // is that they are orthogonal to each other
    // i.e. there's no such country phone code A
    // for which country phone code B exists
    // where B starts with A.
    // Therefore, while scanning digits,
    // if a valid country code is found,
    // that means that it is the country code.
    //
    var i = 2;
    while(i - 1 <= (0, $8XPDb.MAX_LENGTH_COUNTRY_CODE) && i <= number.length){
        var _countryCallingCode = number.slice(1, i);
        if (metadata.hasCallingCode(_countryCallingCode)) {
            metadata.selectNumberingPlan(_countryCallingCode);
            return {
                countryCallingCodeSource: isNumberWithIddPrefix ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
                countryCallingCode: _countryCallingCode,
                number: number.slice(i)
            };
        }
        i++;
    }
    return {};
} // The possible values for the returned `countryCallingCodeSource` are:
 //
 // Copy-pasted from:
 // https://github.com/google/libphonenumber/blob/master/resources/phonenumber.proto
 //
 // // The source from which the country_code is derived. This is not set in the
 // // general parsing method, but in the method that parses and keeps raw_input.
 // // New fields could be added upon request.
 // enum CountryCodeSource {
 //  // Default value returned if this is not set, because the phone number was
 //  // created using parse, not parseAndKeepRawInput. hasCountryCodeSource will
 //  // return false if this is the case.
 //  UNSPECIFIED = 0;
 //
 //  // The country_code is derived based on a phone number with a leading "+",
 //  // e.g. the French number "+33 1 42 68 53 00".
 //  FROM_NUMBER_WITH_PLUS_SIGN = 1;
 //
 //  // The country_code is derived based on a phone number with a leading IDD,
 //  // e.g. the French number "011 33 1 42 68 53 00", as it is dialled from US.
 //  FROM_NUMBER_WITH_IDD = 5;
 //
 //  // The country_code is derived based on a phone number without a leading
 //  // "+", e.g. the French number "33 1 42 68 53 00" when defaultCountry is
 //  // supplied as France.
 //  FROM_NUMBER_WITHOUT_PLUS_SIGN = 10;
 //
 //  // The country_code is derived NOT based on the phone number itself, but
 //  // from the defaultCountry parameter provided in the parsing function by the
 //  // clients. This happens mostly for numbers written in the national format
 //  // (without country code). For example, this would be set when parsing the
 //  // French number "01 42 68 53 00", when defaultCountry is supplied as
 //  // France.
 //  FROM_DEFAULT_COUNTRY = 20;
 // }

});
parcelRequire.register("4AgjR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35672eec073ccdbc$export$2e2bcd8739ae039; });

var $iFKqc = parcelRequire("iFKqc");

var $8XPDb = parcelRequire("8XPDb");
var $35672eec073ccdbc$var$CAPTURING_DIGIT_PATTERN = new RegExp("([" + (0, $8XPDb.VALID_DIGITS) + "])");
function $35672eec073ccdbc$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!country) return;
     // Check if the number is IDD-prefixed.
    var countryMetadata = new (0, $iFKqc.default)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
    if (number.search(IDDPrefixPattern) !== 0) return;
     // Strip IDD prefix.
    number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
    // then those digits are a country calling code.
    // Since no country code starts with a `0`,
    // the code below validates that the next digit (if present) is not `0`.
    var matchedGroups = number.match($35672eec073ccdbc$var$CAPTURING_DIGIT_PATTERN);
    if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
        if (matchedGroups[1] === "0") return;
    }
    return number;
}

});

parcelRequire.register("kAWqu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $efe47da7a8c8dcad$export$2e2bcd8739ae039; });

var $iFKqc = parcelRequire("iFKqc");

var $4v8FZ = parcelRequire("4v8FZ");

var $ipav4 = parcelRequire("ipav4");

var $5Cqti = parcelRequire("5Cqti");

var $iFKqc = parcelRequire("iFKqc");
function $efe47da7a8c8dcad$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    var countryCallingCode = country ? (0, $iFKqc.getCountryCallingCode)(country, metadata) : callingCode;
    if (number.indexOf(countryCallingCode) === 0) {
        metadata = new (0, $iFKqc.default)(metadata);
        metadata.selectNumberingPlan(country, callingCode);
        var possibleShorterNumber = number.slice(countryCallingCode.length);
        var _extractNationalNumbe = (0, $ipav4.default)(possibleShorterNumber, metadata), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
        var _extractNationalNumbe2 = (0, $ipav4.default)(number, metadata), nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
        // or if it was too long before, we consider the number
        // with the country calling code stripped to be a better result
        // and keep that instead.
        // For example, in Germany (+49), `49` is a valid area code,
        // so if a number starts with `49`, it could be both a valid
        // national German number or an international number without
        // a leading `+`.
        if (!(0, $4v8FZ.default)(nationalNumber, metadata.nationalNumberPattern()) && (0, $4v8FZ.default)(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || (0, $5Cqti.default)(nationalNumber, metadata) === "TOO_LONG") return {
            countryCallingCode: countryCallingCode,
            number: possibleShorterNumber
        };
    }
    return {
        number: number
    };
}

});
parcelRequire.register("ipav4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d662b4e2f9146bc2$export$2e2bcd8739ae039; });

var $gNYaO = parcelRequire("gNYaO");

var $4v8FZ = parcelRequire("4v8FZ");

var $5Cqti = parcelRequire("5Cqti");
function $d662b4e2f9146bc2$export$2e2bcd8739ae039(number, metadata) {
    // Parsing national prefixes and carrier codes
    // is only required for local phone numbers
    // but some people don't understand that
    // and sometimes write international phone numbers
    // with national prefixes (or maybe even carrier codes).
    // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
    // Google's original library forgives such mistakes
    // and so does this library, because it has been requested:
    // https://github.com/catamphetamine/libphonenumber-js/issues/127
    var _extractNationalNumbe = (0, $gNYaO.default)(number, metadata), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
    if (nationalNumber !== number) {
        if (!$d662b4e2f9146bc2$var$shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) // Don't strip the national prefix.
        return {
            nationalNumber: number
        };
         // Check the national (significant) number length after extracting national prefix and carrier code.
        // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.
        if (metadata.possibleLengths()) {
            // The number remaining after stripping the national prefix and carrier code
            // should be long enough to have a possible length for the country.
            // Otherwise, don't strip the national prefix and carrier code,
            // since the original number could be a valid number.
            // This check has been copy-pasted "as is" from Google's original library:
            // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
            // It doesn't check for the "possibility" of the original `number`.
            // I guess it's fine not checking that one. It works as is anyway.
            if (!$d662b4e2f9146bc2$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata)) // Don't strip the national prefix.
            return {
                nationalNumber: number
            };
        }
    }
    return {
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.
function $d662b4e2f9146bc2$var$shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
    // The equivalent in Google's code is:
    // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
    if ((0, $4v8FZ.default)(nationalNumberBefore, metadata.nationalNumberPattern()) && !(0, $4v8FZ.default)(nationalNumberAfter, metadata.nationalNumberPattern())) return false;
     // This "is possible" national number (length) check has been commented out
    // because it's superceded by the (effectively) same check done in the
    // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
    // In other words, why run the same check twice if it could only be run once.
    // // Check the national (significant) number length after extracting national prefix and carrier code.
    // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
    // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
    // if (metadata.possibleLengths()) {
    // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
    // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
    // 		return false
    // 	}
    // }
    return true;
}
function $d662b4e2f9146bc2$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
    switch((0, $5Cqti.default)(nationalNumber, metadata)){
        case "TOO_SHORT":
        case "INVALID_LENGTH":
            // This library ignores "local-only" phone numbers (for simplicity).
            // See the readme for more info on what are "local-only" phone numbers.
            // case 'IS_POSSIBLE_LOCAL_ONLY':
            return false;
        default:
            return true;
    }
}

});
parcelRequire.register("gNYaO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3bfe621e4baf549$export$2e2bcd8739ae039; });
/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */ function $c3bfe621e4baf549$export$2e2bcd8739ae039(number, metadata) {
    if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
        // See METADATA.md for the description of
        // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
        // Attempt to parse the first digits as a national prefix.
        var prefixPattern = new RegExp("^(?:" + metadata.numberingPlan.nationalPrefixForParsing() + ")");
        var prefixMatch = prefixPattern.exec(number);
        if (prefixMatch) {
            var nationalNumber;
            var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
            // If a `national_prefix_for_parsing` has any "capturing groups"
            // then it means that the national (significant) number is equal to
            // those "capturing groups" transformed via `national_prefix_transform_rule`,
            // and nothing could be said about the actual national prefix:
            // what is it and was it even there.
            // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
            // then everything it matches is a national prefix.
            // To determine whether `national_prefix_for_parsing` matched any
            // "capturing groups", the value of the result of calling `.exec()`
            // is looked at, and if it has non-undefined values where there're
            // "capturing groups" in the regular expression, then it means
            // that "capturing groups" have been matched.
            // It's not possible to tell whether there'll be any "capturing gropus"
            // before the matching process, because a `national_prefix_for_parsing`
            // could exhibit both behaviors.
            var capturedGroupsCount = prefixMatch.length - 1;
            var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
            if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
                nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
                // then carrier code is the second one.
                if (capturedGroupsCount > 1) carrierCode = prefixMatch[1];
            } else {
                // `prefixBeforeNationalNumber` is the whole substring matched by
                // the `national_prefix_for_parsing` regular expression.
                // There seem to be no guarantees that it's just a national prefix.
                // For example, if there's a carrier code, it's gonna be a
                // part of `prefixBeforeNationalNumber` too.
                var prefixBeforeNationalNumber = prefixMatch[0];
                nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
                // then carrier code is the first one.
                if (hasCapturedGroups) carrierCode = prefixMatch[1];
            } // Tries to guess whether a national prefix was present in the input.
            // This is not something copy-pasted from Google's library:
            // they don't seem to have an equivalent for that.
            // So this isn't an "officially approved" way of doing something like that.
            // But since there seems no other existing method, this library uses it.
            var nationalPrefix;
            if (hasCapturedGroups) {
                var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
                var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
                // `prefixMatch[0]` is `01115`, and `$1` is `11`,
                // and the rest of the phone number is `23456789`.
                // The national number is transformed via `9$1` to `91123456789`.
                // National prefix `0` is detected being present at the start.
                // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {
                if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) nationalPrefix = metadata.numberingPlan.nationalPrefix();
            } else nationalPrefix = prefixMatch[0];
            return {
                nationalNumber: nationalNumber,
                nationalPrefix: nationalPrefix,
                carrierCode: carrierCode
            };
        }
    }
    return {
        nationalNumber: number
    };
}

});




parcelRequire.register("5jaRq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3dd726d160f51659$export$2e2bcd8739ae039; });

var $9lVHo = parcelRequire("9lVHo");
var $3dd726d160f51659$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function $3dd726d160f51659$export$2e2bcd8739ae039(callingCode, _ref) {
    var nationalPhoneNumber = _ref.nationalNumber, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    /* istanbul ignore if */ if ($3dd726d160f51659$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (metadata.isNonGeographicCallingCode(callingCode)) return "001";
    }
    var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return;
     // If there's just one country corresponding to the country code,
    // then just return it, without further phone number digits validation.
    if (possibleCountries.length === 1) return possibleCountries[0];
    return (0, $9lVHo.default)(nationalPhoneNumber, {
        countries: possibleCountries,
        defaultCountry: defaultCountry,
        metadata: metadata.metadata
    });
}

});
parcelRequire.register("9lVHo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6cf2d500e2deab65$export$2e2bcd8739ae039; });

var $iFKqc = parcelRequire("iFKqc");

var $2cIol = parcelRequire("2cIol");
function $6cf2d500e2deab65$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $6cf2d500e2deab65$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6cf2d500e2deab65$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6cf2d500e2deab65$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6cf2d500e2deab65$var$_arrayLikeToArray(o, minLen);
}
function $6cf2d500e2deab65$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6cf2d500e2deab65$export$2e2bcd8739ae039(nationalPhoneNumber, _ref) {
    var countries = _ref.countries, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    // Re-create `metadata` because it will be selecting a `country`.
    metadata = new (0, $iFKqc.default)(metadata);
    var matchingCountries = [];
    for(var _iterator = $6cf2d500e2deab65$var$_createForOfIteratorHelperLoose(countries), _step; !(_step = _iterator()).done;){
        var country = _step.value;
        metadata.country(country); // "Leading digits" patterns are only defined for about 20% of all countries.
        // By definition, matching "leading digits" is a sufficient but not a necessary
        // condition for a phone number to belong to a country.
        // The point of "leading digits" check is that it's the fastest one to get a match.
        // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
        // I'd suppose that "leading digits" patterns are mutually exclusive for different countries
        // because of the intended use of that feature.
        if (metadata.leadingDigits()) {
            if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) return country;
        } else if ((0, $2cIol.default)({
            phone: nationalPhoneNumber,
            country: country
        }, undefined, metadata.metadata)) {
            // If the `defaultCountry` is among the `matchingCountries` then return it.
            if (defaultCountry) {
                if (country === defaultCountry) return country;
                matchingCountries.push(country);
            } else return country;
        }
    } // Return the first ("main") one of the `matchingCountries`.
    if (matchingCountries.length > 0) return matchingCountries[0];
}

});


parcelRequire.register("eoRHm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7bcf5f6c6dde947$export$2e2bcd8739ae039; });

var $1PQwJ = parcelRequire("1PQwJ");

var $7SnHu = parcelRequire("7SnHu");
function $a7bcf5f6c6dde947$export$2e2bcd8739ae039(numberToParse, _ref) {
    var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
    var phoneContext = (0, $1PQwJ.default)(numberToParse);
    if (!(0, $1PQwJ.isPhoneContextValid)(phoneContext)) throw new (0, $7SnHu.default)("NOT_A_NUMBER");
    var phoneNumberString;
    if (phoneContext === null) // Extract a possible number from the string passed in.
    // (this strips leading characters that could not be the start of a phone number)
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || "";
    else {
        phoneNumberString = ""; // If the phone context contains a phone number prefix, we need to capture
        // it, whereas domains will be ignored.
        if (phoneContext.charAt(0) === (0, $1PQwJ.PLUS_SIGN)) phoneNumberString += phoneContext;
         // Now append everything between the "tel:" prefix and the phone-context.
        // This should include the national number, an optional extension or
        // isdn-subaddress component. Note we also handle the case when "tel:" is
        // missing, as we have seen in some of the phone number inputs.
        // In that case, we append everything from the beginning.
        var indexOfRfc3966Prefix = numberToParse.indexOf((0, $1PQwJ.RFC3966_PREFIX_));
        var indexOfNationalNumber; // RFC 3966 "tel:" prefix is preset at this stage because
        // `isPhoneContextValid()` requires it to be present.
        /* istanbul ignore else */ if (indexOfRfc3966Prefix >= 0) indexOfNationalNumber = indexOfRfc3966Prefix + (0, $1PQwJ.RFC3966_PREFIX_).length;
        else indexOfNationalNumber = 0;
        var indexOfPhoneContext = numberToParse.indexOf((0, $1PQwJ.RFC3966_PHONE_CONTEXT_));
        phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
    } // Delete the isdn-subaddress and everything after it if it is present.
    // Note extension won't appear at the same time with isdn-subaddress
    // according to paragraph 5.3 of the RFC3966 spec.
    var indexOfIsdn = phoneNumberString.indexOf((0, $1PQwJ.RFC3966_ISDN_SUBADDRESS_));
    if (indexOfIsdn > 0) phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
     // If both phone context and isdn-subaddress are absent but other
    // parameters are present, the parameters are left in nationalNumber.
    // This is because we are concerned about deleting content from a potential
    // number string when there is no strong evidence that the number is
    // actually written in RFC3966.
    if (phoneNumberString !== "") return phoneNumberString;
}

});
parcelRequire.register("1PQwJ", function(module, exports) {

$parcel$export(module.exports, "PLUS_SIGN", function () { return $15634c9ab47342d0$export$1ddc7eed78155f68; });
$parcel$export(module.exports, "RFC3966_PREFIX_", function () { return $15634c9ab47342d0$export$70d485ce3f6de783; });
$parcel$export(module.exports, "RFC3966_PHONE_CONTEXT_", function () { return $15634c9ab47342d0$export$f6d5879d582c3a27; });
$parcel$export(module.exports, "RFC3966_ISDN_SUBADDRESS_", function () { return $15634c9ab47342d0$export$9e356e12edb00a81; });
$parcel$export(module.exports, "default", function () { return $15634c9ab47342d0$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "isPhoneContextValid", function () { return $15634c9ab47342d0$export$474a4aa22ad6959a; });
// When phone numbers are written in `RFC3966` format — `"tel:+12133734253"` —
// they can have their "calling code" part written separately in a `phone-context` parameter.
// Example: `"tel:12133734253;phone-context=+1"`.
// This function parses the full phone number from the local number and the `phone-context`
// when the `phone-context` contains a `+` sign.

var $8XPDb = parcelRequire("8XPDb");
var $15634c9ab47342d0$export$1ddc7eed78155f68 = "+";
var $15634c9ab47342d0$var$RFC3966_VISUAL_SEPARATOR_ = "[\\-\\.\\(\\)]?";
var $15634c9ab47342d0$var$RFC3966_PHONE_DIGIT_ = "([" + (0, $8XPDb.VALID_DIGITS) + "]" + "|" + $15634c9ab47342d0$var$RFC3966_VISUAL_SEPARATOR_ + ")";
var $15634c9ab47342d0$var$RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + $15634c9ab47342d0$export$1ddc7eed78155f68 + $15634c9ab47342d0$var$RFC3966_PHONE_DIGIT_ + "*" + "[" + (0, $8XPDb.VALID_DIGITS) + "]" + $15634c9ab47342d0$var$RFC3966_PHONE_DIGIT_ + "*" + "$";
/**
 * Regular expression of valid global-number-digits for the phone-context
 * parameter, following the syntax defined in RFC3966.
 */ var $15634c9ab47342d0$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp($15634c9ab47342d0$var$RFC3966_GLOBAL_NUMBER_DIGITS_, "g"); // In this port of Google's library, we don't accept alpha characters in phone numbers.
// const ALPHANUM_ = VALID_ALPHA_ + VALID_DIGITS
var $15634c9ab47342d0$var$ALPHANUM_ = (0, $8XPDb.VALID_DIGITS);
var $15634c9ab47342d0$var$RFC3966_DOMAINLABEL_ = "[" + $15634c9ab47342d0$var$ALPHANUM_ + "]+((\\-)*[" + $15634c9ab47342d0$var$ALPHANUM_ + "])*";
var $15634c9ab47342d0$var$VALID_ALPHA_ = "a-zA-Z";
var $15634c9ab47342d0$var$RFC3966_TOPLABEL_ = "[" + $15634c9ab47342d0$var$VALID_ALPHA_ + "]+((\\-)*[" + $15634c9ab47342d0$var$ALPHANUM_ + "])*";
var $15634c9ab47342d0$var$RFC3966_DOMAINNAME_ = "^(" + $15634c9ab47342d0$var$RFC3966_DOMAINLABEL_ + "\\.)*" + $15634c9ab47342d0$var$RFC3966_TOPLABEL_ + "\\.?$";
/**
 * Regular expression of valid domainname for the phone-context parameter,
 * following the syntax defined in RFC3966.
 */ var $15634c9ab47342d0$var$RFC3966_DOMAINNAME_PATTERN_ = new RegExp($15634c9ab47342d0$var$RFC3966_DOMAINNAME_, "g");
var $15634c9ab47342d0$export$70d485ce3f6de783 = "tel:";
var $15634c9ab47342d0$export$f6d5879d582c3a27 = ";phone-context=";
var $15634c9ab47342d0$export$9e356e12edb00a81 = ";isub=";
function $15634c9ab47342d0$export$2e2bcd8739ae039(numberToExtractFrom) {
    var indexOfPhoneContext = numberToExtractFrom.indexOf($15634c9ab47342d0$export$f6d5879d582c3a27); // If no phone-context parameter is present
    if (indexOfPhoneContext < 0) return null;
    var phoneContextStart = indexOfPhoneContext + $15634c9ab47342d0$export$f6d5879d582c3a27.length; // If phone-context parameter is empty
    if (phoneContextStart >= numberToExtractFrom.length) return "";
    var phoneContextEnd = numberToExtractFrom.indexOf(";", phoneContextStart); // If phone-context is not the last parameter
    if (phoneContextEnd >= 0) return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
    else return numberToExtractFrom.substring(phoneContextStart);
}
function $15634c9ab47342d0$export$474a4aa22ad6959a(phoneContext) {
    if (phoneContext === null) return true;
    if (phoneContext.length === 0) return false;
     // Does phone-context value match pattern of global-number-digits or domainname.
    return $15634c9ab47342d0$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || $15634c9ab47342d0$var$RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}

});




parcelRequire.register("hmkJ5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca34918f209a9409$export$2e2bcd8739ae039; });

var $6cJfw = parcelRequire("6cJfw");
function $ca34918f209a9409$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ca34918f209a9409$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ca34918f209a9409$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ca34918f209a9409$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ca34918f209a9409$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ca34918f209a9409$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ca34918f209a9409$var$_slicedToArray(arr, i) {
    return $ca34918f209a9409$var$_arrayWithHoles(arr) || $ca34918f209a9409$var$_iterableToArrayLimit(arr, i) || $ca34918f209a9409$var$_unsupportedIterableToArray(arr, i) || $ca34918f209a9409$var$_nonIterableRest();
}
function $ca34918f209a9409$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ca34918f209a9409$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ca34918f209a9409$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ca34918f209a9409$var$_arrayLikeToArray(o, minLen);
}
function $ca34918f209a9409$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ca34918f209a9409$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $ca34918f209a9409$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $ca34918f209a9409$export$2e2bcd8739ae039(args) {
    var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = $ca34918f209a9409$var$_slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
    var text;
    var options;
    var metadata; // If the phone number is passed as a string.
    // `parsePhoneNumber('88005553535', ...)`.
    if (typeof arg_1 === "string") text = arg_1;
    else throw new TypeError("A text for parsing must be a string."); // If "default country" argument is being passed then move it to `options`.
    // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.
    if (!arg_2 || typeof arg_2 === "string") {
        if (arg_4) {
            options = arg_3;
            metadata = arg_4;
        } else {
            options = undefined;
            metadata = arg_3;
        }
        if (arg_2) options = $ca34918f209a9409$var$_objectSpread({
            defaultCountry: arg_2
        }, options);
    } else if ((0, $6cJfw.default)(arg_2)) {
        if (arg_3) {
            options = arg_2;
            metadata = arg_3;
        } else metadata = arg_2;
    } else throw new Error("Invalid second argument: ".concat(arg_2));
    return {
        text: text,
        options: options,
        metadata: metadata
    };
}

});




parcelRequire.register("1Iqyx", function(module, exports) {

$parcel$export(module.exports, "isValidSubdomain", function () { return $13fe7ffa5e030689$export$7621d68d5c3b3a53; });
/**
 * Checks if the subdomain string is valid
 * @param subdomain subdomain string
 * @returns boolean indicating whether the subdomain is valid
 */ const $13fe7ffa5e030689$export$7621d68d5c3b3a53 = (subdomain)=>/^([\da-z]([\da-z-]{0,61}[\da-z])?)$/.test(subdomain);

});

parcelRequire.register("fy1wJ", function(module, exports) {
/**
 * A cache that expires entries after a given time-to-live (TTL). It uses a
 * `Map` in memory to store the entries.
 */ class $b51b373a055a9e2a$export$4421a7403324ea68 {
    /**
     * @param ttl The default TTL for entries in milliseconds. Defaults to
     * `Number.POSITIVE_INFINITY`.
     */ constructor(ttl = Number.POSITIVE_INFINITY){
        this.ttl = ttl;
        this.data = new Map();
        this.expiration = new Map();
    }
    /**
     * Sets a value in the cache.
     * @param key The key to set.
     * @param value The value to set.
     * @param ttl The TTL for the entry in milliseconds. Defaults to the default
     * TTL.
     * @throws If the value is `undefined`.
     */ set(key, value, ttl = this.ttl) {
        if (value === undefined) throw new TypeError("Value cannot be undefined");
        this.expiration.set(key, Date.now() + ttl);
        this.data.set(key, value);
    }
    /**
     * Gets a value from the cache.
     * @param key The key to get.
     * @returns The value or `undefined` if the entry has expired or does not
     * exist.
     */ get(key) {
        this.#purge(key);
        return this.data.get(key);
    }
    /**
     * Checks if a key exists in the cache.
     * @param key The key to check.
     * @returns `true` if the key exists and has not expired, `false` otherwise.
     */ has(key) {
        this.#purge(key);
        return this.data.has(key);
    }
    /**
     * Deletes a key and its value from the cache. If the key does not exist, this
     * method does nothing.
     * @param key The key to delete.
     * @returns `true` if the key existed and was deleted, `false` otherwise.
     */ delete(key) {
        this.expiration.delete(key);
        return this.data.delete(key);
    }
    /**
     * Clears the cache. All entries will be deleted.
     */ clear() {
        this.expiration.clear();
        this.data.clear();
    }
    #purge(key) {
        const expiration = this.expiration.get(key);
        if (expiration !== undefined && expiration < Date.now()) this.delete(key);
    }
}

});

parcelRequire.register("clvkc", function(module, exports) {

$parcel$export(module.exports, "getUserDisplayName", function () { return $8fcfbeaa169d4c1f$export$b86884fca6ca2c21; });
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $51A9u = parcelRequire("51A9u");
const $8fcfbeaa169d4c1f$export$b86884fca6ca2c21 = ({ name: name, username: username, primaryEmail: primaryEmail, primaryPhone: primaryPhone })=>{
    const formattedPhoneNumber = (0, $7oDSS.conditional)(primaryPhone && (0, $51A9u.formatToInternationalPhoneNumber)(primaryPhone));
    return name ?? primaryEmail ?? formattedPhoneNumber ?? username ?? undefined;
};

});



parcelRequire.register("c3dK3", function(module, exports) {

$parcel$export(module.exports, "string", function () { return $2432650d76dfe5e5$export$22b082955e083ec3; });
$parcel$export(module.exports, "number", function () { return $2432650d76dfe5e5$export$98e628dec113755e; });
$parcel$export(module.exports, "any", function () { return $2432650d76dfe5e5$export$4154a199d7d90455; });
$parcel$export(module.exports, "array", function () { return $2432650d76dfe5e5$export$2f23118c22fb2630; });
$parcel$export(module.exports, "object", function () { return $2432650d76dfe5e5$export$be5493f9613cbbe; });
$parcel$export(module.exports, "z", function () { return $2432650d76dfe5e5$export$2e2bcd8739ae039; });
var $2432650d76dfe5e5$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($2432650d76dfe5e5$export$7debb50ef11d5e0b || ($2432650d76dfe5e5$export$7debb50ef11d5e0b = {}));
var $2432650d76dfe5e5$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($2432650d76dfe5e5$export$4aa2142c225fd5c7 || ($2432650d76dfe5e5$export$4aa2142c225fd5c7 = {}));
const $2432650d76dfe5e5$export$5716da67bfaa244d = $2432650d76dfe5e5$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $2432650d76dfe5e5$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $2432650d76dfe5e5$export$5716da67bfaa244d.undefined;
        case "string":
            return $2432650d76dfe5e5$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $2432650d76dfe5e5$export$5716da67bfaa244d.nan : $2432650d76dfe5e5$export$5716da67bfaa244d.number;
        case "boolean":
            return $2432650d76dfe5e5$export$5716da67bfaa244d.boolean;
        case "function":
            return $2432650d76dfe5e5$export$5716da67bfaa244d.function;
        case "bigint":
            return $2432650d76dfe5e5$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $2432650d76dfe5e5$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $2432650d76dfe5e5$export$5716da67bfaa244d.array;
            if (data === null) return $2432650d76dfe5e5$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $2432650d76dfe5e5$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $2432650d76dfe5e5$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $2432650d76dfe5e5$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $2432650d76dfe5e5$export$5716da67bfaa244d.date;
            return $2432650d76dfe5e5$export$5716da67bfaa244d.object;
        default:
            return $2432650d76dfe5e5$export$5716da67bfaa244d.unknown;
    }
};
const $2432650d76dfe5e5$export$5ba560653e4a1035 = $2432650d76dfe5e5$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $2432650d76dfe5e5$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $2432650d76dfe5e5$export$f98dac4b251ab333 extends Error {
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $2432650d76dfe5e5$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$2432650d76dfe5e5$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $2432650d76dfe5e5$export$f98dac4b251ab333(issues);
    return error;
};
const $2432650d76dfe5e5$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $2432650d76dfe5e5$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $2432650d76dfe5e5$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $2432650d76dfe5e5$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$2432650d76dfe5e5$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$2432650d76dfe5e5$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$2432650d76dfe5e5$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $2432650d76dfe5e5$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $2432650d76dfe5e5$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $2432650d76dfe5e5$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $2432650d76dfe5e5$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $2432650d76dfe5e5$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $2432650d76dfe5e5$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $2432650d76dfe5e5$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $2432650d76dfe5e5$var$overrideErrorMap = $2432650d76dfe5e5$export$341b0b6e0a6f5099;
function $2432650d76dfe5e5$export$1097a8289cfd22d7(map) {
    $2432650d76dfe5e5$var$overrideErrorMap = map;
}
function $2432650d76dfe5e5$export$32f27c719778d4c4() {
    return $2432650d76dfe5e5$var$overrideErrorMap;
}
const $2432650d76dfe5e5$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: issueData.message || errorMessage
    };
};
const $2432650d76dfe5e5$export$1526d2e05f74572 = [];
function $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, issueData) {
    const issue = $2432650d76dfe5e5$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            $2432650d76dfe5e5$export$32f27c719778d4c4(),
            $2432650d76dfe5e5$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $2432650d76dfe5e5$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $2432650d76dfe5e5$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs)syncPairs.push({
            key: await pair.key,
            value: await pair.value
        });
        return $2432650d76dfe5e5$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $2432650d76dfe5e5$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $2432650d76dfe5e5$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $2432650d76dfe5e5$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $2432650d76dfe5e5$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $2432650d76dfe5e5$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $2432650d76dfe5e5$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $2432650d76dfe5e5$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $2432650d76dfe5e5$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $2432650d76dfe5e5$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
var $2432650d76dfe5e5$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($2432650d76dfe5e5$var$errorUtil || ($2432650d76dfe5e5$var$errorUtil = {}));
class $2432650d76dfe5e5$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $2432650d76dfe5e5$var$handleResult = (ctx, result)=>{
    if ($2432650d76dfe5e5$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $2432650d76dfe5e5$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $2432650d76dfe5e5$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError
        };
        return {
            message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $2432650d76dfe5e5$export$19342e026b58ebb7 {
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $2432650d76dfe5e5$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $2432650d76dfe5e5$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $2432650d76dfe5e5$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $2432650d76dfe5e5$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($2432650d76dfe5e5$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $2432650d76dfe5e5$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $2432650d76dfe5e5$var$handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $2432650d76dfe5e5$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($2432650d76dfe5e5$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $2432650d76dfe5e5$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $2432650d76dfe5e5$export$5ba560653e4a1035.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $2432650d76dfe5e5$export$a60af00cc0ce2582({
            schema: this,
            typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $2432650d76dfe5e5$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $2432650d76dfe5e5$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $2432650d76dfe5e5$export$7acfc3e64785411.create(this, this._def);
    }
    promise() {
        return $2432650d76dfe5e5$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $2432650d76dfe5e5$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $2432650d76dfe5e5$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $2432650d76dfe5e5$export$a60af00cc0ce2582({
            ...$2432650d76dfe5e5$var$processCreateParams(this._def),
            schema: this,
            typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $2432650d76dfe5e5$export$bb19b37874861e7e({
            ...$2432650d76dfe5e5$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $2432650d76dfe5e5$export$66b0c798a395271f({
            typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$2432650d76dfe5e5$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $2432650d76dfe5e5$export$75a44ec6249ac76b({
            ...$2432650d76dfe5e5$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $2432650d76dfe5e5$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $2432650d76dfe5e5$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $2432650d76dfe5e5$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $2432650d76dfe5e5$var$cuid2Regex = /^[a-z][a-z0-9]*$/;
const $2432650d76dfe5e5$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $2432650d76dfe5e5$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $2432650d76dfe5e5$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $2432650d76dfe5e5$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $2432650d76dfe5e5$var$emojiRegex;
const $2432650d76dfe5e5$var$ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
const $2432650d76dfe5e5$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// Adapted from https://stackoverflow.com/a/3143231
const $2432650d76dfe5e5$var$datetimeRegex = (args)=>{
    if (args.precision) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
    } else if (args.precision === 0) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
    } else {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
    }
};
function $2432650d76dfe5e5$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $2432650d76dfe5e5$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $2432650d76dfe5e5$var$ipv6Regex.test(ip)) return true;
    return false;
}
class $2432650d76dfe5e5$export$1230eb29b8d3b502 extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $2432650d76dfe5e5$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_type,
                expected: $2432650d76dfe5e5$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $2432650d76dfe5e5$export$9a105a556e65c2c0;
        }
        const status = new $2432650d76dfe5e5$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                        code: $2432650d76dfe5e5$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                        code: $2432650d76dfe5e5$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                        code: $2432650d76dfe5e5$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                        code: $2432650d76dfe5e5$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$2432650d76dfe5e5$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$2432650d76dfe5e5$var$emojiRegex) $2432650d76dfe5e5$var$emojiRegex = new RegExp($2432650d76dfe5e5$var$_emojiRegex, "u");
                if (!$2432650d76dfe5e5$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$2432650d76dfe5e5$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$2432650d76dfe5e5$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$2432650d76dfe5e5$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$2432650d76dfe5e5$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                        code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                        code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                        code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $2432650d76dfe5e5$var$datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                        code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$2432650d76dfe5e5$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $2432650d76dfe5e5$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_string,
            ...$2432650d76dfe5e5$var$errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new $2432650d76dfe5e5$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$2432650d76dfe5e5$var$errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$2432650d76dfe5e5$var$errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$2432650d76dfe5e5$var$errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$2432650d76dfe5e5$var$errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$2432650d76dfe5e5$var$errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$2432650d76dfe5e5$var$errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$2432650d76dfe5e5$var$errorUtil.errToObj(message)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$2432650d76dfe5e5$var$errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            ...$2432650d76dfe5e5$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$2432650d76dfe5e5$var$errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$2432650d76dfe5e5$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$2432650d76dfe5e5$var$errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$2432650d76dfe5e5$var$errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$2432650d76dfe5e5$var$errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$2432650d76dfe5e5$var$errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$2432650d76dfe5e5$var$errorUtil.errToObj(message)
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */ nonempty(message) {
        return this.min(1, $2432650d76dfe5e5$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $2432650d76dfe5e5$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $2432650d76dfe5e5$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $2432650d76dfe5e5$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$2432650d76dfe5e5$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $2432650d76dfe5e5$export$1230eb29b8d3b502({
        checks: [],
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $2432650d76dfe5e5$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $2432650d76dfe5e5$export$5b070a55c0c43e09 extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $2432650d76dfe5e5$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_type,
                expected: $2432650d76dfe5e5$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $2432650d76dfe5e5$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $2432650d76dfe5e5$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$2432650d76dfe5e5$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                        code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                        code: $2432650d76dfe5e5$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                        code: $2432650d76dfe5e5$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($2432650d76dfe5e5$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                        code: $2432650d76dfe5e5$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                        code: $2432650d76dfe5e5$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $2432650d76dfe5e5$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $2432650d76dfe5e5$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $2432650d76dfe5e5$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $2432650d76dfe5e5$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $2432650d76dfe5e5$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $2432650d76dfe5e5$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $2432650d76dfe5e5$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $2432650d76dfe5e5$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $2432650d76dfe5e5$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $2432650d76dfe5e5$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $2432650d76dfe5e5$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $2432650d76dfe5e5$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $2432650d76dfe5e5$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $2432650d76dfe5e5$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $2432650d76dfe5e5$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $2432650d76dfe5e5$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $2432650d76dfe5e5$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $2432650d76dfe5e5$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$2432650d76dfe5e5$export$5b070a55c0c43e09.create = (params)=>{
    return new $2432650d76dfe5e5$export$5b070a55c0c43e09({
        checks: [],
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
class $2432650d76dfe5e5$export$67d741fd70ff98f4 extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) input.data = BigInt(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $2432650d76dfe5e5$export$5716da67bfaa244d.bigint) {
            const ctx = this._getOrReturnCtx(input);
            $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_type,
                expected: $2432650d76dfe5e5$export$5716da67bfaa244d.bigint,
                received: ctx.parsedType
            });
            return $2432650d76dfe5e5$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $2432650d76dfe5e5$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                        code: $2432650d76dfe5e5$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                        code: $2432650d76dfe5e5$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                        code: $2432650d76dfe5e5$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $2432650d76dfe5e5$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $2432650d76dfe5e5$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $2432650d76dfe5e5$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $2432650d76dfe5e5$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $2432650d76dfe5e5$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $2432650d76dfe5e5$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $2432650d76dfe5e5$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $2432650d76dfe5e5$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $2432650d76dfe5e5$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $2432650d76dfe5e5$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $2432650d76dfe5e5$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $2432650d76dfe5e5$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $2432650d76dfe5e5$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$2432650d76dfe5e5$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $2432650d76dfe5e5$export$67d741fd70ff98f4({
        checks: [],
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
class $2432650d76dfe5e5$export$723d146f80596191 extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $2432650d76dfe5e5$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_type,
                expected: $2432650d76dfe5e5$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $2432650d76dfe5e5$export$9a105a556e65c2c0;
        }
        return $2432650d76dfe5e5$export$c6813a8d51f77eaf(input.data);
    }
}
$2432650d76dfe5e5$export$723d146f80596191.create = (params)=>{
    return new $2432650d76dfe5e5$export$723d146f80596191({
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
class $2432650d76dfe5e5$export$e974be33bdc55521 extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $2432650d76dfe5e5$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_type,
                expected: $2432650d76dfe5e5$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $2432650d76dfe5e5$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_date
            });
            return $2432650d76dfe5e5$export$9a105a556e65c2c0;
        }
        const status = new $2432650d76dfe5e5$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                        code: $2432650d76dfe5e5$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                        code: $2432650d76dfe5e5$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $2432650d76dfe5e5$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $2432650d76dfe5e5$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $2432650d76dfe5e5$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $2432650d76dfe5e5$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$2432650d76dfe5e5$export$e974be33bdc55521.create = (params)=>{
    return new $2432650d76dfe5e5$export$e974be33bdc55521({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodDate,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
class $2432650d76dfe5e5$export$bcc3b40f6b638044 extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $2432650d76dfe5e5$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_type,
                expected: $2432650d76dfe5e5$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $2432650d76dfe5e5$export$9a105a556e65c2c0;
        }
        return $2432650d76dfe5e5$export$c6813a8d51f77eaf(input.data);
    }
}
$2432650d76dfe5e5$export$bcc3b40f6b638044.create = (params)=>{
    return new $2432650d76dfe5e5$export$bcc3b40f6b638044({
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodSymbol,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
class $2432650d76dfe5e5$export$4e780e961c30340d extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $2432650d76dfe5e5$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_type,
                expected: $2432650d76dfe5e5$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $2432650d76dfe5e5$export$9a105a556e65c2c0;
        }
        return $2432650d76dfe5e5$export$c6813a8d51f77eaf(input.data);
    }
}
$2432650d76dfe5e5$export$4e780e961c30340d.create = (params)=>{
    return new $2432650d76dfe5e5$export$4e780e961c30340d({
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodUndefined,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
class $2432650d76dfe5e5$export$a96281f914484f2d extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $2432650d76dfe5e5$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_type,
                expected: $2432650d76dfe5e5$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $2432650d76dfe5e5$export$9a105a556e65c2c0;
        }
        return $2432650d76dfe5e5$export$c6813a8d51f77eaf(input.data);
    }
}
$2432650d76dfe5e5$export$a96281f914484f2d.create = (params)=>{
    return new $2432650d76dfe5e5$export$a96281f914484f2d({
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodNull,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
class $2432650d76dfe5e5$export$b9d1edb536b4e4eb extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return $2432650d76dfe5e5$export$c6813a8d51f77eaf(input.data);
    }
}
$2432650d76dfe5e5$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $2432650d76dfe5e5$export$b9d1edb536b4e4eb({
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodAny,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
class $2432650d76dfe5e5$export$ef3b1bb1630977ae extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return $2432650d76dfe5e5$export$c6813a8d51f77eaf(input.data);
    }
}
$2432650d76dfe5e5$export$ef3b1bb1630977ae.create = (params)=>{
    return new $2432650d76dfe5e5$export$ef3b1bb1630977ae({
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodUnknown,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
class $2432650d76dfe5e5$export$1e576a20c3ce9fb5 extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
            code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_type,
            expected: $2432650d76dfe5e5$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $2432650d76dfe5e5$export$9a105a556e65c2c0;
    }
}
$2432650d76dfe5e5$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $2432650d76dfe5e5$export$1e576a20c3ce9fb5({
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodNever,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
class $2432650d76dfe5e5$export$7d39f5df85f21031 extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $2432650d76dfe5e5$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_type,
                expected: $2432650d76dfe5e5$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $2432650d76dfe5e5$export$9a105a556e65c2c0;
        }
        return $2432650d76dfe5e5$export$c6813a8d51f77eaf(input.data);
    }
}
$2432650d76dfe5e5$export$7d39f5df85f21031.create = (params)=>{
    return new $2432650d76dfe5e5$export$7d39f5df85f21031({
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodVoid,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
class $2432650d76dfe5e5$export$7acfc3e64785411 extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $2432650d76dfe5e5$export$5716da67bfaa244d.array) {
            $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_type,
                expected: $2432650d76dfe5e5$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $2432650d76dfe5e5$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $2432650d76dfe5e5$export$5ba560653e4a1035.too_big : $2432650d76dfe5e5$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                    code: $2432650d76dfe5e5$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                    code: $2432650d76dfe5e5$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $2432650d76dfe5e5$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $2432650d76dfe5e5$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $2432650d76dfe5e5$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $2432650d76dfe5e5$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $2432650d76dfe5e5$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: $2432650d76dfe5e5$var$errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $2432650d76dfe5e5$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $2432650d76dfe5e5$var$errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $2432650d76dfe5e5$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: $2432650d76dfe5e5$var$errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$2432650d76dfe5e5$export$7acfc3e64785411.create = (schema, params)=>{
    return new $2432650d76dfe5e5$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodArray,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
function $2432650d76dfe5e5$var$deepPartialify(schema) {
    if (schema instanceof $2432650d76dfe5e5$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $2432650d76dfe5e5$export$aa56fec1e9d629b8.create($2432650d76dfe5e5$var$deepPartialify(fieldSchema));
        }
        return new $2432650d76dfe5e5$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $2432650d76dfe5e5$export$7acfc3e64785411) return new $2432650d76dfe5e5$export$7acfc3e64785411({
        ...schema._def,
        type: $2432650d76dfe5e5$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $2432650d76dfe5e5$export$aa56fec1e9d629b8) return $2432650d76dfe5e5$export$aa56fec1e9d629b8.create($2432650d76dfe5e5$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $2432650d76dfe5e5$export$aaac0b8b429cef5) return $2432650d76dfe5e5$export$aaac0b8b429cef5.create($2432650d76dfe5e5$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $2432650d76dfe5e5$export$e2a18bb771d8e6a3) return $2432650d76dfe5e5$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$2432650d76dfe5e5$var$deepPartialify(item)));
    else return schema;
}
class $2432650d76dfe5e5$export$736315c5b55efbad extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $2432650d76dfe5e5$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $2432650d76dfe5e5$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_type,
                expected: $2432650d76dfe5e5$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $2432650d76dfe5e5$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $2432650d76dfe5e5$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $2432650d76dfe5e5$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $2432650d76dfe5e5$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                        code: $2432650d76dfe5e5$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $2432650d76dfe5e5$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                syncPairs.push({
                    key: key,
                    value: await pair.value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $2432650d76dfe5e5$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $2432650d76dfe5e5$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $2432650d76dfe5e5$var$errorUtil.errToObj;
        return new $2432650d76dfe5e5$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $2432650d76dfe5e5$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $2432650d76dfe5e5$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $2432650d76dfe5e5$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $2432650d76dfe5e5$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $2432650d76dfe5e5$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $2432650d76dfe5e5$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $2432650d76dfe5e5$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $2432650d76dfe5e5$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $2432650d76dfe5e5$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $2432650d76dfe5e5$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $2432650d76dfe5e5$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $2432650d76dfe5e5$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $2432650d76dfe5e5$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $2432650d76dfe5e5$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $2432650d76dfe5e5$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $2432650d76dfe5e5$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $2432650d76dfe5e5$var$createZodEnum($2432650d76dfe5e5$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
}
$2432650d76dfe5e5$export$736315c5b55efbad.create = (shape, params)=>{
    return new $2432650d76dfe5e5$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $2432650d76dfe5e5$export$1e576a20c3ce9fb5.create(),
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodObject,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
$2432650d76dfe5e5$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $2432650d76dfe5e5$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $2432650d76dfe5e5$export$1e576a20c3ce9fb5.create(),
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodObject,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
$2432650d76dfe5e5$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $2432650d76dfe5e5$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $2432650d76dfe5e5$export$1e576a20c3ce9fb5.create(),
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodObject,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
class $2432650d76dfe5e5$export$a8b236cb5070a311 extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $2432650d76dfe5e5$export$f98dac4b251ab333(result.ctx.common.issues));
            $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $2432650d76dfe5e5$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $2432650d76dfe5e5$export$f98dac4b251ab333(issues));
            $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $2432650d76dfe5e5$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$2432650d76dfe5e5$export$a8b236cb5070a311.create = (types, params)=>{
    return new $2432650d76dfe5e5$export$a8b236cb5070a311({
        options: types,
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodUnion,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $2432650d76dfe5e5$var$getDiscriminator = (type)=>{
    if (type instanceof $2432650d76dfe5e5$export$378d0cfce37406e6) return $2432650d76dfe5e5$var$getDiscriminator(type.schema);
    else if (type instanceof $2432650d76dfe5e5$export$a60af00cc0ce2582) return $2432650d76dfe5e5$var$getDiscriminator(type.innerType());
    else if (type instanceof $2432650d76dfe5e5$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $2432650d76dfe5e5$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $2432650d76dfe5e5$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return Object.keys(type.enum);
    else if (type instanceof $2432650d76dfe5e5$export$bb19b37874861e7e) return $2432650d76dfe5e5$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $2432650d76dfe5e5$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $2432650d76dfe5e5$export$a96281f914484f2d) return [
        null
    ];
    else return null;
};
class $2432650d76dfe5e5$export$5ef2424805ac76a3 extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $2432650d76dfe5e5$export$5716da67bfaa244d.object) {
            $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_type,
                expected: $2432650d76dfe5e5$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $2432650d76dfe5e5$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $2432650d76dfe5e5$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $2432650d76dfe5e5$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $2432650d76dfe5e5$export$5ef2424805ac76a3({
            typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$2432650d76dfe5e5$var$processCreateParams(params)
        });
    }
}
function $2432650d76dfe5e5$var$mergeValues(a, b) {
    const aType = $2432650d76dfe5e5$export$3e9057828ebd5c7a(a);
    const bType = $2432650d76dfe5e5$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $2432650d76dfe5e5$export$5716da67bfaa244d.object && bType === $2432650d76dfe5e5$export$5716da67bfaa244d.object) {
        const bKeys = $2432650d76dfe5e5$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $2432650d76dfe5e5$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $2432650d76dfe5e5$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $2432650d76dfe5e5$export$5716da67bfaa244d.array && bType === $2432650d76dfe5e5$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $2432650d76dfe5e5$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $2432650d76dfe5e5$export$5716da67bfaa244d.date && bType === $2432650d76dfe5e5$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $2432650d76dfe5e5$export$c02deaf0bb5203d4 extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($2432650d76dfe5e5$export$afa861e3c5730743(parsedLeft) || $2432650d76dfe5e5$export$afa861e3c5730743(parsedRight)) return $2432650d76dfe5e5$export$9a105a556e65c2c0;
            const merged = $2432650d76dfe5e5$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                    code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $2432650d76dfe5e5$export$9a105a556e65c2c0;
            }
            if ($2432650d76dfe5e5$export$910b6cdd390341b3(parsedLeft) || $2432650d76dfe5e5$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$2432650d76dfe5e5$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $2432650d76dfe5e5$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodIntersection,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
class $2432650d76dfe5e5$export$e2a18bb771d8e6a3 extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $2432650d76dfe5e5$export$5716da67bfaa244d.array) {
            $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_type,
                expected: $2432650d76dfe5e5$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $2432650d76dfe5e5$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                code: $2432650d76dfe5e5$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $2432650d76dfe5e5$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                code: $2432650d76dfe5e5$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $2432650d76dfe5e5$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $2432650d76dfe5e5$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $2432650d76dfe5e5$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $2432650d76dfe5e5$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$2432650d76dfe5e5$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $2432650d76dfe5e5$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
class $2432650d76dfe5e5$export$a2acc09968cb4b7f extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $2432650d76dfe5e5$export$5716da67bfaa244d.object) {
            $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_type,
                expected: $2432650d76dfe5e5$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $2432650d76dfe5e5$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $2432650d76dfe5e5$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $2432650d76dfe5e5$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key))
        });
        if (ctx.common.async) return $2432650d76dfe5e5$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $2432650d76dfe5e5$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $2432650d76dfe5e5$export$19342e026b58ebb7) return new $2432650d76dfe5e5$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodRecord,
            ...$2432650d76dfe5e5$var$processCreateParams(third)
        });
        return new $2432650d76dfe5e5$export$a2acc09968cb4b7f({
            keyType: $2432650d76dfe5e5$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodRecord,
            ...$2432650d76dfe5e5$var$processCreateParams(second)
        });
    }
}
class $2432650d76dfe5e5$export$163b6a2b712d9542 extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $2432650d76dfe5e5$export$5716da67bfaa244d.map) {
            $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_type,
                expected: $2432650d76dfe5e5$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $2432650d76dfe5e5$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $2432650d76dfe5e5$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $2432650d76dfe5e5$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $2432650d76dfe5e5$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $2432650d76dfe5e5$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$2432650d76dfe5e5$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $2432650d76dfe5e5$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodMap,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
class $2432650d76dfe5e5$export$977057706f816712 extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $2432650d76dfe5e5$export$5716da67bfaa244d.set) {
            $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_type,
                expected: $2432650d76dfe5e5$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $2432650d76dfe5e5$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                    code: $2432650d76dfe5e5$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                    code: $2432650d76dfe5e5$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $2432650d76dfe5e5$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $2432650d76dfe5e5$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $2432650d76dfe5e5$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: $2432650d76dfe5e5$var$errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $2432650d76dfe5e5$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $2432650d76dfe5e5$var$errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$2432650d76dfe5e5$export$977057706f816712.create = (valueType, params)=>{
    return new $2432650d76dfe5e5$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodSet,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
class $2432650d76dfe5e5$export$d4602ba55673f53c extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $2432650d76dfe5e5$export$5716da67bfaa244d.function) {
            $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_type,
                expected: $2432650d76dfe5e5$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $2432650d76dfe5e5$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $2432650d76dfe5e5$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $2432650d76dfe5e5$export$32f27c719778d4c4(),
                    $2432650d76dfe5e5$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $2432650d76dfe5e5$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $2432650d76dfe5e5$export$32f27c719778d4c4(),
                    $2432650d76dfe5e5$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $2432650d76dfe5e5$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $2432650d76dfe5e5$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $2432650d76dfe5e5$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $2432650d76dfe5e5$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $2432650d76dfe5e5$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $2432650d76dfe5e5$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $2432650d76dfe5e5$export$d4602ba55673f53c({
            ...this._def,
            args: $2432650d76dfe5e5$export$e2a18bb771d8e6a3.create(items).rest($2432650d76dfe5e5$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $2432650d76dfe5e5$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $2432650d76dfe5e5$export$d4602ba55673f53c({
            args: args ? args : $2432650d76dfe5e5$export$e2a18bb771d8e6a3.create([]).rest($2432650d76dfe5e5$export$ef3b1bb1630977ae.create()),
            returns: returns || $2432650d76dfe5e5$export$ef3b1bb1630977ae.create(),
            typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodFunction,
            ...$2432650d76dfe5e5$var$processCreateParams(params)
        });
    }
}
class $2432650d76dfe5e5$export$378d0cfce37406e6 extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$2432650d76dfe5e5$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $2432650d76dfe5e5$export$378d0cfce37406e6({
        getter: getter,
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodLazy,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
class $2432650d76dfe5e5$export$7e44096782a165d3 extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $2432650d76dfe5e5$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$2432650d76dfe5e5$export$7e44096782a165d3.create = (value, params)=>{
    return new $2432650d76dfe5e5$export$7e44096782a165d3({
        value: value,
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodLiteral,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
function $2432650d76dfe5e5$var$createZodEnum(values, params) {
    return new $2432650d76dfe5e5$export$d325d1f0e1c20179({
        values: values,
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodEnum,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
}
class $2432650d76dfe5e5$export$d325d1f0e1c20179 extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                expected: $2432650d76dfe5e5$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_type
            });
            return $2432650d76dfe5e5$export$9a105a556e65c2c0;
        }
        if (this._def.values.indexOf(input.data) === -1) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $2432650d76dfe5e5$export$9a105a556e65c2c0;
        }
        return $2432650d76dfe5e5$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values) {
        return $2432650d76dfe5e5$export$d325d1f0e1c20179.create(values);
    }
    exclude(values) {
        return $2432650d76dfe5e5$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)));
    }
}
$2432650d76dfe5e5$export$d325d1f0e1c20179.create = $2432650d76dfe5e5$var$createZodEnum;
class $2432650d76dfe5e5$export$370b2e8d6d6f5c56 extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    _parse(input) {
        const nativeEnumValues = $2432650d76dfe5e5$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $2432650d76dfe5e5$export$5716da67bfaa244d.string && ctx.parsedType !== $2432650d76dfe5e5$export$5716da67bfaa244d.number) {
            const expectedValues = $2432650d76dfe5e5$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                expected: $2432650d76dfe5e5$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_type
            });
            return $2432650d76dfe5e5$export$9a105a556e65c2c0;
        }
        if (nativeEnumValues.indexOf(input.data) === -1) {
            const expectedValues = $2432650d76dfe5e5$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $2432650d76dfe5e5$export$9a105a556e65c2c0;
        }
        return $2432650d76dfe5e5$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$2432650d76dfe5e5$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $2432650d76dfe5e5$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodNativeEnum,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
class $2432650d76dfe5e5$export$3f196b0127d6e50a extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $2432650d76dfe5e5$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_type,
                expected: $2432650d76dfe5e5$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $2432650d76dfe5e5$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $2432650d76dfe5e5$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $2432650d76dfe5e5$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$2432650d76dfe5e5$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $2432650d76dfe5e5$export$3f196b0127d6e50a({
        type: schema,
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodPromise,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
class $2432650d76dfe5e5$export$a60af00cc0ce2582 extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $2432650d76dfe5e5$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.issues.length) return {
                status: "dirty",
                value: ctx.data
            };
            if (ctx.common.async) return Promise.resolve(processed).then((processed)=>{
                return this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
            });
            else return this._def.schema._parseSync({
                data: processed,
                path: ctx.path,
                parent: ctx
            });
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $2432650d76dfe5e5$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $2432650d76dfe5e5$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$2432650d76dfe5e5$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$2432650d76dfe5e5$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $2432650d76dfe5e5$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$2432650d76dfe5e5$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $2432650d76dfe5e5$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
$2432650d76dfe5e5$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $2432650d76dfe5e5$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodEffects,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
class $2432650d76dfe5e5$export$aa56fec1e9d629b8 extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $2432650d76dfe5e5$export$5716da67bfaa244d.undefined) return $2432650d76dfe5e5$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$2432650d76dfe5e5$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $2432650d76dfe5e5$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodOptional,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
class $2432650d76dfe5e5$export$aaac0b8b429cef5 extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $2432650d76dfe5e5$export$5716da67bfaa244d.null) return $2432650d76dfe5e5$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$2432650d76dfe5e5$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $2432650d76dfe5e5$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodNullable,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
class $2432650d76dfe5e5$export$bb19b37874861e7e extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $2432650d76dfe5e5$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$2432650d76dfe5e5$export$bb19b37874861e7e.create = (type, params)=>{
    return new $2432650d76dfe5e5$export$bb19b37874861e7e({
        innerType: type,
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
class $2432650d76dfe5e5$export$75a44ec6249ac76b extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ($2432650d76dfe5e5$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $2432650d76dfe5e5$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $2432650d76dfe5e5$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$2432650d76dfe5e5$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $2432650d76dfe5e5$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
class $2432650d76dfe5e5$export$26ccfa0145e8511f extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $2432650d76dfe5e5$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $2432650d76dfe5e5$export$db7caee60e5d514d(ctx, {
                code: $2432650d76dfe5e5$export$5ba560653e4a1035.invalid_type,
                expected: $2432650d76dfe5e5$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $2432650d76dfe5e5$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$2432650d76dfe5e5$export$26ccfa0145e8511f.create = (params)=>{
    return new $2432650d76dfe5e5$export$26ccfa0145e8511f({
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodNaN,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
const $2432650d76dfe5e5$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $2432650d76dfe5e5$export$66b0c798a395271f extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $2432650d76dfe5e5$export$a3c3ef8a0e95c6da extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $2432650d76dfe5e5$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $2432650d76dfe5e5$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $2432650d76dfe5e5$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $2432650d76dfe5e5$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $2432650d76dfe5e5$export$5d1f7ef05c4e493a extends $2432650d76dfe5e5$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        if ($2432650d76dfe5e5$export$1ea939691cdc45b8(result)) result.value = Object.freeze(result.value);
        return result;
    }
}
$2432650d76dfe5e5$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $2432650d76dfe5e5$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $2432650d76dfe5e5$export$558106ce543bd011.ZodReadonly,
        ...$2432650d76dfe5e5$var$processCreateParams(params)
    });
};
const $2432650d76dfe5e5$export$4c00f665f0d4b443 = (check, params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal)=>{
    if (check) return $2432650d76dfe5e5$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue({
                code: "custom",
                ...p2,
                fatal: _fatal
            });
        }
    });
    return $2432650d76dfe5e5$export$b9d1edb536b4e4eb.create();
};
const $2432650d76dfe5e5$export$1ee8ee30835eab8b = {
    object: $2432650d76dfe5e5$export$736315c5b55efbad.lazycreate
};
var $2432650d76dfe5e5$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($2432650d76dfe5e5$export$558106ce543bd011 || ($2432650d76dfe5e5$export$558106ce543bd011 = {}));
const $2432650d76dfe5e5$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$2432650d76dfe5e5$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $2432650d76dfe5e5$export$22b082955e083ec3 = $2432650d76dfe5e5$export$1230eb29b8d3b502.create;
const $2432650d76dfe5e5$export$98e628dec113755e = $2432650d76dfe5e5$export$5b070a55c0c43e09.create;
const $2432650d76dfe5e5$export$9e06de0973666692 = $2432650d76dfe5e5$export$26ccfa0145e8511f.create;
const $2432650d76dfe5e5$export$a0f65b52274bcc00 = $2432650d76dfe5e5$export$67d741fd70ff98f4.create;
const $2432650d76dfe5e5$export$4a21f16c33752377 = $2432650d76dfe5e5$export$723d146f80596191.create;
const $2432650d76dfe5e5$export$324d90190a8b822a = $2432650d76dfe5e5$export$e974be33bdc55521.create;
const $2432650d76dfe5e5$export$8f701197936bc2a6 = $2432650d76dfe5e5$export$bcc3b40f6b638044.create;
const $2432650d76dfe5e5$export$1db45310990710a5 = $2432650d76dfe5e5$export$4e780e961c30340d.create;
const $2432650d76dfe5e5$export$7b1b591b262c240 = $2432650d76dfe5e5$export$a96281f914484f2d.create;
const $2432650d76dfe5e5$export$4154a199d7d90455 = $2432650d76dfe5e5$export$b9d1edb536b4e4eb.create;
const $2432650d76dfe5e5$export$19282c40b967aec6 = $2432650d76dfe5e5$export$ef3b1bb1630977ae.create;
const $2432650d76dfe5e5$export$b3e22bcfd64c1022 = $2432650d76dfe5e5$export$1e576a20c3ce9fb5.create;
const $2432650d76dfe5e5$export$490e536ee7389aeb = $2432650d76dfe5e5$export$7d39f5df85f21031.create;
const $2432650d76dfe5e5$export$2f23118c22fb2630 = $2432650d76dfe5e5$export$7acfc3e64785411.create;
const $2432650d76dfe5e5$export$be5493f9613cbbe = $2432650d76dfe5e5$export$736315c5b55efbad.create;
const $2432650d76dfe5e5$export$8fb0df5f40d0b477 = $2432650d76dfe5e5$export$736315c5b55efbad.strictCreate;
const $2432650d76dfe5e5$export$971dd5b0dfd021b6 = $2432650d76dfe5e5$export$a8b236cb5070a311.create;
const $2432650d76dfe5e5$export$4b888e40c4ee26dd = $2432650d76dfe5e5$export$5ef2424805ac76a3.create;
const $2432650d76dfe5e5$export$bc86dfbf7795668c = $2432650d76dfe5e5$export$c02deaf0bb5203d4.create;
const $2432650d76dfe5e5$export$65e3907585753458 = $2432650d76dfe5e5$export$e2a18bb771d8e6a3.create;
const $2432650d76dfe5e5$export$e5185e241753e543 = $2432650d76dfe5e5$export$a2acc09968cb4b7f.create;
const $2432650d76dfe5e5$export$871de8747c9eaa88 = $2432650d76dfe5e5$export$163b6a2b712d9542.create;
const $2432650d76dfe5e5$export$adaa4cf7ef1b65be = $2432650d76dfe5e5$export$977057706f816712.create;
const $2432650d76dfe5e5$export$44e51c8aac7c2deb = $2432650d76dfe5e5$export$d4602ba55673f53c.create;
const $2432650d76dfe5e5$export$488013bae63b21da = $2432650d76dfe5e5$export$378d0cfce37406e6.create;
const $2432650d76dfe5e5$export$c8ec6e1ec9fefcb0 = $2432650d76dfe5e5$export$7e44096782a165d3.create;
const $2432650d76dfe5e5$export$78a99c8d44d72635 = $2432650d76dfe5e5$export$d325d1f0e1c20179.create;
const $2432650d76dfe5e5$export$6fe7eca19ebe5199 = $2432650d76dfe5e5$export$370b2e8d6d6f5c56.create;
const $2432650d76dfe5e5$export$c957ef27a0ebfd4 = $2432650d76dfe5e5$export$3f196b0127d6e50a.create;
const $2432650d76dfe5e5$export$dc573d8a6576cdb3 = $2432650d76dfe5e5$export$a60af00cc0ce2582.create;
const $2432650d76dfe5e5$export$516e28dec6a4b6d4 = $2432650d76dfe5e5$export$aa56fec1e9d629b8.create;
const $2432650d76dfe5e5$export$133fc36489ac9add = $2432650d76dfe5e5$export$aaac0b8b429cef5.create;
const $2432650d76dfe5e5$export$fc37fe19dfda43ee = $2432650d76dfe5e5$export$a60af00cc0ce2582.createWithPreprocess;
const $2432650d76dfe5e5$export$43f28b24e1eb8181 = $2432650d76dfe5e5$export$a3c3ef8a0e95c6da.create;
const $2432650d76dfe5e5$export$3b3d07727c5b702c = ()=>$2432650d76dfe5e5$export$22b082955e083ec3().optional();
const $2432650d76dfe5e5$export$eb150471a61fced6 = ()=>$2432650d76dfe5e5$export$98e628dec113755e().optional();
const $2432650d76dfe5e5$export$269251733cdcbbf1 = ()=>$2432650d76dfe5e5$export$4a21f16c33752377().optional();
const $2432650d76dfe5e5$export$8c14e57e778d3873 = {
    string: (arg)=>$2432650d76dfe5e5$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$2432650d76dfe5e5$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$2432650d76dfe5e5$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$2432650d76dfe5e5$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$2432650d76dfe5e5$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $2432650d76dfe5e5$export$96c94437c95d7862 = $2432650d76dfe5e5$export$9a105a556e65c2c0;
var $2432650d76dfe5e5$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $2432650d76dfe5e5$export$341b0b6e0a6f5099,
    setErrorMap: $2432650d76dfe5e5$export$1097a8289cfd22d7,
    getErrorMap: $2432650d76dfe5e5$export$32f27c719778d4c4,
    makeIssue: $2432650d76dfe5e5$export$244a85fde9c419ed,
    EMPTY_PATH: $2432650d76dfe5e5$export$1526d2e05f74572,
    addIssueToContext: $2432650d76dfe5e5$export$db7caee60e5d514d,
    ParseStatus: $2432650d76dfe5e5$export$5b20a5c3d05c1f6f,
    INVALID: $2432650d76dfe5e5$export$9a105a556e65c2c0,
    DIRTY: $2432650d76dfe5e5$export$325a211da9693fcf,
    OK: $2432650d76dfe5e5$export$c6813a8d51f77eaf,
    isAborted: $2432650d76dfe5e5$export$afa861e3c5730743,
    isDirty: $2432650d76dfe5e5$export$910b6cdd390341b3,
    isValid: $2432650d76dfe5e5$export$1ea939691cdc45b8,
    isAsync: $2432650d76dfe5e5$export$aefee5ebe1dcfd9e,
    get util () {
        return $2432650d76dfe5e5$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $2432650d76dfe5e5$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $2432650d76dfe5e5$export$5716da67bfaa244d,
    getParsedType: $2432650d76dfe5e5$export$3e9057828ebd5c7a,
    ZodType: $2432650d76dfe5e5$export$19342e026b58ebb7,
    ZodString: $2432650d76dfe5e5$export$1230eb29b8d3b502,
    ZodNumber: $2432650d76dfe5e5$export$5b070a55c0c43e09,
    ZodBigInt: $2432650d76dfe5e5$export$67d741fd70ff98f4,
    ZodBoolean: $2432650d76dfe5e5$export$723d146f80596191,
    ZodDate: $2432650d76dfe5e5$export$e974be33bdc55521,
    ZodSymbol: $2432650d76dfe5e5$export$bcc3b40f6b638044,
    ZodUndefined: $2432650d76dfe5e5$export$4e780e961c30340d,
    ZodNull: $2432650d76dfe5e5$export$a96281f914484f2d,
    ZodAny: $2432650d76dfe5e5$export$b9d1edb536b4e4eb,
    ZodUnknown: $2432650d76dfe5e5$export$ef3b1bb1630977ae,
    ZodNever: $2432650d76dfe5e5$export$1e576a20c3ce9fb5,
    ZodVoid: $2432650d76dfe5e5$export$7d39f5df85f21031,
    ZodArray: $2432650d76dfe5e5$export$7acfc3e64785411,
    ZodObject: $2432650d76dfe5e5$export$736315c5b55efbad,
    ZodUnion: $2432650d76dfe5e5$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $2432650d76dfe5e5$export$5ef2424805ac76a3,
    ZodIntersection: $2432650d76dfe5e5$export$c02deaf0bb5203d4,
    ZodTuple: $2432650d76dfe5e5$export$e2a18bb771d8e6a3,
    ZodRecord: $2432650d76dfe5e5$export$a2acc09968cb4b7f,
    ZodMap: $2432650d76dfe5e5$export$163b6a2b712d9542,
    ZodSet: $2432650d76dfe5e5$export$977057706f816712,
    ZodFunction: $2432650d76dfe5e5$export$d4602ba55673f53c,
    ZodLazy: $2432650d76dfe5e5$export$378d0cfce37406e6,
    ZodLiteral: $2432650d76dfe5e5$export$7e44096782a165d3,
    ZodEnum: $2432650d76dfe5e5$export$d325d1f0e1c20179,
    ZodNativeEnum: $2432650d76dfe5e5$export$370b2e8d6d6f5c56,
    ZodPromise: $2432650d76dfe5e5$export$3f196b0127d6e50a,
    ZodEffects: $2432650d76dfe5e5$export$a60af00cc0ce2582,
    ZodTransformer: $2432650d76dfe5e5$export$a60af00cc0ce2582,
    ZodOptional: $2432650d76dfe5e5$export$aa56fec1e9d629b8,
    ZodNullable: $2432650d76dfe5e5$export$aaac0b8b429cef5,
    ZodDefault: $2432650d76dfe5e5$export$bb19b37874861e7e,
    ZodCatch: $2432650d76dfe5e5$export$75a44ec6249ac76b,
    ZodNaN: $2432650d76dfe5e5$export$26ccfa0145e8511f,
    BRAND: $2432650d76dfe5e5$export$cf2deea74cde46b4,
    ZodBranded: $2432650d76dfe5e5$export$66b0c798a395271f,
    ZodPipeline: $2432650d76dfe5e5$export$a3c3ef8a0e95c6da,
    ZodReadonly: $2432650d76dfe5e5$export$5d1f7ef05c4e493a,
    custom: $2432650d76dfe5e5$export$4c00f665f0d4b443,
    Schema: $2432650d76dfe5e5$export$19342e026b58ebb7,
    ZodSchema: $2432650d76dfe5e5$export$19342e026b58ebb7,
    late: $2432650d76dfe5e5$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $2432650d76dfe5e5$export$558106ce543bd011;
    },
    coerce: $2432650d76dfe5e5$export$8c14e57e778d3873,
    any: $2432650d76dfe5e5$export$4154a199d7d90455,
    array: $2432650d76dfe5e5$export$2f23118c22fb2630,
    bigint: $2432650d76dfe5e5$export$a0f65b52274bcc00,
    boolean: $2432650d76dfe5e5$export$4a21f16c33752377,
    date: $2432650d76dfe5e5$export$324d90190a8b822a,
    discriminatedUnion: $2432650d76dfe5e5$export$4b888e40c4ee26dd,
    effect: $2432650d76dfe5e5$export$dc573d8a6576cdb3,
    "enum": $2432650d76dfe5e5$export$78a99c8d44d72635,
    "function": $2432650d76dfe5e5$export$44e51c8aac7c2deb,
    "instanceof": $2432650d76dfe5e5$export$3d916e7c22dbd8b5,
    intersection: $2432650d76dfe5e5$export$bc86dfbf7795668c,
    lazy: $2432650d76dfe5e5$export$488013bae63b21da,
    literal: $2432650d76dfe5e5$export$c8ec6e1ec9fefcb0,
    map: $2432650d76dfe5e5$export$871de8747c9eaa88,
    nan: $2432650d76dfe5e5$export$9e06de0973666692,
    nativeEnum: $2432650d76dfe5e5$export$6fe7eca19ebe5199,
    never: $2432650d76dfe5e5$export$b3e22bcfd64c1022,
    "null": $2432650d76dfe5e5$export$7b1b591b262c240,
    nullable: $2432650d76dfe5e5$export$133fc36489ac9add,
    number: $2432650d76dfe5e5$export$98e628dec113755e,
    object: $2432650d76dfe5e5$export$be5493f9613cbbe,
    oboolean: $2432650d76dfe5e5$export$269251733cdcbbf1,
    onumber: $2432650d76dfe5e5$export$eb150471a61fced6,
    optional: $2432650d76dfe5e5$export$516e28dec6a4b6d4,
    ostring: $2432650d76dfe5e5$export$3b3d07727c5b702c,
    pipeline: $2432650d76dfe5e5$export$43f28b24e1eb8181,
    preprocess: $2432650d76dfe5e5$export$fc37fe19dfda43ee,
    promise: $2432650d76dfe5e5$export$c957ef27a0ebfd4,
    record: $2432650d76dfe5e5$export$e5185e241753e543,
    set: $2432650d76dfe5e5$export$adaa4cf7ef1b65be,
    strictObject: $2432650d76dfe5e5$export$8fb0df5f40d0b477,
    string: $2432650d76dfe5e5$export$22b082955e083ec3,
    symbol: $2432650d76dfe5e5$export$8f701197936bc2a6,
    transformer: $2432650d76dfe5e5$export$dc573d8a6576cdb3,
    tuple: $2432650d76dfe5e5$export$65e3907585753458,
    "undefined": $2432650d76dfe5e5$export$1db45310990710a5,
    union: $2432650d76dfe5e5$export$971dd5b0dfd021b6,
    unknown: $2432650d76dfe5e5$export$19282c40b967aec6,
    "void": $2432650d76dfe5e5$export$490e536ee7389aeb,
    NEVER: $2432650d76dfe5e5$export$96c94437c95d7862,
    ZodIssueCode: $2432650d76dfe5e5$export$5ba560653e4a1035,
    quotelessJson: $2432650d76dfe5e5$export$913eddeaf297cfea,
    ZodError: $2432650d76dfe5e5$export$f98dac4b251ab333
});

});

parcelRequire.register("FuhPC", function(module, exports) {

$parcel$export(module.exports, "resolveValue", function () { return $07cb52bd1cb077b9$export$d812c8e1906863d0; });
$parcel$export(module.exports, "toast", function () { return $07cb52bd1cb077b9$export$b410431fab84fa58; });
$parcel$export(module.exports, "Toaster", function () { return $07cb52bd1cb077b9$export$fb98e3a2a4cd92d7; });

var $jC8Vy = parcelRequire("jC8Vy");

var $jvTSI = parcelRequire("jvTSI");
function $07cb52bd1cb077b9$var$_extends() {
    $07cb52bd1cb077b9$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $07cb52bd1cb077b9$var$_extends.apply(this, arguments);
}
function $07cb52bd1cb077b9$var$_taggedTemplateLiteralLoose(strings, raw) {
    if (!raw) raw = strings.slice(0);
    strings.raw = raw;
    return strings;
}
var $07cb52bd1cb077b9$var$isFunction = function isFunction(valOrFunction) {
    return typeof valOrFunction === "function";
};
var $07cb52bd1cb077b9$export$d812c8e1906863d0 = function resolveValue(valOrFunction, arg) {
    return $07cb52bd1cb077b9$var$isFunction(valOrFunction) ? valOrFunction(arg) : valOrFunction;
};
var $07cb52bd1cb077b9$var$genId = /*#__PURE__*/ function() {
    var count = 0;
    return function() {
        return (++count).toString();
    };
}();
var $07cb52bd1cb077b9$var$createRectRef = function createRectRef(onRect) {
    return function(el) {
        if (el) setTimeout(function() {
            var boundingRect = el.getBoundingClientRect();
            onRect(boundingRect);
        });
    };
};
var $07cb52bd1cb077b9$var$prefersReducedMotion = /*#__PURE__*/ function() {
    // Cache result
    var shouldReduceMotion = undefined;
    return function() {
        if (shouldReduceMotion === undefined && typeof window !== "undefined") {
            var mediaQuery = matchMedia("(prefers-reduced-motion: reduce)");
            shouldReduceMotion = !mediaQuery || mediaQuery.matches;
        }
        return shouldReduceMotion;
    };
}();
var $07cb52bd1cb077b9$var$TOAST_LIMIT = 20;
var $07cb52bd1cb077b9$var$ActionType;
(function(ActionType) {
    ActionType[ActionType["ADD_TOAST"] = 0] = "ADD_TOAST";
    ActionType[ActionType["UPDATE_TOAST"] = 1] = "UPDATE_TOAST";
    ActionType[ActionType["UPSERT_TOAST"] = 2] = "UPSERT_TOAST";
    ActionType[ActionType["DISMISS_TOAST"] = 3] = "DISMISS_TOAST";
    ActionType[ActionType["REMOVE_TOAST"] = 4] = "REMOVE_TOAST";
    ActionType[ActionType["START_PAUSE"] = 5] = "START_PAUSE";
    ActionType[ActionType["END_PAUSE"] = 6] = "END_PAUSE";
})($07cb52bd1cb077b9$var$ActionType || ($07cb52bd1cb077b9$var$ActionType = {}));
var $07cb52bd1cb077b9$var$toastTimeouts = /*#__PURE__*/ new Map();
var $07cb52bd1cb077b9$var$addToRemoveQueue = function addToRemoveQueue(toastId) {
    if ($07cb52bd1cb077b9$var$toastTimeouts.has(toastId)) return;
    var timeout = setTimeout(function() {
        $07cb52bd1cb077b9$var$toastTimeouts["delete"](toastId);
        $07cb52bd1cb077b9$var$dispatch({
            type: $07cb52bd1cb077b9$var$ActionType.REMOVE_TOAST,
            toastId: toastId
        });
    }, 1000);
    $07cb52bd1cb077b9$var$toastTimeouts.set(toastId, timeout);
};
var $07cb52bd1cb077b9$var$clearFromRemoveQueue = function clearFromRemoveQueue(toastId) {
    var timeout = $07cb52bd1cb077b9$var$toastTimeouts.get(toastId);
    if (timeout) clearTimeout(timeout);
};
var $07cb52bd1cb077b9$var$reducer = function reducer(state, action) {
    switch(action.type){
        case $07cb52bd1cb077b9$var$ActionType.ADD_TOAST:
            return $07cb52bd1cb077b9$var$_extends({}, state, {
                toasts: [
                    action.toast
                ].concat(state.toasts).slice(0, $07cb52bd1cb077b9$var$TOAST_LIMIT)
            });
        case $07cb52bd1cb077b9$var$ActionType.UPDATE_TOAST:
            //  ! Side effects !
            if (action.toast.id) $07cb52bd1cb077b9$var$clearFromRemoveQueue(action.toast.id);
            return $07cb52bd1cb077b9$var$_extends({}, state, {
                toasts: state.toasts.map(function(t) {
                    return t.id === action.toast.id ? $07cb52bd1cb077b9$var$_extends({}, t, action.toast) : t;
                })
            });
        case $07cb52bd1cb077b9$var$ActionType.UPSERT_TOAST:
            var toast = action.toast;
            return state.toasts.find(function(t) {
                return t.id === toast.id;
            }) ? reducer(state, {
                type: $07cb52bd1cb077b9$var$ActionType.UPDATE_TOAST,
                toast: toast
            }) : reducer(state, {
                type: $07cb52bd1cb077b9$var$ActionType.ADD_TOAST,
                toast: toast
            });
        case $07cb52bd1cb077b9$var$ActionType.DISMISS_TOAST:
            var toastId = action.toastId; // ! Side effects ! - This could be execrated into a dismissToast() action, but I'll keep it here for simplicity
            if (toastId) $07cb52bd1cb077b9$var$addToRemoveQueue(toastId);
            else state.toasts.forEach(function(toast) {
                $07cb52bd1cb077b9$var$addToRemoveQueue(toast.id);
            });
            return $07cb52bd1cb077b9$var$_extends({}, state, {
                toasts: state.toasts.map(function(t) {
                    return t.id === toastId || toastId === undefined ? $07cb52bd1cb077b9$var$_extends({}, t, {
                        visible: false
                    }) : t;
                })
            });
        case $07cb52bd1cb077b9$var$ActionType.REMOVE_TOAST:
            if (action.toastId === undefined) return $07cb52bd1cb077b9$var$_extends({}, state, {
                toasts: []
            });
            return $07cb52bd1cb077b9$var$_extends({}, state, {
                toasts: state.toasts.filter(function(t) {
                    return t.id !== action.toastId;
                })
            });
        case $07cb52bd1cb077b9$var$ActionType.START_PAUSE:
            return $07cb52bd1cb077b9$var$_extends({}, state, {
                pausedAt: action.time
            });
        case $07cb52bd1cb077b9$var$ActionType.END_PAUSE:
            var diff = action.time - (state.pausedAt || 0);
            return $07cb52bd1cb077b9$var$_extends({}, state, {
                pausedAt: undefined,
                toasts: state.toasts.map(function(t) {
                    return $07cb52bd1cb077b9$var$_extends({}, t, {
                        pauseDuration: t.pauseDuration + diff
                    });
                })
            });
    }
};
var $07cb52bd1cb077b9$var$listeners = [];
var $07cb52bd1cb077b9$var$memoryState = {
    toasts: [],
    pausedAt: undefined
};
var $07cb52bd1cb077b9$var$dispatch = function dispatch(action) {
    $07cb52bd1cb077b9$var$memoryState = $07cb52bd1cb077b9$var$reducer($07cb52bd1cb077b9$var$memoryState, action);
    $07cb52bd1cb077b9$var$listeners.forEach(function(listener) {
        listener($07cb52bd1cb077b9$var$memoryState);
    });
};
var $07cb52bd1cb077b9$var$defaultTimeouts = {
    blank: 4000,
    error: 4000,
    success: 2000,
    loading: Infinity,
    custom: 4000
};
var $07cb52bd1cb077b9$export$3960353ab538dc47 = function useStore(toastOptions) {
    if (toastOptions === void 0) toastOptions = {};
    var _useState = (0, $jC8Vy.useState)($07cb52bd1cb077b9$var$memoryState), state = _useState[0], setState = _useState[1];
    (0, $jC8Vy.useEffect)(function() {
        $07cb52bd1cb077b9$var$listeners.push(setState);
        return function() {
            var index = $07cb52bd1cb077b9$var$listeners.indexOf(setState);
            if (index > -1) $07cb52bd1cb077b9$var$listeners.splice(index, 1);
        };
    }, [
        state
    ]);
    var mergedToasts = state.toasts.map(function(t) {
        var _toastOptions$t$type, _toastOptions, _toastOptions$t$type2;
        return $07cb52bd1cb077b9$var$_extends({}, toastOptions, toastOptions[t.type], t, {
            duration: t.duration || ((_toastOptions$t$type = toastOptions[t.type]) == null ? void 0 : _toastOptions$t$type.duration) || ((_toastOptions = toastOptions) == null ? void 0 : _toastOptions.duration) || $07cb52bd1cb077b9$var$defaultTimeouts[t.type],
            style: $07cb52bd1cb077b9$var$_extends({}, toastOptions.style, (_toastOptions$t$type2 = toastOptions[t.type]) == null ? void 0 : _toastOptions$t$type2.style, t.style)
        });
    });
    return $07cb52bd1cb077b9$var$_extends({}, state, {
        toasts: mergedToasts
    });
};
var $07cb52bd1cb077b9$var$createToast = function createToast(message, type, opts) {
    if (type === void 0) type = "blank";
    return $07cb52bd1cb077b9$var$_extends({
        createdAt: Date.now(),
        visible: true,
        type: type,
        ariaProps: {
            role: "status",
            "aria-live": "polite"
        },
        message: message,
        pauseDuration: 0
    }, opts, {
        id: (opts == null ? void 0 : opts.id) || $07cb52bd1cb077b9$var$genId()
    });
};
var $07cb52bd1cb077b9$var$createHandler = function createHandler(type) {
    return function(message, options) {
        var toast = $07cb52bd1cb077b9$var$createToast(message, type, options);
        $07cb52bd1cb077b9$var$dispatch({
            type: $07cb52bd1cb077b9$var$ActionType.UPSERT_TOAST,
            toast: toast
        });
        return toast.id;
    };
};
var $07cb52bd1cb077b9$export$b410431fab84fa58 = function toast(message, opts) {
    return $07cb52bd1cb077b9$var$createHandler("blank")(message, opts);
};
$07cb52bd1cb077b9$export$b410431fab84fa58.error = /*#__PURE__*/ $07cb52bd1cb077b9$var$createHandler("error");
$07cb52bd1cb077b9$export$b410431fab84fa58.success = /*#__PURE__*/ $07cb52bd1cb077b9$var$createHandler("success");
$07cb52bd1cb077b9$export$b410431fab84fa58.loading = /*#__PURE__*/ $07cb52bd1cb077b9$var$createHandler("loading");
$07cb52bd1cb077b9$export$b410431fab84fa58.custom = /*#__PURE__*/ $07cb52bd1cb077b9$var$createHandler("custom");
$07cb52bd1cb077b9$export$b410431fab84fa58.dismiss = function(toastId) {
    $07cb52bd1cb077b9$var$dispatch({
        type: $07cb52bd1cb077b9$var$ActionType.DISMISS_TOAST,
        toastId: toastId
    });
};
$07cb52bd1cb077b9$export$b410431fab84fa58.remove = function(toastId) {
    return $07cb52bd1cb077b9$var$dispatch({
        type: $07cb52bd1cb077b9$var$ActionType.REMOVE_TOAST,
        toastId: toastId
    });
};
$07cb52bd1cb077b9$export$b410431fab84fa58.promise = function(promise, msgs, opts) {
    var id = $07cb52bd1cb077b9$export$b410431fab84fa58.loading(msgs.loading, $07cb52bd1cb077b9$var$_extends({}, opts, opts == null ? void 0 : opts.loading));
    promise.then(function(p) {
        $07cb52bd1cb077b9$export$b410431fab84fa58.success($07cb52bd1cb077b9$export$d812c8e1906863d0(msgs.success, p), $07cb52bd1cb077b9$var$_extends({
            id: id
        }, opts, opts == null ? void 0 : opts.success));
        return p;
    })["catch"](function(e) {
        $07cb52bd1cb077b9$export$b410431fab84fa58.error($07cb52bd1cb077b9$export$d812c8e1906863d0(msgs.error, e), $07cb52bd1cb077b9$var$_extends({
            id: id
        }, opts, opts == null ? void 0 : opts.error));
    });
    return promise;
};
var $07cb52bd1cb077b9$export$f46171b59bb094f9 = function useToaster(toastOptions) {
    var _useStore = $07cb52bd1cb077b9$export$3960353ab538dc47(toastOptions), toasts = _useStore.toasts, pausedAt = _useStore.pausedAt;
    (0, $jC8Vy.useEffect)(function() {
        if (pausedAt) return;
        var now = Date.now();
        var timeouts = toasts.map(function(t) {
            if (t.duration === Infinity) return;
            var durationLeft = (t.duration || 0) + t.pauseDuration - (now - t.createdAt);
            if (durationLeft < 0) {
                if (t.visible) $07cb52bd1cb077b9$export$b410431fab84fa58.dismiss(t.id);
                return;
            }
            return setTimeout(function() {
                return $07cb52bd1cb077b9$export$b410431fab84fa58.dismiss(t.id);
            }, durationLeft);
        });
        return function() {
            timeouts.forEach(function(timeout) {
                return timeout && clearTimeout(timeout);
            });
        };
    }, [
        toasts,
        pausedAt
    ]);
    var handlers = (0, $jC8Vy.useMemo)(function() {
        return {
            startPause: function startPause() {
                $07cb52bd1cb077b9$var$dispatch({
                    type: $07cb52bd1cb077b9$var$ActionType.START_PAUSE,
                    time: Date.now()
                });
            },
            endPause: function endPause() {
                if (pausedAt) $07cb52bd1cb077b9$var$dispatch({
                    type: $07cb52bd1cb077b9$var$ActionType.END_PAUSE,
                    time: Date.now()
                });
            },
            updateHeight: function updateHeight(toastId, height) {
                return $07cb52bd1cb077b9$var$dispatch({
                    type: $07cb52bd1cb077b9$var$ActionType.UPDATE_TOAST,
                    toast: {
                        id: toastId,
                        height: height
                    }
                });
            },
            calculateOffset: function calculateOffset(toast, opts) {
                var _relevantToasts$filte;
                var _ref = opts || {}, _ref$reverseOrder = _ref.reverseOrder, reverseOrder = _ref$reverseOrder === void 0 ? false : _ref$reverseOrder, _ref$gutter = _ref.gutter, gutter = _ref$gutter === void 0 ? 8 : _ref$gutter, defaultPosition = _ref.defaultPosition;
                var relevantToasts = toasts.filter(function(t) {
                    return (t.position || defaultPosition) === (toast.position || defaultPosition) && t.height;
                });
                var toastIndex = relevantToasts.findIndex(function(t) {
                    return t.id === toast.id;
                });
                var toastsBefore = relevantToasts.filter(function(toast, i) {
                    return i < toastIndex && toast.visible;
                }).length;
                var offset = (_relevantToasts$filte = relevantToasts.filter(function(t) {
                    return t.visible;
                })).slice.apply(_relevantToasts$filte, reverseOrder ? [
                    toastsBefore + 1
                ] : [
                    0,
                    toastsBefore
                ]).reduce(function(acc, t) {
                    return acc + (t.height || 0) + gutter;
                }, 0);
                return offset;
            }
        };
    }, [
        toasts,
        pausedAt
    ]);
    return {
        toasts: toasts,
        handlers: handlers
    };
};
function $07cb52bd1cb077b9$var$_templateObject4() {
    var data = $07cb52bd1cb077b9$var$_taggedTemplateLiteralLoose([
        "\n  width: 20px;\n  opacity: 0;\n  height: 20px;\n  border-radius: 10px;\n  background: ",
        ";\n  position: relative;\n  transform: rotate(45deg);\n\n  animation: ",
        " 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n  animation-delay: 100ms;\n\n  &:after,\n  &:before {\n    content: '';\n    animation: ",
        " 0.15s ease-out forwards;\n    animation-delay: 150ms;\n    position: absolute;\n    border-radius: 3px;\n    opacity: 0;\n    background: ",
        ";\n    bottom: 9px;\n    left: 4px;\n    height: 2px;\n    width: 12px;\n  }\n\n  &:before {\n    animation: ",
        " 0.15s ease-out forwards;\n    animation-delay: 180ms;\n    transform: rotate(90deg);\n  }\n"
    ]);
    $07cb52bd1cb077b9$var$_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function $07cb52bd1cb077b9$var$_templateObject3() {
    var data = $07cb52bd1cb077b9$var$_taggedTemplateLiteralLoose([
        "\nfrom {\n  transform: scale(0) rotate(90deg);\n	opacity: 0;\n}\nto {\n  transform: scale(1) rotate(90deg);\n	opacity: 1;\n}"
    ]);
    $07cb52bd1cb077b9$var$_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function $07cb52bd1cb077b9$var$_templateObject2() {
    var data = $07cb52bd1cb077b9$var$_taggedTemplateLiteralLoose([
        "\nfrom {\n  transform: scale(0);\n  opacity: 0;\n}\nto {\n  transform: scale(1);\n  opacity: 1;\n}"
    ]);
    $07cb52bd1cb077b9$var$_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function $07cb52bd1cb077b9$var$_templateObject() {
    var data = $07cb52bd1cb077b9$var$_taggedTemplateLiteralLoose([
        "\nfrom {\n  transform: scale(0) rotate(45deg);\n	opacity: 0;\n}\nto {\n transform: scale(1) rotate(45deg);\n  opacity: 1;\n}"
    ]);
    $07cb52bd1cb077b9$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $07cb52bd1cb077b9$var$circleAnimation = /*#__PURE__*/ (0, $jvTSI.keyframes)(/*#__PURE__*/ $07cb52bd1cb077b9$var$_templateObject());
var $07cb52bd1cb077b9$var$firstLineAnimation = /*#__PURE__*/ (0, $jvTSI.keyframes)(/*#__PURE__*/ $07cb52bd1cb077b9$var$_templateObject2());
var $07cb52bd1cb077b9$var$secondLineAnimation = /*#__PURE__*/ (0, $jvTSI.keyframes)(/*#__PURE__*/ $07cb52bd1cb077b9$var$_templateObject3());
var $07cb52bd1cb077b9$export$19bc16ee58e19b3d = /*#__PURE__*/ (0, $jvTSI.styled)("div")(/*#__PURE__*/ $07cb52bd1cb077b9$var$_templateObject4(), function(p) {
    return p.primary || "#ff4b4b";
}, $07cb52bd1cb077b9$var$circleAnimation, $07cb52bd1cb077b9$var$firstLineAnimation, function(p) {
    return p.secondary || "#fff";
}, $07cb52bd1cb077b9$var$secondLineAnimation);
function $07cb52bd1cb077b9$var$_templateObject2$1() {
    var data = $07cb52bd1cb077b9$var$_taggedTemplateLiteralLoose([
        "\n  width: 12px;\n  height: 12px;\n  box-sizing: border-box;\n  border: 2px solid;\n  border-radius: 100%;\n  border-color: ",
        ";\n  border-right-color: ",
        ";\n  animation: ",
        " 1s linear infinite;\n"
    ]);
    $07cb52bd1cb077b9$var$_templateObject2$1 = function _templateObject2() {
        return data;
    };
    return data;
}
function $07cb52bd1cb077b9$var$_templateObject$1() {
    var data = $07cb52bd1cb077b9$var$_taggedTemplateLiteralLoose([
        "\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"
    ]);
    $07cb52bd1cb077b9$var$_templateObject$1 = function _templateObject() {
        return data;
    };
    return data;
}
var $07cb52bd1cb077b9$var$rotate = /*#__PURE__*/ (0, $jvTSI.keyframes)(/*#__PURE__*/ $07cb52bd1cb077b9$var$_templateObject$1());
var $07cb52bd1cb077b9$export$647aae5028016fe9 = /*#__PURE__*/ (0, $jvTSI.styled)("div")(/*#__PURE__*/ $07cb52bd1cb077b9$var$_templateObject2$1(), function(p) {
    return p.secondary || "#e0e0e0";
}, function(p) {
    return p.primary || "#616161";
}, $07cb52bd1cb077b9$var$rotate);
function $07cb52bd1cb077b9$var$_templateObject3$1() {
    var data = $07cb52bd1cb077b9$var$_taggedTemplateLiteralLoose([
        "\n  width: 20px;\n  opacity: 0;\n  height: 20px;\n  border-radius: 10px;\n  background: ",
        ";\n  position: relative;\n  transform: rotate(45deg);\n\n  animation: ",
        " 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n  animation-delay: 100ms;\n  &:after {\n    content: '';\n    box-sizing: border-box;\n    animation: ",
        " 0.2s ease-out forwards;\n    opacity: 0;\n    animation-delay: 200ms;\n    position: absolute;\n    border-right: 2px solid;\n    border-bottom: 2px solid;\n    border-color: ",
        ";\n    bottom: 6px;\n    left: 6px;\n    height: 10px;\n    width: 6px;\n  }\n"
    ]);
    $07cb52bd1cb077b9$var$_templateObject3$1 = function _templateObject3() {
        return data;
    };
    return data;
}
function $07cb52bd1cb077b9$var$_templateObject2$2() {
    var data = $07cb52bd1cb077b9$var$_taggedTemplateLiteralLoose([
        "\n0% {\n	height: 0;\n	width: 0;\n	opacity: 0;\n}\n40% {\n  height: 0;\n	width: 6px;\n	opacity: 1;\n}\n100% {\n  opacity: 1;\n  height: 10px;\n}"
    ]);
    $07cb52bd1cb077b9$var$_templateObject2$2 = function _templateObject2() {
        return data;
    };
    return data;
}
function $07cb52bd1cb077b9$var$_templateObject$2() {
    var data = $07cb52bd1cb077b9$var$_taggedTemplateLiteralLoose([
        "\nfrom {\n  transform: scale(0) rotate(45deg);\n	opacity: 0;\n}\nto {\n  transform: scale(1) rotate(45deg);\n	opacity: 1;\n}"
    ]);
    $07cb52bd1cb077b9$var$_templateObject$2 = function _templateObject() {
        return data;
    };
    return data;
}
var $07cb52bd1cb077b9$var$circleAnimation$1 = /*#__PURE__*/ (0, $jvTSI.keyframes)(/*#__PURE__*/ $07cb52bd1cb077b9$var$_templateObject$2());
var $07cb52bd1cb077b9$var$checkmarkAnimation = /*#__PURE__*/ (0, $jvTSI.keyframes)(/*#__PURE__*/ $07cb52bd1cb077b9$var$_templateObject2$2());
var $07cb52bd1cb077b9$export$906a919e30cdbd5c = /*#__PURE__*/ (0, $jvTSI.styled)("div")(/*#__PURE__*/ $07cb52bd1cb077b9$var$_templateObject3$1(), function(p) {
    return p.primary || "#61d345";
}, $07cb52bd1cb077b9$var$circleAnimation$1, $07cb52bd1cb077b9$var$checkmarkAnimation, function(p) {
    return p.secondary || "#fff";
});
function $07cb52bd1cb077b9$var$_templateObject4$1() {
    var data = $07cb52bd1cb077b9$var$_taggedTemplateLiteralLoose([
        "\n  position: relative;\n  transform: scale(0.6);\n  opacity: 0.4;\n  min-width: 20px;\n  animation: ",
        " 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n"
    ]);
    $07cb52bd1cb077b9$var$_templateObject4$1 = function _templateObject4() {
        return data;
    };
    return data;
}
function $07cb52bd1cb077b9$var$_templateObject3$2() {
    var data = $07cb52bd1cb077b9$var$_taggedTemplateLiteralLoose([
        "\nfrom {\n  transform: scale(0.6);\n  opacity: 0.4;\n}\nto {\n  transform: scale(1);\n  opacity: 1;\n}"
    ]);
    $07cb52bd1cb077b9$var$_templateObject3$2 = function _templateObject3() {
        return data;
    };
    return data;
}
function $07cb52bd1cb077b9$var$_templateObject2$3() {
    var data = $07cb52bd1cb077b9$var$_taggedTemplateLiteralLoose([
        "\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 20px;\n  min-height: 20px;\n"
    ]);
    $07cb52bd1cb077b9$var$_templateObject2$3 = function _templateObject2() {
        return data;
    };
    return data;
}
function $07cb52bd1cb077b9$var$_templateObject$3() {
    var data = $07cb52bd1cb077b9$var$_taggedTemplateLiteralLoose([
        "\n  position: absolute;\n"
    ]);
    $07cb52bd1cb077b9$var$_templateObject$3 = function _templateObject() {
        return data;
    };
    return data;
}
var $07cb52bd1cb077b9$var$StatusWrapper = /*#__PURE__*/ (0, $jvTSI.styled)("div")(/*#__PURE__*/ $07cb52bd1cb077b9$var$_templateObject$3());
var $07cb52bd1cb077b9$var$IndicatorWrapper = /*#__PURE__*/ (0, $jvTSI.styled)("div")(/*#__PURE__*/ $07cb52bd1cb077b9$var$_templateObject2$3());
var $07cb52bd1cb077b9$var$enter = /*#__PURE__*/ (0, $jvTSI.keyframes)(/*#__PURE__*/ $07cb52bd1cb077b9$var$_templateObject3$2());
var $07cb52bd1cb077b9$var$AnimatedIconWrapper = /*#__PURE__*/ (0, $jvTSI.styled)("div")(/*#__PURE__*/ $07cb52bd1cb077b9$var$_templateObject4$1(), $07cb52bd1cb077b9$var$enter);
var $07cb52bd1cb077b9$export$55554e87ff8bb60f = function ToastIcon(_ref) {
    var toast = _ref.toast;
    var icon = toast.icon, type = toast.type, iconTheme = toast.iconTheme;
    if (icon !== undefined) {
        if (typeof icon === "string") return (0, $jC8Vy.createElement)($07cb52bd1cb077b9$var$AnimatedIconWrapper, null, icon);
        else return icon;
    }
    if (type === "blank") return null;
    return (0, $jC8Vy.createElement)($07cb52bd1cb077b9$var$IndicatorWrapper, null, (0, $jC8Vy.createElement)($07cb52bd1cb077b9$export$647aae5028016fe9, Object.assign({}, iconTheme)), type !== "loading" && (0, $jC8Vy.createElement)($07cb52bd1cb077b9$var$StatusWrapper, null, type === "error" ? (0, $jC8Vy.createElement)($07cb52bd1cb077b9$export$19bc16ee58e19b3d, Object.assign({}, iconTheme)) : (0, $jC8Vy.createElement)($07cb52bd1cb077b9$export$906a919e30cdbd5c, Object.assign({}, iconTheme))));
};
function $07cb52bd1cb077b9$var$_templateObject2$4() {
    var data = $07cb52bd1cb077b9$var$_taggedTemplateLiteralLoose([
        "\n  display: flex;\n  justify-content: center;\n  margin: 4px 10px;\n  color: inherit;\n  flex: 1 1 auto;\n  white-space: pre-line;\n"
    ]);
    $07cb52bd1cb077b9$var$_templateObject2$4 = function _templateObject2() {
        return data;
    };
    return data;
}
function $07cb52bd1cb077b9$var$_templateObject$4() {
    var data = $07cb52bd1cb077b9$var$_taggedTemplateLiteralLoose([
        "\n  display: flex;\n  align-items: center;\n  background: #fff;\n  color: #363636;\n  line-height: 1.3;\n  will-change: transform;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);\n  max-width: 350px;\n  pointer-events: auto;\n  padding: 8px 10px;\n  border-radius: 8px;\n"
    ]);
    $07cb52bd1cb077b9$var$_templateObject$4 = function _templateObject() {
        return data;
    };
    return data;
}
var $07cb52bd1cb077b9$var$enterAnimation = function enterAnimation(factor) {
    return "\n0% {transform: translate3d(0," + factor * -200 + "%,0) scale(.6); opacity:.5;}\n100% {transform: translate3d(0,0,0) scale(1); opacity:1;}\n";
};
var $07cb52bd1cb077b9$var$exitAnimation = function exitAnimation(factor) {
    return "\n0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}\n100% {transform: translate3d(0," + factor * -150 + "%,-1px) scale(.6); opacity:0;}\n";
};
var $07cb52bd1cb077b9$var$fadeInAnimation = "0%{opacity:0;} 100%{opacity:1;}";
var $07cb52bd1cb077b9$var$fadeOutAnimation = "0%{opacity:1;} 100%{opacity:0;}";
var $07cb52bd1cb077b9$var$ToastBarBase = /*#__PURE__*/ (0, $jvTSI.styled)("div", (0, $jC8Vy.forwardRef))(/*#__PURE__*/ $07cb52bd1cb077b9$var$_templateObject$4());
var $07cb52bd1cb077b9$var$Message = /*#__PURE__*/ (0, $jvTSI.styled)("div")(/*#__PURE__*/ $07cb52bd1cb077b9$var$_templateObject2$4());
var $07cb52bd1cb077b9$var$getAnimationStyle = function getAnimationStyle(position, visible) {
    var top = position.includes("top");
    var factor = top ? 1 : -1;
    var _ref = $07cb52bd1cb077b9$var$prefersReducedMotion() ? [
        $07cb52bd1cb077b9$var$fadeInAnimation,
        $07cb52bd1cb077b9$var$fadeOutAnimation
    ] : [
        $07cb52bd1cb077b9$var$enterAnimation(factor),
        $07cb52bd1cb077b9$var$exitAnimation(factor)
    ], enter = _ref[0], exit = _ref[1];
    return {
        animation: visible ? (0, $jvTSI.keyframes)(enter) + " 0.35s cubic-bezier(.21,1.02,.73,1) forwards" : (0, $jvTSI.keyframes)(exit) + " 0.4s forwards cubic-bezier(.06,.71,.55,1)"
    };
};
var $07cb52bd1cb077b9$export$af68597b0c62c1df = /*#__PURE__*/ (0, $jC8Vy.memo)(function(_ref2) {
    var toast = _ref2.toast, position = _ref2.position, style = _ref2.style, children = _ref2.children;
    var animationStyle = toast != null && toast.height ? $07cb52bd1cb077b9$var$getAnimationStyle(toast.position || position || "top-center", toast.visible) : {
        opacity: 0
    };
    var icon = (0, $jC8Vy.createElement)($07cb52bd1cb077b9$export$55554e87ff8bb60f, {
        toast: toast
    });
    var message = (0, $jC8Vy.createElement)($07cb52bd1cb077b9$var$Message, Object.assign({}, toast.ariaProps), $07cb52bd1cb077b9$export$d812c8e1906863d0(toast.message, toast));
    return (0, $jC8Vy.createElement)($07cb52bd1cb077b9$var$ToastBarBase, {
        className: toast.className,
        style: $07cb52bd1cb077b9$var$_extends({}, animationStyle, style, toast.style)
    }, typeof children === "function" ? children({
        icon: icon,
        message: message
    }) : (0, $jC8Vy.createElement)((0, $jC8Vy.Fragment), null, icon, message));
});
function $07cb52bd1cb077b9$var$_templateObject$5() {
    var data = $07cb52bd1cb077b9$var$_taggedTemplateLiteralLoose([
        "\n  z-index: 9999;\n  > * {\n    pointer-events: auto;\n  }\n"
    ]);
    $07cb52bd1cb077b9$var$_templateObject$5 = function _templateObject() {
        return data;
    };
    return data;
}
(0, $jvTSI.setup)((0, $jC8Vy.createElement));
var $07cb52bd1cb077b9$var$getPositionStyle = function getPositionStyle(position, offset) {
    var top = position.includes("top");
    var verticalStyle = top ? {
        top: 0
    } : {
        bottom: 0
    };
    var horizontalStyle = position.includes("center") ? {
        justifyContent: "center"
    } : position.includes("right") ? {
        justifyContent: "flex-end"
    } : {};
    return $07cb52bd1cb077b9$var$_extends({
        left: 0,
        right: 0,
        display: "flex",
        position: "absolute",
        transition: $07cb52bd1cb077b9$var$prefersReducedMotion() ? undefined : "all 230ms cubic-bezier(.21,1.02,.73,1)",
        transform: "translateY(" + offset * (top ? 1 : -1) + "px)"
    }, verticalStyle, horizontalStyle);
};
var $07cb52bd1cb077b9$var$activeClass = /*#__PURE__*/ (0, $jvTSI.css)(/*#__PURE__*/ $07cb52bd1cb077b9$var$_templateObject$5());
var $07cb52bd1cb077b9$var$DEFAULT_OFFSET = 16;
var $07cb52bd1cb077b9$export$fb98e3a2a4cd92d7 = function Toaster(_ref) {
    var reverseOrder = _ref.reverseOrder, _ref$position = _ref.position, position = _ref$position === void 0 ? "top-center" : _ref$position, toastOptions = _ref.toastOptions, gutter = _ref.gutter, children = _ref.children, containerStyle = _ref.containerStyle, containerClassName = _ref.containerClassName;
    var _useToaster = $07cb52bd1cb077b9$export$f46171b59bb094f9(toastOptions), toasts = _useToaster.toasts, handlers = _useToaster.handlers;
    return (0, $jC8Vy.createElement)("div", {
        style: $07cb52bd1cb077b9$var$_extends({
            position: "fixed",
            zIndex: 9999,
            top: $07cb52bd1cb077b9$var$DEFAULT_OFFSET,
            left: $07cb52bd1cb077b9$var$DEFAULT_OFFSET,
            right: $07cb52bd1cb077b9$var$DEFAULT_OFFSET,
            bottom: $07cb52bd1cb077b9$var$DEFAULT_OFFSET,
            pointerEvents: "none"
        }, containerStyle),
        className: containerClassName,
        onMouseEnter: handlers.startPause,
        onMouseLeave: handlers.endPause
    }, toasts.map(function(t) {
        var toastPosition = t.position || position;
        var offset = handlers.calculateOffset(t, {
            reverseOrder: reverseOrder,
            gutter: gutter,
            defaultPosition: position
        });
        var positionStyle = $07cb52bd1cb077b9$var$getPositionStyle(toastPosition, offset);
        var ref = t.height ? undefined : $07cb52bd1cb077b9$var$createRectRef(function(rect) {
            handlers.updateHeight(t.id, rect.height);
        });
        return (0, $jC8Vy.createElement)("div", {
            ref: ref,
            className: t.visible ? $07cb52bd1cb077b9$var$activeClass : "",
            key: t.id,
            style: positionStyle
        }, t.type === "custom" ? $07cb52bd1cb077b9$export$d812c8e1906863d0(t.message, t) : children ? children(t) : (0, $jC8Vy.createElement)($07cb52bd1cb077b9$export$af68597b0c62c1df, {
            toast: t,
            position: toastPosition
        }));
    }));
};
var $07cb52bd1cb077b9$export$2e2bcd8739ae039 = $07cb52bd1cb077b9$export$b410431fab84fa58;

});
parcelRequire.register("jvTSI", function(module, exports) {

$parcel$export(module.exports, "css", function () { return $e34c427625cba931$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $e34c427625cba931$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "setup", function () { return $e34c427625cba931$export$de27182ff8187d6c; });
$parcel$export(module.exports, "styled", function () { return $e34c427625cba931$export$3817b7a54a07cec7; });
let $e34c427625cba931$var$e = {
    data: ""
}, $e34c427625cba931$var$t = (t)=>"object" == typeof window ? ((t ? t.querySelector("#_goober") : window._goober) || Object.assign((t || document.head).appendChild(document.createElement("style")), {
        innerHTML: " ",
        id: "_goober"
    })).firstChild : t || $e34c427625cba931$var$e, $e34c427625cba931$export$54aba348a7896325 = (e)=>{
    let r = $e34c427625cba931$var$t(e), l = r.data;
    return r.data = "", l;
}, $e34c427625cba931$var$l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, $e34c427625cba931$var$a = /\/\*[^]*?\*\/|\s\s+|\n/g, $e34c427625cba931$var$n = (e, t)=>{
    let r = "", l = "", a = "";
    for(let o in e){
        let s = e[o];
        "@" == o[0] ? "i" == o[1] ? r = o + " " + s + ";" : l += "f" == o[1] ? $e34c427625cba931$var$n(s, o) : o + "{" + $e34c427625cba931$var$n(s, "k" == o[1] ? "" : t) + "}" : "object" == typeof s ? l += $e34c427625cba931$var$n(s, t ? t.replace(/([^,])+/g, (e)=>o.replace(/(^:.*)|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : o) : null != s && (o = /^--/.test(o) ? o : o.replace(/[A-Z]/g, "-$&").toLowerCase(), a += $e34c427625cba931$var$n.p ? $e34c427625cba931$var$n.p(o, s) : o + ":" + s + ";");
    }
    return r + (t && a ? t + "{" + a + "}" : a) + l;
}, $e34c427625cba931$var$o = {}, $e34c427625cba931$var$s = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + $e34c427625cba931$var$s(e[r]);
        return t;
    }
    return e;
}, $e34c427625cba931$var$c = (e, t, r, c, i)=>{
    let u = $e34c427625cba931$var$s(e), p = $e34c427625cba931$var$o[u] || ($e34c427625cba931$var$o[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!$e34c427625cba931$var$o[p]) {
        let t = u !== e ? e : ((e)=>{
            let t, r = [
                {}
            ];
            for(; t = $e34c427625cba931$var$l.exec(e.replace($e34c427625cba931$var$a, ""));)t[4] ? r.shift() : t[3] ? r.unshift(r[0][t[3]] = r[0][t[3]] || {}) : r[0][t[1]] = t[2];
            return r[0];
        })(e);
        $e34c427625cba931$var$o[p] = $e34c427625cba931$var$n(i ? {
            ["@keyframes " + p]: t
        } : t, r ? "" : "." + p);
    }
    return ((e, t, r)=>{
        -1 == t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })($e34c427625cba931$var$o[p], t, c), p;
}, $e34c427625cba931$var$i = (e, t, r)=>e.reduce((e, l, a)=>{
        let o = t[a];
        if (o && o.call) {
            let e = o(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            o = t ? "." + t : e && "object" == typeof e ? e.props ? "" : $e34c427625cba931$var$n(e, "") : !1 === e ? "" : e;
        }
        return e + l + (null == o ? "" : o);
    }, "");
function $e34c427625cba931$export$dbf350e5966cf602(e) {
    let r = this || {}, l = e.call ? e(r.p) : e;
    return $e34c427625cba931$var$c(l.unshift ? l.raw ? $e34c427625cba931$var$i(l, [].slice.call(arguments, 1), r.p) : l.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : l, $e34c427625cba931$var$t(r.target), r.g, r.o, r.k);
}
let $e34c427625cba931$var$p, $e34c427625cba931$var$d, $e34c427625cba931$var$f, $e34c427625cba931$export$442f1a04865e4790 = $e34c427625cba931$export$dbf350e5966cf602.bind({
    g: 1
}), $e34c427625cba931$export$d25ddfdf17c3ad3e = $e34c427625cba931$export$dbf350e5966cf602.bind({
    k: 1
});
function $e34c427625cba931$export$de27182ff8187d6c(e, t, r, l) {
    $e34c427625cba931$var$n.p = t, $e34c427625cba931$var$p = e, $e34c427625cba931$var$d = r, $e34c427625cba931$var$f = l;
}
function $e34c427625cba931$export$3817b7a54a07cec7(e, t) {
    let r = this || {};
    return function() {
        let l = arguments;
        function a(n, o) {
            let s = Object.assign({}, n), c = s.className || a.className;
            r.p = Object.assign({
                theme: $e34c427625cba931$var$d && $e34c427625cba931$var$d()
            }, s), r.o = / *go\d+/.test(c), s.className = $e34c427625cba931$export$dbf350e5966cf602.apply(r, l) + (c ? " " + c : ""), t && (s.ref = o);
            let i = e;
            return e[0] && (i = s.as || e, delete s.as), $e34c427625cba931$var$f && i[0] && $e34c427625cba931$var$f(s), $e34c427625cba931$var$p(i, s);
        }
        return t ? t(a) : a;
    };
}

});


parcelRequire.register("8Mb3E", function(module, exports) {
$parcel$export(module.exports, "darkModeApplicationIconMap", function () { return (parcelRequire("gyL1Y")).darkModeApplicationIconMap; });
$parcel$export(module.exports, "lightModeApplicationIconMap", function () { return (parcelRequire("gyL1Y")).lightModeApplicationIconMap; });
$parcel$export(module.exports, "thirdPartyApplicationIcon", function () { return (parcelRequire("e8luV")).default; });
$parcel$export(module.exports, "thirdPartyApplicationIconDark", function () { return (parcelRequire("dxSXj")).default; });
$parcel$export(module.exports, "connectorPlatformLabel", function () { return (parcelRequire("lmQmj")).connectorPlatformLabel; });
$parcel$export(module.exports, "defaultEmailConnectorGroup", function () { return (parcelRequire("lmQmj")).defaultEmailConnectorGroup; });
$parcel$export(module.exports, "defaultSmsConnectorGroup", function () { return (parcelRequire("lmQmj")).defaultSmsConnectorGroup; });
$parcel$export(module.exports, "supportNativePlatformTargets", function () { return (parcelRequire("lmQmj")).supportNativePlatformTargets; });
$parcel$export(module.exports, "auditLogEventTitle", function () { return (parcelRequire("h8YkU")).auditLogEventTitle; });
$parcel$export(module.exports, "cloudApi", function () { return (parcelRequire("7YcaX")).cloudApi; });
$parcel$export(module.exports, "meApi", function () { return (parcelRequire("7YcaX")).meApi; });
$parcel$export(module.exports, "adminTenantEndpoint", function () { return (parcelRequire("ku6YN")).adminTenantEndpoint; });
$parcel$export(module.exports, "defaultSubscriptionPlan", function () { return (parcelRequire("ku6YN")).defaultSubscriptionPlan; });
$parcel$export(module.exports, "defaultTenantResponse", function () { return (parcelRequire("ku6YN")).defaultTenantResponse; });
$parcel$export(module.exports, "mainTitle", function () { return (parcelRequire("ku6YN")).mainTitle; });
$parcel$export(module.exports, "ApiResourceDetailsTabs", function () { return (parcelRequire("bt3dS")).ApiResourceDetailsTabs; });
$parcel$export(module.exports, "ApplicationDetailsTabs", function () { return (parcelRequire("bt3dS")).ApplicationDetailsTabs; });
$parcel$export(module.exports, "ConnectorsTabs", function () { return (parcelRequire("bt3dS")).ConnectorsTabs; });
$parcel$export(module.exports, "EnterpriseSsoDetailsTabs", function () { return (parcelRequire("bt3dS")).EnterpriseSsoDetailsTabs; });
$parcel$export(module.exports, "OrganizationRoleDetailsTabs", function () { return (parcelRequire("bt3dS")).OrganizationRoleDetailsTabs; });
$parcel$export(module.exports, "OrganizationTemplateTabs", function () { return (parcelRequire("bt3dS")).OrganizationTemplateTabs; });
$parcel$export(module.exports, "TenantSettingsTabs", function () { return (parcelRequire("bt3dS")).TenantSettingsTabs; });
$parcel$export(module.exports, "WebhookDetailsTabs", function () { return (parcelRequire("bt3dS")).WebhookDetailsTabs; });
$parcel$export(module.exports, "contactEmail", function () { return (parcelRequire("cfL6o")).contactEmail; });
$parcel$export(module.exports, "contactEmailLink", function () { return (parcelRequire("cfL6o")).contactEmailLink; });
$parcel$export(module.exports, "discordLink", function () { return (parcelRequire("cfL6o")).discordLink; });
$parcel$export(module.exports, "envTagsFeatureLink", function () { return (parcelRequire("cfL6o")).envTagsFeatureLink; });
$parcel$export(module.exports, "githubIssuesLink", function () { return (parcelRequire("cfL6o")).githubIssuesLink; });
$parcel$export(module.exports, "githubOrgLink", function () { return (parcelRequire("cfL6o")).githubOrgLink; });
$parcel$export(module.exports, "githubReleasesLink", function () { return (parcelRequire("cfL6o")).githubReleasesLink; });
$parcel$export(module.exports, "logtoThirdPartyAppBrandingLink", function () { return (parcelRequire("cfL6o")).logtoThirdPartyAppBrandingLink; });
$parcel$export(module.exports, "logtoThirdPartyAppPermissionsLink", function () { return (parcelRequire("cfL6o")).logtoThirdPartyAppPermissionsLink; });
$parcel$export(module.exports, "logtoThirdPartyGuideLink", function () { return (parcelRequire("cfL6o")).logtoThirdPartyGuideLink; });
$parcel$export(module.exports, "newPlansBlogLink", function () { return (parcelRequire("cfL6o")).newPlansBlogLink; });
$parcel$export(module.exports, "organizationPermissionLink", function () { return (parcelRequire("cfL6o")).organizationPermissionLink; });
$parcel$export(module.exports, "organizationRoleLink", function () { return (parcelRequire("cfL6o")).organizationRoleLink; });
$parcel$export(module.exports, "organizationsFeatureLink", function () { return (parcelRequire("cfL6o")).organizationsFeatureLink; });
$parcel$export(module.exports, "organizationTemplateLink", function () { return (parcelRequire("cfL6o")).organizationTemplateLink; });
$parcel$export(module.exports, "pricingLink", function () { return (parcelRequire("cfL6o")).pricingLink; });
$parcel$export(module.exports, "protectedAppLink", function () { return (parcelRequire("cfL6o")).protectedAppLink; });
$parcel$export(module.exports, "reservationLink", function () { return (parcelRequire("cfL6o")).reservationLink; });
$parcel$export(module.exports, "signingKeysLink", function () { return (parcelRequire("cfL6o")).signingKeysLink; });
$parcel$export(module.exports, "trustAndSecurityLink", function () { return (parcelRequire("cfL6o")).trustAndSecurityLink; });
$parcel$export(module.exports, "storageKeys", function () { return (parcelRequire("fb30i")).storageKeys; });

$parcel$export(module.exports, "requestTimeout", function () { return $ed0c0c953b5440fc$export$363ac302bdbd807b; });
$parcel$export(module.exports, "defaultPageSize", function () { return $ed0c0c953b5440fc$export$d515e179bb47bd84; });
$parcel$export(module.exports, "searchKeys", function () { return $ed0c0c953b5440fc$export$7b45cbfd4fd1e917; });
parcelRequire("gyL1Y");
parcelRequire("lmQmj");
parcelRequire("h8YkU");
parcelRequire("7YcaX");
parcelRequire("ku6YN");
parcelRequire("bt3dS");
parcelRequire("cfL6o");
parcelRequire("fb30i");
const $ed0c0c953b5440fc$export$363ac302bdbd807b = 20000;
const $ed0c0c953b5440fc$export$d515e179bb47bd84 = 20;
var $ed0c0c953b5440fc$export$7b45cbfd4fd1e917;
(function(searchKeys) {
    searchKeys["signUp"] = "sign_up";
})($ed0c0c953b5440fc$export$7b45cbfd4fd1e917 || ($ed0c0c953b5440fc$export$7b45cbfd4fd1e917 = {}));

});
parcelRequire.register("gyL1Y", function(module, exports) {

$parcel$export(module.exports, "lightModeApplicationIconMap", function () { return $7916f2cf6fec782d$export$ae9903c14ae038a2; });
$parcel$export(module.exports, "darkModeApplicationIconMap", function () { return $7916f2cf6fec782d$export$3d5d47bf867c811b; });
$parcel$export(module.exports, "thirdPartyApplicationIconDark", function () { return (parcelRequire("dxSXj")).default; });
$parcel$export(module.exports, "thirdPartyApplicationIcon", function () { return (parcelRequire("e8luV")).default; });
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");

var $aPWhn = parcelRequire("aPWhn");

var $hg5YK = parcelRequire("hg5YK");

var $kozlF = parcelRequire("kozlF");

var $clGLf = parcelRequire("clGLf");

var $m3h86 = parcelRequire("m3h86");

var $lwdI3 = parcelRequire("lwdI3");

var $bB4n7 = parcelRequire("bB4n7");

var $XFmQ1 = parcelRequire("XFmQ1");

var $isD4E = parcelRequire("isD4E");

var $7GmJf = parcelRequire("7GmJf");

var $dxSXj = parcelRequire("dxSXj");

var $e8luV = parcelRequire("e8luV");
const $7916f2cf6fec782d$export$ae9903c14ae038a2 = Object.freeze({
    [(0, $61Yml.ApplicationType).Native]: (0, $clGLf.default),
    [(0, $61Yml.ApplicationType).SPA]: (0, $XFmQ1.default),
    [(0, $61Yml.ApplicationType).Traditional]: (0, $7GmJf.default),
    [(0, $61Yml.ApplicationType).MachineToMachine]: (0, $hg5YK.default),
    [(0, $61Yml.ApplicationType).Protected]: (0, $lwdI3.default)
});
const $7916f2cf6fec782d$export$3d5d47bf867c811b = Object.freeze({
    [(0, $61Yml.ApplicationType).Native]: (0, $kozlF.default),
    [(0, $61Yml.ApplicationType).SPA]: (0, $bB4n7.default),
    [(0, $61Yml.ApplicationType).Traditional]: (0, $isD4E.default),
    [(0, $61Yml.ApplicationType).MachineToMachine]: (0, $aPWhn.default),
    [(0, $61Yml.ApplicationType).Protected]: (0, $m3h86.default)
});

});
parcelRequire.register("cuPVN", function(module, exports) {
$parcel$export(module.exports, "customClientMetadataGuard", function () { return (parcelRequire("ZBK3w")).customClientMetadataGuard; });
$parcel$export(module.exports, "DataHookSchema", function () { return (parcelRequire("7CUeL")).DataHookSchema; });
$parcel$export(module.exports, "DomainStatus", function () { return (parcelRequire("3zL0M")).DomainStatus; });
$parcel$export(module.exports, "hookEvents", function () { return (parcelRequire("7CUeL")).hookEvents; });
$parcel$export(module.exports, "InteractionHookEvent", function () { return (parcelRequire("7CUeL")).InteractionHookEvent; });
$parcel$export(module.exports, "jsonGuard", function () { return (parcelRequire("j080Y")).jsonGuard; });
$parcel$export(module.exports, "jsonObjectGuard", function () { return (parcelRequire("j080Y")).jsonObjectGuard; });
$parcel$export(module.exports, "LogResult", function () { return (parcelRequire("7GyLL")).LogResult; });
$parcel$export(module.exports, "MfaFactor", function () { return (parcelRequire("8lyC3")).MfaFactor; });
$parcel$export(module.exports, "MfaPolicy", function () { return (parcelRequire("8lyC3")).MfaPolicy; });
$parcel$export(module.exports, "SignInIdentifier", function () { return (parcelRequire("8lyC3")).SignInIdentifier; });
$parcel$export(module.exports, "ssoBrandingGuard", function () { return (parcelRequire("kupPr")).ssoBrandingGuard; });
$parcel$export(module.exports, "ApplicationType", function () { return (parcelRequire("61Yml")).ApplicationType; });
$parcel$export(module.exports, "OrganizationInvitationStatus", function () { return (parcelRequire("61Yml")).OrganizationInvitationStatus; });
$parcel$export(module.exports, "RoleType", function () { return (parcelRequire("61Yml")).RoleType; });
$parcel$export(module.exports, "SignInMode", function () { return (parcelRequire("61Yml")).SignInMode; });
$parcel$export(module.exports, "AdditionalFeatures", function () { return (parcelRequire("dNkWp")).AdditionalFeatures; });
$parcel$export(module.exports, "ApplicationUserConsentScopeType", function () { return (parcelRequire("fGvTA")).ApplicationUserConsentScopeType; });
$parcel$export(module.exports, "ConnectorPlatform", function () { return (parcelRequire("cIy8v")).ConnectorPlatform; });
$parcel$export(module.exports, "ConnectorType", function () { return (parcelRequire("kowfT")).ConnectorType; });
$parcel$export(module.exports, "getTenantIdFromOrganizationId", function () { return (parcelRequire("aZIrr")).getTenantIdFromOrganizationId; });
$parcel$export(module.exports, "getTenantOrganizationId", function () { return (parcelRequire("aZIrr")).getTenantOrganizationId; });
$parcel$export(module.exports, "hookTestErrorResponseDataGuard", function () { return (parcelRequire("kSjlW")).hookTestErrorResponseDataGuard; });
$parcel$export(module.exports, "LogtoJwtTokenKey", function () { return (parcelRequire("jnq2J")).LogtoJwtTokenKey; });
$parcel$export(module.exports, "LogtoJwtTokenKeyType", function () { return (parcelRequire("6NioG")).LogtoJwtTokenKeyType; });
$parcel$export(module.exports, "LogtoOidcConfigKeyType", function () { return (parcelRequire("jnq2J")).LogtoOidcConfigKeyType; });
$parcel$export(module.exports, "maxUploadFileSize", function () { return (parcelRequire("2rWG7")).maxUploadFileSize; });
$parcel$export(module.exports, "PredefinedScope", function () { return (parcelRequire("68782")).PredefinedScope; });
$parcel$export(module.exports, "Project", function () { return (parcelRequire("dNkWp")).Project; });
$parcel$export(module.exports, "SsoProviderName", function () { return (parcelRequire("8q742")).SsoProviderName; });
$parcel$export(module.exports, "SsoProviderType", function () { return (parcelRequire("8q742")).SsoProviderType; });
$parcel$export(module.exports, "Stage", function () { return (parcelRequire("dNkWp")).Stage; });
$parcel$export(module.exports, "SupportedSigningKeyAlgorithm", function () { return (parcelRequire("jnq2J")).SupportedSigningKeyAlgorithm; });
$parcel$export(module.exports, "TenantRole", function () { return (parcelRequire("aZIrr")).TenantRole; });
$parcel$export(module.exports, "TenantScope", function () { return (parcelRequire("aZIrr")).TenantScope; });
$parcel$export(module.exports, "TenantTag", function () { return (parcelRequire("iq1sR")).TenantTag; });
$parcel$export(module.exports, "Theme", function () { return (parcelRequire("5HVJe")).Theme; });
$parcel$export(module.exports, "userOnboardingDataGuard", function () { return (parcelRequire("dNkWp")).userOnboardingDataGuard; });
$parcel$export(module.exports, "userOnboardingDataKey", function () { return (parcelRequire("dNkWp")).userOnboardingDataKey; });
$parcel$export(module.exports, "adminConsoleApplicationId", function () { return (parcelRequire("5TTZn")).adminConsoleApplicationId; });
$parcel$export(module.exports, "adminTenantId", function () { return (parcelRequire("6hxiJ")).adminTenantId; });
$parcel$export(module.exports, "cloudApiIndicator", function () { return (parcelRequire("4hqEo")).cloudApiIndicator; });
$parcel$export(module.exports, "CloudScope", function () { return (parcelRequire("4hqEo")).CloudScope; });
$parcel$export(module.exports, "defaultManagementApi", function () { return (parcelRequire("j0apn")).defaultManagementApi; });
$parcel$export(module.exports, "defaultTenantId", function () { return (parcelRequire("6hxiJ")).defaultTenantId; });
$parcel$export(module.exports, "demoAppApplicationId", function () { return (parcelRequire("5TTZn")).demoAppApplicationId; });
$parcel$export(module.exports, "getManagementApiResourceIndicator", function () { return (parcelRequire("j0apn")).getManagementApiResourceIndicator; });
$parcel$export(module.exports, "customClientMetadataDefault", function () { return (parcelRequire("7cCjo")).customClientMetadataDefault; });
$parcel$export(module.exports, "maxFreeTenantLimit", function () { return (parcelRequire("clRgC")).maxFreeTenantLimit; });
$parcel$export(module.exports, "ossConsolePath", function () { return (parcelRequire("fjAdn")).ossConsolePath; });
$parcel$export(module.exports, "ReservedPlanId", function () { return (parcelRequire("lXQZH")).ReservedPlanId; });
$parcel$export(module.exports, "findDuplicatedOrBlockedEmailDomains", function () { return (parcelRequire("8ynli")).findDuplicatedOrBlockedEmailDomains; });
$parcel$export(module.exports, "internalRolePrefix", function () { return (parcelRequire("2nQqt")).internalRolePrefix; });
$parcel$export(module.exports, "isManagementApi", function () { return (parcelRequire("9XFlr")).isManagementApi; });
parcelRequire("5Fb6p");
parcelRequire("gh8Fv");
parcelRequire("1qlsF");
parcelRequire("7cEg6");
parcelRequire("c359g");
parcelRequire("jEsaU");
parcelRequire("6Cu0c");

});
parcelRequire.register("5Fb6p", function(module, exports) {
$parcel$export(module.exports, "brandingGuard", function () { return (parcelRequire("8lyC3")).brandingGuard; });
$parcel$export(module.exports, "cloudflareDataGuard", function () { return (parcelRequire("3zL0M")).cloudflareDataGuard; });
$parcel$export(module.exports, "colorGuard", function () { return (parcelRequire("8lyC3")).colorGuard; });
$parcel$export(module.exports, "configurableConnectorMetadataGuard", function () { return (parcelRequire("cIy8v")).configurableConnectorMetadataGuard; });
$parcel$export(module.exports, "connectorTargetsGuard", function () { return (parcelRequire("8lyC3")).connectorTargetsGuard; });
$parcel$export(module.exports, "customClientMetadataGuard", function () { return (parcelRequire("ZBK3w")).customClientMetadataGuard; });
$parcel$export(module.exports, "customContentGuard", function () { return (parcelRequire("8lyC3")).customContentGuard; });
$parcel$export(module.exports, "DataHookSchema", function () { return (parcelRequire("7CUeL")).DataHookSchema; });
$parcel$export(module.exports, "domainDnsRecordsGuard", function () { return (parcelRequire("3zL0M")).domainDnsRecordsGuard; });
$parcel$export(module.exports, "DomainStatus", function () { return (parcelRequire("3zL0M")).DomainStatus; });
$parcel$export(module.exports, "domainStatusGuard", function () { return (parcelRequire("3zL0M")).domainStatusGuard; });
$parcel$export(module.exports, "hookConfigGuard", function () { return (parcelRequire("7CUeL")).hookConfigGuard; });
$parcel$export(module.exports, "hookEventGuard", function () { return (parcelRequire("7CUeL")).hookEventGuard; });
$parcel$export(module.exports, "hookEvents", function () { return (parcelRequire("7CUeL")).hookEvents; });
$parcel$export(module.exports, "hookEventsGuard", function () { return (parcelRequire("7CUeL")).hookEventsGuard; });
$parcel$export(module.exports, "identitiesGuard", function () { return (parcelRequire("1QRmm")).identitiesGuard; });
$parcel$export(module.exports, "InteractionHookEvent", function () { return (parcelRequire("7CUeL")).InteractionHookEvent; });
$parcel$export(module.exports, "jsonGuard", function () { return (parcelRequire("j080Y")).jsonGuard; });
$parcel$export(module.exports, "jsonObjectGuard", function () { return (parcelRequire("j080Y")).jsonObjectGuard; });
$parcel$export(module.exports, "languageInfoGuard", function () { return (parcelRequire("8lyC3")).languageInfoGuard; });
$parcel$export(module.exports, "logContextPayloadGuard", function () { return (parcelRequire("7GyLL")).logContextPayloadGuard; });
$parcel$export(module.exports, "LogResult", function () { return (parcelRequire("7GyLL")).LogResult; });
$parcel$export(module.exports, "MfaFactor", function () { return (parcelRequire("8lyC3")).MfaFactor; });
$parcel$export(module.exports, "mfaFactorsGuard", function () { return (parcelRequire("8lyC3")).mfaFactorsGuard; });
$parcel$export(module.exports, "mfaGuard", function () { return (parcelRequire("8lyC3")).mfaGuard; });
$parcel$export(module.exports, "MfaPolicy", function () { return (parcelRequire("8lyC3")).MfaPolicy; });
$parcel$export(module.exports, "mfaVerificationsGuard", function () { return (parcelRequire("1QRmm")).mfaVerificationsGuard; });
$parcel$export(module.exports, "oidcClientMetadataGuard", function () { return (parcelRequire("ZBK3w")).oidcClientMetadataGuard; });
$parcel$export(module.exports, "oidcModelInstancePayloadGuard", function () { return (parcelRequire("ZBK3w")).oidcModelInstancePayloadGuard; });
$parcel$export(module.exports, "partialPasswordPolicyGuard", function () { return (parcelRequire("7GyLL")).partialPasswordPolicyGuard; });
$parcel$export(module.exports, "protectedAppMetadataGuard", function () { return (parcelRequire("WxNQw")).protectedAppMetadataGuard; });
$parcel$export(module.exports, "sentinelActivityActionGuard", function () { return (parcelRequire("hMPN6")).sentinelActivityActionGuard; });
$parcel$export(module.exports, "sentinelActivityPayloadGuard", function () { return (parcelRequire("hMPN6")).sentinelActivityPayloadGuard; });
$parcel$export(module.exports, "sentinelActivityTargetTypeGuard", function () { return (parcelRequire("hMPN6")).sentinelActivityTargetTypeGuard; });
$parcel$export(module.exports, "signInGuard", function () { return (parcelRequire("8lyC3")).signInGuard; });
$parcel$export(module.exports, "SignInIdentifier", function () { return (parcelRequire("8lyC3")).SignInIdentifier; });
$parcel$export(module.exports, "signUpGuard", function () { return (parcelRequire("8lyC3")).signUpGuard; });
$parcel$export(module.exports, "ssoBrandingGuard", function () { return (parcelRequire("kupPr")).ssoBrandingGuard; });
$parcel$export(module.exports, "ssoDomainsGuard", function () { return (parcelRequire("kupPr")).ssoDomainsGuard; });
$parcel$export(module.exports, "translationGuard", function () { return (parcelRequire("cqPmz")).translationGuard; });
$parcel$export(module.exports, "userProfileGuard", function () { return (parcelRequire("1QRmm")).userProfileGuard; });
$parcel$export(module.exports, "webAuthnTransportGuard", function () { return (parcelRequire("1QRmm")).webAuthnTransportGuard; });
parcelRequire("90TkQ");
parcelRequire("iLhA3");

});
parcelRequire.register("90TkQ", function(module, exports) {

});

parcelRequire.register("iLhA3", function(module, exports) {
$parcel$export(module.exports, "cloudflareDataGuard", function () { return (parcelRequire("3zL0M")).cloudflareDataGuard; });
$parcel$export(module.exports, "domainDnsRecordsGuard", function () { return (parcelRequire("3zL0M")).domainDnsRecordsGuard; });
$parcel$export(module.exports, "DomainStatus", function () { return (parcelRequire("3zL0M")).DomainStatus; });
$parcel$export(module.exports, "domainStatusGuard", function () { return (parcelRequire("3zL0M")).domainStatusGuard; });
$parcel$export(module.exports, "DataHookSchema", function () { return (parcelRequire("7CUeL")).DataHookSchema; });
$parcel$export(module.exports, "hookConfigGuard", function () { return (parcelRequire("7CUeL")).hookConfigGuard; });
$parcel$export(module.exports, "hookEventGuard", function () { return (parcelRequire("7CUeL")).hookEventGuard; });
$parcel$export(module.exports, "hookEvents", function () { return (parcelRequire("7CUeL")).hookEvents; });
$parcel$export(module.exports, "hookEventsGuard", function () { return (parcelRequire("7CUeL")).hookEventsGuard; });
$parcel$export(module.exports, "InteractionHookEvent", function () { return (parcelRequire("7CUeL")).InteractionHookEvent; });
$parcel$export(module.exports, "logContextPayloadGuard", function () { return (parcelRequire("7GyLL")).logContextPayloadGuard; });
$parcel$export(module.exports, "LogResult", function () { return (parcelRequire("7GyLL")).LogResult; });
$parcel$export(module.exports, "partialPasswordPolicyGuard", function () { return (parcelRequire("7GyLL")).partialPasswordPolicyGuard; });
$parcel$export(module.exports, "customClientMetadataGuard", function () { return (parcelRequire("ZBK3w")).customClientMetadataGuard; });
$parcel$export(module.exports, "oidcClientMetadataGuard", function () { return (parcelRequire("ZBK3w")).oidcClientMetadataGuard; });
$parcel$export(module.exports, "oidcModelInstancePayloadGuard", function () { return (parcelRequire("ZBK3w")).oidcModelInstancePayloadGuard; });
$parcel$export(module.exports, "translationGuard", function () { return (parcelRequire("cqPmz")).translationGuard; });
$parcel$export(module.exports, "brandingGuard", function () { return (parcelRequire("8lyC3")).brandingGuard; });
$parcel$export(module.exports, "colorGuard", function () { return (parcelRequire("8lyC3")).colorGuard; });
$parcel$export(module.exports, "connectorTargetsGuard", function () { return (parcelRequire("8lyC3")).connectorTargetsGuard; });
$parcel$export(module.exports, "customContentGuard", function () { return (parcelRequire("8lyC3")).customContentGuard; });
$parcel$export(module.exports, "languageInfoGuard", function () { return (parcelRequire("8lyC3")).languageInfoGuard; });
$parcel$export(module.exports, "MfaFactor", function () { return (parcelRequire("8lyC3")).MfaFactor; });
$parcel$export(module.exports, "mfaFactorsGuard", function () { return (parcelRequire("8lyC3")).mfaFactorsGuard; });
$parcel$export(module.exports, "mfaGuard", function () { return (parcelRequire("8lyC3")).mfaGuard; });
$parcel$export(module.exports, "MfaPolicy", function () { return (parcelRequire("8lyC3")).MfaPolicy; });
$parcel$export(module.exports, "signInGuard", function () { return (parcelRequire("8lyC3")).signInGuard; });
$parcel$export(module.exports, "SignInIdentifier", function () { return (parcelRequire("8lyC3")).SignInIdentifier; });
$parcel$export(module.exports, "signUpGuard", function () { return (parcelRequire("8lyC3")).signUpGuard; });
$parcel$export(module.exports, "sentinelActivityActionGuard", function () { return (parcelRequire("hMPN6")).sentinelActivityActionGuard; });
$parcel$export(module.exports, "sentinelActivityPayloadGuard", function () { return (parcelRequire("hMPN6")).sentinelActivityPayloadGuard; });
$parcel$export(module.exports, "sentinelActivityTargetTypeGuard", function () { return (parcelRequire("hMPN6")).sentinelActivityTargetTypeGuard; });
$parcel$export(module.exports, "identitiesGuard", function () { return (parcelRequire("1QRmm")).identitiesGuard; });
$parcel$export(module.exports, "mfaVerificationsGuard", function () { return (parcelRequire("1QRmm")).mfaVerificationsGuard; });
$parcel$export(module.exports, "userProfileGuard", function () { return (parcelRequire("1QRmm")).userProfileGuard; });
$parcel$export(module.exports, "webAuthnTransportGuard", function () { return (parcelRequire("1QRmm")).webAuthnTransportGuard; });
$parcel$export(module.exports, "ssoBrandingGuard", function () { return (parcelRequire("kupPr")).ssoBrandingGuard; });
$parcel$export(module.exports, "ssoDomainsGuard", function () { return (parcelRequire("kupPr")).ssoDomainsGuard; });
$parcel$export(module.exports, "protectedAppMetadataGuard", function () { return (parcelRequire("WxNQw")).protectedAppMetadataGuard; });

$parcel$export(module.exports, "configurableConnectorMetadataGuard", function () { return (parcelRequire("cIy8v")).configurableConnectorMetadataGuard; });
$parcel$export(module.exports, "jsonGuard", function () { return (parcelRequire("j080Y")).jsonGuard; });
$parcel$export(module.exports, "jsonObjectGuard", function () { return (parcelRequire("j080Y")).jsonObjectGuard; });
parcelRequire("3zL0M");
parcelRequire("7CUeL");
parcelRequire("7GyLL");
parcelRequire("ZBK3w");
parcelRequire("cqPmz");
parcelRequire("8lyC3");
parcelRequire("hMPN6");
parcelRequire("1QRmm");
parcelRequire("kupPr");
parcelRequire("WxNQw");
parcelRequire("oK7kD");
var $cIy8v = parcelRequire("cIy8v");
var $j080Y = parcelRequire("j080Y");

});
parcelRequire.register("3zL0M", function(module, exports) {

$parcel$export(module.exports, "domainDnsRecordsGuard", function () { return $29a91b7ef22d9c16$export$ab6045338fa7d71b; });
$parcel$export(module.exports, "cloudflareDataGuard", function () { return $29a91b7ef22d9c16$export$10762083065a1f71; });
$parcel$export(module.exports, "DomainStatus", function () { return $29a91b7ef22d9c16$export$4bfadd7b59276a6c; });
$parcel$export(module.exports, "domainStatusGuard", function () { return $29a91b7ef22d9c16$export$fda7fbe88a5ffb61; });

var $c3dK3 = parcelRequire("c3dK3");
const $29a91b7ef22d9c16$export$48c1db756576ae1 = (0, $c3dK3.z).object({
    name: (0, $c3dK3.z).string(),
    type: (0, $c3dK3.z).string(),
    value: (0, $c3dK3.z).string()
});
const $29a91b7ef22d9c16$export$ab6045338fa7d71b = $29a91b7ef22d9c16$export$48c1db756576ae1.array();
const $29a91b7ef22d9c16$export$10762083065a1f71 = (0, $c3dK3.z).object({
    id: (0, $c3dK3.z).string(),
    status: (0, $c3dK3.z).string(),
    ssl: (0, $c3dK3.z).object({
        status: (0, $c3dK3.z).string(),
        validation_errors: (0, $c3dK3.z).object({
            message: (0, $c3dK3.z).string()
        }).array().optional()
    }),
    verification_errors: (0, $c3dK3.z).string().array().optional()
});
var $29a91b7ef22d9c16$export$4bfadd7b59276a6c;
(function(DomainStatus) {
    DomainStatus["PendingVerification"] = "PendingVerification";
    DomainStatus["PendingSsl"] = "PendingSsl";
    DomainStatus["Active"] = "Active";
    DomainStatus["Error"] = "Error";
})($29a91b7ef22d9c16$export$4bfadd7b59276a6c || ($29a91b7ef22d9c16$export$4bfadd7b59276a6c = {}));
const $29a91b7ef22d9c16$export$fda7fbe88a5ffb61 = (0, $c3dK3.z).nativeEnum($29a91b7ef22d9c16$export$4bfadd7b59276a6c);

});

parcelRequire.register("7CUeL", function(module, exports) {

$parcel$export(module.exports, "InteractionHookEvent", function () { return $58d7b48a484a833d$export$740c928c8ba29add; });
$parcel$export(module.exports, "DataHookSchema", function () { return $58d7b48a484a833d$export$21fcfd6e96906288; });
$parcel$export(module.exports, "hookEvents", function () { return $58d7b48a484a833d$export$a2d50f63a5a1b889; });
$parcel$export(module.exports, "hookEventGuard", function () { return $58d7b48a484a833d$export$2d2b15eb4f8d4fc9; });
$parcel$export(module.exports, "hookEventsGuard", function () { return $58d7b48a484a833d$export$56e77a150fce61b; });
$parcel$export(module.exports, "hookConfigGuard", function () { return $58d7b48a484a833d$export$924993b6fcd8d738; });

var $c3dK3 = parcelRequire("c3dK3");
var $58d7b48a484a833d$export$740c928c8ba29add;
(function(InteractionHookEvent) {
    InteractionHookEvent["PostRegister"] = "PostRegister";
    InteractionHookEvent["PostSignIn"] = "PostSignIn";
    InteractionHookEvent["PostResetPassword"] = "PostResetPassword";
})($58d7b48a484a833d$export$740c928c8ba29add || ($58d7b48a484a833d$export$740c928c8ba29add = {}));
var $58d7b48a484a833d$export$21fcfd6e96906288;
(function(DataHookSchema) {
    DataHookSchema["User"] = "User";
    DataHookSchema["Role"] = "Role";
    DataHookSchema["Scope"] = "Scope";
    DataHookSchema["Organization"] = "Organization";
    DataHookSchema["OrganizationRole"] = "OrganizationRole";
    DataHookSchema["OrganizationScope"] = "OrganizationScope";
})($58d7b48a484a833d$export$21fcfd6e96906288 || ($58d7b48a484a833d$export$21fcfd6e96906288 = {}));
var $58d7b48a484a833d$var$DataHookBasicMutationType;
(function(DataHookBasicMutationType) {
    DataHookBasicMutationType["Created"] = "Created";
    DataHookBasicMutationType["Deleted"] = "Deleted";
})($58d7b48a484a833d$var$DataHookBasicMutationType || ($58d7b48a484a833d$var$DataHookBasicMutationType = {}));
var $58d7b48a484a833d$var$DataHookDetailMutationType;
(function(DataHookDetailMutationType) {
    DataHookDetailMutationType["Updated"] = "Updated";
})($58d7b48a484a833d$var$DataHookDetailMutationType || ($58d7b48a484a833d$var$DataHookDetailMutationType = {}));
const $58d7b48a484a833d$export$a2d50f63a5a1b889 = Object.freeze([
    $58d7b48a484a833d$export$740c928c8ba29add.PostRegister,
    $58d7b48a484a833d$export$740c928c8ba29add.PostSignIn,
    $58d7b48a484a833d$export$740c928c8ba29add.PostResetPassword,
    "User.Created",
    "User.Deleted",
    "User.Data.Updated",
    "User.SuspensionStatus.Updated",
    "Role.Created",
    "Role.Deleted",
    "Role.Data.Updated",
    "Role.Scopes.Updated",
    "Scope.Created",
    "Scope.Deleted",
    "Scope.Data.Updated",
    "Organization.Created",
    "Organization.Deleted",
    "Organization.Data.Updated",
    "Organization.Membership.Updated",
    "OrganizationRole.Created",
    "OrganizationRole.Deleted",
    "OrganizationRole.Data.Updated",
    "OrganizationRole.Scopes.Updated",
    "OrganizationScope.Created",
    "OrganizationScope.Deleted",
    "OrganizationScope.Data.Updated"
]);
const $58d7b48a484a833d$export$2d2b15eb4f8d4fc9 = (0, $c3dK3.z).enum($58d7b48a484a833d$export$a2d50f63a5a1b889);
const $58d7b48a484a833d$export$56e77a150fce61b = $58d7b48a484a833d$export$2d2b15eb4f8d4fc9.array();
const $58d7b48a484a833d$export$d04e851658657a7f = (0, $c3dK3.z).nativeEnum($58d7b48a484a833d$export$740c928c8ba29add);
const $58d7b48a484a833d$export$924993b6fcd8d738 = (0, $c3dK3.z).object({
    /** We don't need `type` since v1 only has web hook */ // type: 'web';
    /** Method fixed to `POST` */ url: (0, $c3dK3.z).string(),
    /** Additional headers that attach to the request */ headers: (0, $c3dK3.z).record((0, $c3dK3.z).string()).optional(),
    /**
     * @deprecated
     * Retry times when hook response status >= 500.
     * Now the retry times is fixed to 3.
     * Keep for backward compatibility.
     */ retries: (0, $c3dK3.z).number().gte(0).lte(3).optional()
});
const $58d7b48a484a833d$export$d5a3d643322527d7 = Object.freeze({
    "POST /users": "User.Created",
    "DELETE /users/:userId": "User.Deleted",
    "PATCH /users/:userId": "User.Data.Updated",
    "PATCH /users/:userId/custom-data": "User.Data.Updated",
    "PATCH /users/:userId/profile": "User.Data.Updated",
    "PATCH /users/:userId/password": "User.Data.Updated",
    "PATCH /users/:userId/is-suspended": "User.SuspensionStatus.Updated",
    "POST /roles": "Role.Created",
    "DELETE /roles/:id": "Role.Deleted",
    "PATCH /roles/:id": "Role.Data.Updated",
    "POST /roles/:id/scopes": "Role.Scopes.Updated",
    "DELETE /roles/:id/scopes/:scopeId": "Role.Scopes.Updated",
    "POST /resources/:resourceId/scopes": "Scope.Created",
    "DELETE /resources/:resourceId/scopes/:scopeId": "Scope.Deleted",
    "PATCH /resources/:resourceId/scopes/:scopeId": "Scope.Data.Updated",
    "POST /organizations": "Organization.Created",
    "DELETE /organizations/:id": "Organization.Deleted",
    "PATCH /organizations/:id": "Organization.Data.Updated",
    "PUT /organizations/:id/users": "Organization.Membership.Updated",
    "POST /organizations/:id/users": "Organization.Membership.Updated",
    "DELETE /organizations/:id/users/:userId": "Organization.Membership.Updated",
    "POST /organization-roles": "OrganizationRole.Created",
    "DELETE /organization-roles/:id": "OrganizationRole.Deleted",
    "PATCH /organization-roles/:id": "OrganizationRole.Data.Updated",
    "POST /organization-scopes": "OrganizationScope.Created",
    "DELETE /organization-scopes/:id": "OrganizationScope.Deleted",
    "PATCH /organization-scopes/:id": "OrganizationScope.Data.Updated",
    "PUT /organization-roles/:id/scopes": "OrganizationRole.Scopes.Updated",
    "POST /organization-roles/:id/scopes": "OrganizationRole.Scopes.Updated",
    "DELETE /organization-roles/:id/scopes/:organizationScopeId": "OrganizationRole.Scopes.Updated"
});

});

parcelRequire.register("7GyLL", function(module, exports) {

$parcel$export(module.exports, "LogResult", function () { return $59876d1997166fbd$export$a20c8b5ccf36e075; });
$parcel$export(module.exports, "logContextPayloadGuard", function () { return $59876d1997166fbd$export$2938cb1ca9b4e331; });
$parcel$export(module.exports, "partialPasswordPolicyGuard", function () { return $59876d1997166fbd$export$eee4f836f95656a7; });
parcelRequire("4taJ0");
var $d1NuF = parcelRequire("d1NuF");

var $c3dK3 = parcelRequire("c3dK3");
var $59876d1997166fbd$export$a20c8b5ccf36e075;
(function(LogResult) {
    LogResult["Success"] = "Success";
    LogResult["Error"] = "Error";
})($59876d1997166fbd$export$a20c8b5ccf36e075 || ($59876d1997166fbd$export$a20c8b5ccf36e075 = {}));
const $59876d1997166fbd$export$2938cb1ca9b4e331 = (0, $c3dK3.z).object({
    key: (0, $c3dK3.z).string(),
    result: (0, $c3dK3.z).nativeEnum($59876d1997166fbd$export$a20c8b5ccf36e075),
    error: (0, $c3dK3.z).record((0, $c3dK3.z).string(), (0, $c3dK3.z).unknown()).or((0, $c3dK3.z).string()).optional(),
    ip: (0, $c3dK3.z).string().optional(),
    userAgent: (0, $c3dK3.z).string().optional(),
    userId: (0, $c3dK3.z).string().optional(),
    applicationId: (0, $c3dK3.z).string().optional(),
    sessionId: (0, $c3dK3.z).string().optional()
}).catchall((0, $c3dK3.z).unknown());
const $59876d1997166fbd$export$eee4f836f95656a7 = (0, $d1NuF.passwordPolicyGuard).deepPartial();

});
parcelRequire.register("4taJ0", function(module, exports) {
$parcel$export(module.exports, "generateDarkColor", function () { return (parcelRequire("gS6ii")).generateDarkColor; });
$parcel$export(module.exports, "isLocalhost", function () { return (parcelRequire("5rMXH")).isLocalhost; });
$parcel$export(module.exports, "isValidRegEx", function () { return (parcelRequire("b4hyY")).isValidRegEx; });
$parcel$export(module.exports, "isValidUrl", function () { return (parcelRequire("5rMXH")).isValidUrl; });
$parcel$export(module.exports, "validateRedirectUrl", function () { return (parcelRequire("5rMXH")).validateRedirectUrl; });
$parcel$export(module.exports, "validateUriOrigin", function () { return (parcelRequire("5rMXH")).validateUriOrigin; });
$parcel$export(module.exports, "domainRegEx", function () { return (parcelRequire("9vrm1")).domainRegEx; });
$parcel$export(module.exports, "emailRegEx", function () { return (parcelRequire("9vrm1")).emailRegEx; });
$parcel$export(module.exports, "hexColorRegEx", function () { return (parcelRequire("9vrm1")).hexColorRegEx; });
$parcel$export(module.exports, "noSpaceRegEx", function () { return (parcelRequire("9vrm1")).noSpaceRegEx; });
$parcel$export(module.exports, "phoneInputRegEx", function () { return (parcelRequire("9vrm1")).phoneInputRegEx; });
$parcel$export(module.exports, "phoneRegEx", function () { return (parcelRequire("9vrm1")).phoneRegEx; });
$parcel$export(module.exports, "usernameRegEx", function () { return (parcelRequire("9vrm1")).usernameRegEx; });
$parcel$export(module.exports, "buildOrganizationUrn", function () { return (parcelRequire("hyigV")).buildOrganizationUrn; });
$parcel$export(module.exports, "getOrganizationIdFromUrn", function () { return (parcelRequire("hyigV")).getOrganizationIdFromUrn; });
$parcel$export(module.exports, "organizationUrnPrefix", function () { return (parcelRequire("hyigV")).organizationUrnPrefix; });
$parcel$export(module.exports, "UserScope", function () { return (parcelRequire("hyigV")).UserScope; });
$parcel$export(module.exports, "httpCodeToMessage", function () { return (parcelRequire("37iDI")).httpCodeToMessage; });
$parcel$export(module.exports, "PasswordPolicyChecker", function () { return (parcelRequire("d1NuF")).PasswordPolicyChecker; });
$parcel$export(module.exports, "passwordPolicyGuard", function () { return (parcelRequire("d1NuF")).passwordPolicyGuard; });
parcelRequire("4dqSC");
parcelRequire("9vrm1");
parcelRequire("hyigV");
parcelRequire("6xnKJ");
parcelRequire("37iDI");
parcelRequire("d1NuF");

});
parcelRequire.register("4dqSC", function(module, exports) {
$parcel$export(module.exports, "generateDarkColor", function () { return (parcelRequire("gS6ii")).generateDarkColor; });
$parcel$export(module.exports, "isValidRegEx", function () { return (parcelRequire("b4hyY")).isValidRegEx; });
$parcel$export(module.exports, "isLocalhost", function () { return (parcelRequire("5rMXH")).isLocalhost; });
$parcel$export(module.exports, "isValidUrl", function () { return (parcelRequire("5rMXH")).isValidUrl; });
$parcel$export(module.exports, "validateRedirectUrl", function () { return (parcelRequire("5rMXH")).validateRedirectUrl; });
$parcel$export(module.exports, "validateUriOrigin", function () { return (parcelRequire("5rMXH")).validateUriOrigin; });
parcelRequire("gS6ii");
parcelRequire("b4hyY");
parcelRequire("5rMXH");

});
parcelRequire.register("gS6ii", function(module, exports) {

$parcel$export(module.exports, "generateDarkColor", function () { return $c4869261ebcfda47$export$2feb0cd4df065982; });

var $47hYn = parcelRequire("47hYn");
const $c4869261ebcfda47$export$2b47dd798c93e22f = (baseColor, delta)=>{
    const hslArray = baseColor.hsl().round().array();
    return (0, (/*@__PURE__*/$parcel$interopDefault($47hYn)))([
        hslArray[0] ?? 0,
        hslArray[1] ?? 0,
        (hslArray[2] ?? 0) + delta
    ], "hsl");
};
const $c4869261ebcfda47$export$13a5971b241f058c = (baseColor, delta)=>{
    const hslArray = baseColor.hsl().round().array();
    return (0, (/*@__PURE__*/$parcel$interopDefault($47hYn)))([
        hslArray[0] ?? 0,
        hslArray[1] ?? 0,
        (hslArray[2] ?? 0) - delta
    ], "hsl");
};
const $c4869261ebcfda47$export$2feb0cd4df065982 = (lightColor)=>$c4869261ebcfda47$export$2b47dd798c93e22f((0, (/*@__PURE__*/$parcel$interopDefault($47hYn)))(lightColor), 10).hex();

});
parcelRequire.register("47hYn", function(module, exports) {

var $aDJet = parcelRequire("aDJet");

var $8ej7X = parcelRequire("8ej7X");
const $2ff5c1ebf9ab478a$var$skippedModels = [
    // To be honest, I don't really feel like keyword belongs in color convert, but eh.
    "keyword",
    // Gray conflicts with some method names, and has its own method defined.
    "gray",
    // Shouldn't really be in color-convert either...
    "hex"
];
const $2ff5c1ebf9ab478a$var$hashedModelKeys = {};
for (const model of Object.keys($8ej7X))$2ff5c1ebf9ab478a$var$hashedModelKeys[[
    ...$8ej7X[model].labels
].sort().join("")] = model;
const $2ff5c1ebf9ab478a$var$limiters = {};
function $2ff5c1ebf9ab478a$var$Color(object, model) {
    if (!(this instanceof $2ff5c1ebf9ab478a$var$Color)) return new $2ff5c1ebf9ab478a$var$Color(object, model);
    if (model && model in $2ff5c1ebf9ab478a$var$skippedModels) model = null;
    if (model && !(model in $8ej7X)) throw new Error("Unknown model: " + model);
    let i;
    let channels;
    if (object == null) {
        this.model = "rgb";
        this.color = [
            0,
            0,
            0
        ];
        this.valpha = 1;
    } else if (object instanceof $2ff5c1ebf9ab478a$var$Color) {
        this.model = object.model;
        this.color = [
            ...object.color
        ];
        this.valpha = object.valpha;
    } else if (typeof object === "string") {
        const result = $aDJet.get(object);
        if (result === null) throw new Error("Unable to parse color from string: " + object);
        this.model = result.model;
        channels = $8ej7X[this.model].channels;
        this.color = result.value.slice(0, channels);
        this.valpha = typeof result.value[channels] === "number" ? result.value[channels] : 1;
    } else if (object.length > 0) {
        this.model = model || "rgb";
        channels = $8ej7X[this.model].channels;
        const newArray = Array.prototype.slice.call(object, 0, channels);
        this.color = $2ff5c1ebf9ab478a$var$zeroArray(newArray, channels);
        this.valpha = typeof object[channels] === "number" ? object[channels] : 1;
    } else if (typeof object === "number") {
        // This is always RGB - can be converted later on.
        this.model = "rgb";
        this.color = [
            object >> 16 & 0xFF,
            object >> 8 & 0xFF,
            object & 0xFF
        ];
        this.valpha = 1;
    } else {
        this.valpha = 1;
        const keys = Object.keys(object);
        if ("alpha" in object) {
            keys.splice(keys.indexOf("alpha"), 1);
            this.valpha = typeof object.alpha === "number" ? object.alpha : 0;
        }
        const hashedKeys = keys.sort().join("");
        if (!(hashedKeys in $2ff5c1ebf9ab478a$var$hashedModelKeys)) throw new Error("Unable to parse color from object: " + JSON.stringify(object));
        this.model = $2ff5c1ebf9ab478a$var$hashedModelKeys[hashedKeys];
        const { labels: labels } = $8ej7X[this.model];
        const color = [];
        for(i = 0; i < labels.length; i++)color.push(object[labels[i]]);
        this.color = $2ff5c1ebf9ab478a$var$zeroArray(color);
    }
    // Perform limitations (clamping, etc.)
    if ($2ff5c1ebf9ab478a$var$limiters[this.model]) {
        channels = $8ej7X[this.model].channels;
        for(i = 0; i < channels; i++){
            const limit = $2ff5c1ebf9ab478a$var$limiters[this.model][i];
            if (limit) this.color[i] = limit(this.color[i]);
        }
    }
    this.valpha = Math.max(0, Math.min(1, this.valpha));
    if (Object.freeze) Object.freeze(this);
}
$2ff5c1ebf9ab478a$var$Color.prototype = {
    toString () {
        return this.string();
    },
    toJSON () {
        return this[this.model]();
    },
    string (places) {
        let self = this.model in $aDJet.to ? this : this.rgb();
        self = self.round(typeof places === "number" ? places : 1);
        const args = self.valpha === 1 ? self.color : [
            ...self.color,
            this.valpha
        ];
        return $aDJet.to[self.model](args);
    },
    percentString (places) {
        const self = this.rgb().round(typeof places === "number" ? places : 1);
        const args = self.valpha === 1 ? self.color : [
            ...self.color,
            this.valpha
        ];
        return $aDJet.to.rgb.percent(args);
    },
    array () {
        return this.valpha === 1 ? [
            ...this.color
        ] : [
            ...this.color,
            this.valpha
        ];
    },
    object () {
        const result = {};
        const { channels: channels } = $8ej7X[this.model];
        const { labels: labels } = $8ej7X[this.model];
        for(let i = 0; i < channels; i++)result[labels[i]] = this.color[i];
        if (this.valpha !== 1) result.alpha = this.valpha;
        return result;
    },
    unitArray () {
        const rgb = this.rgb().color;
        rgb[0] /= 255;
        rgb[1] /= 255;
        rgb[2] /= 255;
        if (this.valpha !== 1) rgb.push(this.valpha);
        return rgb;
    },
    unitObject () {
        const rgb = this.rgb().object();
        rgb.r /= 255;
        rgb.g /= 255;
        rgb.b /= 255;
        if (this.valpha !== 1) rgb.alpha = this.valpha;
        return rgb;
    },
    round (places) {
        places = Math.max(places || 0, 0);
        return new $2ff5c1ebf9ab478a$var$Color([
            ...this.color.map($2ff5c1ebf9ab478a$var$roundToPlace(places)),
            this.valpha
        ], this.model);
    },
    alpha (value) {
        if (value !== undefined) return new $2ff5c1ebf9ab478a$var$Color([
            ...this.color,
            Math.max(0, Math.min(1, value))
        ], this.model);
        return this.valpha;
    },
    // Rgb
    red: $2ff5c1ebf9ab478a$var$getset("rgb", 0, $2ff5c1ebf9ab478a$var$maxfn(255)),
    green: $2ff5c1ebf9ab478a$var$getset("rgb", 1, $2ff5c1ebf9ab478a$var$maxfn(255)),
    blue: $2ff5c1ebf9ab478a$var$getset("rgb", 2, $2ff5c1ebf9ab478a$var$maxfn(255)),
    hue: $2ff5c1ebf9ab478a$var$getset([
        "hsl",
        "hsv",
        "hsl",
        "hwb",
        "hcg"
    ], 0, (value)=>(value % 360 + 360) % 360),
    saturationl: $2ff5c1ebf9ab478a$var$getset("hsl", 1, $2ff5c1ebf9ab478a$var$maxfn(100)),
    lightness: $2ff5c1ebf9ab478a$var$getset("hsl", 2, $2ff5c1ebf9ab478a$var$maxfn(100)),
    saturationv: $2ff5c1ebf9ab478a$var$getset("hsv", 1, $2ff5c1ebf9ab478a$var$maxfn(100)),
    value: $2ff5c1ebf9ab478a$var$getset("hsv", 2, $2ff5c1ebf9ab478a$var$maxfn(100)),
    chroma: $2ff5c1ebf9ab478a$var$getset("hcg", 1, $2ff5c1ebf9ab478a$var$maxfn(100)),
    gray: $2ff5c1ebf9ab478a$var$getset("hcg", 2, $2ff5c1ebf9ab478a$var$maxfn(100)),
    white: $2ff5c1ebf9ab478a$var$getset("hwb", 1, $2ff5c1ebf9ab478a$var$maxfn(100)),
    wblack: $2ff5c1ebf9ab478a$var$getset("hwb", 2, $2ff5c1ebf9ab478a$var$maxfn(100)),
    cyan: $2ff5c1ebf9ab478a$var$getset("cmyk", 0, $2ff5c1ebf9ab478a$var$maxfn(100)),
    magenta: $2ff5c1ebf9ab478a$var$getset("cmyk", 1, $2ff5c1ebf9ab478a$var$maxfn(100)),
    yellow: $2ff5c1ebf9ab478a$var$getset("cmyk", 2, $2ff5c1ebf9ab478a$var$maxfn(100)),
    black: $2ff5c1ebf9ab478a$var$getset("cmyk", 3, $2ff5c1ebf9ab478a$var$maxfn(100)),
    x: $2ff5c1ebf9ab478a$var$getset("xyz", 0, $2ff5c1ebf9ab478a$var$maxfn(95.047)),
    y: $2ff5c1ebf9ab478a$var$getset("xyz", 1, $2ff5c1ebf9ab478a$var$maxfn(100)),
    z: $2ff5c1ebf9ab478a$var$getset("xyz", 2, $2ff5c1ebf9ab478a$var$maxfn(108.833)),
    l: $2ff5c1ebf9ab478a$var$getset("lab", 0, $2ff5c1ebf9ab478a$var$maxfn(100)),
    a: $2ff5c1ebf9ab478a$var$getset("lab", 1),
    b: $2ff5c1ebf9ab478a$var$getset("lab", 2),
    keyword (value) {
        if (value !== undefined) return new $2ff5c1ebf9ab478a$var$Color(value);
        return $8ej7X[this.model].keyword(this.color);
    },
    hex (value) {
        if (value !== undefined) return new $2ff5c1ebf9ab478a$var$Color(value);
        return $aDJet.to.hex(this.rgb().round().color);
    },
    hexa (value) {
        if (value !== undefined) return new $2ff5c1ebf9ab478a$var$Color(value);
        const rgbArray = this.rgb().round().color;
        let alphaHex = Math.round(this.valpha * 255).toString(16).toUpperCase();
        if (alphaHex.length === 1) alphaHex = "0" + alphaHex;
        return $aDJet.to.hex(rgbArray) + alphaHex;
    },
    rgbNumber () {
        const rgb = this.rgb().color;
        return (rgb[0] & 0xFF) << 16 | (rgb[1] & 0xFF) << 8 | rgb[2] & 0xFF;
    },
    luminosity () {
        // http://www.w3.org/TR/WCAG20/#relativeluminancedef
        const rgb = this.rgb().color;
        const lum = [];
        for (const [i, element] of rgb.entries()){
            const chan = element / 255;
            lum[i] = chan <= 0.04045 ? chan / 12.92 : ((chan + 0.055) / 1.055) ** 2.4;
        }
        return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
    },
    contrast (color2) {
        // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
        const lum1 = this.luminosity();
        const lum2 = color2.luminosity();
        if (lum1 > lum2) return (lum1 + 0.05) / (lum2 + 0.05);
        return (lum2 + 0.05) / (lum1 + 0.05);
    },
    level (color2) {
        // https://www.w3.org/TR/WCAG/#contrast-enhanced
        const contrastRatio = this.contrast(color2);
        if (contrastRatio >= 7) return "AAA";
        return contrastRatio >= 4.5 ? "AA" : "";
    },
    isDark () {
        // YIQ equation from http://24ways.org/2010/calculating-color-contrast
        const rgb = this.rgb().color;
        const yiq = (rgb[0] * 2126 + rgb[1] * 7152 + rgb[2] * 722) / 10000;
        return yiq < 128;
    },
    isLight () {
        return !this.isDark();
    },
    negate () {
        const rgb = this.rgb();
        for(let i = 0; i < 3; i++)rgb.color[i] = 255 - rgb.color[i];
        return rgb;
    },
    lighten (ratio) {
        const hsl = this.hsl();
        hsl.color[2] += hsl.color[2] * ratio;
        return hsl;
    },
    darken (ratio) {
        const hsl = this.hsl();
        hsl.color[2] -= hsl.color[2] * ratio;
        return hsl;
    },
    saturate (ratio) {
        const hsl = this.hsl();
        hsl.color[1] += hsl.color[1] * ratio;
        return hsl;
    },
    desaturate (ratio) {
        const hsl = this.hsl();
        hsl.color[1] -= hsl.color[1] * ratio;
        return hsl;
    },
    whiten (ratio) {
        const hwb = this.hwb();
        hwb.color[1] += hwb.color[1] * ratio;
        return hwb;
    },
    blacken (ratio) {
        const hwb = this.hwb();
        hwb.color[2] += hwb.color[2] * ratio;
        return hwb;
    },
    grayscale () {
        // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
        const rgb = this.rgb().color;
        const value = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
        return $2ff5c1ebf9ab478a$var$Color.rgb(value, value, value);
    },
    fade (ratio) {
        return this.alpha(this.valpha - this.valpha * ratio);
    },
    opaquer (ratio) {
        return this.alpha(this.valpha + this.valpha * ratio);
    },
    rotate (degrees) {
        const hsl = this.hsl();
        let hue = hsl.color[0];
        hue = (hue + degrees) % 360;
        hue = hue < 0 ? 360 + hue : hue;
        hsl.color[0] = hue;
        return hsl;
    },
    mix (mixinColor, weight) {
        // Ported from sass implementation in C
        // https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
        if (!mixinColor || !mixinColor.rgb) throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof mixinColor);
        const color1 = mixinColor.rgb();
        const color2 = this.rgb();
        const p = weight === undefined ? 0.5 : weight;
        const w = 2 * p - 1;
        const a = color1.alpha() - color2.alpha();
        const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2;
        const w2 = 1 - w1;
        return $2ff5c1ebf9ab478a$var$Color.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue(), color1.alpha() * p + color2.alpha() * (1 - p));
    }
};
// Model conversion methods and static constructors
for (const model of Object.keys($8ej7X)){
    if ($2ff5c1ebf9ab478a$var$skippedModels.includes(model)) continue;
    const { channels: channels } = $8ej7X[model];
    // Conversion methods
    $2ff5c1ebf9ab478a$var$Color.prototype[model] = function(...args) {
        if (this.model === model) return new $2ff5c1ebf9ab478a$var$Color(this);
        if (args.length > 0) return new $2ff5c1ebf9ab478a$var$Color(args, model);
        return new $2ff5c1ebf9ab478a$var$Color([
            ...$2ff5c1ebf9ab478a$var$assertArray($8ej7X[this.model][model].raw(this.color)),
            this.valpha
        ], model);
    };
    // 'static' construction methods
    $2ff5c1ebf9ab478a$var$Color[model] = function(...args) {
        let color = args[0];
        if (typeof color === "number") color = $2ff5c1ebf9ab478a$var$zeroArray(args, channels);
        return new $2ff5c1ebf9ab478a$var$Color(color, model);
    };
}
function $2ff5c1ebf9ab478a$var$roundTo(number, places) {
    return Number(number.toFixed(places));
}
function $2ff5c1ebf9ab478a$var$roundToPlace(places) {
    return function(number) {
        return $2ff5c1ebf9ab478a$var$roundTo(number, places);
    };
}
function $2ff5c1ebf9ab478a$var$getset(model, channel, modifier) {
    model = Array.isArray(model) ? model : [
        model
    ];
    for (const m of model)($2ff5c1ebf9ab478a$var$limiters[m] || ($2ff5c1ebf9ab478a$var$limiters[m] = []))[channel] = modifier;
    model = model[0];
    return function(value) {
        let result;
        if (value !== undefined) {
            if (modifier) value = modifier(value);
            result = this[model]();
            result.color[channel] = value;
            return result;
        }
        result = this[model]().color[channel];
        if (modifier) result = modifier(result);
        return result;
    };
}
function $2ff5c1ebf9ab478a$var$maxfn(max) {
    return function(v) {
        return Math.max(0, Math.min(max, v));
    };
}
function $2ff5c1ebf9ab478a$var$assertArray(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
function $2ff5c1ebf9ab478a$var$zeroArray(array, length) {
    for(let i = 0; i < length; i++)if (typeof array[i] !== "number") array[i] = 0;
    return array;
}
module.exports = $2ff5c1ebf9ab478a$var$Color;

});
parcelRequire.register("aDJet", function(module, exports) {
/* MIT license */ 
var $kj0Dq = parcelRequire("kj0Dq");

var $fJm6V = parcelRequire("fJm6V");
var $7bf0a220ae128be5$var$hasOwnProperty = Object.hasOwnProperty;
var $7bf0a220ae128be5$var$reverseNames = Object.create(null);
// create a list of reverse color names
for(var $7bf0a220ae128be5$var$name in $kj0Dq)if ($7bf0a220ae128be5$var$hasOwnProperty.call($kj0Dq, $7bf0a220ae128be5$var$name)) $7bf0a220ae128be5$var$reverseNames[$kj0Dq[$7bf0a220ae128be5$var$name]] = $7bf0a220ae128be5$var$name;
var $7bf0a220ae128be5$var$cs = module.exports = {
    to: {},
    get: {}
};
$7bf0a220ae128be5$var$cs.get = function(string) {
    var prefix = string.substring(0, 3).toLowerCase();
    var val;
    var model;
    switch(prefix){
        case "hsl":
            val = $7bf0a220ae128be5$var$cs.get.hsl(string);
            model = "hsl";
            break;
        case "hwb":
            val = $7bf0a220ae128be5$var$cs.get.hwb(string);
            model = "hwb";
            break;
        default:
            val = $7bf0a220ae128be5$var$cs.get.rgb(string);
            model = "rgb";
            break;
    }
    if (!val) return null;
    return {
        model: model,
        value: val
    };
};
$7bf0a220ae128be5$var$cs.get.rgb = function(string) {
    if (!string) return null;
    var abbr = /^#([a-f0-9]{3,4})$/i;
    var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
    var rgba = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
    var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
    var keyword = /^(\w+)$/;
    var rgb = [
        0,
        0,
        0,
        1
    ];
    var match;
    var i;
    var hexAlpha;
    if (match = string.match(hex)) {
        hexAlpha = match[2];
        match = match[1];
        for(i = 0; i < 3; i++){
            // https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
            var i2 = i * 2;
            rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
        }
        if (hexAlpha) rgb[3] = parseInt(hexAlpha, 16) / 255;
    } else if (match = string.match(abbr)) {
        match = match[1];
        hexAlpha = match[3];
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i] + match[i], 16);
        if (hexAlpha) rgb[3] = parseInt(hexAlpha + hexAlpha, 16) / 255;
    } else if (match = string.match(rgba)) {
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i + 1], 0);
        if (match[4]) {
            if (match[5]) rgb[3] = parseFloat(match[4]) * 0.01;
            else rgb[3] = parseFloat(match[4]);
        }
    } else if (match = string.match(per)) {
        for(i = 0; i < 3; i++)rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
        if (match[4]) {
            if (match[5]) rgb[3] = parseFloat(match[4]) * 0.01;
            else rgb[3] = parseFloat(match[4]);
        }
    } else if (match = string.match(keyword)) {
        if (match[1] === "transparent") return [
            0,
            0,
            0,
            0
        ];
        if (!$7bf0a220ae128be5$var$hasOwnProperty.call($kj0Dq, match[1])) return null;
        rgb = $kj0Dq[match[1]];
        rgb[3] = 1;
        return rgb;
    } else return null;
    for(i = 0; i < 3; i++)rgb[i] = $7bf0a220ae128be5$var$clamp(rgb[i], 0, 255);
    rgb[3] = $7bf0a220ae128be5$var$clamp(rgb[3], 0, 1);
    return rgb;
};
$7bf0a220ae128be5$var$cs.get.hsl = function(string) {
    if (!string) return null;
    var hsl = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
    var match = string.match(hsl);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var s = $7bf0a220ae128be5$var$clamp(parseFloat(match[2]), 0, 100);
        var l = $7bf0a220ae128be5$var$clamp(parseFloat(match[3]), 0, 100);
        var a = $7bf0a220ae128be5$var$clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            s,
            l,
            a
        ];
    }
    return null;
};
$7bf0a220ae128be5$var$cs.get.hwb = function(string) {
    if (!string) return null;
    var hwb = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
    var match = string.match(hwb);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var w = $7bf0a220ae128be5$var$clamp(parseFloat(match[2]), 0, 100);
        var b = $7bf0a220ae128be5$var$clamp(parseFloat(match[3]), 0, 100);
        var a = $7bf0a220ae128be5$var$clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            w,
            b,
            a
        ];
    }
    return null;
};
$7bf0a220ae128be5$var$cs.to.hex = function() {
    var rgba = $fJm6V(arguments);
    return "#" + $7bf0a220ae128be5$var$hexDouble(rgba[0]) + $7bf0a220ae128be5$var$hexDouble(rgba[1]) + $7bf0a220ae128be5$var$hexDouble(rgba[2]) + (rgba[3] < 1 ? $7bf0a220ae128be5$var$hexDouble(Math.round(rgba[3] * 255)) : "");
};
$7bf0a220ae128be5$var$cs.to.rgb = function() {
    var rgba = $fJm6V(arguments);
    return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ")" : "rgba(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ", " + rgba[3] + ")";
};
$7bf0a220ae128be5$var$cs.to.rgb.percent = function() {
    var rgba = $fJm6V(arguments);
    var r = Math.round(rgba[0] / 255 * 100);
    var g = Math.round(rgba[1] / 255 * 100);
    var b = Math.round(rgba[2] / 255 * 100);
    return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + r + "%, " + g + "%, " + b + "%)" : "rgba(" + r + "%, " + g + "%, " + b + "%, " + rgba[3] + ")";
};
$7bf0a220ae128be5$var$cs.to.hsl = function() {
    var hsla = $fJm6V(arguments);
    return hsla.length < 4 || hsla[3] === 1 ? "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)" : "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + hsla[3] + ")";
};
// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
$7bf0a220ae128be5$var$cs.to.hwb = function() {
    var hwba = $fJm6V(arguments);
    var a = "";
    if (hwba.length >= 4 && hwba[3] !== 1) a = ", " + hwba[3];
    return "hwb(" + hwba[0] + ", " + hwba[1] + "%, " + hwba[2] + "%" + a + ")";
};
$7bf0a220ae128be5$var$cs.to.keyword = function(rgb) {
    return $7bf0a220ae128be5$var$reverseNames[rgb.slice(0, 3)];
};
// helpers
function $7bf0a220ae128be5$var$clamp(num, min, max) {
    return Math.min(Math.max(min, num), max);
}
function $7bf0a220ae128be5$var$hexDouble(num) {
    var str = Math.round(num).toString(16).toUpperCase();
    return str.length < 2 ? "0" + str : str;
}

});
parcelRequire.register("kj0Dq", function(module, exports) {
"use strict";
module.exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};

});

parcelRequire.register("fJm6V", function(module, exports) {
"use strict";

var $9dipd = parcelRequire("9dipd");
var $b73c35aeff7b755c$var$concat = Array.prototype.concat;
var $b73c35aeff7b755c$var$slice = Array.prototype.slice;
var $b73c35aeff7b755c$var$swizzle = module.exports = function swizzle(args) {
    var results = [];
    for(var i = 0, len = args.length; i < len; i++){
        var arg = args[i];
        if ($9dipd(arg)) // http://jsperf.com/javascript-array-concat-vs-push/98
        results = $b73c35aeff7b755c$var$concat.call(results, $b73c35aeff7b755c$var$slice.call(arg));
        else results.push(arg);
    }
    return results;
};
$b73c35aeff7b755c$var$swizzle.wrap = function(fn) {
    return function() {
        return fn($b73c35aeff7b755c$var$swizzle(arguments));
    };
};

});
parcelRequire.register("9dipd", function(module, exports) {
module.exports = function isArrayish(obj) {
    if (!obj || typeof obj === "string") return false;
    return obj instanceof Array || Array.isArray(obj) || obj.length >= 0 && (obj.splice instanceof Function || Object.getOwnPropertyDescriptor(obj, obj.length - 1) && obj.constructor.name !== "String");
};

});



parcelRequire.register("8ej7X", function(module, exports) {

var $bR3e7 = parcelRequire("bR3e7");

var $h8g08 = parcelRequire("h8g08");
const $5fde77d5d3b893b4$var$convert = {};
const $5fde77d5d3b893b4$var$models = Object.keys($bR3e7);
function $5fde77d5d3b893b4$var$wrapRaw(fn) {
    const wrappedFn = function(...args) {
        const arg0 = args[0];
        if (arg0 === undefined || arg0 === null) return arg0;
        if (arg0.length > 1) args = arg0;
        return fn(args);
    };
    // Preserve .conversion property if there is one
    if ("conversion" in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
function $5fde77d5d3b893b4$var$wrapRounded(fn) {
    const wrappedFn = function(...args) {
        const arg0 = args[0];
        if (arg0 === undefined || arg0 === null) return arg0;
        if (arg0.length > 1) args = arg0;
        const result = fn(args);
        // We're assuming the result is an array here.
        // see notice in conversions.js; don't use box types
        // in conversion functions.
        if (typeof result === "object") for(let len = result.length, i = 0; i < len; i++)result[i] = Math.round(result[i]);
        return result;
    };
    // Preserve .conversion property if there is one
    if ("conversion" in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
$5fde77d5d3b893b4$var$models.forEach((fromModel)=>{
    $5fde77d5d3b893b4$var$convert[fromModel] = {};
    Object.defineProperty($5fde77d5d3b893b4$var$convert[fromModel], "channels", {
        value: $bR3e7[fromModel].channels
    });
    Object.defineProperty($5fde77d5d3b893b4$var$convert[fromModel], "labels", {
        value: $bR3e7[fromModel].labels
    });
    const routes = $h8g08(fromModel);
    const routeModels = Object.keys(routes);
    routeModels.forEach((toModel)=>{
        const fn = routes[toModel];
        $5fde77d5d3b893b4$var$convert[fromModel][toModel] = $5fde77d5d3b893b4$var$wrapRounded(fn);
        $5fde77d5d3b893b4$var$convert[fromModel][toModel].raw = $5fde77d5d3b893b4$var$wrapRaw(fn);
    });
});
module.exports = $5fde77d5d3b893b4$var$convert;

});
parcelRequire.register("bR3e7", function(module, exports) {
/* MIT license */ /* eslint-disable no-mixed-operators */ 
var $kj0Dq = parcelRequire("kj0Dq");
// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)
const $8a1725baf7d26837$var$reverseKeywords = {};
for (const key of Object.keys($kj0Dq))$8a1725baf7d26837$var$reverseKeywords[$kj0Dq[key]] = key;
const $8a1725baf7d26837$var$convert = {
    rgb: {
        channels: 3,
        labels: "rgb"
    },
    hsl: {
        channels: 3,
        labels: "hsl"
    },
    hsv: {
        channels: 3,
        labels: "hsv"
    },
    hwb: {
        channels: 3,
        labels: "hwb"
    },
    cmyk: {
        channels: 4,
        labels: "cmyk"
    },
    xyz: {
        channels: 3,
        labels: "xyz"
    },
    lab: {
        channels: 3,
        labels: "lab"
    },
    lch: {
        channels: 3,
        labels: "lch"
    },
    hex: {
        channels: 1,
        labels: [
            "hex"
        ]
    },
    keyword: {
        channels: 1,
        labels: [
            "keyword"
        ]
    },
    ansi16: {
        channels: 1,
        labels: [
            "ansi16"
        ]
    },
    ansi256: {
        channels: 1,
        labels: [
            "ansi256"
        ]
    },
    hcg: {
        channels: 3,
        labels: [
            "h",
            "c",
            "g"
        ]
    },
    apple: {
        channels: 3,
        labels: [
            "r16",
            "g16",
            "b16"
        ]
    },
    gray: {
        channels: 1,
        labels: [
            "gray"
        ]
    }
};
module.exports = $8a1725baf7d26837$var$convert;
// Hide .channels and .labels properties
for (const model of Object.keys($8a1725baf7d26837$var$convert)){
    if (!("channels" in $8a1725baf7d26837$var$convert[model])) throw new Error("missing channels property: " + model);
    if (!("labels" in $8a1725baf7d26837$var$convert[model])) throw new Error("missing channel labels property: " + model);
    if ($8a1725baf7d26837$var$convert[model].labels.length !== $8a1725baf7d26837$var$convert[model].channels) throw new Error("channel and label counts mismatch: " + model);
    const { channels: channels, labels: labels } = $8a1725baf7d26837$var$convert[model];
    delete $8a1725baf7d26837$var$convert[model].channels;
    delete $8a1725baf7d26837$var$convert[model].labels;
    Object.defineProperty($8a1725baf7d26837$var$convert[model], "channels", {
        value: channels
    });
    Object.defineProperty($8a1725baf7d26837$var$convert[model], "labels", {
        value: labels
    });
}
$8a1725baf7d26837$var$convert.rgb.hsl = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const min = Math.min(r, g, b);
    const max = Math.max(r, g, b);
    const delta = max - min;
    let h;
    let s;
    if (max === min) h = 0;
    else if (r === max) h = (g - b) / delta;
    else if (g === max) h = 2 + (b - r) / delta;
    else if (b === max) h = 4 + (r - g) / delta;
    h = Math.min(h * 60, 360);
    if (h < 0) h += 360;
    const l = (min + max) / 2;
    if (max === min) s = 0;
    else if (l <= 0.5) s = delta / (max + min);
    else s = delta / (2 - max - min);
    return [
        h,
        s * 100,
        l * 100
    ];
};
$8a1725baf7d26837$var$convert.rgb.hsv = function(rgb) {
    let rdif;
    let gdif;
    let bdif;
    let h;
    let s;
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const v = Math.max(r, g, b);
    const diff = v - Math.min(r, g, b);
    const diffc = function(c) {
        return (v - c) / 6 / diff + 0.5;
    };
    if (diff === 0) {
        h = 0;
        s = 0;
    } else {
        s = diff / v;
        rdif = diffc(r);
        gdif = diffc(g);
        bdif = diffc(b);
        if (r === v) h = bdif - gdif;
        else if (g === v) h = 1 / 3 + rdif - bdif;
        else if (b === v) h = 2 / 3 + gdif - rdif;
        if (h < 0) h += 1;
        else if (h > 1) h -= 1;
    }
    return [
        h * 360,
        s * 100,
        v * 100
    ];
};
$8a1725baf7d26837$var$convert.rgb.hwb = function(rgb) {
    const r = rgb[0];
    const g = rgb[1];
    let b = rgb[2];
    const h = $8a1725baf7d26837$var$convert.rgb.hsl(rgb)[0];
    const w = 1 / 255 * Math.min(r, Math.min(g, b));
    b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
    return [
        h,
        w * 100,
        b * 100
    ];
};
$8a1725baf7d26837$var$convert.rgb.cmyk = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const k = Math.min(1 - r, 1 - g, 1 - b);
    const c = (1 - r - k) / (1 - k) || 0;
    const m = (1 - g - k) / (1 - k) || 0;
    const y = (1 - b - k) / (1 - k) || 0;
    return [
        c * 100,
        m * 100,
        y * 100,
        k * 100
    ];
};
function $8a1725baf7d26837$var$comparativeDistance(x, y) {
    /*
		See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	*/ return (x[0] - y[0]) ** 2 + (x[1] - y[1]) ** 2 + (x[2] - y[2]) ** 2;
}
$8a1725baf7d26837$var$convert.rgb.keyword = function(rgb) {
    const reversed = $8a1725baf7d26837$var$reverseKeywords[rgb];
    if (reversed) return reversed;
    let currentClosestDistance = Infinity;
    let currentClosestKeyword;
    for (const keyword of Object.keys($kj0Dq)){
        const value = $kj0Dq[keyword];
        // Compute comparative distance
        const distance = $8a1725baf7d26837$var$comparativeDistance(rgb, value);
        // Check if its less, if so set as closest
        if (distance < currentClosestDistance) {
            currentClosestDistance = distance;
            currentClosestKeyword = keyword;
        }
    }
    return currentClosestKeyword;
};
$8a1725baf7d26837$var$convert.keyword.rgb = function(keyword) {
    return $kj0Dq[keyword];
};
$8a1725baf7d26837$var$convert.rgb.xyz = function(rgb) {
    let r = rgb[0] / 255;
    let g = rgb[1] / 255;
    let b = rgb[2] / 255;
    // Assume sRGB
    r = r > 0.04045 ? ((r + 0.055) / 1.055) ** 2.4 : r / 12.92;
    g = g > 0.04045 ? ((g + 0.055) / 1.055) ** 2.4 : g / 12.92;
    b = b > 0.04045 ? ((b + 0.055) / 1.055) ** 2.4 : b / 12.92;
    const x = r * 0.4124 + g * 0.3576 + b * 0.1805;
    const y = r * 0.2126 + g * 0.7152 + b * 0.0722;
    const z = r * 0.0193 + g * 0.1192 + b * 0.9505;
    return [
        x * 100,
        y * 100,
        z * 100
    ];
};
$8a1725baf7d26837$var$convert.rgb.lab = function(rgb) {
    const xyz = $8a1725baf7d26837$var$convert.rgb.xyz(rgb);
    let x = xyz[0];
    let y = xyz[1];
    let z = xyz[2];
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? x ** (1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? y ** (1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? z ** (1 / 3) : 7.787 * z + 16 / 116;
    const l = 116 * y - 16;
    const a = 500 * (x - y);
    const b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$8a1725baf7d26837$var$convert.hsl.rgb = function(hsl) {
    const h = hsl[0] / 360;
    const s = hsl[1] / 100;
    const l = hsl[2] / 100;
    let t2;
    let t3;
    let val;
    if (s === 0) {
        val = l * 255;
        return [
            val,
            val,
            val
        ];
    }
    if (l < 0.5) t2 = l * (1 + s);
    else t2 = l + s - l * s;
    const t1 = 2 * l - t2;
    const rgb = [
        0,
        0,
        0
    ];
    for(let i = 0; i < 3; i++){
        t3 = h + 1 / 3 * -(i - 1);
        if (t3 < 0) t3++;
        if (t3 > 1) t3--;
        if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
        else if (2 * t3 < 1) val = t2;
        else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
        else val = t1;
        rgb[i] = val * 255;
    }
    return rgb;
};
$8a1725baf7d26837$var$convert.hsl.hsv = function(hsl) {
    const h = hsl[0];
    let s = hsl[1] / 100;
    let l = hsl[2] / 100;
    let smin = s;
    const lmin = Math.max(l, 0.01);
    l *= 2;
    s *= l <= 1 ? l : 2 - l;
    smin *= lmin <= 1 ? lmin : 2 - lmin;
    const v = (l + s) / 2;
    const sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
    return [
        h,
        sv * 100,
        v * 100
    ];
};
$8a1725baf7d26837$var$convert.hsv.rgb = function(hsv) {
    const h = hsv[0] / 60;
    const s = hsv[1] / 100;
    let v = hsv[2] / 100;
    const hi = Math.floor(h) % 6;
    const f = h - Math.floor(h);
    const p = 255 * v * (1 - s);
    const q = 255 * v * (1 - s * f);
    const t = 255 * v * (1 - s * (1 - f));
    v *= 255;
    switch(hi){
        case 0:
            return [
                v,
                t,
                p
            ];
        case 1:
            return [
                q,
                v,
                p
            ];
        case 2:
            return [
                p,
                v,
                t
            ];
        case 3:
            return [
                p,
                q,
                v
            ];
        case 4:
            return [
                t,
                p,
                v
            ];
        case 5:
            return [
                v,
                p,
                q
            ];
    }
};
$8a1725baf7d26837$var$convert.hsv.hsl = function(hsv) {
    const h = hsv[0];
    const s = hsv[1] / 100;
    const v = hsv[2] / 100;
    const vmin = Math.max(v, 0.01);
    let sl;
    let l;
    l = (2 - s) * v;
    const lmin = (2 - s) * vmin;
    sl = s * vmin;
    sl /= lmin <= 1 ? lmin : 2 - lmin;
    sl = sl || 0;
    l /= 2;
    return [
        h,
        sl * 100,
        l * 100
    ];
};
// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
$8a1725baf7d26837$var$convert.hwb.rgb = function(hwb) {
    const h = hwb[0] / 360;
    let wh = hwb[1] / 100;
    let bl = hwb[2] / 100;
    const ratio = wh + bl;
    let f;
    // Wh + bl cant be > 1
    if (ratio > 1) {
        wh /= ratio;
        bl /= ratio;
    }
    const i = Math.floor(6 * h);
    const v = 1 - bl;
    f = 6 * h - i;
    if ((i & 0x01) !== 0) f = 1 - f;
    const n = wh + f * (v - wh); // Linear interpolation
    let r;
    let g;
    let b;
    /* eslint-disable max-statements-per-line,no-multi-spaces */ switch(i){
        default:
        case 6:
        case 0:
            r = v;
            g = n;
            b = wh;
            break;
        case 1:
            r = n;
            g = v;
            b = wh;
            break;
        case 2:
            r = wh;
            g = v;
            b = n;
            break;
        case 3:
            r = wh;
            g = n;
            b = v;
            break;
        case 4:
            r = n;
            g = wh;
            b = v;
            break;
        case 5:
            r = v;
            g = wh;
            b = n;
            break;
    }
    /* eslint-enable max-statements-per-line,no-multi-spaces */ return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$8a1725baf7d26837$var$convert.cmyk.rgb = function(cmyk) {
    const c = cmyk[0] / 100;
    const m = cmyk[1] / 100;
    const y = cmyk[2] / 100;
    const k = cmyk[3] / 100;
    const r = 1 - Math.min(1, c * (1 - k) + k);
    const g = 1 - Math.min(1, m * (1 - k) + k);
    const b = 1 - Math.min(1, y * (1 - k) + k);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$8a1725baf7d26837$var$convert.xyz.rgb = function(xyz) {
    const x = xyz[0] / 100;
    const y = xyz[1] / 100;
    const z = xyz[2] / 100;
    let r;
    let g;
    let b;
    r = x * 3.2406 + y * -1.5372 + z * -0.4986;
    g = x * -0.9689 + y * 1.8758 + z * 0.0415;
    b = x * 0.0557 + y * -0.204 + z * 1.0570;
    // Assume sRGB
    r = r > 0.0031308 ? 1.055 * r ** (1.0 / 2.4) - 0.055 : r * 12.92;
    g = g > 0.0031308 ? 1.055 * g ** (1.0 / 2.4) - 0.055 : g * 12.92;
    b = b > 0.0031308 ? 1.055 * b ** (1.0 / 2.4) - 0.055 : b * 12.92;
    r = Math.min(Math.max(0, r), 1);
    g = Math.min(Math.max(0, g), 1);
    b = Math.min(Math.max(0, b), 1);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$8a1725baf7d26837$var$convert.xyz.lab = function(xyz) {
    let x = xyz[0];
    let y = xyz[1];
    let z = xyz[2];
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? x ** (1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? y ** (1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? z ** (1 / 3) : 7.787 * z + 16 / 116;
    const l = 116 * y - 16;
    const a = 500 * (x - y);
    const b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$8a1725baf7d26837$var$convert.lab.xyz = function(lab) {
    const l = lab[0];
    const a = lab[1];
    const b = lab[2];
    let x;
    let y;
    let z;
    y = (l + 16) / 116;
    x = a / 500 + y;
    z = y - b / 200;
    const y2 = y ** 3;
    const x2 = x ** 3;
    const z2 = z ** 3;
    y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
    x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
    z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
    x *= 95.047;
    y *= 100;
    z *= 108.883;
    return [
        x,
        y,
        z
    ];
};
$8a1725baf7d26837$var$convert.lab.lch = function(lab) {
    const l = lab[0];
    const a = lab[1];
    const b = lab[2];
    let h;
    const hr = Math.atan2(b, a);
    h = hr * 360 / 2 / Math.PI;
    if (h < 0) h += 360;
    const c = Math.sqrt(a * a + b * b);
    return [
        l,
        c,
        h
    ];
};
$8a1725baf7d26837$var$convert.lch.lab = function(lch) {
    const l = lch[0];
    const c = lch[1];
    const h = lch[2];
    const hr = h / 360 * 2 * Math.PI;
    const a = c * Math.cos(hr);
    const b = c * Math.sin(hr);
    return [
        l,
        a,
        b
    ];
};
$8a1725baf7d26837$var$convert.rgb.ansi16 = function(args, saturation = null) {
    const [r, g, b] = args;
    let value = saturation === null ? $8a1725baf7d26837$var$convert.rgb.hsv(args)[2] : saturation; // Hsv -> ansi16 optimization
    value = Math.round(value / 50);
    if (value === 0) return 30;
    let ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
    if (value === 2) ansi += 60;
    return ansi;
};
$8a1725baf7d26837$var$convert.hsv.ansi16 = function(args) {
    // Optimization here; we already know the value and don't need to get
    // it converted for us.
    return $8a1725baf7d26837$var$convert.rgb.ansi16($8a1725baf7d26837$var$convert.hsv.rgb(args), args[2]);
};
$8a1725baf7d26837$var$convert.rgb.ansi256 = function(args) {
    const r = args[0];
    const g = args[1];
    const b = args[2];
    // We use the extended greyscale palette here, with the exception of
    // black and white. normal palette only has 4 greyscale shades.
    if (r === g && g === b) {
        if (r < 8) return 16;
        if (r > 248) return 231;
        return Math.round((r - 8) / 247 * 24) + 232;
    }
    const ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
    return ansi;
};
$8a1725baf7d26837$var$convert.ansi16.rgb = function(args) {
    let color = args % 10;
    // Handle greyscale
    if (color === 0 || color === 7) {
        if (args > 50) color += 3.5;
        color = color / 10.5 * 255;
        return [
            color,
            color,
            color
        ];
    }
    const mult = (~~(args > 50) + 1) * 0.5;
    const r = (color & 1) * mult * 255;
    const g = (color >> 1 & 1) * mult * 255;
    const b = (color >> 2 & 1) * mult * 255;
    return [
        r,
        g,
        b
    ];
};
$8a1725baf7d26837$var$convert.ansi256.rgb = function(args) {
    // Handle greyscale
    if (args >= 232) {
        const c = (args - 232) * 10 + 8;
        return [
            c,
            c,
            c
        ];
    }
    args -= 16;
    let rem;
    const r = Math.floor(args / 36) / 5 * 255;
    const g = Math.floor((rem = args % 36) / 6) / 5 * 255;
    const b = rem % 6 / 5 * 255;
    return [
        r,
        g,
        b
    ];
};
$8a1725baf7d26837$var$convert.rgb.hex = function(args) {
    const integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
    const string = integer.toString(16).toUpperCase();
    return "000000".substring(string.length) + string;
};
$8a1725baf7d26837$var$convert.hex.rgb = function(args) {
    const match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!match) return [
        0,
        0,
        0
    ];
    let colorString = match[0];
    if (match[0].length === 3) colorString = colorString.split("").map((char)=>{
        return char + char;
    }).join("");
    const integer = parseInt(colorString, 16);
    const r = integer >> 16 & 0xFF;
    const g = integer >> 8 & 0xFF;
    const b = integer & 0xFF;
    return [
        r,
        g,
        b
    ];
};
$8a1725baf7d26837$var$convert.rgb.hcg = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const max = Math.max(Math.max(r, g), b);
    const min = Math.min(Math.min(r, g), b);
    const chroma = max - min;
    let grayscale;
    let hue;
    if (chroma < 1) grayscale = min / (1 - chroma);
    else grayscale = 0;
    if (chroma <= 0) hue = 0;
    else if (max === r) hue = (g - b) / chroma % 6;
    else if (max === g) hue = 2 + (b - r) / chroma;
    else hue = 4 + (r - g) / chroma;
    hue /= 6;
    hue %= 1;
    return [
        hue * 360,
        chroma * 100,
        grayscale * 100
    ];
};
$8a1725baf7d26837$var$convert.hsl.hcg = function(hsl) {
    const s = hsl[1] / 100;
    const l = hsl[2] / 100;
    const c = l < 0.5 ? 2.0 * s * l : 2.0 * s * (1.0 - l);
    let f = 0;
    if (c < 1.0) f = (l - 0.5 * c) / (1.0 - c);
    return [
        hsl[0],
        c * 100,
        f * 100
    ];
};
$8a1725baf7d26837$var$convert.hsv.hcg = function(hsv) {
    const s = hsv[1] / 100;
    const v = hsv[2] / 100;
    const c = s * v;
    let f = 0;
    if (c < 1.0) f = (v - c) / (1 - c);
    return [
        hsv[0],
        c * 100,
        f * 100
    ];
};
$8a1725baf7d26837$var$convert.hcg.rgb = function(hcg) {
    const h = hcg[0] / 360;
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    if (c === 0.0) return [
        g * 255,
        g * 255,
        g * 255
    ];
    const pure = [
        0,
        0,
        0
    ];
    const hi = h % 1 * 6;
    const v = hi % 1;
    const w = 1 - v;
    let mg = 0;
    /* eslint-disable max-statements-per-line */ switch(Math.floor(hi)){
        case 0:
            pure[0] = 1;
            pure[1] = v;
            pure[2] = 0;
            break;
        case 1:
            pure[0] = w;
            pure[1] = 1;
            pure[2] = 0;
            break;
        case 2:
            pure[0] = 0;
            pure[1] = 1;
            pure[2] = v;
            break;
        case 3:
            pure[0] = 0;
            pure[1] = w;
            pure[2] = 1;
            break;
        case 4:
            pure[0] = v;
            pure[1] = 0;
            pure[2] = 1;
            break;
        default:
            pure[0] = 1;
            pure[1] = 0;
            pure[2] = w;
    }
    /* eslint-enable max-statements-per-line */ mg = (1.0 - c) * g;
    return [
        (c * pure[0] + mg) * 255,
        (c * pure[1] + mg) * 255,
        (c * pure[2] + mg) * 255
    ];
};
$8a1725baf7d26837$var$convert.hcg.hsv = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const v = c + g * (1.0 - c);
    let f = 0;
    if (v > 0.0) f = c / v;
    return [
        hcg[0],
        f * 100,
        v * 100
    ];
};
$8a1725baf7d26837$var$convert.hcg.hsl = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const l = g * (1.0 - c) + 0.5 * c;
    let s = 0;
    if (l > 0.0 && l < 0.5) s = c / (2 * l);
    else if (l >= 0.5 && l < 1.0) s = c / (2 * (1 - l));
    return [
        hcg[0],
        s * 100,
        l * 100
    ];
};
$8a1725baf7d26837$var$convert.hcg.hwb = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const v = c + g * (1.0 - c);
    return [
        hcg[0],
        (v - c) * 100,
        (1 - v) * 100
    ];
};
$8a1725baf7d26837$var$convert.hwb.hcg = function(hwb) {
    const w = hwb[1] / 100;
    const b = hwb[2] / 100;
    const v = 1 - b;
    const c = v - w;
    let g = 0;
    if (c < 1) g = (v - c) / (1 - c);
    return [
        hwb[0],
        c * 100,
        g * 100
    ];
};
$8a1725baf7d26837$var$convert.apple.rgb = function(apple) {
    return [
        apple[0] / 65535 * 255,
        apple[1] / 65535 * 255,
        apple[2] / 65535 * 255
    ];
};
$8a1725baf7d26837$var$convert.rgb.apple = function(rgb) {
    return [
        rgb[0] / 255 * 65535,
        rgb[1] / 255 * 65535,
        rgb[2] / 255 * 65535
    ];
};
$8a1725baf7d26837$var$convert.gray.rgb = function(args) {
    return [
        args[0] / 100 * 255,
        args[0] / 100 * 255,
        args[0] / 100 * 255
    ];
};
$8a1725baf7d26837$var$convert.gray.hsl = function(args) {
    return [
        0,
        0,
        args[0]
    ];
};
$8a1725baf7d26837$var$convert.gray.hsv = $8a1725baf7d26837$var$convert.gray.hsl;
$8a1725baf7d26837$var$convert.gray.hwb = function(gray) {
    return [
        0,
        100,
        gray[0]
    ];
};
$8a1725baf7d26837$var$convert.gray.cmyk = function(gray) {
    return [
        0,
        0,
        0,
        gray[0]
    ];
};
$8a1725baf7d26837$var$convert.gray.lab = function(gray) {
    return [
        gray[0],
        0,
        0
    ];
};
$8a1725baf7d26837$var$convert.gray.hex = function(gray) {
    const val = Math.round(gray[0] / 100 * 255) & 0xFF;
    const integer = (val << 16) + (val << 8) + val;
    const string = integer.toString(16).toUpperCase();
    return "000000".substring(string.length) + string;
};
$8a1725baf7d26837$var$convert.rgb.gray = function(rgb) {
    const val = (rgb[0] + rgb[1] + rgb[2]) / 3;
    return [
        val / 255 * 100
    ];
};

});

parcelRequire.register("h8g08", function(module, exports) {

var $bR3e7 = parcelRequire("bR3e7");
/*
	This function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/ function $c78f988a08088058$var$buildGraph() {
    const graph = {};
    // https://jsperf.com/object-keys-vs-for-in-with-closure/3
    const models = Object.keys($bR3e7);
    for(let len = models.length, i = 0; i < len; i++)graph[models[i]] = {
        // http://jsperf.com/1-vs-infinity
        // micro-opt, but this is simple.
        distance: -1,
        parent: null
    };
    return graph;
}
// https://en.wikipedia.org/wiki/Breadth-first_search
function $c78f988a08088058$var$deriveBFS(fromModel) {
    const graph = $c78f988a08088058$var$buildGraph();
    const queue = [
        fromModel
    ]; // Unshift -> queue -> pop
    graph[fromModel].distance = 0;
    while(queue.length){
        const current = queue.pop();
        const adjacents = Object.keys($bR3e7[current]);
        for(let len = adjacents.length, i = 0; i < len; i++){
            const adjacent = adjacents[i];
            const node = graph[adjacent];
            if (node.distance === -1) {
                node.distance = graph[current].distance + 1;
                node.parent = current;
                queue.unshift(adjacent);
            }
        }
    }
    return graph;
}
function $c78f988a08088058$var$link(from, to) {
    return function(args) {
        return to(from(args));
    };
}
function $c78f988a08088058$var$wrapConversion(toModel, graph) {
    const path = [
        graph[toModel].parent,
        toModel
    ];
    let fn = $bR3e7[graph[toModel].parent][toModel];
    let cur = graph[toModel].parent;
    while(graph[cur].parent){
        path.unshift(graph[cur].parent);
        fn = $c78f988a08088058$var$link($bR3e7[graph[cur].parent][cur], fn);
        cur = graph[cur].parent;
    }
    fn.conversion = path;
    return fn;
}
module.exports = function(fromModel) {
    const graph = $c78f988a08088058$var$deriveBFS(fromModel);
    const conversion = {};
    const models = Object.keys(graph);
    for(let len = models.length, i = 0; i < len; i++){
        const toModel = models[i];
        const node = graph[toModel];
        if (node.parent === null) continue;
        conversion[toModel] = $c78f988a08088058$var$wrapConversion(toModel, graph);
    }
    return conversion;
};

});




parcelRequire.register("b4hyY", function(module, exports) {

$parcel$export(module.exports, "isValidRegEx", function () { return $80edb116ef5bb75d$export$6561ab227a8e4a2; });
const $80edb116ef5bb75d$export$6561ab227a8e4a2 = (regEx)=>{
    try {
        return Boolean(regEx && new RegExp(regEx));
    } catch  {
        return false;
    }
};

});

parcelRequire.register("5rMXH", function(module, exports) {

$parcel$export(module.exports, "validateRedirectUrl", function () { return $3f75742a7b328761$export$eabdc444ee87166e; });
$parcel$export(module.exports, "validateUriOrigin", function () { return $3f75742a7b328761$export$6ac9a0b3ab4a632f; });
$parcel$export(module.exports, "isValidUrl", function () { return $3f75742a7b328761$export$bef94a5618bf18bf; });
$parcel$export(module.exports, "isLocalhost", function () { return $3f75742a7b328761$export$ec8a6426516240fc; });

var $9vrm1 = parcelRequire("9vrm1");
const $3f75742a7b328761$export$eabdc444ee87166e = (url, type)=>{
    try {
        const { protocol: protocol } = new URL(url);
        const protocolRegEx = type === "mobile" ? (0, $9vrm1.mobileUriSchemeProtocolRegEx) : (0, $9vrm1.webRedirectUriProtocolRegEx);
        return protocolRegEx.test(protocol);
    } catch  {
        return false;
    }
};
const $3f75742a7b328761$export$6ac9a0b3ab4a632f = (url)=>{
    try {
        return new URL(url).origin === url;
    } catch  {
        return false;
    }
};
const $3f75742a7b328761$export$bef94a5618bf18bf = (url)=>{
    try {
        return Boolean(url && new URL(url));
    } catch  {
        return false;
    }
};
const $3f75742a7b328761$export$ec8a6426516240fc = (url)=>{
    const parsedUrl = new URL(url);
    return [
        "localhost",
        "127.0.0.1",
        "::1"
    ].includes(parsedUrl.hostname);
};

});
parcelRequire.register("9vrm1", function(module, exports) {

$parcel$export(module.exports, "emailRegEx", function () { return $6ebc3a4943d35313$export$bdb23a0789f9885e; });
$parcel$export(module.exports, "phoneRegEx", function () { return $6ebc3a4943d35313$export$205be3a4a78028e; });
$parcel$export(module.exports, "phoneInputRegEx", function () { return $6ebc3a4943d35313$export$3b90d915073188c; });
$parcel$export(module.exports, "usernameRegEx", function () { return $6ebc3a4943d35313$export$221be9ce6b96eec3; });
$parcel$export(module.exports, "webRedirectUriProtocolRegEx", function () { return $6ebc3a4943d35313$export$faa873956c7a1484; });
$parcel$export(module.exports, "mobileUriSchemeProtocolRegEx", function () { return $6ebc3a4943d35313$export$cda568c01bd42f00; });
$parcel$export(module.exports, "hexColorRegEx", function () { return $6ebc3a4943d35313$export$ad64c5d64b2f359b; });
$parcel$export(module.exports, "noSpaceRegEx", function () { return $6ebc3a4943d35313$export$14b44af55c20c1e5; });
$parcel$export(module.exports, "domainRegEx", function () { return $6ebc3a4943d35313$export$d9e81dda45f84c36; });
const $6ebc3a4943d35313$export$bdb23a0789f9885e = /^\S+@\S+\.\S+$/;
const $6ebc3a4943d35313$export$205be3a4a78028e = /^\d+$/;
const $6ebc3a4943d35313$export$3b90d915073188c = /^\+?[\d-( )]+$/;
const $6ebc3a4943d35313$export$221be9ce6b96eec3 = /^[A-Z_a-z]\w*$/;
const $6ebc3a4943d35313$export$faa873956c7a1484 = /^https?:$/;
const $6ebc3a4943d35313$export$cda568c01bd42f00 = /^[a-z][\d+_a-z-]*(\.[\d+_a-z-]+)+:$/;
const $6ebc3a4943d35313$export$ad64c5d64b2f359b = /^#[\da-f]{3}([\da-f]{3})?$/i;
const $6ebc3a4943d35313$export$2586bfd81a855904 = /^\d{4}(-\d{2}){2}/;
const $6ebc3a4943d35313$export$14b44af55c20c1e5 = /^\S+$/;
const $6ebc3a4943d35313$export$d9e81dda45f84c36 = /^[\dA-Za-z](?:[\dA-Za-z-]*[\dA-Za-z])?(?:\.[\dA-Za-z](?:[\dA-Za-z-]*[\dA-Za-z])?){2,}$/;

});



parcelRequire.register("hyigV", function(module, exports) {

$parcel$export(module.exports, "UserScope", function () { return $cc73c912ef4aaf57$export$4b02c5b431f6eb78; });
$parcel$export(module.exports, "organizationUrnPrefix", function () { return $cc73c912ef4aaf57$export$fc38cc6da79faa5c; });
$parcel$export(module.exports, "buildOrganizationUrn", function () { return $cc73c912ef4aaf57$export$22667c0b6b2d7fac; });
$parcel$export(module.exports, "getOrganizationIdFromUrn", function () { return $cc73c912ef4aaf57$export$a237ae1b02e4e718; });
/** Scopes that reserved by Logto, which will be added to the auth request automatically. */ var $cc73c912ef4aaf57$export$1d2e82cebfd4b08;
(function(ReservedScope) {
    ReservedScope["OpenId"] = "openid";
    ReservedScope["OfflineAccess"] = "offline_access";
})($cc73c912ef4aaf57$export$1d2e82cebfd4b08 || ($cc73c912ef4aaf57$export$1d2e82cebfd4b08 = {}));
var $cc73c912ef4aaf57$export$36ba08a8e14b2df6;
(function(ReservedResource) {
    /**
     * The resource for organization template per RFC 0001.
     *
     * @see {@link https://github.com/logto-io/rfcs | RFC 0001} for more details.
     */ ReservedResource["Organization"] = "urn:logto:resource:organizations";
})($cc73c912ef4aaf57$export$36ba08a8e14b2df6 || ($cc73c912ef4aaf57$export$36ba08a8e14b2df6 = {}));
var $cc73c912ef4aaf57$export$4b02c5b431f6eb78;
(function(UserScope) {
    /**
     * Scope for basic user info.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Profile"] = "profile";
    /**
     * Scope for user email address.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Email"] = "email";
    /**
     * Scope for user phone number.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Phone"] = "phone";
    /**
     * Scope for user address.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Address"] = "address";
    /**
     * Scope for user's custom data.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["CustomData"] = "custom_data";
    /**
     * Scope for user's social and SSO identity details.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Identities"] = "identities";
    /**
     * Scope for user's roles.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Roles"] = "roles";
    /**
     * Scope for user's organization IDs and perform organization token grant per [RFC 0001](https://github.com/logto-io/rfcs).
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Organizations"] = "urn:logto:scope:organizations";
    /**
     * Scope for user's organization roles per [RFC 0001](https://github.com/logto-io/rfcs).
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["OrganizationRoles"] = "urn:logto:scope:organization_roles";
})($cc73c912ef4aaf57$export$4b02c5b431f6eb78 || ($cc73c912ef4aaf57$export$4b02c5b431f6eb78 = {}));
const $cc73c912ef4aaf57$export$f57bb8dda2a18319 = Object.freeze({
    [$cc73c912ef4aaf57$export$4b02c5b431f6eb78.Profile]: [
        // Standard claims
        "name",
        "family_name",
        "given_name",
        "middle_name",
        "nickname",
        "preferred_username",
        "profile",
        "picture",
        "website",
        "gender",
        "birthdate",
        "zoneinfo",
        "locale",
        "updated_at",
        // Custom claims
        "username",
        "created_at"
    ],
    [$cc73c912ef4aaf57$export$4b02c5b431f6eb78.Email]: [
        "email",
        "email_verified"
    ],
    [$cc73c912ef4aaf57$export$4b02c5b431f6eb78.Phone]: [
        "phone_number",
        "phone_number_verified"
    ],
    [$cc73c912ef4aaf57$export$4b02c5b431f6eb78.Address]: [
        "address"
    ],
    [$cc73c912ef4aaf57$export$4b02c5b431f6eb78.Roles]: [
        "roles"
    ],
    [$cc73c912ef4aaf57$export$4b02c5b431f6eb78.Organizations]: [
        "organizations"
    ],
    [$cc73c912ef4aaf57$export$4b02c5b431f6eb78.OrganizationRoles]: [
        "organization_roles"
    ],
    [$cc73c912ef4aaf57$export$4b02c5b431f6eb78.CustomData]: [],
    [$cc73c912ef4aaf57$export$4b02c5b431f6eb78.Identities]: []
});
const $cc73c912ef4aaf57$export$c11d5a3385aa71dd = Object.freeze({
    [$cc73c912ef4aaf57$export$4b02c5b431f6eb78.Profile]: [],
    [$cc73c912ef4aaf57$export$4b02c5b431f6eb78.Email]: [],
    [$cc73c912ef4aaf57$export$4b02c5b431f6eb78.Phone]: [],
    [$cc73c912ef4aaf57$export$4b02c5b431f6eb78.Address]: [],
    [$cc73c912ef4aaf57$export$4b02c5b431f6eb78.Roles]: [],
    [$cc73c912ef4aaf57$export$4b02c5b431f6eb78.Organizations]: [
        "organization_data"
    ],
    [$cc73c912ef4aaf57$export$4b02c5b431f6eb78.OrganizationRoles]: [],
    [$cc73c912ef4aaf57$export$4b02c5b431f6eb78.CustomData]: [
        "custom_data"
    ],
    [$cc73c912ef4aaf57$export$4b02c5b431f6eb78.Identities]: [
        "identities",
        "sso_identities"
    ]
});
const $cc73c912ef4aaf57$export$6c46daeabb0176f9 = Object.freeze(// Hard to infer type directly, use `as` for a workaround.
// eslint-disable-next-line no-restricted-syntax
Object.fromEntries(Object.values($cc73c912ef4aaf57$export$4b02c5b431f6eb78).map((current)=>[
        current,
        [
            ...$cc73c912ef4aaf57$export$f57bb8dda2a18319[current],
            ...$cc73c912ef4aaf57$export$c11d5a3385aa71dd[current]
        ]
    ])));
const $cc73c912ef4aaf57$export$fc38cc6da79faa5c = "urn:logto:organization:";
const $cc73c912ef4aaf57$export$22667c0b6b2d7fac = (organizationId)=>`${$cc73c912ef4aaf57$export$fc38cc6da79faa5c}${organizationId}`;
const $cc73c912ef4aaf57$export$a237ae1b02e4e718 = (urn)=>{
    if (!urn.startsWith($cc73c912ef4aaf57$export$fc38cc6da79faa5c)) throw new TypeError("Invalid organization URN.");
    return urn.slice($cc73c912ef4aaf57$export$fc38cc6da79faa5c.length);
};

});

parcelRequire.register("6xnKJ", function(module, exports) {
parcelRequire("54Ke3");

});
parcelRequire.register("54Ke3", function(module, exports) {
parcelRequire("ajkVG");
var $7WNrO = parcelRequire("7WNrO");
// Use lowercase letters for tenant IDs to improve compatibility
const $3b212ee8a5d93fce$var$generateTenantId = ()=>(0, $7WNrO.generateStandardId)(6);
const $3b212ee8a5d93fce$export$f7397bf6ffda60a4 = (databaseName, tenantId = $3b212ee8a5d93fce$var$generateTenantId())=>{
    const parentRole = `logto_tenant_${databaseName}`;
    const role = `logto_tenant_${databaseName}_${tenantId}`;
    const password = (0, $7WNrO.generateStandardId)(32);
    return {
        id: tenantId,
        parentRole: parentRole,
        role: role,
        password: password
    };
};

});


parcelRequire.register("37iDI", function(module, exports) {

$parcel$export(module.exports, "httpCodeToMessage", function () { return $24507bf6feab9210$export$fd24084cc418abf6; });
const $24507bf6feab9210$export$fd24084cc418abf6 = Object.freeze({
    200: "OK",
    201: "Created",
    202: "Accepted",
    203: "Non-Authoritative Information",
    204: "No Content",
    205: "Reset Content",
    206: "Partial Content",
    300: "Multiple Choices",
    301: "Moved Permanently",
    302: "Found",
    303: "See Other",
    304: "Not Modified",
    305: "Use Proxy",
    306: "Unused",
    307: "Temporary Redirect",
    400: "Bad Request",
    401: "Unauthorized",
    402: "Payment Required",
    403: "Forbidden",
    404: "Not Found",
    405: "Method Not Allowed",
    406: "Not Acceptable",
    407: "Proxy Authentication Required",
    408: "Request Timeout",
    409: "Conflict",
    410: "Gone",
    411: "Length Required",
    412: "Precondition Required",
    413: "Request Entry Too Large",
    414: "Request-URI Too Long",
    415: "Unsupported Media Type",
    416: "Requested Range Not Satisfiable",
    417: "Expectation Failed",
    418: "I'm a teapot",
    422: "Unprocessable Content",
    429: "Too Many Requests",
    500: "Internal Server Error",
    501: "Not Implemented",
    502: "Bad Gateway",
    503: "Service Unavailable",
    504: "Gateway Timeout",
    505: "HTTP Version Not Supported"
});

});

parcelRequire.register("d1NuF", function(module, exports) {

$parcel$export(module.exports, "passwordPolicyGuard", function () { return $97c1c2c8c8ddf33c$export$5fffa90e2e38377b; });
$parcel$export(module.exports, "PasswordPolicyChecker", function () { return $97c1c2c8c8ddf33c$export$d2f225c121fa68bd; });

var $c3dK3 = parcelRequire("c3dK3");

var $8w1oR = parcelRequire("8w1oR");
const $97c1c2c8c8ddf33c$export$5fffa90e2e38377b = (0, $c3dK3.z).object({
    length: (0, $c3dK3.z).object({
        min: (0, $c3dK3.z).number().int().min(1).default(8),
        max: (0, $c3dK3.z).number().int().min(1).default(256)
    }).default({}),
    characterTypes: (0, $c3dK3.z).object({
        min: (0, $c3dK3.z).number().int().min(1).max(4).optional().default(1)
    }).default({}),
    rejects: (0, $c3dK3.z).object({
        pwned: (0, $c3dK3.z).boolean().default(true),
        repetitionAndSequence: (0, $c3dK3.z).boolean().default(true),
        userInfo: (0, $c3dK3.z).boolean().default(true),
        words: (0, $c3dK3.z).string().array().default([])
    }).default({})
});
class $97c1c2c8c8ddf33c$export$d2f225c121fa68bd {
    static #_ = (()=>{
        this.symbols = Object.freeze("!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~ ");
    })();
    static #_1 = (()=>{
        this.sequence = Object.freeze([
            "0123456789",
            "abcdefghijklmnopqrstuvwxyz",
            "qwertyuiop",
            "asdfghjkl",
            "zxcvbnm",
            "1qaz",
            "2wsx",
            "3edc",
            "4rfv",
            "5tgb",
            "6yhn",
            "7ujm",
            "8ik",
            "9ol"
        ]);
    })();
    static #_2 = (()=>{
        this.repetitionAndSequenceThreshold = 3;
    })();
    static #_3 = (()=>{
        this.restrictedPhrasesTolerance = 3;
    })();
    /** Get the length threshold for checking restricted phrases. */ static getRestrictedPhraseThreshold(password) {
        const { restrictedPhrasesTolerance: restrictedPhrasesTolerance } = $97c1c2c8c8ddf33c$export$d2f225c121fa68bd;
        return Math.max(1, password.length - restrictedPhrasesTolerance);
    }
    constructor(policy, /** The Web Crypto API to use. By default, the global `crypto.subtle` will be used. */ subtle = crypto.subtle){
        this.subtle = subtle;
        this.policy = $97c1c2c8c8ddf33c$export$5fffa90e2e38377b.parse(policy);
    }
    /**
     * Check if a password meets all the policy requirements.
     *
     * @param password - Password to check.
     * @param userInfo - User information to check. Required if the policy
     * requires to reject passwords that include user information.
     * @returns An array of issues. If the password meets the policy, an empty array will be returned.
     * @throws TypeError - If the policy requires to reject passwords that include user information
     * but the user information is not provided.
     */ /* eslint-disable @silverhand/fp/no-let, @silverhand/fp/no-mutation, @silverhand/fp/no-mutating-methods */ async check(password, userInfo) {
        const issues = this.fastCheck(password);
        if (this.policy.rejects.pwned && await this.hasBeenPwned(password)) issues.push({
            code: "password_rejected.pwned"
        });
        // `hashArray[i]` indicates whether the `i`th character violates the restriction.
        // We'll gradually set the value to `1` if needed.
        // The algorithm time complexity should be O(n^2), but it's fast enough for a password.
        const hashArray = Array.from({
            length: password.length
        }).fill(0);
        const issueCodes = new Set();
        const { repetitionAndSequence: repetitionAndSequence, words: words, userInfo: rejectUserInfo } = this.policy.rejects;
        const rejectWords = words.length > 0;
        const fillHashArray = (startIndex, length, code)=>{
            if (length <= 0) return;
            for(let i = startIndex; i < startIndex + length; i += 1)hashArray[i] = 1;
            issueCodes.add(code);
        };
        for(let i = 0; i < password.length; i += 1){
            const sliced = password.slice(i);
            if (repetitionAndSequence) {
                fillHashArray(i, this.repetitionLength(sliced), "restricted.repetition");
                fillHashArray(i, this.sequenceLength(sliced), "restricted.sequence");
            }
            if (rejectWords) fillHashArray(i, this.wordLength(sliced), "restricted.words");
            if (rejectUserInfo) {
                if (!userInfo) throw new TypeError("User information data is required to check user information.");
                fillHashArray(i, this.userInfoLength(sliced, userInfo), "restricted.user_info");
            }
        }
        return hashArray.reduce((total, current)=>total + current, 0) > $97c1c2c8c8ddf33c$export$d2f225c121fa68bd.getRestrictedPhraseThreshold(password) ? [
            ...issues,
            ...[
                ...issueCodes
            ].map((code)=>({
                    code: `password_rejected.${code}`
                }))
        ] : issues;
    }
    /* eslint-enable @silverhand/fp/no-let, @silverhand/fp/no-mutation, @silverhand/fp/no-mutating-methods */ /**
     * Perform a fast check to see if the password passes the basic requirements.
     * Only the length and character types will be checked.
     *
     * This method is used for frontend validation.
     *
     * @param password - Password to check.
     * @returns Whether the password passes the basic requirements.
     */ /* eslint-disable @silverhand/fp/no-mutating-methods */ fastCheck(password) {
        const issues = [];
        if (password.length < this.policy.length.min) issues.push({
            code: "password_rejected.too_short",
            interpolation: {
                min: this.policy.length.min
            }
        });
        else if (password.length > this.policy.length.max) issues.push({
            code: "password_rejected.too_long",
            interpolation: {
                max: this.policy.length.max
            }
        });
        const characterTypes = this.checkCharTypes(password);
        if (characterTypes === "unsupported") issues.push({
            code: "password_rejected.unsupported_characters"
        });
        else if (!characterTypes) issues.push({
            code: "password_rejected.character_types",
            interpolation: {
                min: this.policy.characterTypes.min
            }
        });
        return issues;
    }
    /* eslint-enable @silverhand/fp/no-mutating-methods */ /**
     * Check if the given password contains enough character types.
     *
     * @param password - Password to check.
     * @returns Whether the password contains enough character types; or `'unsupported'`
     * if the password contains unsupported characters.
     */ checkCharTypes(password) {
        const characterTypes = new Set();
        for (const char of password){
            if (char >= "a" && char <= "z") characterTypes.add("lowercase");
            else if (char >= "A" && char <= "Z") characterTypes.add("uppercase");
            else if (char >= "0" && char <= "9") characterTypes.add("digits");
            else if ($97c1c2c8c8ddf33c$export$d2f225c121fa68bd.symbols.includes(char)) characterTypes.add("symbols");
            else return "unsupported";
        }
        return characterTypes.size >= this.policy.characterTypes.min;
    }
    /**
     * Check if the given password has been pwned.
     *
     * @param password - Password to check.
     * @returns Whether the password has been pwned.
     */ async hasBeenPwned(password) {
        if ((0, $8w1oR.isIntegrationTest)()) return (0, $8w1oR.getPwnPasswordsForTest)().includes(password);
        const hash = await this.subtle.digest("SHA-1", new TextEncoder().encode(password));
        const hashHex = Array.from(new Uint8Array(hash)).map((binary)=>binary.toString(16).padStart(2, "0")).join("");
        const hashPrefix = hashHex.slice(0, 5);
        const hashSuffix = hashHex.slice(5);
        const response = await fetch(`https://api.pwnedpasswords.com/range/${hashPrefix}`);
        const text = await response.text();
        const hashes = text.split("\n");
        const found = hashes.some((hex)=>hex.toLowerCase().startsWith(hashSuffix));
        return found;
    }
    /**
     * Get the length of the repetition at the beginning of the given string.
     * For example, `repetitionLength('aaaaa')` will return `5`.
     *
     * If the length is less than {@link PasswordPolicyChecker.repetitionAndSequenceThreshold},
     * `0` will be returned.
     */ /* eslint-disable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ repetitionLength(password) {
        const { repetitionAndSequenceThreshold: repetitionAndSequenceThreshold } = $97c1c2c8c8ddf33c$export$d2f225c121fa68bd;
        const firstChar = password[0];
        let length = 0;
        if (firstChar === undefined) return 0;
        for (const char of password){
            if (char === firstChar) length += 1;
            else break;
        }
        return length >= repetitionAndSequenceThreshold ? length : 0;
    }
    /* eslint-enable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ /**
     * Get the length of the user information at the beginning of the given string.
     * For example, `userInfoLength('silverhand', { username: 'silverhand' })` will return `10`.
     *
     * For multiple matches, the longest length will be returned.
     */ // eslint-disable-next-line complexity
    userInfoLength(password, userInfo) {
        const lowercased = password.toLowerCase();
        const { name: name, username: username, email: email, phoneNumber: phoneNumber } = userInfo;
        // eslint-disable-next-line @silverhand/fp/no-let
        let length = 0;
        const updateLength = (newLength)=>{
            if (newLength > length) // eslint-disable-next-line @silverhand/fp/no-mutation
            length = newLength;
        };
        if (name) {
            const joined = name.replaceAll(/\s+/g, "");
            // The original name should be the longest string, so we check it first.
            if (lowercased.startsWith(name.toLowerCase())) updateLength(name.length);
            else {
                if (lowercased.startsWith(joined.toLowerCase())) updateLength(joined.length);
                for (const word of name.split(" "))if (lowercased.startsWith(word.toLowerCase())) updateLength(word.length);
            }
        }
        if (username && lowercased.startsWith(username.toLowerCase())) updateLength(username.length);
        if (email) {
            const emailPrefix = email.split("@")[0];
            if (emailPrefix && lowercased.startsWith(emailPrefix.toLowerCase())) updateLength(emailPrefix.length);
        }
        if (phoneNumber && lowercased.startsWith(phoneNumber)) updateLength(phoneNumber.length);
        return length;
    }
    /**
     * Get the length of the word that matches the word list at the beginning of the given string.
     *
     * For multiple matches, the longest length will be returned.
     */ /* eslint-disable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ wordLength(password) {
        const sliced = password.toLowerCase();
        let length = 0;
        for (const word of this.policy.rejects.words)if (sliced.startsWith(word.toLowerCase()) && word.length > length) length = word.length;
        return length;
    }
    /* eslint-enable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ /**
     * Get the length of the sequence at the beginning of the given string.
     * For example, `sequenceLength('12345')` will return `5`.
     *
     * If the length is less than {@link PasswordPolicyChecker.repetitionAndSequenceThreshold},
     * `0` will be returned.
     */ /* eslint-disable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ sequenceLength(password) {
        const { repetitionAndSequenceThreshold: repetitionAndSequenceThreshold } = $97c1c2c8c8ddf33c$export$d2f225c121fa68bd;
        let value = "";
        let length = 0;
        for (const char of password){
            if (!value || this.isSequential(value + char)) {
                value += char;
                length += 1;
            } else break;
        }
        return length >= repetitionAndSequenceThreshold ? length : 0;
    }
    /* eslint-enable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ /**
     * Check if the given string is sequential by iterating through the {@link PasswordPolicyChecker.sequence}.
     */ isSequential(value) {
        const { sequence: sequence } = $97c1c2c8c8ddf33c$export$d2f225c121fa68bd;
        for (const seq of sequence){
            // eslint-disable-next-line @silverhand/fp/no-mutating-methods -- created a new array before mutating
            const reversedSeq = [
                ...seq
            ].reverse().join("");
            if ([
                seq,
                reversedSeq,
                seq.toUpperCase(),
                reversedSeq.toUpperCase()
            ].some((item)=>item.includes(value))) return true;
        }
        return false;
    }
}

});
parcelRequire.register("8w1oR", function(module, exports) {

$parcel$export(module.exports, "isIntegrationTest", function () { return $633265e569973b0a$export$72f2527c55497f9e; });
$parcel$export(module.exports, "getPwnPasswordsForTest", function () { return $633265e569973b0a$export$3411cedb68d31149; });
parcelRequire("12bMu");
var $l0I3U = parcelRequire("l0I3U");
const $633265e569973b0a$export$72f2527c55497f9e = ()=>(0, $l0I3U.yes)(undefined);
const $633265e569973b0a$export$3411cedb68d31149 = ()=>{
    if (!$633265e569973b0a$export$72f2527c55497f9e()) throw new Error("This function should only be called in integration tests");
    return Object.freeze([
        "123456aA",
        "test_password"
    ]);
};

});




parcelRequire.register("ZBK3w", function(module, exports) {

$parcel$export(module.exports, "oidcModelInstancePayloadGuard", function () { return $0b92f95cd2a4be12$export$525df20e0fb1714c; });
$parcel$export(module.exports, "oidcClientMetadataGuard", function () { return $0b92f95cd2a4be12$export$2b5eeb3c40bff26b; });
$parcel$export(module.exports, "customClientMetadataGuard", function () { return $0b92f95cd2a4be12$export$44618fabe8266610; });
parcelRequire("4taJ0");
var $5rMXH = parcelRequire("5rMXH");

var $c3dK3 = parcelRequire("c3dK3");
const $0b92f95cd2a4be12$export$525df20e0fb1714c = (0, $c3dK3.z).object({
    userCode: (0, $c3dK3.z).string().optional(),
    uid: (0, $c3dK3.z).string().optional(),
    grantId: (0, $c3dK3.z).string().optional()
})/**
     * Try to use `.passthrough()` if type has been fixed.
     * https://github.com/colinhacks/zod/issues/452
     */ .catchall((0, $c3dK3.z).unknown());
const $0b92f95cd2a4be12$export$2b5eeb3c40bff26b = (0, $c3dK3.z).object({
    redirectUris: (0, $c3dK3.z).string().refine((url)=>(0, $5rMXH.validateRedirectUrl)(url, "web")).or((0, $c3dK3.z).string().refine((url)=>(0, $5rMXH.validateRedirectUrl)(url, "mobile"))).array(),
    postLogoutRedirectUris: (0, $c3dK3.z).string().url().array(),
    logoUri: (0, $c3dK3.z).string().optional()
});
var $0b92f95cd2a4be12$export$35a50069c63f27cc;
(function(CustomClientMetadataKey) {
    CustomClientMetadataKey["CorsAllowedOrigins"] = "corsAllowedOrigins";
    CustomClientMetadataKey["IdTokenTtl"] = "idTokenTtl";
    /** @deprecated Use {@link RefreshTokenTtlInDays} instead. */ CustomClientMetadataKey["RefreshTokenTtl"] = "refreshTokenTtl";
    CustomClientMetadataKey["RefreshTokenTtlInDays"] = "refreshTokenTtlInDays";
    CustomClientMetadataKey["TenantId"] = "tenantId";
    /**
     * Enabling this configuration will allow Logto to always issue Refresh Tokens, regardless of whether `prompt=consent` is presented in the authentication request.
     *
     * It only works for web applications when the client allowed grant types includes `refresh_token`.
     *
     * This config is for the third-party integrations that do not strictly follow OpenID Connect standards due to some reasons (e.g. they only know OAuth, but requires a Refresh Token to be returned anyway).
     */ CustomClientMetadataKey["AlwaysIssueRefreshToken"] = "alwaysIssueRefreshToken";
    /**
     * When enabled (default), Logto will issue a new Refresh Token for token requests when 70% of the original Time to Live (TTL) has passed.
     *
     * It can be turned off for only traditional web apps for enhanced security.
     */ CustomClientMetadataKey["RotateRefreshToken"] = "rotateRefreshToken";
})($0b92f95cd2a4be12$export$35a50069c63f27cc || ($0b92f95cd2a4be12$export$35a50069c63f27cc = {}));
const $0b92f95cd2a4be12$export$44618fabe8266610 = (0, $c3dK3.z).object({
    [$0b92f95cd2a4be12$export$35a50069c63f27cc.CorsAllowedOrigins]: (0, $c3dK3.z).string().min(1).array().optional(),
    [$0b92f95cd2a4be12$export$35a50069c63f27cc.IdTokenTtl]: (0, $c3dK3.z).number().optional(),
    [$0b92f95cd2a4be12$export$35a50069c63f27cc.RefreshTokenTtl]: (0, $c3dK3.z).number().optional(),
    [$0b92f95cd2a4be12$export$35a50069c63f27cc.RefreshTokenTtlInDays]: (0, $c3dK3.z).number().int().min(1).max(90).optional(),
    [$0b92f95cd2a4be12$export$35a50069c63f27cc.TenantId]: (0, $c3dK3.z).string().optional(),
    [$0b92f95cd2a4be12$export$35a50069c63f27cc.AlwaysIssueRefreshToken]: (0, $c3dK3.z).boolean().optional(),
    [$0b92f95cd2a4be12$export$35a50069c63f27cc.RotateRefreshToken]: (0, $c3dK3.z).boolean().optional()
});

});

parcelRequire.register("cqPmz", function(module, exports) {

$parcel$export(module.exports, "translationGuard", function () { return $90cfc15b6226e209$export$aea1b2a91583fcef; });

var $c3dK3 = parcelRequire("c3dK3");
const $90cfc15b6226e209$export$aea1b2a91583fcef = (0, $c3dK3.z).lazy(()=>(0, $c3dK3.z).record((0, $c3dK3.z).string().or($90cfc15b6226e209$export$aea1b2a91583fcef)));

});

parcelRequire.register("8lyC3", function(module, exports) {

$parcel$export(module.exports, "colorGuard", function () { return $613b224c446fa07a$export$5c91807cab7a8dc1; });
$parcel$export(module.exports, "brandingGuard", function () { return $613b224c446fa07a$export$c9d0acdc98ac45b; });
$parcel$export(module.exports, "languageInfoGuard", function () { return $613b224c446fa07a$export$b8fe26243f8b3b37; });
$parcel$export(module.exports, "SignInIdentifier", function () { return $613b224c446fa07a$export$f2322d76aef584c7; });
$parcel$export(module.exports, "signUpGuard", function () { return $613b224c446fa07a$export$fd48acc070c38d7b; });
$parcel$export(module.exports, "signInGuard", function () { return $613b224c446fa07a$export$8665c7c0edac5e7a; });
$parcel$export(module.exports, "connectorTargetsGuard", function () { return $613b224c446fa07a$export$276d424b39387296; });
$parcel$export(module.exports, "customContentGuard", function () { return $613b224c446fa07a$export$7dfc08c51ef177a5; });
$parcel$export(module.exports, "MfaFactor", function () { return $613b224c446fa07a$export$c62e7669a75c5961; });
$parcel$export(module.exports, "mfaFactorsGuard", function () { return $613b224c446fa07a$export$10c80e60471dfbfa; });
$parcel$export(module.exports, "MfaPolicy", function () { return $613b224c446fa07a$export$da22c5f01b0bc81; });
$parcel$export(module.exports, "mfaGuard", function () { return $613b224c446fa07a$export$74899fc35c1207c8; });
parcelRequire("4taJ0");
var $9vrm1 = parcelRequire("9vrm1");
parcelRequire("hNGhh");
var $eRB1v = parcelRequire("eRB1v");

var $c3dK3 = parcelRequire("c3dK3");
const $613b224c446fa07a$export$5c91807cab7a8dc1 = (0, $c3dK3.z).object({
    primaryColor: (0, $c3dK3.z).string().regex((0, $9vrm1.hexColorRegEx)),
    isDarkModeEnabled: (0, $c3dK3.z).boolean(),
    darkPrimaryColor: (0, $c3dK3.z).string().regex((0, $9vrm1.hexColorRegEx))
});
const $613b224c446fa07a$export$c9d0acdc98ac45b = (0, $c3dK3.z).object({
    logoUrl: (0, $c3dK3.z).string().url().optional(),
    darkLogoUrl: (0, $c3dK3.z).string().url().optional(),
    favicon: (0, $c3dK3.z).string().url().optional()
});
const $613b224c446fa07a$export$b8fe26243f8b3b37 = (0, $c3dK3.z).object({
    autoDetect: (0, $c3dK3.z).boolean(),
    fallbackLanguage: (0, $eRB1v.languageTagGuard)
});
var $613b224c446fa07a$export$f2322d76aef584c7;
(function(SignInIdentifier) {
    SignInIdentifier["Username"] = "username";
    SignInIdentifier["Email"] = "email";
    SignInIdentifier["Phone"] = "phone";
})($613b224c446fa07a$export$f2322d76aef584c7 || ($613b224c446fa07a$export$f2322d76aef584c7 = {}));
const $613b224c446fa07a$export$fd48acc070c38d7b = (0, $c3dK3.z).object({
    identifiers: (0, $c3dK3.z).nativeEnum($613b224c446fa07a$export$f2322d76aef584c7).array(),
    password: (0, $c3dK3.z).boolean(),
    verify: (0, $c3dK3.z).boolean()
});
const $613b224c446fa07a$export$8665c7c0edac5e7a = (0, $c3dK3.z).object({
    methods: (0, $c3dK3.z).object({
        identifier: (0, $c3dK3.z).nativeEnum($613b224c446fa07a$export$f2322d76aef584c7),
        password: (0, $c3dK3.z).boolean(),
        verificationCode: (0, $c3dK3.z).boolean(),
        isPasswordPrimary: (0, $c3dK3.z).boolean()
    }).array()
});
const $613b224c446fa07a$export$276d424b39387296 = (0, $c3dK3.z).string().array();
const $613b224c446fa07a$export$7dfc08c51ef177a5 = (0, $c3dK3.z).record((0, $c3dK3.z).string());
var $613b224c446fa07a$export$c62e7669a75c5961;
(function(MfaFactor) {
    MfaFactor["TOTP"] = "Totp";
    MfaFactor["WebAuthn"] = "WebAuthn";
    MfaFactor["BackupCode"] = "BackupCode";
})($613b224c446fa07a$export$c62e7669a75c5961 || ($613b224c446fa07a$export$c62e7669a75c5961 = {}));
const $613b224c446fa07a$export$10c80e60471dfbfa = (0, $c3dK3.z).nativeEnum($613b224c446fa07a$export$c62e7669a75c5961).array();
var $613b224c446fa07a$export$da22c5f01b0bc81;
(function(MfaPolicy) {
    MfaPolicy["UserControlled"] = "UserControlled";
    MfaPolicy["Mandatory"] = "Mandatory";
})($613b224c446fa07a$export$da22c5f01b0bc81 || ($613b224c446fa07a$export$da22c5f01b0bc81 = {}));
const $613b224c446fa07a$export$74899fc35c1207c8 = (0, $c3dK3.z).object({
    factors: $613b224c446fa07a$export$10c80e60471dfbfa,
    policy: (0, $c3dK3.z).nativeEnum($613b224c446fa07a$export$da22c5f01b0bc81)
});

});
parcelRequire.register("hNGhh", function(module, exports) {
$parcel$export(module.exports, "languages", function () { return (parcelRequire("cOUYQ")).languages; });
$parcel$export(module.exports, "fallback", function () { return (parcelRequire("eRB1v")).fallback; });
$parcel$export(module.exports, "isLanguageTag", function () { return (parcelRequire("eRB1v")).isLanguageTag; });
$parcel$export(module.exports, "languageTagGuard", function () { return (parcelRequire("eRB1v")).languageTagGuard; });
parcelRequire("cOUYQ");
parcelRequire("3oYfS");
parcelRequire("eRB1v");

});
parcelRequire.register("cOUYQ", function(module, exports) {

$parcel$export(module.exports, "languages", function () { return $02689e5d8696240b$export$d0d68bb9ed2c643d; });
const $02689e5d8696240b$export$d0d68bb9ed2c643d = Object.freeze({
    "af-ZA": "Afrikaans",
    "am-ET": "አማርኛ",
    "ar-AR": "العربية",
    "as-IN": "অসমীয়া",
    "az-AZ": "Azərbaycan dili",
    "be-BY": "Беларуская",
    "bg-BG": "Български",
    "bn-IN": "বাংলা",
    "br-FR": "Brezhoneg",
    "bs-BA": "Bosanski",
    "ca-ES": "Catal\xe0",
    "cb-IQ": "کوردیی ناوەندی",
    "co-FR": "Corsu",
    "cs-CZ": "Čeština",
    "cx-PH": "Bisaya",
    "cy-GB": "Cymraeg",
    "da-DK": "Dansk",
    de: "Deutsch",
    "de-DE": "Deutsch (Deutschland)",
    "el-GR": "Ελληνικά",
    en: "English",
    "en-GB": "English (UK)",
    "en-US": "English (US)",
    "eo-EO": "Esperanto",
    es: "Espa\xf1ol",
    "es-ES": "Espa\xf1ol (Espa\xf1a)",
    "es-419": "Espa\xf1ol (Latinoam\xe9rica)",
    "et-EE": "Eesti",
    "eu-ES": "Euskara",
    "fa-IR": "فارسی",
    "ff-NG": "Fula",
    "fi-FI": "Suomi",
    "fo-FO": "F\xf8royskt",
    fr: "Fran\xe7ais",
    "fr-CA": "Fran\xe7ais (Canada)",
    "fr-FR": "Fran\xe7ais (France)",
    "fy-NL": "Frysk",
    "ga-IE": "Gaeilge",
    "gl-ES": "Galego",
    "gn-PY": "Guarani",
    "gu-IN": "ગુજરાતી",
    "ha-NG": "Hausa",
    "he-IL": "עברית",
    "hi-IN": "हिन्दी",
    "hr-HR": "Hrvatski",
    "ht-HT": "Krey\xf2l Ayisyen",
    "hu-HU": "Magyar",
    "hy-AM": "Հայերեն",
    "id-ID": "Bahasa Indonesia",
    "ik-US": "I\xf1upiatun",
    "is-IS": "\xcdslenska",
    it: "Italiano",
    "it-IT": "Italiano (Italia)",
    "iu-CA": "Inuktitut",
    ja: "日本語",
    "ja-JP": "日本語",
    "ja-KS": "日本語(関西)",
    "jv-ID": "Basa Jawa",
    "ka-GE": "ქართული",
    "kk-KZ": "Қазақша",
    "km-KH": "ភាសាខ្មែរ",
    "kn-IN": "ಕನ್ನಡ",
    ko: "한국어",
    "ko-KR": "한국어",
    "ku-TR": "Kurd\xee (Kurmanc\xee)",
    "ky-KG": "кыргызча",
    "lo-LA": "ພາສາລາວ",
    "lt-LT": "Lietuvių",
    "lv-LV": "Latviešu",
    "mg-MG": "Malagasy",
    "mk-MK": "Македонски",
    "ml-IN": "മലയാളം",
    "mn-MN": "Монгол",
    "mr-IN": "मराठी",
    "ms-MY": "Bahasa Melayu",
    "mt-MT": "Malti",
    "my-MM": "မြန်မာဘာသာ",
    "nb-NO": "Norsk (bokm\xe5l)",
    "ne-NP": "नेपाली",
    "nl-BE": "Vlaams",
    "nl-NL": "Nederlands",
    "nn-NO": "Norsk (nynorsk)",
    "or-IN": "ଓଡ଼ିଆ",
    "pa-IN": "ਪੰਜਾਬੀ",
    "pl-PL": "Polski",
    "ps-AF": "پښتو",
    pt: "portugu\xeas",
    "pt-BR": "Portugu\xeas (Brasil)",
    "pt-PT": "Portugu\xeas (Portugal)",
    "ro-RO": "Rom\xe2nă",
    ru: "Русский",
    "ru-RU": "Русский",
    "rw-RW": "Ikinyarwanda",
    "sc-IT": "Sardu",
    "si-LK": "සිංහල",
    "sk-SK": "Slovenčina",
    "sl-SI": "Slovenščina",
    "sn-ZW": "Shona",
    "sq-AL": "Shqip",
    "sr-RS": "Српски",
    "sv-SE": "Svenska",
    "sw-KE": "Kiswahili",
    "sy-SY": "ܣܘܪܝܝܐ",
    "sz-PL": "ślōnskŏ gŏdka",
    "ta-IN": "தமிழ்",
    "te-IN": "తెలుగు",
    "tg-TJ": "Тоҷикӣ",
    "th-TH": "ภาษาไทย",
    "tl-PH": "Filipino",
    tr: "T\xfcrk\xe7e",
    "tr-TR": "T\xfcrk\xe7e",
    "tt-RU": "Татарча",
    "tz-MA": "ⵜⴰⵎⴰⵣⵉⵖⵜ",
    "uk-UA": "Українська",
    "ur-PK": "اردو",
    "uz-UZ": "O'zbek",
    "vi-VN": "Tiếng Việt",
    zh: "中文",
    "zh-CN": "简体中文",
    "zh-HK": "繁體中文（香港）",
    "zh-MO": "繁體中文（澳門）",
    "zh-TW": "繁體中文（台灣）",
    "zz-TR": "Zaza"
});

});

parcelRequire.register("3oYfS", function(module, exports) {

});

parcelRequire.register("eRB1v", function(module, exports) {

$parcel$export(module.exports, "isLanguageTag", function () { return $ad22bbfb1cdeb54b$export$ab649249f0bfeb57; });
$parcel$export(module.exports, "languageTagGuard", function () { return $ad22bbfb1cdeb54b$export$2b8b19a59fcec1e6; });
$parcel$export(module.exports, "fallback", function () { return $ad22bbfb1cdeb54b$export$bcd1dd1f397bba12; });

var $c3dK3 = parcelRequire("c3dK3");

var $cOUYQ = parcelRequire("cOUYQ");
const $ad22bbfb1cdeb54b$export$ab649249f0bfeb57 = (value)=>typeof value === "string" && value in (0, $cOUYQ.languages);
const $ad22bbfb1cdeb54b$export$2b8b19a59fcec1e6 = (0, $c3dK3.z).any().refine((value)=>$ad22bbfb1cdeb54b$export$ab649249f0bfeb57(value));
function $ad22bbfb1cdeb54b$export$bcd1dd1f397bba12(value) {
    return (0, $c3dK3.any)().transform(()=>value);
}

});



parcelRequire.register("hMPN6", function(module, exports) {

$parcel$export(module.exports, "sentinelActivityTargetTypeGuard", function () { return $cf2f17f611c3f857$export$47228912e855c2e6; });
$parcel$export(module.exports, "sentinelActivityActionGuard", function () { return $cf2f17f611c3f857$export$8cdcc536cbf8daf0; });
$parcel$export(module.exports, "sentinelActivityPayloadGuard", function () { return $cf2f17f611c3f857$export$ef3e193200f88c05; });

var $c3dK3 = parcelRequire("c3dK3");
var $cf2f17f611c3f857$export$f6585a37d5516193;
(function(SentinelActivityTargetType) {
    SentinelActivityTargetType["User"] = "User";
    SentinelActivityTargetType["App"] = "App";
})($cf2f17f611c3f857$export$f6585a37d5516193 || ($cf2f17f611c3f857$export$f6585a37d5516193 = {}));
const $cf2f17f611c3f857$export$47228912e855c2e6 = (0, $c3dK3.z).nativeEnum($cf2f17f611c3f857$export$f6585a37d5516193);
var $cf2f17f611c3f857$export$e4c510688679a019;
(function(SentinelActivityAction) {
    /**
     * The subject tries to pass a verification by inputting a password.
     *
     * For example, a user (subject) who inputted a password (action) to authenticate themselves
     * (target).
     */ SentinelActivityAction["Password"] = "Password";
    /**
     * The subject tries to pass a verification by inputting a verification code.
     *
     * For example, a user (subject) who inputted a verification code (action) to authenticate
     * themselves (target).
     */ SentinelActivityAction["VerificationCode"] = "VerificationCode";
})($cf2f17f611c3f857$export$e4c510688679a019 || ($cf2f17f611c3f857$export$e4c510688679a019 = {}));
const $cf2f17f611c3f857$export$8cdcc536cbf8daf0 = (0, $c3dK3.z).nativeEnum($cf2f17f611c3f857$export$e4c510688679a019);
const $cf2f17f611c3f857$export$ef3e193200f88c05 = (0, $c3dK3.z).record((0, $c3dK3.z).unknown());

});

parcelRequire.register("1QRmm", function(module, exports) {

$parcel$export(module.exports, "userProfileGuard", function () { return $159409e551cf7347$export$755522cf8b35e50; });
$parcel$export(module.exports, "identitiesGuard", function () { return $159409e551cf7347$export$9240af6bda06dde7; });
$parcel$export(module.exports, "webAuthnTransportGuard", function () { return $159409e551cf7347$export$aa941865a0228ea6; });
$parcel$export(module.exports, "mfaVerificationsGuard", function () { return $159409e551cf7347$export$cd58e15effbd05b2; });
parcelRequire("oK7kD");
var $j080Y = parcelRequire("j080Y");

var $c3dK3 = parcelRequire("c3dK3");

var $8lyC3 = parcelRequire("8lyC3");
const $159409e551cf7347$export$755522cf8b35e50 = (0, $c3dK3.z).object({
    familyName: (0, $c3dK3.z).string(),
    givenName: (0, $c3dK3.z).string(),
    middleName: (0, $c3dK3.z).string(),
    nickname: (0, $c3dK3.z).string(),
    preferredUsername: (0, $c3dK3.z).string(),
    profile: (0, $c3dK3.z).string(),
    website: (0, $c3dK3.z).string(),
    gender: (0, $c3dK3.z).string(),
    birthdate: (0, $c3dK3.z).string(),
    zoneinfo: (0, $c3dK3.z).string(),
    locale: (0, $c3dK3.z).string(),
    address: (0, $c3dK3.z).object({
        formatted: (0, $c3dK3.z).string(),
        streetAddress: (0, $c3dK3.z).string(),
        locality: (0, $c3dK3.z).string(),
        region: (0, $c3dK3.z).string(),
        postalCode: (0, $c3dK3.z).string(),
        country: (0, $c3dK3.z).string()
    }).partial()
}).partial();
const $159409e551cf7347$export$572b146f6bc88040 = Object.freeze($159409e551cf7347$export$755522cf8b35e50.keyof().options);
const $159409e551cf7347$export$5b0e1cc5f5293c3b = (0, $c3dK3.z).string().array();
const $159409e551cf7347$export$4d846b5d465d17a5 = (0, $c3dK3.z).object({
    userId: (0, $c3dK3.z).string(),
    details: (0, $j080Y.jsonObjectGuard).optional()
});
const $159409e551cf7347$export$9240af6bda06dde7 = (0, $c3dK3.z).record($159409e551cf7347$export$4d846b5d465d17a5);
const $159409e551cf7347$export$45938720c8cd17da = {
    id: (0, $c3dK3.z).string(),
    createdAt: (0, $c3dK3.z).string(),
    lastUsedAt: (0, $c3dK3.z).string().optional()
};
const $159409e551cf7347$export$247de21853358ba3 = (0, $c3dK3.z).object({
    type: (0, $c3dK3.z).literal((0, $8lyC3.MfaFactor).TOTP),
    ...$159409e551cf7347$export$45938720c8cd17da,
    key: (0, $c3dK3.z).string()
});
const $159409e551cf7347$export$aa941865a0228ea6 = (0, $c3dK3.z).enum([
    "usb",
    "nfc",
    "ble",
    "internal",
    "cable",
    "hybrid",
    "smart-card"
]);
const $159409e551cf7347$export$d887df993511916c = (0, $c3dK3.z).object({
    type: (0, $c3dK3.z).literal((0, $8lyC3.MfaFactor).WebAuthn),
    ...$159409e551cf7347$export$45938720c8cd17da,
    credentialId: (0, $c3dK3.z).string(),
    publicKey: (0, $c3dK3.z).string(),
    transports: $159409e551cf7347$export$aa941865a0228ea6.array().optional(),
    counter: (0, $c3dK3.z).number(),
    agent: (0, $c3dK3.z).string()
});
const $159409e551cf7347$export$b31bbb972ba29c41 = (0, $c3dK3.z).object({
    type: (0, $c3dK3.z).literal((0, $8lyC3.MfaFactor).BackupCode),
    ...$159409e551cf7347$export$45938720c8cd17da,
    codes: (0, $c3dK3.z).object({
        code: (0, $c3dK3.z).string(),
        usedAt: (0, $c3dK3.z).string().optional()
    }).array()
});
const $159409e551cf7347$export$e0149a7d7403659d = (0, $c3dK3.z).discriminatedUnion("type", [
    $159409e551cf7347$export$247de21853358ba3,
    $159409e551cf7347$export$d887df993511916c,
    $159409e551cf7347$export$b31bbb972ba29c41
]);
const $159409e551cf7347$export$cd58e15effbd05b2 = $159409e551cf7347$export$e0149a7d7403659d.array();

});
parcelRequire.register("oK7kD", function(module, exports) {
$parcel$export(module.exports, "configurableConnectorMetadataGuard", function () { return (parcelRequire("cIy8v")).configurableConnectorMetadataGuard; });
$parcel$export(module.exports, "ConnectorConfigFormItemType", function () { return (parcelRequire("bpo6r")).ConnectorConfigFormItemType; });
$parcel$export(module.exports, "ConnectorError", function () { return (parcelRequire("4tKex")).ConnectorError; });
$parcel$export(module.exports, "ConnectorErrorCodes", function () { return (parcelRequire("4tKex")).ConnectorErrorCodes; });
$parcel$export(module.exports, "connectorMetadataGuard", function () { return (parcelRequire("cIy8v")).connectorMetadataGuard; });
$parcel$export(module.exports, "ConnectorPlatform", function () { return (parcelRequire("cIy8v")).ConnectorPlatform; });
$parcel$export(module.exports, "ConnectorType", function () { return (parcelRequire("kowfT")).ConnectorType; });
$parcel$export(module.exports, "jsonGuard", function () { return (parcelRequire("j080Y")).jsonGuard; });
$parcel$export(module.exports, "jsonObjectGuard", function () { return (parcelRequire("j080Y")).jsonObjectGuard; });
$parcel$export(module.exports, "ServiceConnector", function () { return (parcelRequire("7YxsJ")).ServiceConnector; });
$parcel$export(module.exports, "socialUserInfoGuard", function () { return (parcelRequire("j080Y")).socialUserInfoGuard; });
$parcel$export(module.exports, "urlRegEx", function () { return (parcelRequire("9BaLv")).urlRegEx; });
parcelRequire("7YxsJ");
var $4tKex = parcelRequire("4tKex");
var $j080Y = parcelRequire("j080Y");
var $kowfT = parcelRequire("kowfT");
function $04a603eeaa25470f$export$127f9a442b42d18(config, guard) {
    const result = guard.safeParse(config);
    if (!result.success) throw new (0, $4tKex.ConnectorError)((0, $4tKex.ConnectorErrorCodes).InvalidConfig, result.error);
}
const $04a603eeaa25470f$export$18c43dcebf00e571 = (jsonString, errorCode = (0, $4tKex.ConnectorErrorCodes).InvalidResponse, errorPayload)=>{
    try {
        return (0, $j080Y.jsonGuard).parse(JSON.parse(jsonString));
    } catch  {
        throw new (0, $4tKex.ConnectorError)(errorCode, errorPayload ?? jsonString);
    }
};
const $04a603eeaa25470f$export$7b9340ca5373286 = (...[jsonString, errorCode = (0, $4tKex.ConnectorErrorCodes).InvalidResponse, errorPayload])=>{
    try {
        return (0, $j080Y.jsonObjectGuard).parse(JSON.parse(jsonString));
    } catch  {
        throw new (0, $4tKex.ConnectorError)(errorCode, errorPayload ?? jsonString);
    }
};
const $04a603eeaa25470f$export$4fe65911a1cf396d = "logto_mock_verification_code_record.txt";
const $04a603eeaa25470f$export$139964ce187c5e2 = Object.freeze({
    [(0, $kowfT.ConnectorType).Sms]: "/tmp/logto_mock_sms_record.txt",
    [(0, $kowfT.ConnectorType).Email]: "/tmp/logto_mock_email_record.txt"
});
const $04a603eeaa25470f$export$24f9fc31d5505892 = (template, payload)=>{
    return Object.keys(payload).reduce((accumulator, key)=>accumulator.replaceAll(new RegExp(`{{\\s*${key}\\s*}}`, "g"), payload[key] ?? ""), template);
};

});
parcelRequire.register("7YxsJ", function(module, exports) {
$parcel$export(module.exports, "ConnectorConfigFormItemType", function () { return (parcelRequire("bpo6r")).ConnectorConfigFormItemType; });
$parcel$export(module.exports, "ConnectorError", function () { return (parcelRequire("4tKex")).ConnectorError; });
$parcel$export(module.exports, "ConnectorErrorCodes", function () { return (parcelRequire("4tKex")).ConnectorErrorCodes; });
$parcel$export(module.exports, "configurableConnectorMetadataGuard", function () { return (parcelRequire("cIy8v")).configurableConnectorMetadataGuard; });
$parcel$export(module.exports, "connectorMetadataGuard", function () { return (parcelRequire("cIy8v")).connectorMetadataGuard; });
$parcel$export(module.exports, "ConnectorPlatform", function () { return (parcelRequire("cIy8v")).ConnectorPlatform; });
$parcel$export(module.exports, "ConnectorType", function () { return (parcelRequire("kowfT")).ConnectorType; });
$parcel$export(module.exports, "urlRegEx", function () { return (parcelRequire("9BaLv")).urlRegEx; });
$parcel$export(module.exports, "jsonGuard", function () { return (parcelRequire("j080Y")).jsonGuard; });
$parcel$export(module.exports, "jsonObjectGuard", function () { return (parcelRequire("j080Y")).jsonObjectGuard; });
$parcel$export(module.exports, "socialUserInfoGuard", function () { return (parcelRequire("j080Y")).socialUserInfoGuard; });

$parcel$export(module.exports, "ServiceConnector", function () { return $5ce817f073de8df3$export$59c1b079c431ef40; });
parcelRequire("bpo6r");
parcelRequire("4tKex");
parcelRequire("cIy8v");
parcelRequire("kowfT");
parcelRequire("9BaLv");
parcelRequire("j080Y");
var $5ce817f073de8df3$export$5dbd9b9b0aba9316;
(function(DemoConnector) {
    DemoConnector["Sms"] = "logto-sms";
    DemoConnector["Social"] = "logto-social-demo";
})($5ce817f073de8df3$export$5dbd9b9b0aba9316 || ($5ce817f073de8df3$export$5dbd9b9b0aba9316 = {}));
const $5ce817f073de8df3$export$a1fe89342af5f2bc = Object.freeze([
    $5ce817f073de8df3$export$5dbd9b9b0aba9316.Sms,
    $5ce817f073de8df3$export$5dbd9b9b0aba9316.Social
]);
var $5ce817f073de8df3$export$59c1b079c431ef40;
(function(ServiceConnector) {
    ServiceConnector["Email"] = "logto-email";
})($5ce817f073de8df3$export$59c1b079c431ef40 || ($5ce817f073de8df3$export$59c1b079c431ef40 = {}));
const $5ce817f073de8df3$export$4a0935744d2041a0 = Object.freeze([
    $5ce817f073de8df3$export$59c1b079c431ef40.Email
]);

});
parcelRequire.register("bpo6r", function(module, exports) {

$parcel$export(module.exports, "ConnectorConfigFormItemType", function () { return $84e4b9da309e1118$export$dc13b60e2521b1fc; });
$parcel$export(module.exports, "connectorConfigFormItemGuard", function () { return $84e4b9da309e1118$export$ee34796348b9598a; });

var $c3dK3 = parcelRequire("c3dK3");
var $84e4b9da309e1118$export$dc13b60e2521b1fc;
(function(ConnectorConfigFormItemType) {
    ConnectorConfigFormItemType["Text"] = "Text";
    ConnectorConfigFormItemType["Number"] = "Number";
    ConnectorConfigFormItemType["MultilineText"] = "MultilineText";
    ConnectorConfigFormItemType["Switch"] = "Switch";
    ConnectorConfigFormItemType["Select"] = "Select";
    ConnectorConfigFormItemType["Json"] = "Json";
})($84e4b9da309e1118$export$dc13b60e2521b1fc || ($84e4b9da309e1118$export$dc13b60e2521b1fc = {}));
const $84e4b9da309e1118$var$baseConfigFormItem = {
    key: (0, $c3dK3.z).string(),
    label: (0, $c3dK3.z).string(),
    placeholder: (0, $c3dK3.z).string().optional(),
    required: (0, $c3dK3.z).boolean().optional(),
    defaultValue: (0, $c3dK3.z).unknown().optional(),
    showConditions: (0, $c3dK3.z).array((0, $c3dK3.z).object({
        targetKey: (0, $c3dK3.z).string(),
        expectValue: (0, $c3dK3.z).unknown().optional()
    })).optional(),
    description: (0, $c3dK3.z).string().optional(),
    tooltip: (0, $c3dK3.z).string().optional(),
    isConfidential: (0, $c3dK3.z).boolean().optional()
};
const $84e4b9da309e1118$export$ee34796348b9598a = (0, $c3dK3.z).discriminatedUnion("type", [
    (0, $c3dK3.z).object({
        type: (0, $c3dK3.z).literal($84e4b9da309e1118$export$dc13b60e2521b1fc.Select),
        selectItems: (0, $c3dK3.z).array((0, $c3dK3.z).object({
            value: (0, $c3dK3.z).string(),
            title: (0, $c3dK3.z).string()
        })),
        ...$84e4b9da309e1118$var$baseConfigFormItem
    }),
    (0, $c3dK3.z).object({
        type: (0, $c3dK3.z).enum([
            $84e4b9da309e1118$export$dc13b60e2521b1fc.Text,
            $84e4b9da309e1118$export$dc13b60e2521b1fc.Number,
            $84e4b9da309e1118$export$dc13b60e2521b1fc.MultilineText,
            $84e4b9da309e1118$export$dc13b60e2521b1fc.Switch,
            $84e4b9da309e1118$export$dc13b60e2521b1fc.Json
        ]),
        ...$84e4b9da309e1118$var$baseConfigFormItem
    })
]);

});

parcelRequire.register("4tKex", function(module, exports) {

$parcel$export(module.exports, "ConnectorErrorCodes", function () { return $342dbbdf4c71f696$export$2ecd4a627c6913d4; });
$parcel$export(module.exports, "ConnectorError", function () { return $342dbbdf4c71f696$export$1a6b62c5b97f19bd; });
var $342dbbdf4c71f696$export$2ecd4a627c6913d4;
(function(ConnectorErrorCodes) {
    ConnectorErrorCodes["General"] = "general";
    ConnectorErrorCodes["InvalidMetadata"] = "invalid_metadata";
    ConnectorErrorCodes["UnexpectedType"] = "unexpected_type";
    ConnectorErrorCodes["InvalidConfigGuard"] = "invalid_config_guard";
    ConnectorErrorCodes["InvalidRequestParameters"] = "invalid_request_parameters";
    ConnectorErrorCodes["InsufficientRequestParameters"] = "insufficient_request_parameters";
    ConnectorErrorCodes["InvalidConfig"] = "invalid_config";
    ConnectorErrorCodes["InvalidCertificate"] = "invalid_certificate";
    ConnectorErrorCodes["InvalidResponse"] = "invalid_response";
    /** The template is not found for the given type. */ ConnectorErrorCodes["TemplateNotFound"] = "template_not_found";
    /**
     * The template type is not supported by the connector.
     *
     * @deprecated Connector should be able to handle dynamic template type.
     */ ConnectorErrorCodes["TemplateNotSupported"] = "template_not_supported";
    ConnectorErrorCodes["RateLimitExceeded"] = "rate_limit_exceeded";
    ConnectorErrorCodes["NotImplemented"] = "not_implemented";
    ConnectorErrorCodes["SocialAuthCodeInvalid"] = "social_auth_code_invalid";
    ConnectorErrorCodes["SocialAccessTokenInvalid"] = "social_invalid_access_token";
    ConnectorErrorCodes["SocialIdTokenInvalid"] = "social_invalid_id_token";
    ConnectorErrorCodes["AuthorizationFailed"] = "authorization_failed";
})($342dbbdf4c71f696$export$2ecd4a627c6913d4 || ($342dbbdf4c71f696$export$2ecd4a627c6913d4 = {}));
class $342dbbdf4c71f696$export$1a6b62c5b97f19bd extends Error {
    constructor(code, data){
        const message = `ConnectorError: ${data ? JSON.stringify(data) : code}`;
        super(message);
        this.code = code;
        this.data = typeof data === "string" ? {
            message: data
        } : data;
    }
}

});

parcelRequire.register("cIy8v", function(module, exports) {

$parcel$export(module.exports, "ConnectorPlatform", function () { return $942412d09dd98194$export$e2b8cfc001e78efb; });
$parcel$export(module.exports, "connectorMetadataGuard", function () { return $942412d09dd98194$export$f7d2da53d88c923c; });
$parcel$export(module.exports, "configurableConnectorMetadataGuard", function () { return $942412d09dd98194$export$155cba4e58565525; });
parcelRequire("hNGhh");
var $eRB1v = parcelRequire("eRB1v");

var $c3dK3 = parcelRequire("c3dK3");

var $bpo6r = parcelRequire("bpo6r");
var $942412d09dd98194$export$e2b8cfc001e78efb;
(function(ConnectorPlatform) {
    ConnectorPlatform["Native"] = "Native";
    ConnectorPlatform["Universal"] = "Universal";
    ConnectorPlatform["Web"] = "Web";
})($942412d09dd98194$export$e2b8cfc001e78efb || ($942412d09dd98194$export$e2b8cfc001e78efb = {}));
const $942412d09dd98194$export$7241e9f50f26948a = (0, $c3dK3.z).object({
    en: (0, $c3dK3.z).string()
}).and((0, $c3dK3.z).record((0, $c3dK3.z).string())).refine((i18nObject)=>{
    const keys = Object.keys(i18nObject);
    if (!keys.includes("en")) return false;
    for (const value of keys){
        if (!(0, $eRB1v.isLanguageTag)(value)) return false;
    }
    return true;
});
const $942412d09dd98194$export$7d252e66ae683236 = (0, $c3dK3.z).object({
    // Social connector platform. TODO: @darcyYe considering remove the nullable and make all the social connector field optional
    platform: (0, $c3dK3.z).nativeEnum($942412d09dd98194$export$e2b8cfc001e78efb).nullable(),
    // Indicates custom connector that follows standard protocol. Currently supported standard connectors are OIDC, OAuth2, and SAML2
    isStandard: (0, $c3dK3.z).boolean().optional()
});
const $942412d09dd98194$export$f7d2da53d88c923c = (0, $c3dK3.z).object({
    // Unique connector factory id
    id: (0, $c3dK3.z).string(),
    /* Connector provider. Unique for each provider. Users can have only one social identity per provider
      For Social connectors, it's manually set on connector creation
      For SSO connectors, it's the same as the issuer
    */ target: (0, $c3dK3.z).string(),
    name: $942412d09dd98194$export$7241e9f50f26948a,
    description: $942412d09dd98194$export$7241e9f50f26948a,
    logo: (0, $c3dK3.z).string(),
    logoDark: (0, $c3dK3.z).string().nullable(),
    readme: (0, $c3dK3.z).string(),
    configTemplate: (0, $c3dK3.z).string().optional(),
    formItems: (0, $bpo6r.connectorConfigFormItemGuard).array().optional()
}).merge($942412d09dd98194$export$7d252e66ae683236).catchall((0, $c3dK3.z).unknown());
const $942412d09dd98194$export$155cba4e58565525 = $942412d09dd98194$export$f7d2da53d88c923c.pick({
    target: true,
    name: true,
    logo: true,
    logoDark: true
}).partial();

});

parcelRequire.register("kowfT", function(module, exports) {

$parcel$export(module.exports, "ConnectorType", function () { return $ed8f11c218425c0a$export$18dbf40ba8d1d9db; });
var $ed8f11c218425c0a$export$18dbf40ba8d1d9db;
(function(ConnectorType) {
    ConnectorType["Email"] = "Email";
    ConnectorType["Sms"] = "Sms";
    ConnectorType["Social"] = "Social";
})($ed8f11c218425c0a$export$18dbf40ba8d1d9db || ($ed8f11c218425c0a$export$18dbf40ba8d1d9db = {}));

});

parcelRequire.register("9BaLv", function(module, exports) {

$parcel$export(module.exports, "urlRegEx", function () { return $6fcfeb812488efc4$export$51e0082496d4c1ff; });
// MARK: SMS + Email connector

var $c3dK3 = parcelRequire("c3dK3");
var $6fcfeb812488efc4$export$849d15400f87ce3f;
(function(VerificationCodeType) {
    VerificationCodeType["SignIn"] = "SignIn";
    VerificationCodeType["Register"] = "Register";
    VerificationCodeType["ForgotPassword"] = "ForgotPassword";
    VerificationCodeType["Generic"] = "Generic";
    /** @deprecated Use `Generic` type template for sending test sms/email use case */ VerificationCodeType["Test"] = "Test";
})($6fcfeb812488efc4$export$849d15400f87ce3f || ($6fcfeb812488efc4$export$849d15400f87ce3f = {}));
const $6fcfeb812488efc4$export$61cf650ef6de814a = (0, $c3dK3.z).nativeEnum($6fcfeb812488efc4$export$849d15400f87ce3f);
var $6fcfeb812488efc4$export$fd0446c06165ed92;
(function(TemplateType) {
    /** The template for sending verification code when user is signing in. */ TemplateType["SignIn"] = "SignIn";
    /** The template for sending verification code when user is registering. */ TemplateType["Register"] = "Register";
    /** The template for sending verification code when user is resetting password. */ TemplateType["ForgotPassword"] = "ForgotPassword";
    /** The template for sending organization invitation. */ TemplateType["OrganizationInvitation"] = "OrganizationInvitation";
    /** The template for generic usage. */ TemplateType["Generic"] = "Generic";
})($6fcfeb812488efc4$export$fd0446c06165ed92 || ($6fcfeb812488efc4$export$fd0446c06165ed92 = {}));
const $6fcfeb812488efc4$export$28d17db1e2f10761 = (0, $c3dK3.z).nativeEnum($6fcfeb812488efc4$export$fd0446c06165ed92);
const $6fcfeb812488efc4$export$f9b3e019678b784e = (0, $c3dK3.z).object({
    code: (0, $c3dK3.z).string().optional(),
    link: (0, $c3dK3.z).string().optional()
}).and((0, $c3dK3.z).record((0, $c3dK3.z).string()));
const $6fcfeb812488efc4$export$51e0082496d4c1ff = /(https?:\/\/)?(?:www\.)?[\w#%+.:=@~-]{1,256}\.[\d()A-Za-z]{1,6}\b[\w#%&()+./:=?@~-]*/;
const $6fcfeb812488efc4$export$21b1fc3b40375a1b = (0, $c3dK3.z).object({
    senderName: (0, $c3dK3.z).string().refine((address)=>!$6fcfeb812488efc4$export$51e0082496d4c1ff.test(address), "URL is not allowed in sender name."),
    companyInformation: (0, $c3dK3.z).string().refine((address)=>!$6fcfeb812488efc4$export$51e0082496d4c1ff.test(address), "URL is not allowed in company information."),
    appLogo: (0, $c3dK3.z).string().url()
}).partial();
const $6fcfeb812488efc4$export$d68193cee3e4f305 = (0, $c3dK3.z).object({
    to: (0, $c3dK3.z).string(),
    type: $6fcfeb812488efc4$export$28d17db1e2f10761.or($6fcfeb812488efc4$export$61cf650ef6de814a),
    payload: $6fcfeb812488efc4$export$f9b3e019678b784e
});

});

parcelRequire.register("j080Y", function(module, exports) {

$parcel$export(module.exports, "jsonGuard", function () { return $dd543bf63a17d940$export$80d8b5946da2a05e; });
$parcel$export(module.exports, "jsonObjectGuard", function () { return $dd543bf63a17d940$export$4ac62c0537cd0db7; });
$parcel$export(module.exports, "socialUserInfoGuard", function () { return $dd543bf63a17d940$export$3788bacea3bf0dba; });

var $c3dK3 = parcelRequire("c3dK3");
// Copied from https://github.com/colinhacks/zod#json-type
const $dd543bf63a17d940$var$literalSchema = (0, $c3dK3.z).union([
    (0, $c3dK3.z).string(),
    (0, $c3dK3.z).number(),
    (0, $c3dK3.z).boolean(),
    (0, $c3dK3.z).null()
]);
const $dd543bf63a17d940$export$80d8b5946da2a05e = (0, $c3dK3.z).lazy(()=>(0, $c3dK3.z).union([
        $dd543bf63a17d940$var$literalSchema,
        (0, $c3dK3.z).array($dd543bf63a17d940$export$80d8b5946da2a05e),
        (0, $c3dK3.z).record($dd543bf63a17d940$export$80d8b5946da2a05e)
    ]));
const $dd543bf63a17d940$export$4ac62c0537cd0db7 = (0, $c3dK3.z).record($dd543bf63a17d940$export$80d8b5946da2a05e);
const $dd543bf63a17d940$export$3788bacea3bf0dba = (0, $c3dK3.z).object({
    id: (0, $c3dK3.z).string(),
    email: (0, $c3dK3.z).string().optional(),
    phone: (0, $c3dK3.z).string().optional(),
    name: (0, $c3dK3.z).string().optional(),
    avatar: (0, $c3dK3.z).string().optional(),
    rawData: $dd543bf63a17d940$export$80d8b5946da2a05e.optional()
});
const $dd543bf63a17d940$export$d09576a05941985c = (0, $c3dK3.z).object({
    nonce: (0, $c3dK3.z).string(),
    redirectUri: (0, $c3dK3.z).string(),
    connectorId: (0, $c3dK3.z).string(),
    connectorFactoryId: (0, $c3dK3.z).string(),
    jti: (0, $c3dK3.z).string(),
    state: (0, $c3dK3.z).string()
}).partial()// Accept arbitrary unspecified keys so developers who can not publish @logto/connector-kit can more flexibly utilize connector session.
.catchall((0, $c3dK3.z).unknown());

});




parcelRequire.register("kupPr", function(module, exports) {

$parcel$export(module.exports, "ssoDomainsGuard", function () { return $eeaaa5020c14363d$export$d7a665f9067dd8f8; });
$parcel$export(module.exports, "ssoBrandingGuard", function () { return $eeaaa5020c14363d$export$363bdce991737de; });

var $c3dK3 = parcelRequire("c3dK3");
const $eeaaa5020c14363d$export$d7a665f9067dd8f8 = (0, $c3dK3.z).array((0, $c3dK3.z).string());
const $eeaaa5020c14363d$export$363bdce991737de = (0, $c3dK3.z).object({
    displayName: (0, $c3dK3.z).string().optional(),
    logo: (0, $c3dK3.z).string().optional(),
    darkLogo: (0, $c3dK3.z).string().optional()
});

});

parcelRequire.register("WxNQw", function(module, exports) {

$parcel$export(module.exports, "protectedAppMetadataGuard", function () { return $0affa375cf82cb9f$export$f7af996b28fe8992; });

var $c3dK3 = parcelRequire("c3dK3");

var $3zL0M = parcelRequire("3zL0M");
const $0affa375cf82cb9f$export$7cbc7e52a66572d6 = (0, $c3dK3.z).object({
    /* The domain name, e.g app.example.com */ domain: (0, $c3dK3.z).string(),
    /* The status of the domain in Cloudflare */ status: (0, $3zL0M.domainStatusGuard),
    /* The error message if any */ errorMessage: (0, $c3dK3.z).string().nullable(),
    /* The DNS records of the domain */ dnsRecords: (0, $3zL0M.domainDnsRecordsGuard),
    /* The remote Cloudflare data */ cloudflareData: (0, $3zL0M.cloudflareDataGuard).nullable()
});
const $0affa375cf82cb9f$export$dea254f43799108e = (0, $c3dK3.z).array($0affa375cf82cb9f$export$7cbc7e52a66572d6);
const $0affa375cf82cb9f$export$f7af996b28fe8992 = (0, $c3dK3.z).object({
    /* The host of the site */ host: (0, $c3dK3.z).string(),
    /* The origin of the site */ origin: (0, $c3dK3.z).string(),
    /* Session duration in seconds */ sessionDuration: (0, $c3dK3.z).number(),
    pageRules: (0, $c3dK3.z).array((0, $c3dK3.z).object({
        /* The path pattern (regex) to match */ path: (0, $c3dK3.z).string()
    })),
    /* Custom domain */ customDomains: $0affa375cf82cb9f$export$dea254f43799108e.optional()
});

});



parcelRequire.register("gh8Fv", function(module, exports) {
$parcel$export(module.exports, "ApplicationType", function () { return (parcelRequire("61Yml")).ApplicationType; });
$parcel$export(module.exports, "OrganizationInvitationStatus", function () { return (parcelRequire("61Yml")).OrganizationInvitationStatus; });
$parcel$export(module.exports, "RoleType", function () { return (parcelRequire("61Yml")).RoleType; });
$parcel$export(module.exports, "SignInMode", function () { return (parcelRequire("61Yml")).SignInMode; });
$parcel$export(module.exports, "ApplicationSignInExperiences", function () { return (parcelRequire("6jyLL")).ApplicationSignInExperiences; });
$parcel$export(module.exports, "Applications", function () { return (parcelRequire("4Ecj3")).Applications; });
$parcel$export(module.exports, "Connectors", function () { return (parcelRequire("LiHtu")).Connectors; });
$parcel$export(module.exports, "Domains", function () { return (parcelRequire("gYR9K")).Domains; });
$parcel$export(module.exports, "Hooks", function () { return (parcelRequire("jX6AI")).Hooks; });
$parcel$export(module.exports, "OrganizationInvitations", function () { return (parcelRequire("gkJkg")).OrganizationInvitations; });
$parcel$export(module.exports, "OrganizationRoles", function () { return (parcelRequire("a5feG")).OrganizationRoles; });
$parcel$export(module.exports, "OrganizationScopes", function () { return (parcelRequire("bPimI")).OrganizationScopes; });
$parcel$export(module.exports, "Organizations", function () { return (parcelRequire("bfvuB")).Organizations; });
$parcel$export(module.exports, "Resources", function () { return (parcelRequire("9Jr5u")).Resources; });
$parcel$export(module.exports, "Roles", function () { return (parcelRequire("5JzQP")).Roles; });
$parcel$export(module.exports, "Scopes", function () { return (parcelRequire("fidVk")).Scopes; });
$parcel$export(module.exports, "UserSsoIdentities", function () { return (parcelRequire("jXiNi")).UserSsoIdentities; });
$parcel$export(module.exports, "Users", function () { return (parcelRequire("ev8Fx")).Users; });
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
parcelRequire("61Yml");
parcelRequire("arOiY");
parcelRequire("gA2gC");
parcelRequire("1J2Ot");
parcelRequire("hIRFj");
parcelRequire("6jyLL");
parcelRequire("ddkd3");
parcelRequire("B8WUa");
parcelRequire("6bgwj");
parcelRequire("OLxX1");
parcelRequire("kyA3J");
parcelRequire("4Ecj3");
parcelRequire("7Dqx8");
parcelRequire("LiHtu");
parcelRequire("jsJQ1");
parcelRequire("27BCk");
parcelRequire("d8feH");
parcelRequire("gYR9K");
parcelRequire("jX6AI");
parcelRequire("kgrb0");
parcelRequire("1Kx34");
parcelRequire("3HKfA");
parcelRequire("gNCQv");
parcelRequire("gkJkg");
parcelRequire("apCLu");
parcelRequire("hpEJ6");
parcelRequire("7VsY7");
parcelRequire("a5feG");
parcelRequire("bPimI");
parcelRequire("kAkpc");
parcelRequire("bfvuB");
parcelRequire("1uDv4");
parcelRequire("9Jr5u");
parcelRequire("5JzQP");
parcelRequire("k9HTR");
parcelRequire("fidVk");
parcelRequire("cBOp0");
parcelRequire("kYkbC");
parcelRequire("4nX9k");
parcelRequire("oBypx");
parcelRequire("jDSNX");
parcelRequire("jXiNi");
parcelRequire("ev8Fx");
parcelRequire("dkWOS");
parcelRequire("2pe2S");

});
parcelRequire.register("61Yml", function(module, exports) {

$parcel$export(module.exports, "ApplicationType", function () { return $4641a830395a7193$export$d16f8fdf0c548b68; });
$parcel$export(module.exports, "OrganizationInvitationStatus", function () { return $4641a830395a7193$export$3ac4f2bb1c3a6ab6; });
$parcel$export(module.exports, "RoleType", function () { return $4641a830395a7193$export$e57c3ccf0ca02b45; });
$parcel$export(module.exports, "SentinelActionResult", function () { return $4641a830395a7193$export$dc6c7df092741a48; });
$parcel$export(module.exports, "SentinelDecision", function () { return $4641a830395a7193$export$418d76209f25e60e; });
$parcel$export(module.exports, "SignInMode", function () { return $4641a830395a7193$export$f927bbb3d448dc2b; });
$parcel$export(module.exports, "UsersPasswordEncryptionMethod", function () { return $4641a830395a7193$export$b3dbe23797267513; });
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
var $4641a830395a7193$export$d16f8fdf0c548b68;
(function(ApplicationType) {
    ApplicationType["Native"] = "Native";
    ApplicationType["SPA"] = "SPA";
    ApplicationType["Traditional"] = "Traditional";
    ApplicationType["MachineToMachine"] = "MachineToMachine";
    ApplicationType["Protected"] = "Protected";
})($4641a830395a7193$export$d16f8fdf0c548b68 || ($4641a830395a7193$export$d16f8fdf0c548b68 = {}));
var $4641a830395a7193$export$3ac4f2bb1c3a6ab6;
(function(OrganizationInvitationStatus) {
    OrganizationInvitationStatus["Pending"] = "Pending";
    OrganizationInvitationStatus["Accepted"] = "Accepted";
    OrganizationInvitationStatus["Expired"] = "Expired";
    OrganizationInvitationStatus["Revoked"] = "Revoked";
})($4641a830395a7193$export$3ac4f2bb1c3a6ab6 || ($4641a830395a7193$export$3ac4f2bb1c3a6ab6 = {}));
var $4641a830395a7193$export$e57c3ccf0ca02b45;
(function(RoleType) {
    RoleType["User"] = "User";
    RoleType["MachineToMachine"] = "MachineToMachine";
})($4641a830395a7193$export$e57c3ccf0ca02b45 || ($4641a830395a7193$export$e57c3ccf0ca02b45 = {}));
var $4641a830395a7193$export$dc6c7df092741a48;
(function(SentinelActionResult) {
    SentinelActionResult["Success"] = "Success";
    SentinelActionResult["Failed"] = "Failed";
})($4641a830395a7193$export$dc6c7df092741a48 || ($4641a830395a7193$export$dc6c7df092741a48 = {}));
var $4641a830395a7193$export$418d76209f25e60e;
(function(SentinelDecision) {
    SentinelDecision["Undecided"] = "Undecided";
    SentinelDecision["Allowed"] = "Allowed";
    SentinelDecision["Blocked"] = "Blocked";
    SentinelDecision["Challenge"] = "Challenge";
})($4641a830395a7193$export$418d76209f25e60e || ($4641a830395a7193$export$418d76209f25e60e = {}));
var $4641a830395a7193$export$f927bbb3d448dc2b;
(function(SignInMode) {
    SignInMode["SignIn"] = "SignIn";
    SignInMode["Register"] = "Register";
    SignInMode["SignInAndRegister"] = "SignInAndRegister";
})($4641a830395a7193$export$f927bbb3d448dc2b || ($4641a830395a7193$export$f927bbb3d448dc2b = {}));
var $4641a830395a7193$export$b3dbe23797267513;
(function(UsersPasswordEncryptionMethod) {
    UsersPasswordEncryptionMethod["Argon2i"] = "Argon2i";
    UsersPasswordEncryptionMethod["SHA1"] = "SHA1";
    UsersPasswordEncryptionMethod["SHA256"] = "SHA256";
    UsersPasswordEncryptionMethod["MD5"] = "MD5";
    UsersPasswordEncryptionMethod["Bcrypt"] = "Bcrypt";
})($4641a830395a7193$export$b3dbe23797267513 || ($4641a830395a7193$export$b3dbe23797267513 = {}));

});

parcelRequire.register("arOiY", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

});

parcelRequire.register("gA2gC", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

});

parcelRequire.register("1J2Ot", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

});

parcelRequire.register("hIRFj", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

});

parcelRequire.register("6jyLL", function(module, exports) {

$parcel$export(module.exports, "ApplicationSignInExperiences", function () { return $498f7ce10223edbf$export$b21e17c60fe7d89c; });
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
parcelRequire("5Fb6p");
var $8lyC3 = parcelRequire("8lyC3");
const $498f7ce10223edbf$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    applicationId: (0, $c3dK3.z).string().min(1).max(21),
    branding: (0, $8lyC3.brandingGuard).optional(),
    termsOfUseUrl: (0, $c3dK3.z).string().max(2048).nullable().optional(),
    privacyPolicyUrl: (0, $c3dK3.z).string().max(2048).nullable().optional(),
    displayName: (0, $c3dK3.z).string().max(256).nullable().optional()
});
const $498f7ce10223edbf$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    applicationId: (0, $c3dK3.z).string().min(1).max(21),
    branding: (0, $8lyC3.brandingGuard),
    termsOfUseUrl: (0, $c3dK3.z).string().max(2048).nullable(),
    privacyPolicyUrl: (0, $c3dK3.z).string().max(2048).nullable(),
    displayName: (0, $c3dK3.z).string().max(256).nullable()
});
const $498f7ce10223edbf$export$b21e17c60fe7d89c = Object.freeze({
    table: "application_sign_in_experiences",
    tableSingular: "application_sign_in_experience",
    fields: {
        tenantId: "tenant_id",
        applicationId: "application_id",
        branding: "branding",
        termsOfUseUrl: "terms_of_use_url",
        privacyPolicyUrl: "privacy_policy_url",
        displayName: "display_name"
    },
    fieldKeys: [
        "tenantId",
        "applicationId",
        "branding",
        "termsOfUseUrl",
        "privacyPolicyUrl",
        "displayName"
    ],
    createGuard: $498f7ce10223edbf$var$createGuard,
    guard: $498f7ce10223edbf$var$guard,
    updateGuard: $498f7ce10223edbf$var$guard.partial()
});

});

parcelRequire.register("ddkd3", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
const $99ec2a71f4f0f8b3$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    applicationId: (0, $c3dK3.z).string().min(1).max(21),
    scopeId: (0, $c3dK3.z).string().min(1).max(21)
});
const $99ec2a71f4f0f8b3$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    applicationId: (0, $c3dK3.z).string().min(1).max(21),
    scopeId: (0, $c3dK3.z).string().min(1).max(21)
});
const $99ec2a71f4f0f8b3$export$e949b56fbcc38220 = Object.freeze({
    table: "application_user_consent_organization_resource_scopes",
    tableSingular: "application_user_consent_organization_resource_scope",
    fields: {
        tenantId: "tenant_id",
        applicationId: "application_id",
        scopeId: "scope_id"
    },
    fieldKeys: [
        "tenantId",
        "applicationId",
        "scopeId"
    ],
    createGuard: $99ec2a71f4f0f8b3$var$createGuard,
    guard: $99ec2a71f4f0f8b3$var$guard,
    updateGuard: $99ec2a71f4f0f8b3$var$guard.partial()
});

});

parcelRequire.register("B8WUa", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
const $06fa65eab7f82c6c$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    applicationId: (0, $c3dK3.z).string().min(1).max(21),
    organizationScopeId: (0, $c3dK3.z).string().min(1).max(21)
});
const $06fa65eab7f82c6c$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    applicationId: (0, $c3dK3.z).string().min(1).max(21),
    organizationScopeId: (0, $c3dK3.z).string().min(1).max(21)
});
const $06fa65eab7f82c6c$export$cc7d7eb8b2d4c88f = Object.freeze({
    table: "application_user_consent_organization_scopes",
    tableSingular: "application_user_consent_organization_scope",
    fields: {
        tenantId: "tenant_id",
        applicationId: "application_id",
        organizationScopeId: "organization_scope_id"
    },
    fieldKeys: [
        "tenantId",
        "applicationId",
        "organizationScopeId"
    ],
    createGuard: $06fa65eab7f82c6c$var$createGuard,
    guard: $06fa65eab7f82c6c$var$guard,
    updateGuard: $06fa65eab7f82c6c$var$guard.partial()
});

});

parcelRequire.register("6bgwj", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
const $480095bad58accf1$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    applicationId: (0, $c3dK3.z).string().min(1).max(21),
    organizationId: (0, $c3dK3.z).string().min(1).max(21),
    userId: (0, $c3dK3.z).string().min(1).max(21)
});
const $480095bad58accf1$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    applicationId: (0, $c3dK3.z).string().min(1).max(21),
    organizationId: (0, $c3dK3.z).string().min(1).max(21),
    userId: (0, $c3dK3.z).string().min(1).max(21)
});
const $480095bad58accf1$export$1477f056ed289a93 = Object.freeze({
    table: "application_user_consent_organizations",
    tableSingular: "application_user_consent_organization",
    fields: {
        tenantId: "tenant_id",
        applicationId: "application_id",
        organizationId: "organization_id",
        userId: "user_id"
    },
    fieldKeys: [
        "tenantId",
        "applicationId",
        "organizationId",
        "userId"
    ],
    createGuard: $480095bad58accf1$var$createGuard,
    guard: $480095bad58accf1$var$guard,
    updateGuard: $480095bad58accf1$var$guard.partial()
});

});

parcelRequire.register("OLxX1", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
const $09898d63e0911053$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    applicationId: (0, $c3dK3.z).string().min(1).max(21),
    scopeId: (0, $c3dK3.z).string().min(1).max(21)
});
const $09898d63e0911053$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    applicationId: (0, $c3dK3.z).string().min(1).max(21),
    scopeId: (0, $c3dK3.z).string().min(1).max(21)
});
const $09898d63e0911053$export$5961a9d1caf5eb5f = Object.freeze({
    table: "application_user_consent_resource_scopes",
    tableSingular: "application_user_consent_resource_scope",
    fields: {
        tenantId: "tenant_id",
        applicationId: "application_id",
        scopeId: "scope_id"
    },
    fieldKeys: [
        "tenantId",
        "applicationId",
        "scopeId"
    ],
    createGuard: $09898d63e0911053$var$createGuard,
    guard: $09898d63e0911053$var$guard,
    updateGuard: $09898d63e0911053$var$guard.partial()
});

});

parcelRequire.register("kyA3J", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
const $ef72f43dc3810f4f$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    applicationId: (0, $c3dK3.z).string().min(1).max(21),
    userScope: (0, $c3dK3.z).string().min(1).max(64)
});
const $ef72f43dc3810f4f$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    applicationId: (0, $c3dK3.z).string().min(1).max(21),
    userScope: (0, $c3dK3.z).string().min(1).max(64)
});
const $ef72f43dc3810f4f$export$23c1519812ac7ae7 = Object.freeze({
    table: "application_user_consent_user_scopes",
    tableSingular: "application_user_consent_user_scope",
    fields: {
        tenantId: "tenant_id",
        applicationId: "application_id",
        userScope: "user_scope"
    },
    fieldKeys: [
        "tenantId",
        "applicationId",
        "userScope"
    ],
    createGuard: $ef72f43dc3810f4f$var$createGuard,
    guard: $ef72f43dc3810f4f$var$guard,
    updateGuard: $ef72f43dc3810f4f$var$guard.partial()
});

});

parcelRequire.register("4Ecj3", function(module, exports) {

$parcel$export(module.exports, "Applications", function () { return $362471a4406b096a$export$73c91b53927e421e; });
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
parcelRequire("5Fb6p");
var $ZBK3w = parcelRequire("ZBK3w");
var $WxNQw = parcelRequire("WxNQw");

var $61Yml = parcelRequire("61Yml");
const $362471a4406b096a$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    id: (0, $c3dK3.z).string().min(1).max(21),
    name: (0, $c3dK3.z).string().min(1).max(256),
    secret: (0, $c3dK3.z).string().min(1).max(64),
    description: (0, $c3dK3.z).string().nullable().optional(),
    type: (0, $c3dK3.z).nativeEnum((0, $61Yml.ApplicationType)),
    oidcClientMetadata: (0, $ZBK3w.oidcClientMetadataGuard),
    customClientMetadata: (0, $ZBK3w.customClientMetadataGuard).optional(),
    protectedAppMetadata: (0, $WxNQw.protectedAppMetadataGuard).nullable().optional(),
    isThirdParty: (0, $c3dK3.z).boolean().optional(),
    createdAt: (0, $c3dK3.z).number().optional()
});
const $362471a4406b096a$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    id: (0, $c3dK3.z).string().min(1).max(21),
    name: (0, $c3dK3.z).string().min(1).max(256),
    secret: (0, $c3dK3.z).string().min(1).max(64),
    description: (0, $c3dK3.z).string().nullable(),
    type: (0, $c3dK3.z).nativeEnum((0, $61Yml.ApplicationType)),
    oidcClientMetadata: (0, $ZBK3w.oidcClientMetadataGuard),
    customClientMetadata: (0, $ZBK3w.customClientMetadataGuard),
    protectedAppMetadata: (0, $WxNQw.protectedAppMetadataGuard).nullable(),
    isThirdParty: (0, $c3dK3.z).boolean(),
    createdAt: (0, $c3dK3.z).number()
});
const $362471a4406b096a$export$73c91b53927e421e = Object.freeze({
    table: "applications",
    tableSingular: "application",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        name: "name",
        secret: "secret",
        description: "description",
        type: "type",
        oidcClientMetadata: "oidc_client_metadata",
        customClientMetadata: "custom_client_metadata",
        protectedAppMetadata: "protected_app_metadata",
        isThirdParty: "is_third_party",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "name",
        "secret",
        "description",
        "type",
        "oidcClientMetadata",
        "customClientMetadata",
        "protectedAppMetadata",
        "isThirdParty",
        "createdAt"
    ],
    createGuard: $362471a4406b096a$var$createGuard,
    guard: $362471a4406b096a$var$guard,
    updateGuard: $362471a4406b096a$var$guard.partial()
});

});

parcelRequire.register("7Dqx8", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
const $58f0c1e8eb4607eb$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    id: (0, $c3dK3.z).string().min(1).max(21),
    applicationId: (0, $c3dK3.z).string().min(1).max(21),
    roleId: (0, $c3dK3.z).string().min(1).max(21)
});
const $58f0c1e8eb4607eb$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    id: (0, $c3dK3.z).string().min(1).max(21),
    applicationId: (0, $c3dK3.z).string().min(1).max(21),
    roleId: (0, $c3dK3.z).string().min(1).max(21)
});
const $58f0c1e8eb4607eb$export$9e9228a1487950f9 = Object.freeze({
    table: "applications_roles",
    tableSingular: "applications_role",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        applicationId: "application_id",
        roleId: "role_id"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "applicationId",
        "roleId"
    ],
    createGuard: $58f0c1e8eb4607eb$var$createGuard,
    guard: $58f0c1e8eb4607eb$var$guard,
    updateGuard: $58f0c1e8eb4607eb$var$guard.partial()
});

});

parcelRequire.register("LiHtu", function(module, exports) {

$parcel$export(module.exports, "Connectors", function () { return $08e2e55f2cfe7157$export$87ce1179d2402b5a; });
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
parcelRequire("5Fb6p");
var $j080Y = parcelRequire("j080Y");
var $cIy8v = parcelRequire("cIy8v");
const $08e2e55f2cfe7157$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    id: (0, $c3dK3.z).string().min(1).max(128),
    syncProfile: (0, $c3dK3.z).boolean().optional(),
    connectorId: (0, $c3dK3.z).string().min(1).max(128),
    config: (0, $j080Y.jsonObjectGuard).optional(),
    metadata: (0, $cIy8v.configurableConnectorMetadataGuard).optional(),
    createdAt: (0, $c3dK3.z).number().optional()
});
const $08e2e55f2cfe7157$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    id: (0, $c3dK3.z).string().min(1).max(128),
    syncProfile: (0, $c3dK3.z).boolean(),
    connectorId: (0, $c3dK3.z).string().min(1).max(128),
    config: (0, $j080Y.jsonObjectGuard),
    metadata: (0, $cIy8v.configurableConnectorMetadataGuard),
    createdAt: (0, $c3dK3.z).number()
});
const $08e2e55f2cfe7157$export$87ce1179d2402b5a = Object.freeze({
    table: "connectors",
    tableSingular: "connector",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        syncProfile: "sync_profile",
        connectorId: "connector_id",
        config: "config",
        metadata: "metadata",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "syncProfile",
        "connectorId",
        "config",
        "metadata",
        "createdAt"
    ],
    createGuard: $08e2e55f2cfe7157$var$createGuard,
    guard: $08e2e55f2cfe7157$var$guard,
    updateGuard: $08e2e55f2cfe7157$var$guard.partial()
});

});

parcelRequire.register("jsJQ1", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
parcelRequire("5Fb6p");
var $cqPmz = parcelRequire("cqPmz");
const $e2b43056f9bca167$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    id: (0, $c3dK3.z).string().min(1).max(21),
    languageTag: (0, $c3dK3.z).string().min(1).max(16),
    translation: (0, $cqPmz.translationGuard)
});
const $e2b43056f9bca167$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    id: (0, $c3dK3.z).string().min(1).max(21),
    languageTag: (0, $c3dK3.z).string().min(1).max(16),
    translation: (0, $cqPmz.translationGuard)
});
const $e2b43056f9bca167$export$68f045a468761c0e = Object.freeze({
    table: "custom_phrases",
    tableSingular: "custom_phrase",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        languageTag: "language_tag",
        translation: "translation"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "languageTag",
        "translation"
    ],
    createGuard: $e2b43056f9bca167$var$createGuard,
    guard: $e2b43056f9bca167$var$guard,
    updateGuard: $e2b43056f9bca167$var$guard.partial()
});

});

parcelRequire.register("27BCk", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
const $18b96a343ce151d7$var$createGuard = (0, $c3dK3.z).object({
    id: (0, $c3dK3.z).string().min(1).max(21),
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    userId: (0, $c3dK3.z).string().min(1).max(21),
    date: (0, $c3dK3.z).number().optional()
});
const $18b96a343ce151d7$var$guard = (0, $c3dK3.z).object({
    id: (0, $c3dK3.z).string().min(1).max(21),
    tenantId: (0, $c3dK3.z).string().max(21),
    userId: (0, $c3dK3.z).string().min(1).max(21),
    date: (0, $c3dK3.z).number()
});
const $18b96a343ce151d7$export$d153bb698683b0a7 = Object.freeze({
    table: "daily_active_users",
    tableSingular: "daily_active_user",
    fields: {
        id: "id",
        tenantId: "tenant_id",
        userId: "user_id",
        date: "date"
    },
    fieldKeys: [
        "id",
        "tenantId",
        "userId",
        "date"
    ],
    createGuard: $18b96a343ce151d7$var$createGuard,
    guard: $18b96a343ce151d7$var$guard,
    updateGuard: $18b96a343ce151d7$var$guard.partial()
});

});

parcelRequire.register("d8feH", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
const $98f7d74419dd0949$var$createGuard = (0, $c3dK3.z).object({
    id: (0, $c3dK3.z).string().min(1).max(21),
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    usage: (0, $c3dK3.z).number().optional(),
    date: (0, $c3dK3.z).number()
});
const $98f7d74419dd0949$var$guard = (0, $c3dK3.z).object({
    id: (0, $c3dK3.z).string().min(1).max(21),
    tenantId: (0, $c3dK3.z).string().max(21),
    usage: (0, $c3dK3.z).number(),
    date: (0, $c3dK3.z).number()
});
const $98f7d74419dd0949$export$46dadcefc3469961 = Object.freeze({
    table: "daily_token_usage",
    tableSingular: "daily_token_usage",
    fields: {
        id: "id",
        tenantId: "tenant_id",
        usage: "usage",
        date: "date"
    },
    fieldKeys: [
        "id",
        "tenantId",
        "usage",
        "date"
    ],
    createGuard: $98f7d74419dd0949$var$createGuard,
    guard: $98f7d74419dd0949$var$guard,
    updateGuard: $98f7d74419dd0949$var$guard.partial()
});

});

parcelRequire.register("gYR9K", function(module, exports) {

$parcel$export(module.exports, "Domains", function () { return $c5cb7bae3903a69d$export$e3e9d7fdf7b67caa; });
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
parcelRequire("5Fb6p");
var $3zL0M = parcelRequire("3zL0M");
const $c5cb7bae3903a69d$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    id: (0, $c3dK3.z).string().min(1).max(21),
    domain: (0, $c3dK3.z).string().min(1).max(256),
    status: (0, $3zL0M.domainStatusGuard).optional(),
    errorMessage: (0, $c3dK3.z).string().max(1024).nullable().optional(),
    dnsRecords: (0, $3zL0M.domainDnsRecordsGuard).optional(),
    cloudflareData: (0, $3zL0M.cloudflareDataGuard).nullable().optional(),
    updatedAt: (0, $c3dK3.z).number().optional(),
    createdAt: (0, $c3dK3.z).number().optional()
});
const $c5cb7bae3903a69d$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    id: (0, $c3dK3.z).string().min(1).max(21),
    domain: (0, $c3dK3.z).string().min(1).max(256),
    status: (0, $3zL0M.domainStatusGuard),
    errorMessage: (0, $c3dK3.z).string().max(1024).nullable(),
    dnsRecords: (0, $3zL0M.domainDnsRecordsGuard),
    cloudflareData: (0, $3zL0M.cloudflareDataGuard).nullable(),
    updatedAt: (0, $c3dK3.z).number(),
    createdAt: (0, $c3dK3.z).number()
});
const $c5cb7bae3903a69d$export$e3e9d7fdf7b67caa = Object.freeze({
    table: "domains",
    tableSingular: "domain",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        domain: "domain",
        status: "status",
        errorMessage: "error_message",
        dnsRecords: "dns_records",
        cloudflareData: "cloudflare_data",
        updatedAt: "updated_at",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "domain",
        "status",
        "errorMessage",
        "dnsRecords",
        "cloudflareData",
        "updatedAt",
        "createdAt"
    ],
    createGuard: $c5cb7bae3903a69d$var$createGuard,
    guard: $c5cb7bae3903a69d$var$guard,
    updateGuard: $c5cb7bae3903a69d$var$guard.partial()
});

});

parcelRequire.register("jX6AI", function(module, exports) {

$parcel$export(module.exports, "Hooks", function () { return $e868a3e642ebfec6$export$5fbefe39e79899a6; });
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
parcelRequire("5Fb6p");
var $7CUeL = parcelRequire("7CUeL");
const $e868a3e642ebfec6$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    id: (0, $c3dK3.z).string().min(1).max(21),
    name: (0, $c3dK3.z).string().min(1).max(256).optional(),
    event: (0, $7CUeL.hookEventGuard).nullable().optional(),
    events: (0, $7CUeL.hookEventsGuard).optional(),
    config: (0, $7CUeL.hookConfigGuard),
    signingKey: (0, $c3dK3.z).string().min(1).max(64).optional(),
    enabled: (0, $c3dK3.z).boolean().optional(),
    createdAt: (0, $c3dK3.z).number().optional()
});
const $e868a3e642ebfec6$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    id: (0, $c3dK3.z).string().min(1).max(21),
    name: (0, $c3dK3.z).string().max(256),
    event: (0, $7CUeL.hookEventGuard).nullable(),
    events: (0, $7CUeL.hookEventsGuard),
    config: (0, $7CUeL.hookConfigGuard),
    signingKey: (0, $c3dK3.z).string().max(64),
    enabled: (0, $c3dK3.z).boolean(),
    createdAt: (0, $c3dK3.z).number()
});
const $e868a3e642ebfec6$export$5fbefe39e79899a6 = Object.freeze({
    table: "hooks",
    tableSingular: "hook",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        name: "name",
        event: "event",
        events: "events",
        config: "config",
        signingKey: "signing_key",
        enabled: "enabled",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "name",
        "event",
        "events",
        "config",
        "signingKey",
        "enabled",
        "createdAt"
    ],
    createGuard: $e868a3e642ebfec6$var$createGuard,
    guard: $e868a3e642ebfec6$var$guard,
    updateGuard: $e868a3e642ebfec6$var$guard.partial()
});

});

parcelRequire.register("kgrb0", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
parcelRequire("5Fb6p");
var $7GyLL = parcelRequire("7GyLL");
const $ec0a61fbaca980ef$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    id: (0, $c3dK3.z).string().min(1).max(21),
    key: (0, $c3dK3.z).string().min(1).max(128),
    payload: (0, $7GyLL.logContextPayloadGuard).optional(),
    createdAt: (0, $c3dK3.z).number().optional()
});
const $ec0a61fbaca980ef$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    id: (0, $c3dK3.z).string().min(1).max(21),
    key: (0, $c3dK3.z).string().min(1).max(128),
    payload: (0, $7GyLL.logContextPayloadGuard),
    createdAt: (0, $c3dK3.z).number()
});
const $ec0a61fbaca980ef$export$55c65d61db3da5ca = Object.freeze({
    table: "logs",
    tableSingular: "log",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        key: "key",
        payload: "payload",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "key",
        "payload",
        "createdAt"
    ],
    createGuard: $ec0a61fbaca980ef$var$createGuard,
    guard: $ec0a61fbaca980ef$var$guard,
    updateGuard: $ec0a61fbaca980ef$var$guard.partial()
});

});

parcelRequire.register("1Kx34", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
parcelRequire("5Fb6p");
var $j080Y = parcelRequire("j080Y");
const $1463b915e3ff7125$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    key: (0, $c3dK3.z).string().min(1).max(256),
    value: (0, $j080Y.jsonGuard).optional()
});
const $1463b915e3ff7125$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    key: (0, $c3dK3.z).string().min(1).max(256),
    value: (0, $j080Y.jsonGuard)
});
const $1463b915e3ff7125$export$d95c9c1f4b55e315 = Object.freeze({
    table: "logto_configs",
    tableSingular: "logto_config",
    fields: {
        tenantId: "tenant_id",
        key: "key",
        value: "value"
    },
    fieldKeys: [
        "tenantId",
        "key",
        "value"
    ],
    createGuard: $1463b915e3ff7125$var$createGuard,
    guard: $1463b915e3ff7125$var$guard,
    updateGuard: $1463b915e3ff7125$var$guard.partial()
});

});

parcelRequire.register("3HKfA", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
parcelRequire("5Fb6p");
var $ZBK3w = parcelRequire("ZBK3w");
const $2b2943996d394b00$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    modelName: (0, $c3dK3.z).string().min(1).max(64),
    id: (0, $c3dK3.z).string().min(1).max(128),
    payload: (0, $ZBK3w.oidcModelInstancePayloadGuard),
    expiresAt: (0, $c3dK3.z).number(),
    consumedAt: (0, $c3dK3.z).number().nullable().optional()
});
const $2b2943996d394b00$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    modelName: (0, $c3dK3.z).string().min(1).max(64),
    id: (0, $c3dK3.z).string().min(1).max(128),
    payload: (0, $ZBK3w.oidcModelInstancePayloadGuard),
    expiresAt: (0, $c3dK3.z).number(),
    consumedAt: (0, $c3dK3.z).number().nullable()
});
const $2b2943996d394b00$export$4825f32a2bacdbff = Object.freeze({
    table: "oidc_model_instances",
    tableSingular: "oidc_model_instance",
    fields: {
        tenantId: "tenant_id",
        modelName: "model_name",
        id: "id",
        payload: "payload",
        expiresAt: "expires_at",
        consumedAt: "consumed_at"
    },
    fieldKeys: [
        "tenantId",
        "modelName",
        "id",
        "payload",
        "expiresAt",
        "consumedAt"
    ],
    createGuard: $2b2943996d394b00$var$createGuard,
    guard: $2b2943996d394b00$var$guard,
    updateGuard: $2b2943996d394b00$var$guard.partial()
});

});

parcelRequire.register("gNCQv", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
const $c3af5ae94f2bcce8$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    organizationInvitationId: (0, $c3dK3.z).string().min(1).max(21),
    organizationRoleId: (0, $c3dK3.z).string().min(1).max(21)
});
const $c3af5ae94f2bcce8$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    organizationInvitationId: (0, $c3dK3.z).string().min(1).max(21),
    organizationRoleId: (0, $c3dK3.z).string().min(1).max(21)
});
const $c3af5ae94f2bcce8$export$fc376a4cb789d28e = Object.freeze({
    table: "organization_invitation_role_relations",
    tableSingular: "organization_invitation_role_relation",
    fields: {
        tenantId: "tenant_id",
        organizationInvitationId: "organization_invitation_id",
        organizationRoleId: "organization_role_id"
    },
    fieldKeys: [
        "tenantId",
        "organizationInvitationId",
        "organizationRoleId"
    ],
    createGuard: $c3af5ae94f2bcce8$var$createGuard,
    guard: $c3af5ae94f2bcce8$var$guard,
    updateGuard: $c3af5ae94f2bcce8$var$guard.partial()
});

});

parcelRequire.register("gkJkg", function(module, exports) {

$parcel$export(module.exports, "OrganizationInvitations", function () { return $be41ac5814f364ed$export$63fd293d5536b534; });
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");

var $61Yml = parcelRequire("61Yml");
const $be41ac5814f364ed$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    id: (0, $c3dK3.z).string().min(1).max(21),
    inviterId: (0, $c3dK3.z).string().max(21).nullable().optional(),
    invitee: (0, $c3dK3.z).string().min(1).max(256),
    acceptedUserId: (0, $c3dK3.z).string().max(21).nullable().optional(),
    organizationId: (0, $c3dK3.z).string().min(1).max(21),
    status: (0, $c3dK3.z).nativeEnum((0, $61Yml.OrganizationInvitationStatus)),
    createdAt: (0, $c3dK3.z).number().optional(),
    updatedAt: (0, $c3dK3.z).number().optional(),
    expiresAt: (0, $c3dK3.z).number()
});
const $be41ac5814f364ed$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    id: (0, $c3dK3.z).string().min(1).max(21),
    inviterId: (0, $c3dK3.z).string().max(21).nullable(),
    invitee: (0, $c3dK3.z).string().min(1).max(256),
    acceptedUserId: (0, $c3dK3.z).string().max(21).nullable(),
    organizationId: (0, $c3dK3.z).string().min(1).max(21),
    status: (0, $c3dK3.z).nativeEnum((0, $61Yml.OrganizationInvitationStatus)),
    createdAt: (0, $c3dK3.z).number(),
    updatedAt: (0, $c3dK3.z).number(),
    expiresAt: (0, $c3dK3.z).number()
});
const $be41ac5814f364ed$export$63fd293d5536b534 = Object.freeze({
    table: "organization_invitations",
    tableSingular: "organization_invitation",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        inviterId: "inviter_id",
        invitee: "invitee",
        acceptedUserId: "accepted_user_id",
        organizationId: "organization_id",
        status: "status",
        createdAt: "created_at",
        updatedAt: "updated_at",
        expiresAt: "expires_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "inviterId",
        "invitee",
        "acceptedUserId",
        "organizationId",
        "status",
        "createdAt",
        "updatedAt",
        "expiresAt"
    ],
    createGuard: $be41ac5814f364ed$var$createGuard,
    guard: $be41ac5814f364ed$var$guard,
    updateGuard: $be41ac5814f364ed$var$guard.partial()
});

});

parcelRequire.register("apCLu", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
const $794a4f18abcb3624$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    organizationRoleId: (0, $c3dK3.z).string().min(1).max(21),
    scopeId: (0, $c3dK3.z).string().min(1).max(21)
});
const $794a4f18abcb3624$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    organizationRoleId: (0, $c3dK3.z).string().min(1).max(21),
    scopeId: (0, $c3dK3.z).string().min(1).max(21)
});
const $794a4f18abcb3624$export$7d2c2ca29d23087b = Object.freeze({
    table: "organization_role_resource_scope_relations",
    tableSingular: "organization_role_resource_scope_relation",
    fields: {
        tenantId: "tenant_id",
        organizationRoleId: "organization_role_id",
        scopeId: "scope_id"
    },
    fieldKeys: [
        "tenantId",
        "organizationRoleId",
        "scopeId"
    ],
    createGuard: $794a4f18abcb3624$var$createGuard,
    guard: $794a4f18abcb3624$var$guard,
    updateGuard: $794a4f18abcb3624$var$guard.partial()
});

});

parcelRequire.register("hpEJ6", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
const $cad45ceafa1b20b3$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    organizationRoleId: (0, $c3dK3.z).string().min(1).max(21),
    organizationScopeId: (0, $c3dK3.z).string().min(1).max(21)
});
const $cad45ceafa1b20b3$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    organizationRoleId: (0, $c3dK3.z).string().min(1).max(21),
    organizationScopeId: (0, $c3dK3.z).string().min(1).max(21)
});
const $cad45ceafa1b20b3$export$3c85c8a4a8d43867 = Object.freeze({
    table: "organization_role_scope_relations",
    tableSingular: "organization_role_scope_relation",
    fields: {
        tenantId: "tenant_id",
        organizationRoleId: "organization_role_id",
        organizationScopeId: "organization_scope_id"
    },
    fieldKeys: [
        "tenantId",
        "organizationRoleId",
        "organizationScopeId"
    ],
    createGuard: $cad45ceafa1b20b3$var$createGuard,
    guard: $cad45ceafa1b20b3$var$guard,
    updateGuard: $cad45ceafa1b20b3$var$guard.partial()
});

});

parcelRequire.register("7VsY7", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
const $5c5453da66466ee3$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    organizationId: (0, $c3dK3.z).string().min(1).max(21),
    organizationRoleId: (0, $c3dK3.z).string().min(1).max(21),
    userId: (0, $c3dK3.z).string().min(1).max(21)
});
const $5c5453da66466ee3$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    organizationId: (0, $c3dK3.z).string().min(1).max(21),
    organizationRoleId: (0, $c3dK3.z).string().min(1).max(21),
    userId: (0, $c3dK3.z).string().min(1).max(21)
});
const $5c5453da66466ee3$export$92d9ab4d1ade1798 = Object.freeze({
    table: "organization_role_user_relations",
    tableSingular: "organization_role_user_relation",
    fields: {
        tenantId: "tenant_id",
        organizationId: "organization_id",
        organizationRoleId: "organization_role_id",
        userId: "user_id"
    },
    fieldKeys: [
        "tenantId",
        "organizationId",
        "organizationRoleId",
        "userId"
    ],
    createGuard: $5c5453da66466ee3$var$createGuard,
    guard: $5c5453da66466ee3$var$guard,
    updateGuard: $5c5453da66466ee3$var$guard.partial()
});

});

parcelRequire.register("a5feG", function(module, exports) {

$parcel$export(module.exports, "OrganizationRoles", function () { return $7576308e6f16ae15$export$29f120f254b547e7; });
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
const $7576308e6f16ae15$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    id: (0, $c3dK3.z).string().min(1).max(21),
    name: (0, $c3dK3.z).string().min(1).max(128),
    description: (0, $c3dK3.z).string().max(256).nullable().optional()
});
const $7576308e6f16ae15$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    id: (0, $c3dK3.z).string().min(1).max(21),
    name: (0, $c3dK3.z).string().min(1).max(128),
    description: (0, $c3dK3.z).string().max(256).nullable()
});
const $7576308e6f16ae15$export$29f120f254b547e7 = Object.freeze({
    table: "organization_roles",
    tableSingular: "organization_role",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        name: "name",
        description: "description"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "name",
        "description"
    ],
    createGuard: $7576308e6f16ae15$var$createGuard,
    guard: $7576308e6f16ae15$var$guard,
    updateGuard: $7576308e6f16ae15$var$guard.partial()
});

});

parcelRequire.register("bPimI", function(module, exports) {

$parcel$export(module.exports, "OrganizationScopes", function () { return $89c2b4219e1972fd$export$9d110f69f69dde7a; });
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
const $89c2b4219e1972fd$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    id: (0, $c3dK3.z).string().min(1).max(21),
    name: (0, $c3dK3.z).string().min(1).max(128),
    description: (0, $c3dK3.z).string().max(256).nullable().optional()
});
const $89c2b4219e1972fd$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    id: (0, $c3dK3.z).string().min(1).max(21),
    name: (0, $c3dK3.z).string().min(1).max(128),
    description: (0, $c3dK3.z).string().max(256).nullable()
});
const $89c2b4219e1972fd$export$9d110f69f69dde7a = Object.freeze({
    table: "organization_scopes",
    tableSingular: "organization_scope",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        name: "name",
        description: "description"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "name",
        "description"
    ],
    createGuard: $89c2b4219e1972fd$var$createGuard,
    guard: $89c2b4219e1972fd$var$guard,
    updateGuard: $89c2b4219e1972fd$var$guard.partial()
});

});

parcelRequire.register("kAkpc", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
const $efc6ff8356b3ead0$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    organizationId: (0, $c3dK3.z).string().min(1).max(21),
    userId: (0, $c3dK3.z).string().min(1).max(21)
});
const $efc6ff8356b3ead0$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    organizationId: (0, $c3dK3.z).string().min(1).max(21),
    userId: (0, $c3dK3.z).string().min(1).max(21)
});
const $efc6ff8356b3ead0$export$cd9bcab5c5506817 = Object.freeze({
    table: "organization_user_relations",
    tableSingular: "organization_user_relation",
    fields: {
        tenantId: "tenant_id",
        organizationId: "organization_id",
        userId: "user_id"
    },
    fieldKeys: [
        "tenantId",
        "organizationId",
        "userId"
    ],
    createGuard: $efc6ff8356b3ead0$var$createGuard,
    guard: $efc6ff8356b3ead0$var$guard,
    updateGuard: $efc6ff8356b3ead0$var$guard.partial()
});

});

parcelRequire.register("bfvuB", function(module, exports) {

$parcel$export(module.exports, "Organizations", function () { return $830986382a58a68b$export$8cdb1b004e612f6c; });
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
parcelRequire("5Fb6p");
var $j080Y = parcelRequire("j080Y");
const $830986382a58a68b$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    id: (0, $c3dK3.z).string().min(1).max(21),
    name: (0, $c3dK3.z).string().min(1).max(128),
    description: (0, $c3dK3.z).string().max(256).nullable().optional(),
    customData: (0, $j080Y.jsonObjectGuard).optional(),
    createdAt: (0, $c3dK3.z).number().optional()
});
const $830986382a58a68b$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    id: (0, $c3dK3.z).string().min(1).max(21),
    name: (0, $c3dK3.z).string().min(1).max(128),
    description: (0, $c3dK3.z).string().max(256).nullable(),
    customData: (0, $j080Y.jsonObjectGuard),
    createdAt: (0, $c3dK3.z).number()
});
const $830986382a58a68b$export$8cdb1b004e612f6c = Object.freeze({
    table: "organizations",
    tableSingular: "organization",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        name: "name",
        description: "description",
        customData: "custom_data",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "name",
        "description",
        "customData",
        "createdAt"
    ],
    createGuard: $830986382a58a68b$var$createGuard,
    guard: $830986382a58a68b$var$guard,
    updateGuard: $830986382a58a68b$var$guard.partial()
});

});

parcelRequire.register("1uDv4", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
const $11673bb075c88b3c$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    id: (0, $c3dK3.z).string().min(1).max(21),
    interactionJti: (0, $c3dK3.z).string().max(128).nullable().optional(),
    phone: (0, $c3dK3.z).string().max(32).nullable().optional(),
    email: (0, $c3dK3.z).string().max(128).nullable().optional(),
    type: (0, $c3dK3.z).string().min(1).max(32),
    code: (0, $c3dK3.z).string().min(1).max(6),
    consumed: (0, $c3dK3.z).boolean().optional(),
    tryCount: (0, $c3dK3.z).number().optional(),
    createdAt: (0, $c3dK3.z).number().optional()
});
const $11673bb075c88b3c$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    id: (0, $c3dK3.z).string().min(1).max(21),
    interactionJti: (0, $c3dK3.z).string().max(128).nullable(),
    phone: (0, $c3dK3.z).string().max(32).nullable(),
    email: (0, $c3dK3.z).string().max(128).nullable(),
    type: (0, $c3dK3.z).string().min(1).max(32),
    code: (0, $c3dK3.z).string().min(1).max(6),
    consumed: (0, $c3dK3.z).boolean(),
    tryCount: (0, $c3dK3.z).number(),
    createdAt: (0, $c3dK3.z).number()
});
const $11673bb075c88b3c$export$9bbf548a87a223fc = Object.freeze({
    table: "passcodes",
    tableSingular: "passcode",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        interactionJti: "interaction_jti",
        phone: "phone",
        email: "email",
        type: "type",
        code: "code",
        consumed: "consumed",
        tryCount: "try_count",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "interactionJti",
        "phone",
        "email",
        "type",
        "code",
        "consumed",
        "tryCount",
        "createdAt"
    ],
    createGuard: $11673bb075c88b3c$var$createGuard,
    guard: $11673bb075c88b3c$var$guard,
    updateGuard: $11673bb075c88b3c$var$guard.partial()
});

});

parcelRequire.register("9Jr5u", function(module, exports) {

$parcel$export(module.exports, "Resources", function () { return $715d54093c4662a8$export$e9a269813a6315a4; });
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
const $715d54093c4662a8$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    id: (0, $c3dK3.z).string().min(1).max(21),
    name: (0, $c3dK3.z).string().min(1),
    indicator: (0, $c3dK3.z).string().min(1),
    isDefault: (0, $c3dK3.z).boolean().optional(),
    accessTokenTtl: (0, $c3dK3.z).number().optional()
});
const $715d54093c4662a8$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    id: (0, $c3dK3.z).string().min(1).max(21),
    name: (0, $c3dK3.z).string().min(1),
    indicator: (0, $c3dK3.z).string().min(1),
    isDefault: (0, $c3dK3.z).boolean(),
    accessTokenTtl: (0, $c3dK3.z).number()
});
const $715d54093c4662a8$export$e9a269813a6315a4 = Object.freeze({
    table: "resources",
    tableSingular: "resource",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        name: "name",
        indicator: "indicator",
        isDefault: "is_default",
        accessTokenTtl: "access_token_ttl"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "name",
        "indicator",
        "isDefault",
        "accessTokenTtl"
    ],
    createGuard: $715d54093c4662a8$var$createGuard,
    guard: $715d54093c4662a8$var$guard,
    updateGuard: $715d54093c4662a8$var$guard.partial()
});

});

parcelRequire.register("5JzQP", function(module, exports) {

$parcel$export(module.exports, "Roles", function () { return $42ccf6f877342d6c$export$d1d9e451800db729; });
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");

var $61Yml = parcelRequire("61Yml");
const $42ccf6f877342d6c$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    id: (0, $c3dK3.z).string().min(1).max(21),
    name: (0, $c3dK3.z).string().min(1).max(128),
    description: (0, $c3dK3.z).string().min(1).max(128),
    type: (0, $c3dK3.z).nativeEnum((0, $61Yml.RoleType)).optional(),
    isDefault: (0, $c3dK3.z).boolean().optional()
});
const $42ccf6f877342d6c$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    id: (0, $c3dK3.z).string().min(1).max(21),
    name: (0, $c3dK3.z).string().min(1).max(128),
    description: (0, $c3dK3.z).string().min(1).max(128),
    type: (0, $c3dK3.z).nativeEnum((0, $61Yml.RoleType)),
    isDefault: (0, $c3dK3.z).boolean()
});
const $42ccf6f877342d6c$export$d1d9e451800db729 = Object.freeze({
    table: "roles",
    tableSingular: "role",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        name: "name",
        description: "description",
        type: "type",
        isDefault: "is_default"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "name",
        "description",
        "type",
        "isDefault"
    ],
    createGuard: $42ccf6f877342d6c$var$createGuard,
    guard: $42ccf6f877342d6c$var$guard,
    updateGuard: $42ccf6f877342d6c$var$guard.partial()
});

});

parcelRequire.register("k9HTR", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
const $eac6b38a4719be20$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    id: (0, $c3dK3.z).string().min(1).max(21),
    roleId: (0, $c3dK3.z).string().min(1).max(21),
    scopeId: (0, $c3dK3.z).string().min(1).max(21)
});
const $eac6b38a4719be20$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    id: (0, $c3dK3.z).string().min(1).max(21),
    roleId: (0, $c3dK3.z).string().min(1).max(21),
    scopeId: (0, $c3dK3.z).string().min(1).max(21)
});
const $eac6b38a4719be20$export$a3e241bf0004129f = Object.freeze({
    table: "roles_scopes",
    tableSingular: "roles_scope",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        roleId: "role_id",
        scopeId: "scope_id"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "roleId",
        "scopeId"
    ],
    createGuard: $eac6b38a4719be20$var$createGuard,
    guard: $eac6b38a4719be20$var$guard,
    updateGuard: $eac6b38a4719be20$var$guard.partial()
});

});

parcelRequire.register("fidVk", function(module, exports) {

$parcel$export(module.exports, "Scopes", function () { return $b22356654f98bd28$export$8546186883d6ff3e; });
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
const $b22356654f98bd28$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    id: (0, $c3dK3.z).string().min(1).max(21),
    resourceId: (0, $c3dK3.z).string().min(1).max(21),
    name: (0, $c3dK3.z).string().min(1).max(256),
    description: (0, $c3dK3.z).string().nullable().optional(),
    createdAt: (0, $c3dK3.z).number().optional()
});
const $b22356654f98bd28$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    id: (0, $c3dK3.z).string().min(1).max(21),
    resourceId: (0, $c3dK3.z).string().min(1).max(21),
    name: (0, $c3dK3.z).string().min(1).max(256),
    description: (0, $c3dK3.z).string().nullable(),
    createdAt: (0, $c3dK3.z).number()
});
const $b22356654f98bd28$export$8546186883d6ff3e = Object.freeze({
    table: "scopes",
    tableSingular: "scope",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        resourceId: "resource_id",
        name: "name",
        description: "description",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "resourceId",
        "name",
        "description",
        "createdAt"
    ],
    createGuard: $b22356654f98bd28$var$createGuard,
    guard: $b22356654f98bd28$var$guard,
    updateGuard: $b22356654f98bd28$var$guard.partial()
});

});

parcelRequire.register("cBOp0", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
parcelRequire("5Fb6p");
var $hMPN6 = parcelRequire("hMPN6");

var $61Yml = parcelRequire("61Yml");
const $92e0099caa8feb56$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    id: (0, $c3dK3.z).string().min(1).max(21),
    targetType: (0, $hMPN6.sentinelActivityTargetTypeGuard),
    targetHash: (0, $c3dK3.z).string().min(1).max(64),
    action: (0, $hMPN6.sentinelActivityActionGuard),
    actionResult: (0, $c3dK3.z).nativeEnum((0, $61Yml.SentinelActionResult)),
    payload: (0, $hMPN6.sentinelActivityPayloadGuard),
    decision: (0, $c3dK3.z).nativeEnum((0, $61Yml.SentinelDecision)),
    decisionExpiresAt: (0, $c3dK3.z).number().optional(),
    createdAt: (0, $c3dK3.z).number().optional()
});
const $92e0099caa8feb56$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    id: (0, $c3dK3.z).string().min(1).max(21),
    targetType: (0, $hMPN6.sentinelActivityTargetTypeGuard),
    targetHash: (0, $c3dK3.z).string().min(1).max(64),
    action: (0, $hMPN6.sentinelActivityActionGuard),
    actionResult: (0, $c3dK3.z).nativeEnum((0, $61Yml.SentinelActionResult)),
    payload: (0, $hMPN6.sentinelActivityPayloadGuard),
    decision: (0, $c3dK3.z).nativeEnum((0, $61Yml.SentinelDecision)),
    decisionExpiresAt: (0, $c3dK3.z).number(),
    createdAt: (0, $c3dK3.z).number()
});
const $92e0099caa8feb56$export$ac14f56217b6b757 = Object.freeze({
    table: "sentinel_activities",
    tableSingular: "sentinel_activity",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        targetType: "target_type",
        targetHash: "target_hash",
        action: "action",
        actionResult: "action_result",
        payload: "payload",
        decision: "decision",
        decisionExpiresAt: "decision_expires_at",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "targetType",
        "targetHash",
        "action",
        "actionResult",
        "payload",
        "decision",
        "decisionExpiresAt",
        "createdAt"
    ],
    createGuard: $92e0099caa8feb56$var$createGuard,
    guard: $92e0099caa8feb56$var$guard,
    updateGuard: $92e0099caa8feb56$var$guard.partial()
});

});

parcelRequire.register("kYkbC", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
parcelRequire("5Fb6p");
var $j080Y = parcelRequire("j080Y");
const $f44911d959d7f9bb$var$createGuard = (0, $c3dK3.z).object({
    id: (0, $c3dK3.z).string().min(1).max(21),
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    type: (0, $c3dK3.z).string().min(1).max(64),
    payload: (0, $j080Y.jsonObjectGuard).optional(),
    createdAt: (0, $c3dK3.z).number().optional()
});
const $f44911d959d7f9bb$var$guard = (0, $c3dK3.z).object({
    id: (0, $c3dK3.z).string().min(1).max(21),
    tenantId: (0, $c3dK3.z).string().max(21),
    type: (0, $c3dK3.z).string().min(1).max(64),
    payload: (0, $j080Y.jsonObjectGuard),
    createdAt: (0, $c3dK3.z).number()
});
const $f44911d959d7f9bb$export$22ef66d3c161d6a7 = Object.freeze({
    table: "service_logs",
    tableSingular: "service_log",
    fields: {
        id: "id",
        tenantId: "tenant_id",
        type: "type",
        payload: "payload",
        createdAt: "created_at"
    },
    fieldKeys: [
        "id",
        "tenantId",
        "type",
        "payload",
        "createdAt"
    ],
    createGuard: $f44911d959d7f9bb$var$createGuard,
    guard: $f44911d959d7f9bb$var$guard,
    updateGuard: $f44911d959d7f9bb$var$guard.partial()
});

});

parcelRequire.register("4nX9k", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
parcelRequire("5Fb6p");
var $8lyC3 = parcelRequire("8lyC3");
var $7GyLL = parcelRequire("7GyLL");

var $61Yml = parcelRequire("61Yml");
const $3317314814c411c6$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    id: (0, $c3dK3.z).string().min(1).max(21),
    color: (0, $8lyC3.colorGuard),
    branding: (0, $8lyC3.brandingGuard),
    languageInfo: (0, $8lyC3.languageInfoGuard),
    termsOfUseUrl: (0, $c3dK3.z).string().max(2048).nullable().optional(),
    privacyPolicyUrl: (0, $c3dK3.z).string().max(2048).nullable().optional(),
    signIn: (0, $8lyC3.signInGuard),
    signUp: (0, $8lyC3.signUpGuard),
    socialSignInConnectorTargets: (0, $8lyC3.connectorTargetsGuard).optional(),
    signInMode: (0, $c3dK3.z).nativeEnum((0, $61Yml.SignInMode)).optional(),
    customCss: (0, $c3dK3.z).string().nullable().optional(),
    customContent: (0, $8lyC3.customContentGuard).optional(),
    passwordPolicy: (0, $7GyLL.partialPasswordPolicyGuard).optional(),
    mfa: (0, $8lyC3.mfaGuard).optional(),
    singleSignOnEnabled: (0, $c3dK3.z).boolean().optional()
});
const $3317314814c411c6$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    id: (0, $c3dK3.z).string().min(1).max(21),
    color: (0, $8lyC3.colorGuard),
    branding: (0, $8lyC3.brandingGuard),
    languageInfo: (0, $8lyC3.languageInfoGuard),
    termsOfUseUrl: (0, $c3dK3.z).string().max(2048).nullable(),
    privacyPolicyUrl: (0, $c3dK3.z).string().max(2048).nullable(),
    signIn: (0, $8lyC3.signInGuard),
    signUp: (0, $8lyC3.signUpGuard),
    socialSignInConnectorTargets: (0, $8lyC3.connectorTargetsGuard),
    signInMode: (0, $c3dK3.z).nativeEnum((0, $61Yml.SignInMode)),
    customCss: (0, $c3dK3.z).string().nullable(),
    customContent: (0, $8lyC3.customContentGuard),
    passwordPolicy: (0, $7GyLL.partialPasswordPolicyGuard),
    mfa: (0, $8lyC3.mfaGuard),
    singleSignOnEnabled: (0, $c3dK3.z).boolean()
});
const $3317314814c411c6$export$761297ae014f2673 = Object.freeze({
    table: "sign_in_experiences",
    tableSingular: "sign_in_experience",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        color: "color",
        branding: "branding",
        languageInfo: "language_info",
        termsOfUseUrl: "terms_of_use_url",
        privacyPolicyUrl: "privacy_policy_url",
        signIn: "sign_in",
        signUp: "sign_up",
        socialSignInConnectorTargets: "social_sign_in_connector_targets",
        signInMode: "sign_in_mode",
        customCss: "custom_css",
        customContent: "custom_content",
        passwordPolicy: "password_policy",
        mfa: "mfa",
        singleSignOnEnabled: "single_sign_on_enabled"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "color",
        "branding",
        "languageInfo",
        "termsOfUseUrl",
        "privacyPolicyUrl",
        "signIn",
        "signUp",
        "socialSignInConnectorTargets",
        "signInMode",
        "customCss",
        "customContent",
        "passwordPolicy",
        "mfa",
        "singleSignOnEnabled"
    ],
    createGuard: $3317314814c411c6$var$createGuard,
    guard: $3317314814c411c6$var$guard,
    updateGuard: $3317314814c411c6$var$guard.partial()
});

});

parcelRequire.register("oBypx", function(module, exports) {

$parcel$export(module.exports, "SsoConnectors", function () { return $049f5f736bbb8d9c$export$cb7d2ef46acb2840; });
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
parcelRequire("5Fb6p");
var $j080Y = parcelRequire("j080Y");
var $kupPr = parcelRequire("kupPr");
const $049f5f736bbb8d9c$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    id: (0, $c3dK3.z).string().min(1).max(128),
    providerName: (0, $c3dK3.z).string().min(1).max(128),
    connectorName: (0, $c3dK3.z).string().min(1).max(128),
    config: (0, $j080Y.jsonObjectGuard).optional(),
    domains: (0, $kupPr.ssoDomainsGuard).optional(),
    branding: (0, $kupPr.ssoBrandingGuard).optional(),
    syncProfile: (0, $c3dK3.z).boolean().optional(),
    createdAt: (0, $c3dK3.z).number().optional()
});
const $049f5f736bbb8d9c$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    id: (0, $c3dK3.z).string().min(1).max(128),
    providerName: (0, $c3dK3.z).string().min(1).max(128),
    connectorName: (0, $c3dK3.z).string().min(1).max(128),
    config: (0, $j080Y.jsonObjectGuard),
    domains: (0, $kupPr.ssoDomainsGuard),
    branding: (0, $kupPr.ssoBrandingGuard),
    syncProfile: (0, $c3dK3.z).boolean(),
    createdAt: (0, $c3dK3.z).number()
});
const $049f5f736bbb8d9c$export$cb7d2ef46acb2840 = Object.freeze({
    table: "sso_connectors",
    tableSingular: "sso_connector",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        providerName: "provider_name",
        connectorName: "connector_name",
        config: "config",
        domains: "domains",
        branding: "branding",
        syncProfile: "sync_profile",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "providerName",
        "connectorName",
        "config",
        "domains",
        "branding",
        "syncProfile",
        "createdAt"
    ],
    createGuard: $049f5f736bbb8d9c$var$createGuard,
    guard: $049f5f736bbb8d9c$var$guard,
    updateGuard: $049f5f736bbb8d9c$var$guard.partial()
});

});

parcelRequire.register("jDSNX", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
parcelRequire("5Fb6p");
var $j080Y = parcelRequire("j080Y");
const $e4cc2bf289339f39$var$createGuard = (0, $c3dK3.z).object({
    key: (0, $c3dK3.z).string().min(1).max(256),
    value: (0, $j080Y.jsonObjectGuard).optional()
});
const $e4cc2bf289339f39$var$guard = (0, $c3dK3.z).object({
    key: (0, $c3dK3.z).string().min(1).max(256),
    value: (0, $j080Y.jsonObjectGuard)
});
const $e4cc2bf289339f39$export$2b3c0ad5912d86e2 = Object.freeze({
    table: "systems",
    tableSingular: "system",
    fields: {
        key: "key",
        value: "value"
    },
    fieldKeys: [
        "key",
        "value"
    ],
    createGuard: $e4cc2bf289339f39$var$createGuard,
    guard: $e4cc2bf289339f39$var$guard,
    updateGuard: $e4cc2bf289339f39$var$guard.partial()
});

});

parcelRequire.register("jXiNi", function(module, exports) {

$parcel$export(module.exports, "UserSsoIdentities", function () { return $e8721b23398adb10$export$53f83427a403da1f; });
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
parcelRequire("5Fb6p");
var $j080Y = parcelRequire("j080Y");
const $e8721b23398adb10$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    id: (0, $c3dK3.z).string().min(1).max(21),
    userId: (0, $c3dK3.z).string().min(1).max(12),
    issuer: (0, $c3dK3.z).string().min(1).max(256),
    identityId: (0, $c3dK3.z).string().min(1).max(128),
    detail: (0, $j080Y.jsonObjectGuard).optional(),
    createdAt: (0, $c3dK3.z).number().optional(),
    ssoConnectorId: (0, $c3dK3.z).string().min(1).max(128)
});
const $e8721b23398adb10$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    id: (0, $c3dK3.z).string().min(1).max(21),
    userId: (0, $c3dK3.z).string().min(1).max(12),
    issuer: (0, $c3dK3.z).string().min(1).max(256),
    identityId: (0, $c3dK3.z).string().min(1).max(128),
    detail: (0, $j080Y.jsonObjectGuard),
    createdAt: (0, $c3dK3.z).number(),
    ssoConnectorId: (0, $c3dK3.z).string().min(1).max(128)
});
const $e8721b23398adb10$export$53f83427a403da1f = Object.freeze({
    table: "user_sso_identities",
    tableSingular: "user_sso_identity",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        userId: "user_id",
        issuer: "issuer",
        identityId: "identity_id",
        detail: "detail",
        createdAt: "created_at",
        ssoConnectorId: "sso_connector_id"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "userId",
        "issuer",
        "identityId",
        "detail",
        "createdAt",
        "ssoConnectorId"
    ],
    createGuard: $e8721b23398adb10$var$createGuard,
    guard: $e8721b23398adb10$var$guard,
    updateGuard: $e8721b23398adb10$var$guard.partial()
});

});

parcelRequire.register("ev8Fx", function(module, exports) {

$parcel$export(module.exports, "Users", function () { return $a8eaaf6f457786fa$export$a69f017b19597ff5; });
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
parcelRequire("5Fb6p");
var $1QRmm = parcelRequire("1QRmm");
var $j080Y = parcelRequire("j080Y");

var $61Yml = parcelRequire("61Yml");
const $a8eaaf6f457786fa$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    id: (0, $c3dK3.z).string().min(1).max(12),
    username: (0, $c3dK3.z).string().max(128).nullable().optional(),
    primaryEmail: (0, $c3dK3.z).string().max(128).nullable().optional(),
    primaryPhone: (0, $c3dK3.z).string().max(128).nullable().optional(),
    passwordEncrypted: (0, $c3dK3.z).string().max(128).nullable().optional(),
    passwordEncryptionMethod: (0, $c3dK3.z).nativeEnum((0, $61Yml.UsersPasswordEncryptionMethod)).nullable().optional(),
    name: (0, $c3dK3.z).string().max(128).nullable().optional(),
    avatar: (0, $c3dK3.z).string().max(2048).nullable().optional(),
    profile: (0, $1QRmm.userProfileGuard).optional(),
    applicationId: (0, $c3dK3.z).string().max(21).nullable().optional(),
    identities: (0, $1QRmm.identitiesGuard).optional(),
    customData: (0, $j080Y.jsonObjectGuard).optional(),
    logtoConfig: (0, $j080Y.jsonObjectGuard).optional(),
    mfaVerifications: (0, $1QRmm.mfaVerificationsGuard).optional(),
    isSuspended: (0, $c3dK3.z).boolean().optional(),
    lastSignInAt: (0, $c3dK3.z).number().nullable().optional(),
    createdAt: (0, $c3dK3.z).number().optional(),
    updatedAt: (0, $c3dK3.z).number().optional()
});
const $a8eaaf6f457786fa$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    id: (0, $c3dK3.z).string().min(1).max(12),
    username: (0, $c3dK3.z).string().max(128).nullable(),
    primaryEmail: (0, $c3dK3.z).string().max(128).nullable(),
    primaryPhone: (0, $c3dK3.z).string().max(128).nullable(),
    passwordEncrypted: (0, $c3dK3.z).string().max(128).nullable(),
    passwordEncryptionMethod: (0, $c3dK3.z).nativeEnum((0, $61Yml.UsersPasswordEncryptionMethod)).nullable(),
    name: (0, $c3dK3.z).string().max(128).nullable(),
    avatar: (0, $c3dK3.z).string().max(2048).nullable(),
    profile: (0, $1QRmm.userProfileGuard),
    applicationId: (0, $c3dK3.z).string().max(21).nullable(),
    identities: (0, $1QRmm.identitiesGuard),
    customData: (0, $j080Y.jsonObjectGuard),
    logtoConfig: (0, $j080Y.jsonObjectGuard),
    mfaVerifications: (0, $1QRmm.mfaVerificationsGuard),
    isSuspended: (0, $c3dK3.z).boolean(),
    lastSignInAt: (0, $c3dK3.z).number().nullable(),
    createdAt: (0, $c3dK3.z).number(),
    updatedAt: (0, $c3dK3.z).number()
});
const $a8eaaf6f457786fa$export$a69f017b19597ff5 = Object.freeze({
    table: "users",
    tableSingular: "user",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        username: "username",
        primaryEmail: "primary_email",
        primaryPhone: "primary_phone",
        passwordEncrypted: "password_encrypted",
        passwordEncryptionMethod: "password_encryption_method",
        name: "name",
        avatar: "avatar",
        profile: "profile",
        applicationId: "application_id",
        identities: "identities",
        customData: "custom_data",
        logtoConfig: "logto_config",
        mfaVerifications: "mfa_verifications",
        isSuspended: "is_suspended",
        lastSignInAt: "last_sign_in_at",
        createdAt: "created_at",
        updatedAt: "updated_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "username",
        "primaryEmail",
        "primaryPhone",
        "passwordEncrypted",
        "passwordEncryptionMethod",
        "name",
        "avatar",
        "profile",
        "applicationId",
        "identities",
        "customData",
        "logtoConfig",
        "mfaVerifications",
        "isSuspended",
        "lastSignInAt",
        "createdAt",
        "updatedAt"
    ],
    createGuard: $a8eaaf6f457786fa$var$createGuard,
    guard: $a8eaaf6f457786fa$var$guard,
    updateGuard: $a8eaaf6f457786fa$var$guard.partial()
});

});

parcelRequire.register("dkWOS", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
const $9b5ac4f846cb3516$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    id: (0, $c3dK3.z).string().min(1).max(21),
    userId: (0, $c3dK3.z).string().min(1).max(21),
    roleId: (0, $c3dK3.z).string().min(1).max(21)
});
const $9b5ac4f846cb3516$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    id: (0, $c3dK3.z).string().min(1).max(21),
    userId: (0, $c3dK3.z).string().min(1).max(21),
    roleId: (0, $c3dK3.z).string().min(1).max(21)
});
const $9b5ac4f846cb3516$export$a93a64b4653e6020 = Object.freeze({
    table: "users_roles",
    tableSingular: "users_role",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        userId: "user_id",
        roleId: "role_id"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "userId",
        "roleId"
    ],
    createGuard: $9b5ac4f846cb3516$var$createGuard,
    guard: $9b5ac4f846cb3516$var$guard,
    updateGuard: $9b5ac4f846cb3516$var$guard.partial()
});

});

parcelRequire.register("2pe2S", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $c3dK3 = parcelRequire("c3dK3");
const $1c08cfaf4b8178dc$var$createGuard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21).optional(),
    id: (0, $c3dK3.z).string().min(1).max(21),
    userId: (0, $c3dK3.z).string().min(1).max(21),
    createdAt: (0, $c3dK3.z).number().optional()
});
const $1c08cfaf4b8178dc$var$guard = (0, $c3dK3.z).object({
    tenantId: (0, $c3dK3.z).string().max(21),
    id: (0, $c3dK3.z).string().min(1).max(21),
    userId: (0, $c3dK3.z).string().min(1).max(21),
    createdAt: (0, $c3dK3.z).number()
});
const $1c08cfaf4b8178dc$export$730f48ea7aa802b0 = Object.freeze({
    table: "verification_statuses",
    tableSingular: "verification_status",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        userId: "user_id",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "userId",
        "createdAt"
    ],
    createGuard: $1c08cfaf4b8178dc$var$createGuard,
    guard: $1c08cfaf4b8178dc$var$guard,
    updateGuard: $1c08cfaf4b8178dc$var$guard.partial()
});

});


parcelRequire.register("1qlsF", function(module, exports) {
$parcel$export(module.exports, "ConnectorPlatform", function () { return (parcelRequire("cIy8v")).ConnectorPlatform; });
$parcel$export(module.exports, "ConnectorType", function () { return (parcelRequire("kowfT")).ConnectorType; });
$parcel$export(module.exports, "AdminTenantRole", function () { return (parcelRequire("68782")).AdminTenantRole; });
$parcel$export(module.exports, "InternalRole", function () { return (parcelRequire("68782")).InternalRole; });
$parcel$export(module.exports, "PredefinedScope", function () { return (parcelRequire("68782")).PredefinedScope; });
$parcel$export(module.exports, "LogtoJwtTokenKey", function () { return (parcelRequire("jnq2J")).LogtoJwtTokenKey; });
$parcel$export(module.exports, "LogtoJwtTokenKeyType", function () { return (parcelRequire("6NioG")).LogtoJwtTokenKeyType; });
$parcel$export(module.exports, "LogtoOidcConfigKeyType", function () { return (parcelRequire("jnq2J")).LogtoOidcConfigKeyType; });
$parcel$export(module.exports, "LogtoTenantConfigKey", function () { return (parcelRequire("jnq2J")).LogtoTenantConfigKey; });
$parcel$export(module.exports, "SupportedSigningKeyAlgorithm", function () { return (parcelRequire("jnq2J")).SupportedSigningKeyAlgorithm; });
$parcel$export(module.exports, "ApplicationUserConsentScopeType", function () { return (parcelRequire("fGvTA")).ApplicationUserConsentScopeType; });
$parcel$export(module.exports, "maxUploadFileSize", function () { return (parcelRequire("2rWG7")).maxUploadFileSize; });
$parcel$export(module.exports, "hookTestErrorResponseDataGuard", function () { return (parcelRequire("kSjlW")).hookTestErrorResponseDataGuard; });
$parcel$export(module.exports, "Theme", function () { return (parcelRequire("5HVJe")).Theme; });
$parcel$export(module.exports, "SsoProviderName", function () { return (parcelRequire("8q742")).SsoProviderName; });
$parcel$export(module.exports, "SsoProviderType", function () { return (parcelRequire("8q742")).SsoProviderType; });
$parcel$export(module.exports, "TenantTag", function () { return (parcelRequire("iq1sR")).TenantTag; });
$parcel$export(module.exports, "getTenantIdFromOrganizationId", function () { return (parcelRequire("aZIrr")).getTenantIdFromOrganizationId; });
$parcel$export(module.exports, "getTenantOrganizationId", function () { return (parcelRequire("aZIrr")).getTenantOrganizationId; });
$parcel$export(module.exports, "TenantRole", function () { return (parcelRequire("aZIrr")).TenantRole; });
$parcel$export(module.exports, "TenantScope", function () { return (parcelRequire("aZIrr")).TenantScope; });
$parcel$export(module.exports, "getMapiProxyRole", function () { return (parcelRequire("50dZF")).getMapiProxyRole; });
$parcel$export(module.exports, "AdditionalFeatures", function () { return (parcelRequire("dNkWp")).AdditionalFeatures; });
$parcel$export(module.exports, "Project", function () { return (parcelRequire("dNkWp")).Project; });
$parcel$export(module.exports, "Stage", function () { return (parcelRequire("dNkWp")).Stage; });
$parcel$export(module.exports, "userOnboardingDataGuard", function () { return (parcelRequire("dNkWp")).userOnboardingDataGuard; });
$parcel$export(module.exports, "userOnboardingDataKey", function () { return (parcelRequire("dNkWp")).userOnboardingDataKey; });
parcelRequire("iIK9Z");
parcelRequire("1bXIk");
parcelRequire("coAqX");
parcelRequire("68782");
parcelRequire("jnq2J");
parcelRequire("5MAQz");
parcelRequire("fG133");
parcelRequire("1R5lx");
parcelRequire("i0p1H");
parcelRequire("3D8rM");
parcelRequire("8QmIT");
parcelRequire("fGvTA");
parcelRequire("5lhZO");
parcelRequire("2rWG7");
parcelRequire("kSjlW");
parcelRequire("6VmW0");
parcelRequire("5HVJe");
parcelRequire("eriGJ");
parcelRequire("jLpFC");
parcelRequire("aVJJI");
parcelRequire("6A3nn");
parcelRequire("do79b");
parcelRequire("2ENqi");
parcelRequire("8q742");
parcelRequire("iq1sR");
parcelRequire("aZIrr");
parcelRequire("50dZF");
parcelRequire("ccPBd");
parcelRequire("dNkWp");

});
parcelRequire.register("iIK9Z", function(module, exports) {

$parcel$export(module.exports, "ConnectorType", function () { return (parcelRequire("kowfT")).ConnectorType; });
$parcel$export(module.exports, "ConnectorPlatform", function () { return (parcelRequire("cIy8v")).ConnectorPlatform; });
parcelRequire("oK7kD");
var $cIy8v = parcelRequire("cIy8v");
var $kowfT = parcelRequire("kowfT");

var $c3dK3 = parcelRequire("c3dK3");
parcelRequire("gh8Fv");
var $LiHtu = parcelRequire("LiHtu");
const $da1024787d6ecfcf$export$b52523f950bcfb2f = (0, $LiHtu.Connectors).guard.pick({
    id: true,
    syncProfile: true,
    config: true,
    metadata: true,
    connectorId: true
}).merge((0, $cIy8v.connectorMetadataGuard)).merge((0, $c3dK3.z).object({
    type: (0, $c3dK3.z).nativeEnum((0, $kowfT.ConnectorType)),
    isDemo: (0, $c3dK3.z).boolean().optional(),
    extraInfo: (0, $c3dK3.z).record((0, $c3dK3.z).unknown()).optional(),
    usage: (0, $c3dK3.z).number().optional()
}));
const $da1024787d6ecfcf$export$8169eaabc815830f = (0, $c3dK3.z).object({
    type: (0, $c3dK3.z).nativeEnum((0, $kowfT.ConnectorType)),
    isDemo: (0, $c3dK3.z).boolean().optional()
}).merge((0, $cIy8v.connectorMetadataGuard));

});

parcelRequire.register("1bXIk", function(module, exports) {

var $etp9a = parcelRequire("etp9a");

var $8ce4W = parcelRequire("8ce4W");

var $j85QL = parcelRequire("j85QL");

var $6fYwH = parcelRequire("6fYwH");
const $0de523809430be2e$export$603af3d01cbca1e0 = "Unknown";

});
parcelRequire.register("etp9a", function(module, exports) {
const $a89747c175300f7d$export$82e9f45cca5ba907 = "Interaction";
var $a89747c175300f7d$export$a455218a85c89869;
(function(Field) {
    Field["Event"] = "Event";
    Field["Identifier"] = "Identifier";
    Field["Profile"] = "Profile";
    Field["BindMfa"] = "BindMfa";
    Field["Mfa"] = "Mfa";
})($a89747c175300f7d$export$a455218a85c89869 || ($a89747c175300f7d$export$a455218a85c89869 = {}));
var $a89747c175300f7d$export$31bb55db0b3e4187;
(function(Method) {
    Method["Password"] = "Password";
    Method["VerificationCode"] = "VerificationCode";
    Method["Social"] = "Social";
    Method["SingleSignOn"] = "SingleSignOn";
})($a89747c175300f7d$export$31bb55db0b3e4187 || ($a89747c175300f7d$export$31bb55db0b3e4187 = {}));
var $a89747c175300f7d$export$e19cd5f9376f8cee;
(function(Action) {
    /** Create a new entity. (E.g. create an interaction, create a verification code) */ Action["Create"] = "Create";
    /** Update an existing entity. (E.g. change interaction type) */ Action["Update"] = "Update";
    /** Submit updated info to an entity, or submit to the system. (E.g. submit an interaction, submit a verification code to get verified) */ Action["Submit"] = "Submit";
    /** Delete a existing entity. (E.g delete profile ) */ Action["Delete"] = "Delete";
    /** Change an entity to the end state. (E.g. end an interaction) */ Action["End"] = "End";
})($a89747c175300f7d$export$e19cd5f9376f8cee || ($a89747c175300f7d$export$e19cd5f9376f8cee = {}));

});

parcelRequire.register("8ce4W", function(module, exports) {
/** The type of a token event. */ var $5f7a5d6e84f8a603$export$92738401e1603719;
(function(Type) {
    Type["ExchangeTokenBy"] = "ExchangeTokenBy";
    Type["RevokeToken"] = "RevokeToken";
})($5f7a5d6e84f8a603$export$92738401e1603719 || ($5f7a5d6e84f8a603$export$92738401e1603719 = {}));
var $5f7a5d6e84f8a603$export$f435f793048e7a0f;
(function(TokenType) {
    TokenType["AccessToken"] = "AccessToken";
    TokenType["RefreshToken"] = "RefreshToken";
    TokenType["IdToken"] = "IdToken";
    TokenType["AuthorizationCode"] = "AuthorizationCode";
    TokenType["DeviceCode"] = "DeviceCode";
    TokenType["BackchannelAuthenticationRequest"] = "BackchannelAuthenticationRequest";
})($5f7a5d6e84f8a603$export$f435f793048e7a0f || ($5f7a5d6e84f8a603$export$f435f793048e7a0f = {}));
var $5f7a5d6e84f8a603$export$4a1942e414bbb622;
(function(ExchangeByType) {
    ExchangeByType["Unknown"] = "Unknown";
    ExchangeByType["AuthorizationCode"] = "AuthorizationCode";
    ExchangeByType["RefreshToken"] = "RefreshToken";
    ExchangeByType["ClientCredentials"] = "ClientCredentials";
})($5f7a5d6e84f8a603$export$4a1942e414bbb622 || ($5f7a5d6e84f8a603$export$4a1942e414bbb622 = {}));

});

parcelRequire.register("j85QL", function(module, exports) {
/** The type of a hook event. */ var $ded34d6106f11cca$export$92738401e1603719;
(function(Type) {
    Type["TriggerHook"] = "TriggerHook";
})($ded34d6106f11cca$export$92738401e1603719 || ($ded34d6106f11cca$export$92738401e1603719 = {}));

});

parcelRequire.register("6fYwH", function(module, exports) {
const $48e3181302814d22$export$82e9f45cca5ba907 = "JwtCustomizer";
var $48e3181302814d22$export$92738401e1603719;
(function(Type) {
    Type["AccessToken"] = "AccessToken";
    Type["ClientCredentials"] = "ClientCredentials";
})($48e3181302814d22$export$92738401e1603719 || ($48e3181302814d22$export$92738401e1603719 = {}));

});


parcelRequire.register("coAqX", function(module, exports) {
var $9063fce7922083b4$export$ce68f19b50b39c0b;
(function(GrantType) {
    GrantType["AuthorizationCode"] = "authorization_code";
    GrantType["RefreshToken"] = "refresh_token";
    GrantType["ClientCredentials"] = "client_credentials";
})($9063fce7922083b4$export$ce68f19b50b39c0b || ($9063fce7922083b4$export$ce68f19b50b39c0b = {}));

});

parcelRequire.register("68782", function(module, exports) {

$parcel$export(module.exports, "userInfoGuard", function () { return $4769050ec83e85cf$export$996c89999cd0d06b; });
$parcel$export(module.exports, "InternalRole", function () { return $4769050ec83e85cf$export$a17952fc1a8aded7; });
$parcel$export(module.exports, "AdminTenantRole", function () { return $4769050ec83e85cf$export$cc68ab3265ed0467; });
$parcel$export(module.exports, "PredefinedScope", function () { return $4769050ec83e85cf$export$90d62586f282d378; });

var $c3dK3 = parcelRequire("c3dK3");
parcelRequire("gh8Fv");
var $ev8Fx = parcelRequire("ev8Fx");
var $jXiNi = parcelRequire("jXiNi");
parcelRequire("5Fb6p");
var $8lyC3 = parcelRequire("8lyC3");
const $4769050ec83e85cf$export$c917e1f6c2e1df9e = Object.freeze([
    "id",
    "username",
    "primaryEmail",
    "primaryPhone",
    "name",
    "avatar",
    "customData",
    "identities",
    "lastSignInAt",
    "createdAt",
    "updatedAt",
    "profile",
    "applicationId",
    "isSuspended"
]);
const $4769050ec83e85cf$export$996c89999cd0d06b = (0, $ev8Fx.Users).guard.pick(// eslint-disable-next-line no-restricted-syntax
Object.fromEntries($4769050ec83e85cf$export$c917e1f6c2e1df9e.map((field)=>[
        field,
        true
    ])));
const $4769050ec83e85cf$export$78c9be0b3d74e4aa = $4769050ec83e85cf$export$996c89999cd0d06b.extend({
    hasPassword: (0, $c3dK3.z).boolean().optional(),
    ssoIdentities: (0, $c3dK3.z).array((0, $jXiNi.UserSsoIdentities).guard).optional()
});
const $4769050ec83e85cf$export$45a6ff4daa005563 = (0, $c3dK3.z).object({
    id: (0, $c3dK3.z).string(),
    createdAt: (0, $c3dK3.z).string(),
    type: (0, $c3dK3.z).nativeEnum((0, $8lyC3.MfaFactor)),
    agent: (0, $c3dK3.z).string().optional(),
    remainCodes: (0, $c3dK3.z).number().optional()
}).array();
var $4769050ec83e85cf$export$a17952fc1a8aded7;
(function(InternalRole) {
    /**
     * Internal admin role for Machine-to-Machine apps in Logto user tenants.
     *
     * It should NOT be assigned to any user.
     */ InternalRole["Admin"] = "#internal:admin";
})($4769050ec83e85cf$export$a17952fc1a8aded7 || ($4769050ec83e85cf$export$a17952fc1a8aded7 = {}));
var $4769050ec83e85cf$export$cc68ab3265ed0467;
(function(AdminTenantRole) {
    /** Common user role in admin tenant. */ AdminTenantRole["User"] = "user";
    /** The role for machine to machine applications that represent a user tenant and send requests to Logto Cloud. */ AdminTenantRole["TenantApplication"] = "tenantApplication";
})($4769050ec83e85cf$export$cc68ab3265ed0467 || ($4769050ec83e85cf$export$cc68ab3265ed0467 = {}));
var $4769050ec83e85cf$export$90d62586f282d378;
(function(PredefinedScope) {
    PredefinedScope["All"] = "all";
})($4769050ec83e85cf$export$90d62586f282d378 || ($4769050ec83e85cf$export$90d62586f282d378 = {}));
const $4769050ec83e85cf$export$7ffb47057ef1f416 = (0, $ev8Fx.Users).guard.pick({
    id: true,
    avatar: true,
    name: true
});

});

parcelRequire.register("jnq2J", function(module, exports) {
$parcel$export(module.exports, "accessTokenJwtCustomizerGuard", function () { return (parcelRequire("6NioG")).accessTokenJwtCustomizerGuard; });
$parcel$export(module.exports, "clientCredentialsJwtCustomizerGuard", function () { return (parcelRequire("6NioG")).clientCredentialsJwtCustomizerGuard; });
$parcel$export(module.exports, "LogtoJwtTokenKeyType", function () { return (parcelRequire("6NioG")).LogtoJwtTokenKeyType; });

$parcel$export(module.exports, "LogtoOidcConfigKeyType", function () { return $e1b45de317ee2288$export$15b2d6ce08800aad; });
$parcel$export(module.exports, "SupportedSigningKeyAlgorithm", function () { return $e1b45de317ee2288$export$e33814a1cc7d5e24; });
$parcel$export(module.exports, "LogtoJwtTokenKey", function () { return $e1b45de317ee2288$export$35597c7744ab3ee6; });
$parcel$export(module.exports, "LogtoTenantConfigKey", function () { return $e1b45de317ee2288$export$a249f1a8f5d6b725; });

var $c3dK3 = parcelRequire("c3dK3");

var $6NioG = parcelRequire("6NioG");
parcelRequire("9PiNF");
var $e1b45de317ee2288$export$15b2d6ce08800aad;
(function(LogtoOidcConfigKeyType) {
    LogtoOidcConfigKeyType["PrivateKeys"] = "private-keys";
    LogtoOidcConfigKeyType["CookieKeys"] = "cookie-keys";
})($e1b45de317ee2288$export$15b2d6ce08800aad || ($e1b45de317ee2288$export$15b2d6ce08800aad = {}));
var $e1b45de317ee2288$export$30b1b445ccf496a4;
(function(LogtoOidcConfigKey) {
    LogtoOidcConfigKey["PrivateKeys"] = "oidc.privateKeys";
    LogtoOidcConfigKey["CookieKeys"] = "oidc.cookieKeys";
})($e1b45de317ee2288$export$30b1b445ccf496a4 || ($e1b45de317ee2288$export$30b1b445ccf496a4 = {}));
var $e1b45de317ee2288$export$e33814a1cc7d5e24;
(function(SupportedSigningKeyAlgorithm) {
    SupportedSigningKeyAlgorithm["RSA"] = "RSA";
    SupportedSigningKeyAlgorithm["EC"] = "EC";
})($e1b45de317ee2288$export$e33814a1cc7d5e24 || ($e1b45de317ee2288$export$e33814a1cc7d5e24 = {}));
const $e1b45de317ee2288$export$a1c94f11d0704ec5 = (0, $c3dK3.z).object({
    id: (0, $c3dK3.z).string(),
    value: (0, $c3dK3.z).string(),
    createdAt: (0, $c3dK3.z).number()
});
const $e1b45de317ee2288$export$f5f9e866e854b681 = Object.freeze({
    [$e1b45de317ee2288$export$30b1b445ccf496a4.PrivateKeys]: $e1b45de317ee2288$export$a1c94f11d0704ec5.array(),
    [$e1b45de317ee2288$export$30b1b445ccf496a4.CookieKeys]: $e1b45de317ee2288$export$a1c94f11d0704ec5.array()
});
var $e1b45de317ee2288$export$35597c7744ab3ee6;
(function(LogtoJwtTokenKey) {
    LogtoJwtTokenKey["AccessToken"] = "jwt.accessToken";
    LogtoJwtTokenKey["ClientCredentials"] = "jwt.clientCredentials";
})($e1b45de317ee2288$export$35597c7744ab3ee6 || ($e1b45de317ee2288$export$35597c7744ab3ee6 = {}));
const $e1b45de317ee2288$export$2bd93abaa47d773b = Object.freeze({
    [$e1b45de317ee2288$export$35597c7744ab3ee6.AccessToken]: (0, $6NioG.accessTokenJwtCustomizerGuard),
    [$e1b45de317ee2288$export$35597c7744ab3ee6.ClientCredentials]: (0, $6NioG.clientCredentialsJwtCustomizerGuard)
});
const $e1b45de317ee2288$export$f10f3dc56ae796fc = (0, $c3dK3.z).discriminatedUnion("key", [
    (0, $c3dK3.z).object({
        key: (0, $c3dK3.z).literal($e1b45de317ee2288$export$35597c7744ab3ee6.AccessToken),
        value: (0, $6NioG.accessTokenJwtCustomizerGuard)
    }),
    (0, $c3dK3.z).object({
        key: (0, $c3dK3.z).literal($e1b45de317ee2288$export$35597c7744ab3ee6.ClientCredentials),
        value: (0, $6NioG.clientCredentialsJwtCustomizerGuard)
    })
]);
const $e1b45de317ee2288$export$73b6ce9fa4b1d915 = (0, $c3dK3.z).object({
    signInExperienceCustomized: (0, $c3dK3.z).boolean(),
    organizationCreated: (0, $c3dK3.z).boolean(),
    developmentTenantMigrationNotification: (0, $c3dK3.z).object({
        isPaidTenant: (0, $c3dK3.z).boolean(),
        /**
         * Tag is used to store the original tenant tag before dev tenant migration.
         * This field is only used for DB rollback and because the `TenantTag` may change, so we don't guard it as the `TenantTag` type.
         */ tag: (0, $c3dK3.z).string(),
        readAt: (0, $c3dK3.z).number().optional()
    }).optional(),
    checkedChargeNotification: (0, $c3dK3.z).object({
        token: (0, $c3dK3.z).boolean().optional(),
        apiResource: (0, $c3dK3.z).boolean().optional(),
        machineToMachineApp: (0, $c3dK3.z).boolean().optional(),
        tenantMember: (0, $c3dK3.z).boolean().optional()
    }).optional()
});
const $e1b45de317ee2288$export$bf5ba14ccde3732d = (0, $c3dK3.z).object({
    appId: (0, $c3dK3.z).string(),
    appSecret: (0, $c3dK3.z).string(),
    resource: (0, $c3dK3.z).string()
});
var $e1b45de317ee2288$export$a249f1a8f5d6b725;
(function(LogtoTenantConfigKey) {
    LogtoTenantConfigKey["AdminConsole"] = "adminConsole";
    LogtoTenantConfigKey["CloudConnection"] = "cloudConnection";
    /** The URL to redirect when session not found in Sign-in Experience. */ LogtoTenantConfigKey["SessionNotFoundRedirectUrl"] = "sessionNotFoundRedirectUrl";
})($e1b45de317ee2288$export$a249f1a8f5d6b725 || ($e1b45de317ee2288$export$a249f1a8f5d6b725 = {}));
const $e1b45de317ee2288$export$aebdc60e0ed8c4a5 = Object.freeze({
    [$e1b45de317ee2288$export$a249f1a8f5d6b725.AdminConsole]: $e1b45de317ee2288$export$73b6ce9fa4b1d915,
    [$e1b45de317ee2288$export$a249f1a8f5d6b725.CloudConnection]: $e1b45de317ee2288$export$bf5ba14ccde3732d,
    [$e1b45de317ee2288$export$a249f1a8f5d6b725.SessionNotFoundRedirectUrl]: (0, $c3dK3.z).object({
        url: (0, $c3dK3.z).string()
    })
});
const $e1b45de317ee2288$export$581c47e529f15f7a = Object.freeze([
    ...Object.values($e1b45de317ee2288$export$30b1b445ccf496a4),
    ...Object.values($e1b45de317ee2288$export$35597c7744ab3ee6),
    ...Object.values($e1b45de317ee2288$export$a249f1a8f5d6b725)
]);
const $e1b45de317ee2288$export$7684a7ad17d11565 = Object.freeze({
    ...$e1b45de317ee2288$export$f5f9e866e854b681,
    ...$e1b45de317ee2288$export$2bd93abaa47d773b,
    ...$e1b45de317ee2288$export$aebdc60e0ed8c4a5
});
const $e1b45de317ee2288$export$aeb5ffc4d17f8d05 = $e1b45de317ee2288$export$a1c94f11d0704ec5.omit({
    value: true
}).merge((0, $c3dK3.z).object({
    signingKeyAlgorithm: (0, $c3dK3.z).nativeEnum($e1b45de317ee2288$export$e33814a1cc7d5e24).optional()
}));

});
parcelRequire.register("6NioG", function(module, exports) {

$parcel$export(module.exports, "LogtoJwtTokenKeyType", function () { return $4f2596f451c6093f$export$2b5732891b015568; });
$parcel$export(module.exports, "accessTokenJwtCustomizerGuard", function () { return $4f2596f451c6093f$export$91f53954808434ef; });
$parcel$export(module.exports, "clientCredentialsJwtCustomizerGuard", function () { return $4f2596f451c6093f$export$7c0ea0dbf45c263b; });
parcelRequire("oK7kD");
var $j080Y = parcelRequire("j080Y");

var $c3dK3 = parcelRequire("c3dK3");
parcelRequire("gh8Fv");
var $jXiNi = parcelRequire("jXiNi");
var $5JzQP = parcelRequire("5JzQP");
var $bfvuB = parcelRequire("bfvuB");
parcelRequire("5Fb6p");
var $8lyC3 = parcelRequire("8lyC3");

var $i0p1H = parcelRequire("i0p1H");

var $68782 = parcelRequire("68782");

var $9PiNF = parcelRequire("9PiNF");
const $4f2596f451c6093f$export$35f2e5a17d1b65f1 = (0, $c3dK3.z).object({
    script: (0, $c3dK3.z).string(),
    environmentVariables: (0, $c3dK3.z).record((0, $c3dK3.z).string()).optional(),
    contextSample: (0, $j080Y.jsonObjectGuard).optional()
});
var $4f2596f451c6093f$export$2b5732891b015568;
(function(LogtoJwtTokenKeyType) {
    LogtoJwtTokenKeyType["AccessToken"] = "access-token";
    LogtoJwtTokenKeyType["ClientCredentials"] = "client-credentials";
})($4f2596f451c6093f$export$2b5732891b015568 || ($4f2596f451c6093f$export$2b5732891b015568 = {}));
const $4f2596f451c6093f$export$f3e66f6027afb6ea = (0, $68782.userInfoGuard).extend({
    ssoIdentities: (0, $jXiNi.UserSsoIdentities).guard.pick({
        issuer: true,
        identityId: true,
        detail: true
    }).array(),
    mfaVerificationFactors: (0, $8lyC3.mfaFactorsGuard),
    roles: (0, $5JzQP.Roles).guard.pick({
        id: true,
        name: true,
        description: true
    }).extend({
        scopes: (0, $i0p1H.scopeResponseGuard).pick({
            id: true,
            name: true,
            description: true,
            resourceId: true,
            resource: true
        }).array()
    }).array(),
    organizations: (0, $bfvuB.Organizations).guard.pick({
        id: true,
        name: true,
        description: true
    }).array(),
    organizationRoles: (0, $c3dK3.z).object({
        organizationId: (0, $c3dK3.z).string(),
        roleId: (0, $c3dK3.z).string(),
        roleName: (0, $c3dK3.z).string()
    }).array()
});
const $4f2596f451c6093f$export$91f53954808434ef = $4f2596f451c6093f$export$35f2e5a17d1b65f1.extend({
    // Use partial token guard since users customization may not rely on all fields.
    tokenSample: (0, $9PiNF.accessTokenPayloadGuard).partial().optional(),
    contextSample: (0, $c3dK3.z).object({
        user: $4f2596f451c6093f$export$f3e66f6027afb6ea.partial()
    }).optional()
}).strict();
const $4f2596f451c6093f$export$7c0ea0dbf45c263b = $4f2596f451c6093f$export$35f2e5a17d1b65f1.extend({
    // Use partial token guard since users customization may not rely on all fields.
    tokenSample: (0, $9PiNF.clientCredentialsPayloadGuard).partial().optional()
}).strict();
const $4f2596f451c6093f$export$862c888fb3aaa059 = (0, $c3dK3.z).discriminatedUnion("tokenType", [
    (0, $c3dK3.z).object({
        tokenType: (0, $c3dK3.z).literal($4f2596f451c6093f$export$2b5732891b015568.AccessToken),
        ...$4f2596f451c6093f$export$91f53954808434ef.pick({
            environmentVariables: true,
            script: true
        }).shape,
        token: $4f2596f451c6093f$export$91f53954808434ef.required().shape.tokenSample,
        context: $4f2596f451c6093f$export$91f53954808434ef.required().shape.contextSample
    }),
    (0, $c3dK3.z).object({
        tokenType: (0, $c3dK3.z).literal($4f2596f451c6093f$export$2b5732891b015568.ClientCredentials),
        ...$4f2596f451c6093f$export$7c0ea0dbf45c263b.pick({
            environmentVariables: true,
            script: true
        }).shape,
        token: $4f2596f451c6093f$export$7c0ea0dbf45c263b.required().shape.tokenSample
    })
]);
/**
 * This guard is for cloud API use (request body guard).
 * Since the cloud API will be use by both testing and production, should keep the fields as general as possible.
 * The response guard for the cloud API is `jsonObjectGuard` since it extends the `token` with extra claims.
 */ const $4f2596f451c6093f$var$commonJwtCustomizerGuard = $4f2596f451c6093f$export$35f2e5a17d1b65f1.pick({
    script: true,
    environmentVariables: true
}).required({
    script: true
}).extend({
    token: (0, $j080Y.jsonObjectGuard)
});
const $4f2596f451c6093f$export$7a76d1cb4609fd08 = (0, $c3dK3.z).discriminatedUnion("tokenType", [
    $4f2596f451c6093f$var$commonJwtCustomizerGuard.extend({
        tokenType: (0, $c3dK3.z).literal($4f2596f451c6093f$export$2b5732891b015568.AccessToken),
        context: (0, $j080Y.jsonObjectGuard)
    }),
    $4f2596f451c6093f$var$commonJwtCustomizerGuard.extend({
        tokenType: (0, $c3dK3.z).literal($4f2596f451c6093f$export$2b5732891b015568.ClientCredentials)
    })
]);

});
parcelRequire.register("i0p1H", function(module, exports) {

$parcel$export(module.exports, "scopeResponseGuard", function () { return $d1bba3d0399f1a45$export$3efa9f96d1ddc3f2; });
parcelRequire("gh8Fv");
var $fidVk = parcelRequire("fidVk");
var $9Jr5u = parcelRequire("9Jr5u");
const $d1bba3d0399f1a45$export$3efa9f96d1ddc3f2 = (0, $fidVk.Scopes).guard.extend({
    resource: (0, $9Jr5u.Resources).guard
});

});

parcelRequire.register("9PiNF", function(module, exports) {

$parcel$export(module.exports, "accessTokenPayloadGuard", function () { return $727775c9947e925c$export$e75da9f812cdc25c; });
$parcel$export(module.exports, "clientCredentialsPayloadGuard", function () { return $727775c9947e925c$export$702899eeb662faa6; });
/**
 * Manually implement zod guards of some node OIDC provider types.
 *
 * Please note that we defined `accessTokenPayloadGuard` and `clientCredentialsPayloadGuard` in this file, they are used to make the user-defined token
 * sample to be aligned with the real token payload given by the OIDC provider in a real use case.
 *
 * Only keep the least necessary fields in the guards to align with the raw token payload that can be used for `extraTokenClaims` method.
 */ 
var $c3dK3 = parcelRequire("c3dK3");
const $727775c9947e925c$var$baseTokenPayloadGuardObject = {
    jti: (0, $c3dK3.z).string(),
    aud: (0, $c3dK3.z).union([
        (0, $c3dK3.z).string(),
        (0, $c3dK3.z).string().array()
    ]),
    scope: (0, $c3dK3.z).string().optional(),
    clientId: (0, $c3dK3.z).string().optional()
};
const $727775c9947e925c$export$e75da9f812cdc25c = (0, $c3dK3.z).object({
    ...$727775c9947e925c$var$baseTokenPayloadGuardObject,
    accountId: (0, $c3dK3.z).string(),
    expiresWithSession: (0, $c3dK3.z).boolean().optional(),
    grantId: (0, $c3dK3.z).string(),
    gty: (0, $c3dK3.z).string(),
    sessionUid: (0, $c3dK3.z).string().optional(),
    sid: (0, $c3dK3.z).string().optional(),
    kind: (0, $c3dK3.z).literal("AccessToken")
}).strict();
const $727775c9947e925c$export$702899eeb662faa6 = (0, $c3dK3.z).object({
    ...$727775c9947e925c$var$baseTokenPayloadGuardObject,
    kind: (0, $c3dK3.z).literal("ClientCredentials")
}).strict();

});



parcelRequire.register("5MAQz", function(module, exports) {
parcelRequire("4taJ0");
var $9vrm1 = parcelRequire("9vrm1");

var $c3dK3 = parcelRequire("c3dK3");
parcelRequire("5Fb6p");
var $j080Y = parcelRequire("j080Y");
var $8lyC3 = parcelRequire("8lyC3");
var $1QRmm = parcelRequire("1QRmm");

var $8QmIT = parcelRequire("8QmIT");
const $435e047ab0c1d664$export$6df2cc07ea6d94e4 = (0, $c3dK3.z).object({
    username: (0, $c3dK3.z).string().min(1),
    password: (0, $c3dK3.z).string().min(1)
});
const $435e047ab0c1d664$export$fe8dab8622cea973 = (0, $c3dK3.z).object({
    email: (0, $c3dK3.z).string().min(1),
    password: (0, $c3dK3.z).string().min(1)
});
const $435e047ab0c1d664$export$654a1e6496f28807 = (0, $c3dK3.z).object({
    phone: (0, $c3dK3.z).string().min(1),
    password: (0, $c3dK3.z).string().min(1)
});
const $435e047ab0c1d664$export$37cf496dfd2fc283 = (0, $c3dK3.z).object({
    connectorId: (0, $c3dK3.z).string(),
    connectorData: (0, $j080Y.jsonObjectGuard)
});
const $435e047ab0c1d664$export$c45e1b6fde4cf46f = (0, $c3dK3.z).object({
    connectorId: (0, $c3dK3.z).string(),
    email: (0, $c3dK3.z).string()
});
const $435e047ab0c1d664$export$368d623e521112fc = (0, $c3dK3.z).object({
    connectorId: (0, $c3dK3.z).string(),
    phone: (0, $c3dK3.z).string()
});
var $435e047ab0c1d664$export$5b6496a0e009b82d;
(function(InteractionEvent) {
    InteractionEvent["SignIn"] = "SignIn";
    InteractionEvent["Register"] = "Register";
    InteractionEvent["ForgotPassword"] = "ForgotPassword";
})($435e047ab0c1d664$export$5b6496a0e009b82d || ($435e047ab0c1d664$export$5b6496a0e009b82d = {}));
const $435e047ab0c1d664$export$bdffc825a5318abd = (0, $c3dK3.z).nativeEnum($435e047ab0c1d664$export$5b6496a0e009b82d);
const $435e047ab0c1d664$export$683a5ef9930735ce = (0, $c3dK3.z).union([
    $435e047ab0c1d664$export$6df2cc07ea6d94e4,
    $435e047ab0c1d664$export$fe8dab8622cea973,
    $435e047ab0c1d664$export$654a1e6496f28807,
    (0, $8QmIT.emailVerificationCodePayloadGuard),
    (0, $8QmIT.phoneVerificationCodePayloadGuard),
    $435e047ab0c1d664$export$37cf496dfd2fc283,
    $435e047ab0c1d664$export$c45e1b6fde4cf46f,
    $435e047ab0c1d664$export$368d623e521112fc
]);
const $435e047ab0c1d664$export$5f4b9d03b6e579b = (0, $c3dK3.z).object({
    username: (0, $c3dK3.z).string().regex((0, $9vrm1.usernameRegEx)).optional(),
    email: (0, $c3dK3.z).string().regex((0, $9vrm1.emailRegEx)).optional(),
    phone: (0, $c3dK3.z).string().regex((0, $9vrm1.phoneRegEx)).optional(),
    connectorId: (0, $c3dK3.z).string().optional(),
    password: (0, $c3dK3.z).string().optional()
});
var $435e047ab0c1d664$export$68a887ed3b61b98e;
(function(MissingProfile) {
    MissingProfile["username"] = "username";
    MissingProfile["email"] = "email";
    MissingProfile["phone"] = "phone";
    MissingProfile["password"] = "password";
    MissingProfile["emailOrPhone"] = "emailOrPhone";
})($435e047ab0c1d664$export$68a887ed3b61b98e || ($435e047ab0c1d664$export$68a887ed3b61b98e = {}));
const $435e047ab0c1d664$export$3cf8b0ef3f34f283 = (0, $c3dK3.z).object({
    // Unlike identifier payload which has indicator like "email",
    // mfa payload must have an additional type field to indicate type
    type: (0, $c3dK3.z).literal((0, $8lyC3.MfaFactor).TOTP),
    code: (0, $c3dK3.z).string()
});
const $435e047ab0c1d664$export$909f398f25e38a05 = (0, $c3dK3.z).object({
    type: (0, $c3dK3.z).literal((0, $8lyC3.MfaFactor).WebAuthn),
    id: (0, $c3dK3.z).string(),
    rawId: (0, $c3dK3.z).string(),
    /**
     * The response from WebAuthn API
     *
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/PublicKeyCredential}
     */ response: (0, $c3dK3.z).object({
        clientDataJSON: (0, $c3dK3.z).string(),
        attestationObject: (0, $c3dK3.z).string(),
        authenticatorData: (0, $c3dK3.z).string().optional(),
        transports: (0, $1QRmm.webAuthnTransportGuard).array().optional(),
        publicKeyAlgorithm: (0, $c3dK3.z).number().optional(),
        publicKey: (0, $c3dK3.z).string().optional()
    }),
    authenticatorAttachment: (0, $c3dK3.z).enum([
        "cross-platform",
        "platform"
    ]).optional(),
    clientExtensionResults: (0, $c3dK3.z).object({
        appid: (0, $c3dK3.z).boolean().optional(),
        crepProps: (0, $c3dK3.z).object({
            rk: (0, $c3dK3.z).boolean().optional()
        }).optional(),
        hmacCreateSecret: (0, $c3dK3.z).boolean().optional()
    })
});
const $435e047ab0c1d664$export$f2b00820cf0758fd = (0, $c3dK3.z).object({
    type: (0, $c3dK3.z).literal((0, $8lyC3.MfaFactor).BackupCode)
});
const $435e047ab0c1d664$export$dd85cb6e2ec2273d = (0, $c3dK3.z).discriminatedUnion("type", [
    $435e047ab0c1d664$export$3cf8b0ef3f34f283,
    $435e047ab0c1d664$export$909f398f25e38a05,
    $435e047ab0c1d664$export$f2b00820cf0758fd
]);
const $435e047ab0c1d664$export$850eb029f701b547 = $435e047ab0c1d664$export$3cf8b0ef3f34f283;
const $435e047ab0c1d664$export$4cf08ba69fb7c5b0 = $435e047ab0c1d664$export$909f398f25e38a05.omit({
    response: true
}).extend({
    response: (0, $c3dK3.z).object({
        clientDataJSON: (0, $c3dK3.z).string(),
        authenticatorData: (0, $c3dK3.z).string(),
        signature: (0, $c3dK3.z).string(),
        userHandle: (0, $c3dK3.z).string().optional()
    })
});
const $435e047ab0c1d664$export$975166347c3a7642 = (0, $c3dK3.z).object({
    type: (0, $c3dK3.z).literal((0, $8lyC3.MfaFactor).BackupCode),
    code: (0, $c3dK3.z).string()
});
const $435e047ab0c1d664$export$4d6ec7236b10bd3 = (0, $c3dK3.z).discriminatedUnion("type", [
    $435e047ab0c1d664$export$850eb029f701b547,
    $435e047ab0c1d664$export$4cf08ba69fb7c5b0,
    $435e047ab0c1d664$export$975166347c3a7642
]);
const $435e047ab0c1d664$export$fc67cd5d235908c3 = (0, $c3dK3.z).object({
    type: (0, $c3dK3.z).literal((0, $8lyC3.MfaFactor).TOTP),
    secret: (0, $c3dK3.z).string()
});
const $435e047ab0c1d664$export$5159fecc862158ed = (0, $c3dK3.z).object({
    type: (0, $c3dK3.z).literal((0, $8lyC3.MfaFactor).WebAuthn),
    challenge: (0, $c3dK3.z).string()
});
const $435e047ab0c1d664$export$ea1eb8d3018f63a8 = (0, $c3dK3.z).object({
    type: (0, $c3dK3.z).literal((0, $8lyC3.MfaFactor).BackupCode),
    codes: (0, $c3dK3.z).array((0, $c3dK3.z).string())
});
const $435e047ab0c1d664$export$ad9fd10992842c85 = (0, $c3dK3.z).discriminatedUnion("type", [
    $435e047ab0c1d664$export$fc67cd5d235908c3,
    $435e047ab0c1d664$export$5159fecc862158ed,
    $435e047ab0c1d664$export$ea1eb8d3018f63a8
]);
const $435e047ab0c1d664$export$4a8ba443157a60f8 = $435e047ab0c1d664$export$fc67cd5d235908c3;
const $435e047ab0c1d664$export$9c31fcc1c40b68d4 = (0, $c3dK3.z).object({
    type: (0, $c3dK3.z).literal((0, $8lyC3.MfaFactor).WebAuthn),
    credentialId: (0, $c3dK3.z).string(),
    publicKey: (0, $c3dK3.z).string(),
    transports: (0, $1QRmm.webAuthnTransportGuard).array(),
    counter: (0, $c3dK3.z).number(),
    agent: (0, $c3dK3.z).string()
});
const $435e047ab0c1d664$export$d103a080e257fd4e = $435e047ab0c1d664$export$ea1eb8d3018f63a8;
const $435e047ab0c1d664$export$346032d688e2ee1d = (0, $c3dK3.z).discriminatedUnion("type", [
    $435e047ab0c1d664$export$4a8ba443157a60f8,
    $435e047ab0c1d664$export$9c31fcc1c40b68d4,
    $435e047ab0c1d664$export$d103a080e257fd4e
]);
const $435e047ab0c1d664$export$7d4f7ea03460ffc6 = (0, $c3dK3.z).object({
    type: (0, $c3dK3.z).nativeEnum((0, $8lyC3.MfaFactor)),
    id: (0, $c3dK3.z).string()
});

});
parcelRequire.register("8QmIT", function(module, exports) {

$parcel$export(module.exports, "emailVerificationCodePayloadGuard", function () { return $6704ce69a89f727f$export$37e88450d6946bf5; });
$parcel$export(module.exports, "phoneVerificationCodePayloadGuard", function () { return $6704ce69a89f727f$export$7934fcc6bad2c738; });
parcelRequire("4taJ0");
var $9vrm1 = parcelRequire("9vrm1");

var $c3dK3 = parcelRequire("c3dK3");
const $6704ce69a89f727f$var$emailIdentifierGuard = (0, $c3dK3.z).string().regex((0, $9vrm1.emailRegEx));
const $6704ce69a89f727f$var$phoneIdentifierGuard = (0, $c3dK3.z).string().regex((0, $9vrm1.phoneRegEx));
const $6704ce69a89f727f$var$codeGuard = (0, $c3dK3.z).string().min(1);
const $6704ce69a89f727f$export$6d0d05bfd78fb80d = (0, $c3dK3.z).union([
    (0, $c3dK3.z).object({
        email: $6704ce69a89f727f$var$emailIdentifierGuard
    }),
    (0, $c3dK3.z).object({
        phone: $6704ce69a89f727f$var$phoneIdentifierGuard
    })
]);
const $6704ce69a89f727f$export$37e88450d6946bf5 = (0, $c3dK3.z).object({
    email: $6704ce69a89f727f$var$emailIdentifierGuard,
    verificationCode: $6704ce69a89f727f$var$codeGuard
});
const $6704ce69a89f727f$export$7934fcc6bad2c738 = (0, $c3dK3.z).object({
    phone: $6704ce69a89f727f$var$phoneIdentifierGuard,
    verificationCode: $6704ce69a89f727f$var$codeGuard
});
const $6704ce69a89f727f$export$40faae2aa67d03fa = (0, $c3dK3.z).union([
    $6704ce69a89f727f$export$37e88450d6946bf5,
    $6704ce69a89f727f$export$7934fcc6bad2c738
]);

});


parcelRequire.register("fG133", function(module, exports) {
/** Mode for matching the given value(s) and database entries. */ var $b69b976f6ef1229e$export$a51f1551b9b55e4d;
(function(SearchMatchMode) {
    /** Use `=` or in-array checking. */ SearchMatchMode["Exact"] = "exact";
    /** Use the keyword `LIKE`. See [Postgres docs](https://www.postgresql.org/docs/current/functions-matching.html#FUNCTIONS-LIKE). */ SearchMatchMode["Like"] = "like";
    /** Use the keyword `SIMILAR TO` for regular expression matching. See [Postgres docs](https://www.postgresql.org/docs/current/functions-matching.html#FUNCTIONS-SIMILARTO-REGEXP). */ SearchMatchMode["SimilarTo"] = "similar_to";
    /** Use the keyword `POSIX` for regular expression matching. See [Postgres docs](https://www.postgresql.org/docs/current/functions-matching.html#FUNCTIONS-POSIX-REGEXP). */ SearchMatchMode["Posix"] = "posix";
})($b69b976f6ef1229e$export$a51f1551b9b55e4d || ($b69b976f6ef1229e$export$a51f1551b9b55e4d = {}));
var $b69b976f6ef1229e$export$6d217b707eba5852;
(function(SearchJointMode) {
    SearchJointMode["Or"] = "or";
    SearchJointMode["And"] = "and";
})($b69b976f6ef1229e$export$6d217b707eba5852 || ($b69b976f6ef1229e$export$6d217b707eba5852 = {}));

});

parcelRequire.register("1R5lx", function(module, exports) {

});

parcelRequire.register("3D8rM", function(module, exports) {

});

parcelRequire.register("fGvTA", function(module, exports) {

$parcel$export(module.exports, "ApplicationUserConsentScopeType", function () { return $b6b38512cc69ea1a$export$9b2e974edaaa0e9c; });
parcelRequire("4taJ0");
var $hyigV = parcelRequire("hyigV");

var $c3dK3 = parcelRequire("c3dK3");
parcelRequire("gh8Fv");
var $4Ecj3 = parcelRequire("4Ecj3");
var $9Jr5u = parcelRequire("9Jr5u");
var $fidVk = parcelRequire("fidVk");
var $bPimI = parcelRequire("bPimI");
var $6jyLL = parcelRequire("6jyLL");
const $b6b38512cc69ea1a$export$71547dc50acd9a7c = (0, $4Ecj3.Applications).guard.pick({
    id: true,
    name: true,
    type: true
});
const $b6b38512cc69ea1a$export$590c2403cf18bb08 = (0, $4Ecj3.Applications).createGuard.omit({
    id: true,
    createdAt: true,
    secret: true,
    tenantId: true
}).partial().merge((0, $4Ecj3.Applications).createGuard.pick({
    name: true,
    type: true
}));
const $b6b38512cc69ea1a$export$f8933e674a6d3243 = $b6b38512cc69ea1a$export$590c2403cf18bb08.partial().omit({
    type: true,
    isThirdParty: true
});
const $b6b38512cc69ea1a$var$resourceScopesGuard = (0, $c3dK3.z).array((0, $c3dK3.z).object({
    resource: (0, $9Jr5u.Resources).guard.pick({
        id: true,
        name: true,
        indicator: true
    }),
    scopes: (0, $c3dK3.z).array((0, $fidVk.Scopes).guard.pick({
        id: true,
        name: true,
        description: true
    }))
}));
const $b6b38512cc69ea1a$export$8f1fa196fa63bf04 = (0, $c3dK3.z).object({
    organizationScopes: (0, $c3dK3.z).array((0, $bPimI.OrganizationScopes).guard.pick({
        id: true,
        name: true,
        description: true
    })),
    resourceScopes: $b6b38512cc69ea1a$var$resourceScopesGuard,
    organizationResourceScopes: $b6b38512cc69ea1a$var$resourceScopesGuard,
    userScopes: (0, $c3dK3.z).array((0, $c3dK3.z).nativeEnum((0, $hyigV.UserScope)))
});
var $b6b38512cc69ea1a$export$9b2e974edaaa0e9c;
(function(ApplicationUserConsentScopeType) {
    ApplicationUserConsentScopeType["OrganizationScopes"] = "organization-scopes";
    ApplicationUserConsentScopeType["ResourceScopes"] = "resource-scopes";
    ApplicationUserConsentScopeType["OrganizationResourceScopes"] = "organization-resource-scopes";
    ApplicationUserConsentScopeType["UserScopes"] = "user-scopes";
})($b6b38512cc69ea1a$export$9b2e974edaaa0e9c || ($b6b38512cc69ea1a$export$9b2e974edaaa0e9c = {}));
const $b6b38512cc69ea1a$export$8629c19b82b57228 = (0, $6jyLL.ApplicationSignInExperiences).createGuard.omit({
    applicationId: true,
    tenantId: true,
    termsOfUseUrl: true,
    privacyPolicyUrl: true
})// Align with the sign-in-experience create guard.
.merge((0, $c3dK3.z).object({
    termsOfUseUrl: (0, $c3dK3.z).string().max(2048).url().optional().nullable().or((0, $c3dK3.z).literal("")),
    privacyPolicyUrl: (0, $c3dK3.z).string().max(2048).url().optional().nullable().or((0, $c3dK3.z).literal(""))
}));

});

parcelRequire.register("5lhZO", function(module, exports) {

var $c3dK3 = parcelRequire("c3dK3");
var $3e3cdf882cde90e0$export$4857b48889187a39;
(function(AlterationStateKey) {
    AlterationStateKey["AlterationState"] = "alterationState";
})($3e3cdf882cde90e0$export$4857b48889187a39 || ($3e3cdf882cde90e0$export$4857b48889187a39 = {}));
const $3e3cdf882cde90e0$export$b648b84528d1cda3 = Object.freeze({
    [$3e3cdf882cde90e0$export$4857b48889187a39.AlterationState]: (0, $c3dK3.z).object({
        timestamp: (0, $c3dK3.z).number(),
        updatedAt: (0, $c3dK3.z).string().optional()
    })
});
var $3e3cdf882cde90e0$export$465a18018f692373;
(function(StorageProvider) {
    StorageProvider["AzureStorage"] = "AzureStorage";
    StorageProvider["S3Storage"] = "S3Storage";
    StorageProvider["GoogleStorage"] = "GoogleStorage";
})($3e3cdf882cde90e0$export$465a18018f692373 || ($3e3cdf882cde90e0$export$465a18018f692373 = {}));
const $3e3cdf882cde90e0$var$basicConfig = {
    publicUrl: (0, $c3dK3.z).string().optional()
};
const $3e3cdf882cde90e0$export$6882da4bfe6c548e = (0, $c3dK3.z).discriminatedUnion("provider", [
    (0, $c3dK3.z).object({
        provider: (0, $c3dK3.z).literal($3e3cdf882cde90e0$export$465a18018f692373.AzureStorage),
        connectionString: (0, $c3dK3.z).string(),
        container: (0, $c3dK3.z).string(),
        ...$3e3cdf882cde90e0$var$basicConfig
    }),
    (0, $c3dK3.z).object({
        provider: (0, $c3dK3.z).literal($3e3cdf882cde90e0$export$465a18018f692373.S3Storage),
        endpoint: (0, $c3dK3.z).string().optional(),
        region: (0, $c3dK3.z).string().optional(),
        bucket: (0, $c3dK3.z).string(),
        accessKeyId: (0, $c3dK3.z).string(),
        accessSecretKey: (0, $c3dK3.z).string(),
        ...$3e3cdf882cde90e0$var$basicConfig
    }),
    (0, $c3dK3.z).object({
        provider: (0, $c3dK3.z).literal($3e3cdf882cde90e0$export$465a18018f692373.GoogleStorage),
        projectId: (0, $c3dK3.z).string(),
        keyFilename: (0, $c3dK3.z).string(),
        bucketName: (0, $c3dK3.z).string(),
        ...$3e3cdf882cde90e0$var$basicConfig
    })
]);
var $3e3cdf882cde90e0$export$589fea410707bd1e;
(function(StorageProviderKey) {
    StorageProviderKey["StorageProvider"] = "storageProvider";
})($3e3cdf882cde90e0$export$589fea410707bd1e || ($3e3cdf882cde90e0$export$589fea410707bd1e = {}));
const $3e3cdf882cde90e0$export$1755428192b369f4 = Object.freeze({
    [$3e3cdf882cde90e0$export$589fea410707bd1e.StorageProvider]: $3e3cdf882cde90e0$export$6882da4bfe6c548e
});
var $3e3cdf882cde90e0$export$c04e0db396d22ede;
(function(EmailServiceProvider) {
    EmailServiceProvider["SendGrid"] = "SendGrid";
})($3e3cdf882cde90e0$export$c04e0db396d22ede || ($3e3cdf882cde90e0$export$c04e0db396d22ede = {}));
const $3e3cdf882cde90e0$export$ae559586eab6a29d = (0, $c3dK3.z).object({
    provider: (0, $c3dK3.z).literal($3e3cdf882cde90e0$export$c04e0db396d22ede.SendGrid),
    apiKey: (0, $c3dK3.z).string(),
    templateId: (0, $c3dK3.z).string(),
    fromName: (0, $c3dK3.z).string(),
    fromEmail: (0, $c3dK3.z).string()
});
const $3e3cdf882cde90e0$export$eed90e6abe4b6331 = (0, $c3dK3.z).discriminatedUnion("provider", [
    $3e3cdf882cde90e0$export$ae559586eab6a29d
]);
var $3e3cdf882cde90e0$export$1b716a2fb233f165;
(function(EmailServiceProviderKey) {
    EmailServiceProviderKey["EmailServiceProvider"] = "emailServiceProvider";
})($3e3cdf882cde90e0$export$1b716a2fb233f165 || ($3e3cdf882cde90e0$export$1b716a2fb233f165 = {}));
const $3e3cdf882cde90e0$export$148ac52baf2fe1fe = Object.freeze({
    [$3e3cdf882cde90e0$export$1b716a2fb233f165.EmailServiceProvider]: $3e3cdf882cde90e0$export$eed90e6abe4b6331
});
var $3e3cdf882cde90e0$export$3f96ea771b870c9b;
(function(DemoSocialProvider) {
    DemoSocialProvider["Google"] = "google";
    DemoSocialProvider["GitHub"] = "github";
    DemoSocialProvider["Discord"] = "discord";
})($3e3cdf882cde90e0$export$3f96ea771b870c9b || ($3e3cdf882cde90e0$export$3f96ea771b870c9b = {}));
const $3e3cdf882cde90e0$export$b0cb774a6cdd5c2c = (0, $c3dK3.z).object({
    name: (0, $c3dK3.z).string(),
    logo: (0, $c3dK3.z).string(),
    logoDark: (0, $c3dK3.z).string(),
    provider: (0, $c3dK3.z).nativeEnum($3e3cdf882cde90e0$export$3f96ea771b870c9b),
    clientId: (0, $c3dK3.z).string()
}).array();
var $3e3cdf882cde90e0$export$2b6e95870946a21e;
(function(DemoSocialKey) {
    DemoSocialKey["DemoSocial"] = "demoSocial";
})($3e3cdf882cde90e0$export$2b6e95870946a21e || ($3e3cdf882cde90e0$export$2b6e95870946a21e = {}));
const $3e3cdf882cde90e0$export$ae90bacd174e78c0 = Object.freeze({
    [$3e3cdf882cde90e0$export$2b6e95870946a21e.DemoSocial]: $3e3cdf882cde90e0$export$b0cb774a6cdd5c2c
});
const $3e3cdf882cde90e0$export$4792a20f2d99e347 = (0, $c3dK3.z).object({
    zoneId: (0, $c3dK3.z).string(),
    apiToken: (0, $c3dK3.z).string(),
    blockedDomains: (0, $c3dK3.z).string().array().optional()
});
const $3e3cdf882cde90e0$export$aa9834a14f8dda83 = (0, $c3dK3.z).object({
    /* Cloudflare Workers & Pages account ID */ accountIdentifier: (0, $c3dK3.z).string(),
    /* KV namespace ID */ namespaceIdentifier: (0, $c3dK3.z).string(),
    /* Key prefix for protected app config */ keyName: (0, $c3dK3.z).string(),
    /* The default domain (e.g protected.app) for the protected app */ domain: (0, $c3dK3.z).string(),
    apiToken: (0, $c3dK3.z).string()
});
const $3e3cdf882cde90e0$export$17c589ef0ecd4097 = (0, $c3dK3.z).object({
    /** Cloudflare API Key (api_key). */ apiKey: (0, $c3dK3.z).string(),
    /** Cloudflare API Key (api_email). */ apiEmail: (0, $c3dK3.z).string(),
    /** Cloudflare account ID. */ accountId: (0, $c3dK3.z).string(),
    /** Default Cloudflare subdomain for the account. */ subdomain: (0, $c3dK3.z).string()
});
var $3e3cdf882cde90e0$export$24bf5ccdb699e65e;
(function(CloudflareKey) {
    CloudflareKey["HostnameProvider"] = "cloudflareHostnameProvider";
    CloudflareKey["ProtectedAppConfigProvider"] = "cloudflareProtectedAppConfigProvider";
    CloudflareKey["ProtectedAppHostnameProvider"] = "cloudflareProtectedAppHostnameProvider";
    CloudflareKey["CustomJwtWorkerConfig"] = "cloudflareCustomJwtWorkerConfig";
})($3e3cdf882cde90e0$export$24bf5ccdb699e65e || ($3e3cdf882cde90e0$export$24bf5ccdb699e65e = {}));
const $3e3cdf882cde90e0$export$7dae3b09179b4445 = Object.freeze({
    [$3e3cdf882cde90e0$export$24bf5ccdb699e65e.HostnameProvider]: $3e3cdf882cde90e0$export$4792a20f2d99e347,
    [$3e3cdf882cde90e0$export$24bf5ccdb699e65e.ProtectedAppConfigProvider]: $3e3cdf882cde90e0$export$aa9834a14f8dda83,
    [$3e3cdf882cde90e0$export$24bf5ccdb699e65e.ProtectedAppHostnameProvider]: $3e3cdf882cde90e0$export$4792a20f2d99e347,
    [$3e3cdf882cde90e0$export$24bf5ccdb699e65e.CustomJwtWorkerConfig]: $3e3cdf882cde90e0$export$17c589ef0ecd4097
});
const $3e3cdf882cde90e0$export$20b0450fb73770e2 = Object.freeze([
    ...Object.values($3e3cdf882cde90e0$export$4857b48889187a39),
    ...Object.values($3e3cdf882cde90e0$export$589fea410707bd1e),
    ...Object.values($3e3cdf882cde90e0$export$2b6e95870946a21e),
    ...Object.values($3e3cdf882cde90e0$export$24bf5ccdb699e65e),
    ...Object.values($3e3cdf882cde90e0$export$1b716a2fb233f165)
]);
const $3e3cdf882cde90e0$export$b74a29afb5bd243f = Object.freeze({
    ...$3e3cdf882cde90e0$export$b648b84528d1cda3,
    ...$3e3cdf882cde90e0$export$1755428192b369f4,
    ...$3e3cdf882cde90e0$export$ae90bacd174e78c0,
    ...$3e3cdf882cde90e0$export$7dae3b09179b4445,
    ...$3e3cdf882cde90e0$export$148ac52baf2fe1fe
});

});

parcelRequire.register("2rWG7", function(module, exports) {

$parcel$export(module.exports, "maxUploadFileSize", function () { return $1c8b9eb19b7c5033$export$8ef133238cd2874; });

var $c3dK3 = parcelRequire("c3dK3");
const $1c8b9eb19b7c5033$export$8ef133238cd2874 = 8388608; // 8MB
const $1c8b9eb19b7c5033$export$e2adfe8ff5d50ee4 = [
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/vnd.microsoft.icon",
    "image/x-icon",
    "image/svg+xml",
    "image/tiff",
    "image/webp",
    "image/bmp"
];
const $1c8b9eb19b7c5033$var$allowUploadMimeTypeGuard = (0, $c3dK3.z).enum($1c8b9eb19b7c5033$export$e2adfe8ff5d50ee4);
const $1c8b9eb19b7c5033$export$2dd272e4b553b8ba = (0, $c3dK3.z).object({
    status: (0, $c3dK3.z).union([
        (0, $c3dK3.z).literal("ready"),
        (0, $c3dK3.z).literal("not_configured")
    ]),
    allowUploadMimeTypes: (0, $c3dK3.z).array($1c8b9eb19b7c5033$var$allowUploadMimeTypeGuard).optional(),
    maxUploadFileSize: (0, $c3dK3.z).number().optional()
});
const $1c8b9eb19b7c5033$export$aaf4674b6bfc26fb = (0, $c3dK3.z).object({
    url: (0, $c3dK3.z).string()
});

});

parcelRequire.register("kSjlW", function(module, exports) {

$parcel$export(module.exports, "hookTestErrorResponseDataGuard", function () { return $f327dce5f5c90da0$export$4d1fa1bc05a05454; });

var $c3dK3 = parcelRequire("c3dK3");
parcelRequire("gh8Fv");
var $jX6AI = parcelRequire("jX6AI");
const $f327dce5f5c90da0$var$hookExecutionStatsGuard = (0, $c3dK3.z).object({
    successCount: (0, $c3dK3.z).number(),
    requestCount: (0, $c3dK3.z).number()
});
const $f327dce5f5c90da0$export$5c5f088aefddc59e = (0, $jX6AI.Hooks).guard.extend({
    executionStats: $f327dce5f5c90da0$var$hookExecutionStatsGuard
});
const $f327dce5f5c90da0$export$4d1fa1bc05a05454 = (0, $c3dK3.z).object({
    responseStatus: (0, $c3dK3.z).number(),
    responseBody: (0, $c3dK3.z).string()
});

});

parcelRequire.register("6VmW0", function(module, exports) {
var $50a9db4b9198ebb4$export$2cad645b7df28dd5;
(function(ServiceLogType) {
    ServiceLogType["SendEmail"] = "sendEmail";
    ServiceLogType["SendSms"] = "sendSms";
    ServiceLogType["FetchCustomJwt"] = "fetchCustomJwt";
})($50a9db4b9198ebb4$export$2cad645b7df28dd5 || ($50a9db4b9198ebb4$export$2cad645b7df28dd5 = {}));

});

parcelRequire.register("5HVJe", function(module, exports) {

$parcel$export(module.exports, "Theme", function () { return $427dbf93becc8708$export$14faa19a0f3bbeb2; });
var $427dbf93becc8708$export$14faa19a0f3bbeb2;
(function(Theme) {
    Theme["Light"] = "light";
    Theme["Dark"] = "dark";
})($427dbf93becc8708$export$14faa19a0f3bbeb2 || ($427dbf93becc8708$export$14faa19a0f3bbeb2 = {}));

});

parcelRequire.register("eriGJ", function(module, exports) {

var $c3dK3 = parcelRequire("c3dK3");
const $a832156989c9ca2c$export$3b9208034fe791c1 = (0, $c3dK3.z).object({
    appId: (0, $c3dK3.z).string()
}).partial();

});

parcelRequire.register("jLpFC", function(module, exports) {

var $c3dK3 = parcelRequire("c3dK3");
const $e63651b2b901d7c1$var$dashboardUsersDataGuard = (0, $c3dK3.object)({
    count: (0, $c3dK3.number)(),
    delta: (0, $c3dK3.number)()
});
const $e63651b2b901d7c1$export$9d1c6ddb5817c52e = (0, $c3dK3.object)({
    today: $e63651b2b901d7c1$var$dashboardUsersDataGuard,
    last7Days: $e63651b2b901d7c1$var$dashboardUsersDataGuard
});
const $e63651b2b901d7c1$export$fd0651ecbc2a1652 = (0, $c3dK3.object)({
    dauCurve: (0, $c3dK3.array)((0, $c3dK3.object)({
        date: (0, $c3dK3.string)(),
        count: (0, $c3dK3.number)()
    })),
    dau: $e63651b2b901d7c1$var$dashboardUsersDataGuard,
    wau: $e63651b2b901d7c1$var$dashboardUsersDataGuard,
    mau: $e63651b2b901d7c1$var$dashboardUsersDataGuard
});

});

parcelRequire.register("aVJJI", function(module, exports) {
parcelRequire("gh8Fv");
var $gYR9K = parcelRequire("gYR9K");
const $7f52b489fdb395fa$export$81290fbb16f7e442 = Object.freeze([
    "id",
    "domain",
    "status",
    "errorMessage",
    "dnsRecords"
]);
const $7f52b489fdb395fa$export$8181686bf073ccc4 = (0, $gYR9K.Domains).guard.pick({
    id: true,
    domain: true,
    status: true,
    errorMessage: true,
    dnsRecords: true
});

});

parcelRequire.register("6A3nn", function(module, exports) {
/**
 * The sentinel class interface.
 *
 * Sentinels are responsible for accepting activity reports and making decisions based on them.
 *
 * For example, for a user sign-in activity, the sentinel might decide to:
 *
 * - Accept since the user uses the same device and location as usual;
 * - Require a MFA code since the user uses a new device or location;
 * - Block the user since the user tried to sign-in too many times with an incorrect password.
 *
 * The implementation should be privacy-aware and not store any personal identifiable information.
 */ class $4ca8b94729d90ed6$export$84d34c4405d4a2e8 {
}

});

parcelRequire.register("do79b", function(module, exports) {

var $c3dK3 = parcelRequire("c3dK3");
parcelRequire("iLhA3");
var $1QRmm = parcelRequire("1QRmm");
const $9bf30f8231f50084$export$2334438dedb2ca6f = (0, $c3dK3.z).object({
    rp: (0, $c3dK3.z).object({
        name: (0, $c3dK3.z).string(),
        id: (0, $c3dK3.z).string().optional()
    }),
    user: (0, $c3dK3.z).object({
        id: (0, $c3dK3.z).string(),
        name: (0, $c3dK3.z).string(),
        displayName: (0, $c3dK3.z).string()
    }),
    challenge: (0, $c3dK3.z).string(),
    pubKeyCredParams: (0, $c3dK3.z).array((0, $c3dK3.z).object({
        type: (0, $c3dK3.z).literal("public-key"),
        alg: (0, $c3dK3.z).number()
    })),
    timeout: (0, $c3dK3.z).number().optional(),
    excludeCredentials: (0, $c3dK3.z).array((0, $c3dK3.z).object({
        type: (0, $c3dK3.z).literal("public-key"),
        id: (0, $c3dK3.z).string(),
        transports: (0, $1QRmm.webAuthnTransportGuard).array().optional()
    })).optional(),
    authenticatorSelection: (0, $c3dK3.z).object({
        authenticatorAttachment: (0, $c3dK3.z).enum([
            "platform",
            "cross-platform"
        ]).optional(),
        requireResidentKey: (0, $c3dK3.z).boolean().optional(),
        residentKey: (0, $c3dK3.z).enum([
            "discouraged",
            "preferred",
            "required"
        ]).optional(),
        userVerification: (0, $c3dK3.z).enum([
            "required",
            "preferred",
            "discouraged"
        ]).optional()
    }).optional(),
    attestation: (0, $c3dK3.z).enum([
        "none",
        "indirect",
        "direct",
        "enterprise"
    ]).optional(),
    extensions: (0, $c3dK3.z).object({
        appid: (0, $c3dK3.z).string().optional(),
        credProps: (0, $c3dK3.z).boolean().optional(),
        hmacCreateSecret: (0, $c3dK3.z).boolean().optional()
    }).optional()
});
const $9bf30f8231f50084$export$e849189769e7ddda = (0, $c3dK3.z).object({
    challenge: (0, $c3dK3.z).string(),
    timeout: (0, $c3dK3.z).number().optional(),
    rpId: (0, $c3dK3.z).string().optional(),
    allowCredentials: (0, $c3dK3.z).array((0, $c3dK3.z).object({
        type: (0, $c3dK3.z).literal("public-key"),
        id: (0, $c3dK3.z).string(),
        transports: (0, $1QRmm.webAuthnTransportGuard).array().optional()
    })).optional(),
    userVerification: (0, $c3dK3.z).enum([
        "required",
        "preferred",
        "discouraged"
    ]).optional(),
    extensions: (0, $c3dK3.z).object({
        appid: (0, $c3dK3.z).string().optional(),
        credProps: (0, $c3dK3.z).boolean().optional(),
        hmacCreateSecret: (0, $c3dK3.z).boolean().optional()
    }).optional()
});

});

parcelRequire.register("2ENqi", function(module, exports) {

var $c3dK3 = parcelRequire("c3dK3");
parcelRequire("gh8Fv");
var $a5feG = parcelRequire("a5feG");
var $bfvuB = parcelRequire("bfvuB");
var $gkJkg = parcelRequire("gkJkg");

var $68782 = parcelRequire("68782");
const $1ef5a796dfa6059e$export$a8f6e59aae709371 = (0, $a5feG.OrganizationRoles).guard.extend({
    scopes: (0, $c3dK3.z).object({
        id: (0, $c3dK3.z).string(),
        name: (0, $c3dK3.z).string()
    }).array(),
    resourceScopes: (0, $c3dK3.z).object({
        id: (0, $c3dK3.z).string(),
        name: (0, $c3dK3.z).string(),
        resource: (0, $c3dK3.z).object({
            id: (0, $c3dK3.z).string(),
            name: (0, $c3dK3.z).string()
        })
    }).array()
});
const $1ef5a796dfa6059e$var$organizationRoleEntityGuard = (0, $c3dK3.z).object({
    id: (0, $c3dK3.z).string(),
    name: (0, $c3dK3.z).string()
});
const $1ef5a796dfa6059e$export$a1b68498f213370c = (0, $bfvuB.Organizations).guard.extend({
    organizationRoles: $1ef5a796dfa6059e$var$organizationRoleEntityGuard.array()
});
const $1ef5a796dfa6059e$export$6c095334bcf53b71 = (0, $68782.userInfoGuard).extend({
    organizationRoles: $1ef5a796dfa6059e$var$organizationRoleEntityGuard.array()
});
const $1ef5a796dfa6059e$export$c805c92fd00f1460 = (0, $gkJkg.OrganizationInvitations).guard.extend({
    organizationRoles: $1ef5a796dfa6059e$var$organizationRoleEntityGuard.array()
});

});

parcelRequire.register("8q742", function(module, exports) {

$parcel$export(module.exports, "SsoProviderName", function () { return $62163b34a50d85e1$export$88b6bcc5c3531d29; });
$parcel$export(module.exports, "SsoProviderType", function () { return $62163b34a50d85e1$export$f37fcb7c8234a0f8; });
$parcel$export(module.exports, "singleSignOnDomainBlackList", function () { return $62163b34a50d85e1$export$92ee0fc3a3bf5566; });

var $c3dK3 = parcelRequire("c3dK3");

var $oBypx = parcelRequire("oBypx");
const $62163b34a50d85e1$export$7f91c1744e02ec3c = (0, $c3dK3.z).object({
    id: (0, $c3dK3.z).string(),
    connectorName: (0, $c3dK3.z).string(),
    logo: (0, $c3dK3.z).string(),
    darkLogo: (0, $c3dK3.z).string().optional()
});
var $62163b34a50d85e1$export$88b6bcc5c3531d29;
(function(SsoProviderName) {
    SsoProviderName["OIDC"] = "OIDC";
    SsoProviderName["SAML"] = "SAML";
    SsoProviderName["AZURE_AD"] = "AzureAD";
    SsoProviderName["GOOGLE_WORKSPACE"] = "GoogleWorkspace";
    SsoProviderName["OKTA"] = "Okta";
    SsoProviderName["AZURE_AD_OIDC"] = "AzureAdOidc";
})($62163b34a50d85e1$export$88b6bcc5c3531d29 || ($62163b34a50d85e1$export$88b6bcc5c3531d29 = {}));
var $62163b34a50d85e1$export$f37fcb7c8234a0f8;
(function(SsoProviderType) {
    SsoProviderType["OIDC"] = "oidc";
    SsoProviderType["SAML"] = "saml";
})($62163b34a50d85e1$export$f37fcb7c8234a0f8 || ($62163b34a50d85e1$export$f37fcb7c8234a0f8 = {}));
const $62163b34a50d85e1$export$92ee0fc3a3bf5566 = Object.freeze([
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "outlook.com",
    "live.com",
    "icloud.com",
    "aol.com",
    "yandex.com",
    "mail.com",
    "protonmail.com",
    "yanex.com",
    "gmx.com",
    "mail.ru",
    "zoho.com",
    "qq.com",
    "163.com",
    "126.com",
    "sina.com",
    "sohu.com"
]);
const $62163b34a50d85e1$var$ssoConnectorProviderDetailGuard = (0, $c3dK3.z).object({
    providerName: (0, $c3dK3.z).nativeEnum($62163b34a50d85e1$export$88b6bcc5c3531d29),
    providerType: (0, $c3dK3.z).nativeEnum($62163b34a50d85e1$export$f37fcb7c8234a0f8),
    logo: (0, $c3dK3.z).string(),
    logoDark: (0, $c3dK3.z).string(),
    description: (0, $c3dK3.z).string(),
    name: (0, $c3dK3.z).string()
});
const $62163b34a50d85e1$export$daec852f2106e44c = (0, $c3dK3.z).array($62163b34a50d85e1$var$ssoConnectorProviderDetailGuard);
const $62163b34a50d85e1$export$a536522a091757cc = (0, $oBypx.SsoConnectors).guard// Must be a supported SSO provider name. Overwrite the providerName string type to enum.
.extend({
    providerName: (0, $c3dK3.z).nativeEnum($62163b34a50d85e1$export$88b6bcc5c3531d29)
}).merge(// Static provider details
(0, $c3dK3.z).object({
    name: (0, $c3dK3.z).string(),
    providerType: (0, $c3dK3.z).nativeEnum($62163b34a50d85e1$export$f37fcb7c8234a0f8),
    providerLogo: (0, $c3dK3.z).string(),
    providerLogoDark: (0, $c3dK3.z).string(),
    // SSO connection config parsed from the provider.
    // - OIDC: connection config fetched from the OIDC provider.
    // - SAML: connection config fetched from the metadata url or metadata file.
    providerConfig: (0, $c3dK3.z).record((0, $c3dK3.z).unknown()).optional()
}));

});

parcelRequire.register("iq1sR", function(module, exports) {

$parcel$export(module.exports, "TenantTag", function () { return $d68bca8615fb67d5$export$3baa67aafdc7045f; });
var $d68bca8615fb67d5$export$3baa67aafdc7045f;
(function(TenantTag) {
    /* Development tenants are free to use but are not meant to be used as production environment. */ TenantTag["Development"] = "development";
    /* A production tenant must have an associated subscription plan, even if it's a free plan. */ TenantTag["Production"] = "production";
})($d68bca8615fb67d5$export$3baa67aafdc7045f || ($d68bca8615fb67d5$export$3baa67aafdc7045f = {}));

});

parcelRequire.register("aZIrr", function(module, exports) {

$parcel$export(module.exports, "getTenantOrganizationId", function () { return $80121311c865cfd1$export$2469be9aaea94b3b; });
$parcel$export(module.exports, "getTenantIdFromOrganizationId", function () { return $80121311c865cfd1$export$e34151e8896fc4e0; });
$parcel$export(module.exports, "TenantScope", function () { return $80121311c865cfd1$export$5bc5773220b3c720; });
$parcel$export(module.exports, "TenantRole", function () { return $80121311c865cfd1$export$af4151a4e98c49fa; });
/**
 * @fileoverview
 * Tenant organizations are organizations in the admin tenant that represent tenants. They are
 * created when a tenant is created, and are used to define the roles and scopes for the users in
 * the tenant.
 *
 * This module provides utilities to manage tenant organizations.
 */ 
var $6hxiJ = parcelRequire("6hxiJ");
const $80121311c865cfd1$export$2469be9aaea94b3b = (tenantId)=>`t-${tenantId}`;
const $80121311c865cfd1$export$e34151e8896fc4e0 = (organizationId)=>{
    if (!organizationId.startsWith("t-")) throw new Error(`Invalid admin tenant organization ID: ${organizationId}`);
    return organizationId.slice(2);
};
const $80121311c865cfd1$export$2d8382267fbcadbe = (tenantId)=>Object.freeze({
        tenantId: (0, $6hxiJ.adminTenantId),
        id: $80121311c865cfd1$export$2469be9aaea94b3b(tenantId),
        name: `Tenant ${tenantId}`
    });
var $80121311c865cfd1$export$5bc5773220b3c720;
(function(TenantScope) {
    /** Read the tenant data. */ TenantScope["ReadData"] = "read:data";
    /** Write the tenant data, including creating and updating the tenant. */ TenantScope["WriteData"] = "write:data";
    /** Delete data of the tenant. */ TenantScope["DeleteData"] = "delete:data";
    /** Read members of the tenant. */ TenantScope["ReadMember"] = "read:member";
    /** Invite members to the tenant. */ TenantScope["InviteMember"] = "invite:member";
    /** Remove members from the tenant. */ TenantScope["RemoveMember"] = "remove:member";
    /** Update the role of a member in the tenant. */ TenantScope["UpdateMemberRole"] = "update:member:role";
    /** Manage the tenant settings, including name, billing, etc. */ TenantScope["ManageTenant"] = "manage:tenant";
})($80121311c865cfd1$export$5bc5773220b3c720 || ($80121311c865cfd1$export$5bc5773220b3c720 = {}));
const $80121311c865cfd1$var$allTenantScopes = Object.freeze(Object.values($80121311c865cfd1$export$5bc5773220b3c720));
const $80121311c865cfd1$export$d33885dda1bb96a0 = (scope)=>Object.freeze({
        tenantId: (0, $6hxiJ.adminTenantId),
        id: scope.replaceAll(":", "-"),
        name: scope,
        description: $80121311c865cfd1$var$tenantScopeDescriptions[scope]
    });
const $80121311c865cfd1$var$tenantScopeDescriptions = Object.freeze({
    [$80121311c865cfd1$export$5bc5773220b3c720.ReadData]: "Read the tenant data.",
    [$80121311c865cfd1$export$5bc5773220b3c720.WriteData]: "Write the tenant data, including creating and updating the tenant.",
    [$80121311c865cfd1$export$5bc5773220b3c720.DeleteData]: "Delete data of the tenant.",
    [$80121311c865cfd1$export$5bc5773220b3c720.ReadMember]: "Read members of the tenant.",
    [$80121311c865cfd1$export$5bc5773220b3c720.InviteMember]: "Invite members to the tenant.",
    [$80121311c865cfd1$export$5bc5773220b3c720.RemoveMember]: "Remove members from the tenant.",
    [$80121311c865cfd1$export$5bc5773220b3c720.UpdateMemberRole]: "Update the role of a member in the tenant.",
    [$80121311c865cfd1$export$5bc5773220b3c720.ManageTenant]: "Manage the tenant settings, including name, billing, etc."
});
var $80121311c865cfd1$export$af4151a4e98c49fa;
(function(TenantRole) {
    /** Admin of the tenant, who has all permissions. */ TenantRole["Admin"] = "admin";
    /** Collaborator of the tenant, who has permissions to operate the tenant data, but not the tenant settings. */ TenantRole["Collaborator"] = "collaborator";
})($80121311c865cfd1$export$af4151a4e98c49fa || ($80121311c865cfd1$export$af4151a4e98c49fa = {}));
const $80121311c865cfd1$var$tenantRoleDescriptions = Object.freeze({
    [$80121311c865cfd1$export$af4151a4e98c49fa.Admin]: "Admin of the tenant, who has all permissions.",
    [$80121311c865cfd1$export$af4151a4e98c49fa.Collaborator]: "Collaborator of the tenant, who has permissions to operate the tenant data, but not the tenant settings."
});
const $80121311c865cfd1$export$1775965c9a0d8dc9 = (role)=>Object.freeze({
        tenantId: (0, $6hxiJ.adminTenantId),
        id: role,
        name: role,
        description: $80121311c865cfd1$var$tenantRoleDescriptions[role]
    });
const $80121311c865cfd1$export$3f89b2d5d2b9eb42 = Object.freeze({
    [$80121311c865cfd1$export$af4151a4e98c49fa.Admin]: $80121311c865cfd1$var$allTenantScopes,
    [$80121311c865cfd1$export$af4151a4e98c49fa.Collaborator]: [
        $80121311c865cfd1$export$5bc5773220b3c720.ReadData,
        $80121311c865cfd1$export$5bc5773220b3c720.WriteData,
        $80121311c865cfd1$export$5bc5773220b3c720.DeleteData,
        $80121311c865cfd1$export$5bc5773220b3c720.ReadMember
    ]
});

});
parcelRequire.register("6hxiJ", function(module, exports) {

$parcel$export(module.exports, "defaultTenantId", function () { return $492e298b15306aa4$export$ccc9014151910116; });
$parcel$export(module.exports, "adminTenantId", function () { return $492e298b15306aa4$export$87d9f170d46b6e1e; });
const $492e298b15306aa4$export$ccc9014151910116 = "default";
const $492e298b15306aa4$export$87d9f170d46b6e1e = "admin";

});


parcelRequire.register("50dZF", function(module, exports) {

$parcel$export(module.exports, "getMapiProxyRole", function () { return $3a47ceb4022189b4$export$a1252204700ae600; });
/**
 * @fileoverview
 * Mapi (Management API) proxy is an endpoint in Logto Cloud that proxies the requests to the
 * corresponding Management API. It has the following benefits:
 *
 * - When we migrate the tenant management from API resources to tenant organizations, we can
 *   migrate Console to use the mapi proxy endpoint by changing only the base URL.
 * - It decouples the access control of Cloud user collaboration from the machine-to-machine access
 *   control of the Management API.
 * - The mapi proxy endpoint shares the same domain with Logto Cloud, so it can be used in the
 *   browser without CORS.
 *
 * This module provides utilities to manage mapi proxy.
 */ parcelRequire("ajkVG");
var $7WNrO = parcelRequire("7WNrO");
parcelRequire("gh8Fv");
var $61Yml = parcelRequire("61Yml");

var $6hxiJ = parcelRequire("6hxiJ");
const $3a47ceb4022189b4$export$a1252204700ae600 = (tenantId)=>Object.freeze({
        tenantId: (0, $6hxiJ.adminTenantId),
        id: `m-${tenantId}`,
        name: `machine:mapi:${tenantId}`,
        description: `Machine-to-machine role for accessing Management API of tenant '${tenantId}'.`,
        type: (0, $61Yml.RoleType).MachineToMachine,
        isDefault: false
    });
const $3a47ceb4022189b4$export$deaf541980006e1f = (tenantId)=>Object.freeze({
        tenantId: (0, $6hxiJ.adminTenantId),
        id: `m-${tenantId}`,
        secret: (0, $7WNrO.generateStandardSecret)(32),
        name: `Management API access for ${tenantId}`,
        description: `Machine-to-machine app for accessing Management API of tenant '${tenantId}'.`,
        type: (0, $61Yml.ApplicationType).MachineToMachine,
        oidcClientMetadata: {
            redirectUris: [],
            postLogoutRedirectUris: []
        }
    });

});

parcelRequire.register("ccPBd", function(module, exports) {

var $c3dK3 = parcelRequire("c3dK3");
parcelRequire("gh8Fv");
var $ev8Fx = parcelRequire("ev8Fx");
var $4Ecj3 = parcelRequire("4Ecj3");
var $6jyLL = parcelRequire("6jyLL");
var $9Jr5u = parcelRequire("9Jr5u");
var $fidVk = parcelRequire("fidVk");
var $bfvuB = parcelRequire("bfvuB");
const $8e2ea1926b278028$export$d6a2d3784301e7e6 = (0, $ev8Fx.Users).guard.pick({
    id: true,
    name: true,
    avatar: true,
    username: true,
    primaryEmail: true,
    primaryPhone: true
});
const $8e2ea1926b278028$export$bd52a8a3b354bd5c = (0, $4Ecj3.Applications).guard.pick({
    id: true,
    name: true
});
const $8e2ea1926b278028$export$18c739dd80de9062 = (0, $6jyLL.ApplicationSignInExperiences).guard.pick({
    branding: true,
    displayName: true,
    privacyPolicyUrl: true,
    termsOfUseUrl: true
});
const $8e2ea1926b278028$export$852b61cc27b5cdcd = (0, $c3dK3.z).object({
    // The original resource id has a maximum length of 21 restriction. We need to make it compatible with the logto reserved organization name.
    // use string here, as we do not care about the resource id length here.
    resource: (0, $9Jr5u.Resources).guard.pick({
        name: true,
        indicator: true
    }).extend({
        id: (0, $c3dK3.z).string()
    }),
    scopes: (0, $fidVk.Scopes).guard.pick({
        id: true,
        name: true,
        description: true
    }).array()
});
const $8e2ea1926b278028$export$9694f7ffb7c13fa0 = (0, $bfvuB.Organizations).guard.pick({
    id: true,
    name: true
}).extend({
    missingResourceScopes: $8e2ea1926b278028$export$852b61cc27b5cdcd.array().optional()
});
const $8e2ea1926b278028$export$c3e25094abccc08 = (0, $c3dK3.z).object({
    application: $8e2ea1926b278028$export$bd52a8a3b354bd5c.merge($8e2ea1926b278028$export$18c739dd80de9062.partial()),
    user: $8e2ea1926b278028$export$d6a2d3784301e7e6,
    organizations: $8e2ea1926b278028$export$9694f7ffb7c13fa0.array().optional(),
    missingOIDCScope: (0, $c3dK3.z).string().array().optional(),
    missingResourceScopes: $8e2ea1926b278028$export$852b61cc27b5cdcd.array().optional(),
    redirectUri: (0, $c3dK3.z).string()
});

});

parcelRequire.register("dNkWp", function(module, exports) {

$parcel$export(module.exports, "userOnboardingDataKey", function () { return $a0b0186f8cabb7f7$export$b68ca08271df260b; });
$parcel$export(module.exports, "Project", function () { return $a0b0186f8cabb7f7$export$b6032183171af19f; });
$parcel$export(module.exports, "Stage", function () { return $a0b0186f8cabb7f7$export$208cd1682bd0e4b6; });
$parcel$export(module.exports, "AdditionalFeatures", function () { return $a0b0186f8cabb7f7$export$e03ccbddd0690b5c; });
$parcel$export(module.exports, "userOnboardingDataGuard", function () { return $a0b0186f8cabb7f7$export$a9c4e6d214c76225; });

var $c3dK3 = parcelRequire("c3dK3");
const $a0b0186f8cabb7f7$export$b68ca08271df260b = "onboarding";
var $a0b0186f8cabb7f7$export$b6032183171af19f;
(function(Project) {
    Project["Personal"] = "personal";
    Project["Company"] = "company";
})($a0b0186f8cabb7f7$export$b6032183171af19f || ($a0b0186f8cabb7f7$export$b6032183171af19f = {}));
/** @deprecated Open-source options was for cloud preview use, no longer needed. Use default `Cloud` value for placeholder. */ var $a0b0186f8cabb7f7$var$DeploymentType;
(function(DeploymentType) {
    DeploymentType["OpenSource"] = "open-source";
    DeploymentType["Cloud"] = "cloud";
})($a0b0186f8cabb7f7$var$DeploymentType || ($a0b0186f8cabb7f7$var$DeploymentType = {}));
var $a0b0186f8cabb7f7$export$f99233281efd08a0;
(function(Title) {
    Title["Developer"] = "developer";
    Title["TeamLead"] = "team-lead";
    Title["Ceo"] = "ceo";
    Title["Cto"] = "cto";
    Title["Product"] = "product";
    Title["Others"] = "others";
})($a0b0186f8cabb7f7$export$f99233281efd08a0 || ($a0b0186f8cabb7f7$export$f99233281efd08a0 = {}));
var $a0b0186f8cabb7f7$export$41cc48adf872ce3b;
(function(CompanySize) {
    CompanySize["Scale1"] = "1";
    CompanySize["Scale2"] = "2-49";
    CompanySize["Scale3"] = "50-199";
    CompanySize["Scale4"] = "200-999";
    CompanySize["Scale5"] = "1000+";
})($a0b0186f8cabb7f7$export$41cc48adf872ce3b || ($a0b0186f8cabb7f7$export$41cc48adf872ce3b = {}));
var $a0b0186f8cabb7f7$export$fe867595c4640fb1;
(function(Reason) {
    Reason["Passwordless"] = "passwordless";
    Reason["Efficiency"] = "efficiency";
    Reason["AccessControl"] = "access-control";
    Reason["MultiTenancy"] = "multi-tenancy";
    Reason["Enterprise"] = "enterprise";
    Reason["Others"] = "others";
})($a0b0186f8cabb7f7$export$fe867595c4640fb1 || ($a0b0186f8cabb7f7$export$fe867595c4640fb1 = {}));
var $a0b0186f8cabb7f7$export$208cd1682bd0e4b6;
(function(Stage) {
    Stage["NewProduct"] = "new-product";
    Stage["ExistingProduct"] = "existing-product";
    Stage["TargetEnterpriseReady"] = "target-enterprise-ready";
})($a0b0186f8cabb7f7$export$208cd1682bd0e4b6 || ($a0b0186f8cabb7f7$export$208cd1682bd0e4b6 = {}));
var $a0b0186f8cabb7f7$export$e03ccbddd0690b5c;
(function(AdditionalFeatures) {
    AdditionalFeatures["CustomizeUiAndFlow"] = "customize-ui-and-flow";
    AdditionalFeatures["Compliance"] = "compliance";
    AdditionalFeatures["ExportUserDataFromLogto"] = "export-user-data-from-logto";
    AdditionalFeatures["BudgetControl"] = "budget-control";
    AdditionalFeatures["BringOwnAuth"] = "bring-own-auth";
    AdditionalFeatures["Others"] = "others";
})($a0b0186f8cabb7f7$export$e03ccbddd0690b5c || ($a0b0186f8cabb7f7$export$e03ccbddd0690b5c = {}));
const $a0b0186f8cabb7f7$var$questionnaireGuard = (0, $c3dK3.z).object({
    project: (0, $c3dK3.z).nativeEnum($a0b0186f8cabb7f7$export$b6032183171af19f).optional(),
    /** @deprecated Open-source options was for cloud preview use, no longer needed. Use default `Cloud` value for placeholder. */ deploymentType: (0, $c3dK3.z).nativeEnum($a0b0186f8cabb7f7$var$DeploymentType).optional().default($a0b0186f8cabb7f7$var$DeploymentType.Cloud),
    /** @deprecated */ titles: (0, $c3dK3.z).array((0, $c3dK3.z).nativeEnum($a0b0186f8cabb7f7$export$f99233281efd08a0)).optional(),
    companyName: (0, $c3dK3.z).string().optional(),
    /** @deprecated */ companySize: (0, $c3dK3.z).nativeEnum($a0b0186f8cabb7f7$export$41cc48adf872ce3b).optional(),
    /** @deprecated */ reasons: (0, $c3dK3.z).array((0, $c3dK3.z).nativeEnum($a0b0186f8cabb7f7$export$fe867595c4640fb1)).optional(),
    stage: (0, $c3dK3.z).nativeEnum($a0b0186f8cabb7f7$export$208cd1682bd0e4b6).optional(),
    additionalFeatures: (0, $c3dK3.z).array((0, $c3dK3.z).nativeEnum($a0b0186f8cabb7f7$export$e03ccbddd0690b5c)).optional()
});
const $a0b0186f8cabb7f7$export$a9c4e6d214c76225 = (0, $c3dK3.z).object({
    questionnaire: $a0b0186f8cabb7f7$var$questionnaireGuard.optional(),
    isOnboardingDone: (0, $c3dK3.z).boolean().optional()
});

});


parcelRequire.register("7cEg6", function(module, exports) {
parcelRequire("jxhiT");

});
parcelRequire.register("jxhiT", function(module, exports) {

});


parcelRequire.register("c359g", function(module, exports) {
$parcel$export(module.exports, "adminConsoleApplicationId", function () { return (parcelRequire("5TTZn")).adminConsoleApplicationId; });
$parcel$export(module.exports, "demoAppApplicationId", function () { return (parcelRequire("5TTZn")).demoAppApplicationId; });
$parcel$export(module.exports, "cloudApiIndicator", function () { return (parcelRequire("4hqEo")).cloudApiIndicator; });
$parcel$export(module.exports, "CloudScope", function () { return (parcelRequire("4hqEo")).CloudScope; });
$parcel$export(module.exports, "defaultManagementApi", function () { return (parcelRequire("j0apn")).defaultManagementApi; });
$parcel$export(module.exports, "getManagementApiResourceIndicator", function () { return (parcelRequire("j0apn")).getManagementApiResourceIndicator; });
$parcel$export(module.exports, "adminTenantId", function () { return (parcelRequire("6hxiJ")).adminTenantId; });
$parcel$export(module.exports, "defaultTenantId", function () { return (parcelRequire("6hxiJ")).defaultTenantId; });
parcelRequire("5TTZn");
parcelRequire("4hqEo");
parcelRequire("j0apn");
parcelRequire("3Qh8z");
parcelRequire("88xXL");
parcelRequire("6hxiJ");

});
parcelRequire.register("5TTZn", function(module, exports) {

$parcel$export(module.exports, "adminConsoleApplicationId", function () { return $44bd8511920eed4d$export$1bb5e159b3d64354; });
$parcel$export(module.exports, "demoAppApplicationId", function () { return $44bd8511920eed4d$export$92b495973538657d; });
parcelRequire("ajkVG");
var $7WNrO = parcelRequire("7WNrO");
parcelRequire("gh8Fv");
var $61Yml = parcelRequire("61Yml");

var $6hxiJ = parcelRequire("6hxiJ");
const $44bd8511920eed4d$export$1bb5e159b3d64354 = "admin-console";
const $44bd8511920eed4d$export$92b495973538657d = "demo-app";
const $44bd8511920eed4d$export$c3f41e16cf1f3ff0 = (tenantId)=>({
        tenantId: tenantId,
        id: $44bd8511920eed4d$export$92b495973538657d,
        name: "Live Preview",
        secret: "N/A",
        description: "Preview for Sign-in Experience.",
        type: (0, $61Yml.ApplicationType).SPA,
        oidcClientMetadata: {
            redirectUris: [],
            postLogoutRedirectUris: []
        },
        customClientMetadata: {},
        protectedAppMetadata: null,
        isThirdParty: false,
        createdAt: 0
    });
const $44bd8511920eed4d$export$e6ae95e19af732a3 = ()=>Object.freeze({
        tenantId: (0, $6hxiJ.adminTenantId),
        id: $44bd8511920eed4d$export$1bb5e159b3d64354,
        name: "Admin Console",
        secret: (0, $7WNrO.generateStandardSecret)(),
        description: "Logto Admin Console.",
        type: (0, $61Yml.ApplicationType).SPA,
        oidcClientMetadata: {
            redirectUris: [],
            postLogoutRedirectUris: []
        }
    });
const $44bd8511920eed4d$export$7480c3dfa7c833f3 = (tenantId)=>Object.freeze({
        tenantId: (0, $6hxiJ.adminTenantId),
        id: (0, $7WNrO.generateStandardId)(),
        name: "Cloud Service",
        description: `Machine to machine application for tenant ${tenantId}`,
        secret: (0, $7WNrO.generateStandardSecret)(),
        type: (0, $61Yml.ApplicationType).MachineToMachine,
        oidcClientMetadata: {
            redirectUris: [],
            postLogoutRedirectUris: []
        },
        customClientMetadata: {
            tenantId: tenantId
        }
    });
const $44bd8511920eed4d$export$2d5b05d2f01b280 = (applicationId, roleId)=>Object.freeze({
        id: (0, $7WNrO.generateStandardId)(),
        tenantId: (0, $6hxiJ.adminTenantId),
        applicationId: applicationId,
        roleId: roleId
    });

});

parcelRequire.register("4hqEo", function(module, exports) {

$parcel$export(module.exports, "cloudApiIndicator", function () { return $31dd6c36d253a92f$export$e3fa12c425ddba26; });
$parcel$export(module.exports, "CloudScope", function () { return $31dd6c36d253a92f$export$fd6cfb345221c2ba; });
parcelRequire("ajkVG");
var $7WNrO = parcelRequire("7WNrO");
parcelRequire("gh8Fv");
var $61Yml = parcelRequire("61Yml");
parcelRequire("1qlsF");
var $68782 = parcelRequire("68782");

var $6hxiJ = parcelRequire("6hxiJ");
const $31dd6c36d253a92f$export$e3fa12c425ddba26 = "https://cloud.logto.io/api";
var $31dd6c36d253a92f$export$fd6cfb345221c2ba;
(function(CloudScope) {
    /** The user can create a user tenant. */ CloudScope["CreateTenant"] = "create:tenant";
    /** The user can update or delete its own tenants. */ CloudScope["ManageTenantSelf"] = "manage:tenant:self";
    CloudScope["SendSms"] = "send:sms";
    CloudScope["SendEmail"] = "send:email";
    /**
     * The user can access external (independent from Logto instance) resource to run JWT payload customizer
     * scripts and fetch the parsed token payload.
     */ CloudScope["FetchCustomJwt"] = "fetch:custom:jwt";
    /** The user can see and manage affiliates, including create, update, and delete. */ CloudScope["ManageAffiliate"] = "manage:affiliate";
    /** The user can create new affiliates and logs. */ CloudScope["CreateAffiliate"] = "create:affiliate";
})($31dd6c36d253a92f$export$fd6cfb345221c2ba || ($31dd6c36d253a92f$export$fd6cfb345221c2ba = {}));
const $31dd6c36d253a92f$export$3ae0ed740a70db11 = ()=>{
    const resourceId = (0, $7WNrO.generateStandardId)();
    const buildScope = (name, description)=>({
            tenantId: (0, $6hxiJ.adminTenantId),
            id: (0, $7WNrO.generateStandardId)(),
            name: name,
            description: description,
            resourceId: resourceId
        });
    return Object.freeze([
        {
            resource: {
                tenantId: (0, $6hxiJ.adminTenantId),
                id: resourceId,
                indicator: $31dd6c36d253a92f$export$e3fa12c425ddba26,
                name: `Logto Cloud API`
            },
            scopes: [
                buildScope($31dd6c36d253a92f$export$fd6cfb345221c2ba.CreateTenant, "Allow creating new tenants."),
                buildScope($31dd6c36d253a92f$export$fd6cfb345221c2ba.ManageTenantSelf, "Allow managing tenant itself, including update and delete.")
            ],
            role: {
                tenantId: (0, $6hxiJ.adminTenantId),
                name: (0, $68782.AdminTenantRole).User
            }
        },
        buildScope($31dd6c36d253a92f$export$fd6cfb345221c2ba.SendEmail, "Allow sending emails. This scope is only available to M2M application."),
        buildScope($31dd6c36d253a92f$export$fd6cfb345221c2ba.SendSms, "Allow sending SMS. This scope is only available to M2M application."),
        buildScope($31dd6c36d253a92f$export$fd6cfb345221c2ba.FetchCustomJwt, "Allow accessing external resource to execute JWT payload customizer script and fetch the parsed token payload."),
        buildScope($31dd6c36d253a92f$export$fd6cfb345221c2ba.CreateAffiliate, "Allow creating new affiliates and logs."),
        buildScope($31dd6c36d253a92f$export$fd6cfb345221c2ba.ManageAffiliate, "Allow managing affiliates, including create, update, and delete.")
    ]);
};
const $31dd6c36d253a92f$export$233b871be9b6564f = ()=>({
        tenantId: (0, $6hxiJ.adminTenantId),
        id: (0, $7WNrO.generateStandardId)(),
        name: (0, $68782.AdminTenantRole).TenantApplication,
        description: "The role for M2M applications that represent a user tenant and send requests to Logto Cloud.",
        type: (0, $61Yml.RoleType).MachineToMachine,
        isDefault: false
    });

});

parcelRequire.register("j0apn", function(module, exports) {

$parcel$export(module.exports, "defaultManagementApi", function () { return $dd56174cd092d03d$export$711b817cd779af20; });
$parcel$export(module.exports, "getManagementApiResourceIndicator", function () { return $dd56174cd092d03d$export$245dbc301cf93887; });
parcelRequire("ajkVG");
var $7WNrO = parcelRequire("7WNrO");
parcelRequire("gh8Fv");
var $61Yml = parcelRequire("61Yml");
parcelRequire("1qlsF");
var $68782 = parcelRequire("68782");
var $50dZF = parcelRequire("50dZF");

var $6hxiJ = parcelRequire("6hxiJ");
// Consider remove the dependency of IDs
const $dd56174cd092d03d$var$defaultResourceId = "management-api";
const $dd56174cd092d03d$var$defaultScopeAllId = "management-api-all";
const $dd56174cd092d03d$export$711b817cd779af20 = Object.freeze({
    resource: {
        tenantId: (0, $6hxiJ.defaultTenantId),
        /** @deprecated You should not rely on this constant. Change to something else. */ id: $dd56174cd092d03d$var$defaultResourceId,
        /**
         * The fixed resource indicator for Management APIs.
         *
         * Admin Console requires the access token of this resource to be functional.
         */ indicator: `https://${(0, $6hxiJ.defaultTenantId)}.logto.app/api`,
        name: "Logto Management API"
    },
    scopes: [
        {
            tenantId: (0, $6hxiJ.defaultTenantId),
            /** @deprecated You should not rely on this constant. Change to something else. */ id: $dd56174cd092d03d$var$defaultScopeAllId,
            name: (0, $68782.PredefinedScope).All,
            description: "Default scope for Management API, allows all permissions.",
            /** @deprecated You should not rely on this constant. Change to something else. */ resourceId: $dd56174cd092d03d$var$defaultResourceId
        }
    ],
    /**
     * An internal user role for Management API of the `default` tenant.
     * @deprecated This role will be removed soon.
     */ role: {
        tenantId: (0, $6hxiJ.defaultTenantId),
        /** @deprecated You should not rely on this constant. Change to something else. */ id: "admin-role",
        name: (0, $68782.InternalRole).Admin,
        description: `Internal admin role for Logto tenant ${(0, $6hxiJ.defaultTenantId)}.`,
        type: (0, $61Yml.RoleType).MachineToMachine
    }
});
function $dd56174cd092d03d$export$245dbc301cf93887(tenantId, path = "api") {
    return `https://${tenantId}.logto.app/${path}`;
}
const $dd56174cd092d03d$export$ba32cb0bde5eb6df = `${(0, $6hxiJ.defaultTenantId)}:admin`;
const $dd56174cd092d03d$export$c7852ca43795084 = (tenantId)=>{
    const resourceId = (0, $7WNrO.generateStandardId)();
    return Object.freeze({
        resource: {
            tenantId: tenantId,
            id: resourceId,
            indicator: $dd56174cd092d03d$export$245dbc301cf93887(tenantId),
            name: `Logto Management API`
        },
        scopes: [
            {
                tenantId: tenantId,
                id: (0, $7WNrO.generateStandardId)(),
                name: (0, $68782.PredefinedScope).All,
                description: "Default scope for Management API, allows all permissions.",
                resourceId: resourceId
            }
        ],
        /** @deprecated This role will be removed soon. */ role: {
            tenantId: tenantId,
            id: (0, $7WNrO.generateStandardId)(),
            name: (0, $68782.InternalRole).Admin,
            description: `Internal admin role for Logto tenant ${(0, $6hxiJ.defaultTenantId)}.`,
            type: (0, $61Yml.RoleType).MachineToMachine
        }
    });
};
const $dd56174cd092d03d$export$305b333dcaea6e0e = (tenantId)=>{
    const resourceId = (0, $7WNrO.generateStandardId)();
    return Object.freeze({
        resource: {
            tenantId: (0, $6hxiJ.adminTenantId),
            id: resourceId,
            indicator: $dd56174cd092d03d$export$245dbc301cf93887(tenantId),
            name: `Logto Management API for tenant ${tenantId}`
        },
        scopes: [
            {
                tenantId: (0, $6hxiJ.adminTenantId),
                id: (0, $7WNrO.generateStandardId)(),
                name: (0, $68782.PredefinedScope).All,
                description: "Default scope for Management API, allows all permissions.",
                resourceId: resourceId
            }
        ],
        /** The machine-to-machine role for the Management API proxy of the given tenant ID. */ role: (0, $50dZF.getMapiProxyRole)(tenantId)
    });
};
const $dd56174cd092d03d$export$3e34893e87727786 = ()=>{
    const resourceId = (0, $7WNrO.generateStandardId)();
    return Object.freeze({
        resource: {
            tenantId: (0, $6hxiJ.adminTenantId),
            id: resourceId,
            indicator: $dd56174cd092d03d$export$245dbc301cf93887((0, $6hxiJ.adminTenantId), "me"),
            name: `Logto Me API`
        },
        scopes: [
            {
                tenantId: (0, $6hxiJ.adminTenantId),
                id: (0, $7WNrO.generateStandardId)(),
                name: (0, $68782.PredefinedScope).All,
                description: "Default scope for Me API, allows all permissions.",
                resourceId: resourceId
            }
        ],
        role: {
            tenantId: (0, $6hxiJ.adminTenantId),
            id: (0, $7WNrO.generateStandardId)(),
            name: (0, $68782.AdminTenantRole).User,
            description: "Default role for admin tenant.",
            type: (0, $61Yml.RoleType).User
        }
    });
};
const $dd56174cd092d03d$export$60d9196a3fb69639 = (tenantId)=>({
        tenantId: tenantId,
        id: (0, $7WNrO.generateStandardId)(),
        description: "This default role grants access to the Logto management API.",
        name: "Logto Management API access",
        type: (0, $61Yml.RoleType).MachineToMachine
    });

});

parcelRequire.register("3Qh8z", function(module, exports) {
parcelRequire("1qlsF");
var $jnq2J = parcelRequire("jnq2J");

var $4hqEo = parcelRequire("4hqEo");
const $2cc38585157809ff$export$eac2ea73871449a = (forTenantId)=>Object.freeze({
        tenantId: forTenantId,
        key: (0, $jnq2J.LogtoTenantConfigKey).AdminConsole,
        value: {
            signInExperienceCustomized: false,
            organizationCreated: false
        }
    });
const $2cc38585157809ff$export$fb8e6733ef2d5505 = (forTenantId, appId, appSecret)=>Object.freeze({
        tenantId: forTenantId,
        key: (0, $jnq2J.LogtoTenantConfigKey).CloudConnection,
        value: {
            appId: appId,
            appSecret: appSecret,
            resource: (0, $4hqEo.cloudApiIndicator)
        }
    });

});

parcelRequire.register("88xXL", function(module, exports) {
parcelRequire("4taJ0");
var $gS6ii = parcelRequire("gS6ii");
parcelRequire("gh8Fv");
var $61Yml = parcelRequire("61Yml");
parcelRequire("5Fb6p");
var $8lyC3 = parcelRequire("8lyC3");

var $6hxiJ = parcelRequire("6hxiJ");
const $5ec96a64beb10d68$var$defaultPrimaryColor = "#6139F6";
const $5ec96a64beb10d68$export$9aabb866d7e7cb45 = (forTenantId, isCloud)=>Object.freeze({
        tenantId: forTenantId,
        id: "default",
        color: {
            primaryColor: $5ec96a64beb10d68$var$defaultPrimaryColor,
            isDarkModeEnabled: false,
            darkPrimaryColor: (0, $gS6ii.generateDarkColor)($5ec96a64beb10d68$var$defaultPrimaryColor)
        },
        branding: {
            logoUrl: isCloud ? undefined : "https://logto.io/logo.svg",
            darkLogoUrl: isCloud ? undefined : "https://logto.io/logo-dark.svg"
        },
        languageInfo: {
            autoDetect: true,
            fallbackLanguage: "en"
        },
        termsOfUseUrl: null,
        privacyPolicyUrl: null,
        signUp: {
            identifiers: [
                isCloud ? (0, $8lyC3.SignInIdentifier).Email : (0, $8lyC3.SignInIdentifier).Username
            ],
            password: true,
            verify: isCloud
        },
        signIn: {
            methods: [
                {
                    identifier: isCloud ? (0, $8lyC3.SignInIdentifier).Email : (0, $8lyC3.SignInIdentifier).Username,
                    password: true,
                    verificationCode: false,
                    isPasswordPrimary: true
                }
            ]
        },
        socialSignInConnectorTargets: [],
        signInMode: (0, $61Yml.SignInMode).SignInAndRegister,
        customCss: null,
        customContent: {},
        passwordPolicy: {},
        mfa: {
            factors: [],
            policy: (0, $8lyC3.MfaPolicy).UserControlled
        }
    });
const $5ec96a64beb10d68$export$7e36ef2bc7e2871f = $5ec96a64beb10d68$export$9aabb866d7e7cb45((0, $6hxiJ.defaultTenantId), false);
const $5ec96a64beb10d68$export$e9fd471c1ae91561 = ()=>Object.freeze({
        ...$5ec96a64beb10d68$export$7e36ef2bc7e2871f,
        tenantId: (0, $6hxiJ.adminTenantId),
        color: {
            ...$5ec96a64beb10d68$export$7e36ef2bc7e2871f.color,
            isDarkModeEnabled: true
        },
        signInMode: (0, $61Yml.SignInMode).Register,
        branding: {
            logoUrl: "https://logto.io/logo.svg",
            darkLogoUrl: "https://logto.io/logo-dark.svg"
        }
    });

});


parcelRequire.register("jEsaU", function(module, exports) {
$parcel$export(module.exports, "ossConsolePath", function () { return (parcelRequire("fjAdn")).ossConsolePath; });
$parcel$export(module.exports, "customClientMetadataDefault", function () { return (parcelRequire("7cCjo")).customClientMetadataDefault; });
$parcel$export(module.exports, "maxFreeTenantLimit", function () { return (parcelRequire("clRgC")).maxFreeTenantLimit; });
$parcel$export(module.exports, "ReservedPlanId", function () { return (parcelRequire("lXQZH")).ReservedPlanId; });
parcelRequire("9K6gO");
parcelRequire("fjAdn");
parcelRequire("7cCjo");
parcelRequire("4FARz");
parcelRequire("clRgC");
parcelRequire("lXQZH");
parcelRequire("5GFQK");

});
parcelRequire.register("9K6gO", function(module, exports) {
const $717d460d669e448f$export$58a828960e98f161 = "_logto";

});

parcelRequire.register("fjAdn", function(module, exports) {

$parcel$export(module.exports, "ossConsolePath", function () { return $b264b8d8092afd66$export$c114d6e260d7e866; });
/**
 * In OSS:
 *
 * - Only one single user tenant (`default`) is available.
 * - Admin tenant and Admin Console share one endpoint (`ADMIN_ENDPOINT`).
 *
 * There's no need to parse tenant ID from the first path segment in OSS, and the segment should be a fixed value.
 *
 * If we use `/default`, the URL will look ugly; thus we keep the old fashion `/console`.
 */ const $b264b8d8092afd66$export$c114d6e260d7e866 = "/console";

});

parcelRequire.register("7cCjo", function(module, exports) {

$parcel$export(module.exports, "customClientMetadataDefault", function () { return $53e75f578210548f$export$2d48ae5b9b7ef84; });

var $c3dK3 = parcelRequire("c3dK3");

var $4FARz = parcelRequire("4FARz");
const $53e75f578210548f$export$69773729edd6695 = "tenant_id";
const $53e75f578210548f$export$2d48ae5b9b7ef84 = Object.freeze({
    idTokenTtl: (0, $4FARz.inSeconds).oneHour,
    refreshTokenTtlInDays: 14,
    rotateRefreshToken: true
});
var $53e75f578210548f$export$d59e370a591c2f6e;
(function(ExtraParamsKey) {
    /**
     * @deprecated Use {@link FirstScreen} instead.
     * @see {@link InteractionMode} for the available values.
     */ ExtraParamsKey["InteractionMode"] = "interaction_mode";
    /**
     * The first screen to show for the user.
     *
     * @see {@link FirstScreen} for the available values.
     */ ExtraParamsKey["FirstScreen"] = "first_screen";
    /**
     * Directly sign in via the specified method. Note that the method must be properly configured
     * in Logto.
     *
     * @remark
     * The format of the value for this key is one of the following:
     *
     * - `social:<target>` (Use a social connector with the specified target, e.g. `social:google`)
     * - `sso:<connector-id>` (Use the specified SSO connector, e.g. `sso:123456`)
     */ ExtraParamsKey["DirectSignIn"] = "direct_sign_in";
})($53e75f578210548f$export$d59e370a591c2f6e || ($53e75f578210548f$export$d59e370a591c2f6e = {}));
var $53e75f578210548f$export$d184c05d3e025a16;
(function(InteractionMode) {
    InteractionMode["SignIn"] = "signIn";
    InteractionMode["SignUp"] = "signUp";
})($53e75f578210548f$export$d184c05d3e025a16 || ($53e75f578210548f$export$d184c05d3e025a16 = {}));
var $53e75f578210548f$export$fa38afa20f77931e;
(function(FirstScreen) {
    FirstScreen["SignIn"] = "signIn";
    FirstScreen["Register"] = "register";
})($53e75f578210548f$export$fa38afa20f77931e || ($53e75f578210548f$export$fa38afa20f77931e = {}));
const $53e75f578210548f$export$d4edee201590d836 = (0, $c3dK3.z).object({
    [$53e75f578210548f$export$d59e370a591c2f6e.InteractionMode]: (0, $c3dK3.z).nativeEnum($53e75f578210548f$export$d184c05d3e025a16),
    [$53e75f578210548f$export$d59e370a591c2f6e.FirstScreen]: (0, $c3dK3.z).nativeEnum($53e75f578210548f$export$fa38afa20f77931e),
    [$53e75f578210548f$export$d59e370a591c2f6e.DirectSignIn]: (0, $c3dK3.z).string()
}).partial();

});
parcelRequire.register("4FARz", function(module, exports) {

$parcel$export(module.exports, "inSeconds", function () { return $366796044e05c1ad$export$41e1f3752bfbbffc; });
const $366796044e05c1ad$export$41e1f3752bfbbffc = Object.freeze({
    oneMinute: 60,
    oneHour: 3600,
    oneDay: 86400
});

});


parcelRequire.register("clRgC", function(module, exports) {

$parcel$export(module.exports, "maxFreeTenantLimit", function () { return $8fe0c3ed89b01083$export$33e784254961b75a; });
const $8fe0c3ed89b01083$export$33e784254961b75a = 10;

});

parcelRequire.register("lXQZH", function(module, exports) {

$parcel$export(module.exports, "ReservedPlanId", function () { return $ffd83732e628e034$export$70d79c7c84af5a3e; });
/**
 * Logto-provided predefined subscription plan IDs.
 *
 * In theory, the subscription plan ID will be a random string,
 * but Logto provides some predefined subscription plans and their IDs are reserved plan IDs.
 */ var $ffd83732e628e034$export$70d79c7c84af5a3e;
(function(ReservedPlanId) {
    ReservedPlanId["Free"] = "free";
    /**
     * @deprecated
     * In recent refactoring, the `hobby` plan is now treated as the `pro` plan.
     * Only use this plan ID to check if a plan is a `pro` plan or not.
     * This plan ID will be renamed to `pro` after legacy Stripe data is migrated by @darcyYe
     *
     * Todo @darcyYe:
     * - LOG-7846: Rename `hobby` to `pro` and `pro` to `legacy-pro`
     * - LOG-8339: Migrate legacy Stripe data
     */ ReservedPlanId["Hobby"] = "hobby";
    /**
     * @deprecated
     * Now this `pro` ID is not used anymore, we use `hobby` as the `pro` plan ID.
     * Only use this `pro` value when displaying the plan ID to the user.
     *
     * Todo @darcyYe see `Hobby` todo
     */ ReservedPlanId["Pro"] = "pro";
    ReservedPlanId["Development"] = "dev";
})($ffd83732e628e034$export$70d79c7c84af5a3e || ($ffd83732e628e034$export$70d79c7c84af5a3e = {}));

});

parcelRequire.register("5GFQK", function(module, exports) {
const $42415681d43c53bc$var$routes = Object.freeze({
    signIn: "sign-in",
    register: "register",
    sso: "single-sign-on",
    consent: "consent"
});
const $42415681d43c53bc$export$45794d16c9d83fe2 = Object.freeze({
    routes: $42415681d43c53bc$var$routes
});

});


parcelRequire.register("6Cu0c", function(module, exports) {
$parcel$export(module.exports, "internalRolePrefix", function () { return (parcelRequire("2nQqt")).internalRolePrefix; });
$parcel$export(module.exports, "isManagementApi", function () { return (parcelRequire("9XFlr")).isManagementApi; });
$parcel$export(module.exports, "findDuplicatedOrBlockedEmailDomains", function () { return (parcelRequire("8ynli")).findDuplicatedOrBlockedEmailDomains; });
parcelRequire("2nQqt");
parcelRequire("9XFlr");
parcelRequire("8ynli");

});
parcelRequire.register("2nQqt", function(module, exports) {

$parcel$export(module.exports, "internalRolePrefix", function () { return $1bc66570dd07b1c9$export$7ebc507e3327c47b; });
/** @deprecated We don't restrict roles in the database anymore. */ const $1bc66570dd07b1c9$export$7ebc507e3327c47b = "#internal:";
const $1bc66570dd07b1c9$export$9aaedfefea44825f = (roleName)=>roleName.startsWith($1bc66570dd07b1c9$export$7ebc507e3327c47b);

});

parcelRequire.register("9XFlr", function(module, exports) {

$parcel$export(module.exports, "isManagementApi", function () { return $7409b1f48d56d14b$export$5ae1b4d89745ee61; });
const $7409b1f48d56d14b$export$5ae1b4d89745ee61 = (indicator)=>/^https:\/\/[^.]+\.logto\.app\/api$/.test(indicator);

});

parcelRequire.register("8ynli", function(module, exports) {

$parcel$export(module.exports, "findDuplicatedOrBlockedEmailDomains", function () { return $63a39b06736d4604$export$642cfcc4b084a733; });

var $8q742 = parcelRequire("8q742");
const $63a39b06736d4604$export$642cfcc4b084a733 = (domains)=>{
    const blackListSet = new Set((0, $8q742.singleSignOnDomainBlackList));
    const validDomainSet = new Set();
    const duplicatedDomains = new Set();
    const forbiddenDomains = new Set();
    for (const domain of domains ?? []){
        if (blackListSet.has(domain)) forbiddenDomains.add(domain);
        if (validDomainSet.has(domain)) duplicatedDomains.add(domain);
        else validDomainSet.add(domain);
    }
    return {
        duplicatedDomains: duplicatedDomains,
        forbiddenDomains: forbiddenDomains
    };
};

});



parcelRequire.register("aPWhn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67ee75522d3a69ac$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $67ee75522d3a69ac$var$SvgMachineToMachineDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 40,
        height: 41,
        viewBox: "0 0 40 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                y: 0.5,
                width: 40,
                height: 40,
                rx: 8,
                fill: "#F7F8F8",
                fillOpacity: 0.12
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M17 6.5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H19a2 2 0 0 1-2-2v-10Z",
                fill: "url(#paint0_linear_4270_17368)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#D361E7",
                d: "M17 8.5h18v1H17z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M27 7a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5A.5.5 0 0 1 27 7Z",
                fill: "#B545CA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 19,
                y: 6.5,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M27 12a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Z",
                fill: "#B545CA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 19,
                y: 11.5,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 21,
                y: 11.5,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M27 17a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Z",
                fill: "#B545CA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 19,
                y: 16.5,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 21,
                y: 16.5,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#D361E7",
                d: "M17 13.5h18v1H17z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M5 24.5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-10Z",
                fill: "url(#paint1_linear_4270_17368)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#947DFF",
                d: "M5 26.5h18v1H5z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M15 25a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 7,
                y: 24.5,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M15 30a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 7,
                y: 29.5,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 9,
                y: 29.5,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M15 35a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 7,
                y: 34.5,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 9,
                y: 34.5,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#947DFF",
                d: "M5 31.5h18v1H5z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                opacity: 0.4,
                d: "M20 27.5a8 8 0 0 0 8-8m-16 1a8 8 0 0 1 8-8",
                stroke: "#C9C5D0",
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_4270_17368",
                        x1: 12.5,
                        y1: 13.833,
                        x2: 36.414,
                        y2: 10.479,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#E4A3FB"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EC78FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_4270_17368",
                        x1: 3.521,
                        y1: 30.521,
                        x2: 21.363,
                        y2: 22.051,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $67ee75522d3a69ac$export$2e2bcd8739ae039 = $67ee75522d3a69ac$var$SvgMachineToMachineDark;

});

parcelRequire.register("hg5YK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe899a436e512373$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $fe899a436e512373$var$SvgMachineToMachine = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 40,
                height: 40,
                rx: 8,
                fill: "#F3EFFA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M17 6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H19a2 2 0 0 1-2-2V6Z",
                fill: "url(#paint0_linear_1091_20131)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#D361E7",
                d: "M17 8h18v1H17z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 27,
                y: 6,
                width: 6,
                height: 1,
                rx: 0.5,
                fill: "#B545CA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 19,
                y: 6,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 27,
                y: 11,
                width: 6,
                height: 1,
                rx: 0.5,
                fill: "#B545CA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 19,
                y: 11,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 21,
                y: 11,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 27,
                y: 16,
                width: 6,
                height: 1,
                rx: 0.5,
                fill: "#B545CA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 19,
                y: 16,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 21,
                y: 16,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#D361E7",
                d: "M17 13h18v1H17z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M5 24a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V24Z",
                fill: "url(#paint1_linear_1091_20131)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#947DFF",
                d: "M5 26h18v1H5z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 15,
                y: 24,
                width: 6,
                height: 1,
                rx: 0.5,
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 7,
                y: 24,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 15,
                y: 29,
                width: 6,
                height: 1,
                rx: 0.5,
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 7,
                y: 29,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 9,
                y: 29,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 15,
                y: 34,
                width: 6,
                height: 1,
                rx: 0.5,
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 7,
                y: 34,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 9,
                y: 34,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#947DFF",
                d: "M5 31h18v1H5z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M20 27a8 8 0 0 0 8-8m-16 1a8 8 0 0 1 8-8",
                stroke: "#C9C5D0",
                strokeWidth: 2,
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_1091_20131",
                        x1: 12.5,
                        y1: 13.333,
                        x2: 36.414,
                        y2: 9.979,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#E4A3FB"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EC78FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_1091_20131",
                        x1: 3.521,
                        y1: 30.021,
                        x2: 21.363,
                        y2: 21.551,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $fe899a436e512373$export$2e2bcd8739ae039 = $fe899a436e512373$var$SvgMachineToMachine;

});

parcelRequire.register("kozlF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b52d983c3e0025f$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $9b52d983c3e0025f$var$SvgNativeAppDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 40,
        height: 41,
        viewBox: "0 0 40 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                y: 0.5,
                width: 40,
                height: 40,
                rx: 8,
                fill: "#F7F8F8",
                fillOpacity: 0.12
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M12 9.5a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v22a4 4 0 0 1-4 4h-8a4 4 0 0 1-4-4v-22Z",
                fill: "url(#paint0_linear_4270_17365)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 20,
                cy: 31.5,
                r: 1.5,
                stroke: "#D3BCF3"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M16 6.5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-1Z",
                fill: "#5938A3"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                opacity: 0.6,
                d: "M28.35 4.5a.667.667 0 0 1 1.156 0l5.773 10a.667.667 0 0 1-.577 1H23.155a.667.667 0 0 1-.578-1l5.774-10Z",
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 10,
                cy: 26.5,
                r: 6,
                fill: "#F07EFF",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("defs", {
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                    id: "paint0_linear_4270_17365",
                    x1: 10.686,
                    y1: 22.688,
                    x2: 29.393,
                    y2: 19.004,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            stopColor: "#614DDD"
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            offset: 1,
                            stopColor: "#D47AFE"
                        })
                    ]
                })
            })
        ]
    });
var $9b52d983c3e0025f$export$2e2bcd8739ae039 = $9b52d983c3e0025f$var$SvgNativeAppDark;

});

parcelRequire.register("clGLf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a660016d1b4e645f$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $a660016d1b4e645f$var$SvgNativeApp = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 40,
                height: 40,
                rx: 8,
                fill: "#F3EFFA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 12,
                y: 5,
                width: 16,
                height: 30,
                rx: 4,
                fill: "url(#paint0_linear_1091_20216)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 20,
                cy: 31,
                r: 1.5,
                stroke: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M16 5h8v2a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V5Z",
                fill: "#4300DA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                opacity: 0.8,
                d: "M28.35 3a.667.667 0 0 1 1.156 0l5.773 10a.667.667 0 0 1-.577 1H23.155a.667.667 0 0 1-.578-1l5.774-10Z",
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 10,
                cy: 26,
                r: 6,
                fill: "#F07EFF",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("defs", {
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                    id: "paint0_linear_1091_20216",
                    x1: 10.686,
                    y1: 22.188,
                    x2: 29.393,
                    y2: 18.504,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            stopColor: "#492EF3"
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            offset: 1,
                            stopColor: "#CF69FF"
                        })
                    ]
                })
            })
        ]
    });
var $a660016d1b4e645f$export$2e2bcd8739ae039 = $a660016d1b4e645f$var$SvgNativeApp;

});

parcelRequire.register("m3h86", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ba6e29ae56c0640$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $2ba6e29ae56c0640$var$SvgProtectedAppDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 40,
                height: 40,
                rx: 8,
                fill: "#F7F8F8",
                fillOpacity: 0.12
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M30.706 9.901c.303.007.549.251.549.554V22.93c0 4.483-5.736 9.596-10.939 11.002a.997.997 0 0 1-.522 0C14.59 32.526 8.855 27.413 8.855 22.93V10.455c0-.303.246-.547.549-.554 5.552-.115 8.775-1.961 10.125-3.286a.78.78 0 0 1 1.052 0c1.35 1.325 4.573 3.171 10.125 3.286Zm-8.324 7.804c0 .914-.555 1.698-1.345 2.033l1.152 3a.561.561 0 0 1-.524.762h-3.283a.561.561 0 0 1-.504-.808l1.448-2.954a2.206 2.206 0 0 1-1.344-2.033c0-1.218.985-2.205 2.2-2.205 1.215 0 2.2.987 2.2 2.205Z",
                fill: "url(#paint0_linear_10098_21308)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "path-3-inside-1_10098_21308",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M19.53 6.615a.75.75 0 0 1 .525-.204v9.093a2.203 2.203 0 0 0-2.073 2.201c0 .914.554 1.698 1.344 2.033l-1.448 2.954a.561.561 0 0 0 .504.808h1.673v10.467a.999.999 0 0 1-.261-.035C14.59 32.526 8.855 27.413 8.855 22.93V10.455c0-.303.246-.547.549-.554 5.552-.115 8.775-1.961 10.125-3.286Z"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.53 6.615a.75.75 0 0 1 .525-.204v9.093a2.203 2.203 0 0 0-2.073 2.201c0 .914.554 1.698 1.344 2.033l-1.448 2.954a.561.561 0 0 0 .504.808h1.673v10.467a.999.999 0 0 1-.261-.035C14.59 32.526 8.855 27.413 8.855 22.93V10.455c0-.303.246-.547.549-.554 5.552-.115 8.775-1.961 10.125-3.286Z",
                fill: "url(#paint1_linear_10098_21308)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.53 6.615a.75.75 0 0 1 .525-.204v9.093a2.203 2.203 0 0 0-2.073 2.201c0 .914.554 1.698 1.344 2.033l-1.448 2.954a.561.561 0 0 0 .504.808h1.673v10.467a.999.999 0 0 1-.261-.035C14.59 32.526 8.855 27.413 8.855 22.93V10.455c0-.303.246-.547.549-.554 5.552-.115 8.775-1.961 10.125-3.286Z",
                fill: "#4300DA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M20.055 6.411h13.26v-13.26h-13.26v13.26Zm-.526.204 9.285 9.466-9.285-9.466Zm.526 8.889.754 13.238 12.506-.712V15.504h-13.26Zm-.729 4.234 11.906 5.837 6.17-12.584-12.906-5.464-5.17 12.21Zm-1.448 2.954 11.906 5.837-11.906-5.837Zm2.177.808h13.26V10.24h-13.26V23.5Zm0 10.467v13.26h13.26v-13.26h-13.26Zm-.261-.035 3.46-12.8-3.46 12.8ZM9.404 9.902 9.129-3.357l.275 13.257Zm10.65-16.75c-3.145 0-6.844 1.088-9.81 3.997l18.57 18.932c-2.688 2.637-6 3.59-8.758 3.59l-.002-26.52Zm13.261 22.352V6.41H6.795v9.093h26.52ZM19.301 2.265c-8.162.465-14.58 7.221-14.58 15.44h26.52c0 5.868-4.582 10.704-10.432 11.037L19.3 2.265Zm-14.58 15.44c0 6.411 3.901 11.9 9.436 14.243l10.34-24.421c3.953 1.674 6.745 5.595 6.745 10.178H4.722Zm2.7-3.805-1.449 2.954L29.784 28.53l1.448-2.954L7.42 13.9Zm-1.449 2.954C1.47 26.037 8.155 36.76 18.382 36.76V10.24c9.397 0 15.539 9.852 11.402 18.289L5.972 16.854Zm12.41 19.906h1.673V10.24h-1.673v26.52Zm14.933-2.793V23.5H6.795v10.467h26.52Zm-16.98 12.766c1.207.327 2.458.494 3.72.494v-26.52c1.087 0 2.162.145 3.199.425l-6.92 25.601ZM-4.406 22.93c0 7.518 4.423 13.155 7.563 16.19 3.482 3.365 8.14 6.252 13.176 7.613l6.92-25.601c.012.003-.23-.068-.639-.31a5.65 5.65 0 0 1-1.027-.772c-.287-.278-.27-.34-.122-.07.13.239.649 1.268.649 2.95h-26.52Zm0-12.475V22.93h26.52V10.455h-26.52ZM9.129-3.355c-7.303.15-13.534 6.078-13.534 13.81h26.52c0 7.126-5.738 12.565-12.436 12.704l-.55-26.515Zm1.115.504c.422-.414.745-.634.894-.727.164-.102.221-.116.145-.087-.138.053-.804.281-2.154.31l.55 26.514c8.313-.173 14.968-2.99 19.135-7.078L10.244-2.85Z",
                fill: "#9C85FD",
                mask: "url(#path-3-inside-1_10098_21308)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 4,
                y: 24,
                width: 3,
                height: 3,
                rx: 0.5,
                fill: "url(#paint2_linear_10098_21308)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 4,
                y: 12,
                width: 3,
                height: 3,
                rx: 0.5,
                fill: "url(#paint3_linear_10098_21308)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.229 21.367a.2.2 0 0 0-.143-.34H4.51a.503.503 0 0 1-.503-.503v-2.105c0-.278.226-.503.503-.503h7.571a.2.2 0 0 0 .141-.342l-1.724-1.719a.5.5 0 0 1 .354-.854l1.852.003a1 1 0 0 1 .735.324l3.423 3.73a.8.8 0 0 1-.013 1.096l-3.411 3.539a1 1 0 0 1-.72.306h-1.885a.5.5 0 0 1-.356-.85l1.753-1.782Z",
                fill: "#F7F8F8",
                fillOpacity: 0.14
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.229 21.367a.2.2 0 0 0-.143-.34H4.51a.503.503 0 0 1-.503-.503v-2.105c0-.278.226-.503.503-.503h7.571a.2.2 0 0 0 .141-.342l-1.724-1.719a.5.5 0 0 1 .354-.854l1.852.003a1 1 0 0 1 .735.324l3.423 3.73a.8.8 0 0 1-.013 1.096l-3.411 3.539a1 1 0 0 1-.72.306h-1.885a.5.5 0 0 1-.356-.85l1.753-1.782Z",
                fill: "url(#paint4_linear_10098_21308)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.229 21.367a.2.2 0 0 0-.143-.34H4.51a.503.503 0 0 1-.503-.503v-2.105c0-.278.226-.503.503-.503h7.571a.2.2 0 0 0 .141-.342l-1.724-1.719a.5.5 0 0 1 .354-.854l1.852.003a1 1 0 0 1 .735.324l3.423 3.73a.8.8 0 0 1-.013 1.096l-3.411 3.539a1 1 0 0 1-.72.306h-1.885a.5.5 0 0 1-.356-.85l1.753-1.782Z",
                fill: "url(#paint5_linear_10098_21308)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_10098_21308",
                        x1: 7.015,
                        y1: 22.042,
                        x2: 32.038,
                        y2: 14.65,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_10098_21308",
                        x1: 7.935,
                        y1: 22.198,
                        x2: 21.238,
                        y2: 20.202,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint2_linear_10098_21308",
                        x1: 10.724,
                        y1: 24.701,
                        x2: 1.456,
                        y2: 26.336,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FFF06A"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EC78FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint3_linear_10098_21308",
                        x1: 10.724,
                        y1: 12.701,
                        x2: 1.456,
                        y2: 14.336,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FFF06A"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EC78FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint4_linear_10098_21308",
                        x1: -13.367,
                        y1: 22.362,
                        x2: 17.596,
                        y2: 13.63,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FFF06A"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EC78FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint5_linear_10098_21308",
                        x1: -1.896,
                        y1: 23.03,
                        x2: 26.205,
                        y2: 13.143,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#EC78FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFF06A"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $2ba6e29ae56c0640$export$2e2bcd8739ae039 = $2ba6e29ae56c0640$var$SvgProtectedAppDark;

});

parcelRequire.register("lwdI3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $105471db53cdaf09$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $105471db53cdaf09$var$SvgProtectedApp = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 40,
                height: 40,
                rx: 8,
                fill: "#F3EFFA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M30.706 9.901c.303.007.549.251.549.554V22.93c0 4.483-5.736 9.596-10.939 11.002a.997.997 0 0 1-.522 0C14.59 32.526 8.855 27.413 8.855 22.93V10.455c0-.303.246-.547.549-.554 5.552-.115 8.775-1.961 10.125-3.286a.78.78 0 0 1 1.052 0c1.35 1.325 4.573 3.171 10.125 3.286Zm-8.324 7.804c0 .914-.555 1.698-1.345 2.033l1.152 3a.561.561 0 0 1-.524.762h-3.283a.561.561 0 0 1-.504-.808l1.448-2.954a2.206 2.206 0 0 1-1.344-2.033c0-1.218.985-2.205 2.2-2.205 1.215 0 2.2.987 2.2 2.205Z",
                fill: "url(#paint0_linear_10098_21288)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.53 6.615a.75.75 0 0 1 .525-.204v9.093a2.203 2.203 0 0 0-2.073 2.201c0 .914.554 1.698 1.344 2.033l-1.448 2.954a.561.561 0 0 0 .504.808h1.673v10.467a.999.999 0 0 1-.261-.035C14.59 32.526 8.855 27.413 8.855 22.93V10.455c0-.303.246-.547.549-.554 5.552-.115 8.775-1.961 10.125-3.286Z",
                fill: "url(#paint1_linear_10098_21288)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.53 6.615a.75.75 0 0 1 .525-.204v9.093a2.203 2.203 0 0 0-2.073 2.201c0 .914.554 1.698 1.344 2.033l-1.448 2.954a.561.561 0 0 0 .504.808h1.673v10.467a.999.999 0 0 1-.261-.035C14.59 32.526 8.855 27.413 8.855 22.93V10.455c0-.303.246-.547.549-.554 5.552-.115 8.775-1.961 10.125-3.286Z",
                fill: "#4300DA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 4,
                y: 24,
                width: 3,
                height: 3,
                rx: 0.5,
                fill: "url(#paint2_linear_10098_21288)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 4,
                y: 12,
                width: 3,
                height: 3,
                rx: 0.5,
                fill: "url(#paint3_linear_10098_21288)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.229 21.367a.2.2 0 0 0-.143-.34H4.51a.503.503 0 0 1-.503-.503v-2.105c0-.278.226-.503.503-.503h7.571a.2.2 0 0 0 .141-.342l-1.724-1.719a.5.5 0 0 1 .354-.854l1.852.003a1 1 0 0 1 .735.324l3.423 3.73a.8.8 0 0 1-.013 1.096l-3.411 3.539a1 1 0 0 1-.72.306h-1.885a.5.5 0 0 1-.356-.85l1.753-1.782Z",
                fill: "#191C1D",
                fillOpacity: 0.12
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.229 21.367a.2.2 0 0 0-.143-.34H4.51a.503.503 0 0 1-.503-.503v-2.105c0-.278.226-.503.503-.503h7.571a.2.2 0 0 0 .141-.342l-1.724-1.719a.5.5 0 0 1 .354-.854l1.852.003a1 1 0 0 1 .735.324l3.423 3.73a.8.8 0 0 1-.013 1.096l-3.411 3.539a1 1 0 0 1-.72.306h-1.885a.5.5 0 0 1-.356-.85l1.753-1.782Z",
                fill: "url(#paint4_linear_10098_21288)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.229 21.367a.2.2 0 0 0-.143-.34H4.51a.503.503 0 0 1-.503-.503v-2.105c0-.278.226-.503.503-.503h7.571a.2.2 0 0 0 .141-.342l-1.724-1.719a.5.5 0 0 1 .354-.854l1.852.003a1 1 0 0 1 .735.324l3.423 3.73a.8.8 0 0 1-.013 1.096l-3.411 3.539a1 1 0 0 1-.72.306h-1.885a.5.5 0 0 1-.356-.85l1.753-1.782Z",
                fill: "url(#paint5_linear_10098_21288)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_10098_21288",
                        x1: 7.015,
                        y1: 22.042,
                        x2: 32.038,
                        y2: 14.65,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_10098_21288",
                        x1: 7.935,
                        y1: 22.198,
                        x2: 21.238,
                        y2: 20.202,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint2_linear_10098_21288",
                        x1: 10.724,
                        y1: 24.701,
                        x2: 1.456,
                        y2: 26.336,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FFF06A"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EC78FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint3_linear_10098_21288",
                        x1: 10.724,
                        y1: 12.701,
                        x2: 1.456,
                        y2: 14.336,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FFF06A"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EC78FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint4_linear_10098_21288",
                        x1: -13.367,
                        y1: 22.362,
                        x2: 17.596,
                        y2: 13.63,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FFF06A"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EC78FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint5_linear_10098_21288",
                        x1: -1.896,
                        y1: 23.03,
                        x2: 26.205,
                        y2: 13.143,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#EC78FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFF06A"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $105471db53cdaf09$export$2e2bcd8739ae039 = $105471db53cdaf09$var$SvgProtectedApp;

});

parcelRequire.register("bB4n7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db80505624cc131c$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $db80505624cc131c$var$SvgSinglePageAppDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 40,
        height: 41,
        viewBox: "0 0 40 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                y: 0.5,
                width: 40,
                height: 40,
                rx: 8,
                fill: "#F7F8F8",
                fillOpacity: 0.12
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M28.5 12.5c0 2.148-.436 4.069-1.119 5.433C26.684 19.328 25.813 20 25 20c-.813 0-1.684-.672-2.381-2.067-.683-1.364-1.119-3.285-1.119-5.433 0-2.148.436-4.069 1.119-5.433C23.316 5.672 24.187 5 25 5c.813 0 1.684.672 2.381 2.067.683 1.364 1.119 3.285 1.119 5.433Z",
                stroke: "#9D85FD",
                strokeMiterlimit: 16,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M26.75 9.469c1.861 1.074 3.306 2.412 4.146 3.685.86 1.301 1.006 2.392.6 3.096-.407.704-1.424 1.122-2.98 1.029-1.524-.092-3.405-.674-5.265-1.748-1.861-1.074-3.306-2.412-4.146-3.686-.86-1.3-1.006-2.391-.6-3.095.407-.704 1.424-1.122 2.98-1.029 1.524.091 3.405.674 5.265 1.748Z",
                stroke: "#9D85FD",
                strokeMiterlimit: 16,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M23.252 9.469c-1.861 1.074-3.306 2.412-4.146 3.685-.86 1.301-1.006 2.392-.6 3.096.407.704 1.424 1.122 2.98 1.029 1.524-.092 3.405-.674 5.265-1.748 1.861-1.074 3.306-2.412 4.146-3.686.86-1.3 1.006-2.391.6-3.095-.407-.704-1.424-1.122-2.98-1.029-1.524.091-3.405.674-5.265 1.748Z",
                stroke: "#9C85FD",
                strokeMiterlimit: 16,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 25,
                cy: 12.5,
                r: 1,
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m4.778 18.24 4.906-1.635a1 1 0 0 1 .632 0l4.906 1.635a1 1 0 0 1 .676 1.073l-.825 6.601a1 1 0 0 1-.62.805L10.37 28.35a1 1 0 0 1-.742 0L5.548 26.72a1 1 0 0 1-.621-.805l-.825-6.6a1 1 0 0 1 .676-1.074Z",
                fill: "url(#paint0_linear_4270_17366)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M11.582 25.5H13l-2.218-6H9.214L7 25.5h1.37l.486-1.455h2.24l.486 1.455ZM9.96 20.648h.031l.818 2.457H9.143l.817-2.457Z",
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m18.495 23.27 8.084 12.576a.5.5 0 0 0 .842 0l8.084-12.576a.5.5 0 0 0-.42-.77h-5.817a.5.5 0 0 0-.416.223l-1.436 2.153a.5.5 0 0 1-.832 0l-1.436-2.153a.5.5 0 0 0-.416-.223h-5.816a.5.5 0 0 0-.42.77Z",
                fill: "url(#paint1_linear_4270_17366)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "mask0_4270_17366",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 18,
                y: 22,
                width: 18,
                height: 15,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    opacity: 0.7,
                    d: "m18.495 23.27 8.084 12.576a.5.5 0 0 0 .842 0l8.084-12.576a.5.5 0 0 0-.42-.77h-5.817a.5.5 0 0 0-.416.223L27 25.5l-1.852-2.777a.5.5 0 0 0-.416-.223h-5.816a.5.5 0 0 0-.42.77Z",
                    fill: "#7958FF"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("g", {
                mask: "url(#mask0_4270_17366)",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    d: "m22 22.5 4.576 7.322a.5.5 0 0 0 .848 0L32 22.5H22Z",
                    fill: "#4300DA"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_4270_17366",
                        x1: 1,
                        y1: 24.5,
                        x2: 16.943,
                        y2: 21.625,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FFF06A"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EC78FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_4270_17366",
                        x1: 16.521,
                        y1: 30.521,
                        x2: 34.363,
                        y2: 22.051,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $db80505624cc131c$export$2e2bcd8739ae039 = $db80505624cc131c$var$SvgSinglePageAppDark;

});

parcelRequire.register("XFmQ1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $219067b74f10a9ee$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $219067b74f10a9ee$var$SvgSinglePageApp = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 40,
                height: 40,
                rx: 8,
                fill: "#F3EFFA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M28.5 12c0 2.148-.436 4.069-1.119 5.433C26.684 18.828 25.813 19.5 25 19.5c-.813 0-1.684-.672-2.381-2.067C21.936 16.07 21.5 14.148 21.5 12c0-2.148.436-4.069 1.119-5.433C23.316 5.172 24.187 4.5 25 4.5c.813 0 1.684.672 2.381 2.067C28.064 7.93 28.5 9.852 28.5 12Z",
                stroke: "#7958FF",
                strokeMiterlimit: 16,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M26.75 8.969c1.86 1.074 3.305 2.412 4.146 3.685.859 1.302 1.006 2.392.6 3.096-.407.704-1.425 1.122-2.981 1.029-1.523-.092-3.405-.674-5.265-1.748-1.86-1.074-3.305-2.412-4.146-3.685-.859-1.302-1.006-2.392-.6-3.096.407-.704 1.425-1.122 2.981-1.029 1.523.092 3.405.674 5.265 1.748Z",
                stroke: "#7958FF",
                strokeMiterlimit: 16,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M23.25 8.969c-1.86 1.074-3.305 2.412-4.146 3.685-.859 1.302-1.006 2.392-.6 3.096.407.704 1.425 1.122 2.981 1.029 1.523-.092 3.405-.674 5.265-1.748 1.86-1.074 3.305-2.412 4.146-3.685.859-1.302 1.006-2.392.6-3.096-.407-.704-1.425-1.122-2.981-1.029-1.523.092-3.405.674-5.265 1.748Z",
                stroke: "#7958FF",
                strokeMiterlimit: 16,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 25,
                cy: 12,
                r: 1,
                fill: "#F07EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m4.778 17.74 4.906-1.635a1 1 0 0 1 .632 0l4.906 1.636a1 1 0 0 1 .676 1.073l-.825 6.6a1 1 0 0 1-.62.805l-4.082 1.632a1 1 0 0 1-.742 0L5.548 26.22a1 1 0 0 1-.621-.804l-.825-6.601a1 1 0 0 1 .676-1.073Z",
                fill: "url(#paint0_linear_1091_20233)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M11.582 25H13l-2.218-6H9.214L7 25h1.37l.486-1.455h2.24L11.582 25ZM9.96 20.148h.031l.818 2.457H9.143l.817-2.457Z",
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m18.495 22.77 8.084 12.576a.5.5 0 0 0 .842 0l8.084-12.576a.5.5 0 0 0-.42-.77h-5.817a.5.5 0 0 0-.416.223L27 25l-1.852-2.777a.5.5 0 0 0-.416-.223h-5.816a.5.5 0 0 0-.42.77Z",
                fill: "url(#paint1_linear_1091_20233)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "mask0_1091_20233",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 18,
                y: 22,
                width: 18,
                height: 14,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    opacity: 0.7,
                    d: "m18.495 22.77 8.084 12.576a.5.5 0 0 0 .842 0l8.084-12.576a.5.5 0 0 0-.42-.77h-5.817a.5.5 0 0 0-.416.223L27 25l-1.852-2.777a.5.5 0 0 0-.416-.223h-5.816a.5.5 0 0 0-.42.77Z",
                    fill: "#7958FF"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("g", {
                mask: "url(#mask0_1091_20233)",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    d: "m22 22 4.576 7.322a.5.5 0 0 0 .848 0L32 22H22Z",
                    fill: "#4300DA"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_1091_20233",
                        x1: 1,
                        y1: 24,
                        x2: 16.943,
                        y2: 21.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FFF06A"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EC78FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_1091_20233",
                        x1: 16.521,
                        y1: 30.021,
                        x2: 34.363,
                        y2: 21.551,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $219067b74f10a9ee$export$2e2bcd8739ae039 = $219067b74f10a9ee$var$SvgSinglePageApp;

});

parcelRequire.register("isD4E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f30178ed5916a35$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $0f30178ed5916a35$var$SvgTraditionalWebAppDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 40,
        height: 41,
        viewBox: "0 0 40 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                y: 0.5,
                width: 40,
                height: 40,
                rx: 8,
                fill: "#F7F8F8",
                fillOpacity: 0.12
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                opacity: 0.8,
                d: "M7.5 13.5a2 2 0 0 1 2-2h21a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2h-21a2 2 0 0 1-2-2v-15Z",
                fill: "url(#paint0_linear_4270_17367)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M7.5 15.571h25V13.5a2 2 0 0 0-2-2h-21a2 2 0 0 0-2 2v2.071Z",
                fill: "#5D34F2"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M10.277 18.964c0-.375.304-.679.679-.679h6.976a.679.679 0 1 1 0 1.357h-6.976a.679.679 0 0 1-.679-.678ZM10.277 23.036c0-.375.304-.679.679-.679h15.31a.679.679 0 1 1 0 1.358h-15.31a.679.679 0 0 1-.679-.679Z",
                fill: "#D3BCF3"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                opacity: 0.6,
                d: "M29.35 25.5a.667.667 0 0 1 1.156 0l5.773 10a.667.667 0 0 1-.577 1H24.155a.667.667 0 0 1-.578-1l5.774-10Z",
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 10,
                cy: 10.5,
                r: 6,
                fill: "#F07EFF",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("defs", {
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                    id: "paint0_linear_4270_17367",
                    x1: 5.446,
                    y1: 22.385,
                    x2: 30.012,
                    y2: 10.451,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            stopColor: "#492EF3"
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            offset: 1,
                            stopColor: "#CF69FF"
                        })
                    ]
                })
            })
        ]
    });
var $0f30178ed5916a35$export$2e2bcd8739ae039 = $0f30178ed5916a35$var$SvgTraditionalWebAppDark;

});

parcelRequire.register("7GmJf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f7b4c32ff993fde$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $2f7b4c32ff993fde$var$SvgTraditionalWebApp = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 40,
                height: 40,
                rx: 8,
                fill: "#F3EFFA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                opacity: 0.8,
                x: 7.5,
                y: 11,
                width: 25,
                height: 19,
                rx: 2,
                fill: "url(#paint0_linear_1091_20177)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M7.5 15.072h25V13a2 2 0 0 0-2-2h-21a2 2 0 0 0-2 2v2.072Z",
                fill: "#5D34F2"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 10.277,
                y: 17.786,
                width: 8.333,
                height: 1.357,
                rx: 0.679,
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 10.277,
                y: 21.857,
                width: 16.667,
                height: 1.357,
                rx: 0.679,
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                opacity: 0.8,
                d: "M29.35 25a.667.667 0 0 1 1.156 0l5.773 10a.667.667 0 0 1-.577 1H24.155a.667.667 0 0 1-.578-1l5.774-10Z",
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 10,
                cy: 10,
                r: 6,
                fill: "#F07EFF",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("defs", {
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                    id: "paint0_linear_1091_20177",
                    x1: 5.446,
                    y1: 21.885,
                    x2: 30.012,
                    y2: 9.951,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            stopColor: "#492EF3"
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            offset: 1,
                            stopColor: "#CF69FF"
                        })
                    ]
                })
            })
        ]
    });
var $2f7b4c32ff993fde$export$2e2bcd8739ae039 = $2f7b4c32ff993fde$var$SvgTraditionalWebApp;

});

parcelRequire.register("dxSXj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8a38d74272c6a42$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $d8a38d74272c6a42$var$SvgThirdPartyAppDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 40,
        height: 41,
        viewBox: "0 0 40 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                y: 0.5,
                width: 40,
                height: 40,
                rx: 8,
                fill: "#F7F8F8",
                fillOpacity: 0.12
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "mask0_10024_21501",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 7,
                y: 6,
                width: 26,
                height: 29,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    d: "M18.466 6.924c.583-.337.874-.505 1.184-.57a2 2 0 0 1 .832 0c.31.065.601.233 1.184.57l9.483 5.474c.582.337.874.505 1.086.74a2 2 0 0 1 .416.72c.098.302.098.639.098 1.312v10.95c0 .672 0 1.009-.098 1.31a1.999 1.999 0 0 1-.416.72c-.212.236-.503.404-1.086.74l-9.483 5.475c-.583.337-.874.505-1.184.571a2.002 2.002 0 0 1-.832 0c-.31-.066-.601-.234-1.184-.57L8.984 28.89c-.583-.337-.875-.505-1.087-.74a2 2 0 0 1-.416-.72c-.097-.302-.097-.639-.097-1.312V15.17c0-.672 0-1.009.097-1.31a2 2 0 0 1 .416-.72c.212-.236.504-.404 1.087-.74l9.482-5.475Z",
                    fill: "#000"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                mask: "url(#mask0_10024_21501)",
                fillRule: "evenodd",
                clipRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M31.949 12.827a.2.2 0 0 1 0 .346l-10.825 6.25a2 2 0 0 1-2 0L8.3 13.173a.2.2 0 0 1 0-.346L20.124 6l11.825 6.827Z",
                        fill: "#AF9EFF"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M7.384 14.346a.2.2 0 0 1 .3-.173l10.824 6.25a2 2 0 0 1 1 1.732v12.498a.2.2 0 0 1-.3.174L7.384 28V14.346Z",
                        fill: "#947DFF"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M32.749 14.346a.2.2 0 0 0-.3-.173l-10.825 6.25a2 2 0 0 0-1 1.732v12.499a.2.2 0 0 0 .3.173L32.75 28V14.346Z",
                        fill: "#7958FF"
                    })
                ]
            })
        ]
    });
var $d8a38d74272c6a42$export$2e2bcd8739ae039 = $d8a38d74272c6a42$var$SvgThirdPartyAppDark;

});

parcelRequire.register("e8luV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1e5b58a78c70917$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $f1e5b58a78c70917$var$SvgThirdPartyApp = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 40,
                height: 40,
                rx: 8,
                fill: "#F3EFFA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "mask0_462_19017",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 7,
                y: 5,
                width: 26,
                height: 29,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    d: "M18.466 5.924c.583-.337.875-.505 1.184-.57a2 2 0 0 1 .832 0c.31.065.601.233 1.184.57l9.483 5.474c.583.337.874.505 1.086.74a2 2 0 0 1 .416.72c.098.302.098.639.098 1.312v10.95c0 .672 0 1.009-.098 1.31a2 2 0 0 1-.416.72c-.212.236-.503.404-1.086.74l-9.483 5.475c-.583.337-.874.505-1.184.571a2.002 2.002 0 0 1-.831 0c-.31-.066-.602-.234-1.185-.57L8.984 27.89c-.583-.337-.875-.505-1.087-.74a2 2 0 0 1-.415-.72c-.098-.302-.098-.639-.098-1.312V14.17c0-.672 0-1.009.098-1.31a2 2 0 0 1 .415-.72c.212-.236.504-.404 1.087-.74l9.482-5.475Z",
                    fill: "#000"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                mask: "url(#mask0_462_19017)",
                fillRule: "evenodd",
                clipRule: "evenodd",
                fill: "#7958FF",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        opacity: 0.22,
                        d: "M31.949 11.827a.2.2 0 0 1 0 .346l-10.825 6.25a2 2 0 0 1-2 0L8.3 12.173a.2.2 0 0 1 0-.346L20.124 5l11.825 6.827Z"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        opacity: 0.4,
                        d: "M7.384 13.346a.2.2 0 0 1 .3-.173l10.824 6.25a2 2 0 0 1 1 1.732v12.498a.2.2 0 0 1-.3.174L7.384 27V13.346Z"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        opacity: 0.6,
                        d: "M32.748 13.346a.2.2 0 0 0-.3-.173l-10.824 6.25a2 2 0 0 0-1 1.732v12.499a.2.2 0 0 0 .3.173L32.748 27V13.346Z"
                    })
                ]
            })
        ]
    });
var $f1e5b58a78c70917$export$2e2bcd8739ae039 = $f1e5b58a78c70917$var$SvgThirdPartyApp;

});


parcelRequire.register("lmQmj", function(module, exports) {

$parcel$export(module.exports, "connectorTitlePlaceHolder", function () { return $03a2bba1cdfede57$export$8cda72be599ebe6e; });
$parcel$export(module.exports, "connectorPlatformLabel", function () { return $03a2bba1cdfede57$export$c4d4d16912adcc79; });
$parcel$export(module.exports, "connectorPlaceholderIcon", function () { return $03a2bba1cdfede57$export$bba2184b1a46bf3c; });
$parcel$export(module.exports, "defaultSmsConnectorGroup", function () { return $03a2bba1cdfede57$export$2622c3c996991e6; });
$parcel$export(module.exports, "defaultEmailConnectorGroup", function () { return $03a2bba1cdfede57$export$bdeb041190326b74; });
$parcel$export(module.exports, "supportNativePlatformTargets", function () { return $03a2bba1cdfede57$export$1457ebbf3974f034; });
parcelRequire("cuPVN");
var $kowfT = parcelRequire("kowfT");
var $cIy8v = parcelRequire("cIy8v");

var $e96yw = parcelRequire("e96yw");

var $Fku4Z = parcelRequire("Fku4Z");
const $03a2bba1cdfede57$export$8cda72be599ebe6e = Object.freeze({
    [(0, $kowfT.ConnectorType).Sms]: "connectors.type.sms",
    [(0, $kowfT.ConnectorType).Email]: "connectors.type.email",
    [(0, $kowfT.ConnectorType).Social]: "connectors.type.social"
});
const $03a2bba1cdfede57$export$c4d4d16912adcc79 = Object.freeze({
    [(0, $cIy8v.ConnectorPlatform).Native]: "connectors.platform.native",
    [(0, $cIy8v.ConnectorPlatform).Universal]: "connectors.platform.universal",
    [(0, $cIy8v.ConnectorPlatform).Web]: "connectors.platform.web"
});
const $03a2bba1cdfede57$export$bba2184b1a46bf3c = Object.freeze({
    [(0, $kowfT.ConnectorType).Sms]: (0, $Fku4Z.default),
    [(0, $kowfT.ConnectorType).Email]: (0, $e96yw.default)
});
const $03a2bba1cdfede57$export$2622c3c996991e6 = {
    id: "default-sms-connector",
    type: (0, $kowfT.ConnectorType).Sms,
    connectors: [],
    name: {
        en: ""
    },
    description: {
        en: ""
    },
    logo: "",
    logoDark: null,
    target: ""
};
const $03a2bba1cdfede57$export$bdeb041190326b74 = {
    id: "default-email-connector",
    type: (0, $kowfT.ConnectorType).Email,
    connectors: [],
    name: {
        en: ""
    },
    description: {
        en: ""
    },
    logo: "",
    logoDark: null,
    target: ""
};
const $03a2bba1cdfede57$export$1457ebbf3974f034 = [
    "wechat",
    "alipay"
];

});
parcelRequire.register("e96yw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cee6fefecb41f3c$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $2cee6fefecb41f3c$var$SvgConnectorEmail = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 24,
        height: 20,
        viewBox: "0 0 24 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.55.037 12 8.587 3.452.036C3.632.013 3.814 0 4 0h16c.186 0 .37.013.55.037ZM12 10.95a.998.998 0 0 1-.758-.292L1.48.893A3.992 3.992 0 0 0 0 4v12a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V4A3.992 3.992 0 0 0 22.521.894l-9.762 9.763a.997.997 0 0 1-.758.291Z",
                fill: "url(#paint0_linear_1570_8802)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("defs", {
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                    id: "paint0_linear_1570_8802",
                    x1: 17,
                    y1: 0,
                    x2: -1.5,
                    y2: 20,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            stopColor: "#D361E7"
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            offset: 1,
                            stopColor: "#7D5FF4"
                        })
                    ]
                })
            })
        ]
    });
var $2cee6fefecb41f3c$export$2e2bcd8739ae039 = $2cee6fefecb41f3c$var$SvgConnectorEmail;

});

parcelRequire.register("Fku4Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58f29bd75130b73b$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $58f29bd75130b73b$var$SvgConnectorSms = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 26,
        height: 28,
        viewBox: "0 0 26 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 16,
                height: 28,
                rx: 4,
                fill: "url(#paint0_linear_3194_16010)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 8,
                cy: 25,
                r: 1.5,
                stroke: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M4 0h8v1a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V0Z",
                fill: "#2D009D"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M8 9a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v5a4 4 0 0 1-4 4h-7.892a4 4 0 0 0-2.058.57l-2.536 1.521A1 1 0 0 1 8 19.234V9Z",
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M12.077 14.114c1.113 0 1.778-.55 1.778-1.415v-.003c0-.682-.41-1.043-1.31-1.219l-.436-.084c-.457-.091-.65-.223-.65-.463v-.003c0-.252.229-.425.615-.425.39 0 .653.176.697.44l.006.035h.996l-.002-.036c-.065-.747-.642-1.283-1.703-1.283-.972 0-1.675.533-1.678 1.363v.002c0 .66.386 1.082 1.28 1.254l.436.085c.496.097.683.208.683.446v.002c0 .27-.275.46-.694.46-.434 0-.724-.187-.753-.448l-.003-.026h-1.026l.003.053c.044.785.707 1.265 1.761 1.265ZM14.55 14h.946v-2.692h.059l.96 2.692h.613l.961-2.692h.062V14h.943V9.772h-1.222l-1.02 2.869h-.055l-1.023-2.869H14.55V14Zm7.002.114c1.113 0 1.778-.55 1.778-1.415v-.003c0-.682-.41-1.043-1.31-1.219l-.436-.084c-.457-.091-.65-.223-.65-.463v-.003c0-.252.228-.425.615-.425.39 0 .653.176.697.44l.006.035h.996l-.003-.036c-.064-.747-.641-1.283-1.702-1.283-.973 0-1.676.533-1.678 1.363v.002c0 .66.386 1.082 1.28 1.254l.436.085c.495.097.683.208.683.446v.002c0 .27-.276.46-.694.46-.434 0-.724-.187-.753-.448l-.003-.026h-1.026l.003.053c.044.785.706 1.265 1.761 1.265Z",
                fill: "#191C1D"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("defs", {
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                    id: "paint0_linear_3194_16010",
                    x1: -1.314,
                    y1: 16.042,
                    x2: 17.291,
                    y2: 12.116,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            stopColor: "#492EF3"
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            offset: 1,
                            stopColor: "#CF69FF"
                        })
                    ]
                })
            })
        ]
    });
var $58f29bd75130b73b$export$2e2bcd8739ae039 = $58f29bd75130b73b$var$SvgConnectorSms;

});


parcelRequire.register("h8YkU", function(module, exports) {

$parcel$export(module.exports, "auditLogEventTitle", function () { return $cd51a9c2d7f9837d$export$68fd187e42e1a450; });
$parcel$export(module.exports, "logEventTitle", function () { return $cd51a9c2d7f9837d$export$dd2e226a5b5c4031; });
const $cd51a9c2d7f9837d$export$68fd187e42e1a450 = Object.freeze({
    "ExchangeTokenBy.AuthorizationCode": "Exchange token by Code",
    "ExchangeTokenBy.ClientCredentials": "Exchange token by Client Credentials",
    "ExchangeTokenBy.RefreshToken": "Exchange token by Refresh Token",
    "Interaction.Create": "Interaction started",
    "Interaction.End": "Interaction ended",
    "Interaction.ForgotPassword.Identifier.VerificationCode.Create": "Create and send forgot-password verification code",
    "Interaction.ForgotPassword.Identifier.VerificationCode.Submit": "Submit and verify forgot-password verification code",
    "Interaction.ForgotPassword.Profile.Create": "Put new forgot-password interaction profile",
    "Interaction.ForgotPassword.Profile.Delete": "Delete forgot-password interaction profile",
    "Interaction.ForgotPassword.Profile.Update": "Patch update forgot-password interaction profile",
    "Interaction.ForgotPassword.Submit": "Submit forgot-password interaction",
    "Interaction.ForgotPassword.Update": "Update forgot-password interaction",
    "Interaction.Register.Identifier.VerificationCode.Create": "Create and send register identifier with verification code",
    "Interaction.Register.Identifier.VerificationCode.Submit": "Submit and verify register verification code",
    "Interaction.Register.Profile.Create": "Put new register interaction profile",
    "Interaction.Register.Profile.Delete": "Delete register interaction profile",
    "Interaction.Register.Profile.Update": "Patch update register interaction profile",
    "Interaction.Register.Submit": "Submit register interaction",
    "Interaction.Register.Update": "Update register interaction",
    "Interaction.SignIn.Identifier.Password.Submit": "Submit sign-in identifier with password",
    "Interaction.SignIn.Identifier.Social.Create": "Create social sign-in authorization-url",
    "Interaction.SignIn.Identifier.Social.Submit": "Authenticate and submit social identifier",
    "Interaction.SignIn.Identifier.VerificationCode.Create": "Create and send sign-in verification code",
    "Interaction.SignIn.Identifier.VerificationCode.Submit": "Submit and verify sign-in identifier with verification code",
    "Interaction.SignIn.Profile.Create": "Put new sign-in interaction profile",
    "Interaction.SignIn.Profile.Delete": "Delete sign-in interaction profile",
    "Interaction.SignIn.Profile.Update": "Patch Update sign-in interaction profile",
    "Interaction.SignIn.Submit": "Submit sign-in interaction",
    "Interaction.SignIn.Update": "Update sign-in interaction",
    "Interaction.SignIn.Identifier.SingleSignOn.Create": "Create single-sign-on authentication session",
    "Interaction.SignIn.Identifier.SingleSignOn.Submit": "Submit single-sign-on authentication interaction"
});
const $cd51a9c2d7f9837d$export$dd2e226a5b5c4031 = {
    ...$cd51a9c2d7f9837d$export$68fd187e42e1a450
};

});

parcelRequire.register("7YcaX", function(module, exports) {

$parcel$export(module.exports, "getManagementApi", function () { return $9e271580ad42e7c6$export$bf13d33c4ce8e38d; });
$parcel$export(module.exports, "meApi", function () { return $9e271580ad42e7c6$export$6acfde9189b78772; });
$parcel$export(module.exports, "cloudApi", function () { return $9e271580ad42e7c6$export$84e66cc9b5c68656; });
parcelRequire("cuPVN");
var $j0apn = parcelRequire("j0apn");
var $68782 = parcelRequire("68782");
var $6hxiJ = parcelRequire("6hxiJ");
var $4hqEo = parcelRequire("4hqEo");
const $9e271580ad42e7c6$export$bf13d33c4ce8e38d = (tenantId)=>Object.freeze({
        indicator: (0, $j0apn.getManagementApiResourceIndicator)(tenantId),
        scopes: (0, $68782.PredefinedScope)
    });
const $9e271580ad42e7c6$export$6acfde9189b78772 = Object.freeze({
    indicator: (0, $j0apn.getManagementApiResourceIndicator)((0, $6hxiJ.adminTenantId), "me"),
    scopes: (0, $68782.PredefinedScope)
});
const $9e271580ad42e7c6$export$84e66cc9b5c68656 = Object.freeze({
    indicator: (0, $4hqEo.cloudApiIndicator),
    scopes: (0, $4hqEo.CloudScope)
});

});

parcelRequire.register("ku6YN", function(module, exports) {

$parcel$export(module.exports, "defaultTenantResponse", function () { return $14c85de8e694d382$export$84eb0f8e9528b362; });
$parcel$export(module.exports, "defaultSubscriptionPlan", function () { return $14c85de8e694d382$export$6f6dcaec148943bb; });
$parcel$export(module.exports, "adminTenantEndpoint", function () { return $14c85de8e694d382$export$b21900f0ee1c3331; });
$parcel$export(module.exports, "mainTitle", function () { return $14c85de8e694d382$export$148f1d8a17c0f2b1; });
parcelRequire("cuPVN");
var $j0apn = parcelRequire("j0apn");
var $lXQZH = parcelRequire("lXQZH");
var $iq1sR = parcelRequire("iq1sR");

var $b67J2 = parcelRequire("b67J2");

var $56db5 = parcelRequire("56db5");

var $8TpMk = parcelRequire("8TpMk");
const { tenantId: $14c85de8e694d382$var$tenantId, indicator: $14c85de8e694d382$var$indicator } = (0, $j0apn.defaultManagementApi).resource;
const $14c85de8e694d382$var$defaultSubscriptionPlanId = (0, $lXQZH.ReservedPlanId).Development;
const $14c85de8e694d382$export$84eb0f8e9528b362 = {
    id: $14c85de8e694d382$var$tenantId,
    name: `tenant_${$14c85de8e694d382$var$tenantId}`,
    tag: (0, $iq1sR.TenantTag).Development,
    indicator: $14c85de8e694d382$var$indicator,
    subscription: {
        status: "active",
        planId: $14c85de8e694d382$var$defaultSubscriptionPlanId,
        currentPeriodStart: (0, (/*@__PURE__*/$parcel$interopDefault($b67J2)))().toDate(),
        currentPeriodEnd: (0, (/*@__PURE__*/$parcel$interopDefault($b67J2)))().add(1, "month").toDate()
    },
    usage: {
        activeUsers: 0,
        cost: 0,
        tokenUsage: 0
    },
    openInvoices: [],
    isSuspended: false,
    planId: $14c85de8e694d382$var$defaultSubscriptionPlanId,
    regionName: (0, $56db5.RegionName).EU,
    createdAt: new Date()
};
const $14c85de8e694d382$export$6f6dcaec148943bb = {
    id: $14c85de8e694d382$var$defaultSubscriptionPlanId,
    name: "Development",
    createdAt: new Date(),
    updatedAt: new Date(),
    stripeProducts: [],
    quota: {
        mauLimit: null,
        tokenLimit: null,
        applicationsLimit: null,
        machineToMachineLimit: null,
        resourcesLimit: null,
        scopesPerResourceLimit: null,
        customDomainEnabled: true,
        mfaEnabled: true,
        omniSignInEnabled: true,
        socialConnectorsLimit: null,
        standardConnectorsLimit: null,
        rolesLimit: null,
        machineToMachineRolesLimit: null,
        scopesPerRoleLimit: null,
        auditLogsRetentionDays: null,
        hooksLimit: null,
        organizationsEnabled: true,
        ssoEnabled: true,
        ticketSupportResponseTime: 48,
        thirdPartyApplicationsLimit: null,
        tenantMembersLimit: null,
        customJwtEnabled: true
    }
};
const $14c85de8e694d382$var$getAdminTenantEndpoint = ()=>{
    // Allow endpoint override for dev or testing
    if (0, $8TpMk.adminEndpoint) return new URL((0, $8TpMk.adminEndpoint));
    return new URL((0, $8TpMk.isCloud) ? window.location.origin.replace("cloud.", "auth.") : window.location.origin);
};
const $14c85de8e694d382$export$b21900f0ee1c3331 = $14c85de8e694d382$var$getAdminTenantEndpoint();
const $14c85de8e694d382$export$148f1d8a17c0f2b1 = (0, $8TpMk.isCloud) ? "Logto Cloud" : "Logto Console";

});
parcelRequire.register("b67J2", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", f = "month", h = "quarter", c = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, f), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), f);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: f,
                y: c,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: h
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = function(t) {
        return t instanceof _;
    }, S = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, w = function(t, e) {
        if (p(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, O = v;
    O.l = S, O.i = p, O.w = function(t, e) {
        return w(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = S(t.locale, null, !0), this.parse(t);
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (O.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.$x = t.x || {}, this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return O;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = w(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return w(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < w(t);
        }, m.$g = function(t, e, n) {
            return O.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!O.u(e) || e, h = O.p(t), l = function(t, e) {
                var i = O.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return O.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(h){
                case c:
                    return r ? l(1, 0) : l(31, 11);
                case f:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = O.p(t), h = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = h + "Date", n[d] = h + "Date", n[f] = h + "Month", n[c] = h + "FullYear", n[u] = h + "Hours", n[s] = h + "Minutes", n[i] = h + "Seconds", n[r] = h + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === f || o === c) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[O.p(t)]();
        }, m.add = function(r, h) {
            var d, l = this;
            r = Number(r);
            var $ = O.p(h), y = function(t) {
                var e = w(l);
                return O.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === f) return this.set(f, this.$M + r);
            if ($ === c) return this.set(c, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return O.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = O.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, f = n.months, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, c = function(t) {
                return O.s(s % 12 || 12, t, "0");
            }, d = n.meridiem || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            }, $ = {
                YY: String(this.$y).slice(-2),
                YYYY: this.$y,
                M: a + 1,
                MM: O.s(a + 1, 2, "0"),
                MMM: h(n.monthsShort, a, f, 3),
                MMMM: h(f, a),
                D: this.$D,
                DD: O.s(this.$D, 2, "0"),
                d: String(this.$W),
                dd: h(n.weekdaysMin, this.$W, o, 2),
                ddd: h(n.weekdaysShort, this.$W, o, 3),
                dddd: o[this.$W],
                H: String(s),
                HH: O.s(s, 2, "0"),
                h: c(1),
                hh: c(2),
                a: d(s, u, !0),
                A: d(s, u, !1),
                m: String(u),
                mm: O.s(u, 2, "0"),
                s: String(this.$s),
                ss: O.s(this.$s, 2, "0"),
                SSS: O.s(this.$ms, 3, "0"),
                Z: i
            };
            return r.replace(y, function(t, e) {
                return e || $[t] || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = O.p(d), M = w(r), m = (M.utcOffset() - this.utcOffset()) * e, v = this - M, g = O.m(this, M);
            return g = ($ = {}, $[c] = g / 12, $[f] = g, $[h] = g / 3, $[o] = (v - m) / 6048e5, $[a] = (v - m) / 864e5, $[u] = v / n, $[s] = v / e, $[i] = v / t, $)[y] || v, l ? g : O.a(g);
        }, m.daysInMonth = function() {
            return this.endOf(f).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = S(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return O.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), T = _.prototype;
    return w.prototype = T, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            f
        ],
        [
            "$y",
            c
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        T[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), w.extend = function(t, e) {
        return t.$i || (t(e, _, w), t.$i = !0), w;
    }, w.locale = S, w.isDayjs = p, w.unix = function(t) {
        return w(1e3 * t);
    }, w.en = D[g], w.Ls = D, w.p = {}, w;
});

});

parcelRequire.register("56db5", function(module, exports) {

$parcel$export(module.exports, "RegionName", function () { return $c7e0c346be0a3fbf$export$11a427f05f4c3b2f; });
$parcel$export(module.exports, "default", function () { return $c7e0c346be0a3fbf$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $hvK1V = parcelRequire("hvK1V");
var $c7e0c346be0a3fbf$export$11a427f05f4c3b2f;
(function(RegionName) {
    RegionName["EU"] = "EU";
    RegionName["US"] = "US";
})($c7e0c346be0a3fbf$export$11a427f05f4c3b2f || ($c7e0c346be0a3fbf$export$11a427f05f4c3b2f = {}));
const $c7e0c346be0a3fbf$var$regionFlagMap = Object.freeze({
    [$c7e0c346be0a3fbf$export$11a427f05f4c3b2f.EU]: "\uD83C\uDDEA\uD83C\uDDFA",
    [$c7e0c346be0a3fbf$export$11a427f05f4c3b2f.US]: "\uD83C\uDDFA\uD83C\uDDF8"
});
function $c7e0c346be0a3fbf$var$Region({ isComingSoon: isComingSoon = false, regionName: regionName, className: className }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($hvK1V.regionText, className),
        children: [
            $c7e0c346be0a3fbf$var$regionFlagMap[regionName],
            " ",
            regionName,
            isComingSoon && /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                className: $hvK1V.comingSoon,
                children: `(${t("general.coming_soon")})`
            })
        ]
    });
}
var $c7e0c346be0a3fbf$export$2e2bcd8739ae039 = $c7e0c346be0a3fbf$var$Region;

});
parcelRequire.register("5UrGx", function(module, exports) {
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString === Object.prototype.toString) {
                    for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
                } else classes.push(arg.toString());
            }
        }
        return classes.join(" ");
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRequire.register("jgimp", function(module, exports) {

$parcel$export(module.exports, "Trans", function () { return (parcelRequire("7i2be")).Trans; });
$parcel$export(module.exports, "useTranslation", function () { return (parcelRequire("5OuPq")).useTranslation; });
$parcel$export(module.exports, "withTranslation", function () { return (parcelRequire("2j4C6")).withTranslation; });
$parcel$export(module.exports, "initReactI18next", function () { return (parcelRequire("jw6S0")).initReactI18next; });

var $7i2be = parcelRequire("7i2be");

var $5D7Fi = parcelRequire("5D7Fi");

var $5OuPq = parcelRequire("5OuPq");

var $2j4C6 = parcelRequire("2j4C6");

var $pYRGq = parcelRequire("pYRGq");

var $gdbmE = parcelRequire("gdbmE");

var $2w80Z = parcelRequire("2w80Z");

var $hPvBu = parcelRequire("hPvBu");

var $jw6S0 = parcelRequire("jw6S0");

var $3dEcl = parcelRequire("3dEcl");

var $ateq0 = parcelRequire("ateq0");

var $jlOW7 = parcelRequire("jlOW7");
var $e05dc0ebc8730257$export$324d90190a8b822a = function date() {
    return "";
};
var $e05dc0ebc8730257$export$2da9be4cfdb689b1 = function time() {
    return "";
};
var $e05dc0ebc8730257$export$98e628dec113755e = function number() {
    return "";
};
var $e05dc0ebc8730257$export$2e6c959c16ff56b8 = function select() {
    return "";
};
var $e05dc0ebc8730257$export$4e35d5c922a95490 = function plural() {
    return "";
};
var $e05dc0ebc8730257$export$720a3b9db04b7a0f = function selectOrdinal() {
    return "";
};

});
parcelRequire.register("7i2be", function(module, exports) {

$parcel$export(module.exports, "Trans", function () { return $54ebe7c8b438d3e3$export$8d6a9236f2e3f2ce; });

var $azUPN = parcelRequire("azUPN");

var $98uwT = parcelRequire("98uwT");

var $jC8Vy = parcelRequire("jC8Vy");

var $5D7Fi = parcelRequire("5D7Fi");

var $jlOW7 = parcelRequire("jlOW7");
var $ateq0 = parcelRequire("ateq0");
var $54ebe7c8b438d3e3$var$_excluded = [
    "children",
    "count",
    "parent",
    "i18nKey",
    "context",
    "tOptions",
    "values",
    "defaults",
    "components",
    "ns",
    "i18n",
    "t",
    "shouldUnescape"
];
function $54ebe7c8b438d3e3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $54ebe7c8b438d3e3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $54ebe7c8b438d3e3$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $azUPN.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $54ebe7c8b438d3e3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $54ebe7c8b438d3e3$export$8d6a9236f2e3f2ce(_ref) {
    var children = _ref.children, count = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, context = _ref.context, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = (0, $98uwT.default)(_ref, $54ebe7c8b438d3e3$var$_excluded);
    var _ref2 = (0, $jC8Vy.useContext)((0, $jlOW7.I18nContext)) || {}, i18nFromContext = _ref2.i18n, defaultNSFromContext = _ref2.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $ateq0.getI18n)();
    var t = tFromProps || i18n && i18n.t.bind(i18n);
    return (0, $5D7Fi.Trans)($54ebe7c8b438d3e3$var$_objectSpread({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape
    }, additionalProps));
}

});
parcelRequire.register("azUPN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b39426b5a524934$export$2e2bcd8739ae039; });

var $LEIzh = parcelRequire("LEIzh");
function $7b39426b5a524934$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $LEIzh.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});
parcelRequire.register("LEIzh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08f3f99d9402ba49$export$2e2bcd8739ae039; });

var $2oi0t = parcelRequire("2oi0t");

var $yD33u = parcelRequire("yD33u");
function $08f3f99d9402ba49$export$2e2bcd8739ae039(arg) {
    var key = (0, $yD33u.default)(arg, "string");
    return (0, $2oi0t.default)(key) === "symbol" ? key : String(key);
}

});
parcelRequire.register("2oi0t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1bdbca699f007e2f$export$2e2bcd8739ae039; });
function $1bdbca699f007e2f$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $1bdbca699f007e2f$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $1bdbca699f007e2f$export$2e2bcd8739ae039(obj);
}

});

parcelRequire.register("yD33u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06817743ea98b1b1$export$2e2bcd8739ae039; });

var $2oi0t = parcelRequire("2oi0t");
function $06817743ea98b1b1$export$2e2bcd8739ae039(input, hint) {
    if ((0, $2oi0t.default)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $2oi0t.default)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

});



parcelRequire.register("98uwT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a6c8af282bc615b$export$2e2bcd8739ae039; });

var $lOvFS = parcelRequire("lOvFS");
function $6a6c8af282bc615b$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $lOvFS.default)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRequire.register("lOvFS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe16d65f2a994e84$export$2e2bcd8739ae039; });
function $fe16d65f2a994e84$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRequire.register("5D7Fi", function(module, exports) {

$parcel$export(module.exports, "Trans", function () { return $41968a67b220b594$export$8d6a9236f2e3f2ce; });

var $98uwT = parcelRequire("98uwT");

var $2oi0t = parcelRequire("2oi0t");

var $azUPN = parcelRequire("azUPN");

var $jC8Vy = parcelRequire("jC8Vy");

var $MktlS = parcelRequire("MktlS");

var $1wttn = parcelRequire("1wttn");

var $3dEcl = parcelRequire("3dEcl");

var $ateq0 = parcelRequire("ateq0");
var $41968a67b220b594$var$_excluded = [
    "format"
], $41968a67b220b594$var$_excluded2 = [
    "children",
    "count",
    "parent",
    "i18nKey",
    "context",
    "tOptions",
    "values",
    "defaults",
    "components",
    "ns",
    "i18n",
    "t",
    "shouldUnescape"
];
function $41968a67b220b594$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $41968a67b220b594$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $41968a67b220b594$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $azUPN.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $41968a67b220b594$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $41968a67b220b594$var$hasChildren(node, checkLength) {
    if (!node) return false;
    var base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function $41968a67b220b594$var$getChildren(node) {
    if (!node) return [];
    return node.props ? node.props.children : node.children;
}
function $41968a67b220b594$var$hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== "[object Array]") return false;
    return children.every(function(child) {
        return (0, $jC8Vy.isValidElement)(child);
    });
}
function $41968a67b220b594$var$getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function $41968a67b220b594$var$mergeProps(source, target) {
    var newTarget = $41968a67b220b594$var$_objectSpread({}, target);
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function $41968a67b220b594$export$4f7a36dd898f1267(children, i18nOptions) {
    if (!children) return "";
    var stringNode = "";
    var childrenArray = $41968a67b220b594$var$getAsArray(children);
    var keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach(function(child, childIndex) {
        if (typeof child === "string") stringNode += "".concat(child);
        else if ((0, $jC8Vy.isValidElement)(child)) {
            var childPropsCount = Object.keys(child.props).length;
            var shouldKeepChild = keepArray.indexOf(child.type) > -1;
            var childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += "<".concat(child.type, "/>");
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (child.props.i18nIsDynamicList) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === "string") stringNode += "<".concat(child.type, ">").concat(childChildren, "</").concat(child.type, ">");
            else {
                var content = $41968a67b220b594$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
            }
        } else if (child === null) (0, $1wttn.warn)("Trans: the passed in value is invalid - seems you passed in a null child.");
        else if ((0, $2oi0t.default)(child) === "object") {
            var format = child.format, clone = (0, $98uwT.default)(child, $41968a67b220b594$var$_excluded);
            var keys = Object.keys(clone);
            if (keys.length === 1) {
                var value = format ? "".concat(keys[0], ", ").concat(format) : keys[0];
                stringNode += "{{".concat(value, "}}");
            } else (0, $1wttn.warn)("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
        } else (0, $1wttn.warn)("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    });
    return stringNode;
}
function $41968a67b220b594$var$renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === "") return [];
    var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join("|")).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling) return [
        targetString
    ];
    var data = {};
    function getData(childs) {
        var childrenArray = $41968a67b220b594$var$getAsArray(childs);
        childrenArray.forEach(function(child) {
            if (typeof child === "string") return;
            if ($41968a67b220b594$var$hasChildren(child)) getData($41968a67b220b594$var$getChildren(child));
            else if ((0, $2oi0t.default)(child) === "object" && !(0, $jC8Vy.isValidElement)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    var ast = (0, $MktlS.default).parse("<0>".concat(targetString, "</0>"));
    var opts = $41968a67b220b594$var$_objectSpread($41968a67b220b594$var$_objectSpread({}, data), combinedTOpts);
    function renderInner(child, node, rootReactNode) {
        var childs = $41968a67b220b594$var$getChildren(child);
        var mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $41968a67b220b594$var$hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) child.children = inner;
        mem.push((0, $jC8Vy.cloneElement)(child, $41968a67b220b594$var$_objectSpread($41968a67b220b594$var$_objectSpread({}, child.props), {}, {
            key: i
        }), isVoid ? undefined : inner));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        var reactNodes = $41968a67b220b594$var$getAsArray(reactNode);
        var astNodes = $41968a67b220b594$var$getAsArray(astNode);
        return astNodes.reduce(function(mem, node, i) {
            var translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === "tag") {
                var tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name]) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                var child = Object.keys(node.attrs).length !== 0 ? $41968a67b220b594$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                var isElement = (0, $jC8Vy.isValidElement)(child);
                var isValidTranslationWithChildren = isElement && $41968a67b220b594$var$hasChildren(node, true) && !node.voidElement;
                var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, $2oi0t.default)(child) === "object" && child.dummy && !isElement;
                var isKnownComponent = (0, $2oi0t.default)(children) === "object" && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === "string") {
                    var value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($41968a67b220b594$var$hasChildren(child) || isValidTranslationWithChildren) {
                    var inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    var _inner = mapAST(reactNodes, node.children, rootReactNode);
                    mem.push((0, $jC8Vy.cloneElement)(child, $41968a67b220b594$var$_objectSpread($41968a67b220b594$var$_objectSpread({}, child.props), {}, {
                        key: i
                    }), _inner));
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        var _inner2 = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, _inner2, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $jC8Vy.createElement)(node.name, {
                            key: "".concat(node.name, "-").concat(i)
                        }));
                        else {
                            var _inner3 = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $jC8Vy.createElement)(node.name, {
                                key: "".concat(node.name, "-").concat(i)
                            }, _inner3));
                        }
                    } else if (node.voidElement) mem.push("<".concat(node.name, " />"));
                    else {
                        var _inner4 = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push("<".concat(node.name, ">").concat(_inner4, "</").concat(node.name, ">"));
                    }
                } else if ((0, $2oi0t.default)(child) === "object" && !isElement) {
                    var content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else if (node.children.length === 1 && translationContent) mem.push((0, $jC8Vy.cloneElement)(child, $41968a67b220b594$var$_objectSpread($41968a67b220b594$var$_objectSpread({}, child.props), {}, {
                    key: i
                }), translationContent));
                else mem.push((0, $jC8Vy.cloneElement)(child, $41968a67b220b594$var$_objectSpread($41968a67b220b594$var$_objectSpread({}, child.props), {}, {
                    key: i
                })));
            } else if (node.type === "text") {
                var wrapTextNodes = i18nOptions.transWrapTextNodes;
                var _content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $jC8Vy.createElement)(wrapTextNodes, {
                    key: "".concat(node.name, "-").concat(i)
                }, _content));
                else mem.push(_content);
            }
            return mem;
        }, []);
    }
    var result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $41968a67b220b594$var$getAsArray(children || []));
    return $41968a67b220b594$var$getChildren(result[0]);
}
function $41968a67b220b594$export$8d6a9236f2e3f2ce(_ref) {
    var children = _ref.children, count = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, context = _ref.context, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = (0, $98uwT.default)(_ref, $41968a67b220b594$var$_excluded2);
    var i18n = i18nFromProps || (0, $ateq0.getI18n)();
    if (!i18n) {
        (0, $1wttn.warnOnce)("You will need to pass in an i18next instance by using i18nextReactModule");
        return children;
    }
    var t = tFromProps || i18n.t.bind(i18n) || function(k) {
        return k;
    };
    if (context) tOptions.context = context;
    var reactI18nextOptions = $41968a67b220b594$var$_objectSpread($41968a67b220b594$var$_objectSpread({}, (0, $3dEcl.getDefaults)()), i18n.options && i18n.options.react);
    var namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    var defaultValue = defaults || $41968a67b220b594$export$4f7a36dd898f1267(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    var hashTransKey = reactI18nextOptions.hashTransKey;
    var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
    var interpolationOverride = values ? tOptions.interpolation : {
        interpolation: $41968a67b220b594$var$_objectSpread($41968a67b220b594$var$_objectSpread({}, tOptions.interpolation), {}, {
            prefix: "#$?",
            suffix: "?$#"
        })
    };
    var combinedTOpts = $41968a67b220b594$var$_objectSpread($41968a67b220b594$var$_objectSpread($41968a67b220b594$var$_objectSpread($41968a67b220b594$var$_objectSpread({}, tOptions), {}, {
        count: count
    }, values), interpolationOverride), {}, {
        defaultValue: defaultValue,
        ns: namespaces
    });
    var translation = key ? t(key, combinedTOpts) : defaultValue;
    var content = $41968a67b220b594$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $jC8Vy.createElement)(useAsParent, additionalProps, content) : content;
}

});
parcelRequire.register("MktlS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09145d347ef81289$export$2e2bcd8739ae039; });

var $6vR6M = parcelRequire("6vR6M");
var $09145d347ef81289$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $09145d347ef81289$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($6vR6M)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("-->");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($09145d347ef81289$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $09145d347ef81289$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $09145d347ef81289$var$i = /^\s*$/, $09145d347ef81289$var$s = Object.create(null);
function $09145d347ef81289$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($09145d347ef81289$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "<!--" + t.comment + "-->";
    }
}
var $09145d347ef81289$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $09145d347ef81289$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($09145d347ef81289$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("<!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $09145d347ef81289$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $09145d347ef81289$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $09145d347ef81289$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $09145d347ef81289$var$a("", t);
        }, "");
    }
};
var $09145d347ef81289$export$2e2bcd8739ae039 = $09145d347ef81289$var$c;

});
parcelRequire.register("6vR6M", function(module, exports) {
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ module.exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};

});


parcelRequire.register("1wttn", function(module, exports) {

$parcel$export(module.exports, "warn", function () { return $11bfa445c548af50$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "warnOnce", function () { return $11bfa445c548af50$export$5b28268982f175ba; });
$parcel$export(module.exports, "loadNamespaces", function () { return $11bfa445c548af50$export$83be934b53fff43b; });
$parcel$export(module.exports, "loadLanguages", function () { return $11bfa445c548af50$export$8cd7e7a54fa865bc; });
$parcel$export(module.exports, "hasLoadedNamespace", function () { return $11bfa445c548af50$export$93d9ee97c1ad3f31; });
$parcel$export(module.exports, "getDisplayName", function () { return $11bfa445c548af50$export$be63e0664592e141; });
function $11bfa445c548af50$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        var _console;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === "string") args[0] = "react-i18next:: ".concat(args[0]);
        (_console = console).warn.apply(_console, args);
    }
}
var $11bfa445c548af50$var$alreadyWarned = {};
function $11bfa445c548af50$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === "string" && $11bfa445c548af50$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === "string") $11bfa445c548af50$var$alreadyWarned[args[0]] = new Date();
    $11bfa445c548af50$export$c106dd0671a0fc2d.apply(void 0, args);
}
var $11bfa445c548af50$var$loadedClb = function loadedClb(i18n, cb) {
    return function() {
        if (i18n.isInitialized) cb();
        else {
            var initialized = function initialized() {
                setTimeout(function() {
                    i18n.off("initialized", initialized);
                }, 0);
                cb();
            };
            i18n.on("initialized", initialized);
        }
    };
};
function $11bfa445c548af50$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, $11bfa445c548af50$var$loadedClb(i18n, cb));
}
function $11bfa445c548af50$export$8cd7e7a54fa865bc(i18n, lng, ns, cb) {
    if (typeof ns === "string") ns = [
        ns
    ];
    ns.forEach(function(n) {
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $11bfa445c548af50$var$loadedClb(i18n, cb));
}
function $11bfa445c548af50$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lng = i18n.languages[0];
    var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    var lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === "cimode") return true;
    var loadNotPending = function loadNotPending(l, n) {
        var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $11bfa445c548af50$export$93d9ee97c1ad3f31(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $11bfa445c548af50$export$5b28268982f175ba("i18n.languages were undefined or empty", i18n.languages);
        return true;
    }
    var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $11bfa445c548af50$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: function precheck(i18nInstance, loadNotPending) {
            if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $11bfa445c548af50$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}

});

parcelRequire.register("3dEcl", function(module, exports) {

$parcel$export(module.exports, "setDefaults", function () { return $2581c47d2f92223e$export$2e2366488d12e20d; });
$parcel$export(module.exports, "getDefaults", function () { return $2581c47d2f92223e$export$212bb2fc580a90a8; });

var $azUPN = parcelRequire("azUPN");

var $2WNTF = parcelRequire("2WNTF");
function $2581c47d2f92223e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2581c47d2f92223e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2581c47d2f92223e$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $azUPN.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2581c47d2f92223e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $2581c47d2f92223e$var$defaultOptions = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: true,
    unescape: (0, $2WNTF.unescape)
};
function $2581c47d2f92223e$export$2e2366488d12e20d() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $2581c47d2f92223e$var$defaultOptions = $2581c47d2f92223e$var$_objectSpread($2581c47d2f92223e$var$_objectSpread({}, $2581c47d2f92223e$var$defaultOptions), options);
}
function $2581c47d2f92223e$export$212bb2fc580a90a8() {
    return $2581c47d2f92223e$var$defaultOptions;
}

});
parcelRequire.register("2WNTF", function(module, exports) {

$parcel$export(module.exports, "unescape", function () { return $2257b40b785955d0$export$e8bacd2802a88316; });
var $2257b40b785955d0$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var $2257b40b785955d0$var$htmlEntities = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "\xa9",
    "&#169;": "\xa9",
    "&reg;": "\xae",
    "&#174;": "\xae",
    "&hellip;": "…",
    "&#8230;": "…",
    "&#x2F;": "/",
    "&#47;": "/"
};
var $2257b40b785955d0$var$unescapeHtmlEntity = function unescapeHtmlEntity(m) {
    return $2257b40b785955d0$var$htmlEntities[m];
};
var $2257b40b785955d0$export$e8bacd2802a88316 = function unescape(text) {
    return text.replace($2257b40b785955d0$var$matchHtmlEntity, $2257b40b785955d0$var$unescapeHtmlEntity);
};

});


parcelRequire.register("ateq0", function(module, exports) {

$parcel$export(module.exports, "setI18n", function () { return $79f7cc07bbb68521$export$a039134f2fc7e0; });
$parcel$export(module.exports, "getI18n", function () { return $79f7cc07bbb68521$export$64af334f494c2f47; });
var $79f7cc07bbb68521$var$i18nInstance;
function $79f7cc07bbb68521$export$a039134f2fc7e0(instance) {
    $79f7cc07bbb68521$var$i18nInstance = instance;
}
function $79f7cc07bbb68521$export$64af334f494c2f47() {
    return $79f7cc07bbb68521$var$i18nInstance;
}

});


parcelRequire.register("jlOW7", function(module, exports) {

$parcel$export(module.exports, "I18nContext", function () { return $e1677d607f5937a5$export$5603ab5ced17ce64; });
$parcel$export(module.exports, "ReportNamespaces", function () { return $e1677d607f5937a5$export$ea171b67e3820290; });
$parcel$export(module.exports, "composeInitialProps", function () { return $e1677d607f5937a5$export$30ff0342ccf735a; });
$parcel$export(module.exports, "getDefaults", function () { return (parcelRequire("3dEcl")).getDefaults; });
$parcel$export(module.exports, "getI18n", function () { return (parcelRequire("ateq0")).getI18n; });

var $azUPN = parcelRequire("azUPN");

var $1IOZg = parcelRequire("1IOZg");

var $lcCFm = parcelRequire("lcCFm");

var $jC8Vy = parcelRequire("jC8Vy");

var $3dEcl = parcelRequire("3dEcl");

var $ateq0 = parcelRequire("ateq0");

var $jw6S0 = parcelRequire("jw6S0");
function $e1677d607f5937a5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e1677d607f5937a5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e1677d607f5937a5$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $azUPN.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e1677d607f5937a5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $e1677d607f5937a5$export$5603ab5ced17ce64 = (0, $jC8Vy.createContext)();
var $e1677d607f5937a5$export$ea171b67e3820290 = function() {
    function ReportNamespaces() {
        (0, $1IOZg.default)(this, ReportNamespaces);
        this.usedNamespaces = {};
    }
    (0, $lcCFm.default)(ReportNamespaces, [
        {
            key: "addUsedNamespaces",
            value: function addUsedNamespaces(namespaces) {
                var _this = this;
                namespaces.forEach(function(ns) {
                    if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
                });
            }
        },
        {
            key: "getUsedNamespaces",
            value: function getUsedNamespaces() {
                return Object.keys(this.usedNamespaces);
            }
        }
    ]);
    return ReportNamespaces;
}();
function $e1677d607f5937a5$export$30ff0342ccf735a(ForComponent) {
    return function(ctx) {
        return new Promise(function(resolve) {
            var i18nInitialProps = $e1677d607f5937a5$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then(function(componentsInitialProps) {
                resolve($e1677d607f5937a5$var$_objectSpread($e1677d607f5937a5$var$_objectSpread({}, componentsInitialProps), i18nInitialProps));
            });
            else resolve(i18nInitialProps);
        });
    };
}
function $e1677d607f5937a5$export$704200e5d0b9e8f() {
    var i18n = (0, $ateq0.getI18n)();
    var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    var ret = {};
    var initialI18nStore = {};
    i18n.languages.forEach(function(l) {
        initialI18nStore[l] = {};
        namespaces.forEach(function(ns) {
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}

});
parcelRequire.register("1IOZg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $141173829fe7cf31$export$2e2bcd8739ae039; });
function $141173829fe7cf31$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRequire.register("lcCFm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6f8b63f7f81b7e6$export$2e2bcd8739ae039; });

var $LEIzh = parcelRequire("LEIzh");
function $f6f8b63f7f81b7e6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $LEIzh.default)(descriptor.key), descriptor);
    }
}
function $f6f8b63f7f81b7e6$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $f6f8b63f7f81b7e6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f6f8b63f7f81b7e6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

});

parcelRequire.register("jw6S0", function(module, exports) {

$parcel$export(module.exports, "initReactI18next", function () { return $e35655b9a9e10a9f$export$ae7e14d40d89f296; });

var $3dEcl = parcelRequire("3dEcl");

var $ateq0 = parcelRequire("ateq0");
var $e35655b9a9e10a9f$export$ae7e14d40d89f296 = {
    type: "3rdParty",
    init: function init(instance) {
        (0, $3dEcl.setDefaults)(instance.options.react);
        (0, $ateq0.setI18n)(instance);
    }
};

});



parcelRequire.register("5OuPq", function(module, exports) {

$parcel$export(module.exports, "useTranslation", function () { return $43b989215dded41c$export$9fc83ad70ead8663; });

var $4kKbO = parcelRequire("4kKbO");

var $azUPN = parcelRequire("azUPN");

var $2oi0t = parcelRequire("2oi0t");

var $jC8Vy = parcelRequire("jC8Vy");

var $jlOW7 = parcelRequire("jlOW7");
var $ateq0 = parcelRequire("ateq0");
var $3dEcl = parcelRequire("3dEcl");

var $1wttn = parcelRequire("1wttn");
function $43b989215dded41c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $43b989215dded41c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $43b989215dded41c$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $azUPN.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $43b989215dded41c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $43b989215dded41c$var$usePrevious = function usePrevious(value, ignore) {
    var ref = (0, $jC8Vy.useRef)();
    (0, $jC8Vy.useEffect)(function() {
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $43b989215dded41c$export$9fc83ad70ead8663(ns) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $jC8Vy.useContext)((0, $jlOW7.I18nContext)) || {}, i18nFromContext = _ref.i18n, defaultNSFromContext = _ref.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $ateq0.getI18n)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $jlOW7.ReportNamespaces)();
    if (!i18n) {
        (0, $1wttn.warnOnce)("You will need to pass in an i18next instance by using initReactI18next");
        var notReadyT = function notReadyT(k, optsOrDefaultValue) {
            if (typeof optsOrDefaultValue === "string") return optsOrDefaultValue;
            if (optsOrDefaultValue && (0, $2oi0t.default)(optsOrDefaultValue) === "object" && typeof optsOrDefaultValue.defaultValue === "string") return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        var retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $1wttn.warnOnce)("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
    var i18nOptions = $43b989215dded41c$var$_objectSpread($43b989215dded41c$var$_objectSpread($43b989215dded41c$var$_objectSpread({}, (0, $3dEcl.getDefaults)()), i18n.options.react), props);
    var useSuspense = i18nOptions.useSuspense, keyPrefix = i18nOptions.keyPrefix;
    var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function(n) {
        return (0, $1wttn.hasLoadedNamespace)(n, i18n, i18nOptions);
    });
    function getT() {
        return i18n.getFixedT(props.lng || null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    }
    var _useState = (0, $jC8Vy.useState)(getT), _useState2 = (0, $4kKbO.default)(_useState, 2), t = _useState2[0], setT = _useState2[1];
    var joinedNS = namespaces.join();
    if (props.lng) joinedNS = "".concat(props.lng).concat(joinedNS);
    var previousJoinedNS = $43b989215dded41c$var$usePrevious(joinedNS);
    var isMounted = (0, $jC8Vy.useRef)(true);
    (0, $jC8Vy.useEffect)(function() {
        var bindI18n = i18nOptions.bindI18n, bindI18nStore = i18nOptions.bindI18nStore;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $1wttn.loadLanguages)(i18n, props.lng, namespaces, function() {
                if (isMounted.current) setT(getT);
            });
            else (0, $1wttn.loadNamespaces)(i18n, namespaces, function() {
                if (isMounted.current) setT(getT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return function() {
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(" ").forEach(function(e) {
                return i18n.off(e, boundReset);
            });
            if (bindI18nStore && i18n) bindI18nStore.split(" ").forEach(function(e) {
                return i18n.store.off(e, boundReset);
            });
        };
    }, [
        i18n,
        joinedNS
    ]);
    var isInitial = (0, $jC8Vy.useRef)(true);
    (0, $jC8Vy.useEffect)(function() {
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    var ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise(function(resolve) {
        if (props.lng) (0, $1wttn.loadLanguages)(i18n, props.lng, namespaces, function() {
            return resolve();
        });
        else (0, $1wttn.loadNamespaces)(i18n, namespaces, function() {
            return resolve();
        });
    });
}

});
parcelRequire.register("4kKbO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $327cdbf39337dd6f$export$2e2bcd8739ae039; });

var $gTtSD = parcelRequire("gTtSD");

var $H1C0Z = parcelRequire("H1C0Z");

var $7yoNA = parcelRequire("7yoNA");

var $lKy8Z = parcelRequire("lKy8Z");
function $327cdbf39337dd6f$export$2e2bcd8739ae039(arr, i) {
    return (0, $gTtSD.default)(arr) || (0, $H1C0Z.default)(arr, i) || (0, $7yoNA.default)(arr, i) || (0, $lKy8Z.default)();
}

});
parcelRequire.register("gTtSD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4c8f6003d6e737d$export$2e2bcd8739ae039; });
function $c4c8f6003d6e737d$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRequire.register("H1C0Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08154467defeccf4$export$2e2bcd8739ae039; });
function $08154467defeccf4$export$2e2bcd8739ae039(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}

});

parcelRequire.register("7yoNA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57fef1e1dea22740$export$2e2bcd8739ae039; });

var $8GVB1 = parcelRequire("8GVB1");
function $57fef1e1dea22740$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $8GVB1.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $8GVB1.default)(o, minLen);
}

});
parcelRequire.register("8GVB1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $653eec5c0aa9bdbd$export$2e2bcd8739ae039; });
function $653eec5c0aa9bdbd$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRequire.register("lKy8Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd58611d04754acb$export$2e2bcd8739ae039; });
function $fd58611d04754acb$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



parcelRequire.register("2j4C6", function(module, exports) {

$parcel$export(module.exports, "withTranslation", function () { return $1ae0ef4229ad75ab$export$2dcb0053efd21124; });

var $azUPN = parcelRequire("azUPN");

var $4kKbO = parcelRequire("4kKbO");

var $98uwT = parcelRequire("98uwT");

var $jC8Vy = parcelRequire("jC8Vy");

var $5OuPq = parcelRequire("5OuPq");

var $1wttn = parcelRequire("1wttn");
var $1ae0ef4229ad75ab$var$_excluded = [
    "forwardedRef"
];
function $1ae0ef4229ad75ab$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1ae0ef4229ad75ab$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $1ae0ef4229ad75ab$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $azUPN.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $1ae0ef4229ad75ab$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1ae0ef4229ad75ab$export$2dcb0053efd21124(ns) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_ref) {
            var forwardedRef = _ref.forwardedRef, rest = (0, $98uwT.default)(_ref, $1ae0ef4229ad75ab$var$_excluded);
            var _useTranslation = (0, $5OuPq.useTranslation)(ns, $1ae0ef4229ad75ab$var$_objectSpread($1ae0ef4229ad75ab$var$_objectSpread({}, rest), {}, {
                keyPrefix: options.keyPrefix
            })), _useTranslation2 = (0, $4kKbO.default)(_useTranslation, 3), t = _useTranslation2[0], i18n = _useTranslation2[1], ready = _useTranslation2[2];
            var passDownProps = $1ae0ef4229ad75ab$var$_objectSpread($1ae0ef4229ad75ab$var$_objectSpread({}, rest), {}, {
                t: t,
                i18n: i18n,
                tReady: ready
            });
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $jC8Vy.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = "withI18nextTranslation(".concat((0, $1wttn.getDisplayName)(WrappedComponent), ")");
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        var forwardRef = function forwardRef(props, ref) {
            return (0, $jC8Vy.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        };
        return options.withRef ? (0, $jC8Vy.forwardRef)(forwardRef) : I18nextWithTranslation;
    };
}

});

parcelRequire.register("pYRGq", function(module, exports) {

var $4kKbO = parcelRequire("4kKbO");

var $98uwT = parcelRequire("98uwT");

var $5OuPq = parcelRequire("5OuPq");
var $04e18c682fdb0e7c$var$_excluded = [
    "ns",
    "children"
];
function $04e18c682fdb0e7c$export$b63289fbda65eed1(props) {
    var ns = props.ns, children = props.children, options = (0, $98uwT.default)(props, $04e18c682fdb0e7c$var$_excluded);
    var _useTranslation = (0, $5OuPq.useTranslation)(ns, options), _useTranslation2 = (0, $4kKbO.default)(_useTranslation, 3), t = _useTranslation2[0], i18n = _useTranslation2[1], ready = _useTranslation2[2];
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
}

});

parcelRequire.register("gdbmE", function(module, exports) {

var $jC8Vy = parcelRequire("jC8Vy");

var $jlOW7 = parcelRequire("jlOW7");
function $bcd6acf7c215dd20$export$1325e8699caa160f(_ref) {
    var i18n = _ref.i18n, defaultNS = _ref.defaultNS, children = _ref.children;
    var value = (0, $jC8Vy.useMemo)(function() {
        return {
            i18n: i18n,
            defaultNS: defaultNS
        };
    }, [
        i18n,
        defaultNS
    ]);
    return (0, $jC8Vy.createElement)((0, $jlOW7.I18nContext).Provider, {
        value: value
    }, children);
}

});

parcelRequire.register("2w80Z", function(module, exports) {

var $azUPN = parcelRequire("azUPN");

var $98uwT = parcelRequire("98uwT");

var $jC8Vy = parcelRequire("jC8Vy");

var $hPvBu = parcelRequire("hPvBu");

var $jlOW7 = parcelRequire("jlOW7");

var $1wttn = parcelRequire("1wttn");
var $1d54c98d14200cb5$var$_excluded = [
    "initialI18nStore",
    "initialLanguage"
];
function $1d54c98d14200cb5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1d54c98d14200cb5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $1d54c98d14200cb5$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $azUPN.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $1d54c98d14200cb5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1d54c98d14200cb5$export$80dfa519af1c8605() {
    return function Extend(WrappedComponent) {
        function I18nextWithSSR(_ref) {
            var initialI18nStore = _ref.initialI18nStore, initialLanguage = _ref.initialLanguage, rest = (0, $98uwT.default)(_ref, $1d54c98d14200cb5$var$_excluded);
            (0, $hPvBu.useSSR)(initialI18nStore, initialLanguage);
            return (0, $jC8Vy.createElement)(WrappedComponent, $1d54c98d14200cb5$var$_objectSpread({}, rest));
        }
        I18nextWithSSR.getInitialProps = (0, $jlOW7.composeInitialProps)(WrappedComponent);
        I18nextWithSSR.displayName = "withI18nextSSR(".concat((0, $1wttn.getDisplayName)(WrappedComponent), ")");
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };
}

});
parcelRequire.register("hPvBu", function(module, exports) {

$parcel$export(module.exports, "useSSR", function () { return $cfafb6ebb8ed168e$export$3526fb65ade8d8b7; });

var $jC8Vy = parcelRequire("jC8Vy");

var $jlOW7 = parcelRequire("jlOW7");
var $ateq0 = parcelRequire("ateq0");
function $cfafb6ebb8ed168e$export$3526fb65ade8d8b7(initialI18nStore, initialLanguage) {
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $jC8Vy.useContext)((0, $jlOW7.I18nContext)) || {}, i18nFromContext = _ref.i18n;
    var i18n = i18nFromProps || i18nFromContext || (0, $ateq0.getI18n)();
    if (i18n.options && i18n.options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce(function(mem, lngResources) {
            Object.keys(lngResources).forEach(function(ns) {
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
}

});



parcelRequire.register("hvK1V", function(module, exports) {

$parcel$export(module.exports, "comingSoon", function () { return $cbf909861947f9ac$export$d16dae6e9710581; }, function (v) { return $cbf909861947f9ac$export$d16dae6e9710581 = v; });
$parcel$export(module.exports, "regionText", function () { return $cbf909861947f9ac$export$d1b66e7d409a3f7a; }, function (v) { return $cbf909861947f9ac$export$d1b66e7d409a3f7a = v; });
var $cbf909861947f9ac$export$d16dae6e9710581;
var $cbf909861947f9ac$export$d1b66e7d409a3f7a;
var $cbf909861947f9ac$export$bfd64c937657f93a;
var $cbf909861947f9ac$export$4a6dd88bada4e7d2;
$cbf909861947f9ac$export$d16dae6e9710581 = `FR-9VG_comingSoon`;
$cbf909861947f9ac$export$d1b66e7d409a3f7a = `FR-9VG_regionText`;
$cbf909861947f9ac$export$bfd64c937657f93a = `FR-9VG_rotating`;
$cbf909861947f9ac$export$4a6dd88bada4e7d2 = `FR-9VG_shimmer`;

});


parcelRequire.register("8TpMk", function(module, exports) {

$parcel$export(module.exports, "isCloud", function () { return $b9856562c8e69020$export$12546c493525abfc; });
$parcel$export(module.exports, "adminEndpoint", function () { return $b9856562c8e69020$export$348a11e4ba7c8edf; });
$parcel$export(module.exports, "isDevFeaturesEnabled", function () { return $b9856562c8e69020$export$40f514de6322fa2e; });
parcelRequire("12bMu");
var $l0I3U = parcelRequire("l0I3U");

var $fb30i = parcelRequire("fb30i");
const $b9856562c8e69020$var$isProduction = true;
const $b9856562c8e69020$export$12546c493525abfc = (0, $l0I3U.yes)(undefined);
const $b9856562c8e69020$export$348a11e4ba7c8edf = undefined;
const $b9856562c8e69020$export$40f514de6322fa2e = !$b9856562c8e69020$var$isProduction || (0, $l0I3U.yes)("") || (0, $l0I3U.yes)(undefined) || (0, $l0I3U.yes)(localStorage.getItem((0, $fb30i.storageKeys).isDevFeaturesEnabled));

});
parcelRequire.register("fb30i", function(module, exports) {

$parcel$export(module.exports, "storageKeys", function () { return $cfd4e95fa689a3ca$export$4a127c3d87b83db7; });
const $cfd4e95fa689a3ca$export$902ba6ec74c93f9d = (forType)=>`logto:admin_console:${forType}`;
const $cfd4e95fa689a3ca$export$4a127c3d87b83db7 = Object.freeze({
    appearanceMode: $cfd4e95fa689a3ca$export$902ba6ec74c93f9d("appearance_mode"),
    linkingSocialConnector: $cfd4e95fa689a3ca$export$902ba6ec74c93f9d("linking_social_connector"),
    checkoutSession: $cfd4e95fa689a3ca$export$902ba6ec74c93f9d("checkout_session"),
    /** The react-router redirect location after sign in. The value should be a stringified Location object. */ redirectAfterSignIn: $cfd4e95fa689a3ca$export$902ba6ec74c93f9d("redirect_after_sign_in"),
    webhookTestResult: $cfd4e95fa689a3ca$export$902ba6ec74c93f9d("webhook_test_result"),
    /** Whether the under-development features are enabled. */ isDevFeaturesEnabled: $cfd4e95fa689a3ca$export$902ba6ec74c93f9d("is_dev_features_enabled")
});

});



parcelRequire.register("bt3dS", function(module, exports) {

$parcel$export(module.exports, "ApplicationDetailsTabs", function () { return $a01dd12e9c785385$export$41c455531d6f2c11; });
$parcel$export(module.exports, "ApiResourceDetailsTabs", function () { return $a01dd12e9c785385$export$973f987da39d2e74; });
$parcel$export(module.exports, "ConnectorsTabs", function () { return $a01dd12e9c785385$export$b3bd1d3dc666a7f6; });
$parcel$export(module.exports, "WebhookDetailsTabs", function () { return $a01dd12e9c785385$export$6fe03a8e666f5ee8; });
$parcel$export(module.exports, "UserDetailsTabs", function () { return $a01dd12e9c785385$export$459a32b7ea60495c; });
$parcel$export(module.exports, "RoleDetailsTabs", function () { return $a01dd12e9c785385$export$a6a250d41b5029e4; });
$parcel$export(module.exports, "TenantSettingsTabs", function () { return $a01dd12e9c785385$export$ff87e72992de0630; });
$parcel$export(module.exports, "EnterpriseSsoDetailsTabs", function () { return $a01dd12e9c785385$export$b021f61ae8cc4286; });
$parcel$export(module.exports, "OrganizationTemplateTabs", function () { return $a01dd12e9c785385$export$172d634003d05a2e; });
$parcel$export(module.exports, "OrganizationRoleDetailsTabs", function () { return $a01dd12e9c785385$export$24ad483d14d151cf; });
var $a01dd12e9c785385$export$41c455531d6f2c11;
(function(ApplicationDetailsTabs) {
    ApplicationDetailsTabs["Settings"] = "settings";
    ApplicationDetailsTabs["Roles"] = "roles";
    ApplicationDetailsTabs["Logs"] = "logs";
    ApplicationDetailsTabs["Branding"] = "branding";
    ApplicationDetailsTabs["Permissions"] = "permissions";
})($a01dd12e9c785385$export$41c455531d6f2c11 || ($a01dd12e9c785385$export$41c455531d6f2c11 = {}));
var $a01dd12e9c785385$export$973f987da39d2e74;
(function(ApiResourceDetailsTabs) {
    ApiResourceDetailsTabs["Permissions"] = "permissions";
    ApiResourceDetailsTabs["General"] = "general";
})($a01dd12e9c785385$export$973f987da39d2e74 || ($a01dd12e9c785385$export$973f987da39d2e74 = {}));
var $a01dd12e9c785385$export$b3bd1d3dc666a7f6;
(function(ConnectorsTabs) {
    ConnectorsTabs["Passwordless"] = "passwordless";
    ConnectorsTabs["Social"] = "social";
})($a01dd12e9c785385$export$b3bd1d3dc666a7f6 || ($a01dd12e9c785385$export$b3bd1d3dc666a7f6 = {}));
var $a01dd12e9c785385$export$6fe03a8e666f5ee8;
(function(WebhookDetailsTabs) {
    WebhookDetailsTabs["Settings"] = "settings";
    WebhookDetailsTabs["RecentRequests"] = "recent-requests";
})($a01dd12e9c785385$export$6fe03a8e666f5ee8 || ($a01dd12e9c785385$export$6fe03a8e666f5ee8 = {}));
var $a01dd12e9c785385$export$459a32b7ea60495c;
(function(UserDetailsTabs) {
    UserDetailsTabs["Settings"] = "settings";
    UserDetailsTabs["Roles"] = "roles";
    UserDetailsTabs["Logs"] = "logs";
    UserDetailsTabs["Organizations"] = "organizations";
})($a01dd12e9c785385$export$459a32b7ea60495c || ($a01dd12e9c785385$export$459a32b7ea60495c = {}));
var $a01dd12e9c785385$export$a6a250d41b5029e4;
(function(RoleDetailsTabs) {
    RoleDetailsTabs["Permissions"] = "permissions";
    RoleDetailsTabs["Users"] = "users";
    RoleDetailsTabs["M2mApps"] = "machine-to-machine-apps";
    RoleDetailsTabs["General"] = "general";
})($a01dd12e9c785385$export$a6a250d41b5029e4 || ($a01dd12e9c785385$export$a6a250d41b5029e4 = {}));
var $a01dd12e9c785385$export$ff87e72992de0630;
(function(TenantSettingsTabs) {
    TenantSettingsTabs["Settings"] = "settings";
    TenantSettingsTabs["Members"] = "members";
    TenantSettingsTabs["Domains"] = "domains";
    TenantSettingsTabs["Subscription"] = "subscription";
    TenantSettingsTabs["BillingHistory"] = "billing-history";
})($a01dd12e9c785385$export$ff87e72992de0630 || ($a01dd12e9c785385$export$ff87e72992de0630 = {}));
var $a01dd12e9c785385$export$b021f61ae8cc4286;
(function(EnterpriseSsoDetailsTabs) {
    EnterpriseSsoDetailsTabs["Connection"] = "connection";
    EnterpriseSsoDetailsTabs["Experience"] = "experience";
})($a01dd12e9c785385$export$b021f61ae8cc4286 || ($a01dd12e9c785385$export$b021f61ae8cc4286 = {}));
var $a01dd12e9c785385$export$172d634003d05a2e;
(function(OrganizationTemplateTabs) {
    OrganizationTemplateTabs["OrganizationRoles"] = "organization-roles";
    OrganizationTemplateTabs["OrganizationPermissions"] = "organization-permissions";
})($a01dd12e9c785385$export$172d634003d05a2e || ($a01dd12e9c785385$export$172d634003d05a2e = {}));
var $a01dd12e9c785385$export$24ad483d14d151cf;
(function(OrganizationRoleDetailsTabs) {
    OrganizationRoleDetailsTabs["Permissions"] = "permissions";
    OrganizationRoleDetailsTabs["General"] = "general";
})($a01dd12e9c785385$export$24ad483d14d151cf || ($a01dd12e9c785385$export$24ad483d14d151cf = {}));

});

parcelRequire.register("cfL6o", function(module, exports) {

$parcel$export(module.exports, "discordLink", function () { return $d78a7bf2c6be3b07$export$770bac037405f4d8; });
$parcel$export(module.exports, "githubOrgLink", function () { return $d78a7bf2c6be3b07$export$e6d4ee48329e88d9; });
$parcel$export(module.exports, "githubIssuesLink", function () { return $d78a7bf2c6be3b07$export$65835372d5db9813; });
$parcel$export(module.exports, "githubReleasesLink", function () { return $d78a7bf2c6be3b07$export$ae16a8547e29e875; });
$parcel$export(module.exports, "contactEmail", function () { return $d78a7bf2c6be3b07$export$216bebe50ea21113; });
$parcel$export(module.exports, "contactEmailLink", function () { return $d78a7bf2c6be3b07$export$6926f778a352c0aa; });
$parcel$export(module.exports, "reservationLink", function () { return $d78a7bf2c6be3b07$export$f3387181d20561c1; });
$parcel$export(module.exports, "trustAndSecurityLink", function () { return $d78a7bf2c6be3b07$export$7ab2cab94b61f6c0; });
$parcel$export(module.exports, "pricingLink", function () { return $d78a7bf2c6be3b07$export$caf913631c801f96; });
$parcel$export(module.exports, "newPlansBlogLink", function () { return $d78a7bf2c6be3b07$export$2e62bea208da5997; });
$parcel$export(module.exports, "envTagsFeatureLink", function () { return $d78a7bf2c6be3b07$export$34d13a5fd583d5bb; });
$parcel$export(module.exports, "organizationsFeatureLink", function () { return $d78a7bf2c6be3b07$export$668cc2699ecbff01; });
$parcel$export(module.exports, "protectedAppLink", function () { return $d78a7bf2c6be3b07$export$5c4049ce5957b99e; });
$parcel$export(module.exports, "logtoThirdPartyGuideLink", function () { return $d78a7bf2c6be3b07$export$7af5fdbb8fc64237; });
$parcel$export(module.exports, "logtoThirdPartyAppPermissionsLink", function () { return $d78a7bf2c6be3b07$export$f23a052aea91b47a; });
$parcel$export(module.exports, "logtoThirdPartyAppBrandingLink", function () { return $d78a7bf2c6be3b07$export$f23d6b2a670ba4e4; });
$parcel$export(module.exports, "signingKeysLink", function () { return $d78a7bf2c6be3b07$export$2bab06657a9ac334; });
$parcel$export(module.exports, "organizationTemplateLink", function () { return $d78a7bf2c6be3b07$export$d198a3a9c9eea537; });
$parcel$export(module.exports, "organizationRoleLink", function () { return $d78a7bf2c6be3b07$export$8446810e68289f75; });
$parcel$export(module.exports, "organizationPermissionLink", function () { return $d78a7bf2c6be3b07$export$af319c3a72e97e5b; });
const $d78a7bf2c6be3b07$export$770bac037405f4d8 = "https://discord.gg/UEPaF3j5e6";
const $d78a7bf2c6be3b07$export$e6d4ee48329e88d9 = "https://github.com/logto-io";
const $d78a7bf2c6be3b07$export$f282d82959650472 = "https://github.com/logto-io/logto";
const $d78a7bf2c6be3b07$export$65835372d5db9813 = "https://github.com/logto-io/logto/issues";
const $d78a7bf2c6be3b07$export$ae16a8547e29e875 = "https://github.com/logto-io/logto/releases";
const $d78a7bf2c6be3b07$export$216bebe50ea21113 = "contact@logto.io";
const $d78a7bf2c6be3b07$export$6926f778a352c0aa = `mailto:${$d78a7bf2c6be3b07$export$216bebe50ea21113}`;
const $d78a7bf2c6be3b07$export$f3387181d20561c1 = "https://cal.com/logto/30min";
const $d78a7bf2c6be3b07$export$7ab2cab94b61f6c0 = "https://logto.io/trust-and-security";
const $d78a7bf2c6be3b07$export$caf913631c801f96 = "https://logto.io/pricing";
const $d78a7bf2c6be3b07$export$2e62bea208da5997 = "https://blog.logto.io/logto-pricing-v2";
const $d78a7bf2c6be3b07$export$34d13a5fd583d5bb = "/docs/recipes/tenant-type/";
const $d78a7bf2c6be3b07$export$668cc2699ecbff01 = "/docs/recipes/organizations/";
const $d78a7bf2c6be3b07$export$46dd7b245c67073b = "/docs/recipes/organizations/configuration/";
const $d78a7bf2c6be3b07$export$5c4049ce5957b99e = "/docs/recipes/protected-app/";
const $d78a7bf2c6be3b07$export$7af5fdbb8fc64237 = "/docs/recipes/logto-as-idp/";
const $d78a7bf2c6be3b07$export$f23a052aea91b47a = "/docs/recipes/logto-as-idp/permissions-management/";
const $d78a7bf2c6be3b07$export$f23d6b2a670ba4e4 = "/docs/recipes/logto-as-idp/branding-customization/";
const $d78a7bf2c6be3b07$export$2bab06657a9ac334 = "/docs/recipes/openid-connect/signing-keys-rotation/";
const $d78a7bf2c6be3b07$export$d198a3a9c9eea537 = "/docs/recipes/organizations/understand-how-it-works/#organization-template";
const $d78a7bf2c6be3b07$export$8446810e68289f75 = "/docs/recipes/organizations/understand-how-it-works/#organization-role";
const $d78a7bf2c6be3b07$export$af319c3a72e97e5b = "/docs/recipes/organizations/understand-how-it-works/#organization-permission";

});


parcelRequire.register("voszV", function(module, exports) {

$parcel$export(module.exports, "SWRConfig", function () { return $2ddd5897b5f9e2f0$export$4c7bbecdacc3ca2c; });
$parcel$export(module.exports, "default", function () { return $2ddd5897b5f9e2f0$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "useSWRConfig", function () { return (parcelRequire("hgWIN")).useSWRConfig; });

var $jC8Vy = parcelRequire("jC8Vy");

var $8iPR9 = parcelRequire("8iPR9");

var $hgWIN = parcelRequire("hgWIN");
const $2ddd5897b5f9e2f0$export$dbab534a48e651ef = (key)=>(0, $hgWIN.serialize)(key)[0];
/// <reference types="react/experimental" />
const $2ddd5897b5f9e2f0$var$use = (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).use || ((promise)=>{
    if (promise.status === "pending") throw promise;
    else if (promise.status === "fulfilled") return promise.value;
    else if (promise.status === "rejected") throw promise.reason;
    else {
        promise.status = "pending";
        promise.then((v)=>{
            promise.status = "fulfilled";
            promise.value = v;
        }, (e)=>{
            promise.status = "rejected";
            promise.reason = e;
        });
        throw promise;
    }
});
const $2ddd5897b5f9e2f0$var$WITH_DEDUPE = {
    dedupe: true
};
const $2ddd5897b5f9e2f0$var$useSWRHandler = (_key, fetcher, config)=>{
    const { cache: cache, compare: compare, suspense: suspense, fallbackData: fallbackData, revalidateOnMount: revalidateOnMount, revalidateIfStale: revalidateIfStale, refreshInterval: refreshInterval, refreshWhenHidden: refreshWhenHidden, refreshWhenOffline: refreshWhenOffline, keepPreviousData: keepPreviousData } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = (0, $hgWIN.SWRGlobalState).get(cache);
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    const [key, fnArg] = (0, $hgWIN.serialize)(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0, $jC8Vy.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0, $jC8Vy.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0, $jC8Vy.useRef)(key);
    const fetcherRef = (0, $jC8Vy.useRef)(fetcher);
    const configRef = (0, $jC8Vy.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = (0, $hgWIN.createCacheHelper)(cache, key);
    const stateDependencies = (0, $jC8Vy.useRef)({}).current;
    const fallback = (0, $hgWIN.isUndefined)(fallbackData) ? config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        for(const _ in stateDependencies){
            const t = _;
            if (t === "data") {
                if (!compare(prev[t], current[t])) {
                    if (!(0, $hgWIN.isUndefined)(prev[t])) return false;
                    if (!compare(returnedData, current[t])) return false;
                }
            } else {
                if (current[t] !== prev[t]) return false;
            }
        }
        return true;
    };
    const getSnapshot = (0, $jC8Vy.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!(0, $hgWIN.isUndefined)(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            if (!(0, $hgWIN.isUndefined)(revalidateIfStale)) return revalidateIfStale;
            return true;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = (0, $hgWIN.mergeObjects)(state);
            delete snapshot._k;
            if (!shouldStartRequest) return snapshot;
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        const cachedData = getCache();
        const initialData = getInitialCache();
        const clientSnapshot = getSelectedCache(cachedData);
        const serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = clientSnapshot;
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                const compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            ()=>serverSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0, $8iPR9.useSyncExternalStore)((0, $jC8Vy.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = (0, $hgWIN.isUndefined)(cachedData) ? fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0, $jC8Vy.useRef)(data);
    const returnedData = keepPreviousData ? (0, $hgWIN.isUndefined)(cachedData) ? laggyDataRef.current : cachedData : data;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !(0, $hgWIN.isUndefined)(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0, $hgWIN.isUndefined)(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return (0, $hgWIN.isUndefined)(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0, $hgWIN.isUndefined)(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = (0, $hgWIN.isUndefined)(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = (0, $hgWIN.isUndefined)(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0, $jC8Vy.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) return false;
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (0, $hgWIN.IS_REACT_LEGACY) return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) delete FETCH[key];
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if ((0, $hgWIN.isUndefined)(getCache().data)) initialState.isLoading = true;
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && (0, $hgWIN.isUndefined)(getCache().data)) setTimeout(()=>{
                    if (loading && callbackSafeguard()) getConfig().onLoadingSlow(key, config);
                }, config.loadingTimeout);
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    (0, $hgWIN.getTimestamp)()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) // If the request isn't interrupted, clean it up after the
            // deduplication interval.
            setTimeout(cleanupState, config.dedupingInterval);
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Clear error.
            finalState.error = (0, $hgWIN.UNDEFINED);
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!(0, $hgWIN.isUndefined)(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) getConfig().onSuccess(newData, key, config);
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError: shouldRetryOnError } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || (0, $hgWIN.isFunction)(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (isActive()) // If it's inactive, stop. It will auto-revalidate when
                        // refocusing or reconnecting.
                        // When retrying, deduplication is always enabled.
                        currentConfig.onErrorRetry(err, key, currentConfig, (_opts)=>{
                            const revalidators = EVENT_REVALIDATORS[key];
                            if (revalidators && revalidators[0]) revalidators[0]((0, $hgWIN.revalidateEvents).ERROR_REVALIDATE_EVENT, _opts);
                        }, {
                            retryCount: (opts.retryCount || 0) + 1,
                            dedupe: true
                        });
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const boundMutate = (0, $jC8Vy.useCallback)((...args)=>{
        return (0, $hgWIN.internalMutate)(cache, keyRef.current, ...args);
    }, []);
    // The logic for updating refs.
    (0, $hgWIN.useIsomorphicLayoutEffect)(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0, $hgWIN.isUndefined)(cachedData)) laggyDataRef.current = cachedData;
    });
    // After mounted or key changed.
    (0, $hgWIN.useIsomorphicLayoutEffect)(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind((0, $hgWIN.UNDEFINED), $2ddd5897b5f9e2f0$var$WITH_DEDUPE);
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        let nextFocusRevalidatedAt = 0;
        const onRevalidate = (type, opts = {})=>{
            if (type == (0, $hgWIN.revalidateEvents).FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == (0, $hgWIN.revalidateEvents).RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) softRevalidate();
            } else if (type == (0, $hgWIN.revalidateEvents).MUTATE_EVENT) return revalidate();
            else if (type == (0, $hgWIN.revalidateEvents).ERROR_REVALIDATE_EVENT) return revalidate(opts);
            return;
        };
        const unsubEvents = (0, $hgWIN.subscribeCallback)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation
        if (shouldDoInitialRevalidation) {
            if ((0, $hgWIN.isUndefined)(data) || (0, $hgWIN.IS_SERVER)) // Revalidate immediately.
            softRevalidate();
            else // Delay the revalidate if we have data to return so we won't block
            // rendering.
            (0, $hgWIN.rAF)(softRevalidate);
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    (0, $hgWIN.useIsomorphicLayoutEffect)(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = (0, $hgWIN.isFunction)(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) timer = setTimeout(execute, interval);
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) revalidate($2ddd5897b5f9e2f0$var$WITH_DEDUPE).then(next);
            else // Schedule the next interval to check again.
            next();
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0, $jC8Vy.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && (0, $hgWIN.isUndefined)(data) && key) {
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any initial data. See:
        // https://github.com/vercel/swr/issues/1832
        if (!(0, $hgWIN.IS_REACT_LEGACY) && (0, $hgWIN.IS_SERVER)) throw new Error("Fallback data is required when using suspense in SSR.");
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        const req = PRELOAD[key];
        if (!(0, $hgWIN.isUndefined)(req)) {
            const promise = boundMutate(req);
            $2ddd5897b5f9e2f0$var$use(promise);
        }
        if ((0, $hgWIN.isUndefined)(error)) {
            const promise = revalidate($2ddd5897b5f9e2f0$var$WITH_DEDUPE);
            if (!(0, $hgWIN.isUndefined)(returnedData)) {
                promise.status = "fulfilled";
                promise.value = true;
            }
            $2ddd5897b5f9e2f0$var$use(promise);
        } else throw error;
    }
    return {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
};
const $2ddd5897b5f9e2f0$export$4c7bbecdacc3ca2c = (0, $hgWIN.OBJECT).defineProperty((0, $hgWIN.SWRConfig), "defaultValue", {
    value: (0, $hgWIN.defaultConfig)
});
/**
 * A hook to fetch data.
 *
 * @link https://swr.vercel.app
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (!data) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ const $2ddd5897b5f9e2f0$export$2e2bcd8739ae039 = (0, $hgWIN.withArgs)($2ddd5897b5f9e2f0$var$useSWRHandler);

});
parcelRequire.register("8iPR9", function(module, exports) {
"use strict";

module.exports = (parcelRequire("kMIUU"));

});
parcelRequire.register("kMIUU", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $03e7a9d66466b55d$export$306c0aa65ff9ec16; }, function (v) { return $03e7a9d66466b55d$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $03e7a9d66466b55d$export$306c0aa65ff9ec16;
"use strict";

var $jC8Vy = parcelRequire("jC8Vy");
function $03e7a9d66466b55d$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $03e7a9d66466b55d$var$k = "function" === typeof Object.is ? Object.is : $03e7a9d66466b55d$var$h, $03e7a9d66466b55d$var$l = $jC8Vy.useState, $03e7a9d66466b55d$var$m = $jC8Vy.useEffect, $03e7a9d66466b55d$var$n = $jC8Vy.useLayoutEffect, $03e7a9d66466b55d$var$p = $jC8Vy.useDebugValue;
function $03e7a9d66466b55d$var$q(a, b) {
    var d = b(), f = $03e7a9d66466b55d$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $03e7a9d66466b55d$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $03e7a9d66466b55d$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $03e7a9d66466b55d$var$m(function() {
        $03e7a9d66466b55d$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $03e7a9d66466b55d$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $03e7a9d66466b55d$var$p(d);
    return d;
}
function $03e7a9d66466b55d$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$03e7a9d66466b55d$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $03e7a9d66466b55d$var$t(a, b) {
    return b();
}
var $03e7a9d66466b55d$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $03e7a9d66466b55d$var$t : $03e7a9d66466b55d$var$q;
$03e7a9d66466b55d$export$306c0aa65ff9ec16 = void 0 !== $jC8Vy.useSyncExternalStore ? $jC8Vy.useSyncExternalStore : $03e7a9d66466b55d$var$u;

});


parcelRequire.register("hgWIN", function(module, exports) {

$parcel$export(module.exports, "UNDEFINED", function () { return $c29f42abb709259a$export$6db089fe7b26f5b6; });
$parcel$export(module.exports, "OBJECT", function () { return $c29f42abb709259a$export$8b8a958a7f6f130c; });
$parcel$export(module.exports, "isUndefined", function () { return $c29f42abb709259a$export$fce6876652108ab; });
$parcel$export(module.exports, "isFunction", function () { return $c29f42abb709259a$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "mergeObjects", function () { return $c29f42abb709259a$export$2321aea138b44780; });
$parcel$export(module.exports, "SWRGlobalState", function () { return $c29f42abb709259a$export$b94ca9901c60634; });
$parcel$export(module.exports, "createCacheHelper", function () { return $c29f42abb709259a$export$1251d51d9c571b45; });
$parcel$export(module.exports, "IS_REACT_LEGACY", function () { return $c29f42abb709259a$export$ddb64fe6466374f7; });
$parcel$export(module.exports, "IS_SERVER", function () { return $c29f42abb709259a$export$d2f4d8e74279c212; });
$parcel$export(module.exports, "rAF", function () { return $c29f42abb709259a$export$eba6076d3d7d0c06; });
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $c29f42abb709259a$export$700979bc83e7db82; });
$parcel$export(module.exports, "serialize", function () { return $c29f42abb709259a$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "getTimestamp", function () { return $c29f42abb709259a$export$3c95c4c8b671ef0; });
$parcel$export(module.exports, "revalidateEvents", function () { return $c29f42abb709259a$export$10213d6aa5ce32e6; });
$parcel$export(module.exports, "internalMutate", function () { return $c29f42abb709259a$export$c9d44e5bea4509be; });
$parcel$export(module.exports, "defaultConfig", function () { return $c29f42abb709259a$export$f84bd70098573c5c; });
$parcel$export(module.exports, "SWRConfig", function () { return $c29f42abb709259a$export$4c7bbecdacc3ca2c; });
$parcel$export(module.exports, "useSWRConfig", function () { return $c29f42abb709259a$export$f1dc0e282d4c1c0; });
$parcel$export(module.exports, "withArgs", function () { return $c29f42abb709259a$export$84d44e54e14b0133; });
$parcel$export(module.exports, "useStateWithDeps", function () { return $c29f42abb709259a$export$e1784150b9e765ac; });
$parcel$export(module.exports, "subscribeCallback", function () { return $c29f42abb709259a$export$e005210ed621746; });
$parcel$export(module.exports, "withMiddleware", function () { return $c29f42abb709259a$export$525ea7fc6ba00096; });

var $jC8Vy = parcelRequire("jC8Vy");
// Shared state between server components and client components
const $c29f42abb709259a$export$8793edee2d425525 = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $c29f42abb709259a$export$6db089fe7b26f5b6 = /*#__NOINLINE__*/ $c29f42abb709259a$export$8793edee2d425525();
const $c29f42abb709259a$export$8b8a958a7f6f130c = Object;
const $c29f42abb709259a$export$fce6876652108ab = (v)=>v === $c29f42abb709259a$export$6db089fe7b26f5b6;
const $c29f42abb709259a$export$f6e2535fb5126e54 = (v)=>typeof v == "function";
const $c29f42abb709259a$export$2321aea138b44780 = (a, b)=>({
        ...a,
        ...b
    });
const $c29f42abb709259a$export$ae936b9d47e5870e = (x)=>$c29f42abb709259a$export$f6e2535fb5126e54(x.then);
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $c29f42abb709259a$var$table = new WeakMap();
// counter of the key
let $c29f42abb709259a$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $c29f42abb709259a$export$e9a4e06c7dfb0bd4 = (arg)=>{
    const type = typeof arg;
    const constructor = arg && arg.constructor;
    const isDate = constructor == Date;
    let result;
    let index;
    if ($c29f42abb709259a$export$8b8a958a7f6f130c(arg) === arg && !isDate && constructor != RegExp) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $c29f42abb709259a$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$c29f42abb709259a$var$counter + "~";
        $c29f42abb709259a$var$table.set(arg, result);
        if (constructor == Array) {
            // Array.
            result = "@";
            for(index = 0; index < arg.length; index++)result += $c29f42abb709259a$export$e9a4e06c7dfb0bd4(arg[index]) + ",";
            $c29f42abb709259a$var$table.set(arg, result);
        }
        if (constructor == $c29f42abb709259a$export$8b8a958a7f6f130c) {
            // Object, sort keys.
            result = "#";
            const keys = $c29f42abb709259a$export$8b8a958a7f6f130c.keys(arg).sort();
            while(!$c29f42abb709259a$export$fce6876652108ab(index = keys.pop()))if (!$c29f42abb709259a$export$fce6876652108ab(arg[index])) result += index + ":" + $c29f42abb709259a$export$e9a4e06c7dfb0bd4(arg[index]) + ",";
            $c29f42abb709259a$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == "symbol" ? arg.toString() : type == "string" ? JSON.stringify(arg) : "" + arg;
    return result;
};
// Global state used to deduplicate requests and store listeners
const $c29f42abb709259a$export$b94ca9901c60634 = new WeakMap();
const $c29f42abb709259a$var$EMPTY_CACHE = {};
const $c29f42abb709259a$var$INITIAL_CACHE = {};
const $c29f42abb709259a$var$STR_UNDEFINED = "undefined";
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
const $c29f42abb709259a$export$6e85fd745dc51282 = typeof window != $c29f42abb709259a$var$STR_UNDEFINED;
const $c29f42abb709259a$export$842dfe7a9f24298 = typeof document != $c29f42abb709259a$var$STR_UNDEFINED;
const $c29f42abb709259a$export$a9116928c9d15917 = ()=>$c29f42abb709259a$export$6e85fd745dc51282 && typeof window["requestAnimationFrame"] != $c29f42abb709259a$var$STR_UNDEFINED;
const $c29f42abb709259a$export$1251d51d9c571b45 = (cache, key)=>{
    const state = $c29f42abb709259a$export$b94ca9901c60634.get(cache);
    return [
        // Getter
        ()=>!$c29f42abb709259a$export$fce6876652108ab(key) && cache.get(key) || $c29f42abb709259a$var$EMPTY_CACHE,
        // Setter
        (info)=>{
            if (!$c29f42abb709259a$export$fce6876652108ab(key)) {
                const prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in $c29f42abb709259a$var$INITIAL_CACHE)) $c29f42abb709259a$var$INITIAL_CACHE[key] = prev;
                state[5](key, $c29f42abb709259a$export$2321aea138b44780(prev, info), prev || $c29f42abb709259a$var$EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        ()=>{
            if (!$c29f42abb709259a$export$fce6876652108ab(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in $c29f42abb709259a$var$INITIAL_CACHE) return $c29f42abb709259a$var$INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return !$c29f42abb709259a$export$fce6876652108ab(key) && cache.get(key) || $c29f42abb709259a$var$EMPTY_CACHE;
        }
    ];
} // export { UNDEFINED, OBJECT, isUndefined, isFunction, mergeObjects, isPromiseLike }
;
/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ let $c29f42abb709259a$var$online = true;
const $c29f42abb709259a$var$isOnline = ()=>$c29f42abb709259a$var$online;
// For node and React Native, `add/removeEventListener` doesn't exist on window.
const [$c29f42abb709259a$var$onWindowEvent, $c29f42abb709259a$var$offWindowEvent] = $c29f42abb709259a$export$6e85fd745dc51282 && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    $c29f42abb709259a$export$8793edee2d425525,
    $c29f42abb709259a$export$8793edee2d425525
];
const $c29f42abb709259a$var$isVisible = ()=>{
    const visibilityState = $c29f42abb709259a$export$842dfe7a9f24298 && document.visibilityState;
    return $c29f42abb709259a$export$fce6876652108ab(visibilityState) || visibilityState !== "hidden";
};
const $c29f42abb709259a$var$initFocus = (callback)=>{
    // focus revalidate
    if ($c29f42abb709259a$export$842dfe7a9f24298) document.addEventListener("visibilitychange", callback);
    $c29f42abb709259a$var$onWindowEvent("focus", callback);
    return ()=>{
        if ($c29f42abb709259a$export$842dfe7a9f24298) document.removeEventListener("visibilitychange", callback);
        $c29f42abb709259a$var$offWindowEvent("focus", callback);
    };
};
const $c29f42abb709259a$var$initReconnect = (callback)=>{
    // revalidate on reconnected
    const onOnline = ()=>{
        $c29f42abb709259a$var$online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = ()=>{
        $c29f42abb709259a$var$online = false;
    };
    $c29f42abb709259a$var$onWindowEvent("online", onOnline);
    $c29f42abb709259a$var$onWindowEvent("offline", onOffline);
    return ()=>{
        $c29f42abb709259a$var$offWindowEvent("online", onOnline);
        $c29f42abb709259a$var$offWindowEvent("offline", onOffline);
    };
};
const $c29f42abb709259a$export$f5ab8217e0edff04 = {
    isOnline: $c29f42abb709259a$var$isOnline,
    isVisible: $c29f42abb709259a$var$isVisible
};
const $c29f42abb709259a$export$b1857f3440a65373 = {
    initFocus: $c29f42abb709259a$var$initFocus,
    initReconnect: $c29f42abb709259a$var$initReconnect
};
const $c29f42abb709259a$export$ddb64fe6466374f7 = !(0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useId;
const $c29f42abb709259a$export$d2f4d8e74279c212 = !$c29f42abb709259a$export$6e85fd745dc51282 || "Deno" in window;
// Polyfill requestAnimationFrame
const $c29f42abb709259a$export$eba6076d3d7d0c06 = (f)=>$c29f42abb709259a$export$a9116928c9d15917() ? window["requestAnimationFrame"](f) : setTimeout(f, 1);
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
const $c29f42abb709259a$export$700979bc83e7db82 = $c29f42abb709259a$export$d2f4d8e74279c212 ? (0, $jC8Vy.useEffect) : (0, $jC8Vy.useLayoutEffect);
// This assignment is to extend the Navigator type to use effectiveType.
const $c29f42abb709259a$var$navigatorConnection = typeof navigator !== "undefined" && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
const $c29f42abb709259a$export$3723beb60427dc52 = !$c29f42abb709259a$export$d2f4d8e74279c212 && $c29f42abb709259a$var$navigatorConnection && ([
    "slow-2g",
    "2g"
].includes($c29f42abb709259a$var$navigatorConnection.effectiveType) || $c29f42abb709259a$var$navigatorConnection.saveData);
const $c29f42abb709259a$export$dfdc1655ccc5b9cb = (key)=>{
    if ($c29f42abb709259a$export$f6e2535fb5126e54(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = "";
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == "string" ? key : (Array.isArray(key) ? key.length : key) ? $c29f42abb709259a$export$e9a4e06c7dfb0bd4(key) : "";
    return [
        key,
        args
    ];
};
// Global timestamp.
let $c29f42abb709259a$var$__timestamp = 0;
const $c29f42abb709259a$export$3c95c4c8b671ef0 = ()=>++$c29f42abb709259a$var$__timestamp;
const $c29f42abb709259a$var$FOCUS_EVENT = 0;
const $c29f42abb709259a$var$RECONNECT_EVENT = 1;
const $c29f42abb709259a$var$MUTATE_EVENT = 2;
const $c29f42abb709259a$var$ERROR_REVALIDATE_EVENT = 3;
var $c29f42abb709259a$export$10213d6aa5ce32e6 = {
    __proto__: null,
    ERROR_REVALIDATE_EVENT: $c29f42abb709259a$var$ERROR_REVALIDATE_EVENT,
    FOCUS_EVENT: $c29f42abb709259a$var$FOCUS_EVENT,
    MUTATE_EVENT: $c29f42abb709259a$var$MUTATE_EVENT,
    RECONNECT_EVENT: $c29f42abb709259a$var$RECONNECT_EVENT
};
async function $c29f42abb709259a$export$c9d44e5bea4509be(...args) {
    const [cache, _key, _data, _opts] = args;
    // When passing as a boolean, it's explicitly used to disable/enable
    // revalidation.
    const options = $c29f42abb709259a$export$2321aea138b44780({
        populateCache: true,
        throwOnError: true
    }, typeof _opts === "boolean" ? {
        revalidate: _opts
    } : _opts || {});
    let populateCache = options.populateCache;
    const rollbackOnErrorOption = options.rollbackOnError;
    let optimisticData = options.optimisticData;
    const revalidate = options.revalidate !== false;
    const rollbackOnError = (error)=>{
        return typeof rollbackOnErrorOption === "function" ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
    };
    const throwOnError = options.throwOnError;
    // If the second argument is a key filter, return the mutation results for all
    // filtered keys.
    if ($c29f42abb709259a$export$f6e2535fb5126e54(_key)) {
        const keyFilter = _key;
        const matchedKeys = [];
        const it = cache.keys();
        for (const key of it)if (!/^\$(inf|sub)\$/.test(key) && keyFilter(cache.get(key)._k)) matchedKeys.push(key);
        return Promise.all(matchedKeys.map(mutateByKey));
    }
    return mutateByKey(_key);
    async function mutateByKey(_k) {
        // Serialize key
        const [key] = $c29f42abb709259a$export$dfdc1655ccc5b9cb(_k);
        if (!key) return;
        const [get, set] = $c29f42abb709259a$export$1251d51d9c571b45(cache, key);
        const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = $c29f42abb709259a$export$b94ca9901c60634.get(cache);
        const revalidators = EVENT_REVALIDATORS[key];
        const startRevalidate = ()=>{
            if (revalidate) {
                // Invalidate the key by deleting the concurrent request markers so new
                // requests will not be deduped.
                delete FETCH[key];
                delete PRELOAD[key];
                if (revalidators && revalidators[0]) return revalidators[0]($c29f42abb709259a$var$MUTATE_EVENT).then(()=>get().data);
            }
            return get().data;
        };
        // If there is no new data provided, revalidate the key with current state.
        if (args.length < 3) // Revalidate and broadcast state.
        return startRevalidate();
        let data = _data;
        let error;
        // Update global timestamps.
        const beforeMutationTs = $c29f42abb709259a$export$3c95c4c8b671ef0();
        MUTATION[key] = [
            beforeMutationTs,
            0
        ];
        const hasOptimisticData = !$c29f42abb709259a$export$fce6876652108ab(optimisticData);
        const state = get();
        // `displayedData` is the current value on screen. It could be the optimistic value
        // that is going to be overridden by a `committedData`, or get reverted back.
        // `committedData` is the validated value that comes from a fetch or mutation.
        const displayedData = state.data;
        const currentData = state._c;
        const committedData = $c29f42abb709259a$export$fce6876652108ab(currentData) ? displayedData : currentData;
        // Do optimistic data update.
        if (hasOptimisticData) {
            optimisticData = $c29f42abb709259a$export$f6e2535fb5126e54(optimisticData) ? optimisticData(committedData, displayedData) : optimisticData;
            // When we set optimistic data, backup the current committedData data in `_c`.
            set({
                data: optimisticData,
                _c: committedData
            });
        }
        if ($c29f42abb709259a$export$f6e2535fb5126e54(data)) // `data` is a function, call it passing current cache value.
        try {
            data = data(committedData);
        } catch (err) {
            // If it throws an error synchronously, we shouldn't update the cache.
            error = err;
        }
        // `data` is a promise/thenable, resolve the final data first.
        if (data && $c29f42abb709259a$export$ae936b9d47e5870e(data)) {
            // This means that the mutation is async, we need to check timestamps to
            // avoid race conditions.
            data = await data.catch((err)=>{
                error = err;
            });
            // Check if other mutations have occurred since we've started this mutation.
            // If there's a race we don't update cache or broadcast the change,
            // just return the data.
            if (beforeMutationTs !== MUTATION[key][0]) {
                if (error) throw error;
                return data;
            } else if (error && hasOptimisticData && rollbackOnError(error)) {
                // Rollback. Always populate the cache in this case but without
                // transforming the data.
                populateCache = true;
                data = committedData;
                // Reset data to be the latest committed data, and clear the `_c` value.
                set({
                    data: data,
                    _c: $c29f42abb709259a$export$6db089fe7b26f5b6
                });
            }
        }
        // If we should write back the cache after request.
        if (populateCache) {
            if (!error) {
                // Transform the result into data.
                if ($c29f42abb709259a$export$f6e2535fb5126e54(populateCache)) data = populateCache(data, committedData);
                // Only update cached data and reset the error if there's no error. Data can be `undefined` here.
                set({
                    data: data,
                    error: $c29f42abb709259a$export$6db089fe7b26f5b6,
                    _c: $c29f42abb709259a$export$6db089fe7b26f5b6
                });
            }
        }
        // Reset the timestamp to mark the mutation has ended.
        MUTATION[key][1] = $c29f42abb709259a$export$3c95c4c8b671ef0();
        // Update existing SWR Hooks' internal states:
        const res = await startRevalidate();
        // The mutation and revalidation are ended, we can clear it since the data is
        // not an optimistic value anymore.
        set({
            _c: $c29f42abb709259a$export$6db089fe7b26f5b6
        });
        // Throw error or return data
        if (error) {
            if (throwOnError) throw error;
            return;
        }
        return populateCache ? res : data;
    }
}
const $c29f42abb709259a$var$revalidateAllKeys = (revalidators, type)=>{
    for(const key in revalidators)if (revalidators[key][0]) revalidators[key][0](type);
};
const $c29f42abb709259a$export$4008f5b66f9e0b3c = (provider, options)=>{
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!$c29f42abb709259a$export$b94ca9901c60634.has(provider)) {
        const opts = $c29f42abb709259a$export$2321aea138b44780($c29f42abb709259a$export$b1857f3440a65373, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        const EVENT_REVALIDATORS = {};
        const mutate = $c29f42abb709259a$export$c9d44e5bea4509be.bind($c29f42abb709259a$export$6db089fe7b26f5b6, provider);
        let unmount = $c29f42abb709259a$export$8793edee2d425525;
        const subscriptions = {};
        const subscribe = (key, callback)=>{
            const subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return ()=>subs.splice(subs.indexOf(callback), 1);
        };
        const setter = (key, value, prev)=>{
            provider.set(key, value);
            const subs = subscriptions[key];
            if (subs) for (const fn of subs)fn(value, prev);
        };
        const initProvider = ()=>{
            if (!$c29f42abb709259a$export$b94ca9901c60634.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                $c29f42abb709259a$export$b94ca9901c60634.set(provider, [
                    EVENT_REVALIDATORS,
                    {},
                    {},
                    {},
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!$c29f42abb709259a$export$d2f4d8e74279c212) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    const releaseFocus = opts.initFocus(setTimeout.bind($c29f42abb709259a$export$6db089fe7b26f5b6, $c29f42abb709259a$var$revalidateAllKeys.bind($c29f42abb709259a$export$6db089fe7b26f5b6, EVENT_REVALIDATORS, $c29f42abb709259a$var$FOCUS_EVENT)));
                    const releaseReconnect = opts.initReconnect(setTimeout.bind($c29f42abb709259a$export$6db089fe7b26f5b6, $c29f42abb709259a$var$revalidateAllKeys.bind($c29f42abb709259a$export$6db089fe7b26f5b6, EVENT_REVALIDATORS, $c29f42abb709259a$var$RECONNECT_EVENT)));
                    unmount = ()=>{
                        releaseFocus && releaseFocus();
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        $c29f42abb709259a$export$b94ca9901c60634.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        $c29f42abb709259a$export$b94ca9901c60634.get(provider)[4]
    ];
};
// error retry
const $c29f42abb709259a$var$onErrorRetry = (_, __, config, revalidate, opts)=>{
    const maxRetryCount = config.errorRetryCount;
    const currentRetryCount = opts.retryCount;
    // Exponential backoff
    const timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!$c29f42abb709259a$export$fce6876652108ab(maxRetryCount) && currentRetryCount > maxRetryCount) return;
    setTimeout(revalidate, timeout, opts);
};
const $c29f42abb709259a$export$398604a469f7de9a = (currentData, newData)=>$c29f42abb709259a$export$e9a4e06c7dfb0bd4(currentData) == $c29f42abb709259a$export$e9a4e06c7dfb0bd4(newData);
// Default cache provider
const [$c29f42abb709259a$export$69a3209f1a06c04d, $c29f42abb709259a$export$57e795267c26e600] = $c29f42abb709259a$export$4008f5b66f9e0b3c(new Map());
// Default config
const $c29f42abb709259a$export$f84bd70098573c5c = $c29f42abb709259a$export$2321aea138b44780({
    // events
    onLoadingSlow: $c29f42abb709259a$export$8793edee2d425525,
    onSuccess: $c29f42abb709259a$export$8793edee2d425525,
    onError: $c29f42abb709259a$export$8793edee2d425525,
    onErrorRetry: $c29f42abb709259a$var$onErrorRetry,
    onDiscarded: $c29f42abb709259a$export$8793edee2d425525,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: $c29f42abb709259a$export$3723beb60427dc52 ? 10000 : 5000,
    focusThrottleInterval: 5000,
    dedupingInterval: 2000,
    loadingTimeout: $c29f42abb709259a$export$3723beb60427dc52 ? 5000 : 3000,
    compare: // providers
    $c29f42abb709259a$export$398604a469f7de9a,
    isPaused: ()=>false,
    cache: $c29f42abb709259a$export$69a3209f1a06c04d,
    mutate: $c29f42abb709259a$export$57e795267c26e600,
    fallback: {}
}, $c29f42abb709259a$export$f5ab8217e0edff04);
const $c29f42abb709259a$export$5d86b86a654a7039 = (a, b)=>{
    // Need to create a new object to avoid mutating the original here.
    const v = $c29f42abb709259a$export$2321aea138b44780(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        const { use: u1, fallback: f1 } = a;
        const { use: u2, fallback: f2 } = b;
        if (u1 && u2) v.use = u1.concat(u2);
        if (f1 && f2) v.fallback = $c29f42abb709259a$export$2321aea138b44780(f1, f2);
    }
    return v;
};
const $c29f42abb709259a$var$SWRConfigContext = (0, $jC8Vy.createContext)({});
const $c29f42abb709259a$export$4c7bbecdacc3ca2c = (props)=>{
    const { value: value } = props;
    const parentConfig = (0, $jC8Vy.useContext)($c29f42abb709259a$var$SWRConfigContext);
    const isFunctionalConfig = $c29f42abb709259a$export$f6e2535fb5126e54(value);
    const config = (0, $jC8Vy.useMemo)(()=>isFunctionalConfig ? value(parentConfig) : value, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    const extendedConfig = (0, $jC8Vy.useMemo)(()=>isFunctionalConfig ? config : $c29f42abb709259a$export$5d86b86a654a7039(parentConfig, config), [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    const provider = config && config.provider;
    // initialize the cache only on first access.
    const cacheContextRef = (0, $jC8Vy.useRef)($c29f42abb709259a$export$6db089fe7b26f5b6);
    if (provider && !cacheContextRef.current) cacheContextRef.current = $c29f42abb709259a$export$4008f5b66f9e0b3c(provider(extendedConfig.cache || $c29f42abb709259a$export$69a3209f1a06c04d), config);
    const cacheContext = cacheContextRef.current;
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    $c29f42abb709259a$export$700979bc83e7db82(()=>{
        if (cacheContext) {
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0, $jC8Vy.createElement)($c29f42abb709259a$var$SWRConfigContext.Provider, $c29f42abb709259a$export$2321aea138b44780(props, {
        value: extendedConfig
    }));
};
// @ts-expect-error
const $c29f42abb709259a$var$enableDevtools = $c29f42abb709259a$export$6e85fd745dc51282 && window.__SWR_DEVTOOLS_USE__;
const $c29f42abb709259a$var$use = $c29f42abb709259a$var$enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
const $c29f42abb709259a$var$setupDevTools = ()=>{
    if ($c29f42abb709259a$var$enableDevtools) // @ts-expect-error
    window.__SWR_DEVTOOLS_REACT__ = (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy)));
};
const $c29f42abb709259a$export$a3295358bff77e = (args)=>{
    return $c29f42abb709259a$export$f6e2535fb5126e54(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};
const $c29f42abb709259a$export$f1dc0e282d4c1c0 = ()=>{
    return $c29f42abb709259a$export$2321aea138b44780($c29f42abb709259a$export$f84bd70098573c5c, (0, $jC8Vy.useContext)($c29f42abb709259a$var$SWRConfigContext));
};
const $c29f42abb709259a$export$513ccb98c53b8039 = (key_, fetcher)=>{
    const [key, fnArg] = $c29f42abb709259a$export$dfdc1655ccc5b9cb(key_);
    const [, , , PRELOAD] = $c29f42abb709259a$export$b94ca9901c60634.get($c29f42abb709259a$export$69a3209f1a06c04d);
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    const req = fetcher(fnArg);
    PRELOAD[key] = req;
    return req;
};
const $c29f42abb709259a$var$middleware = (useSWRNext)=>(key_, fetcher_, config)=>{
        // fetcher might be a sync function, so this should not be an async function
        const fetcher = fetcher_ && ((...args)=>{
            const [key] = $c29f42abb709259a$export$dfdc1655ccc5b9cb(key_);
            const [, , , PRELOAD] = $c29f42abb709259a$export$b94ca9901c60634.get($c29f42abb709259a$export$69a3209f1a06c04d);
            const req = PRELOAD[key];
            if ($c29f42abb709259a$export$fce6876652108ab(req)) return fetcher_(...args);
            delete PRELOAD[key];
            return req;
        });
        return useSWRNext(key_, fetcher, config);
    };
const $c29f42abb709259a$var$BUILT_IN_MIDDLEWARE = $c29f42abb709259a$var$use.concat($c29f42abb709259a$var$middleware);
// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
const $c29f42abb709259a$export$84d44e54e14b0133 = (hook)=>{
    return function useSWRArgs(...args) {
        // Get the default and inherited configuration.
        const fallbackConfig = $c29f42abb709259a$export$f1dc0e282d4c1c0();
        // Normalize arguments.
        const [key, fn, _config] = $c29f42abb709259a$export$a3295358bff77e(args);
        // Merge configurations.
        const config = $c29f42abb709259a$export$5d86b86a654a7039(fallbackConfig, _config);
        // Apply middleware
        let next = hook;
        const { use: use } = config;
        const middleware = (use || []).concat($c29f42abb709259a$var$BUILT_IN_MIDDLEWARE);
        for(let i = middleware.length; i--;)next = middleware[i](next);
        return next(key, fn || config.fetcher || null, config);
    };
};
/**
 * An implementation of state with dependency-tracking.
 */ const $c29f42abb709259a$export$e1784150b9e765ac = (state)=>{
    const rerender = (0, $jC8Vy.useState)({})[1];
    const unmountedRef = (0, $jC8Vy.useRef)(false);
    const stateRef = (0, $jC8Vy.useRef)(state);
    // If a state property (data, error, or isValidating) is accessed by the render
    // function, we mark the property as a dependency so if it is updated again
    // in the future, we trigger a rerender.
    // This is also known as dependency-tracking.
    const stateDependenciesRef = (0, $jC8Vy.useRef)({
        data: false,
        error: false,
        isValidating: false
    });
    /**
   * @param payload To change stateRef, pass the values explicitly to setState:
   * @example
   * ```js
   * setState({
   *   isValidating: false
   *   data: newData // set data to newData
   *   error: undefined // set error to undefined
   * })
   *
   * setState({
   *   isValidating: false
   *   data: undefined // set data to undefined
   *   error: err // set error to err
   * })
   * ```
   */ const setState = (0, $jC8Vy.useCallback)((payload)=>{
        let shouldRerender = false;
        const currentState = stateRef.current;
        for(const _ in payload){
            const k = _;
            // If the property has changed, update the state and mark rerender as
            // needed.
            if (currentState[k] !== payload[k]) {
                currentState[k] = payload[k];
                // If the property is accessed by the component, a rerender should be
                // triggered.
                if (stateDependenciesRef.current[k]) shouldRerender = true;
            }
        }
        if (shouldRerender && !unmountedRef.current) {
            if ($c29f42abb709259a$export$ddb64fe6466374f7) rerender({});
            else (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).startTransition(()=>rerender({}));
        }
    }, [
        rerender
    ]);
    $c29f42abb709259a$export$700979bc83e7db82(()=>{
        unmountedRef.current = false;
        return ()=>{
            unmountedRef.current = true;
        };
    });
    return [
        stateRef,
        stateDependenciesRef.current,
        setState
    ];
};
// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
const $c29f42abb709259a$export$e005210ed621746 = (key, callbacks, callback)=>{
    const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return ()=>{
        const index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};
// Create a custom hook with a middleware
const $c29f42abb709259a$export$525ea7fc6ba00096 = (useSWR, middleware)=>{
    return (...args)=>{
        const [key, fn, config] = $c29f42abb709259a$export$a3295358bff77e(args);
        const uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, {
            ...config,
            use: uses
        });
    };
};
$c29f42abb709259a$var$setupDevTools();

});


parcelRequire.register("7VnwS", function(module, exports) {

$parcel$export(module.exports, "RequestError", function () { return $41644f3cc0b327a9$export$43ee7d0e4f429743; });
$parcel$export(module.exports, "useStaticApi", function () { return $41644f3cc0b327a9$export$181b551a2bac23b4; });
$parcel$export(module.exports, "default", function () { return $41644f3cc0b327a9$export$2e2bcd8739ae039; });
parcelRequire("4taJ0");
var $37iDI = parcelRequire("37iDI");
var $hyigV = parcelRequire("hyigV");
parcelRequire("9zW7e");
var $jSb9j = parcelRequire("jSb9j");
parcelRequire("cuPVN");
var $aZIrr = parcelRequire("aZIrr");
var $j0apn = parcelRequire("j0apn");
var $6hxiJ = parcelRequire("6hxiJ");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");
var $gcHb7 = parcelRequire("gcHb7");

var $64jBf = parcelRequire("64jBf");

var $jC8Vy = parcelRequire("jC8Vy");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $8Mb3E = parcelRequire("8Mb3E");

var $8TpMk = parcelRequire("8TpMk");

var $fG7L1 = parcelRequire("fG7L1");

var $cDKfs = parcelRequire("cDKfs");

var $kBpQ2 = parcelRequire("kBpQ2");

var $azCDQ = parcelRequire("azCDQ");
class $41644f3cc0b327a9$export$43ee7d0e4f429743 extends Error {
    constructor(status, body){
        super("Request error occurred.");
        this.status = status;
        this.body = body;
    }
}
const $41644f3cc0b327a9$var$useGlobalRequestErrorHandler = (toastDisabledErrorCodes)=>{
    const { signOut: signOut } = (0, $jSb9j.useLogto)();
    const { show: show } = (0, $kBpQ2.useConfirmModal)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const postSignOutRedirectUri = (0, $azCDQ.default)("signOut");
    const handleError = (0, $jC8Vy.useCallback)(async (response)=>{
        const fallbackErrorMessage = t("errors.unknown_server_error");
        try {
            // Clone the response to avoid "Response body is already used".
            const data = await response.clone().json();
            // This is what will happen when the user still has the legacy refresh token without
            // organization scope. We should sign them out and redirect to the sign in page.
            // TODO: This is a temporary solution to prevent the user from getting stuck in Console,
            // which can be removed after all legacy refresh tokens are expired, i.e. after Jan 10th,
            // 2024.
            if (response.status === 403 && data.message === "Insufficient permissions.") {
                await signOut(postSignOutRedirectUri.href);
                return;
            }
            // Inform and redirect un-authorized users to sign in page.
            if (data.code === "auth.forbidden") {
                await show({
                    ModalContent: data.message,
                    type: "alert",
                    cancelButtonText: "general.got_it"
                });
                await signOut(postSignOutRedirectUri.href);
                return;
            }
            // Skip showing toast for specific error codes.
            if (toastDisabledErrorCodes?.includes(data.code)) return;
            (0, $FuhPC.toast).error([
                data.message,
                data.details
            ].join("\n") || fallbackErrorMessage);
        } catch  {
            (0, $FuhPC.toast).error((0, $37iDI.httpCodeToMessage)[response.status] ?? fallbackErrorMessage);
        }
    }, [
        t,
        toastDisabledErrorCodes,
        signOut,
        postSignOutRedirectUri.href,
        show
    ]);
    return {
        handleError: handleError
    };
};
const $41644f3cc0b327a9$export$181b551a2bac23b4 = ({ prefixUrl: prefixUrl, hideErrorToast: hideErrorToast, resourceIndicator: resourceIndicator })=>{
    const { isAuthenticated: isAuthenticated, getAccessToken: getAccessToken, getOrganizationToken: getOrganizationToken } = (0, $jSb9j.useLogto)();
    const { i18n: i18n } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    // Disable global error handling if `hideErrorToast` is true.
    const disableGlobalErrorHandling = hideErrorToast === true;
    // Disable toast for specific error codes.
    const toastDisabledErrorCodes = Array.isArray(hideErrorToast) ? hideErrorToast : undefined;
    const { handleError: handleError } = $41644f3cc0b327a9$var$useGlobalRequestErrorHandler(toastDisabledErrorCodes);
    const api = (0, $jC8Vy.useMemo)(()=>(0, $64jBf.default).create({
            prefixUrl: prefixUrl,
            timeout: (0, $8Mb3E.requestTimeout),
            hooks: {
                beforeError: (0, $7oDSS.conditionalArray)(!disableGlobalErrorHandling && (async (error)=>{
                    await handleError(error.response);
                    return error;
                })),
                beforeRequest: [
                    async (request)=>{
                        if (isAuthenticated) {
                            const accessToken = await (resourceIndicator.startsWith((0, $hyigV.organizationUrnPrefix)) ? getOrganizationToken((0, $hyigV.getOrganizationIdFromUrn)(resourceIndicator)) : getAccessToken(resourceIndicator));
                            request.headers.set("Authorization", `Bearer ${accessToken ?? ""}`);
                            request.headers.set("Accept-Language", i18n.language);
                        }
                    }
                ]
            }
        }), [
        prefixUrl,
        disableGlobalErrorHandling,
        handleError,
        isAuthenticated,
        resourceIndicator,
        getOrganizationToken,
        getAccessToken,
        i18n.language
    ]);
    return api;
};
/** A hook to get a Ky instance with the current tenant's Management API prefix URL. */ const $41644f3cc0b327a9$var$useApi = (props = {})=>{
    const { tenantEndpoint: tenantEndpoint } = (0, $jC8Vy.useContext)((0, $fG7L1.AppDataContext));
    const { currentTenantId: currentTenantId } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    /**
   * The config object for the Ky instance.
   *
   * - In Cloud, it uses the Management API proxy endpoint with tenant organization tokens.
   * - In OSS, it directly uses the tenant endpoint (Management API).
   *
   * Since we removes all user roles for the Management API except the one for the default tenant,
   * the OSS version should be used for the default tenant only.
   */ const config = (0, $jC8Vy.useMemo)(()=>(0, $8TpMk.isCloud) ? {
            prefixUrl: (0, $gcHb7.appendPath)(new URL(window.location.origin), "m", currentTenantId),
            resourceIndicator: (0, $hyigV.buildOrganizationUrn)((0, $aZIrr.getTenantOrganizationId)(currentTenantId))
        } : {
            prefixUrl: tenantEndpoint,
            resourceIndicator: (0, $j0apn.getManagementApiResourceIndicator)(currentTenantId)
        }, [
        currentTenantId,
        tenantEndpoint
    ]);
    if (!(0, $8TpMk.isCloud) && currentTenantId !== (0, $6hxiJ.defaultTenantId)) throw new Error("Only the default tenant is supported in OSS.");
    return $41644f3cc0b327a9$export$181b551a2bac23b4({
        ...props,
        ...config
    });
};
var $41644f3cc0b327a9$export$2e2bcd8739ae039 = $41644f3cc0b327a9$var$useApi;

});
parcelRequire.register("9zW7e", function(module, exports) {

$parcel$export(module.exports, "LogtoClientError", function () { return (parcelRequire("v4mmb")).LogtoClientError; });
$parcel$export(module.exports, "LogtoError", function () { return (parcelRequire("4aiSz")).LogtoError; });
$parcel$export(module.exports, "LogtoRequestError", function () { return (parcelRequire("4aiSz")).LogtoRequestError; });
$parcel$export(module.exports, "OidcError", function () { return (parcelRequire("4aiSz")).OidcError; });
$parcel$export(module.exports, "Prompt", function () { return (parcelRequire("gz11x")).Prompt; });
$parcel$export(module.exports, "LogtoProvider", function () { return (parcelRequire("7pgvg")).LogtoProvider; });
$parcel$export(module.exports, "useHandleSignInCallback", function () { return (parcelRequire("jSb9j")).useHandleSignInCallback; });
$parcel$export(module.exports, "useLogto", function () { return (parcelRequire("jSb9j")).useLogto; });
parcelRequire("hNIcd");
var $v4mmb = parcelRequire("v4mmb");
var $4aiSz = parcelRequire("4aiSz");
var $gz11x = parcelRequire("gz11x");

var $7pgvg = parcelRequire("7pgvg");

var $jSb9j = parcelRequire("jSb9j");

});
parcelRequire.register("hNIcd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf594bb426ddcfd5$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "LogtoClientError", function () { return (parcelRequire("v4mmb")).LogtoClientError; });
$parcel$export(module.exports, "LogtoError", function () { return (parcelRequire("4aiSz")).LogtoError; });
$parcel$export(module.exports, "LogtoRequestError", function () { return (parcelRequire("4aiSz")).LogtoRequestError; });
$parcel$export(module.exports, "OidcError", function () { return (parcelRequire("4aiSz")).OidcError; });
$parcel$export(module.exports, "Prompt", function () { return (parcelRequire("gz11x")).Prompt; });
parcelRequire("1cDtu");
var $db23v = parcelRequire("db23v");
var $1cDtu = parcelRequire("1cDtu");
var $v4mmb = parcelRequire("v4mmb");
var $4aiSz = parcelRequire("4aiSz");
var $gz11x = parcelRequire("gz11x");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $aqwQn = parcelRequire("aqwQn");

var $8rtZQ = parcelRequire("8rtZQ");

var $ctNOk = parcelRequire("ctNOk");
const $cf594bb426ddcfd5$var$navigate = (url)=>{
    window.location.assign(url);
};
class $cf594bb426ddcfd5$export$2e2bcd8739ae039 extends (0, $1cDtu.default) {
    /**
     * @param config The configuration object for the client.
     * @param [unstable_enableCache=false] Whether to enable cache for well-known data.
     * Use sessionStorage by default.
     */ constructor(config, unstable_enableCache = false){
        const requester = (0, $db23v.createRequester)(fetch);
        super(config, {
            requester: requester,
            navigate: $cf594bb426ddcfd5$var$navigate,
            storage: new (0, $8rtZQ.BrowserStorage)(config.appId),
            unstable_cache: (0, $7oDSS.conditional)(unstable_enableCache && new (0, $aqwQn.CacheStorage)(config.appId)),
            generateCodeChallenge: $ctNOk.generateCodeChallenge,
            generateCodeVerifier: $ctNOk.generateCodeVerifier,
            generateState: $ctNOk.generateState
        });
    }
}

});
parcelRequire.register("1cDtu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e05884670f6e44c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "LogtoError", function () { return (parcelRequire("4aiSz")).LogtoError; });
$parcel$export(module.exports, "LogtoRequestError", function () { return (parcelRequire("4aiSz")).LogtoRequestError; });
$parcel$export(module.exports, "OidcError", function () { return (parcelRequire("4aiSz")).OidcError; });
$parcel$export(module.exports, "Prompt", function () { return (parcelRequire("gz11x")).Prompt; });
$parcel$export(module.exports, "LogtoClientError", function () { return (parcelRequire("v4mmb")).LogtoClientError; });
$parcel$export(module.exports, "createRequester", function () { return (parcelRequire("db23v")).createRequester; });

var $covKo = parcelRequire("covKo");

var $23Be9 = parcelRequire("23Be9");
parcelRequire("dWRvH");
var $4aiSz = parcelRequire("4aiSz");
var $gz11x = parcelRequire("gz11x");

var $v4mmb = parcelRequire("v4mmb");
parcelRequire("12bMu");

var $9q1Q2 = parcelRequire("9q1Q2");

var $db23v = parcelRequire("db23v");

var $ddB4E = parcelRequire("ddB4E");
/**
 * The Logto base client class that provides the essential methods for
 * interacting with the Logto server.
 *
 * It also provides an adapter object that allows the customizations of the
 * client behavior for different environments.
 */ class $0e05884670f6e44c$export$2e2bcd8739ae039 extends (0, $23Be9.StandardLogtoClient) {
    constructor(logtoConfig, adapter, buildJwtVerifier){
        super(logtoConfig, adapter, buildJwtVerifier ?? ((client)=>new (0, $covKo.DefaultJwtVerifier)(client)));
    }
}

});
parcelRequire.register("covKo", function(module, exports) {

$parcel$export(module.exports, "DefaultJwtVerifier", function () { return $90605a47e44790f8$export$74fd7dca29afc16a; });
parcelRequire("dWRvH");
var $4aiSz = parcelRequire("4aiSz");
parcelRequire("bocSp");
var $lR5W2 = parcelRequire("lR5W2");
var $3PpsA = parcelRequire("3PpsA");
const $90605a47e44790f8$var$issuedAtTimeTolerance = 300; // 5 minutes
const $90605a47e44790f8$export$b5b3317c8aecbcd5 = async (idToken, clientId, issuer, jwks)=>{
    const result = await (0, $lR5W2.jwtVerify)(idToken, jwks, {
        audience: clientId,
        issuer: issuer
    });
    if (Math.abs((result.payload.iat ?? 0) - Date.now() / 1000) > $90605a47e44790f8$var$issuedAtTimeTolerance) throw new (0, $4aiSz.LogtoError)("id_token.invalid_iat");
};
class $90605a47e44790f8$export$74fd7dca29afc16a {
    constructor(client){
        this.client = client;
    }
    async verifyIdToken(idToken) {
        const { appId: appId } = this.client.logtoConfig;
        const { issuer: issuer, jwksUri: jwksUri } = await this.client.getOidcConfig();
        if (!this.getJwtVerifyGetKey) this.getJwtVerifyGetKey = (0, $3PpsA.createRemoteJWKSet)(new URL(jwksUri));
        await $90605a47e44790f8$export$b5b3317c8aecbcd5(idToken, appId, issuer, this.getJwtVerifyGetKey);
    }
}

});
parcelRequire.register("dWRvH", function(module, exports) {

$parcel$export(module.exports, "fetchTokenByAuthorizationCode", function () { return (parcelRequire("J24Fb")).fetchTokenByAuthorizationCode; });
$parcel$export(module.exports, "fetchTokenByRefreshToken", function () { return (parcelRequire("J24Fb")).fetchTokenByRefreshToken; });
$parcel$export(module.exports, "discoveryPath", function () { return (parcelRequire("fNnrz")).discoveryPath; });
$parcel$export(module.exports, "fetchOidcConfig", function () { return (parcelRequire("fNnrz")).fetchOidcConfig; });
$parcel$export(module.exports, "revoke", function () { return (parcelRequire("8yRDe")).revoke; });
$parcel$export(module.exports, "generateSignInUri", function () { return (parcelRequire("1Uy1B")).generateSignInUri; });
$parcel$export(module.exports, "generateSignOutUri", function () { return (parcelRequire("8Dq0r")).generateSignOutUri; });
$parcel$export(module.exports, "fetchUserInfo", function () { return (parcelRequire("dpAr1")).fetchUserInfo; });
$parcel$export(module.exports, "verifyAndParseCodeFromCallbackUri", function () { return (parcelRequire("7SAxh")).verifyAndParseCodeFromCallbackUri; });
$parcel$export(module.exports, "LogtoError", function () { return (parcelRequire("4aiSz")).LogtoError; });
$parcel$export(module.exports, "LogtoRequestError", function () { return (parcelRequire("4aiSz")).LogtoRequestError; });
$parcel$export(module.exports, "OidcError", function () { return (parcelRequire("4aiSz")).OidcError; });
$parcel$export(module.exports, "isLogtoRequestError", function () { return (parcelRequire("4aiSz")).isLogtoRequestError; });
$parcel$export(module.exports, "decodeIdToken", function () { return (parcelRequire("fRuVm")).decodeIdToken; });
$parcel$export(module.exports, "decodeAccessToken", function () { return (parcelRequire("duMzr")).decodeAccessToken; });
$parcel$export(module.exports, "withDefaultScopes", function () { return (parcelRequire("aUkwV")).withDefaultScopes; });
$parcel$export(module.exports, "isArbitraryObject", function () { return (parcelRequire("i1sNc")).isArbitraryObject; });
$parcel$export(module.exports, "Prompt", function () { return (parcelRequire("gz11x")).Prompt; });
$parcel$export(module.exports, "ReservedResource", function () { return (parcelRequire("kTA61")).ReservedResource; });
$parcel$export(module.exports, "UserScope", function () { return (parcelRequire("kTA61")).UserScope; });

var $J24Fb = parcelRequire("J24Fb");

var $fNnrz = parcelRequire("fNnrz");

var $8yRDe = parcelRequire("8yRDe");

var $1Uy1B = parcelRequire("1Uy1B");

var $8Dq0r = parcelRequire("8Dq0r");

var $dpAr1 = parcelRequire("dpAr1");

var $7SAxh = parcelRequire("7SAxh");

var $4aiSz = parcelRequire("4aiSz");

var $fRuVm = parcelRequire("fRuVm");

var $duMzr = parcelRequire("duMzr");

var $aUkwV = parcelRequire("aUkwV");

var $i1sNc = parcelRequire("i1sNc");

var $h7eJh = parcelRequire("h7eJh");

var $gz11x = parcelRequire("gz11x");

var $kTA61 = parcelRequire("kTA61");

});
parcelRequire.register("J24Fb", function(module, exports) {

$parcel$export(module.exports, "fetchTokenByAuthorizationCode", function () { return $0875cffaca112175$export$684f740cd70532d4; });
$parcel$export(module.exports, "fetchTokenByRefreshToken", function () { return $0875cffaca112175$export$9909137b467efb8b; });

var $feIB3 = parcelRequire("feIB3");

var $gz11x = parcelRequire("gz11x");
const $0875cffaca112175$export$684f740cd70532d4 = async ({ clientId: clientId, tokenEndpoint: tokenEndpoint, redirectUri: redirectUri, codeVerifier: codeVerifier, code: code, resource: resource }, requester)=>{
    const parameters = new URLSearchParams();
    parameters.append((0, $gz11x.QueryKey).ClientId, clientId);
    parameters.append((0, $gz11x.QueryKey).Code, code);
    parameters.append((0, $gz11x.QueryKey).CodeVerifier, codeVerifier);
    parameters.append((0, $gz11x.QueryKey).RedirectUri, redirectUri);
    parameters.append((0, $gz11x.QueryKey).GrantType, (0, $gz11x.TokenGrantType).AuthorizationCode);
    if (resource) parameters.append((0, $gz11x.QueryKey).Resource, resource);
    const snakeCaseCodeTokenResponse = await requester(tokenEndpoint, {
        method: "POST",
        headers: (0, $gz11x.ContentType).formUrlEncoded,
        body: parameters.toString()
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($feIB3)))(snakeCaseCodeTokenResponse);
};
/**
 * Fetch access token by refresh token using the token endpoint and `refresh_token` grant type.
 * @param params The parameters for fetching access token.
 * @param requester The requester for sending HTTP request.
 * @returns A Promise that resolves to the access token response.
 */ const $0875cffaca112175$export$9909137b467efb8b = async (params, requester)=>{
    const { clientId: clientId, tokenEndpoint: tokenEndpoint, refreshToken: refreshToken, resource: resource, organizationId: organizationId, scopes: scopes } = params;
    const parameters = new URLSearchParams();
    parameters.append((0, $gz11x.QueryKey).ClientId, clientId);
    parameters.append((0, $gz11x.QueryKey).RefreshToken, refreshToken);
    parameters.append((0, $gz11x.QueryKey).GrantType, (0, $gz11x.TokenGrantType).RefreshToken);
    if (resource) parameters.append((0, $gz11x.QueryKey).Resource, resource);
    if (organizationId) parameters.append((0, $gz11x.QueryKey).OrganizationId, organizationId);
    if (scopes?.length) parameters.append((0, $gz11x.QueryKey).Scope, scopes.join(" "));
    const snakeCaseRefreshTokenTokenResponse = await requester(tokenEndpoint, {
        method: "POST",
        headers: (0, $gz11x.ContentType).formUrlEncoded,
        body: parameters.toString()
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($feIB3)))(snakeCaseRefreshTokenTokenResponse);
};

});
parcelRequire.register("feIB3", function(module, exports) {
"use strict";

var $1rn4v = parcelRequire("1rn4v");

var $eqTF1 = parcelRequire("eqTF1");

var $7o0yp = parcelRequire("7o0yp");
const $b17ac1c9b12366de$var$has = (array, key)=>array.some((x)=>{
        if (typeof x === "string") return x === key;
        x.lastIndex = 0;
        return x.test(key);
    });
const $b17ac1c9b12366de$var$cache = new $7o0yp({
    maxSize: 100000
});
// Reproduces behavior from `map-obj`
const $b17ac1c9b12366de$var$isObject = (value)=>typeof value === "object" && value !== null && !(value instanceof RegExp) && !(value instanceof Error) && !(value instanceof Date);
const $b17ac1c9b12366de$var$camelCaseConvert = (input, options)=>{
    if (!$b17ac1c9b12366de$var$isObject(input)) return input;
    options = {
        deep: false,
        pascalCase: false,
        ...options
    };
    const { exclude: exclude, pascalCase: pascalCase, stopPaths: stopPaths, deep: deep } = options;
    const stopPathsSet = new Set(stopPaths);
    const makeMapper = (parentPath)=>(key, value)=>{
            if (deep && $b17ac1c9b12366de$var$isObject(value)) {
                const path = parentPath === undefined ? key : `${parentPath}.${key}`;
                if (!stopPathsSet.has(path)) value = $1rn4v(value, makeMapper(path));
            }
            if (!(exclude && $b17ac1c9b12366de$var$has(exclude, key))) {
                const cacheKey = pascalCase ? `${key}_` : key;
                if ($b17ac1c9b12366de$var$cache.has(cacheKey)) key = $b17ac1c9b12366de$var$cache.get(cacheKey);
                else {
                    const returnValue = $eqTF1(key, {
                        pascalCase: pascalCase,
                        locale: false
                    });
                    if (key.length < 100) $b17ac1c9b12366de$var$cache.set(cacheKey, returnValue);
                    key = returnValue;
                }
            }
            return [
                key,
                value
            ];
        };
    return $1rn4v(input, makeMapper(undefined));
};
module.exports = (input, options)=>{
    if (Array.isArray(input)) return Object.keys(input).map((key)=>$b17ac1c9b12366de$var$camelCaseConvert(input[key], options));
    return $b17ac1c9b12366de$var$camelCaseConvert(input, options);
};

});
parcelRequire.register("1rn4v", function(module, exports) {
"use strict";
const $10ca359e067807da$var$isObject = (value)=>typeof value === "object" && value !== null;
const $10ca359e067807da$var$mapObjectSkip = Symbol("skip");
// Customized for this use-case
const $10ca359e067807da$var$isObjectCustom = (value)=>$10ca359e067807da$var$isObject(value) && !(value instanceof RegExp) && !(value instanceof Error) && !(value instanceof Date);
const $10ca359e067807da$var$mapObject = (object, mapper, options, isSeen = new WeakMap())=>{
    options = {
        deep: false,
        target: {},
        ...options
    };
    if (isSeen.has(object)) return isSeen.get(object);
    isSeen.set(object, options.target);
    const { target: target } = options;
    delete options.target;
    const mapArray = (array)=>array.map((element)=>$10ca359e067807da$var$isObjectCustom(element) ? $10ca359e067807da$var$mapObject(element, mapper, options, isSeen) : element);
    if (Array.isArray(object)) return mapArray(object);
    for (const [key, value] of Object.entries(object)){
        const mapResult = mapper(key, value, object);
        if (mapResult === $10ca359e067807da$var$mapObjectSkip) continue;
        let [newKey, newValue, { shouldRecurse: shouldRecurse = true } = {}] = mapResult;
        // Drop `__proto__` keys.
        if (newKey === "__proto__") continue;
        if (options.deep && shouldRecurse && $10ca359e067807da$var$isObjectCustom(newValue)) newValue = Array.isArray(newValue) ? mapArray(newValue) : $10ca359e067807da$var$mapObject(newValue, mapper, options, isSeen);
        target[newKey] = newValue;
    }
    return target;
};
module.exports = (object, mapper, options)=>{
    if (!$10ca359e067807da$var$isObject(object)) throw new TypeError(`Expected an object, got \`${object}\` (${typeof object})`);
    return $10ca359e067807da$var$mapObject(object, mapper, options);
};
module.exports.mapObjectSkip = $10ca359e067807da$var$mapObjectSkip;

});

parcelRequire.register("eqTF1", function(module, exports) {
"use strict";
const $a81eab77504199ae$var$UPPERCASE = /[\p{Lu}]/u;
const $a81eab77504199ae$var$LOWERCASE = /[\p{Ll}]/u;
const $a81eab77504199ae$var$LEADING_CAPITAL = /^[\p{Lu}](?![\p{Lu}])/gu;
const $a81eab77504199ae$var$IDENTIFIER = /([\p{Alpha}\p{N}_]|$)/u;
const $a81eab77504199ae$var$SEPARATORS = /[_.\- ]+/;
const $a81eab77504199ae$var$LEADING_SEPARATORS = new RegExp("^" + $a81eab77504199ae$var$SEPARATORS.source);
const $a81eab77504199ae$var$SEPARATORS_AND_IDENTIFIER = new RegExp($a81eab77504199ae$var$SEPARATORS.source + $a81eab77504199ae$var$IDENTIFIER.source, "gu");
const $a81eab77504199ae$var$NUMBERS_AND_IDENTIFIER = new RegExp("\\d+" + $a81eab77504199ae$var$IDENTIFIER.source, "gu");
const $a81eab77504199ae$var$preserveCamelCase = (string, toLowerCase, toUpperCase)=>{
    let isLastCharLower = false;
    let isLastCharUpper = false;
    let isLastLastCharUpper = false;
    for(let i = 0; i < string.length; i++){
        const character = string[i];
        if (isLastCharLower && $a81eab77504199ae$var$UPPERCASE.test(character)) {
            string = string.slice(0, i) + "-" + string.slice(i);
            isLastCharLower = false;
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = true;
            i++;
        } else if (isLastCharUpper && isLastLastCharUpper && $a81eab77504199ae$var$LOWERCASE.test(character)) {
            string = string.slice(0, i - 1) + "-" + string.slice(i - 1);
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = false;
            isLastCharLower = true;
        } else {
            isLastCharLower = toLowerCase(character) === character && toUpperCase(character) !== character;
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = toUpperCase(character) === character && toLowerCase(character) !== character;
        }
    }
    return string;
};
const $a81eab77504199ae$var$preserveConsecutiveUppercase = (input, toLowerCase)=>{
    $a81eab77504199ae$var$LEADING_CAPITAL.lastIndex = 0;
    return input.replace($a81eab77504199ae$var$LEADING_CAPITAL, (m1)=>toLowerCase(m1));
};
const $a81eab77504199ae$var$postProcess = (input, toUpperCase)=>{
    $a81eab77504199ae$var$SEPARATORS_AND_IDENTIFIER.lastIndex = 0;
    $a81eab77504199ae$var$NUMBERS_AND_IDENTIFIER.lastIndex = 0;
    return input.replace($a81eab77504199ae$var$SEPARATORS_AND_IDENTIFIER, (_, identifier)=>toUpperCase(identifier)).replace($a81eab77504199ae$var$NUMBERS_AND_IDENTIFIER, (m)=>toUpperCase(m));
};
const $a81eab77504199ae$var$camelCase = (input, options)=>{
    if (!(typeof input === "string" || Array.isArray(input))) throw new TypeError("Expected the input to be `string | string[]`");
    options = {
        pascalCase: false,
        preserveConsecutiveUppercase: false,
        ...options
    };
    if (Array.isArray(input)) input = input.map((x)=>x.trim()).filter((x)=>x.length).join("-");
    else input = input.trim();
    if (input.length === 0) return "";
    const toLowerCase = options.locale === false ? (string)=>string.toLowerCase() : (string)=>string.toLocaleLowerCase(options.locale);
    const toUpperCase = options.locale === false ? (string)=>string.toUpperCase() : (string)=>string.toLocaleUpperCase(options.locale);
    if (input.length === 1) return options.pascalCase ? toUpperCase(input) : toLowerCase(input);
    const hasUpperCase = input !== toLowerCase(input);
    if (hasUpperCase) input = $a81eab77504199ae$var$preserveCamelCase(input, toLowerCase, toUpperCase);
    input = input.replace($a81eab77504199ae$var$LEADING_SEPARATORS, "");
    if (options.preserveConsecutiveUppercase) input = $a81eab77504199ae$var$preserveConsecutiveUppercase(input, toLowerCase);
    else input = toLowerCase(input);
    if (options.pascalCase) input = toUpperCase(input.charAt(0)) + input.slice(1);
    return $a81eab77504199ae$var$postProcess(input, toUpperCase);
};
module.exports = $a81eab77504199ae$var$camelCase;
// TODO: Remove this for the next major release
module.exports.default = $a81eab77504199ae$var$camelCase;

});

parcelRequire.register("7o0yp", function(module, exports) {
"use strict";
class $560b3453f528f791$var$QuickLRU {
    constructor(options = {}){
        if (!(options.maxSize && options.maxSize > 0)) throw new TypeError("`maxSize` must be a number greater than 0");
        this.maxSize = options.maxSize;
        this.onEviction = options.onEviction;
        this.cache = new Map();
        this.oldCache = new Map();
        this._size = 0;
    }
    _set(key, value) {
        this.cache.set(key, value);
        this._size++;
        if (this._size >= this.maxSize) {
            this._size = 0;
            if (typeof this.onEviction === "function") for (const [key, value] of this.oldCache.entries())this.onEviction(key, value);
            this.oldCache = this.cache;
            this.cache = new Map();
        }
    }
    get(key) {
        if (this.cache.has(key)) return this.cache.get(key);
        if (this.oldCache.has(key)) {
            const value = this.oldCache.get(key);
            this.oldCache.delete(key);
            this._set(key, value);
            return value;
        }
    }
    set(key, value) {
        if (this.cache.has(key)) this.cache.set(key, value);
        else this._set(key, value);
        return this;
    }
    has(key) {
        return this.cache.has(key) || this.oldCache.has(key);
    }
    peek(key) {
        if (this.cache.has(key)) return this.cache.get(key);
        if (this.oldCache.has(key)) return this.oldCache.get(key);
    }
    delete(key) {
        const deleted = this.cache.delete(key);
        if (deleted) this._size--;
        return this.oldCache.delete(key) || deleted;
    }
    clear() {
        this.cache.clear();
        this.oldCache.clear();
        this._size = 0;
    }
    *keys() {
        for (const [key] of this)yield key;
    }
    *values() {
        for (const [, value] of this)yield value;
    }
    *[Symbol.iterator]() {
        for (const item of this.cache)yield item;
        for (const item of this.oldCache){
            const [key] = item;
            if (!this.cache.has(key)) yield item;
        }
    }
    get size() {
        let oldCacheSize = 0;
        for (const key of this.oldCache.keys())if (!this.cache.has(key)) oldCacheSize++;
        return Math.min(this._size + oldCacheSize, this.maxSize);
    }
}
module.exports = $560b3453f528f791$var$QuickLRU;

});


parcelRequire.register("gz11x", function(module, exports) {

$parcel$export(module.exports, "ContentType", function () { return $c0f0b583a11fcbe2$export$e2e108cbe2e4f865; });
$parcel$export(module.exports, "TokenGrantType", function () { return $c0f0b583a11fcbe2$export$3f2aafdd1ccae76c; });
$parcel$export(module.exports, "QueryKey", function () { return $c0f0b583a11fcbe2$export$65f63a8bc3cba53d; });
$parcel$export(module.exports, "Prompt", function () { return $c0f0b583a11fcbe2$export$83716a4aa1642908; });

var $kTA61 = parcelRequire("kTA61");
const $c0f0b583a11fcbe2$export$e2e108cbe2e4f865 = {
    formUrlEncoded: {
        "Content-Type": "application/x-www-form-urlencoded"
    }
};
var $c0f0b583a11fcbe2$export$3f2aafdd1ccae76c;
(function(TokenGrantType) {
    TokenGrantType["AuthorizationCode"] = "authorization_code";
    TokenGrantType["RefreshToken"] = "refresh_token";
})($c0f0b583a11fcbe2$export$3f2aafdd1ccae76c || ($c0f0b583a11fcbe2$export$3f2aafdd1ccae76c = {}));
var $c0f0b583a11fcbe2$export$65f63a8bc3cba53d;
(function(QueryKey) {
    QueryKey["ClientId"] = "client_id";
    QueryKey["Code"] = "code";
    QueryKey["CodeChallenge"] = "code_challenge";
    QueryKey["CodeChallengeMethod"] = "code_challenge_method";
    QueryKey["CodeVerifier"] = "code_verifier";
    QueryKey["Error"] = "error";
    QueryKey["ErrorDescription"] = "error_description";
    QueryKey["GrantType"] = "grant_type";
    QueryKey["IdToken"] = "id_token";
    QueryKey["IdTokenHint"] = "id_token_hint";
    QueryKey["LoginHint"] = "login_hint";
    QueryKey["PostLogoutRedirectUri"] = "post_logout_redirect_uri";
    QueryKey["Prompt"] = "prompt";
    QueryKey["RedirectUri"] = "redirect_uri";
    QueryKey["RefreshToken"] = "refresh_token";
    QueryKey["Resource"] = "resource";
    QueryKey["ResponseType"] = "response_type";
    QueryKey["Scope"] = "scope";
    QueryKey["State"] = "state";
    QueryKey["Token"] = "token";
    // Need to align with the OIDC extraParams settings in core
    QueryKey["InteractionMode"] = "interaction_mode";
    /** The query key for specifying the organization ID. */ QueryKey["OrganizationId"] = "organization_id";
    QueryKey["FirstScreen"] = "first_screen";
    QueryKey["DirectSignIn"] = "direct_sign_in";
})($c0f0b583a11fcbe2$export$65f63a8bc3cba53d || ($c0f0b583a11fcbe2$export$65f63a8bc3cba53d = {}));
/** The prompt parameter to be used for the authorization request. */ var $c0f0b583a11fcbe2$export$83716a4aa1642908;
(function(Prompt) {
    Prompt["None"] = "none";
    /**
     * The Authorization Server MUST prompt the End-User for consent
     * before returning information to the Client.
     */ Prompt["Consent"] = "consent";
    /**
     * The Authorization Server MUST prompt the End-User for re-authentication,
     * forcing the user to log in again. Note the there'll be no Refresh Token
     * returned in this case.
     */ Prompt["Login"] = "login";
})($c0f0b583a11fcbe2$export$83716a4aa1642908 || ($c0f0b583a11fcbe2$export$83716a4aa1642908 = {}));

});
parcelRequire.register("kTA61", function(module, exports) {

$parcel$export(module.exports, "ReservedScope", function () { return $f364f1a716a006bc$export$1d2e82cebfd4b08; });
$parcel$export(module.exports, "ReservedResource", function () { return $f364f1a716a006bc$export$36ba08a8e14b2df6; });
$parcel$export(module.exports, "UserScope", function () { return $f364f1a716a006bc$export$4b02c5b431f6eb78; });
/**
 * @overview Constants for Logto. Synchronized with `@logto/core-kit` package at hash `081094d`.
 */ /** Scopes that reserved by Logto, which will be added to the auth request automatically. */ var $f364f1a716a006bc$export$1d2e82cebfd4b08;
(function(ReservedScope) {
    ReservedScope["OpenId"] = "openid";
    ReservedScope["OfflineAccess"] = "offline_access";
})($f364f1a716a006bc$export$1d2e82cebfd4b08 || ($f364f1a716a006bc$export$1d2e82cebfd4b08 = {}));
/** Resources that reserved by Logto, which cannot be defined by users. */ var $f364f1a716a006bc$export$36ba08a8e14b2df6;
(function(ReservedResource) {
    /**
     * The resource for organization template per RFC 0001.
     *
     * @see {@link https://github.com/logto-io/rfcs | RFC 0001} for more details.
     */ ReservedResource["Organization"] = "urn:logto:resource:organizations";
})($f364f1a716a006bc$export$36ba08a8e14b2df6 || ($f364f1a716a006bc$export$36ba08a8e14b2df6 = {}));
/**
 * Scopes for ID Token and Userinfo Endpoint.
 */ var $f364f1a716a006bc$export$4b02c5b431f6eb78;
(function(UserScope) {
    /**
     * Scope for basic user info.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Profile"] = "profile";
    /**
     * Scope for user email address.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Email"] = "email";
    /**
     * Scope for user phone number.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Phone"] = "phone";
    /**
     * Scope for user's custom data.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["CustomData"] = "custom_data";
    /**
     * Scope for user's social identity details.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Identities"] = "identities";
    /**
     * Scope for user's roles.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Roles"] = "roles";
    /**
     * Scope for user's organization IDs and perform organization token grant per [RFC 0001](https://github.com/logto-io/rfcs).
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Organizations"] = "urn:logto:scope:organizations";
    /**
     * Scope for user's organization roles per [RFC 0001](https://github.com/logto-io/rfcs).
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["OrganizationRoles"] = "urn:logto:scope:organization_roles";
})($f364f1a716a006bc$export$4b02c5b431f6eb78 || ($f364f1a716a006bc$export$4b02c5b431f6eb78 = {}));
/**
 * Mapped claims that ID Token includes.
 */ const $f364f1a716a006bc$export$f57bb8dda2a18319 = Object.freeze({
    [$f364f1a716a006bc$export$4b02c5b431f6eb78.Profile]: [
        "name",
        "picture",
        "username"
    ],
    [$f364f1a716a006bc$export$4b02c5b431f6eb78.Email]: [
        "email",
        "email_verified"
    ],
    [$f364f1a716a006bc$export$4b02c5b431f6eb78.Phone]: [
        "phone_number",
        "phone_number_verified"
    ],
    [$f364f1a716a006bc$export$4b02c5b431f6eb78.Roles]: [
        "roles"
    ],
    [$f364f1a716a006bc$export$4b02c5b431f6eb78.Organizations]: [
        "organizations"
    ],
    [$f364f1a716a006bc$export$4b02c5b431f6eb78.OrganizationRoles]: [
        "organization_roles"
    ],
    [$f364f1a716a006bc$export$4b02c5b431f6eb78.CustomData]: [],
    [$f364f1a716a006bc$export$4b02c5b431f6eb78.Identities]: []
});
/**
 * Additional claims that Userinfo Endpoint returns.
 */ const $f364f1a716a006bc$export$c11d5a3385aa71dd = Object.freeze({
    [$f364f1a716a006bc$export$4b02c5b431f6eb78.Profile]: [],
    [$f364f1a716a006bc$export$4b02c5b431f6eb78.Email]: [],
    [$f364f1a716a006bc$export$4b02c5b431f6eb78.Phone]: [],
    [$f364f1a716a006bc$export$4b02c5b431f6eb78.Roles]: [],
    [$f364f1a716a006bc$export$4b02c5b431f6eb78.Organizations]: [],
    [$f364f1a716a006bc$export$4b02c5b431f6eb78.OrganizationRoles]: [],
    [$f364f1a716a006bc$export$4b02c5b431f6eb78.CustomData]: [
        "custom_data"
    ],
    [$f364f1a716a006bc$export$4b02c5b431f6eb78.Identities]: [
        "identities"
    ]
});
const $f364f1a716a006bc$export$6c46daeabb0176f9 = Object.freeze(// Hard to infer type directly, use `as` for a workaround.
// eslint-disable-next-line no-restricted-syntax
Object.fromEntries(Object.values($f364f1a716a006bc$export$4b02c5b431f6eb78).map((current)=>[
        current,
        [
            ...$f364f1a716a006bc$export$f57bb8dda2a18319[current],
            ...$f364f1a716a006bc$export$c11d5a3385aa71dd[current]
        ]
    ])));
/**
 * The prefix of the URN (Uniform Resource Name) for the organization in Logto.
 *
 * @example
 * ```
 * urn:logto:organization:123 // organization with ID 123
 * ```
 * @see {@link https://en.wikipedia.org/wiki/Uniform_Resource_Name | Uniform Resource Name}
 */ const $f364f1a716a006bc$export$fc38cc6da79faa5c = "urn:logto:organization:";
/**
 * Build the URN (Uniform Resource Name) for the organization in Logto.
 *
 * @param organizationId The ID of the organization.
 * @returns The URN for the organization.
 * @see {@link organizationUrnPrefix} for the prefix of the URN.
 * @example
 * ```ts
 * buildOrganizationUrn('1') // returns 'urn:logto:organization:1'
 * ```
 */ const $f364f1a716a006bc$export$22667c0b6b2d7fac = (organizationId)=>`${$f364f1a716a006bc$export$fc38cc6da79faa5c}${organizationId}`;
/**
 * Get the organization ID from the URN (Uniform Resource Name) for the organization in Logto.
 *
 * @param urn The URN for the organization. Must start with {@link organizationUrnPrefix}.
 * @returns The ID of the organization.
 * @throws {TypeError} If the URN is invalid.
 * @example
 * ```ts
 * getOrganizationIdFromUrn('1') // throws TypeError
 * getOrganizationIdFromUrn('urn:logto:organization:1') // returns '1'
 * ```
 */ const $f364f1a716a006bc$export$a237ae1b02e4e718 = (urn)=>{
    if (!urn.startsWith($f364f1a716a006bc$export$fc38cc6da79faa5c)) throw new TypeError("Invalid organization URN.");
    return urn.slice($f364f1a716a006bc$export$fc38cc6da79faa5c.length);
};

});



parcelRequire.register("fNnrz", function(module, exports) {

$parcel$export(module.exports, "discoveryPath", function () { return $b7fd9e10eff1ce2f$export$815bda5ead26b243; });
$parcel$export(module.exports, "fetchOidcConfig", function () { return $b7fd9e10eff1ce2f$export$98242d8e822ad11f; });

var $feIB3 = parcelRequire("feIB3");
const $b7fd9e10eff1ce2f$export$815bda5ead26b243 = "/oidc/.well-known/openid-configuration";
const $b7fd9e10eff1ce2f$export$98242d8e822ad11f = async (endpoint, requester)=>(0, (/*@__PURE__*/$parcel$interopDefault($feIB3)))(await requester(endpoint));

});

parcelRequire.register("8yRDe", function(module, exports) {

$parcel$export(module.exports, "revoke", function () { return $63bb19d917de26d7$export$573f8dbbf6fbef75; });

var $gz11x = parcelRequire("gz11x");
const $63bb19d917de26d7$export$573f8dbbf6fbef75 = async (revocationEndpoint, clientId, token, requester)=>requester(revocationEndpoint, {
        method: "POST",
        headers: (0, $gz11x.ContentType).formUrlEncoded,
        body: new URLSearchParams({
            [(0, $gz11x.QueryKey).ClientId]: clientId,
            [(0, $gz11x.QueryKey).Token]: token
        }).toString()
    });

});

parcelRequire.register("1Uy1B", function(module, exports) {

$parcel$export(module.exports, "generateSignInUri", function () { return $16456a0bdf694268$export$b01a187f12b774c6; });

var $gz11x = parcelRequire("gz11x");

var $aUkwV = parcelRequire("aUkwV");
const $16456a0bdf694268$var$codeChallengeMethod = "S256";
const $16456a0bdf694268$var$responseType = "code";
const $16456a0bdf694268$var$buildPrompt = (prompt)=>{
    if (Array.isArray(prompt)) return prompt.join(" ");
    return prompt ?? (0, $gz11x.Prompt).Consent;
};
const $16456a0bdf694268$export$b01a187f12b774c6 = ({ authorizationEndpoint: authorizationEndpoint, clientId: clientId, redirectUri: redirectUri, codeChallenge: codeChallenge, state: state, scopes: scopes, resources: resources, prompt: prompt, firstScreen: firstScreen, interactionMode: interactionMode, loginHint: loginHint, directSignIn: directSignIn, extraParams: extraParams })=>{
    const urlSearchParameters = new URLSearchParams({
        [(0, $gz11x.QueryKey).ClientId]: clientId,
        [(0, $gz11x.QueryKey).RedirectUri]: redirectUri,
        [(0, $gz11x.QueryKey).CodeChallenge]: codeChallenge,
        [(0, $gz11x.QueryKey).CodeChallengeMethod]: $16456a0bdf694268$var$codeChallengeMethod,
        [(0, $gz11x.QueryKey).State]: state,
        [(0, $gz11x.QueryKey).ResponseType]: $16456a0bdf694268$var$responseType,
        [(0, $gz11x.QueryKey).Prompt]: $16456a0bdf694268$var$buildPrompt(prompt),
        [(0, $gz11x.QueryKey).Scope]: (0, $aUkwV.withDefaultScopes)(scopes),
        ...extraParams
    });
    if (loginHint) urlSearchParameters.append((0, $gz11x.QueryKey).LoginHint, loginHint);
    if (directSignIn) urlSearchParameters.append((0, $gz11x.QueryKey).DirectSignIn, `${directSignIn.method}:${directSignIn.target}`);
    for (const resource of resources ?? [])urlSearchParameters.append((0, $gz11x.QueryKey).Resource, resource);
    if (firstScreen) urlSearchParameters.append((0, $gz11x.QueryKey).FirstScreen, firstScreen);
    else if (interactionMode) urlSearchParameters.append((0, $gz11x.QueryKey).InteractionMode, interactionMode);
    return `${authorizationEndpoint}?${urlSearchParameters.toString()}`;
};

});
parcelRequire.register("aUkwV", function(module, exports) {

$parcel$export(module.exports, "withDefaultScopes", function () { return $7f0f0f2a6ce7ce80$export$3cf0748e30b766d7; });
parcelRequire("gz11x");

var $kTA61 = parcelRequire("kTA61");
/**
 * @param originalScopes
 * @return scopes should contain all default scopes (`openid`, `offline_access` and `profile`)
 */ const $7f0f0f2a6ce7ce80$export$3cf0748e30b766d7 = (originalScopes)=>{
    const reservedScopes = Object.values((0, $kTA61.ReservedScope));
    const uniqueScopes = new Set([
        ...reservedScopes,
        (0, $kTA61.UserScope).Profile,
        ...originalScopes ?? []
    ]);
    return Array.from(uniqueScopes).join(" ");
};

});


parcelRequire.register("8Dq0r", function(module, exports) {

$parcel$export(module.exports, "generateSignOutUri", function () { return $64962387d694d535$export$b3c9a2bd2330de28; });

var $gz11x = parcelRequire("gz11x");
const $64962387d694d535$export$b3c9a2bd2330de28 = ({ endSessionEndpoint: endSessionEndpoint, clientId: clientId, postLogoutRedirectUri: postLogoutRedirectUri })=>{
    const urlSearchParameters = new URLSearchParams({
        [(0, $gz11x.QueryKey).ClientId]: clientId
    });
    if (postLogoutRedirectUri) urlSearchParameters.append((0, $gz11x.QueryKey).PostLogoutRedirectUri, postLogoutRedirectUri);
    return `${endSessionEndpoint}?${urlSearchParameters.toString()}`;
};

});

parcelRequire.register("dpAr1", function(module, exports) {

$parcel$export(module.exports, "fetchUserInfo", function () { return $9c39df5c24eb55ad$export$eee09f98e5b044aa; });
const $9c39df5c24eb55ad$export$eee09f98e5b044aa = async (userInfoEndpoint, accessToken, requester)=>requester(userInfoEndpoint, {
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    });

});

parcelRequire.register("7SAxh", function(module, exports) {

$parcel$export(module.exports, "verifyAndParseCodeFromCallbackUri", function () { return $5bc9eac977f7a2ae$export$dc3fae3c99763885; });
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $gz11x = parcelRequire("gz11x");

var $4aiSz = parcelRequire("4aiSz");
const $5bc9eac977f7a2ae$export$4851e69315d5b72c = (uri)=>{
    const [, queryString = ""] = uri.split("?");
    return new URLSearchParams(queryString);
};
const $5bc9eac977f7a2ae$export$dc3fae3c99763885 = (callbackUri, redirectUri, state)=>{
    if (!callbackUri.startsWith(redirectUri)) throw new (0, $4aiSz.LogtoError)("callback_uri_verification.redirect_uri_mismatched");
    const uriParameters = $5bc9eac977f7a2ae$export$4851e69315d5b72c(callbackUri);
    const error = (0, $7oDSS.conditional)(uriParameters.get((0, $gz11x.QueryKey).Error));
    const errorDescription = (0, $7oDSS.conditional)(uriParameters.get((0, $gz11x.QueryKey).ErrorDescription));
    if (error) throw new (0, $4aiSz.LogtoError)("callback_uri_verification.error_found", new (0, $4aiSz.OidcError)(error, errorDescription));
    const stateFromCallbackUri = uriParameters.get((0, $gz11x.QueryKey).State);
    if (!stateFromCallbackUri) throw new (0, $4aiSz.LogtoError)("callback_uri_verification.missing_state");
    if (stateFromCallbackUri !== state) throw new (0, $4aiSz.LogtoError)("callback_uri_verification.state_mismatched");
    const code = uriParameters.get((0, $gz11x.QueryKey).Code);
    if (!code) throw new (0, $4aiSz.LogtoError)("callback_uri_verification.missing_code");
    return code;
};

});
parcelRequire.register("4aiSz", function(module, exports) {

$parcel$export(module.exports, "LogtoError", function () { return $3086bd9e0ead8b18$export$ba60d77e6748b659; });
$parcel$export(module.exports, "isLogtoRequestError", function () { return $3086bd9e0ead8b18$export$27f79c8238476d38; });
$parcel$export(module.exports, "LogtoRequestError", function () { return $3086bd9e0ead8b18$export$e6e15b8ba42b9b70; });
$parcel$export(module.exports, "OidcError", function () { return $3086bd9e0ead8b18$export$d4832bcf9ce430e0; });

var $i1sNc = parcelRequire("i1sNc");
const $3086bd9e0ead8b18$var$logtoErrorCodes = Object.freeze({
    "id_token.invalid_iat": "Invalid issued at time in the ID token",
    "id_token.invalid_token": "Invalid ID token",
    "callback_uri_verification.redirect_uri_mismatched": "The callback URI mismatches the redirect URI.",
    "callback_uri_verification.error_found": "Error found in the callback URI",
    "callback_uri_verification.missing_state": "Missing state in the callback URI",
    "callback_uri_verification.state_mismatched": "State mismatched in the callback URI",
    "callback_uri_verification.missing_code": "Missing code in the callback URI",
    crypto_subtle_unavailable: "Crypto.subtle is unavailable in insecure contexts (non-HTTPS).",
    unexpected_response_error: "Unexpected response error from the server."
});
class $3086bd9e0ead8b18$export$ba60d77e6748b659 extends Error {
    constructor(code, data){
        super($3086bd9e0ead8b18$var$logtoErrorCodes[code]);
        this.code = code;
        this.data = data;
    }
}
const $3086bd9e0ead8b18$export$27f79c8238476d38 = (data)=>{
    if (!(0, $i1sNc.isArbitraryObject)(data)) return false;
    return typeof data.code === "string" && typeof data.message === "string";
};
class $3086bd9e0ead8b18$export$e6e15b8ba42b9b70 extends Error {
    constructor(code, message){
        super(message);
        this.code = code;
    }
}
class $3086bd9e0ead8b18$export$d4832bcf9ce430e0 {
    constructor(error, errorDescription){
        this.error = error;
        this.errorDescription = errorDescription;
    }
}

});
parcelRequire.register("i1sNc", function(module, exports) {

$parcel$export(module.exports, "isArbitraryObject", function () { return $d1eea79bbf771328$export$aa016a295c6092c8; });
const $d1eea79bbf771328$export$aa016a295c6092c8 = (data)=>typeof data === "object" && data !== null;

});



parcelRequire.register("fRuVm", function(module, exports) {

$parcel$export(module.exports, "decodeIdToken", function () { return $b8c3cb294dfb8eea$export$aac2d5b7f5cd16d5; });
parcelRequire("12bMu");
var $l0I3U = parcelRequire("l0I3U");

var $i1sNc = parcelRequire("i1sNc");

var $4aiSz = parcelRequire("4aiSz");
/* eslint-disable complexity */ /**
 * @link [ID Token](https://openid.net/specs/openid-connect-core-1_0.html#IDToken)
 */ function $b8c3cb294dfb8eea$var$assertIdTokenClaims(data) {
    if (!(0, $i1sNc.isArbitraryObject)(data)) throw new TypeError("IdToken is expected to be an object");
    for (const key of [
        "iss",
        "sub",
        "aud"
    ]){
        if (typeof data[key] !== "string") throw new TypeError(`At path: IdToken.${key}: expected a string`);
    }
    for (const key of [
        "exp",
        "iat"
    ]){
        if (typeof data[key] !== "number") throw new TypeError(`At path: IdToken.${key}: expected a number`);
    }
    for (const key of [
        "at_hash",
        "name",
        "username",
        "picture",
        "email",
        "phone_number"
    ]){
        if (data[key] === undefined) continue;
        if (typeof data[key] !== "string" && data[key] !== null) throw new TypeError(`At path: IdToken.${key}: expected null or a string`);
    }
    for (const key of [
        "email_verified",
        "phone_number_verified"
    ]){
        if (data[key] === undefined) continue;
        if (typeof data[key] !== "boolean") throw new TypeError(`At path: IdToken.${key}: expected a boolean`);
    }
}
/* eslint-enable complexity */ const $b8c3cb294dfb8eea$export$aac2d5b7f5cd16d5 = (token)=>{
    const { 1: encodedPayload } = token.split(".");
    if (!encodedPayload) throw new (0, $4aiSz.LogtoError)("id_token.invalid_token");
    const json = (0, $l0I3U.urlSafeBase64).decode(encodedPayload);
    const idTokenClaims = JSON.parse(json);
    $b8c3cb294dfb8eea$var$assertIdTokenClaims(idTokenClaims);
    return idTokenClaims;
};

});

parcelRequire.register("duMzr", function(module, exports) {

$parcel$export(module.exports, "decodeAccessToken", function () { return $9d33c0d270782763$export$1b57a6e65b75f5b3; });
parcelRequire("12bMu");
var $l0I3U = parcelRequire("l0I3U");

var $i1sNc = parcelRequire("i1sNc");
// https://docs.logto.io/docs/recipes/protect-your-api/
function $9d33c0d270782763$var$assertAccessTokenClaims(data) {
    if (!(0, $i1sNc.isArbitraryObject)(data)) throw new TypeError("AccessToken is expected to be an object");
    for (const key of [
        "jti",
        "iss",
        "sub",
        "aud",
        "client_id",
        "scope"
    ]){
        if (data[key] === undefined) continue;
        if (typeof data[key] !== "string" && data[key] !== null) throw new TypeError(`At path: AccessToken.${key}: expected null or a string`);
    }
    for (const key of [
        "exp",
        "iat"
    ]){
        if (data[key] === undefined) continue;
        if (typeof data[key] !== "number" && data[key] !== null) throw new TypeError(`At path: AccessToken.${key}: expected null or a number`);
    }
}
const $9d33c0d270782763$export$1b57a6e65b75f5b3 = (accessToken)=>{
    const { 1: encodedPayload } = accessToken.split(".");
    if (!encodedPayload) // Non-JWT format token string
    return {};
    const json = (0, $l0I3U.urlSafeBase64).decode(encodedPayload);
    const accessTokenClaims = JSON.parse(json);
    $9d33c0d270782763$var$assertAccessTokenClaims(accessTokenClaims);
    return accessTokenClaims;
};

});

parcelRequire.register("h7eJh", function(module, exports) {

var $gz11x = parcelRequire("gz11x");

var $aUkwV = parcelRequire("aUkwV");
/**
 * A helper function to build the OpenID Connect configuration for `angular-auth-oidc-client`
 * using a Logto-friendly way.
 *
 * @example
 * ```ts
 * // A minimal example
 * import { buildAngularAuthConfig } from '@logto/js';
 * import { provideAuth } from 'angular-auth-oidc-client';
 *
 * provideAuth({
 *   config: buildAngularAuthConfig({
 *     endpoint: '<your-logto-endpoint>',
 *     appId: '<your-app-id>',
 *     redirectUri: '<your-app-redirect-uri>',
 *   }),
 * });
 * ```
 *
 * @param logtoConfig The Logto configuration object for Angular apps.
 * @returns The OpenID Connect configuration for `angular-auth-oidc-client`.
 * @see {@link https://angular-auth-oidc-client.com/ | angular-auth-oidc-client} to learn more
 * about how to use the library.
 */ const $c75e840a1f349e9b$export$a2c5e6fd3c78a908 = (logtoConfig)=>{
    const { endpoint: endpoint, appId: clientId, scopes: scopes, resource: resource, redirectUri: redirectUrl, postLogoutRedirectUri: postLogoutRedirectUri, prompt: prompt = (0, $gz11x.Prompt).Consent } = logtoConfig;
    const scope = (0, $aUkwV.withDefaultScopes)(scopes);
    const customParameters = resource ? {
        resource: resource
    } : undefined;
    return {
        authority: new URL("/oidc", endpoint).href,
        redirectUrl: redirectUrl,
        postLogoutRedirectUri: postLogoutRedirectUri,
        clientId: clientId,
        scope: scope,
        responseType: "code",
        autoUserInfo: !resource,
        renewUserInfoAfterTokenRenew: !resource,
        silentRenew: true,
        useRefreshToken: true,
        customParamsAuthRequest: {
            prompt: Array.isArray(prompt) ? prompt.join(" ") : prompt,
            ...customParameters
        },
        customParamsCodeRequest: {
            ...customParameters
        },
        customParamsRefreshTokenRequest: {
            ...customParameters
        }
    };
};

});


parcelRequire.register("bocSp", function(module, exports) {

$parcel$export(module.exports, "jwtVerify", function () { return (parcelRequire("lR5W2")).jwtVerify; });
$parcel$export(module.exports, "createRemoteJWKSet", function () { return (parcelRequire("3PpsA")).createRemoteJWKSet; });

var $aQEEt = parcelRequire("aQEEt");

var $c4eVB = parcelRequire("c4eVB");

var $dOOtZ = parcelRequire("dOOtZ");

var $jaCiA = parcelRequire("jaCiA");

var $hxEit = parcelRequire("hxEit");

var $lrQ5y = parcelRequire("lrQ5y");

var $kvA38 = parcelRequire("kvA38");

var $lR5W2 = parcelRequire("lR5W2");

var $gp22Y = parcelRequire("gp22Y");

var $12qCl = parcelRequire("12qCl");

var $aG3Rw = parcelRequire("aG3Rw");

var $el7ed = parcelRequire("el7ed");

var $eg8KM = parcelRequire("eg8KM");

var $cPuou = parcelRequire("cPuou");

var $pUOMv = parcelRequire("pUOMv");

var $d0MOL = parcelRequire("d0MOL");

var $gXdx3 = parcelRequire("gXdx3");

var $kETdY = parcelRequire("kETdY");

var $hqEAs = parcelRequire("hqEAs");

var $3PpsA = parcelRequire("3PpsA");

var $8kyC5 = parcelRequire("8kyC5");

var $li5Rd = parcelRequire("li5Rd");

var $i50Kz = parcelRequire("i50Kz");

var $4SnOC = parcelRequire("4SnOC");

var $5tHmH = parcelRequire("5tHmH");

var $22n7Y = parcelRequire("22n7Y");

var $8J4Vs = parcelRequire("8J4Vs");

var $3iNLm = parcelRequire("3iNLm");

var $dG95M = parcelRequire("dG95M");

var $gbzgj = parcelRequire("gbzgj");

});
parcelRequire.register("aQEEt", function(module, exports) {

$parcel$export(module.exports, "compactDecrypt", function () { return $7e5e4b4a2cbdde3c$export$c9a8efe6bfd872ce; });

var $c4eVB = parcelRequire("c4eVB");

var $22n7Y = parcelRequire("22n7Y");

var $hBRjO = parcelRequire("hBRjO");
async function $7e5e4b4a2cbdde3c$export$c9a8efe6bfd872ce(jwe, key, options) {
    if (jwe instanceof Uint8Array) jwe = (0, $hBRjO.decoder).decode(jwe);
    if (typeof jwe !== "string") throw new (0, $22n7Y.JWEInvalid)("Compact JWE must be a string or Uint8Array");
    const { 0: protectedHeader, 1: encryptedKey, 2: iv, 3: ciphertext, 4: tag, length: length } = jwe.split(".");
    if (length !== 5) throw new (0, $22n7Y.JWEInvalid)("Invalid Compact JWE");
    const decrypted = await (0, $c4eVB.flattenedDecrypt)({
        ciphertext: ciphertext,
        iv: iv || undefined,
        protected: protectedHeader,
        tag: tag || undefined,
        encrypted_key: encryptedKey || undefined
    }, key, options);
    const result = {
        plaintext: decrypted.plaintext,
        protectedHeader: decrypted.protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: decrypted.key
    };
    return result;
}

});
parcelRequire.register("c4eVB", function(module, exports) {

$parcel$export(module.exports, "flattenedDecrypt", function () { return $8c917029b70769e6$export$b75cd12892ae94d2; });

var $gQjU9 = parcelRequire("gQjU9");

var $1bzHM = parcelRequire("1bzHM");

var $22n7Y = parcelRequire("22n7Y");

var $6jtNr = parcelRequire("6jtNr");

var $36w7K = parcelRequire("36w7K");

var $6Ol6n = parcelRequire("6Ol6n");

var $hBRjO = parcelRequire("hBRjO");

var $aAX83 = parcelRequire("aAX83");

var $jtVF0 = parcelRequire("jtVF0");

var $huFnR = parcelRequire("huFnR");
async function $8c917029b70769e6$export$b75cd12892ae94d2(jwe, key, options) {
    if (!(0, $36w7K.default)(jwe)) throw new (0, $22n7Y.JWEInvalid)("Flattened JWE must be an object");
    if (jwe.protected === undefined && jwe.header === undefined && jwe.unprotected === undefined) throw new (0, $22n7Y.JWEInvalid)("JOSE Header missing");
    if (jwe.iv !== undefined && typeof jwe.iv !== "string") throw new (0, $22n7Y.JWEInvalid)("JWE Initialization Vector incorrect type");
    if (typeof jwe.ciphertext !== "string") throw new (0, $22n7Y.JWEInvalid)("JWE Ciphertext missing or incorrect type");
    if (jwe.tag !== undefined && typeof jwe.tag !== "string") throw new (0, $22n7Y.JWEInvalid)("JWE Authentication Tag incorrect type");
    if (jwe.protected !== undefined && typeof jwe.protected !== "string") throw new (0, $22n7Y.JWEInvalid)("JWE Protected Header incorrect type");
    if (jwe.encrypted_key !== undefined && typeof jwe.encrypted_key !== "string") throw new (0, $22n7Y.JWEInvalid)("JWE Encrypted Key incorrect type");
    if (jwe.aad !== undefined && typeof jwe.aad !== "string") throw new (0, $22n7Y.JWEInvalid)("JWE AAD incorrect type");
    if (jwe.header !== undefined && !(0, $36w7K.default)(jwe.header)) throw new (0, $22n7Y.JWEInvalid)("JWE Shared Unprotected Header incorrect type");
    if (jwe.unprotected !== undefined && !(0, $36w7K.default)(jwe.unprotected)) throw new (0, $22n7Y.JWEInvalid)("JWE Per-Recipient Unprotected Header incorrect type");
    let parsedProt;
    if (jwe.protected) try {
        const protectedHeader = (0, $gQjU9.decode)(jwe.protected);
        parsedProt = JSON.parse((0, $hBRjO.decoder).decode(protectedHeader));
    } catch  {
        throw new (0, $22n7Y.JWEInvalid)("JWE Protected Header is invalid");
    }
    if (!(0, $6jtNr.default)(parsedProt, jwe.header, jwe.unprotected)) throw new (0, $22n7Y.JWEInvalid)("JWE Protected, JWE Unprotected Header, and JWE Per-Recipient Unprotected Header Parameter names must be disjoint");
    const joseHeader = {
        ...parsedProt,
        ...jwe.header,
        ...jwe.unprotected
    };
    (0, $jtVF0.default)((0, $22n7Y.JWEInvalid), new Map(), options?.crit, parsedProt, joseHeader);
    if (joseHeader.zip !== undefined) throw new (0, $22n7Y.JOSENotSupported)('JWE "zip" (Compression Algorithm) Header Parameter is not supported.');
    const { alg: alg, enc: enc } = joseHeader;
    if (typeof alg !== "string" || !alg) throw new (0, $22n7Y.JWEInvalid)("missing JWE Algorithm (alg) in JWE Header");
    if (typeof enc !== "string" || !enc) throw new (0, $22n7Y.JWEInvalid)("missing JWE Encryption Algorithm (enc) in JWE Header");
    const keyManagementAlgorithms = options && (0, $huFnR.default)("keyManagementAlgorithms", options.keyManagementAlgorithms);
    const contentEncryptionAlgorithms = options && (0, $huFnR.default)("contentEncryptionAlgorithms", options.contentEncryptionAlgorithms);
    if (keyManagementAlgorithms && !keyManagementAlgorithms.has(alg) || !keyManagementAlgorithms && alg.startsWith("PBES2")) throw new (0, $22n7Y.JOSEAlgNotAllowed)('"alg" (Algorithm) Header Parameter value not allowed');
    if (contentEncryptionAlgorithms && !contentEncryptionAlgorithms.has(enc)) throw new (0, $22n7Y.JOSEAlgNotAllowed)('"enc" (Encryption Algorithm) Header Parameter value not allowed');
    let encryptedKey;
    if (jwe.encrypted_key !== undefined) try {
        encryptedKey = (0, $gQjU9.decode)(jwe.encrypted_key);
    } catch  {
        throw new (0, $22n7Y.JWEInvalid)("Failed to base64url decode the encrypted_key");
    }
    let resolvedKey = false;
    if (typeof key === "function") {
        key = await key(parsedProt, jwe);
        resolvedKey = true;
    }
    let cek;
    try {
        cek = await (0, $6Ol6n.default)(alg, key, encryptedKey, joseHeader, options);
    } catch (err) {
        if (err instanceof TypeError || err instanceof (0, $22n7Y.JWEInvalid) || err instanceof (0, $22n7Y.JOSENotSupported)) throw err;
        cek = (0, $aAX83.default)(enc);
    }
    let iv;
    let tag;
    if (jwe.iv !== undefined) try {
        iv = (0, $gQjU9.decode)(jwe.iv);
    } catch  {
        throw new (0, $22n7Y.JWEInvalid)("Failed to base64url decode the iv");
    }
    if (jwe.tag !== undefined) try {
        tag = (0, $gQjU9.decode)(jwe.tag);
    } catch  {
        throw new (0, $22n7Y.JWEInvalid)("Failed to base64url decode the tag");
    }
    const protectedHeader = (0, $hBRjO.encoder).encode(jwe.protected ?? "");
    let additionalData;
    if (jwe.aad !== undefined) additionalData = (0, $hBRjO.concat)(protectedHeader, (0, $hBRjO.encoder).encode("."), (0, $hBRjO.encoder).encode(jwe.aad));
    else additionalData = protectedHeader;
    let ciphertext;
    try {
        ciphertext = (0, $gQjU9.decode)(jwe.ciphertext);
    } catch  {
        throw new (0, $22n7Y.JWEInvalid)("Failed to base64url decode the ciphertext");
    }
    const plaintext = await (0, $1bzHM.default)(enc, cek, ciphertext, iv, tag, additionalData);
    const result = {
        plaintext: plaintext
    };
    if (jwe.protected !== undefined) result.protectedHeader = parsedProt;
    if (jwe.aad !== undefined) try {
        result.additionalAuthenticatedData = (0, $gQjU9.decode)(jwe.aad);
    } catch  {
        throw new (0, $22n7Y.JWEInvalid)("Failed to base64url decode the aad");
    }
    if (jwe.unprotected !== undefined) result.sharedUnprotectedHeader = jwe.unprotected;
    if (jwe.header !== undefined) result.unprotectedHeader = jwe.header;
    if (resolvedKey) return {
        ...result,
        key: key
    };
    return result;
}

});
parcelRequire.register("gQjU9", function(module, exports) {

$parcel$export(module.exports, "encodeBase64", function () { return $c430f1555a2351fc$export$8fb536984ec8b4d7; });
$parcel$export(module.exports, "encode", function () { return $c430f1555a2351fc$export$c564cdbbe6da493; });
$parcel$export(module.exports, "decodeBase64", function () { return $c430f1555a2351fc$export$94fdf11bafc8de6b; });
$parcel$export(module.exports, "decode", function () { return $c430f1555a2351fc$export$2f872c0f2117be69; });

var $hBRjO = parcelRequire("hBRjO");
const $c430f1555a2351fc$export$8fb536984ec8b4d7 = (input)=>{
    let unencoded = input;
    if (typeof unencoded === "string") unencoded = (0, $hBRjO.encoder).encode(unencoded);
    const CHUNK_SIZE = 0x8000;
    const arr = [];
    for(let i = 0; i < unencoded.length; i += CHUNK_SIZE)arr.push(String.fromCharCode.apply(null, unencoded.subarray(i, i + CHUNK_SIZE)));
    return btoa(arr.join(""));
};
const $c430f1555a2351fc$export$c564cdbbe6da493 = (input)=>{
    return $c430f1555a2351fc$export$8fb536984ec8b4d7(input).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
};
const $c430f1555a2351fc$export$94fdf11bafc8de6b = (encoded)=>{
    const binary = atob(encoded);
    const bytes = new Uint8Array(binary.length);
    for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
    return bytes;
};
const $c430f1555a2351fc$export$2f872c0f2117be69 = (input)=>{
    let encoded = input;
    if (encoded instanceof Uint8Array) encoded = (0, $hBRjO.decoder).decode(encoded);
    encoded = encoded.replace(/-/g, "+").replace(/_/g, "/").replace(/\s/g, "");
    try {
        return $c430f1555a2351fc$export$94fdf11bafc8de6b(encoded);
    } catch  {
        throw new TypeError("The input to be decoded is not correctly encoded.");
    }
};

});
parcelRequire.register("hBRjO", function(module, exports) {

$parcel$export(module.exports, "encoder", function () { return $cd1f40533fc37715$export$5486af06137bf21a; });
$parcel$export(module.exports, "decoder", function () { return $cd1f40533fc37715$export$124c96e6ce37090b; });
$parcel$export(module.exports, "concat", function () { return $cd1f40533fc37715$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "p2s", function () { return $cd1f40533fc37715$export$256d3ca12372f112; });
$parcel$export(module.exports, "uint64be", function () { return $cd1f40533fc37715$export$e7b531e00a18fdd7; });
$parcel$export(module.exports, "uint32be", function () { return $cd1f40533fc37715$export$74c16dba6c885532; });
$parcel$export(module.exports, "lengthAndInput", function () { return $cd1f40533fc37715$export$c1498c4a3718d967; });
$parcel$export(module.exports, "concatKdf", function () { return $cd1f40533fc37715$export$67163693c21af44f; });

var $dj3HR = parcelRequire("dj3HR");
const $cd1f40533fc37715$export$5486af06137bf21a = new TextEncoder();
const $cd1f40533fc37715$export$124c96e6ce37090b = new TextDecoder();
const $cd1f40533fc37715$var$MAX_INT32 = 2 ** 32;
function $cd1f40533fc37715$export$ee1b3e54f0441b22(...buffers) {
    const size = buffers.reduce((acc, { length: length })=>acc + length, 0);
    const buf = new Uint8Array(size);
    let i = 0;
    for (const buffer of buffers){
        buf.set(buffer, i);
        i += buffer.length;
    }
    return buf;
}
function $cd1f40533fc37715$export$256d3ca12372f112(alg, p2sInput) {
    return $cd1f40533fc37715$export$ee1b3e54f0441b22($cd1f40533fc37715$export$5486af06137bf21a.encode(alg), new Uint8Array([
        0
    ]), p2sInput);
}
function $cd1f40533fc37715$var$writeUInt32BE(buf, value, offset) {
    if (value < 0 || value >= $cd1f40533fc37715$var$MAX_INT32) throw new RangeError(`value must be >= 0 and <= ${$cd1f40533fc37715$var$MAX_INT32 - 1}. Received ${value}`);
    buf.set([
        value >>> 24,
        value >>> 16,
        value >>> 8,
        value & 0xff
    ], offset);
}
function $cd1f40533fc37715$export$e7b531e00a18fdd7(value) {
    const high = Math.floor(value / $cd1f40533fc37715$var$MAX_INT32);
    const low = value % $cd1f40533fc37715$var$MAX_INT32;
    const buf = new Uint8Array(8);
    $cd1f40533fc37715$var$writeUInt32BE(buf, high, 0);
    $cd1f40533fc37715$var$writeUInt32BE(buf, low, 4);
    return buf;
}
function $cd1f40533fc37715$export$74c16dba6c885532(value) {
    const buf = new Uint8Array(4);
    $cd1f40533fc37715$var$writeUInt32BE(buf, value);
    return buf;
}
function $cd1f40533fc37715$export$c1498c4a3718d967(input) {
    return $cd1f40533fc37715$export$ee1b3e54f0441b22($cd1f40533fc37715$export$74c16dba6c885532(input.length), input);
}
async function $cd1f40533fc37715$export$67163693c21af44f(secret, bits, value) {
    const iterations = Math.ceil((bits >> 3) / 32);
    const res = new Uint8Array(iterations * 32);
    for(let iter = 0; iter < iterations; iter++){
        const buf = new Uint8Array(4 + secret.length + value.length);
        buf.set($cd1f40533fc37715$export$74c16dba6c885532(iter + 1));
        buf.set(secret, 4);
        buf.set(value, 4 + secret.length);
        res.set(await (0, $dj3HR.default)("sha256", buf), iter * 32);
    }
    return res.slice(0, bits >> 3);
}

});
parcelRequire.register("dj3HR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9affecb995a35e2a$export$2e2bcd8739ae039; });

var $b5yyA = parcelRequire("b5yyA");
const $9affecb995a35e2a$var$digest = async (algorithm, data)=>{
    const subtleDigest = `SHA-${algorithm.slice(-3)}`;
    return new Uint8Array(await (0, $b5yyA.default).subtle.digest(subtleDigest, data));
};
var $9affecb995a35e2a$export$2e2bcd8739ae039 = $9affecb995a35e2a$var$digest;

});
parcelRequire.register("b5yyA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $812af79c894eb165$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "isCryptoKey", function () { return $812af79c894eb165$export$600b5603bbac4c6; });
var $812af79c894eb165$export$2e2bcd8739ae039 = crypto;
const $812af79c894eb165$export$600b5603bbac4c6 = (key)=>key instanceof CryptoKey;

});




parcelRequire.register("1bzHM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0dd283d733202b7d$export$2e2bcd8739ae039; });

var $hBRjO = parcelRequire("hBRjO");

var $6X3Ct = parcelRequire("6X3Ct");

var $lff5h = parcelRequire("lff5h");

var $j1i6k = parcelRequire("j1i6k");

var $22n7Y = parcelRequire("22n7Y");

var $b5yyA = parcelRequire("b5yyA");

var $5ap99 = parcelRequire("5ap99");

var $7ywXS = parcelRequire("7ywXS");

var $lNabF = parcelRequire("lNabF");
async function $0dd283d733202b7d$var$cbcDecrypt(enc, cek, ciphertext, iv, tag, aad) {
    if (!(cek instanceof Uint8Array)) throw new TypeError((0, $7ywXS.default)(cek, "Uint8Array"));
    const keySize = parseInt(enc.slice(1, 4), 10);
    const encKey = await (0, $b5yyA.default).subtle.importKey("raw", cek.subarray(keySize >> 3), "AES-CBC", false, [
        "decrypt"
    ]);
    const macKey = await (0, $b5yyA.default).subtle.importKey("raw", cek.subarray(0, keySize >> 3), {
        hash: `SHA-${keySize << 1}`,
        name: "HMAC"
    }, false, [
        "sign"
    ]);
    const macData = (0, $hBRjO.concat)(aad, iv, ciphertext, (0, $hBRjO.uint64be)(aad.length << 3));
    const expectedTag = new Uint8Array((await (0, $b5yyA.default).subtle.sign("HMAC", macKey, macData)).slice(0, keySize >> 3));
    let macCheckPassed;
    try {
        macCheckPassed = (0, $j1i6k.default)(tag, expectedTag);
    } catch  {}
    if (!macCheckPassed) throw new (0, $22n7Y.JWEDecryptionFailed)();
    let plaintext;
    try {
        plaintext = new Uint8Array(await (0, $b5yyA.default).subtle.decrypt({
            iv: iv,
            name: "AES-CBC"
        }, encKey, ciphertext));
    } catch  {}
    if (!plaintext) throw new (0, $22n7Y.JWEDecryptionFailed)();
    return plaintext;
}
async function $0dd283d733202b7d$var$gcmDecrypt(enc, cek, ciphertext, iv, tag, aad) {
    let encKey;
    if (cek instanceof Uint8Array) encKey = await (0, $b5yyA.default).subtle.importKey("raw", cek, "AES-GCM", false, [
        "decrypt"
    ]);
    else {
        (0, $5ap99.checkEncCryptoKey)(cek, enc, "decrypt");
        encKey = cek;
    }
    try {
        return new Uint8Array(await (0, $b5yyA.default).subtle.decrypt({
            additionalData: aad,
            iv: iv,
            name: "AES-GCM",
            tagLength: 128
        }, encKey, (0, $hBRjO.concat)(ciphertext, tag)));
    } catch  {
        throw new (0, $22n7Y.JWEDecryptionFailed)();
    }
}
const $0dd283d733202b7d$var$decrypt = async (enc, cek, ciphertext, iv, tag, aad)=>{
    if (!(0, $b5yyA.isCryptoKey)(cek) && !(cek instanceof Uint8Array)) throw new TypeError((0, $7ywXS.default)(cek, ...(0, $lNabF.types), "Uint8Array"));
    if (!iv) throw new (0, $22n7Y.JWEInvalid)("JWE Initialization Vector missing");
    if (!tag) throw new (0, $22n7Y.JWEInvalid)("JWE Authentication Tag missing");
    (0, $6X3Ct.default)(enc, iv);
    switch(enc){
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            if (cek instanceof Uint8Array) (0, $lff5h.default)(cek, parseInt(enc.slice(-3), 10));
            return $0dd283d733202b7d$var$cbcDecrypt(enc, cek, ciphertext, iv, tag, aad);
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            if (cek instanceof Uint8Array) (0, $lff5h.default)(cek, parseInt(enc.slice(1, 4), 10));
            return $0dd283d733202b7d$var$gcmDecrypt(enc, cek, ciphertext, iv, tag, aad);
        default:
            throw new (0, $22n7Y.JOSENotSupported)("Unsupported JWE Content Encryption Algorithm");
    }
};
var $0dd283d733202b7d$export$2e2bcd8739ae039 = $0dd283d733202b7d$var$decrypt;

});
parcelRequire.register("6X3Ct", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50fb0f862eed55c1$export$2e2bcd8739ae039; });

var $22n7Y = parcelRequire("22n7Y");

var $4kPpN = parcelRequire("4kPpN");
const $50fb0f862eed55c1$var$checkIvLength = (enc, iv)=>{
    if (iv.length << 3 !== (0, $4kPpN.bitLength)(enc)) throw new (0, $22n7Y.JWEInvalid)("Invalid Initialization Vector length");
};
var $50fb0f862eed55c1$export$2e2bcd8739ae039 = $50fb0f862eed55c1$var$checkIvLength;

});
parcelRequire.register("22n7Y", function(module, exports) {

$parcel$export(module.exports, "JOSEError", function () { return $17bdb5579d481c16$export$f754d6850d76bf87; });
$parcel$export(module.exports, "JWTClaimValidationFailed", function () { return $17bdb5579d481c16$export$f1e14efb908196e9; });
$parcel$export(module.exports, "JWTExpired", function () { return $17bdb5579d481c16$export$4b386bf852b7863d; });
$parcel$export(module.exports, "JOSEAlgNotAllowed", function () { return $17bdb5579d481c16$export$d51fd7fedeccc338; });
$parcel$export(module.exports, "JOSENotSupported", function () { return $17bdb5579d481c16$export$19ddbcbf2016ab28; });
$parcel$export(module.exports, "JWEDecryptionFailed", function () { return $17bdb5579d481c16$export$1a57512ad9773b2a; });
$parcel$export(module.exports, "JWEInvalid", function () { return $17bdb5579d481c16$export$19f281f2275f6a15; });
$parcel$export(module.exports, "JWSInvalid", function () { return $17bdb5579d481c16$export$e838de724af3d116; });
$parcel$export(module.exports, "JWTInvalid", function () { return $17bdb5579d481c16$export$936b39ada0bbfceb; });
$parcel$export(module.exports, "JWKInvalid", function () { return $17bdb5579d481c16$export$b3992e0f88fb07e3; });
$parcel$export(module.exports, "JWKSInvalid", function () { return $17bdb5579d481c16$export$9b22c2a1e2403b8e; });
$parcel$export(module.exports, "JWKSNoMatchingKey", function () { return $17bdb5579d481c16$export$3d5ed1a538bed04e; });
$parcel$export(module.exports, "JWKSMultipleMatchingKeys", function () { return $17bdb5579d481c16$export$dc036de401a5c284; });
$parcel$export(module.exports, "JWKSTimeout", function () { return $17bdb5579d481c16$export$3f30acebf25c04e6; });
$parcel$export(module.exports, "JWSSignatureVerificationFailed", function () { return $17bdb5579d481c16$export$c67a0218e7c50378; });
class $17bdb5579d481c16$export$f754d6850d76bf87 extends Error {
    static get code() {
        return "ERR_JOSE_GENERIC";
    }
    constructor(message){
        super(message);
        this.code = "ERR_JOSE_GENERIC";
        this.name = this.constructor.name;
        Error.captureStackTrace?.(this, this.constructor);
    }
}
class $17bdb5579d481c16$export$f1e14efb908196e9 extends $17bdb5579d481c16$export$f754d6850d76bf87 {
    static get code() {
        return "ERR_JWT_CLAIM_VALIDATION_FAILED";
    }
    constructor(message, claim = "unspecified", reason = "unspecified"){
        super(message);
        this.code = "ERR_JWT_CLAIM_VALIDATION_FAILED";
        this.claim = claim;
        this.reason = reason;
    }
}
class $17bdb5579d481c16$export$4b386bf852b7863d extends $17bdb5579d481c16$export$f754d6850d76bf87 {
    static get code() {
        return "ERR_JWT_EXPIRED";
    }
    constructor(message, claim = "unspecified", reason = "unspecified"){
        super(message);
        this.code = "ERR_JWT_EXPIRED";
        this.claim = claim;
        this.reason = reason;
    }
}
class $17bdb5579d481c16$export$d51fd7fedeccc338 extends $17bdb5579d481c16$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JOSE_ALG_NOT_ALLOWED";
    }
    static get code() {
        return "ERR_JOSE_ALG_NOT_ALLOWED";
    }
}
class $17bdb5579d481c16$export$19ddbcbf2016ab28 extends $17bdb5579d481c16$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JOSE_NOT_SUPPORTED";
    }
    static get code() {
        return "ERR_JOSE_NOT_SUPPORTED";
    }
}
class $17bdb5579d481c16$export$1a57512ad9773b2a extends $17bdb5579d481c16$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWE_DECRYPTION_FAILED";
        this.message = "decryption operation failed";
    }
    static get code() {
        return "ERR_JWE_DECRYPTION_FAILED";
    }
}
class $17bdb5579d481c16$export$19f281f2275f6a15 extends $17bdb5579d481c16$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWE_INVALID";
    }
    static get code() {
        return "ERR_JWE_INVALID";
    }
}
class $17bdb5579d481c16$export$e838de724af3d116 extends $17bdb5579d481c16$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWS_INVALID";
    }
    static get code() {
        return "ERR_JWS_INVALID";
    }
}
class $17bdb5579d481c16$export$936b39ada0bbfceb extends $17bdb5579d481c16$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWT_INVALID";
    }
    static get code() {
        return "ERR_JWT_INVALID";
    }
}
class $17bdb5579d481c16$export$b3992e0f88fb07e3 extends $17bdb5579d481c16$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWK_INVALID";
    }
    static get code() {
        return "ERR_JWK_INVALID";
    }
}
class $17bdb5579d481c16$export$9b22c2a1e2403b8e extends $17bdb5579d481c16$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_INVALID";
    }
    static get code() {
        return "ERR_JWKS_INVALID";
    }
}
class $17bdb5579d481c16$export$3d5ed1a538bed04e extends $17bdb5579d481c16$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_NO_MATCHING_KEY";
        this.message = "no applicable key found in the JSON Web Key Set";
    }
    static get code() {
        return "ERR_JWKS_NO_MATCHING_KEY";
    }
}
class $17bdb5579d481c16$export$dc036de401a5c284 extends $17bdb5579d481c16$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_MULTIPLE_MATCHING_KEYS";
        this.message = "multiple matching keys found in the JSON Web Key Set";
    }
    static get code() {
        return "ERR_JWKS_MULTIPLE_MATCHING_KEYS";
    }
}
Symbol.asyncIterator;
class $17bdb5579d481c16$export$3f30acebf25c04e6 extends $17bdb5579d481c16$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_TIMEOUT";
        this.message = "request timed out";
    }
    static get code() {
        return "ERR_JWKS_TIMEOUT";
    }
}
class $17bdb5579d481c16$export$c67a0218e7c50378 extends $17bdb5579d481c16$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWS_SIGNATURE_VERIFICATION_FAILED";
        this.message = "signature verification failed";
    }
    static get code() {
        return "ERR_JWS_SIGNATURE_VERIFICATION_FAILED";
    }
}

});

parcelRequire.register("4kPpN", function(module, exports) {

$parcel$export(module.exports, "bitLength", function () { return $3280e9aae5eab527$export$db433e85ac514a95; });
$parcel$export(module.exports, "default", function () { return $3280e9aae5eab527$export$2e2bcd8739ae039; });

var $22n7Y = parcelRequire("22n7Y");

var $lNduJ = parcelRequire("lNduJ");
function $3280e9aae5eab527$export$db433e85ac514a95(alg) {
    switch(alg){
        case "A128GCM":
        case "A128GCMKW":
        case "A192GCM":
        case "A192GCMKW":
        case "A256GCM":
        case "A256GCMKW":
            return 96;
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            return 128;
        default:
            throw new (0, $22n7Y.JOSENotSupported)(`Unsupported JWE Algorithm: ${alg}`);
    }
}
var $3280e9aae5eab527$export$2e2bcd8739ae039 = (alg)=>(0, $lNduJ.default)(new Uint8Array($3280e9aae5eab527$export$db433e85ac514a95(alg) >> 3));

});
parcelRequire.register("lNduJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdd8a4566aeeaf9a$export$2e2bcd8739ae039; });

var $b5yyA = parcelRequire("b5yyA");
var $fdd8a4566aeeaf9a$export$2e2bcd8739ae039 = (0, $b5yyA.default).getRandomValues.bind((0, $b5yyA.default));

});



parcelRequire.register("lff5h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f776b318d29a3f13$export$2e2bcd8739ae039; });

var $22n7Y = parcelRequire("22n7Y");
const $f776b318d29a3f13$var$checkCekLength = (cek, expected)=>{
    const actual = cek.byteLength << 3;
    if (actual !== expected) throw new (0, $22n7Y.JWEInvalid)(`Invalid Content Encryption Key length. Expected ${expected} bits, got ${actual} bits`);
};
var $f776b318d29a3f13$export$2e2bcd8739ae039 = $f776b318d29a3f13$var$checkCekLength;

});

parcelRequire.register("j1i6k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd8c26d2ec5e6cfe$export$2e2bcd8739ae039; });
const $dd8c26d2ec5e6cfe$var$timingSafeEqual = (a, b)=>{
    if (!(a instanceof Uint8Array)) throw new TypeError("First argument must be a buffer");
    if (!(b instanceof Uint8Array)) throw new TypeError("Second argument must be a buffer");
    if (a.length !== b.length) throw new TypeError("Input buffers must have the same length");
    const len = a.length;
    let out = 0;
    let i = -1;
    while(++i < len)out |= a[i] ^ b[i];
    return out === 0;
};
var $dd8c26d2ec5e6cfe$export$2e2bcd8739ae039 = $dd8c26d2ec5e6cfe$var$timingSafeEqual;

});

parcelRequire.register("5ap99", function(module, exports) {

$parcel$export(module.exports, "checkSigCryptoKey", function () { return $3c316484e0660088$export$39a36029eee6729; });
$parcel$export(module.exports, "checkEncCryptoKey", function () { return $3c316484e0660088$export$41a67f89f6678b35; });
function $3c316484e0660088$var$unusable(name, prop = "algorithm.name") {
    return new TypeError(`CryptoKey does not support this operation, its ${prop} must be ${name}`);
}
function $3c316484e0660088$var$isAlgorithm(algorithm, name) {
    return algorithm.name === name;
}
function $3c316484e0660088$var$getHashLength(hash) {
    return parseInt(hash.name.slice(4), 10);
}
function $3c316484e0660088$var$getNamedCurve(alg) {
    switch(alg){
        case "ES256":
            return "P-256";
        case "ES384":
            return "P-384";
        case "ES512":
            return "P-521";
        default:
            throw new Error("unreachable");
    }
}
function $3c316484e0660088$var$checkUsage(key, usages) {
    if (usages.length && !usages.some((expected)=>key.usages.includes(expected))) {
        let msg = "CryptoKey does not support this operation, its usages must include ";
        if (usages.length > 2) {
            const last = usages.pop();
            msg += `one of ${usages.join(", ")}, or ${last}.`;
        } else if (usages.length === 2) msg += `one of ${usages[0]} or ${usages[1]}.`;
        else msg += `${usages[0]}.`;
        throw new TypeError(msg);
    }
}
function $3c316484e0660088$export$39a36029eee6729(key, alg, ...usages) {
    switch(alg){
        case "HS256":
        case "HS384":
        case "HS512":
            {
                if (!$3c316484e0660088$var$isAlgorithm(key.algorithm, "HMAC")) throw $3c316484e0660088$var$unusable("HMAC");
                const expected = parseInt(alg.slice(2), 10);
                const actual = $3c316484e0660088$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $3c316484e0660088$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        case "RS256":
        case "RS384":
        case "RS512":
            {
                if (!$3c316484e0660088$var$isAlgorithm(key.algorithm, "RSASSA-PKCS1-v1_5")) throw $3c316484e0660088$var$unusable("RSASSA-PKCS1-v1_5");
                const expected = parseInt(alg.slice(2), 10);
                const actual = $3c316484e0660088$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $3c316484e0660088$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        case "PS256":
        case "PS384":
        case "PS512":
            {
                if (!$3c316484e0660088$var$isAlgorithm(key.algorithm, "RSA-PSS")) throw $3c316484e0660088$var$unusable("RSA-PSS");
                const expected = parseInt(alg.slice(2), 10);
                const actual = $3c316484e0660088$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $3c316484e0660088$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        case "EdDSA":
            if (key.algorithm.name !== "Ed25519" && key.algorithm.name !== "Ed448") throw $3c316484e0660088$var$unusable("Ed25519 or Ed448");
            break;
        case "ES256":
        case "ES384":
        case "ES512":
            {
                if (!$3c316484e0660088$var$isAlgorithm(key.algorithm, "ECDSA")) throw $3c316484e0660088$var$unusable("ECDSA");
                const expected = $3c316484e0660088$var$getNamedCurve(alg);
                const actual = key.algorithm.namedCurve;
                if (actual !== expected) throw $3c316484e0660088$var$unusable(expected, "algorithm.namedCurve");
                break;
            }
        default:
            throw new TypeError("CryptoKey does not support this operation");
    }
    $3c316484e0660088$var$checkUsage(key, usages);
}
function $3c316484e0660088$export$41a67f89f6678b35(key, alg, ...usages) {
    switch(alg){
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            {
                if (!$3c316484e0660088$var$isAlgorithm(key.algorithm, "AES-GCM")) throw $3c316484e0660088$var$unusable("AES-GCM");
                const expected = parseInt(alg.slice(1, 4), 10);
                const actual = key.algorithm.length;
                if (actual !== expected) throw $3c316484e0660088$var$unusable(expected, "algorithm.length");
                break;
            }
        case "A128KW":
        case "A192KW":
        case "A256KW":
            {
                if (!$3c316484e0660088$var$isAlgorithm(key.algorithm, "AES-KW")) throw $3c316484e0660088$var$unusable("AES-KW");
                const expected = parseInt(alg.slice(1, 4), 10);
                const actual = key.algorithm.length;
                if (actual !== expected) throw $3c316484e0660088$var$unusable(expected, "algorithm.length");
                break;
            }
        case "ECDH":
            switch(key.algorithm.name){
                case "ECDH":
                case "X25519":
                case "X448":
                    break;
                default:
                    throw $3c316484e0660088$var$unusable("ECDH, X25519, or X448");
            }
            break;
        case "PBES2-HS256+A128KW":
        case "PBES2-HS384+A192KW":
        case "PBES2-HS512+A256KW":
            if (!$3c316484e0660088$var$isAlgorithm(key.algorithm, "PBKDF2")) throw $3c316484e0660088$var$unusable("PBKDF2");
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            {
                if (!$3c316484e0660088$var$isAlgorithm(key.algorithm, "RSA-OAEP")) throw $3c316484e0660088$var$unusable("RSA-OAEP");
                const expected = parseInt(alg.slice(9), 10) || 1;
                const actual = $3c316484e0660088$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $3c316484e0660088$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        default:
            throw new TypeError("CryptoKey does not support this operation");
    }
    $3c316484e0660088$var$checkUsage(key, usages);
}

});

parcelRequire.register("7ywXS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58054781e4844948$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "withAlg", function () { return $58054781e4844948$export$e94f758d09bc1828; });
function $58054781e4844948$var$message(msg, actual, ...types) {
    if (types.length > 2) {
        const last = types.pop();
        msg += `one of type ${types.join(", ")}, or ${last}.`;
    } else if (types.length === 2) msg += `one of type ${types[0]} or ${types[1]}.`;
    else msg += `of type ${types[0]}.`;
    if (actual == null) msg += ` Received ${actual}`;
    else if (typeof actual === "function" && actual.name) msg += ` Received function ${actual.name}`;
    else if (typeof actual === "object" && actual != null) {
        if (actual.constructor?.name) msg += ` Received an instance of ${actual.constructor.name}`;
    }
    return msg;
}
var $58054781e4844948$export$2e2bcd8739ae039 = (actual, ...types)=>{
    return $58054781e4844948$var$message("Key must be ", actual, ...types);
};
function $58054781e4844948$export$e94f758d09bc1828(alg, actual, ...types) {
    return $58054781e4844948$var$message(`Key for the ${alg} algorithm must be `, actual, ...types);
}

});

parcelRequire.register("lNabF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdd61384a8370448$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "types", function () { return $fdd61384a8370448$export$b14ad400b1d09e0f; });

var $b5yyA = parcelRequire("b5yyA");
var $fdd61384a8370448$export$2e2bcd8739ae039 = (key)=>{
    return (0, $b5yyA.isCryptoKey)(key);
};
const $fdd61384a8370448$export$b14ad400b1d09e0f = [
    "CryptoKey"
];

});


parcelRequire.register("6jtNr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $498ba15c042e0358$export$2e2bcd8739ae039; });
const $498ba15c042e0358$var$isDisjoint = (...headers)=>{
    const sources = headers.filter(Boolean);
    if (sources.length === 0 || sources.length === 1) return true;
    let acc;
    for (const header of sources){
        const parameters = Object.keys(header);
        if (!acc || acc.size === 0) {
            acc = new Set(parameters);
            continue;
        }
        for (const parameter of parameters){
            if (acc.has(parameter)) return false;
            acc.add(parameter);
        }
    }
    return true;
};
var $498ba15c042e0358$export$2e2bcd8739ae039 = $498ba15c042e0358$var$isDisjoint;

});

parcelRequire.register("36w7K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $242ad9cd29a18e36$export$2e2bcd8739ae039; });
function $242ad9cd29a18e36$var$isObjectLike(value) {
    return typeof value === "object" && value !== null;
}
function $242ad9cd29a18e36$export$2e2bcd8739ae039(input) {
    if (!$242ad9cd29a18e36$var$isObjectLike(input) || Object.prototype.toString.call(input) !== "[object Object]") return false;
    if (Object.getPrototypeOf(input) === null) return true;
    let proto = input;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(input) === proto;
}

});

parcelRequire.register("6Ol6n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f57c7f66e02b723$export$2e2bcd8739ae039; });

var $bnY3q = parcelRequire("bnY3q");

var $bwIOL = parcelRequire("bwIOL");

var $k8ahq = parcelRequire("k8ahq");

var $8Kqgm = parcelRequire("8Kqgm");

var $gQjU9 = parcelRequire("gQjU9");

var $22n7Y = parcelRequire("22n7Y");

var $aAX83 = parcelRequire("aAX83");

var $i50Kz = parcelRequire("i50Kz");

var $TQWvz = parcelRequire("TQWvz");

var $36w7K = parcelRequire("36w7K");

var $84uLC = parcelRequire("84uLC");
async function $4f57c7f66e02b723$var$decryptKeyManagement(alg, key, encryptedKey, joseHeader, options) {
    (0, $TQWvz.default)(alg, key, "decrypt");
    switch(alg){
        case "dir":
            if (encryptedKey !== undefined) throw new (0, $22n7Y.JWEInvalid)("Encountered unexpected JWE Encrypted Key");
            return key;
        case "ECDH-ES":
            if (encryptedKey !== undefined) throw new (0, $22n7Y.JWEInvalid)("Encountered unexpected JWE Encrypted Key");
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                if (!(0, $36w7K.default)(joseHeader.epk)) throw new (0, $22n7Y.JWEInvalid)(`JOSE Header "epk" (Ephemeral Public Key) missing or invalid`);
                if (!$bwIOL.ecdhAllowed(key)) throw new (0, $22n7Y.JOSENotSupported)("ECDH with the provided key is not allowed or not supported by your javascript runtime");
                const epk = await (0, $i50Kz.importJWK)(joseHeader.epk, alg);
                let partyUInfo;
                let partyVInfo;
                if (joseHeader.apu !== undefined) {
                    if (typeof joseHeader.apu !== "string") throw new (0, $22n7Y.JWEInvalid)(`JOSE Header "apu" (Agreement PartyUInfo) invalid`);
                    try {
                        partyUInfo = (0, $gQjU9.decode)(joseHeader.apu);
                    } catch  {
                        throw new (0, $22n7Y.JWEInvalid)("Failed to base64url decode the apu");
                    }
                }
                if (joseHeader.apv !== undefined) {
                    if (typeof joseHeader.apv !== "string") throw new (0, $22n7Y.JWEInvalid)(`JOSE Header "apv" (Agreement PartyVInfo) invalid`);
                    try {
                        partyVInfo = (0, $gQjU9.decode)(joseHeader.apv);
                    } catch  {
                        throw new (0, $22n7Y.JWEInvalid)("Failed to base64url decode the apv");
                    }
                }
                const sharedSecret = await $bwIOL.deriveKey(epk, key, alg === "ECDH-ES" ? joseHeader.enc : alg, alg === "ECDH-ES" ? (0, $aAX83.bitLength)(joseHeader.enc) : parseInt(alg.slice(-5, -2), 10), partyUInfo, partyVInfo);
                if (alg === "ECDH-ES") return sharedSecret;
                if (encryptedKey === undefined) throw new (0, $22n7Y.JWEInvalid)("JWE Encrypted Key missing");
                return (0, $bnY3q.unwrap)(alg.slice(-6), sharedSecret, encryptedKey);
            }
        case "RSA1_5":
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            if (encryptedKey === undefined) throw new (0, $22n7Y.JWEInvalid)("JWE Encrypted Key missing");
            return (0, $8Kqgm.decrypt)(alg, key, encryptedKey);
        case "PBES2-HS256+A128KW":
        case "PBES2-HS384+A192KW":
        case "PBES2-HS512+A256KW":
            {
                if (encryptedKey === undefined) throw new (0, $22n7Y.JWEInvalid)("JWE Encrypted Key missing");
                if (typeof joseHeader.p2c !== "number") throw new (0, $22n7Y.JWEInvalid)(`JOSE Header "p2c" (PBES2 Count) missing or invalid`);
                const p2cLimit = options?.maxPBES2Count || 10000;
                if (joseHeader.p2c > p2cLimit) throw new (0, $22n7Y.JWEInvalid)(`JOSE Header "p2c" (PBES2 Count) out is of acceptable bounds`);
                if (typeof joseHeader.p2s !== "string") throw new (0, $22n7Y.JWEInvalid)(`JOSE Header "p2s" (PBES2 Salt) missing or invalid`);
                let p2s;
                try {
                    p2s = (0, $gQjU9.decode)(joseHeader.p2s);
                } catch  {
                    throw new (0, $22n7Y.JWEInvalid)("Failed to base64url decode the p2s");
                }
                return (0, $k8ahq.decrypt)(alg, key, encryptedKey, joseHeader.p2c, p2s);
            }
        case "A128KW":
        case "A192KW":
        case "A256KW":
            if (encryptedKey === undefined) throw new (0, $22n7Y.JWEInvalid)("JWE Encrypted Key missing");
            return (0, $bnY3q.unwrap)(alg, key, encryptedKey);
        case "A128GCMKW":
        case "A192GCMKW":
        case "A256GCMKW":
            {
                if (encryptedKey === undefined) throw new (0, $22n7Y.JWEInvalid)("JWE Encrypted Key missing");
                if (typeof joseHeader.iv !== "string") throw new (0, $22n7Y.JWEInvalid)(`JOSE Header "iv" (Initialization Vector) missing or invalid`);
                if (typeof joseHeader.tag !== "string") throw new (0, $22n7Y.JWEInvalid)(`JOSE Header "tag" (Authentication Tag) missing or invalid`);
                let iv;
                try {
                    iv = (0, $gQjU9.decode)(joseHeader.iv);
                } catch  {
                    throw new (0, $22n7Y.JWEInvalid)("Failed to base64url decode the iv");
                }
                let tag;
                try {
                    tag = (0, $gQjU9.decode)(joseHeader.tag);
                } catch  {
                    throw new (0, $22n7Y.JWEInvalid)("Failed to base64url decode the tag");
                }
                return (0, $84uLC.unwrap)(alg, key, encryptedKey, iv, tag);
            }
        default:
            throw new (0, $22n7Y.JOSENotSupported)('Invalid or unsupported "alg" (JWE Algorithm) header value');
    }
}
var $4f57c7f66e02b723$export$2e2bcd8739ae039 = $4f57c7f66e02b723$var$decryptKeyManagement;

});
parcelRequire.register("bnY3q", function(module, exports) {

$parcel$export(module.exports, "wrap", function () { return $84a06d3ca0563936$export$4997ffc0176396a6; });
$parcel$export(module.exports, "unwrap", function () { return $84a06d3ca0563936$export$debb760848ca95a; });

var $gfRgp = parcelRequire("gfRgp");

var $b5yyA = parcelRequire("b5yyA");

var $5ap99 = parcelRequire("5ap99");

var $7ywXS = parcelRequire("7ywXS");

var $lNabF = parcelRequire("lNabF");
function $84a06d3ca0563936$var$checkKeySize(key, alg) {
    if (key.algorithm.length !== parseInt(alg.slice(1, 4), 10)) throw new TypeError(`Invalid key size for alg: ${alg}`);
}
function $84a06d3ca0563936$var$getCryptoKey(key, alg, usage) {
    if ((0, $b5yyA.isCryptoKey)(key)) {
        (0, $5ap99.checkEncCryptoKey)(key, alg, usage);
        return key;
    }
    if (key instanceof Uint8Array) return (0, $b5yyA.default).subtle.importKey("raw", key, "AES-KW", true, [
        usage
    ]);
    throw new TypeError((0, $7ywXS.default)(key, ...(0, $lNabF.types), "Uint8Array"));
}
const $84a06d3ca0563936$export$4997ffc0176396a6 = async (alg, key, cek)=>{
    const cryptoKey = await $84a06d3ca0563936$var$getCryptoKey(key, alg, "wrapKey");
    $84a06d3ca0563936$var$checkKeySize(cryptoKey, alg);
    const cryptoKeyCek = await (0, $b5yyA.default).subtle.importKey("raw", cek, ...(0, $gfRgp.default));
    return new Uint8Array(await (0, $b5yyA.default).subtle.wrapKey("raw", cryptoKeyCek, cryptoKey, "AES-KW"));
};
const $84a06d3ca0563936$export$debb760848ca95a = async (alg, key, encryptedKey)=>{
    const cryptoKey = await $84a06d3ca0563936$var$getCryptoKey(key, alg, "unwrapKey");
    $84a06d3ca0563936$var$checkKeySize(cryptoKey, alg);
    const cryptoKeyCek = await (0, $b5yyA.default).subtle.unwrapKey("raw", encryptedKey, cryptoKey, "AES-KW", ...(0, $gfRgp.default));
    return new Uint8Array(await (0, $b5yyA.default).subtle.exportKey("raw", cryptoKeyCek));
};

});
parcelRequire.register("gfRgp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd575d1b23d464fd$export$2e2bcd8739ae039; });
const $bd575d1b23d464fd$var$bogusWebCrypto = [
    {
        hash: "SHA-256",
        name: "HMAC"
    },
    true,
    [
        "sign"
    ]
];
var $bd575d1b23d464fd$export$2e2bcd8739ae039 = $bd575d1b23d464fd$var$bogusWebCrypto;

});


parcelRequire.register("bwIOL", function(module, exports) {

$parcel$export(module.exports, "deriveKey", function () { return $864572ba0925608c$export$87770b6b245073b5; });
$parcel$export(module.exports, "generateEpk", function () { return $864572ba0925608c$export$1338dee8c889e310; });
$parcel$export(module.exports, "ecdhAllowed", function () { return $864572ba0925608c$export$f28ab77d793719b2; });

var $hBRjO = parcelRequire("hBRjO");

var $b5yyA = parcelRequire("b5yyA");

var $5ap99 = parcelRequire("5ap99");

var $7ywXS = parcelRequire("7ywXS");

var $lNabF = parcelRequire("lNabF");
async function $864572ba0925608c$export$87770b6b245073b5(publicKey, privateKey, algorithm, keyLength, apu = new Uint8Array(0), apv = new Uint8Array(0)) {
    if (!(0, $b5yyA.isCryptoKey)(publicKey)) throw new TypeError((0, $7ywXS.default)(publicKey, ...(0, $lNabF.types)));
    (0, $5ap99.checkEncCryptoKey)(publicKey, "ECDH");
    if (!(0, $b5yyA.isCryptoKey)(privateKey)) throw new TypeError((0, $7ywXS.default)(privateKey, ...(0, $lNabF.types)));
    (0, $5ap99.checkEncCryptoKey)(privateKey, "ECDH", "deriveBits");
    const value = (0, $hBRjO.concat)((0, $hBRjO.lengthAndInput)((0, $hBRjO.encoder).encode(algorithm)), (0, $hBRjO.lengthAndInput)(apu), (0, $hBRjO.lengthAndInput)(apv), (0, $hBRjO.uint32be)(keyLength));
    let length;
    if (publicKey.algorithm.name === "X25519") length = 256;
    else if (publicKey.algorithm.name === "X448") length = 448;
    else length = Math.ceil(parseInt(publicKey.algorithm.namedCurve.substr(-3), 10) / 8) << 3;
    const sharedSecret = new Uint8Array(await (0, $b5yyA.default).subtle.deriveBits({
        name: publicKey.algorithm.name,
        public: publicKey
    }, privateKey, length));
    return (0, $hBRjO.concatKdf)(sharedSecret, keyLength, value);
}
async function $864572ba0925608c$export$1338dee8c889e310(key) {
    if (!(0, $b5yyA.isCryptoKey)(key)) throw new TypeError((0, $7ywXS.default)(key, ...(0, $lNabF.types)));
    return (0, $b5yyA.default).subtle.generateKey(key.algorithm, true, [
        "deriveBits"
    ]);
}
function $864572ba0925608c$export$f28ab77d793719b2(key) {
    if (!(0, $b5yyA.isCryptoKey)(key)) throw new TypeError((0, $7ywXS.default)(key, ...(0, $lNabF.types)));
    return [
        "P-256",
        "P-384",
        "P-521"
    ].includes(key.algorithm.namedCurve) || key.algorithm.name === "X25519" || key.algorithm.name === "X448";
}

});

parcelRequire.register("k8ahq", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $ea7c8767842cc9f2$export$5b0f6292f11d1d18; });
$parcel$export(module.exports, "decrypt", function () { return $ea7c8767842cc9f2$export$e85a0c9a1067c5d3; });

var $lNduJ = parcelRequire("lNduJ");

var $hBRjO = parcelRequire("hBRjO");

var $gQjU9 = parcelRequire("gQjU9");

var $bnY3q = parcelRequire("bnY3q");

var $fIWoT = parcelRequire("fIWoT");

var $b5yyA = parcelRequire("b5yyA");

var $5ap99 = parcelRequire("5ap99");

var $7ywXS = parcelRequire("7ywXS");

var $lNabF = parcelRequire("lNabF");
function $ea7c8767842cc9f2$var$getCryptoKey(key, alg) {
    if (key instanceof Uint8Array) return (0, $b5yyA.default).subtle.importKey("raw", key, "PBKDF2", false, [
        "deriveBits"
    ]);
    if ((0, $b5yyA.isCryptoKey)(key)) {
        (0, $5ap99.checkEncCryptoKey)(key, alg, "deriveBits", "deriveKey");
        return key;
    }
    throw new TypeError((0, $7ywXS.default)(key, ...(0, $lNabF.types), "Uint8Array"));
}
async function $ea7c8767842cc9f2$var$deriveKey(p2s, alg, p2c, key) {
    (0, $fIWoT.default)(p2s);
    const salt = (0, $hBRjO.p2s)(alg, p2s);
    const keylen = parseInt(alg.slice(13, 16), 10);
    const subtleAlg = {
        hash: `SHA-${alg.slice(8, 11)}`,
        iterations: p2c,
        name: "PBKDF2",
        salt: salt
    };
    const wrapAlg = {
        length: keylen,
        name: "AES-KW"
    };
    const cryptoKey = await $ea7c8767842cc9f2$var$getCryptoKey(key, alg);
    if (cryptoKey.usages.includes("deriveBits")) return new Uint8Array(await (0, $b5yyA.default).subtle.deriveBits(subtleAlg, cryptoKey, keylen));
    if (cryptoKey.usages.includes("deriveKey")) return (0, $b5yyA.default).subtle.deriveKey(subtleAlg, cryptoKey, wrapAlg, false, [
        "wrapKey",
        "unwrapKey"
    ]);
    throw new TypeError('PBKDF2 key "usages" must include "deriveBits" or "deriveKey"');
}
const $ea7c8767842cc9f2$export$5b0f6292f11d1d18 = async (alg, key, cek, p2c = 2048, p2s = (0, $lNduJ.default)(new Uint8Array(16)))=>{
    const derived = await $ea7c8767842cc9f2$var$deriveKey(p2s, alg, p2c, key);
    const encryptedKey = await (0, $bnY3q.wrap)(alg.slice(-6), derived, cek);
    return {
        encryptedKey: encryptedKey,
        p2c: p2c,
        p2s: (0, $gQjU9.encode)(p2s)
    };
};
const $ea7c8767842cc9f2$export$e85a0c9a1067c5d3 = async (alg, key, encryptedKey, p2c, p2s)=>{
    const derived = await $ea7c8767842cc9f2$var$deriveKey(p2s, alg, p2c, key);
    return (0, $bnY3q.unwrap)(alg.slice(-6), derived, encryptedKey);
};

});
parcelRequire.register("fIWoT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7284434d5ef08a5$export$2e2bcd8739ae039; });

var $22n7Y = parcelRequire("22n7Y");
function $b7284434d5ef08a5$export$2e2bcd8739ae039(p2s) {
    if (!(p2s instanceof Uint8Array) || p2s.length < 8) throw new (0, $22n7Y.JWEInvalid)("PBES2 Salt Input must be 8 or more octets");
}

});


parcelRequire.register("8Kqgm", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $65e6fddc9176344f$export$5b0f6292f11d1d18; });
$parcel$export(module.exports, "decrypt", function () { return $65e6fddc9176344f$export$e85a0c9a1067c5d3; });

var $6iXqG = parcelRequire("6iXqG");

var $gfRgp = parcelRequire("gfRgp");

var $b5yyA = parcelRequire("b5yyA");

var $5ap99 = parcelRequire("5ap99");

var $gVMHg = parcelRequire("gVMHg");

var $7ywXS = parcelRequire("7ywXS");

var $lNabF = parcelRequire("lNabF");
const $65e6fddc9176344f$export$5b0f6292f11d1d18 = async (alg, key, cek)=>{
    if (!(0, $b5yyA.isCryptoKey)(key)) throw new TypeError((0, $7ywXS.default)(key, ...(0, $lNabF.types)));
    (0, $5ap99.checkEncCryptoKey)(key, alg, "encrypt", "wrapKey");
    (0, $gVMHg.default)(alg, key);
    if (key.usages.includes("encrypt")) return new Uint8Array(await (0, $b5yyA.default).subtle.encrypt((0, $6iXqG.default)(alg), key, cek));
    if (key.usages.includes("wrapKey")) {
        const cryptoKeyCek = await (0, $b5yyA.default).subtle.importKey("raw", cek, ...(0, $gfRgp.default));
        return new Uint8Array(await (0, $b5yyA.default).subtle.wrapKey("raw", cryptoKeyCek, key, (0, $6iXqG.default)(alg)));
    }
    throw new TypeError('RSA-OAEP key "usages" must include "encrypt" or "wrapKey" for this operation');
};
const $65e6fddc9176344f$export$e85a0c9a1067c5d3 = async (alg, key, encryptedKey)=>{
    if (!(0, $b5yyA.isCryptoKey)(key)) throw new TypeError((0, $7ywXS.default)(key, ...(0, $lNabF.types)));
    (0, $5ap99.checkEncCryptoKey)(key, alg, "decrypt", "unwrapKey");
    (0, $gVMHg.default)(alg, key);
    if (key.usages.includes("decrypt")) return new Uint8Array(await (0, $b5yyA.default).subtle.decrypt((0, $6iXqG.default)(alg), key, encryptedKey));
    if (key.usages.includes("unwrapKey")) {
        const cryptoKeyCek = await (0, $b5yyA.default).subtle.unwrapKey("raw", encryptedKey, key, (0, $6iXqG.default)(alg), ...(0, $gfRgp.default));
        return new Uint8Array(await (0, $b5yyA.default).subtle.exportKey("raw", cryptoKeyCek));
    }
    throw new TypeError('RSA-OAEP key "usages" must include "decrypt" or "unwrapKey" for this operation');
};

});
parcelRequire.register("6iXqG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $497285f1768a7d4a$export$2e2bcd8739ae039; });

var $22n7Y = parcelRequire("22n7Y");
function $497285f1768a7d4a$export$2e2bcd8739ae039(alg) {
    switch(alg){
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            return "RSA-OAEP";
        default:
            throw new (0, $22n7Y.JOSENotSupported)(`alg ${alg} is not supported either by JOSE or your javascript runtime`);
    }
}

});

parcelRequire.register("gVMHg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c537be6630d4afd2$export$2e2bcd8739ae039; });
var $c537be6630d4afd2$export$2e2bcd8739ae039 = (alg, key)=>{
    if (alg.startsWith("RS") || alg.startsWith("PS")) {
        const { modulusLength: modulusLength } = key.algorithm;
        if (typeof modulusLength !== "number" || modulusLength < 2048) throw new TypeError(`${alg} requires key modulusLength to be 2048 bits or larger`);
    }
};

});


parcelRequire.register("aAX83", function(module, exports) {

$parcel$export(module.exports, "bitLength", function () { return $7b6b21f7cd8f21db$export$db433e85ac514a95; });
$parcel$export(module.exports, "default", function () { return $7b6b21f7cd8f21db$export$2e2bcd8739ae039; });

var $22n7Y = parcelRequire("22n7Y");

var $lNduJ = parcelRequire("lNduJ");
function $7b6b21f7cd8f21db$export$db433e85ac514a95(alg) {
    switch(alg){
        case "A128GCM":
            return 128;
        case "A192GCM":
            return 192;
        case "A256GCM":
        case "A128CBC-HS256":
            return 256;
        case "A192CBC-HS384":
            return 384;
        case "A256CBC-HS512":
            return 512;
        default:
            throw new (0, $22n7Y.JOSENotSupported)(`Unsupported JWE Algorithm: ${alg}`);
    }
}
var $7b6b21f7cd8f21db$export$2e2bcd8739ae039 = (alg)=>(0, $lNduJ.default)(new Uint8Array($7b6b21f7cd8f21db$export$db433e85ac514a95(alg) >> 3));

});

parcelRequire.register("i50Kz", function(module, exports) {

$parcel$export(module.exports, "importJWK", function () { return $d299469a06ae90e9$export$2b70d37b4d0b888b; });

var $gQjU9 = parcelRequire("gQjU9");

var $fyTBI = parcelRequire("fyTBI");

var $1fbgL = parcelRequire("1fbgL");

var $22n7Y = parcelRequire("22n7Y");

var $36w7K = parcelRequire("36w7K");
async function $d299469a06ae90e9$export$7cdfc961c11d0266(spki, alg, options) {
    if (typeof spki !== "string" || spki.indexOf("-----BEGIN PUBLIC KEY-----") !== 0) throw new TypeError('"spki" must be SPKI formatted string');
    return (0, $fyTBI.fromSPKI)(spki, alg, options);
}
async function $d299469a06ae90e9$export$948757ecbbf4a918(x509, alg, options) {
    if (typeof x509 !== "string" || x509.indexOf("-----BEGIN CERTIFICATE-----") !== 0) throw new TypeError('"x509" must be X.509 formatted string');
    return (0, $fyTBI.fromX509)(x509, alg, options);
}
async function $d299469a06ae90e9$export$17f5e7f6d2848df5(pkcs8, alg, options) {
    if (typeof pkcs8 !== "string" || pkcs8.indexOf("-----BEGIN PRIVATE KEY-----") !== 0) throw new TypeError('"pkcs8" must be PKCS#8 formatted string');
    return (0, $fyTBI.fromPKCS8)(pkcs8, alg, options);
}
async function $d299469a06ae90e9$export$2b70d37b4d0b888b(jwk, alg) {
    if (!(0, $36w7K.default)(jwk)) throw new TypeError("JWK must be an object");
    alg || (alg = jwk.alg);
    switch(jwk.kty){
        case "oct":
            if (typeof jwk.k !== "string" || !jwk.k) throw new TypeError('missing "k" (Key Value) Parameter value');
            return (0, $gQjU9.decode)(jwk.k);
        case "RSA":
            if (jwk.oth !== undefined) throw new (0, $22n7Y.JOSENotSupported)('RSA JWK "oth" (Other Primes Info) Parameter value is not supported');
        case "EC":
        case "OKP":
            return (0, $1fbgL.default)({
                ...jwk,
                alg: alg
            });
        default:
            throw new (0, $22n7Y.JOSENotSupported)('Unsupported "kty" (Key Type) Parameter value');
    }
}

});
parcelRequire.register("fyTBI", function(module, exports) {

$parcel$export(module.exports, "toSPKI", function () { return $b5452a6d4afea361$export$cfba7e924fe414ca; });
$parcel$export(module.exports, "toPKCS8", function () { return $b5452a6d4afea361$export$cac76a78a90b914d; });
$parcel$export(module.exports, "fromPKCS8", function () { return $b5452a6d4afea361$export$224b0a6339c7267f; });
$parcel$export(module.exports, "fromSPKI", function () { return $b5452a6d4afea361$export$f9a3505cdaa1fb3e; });
$parcel$export(module.exports, "fromX509", function () { return $b5452a6d4afea361$export$ed788b6a8533858f; });

var $b5yyA = parcelRequire("b5yyA");

var $7ywXS = parcelRequire("7ywXS");

var $gQjU9 = parcelRequire("gQjU9");

var $bkbiP = parcelRequire("bkbiP");

var $22n7Y = parcelRequire("22n7Y");

var $lNabF = parcelRequire("lNabF");
const $b5452a6d4afea361$var$genericExport = async (keyType, keyFormat, key)=>{
    if (!(0, $b5yyA.isCryptoKey)(key)) throw new TypeError((0, $7ywXS.default)(key, ...(0, $lNabF.types)));
    if (!key.extractable) throw new TypeError("CryptoKey is not extractable");
    if (key.type !== keyType) throw new TypeError(`key is not a ${keyType} key`);
    return (0, $bkbiP.default)((0, $gQjU9.encodeBase64)(new Uint8Array(await (0, $b5yyA.default).subtle.exportKey(keyFormat, key))), `${keyType.toUpperCase()} KEY`);
};
const $b5452a6d4afea361$export$cfba7e924fe414ca = (key)=>{
    return $b5452a6d4afea361$var$genericExport("public", "spki", key);
};
const $b5452a6d4afea361$export$cac76a78a90b914d = (key)=>{
    return $b5452a6d4afea361$var$genericExport("private", "pkcs8", key);
};
const $b5452a6d4afea361$var$findOid = (keyData, oid, from = 0)=>{
    if (from === 0) {
        oid.unshift(oid.length);
        oid.unshift(0x06);
    }
    const i = keyData.indexOf(oid[0], from);
    if (i === -1) return false;
    const sub = keyData.subarray(i, i + oid.length);
    if (sub.length !== oid.length) return false;
    return sub.every((value, index)=>value === oid[index]) || $b5452a6d4afea361$var$findOid(keyData, oid, i + 1);
};
const $b5452a6d4afea361$var$getNamedCurve = (keyData)=>{
    switch(true){
        case $b5452a6d4afea361$var$findOid(keyData, [
            0x2a,
            0x86,
            0x48,
            0xce,
            0x3d,
            0x03,
            0x01,
            0x07
        ]):
            return "P-256";
        case $b5452a6d4afea361$var$findOid(keyData, [
            0x2b,
            0x81,
            0x04,
            0x00,
            0x22
        ]):
            return "P-384";
        case $b5452a6d4afea361$var$findOid(keyData, [
            0x2b,
            0x81,
            0x04,
            0x00,
            0x23
        ]):
            return "P-521";
        case $b5452a6d4afea361$var$findOid(keyData, [
            0x2b,
            0x65,
            0x6e
        ]):
            return "X25519";
        case $b5452a6d4afea361$var$findOid(keyData, [
            0x2b,
            0x65,
            0x6f
        ]):
            return "X448";
        case $b5452a6d4afea361$var$findOid(keyData, [
            0x2b,
            0x65,
            0x70
        ]):
            return "Ed25519";
        case $b5452a6d4afea361$var$findOid(keyData, [
            0x2b,
            0x65,
            0x71
        ]):
            return "Ed448";
        default:
            throw new (0, $22n7Y.JOSENotSupported)("Invalid or unsupported EC Key Curve or OKP Key Sub Type");
    }
};
const $b5452a6d4afea361$var$genericImport = async (replace, keyFormat, pem, alg, options)=>{
    let algorithm;
    let keyUsages;
    const keyData = new Uint8Array(atob(pem.replace(replace, "")).split("").map((c)=>c.charCodeAt(0)));
    const isPublic = keyFormat === "spki";
    switch(alg){
        case "PS256":
        case "PS384":
        case "PS512":
            algorithm = {
                name: "RSA-PSS",
                hash: `SHA-${alg.slice(-3)}`
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "RS256":
        case "RS384":
        case "RS512":
            algorithm = {
                name: "RSASSA-PKCS1-v1_5",
                hash: `SHA-${alg.slice(-3)}`
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            algorithm = {
                name: "RSA-OAEP",
                hash: `SHA-${parseInt(alg.slice(-3), 10) || 1}`
            };
            keyUsages = isPublic ? [
                "encrypt",
                "wrapKey"
            ] : [
                "decrypt",
                "unwrapKey"
            ];
            break;
        case "ES256":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-256"
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "ES384":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-384"
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "ES512":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-521"
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                const namedCurve = $b5452a6d4afea361$var$getNamedCurve(keyData);
                algorithm = namedCurve.startsWith("P-") ? {
                    name: "ECDH",
                    namedCurve: namedCurve
                } : {
                    name: namedCurve
                };
                keyUsages = isPublic ? [] : [
                    "deriveBits"
                ];
                break;
            }
        case "EdDSA":
            algorithm = {
                name: $b5452a6d4afea361$var$getNamedCurve(keyData)
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        default:
            throw new (0, $22n7Y.JOSENotSupported)('Invalid or unsupported "alg" (Algorithm) value');
    }
    return (0, $b5yyA.default).subtle.importKey(keyFormat, keyData, algorithm, options?.extractable ?? false, keyUsages);
};
const $b5452a6d4afea361$export$224b0a6339c7267f = (pem, alg, options)=>{
    return $b5452a6d4afea361$var$genericImport(/(?:-----(?:BEGIN|END) PRIVATE KEY-----|\s)/g, "pkcs8", pem, alg, options);
};
const $b5452a6d4afea361$export$f9a3505cdaa1fb3e = (pem, alg, options)=>{
    return $b5452a6d4afea361$var$genericImport(/(?:-----(?:BEGIN|END) PUBLIC KEY-----|\s)/g, "spki", pem, alg, options);
};
function $b5452a6d4afea361$var$getElement(seq) {
    const result = [];
    let next = 0;
    while(next < seq.length){
        const nextPart = $b5452a6d4afea361$var$parseElement(seq.subarray(next));
        result.push(nextPart);
        next += nextPart.byteLength;
    }
    return result;
}
function $b5452a6d4afea361$var$parseElement(bytes) {
    let position = 0;
    let tag = bytes[0] & 0x1f;
    position++;
    if (tag === 0x1f) {
        tag = 0;
        while(bytes[position] >= 0x80){
            tag = tag * 128 + bytes[position] - 0x80;
            position++;
        }
        tag = tag * 128 + bytes[position] - 0x80;
        position++;
    }
    let length = 0;
    if (bytes[position] < 0x80) {
        length = bytes[position];
        position++;
    } else if (length === 0x80) {
        length = 0;
        while(bytes[position + length] !== 0 || bytes[position + length + 1] !== 0){
            if (length > bytes.byteLength) throw new TypeError("invalid indefinite form length");
            length++;
        }
        const byteLength = position + length + 2;
        return {
            byteLength: byteLength,
            contents: bytes.subarray(position, position + length),
            raw: bytes.subarray(0, byteLength)
        };
    } else {
        const numberOfDigits = bytes[position] & 0x7f;
        position++;
        length = 0;
        for(let i = 0; i < numberOfDigits; i++){
            length = length * 256 + bytes[position];
            position++;
        }
    }
    const byteLength = position + length;
    return {
        byteLength: byteLength,
        contents: bytes.subarray(position, byteLength),
        raw: bytes.subarray(0, byteLength)
    };
}
function $b5452a6d4afea361$var$spkiFromX509(buf) {
    const tbsCertificate = $b5452a6d4afea361$var$getElement($b5452a6d4afea361$var$getElement($b5452a6d4afea361$var$parseElement(buf).contents)[0].contents);
    return (0, $gQjU9.encodeBase64)(tbsCertificate[tbsCertificate[0].raw[0] === 0xa0 ? 6 : 5].raw);
}
function $b5452a6d4afea361$var$getSPKI(x509) {
    const pem = x509.replace(/(?:-----(?:BEGIN|END) CERTIFICATE-----|\s)/g, "");
    const raw = (0, $gQjU9.decodeBase64)(pem);
    return (0, $bkbiP.default)($b5452a6d4afea361$var$spkiFromX509(raw), "PUBLIC KEY");
}
const $b5452a6d4afea361$export$ed788b6a8533858f = (pem, alg, options)=>{
    let spki;
    try {
        spki = $b5452a6d4afea361$var$getSPKI(pem);
    } catch (cause) {
        throw new TypeError("Failed to parse the X.509 certificate", {
            cause: cause
        });
    }
    return $b5452a6d4afea361$export$f9a3505cdaa1fb3e(spki, alg, options);
};

});
parcelRequire.register("bkbiP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83ea546b996c51f3$export$2e2bcd8739ae039; });
var $83ea546b996c51f3$export$2e2bcd8739ae039 = (b64, descriptor)=>{
    const newlined = (b64.match(/.{1,64}/g) || []).join("\n");
    return `-----BEGIN ${descriptor}-----\n${newlined}\n-----END ${descriptor}-----`;
};

});


parcelRequire.register("1fbgL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e7fef034a8e1151$export$2e2bcd8739ae039; });

var $b5yyA = parcelRequire("b5yyA");

var $22n7Y = parcelRequire("22n7Y");
function $0e7fef034a8e1151$var$subtleMapping(jwk) {
    let algorithm;
    let keyUsages;
    switch(jwk.kty){
        case "RSA":
            switch(jwk.alg){
                case "PS256":
                case "PS384":
                case "PS512":
                    algorithm = {
                        name: "RSA-PSS",
                        hash: `SHA-${jwk.alg.slice(-3)}`
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "RS256":
                case "RS384":
                case "RS512":
                    algorithm = {
                        name: "RSASSA-PKCS1-v1_5",
                        hash: `SHA-${jwk.alg.slice(-3)}`
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "RSA-OAEP":
                case "RSA-OAEP-256":
                case "RSA-OAEP-384":
                case "RSA-OAEP-512":
                    algorithm = {
                        name: "RSA-OAEP",
                        hash: `SHA-${parseInt(jwk.alg.slice(-3), 10) || 1}`
                    };
                    keyUsages = jwk.d ? [
                        "decrypt",
                        "unwrapKey"
                    ] : [
                        "encrypt",
                        "wrapKey"
                    ];
                    break;
                default:
                    throw new (0, $22n7Y.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case "EC":
            switch(jwk.alg){
                case "ES256":
                    algorithm = {
                        name: "ECDSA",
                        namedCurve: "P-256"
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ES384":
                    algorithm = {
                        name: "ECDSA",
                        namedCurve: "P-384"
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ES512":
                    algorithm = {
                        name: "ECDSA",
                        namedCurve: "P-521"
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ECDH-ES":
                case "ECDH-ES+A128KW":
                case "ECDH-ES+A192KW":
                case "ECDH-ES+A256KW":
                    algorithm = {
                        name: "ECDH",
                        namedCurve: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        "deriveBits"
                    ] : [];
                    break;
                default:
                    throw new (0, $22n7Y.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case "OKP":
            switch(jwk.alg){
                case "EdDSA":
                    algorithm = {
                        name: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ECDH-ES":
                case "ECDH-ES+A128KW":
                case "ECDH-ES+A192KW":
                case "ECDH-ES+A256KW":
                    algorithm = {
                        name: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        "deriveBits"
                    ] : [];
                    break;
                default:
                    throw new (0, $22n7Y.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        default:
            throw new (0, $22n7Y.JOSENotSupported)('Invalid or unsupported JWK "kty" (Key Type) Parameter value');
    }
    return {
        algorithm: algorithm,
        keyUsages: keyUsages
    };
}
const $0e7fef034a8e1151$var$parse = async (jwk)=>{
    if (!jwk.alg) throw new TypeError('"alg" argument is required when "jwk.alg" is not present');
    const { algorithm: algorithm, keyUsages: keyUsages } = $0e7fef034a8e1151$var$subtleMapping(jwk);
    const rest = [
        algorithm,
        jwk.ext ?? false,
        jwk.key_ops ?? keyUsages
    ];
    const keyData = {
        ...jwk
    };
    delete keyData.alg;
    delete keyData.use;
    return (0, $b5yyA.default).subtle.importKey("jwk", keyData, ...rest);
};
var $0e7fef034a8e1151$export$2e2bcd8739ae039 = $0e7fef034a8e1151$var$parse;

});


parcelRequire.register("TQWvz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a7e347b6adae956$export$2e2bcd8739ae039; });

var $7ywXS = parcelRequire("7ywXS");

var $lNabF = parcelRequire("lNabF");
const $0a7e347b6adae956$var$symmetricTypeCheck = (alg, key)=>{
    if (key instanceof Uint8Array) return;
    if (!(0, $lNabF.default)(key)) throw new TypeError((0, $7ywXS.withAlg)(alg, key, ...(0, $lNabF.types), "Uint8Array"));
    if (key.type !== "secret") throw new TypeError(`${(0, $lNabF.types).join(" or ")} instances for symmetric algorithms must be of type "secret"`);
};
const $0a7e347b6adae956$var$asymmetricTypeCheck = (alg, key, usage)=>{
    if (!(0, $lNabF.default)(key)) throw new TypeError((0, $7ywXS.withAlg)(alg, key, ...(0, $lNabF.types)));
    if (key.type === "secret") throw new TypeError(`${(0, $lNabF.types).join(" or ")} instances for asymmetric algorithms must not be of type "secret"`);
    if (usage === "sign" && key.type === "public") throw new TypeError(`${(0, $lNabF.types).join(" or ")} instances for asymmetric algorithm signing must be of type "private"`);
    if (usage === "decrypt" && key.type === "public") throw new TypeError(`${(0, $lNabF.types).join(" or ")} instances for asymmetric algorithm decryption must be of type "private"`);
    if (key.algorithm && usage === "verify" && key.type === "private") throw new TypeError(`${(0, $lNabF.types).join(" or ")} instances for asymmetric algorithm verifying must be of type "public"`);
    if (key.algorithm && usage === "encrypt" && key.type === "private") throw new TypeError(`${(0, $lNabF.types).join(" or ")} instances for asymmetric algorithm encryption must be of type "public"`);
};
const $0a7e347b6adae956$var$checkKeyType = (alg, key, usage)=>{
    const symmetric = alg.startsWith("HS") || alg === "dir" || alg.startsWith("PBES2") || /^A\d{3}(?:GCM)?KW$/.test(alg);
    if (symmetric) $0a7e347b6adae956$var$symmetricTypeCheck(alg, key);
    else $0a7e347b6adae956$var$asymmetricTypeCheck(alg, key, usage);
};
var $0a7e347b6adae956$export$2e2bcd8739ae039 = $0a7e347b6adae956$var$checkKeyType;

});

parcelRequire.register("84uLC", function(module, exports) {

$parcel$export(module.exports, "wrap", function () { return $5e069021e1822ca7$export$4997ffc0176396a6; });
$parcel$export(module.exports, "unwrap", function () { return $5e069021e1822ca7$export$debb760848ca95a; });

var $1XUEy = parcelRequire("1XUEy");

var $1bzHM = parcelRequire("1bzHM");

var $4kPpN = parcelRequire("4kPpN");

var $gQjU9 = parcelRequire("gQjU9");
async function $5e069021e1822ca7$export$4997ffc0176396a6(alg, key, cek, iv) {
    const jweAlgorithm = alg.slice(0, 7);
    iv || (iv = (0, $4kPpN.default)(jweAlgorithm));
    const { ciphertext: encryptedKey, tag: tag } = await (0, $1XUEy.default)(jweAlgorithm, cek, key, iv, new Uint8Array(0));
    return {
        encryptedKey: encryptedKey,
        iv: (0, $gQjU9.encode)(iv),
        tag: (0, $gQjU9.encode)(tag)
    };
}
async function $5e069021e1822ca7$export$debb760848ca95a(alg, key, encryptedKey, iv, tag) {
    const jweAlgorithm = alg.slice(0, 7);
    return (0, $1bzHM.default)(jweAlgorithm, key, encryptedKey, iv, tag, new Uint8Array(0));
}

});
parcelRequire.register("1XUEy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16e73f3c5e581cca$export$2e2bcd8739ae039; });

var $hBRjO = parcelRequire("hBRjO");

var $6X3Ct = parcelRequire("6X3Ct");

var $lff5h = parcelRequire("lff5h");

var $b5yyA = parcelRequire("b5yyA");

var $5ap99 = parcelRequire("5ap99");

var $7ywXS = parcelRequire("7ywXS");

var $22n7Y = parcelRequire("22n7Y");

var $lNabF = parcelRequire("lNabF");
async function $16e73f3c5e581cca$var$cbcEncrypt(enc, plaintext, cek, iv, aad) {
    if (!(cek instanceof Uint8Array)) throw new TypeError((0, $7ywXS.default)(cek, "Uint8Array"));
    const keySize = parseInt(enc.slice(1, 4), 10);
    const encKey = await (0, $b5yyA.default).subtle.importKey("raw", cek.subarray(keySize >> 3), "AES-CBC", false, [
        "encrypt"
    ]);
    const macKey = await (0, $b5yyA.default).subtle.importKey("raw", cek.subarray(0, keySize >> 3), {
        hash: `SHA-${keySize << 1}`,
        name: "HMAC"
    }, false, [
        "sign"
    ]);
    const ciphertext = new Uint8Array(await (0, $b5yyA.default).subtle.encrypt({
        iv: iv,
        name: "AES-CBC"
    }, encKey, plaintext));
    const macData = (0, $hBRjO.concat)(aad, iv, ciphertext, (0, $hBRjO.uint64be)(aad.length << 3));
    const tag = new Uint8Array((await (0, $b5yyA.default).subtle.sign("HMAC", macKey, macData)).slice(0, keySize >> 3));
    return {
        ciphertext: ciphertext,
        tag: tag
    };
}
async function $16e73f3c5e581cca$var$gcmEncrypt(enc, plaintext, cek, iv, aad) {
    let encKey;
    if (cek instanceof Uint8Array) encKey = await (0, $b5yyA.default).subtle.importKey("raw", cek, "AES-GCM", false, [
        "encrypt"
    ]);
    else {
        (0, $5ap99.checkEncCryptoKey)(cek, enc, "encrypt");
        encKey = cek;
    }
    const encrypted = new Uint8Array(await (0, $b5yyA.default).subtle.encrypt({
        additionalData: aad,
        iv: iv,
        name: "AES-GCM",
        tagLength: 128
    }, encKey, plaintext));
    const tag = encrypted.slice(-16);
    const ciphertext = encrypted.slice(0, -16);
    return {
        ciphertext: ciphertext,
        tag: tag
    };
}
const $16e73f3c5e581cca$var$encrypt = async (enc, plaintext, cek, iv, aad)=>{
    if (!(0, $b5yyA.isCryptoKey)(cek) && !(cek instanceof Uint8Array)) throw new TypeError((0, $7ywXS.default)(cek, ...(0, $lNabF.types), "Uint8Array"));
    (0, $6X3Ct.default)(enc, iv);
    switch(enc){
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            if (cek instanceof Uint8Array) (0, $lff5h.default)(cek, parseInt(enc.slice(-3), 10));
            return $16e73f3c5e581cca$var$cbcEncrypt(enc, plaintext, cek, iv, aad);
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            if (cek instanceof Uint8Array) (0, $lff5h.default)(cek, parseInt(enc.slice(1, 4), 10));
            return $16e73f3c5e581cca$var$gcmEncrypt(enc, plaintext, cek, iv, aad);
        default:
            throw new (0, $22n7Y.JOSENotSupported)("Unsupported JWE Content Encryption Algorithm");
    }
};
var $16e73f3c5e581cca$export$2e2bcd8739ae039 = $16e73f3c5e581cca$var$encrypt;

});



parcelRequire.register("jtVF0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2ed73ed8ae48301$export$2e2bcd8739ae039; });

var $22n7Y = parcelRequire("22n7Y");
function $e2ed73ed8ae48301$var$validateCrit(Err, recognizedDefault, recognizedOption, protectedHeader, joseHeader) {
    if (joseHeader.crit !== undefined && protectedHeader.crit === undefined) throw new Err('"crit" (Critical) Header Parameter MUST be integrity protected');
    if (!protectedHeader || protectedHeader.crit === undefined) return new Set();
    if (!Array.isArray(protectedHeader.crit) || protectedHeader.crit.length === 0 || protectedHeader.crit.some((input)=>typeof input !== "string" || input.length === 0)) throw new Err('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
    let recognized;
    if (recognizedOption !== undefined) recognized = new Map([
        ...Object.entries(recognizedOption),
        ...recognizedDefault.entries()
    ]);
    else recognized = recognizedDefault;
    for (const parameter of protectedHeader.crit){
        if (!recognized.has(parameter)) throw new (0, $22n7Y.JOSENotSupported)(`Extension Header Parameter "${parameter}" is not recognized`);
        if (joseHeader[parameter] === undefined) throw new Err(`Extension Header Parameter "${parameter}" is missing`);
        if (recognized.get(parameter) && protectedHeader[parameter] === undefined) throw new Err(`Extension Header Parameter "${parameter}" MUST be integrity protected`);
    }
    return new Set(protectedHeader.crit);
}
var $e2ed73ed8ae48301$export$2e2bcd8739ae039 = $e2ed73ed8ae48301$var$validateCrit;

});

parcelRequire.register("huFnR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbc556fbe7137067$export$2e2bcd8739ae039; });
const $cbc556fbe7137067$var$validateAlgorithms = (option, algorithms)=>{
    if (algorithms !== undefined && (!Array.isArray(algorithms) || algorithms.some((s)=>typeof s !== "string"))) throw new TypeError(`"${option}" option must be an array of strings`);
    if (!algorithms) return undefined;
    return new Set(algorithms);
};
var $cbc556fbe7137067$export$2e2bcd8739ae039 = $cbc556fbe7137067$var$validateAlgorithms;

});



parcelRequire.register("dOOtZ", function(module, exports) {

var $c4eVB = parcelRequire("c4eVB");

var $22n7Y = parcelRequire("22n7Y");

var $36w7K = parcelRequire("36w7K");
async function $a0f71ab50aea1e19$export$56bc728c88264430(jwe, key, options) {
    if (!(0, $36w7K.default)(jwe)) throw new (0, $22n7Y.JWEInvalid)("General JWE must be an object");
    if (!Array.isArray(jwe.recipients) || !jwe.recipients.every((0, $36w7K.default))) throw new (0, $22n7Y.JWEInvalid)("JWE Recipients missing or incorrect type");
    if (!jwe.recipients.length) throw new (0, $22n7Y.JWEInvalid)("JWE Recipients has no members");
    for (const recipient of jwe.recipients)try {
        return await (0, $c4eVB.flattenedDecrypt)({
            aad: jwe.aad,
            ciphertext: jwe.ciphertext,
            encrypted_key: recipient.encrypted_key,
            header: recipient.header,
            iv: jwe.iv,
            protected: jwe.protected,
            tag: jwe.tag,
            unprotected: jwe.unprotected
        }, key, options);
    } catch  {}
    throw new (0, $22n7Y.JWEDecryptionFailed)();
}

});

parcelRequire.register("jaCiA", function(module, exports) {

var $aG3Rw = parcelRequire("aG3Rw");

var $22n7Y = parcelRequire("22n7Y");

var $aAX83 = parcelRequire("aAX83");

var $6jtNr = parcelRequire("6jtNr");

var $7YxM4 = parcelRequire("7YxM4");

var $gQjU9 = parcelRequire("gQjU9");

var $jtVF0 = parcelRequire("jtVF0");
class $df4ca8d6851fecee$var$IndividualRecipient {
    constructor(enc, key, options){
        this.parent = enc;
        this.key = key;
        this.options = options;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this.unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this.unprotectedHeader = unprotectedHeader;
        return this;
    }
    addRecipient(...args) {
        return this.parent.addRecipient(...args);
    }
    encrypt(...args) {
        return this.parent.encrypt(...args);
    }
    done() {
        return this.parent;
    }
}
class $df4ca8d6851fecee$export$44234adffc6b0b92 {
    constructor(plaintext){
        this._recipients = [];
        this._plaintext = plaintext;
    }
    addRecipient(key, options) {
        const recipient = new $df4ca8d6851fecee$var$IndividualRecipient(this, key, {
            crit: options?.crit
        });
        this._recipients.push(recipient);
        return recipient;
    }
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setSharedUnprotectedHeader(sharedUnprotectedHeader) {
        if (this._unprotectedHeader) throw new TypeError("setSharedUnprotectedHeader can only be called once");
        this._unprotectedHeader = sharedUnprotectedHeader;
        return this;
    }
    setAdditionalAuthenticatedData(aad) {
        this._aad = aad;
        return this;
    }
    async encrypt() {
        if (!this._recipients.length) throw new (0, $22n7Y.JWEInvalid)("at least one recipient must be added");
        if (this._recipients.length === 1) {
            const [recipient] = this._recipients;
            const flattened = await new (0, $aG3Rw.FlattenedEncrypt)(this._plaintext).setAdditionalAuthenticatedData(this._aad).setProtectedHeader(this._protectedHeader).setSharedUnprotectedHeader(this._unprotectedHeader).setUnprotectedHeader(recipient.unprotectedHeader).encrypt(recipient.key, {
                ...recipient.options
            });
            const jwe = {
                ciphertext: flattened.ciphertext,
                iv: flattened.iv,
                recipients: [
                    {}
                ],
                tag: flattened.tag
            };
            if (flattened.aad) jwe.aad = flattened.aad;
            if (flattened.protected) jwe.protected = flattened.protected;
            if (flattened.unprotected) jwe.unprotected = flattened.unprotected;
            if (flattened.encrypted_key) jwe.recipients[0].encrypted_key = flattened.encrypted_key;
            if (flattened.header) jwe.recipients[0].header = flattened.header;
            return jwe;
        }
        let enc;
        for(let i = 0; i < this._recipients.length; i++){
            const recipient = this._recipients[i];
            if (!(0, $6jtNr.default)(this._protectedHeader, this._unprotectedHeader, recipient.unprotectedHeader)) throw new (0, $22n7Y.JWEInvalid)("JWE Protected, JWE Shared Unprotected and JWE Per-Recipient Header Parameter names must be disjoint");
            const joseHeader = {
                ...this._protectedHeader,
                ...this._unprotectedHeader,
                ...recipient.unprotectedHeader
            };
            const { alg: alg } = joseHeader;
            if (typeof alg !== "string" || !alg) throw new (0, $22n7Y.JWEInvalid)('JWE "alg" (Algorithm) Header Parameter missing or invalid');
            if (alg === "dir" || alg === "ECDH-ES") throw new (0, $22n7Y.JWEInvalid)('"dir" and "ECDH-ES" alg may only be used with a single recipient');
            if (typeof joseHeader.enc !== "string" || !joseHeader.enc) throw new (0, $22n7Y.JWEInvalid)('JWE "enc" (Encryption Algorithm) Header Parameter missing or invalid');
            if (!enc) enc = joseHeader.enc;
            else if (enc !== joseHeader.enc) throw new (0, $22n7Y.JWEInvalid)('JWE "enc" (Encryption Algorithm) Header Parameter must be the same for all recipients');
            (0, $jtVF0.default)((0, $22n7Y.JWEInvalid), new Map(), recipient.options.crit, this._protectedHeader, joseHeader);
            if (joseHeader.zip !== undefined) throw new (0, $22n7Y.JOSENotSupported)('JWE "zip" (Compression Algorithm) Header Parameter is not supported.');
        }
        const cek = (0, $aAX83.default)(enc);
        const jwe = {
            ciphertext: "",
            iv: "",
            recipients: [],
            tag: ""
        };
        for(let i = 0; i < this._recipients.length; i++){
            const recipient = this._recipients[i];
            const target = {};
            jwe.recipients.push(target);
            const joseHeader = {
                ...this._protectedHeader,
                ...this._unprotectedHeader,
                ...recipient.unprotectedHeader
            };
            const p2c = joseHeader.alg.startsWith("PBES2") ? 2048 + i : undefined;
            if (i === 0) {
                const flattened = await new (0, $aG3Rw.FlattenedEncrypt)(this._plaintext).setAdditionalAuthenticatedData(this._aad).setContentEncryptionKey(cek).setProtectedHeader(this._protectedHeader).setSharedUnprotectedHeader(this._unprotectedHeader).setUnprotectedHeader(recipient.unprotectedHeader).setKeyManagementParameters({
                    p2c: p2c
                }).encrypt(recipient.key, {
                    ...recipient.options,
                    [(0, $aG3Rw.unprotected)]: true
                });
                jwe.ciphertext = flattened.ciphertext;
                jwe.iv = flattened.iv;
                jwe.tag = flattened.tag;
                if (flattened.aad) jwe.aad = flattened.aad;
                if (flattened.protected) jwe.protected = flattened.protected;
                if (flattened.unprotected) jwe.unprotected = flattened.unprotected;
                target.encrypted_key = flattened.encrypted_key;
                if (flattened.header) target.header = flattened.header;
                continue;
            }
            const { encryptedKey: encryptedKey, parameters: parameters } = await (0, $7YxM4.default)(recipient.unprotectedHeader?.alg || this._protectedHeader?.alg || this._unprotectedHeader?.alg, enc, recipient.key, cek, {
                p2c: p2c
            });
            target.encrypted_key = (0, $gQjU9.encode)(encryptedKey);
            if (recipient.unprotectedHeader || parameters) target.header = {
                ...recipient.unprotectedHeader,
                ...parameters
            };
        }
        return jwe;
    }
}

});
parcelRequire.register("aG3Rw", function(module, exports) {

$parcel$export(module.exports, "unprotected", function () { return $7c60d29d8961b1b6$export$39c45cb77eaf132; });
$parcel$export(module.exports, "FlattenedEncrypt", function () { return $7c60d29d8961b1b6$export$eec23736d3c24809; });

var $gQjU9 = parcelRequire("gQjU9");

var $1XUEy = parcelRequire("1XUEy");

var $4kPpN = parcelRequire("4kPpN");

var $7YxM4 = parcelRequire("7YxM4");

var $22n7Y = parcelRequire("22n7Y");

var $6jtNr = parcelRequire("6jtNr");

var $hBRjO = parcelRequire("hBRjO");

var $jtVF0 = parcelRequire("jtVF0");
const $7c60d29d8961b1b6$export$39c45cb77eaf132 = Symbol();
class $7c60d29d8961b1b6$export$eec23736d3c24809 {
    constructor(plaintext){
        if (!(plaintext instanceof Uint8Array)) throw new TypeError("plaintext must be an instance of Uint8Array");
        this._plaintext = plaintext;
    }
    setKeyManagementParameters(parameters) {
        if (this._keyManagementParameters) throw new TypeError("setKeyManagementParameters can only be called once");
        this._keyManagementParameters = parameters;
        return this;
    }
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setSharedUnprotectedHeader(sharedUnprotectedHeader) {
        if (this._sharedUnprotectedHeader) throw new TypeError("setSharedUnprotectedHeader can only be called once");
        this._sharedUnprotectedHeader = sharedUnprotectedHeader;
        return this;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this._unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this._unprotectedHeader = unprotectedHeader;
        return this;
    }
    setAdditionalAuthenticatedData(aad) {
        this._aad = aad;
        return this;
    }
    setContentEncryptionKey(cek) {
        if (this._cek) throw new TypeError("setContentEncryptionKey can only be called once");
        this._cek = cek;
        return this;
    }
    setInitializationVector(iv) {
        if (this._iv) throw new TypeError("setInitializationVector can only be called once");
        this._iv = iv;
        return this;
    }
    async encrypt(key, options) {
        if (!this._protectedHeader && !this._unprotectedHeader && !this._sharedUnprotectedHeader) throw new (0, $22n7Y.JWEInvalid)("either setProtectedHeader, setUnprotectedHeader, or sharedUnprotectedHeader must be called before #encrypt()");
        if (!(0, $6jtNr.default)(this._protectedHeader, this._unprotectedHeader, this._sharedUnprotectedHeader)) throw new (0, $22n7Y.JWEInvalid)("JWE Protected, JWE Shared Unprotected and JWE Per-Recipient Header Parameter names must be disjoint");
        const joseHeader = {
            ...this._protectedHeader,
            ...this._unprotectedHeader,
            ...this._sharedUnprotectedHeader
        };
        (0, $jtVF0.default)((0, $22n7Y.JWEInvalid), new Map(), options?.crit, this._protectedHeader, joseHeader);
        if (joseHeader.zip !== undefined) throw new (0, $22n7Y.JOSENotSupported)('JWE "zip" (Compression Algorithm) Header Parameter is not supported.');
        const { alg: alg, enc: enc } = joseHeader;
        if (typeof alg !== "string" || !alg) throw new (0, $22n7Y.JWEInvalid)('JWE "alg" (Algorithm) Header Parameter missing or invalid');
        if (typeof enc !== "string" || !enc) throw new (0, $22n7Y.JWEInvalid)('JWE "enc" (Encryption Algorithm) Header Parameter missing or invalid');
        let encryptedKey;
        if (alg === "dir") {
            if (this._cek) throw new TypeError("setContentEncryptionKey cannot be called when using Direct Encryption");
        } else if (alg === "ECDH-ES") {
            if (this._cek) throw new TypeError("setContentEncryptionKey cannot be called when using Direct Key Agreement");
        }
        let cek;
        {
            let parameters;
            ({ cek: cek, encryptedKey: encryptedKey, parameters: parameters } = await (0, $7YxM4.default)(alg, enc, key, this._cek, this._keyManagementParameters));
            if (parameters) {
                if (options && $7c60d29d8961b1b6$export$39c45cb77eaf132 in options) {
                    if (!this._unprotectedHeader) this.setUnprotectedHeader(parameters);
                    else this._unprotectedHeader = {
                        ...this._unprotectedHeader,
                        ...parameters
                    };
                } else if (!this._protectedHeader) this.setProtectedHeader(parameters);
                else this._protectedHeader = {
                    ...this._protectedHeader,
                    ...parameters
                };
            }
        }
        this._iv || (this._iv = (0, $4kPpN.default)(enc));
        let additionalData;
        let protectedHeader;
        let aadMember;
        if (this._protectedHeader) protectedHeader = (0, $hBRjO.encoder).encode((0, $gQjU9.encode)(JSON.stringify(this._protectedHeader)));
        else protectedHeader = (0, $hBRjO.encoder).encode("");
        if (this._aad) {
            aadMember = (0, $gQjU9.encode)(this._aad);
            additionalData = (0, $hBRjO.concat)(protectedHeader, (0, $hBRjO.encoder).encode("."), (0, $hBRjO.encoder).encode(aadMember));
        } else additionalData = protectedHeader;
        const { ciphertext: ciphertext, tag: tag } = await (0, $1XUEy.default)(enc, this._plaintext, cek, this._iv, additionalData);
        const jwe = {
            ciphertext: (0, $gQjU9.encode)(ciphertext),
            iv: (0, $gQjU9.encode)(this._iv),
            tag: (0, $gQjU9.encode)(tag)
        };
        if (encryptedKey) jwe.encrypted_key = (0, $gQjU9.encode)(encryptedKey);
        if (aadMember) jwe.aad = aadMember;
        if (this._protectedHeader) jwe.protected = (0, $hBRjO.decoder).decode(protectedHeader);
        if (this._sharedUnprotectedHeader) jwe.unprotected = this._sharedUnprotectedHeader;
        if (this._unprotectedHeader) jwe.header = this._unprotectedHeader;
        return jwe;
    }
}

});
parcelRequire.register("7YxM4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ce855e33e12b0cc$export$2e2bcd8739ae039; });

var $bnY3q = parcelRequire("bnY3q");

var $bwIOL = parcelRequire("bwIOL");

var $k8ahq = parcelRequire("k8ahq");

var $8Kqgm = parcelRequire("8Kqgm");

var $gQjU9 = parcelRequire("gQjU9");

var $aAX83 = parcelRequire("aAX83");

var $22n7Y = parcelRequire("22n7Y");

var $li5Rd = parcelRequire("li5Rd");

var $TQWvz = parcelRequire("TQWvz");

var $84uLC = parcelRequire("84uLC");
async function $5ce855e33e12b0cc$var$encryptKeyManagement(alg, enc, key, providedCek, providedParameters = {}) {
    let encryptedKey;
    let parameters;
    let cek;
    (0, $TQWvz.default)(alg, key, "encrypt");
    switch(alg){
        case "dir":
            cek = key;
            break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                if (!$bwIOL.ecdhAllowed(key)) throw new (0, $22n7Y.JOSENotSupported)("ECDH with the provided key is not allowed or not supported by your javascript runtime");
                const { apu: apu, apv: apv } = providedParameters;
                let { epk: ephemeralKey } = providedParameters;
                ephemeralKey || (ephemeralKey = (await $bwIOL.generateEpk(key)).privateKey);
                const { x: x, y: y, crv: crv, kty: kty } = await (0, $li5Rd.exportJWK)(ephemeralKey);
                const sharedSecret = await $bwIOL.deriveKey(key, ephemeralKey, alg === "ECDH-ES" ? enc : alg, alg === "ECDH-ES" ? (0, $aAX83.bitLength)(enc) : parseInt(alg.slice(-5, -2), 10), apu, apv);
                parameters = {
                    epk: {
                        x: x,
                        crv: crv,
                        kty: kty
                    }
                };
                if (kty === "EC") parameters.epk.y = y;
                if (apu) parameters.apu = (0, $gQjU9.encode)(apu);
                if (apv) parameters.apv = (0, $gQjU9.encode)(apv);
                if (alg === "ECDH-ES") {
                    cek = sharedSecret;
                    break;
                }
                cek = providedCek || (0, $aAX83.default)(enc);
                const kwAlg = alg.slice(-6);
                encryptedKey = await (0, $bnY3q.wrap)(kwAlg, sharedSecret, cek);
                break;
            }
        case "RSA1_5":
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            cek = providedCek || (0, $aAX83.default)(enc);
            encryptedKey = await (0, $8Kqgm.encrypt)(alg, key, cek);
            break;
        case "PBES2-HS256+A128KW":
        case "PBES2-HS384+A192KW":
        case "PBES2-HS512+A256KW":
            {
                cek = providedCek || (0, $aAX83.default)(enc);
                const { p2c: p2c, p2s: p2s } = providedParameters;
                ({ encryptedKey: encryptedKey, ...parameters } = await (0, $k8ahq.encrypt)(alg, key, cek, p2c, p2s));
                break;
            }
        case "A128KW":
        case "A192KW":
        case "A256KW":
            cek = providedCek || (0, $aAX83.default)(enc);
            encryptedKey = await (0, $bnY3q.wrap)(alg, key, cek);
            break;
        case "A128GCMKW":
        case "A192GCMKW":
        case "A256GCMKW":
            {
                cek = providedCek || (0, $aAX83.default)(enc);
                const { iv: iv } = providedParameters;
                ({ encryptedKey: encryptedKey, ...parameters } = await (0, $84uLC.wrap)(alg, key, cek, iv));
                break;
            }
        default:
            throw new (0, $22n7Y.JOSENotSupported)('Invalid or unsupported "alg" (JWE Algorithm) header value');
    }
    return {
        cek: cek,
        encryptedKey: encryptedKey,
        parameters: parameters
    };
}
var $5ce855e33e12b0cc$export$2e2bcd8739ae039 = $5ce855e33e12b0cc$var$encryptKeyManagement;

});
parcelRequire.register("li5Rd", function(module, exports) {

$parcel$export(module.exports, "exportJWK", function () { return $f7ffd2902ab46bf8$export$ffb510cfd482ce82; });

var $fyTBI = parcelRequire("fyTBI");

var $dS2t3 = parcelRequire("dS2t3");
async function $f7ffd2902ab46bf8$export$7f687badbeed246d(key) {
    return (0, $fyTBI.toSPKI)(key);
}
async function $f7ffd2902ab46bf8$export$ba4a7192ac1a47fe(key) {
    return (0, $fyTBI.toPKCS8)(key);
}
async function $f7ffd2902ab46bf8$export$ffb510cfd482ce82(key) {
    return (0, $dS2t3.default)(key);
}

});
parcelRequire.register("dS2t3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1923b8345e9f470$export$2e2bcd8739ae039; });

var $b5yyA = parcelRequire("b5yyA");

var $7ywXS = parcelRequire("7ywXS");

var $gQjU9 = parcelRequire("gQjU9");

var $lNabF = parcelRequire("lNabF");
const $a1923b8345e9f470$var$keyToJWK = async (key)=>{
    if (key instanceof Uint8Array) return {
        kty: "oct",
        k: (0, $gQjU9.encode)(key)
    };
    if (!(0, $b5yyA.isCryptoKey)(key)) throw new TypeError((0, $7ywXS.default)(key, ...(0, $lNabF.types), "Uint8Array"));
    if (!key.extractable) throw new TypeError("non-extractable CryptoKey cannot be exported as a JWK");
    const { ext: ext, key_ops: key_ops, alg: alg, use: use, ...jwk } = await (0, $b5yyA.default).subtle.exportKey("jwk", key);
    return jwk;
};
var $a1923b8345e9f470$export$2e2bcd8739ae039 = $a1923b8345e9f470$var$keyToJWK;

});





parcelRequire.register("hxEit", function(module, exports) {

$parcel$export(module.exports, "compactVerify", function () { return $cc54c6df52f1a3a1$export$996150e72a8992e; });

var $lrQ5y = parcelRequire("lrQ5y");

var $22n7Y = parcelRequire("22n7Y");

var $hBRjO = parcelRequire("hBRjO");
async function $cc54c6df52f1a3a1$export$996150e72a8992e(jws, key, options) {
    if (jws instanceof Uint8Array) jws = (0, $hBRjO.decoder).decode(jws);
    if (typeof jws !== "string") throw new (0, $22n7Y.JWSInvalid)("Compact JWS must be a string or Uint8Array");
    const { 0: protectedHeader, 1: payload, 2: signature, length: length } = jws.split(".");
    if (length !== 3) throw new (0, $22n7Y.JWSInvalid)("Invalid Compact JWS");
    const verified = await (0, $lrQ5y.flattenedVerify)({
        payload: payload,
        protected: protectedHeader,
        signature: signature
    }, key, options);
    const result = {
        payload: verified.payload,
        protectedHeader: verified.protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: verified.key
    };
    return result;
}

});
parcelRequire.register("lrQ5y", function(module, exports) {

$parcel$export(module.exports, "flattenedVerify", function () { return $f9d48647c45bb40b$export$b2614975507c40c9; });

var $gQjU9 = parcelRequire("gQjU9");

var $j6XgI = parcelRequire("j6XgI");

var $22n7Y = parcelRequire("22n7Y");

var $hBRjO = parcelRequire("hBRjO");

var $6jtNr = parcelRequire("6jtNr");

var $36w7K = parcelRequire("36w7K");

var $TQWvz = parcelRequire("TQWvz");

var $jtVF0 = parcelRequire("jtVF0");

var $huFnR = parcelRequire("huFnR");
async function $f9d48647c45bb40b$export$b2614975507c40c9(jws, key, options) {
    if (!(0, $36w7K.default)(jws)) throw new (0, $22n7Y.JWSInvalid)("Flattened JWS must be an object");
    if (jws.protected === undefined && jws.header === undefined) throw new (0, $22n7Y.JWSInvalid)('Flattened JWS must have either of the "protected" or "header" members');
    if (jws.protected !== undefined && typeof jws.protected !== "string") throw new (0, $22n7Y.JWSInvalid)("JWS Protected Header incorrect type");
    if (jws.payload === undefined) throw new (0, $22n7Y.JWSInvalid)("JWS Payload missing");
    if (typeof jws.signature !== "string") throw new (0, $22n7Y.JWSInvalid)("JWS Signature missing or incorrect type");
    if (jws.header !== undefined && !(0, $36w7K.default)(jws.header)) throw new (0, $22n7Y.JWSInvalid)("JWS Unprotected Header incorrect type");
    let parsedProt = {};
    if (jws.protected) try {
        const protectedHeader = (0, $gQjU9.decode)(jws.protected);
        parsedProt = JSON.parse((0, $hBRjO.decoder).decode(protectedHeader));
    } catch  {
        throw new (0, $22n7Y.JWSInvalid)("JWS Protected Header is invalid");
    }
    if (!(0, $6jtNr.default)(parsedProt, jws.header)) throw new (0, $22n7Y.JWSInvalid)("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
    const joseHeader = {
        ...parsedProt,
        ...jws.header
    };
    const extensions = (0, $jtVF0.default)((0, $22n7Y.JWSInvalid), new Map([
        [
            "b64",
            true
        ]
    ]), options?.crit, parsedProt, joseHeader);
    let b64 = true;
    if (extensions.has("b64")) {
        b64 = parsedProt.b64;
        if (typeof b64 !== "boolean") throw new (0, $22n7Y.JWSInvalid)('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
    }
    const { alg: alg } = joseHeader;
    if (typeof alg !== "string" || !alg) throw new (0, $22n7Y.JWSInvalid)('JWS "alg" (Algorithm) Header Parameter missing or invalid');
    const algorithms = options && (0, $huFnR.default)("algorithms", options.algorithms);
    if (algorithms && !algorithms.has(alg)) throw new (0, $22n7Y.JOSEAlgNotAllowed)('"alg" (Algorithm) Header Parameter value not allowed');
    if (b64) {
        if (typeof jws.payload !== "string") throw new (0, $22n7Y.JWSInvalid)("JWS Payload must be a string");
    } else if (typeof jws.payload !== "string" && !(jws.payload instanceof Uint8Array)) throw new (0, $22n7Y.JWSInvalid)("JWS Payload must be a string or an Uint8Array instance");
    let resolvedKey = false;
    if (typeof key === "function") {
        key = await key(parsedProt, jws);
        resolvedKey = true;
    }
    (0, $TQWvz.default)(alg, key, "verify");
    const data = (0, $hBRjO.concat)((0, $hBRjO.encoder).encode(jws.protected ?? ""), (0, $hBRjO.encoder).encode("."), typeof jws.payload === "string" ? (0, $hBRjO.encoder).encode(jws.payload) : jws.payload);
    let signature;
    try {
        signature = (0, $gQjU9.decode)(jws.signature);
    } catch  {
        throw new (0, $22n7Y.JWSInvalid)("Failed to base64url decode the signature");
    }
    const verified = await (0, $j6XgI.default)(alg, key, signature, data);
    if (!verified) throw new (0, $22n7Y.JWSSignatureVerificationFailed)();
    let payload;
    if (b64) try {
        payload = (0, $gQjU9.decode)(jws.payload);
    } catch  {
        throw new (0, $22n7Y.JWSInvalid)("Failed to base64url decode the payload");
    }
    else if (typeof jws.payload === "string") payload = (0, $hBRjO.encoder).encode(jws.payload);
    else payload = jws.payload;
    const result = {
        payload: payload
    };
    if (jws.protected !== undefined) result.protectedHeader = parsedProt;
    if (jws.header !== undefined) result.unprotectedHeader = jws.header;
    if (resolvedKey) return {
        ...result,
        key: key
    };
    return result;
}

});
parcelRequire.register("j6XgI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de9c8d5fe5d054bf$export$2e2bcd8739ae039; });

var $hKBeq = parcelRequire("hKBeq");

var $b5yyA = parcelRequire("b5yyA");

var $gVMHg = parcelRequire("gVMHg");

var $2XJJL = parcelRequire("2XJJL");
const $de9c8d5fe5d054bf$var$verify = async (alg, key, signature, data)=>{
    const cryptoKey = await (0, $2XJJL.default)(alg, key, "verify");
    (0, $gVMHg.default)(alg, cryptoKey);
    const algorithm = (0, $hKBeq.default)(alg, cryptoKey.algorithm);
    try {
        return await (0, $b5yyA.default).subtle.verify(algorithm, cryptoKey, signature, data);
    } catch  {
        return false;
    }
};
var $de9c8d5fe5d054bf$export$2e2bcd8739ae039 = $de9c8d5fe5d054bf$var$verify;

});
parcelRequire.register("hKBeq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cec39cfea3f84598$export$2e2bcd8739ae039; });

var $22n7Y = parcelRequire("22n7Y");
function $cec39cfea3f84598$export$2e2bcd8739ae039(alg, algorithm) {
    const hash = `SHA-${alg.slice(-3)}`;
    switch(alg){
        case "HS256":
        case "HS384":
        case "HS512":
            return {
                hash: hash,
                name: "HMAC"
            };
        case "PS256":
        case "PS384":
        case "PS512":
            return {
                hash: hash,
                name: "RSA-PSS",
                saltLength: alg.slice(-3) >> 3
            };
        case "RS256":
        case "RS384":
        case "RS512":
            return {
                hash: hash,
                name: "RSASSA-PKCS1-v1_5"
            };
        case "ES256":
        case "ES384":
        case "ES512":
            return {
                hash: hash,
                name: "ECDSA",
                namedCurve: algorithm.namedCurve
            };
        case "EdDSA":
            return {
                name: algorithm.name
            };
        default:
            throw new (0, $22n7Y.JOSENotSupported)(`alg ${alg} is not supported either by JOSE or your javascript runtime`);
    }
}

});

parcelRequire.register("2XJJL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $228491e1f61aac1b$export$2e2bcd8739ae039; });

var $b5yyA = parcelRequire("b5yyA");

var $5ap99 = parcelRequire("5ap99");

var $7ywXS = parcelRequire("7ywXS");

var $lNabF = parcelRequire("lNabF");
function $228491e1f61aac1b$export$2e2bcd8739ae039(alg, key, usage) {
    if ((0, $b5yyA.isCryptoKey)(key)) {
        (0, $5ap99.checkSigCryptoKey)(key, alg, usage);
        return key;
    }
    if (key instanceof Uint8Array) {
        if (!alg.startsWith("HS")) throw new TypeError((0, $7ywXS.default)(key, ...(0, $lNabF.types)));
        return (0, $b5yyA.default).subtle.importKey("raw", key, {
            hash: `SHA-${alg.slice(-3)}`,
            name: "HMAC"
        }, false, [
            usage
        ]);
    }
    throw new TypeError((0, $7ywXS.default)(key, ...(0, $lNabF.types), "Uint8Array"));
}

});




parcelRequire.register("kvA38", function(module, exports) {

var $lrQ5y = parcelRequire("lrQ5y");

var $22n7Y = parcelRequire("22n7Y");

var $36w7K = parcelRequire("36w7K");
async function $eee2aa9701cca556$export$45b643129436bc63(jws, key, options) {
    if (!(0, $36w7K.default)(jws)) throw new (0, $22n7Y.JWSInvalid)("General JWS must be an object");
    if (!Array.isArray(jws.signatures) || !jws.signatures.every((0, $36w7K.default))) throw new (0, $22n7Y.JWSInvalid)("JWS Signatures missing or incorrect type");
    for (const signature of jws.signatures)try {
        return await (0, $lrQ5y.flattenedVerify)({
            header: signature.header,
            payload: jws.payload,
            protected: signature.protected,
            signature: signature.signature
        }, key, options);
    } catch  {}
    throw new (0, $22n7Y.JWSSignatureVerificationFailed)();
}

});

parcelRequire.register("lR5W2", function(module, exports) {

$parcel$export(module.exports, "jwtVerify", function () { return $fe9326c68a10a03c$export$c878fd0f8381da51; });

var $hxEit = parcelRequire("hxEit");

var $4aOsR = parcelRequire("4aOsR");

var $22n7Y = parcelRequire("22n7Y");
async function $fe9326c68a10a03c$export$c878fd0f8381da51(jwt, key, options) {
    const verified = await (0, $hxEit.compactVerify)(jwt, key, options);
    if (verified.protectedHeader.crit?.includes("b64") && verified.protectedHeader.b64 === false) throw new (0, $22n7Y.JWTInvalid)("JWTs MUST NOT use unencoded payload");
    const payload = (0, $4aOsR.default)(verified.protectedHeader, verified.payload, options);
    const result = {
        payload: payload,
        protectedHeader: verified.protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: verified.key
    };
    return result;
}

});
parcelRequire.register("4aOsR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $309f3dc6717e8bc2$export$2e2bcd8739ae039; });

var $22n7Y = parcelRequire("22n7Y");

var $hBRjO = parcelRequire("hBRjO");

var $bDbj1 = parcelRequire("bDbj1");

var $b8bH0 = parcelRequire("b8bH0");

var $36w7K = parcelRequire("36w7K");
const $309f3dc6717e8bc2$var$normalizeTyp = (value)=>value.toLowerCase().replace(/^application\//, "");
const $309f3dc6717e8bc2$var$checkAudiencePresence = (audPayload, audOption)=>{
    if (typeof audPayload === "string") return audOption.includes(audPayload);
    if (Array.isArray(audPayload)) return audOption.some(Set.prototype.has.bind(new Set(audPayload)));
    return false;
};
var $309f3dc6717e8bc2$export$2e2bcd8739ae039 = (protectedHeader, encodedPayload, options = {})=>{
    const { typ: typ } = options;
    if (typ && (typeof protectedHeader.typ !== "string" || $309f3dc6717e8bc2$var$normalizeTyp(protectedHeader.typ) !== $309f3dc6717e8bc2$var$normalizeTyp(typ))) throw new (0, $22n7Y.JWTClaimValidationFailed)('unexpected "typ" JWT header value', "typ", "check_failed");
    let payload;
    try {
        payload = JSON.parse((0, $hBRjO.decoder).decode(encodedPayload));
    } catch  {}
    if (!(0, $36w7K.default)(payload)) throw new (0, $22n7Y.JWTInvalid)("JWT Claims Set must be a top-level JSON object");
    const { requiredClaims: requiredClaims = [], issuer: issuer, subject: subject, audience: audience, maxTokenAge: maxTokenAge } = options;
    const presenceCheck = [
        ...requiredClaims
    ];
    if (maxTokenAge !== undefined) presenceCheck.push("iat");
    if (audience !== undefined) presenceCheck.push("aud");
    if (subject !== undefined) presenceCheck.push("sub");
    if (issuer !== undefined) presenceCheck.push("iss");
    for (const claim of new Set(presenceCheck.reverse())){
        if (!(claim in payload)) throw new (0, $22n7Y.JWTClaimValidationFailed)(`missing required "${claim}" claim`, claim, "missing");
    }
    if (issuer && !(Array.isArray(issuer) ? issuer : [
        issuer
    ]).includes(payload.iss)) throw new (0, $22n7Y.JWTClaimValidationFailed)('unexpected "iss" claim value', "iss", "check_failed");
    if (subject && payload.sub !== subject) throw new (0, $22n7Y.JWTClaimValidationFailed)('unexpected "sub" claim value', "sub", "check_failed");
    if (audience && !$309f3dc6717e8bc2$var$checkAudiencePresence(payload.aud, typeof audience === "string" ? [
        audience
    ] : audience)) throw new (0, $22n7Y.JWTClaimValidationFailed)('unexpected "aud" claim value', "aud", "check_failed");
    let tolerance;
    switch(typeof options.clockTolerance){
        case "string":
            tolerance = (0, $b8bH0.default)(options.clockTolerance);
            break;
        case "number":
            tolerance = options.clockTolerance;
            break;
        case "undefined":
            tolerance = 0;
            break;
        default:
            throw new TypeError("Invalid clockTolerance option type");
    }
    const { currentDate: currentDate } = options;
    const now = (0, $bDbj1.default)(currentDate || new Date());
    if ((payload.iat !== undefined || maxTokenAge) && typeof payload.iat !== "number") throw new (0, $22n7Y.JWTClaimValidationFailed)('"iat" claim must be a number', "iat", "invalid");
    if (payload.nbf !== undefined) {
        if (typeof payload.nbf !== "number") throw new (0, $22n7Y.JWTClaimValidationFailed)('"nbf" claim must be a number', "nbf", "invalid");
        if (payload.nbf > now + tolerance) throw new (0, $22n7Y.JWTClaimValidationFailed)('"nbf" claim timestamp check failed', "nbf", "check_failed");
    }
    if (payload.exp !== undefined) {
        if (typeof payload.exp !== "number") throw new (0, $22n7Y.JWTClaimValidationFailed)('"exp" claim must be a number', "exp", "invalid");
        if (payload.exp <= now - tolerance) throw new (0, $22n7Y.JWTExpired)('"exp" claim timestamp check failed', "exp", "check_failed");
    }
    if (maxTokenAge) {
        const age = now - payload.iat;
        const max = typeof maxTokenAge === "number" ? maxTokenAge : (0, $b8bH0.default)(maxTokenAge);
        if (age - tolerance > max) throw new (0, $22n7Y.JWTExpired)('"iat" claim timestamp check failed (too far in the past)', "iat", "check_failed");
        if (age < 0 - tolerance) throw new (0, $22n7Y.JWTClaimValidationFailed)('"iat" claim timestamp check failed (it should be in the past)', "iat", "check_failed");
    }
    return payload;
};

});
parcelRequire.register("bDbj1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $877c1b4ea9ce7124$export$2e2bcd8739ae039; });
var $877c1b4ea9ce7124$export$2e2bcd8739ae039 = (date)=>Math.floor(date.getTime() / 1000);

});

parcelRequire.register("b8bH0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81a982fc0c3c42ab$export$2e2bcd8739ae039; });
const $81a982fc0c3c42ab$var$minute = 60;
const $81a982fc0c3c42ab$var$hour = $81a982fc0c3c42ab$var$minute * 60;
const $81a982fc0c3c42ab$var$day = $81a982fc0c3c42ab$var$hour * 24;
const $81a982fc0c3c42ab$var$week = $81a982fc0c3c42ab$var$day * 7;
const $81a982fc0c3c42ab$var$year = $81a982fc0c3c42ab$var$day * 365.25;
const $81a982fc0c3c42ab$var$REGEX = /^(\+|\-)? ?(\d+|\d+\.\d+) ?(seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)(?: (ago|from now))?$/i;
var $81a982fc0c3c42ab$export$2e2bcd8739ae039 = (str)=>{
    const matched = $81a982fc0c3c42ab$var$REGEX.exec(str);
    if (!matched || matched[4] && matched[1]) throw new TypeError("Invalid time period format");
    const value = parseFloat(matched[2]);
    const unit = matched[3].toLowerCase();
    let numericDate;
    switch(unit){
        case "sec":
        case "secs":
        case "second":
        case "seconds":
        case "s":
            numericDate = Math.round(value);
            break;
        case "minute":
        case "minutes":
        case "min":
        case "mins":
        case "m":
            numericDate = Math.round(value * $81a982fc0c3c42ab$var$minute);
            break;
        case "hour":
        case "hours":
        case "hr":
        case "hrs":
        case "h":
            numericDate = Math.round(value * $81a982fc0c3c42ab$var$hour);
            break;
        case "day":
        case "days":
        case "d":
            numericDate = Math.round(value * $81a982fc0c3c42ab$var$day);
            break;
        case "week":
        case "weeks":
        case "w":
            numericDate = Math.round(value * $81a982fc0c3c42ab$var$week);
            break;
        default:
            numericDate = Math.round(value * $81a982fc0c3c42ab$var$year);
            break;
    }
    if (matched[1] === "-" || matched[4] === "ago") return -numericDate;
    return numericDate;
};

});



parcelRequire.register("gp22Y", function(module, exports) {

var $aQEEt = parcelRequire("aQEEt");

var $4aOsR = parcelRequire("4aOsR");

var $22n7Y = parcelRequire("22n7Y");
async function $bf109199b790db9e$export$6ee899505bc40a19(jwt, key, options) {
    const decrypted = await (0, $aQEEt.compactDecrypt)(jwt, key, options);
    const payload = (0, $4aOsR.default)(decrypted.protectedHeader, decrypted.plaintext, options);
    const { protectedHeader: protectedHeader } = decrypted;
    if (protectedHeader.iss !== undefined && protectedHeader.iss !== payload.iss) throw new (0, $22n7Y.JWTClaimValidationFailed)('replicated "iss" claim header parameter mismatch', "iss", "mismatch");
    if (protectedHeader.sub !== undefined && protectedHeader.sub !== payload.sub) throw new (0, $22n7Y.JWTClaimValidationFailed)('replicated "sub" claim header parameter mismatch', "sub", "mismatch");
    if (protectedHeader.aud !== undefined && JSON.stringify(protectedHeader.aud) !== JSON.stringify(payload.aud)) throw new (0, $22n7Y.JWTClaimValidationFailed)('replicated "aud" claim header parameter mismatch', "aud", "mismatch");
    const result = {
        payload: payload,
        protectedHeader: protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: decrypted.key
    };
    return result;
}

});

parcelRequire.register("12qCl", function(module, exports) {

$parcel$export(module.exports, "CompactEncrypt", function () { return $0c1aa0045bf29bee$export$965e4de9938e070e; });

var $aG3Rw = parcelRequire("aG3Rw");
class $0c1aa0045bf29bee$export$965e4de9938e070e {
    constructor(plaintext){
        this._flattened = new (0, $aG3Rw.FlattenedEncrypt)(plaintext);
    }
    setContentEncryptionKey(cek) {
        this._flattened.setContentEncryptionKey(cek);
        return this;
    }
    setInitializationVector(iv) {
        this._flattened.setInitializationVector(iv);
        return this;
    }
    setProtectedHeader(protectedHeader) {
        this._flattened.setProtectedHeader(protectedHeader);
        return this;
    }
    setKeyManagementParameters(parameters) {
        this._flattened.setKeyManagementParameters(parameters);
        return this;
    }
    async encrypt(key, options) {
        const jwe = await this._flattened.encrypt(key, options);
        return [
            jwe.protected,
            jwe.encrypted_key,
            jwe.iv,
            jwe.ciphertext,
            jwe.tag
        ].join(".");
    }
}

});

parcelRequire.register("el7ed", function(module, exports) {

$parcel$export(module.exports, "CompactSign", function () { return $a708a237639d53fc$export$b6738d8e70498d17; });

var $eg8KM = parcelRequire("eg8KM");
class $a708a237639d53fc$export$b6738d8e70498d17 {
    constructor(payload){
        this._flattened = new (0, $eg8KM.FlattenedSign)(payload);
    }
    setProtectedHeader(protectedHeader) {
        this._flattened.setProtectedHeader(protectedHeader);
        return this;
    }
    async sign(key, options) {
        const jws = await this._flattened.sign(key, options);
        if (jws.payload === undefined) throw new TypeError("use the flattened module for creating JWS with b64: false");
        return `${jws.protected}.${jws.payload}.${jws.signature}`;
    }
}

});
parcelRequire.register("eg8KM", function(module, exports) {

$parcel$export(module.exports, "FlattenedSign", function () { return $a619598d8c5e9337$export$9a8af5200da5ddb1; });

var $gQjU9 = parcelRequire("gQjU9");

var $7SOgf = parcelRequire("7SOgf");

var $6jtNr = parcelRequire("6jtNr");

var $22n7Y = parcelRequire("22n7Y");

var $hBRjO = parcelRequire("hBRjO");

var $TQWvz = parcelRequire("TQWvz");

var $jtVF0 = parcelRequire("jtVF0");
class $a619598d8c5e9337$export$9a8af5200da5ddb1 {
    constructor(payload){
        if (!(payload instanceof Uint8Array)) throw new TypeError("payload must be an instance of Uint8Array");
        this._payload = payload;
    }
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this._unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this._unprotectedHeader = unprotectedHeader;
        return this;
    }
    async sign(key, options) {
        if (!this._protectedHeader && !this._unprotectedHeader) throw new (0, $22n7Y.JWSInvalid)("either setProtectedHeader or setUnprotectedHeader must be called before #sign()");
        if (!(0, $6jtNr.default)(this._protectedHeader, this._unprotectedHeader)) throw new (0, $22n7Y.JWSInvalid)("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
        const joseHeader = {
            ...this._protectedHeader,
            ...this._unprotectedHeader
        };
        const extensions = (0, $jtVF0.default)((0, $22n7Y.JWSInvalid), new Map([
            [
                "b64",
                true
            ]
        ]), options?.crit, this._protectedHeader, joseHeader);
        let b64 = true;
        if (extensions.has("b64")) {
            b64 = this._protectedHeader.b64;
            if (typeof b64 !== "boolean") throw new (0, $22n7Y.JWSInvalid)('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
        }
        const { alg: alg } = joseHeader;
        if (typeof alg !== "string" || !alg) throw new (0, $22n7Y.JWSInvalid)('JWS "alg" (Algorithm) Header Parameter missing or invalid');
        (0, $TQWvz.default)(alg, key, "sign");
        let payload = this._payload;
        if (b64) payload = (0, $hBRjO.encoder).encode((0, $gQjU9.encode)(payload));
        let protectedHeader;
        if (this._protectedHeader) protectedHeader = (0, $hBRjO.encoder).encode((0, $gQjU9.encode)(JSON.stringify(this._protectedHeader)));
        else protectedHeader = (0, $hBRjO.encoder).encode("");
        const data = (0, $hBRjO.concat)(protectedHeader, (0, $hBRjO.encoder).encode("."), payload);
        const signature = await (0, $7SOgf.default)(alg, key, data);
        const jws = {
            signature: (0, $gQjU9.encode)(signature),
            payload: ""
        };
        if (b64) jws.payload = (0, $hBRjO.decoder).decode(payload);
        if (this._unprotectedHeader) jws.header = this._unprotectedHeader;
        if (this._protectedHeader) jws.protected = (0, $hBRjO.decoder).decode(protectedHeader);
        return jws;
    }
}

});
parcelRequire.register("7SOgf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bd49059d6fac7b0$export$2e2bcd8739ae039; });

var $hKBeq = parcelRequire("hKBeq");

var $b5yyA = parcelRequire("b5yyA");

var $gVMHg = parcelRequire("gVMHg");

var $2XJJL = parcelRequire("2XJJL");
const $5bd49059d6fac7b0$var$sign = async (alg, key, data)=>{
    const cryptoKey = await (0, $2XJJL.default)(alg, key, "sign");
    (0, $gVMHg.default)(alg, cryptoKey);
    const signature = await (0, $b5yyA.default).subtle.sign((0, $hKBeq.default)(alg, cryptoKey.algorithm), cryptoKey, data);
    return new Uint8Array(signature);
};
var $5bd49059d6fac7b0$export$2e2bcd8739ae039 = $5bd49059d6fac7b0$var$sign;

});



parcelRequire.register("cPuou", function(module, exports) {

var $eg8KM = parcelRequire("eg8KM");

var $22n7Y = parcelRequire("22n7Y");
class $9571d316cacca41b$var$IndividualSignature {
    constructor(sig, key, options){
        this.parent = sig;
        this.key = key;
        this.options = options;
    }
    setProtectedHeader(protectedHeader) {
        if (this.protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this.protectedHeader = protectedHeader;
        return this;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this.unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this.unprotectedHeader = unprotectedHeader;
        return this;
    }
    addSignature(...args) {
        return this.parent.addSignature(...args);
    }
    sign(...args) {
        return this.parent.sign(...args);
    }
    done() {
        return this.parent;
    }
}
class $9571d316cacca41b$export$7e2f94727ed1a34b {
    constructor(payload){
        this._signatures = [];
        this._payload = payload;
    }
    addSignature(key, options) {
        const signature = new $9571d316cacca41b$var$IndividualSignature(this, key, options);
        this._signatures.push(signature);
        return signature;
    }
    async sign() {
        if (!this._signatures.length) throw new (0, $22n7Y.JWSInvalid)("at least one signature must be added");
        const jws = {
            signatures: [],
            payload: ""
        };
        for(let i = 0; i < this._signatures.length; i++){
            const signature = this._signatures[i];
            const flattened = new (0, $eg8KM.FlattenedSign)(this._payload);
            flattened.setProtectedHeader(signature.protectedHeader);
            flattened.setUnprotectedHeader(signature.unprotectedHeader);
            const { payload: payload, ...rest } = await flattened.sign(signature.key, signature.options);
            if (i === 0) jws.payload = payload;
            else if (jws.payload !== payload) throw new (0, $22n7Y.JWSInvalid)("inconsistent use of JWS Unencoded Payload (RFC7797)");
            jws.signatures.push(rest);
        }
        return jws;
    }
}

});

parcelRequire.register("pUOMv", function(module, exports) {

var $el7ed = parcelRequire("el7ed");

var $22n7Y = parcelRequire("22n7Y");

var $hBRjO = parcelRequire("hBRjO");

var $fusw6 = parcelRequire("fusw6");
class $04de68cbd42a6c4f$export$88d4e5d23fbe6c84 extends (0, $fusw6.ProduceJWT) {
    setProtectedHeader(protectedHeader) {
        this._protectedHeader = protectedHeader;
        return this;
    }
    async sign(key, options) {
        const sig = new (0, $el7ed.CompactSign)((0, $hBRjO.encoder).encode(JSON.stringify(this._payload)));
        sig.setProtectedHeader(this._protectedHeader);
        if (Array.isArray(this._protectedHeader?.crit) && this._protectedHeader.crit.includes("b64") && this._protectedHeader.b64 === false) throw new (0, $22n7Y.JWTInvalid)("JWTs MUST NOT use unencoded payload");
        return sig.sign(key, options);
    }
}

});
parcelRequire.register("fusw6", function(module, exports) {

$parcel$export(module.exports, "ProduceJWT", function () { return $b46fc72feebdbc50$export$2ef1b74b7c7e6eb3; });

var $bDbj1 = parcelRequire("bDbj1");

var $36w7K = parcelRequire("36w7K");

var $b8bH0 = parcelRequire("b8bH0");
function $b46fc72feebdbc50$var$validateInput(label, input) {
    if (!Number.isFinite(input)) throw new TypeError(`Invalid ${label} input`);
    return input;
}
class $b46fc72feebdbc50$export$2ef1b74b7c7e6eb3 {
    constructor(payload = {}){
        if (!(0, $36w7K.default)(payload)) throw new TypeError("JWT Claims Set MUST be an object");
        this._payload = payload;
    }
    setIssuer(issuer) {
        this._payload = {
            ...this._payload,
            iss: issuer
        };
        return this;
    }
    setSubject(subject) {
        this._payload = {
            ...this._payload,
            sub: subject
        };
        return this;
    }
    setAudience(audience) {
        this._payload = {
            ...this._payload,
            aud: audience
        };
        return this;
    }
    setJti(jwtId) {
        this._payload = {
            ...this._payload,
            jti: jwtId
        };
        return this;
    }
    setNotBefore(input) {
        if (typeof input === "number") this._payload = {
            ...this._payload,
            nbf: $b46fc72feebdbc50$var$validateInput("setNotBefore", input)
        };
        else if (input instanceof Date) this._payload = {
            ...this._payload,
            nbf: $b46fc72feebdbc50$var$validateInput("setNotBefore", (0, $bDbj1.default)(input))
        };
        else this._payload = {
            ...this._payload,
            nbf: (0, $bDbj1.default)(new Date()) + (0, $b8bH0.default)(input)
        };
        return this;
    }
    setExpirationTime(input) {
        if (typeof input === "number") this._payload = {
            ...this._payload,
            exp: $b46fc72feebdbc50$var$validateInput("setExpirationTime", input)
        };
        else if (input instanceof Date) this._payload = {
            ...this._payload,
            exp: $b46fc72feebdbc50$var$validateInput("setExpirationTime", (0, $bDbj1.default)(input))
        };
        else this._payload = {
            ...this._payload,
            exp: (0, $bDbj1.default)(new Date()) + (0, $b8bH0.default)(input)
        };
        return this;
    }
    setIssuedAt(input) {
        if (typeof input === "undefined") this._payload = {
            ...this._payload,
            iat: (0, $bDbj1.default)(new Date())
        };
        else if (input instanceof Date) this._payload = {
            ...this._payload,
            iat: $b46fc72feebdbc50$var$validateInput("setIssuedAt", (0, $bDbj1.default)(input))
        };
        else if (typeof input === "string") this._payload = {
            ...this._payload,
            iat: $b46fc72feebdbc50$var$validateInput("setIssuedAt", (0, $bDbj1.default)(new Date()) + (0, $b8bH0.default)(input))
        };
        else this._payload = {
            ...this._payload,
            iat: $b46fc72feebdbc50$var$validateInput("setIssuedAt", input)
        };
        return this;
    }
}

});


parcelRequire.register("d0MOL", function(module, exports) {

var $12qCl = parcelRequire("12qCl");

var $hBRjO = parcelRequire("hBRjO");

var $fusw6 = parcelRequire("fusw6");
class $979124a2f85d3b70$export$28c9f8d29aec6f3d extends (0, $fusw6.ProduceJWT) {
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setKeyManagementParameters(parameters) {
        if (this._keyManagementParameters) throw new TypeError("setKeyManagementParameters can only be called once");
        this._keyManagementParameters = parameters;
        return this;
    }
    setContentEncryptionKey(cek) {
        if (this._cek) throw new TypeError("setContentEncryptionKey can only be called once");
        this._cek = cek;
        return this;
    }
    setInitializationVector(iv) {
        if (this._iv) throw new TypeError("setInitializationVector can only be called once");
        this._iv = iv;
        return this;
    }
    replicateIssuerAsHeader() {
        this._replicateIssuerAsHeader = true;
        return this;
    }
    replicateSubjectAsHeader() {
        this._replicateSubjectAsHeader = true;
        return this;
    }
    replicateAudienceAsHeader() {
        this._replicateAudienceAsHeader = true;
        return this;
    }
    async encrypt(key, options) {
        const enc = new (0, $12qCl.CompactEncrypt)((0, $hBRjO.encoder).encode(JSON.stringify(this._payload)));
        if (this._replicateIssuerAsHeader) this._protectedHeader = {
            ...this._protectedHeader,
            iss: this._payload.iss
        };
        if (this._replicateSubjectAsHeader) this._protectedHeader = {
            ...this._protectedHeader,
            sub: this._payload.sub
        };
        if (this._replicateAudienceAsHeader) this._protectedHeader = {
            ...this._protectedHeader,
            aud: this._payload.aud
        };
        enc.setProtectedHeader(this._protectedHeader);
        if (this._iv) enc.setInitializationVector(this._iv);
        if (this._cek) enc.setContentEncryptionKey(this._cek);
        if (this._keyManagementParameters) enc.setKeyManagementParameters(this._keyManagementParameters);
        return enc.encrypt(key, options);
    }
}

});

parcelRequire.register("gXdx3", function(module, exports) {

var $dj3HR = parcelRequire("dj3HR");

var $gQjU9 = parcelRequire("gQjU9");

var $22n7Y = parcelRequire("22n7Y");

var $hBRjO = parcelRequire("hBRjO");

var $36w7K = parcelRequire("36w7K");
const $c57ca73afe063e8a$var$check = (value, description)=>{
    if (typeof value !== "string" || !value) throw new (0, $22n7Y.JWKInvalid)(`${description} missing or invalid`);
};
async function $c57ca73afe063e8a$export$f1ec189735e8660f(jwk, digestAlgorithm) {
    if (!(0, $36w7K.default)(jwk)) throw new TypeError("JWK must be an object");
    digestAlgorithm ?? (digestAlgorithm = "sha256");
    if (digestAlgorithm !== "sha256" && digestAlgorithm !== "sha384" && digestAlgorithm !== "sha512") throw new TypeError('digestAlgorithm must one of "sha256", "sha384", or "sha512"');
    let components;
    switch(jwk.kty){
        case "EC":
            $c57ca73afe063e8a$var$check(jwk.crv, '"crv" (Curve) Parameter');
            $c57ca73afe063e8a$var$check(jwk.x, '"x" (X Coordinate) Parameter');
            $c57ca73afe063e8a$var$check(jwk.y, '"y" (Y Coordinate) Parameter');
            components = {
                crv: jwk.crv,
                kty: jwk.kty,
                x: jwk.x,
                y: jwk.y
            };
            break;
        case "OKP":
            $c57ca73afe063e8a$var$check(jwk.crv, '"crv" (Subtype of Key Pair) Parameter');
            $c57ca73afe063e8a$var$check(jwk.x, '"x" (Public Key) Parameter');
            components = {
                crv: jwk.crv,
                kty: jwk.kty,
                x: jwk.x
            };
            break;
        case "RSA":
            $c57ca73afe063e8a$var$check(jwk.e, '"e" (Exponent) Parameter');
            $c57ca73afe063e8a$var$check(jwk.n, '"n" (Modulus) Parameter');
            components = {
                e: jwk.e,
                kty: jwk.kty,
                n: jwk.n
            };
            break;
        case "oct":
            $c57ca73afe063e8a$var$check(jwk.k, '"k" (Key Value) Parameter');
            components = {
                k: jwk.k,
                kty: jwk.kty
            };
            break;
        default:
            throw new (0, $22n7Y.JOSENotSupported)('"kty" (Key Type) Parameter missing or unsupported');
    }
    const data = (0, $hBRjO.encoder).encode(JSON.stringify(components));
    return (0, $gQjU9.encode)(await (0, $dj3HR.default)(digestAlgorithm, data));
}
async function $c57ca73afe063e8a$export$b9879ebc49d4fd7a(jwk, digestAlgorithm) {
    digestAlgorithm ?? (digestAlgorithm = "sha256");
    const thumbprint = await $c57ca73afe063e8a$export$f1ec189735e8660f(jwk, digestAlgorithm);
    return `urn:ietf:params:oauth:jwk-thumbprint:sha-${digestAlgorithm.slice(-3)}:${thumbprint}`;
}

});

parcelRequire.register("kETdY", function(module, exports) {

var $i50Kz = parcelRequire("i50Kz");

var $36w7K = parcelRequire("36w7K");

var $22n7Y = parcelRequire("22n7Y");
async function $f0a261813fce8f37$export$c51e3062a159ef59(protectedHeader, token) {
    const joseHeader = {
        ...protectedHeader,
        ...token?.header
    };
    if (!(0, $36w7K.default)(joseHeader.jwk)) throw new (0, $22n7Y.JWSInvalid)('"jwk" (JSON Web Key) Header Parameter must be a JSON object');
    const key = await (0, $i50Kz.importJWK)({
        ...joseHeader.jwk,
        ext: true
    }, joseHeader.alg);
    if (key instanceof Uint8Array || key.type !== "public") throw new (0, $22n7Y.JWSInvalid)('"jwk" (JSON Web Key) Header Parameter must be a public key');
    return key;
}

});

parcelRequire.register("hqEAs", function(module, exports) {

$parcel$export(module.exports, "isJWKSLike", function () { return $cb04591e025155a9$export$d01e0ebadbb4baf; });
$parcel$export(module.exports, "LocalJWKSet", function () { return $cb04591e025155a9$export$cfeaec9a672ea12b; });

var $i50Kz = parcelRequire("i50Kz");

var $22n7Y = parcelRequire("22n7Y");

var $36w7K = parcelRequire("36w7K");
function $cb04591e025155a9$var$getKtyFromAlg(alg) {
    switch(typeof alg === "string" && alg.slice(0, 2)){
        case "RS":
        case "PS":
            return "RSA";
        case "ES":
            return "EC";
        case "Ed":
            return "OKP";
        default:
            throw new (0, $22n7Y.JOSENotSupported)('Unsupported "alg" value for a JSON Web Key Set');
    }
}
function $cb04591e025155a9$export$d01e0ebadbb4baf(jwks) {
    return jwks && typeof jwks === "object" && Array.isArray(jwks.keys) && jwks.keys.every($cb04591e025155a9$var$isJWKLike);
}
function $cb04591e025155a9$var$isJWKLike(key) {
    return (0, $36w7K.default)(key);
}
function $cb04591e025155a9$var$clone(obj) {
    if (typeof structuredClone === "function") return structuredClone(obj);
    return JSON.parse(JSON.stringify(obj));
}
class $cb04591e025155a9$export$cfeaec9a672ea12b {
    constructor(jwks){
        this._cached = new WeakMap();
        if (!$cb04591e025155a9$export$d01e0ebadbb4baf(jwks)) throw new (0, $22n7Y.JWKSInvalid)("JSON Web Key Set malformed");
        this._jwks = $cb04591e025155a9$var$clone(jwks);
    }
    async getKey(protectedHeader, token) {
        const { alg: alg, kid: kid } = {
            ...protectedHeader,
            ...token?.header
        };
        const kty = $cb04591e025155a9$var$getKtyFromAlg(alg);
        const candidates = this._jwks.keys.filter((jwk)=>{
            let candidate = kty === jwk.kty;
            if (candidate && typeof kid === "string") candidate = kid === jwk.kid;
            if (candidate && typeof jwk.alg === "string") candidate = alg === jwk.alg;
            if (candidate && typeof jwk.use === "string") candidate = jwk.use === "sig";
            if (candidate && Array.isArray(jwk.key_ops)) candidate = jwk.key_ops.includes("verify");
            if (candidate && alg === "EdDSA") candidate = jwk.crv === "Ed25519" || jwk.crv === "Ed448";
            if (candidate) switch(alg){
                case "ES256":
                    candidate = jwk.crv === "P-256";
                    break;
                case "ES256K":
                    candidate = jwk.crv === "secp256k1";
                    break;
                case "ES384":
                    candidate = jwk.crv === "P-384";
                    break;
                case "ES512":
                    candidate = jwk.crv === "P-521";
                    break;
            }
            return candidate;
        });
        const { 0: jwk, length: length } = candidates;
        if (length === 0) throw new (0, $22n7Y.JWKSNoMatchingKey)();
        if (length !== 1) {
            const error = new (0, $22n7Y.JWKSMultipleMatchingKeys)();
            const { _cached: _cached } = this;
            error[Symbol.asyncIterator] = async function*() {
                for (const jwk of candidates)try {
                    yield await $cb04591e025155a9$var$importWithAlgCache(_cached, jwk, alg);
                } catch  {}
            };
            throw error;
        }
        return $cb04591e025155a9$var$importWithAlgCache(this._cached, jwk, alg);
    }
}
async function $cb04591e025155a9$var$importWithAlgCache(cache, jwk, alg) {
    const cached = cache.get(jwk) || cache.set(jwk, {}).get(jwk);
    if (cached[alg] === undefined) {
        const key = await (0, $i50Kz.importJWK)({
            ...jwk,
            ext: true
        }, alg);
        if (key instanceof Uint8Array || key.type !== "public") throw new (0, $22n7Y.JWKSInvalid)("JSON Web Key Set members must be public keys");
        cached[alg] = key;
    }
    return cached[alg];
}
function $cb04591e025155a9$export$4892abc640e5f80e(jwks) {
    const set = new $cb04591e025155a9$export$cfeaec9a672ea12b(jwks);
    return async (protectedHeader, token)=>set.getKey(protectedHeader, token);
}

});

parcelRequire.register("3PpsA", function(module, exports) {

$parcel$export(module.exports, "createRemoteJWKSet", function () { return $2c99e25aef6cb1c2$export$78ce35c2df51c333; });

var $5GQBC = parcelRequire("5GQBC");

var $22n7Y = parcelRequire("22n7Y");

var $hqEAs = parcelRequire("hqEAs");
function $2c99e25aef6cb1c2$var$isCloudflareWorkers() {
    return typeof WebSocketPair !== "undefined" || typeof navigator !== "undefined" && navigator.userAgent === "Cloudflare-Workers" || typeof EdgeRuntime !== "undefined" && EdgeRuntime === "vercel";
}
let $2c99e25aef6cb1c2$var$USER_AGENT;
if (typeof navigator === "undefined" || !navigator.userAgent?.startsWith?.("Mozilla/5.0 ")) {
    const NAME = "jose";
    const VERSION = "v5.2.2";
    $2c99e25aef6cb1c2$var$USER_AGENT = `${NAME}/${VERSION}`;
}
class $2c99e25aef6cb1c2$var$RemoteJWKSet extends (0, $hqEAs.LocalJWKSet) {
    constructor(url, options){
        super({
            keys: []
        });
        this._jwks = undefined;
        if (!(url instanceof URL)) throw new TypeError("url must be an instance of URL");
        this._url = new URL(url.href);
        this._options = {
            agent: options?.agent,
            headers: options?.headers
        };
        this._timeoutDuration = typeof options?.timeoutDuration === "number" ? options?.timeoutDuration : 5000;
        this._cooldownDuration = typeof options?.cooldownDuration === "number" ? options?.cooldownDuration : 30000;
        this._cacheMaxAge = typeof options?.cacheMaxAge === "number" ? options?.cacheMaxAge : 600000;
    }
    coolingDown() {
        return typeof this._jwksTimestamp === "number" ? Date.now() < this._jwksTimestamp + this._cooldownDuration : false;
    }
    fresh() {
        return typeof this._jwksTimestamp === "number" ? Date.now() < this._jwksTimestamp + this._cacheMaxAge : false;
    }
    async getKey(protectedHeader, token) {
        if (!this._jwks || !this.fresh()) await this.reload();
        try {
            return await super.getKey(protectedHeader, token);
        } catch (err) {
            if (err instanceof (0, $22n7Y.JWKSNoMatchingKey)) {
                if (this.coolingDown() === false) {
                    await this.reload();
                    return super.getKey(protectedHeader, token);
                }
            }
            throw err;
        }
    }
    async reload() {
        if (this._pendingFetch && $2c99e25aef6cb1c2$var$isCloudflareWorkers()) this._pendingFetch = undefined;
        const headers = new Headers(this._options.headers);
        if ($2c99e25aef6cb1c2$var$USER_AGENT && !headers.has("User-Agent")) {
            headers.set("User-Agent", $2c99e25aef6cb1c2$var$USER_AGENT);
            this._options.headers = Object.fromEntries(headers.entries());
        }
        this._pendingFetch || (this._pendingFetch = (0, $5GQBC.default)(this._url, this._timeoutDuration, this._options).then((json)=>{
            if (!(0, $hqEAs.isJWKSLike)(json)) throw new (0, $22n7Y.JWKSInvalid)("JSON Web Key Set malformed");
            this._jwks = {
                keys: json.keys
            };
            this._jwksTimestamp = Date.now();
            this._pendingFetch = undefined;
        }).catch((err)=>{
            this._pendingFetch = undefined;
            throw err;
        }));
        await this._pendingFetch;
    }
}
function $2c99e25aef6cb1c2$export$78ce35c2df51c333(url, options) {
    const set = new $2c99e25aef6cb1c2$var$RemoteJWKSet(url, options);
    return async (protectedHeader, token)=>set.getKey(protectedHeader, token);
}

});
parcelRequire.register("5GQBC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4249ae6578f6f7c5$export$2e2bcd8739ae039; });

var $22n7Y = parcelRequire("22n7Y");
const $4249ae6578f6f7c5$var$fetchJwks = async (url, timeout, options)=>{
    let controller;
    let id;
    let timedOut = false;
    if (typeof AbortController === "function") {
        controller = new AbortController();
        id = setTimeout(()=>{
            timedOut = true;
            controller.abort();
        }, timeout);
    }
    const response = await fetch(url.href, {
        signal: controller ? controller.signal : undefined,
        redirect: "manual",
        headers: options.headers
    }).catch((err)=>{
        if (timedOut) throw new (0, $22n7Y.JWKSTimeout)();
        throw err;
    });
    if (id !== undefined) clearTimeout(id);
    if (response.status !== 200) throw new (0, $22n7Y.JOSEError)("Expected 200 OK from the JSON Web Key Set HTTP response");
    try {
        return await response.json();
    } catch  {
        throw new (0, $22n7Y.JOSEError)("Failed to parse the JSON Web Key Set HTTP response as JSON");
    }
};
var $4249ae6578f6f7c5$export$2e2bcd8739ae039 = $4249ae6578f6f7c5$var$fetchJwks;

});


parcelRequire.register("8kyC5", function(module, exports) {

var $gQjU9 = parcelRequire("gQjU9");

var $hBRjO = parcelRequire("hBRjO");

var $22n7Y = parcelRequire("22n7Y");

var $4aOsR = parcelRequire("4aOsR");

var $fusw6 = parcelRequire("fusw6");
class $610b0a79f547d8e9$export$6404fb90f16d8733 extends (0, $fusw6.ProduceJWT) {
    encode() {
        const header = $gQjU9.encode(JSON.stringify({
            alg: "none"
        }));
        const payload = $gQjU9.encode(JSON.stringify(this._payload));
        return `${header}.${payload}.`;
    }
    static decode(jwt, options) {
        if (typeof jwt !== "string") throw new (0, $22n7Y.JWTInvalid)("Unsecured JWT must be a string");
        const { 0: encodedHeader, 1: encodedPayload, 2: signature, length: length } = jwt.split(".");
        if (length !== 3 || signature !== "") throw new (0, $22n7Y.JWTInvalid)("Invalid Unsecured JWT");
        let header;
        try {
            header = JSON.parse((0, $hBRjO.decoder).decode($gQjU9.decode(encodedHeader)));
            if (header.alg !== "none") throw new Error();
        } catch  {
            throw new (0, $22n7Y.JWTInvalid)("Invalid Unsecured JWT");
        }
        const payload = (0, $4aOsR.default)(header, $gQjU9.decode(encodedPayload), options);
        return {
            payload: payload,
            header: header
        };
    }
}

});

parcelRequire.register("4SnOC", function(module, exports) {

var $dG95M = parcelRequire("dG95M");

var $hBRjO = parcelRequire("hBRjO");

var $36w7K = parcelRequire("36w7K");
function $38ceadd20684d3a0$export$ca23208356ba8d90(token) {
    let protectedB64u;
    if (typeof token === "string") {
        const parts = token.split(".");
        if (parts.length === 3 || parts.length === 5) [protectedB64u] = parts;
    } else if (typeof token === "object" && token) {
        if ("protected" in token) protectedB64u = token.protected;
        else throw new TypeError("Token does not contain a Protected Header");
    }
    try {
        if (typeof protectedB64u !== "string" || !protectedB64u) throw new Error();
        const result = JSON.parse((0, $hBRjO.decoder).decode((0, $dG95M.decode)(protectedB64u)));
        if (!(0, $36w7K.default)(result)) throw new Error();
        return result;
    } catch  {
        throw new TypeError("Invalid Token or Protected Header formatting");
    }
}

});
parcelRequire.register("dG95M", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $9f564026349ab557$export$2f872c0f2117be69; });

var $gQjU9 = parcelRequire("gQjU9");
const $9f564026349ab557$export$c564cdbbe6da493 = $gQjU9.encode;
const $9f564026349ab557$export$2f872c0f2117be69 = $gQjU9.decode;

});


parcelRequire.register("5tHmH", function(module, exports) {

var $dG95M = parcelRequire("dG95M");

var $hBRjO = parcelRequire("hBRjO");

var $36w7K = parcelRequire("36w7K");

var $22n7Y = parcelRequire("22n7Y");
function $3fd14c9a1aad6fc4$export$dcef71b8fb9a6794(jwt) {
    if (typeof jwt !== "string") throw new (0, $22n7Y.JWTInvalid)("JWTs must use Compact JWS serialization, JWT must be a string");
    const { 1: payload, length: length } = jwt.split(".");
    if (length === 5) throw new (0, $22n7Y.JWTInvalid)("Only JWTs using Compact JWS serialization can be decoded");
    if (length !== 3) throw new (0, $22n7Y.JWTInvalid)("Invalid JWT");
    if (!payload) throw new (0, $22n7Y.JWTInvalid)("JWTs must contain a payload");
    let decoded;
    try {
        decoded = (0, $dG95M.decode)(payload);
    } catch  {
        throw new (0, $22n7Y.JWTInvalid)("Failed to base64url decode the payload");
    }
    let result;
    try {
        result = JSON.parse((0, $hBRjO.decoder).decode(decoded));
    } catch  {
        throw new (0, $22n7Y.JWTInvalid)("Failed to parse the decoded payload as JSON");
    }
    if (!(0, $36w7K.default)(result)) throw new (0, $22n7Y.JWTInvalid)("Invalid JWT Claims Set");
    return result;
}

});

parcelRequire.register("8J4Vs", function(module, exports) {

var $euB4i = parcelRequire("euB4i");
async function $65a658d7702a8a91$export$a949d36eab55b41f(alg, options) {
    return (0, $euB4i.generateKeyPair)(alg, options);
}

});
parcelRequire.register("euB4i", function(module, exports) {

$parcel$export(module.exports, "generateSecret", function () { return $a8d09f075bdbb508$export$25395fe8d170ad7; });
$parcel$export(module.exports, "generateKeyPair", function () { return $a8d09f075bdbb508$export$a949d36eab55b41f; });

var $b5yyA = parcelRequire("b5yyA");

var $22n7Y = parcelRequire("22n7Y");

var $lNduJ = parcelRequire("lNduJ");
async function $a8d09f075bdbb508$export$25395fe8d170ad7(alg, options) {
    let length;
    let algorithm;
    let keyUsages;
    switch(alg){
        case "HS256":
        case "HS384":
        case "HS512":
            length = parseInt(alg.slice(-3), 10);
            algorithm = {
                name: "HMAC",
                hash: `SHA-${length}`,
                length: length
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            length = parseInt(alg.slice(-3), 10);
            return (0, $lNduJ.default)(new Uint8Array(length >> 3));
        case "A128KW":
        case "A192KW":
        case "A256KW":
            length = parseInt(alg.slice(1, 4), 10);
            algorithm = {
                name: "AES-KW",
                length: length
            };
            keyUsages = [
                "wrapKey",
                "unwrapKey"
            ];
            break;
        case "A128GCMKW":
        case "A192GCMKW":
        case "A256GCMKW":
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            length = parseInt(alg.slice(1, 4), 10);
            algorithm = {
                name: "AES-GCM",
                length: length
            };
            keyUsages = [
                "encrypt",
                "decrypt"
            ];
            break;
        default:
            throw new (0, $22n7Y.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
    }
    return (0, $b5yyA.default).subtle.generateKey(algorithm, options?.extractable ?? false, keyUsages);
}
function $a8d09f075bdbb508$var$getModulusLengthOption(options) {
    const modulusLength = options?.modulusLength ?? 2048;
    if (typeof modulusLength !== "number" || modulusLength < 2048) throw new (0, $22n7Y.JOSENotSupported)("Invalid or unsupported modulusLength option provided, 2048 bits or larger keys must be used");
    return modulusLength;
}
async function $a8d09f075bdbb508$export$a949d36eab55b41f(alg, options) {
    let algorithm;
    let keyUsages;
    switch(alg){
        case "PS256":
        case "PS384":
        case "PS512":
            algorithm = {
                name: "RSA-PSS",
                hash: `SHA-${alg.slice(-3)}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: $a8d09f075bdbb508$var$getModulusLengthOption(options)
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "RS256":
        case "RS384":
        case "RS512":
            algorithm = {
                name: "RSASSA-PKCS1-v1_5",
                hash: `SHA-${alg.slice(-3)}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: $a8d09f075bdbb508$var$getModulusLengthOption(options)
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            algorithm = {
                name: "RSA-OAEP",
                hash: `SHA-${parseInt(alg.slice(-3), 10) || 1}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: $a8d09f075bdbb508$var$getModulusLengthOption(options)
            };
            keyUsages = [
                "decrypt",
                "unwrapKey",
                "encrypt",
                "wrapKey"
            ];
            break;
        case "ES256":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-256"
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "ES384":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-384"
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "ES512":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-521"
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "EdDSA":
            {
                keyUsages = [
                    "sign",
                    "verify"
                ];
                const crv = options?.crv ?? "Ed25519";
                switch(crv){
                    case "Ed25519":
                    case "Ed448":
                        algorithm = {
                            name: crv
                        };
                        break;
                    default:
                        throw new (0, $22n7Y.JOSENotSupported)("Invalid or unsupported crv option provided");
                }
                break;
            }
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                keyUsages = [
                    "deriveKey",
                    "deriveBits"
                ];
                const crv = options?.crv ?? "P-256";
                switch(crv){
                    case "P-256":
                    case "P-384":
                    case "P-521":
                        algorithm = {
                            name: "ECDH",
                            namedCurve: crv
                        };
                        break;
                    case "X25519":
                    case "X448":
                        algorithm = {
                            name: crv
                        };
                        break;
                    default:
                        throw new (0, $22n7Y.JOSENotSupported)("Invalid or unsupported crv option provided, supported values are P-256, P-384, P-521, X25519, and X448");
                }
                break;
            }
        default:
            throw new (0, $22n7Y.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
    }
    return (0, $b5yyA.default).subtle.generateKey(algorithm, options?.extractable ?? false, keyUsages);
}

});


parcelRequire.register("3iNLm", function(module, exports) {

var $euB4i = parcelRequire("euB4i");
async function $2679a7666419c3fb$export$25395fe8d170ad7(alg, options) {
    return (0, $euB4i.generateSecret)(alg, options);
}

});

parcelRequire.register("gbzgj", function(module, exports) {

var $kzkdd = parcelRequire("kzkdd");
var $bc8906c1438a07c9$export$2e2bcd8739ae039 = (0, $kzkdd.default);

});
parcelRequire.register("kzkdd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef96c13822890b22$export$2e2bcd8739ae039; });
var $ef96c13822890b22$export$2e2bcd8739ae039 = "WebCryptoAPI";

});




parcelRequire.register("23Be9", function(module, exports) {

$parcel$export(module.exports, "StandardLogtoClient", function () { return $17f8bd221bf5fcdd$export$13350ca41f199138; });
parcelRequire("dWRvH");
var $fRuVm = parcelRequire("fRuVm");
var $duMzr = parcelRequire("duMzr");
var $dpAr1 = parcelRequire("dpAr1");
var $1Uy1B = parcelRequire("1Uy1B");
var $8yRDe = parcelRequire("8yRDe");
var $8Dq0r = parcelRequire("8Dq0r");
var $J24Fb = parcelRequire("J24Fb");
var $fNnrz = parcelRequire("fNnrz");
var $kTA61 = parcelRequire("kTA61");
var $7SAxh = parcelRequire("7SAxh");

var $qv3T5 = parcelRequire("qv3T5");

var $v4mmb = parcelRequire("v4mmb");

var $ddB4E = parcelRequire("ddB4E");

var $gwXIC = parcelRequire("gwXIC");

var $bMiCi = parcelRequire("bMiCi");

var $2wQsY = parcelRequire("2wQsY");

var $9q1Q2 = parcelRequire("9q1Q2");
/* eslint-disable max-lines */ /**
 * The Logto base client class that provides the essential methods for
 * interacting with the Logto server.
 *
 * It also provides an adapter object that allows the customizations of the
 * client behavior for different environments.
 *
 * NOTE: Usually, you would use the `LogtoClient` class instead of `StandardLogtoClient` since it
 * provides the default JWT verifier. However, if you want to avoid the use of `jose` package
 * which is useful for certain environments that don't support native modules like `crypto`, you
 * can use `StandardLogtoClient` and provide your own JWT verifier.
 */ class $17f8bd221bf5fcdd$export$13350ca41f199138 {
    constructor(logtoConfig, adapter, buildJwtVerifier){
        /**
         * Get the OIDC configuration from the discovery endpoint. This method will
         * only fetch the configuration once and cache the result.
         */ this.getOidcConfig = (0, $2wQsY.once)(this.#getOidcConfig);
        /**
         * Get the access token from the storage with refresh strategy.
         *
         * - If the access token has expired, it will try to fetch a new one using the Refresh Token.
         * - If there's an ongoing Promise to fetch the access token, it will return the Promise.
         *
         * If you want to get the access token claims, use {@link getAccessTokenClaims} instead.
         *
         * @param resource The resource that the access token is granted for. If not
         * specified, the access token will be used for OpenID Connect or the default
         * resource, as specified in the Logto Console.
         * @returns The access token string.
         * @throws LogtoClientError if the user is not authenticated.
         */ this.getAccessToken = (0, $bMiCi.memoize)(this.#getAccessToken);
        /**
         * Get the access token for the specified organization from the storage with refresh strategy.
         *
         * Scope {@link UserScope.Organizations} is required in the config to use organization-related
         * methods.
         *
         * @param organizationId The ID of the organization that the access token is granted for.
         * @returns The access token string.
         * @throws LogtoClientError if the user is not authenticated.
         * @remarks
         * It uses the same refresh strategy as {@link getAccessToken}.
         */ this.getOrganizationToken = (0, $bMiCi.memoize)(this.#getOrganizationToken);
        /**
         * Clear the access token from the cache storage.
         */ this.clearAccessToken = (0, $bMiCi.memoize)(this.#clearAccessToken);
        /**
         * Clear all cached tokens from storage.
         */ this.clearAllTokens = (0, $bMiCi.memoize)(this.#clearAllTokens);
        /**
         * Handle the sign-in callback by parsing the authorization code from the
         * callback URI and exchanging it for the tokens.
         *
         * @param callbackUri The callback URI, including the search params, that the user is redirected to after the sign-in flow is completed.
         * The origin and pathname of this URI must match the origin and pathname of the redirect URI specified in {@link signIn}.
         * In many cases you'll probably end up passing `window.location.href` as the argument to this function.
         * @throws LogtoClientError if the sign-in session is not found.
         */ this.handleSignInCallback = (0, $bMiCi.memoize)(this.#handleSignInCallback);
        this.accessTokenMap = new Map();
        this.logtoConfig = (0, $ddB4E.normalizeLogtoConfig)(logtoConfig);
        this.adapter = new (0, $qv3T5.ClientAdapterInstance)(adapter);
        this.jwtVerifier = buildJwtVerifier(this);
        this.loadAccessTokenMap();
    }
    /**
     * Check if the user is authenticated by checking if the ID token exists.
     */ async isAuthenticated() {
        return Boolean(await this.getIdToken());
    }
    /**
     * Get the Refresh Token from the storage.
     */ async getRefreshToken() {
        return this.adapter.storage.getItem("refreshToken");
    }
    /**
     * Get the ID Token from the storage. If you want to get the ID Token claims,
     * use {@link getIdTokenClaims} instead.
     */ async getIdToken() {
        return this.adapter.storage.getItem("idToken");
    }
    /**
     * Get the ID Token claims.
     */ async getIdTokenClaims() {
        const idToken = await this.getIdToken();
        if (!idToken) throw new (0, $v4mmb.LogtoClientError)("not_authenticated");
        return (0, $fRuVm.decodeIdToken)(idToken);
    }
    /**
     * Get the access token claims for the specified resource.
     *
     * @param resource The resource that the access token is granted for. If not
     * specified, the access token will be used for OpenID Connect or the default
     * resource, as specified in the Logto Console.
     */ async getAccessTokenClaims(resource) {
        const accessToken = await this.getAccessToken(resource);
        return (0, $duMzr.decodeAccessToken)(accessToken);
    }
    /**
     * Get the organization token claims for the specified organization.
     *
     * @param organizationId The ID of the organization that the access token is granted for.
     */ async getOrganizationTokenClaims(organizationId) {
        const accessToken = await this.getOrganizationToken(organizationId);
        return (0, $duMzr.decodeAccessToken)(accessToken);
    }
    /**
     * Get the user information from the Userinfo Endpoint.
     *
     * Note the Userinfo Endpoint will return more claims than the ID Token. See
     * {@link https://docs.logto.io/docs/recipes/integrate-logto/vanilla-js/#fetch-user-information | Fetch user information}
     * for more information.
     *
     * @returns The user information.
     * @throws LogtoClientError if the user is not authenticated.
     */ async fetchUserInfo() {
        const { userinfoEndpoint: userinfoEndpoint } = await this.getOidcConfig();
        const accessToken = await this.getAccessToken();
        if (!accessToken) throw new (0, $v4mmb.LogtoClientError)("fetch_user_info_failed");
        return (0, $dpAr1.fetchUserInfo)(userinfoEndpoint, accessToken, this.adapter.requester);
    }
    async signIn(options, mode, hint) {
        const { redirectUri: redirectUriUrl, postRedirectUri: postRedirectUriUrl, firstScreen: firstScreen, interactionMode: interactionMode, loginHint: loginHint, directSignIn: directSignIn, extraParams: extraParams, prompt: prompt } = typeof options === "string" || options instanceof URL ? {
            redirectUri: options,
            postRedirectUri: undefined,
            firstScreen: undefined,
            interactionMode: mode,
            loginHint: hint,
            directSignIn: undefined,
            extraParams: undefined,
            prompt: undefined
        } : options;
        const redirectUri = redirectUriUrl.toString();
        const postRedirectUri = postRedirectUriUrl?.toString();
        const { appId: clientId, prompt: promptViaConfig, resources: resources, scopes: scopes } = this.logtoConfig;
        const { authorizationEndpoint: authorizationEndpoint } = await this.getOidcConfig();
        const [codeVerifier, state] = await Promise.all([
            this.adapter.generateCodeVerifier(),
            this.adapter.generateState()
        ]);
        const codeChallenge = await this.adapter.generateCodeChallenge(codeVerifier);
        const signInUri = (0, $1Uy1B.generateSignInUri)({
            authorizationEndpoint: authorizationEndpoint,
            clientId: clientId,
            redirectUri: redirectUri.toString(),
            codeChallenge: codeChallenge,
            state: state,
            scopes: scopes,
            resources: resources,
            prompt: prompt ?? promptViaConfig,
            firstScreen: firstScreen,
            interactionMode: interactionMode,
            loginHint: loginHint,
            directSignIn: directSignIn,
            extraParams: extraParams
        });
        await Promise.all([
            this.setSignInSession({
                redirectUri: redirectUri,
                postRedirectUri: postRedirectUri,
                codeVerifier: codeVerifier,
                state: state
            }),
            this.clearAllTokens()
        ]);
        await this.adapter.navigate(signInUri, {
            redirectUri: redirectUri,
            for: "sign-in"
        });
    }
    /**
     * Check if the user is redirected from the sign-in page by checking if the
     * current URL matches the redirect URI in the sign-in session.
     *
     * If there's no sign-in session, it will return `false`.
     *
     * @param url The current URL.
     */ async isSignInRedirected(url) {
        const signInSession = await this.getSignInSession();
        if (!signInSession) return false;
        const { redirectUri: redirectUri } = signInSession;
        const { origin: origin, pathname: pathname } = new URL(url);
        return `${origin}${pathname}` === redirectUri;
    }
    /**
     * Start the sign-out flow with the specified redirect URI. The URI must be
     * registered in the Logto Console.
     *
     * It will also revoke all the tokens and clean up the storage.
     *
     * The user will be redirected that URI after the sign-out flow is completed.
     * If the `postLogoutRedirectUri` is not specified, the user will be redirected
     * to a default page.
     */ async signOut(postLogoutRedirectUri) {
        const { appId: clientId } = this.logtoConfig;
        const { endSessionEndpoint: endSessionEndpoint, revocationEndpoint: revocationEndpoint } = await this.getOidcConfig();
        const refreshToken = await this.getRefreshToken();
        if (refreshToken) try {
            await (0, $8yRDe.revoke)(revocationEndpoint, clientId, refreshToken, this.adapter.requester);
        } catch  {
        // Do nothing at this point, as we don't want to break the sign-out flow even if the revocation is failed
        }
        const url = (0, $8Dq0r.generateSignOutUri)({
            endSessionEndpoint: endSessionEndpoint,
            postLogoutRedirectUri: postLogoutRedirectUri,
            clientId: clientId
        });
        await this.clearAllTokens();
        await this.adapter.navigate(url, {
            redirectUri: postLogoutRedirectUri,
            for: "sign-out"
        });
    }
    async getSignInSession() {
        const jsonItem = await this.adapter.storage.getItem("signInSession");
        if (!jsonItem) return null;
        const item = JSON.parse(jsonItem);
        if (!(0, $ddB4E.isLogtoSignInSessionItem)(item)) throw new (0, $v4mmb.LogtoClientError)("sign_in_session.invalid");
        return item;
    }
    async setSignInSession(value) {
        return this.adapter.setStorageItem((0, $9q1Q2.PersistKey).SignInSession, value && JSON.stringify(value));
    }
    async setIdToken(value) {
        return this.adapter.setStorageItem((0, $9q1Q2.PersistKey).IdToken, value);
    }
    async setRefreshToken(value) {
        return this.adapter.setStorageItem((0, $9q1Q2.PersistKey).RefreshToken, value);
    }
    async getAccessTokenByRefreshToken(resource, organizationId) {
        const currentRefreshToken = await this.getRefreshToken();
        if (!currentRefreshToken) throw new (0, $v4mmb.LogtoClientError)("not_authenticated");
        const accessTokenKey = (0, $gwXIC.buildAccessTokenKey)(resource, organizationId);
        const { appId: clientId } = this.logtoConfig;
        const { tokenEndpoint: tokenEndpoint } = await this.getOidcConfig();
        const requestedAt = Math.round(Date.now() / 1000);
        const { accessToken: accessToken, refreshToken: refreshToken, idToken: idToken, scope: scope, expiresIn: expiresIn } = await (0, $J24Fb.fetchTokenByRefreshToken)({
            clientId: clientId,
            tokenEndpoint: tokenEndpoint,
            refreshToken: currentRefreshToken,
            resource: resource,
            organizationId: organizationId
        }, this.adapter.requester);
        this.accessTokenMap.set(accessTokenKey, {
            token: accessToken,
            scope: scope,
            /** The `expiresAt` variable provides an approximate estimation of the actual `exp` property
             * in the token claims. It is utilized by the client to determine if the cached access token
             * has expired and when a new access token should be requested.
             */ expiresAt: requestedAt + expiresIn
        });
        await this.saveAccessTokenMap();
        if (refreshToken) await this.setRefreshToken(refreshToken);
        if (idToken) {
            await this.jwtVerifier.verifyIdToken(idToken);
            await this.setIdToken(idToken);
        }
        return accessToken;
    }
    async saveAccessTokenMap() {
        const data = {};
        for (const [key, accessToken] of this.accessTokenMap.entries())// eslint-disable-next-line @silverhand/fp/no-mutation
        data[key] = accessToken;
        await this.adapter.storage.setItem("accessToken", JSON.stringify(data));
    }
    async loadAccessTokenMap() {
        const raw = await this.adapter.storage.getItem("accessToken");
        if (!raw) return;
        try {
            const json = JSON.parse(raw);
            if (!(0, $ddB4E.isLogtoAccessTokenMap)(json)) return;
            this.accessTokenMap.clear();
            for (const [key, accessToken] of Object.entries(json))this.accessTokenMap.set(key, accessToken);
        } catch (error) {
            console.warn(error);
        }
    }
    async #getOidcConfig() {
        return this.adapter.getWithCache((0, $9q1Q2.CacheKey).OpenidConfig, async ()=>{
            return (0, $fNnrz.fetchOidcConfig)((0, $gwXIC.getDiscoveryEndpoint)(this.logtoConfig.endpoint), this.adapter.requester);
        });
    }
    async #getAccessToken(resource, organizationId) {
        if (!await this.isAuthenticated()) throw new (0, $v4mmb.LogtoClientError)("not_authenticated");
        const accessTokenKey = (0, $gwXIC.buildAccessTokenKey)(resource, organizationId);
        const accessToken = this.accessTokenMap.get(accessTokenKey);
        if (accessToken && accessToken.expiresAt > Date.now() / 1000) return accessToken.token;
        // Since the access token has expired, delete it from the map.
        if (accessToken) this.accessTokenMap.delete(accessTokenKey);
        /**
         * Need to fetch a new access token using refresh token.
         */ return this.getAccessTokenByRefreshToken(resource, organizationId);
    }
    async #getOrganizationToken(organizationId) {
        if (!this.logtoConfig.scopes?.includes((0, $kTA61.UserScope).Organizations)) throw new (0, $v4mmb.LogtoClientError)("missing_scope_organizations");
        return this.getAccessToken(undefined, organizationId);
    }
    async #clearAccessToken() {
        this.accessTokenMap.clear();
        await this.adapter.storage.removeItem("accessToken");
    }
    async #clearAllTokens() {
        await Promise.all([
            this.setRefreshToken(null),
            this.setIdToken(null),
            this.clearAccessToken()
        ]);
    }
    async #handleSignInCallback(callbackUri) {
        const signInSession = await this.getSignInSession();
        if (!signInSession) throw new (0, $v4mmb.LogtoClientError)("sign_in_session.not_found");
        const { redirectUri: redirectUri, postRedirectUri: postRedirectUri, state: state, codeVerifier: codeVerifier } = signInSession;
        const code = (0, $7SAxh.verifyAndParseCodeFromCallbackUri)(callbackUri, redirectUri, state);
        // NOTE: Will add scope to accessTokenKey when needed. (Linear issue LOG-1589)
        const accessTokenKey = (0, $gwXIC.buildAccessTokenKey)();
        const { appId: clientId } = this.logtoConfig;
        const { tokenEndpoint: tokenEndpoint } = await this.getOidcConfig();
        const requestedAt = Math.round(Date.now() / 1000);
        const { idToken: idToken, refreshToken: refreshToken, accessToken: accessToken, scope: scope, expiresIn: expiresIn } = await (0, $J24Fb.fetchTokenByAuthorizationCode)({
            clientId: clientId,
            tokenEndpoint: tokenEndpoint,
            redirectUri: redirectUri,
            codeVerifier: codeVerifier,
            code: code
        }, this.adapter.requester);
        await this.jwtVerifier.verifyIdToken(idToken);
        await this.setRefreshToken(refreshToken ?? null);
        await this.setIdToken(idToken);
        this.accessTokenMap.set(accessTokenKey, {
            token: accessToken,
            scope: scope,
            /** The `expiresAt` variable provides an approximate estimation of the actual `exp` property
             * in the token claims. It is utilized by the client to determine if the cached access token
             * has expired and when a new access token should be requested.
             */ expiresAt: requestedAt + expiresIn
        });
        await this.saveAccessTokenMap();
        await this.setSignInSession(null);
        if (postRedirectUri) await this.adapter.navigate(postRedirectUri, {
            for: "post-sign-in"
        });
    }
}

});
parcelRequire.register("qv3T5", function(module, exports) {

$parcel$export(module.exports, "ClientAdapterInstance", function () { return $04fa8607a0a9e37c$export$63ca545e0fd86684; });
parcelRequire("12bMu");
var $3dBAh = parcelRequire("3dBAh");
var $7oDSS = parcelRequire("7oDSS");

var $9q1Q2 = parcelRequire("9q1Q2");
class $04fa8607a0a9e37c$export$63ca545e0fd86684 {
    /* END OF IMPLEMENTATION */ constructor(adapter){
        // eslint-disable-next-line @silverhand/fp/no-mutating-assign
        Object.assign(this, adapter);
    }
    async setStorageItem(key, value) {
        if (!value) {
            await this.storage.removeItem(key);
            return;
        }
        await this.storage.setItem(key, value);
    }
    /**
     * Try to get the string value from the cache and parse as JSON.
     * Return the parsed value if it is an object, return `undefined` otherwise.
     *
     * @param key The cache key to get value from.
     */ async getCachedObject(key) {
        const cached = await (0, $3dBAh.trySafe)(async ()=>{
            const data = await this.unstable_cache?.getItem(key);
            // It's actually `unknown`
            // eslint-disable-next-line no-restricted-syntax
            return (0, $7oDSS.conditional)(data && JSON.parse(data));
        });
        if (cached && typeof cached === "object") // Trust cache for now
        // eslint-disable-next-line no-restricted-syntax
        return cached;
    }
    /**
     * Try to get the value from the cache first, if it doesn't exist in cache,
     * run the getter function and store the result into cache.
     *
     * @param key The cache key to get value from.
     */ async getWithCache(key, getter) {
        const cached = await this.getCachedObject(key);
        if (cached) return cached;
        const result = await getter();
        await this.unstable_cache?.setItem(key, JSON.stringify(result));
        return result;
    }
}

});
parcelRequire.register("9q1Q2", function(module, exports) {

$parcel$export(module.exports, "PersistKey", function () { return $6db7f7d4b125925c$export$ae0fd1fd1ad1c3f8; });
$parcel$export(module.exports, "CacheKey", function () { return $6db7f7d4b125925c$export$2cb47d384c8dd787; });
var $6db7f7d4b125925c$export$ae0fd1fd1ad1c3f8;
(function(PersistKey) {
    PersistKey["IdToken"] = "idToken";
    PersistKey["RefreshToken"] = "refreshToken";
    PersistKey["AccessToken"] = "accessToken";
    PersistKey["SignInSession"] = "signInSession";
})($6db7f7d4b125925c$export$ae0fd1fd1ad1c3f8 || ($6db7f7d4b125925c$export$ae0fd1fd1ad1c3f8 = {}));
var $6db7f7d4b125925c$export$2cb47d384c8dd787;
(function(CacheKey) {
    /**
     * OpenID Configuration endpoint response.
     *
     * @see {@link https://openid.net/specs/openid-connect-discovery-1_0.html#ProviderConfigurationResponse | OpenID Connect Discovery 1.0}
     */ CacheKey["OpenidConfig"] = "openidConfiguration";
    /**
     * The content of OpenID Provider's `jwks_uri` (JSON Web Key Set).
     *
     * @see {@link https://openid.net/specs/openid-connect-discovery-1_0-21.html#ProviderMetadata | OpenID Connect Discovery 1.0}
     */ CacheKey["Jwks"] = "jwks";
})($6db7f7d4b125925c$export$2cb47d384c8dd787 || ($6db7f7d4b125925c$export$2cb47d384c8dd787 = {}));

});


parcelRequire.register("v4mmb", function(module, exports) {

$parcel$export(module.exports, "LogtoClientError", function () { return $05d64717026abc4b$export$877962ca249b8fc8; });
parcelRequire("dWRvH");
var $kTA61 = parcelRequire("kTA61");
const $05d64717026abc4b$var$logtoClientErrorCodes = Object.freeze({
    "sign_in_session.invalid": "Invalid sign-in session.",
    "sign_in_session.not_found": "Sign-in session not found.",
    not_authenticated: "Not authenticated.",
    fetch_user_info_failed: "Unable to fetch user info. The access token may be invalid.",
    user_cancelled: "The user cancelled the action.",
    missing_scope_organizations: `The \`${(0, $kTA61.UserScope).Organizations}\` scope is required`
});
class $05d64717026abc4b$export$877962ca249b8fc8 extends Error {
    constructor(code, data){
        super($05d64717026abc4b$var$logtoClientErrorCodes[code]);
        this.name = "LogtoClientError";
        this.code = code;
        this.data = data;
    }
}

});

parcelRequire.register("ddB4E", function(module, exports) {

$parcel$export(module.exports, "normalizeLogtoConfig", function () { return $99f93f600be16cb1$export$36dfb28a0f06fe9c; });
$parcel$export(module.exports, "isLogtoSignInSessionItem", function () { return $99f93f600be16cb1$export$5d8adf6e063019de; });
$parcel$export(module.exports, "isLogtoAccessTokenMap", function () { return $99f93f600be16cb1$export$c12fab42a9a3e2a6; });
parcelRequire("dWRvH");
var $gz11x = parcelRequire("gz11x");
var $aUkwV = parcelRequire("aUkwV");
var $kTA61 = parcelRequire("kTA61");
var $i1sNc = parcelRequire("i1sNc");
parcelRequire("12bMu");
var $6cnHd = parcelRequire("6cnHd");
/**
 * Normalize the Logto client configuration per the following rules:
 *
 * - Add default scopes (`openid`, `offline_access` and `profile`) if not provided.
 * - Add {@link ReservedResource.Organization} to resources if {@link UserScope.Organizations} is included in scopes.
 *
 * @param config The Logto client configuration to be normalized.
 * @returns The normalized Logto client configuration.
 */ const $99f93f600be16cb1$export$36dfb28a0f06fe9c = (config)=>{
    const { prompt: prompt = (0, $gz11x.Prompt).Consent, scopes: scopes = [], resources: resources, ...rest } = config;
    return {
        ...rest,
        prompt: prompt,
        scopes: (0, $aUkwV.withDefaultScopes)(scopes).split(" "),
        resources: scopes.includes((0, $kTA61.UserScope).Organizations) ? (0, $6cnHd.deduplicate)([
            ...resources ?? [],
            (0, $kTA61.ReservedResource).Organization
        ]) : resources
    };
};
const $99f93f600be16cb1$export$5d8adf6e063019de = (data)=>{
    if (!(0, $i1sNc.isArbitraryObject)(data)) return false;
    return [
        "redirectUri",
        "codeVerifier",
        "state"
    ].every((key)=>typeof data[key] === "string");
};
const $99f93f600be16cb1$export$c12fab42a9a3e2a6 = (data)=>{
    if (!(0, $i1sNc.isArbitraryObject)(data)) return false;
    return Object.values(data).every((value)=>{
        if (!(0, $i1sNc.isArbitraryObject)(value)) return false;
        return typeof value.token === "string" && typeof value.scope === "string" && typeof value.expiresAt === "number";
    });
};

});

parcelRequire.register("gwXIC", function(module, exports) {

$parcel$export(module.exports, "buildAccessTokenKey", function () { return $c08df561341fdf1e$export$8f595bd2a47bcea6; });
$parcel$export(module.exports, "getDiscoveryEndpoint", function () { return $c08df561341fdf1e$export$5d9c34f69c80822b; });
parcelRequire("dWRvH");
var $fNnrz = parcelRequire("fNnrz");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");
const $c08df561341fdf1e$export$8f595bd2a47bcea6 = (resource = "", organizationId, scopes = [])=>`${scopes.slice().sort().join(" ")}@${resource}${(0, $7oDSS.conditionalString)(organizationId && `#${organizationId}`)}`;
const $c08df561341fdf1e$export$5d9c34f69c80822b = (endpoint)=>new URL((0, $fNnrz.discoveryPath), endpoint).toString();

});

parcelRequire.register("bMiCi", function(module, exports) {

$parcel$export(module.exports, "memoize", function () { return $89329e46a5a15b55$export$fc10aeed3a532e2a; });
function $89329e46a5a15b55$export$fc10aeed3a532e2a(run) {
    const promiseCache = new Map();
    const memoized = async function(...args) {
        const promiseKey = args[0];
        const cachedPromise = promiseCache.get(promiseKey);
        if (cachedPromise) return cachedPromise;
        const promise = (async ()=>{
            try {
                return await run.apply(this, args);
            } finally{
                promiseCache.delete(promiseKey);
            }
        })();
        promiseCache.set(promiseKey, promise);
        return promise;
    };
    return memoized;
}

});

parcelRequire.register("2wQsY", function(module, exports) {

$parcel$export(module.exports, "once", function () { return $1d7744a658136e83$export$d2de3aaeafa91619; });
// TODO @sijie move to essentials
/* eslint-disable @silverhand/fp/no-let */ /* eslint-disable @silverhand/fp/no-mutation */ function $1d7744a658136e83$export$d2de3aaeafa91619(function_) {
    let called = false;
    let result;
    return function(...args) {
        if (!called) {
            called = true;
            result = function_.apply(this, args);
        }
        return result;
    };
}

});


parcelRequire.register("db23v", function(module, exports) {

$parcel$export(module.exports, "createRequester", function () { return $997de59b389d05f1$export$8d54726fdbf08e0a; });
parcelRequire("dWRvH");
var $4aiSz = parcelRequire("4aiSz");
/**
 * A factory function that creates a requester by accepting a `fetch`-like function.
 *
 * @param fetchFunction A `fetch`-like function.
 * @returns A requester function.
 * @see {@link Requester}
 */ const $997de59b389d05f1$export$8d54726fdbf08e0a = (fetchFunction)=>{
    return async (...args)=>{
        const response = await fetchFunction(...args);
        if (!response.ok) {
            const responseJson = await response.json();
            console.error(`Logto requester error: [status=${response.status}]`, responseJson);
            if (!(0, $4aiSz.isLogtoRequestError)(responseJson)) throw new (0, $4aiSz.LogtoError)("unexpected_response_error", responseJson);
            // Expected request error from server
            const { code: code, message: message } = responseJson;
            throw new (0, $4aiSz.LogtoRequestError)(code, message);
        }
        return response.json();
    };
};

});


parcelRequire.register("aqwQn", function(module, exports) {

$parcel$export(module.exports, "CacheStorage", function () { return $7975cf317be3232c$export$2b715f8922748263; });
const $7975cf317be3232c$var$keyPrefix = `logto_cache`;
class $7975cf317be3232c$export$2b715f8922748263 {
    constructor(appId){
        this.appId = appId;
    }
    getKey(item) {
        if (item === undefined) return `${$7975cf317be3232c$var$keyPrefix}:${this.appId}`;
        return `${$7975cf317be3232c$var$keyPrefix}:${this.appId}:${item}`;
    }
    async getItem(key) {
        return sessionStorage.getItem(this.getKey(key));
    }
    async setItem(key, value) {
        sessionStorage.setItem(this.getKey(key), value);
    }
    async removeItem(key) {
        sessionStorage.removeItem(`${this.getKey(key)}`);
    }
}

});

parcelRequire.register("8rtZQ", function(module, exports) {

$parcel$export(module.exports, "BrowserStorage", function () { return $62581d0692f0126e$export$2baa60fa09b100be; });
const $62581d0692f0126e$var$keyPrefix = `logto`;
class $62581d0692f0126e$export$2baa60fa09b100be {
    constructor(appId){
        this.appId = appId;
    }
    getKey(item) {
        if (item === undefined) return `${$62581d0692f0126e$var$keyPrefix}:${this.appId}`;
        return `${$62581d0692f0126e$var$keyPrefix}:${this.appId}:${item}`;
    }
    async getItem(key) {
        if (key === "signInSession") // The latter `getItem()` is for backward compatibility. Can be removed when major bump.
        return sessionStorage.getItem(this.getKey(key)) ?? sessionStorage.getItem(this.getKey());
        return localStorage.getItem(this.getKey(key));
    }
    async setItem(key, value) {
        if (key === "signInSession") {
            sessionStorage.setItem(this.getKey(key), value);
            return;
        }
        localStorage.setItem(this.getKey(key), value);
    }
    async removeItem(key) {
        if (key === "signInSession") {
            sessionStorage.removeItem(this.getKey(key));
            return;
        }
        localStorage.removeItem(this.getKey(key));
    }
}

});

parcelRequire.register("ctNOk", function(module, exports) {

$parcel$export(module.exports, "generateState", function () { return $915ed4da5a18dde0$export$9ccd2716e53a229b; });
$parcel$export(module.exports, "generateCodeVerifier", function () { return $915ed4da5a18dde0$export$cf1891f923f5943a; });
$parcel$export(module.exports, "generateCodeChallenge", function () { return $915ed4da5a18dde0$export$414b01b1f867308a; });
parcelRequire("1cDtu");
var $4aiSz = parcelRequire("4aiSz");

var $ddT5u = parcelRequire("ddT5u");
/** @link [Proof Key for Code Exchange by OAuth Public Clients](https://datatracker.ietf.org/doc/html/rfc7636) */ /**
 * @param length The length of the raw random data.
 */ const $915ed4da5a18dde0$var$generateRandomString = (length = 64)=>(0, $ddT5u.fromUint8Array)(crypto.getRandomValues(new Uint8Array(length)), true);
/**
 * Generates random string for state and encodes them in url safe base64
 */ const $915ed4da5a18dde0$export$9ccd2716e53a229b = ()=>$915ed4da5a18dde0$var$generateRandomString();
/**
 * Generates code verifier
 *
 * @link [Client Creates a Code Verifier](https://datatracker.ietf.org/doc/html/rfc7636#section-4.1)
 */ const $915ed4da5a18dde0$export$cf1891f923f5943a = ()=>$915ed4da5a18dde0$var$generateRandomString();
/**
 * Calculates the S256 PKCE code challenge for an arbitrary code verifier and encodes it in url safe base64
 *
 * @param {String} codeVerifier Code verifier to calculate the S256 code challenge for
 * @link [Client Creates the Code Challenge](https://datatracker.ietf.org/doc/html/rfc7636#section-4.2)
 */ const $915ed4da5a18dde0$export$414b01b1f867308a = async (codeVerifier)=>{
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (crypto.subtle === undefined) /**
         * `crypto.subtle` is available only in secure contexts (HTTPS) in some or all supporting browsers,
         * https://developer.mozilla.org/en-US/docs/Web/API/Crypto/subtle
         * https://www.chromium.org/blink/webcrypto/#accessing-it
         */ throw new (0, $4aiSz.LogtoError)("crypto_subtle_unavailable");
    const encodedCodeVerifier = new TextEncoder().encode(codeVerifier);
    const codeChallenge = new Uint8Array(await crypto.subtle.digest("SHA-256", encodedCodeVerifier));
    return (0, $ddT5u.fromUint8Array)(codeChallenge, true);
};

});
parcelRequire.register("ddT5u", function(module, exports) {

$parcel$export(module.exports, "fromUint8Array", function () { return $a51df0a00d9875e7$export$27bbb4e040978768; });
/**
 *  base64.ts
 *
 *  Licensed under the BSD 3-Clause License.
 *    http://opensource.org/licenses/BSD-3-Clause
 *
 *  References:
 *    http://en.wikipedia.org/wiki/Base64
 *
 * @author Dan Kogai (https://github.com/dankogai)
 */ 
var $69DCu = parcelRequire("69DCu");
var $a51df0a00d9875e7$require$Buffer = $69DCu.Buffer;
const $a51df0a00d9875e7$export$83d89fbfd8236492 = "3.7.5";
/**
 * @deprecated use lowercase `version`.
 */ const $a51df0a00d9875e7$export$a4ad2735b021c132 = $a51df0a00d9875e7$export$83d89fbfd8236492;
const $a51df0a00d9875e7$var$_hasatob = typeof atob === "function";
const $a51df0a00d9875e7$var$_hasbtoa = typeof btoa === "function";
const $a51df0a00d9875e7$var$_hasBuffer = typeof $a51df0a00d9875e7$require$Buffer === "function";
const $a51df0a00d9875e7$var$_TD = typeof TextDecoder === "function" ? new TextDecoder() : undefined;
const $a51df0a00d9875e7$var$_TE = typeof TextEncoder === "function" ? new TextEncoder() : undefined;
const $a51df0a00d9875e7$var$b64ch = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
const $a51df0a00d9875e7$var$b64chs = Array.prototype.slice.call($a51df0a00d9875e7$var$b64ch);
const $a51df0a00d9875e7$var$b64tab = ((a)=>{
    let tab = {};
    a.forEach((c, i)=>tab[c] = i);
    return tab;
})($a51df0a00d9875e7$var$b64chs);
const $a51df0a00d9875e7$var$b64re = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/;
const $a51df0a00d9875e7$var$_fromCC = String.fromCharCode.bind(String);
const $a51df0a00d9875e7$var$_U8Afrom = typeof Uint8Array.from === "function" ? Uint8Array.from.bind(Uint8Array) : (it)=>new Uint8Array(Array.prototype.slice.call(it, 0));
const $a51df0a00d9875e7$var$_mkUriSafe = (src)=>src.replace(/=/g, "").replace(/[+\/]/g, (m0)=>m0 == "+" ? "-" : "_");
const $a51df0a00d9875e7$var$_tidyB64 = (s)=>s.replace(/[^A-Za-z0-9\+\/]/g, "");
/**
 * polyfill version of `btoa`
 */ const $a51df0a00d9875e7$export$ec0fb543302ee251 = (bin)=>{
    // console.log('polyfilled');
    let u32, c0, c1, c2, asc = "";
    const pad = bin.length % 3;
    for(let i = 0; i < bin.length;){
        if ((c0 = bin.charCodeAt(i++)) > 255 || (c1 = bin.charCodeAt(i++)) > 255 || (c2 = bin.charCodeAt(i++)) > 255) throw new TypeError("invalid character found");
        u32 = c0 << 16 | c1 << 8 | c2;
        asc += $a51df0a00d9875e7$var$b64chs[u32 >> 18 & 63] + $a51df0a00d9875e7$var$b64chs[u32 >> 12 & 63] + $a51df0a00d9875e7$var$b64chs[u32 >> 6 & 63] + $a51df0a00d9875e7$var$b64chs[u32 & 63];
    }
    return pad ? asc.slice(0, pad - 3) + "===".substring(pad) : asc;
};
/**
 * does what `window.btoa` of web browsers do.
 * @param {String} bin binary string
 * @returns {string} Base64-encoded string
 */ const $a51df0a00d9875e7$export$a32219e24f8d1e2 = $a51df0a00d9875e7$var$_hasbtoa ? (bin)=>btoa(bin) : $a51df0a00d9875e7$var$_hasBuffer ? (bin)=>$a51df0a00d9875e7$require$Buffer.from(bin, "binary").toString("base64") : $a51df0a00d9875e7$export$ec0fb543302ee251;
const $a51df0a00d9875e7$var$_fromUint8Array = $a51df0a00d9875e7$var$_hasBuffer ? (u8a)=>$a51df0a00d9875e7$require$Buffer.from(u8a).toString("base64") : (u8a)=>{
    // cf. https://stackoverflow.com/questions/12710001/how-to-convert-uint8-array-to-base64-encoded-string/12713326#12713326
    const maxargs = 0x1000;
    let strs = [];
    for(let i = 0, l = u8a.length; i < l; i += maxargs)strs.push($a51df0a00d9875e7$var$_fromCC.apply(null, u8a.subarray(i, i + maxargs)));
    return $a51df0a00d9875e7$export$a32219e24f8d1e2(strs.join(""));
};
/**
 * converts a Uint8Array to a Base64 string.
 * @param {boolean} [urlsafe] URL-and-filename-safe a la RFC4648 §5
 * @returns {string} Base64 string
 */ const $a51df0a00d9875e7$export$27bbb4e040978768 = (u8a, urlsafe = false)=>urlsafe ? $a51df0a00d9875e7$var$_mkUriSafe($a51df0a00d9875e7$var$_fromUint8Array(u8a)) : $a51df0a00d9875e7$var$_fromUint8Array(u8a);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const utob = (src: string) => unescape(encodeURIComponent(src));
// reverting good old fationed regexp
const $a51df0a00d9875e7$var$cb_utob = (c)=>{
    if (c.length < 2) {
        var cc = c.charCodeAt(0);
        return cc < 0x80 ? c : cc < 0x800 ? $a51df0a00d9875e7$var$_fromCC(0xc0 | cc >>> 6) + $a51df0a00d9875e7$var$_fromCC(0x80 | cc & 0x3f) : $a51df0a00d9875e7$var$_fromCC(0xe0 | cc >>> 12 & 0x0f) + $a51df0a00d9875e7$var$_fromCC(0x80 | cc >>> 6 & 0x3f) + $a51df0a00d9875e7$var$_fromCC(0x80 | cc & 0x3f);
    } else {
        var cc = 0x10000 + (c.charCodeAt(0) - 0xD800) * 0x400 + (c.charCodeAt(1) - 0xDC00);
        return $a51df0a00d9875e7$var$_fromCC(0xf0 | cc >>> 18 & 0x07) + $a51df0a00d9875e7$var$_fromCC(0x80 | cc >>> 12 & 0x3f) + $a51df0a00d9875e7$var$_fromCC(0x80 | cc >>> 6 & 0x3f) + $a51df0a00d9875e7$var$_fromCC(0x80 | cc & 0x3f);
    }
};
const $a51df0a00d9875e7$var$re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-8 string
 * @returns {string} UTF-16 string
 */ const $a51df0a00d9875e7$export$10d4b9bd20a66b0 = (u)=>u.replace($a51df0a00d9875e7$var$re_utob, $a51df0a00d9875e7$var$cb_utob);
//
const $a51df0a00d9875e7$var$_encode = $a51df0a00d9875e7$var$_hasBuffer ? (s)=>$a51df0a00d9875e7$require$Buffer.from(s, "utf8").toString("base64") : $a51df0a00d9875e7$var$_TE ? (s)=>$a51df0a00d9875e7$var$_fromUint8Array($a51df0a00d9875e7$var$_TE.encode(s)) : (s)=>$a51df0a00d9875e7$export$a32219e24f8d1e2($a51df0a00d9875e7$export$10d4b9bd20a66b0(s));
/**
 * converts a UTF-8-encoded string to a Base64 string.
 * @param {boolean} [urlsafe] if `true` make the result URL-safe
 * @returns {string} Base64 string
 */ const $a51df0a00d9875e7$export$37cc283d8fbd3462 = (src, urlsafe = false)=>urlsafe ? $a51df0a00d9875e7$var$_mkUriSafe($a51df0a00d9875e7$var$_encode(src)) : $a51df0a00d9875e7$var$_encode(src);
/**
 * converts a UTF-8-encoded string to URL-safe Base64 RFC4648 §5.
 * @returns {string} Base64 string
 */ const $a51df0a00d9875e7$export$90c31d5baa78df44 = (src)=>$a51df0a00d9875e7$export$37cc283d8fbd3462(src, true);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const btou = (src: string) => decodeURIComponent(escape(src));
// reverting good old fationed regexp
const $a51df0a00d9875e7$var$re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
const $a51df0a00d9875e7$var$cb_btou = (cccc)=>{
    switch(cccc.length){
        case 4:
            var cp = (0x07 & cccc.charCodeAt(0)) << 18 | (0x3f & cccc.charCodeAt(1)) << 12 | (0x3f & cccc.charCodeAt(2)) << 6 | 0x3f & cccc.charCodeAt(3), offset = cp - 0x10000;
            return $a51df0a00d9875e7$var$_fromCC((offset >>> 10) + 0xD800) + $a51df0a00d9875e7$var$_fromCC((offset & 0x3FF) + 0xDC00);
        case 3:
            return $a51df0a00d9875e7$var$_fromCC((0x0f & cccc.charCodeAt(0)) << 12 | (0x3f & cccc.charCodeAt(1)) << 6 | 0x3f & cccc.charCodeAt(2));
        default:
            return $a51df0a00d9875e7$var$_fromCC((0x1f & cccc.charCodeAt(0)) << 6 | 0x3f & cccc.charCodeAt(1));
    }
};
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-16 string
 * @returns {string} UTF-8 string
 */ const $a51df0a00d9875e7$export$67e9defdeac3dd95 = (b)=>b.replace($a51df0a00d9875e7$var$re_btou, $a51df0a00d9875e7$var$cb_btou);
/**
 * polyfill version of `atob`
 */ const $a51df0a00d9875e7$export$7f16d8e674ddec24 = (asc)=>{
    // console.log('polyfilled');
    asc = asc.replace(/\s+/g, "");
    if (!$a51df0a00d9875e7$var$b64re.test(asc)) throw new TypeError("malformed base64.");
    asc += "==".slice(2 - (asc.length & 3));
    let u24, bin = "", r1, r2;
    for(let i = 0; i < asc.length;){
        u24 = $a51df0a00d9875e7$var$b64tab[asc.charAt(i++)] << 18 | $a51df0a00d9875e7$var$b64tab[asc.charAt(i++)] << 12 | (r1 = $a51df0a00d9875e7$var$b64tab[asc.charAt(i++)]) << 6 | (r2 = $a51df0a00d9875e7$var$b64tab[asc.charAt(i++)]);
        bin += r1 === 64 ? $a51df0a00d9875e7$var$_fromCC(u24 >> 16 & 255) : r2 === 64 ? $a51df0a00d9875e7$var$_fromCC(u24 >> 16 & 255, u24 >> 8 & 255) : $a51df0a00d9875e7$var$_fromCC(u24 >> 16 & 255, u24 >> 8 & 255, u24 & 255);
    }
    return bin;
};
/**
 * does what `window.atob` of web browsers do.
 * @param {String} asc Base64-encoded string
 * @returns {string} binary string
 */ const $a51df0a00d9875e7$export$1406ac7a6dfd7b7a = $a51df0a00d9875e7$var$_hasatob ? (asc)=>atob($a51df0a00d9875e7$var$_tidyB64(asc)) : $a51df0a00d9875e7$var$_hasBuffer ? (asc)=>$a51df0a00d9875e7$require$Buffer.from(asc, "base64").toString("binary") : $a51df0a00d9875e7$export$7f16d8e674ddec24;
//
const $a51df0a00d9875e7$var$_toUint8Array = $a51df0a00d9875e7$var$_hasBuffer ? (a)=>$a51df0a00d9875e7$var$_U8Afrom($a51df0a00d9875e7$require$Buffer.from(a, "base64")) : (a)=>$a51df0a00d9875e7$var$_U8Afrom($a51df0a00d9875e7$export$1406ac7a6dfd7b7a(a).split("").map((c)=>c.charCodeAt(0)));
/**
 * converts a Base64 string to a Uint8Array.
 */ const $a51df0a00d9875e7$export$73470fd2221e6aef = (a)=>$a51df0a00d9875e7$var$_toUint8Array($a51df0a00d9875e7$var$_unURI(a));
//
const $a51df0a00d9875e7$var$_decode = $a51df0a00d9875e7$var$_hasBuffer ? (a)=>$a51df0a00d9875e7$require$Buffer.from(a, "base64").toString("utf8") : $a51df0a00d9875e7$var$_TD ? (a)=>$a51df0a00d9875e7$var$_TD.decode($a51df0a00d9875e7$var$_toUint8Array(a)) : (a)=>$a51df0a00d9875e7$export$67e9defdeac3dd95($a51df0a00d9875e7$export$1406ac7a6dfd7b7a(a));
const $a51df0a00d9875e7$var$_unURI = (a)=>$a51df0a00d9875e7$var$_tidyB64(a.replace(/[-_]/g, (m0)=>m0 == "-" ? "+" : "/"));
/**
 * converts a Base64 string to a UTF-8 string.
 * @param {String} src Base64 string.  Both normal and URL-safe are supported
 * @returns {string} UTF-8 string
 */ const $a51df0a00d9875e7$export$c537b38001c583b7 = (src)=>$a51df0a00d9875e7$var$_decode($a51df0a00d9875e7$var$_unURI(src));
/**
 * check if a value is a valid Base64 string
 * @param {String} src a value to check
  */ const $a51df0a00d9875e7$export$1ea939691cdc45b8 = (src)=>{
    if (typeof src !== "string") return false;
    const s = src.replace(/\s+/g, "").replace(/={0,2}$/, "");
    return !/[^\s0-9a-zA-Z\+/]/.test(s) || !/[^\s0-9a-zA-Z\-_]/.test(s);
};
//
const $a51df0a00d9875e7$var$_noEnum = (v)=>{
    return {
        value: v,
        enumerable: false,
        writable: true,
        configurable: true
    };
};
/**
 * extend String.prototype with relevant methods
 */ const $a51df0a00d9875e7$export$4678ebf2295c49b = function() {
    const _add = (name, body)=>Object.defineProperty(String.prototype, name, $a51df0a00d9875e7$var$_noEnum(body));
    _add("fromBase64", function() {
        return $a51df0a00d9875e7$export$c537b38001c583b7(this);
    });
    _add("toBase64", function(urlsafe) {
        return $a51df0a00d9875e7$export$37cc283d8fbd3462(this, urlsafe);
    });
    _add("toBase64URI", function() {
        return $a51df0a00d9875e7$export$37cc283d8fbd3462(this, true);
    });
    _add("toBase64URL", function() {
        return $a51df0a00d9875e7$export$37cc283d8fbd3462(this, true);
    });
    _add("toUint8Array", function() {
        return $a51df0a00d9875e7$export$73470fd2221e6aef(this);
    });
};
/**
 * extend Uint8Array.prototype with relevant methods
 */ const $a51df0a00d9875e7$export$a105d6a15258bd2 = function() {
    const _add = (name, body)=>Object.defineProperty(Uint8Array.prototype, name, $a51df0a00d9875e7$var$_noEnum(body));
    _add("toBase64", function(urlsafe) {
        return $a51df0a00d9875e7$export$27bbb4e040978768(this, urlsafe);
    });
    _add("toBase64URI", function() {
        return $a51df0a00d9875e7$export$27bbb4e040978768(this, true);
    });
    _add("toBase64URL", function() {
        return $a51df0a00d9875e7$export$27bbb4e040978768(this, true);
    });
};
/**
 * extend Builtin prototypes with relevant methods
 */ const $a51df0a00d9875e7$export$1abf1fe5ebfd5245 = ()=>{
    $a51df0a00d9875e7$export$4678ebf2295c49b();
    $a51df0a00d9875e7$export$a105d6a15258bd2();
};
const $a51df0a00d9875e7$export$f436b0c2107cbd35 = {
    version: $a51df0a00d9875e7$export$83d89fbfd8236492,
    VERSION: $a51df0a00d9875e7$export$a4ad2735b021c132,
    atob: $a51df0a00d9875e7$export$1406ac7a6dfd7b7a,
    atobPolyfill: $a51df0a00d9875e7$export$7f16d8e674ddec24,
    btoa: $a51df0a00d9875e7$export$a32219e24f8d1e2,
    btoaPolyfill: $a51df0a00d9875e7$export$ec0fb543302ee251,
    fromBase64: $a51df0a00d9875e7$export$c537b38001c583b7,
    toBase64: $a51df0a00d9875e7$export$37cc283d8fbd3462,
    encode: $a51df0a00d9875e7$export$37cc283d8fbd3462,
    encodeURI: $a51df0a00d9875e7$export$90c31d5baa78df44,
    encodeURL: $a51df0a00d9875e7$export$90c31d5baa78df44,
    utob: $a51df0a00d9875e7$export$10d4b9bd20a66b0,
    btou: $a51df0a00d9875e7$export$67e9defdeac3dd95,
    decode: $a51df0a00d9875e7$export$c537b38001c583b7,
    isValid: $a51df0a00d9875e7$export$1ea939691cdc45b8,
    fromUint8Array: $a51df0a00d9875e7$export$27bbb4e040978768,
    toUint8Array: $a51df0a00d9875e7$export$73470fd2221e6aef,
    extendString: $a51df0a00d9875e7$export$4678ebf2295c49b,
    extendUint8Array: $a51df0a00d9875e7$export$a105d6a15258bd2,
    extendBuiltins: $a51df0a00d9875e7$export$1abf1fe5ebfd5245
};

});
parcelRequire.register("69DCu", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $47b2510643d68487$export$a143d493d941bafc; }, function (v) { return $47b2510643d68487$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $47b2510643d68487$export$f99ded8fe4b79145; }, function (v) { return $47b2510643d68487$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $47b2510643d68487$export$a143d493d941bafc;
var $47b2510643d68487$export$e4cf37d7f6fb9e0a;
var $47b2510643d68487$export$f99ded8fe4b79145;
var $47b2510643d68487$export$599f31c3813fae4d;
"use strict";

var $17QOo = parcelRequire("17QOo");

var $52FOt = parcelRequire("52FOt");
var $47b2510643d68487$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$47b2510643d68487$export$a143d493d941bafc = $47b2510643d68487$var$Buffer;
$47b2510643d68487$export$e4cf37d7f6fb9e0a = $47b2510643d68487$var$SlowBuffer;
$47b2510643d68487$export$f99ded8fe4b79145 = 50;
var $47b2510643d68487$var$K_MAX_LENGTH = 0x7fffffff;
$47b2510643d68487$export$599f31c3813fae4d = $47b2510643d68487$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $47b2510643d68487$var$Buffer.TYPED_ARRAY_SUPPORT = $47b2510643d68487$var$typedArraySupport();
if (!$47b2510643d68487$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $47b2510643d68487$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($47b2510643d68487$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$47b2510643d68487$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($47b2510643d68487$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$47b2510643d68487$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $47b2510643d68487$var$createBuffer(length) {
    if (length > $47b2510643d68487$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $47b2510643d68487$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $47b2510643d68487$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $47b2510643d68487$var$allocUnsafe(arg);
    }
    return $47b2510643d68487$var$from(arg, encodingOrOffset, length);
}
$47b2510643d68487$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $47b2510643d68487$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $47b2510643d68487$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $47b2510643d68487$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($47b2510643d68487$var$isInstance(value, ArrayBuffer) || value && $47b2510643d68487$var$isInstance(value.buffer, ArrayBuffer)) return $47b2510643d68487$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($47b2510643d68487$var$isInstance(value, SharedArrayBuffer) || value && $47b2510643d68487$var$isInstance(value.buffer, SharedArrayBuffer))) return $47b2510643d68487$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $47b2510643d68487$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $47b2510643d68487$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $47b2510643d68487$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $47b2510643d68487$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $47b2510643d68487$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($47b2510643d68487$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($47b2510643d68487$var$Buffer, Uint8Array);
function $47b2510643d68487$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $47b2510643d68487$var$alloc(size, fill, encoding) {
    $47b2510643d68487$var$assertSize(size);
    if (size <= 0) return $47b2510643d68487$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $47b2510643d68487$var$createBuffer(size).fill(fill, encoding) : $47b2510643d68487$var$createBuffer(size).fill(fill);
    return $47b2510643d68487$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $47b2510643d68487$var$Buffer.alloc = function(size, fill, encoding) {
    return $47b2510643d68487$var$alloc(size, fill, encoding);
};
function $47b2510643d68487$var$allocUnsafe(size) {
    $47b2510643d68487$var$assertSize(size);
    return $47b2510643d68487$var$createBuffer(size < 0 ? 0 : $47b2510643d68487$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $47b2510643d68487$var$Buffer.allocUnsafe = function(size) {
    return $47b2510643d68487$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $47b2510643d68487$var$Buffer.allocUnsafeSlow = function(size) {
    return $47b2510643d68487$var$allocUnsafe(size);
};
function $47b2510643d68487$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$47b2510643d68487$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $47b2510643d68487$var$byteLength(string, encoding) | 0;
    var buf = $47b2510643d68487$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $47b2510643d68487$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $47b2510643d68487$var$checked(array.length) | 0;
    var buf = $47b2510643d68487$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $47b2510643d68487$var$fromArrayView(arrayView) {
    if ($47b2510643d68487$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $47b2510643d68487$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $47b2510643d68487$var$fromArrayLike(arrayView);
}
function $47b2510643d68487$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $47b2510643d68487$var$Buffer.prototype);
    return buf;
}
function $47b2510643d68487$var$fromObject(obj) {
    if ($47b2510643d68487$var$Buffer.isBuffer(obj)) {
        var len = $47b2510643d68487$var$checked(obj.length) | 0;
        var buf = $47b2510643d68487$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $47b2510643d68487$var$numberIsNaN(obj.length)) return $47b2510643d68487$var$createBuffer(0);
        return $47b2510643d68487$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $47b2510643d68487$var$fromArrayLike(obj.data);
}
function $47b2510643d68487$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $47b2510643d68487$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $47b2510643d68487$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $47b2510643d68487$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $47b2510643d68487$var$Buffer.alloc(+length);
}
$47b2510643d68487$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $47b2510643d68487$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$47b2510643d68487$var$Buffer.compare = function compare(a, b) {
    if ($47b2510643d68487$var$isInstance(a, Uint8Array)) a = $47b2510643d68487$var$Buffer.from(a, a.offset, a.byteLength);
    if ($47b2510643d68487$var$isInstance(b, Uint8Array)) b = $47b2510643d68487$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$47b2510643d68487$var$Buffer.isBuffer(a) || !$47b2510643d68487$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$47b2510643d68487$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$47b2510643d68487$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $47b2510643d68487$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $47b2510643d68487$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($47b2510643d68487$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $47b2510643d68487$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$47b2510643d68487$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $47b2510643d68487$var$byteLength(string, encoding) {
    if ($47b2510643d68487$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $47b2510643d68487$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $47b2510643d68487$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $47b2510643d68487$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $47b2510643d68487$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$47b2510643d68487$var$Buffer.byteLength = $47b2510643d68487$var$byteLength;
function $47b2510643d68487$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $47b2510643d68487$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $47b2510643d68487$var$utf8Slice(this, start, end);
        case "ascii":
            return $47b2510643d68487$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $47b2510643d68487$var$latin1Slice(this, start, end);
        case "base64":
            return $47b2510643d68487$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $47b2510643d68487$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$47b2510643d68487$var$Buffer.prototype._isBuffer = true;
function $47b2510643d68487$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$47b2510643d68487$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$47b2510643d68487$var$swap(this, i, i + 1);
    return this;
};
$47b2510643d68487$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $47b2510643d68487$var$swap(this, i, i + 3);
        $47b2510643d68487$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$47b2510643d68487$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $47b2510643d68487$var$swap(this, i, i + 7);
        $47b2510643d68487$var$swap(this, i + 1, i + 6);
        $47b2510643d68487$var$swap(this, i + 2, i + 5);
        $47b2510643d68487$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$47b2510643d68487$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $47b2510643d68487$var$utf8Slice(this, 0, length);
    return $47b2510643d68487$var$slowToString.apply(this, arguments);
};
$47b2510643d68487$var$Buffer.prototype.toLocaleString = $47b2510643d68487$var$Buffer.prototype.toString;
$47b2510643d68487$var$Buffer.prototype.equals = function equals(b) {
    if (!$47b2510643d68487$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $47b2510643d68487$var$Buffer.compare(this, b) === 0;
};
$47b2510643d68487$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $47b2510643d68487$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($47b2510643d68487$var$customInspectSymbol) $47b2510643d68487$var$Buffer.prototype[$47b2510643d68487$var$customInspectSymbol] = $47b2510643d68487$var$Buffer.prototype.inspect;
$47b2510643d68487$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($47b2510643d68487$var$isInstance(target, Uint8Array)) target = $47b2510643d68487$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$47b2510643d68487$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $47b2510643d68487$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($47b2510643d68487$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $47b2510643d68487$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($47b2510643d68487$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $47b2510643d68487$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $47b2510643d68487$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $47b2510643d68487$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$47b2510643d68487$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$47b2510643d68487$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $47b2510643d68487$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$47b2510643d68487$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $47b2510643d68487$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $47b2510643d68487$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($47b2510643d68487$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $47b2510643d68487$var$utf8Write(buf, string, offset, length) {
    return $47b2510643d68487$var$blitBuffer($47b2510643d68487$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $47b2510643d68487$var$asciiWrite(buf, string, offset, length) {
    return $47b2510643d68487$var$blitBuffer($47b2510643d68487$var$asciiToBytes(string), buf, offset, length);
}
function $47b2510643d68487$var$base64Write(buf, string, offset, length) {
    return $47b2510643d68487$var$blitBuffer($47b2510643d68487$var$base64ToBytes(string), buf, offset, length);
}
function $47b2510643d68487$var$ucs2Write(buf, string, offset, length) {
    return $47b2510643d68487$var$blitBuffer($47b2510643d68487$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$47b2510643d68487$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $47b2510643d68487$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $47b2510643d68487$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $47b2510643d68487$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $47b2510643d68487$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $47b2510643d68487$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$47b2510643d68487$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $47b2510643d68487$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $17QOo.fromByteArray(buf);
    else return $17QOo.fromByteArray(buf.slice(start, end));
}
function $47b2510643d68487$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $47b2510643d68487$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $47b2510643d68487$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $47b2510643d68487$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $47b2510643d68487$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $47b2510643d68487$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $47b2510643d68487$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $47b2510643d68487$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $47b2510643d68487$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $47b2510643d68487$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $47b2510643d68487$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$47b2510643d68487$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $47b2510643d68487$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $47b2510643d68487$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$47b2510643d68487$var$Buffer.prototype.readUintLE = $47b2510643d68487$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $47b2510643d68487$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$47b2510643d68487$var$Buffer.prototype.readUintBE = $47b2510643d68487$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $47b2510643d68487$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$47b2510643d68487$var$Buffer.prototype.readUint8 = $47b2510643d68487$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $47b2510643d68487$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$47b2510643d68487$var$Buffer.prototype.readUint16LE = $47b2510643d68487$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $47b2510643d68487$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$47b2510643d68487$var$Buffer.prototype.readUint16BE = $47b2510643d68487$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $47b2510643d68487$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$47b2510643d68487$var$Buffer.prototype.readUint32LE = $47b2510643d68487$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $47b2510643d68487$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$47b2510643d68487$var$Buffer.prototype.readUint32BE = $47b2510643d68487$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $47b2510643d68487$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$47b2510643d68487$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $47b2510643d68487$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$47b2510643d68487$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $47b2510643d68487$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$47b2510643d68487$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $47b2510643d68487$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$47b2510643d68487$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $47b2510643d68487$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$47b2510643d68487$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $47b2510643d68487$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$47b2510643d68487$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $47b2510643d68487$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$47b2510643d68487$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $47b2510643d68487$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$47b2510643d68487$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $47b2510643d68487$var$checkOffset(offset, 4, this.length);
    return $52FOt.read(this, offset, true, 23, 4);
};
$47b2510643d68487$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $47b2510643d68487$var$checkOffset(offset, 4, this.length);
    return $52FOt.read(this, offset, false, 23, 4);
};
$47b2510643d68487$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $47b2510643d68487$var$checkOffset(offset, 8, this.length);
    return $52FOt.read(this, offset, true, 52, 8);
};
$47b2510643d68487$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $47b2510643d68487$var$checkOffset(offset, 8, this.length);
    return $52FOt.read(this, offset, false, 52, 8);
};
function $47b2510643d68487$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$47b2510643d68487$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$47b2510643d68487$var$Buffer.prototype.writeUintLE = $47b2510643d68487$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $47b2510643d68487$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$47b2510643d68487$var$Buffer.prototype.writeUintBE = $47b2510643d68487$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $47b2510643d68487$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$47b2510643d68487$var$Buffer.prototype.writeUint8 = $47b2510643d68487$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $47b2510643d68487$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$47b2510643d68487$var$Buffer.prototype.writeUint16LE = $47b2510643d68487$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $47b2510643d68487$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$47b2510643d68487$var$Buffer.prototype.writeUint16BE = $47b2510643d68487$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $47b2510643d68487$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$47b2510643d68487$var$Buffer.prototype.writeUint32LE = $47b2510643d68487$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $47b2510643d68487$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$47b2510643d68487$var$Buffer.prototype.writeUint32BE = $47b2510643d68487$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $47b2510643d68487$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$47b2510643d68487$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $47b2510643d68487$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$47b2510643d68487$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $47b2510643d68487$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$47b2510643d68487$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $47b2510643d68487$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$47b2510643d68487$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $47b2510643d68487$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$47b2510643d68487$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $47b2510643d68487$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$47b2510643d68487$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $47b2510643d68487$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$47b2510643d68487$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $47b2510643d68487$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $47b2510643d68487$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $47b2510643d68487$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $47b2510643d68487$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $52FOt.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$47b2510643d68487$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $47b2510643d68487$var$writeFloat(this, value, offset, true, noAssert);
};
$47b2510643d68487$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $47b2510643d68487$var$writeFloat(this, value, offset, false, noAssert);
};
function $47b2510643d68487$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $47b2510643d68487$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $52FOt.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$47b2510643d68487$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $47b2510643d68487$var$writeDouble(this, value, offset, true, noAssert);
};
$47b2510643d68487$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $47b2510643d68487$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$47b2510643d68487$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$47b2510643d68487$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$47b2510643d68487$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$47b2510643d68487$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $47b2510643d68487$var$Buffer.isBuffer(val) ? val : $47b2510643d68487$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $47b2510643d68487$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $47b2510643d68487$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($47b2510643d68487$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $47b2510643d68487$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $47b2510643d68487$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $47b2510643d68487$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $47b2510643d68487$var$base64ToBytes(str) {
    return $17QOo.toByteArray($47b2510643d68487$var$base64clean(str));
}
function $47b2510643d68487$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $47b2510643d68487$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $47b2510643d68487$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $47b2510643d68487$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRequire.register("17QOo", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $0d1f6938271f830f$export$d622b2ad8d90c771; }, function (v) { return $0d1f6938271f830f$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $0d1f6938271f830f$export$6100ba28696e12de; }, function (v) { return $0d1f6938271f830f$export$6100ba28696e12de = v; });
var $0d1f6938271f830f$export$a48f0734ac7c2329;
var $0d1f6938271f830f$export$d622b2ad8d90c771;
var $0d1f6938271f830f$export$6100ba28696e12de;
"use strict";
$0d1f6938271f830f$export$a48f0734ac7c2329 = $0d1f6938271f830f$var$byteLength;
$0d1f6938271f830f$export$d622b2ad8d90c771 = $0d1f6938271f830f$var$toByteArray;
$0d1f6938271f830f$export$6100ba28696e12de = $0d1f6938271f830f$var$fromByteArray;
var $0d1f6938271f830f$var$lookup = [];
var $0d1f6938271f830f$var$revLookup = [];
var $0d1f6938271f830f$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $0d1f6938271f830f$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $0d1f6938271f830f$var$i = 0, $0d1f6938271f830f$var$len = $0d1f6938271f830f$var$code.length; $0d1f6938271f830f$var$i < $0d1f6938271f830f$var$len; ++$0d1f6938271f830f$var$i){
    $0d1f6938271f830f$var$lookup[$0d1f6938271f830f$var$i] = $0d1f6938271f830f$var$code[$0d1f6938271f830f$var$i];
    $0d1f6938271f830f$var$revLookup[$0d1f6938271f830f$var$code.charCodeAt($0d1f6938271f830f$var$i)] = $0d1f6938271f830f$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$0d1f6938271f830f$var$revLookup["-".charCodeAt(0)] = 62;
$0d1f6938271f830f$var$revLookup["_".charCodeAt(0)] = 63;
function $0d1f6938271f830f$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $0d1f6938271f830f$var$byteLength(b64) {
    var lens = $0d1f6938271f830f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $0d1f6938271f830f$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $0d1f6938271f830f$var$toByteArray(b64) {
    var tmp;
    var lens = $0d1f6938271f830f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $0d1f6938271f830f$var$Arr($0d1f6938271f830f$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $0d1f6938271f830f$var$revLookup[b64.charCodeAt(i)] << 18 | $0d1f6938271f830f$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $0d1f6938271f830f$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $0d1f6938271f830f$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $0d1f6938271f830f$var$revLookup[b64.charCodeAt(i)] << 2 | $0d1f6938271f830f$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $0d1f6938271f830f$var$revLookup[b64.charCodeAt(i)] << 10 | $0d1f6938271f830f$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $0d1f6938271f830f$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $0d1f6938271f830f$var$tripletToBase64(num) {
    return $0d1f6938271f830f$var$lookup[num >> 18 & 0x3F] + $0d1f6938271f830f$var$lookup[num >> 12 & 0x3F] + $0d1f6938271f830f$var$lookup[num >> 6 & 0x3F] + $0d1f6938271f830f$var$lookup[num & 0x3F];
}
function $0d1f6938271f830f$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($0d1f6938271f830f$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $0d1f6938271f830f$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($0d1f6938271f830f$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($0d1f6938271f830f$var$lookup[tmp >> 2] + $0d1f6938271f830f$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($0d1f6938271f830f$var$lookup[tmp >> 10] + $0d1f6938271f830f$var$lookup[tmp >> 4 & 0x3F] + $0d1f6938271f830f$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRequire.register("52FOt", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $3abd92db23031ff7$export$aafa59e2e03f2942; }, function (v) { return $3abd92db23031ff7$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $3abd92db23031ff7$export$68d8715fc104d294; }, function (v) { return $3abd92db23031ff7$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $3abd92db23031ff7$export$aafa59e2e03f2942;
var $3abd92db23031ff7$export$68d8715fc104d294;
$3abd92db23031ff7$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$3abd92db23031ff7$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});





parcelRequire.register("7pgvg", function(module, exports) {

$parcel$export(module.exports, "LogtoProvider", function () { return $5647ab6a4a961344$export$bfa587c2c3245948; });

var $C7mD2 = parcelRequire("C7mD2");

var $hNIcd = parcelRequire("hNIcd");

var $jC8Vy = parcelRequire("jC8Vy");

var $fyi6K = parcelRequire("fyi6K");
const $5647ab6a4a961344$export$bfa587c2c3245948 = ({ config: config, LogtoClientClass: LogtoClientClass = (0, $hNIcd.default), children: children, unstable_enableCache: unstable_enableCache = false })=>{
    const [loadingCount, setLoadingCount] = (0, $jC8Vy.useState)(1);
    const memorizedLogtoClient = (0, $jC8Vy.useMemo)(()=>({
            logtoClient: new LogtoClientClass(config, unstable_enableCache)
        }), [
        LogtoClientClass,
        config,
        unstable_enableCache
    ]);
    const [isAuthenticated, setIsAuthenticated] = (0, $jC8Vy.useState)(false);
    const [error, setError] = (0, $jC8Vy.useState)();
    const isLoading = (0, $jC8Vy.useMemo)(()=>loadingCount > 0, [
        loadingCount
    ]);
    const setIsLoading = (0, $jC8Vy.useCallback)((state)=>{
        if (state) setLoadingCount((count)=>count + 1);
        else setLoadingCount((count)=>Math.max(0, count - 1));
    }, [
        setLoadingCount
    ]);
    (0, $jC8Vy.useEffect)(()=>{
        (async ()=>{
            const isAuthenticated = await memorizedLogtoClient.logtoClient.isAuthenticated();
            setIsAuthenticated(isAuthenticated);
            setLoadingCount((count)=>Math.max(0, count - 1));
        })();
    }, [
        memorizedLogtoClient
    ]);
    const memorizedContextValue = (0, $jC8Vy.useMemo)(()=>({
            ...memorizedLogtoClient,
            isAuthenticated: isAuthenticated,
            setIsAuthenticated: setIsAuthenticated,
            isLoading: isLoading,
            setIsLoading: setIsLoading,
            error: error,
            setError: setError
        }), [
        memorizedLogtoClient,
        isAuthenticated,
        isLoading,
        setIsLoading,
        error
    ]);
    return (0, $C7mD2.jsx)((0, $fyi6K.LogtoContext).Provider, {
        value: memorizedContextValue,
        children: children
    });
};

});
parcelRequire.register("fyi6K", function(module, exports) {

$parcel$export(module.exports, "throwContextError", function () { return $b52813d5729b2a5b$export$838ead842aa548e7; });
$parcel$export(module.exports, "LogtoContext", function () { return $b52813d5729b2a5b$export$e5bf247804b97da7; });

var $jC8Vy = parcelRequire("jC8Vy");
const $b52813d5729b2a5b$export$838ead842aa548e7 = ()=>{
    throw new Error("Must be used inside <LogtoProvider> context.");
};
/**
 * The context for the LogtoProvider.
 *
 * @remarks
 * Instead of using this context directly, in most cases you should use the `useLogto` hook.
 */ const $b52813d5729b2a5b$export$e5bf247804b97da7 = (0, $jC8Vy.createContext)({
    logtoClient: undefined,
    isAuthenticated: false,
    isLoading: false,
    error: undefined,
    setIsAuthenticated: $b52813d5729b2a5b$export$838ead842aa548e7,
    setIsLoading: $b52813d5729b2a5b$export$838ead842aa548e7,
    setError: $b52813d5729b2a5b$export$838ead842aa548e7
});

});


parcelRequire.register("jSb9j", function(module, exports) {

$parcel$export(module.exports, "useHandleSignInCallback", function () { return $e77bb57c01014063$export$84e88c4b3c082374; });
$parcel$export(module.exports, "useLogto", function () { return $e77bb57c01014063$export$44fc9df4d2a1789a; });
parcelRequire("12bMu");
var $3dBAh = parcelRequire("3dBAh");

var $jC8Vy = parcelRequire("jC8Vy");

var $fyi6K = parcelRequire("fyi6K");
const $e77bb57c01014063$var$useErrorHandler = ()=>{
    const { setError: setError } = (0, $jC8Vy.useContext)((0, $fyi6K.LogtoContext));
    const handleError = (0, $jC8Vy.useCallback)((error, fallbackErrorMessage)=>{
        if (error instanceof Error) setError(error);
        else if (fallbackErrorMessage) setError(new Error(fallbackErrorMessage));
        console.error(error);
    }, [
        setError
    ]);
    return {
        handleError: handleError
    };
};
const $e77bb57c01014063$export$84e88c4b3c082374 = (callback)=>{
    const { logtoClient: logtoClient, isAuthenticated: isAuthenticated, error: error, setIsAuthenticated: setIsAuthenticated, isLoading: isLoading, setIsLoading: setIsLoading } = (0, $jC8Vy.useContext)((0, $fyi6K.LogtoContext));
    const { handleError: handleError } = $e77bb57c01014063$var$useErrorHandler();
    const callbackRef = (0, $jC8Vy.useRef)();
    (0, $jC8Vy.useEffect)(()=>{
        // eslint-disable-next-line @silverhand/fp/no-mutation
        callbackRef.current = callback; // Update ref to the latest callback.
    }, [
        callback
    ]);
    (0, $jC8Vy.useEffect)(()=>{
        if (!logtoClient || isLoading || error) return;
        (async ()=>{
            const currentPageUrl = window.location.href;
            const isRedirected = await logtoClient.isSignInRedirected(currentPageUrl);
            if (!isAuthenticated && isRedirected) {
                setIsLoading(true);
                await (0, $3dBAh.trySafe)(async ()=>{
                    await logtoClient.handleSignInCallback(currentPageUrl);
                    setIsAuthenticated(true);
                    callbackRef.current?.();
                }, (error)=>{
                    handleError(error, "Unexpected error occurred while handling sign in callback.");
                });
                setIsLoading(false);
            }
        })();
    }, [
        error,
        handleError,
        isAuthenticated,
        isLoading,
        logtoClient,
        setIsAuthenticated,
        setIsLoading
    ]);
    return {
        isLoading: isLoading,
        isAuthenticated: isAuthenticated,
        error: error
    };
};
const $e77bb57c01014063$export$44fc9df4d2a1789a = ()=>{
    const { logtoClient: logtoClient, isAuthenticated: isAuthenticated, error: error, isLoading: isLoading, setIsLoading: setIsLoading } = (0, $jC8Vy.useContext)((0, $fyi6K.LogtoContext));
    const { handleError: handleError } = $e77bb57c01014063$var$useErrorHandler();
    const client = logtoClient ?? (0, $fyi6K.throwContextError)();
    const proxy = (0, $jC8Vy.useCallback)((run, resetLoadingState = true)=>{
        return async (...args)=>{
            try {
                setIsLoading(true);
                return await run(...args);
            } catch (error) {
                handleError(error, `Unexpected error occurred while calling ${run.name}.`);
            } finally{
                if (resetLoadingState) setIsLoading(false);
            }
        };
    }, [
        setIsLoading,
        handleError
    ]);
    const methods = (0, $jC8Vy.useMemo)(()=>({
            getRefreshToken: proxy(client.getRefreshToken.bind(client)),
            getAccessToken: proxy(client.getAccessToken.bind(client)),
            getAccessTokenClaims: proxy(client.getAccessTokenClaims.bind(client)),
            getOrganizationToken: proxy(client.getOrganizationToken.bind(client)),
            getOrganizationTokenClaims: proxy(client.getOrganizationTokenClaims.bind(client)),
            getIdToken: proxy(client.getIdToken.bind(client)),
            getIdTokenClaims: proxy(client.getIdTokenClaims.bind(client)),
            // eslint-disable-next-line no-restricted-syntax -- TypeScript cannot infer the correct type.
            signIn: proxy(client.signIn.bind(client), false),
            // We deliberately do NOT set isAuthenticated to false in the function below, because the app state
            // may change immediately even before navigating to the oidc end session endpoint, which might cause
            // rendering problems.
            // Moreover, since the location will be redirected, the isAuthenticated state will not matter any more.
            signOut: proxy(client.signOut.bind(client)),
            fetchUserInfo: proxy(client.fetchUserInfo.bind(client)),
            clearAccessToken: proxy(client.clearAccessToken.bind(client)),
            clearAllTokens: proxy(client.clearAllTokens.bind(client))
        }), [
        client,
        proxy
    ]);
    return {
        isAuthenticated: isAuthenticated,
        isLoading: isLoading,
        error: error,
        ...methods
    };
};

});


parcelRequire.register("64jBf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46b251e9fd0b348c$export$2e2bcd8739ae039; });
/*! MIT License © Sindre Sorhus */ 
var $hUScF = parcelRequire("hUScF");

var $2Gxno = parcelRequire("2Gxno");

var $4DUCQ = parcelRequire("4DUCQ");

var $5cXXM = parcelRequire("5cXXM");

const $46b251e9fd0b348c$var$createInstance = (defaults)=>{
    // eslint-disable-next-line @typescript-eslint/promise-function-async
    const ky = (input, options)=>(0, $hUScF.Ky).create(input, (0, $4DUCQ.validateAndMerge)(defaults, options));
    for (const method of (0, $2Gxno.requestMethods))// eslint-disable-next-line @typescript-eslint/promise-function-async
    ky[method] = (input, options)=>(0, $hUScF.Ky).create(input, (0, $4DUCQ.validateAndMerge)(defaults, options, {
            method: method
        }));
    ky.create = (newDefaults)=>$46b251e9fd0b348c$var$createInstance((0, $4DUCQ.validateAndMerge)(newDefaults));
    ky.extend = (newDefaults)=>$46b251e9fd0b348c$var$createInstance((0, $4DUCQ.validateAndMerge)(defaults, newDefaults));
    ky.stop = (0, $2Gxno.stop);
    return ky;
};
const $46b251e9fd0b348c$var$ky = $46b251e9fd0b348c$var$createInstance();
var $46b251e9fd0b348c$export$2e2bcd8739ae039 = $46b251e9fd0b348c$var$ky;

});
parcelRequire.register("hUScF", function(module, exports) {

$parcel$export(module.exports, "Ky", function () { return $d0b1b64739876117$export$c482d6f00e170af3; });

var $5cXXM = parcelRequire("5cXXM");

var $7JIVu = parcelRequire("7JIVu");

var $4DUCQ = parcelRequire("4DUCQ");

var $f4plr = parcelRequire("f4plr");

var $2wSQZ = parcelRequire("2wSQZ");

var $e2M0r = parcelRequire("e2M0r");

var $FK38X = parcelRequire("FK38X");

var $2Gxno = parcelRequire("2Gxno");
class $d0b1b64739876117$export$c482d6f00e170af3 {
    static create(input, options) {
        const ky = new $d0b1b64739876117$export$c482d6f00e170af3(input, options);
        const function_ = async ()=>{
            if (typeof ky._options.timeout === "number" && ky._options.timeout > (0, $2Gxno.maxSafeTimeout)) throw new RangeError(`The \`timeout\` option cannot be greater than ${(0, $2Gxno.maxSafeTimeout)}`);
            // Delay the fetch so that body method shortcuts can set the Accept header
            await Promise.resolve();
            let response = await ky._fetch();
            for (const hook of ky._options.hooks.afterResponse){
                // eslint-disable-next-line no-await-in-loop
                const modifiedResponse = await hook(ky.request, ky._options, ky._decorateResponse(response.clone()));
                if (modifiedResponse instanceof globalThis.Response) response = modifiedResponse;
            }
            ky._decorateResponse(response);
            if (!response.ok && ky._options.throwHttpErrors) {
                let error = new (0, $5cXXM.HTTPError)(response, ky.request, ky._options);
                for (const hook of ky._options.hooks.beforeError)// eslint-disable-next-line no-await-in-loop
                error = await hook(error);
                throw error;
            }
            // If `onDownloadProgress` is passed, it uses the stream API internally
            /* istanbul ignore next */ if (ky._options.onDownloadProgress) {
                if (typeof ky._options.onDownloadProgress !== "function") throw new TypeError("The `onDownloadProgress` option must be a function");
                if (!(0, $2Gxno.supportsResponseStreams)) throw new Error("Streams are not supported in your environment. `ReadableStream` is missing.");
                return ky._stream(response.clone(), ky._options.onDownloadProgress);
            }
            return response;
        };
        const isRetriableMethod = ky._options.retry.methods.includes(ky.request.method.toLowerCase());
        const result = isRetriableMethod ? ky._retry(function_) : function_();
        for (const [type, mimeType] of Object.entries((0, $2Gxno.responseTypes)))result[type] = async ()=>{
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            ky.request.headers.set("accept", ky.request.headers.get("accept") || mimeType);
            const awaitedResult = await result;
            const response = awaitedResult.clone();
            if (type === "json") {
                if (response.status === 204) return "";
                const arrayBuffer = await response.clone().arrayBuffer();
                const responseSize = arrayBuffer.byteLength;
                if (responseSize === 0) return "";
                if (options.parseJson) return options.parseJson(await response.text());
            }
            return response[type]();
        };
        return result;
    }
    // eslint-disable-next-line complexity
    constructor(input, options = {}){
        Object.defineProperty(this, "request", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "abortController", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_retryCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "_input", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._input = input;
        const credentials = this._input instanceof Request && "credentials" in Request.prototype ? this._input.credentials : undefined;
        this._options = {
            ...credentials && {
                credentials: credentials
            },
            ...options,
            headers: (0, $4DUCQ.mergeHeaders)(this._input.headers, options.headers),
            hooks: (0, $4DUCQ.deepMerge)({
                beforeRequest: [],
                beforeRetry: [],
                beforeError: [],
                afterResponse: []
            }, options.hooks),
            method: (0, $f4plr.normalizeRequestMethod)(options.method ?? this._input.method),
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            prefixUrl: String(options.prefixUrl || ""),
            retry: (0, $f4plr.normalizeRetryOptions)(options.retry),
            throwHttpErrors: options.throwHttpErrors !== false,
            timeout: options.timeout ?? 10000,
            fetch: options.fetch ?? globalThis.fetch.bind(globalThis)
        };
        if (typeof this._input !== "string" && !(this._input instanceof URL || this._input instanceof globalThis.Request)) throw new TypeError("`input` must be a string, URL, or Request");
        if (this._options.prefixUrl && typeof this._input === "string") {
            if (this._input.startsWith("/")) throw new Error("`input` must not begin with a slash when using `prefixUrl`");
            if (!this._options.prefixUrl.endsWith("/")) this._options.prefixUrl += "/";
            this._input = this._options.prefixUrl + this._input;
        }
        if (0, $2Gxno.supportsAbortController) {
            this.abortController = new globalThis.AbortController();
            if (this._options.signal) {
                const originalSignal = this._options.signal;
                this._options.signal.addEventListener("abort", ()=>{
                    this.abortController.abort(originalSignal.reason);
                });
            }
            this._options.signal = this.abortController.signal;
        }
        if (0, $2Gxno.supportsRequestStreams) // @ts-expect-error - Types are outdated.
        this._options.duplex = "half";
        this.request = new globalThis.Request(this._input, this._options);
        if (this._options.searchParams) {
            // eslint-disable-next-line unicorn/prevent-abbreviations
            const textSearchParams = typeof this._options.searchParams === "string" ? this._options.searchParams.replace(/^\?/, "") : new URLSearchParams(this._options.searchParams).toString();
            // eslint-disable-next-line unicorn/prevent-abbreviations
            const searchParams = "?" + textSearchParams;
            const url = this.request.url.replace(/(?:\?.*?)?(?=#|$)/, searchParams);
            // To provide correct form boundary, Content-Type header should be deleted each time when new Request instantiated from another one
            if (((0, $2Gxno.supportsFormData) && this._options.body instanceof globalThis.FormData || this._options.body instanceof URLSearchParams) && !(this._options.headers && this._options.headers["content-type"])) this.request.headers.delete("content-type");
            // The spread of `this.request` is required as otherwise it misses the `duplex` option for some reason and throws.
            this.request = new globalThis.Request(new globalThis.Request(url, {
                ...this.request
            }), this._options);
        }
        if (this._options.json !== undefined) {
            this._options.body = JSON.stringify(this._options.json);
            this.request.headers.set("content-type", this._options.headers.get("content-type") ?? "application/json");
            this.request = new globalThis.Request(this.request, {
                body: this._options.body
            });
        }
    }
    _calculateRetryDelay(error) {
        this._retryCount++;
        if (this._retryCount <= this._options.retry.limit && !(error instanceof (0, $7JIVu.TimeoutError))) {
            if (error instanceof (0, $5cXXM.HTTPError)) {
                if (!this._options.retry.statusCodes.includes(error.response.status)) return 0;
                const retryAfter = error.response.headers.get("Retry-After");
                if (retryAfter && this._options.retry.afterStatusCodes.includes(error.response.status)) {
                    let after = Number(retryAfter);
                    if (Number.isNaN(after)) after = Date.parse(retryAfter) - Date.now();
                    else after *= 1000;
                    if (this._options.retry.maxRetryAfter !== undefined && after > this._options.retry.maxRetryAfter) return 0;
                    return after;
                }
                if (error.response.status === 413) return 0;
            }
            const retryDelay = this._options.retry.delay(this._retryCount);
            return Math.min(this._options.retry.backoffLimit, retryDelay);
        }
        return 0;
    }
    _decorateResponse(response) {
        if (this._options.parseJson) response.json = async ()=>this._options.parseJson(await response.text());
        return response;
    }
    async _retry(function_) {
        try {
            return await function_();
        } catch (error) {
            const ms = Math.min(this._calculateRetryDelay(error), (0, $2Gxno.maxSafeTimeout));
            if (ms !== 0 && this._retryCount > 0) {
                await (0, $e2M0r.default)(ms, {
                    signal: this._options.signal
                });
                for (const hook of this._options.hooks.beforeRetry){
                    // eslint-disable-next-line no-await-in-loop
                    const hookResult = await hook({
                        request: this.request,
                        options: this._options,
                        error: error,
                        retryCount: this._retryCount
                    });
                    // If `stop` is returned from the hook, the retry process is stopped
                    if (hookResult === (0, $2Gxno.stop)) return;
                }
                return this._retry(function_);
            }
            throw error;
        }
    }
    async _fetch() {
        for (const hook of this._options.hooks.beforeRequest){
            // eslint-disable-next-line no-await-in-loop
            const result = await hook(this.request, this._options);
            if (result instanceof Request) {
                this.request = result;
                break;
            }
            if (result instanceof Response) return result;
        }
        const nonRequestOptions = (0, $FK38X.findUnknownOptions)(this.request, this._options);
        if (this._options.timeout === false) return this._options.fetch(this.request.clone(), nonRequestOptions);
        return (0, $2wSQZ.default)(this.request.clone(), nonRequestOptions, this.abortController, this._options);
    }
    /* istanbul ignore next */ _stream(response, onDownloadProgress) {
        const totalBytes = Number(response.headers.get("content-length")) || 0;
        let transferredBytes = 0;
        if (response.status === 204) {
            if (onDownloadProgress) onDownloadProgress({
                percent: 1,
                totalBytes: totalBytes,
                transferredBytes: transferredBytes
            }, new Uint8Array());
            return new globalThis.Response(null, {
                status: response.status,
                statusText: response.statusText,
                headers: response.headers
            });
        }
        return new globalThis.Response(new globalThis.ReadableStream({
            async start (controller) {
                const reader = response.body.getReader();
                if (onDownloadProgress) onDownloadProgress({
                    percent: 0,
                    transferredBytes: 0,
                    totalBytes: totalBytes
                }, new Uint8Array());
                async function read() {
                    const { done: done, value: value } = await reader.read();
                    if (done) {
                        controller.close();
                        return;
                    }
                    if (onDownloadProgress) {
                        transferredBytes += value.byteLength;
                        const percent = totalBytes === 0 ? 0 : transferredBytes / totalBytes;
                        onDownloadProgress({
                            percent: percent,
                            transferredBytes: transferredBytes,
                            totalBytes: totalBytes
                        }, value);
                    }
                    controller.enqueue(value);
                    await read();
                }
                await read();
            }
        }), {
            status: response.status,
            statusText: response.statusText,
            headers: response.headers
        });
    }
}

});
parcelRequire.register("5cXXM", function(module, exports) {

$parcel$export(module.exports, "HTTPError", function () { return $3cac9630014f3781$export$aa9d629c530f62a7; });
// eslint-lint-disable-next-line @typescript-eslint/naming-convention
class $3cac9630014f3781$export$aa9d629c530f62a7 extends Error {
    constructor(response, request, options){
        const code = response.status || response.status === 0 ? response.status : "";
        const title = response.statusText || "";
        const status = `${code} ${title}`.trim();
        const reason = status ? `status code ${status}` : "an unknown error";
        super(`Request failed with ${reason}`);
        Object.defineProperty(this, "response", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "request", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = "HTTPError";
        this.response = response;
        this.request = request;
        this.options = options;
    }
}

});

parcelRequire.register("7JIVu", function(module, exports) {

$parcel$export(module.exports, "TimeoutError", function () { return $5a1f95c8ddb1b307$export$66d311bf29d5c89c; });
class $5a1f95c8ddb1b307$export$66d311bf29d5c89c extends Error {
    constructor(request){
        super("Request timed out");
        Object.defineProperty(this, "request", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = "TimeoutError";
        this.request = request;
    }
}

});

parcelRequire.register("4DUCQ", function(module, exports) {

$parcel$export(module.exports, "validateAndMerge", function () { return $3616ba98b4b2d8a5$export$8886f5ba30bd5e0; });
$parcel$export(module.exports, "deepMerge", function () { return $3616ba98b4b2d8a5$export$6969335ea1e4e77c; });
$parcel$export(module.exports, "mergeHeaders", function () { return $3616ba98b4b2d8a5$export$eee1781d075786ae; });

var $gAVkT = parcelRequire("gAVkT");
const $3616ba98b4b2d8a5$export$8886f5ba30bd5e0 = (...sources)=>{
    for (const source of sources){
        if ((!(0, $gAVkT.isObject)(source) || Array.isArray(source)) && source !== undefined) throw new TypeError("The `options` argument must be an object");
    }
    return $3616ba98b4b2d8a5$export$6969335ea1e4e77c({}, ...sources);
};
const $3616ba98b4b2d8a5$export$eee1781d075786ae = (source1 = {}, source2 = {})=>{
    const result = new globalThis.Headers(source1);
    const isHeadersInstance = source2 instanceof globalThis.Headers;
    const source = new globalThis.Headers(source2);
    for (const [key, value] of source.entries())if (isHeadersInstance && value === "undefined" || value === undefined) result.delete(key);
    else result.set(key, value);
    return result;
};
const $3616ba98b4b2d8a5$export$6969335ea1e4e77c = (...sources)=>{
    let returnValue = {};
    let headers = {};
    for (const source of sources){
        if (Array.isArray(source)) {
            if (!Array.isArray(returnValue)) returnValue = [];
            returnValue = [
                ...returnValue,
                ...source
            ];
        } else if ((0, $gAVkT.isObject)(source)) {
            for (let [key, value] of Object.entries(source)){
                if ((0, $gAVkT.isObject)(value) && key in returnValue) value = $3616ba98b4b2d8a5$export$6969335ea1e4e77c(returnValue[key], value);
                returnValue = {
                    ...returnValue,
                    [key]: value
                };
            }
            if ((0, $gAVkT.isObject)(source.headers)) {
                headers = $3616ba98b4b2d8a5$export$eee1781d075786ae(headers, source.headers);
                returnValue.headers = headers;
            }
        }
    }
    return returnValue;
};

});
parcelRequire.register("gAVkT", function(module, exports) {

$parcel$export(module.exports, "isObject", function () { return $c14c7bdfbe0a21d0$export$a6cdc56e425d0d0a; });
// eslint-disable-next-line @typescript-eslint/ban-types
const $c14c7bdfbe0a21d0$export$a6cdc56e425d0d0a = (value)=>value !== null && typeof value === "object";

});


parcelRequire.register("f4plr", function(module, exports) {

$parcel$export(module.exports, "normalizeRequestMethod", function () { return $af8ae3b1f5446b98$export$d585027d4667ffce; });
$parcel$export(module.exports, "normalizeRetryOptions", function () { return $af8ae3b1f5446b98$export$3e5471bb9440c9c1; });

var $2Gxno = parcelRequire("2Gxno");
const $af8ae3b1f5446b98$export$d585027d4667ffce = (input)=>(0, $2Gxno.requestMethods).includes(input) ? input.toUpperCase() : input;
const $af8ae3b1f5446b98$var$retryMethods = [
    "get",
    "put",
    "head",
    "delete",
    "options",
    "trace"
];
const $af8ae3b1f5446b98$var$retryStatusCodes = [
    408,
    413,
    429,
    500,
    502,
    503,
    504
];
const $af8ae3b1f5446b98$var$retryAfterStatusCodes = [
    413,
    429,
    503
];
const $af8ae3b1f5446b98$var$defaultRetryOptions = {
    limit: 2,
    methods: $af8ae3b1f5446b98$var$retryMethods,
    statusCodes: $af8ae3b1f5446b98$var$retryStatusCodes,
    afterStatusCodes: $af8ae3b1f5446b98$var$retryAfterStatusCodes,
    maxRetryAfter: Number.POSITIVE_INFINITY,
    backoffLimit: Number.POSITIVE_INFINITY,
    delay: (attemptCount)=>0.3 * 2 ** (attemptCount - 1) * 1000
};
const $af8ae3b1f5446b98$export$3e5471bb9440c9c1 = (retry = {})=>{
    if (typeof retry === "number") return {
        ...$af8ae3b1f5446b98$var$defaultRetryOptions,
        limit: retry
    };
    if (retry.methods && !Array.isArray(retry.methods)) throw new Error("retry.methods must be an array");
    if (retry.statusCodes && !Array.isArray(retry.statusCodes)) throw new Error("retry.statusCodes must be an array");
    return {
        ...$af8ae3b1f5446b98$var$defaultRetryOptions,
        ...retry,
        afterStatusCodes: $af8ae3b1f5446b98$var$retryAfterStatusCodes
    };
};

});
parcelRequire.register("2Gxno", function(module, exports) {

$parcel$export(module.exports, "supportsRequestStreams", function () { return $1f4964db56fadb2d$export$d8618555562b76b7; });
$parcel$export(module.exports, "supportsAbortController", function () { return $1f4964db56fadb2d$export$6c0aacaed85a4966; });
$parcel$export(module.exports, "supportsResponseStreams", function () { return $1f4964db56fadb2d$export$135162ac70ac2b21; });
$parcel$export(module.exports, "supportsFormData", function () { return $1f4964db56fadb2d$export$f1525fa7979d0aa9; });
$parcel$export(module.exports, "requestMethods", function () { return $1f4964db56fadb2d$export$fb003dbd6df95edb; });
$parcel$export(module.exports, "responseTypes", function () { return $1f4964db56fadb2d$export$a6f212d4ee888d8c; });
$parcel$export(module.exports, "maxSafeTimeout", function () { return $1f4964db56fadb2d$export$9b60a72e3f70a1d2; });
$parcel$export(module.exports, "stop", function () { return $1f4964db56fadb2d$export$fa6813432f753b0d; });
$parcel$export(module.exports, "kyOptionKeys", function () { return $1f4964db56fadb2d$export$601fffa09f19102d; });
$parcel$export(module.exports, "requestOptionsRegistry", function () { return $1f4964db56fadb2d$export$b2ec467665ae937d; });
const $1f4964db56fadb2d$export$d8618555562b76b7 = (()=>{
    let duplexAccessed = false;
    let hasContentType = false;
    const supportsReadableStream = typeof globalThis.ReadableStream === "function";
    const supportsRequest = typeof globalThis.Request === "function";
    if (supportsReadableStream && supportsRequest) hasContentType = new globalThis.Request("https://empty.invalid", {
        body: new globalThis.ReadableStream(),
        method: "POST",
        // @ts-expect-error - Types are outdated.
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
})();
const $1f4964db56fadb2d$export$6c0aacaed85a4966 = typeof globalThis.AbortController === "function";
const $1f4964db56fadb2d$export$135162ac70ac2b21 = typeof globalThis.ReadableStream === "function";
const $1f4964db56fadb2d$export$f1525fa7979d0aa9 = typeof globalThis.FormData === "function";
const $1f4964db56fadb2d$export$fb003dbd6df95edb = [
    "get",
    "post",
    "put",
    "patch",
    "head",
    "delete"
];
const $1f4964db56fadb2d$var$validate = ()=>undefined;
$1f4964db56fadb2d$var$validate();
const $1f4964db56fadb2d$export$a6f212d4ee888d8c = {
    json: "application/json",
    text: "text/*",
    formData: "multipart/form-data",
    arrayBuffer: "*/*",
    blob: "*/*"
};
const $1f4964db56fadb2d$export$9b60a72e3f70a1d2 = 2147483647;
const $1f4964db56fadb2d$export$fa6813432f753b0d = Symbol("stop");
const $1f4964db56fadb2d$export$601fffa09f19102d = {
    json: true,
    parseJson: true,
    searchParams: true,
    prefixUrl: true,
    retry: true,
    timeout: true,
    hooks: true,
    throwHttpErrors: true,
    onDownloadProgress: true,
    fetch: true
};
const $1f4964db56fadb2d$export$b2ec467665ae937d = {
    method: true,
    headers: true,
    body: true,
    mode: true,
    credentials: true,
    cache: true,
    redirect: true,
    referrer: true,
    referrerPolicy: true,
    integrity: true,
    keepalive: true,
    signal: true,
    window: true,
    dispatcher: true,
    duplex: true,
    priority: true
};

});


parcelRequire.register("2wSQZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d791eba2c75b308$export$2e2bcd8739ae039; });

var $7JIVu = parcelRequire("7JIVu");
async function $1d791eba2c75b308$export$2e2bcd8739ae039(request, init, abortController, options) {
    return new Promise((resolve, reject)=>{
        const timeoutId = setTimeout(()=>{
            if (abortController) abortController.abort();
            reject(new (0, $7JIVu.TimeoutError)(request));
        }, options.timeout);
        options.fetch(request, init).then(resolve).catch(reject).then(()=>{
            clearTimeout(timeoutId);
        });
    });
}

});

parcelRequire.register("e2M0r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3967d9d9533b26c$export$2e2bcd8739ae039; });
// https://github.com/sindresorhus/delay/tree/ab98ae8dfcb38e1593286c94d934e70d14a4e111
async function $a3967d9d9533b26c$export$2e2bcd8739ae039(ms, { signal: signal }) {
    return new Promise((resolve, reject)=>{
        if (signal) {
            signal.throwIfAborted();
            signal.addEventListener("abort", abortHandler, {
                once: true
            });
        }
        function abortHandler() {
            clearTimeout(timeoutId);
            reject(signal.reason);
        }
        const timeoutId = setTimeout(()=>{
            signal?.removeEventListener("abort", abortHandler);
            resolve();
        }, ms);
    });
}

});

parcelRequire.register("FK38X", function(module, exports) {

$parcel$export(module.exports, "findUnknownOptions", function () { return $07d78cf61a2903ca$export$95d8775889ec941f; });

var $2Gxno = parcelRequire("2Gxno");
const $07d78cf61a2903ca$export$95d8775889ec941f = (request, options)=>{
    const unknownOptions = {};
    for(const key in options)if (!(key in (0, $2Gxno.requestOptionsRegistry)) && !(key in (0, $2Gxno.kyOptionKeys)) && !(key in request)) unknownOptions[key] = options[key];
    return unknownOptions;
};

});



parcelRequire.register("fG7L1", function(module, exports) {

$parcel$export(module.exports, "AppDataContext", function () { return $8498e60b639e050e$export$7dc2bc02137acda8; });
$parcel$export(module.exports, "useTenantEndpoint", function () { return $8498e60b639e050e$export$8e0d625b7be89210; });
$parcel$export(module.exports, "default", function () { return $8498e60b639e050e$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");

var $64jBf = parcelRequire("64jBf");

var $jC8Vy = parcelRequire("jC8Vy");

var $Xh5AE = parcelRequire("Xh5AE");
parcelRequire("8Mb3E");
var $ku6YN = parcelRequire("ku6YN");

var $cDKfs = parcelRequire("cDKfs");
const $8498e60b639e050e$export$7dc2bc02137acda8 = /*#__PURE__*/ (0, $jC8Vy.createContext)({});
const $8498e60b639e050e$export$8e0d625b7be89210 = (tenantId)=>{
    return (0, $Xh5AE.default)(`api/.well-known/endpoints/${tenantId}`, async (pathname)=>{
        const { user: user } = await (0, $64jBf.default).get(new URL(pathname, (0, $ku6YN.adminTenantEndpoint))).json();
        return new URL(user);
    });
};
/** The context provider for the global app data. */ function $8498e60b639e050e$var$AppDataProvider({ children: children }) {
    const { currentTenantId: currentTenantId } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { data: tenantEndpoint } = $8498e60b639e050e$export$8e0d625b7be89210(currentTenantId);
    const memorizedContext = (0, $jC8Vy.useMemo)(()=>({
            tenantEndpoint: tenantEndpoint
        }), [
        tenantEndpoint
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsx)($8498e60b639e050e$export$7dc2bc02137acda8.Provider, {
        value: memorizedContext,
        children: children
    });
}
var $8498e60b639e050e$export$2e2bcd8739ae039 = $8498e60b639e050e$var$AppDataProvider;

});
parcelRequire.register("Xh5AE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1e41cfcff5ea01c$export$2e2bcd8739ae039; });

var $voszV = parcelRequire("voszV");

var $hgWIN = parcelRequire("hgWIN");
const $c1e41cfcff5ea01c$export$fc3a40dec7b33bf = (useSWRNext)=>(key, fetcher, config)=>{
        // Always override all revalidate options.
        config.revalidateOnFocus = false;
        config.revalidateIfStale = false;
        config.revalidateOnReconnect = false;
        return useSWRNext(key, fetcher, config);
    };
const $c1e41cfcff5ea01c$export$2e2bcd8739ae039 = (0, $hgWIN.withMiddleware)((0, $voszV.default), $c1e41cfcff5ea01c$export$fc3a40dec7b33bf);

});

parcelRequire.register("cDKfs", function(module, exports) {

$parcel$export(module.exports, "GlobalAnonymousRoute", function () { return $bf5c03a4a7b5e23c$export$5f9d5f8506602833; });
$parcel$export(module.exports, "GlobalRoute", function () { return $bf5c03a4a7b5e23c$export$e120f3f2345ed69b; });
$parcel$export(module.exports, "TenantsContext", function () { return $bf5c03a4a7b5e23c$export$c55cece32887d01f; });
$parcel$export(module.exports, "default", function () { return $bf5c03a4a7b5e23c$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $6hxiJ = parcelRequire("6hxiJ");
var $iq1sR = parcelRequire("iq1sR");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");
var $3dBAh = parcelRequire("3dBAh");

var $jC8Vy = parcelRequire("jC8Vy");

var $2Phw0 = parcelRequire("2Phw0");parcelRequire("6bq3s");
var $2Phw0 = parcelRequire("2Phw0");
parcelRequire("8Mb3E");
var $ku6YN = parcelRequire("ku6YN");

var $8TpMk = parcelRequire("8TpMk");
var $bf5c03a4a7b5e23c$export$5f9d5f8506602833;
(function(GlobalAnonymousRoute) {
    GlobalAnonymousRoute[/** The global callback route for OpenID Connect. */ "Callback"] = "/callback";
    GlobalAnonymousRoute["SocialDemoCallback"] = "/social-demo-callback";
})($bf5c03a4a7b5e23c$export$5f9d5f8506602833 || ($bf5c03a4a7b5e23c$export$5f9d5f8506602833 = {}));
var $bf5c03a4a7b5e23c$export$e120f3f2345ed69b;
(function(GlobalRoute) {
    GlobalRoute["CheckoutSuccessCallback"] = "/checkout-success-callback";
    GlobalRoute["Onboarding"] = "/onboarding";
    GlobalRoute["AcceptInvitation"] = "/accept";
    GlobalRoute["Profile"] = "/profile";
    GlobalRoute["HandleSocial"] = "/handle-social";
})($bf5c03a4a7b5e23c$export$e120f3f2345ed69b || ($bf5c03a4a7b5e23c$export$e120f3f2345ed69b = {}));
const $bf5c03a4a7b5e23c$var$reservedRoutes = Object.freeze([
    ...Object.values($bf5c03a4a7b5e23c$export$5f9d5f8506602833),
    ...Object.values($bf5c03a4a7b5e23c$export$e120f3f2345ed69b)
]);
const $bf5c03a4a7b5e23c$var$initialTenants = Object.freeze((0, $7oDSS.conditionalArray)(!(0, $8TpMk.isCloud) && (0, $ku6YN.defaultTenantResponse)));
const $bf5c03a4a7b5e23c$export$c55cece32887d01f = /*#__PURE__*/ (0, $jC8Vy.createContext)({
    tenants: $bf5c03a4a7b5e23c$var$initialTenants,
    isInitComplete: false,
    resetTenants: (0, $3dBAh.noop),
    prependTenant: (0, $3dBAh.noop),
    removeTenant: (0, $3dBAh.noop),
    updateTenant: (0, $3dBAh.noop),
    currentTenantId: "",
    isDevTenant: false,
    navigateTenant: (0, $3dBAh.noop)
});
/**
 * The global tenants context provider for all available tenants of the current users.
 * It is used to manage the tenants information, including create, update, and delete;
 * also for navigating between tenants.
 *
 * Note it is not practical to use `useSWR()` for tenants context, since fetching tenants
 * requires authentication, and the authentication is managed by the `LogtoProvider` which
 * depends and locates inside the `TenantsProvider`. Thus the fetching tenants action should
 * be done by a component inside the `LogtoProvider`, which `useSWR()` cannot handle.
 */ function $bf5c03a4a7b5e23c$var$TenantsProvider({ children: children }) {
    const [tenants, setTenants] = (0, $jC8Vy.useState)($bf5c03a4a7b5e23c$var$initialTenants);
    /** @see {@link initialTenants} */ const [isInitComplete, setIsInitComplete] = (0, $jC8Vy.useState)(!(0, $8TpMk.isCloud));
    const match = (0, $2Phw0.useMatch)("/:tenantId/*");
    const navigate = (0, $2Phw0.useNavigate)();
    const currentTenantId = (0, $jC8Vy.useMemo)(()=>{
        if (!(0, $8TpMk.isCloud)) return 0, $6hxiJ.defaultTenantId;
        if (!match || $bf5c03a4a7b5e23c$var$reservedRoutes.some((route)=>match.pathname === route || match.pathname.startsWith(route + "/"))) return "";
        return match.params.tenantId ?? "";
    }, [
        match
    ]);
    const navigateTenant = (0, $jC8Vy.useCallback)((tenantId)=>{
        navigate(`/${tenantId}`);
    }, [
        navigate
    ]);
    const currentTenant = (0, $jC8Vy.useMemo)(()=>tenants.find((tenant)=>tenant.id === currentTenantId), [
        currentTenantId,
        tenants
    ]);
    const memorizedContext = (0, $jC8Vy.useMemo)(()=>({
            tenants: tenants,
            resetTenants: (tenants)=>{
                setTenants(tenants);
                setIsInitComplete(true);
            },
            prependTenant: (tenant)=>{
                setTenants((tenants)=>[
                        tenant,
                        ...tenants
                    ]);
            },
            removeTenant: (tenantId)=>{
                setTenants((tenants)=>tenants.filter((tenant)=>tenant.id !== tenantId));
            },
            updateTenant: (tenantId, data)=>{
                setTenants((tenants)=>tenants.map((tenant)=>tenant.id === tenantId ? {
                            ...tenant,
                            ...data
                        } : tenant));
            },
            isInitComplete: isInitComplete,
            currentTenantId: currentTenantId,
            isDevTenant: currentTenant?.tag === (0, $iq1sR.TenantTag).Development,
            currentTenant: currentTenant,
            navigateTenant: navigateTenant
        }), [
        currentTenant,
        currentTenantId,
        isInitComplete,
        navigateTenant,
        tenants
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsx)($bf5c03a4a7b5e23c$export$c55cece32887d01f.Provider, {
        value: memorizedContext,
        children: children
    });
}
var $bf5c03a4a7b5e23c$export$2e2bcd8739ae039 = $bf5c03a4a7b5e23c$var$TenantsProvider;

});
parcelRequire.register("2Phw0", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", function () { return $20edee602e30e054$export$3add0d5dce533e2e; });
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", function () { return $20edee602e30e054$export$145dfa71566a64dc; });
$parcel$export(module.exports, "UNSAFE_NavigationContext", function () { return $20edee602e30e054$export$26749e8557646306; });
$parcel$export(module.exports, "UNSAFE_RouteContext", function () { return $20edee602e30e054$export$9072aa6dd1f93057; });
$parcel$export(module.exports, "useHref", function () { return $20edee602e30e054$export$b66bb29c5006f12f; });
$parcel$export(module.exports, "useResolvedPath", function () { return $20edee602e30e054$export$e75d2a2d1b3c245b; });
$parcel$export(module.exports, "useLocation", function () { return $20edee602e30e054$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useMatch", function () { return $20edee602e30e054$export$6c330e8992e8a295; });
$parcel$export(module.exports, "useNavigate", function () { return $20edee602e30e054$export$9770f232ac06a008; });
$parcel$export(module.exports, "useOutletContext", function () { return $20edee602e30e054$export$4138103a3ae699cc; });
$parcel$export(module.exports, "useParams", function () { return $20edee602e30e054$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "useRoutes", function () { return $20edee602e30e054$export$5d3fca4a98652595; });
$parcel$export(module.exports, "useNavigation", function () { return $20edee602e30e054$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useMatches", function () { return $20edee602e30e054$export$2378eb7f5ff86053; });
$parcel$export(module.exports, "unstable_useBlocker", function () { return $20edee602e30e054$export$2af03a1de5c0910; });
$parcel$export(module.exports, "RouterProvider", function () { return $20edee602e30e054$export$323e4fc2fa4753fb; });
$parcel$export(module.exports, "Router", function () { return $20edee602e30e054$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Routes", function () { return $20edee602e30e054$export$3565eb3d00ca5a74; });
$parcel$export(module.exports, "Navigate", function () { return $20edee602e30e054$export$444b3ab0cb9aec40; });
$parcel$export(module.exports, "Outlet", function () { return $20edee602e30e054$export$910ae8079b2c2852; });
$parcel$export(module.exports, "Route", function () { return $20edee602e30e054$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "UNSAFE_detectErrorBoundary", function () { return $20edee602e30e054$export$48907b48b599f040; });
$parcel$export(module.exports, "matchPath", function () { return (parcelRequire("4szZx")).matchPath; });
$parcel$export(module.exports, "matchRoutes", function () { return (parcelRequire("4szZx")).matchRoutes; });
/**
 * React Router v6.10.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $4szZx = parcelRequire("4szZx");

var $jC8Vy = parcelRequire("jC8Vy");
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function $20edee602e30e054$var$isPolyfill(x, y) {
    return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
    ;
}
const $20edee602e30e054$var$is = typeof Object.is === "function" ? Object.is : $20edee602e30e054$var$isPolyfill; // Intentionally not using named imports because Rollup uses dynamic
// dispatch for CommonJS interop named imports.
const { useState: $20edee602e30e054$var$useState, useEffect: $20edee602e30e054$var$useEffect, useLayoutEffect: $20edee602e30e054$var$useLayoutEffect, useDebugValue: $20edee602e30e054$var$useDebugValue } = $jC8Vy;
let $20edee602e30e054$var$didWarnOld18Alpha = false;
let $20edee602e30e054$var$didWarnUncachedGetSnapshot = false; // Disclaimer: This shim breaks many of the rules of React, and only works
// because of a very particular set of implementation details and assumptions
// -- change any one of them and it will break. The most important assumption
// is that updates are always synchronous, because concurrent rendering is
// only available in versions of React that also have a built-in
// useSyncExternalStore API. And we only use this shim when the built-in API
// does not exist.
//
// Do not assume that the clever hacks used by this hook also work in general.
// The point of this shim is to replace the need for hacks by other libraries.
function $20edee602e30e054$var$useSyncExternalStore$2(subscribe, getSnapshot, // React do not expose a way to check if we're hydrating. So users of the shim
// will need to track that themselves and return the correct value
// from `getSnapshot`.
getServerSnapshot) {
    // breaks the rules of React, and only works here because of specific
    // implementation details, most importantly that updates are
    // always synchronous.
    const value = getSnapshot();
    // re-render whenever the subscribed state changes by updating an some
    // arbitrary useState hook. Then, during render, we call getSnapshot to read
    // the current value.
    //
    // Because we don't actually use the state returned by the useState hook, we
    // can save a bit of memory by storing other stuff in that slot.
    //
    // To implement the early bailout, we need to track some things on a mutable
    // object. Usually, we would put that in a useRef hook, but we can stash it in
    // our useState hook instead.
    //
    // To force a re-render, we call forceUpdate({inst}). That works because the
    // new object always fails an equality check.
    const [{ inst: inst }, forceUpdate] = $20edee602e30e054$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }); // Track the latest getSnapshot function with a ref. This needs to be updated
    // in the layout phase so we can access it during the tearing check that
    // happens on subscribe.
    $20edee602e30e054$var$useLayoutEffect(()=>{
        inst.value = value;
        inst.getSnapshot = getSnapshot; // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if ($20edee602e30e054$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $20edee602e30e054$var$useEffect(()=>{
        // Check for changes right before subscribing. Subsequent changes will be
        // detected in the subscription handler.
        if ($20edee602e30e054$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
        const handleStoreChange = ()=>{
            // TODO: Because there is no cross-renderer API for batching updates, it's
            // up to the consumer of this library to wrap their subscription event
            // with unstable_batchedUpdates. Should we try to detect when this isn't
            // the case and print a warning in development?
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if ($20edee602e30e054$var$checkIfSnapshotChanged(inst)) // Force a re-render.
            forceUpdate({
                inst: inst
            });
        }; // Subscribe to the store and return a clean-up function.
        return subscribe(handleStoreChange); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe
    ]);
    $20edee602e30e054$var$useDebugValue(value);
    return value;
}
function $20edee602e30e054$var$checkIfSnapshotChanged(inst) {
    const latestGetSnapshot = inst.getSnapshot;
    const prevValue = inst.value;
    try {
        const nextValue = latestGetSnapshot();
        return !$20edee602e30e054$var$is(prevValue, nextValue);
    } catch (error) {
        return true;
    }
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 */ function $20edee602e30e054$var$useSyncExternalStore$1(subscribe, getSnapshot, getServerSnapshot) {
    // Note: The shim does not use getServerSnapshot, because pre-18 versions of
    // React do not expose a way to check if we're hydrating. So users of the shim
    // will need to track that themselves and return the correct value
    // from `getSnapshot`.
    return getSnapshot();
}
/**
 * Inlined into the react-router repo since use-sync-external-store does not
 * provide a UMD-compatible package, so we need this to be able to distribute
 * UMD react-router bundles
 */ const $20edee602e30e054$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $20edee602e30e054$var$isServerEnvironment = !$20edee602e30e054$var$canUseDOM;
const $20edee602e30e054$var$shim = $20edee602e30e054$var$isServerEnvironment ? $20edee602e30e054$var$useSyncExternalStore$1 : $20edee602e30e054$var$useSyncExternalStore$2;
const $20edee602e30e054$var$useSyncExternalStore = "useSyncExternalStore" in $jC8Vy ? ((module)=>module.useSyncExternalStore)($jC8Vy) : $20edee602e30e054$var$shim;
const $20edee602e30e054$export$3add0d5dce533e2e = /*#__PURE__*/ $jC8Vy.createContext(null);
const $20edee602e30e054$export$145dfa71566a64dc = /*#__PURE__*/ $jC8Vy.createContext(null);
const $20edee602e30e054$var$AwaitContext = /*#__PURE__*/ $jC8Vy.createContext(null);
const $20edee602e30e054$export$26749e8557646306 = /*#__PURE__*/ $jC8Vy.createContext(null);
const $20edee602e30e054$export$c7914228fb69b0f5 = /*#__PURE__*/ $jC8Vy.createContext(null);
const $20edee602e30e054$export$9072aa6dd1f93057 = /*#__PURE__*/ $jC8Vy.createContext({
    outlet: null,
    matches: []
});
const $20edee602e30e054$var$RouteErrorContext = /*#__PURE__*/ $jC8Vy.createContext(null);
function $20edee602e30e054$var$_extends() {
    $20edee602e30e054$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $20edee602e30e054$var$_extends.apply(this, arguments);
}
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $20edee602e30e054$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$20edee602e30e054$export$9c954a9d03d32f4a() && (0, $4szZx.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $jC8Vy.useContext($20edee602e30e054$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $20edee602e30e054$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname; // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $4szZx.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $20edee602e30e054$export$9c954a9d03d32f4a() {
    return $jC8Vy.useContext($20edee602e30e054$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $20edee602e30e054$export$45d76561a5302f2b() {
    !$20edee602e30e054$export$9c954a9d03d32f4a() && (0, $4szZx.UNSAFE_invariant)(false);
    return $jC8Vy.useContext($20edee602e30e054$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $20edee602e30e054$export$1b3f31771c5d07c() {
    return $jC8Vy.useContext($20edee602e30e054$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $20edee602e30e054$export$6c330e8992e8a295(pattern) {
    !$20edee602e30e054$export$9c954a9d03d32f4a() && (0, $4szZx.UNSAFE_invariant)(false);
    let { pathname: pathname } = $20edee602e30e054$export$45d76561a5302f2b();
    return $jC8Vy.useMemo(()=>(0, $4szZx.matchPath)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ /**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $20edee602e30e054$export$9770f232ac06a008() {
    !$20edee602e30e054$export$9c954a9d03d32f4a() && (0, $4szZx.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $jC8Vy.useContext($20edee602e30e054$export$26749e8557646306);
    let { matches: matches } = $jC8Vy.useContext($20edee602e30e054$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $20edee602e30e054$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $4szZx.UNSAFE_getPathContributingMatches)(matches).map((match)=>match.pathnameBase));
    let activeRef = $jC8Vy.useRef(false);
    $jC8Vy.useEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $jC8Vy.useCallback(function(to, options) {
        if (options === void 0) options = {};
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $4szZx.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path"); // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history.  If this is a root navigation, then we
        // navigate to the raw basename which allows the basename to have full
        // control over the presence of a trailing slash on root links
        if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $4szZx.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname
    ]);
    return navigate;
}
const $20edee602e30e054$var$OutletContext = /*#__PURE__*/ $jC8Vy.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $20edee602e30e054$export$4138103a3ae699cc() {
    return $jC8Vy.useContext($20edee602e30e054$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $20edee602e30e054$export$a3be3530d8e40d0b(context) {
    let outlet = $jC8Vy.useContext($20edee602e30e054$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $jC8Vy.createElement($20edee602e30e054$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $20edee602e30e054$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $jC8Vy.useContext($20edee602e30e054$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $20edee602e30e054$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $jC8Vy.useContext($20edee602e30e054$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $20edee602e30e054$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $4szZx.UNSAFE_getPathContributingMatches)(matches).map((match)=>match.pathnameBase));
    return $jC8Vy.useMemo(()=>(0, $4szZx.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $20edee602e30e054$export$5d3fca4a98652595(routes, locationArg) {
    !$20edee602e30e054$export$9c954a9d03d32f4a() && (0, $4szZx.UNSAFE_invariant)(false);
    let { navigator: navigator } = $jC8Vy.useContext($20edee602e30e054$export$26749e8557646306);
    let dataRouterStateContext = $jC8Vy.useContext($20edee602e30e054$export$145dfa71566a64dc);
    let { matches: parentMatches } = $jC8Vy.useContext($20edee602e30e054$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $20edee602e30e054$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $4szZx.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $4szZx.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $4szZx.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $20edee602e30e054$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $4szZx.joinPaths)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $4szZx.joinPaths)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterStateContext || undefined); // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $jC8Vy.createElement($20edee602e30e054$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $20edee602e30e054$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $4szZx.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $20edee602e30e054$var$DefaultErrorComponent() {
    let error = $20edee602e30e054$export$ed527bf60f6e05f2();
    let message = (0, $4szZx.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $jC8Vy.createElement($jC8Vy.Fragment, null, /*#__PURE__*/ $jC8Vy.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $jC8Vy.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $jC8Vy.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
class $20edee602e30e054$var$RenderErrorBoundary extends $jC8Vy.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location) return {
            error: props.error,
            location: props.location
        };
         // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $jC8Vy.createElement($20edee602e30e054$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $jC8Vy.createElement($20edee602e30e054$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $20edee602e30e054$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $jC8Vy.useContext($20edee602e30e054$export$3add0d5dce533e2e); // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $jC8Vy.createElement($20edee602e30e054$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $20edee602e30e054$var$_renderMatches(matches, parentMatches, dataRouterState) {
    if (parentMatches === void 0) parentMatches = [];
    if (matches == null) {
        if (dataRouterState != null && dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches; // If we have data errors, trim matches to the highest error boundary
    let errors = dataRouterState == null ? void 0 : dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $4szZx.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null; // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) {
            if (match.route.ErrorBoundary) errorElement = /*#__PURE__*/ $jC8Vy.createElement(match.route.ErrorBoundary, null);
            else if (match.route.errorElement) errorElement = match.route.errorElement;
            else errorElement = /*#__PURE__*/ $jC8Vy.createElement($20edee602e30e054$var$DefaultErrorComponent, null);
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children = outlet;
            if (error) children = errorElement;
            else if (match.route.Component) children = /*#__PURE__*/ $jC8Vy.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            return /*#__PURE__*/ $jC8Vy.createElement($20edee602e30e054$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches
                },
                children: children
            });
        }; // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $jC8Vy.createElement($20edee602e30e054$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches
            }
        }) : getChildren();
    }, null);
}
var $20edee602e30e054$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
})($20edee602e30e054$var$DataRouterHook || ($20edee602e30e054$var$DataRouterHook = {}));
var $20edee602e30e054$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
})($20edee602e30e054$var$DataRouterStateHook || ($20edee602e30e054$var$DataRouterStateHook = {}));
function $20edee602e30e054$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $20edee602e30e054$var$useDataRouterContext(hookName) {
    let ctx = $jC8Vy.useContext($20edee602e30e054$export$3add0d5dce533e2e);
    !ctx && (0, $4szZx.UNSAFE_invariant)(false);
    return ctx;
}
function $20edee602e30e054$var$useDataRouterState(hookName) {
    let state = $jC8Vy.useContext($20edee602e30e054$export$145dfa71566a64dc);
    !state && (0, $4szZx.UNSAFE_invariant)(false);
    return state;
}
function $20edee602e30e054$var$useRouteContext(hookName) {
    let route = $jC8Vy.useContext($20edee602e30e054$export$9072aa6dd1f93057);
    !route && (0, $4szZx.UNSAFE_invariant)(false);
    return route;
}
function $20edee602e30e054$var$useCurrentRouteId(hookName) {
    let route = $20edee602e30e054$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $4szZx.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $20edee602e30e054$export$d0fd4b7106de2769() {
    let state = $20edee602e30e054$var$useDataRouterState($20edee602e30e054$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $20edee602e30e054$export$600dc272ed516c15() {
    let dataRouterContext = $20edee602e30e054$var$useDataRouterContext($20edee602e30e054$var$DataRouterHook.UseRevalidator);
    let state = $20edee602e30e054$var$useDataRouterState($20edee602e30e054$var$DataRouterStateHook.UseRevalidator);
    return {
        revalidate: dataRouterContext.router.revalidate,
        state: state.revalidation
    };
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $20edee602e30e054$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $20edee602e30e054$var$useDataRouterState($20edee602e30e054$var$DataRouterStateHook.UseMatches);
    return $jC8Vy.useMemo(()=>matches.map((match)=>{
            let { pathname: pathname, params: params } = match; // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname: pathname,
                params: params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        }), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $20edee602e30e054$export$1448a5050d252c4d() {
    let state = $20edee602e30e054$var$useDataRouterState($20edee602e30e054$var$DataRouterStateHook.UseLoaderData);
    let routeId = $20edee602e30e054$var$useCurrentRouteId($20edee602e30e054$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $20edee602e30e054$export$fd5d37484eab868d(routeId) {
    let state = $20edee602e30e054$var$useDataRouterState($20edee602e30e054$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $20edee602e30e054$export$fdc00f3f26066d5e() {
    let state = $20edee602e30e054$var$useDataRouterState($20edee602e30e054$var$DataRouterStateHook.UseActionData);
    let route = $jC8Vy.useContext($20edee602e30e054$export$9072aa6dd1f93057);
    !route && (0, $4szZx.UNSAFE_invariant)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $20edee602e30e054$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $jC8Vy.useContext($20edee602e30e054$var$RouteErrorContext);
    let state = $20edee602e30e054$var$useDataRouterState($20edee602e30e054$var$DataRouterStateHook.UseRouteError);
    let routeId = $20edee602e30e054$var$useCurrentRouteId($20edee602e30e054$var$DataRouterStateHook.UseRouteError); // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
     // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $20edee602e30e054$export$78a72ddb39bdd145() {
    let value = $jC8Vy.useContext($20edee602e30e054$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $20edee602e30e054$export$17f53340677d5831() {
    let value = $jC8Vy.useContext($20edee602e30e054$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $20edee602e30e054$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $20edee602e30e054$export$2af03a1de5c0910(shouldBlock) {
    let { router: router } = $20edee602e30e054$var$useDataRouterContext($20edee602e30e054$var$DataRouterHook.UseBlocker);
    let state = $20edee602e30e054$var$useDataRouterState($20edee602e30e054$var$DataRouterStateHook.UseBlocker);
    let [blockerKey] = $jC8Vy.useState(()=>String(++$20edee602e30e054$var$blockerId));
    let blockerFunction = $jC8Vy.useCallback((args)=>{
        return typeof shouldBlock === "function" ? !!shouldBlock(args) : !!shouldBlock;
    }, [
        shouldBlock
    ]);
    let blocker = router.getBlocker(blockerKey, blockerFunction); // Cleanup on unmount
    $jC8Vy.useEffect(()=>()=>router.deleteBlocker(blockerKey), [
        router,
        blockerKey
    ]); // Prefer the blocker from state since DataRouterContext is memoized so this
    // ensures we update on blocker state updates
    return state.blockers.get(blockerKey) || blocker;
}
const $20edee602e30e054$var$alreadyWarned = {};
function $20edee602e30e054$var$warningOnce(key, cond, message) {
    if (!cond && !$20edee602e30e054$var$alreadyWarned[key]) $20edee602e30e054$var$alreadyWarned[key] = true;
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $20edee602e30e054$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router } = _ref;
    let getState = $jC8Vy.useCallback(()=>router.state, [
        router
    ]); // Sync router state to our component state to force re-renders
    let state = $20edee602e30e054$var$useSyncExternalStore(router.subscribe, getState, // but we pass our serialized hydration data into the router so state here
    // is already synced with what the server saw
    getState);
    let navigator = $jC8Vy.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $jC8Vy.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]); // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $jC8Vy.createElement($jC8Vy.Fragment, null, /*#__PURE__*/ $jC8Vy.createElement($20edee602e30e054$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $jC8Vy.createElement($20edee602e30e054$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $jC8Vy.createElement($20edee602e30e054$export$55185c17a0fcbe46, {
        basename: router.basename,
        location: router.state.location,
        navigationType: router.state.historyAction,
        navigator: navigator
    }, router.state.initialized ? /*#__PURE__*/ $jC8Vy.createElement($20edee602e30e054$export$3565eb3d00ca5a74, null) : fallbackElement))), null);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $20edee602e30e054$export$ae46f04cfaffe093(_ref2) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex } = _ref2;
    let historyRef = $jC8Vy.useRef();
    if (historyRef.current == null) historyRef.current = (0, $4szZx.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $jC8Vy.useState({
        action: history.action,
        location: history.location
    });
    $jC8Vy.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $jC8Vy.createElement($20edee602e30e054$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $20edee602e30e054$export$444b3ab0cb9aec40(_ref3) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref3;
    !$20edee602e30e054$export$9c954a9d03d32f4a() && (0, $4szZx.UNSAFE_invariant)(false);
    let dataRouterState = $jC8Vy.useContext($20edee602e30e054$export$145dfa71566a64dc);
    let navigate = $20edee602e30e054$export$9770f232ac06a008();
    $jC8Vy.useEffect(()=>{
        // Avoid kicking off multiple navigations if we're in the middle of a
        // data-router navigation, since components get re-rendered when we enter
        // a submitting/loading state
        if (dataRouterState && dataRouterState.navigation.state !== "idle") return;
        navigate(to, {
            replace: replace,
            state: state,
            relative: relative
        });
    });
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $20edee602e30e054$export$910ae8079b2c2852(props) {
    return $20edee602e30e054$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $20edee602e30e054$export$e7b0ac011bb776c6(_props) {
    (0, $4szZx.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $20edee602e30e054$export$55185c17a0fcbe46(_ref4) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $4szZx.Action).Pop, navigator: navigator, static: staticProp = false } = _ref4;
    !!$20edee602e30e054$export$9c954a9d03d32f4a() && (0, $4szZx.UNSAFE_invariant)(false); // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $jC8Vy.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $4szZx.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $jC8Vy.useMemo(()=>{
        let trailingPathname = (0, $4szZx.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $jC8Vy.createElement($20edee602e30e054$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $jC8Vy.createElement($20edee602e30e054$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $20edee602e30e054$export$3565eb3d00ca5a74(_ref5) {
    let { children: children, location: location } = _ref5;
    let dataRouterContext = $jC8Vy.useContext($20edee602e30e054$export$3add0d5dce533e2e); // When in a DataRouterContext _without_ children, we use the router routes
    // directly.  If we have children, then we're in a descendant tree and we
    // need to use child routes.
    let routes = dataRouterContext && !children ? dataRouterContext.router.routes : $20edee602e30e054$export$16da398f5434bdec(children);
    return $20edee602e30e054$export$5d3fca4a98652595(routes, location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $20edee602e30e054$export$6ddabde395c8c576(_ref6) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref6;
    return /*#__PURE__*/ $jC8Vy.createElement($20edee602e30e054$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $jC8Vy.createElement($20edee602e30e054$var$ResolveAwait, null, children));
}
var $20edee602e30e054$var$AwaitRenderStatus;
(function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
})($20edee602e30e054$var$AwaitRenderStatus || ($20edee602e30e054$var$AwaitRenderStatus = {}));
const $20edee602e30e054$var$neverSettledPromise = new Promise(()=>{});
class $20edee602e30e054$var$AwaitErrorBoundary extends $jC8Vy.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $20edee602e30e054$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $20edee602e30e054$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $20edee602e30e054$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $20edee602e30e054$var$AwaitRenderStatus.error : promise._data !== undefined ? $20edee602e30e054$var$AwaitRenderStatus.success : $20edee602e30e054$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $20edee602e30e054$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $20edee602e30e054$var$AwaitRenderStatus.error && promise._error instanceof (0, $4szZx.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $20edee602e30e054$var$neverSettledPromise;
        if (status === $20edee602e30e054$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $20edee602e30e054$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $jC8Vy.createElement($20edee602e30e054$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $20edee602e30e054$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $jC8Vy.createElement($20edee602e30e054$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
         // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $20edee602e30e054$var$ResolveAwait(_ref7) {
    let { children: children } = _ref7;
    let data = $20edee602e30e054$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $jC8Vy.createElement($jC8Vy.Fragment, null, toRender);
} ///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $20edee602e30e054$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $jC8Vy.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $jC8Vy.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $jC8Vy.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $20edee602e30e054$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $20edee602e30e054$export$e7b0ac011bb776c6) && (0, $4szZx.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $4szZx.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $20edee602e30e054$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $20edee602e30e054$export$daf73786167a7f72(matches) {
    return $20edee602e30e054$var$_renderMatches(matches);
}
function $20edee602e30e054$export$48907b48b599f040(route) {
    // there if you change this
    return Boolean(route.ErrorBoundary) || Boolean(route.errorElement);
}
function $20edee602e30e054$export$f30f7e456d254e83(routes, opts) {
    return (0, $4szZx.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: opts == null ? void 0 : opts.future,
        history: (0, $4szZx.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        detectErrorBoundary: $20edee602e30e054$export$48907b48b599f040
    }).initialize();
} ///////////////////////////////////////////////////////////////////////////////

});
parcelRequire.register("4szZx", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return $33f5b21db3678030$export$e19cd5f9376f8cee; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $33f5b21db3678030$export$2b76ad033c6e6d08; });
$parcel$export(module.exports, "createPath", function () { return $33f5b21db3678030$export$fe53371bee54353d; });
$parcel$export(module.exports, "parsePath", function () { return $33f5b21db3678030$export$8ccf933b0513f8d0; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $33f5b21db3678030$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $33f5b21db3678030$export$b71fdd3798280242; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return $33f5b21db3678030$export$3e9cee6b33872309; });
$parcel$export(module.exports, "matchRoutes", function () { return $33f5b21db3678030$export$2708184779ceb39d; });
$parcel$export(module.exports, "stripBasename", function () { return $33f5b21db3678030$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "joinPaths", function () { return $33f5b21db3678030$export$86d9a7913e44197e; });
$parcel$export(module.exports, "matchPath", function () { return $33f5b21db3678030$export$81336c211d5ff295; });
$parcel$export(module.exports, "UNSAFE_getPathContributingMatches", function () { return $33f5b21db3678030$export$90ba53ce1c7fdff2; });
$parcel$export(module.exports, "resolveTo", function () { return $33f5b21db3678030$export$cae722b0cc860f13; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return $33f5b21db3678030$export$42a99a7a4bc0e76a; });
$parcel$export(module.exports, "ErrorResponse", function () { return $33f5b21db3678030$export$acf1a680051f5031; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $33f5b21db3678030$export$972111febbeef05b; });
$parcel$export(module.exports, "createRouter", function () { return $33f5b21db3678030$export$baddd0131ee8c05b; });
/**
 * @remix-run/router v1.5.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $33f5b21db3678030$var$_extends() {
    $33f5b21db3678030$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $33f5b21db3678030$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $33f5b21db3678030$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($33f5b21db3678030$export$e19cd5f9376f8cee || ($33f5b21db3678030$export$e19cd5f9376f8cee = {}));
const $33f5b21db3678030$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $33f5b21db3678030$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $33f5b21db3678030$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $33f5b21db3678030$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $33f5b21db3678030$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $33f5b21db3678030$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $33f5b21db3678030$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $33f5b21db3678030$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $33f5b21db3678030$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $33f5b21db3678030$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $33f5b21db3678030$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $33f5b21db3678030$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $33f5b21db3678030$export$fe53371bee54353d(to);
    }
    return $33f5b21db3678030$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $33f5b21db3678030$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $33f5b21db3678030$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        return $33f5b21db3678030$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $33f5b21db3678030$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $33f5b21db3678030$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $33f5b21db3678030$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $33f5b21db3678030$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $33f5b21db3678030$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $33f5b21db3678030$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $33f5b21db3678030$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $33f5b21db3678030$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $33f5b21db3678030$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $33f5b21db3678030$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $33f5b21db3678030$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $33f5b21db3678030$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $33f5b21db3678030$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $33f5b21db3678030$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $33f5b21db3678030$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex(); // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($33f5b21db3678030$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $33f5b21db3678030$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $33f5b21db3678030$export$e19cd5f9376f8cee.Push;
        let location = $33f5b21db3678030$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $33f5b21db3678030$var$getHistoryState(location, index);
        let url = history.createHref(location); // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $33f5b21db3678030$export$e19cd5f9376f8cee.Replace;
        let location = $33f5b21db3678030$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $33f5b21db3678030$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $33f5b21db3678030$export$fe53371bee54353d(to);
        $33f5b21db3678030$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($33f5b21db3678030$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($33f5b21db3678030$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
} //#endregion
var $33f5b21db3678030$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($33f5b21db3678030$var$ResultType || ($33f5b21db3678030$var$ResultType = {}));
const $33f5b21db3678030$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $33f5b21db3678030$var$isIndexRoute(route) {
    return route.index === true;
} // Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function $33f5b21db3678030$export$4a6d22b32134ea5d(routes, detectErrorBoundary, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $33f5b21db3678030$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $33f5b21db3678030$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($33f5b21db3678030$var$isIndexRoute(route)) {
            let indexRoute = $33f5b21db3678030$var$_extends({}, route, {
                hasErrorBoundary: detectErrorBoundary(route),
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $33f5b21db3678030$var$_extends({}, route, {
                id: id,
                hasErrorBoundary: detectErrorBoundary(route),
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $33f5b21db3678030$export$4a6d22b32134ea5d(route.children, detectErrorBoundary, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $33f5b21db3678030$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $33f5b21db3678030$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $33f5b21db3678030$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $33f5b21db3678030$var$flattenRoutes(routes);
    $33f5b21db3678030$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $33f5b21db3678030$var$matchRouteBranch(branches[i], // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $33f5b21db3678030$var$safelyDecodeURI(pathname));
    return matches;
}
function $33f5b21db3678030$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $33f5b21db3678030$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $33f5b21db3678030$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta); // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $33f5b21db3678030$export$3e9cee6b33872309(// @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $33f5b21db3678030$var$flattenRoutes(route.children, branches, routesMeta, path);
        } // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $33f5b21db3678030$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $33f5b21db3678030$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $33f5b21db3678030$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments; // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?"); // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $33f5b21db3678030$var$explodeOptionalSegments(rest.join("/"));
    let result = []; // All child paths with the prefix.  Do this for all children before the
    // optional version for all children so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explodes _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/"))); // Then if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
     // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $33f5b21db3678030$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $33f5b21db3678030$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $33f5b21db3678030$var$paramRe = /^:\w+$/;
const $33f5b21db3678030$var$dynamicSegmentValue = 3;
const $33f5b21db3678030$var$indexRouteValue = 2;
const $33f5b21db3678030$var$emptySegmentValue = 1;
const $33f5b21db3678030$var$staticSegmentValue = 10;
const $33f5b21db3678030$var$splatPenalty = -2;
const $33f5b21db3678030$var$isSplat = (s)=>s === "*";
function $33f5b21db3678030$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($33f5b21db3678030$var$isSplat)) initialScore += $33f5b21db3678030$var$splatPenalty;
    if (index) initialScore += $33f5b21db3678030$var$indexRouteValue;
    return segments.filter((s)=>!$33f5b21db3678030$var$isSplat(s)).reduce((score, segment)=>score + ($33f5b21db3678030$var$paramRe.test(segment) ? $33f5b21db3678030$var$dynamicSegmentValue : segment === "" ? $33f5b21db3678030$var$emptySegmentValue : $33f5b21db3678030$var$staticSegmentValue), initialScore);
}
function $33f5b21db3678030$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // so they sort equally.
    0;
}
function $33f5b21db3678030$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $33f5b21db3678030$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $33f5b21db3678030$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $33f5b21db3678030$export$a5c6d149b50c1d86($33f5b21db3678030$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $33f5b21db3678030$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $33f5b21db3678030$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $33f5b21db3678030$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    } // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1; // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            const starParam = params[star]; // Apply the splat
            return starParam;
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            if (optional === "?") return param == null ? "" : param;
            if (param == null) $33f5b21db3678030$export$3e9cee6b33872309(false, 'Missing ":' + key + '" param');
            return param;
        } // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    }) // Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $33f5b21db3678030$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $33f5b21db3678030$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $33f5b21db3678030$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $33f5b21db3678030$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $33f5b21db3678030$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $33f5b21db3678030$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $33f5b21db3678030$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $33f5b21db3678030$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $33f5b21db3678030$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $33f5b21db3678030$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
     // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $33f5b21db3678030$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $33f5b21db3678030$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $33f5b21db3678030$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $33f5b21db3678030$var$normalizeSearch(search),
        hash: $33f5b21db3678030$var$normalizeHash(hash)
    };
}
function $33f5b21db3678030$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $33f5b21db3678030$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $33f5b21db3678030$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $33f5b21db3678030$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $33f5b21db3678030$export$8ccf933b0513f8d0(toArg);
    else {
        to = $33f5b21db3678030$var$_extends({}, toArg);
        $33f5b21db3678030$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $33f5b21db3678030$var$getInvalidPathError("?", "pathname", "search", to));
        $33f5b21db3678030$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $33f5b21db3678030$var$getInvalidPathError("#", "pathname", "hash", to));
        $33f5b21db3678030$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $33f5b21db3678030$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from; // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/"); // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        } // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $33f5b21db3678030$export$b09f2ff0bbcb43c7(to, from); // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/"); // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $33f5b21db3678030$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $33f5b21db3678030$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $33f5b21db3678030$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $33f5b21db3678030$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $33f5b21db3678030$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $33f5b21db3678030$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $33f5b21db3678030$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $33f5b21db3678030$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $33f5b21db3678030$export$42a99a7a4bc0e76a extends Error {
}
class $33f5b21db3678030$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $33f5b21db3678030$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects"); // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $33f5b21db3678030$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key); // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, null, data), (error)=>this.onSettle(promise, key, error)); // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $33f5b21db3678030$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        if (error) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $33f5b21db3678030$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $33f5b21db3678030$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $33f5b21db3678030$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $33f5b21db3678030$var$unwrapTrackedPromise(value) {
    if (!$33f5b21db3678030$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $33f5b21db3678030$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $33f5b21db3678030$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $33f5b21db3678030$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $33f5b21db3678030$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $33f5b21db3678030$export$acf1a680051f5031 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $33f5b21db3678030$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $33f5b21db3678030$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $33f5b21db3678030$var$validMutationMethods = new Set($33f5b21db3678030$var$validMutationMethodsArr);
const $33f5b21db3678030$var$validRequestMethodsArr = [
    "get",
    ...$33f5b21db3678030$var$validMutationMethodsArr
];
const $33f5b21db3678030$var$validRequestMethods = new Set($33f5b21db3678030$var$validRequestMethodsArr);
const $33f5b21db3678030$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $33f5b21db3678030$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $33f5b21db3678030$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $33f5b21db3678030$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $33f5b21db3678030$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $33f5b21db3678030$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $33f5b21db3678030$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $33f5b21db3678030$var$isServer = !$33f5b21db3678030$var$isBrowser;
const $33f5b21db3678030$var$defaultDetectErrorBoundary = (route)=>Boolean(route.hasErrorBoundary); //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $33f5b21db3678030$export$baddd0131ee8c05b(init) {
    $33f5b21db3678030$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let detectErrorBoundary = init.detectErrorBoundary || $33f5b21db3678030$var$defaultDetectErrorBoundary; // Routes keyed by ID
    let manifest = {}; // Routes in tree format for matching
    let dataRoutes = $33f5b21db3678030$export$4a6d22b32134ea5d(init.routes, detectErrorBoundary, undefined, manifest);
    let inFlightDataRoutes; // Config driven behavior flags
    let future = $33f5b21db3678030$var$_extends({
        v7_normalizeFormMethod: false
    }, init.future); // Cleanup function for history
    let unlistenHistory = null; // Externally-provided functions to call on all state changes
    let subscribers = new Set(); // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null; // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null; // Externally-provided function to get current scroll position
    let getScrollPosition = null; // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $33f5b21db3678030$export$2708184779ceb39d(dataRoutes, init.history.location, init.basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $33f5b21db3678030$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $33f5b21db3678030$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $33f5b21db3678030$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    }; // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $33f5b21db3678030$export$e19cd5f9376f8cee.Pop; // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false; // AbortController for the active navigation
    let pendingNavigationController; // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false; // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidate()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false; // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = []; // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = []; // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map(); // Track loads based on the order in which they started
    let incrementingLoadId = 0; // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1; // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map(); // Fetchers that triggered redirect navigations from their actions
    let fetchRedirectIds = new Set(); // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map(); // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map(); // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map(); // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false; // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $33f5b21db3678030$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1); // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        }); // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        deleteBlocker(blockerKey);
                        updateState({
                            blockers: new Map(router.state.blockers)
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        }); // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($33f5b21db3678030$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    } // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    } // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    } // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $33f5b21db3678030$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    } // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $33f5b21db3678030$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
         // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $33f5b21db3678030$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData; // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        for (let [key] of blockerFunctions)deleteBlocker(key);
         // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $33f5b21db3678030$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        updateState($33f5b21db3678030$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $33f5b21db3678030$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: new Map(state.blockers)
        }));
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $33f5b21db3678030$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $33f5b21db3678030$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $33f5b21db3678030$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
         // Reset stateful navigation vars
        pendingAction = $33f5b21db3678030$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    } // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let { path: path, submission: submission, error: error } = $33f5b21db3678030$var$normalizeNavigateOptions(to, future, opts);
        let currentLocation = state.location;
        let nextLocation = $33f5b21db3678030$var$createLocation(state.location, path, opts && opts.state); // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $33f5b21db3678030$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $33f5b21db3678030$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $33f5b21db3678030$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $33f5b21db3678030$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $33f5b21db3678030$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    }); // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    deleteBlocker(blockerKey);
                    updateState({
                        blockers: new Map(state.blockers)
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    } // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        }); // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
         // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        } // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    } // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true; // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $33f5b21db3678030$export$2708184779ceb39d(routesToUse, location, init.basename); // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $33f5b21db3678030$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $33f5b21db3678030$var$getShortCircuitMatches(routesToUse); // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        } // Short circuit if it's only a hash change and not a mutation submission
        // For example, on /page#hash and submit a <Form method="post"> which will
        // default to a navigation to /page
        if ($33f5b21db3678030$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $33f5b21db3678030$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        } // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $33f5b21db3678030$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$33f5b21db3678030$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $33f5b21db3678030$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            let navigation = $33f5b21db3678030$var$_extends({
                state: "loading",
                location: location
            }, opts.submission);
            loadingNavigation = navigation; // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        } // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
         // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $33f5b21db3678030$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    } // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        interruptActiveLoads(); // Put us in a submitting state
        let navigation = $33f5b21db3678030$var$_extends({
            state: "submitting",
            location: location
        }, submission);
        updateState({
            navigation: navigation
        }); // Call our action and get the result
        let result;
        let actionMatch = $33f5b21db3678030$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $33f5b21db3678030$var$ResultType.error,
            error: $33f5b21db3678030$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $33f5b21db3678030$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, detectErrorBoundary, router.basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($33f5b21db3678030$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($33f5b21db3678030$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $33f5b21db3678030$var$findNearestBoundary(matches, actionMatch.route.id); // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $33f5b21db3678030$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($33f5b21db3678030$var$isDeferredResult(result)) throw $33f5b21db3678030$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    } // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation;
        if (!loadingNavigation) {
            let navigation = $33f5b21db3678030$var$_extends({
                state: "loading",
                location: location,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            }, submission);
            loadingNavigation = navigation;
        } // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission ? submission || fetcherSubmission : loadingNavigation.formMethod && loadingNavigation.formAction && loadingNavigation.formData && loadingNavigation.formEncType ? {
            formMethod: loadingNavigation.formMethod,
            formAction: loadingNavigation.formAction,
            formData: loadingNavigation.formData,
            formEncType: loadingNavigation.formEncType
        } : undefined;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $33f5b21db3678030$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, init.basename, pendingActionData, pendingError); // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId)); // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            completeNavigation(location, $33f5b21db3678030$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}));
            return {
                shortCircuited: true
            };
        } // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = {
                    state: "loading",
                    data: fetcher && fetcher.data,
                    formMethod: undefined,
                    formAction: undefined,
                    formEncType: undefined,
                    formData: undefined,
                    " _hasFetcherDoneAnything ": true
                };
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($33f5b21db3678030$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        pendingNavigationLoadId = ++incrementingLoadId;
        revalidatingFetchers.forEach((rf)=>fetchControllers.set(rf.key, pendingNavigationController));
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
         // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key)); // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $33f5b21db3678030$var$findRedirect(results);
        if (redirect) {
            await startRedirectNavigation(state, redirect, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        } // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $33f5b21db3678030$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds); // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        return $33f5b21db3678030$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $33f5b21db3678030$export$52eace9c284d3585;
    } // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if ($33f5b21db3678030$var$isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = $33f5b21db3678030$export$2708184779ceb39d(routesToUse, href, init.basename);
        if (!matches) {
            setFetcherError(key, routeId, $33f5b21db3678030$var$getInternalRouterError(404, {
                pathname: href
            }));
            return;
        }
        let { path: path, submission: submission } = $33f5b21db3678030$var$normalizeNavigateOptions(href, future, opts, true);
        let match = $33f5b21db3678030$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $33f5b21db3678030$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        } // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    } // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $33f5b21db3678030$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        } // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $33f5b21db3678030$var$_extends({
            state: "submitting"
        }, submission, {
            data: existingFetcher && existingFetcher.data,
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }); // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $33f5b21db3678030$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let actionResult = await $33f5b21db3678030$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, detectErrorBoundary, router.basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($33f5b21db3678030$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            fetchRedirectIds.add(key);
            let loadingFetcher = $33f5b21db3678030$var$_extends({
                state: "loading"
            }, submission, {
                data: undefined,
                " _hasFetcherDoneAnything ": true
            });
            state.fetchers.set(key, loadingFetcher);
            updateState({
                fetchers: new Map(state.fetchers)
            });
            return startRedirectNavigation(state, actionResult, {
                submission: submission,
                isFetchActionRedirect: true
            });
        } // Process any non-redirect errors thrown
        if ($33f5b21db3678030$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($33f5b21db3678030$var$isDeferredResult(actionResult)) throw $33f5b21db3678030$var$getInternalRouterError(400, {
            type: "defer-action"
        });
         // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $33f5b21db3678030$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $33f5b21db3678030$export$2708184779ceb39d(routesToUse, state.navigation.location, init.basename) : state.matches;
        $33f5b21db3678030$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $33f5b21db3678030$var$_extends({
            state: "loading",
            data: actionResult.data
        }, submission, {
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $33f5b21db3678030$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, init.basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        ); // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = {
                state: "loading",
                data: existingFetcher && existingFetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(staleKey, revalidatingFetcher);
            fetchControllers.set(staleKey, abortController);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $33f5b21db3678030$var$findRedirect(results);
        if (redirect) return startRedirectNavigation(state, redirect);
         // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $33f5b21db3678030$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        let doneFetcher = {
            state: "idle",
            data: actionResult.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            " _hasFetcherDoneAnything ": true
        };
        state.fetchers.set(key, doneFetcher);
        let didAbortFetchLoads = abortStaleFetchLoads(loadId); // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $33f5b21db3678030$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($33f5b21db3678030$var$_extends({
                errors: errors,
                loaderData: $33f5b21db3678030$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    } // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key); // Put this fetcher into it's loading state
        let loadingFetcher = $33f5b21db3678030$var$_extends({
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined
        }, submission, {
            data: existingFetcher && existingFetcher.data,
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }); // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $33f5b21db3678030$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let result = await $33f5b21db3678030$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, detectErrorBoundary, router.basename); // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($33f5b21db3678030$var$isDeferredResult(result)) result = await $33f5b21db3678030$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
         // We can delete this so long as we weren't aborted by ou our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
         // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($33f5b21db3678030$var$isRedirectResult(result)) {
            await startRedirectNavigation(state, result);
            return;
        } // Process any non-redirect errors thrown
        if ($33f5b21db3678030$var$isErrorResult(result)) {
            let boundaryMatch = $33f5b21db3678030$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key); // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $33f5b21db3678030$export$3e9cee6b33872309(!$33f5b21db3678030$var$isDeferredResult(result), "Unhandled fetcher deferred data"); // Put the fetcher back into an idle state
        let doneFetcher = {
            state: "idle",
            data: result.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            " _hasFetcherDoneAnything ": true
        };
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        var _window;
        let { submission: submission, replace: replace, isFetchActionRedirect: isFetchActionRedirect } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $33f5b21db3678030$var$createLocation(state.location, redirect.location, $33f5b21db3678030$var$_extends({
            _isRedirect: true
        }, isFetchActionRedirect ? {
            _isFetchActionRedirect: true
        } : {}));
        $33f5b21db3678030$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation"); // Check if this an absolute external redirect that goes to a new origin
        if ($33f5b21db3678030$var$ABSOLUTE_URL_REGEX.test(redirect.location) && $33f5b21db3678030$var$isBrowser && typeof ((_window = window) == null ? void 0 : _window.location) !== "undefined") {
            let url = init.history.createURL(redirect.location);
            let isDifferentBasename = $33f5b21db3678030$export$b69e3301ce081aa3(url.pathname, init.basename || "/") == null;
            if (window.location.origin !== url.origin || isDifferentBasename) {
                if (replace) window.location.replace(redirect.location);
                else window.location.assign(redirect.location);
                return;
            }
        } // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $33f5b21db3678030$export$e19cd5f9376f8cee.Replace : $33f5b21db3678030$export$e19cd5f9376f8cee.Push; // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, formData: formData } = state.navigation;
        if (!submission && formMethod && formAction && formData && formEncType) submission = {
            formMethod: formMethod,
            formAction: formAction,
            formEncType: formEncType,
            formData: formData
        };
         // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        if ($33f5b21db3678030$var$redirectPreserveMethodStatusCodes.has(redirect.status) && submission && $33f5b21db3678030$var$isMutationMethod(submission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $33f5b21db3678030$var$_extends({}, submission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else if (isFetchActionRedirect) // For a fetch action redirect, we kick off a new loading navigation
        // without the fetcher submission, but we send it along for shouldRevalidate
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: {
                state: "loading",
                location: redirectLocation,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            },
            fetcherSubmission: submission,
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else // Otherwise, we kick off a new loading navigation, preserving the
        // submission info for the duration of this navigation
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: {
                state: "loading",
                location: redirectLocation,
                formMethod: submission ? submission.formMethod : undefined,
                formAction: submission ? submission.formAction : undefined,
                formEncType: submission ? submission.formEncType : undefined,
                formData: submission ? submission.formData : undefined
            },
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$33f5b21db3678030$var$callLoaderOrAction("loader", request, match, matches, manifest, detectErrorBoundary, router.basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match) return $33f5b21db3678030$var$callLoaderOrAction("loader", $33f5b21db3678030$var$createClientSideRequest(init.history, f.path, request.signal), f.match, f.matches, manifest, detectErrorBoundary, router.basename);
                else {
                    let error = {
                        type: $33f5b21db3678030$var$ResultType.error,
                        error: $33f5b21db3678030$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $33f5b21db3678030$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, request.signal, false, state.loaderData),
            $33f5b21db3678030$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, request.signal, true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true; // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds()); // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $33f5b21db3678030$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        if (fetchControllers.has(key)) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $33f5b21db3678030$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = {
                state: "idle",
                data: fetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $33f5b21db3678030$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
            }
        }
        markFetchersDone(doneKeys);
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $33f5b21db3678030$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $33f5b21db3678030$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    } // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $33f5b21db3678030$export$386d57f03f0b2883; // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $33f5b21db3678030$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        state.blockers.set(key, newBlocker);
        updateState({
            blockers: new Map(state.blockers)
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
         // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $33f5b21db3678030$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
         // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    } // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || ((location)=>location.key); // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $33f5b21db3678030$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$33f5b21db3678030$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$33f5b21db3678030$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        inFlightDataRoutes = newRoutes;
    }
    router = {
        get basename () {
            return init.basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $33f5b21db3678030$export$4d0306f8f6a4585b = Symbol("deferred");
function $33f5b21db3678030$export$3336b097a6fbc59a(routes, opts) {
    $33f5b21db3678030$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let detectErrorBoundary = (opts == null ? void 0 : opts.detectErrorBoundary) || $33f5b21db3678030$var$defaultDetectErrorBoundary;
    let dataRoutes = $33f5b21db3678030$export$4a6d22b32134ea5d(routes, detectErrorBoundary, undefined, manifest);
    let basename = (opts ? opts.basename : null) || "/";
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $33f5b21db3678030$var$createLocation("", $33f5b21db3678030$export$fe53371bee54353d(url), null, "default");
        let matches = $33f5b21db3678030$export$2708184779ceb39d(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
        if (!$33f5b21db3678030$var$isValidMethod(method) && method !== "HEAD") {
            let error = $33f5b21db3678030$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $33f5b21db3678030$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $33f5b21db3678030$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $33f5b21db3678030$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($33f5b21db3678030$var$isResponse(result)) return result;
         // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $33f5b21db3678030$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $33f5b21db3678030$var$createLocation("", $33f5b21db3678030$export$fe53371bee54353d(url), null, "default");
        let matches = $33f5b21db3678030$export$2708184779ceb39d(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
        if (!$33f5b21db3678030$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $33f5b21db3678030$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $33f5b21db3678030$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $33f5b21db3678030$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $33f5b21db3678030$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $33f5b21db3678030$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($33f5b21db3678030$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
         // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$33f5b21db3678030$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $33f5b21db3678030$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($33f5b21db3678030$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $33f5b21db3678030$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $33f5b21db3678030$var$isResponse(result) ? result : $33f5b21db3678030$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($33f5b21db3678030$var$isQueryRouteResponse(e)) {
                if (e.type === $33f5b21db3678030$var$ResultType.error && !$33f5b21db3678030$var$isRedirectResponse(e.response)) throw e.response;
                return e.response;
            } // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($33f5b21db3678030$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $33f5b21db3678030$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $33f5b21db3678030$var$ResultType.error,
                error: error
            };
        } else {
            result = await $33f5b21db3678030$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, detectErrorBoundary, basename, true, isRouteRequest, requestContext);
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted");
            }
        }
        if ($33f5b21db3678030$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($33f5b21db3678030$var$isDeferredResult(result)) {
            let error = $33f5b21db3678030$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $33f5b21db3678030$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($33f5b21db3678030$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($33f5b21db3678030$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $33f5b21db3678030$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            }); // action status codes take precedence over loader status codes
            return $33f5b21db3678030$var$_extends({}, context, {
                statusCode: $33f5b21db3678030$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $33f5b21db3678030$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        } // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $33f5b21db3678030$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $33f5b21db3678030$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null; // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $33f5b21db3678030$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $33f5b21db3678030$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy); // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$33f5b21db3678030$var$callLoaderOrAction("loader", request, match, matches, manifest, detectErrorBoundary, basename, true, isRouteRequest, requestContext))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted");
        } // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $33f5b21db3678030$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds); // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $33f5b21db3678030$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $33f5b21db3678030$export$fec11da027c70692(routes, context, error) {
    let newContext = $33f5b21db3678030$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $33f5b21db3678030$var$isSubmissionNavigation(opts) {
    return opts != null && "formData" in opts;
} // Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $33f5b21db3678030$var$normalizeNavigateOptions(to, future, opts, isFetcher) {
    if (isFetcher === void 0) isFetcher = false;
    let path = typeof to === "string" ? to : $33f5b21db3678030$export$fe53371bee54353d(to); // Return location verbatim on non-submission navigations
    if (!opts || !$33f5b21db3678030$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$33f5b21db3678030$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $33f5b21db3678030$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
     // Create a Submission on non-GET navigations
    let submission;
    if (opts.formData) {
        let formMethod = opts.formMethod || "get";
        submission = {
            formMethod: future.v7_normalizeFormMethod ? formMethod.toUpperCase() : formMethod.toLowerCase(),
            formAction: $33f5b21db3678030$var$stripHashFromPath(path),
            formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
            formData: opts.formData
        };
        if ($33f5b21db3678030$var$isMutationMethod(submission.formMethod)) return {
            path: path,
            submission: submission
        };
    } // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $33f5b21db3678030$export$8ccf933b0513f8d0(path);
    let searchParams = $33f5b21db3678030$var$convertFormDataToSearchParams(opts.formData); // Since fetcher GET submissions only run a single loader (as opposed to
    // navigation GET submissions which run all loaders), we need to preserve
    // any incoming ?index params
    if (isFetcher && parsedPath.search && $33f5b21db3678030$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $33f5b21db3678030$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
} // Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $33f5b21db3678030$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $33f5b21db3678030$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let defaultShouldRevalidate = isRevalidationRequired || // Clicked the same link, resubmitted a GET form
    currentUrl.toString() === nextUrl.toString() || // Search params affect all loaders
    currentUrl.search !== nextUrl.search; // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $33f5b21db3678030$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
         // Always call the loader on new route instances and pending defer cancellations
        if ($33f5b21db3678030$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
         // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $33f5b21db3678030$var$shouldRevalidateLoader(match, $33f5b21db3678030$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: defaultShouldRevalidate || $33f5b21db3678030$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    }); // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $33f5b21db3678030$export$2708184779ceb39d(routesToUse, f.path, basename); // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData
        if (!fetcherMatches) {
            revalidatingFetchers.push($33f5b21db3678030$var$_extends({
                key: key
            }, f, {
                matches: null,
                match: null
            }));
            return;
        }
        let fetcherMatch = $33f5b21db3678030$var$getTargetMatch(fetcherMatches, f.path);
        if (cancelledFetcherLoads.includes(key)) {
            revalidatingFetchers.push($33f5b21db3678030$var$_extends({
                key: key,
                matches: fetcherMatches,
                match: fetcherMatch
            }, f));
            return;
        } // Revalidating fetchers are decoupled from the route matches since they
        // hit a static href, so they _always_ check shouldRevalidate and the
        // default is strictly if a revalidation is explicitly required (action
        // submissions, useRevalidator, X-Remix-Revalidate).
        let shouldRevalidate = $33f5b21db3678030$var$shouldRevalidateLoader(fetcherMatch, $33f5b21db3678030$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: defaultShouldRevalidate
        }));
        if (shouldRevalidate) revalidatingFetchers.push($33f5b21db3678030$var$_extends({
            key: key,
            matches: fetcherMatches,
            match: fetcherMatch
        }, f));
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $33f5b21db3678030$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id; // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined; // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $33f5b21db3678030$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"];
}
function $33f5b21db3678030$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $33f5b21db3678030$var$loadLazyRouteModule(route, detectErrorBoundary, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy(); // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $33f5b21db3678030$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest"); // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $33f5b21db3678030$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$33f5b21db3678030$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    } // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to detectErrorBoundary
    Object.assign(routeToUpdate, routeUpdates); // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, {
        // To keep things framework agnostic, we use the provided
        // `detectErrorBoundary` function to set the `hasErrorBoundary` route
        // property since the logic will differ between frameworks.
        hasErrorBoundary: detectErrorBoundary($33f5b21db3678030$var$_extends({}, routeToUpdate)),
        lazy: undefined
    });
}
async function $33f5b21db3678030$var$callLoaderOrAction(type, request, match, matches, manifest, detectErrorBoundary, basename, isStaticRequest, isRouteRequest, requestContext) {
    if (basename === void 0) basename = "/";
    if (isStaticRequest === void 0) isStaticRequest = false;
    if (isRouteRequest === void 0) isRouteRequest = false;
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let values = await Promise.all([
                    runHandler(handler),
                    $33f5b21db3678030$var$loadLazyRouteModule(match.route, detectErrorBoundary, manifest)
                ]);
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $33f5b21db3678030$var$loadLazyRouteModule(match.route, detectErrorBoundary, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") throw $33f5b21db3678030$var$getInternalRouterError(405, {
                    method: request.method,
                    pathname: new URL(request.url).pathname,
                    routeId: match.route.id
                });
                else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $33f5b21db3678030$var$ResultType.data,
                    data: undefined
                };
            }
        } else {
            $33f5b21db3678030$export$3e9cee6b33872309(handler, "Could not find the " + type + ' to run on the "' + match.route.id + '" route');
            result = await runHandler(handler);
        }
        $33f5b21db3678030$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $33f5b21db3678030$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($33f5b21db3678030$var$isResponse(result)) {
        let status = result.status; // Process redirects
        if ($33f5b21db3678030$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $33f5b21db3678030$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header"); // Support relative routing in internal redirects
            if (!$33f5b21db3678030$var$ABSOLUTE_URL_REGEX.test(location)) {
                let activeMatches = matches.slice(0, matches.indexOf(match) + 1);
                let routePathnames = $33f5b21db3678030$export$90ba53ce1c7fdff2(activeMatches).map((match)=>match.pathnameBase);
                let resolvedLocation = $33f5b21db3678030$export$cae722b0cc860f13(location, routePathnames, new URL(request.url).pathname);
                $33f5b21db3678030$export$3e9cee6b33872309($33f5b21db3678030$export$fe53371bee54353d(resolvedLocation), "Unable to resolve redirect location: " + location); // Prepend the basename to the redirect location if we have one
                if (basename) {
                    let path = resolvedLocation.pathname;
                    resolvedLocation.pathname = path === "/" ? basename : $33f5b21db3678030$export$86d9a7913e44197e([
                        basename,
                        path
                    ]);
                }
                location = $33f5b21db3678030$export$fe53371bee54353d(resolvedLocation);
            } else if (!isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $33f5b21db3678030$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            } // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $33f5b21db3678030$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null
            };
        } // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (isRouteRequest) // eslint-disable-next-line no-throw-literal
        throw {
            type: resultType || $33f5b21db3678030$var$ResultType.data,
            response: result
        };
        let data;
        let contentType = result.headers.get("Content-Type"); // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $33f5b21db3678030$var$ResultType.error) return {
            type: resultType,
            error: new $33f5b21db3678030$export$acf1a680051f5031(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $33f5b21db3678030$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $33f5b21db3678030$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($33f5b21db3678030$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $33f5b21db3678030$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $33f5b21db3678030$var$ResultType.data,
        data: result
    };
} // Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $33f5b21db3678030$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($33f5b21db3678030$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $33f5b21db3678030$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType, formData: formData } = submission; // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        init.body = formEncType === "application/x-www-form-urlencoded" ? $33f5b21db3678030$var$convertFormDataToSearchParams(formData) : formData;
    } // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
    return new Request(url, init);
}
function $33f5b21db3678030$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, value instanceof File ? value.name : value);
    return searchParams;
}
function $33f5b21db3678030$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {}; // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $33f5b21db3678030$export$3e9cee6b33872309(!$33f5b21db3678030$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($33f5b21db3678030$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $33f5b21db3678030$var$findNearestBoundary(matches, id);
            let error = result.error; // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {}; // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
             // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined; // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $33f5b21db3678030$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($33f5b21db3678030$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
             // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    }); // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $33f5b21db3678030$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $33f5b21db3678030$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds); // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match } = revalidatingFetchers[index];
        $33f5b21db3678030$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index]; // Process fetcher non-redirect errors
        if ($33f5b21db3678030$var$isErrorResult(result)) {
            let boundaryMatch = $33f5b21db3678030$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $33f5b21db3678030$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($33f5b21db3678030$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $33f5b21db3678030$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($33f5b21db3678030$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $33f5b21db3678030$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = {
                state: "idle",
                data: result.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $33f5b21db3678030$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $33f5b21db3678030$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
} // Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $33f5b21db3678030$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $33f5b21db3678030$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $33f5b21db3678030$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $33f5b21db3678030$export$acf1a680051f5031(status || 500, statusText, new Error(errorMessage), true);
} // Find any returned redirect errors, starting from the lowest match
function $33f5b21db3678030$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($33f5b21db3678030$var$isRedirectResult(result)) return result;
    }
}
function $33f5b21db3678030$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $33f5b21db3678030$export$8ccf933b0513f8d0(path) : path;
    return $33f5b21db3678030$export$fe53371bee54353d($33f5b21db3678030$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $33f5b21db3678030$var$isHashChangeOnly(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash !== b.hash;
}
function $33f5b21db3678030$var$isDeferredResult(result) {
    return result.type === $33f5b21db3678030$var$ResultType.deferred;
}
function $33f5b21db3678030$var$isErrorResult(result) {
    return result.type === $33f5b21db3678030$var$ResultType.error;
}
function $33f5b21db3678030$var$isRedirectResult(result) {
    return (result && result.type) === $33f5b21db3678030$var$ResultType.redirect;
}
function $33f5b21db3678030$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $33f5b21db3678030$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $33f5b21db3678030$var$isRedirectResponse(result) {
    if (!$33f5b21db3678030$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $33f5b21db3678030$var$isQueryRouteResponse(obj) {
    return obj && $33f5b21db3678030$var$isResponse(obj.response) && (obj.type === $33f5b21db3678030$var$ResultType.data || $33f5b21db3678030$var$ResultType.error);
}
function $33f5b21db3678030$var$isValidMethod(method) {
    return $33f5b21db3678030$var$validRequestMethods.has(method.toLowerCase());
}
function $33f5b21db3678030$var$isMutationMethod(method) {
    return $33f5b21db3678030$var$validMutationMethods.has(method.toLowerCase());
}
async function $33f5b21db3678030$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signal, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index]; // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$33f5b21db3678030$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($33f5b21db3678030$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $33f5b21db3678030$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
            if (result) results[index] = result || results[index];
        });
    }
}
async function $33f5b21db3678030$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $33f5b21db3678030$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $33f5b21db3678030$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $33f5b21db3678030$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $33f5b21db3678030$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
} // Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function $33f5b21db3678030$var$createUseMatchesMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $33f5b21db3678030$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $33f5b21db3678030$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $33f5b21db3678030$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
     // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $33f5b21db3678030$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
} //#endregion

});


parcelRequire.register("6bq3s", function(module, exports) {

$parcel$export(module.exports, "createBrowserRouter", function () { return $4807fb19dc15980e$export$1f3f55432a00e06d; });
$parcel$export(module.exports, "Link", function () { return $4807fb19dc15980e$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "useSearchParams", function () { return $4807fb19dc15980e$export$f1a78c17382fe22a; });
$parcel$export(module.exports, "unstable_useBlocker", function () { return (parcelRequire("2Phw0")).unstable_useBlocker; });
$parcel$export(module.exports, "useHref", function () { return (parcelRequire("2Phw0")).useHref; });
$parcel$export(module.exports, "useLocation", function () { return (parcelRequire("2Phw0")).useLocation; });
$parcel$export(module.exports, "useNavigate", function () { return (parcelRequire("2Phw0")).useNavigate; });
/**
 * React Router DOM v6.10.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $jC8Vy = parcelRequire("jC8Vy");

var $4szZx = parcelRequire("4szZx");
var $2Phw0 = parcelRequire("2Phw0");
var $4szZx = parcelRequire("4szZx");

var $4szZx = parcelRequire("4szZx");
function $4807fb19dc15980e$var$_extends() {
    $4807fb19dc15980e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4807fb19dc15980e$var$_extends.apply(this, arguments);
}
function $4807fb19dc15980e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $4807fb19dc15980e$var$defaultMethod = "get";
const $4807fb19dc15980e$var$defaultEncType = "application/x-www-form-urlencoded";
function $4807fb19dc15980e$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $4807fb19dc15980e$var$isButtonElement(object) {
    return $4807fb19dc15980e$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $4807fb19dc15980e$var$isFormElement(object) {
    return $4807fb19dc15980e$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $4807fb19dc15980e$var$isInputElement(object) {
    return $4807fb19dc15980e$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $4807fb19dc15980e$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $4807fb19dc15980e$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$4807fb19dc15980e$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $4807fb19dc15980e$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $4807fb19dc15980e$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $4807fb19dc15980e$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) {
        for (let key of defaultSearchParams.keys())if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    }
    return searchParams;
}
function $4807fb19dc15980e$var$getFormSubmissionInfo(target, defaultAction, options) {
    let method;
    let action;
    let encType;
    let formData;
    if ($4807fb19dc15980e$var$isFormElement(target)) {
        let submissionTrigger = options.submissionTrigger;
        method = options.method || target.getAttribute("method") || $4807fb19dc15980e$var$defaultMethod;
        action = options.action || target.getAttribute("action") || defaultAction;
        encType = options.encType || target.getAttribute("enctype") || $4807fb19dc15980e$var$defaultEncType;
        formData = new FormData(target);
        if (submissionTrigger && submissionTrigger.name) formData.append(submissionTrigger.name, submissionTrigger.value);
    } else if ($4807fb19dc15980e$var$isButtonElement(target) || $4807fb19dc15980e$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
         // <button>/<input type="submit"> may override attributes of <form>
        method = options.method || target.getAttribute("formmethod") || form.getAttribute("method") || $4807fb19dc15980e$var$defaultMethod;
        action = options.action || target.getAttribute("formaction") || form.getAttribute("action") || defaultAction;
        encType = options.encType || target.getAttribute("formenctype") || form.getAttribute("enctype") || $4807fb19dc15980e$var$defaultEncType;
        formData = new FormData(form); // Include name + value from a <button>, appending in case the button name
        // matches an existing input name
        if (target.name) formData.append(target.name, target.value);
    } else if ($4807fb19dc15980e$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = options.method || $4807fb19dc15980e$var$defaultMethod;
        action = options.action || defaultAction;
        encType = options.encType || $4807fb19dc15980e$var$defaultEncType;
        if (target instanceof FormData) formData = target;
        else {
            formData = new FormData();
            if (target instanceof URLSearchParams) for (let [name, value] of target)formData.append(name, value);
            else if (target != null) for (let name of Object.keys(target))formData.append(name, target[name]);
        }
    }
    let { protocol: protocol, host: host } = window.location;
    let url = new URL(action, protocol + "//" + host);
    return {
        url: url,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData
    };
}
const $4807fb19dc15980e$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $4807fb19dc15980e$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $4807fb19dc15980e$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "method",
    "action",
    "onSubmit",
    "fetcherKey",
    "routeId",
    "relative",
    "preventScrollReset"
];
function $4807fb19dc15980e$export$1f3f55432a00e06d(routes, opts) {
    return (0, $4szZx.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: opts == null ? void 0 : opts.future,
        history: (0, $4szZx.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $4807fb19dc15980e$var$parseHydrationData(),
        routes: routes,
        detectErrorBoundary: (0, $2Phw0.UNSAFE_detectErrorBoundary)
    }).initialize();
}
function $4807fb19dc15980e$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $4szZx.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: opts == null ? void 0 : opts.future,
        history: (0, $4szZx.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $4807fb19dc15980e$var$parseHydrationData(),
        routes: routes,
        detectErrorBoundary: (0, $2Phw0.UNSAFE_detectErrorBoundary)
    }).initialize();
}
function $4807fb19dc15980e$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $4807fb19dc15980e$var$_extends({}, state, {
        errors: $4807fb19dc15980e$var$deserializeErrors(state.errors)
    });
    return state;
}
function $4807fb19dc15980e$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $4szZx.ErrorResponse)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            let error = new Error(val.message); // Wipe away the client-side stack trace.  Nothing to fill it in with
            // because we don't serialize SSR stack traces for security reasons
            error.stack = "";
            serialized[key] = error;
        } else serialized[key] = val;
    }
    return serialized;
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $4807fb19dc15980e$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, window: window1 } = _ref;
    let historyRef = $jC8Vy.useRef();
    if (historyRef.current == null) historyRef.current = (0, $4szZx.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $jC8Vy.useState({
        action: history.action,
        location: history.location
    });
    $jC8Vy.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $jC8Vy.createElement((0, $2Phw0.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $4807fb19dc15980e$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, window: window1 } = _ref2;
    let historyRef = $jC8Vy.useRef();
    if (historyRef.current == null) historyRef.current = (0, $4szZx.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $jC8Vy.useState({
        action: history.action,
        location: history.location
    });
    $jC8Vy.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $jC8Vy.createElement((0, $2Phw0.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $4807fb19dc15980e$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, history: history } = _ref3;
    const [state, setState] = $jC8Vy.useState({
        action: history.action,
        location: history.location
    });
    $jC8Vy.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $jC8Vy.createElement((0, $2Phw0.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $4807fb19dc15980e$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $4807fb19dc15980e$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ const $4807fb19dc15980e$export$a6c7ac8248d6e38a = /*#__PURE__*/ $jC8Vy.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset } = _ref4, rest = $4807fb19dc15980e$var$_objectWithoutPropertiesLoose(_ref4, $4807fb19dc15980e$var$_excluded);
    let { basename: basename } = $jC8Vy.useContext((0, $2Phw0.UNSAFE_NavigationContext)); // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $4807fb19dc15980e$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to; // Only check for external origins client-side
        if ($4807fb19dc15980e$var$isBrowser) {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $4szZx.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        }
    } // Rendered into <a href> for relative URLs
    let href = (0, $2Phw0.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $4807fb19dc15980e$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $jC8Vy.createElement("a", $4807fb19dc15980e$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $4807fb19dc15980e$export$b0d92dbee9b5b60d = /*#__PURE__*/ $jC8Vy.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $4807fb19dc15980e$var$_objectWithoutPropertiesLoose(_ref5, $4807fb19dc15980e$var$_excluded2);
    let path = (0, $2Phw0.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $2Phw0.useLocation)();
    let routerState = $jC8Vy.useContext((0, $2Phw0.UNSAFE_DataRouterStateContext));
    let { navigator: navigator } = $jC8Vy.useContext((0, $2Phw0.UNSAFE_NavigationContext));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $jC8Vy.createElement($4807fb19dc15980e$export$a6c7ac8248d6e38a, $4807fb19dc15980e$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $4807fb19dc15980e$export$a7fed597f4b8afd8 = /*#__PURE__*/ $jC8Vy.forwardRef((props, ref)=>{
    return /*#__PURE__*/ $jC8Vy.createElement($4807fb19dc15980e$var$FormImpl, $4807fb19dc15980e$var$_extends({}, props, {
        ref: ref
    }));
});
const $4807fb19dc15980e$var$FormImpl = /*#__PURE__*/ $jC8Vy.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, method: method = $4807fb19dc15980e$var$defaultMethod, action: action, onSubmit: onSubmit, fetcherKey: fetcherKey, routeId: routeId, relative: relative, preventScrollReset: preventScrollReset } = _ref6, props = $4807fb19dc15980e$var$_objectWithoutPropertiesLoose(_ref6, $4807fb19dc15980e$var$_excluded3);
    let submit = $4807fb19dc15980e$var$useSubmitImpl(fetcherKey, routeId);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $4807fb19dc15980e$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $jC8Vy.createElement("form", $4807fb19dc15980e$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $4807fb19dc15980e$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey, storageKey: storageKey } = _ref7;
    $4807fb19dc15980e$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $4807fb19dc15980e$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmitImpl"] = "useSubmitImpl";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($4807fb19dc15980e$var$DataRouterHook || ($4807fb19dc15980e$var$DataRouterHook = {}));
var $4807fb19dc15980e$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($4807fb19dc15980e$var$DataRouterStateHook || ($4807fb19dc15980e$var$DataRouterStateHook = {}));
function $4807fb19dc15980e$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $4807fb19dc15980e$var$useDataRouterContext(hookName) {
    let ctx = $jC8Vy.useContext((0, $2Phw0.UNSAFE_DataRouterContext));
    !ctx && (0, $4szZx.UNSAFE_invariant)(false);
    return ctx;
}
function $4807fb19dc15980e$var$useDataRouterState(hookName) {
    let state = $jC8Vy.useContext((0, $2Phw0.UNSAFE_DataRouterStateContext));
    !state && (0, $4szZx.UNSAFE_invariant)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $4807fb19dc15980e$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $2Phw0.useNavigate)();
    let location = (0, $2Phw0.useLocation)();
    let path = (0, $2Phw0.useResolvedPath)(to, {
        relative: relative
    });
    return $jC8Vy.useCallback((event)=>{
        if ($4807fb19dc15980e$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault(); // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $4szZx.createPath)(location) === (0, $4szZx.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $4807fb19dc15980e$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $jC8Vy.useRef($4807fb19dc15980e$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $jC8Vy.useRef(false);
    let location = (0, $2Phw0.useLocation)();
    let searchParams = $jC8Vy.useMemo(()=>// Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $4807fb19dc15980e$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $2Phw0.useNavigate)();
    let setSearchParams = $jC8Vy.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $4807fb19dc15980e$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $4807fb19dc15980e$export$47c85c6e3a081d3() {
    return $4807fb19dc15980e$var$useSubmitImpl();
}
function $4807fb19dc15980e$var$useSubmitImpl(fetcherKey, routeId) {
    let { router: router } = $4807fb19dc15980e$var$useDataRouterContext($4807fb19dc15980e$var$DataRouterHook.UseSubmitImpl);
    let defaultAction = $4807fb19dc15980e$export$89a6bd6db0d97c56();
    return $jC8Vy.useCallback(function(target, options) {
        if (options === void 0) options = {};
        if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
        let { method: method, encType: encType, formData: formData, url: url } = $4807fb19dc15980e$var$getFormSubmissionInfo(target, defaultAction, options);
        let href = url.pathname + url.search;
        let opts = {
            replace: options.replace,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            formMethod: method,
            formEncType: encType
        };
        if (fetcherKey) {
            !(routeId != null) && (0, $4szZx.UNSAFE_invariant)(false);
            router.fetch(fetcherKey, routeId, href, opts);
        } else router.navigate(href, opts);
    }, [
        defaultAction,
        router,
        fetcherKey,
        routeId
    ]);
}
function $4807fb19dc15980e$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $jC8Vy.useContext((0, $2Phw0.UNSAFE_NavigationContext));
    let routeContext = $jC8Vy.useContext((0, $2Phw0.UNSAFE_RouteContext));
    !routeContext && (0, $4szZx.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1); // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $4807fb19dc15980e$var$_extends({}, (0, $2Phw0.useResolvedPath)(action ? action : ".", {
        relative: relative
    })); // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params and the hash of the resolved
    // URL. This is the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $2Phw0.useLocation)();
    if (action == null) {
        // Safe to write to these directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        // or hash
        path.search = location.search;
        path.hash = location.hash; // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
     // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $4szZx.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $4szZx.createPath)(path);
}
function $4807fb19dc15980e$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $jC8Vy.forwardRef((props, ref)=>{
        return /*#__PURE__*/ $jC8Vy.createElement($4807fb19dc15980e$var$FormImpl, $4807fb19dc15980e$var$_extends({}, props, {
            ref: ref,
            fetcherKey: fetcherKey,
            routeId: routeId
        }));
    });
    return FetcherForm;
}
let $4807fb19dc15980e$var$fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $4807fb19dc15980e$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $4807fb19dc15980e$var$useDataRouterContext($4807fb19dc15980e$var$DataRouterHook.UseFetcher);
    let route = $jC8Vy.useContext((0, $2Phw0.UNSAFE_RouteContext));
    !route && (0, $4szZx.UNSAFE_invariant)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $4szZx.UNSAFE_invariant)(false);
    let [fetcherKey] = $jC8Vy.useState(()=>String(++$4807fb19dc15980e$var$fetcherId));
    let [Form] = $jC8Vy.useState(()=>{
        !routeId && (0, $4szZx.UNSAFE_invariant)(false);
        return $4807fb19dc15980e$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $jC8Vy.useState(()=>(href)=>{
            !router && (0, $4szZx.UNSAFE_invariant)(false);
            !routeId && (0, $4szZx.UNSAFE_invariant)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $4807fb19dc15980e$var$useSubmitImpl(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $jC8Vy.useMemo(()=>$4807fb19dc15980e$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $jC8Vy.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No fetcher available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $4807fb19dc15980e$export$fa996778a3a31087() {
    let state = $4807fb19dc15980e$var$useDataRouterState($4807fb19dc15980e$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $4807fb19dc15980e$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $4807fb19dc15980e$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $4807fb19dc15980e$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $4807fb19dc15980e$var$useDataRouterContext($4807fb19dc15980e$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $4807fb19dc15980e$var$useDataRouterState($4807fb19dc15980e$var$DataRouterStateHook.UseScrollRestoration);
    let location = (0, $2Phw0.useLocation)();
    let matches = (0, $2Phw0.useMatches)();
    let navigation = (0, $2Phw0.useNavigation)(); // Trigger manual scroll restoration while we're active
    $jC8Vy.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []); // Save positions on pagehide
    $4807fb19dc15980e$var$usePageHide($jC8Vy.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $4807fb19dc15980e$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $4807fb19dc15980e$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($4807fb19dc15980e$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ])); // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $jC8Vy.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $4807fb19dc15980e$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $4807fb19dc15980e$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]); // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $jC8Vy.useLayoutEffect(()=>{
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($4807fb19dc15980e$var$savedScrollPositions, ()=>window.scrollY, getKey);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            getKey
        ]); // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $jC8Vy.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
             // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            } // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(location.hash.slice(1));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            } // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
             // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $4807fb19dc15980e$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $jC8Vy.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $4807fb19dc15980e$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $jC8Vy.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $4807fb19dc15980e$export$39f4eb3dbd812741(_ref8) {
    let { when: when, message: message } = _ref8;
    let blocker = (0, $2Phw0.unstable_useBlocker)(when);
    $jC8Vy.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
    $jC8Vy.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
}

});



parcelRequire.register("kBpQ2", function(module, exports) {

$parcel$export(module.exports, "useConfirmModal", function () { return $42e5ab35147a2f03$export$753980156bc86c10; });

var $jC8Vy = parcelRequire("jC8Vy");

var $3nBui = parcelRequire("3nBui");
const $42e5ab35147a2f03$export$753980156bc86c10 = ()=>(0, $jC8Vy.useContext)((0, $3nBui.AppConfirmModalContext));

});
parcelRequire.register("3nBui", function(module, exports) {

$parcel$export(module.exports, "AppConfirmModalContext", function () { return $a08840f127efd640$export$9967fa47cf125764; });
$parcel$export(module.exports, "default", function () { return $a08840f127efd640$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $3dBAh = parcelRequire("3dBAh");

var $jC8Vy = parcelRequire("jC8Vy");

var $dL4NZ = parcelRequire("dL4NZ");
const $a08840f127efd640$export$9967fa47cf125764 = /*#__PURE__*/ (0, $jC8Vy.createContext)({
    show: async ()=>[
            true
        ],
    confirm: (0, $3dBAh.noop),
    cancel: (0, $3dBAh.noop)
});
const $a08840f127efd640$var$defaultModalState = {
    isOpen: false,
    type: "confirm",
    ModalContent: ()=>null
};
function $a08840f127efd640$var$AppConfirmModalProvider({ children: children }) {
    const [modalState, setModalState] = (0, $jC8Vy.useState)($a08840f127efd640$var$defaultModalState);
    const resolver = (0, $jC8Vy.useRef)();
    const handleShow = (0, $jC8Vy.useCallback)(async ({ type: type = "confirm", ...props })=>{
        resolver.current?.([
            false
        ]);
        setModalState({
            isOpen: true,
            type: type,
            ...props
        });
        return new Promise((resolve)=>{
            // eslint-disable-next-line @silverhand/fp/no-mutation
            resolver.current = resolve;
        });
    }, []);
    const handleConfirm = (0, $jC8Vy.useCallback)((data)=>{
        resolver.current?.([
            true,
            data
        ]);
        setModalState($a08840f127efd640$var$defaultModalState);
    }, []);
    const handleCancel = (0, $jC8Vy.useCallback)((data)=>{
        resolver.current?.([
            false,
            data
        ]);
        setModalState($a08840f127efd640$var$defaultModalState);
    }, []);
    const contextValue = (0, $jC8Vy.useMemo)(()=>({
            show: handleShow,
            confirm: handleConfirm,
            cancel: handleCancel
        }), [
        handleCancel,
        handleConfirm,
        handleShow
    ]);
    (0, $jC8Vy.useEffect)(()=>{
        const handlePathChange = ()=>{
            handleCancel();
        };
        /**
     * Note: Close the modal when the location path changes.
     * We don't use react-router-dom's `UseLocation` since this is a global component and not relying on the router.
     */ window.addEventListener("popstate", handlePathChange);
        return ()=>{
            window.removeEventListener("popstate", handlePathChange);
        };
    }, [
        handleCancel
    ]);
    const { ModalContent: ModalContent, type: type, ...restProps } = modalState;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)($a08840f127efd640$export$9967fa47cf125764.Provider, {
        value: contextValue,
        children: [
            children,
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dL4NZ.default), {
                ...restProps,
                onConfirm: type === "confirm" ? handleConfirm : undefined,
                onCancel: handleCancel,
                children: typeof ModalContent === "string" ? ModalContent : /*#__PURE__*/ (0, $C7mD2.jsx)(ModalContent, {})
            })
        ]
    });
}
var $a08840f127efd640$export$2e2bcd8739ae039 = $a08840f127efd640$var$AppConfirmModalProvider;

});
parcelRequire.register("dL4NZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a60375d32ed5138$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $kUZ14 = parcelRequire("kUZ14");

var $jGWQ4 = parcelRequire("jGWQ4");

var $dW2kG = parcelRequire("dW2kG");

var $5vVWy = parcelRequire("5vVWy");

var $4fYFM = parcelRequire("4fYFM");
function $2a60375d32ed5138$var$ConfirmModal({ children: children, className: className, title: title = "general.reminder", subtitle: subtitle, confirmButtonType: confirmButtonType = "danger", confirmButtonText: confirmButtonText = "general.confirm", cancelButtonText: cancelButtonText = "general.cancel", isOpen: isOpen, isConfirmButtonDisabled: isConfirmButtonDisabled = false, isLoading: isLoading = false, isCancelButtonVisible: isCancelButtonVisible = true, size: size, onCancel: onCancel, onConfirm: onConfirm }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        shouldCloseOnEsc: true,
        isOpen: isOpen,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($dW2kG.content),
        overlayClassName: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($dW2kG.overlay, $4fYFM.overlay),
        onRequestClose: onCancel,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5vVWy.default), {
            title: title,
            subtitle: subtitle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($4fYFM.content, className),
            size: size,
            footer: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    isCancelButtonVisible && onCancel && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        title: cancelButtonText,
                        onClick: onCancel
                    }),
                    onConfirm && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        type: confirmButtonType,
                        title: confirmButtonText,
                        disabled: isConfirmButtonDisabled,
                        isLoading: isLoading,
                        onClick: onConfirm
                    })
                ]
            }),
            onClose: onCancel,
            children: children
        })
    });
}
var $2a60375d32ed5138$export$2e2bcd8739ae039 = $2a60375d32ed5138$var$ConfirmModal;

});
parcelRequire.register("kUZ14", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9V5h3 = parcelRequire("9V5h3");
var $f3a85e2f8c03dfcb$var$_Modal2 = $f3a85e2f8c03dfcb$var$_interopRequireDefault($9V5h3);
function $f3a85e2f8c03dfcb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = $f3a85e2f8c03dfcb$var$_Modal2.default;
module.exports = module.exports["default"];

});
parcelRequire.register("9V5h3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bodyOpenClassName = module.exports.portalClassName = undefined;
var $738d87441bc4d60f$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $738d87441bc4d60f$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $jC8Vy = parcelRequire("jC8Vy");
var $738d87441bc4d60f$var$_react2 = $738d87441bc4d60f$var$_interopRequireDefault($jC8Vy);

var $jH4WR = parcelRequire("jH4WR");
var $738d87441bc4d60f$var$_reactDom2 = $738d87441bc4d60f$var$_interopRequireDefault($jH4WR);

var $bD9Bx = parcelRequire("bD9Bx");
var $738d87441bc4d60f$var$_propTypes2 = $738d87441bc4d60f$var$_interopRequireDefault($bD9Bx);

var $eKu42 = parcelRequire("eKu42");
var $738d87441bc4d60f$var$_ModalPortal2 = $738d87441bc4d60f$var$_interopRequireDefault($eKu42);

var $goS5N = parcelRequire("goS5N");
var $738d87441bc4d60f$var$ariaAppHider = $738d87441bc4d60f$var$_interopRequireWildcard($goS5N);

var $ii1TA = parcelRequire("ii1TA");
var $738d87441bc4d60f$var$_safeHTMLElement2 = $738d87441bc4d60f$var$_interopRequireDefault($ii1TA);

var $iOeic = parcelRequire("iOeic");
function $738d87441bc4d60f$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $738d87441bc4d60f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $738d87441bc4d60f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $738d87441bc4d60f$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $738d87441bc4d60f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $738d87441bc4d60f$var$portalClassName = module.exports.portalClassName = "ReactModalPortal";
var $738d87441bc4d60f$var$bodyOpenClassName = module.exports.bodyOpenClassName = "ReactModal__Body--open";
var $738d87441bc4d60f$var$isReact16 = $ii1TA.canUseDOM && $738d87441bc4d60f$var$_reactDom2.default.createPortal !== undefined;
var $738d87441bc4d60f$var$createHTMLElement = function createHTMLElement(name) {
    return document.createElement(name);
};
var $738d87441bc4d60f$var$getCreatePortal = function getCreatePortal() {
    return $738d87441bc4d60f$var$isReact16 ? $738d87441bc4d60f$var$_reactDom2.default.createPortal : $738d87441bc4d60f$var$_reactDom2.default.unstable_renderSubtreeIntoContainer;
};
function $738d87441bc4d60f$var$getParentElement(parentSelector) {
    return parentSelector();
}
var $738d87441bc4d60f$var$Modal = function(_Component) {
    $738d87441bc4d60f$var$_inherits(Modal, _Component);
    function Modal() {
        var _ref;
        var _temp, _this, _ret;
        $738d87441bc4d60f$var$_classCallCheck(this, Modal);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $738d87441bc4d60f$var$_possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.removePortal = function() {
            !$738d87441bc4d60f$var$isReact16 && $738d87441bc4d60f$var$_reactDom2.default.unmountComponentAtNode(_this.node);
            var parent = $738d87441bc4d60f$var$getParentElement(_this.props.parentSelector);
            if (parent && parent.contains(_this.node)) parent.removeChild(_this.node);
            else // eslint-disable-next-line no-console
            console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
        }, _this.portalRef = function(ref) {
            _this.portal = ref;
        }, _this.renderPortal = function(props) {
            var createPortal = $738d87441bc4d60f$var$getCreatePortal();
            var portal = createPortal(_this, $738d87441bc4d60f$var$_react2.default.createElement($738d87441bc4d60f$var$_ModalPortal2.default, $738d87441bc4d60f$var$_extends({
                defaultStyles: Modal.defaultStyles
            }, props)), _this.node);
            _this.portalRef(portal);
        }, _temp), $738d87441bc4d60f$var$_possibleConstructorReturn(_this, _ret);
    }
    $738d87441bc4d60f$var$_createClass(Modal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!$ii1TA.canUseDOM) return;
                if (!$738d87441bc4d60f$var$isReact16) this.node = $738d87441bc4d60f$var$createHTMLElement("div");
                this.node.className = this.props.portalClassName;
                var parent = $738d87441bc4d60f$var$getParentElement(this.props.parentSelector);
                parent.appendChild(this.node);
                !$738d87441bc4d60f$var$isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "getSnapshotBeforeUpdate",
            value: function getSnapshotBeforeUpdate(prevProps) {
                var prevParent = $738d87441bc4d60f$var$getParentElement(prevProps.parentSelector);
                var nextParent = $738d87441bc4d60f$var$getParentElement(this.props.parentSelector);
                return {
                    prevParent: prevParent,
                    nextParent: nextParent
                };
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, _, snapshot) {
                if (!$ii1TA.canUseDOM) return;
                var _props = this.props, isOpen = _props.isOpen, portalClassName = _props.portalClassName;
                if (prevProps.portalClassName !== portalClassName) this.node.className = portalClassName;
                var prevParent = snapshot.prevParent, nextParent = snapshot.nextParent;
                if (nextParent !== prevParent) {
                    prevParent.removeChild(this.node);
                    nextParent.appendChild(this.node);
                }
                // Stop unnecessary renders if modal is remaining closed
                if (!prevProps.isOpen && !isOpen) return;
                !$738d87441bc4d60f$var$isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (!$ii1TA.canUseDOM || !this.node || !this.portal) return;
                var state = this.portal.state;
                var now = Date.now();
                var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
                if (closesAt) {
                    if (!state.beforeClose) this.portal.closeWithTimeout();
                    setTimeout(this.removePortal, closesAt - now);
                } else this.removePortal();
            }
        },
        {
            key: "render",
            value: function render() {
                if (!$ii1TA.canUseDOM || !$738d87441bc4d60f$var$isReact16) return null;
                if (!this.node && $738d87441bc4d60f$var$isReact16) this.node = $738d87441bc4d60f$var$createHTMLElement("div");
                var createPortal = $738d87441bc4d60f$var$getCreatePortal();
                return createPortal($738d87441bc4d60f$var$_react2.default.createElement($738d87441bc4d60f$var$_ModalPortal2.default, $738d87441bc4d60f$var$_extends({
                    ref: this.portalRef,
                    defaultStyles: Modal.defaultStyles
                }, this.props)), this.node);
            }
        }
    ], [
        {
            key: "setAppElement",
            value: function setAppElement(element) {
                $738d87441bc4d60f$var$ariaAppHider.setElement(element);
            }
        }
    ]);
    return Modal;
}($jC8Vy.Component);
$738d87441bc4d60f$var$Modal.propTypes = {
    isOpen: $738d87441bc4d60f$var$_propTypes2.default.bool.isRequired,
    style: $738d87441bc4d60f$var$_propTypes2.default.shape({
        content: $738d87441bc4d60f$var$_propTypes2.default.object,
        overlay: $738d87441bc4d60f$var$_propTypes2.default.object
    }),
    portalClassName: $738d87441bc4d60f$var$_propTypes2.default.string,
    bodyOpenClassName: $738d87441bc4d60f$var$_propTypes2.default.string,
    htmlOpenClassName: $738d87441bc4d60f$var$_propTypes2.default.string,
    className: $738d87441bc4d60f$var$_propTypes2.default.oneOfType([
        $738d87441bc4d60f$var$_propTypes2.default.string,
        $738d87441bc4d60f$var$_propTypes2.default.shape({
            base: $738d87441bc4d60f$var$_propTypes2.default.string.isRequired,
            afterOpen: $738d87441bc4d60f$var$_propTypes2.default.string.isRequired,
            beforeClose: $738d87441bc4d60f$var$_propTypes2.default.string.isRequired
        })
    ]),
    overlayClassName: $738d87441bc4d60f$var$_propTypes2.default.oneOfType([
        $738d87441bc4d60f$var$_propTypes2.default.string,
        $738d87441bc4d60f$var$_propTypes2.default.shape({
            base: $738d87441bc4d60f$var$_propTypes2.default.string.isRequired,
            afterOpen: $738d87441bc4d60f$var$_propTypes2.default.string.isRequired,
            beforeClose: $738d87441bc4d60f$var$_propTypes2.default.string.isRequired
        })
    ]),
    appElement: $738d87441bc4d60f$var$_propTypes2.default.oneOfType([
        $738d87441bc4d60f$var$_propTypes2.default.instanceOf($738d87441bc4d60f$var$_safeHTMLElement2.default),
        $738d87441bc4d60f$var$_propTypes2.default.instanceOf($ii1TA.SafeHTMLCollection),
        $738d87441bc4d60f$var$_propTypes2.default.instanceOf($ii1TA.SafeNodeList),
        $738d87441bc4d60f$var$_propTypes2.default.arrayOf($738d87441bc4d60f$var$_propTypes2.default.instanceOf($738d87441bc4d60f$var$_safeHTMLElement2.default))
    ]),
    onAfterOpen: $738d87441bc4d60f$var$_propTypes2.default.func,
    onRequestClose: $738d87441bc4d60f$var$_propTypes2.default.func,
    closeTimeoutMS: $738d87441bc4d60f$var$_propTypes2.default.number,
    ariaHideApp: $738d87441bc4d60f$var$_propTypes2.default.bool,
    shouldFocusAfterRender: $738d87441bc4d60f$var$_propTypes2.default.bool,
    shouldCloseOnOverlayClick: $738d87441bc4d60f$var$_propTypes2.default.bool,
    shouldReturnFocusAfterClose: $738d87441bc4d60f$var$_propTypes2.default.bool,
    preventScroll: $738d87441bc4d60f$var$_propTypes2.default.bool,
    parentSelector: $738d87441bc4d60f$var$_propTypes2.default.func,
    aria: $738d87441bc4d60f$var$_propTypes2.default.object,
    data: $738d87441bc4d60f$var$_propTypes2.default.object,
    role: $738d87441bc4d60f$var$_propTypes2.default.string,
    contentLabel: $738d87441bc4d60f$var$_propTypes2.default.string,
    shouldCloseOnEsc: $738d87441bc4d60f$var$_propTypes2.default.bool,
    overlayRef: $738d87441bc4d60f$var$_propTypes2.default.func,
    contentRef: $738d87441bc4d60f$var$_propTypes2.default.func,
    id: $738d87441bc4d60f$var$_propTypes2.default.string,
    overlayElement: $738d87441bc4d60f$var$_propTypes2.default.func,
    contentElement: $738d87441bc4d60f$var$_propTypes2.default.func
};
$738d87441bc4d60f$var$Modal.defaultProps = {
    isOpen: false,
    portalClassName: $738d87441bc4d60f$var$portalClassName,
    bodyOpenClassName: $738d87441bc4d60f$var$bodyOpenClassName,
    role: "dialog",
    ariaHideApp: true,
    closeTimeoutMS: 0,
    shouldFocusAfterRender: true,
    shouldCloseOnEsc: true,
    shouldCloseOnOverlayClick: true,
    shouldReturnFocusAfterClose: true,
    preventScroll: false,
    parentSelector: function parentSelector() {
        return document.body;
    },
    overlayElement: function overlayElement(props, contentEl) {
        return $738d87441bc4d60f$var$_react2.default.createElement("div", props, contentEl);
    },
    contentElement: function contentElement(props, children) {
        return $738d87441bc4d60f$var$_react2.default.createElement("div", props, children);
    }
};
$738d87441bc4d60f$var$Modal.defaultStyles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.75)"
    },
    content: {
        position: "absolute",
        top: "40px",
        left: "40px",
        right: "40px",
        bottom: "40px",
        border: "1px solid #ccc",
        background: "#fff",
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
        borderRadius: "4px",
        outline: "none",
        padding: "20px"
    }
};
(0, $iOeic.polyfill)($738d87441bc4d60f$var$Modal);
module.exports.default = $738d87441bc4d60f$var$Modal;

});
parcelRequire.register("eKu42", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $abccaeb11f28ec11$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $abccaeb11f28ec11$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $abccaeb11f28ec11$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $jC8Vy = parcelRequire("jC8Vy");

var $bD9Bx = parcelRequire("bD9Bx");
var $abccaeb11f28ec11$var$_propTypes2 = $abccaeb11f28ec11$var$_interopRequireDefault($bD9Bx);

var $60hsw = parcelRequire("60hsw");
var $abccaeb11f28ec11$var$focusManager = $abccaeb11f28ec11$var$_interopRequireWildcard($60hsw);

var $eNZgo = parcelRequire("eNZgo");
var $abccaeb11f28ec11$var$_scopeTab2 = $abccaeb11f28ec11$var$_interopRequireDefault($eNZgo);

var $goS5N = parcelRequire("goS5N");
var $abccaeb11f28ec11$var$ariaAppHider = $abccaeb11f28ec11$var$_interopRequireWildcard($goS5N);

var $evxWF = parcelRequire("evxWF");
var $abccaeb11f28ec11$var$classList = $abccaeb11f28ec11$var$_interopRequireWildcard($evxWF);

var $ii1TA = parcelRequire("ii1TA");
var $abccaeb11f28ec11$var$_safeHTMLElement2 = $abccaeb11f28ec11$var$_interopRequireDefault($ii1TA);

var $jM12I = parcelRequire("jM12I");
var $abccaeb11f28ec11$var$_portalOpenInstances2 = $abccaeb11f28ec11$var$_interopRequireDefault($jM12I);
parcelRequire("a2PGv");
function $abccaeb11f28ec11$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $abccaeb11f28ec11$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $abccaeb11f28ec11$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $abccaeb11f28ec11$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $abccaeb11f28ec11$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// so that our CSS is statically analyzable
var $abccaeb11f28ec11$var$CLASS_NAMES = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
};
var $abccaeb11f28ec11$var$TAB_KEY = 9;
var $abccaeb11f28ec11$var$ESC_KEY = 27;
var $abccaeb11f28ec11$var$ariaHiddenInstances = 0;
var $abccaeb11f28ec11$var$ModalPortal = function(_Component) {
    $abccaeb11f28ec11$var$_inherits(ModalPortal, _Component);
    function ModalPortal(props) {
        $abccaeb11f28ec11$var$_classCallCheck(this, ModalPortal);
        var _this = $abccaeb11f28ec11$var$_possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
        _this.setOverlayRef = function(overlay) {
            _this.overlay = overlay;
            _this.props.overlayRef && _this.props.overlayRef(overlay);
        };
        _this.setContentRef = function(content) {
            _this.content = content;
            _this.props.contentRef && _this.props.contentRef(content);
        };
        _this.afterClose = function() {
            var _this$props = _this.props, appElement = _this$props.appElement, ariaHideApp = _this$props.ariaHideApp, htmlOpenClassName = _this$props.htmlOpenClassName, bodyOpenClassName = _this$props.bodyOpenClassName;
            // Remove classes.
            bodyOpenClassName && $abccaeb11f28ec11$var$classList.remove(document.body, bodyOpenClassName);
            htmlOpenClassName && $abccaeb11f28ec11$var$classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);
            // Reset aria-hidden attribute if all modals have been removed
            if (ariaHideApp && $abccaeb11f28ec11$var$ariaHiddenInstances > 0) {
                $abccaeb11f28ec11$var$ariaHiddenInstances -= 1;
                if ($abccaeb11f28ec11$var$ariaHiddenInstances === 0) $abccaeb11f28ec11$var$ariaAppHider.show(appElement);
            }
            if (_this.props.shouldFocusAfterRender) {
                if (_this.props.shouldReturnFocusAfterClose) {
                    $abccaeb11f28ec11$var$focusManager.returnFocus(_this.props.preventScroll);
                    $abccaeb11f28ec11$var$focusManager.teardownScopedFocus();
                } else $abccaeb11f28ec11$var$focusManager.popWithoutFocus();
            }
            if (_this.props.onAfterClose) _this.props.onAfterClose();
            $abccaeb11f28ec11$var$_portalOpenInstances2.default.deregister(_this);
        };
        _this.open = function() {
            _this.beforeOpen();
            if (_this.state.afterOpen && _this.state.beforeClose) {
                clearTimeout(_this.closeTimer);
                _this.setState({
                    beforeClose: false
                });
            } else {
                if (_this.props.shouldFocusAfterRender) {
                    $abccaeb11f28ec11$var$focusManager.setupScopedFocus(_this.node);
                    $abccaeb11f28ec11$var$focusManager.markForFocusLater();
                }
                _this.setState({
                    isOpen: true
                }, function() {
                    _this.openAnimationFrame = requestAnimationFrame(function() {
                        _this.setState({
                            afterOpen: true
                        });
                        if (_this.props.isOpen && _this.props.onAfterOpen) _this.props.onAfterOpen({
                            overlayEl: _this.overlay,
                            contentEl: _this.content
                        });
                    });
                });
            }
        };
        _this.close = function() {
            if (_this.props.closeTimeoutMS > 0) _this.closeWithTimeout();
            else _this.closeWithoutTimeout();
        };
        _this.focusContent = function() {
            return _this.content && !_this.contentHasFocus() && _this.content.focus({
                preventScroll: true
            });
        };
        _this.closeWithTimeout = function() {
            var closesAt = Date.now() + _this.props.closeTimeoutMS;
            _this.setState({
                beforeClose: true,
                closesAt: closesAt
            }, function() {
                _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
            });
        };
        _this.closeWithoutTimeout = function() {
            _this.setState({
                beforeClose: false,
                isOpen: false,
                afterOpen: false,
                closesAt: null
            }, _this.afterClose);
        };
        _this.handleKeyDown = function(event) {
            if (event.keyCode === $abccaeb11f28ec11$var$TAB_KEY) (0, $abccaeb11f28ec11$var$_scopeTab2.default)(_this.content, event);
            if (_this.props.shouldCloseOnEsc && event.keyCode === $abccaeb11f28ec11$var$ESC_KEY) {
                event.stopPropagation();
                _this.requestClose(event);
            }
        };
        _this.handleOverlayOnClick = function(event) {
            if (_this.shouldClose === null) _this.shouldClose = true;
            if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
                if (_this.ownerHandlesClose()) _this.requestClose(event);
                else _this.focusContent();
            }
            _this.shouldClose = null;
        };
        _this.handleContentOnMouseUp = function() {
            _this.shouldClose = false;
        };
        _this.handleOverlayOnMouseDown = function(event) {
            if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) event.preventDefault();
        };
        _this.handleContentOnClick = function() {
            _this.shouldClose = false;
        };
        _this.handleContentOnMouseDown = function() {
            _this.shouldClose = false;
        };
        _this.requestClose = function(event) {
            return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
        };
        _this.ownerHandlesClose = function() {
            return _this.props.onRequestClose;
        };
        _this.shouldBeClosed = function() {
            return !_this.state.isOpen && !_this.state.beforeClose;
        };
        _this.contentHasFocus = function() {
            return document.activeElement === _this.content || _this.content.contains(document.activeElement);
        };
        _this.buildClassName = function(which, additional) {
            var classNames = (typeof additional === "undefined" ? "undefined" : $abccaeb11f28ec11$var$_typeof(additional)) === "object" ? additional : {
                base: $abccaeb11f28ec11$var$CLASS_NAMES[which],
                afterOpen: $abccaeb11f28ec11$var$CLASS_NAMES[which] + "--after-open",
                beforeClose: $abccaeb11f28ec11$var$CLASS_NAMES[which] + "--before-close"
            };
            var className = classNames.base;
            if (_this.state.afterOpen) className = className + " " + classNames.afterOpen;
            if (_this.state.beforeClose) className = className + " " + classNames.beforeClose;
            return typeof additional === "string" && additional ? className + " " + additional : className;
        };
        _this.attributesFromObject = function(prefix, items) {
            return Object.keys(items).reduce(function(acc, name) {
                acc[prefix + "-" + name] = items[name];
                return acc;
            }, {});
        };
        _this.state = {
            afterOpen: false,
            beforeClose: false
        };
        _this.shouldClose = null;
        _this.moveFromContentToOverlay = null;
        return _this;
    }
    $abccaeb11f28ec11$var$_createClass(ModalPortal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.isOpen) this.open();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.isOpen && !prevProps.isOpen) this.open();
                else if (!this.props.isOpen && prevProps.isOpen) this.close();
                // Focus only needs to be set once when the modal is being opened
                if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) this.focusContent();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.state.isOpen) this.afterClose();
                clearTimeout(this.closeTimer);
                cancelAnimationFrame(this.openAnimationFrame);
            }
        },
        {
            key: "beforeOpen",
            value: function beforeOpen() {
                var _props = this.props, appElement = _props.appElement, ariaHideApp = _props.ariaHideApp, htmlOpenClassName = _props.htmlOpenClassName, bodyOpenClassName = _props.bodyOpenClassName;
                // Add classes.
                bodyOpenClassName && $abccaeb11f28ec11$var$classList.add(document.body, bodyOpenClassName);
                htmlOpenClassName && $abccaeb11f28ec11$var$classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);
                if (ariaHideApp) {
                    $abccaeb11f28ec11$var$ariaHiddenInstances += 1;
                    $abccaeb11f28ec11$var$ariaAppHider.hide(appElement);
                }
                $abccaeb11f28ec11$var$_portalOpenInstances2.default.register(this);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props2 = this.props, id = _props2.id, className = _props2.className, overlayClassName = _props2.overlayClassName, defaultStyles = _props2.defaultStyles, children = _props2.children;
                var contentStyles = className ? {} : defaultStyles.content;
                var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
                if (this.shouldBeClosed()) return null;
                var overlayProps = {
                    ref: this.setOverlayRef,
                    className: this.buildClassName("overlay", overlayClassName),
                    style: $abccaeb11f28ec11$var$_extends({}, overlayStyles, this.props.style.overlay),
                    onClick: this.handleOverlayOnClick,
                    onMouseDown: this.handleOverlayOnMouseDown
                };
                var contentProps = $abccaeb11f28ec11$var$_extends({
                    id: id,
                    ref: this.setContentRef,
                    style: $abccaeb11f28ec11$var$_extends({}, contentStyles, this.props.style.content),
                    className: this.buildClassName("content", className),
                    tabIndex: "-1",
                    onKeyDown: this.handleKeyDown,
                    onMouseDown: this.handleContentOnMouseDown,
                    onMouseUp: this.handleContentOnMouseUp,
                    onClick: this.handleContentOnClick,
                    role: this.props.role,
                    "aria-label": this.props.contentLabel
                }, this.attributesFromObject("aria", $abccaeb11f28ec11$var$_extends({
                    modal: true
                }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
                    "data-testid": this.props.testId
                });
                var contentElement = this.props.contentElement(contentProps, children);
                return this.props.overlayElement(overlayProps, contentElement);
            }
        }
    ]);
    return ModalPortal;
}($jC8Vy.Component);
$abccaeb11f28ec11$var$ModalPortal.defaultProps = {
    style: {
        overlay: {},
        content: {}
    },
    defaultStyles: {}
};
$abccaeb11f28ec11$var$ModalPortal.propTypes = {
    isOpen: $abccaeb11f28ec11$var$_propTypes2.default.bool.isRequired,
    defaultStyles: $abccaeb11f28ec11$var$_propTypes2.default.shape({
        content: $abccaeb11f28ec11$var$_propTypes2.default.object,
        overlay: $abccaeb11f28ec11$var$_propTypes2.default.object
    }),
    style: $abccaeb11f28ec11$var$_propTypes2.default.shape({
        content: $abccaeb11f28ec11$var$_propTypes2.default.object,
        overlay: $abccaeb11f28ec11$var$_propTypes2.default.object
    }),
    className: $abccaeb11f28ec11$var$_propTypes2.default.oneOfType([
        $abccaeb11f28ec11$var$_propTypes2.default.string,
        $abccaeb11f28ec11$var$_propTypes2.default.object
    ]),
    overlayClassName: $abccaeb11f28ec11$var$_propTypes2.default.oneOfType([
        $abccaeb11f28ec11$var$_propTypes2.default.string,
        $abccaeb11f28ec11$var$_propTypes2.default.object
    ]),
    bodyOpenClassName: $abccaeb11f28ec11$var$_propTypes2.default.string,
    htmlOpenClassName: $abccaeb11f28ec11$var$_propTypes2.default.string,
    ariaHideApp: $abccaeb11f28ec11$var$_propTypes2.default.bool,
    appElement: $abccaeb11f28ec11$var$_propTypes2.default.oneOfType([
        $abccaeb11f28ec11$var$_propTypes2.default.instanceOf($abccaeb11f28ec11$var$_safeHTMLElement2.default),
        $abccaeb11f28ec11$var$_propTypes2.default.instanceOf($ii1TA.SafeHTMLCollection),
        $abccaeb11f28ec11$var$_propTypes2.default.instanceOf($ii1TA.SafeNodeList),
        $abccaeb11f28ec11$var$_propTypes2.default.arrayOf($abccaeb11f28ec11$var$_propTypes2.default.instanceOf($abccaeb11f28ec11$var$_safeHTMLElement2.default))
    ]),
    onAfterOpen: $abccaeb11f28ec11$var$_propTypes2.default.func,
    onAfterClose: $abccaeb11f28ec11$var$_propTypes2.default.func,
    onRequestClose: $abccaeb11f28ec11$var$_propTypes2.default.func,
    closeTimeoutMS: $abccaeb11f28ec11$var$_propTypes2.default.number,
    shouldFocusAfterRender: $abccaeb11f28ec11$var$_propTypes2.default.bool,
    shouldCloseOnOverlayClick: $abccaeb11f28ec11$var$_propTypes2.default.bool,
    shouldReturnFocusAfterClose: $abccaeb11f28ec11$var$_propTypes2.default.bool,
    preventScroll: $abccaeb11f28ec11$var$_propTypes2.default.bool,
    role: $abccaeb11f28ec11$var$_propTypes2.default.string,
    contentLabel: $abccaeb11f28ec11$var$_propTypes2.default.string,
    aria: $abccaeb11f28ec11$var$_propTypes2.default.object,
    data: $abccaeb11f28ec11$var$_propTypes2.default.object,
    children: $abccaeb11f28ec11$var$_propTypes2.default.node,
    shouldCloseOnEsc: $abccaeb11f28ec11$var$_propTypes2.default.bool,
    overlayRef: $abccaeb11f28ec11$var$_propTypes2.default.func,
    contentRef: $abccaeb11f28ec11$var$_propTypes2.default.func,
    id: $abccaeb11f28ec11$var$_propTypes2.default.string,
    overlayElement: $abccaeb11f28ec11$var$_propTypes2.default.func,
    contentElement: $abccaeb11f28ec11$var$_propTypes2.default.func,
    testId: $abccaeb11f28ec11$var$_propTypes2.default.string
};
module.exports.default = $abccaeb11f28ec11$var$ModalPortal;
module.exports = module.exports["default"];

});
parcelRequire.register("60hsw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resetState = $45f0492ea7bb79ad$var$resetState;
module.exports.log = $45f0492ea7bb79ad$var$log;
module.exports.handleBlur = $45f0492ea7bb79ad$var$handleBlur;
module.exports.handleFocus = $45f0492ea7bb79ad$var$handleFocus;
module.exports.markForFocusLater = $45f0492ea7bb79ad$var$markForFocusLater;
module.exports.returnFocus = $45f0492ea7bb79ad$var$returnFocus;
module.exports.popWithoutFocus = $45f0492ea7bb79ad$var$popWithoutFocus;
module.exports.setupScopedFocus = $45f0492ea7bb79ad$var$setupScopedFocus;
module.exports.teardownScopedFocus = $45f0492ea7bb79ad$var$teardownScopedFocus;

var $2INhA = parcelRequire("2INhA");
var $45f0492ea7bb79ad$var$_tabbable2 = $45f0492ea7bb79ad$var$_interopRequireDefault($2INhA);
function $45f0492ea7bb79ad$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $45f0492ea7bb79ad$var$focusLaterElements = [];
var $45f0492ea7bb79ad$var$modalElement = null;
var $45f0492ea7bb79ad$var$needToFocus = false;
/* eslint-disable no-console */ /* istanbul ignore next */ function $45f0492ea7bb79ad$var$resetState() {
    $45f0492ea7bb79ad$var$focusLaterElements = [];
}
/* istanbul ignore next */ function $45f0492ea7bb79ad$var$log() {}
/* eslint-enable no-console */ function $45f0492ea7bb79ad$var$handleBlur() {
    $45f0492ea7bb79ad$var$needToFocus = true;
}
function $45f0492ea7bb79ad$var$handleFocus() {
    if ($45f0492ea7bb79ad$var$needToFocus) {
        $45f0492ea7bb79ad$var$needToFocus = false;
        if (!$45f0492ea7bb79ad$var$modalElement) return;
        // need to see how jQuery shims document.on('focusin') so we don't need the
        // setTimeout, firefox doesn't support focusin, if it did, we could focus
        // the element outside of a setTimeout. Side-effect of this implementation
        // is that the document.body gets focus, and then we focus our element right
        // after, seems fine.
        setTimeout(function() {
            if ($45f0492ea7bb79ad$var$modalElement.contains(document.activeElement)) return;
            var el = (0, $45f0492ea7bb79ad$var$_tabbable2.default)($45f0492ea7bb79ad$var$modalElement)[0] || $45f0492ea7bb79ad$var$modalElement;
            el.focus();
        }, 0);
    }
}
function $45f0492ea7bb79ad$var$markForFocusLater() {
    $45f0492ea7bb79ad$var$focusLaterElements.push(document.activeElement);
}
/* eslint-disable no-console */ function $45f0492ea7bb79ad$var$returnFocus() {
    var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var toFocus = null;
    try {
        if ($45f0492ea7bb79ad$var$focusLaterElements.length !== 0) {
            toFocus = $45f0492ea7bb79ad$var$focusLaterElements.pop();
            toFocus.focus({
                preventScroll: preventScroll
            });
        }
        return;
    } catch (e) {
        console.warn([
            "You tried to return focus to",
            toFocus,
            "but it is not in the DOM anymore"
        ].join(" "));
    }
}
/* eslint-enable no-console */ function $45f0492ea7bb79ad$var$popWithoutFocus() {
    $45f0492ea7bb79ad$var$focusLaterElements.length > 0 && $45f0492ea7bb79ad$var$focusLaterElements.pop();
}
function $45f0492ea7bb79ad$var$setupScopedFocus(element) {
    $45f0492ea7bb79ad$var$modalElement = element;
    if (window.addEventListener) {
        window.addEventListener("blur", $45f0492ea7bb79ad$var$handleBlur, false);
        document.addEventListener("focus", $45f0492ea7bb79ad$var$handleFocus, true);
    } else {
        window.attachEvent("onBlur", $45f0492ea7bb79ad$var$handleBlur);
        document.attachEvent("onFocus", $45f0492ea7bb79ad$var$handleFocus);
    }
}
function $45f0492ea7bb79ad$var$teardownScopedFocus() {
    $45f0492ea7bb79ad$var$modalElement = null;
    if (window.addEventListener) {
        window.removeEventListener("blur", $45f0492ea7bb79ad$var$handleBlur);
        document.removeEventListener("focus", $45f0492ea7bb79ad$var$handleFocus);
    } else {
        window.detachEvent("onBlur", $45f0492ea7bb79ad$var$handleBlur);
        document.detachEvent("onFocus", $45f0492ea7bb79ad$var$handleFocus);
    }
}

});
parcelRequire.register("2INhA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1fb5eb50b988e2fc$var$findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */ var $1fb5eb50b988e2fc$var$tabbableNode = /input|select|textarea|button|object|iframe/;
function $1fb5eb50b988e2fc$var$hidesContents(element) {
    var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
    // If the node is empty, this is good enough
    if (zeroSize && !element.innerHTML) return true;
    try {
        // Otherwise we need to check some styles
        var style = window.getComputedStyle(element);
        return zeroSize ? style.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
        element.scrollWidth <= 0 && element.scrollHeight <= 0 : style.getPropertyValue("display") == "none";
    } catch (exception) {
        // eslint-disable-next-line no-console
        console.warn("Failed to inspect element style");
        return false;
    }
}
function $1fb5eb50b988e2fc$var$visible(element) {
    var parentElement = element;
    var rootNode = element.getRootNode && element.getRootNode();
    while(parentElement){
        if (parentElement === document.body) break;
        // if we are not hidden yet, skip to checking outside the Web Component
        if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;
        if ($1fb5eb50b988e2fc$var$hidesContents(parentElement)) return false;
        parentElement = parentElement.parentNode;
    }
    return true;
}
function $1fb5eb50b988e2fc$var$focusable(element, isTabIndexNotNaN) {
    var nodeName = element.nodeName.toLowerCase();
    var res = $1fb5eb50b988e2fc$var$tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
    return res && $1fb5eb50b988e2fc$var$visible(element);
}
function $1fb5eb50b988e2fc$var$tabbable(element) {
    var tabIndex = element.getAttribute("tabindex");
    if (tabIndex === null) tabIndex = undefined;
    var isTabIndexNaN = isNaN(tabIndex);
    return (isTabIndexNaN || tabIndex >= 0) && $1fb5eb50b988e2fc$var$focusable(element, !isTabIndexNaN);
}
function $1fb5eb50b988e2fc$var$findTabbableDescendants(element) {
    var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function(finished, el) {
        return finished.concat(!el.shadowRoot ? [
            el
        ] : $1fb5eb50b988e2fc$var$findTabbableDescendants(el.shadowRoot));
    }, []);
    return descendants.filter($1fb5eb50b988e2fc$var$tabbable);
}
module.exports = module.exports["default"];

});


parcelRequire.register("eNZgo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ac7529ec412dd860$var$scopeTab;

var $2INhA = parcelRequire("2INhA");
var $ac7529ec412dd860$var$_tabbable2 = $ac7529ec412dd860$var$_interopRequireDefault($2INhA);
function $ac7529ec412dd860$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ac7529ec412dd860$var$getActiveElement() {
    var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    return el.activeElement.shadowRoot ? $ac7529ec412dd860$var$getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}
function $ac7529ec412dd860$var$scopeTab(node, event) {
    var tabbable = (0, $ac7529ec412dd860$var$_tabbable2.default)(node);
    if (!tabbable.length) {
        // Do nothing, since there are no elements that can receive focus.
        event.preventDefault();
        return;
    }
    var target = void 0;
    var shiftKey = event.shiftKey;
    var head = tabbable[0];
    var tail = tabbable[tabbable.length - 1];
    var activeElement = $ac7529ec412dd860$var$getActiveElement();
    // proceed with default browser behavior on tab.
    // Focus on last element on shift + tab.
    if (node === activeElement) {
        if (!shiftKey) return;
        target = tail;
    }
    if (tail === activeElement && !shiftKey) target = head;
    if (head === activeElement && shiftKey) target = tail;
    if (target) {
        event.preventDefault();
        target.focus();
        return;
    }
    // Safari radio issue.
    //
    // Safari does not move the focus to the radio button,
    // so we need to force it to really walk through all elements.
    //
    // This is very error prone, since we are trying to guess
    // if it is a safari browser from the first occurence between
    // chrome or safari.
    //
    // The chrome user agent contains the first ocurrence
    // as the 'chrome/version' and later the 'safari/version'.
    var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
    var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    // If we are not in safari desktop, let the browser control
    // the focus
    if (!isSafariDesktop) return;
    var x = tabbable.indexOf(activeElement);
    if (x > -1) x += shiftKey ? -1 : 1;
    target = tabbable[x];
    // If the tabbable element does not exist,
    // focus head/tail based on shiftKey
    if (typeof target === "undefined") {
        event.preventDefault();
        target = shiftKey ? tail : head;
        target.focus();
        return;
    }
    event.preventDefault();
    target.focus();
}
module.exports = module.exports["default"];

});

parcelRequire.register("goS5N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resetState = $bf08d8dc6b8914df$var$resetState;
module.exports.log = $bf08d8dc6b8914df$var$log;
module.exports.assertNodeList = $bf08d8dc6b8914df$var$assertNodeList;
module.exports.setElement = $bf08d8dc6b8914df$var$setElement;
module.exports.validateElement = $bf08d8dc6b8914df$var$validateElement;
module.exports.hide = $bf08d8dc6b8914df$var$hide;
module.exports.show = $bf08d8dc6b8914df$var$show;
module.exports.documentNotReadyOrSSRTesting = $bf08d8dc6b8914df$var$documentNotReadyOrSSRTesting;

var $iYobC = parcelRequire("iYobC");
var $bf08d8dc6b8914df$var$_warning2 = $bf08d8dc6b8914df$var$_interopRequireDefault($iYobC);

var $ii1TA = parcelRequire("ii1TA");
function $bf08d8dc6b8914df$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $bf08d8dc6b8914df$var$globalElement = null;
/* eslint-disable no-console */ /* istanbul ignore next */ function $bf08d8dc6b8914df$var$resetState() {
    if ($bf08d8dc6b8914df$var$globalElement) {
        if ($bf08d8dc6b8914df$var$globalElement.removeAttribute) $bf08d8dc6b8914df$var$globalElement.removeAttribute("aria-hidden");
        else if ($bf08d8dc6b8914df$var$globalElement.length != null) $bf08d8dc6b8914df$var$globalElement.forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
        else document.querySelectorAll($bf08d8dc6b8914df$var$globalElement).forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
    }
    $bf08d8dc6b8914df$var$globalElement = null;
}
/* istanbul ignore next */ function $bf08d8dc6b8914df$var$log() {
    var check;
}
/* eslint-enable no-console */ function $bf08d8dc6b8914df$var$assertNodeList(nodeList, selector) {
    if (!nodeList || !nodeList.length) throw new Error("react-modal: No elements were found for selector " + selector + ".");
}
function $bf08d8dc6b8914df$var$setElement(element) {
    var useElement = element;
    if (typeof useElement === "string" && $ii1TA.canUseDOM) {
        var el = document.querySelectorAll(useElement);
        $bf08d8dc6b8914df$var$assertNodeList(el, useElement);
        useElement = el;
    }
    $bf08d8dc6b8914df$var$globalElement = useElement || $bf08d8dc6b8914df$var$globalElement;
    return $bf08d8dc6b8914df$var$globalElement;
}
function $bf08d8dc6b8914df$var$validateElement(appElement) {
    var el = appElement || $bf08d8dc6b8914df$var$globalElement;
    if (el) return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [
        el
    ];
    else {
        (0, $bf08d8dc6b8914df$var$_warning2.default)(false, [
            "react-modal: App element is not defined.",
            "Please use `Modal.setAppElement(el)` or set `appElement={el}`.",
            "This is needed so screen readers don't see main content",
            "when modal is opened. It is not recommended, but you can opt-out",
            "by setting `ariaHideApp={false}`."
        ].join(" "));
        return [];
    }
}
function $bf08d8dc6b8914df$var$hide(appElement) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
        for(var _iterator = $bf08d8dc6b8914df$var$validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var el = _step.value;
            el.setAttribute("aria-hidden", "true");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
}
function $bf08d8dc6b8914df$var$show(appElement) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;
    try {
        for(var _iterator2 = $bf08d8dc6b8914df$var$validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var el = _step2.value;
            el.removeAttribute("aria-hidden");
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
        } finally{
            if (_didIteratorError2) throw _iteratorError2;
        }
    }
}
function $bf08d8dc6b8914df$var$documentNotReadyOrSSRTesting() {
    $bf08d8dc6b8914df$var$globalElement = null;
}

});
parcelRequire.register("iYobC", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $dd009780ae37594e$var$__DEV__ = false;
var $dd009780ae37594e$var$warning = function() {};
if ($dd009780ae37594e$var$__DEV__) {
    var $dd009780ae37594e$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $dd009780ae37594e$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $dd009780ae37594e$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $dd009780ae37594e$var$warning;

});

parcelRequire.register("ii1TA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.canUseDOM = module.exports.SafeNodeList = module.exports.SafeHTMLCollection = undefined;

var $9PiU4 = parcelRequire("9PiU4");
var $d50b60df5c773b0e$var$_exenv2 = $d50b60df5c773b0e$var$_interopRequireDefault($9PiU4);
function $d50b60df5c773b0e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d50b60df5c773b0e$var$EE = $d50b60df5c773b0e$var$_exenv2.default;
var $d50b60df5c773b0e$var$SafeHTMLElement = $d50b60df5c773b0e$var$EE.canUseDOM ? window.HTMLElement : {};
var $d50b60df5c773b0e$var$SafeHTMLCollection = module.exports.SafeHTMLCollection = $d50b60df5c773b0e$var$EE.canUseDOM ? window.HTMLCollection : {};
var $d50b60df5c773b0e$var$SafeNodeList = module.exports.SafeNodeList = $d50b60df5c773b0e$var$EE.canUseDOM ? window.NodeList : {};
var $d50b60df5c773b0e$var$canUseDOM = module.exports.canUseDOM = $d50b60df5c773b0e$var$EE.canUseDOM;
module.exports.default = $d50b60df5c773b0e$var$SafeHTMLElement;

});
parcelRequire.register("9PiU4", function(module, exports) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    "use strict";
    var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== "undefined",
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === "function" && typeof define.amd === "object" && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (0, module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

});



parcelRequire.register("evxWF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resetState = $a8fe4abd6f79901c$var$resetState;
module.exports.log = $a8fe4abd6f79901c$var$log;
var $a8fe4abd6f79901c$var$htmlClassList = {};
var $a8fe4abd6f79901c$var$docBodyClassList = {};
/* eslint-disable no-console */ /* istanbul ignore next */ function $a8fe4abd6f79901c$var$removeClass(at, cls) {
    at.classList.remove(cls);
}
/* istanbul ignore next */ function $a8fe4abd6f79901c$var$resetState() {
    var htmlElement = document.getElementsByTagName("html")[0];
    for(var cls in $a8fe4abd6f79901c$var$htmlClassList)$a8fe4abd6f79901c$var$removeClass(htmlElement, $a8fe4abd6f79901c$var$htmlClassList[cls]);
    var body = document.body;
    for(var _cls in $a8fe4abd6f79901c$var$docBodyClassList)$a8fe4abd6f79901c$var$removeClass(body, $a8fe4abd6f79901c$var$docBodyClassList[_cls]);
    $a8fe4abd6f79901c$var$htmlClassList = {};
    $a8fe4abd6f79901c$var$docBodyClassList = {};
}
/* istanbul ignore next */ function $a8fe4abd6f79901c$var$log() {
    var classes, buffer, x, _x;
}
/* eslint-enable no-console */ /**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var $a8fe4abd6f79901c$var$incrementReference = function incrementReference(poll, className) {
    if (!poll[className]) poll[className] = 0;
    poll[className] += 1;
    return className;
};
/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var $a8fe4abd6f79901c$var$decrementReference = function decrementReference(poll, className) {
    if (poll[className]) poll[className] -= 1;
    return className;
};
/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */ var $a8fe4abd6f79901c$var$trackClass = function trackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        $a8fe4abd6f79901c$var$incrementReference(poll, className);
        classListRef.add(className);
    });
};
/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */ var $a8fe4abd6f79901c$var$untrackClass = function untrackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        $a8fe4abd6f79901c$var$decrementReference(poll, className);
        poll[className] === 0 && classListRef.remove(className);
    });
};
/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var $a8fe4abd6f79901c$var$add = module.exports.add = function add(element, classString) {
    return $a8fe4abd6f79901c$var$trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? $a8fe4abd6f79901c$var$htmlClassList : $a8fe4abd6f79901c$var$docBodyClassList, classString.split(" "));
};
/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var $a8fe4abd6f79901c$var$remove = module.exports.remove = function remove(element, classString) {
    return $a8fe4abd6f79901c$var$untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? $a8fe4abd6f79901c$var$htmlClassList : $a8fe4abd6f79901c$var$docBodyClassList, classString.split(" "));
};

});

parcelRequire.register("jM12I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.log = $e6534f125fec945b$var$log;
module.exports.resetState = $e6534f125fec945b$var$resetState;
function $e6534f125fec945b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
// Tracks portals that are open and emits events to subscribers
var $e6534f125fec945b$var$PortalOpenInstances = function PortalOpenInstances() {
    var _this = this;
    $e6534f125fec945b$var$_classCallCheck(this, PortalOpenInstances);
    this.register = function(openInstance) {
        if (_this.openInstances.indexOf(openInstance) !== -1) return;
        _this.openInstances.push(openInstance);
        _this.emit("register");
    };
    this.deregister = function(openInstance) {
        var index = _this.openInstances.indexOf(openInstance);
        if (index === -1) return;
        _this.openInstances.splice(index, 1);
        _this.emit("deregister");
    };
    this.subscribe = function(callback) {
        _this.subscribers.push(callback);
    };
    this.emit = function(eventType) {
        _this.subscribers.forEach(function(subscriber) {
            return subscriber(eventType, // shallow copy to avoid accidental mutation
            _this.openInstances.slice());
        });
    };
    this.openInstances = [];
    this.subscribers = [];
};
var $e6534f125fec945b$var$portalOpenInstances = new $e6534f125fec945b$var$PortalOpenInstances();
/* eslint-disable no-console */ /* istanbul ignore next */ function $e6534f125fec945b$var$log() {
    console.log("portalOpenInstances ----------");
    console.log($e6534f125fec945b$var$portalOpenInstances.openInstances.length);
    $e6534f125fec945b$var$portalOpenInstances.openInstances.forEach(function(p) {
        return console.log(p);
    });
    console.log("end portalOpenInstances ----------");
}
/* istanbul ignore next */ function $e6534f125fec945b$var$resetState() {
    $e6534f125fec945b$var$portalOpenInstances = new $e6534f125fec945b$var$PortalOpenInstances();
}
/* eslint-enable no-console */ module.exports.default = $e6534f125fec945b$var$portalOpenInstances;

});

parcelRequire.register("a2PGv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resetState = $75022ec7241d3a0d$var$resetState;
module.exports.log = $75022ec7241d3a0d$var$log;

var $jM12I = parcelRequire("jM12I");
var $75022ec7241d3a0d$var$_portalOpenInstances2 = $75022ec7241d3a0d$var$_interopRequireDefault($jM12I);
function $75022ec7241d3a0d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// Body focus trap see Issue #742
var $75022ec7241d3a0d$var$before = void 0, $75022ec7241d3a0d$var$after = void 0, $75022ec7241d3a0d$var$instances = [];
/* eslint-disable no-console */ /* istanbul ignore next */ function $75022ec7241d3a0d$var$resetState() {
    var _arr = [
        $75022ec7241d3a0d$var$before,
        $75022ec7241d3a0d$var$after
    ];
    for(var _i = 0; _i < _arr.length; _i++){
        var item = _arr[_i];
        if (!item) continue;
        item.parentNode && item.parentNode.removeChild(item);
    }
    $75022ec7241d3a0d$var$before = $75022ec7241d3a0d$var$after = null;
    $75022ec7241d3a0d$var$instances = [];
}
/* istanbul ignore next */ function $75022ec7241d3a0d$var$log() {
    console.log("bodyTrap ----------");
    console.log($75022ec7241d3a0d$var$instances.length);
    var _arr2 = [
        $75022ec7241d3a0d$var$before,
        $75022ec7241d3a0d$var$after
    ];
    for(var _i2 = 0; _i2 < _arr2.length; _i2++){
        var item = _arr2[_i2];
        var check = item || {};
        console.log(check.nodeName, check.className, check.id);
    }
    console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */ function $75022ec7241d3a0d$var$focusContent() {
    if ($75022ec7241d3a0d$var$instances.length === 0) return;
    $75022ec7241d3a0d$var$instances[$75022ec7241d3a0d$var$instances.length - 1].focusContent();
}
function $75022ec7241d3a0d$var$bodyTrap(eventType, openInstances) {
    if (!$75022ec7241d3a0d$var$before && !$75022ec7241d3a0d$var$after) {
        $75022ec7241d3a0d$var$before = document.createElement("div");
        $75022ec7241d3a0d$var$before.setAttribute("data-react-modal-body-trap", "");
        $75022ec7241d3a0d$var$before.style.position = "absolute";
        $75022ec7241d3a0d$var$before.style.opacity = "0";
        $75022ec7241d3a0d$var$before.setAttribute("tabindex", "0");
        $75022ec7241d3a0d$var$before.addEventListener("focus", $75022ec7241d3a0d$var$focusContent);
        $75022ec7241d3a0d$var$after = $75022ec7241d3a0d$var$before.cloneNode();
        $75022ec7241d3a0d$var$after.addEventListener("focus", $75022ec7241d3a0d$var$focusContent);
    }
    $75022ec7241d3a0d$var$instances = openInstances;
    if ($75022ec7241d3a0d$var$instances.length > 0) {
        // Add focus trap
        if (document.body.firstChild !== $75022ec7241d3a0d$var$before) document.body.insertBefore($75022ec7241d3a0d$var$before, document.body.firstChild);
        if (document.body.lastChild !== $75022ec7241d3a0d$var$after) document.body.appendChild($75022ec7241d3a0d$var$after);
    } else {
        // Remove focus trap
        if ($75022ec7241d3a0d$var$before.parentElement) $75022ec7241d3a0d$var$before.parentElement.removeChild($75022ec7241d3a0d$var$before);
        if ($75022ec7241d3a0d$var$after.parentElement) $75022ec7241d3a0d$var$after.parentElement.removeChild($75022ec7241d3a0d$var$after);
    }
}
$75022ec7241d3a0d$var$_portalOpenInstances2.default.subscribe($75022ec7241d3a0d$var$bodyTrap);

});


parcelRequire.register("iOeic", function(module, exports) {

$parcel$export(module.exports, "polyfill", function () { return $db17fbaec8ac25b7$export$cea1c58a6db52bca; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $db17fbaec8ac25b7$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $db17fbaec8ac25b7$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $db17fbaec8ac25b7$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$db17fbaec8ac25b7$var$componentWillMount.__suppressDeprecationWarning = true;
$db17fbaec8ac25b7$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$db17fbaec8ac25b7$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $db17fbaec8ac25b7$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
    if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === "function") foundWillMountName = "componentWillMount";
    else if (typeof prototype.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
    if (typeof prototype.componentWillReceiveProps === "function") foundWillReceivePropsName = "componentWillReceiveProps";
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
    if (typeof prototype.componentWillUpdate === "function") foundWillUpdateName = "componentWillUpdate";
    else if (typeof prototype.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\n" + "https://fb.me/react-async-component-lifecycle-hooks");
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === "function") {
        prototype.componentWillMount = $db17fbaec8ac25b7$var$componentWillMount;
        prototype.componentWillReceiveProps = $db17fbaec8ac25b7$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === "function") {
        if (typeof prototype.componentDidUpdate !== "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        prototype.componentWillUpdate = $db17fbaec8ac25b7$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

});



parcelRequire.register("jGWQ4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2591439018ac5554$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "LinkButton", function () { return $2591439018ac5554$export$29d11c0fe2fc51d8; });

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $6bq3s = parcelRequire("6bq3s");

var $k9Oeh = parcelRequire("k9Oeh");

var $4ZcUR = parcelRequire("4ZcUR");

var $7kooT = parcelRequire("7kooT");

var $66ixW = parcelRequire("66ixW");

var $8Dzml = parcelRequire("8Dzml");
function $2591439018ac5554$var$Button({ htmlType: htmlType = "button", type: type = "default", size: size = "medium", title: title, icon: icon, className: className, isLoading: isLoading = false, loadingDelay: loadingDelay = 500, trailingIcon: trailingIcon, disabled: disabled, ...rest }, buttonRef) {
    const [showSpinner, setShowSpinner] = (0, $jC8Vy.useState)(false);
    const timerRef = (0, $jC8Vy.useRef)();
    (0, $jC8Vy.useEffect)(()=>{
        // Delay showing the spinner after 'loadingDelay' milliseconds
        if (isLoading) // eslint-disable-next-line @silverhand/fp/no-mutation
        timerRef.current = window.setTimeout(()=>{
            setShowSpinner(true);
        }, loadingDelay);
        return ()=>{
            clearTimeout(timerRef.current);
            setShowSpinner(false);
        };
    }, [
        isLoading,
        loadingDelay
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("button", {
        ref: buttonRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($8Dzml.button, $8Dzml[type], $8Dzml[size], icon && $8Dzml.withIcon, isLoading && $8Dzml.loading, className),
        type: htmlType,
        disabled: isLoading || disabled,
        ...rest,
        children: [
            showSpinner && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $k9Oeh.Ring), {
                className: $8Dzml.spinner
            }),
            icon && /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                className: $8Dzml.icon,
                children: icon
            }),
            title && (typeof title === "string" ? /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                    forKey: title
                })
            }) : title),
            trailingIcon && /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                className: $8Dzml.trailingIcon,
                children: trailingIcon
            })
        ]
    });
}
var $2591439018ac5554$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $jC8Vy.forwardRef)($2591439018ac5554$var$Button);
function $2591439018ac5554$export$29d11c0fe2fc51d8({ title: title, type: type = "default", size: size = "medium", className: className, href: href, targetBlank: targetBlank, ...rest }) {
    const { getTo: getTo } = (0, $4ZcUR.default)();
    const props = (0, $jC8Vy.useMemo)(()=>({
            ...rest,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($8Dzml.button, $8Dzml[type], $8Dzml[size], className),
            ...Boolean(targetBlank) && {
                rel: typeof targetBlank === "string" ? targetBlank : "noopener noreferrer",
                target: "_blank"
            }
        }), [
        className,
        rest,
        size,
        targetBlank,
        type
    ]);
    const innerElement = (0, $jC8Vy.useMemo)(()=>typeof title === "string" ? /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                forKey: title
            })
        }) : title, [
        title
    ]);
    return !href || (0, $7kooT.isAbsoluteUrl)(href) ? /*#__PURE__*/ (0, $C7mD2.jsx)("a", {
        ...props,
        href: href,
        children: innerElement
    }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6bq3s.Link), {
        ...props,
        to: getTo(href),
        children: innerElement
    });
}

});
parcelRequire.register("k9Oeh", function(module, exports) {

$parcel$export(module.exports, "Ring", function () { return $621ab39b8b2c89d9$export$a6e3577650b6d6d7; });
$parcel$export(module.exports, "Daisy", function () { return $621ab39b8b2c89d9$export$9a60c84efaf62b31; });

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $3EArU = parcelRequire("3EArU");
function $621ab39b8b2c89d9$export$a6e3577650b6d6d7({ className: className }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($3EArU.ring, className),
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M9.33566 14.8714C9.44104 15.4135 9.08652 15.9451 8.53547 15.9821C7.4048 16.0579 6.2669 15.8929 5.19834 15.4934C3.81639 14.9767 2.60425 14.0879 1.69591 12.9253C0.78758 11.7627 0.218443 10.3715 0.0514252 8.90563C-0.115592 7.43973 0.126015 5.9562 0.749537 4.61905C1.37306 3.28191 2.35421 2.14323 3.5845 1.32891C4.8148 0.514598 6.24632 0.0563637 7.7208 0.00487344C9.19528 -0.0466168 10.6553 0.310643 11.9394 1.03715C12.9323 1.59891 13.7901 2.36452 14.4588 3.27942C14.7847 3.72531 14.6054 4.33858 14.1223 4.60633C13.6393 4.87408 13.0366 4.69278 12.6924 4.26086C12.2154 3.66218 11.6262 3.15785 10.9545 2.77787C9.99146 2.23298 8.89646 1.96504 7.7906 2.00366C6.68474 2.04227 5.6111 2.38595 4.68838 2.99669C3.76565 3.60742 3.02979 4.46143 2.56215 5.46429C2.09451 6.46715 1.91331 7.5798 2.03857 8.67922C2.16383 9.77864 2.59069 10.822 3.27194 11.694C3.95319 12.5659 4.8623 13.2325 5.89876 13.62C6.62154 13.8903 7.38663 14.0175 8.15188 13.9981C8.70399 13.9841 9.23028 14.3293 9.33566 14.8714Z",
            fill: "currentColor"
        })
    });
}
function $621ab39b8b2c89d9$export$9a60c84efaf62b31({ className: className }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($3EArU.daisy, className),
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                opacity: "0.48",
                x: "15",
                width: "2",
                height: "8",
                rx: "1",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                opacity: "0.96",
                x: "15",
                y: "24",
                width: "2",
                height: "8",
                rx: "1",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                opacity: "0.72",
                y: "17",
                width: "2",
                height: "8",
                rx: "1",
                transform: "rotate(-90 0 17)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                opacity: "0.24",
                x: "24",
                y: "17",
                width: "2",
                height: "8",
                rx: "1",
                transform: "rotate(-90 24 17)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                opacity: "0.32",
                x: "29.3564",
                y: "7.13403",
                width: "2",
                height: "8",
                rx: "1",
                transform: "rotate(60 29.3564 7.13403)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                opacity: "0.8",
                x: "8.57227",
                y: "19.134",
                width: "2",
                height: "8",
                rx: "1",
                transform: "rotate(60 8.57227 19.134)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                opacity: "0.64",
                x: "1.64355",
                y: "8.86597",
                width: "2",
                height: "8",
                rx: "1",
                transform: "rotate(-60 1.64355 8.86597)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                opacity: "0.16",
                x: "22.4277",
                y: "20.866",
                width: "2",
                height: "8",
                rx: "1",
                transform: "rotate(-60 22.4277 20.866)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                opacity: "0.4",
                x: "23.1338",
                y: "1.64355",
                width: "2",
                height: "8",
                rx: "1",
                transform: "rotate(30 23.1338 1.64355)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                opacity: "0.88",
                x: "11.1338",
                y: "22.4282",
                width: "2",
                height: "8",
                rx: "1",
                transform: "rotate(30 11.1338 22.4282)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                opacity: "0.56",
                x: "7.13379",
                y: "2.64355",
                width: "2",
                height: "8",
                rx: "1",
                transform: "rotate(-30 7.13379 2.64355)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                opacity: "0.08",
                x: "19.1338",
                y: "23.4282",
                width: "2",
                height: "8",
                rx: "1",
                transform: "rotate(-30 19.1338 23.4282)",
                fill: "currentColor"
            })
        ]
    });
}

});
parcelRequire.register("3EArU", function(module, exports) {

$parcel$export(module.exports, "daisy", function () { return $2a91618fb15e5f9a$export$7a08098a941a19df; }, function (v) { return $2a91618fb15e5f9a$export$7a08098a941a19df = v; });
$parcel$export(module.exports, "ring", function () { return $2a91618fb15e5f9a$export$e7d0da6968da5dd; }, function (v) { return $2a91618fb15e5f9a$export$e7d0da6968da5dd = v; });
$parcel$export(module.exports, "rotating", function () { return $2a91618fb15e5f9a$export$bfd64c937657f93a; }, function (v) { return $2a91618fb15e5f9a$export$bfd64c937657f93a = v; });
var $2a91618fb15e5f9a$export$7a08098a941a19df;
var $2a91618fb15e5f9a$export$e7d0da6968da5dd;
var $2a91618fb15e5f9a$export$bfd64c937657f93a;
var $2a91618fb15e5f9a$export$4a6dd88bada4e7d2;
$2a91618fb15e5f9a$export$7a08098a941a19df = `pXtXgq_daisy`;
$2a91618fb15e5f9a$export$e7d0da6968da5dd = `pXtXgq_ring`;
$2a91618fb15e5f9a$export$bfd64c937657f93a = `pXtXgq_rotating`;
$2a91618fb15e5f9a$export$bfd64c937657f93a;
$2a91618fb15e5f9a$export$4a6dd88bada4e7d2 = `pXtXgq_shimmer`;

});


parcelRequire.register("4ZcUR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da1cc6df936a8e19$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $fjAdn = parcelRequire("fjAdn");
parcelRequire("12bMu");
var $gcHb7 = parcelRequire("gcHb7");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("2Phw0");
var $4szZx = parcelRequire("4szZx");parcelRequire("6bq3s");
var $2Phw0 = parcelRequire("2Phw0");

var $8TpMk = parcelRequire("8TpMk");

var $cDKfs = parcelRequire("cDKfs");
/**
 * Returns a `TenantPathname` object that contains utilities for matching
 * and generating tenant-specific pathnames.
 *
 * @see {@link TenantPathname}
 */ function $da1cc6df936a8e19$var$useTenantPathname() {
    const location = (0, $2Phw0.useLocation)();
    const { currentTenantId: currentTenantId } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const tenantSegment = (0, $jC8Vy.useMemo)(()=>(0, $8TpMk.isCloud) ? currentTenantId : (0, $fjAdn.ossConsolePath).slice(1), [
        currentTenantId
    ]);
    const navigate = (0, $2Phw0.useNavigate)();
    const href = (0, $2Phw0.useHref)("/");
    const match = (0, $jC8Vy.useCallback)((pathname, exact = false)=>{
        // Match relative pathnames directly
        if (!pathname.startsWith("/")) return (0, $4szZx.matchPath)((0, $gcHb7.joinPath)(location.pathname, pathname, exact ? "" : "*"), location.pathname) !== null;
        // Match absolute pathnames with the tenant segment
        return (0, $4szZx.matchPath)((0, $gcHb7.joinPath)(":tenantId", pathname, exact ? "" : "*"), location.pathname) !== null;
    }, [
        location.pathname
    ]);
    /** Returns the pathname with the current tenant ID prepended. */ const getPathname = (0, $jC8Vy.useCallback)((pathname)=>{
        if (pathname.startsWith("/") && !pathname.startsWith(`/${tenantSegment}`)) return (0, $gcHb7.joinPath)(tenantSegment, pathname);
        // Directly return the pathname if it's a relative pathname
        return pathname;
    }, [
        tenantSegment
    ]);
    const getTo = (0, $jC8Vy.useCallback)((to)=>{
        if (typeof to === "string") return getPathname(to);
        return {
            ...to,
            pathname: getPathname(to.pathname ?? "")
        };
    }, [
        getPathname
    ]);
    const getUrl = (0, $jC8Vy.useCallback)((pathname = "/")=>(0, $gcHb7.appendPath)(new URL(window.location.origin), href, tenantSegment, pathname), [
        href,
        tenantSegment
    ]);
    const data = (0, $jC8Vy.useMemo)(()=>({
            match: match,
            navigate: (to, options)=>{
                // Navigate to the given index in the history stack
                if (typeof to === "number") {
                    navigate(to);
                    return;
                }
                navigate(getTo(to), options);
            },
            getPathname: getPathname,
            getTo: getTo,
            getUrl: getUrl
        }), [
        match,
        getPathname,
        getTo,
        navigate,
        getUrl
    ]);
    return data;
}
var $da1cc6df936a8e19$export$2e2bcd8739ae039 = $da1cc6df936a8e19$var$useTenantPathname;

});

parcelRequire.register("7kooT", function(module, exports) {

$parcel$export(module.exports, "buildUrl", function () { return $2d184232a0e6ccb1$export$b5cd97dee32de81d; });
$parcel$export(module.exports, "formatSearchKeyword", function () { return $2d184232a0e6ccb1$export$9d3815b1d377c7ae; });
$parcel$export(module.exports, "isInCallback", function () { return $2d184232a0e6ccb1$export$412c684fc323ffe4; });
$parcel$export(module.exports, "isAbsoluteUrl", function () { return $2d184232a0e6ccb1$export$a1cbf2de32a9fd1; });
$parcel$export(module.exports, "dropLeadingSlash", function () { return $2d184232a0e6ccb1$export$89d2b00dec6d70aa; });
parcelRequire("12bMu");
var $3dBAh = parcelRequire("3dBAh");
const $2d184232a0e6ccb1$export$b5cd97dee32de81d = (path, searchParameters)=>`${path}?${new URLSearchParams(searchParameters).toString()}`;
const $2d184232a0e6ccb1$export$9d3815b1d377c7ae = (keyword)=>`%${keyword}%`;
const $2d184232a0e6ccb1$export$412c684fc323ffe4 = ()=>[
        "/callback",
        "-callback"
    ].some((path)=>window.location.pathname.endsWith(path));
const $2d184232a0e6ccb1$export$a1cbf2de32a9fd1 = (url)=>Boolean((0, $3dBAh.trySafe)(()=>url && new URL(url)));
const $2d184232a0e6ccb1$export$89d2b00dec6d70aa = (path)=>path.replace(/^\/+/, "");

});

parcelRequire.register("66ixW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0476178c6e51771$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
function $f0476178c6e51771$export$2e2bcd8739ae039({ forKey: forKey, interpolation: interpolation }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    /**
   * The default return of `t()` is already string even if the given key is not a leaf key.
   * For example:
   *
   * ```ts
   * const translation = { foo: { bar: 'baz' } };
   *
   * t('foo.bar') // 'baz'
   * t('foo') // 'key 'foo (en)' returned an object instead of string.'
   * ```
   *
   * So actually there's no need to check key validity to make sure `t()` returns a string.
   * But it seems the type definition is not correct for the function in `i18next`. Use this trick to
   * bypass for now.
   */ return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $C7mD2.Fragment), {
        children: t(forKey, interpolation ?? {})
    });
}

});

parcelRequire.register("8Dzml", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "branding", function () { return $649d64de56ba3bc6$export$aa1c855dc9a4ab00; }, function (v) { return $649d64de56ba3bc6$export$aa1c855dc9a4ab00 = v; });
$parcel$export(module.exports, "button", function () { return $649d64de56ba3bc6$export$2ba01fb71ed41cb6; }, function (v) { return $649d64de56ba3bc6$export$2ba01fb71ed41cb6 = v; });
$parcel$export(module.exports, "danger", function () { return $649d64de56ba3bc6$export$7c4df8d735fa2705; }, function (v) { return $649d64de56ba3bc6$export$7c4df8d735fa2705 = v; });
$parcel$export(module.exports, "default", function () { return $649d64de56ba3bc6$export$2e2bcd8739ae039; }, function (v) { return $649d64de56ba3bc6$export$2e2bcd8739ae039 = v; });
$parcel$export(module.exports, "icon", function () { return $649d64de56ba3bc6$export$1ca1ec8b29a4ce27; }, function (v) { return $649d64de56ba3bc6$export$1ca1ec8b29a4ce27 = v; });
$parcel$export(module.exports, "large", function () { return $649d64de56ba3bc6$export$f09585a853dddd32; }, function (v) { return $649d64de56ba3bc6$export$f09585a853dddd32 = v; });
$parcel$export(module.exports, "loading", function () { return $649d64de56ba3bc6$export$46c1c92549715335; }, function (v) { return $649d64de56ba3bc6$export$46c1c92549715335 = v; });
$parcel$export(module.exports, "medium", function () { return $649d64de56ba3bc6$export$649ecc744817b5c7; }, function (v) { return $649d64de56ba3bc6$export$649ecc744817b5c7 = v; });
$parcel$export(module.exports, "outline", function () { return $649d64de56ba3bc6$export$f9258c55612cbed7; }, function (v) { return $649d64de56ba3bc6$export$f9258c55612cbed7 = v; });
$parcel$export(module.exports, "primary", function () { return $649d64de56ba3bc6$export$9ad721cf3b3debe0; }, function (v) { return $649d64de56ba3bc6$export$9ad721cf3b3debe0 = v; });
$parcel$export(module.exports, "rotating", function () { return $649d64de56ba3bc6$export$bfd64c937657f93a; }, function (v) { return $649d64de56ba3bc6$export$bfd64c937657f93a = v; });
$parcel$export(module.exports, "shimmer", function () { return $649d64de56ba3bc6$export$4a6dd88bada4e7d2; }, function (v) { return $649d64de56ba3bc6$export$4a6dd88bada4e7d2 = v; });
$parcel$export(module.exports, "small", function () { return $649d64de56ba3bc6$export$3c17b0e969a90510; }, function (v) { return $649d64de56ba3bc6$export$3c17b0e969a90510 = v; });
$parcel$export(module.exports, "spinner", function () { return $649d64de56ba3bc6$export$641374ffb95bc399; }, function (v) { return $649d64de56ba3bc6$export$641374ffb95bc399 = v; });
$parcel$export(module.exports, "text", function () { return $649d64de56ba3bc6$export$6f093cfa640b7166; }, function (v) { return $649d64de56ba3bc6$export$6f093cfa640b7166 = v; });
$parcel$export(module.exports, "trailingIcon", function () { return $649d64de56ba3bc6$export$74dc5dd4e622afa8; }, function (v) { return $649d64de56ba3bc6$export$74dc5dd4e622afa8 = v; });
$parcel$export(module.exports, "violet", function () { return $649d64de56ba3bc6$export$8241b7126941c403; }, function (v) { return $649d64de56ba3bc6$export$8241b7126941c403 = v; });
$parcel$export(module.exports, "withIcon", function () { return $649d64de56ba3bc6$export$5146850fc0ce88d1; }, function (v) { return $649d64de56ba3bc6$export$5146850fc0ce88d1 = v; });
var $649d64de56ba3bc6$export$aa1c855dc9a4ab00;
var $649d64de56ba3bc6$export$2ba01fb71ed41cb6;
var $649d64de56ba3bc6$export$7c4df8d735fa2705;
var $649d64de56ba3bc6$export$2e2bcd8739ae039;
var $649d64de56ba3bc6$export$1ca1ec8b29a4ce27;
var $649d64de56ba3bc6$export$f09585a853dddd32;
var $649d64de56ba3bc6$export$46c1c92549715335;
var $649d64de56ba3bc6$export$649ecc744817b5c7;
var $649d64de56ba3bc6$export$f9258c55612cbed7;
var $649d64de56ba3bc6$export$9ad721cf3b3debe0;
var $649d64de56ba3bc6$export$bfd64c937657f93a;
var $649d64de56ba3bc6$export$4a6dd88bada4e7d2;
var $649d64de56ba3bc6$export$3c17b0e969a90510;
var $649d64de56ba3bc6$export$641374ffb95bc399;
var $649d64de56ba3bc6$export$6f093cfa640b7166;
var $649d64de56ba3bc6$export$74dc5dd4e622afa8;
var $649d64de56ba3bc6$export$8241b7126941c403;
var $649d64de56ba3bc6$export$5146850fc0ce88d1;
$649d64de56ba3bc6$export$aa1c855dc9a4ab00 = `jrMu9W_branding`;
$649d64de56ba3bc6$export$2ba01fb71ed41cb6 = `jrMu9W_button`;
$649d64de56ba3bc6$export$7c4df8d735fa2705 = `jrMu9W_danger`;
$649d64de56ba3bc6$export$2e2bcd8739ae039 = `jrMu9W_default`;
$649d64de56ba3bc6$export$1ca1ec8b29a4ce27 = `jrMu9W_icon`;
$649d64de56ba3bc6$export$f09585a853dddd32 = `jrMu9W_large`;
$649d64de56ba3bc6$export$46c1c92549715335 = `jrMu9W_loading`;
$649d64de56ba3bc6$export$649ecc744817b5c7 = `jrMu9W_medium`;
$649d64de56ba3bc6$export$f9258c55612cbed7 = `jrMu9W_outline`;
$649d64de56ba3bc6$export$9ad721cf3b3debe0 = `jrMu9W_primary`;
$649d64de56ba3bc6$export$bfd64c937657f93a = `jrMu9W_rotating`;
$649d64de56ba3bc6$export$4a6dd88bada4e7d2 = `jrMu9W_shimmer`;
$649d64de56ba3bc6$export$3c17b0e969a90510 = `jrMu9W_small`;
$649d64de56ba3bc6$export$641374ffb95bc399 = `jrMu9W_spinner`;
$649d64de56ba3bc6$export$6f093cfa640b7166 = `jrMu9W_text`;
$649d64de56ba3bc6$export$74dc5dd4e622afa8 = `jrMu9W_trailingIcon`;
$649d64de56ba3bc6$export$8241b7126941c403 = `jrMu9W_violet`;
$649d64de56ba3bc6$export$5146850fc0ce88d1 = `jrMu9W_withIcon`;

});


parcelRequire.register("dW2kG", function(module, exports) {

$parcel$export(module.exports, "content", function () { return $a252805689ca7c47$export$a7db06668cad9adb; }, function (v) { return $a252805689ca7c47$export$a7db06668cad9adb = v; });
$parcel$export(module.exports, "fullScreen", function () { return $a252805689ca7c47$export$708e76f13b8a286c; }, function (v) { return $a252805689ca7c47$export$708e76f13b8a286c = v; });
$parcel$export(module.exports, "overlay", function () { return $a252805689ca7c47$export$29dd17c7f3c81c36; }, function (v) { return $a252805689ca7c47$export$29dd17c7f3c81c36 = v; });
var $a252805689ca7c47$export$a7db06668cad9adb;
var $a252805689ca7c47$export$708e76f13b8a286c;
var $a252805689ca7c47$export$29dd17c7f3c81c36;
var $a252805689ca7c47$export$bfd64c937657f93a;
var $a252805689ca7c47$export$4a6dd88bada4e7d2;
$a252805689ca7c47$export$a7db06668cad9adb = `uLSymG_content`;
$a252805689ca7c47$export$708e76f13b8a286c = `uLSymG_fullScreen`;
$a252805689ca7c47$export$29dd17c7f3c81c36 = `uLSymG_overlay`;
$a252805689ca7c47$export$bfd64c937657f93a = `uLSymG_rotating`;
$a252805689ca7c47$export$4a6dd88bada4e7d2 = `uLSymG_shimmer`;

});

parcelRequire.register("5vVWy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c6ee93fe6603d1a$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $HHYyb = parcelRequire("HHYyb");

var $gC7hG = parcelRequire("gC7hG");

var $18SWy = parcelRequire("18SWy");

var $75SRw = parcelRequire("75SRw");

var $g8iry = parcelRequire("g8iry");
function $5c6ee93fe6603d1a$var$ModalLayout({ children: children, footer: footer, onClose: onClose, className: className, size: size = "medium", headerIcon: headerIcon, ...cardTitleProps }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($g8iry.container, $g8iry[size]),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $g8iry.header,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $g8iry.iconAndTitle,
                        children: [
                            headerIcon,
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $18SWy.default), {
                                isWordWrapEnabled: true,
                                ...cardTitleProps
                            })
                        ]
                    }),
                    onClose && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                        onClick: ()=>{
                            onClose();
                        },
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $HHYyb.default), {
                            className: $g8iry.closeIcon
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: className,
                children: children
            }),
            footer && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $g8iry.footer,
                children: footer
            })
        ]
    });
}
var $5c6ee93fe6603d1a$export$2e2bcd8739ae039 = $5c6ee93fe6603d1a$var$ModalLayout;

});
parcelRequire.register("HHYyb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5903563ac29b092e$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $5903563ac29b092e$var$SvgClose = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "m13.41 12 6.3-6.29a1.004 1.004 0 0 0-1.42-1.42L12 10.59l-6.29-6.3a1.004 1.004 0 1 0-1.42 1.42l6.3 6.29-6.3 6.29a.999.999 0 0 0 0 1.42 1 1 0 0 0 1.42 0l6.29-6.3 6.29 6.3a1.001 1.001 0 0 0 1.639-.325 1 1 0 0 0-.22-1.095L13.41 12Z",
            fill: "currentColor"
        })
    });
var $5903563ac29b092e$export$2e2bcd8739ae039 = $5903563ac29b092e$var$SvgClose;

});

parcelRequire.register("gC7hG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4ddf74046ac086d$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $lEwhk = parcelRequire("lEwhk");
function $d4ddf74046ac086d$var$Card(props, reference) {
    const { children: children, className: className } = props;
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        ref: reference,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($lEwhk.card, className),
        children: children
    });
}
var $d4ddf74046ac086d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $jC8Vy.forwardRef)($d4ddf74046ac086d$var$Card);

});
parcelRequire.register("lEwhk", function(module, exports) {

$parcel$export(module.exports, "card", function () { return $fc365f3e460a444e$export$aa3e815946b80764; }, function (v) { return $fc365f3e460a444e$export$aa3e815946b80764 = v; });
var $fc365f3e460a444e$export$aa3e815946b80764;
var $fc365f3e460a444e$export$bfd64c937657f93a;
var $fc365f3e460a444e$export$4a6dd88bada4e7d2;
$fc365f3e460a444e$export$aa3e815946b80764 = `_lxpOa_card`;
$fc365f3e460a444e$export$bfd64c937657f93a = `_lxpOa_rotating`;
$fc365f3e460a444e$export$4a6dd88bada4e7d2 = `_lxpOa_shimmer`;

});


parcelRequire.register("18SWy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b8def0628e2cc11$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $fXNOZ = parcelRequire("fXNOZ");

var $8TpMk = parcelRequire("8TpMk");

var $66ixW = parcelRequire("66ixW");

var $9Q3SI = parcelRequire("9Q3SI");

var $ePOvx = parcelRequire("ePOvx");
/**
 * Always use this component to render CardTitle, with built-in i18n support.
 */ function $8b8def0628e2cc11$var$CardTitle({ title: title, subtitle: subtitle, size: size = "large", isWordWrapEnabled: isWordWrapEnabled = false, learnMoreLink: learnMoreLink, className: className, paywall: paywall }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($ePOvx.container, $ePOvx[size], className),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($ePOvx.title, !isWordWrapEnabled && $ePOvx.titleEllipsis),
                children: [
                    typeof title === "string" ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                        forKey: title
                    }) : title,
                    paywall && (0, $8TpMk.isCloud) && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fXNOZ.default), {
                        isVisible: true,
                        plan: paywall
                    })
                ]
            }),
            Boolean(subtitle ?? learnMoreLink) && /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $ePOvx.subtitle,
                children: [
                    subtitle && /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                        children: typeof subtitle === "string" ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: subtitle
                        }) : subtitle
                    }),
                    learnMoreLink?.href && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                                href: learnMoreLink.href,
                                targetBlank: learnMoreLink.targetBlank,
                                children: t("general.learn_more")
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $8b8def0628e2cc11$export$2e2bcd8739ae039 = $8b8def0628e2cc11$var$CardTitle;

});
parcelRequire.register("fXNOZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a657835b7f17eeda$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "BetaTag", function () { return (parcelRequire("c8znl")).default; });

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $cDKfs = parcelRequire("cDKfs");

var $705Mn = parcelRequire("705Mn");

var $c8znl = parcelRequire("c8znl");
/**
 * A tag that indicates whether a feature requires a paid plan.
 *
 * The tag will be visible if `isVisible` is `true`, which means that
 * the tenant's subscription plan has no access to the feature (paywall). However, it will always
 * be visible for dev tenants since they have access to almost all features, and it's useful for
 * developers to know which features need to be paid for in production.
 *
 * CAUTION: You should only render this component when the feature has a paywall.
 *
 * @example
 *
 * ```tsx
 * // In a production tenant, the tag will be visible when there's no access to the feature
 * <FeatureTag isVisible={noAccessToFeature} plan={ReservedPlanId.Pro} />
 *
 * // In a dev tenant, the tag will always be visible even if `isVisible` is `false`
 * <FeatureTag isVisible={false} plan={ReservedPlanId.Pro} />
 *
 * // For conditionally rendering the tag, usually in an iteration on a list which contains
 * // both free and paid features
 * {features.map((feature) => (
 *   hasPaywall(feature) &&
 *     <FeatureTag isVisible={hasAccess(feature)} plan={ReservedPlanId.Hobby} />
 * ))}
 * ```
 */ function $a657835b7f17eeda$var$FeatureTag(props) {
    const { className: className } = props;
    const { isDevTenant: isDevTenant } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { isVisible: isVisible, plan: plan } = props;
    // Dev tenant should always see the tag since they have access to almost all features, and it's
    // useful for developers to know which features need to be paid for in production.
    if (!isDevTenant && !isVisible) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($705Mn.tag, className),
        children: plan
    });
}
var $a657835b7f17eeda$export$2e2bcd8739ae039 = $a657835b7f17eeda$var$FeatureTag;

});
parcelRequire.register("705Mn", function(module, exports) {

$parcel$export(module.exports, "beta", function () { return $518d04219172a9ea$export$7dc96fe8e7fc9104; }, function (v) { return $518d04219172a9ea$export$7dc96fe8e7fc9104 = v; });
$parcel$export(module.exports, "tag", function () { return $518d04219172a9ea$export$2b067c6666111485; }, function (v) { return $518d04219172a9ea$export$2b067c6666111485 = v; });
var $518d04219172a9ea$export$7dc96fe8e7fc9104;
var $518d04219172a9ea$export$bfd64c937657f93a;
var $518d04219172a9ea$export$4a6dd88bada4e7d2;
var $518d04219172a9ea$export$2b067c6666111485;
$518d04219172a9ea$export$7dc96fe8e7fc9104 = `XEcPNG_beta`;
$518d04219172a9ea$export$bfd64c937657f93a = `XEcPNG_rotating`;
$518d04219172a9ea$export$4a6dd88bada4e7d2 = `XEcPNG_shimmer`;
$518d04219172a9ea$export$2b067c6666111485 = `XEcPNG_tag`;

});

parcelRequire.register("c8znl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0145b5620dbd8d75$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $705Mn = parcelRequire("705Mn");
function $0145b5620dbd8d75$var$BetaTag({ className: className }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($705Mn.tag, $705Mn.beta, className),
        children: "Beta"
    });
}
var $0145b5620dbd8d75$export$2e2bcd8739ae039 = $0145b5620dbd8d75$var$BetaTag;

});


parcelRequire.register("9Q3SI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b2e2d6fab14bf96$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $6bq3s = parcelRequire("6bq3s");

var $4ZcUR = parcelRequire("4ZcUR");

var $2P8yH = parcelRequire("2P8yH");
function $3b2e2d6fab14bf96$var$TextLink({ to: to, children: children, icon: icon, isTrailingIcon: isTrailingIcon = false, className: className, targetBlank: targetBlank, ...rest }) {
    const { getTo: getTo } = (0, $4ZcUR.default)();
    const props = (0, $jC8Vy.useMemo)(()=>({
            ...rest,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($2P8yH.link, isTrailingIcon && $2P8yH.trailingIcon, className),
            ...Boolean(targetBlank) && {
                rel: typeof targetBlank === "string" ? targetBlank : "noopener noreferrer",
                target: "_blank"
            }
        }), [
        className,
        isTrailingIcon,
        rest,
        targetBlank
    ]);
    if (to) return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $6bq3s.Link), {
        to: getTo(to),
        ...props,
        children: [
            icon,
            children
        ]
    });
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("a", {
        ...props,
        children: [
            icon,
            children
        ]
    });
}
var $3b2e2d6fab14bf96$export$2e2bcd8739ae039 = $3b2e2d6fab14bf96$var$TextLink;

});
parcelRequire.register("2P8yH", function(module, exports) {

$parcel$export(module.exports, "link", function () { return $20e6fbc8a2f48775$export$9c30223ca0a664fb; }, function (v) { return $20e6fbc8a2f48775$export$9c30223ca0a664fb = v; });
$parcel$export(module.exports, "trailingIcon", function () { return $20e6fbc8a2f48775$export$74dc5dd4e622afa8; }, function (v) { return $20e6fbc8a2f48775$export$74dc5dd4e622afa8 = v; });
var $20e6fbc8a2f48775$export$9c30223ca0a664fb;
var $20e6fbc8a2f48775$export$bfd64c937657f93a;
var $20e6fbc8a2f48775$export$4a6dd88bada4e7d2;
var $20e6fbc8a2f48775$export$74dc5dd4e622afa8;
$20e6fbc8a2f48775$export$9c30223ca0a664fb = `gty49a_link`;
$20e6fbc8a2f48775$export$bfd64c937657f93a = `gty49a_rotating`;
$20e6fbc8a2f48775$export$4a6dd88bada4e7d2 = `gty49a_shimmer`;
$20e6fbc8a2f48775$export$74dc5dd4e622afa8 = `gty49a_trailingIcon`;

});


parcelRequire.register("ePOvx", function(module, exports) {

$parcel$export(module.exports, "container", function () { return $accd01e16f3daa1d$export$34e0f9847d4c02dd; }, function (v) { return $accd01e16f3daa1d$export$34e0f9847d4c02dd = v; });
$parcel$export(module.exports, "large", function () { return $accd01e16f3daa1d$export$f09585a853dddd32; }, function (v) { return $accd01e16f3daa1d$export$f09585a853dddd32 = v; });
$parcel$export(module.exports, "medium", function () { return $accd01e16f3daa1d$export$649ecc744817b5c7; }, function (v) { return $accd01e16f3daa1d$export$649ecc744817b5c7 = v; });
$parcel$export(module.exports, "rotating", function () { return $accd01e16f3daa1d$export$bfd64c937657f93a; }, function (v) { return $accd01e16f3daa1d$export$bfd64c937657f93a = v; });
$parcel$export(module.exports, "shimmer", function () { return $accd01e16f3daa1d$export$4a6dd88bada4e7d2; }, function (v) { return $accd01e16f3daa1d$export$4a6dd88bada4e7d2 = v; });
$parcel$export(module.exports, "small", function () { return $accd01e16f3daa1d$export$3c17b0e969a90510; }, function (v) { return $accd01e16f3daa1d$export$3c17b0e969a90510 = v; });
$parcel$export(module.exports, "subtitle", function () { return $accd01e16f3daa1d$export$c96745152eb2740f; }, function (v) { return $accd01e16f3daa1d$export$c96745152eb2740f = v; });
$parcel$export(module.exports, "title", function () { return $accd01e16f3daa1d$export$fb184b623420d9be; }, function (v) { return $accd01e16f3daa1d$export$fb184b623420d9be = v; });
$parcel$export(module.exports, "titleEllipsis", function () { return $accd01e16f3daa1d$export$4cb77ab59beb2e4f; }, function (v) { return $accd01e16f3daa1d$export$4cb77ab59beb2e4f = v; });
var $accd01e16f3daa1d$export$34e0f9847d4c02dd;
var $accd01e16f3daa1d$export$f09585a853dddd32;
var $accd01e16f3daa1d$export$649ecc744817b5c7;
var $accd01e16f3daa1d$export$bfd64c937657f93a;
var $accd01e16f3daa1d$export$4a6dd88bada4e7d2;
var $accd01e16f3daa1d$export$3c17b0e969a90510;
var $accd01e16f3daa1d$export$c96745152eb2740f;
var $accd01e16f3daa1d$export$fb184b623420d9be;
var $accd01e16f3daa1d$export$4cb77ab59beb2e4f;
$accd01e16f3daa1d$export$34e0f9847d4c02dd = `u3lpsW_container`;
$accd01e16f3daa1d$export$f09585a853dddd32 = `u3lpsW_large`;
$accd01e16f3daa1d$export$649ecc744817b5c7 = `u3lpsW_medium`;
$accd01e16f3daa1d$export$bfd64c937657f93a = `u3lpsW_rotating`;
$accd01e16f3daa1d$export$4a6dd88bada4e7d2 = `u3lpsW_shimmer`;
$accd01e16f3daa1d$export$3c17b0e969a90510 = `u3lpsW_small`;
$accd01e16f3daa1d$export$c96745152eb2740f = `u3lpsW_subtitle`;
$accd01e16f3daa1d$export$fb184b623420d9be = `u3lpsW_title`;
$accd01e16f3daa1d$export$4cb77ab59beb2e4f = `u3lpsW_titleEllipsis`;

});


parcelRequire.register("75SRw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9da6799f8c5aadd$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $aVUks = parcelRequire("aVUks");
function $f9da6799f8c5aadd$var$IconButton({ size: size = "medium", children: children, className: className, iconClassName: iconClassName, ...rest }, reference) {
    const tipRef = (0, $jC8Vy.useRef)(null);
    return /*#__PURE__*/ (0, $C7mD2.jsx)("button", {
        ref: reference,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($aVUks.button, $aVUks[size], className),
        ...rest,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
            ref: tipRef,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($aVUks.icon, iconClassName),
            children: children
        })
    });
}
var $f9da6799f8c5aadd$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $jC8Vy.forwardRef)($f9da6799f8c5aadd$var$IconButton);

});
parcelRequire.register("aVUks", function(module, exports) {

$parcel$export(module.exports, "button", function () { return $7f5aec01430fe67b$export$2ba01fb71ed41cb6; }, function (v) { return $7f5aec01430fe67b$export$2ba01fb71ed41cb6 = v; });
$parcel$export(module.exports, "icon", function () { return $7f5aec01430fe67b$export$1ca1ec8b29a4ce27; }, function (v) { return $7f5aec01430fe67b$export$1ca1ec8b29a4ce27 = v; });
$parcel$export(module.exports, "large", function () { return $7f5aec01430fe67b$export$f09585a853dddd32; }, function (v) { return $7f5aec01430fe67b$export$f09585a853dddd32 = v; });
$parcel$export(module.exports, "medium", function () { return $7f5aec01430fe67b$export$649ecc744817b5c7; }, function (v) { return $7f5aec01430fe67b$export$649ecc744817b5c7 = v; });
$parcel$export(module.exports, "rotating", function () { return $7f5aec01430fe67b$export$bfd64c937657f93a; }, function (v) { return $7f5aec01430fe67b$export$bfd64c937657f93a = v; });
$parcel$export(module.exports, "shimmer", function () { return $7f5aec01430fe67b$export$4a6dd88bada4e7d2; }, function (v) { return $7f5aec01430fe67b$export$4a6dd88bada4e7d2 = v; });
$parcel$export(module.exports, "small", function () { return $7f5aec01430fe67b$export$3c17b0e969a90510; }, function (v) { return $7f5aec01430fe67b$export$3c17b0e969a90510 = v; });
var $7f5aec01430fe67b$export$2ba01fb71ed41cb6;
var $7f5aec01430fe67b$export$1ca1ec8b29a4ce27;
var $7f5aec01430fe67b$export$f09585a853dddd32;
var $7f5aec01430fe67b$export$649ecc744817b5c7;
var $7f5aec01430fe67b$export$bfd64c937657f93a;
var $7f5aec01430fe67b$export$4a6dd88bada4e7d2;
var $7f5aec01430fe67b$export$3c17b0e969a90510;
$7f5aec01430fe67b$export$2ba01fb71ed41cb6 = `nDPQTW_button`;
$7f5aec01430fe67b$export$1ca1ec8b29a4ce27 = `nDPQTW_icon`;
$7f5aec01430fe67b$export$f09585a853dddd32 = `nDPQTW_large`;
$7f5aec01430fe67b$export$649ecc744817b5c7 = `nDPQTW_medium`;
$7f5aec01430fe67b$export$bfd64c937657f93a = `nDPQTW_rotating`;
$7f5aec01430fe67b$export$4a6dd88bada4e7d2 = `nDPQTW_shimmer`;
$7f5aec01430fe67b$export$3c17b0e969a90510 = `nDPQTW_small`;

});


parcelRequire.register("g8iry", function(module, exports) {

$parcel$export(module.exports, "closeIcon", function () { return $bbebb3270a302ea0$export$64a53ecd158b85c4; }, function (v) { return $bbebb3270a302ea0$export$64a53ecd158b85c4 = v; });
$parcel$export(module.exports, "container", function () { return $bbebb3270a302ea0$export$34e0f9847d4c02dd; }, function (v) { return $bbebb3270a302ea0$export$34e0f9847d4c02dd = v; });
$parcel$export(module.exports, "footer", function () { return $bbebb3270a302ea0$export$adb608be33961c98; }, function (v) { return $bbebb3270a302ea0$export$adb608be33961c98 = v; });
$parcel$export(module.exports, "header", function () { return $bbebb3270a302ea0$export$38e42c68cf43b5d4; }, function (v) { return $bbebb3270a302ea0$export$38e42c68cf43b5d4 = v; });
$parcel$export(module.exports, "iconAndTitle", function () { return $bbebb3270a302ea0$export$92e105a06b80aeff; }, function (v) { return $bbebb3270a302ea0$export$92e105a06b80aeff = v; });
$parcel$export(module.exports, "large", function () { return $bbebb3270a302ea0$export$f09585a853dddd32; }, function (v) { return $bbebb3270a302ea0$export$f09585a853dddd32 = v; });
$parcel$export(module.exports, "medium", function () { return $bbebb3270a302ea0$export$649ecc744817b5c7; }, function (v) { return $bbebb3270a302ea0$export$649ecc744817b5c7 = v; });
$parcel$export(module.exports, "rotating", function () { return $bbebb3270a302ea0$export$bfd64c937657f93a; }, function (v) { return $bbebb3270a302ea0$export$bfd64c937657f93a = v; });
$parcel$export(module.exports, "shimmer", function () { return $bbebb3270a302ea0$export$4a6dd88bada4e7d2; }, function (v) { return $bbebb3270a302ea0$export$4a6dd88bada4e7d2 = v; });
$parcel$export(module.exports, "xlarge", function () { return $bbebb3270a302ea0$export$bb57e550b957ab; }, function (v) { return $bbebb3270a302ea0$export$bb57e550b957ab = v; });
var $bbebb3270a302ea0$export$64a53ecd158b85c4;
var $bbebb3270a302ea0$export$34e0f9847d4c02dd;
var $bbebb3270a302ea0$export$adb608be33961c98;
var $bbebb3270a302ea0$export$38e42c68cf43b5d4;
var $bbebb3270a302ea0$export$92e105a06b80aeff;
var $bbebb3270a302ea0$export$f09585a853dddd32;
var $bbebb3270a302ea0$export$649ecc744817b5c7;
var $bbebb3270a302ea0$export$bfd64c937657f93a;
var $bbebb3270a302ea0$export$4a6dd88bada4e7d2;
var $bbebb3270a302ea0$export$bb57e550b957ab;
$bbebb3270a302ea0$export$64a53ecd158b85c4 = `tG7Whq_closeIcon`;
$bbebb3270a302ea0$export$34e0f9847d4c02dd = `tG7Whq_container`;
$bbebb3270a302ea0$export$adb608be33961c98 = `tG7Whq_footer`;
$bbebb3270a302ea0$export$38e42c68cf43b5d4 = `tG7Whq_header`;
$bbebb3270a302ea0$export$92e105a06b80aeff = `tG7Whq_iconAndTitle`;
$bbebb3270a302ea0$export$f09585a853dddd32 = `tG7Whq_large`;
$bbebb3270a302ea0$export$649ecc744817b5c7 = `tG7Whq_medium`;
$bbebb3270a302ea0$export$bfd64c937657f93a = `tG7Whq_rotating`;
$bbebb3270a302ea0$export$4a6dd88bada4e7d2 = `tG7Whq_shimmer`;
$bbebb3270a302ea0$export$bb57e550b957ab = `tG7Whq_xlarge`;

});


parcelRequire.register("4fYFM", function(module, exports) {

$parcel$export(module.exports, "content", function () { return $3197a0811cf5283e$export$a7db06668cad9adb; }, function (v) { return $3197a0811cf5283e$export$a7db06668cad9adb = v; });
$parcel$export(module.exports, "overlay", function () { return $3197a0811cf5283e$export$29dd17c7f3c81c36; }, function (v) { return $3197a0811cf5283e$export$29dd17c7f3c81c36 = v; });
var $3197a0811cf5283e$export$a7db06668cad9adb;
var $3197a0811cf5283e$export$29dd17c7f3c81c36;
var $3197a0811cf5283e$export$bfd64c937657f93a;
var $3197a0811cf5283e$export$4a6dd88bada4e7d2;
$3197a0811cf5283e$export$a7db06668cad9adb = `neT2BG_content`;
$3197a0811cf5283e$export$29dd17c7f3c81c36 = `neT2BG_overlay`;
$3197a0811cf5283e$export$bfd64c937657f93a = `neT2BG_rotating`;
$3197a0811cf5283e$export$4a6dd88bada4e7d2 = `neT2BG_shimmer`;

});




parcelRequire.register("azCDQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cdbffb066c7dc690$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $fjAdn = parcelRequire("fjAdn");
parcelRequire("12bMu");
var $gcHb7 = parcelRequire("gcHb7");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("6bq3s");
var $2Phw0 = parcelRequire("2Phw0");

var $8TpMk = parcelRequire("8TpMk");
/**
 * The hook that returns the absolute URL for the sign-in or sign-out callback.
 * The path is not related to react-router, which means the path will also include
 * the basename of react-router if it's set.
 */ const $cdbffb066c7dc690$var$useRedirectUri = (flow = "signIn")=>{
    const path = (0, $2Phw0.useHref)((0, $gcHb7.joinPath)(...(0, $7oDSS.conditionalArray)(!(0, $8TpMk.isCloud) && (0, $fjAdn.ossConsolePath), flow === "signIn" ? "/callback" : "/")));
    const url = (0, $jC8Vy.useMemo)(()=>new URL(path, window.location.origin), [
        path
    ]);
    return url;
};
var $cdbffb066c7dc690$export$2e2bcd8739ae039 = $cdbffb066c7dc690$var$useRedirectUri;

});


parcelRequire.register("bawJt", function(module, exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */ 
function $821a04da013dcf17$var$setup(env) {
    createDebug.debug = createDebug;
    createDebug.default = createDebug;
    createDebug.coerce = coerce;
    createDebug.disable = disable;
    createDebug.enable = enable;
    createDebug.enabled = enabled;
    createDebug.humanize = (parcelRequire("8y3nK"));
    createDebug.destroy = destroy;
    Object.keys(env).forEach((key)=>{
        createDebug[key] = env[key];
    });
    /**
	* The currently active debug mode names, and names to skip.
	*/ createDebug.names = [];
    createDebug.skips = [];
    /**
	* Map of special "%n" handling functions, for the debug "format" argument.
	*
	* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	*/ createDebug.formatters = {};
    /**
	* Selects a color for a debug namespace
	* @param {String} namespace The namespace string for the debug instance to be colored
	* @return {Number|String} An ANSI color code for the given namespace
	* @api private
	*/ function selectColor(namespace) {
        let hash = 0;
        for(let i = 0; i < namespace.length; i++){
            hash = (hash << 5) - hash + namespace.charCodeAt(i);
            hash |= 0; // Convert to 32bit integer
        }
        return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
    }
    createDebug.selectColor = selectColor;
    /**
	* Create a debugger with the given `namespace`.
	*
	* @param {String} namespace
	* @return {Function}
	* @api public
	*/ function createDebug(namespace) {
        let prevTime;
        let enableOverride = null;
        let namespacesCache;
        let enabledCache;
        function debug(...args) {
            // Disabled?
            if (!debug.enabled) return;
            const self = debug;
            // Set `diff` timestamp
            const curr = Number(new Date());
            const ms = curr - (prevTime || curr);
            self.diff = ms;
            self.prev = prevTime;
            self.curr = curr;
            prevTime = curr;
            args[0] = createDebug.coerce(args[0]);
            if (typeof args[0] !== "string") // Anything else let's inspect with %O
            args.unshift("%O");
            // Apply any `formatters` transformations
            let index = 0;
            args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format)=>{
                // If we encounter an escaped % then don't increase the array index
                if (match === "%%") return "%";
                index++;
                const formatter = createDebug.formatters[format];
                if (typeof formatter === "function") {
                    const val = args[index];
                    match = formatter.call(self, val);
                    // Now we need to remove `args[index]` since it's inlined in the `format`
                    args.splice(index, 1);
                    index--;
                }
                return match;
            });
            // Apply env-specific formatting (colors, etc.)
            createDebug.formatArgs.call(self, args);
            const logFn = self.log || createDebug.log;
            logFn.apply(self, args);
        }
        debug.namespace = namespace;
        debug.useColors = createDebug.useColors();
        debug.color = createDebug.selectColor(namespace);
        debug.extend = extend;
        debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.
        Object.defineProperty(debug, "enabled", {
            enumerable: true,
            configurable: false,
            get: ()=>{
                if (enableOverride !== null) return enableOverride;
                if (namespacesCache !== createDebug.namespaces) {
                    namespacesCache = createDebug.namespaces;
                    enabledCache = createDebug.enabled(namespace);
                }
                return enabledCache;
            },
            set: (v)=>{
                enableOverride = v;
            }
        });
        // Env-specific initialization logic for debug instances
        if (typeof createDebug.init === "function") createDebug.init(debug);
        return debug;
    }
    function extend(namespace, delimiter) {
        const newDebug = createDebug(this.namespace + (typeof delimiter === "undefined" ? ":" : delimiter) + namespace);
        newDebug.log = this.log;
        return newDebug;
    }
    /**
	* Enables a debug mode by namespaces. This can include modes
	* separated by a colon and wildcards.
	*
	* @param {String} namespaces
	* @api public
	*/ function enable(namespaces) {
        createDebug.save(namespaces);
        createDebug.namespaces = namespaces;
        createDebug.names = [];
        createDebug.skips = [];
        let i;
        const split = (typeof namespaces === "string" ? namespaces : "").split(/[\s,]+/);
        const len = split.length;
        for(i = 0; i < len; i++){
            if (!split[i]) continue;
            namespaces = split[i].replace(/\*/g, ".*?");
            if (namespaces[0] === "-") createDebug.skips.push(new RegExp("^" + namespaces.slice(1) + "$"));
            else createDebug.names.push(new RegExp("^" + namespaces + "$"));
        }
    }
    /**
	* Disable debug output.
	*
	* @return {String} namespaces
	* @api public
	*/ function disable() {
        const namespaces = [
            ...createDebug.names.map(toNamespace),
            ...createDebug.skips.map(toNamespace).map((namespace)=>"-" + namespace)
        ].join(",");
        createDebug.enable("");
        return namespaces;
    }
    /**
	* Returns true if the given mode name is enabled, false otherwise.
	*
	* @param {String} name
	* @return {Boolean}
	* @api public
	*/ function enabled(name) {
        if (name[name.length - 1] === "*") return true;
        let i;
        let len;
        for(i = 0, len = createDebug.skips.length; i < len; i++){
            if (createDebug.skips[i].test(name)) return false;
        }
        for(i = 0, len = createDebug.names.length; i < len; i++){
            if (createDebug.names[i].test(name)) return true;
        }
        return false;
    }
    /**
	* Convert regexp to namespace
	*
	* @param {RegExp} regxep
	* @return {String} namespace
	* @api private
	*/ function toNamespace(regexp) {
        return regexp.toString().substring(2, regexp.toString().length - 2).replace(/\.\*\?$/, "*");
    }
    /**
	* Coerce `val`.
	*
	* @param {Mixed} val
	* @return {Mixed}
	* @api private
	*/ function coerce(val) {
        if (val instanceof Error) return val.stack || val.message;
        return val;
    }
    /**
	* XXX DO NOT USE. This is a temporary stub function.
	* XXX It WILL be removed in the next major release.
	*/ function destroy() {
        console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
    }
    createDebug.enable(createDebug.load());
    return createDebug;
}
module.exports = $821a04da013dcf17$var$setup;

});
parcelRequire.register("8y3nK", function(module, exports) {
/**
 * Helpers.
 */ var $63941f52610dd6d5$var$s = 1000;
var $63941f52610dd6d5$var$m = $63941f52610dd6d5$var$s * 60;
var $63941f52610dd6d5$var$h = $63941f52610dd6d5$var$m * 60;
var $63941f52610dd6d5$var$d = $63941f52610dd6d5$var$h * 24;
var $63941f52610dd6d5$var$w = $63941f52610dd6d5$var$d * 7;
var $63941f52610dd6d5$var$y = $63941f52610dd6d5$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === "string" && val.length > 0) return $63941f52610dd6d5$var$parse(val);
    else if (type === "number" && isFinite(val)) return options.long ? $63941f52610dd6d5$var$fmtLong(val) : $63941f52610dd6d5$var$fmtShort(val);
    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $63941f52610dd6d5$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || "ms").toLowerCase();
    switch(type){
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
            return n * $63941f52610dd6d5$var$y;
        case "weeks":
        case "week":
        case "w":
            return n * $63941f52610dd6d5$var$w;
        case "days":
        case "day":
        case "d":
            return n * $63941f52610dd6d5$var$d;
        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
            return n * $63941f52610dd6d5$var$h;
        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
            return n * $63941f52610dd6d5$var$m;
        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
            return n * $63941f52610dd6d5$var$s;
        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $63941f52610dd6d5$var$fmtShort(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $63941f52610dd6d5$var$d) return Math.round(ms / $63941f52610dd6d5$var$d) + "d";
    if (msAbs >= $63941f52610dd6d5$var$h) return Math.round(ms / $63941f52610dd6d5$var$h) + "h";
    if (msAbs >= $63941f52610dd6d5$var$m) return Math.round(ms / $63941f52610dd6d5$var$m) + "m";
    if (msAbs >= $63941f52610dd6d5$var$s) return Math.round(ms / $63941f52610dd6d5$var$s) + "s";
    return ms + "ms";
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $63941f52610dd6d5$var$fmtLong(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $63941f52610dd6d5$var$d) return $63941f52610dd6d5$var$plural(ms, msAbs, $63941f52610dd6d5$var$d, "day");
    if (msAbs >= $63941f52610dd6d5$var$h) return $63941f52610dd6d5$var$plural(ms, msAbs, $63941f52610dd6d5$var$h, "hour");
    if (msAbs >= $63941f52610dd6d5$var$m) return $63941f52610dd6d5$var$plural(ms, msAbs, $63941f52610dd6d5$var$m, "minute");
    if (msAbs >= $63941f52610dd6d5$var$s) return $63941f52610dd6d5$var$plural(ms, msAbs, $63941f52610dd6d5$var$s, "second");
    return ms + " ms";
}
/**
 * Pluralization helper.
 */ function $63941f52610dd6d5$var$plural(ms, msAbs, n, name) {
    var isPlural = msAbs >= n * 1.5;
    return Math.round(ms / n) + " " + name + (isPlural ? "s" : "");
}

});


parcelRequire.register("codQP", function(module, exports) {

$parcel$export(module.exports, "useFormContext", function () { return $56b6b4b79df10288$export$4d957a5e1be13b03; });
$parcel$export(module.exports, "FormProvider", function () { return $56b6b4b79df10288$export$8ce1ff4f94d08846; });
$parcel$export(module.exports, "useWatch", function () { return $56b6b4b79df10288$export$3c773aa2b84f29e0; });
$parcel$export(module.exports, "useController", function () { return $56b6b4b79df10288$export$e8c786024a2b0a79; });
$parcel$export(module.exports, "Controller", function () { return $56b6b4b79df10288$export$bd0bf19f25da8474; });
$parcel$export(module.exports, "useFieldArray", function () { return $56b6b4b79df10288$export$310131896651d559; });
$parcel$export(module.exports, "useForm", function () { return $56b6b4b79df10288$export$87c0cf8eb5a167e0; });

var $jC8Vy = parcelRequire("jC8Vy");
var $56b6b4b79df10288$var$isCheckBoxInput = (element)=>element.type === "checkbox";
var $56b6b4b79df10288$var$isDateObject = (value1)=>value1 instanceof Date;
var $56b6b4b79df10288$var$isNullOrUndefined = (value1)=>value1 == null;
const $56b6b4b79df10288$var$isObjectType = (value1)=>typeof value1 === "object";
var $56b6b4b79df10288$var$isObject = (value1)=>!$56b6b4b79df10288$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $56b6b4b79df10288$var$isObjectType(value1) && !$56b6b4b79df10288$var$isDateObject(value1);
var $56b6b4b79df10288$var$getEventValue = (event)=>$56b6b4b79df10288$var$isObject(event) && event.target ? $56b6b4b79df10288$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $56b6b4b79df10288$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $56b6b4b79df10288$var$isNameInFieldArray = (names, name)=>names.has($56b6b4b79df10288$var$getNodeParentName(name));
var $56b6b4b79df10288$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $56b6b4b79df10288$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty("isPrototypeOf");
};
var $56b6b4b79df10288$var$isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
function $56b6b4b79df10288$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (!($56b6b4b79df10288$var$isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || $56b6b4b79df10288$var$isObject(data))) {
        copy = isArray ? [] : {};
        if (!Array.isArray(data) && !$56b6b4b79df10288$var$isPlainObject(data)) copy = data;
        else for(const key in data)copy[key] = $56b6b4b79df10288$var$cloneObject(data[key]);
    } else return data;
    return copy;
}
var $56b6b4b79df10288$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $56b6b4b79df10288$var$isUndefined = (val)=>val === undefined;
var $56b6b4b79df10288$export$3988ae62b71be9a3 = (obj, path, defaultValue)=>{
    if (!path || !$56b6b4b79df10288$var$isObject(obj)) return defaultValue;
    const result = $56b6b4b79df10288$var$compact(path.split(/[,[\].]+?/)).reduce((result, key)=>$56b6b4b79df10288$var$isNullOrUndefined(result) ? result : result[key], obj);
    return $56b6b4b79df10288$var$isUndefined(result) || result === obj ? $56b6b4b79df10288$var$isUndefined(obj[path]) ? defaultValue : obj[path] : result;
};
const $56b6b4b79df10288$var$EVENTS = {
    BLUR: "blur",
    FOCUS_OUT: "focusout",
    CHANGE: "change"
};
const $56b6b4b79df10288$var$VALIDATION_MODE = {
    onBlur: "onBlur",
    onChange: "onChange",
    onSubmit: "onSubmit",
    onTouched: "onTouched",
    all: "all"
};
const $56b6b4b79df10288$var$INPUT_VALIDATION_RULES = {
    max: "max",
    min: "min",
    maxLength: "maxLength",
    minLength: "minLength",
    pattern: "pattern",
    required: "required",
    validate: "validate"
};
const $56b6b4b79df10288$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $56b6b4b79df10288$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useContext($56b6b4b79df10288$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useFrom methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $56b6b4b79df10288$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children, ...data } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement($56b6b4b79df10288$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $56b6b4b79df10288$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $56b6b4b79df10288$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $56b6b4b79df10288$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
var $56b6b4b79df10288$var$isEmptyObject = (value1)=>$56b6b4b79df10288$var$isObject(value1) && !Object.keys(value1).length;
var $56b6b4b79df10288$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name, ...formState } = formStateData;
    return $56b6b4b79df10288$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $56b6b4b79df10288$var$VALIDATION_MODE.all));
};
var $56b6b4b79df10288$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $56b6b4b79df10288$var$shouldSubscribeByName = (name, signalName, exact)=>exact && signalName ? name === signalName : !name || !signalName || name === signalName || $56b6b4b79df10288$var$convertToArrayPayload(name).some((currentName)=>currentName && (currentName.startsWith(signalName) || signalName.startsWith(currentName)));
function $56b6b4b79df10288$var$useSubscribe(props) {
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useRef(props);
    _props.current = props;
    (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useEffect(()=>{
        const subscription = !props.disabled && _props.current.subject && _props.current.subject.subscribe({
            next: _props.current.next
        });
        return ()=>{
            subscription && subscription.unsubscribe();
        };
    }, [
        props.disabled
    ]);
}
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $56b6b4b79df10288$export$606f11b2eb45ecc6(props) {
    const methods = $56b6b4b79df10288$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useState(control._formState);
    const _mounted = (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useRef(true);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useRef(name);
    _name.current = name;
    $56b6b4b79df10288$var$useSubscribe({
        disabled: disabled,
        next: (value1)=>_mounted.current && $56b6b4b79df10288$var$shouldSubscribeByName(_name.current, value1.name, exact) && $56b6b4b79df10288$var$shouldRenderFormState(value1, _localProxyFormState.current, control._updateFormState) && updateFormState({
                ...control._formState,
                ...value1
            }),
        subject: control._subjects.state
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useEffect(()=>{
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return ()=>{
            _mounted.current = false;
        };
    }, [
        control
    ]);
    return $56b6b4b79df10288$var$getProxyFormState(formState, control, _localProxyFormState.current, false);
}
var $56b6b4b79df10288$var$isString = (value1)=>typeof value1 === "string";
var $56b6b4b79df10288$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($56b6b4b79df10288$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $56b6b4b79df10288$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $56b6b4b79df10288$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/api/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { watch } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $56b6b4b79df10288$export$3c773aa2b84f29e0(props) {
    const methods = $56b6b4b79df10288$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact } = props || {};
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useRef(name);
    _name.current = name;
    $56b6b4b79df10288$var$useSubscribe({
        disabled: disabled,
        subject: control._subjects.values,
        next: (formState)=>{
            if ($56b6b4b79df10288$var$shouldSubscribeByName(_name.current, formState.name, exact)) updateValue($56b6b4b79df10288$var$cloneObject($56b6b4b79df10288$var$generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
        }
    });
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useState(control._getWatch(name, defaultValue));
    (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useEffect(()=>control._removeUnmounted());
    return value1;
}
var $56b6b4b79df10288$var$isKey = (value1)=>/^\w*$/.test(value1);
var $56b6b4b79df10288$var$stringToPath = (input)=>$56b6b4b79df10288$var$compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
function $56b6b4b79df10288$export$adaa4cf7ef1b65be(object, path, value1) {
    let index = -1;
    const tempPath = $56b6b4b79df10288$var$isKey(path) ? [
        path
    ] : $56b6b4b79df10288$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $56b6b4b79df10288$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $56b6b4b79df10288$export$e8c786024a2b0a79(props) {
    const methods = $56b6b4b79df10288$export$4d957a5e1be13b03();
    const { name: name, control: control = methods.control, shouldUnregister: shouldUnregister } = props;
    const isArrayField = $56b6b4b79df10288$var$isNameInFieldArray(control._names.array, name);
    const value1 = $56b6b4b79df10288$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: $56b6b4b79df10288$export$3988ae62b71be9a3(control._formValues, name, $56b6b4b79df10288$export$3988ae62b71be9a3(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    const formState = $56b6b4b79df10288$export$606f11b2eb45ecc6({
        control: control,
        name: name
    });
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useRef(control.register(name, {
        ...props.rules,
        value: value1
    }));
    (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value1)=>{
            const field = $56b6b4b79df10288$export$3988ae62b71be9a3(control._fields, name);
            if (field) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $56b6b4b79df10288$var$cloneObject($56b6b4b79df10288$export$3988ae62b71be9a3(control._options.defaultValues, name));
            $56b6b4b79df10288$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($56b6b4b79df10288$var$isUndefined($56b6b4b79df10288$export$3988ae62b71be9a3(control._formValues, name))) $56b6b4b79df10288$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    return {
        field: {
            name: name,
            value: value1,
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useCallback((event)=>_registerProps.current.onChange({
                    target: {
                        value: $56b6b4b79df10288$var$getEventValue(event),
                        name: name
                    },
                    type: $56b6b4b79df10288$var$EVENTS.CHANGE
                }), [
                name
            ]),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useCallback(()=>_registerProps.current.onBlur({
                    target: {
                        value: $56b6b4b79df10288$export$3988ae62b71be9a3(control._formValues, name),
                        name: name
                    },
                    type: $56b6b4b79df10288$var$EVENTS.BLUR
                }), [
                name,
                control
            ]),
            ref: (elm)=>{
                const field = $56b6b4b79df10288$export$3988ae62b71be9a3(control._fields, name);
                if (field && elm) field._f.ref = {
                    focus: ()=>elm.focus(),
                    select: ()=>elm.select(),
                    setCustomValidity: (message)=>elm.setCustomValidity(message),
                    reportValidity: ()=>elm.reportValidity()
                };
            }
        },
        formState: formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$56b6b4b79df10288$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$56b6b4b79df10288$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$56b6b4b79df10288$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$56b6b4b79df10288$export$3988ae62b71be9a3(formState.errors, name)
            }
        })
    };
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $56b6b4b79df10288$export$bd0bf19f25da8474 = (props)=>props.render($56b6b4b79df10288$export$e8c786024a2b0a79(props));
var $56b6b4b79df10288$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
const $56b6b4b79df10288$var$focusFieldBy = (fields, callback, fieldsNames)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $56b6b4b79df10288$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f, ...currentField } = field;
            if (_f && callback(_f.name)) {
                if (_f.ref.focus) {
                    _f.ref.focus();
                    break;
                } else if (_f.refs && _f.refs[0].focus) {
                    _f.refs[0].focus();
                    break;
                }
            } else if ($56b6b4b79df10288$var$isObject(currentField)) $56b6b4b79df10288$var$focusFieldBy(currentField, callback);
        }
    }
};
var $56b6b4b79df10288$var$generateId = ()=>{
    const d = typeof performance === "undefined" ? Date.now() : performance.now() * 1000;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $56b6b4b79df10288$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $56b6b4b79df10288$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$56b6b4b79df10288$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : "";
var $56b6b4b79df10288$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $56b6b4b79df10288$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $56b6b4b79df10288$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $56b6b4b79df10288$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $56b6b4b79df10288$var$VALIDATION_MODE.all,
        isOnTouch: mode === $56b6b4b79df10288$var$VALIDATION_MODE.onTouched
    });
var $56b6b4b79df10288$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
var $56b6b4b79df10288$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $56b6b4b79df10288$var$compact($56b6b4b79df10288$export$3988ae62b71be9a3(errors, name));
    $56b6b4b79df10288$export$adaa4cf7ef1b65be(fieldArrayErrors, "root", error[name]);
    $56b6b4b79df10288$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $56b6b4b79df10288$var$isBoolean = (value1)=>typeof value1 === "boolean";
var $56b6b4b79df10288$var$isFileInput = (element)=>element.type === "file";
var $56b6b4b79df10288$var$isFunction = (value1)=>typeof value1 === "function";
var $56b6b4b79df10288$var$isHTMLElement = (value1)=>{
    if (!$56b6b4b79df10288$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $56b6b4b79df10288$var$isMessage = (value1)=>$56b6b4b79df10288$var$isString(value1);
var $56b6b4b79df10288$var$isRadioInput = (element)=>element.type === "radio";
var $56b6b4b79df10288$var$isRegex = (value1)=>value1 instanceof RegExp;
const $56b6b4b79df10288$var$defaultResult = {
    value: false,
    isValid: false
};
const $56b6b4b79df10288$var$validResult = {
    value: true,
    isValid: true
};
var $56b6b4b79df10288$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$56b6b4b79df10288$var$isUndefined(options[0].attributes.value) ? $56b6b4b79df10288$var$isUndefined(options[0].value) || options[0].value === "" ? $56b6b4b79df10288$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $56b6b4b79df10288$var$validResult : $56b6b4b79df10288$var$defaultResult;
    }
    return $56b6b4b79df10288$var$defaultResult;
};
const $56b6b4b79df10288$var$defaultReturn = {
    isValid: false,
    value: null
};
var $56b6b4b79df10288$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $56b6b4b79df10288$var$defaultReturn) : $56b6b4b79df10288$var$defaultReturn;
function $56b6b4b79df10288$var$getValidateError(result, ref, type = "validate") {
    if ($56b6b4b79df10288$var$isMessage(result) || Array.isArray(result) && result.every($56b6b4b79df10288$var$isMessage) || $56b6b4b79df10288$var$isBoolean(result) && !result) return {
        type: type,
        message: $56b6b4b79df10288$var$isMessage(result) ? result : "",
        ref: ref
    };
}
var $56b6b4b79df10288$var$getValueAndMessage = (validationData)=>$56b6b4b79df10288$var$isObject(validationData) && !$56b6b4b79df10288$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ""
    };
var $56b6b4b79df10288$var$validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount, disabled: disabled } = field._f;
    const inputValue = $56b6b4b79df10288$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabled) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($56b6b4b79df10288$var$isBoolean(message) ? "" : message || "");
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $56b6b4b79df10288$var$isRadioInput(ref);
    const isCheckBox = $56b6b4b79df10288$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $56b6b4b79df10288$var$isFileInput(ref)) && $56b6b4b79df10288$var$isUndefined(ref.value) && $56b6b4b79df10288$var$isUndefined(inputValue) || $56b6b4b79df10288$var$isHTMLElement(ref) && ref.value === "" || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $56b6b4b79df10288$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $56b6b4b79df10288$var$INPUT_VALIDATION_RULES.maxLength, minType = $56b6b4b79df10288$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $56b6b4b79df10288$var$isNullOrUndefined(inputValue)) || $56b6b4b79df10288$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$56b6b4b79df10288$var$getCheckboxValue(refs).isValid || isRadio && !$56b6b4b79df10288$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $56b6b4b79df10288$var$isMessage(required) ? {
            value: !!required,
            message: required
        } : $56b6b4b79df10288$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $56b6b4b79df10288$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($56b6b4b79df10288$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$56b6b4b79df10288$var$isNullOrUndefined(min) || !$56b6b4b79df10288$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $56b6b4b79df10288$var$getValueAndMessage(max);
        const minOutput = $56b6b4b79df10288$var$getValueAndMessage(min);
        if (!$56b6b4b79df10288$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$56b6b4b79df10288$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$56b6b4b79df10288$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + " " + time);
            const isTime = ref.type == "time";
            const isWeek = ref.type == "week";
            if ($56b6b4b79df10288$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($56b6b4b79df10288$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $56b6b4b79df10288$var$INPUT_VALIDATION_RULES.max, $56b6b4b79df10288$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($56b6b4b79df10288$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $56b6b4b79df10288$var$getValueAndMessage(maxLength);
        const minLengthOutput = $56b6b4b79df10288$var$getValueAndMessage(minLength);
        const exceedMax = !$56b6b4b79df10288$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$56b6b4b79df10288$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $56b6b4b79df10288$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $56b6b4b79df10288$var$getValueAndMessage(pattern);
        if ($56b6b4b79df10288$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $56b6b4b79df10288$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($56b6b4b79df10288$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($56b6b4b79df10288$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $56b6b4b79df10288$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($56b6b4b79df10288$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($56b6b4b79df10288$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$56b6b4b79df10288$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $56b6b4b79df10288$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$56b6b4b79df10288$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
function $56b6b4b79df10288$var$append(data, value1) {
    return [
        ...data,
        ...$56b6b4b79df10288$var$convertToArrayPayload(value1)
    ];
}
var $56b6b4b79df10288$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $56b6b4b79df10288$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$56b6b4b79df10288$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $56b6b4b79df10288$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($56b6b4b79df10288$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
function $56b6b4b79df10288$var$prepend(data, value1) {
    return [
        ...$56b6b4b79df10288$var$convertToArrayPayload(value1),
        ...$56b6b4b79df10288$var$convertToArrayPayload(data)
    ];
}
function $56b6b4b79df10288$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $56b6b4b79df10288$var$compact(temp).length ? temp : [];
}
var $56b6b4b79df10288$var$removeArrayAt = (data, index)=>$56b6b4b79df10288$var$isUndefined(index) ? [] : $56b6b4b79df10288$var$removeAtIndexes(data, $56b6b4b79df10288$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $56b6b4b79df10288$var$swapArrayAt = (data, indexA, indexB)=>{
    data[indexA] = [
        data[indexB],
        data[indexB] = data[indexA]
    ][0];
};
function $56b6b4b79df10288$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $56b6b4b79df10288$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $56b6b4b79df10288$var$isEmptyArray(obj) {
    for(const key in obj){
        if (!$56b6b4b79df10288$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $56b6b4b79df10288$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $56b6b4b79df10288$var$isKey(path) ? [
        path
    ] : $56b6b4b79df10288$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $56b6b4b79df10288$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($56b6b4b79df10288$var$isObject(childObject) && $56b6b4b79df10288$var$isEmptyObject(childObject) || Array.isArray(childObject) && $56b6b4b79df10288$var$isEmptyArray(childObject))) $56b6b4b79df10288$var$unset(object, paths.slice(0, -1));
    return object;
}
var $56b6b4b79df10288$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $56b6b4b79df10288$export$310131896651d559(props) {
    const methods = $56b6b4b79df10288$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = "id", shouldUnregister: shouldUnregister } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useRef(control._getFieldArray(name).map($56b6b4b79df10288$var$generateId));
    const _fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useRef(fields);
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useRef(name);
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules && control.register(name, props.rules);
    $56b6b4b79df10288$var$useSubscribe({
        next: ({ values: values, name: fieldArrayName })=>{
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = $56b6b4b79df10288$export$3988ae62b71be9a3(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map($56b6b4b79df10288$var$generateId);
                }
            }
        },
        subject: control._subjects.array
    });
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append$1 = (value1, options)=>{
        const appendValue = $56b6b4b79df10288$var$convertToArrayPayload($56b6b4b79df10288$var$cloneObject(value1));
        const updatedFieldArrayValues = $56b6b4b79df10288$var$append(control._getFieldArray(name), appendValue);
        control._names.focus = $56b6b4b79df10288$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $56b6b4b79df10288$var$append(ids.current, appendValue.map($56b6b4b79df10288$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $56b6b4b79df10288$var$append, {
            argA: $56b6b4b79df10288$var$fillEmptyArray(value1)
        });
    };
    const prepend$1 = (value1, options)=>{
        const prependValue = $56b6b4b79df10288$var$convertToArrayPayload($56b6b4b79df10288$var$cloneObject(value1));
        const updatedFieldArrayValues = $56b6b4b79df10288$var$prepend(control._getFieldArray(name), prependValue);
        control._names.focus = $56b6b4b79df10288$var$getFocusFieldName(name, 0, options);
        ids.current = $56b6b4b79df10288$var$prepend(ids.current, prependValue.map($56b6b4b79df10288$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $56b6b4b79df10288$var$prepend, {
            argA: $56b6b4b79df10288$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $56b6b4b79df10288$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $56b6b4b79df10288$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $56b6b4b79df10288$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $56b6b4b79df10288$var$convertToArrayPayload($56b6b4b79df10288$var$cloneObject(value1));
        const updatedFieldArrayValues = $56b6b4b79df10288$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $56b6b4b79df10288$var$getFocusFieldName(name, index, options);
        ids.current = $56b6b4b79df10288$var$insert(ids.current, index, insertValue.map($56b6b4b79df10288$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $56b6b4b79df10288$var$insert, {
            argA: index,
            argB: $56b6b4b79df10288$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $56b6b4b79df10288$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $56b6b4b79df10288$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $56b6b4b79df10288$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $56b6b4b79df10288$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $56b6b4b79df10288$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $56b6b4b79df10288$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $56b6b4b79df10288$var$cloneObject(value1);
        const updatedFieldArrayValues = $56b6b4b79df10288$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $56b6b4b79df10288$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, updatedFieldArrayValues, $56b6b4b79df10288$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $56b6b4b79df10288$var$convertToArrayPayload($56b6b4b79df10288$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($56b6b4b79df10288$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useEffect(()=>{
        control._state.action = false;
        $56b6b4b79df10288$var$isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!$56b6b4b79df10288$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted)) {
            if (control._options.resolver) control._executeSchema([
                name
            ]).then((result)=>{
                const error = $56b6b4b79df10288$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $56b6b4b79df10288$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type : error && error.type) {
                    error ? $56b6b4b79df10288$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $56b6b4b79df10288$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $56b6b4b79df10288$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f) $56b6b4b79df10288$var$validateField(field, control._formValues, control._options.criteriaMode === $56b6b4b79df10288$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$56b6b4b79df10288$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $56b6b4b79df10288$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.values.next({
            name: name,
            values: {
                ...control._formValues
            }
        });
        control._names.focus && $56b6b4b79df10288$var$focusFieldBy(control._fields, (key)=>!!key && key.startsWith(control._names.focus || ""));
        control._names.focus = "";
        control._updateValid();
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useEffect(()=>{
        !$56b6b4b79df10288$export$3988ae62b71be9a3(control._formValues, name) && control._updateFieldArray(name);
        return ()=>{
            (control._options.shouldUnregister || shouldUnregister) && control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useCallback(prepend$1, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useCallback(append$1, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $56b6b4b79df10288$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
function $56b6b4b79df10288$var$createSubject() {
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
}
var $56b6b4b79df10288$var$isPrimitive = (value1)=>$56b6b4b79df10288$var$isNullOrUndefined(value1) || !$56b6b4b79df10288$var$isObjectType(value1);
function $56b6b4b79df10288$var$deepEqual(object1, object2) {
    if ($56b6b4b79df10288$var$isPrimitive(object1) || $56b6b4b79df10288$var$isPrimitive(object2)) return object1 === object2;
    if ($56b6b4b79df10288$var$isDateObject(object1) && $56b6b4b79df10288$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== "ref") {
            const val2 = object2[key];
            if ($56b6b4b79df10288$var$isDateObject(val1) && $56b6b4b79df10288$var$isDateObject(val2) || $56b6b4b79df10288$var$isObject(val1) && $56b6b4b79df10288$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$56b6b4b79df10288$var$deepEqual(val1, val2) : val1 !== val2) return false;
        }
    }
    return true;
}
var $56b6b4b79df10288$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $56b6b4b79df10288$var$isRadioOrCheckbox = (ref)=>$56b6b4b79df10288$var$isRadioInput(ref) || $56b6b4b79df10288$var$isCheckBoxInput(ref);
var $56b6b4b79df10288$var$live = (ref)=>$56b6b4b79df10288$var$isHTMLElement(ref) && ref.isConnected;
var $56b6b4b79df10288$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($56b6b4b79df10288$var$isFunction(data[key])) return true;
    }
    return false;
};
function $56b6b4b79df10288$var$markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if ($56b6b4b79df10288$var$isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || $56b6b4b79df10288$var$isObject(data[key]) && !$56b6b4b79df10288$var$objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $56b6b4b79df10288$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$56b6b4b79df10288$var$isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $56b6b4b79df10288$var$getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if ($56b6b4b79df10288$var$isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || $56b6b4b79df10288$var$isObject(data[key]) && !$56b6b4b79df10288$var$objectHasFunction(data[key])) {
            if ($56b6b4b79df10288$var$isUndefined(formValues) || $56b6b4b79df10288$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? $56b6b4b79df10288$var$markFieldsDirty(data[key], []) : {
                ...$56b6b4b79df10288$var$markFieldsDirty(data[key])
            };
            else $56b6b4b79df10288$var$getDirtyFieldsFromDefaultValues(data[key], $56b6b4b79df10288$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !$56b6b4b79df10288$var$deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var $56b6b4b79df10288$var$getDirtyFields = (defaultValues, formValues)=>$56b6b4b79df10288$var$getDirtyFieldsFromDefaultValues(defaultValues, formValues, $56b6b4b79df10288$var$markFieldsDirty(formValues));
var $56b6b4b79df10288$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$56b6b4b79df10288$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === "" ? NaN : value1 ? +value1 : value1 : valueAsDate && $56b6b4b79df10288$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
function $56b6b4b79df10288$var$getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref)=>ref.disabled) : ref.disabled) return;
    if ($56b6b4b79df10288$var$isFileInput(ref)) return ref.files;
    if ($56b6b4b79df10288$var$isRadioInput(ref)) return $56b6b4b79df10288$var$getRadioValue(_f.refs).value;
    if ($56b6b4b79df10288$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($56b6b4b79df10288$var$isCheckBoxInput(ref)) return $56b6b4b79df10288$var$getCheckboxValue(_f.refs).value;
    return $56b6b4b79df10288$var$getFieldValueAs($56b6b4b79df10288$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $56b6b4b79df10288$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $56b6b4b79df10288$export$3988ae62b71be9a3(_fields, name);
        field && $56b6b4b79df10288$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $56b6b4b79df10288$var$getRuleValue = (rule)=>$56b6b4b79df10288$var$isUndefined(rule) ? rule : $56b6b4b79df10288$var$isRegex(rule) ? rule.source : $56b6b4b79df10288$var$isObject(rule) ? $56b6b4b79df10288$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
var $56b6b4b79df10288$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function $56b6b4b79df10288$var$schemaErrorLookup(errors, _fields, name) {
    const error = $56b6b4b79df10288$export$3988ae62b71be9a3(errors, name);
    if (error || $56b6b4b79df10288$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split(".");
    while(names.length){
        const fieldName = names.join(".");
        const field = $56b6b4b79df10288$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $56b6b4b79df10288$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $56b6b4b79df10288$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $56b6b4b79df10288$var$unsetEmptyArray = (ref, name)=>!$56b6b4b79df10288$var$compact($56b6b4b79df10288$export$3988ae62b71be9a3(ref, name)).length && $56b6b4b79df10288$var$unset(ref, name);
const $56b6b4b79df10288$var$defaultOptions = {
    mode: $56b6b4b79df10288$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $56b6b4b79df10288$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $56b6b4b79df10288$var$createFormControl(props = {}, flushRootRender) {
    let _options = {
        ...$56b6b4b79df10288$var$defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: $56b6b4b79df10288$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        errors: {}
    };
    let _fields = {};
    let _defaultValues = $56b6b4b79df10288$var$isObject(_options.defaultValues) || $56b6b4b79df10288$var$isObject(_options.values) ? $56b6b4b79df10288$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $56b6b4b79df10288$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _subjects = {
        values: $56b6b4b79df10288$var$createSubject(),
        array: $56b6b4b79df10288$var$createSubject(),
        state: $56b6b4b79df10288$var$createSubject()
    };
    const shouldCaptureDirtyFields = props.resetOptions && props.resetOptions.keepDirtyValues;
    const validationModeBeforeSubmit = $56b6b4b79df10288$var$getValidationModes(_options.mode);
    const validationModeAfterSubmit = $56b6b4b79df10288$var$getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $56b6b4b79df10288$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _updateValid = async (shouldUpdateValid)=>{
        if (_proxyFormState.isValid || shouldUpdateValid) {
            const isValid = _options.resolver ? $56b6b4b79df10288$var$isEmptyObject((await _executeSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (value1)=>_proxyFormState.isValidating && _subjects.state.next({
            isValidating: value1
        });
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($56b6b4b79df10288$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($56b6b4b79df10288$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $56b6b4b79df10288$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($56b6b4b79df10288$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($56b6b4b79df10288$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $56b6b4b79df10288$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $56b6b4b79df10288$var$unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray($56b6b4b79df10288$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($56b6b4b79df10288$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $56b6b4b79df10288$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) _formState.dirtyFields = $56b6b4b79df10288$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $56b6b4b79df10288$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $56b6b4b79df10288$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $56b6b4b79df10288$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $56b6b4b79df10288$export$3988ae62b71be9a3(_formValues, name, $56b6b4b79df10288$var$isUndefined(value1) ? $56b6b4b79df10288$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $56b6b4b79df10288$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $56b6b4b79df10288$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $56b6b4b79df10288$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        if (!isBlurEvent || shouldDirty) {
            if (_proxyFormState.isDirty) {
                isPreviousDirty = _formState.isDirty;
                _formState.isDirty = output.isDirty = _getDirty();
                shouldUpdateField = isPreviousDirty !== output.isDirty;
            }
            const isCurrentFieldPristine = $56b6b4b79df10288$var$deepEqual($56b6b4b79df10288$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
            isPreviousDirty = $56b6b4b79df10288$export$3988ae62b71be9a3(_formState.dirtyFields, name);
            isCurrentFieldPristine ? $56b6b4b79df10288$var$unset(_formState.dirtyFields, name) : $56b6b4b79df10288$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
        }
        if (isBlurEvent) {
            const isPreviousFieldTouched = $56b6b4b79df10288$export$3988ae62b71be9a3(_formState.touchedFields, name);
            if (!isPreviousFieldTouched) {
                $56b6b4b79df10288$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                output.touchedFields = _formState.touchedFields;
                shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
            }
        }
        shouldUpdateField && shouldRender && _subjects.state.next(output);
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $56b6b4b79df10288$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && $56b6b4b79df10288$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(props.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $56b6b4b79df10288$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $56b6b4b79df10288$var$unset(_formState.errors, name);
        }
        if ((error ? !$56b6b4b79df10288$var$deepEqual(previousFieldError, error) : previousFieldError) || !$56b6b4b79df10288$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && $56b6b4b79df10288$var$isBoolean(isValid) ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
        _updateIsValidating(false);
    };
    const _executeSchema = async (name)=>_options.resolver(_formValues, _options.context, $56b6b4b79df10288$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _executeSchema();
        if (names) for (const name of names){
            const error = $56b6b4b79df10288$export$3988ae62b71be9a3(errors, name);
            error ? $56b6b4b79df10288$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $56b6b4b79df10288$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const fieldError = await $56b6b4b79df10288$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($56b6b4b79df10288$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $56b6b4b79df10288$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $56b6b4b79df10288$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $56b6b4b79df10288$var$unset(_formState.errors, _f.name));
                }
                fieldValue && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $56b6b4b79df10288$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$56b6b4b79df10288$var$live(ref)) : !$56b6b4b79df10288$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>(name && data && $56b6b4b79df10288$export$adaa4cf7ef1b65be(_formValues, name, data), !$56b6b4b79df10288$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$56b6b4b79df10288$var$generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : $56b6b4b79df10288$var$isUndefined(defaultValue) ? _defaultValues : $56b6b4b79df10288$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>$56b6b4b79df10288$var$compact($56b6b4b79df10288$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? $56b6b4b79df10288$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $56b6b4b79df10288$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $56b6b4b79df10288$export$adaa4cf7ef1b65be(_formValues, name, $56b6b4b79df10288$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $56b6b4b79df10288$var$isHTMLElement(fieldReference.ref) && $56b6b4b79df10288$var$isNullOrUndefined(value1) ? "" : value1;
                if ($56b6b4b79df10288$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($56b6b4b79df10288$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef)=>(!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data)=>data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($56b6b4b79df10288$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = "";
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.values.next({
                        name: name,
                        values: {
                            ..._formValues
                        }
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            const fieldValue = value1[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = $56b6b4b79df10288$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || !$56b6b4b79df10288$var$isPrimitive(fieldValue) || field && !field._f) && !$56b6b4b79df10288$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $56b6b4b79df10288$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $56b6b4b79df10288$var$cloneObject(value1);
        $56b6b4b79df10288$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: {
                    ..._formValues
                }
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $56b6b4b79df10288$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$56b6b4b79df10288$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $56b6b4b79df10288$var$isWatched(name, _names) && _subjects.state.next({
            ..._formState
        });
        _subjects.values.next({
            name: name,
            values: {
                ..._formValues
            }
        });
        !_state.mount && flushRootRender();
    };
    const onChange = async (event)=>{
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $56b6b4b79df10288$export$3988ae62b71be9a3(_fields, name);
        const getCurrentFieldValue = ()=>target.type ? $56b6b4b79df10288$var$getFieldValue(field._f) : $56b6b4b79df10288$var$getEventValue(event);
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === $56b6b4b79df10288$var$EVENTS.BLUR || event.type === $56b6b4b79df10288$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$56b6b4b79df10288$var$hasValidation(field._f) && !_options.resolver && !$56b6b4b79df10288$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $56b6b4b79df10288$var$skipValidation(isBlurEvent, $56b6b4b79df10288$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $56b6b4b79df10288$var$isWatched(name, _names, isBlurEvent);
            $56b6b4b79df10288$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !$56b6b4b79df10288$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.values.next({
                name: name,
                type: event.type,
                values: {
                    ..._formValues
                }
            });
            if (shouldSkipValidation) {
                _proxyFormState.isValid && _updateValid();
                return shouldRender && _subjects.state.next({
                    name: name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            _updateIsValidating(true);
            if (_options.resolver) {
                const { errors: errors } = await _executeSchema([
                    name
                ]);
                const previousErrorLookupResult = $56b6b4b79df10288$var$schemaErrorLookup(_formState.errors, _fields, name);
                const errorLookupResult = $56b6b4b79df10288$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                error = errorLookupResult.error;
                name = errorLookupResult.name;
                isValid = $56b6b4b79df10288$var$isEmptyObject(errors);
            } else {
                error = (await $56b6b4b79df10288$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                isFieldValueUpdated = isNaN(fieldValue) || fieldValue === $56b6b4b79df10288$export$3988ae62b71be9a3(_formValues, name, fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $56b6b4b79df10288$var$convertToArrayPayload(name);
        _updateIsValidating(true);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($56b6b4b79df10288$var$isUndefined(name) ? name : fieldNames);
            isValid = $56b6b4b79df10288$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$56b6b4b79df10288$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $56b6b4b79df10288$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!$56b6b4b79df10288$var$isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver || !name ? {
                isValid: isValid
            } : {},
            errors: _formState.errors,
            isValidating: false
        });
        options.shouldFocus && !validationResult && $56b6b4b79df10288$var$focusFieldBy(_fields, (key)=>key && $56b6b4b79df10288$export$3988ae62b71be9a3(_formState.errors, key), name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = {
            ..._defaultValues,
            ..._state.mount ? _formValues : {}
        };
        return $56b6b4b79df10288$var$isUndefined(fieldNames) ? values : $56b6b4b79df10288$var$isString(fieldNames) ? $56b6b4b79df10288$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$56b6b4b79df10288$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$56b6b4b79df10288$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$56b6b4b79df10288$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            isTouched: !!$56b6b4b79df10288$export$3988ae62b71be9a3((formState || _formState).touchedFields, name),
            error: $56b6b4b79df10288$export$3988ae62b71be9a3((formState || _formState).errors, name)
        });
    const clearErrors = (name)=>{
        name && $56b6b4b79df10288$var$convertToArrayPayload(name).forEach((inputName)=>$56b6b4b79df10288$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($56b6b4b79df10288$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        $56b6b4b79df10288$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$56b6b4b79df10288$var$isFunction(name) ? _subjects.values.subscribe({
            next: (payload)=>name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $56b6b4b79df10288$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $56b6b4b79df10288$var$unset(_fields, fieldName);
                $56b6b4b79df10288$var$unset(_formValues, fieldName);
            }
            !options.keepError && $56b6b4b79df10288$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $56b6b4b79df10288$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $56b6b4b79df10288$var$unset(_formState.touchedFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $56b6b4b79df10288$var$unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: {
                ..._formValues
            }
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _updateValid();
    };
    const register = (name, options = {})=>{
        let field = $56b6b4b79df10288$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $56b6b4b79df10288$var$isBoolean(options.disabled);
        $56b6b4b79df10288$export$adaa4cf7ef1b65be(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        field ? disabledIsDefined && $56b6b4b79df10288$export$adaa4cf7ef1b65be(_formValues, name, options.disabled ? undefined : $56b6b4b79df10288$export$3988ae62b71be9a3(_formValues, name, $56b6b4b79df10288$var$getFieldValue(field._f))) : updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled
            } : {},
            ..._options.shouldUseNativeValidation ? {
                required: !!options.required,
                min: $56b6b4b79df10288$var$getRuleValue(options.min),
                max: $56b6b4b79df10288$var$getRuleValue(options.max),
                minLength: $56b6b4b79df10288$var$getRuleValue(options.minLength),
                maxLength: $56b6b4b79df10288$var$getRuleValue(options.maxLength),
                pattern: $56b6b4b79df10288$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $56b6b4b79df10288$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $56b6b4b79df10288$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
                    const radioOrCheckbox = $56b6b4b79df10288$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $56b6b4b79df10288$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($56b6b4b79df10288$var$live),
                                    fieldRef,
                                    ...Array.isArray($56b6b4b79df10288$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $56b6b4b79df10288$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($56b6b4b79df10288$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && $56b6b4b79df10288$var$focusFieldBy(_fields, (key)=>key && $56b6b4b79df10288$export$3988ae62b71be9a3(_formState.errors, key), _names.mount);
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $56b6b4b79df10288$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            } else await executeBuiltInValidation(_fields);
            $56b6b4b79df10288$var$unset(_formState.errors, "root");
            if ($56b6b4b79df10288$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                await onValid(fieldValues, e);
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $56b6b4b79df10288$var$isEmptyObject(_formState.errors),
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
        };
    const resetField = (name, options = {})=>{
        if ($56b6b4b79df10288$export$3988ae62b71be9a3(_fields, name)) {
            if ($56b6b4b79df10288$var$isUndefined(options.defaultValue)) setValue(name, $56b6b4b79df10288$export$3988ae62b71be9a3(_defaultValues, name));
            else {
                setValue(name, options.defaultValue);
                $56b6b4b79df10288$export$adaa4cf7ef1b65be(_defaultValues, name, options.defaultValue);
            }
            if (!options.keepTouched) $56b6b4b79df10288$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $56b6b4b79df10288$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $56b6b4b79df10288$export$3988ae62b71be9a3(_defaultValues, name)) : _getDirty();
            }
            if (!options.keepError) {
                $56b6b4b79df10288$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues || _defaultValues;
        const cloneUpdatedValues = $56b6b4b79df10288$var$cloneObject(updatedValues);
        const values = formValues && !$56b6b4b79df10288$var$isEmptyObject(formValues) ? cloneUpdatedValues : _defaultValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues || shouldCaptureDirtyFields) for (const fieldName of _names.mount)$56b6b4b79df10288$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $56b6b4b79df10288$export$adaa4cf7ef1b65be(values, fieldName, $56b6b4b79df10288$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $56b6b4b79df10288$export$3988ae62b71be9a3(values, fieldName));
            else {
                if ($56b6b4b79df10288$var$isWeb && $56b6b4b79df10288$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $56b6b4b79df10288$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($56b6b4b79df10288$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest("form");
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? $56b6b4b79df10288$var$cloneObject(_defaultValues) : {} : cloneUpdatedValues;
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.values.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ""
        };
        !_state.mount && flushRootRender();
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
        _state.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$56b6b4b79df10288$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: keepStateOptions.keepDirtyValues ? _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $56b6b4b79df10288$var$getDirtyFields(_defaultValues, formValues) : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitting: false,
            isSubmitSuccessful: false
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($56b6b4b79df10288$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $56b6b4b79df10288$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>$56b6b4b79df10288$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    return {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            _executeSchema: _executeSchema,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _updateValid: _updateValid,
            _removeUnmounted: _removeUnmounted,
            _updateFieldArray: _updateFieldArray,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _updateFormState: _updateFormState,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            set _formState (value){
                _formState = value;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $56b6b4b79df10288$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useRef();
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $56b6b4b79df10288$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        errors: {},
        defaultValues: $56b6b4b79df10288$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) _formControl.current = {
        ...$56b6b4b79df10288$var$createFormControl(props, ()=>updateFormState((formState)=>({
                    ...formState
                }))),
        formState: formState
    };
    const control = _formControl.current.control;
    control._options = props;
    $56b6b4b79df10288$var$useSubscribe({
        subject: control._subjects.state,
        next: (value1)=>{
            if ($56b6b4b79df10288$var$shouldRenderFormState(value1, control._proxyFormState, control._updateFormState, true)) updateFormState({
                ...control._formState
            });
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useEffect(()=>{
        if (props.values && !$56b6b4b79df10288$var$deepEqual(props.values, control._defaultValues)) control._reset(props.values, control._options.resetOptions);
        else control._resetDefaultValues();
    }, [
        props.values,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useEffect(()=>{
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = $56b6b4b79df10288$var$getProxyFormState(formState, control);
    return _formControl.current;
}

});

parcelRequire.register("8R7rc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a408fcb8f03f87fa$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
/**
 * The component to render a raw component when a single translate key is not enough.
 *
 * It is not dangerous for rendering, but it may cause unexpected behavior if the content
 * is intended to be translated.
 */ function $a408fcb8f03f87fa$var$DangerousRaw({ children: children }) {
    return children ? /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
        children: children
    }) : null;
}
var $a408fcb8f03f87fa$export$2e2bcd8739ae039 = $a408fcb8f03f87fa$var$DangerousRaw;

});

parcelRequire.register("aqmjm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cefeac7fab77bb86$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $lf8OC = parcelRequire("lf8OC");

var $66ixW = parcelRequire("66ixW");

var $75SRw = parcelRequire("75SRw");

var $jbKqE = parcelRequire("jbKqE");
parcelRequire("fIF1D");
var $2LaLj = parcelRequire("2LaLj");

var $gjiog = parcelRequire("gjiog");
function $cefeac7fab77bb86$var$FormField({ title: title, description: description, descriptionPosition: descriptionPosition = "bottom", children: children, isRequired: isRequired, isMultiple: isMultiple, className: className, headlineSpacing: headlineSpacing = "default", tip: tip, headlineClassName: headlineClassName }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($gjiog.field, className),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($gjiog.headline, headlineSpacing === "large" && $gjiog.withLargeSpacing, headlineClassName),
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $gjiog.title,
                        children: [
                            typeof title === "string" ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                forKey: title
                            }) : title,
                            isMultiple && /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                                className: $gjiog.multiple,
                                children: t("general.multiple_form_field")
                            })
                        ]
                    }),
                    tip && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2LaLj.default), {
                        anchorClassName: $gjiog.toggleTipButton,
                        content: tip,
                        horizontalAlign: "start",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                            size: "small",
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $lf8OC.default), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jbKqE.default), {}),
                    isRequired && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $gjiog.required,
                        children: t("general.required")
                    })
                ]
            }),
            description && descriptionPosition === "top" && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($gjiog.description, $gjiog.top),
                children: typeof description === "string" ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                    forKey: description
                }) : description
            }),
            children,
            description && descriptionPosition === "bottom" && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $gjiog.description,
                children: typeof description === "string" ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                    forKey: description
                }) : description
            })
        ]
    });
}
var $cefeac7fab77bb86$export$2e2bcd8739ae039 = $cefeac7fab77bb86$var$FormField;

});
parcelRequire.register("lf8OC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c2e814510e2caaa$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $5c2e814510e2caaa$var$SvgTip = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M8 7.333A.667.667 0 0 0 7.333 8v2.667a.667.667 0 1 0 1.334 0V8A.667.667 0 0 0 8 7.333Zm.253-2.613a.667.667 0 0 0-.506 0 .667.667 0 0 0-.22.14.767.767 0 0 0-.14.22.667.667 0 0 0 .14.727c.064.059.139.106.22.14a.667.667 0 0 0 .92-.614.7.7 0 0 0-.194-.473.667.667 0 0 0-.22-.14ZM8 1.333a6.667 6.667 0 1 0 0 13.334A6.667 6.667 0 0 0 8 1.333Zm0 12A5.334 5.334 0 1 1 8 2.666a5.334 5.334 0 0 1 0 10.667Z",
            fill: "currentColor"
        })
    });
var $5c2e814510e2caaa$export$2e2bcd8739ae039 = $5c2e814510e2caaa$var$SvgTip;

});

parcelRequire.register("jbKqE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $adf6c53e5155563c$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");

var $kHW7O = parcelRequire("kHW7O");
function $adf6c53e5155563c$var$Spacer() {
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: $kHW7O.spacer
    });
}
var $adf6c53e5155563c$export$2e2bcd8739ae039 = $adf6c53e5155563c$var$Spacer;

});
parcelRequire.register("kHW7O", function(module, exports) {

$parcel$export(module.exports, "spacer", function () { return $f134e93098411fa6$export$8cc075c801fd6817; }, function (v) { return $f134e93098411fa6$export$8cc075c801fd6817 = v; });
var $f134e93098411fa6$export$8cc075c801fd6817;
$f134e93098411fa6$export$8cc075c801fd6817 = `O3Avlq_spacer`;

});


parcelRequire.register("fIF1D", function(module, exports) {

$parcel$export(module.exports, "Tooltip", function () { return (parcelRequire("16GE9")).default; });
$parcel$export(module.exports, "ToggleTip", function () { return (parcelRequire("2LaLj")).default; });

var $16GE9 = parcelRequire("16GE9");

var $2LaLj = parcelRequire("2LaLj");

});
parcelRequire.register("16GE9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb5b13e622dff71d$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $jH4WR = parcelRequire("jH4WR");

var $d1oKd = parcelRequire("d1oKd");

var $8MnOa = parcelRequire("8MnOa");

var $gQnBx = parcelRequire("gQnBx");

var $33UGv = parcelRequire("33UGv");
function $eb5b13e622dff71d$var$Tooltip({ className: className, isKeepOpen: isKeepOpen = false, isSuccessful: isSuccessful = false, placement: placement = "top", horizontalAlign: horizontalAlign = "center", anchorClassName: anchorClassName, children: children, content: content }) {
    const [tooltipDom, setTooltipDom] = (0, $jC8Vy.useState)();
    const anchorRef = (0, $jC8Vy.useRef)(null);
    const tooltipRef = (0, $jC8Vy.useRef)(null);
    const { position: position, positionState: positionState, mutate: mutate } = (0, $d1oKd.default)({
        verticalAlign: (0, $gQnBx.getVerticalAlignment)(placement),
        horizontalAlign: (0, $gQnBx.getHorizontalAlignment)(placement, horizontalAlign),
        offset: {
            vertical: (0, $gQnBx.getVerticalOffset)(placement),
            horizontal: (0, $gQnBx.getHorizontalOffset)(placement, horizontalAlign)
        },
        anchorRef: anchorRef,
        overlayRef: tooltipRef
    });
    const [isVisible, setIsVisible] = (0, $jC8Vy.useState)(false);
    (0, $jC8Vy.useEffect)(()=>{
        if (!isVisible) return;
        const mutateAnimationFrame = requestAnimationFrame(()=>{
            mutate();
        });
        return ()=>{
            cancelAnimationFrame(mutateAnimationFrame);
        };
    }, [
        isVisible,
        mutate
    ]);
    (0, $jC8Vy.useEffect)(()=>{
        if (!anchorRef.current) return;
        if (isKeepOpen) {
            setIsVisible(true);
            return;
        }
        const dom = anchorRef.current;
        const enterHandler = ()=>{
            if (!isVisible) setIsVisible(true);
        };
        const leaveHandler = ()=>{
            setIsVisible(false);
        };
        dom.addEventListener("mouseenter", enterHandler);
        dom.addEventListener("mouseleave", leaveHandler);
        return ()=>{
            dom.removeEventListener("mouseenter", enterHandler);
            dom.removeEventListener("mouseleave", leaveHandler);
        };
    }, [
        anchorRef,
        isVisible,
        isKeepOpen
    ]);
    (0, $jC8Vy.useEffect)(()=>{
        if (!isVisible) {
            if (tooltipDom) {
                tooltipDom.remove();
                setTooltipDom(undefined);
            }
            return;
        }
        if (!tooltipDom) {
            const dom = document.createElement("div");
            document.body.append(dom);
            setTooltipDom(dom);
        }
        return ()=>tooltipDom?.remove();
    }, [
        isVisible,
        tooltipDom
    ]);
    (0, $jC8Vy.useLayoutEffect)(()=>{
        mutate();
    }, [
        mutate,
        content
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                ref: anchorRef,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($33UGv.anchor, anchorClassName),
                children: children
            }),
            tooltipDom && content && /*#__PURE__*/ (0, $jH4WR.createPortal)(/*#__PURE__*/ (0, $C7mD2.jsx)((0, $8MnOa.default), {
                ref: tooltipRef,
                anchorRef: anchorRef,
                className: className,
                position: position,
                placement: placement,
                horizontalAlignment: positionState.horizontalAlign,
                isSuccessful: isSuccessful,
                children: content
            }), tooltipDom)
        ]
    });
}
var $eb5b13e622dff71d$export$2e2bcd8739ae039 = $eb5b13e622dff71d$var$Tooltip;

});
parcelRequire.register("d1oKd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e2e0b3d442a9f97$export$2e2bcd8739ae039; });

var $jC8Vy = parcelRequire("jC8Vy");
// Leave space for box-shadow effect.
const $7e2e0b3d442a9f97$var$windowSafePadding = 12;
const $7e2e0b3d442a9f97$var$selectVerticalAlignment = ({ verticalAlign: verticalAlign, verticalTop: verticalTop, verticalMiddle: verticalMiddle, verticalBottom: verticalBottom, overlayHeight: overlayHeight })=>{
    const minY = $7e2e0b3d442a9f97$var$windowSafePadding;
    const maxY = window.innerHeight - $7e2e0b3d442a9f97$var$windowSafePadding;
    const isTopAllowed = verticalTop >= minY;
    const isCenterAllowed = verticalMiddle - overlayHeight / 2 >= minY && verticalMiddle + overlayHeight / 2 <= maxY;
    const isBottomAllowed = verticalBottom + overlayHeight <= maxY;
    switch(verticalAlign){
        case "top":
            if (isTopAllowed) return "top";
            if (isBottomAllowed) return "bottom";
            if (isCenterAllowed) return "middle";
            return verticalAlign;
        case "middle":
            if (isCenterAllowed) return "middle";
            if (isTopAllowed) return "top";
            if (isBottomAllowed) return "bottom";
            return verticalAlign;
        case "bottom":
            if (isBottomAllowed) return "bottom";
            if (isTopAllowed) return "top";
            if (isCenterAllowed) return "middle";
            return verticalAlign;
    }
};
const $7e2e0b3d442a9f97$var$selectHorizontalAlignment = ({ horizontalAlign: horizontalAlign, horizontalStart: horizontalStart, horizontalCenter: horizontalCenter, horizontalEnd: horizontalEnd, overlayWidth: overlayWidth })=>{
    const minX = $7e2e0b3d442a9f97$var$windowSafePadding;
    const maxX = window.innerWidth - $7e2e0b3d442a9f97$var$windowSafePadding;
    const isStartAllowed = horizontalStart + overlayWidth <= maxX;
    const isCenterAllowed = horizontalCenter - overlayWidth / 2 >= minX && horizontalCenter + overlayWidth / 2 <= maxX;
    const isEndAllowed = horizontalEnd >= minX;
    switch(horizontalAlign){
        case "start":
            if (isStartAllowed) return "start";
            if (isEndAllowed) return "end";
            if (isCenterAllowed) return "center";
            return horizontalAlign;
        case "center":
            if (isCenterAllowed) return "center";
            if (isStartAllowed) return "start";
            if (isEndAllowed) return "end";
            return horizontalAlign;
        case "end":
            if (isEndAllowed) return "end";
            if (isStartAllowed) return "start";
            if (isCenterAllowed) return "center";
            return horizontalAlign;
    }
};
function $7e2e0b3d442a9f97$export$2e2bcd8739ae039({ verticalAlign: verticalAlign, horizontalAlign: horizontalAlign, offset: offset, anchorRef: anchorRef, overlayRef: overlayRef }) {
    const [position, setPosition] = (0, $jC8Vy.useState)();
    const [currentVerticalAlign, setCurrentVerticalAlign] = (0, $jC8Vy.useState)(verticalAlign);
    const [currentHorizontalAlign, setCurrentHorizontalAlign] = (0, $jC8Vy.useState)(horizontalAlign);
    const updatePosition = (0, $jC8Vy.useCallback)(()=>{
        if (!anchorRef.current || !overlayRef.current) return;
        const anchorRect = anchorRef.current.getBoundingClientRect();
        const overlayRect = overlayRef.current.getBoundingClientRect();
        const verticalTop = anchorRect.y - overlayRect.height + offset.vertical;
        const verticalMiddle = anchorRect.y + anchorRect.height / 2 - overlayRect.height / 2 + offset.vertical;
        const verticalBottom = anchorRect.y + anchorRect.height + offset.vertical;
        const verticalPositionMap = {
            top: verticalTop,
            middle: verticalMiddle,
            bottom: verticalBottom
        };
        const horizontalStart = anchorRect.x + offset.horizontal;
        const horizontalCenter = anchorRect.x + anchorRect.width / 2 - overlayRect.width / 2 + offset.horizontal;
        const horizontalEnd = anchorRect.x + anchorRect.width - overlayRect.width + offset.horizontal;
        const horizontalPositionMap = {
            start: horizontalStart,
            center: horizontalCenter,
            end: horizontalEnd
        };
        const selectedVerticalAlign = $7e2e0b3d442a9f97$var$selectVerticalAlignment({
            verticalAlign: verticalAlign,
            verticalTop: verticalTop,
            verticalMiddle: verticalMiddle,
            verticalBottom: verticalBottom,
            overlayHeight: overlayRect.height
        });
        const selectedHorizontalAlign = $7e2e0b3d442a9f97$var$selectHorizontalAlignment({
            horizontalAlign: horizontalAlign,
            horizontalStart: horizontalStart,
            horizontalCenter: horizontalCenter,
            horizontalEnd: horizontalEnd,
            overlayWidth: overlayRect.width
        });
        setCurrentVerticalAlign(selectedVerticalAlign);
        setCurrentHorizontalAlign(selectedHorizontalAlign);
        setPosition({
            top: verticalPositionMap[selectedVerticalAlign],
            left: horizontalPositionMap[selectedHorizontalAlign]
        });
    }, [
        anchorRef,
        horizontalAlign,
        offset.vertical,
        offset.horizontal,
        overlayRef,
        verticalAlign
    ]);
    (0, $jC8Vy.useEffect)(()=>{
        updatePosition();
        window.addEventListener("resize", updatePosition);
        window.addEventListener("scroll", updatePosition);
        return ()=>{
            window.removeEventListener("resize", updatePosition);
            window.removeEventListener("scroll", updatePosition);
        };
    }, [
        updatePosition
    ]);
    return {
        position: position,
        mutate: updatePosition,
        positionState: {
            verticalAlign: currentVerticalAlign,
            horizontalAlign: currentHorizontalAlign
        }
    };
}

});

parcelRequire.register("8MnOa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f59d8e72750cc13$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $aGJwO = parcelRequire("aGJwO");
const $2f59d8e72750cc13$var$supportHorizontalAlignmentPlacements = new Set([
    "top",
    "bottom"
]);
function $2f59d8e72750cc13$var$TipBubble({ children: children, position: position, placement: placement = "bottom", horizontalAlignment: horizontalAlignment = "center", className: className, anchorRef: anchorRef, isSuccessful: isSuccessful, ...rest }, reference) {
    if (!anchorRef.current) return null;
    const anchorRect = anchorRef.current.getBoundingClientRect();
    const arrowPosition = (0, $7oDSS.conditional)($2f59d8e72750cc13$var$supportHorizontalAlignmentPlacements.has(placement) && position && {
        left: anchorRect.x + anchorRect.width / 2 - Number(position.left)
    });
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        ...rest,
        ref: reference,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($aGJwO.tipBubble, $aGJwO[placement], !position && $aGJwO.invisible, isSuccessful && $aGJwO.successful, className),
        style: {
            ...position
        },
        children: [
            children,
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $aGJwO.arrow,
                style: {
                    ...arrowPosition
                }
            })
        ]
    });
}
var $2f59d8e72750cc13$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $jC8Vy.forwardRef)($2f59d8e72750cc13$var$TipBubble);

});
parcelRequire.register("aGJwO", function(module, exports) {

$parcel$export(module.exports, "arrow", function () { return $7c8124947605efec$export$f2120bbfa5450bd2; }, function (v) { return $7c8124947605efec$export$f2120bbfa5450bd2 = v; });
$parcel$export(module.exports, "bottom", function () { return $7c8124947605efec$export$40e543e69a8b3fbb; }, function (v) { return $7c8124947605efec$export$40e543e69a8b3fbb = v; });
$parcel$export(module.exports, "invisible", function () { return $7c8124947605efec$export$c99df9cf5e6bee9b; }, function (v) { return $7c8124947605efec$export$c99df9cf5e6bee9b = v; });
$parcel$export(module.exports, "left", function () { return $7c8124947605efec$export$eabcd2c8791e7bf4; }, function (v) { return $7c8124947605efec$export$eabcd2c8791e7bf4 = v; });
$parcel$export(module.exports, "right", function () { return $7c8124947605efec$export$79ffe56a765070d2; }, function (v) { return $7c8124947605efec$export$79ffe56a765070d2 = v; });
$parcel$export(module.exports, "rotating", function () { return $7c8124947605efec$export$bfd64c937657f93a; }, function (v) { return $7c8124947605efec$export$bfd64c937657f93a = v; });
$parcel$export(module.exports, "shimmer", function () { return $7c8124947605efec$export$4a6dd88bada4e7d2; }, function (v) { return $7c8124947605efec$export$4a6dd88bada4e7d2 = v; });
$parcel$export(module.exports, "successful", function () { return $7c8124947605efec$export$62fcf40e4d1fffb5; }, function (v) { return $7c8124947605efec$export$62fcf40e4d1fffb5 = v; });
$parcel$export(module.exports, "tipBubble", function () { return $7c8124947605efec$export$d03cc62ddab7bcdd; }, function (v) { return $7c8124947605efec$export$d03cc62ddab7bcdd = v; });
$parcel$export(module.exports, "top", function () { return $7c8124947605efec$export$1e95b668f3b82d; }, function (v) { return $7c8124947605efec$export$1e95b668f3b82d = v; });
var $7c8124947605efec$export$f2120bbfa5450bd2;
var $7c8124947605efec$export$40e543e69a8b3fbb;
var $7c8124947605efec$export$c99df9cf5e6bee9b;
var $7c8124947605efec$export$eabcd2c8791e7bf4;
var $7c8124947605efec$export$79ffe56a765070d2;
var $7c8124947605efec$export$bfd64c937657f93a;
var $7c8124947605efec$export$4a6dd88bada4e7d2;
var $7c8124947605efec$export$62fcf40e4d1fffb5;
var $7c8124947605efec$export$d03cc62ddab7bcdd;
var $7c8124947605efec$export$1e95b668f3b82d;
$7c8124947605efec$export$f2120bbfa5450bd2 = `_1_sVWW_arrow`;
$7c8124947605efec$export$40e543e69a8b3fbb = `_1_sVWW_bottom`;
$7c8124947605efec$export$c99df9cf5e6bee9b = `_1_sVWW_invisible`;
$7c8124947605efec$export$eabcd2c8791e7bf4 = `_1_sVWW_left`;
$7c8124947605efec$export$79ffe56a765070d2 = `_1_sVWW_right`;
$7c8124947605efec$export$bfd64c937657f93a = `_1_sVWW_rotating`;
$7c8124947605efec$export$4a6dd88bada4e7d2 = `_1_sVWW_shimmer`;
$7c8124947605efec$export$62fcf40e4d1fffb5 = `_1_sVWW_successful`;
$7c8124947605efec$export$d03cc62ddab7bcdd = `_1_sVWW_tipBubble`;
$7c8124947605efec$export$1e95b668f3b82d = `_1_sVWW_top`;

});


parcelRequire.register("gQnBx", function(module, exports) {

$parcel$export(module.exports, "getVerticalOffset", function () { return $8cd61aba6d608816$export$c7ca8986ba140884; });
$parcel$export(module.exports, "getHorizontalOffset", function () { return $8cd61aba6d608816$export$f425d04b8b775845; });
$parcel$export(module.exports, "getVerticalAlignment", function () { return $8cd61aba6d608816$export$7cf35ab7c148e889; });
$parcel$export(module.exports, "getHorizontalAlignment", function () { return $8cd61aba6d608816$export$57b9fac71d74bea1; });
const $8cd61aba6d608816$export$c7ca8986ba140884 = (placement)=>{
    switch(placement){
        case "top":
            return -16;
        case "bottom":
            return 16;
        default:
            return 0;
    }
};
const $8cd61aba6d608816$export$f425d04b8b775845 = (placement, horizontalAlignment)=>{
    if (placement === "top" || placement === "bottom") switch(horizontalAlignment){
        case "start":
            return -32;
        case "end":
            return 32;
        default:
            return 0;
    }
    else return placement === "left" ? -32 : 32;
};
const $8cd61aba6d608816$export$7cf35ab7c148e889 = (placement)=>{
    switch(placement){
        case "top":
            return "top";
        case "bottom":
            return "bottom";
        default:
            return "middle";
    }
};
const $8cd61aba6d608816$export$57b9fac71d74bea1 = (placement, fallback)=>{
    switch(placement){
        case "right":
            return "start";
        case "left":
            return "end";
        default:
            return fallback;
    }
};

});

parcelRequire.register("33UGv", function(module, exports) {

$parcel$export(module.exports, "anchor", function () { return $23ad9f4f2f23744e$export$2e2992790a6f69a8; }, function (v) { return $23ad9f4f2f23744e$export$2e2992790a6f69a8 = v; });
var $23ad9f4f2f23744e$export$2e2992790a6f69a8;
var $23ad9f4f2f23744e$export$bfd64c937657f93a;
var $23ad9f4f2f23744e$export$4a6dd88bada4e7d2;
$23ad9f4f2f23744e$export$2e2992790a6f69a8 = `_9uLVAW_anchor`;
$23ad9f4f2f23744e$export$bfd64c937657f93a = `_9uLVAW_rotating`;
$23ad9f4f2f23744e$export$4a6dd88bada4e7d2 = `_9uLVAW_shimmer`;

});


parcelRequire.register("2LaLj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8f2d5e95f5b2f48$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $kUZ14 = parcelRequire("kUZ14");

var $d1oKd = parcelRequire("d1oKd");

var $dW2kG = parcelRequire("dW2kG");

var $bnkR4 = parcelRequire("bnkR4");

var $8MnOa = parcelRequire("8MnOa");

var $gQnBx = parcelRequire("gQnBx");

var $26rIv = parcelRequire("26rIv");
function $c8f2d5e95f5b2f48$var$ToggleTip({ children: children, className: className, anchorClassName: anchorClassName, placement: placement = "top", horizontalAlign: horizontalAlign = "center", content: content }) {
    const tipBubbleRef = (0, $jC8Vy.useRef)(null);
    const anchorRef = (0, $jC8Vy.useRef)(null);
    const [isOpen, setIsOpen] = (0, $jC8Vy.useState)(false);
    const openTip = (0, $jC8Vy.useCallback)(()=>{
        setIsOpen(true);
        /**
     * Note: should focus on the anchor wrapper element after the tip bubble is opened,
     * or the hover state will not be removed from its child element, and this will cause the child element to have a hover state after the tip bubble is closed.
     */ anchorRef.current?.focus();
    }, []);
    const onClose = (0, $jC8Vy.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    const { position: layoutPosition, positionState: positionState, mutate: mutate } = (0, $d1oKd.default)({
        verticalAlign: (0, $gQnBx.getVerticalAlignment)(placement),
        horizontalAlign: (0, $gQnBx.getHorizontalAlignment)(placement, horizontalAlign),
        offset: {
            vertical: (0, $gQnBx.getVerticalOffset)(placement),
            horizontal: (0, $gQnBx.getHorizontalOffset)(placement, horizontalAlign)
        },
        anchorRef: anchorRef,
        overlayRef: tipBubbleRef
    });
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                ref: anchorRef,
                role: "tab",
                tabIndex: 0,
                className: anchorClassName,
                onClick: openTip,
                onKeyDown: (0, $bnkR4.onKeyDownHandler)(openTip),
                children: children
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
                shouldCloseOnOverlayClick: true,
                shouldCloseOnEsc: true,
                isOpen: isOpen,
                className: $26rIv.content,
                overlayClassName: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($dW2kG.overlay, $26rIv.overlay),
                onRequestClose: onClose,
                onAfterOpen: mutate,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8MnOa.default), {
                    ref: tipBubbleRef,
                    anchorRef: anchorRef,
                    position: layoutPosition,
                    placement: placement,
                    className: className,
                    horizontalAlignment: positionState.horizontalAlign,
                    children: typeof content === "function" ? content(onClose) : content
                })
            })
        ]
    });
}
var $c8f2d5e95f5b2f48$export$2e2bcd8739ae039 = $c8f2d5e95f5b2f48$var$ToggleTip;

});
parcelRequire.register("bnkR4", function(module, exports) {

$parcel$export(module.exports, "onKeyDownHandler", function () { return $905b604deca88628$export$c2c388d6a668999e; });
const $905b604deca88628$export$c2c388d6a668999e = (callback)=>(event)=>{
        const { key: key } = event;
        if (typeof callback === "function" && [
            " ",
            "Enter"
        ].includes(key)) {
            callback(event);
            event.preventDefault();
        }
        if (typeof callback === "object") {
            const handler = callback[key];
            if (handler) {
                handler(event);
                event.preventDefault();
            }
        }
    };

});

parcelRequire.register("26rIv", function(module, exports) {

$parcel$export(module.exports, "content", function () { return $1881a44d567b600d$export$a7db06668cad9adb; }, function (v) { return $1881a44d567b600d$export$a7db06668cad9adb = v; });
$parcel$export(module.exports, "overlay", function () { return $1881a44d567b600d$export$29dd17c7f3c81c36; }, function (v) { return $1881a44d567b600d$export$29dd17c7f3c81c36 = v; });
var $1881a44d567b600d$export$a7db06668cad9adb;
var $1881a44d567b600d$export$29dd17c7f3c81c36;
var $1881a44d567b600d$export$bfd64c937657f93a;
var $1881a44d567b600d$export$4a6dd88bada4e7d2;
$1881a44d567b600d$export$a7db06668cad9adb = `-rGTfG_content`;
$1881a44d567b600d$export$29dd17c7f3c81c36 = `-rGTfG_overlay`;
$1881a44d567b600d$export$bfd64c937657f93a = `-rGTfG_rotating`;
$1881a44d567b600d$export$4a6dd88bada4e7d2 = `-rGTfG_shimmer`;

});



parcelRequire.register("gjiog", function(module, exports) {

$parcel$export(module.exports, "description", function () { return $bdfcaf9d45e0960f$export$6d59db4903f20f7d; }, function (v) { return $bdfcaf9d45e0960f$export$6d59db4903f20f7d = v; });
$parcel$export(module.exports, "field", function () { return $bdfcaf9d45e0960f$export$e0f35d825088c098; }, function (v) { return $bdfcaf9d45e0960f$export$e0f35d825088c098 = v; });
$parcel$export(module.exports, "headline", function () { return $bdfcaf9d45e0960f$export$516dd90aeaaabcf0; }, function (v) { return $bdfcaf9d45e0960f$export$516dd90aeaaabcf0 = v; });
$parcel$export(module.exports, "multiple", function () { return $bdfcaf9d45e0960f$export$939ddaa3205df08e; }, function (v) { return $bdfcaf9d45e0960f$export$939ddaa3205df08e = v; });
$parcel$export(module.exports, "required", function () { return $bdfcaf9d45e0960f$export$a7a0278c004aac3f; }, function (v) { return $bdfcaf9d45e0960f$export$a7a0278c004aac3f = v; });
$parcel$export(module.exports, "title", function () { return $bdfcaf9d45e0960f$export$fb184b623420d9be; }, function (v) { return $bdfcaf9d45e0960f$export$fb184b623420d9be = v; });
$parcel$export(module.exports, "toggleTipButton", function () { return $bdfcaf9d45e0960f$export$d7648c09dd2d912c; }, function (v) { return $bdfcaf9d45e0960f$export$d7648c09dd2d912c = v; });
$parcel$export(module.exports, "top", function () { return $bdfcaf9d45e0960f$export$1e95b668f3b82d; }, function (v) { return $bdfcaf9d45e0960f$export$1e95b668f3b82d = v; });
$parcel$export(module.exports, "withLargeSpacing", function () { return $bdfcaf9d45e0960f$export$feea9e02112d2b92; }, function (v) { return $bdfcaf9d45e0960f$export$feea9e02112d2b92 = v; });
var $bdfcaf9d45e0960f$export$6d59db4903f20f7d;
var $bdfcaf9d45e0960f$export$e0f35d825088c098;
var $bdfcaf9d45e0960f$export$516dd90aeaaabcf0;
var $bdfcaf9d45e0960f$export$939ddaa3205df08e;
var $bdfcaf9d45e0960f$export$a7a0278c004aac3f;
var $bdfcaf9d45e0960f$export$bfd64c937657f93a;
var $bdfcaf9d45e0960f$export$4a6dd88bada4e7d2;
var $bdfcaf9d45e0960f$export$fb184b623420d9be;
var $bdfcaf9d45e0960f$export$d7648c09dd2d912c;
var $bdfcaf9d45e0960f$export$1e95b668f3b82d;
var $bdfcaf9d45e0960f$export$feea9e02112d2b92;
$bdfcaf9d45e0960f$export$6d59db4903f20f7d = `KtdR-q_description`;
$bdfcaf9d45e0960f$export$e0f35d825088c098 = `KtdR-q_field`;
$bdfcaf9d45e0960f$export$516dd90aeaaabcf0 = `KtdR-q_headline`;
$bdfcaf9d45e0960f$export$939ddaa3205df08e = `KtdR-q_multiple`;
$bdfcaf9d45e0960f$export$a7a0278c004aac3f = `KtdR-q_required`;
$bdfcaf9d45e0960f$export$bfd64c937657f93a = `KtdR-q_rotating`;
$bdfcaf9d45e0960f$export$4a6dd88bada4e7d2 = `KtdR-q_shimmer`;
$bdfcaf9d45e0960f$export$fb184b623420d9be = `KtdR-q_title`;
$bdfcaf9d45e0960f$export$d7648c09dd2d912c = `KtdR-q_toggleTipButton`;
$bdfcaf9d45e0960f$export$1e95b668f3b82d = `KtdR-q_top`;
$bdfcaf9d45e0960f$export$feea9e02112d2b92 = `KtdR-q_withLargeSpacing`;

});


parcelRequire.register("5OcFi", function(module, exports) {

$parcel$export(module.exports, "trySubmitSafe", function () { return $6b93016f3de9ffa7$export$71d68564151b8269; });

var $5cXXM = parcelRequire("5cXXM");
const $6b93016f3de9ffa7$export$71d68564151b8269 = (handler)=>async (formData, event)=>{
        try {
            await handler(formData, event);
        } catch (error) {
            if (error instanceof (0, $5cXXM.HTTPError) && error.response.status !== 401) return;
            throw error;
        }
    };

});

parcelRequire.register("ca1Sy", function(module, exports) {

var $jKHUh = parcelRequire("jKHUh");

var $eAvZt = parcelRequire("eAvZt");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $jKHUh.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $eAvZt;
module.exports = isBuffer;

});
parcelRequire.register("jKHUh", function(module, exports) {

var $8EzUW = parcelRequire("8EzUW");
/** Detect free variable `self`. */ var $03b60188dceb83aa$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $03b60188dceb83aa$var$root = $8EzUW || $03b60188dceb83aa$var$freeSelf || Function("return this")();
module.exports = $03b60188dceb83aa$var$root;

});
parcelRequire.register("8EzUW", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $64cdeb96380c73c7$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $64cdeb96380c73c7$var$freeGlobal;

});


parcelRequire.register("eAvZt", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $a9ed3e1b9cbc00de$var$stubFalse() {
    return false;
}
module.exports = $a9ed3e1b9cbc00de$var$stubFalse;

});


parcelRequire.register("4noEQ", function(module, exports) {

var $8EzUW = parcelRequire("8EzUW");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $8EzUW.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRequire.register("83wuy", function(module, exports) {

var $jKHUh = parcelRequire("jKHUh");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $jKHUh.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRequire.register("fkQSb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2a1bcbfd2c90350$export$2e2bcd8739ae039; });

var $kXc8K = parcelRequire("kXc8K");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $kXc8K.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $b2a1bcbfd2c90350$export$2e2bcd8739ae039 = cloneBuffer;

});
parcelRequire.register("kXc8K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03efc93a503156be$export$2e2bcd8739ae039; });

var $ii7ll = parcelRequire("ii7ll");
/** Detect free variable `self`. */ var $03efc93a503156be$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $03efc93a503156be$var$root = (0, $ii7ll.default) || $03efc93a503156be$var$freeSelf || Function("return this")();
var $03efc93a503156be$export$2e2bcd8739ae039 = $03efc93a503156be$var$root;

});
parcelRequire.register("ii7ll", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d50f9aa1cf43696e$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $d50f9aa1cf43696e$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $d50f9aa1cf43696e$export$2e2bcd8739ae039 = $d50f9aa1cf43696e$var$freeGlobal;

});



parcelRequire.register("2wMWH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d74898b2d9db656$export$2e2bcd8739ae039; });

var $kXc8K = parcelRequire("kXc8K");

var $XHs4k = parcelRequire("XHs4k");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $kXc8K.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $XHs4k.default);
var $1d74898b2d9db656$export$2e2bcd8739ae039 = isBuffer;

});
parcelRequire.register("XHs4k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b373768f03166a2$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $0b373768f03166a2$var$stubFalse() {
    return false;
}
var $0b373768f03166a2$export$2e2bcd8739ae039 = $0b373768f03166a2$var$stubFalse;

});


parcelRequire.register("gIKSS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2c51f9bb4a66329$export$2e2bcd8739ae039; });

var $ii7ll = parcelRequire("ii7ll");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $ii7ll.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
var $c2c51f9bb4a66329$export$2e2bcd8739ae039 = nodeUtil;

});

parcelRequire.register("cRLgg", function(module, exports) {

$parcel$export(module.exports, "uriValidator", function () { return $246ac2d2c61fa834$export$36d0ae2aa57c858b; });
$parcel$export(module.exports, "jsonValidator", function () { return $246ac2d2c61fa834$export$9d5afbcb5ee0ae5; });
const $246ac2d2c61fa834$export$36d0ae2aa57c858b = (value)=>{
    try {
        // eslint-disable-next-line no-new
        new URL(value);
    } catch  {
        return false;
    }
    return true;
};
const $246ac2d2c61fa834$export$9d5afbcb5ee0ae5 = (value)=>{
    try {
        JSON.parse(value);
    } catch  {
        return false;
    }
    return true;
};

});

parcelRequire.register("3co9T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73b7bdf41bfeeb0f$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $73b7bdf41bfeeb0f$var$SvgTick = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M15.592 6.008a.833.833 0 0 0-1.184 0L8.2 12.225 5.592 9.608a.852.852 0 0 0-1.184 1.225l3.2 3.2a.833.833 0 0 0 1.184 0l6.8-6.8a.834.834 0 0 0 0-1.225Z",
            fill: "currentColor"
        })
    });
var $73b7bdf41bfeeb0f$export$2e2bcd8739ae039 = $73b7bdf41bfeeb0f$var$SvgTick;

});

parcelRequire.register("95YIy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c50d4c1a223874e6$export$2e2bcd8739ae039; });

var $jC8Vy = parcelRequire("jC8Vy");
const $c50d4c1a223874e6$var$useScroll = (contentRef)=>{
    const [scrollTop, setScrollTop] = (0, $jC8Vy.useState)(0);
    const [scrollLeft, setScrollLeft] = (0, $jC8Vy.useState)(0);
    const handleScroll = (0, $jC8Vy.useCallback)(()=>{
        if (!contentRef) return;
        const { scrollTop: scrollTop, scrollLeft: scrollLeft } = contentRef;
        setScrollTop(scrollTop);
        setScrollLeft(scrollLeft);
    }, [
        contentRef
    ]);
    (0, $jC8Vy.useEffect)(()=>{
        if (!contentRef) return;
        contentRef.addEventListener("scroll", handleScroll);
        return ()=>{
            contentRef.removeEventListener("scroll", handleScroll);
        };
    }, [
        handleScroll,
        contentRef
    ]);
    return {
        scrollTop: scrollTop,
        scrollLeft: scrollLeft
    };
};
var $c50d4c1a223874e6$export$2e2bcd8739ae039 = $c50d4c1a223874e6$var$useScroll;

});

parcelRequire.register("1QOtg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a511cad1c7f1c34d$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $kqSmB = parcelRequire("kqSmB");

var $5PfCS = parcelRequire("5PfCS");

var $4vbce = parcelRequire("4vbce");

var $kjc8Y = parcelRequire("kjc8Y");

var $jGWQ4 = parcelRequire("jGWQ4");

var $66ixW = parcelRequire("66ixW");

var $9Q3SI = parcelRequire("9Q3SI");

var $cSrYO = parcelRequire("cSrYO");
function $a511cad1c7f1c34d$var$NotificationIcon({ severity: severity }) {
    switch(severity){
        case "info":
            return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5PfCS.default), {});
        case "alert":
            return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $kqSmB.default), {});
        case "success":
            return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $kjc8Y.default), {});
        case "error":
            return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4vbce.default), {});
    }
}
function $a511cad1c7f1c34d$var$InlineNotification({ children: children, action: action, href: href, hrefTargetBlank: hrefTargetBlank, onClick: onClick, severity: severity = "info", variant: variant = "plain", hasIcon: hasIcon = true, isActionLoading: isActionLoading = false, className: className }, ref) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($cSrYO.inlineNotification, $cSrYO[severity], $cSrYO[variant], className),
        children: [
            hasIcon && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $cSrYO.icon,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)($a511cad1c7f1c34d$var$NotificationIcon, {
                    severity: severity
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $cSrYO.content,
                children: children
            }),
            action && href && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                to: href,
                targetBlank: hrefTargetBlank,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                    forKey: action
                })
            }),
            action && onClick && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $cSrYO.action,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                    title: action,
                    type: "text",
                    size: "small",
                    isLoading: isActionLoading,
                    onClick: onClick
                })
            })
        ]
    });
}
var $a511cad1c7f1c34d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $jC8Vy.forwardRef)($a511cad1c7f1c34d$var$InlineNotification);

});
parcelRequire.register("kqSmB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c21fbcef4363ca0$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $1c21fbcef4363ca0$var$SvgAlert = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M10 1.667a8.333 8.333 0 1 0 0 16.667 8.333 8.333 0 0 0 0-16.667Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M10 1.667c-4.583 0-8.333 3.75-8.333 8.333 0 4.584 3.75 8.334 8.333 8.334s8.333-3.75 8.333-8.334c0-4.583-3.75-8.333-8.333-8.333Zm0 12.5c-.5 0-.833-.333-.833-.833 0-.5.333-.834.833-.834.5 0 .833.334.833.834 0 .5-.333.833-.833.833ZM10.833 10c0 .5-.333.834-.833.834-.5 0-.833-.334-.833-.834V6.667c0-.5.333-.833.833-.833.5 0 .833.333.833.833V10Z",
                fill: "#EB9918"
            })
        ]
    });
var $1c21fbcef4363ca0$export$2e2bcd8739ae039 = $1c21fbcef4363ca0$var$SvgAlert;

});

parcelRequire.register("5PfCS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89cb4f53b13a95d7$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $89cb4f53b13a95d7$var$SvgInfo = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M10 1.667a8.333 8.333 0 1 0 0 16.666 8.333 8.333 0 0 0 0-16.666Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M9.41 9.41a.833.833 0 0 1 1.423.59v3.333a.833.833 0 1 1-1.666 0V10c0-.221.088-.433.244-.59ZM9.683 5.9a.833.833 0 0 1 .634 0c.102.04.195.1.275.175.152.16.238.37.241.592a.834.834 0 0 1-1.15.766.958.958 0 0 1-.275-.175.833.833 0 0 1-.175-.908.958.958 0 0 1 .175-.275.834.834 0 0 1 .275-.175Z",
                fill: "#fff"
            })
        ]
    });
var $89cb4f53b13a95d7$export$2e2bcd8739ae039 = $89cb4f53b13a95d7$var$SvgInfo;

});

parcelRequire.register("4vbce", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2de1c09ea1c307ce$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $2de1c09ea1c307ce$var$SvgToastError = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "m11.732 3.165.002.002 6.742 11.653c.15.303.253.597.197.931l-.006.041v.041c0 1.068-.87 2-2 2H3.25c-.344 0-.668-.067-.993-.262l-.009-.005c-.922-.527-1.263-1.802-.731-2.733v-.002l6.75-11.664.007-.013.007-.014c.112-.225.365-.493.722-.708.93-.529 2.203-.188 2.73.733ZM8.668 14.167c0 .363.123.705.375.957.252.253.594.376.958.376s.706-.123.958-.376c.252-.252.375-.594.375-.957 0-.364-.123-.706-.375-.958a1.332 1.332 0 0 0-.958-.376c-.364 0-.706.124-.958.376a1.332 1.332 0 0 0-.375.958Zm1.333-2c.364 0 .706-.124.958-.376s.375-.594.375-.958V7.5c0-.364-.123-.705-.375-.958A1.332 1.332 0 0 0 10 6.167c-.364 0-.706.123-.958.375a1.332 1.332 0 0 0-.375.958v3.333c0 .364.123.706.375.958s.594.376.958.376Z",
            fill: "#DD3730",
            stroke: "#DD3730"
        })
    });
var $2de1c09ea1c307ce$export$2e2bcd8739ae039 = $2de1c09ea1c307ce$var$SvgToastError;

});

parcelRequire.register("kjc8Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1281884d37cb908f$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $1281884d37cb908f$var$SvgToastSuccess = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M2.167 10c0-4.307 3.526-7.833 7.833-7.833S17.833 5.693 17.833 10 14.307 17.833 10 17.833 2.167 14.307 2.167 10Zm7.687 2.937 4-4a1.305 1.305 0 0 0 0-1.874 1.305 1.305 0 0 0-1.874 0l-3.063 3.063-.897-.896a1.305 1.305 0 0 0-1.873 0 1.305 1.305 0 0 0 0 1.874l1.833 1.833a1.305 1.305 0 0 0 1.874 0Z",
            fill: "#32873D",
            stroke: "#32873D"
        })
    });
var $1281884d37cb908f$export$2e2bcd8739ae039 = $1281884d37cb908f$var$SvgToastSuccess;

});

parcelRequire.register("cSrYO", function(module, exports) {

$parcel$export(module.exports, "alert", function () { return $96003b60c20156cc$export$5ea928c9faf85bd3; }, function (v) { return $96003b60c20156cc$export$5ea928c9faf85bd3 = v; });
$parcel$export(module.exports, "content", function () { return $96003b60c20156cc$export$a7db06668cad9adb; }, function (v) { return $96003b60c20156cc$export$a7db06668cad9adb = v; });
$parcel$export(module.exports, "error", function () { return $96003b60c20156cc$export$a3bc9b8ed74fc; }, function (v) { return $96003b60c20156cc$export$a3bc9b8ed74fc = v; });
$parcel$export(module.exports, "icon", function () { return $96003b60c20156cc$export$1ca1ec8b29a4ce27; }, function (v) { return $96003b60c20156cc$export$1ca1ec8b29a4ce27 = v; });
$parcel$export(module.exports, "info", function () { return $96003b60c20156cc$export$a80b3bd66acc52ff; }, function (v) { return $96003b60c20156cc$export$a80b3bd66acc52ff = v; });
$parcel$export(module.exports, "inlineNotification", function () { return $96003b60c20156cc$export$9e9024ab31cc2703; }, function (v) { return $96003b60c20156cc$export$9e9024ab31cc2703 = v; });
$parcel$export(module.exports, "rotating", function () { return $96003b60c20156cc$export$bfd64c937657f93a; }, function (v) { return $96003b60c20156cc$export$bfd64c937657f93a = v; });
$parcel$export(module.exports, "shadow", function () { return $96003b60c20156cc$export$b8972b998723d602; }, function (v) { return $96003b60c20156cc$export$b8972b998723d602 = v; });
$parcel$export(module.exports, "shimmer", function () { return $96003b60c20156cc$export$4a6dd88bada4e7d2; }, function (v) { return $96003b60c20156cc$export$4a6dd88bada4e7d2 = v; });
$parcel$export(module.exports, "success", function () { return $96003b60c20156cc$export$fe7c49d056ea1d88; }, function (v) { return $96003b60c20156cc$export$fe7c49d056ea1d88 = v; });
var $96003b60c20156cc$export$5ea928c9faf85bd3;
var $96003b60c20156cc$export$a7db06668cad9adb;
var $96003b60c20156cc$export$a3bc9b8ed74fc;
var $96003b60c20156cc$export$1ca1ec8b29a4ce27;
var $96003b60c20156cc$export$a80b3bd66acc52ff;
var $96003b60c20156cc$export$9e9024ab31cc2703;
var $96003b60c20156cc$export$bfd64c937657f93a;
var $96003b60c20156cc$export$b8972b998723d602;
var $96003b60c20156cc$export$4a6dd88bada4e7d2;
var $96003b60c20156cc$export$fe7c49d056ea1d88;
$96003b60c20156cc$export$5ea928c9faf85bd3 = `_p8-jq_alert`;
$96003b60c20156cc$export$a7db06668cad9adb = `_p8-jq_content`;
$96003b60c20156cc$export$a3bc9b8ed74fc = `_p8-jq_error`;
$96003b60c20156cc$export$1ca1ec8b29a4ce27 = `_p8-jq_icon`;
$96003b60c20156cc$export$a80b3bd66acc52ff = `_p8-jq_info`;
$96003b60c20156cc$export$9e9024ab31cc2703 = `_p8-jq_inlineNotification`;
$96003b60c20156cc$export$bfd64c937657f93a = `_p8-jq_rotating`;
$96003b60c20156cc$export$b8972b998723d602 = `_p8-jq_shadow`;
$96003b60c20156cc$export$4a6dd88bada4e7d2 = `_p8-jq_shimmer`;
$96003b60c20156cc$export$fe7c49d056ea1d88 = `_p8-jq_success`;

});


parcelRequire.register("76jA5", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $52b848567c3f9843$var$PropTypes = $52b848567c3f9843$var$_interopRequireWildcard((parcelRequire("bD9Bx")));

var $52b848567c3f9843$var$_addClass = $52b848567c3f9843$var$_interopRequireDefault((parcelRequire("hbdms")));

var $52b848567c3f9843$var$_removeClass = $52b848567c3f9843$var$_interopRequireDefault((parcelRequire("5hRAV")));

var $52b848567c3f9843$var$_react = $52b848567c3f9843$var$_interopRequireDefault((parcelRequire("jC8Vy")));

var $52b848567c3f9843$var$_Transition = $52b848567c3f9843$var$_interopRequireDefault((parcelRequire("ebNR2")));

function $52b848567c3f9843$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $52b848567c3f9843$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $52b848567c3f9843$var$_extends() {
    $52b848567c3f9843$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $52b848567c3f9843$var$_extends.apply(this, arguments);
}
function $52b848567c3f9843$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $52b848567c3f9843$var$addClass = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $52b848567c3f9843$var$_addClass.default)(node, c);
    });
};
var $52b848567c3f9843$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $52b848567c3f9843$var$_removeClass.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */ var $52b848567c3f9843$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    $52b848567c3f9843$var$_inheritsLoose(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.onEnter = function(node, appearing) {
            var _this$getClassNames = _this.getClassNames(appearing ? "appear" : "enter"), className = _this$getClassNames.className;
            _this.removeClasses(node, "exit");
            $52b848567c3f9843$var$addClass(node, className);
            if (_this.props.onEnter) _this.props.onEnter(node, appearing);
        };
        _this.onEntering = function(node, appearing) {
            var _this$getClassNames2 = _this.getClassNames(appearing ? "appear" : "enter"), activeClassName = _this$getClassNames2.activeClassName;
            _this.reflowAndAddClass(node, activeClassName);
            if (_this.props.onEntering) _this.props.onEntering(node, appearing);
        };
        _this.onEntered = function(node, appearing) {
            var appearClassName = _this.getClassNames("appear").doneClassName;
            var enterClassName = _this.getClassNames("enter").doneClassName;
            var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;
            _this.removeClasses(node, appearing ? "appear" : "enter");
            $52b848567c3f9843$var$addClass(node, doneClassName);
            if (_this.props.onEntered) _this.props.onEntered(node, appearing);
        };
        _this.onExit = function(node) {
            var _this$getClassNames3 = _this.getClassNames("exit"), className = _this$getClassNames3.className;
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            $52b848567c3f9843$var$addClass(node, className);
            if (_this.props.onExit) _this.props.onExit(node);
        };
        _this.onExiting = function(node) {
            var _this$getClassNames4 = _this.getClassNames("exit"), activeClassName = _this$getClassNames4.activeClassName;
            _this.reflowAndAddClass(node, activeClassName);
            if (_this.props.onExiting) _this.props.onExiting(node);
        };
        _this.onExited = function(node) {
            var _this$getClassNames5 = _this.getClassNames("exit"), doneClassName = _this$getClassNames5.doneClassName;
            _this.removeClasses(node, "exit");
            $52b848567c3f9843$var$addClass(node, doneClassName);
            if (_this.props.onExited) _this.props.onExited(node);
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var className = isStringClassNames ? prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? className + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? className + "-done" : classNames[type + "Done"];
            return {
                className: className,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$getClassNames6 = this.getClassNames(type), className = _this$getClassNames6.className, activeClassName = _this$getClassNames6.activeClassName, doneClassName = _this$getClassNames6.doneClassName;
        className && $52b848567c3f9843$var$removeClass(node, className);
        activeClassName && $52b848567c3f9843$var$removeClass(node, activeClassName);
        doneClassName && $52b848567c3f9843$var$removeClass(node, doneClassName);
    };
    _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (className) {
            /* eslint-disable no-unused-expressions */ node && node.scrollTop;
            /* eslint-enable no-unused-expressions */ $52b848567c3f9843$var$addClass(node, className);
        }
    };
    _proto.render = function render() {
        var props = $52b848567c3f9843$var$_extends({}, this.props);
        delete props.classNames;
        return $52b848567c3f9843$var$_react.default.createElement($52b848567c3f9843$var$_Transition.default, $52b848567c3f9843$var$_extends({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}($52b848567c3f9843$var$_react.default.Component);
$52b848567c3f9843$var$CSSTransition.defaultProps = {
    classNames: ""
};
$52b848567c3f9843$var$CSSTransition.propTypes = {};
var $52b848567c3f9843$var$_default = $52b848567c3f9843$var$CSSTransition;
module.exports.default = $52b848567c3f9843$var$_default;
module.exports = module.exports["default"];

});
parcelRequire.register("hbdms", function(module, exports) {
"use strict";

var $dbOXB = parcelRequire("dbOXB");
module.exports.__esModule = true;
module.exports.default = $c81dd3fd204e893f$var$addClass;

var $c81dd3fd204e893f$var$_hasClass = $dbOXB((parcelRequire("fdqNB")));
function $c81dd3fd204e893f$var$addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $c81dd3fd204e893f$var$_hasClass.default)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}
module.exports = module.exports["default"];

});
parcelRequire.register("dbOXB", function(module, exports) {
function $99a3d518e7497b1c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $99a3d518e7497b1c$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("fdqNB", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $b13cdba97a06ade0$var$hasClass;
function $b13cdba97a06ade0$var$hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = module.exports["default"];

});


parcelRequire.register("5hRAV", function(module, exports) {
"use strict";
function $3d981d11fc0a5ae9$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
module.exports = function removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $3d981d11fc0a5ae9$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $3d981d11fc0a5ae9$var$replaceClassName(element.className && element.className.baseVal || "", className));
};

});

parcelRequire.register("ebNR2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $a548c3cdd574c761$export$1e511d4a378977f5; }, function (v) { return $a548c3cdd574c761$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $a548c3cdd574c761$export$2e2bcd8739ae039; }, function (v) { return $a548c3cdd574c761$export$2e2bcd8739ae039 = v; });
$parcel$export(module.exports, "EXITING", function () { return $a548c3cdd574c761$export$4aacc83d4d59139f; }, function (v) { return $a548c3cdd574c761$export$4aacc83d4d59139f = v; });
$parcel$export(module.exports, "ENTERED", function () { return $a548c3cdd574c761$export$78e9e6e3e014d60a; }, function (v) { return $a548c3cdd574c761$export$78e9e6e3e014d60a = v; });
$parcel$export(module.exports, "ENTERING", function () { return $a548c3cdd574c761$export$df38205c966be359; }, function (v) { return $a548c3cdd574c761$export$df38205c966be359 = v; });
$parcel$export(module.exports, "EXITED", function () { return $a548c3cdd574c761$export$84cbff306f539230; }, function (v) { return $a548c3cdd574c761$export$84cbff306f539230 = v; });
$parcel$export(module.exports, "UNMOUNTED", function () { return $a548c3cdd574c761$export$bb38bb9a1161268; }, function (v) { return $a548c3cdd574c761$export$bb38bb9a1161268 = v; });
var $a548c3cdd574c761$export$1e511d4a378977f5;
var $a548c3cdd574c761$export$2e2bcd8739ae039;
var $a548c3cdd574c761$export$4aacc83d4d59139f;
var $a548c3cdd574c761$export$78e9e6e3e014d60a;
var $a548c3cdd574c761$export$df38205c966be359;
var $a548c3cdd574c761$export$84cbff306f539230;
var $a548c3cdd574c761$export$bb38bb9a1161268;
"use strict";
$a548c3cdd574c761$export$1e511d4a378977f5 = true;
$a548c3cdd574c761$export$2e2bcd8739ae039 = $a548c3cdd574c761$export$4aacc83d4d59139f = $a548c3cdd574c761$export$78e9e6e3e014d60a = $a548c3cdd574c761$export$df38205c966be359 = $a548c3cdd574c761$export$84cbff306f539230 = $a548c3cdd574c761$export$bb38bb9a1161268 = void 0;

var $a548c3cdd574c761$var$PropTypes = $a548c3cdd574c761$var$_interopRequireWildcard((parcelRequire("bD9Bx")));

var $a548c3cdd574c761$var$_react = $a548c3cdd574c761$var$_interopRequireDefault((parcelRequire("jC8Vy")));

var $a548c3cdd574c761$var$_reactDom = $a548c3cdd574c761$var$_interopRequireDefault((parcelRequire("jH4WR")));

var $iOeic = parcelRequire("iOeic");

function $a548c3cdd574c761$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a548c3cdd574c761$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $a548c3cdd574c761$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $a548c3cdd574c761$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $a548c3cdd574c761$var$UNMOUNTED = "unmounted";
$a548c3cdd574c761$export$bb38bb9a1161268 = $a548c3cdd574c761$var$UNMOUNTED;
var $a548c3cdd574c761$var$EXITED = "exited";
$a548c3cdd574c761$export$84cbff306f539230 = $a548c3cdd574c761$var$EXITED;
var $a548c3cdd574c761$var$ENTERING = "entering";
$a548c3cdd574c761$export$df38205c966be359 = $a548c3cdd574c761$var$ENTERING;
var $a548c3cdd574c761$var$ENTERED = "entered";
$a548c3cdd574c761$export$78e9e6e3e014d60a = $a548c3cdd574c761$var$ENTERED;
var $a548c3cdd574c761$var$EXITING = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ $a548c3cdd574c761$export$4aacc83d4d59139f = $a548c3cdd574c761$var$EXITING;
var $a548c3cdd574c761$var$Transition = /*#__PURE__*/ function(_React$Component) {
    $a548c3cdd574c761$var$_inheritsLoose(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $a548c3cdd574c761$var$EXITED;
                _this.appearStatus = $a548c3cdd574c761$var$ENTERING;
            } else initialStatus = $a548c3cdd574c761$var$ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $a548c3cdd574c761$var$UNMOUNTED;
        else initialStatus = $a548c3cdd574c761$var$EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    var _proto = Transition.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: null // allows for nested Transitions
        };
    };
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $a548c3cdd574c761$var$UNMOUNTED) return {
            status: $a548c3cdd574c761$var$EXITED
        };
        return null;
    }; // getSnapshotBeforeUpdate(prevProps) {
    //   let nextStatus = null
    //   if (prevProps !== this.props) {
    //     const { status } = this.state
    //     if (this.props.in) {
    //       if (status !== ENTERING && status !== ENTERED) {
    //         nextStatus = ENTERING
    //       }
    //     } else {
    //       if (status === ENTERING || status === ENTERED) {
    //         nextStatus = EXITING
    //       }
    //     }
    //   }
    //   return { nextStatus }
    // }
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $a548c3cdd574c761$var$ENTERING && status !== $a548c3cdd574c761$var$ENTERED) nextStatus = $a548c3cdd574c761$var$ENTERING;
            } else if (status === $a548c3cdd574c761$var$ENTERING || status === $a548c3cdd574c761$var$ENTERED) nextStatus = $a548c3cdd574c761$var$EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            var node = $a548c3cdd574c761$var$_reactDom.default.findDOMNode(this);
            if (nextStatus === $a548c3cdd574c761$var$ENTERING) this.performEnter(node, mounting);
            else this.performExit(node);
        } else if (this.props.unmountOnExit && this.state.status === $a548c3cdd574c761$var$EXITED) this.setState({
            status: $a548c3cdd574c761$var$UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(node, mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter) {
            this.safeSetState({
                status: $a548c3cdd574c761$var$ENTERED
            }, function() {
                _this2.props.onEntered(node);
            });
            return;
        }
        this.props.onEnter(node, appearing);
        this.safeSetState({
            status: $a548c3cdd574c761$var$ENTERING
        }, function() {
            _this2.props.onEntering(node, appearing);
            _this2.onTransitionEnd(node, enterTimeout, function() {
                _this2.safeSetState({
                    status: $a548c3cdd574c761$var$ENTERED
                }, function() {
                    _this2.props.onEntered(node, appearing);
                });
            });
        });
    };
    _proto.performExit = function performExit(node) {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
        if (!exit) {
            this.safeSetState({
                status: $a548c3cdd574c761$var$EXITED
            }, function() {
                _this3.props.onExited(node);
            });
            return;
        }
        this.props.onExit(node);
        this.safeSetState({
            status: $a548c3cdd574c761$var$EXITING
        }, function() {
            _this3.props.onExiting(node);
            _this3.onTransitionEnd(node, timeouts.exit, function() {
                _this3.safeSetState({
                    status: $a548c3cdd574c761$var$EXITED
                }, function() {
                    _this3.props.onExited(node);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
        this.setNextCallback(handler);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) this.props.addEndListener(node, this.nextCallback);
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $a548c3cdd574c761$var$UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, childProps = $a548c3cdd574c761$var$_objectWithoutPropertiesLoose(_this$props, [
            "children"
        ]); // filter props for Transtition
        delete childProps.in;
        delete childProps.mountOnEnter;
        delete childProps.unmountOnExit;
        delete childProps.appear;
        delete childProps.enter;
        delete childProps.exit;
        delete childProps.timeout;
        delete childProps.addEndListener;
        delete childProps.onEnter;
        delete childProps.onEntering;
        delete childProps.onEntered;
        delete childProps.onExit;
        delete childProps.onExiting;
        delete childProps.onExited;
        if (typeof children === "function") return children(status, childProps);
        var child = $a548c3cdd574c761$var$_react.default.Children.only(children);
        return $a548c3cdd574c761$var$_react.default.cloneElement(child, childProps);
    };
    return Transition;
}($a548c3cdd574c761$var$_react.default.Component);
$a548c3cdd574c761$var$Transition.contextTypes = {
    transitionGroup: $a548c3cdd574c761$var$PropTypes.object
};
$a548c3cdd574c761$var$Transition.childContextTypes = {
    transitionGroup: function transitionGroup() {}
};
$a548c3cdd574c761$var$Transition.propTypes = {};
function $a548c3cdd574c761$var$noop() {}
$a548c3cdd574c761$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $a548c3cdd574c761$var$noop,
    onEntering: $a548c3cdd574c761$var$noop,
    onEntered: $a548c3cdd574c761$var$noop,
    onExit: $a548c3cdd574c761$var$noop,
    onExiting: $a548c3cdd574c761$var$noop,
    onExited: $a548c3cdd574c761$var$noop
};
$a548c3cdd574c761$var$Transition.UNMOUNTED = 0;
$a548c3cdd574c761$var$Transition.EXITED = 1;
$a548c3cdd574c761$var$Transition.ENTERING = 2;
$a548c3cdd574c761$var$Transition.ENTERED = 3;
$a548c3cdd574c761$var$Transition.EXITING = 4;
var $a548c3cdd574c761$var$_default = (0, $iOeic.polyfill)($a548c3cdd574c761$var$Transition);
$a548c3cdd574c761$export$2e2bcd8739ae039 = $a548c3cdd574c761$var$_default;

});


parcelRequire.register("lmllh", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $f8cc3529e9e48dd8$var$_propTypes = $f8cc3529e9e48dd8$var$_interopRequireDefault((parcelRequire("bD9Bx")));

var $f8cc3529e9e48dd8$var$_react = $f8cc3529e9e48dd8$var$_interopRequireDefault((parcelRequire("jC8Vy")));

var $jH4WR = parcelRequire("jH4WR");

var $f8cc3529e9e48dd8$var$_TransitionGroup = $f8cc3529e9e48dd8$var$_interopRequireDefault((parcelRequire("ir7dc")));
function $f8cc3529e9e48dd8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f8cc3529e9e48dd8$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $f8cc3529e9e48dd8$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */ var $f8cc3529e9e48dd8$var$ReplaceTransition = /*#__PURE__*/ function(_React$Component) {
    $f8cc3529e9e48dd8$var$_inheritsLoose(ReplaceTransition, _React$Component);
    function ReplaceTransition() {
        var _this;
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(_args)) || this;
        _this.handleEnter = function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return _this.handleLifecycle("onEnter", 0, args);
        };
        _this.handleEntering = function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            return _this.handleLifecycle("onEntering", 0, args);
        };
        _this.handleEntered = function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return _this.handleLifecycle("onEntered", 0, args);
        };
        _this.handleExit = function() {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            return _this.handleLifecycle("onExit", 1, args);
        };
        _this.handleExiting = function() {
            for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
            return _this.handleLifecycle("onExiting", 1, args);
        };
        _this.handleExited = function() {
            for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
            return _this.handleLifecycle("onExited", 1, args);
        };
        return _this;
    }
    var _proto = ReplaceTransition.prototype;
    _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
        var _child$props;
        var children = this.props.children;
        var child = $f8cc3529e9e48dd8$var$_react.default.Children.toArray(children)[idx];
        if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
        if (this.props[handler]) this.props[handler]((0, $jH4WR.findDOMNode)(this));
    };
    _proto.render = function render() {
        var _this$props = this.props, children = _this$props.children, inProp = _this$props.in, props = $f8cc3529e9e48dd8$var$_objectWithoutPropertiesLoose(_this$props, [
            "children",
            "in"
        ]);
        var _React$Children$toArr = $f8cc3529e9e48dd8$var$_react.default.Children.toArray(children), first = _React$Children$toArr[0], second = _React$Children$toArr[1];
        delete props.onEnter;
        delete props.onEntering;
        delete props.onEntered;
        delete props.onExit;
        delete props.onExiting;
        delete props.onExited;
        return $f8cc3529e9e48dd8$var$_react.default.createElement($f8cc3529e9e48dd8$var$_TransitionGroup.default, props, inProp ? $f8cc3529e9e48dd8$var$_react.default.cloneElement(first, {
            key: "first",
            onEnter: this.handleEnter,
            onEntering: this.handleEntering,
            onEntered: this.handleEntered
        }) : $f8cc3529e9e48dd8$var$_react.default.cloneElement(second, {
            key: "second",
            onEnter: this.handleExit,
            onEntering: this.handleExiting,
            onEntered: this.handleExited
        }));
    };
    return ReplaceTransition;
}($f8cc3529e9e48dd8$var$_react.default.Component);
$f8cc3529e9e48dd8$var$ReplaceTransition.propTypes = {};
var $f8cc3529e9e48dd8$var$_default = $f8cc3529e9e48dd8$var$ReplaceTransition;
module.exports.default = $f8cc3529e9e48dd8$var$_default;
module.exports = module.exports["default"];

});
parcelRequire.register("ir7dc", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $d6c057b7cc9dc134$var$_propTypes = $d6c057b7cc9dc134$var$_interopRequireDefault((parcelRequire("bD9Bx")));

var $d6c057b7cc9dc134$var$_react = $d6c057b7cc9dc134$var$_interopRequireDefault((parcelRequire("jC8Vy")));

var $iOeic = parcelRequire("iOeic");

var $eEsfC = parcelRequire("eEsfC");
function $d6c057b7cc9dc134$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d6c057b7cc9dc134$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d6c057b7cc9dc134$var$_extends() {
    $d6c057b7cc9dc134$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d6c057b7cc9dc134$var$_extends.apply(this, arguments);
}
function $d6c057b7cc9dc134$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $d6c057b7cc9dc134$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var $d6c057b7cc9dc134$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $d6c057b7cc9dc134$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
var $d6c057b7cc9dc134$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    $d6c057b7cc9dc134$var$_inheritsLoose(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind($d6c057b7cc9dc134$var$_assertThisInitialized($d6c057b7cc9dc134$var$_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
        _this.state = {
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: {
                isMounting: !this.appeared
            }
        };
    };
    _proto.componentDidMount = function componentDidMount() {
        this.appeared = true;
        this.mounted = true;
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $eEsfC.getInitialChildMapping)(nextProps, handleExited) : (0, $eEsfC.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    };
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $eEsfC.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = $d6c057b7cc9dc134$var$_extends({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = $d6c057b7cc9dc134$var$_objectWithoutPropertiesLoose(_this$props, [
            "component",
            "childFactory"
        ]);
        var children = $d6c057b7cc9dc134$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return children;
        return $d6c057b7cc9dc134$var$_react.default.createElement(Component, props, children);
    };
    return TransitionGroup;
}($d6c057b7cc9dc134$var$_react.default.Component);
$d6c057b7cc9dc134$var$TransitionGroup.childContextTypes = {
    transitionGroup: $d6c057b7cc9dc134$var$_propTypes.default.object.isRequired
};
$d6c057b7cc9dc134$var$TransitionGroup.propTypes = {};
$d6c057b7cc9dc134$var$TransitionGroup.defaultProps = $d6c057b7cc9dc134$var$defaultProps;
var $d6c057b7cc9dc134$var$_default = (0, $iOeic.polyfill)($d6c057b7cc9dc134$var$TransitionGroup);
module.exports.default = $d6c057b7cc9dc134$var$_default;
module.exports = module.exports["default"];

});
parcelRequire.register("eEsfC", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $aaaab72761ad5f63$export$bbc8a025727ea824; }, function (v) { return $aaaab72761ad5f63$export$bbc8a025727ea824 = v; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $aaaab72761ad5f63$export$fa71e2345c31d7a2; }, function (v) { return $aaaab72761ad5f63$export$fa71e2345c31d7a2 = v; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $aaaab72761ad5f63$export$36fd1af28d383ec0; }, function (v) { return $aaaab72761ad5f63$export$36fd1af28d383ec0 = v; });
var $aaaab72761ad5f63$export$1e511d4a378977f5;
var $aaaab72761ad5f63$export$bbc8a025727ea824;
var $aaaab72761ad5f63$export$7a874f95ccf533dd;
var $aaaab72761ad5f63$export$fa71e2345c31d7a2;
var $aaaab72761ad5f63$export$36fd1af28d383ec0;
"use strict";
$aaaab72761ad5f63$export$1e511d4a378977f5 = true;
$aaaab72761ad5f63$export$bbc8a025727ea824 = $aaaab72761ad5f63$var$getChildMapping;
$aaaab72761ad5f63$export$7a874f95ccf533dd = $aaaab72761ad5f63$var$mergeChildMappings;
$aaaab72761ad5f63$export$fa71e2345c31d7a2 = $aaaab72761ad5f63$var$getInitialChildMapping;
$aaaab72761ad5f63$export$36fd1af28d383ec0 = $aaaab72761ad5f63$var$getNextChildMapping;

var $jC8Vy = parcelRequire("jC8Vy");
/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */ function $aaaab72761ad5f63$var$getChildMapping(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $jC8Vy.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) $jC8Vy.Children.map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */ function $aaaab72761ad5f63$var$mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $aaaab72761ad5f63$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $aaaab72761ad5f63$var$getInitialChildMapping(props, onExited) {
    return $aaaab72761ad5f63$var$getChildMapping(props.children, function(child) {
        return (0, $jC8Vy.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $aaaab72761ad5f63$var$getProp(child, "appear", props),
            enter: $aaaab72761ad5f63$var$getProp(child, "enter", props),
            exit: $aaaab72761ad5f63$var$getProp(child, "exit", props)
        });
    });
}
function $aaaab72761ad5f63$var$getNextChildMapping(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $aaaab72761ad5f63$var$getChildMapping(nextProps.children);
    var children = $aaaab72761ad5f63$var$mergeChildMappings(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $jC8Vy.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $jC8Vy.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $jC8Vy.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $aaaab72761ad5f63$var$getProp(child, "exit", nextProps),
            enter: $aaaab72761ad5f63$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $jC8Vy.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $jC8Vy.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $jC8Vy.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $aaaab72761ad5f63$var$getProp(child, "exit", nextProps),
            enter: $aaaab72761ad5f63$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}

});



parcelRequire.register("5cb9q", function(module, exports) {
var $3c86b915da645c69$var$minus = "-".charCodeAt(0);
var $3c86b915da645c69$var$plus = "+".charCodeAt(0);
var $3c86b915da645c69$var$dot = ".".charCodeAt(0);
var $3c86b915da645c69$var$exp = "e".charCodeAt(0);
var $3c86b915da645c69$var$EXP = "E".charCodeAt(0);
module.exports = function(value) {
    var pos = 0;
    var length = value.length;
    var dotted = false;
    var sciPos = -1;
    var containsNumber = false;
    var code;
    while(pos < length){
        code = value.charCodeAt(pos);
        if (code >= 48 && code <= 57) containsNumber = true;
        else if (code === $3c86b915da645c69$var$exp || code === $3c86b915da645c69$var$EXP) {
            if (sciPos > -1) break;
            sciPos = pos;
        } else if (code === $3c86b915da645c69$var$dot) {
            if (dotted) break;
            dotted = true;
        } else if (code === $3c86b915da645c69$var$plus || code === $3c86b915da645c69$var$minus) {
            if (pos !== 0) break;
        } else break;
        pos += 1;
    }
    if (sciPos + 1 === pos) pos--;
    return containsNumber ? {
        number: value.slice(0, pos),
        unit: value.slice(pos)
    } : false;
};

});

parcelRequire.register("3EhUN", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $2a83010f33412375$export$2b8d127b894957b9; }, function (v) { return $2a83010f33412375$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $2a83010f33412375$export$cea3a54a6425200c; }, function (v) { return $2a83010f33412375$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $2a83010f33412375$export$a7c73072b1a182ae; }, function (v) { return $2a83010f33412375$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $2a83010f33412375$export$9f27bc3417b4524d; }, function (v) { return $2a83010f33412375$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $2a83010f33412375$export$db77ccec0bb4ccac; }, function (v) { return $2a83010f33412375$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $2a83010f33412375$export$8392c0c9d3dcbd35; }, function (v) { return $2a83010f33412375$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $2a83010f33412375$export$ffb0004e005737fa; }, function (v) { return $2a83010f33412375$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $2a83010f33412375$export$b624eff549462981; }, function (v) { return $2a83010f33412375$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $2a83010f33412375$export$7897aa7841a5380c; }, function (v) { return $2a83010f33412375$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $2a83010f33412375$export$602eac185826482c; }, function (v) { return $2a83010f33412375$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $2a83010f33412375$export$e2c29f18771995cb; }, function (v) { return $2a83010f33412375$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $2a83010f33412375$export$5f8d39834fd61797; }, function (v) { return $2a83010f33412375$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $2a83010f33412375$export$74bf444e3cd11ea5; }, function (v) { return $2a83010f33412375$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $2a83010f33412375$export$92387174baf9b227; }, function (v) { return $2a83010f33412375$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $2a83010f33412375$export$ec112efeb987d9c6; }, function (v) { return $2a83010f33412375$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $2a83010f33412375$export$b706b080d889d2c9; }, function (v) { return $2a83010f33412375$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $2a83010f33412375$export$5be5a87408f70ddc; }, function (v) { return $2a83010f33412375$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $2a83010f33412375$export$45a5e7f76e0caa8d; }, function (v) { return $2a83010f33412375$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $2a83010f33412375$export$455c2e768291efa6; }, function (v) { return $2a83010f33412375$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $2a83010f33412375$export$9522e17588c12572; }, function (v) { return $2a83010f33412375$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $2a83010f33412375$export$2110ac352bb060b9; }, function (v) { return $2a83010f33412375$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $2a83010f33412375$export$56885ab8b9c456ab; }, function (v) { return $2a83010f33412375$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $2a83010f33412375$export$d927fcb6adf8f9de; }, function (v) { return $2a83010f33412375$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $2a83010f33412375$export$b82d16f27459e05a; }, function (v) { return $2a83010f33412375$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $2a83010f33412375$export$522c17b4f5e123e8; }, function (v) { return $2a83010f33412375$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $2a83010f33412375$export$1aabd8a0274ecfd6; }, function (v) { return $2a83010f33412375$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $2a83010f33412375$export$9b621391a187a31a; }, function (v) { return $2a83010f33412375$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $2a83010f33412375$export$f5bbd400c2f4426f; }, function (v) { return $2a83010f33412375$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2a83010f33412375$export$2b8d127b894957b9;
var $2a83010f33412375$export$cea3a54a6425200c;
var $2a83010f33412375$export$a7c73072b1a182ae;
var $2a83010f33412375$export$9f27bc3417b4524d;
var $2a83010f33412375$export$db77ccec0bb4ccac;
var $2a83010f33412375$export$8392c0c9d3dcbd35;
var $2a83010f33412375$export$ffb0004e005737fa;
var $2a83010f33412375$export$b624eff549462981;
var $2a83010f33412375$export$7897aa7841a5380c;
var $2a83010f33412375$export$602eac185826482c;
var $2a83010f33412375$export$e2c29f18771995cb;
var $2a83010f33412375$export$5f8d39834fd61797;
var $2a83010f33412375$export$74bf444e3cd11ea5;
var $2a83010f33412375$export$92387174baf9b227;
var $2a83010f33412375$export$ec112efeb987d9c6;
var $2a83010f33412375$export$b706b080d889d2c9;
var $2a83010f33412375$export$5be5a87408f70ddc;
var $2a83010f33412375$export$45a5e7f76e0caa8d;
var $2a83010f33412375$export$455c2e768291efa6;
var $2a83010f33412375$export$9522e17588c12572;
var $2a83010f33412375$export$2110ac352bb060b9;
var $2a83010f33412375$export$56885ab8b9c456ab;
var $2a83010f33412375$export$d927fcb6adf8f9de;
var $2a83010f33412375$export$b82d16f27459e05a;
var $2a83010f33412375$export$522c17b4f5e123e8;
var $2a83010f33412375$export$1aabd8a0274ecfd6;
var $2a83010f33412375$export$9b621391a187a31a;
var $2a83010f33412375$export$f5bbd400c2f4426f;
"use strict";
var $2a83010f33412375$var$b = "function" === typeof Symbol && Symbol.for, $2a83010f33412375$var$c = $2a83010f33412375$var$b ? Symbol.for("react.element") : 60103, $2a83010f33412375$var$d = $2a83010f33412375$var$b ? Symbol.for("react.portal") : 60106, $2a83010f33412375$var$e = $2a83010f33412375$var$b ? Symbol.for("react.fragment") : 60107, $2a83010f33412375$var$f = $2a83010f33412375$var$b ? Symbol.for("react.strict_mode") : 60108, $2a83010f33412375$var$g = $2a83010f33412375$var$b ? Symbol.for("react.profiler") : 60114, $2a83010f33412375$var$h = $2a83010f33412375$var$b ? Symbol.for("react.provider") : 60109, $2a83010f33412375$var$k = $2a83010f33412375$var$b ? Symbol.for("react.context") : 60110, $2a83010f33412375$var$l = $2a83010f33412375$var$b ? Symbol.for("react.async_mode") : 60111, $2a83010f33412375$var$m = $2a83010f33412375$var$b ? Symbol.for("react.concurrent_mode") : 60111, $2a83010f33412375$var$n = $2a83010f33412375$var$b ? Symbol.for("react.forward_ref") : 60112, $2a83010f33412375$var$p = $2a83010f33412375$var$b ? Symbol.for("react.suspense") : 60113, $2a83010f33412375$var$q = $2a83010f33412375$var$b ? Symbol.for("react.suspense_list") : 60120, $2a83010f33412375$var$r = $2a83010f33412375$var$b ? Symbol.for("react.memo") : 60115, $2a83010f33412375$var$t = $2a83010f33412375$var$b ? Symbol.for("react.lazy") : 60116, $2a83010f33412375$var$v = $2a83010f33412375$var$b ? Symbol.for("react.block") : 60121, $2a83010f33412375$var$w = $2a83010f33412375$var$b ? Symbol.for("react.fundamental") : 60117, $2a83010f33412375$var$x = $2a83010f33412375$var$b ? Symbol.for("react.responder") : 60118, $2a83010f33412375$var$y = $2a83010f33412375$var$b ? Symbol.for("react.scope") : 60119;
function $2a83010f33412375$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $2a83010f33412375$var$c:
                switch(a = a.type, a){
                    case $2a83010f33412375$var$l:
                    case $2a83010f33412375$var$m:
                    case $2a83010f33412375$var$e:
                    case $2a83010f33412375$var$g:
                    case $2a83010f33412375$var$f:
                    case $2a83010f33412375$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $2a83010f33412375$var$k:
                            case $2a83010f33412375$var$n:
                            case $2a83010f33412375$var$t:
                            case $2a83010f33412375$var$r:
                            case $2a83010f33412375$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $2a83010f33412375$var$d:
                return u;
        }
    }
}
function $2a83010f33412375$var$A(a) {
    return $2a83010f33412375$var$z(a) === $2a83010f33412375$var$m;
}
$2a83010f33412375$export$2b8d127b894957b9 = $2a83010f33412375$var$l;
$2a83010f33412375$export$cea3a54a6425200c = $2a83010f33412375$var$m;
$2a83010f33412375$export$a7c73072b1a182ae = $2a83010f33412375$var$k;
$2a83010f33412375$export$9f27bc3417b4524d = $2a83010f33412375$var$h;
$2a83010f33412375$export$db77ccec0bb4ccac = $2a83010f33412375$var$c;
$2a83010f33412375$export$8392c0c9d3dcbd35 = $2a83010f33412375$var$n;
$2a83010f33412375$export$ffb0004e005737fa = $2a83010f33412375$var$e;
$2a83010f33412375$export$b624eff549462981 = $2a83010f33412375$var$t;
$2a83010f33412375$export$7897aa7841a5380c = $2a83010f33412375$var$r;
$2a83010f33412375$export$602eac185826482c = $2a83010f33412375$var$d;
$2a83010f33412375$export$e2c29f18771995cb = $2a83010f33412375$var$g;
$2a83010f33412375$export$5f8d39834fd61797 = $2a83010f33412375$var$f;
$2a83010f33412375$export$74bf444e3cd11ea5 = $2a83010f33412375$var$p;
$2a83010f33412375$export$92387174baf9b227 = function(a) {
    return $2a83010f33412375$var$A(a) || $2a83010f33412375$var$z(a) === $2a83010f33412375$var$l;
};
$2a83010f33412375$export$ec112efeb987d9c6 = $2a83010f33412375$var$A;
$2a83010f33412375$export$b706b080d889d2c9 = function(a) {
    return $2a83010f33412375$var$z(a) === $2a83010f33412375$var$k;
};
$2a83010f33412375$export$5be5a87408f70ddc = function(a) {
    return $2a83010f33412375$var$z(a) === $2a83010f33412375$var$h;
};
$2a83010f33412375$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $2a83010f33412375$var$c;
};
$2a83010f33412375$export$455c2e768291efa6 = function(a) {
    return $2a83010f33412375$var$z(a) === $2a83010f33412375$var$n;
};
$2a83010f33412375$export$9522e17588c12572 = function(a) {
    return $2a83010f33412375$var$z(a) === $2a83010f33412375$var$e;
};
$2a83010f33412375$export$2110ac352bb060b9 = function(a) {
    return $2a83010f33412375$var$z(a) === $2a83010f33412375$var$t;
};
$2a83010f33412375$export$56885ab8b9c456ab = function(a) {
    return $2a83010f33412375$var$z(a) === $2a83010f33412375$var$r;
};
$2a83010f33412375$export$d927fcb6adf8f9de = function(a) {
    return $2a83010f33412375$var$z(a) === $2a83010f33412375$var$d;
};
$2a83010f33412375$export$b82d16f27459e05a = function(a) {
    return $2a83010f33412375$var$z(a) === $2a83010f33412375$var$g;
};
$2a83010f33412375$export$522c17b4f5e123e8 = function(a) {
    return $2a83010f33412375$var$z(a) === $2a83010f33412375$var$f;
};
$2a83010f33412375$export$1aabd8a0274ecfd6 = function(a) {
    return $2a83010f33412375$var$z(a) === $2a83010f33412375$var$p;
};
$2a83010f33412375$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $2a83010f33412375$var$e || a === $2a83010f33412375$var$m || a === $2a83010f33412375$var$g || a === $2a83010f33412375$var$f || a === $2a83010f33412375$var$p || a === $2a83010f33412375$var$q || "object" === typeof a && null !== a && (a.$$typeof === $2a83010f33412375$var$t || a.$$typeof === $2a83010f33412375$var$r || a.$$typeof === $2a83010f33412375$var$h || a.$$typeof === $2a83010f33412375$var$k || a.$$typeof === $2a83010f33412375$var$n || a.$$typeof === $2a83010f33412375$var$w || a.$$typeof === $2a83010f33412375$var$x || a.$$typeof === $2a83010f33412375$var$y || a.$$typeof === $2a83010f33412375$var$v);
};
$2a83010f33412375$export$f5bbd400c2f4426f = $2a83010f33412375$var$z;

});

parcelRequire.register("g6wRR", function(module, exports) {

!function(e11, t11) {
    module.exports = t11((parcelRequire("jC8Vy")));
}(this, function(__WEBPACK_EXTERNAL_MODULE__98__) {
    return (()=>{
        var __webpack_modules__ = {
            759: (e11, t11, a11)=>{
                "use strict";
                a11.d(t11, {
                    Z: ()=>c11
                });
                var r11, o11 = a11(98), _11 = a11.n(o11), n11 = a11(697), i11 = a11.n(n11);
                function s11() {
                    return s11 = Object.assign || function(e11) {
                        for(var t11 = 1; t11 < arguments.length; t11++){
                            var a11 = arguments[t11];
                            for(var r11 in a11)Object.prototype.hasOwnProperty.call(a11, r11) && (e11[r11] = a11[r11]);
                        }
                        return e11;
                    }, s11.apply(this, arguments);
                }
                e11 = a11.hmd(e11), (r11 = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.enterModule : void 0) && r11(e11), "undefined" != typeof reactHotLoaderGlobal && reactHotLoaderGlobal.default.signature;
                var l11 = function(e11) {
                    var t11 = e11.breakLabel, a11 = e11.breakClassName, r11 = e11.breakLinkClassName, o11 = e11.breakHandler, n11 = e11.getEventListener, i11 = a11 || "break";
                    return _11().createElement("li", {
                        className: i11
                    }, _11().createElement("a", s11({
                        className: r11,
                        role: "button",
                        tabIndex: "0",
                        onKeyPress: o11
                    }, n11(o11)), t11));
                };
                l11.propTypes = {
                    breakLabel: i11().oneOfType([
                        i11().string,
                        i11().node
                    ]),
                    breakClassName: i11().string,
                    breakLinkClassName: i11().string,
                    breakHandler: i11().func.isRequired,
                    getEventListener: i11().func.isRequired
                };
                var p11 = l11;
                const c11 = p11;
                var d11, u11;
                (d11 = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.default : void 0) && (d11.register(l11, "BreakView", "/home/yoan/work/oss/react-paginate/react_components/BreakView.js"), d11.register(p11, "default", "/home/yoan/work/oss/react-paginate/react_components/BreakView.js")), (u11 = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.leaveModule : void 0) && u11(e11);
            },
            770: (e11, t11, a11)=>{
                "use strict";
                a11.d(t11, {
                    Z: ()=>c11
                });
                var r11, o11 = a11(98), _11 = a11.n(o11), n11 = a11(697), i11 = a11.n(n11);
                function s11() {
                    return s11 = Object.assign || function(e11) {
                        for(var t11 = 1; t11 < arguments.length; t11++){
                            var a11 = arguments[t11];
                            for(var r11 in a11)Object.prototype.hasOwnProperty.call(a11, r11) && (e11[r11] = a11[r11]);
                        }
                        return e11;
                    }, s11.apply(this, arguments);
                }
                e11 = a11.hmd(e11), (r11 = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.enterModule : void 0) && r11(e11), "undefined" != typeof reactHotLoaderGlobal && reactHotLoaderGlobal.default.signature;
                var l11 = function(e11) {
                    var t11 = e11.pageClassName, a11 = e11.pageLinkClassName, r11 = e11.page, o11 = e11.selected, n11 = e11.activeClassName, i11 = e11.activeLinkClassName, l11 = e11.getEventListener, p11 = e11.pageSelectedHandler, c11 = e11.href, d11 = e11.extraAriaContext, u11 = e11.pageLabelBuilder, f11 = e11.rel, g11 = e11.ariaLabel || "Page " + r11 + (d11 ? " " + d11 : ""), P11 = null;
                    return o11 && (P11 = "page", g11 = e11.ariaLabel || "Page " + r11 + " is your current page", t11 = void 0 !== t11 ? t11 + " " + n11 : n11, void 0 !== a11 ? void 0 !== i11 && (a11 = a11 + " " + i11) : a11 = i11), _11().createElement("li", {
                        className: t11
                    }, _11().createElement("a", s11({
                        rel: f11,
                        role: c11 ? void 0 : "button",
                        className: a11,
                        href: c11,
                        tabIndex: o11 ? "-1" : "0",
                        "aria-label": g11,
                        "aria-current": P11,
                        onKeyPress: p11
                    }, l11(p11)), u11(r11)));
                };
                l11.propTypes = {
                    pageSelectedHandler: i11().func.isRequired,
                    selected: i11().bool.isRequired,
                    pageClassName: i11().string,
                    pageLinkClassName: i11().string,
                    activeClassName: i11().string,
                    activeLinkClassName: i11().string,
                    extraAriaContext: i11().string,
                    href: i11().string,
                    ariaLabel: i11().string,
                    page: i11().number.isRequired,
                    getEventListener: i11().func.isRequired,
                    pageLabelBuilder: i11().func.isRequired,
                    rel: i11().string
                };
                var p11 = l11;
                const c11 = p11;
                var d11, u11;
                (d11 = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.default : void 0) && (d11.register(l11, "PageView", "/home/yoan/work/oss/react-paginate/react_components/PageView.js"), d11.register(p11, "default", "/home/yoan/work/oss/react-paginate/react_components/PageView.js")), (u11 = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.leaveModule : void 0) && u11(e11);
            },
            214: (module, __webpack_exports__, __webpack_require__)=>{
                "use strict";
                __webpack_require__.d(__webpack_exports__, {
                    Z: ()=>PaginationBoxView
                });
                var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98), react__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__), prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(697), prop_types__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__), _PageView__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(770), _BreakView__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(759), _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(923), enterModule;
                function _typeof(e11) {
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e11) {
                        return typeof e11;
                    } : function(e11) {
                        return e11 && "function" == typeof Symbol && e11.constructor === Symbol && e11 !== Symbol.prototype ? "symbol" : typeof e11;
                    }, _typeof(e11);
                }
                function _extends() {
                    return _extends = Object.assign || function(e11) {
                        for(var t11 = 1; t11 < arguments.length; t11++){
                            var a11 = arguments[t11];
                            for(var r11 in a11)Object.prototype.hasOwnProperty.call(a11, r11) && (e11[r11] = a11[r11]);
                        }
                        return e11;
                    }, _extends.apply(this, arguments);
                }
                function _classCallCheck(e11, t11) {
                    if (!(e11 instanceof t11)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(e11, t11) {
                    for(var a11 = 0; a11 < t11.length; a11++){
                        var r11 = t11[a11];
                        r11.enumerable = r11.enumerable || !1, r11.configurable = !0, "value" in r11 && (r11.writable = !0), Object.defineProperty(e11, r11.key, r11);
                    }
                }
                function _createClass(e11, t11, a11) {
                    return t11 && _defineProperties(e11.prototype, t11), a11 && _defineProperties(e11, a11), e11;
                }
                function _inherits(e11, t11) {
                    if ("function" != typeof t11 && null !== t11) throw new TypeError("Super expression must either be null or a function");
                    e11.prototype = Object.create(t11 && t11.prototype, {
                        constructor: {
                            value: e11,
                            writable: !0,
                            configurable: !0
                        }
                    }), t11 && _setPrototypeOf(e11, t11);
                }
                function _setPrototypeOf(e11, t11) {
                    return _setPrototypeOf = Object.setPrototypeOf || function(e11, t11) {
                        return e11.__proto__ = t11, e11;
                    }, _setPrototypeOf(e11, t11);
                }
                function _createSuper(e11) {
                    var t11 = _isNativeReflectConstruct();
                    return function() {
                        var a11, r11 = _getPrototypeOf(e11);
                        if (t11) {
                            var o11 = _getPrototypeOf(this).constructor;
                            a11 = Reflect.construct(r11, arguments, o11);
                        } else a11 = r11.apply(this, arguments);
                        return _possibleConstructorReturn(this, a11);
                    };
                }
                function _possibleConstructorReturn(e11, t11) {
                    if (t11 && ("object" === _typeof(t11) || "function" == typeof t11)) return t11;
                    if (void 0 !== t11) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized(e11);
                }
                function _assertThisInitialized(e11) {
                    if (void 0 === e11) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e11;
                }
                function _isNativeReflectConstruct() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e11) {
                        return !1;
                    }
                }
                function _getPrototypeOf(e11) {
                    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function(e11) {
                        return e11.__proto__ || Object.getPrototypeOf(e11);
                    }, _getPrototypeOf(e11);
                }
                function _defineProperty(e11, t11, a11) {
                    return t11 in e11 ? Object.defineProperty(e11, t11, {
                        value: a11,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e11[t11] = a11, e11;
                }
                module = __webpack_require__.hmd(module), enterModule = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.enterModule : void 0, enterModule && enterModule(module);
                var __signature__ = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.default.signature : function(e11) {
                    return e11;
                }, PaginationBoxView = function(_Component) {
                    _inherits(PaginationBoxView, _Component);
                    var _super = _createSuper(PaginationBoxView);
                    function PaginationBoxView(e11) {
                        var t11, a11;
                        return _classCallCheck(this, PaginationBoxView), _defineProperty(_assertThisInitialized(t11 = _super.call(this, e11)), "handlePreviousPage", function(e11) {
                            var a11 = t11.state.selected;
                            t11.handleClick(e11, null, a11 > 0 ? a11 - 1 : void 0, {
                                isPrevious: !0
                            });
                        }), _defineProperty(_assertThisInitialized(t11), "handleNextPage", function(e11) {
                            var a11 = t11.state.selected, r11 = t11.props.pageCount;
                            t11.handleClick(e11, null, a11 < r11 - 1 ? a11 + 1 : void 0, {
                                isNext: !0
                            });
                        }), _defineProperty(_assertThisInitialized(t11), "handlePageSelected", function(e11, a11) {
                            if (t11.state.selected === e11) return t11.callActiveCallback(e11), void t11.handleClick(a11, null, void 0, {
                                isActive: !0
                            });
                            t11.handleClick(a11, null, e11);
                        }), _defineProperty(_assertThisInitialized(t11), "handlePageChange", function(e11) {
                            t11.state.selected !== e11 && (t11.setState({
                                selected: e11
                            }), t11.callCallback(e11));
                        }), _defineProperty(_assertThisInitialized(t11), "getEventListener", function(e11) {
                            return _defineProperty({}, t11.props.eventListener, e11);
                        }), _defineProperty(_assertThisInitialized(t11), "handleClick", function(e11, a11, r11) {
                            var o11 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, _11 = o11.isPrevious, n11 = void 0 !== _11 && _11, i11 = o11.isNext, s11 = void 0 !== i11 && i11, l11 = o11.isBreak, p11 = void 0 !== l11 && l11, c11 = o11.isActive, d11 = void 0 !== c11 && c11;
                            e11.preventDefault ? e11.preventDefault() : e11.returnValue = !1;
                            var u11 = t11.state.selected, f11 = t11.props.onClick, g11 = r11;
                            if (f11) {
                                var P11 = f11({
                                    index: a11,
                                    selected: u11,
                                    nextSelectedPage: r11,
                                    event: e11,
                                    isPrevious: n11,
                                    isNext: s11,
                                    isBreak: p11,
                                    isActive: d11
                                });
                                if (!1 === P11) return;
                                Number.isInteger(P11) && (g11 = P11);
                            }
                            void 0 !== g11 && t11.handlePageChange(g11);
                        }), _defineProperty(_assertThisInitialized(t11), "handleBreakClick", function(e11, a11) {
                            var r11 = t11.state.selected;
                            t11.handleClick(a11, e11, r11 < e11 ? t11.getForwardJump() : t11.getBackwardJump(), {
                                isBreak: !0
                            });
                        }), _defineProperty(_assertThisInitialized(t11), "callCallback", function(e11) {
                            void 0 !== t11.props.onPageChange && "function" == typeof t11.props.onPageChange && t11.props.onPageChange({
                                selected: e11
                            });
                        }), _defineProperty(_assertThisInitialized(t11), "callActiveCallback", function(e11) {
                            void 0 !== t11.props.onPageActive && "function" == typeof t11.props.onPageActive && t11.props.onPageActive({
                                selected: e11
                            });
                        }), _defineProperty(_assertThisInitialized(t11), "getElementPageRel", function(e11) {
                            var a11 = t11.state.selected, r11 = t11.props, o11 = r11.nextPageRel, _11 = r11.prevPageRel, n11 = r11.selectedPageRel;
                            return a11 - 1 === e11 ? _11 : a11 === e11 ? n11 : a11 + 1 === e11 ? o11 : void 0;
                        }), _defineProperty(_assertThisInitialized(t11), "pagination", function() {
                            var e11 = [], a11 = t11.props, r11 = a11.pageRangeDisplayed, o11 = a11.pageCount, _11 = a11.marginPagesDisplayed, n11 = a11.breakLabel, i11 = a11.breakClassName, s11 = a11.breakLinkClassName, l11 = t11.state.selected;
                            if (o11 <= r11) for(var p11 = 0; p11 < o11; p11++)e11.push(t11.getPageElement(p11));
                            else {
                                var c11 = r11 / 2, d11 = r11 - c11;
                                l11 > o11 - r11 / 2 ? c11 = r11 - (d11 = o11 - l11) : l11 < r11 / 2 && (d11 = r11 - (c11 = l11));
                                var u11, f11, g11 = function(e11) {
                                    return t11.getPageElement(e11);
                                }, P11 = [];
                                for(u11 = 0; u11 < o11; u11++){
                                    var E11 = u11 + 1;
                                    E11 <= _11 || E11 > o11 - _11 || u11 >= l11 - c11 && u11 <= l11 + (0 === l11 && r11 > 1 ? d11 - 1 : d11) ? P11.push({
                                        type: "page",
                                        index: u11,
                                        display: g11(u11)
                                    }) : n11 && P11.length > 0 && P11[P11.length - 1].display !== f11 && (r11 > 0 || _11 > 0) && (f11 = react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_BreakView__WEBPACK_IMPORTED_MODULE_3__.Z, {
                                        key: u11,
                                        breakLabel: n11,
                                        breakClassName: i11,
                                        breakLinkClassName: s11,
                                        breakHandler: t11.handleBreakClick.bind(null, u11),
                                        getEventListener: t11.getEventListener
                                    }), P11.push({
                                        type: "break",
                                        index: u11,
                                        display: f11
                                    }));
                                }
                                P11.forEach(function(t11, a11) {
                                    var r11 = t11;
                                    "break" === t11.type && P11[a11 - 1] && "page" === P11[a11 - 1].type && P11[a11 + 1] && "page" === P11[a11 + 1].type && P11[a11 + 1].index - P11[a11 - 1].index <= 2 && (r11 = {
                                        type: "page",
                                        index: t11.index,
                                        display: g11(t11.index)
                                    }), e11.push(r11.display);
                                });
                            }
                            return e11;
                        }), void 0 !== e11.initialPage && void 0 !== e11.forcePage && console.warn("(react-paginate): Both initialPage (".concat(e11.initialPage, ") and forcePage (").concat(e11.forcePage, ") props are provided, which is discouraged.") + " Use exclusively forcePage prop for a controlled component.\nSee https://reactjs.org/docs/forms.html#controlled-components"), a11 = e11.initialPage ? e11.initialPage : e11.forcePage ? e11.forcePage : 0, t11.state = {
                            selected: a11
                        }, t11;
                    }
                    return _createClass(PaginationBoxView, [
                        {
                            key: "componentDidMount",
                            value: function() {
                                var e11 = this.props, t11 = e11.initialPage, a11 = e11.disableInitialCallback, r11 = e11.extraAriaContext, o11 = e11.pageCount, _11 = e11.forcePage;
                                void 0 === t11 || a11 || this.callCallback(t11), r11 && console.warn("DEPRECATED (react-paginate): The extraAriaContext prop is deprecated. You should now use the ariaLabelBuilder instead."), Number.isInteger(o11) || console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(o11, "). Did you forget a Math.ceil()?")), void 0 !== t11 && t11 > o11 - 1 && console.warn("(react-paginate): The initialPage prop provided is greater than the maximum page index from pageCount prop (".concat(t11, " > ").concat(o11 - 1, ").")), void 0 !== _11 && _11 > o11 - 1 && console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(_11, " > ").concat(o11 - 1, ")."));
                            }
                        },
                        {
                            key: "componentDidUpdate",
                            value: function(e11) {
                                void 0 !== this.props.forcePage && this.props.forcePage !== e11.forcePage && (this.props.forcePage > this.props.pageCount - 1 && console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(this.props.forcePage, " > ").concat(this.props.pageCount - 1, ").")), this.setState({
                                    selected: this.props.forcePage
                                })), Number.isInteger(e11.pageCount) && !Number.isInteger(this.props.pageCount) && console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(this.props.pageCount, "). Did you forget a Math.ceil()?"));
                            }
                        },
                        {
                            key: "getForwardJump",
                            value: function() {
                                var e11 = this.state.selected, t11 = this.props, a11 = t11.pageCount, r11 = e11 + t11.pageRangeDisplayed;
                                return r11 >= a11 ? a11 - 1 : r11;
                            }
                        },
                        {
                            key: "getBackwardJump",
                            value: function() {
                                var e11 = this.state.selected - this.props.pageRangeDisplayed;
                                return e11 < 0 ? 0 : e11;
                            }
                        },
                        {
                            key: "getElementHref",
                            value: function(e11) {
                                var t11 = this.props, a11 = t11.hrefBuilder, r11 = t11.pageCount, o11 = t11.hrefAllControls;
                                if (a11) return o11 || e11 >= 0 && e11 < r11 ? a11(e11 + 1, r11, this.state.selected) : void 0;
                            }
                        },
                        {
                            key: "ariaLabelBuilder",
                            value: function(e11) {
                                var t11 = e11 === this.state.selected;
                                if (this.props.ariaLabelBuilder && e11 >= 0 && e11 < this.props.pageCount) {
                                    var a11 = this.props.ariaLabelBuilder(e11 + 1, t11);
                                    return this.props.extraAriaContext && !t11 && (a11 = a11 + " " + this.props.extraAriaContext), a11;
                                }
                            }
                        },
                        {
                            key: "getPageElement",
                            value: function(e11) {
                                var t11 = this.state.selected, a11 = this.props, r11 = a11.pageClassName, o11 = a11.pageLinkClassName, _11 = a11.activeClassName, n11 = a11.activeLinkClassName, i11 = a11.extraAriaContext, s11 = a11.pageLabelBuilder;
                                return react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_PageView__WEBPACK_IMPORTED_MODULE_2__.Z, {
                                    key: e11,
                                    pageSelectedHandler: this.handlePageSelected.bind(null, e11),
                                    selected: t11 === e11,
                                    rel: this.getElementPageRel(e11),
                                    pageClassName: r11,
                                    pageLinkClassName: o11,
                                    activeClassName: _11,
                                    activeLinkClassName: n11,
                                    extraAriaContext: i11,
                                    href: this.getElementHref(e11),
                                    ariaLabel: this.ariaLabelBuilder(e11),
                                    page: e11 + 1,
                                    pageLabelBuilder: s11,
                                    getEventListener: this.getEventListener
                                });
                            }
                        },
                        {
                            key: "render",
                            value: function() {
                                var e11 = this.props.renderOnZeroPageCount;
                                if (0 === this.props.pageCount && void 0 !== e11) return e11 ? e11(this.props) : e11;
                                var t11 = this.props, a11 = t11.disabledClassName, r11 = t11.disabledLinkClassName, o11 = t11.pageCount, _11 = t11.className, n11 = t11.containerClassName, i11 = t11.previousLabel, s11 = t11.previousClassName, l11 = t11.previousLinkClassName, p11 = t11.previousAriaLabel, c11 = t11.prevRel, d11 = t11.nextLabel, u11 = t11.nextClassName, f11 = t11.nextLinkClassName, g11 = t11.nextAriaLabel, P11 = t11.nextRel, E11 = this.state.selected, b11 = 0 === E11, y11 = E11 === o11 - 1, v11 = "".concat((0, _utils__WEBPACK_IMPORTED_MODULE_4__.m)(s11)).concat(b11 ? " ".concat((0, _utils__WEBPACK_IMPORTED_MODULE_4__.m)(a11)) : ""), C11 = "".concat((0, _utils__WEBPACK_IMPORTED_MODULE_4__.m)(u11)).concat(y11 ? " ".concat((0, _utils__WEBPACK_IMPORTED_MODULE_4__.m)(a11)) : ""), O11 = "".concat((0, _utils__WEBPACK_IMPORTED_MODULE_4__.m)(l11)).concat(b11 ? " ".concat((0, _utils__WEBPACK_IMPORTED_MODULE_4__.m)(r11)) : ""), m11 = "".concat((0, _utils__WEBPACK_IMPORTED_MODULE_4__.m)(f11)).concat(y11 ? " ".concat((0, _utils__WEBPACK_IMPORTED_MODULE_4__.m)(r11)) : ""), L11 = b11 ? "true" : "false", h11 = y11 ? "true" : "false";
                                return react__WEBPACK_IMPORTED_MODULE_0___default().createElement("ul", {
                                    className: _11 || n11
                                }, react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", {
                                    className: v11
                                }, react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", _extends({
                                    className: O11,
                                    href: this.getElementHref(E11 - 1),
                                    tabIndex: b11 ? "-1" : "0",
                                    role: "button",
                                    onKeyPress: this.handlePreviousPage,
                                    "aria-disabled": L11,
                                    "aria-label": p11,
                                    rel: c11
                                }, this.getEventListener(this.handlePreviousPage)), i11)), this.pagination(), react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", {
                                    className: C11
                                }, react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", _extends({
                                    className: m11,
                                    href: this.getElementHref(E11 + 1),
                                    tabIndex: y11 ? "-1" : "0",
                                    role: "button",
                                    onKeyPress: this.handleNextPage,
                                    "aria-disabled": h11,
                                    "aria-label": g11,
                                    rel: P11
                                }, this.getEventListener(this.handleNextPage)), d11)));
                            }
                        },
                        {
                            key: "__reactstandin__regenerateByEval",
                            value: function __reactstandin__regenerateByEval(key, code) {
                                this[key] = eval(code);
                            }
                        }
                    ]), PaginationBoxView;
                }(react__WEBPACK_IMPORTED_MODULE_0__.Component), reactHotLoader, leaveModule;
                _defineProperty(PaginationBoxView, "propTypes", {
                    pageCount: prop_types__WEBPACK_IMPORTED_MODULE_1___default().number.isRequired,
                    pageRangeDisplayed: prop_types__WEBPACK_IMPORTED_MODULE_1___default().number,
                    marginPagesDisplayed: prop_types__WEBPACK_IMPORTED_MODULE_1___default().number,
                    previousLabel: prop_types__WEBPACK_IMPORTED_MODULE_1___default().node,
                    previousAriaLabel: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    prevPageRel: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    prevRel: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    nextLabel: prop_types__WEBPACK_IMPORTED_MODULE_1___default().node,
                    nextAriaLabel: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    nextPageRel: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    nextRel: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    breakLabel: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([
                        prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                        prop_types__WEBPACK_IMPORTED_MODULE_1___default().node
                    ]),
                    hrefBuilder: prop_types__WEBPACK_IMPORTED_MODULE_1___default().func,
                    hrefAllControls: prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool,
                    onPageChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default().func,
                    onPageActive: prop_types__WEBPACK_IMPORTED_MODULE_1___default().func,
                    onClick: prop_types__WEBPACK_IMPORTED_MODULE_1___default().func,
                    initialPage: prop_types__WEBPACK_IMPORTED_MODULE_1___default().number,
                    forcePage: prop_types__WEBPACK_IMPORTED_MODULE_1___default().number,
                    disableInitialCallback: prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool,
                    containerClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    className: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    pageClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    pageLinkClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    pageLabelBuilder: prop_types__WEBPACK_IMPORTED_MODULE_1___default().func,
                    activeClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    activeLinkClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    previousClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    nextClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    previousLinkClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    nextLinkClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    disabledClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    disabledLinkClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    breakClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    breakLinkClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    extraAriaContext: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    ariaLabelBuilder: prop_types__WEBPACK_IMPORTED_MODULE_1___default().func,
                    eventListener: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    renderOnZeroPageCount: prop_types__WEBPACK_IMPORTED_MODULE_1___default().func,
                    selectedPageRel: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string
                }), _defineProperty(PaginationBoxView, "defaultProps", {
                    pageRangeDisplayed: 2,
                    marginPagesDisplayed: 3,
                    activeClassName: "selected",
                    previousLabel: "Previous",
                    previousClassName: "previous",
                    previousAriaLabel: "Previous page",
                    prevPageRel: "prev",
                    prevRel: "prev",
                    nextLabel: "Next",
                    nextClassName: "next",
                    nextAriaLabel: "Next page",
                    nextPageRel: "next",
                    nextRel: "next",
                    breakLabel: "...",
                    disabledClassName: "disabled",
                    disableInitialCallback: !1,
                    pageLabelBuilder: function(e11) {
                        return e11;
                    },
                    eventListener: "onClick",
                    renderOnZeroPageCount: void 0,
                    selectedPageRel: "canonical",
                    hrefAllControls: !1
                }), reactHotLoader = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.default : void 0, reactHotLoader && reactHotLoader.register(PaginationBoxView, "PaginationBoxView", "/home/yoan/work/oss/react-paginate/react_components/PaginationBoxView.js"), leaveModule = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.leaveModule : void 0, leaveModule && leaveModule(module);
            },
            351: (e11, t11, a11)=>{
                "use strict";
                a11.r(t11), a11.d(t11, {
                    default: ()=>n11
                });
                var r11, o11 = a11(214);
                e11 = a11.hmd(e11), (r11 = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.enterModule : void 0) && r11(e11), "undefined" != typeof reactHotLoaderGlobal && reactHotLoaderGlobal.default.signature;
                var _11 = o11.Z;
                const n11 = _11;
                var i11, s11;
                (i11 = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.default : void 0) && i11.register(_11, "default", "/home/yoan/work/oss/react-paginate/react_components/index.js"), (s11 = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.leaveModule : void 0) && s11(e11);
            },
            923: (e11, t11, a11)=>{
                "use strict";
                var r11, o11, _11;
                function n11(e11) {
                    var t11 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
                    return null != e11 ? e11 : t11;
                }
                a11.d(t11, {
                    m: ()=>n11
                }), e11 = a11.hmd(e11), (r11 = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.enterModule : void 0) && r11(e11), "undefined" != typeof reactHotLoaderGlobal && reactHotLoaderGlobal.default.signature, (o11 = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.default : void 0) && o11.register(n11, "classNameIfDefined", "/home/yoan/work/oss/react-paginate/react_components/utils.js"), (_11 = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.leaveModule : void 0) && _11(e11);
            },
            703: (e11, t11, a11)=>{
                "use strict";
                var r11 = a11(414);
                function o11() {}
                function _11() {}
                _11.resetWarningCache = o11, e11.exports = function() {
                    function e11(e11, t11, a11, o11, _11, n11) {
                        if (n11 !== r11) {
                            var i11 = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                            throw i11.name = "Invariant Violation", i11;
                        }
                    }
                    function t11() {
                        return e11;
                    }
                    e11.isRequired = e11;
                    var a11 = {
                        array: e11,
                        bool: e11,
                        func: e11,
                        number: e11,
                        object: e11,
                        string: e11,
                        symbol: e11,
                        any: e11,
                        arrayOf: t11,
                        element: e11,
                        elementType: e11,
                        instanceOf: t11,
                        node: e11,
                        objectOf: t11,
                        oneOf: t11,
                        oneOfType: t11,
                        shape: t11,
                        exact: t11,
                        checkPropTypes: _11,
                        resetWarningCache: o11
                    };
                    return a11.PropTypes = a11, a11;
                };
            },
            697: (e11, t11, a11)=>{
                e11.exports = a11(703)();
            },
            414: (e11)=>{
                "use strict";
                e11.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
            },
            98: (e11)=>{
                "use strict";
                e11.exports = __WEBPACK_EXTERNAL_MODULE__98__;
            }
        }, __webpack_module_cache__ = {};
        function __webpack_require__(e11) {
            var t11 = __webpack_module_cache__[e11];
            if (void 0 !== t11) return t11.exports;
            var a11 = __webpack_module_cache__[e11] = {
                id: e11,
                loaded: !1,
                exports: {}
            };
            return __webpack_modules__[e11](a11, a11.exports, __webpack_require__), a11.loaded = !0, a11.exports;
        }
        __webpack_require__.n = (e11)=>{
            var t11 = e11 && e11.__esModule ? ()=>e11.default : ()=>e11;
            return __webpack_require__.d(t11, {
                a: t11
            }), t11;
        }, __webpack_require__.d = (e11, t11)=>{
            for(var a11 in t11)__webpack_require__.o(t11, a11) && !__webpack_require__.o(e11, a11) && Object.defineProperty(e11, a11, {
                enumerable: !0,
                get: t11[a11]
            });
        }, __webpack_require__.hmd = (e11)=>((e11 = Object.create(e11)).children || (e11.children = []), Object.defineProperty(e11, "exports", {
                enumerable: !0,
                set: ()=>{
                    throw new Error("ES Modules may not assign module.exports or exports.*, Use ESM export syntax, instead: " + e11.id);
                }
            }), e11), __webpack_require__.o = (e11, t11)=>Object.prototype.hasOwnProperty.call(e11, t11), __webpack_require__.r = (e11)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e11, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e11, "__esModule", {
                value: !0
            });
        };
        var __webpack_exports__ = __webpack_require__(351);
        return __webpack_exports__;
    })();
});

});

parcelRequire.register("8Wp5H", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("9Jn3N")).then(()=>parcelRequire("5jTk6"));

});
parcelRequire.register("jPoCU", function(module, exports) {
"use strict";

var $f9lIi = parcelRequire("f9lIi");
module.exports = $f9lIi(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRequire.register("f9lIi", function(module, exports) {
"use strict";
var $b0788a1d0b51f5c0$var$cachedBundles = {};
var $b0788a1d0b51f5c0$var$cachedPreloads = {};
var $b0788a1d0b51f5c0$var$cachedPrefetches = {};
function $b0788a1d0b51f5c0$var$getCache(type) {
    switch(type){
        case "preload":
            return $b0788a1d0b51f5c0$var$cachedPreloads;
        case "prefetch":
            return $b0788a1d0b51f5c0$var$cachedPrefetches;
        default:
            return $b0788a1d0b51f5c0$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $b0788a1d0b51f5c0$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRequire.register("2KvlN", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $200832379a035c69$export$bdfd709ae4826697; }, function (v) { return $200832379a035c69$export$bdfd709ae4826697 = v; });
var $200832379a035c69$export$bdfd709ae4826697;
var $200832379a035c69$export$c9e73fbda7da57b6;
var $200832379a035c69$export$5a759dc7a1cfb72a;
"use strict";
var $200832379a035c69$var$bundleURL = {};
function $200832379a035c69$var$getBundleURLCached(id) {
    var value = $200832379a035c69$var$bundleURL[id];
    if (!value) {
        value = $200832379a035c69$var$getBundleURL();
        $200832379a035c69$var$bundleURL[id] = value;
    }
    return value;
}
function $200832379a035c69$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $200832379a035c69$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $200832379a035c69$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $200832379a035c69$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$200832379a035c69$export$bdfd709ae4826697 = $200832379a035c69$var$getBundleURLCached;
$200832379a035c69$export$c9e73fbda7da57b6 = $200832379a035c69$var$getBaseURL;
$200832379a035c69$export$5a759dc7a1cfb72a = $200832379a035c69$var$getOrigin;

});


parcelRequire.register("gNAel", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("f6X4o"))
]).then(()=>parcelRequire("1pzZv"));

});
parcelRequire.register("k6BSO", function(module, exports) {
"use strict";

var $f9lIi = parcelRequire("f9lIi");
module.exports = $f9lIi(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

});


parcelRequire.register("bvEmC", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("lekiy")).then(()=>parcelRequire("2sRwe"));

});

parcelRequire.register("3kYP8", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("ivYjF"))
]).then(()=>parcelRequire("gPDgu"));

});

parcelRequire.register("fS1qe", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("g4wMj")).then(()=>parcelRequire("3sE0e"));

});

parcelRequire.register("kWNaX", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("jzbHC"))
]).then(()=>parcelRequire("hjBsk"));

});

parcelRequire.register("950fK", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("84vbb")).then(()=>parcelRequire("1z8wh"));

});

parcelRequire.register("b1iax", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("3ZWpB"))
]).then(()=>parcelRequire("jA953"));

});

parcelRequire.register("bDBlx", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("bGi9s")).then(()=>parcelRequire("izqaf"));

});

parcelRequire.register("kgxhz", function(module, exports) {









module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fmUdJ")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("hBYYP"))
]).then(()=>parcelRequire("cMRM8"));

});

parcelRequire.register("hAdKV", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("kcxAh")).then(()=>parcelRequire("4Dite"));

});

parcelRequire.register("91D1K", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("cEXEx"))
]).then(()=>parcelRequire("lt0E3"));

});

parcelRequire.register("6uRMY", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("aM6Gx")).then(()=>parcelRequire("6C90F"));

});

parcelRequire.register("dNcef", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("3N65a"))
]).then(()=>parcelRequire("gh9D9"));

});

parcelRequire.register("dsZ8p", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("3obyM")).then(()=>parcelRequire("8Us2B"));

});

parcelRequire.register("4WvIx", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("4CVuT"))
]).then(()=>parcelRequire("6wdFr"));

});

parcelRequire.register("dsGsZ", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("8UZzc")).then(()=>parcelRequire("1UOPA"));

});

parcelRequire.register("iaMKk", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("aRW3v"))
]).then(()=>parcelRequire("5G8qe"));

});

parcelRequire.register("4HI07", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("bDaZk")).then(()=>parcelRequire("7Cf5C"));

});

parcelRequire.register("gyrap", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("bXNCc"))
]).then(()=>parcelRequire("5evQW"));

});

parcelRequire.register("d46yN", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("hLXnh")).then(()=>parcelRequire("llyZ4"));

});

parcelRequire.register("kdbvk", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("1wYje"))
]).then(()=>parcelRequire("cq5sY"));

});

parcelRequire.register("bYV01", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("7zjiT")).then(()=>parcelRequire("1g8fF"));

});

parcelRequire.register("2VScH", function(module, exports) {









module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("2fEHf")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("bLmpI"))
]).then(()=>parcelRequire("jQmCg"));

});

parcelRequire.register("lVYOT", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("ayJCB")).then(()=>parcelRequire("5Iagn"));

});

parcelRequire.register("8MTXs", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("gFt4r"))
]).then(()=>parcelRequire("lyP9h"));

});

parcelRequire.register("gY2M7", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("7Y6Q8")).then(()=>parcelRequire("fcgI9"));

});

parcelRequire.register("dv4za", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("2mIAj"))
]).then(()=>parcelRequire("lRVio"));

});

parcelRequire.register("1VMPO", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("2nyw9")).then(()=>parcelRequire("9FSka"));

});

parcelRequire.register("9b8v9", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("5kG9x"))
]).then(()=>parcelRequire("6rRH0"));

});

parcelRequire.register("9BDDR", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("3iotI")).then(()=>parcelRequire("esnCy"));

});

parcelRequire.register("j9qYD", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("lWX6d"))
]).then(()=>parcelRequire("bJh4W"));

});

parcelRequire.register("9Yp6d", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("dX7qM")).then(()=>parcelRequire("bfEqD"));

});

parcelRequire.register("8QaiC", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("k0LAp"))
]).then(()=>parcelRequire("hpDmY"));

});

parcelRequire.register("hMIZk", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("lCgSh")).then(()=>parcelRequire("27xNU"));

});

parcelRequire.register("aW9Vs", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("1l2A4"))
]).then(()=>parcelRequire("4kvVr"));

});

parcelRequire.register("8TePg", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("dlPtU")).then(()=>parcelRequire("hLtf6"));

});

parcelRequire.register("gySfN", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("gbcLw"))
]).then(()=>parcelRequire("fVfUh"));

});

parcelRequire.register("jahOe", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("6iGDr")).then(()=>parcelRequire("fDxB0"));

});

parcelRequire.register("6GGYm", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("7tJTH"))
]).then(()=>parcelRequire("215AQ"));

});

parcelRequire.register("f5OPi", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("cRX9l")).then(()=>parcelRequire("6Wn63"));

});

parcelRequire.register("evpuN", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("hZHlk"))
]).then(()=>parcelRequire("eDMkB"));

});

parcelRequire.register("dQxQX", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("2UUZd")).then(()=>parcelRequire("iARRN"));

});

parcelRequire.register("3FNXd", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("adLM5"))
]).then(()=>parcelRequire("4OFiC"));

});

parcelRequire.register("1en2t", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("igiCk")).then(()=>parcelRequire("6zETl"));

});

parcelRequire.register("kjGzg", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("eSj8S"))
]).then(()=>parcelRequire("efDpf"));

});

parcelRequire.register("85M6h", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("2RNqP")).then(()=>parcelRequire("4JzzE"));

});

parcelRequire.register("3XsT3", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("7zbGt"))
]).then(()=>parcelRequire("5EvLl"));

});

parcelRequire.register("kTRee", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("34TQe")).then(()=>parcelRequire("55JNo"));

});

parcelRequire.register("kFqAe", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("ezrb9"))
]).then(()=>parcelRequire("gi62O"));

});

parcelRequire.register("7KzV4", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("2eGRm")).then(()=>parcelRequire("d7lQ4"));

});

parcelRequire.register("e2qve", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("dDoUn"))
]).then(()=>parcelRequire("3YE4j"));

});

parcelRequire.register("7vo8m", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("3OWuA")).then(()=>parcelRequire("jhX55"));

});

parcelRequire.register("glGFo", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("RoBOM"))
]).then(()=>parcelRequire("7rd0N"));

});

parcelRequire.register("6USxJ", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("8WZjJ")).then(()=>parcelRequire("ckWp6"));

});

parcelRequire.register("5zZ0E", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("9awdr"))
]).then(()=>parcelRequire("6z80u"));

});

parcelRequire.register("5wwdD", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("3ofvP")).then(()=>parcelRequire("fMNx2"));

});

parcelRequire.register("etkbA", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("7N8Qq"))
]).then(()=>parcelRequire("c6edP"));

});

parcelRequire.register("f4lBs", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("5nquF")).then(()=>parcelRequire("6MAsL"));

});

parcelRequire.register("4dmq0", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("dymK4"))
]).then(()=>parcelRequire("gjkpM"));

});

parcelRequire.register("hVtVZ", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("6Imur")).then(()=>parcelRequire("hv1NZ"));

});

parcelRequire.register("5e0af", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("k7VgK"))
]).then(()=>parcelRequire("7mETh"));

});

parcelRequire.register("div5d", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("9Bgo4")).then(()=>parcelRequire("e5cqx"));

});

parcelRequire.register("8PnWa", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("cp16G"))
]).then(()=>parcelRequire("aw1lB"));

});

parcelRequire.register("aYDzk", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("ipQph")).then(()=>parcelRequire("6gLuN"));

});

parcelRequire.register("66f2j", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("3OPaf")).then(()=>parcelRequire("eiszV"));

});

parcelRequire.register("cw2No", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9cd99644facd4e27$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $Swc7z = parcelRequire("Swc7z");

var $fzDoK = parcelRequire("fzDoK");

var $cJEhq = parcelRequire("cJEhq");

var $bnkR4 = parcelRequire("bnkR4");

var $75SRw = parcelRequire("75SRw");
parcelRequire("fIF1D");
var $16GE9 = parcelRequire("16GE9");

var $38oKl = parcelRequire("38oKl");
function $9cd99644facd4e27$var$CopyToClipboard({ value: value, className: className, style: style, valueStyle: valueStyle, hasVisibilityToggle: hasVisibilityToggle, variant: variant = "contained", size: size = "default", isWordWrapAllowed: isWordWrapAllowed = false, displayType: displayType = "inline" }, ref) {
    const copyIconReference = (0, $jC8Vy.useRef)(null);
    const [copyState, setCopyState] = (0, $jC8Vy.useState)("copy");
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.general"
    });
    const [showHiddenContent, setShowHiddenContent] = (0, $jC8Vy.useState)(false);
    const displayValue = (0, $jC8Vy.useMemo)(()=>{
        if (!hasVisibilityToggle || showHiddenContent) return value;
        return "•".repeat(value.length);
    }, [
        hasVisibilityToggle,
        showHiddenContent,
        value
    ]);
    (0, $jC8Vy.useEffect)(()=>{
        copyIconReference.current?.addEventListener("mouseleave", ()=>{
            setCopyState("copy");
        });
    }, []);
    const copy = async ()=>{
        /**
     * Note: should blur the copy icon button before the tooltip is shown, or it will remain focused after the tooltip is closed.
     */ copyIconReference.current?.blur();
        setCopyState("copying");
        await navigator.clipboard.writeText(value);
        setCopyState("copied");
    };
    const toggleHiddenContent = ()=>{
        setShowHiddenContent((previous)=>!previous);
    };
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($38oKl.container, $38oKl[variant], $38oKl[size], $38oKl[displayType], className),
        role: "button",
        tabIndex: 0,
        style: style,
        onKeyDown: (0, $bnkR4.onKeyDownHandler)((event)=>{
            event.stopPropagation();
        }),
        onClick: (event)=>{
            event.stopPropagation();
        },
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
            className: $38oKl.row,
            children: [
                variant !== "icon" && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($38oKl.content, isWordWrapAllowed && $38oKl.wrapContent),
                    style: valueStyle,
                    children: displayValue
                }),
                hasVisibilityToggle && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $16GE9.default), {
                    content: t(showHiddenContent ? "hide" : "view"),
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                        className: $38oKl.iconButton,
                        iconClassName: $38oKl.icon,
                        size: "small",
                        onClick: toggleHiddenContent,
                        children: showHiddenContent ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fzDoK.default), {}) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cJEhq.default), {})
                    })
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $16GE9.default), {
                    isSuccessful: copyState === "copied",
                    anchorClassName: $38oKl.copyToolTipAnchor,
                    content: t(copyState),
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                        ref: copyIconReference,
                        className: $38oKl.iconButton,
                        iconClassName: $38oKl.icon,
                        size: "small",
                        onClick: copy,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $Swc7z.default), {})
                    })
                })
            ]
        })
    });
}
var $9cd99644facd4e27$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $jC8Vy.forwardRef)($9cd99644facd4e27$var$CopyToClipboard);

});
parcelRequire.register("Swc7z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $665d6d6fb491653a$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $665d6d6fb491653a$var$SvgCopy = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M9.333 14.667H2.667a1.29 1.29 0 0 1-1.334-1.334V6.667a1.29 1.29 0 0 1 1.334-1.334h2.666V2.667a1.29 1.29 0 0 1 1.334-1.334h6.666a1.29 1.29 0 0 1 1.334 1.334v6.666a1.29 1.29 0 0 1-1.334 1.334h-2.666v2.666a1.29 1.29 0 0 1-1.334 1.334Zm-6.666-8v6.666h6.666v-2.666H6.667a1.29 1.29 0 0 1-1.334-1.334V6.667H2.667Zm4-4v6.666h6.666V2.667H6.667Z",
            fill: "currentColor"
        })
    });
var $665d6d6fb491653a$export$2e2bcd8739ae039 = $665d6d6fb491653a$var$SvgCopy;

});

parcelRequire.register("fzDoK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec17f4803d08ba4d$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $ec17f4803d08ba4d$var$SvgEyeClosed = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.09 1.91A.833.833 0 0 0 1.91 3.09L4.33 5.507C2.834 6.729 1.815 8.165 1.313 8.959l-.02.032c-.098.155-.226.356-.29.636a1.799 1.799 0 0 0 0 .745c.064.281.191.481.29.636l.02.031c.493.782 1.48 2.17 2.918 3.371 1.44 1.203 3.385 2.257 5.77 2.257 1.642 0 3.078-.501 4.282-1.206l2.628 2.628a.833.833 0 1 0 1.179-1.178l-3.022-3.022a.827.827 0 0 0-.153-.153l-8.66-8.66a.83.83 0 0 0-.133-.133L3.09 1.911Zm-.368 7.94c.473-.75 1.427-2.078 2.793-3.157L7.13 8.307a3.333 3.333 0 0 0 4.565 4.565l1.362 1.362c-.908.467-1.928.766-3.056.766-1.87 0-3.448-.823-4.701-1.87-1.255-1.047-2.134-2.278-2.578-2.98a7.144 7.144 0 0 1-.09-.149v-.002c.004-.01.012-.022.024-.041l.067-.109Zm5.612.15c0-.15.02-.294.056-.432l2.042 2.042A1.67 1.67 0 0 1 8.334 10Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M9.074 5.068C9.374 5.024 9.682 5 10 5c1.87 0 3.448.823 4.702 1.869 1.255 1.048 2.133 2.279 2.577 2.982a7.93 7.93 0 0 1 .091.148V10l-.024.043-.068.108c-.234.371-.594.896-1.07 1.464a.833.833 0 1 0 1.278 1.07c.533-.637.936-1.224 1.201-1.644l.02-.032c.099-.155.227-.356.291-.636a1.8 1.8 0 0 0 0-.745c-.064-.281-.191-.481-.29-.636l-.02-.031c-.493-.782-1.48-2.17-2.918-3.372-1.44-1.202-3.385-2.256-5.77-2.256-.401 0-.791.03-1.17.086a.833.833 0 1 0 .244 1.649Z",
                fill: "#747778"
            })
        ]
    });
var $ec17f4803d08ba4d$export$2e2bcd8739ae039 = $ec17f4803d08ba4d$var$SvgEyeClosed;

});

parcelRequire.register("cJEhq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $582ca4d507026fee$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $582ca4d507026fee$var$SvgEye = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 18,
        height: 12,
        viewBox: "0 0 18 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M11.5 6a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M17.246 5.627C15.447 2.03 12.253.167 9 .167 5.748.167 2.553 2.03.755 5.627a.833.833 0 0 0 0 .746C2.553 9.97 5.748 11.833 9 11.833c3.253 0 6.447-1.863 8.246-5.46a.833.833 0 0 0 0-.746ZM9 10.167C6.526 10.167 4 8.816 2.442 6 3.999 3.184 6.526 1.833 9 1.833S14.002 3.183 15.56 6C14.002 8.816 11.474 10.167 9 10.167Z",
                fill: "currentColor"
            })
        ]
    });
var $582ca4d507026fee$export$2e2bcd8739ae039 = $582ca4d507026fee$var$SvgEye;

});

parcelRequire.register("38oKl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "block", function () { return $2485509584a32ebf$export$837bd02682cd3db9; }, function (v) { return $2485509584a32ebf$export$837bd02682cd3db9 = v; });
$parcel$export(module.exports, "border", function () { return $2485509584a32ebf$export$1edee58a52776cd9; }, function (v) { return $2485509584a32ebf$export$1edee58a52776cd9 = v; });
$parcel$export(module.exports, "contained", function () { return $2485509584a32ebf$export$98e6239189c28b84; }, function (v) { return $2485509584a32ebf$export$98e6239189c28b84 = v; });
$parcel$export(module.exports, "container", function () { return $2485509584a32ebf$export$34e0f9847d4c02dd; }, function (v) { return $2485509584a32ebf$export$34e0f9847d4c02dd = v; });
$parcel$export(module.exports, "content", function () { return $2485509584a32ebf$export$a7db06668cad9adb; }, function (v) { return $2485509584a32ebf$export$a7db06668cad9adb = v; });
$parcel$export(module.exports, "copyToolTipAnchor", function () { return $2485509584a32ebf$export$56668e8595601db0; }, function (v) { return $2485509584a32ebf$export$56668e8595601db0 = v; });
$parcel$export(module.exports, "default", function () { return $2485509584a32ebf$export$2e2bcd8739ae039; }, function (v) { return $2485509584a32ebf$export$2e2bcd8739ae039 = v; });
$parcel$export(module.exports, "icon", function () { return $2485509584a32ebf$export$1ca1ec8b29a4ce27; }, function (v) { return $2485509584a32ebf$export$1ca1ec8b29a4ce27 = v; });
$parcel$export(module.exports, "iconButton", function () { return $2485509584a32ebf$export$60bb6c1f29b8a8cc; }, function (v) { return $2485509584a32ebf$export$60bb6c1f29b8a8cc = v; });
$parcel$export(module.exports, "rotating", function () { return $2485509584a32ebf$export$bfd64c937657f93a; }, function (v) { return $2485509584a32ebf$export$bfd64c937657f93a = v; });
$parcel$export(module.exports, "row", function () { return $2485509584a32ebf$export$120ff0929b202a6d; }, function (v) { return $2485509584a32ebf$export$120ff0929b202a6d = v; });
$parcel$export(module.exports, "shimmer", function () { return $2485509584a32ebf$export$4a6dd88bada4e7d2; }, function (v) { return $2485509584a32ebf$export$4a6dd88bada4e7d2 = v; });
$parcel$export(module.exports, "small", function () { return $2485509584a32ebf$export$3c17b0e969a90510; }, function (v) { return $2485509584a32ebf$export$3c17b0e969a90510 = v; });
$parcel$export(module.exports, "wrapContent", function () { return $2485509584a32ebf$export$7e3af17b76ad5e5f; }, function (v) { return $2485509584a32ebf$export$7e3af17b76ad5e5f = v; });
var $2485509584a32ebf$export$837bd02682cd3db9;
var $2485509584a32ebf$export$1edee58a52776cd9;
var $2485509584a32ebf$export$98e6239189c28b84;
var $2485509584a32ebf$export$34e0f9847d4c02dd;
var $2485509584a32ebf$export$a7db06668cad9adb;
var $2485509584a32ebf$export$56668e8595601db0;
var $2485509584a32ebf$export$2e2bcd8739ae039;
var $2485509584a32ebf$export$1ca1ec8b29a4ce27;
var $2485509584a32ebf$export$60bb6c1f29b8a8cc;
var $2485509584a32ebf$export$bfd64c937657f93a;
var $2485509584a32ebf$export$120ff0929b202a6d;
var $2485509584a32ebf$export$4a6dd88bada4e7d2;
var $2485509584a32ebf$export$3c17b0e969a90510;
var $2485509584a32ebf$export$7e3af17b76ad5e5f;
$2485509584a32ebf$export$837bd02682cd3db9 = `UyyloG_block`;
$2485509584a32ebf$export$1edee58a52776cd9 = `UyyloG_border`;
$2485509584a32ebf$export$98e6239189c28b84 = `UyyloG_contained`;
$2485509584a32ebf$export$34e0f9847d4c02dd = `UyyloG_container`;
$2485509584a32ebf$export$a7db06668cad9adb = `UyyloG_content`;
$2485509584a32ebf$export$56668e8595601db0 = `UyyloG_copyToolTipAnchor`;
$2485509584a32ebf$export$2e2bcd8739ae039 = `UyyloG_default`;
$2485509584a32ebf$export$1ca1ec8b29a4ce27 = `UyyloG_icon`;
$2485509584a32ebf$export$60bb6c1f29b8a8cc = `UyyloG_iconButton`;
$2485509584a32ebf$export$bfd64c937657f93a = `UyyloG_rotating`;
$2485509584a32ebf$export$120ff0929b202a6d = `UyyloG_row`;
$2485509584a32ebf$export$4a6dd88bada4e7d2 = `UyyloG_shimmer`;
$2485509584a32ebf$export$3c17b0e969a90510 = `UyyloG_small`;
$2485509584a32ebf$export$7e3af17b76ad5e5f = `UyyloG_wrapContent`;

});


parcelRequire.register("8RfrQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdf6f176e824c7eb$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $d8ISM = parcelRequire("d8ISM");
function $fdf6f176e824c7eb$var$Switch({ label: label, hasError: hasError, ...rest }, ref) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($d8ISM.wrapper, hasError && $d8ISM.error),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $d8ISM.label,
                children: label
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("label", {
                className: $d8ISM.switch,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("input", {
                        type: "checkbox",
                        ...rest,
                        ref: ref
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                        className: $d8ISM.slider
                    })
                ]
            })
        ]
    });
}
var $fdf6f176e824c7eb$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $jC8Vy.forwardRef)($fdf6f176e824c7eb$var$Switch);

});
parcelRequire.register("d8ISM", function(module, exports) {

$parcel$export(module.exports, "error", function () { return $990ed67164435953$export$a3bc9b8ed74fc; }, function (v) { return $990ed67164435953$export$a3bc9b8ed74fc = v; });
$parcel$export(module.exports, "label", function () { return $990ed67164435953$export$1237798dc640739a; }, function (v) { return $990ed67164435953$export$1237798dc640739a = v; });
$parcel$export(module.exports, "slider", function () { return $990ed67164435953$export$b38bf4f33e9e4c25; }, function (v) { return $990ed67164435953$export$b38bf4f33e9e4c25 = v; });
$parcel$export(module.exports, "switch", function () { return $990ed67164435953$export$52002a3975269b5d; }, function (v) { return $990ed67164435953$export$52002a3975269b5d = v; });
$parcel$export(module.exports, "wrapper", function () { return $990ed67164435953$export$cc74dcc53cfce4eb; }, function (v) { return $990ed67164435953$export$cc74dcc53cfce4eb = v; });
var $990ed67164435953$export$a3bc9b8ed74fc;
var $990ed67164435953$export$1237798dc640739a;
var $990ed67164435953$export$bfd64c937657f93a;
var $990ed67164435953$export$4a6dd88bada4e7d2;
var $990ed67164435953$export$b38bf4f33e9e4c25;
var $990ed67164435953$export$52002a3975269b5d;
var $990ed67164435953$export$cc74dcc53cfce4eb;
$990ed67164435953$export$a3bc9b8ed74fc = `zyS_Na_error`;
$990ed67164435953$export$1237798dc640739a = `zyS_Na_label`;
$990ed67164435953$export$bfd64c937657f93a = `zyS_Na_rotating`;
$990ed67164435953$export$4a6dd88bada4e7d2 = `zyS_Na_shimmer`;
$990ed67164435953$export$b38bf4f33e9e4c25 = `zyS_Na_slider`;
$990ed67164435953$export$52002a3975269b5d = `zyS_Na_switch`;
$990ed67164435953$export$cc74dcc53cfce4eb = `zyS_Na_wrapper`;

});


parcelRequire.register("2ZX8W", function(module, exports) {

$parcel$export(module.exports, "GuideContext", function () { return $d2f351638e74e08b$export$b3f904f25eabb807; });
$parcel$export(module.exports, "default", function () { return $d2f351638e74e08b$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");

var $6YrGU = parcelRequire("6YrGU");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $fiyfZ = parcelRequire("fiyfZ");

var $jGWQ4 = parcelRequire("jGWQ4");

var $kUskP = parcelRequire("kUskP");

var $aTllQ = parcelRequire("aTllQ");

var $9Q3SI = parcelRequire("9Q3SI");

var $5qJ69 = parcelRequire("5qJ69");

var $g0vtZ = parcelRequire("g0vtZ");

var $4F3tE = parcelRequire("4F3tE");

var $2DbJo = parcelRequire("2DbJo");
const $d2f351638e74e08b$export$b3f904f25eabb807 = /*#__PURE__*/ (0, $jC8Vy.createContext)({
    // The following `as` is for context initialization, they won't be used in production except for
    // HMR.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-restricted-syntax
    metadata: {},
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-restricted-syntax
    app: {},
    endpoint: "",
    redirectUris: [],
    postLogoutRedirectUris: [],
    isCompact: false,
    sampleUrls: {
        origin: "",
        callback: ""
    },
    audience: ""
});
function $d2f351638e74e08b$var$Guide({ className: className, guideId: guideId, isEmpty: isEmpty, isLoading: isLoading, onClose: onClose }) {
    const guide = (0, $fiyfZ.default).find(({ id: id })=>id === guideId);
    const GuideComponent = guide?.Component;
    const isApiResourceGuide = guide?.metadata.target === "API";
    const context = (0, $jC8Vy.useContext)($d2f351638e74e08b$export$b3f904f25eabb807);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aTllQ.default), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($2DbJo.content, className),
                children: [
                    isLoading && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4F3tE.default), {}),
                    isEmpty && !guide && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $g0vtZ.default), {
                        className: $2DbJo.notFound
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6YrGU.MDXProvider), {
                        components: {
                            code: ({ className: className, children: children })=>{
                                const [, language] = /language-(\w+)/.exec(String(className ?? "")) ?? [];
                                return language ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $kUskP.default), {
                                    isReadonly: true,
                                    // We need to transform `ts` to `typescript` for prismjs, and
                                    // it's weird since it worked in the original Guide component.
                                    // To be investigated.
                                    language: language === "ts" ? "typescript" : language,
                                    value: String(children).trimEnd()
                                }) : /*#__PURE__*/ (0, $C7mD2.jsx)("code", {
                                    children: String(children).trimEnd()
                                });
                            },
                            a: ({ children: children, ...props })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                                    ...props,
                                    targetBlank: true,
                                    children: children
                                }),
                            details: (0, $5qJ69.default)
                        },
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jC8Vy.Suspense), {
                            fallback: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4F3tE.default), {}),
                            children: GuideComponent && /*#__PURE__*/ (0, $C7mD2.jsx)(GuideComponent, {
                                ...context
                            })
                        })
                    })
                ]
            }),
            !isApiResourceGuide && /*#__PURE__*/ (0, $C7mD2.jsx)("nav", {
                className: $2DbJo.actionBar,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $2DbJo.layout,
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        size: "large",
                        title: "guide.finish_and_done",
                        type: "primary",
                        onClick: onClose
                    })
                })
            })
        ]
    });
}
var $d2f351638e74e08b$export$2e2bcd8739ae039 = $d2f351638e74e08b$var$Guide;

});
parcelRequire.register("6YrGU", function(module, exports) {

$parcel$export(module.exports, "MDXProvider", function () { return $513dd3924344462f$export$1cf78dad7550a52b; });
$parcel$export(module.exports, "mdx", function () { return $513dd3924344462f$export$5beccd7059e5fba5; });

var $jC8Vy = parcelRequire("jC8Vy");
function $513dd3924344462f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $513dd3924344462f$var$_extends() {
    $513dd3924344462f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $513dd3924344462f$var$_extends.apply(this, arguments);
}
function $513dd3924344462f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $513dd3924344462f$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $513dd3924344462f$var$ownKeys(Object(source), true).forEach(function(key) {
            $513dd3924344462f$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $513dd3924344462f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $513dd3924344462f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $513dd3924344462f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $513dd3924344462f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
var $513dd3924344462f$var$isFunction = function isFunction(obj) {
    return typeof obj === "function";
};
var $513dd3924344462f$export$d7de0f1cab697634 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createContext({});
var $513dd3924344462f$export$aae81db1754c1e05 = function withMDXComponents(Component) {
    return function(props) {
        var allComponents = $513dd3924344462f$export$ba49c9ffd2310961(props.components);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement(Component, $513dd3924344462f$var$_extends({}, props, {
            components: allComponents
        }));
    };
};
var $513dd3924344462f$export$ba49c9ffd2310961 = function useMDXComponents(components) {
    var contextComponents = (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).useContext($513dd3924344462f$export$d7de0f1cab697634);
    var allComponents = contextComponents;
    if (components) allComponents = $513dd3924344462f$var$isFunction(components) ? components(contextComponents) : $513dd3924344462f$var$_objectSpread2($513dd3924344462f$var$_objectSpread2({}, contextComponents), components);
    return allComponents;
};
var $513dd3924344462f$export$1cf78dad7550a52b = function MDXProvider(props) {
    var allComponents = $513dd3924344462f$export$ba49c9ffd2310961(props.components);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement($513dd3924344462f$export$d7de0f1cab697634.Provider, {
        value: allComponents
    }, props.children);
};
var $513dd3924344462f$var$TYPE_PROP_NAME = "mdxType";
var $513dd3924344462f$var$DEFAULTS = {
    inlineCode: "code",
    wrapper: function wrapper(_ref) {
        var children = _ref.children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).Fragment, {}, children);
    }
};
var $513dd3924344462f$var$MDXCreateElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).forwardRef(function(props, ref) {
    var propComponents = props.components, mdxType = props.mdxType, originalType = props.originalType, parentName = props.parentName, etc = $513dd3924344462f$var$_objectWithoutProperties(props, [
        "components",
        "mdxType",
        "originalType",
        "parentName"
    ]);
    var components = $513dd3924344462f$export$ba49c9ffd2310961(propComponents);
    var type = mdxType;
    var Component = components["".concat(parentName, ".").concat(type)] || components[type] || $513dd3924344462f$var$DEFAULTS[type] || originalType;
    if (propComponents) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement(Component, $513dd3924344462f$var$_objectSpread2($513dd3924344462f$var$_objectSpread2({
        ref: ref
    }, etc), {}, {
        components: propComponents
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement(Component, $513dd3924344462f$var$_objectSpread2({
        ref: ref
    }, etc));
});
$513dd3924344462f$var$MDXCreateElement.displayName = "MDXCreateElement";
function $513dd3924344462f$export$5beccd7059e5fba5(type, props) {
    var args = arguments;
    var mdxType = props && props.mdxType;
    if (typeof type === "string" || mdxType) {
        var argsLength = args.length;
        var createElementArgArray = new Array(argsLength);
        createElementArgArray[0] = $513dd3924344462f$var$MDXCreateElement;
        var newProps = {};
        for(var key in props)if (hasOwnProperty.call(props, key)) newProps[key] = props[key];
        newProps.originalType = type;
        newProps[$513dd3924344462f$var$TYPE_PROP_NAME] = typeof type === "string" ? type : mdxType;
        createElementArgArray[1] = newProps;
        for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
        return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement.apply(null, createElementArgArray);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement.apply(null, args);
}

});

parcelRequire.register("fiyfZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9cf2daf5b93e6115$export$2e2bcd8739ae039; });
// This is a generated file, don't update manually.

var $jC8Vy = parcelRequire("jC8Vy");

var $z2Kqs = parcelRequire("z2Kqs");

var $33C68 = parcelRequire("33C68");

var $j0cRA = parcelRequire("j0cRA");

var $kz8Jq = parcelRequire("kz8Jq");

var $cGqI4 = parcelRequire("cGqI4");

var $eC77f = parcelRequire("eC77f");

var $3ZeUQ = parcelRequire("3ZeUQ");

var $kHgya = parcelRequire("kHgya");

var $85fUJ = parcelRequire("85fUJ");

var $cBXWX = parcelRequire("cBXWX");

var $lb8Tu = parcelRequire("lb8Tu");

var $4sspC = parcelRequire("4sspC");

var $1NW9u = parcelRequire("1NW9u");

var $fAJUu = parcelRequire("fAJUu");

var $dp0H3 = parcelRequire("dp0H3");

var $afJgg = parcelRequire("afJgg");

var $iG5aE = parcelRequire("iG5aE");

var $1iOWA = parcelRequire("1iOWA");

var $agZK3 = parcelRequire("agZK3");

var $g7lHC = parcelRequire("g7lHC");

var $9lE3w = parcelRequire("9lE3w");

var $59JUK = parcelRequire("59JUK");

var $4PHud = parcelRequire("4PHud");

var $kd6Cn = parcelRequire("kd6Cn");

var $f3NxG = parcelRequire("f3NxG");

var $ePOMP = parcelRequire("ePOMP");

var $5drQG = parcelRequire("5drQG");

var $f8OX6 = parcelRequire("f8OX6");

var $4xhgJ = parcelRequire("4xhgJ");

var $4wpDD = parcelRequire("4wpDD");

var $c7hGk = parcelRequire("c7hGk");

var $1IFp3 = parcelRequire("1IFp3");

var $hx304 = parcelRequire("hx304");


































































const $9cf2daf5b93e6115$var$guides = Object.freeze([
    {
        order: 1.1,
        id: "native-expo",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("8Wp5H"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("gNAel"))),
        metadata: (0, $3ZeUQ.default)
    },
    {
        order: 1.1,
        id: "spa-angular",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("bvEmC"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("3kYP8"))),
        metadata: (0, $cBXWX.default)
    },
    {
        order: 1.1,
        id: "spa-react",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("fS1qe"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("kWNaX"))),
        metadata: (0, $lb8Tu.default)
    },
    {
        order: 1.1,
        id: "web-next-app-router",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("950fK"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("b1iax"))),
        metadata: (0, $f3NxG.default)
    },
    {
        order: 1.2,
        id: "m2m-general",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("bDBlx"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("kgxhz"))),
        metadata: (0, $kz8Jq.default)
    },
    {
        order: 1.2,
        id: "web-express",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("hAdKV"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("91D1K"))),
        metadata: (0, $g7lHC.default)
    },
    {
        order: 1.2,
        id: "web-next",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("6uRMY"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("dNcef"))),
        metadata: (0, $kd6Cn.default)
    },
    {
        order: 1.2,
        id: "web-sveltekit",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("dsZ8p"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("4WvIx"))),
        metadata: (0, $1IFp3.default)
    },
    {
        order: 1.3,
        id: "web-go",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("dsGsZ"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("iaMKk"))),
        metadata: (0, $9lE3w.default)
    },
    {
        order: 1.3,
        id: "web-next-auth",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("4HI07"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("gyrap"))),
        metadata: (0, $ePOMP.default)
    },
    {
        order: 1.4,
        id: "web-java-spring-boot",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("d46yN"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("kdbvk"))),
        metadata: (0, $4PHud.default)
    },
    {
        order: 1.5,
        id: "web-gpt-plugin",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("bYV01"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("2VScH"))),
        metadata: (0, $59JUK.default)
    },
    {
        order: 1.6,
        id: "spa-vue",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("lVYOT"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("8MTXs"))),
        metadata: (0, $1NW9u.default)
    },
    {
        order: 1.7,
        id: "native-ios-swift",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("gY2M7"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("dv4za"))),
        metadata: (0, $85fUJ.default)
    },
    {
        order: 2,
        id: "native-android",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("1VMPO"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("9b8v9"))),
        metadata: (0, $cGqI4.default)
    },
    {
        order: 2,
        id: "spa-vanilla",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("9BDDR"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("j9qYD"))),
        metadata: (0, $4sspC.default)
    },
    {
        order: 2,
        id: "web-nuxt",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("9Yp6d"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("8QaiC"))),
        metadata: (0, $5drQG.default)
    },
    {
        order: 2,
        id: "web-php",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("hMIZk"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("aW9Vs"))),
        metadata: (0, $4xhgJ.default)
    },
    {
        order: 2.1,
        id: "spa-webflow",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("8TePg"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("gySfN"))),
        metadata: (0, $fAJUu.default)
    },
    {
        order: 2.2,
        id: "web-wordpress",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("jahOe"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("6GGYm"))),
        metadata: (0, $hx304.default)
    },
    {
        order: 3,
        id: "web-python",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("f5OPi"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("evpuN"))),
        metadata: (0, $4wpDD.default)
    },
    {
        order: 4,
        id: "native-capacitor",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("dQxQX"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("3FNXd"))),
        metadata: (0, $eC77f.default)
    },
    {
        order: 4,
        id: "web-remix",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("1en2t"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("kjGzg"))),
        metadata: (0, $c7hGk.default)
    },
    {
        order: 5,
        id: "native-flutter",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("85M6h"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("3XsT3"))),
        metadata: (0, $kHgya.default)
    },
    {
        order: 5,
        id: "web-dotnet-core",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("kTRee"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("kFqAe"))),
        metadata: (0, $afJgg.default)
    },
    {
        order: 5.1,
        id: "web-dotnet-core-mvc",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("7KzV4"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("e2qve"))),
        metadata: (0, $agZK3.default)
    },
    {
        order: 5.2,
        id: "web-dotnet-core-blazor-server",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("7vo8m"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("glGFo"))),
        metadata: (0, $iG5aE.default)
    },
    {
        order: 5.3,
        id: "web-dotnet-core-blazor-wasm",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("6USxJ"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("5zZ0E"))),
        metadata: (0, $1iOWA.default)
    },
    {
        order: 6,
        id: "web-outline",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("5wwdD"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("etkbA"))),
        metadata: (0, $f8OX6.default)
    },
    {
        order: Number.POSITIVE_INFINITY,
        id: "api-express",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("f4lBs"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("4dmq0"))),
        metadata: (0, $z2Kqs.default)
    },
    {
        order: Number.POSITIVE_INFINITY,
        id: "api-python",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("hVtVZ"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("5e0af"))),
        metadata: (0, $33C68.default)
    },
    {
        order: Number.POSITIVE_INFINITY,
        id: "api-spring-boot",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("div5d"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("8PnWa"))),
        metadata: (0, $j0cRA.default)
    },
    {
        order: Number.POSITIVE_INFINITY,
        id: "third-party-oidc",
        Logo: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("aYDzk"))),
        Component: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("66f2j"))),
        metadata: (0, $dp0H3.default)
    }
]);
var $9cf2daf5b93e6115$export$2e2bcd8739ae039 = $9cf2daf5b93e6115$var$guides;

});
parcelRequire.register("z2Kqs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $263daf98f252a253$export$2e2bcd8739ae039; });
const $263daf98f252a253$var$metadata = Object.freeze({
    name: "Express",
    description: "Express is a minimal and flexible Node.js web application framework that provides a robust set of features for web and mobile applications.",
    target: "API"
});
var $263daf98f252a253$export$2e2bcd8739ae039 = $263daf98f252a253$var$metadata;

});

parcelRequire.register("33C68", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb886ceecd35466b$export$2e2bcd8739ae039; });
const $bb886ceecd35466b$var$metadata = Object.freeze({
    name: "Python",
    description: "Integrate Logto into your Python web app, such as Django and Flask.",
    target: "API"
});
var $bb886ceecd35466b$export$2e2bcd8739ae039 = $bb886ceecd35466b$var$metadata;

});

parcelRequire.register("j0cRA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7bf797ca19d39a1f$export$2e2bcd8739ae039; });
const $7bf797ca19d39a1f$var$metadata = Object.freeze({
    name: "Spring Boot",
    description: "Spring Boot is an open source Java-based framework used to create a micro Service.",
    target: "API"
});
var $7bf797ca19d39a1f$export$2e2bcd8739ae039 = $7bf797ca19d39a1f$var$metadata;

});

parcelRequire.register("kz8Jq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82bcd6eaa048926a$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
const $82bcd6eaa048926a$var$metadata = Object.freeze({
    name: "Machine-to-machine",
    description: "Enables direct communication between machines.",
    target: (0, $61Yml.ApplicationType).MachineToMachine,
    isFeatured: true,
    fullGuide: {
        title: "Full machine-to-machine integration tutorial",
        url: "https://docs.logto.io/quick-starts/m2m"
    }
});
var $82bcd6eaa048926a$export$2e2bcd8739ae039 = $82bcd6eaa048926a$var$metadata;

});

parcelRequire.register("cGqI4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee052cff82f72058$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
const $ee052cff82f72058$var$metadata = Object.freeze({
    name: "Android",
    description: "Android integration guide.",
    target: (0, $61Yml.ApplicationType).Native,
    sample: {
        repo: "kotlin",
        path: "android-sample-kotlin"
    },
    fullGuide: {
        title: "Full Android SDK tutorial",
        url: "https://docs.logto.io/quick-starts/android"
    }
});
var $ee052cff82f72058$export$2e2bcd8739ae039 = $ee052cff82f72058$var$metadata;

});

parcelRequire.register("eC77f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e4a3b02e3d3cda9$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
const $3e4a3b02e3d3cda9$var$metadata = Object.freeze({
    name: "Capacitor JS",
    description: "Capacitor JS is a framework for building hybrid mobile apps.",
    target: (0, $61Yml.ApplicationType).Native
});
var $3e4a3b02e3d3cda9$export$2e2bcd8739ae039 = $3e4a3b02e3d3cda9$var$metadata;

});

parcelRequire.register("3ZeUQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $321f4838ad6bac3a$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
const $321f4838ad6bac3a$var$metadata = Object.freeze({
    name: "Expo (React Native)",
    description: "Create universal native apps with React that run on Android, iOS, and the web.",
    target: (0, $61Yml.ApplicationType).Native,
    sample: {
        repo: "react-native",
        path: "packages/rn-sample"
    },
    fullGuide: {
        title: "Full Expo (React Native) guide",
        url: "https://docs.logto.io/quick-starts/expo"
    }
});
var $321f4838ad6bac3a$export$2e2bcd8739ae039 = $321f4838ad6bac3a$var$metadata;

});

parcelRequire.register("kHgya", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $576f2717a412edb2$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
const $576f2717a412edb2$var$metadata = Object.freeze({
    name: "Flutter",
    description: "Flutter is a framework for building hybrid mobile apps.",
    target: (0, $61Yml.ApplicationType).Native
});
var $576f2717a412edb2$export$2e2bcd8739ae039 = $576f2717a412edb2$var$metadata;

});

parcelRequire.register("85fUJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a070c31b36a615d$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
const $2a070c31b36a615d$var$metadata = Object.freeze({
    name: "iOS (Swift)",
    description: "iOS (Swift) application integration guide.",
    target: (0, $61Yml.ApplicationType).Native,
    sample: {
        repo: "swift",
        path: "Demos/SwiftUI%20Demo"
    },
    isFeatured: true
});
var $2a070c31b36a615d$export$2e2bcd8739ae039 = $2a070c31b36a615d$var$metadata;

});

parcelRequire.register("cBXWX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e43b1f250f41a1a$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
const $6e43b1f250f41a1a$var$metadata = Object.freeze({
    name: "Angular",
    description: "Angular is a JavaScript library for building user interfaces.",
    target: (0, $61Yml.ApplicationType).SPA,
    sample: {
        repo: "js",
        path: "packages/angular-sample"
    },
    fullGuide: {
        title: "Full Angular guide",
        url: "https://docs.logto.io/quick-starts/angular"
    }
});
var $6e43b1f250f41a1a$export$2e2bcd8739ae039 = $6e43b1f250f41a1a$var$metadata;

});

parcelRequire.register("lb8Tu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bddff8d19e9c4488$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
const $bddff8d19e9c4488$var$metadata = Object.freeze({
    name: "React",
    description: "React is a JavaScript library for building user interfaces.",
    target: (0, $61Yml.ApplicationType).SPA,
    sample: {
        repo: "js",
        path: "packages/react-sample"
    },
    isFeatured: true,
    fullGuide: {
        title: "Full React SDK tutorial",
        url: "https://docs.logto.io/quick-starts/react"
    }
});
var $bddff8d19e9c4488$export$2e2bcd8739ae039 = $bddff8d19e9c4488$var$metadata;

});

parcelRequire.register("4sspC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cd02222ef0d20ac$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
const $0cd02222ef0d20ac$var$metadata = Object.freeze({
    name: "Vanilla JS",
    description: "The framework-agnostic JavaScript integration.",
    target: (0, $61Yml.ApplicationType).SPA,
    sample: {
        repo: "js",
        path: "packages/browser-sample"
    },
    fullGuide: {
        title: "Full vanilla JS SDK tutorial",
        url: "https://docs.logto.io/quick-starts/vanilla-js"
    }
});
var $0cd02222ef0d20ac$export$2e2bcd8739ae039 = $0cd02222ef0d20ac$var$metadata;

});

parcelRequire.register("1NW9u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3eb0abba53f88034$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
const $3eb0abba53f88034$var$metadata = Object.freeze({
    name: "Vue",
    description: "Vue.js is a progressive, incrementally-adoptable JavaScript framework for building UI on the web.",
    target: (0, $61Yml.ApplicationType).SPA,
    sample: {
        repo: "js",
        path: "packages/vue-sample"
    },
    isFeatured: true,
    fullGuide: {
        title: "Full Vue SDK tutorial",
        url: "https://docs.logto.io/quick-starts/vue"
    }
});
var $3eb0abba53f88034$export$2e2bcd8739ae039 = $3eb0abba53f88034$var$metadata;

});

parcelRequire.register("fAJUu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37f85dc6541a90bb$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
const $37f85dc6541a90bb$var$metadata = Object.freeze({
    name: "Webflow",
    description: "Webflow is a SaaS platform for website building and hosting.",
    target: (0, $61Yml.ApplicationType).SPA
});
var $37f85dc6541a90bb$export$2e2bcd8739ae039 = $37f85dc6541a90bb$var$metadata;

});

parcelRequire.register("dp0H3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b77b92ef1922762$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
const $1b77b92ef1922762$var$metadata = Object.freeze({
    name: "OIDC",
    description: "Use Logto as a third-party OIDC identity provider (IdP) for your application. ",
    target: (0, $61Yml.ApplicationType).Traditional,
    isThirdParty: true
});
var $1b77b92ef1922762$export$2e2bcd8739ae039 = $1b77b92ef1922762$var$metadata;

});

parcelRequire.register("afJgg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ac478f47add2499$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
const $5ac478f47add2499$var$metadata = Object.freeze({
    name: ".NET Core (Razor Pages)",
    description: "Integrate Logto into your .NET Core web app with Razor Pages and view models.",
    target: (0, $61Yml.ApplicationType).Traditional,
    sample: {
        repo: "csharp",
        path: "/"
    }
});
var $5ac478f47add2499$export$2e2bcd8739ae039 = $5ac478f47add2499$var$metadata;

});

parcelRequire.register("iG5aE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $880c23cfd9ad46ee$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
const $880c23cfd9ad46ee$var$metadata = Object.freeze({
    name: ".NET Core (Blazor Server)",
    description: "Integrate Logto into your .NET Core Blazor Server app.",
    target: (0, $61Yml.ApplicationType).Traditional,
    sample: {
        repo: "csharp",
        path: "/"
    },
    fullGuide: {
        title: "Full .NET Core (Blazor Server) integration tutorial",
        url: "https://docs.logto.io/quick-starts/dotnet-core/blazor-server"
    }
});
var $880c23cfd9ad46ee$export$2e2bcd8739ae039 = $880c23cfd9ad46ee$var$metadata;

});

parcelRequire.register("1iOWA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c623135ed254e378$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
const $c623135ed254e378$var$metadata = Object.freeze({
    name: ".NET Core (Blazor WASM)",
    description: "Integrate Logto into your .NET Core Blazor WebAssembly app.",
    target: (0, $61Yml.ApplicationType).SPA,
    sample: {
        repo: "csharp",
        path: "/"
    },
    fullGuide: {
        title: "Full .NET Core (Blazor WASM) integration tutorial",
        url: "https://docs.logto.io/quick-starts/dotnet-core/blazor-wasm"
    }
});
var $c623135ed254e378$export$2e2bcd8739ae039 = $c623135ed254e378$var$metadata;

});

parcelRequire.register("agZK3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd202bc94d158d18$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
const $bd202bc94d158d18$var$metadata = Object.freeze({
    name: ".NET Core (MVC)",
    description: "Integrate Logto into your .NET Core web app with Model-View-Controller (MVC).",
    target: (0, $61Yml.ApplicationType).Traditional,
    sample: {
        repo: "csharp",
        path: "/"
    },
    fullGuide: {
        title: "Full .NET Core (MVC) integration tutorial",
        url: "https://docs.logto.io/quick-starts/dotnet-core/mvc"
    }
});
var $bd202bc94d158d18$export$2e2bcd8739ae039 = $bd202bc94d158d18$var$metadata;

});

parcelRequire.register("g7lHC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7851791be21b8471$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
const $7851791be21b8471$var$metadata = Object.freeze({
    name: "Express",
    description: "Express is a minimal and flexible Node.js web application framework that provides a robust set of features for web and mobile applications.",
    target: (0, $61Yml.ApplicationType).Traditional,
    sample: {
        repo: "js",
        path: "packages/express-sample"
    },
    fullGuide: {
        title: "Full Express SDK tutorial",
        url: "https://docs.logto.io/quick-starts/express"
    }
});
var $7851791be21b8471$export$2e2bcd8739ae039 = $7851791be21b8471$var$metadata;

});

parcelRequire.register("9lE3w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1956ede3f2c9be0$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
const $a1956ede3f2c9be0$var$metadata = Object.freeze({
    name: "Go",
    description: "Go is an efficient, concurrent, statically typed programming language for web applications ",
    target: (0, $61Yml.ApplicationType).Traditional,
    sample: {
        repo: "go",
        path: "gin-sample"
    },
    fullGuide: {
        title: "Full Go SDK tutorial",
        url: "https://docs.logto.io/quick-starts/go"
    }
});
var $a1956ede3f2c9be0$export$2e2bcd8739ae039 = $a1956ede3f2c9be0$var$metadata;

});

parcelRequire.register("59JUK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f730c4a0f2161398$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
const $f730c4a0f2161398$var$metadata = Object.freeze({
    name: "ChatGPT plugin",
    description: "Use Logto as an OAuth identity provider for ChatGPT plugins.",
    target: (0, $61Yml.ApplicationType).Traditional,
    isFeatured: true
});
var $f730c4a0f2161398$export$2e2bcd8739ae039 = $f730c4a0f2161398$var$metadata;

});

parcelRequire.register("4PHud", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d65abee3cd6e53fd$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
const $d65abee3cd6e53fd$var$metadata = Object.freeze({
    name: "Java Spring Boot Web",
    description: "Spring Boot is a web framework for Java that enables developers to build secure, fast, and scalable server applications with the Java programming language.",
    target: (0, $61Yml.ApplicationType).Traditional,
    sample: {
        repo: "spring-boot-sample",
        path: ""
    }
});
var $d65abee3cd6e53fd$export$2e2bcd8739ae039 = $d65abee3cd6e53fd$var$metadata;

});

parcelRequire.register("kd6Cn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e947a093dbb83db4$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
const $e947a093dbb83db4$var$metadata = Object.freeze({
    name: "Next.js",
    description: "Next.js is a React framework for production - it makes building fullstack React apps a breeze and ships with built-in SSR.",
    target: (0, $61Yml.ApplicationType).Traditional,
    sample: {
        repo: "js",
        path: "packages/next-sample"
    },
    fullGuide: {
        title: "Full Next.js SDK tutorial",
        url: "https://docs.logto.io/quick-starts/next"
    }
});
var $e947a093dbb83db4$export$2e2bcd8739ae039 = $e947a093dbb83db4$var$metadata;

});

parcelRequire.register("f3NxG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91b569332a48e6f1$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
const $91b569332a48e6f1$var$metadata = Object.freeze({
    name: "Next.js (App Router)",
    description: "Next.js integration guide for App Router.",
    target: (0, $61Yml.ApplicationType).Traditional,
    sample: {
        repo: "js",
        path: "packages/next-server-actions-sample"
    },
    isFeatured: true,
    fullGuide: {
        title: "Full Next.js SDK tutorial",
        url: "https://docs.logto.io/sdk/next-app-router/"
    }
});
var $91b569332a48e6f1$export$2e2bcd8739ae039 = $91b569332a48e6f1$var$metadata;

});

parcelRequire.register("ePOMP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4357b10cd28859f$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
const $c4357b10cd28859f$var$metadata = Object.freeze({
    name: "Next Auth",
    description: "Authentication for Next.js.",
    target: (0, $61Yml.ApplicationType).Traditional
});
var $c4357b10cd28859f$export$2e2bcd8739ae039 = $c4357b10cd28859f$var$metadata;

});

parcelRequire.register("5drQG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bfbb1025da6782f$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
const $3bfbb1025da6782f$var$metadata = Object.freeze({
    name: "Nuxt",
    description: "Nuxt is an open source framework that makes web development intuitive and powerful.",
    target: (0, $61Yml.ApplicationType).Traditional,
    sample: {
        repo: "js",
        path: "packages/nuxt"
    },
    fullGuide: {
        title: "Full Nuxt guide",
        url: "https://docs.logto.io/quick-starts/nuxt"
    }
});
var $3bfbb1025da6782f$export$2e2bcd8739ae039 = $3bfbb1025da6782f$var$metadata;

});

parcelRequire.register("f8OX6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7feaa377a40f570c$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
const $7feaa377a40f570c$var$metadata = Object.freeze({
    name: "Outline",
    description: "Use Logto as an identity provider for Outline",
    target: (0, $61Yml.ApplicationType).Traditional
});
var $7feaa377a40f570c$export$2e2bcd8739ae039 = $7feaa377a40f570c$var$metadata;

});

parcelRequire.register("4xhgJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8146c1705ea66118$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
const $8146c1705ea66118$var$metadata = Object.freeze({
    name: "PHP",
    description: "Integrate Logto into your PHP web app, such as Laravel.",
    target: (0, $61Yml.ApplicationType).Traditional,
    sample: {
        repo: "php",
        path: "samples"
    },
    fullGuide: {
        title: "Full PHP SDK tutorial",
        url: "https://docs.logto.io/quick-starts/php"
    }
});
var $8146c1705ea66118$export$2e2bcd8739ae039 = $8146c1705ea66118$var$metadata;

});

parcelRequire.register("4wpDD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $838ecd20baff1603$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
const $838ecd20baff1603$var$metadata = Object.freeze({
    name: "Python",
    description: "Integrate Logto into your Python web app, such as Django and Flask.",
    target: (0, $61Yml.ApplicationType).Traditional,
    sample: {
        repo: "python",
        path: "samples"
    },
    fullGuide: {
        title: "Full Python SDK tutorial",
        url: "https://docs.logto.io/quick-starts/python"
    }
});
var $838ecd20baff1603$export$2e2bcd8739ae039 = $838ecd20baff1603$var$metadata;

});

parcelRequire.register("c7hGk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac741492c09657a2$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
const $ac741492c09657a2$var$metadata = Object.freeze({
    name: "Remix",
    description: "Remix is a modern SSR full stack web framework that lets you focus on the user interface and work back through web standards.",
    target: (0, $61Yml.ApplicationType).Traditional
});
var $ac741492c09657a2$export$2e2bcd8739ae039 = $ac741492c09657a2$var$metadata;

});

parcelRequire.register("1IFp3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05e66ee5432d36be$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
const $05e66ee5432d36be$var$metadata = Object.freeze({
    name: "SvelteKit",
    description: "SvelteKit is a framework for rapidly developing robust, performant web applications using Svelte.",
    target: (0, $61Yml.ApplicationType).Traditional,
    sample: {
        repo: "js",
        path: "packages/sveltekit-sample"
    },
    fullGuide: {
        title: "Full SvelteKit guide",
        url: "https://docs.logto.io/quick-starts/sveltekit"
    }
});
var $05e66ee5432d36be$export$2e2bcd8739ae039 = $05e66ee5432d36be$var$metadata;

});

parcelRequire.register("hx304", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ef4edf731160056$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
const $7ef4edf731160056$var$metadata = Object.freeze({
    name: "WordPress",
    description: "Integrate Logto into your WordPress app.",
    target: (0, $61Yml.ApplicationType).Traditional,
    fullGuide: {
        title: "Authorization and role mapping in WordPress",
        url: "https://blog.logto.io/integrate-with-wordpress-authorization/"
    }
});
var $7ef4edf731160056$export$2e2bcd8739ae039 = $7ef4edf731160056$var$metadata;

});


parcelRequire.register("kUskP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3b72518990502a2$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $d6jxg = parcelRequire("d6jxg");

var $5hoyb = parcelRequire("5hoyb");

var $cw2No = parcelRequire("cw2No");

var $7TamO = parcelRequire("7TamO");

var $3JJsj = parcelRequire("3JJsj");
function $c3b72518990502a2$var$CodeEditor({ className: className, language: language, isReadonly: isReadonly = false, value: value, onChange: onChange, tabSize: tabSize = 2, error: error, placeholder: placeholder }) {
    const textareaRef = (0, $jC8Vy.useRef)(null);
    const editorRef = (0, $jC8Vy.useRef)(null);
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    (0, $jC8Vy.useLayoutEffect)(()=>{
        // Update textarea width according to its scroll width
        const { current: current } = textareaRef;
        if (current && current.style.width !== `${current.scrollWidth}px`) // eslint-disable-next-line @silverhand/fp/no-mutation
        current.style.width = `${current.scrollWidth}px`;
    }, [
        value
    ]);
    const handleChange = (event)=>{
        const { value: value } = event.currentTarget;
        onChange?.(value);
    };
    const handleKeydown = (event)=>{
        if (event.key === "Tab") {
            const { value: value, selectionStart: selectionStart } = event.currentTarget;
            event.preventDefault();
            const newText = value.slice(0, selectionStart) + " ".repeat(tabSize) + value.slice(selectionStart);
            // Need to update value to set selection without useEffect
            // eslint-disable-next-line @silverhand/fp/no-mutation
            event.currentTarget.value = newText;
            event.currentTarget.setSelectionRange(selectionStart + tabSize, selectionStart + tabSize);
            onChange?.(newText);
        }
        /**
     * Since lineNumber container could cover leftmost part of the editor,
     * when user is clicking on "Enter", should manually scroll to the leftmost.
     */ if (event.key === "Enter" && editorRef.current && editorRef.current.scrollLeft !== 0) // eslint-disable-next-line @silverhand/fp/no-mutation
        editorRef.current.scrollLeft = 0;
    };
    // TODO @sijie temp solution for required error (the errorMessage is an empty string)
    const finalErrorMessage = typeof error === "string" ? error : t("general.required");
    const maxLineNumberDigits = (value ?? "").split("\n").length.toString().length;
    const isShowingPlaceholder = !value;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($7TamO.container, className),
                children: [
                    isShowingPlaceholder && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $7TamO.placeholder,
                        children: placeholder
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
                        value: value ?? "",
                        variant: "icon",
                        className: $7TamO.copy
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        ref: editorRef,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($7TamO.editor, isReadonly && $7TamO.readonly),
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("textarea", {
                                ref: textareaRef,
                                autoCapitalize: "off",
                                autoComplete: "off",
                                autoCorrect: "off",
                                "data-gramm": "false",
                                wrap: "false",
                                readOnly: isReadonly,
                                spellCheck: "false",
                                value: value,
                                style: isShowingPlaceholder ? {
                                    marginLeft: "8px",
                                    width: "calc(100% - 8px)"
                                } : {
                                    marginLeft: `calc(${maxLineNumberDigits}ch + 20px)`,
                                    width: `calc(100% - ${maxLineNumberDigits}ch - 20px)`
                                },
                                onChange: handleChange,
                                onKeyDown: handleKeydown
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $d6jxg.default), {
                                showInlineLineNumbers: true,
                                showLineNumbers: !isShowingPlaceholder,
                                width: textareaRef.current?.scrollWidth ?? 0,
                                lineNumberContainerStyle: (0, $3JJsj.lineNumberContainerStyle)(),
                                lineNumberStyle: (0, $3JJsj.lineNumberStyle)(maxLineNumberDigits),
                                codeTagProps: {
                                    style: {
                                        fontFamily: "'Roboto Mono', monospace"
                                    }
                                },
                                customStyle: (0, $3JJsj.customStyle)(textareaRef.current?.scrollWidth),
                                language: language,
                                style: (0, $5hoyb.default),
                                children: value ?? ""
                            })
                        ]
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $7TamO.errorMessage,
                children: finalErrorMessage
            })
        ]
    });
}
var $c3b72518990502a2$export$2e2bcd8739ae039 = $c3b72518990502a2$var$CodeEditor;

});
parcelRequire.register("d6jxg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $989afd41f3812ecb$export$2e2bcd8739ae039; });

var $853Zf = parcelRequire("853Zf");

var $cWa6F = parcelRequire("cWa6F");

var $989afd41f3812ecb$export$2e2bcd8739ae039 = (0, $853Zf.default)({
    loader: function loader() {
        return (parcelRequire("XHWfS")).then(function(module) {
            // Webpack 3 returns module.exports as default as module, but webpack 4 returns module.exports as module.default
            return module["default"] || module;
        });
    },
    isLanguageRegistered: function isLanguageRegistered(instance, language) {
        return instance.registered(language);
    },
    languageLoaders: (0, $cWa6F.default),
    registerLanguage: function registerLanguage(instance, name, language) {
        return instance.register(language);
    }
});

});
parcelRequire.register("853Zf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e21e21595af6084$export$2e2bcd8739ae039; });

var $fUktq = parcelRequire("fUktq");

var $eFVd0 = parcelRequire("eFVd0");

var $2Gdov = parcelRequire("2Gdov");

var $4jYfh = parcelRequire("4jYfh");

var $16R4D = parcelRequire("16R4D");

var $eg3iM = parcelRequire("eg3iM");

var $gD5vi = parcelRequire("gD5vi");

var $8Ysgg = parcelRequire("8Ysgg");

var $iwJJ6 = parcelRequire("iwJJ6");

var $jC8Vy = parcelRequire("jC8Vy");

var $9bsXM = parcelRequire("9bsXM");
function $5e21e21595af6084$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5e21e21595af6084$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $gD5vi.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $gD5vi.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $eg3iM.default)(this, result);
    };
}
function $5e21e21595af6084$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $5e21e21595af6084$export$2e2bcd8739ae039 = function(options) {
    var loader = options.loader, isLanguageRegistered = options.isLanguageRegistered, registerLanguage = options.registerLanguage, languageLoaders = options.languageLoaders, noAsyncLoadingLanguages = options.noAsyncLoadingLanguages;
    var ReactAsyncHighlighter = /*#__PURE__*/ function(_React$PureComponent) {
        (0, $16R4D.default)(ReactAsyncHighlighter, _React$PureComponent);
        var _super = $5e21e21595af6084$var$_createSuper(ReactAsyncHighlighter);
        function ReactAsyncHighlighter() {
            (0, $2Gdov.default)(this, ReactAsyncHighlighter);
            return _super.apply(this, arguments);
        }
        (0, $4jYfh.default)(ReactAsyncHighlighter, [
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate() {
                    if (!ReactAsyncHighlighter.isRegistered(this.props.language) && languageLoaders) this.loadLanguage();
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this = this;
                    if (!ReactAsyncHighlighter.astGeneratorPromise) ReactAsyncHighlighter.loadAstGenerator();
                    if (!ReactAsyncHighlighter.astGenerator) ReactAsyncHighlighter.astGeneratorPromise.then(function() {
                        _this.forceUpdate();
                    });
                    if (!ReactAsyncHighlighter.isRegistered(this.props.language) && languageLoaders) this.loadLanguage();
                }
            },
            {
                key: "loadLanguage",
                value: function loadLanguage() {
                    var _this2 = this;
                    var language = this.props.language;
                    if (language === "text") return;
                    ReactAsyncHighlighter.loadLanguage(language).then(function() {
                        return _this2.forceUpdate();
                    })["catch"](function() {});
                }
            },
            {
                key: "normalizeLanguage",
                value: function normalizeLanguage(language) {
                    return ReactAsyncHighlighter.isSupportedLanguage(language) ? language : "text";
                }
            },
            {
                key: "render",
                value: function render() {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement(ReactAsyncHighlighter.highlightInstance, (0, $eFVd0.default)({}, this.props, {
                        language: this.normalizeLanguage(this.props.language),
                        astGenerator: ReactAsyncHighlighter.astGenerator
                    }));
                }
            }
        ], [
            {
                key: "preload",
                value: function preload() {
                    return ReactAsyncHighlighter.loadAstGenerator();
                }
            },
            {
                key: "loadLanguage",
                value: function() {
                    var _loadLanguage = (0, $fUktq.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iwJJ6))).mark(function _callee(language) {
                        var languageLoader;
                        return (0, (/*@__PURE__*/$parcel$interopDefault($iwJJ6))).wrap(function _callee$(_context) {
                            while(true)switch(_context.prev = _context.next){
                                case 0:
                                    languageLoader = languageLoaders[language];
                                    if (!(typeof languageLoader === "function")) {
                                        _context.next = 5;
                                        break;
                                    }
                                    return _context.abrupt("return", languageLoader(ReactAsyncHighlighter.registerLanguage));
                                case 5:
                                    throw new Error("Language ".concat(language, " not supported"));
                                case 6:
                                case "end":
                                    return _context.stop();
                            }
                        }, _callee);
                    }));
                    function loadLanguage(_x) {
                        return _loadLanguage.apply(this, arguments);
                    }
                    return loadLanguage;
                }()
            },
            {
                key: "isSupportedLanguage",
                value: function isSupportedLanguage(language) {
                    return ReactAsyncHighlighter.isRegistered(language) || typeof languageLoaders[language] === "function";
                }
            },
            {
                key: "loadAstGenerator",
                value: function loadAstGenerator() {
                    ReactAsyncHighlighter.astGeneratorPromise = loader().then(function(astGenerator) {
                        ReactAsyncHighlighter.astGenerator = astGenerator;
                        if (registerLanguage) ReactAsyncHighlighter.languages.forEach(function(language, name) {
                            return registerLanguage(astGenerator, name, language);
                        });
                    });
                    return ReactAsyncHighlighter.astGeneratorPromise;
                }
            }
        ]);
        return ReactAsyncHighlighter;
    }((0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).PureComponent);
    (0, $8Ysgg.default)(ReactAsyncHighlighter, "astGenerator", null);
    (0, $8Ysgg.default)(ReactAsyncHighlighter, "highlightInstance", (0, $9bsXM.default)(null, {}));
    (0, $8Ysgg.default)(ReactAsyncHighlighter, "astGeneratorPromise", null);
    (0, $8Ysgg.default)(ReactAsyncHighlighter, "languages", new Map());
    (0, $8Ysgg.default)(ReactAsyncHighlighter, "supportedLanguages", options.supportedLanguages || Object.keys(languageLoaders || {}));
    (0, $8Ysgg.default)(ReactAsyncHighlighter, "isRegistered", function(language) {
        if (noAsyncLoadingLanguages) return true;
        if (!registerLanguage) throw new Error("Current syntax highlighter doesn't support registration of languages");
        if (!ReactAsyncHighlighter.astGenerator) // Ast generator not available yet, but language will be registered once it is.
        return ReactAsyncHighlighter.languages.has(language);
        return isLanguageRegistered(ReactAsyncHighlighter.astGenerator, language);
    });
    (0, $8Ysgg.default)(ReactAsyncHighlighter, "registerLanguage", function(name, language) {
        if (!registerLanguage) throw new Error("Current syntax highlighter doesn't support registration of languages");
        if (ReactAsyncHighlighter.astGenerator) return registerLanguage(ReactAsyncHighlighter.astGenerator, name, language);
        else ReactAsyncHighlighter.languages.set(name, language);
    });
    return ReactAsyncHighlighter;
};

});
parcelRequire.register("fUktq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b94bf7968b7b60b0$export$2e2bcd8739ae039; });
function $b94bf7968b7b60b0$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $b94bf7968b7b60b0$export$2e2bcd8739ae039(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $b94bf7968b7b60b0$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $b94bf7968b7b60b0$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRequire.register("eFVd0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aaf14583dea5ef5c$export$2e2bcd8739ae039; });
function $aaf14583dea5ef5c$export$2e2bcd8739ae039() {
    $aaf14583dea5ef5c$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $aaf14583dea5ef5c$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRequire.register("2Gdov", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f39e4db5a55ed69$export$2e2bcd8739ae039; });
function $1f39e4db5a55ed69$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRequire.register("4jYfh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3257ab452a26ec03$export$2e2bcd8739ae039; });
function $3257ab452a26ec03$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3257ab452a26ec03$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $3257ab452a26ec03$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3257ab452a26ec03$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

});

parcelRequire.register("16R4D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cef8551e59f247d$export$2e2bcd8739ae039; });

var $lOrdt = parcelRequire("lOrdt");
function $0cef8551e59f247d$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $lOrdt.default)(subClass, superClass);
}

});
parcelRequire.register("lOrdt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe136115b9cbc395$export$2e2bcd8739ae039; });
function $fe136115b9cbc395$export$2e2bcd8739ae039(o, p) {
    $fe136115b9cbc395$export$2e2bcd8739ae039 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $fe136115b9cbc395$export$2e2bcd8739ae039(o, p);
}

});


parcelRequire.register("eg3iM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6151ef9d08fe08f$export$2e2bcd8739ae039; });

var $fL5W2 = parcelRequire("fL5W2");

var $lpTaS = parcelRequire("lpTaS");
function $a6151ef9d08fe08f$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $fL5W2.default)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $lpTaS.default)(self);
}

});
parcelRequire.register("fL5W2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b78fd95dcd01ba42$export$2e2bcd8739ae039; });
function $b78fd95dcd01ba42$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $b78fd95dcd01ba42$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b78fd95dcd01ba42$export$2e2bcd8739ae039(obj);
}

});

parcelRequire.register("lpTaS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f976bb43656c1a8b$export$2e2bcd8739ae039; });
function $f976bb43656c1a8b$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});


parcelRequire.register("gD5vi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1b48ec575694c1a$export$2e2bcd8739ae039; });
function $c1b48ec575694c1a$export$2e2bcd8739ae039(o) {
    $c1b48ec575694c1a$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c1b48ec575694c1a$export$2e2bcd8739ae039(o);
}

});

parcelRequire.register("8Ysgg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6889d97620360480$export$2e2bcd8739ae039; });
function $6889d97620360480$export$2e2bcd8739ae039(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRequire.register("iwJJ6", function(module, exports) {

module.exports = (parcelRequire("dfVQk"));

});
parcelRequire.register("dfVQk", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9a698b7fadaca5e2$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, module.exports));
try {
    regeneratorRuntime = $9a698b7fadaca5e2$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $9a698b7fadaca5e2$var$runtime;
    else Function("r", "regeneratorRuntime = r")($9a698b7fadaca5e2$var$runtime);
}

});


parcelRequire.register("9bsXM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6afb9ba2cd6c253c$export$2e2bcd8739ae039; });

var $lekW6 = parcelRequire("lekW6");

var $9CTwB = parcelRequire("9CTwB");

var $8Ysgg = parcelRequire("8Ysgg");

var $jC8Vy = parcelRequire("jC8Vy");

var $TPIJ1 = parcelRequire("TPIJ1");

var $gMmpV = parcelRequire("gMmpV");
var $6afb9ba2cd6c253c$var$_excluded = [
    "language",
    "children",
    "style",
    "customStyle",
    "codeTagProps",
    "useInlineStyles",
    "showLineNumbers",
    "showInlineLineNumbers",
    "startingLineNumber",
    "lineNumberContainerStyle",
    "lineNumberStyle",
    "wrapLines",
    "wrapLongLines",
    "lineProps",
    "renderer",
    "PreTag",
    "CodeTag",
    "code",
    "astGenerator"
];
function $6afb9ba2cd6c253c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6afb9ba2cd6c253c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6afb9ba2cd6c253c$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $8Ysgg.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6afb9ba2cd6c253c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $6afb9ba2cd6c253c$var$newLineRegex = /\n/g;
function $6afb9ba2cd6c253c$var$getNewLines(str) {
    return str.match($6afb9ba2cd6c253c$var$newLineRegex);
}
function $6afb9ba2cd6c253c$var$getAllLineNumbers(_ref) {
    var lines = _ref.lines, startingLineNumber = _ref.startingLineNumber, style = _ref.style;
    return lines.map(function(_, i) {
        var number = i + startingLineNumber;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("span", {
            key: "line-".concat(i),
            className: "react-syntax-highlighter-line-number",
            style: typeof style === "function" ? style(number) : style
        }, "".concat(number, "\n"));
    });
}
function $6afb9ba2cd6c253c$var$AllLineNumbers(_ref2) {
    var codeString = _ref2.codeString, codeStyle = _ref2.codeStyle, _ref2$containerStyle = _ref2.containerStyle, containerStyle = _ref2$containerStyle === void 0 ? {
        "float": "left",
        paddingRight: "10px"
    } : _ref2$containerStyle, _ref2$numberStyle = _ref2.numberStyle, numberStyle = _ref2$numberStyle === void 0 ? {} : _ref2$numberStyle, startingLineNumber = _ref2.startingLineNumber;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("code", {
        style: Object.assign({}, codeStyle, containerStyle)
    }, $6afb9ba2cd6c253c$var$getAllLineNumbers({
        lines: codeString.replace(/\n$/, "").split("\n"),
        style: numberStyle,
        startingLineNumber: startingLineNumber
    }));
}
function $6afb9ba2cd6c253c$var$getEmWidthOfNumber(num) {
    return "".concat(num.toString().length, ".25em");
}
function $6afb9ba2cd6c253c$var$getInlineLineNumber(lineNumber, inlineLineNumberStyle) {
    return {
        type: "element",
        tagName: "span",
        properties: {
            key: "line-number--".concat(lineNumber),
            className: [
                "comment",
                "linenumber",
                "react-syntax-highlighter-line-number"
            ],
            style: inlineLineNumberStyle
        },
        children: [
            {
                type: "text",
                value: lineNumber
            }
        ]
    };
}
function $6afb9ba2cd6c253c$var$assembleLineNumberStyles(lineNumberStyle, lineNumber, largestLineNumber) {
    // minimally necessary styling for line numbers
    var defaultLineNumberStyle = {
        display: "inline-block",
        minWidth: $6afb9ba2cd6c253c$var$getEmWidthOfNumber(largestLineNumber),
        paddingRight: "1em",
        textAlign: "right",
        userSelect: "none"
    }; // prep custom styling
    var customLineNumberStyle = typeof lineNumberStyle === "function" ? lineNumberStyle(lineNumber) : lineNumberStyle; // combine
    var assembledStyle = $6afb9ba2cd6c253c$var$_objectSpread($6afb9ba2cd6c253c$var$_objectSpread({}, defaultLineNumberStyle), customLineNumberStyle);
    return assembledStyle;
}
function $6afb9ba2cd6c253c$var$createLineElement(_ref3) {
    var children = _ref3.children, lineNumber = _ref3.lineNumber, lineNumberStyle = _ref3.lineNumberStyle, largestLineNumber = _ref3.largestLineNumber, showInlineLineNumbers = _ref3.showInlineLineNumbers, _ref3$lineProps = _ref3.lineProps, lineProps = _ref3$lineProps === void 0 ? {} : _ref3$lineProps, _ref3$className = _ref3.className, className = _ref3$className === void 0 ? [] : _ref3$className, showLineNumbers = _ref3.showLineNumbers, wrapLongLines = _ref3.wrapLongLines;
    var properties = typeof lineProps === "function" ? lineProps(lineNumber) : lineProps;
    properties["className"] = className;
    if (lineNumber && showInlineLineNumbers) {
        var inlineLineNumberStyle = $6afb9ba2cd6c253c$var$assembleLineNumberStyles(lineNumberStyle, lineNumber, largestLineNumber);
        children.unshift($6afb9ba2cd6c253c$var$getInlineLineNumber(lineNumber, inlineLineNumberStyle));
    }
    if (wrapLongLines & showLineNumbers) properties.style = $6afb9ba2cd6c253c$var$_objectSpread($6afb9ba2cd6c253c$var$_objectSpread({}, properties.style), {}, {
        display: "flex"
    });
    return {
        type: "element",
        tagName: "span",
        properties: properties,
        children: children
    };
}
function $6afb9ba2cd6c253c$var$flattenCodeTree(tree) {
    var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var newTree = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    for(var i = 0; i < tree.length; i++){
        var node = tree[i];
        if (node.type === "text") newTree.push($6afb9ba2cd6c253c$var$createLineElement({
            children: [
                node
            ],
            className: (0, $9CTwB.default)(new Set(className))
        }));
        else if (node.children) {
            var classNames = className.concat(node.properties.className);
            $6afb9ba2cd6c253c$var$flattenCodeTree(node.children, classNames).forEach(function(i) {
                return newTree.push(i);
            });
        }
    }
    return newTree;
}
function $6afb9ba2cd6c253c$var$processLines(codeTree, wrapLines, lineProps, showLineNumbers, showInlineLineNumbers, startingLineNumber, largestLineNumber, lineNumberStyle, wrapLongLines) {
    var _ref4;
    var tree = $6afb9ba2cd6c253c$var$flattenCodeTree(codeTree.value);
    var newTree = [];
    var lastLineBreakIndex = -1;
    var index = 0;
    function createWrappedLine(children, lineNumber) {
        var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        return $6afb9ba2cd6c253c$var$createLineElement({
            children: children,
            lineNumber: lineNumber,
            lineNumberStyle: lineNumberStyle,
            largestLineNumber: largestLineNumber,
            showInlineLineNumbers: showInlineLineNumbers,
            lineProps: lineProps,
            className: className,
            showLineNumbers: showLineNumbers,
            wrapLongLines: wrapLongLines
        });
    }
    function createUnwrappedLine(children, lineNumber) {
        if (showLineNumbers && lineNumber && showInlineLineNumbers) {
            var inlineLineNumberStyle = $6afb9ba2cd6c253c$var$assembleLineNumberStyles(lineNumberStyle, lineNumber, largestLineNumber);
            children.unshift($6afb9ba2cd6c253c$var$getInlineLineNumber(lineNumber, inlineLineNumberStyle));
        }
        return children;
    }
    function createLine(children, lineNumber) {
        var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        return wrapLines || className.length > 0 ? createWrappedLine(children, lineNumber, className) : createUnwrappedLine(children, lineNumber);
    }
    var _loop = function _loop() {
        var node = tree[index];
        var value = node.children[0].value;
        var newLines = $6afb9ba2cd6c253c$var$getNewLines(value);
        if (newLines) {
            var splitValue = value.split("\n");
            splitValue.forEach(function(text, i) {
                var lineNumber = showLineNumbers && newTree.length + startingLineNumber;
                var newChild = {
                    type: "text",
                    value: "".concat(text, "\n")
                }; // if it's the first line
                if (i === 0) {
                    var _children = tree.slice(lastLineBreakIndex + 1, index).concat($6afb9ba2cd6c253c$var$createLineElement({
                        children: [
                            newChild
                        ],
                        className: node.properties.className
                    }));
                    var _line = createLine(_children, lineNumber);
                    newTree.push(_line); // if it's the last line
                } else if (i === splitValue.length - 1) {
                    var stringChild = tree[index + 1] && tree[index + 1].children && tree[index + 1].children[0];
                    var lastLineInPreviousSpan = {
                        type: "text",
                        value: "".concat(text)
                    };
                    if (stringChild) {
                        var newElem = $6afb9ba2cd6c253c$var$createLineElement({
                            children: [
                                lastLineInPreviousSpan
                            ],
                            className: node.properties.className
                        });
                        tree.splice(index + 1, 0, newElem);
                    } else {
                        var _children2 = [
                            lastLineInPreviousSpan
                        ];
                        var _line2 = createLine(_children2, lineNumber, node.properties.className);
                        newTree.push(_line2);
                    } // if it's neither the first nor the last line
                } else {
                    var _children3 = [
                        newChild
                    ];
                    var _line3 = createLine(_children3, lineNumber, node.properties.className);
                    newTree.push(_line3);
                }
            });
            lastLineBreakIndex = index;
        }
        index++;
    };
    while(index < tree.length)_loop();
    if (lastLineBreakIndex !== tree.length - 1) {
        var children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            var lineNumber = showLineNumbers && newTree.length + startingLineNumber;
            var line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    return wrapLines ? newTree : (_ref4 = []).concat.apply(_ref4, newTree);
}
function $6afb9ba2cd6c253c$var$defaultRenderer(_ref5) {
    var rows = _ref5.rows, stylesheet = _ref5.stylesheet, useInlineStyles = _ref5.useInlineStyles;
    return rows.map(function(node, i) {
        return (0, $TPIJ1.default)({
            node: node,
            stylesheet: stylesheet,
            useInlineStyles: useInlineStyles,
            key: "code-segement".concat(i)
        });
    });
} // only highlight.js has the highlightAuto method
function $6afb9ba2cd6c253c$var$isHighlightJs(astGenerator) {
    return astGenerator && typeof astGenerator.highlightAuto !== "undefined";
}
function $6afb9ba2cd6c253c$var$getCodeTree(_ref6) {
    var astGenerator = _ref6.astGenerator, language = _ref6.language, code = _ref6.code, defaultCodeValue = _ref6.defaultCodeValue;
    // figure out whether we're using lowlight/highlight or refractor/prism
    // then attempt highlighting accordingly
    // lowlight/highlight?
    if ($6afb9ba2cd6c253c$var$isHighlightJs(astGenerator)) {
        var hasLanguage = (0, $gMmpV.default)(astGenerator, language);
        if (language === "text") return {
            value: defaultCodeValue,
            language: "text"
        };
        else if (hasLanguage) return astGenerator.highlight(language, code);
        else return astGenerator.highlightAuto(code);
    } // must be refractor/prism, then
    try {
        return language && language !== "text" ? {
            value: astGenerator.highlight(code, language)
        } : {
            value: defaultCodeValue
        };
    } catch (e) {
        return {
            value: defaultCodeValue
        };
    }
}
function $6afb9ba2cd6c253c$export$2e2bcd8739ae039(defaultAstGenerator, defaultStyle) {
    return function SyntaxHighlighter(_ref7) {
        var language = _ref7.language, children = _ref7.children, _ref7$style = _ref7.style, style = _ref7$style === void 0 ? defaultStyle : _ref7$style, _ref7$customStyle = _ref7.customStyle, customStyle = _ref7$customStyle === void 0 ? {} : _ref7$customStyle, _ref7$codeTagProps = _ref7.codeTagProps, codeTagProps = _ref7$codeTagProps === void 0 ? {
            className: language ? "language-".concat(language) : undefined,
            style: $6afb9ba2cd6c253c$var$_objectSpread($6afb9ba2cd6c253c$var$_objectSpread({}, style['code[class*="language-"]']), style['code[class*="language-'.concat(language, '"]')])
        } : _ref7$codeTagProps, _ref7$useInlineStyles = _ref7.useInlineStyles, useInlineStyles = _ref7$useInlineStyles === void 0 ? true : _ref7$useInlineStyles, _ref7$showLineNumbers = _ref7.showLineNumbers, showLineNumbers = _ref7$showLineNumbers === void 0 ? false : _ref7$showLineNumbers, _ref7$showInlineLineN = _ref7.showInlineLineNumbers, showInlineLineNumbers = _ref7$showInlineLineN === void 0 ? true : _ref7$showInlineLineN, _ref7$startingLineNum = _ref7.startingLineNumber, startingLineNumber = _ref7$startingLineNum === void 0 ? 1 : _ref7$startingLineNum, lineNumberContainerStyle = _ref7.lineNumberContainerStyle, _ref7$lineNumberStyle = _ref7.lineNumberStyle, lineNumberStyle = _ref7$lineNumberStyle === void 0 ? {} : _ref7$lineNumberStyle, wrapLines = _ref7.wrapLines, _ref7$wrapLongLines = _ref7.wrapLongLines, wrapLongLines = _ref7$wrapLongLines === void 0 ? false : _ref7$wrapLongLines, _ref7$lineProps = _ref7.lineProps, lineProps = _ref7$lineProps === void 0 ? {} : _ref7$lineProps, renderer = _ref7.renderer, _ref7$PreTag = _ref7.PreTag, PreTag = _ref7$PreTag === void 0 ? "pre" : _ref7$PreTag, _ref7$CodeTag = _ref7.CodeTag, CodeTag = _ref7$CodeTag === void 0 ? "code" : _ref7$CodeTag, _ref7$code = _ref7.code, code = _ref7$code === void 0 ? (Array.isArray(children) ? children[0] : children) || "" : _ref7$code, astGenerator = _ref7.astGenerator, rest = (0, $lekW6.default)(_ref7, $6afb9ba2cd6c253c$var$_excluded);
        astGenerator = astGenerator || defaultAstGenerator;
        var allLineNumbers = showLineNumbers ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement($6afb9ba2cd6c253c$var$AllLineNumbers, {
            containerStyle: lineNumberContainerStyle,
            codeStyle: codeTagProps.style || {},
            numberStyle: lineNumberStyle,
            startingLineNumber: startingLineNumber,
            codeString: code
        }) : null;
        var defaultPreStyle = style.hljs || style['pre[class*="language-"]'] || {
            backgroundColor: "#fff"
        };
        var generatorClassName = $6afb9ba2cd6c253c$var$isHighlightJs(astGenerator) ? "hljs" : "prismjs";
        var preProps = useInlineStyles ? Object.assign({}, rest, {
            style: Object.assign({}, defaultPreStyle, customStyle)
        }) : Object.assign({}, rest, {
            className: rest.className ? "".concat(generatorClassName, " ").concat(rest.className) : generatorClassName,
            style: Object.assign({}, customStyle)
        });
        if (wrapLongLines) codeTagProps.style = $6afb9ba2cd6c253c$var$_objectSpread($6afb9ba2cd6c253c$var$_objectSpread({}, codeTagProps.style), {}, {
            whiteSpace: "pre-wrap"
        });
        else codeTagProps.style = $6afb9ba2cd6c253c$var$_objectSpread($6afb9ba2cd6c253c$var$_objectSpread({}, codeTagProps.style), {}, {
            whiteSpace: "pre"
        });
        if (!astGenerator) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement(PreTag, preProps, allLineNumbers, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement(CodeTag, codeTagProps, code));
        /*
     * Some custom renderers rely on individual row elements so we need to turn wrapLines on
     * if renderer is provided and wrapLines is undefined.
     */ if (wrapLines === undefined && renderer || wrapLongLines) wrapLines = true;
        renderer = renderer || $6afb9ba2cd6c253c$var$defaultRenderer;
        var defaultCodeValue = [
            {
                type: "text",
                value: code
            }
        ];
        var codeTree = $6afb9ba2cd6c253c$var$getCodeTree({
            astGenerator: astGenerator,
            language: language,
            code: code,
            defaultCodeValue: defaultCodeValue
        });
        if (codeTree.language === null) codeTree.value = defaultCodeValue;
         // determine largest line number so that we can force minWidth on all linenumber elements
        var largestLineNumber = codeTree.value.length + startingLineNumber;
        var rows = $6afb9ba2cd6c253c$var$processLines(codeTree, wrapLines, lineProps, showLineNumbers, showInlineLineNumbers, startingLineNumber, largestLineNumber, lineNumberStyle, wrapLongLines);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement(PreTag, preProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement(CodeTag, codeTagProps, !showInlineLineNumbers && allLineNumbers, renderer({
            rows: rows,
            stylesheet: style,
            useInlineStyles: useInlineStyles
        })));
    };
}

});
parcelRequire.register("lekW6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f74b253d24f701f1$export$2e2bcd8739ae039; });

var $2AA1s = parcelRequire("2AA1s");
function $f74b253d24f701f1$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $2AA1s.default)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRequire.register("2AA1s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e2ae2e20ac120e2$export$2e2bcd8739ae039; });
function $1e2ae2e20ac120e2$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRequire.register("9CTwB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7022bbbb21b3c12e$export$2e2bcd8739ae039; });

var $lp0Zp = parcelRequire("lp0Zp");

var $gpa1k = parcelRequire("gpa1k");

var $c6FU7 = parcelRequire("c6FU7");

var $5apgH = parcelRequire("5apgH");
function $7022bbbb21b3c12e$export$2e2bcd8739ae039(arr) {
    return (0, $lp0Zp.default)(arr) || (0, $gpa1k.default)(arr) || (0, $c6FU7.default)(arr) || (0, $5apgH.default)();
}

});
parcelRequire.register("lp0Zp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f94cb33f4ee2ab70$export$2e2bcd8739ae039; });

var $juGWL = parcelRequire("juGWL");
function $f94cb33f4ee2ab70$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $juGWL.default)(arr);
}

});
parcelRequire.register("juGWL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e31221fd08c1c6ef$export$2e2bcd8739ae039; });
function $e31221fd08c1c6ef$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRequire.register("gpa1k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf16c0fa5c9c0dc4$export$2e2bcd8739ae039; });
function $bf16c0fa5c9c0dc4$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRequire.register("c6FU7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d068ce1febc89d0$export$2e2bcd8739ae039; });

var $juGWL = parcelRequire("juGWL");
function $8d068ce1febc89d0$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $juGWL.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $juGWL.default)(o, minLen);
}

});

parcelRequire.register("5apgH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c317cb46e126b84$export$2e2bcd8739ae039; });
function $3c317cb46e126b84$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRequire.register("TPIJ1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a7d41c20c23d38f$export$2e2bcd8739ae039; });

var $eFVd0 = parcelRequire("eFVd0");

var $8Ysgg = parcelRequire("8Ysgg");

var $jC8Vy = parcelRequire("jC8Vy");
function $0a7d41c20c23d38f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0a7d41c20c23d38f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0a7d41c20c23d38f$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $8Ysgg.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0a7d41c20c23d38f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
//
// Super simple, non-algorithmic solution since the
// number of class names will not be greater than 4
function $0a7d41c20c23d38f$var$powerSetPermutations(arr) {
    var arrLength = arr.length;
    if (arrLength === 0 || arrLength === 1) return arr;
    if (arrLength === 2) // prettier-ignore
    return [
        arr[0],
        arr[1],
        "".concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[1], ".").concat(arr[0])
    ];
    if (arrLength === 3) return [
        arr[0],
        arr[1],
        arr[2],
        "".concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0])
    ];
    if (arrLength >= 4) // Currently does not support more than 4 extra
    // class names (after `.token` has been removed)
    return [
        arr[0],
        arr[1],
        arr[2],
        arr[3],
        "".concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[1], ".").concat(arr[0])
    ];
}
var $0a7d41c20c23d38f$var$classNameCombinations = {};
function $0a7d41c20c23d38f$var$getClassNameCombinations(classNames) {
    if (classNames.length === 0 || classNames.length === 1) return classNames;
    var key = classNames.join(".");
    if (!$0a7d41c20c23d38f$var$classNameCombinations[key]) $0a7d41c20c23d38f$var$classNameCombinations[key] = $0a7d41c20c23d38f$var$powerSetPermutations(classNames);
    return $0a7d41c20c23d38f$var$classNameCombinations[key];
}
function $0a7d41c20c23d38f$export$28a8c6cb018dfadc(classNames) {
    var elementStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var stylesheet = arguments.length > 2 ? arguments[2] : undefined;
    var nonTokenClassNames = classNames.filter(function(className) {
        return className !== "token";
    });
    var classNamesCombinations = $0a7d41c20c23d38f$var$getClassNameCombinations(nonTokenClassNames);
    return classNamesCombinations.reduce(function(styleObject, className) {
        return $0a7d41c20c23d38f$var$_objectSpread($0a7d41c20c23d38f$var$_objectSpread({}, styleObject), stylesheet[className]);
    }, elementStyle);
}
function $0a7d41c20c23d38f$export$d0f1f443a3b7b5(classNames) {
    return classNames.join(" ");
}
function $0a7d41c20c23d38f$export$86fb3c3a621e8db6(stylesheet, useInlineStyles) {
    var childrenCount = 0;
    return function(children) {
        childrenCount += 1;
        return children.map(function(child, i) {
            return $0a7d41c20c23d38f$export$2e2bcd8739ae039({
                node: child,
                stylesheet: stylesheet,
                useInlineStyles: useInlineStyles,
                key: "code-segment-".concat(childrenCount, "-").concat(i)
            });
        });
    };
}
function $0a7d41c20c23d38f$export$2e2bcd8739ae039(_ref) {
    var node = _ref.node, stylesheet = _ref.stylesheet, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style, useInlineStyles = _ref.useInlineStyles, key = _ref.key;
    var properties = node.properties, type = node.type, TagName = node.tagName, value = node.value;
    if (type === "text") return value;
    else if (TagName) {
        var childrenCreator = $0a7d41c20c23d38f$export$86fb3c3a621e8db6(stylesheet, useInlineStyles);
        var props;
        if (!useInlineStyles) props = $0a7d41c20c23d38f$var$_objectSpread($0a7d41c20c23d38f$var$_objectSpread({}, properties), {}, {
            className: $0a7d41c20c23d38f$export$d0f1f443a3b7b5(properties.className)
        });
        else {
            var allStylesheetSelectors = Object.keys(stylesheet).reduce(function(classes, selector) {
                selector.split(".").forEach(function(className) {
                    if (!classes.includes(className)) classes.push(className);
                });
                return classes;
            }, []); // For compatibility with older versions of react-syntax-highlighter
            var startingClassName = properties.className && properties.className.includes("token") ? [
                "token"
            ] : [];
            var className = properties.className && startingClassName.concat(properties.className.filter(function(className) {
                return !allStylesheetSelectors.includes(className);
            }));
            props = $0a7d41c20c23d38f$var$_objectSpread($0a7d41c20c23d38f$var$_objectSpread({}, properties), {}, {
                className: $0a7d41c20c23d38f$export$d0f1f443a3b7b5(className) || undefined,
                style: $0a7d41c20c23d38f$export$28a8c6cb018dfadc(properties.className, Object.assign({}, properties.style, style), stylesheet)
            });
        }
        var children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement(TagName, (0, $eFVd0.default)({
            key: key
        }, props), children);
    }
}

});

parcelRequire.register("gMmpV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c37284a1fd10e894$export$2e2bcd8739ae039; });
var $c37284a1fd10e894$export$2e2bcd8739ae039 = function(astGenerator, language) {
    var langs = astGenerator.listLanguages();
    return langs.indexOf(language) !== -1;
};

});



parcelRequire.register("cWa6F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96b2bdc0d3186852$export$2e2bcd8739ae039; });

var $aTvoU = parcelRequire("aTvoU");





















































































































































































































































































var $96b2bdc0d3186852$export$2e2bcd8739ae039 = {
    abap: (0, $aTvoU.default)("abap", function() {
        return (parcelRequire("jeLcl"));
    }),
    abnf: (0, $aTvoU.default)("abnf", function() {
        return (parcelRequire("k24E2"));
    }),
    actionscript: (0, $aTvoU.default)("actionscript", function() {
        return (parcelRequire("ay58t"));
    }),
    ada: (0, $aTvoU.default)("ada", function() {
        return (parcelRequire("cuH1L"));
    }),
    agda: (0, $aTvoU.default)("agda", function() {
        return (parcelRequire("2T30k"));
    }),
    al: (0, $aTvoU.default)("al", function() {
        return (parcelRequire("6qeWk"));
    }),
    antlr4: (0, $aTvoU.default)("antlr4", function() {
        return (parcelRequire("01pJB"));
    }),
    apacheconf: (0, $aTvoU.default)("apacheconf", function() {
        return (parcelRequire("2nbiO"));
    }),
    apex: (0, $aTvoU.default)("apex", function() {
        return (parcelRequire("b52Nf"));
    }),
    apl: (0, $aTvoU.default)("apl", function() {
        return (parcelRequire("lfyNf"));
    }),
    applescript: (0, $aTvoU.default)("applescript", function() {
        return (parcelRequire("dKYQp"));
    }),
    aql: (0, $aTvoU.default)("aql", function() {
        return (parcelRequire("dtP1m"));
    }),
    arduino: (0, $aTvoU.default)("arduino", function() {
        return (parcelRequire("h9b2k"));
    }),
    arff: (0, $aTvoU.default)("arff", function() {
        return (parcelRequire("556y9"));
    }),
    asciidoc: (0, $aTvoU.default)("asciidoc", function() {
        return (parcelRequire("eaZg8"));
    }),
    asm6502: (0, $aTvoU.default)("asm6502", function() {
        return (parcelRequire("3Rh2y"));
    }),
    asmatmel: (0, $aTvoU.default)("asmatmel", function() {
        return (parcelRequire("iY8T7"));
    }),
    aspnet: (0, $aTvoU.default)("aspnet", function() {
        return (parcelRequire("jJH6g"));
    }),
    autohotkey: (0, $aTvoU.default)("autohotkey", function() {
        return (parcelRequire("3Cf7x"));
    }),
    autoit: (0, $aTvoU.default)("autoit", function() {
        return (parcelRequire("4cAvP"));
    }),
    avisynth: (0, $aTvoU.default)("avisynth", function() {
        return (parcelRequire("40BaG"));
    }),
    avroIdl: (0, $aTvoU.default)("avroIdl", function() {
        return (parcelRequire("gGHtK"));
    }),
    bash: (0, $aTvoU.default)("bash", function() {
        return (parcelRequire("bmGYo"));
    }),
    basic: (0, $aTvoU.default)("basic", function() {
        return (parcelRequire("7rwZl"));
    }),
    batch: (0, $aTvoU.default)("batch", function() {
        return (parcelRequire("1T7gS"));
    }),
    bbcode: (0, $aTvoU.default)("bbcode", function() {
        return (parcelRequire("iSdnA"));
    }),
    bicep: (0, $aTvoU.default)("bicep", function() {
        return (parcelRequire("hyVJa"));
    }),
    birb: (0, $aTvoU.default)("birb", function() {
        return (parcelRequire("eX6aW"));
    }),
    bison: (0, $aTvoU.default)("bison", function() {
        return (parcelRequire("hvVZr"));
    }),
    bnf: (0, $aTvoU.default)("bnf", function() {
        return (parcelRequire("aSMxV"));
    }),
    brainfuck: (0, $aTvoU.default)("brainfuck", function() {
        return (parcelRequire("ynbCi"));
    }),
    brightscript: (0, $aTvoU.default)("brightscript", function() {
        return (parcelRequire("3ojQv"));
    }),
    bro: (0, $aTvoU.default)("bro", function() {
        return (parcelRequire("gnXaj"));
    }),
    bsl: (0, $aTvoU.default)("bsl", function() {
        return (parcelRequire("ix23A"));
    }),
    c: (0, $aTvoU.default)("c", function() {
        return (parcelRequire("bH79W"));
    }),
    cfscript: (0, $aTvoU.default)("cfscript", function() {
        return (parcelRequire("g4o8m"));
    }),
    chaiscript: (0, $aTvoU.default)("chaiscript", function() {
        return (parcelRequire("3Btr9"));
    }),
    cil: (0, $aTvoU.default)("cil", function() {
        return (parcelRequire("kfuQs"));
    }),
    clike: (0, $aTvoU.default)("clike", function() {
        return (parcelRequire("fi2Ev"));
    }),
    clojure: (0, $aTvoU.default)("clojure", function() {
        return (parcelRequire("ahN1j"));
    }),
    cmake: (0, $aTvoU.default)("cmake", function() {
        return (parcelRequire("kguP1"));
    }),
    cobol: (0, $aTvoU.default)("cobol", function() {
        return (parcelRequire("fAncd"));
    }),
    coffeescript: (0, $aTvoU.default)("coffeescript", function() {
        return (parcelRequire("7sZsV"));
    }),
    concurnas: (0, $aTvoU.default)("concurnas", function() {
        return (parcelRequire("jwmsw"));
    }),
    coq: (0, $aTvoU.default)("coq", function() {
        return (parcelRequire("hM4XU"));
    }),
    cpp: (0, $aTvoU.default)("cpp", function() {
        return (parcelRequire("gqAAm"));
    }),
    crystal: (0, $aTvoU.default)("crystal", function() {
        return (parcelRequire("kvwqP"));
    }),
    csharp: (0, $aTvoU.default)("csharp", function() {
        return (parcelRequire("in1tv"));
    }),
    cshtml: (0, $aTvoU.default)("cshtml", function() {
        return (parcelRequire("8oSV6"));
    }),
    csp: (0, $aTvoU.default)("csp", function() {
        return (parcelRequire("khrNp"));
    }),
    cssExtras: (0, $aTvoU.default)("cssExtras", function() {
        return (parcelRequire("95M9M"));
    }),
    css: (0, $aTvoU.default)("css", function() {
        return (parcelRequire("16KCw"));
    }),
    csv: (0, $aTvoU.default)("csv", function() {
        return (parcelRequire("xFmyy"));
    }),
    cypher: (0, $aTvoU.default)("cypher", function() {
        return (parcelRequire("2J3B2"));
    }),
    d: (0, $aTvoU.default)("d", function() {
        return (parcelRequire("gXlIj"));
    }),
    dart: (0, $aTvoU.default)("dart", function() {
        return (parcelRequire("bxTnl"));
    }),
    dataweave: (0, $aTvoU.default)("dataweave", function() {
        return (parcelRequire("ePK2o"));
    }),
    dax: (0, $aTvoU.default)("dax", function() {
        return (parcelRequire("cFQBT"));
    }),
    dhall: (0, $aTvoU.default)("dhall", function() {
        return (parcelRequire("efaWR"));
    }),
    diff: (0, $aTvoU.default)("diff", function() {
        return (parcelRequire("5BXKA"));
    }),
    django: (0, $aTvoU.default)("django", function() {
        return (parcelRequire("azBXG"));
    }),
    dnsZoneFile: (0, $aTvoU.default)("dnsZoneFile", function() {
        return (parcelRequire("fCNtm"));
    }),
    docker: (0, $aTvoU.default)("docker", function() {
        return (parcelRequire("iV6Ah"));
    }),
    dot: (0, $aTvoU.default)("dot", function() {
        return (parcelRequire("bTWPI"));
    }),
    ebnf: (0, $aTvoU.default)("ebnf", function() {
        return (parcelRequire("1XlCU"));
    }),
    editorconfig: (0, $aTvoU.default)("editorconfig", function() {
        return (parcelRequire("ixShN"));
    }),
    eiffel: (0, $aTvoU.default)("eiffel", function() {
        return (parcelRequire("iaI3U"));
    }),
    ejs: (0, $aTvoU.default)("ejs", function() {
        return (parcelRequire("7Usfr"));
    }),
    elixir: (0, $aTvoU.default)("elixir", function() {
        return (parcelRequire("8UXTn"));
    }),
    elm: (0, $aTvoU.default)("elm", function() {
        return (parcelRequire("iBEDx"));
    }),
    erb: (0, $aTvoU.default)("erb", function() {
        return (parcelRequire("jj2Bu"));
    }),
    erlang: (0, $aTvoU.default)("erlang", function() {
        return (parcelRequire("jhCSO"));
    }),
    etlua: (0, $aTvoU.default)("etlua", function() {
        return (parcelRequire("8ZGdY"));
    }),
    excelFormula: (0, $aTvoU.default)("excelFormula", function() {
        return (parcelRequire("k2mWT"));
    }),
    factor: (0, $aTvoU.default)("factor", function() {
        return (parcelRequire("38ubn"));
    }),
    falselang: (0, $aTvoU.default)("falselang", function() {
        return (parcelRequire("d3lOW"));
    }),
    firestoreSecurityRules: (0, $aTvoU.default)("firestoreSecurityRules", function() {
        return (parcelRequire("03XAo"));
    }),
    flow: (0, $aTvoU.default)("flow", function() {
        return (parcelRequire("bm0hR"));
    }),
    fortran: (0, $aTvoU.default)("fortran", function() {
        return (parcelRequire("9x3hX"));
    }),
    fsharp: (0, $aTvoU.default)("fsharp", function() {
        return (parcelRequire("ghYJJ"));
    }),
    ftl: (0, $aTvoU.default)("ftl", function() {
        return (parcelRequire("4wwx1"));
    }),
    gap: (0, $aTvoU.default)("gap", function() {
        return (parcelRequire("N5dA1"));
    }),
    gcode: (0, $aTvoU.default)("gcode", function() {
        return (parcelRequire("bmeQn"));
    }),
    gdscript: (0, $aTvoU.default)("gdscript", function() {
        return (parcelRequire("prxFN"));
    }),
    gedcom: (0, $aTvoU.default)("gedcom", function() {
        return (parcelRequire("ljkrl"));
    }),
    gherkin: (0, $aTvoU.default)("gherkin", function() {
        return (parcelRequire("hdP51"));
    }),
    git: (0, $aTvoU.default)("git", function() {
        return (parcelRequire("cE1ot"));
    }),
    glsl: (0, $aTvoU.default)("glsl", function() {
        return (parcelRequire("5Lqpu"));
    }),
    gml: (0, $aTvoU.default)("gml", function() {
        return (parcelRequire("5186D"));
    }),
    gn: (0, $aTvoU.default)("gn", function() {
        return (parcelRequire("7OWiG"));
    }),
    goModule: (0, $aTvoU.default)("goModule", function() {
        return (parcelRequire("86NWs"));
    }),
    go: (0, $aTvoU.default)("go", function() {
        return (parcelRequire("dJcTd"));
    }),
    graphql: (0, $aTvoU.default)("graphql", function() {
        return (parcelRequire("gfrUW"));
    }),
    groovy: (0, $aTvoU.default)("groovy", function() {
        return (parcelRequire("jJrxl"));
    }),
    haml: (0, $aTvoU.default)("haml", function() {
        return (parcelRequire("baY8r"));
    }),
    handlebars: (0, $aTvoU.default)("handlebars", function() {
        return (parcelRequire("1i26O"));
    }),
    haskell: (0, $aTvoU.default)("haskell", function() {
        return (parcelRequire("jGNnx"));
    }),
    haxe: (0, $aTvoU.default)("haxe", function() {
        return (parcelRequire("c6IxX"));
    }),
    hcl: (0, $aTvoU.default)("hcl", function() {
        return (parcelRequire("k3yhj"));
    }),
    hlsl: (0, $aTvoU.default)("hlsl", function() {
        return (parcelRequire("2eaUn"));
    }),
    hoon: (0, $aTvoU.default)("hoon", function() {
        return (parcelRequire("7AcZO"));
    }),
    hpkp: (0, $aTvoU.default)("hpkp", function() {
        return (parcelRequire("6pDHp"));
    }),
    hsts: (0, $aTvoU.default)("hsts", function() {
        return (parcelRequire("fuH8r"));
    }),
    http: (0, $aTvoU.default)("http", function() {
        return (parcelRequire("k9wxQ"));
    }),
    ichigojam: (0, $aTvoU.default)("ichigojam", function() {
        return (parcelRequire("hiH43"));
    }),
    icon: (0, $aTvoU.default)("icon", function() {
        return (parcelRequire("gkyde"));
    }),
    icuMessageFormat: (0, $aTvoU.default)("icuMessageFormat", function() {
        return (parcelRequire("lJtMw"));
    }),
    idris: (0, $aTvoU.default)("idris", function() {
        return (parcelRequire("a7xRa"));
    }),
    iecst: (0, $aTvoU.default)("iecst", function() {
        return (parcelRequire("6uhwH"));
    }),
    ignore: (0, $aTvoU.default)("ignore", function() {
        return (parcelRequire("ebCdc"));
    }),
    inform7: (0, $aTvoU.default)("inform7", function() {
        return (parcelRequire("cWwDI"));
    }),
    ini: (0, $aTvoU.default)("ini", function() {
        return (parcelRequire("7rzsg"));
    }),
    io: (0, $aTvoU.default)("io", function() {
        return (parcelRequire("8Vgmt"));
    }),
    j: (0, $aTvoU.default)("j", function() {
        return (parcelRequire("17z4w"));
    }),
    java: (0, $aTvoU.default)("java", function() {
        return (parcelRequire("4aa5B"));
    }),
    javadoc: (0, $aTvoU.default)("javadoc", function() {
        return (parcelRequire("iu6gE"));
    }),
    javadoclike: (0, $aTvoU.default)("javadoclike", function() {
        return (parcelRequire("bMvMj"));
    }),
    javascript: (0, $aTvoU.default)("javascript", function() {
        return (parcelRequire("b0Jhm"));
    }),
    javastacktrace: (0, $aTvoU.default)("javastacktrace", function() {
        return (parcelRequire("aRb7p"));
    }),
    jexl: (0, $aTvoU.default)("jexl", function() {
        return (parcelRequire("dYy1q"));
    }),
    jolie: (0, $aTvoU.default)("jolie", function() {
        return (parcelRequire("de5gw"));
    }),
    jq: (0, $aTvoU.default)("jq", function() {
        return (parcelRequire("kO2ih"));
    }),
    jsExtras: (0, $aTvoU.default)("jsExtras", function() {
        return (parcelRequire("75XdH"));
    }),
    jsTemplates: (0, $aTvoU.default)("jsTemplates", function() {
        return (parcelRequire("6lilA"));
    }),
    jsdoc: (0, $aTvoU.default)("jsdoc", function() {
        return (parcelRequire("bumD7"));
    }),
    json: (0, $aTvoU.default)("json", function() {
        return (parcelRequire("kdfjJ"));
    }),
    json5: (0, $aTvoU.default)("json5", function() {
        return (parcelRequire("65YCF"));
    }),
    jsonp: (0, $aTvoU.default)("jsonp", function() {
        return (parcelRequire("hsBPh"));
    }),
    jsstacktrace: (0, $aTvoU.default)("jsstacktrace", function() {
        return (parcelRequire("ejBOa"));
    }),
    jsx: (0, $aTvoU.default)("jsx", function() {
        return (parcelRequire("P61to"));
    }),
    julia: (0, $aTvoU.default)("julia", function() {
        return (parcelRequire("h5yUY"));
    }),
    keepalived: (0, $aTvoU.default)("keepalived", function() {
        return (parcelRequire("eJ6gw"));
    }),
    keyman: (0, $aTvoU.default)("keyman", function() {
        return (parcelRequire("6FYZC"));
    }),
    kotlin: (0, $aTvoU.default)("kotlin", function() {
        return (parcelRequire("bFb92"));
    }),
    kumir: (0, $aTvoU.default)("kumir", function() {
        return (parcelRequire("enDTs"));
    }),
    kusto: (0, $aTvoU.default)("kusto", function() {
        return (parcelRequire("4vV9z"));
    }),
    latex: (0, $aTvoU.default)("latex", function() {
        return (parcelRequire("8HPOF"));
    }),
    latte: (0, $aTvoU.default)("latte", function() {
        return (parcelRequire("brweb"));
    }),
    less: (0, $aTvoU.default)("less", function() {
        return (parcelRequire("kFfhT"));
    }),
    lilypond: (0, $aTvoU.default)("lilypond", function() {
        return (parcelRequire("hqj8Z"));
    }),
    liquid: (0, $aTvoU.default)("liquid", function() {
        return (parcelRequire("8HsHG"));
    }),
    lisp: (0, $aTvoU.default)("lisp", function() {
        return (parcelRequire("9AgfI"));
    }),
    livescript: (0, $aTvoU.default)("livescript", function() {
        return (parcelRequire("6vqNT"));
    }),
    llvm: (0, $aTvoU.default)("llvm", function() {
        return (parcelRequire("9eenK"));
    }),
    log: (0, $aTvoU.default)("log", function() {
        return (parcelRequire("2xiZb"));
    }),
    lolcode: (0, $aTvoU.default)("lolcode", function() {
        return (parcelRequire("9lBGs"));
    }),
    lua: (0, $aTvoU.default)("lua", function() {
        return (parcelRequire("lOwoR"));
    }),
    magma: (0, $aTvoU.default)("magma", function() {
        return (parcelRequire("9II4F"));
    }),
    makefile: (0, $aTvoU.default)("makefile", function() {
        return (parcelRequire("k55AZ"));
    }),
    markdown: (0, $aTvoU.default)("markdown", function() {
        return (parcelRequire("kupqo"));
    }),
    markupTemplating: (0, $aTvoU.default)("markupTemplating", function() {
        return (parcelRequire("1Telt"));
    }),
    markup: (0, $aTvoU.default)("markup", function() {
        return (parcelRequire("jynAy"));
    }),
    matlab: (0, $aTvoU.default)("matlab", function() {
        return (parcelRequire("3MtTd"));
    }),
    maxscript: (0, $aTvoU.default)("maxscript", function() {
        return (parcelRequire("8WioY"));
    }),
    mel: (0, $aTvoU.default)("mel", function() {
        return (parcelRequire("ad4kh"));
    }),
    mermaid: (0, $aTvoU.default)("mermaid", function() {
        return (parcelRequire("bGTcx"));
    }),
    mizar: (0, $aTvoU.default)("mizar", function() {
        return (parcelRequire("ln6lx"));
    }),
    mongodb: (0, $aTvoU.default)("mongodb", function() {
        return (parcelRequire("iulCv"));
    }),
    monkey: (0, $aTvoU.default)("monkey", function() {
        return (parcelRequire("8aycX"));
    }),
    moonscript: (0, $aTvoU.default)("moonscript", function() {
        return (parcelRequire("c4ZJ6"));
    }),
    n1ql: (0, $aTvoU.default)("n1ql", function() {
        return (parcelRequire("8bv6o"));
    }),
    n4js: (0, $aTvoU.default)("n4js", function() {
        return (parcelRequire("hNDMm"));
    }),
    nand2tetrisHdl: (0, $aTvoU.default)("nand2tetrisHdl", function() {
        return (parcelRequire("cLSQM"));
    }),
    naniscript: (0, $aTvoU.default)("naniscript", function() {
        return (parcelRequire("8klao"));
    }),
    nasm: (0, $aTvoU.default)("nasm", function() {
        return (parcelRequire("dtceJ"));
    }),
    neon: (0, $aTvoU.default)("neon", function() {
        return (parcelRequire("4LlQk"));
    }),
    nevod: (0, $aTvoU.default)("nevod", function() {
        return (parcelRequire("2kduW"));
    }),
    nginx: (0, $aTvoU.default)("nginx", function() {
        return (parcelRequire("ekVAf"));
    }),
    nim: (0, $aTvoU.default)("nim", function() {
        return (parcelRequire("2lcK8"));
    }),
    nix: (0, $aTvoU.default)("nix", function() {
        return (parcelRequire("ed4w4"));
    }),
    nsis: (0, $aTvoU.default)("nsis", function() {
        return (parcelRequire("lIG48"));
    }),
    objectivec: (0, $aTvoU.default)("objectivec", function() {
        return (parcelRequire("iL6lG"));
    }),
    ocaml: (0, $aTvoU.default)("ocaml", function() {
        return (parcelRequire("8wDnV"));
    }),
    opencl: (0, $aTvoU.default)("opencl", function() {
        return (parcelRequire("aobQJ"));
    }),
    openqasm: (0, $aTvoU.default)("openqasm", function() {
        return (parcelRequire("lN8eG"));
    }),
    oz: (0, $aTvoU.default)("oz", function() {
        return (parcelRequire("7EDRO"));
    }),
    parigp: (0, $aTvoU.default)("parigp", function() {
        return (parcelRequire("28VIG"));
    }),
    parser: (0, $aTvoU.default)("parser", function() {
        return (parcelRequire("1SlhB"));
    }),
    pascal: (0, $aTvoU.default)("pascal", function() {
        return (parcelRequire("fM6L3"));
    }),
    pascaligo: (0, $aTvoU.default)("pascaligo", function() {
        return (parcelRequire("6cV9b"));
    }),
    pcaxis: (0, $aTvoU.default)("pcaxis", function() {
        return (parcelRequire("gzCe5"));
    }),
    peoplecode: (0, $aTvoU.default)("peoplecode", function() {
        return (parcelRequire("kfkV3"));
    }),
    perl: (0, $aTvoU.default)("perl", function() {
        return (parcelRequire("j96fP"));
    }),
    phpExtras: (0, $aTvoU.default)("phpExtras", function() {
        return (parcelRequire("f1mXC"));
    }),
    php: (0, $aTvoU.default)("php", function() {
        return (parcelRequire("bMj5U"));
    }),
    phpdoc: (0, $aTvoU.default)("phpdoc", function() {
        return (parcelRequire("bsS2r"));
    }),
    plsql: (0, $aTvoU.default)("plsql", function() {
        return (parcelRequire("c9Qxq"));
    }),
    powerquery: (0, $aTvoU.default)("powerquery", function() {
        return (parcelRequire("g8g8B"));
    }),
    powershell: (0, $aTvoU.default)("powershell", function() {
        return (parcelRequire("8AqDn"));
    }),
    processing: (0, $aTvoU.default)("processing", function() {
        return (parcelRequire("6gDz1"));
    }),
    prolog: (0, $aTvoU.default)("prolog", function() {
        return (parcelRequire("fy85Q"));
    }),
    promql: (0, $aTvoU.default)("promql", function() {
        return (parcelRequire("83sMW"));
    }),
    properties: (0, $aTvoU.default)("properties", function() {
        return (parcelRequire("5VNI3"));
    }),
    protobuf: (0, $aTvoU.default)("protobuf", function() {
        return (parcelRequire("hx1I1"));
    }),
    psl: (0, $aTvoU.default)("psl", function() {
        return (parcelRequire("4emdn"));
    }),
    pug: (0, $aTvoU.default)("pug", function() {
        return (parcelRequire("fJfZA"));
    }),
    puppet: (0, $aTvoU.default)("puppet", function() {
        return (parcelRequire("ZUaNs"));
    }),
    pure: (0, $aTvoU.default)("pure", function() {
        return (parcelRequire("40EIT"));
    }),
    purebasic: (0, $aTvoU.default)("purebasic", function() {
        return (parcelRequire("hyCHR"));
    }),
    purescript: (0, $aTvoU.default)("purescript", function() {
        return (parcelRequire("5MSOh"));
    }),
    python: (0, $aTvoU.default)("python", function() {
        return (parcelRequire("g15tB"));
    }),
    q: (0, $aTvoU.default)("q", function() {
        return (parcelRequire("hDRoT"));
    }),
    qml: (0, $aTvoU.default)("qml", function() {
        return (parcelRequire("3ph3C"));
    }),
    qore: (0, $aTvoU.default)("qore", function() {
        return (parcelRequire("9egzH"));
    }),
    qsharp: (0, $aTvoU.default)("qsharp", function() {
        return (parcelRequire("g2SPq"));
    }),
    r: (0, $aTvoU.default)("r", function() {
        return (parcelRequire("d1bgL"));
    }),
    racket: (0, $aTvoU.default)("racket", function() {
        return (parcelRequire("l0k3O"));
    }),
    reason: (0, $aTvoU.default)("reason", function() {
        return (parcelRequire("3E5vn"));
    }),
    regex: (0, $aTvoU.default)("regex", function() {
        return (parcelRequire("c8yXa"));
    }),
    rego: (0, $aTvoU.default)("rego", function() {
        return (parcelRequire("dmerW"));
    }),
    renpy: (0, $aTvoU.default)("renpy", function() {
        return (parcelRequire("cPcnu"));
    }),
    rest: (0, $aTvoU.default)("rest", function() {
        return (parcelRequire("1x0GY"));
    }),
    rip: (0, $aTvoU.default)("rip", function() {
        return (parcelRequire("lM2zJ"));
    }),
    roboconf: (0, $aTvoU.default)("roboconf", function() {
        return (parcelRequire("drCtt"));
    }),
    robotframework: (0, $aTvoU.default)("robotframework", function() {
        return (parcelRequire("eijtv"));
    }),
    ruby: (0, $aTvoU.default)("ruby", function() {
        return (parcelRequire("3aUES"));
    }),
    rust: (0, $aTvoU.default)("rust", function() {
        return (parcelRequire("7yp6C"));
    }),
    sas: (0, $aTvoU.default)("sas", function() {
        return (parcelRequire("71m4j"));
    }),
    sass: (0, $aTvoU.default)("sass", function() {
        return (parcelRequire("aVgeo"));
    }),
    scala: (0, $aTvoU.default)("scala", function() {
        return (parcelRequire("cPiqj"));
    }),
    scheme: (0, $aTvoU.default)("scheme", function() {
        return (parcelRequire("b8fvn"));
    }),
    scss: (0, $aTvoU.default)("scss", function() {
        return (parcelRequire("a20mT"));
    }),
    shellSession: (0, $aTvoU.default)("shellSession", function() {
        return (parcelRequire("eKYQA"));
    }),
    smali: (0, $aTvoU.default)("smali", function() {
        return (parcelRequire("5JUKT"));
    }),
    smalltalk: (0, $aTvoU.default)("smalltalk", function() {
        return (parcelRequire("eGTPz"));
    }),
    smarty: (0, $aTvoU.default)("smarty", function() {
        return (parcelRequire("cHJhs"));
    }),
    sml: (0, $aTvoU.default)("sml", function() {
        return (parcelRequire("iZsKL"));
    }),
    solidity: (0, $aTvoU.default)("solidity", function() {
        return (parcelRequire("cyxf2"));
    }),
    solutionFile: (0, $aTvoU.default)("solutionFile", function() {
        return (parcelRequire("gkJcN"));
    }),
    soy: (0, $aTvoU.default)("soy", function() {
        return (parcelRequire("gDPui"));
    }),
    sparql: (0, $aTvoU.default)("sparql", function() {
        return (parcelRequire("gZetJ"));
    }),
    splunkSpl: (0, $aTvoU.default)("splunkSpl", function() {
        return (parcelRequire("hap1F"));
    }),
    sqf: (0, $aTvoU.default)("sqf", function() {
        return (parcelRequire("eL9NM"));
    }),
    sql: (0, $aTvoU.default)("sql", function() {
        return (parcelRequire("dZkTD"));
    }),
    squirrel: (0, $aTvoU.default)("squirrel", function() {
        return (parcelRequire("k03sx"));
    }),
    stan: (0, $aTvoU.default)("stan", function() {
        return (parcelRequire("7Kphk"));
    }),
    stylus: (0, $aTvoU.default)("stylus", function() {
        return (parcelRequire("jLaZi"));
    }),
    swift: (0, $aTvoU.default)("swift", function() {
        return (parcelRequire("fQMwN"));
    }),
    systemd: (0, $aTvoU.default)("systemd", function() {
        return (parcelRequire("gnqul"));
    }),
    t4Cs: (0, $aTvoU.default)("t4Cs", function() {
        return (parcelRequire("lksra"));
    }),
    t4Templating: (0, $aTvoU.default)("t4Templating", function() {
        return (parcelRequire("2ZQmr"));
    }),
    t4Vb: (0, $aTvoU.default)("t4Vb", function() {
        return (parcelRequire("8YaPZ"));
    }),
    tap: (0, $aTvoU.default)("tap", function() {
        return (parcelRequire("2VH0E"));
    }),
    tcl: (0, $aTvoU.default)("tcl", function() {
        return (parcelRequire("39ata"));
    }),
    textile: (0, $aTvoU.default)("textile", function() {
        return (parcelRequire("cyf6d"));
    }),
    toml: (0, $aTvoU.default)("toml", function() {
        return (parcelRequire("i3Oof"));
    }),
    tremor: (0, $aTvoU.default)("tremor", function() {
        return (parcelRequire("9oVUi"));
    }),
    tsx: (0, $aTvoU.default)("tsx", function() {
        return (parcelRequire("1515L"));
    }),
    tt2: (0, $aTvoU.default)("tt2", function() {
        return (parcelRequire("f4SgS"));
    }),
    turtle: (0, $aTvoU.default)("turtle", function() {
        return (parcelRequire("bClhD"));
    }),
    twig: (0, $aTvoU.default)("twig", function() {
        return (parcelRequire("aRwgi"));
    }),
    typescript: (0, $aTvoU.default)("typescript", function() {
        return (parcelRequire("01dmj"));
    }),
    typoscript: (0, $aTvoU.default)("typoscript", function() {
        return (parcelRequire("ijifA"));
    }),
    unrealscript: (0, $aTvoU.default)("unrealscript", function() {
        return (parcelRequire("dlhpe"));
    }),
    uorazor: (0, $aTvoU.default)("uorazor", function() {
        return (parcelRequire("7nb2W"));
    }),
    uri: (0, $aTvoU.default)("uri", function() {
        return (parcelRequire("90an1"));
    }),
    v: (0, $aTvoU.default)("v", function() {
        return (parcelRequire("1a4ID"));
    }),
    vala: (0, $aTvoU.default)("vala", function() {
        return (parcelRequire("fYFaL"));
    }),
    vbnet: (0, $aTvoU.default)("vbnet", function() {
        return (parcelRequire("2beL0"));
    }),
    velocity: (0, $aTvoU.default)("velocity", function() {
        return (parcelRequire("h9JRM"));
    }),
    verilog: (0, $aTvoU.default)("verilog", function() {
        return (parcelRequire("6CjjQ"));
    }),
    vhdl: (0, $aTvoU.default)("vhdl", function() {
        return (parcelRequire("fxQoU"));
    }),
    vim: (0, $aTvoU.default)("vim", function() {
        return (parcelRequire("iZLso"));
    }),
    visualBasic: (0, $aTvoU.default)("visualBasic", function() {
        return (parcelRequire("1Qbq9"));
    }),
    warpscript: (0, $aTvoU.default)("warpscript", function() {
        return (parcelRequire("6Ragk"));
    }),
    wasm: (0, $aTvoU.default)("wasm", function() {
        return (parcelRequire("j33QK"));
    }),
    webIdl: (0, $aTvoU.default)("webIdl", function() {
        return (parcelRequire("5mjB0"));
    }),
    wiki: (0, $aTvoU.default)("wiki", function() {
        return (parcelRequire("jzCEn"));
    }),
    wolfram: (0, $aTvoU.default)("wolfram", function() {
        return (parcelRequire("i57AB"));
    }),
    wren: (0, $aTvoU.default)("wren", function() {
        return (parcelRequire("955Qe"));
    }),
    xeora: (0, $aTvoU.default)("xeora", function() {
        return (parcelRequire("scDv4"));
    }),
    xmlDoc: (0, $aTvoU.default)("xmlDoc", function() {
        return (parcelRequire("cLDds"));
    }),
    xojo: (0, $aTvoU.default)("xojo", function() {
        return (parcelRequire("fXQIJ"));
    }),
    xquery: (0, $aTvoU.default)("xquery", function() {
        return (parcelRequire("8JVPK"));
    }),
    yaml: (0, $aTvoU.default)("yaml", function() {
        return (parcelRequire("2arys"));
    }),
    yang: (0, $aTvoU.default)("yang", function() {
        return (parcelRequire("5QRzH"));
    }),
    zig: (0, $aTvoU.default)("zig", function() {
        return (parcelRequire("18nxD"));
    })
};

});
parcelRequire.register("aTvoU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ee765f88761fa3d$export$2e2bcd8739ae039; });

var $fUktq = parcelRequire("fUktq");

var $iwJJ6 = parcelRequire("iwJJ6");
var $7ee765f88761fa3d$export$2e2bcd8739ae039 = function(name, loader) {
    return /*#__PURE__*/ function() {
        var _ref = (0, $fUktq.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iwJJ6))).mark(function _callee(registerLanguage) {
            var module;
            return (0, (/*@__PURE__*/$parcel$interopDefault($iwJJ6))).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _context.next = 2;
                        return loader();
                    case 2:
                        module = _context.sent;
                        registerLanguage(name, module["default"] || module);
                    case 4:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function(_x) {
            return _ref.apply(this, arguments);
        };
    }();
};

});

parcelRequire.register("jeLcl", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("97Q4N")).then(()=>parcelRequire("hCj0K"));

});

parcelRequire.register("k24E2", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("h2l5o")).then(()=>parcelRequire("20jlZ"));

});

parcelRequire.register("ay58t", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("jeCOw")).then(()=>parcelRequire("7GR3u"));

});

parcelRequire.register("cuH1L", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("154at")).then(()=>parcelRequire("xiPpx"));

});

parcelRequire.register("2T30k", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("3PCMY")).then(()=>parcelRequire("3nGQA"));

});

parcelRequire.register("6qeWk", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("hRoYm")).then(()=>parcelRequire("hKC3U"));

});

parcelRequire.register("01pJB", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("jgOn3")).then(()=>parcelRequire("7thEg"));

});

parcelRequire.register("2nbiO", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("eXvt4")).then(()=>parcelRequire("beUtB"));

});

parcelRequire.register("b52Nf", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fyTk0")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("jhkic"))
]).then(()=>parcelRequire("9FQdK"));

});

parcelRequire.register("lfyNf", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("hutLV")).then(()=>parcelRequire("GL7c9"));

});

parcelRequire.register("dKYQp", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("bgRS2")).then(()=>parcelRequire("9mRfQ"));

});

parcelRequire.register("dtP1m", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("32Cu5")).then(()=>parcelRequire("gKh2E"));

});

parcelRequire.register("h9b2k", function(module, exports) {









module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("evw3J")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("3Cfqo")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("2MWyN"))
]).then(()=>parcelRequire("f0Tyv"));

});

parcelRequire.register("556y9", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("Kb3EB")).then(()=>parcelRequire("8e21d"));

});

parcelRequire.register("eaZg8", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("6LfAY")).then(()=>parcelRequire("cvBIK"));

});

parcelRequire.register("3Rh2y", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("7ZHMc")).then(()=>parcelRequire("4ua0n"));

});

parcelRequire.register("iY8T7", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("9jQWS")).then(()=>parcelRequire("hbKR3"));

});

parcelRequire.register("jJH6g", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("4fmB7")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("1tj8G"))
]).then(()=>parcelRequire("cyr6s"));

});

parcelRequire.register("3Cf7x", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("60cQZ")).then(()=>parcelRequire("cQTBb"));

});

parcelRequire.register("4cAvP", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fDCNB")).then(()=>parcelRequire("2NLni"));

});

parcelRequire.register("40BaG", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("b3j2U")).then(()=>parcelRequire("cddb7"));

});

parcelRequire.register("gGHtK", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("5BOPo")).then(()=>parcelRequire("dCF4z"));

});

parcelRequire.register("bmGYo", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("7ydyW")).then(()=>parcelRequire("dz1zE"));

});

parcelRequire.register("7rwZl", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("5jujM")).then(()=>parcelRequire("bPhDe"));

});

parcelRequire.register("1T7gS", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("v7it9")).then(()=>parcelRequire("1CrZT"));

});

parcelRequire.register("iSdnA", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("4SyEB")).then(()=>parcelRequire("9nq2g"));

});

parcelRequire.register("hyVJa", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("jIAbF")).then(()=>parcelRequire("4EqQX"));

});

parcelRequire.register("eX6aW", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("iAhzA")).then(()=>parcelRequire("cPD9a"));

});

parcelRequire.register("hvVZr", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("evw3J")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("bf3XR"))
]).then(()=>parcelRequire("kZiRQ"));

});

parcelRequire.register("aSMxV", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("4DaJO")).then(()=>parcelRequire("lwuMR"));

});

parcelRequire.register("ynbCi", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("aGIT9")).then(()=>parcelRequire("aViII"));

});

parcelRequire.register("3ojQv", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("hx6Tx")).then(()=>parcelRequire("e3Y8e"));

});

parcelRequire.register("gnXaj", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("kuce4")).then(()=>parcelRequire("gIGs0"));

});

parcelRequire.register("ix23A", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("5yEe8")).then(()=>parcelRequire("2i2RP"));

});

parcelRequire.register("bH79W", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("evw3J")).then(()=>parcelRequire("8gOup"));

});

parcelRequire.register("g4o8m", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("aMQgB")).then(()=>parcelRequire("annfF"));

});

parcelRequire.register("3Btr9", function(module, exports) {









module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("evw3J")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("3Cfqo")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("bhqTm"))
]).then(()=>parcelRequire("4HdW0"));

});

parcelRequire.register("kfuQs", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("eTVe3")).then(()=>parcelRequire("78sQ0"));

});

parcelRequire.register("fi2Ev", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("7TFH7")).then(()=>parcelRequire("4xKaQ"));

});

parcelRequire.register("ahN1j", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("eq84r")).then(()=>parcelRequire("01L6w"));

});

parcelRequire.register("kguP1", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("7IZEJ")).then(()=>parcelRequire("ga0SD"));

});

parcelRequire.register("fAncd", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("6Bi5A")).then(()=>parcelRequire("d840W"));

});

parcelRequire.register("7sZsV", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("9lOS0")).then(()=>parcelRequire("1iHYP"));

});

parcelRequire.register("jwmsw", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("6AxIB")).then(()=>parcelRequire("5dVGq"));

});

parcelRequire.register("hM4XU", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("8aXiN")).then(()=>parcelRequire("aPRrM"));

});

parcelRequire.register("gqAAm", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("evw3J")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("3Cfqo"))
]).then(()=>parcelRequire("5pmJk"));

});

parcelRequire.register("kvwqP", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("3TOrQ")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("63wzs"))
]).then(()=>parcelRequire("lmZhU"));

});

parcelRequire.register("in1tv", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("4fmB7")).then(()=>parcelRequire("7zZPy"));

});

parcelRequire.register("8oSV6", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("4fmB7")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("5tPhO"))
]).then(()=>parcelRequire("jJ7xc"));

});

parcelRequire.register("khrNp", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("hWZLv")).then(()=>parcelRequire("8lE9I"));

});

parcelRequire.register("95M9M", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("9gDlq")).then(()=>parcelRequire("kYgfo"));

});

parcelRequire.register("16KCw", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("74TTn")).then(()=>parcelRequire("bXysr"));

});

parcelRequire.register("xFmyy", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("gJ4PJ")).then(()=>parcelRequire("9P2LL"));

});

parcelRequire.register("2J3B2", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("eeqro")).then(()=>parcelRequire("8jTF4"));

});

parcelRequire.register("gXlIj", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("lsxva")).then(()=>parcelRequire("d3tx0"));

});

parcelRequire.register("bxTnl", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("isuG7")).then(()=>parcelRequire("3G849"));

});

parcelRequire.register("ePK2o", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("l6PPd")).then(()=>parcelRequire("8sXxw"));

});

parcelRequire.register("cFQBT", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("cI4XZ")).then(()=>parcelRequire("i1l0i"));

});

parcelRequire.register("efaWR", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("a5OWT")).then(()=>parcelRequire("fwaZg"));

});

parcelRequire.register("5BXKA", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("bwd4Y")).then(()=>parcelRequire("3bf4i"));

});

parcelRequire.register("azBXG", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("eTlf4")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("ht3dN"))
]).then(()=>parcelRequire("bOo4n"));

});

parcelRequire.register("fCNtm", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("g7QyH")).then(()=>parcelRequire("8fKYO"));

});

parcelRequire.register("iV6Ah", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("3XDSg")).then(()=>parcelRequire("lAuQj"));

});

parcelRequire.register("bTWPI", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("3az6Y")).then(()=>parcelRequire("b9r7c"));

});

parcelRequire.register("1XlCU", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("g1Rkl")).then(()=>parcelRequire("c99R9"));

});

parcelRequire.register("ixShN", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("lCyEv")).then(()=>parcelRequire("dZDrv"));

});

parcelRequire.register("iaI3U", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("10Jya")).then(()=>parcelRequire("5vnDL"));

});

parcelRequire.register("7Usfr", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("eTlf4")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("3M6g1"))
]).then(()=>parcelRequire("aFm8t"));

});

parcelRequire.register("8UXTn", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("gt0jj")).then(()=>parcelRequire("jsdxB"));

});

parcelRequire.register("iBEDx", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("avPEU")).then(()=>parcelRequire("817vW"));

});

parcelRequire.register("jj2Bu", function(module, exports) {









module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("eTlf4")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("3TOrQ")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("hqJSq"))
]).then(()=>parcelRequire("dZCLc"));

});

parcelRequire.register("jhCSO", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("aLI6M")).then(()=>parcelRequire("fXFSk"));

});

parcelRequire.register("8ZGdY", function(module, exports) {









module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("iWA7k")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("eTlf4")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("2uMBh"))
]).then(()=>parcelRequire("5zgBW"));

});

parcelRequire.register("k2mWT", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("6rx7c")).then(()=>parcelRequire("koo5v"));

});

parcelRequire.register("38ubn", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("gOZEz")).then(()=>parcelRequire("1azXf"));

});

parcelRequire.register("d3lOW", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("3ToHP")).then(()=>parcelRequire("ba9xi"));

});

parcelRequire.register("03XAo", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("2zBlY")).then(()=>parcelRequire("gbcTz"));

});

parcelRequire.register("bm0hR", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("crol6")).then(()=>parcelRequire("8lnoY"));

});

parcelRequire.register("9x3hX", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("lHWTp")).then(()=>parcelRequire("fxfsY"));

});

parcelRequire.register("ghYJJ", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("9hq34")).then(()=>parcelRequire("k6eDM"));

});

parcelRequire.register("4wwx1", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("eTlf4")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("9cFDZ"))
]).then(()=>parcelRequire("36Ez1"));

});

parcelRequire.register("N5dA1", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("h9g4P")).then(()=>parcelRequire("dsA5D"));

});

parcelRequire.register("bmeQn", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("jdosd")).then(()=>parcelRequire("bYFbh"));

});

parcelRequire.register("prxFN", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("inhc8")).then(()=>parcelRequire("lFy8h"));

});

parcelRequire.register("ljkrl", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("4PFO5")).then(()=>parcelRequire("5NtNt"));

});

parcelRequire.register("hdP51", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("91Xtf")).then(()=>parcelRequire("a19Cd"));

});

parcelRequire.register("cE1ot", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("boXP2")).then(()=>parcelRequire("iyNCL"));

});

parcelRequire.register("5Lqpu", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("evw3J")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("14ABL"))
]).then(()=>parcelRequire("9z8Zy"));

});

parcelRequire.register("5186D", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("doCMV")).then(()=>parcelRequire("4nTUd"));

});

parcelRequire.register("7OWiG", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("2kPO4")).then(()=>parcelRequire("kobaY"));

});

parcelRequire.register("86NWs", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("5EvhG")).then(()=>parcelRequire("bEPLB"));

});

parcelRequire.register("dJcTd", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("49pBh")).then(()=>parcelRequire("eIxZD"));

});

parcelRequire.register("gfrUW", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("6hJw0")).then(()=>parcelRequire("a0TQu"));

});

parcelRequire.register("jJrxl", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("1r5Yw")).then(()=>parcelRequire("iQBPY"));

});

parcelRequire.register("baY8r", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("3TOrQ")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("97fEl"))
]).then(()=>parcelRequire("5kR7w"));

});

parcelRequire.register("1i26O", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("eTlf4")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("egte2"))
]).then(()=>parcelRequire("1T93h"));

});

parcelRequire.register("jGNnx", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("bGRey")).then(()=>parcelRequire("61qYj"));

});

parcelRequire.register("c6IxX", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("16mlj")).then(()=>parcelRequire("1mkGt"));

});

parcelRequire.register("k3yhj", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("g4xDe")).then(()=>parcelRequire("foMf9"));

});

parcelRequire.register("2eaUn", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("evw3J")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("W4yLI"))
]).then(()=>parcelRequire("cALfs"));

});

parcelRequire.register("7AcZO", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("iGiO7")).then(()=>parcelRequire("9XNhz"));

});

parcelRequire.register("6pDHp", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("cOCJY")).then(()=>parcelRequire("4XLtL"));

});

parcelRequire.register("fuH8r", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("i19Id")).then(()=>parcelRequire("5Mjth"));

});

parcelRequire.register("k9wxQ", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("99cTD")).then(()=>parcelRequire("4NmfJ"));

});

parcelRequire.register("hiH43", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("ercgH")).then(()=>parcelRequire("gIDAn"));

});

parcelRequire.register("gkyde", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("33Bwd")).then(()=>parcelRequire("7CIOE"));

});

parcelRequire.register("lJtMw", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("a8hoV")).then(()=>parcelRequire("1a97N"));

});

parcelRequire.register("a7xRa", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("bGRey")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("ciC2z"))
]).then(()=>parcelRequire("h5JhT"));

});

parcelRequire.register("6uhwH", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("1diWa")).then(()=>parcelRequire("2gGMt"));

});

parcelRequire.register("ebCdc", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("36z6b")).then(()=>parcelRequire("cyouS"));

});

parcelRequire.register("cWwDI", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("gzX7g")).then(()=>parcelRequire("2SVjC"));

});

parcelRequire.register("7rzsg", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("hmjh7")).then(()=>parcelRequire("1KuDV"));

});

parcelRequire.register("8Vgmt", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("bfRz0")).then(()=>parcelRequire("jTYVs"));

});

parcelRequire.register("17z4w", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("eAXnj")).then(()=>parcelRequire("2Lf2X"));

});

parcelRequire.register("4aa5B", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("b14Bo")).then(()=>parcelRequire("CODKY"));

});

parcelRequire.register("iu6gE", function(module, exports) {









module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("kts0I")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("b14Bo")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("3RJLu"))
]).then(()=>parcelRequire("c6G7V"));

});

parcelRequire.register("bMvMj", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("kts0I")).then(()=>parcelRequire("gKpoN"));

});

parcelRequire.register("b0Jhm", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("idXuV")).then(()=>parcelRequire("75SGQ"));

});

parcelRequire.register("aRb7p", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("dC6x7")).then(()=>parcelRequire("kyzWy"));

});

parcelRequire.register("dYy1q", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("47ipL")).then(()=>parcelRequire("ajkmj"));

});

parcelRequire.register("de5gw", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("jEBFk")).then(()=>parcelRequire("bLWBn"));

});

parcelRequire.register("kO2ih", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("a0Bzs")).then(()=>parcelRequire("55k39"));

});

parcelRequire.register("75XdH", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("epnwa")).then(()=>parcelRequire("2CCZZ"));

});

parcelRequire.register("6lilA", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("39jpl")).then(()=>parcelRequire("5nOAZ"));

});

parcelRequire.register("bumD7", function(module, exports) {









module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("kslFH")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("kts0I")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("2Zl6G"))
]).then(()=>parcelRequire("bnwo2"));

});

parcelRequire.register("kdfjJ", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("k7Rg3")).then(()=>parcelRequire("7adzS"));

});

parcelRequire.register("65YCF", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("k7Rg3")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("8liZm"))
]).then(()=>parcelRequire("8EWCL"));

});

parcelRequire.register("hsBPh", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("k7Rg3")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("cL4iZ"))
]).then(()=>parcelRequire("0UHvr"));

});

parcelRequire.register("ejBOa", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("j9lYR")).then(()=>parcelRequire("6HjPT"));

});

parcelRequire.register("P61to", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("5y99i")).then(()=>parcelRequire("h1pUM"));

});

parcelRequire.register("h5yUY", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("cVdIK")).then(()=>parcelRequire("3UNrB"));

});

parcelRequire.register("eJ6gw", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("cIp8C")).then(()=>parcelRequire("iRWkX"));

});

parcelRequire.register("6FYZC", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("is0fo")).then(()=>parcelRequire("bKkzQ"));

});

parcelRequire.register("bFb92", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("dPd8Y")).then(()=>parcelRequire("g4YYS"));

});

parcelRequire.register("enDTs", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("4ASMw")).then(()=>parcelRequire("6bcxA"));

});

parcelRequire.register("4vV9z", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("a3REe")).then(()=>parcelRequire("4kAzy"));

});

parcelRequire.register("8HPOF", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("6FBen")).then(()=>parcelRequire("8fSvS"));

});

parcelRequire.register("brweb", function(module, exports) {









module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("d334m")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("eTlf4")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("iNwrb"))
]).then(()=>parcelRequire("jM8s8"));

});

parcelRequire.register("kFfhT", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("4mrAf")).then(()=>parcelRequire("c15VK"));

});

parcelRequire.register("hqj8Z", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("76dL4")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("iDdnv"))
]).then(()=>parcelRequire("4Z3Va"));

});

parcelRequire.register("8HsHG", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("eTlf4")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("dzhA4"))
]).then(()=>parcelRequire("9njZO"));

});

parcelRequire.register("9AgfI", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("gd3a1")).then(()=>parcelRequire("mHkew"));

});

parcelRequire.register("6vqNT", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("6bw0C")).then(()=>parcelRequire("9PFoJ"));

});

parcelRequire.register("9eenK", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("kQl5D")).then(()=>parcelRequire("9Sx9y"));

});

parcelRequire.register("2xiZb", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("3pxWN")).then(()=>parcelRequire("hRXGs"));

});

parcelRequire.register("9lBGs", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("Ug2OM")).then(()=>parcelRequire("hLWqp"));

});

parcelRequire.register("lOwoR", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("iWA7k")).then(()=>parcelRequire("2yXgp"));

});

parcelRequire.register("9II4F", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("8t0yO")).then(()=>parcelRequire("3CWaC"));

});

parcelRequire.register("k55AZ", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("busjs")).then(()=>parcelRequire("c2M3l"));

});

parcelRequire.register("kupqo", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("1wgIl")).then(()=>parcelRequire("jCf0K"));

});

parcelRequire.register("1Telt", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("eTlf4")).then(()=>parcelRequire("69jOl"));

});

parcelRequire.register("jynAy", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("85Ct2")).then(()=>parcelRequire("8nX7G"));

});

parcelRequire.register("3MtTd", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("bf8oq")).then(()=>parcelRequire("9my4h"));

});

parcelRequire.register("8WioY", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("9d9Xx")).then(()=>parcelRequire("eotf4"));

});

parcelRequire.register("ad4kh", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("cz9kR")).then(()=>parcelRequire("keTsa"));

});

parcelRequire.register("bGTcx", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("2f4EO")).then(()=>parcelRequire("jFBUp"));

});

parcelRequire.register("ln6lx", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("6ZiMR")).then(()=>parcelRequire("kMh36"));

});

parcelRequire.register("iulCv", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("ln56X")).then(()=>parcelRequire("5ax4T"));

});

parcelRequire.register("8aycX", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("kBaCL")).then(()=>parcelRequire("itQXA"));

});

parcelRequire.register("c4ZJ6", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("pl7lf")).then(()=>parcelRequire("eEdrk"));

});

parcelRequire.register("8bv6o", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("h54sU")).then(()=>parcelRequire("1UMyD"));

});

parcelRequire.register("hNDMm", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("5FSJH")).then(()=>parcelRequire("e4i4r"));

});

parcelRequire.register("cLSQM", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("1DyXn")).then(()=>parcelRequire("6aSvx"));

});

parcelRequire.register("8klao", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fFsrr")).then(()=>parcelRequire("jNgrm"));

});

parcelRequire.register("dtceJ", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("asMUn")).then(()=>parcelRequire("jQaH0"));

});

parcelRequire.register("4LlQk", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("9aCA3")).then(()=>parcelRequire("igIU9"));

});

parcelRequire.register("2kduW", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("dR254")).then(()=>parcelRequire("dWmI3"));

});

parcelRequire.register("ekVAf", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("5cfJy")).then(()=>parcelRequire("kekok"));

});

parcelRequire.register("2lcK8", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("7xNvH")).then(()=>parcelRequire("7Wjsn"));

});

parcelRequire.register("ed4w4", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("bTc4E")).then(()=>parcelRequire("2STBX"));

});

parcelRequire.register("lIG48", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("k09bi")).then(()=>parcelRequire("8NgB3"));

});

parcelRequire.register("iL6lG", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("evw3J")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("lppn7"))
]).then(()=>parcelRequire("4xLf3"));

});

parcelRequire.register("8wDnV", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("kIZ7K")).then(()=>parcelRequire("dsgzk"));

});

parcelRequire.register("aobQJ", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("evw3J")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("5RCsr"))
]).then(()=>parcelRequire("iREK0"));

});

parcelRequire.register("lN8eG", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("kqqwP")).then(()=>parcelRequire("fdk5A"));

});

parcelRequire.register("7EDRO", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("bhrOR")).then(()=>parcelRequire("iYcrL"));

});

parcelRequire.register("28VIG", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("1mGgu")).then(()=>parcelRequire("j1bOm"));

});

parcelRequire.register("1SlhB", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("lza4J")).then(()=>parcelRequire("6XP9B"));

});

parcelRequire.register("fM6L3", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("1Guzd")).then(()=>parcelRequire("oQI8x"));

});

parcelRequire.register("6cV9b", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("3hKiS")).then(()=>parcelRequire("7ma4y"));

});

parcelRequire.register("gzCe5", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("730IO")).then(()=>parcelRequire("4eoFx"));

});

parcelRequire.register("kfkV3", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fdUfd")).then(()=>parcelRequire("kTj5U"));

});

parcelRequire.register("j96fP", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("aTWyt")).then(()=>parcelRequire("cac8H"));

});

parcelRequire.register("f1mXC", function(module, exports) {









module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("d334m")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("eTlf4")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("1PXh5"))
]).then(()=>parcelRequire("kfMlS"));

});

parcelRequire.register("bMj5U", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("eTlf4")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("d334m"))
]).then(()=>parcelRequire("j0B3m"));

});

parcelRequire.register("bsS2r", function(module, exports) {












module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("d334m")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("kts0I")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("eTlf4")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("pkzeB"))
]).then(()=>parcelRequire("eDYx9"));

});

parcelRequire.register("c9Qxq", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fyTk0")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("AKPps"))
]).then(()=>parcelRequire("liUsE"));

});

parcelRequire.register("g8g8B", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("euz28")).then(()=>parcelRequire("jV5ry"));

});

parcelRequire.register("8AqDn", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("6dPWs")).then(()=>parcelRequire("5At8F"));

});

parcelRequire.register("6gDz1", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("4WOZY")).then(()=>parcelRequire("dy2dL"));

});

parcelRequire.register("fy85Q", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("lerIj")).then(()=>parcelRequire("gjAaq"));

});

parcelRequire.register("83sMW", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("hMcol")).then(()=>parcelRequire("gdLk1"));

});

parcelRequire.register("5VNI3", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("gRmYq")).then(()=>parcelRequire("1YUaU"));

});

parcelRequire.register("hx1I1", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("eKK2A")).then(()=>parcelRequire("bHbZR"));

});

parcelRequire.register("4emdn", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("4gIKL")).then(()=>parcelRequire("4TYez"));

});

parcelRequire.register("fJfZA", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("a1tCJ")).then(()=>parcelRequire("7g6nU"));

});

parcelRequire.register("ZUaNs", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("16YPY")).then(()=>parcelRequire("84ave"));

});

parcelRequire.register("40EIT", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("2FLxj")).then(()=>parcelRequire("hfgkW"));

});

parcelRequire.register("hyCHR", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("bfYcm")).then(()=>parcelRequire("jtSaL"));

});

parcelRequire.register("5MSOh", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("bGRey")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("iXZ8W"))
]).then(()=>parcelRequire("5SHpn"));

});

parcelRequire.register("g15tB", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("7ADoS")).then(()=>parcelRequire("dKkHx"));

});

parcelRequire.register("hDRoT", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("9JGdv")).then(()=>parcelRequire("l9RTB"));

});

parcelRequire.register("3ph3C", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("bImPE")).then(()=>parcelRequire("62heN"));

});

parcelRequire.register("9egzH", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("5hbvh")).then(()=>parcelRequire("7rZxY"));

});

parcelRequire.register("g2SPq", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("4YqQr")).then(()=>parcelRequire("66xS7"));

});

parcelRequire.register("d1bgL", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("6Pcno")).then(()=>parcelRequire("gdIeL"));

});

parcelRequire.register("l0k3O", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("76dL4")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("23zYA"))
]).then(()=>parcelRequire("horvy"));

});

parcelRequire.register("3E5vn", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("byf4A")).then(()=>parcelRequire("dWtmL"));

});

parcelRequire.register("c8yXa", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("jDSsz")).then(()=>parcelRequire("cpgME"));

});

parcelRequire.register("dmerW", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("4bWet")).then(()=>parcelRequire("2If1b"));

});

parcelRequire.register("cPcnu", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fMoUR")).then(()=>parcelRequire("jXAuT"));

});

parcelRequire.register("1x0GY", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("36CiJ")).then(()=>parcelRequire("6Aqz7"));

});

parcelRequire.register("lM2zJ", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("7yuLd")).then(()=>parcelRequire("6KIKN"));

});

parcelRequire.register("drCtt", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("bfPXr")).then(()=>parcelRequire("eeC0U"));

});

parcelRequire.register("eijtv", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("6upyS")).then(()=>parcelRequire("5S9XK"));

});

parcelRequire.register("3aUES", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("3TOrQ")).then(()=>parcelRequire("h0PED"));

});

parcelRequire.register("7yp6C", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("gxNCq")).then(()=>parcelRequire("l0zFn"));

});

parcelRequire.register("71m4j", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("ihCuR")).then(()=>parcelRequire("h6g8i"));

});

parcelRequire.register("aVgeo", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("ccunm")).then(()=>parcelRequire("EG5IL"));

});

parcelRequire.register("cPiqj", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("b14Bo")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("dHy7X"))
]).then(()=>parcelRequire("15J1W"));

});

parcelRequire.register("b8fvn", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("76dL4")).then(()=>parcelRequire("izkGm"));

});

parcelRequire.register("a20mT", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("1FaIe")).then(()=>parcelRequire("8yGK9"));

});

parcelRequire.register("eKYQA", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("7ydyW")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("i1fHu"))
]).then(()=>parcelRequire("jY0Oe"));

});

parcelRequire.register("5JUKT", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("62Fi9")).then(()=>parcelRequire("eoIbJ"));

});

parcelRequire.register("eGTPz", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fWFkg")).then(()=>parcelRequire("eiGP3"));

});

parcelRequire.register("cHJhs", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("eTlf4")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("aMmHu"))
]).then(()=>parcelRequire("3Zd6h"));

});

parcelRequire.register("iZsKL", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("8bGNf")).then(()=>parcelRequire("5D9Dc"));

});

parcelRequire.register("cyxf2", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("cHDs3")).then(()=>parcelRequire("kso3I"));

});

parcelRequire.register("gkJcN", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("8iYiI")).then(()=>parcelRequire("i49Um"));

});

parcelRequire.register("gDPui", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("eTlf4")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("7MF2y"))
]).then(()=>parcelRequire("7seFs"));

});

parcelRequire.register("gZetJ", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("hZqK6")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("4ksUk"))
]).then(()=>parcelRequire("2tJDm"));

});

parcelRequire.register("hap1F", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("lDeLQ")).then(()=>parcelRequire("1xEil"));

});

parcelRequire.register("eL9NM", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("8xkA5")).then(()=>parcelRequire("jcpPe"));

});

parcelRequire.register("dZkTD", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fyTk0")).then(()=>parcelRequire("eR8Ow"));

});

parcelRequire.register("k03sx", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("b82g6")).then(()=>parcelRequire("10hDU"));

});

parcelRequire.register("7Kphk", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("k1YVv")).then(()=>parcelRequire("ebeno"));

});

parcelRequire.register("jLaZi", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("4D4eC")).then(()=>parcelRequire("h2nyI"));

});

parcelRequire.register("fQMwN", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("6kjxJ")).then(()=>parcelRequire("lQttC"));

});

parcelRequire.register("gnqul", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("40OWN")).then(()=>parcelRequire("3NdII"));

});

parcelRequire.register("lksra", function(module, exports) {









module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("2Hdkq")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("4fmB7")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("jDkXS"))
]).then(()=>parcelRequire("jJVSv"));

});

parcelRequire.register("2ZQmr", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("2Hdkq")).then(()=>parcelRequire("4PhPd"));

});

parcelRequire.register("8YaPZ", function(module, exports) {












module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("kx25m")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("2Hdkq")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("5jujM")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fYn6y"))
]).then(()=>parcelRequire("kkxJl"));

});

parcelRequire.register("2VH0E", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("hEzBF")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("75GK8"))
]).then(()=>parcelRequire("e76eu"));

});

parcelRequire.register("39ata", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("iC8Ae")).then(()=>parcelRequire("llWT3"));

});

parcelRequire.register("cyf6d", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fas6F")).then(()=>parcelRequire("oZ3iA"));

});

parcelRequire.register("i3Oof", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("e2Bwk")).then(()=>parcelRequire("bOC2o"));

});

parcelRequire.register("9oVUi", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("dpl0W")).then(()=>parcelRequire("5XudI"));

});

parcelRequire.register("1515L", function(module, exports) {









module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("5y99i")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("kslFH")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("jo2BL"))
]).then(()=>parcelRequire("5GUv2"));

});

parcelRequire.register("f4SgS", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("eTlf4")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("d96Pw"))
]).then(()=>parcelRequire("1Ofmt"));

});

parcelRequire.register("bClhD", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("hZqK6")).then(()=>parcelRequire("jPRmd"));

});

parcelRequire.register("aRwgi", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("eTlf4")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("eLCij"))
]).then(()=>parcelRequire("53lUk"));

});

parcelRequire.register("01dmj", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("kslFH")).then(()=>parcelRequire("1lWF3"));

});

parcelRequire.register("ijifA", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("975Qj")).then(()=>parcelRequire("5w4bF"));

});

parcelRequire.register("dlhpe", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("3ZMyV")).then(()=>parcelRequire("cZQZ6"));

});

parcelRequire.register("7nb2W", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("cVE9M")).then(()=>parcelRequire("avtDU"));

});

parcelRequire.register("90an1", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("3FCMl")).then(()=>parcelRequire("3qX9p"));

});

parcelRequire.register("1a4ID", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("5vXmX")).then(()=>parcelRequire("4b3rM"));

});

parcelRequire.register("fYFaL", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("cNedT")).then(()=>parcelRequire("hjNs9"));

});

parcelRequire.register("2beL0", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("5jujM")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("kx25m"))
]).then(()=>parcelRequire("kF0Hx"));

});

parcelRequire.register("h9JRM", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("4h2iS")).then(()=>parcelRequire("azeUh"));

});

parcelRequire.register("6CjjQ", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("gCFun")).then(()=>parcelRequire("enBbt"));

});

parcelRequire.register("fxQoU", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("66fOq")).then(()=>parcelRequire("htsBA"));

});

parcelRequire.register("iZLso", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("yL5DR")).then(()=>parcelRequire("bYJGS"));

});

parcelRequire.register("1Qbq9", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("9Jh0L")).then(()=>parcelRequire("9eQH3"));

});

parcelRequire.register("6Ragk", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("eAUdY")).then(()=>parcelRequire("a7KOe"));

});

parcelRequire.register("j33QK", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("jJdmU")).then(()=>parcelRequire("cgB4c"));

});

parcelRequire.register("5mjB0", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("7M43l")).then(()=>parcelRequire("27dKK"));

});

parcelRequire.register("jzCEn", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("hpBAZ")).then(()=>parcelRequire("fNTle"));

});

parcelRequire.register("i57AB", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("7nAjx")).then(()=>parcelRequire("lpoSX"));

});

parcelRequire.register("955Qe", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("eImxQ")).then(()=>parcelRequire("giK5A"));

});

parcelRequire.register("scDv4", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("l5TJG")).then(()=>parcelRequire("lYi8X"));

});

parcelRequire.register("cLDds", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("6Dk8B")).then(()=>parcelRequire("4ufo6"));

});

parcelRequire.register("fXQIJ", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("cY1Mu")).then(()=>parcelRequire("c2O10"));

});

parcelRequire.register("8JVPK", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("ajsQG")).then(()=>parcelRequire("fDCot"));

});

parcelRequire.register("2arys", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("hEzBF")).then(()=>parcelRequire("kC4dr"));

});

parcelRequire.register("5QRzH", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("3x7TU")).then(()=>parcelRequire("6qZaJ"));

});

parcelRequire.register("18nxD", function(module, exports) {



module.exports = (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("iV1DM")).then(()=>parcelRequire("9xHPK"));

});


parcelRequire.register("XHWfS", function(module, exports) {















module.exports = Promise.all([
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("85Ct2")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("idXuV")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("74TTn")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("7TFH7")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("2Nxi1"))
]).then(()=>parcelRequire("gFupu"));

});


parcelRequire.register("5hoyb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d819573beab3bcb$export$2e2bcd8739ae039; });
var $3d819573beab3bcb$export$2e2bcd8739ae039 = {
    'code[class*="language-"]': {
        "color": "#f8f8f2",
        "background": "none",
        "fontFamily": "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
        "textAlign": "left",
        "whiteSpace": "pre",
        "wordSpacing": "normal",
        "wordBreak": "normal",
        "wordWrap": "normal",
        "lineHeight": "1.5",
        "MozTabSize": "4",
        "OTabSize": "4",
        "tabSize": "4",
        "WebkitHyphens": "none",
        "MozHyphens": "none",
        "msHyphens": "none",
        "hyphens": "none"
    },
    'pre[class*="language-"]': {
        "color": "#f8f8f2",
        "background": "#2b2b2b",
        "fontFamily": "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
        "textAlign": "left",
        "whiteSpace": "pre",
        "wordSpacing": "normal",
        "wordBreak": "normal",
        "wordWrap": "normal",
        "lineHeight": "1.5",
        "MozTabSize": "4",
        "OTabSize": "4",
        "tabSize": "4",
        "WebkitHyphens": "none",
        "MozHyphens": "none",
        "msHyphens": "none",
        "hyphens": "none",
        "padding": "1em",
        "margin": "0.5em 0",
        "overflow": "auto",
        "borderRadius": "0.3em"
    },
    ':not(pre) > code[class*="language-"]': {
        "background": "#2b2b2b",
        "padding": "0.1em",
        "borderRadius": "0.3em",
        "whiteSpace": "normal"
    },
    "comment": {
        "color": "#d4d0ab"
    },
    "prolog": {
        "color": "#d4d0ab"
    },
    "doctype": {
        "color": "#d4d0ab"
    },
    "cdata": {
        "color": "#d4d0ab"
    },
    "punctuation": {
        "color": "#fefefe"
    },
    "property": {
        "color": "#ffa07a"
    },
    "tag": {
        "color": "#ffa07a"
    },
    "constant": {
        "color": "#ffa07a"
    },
    "symbol": {
        "color": "#ffa07a"
    },
    "deleted": {
        "color": "#ffa07a"
    },
    "boolean": {
        "color": "#00e0e0"
    },
    "number": {
        "color": "#00e0e0"
    },
    "selector": {
        "color": "#abe338"
    },
    "attr-name": {
        "color": "#abe338"
    },
    "string": {
        "color": "#abe338"
    },
    "char": {
        "color": "#abe338"
    },
    "builtin": {
        "color": "#abe338"
    },
    "inserted": {
        "color": "#abe338"
    },
    "operator": {
        "color": "#00e0e0"
    },
    "entity": {
        "color": "#00e0e0",
        "cursor": "help"
    },
    "url": {
        "color": "#00e0e0"
    },
    ".language-css .token.string": {
        "color": "#00e0e0"
    },
    ".style .token.string": {
        "color": "#00e0e0"
    },
    "variable": {
        "color": "#00e0e0"
    },
    "atrule": {
        "color": "#ffd700"
    },
    "attr-value": {
        "color": "#ffd700"
    },
    "function": {
        "color": "#ffd700"
    },
    "keyword": {
        "color": "#00e0e0"
    },
    "regex": {
        "color": "#ffd700"
    },
    "important": {
        "color": "#ffd700",
        "fontWeight": "bold"
    },
    "bold": {
        "fontWeight": "bold"
    },
    "italic": {
        "fontStyle": "italic"
    }
};

});

parcelRequire.register("7TamO", function(module, exports) {

$parcel$export(module.exports, "container", function () { return $5be5b61d5a4e07aa$export$34e0f9847d4c02dd; }, function (v) { return $5be5b61d5a4e07aa$export$34e0f9847d4c02dd = v; });
$parcel$export(module.exports, "copy", function () { return $5be5b61d5a4e07aa$export$784d13d8ee351f07; }, function (v) { return $5be5b61d5a4e07aa$export$784d13d8ee351f07 = v; });
$parcel$export(module.exports, "editor", function () { return $5be5b61d5a4e07aa$export$b5d042d2b680aed6; }, function (v) { return $5be5b61d5a4e07aa$export$b5d042d2b680aed6 = v; });
$parcel$export(module.exports, "errorMessage", function () { return $5be5b61d5a4e07aa$export$493b5823483d2c4e; }, function (v) { return $5be5b61d5a4e07aa$export$493b5823483d2c4e = v; });
$parcel$export(module.exports, "placeholder", function () { return $5be5b61d5a4e07aa$export$c7187bbd1a7a9244; }, function (v) { return $5be5b61d5a4e07aa$export$c7187bbd1a7a9244 = v; });
$parcel$export(module.exports, "readonly", function () { return $5be5b61d5a4e07aa$export$6ec456bd5b7b3c51; }, function (v) { return $5be5b61d5a4e07aa$export$6ec456bd5b7b3c51 = v; });
var $5be5b61d5a4e07aa$export$34e0f9847d4c02dd;
var $5be5b61d5a4e07aa$export$784d13d8ee351f07;
var $5be5b61d5a4e07aa$export$b5d042d2b680aed6;
var $5be5b61d5a4e07aa$export$493b5823483d2c4e;
var $5be5b61d5a4e07aa$export$c7187bbd1a7a9244;
var $5be5b61d5a4e07aa$export$6ec456bd5b7b3c51;
var $5be5b61d5a4e07aa$export$bfd64c937657f93a;
var $5be5b61d5a4e07aa$export$4a6dd88bada4e7d2;
$5be5b61d5a4e07aa$export$34e0f9847d4c02dd = `Nd8Kjq_container`;
$5be5b61d5a4e07aa$export$784d13d8ee351f07 = `Nd8Kjq_copy`;
$5be5b61d5a4e07aa$export$b5d042d2b680aed6 = `Nd8Kjq_editor`;
$5be5b61d5a4e07aa$export$493b5823483d2c4e = `Nd8Kjq_errorMessage`;
$5be5b61d5a4e07aa$export$c7187bbd1a7a9244 = `Nd8Kjq_placeholder`;
$5be5b61d5a4e07aa$export$6ec456bd5b7b3c51 = `Nd8Kjq_readonly`;
$5be5b61d5a4e07aa$export$bfd64c937657f93a = `Nd8Kjq_rotating`;
$5be5b61d5a4e07aa$export$4a6dd88bada4e7d2 = `Nd8Kjq_shimmer`;

});

parcelRequire.register("3JJsj", function(module, exports) {

$parcel$export(module.exports, "lineNumberContainerStyle", function () { return $0374d8395638bb2b$export$5d6f61bfcedf3be5; });
$parcel$export(module.exports, "lineNumberStyle", function () { return $0374d8395638bb2b$export$cc7b563314bb7222; });
$parcel$export(module.exports, "customStyle", function () { return $0374d8395638bb2b$export$f87aef060aea76c7; });
const $0374d8395638bb2b$export$5d6f61bfcedf3be5 = ()=>{
    return {
        display: "flex",
        flexDirection: "column",
        textAlign: "right",
        paddingLeft: "0px",
        paddingRight: "0px"
    };
};
const $0374d8395638bb2b$export$cc7b563314bb7222 = (numberOfLines)=>{
    return {
        minWidth: `calc(${numberOfLines}ch + 20px)`,
        marginLeft: "0px",
        paddingRight: "20px",
        paddingLeft: "0px",
        display: "inline-flex",
        justifyContent: "flex-end",
        counterIncrement: "line",
        lineHeight: "1.5",
        flexShrink: 0,
        fontFamily: "'Roboto Mono', monospace",
        fontSize: "14px",
        position: "sticky",
        background: "#34353f",
        left: 0
    };
};
const $0374d8395638bb2b$export$f87aef060aea76c7 = (width)=>{
    return {
        width: `${width ?? 0}px`,
        background: "transparent",
        fontSize: "14px",
        margin: "0",
        padding: "0",
        borderRadius: "0",
        wordBreak: "break-all",
        overflow: "unset",
        fontFamily: "'Roboto Mono', monospace"
    };
};

});


parcelRequire.register("aTllQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f09b623f7d79c1ab$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");

var $8Lben = parcelRequire("8Lben");
function $f09b623f7d79c1ab$var$OverlayScrollbar(props) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8Lben.OverlayScrollbarsComponent), {
        options: {
            scrollbars: {
                autoHide: "leave",
                autoHideDelay: 0
            }
        },
        ...props
    });
}
var $f09b623f7d79c1ab$export$2e2bcd8739ae039 = $f09b623f7d79c1ab$var$OverlayScrollbar;

});
parcelRequire.register("8Lben", function(module, exports) {

$parcel$export(module.exports, "OverlayScrollbarsComponent", function () { return $660b6cba2dc7c868$export$5c3912403b9b36ce; });

var $jC8Vy = parcelRequire("jC8Vy");

var $6xThT = parcelRequire("6xThT");
const $660b6cba2dc7c868$var$O = ()=>{
    if (typeof window > "u") {
        const n = ()=>{};
        return [
            n,
            n
        ];
    }
    let l, c;
    const t = window, o = typeof t.requestIdleCallback == "function", a = t.requestAnimationFrame, i = t.cancelAnimationFrame, r = o ? t.requestIdleCallback : a, u = o ? t.cancelIdleCallback : i, s = ()=>{
        u(l), i(c);
    };
    return [
        (n, e)=>{
            s(), l = r(o ? ()=>{
                s(), c = a(n);
            } : n, typeof e == "object" ? e : {
                timeout: 2233
            });
        },
        s
    ];
}, $660b6cba2dc7c868$export$98c834f87b3a8a6f = (l)=>{
    const { options: c, events: t, defer: o } = l || {}, [a, i] = (0, $jC8Vy.useMemo)($660b6cba2dc7c868$var$O, []), r = (0, $jC8Vy.useRef)(null), u = (0, $jC8Vy.useRef)(o), s = (0, $jC8Vy.useRef)(c), n = (0, $jC8Vy.useRef)(t);
    return (0, $jC8Vy.useEffect)(()=>{
        u.current = o;
    }, [
        o
    ]), (0, $jC8Vy.useEffect)(()=>{
        const { current: e } = r;
        s.current = c, (0, $6xThT.OverlayScrollbars).valid(e) && e.options(c || {}, !0);
    }, [
        c
    ]), (0, $jC8Vy.useEffect)(()=>{
        const { current: e } = r;
        n.current = t, (0, $6xThT.OverlayScrollbars).valid(e) && e.on(t || {}, !0);
    }, [
        t
    ]), (0, $jC8Vy.useEffect)(()=>()=>{
            var e;
            i(), (e = r.current) == null || e.destroy();
        }, []), (0, $jC8Vy.useMemo)(()=>[
            (e)=>{
                const y = r.current;
                if ((0, $6xThT.OverlayScrollbars).valid(y)) return;
                const d = u.current, I = s.current || {}, m = n.current || {}, p = ()=>r.current = (0, $6xThT.OverlayScrollbars)(e, I, m);
                d ? a(p, d) : p();
            },
            ()=>r.current
        ], []);
}, $660b6cba2dc7c868$var$F = (l, c)=>{
    const { element: t = "div", options: o, events: a, defer: i, children: r, ...u } = l, s = t, n = (0, $jC8Vy.useRef)(null), e = (0, $jC8Vy.useRef)(null), [y, d] = $660b6cba2dc7c868$export$98c834f87b3a8a6f({
        options: o,
        events: a,
        defer: i
    });
    return (0, $jC8Vy.useEffect)(()=>{
        const { current: I } = n, { current: m } = e;
        return I && m && y({
            target: I,
            elements: {
                viewport: m,
                content: m
            }
        }), ()=>{
            var p;
            return (p = d()) == null ? void 0 : p.destroy();
        };
    }, [
        y,
        t
    ]), (0, $jC8Vy.useImperativeHandle)(c, ()=>({
            osInstance: d,
            getElement: ()=>n.current
        }), []), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement(s, {
        "data-overlayscrollbars-initialize": "",
        ref: n,
        ...u
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        ref: e
    }, r));
}, $660b6cba2dc7c868$export$5c3912403b9b36ce = (0, $jC8Vy.forwardRef)($660b6cba2dc7c868$var$F);

});
parcelRequire.register("6xThT", function(module, exports) {

$parcel$export(module.exports, "OverlayScrollbars", function () { return $5d4c081fc8529528$export$d08ab3fe303a3356; });
/*!
 * OverlayScrollbars
 * Version: 2.0.3
 *
 * Copyright (c) Rene Haas | KingSora.
 * https://github.com/KingSora
 *
 * Released under the MIT license.
 */ function $5d4c081fc8529528$var$each(t, n) {
    if ($5d4c081fc8529528$var$isArrayLike(t)) for(let o = 0; o < t.length; o++){
        if (false === n(t[o], o, t)) break;
    }
    else if (t) $5d4c081fc8529528$var$each(Object.keys(t), (o)=>n(t[o], o, t));
    return t;
}
function $5d4c081fc8529528$var$style(t, n) {
    const o = $5d4c081fc8529528$var$isString(n);
    const s = $5d4c081fc8529528$var$isArray(n) || o;
    if (s) {
        let s = o ? "" : {};
        if (t) {
            const e = window.getComputedStyle(t, null);
            s = o ? $5d4c081fc8529528$var$getCSSVal(t, e, n) : n.reduce((n, o)=>{
                n[o] = $5d4c081fc8529528$var$getCSSVal(t, e, o);
                return n;
            }, s);
        }
        return s;
    }
    t && $5d4c081fc8529528$var$each($5d4c081fc8529528$var$keys(n), (o)=>$5d4c081fc8529528$var$setCSSVal(t, o, n[o]));
}
const $5d4c081fc8529528$var$createCache = (t, n)=>{
    const { o: o, u: s, _: e } = t;
    let c = o;
    let r;
    const cacheUpdateContextual = (t, n)=>{
        const o = c;
        const i = t;
        const l = n || (s ? !s(o, i) : o !== i);
        if (l || e) {
            c = i;
            r = o;
        }
        return [
            c,
            l,
            r
        ];
    };
    const cacheUpdateIsolated = (t)=>cacheUpdateContextual(n(c, r), t);
    const getCurrentCache = (t)=>[
            c,
            !!t,
            r
        ];
    return [
        n ? cacheUpdateIsolated : cacheUpdateContextual,
        getCurrentCache
    ];
};
const $5d4c081fc8529528$var$isClient = ()=>"undefined" !== typeof window;
const $5d4c081fc8529528$var$t = $5d4c081fc8529528$var$isClient() && Node.ELEMENT_NODE;
const { toString: $5d4c081fc8529528$var$n, hasOwnProperty: $5d4c081fc8529528$var$o } = Object.prototype;
const $5d4c081fc8529528$var$isUndefined = (t)=>void 0 === t;
const $5d4c081fc8529528$var$isNull = (t)=>null === t;
const $5d4c081fc8529528$var$type = (t)=>$5d4c081fc8529528$var$isUndefined(t) || $5d4c081fc8529528$var$isNull(t) ? `${t}` : $5d4c081fc8529528$var$n.call(t).replace(/^\[object (.+)\]$/, "$1").toLowerCase();
const $5d4c081fc8529528$var$isNumber = (t)=>"number" === typeof t;
const $5d4c081fc8529528$var$isString = (t)=>"string" === typeof t;
const $5d4c081fc8529528$var$isBoolean = (t)=>"boolean" === typeof t;
const $5d4c081fc8529528$var$isFunction = (t)=>"function" === typeof t;
const $5d4c081fc8529528$var$isArray = (t)=>Array.isArray(t);
const $5d4c081fc8529528$var$isObject = (t)=>"object" === typeof t && !$5d4c081fc8529528$var$isArray(t) && !$5d4c081fc8529528$var$isNull(t);
const $5d4c081fc8529528$var$isArrayLike = (t)=>{
    const n = !!t && t.length;
    const o = $5d4c081fc8529528$var$isNumber(n) && n > -1 && n % 1 == 0;
    return $5d4c081fc8529528$var$isArray(t) || !$5d4c081fc8529528$var$isFunction(t) && o ? n > 0 && $5d4c081fc8529528$var$isObject(t) ? n - 1 in t : true : false;
};
const $5d4c081fc8529528$var$isPlainObject = (t)=>{
    if (!t || !$5d4c081fc8529528$var$isObject(t) || "object" !== $5d4c081fc8529528$var$type(t)) return false;
    let n;
    const s = "constructor";
    const e = t[s];
    const c = e && e.prototype;
    const r = $5d4c081fc8529528$var$o.call(t, s);
    const i = c && $5d4c081fc8529528$var$o.call(c, "isPrototypeOf");
    if (e && !r && !i) return false;
    for(n in t);
    return $5d4c081fc8529528$var$isUndefined(n) || $5d4c081fc8529528$var$o.call(t, n);
};
const $5d4c081fc8529528$var$isHTMLElement = (n)=>{
    const o = HTMLElement;
    return n ? o ? n instanceof o : n.nodeType === $5d4c081fc8529528$var$t : false;
};
const $5d4c081fc8529528$var$isElement = (n)=>{
    const o = Element;
    return n ? o ? n instanceof o : n.nodeType === $5d4c081fc8529528$var$t : false;
};
const $5d4c081fc8529528$var$indexOf = (t, n, o)=>t.indexOf(n, o);
const $5d4c081fc8529528$var$push = (t, n, o)=>{
    !o && !$5d4c081fc8529528$var$isString(n) && $5d4c081fc8529528$var$isArrayLike(n) ? Array.prototype.push.apply(t, n) : t.push(n);
    return t;
};
const $5d4c081fc8529528$var$from = (t)=>{
    const n = Array.from;
    const o = [];
    if (n && t) return n(t);
    if (t instanceof Set) t.forEach((t)=>{
        $5d4c081fc8529528$var$push(o, t);
    });
    else $5d4c081fc8529528$var$each(t, (t)=>{
        $5d4c081fc8529528$var$push(o, t);
    });
    return o;
};
const $5d4c081fc8529528$var$isEmptyArray = (t)=>!!t && 0 === t.length;
const $5d4c081fc8529528$var$runEachAndClear = (t, n, o)=>{
    const runFn = (t)=>t && t.apply(void 0, n || []);
    $5d4c081fc8529528$var$each(t, runFn);
    !o && (t.length = 0);
};
const $5d4c081fc8529528$var$hasOwnProperty = (t, n)=>Object.prototype.hasOwnProperty.call(t, n);
const $5d4c081fc8529528$var$keys = (t)=>t ? Object.keys(t) : [];
const $5d4c081fc8529528$var$assignDeep = (t, n, o, s, e, c, r)=>{
    const i = [
        n,
        o,
        s,
        e,
        c,
        r
    ];
    if (("object" !== typeof t || $5d4c081fc8529528$var$isNull(t)) && !$5d4c081fc8529528$var$isFunction(t)) t = {};
    $5d4c081fc8529528$var$each(i, (n)=>{
        $5d4c081fc8529528$var$each($5d4c081fc8529528$var$keys(n), (o)=>{
            const s = n[o];
            if (t === s) return true;
            const e = $5d4c081fc8529528$var$isArray(s);
            if (s && ($5d4c081fc8529528$var$isPlainObject(s) || e)) {
                const n = t[o];
                let c = n;
                if (e && !$5d4c081fc8529528$var$isArray(n)) c = [];
                else if (!e && !$5d4c081fc8529528$var$isPlainObject(n)) c = {};
                t[o] = $5d4c081fc8529528$var$assignDeep(c, s);
            } else t[o] = s;
        });
    });
    return t;
};
const $5d4c081fc8529528$var$isEmptyObject = (t)=>{
    for(const n in t)return false;
    return true;
};
const $5d4c081fc8529528$var$getSetProp = (t, n, o, s)=>{
    if ($5d4c081fc8529528$var$isUndefined(s)) return o ? o[t] : n;
    o && ($5d4c081fc8529528$var$isString(s) || $5d4c081fc8529528$var$isNumber(s)) && (o[t] = s);
};
const $5d4c081fc8529528$var$attr = (t, n, o)=>{
    if ($5d4c081fc8529528$var$isUndefined(o)) return t ? t.getAttribute(n) : null;
    t && t.setAttribute(n, o);
};
const $5d4c081fc8529528$var$attrClass = (t, n, o, s)=>{
    if (o) {
        const e = $5d4c081fc8529528$var$attr(t, n) || "";
        const c = new Set(e.split(" "));
        c[s ? "add" : "delete"](o);
        $5d4c081fc8529528$var$attr(t, n, $5d4c081fc8529528$var$from(c).join(" ").trim());
    }
};
const $5d4c081fc8529528$var$hasAttrClass = (t, n, o)=>{
    const s = $5d4c081fc8529528$var$attr(t, n) || "";
    const e = new Set(s.split(" "));
    return e.has(o);
};
const $5d4c081fc8529528$var$removeAttr = (t, n)=>{
    t && t.removeAttribute(n);
};
const $5d4c081fc8529528$var$scrollLeft = (t, n)=>$5d4c081fc8529528$var$getSetProp("scrollLeft", 0, t, n);
const $5d4c081fc8529528$var$scrollTop = (t, n)=>$5d4c081fc8529528$var$getSetProp("scrollTop", 0, t, n);
const $5d4c081fc8529528$var$s = $5d4c081fc8529528$var$isClient() && Element.prototype;
const $5d4c081fc8529528$var$find = (t, n)=>{
    const o = [];
    const s = n ? $5d4c081fc8529528$var$isElement(n) ? n : null : document;
    return s ? $5d4c081fc8529528$var$push(o, s.querySelectorAll(t)) : o;
};
const $5d4c081fc8529528$var$findFirst = (t, n)=>{
    const o = n ? $5d4c081fc8529528$var$isElement(n) ? n : null : document;
    return o ? o.querySelector(t) : null;
};
const $5d4c081fc8529528$var$is = (t, n)=>{
    if ($5d4c081fc8529528$var$isElement(t)) {
        const o = $5d4c081fc8529528$var$s.matches || $5d4c081fc8529528$var$s.msMatchesSelector;
        return o.call(t, n);
    }
    return false;
};
const $5d4c081fc8529528$var$contents = (t)=>t ? $5d4c081fc8529528$var$from(t.childNodes) : [];
const $5d4c081fc8529528$var$parent = (t)=>t ? t.parentElement : null;
const $5d4c081fc8529528$var$closest = (t, n)=>{
    if ($5d4c081fc8529528$var$isElement(t)) {
        const o = $5d4c081fc8529528$var$s.closest;
        if (o) return o.call(t, n);
        do {
            if ($5d4c081fc8529528$var$is(t, n)) return t;
            t = $5d4c081fc8529528$var$parent(t);
        }while (t);
    }
    return null;
};
const $5d4c081fc8529528$var$liesBetween = (t, n, o)=>{
    const s = t && $5d4c081fc8529528$var$closest(t, n);
    const e = t && $5d4c081fc8529528$var$findFirst(o, s);
    const c = $5d4c081fc8529528$var$closest(e, n) === s;
    return s && e ? s === t || e === t || c && $5d4c081fc8529528$var$closest($5d4c081fc8529528$var$closest(t, o), n) !== s : false;
};
const $5d4c081fc8529528$var$before = (t, n, o)=>{
    if (o && t) {
        let s = n;
        let e;
        if ($5d4c081fc8529528$var$isArrayLike(o)) {
            e = document.createDocumentFragment();
            $5d4c081fc8529528$var$each(o, (t)=>{
                if (t === s) s = t.previousSibling;
                e.appendChild(t);
            });
        } else e = o;
        if (n) {
            if (!s) s = t.firstChild;
            else if (s !== n) s = s.nextSibling;
        }
        t.insertBefore(e, s || null);
    }
};
const $5d4c081fc8529528$var$appendChildren = (t, n)=>{
    $5d4c081fc8529528$var$before(t, null, n);
};
const $5d4c081fc8529528$var$insertBefore = (t, n)=>{
    $5d4c081fc8529528$var$before($5d4c081fc8529528$var$parent(t), t, n);
};
const $5d4c081fc8529528$var$insertAfter = (t, n)=>{
    $5d4c081fc8529528$var$before($5d4c081fc8529528$var$parent(t), t && t.nextSibling, n);
};
const $5d4c081fc8529528$var$removeElements = (t)=>{
    if ($5d4c081fc8529528$var$isArrayLike(t)) $5d4c081fc8529528$var$each($5d4c081fc8529528$var$from(t), (t)=>$5d4c081fc8529528$var$removeElements(t));
    else if (t) {
        const n = $5d4c081fc8529528$var$parent(t);
        if (n) n.removeChild(t);
    }
};
const $5d4c081fc8529528$var$createDiv = (t)=>{
    const n = document.createElement("div");
    if (t) $5d4c081fc8529528$var$attr(n, "class", t);
    return n;
};
const $5d4c081fc8529528$var$createDOM = (t)=>{
    const n = $5d4c081fc8529528$var$createDiv();
    n.innerHTML = t.trim();
    return $5d4c081fc8529528$var$each($5d4c081fc8529528$var$contents(n), (t)=>$5d4c081fc8529528$var$removeElements(t));
};
const $5d4c081fc8529528$var$firstLetterToUpper = (t)=>t.charAt(0).toUpperCase() + t.slice(1);
const $5d4c081fc8529528$var$getDummyStyle = ()=>$5d4c081fc8529528$var$createDiv().style;
const $5d4c081fc8529528$var$e = [
    "-webkit-",
    "-moz-",
    "-o-",
    "-ms-"
];
const $5d4c081fc8529528$var$c = [
    "WebKit",
    "Moz",
    "O",
    "MS",
    "webkit",
    "moz",
    "o",
    "ms"
];
const $5d4c081fc8529528$var$r = {};
const $5d4c081fc8529528$var$i = {};
const $5d4c081fc8529528$var$cssProperty = (t)=>{
    let n = $5d4c081fc8529528$var$i[t];
    if ($5d4c081fc8529528$var$hasOwnProperty($5d4c081fc8529528$var$i, t)) return n;
    const o = $5d4c081fc8529528$var$firstLetterToUpper(t);
    const s = $5d4c081fc8529528$var$getDummyStyle();
    $5d4c081fc8529528$var$each($5d4c081fc8529528$var$e, (e)=>{
        const c = e.replace(/-/g, "");
        const r = [
            t,
            e + t,
            c + o,
            $5d4c081fc8529528$var$firstLetterToUpper(c) + o
        ];
        return !(n = r.find((t)=>void 0 !== s[t]));
    });
    return $5d4c081fc8529528$var$i[t] = n || "";
};
const $5d4c081fc8529528$var$jsAPI = (t)=>{
    if ($5d4c081fc8529528$var$isClient()) {
        let n = $5d4c081fc8529528$var$r[t] || window[t];
        if ($5d4c081fc8529528$var$hasOwnProperty($5d4c081fc8529528$var$r, t)) return n;
        $5d4c081fc8529528$var$each($5d4c081fc8529528$var$c, (o)=>{
            n = n || window[o + $5d4c081fc8529528$var$firstLetterToUpper(t)];
            return !n;
        });
        $5d4c081fc8529528$var$r[t] = n;
        return n;
    }
};
const $5d4c081fc8529528$var$l = $5d4c081fc8529528$var$jsAPI("MutationObserver");
const $5d4c081fc8529528$var$a = $5d4c081fc8529528$var$jsAPI("IntersectionObserver");
const $5d4c081fc8529528$var$u = $5d4c081fc8529528$var$jsAPI("ResizeObserver");
const $5d4c081fc8529528$var$d = $5d4c081fc8529528$var$jsAPI("cancelAnimationFrame");
const $5d4c081fc8529528$var$f = $5d4c081fc8529528$var$jsAPI("requestAnimationFrame");
const $5d4c081fc8529528$var$_ = $5d4c081fc8529528$var$isClient() && window.setTimeout;
const $5d4c081fc8529528$var$h = $5d4c081fc8529528$var$isClient() && window.clearTimeout;
const $5d4c081fc8529528$var$equal = (t, n, o, s)=>{
    if (t && n) {
        let e = true;
        $5d4c081fc8529528$var$each(o, (o)=>{
            const c = s ? s(t[o]) : t[o];
            const r = s ? s(n[o]) : n[o];
            if (c !== r) e = false;
        });
        return e;
    }
    return false;
};
const $5d4c081fc8529528$var$equalWH = (t, n)=>$5d4c081fc8529528$var$equal(t, n, [
        "w",
        "h"
    ]);
const $5d4c081fc8529528$var$equalXY = (t, n)=>$5d4c081fc8529528$var$equal(t, n, [
        "x",
        "y"
    ]);
const $5d4c081fc8529528$var$equalTRBL = (t, n)=>$5d4c081fc8529528$var$equal(t, n, [
        "t",
        "r",
        "b",
        "l"
    ]);
const $5d4c081fc8529528$var$equalBCRWH = (t, n, o)=>$5d4c081fc8529528$var$equal(t, n, [
        "width",
        "height"
    ], o && ((t)=>Math.round(t)));
const $5d4c081fc8529528$var$noop = ()=>{};
const $5d4c081fc8529528$var$selfClearTimeout = (t)=>{
    let n;
    const o = t ? $5d4c081fc8529528$var$_ : $5d4c081fc8529528$var$f;
    const s = t ? $5d4c081fc8529528$var$h : $5d4c081fc8529528$var$d;
    return [
        (e)=>{
            s(n);
            n = o(e, $5d4c081fc8529528$var$isFunction(t) ? t() : t);
        },
        ()=>s(n)
    ];
};
const $5d4c081fc8529528$var$debounce = (t, n)=>{
    let o;
    let s;
    let e;
    let c = $5d4c081fc8529528$var$noop;
    const { g: r, v: i, p: l } = n || {};
    const a = function invokeFunctionToDebounce(n) {
        c();
        $5d4c081fc8529528$var$h(o);
        o = s = void 0;
        c = $5d4c081fc8529528$var$noop;
        t.apply(this, n);
    };
    const mergeParms = (t)=>l && s ? l(s, t) : t;
    const flush = ()=>{
        if (c !== $5d4c081fc8529528$var$noop) a(mergeParms(e) || e);
    };
    const u = function debouncedFn() {
        const t = $5d4c081fc8529528$var$from(arguments);
        const n = $5d4c081fc8529528$var$isFunction(r) ? r() : r;
        const l = $5d4c081fc8529528$var$isNumber(n) && n >= 0;
        if (l) {
            const r = $5d4c081fc8529528$var$isFunction(i) ? i() : i;
            const l = $5d4c081fc8529528$var$isNumber(r) && r >= 0;
            const u = n > 0 ? $5d4c081fc8529528$var$_ : $5d4c081fc8529528$var$f;
            const g = n > 0 ? $5d4c081fc8529528$var$h : $5d4c081fc8529528$var$d;
            const v = mergeParms(t);
            const w = v || t;
            const p = a.bind(0, w);
            c();
            const b = u(p, n);
            c = ()=>g(b);
            if (l && !o) o = $5d4c081fc8529528$var$_(flush, r);
            s = e = w;
        } else a(t);
    };
    u.m = flush;
    return u;
};
const { max: $5d4c081fc8529528$var$g } = Math;
const $5d4c081fc8529528$var$animationCurrentTime = ()=>performance.now();
const $5d4c081fc8529528$var$animateNumber = (t, n, o, s, e)=>{
    let c = 0;
    const r = $5d4c081fc8529528$var$animationCurrentTime();
    const i = Math.max(0, o);
    const frame = (o)=>{
        const l = $5d4c081fc8529528$var$animationCurrentTime();
        const a = l - r;
        const u = a >= i;
        const d = o ? 1 : 1 - ($5d4c081fc8529528$var$g(0, r + i - l) / i || 0);
        const _ = (n - t) * ($5d4c081fc8529528$var$isFunction(e) ? e(d, d * i, 0, 1, i) : d) + t;
        const h = u || 1 === d;
        s && s(_, d, h);
        c = h ? 0 : $5d4c081fc8529528$var$f(()=>frame());
    };
    frame();
    return (t)=>{
        $5d4c081fc8529528$var$d(c);
        t && frame(t);
    };
};
const $5d4c081fc8529528$var$v = /[^\x20\t\r\n\f]+/g;
const $5d4c081fc8529528$var$classListAction = (t, n, o)=>{
    const s = t && t.classList;
    let e;
    let c = 0;
    let r = false;
    if (s && n && $5d4c081fc8529528$var$isString(n)) {
        const t = n.match($5d4c081fc8529528$var$v) || [];
        r = t.length > 0;
        while(e = t[c++])r = !!o(s, e) && r;
    }
    return r;
};
const $5d4c081fc8529528$var$hasClass = (t, n)=>$5d4c081fc8529528$var$classListAction(t, n, (t, n)=>t.contains(n));
const $5d4c081fc8529528$var$removeClass = (t, n)=>{
    $5d4c081fc8529528$var$classListAction(t, n, (t, n)=>t.remove(n));
};
const $5d4c081fc8529528$var$addClass = (t, n)=>{
    $5d4c081fc8529528$var$classListAction(t, n, (t, n)=>t.add(n));
    return $5d4c081fc8529528$var$removeClass.bind(0, t, n);
};
const $5d4c081fc8529528$var$w = {
    opacity: 1,
    zindex: 1
};
const $5d4c081fc8529528$var$parseToZeroOrNumber = (t, n)=>{
    const o = n ? parseFloat(t) : parseInt(t, 10);
    return o === o ? o : 0;
};
const $5d4c081fc8529528$var$adaptCSSVal = (t, n)=>!$5d4c081fc8529528$var$w[t.toLowerCase()] && $5d4c081fc8529528$var$isNumber(n) ? `${n}px` : n;
const $5d4c081fc8529528$var$getCSSVal = (t, n, o)=>null != n ? n[o] || n.getPropertyValue(o) : t.style[o];
const $5d4c081fc8529528$var$setCSSVal = (t, n, o)=>{
    try {
        const { style: s } = t;
        if (!$5d4c081fc8529528$var$isUndefined(s[n])) s[n] = $5d4c081fc8529528$var$adaptCSSVal(n, o);
        else s.setProperty(n, o);
    } catch (s) {}
};
const $5d4c081fc8529528$var$directionIsRTL = (t)=>"rtl" === $5d4c081fc8529528$var$style(t, "direction");
const $5d4c081fc8529528$var$topRightBottomLeft = (t, n, o)=>{
    const s = n ? `${n}-` : "";
    const e = o ? `-${o}` : "";
    const c = `${s}top${e}`;
    const r = `${s}right${e}`;
    const i = `${s}bottom${e}`;
    const l = `${s}left${e}`;
    const a = $5d4c081fc8529528$var$style(t, [
        c,
        r,
        i,
        l
    ]);
    return {
        t: $5d4c081fc8529528$var$parseToZeroOrNumber(a[c], true),
        r: $5d4c081fc8529528$var$parseToZeroOrNumber(a[r], true),
        b: $5d4c081fc8529528$var$parseToZeroOrNumber(a[i], true),
        l: $5d4c081fc8529528$var$parseToZeroOrNumber(a[l], true)
    };
};
const { round: $5d4c081fc8529528$var$p } = Math;
const $5d4c081fc8529528$var$b = {
    w: 0,
    h: 0
};
const $5d4c081fc8529528$var$windowSize = ()=>({
        w: window.innerWidth,
        h: window.innerHeight
    });
const $5d4c081fc8529528$var$offsetSize = (t)=>t ? {
        w: t.offsetWidth,
        h: t.offsetHeight
    } : $5d4c081fc8529528$var$b;
const $5d4c081fc8529528$var$clientSize = (t)=>t ? {
        w: t.clientWidth,
        h: t.clientHeight
    } : $5d4c081fc8529528$var$b;
const $5d4c081fc8529528$var$scrollSize = (t)=>t ? {
        w: t.scrollWidth,
        h: t.scrollHeight
    } : $5d4c081fc8529528$var$b;
const $5d4c081fc8529528$var$fractionalSize = (t)=>{
    const n = parseFloat($5d4c081fc8529528$var$style(t, "height")) || 0;
    const o = parseFloat($5d4c081fc8529528$var$style(t, "width")) || 0;
    return {
        w: o - $5d4c081fc8529528$var$p(o),
        h: n - $5d4c081fc8529528$var$p(n)
    };
};
const $5d4c081fc8529528$var$getBoundingClientRect = (t)=>t.getBoundingClientRect();
let $5d4c081fc8529528$var$m;
const $5d4c081fc8529528$var$supportPassiveEvents = ()=>{
    if ($5d4c081fc8529528$var$isUndefined($5d4c081fc8529528$var$m)) {
        $5d4c081fc8529528$var$m = false;
        try {
            window.addEventListener("test", null, Object.defineProperty({}, "passive", {
                get () {
                    $5d4c081fc8529528$var$m = true;
                }
            }));
        } catch (t) {}
    }
    return $5d4c081fc8529528$var$m;
};
const $5d4c081fc8529528$var$splitEventNames = (t)=>t.split(" ");
const $5d4c081fc8529528$var$off = (t, n, o, s)=>{
    $5d4c081fc8529528$var$each($5d4c081fc8529528$var$splitEventNames(n), (n)=>{
        t.removeEventListener(n, o, s);
    });
};
const $5d4c081fc8529528$var$on = (t, n, o, s)=>{
    var e;
    const c = $5d4c081fc8529528$var$supportPassiveEvents();
    const r = null != (e = c && s && s.S) ? e : c;
    const i = s && s.$ || false;
    const l = s && s.C || false;
    const a = [];
    const u = c ? {
        passive: r,
        capture: i
    } : i;
    $5d4c081fc8529528$var$each($5d4c081fc8529528$var$splitEventNames(n), (n)=>{
        const s = l ? (e)=>{
            t.removeEventListener(n, s, i);
            o && o(e);
        } : o;
        $5d4c081fc8529528$var$push(a, $5d4c081fc8529528$var$off.bind(null, t, n, s, i));
        t.addEventListener(n, s, u);
    });
    return $5d4c081fc8529528$var$runEachAndClear.bind(0, a);
};
const $5d4c081fc8529528$var$stopPropagation = (t)=>t.stopPropagation();
const $5d4c081fc8529528$var$preventDefault = (t)=>t.preventDefault();
const $5d4c081fc8529528$var$y = {
    x: 0,
    y: 0
};
const $5d4c081fc8529528$var$absoluteCoordinates = (t)=>{
    const n = t ? $5d4c081fc8529528$var$getBoundingClientRect(t) : 0;
    return n ? {
        x: n.left + window.pageYOffset,
        y: n.top + window.pageXOffset
    } : $5d4c081fc8529528$var$y;
};
const $5d4c081fc8529528$var$manageListener = (t, n)=>{
    $5d4c081fc8529528$var$each($5d4c081fc8529528$var$isArray(n) ? n : [
        n
    ], t);
};
const $5d4c081fc8529528$var$createEventListenerHub = (t)=>{
    const n = new Map;
    const removeEvent = (t, o)=>{
        if (t) {
            const s = n.get(t);
            $5d4c081fc8529528$var$manageListener((t)=>{
                if (s) s[t ? "delete" : "clear"](t);
            }, o);
        } else {
            n.forEach((t)=>{
                t.clear();
            });
            n.clear();
        }
    };
    const addEvent = (t, o)=>{
        if ($5d4c081fc8529528$var$isString(t)) {
            const s = n.get(t) || new Set;
            n.set(t, s);
            $5d4c081fc8529528$var$manageListener((t)=>{
                $5d4c081fc8529528$var$isFunction(t) && s.add(t);
            }, o);
            return removeEvent.bind(0, t, o);
        }
        if ($5d4c081fc8529528$var$isBoolean(o) && o) removeEvent();
        const s = $5d4c081fc8529528$var$keys(t);
        const e = [];
        $5d4c081fc8529528$var$each(s, (n)=>{
            const o = t[n];
            o && $5d4c081fc8529528$var$push(e, addEvent(n, o));
        });
        return $5d4c081fc8529528$var$runEachAndClear.bind(0, e);
    };
    const triggerEvent = (t, o)=>{
        const s = n.get(t);
        $5d4c081fc8529528$var$each($5d4c081fc8529528$var$from(s), (t)=>{
            if (o && !$5d4c081fc8529528$var$isEmptyArray(o)) t.apply(0, o);
            else t();
        });
    };
    addEvent(t || {});
    return [
        addEvent,
        removeEvent,
        triggerEvent
    ];
};
const $5d4c081fc8529528$var$opsStringify = (t)=>JSON.stringify(t, (t, n)=>{
        if ($5d4c081fc8529528$var$isFunction(n)) throw new Error;
        return n;
    });
const $5d4c081fc8529528$var$S = {
    paddingAbsolute: false,
    showNativeOverlaidScrollbars: false,
    update: {
        elementEvents: [
            [
                "img",
                "load"
            ]
        ],
        debounce: [
            0,
            33
        ],
        attributes: null,
        ignoreMutation: null
    },
    overflow: {
        x: "scroll",
        y: "scroll"
    },
    scrollbars: {
        theme: "os-theme-dark",
        visibility: "auto",
        autoHide: "never",
        autoHideDelay: 1300,
        dragScroll: true,
        clickScroll: false,
        pointers: [
            "mouse",
            "touch",
            "pen"
        ]
    }
};
const $5d4c081fc8529528$var$getOptionsDiff = (t, n)=>{
    const o = {};
    const s = $5d4c081fc8529528$var$keys(n).concat($5d4c081fc8529528$var$keys(t));
    $5d4c081fc8529528$var$each(s, (s)=>{
        const e = t[s];
        const c = n[s];
        if ($5d4c081fc8529528$var$isObject(e) && $5d4c081fc8529528$var$isObject(c)) {
            $5d4c081fc8529528$var$assignDeep(o[s] = {}, $5d4c081fc8529528$var$getOptionsDiff(e, c));
            if ($5d4c081fc8529528$var$isEmptyObject(o[s])) delete o[s];
        } else if ($5d4c081fc8529528$var$hasOwnProperty(n, s) && c !== e) {
            let t = true;
            if ($5d4c081fc8529528$var$isArray(e) || $5d4c081fc8529528$var$isArray(c)) try {
                if ($5d4c081fc8529528$var$opsStringify(e) === $5d4c081fc8529528$var$opsStringify(c)) t = false;
            } catch (r) {}
            if (t) o[s] = c;
        }
    });
    return o;
};
const $5d4c081fc8529528$var$x = "os-environment";
const $5d4c081fc8529528$var$$ = `${$5d4c081fc8529528$var$x}-flexbox-glue`;
const $5d4c081fc8529528$var$C = `${$5d4c081fc8529528$var$$}-max`;
const $5d4c081fc8529528$var$O = "data-overlayscrollbars";
const $5d4c081fc8529528$var$z = "data-overlayscrollbars-initialize";
const $5d4c081fc8529528$var$T = `${$5d4c081fc8529528$var$O}-overflow-x`;
const $5d4c081fc8529528$var$E = `${$5d4c081fc8529528$var$O}-overflow-y`;
const $5d4c081fc8529528$var$I = "overflowVisible";
const $5d4c081fc8529528$var$A = "scrollbarHidden";
const $5d4c081fc8529528$var$L = "updating";
const $5d4c081fc8529528$var$H = "os-padding";
const $5d4c081fc8529528$var$M = "os-viewport";
const $5d4c081fc8529528$var$P = `${$5d4c081fc8529528$var$M}-arrange`;
const $5d4c081fc8529528$var$D = "os-content";
const $5d4c081fc8529528$var$R = `${$5d4c081fc8529528$var$M}-scrollbar-hidden`;
const $5d4c081fc8529528$var$k = `os-overflow-visible`;
const $5d4c081fc8529528$var$B = "os-size-observer";
const $5d4c081fc8529528$var$V = `${$5d4c081fc8529528$var$B}-appear`;
const $5d4c081fc8529528$var$Y = `${$5d4c081fc8529528$var$B}-listener`;
const $5d4c081fc8529528$var$j = `${$5d4c081fc8529528$var$Y}-scroll`;
const $5d4c081fc8529528$var$N = `${$5d4c081fc8529528$var$Y}-item`;
const $5d4c081fc8529528$var$q = `${$5d4c081fc8529528$var$N}-final`;
const $5d4c081fc8529528$var$F = "os-trinsic-observer";
const $5d4c081fc8529528$var$G = "os-theme-none";
const $5d4c081fc8529528$var$X = "os-scrollbar";
const $5d4c081fc8529528$var$U = `${$5d4c081fc8529528$var$X}-rtl`;
const $5d4c081fc8529528$var$W = `${$5d4c081fc8529528$var$X}-horizontal`;
const $5d4c081fc8529528$var$Z = `${$5d4c081fc8529528$var$X}-vertical`;
const $5d4c081fc8529528$var$J = `${$5d4c081fc8529528$var$X}-track`;
const $5d4c081fc8529528$var$K = `${$5d4c081fc8529528$var$X}-handle`;
const $5d4c081fc8529528$var$Q = `${$5d4c081fc8529528$var$X}-visible`;
const $5d4c081fc8529528$var$tt = `${$5d4c081fc8529528$var$X}-cornerless`;
const $5d4c081fc8529528$var$nt = `${$5d4c081fc8529528$var$X}-transitionless`;
const $5d4c081fc8529528$var$ot = `${$5d4c081fc8529528$var$X}-interaction`;
const $5d4c081fc8529528$var$st = `${$5d4c081fc8529528$var$X}-unusable`;
const $5d4c081fc8529528$var$et = `${$5d4c081fc8529528$var$X}-auto-hidden`;
const $5d4c081fc8529528$var$ct = `${$5d4c081fc8529528$var$X}-wheel`;
const $5d4c081fc8529528$var$rt = `${$5d4c081fc8529528$var$J}-interactive`;
const $5d4c081fc8529528$var$it = `${$5d4c081fc8529528$var$K}-interactive`;
const $5d4c081fc8529528$var$lt = {};
const $5d4c081fc8529528$var$getPlugins = ()=>$5d4c081fc8529528$var$lt;
const $5d4c081fc8529528$var$addPlugin = (t)=>{
    const n = [];
    $5d4c081fc8529528$var$each($5d4c081fc8529528$var$isArray(t) ? t : [
        t
    ], (t)=>{
        const o = $5d4c081fc8529528$var$keys(t);
        $5d4c081fc8529528$var$each(o, (o)=>{
            $5d4c081fc8529528$var$push(n, $5d4c081fc8529528$var$lt[o] = t[o]);
        });
    });
    return n;
};
const $5d4c081fc8529528$var$at = {
    boolean: "__TPL_boolean_TYPE__",
    number: "__TPL_number_TYPE__",
    string: "__TPL_string_TYPE__",
    array: "__TPL_array_TYPE__",
    object: "__TPL_object_TYPE__",
    function: "__TPL_function_TYPE__",
    null: "__TPL_null_TYPE__"
};
const $5d4c081fc8529528$var$ut = $5d4c081fc8529528$var$at.number;
const $5d4c081fc8529528$var$dt = $5d4c081fc8529528$var$at.boolean;
const $5d4c081fc8529528$var$ft = [
    $5d4c081fc8529528$var$at.array,
    $5d4c081fc8529528$var$at.null
];
const $5d4c081fc8529528$var$_t = "hidden scroll visible visible-hidden";
const $5d4c081fc8529528$var$ht = "visible hidden auto";
const $5d4c081fc8529528$var$gt = "never scroll leavemove";
$5d4c081fc8529528$var$at.number, $5d4c081fc8529528$var$at.array, $5d4c081fc8529528$var$at.null, $5d4c081fc8529528$var$at.function, $5d4c081fc8529528$var$at.null, $5d4c081fc8529528$var$at.string, $5d4c081fc8529528$var$at.null, $5d4c081fc8529528$var$at.array, $5d4c081fc8529528$var$at.null;
const $5d4c081fc8529528$var$vt = "__osOptionsValidationPlugin";
const $5d4c081fc8529528$var$wt = 3333333;
const $5d4c081fc8529528$var$pt = "scroll";
const $5d4c081fc8529528$var$bt = "__osSizeObserverPlugin";
const $5d4c081fc8529528$export$c327021fb99a6481 = /* @__PURE__ */ (()=>({
        [$5d4c081fc8529528$var$bt]: {
            O: (t, n, o)=>{
                const s = $5d4c081fc8529528$var$createDOM(`<div class="${$5d4c081fc8529528$var$N}" dir="ltr"><div class="${$5d4c081fc8529528$var$N}"><div class="${$5d4c081fc8529528$var$q}"></div></div><div class="${$5d4c081fc8529528$var$N}"><div class="${$5d4c081fc8529528$var$q}" style="width: 200%; height: 200%"></div></div></div>`);
                $5d4c081fc8529528$var$appendChildren(t, s);
                $5d4c081fc8529528$var$addClass(t, $5d4c081fc8529528$var$j);
                const e = s[0];
                const c = e.lastChild;
                const r = e.firstChild;
                const i = null == r ? void 0 : r.firstChild;
                let l = $5d4c081fc8529528$var$offsetSize(e);
                let a = l;
                let u = false;
                let _;
                const reset = ()=>{
                    $5d4c081fc8529528$var$scrollLeft(r, $5d4c081fc8529528$var$wt);
                    $5d4c081fc8529528$var$scrollTop(r, $5d4c081fc8529528$var$wt);
                    $5d4c081fc8529528$var$scrollLeft(c, $5d4c081fc8529528$var$wt);
                    $5d4c081fc8529528$var$scrollTop(c, $5d4c081fc8529528$var$wt);
                };
                const onResized = (t)=>{
                    _ = 0;
                    if (u) {
                        l = a;
                        n(true === t);
                    }
                };
                const onScroll = (t)=>{
                    a = $5d4c081fc8529528$var$offsetSize(e);
                    u = !t || !$5d4c081fc8529528$var$equalWH(a, l);
                    if (t) {
                        $5d4c081fc8529528$var$stopPropagation(t);
                        if (u && !_) {
                            $5d4c081fc8529528$var$d(_);
                            _ = $5d4c081fc8529528$var$f(onResized);
                        }
                    } else onResized(false === t);
                    reset();
                };
                const h = $5d4c081fc8529528$var$push([], [
                    $5d4c081fc8529528$var$on(r, $5d4c081fc8529528$var$pt, onScroll),
                    $5d4c081fc8529528$var$on(c, $5d4c081fc8529528$var$pt, onScroll)
                ]);
                $5d4c081fc8529528$var$style(i, {
                    width: $5d4c081fc8529528$var$wt,
                    height: $5d4c081fc8529528$var$wt
                });
                $5d4c081fc8529528$var$f(reset);
                return [
                    o ? onScroll.bind(0, false) : reset,
                    h
                ];
            }
        }
    }))();
let $5d4c081fc8529528$var$yt = 0;
const { round: $5d4c081fc8529528$var$St, abs: $5d4c081fc8529528$var$xt } = Math;
const $5d4c081fc8529528$var$getWindowDPR = ()=>{
    const t = window.screen.deviceXDPI || 0;
    const n = window.screen.logicalXDPI || 1;
    return window.devicePixelRatio || t / n;
};
const $5d4c081fc8529528$var$diffBiggerThanOne = (t, n)=>{
    const o = $5d4c081fc8529528$var$xt(t);
    const s = $5d4c081fc8529528$var$xt(n);
    return !(o === s || o + 1 === s || o - 1 === s);
};
const $5d4c081fc8529528$var$$t = "__osScrollbarsHidingPlugin";
const $5d4c081fc8529528$export$8c9a9f9ae72a1689 = /* @__PURE__ */ (()=>({
        [$5d4c081fc8529528$var$$t]: {
            T: (t)=>{
                const { I: n, A: o, L: s } = t;
                const e = !s && !n && (o.x || o.y);
                const c = e ? document.createElement("style") : false;
                if (c) {
                    $5d4c081fc8529528$var$attr(c, "id", `${$5d4c081fc8529528$var$P}-${$5d4c081fc8529528$var$yt}`);
                    $5d4c081fc8529528$var$yt++;
                }
                return c;
            },
            H: (t, n, o, s, e, c, r)=>{
                const arrangeViewport = (n, c, r, i)=>{
                    if (t) {
                        const { M: t } = e();
                        const { P: l, D: a } = n;
                        const { x: u, y: d } = a;
                        const { x: f, y: _ } = l;
                        const h = i ? "paddingRight" : "paddingLeft";
                        const g = t[h];
                        const v = t.paddingTop;
                        const w = c.w + r.w;
                        const p = c.h + r.h;
                        const b = {
                            w: _ && d ? `${_ + w - g}px` : "",
                            h: f && u ? `${f + p - v}px` : ""
                        };
                        if (s) {
                            const { sheet: t } = s;
                            if (t) {
                                const { cssRules: n } = t;
                                if (n) {
                                    if (!n.length) t.insertRule(`#${$5d4c081fc8529528$var$attr(s, "id")} + .${$5d4c081fc8529528$var$P}::before {}`, 0);
                                    const o = n[0].style;
                                    o.width = b.w;
                                    o.height = b.h;
                                }
                            }
                        } else $5d4c081fc8529528$var$style(o, {
                            "--os-vaw": b.w,
                            "--os-vah": b.h
                        });
                    }
                    return t;
                };
                const undoViewportArrange = (s, i, l)=>{
                    if (t) {
                        const a = l || c(s);
                        const { M: u } = e();
                        const { D: d } = a;
                        const { x: f, y: _ } = d;
                        const h = {};
                        const assignProps = (t)=>$5d4c081fc8529528$var$each(t.split(" "), (t)=>{
                                h[t] = u[t];
                            });
                        if (f) assignProps("marginBottom paddingTop paddingBottom");
                        if (_) assignProps("marginLeft marginRight paddingLeft paddingRight");
                        const g = $5d4c081fc8529528$var$style(o, $5d4c081fc8529528$var$keys(h));
                        $5d4c081fc8529528$var$removeClass(o, $5d4c081fc8529528$var$P);
                        if (!n) h.height = "";
                        $5d4c081fc8529528$var$style(o, h);
                        return [
                            ()=>{
                                r(a, i, t, g);
                                $5d4c081fc8529528$var$style(o, g);
                                $5d4c081fc8529528$var$addClass(o, $5d4c081fc8529528$var$P);
                            },
                            a
                        ];
                    }
                    return [
                        $5d4c081fc8529528$var$noop
                    ];
                };
                return [
                    arrangeViewport,
                    undoViewportArrange
                ];
            },
            R: ()=>{
                let t = {
                    w: 0,
                    h: 0
                };
                let n = 0;
                return (o, s, e)=>{
                    const c = $5d4c081fc8529528$var$windowSize();
                    const r = {
                        w: c.w - t.w,
                        h: c.h - t.h
                    };
                    if (0 === r.w && 0 === r.h) return;
                    const i = {
                        w: $5d4c081fc8529528$var$xt(r.w),
                        h: $5d4c081fc8529528$var$xt(r.h)
                    };
                    const l = {
                        w: $5d4c081fc8529528$var$xt($5d4c081fc8529528$var$St(c.w / (t.w / 100))),
                        h: $5d4c081fc8529528$var$xt($5d4c081fc8529528$var$St(c.h / (t.h / 100)))
                    };
                    const a = $5d4c081fc8529528$var$getWindowDPR();
                    const u = i.w > 2 && i.h > 2;
                    const d = !$5d4c081fc8529528$var$diffBiggerThanOne(l.w, l.h);
                    const f = a !== n && a > 0;
                    const _ = u && d && f;
                    if (_) {
                        const [t, n] = s();
                        $5d4c081fc8529528$var$assignDeep(o.k, t);
                        if (n) e();
                    }
                    t = c;
                    n = a;
                };
            }
        }
    }))();
const $5d4c081fc8529528$var$Ot = "__osClickScrollPlugin";
const $5d4c081fc8529528$export$1a35b83948406b62 = /* @__PURE__ */ (()=>({
        [$5d4c081fc8529528$var$Ot]: {
            O: (t, n, o, s, e)=>{
                let c = 0;
                let r = $5d4c081fc8529528$var$noop;
                const animateClickScroll = (i)=>{
                    r = $5d4c081fc8529528$var$animateNumber(i, i + s * Math.sign(o), 133, (o, i, l)=>{
                        t(o);
                        const a = n();
                        const u = a + s;
                        const d = e >= a && e <= u;
                        if (l && !d) {
                            if (c) animateClickScroll(o);
                            else {
                                const t = setTimeout(()=>{
                                    animateClickScroll(o);
                                }, 222);
                                r = ()=>{
                                    clearTimeout(t);
                                };
                            }
                            c++;
                        }
                    });
                };
                animateClickScroll(0);
                return ()=>r();
            }
        }
    }))();
let $5d4c081fc8529528$var$Tt;
const $5d4c081fc8529528$var$getNativeScrollbarSize = (t, n, o, s)=>{
    $5d4c081fc8529528$var$appendChildren(t, n);
    const e = $5d4c081fc8529528$var$clientSize(n);
    const c = $5d4c081fc8529528$var$offsetSize(n);
    const r = $5d4c081fc8529528$var$fractionalSize(o);
    s && $5d4c081fc8529528$var$removeElements(n);
    return {
        x: c.h - e.h + r.h,
        y: c.w - e.w + r.w
    };
};
const $5d4c081fc8529528$var$getNativeScrollbarsHiding = (t)=>{
    let n = false;
    const o = $5d4c081fc8529528$var$addClass(t, $5d4c081fc8529528$var$R);
    try {
        n = "none" === $5d4c081fc8529528$var$style(t, $5d4c081fc8529528$var$cssProperty("scrollbar-width")) || "none" === window.getComputedStyle(t, "::-webkit-scrollbar").getPropertyValue("display");
    } catch (s) {}
    o();
    return n;
};
const $5d4c081fc8529528$var$getRtlScrollBehavior = (t, n)=>{
    const o = "hidden";
    $5d4c081fc8529528$var$style(t, {
        overflowX: o,
        overflowY: o,
        direction: "rtl"
    });
    $5d4c081fc8529528$var$scrollLeft(t, 0);
    const s = $5d4c081fc8529528$var$absoluteCoordinates(t);
    const e = $5d4c081fc8529528$var$absoluteCoordinates(n);
    $5d4c081fc8529528$var$scrollLeft(t, -999);
    const c = $5d4c081fc8529528$var$absoluteCoordinates(n);
    return {
        i: s.x === e.x,
        n: e.x !== c.x
    };
};
const $5d4c081fc8529528$var$getFlexboxGlue = (t, n)=>{
    const o = $5d4c081fc8529528$var$addClass(t, $5d4c081fc8529528$var$$);
    const s = $5d4c081fc8529528$var$getBoundingClientRect(t);
    const e = $5d4c081fc8529528$var$getBoundingClientRect(n);
    const c = $5d4c081fc8529528$var$equalBCRWH(e, s, true);
    const r = $5d4c081fc8529528$var$addClass(t, $5d4c081fc8529528$var$C);
    const i = $5d4c081fc8529528$var$getBoundingClientRect(t);
    const l = $5d4c081fc8529528$var$getBoundingClientRect(n);
    const a = $5d4c081fc8529528$var$equalBCRWH(l, i, true);
    o();
    r();
    return c && a;
};
const $5d4c081fc8529528$var$createEnvironment = ()=>{
    const { body: t } = document;
    const n = $5d4c081fc8529528$var$createDOM(`<div class="${$5d4c081fc8529528$var$x}"><div></div></div>`);
    const o = n[0];
    const s = o.firstChild;
    const [e, , c] = $5d4c081fc8529528$var$createEventListenerHub();
    const [r, i] = $5d4c081fc8529528$var$createCache({
        o: $5d4c081fc8529528$var$getNativeScrollbarSize(t, o, s),
        u: $5d4c081fc8529528$var$equalXY
    }, $5d4c081fc8529528$var$getNativeScrollbarSize.bind(0, t, o, s, true));
    const [l] = i();
    const a = $5d4c081fc8529528$var$getNativeScrollbarsHiding(o);
    const u = {
        x: 0 === l.x,
        y: 0 === l.y
    };
    const d = {
        elements: {
            host: null,
            padding: !a,
            viewport: (t)=>a && t === t.ownerDocument.body && t,
            content: false
        },
        scrollbars: {
            slot: true
        },
        cancel: {
            nativeScrollbarsOverlaid: false,
            body: null
        }
    };
    const f = $5d4c081fc8529528$var$assignDeep({}, $5d4c081fc8529528$var$S);
    const _ = $5d4c081fc8529528$var$assignDeep.bind(0, {}, f);
    const h = $5d4c081fc8529528$var$assignDeep.bind(0, {}, d);
    const g = {
        k: l,
        A: u,
        I: a,
        L: "-1" === $5d4c081fc8529528$var$style(o, "zIndex"),
        B: $5d4c081fc8529528$var$getRtlScrollBehavior(o, s),
        V: $5d4c081fc8529528$var$getFlexboxGlue(o, s),
        Y: e.bind(0, "z"),
        j: e.bind(0, "r"),
        N: h,
        q: (t)=>$5d4c081fc8529528$var$assignDeep(d, t) && h(),
        F: _,
        G: (t)=>$5d4c081fc8529528$var$assignDeep(f, t) && _(),
        X: $5d4c081fc8529528$var$assignDeep({}, d),
        U: $5d4c081fc8529528$var$assignDeep({}, f)
    };
    const v = window.addEventListener;
    const w = $5d4c081fc8529528$var$debounce((t)=>c(t ? "z" : "r"), {
        g: 33,
        v: 99
    });
    $5d4c081fc8529528$var$removeAttr(o, "style");
    $5d4c081fc8529528$var$removeElements(o);
    v("resize", w.bind(0, false));
    if (!a && (!u.x || !u.y)) {
        let t;
        v("resize", ()=>{
            const n = $5d4c081fc8529528$var$getPlugins()[$5d4c081fc8529528$var$$t];
            t = t || n && n.R();
            t && t(g, r, w.bind(0, true));
        });
    }
    return g;
};
const $5d4c081fc8529528$var$getEnvironment = ()=>{
    if (!$5d4c081fc8529528$var$Tt) $5d4c081fc8529528$var$Tt = $5d4c081fc8529528$var$createEnvironment();
    return $5d4c081fc8529528$var$Tt;
};
const $5d4c081fc8529528$var$resolveInitialization = (t, n)=>$5d4c081fc8529528$var$isFunction(n) ? n.apply(0, t) : n;
const $5d4c081fc8529528$var$staticInitializationElement = (t, n, o, s)=>{
    const e = $5d4c081fc8529528$var$isUndefined(s) ? o : s;
    const c = $5d4c081fc8529528$var$resolveInitialization(t, e);
    return c || n.apply(0, t);
};
const $5d4c081fc8529528$var$dynamicInitializationElement = (t, n, o, s)=>{
    const e = $5d4c081fc8529528$var$isUndefined(s) ? o : s;
    const c = $5d4c081fc8529528$var$resolveInitialization(t, e);
    return !!c && ($5d4c081fc8529528$var$isHTMLElement(c) ? c : n.apply(0, t));
};
const $5d4c081fc8529528$var$cancelInitialization = (t, n, o)=>{
    const { nativeScrollbarsOverlaid: s, body: e } = o || {};
    const { A: c, I: r } = $5d4c081fc8529528$var$getEnvironment();
    const { nativeScrollbarsOverlaid: i, body: l } = n;
    const a = null != s ? s : i;
    const u = $5d4c081fc8529528$var$isUndefined(e) ? l : e;
    const d = (c.x || c.y) && a;
    const f = t && ($5d4c081fc8529528$var$isNull(u) ? !r : u);
    return !!d || !!f;
};
const $5d4c081fc8529528$var$Et = new WeakMap;
const $5d4c081fc8529528$var$addInstance = (t, n)=>{
    $5d4c081fc8529528$var$Et.set(t, n);
};
const $5d4c081fc8529528$var$removeInstance = (t)=>{
    $5d4c081fc8529528$var$Et.delete(t);
};
const $5d4c081fc8529528$var$getInstance = (t)=>$5d4c081fc8529528$var$Et.get(t);
const $5d4c081fc8529528$var$getPropByPath = (t, n)=>t ? n.split(".").reduce((t, n)=>t && $5d4c081fc8529528$var$hasOwnProperty(t, n) ? t[n] : void 0, t) : void 0;
const $5d4c081fc8529528$var$createOptionCheck = (t, n, o)=>(s)=>[
            $5d4c081fc8529528$var$getPropByPath(t, s),
            o || void 0 !== $5d4c081fc8529528$var$getPropByPath(n, s)
        ];
const $5d4c081fc8529528$var$createState = (t)=>{
    let n = t;
    return [
        ()=>n,
        (t)=>{
            n = $5d4c081fc8529528$var$assignDeep({}, n, t);
        }
    ];
};
const $5d4c081fc8529528$var$It = "tabindex";
const $5d4c081fc8529528$var$At = $5d4c081fc8529528$var$createDiv.bind(0, "");
const $5d4c081fc8529528$var$unwrap = (t)=>{
    $5d4c081fc8529528$var$appendChildren($5d4c081fc8529528$var$parent(t), $5d4c081fc8529528$var$contents(t));
    $5d4c081fc8529528$var$removeElements(t);
};
const $5d4c081fc8529528$var$createStructureSetupElements = (t)=>{
    const n = $5d4c081fc8529528$var$getEnvironment();
    const { N: o, I: s } = n;
    const e = $5d4c081fc8529528$var$getPlugins()[$5d4c081fc8529528$var$$t];
    const c = e && e.T;
    const { elements: r } = o();
    const { host: i, padding: l, viewport: a, content: u } = r;
    const d = $5d4c081fc8529528$var$isHTMLElement(t);
    const f = d ? {} : t;
    const { elements: _ } = f;
    const { host: h, padding: g, viewport: v, content: w } = _ || {};
    const p = d ? t : f.target;
    const b = $5d4c081fc8529528$var$is(p, "textarea");
    const m = p.ownerDocument;
    const y = m.documentElement;
    const S = p === m.body;
    const x = m.defaultView;
    const $ = $5d4c081fc8529528$var$staticInitializationElement.bind(0, [
        p
    ]);
    const C = $5d4c081fc8529528$var$dynamicInitializationElement.bind(0, [
        p
    ]);
    const I = $5d4c081fc8529528$var$resolveInitialization.bind(0, [
        p
    ]);
    const A = $.bind(0, $5d4c081fc8529528$var$At, a);
    const L = C.bind(0, $5d4c081fc8529528$var$At, u);
    const P = A(v);
    const k = P === p;
    const B = k && S;
    const V = !k && L(w);
    const Y = !k && $5d4c081fc8529528$var$isHTMLElement(P) && P === V;
    const j = Y && !!I(u);
    const N = j ? A() : P;
    const q = j ? V : L();
    const F = Y ? N : P;
    const G = B ? y : F;
    const X = b ? $($5d4c081fc8529528$var$At, i, h) : p;
    const U = B ? G : X;
    const W = Y ? q : V;
    const Z = m.activeElement;
    const J = !k && x.top === x && Z === p;
    const K = {
        W: p,
        Z: U,
        J: G,
        K: !k && C($5d4c081fc8529528$var$At, l, g),
        tt: W,
        nt: !k && !s && c && c(n),
        ot: B ? y : G,
        st: B ? m : G,
        et: x,
        ct: m,
        rt: b,
        it: S,
        lt: d,
        ut: k,
        dt: Y,
        ft: (t, n)=>k ? $5d4c081fc8529528$var$hasAttrClass(G, $5d4c081fc8529528$var$O, n) : $5d4c081fc8529528$var$hasClass(G, t),
        _t: (t, n, o)=>k ? $5d4c081fc8529528$var$attrClass(G, $5d4c081fc8529528$var$O, n, o) : (o ? $5d4c081fc8529528$var$addClass : $5d4c081fc8529528$var$removeClass)(G, t)
    };
    const Q = $5d4c081fc8529528$var$keys(K).reduce((t, n)=>{
        const o = K[n];
        return $5d4c081fc8529528$var$push(t, o && !$5d4c081fc8529528$var$parent(o) ? o : false);
    }, []);
    const elementIsGenerated = (t)=>t ? $5d4c081fc8529528$var$indexOf(Q, t) > -1 : null;
    const { W: tt, Z: nt, K: ot, J: st, tt: et, nt: ct } = K;
    const rt = [
        ()=>{
            $5d4c081fc8529528$var$removeAttr(nt, $5d4c081fc8529528$var$O);
            $5d4c081fc8529528$var$removeAttr(nt, $5d4c081fc8529528$var$z);
            $5d4c081fc8529528$var$removeAttr(tt, $5d4c081fc8529528$var$z);
            if (S) {
                $5d4c081fc8529528$var$removeAttr(y, $5d4c081fc8529528$var$O);
                $5d4c081fc8529528$var$removeAttr(y, $5d4c081fc8529528$var$z);
            }
        }
    ];
    const it = b && elementIsGenerated(nt);
    let lt = b ? tt : $5d4c081fc8529528$var$contents([
        et,
        st,
        ot,
        nt,
        tt
    ].find((t)=>false === elementIsGenerated(t)));
    const at = B ? tt : et || st;
    const appendElements = ()=>{
        $5d4c081fc8529528$var$attr(nt, $5d4c081fc8529528$var$O, k ? "viewport" : "host");
        const t = $5d4c081fc8529528$var$addClass(ot, $5d4c081fc8529528$var$H);
        const n = $5d4c081fc8529528$var$addClass(st, !k && $5d4c081fc8529528$var$M);
        const o = $5d4c081fc8529528$var$addClass(et, $5d4c081fc8529528$var$D);
        const e = S && !k ? $5d4c081fc8529528$var$addClass($5d4c081fc8529528$var$parent(p), $5d4c081fc8529528$var$R) : $5d4c081fc8529528$var$noop;
        if (it) {
            $5d4c081fc8529528$var$insertAfter(tt, nt);
            $5d4c081fc8529528$var$push(rt, ()=>{
                $5d4c081fc8529528$var$insertAfter(nt, tt);
                $5d4c081fc8529528$var$removeElements(nt);
            });
        }
        $5d4c081fc8529528$var$appendChildren(at, lt);
        $5d4c081fc8529528$var$appendChildren(nt, ot);
        $5d4c081fc8529528$var$appendChildren(ot || nt, !k && st);
        $5d4c081fc8529528$var$appendChildren(st, et);
        $5d4c081fc8529528$var$push(rt, ()=>{
            e();
            $5d4c081fc8529528$var$removeAttr(st, $5d4c081fc8529528$var$T);
            $5d4c081fc8529528$var$removeAttr(st, $5d4c081fc8529528$var$E);
            if (elementIsGenerated(et)) $5d4c081fc8529528$var$unwrap(et);
            if (elementIsGenerated(st)) $5d4c081fc8529528$var$unwrap(st);
            if (elementIsGenerated(ot)) $5d4c081fc8529528$var$unwrap(ot);
            t();
            n();
            o();
        });
        if (s && !k) $5d4c081fc8529528$var$push(rt, $5d4c081fc8529528$var$removeClass.bind(0, st, $5d4c081fc8529528$var$R));
        if (ct) {
            $5d4c081fc8529528$var$insertBefore(st, ct);
            $5d4c081fc8529528$var$push(rt, $5d4c081fc8529528$var$removeElements.bind(0, ct));
        }
        if (J) {
            const t = $5d4c081fc8529528$var$attr(st, $5d4c081fc8529528$var$It);
            $5d4c081fc8529528$var$attr(st, $5d4c081fc8529528$var$It, "-1");
            st.focus();
            const revertViewportTabIndex = ()=>t ? $5d4c081fc8529528$var$attr(st, $5d4c081fc8529528$var$It, t) : $5d4c081fc8529528$var$removeAttr(st, $5d4c081fc8529528$var$It);
            const n = $5d4c081fc8529528$var$on(m, "pointerdown keydown", ()=>{
                revertViewportTabIndex();
                n();
            });
            $5d4c081fc8529528$var$push(rt, [
                revertViewportTabIndex,
                n
            ]);
        } else if (Z && Z.focus) Z.focus();
        lt = 0;
    };
    return [
        K,
        appendElements,
        $5d4c081fc8529528$var$runEachAndClear.bind(0, rt)
    ];
};
const $5d4c081fc8529528$var$createTrinsicUpdateSegment = (t, n)=>{
    const { tt: o } = t;
    const [s] = n;
    return (t)=>{
        const { V: n } = $5d4c081fc8529528$var$getEnvironment();
        const { ht: e } = s();
        const { gt: c } = t;
        const r = (o || !n) && c;
        if (r) $5d4c081fc8529528$var$style(o, {
            height: e ? "" : "100%"
        });
        return {
            vt: r,
            wt: r
        };
    };
};
const $5d4c081fc8529528$var$createPaddingUpdateSegment = (t, n)=>{
    const [o, s] = n;
    const { Z: e, K: c, J: r, ut: i } = t;
    const [l, a] = $5d4c081fc8529528$var$createCache({
        u: $5d4c081fc8529528$var$equalTRBL,
        o: $5d4c081fc8529528$var$topRightBottomLeft()
    }, $5d4c081fc8529528$var$topRightBottomLeft.bind(0, e, "padding", ""));
    return (t, n, e)=>{
        let [u, d] = a(e);
        const { I: f, V: _ } = $5d4c081fc8529528$var$getEnvironment();
        const { bt: h } = o();
        const { vt: g, wt: v, yt: w } = t;
        const [p, b] = n("paddingAbsolute");
        const m = !_ && v;
        if (g || d || m) [u, d] = l(e);
        const y = !i && (b || w || d);
        if (y) {
            const t = !p || !c && !f;
            const n = u.r + u.l;
            const o = u.t + u.b;
            const e = {
                marginRight: t && !h ? -n : 0,
                marginBottom: t ? -o : 0,
                marginLeft: t && h ? -n : 0,
                top: t ? -u.t : 0,
                right: t ? h ? -u.r : "auto" : 0,
                left: t ? h ? "auto" : -u.l : 0,
                width: t ? `calc(100% + ${n}px)` : ""
            };
            const i = {
                paddingTop: t ? u.t : 0,
                paddingRight: t ? u.r : 0,
                paddingBottom: t ? u.b : 0,
                paddingLeft: t ? u.l : 0
            };
            $5d4c081fc8529528$var$style(c || r, e);
            $5d4c081fc8529528$var$style(r, i);
            s({
                K: u,
                St: !t,
                M: c ? i : $5d4c081fc8529528$var$assignDeep({}, e, i)
            });
        }
        return {
            xt: y
        };
    };
};
const { max: $5d4c081fc8529528$var$Lt } = Math;
const $5d4c081fc8529528$var$Ht = $5d4c081fc8529528$var$Lt.bind(0, 0);
const $5d4c081fc8529528$var$Mt = "visible";
const $5d4c081fc8529528$var$Pt = "hidden";
const $5d4c081fc8529528$var$Dt = 42;
const $5d4c081fc8529528$var$Rt = {
    u: $5d4c081fc8529528$var$equalWH,
    o: {
        w: 0,
        h: 0
    }
};
const $5d4c081fc8529528$var$kt = {
    u: $5d4c081fc8529528$var$equalXY,
    o: {
        x: $5d4c081fc8529528$var$Pt,
        y: $5d4c081fc8529528$var$Pt
    }
};
const $5d4c081fc8529528$var$getOverflowAmount = (t, n)=>{
    const o = window.devicePixelRatio % 1 !== 0 ? 1 : 0;
    const s = {
        w: $5d4c081fc8529528$var$Ht(t.w - n.w),
        h: $5d4c081fc8529528$var$Ht(t.h - n.h)
    };
    return {
        w: s.w > o ? s.w : 0,
        h: s.h > o ? s.h : 0
    };
};
const $5d4c081fc8529528$var$conditionalClass = (t, n, o)=>o ? $5d4c081fc8529528$var$addClass(t, n) : $5d4c081fc8529528$var$removeClass(t, n);
const $5d4c081fc8529528$var$overflowIsVisible = (t)=>0 === t.indexOf($5d4c081fc8529528$var$Mt);
const $5d4c081fc8529528$var$createOverflowUpdateSegment = (t, n)=>{
    const [o, s] = n;
    const { Z: e, K: c, J: r, nt: i, ut: l, _t: a, it: u, et: d } = t;
    const { k: f, V: _, I: h, A: g } = $5d4c081fc8529528$var$getEnvironment();
    const v = $5d4c081fc8529528$var$getPlugins()[$5d4c081fc8529528$var$$t];
    const w = !l && !h && (g.x || g.y);
    const p = u && l;
    const [b, m] = $5d4c081fc8529528$var$createCache($5d4c081fc8529528$var$Rt, $5d4c081fc8529528$var$fractionalSize.bind(0, r));
    const [y, S] = $5d4c081fc8529528$var$createCache($5d4c081fc8529528$var$Rt, $5d4c081fc8529528$var$scrollSize.bind(0, r));
    const [x, $] = $5d4c081fc8529528$var$createCache($5d4c081fc8529528$var$Rt);
    const [C, z] = $5d4c081fc8529528$var$createCache($5d4c081fc8529528$var$Rt);
    const [L] = $5d4c081fc8529528$var$createCache($5d4c081fc8529528$var$kt);
    const fixFlexboxGlue = (t, n)=>{
        $5d4c081fc8529528$var$style(r, {
            height: ""
        });
        if (n) {
            const { St: n, K: s } = o();
            const { $t: c, P: i } = t;
            const l = $5d4c081fc8529528$var$fractionalSize(e);
            const a = $5d4c081fc8529528$var$clientSize(e);
            const u = "content-box" === $5d4c081fc8529528$var$style(r, "boxSizing");
            const d = n || u ? s.b + s.t : 0;
            const f = !(g.x && u);
            $5d4c081fc8529528$var$style(r, {
                height: a.h + l.h + (c.x && f ? i.x : 0) - d
            });
        }
    };
    const getViewportOverflowState = (t, n)=>{
        const o = !h && !t ? $5d4c081fc8529528$var$Dt : 0;
        const getStatePerAxis = (t, s, e)=>{
            const c = $5d4c081fc8529528$var$style(r, t);
            const i = n ? n[t] : c;
            const l = "scroll" === i;
            const a = s ? o : e;
            const u = l && !h ? a : 0;
            const d = s && !!o;
            return [
                c,
                l,
                u,
                d
            ];
        };
        const [s, e, c, i] = getStatePerAxis("overflowX", g.x, f.x);
        const [l, a, u, d] = getStatePerAxis("overflowY", g.y, f.y);
        return {
            Ct: {
                x: s,
                y: l
            },
            $t: {
                x: e,
                y: a
            },
            P: {
                x: c,
                y: u
            },
            D: {
                x: i,
                y: d
            }
        };
    };
    const setViewportOverflowState = (t, n, o, s)=>{
        const setAxisOverflowStyle = (t, n)=>{
            const o = $5d4c081fc8529528$var$overflowIsVisible(t);
            const s = n && o && t.replace(`${$5d4c081fc8529528$var$Mt}-`, "") || "";
            return [
                n && !o ? t : "",
                $5d4c081fc8529528$var$overflowIsVisible(s) ? "hidden" : s
            ];
        };
        const [e, c] = setAxisOverflowStyle(o.x, n.x);
        const [r, i] = setAxisOverflowStyle(o.y, n.y);
        s.overflowX = c && r ? c : e;
        s.overflowY = i && e ? i : r;
        return getViewportOverflowState(t, s);
    };
    const hideNativeScrollbars = (t, n, s, e)=>{
        const { P: c, D: r } = t;
        const { x: i, y: l } = r;
        const { x: a, y: u } = c;
        const { M: d } = o();
        const f = n ? "marginLeft" : "marginRight";
        const _ = n ? "paddingLeft" : "paddingRight";
        const h = d[f];
        const g = d.marginBottom;
        const v = d[_];
        const w = d.paddingBottom;
        e.width = `calc(100% + ${u + -1 * h}px)`;
        e[f] = -u + h;
        e.marginBottom = -a + g;
        if (s) {
            e[_] = v + (l ? u : 0);
            e.paddingBottom = w + (i ? a : 0);
        }
    };
    const [H, M] = v ? v.H(w, _, r, i, o, getViewportOverflowState, hideNativeScrollbars) : [
        ()=>w,
        ()=>[
                $5d4c081fc8529528$var$noop
            ]
    ];
    return (t, n, i)=>{
        const { vt: u, Ot: f, wt: v, xt: w, gt: P, yt: D } = t;
        const { ht: B, bt: V } = o();
        const [Y, j] = n("showNativeOverlaidScrollbars");
        const [N, q] = n("overflow");
        const F = Y && g.x && g.y;
        const G = !l && !_ && (u || v || f || j || P);
        const X = $5d4c081fc8529528$var$overflowIsVisible(N.x);
        const U = $5d4c081fc8529528$var$overflowIsVisible(N.y);
        const W = X || U;
        let Z = m(i);
        let J = S(i);
        let K = $(i);
        let Q = z(i);
        let tt;
        if (j && h) a($5d4c081fc8529528$var$R, $5d4c081fc8529528$var$A, !F);
        if (G) {
            tt = getViewportOverflowState(F);
            fixFlexboxGlue(tt, B);
        }
        if (u || w || v || D || j) {
            if (W) a($5d4c081fc8529528$var$k, $5d4c081fc8529528$var$I, false);
            const [t, n] = M(F, V, tt);
            const [o, s] = Z = b(i);
            const [e, c] = J = y(i);
            const l = $5d4c081fc8529528$var$clientSize(r);
            let u = e;
            let f = l;
            t();
            if ((c || s || j) && n && !F && H(n, e, o, V)) {
                f = $5d4c081fc8529528$var$clientSize(r);
                u = $5d4c081fc8529528$var$scrollSize(r);
            }
            const _ = {
                w: $5d4c081fc8529528$var$Ht($5d4c081fc8529528$var$Lt(e.w, u.w) + o.w),
                h: $5d4c081fc8529528$var$Ht($5d4c081fc8529528$var$Lt(e.h, u.h) + o.h)
            };
            const h = {
                w: $5d4c081fc8529528$var$Ht((p ? d.innerWidth : f.w + $5d4c081fc8529528$var$Ht(l.w - e.w)) + o.w),
                h: $5d4c081fc8529528$var$Ht((p ? d.innerHeight + o.h : f.h + $5d4c081fc8529528$var$Ht(l.h - e.h)) + o.h)
            };
            Q = C(h);
            K = x($5d4c081fc8529528$var$getOverflowAmount(_, h), i);
        }
        const [nt, ot] = Q;
        const [st, et] = K;
        const [ct, rt] = J;
        const [it, lt] = Z;
        const at = {
            x: st.w > 0,
            y: st.h > 0
        };
        const ut = X && U && (at.x || at.y) || X && at.x && !at.y || U && at.y && !at.x;
        if (w || D || lt || rt || ot || et || q || j || G) {
            const t = {
                marginRight: 0,
                marginBottom: 0,
                marginLeft: 0,
                width: "",
                overflowY: "",
                overflowX: ""
            };
            const n = setViewportOverflowState(F, at, N, t);
            const o = H(n, ct, it, V);
            if (!l) hideNativeScrollbars(n, V, o, t);
            if (G) fixFlexboxGlue(n, B);
            if (l) {
                $5d4c081fc8529528$var$attr(e, $5d4c081fc8529528$var$T, t.overflowX);
                $5d4c081fc8529528$var$attr(e, $5d4c081fc8529528$var$E, t.overflowY);
            } else $5d4c081fc8529528$var$style(r, t);
        }
        $5d4c081fc8529528$var$attrClass(e, $5d4c081fc8529528$var$O, $5d4c081fc8529528$var$I, ut);
        $5d4c081fc8529528$var$conditionalClass(c, $5d4c081fc8529528$var$k, ut);
        !l && $5d4c081fc8529528$var$conditionalClass(r, $5d4c081fc8529528$var$k, W);
        const [dt, ft] = L(getViewportOverflowState(F).Ct);
        s({
            Ct: dt,
            zt: {
                x: nt.w,
                y: nt.h
            },
            Tt: {
                x: st.w,
                y: st.h
            },
            Et: at
        });
        return {
            It: ft,
            At: ot,
            Lt: et
        };
    };
};
const $5d4c081fc8529528$var$prepareUpdateHints = (t, n, o)=>{
    const s = {};
    const e = n || {};
    const c = $5d4c081fc8529528$var$keys(t).concat($5d4c081fc8529528$var$keys(e));
    $5d4c081fc8529528$var$each(c, (n)=>{
        const c = t[n];
        const r = e[n];
        s[n] = !!(o || c || r);
    });
    return s;
};
const $5d4c081fc8529528$var$createStructureSetupUpdate = (t, n)=>{
    const { W: o, J: s, _t: e, ut: c } = t;
    const { I: r, A: i, V: l } = $5d4c081fc8529528$var$getEnvironment();
    const a = !r && (i.x || i.y);
    const u = [
        $5d4c081fc8529528$var$createTrinsicUpdateSegment(t, n),
        $5d4c081fc8529528$var$createPaddingUpdateSegment(t, n),
        $5d4c081fc8529528$var$createOverflowUpdateSegment(t, n)
    ];
    return (t, n, r)=>{
        const i = $5d4c081fc8529528$var$prepareUpdateHints($5d4c081fc8529528$var$assignDeep({
            vt: false,
            xt: false,
            yt: false,
            gt: false,
            At: false,
            Lt: false,
            It: false,
            Ot: false,
            wt: false
        }, n), {}, r);
        const d = a || !l;
        const f = d && $5d4c081fc8529528$var$scrollLeft(s);
        const _ = d && $5d4c081fc8529528$var$scrollTop(s);
        e("", $5d4c081fc8529528$var$L, true);
        let h = i;
        $5d4c081fc8529528$var$each(u, (n)=>{
            h = $5d4c081fc8529528$var$prepareUpdateHints(h, n(h, t, !!r) || {}, r);
        });
        $5d4c081fc8529528$var$scrollLeft(s, f);
        $5d4c081fc8529528$var$scrollTop(s, _);
        e("", $5d4c081fc8529528$var$L);
        if (!c) {
            $5d4c081fc8529528$var$scrollLeft(o, 0);
            $5d4c081fc8529528$var$scrollTop(o, 0);
        }
        return h;
    };
};
const $5d4c081fc8529528$var$createEventContentChange = (t, n, o)=>{
    let s;
    let e = false;
    const destroy = ()=>{
        e = true;
    };
    const updateElements = (c)=>{
        if (o) {
            const r = o.reduce((n, o)=>{
                if (o) {
                    const [s, e] = o;
                    const r = e && s && (c ? c(s) : $5d4c081fc8529528$var$find(s, t));
                    if (r && r.length && e && $5d4c081fc8529528$var$isString(e)) $5d4c081fc8529528$var$push(n, [
                        r,
                        e.trim()
                    ], true);
                }
                return n;
            }, []);
            $5d4c081fc8529528$var$each(r, (o)=>$5d4c081fc8529528$var$each(o[0], (c)=>{
                    const r = o[1];
                    const i = s.get(c) || [];
                    const l = t.contains(c);
                    if (l) {
                        const t = $5d4c081fc8529528$var$on(c, r, (o)=>{
                            if (e) {
                                t();
                                s.delete(c);
                            } else n(o);
                        });
                        s.set(c, $5d4c081fc8529528$var$push(i, t));
                    } else {
                        $5d4c081fc8529528$var$runEachAndClear(i);
                        s.delete(c);
                    }
                }));
        }
    };
    if (o) {
        s = new WeakMap;
        updateElements();
    }
    return [
        destroy,
        updateElements
    ];
};
const $5d4c081fc8529528$var$createDOMObserver = (t, n, o, s)=>{
    let e = false;
    const { Ht: c, Mt: r, Pt: i, Dt: a, Rt: u, kt: d } = s || {};
    const f = $5d4c081fc8529528$var$debounce(()=>{
        if (e) o(true);
    }, {
        g: 33,
        v: 99
    });
    const [_, h] = $5d4c081fc8529528$var$createEventContentChange(t, f, i);
    const g = c || [];
    const v = r || [];
    const w = g.concat(v);
    const observerCallback = (e, c)=>{
        const r = u || $5d4c081fc8529528$var$noop;
        const i = d || $5d4c081fc8529528$var$noop;
        const l = new Set;
        const f = new Set;
        let _ = false;
        let g = false;
        $5d4c081fc8529528$var$each(e, (o)=>{
            const { attributeName: e, target: c, type: u, oldValue: d, addedNodes: h, removedNodes: w } = o;
            const p = "attributes" === u;
            const b = "childList" === u;
            const m = t === c;
            const y = p && $5d4c081fc8529528$var$isString(e) ? $5d4c081fc8529528$var$attr(c, e) : 0;
            const S = 0 !== y && d !== y;
            const x = $5d4c081fc8529528$var$indexOf(v, e) > -1 && S;
            if (n && (b || !m)) {
                const n = !p;
                const u = p && S;
                const f = u && a && $5d4c081fc8529528$var$is(c, a);
                const _ = f ? !r(c, e, d, y) : n || u;
                const v = _ && !i(o, !!f, t, s);
                $5d4c081fc8529528$var$each(h, (t)=>l.add(t));
                $5d4c081fc8529528$var$each(w, (t)=>l.add(t));
                g = g || v;
            }
            if (!n && m && S && !r(c, e, d, y)) {
                f.add(e);
                _ = _ || x;
            }
        });
        if (l.size > 0) h((t)=>$5d4c081fc8529528$var$from(l).reduce((n, o)=>{
                $5d4c081fc8529528$var$push(n, $5d4c081fc8529528$var$find(t, o));
                return $5d4c081fc8529528$var$is(o, t) ? $5d4c081fc8529528$var$push(n, o) : n;
            }, []));
        if (n) {
            !c && g && o(false);
            return [
                false
            ];
        }
        if (f.size > 0 || _) {
            const t = [
                $5d4c081fc8529528$var$from(f),
                _
            ];
            !c && o.apply(0, t);
            return t;
        }
    };
    const p = new $5d4c081fc8529528$var$l((t)=>observerCallback(t));
    p.observe(t, {
        attributes: true,
        attributeOldValue: true,
        attributeFilter: w,
        subtree: n,
        childList: n,
        characterData: n
    });
    e = true;
    return [
        ()=>{
            if (e) {
                _();
                p.disconnect();
                e = false;
            }
        },
        ()=>{
            if (e) {
                f.m();
                const t = p.takeRecords();
                return !$5d4c081fc8529528$var$isEmptyArray(t) && observerCallback(t, true);
            }
        }
    ];
};
const $5d4c081fc8529528$var$Bt = 3333333;
const $5d4c081fc8529528$var$domRectHasDimensions = (t)=>t && (t.height || t.width);
const $5d4c081fc8529528$var$createSizeObserver = (t, n, o)=>{
    const { Bt: s = false, Vt: e = false } = o || {};
    const c = $5d4c081fc8529528$var$getPlugins()[$5d4c081fc8529528$var$bt];
    const { B: r } = $5d4c081fc8529528$var$getEnvironment();
    const i = $5d4c081fc8529528$var$createDOM(`<div class="${$5d4c081fc8529528$var$B}"><div class="${$5d4c081fc8529528$var$Y}"></div></div>`);
    const l = i[0];
    const a = l.firstChild;
    const d = $5d4c081fc8529528$var$directionIsRTL.bind(0, t);
    const [f] = $5d4c081fc8529528$var$createCache({
        o: void 0,
        _: true,
        u: (t, n)=>!(!t || !$5d4c081fc8529528$var$domRectHasDimensions(t) && $5d4c081fc8529528$var$domRectHasDimensions(n))
    });
    const onSizeChangedCallbackProxy = (t)=>{
        const o = $5d4c081fc8529528$var$isArray(t) && t.length > 0 && $5d4c081fc8529528$var$isObject(t[0]);
        const e = !o && $5d4c081fc8529528$var$isBoolean(t[0]);
        let c = false;
        let i = false;
        let a = true;
        if (o) {
            const [n, , o] = f(t.pop().contentRect);
            const s = $5d4c081fc8529528$var$domRectHasDimensions(n);
            const e = $5d4c081fc8529528$var$domRectHasDimensions(o);
            c = !o || !s;
            i = !e && s;
            a = !c;
        } else if (e) [, a] = t;
        else i = true === t;
        if (s && a) {
            const n = e ? t[0] : $5d4c081fc8529528$var$directionIsRTL(l);
            $5d4c081fc8529528$var$scrollLeft(l, n ? r.n ? -$5d4c081fc8529528$var$Bt : r.i ? 0 : $5d4c081fc8529528$var$Bt : $5d4c081fc8529528$var$Bt);
            $5d4c081fc8529528$var$scrollTop(l, $5d4c081fc8529528$var$Bt);
        }
        if (!c) n({
            vt: !e,
            Yt: e ? t : void 0,
            Vt: !!i
        });
    };
    const _ = [];
    let h = e ? onSizeChangedCallbackProxy : false;
    return [
        ()=>{
            $5d4c081fc8529528$var$runEachAndClear(_);
            $5d4c081fc8529528$var$removeElements(l);
        },
        ()=>{
            if ($5d4c081fc8529528$var$u) {
                const t = new $5d4c081fc8529528$var$u(onSizeChangedCallbackProxy);
                t.observe(a);
                $5d4c081fc8529528$var$push(_, ()=>{
                    t.disconnect();
                });
            } else if (c) {
                const [t, n] = c.O(a, onSizeChangedCallbackProxy, e);
                h = t;
                $5d4c081fc8529528$var$push(_, n);
            }
            if (s) {
                const [t] = $5d4c081fc8529528$var$createCache({
                    o: !d()
                }, d);
                $5d4c081fc8529528$var$push(_, $5d4c081fc8529528$var$on(l, "scroll", (n)=>{
                    const o = t();
                    const [s, e] = o;
                    if (e) {
                        $5d4c081fc8529528$var$removeClass(a, "ltr rtl");
                        if (s) $5d4c081fc8529528$var$addClass(a, "rtl");
                        else $5d4c081fc8529528$var$addClass(a, "ltr");
                        onSizeChangedCallbackProxy(o);
                    }
                    $5d4c081fc8529528$var$stopPropagation(n);
                }));
            }
            if (h) {
                $5d4c081fc8529528$var$addClass(l, $5d4c081fc8529528$var$V);
                $5d4c081fc8529528$var$push(_, $5d4c081fc8529528$var$on(l, "animationstart", h, {
                    C: !!$5d4c081fc8529528$var$u
                }));
            }
            if ($5d4c081fc8529528$var$u || c) $5d4c081fc8529528$var$appendChildren(t, l);
        }
    ];
};
const $5d4c081fc8529528$var$isHeightIntrinsic = (t)=>0 === t.h || t.isIntersecting || t.intersectionRatio > 0;
const $5d4c081fc8529528$var$createTrinsicObserver = (t, n)=>{
    let o;
    const s = $5d4c081fc8529528$var$createDiv($5d4c081fc8529528$var$F);
    const e = [];
    const [c] = $5d4c081fc8529528$var$createCache({
        o: false
    });
    const triggerOnTrinsicChangedCallback = (t, o)=>{
        if (t) {
            const s = c($5d4c081fc8529528$var$isHeightIntrinsic(t));
            const [, e] = s;
            if (e) {
                !o && n(s);
                return [
                    s
                ];
            }
        }
    };
    const intersectionObserverCallback = (t, n)=>{
        if (t && t.length > 0) return triggerOnTrinsicChangedCallback(t.pop(), n);
    };
    return [
        ()=>{
            $5d4c081fc8529528$var$runEachAndClear(e);
            $5d4c081fc8529528$var$removeElements(s);
        },
        ()=>{
            if ($5d4c081fc8529528$var$a) {
                o = new $5d4c081fc8529528$var$a((t)=>intersectionObserverCallback(t), {
                    root: t
                });
                o.observe(s);
                $5d4c081fc8529528$var$push(e, ()=>{
                    o.disconnect();
                });
            } else {
                const onSizeChanged = ()=>{
                    const t = $5d4c081fc8529528$var$offsetSize(s);
                    triggerOnTrinsicChangedCallback(t);
                };
                const [t, n] = $5d4c081fc8529528$var$createSizeObserver(s, onSizeChanged);
                $5d4c081fc8529528$var$push(e, t);
                n();
                onSizeChanged();
            }
            $5d4c081fc8529528$var$appendChildren(t, s);
        },
        ()=>{
            if (o) return intersectionObserverCallback(o.takeRecords(), true);
        }
    ];
};
const $5d4c081fc8529528$var$Vt = `[${$5d4c081fc8529528$var$O}]`;
const $5d4c081fc8529528$var$Yt = `.${$5d4c081fc8529528$var$M}`;
const $5d4c081fc8529528$var$jt = [
    "tabindex"
];
const $5d4c081fc8529528$var$Nt = [
    "wrap",
    "cols",
    "rows"
];
const $5d4c081fc8529528$var$qt = [
    "id",
    "class",
    "style",
    "open"
];
const $5d4c081fc8529528$var$createStructureSetupObservers = (t, n, o)=>{
    let s;
    let e;
    let c;
    const { Z: r, J: i, tt: l, rt: a, ut: d, ft: f, _t: _ } = t;
    const { V: h } = $5d4c081fc8529528$var$getEnvironment();
    const [g] = $5d4c081fc8529528$var$createCache({
        u: $5d4c081fc8529528$var$equalWH,
        o: {
            w: 0,
            h: 0
        }
    }, ()=>{
        const t = f($5d4c081fc8529528$var$k, $5d4c081fc8529528$var$I);
        const n = f($5d4c081fc8529528$var$P, "");
        const o = n && $5d4c081fc8529528$var$scrollLeft(i);
        const s = n && $5d4c081fc8529528$var$scrollTop(i);
        _($5d4c081fc8529528$var$k, $5d4c081fc8529528$var$I);
        _($5d4c081fc8529528$var$P, "");
        _("", $5d4c081fc8529528$var$L, true);
        const e = $5d4c081fc8529528$var$scrollSize(l);
        const c = $5d4c081fc8529528$var$scrollSize(i);
        const r = $5d4c081fc8529528$var$fractionalSize(i);
        _($5d4c081fc8529528$var$k, $5d4c081fc8529528$var$I, t);
        _($5d4c081fc8529528$var$P, "", n);
        _("", $5d4c081fc8529528$var$L);
        $5d4c081fc8529528$var$scrollLeft(i, o);
        $5d4c081fc8529528$var$scrollTop(i, s);
        return {
            w: c.w + e.w + r.w,
            h: c.h + e.h + r.h
        };
    });
    const v = a ? $5d4c081fc8529528$var$Nt : $5d4c081fc8529528$var$qt.concat($5d4c081fc8529528$var$Nt);
    const w = $5d4c081fc8529528$var$debounce(o, {
        g: ()=>s,
        v: ()=>e,
        p (t, n) {
            const [o] = t;
            const [s] = n;
            return [
                $5d4c081fc8529528$var$keys(o).concat($5d4c081fc8529528$var$keys(s)).reduce((t, n)=>{
                    t[n] = o[n] || s[n];
                    return t;
                }, {})
            ];
        }
    });
    const updateViewportAttrsFromHost = (t)=>{
        $5d4c081fc8529528$var$each(t || $5d4c081fc8529528$var$jt, (t)=>{
            if ($5d4c081fc8529528$var$indexOf($5d4c081fc8529528$var$jt, t) > -1) {
                const n = $5d4c081fc8529528$var$attr(r, t);
                if ($5d4c081fc8529528$var$isString(n)) $5d4c081fc8529528$var$attr(i, t, n);
                else $5d4c081fc8529528$var$removeAttr(i, t);
            }
        });
    };
    const onTrinsicChanged = (t, s)=>{
        const [e, c] = t;
        const r = {
            gt: c
        };
        n({
            ht: e
        });
        !s && o(r);
        return r;
    };
    const onSizeChanged = ({ vt: t, Yt: s, Vt: e })=>{
        const c = !t || e ? o : w;
        let r = false;
        if (s) {
            const [t, o] = s;
            r = o;
            n({
                bt: t
            });
        }
        c({
            vt: t,
            yt: r
        });
    };
    const onContentMutation = (t, n)=>{
        const [, s] = g();
        const e = {
            wt: s
        };
        const c = t ? o : w;
        if (s) !n && c(e);
        return e;
    };
    const onHostMutation = (t, n, o)=>{
        const s = {
            Ot: n
        };
        if (n) !o && w(s);
        else if (!d) updateViewportAttrsFromHost(t);
        return s;
    };
    const [p, b, m] = l || !h ? $5d4c081fc8529528$var$createTrinsicObserver(r, onTrinsicChanged) : [
        $5d4c081fc8529528$var$noop,
        $5d4c081fc8529528$var$noop,
        $5d4c081fc8529528$var$noop
    ];
    const [y, S] = !d ? $5d4c081fc8529528$var$createSizeObserver(r, onSizeChanged, {
        Vt: true,
        Bt: true
    }) : [
        $5d4c081fc8529528$var$noop,
        $5d4c081fc8529528$var$noop
    ];
    const [x, $] = $5d4c081fc8529528$var$createDOMObserver(r, false, onHostMutation, {
        Mt: $5d4c081fc8529528$var$qt,
        Ht: $5d4c081fc8529528$var$qt.concat($5d4c081fc8529528$var$jt)
    });
    const C = d && $5d4c081fc8529528$var$u && new $5d4c081fc8529528$var$u(onSizeChanged.bind(0, {
        vt: true
    }));
    C && C.observe(r);
    updateViewportAttrsFromHost();
    return [
        ()=>{
            p();
            y();
            c && c[0]();
            C && C.disconnect();
            x();
        },
        ()=>{
            S();
            b();
        },
        ()=>{
            const t = {};
            const n = $();
            const o = m();
            const s = c && c[1]();
            if (n) $5d4c081fc8529528$var$assignDeep(t, onHostMutation.apply(0, $5d4c081fc8529528$var$push(n, true)));
            if (o) $5d4c081fc8529528$var$assignDeep(t, onTrinsicChanged.apply(0, $5d4c081fc8529528$var$push(o, true)));
            if (s) $5d4c081fc8529528$var$assignDeep(t, onContentMutation.apply(0, $5d4c081fc8529528$var$push(s, true)));
            return t;
        },
        (t)=>{
            const [n] = t("update.ignoreMutation");
            const [o, r] = t("update.attributes");
            const [a, u] = t("update.elementEvents");
            const [f, _] = t("update.debounce");
            const h = u || r;
            const ignoreMutationFromOptions = (t)=>$5d4c081fc8529528$var$isFunction(n) && n(t);
            if (h) {
                if (c) {
                    c[1]();
                    c[0]();
                }
                c = $5d4c081fc8529528$var$createDOMObserver(l || i, true, onContentMutation, {
                    Ht: v.concat(o || []),
                    Pt: a,
                    Dt: $5d4c081fc8529528$var$Vt,
                    kt: (t, n)=>{
                        const { target: o, attributeName: s } = t;
                        const e = !n && s && !d ? $5d4c081fc8529528$var$liesBetween(o, $5d4c081fc8529528$var$Vt, $5d4c081fc8529528$var$Yt) : false;
                        return e || !!$5d4c081fc8529528$var$closest(o, `.${$5d4c081fc8529528$var$X}`) || !!ignoreMutationFromOptions(t);
                    }
                });
            }
            if (_) {
                w.m();
                if ($5d4c081fc8529528$var$isArray(f)) {
                    const t = f[0];
                    const n = f[1];
                    s = $5d4c081fc8529528$var$isNumber(t) && t;
                    e = $5d4c081fc8529528$var$isNumber(n) && n;
                } else if ($5d4c081fc8529528$var$isNumber(f)) {
                    s = f;
                    e = false;
                } else {
                    s = false;
                    e = false;
                }
            }
        }
    ];
};
const $5d4c081fc8529528$var$Ft = {
    x: 0,
    y: 0
};
const $5d4c081fc8529528$var$Gt = {
    K: {
        t: 0,
        r: 0,
        b: 0,
        l: 0
    },
    St: false,
    M: {
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
        paddingLeft: 0
    },
    zt: $5d4c081fc8529528$var$Ft,
    Tt: $5d4c081fc8529528$var$Ft,
    Ct: {
        x: "hidden",
        y: "hidden"
    },
    Et: {
        x: false,
        y: false
    },
    ht: false,
    bt: false
};
const $5d4c081fc8529528$var$createStructureSetup = (t, n)=>{
    const o = $5d4c081fc8529528$var$createOptionCheck(n, {});
    const s = $5d4c081fc8529528$var$createState($5d4c081fc8529528$var$Gt);
    const [e, c, r] = $5d4c081fc8529528$var$createEventListenerHub();
    const [i, l] = s;
    const [a, u, d] = $5d4c081fc8529528$var$createStructureSetupElements(t);
    const f = $5d4c081fc8529528$var$createStructureSetupUpdate(a, s);
    const triggerUpdateEvent = (t, n, o)=>{
        const s = $5d4c081fc8529528$var$keys(t).some((n)=>t[n]);
        const e = s || !$5d4c081fc8529528$var$isEmptyObject(n) || o;
        if (e) r("u", [
            t,
            n,
            o
        ]);
        return e;
    };
    const [_, h, g, v] = $5d4c081fc8529528$var$createStructureSetupObservers(a, l, (t)=>triggerUpdateEvent(f(o, t), {}, false));
    const w = i.bind(0);
    w.jt = (t)=>e("u", t);
    w.Nt = ()=>{
        const { W: t, J: n } = a;
        const o = $5d4c081fc8529528$var$scrollLeft(t);
        const s = $5d4c081fc8529528$var$scrollTop(t);
        h();
        u();
        $5d4c081fc8529528$var$scrollLeft(n, o);
        $5d4c081fc8529528$var$scrollTop(n, s);
    };
    w.qt = a;
    return [
        (t, o)=>{
            const s = $5d4c081fc8529528$var$createOptionCheck(n, t, o);
            v(s);
            return triggerUpdateEvent(f(s, g(), o), t, !!o);
        },
        w,
        ()=>{
            c();
            _();
            d();
        }
    ];
};
const { round: $5d4c081fc8529528$var$Xt } = Math;
const $5d4c081fc8529528$var$getScale = (t)=>{
    const { width: n, height: o } = $5d4c081fc8529528$var$getBoundingClientRect(t);
    const { w: s, h: e } = $5d4c081fc8529528$var$offsetSize(t);
    return {
        x: $5d4c081fc8529528$var$Xt(n) / s || 1,
        y: $5d4c081fc8529528$var$Xt(o) / e || 1
    };
};
const $5d4c081fc8529528$var$continuePointerDown = (t, n, o)=>{
    const s = n.scrollbars;
    const { button: e, isPrimary: c, pointerType: r } = t;
    const { pointers: i } = s;
    return 0 === e && c && s[o ? "dragScroll" : "clickScroll"] && (i || []).includes(r);
};
const $5d4c081fc8529528$var$createRootClickStopPropagationEvents = (t, n)=>$5d4c081fc8529528$var$on(t, "mousedown", $5d4c081fc8529528$var$on.bind(0, n, "click", $5d4c081fc8529528$var$stopPropagation, {
        C: true,
        $: true
    }), {
        $: true
    });
const $5d4c081fc8529528$var$createInteractiveScrollEvents = (t, n, o, s, e, c)=>{
    const { B: r } = $5d4c081fc8529528$var$getEnvironment();
    const { Ft: i, Gt: l, Xt: a } = o;
    const u = `scroll${c ? "Left" : "Top"}`;
    const d = `client${c ? "X" : "Y"}`;
    const f = c ? "width" : "height";
    const _ = c ? "left" : "top";
    const h = c ? "w" : "h";
    const g = c ? "x" : "y";
    const createRelativeHandleMove = (t, n)=>(o)=>{
            const { Tt: d } = e();
            const f = $5d4c081fc8529528$var$offsetSize(l)[h] - $5d4c081fc8529528$var$offsetSize(i)[h];
            const _ = n * o / f;
            const v = _ * d[g];
            const w = $5d4c081fc8529528$var$directionIsRTL(a);
            const p = w && c ? r.n || r.i ? 1 : -1 : 1;
            s[u] = t + v * p;
        };
    return $5d4c081fc8529528$var$on(l, "pointerdown", (o)=>{
        const e = $5d4c081fc8529528$var$closest(o.target, `.${$5d4c081fc8529528$var$K}`) === i;
        if ($5d4c081fc8529528$var$continuePointerDown(o, t, e)) {
            const t = !e && o.shiftKey;
            const getHandleRect = ()=>$5d4c081fc8529528$var$getBoundingClientRect(i);
            const getTrackRect = ()=>$5d4c081fc8529528$var$getBoundingClientRect(l);
            const getHandleOffset = (t, n)=>(t || getHandleRect())[_] - (n || getTrackRect())[_];
            const c = createRelativeHandleMove(s[u] || 0, 1 / $5d4c081fc8529528$var$getScale(s)[g]);
            const r = o[d];
            const a = getHandleRect();
            const h = getTrackRect();
            const v = a[f];
            const w = getHandleOffset(a, h) + v / 2;
            const p = r - h[_];
            const b = e ? 0 : p - w;
            const m = [
                $5d4c081fc8529528$var$on(n, "selectstart", (t)=>$5d4c081fc8529528$var$preventDefault(t), {
                    S: false
                }),
                $5d4c081fc8529528$var$on(l, "pointermove", (n)=>{
                    const o = n[d] - r;
                    if (e || t) c(b + o);
                })
            ];
            if (t) c(b);
            else if (!e) {
                const t = $5d4c081fc8529528$var$getPlugins()[$5d4c081fc8529528$var$Ot];
                if (t) $5d4c081fc8529528$var$push(m, t.O(c, getHandleOffset, b, v, p));
            }
            $5d4c081fc8529528$var$on(l, "pointerup", (t)=>{
                $5d4c081fc8529528$var$runEachAndClear(m);
                l.releasePointerCapture(t.pointerId);
            }, {
                C: true
            });
            l.setPointerCapture(o.pointerId);
        }
    });
};
const $5d4c081fc8529528$var$createScrollbarsSetupEvents = (t, n)=>(o, s, e, c, r, i)=>{
        const { Xt: l } = o;
        const [a, u] = $5d4c081fc8529528$var$selfClearTimeout(333);
        const d = !!r.scrollBy;
        let f = true;
        return $5d4c081fc8529528$var$runEachAndClear.bind(0, [
            $5d4c081fc8529528$var$on(l, "pointerenter", ()=>{
                s($5d4c081fc8529528$var$ot, true);
            }),
            $5d4c081fc8529528$var$on(l, "pointerleave pointercancel", ()=>{
                s($5d4c081fc8529528$var$ot);
            }),
            $5d4c081fc8529528$var$on(l, "wheel", (t)=>{
                const { deltaX: n, deltaY: o, deltaMode: e } = t;
                if (d && f && 0 === e && $5d4c081fc8529528$var$parent(l) === c) r.scrollBy({
                    left: n,
                    top: o,
                    behavior: "smooth"
                });
                f = false;
                s($5d4c081fc8529528$var$ct, true);
                a(()=>{
                    f = true;
                    s($5d4c081fc8529528$var$ct);
                });
                $5d4c081fc8529528$var$preventDefault(t);
            }, {
                S: false,
                $: true
            }),
            $5d4c081fc8529528$var$createRootClickStopPropagationEvents(l, e),
            $5d4c081fc8529528$var$createInteractiveScrollEvents(t, e, o, r, n, i),
            u
        ]);
    };
const { min: $5d4c081fc8529528$var$Ut, max: $5d4c081fc8529528$var$Wt, abs: $5d4c081fc8529528$var$Zt, round: $5d4c081fc8529528$var$Jt } = Math;
const $5d4c081fc8529528$var$getScrollbarHandleLengthRatio = (t, n, o, s)=>{
    if (s) {
        const t = o ? "x" : "y";
        const { Tt: n, zt: e } = s;
        const c = e[t];
        const r = n[t];
        return $5d4c081fc8529528$var$Wt(0, $5d4c081fc8529528$var$Ut(1, c / (c + r)));
    }
    const e = o ? "w" : "h";
    const c = $5d4c081fc8529528$var$offsetSize(t)[e];
    const r = $5d4c081fc8529528$var$offsetSize(n)[e];
    return $5d4c081fc8529528$var$Wt(0, $5d4c081fc8529528$var$Ut(1, c / r));
};
const $5d4c081fc8529528$var$getScrollbarHandleOffsetRatio = (t, n, o, s, e, c)=>{
    const { B: r } = $5d4c081fc8529528$var$getEnvironment();
    const i = c ? "x" : "y";
    const l = c ? "Left" : "Top";
    const { Tt: a } = s;
    const u = $5d4c081fc8529528$var$Jt(a[i]);
    const d = $5d4c081fc8529528$var$Zt(o[`scroll${l}`]);
    const f = c && e;
    const _ = r.i ? d : u - d;
    const h = f ? _ : d;
    const g = $5d4c081fc8529528$var$Ut(1, h / u);
    const v = $5d4c081fc8529528$var$getScrollbarHandleLengthRatio(t, n, c);
    return 1 / v * (1 - v) * g;
};
const $5d4c081fc8529528$var$createScrollbarsSetupElements = (t, n, o)=>{
    const { N: s } = $5d4c081fc8529528$var$getEnvironment();
    const { scrollbars: e } = s();
    const { slot: c } = e;
    const { ct: r, W: i, Z: l, J: a, lt: u, ot: d, it: f, ut: h } = n;
    const { scrollbars: g } = u ? {} : t;
    const { slot: v } = g || {};
    const w = $5d4c081fc8529528$var$dynamicInitializationElement([
        i,
        l,
        a
    ], ()=>h && f ? i : l, c, v);
    const scrollbarStructureAddRemoveClass = (t, n, o)=>{
        const s = o ? $5d4c081fc8529528$var$addClass : $5d4c081fc8529528$var$removeClass;
        $5d4c081fc8529528$var$each(t, (t)=>{
            s(t.Xt, n);
        });
    };
    const scrollbarsHandleStyle = (t, n)=>{
        $5d4c081fc8529528$var$each(t, (t)=>{
            const [o, s] = n(t);
            $5d4c081fc8529528$var$style(o, s);
        });
    };
    const scrollbarStructureRefreshHandleLength = (t, n, o)=>{
        scrollbarsHandleStyle(t, (t)=>{
            const { Ft: s, Gt: e } = t;
            return [
                s,
                {
                    [o ? "width" : "height"]: `${(100 * $5d4c081fc8529528$var$getScrollbarHandleLengthRatio(s, e, o, n)).toFixed(3)}%`
                }
            ];
        });
    };
    const scrollbarStructureRefreshHandleOffset = (t, n, o)=>{
        const s = o ? "X" : "Y";
        scrollbarsHandleStyle(t, (t)=>{
            const { Ft: e, Gt: c, Xt: r } = t;
            const i = $5d4c081fc8529528$var$getScrollbarHandleOffsetRatio(e, c, d, n, $5d4c081fc8529528$var$directionIsRTL(r), o);
            const l = i === i;
            return [
                e,
                {
                    transform: l ? `translate${s}(${(100 * i).toFixed(3)}%)` : ""
                }
            ];
        });
    };
    const p = [];
    const b = [];
    const m = [];
    const scrollbarsAddRemoveClass = (t, n, o)=>{
        const s = $5d4c081fc8529528$var$isBoolean(o);
        const e = s ? o : true;
        const c = s ? !o : true;
        e && scrollbarStructureAddRemoveClass(b, t, n);
        c && scrollbarStructureAddRemoveClass(m, t, n);
    };
    const refreshScrollbarsHandleLength = (t)=>{
        scrollbarStructureRefreshHandleLength(b, t, true);
        scrollbarStructureRefreshHandleLength(m, t);
    };
    const refreshScrollbarsHandleOffset = (t)=>{
        scrollbarStructureRefreshHandleOffset(b, t, true);
        scrollbarStructureRefreshHandleOffset(m, t);
    };
    const generateScrollbarDOM = (t)=>{
        const n = t ? $5d4c081fc8529528$var$W : $5d4c081fc8529528$var$Z;
        const s = t ? b : m;
        const e = $5d4c081fc8529528$var$isEmptyArray(s) ? $5d4c081fc8529528$var$nt : "";
        const c = $5d4c081fc8529528$var$createDiv(`${$5d4c081fc8529528$var$X} ${n} ${e}`);
        const i = $5d4c081fc8529528$var$createDiv($5d4c081fc8529528$var$J);
        const a = $5d4c081fc8529528$var$createDiv($5d4c081fc8529528$var$K);
        const u = {
            Xt: c,
            Gt: i,
            Ft: a
        };
        $5d4c081fc8529528$var$appendChildren(c, i);
        $5d4c081fc8529528$var$appendChildren(i, a);
        $5d4c081fc8529528$var$push(s, u);
        $5d4c081fc8529528$var$push(p, [
            $5d4c081fc8529528$var$removeElements.bind(0, c),
            o(u, scrollbarsAddRemoveClass, r, l, d, t)
        ]);
        return u;
    };
    const y = generateScrollbarDOM.bind(0, true);
    const S = generateScrollbarDOM.bind(0, false);
    const appendElements = ()=>{
        $5d4c081fc8529528$var$appendChildren(w, b[0].Xt);
        $5d4c081fc8529528$var$appendChildren(w, m[0].Xt);
        $5d4c081fc8529528$var$_(()=>{
            scrollbarsAddRemoveClass($5d4c081fc8529528$var$nt);
        }, 300);
    };
    y();
    S();
    return [
        {
            Ut: refreshScrollbarsHandleLength,
            Wt: refreshScrollbarsHandleOffset,
            Zt: scrollbarsAddRemoveClass,
            Jt: {
                Kt: b,
                Qt: y,
                tn: scrollbarsHandleStyle.bind(0, b)
            },
            nn: {
                Kt: m,
                Qt: S,
                tn: scrollbarsHandleStyle.bind(0, m)
            }
        },
        appendElements,
        $5d4c081fc8529528$var$runEachAndClear.bind(0, p)
    ];
};
const $5d4c081fc8529528$var$createScrollbarsSetup = (t, n, o, s)=>{
    let e;
    let c;
    let r;
    let i;
    let l;
    let a = 0;
    const u = $5d4c081fc8529528$var$createState({});
    const [d] = u;
    const [f, _] = $5d4c081fc8529528$var$selfClearTimeout();
    const [h, g] = $5d4c081fc8529528$var$selfClearTimeout();
    const [v, w] = $5d4c081fc8529528$var$selfClearTimeout(100);
    const [p, b] = $5d4c081fc8529528$var$selfClearTimeout(100);
    const [m, y] = $5d4c081fc8529528$var$selfClearTimeout(()=>a);
    const [S, x, $] = $5d4c081fc8529528$var$createScrollbarsSetupElements(t, o.qt, $5d4c081fc8529528$var$createScrollbarsSetupEvents(n, o));
    const { Z: C, J: O, ot: z, st: T, ut: E, it: I } = o.qt;
    const { Jt: A, nn: L, Zt: H, Ut: M, Wt: P } = S;
    const { tn: D } = A;
    const { tn: R } = L;
    const styleScrollbarPosition = (t)=>{
        const { Xt: n } = t;
        const o = E && !I && $5d4c081fc8529528$var$parent(n) === O && n;
        return [
            o,
            {
                transform: o ? `translate(${$5d4c081fc8529528$var$scrollLeft(z)}px, ${$5d4c081fc8529528$var$scrollTop(z)}px)` : ""
            }
        ];
    };
    const manageScrollbarsAutoHide = (t, n)=>{
        y();
        if (t) H($5d4c081fc8529528$var$et);
        else {
            const hide = ()=>H($5d4c081fc8529528$var$et, true);
            if (a > 0 && !n) m(hide);
            else hide();
        }
    };
    const onHostMouseEnter = ()=>{
        i = c;
        i && manageScrollbarsAutoHide(true);
    };
    const k = [
        w,
        y,
        b,
        g,
        _,
        $,
        $5d4c081fc8529528$var$on(C, "pointerover", onHostMouseEnter, {
            C: true
        }),
        $5d4c081fc8529528$var$on(C, "pointerenter", onHostMouseEnter),
        $5d4c081fc8529528$var$on(C, "pointerleave", ()=>{
            i = false;
            c && manageScrollbarsAutoHide(false);
        }),
        $5d4c081fc8529528$var$on(C, "pointermove", ()=>{
            e && f(()=>{
                w();
                manageScrollbarsAutoHide(true);
                p(()=>{
                    e && manageScrollbarsAutoHide(false);
                });
            });
        }),
        $5d4c081fc8529528$var$on(T, "scroll", (t)=>{
            h(()=>{
                P(o());
                r && manageScrollbarsAutoHide(true);
                v(()=>{
                    r && !i && manageScrollbarsAutoHide(false);
                });
            });
            s(t);
            E && D(styleScrollbarPosition);
            E && R(styleScrollbarPosition);
        })
    ];
    const B = d.bind(0);
    B.qt = S;
    B.Nt = x;
    return [
        (t, s, i)=>{
            const { At: u, Lt: d, It: f, yt: _ } = i;
            const { A: h } = $5d4c081fc8529528$var$getEnvironment();
            const g = $5d4c081fc8529528$var$createOptionCheck(n, t, s);
            const v = o();
            const { Tt: w, Ct: p, bt: b } = v;
            const [m, y] = g("showNativeOverlaidScrollbars");
            const [S, x] = g("scrollbars.theme");
            const [$, C] = g("scrollbars.visibility");
            const [O, z] = g("scrollbars.autoHide");
            const [T] = g("scrollbars.autoHideDelay");
            const [E, A] = g("scrollbars.dragScroll");
            const [L, D] = g("scrollbars.clickScroll");
            const R = u || d || _;
            const k = f || C;
            const B = m && h.x && h.y;
            const setScrollbarVisibility = (t, n)=>{
                const o = "visible" === $ || "auto" === $ && "scroll" === t;
                H($5d4c081fc8529528$var$Q, o, n);
                return o;
            };
            a = T;
            if (y) H($5d4c081fc8529528$var$G, B);
            if (x) {
                H(l);
                H(S, true);
                l = S;
            }
            if (z) {
                e = "move" === O;
                c = "leave" === O;
                r = "never" !== O;
                manageScrollbarsAutoHide(!r, true);
            }
            if (A) H($5d4c081fc8529528$var$it, E);
            if (D) H($5d4c081fc8529528$var$rt, L);
            if (k) {
                const t = setScrollbarVisibility(p.x, true);
                const n = setScrollbarVisibility(p.y, false);
                const o = t && n;
                H($5d4c081fc8529528$var$tt, !o);
            }
            if (R) {
                M(v);
                P(v);
                H($5d4c081fc8529528$var$st, !w.x, true);
                H($5d4c081fc8529528$var$st, !w.y, false);
                H($5d4c081fc8529528$var$U, b && !I);
            }
        },
        B,
        $5d4c081fc8529528$var$runEachAndClear.bind(0, k)
    ];
};
const $5d4c081fc8529528$var$invokePluginInstance = (t, n, o)=>{
    if ($5d4c081fc8529528$var$isFunction(t)) t(n || void 0, o || void 0);
};
const $5d4c081fc8529528$export$d08ab3fe303a3356 = (t, n, o)=>{
    const { F: s, N: e, Y: c, j: r } = $5d4c081fc8529528$var$getEnvironment();
    const i = $5d4c081fc8529528$var$getPlugins();
    const l = $5d4c081fc8529528$var$isHTMLElement(t);
    const a = l ? t : t.target;
    const u = $5d4c081fc8529528$var$getInstance(a);
    if (n && !u) {
        let u = false;
        const validateOptions = (t)=>{
            const n = $5d4c081fc8529528$var$getPlugins()[$5d4c081fc8529528$var$vt];
            const o = n && n.O;
            return o ? o(t, true) : t;
        };
        const d = $5d4c081fc8529528$var$assignDeep({}, s(), validateOptions(n));
        const [f, _, h] = $5d4c081fc8529528$var$createEventListenerHub(o);
        const [g, v, w] = $5d4c081fc8529528$var$createStructureSetup(t, d);
        const [p, b, m] = $5d4c081fc8529528$var$createScrollbarsSetup(t, d, v, (t)=>h("scroll", [
                $,
                t
            ]));
        const update = (t, n)=>g(t, !!n);
        const y = update.bind(0, {}, true);
        const S = c(y);
        const x = r(y);
        const destroy = (t)=>{
            $5d4c081fc8529528$var$removeInstance(a);
            S();
            x();
            m();
            w();
            u = true;
            h("destroyed", [
                $,
                !!t
            ]);
            _();
        };
        const $ = {
            options (t, n) {
                if (t) {
                    const o = n ? s() : {};
                    const e = $5d4c081fc8529528$var$getOptionsDiff(d, $5d4c081fc8529528$var$assignDeep(o, validateOptions(t)));
                    if (!$5d4c081fc8529528$var$isEmptyObject(e)) {
                        $5d4c081fc8529528$var$assignDeep(d, e);
                        update(e);
                    }
                }
                return $5d4c081fc8529528$var$assignDeep({}, d);
            },
            on: f,
            off: (t, n)=>{
                t && n && _(t, n);
            },
            state () {
                const { zt: t, Tt: n, Ct: o, Et: s, K: e, St: c, bt: r } = v();
                return $5d4c081fc8529528$var$assignDeep({}, {
                    overflowEdge: t,
                    overflowAmount: n,
                    overflowStyle: o,
                    hasOverflow: s,
                    padding: e,
                    paddingAbsolute: c,
                    directionRTL: r,
                    destroyed: u
                });
            },
            elements () {
                const { W: t, Z: n, K: o, J: s, tt: e, ot: c, st: r } = v.qt;
                const { Jt: i, nn: l } = b.qt;
                const translateScrollbarStructure = (t)=>{
                    const { Ft: n, Gt: o, Xt: s } = t;
                    return {
                        scrollbar: s,
                        track: o,
                        handle: n
                    };
                };
                const translateScrollbarsSetupElement = (t)=>{
                    const { Kt: n, Qt: o } = t;
                    const s = translateScrollbarStructure(n[0]);
                    return $5d4c081fc8529528$var$assignDeep({}, s, {
                        clone: ()=>{
                            const t = translateScrollbarStructure(o());
                            p({}, true, {});
                            return t;
                        }
                    });
                };
                return $5d4c081fc8529528$var$assignDeep({}, {
                    target: t,
                    host: n,
                    padding: o || s,
                    viewport: s,
                    content: e || s,
                    scrollOffsetElement: c,
                    scrollEventElement: r,
                    scrollbarHorizontal: translateScrollbarsSetupElement(i),
                    scrollbarVertical: translateScrollbarsSetupElement(l)
                });
            },
            update: (t)=>update({}, t),
            destroy: destroy.bind(0)
        };
        v.jt((t, n, o)=>{
            p(n, o, t);
        });
        $5d4c081fc8529528$var$addInstance(a, $);
        $5d4c081fc8529528$var$each($5d4c081fc8529528$var$keys(i), (t)=>$5d4c081fc8529528$var$invokePluginInstance(i[t], 0, $));
        if ($5d4c081fc8529528$var$cancelInitialization(v.qt.it, e().cancel, !l && t.cancel)) {
            destroy(true);
            return $;
        }
        v.Nt();
        b.Nt();
        h("initialized", [
            $
        ]);
        v.jt((t, n, o)=>{
            const { vt: s, yt: e, gt: c, At: r, Lt: i, It: l, wt: a, Ot: u } = t;
            h("updated", [
                $,
                {
                    updateHints: {
                        sizeChanged: s,
                        directionChanged: e,
                        heightIntrinsicChanged: c,
                        overflowEdgeChanged: r,
                        overflowAmountChanged: i,
                        overflowStyleChanged: l,
                        contentMutation: a,
                        hostMutation: u
                    },
                    changedOptions: n,
                    force: o
                }
            ]);
        });
        $.update(true);
        return $;
    }
    return u;
};
$5d4c081fc8529528$export$d08ab3fe303a3356.plugin = (t)=>{
    $5d4c081fc8529528$var$each($5d4c081fc8529528$var$addPlugin(t), (t)=>$5d4c081fc8529528$var$invokePluginInstance(t, $5d4c081fc8529528$export$d08ab3fe303a3356));
};
$5d4c081fc8529528$export$d08ab3fe303a3356.valid = (t)=>{
    const n = t && t.elements;
    const o = $5d4c081fc8529528$var$isFunction(n) && n();
    return $5d4c081fc8529528$var$isPlainObject(o) && !!$5d4c081fc8529528$var$getInstance(o.target);
};
$5d4c081fc8529528$export$d08ab3fe303a3356.env = ()=>{
    const { k: t, A: n, I: o, B: s, V: e, L: c, X: r, U: i, N: l, q: a, F: u, G: d } = $5d4c081fc8529528$var$getEnvironment();
    return $5d4c081fc8529528$var$assignDeep({}, {
        scrollbarsSize: t,
        scrollbarsOverlaid: n,
        scrollbarsHiding: o,
        rtlScrollBehavior: s,
        flexboxGlue: e,
        cssCustomProperties: c,
        staticDefaultInitialization: r,
        staticDefaultOptions: i,
        getDefaultInitialization: l,
        setDefaultInitialization: a,
        getDefaultOptions: u,
        setDefaultOptions: d
    });
};

});



parcelRequire.register("5qJ69", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $308fffbae0d6d871$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $4QYLH = parcelRequire("4QYLH");

var $aWoIV = parcelRequire("aWoIV");

var $bnkR4 = parcelRequire("bnkR4");

var $gq6DZ = parcelRequire("gq6DZ");
function $308fffbae0d6d871$var$DetailsSummary({ children: children }) {
    const [summary, details] = Array.isArray(children) ? children : [
        children
    ];
    const [isExpanded, setIsExpanded] = (0, $jC8Vy.useState)(false);
    const [height, setHeight] = (0, $jC8Vy.useState)(0);
    const onClickHandler = (0, $jC8Vy.useCallback)(()=>{
        setIsExpanded(!isExpanded);
        setHeight(height === 0 ? "auto" : 0);
    }, [
        height,
        isExpanded
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($gq6DZ.container, isExpanded && $gq6DZ.expanded),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                role: "button",
                tabIndex: 0,
                className: $gq6DZ.summary,
                onKeyDown: (0, $bnkR4.onKeyDownHandler)({
                    Esc: ()=>{
                        setIsExpanded(false);
                        setHeight(0);
                    },
                    Enter: onClickHandler,
                    " ": onClickHandler
                }),
                onClick: onClickHandler,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aWoIV.default), {
                        className: $gq6DZ.arrow
                    }),
                    summary
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4QYLH.default), {
                animateOpacity: true,
                duration: 300,
                height: height,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $gq6DZ.details,
                    children: details
                })
            })
        ]
    });
}
var $308fffbae0d6d871$export$2e2bcd8739ae039 = $308fffbae0d6d871$var$DetailsSummary;

});
parcelRequire.register("4QYLH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $388b28168d532d32$export$2e2bcd8739ae039; });

var $jC8Vy = parcelRequire("jC8Vy");

var $5UrGx = parcelRequire("5UrGx");
var $388b28168d532d32$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
// ------------------ Helpers
function $388b28168d532d32$var$isNumber(n) {
    const number = parseFloat(n);
    return !isNaN(number) && isFinite(number);
}
function $388b28168d532d32$var$isPercentage(height) {
    // Percentage height
    return typeof height === "string" && height[height.length - 1] === "%" && $388b28168d532d32$var$isNumber(height.substring(0, height.length - 1));
}
function $388b28168d532d32$var$hideContent(element, height) {
    // Check for element?.style is added cause this would fail in tests (react-test-renderer)
    // Read more here: https://github.com/Stanko/react-animate-height/issues/17
    if (height === 0 && (element === null || element === void 0 ? void 0 : element.style)) element.style.display = "none";
}
function $388b28168d532d32$var$showContent(element, height) {
    // Check for element?.style is added cause this would fail in tests (react-test-renderer)
    // Read more here: https://github.com/Stanko/react-animate-height/issues/17
    if (height === 0 && (element === null || element === void 0 ? void 0 : element.style)) element.style.display = "";
}
const $388b28168d532d32$var$ANIMATION_STATE_CLASSES = {
    animating: "rah-animating",
    animatingUp: "rah-animating--up",
    animatingDown: "rah-animating--down",
    animatingToHeightZero: "rah-animating--to-height-zero",
    animatingToHeightAuto: "rah-animating--to-height-auto",
    animatingToHeightSpecific: "rah-animating--to-height-specific",
    static: "rah-static",
    staticHeightZero: "rah-static--height-zero",
    staticHeightAuto: "rah-static--height-auto",
    staticHeightSpecific: "rah-static--height-specific"
};
function $388b28168d532d32$var$getStaticStateClasses(animationStateClasses, height) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))({
        [animationStateClasses.static]: true,
        [animationStateClasses.staticHeightZero]: height === 0,
        [animationStateClasses.staticHeightSpecific]: height > 0,
        [animationStateClasses.staticHeightAuto]: height === "auto"
    });
}
const $388b28168d532d32$var$AnimateHeight = (_a)=>{
    var { animateOpacity: animateOpacity = false, animationStateClasses: animationStateClasses = {}, applyInlineTransitions: applyInlineTransitions = true, children: children, className: className = "", contentClassName: contentClassName, delay: userDelay = 0, duration: userDuration = 500, easing: easing = "ease", height: height, onHeightAnimationEnd: onHeightAnimationEnd, onHeightAnimationStart: onHeightAnimationStart, style: style } = _a, props = $388b28168d532d32$var$__rest(_a, [
        "animateOpacity",
        "animationStateClasses",
        "applyInlineTransitions",
        "children",
        "className",
        "contentClassName",
        "delay",
        "duration",
        "easing",
        "height",
        "onHeightAnimationEnd",
        "onHeightAnimationStart",
        "style"
    ]);
    // ------------------ Initialization
    const prevHeight = (0, $jC8Vy.useRef)(height);
    const contentElement = (0, $jC8Vy.useRef)(null);
    const animationClassesTimeoutID = (0, $jC8Vy.useRef)();
    const timeoutID = (0, $jC8Vy.useRef)();
    const stateClasses = (0, $jC8Vy.useRef)(Object.assign(Object.assign({}, $388b28168d532d32$var$ANIMATION_STATE_CLASSES), animationStateClasses));
    const isBrowser = typeof window !== "undefined";
    const prefersReducedMotion = (0, $jC8Vy.useRef)(isBrowser && window.matchMedia ? window.matchMedia("(prefers-reduced-motion)").matches : false);
    const delay = prefersReducedMotion.current ? 0 : userDelay;
    const duration = prefersReducedMotion.current ? 0 : userDuration;
    let initHeight = height;
    let initOverflow = "visible";
    if (typeof initHeight === "number") {
        // Reset negative height to 0
        initHeight = height < 0 ? 0 : height;
        initOverflow = "hidden";
    } else if ($388b28168d532d32$var$isPercentage(initHeight)) {
        // If value is string "0%" make sure we convert it to number 0
        initHeight = height === "0%" ? 0 : height;
        initOverflow = "hidden";
    }
    const [currentHeight, setCurrentHeight] = (0, $jC8Vy.useState)(initHeight);
    const [overflow, setOverflow] = (0, $jC8Vy.useState)(initOverflow);
    const [useTransitions, setUseTransitions] = (0, $jC8Vy.useState)(false);
    const [animationStateClassNames, setAnimationStateClassNames] = (0, $jC8Vy.useState)($388b28168d532d32$var$getStaticStateClasses(stateClasses.current, height));
    // ------------------ Did mount
    (0, $jC8Vy.useEffect)(()=>{
        // Hide content if height is 0 (to prevent tabbing into it)
        $388b28168d532d32$var$hideContent(contentElement.current, currentHeight);
    // This should be explicitly run only on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // ------------------ Height update
    (0, $jC8Vy.useEffect)(()=>{
        if (height !== prevHeight.current && contentElement.current) {
            $388b28168d532d32$var$showContent(contentElement.current, prevHeight.current);
            // Cache content height
            contentElement.current.style.overflow = "hidden";
            const contentHeight = contentElement.current.offsetHeight;
            contentElement.current.style.overflow = "";
            // set total animation time
            const totalDuration = duration + delay;
            let newHeight;
            let timeoutHeight;
            let timeoutOverflow = "hidden";
            let timeoutUseTransitions;
            const isCurrentHeightAuto = prevHeight.current === "auto";
            if (typeof height === "number") {
                // Reset negative height to 0
                newHeight = height < 0 ? 0 : height;
                timeoutHeight = newHeight;
            } else if ($388b28168d532d32$var$isPercentage(height)) {
                // If value is string "0%" make sure we convert it to number 0
                newHeight = height === "0%" ? 0 : height;
                timeoutHeight = newHeight;
            } else {
                // If not, animate to content height
                // and then reset to auto
                newHeight = contentHeight; // TODO solve contentHeight = 0
                timeoutHeight = "auto";
                timeoutOverflow = undefined;
            }
            if (isCurrentHeightAuto) {
                // This is the height to be animated to
                timeoutHeight = newHeight;
                // If previous height was 'auto'
                // set starting height explicitly to be able to use transition
                newHeight = contentHeight;
            }
            // Animation classes
            const newAnimationStateClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))({
                [stateClasses.current.animating]: true,
                [stateClasses.current.animatingUp]: prevHeight.current === "auto" || height < prevHeight.current,
                [stateClasses.current.animatingDown]: height === "auto" || height > prevHeight.current,
                [stateClasses.current.animatingToHeightZero]: timeoutHeight === 0,
                [stateClasses.current.animatingToHeightAuto]: timeoutHeight === "auto",
                [stateClasses.current.animatingToHeightSpecific]: timeoutHeight > 0
            });
            // Animation classes to be put after animation is complete
            const timeoutAnimationStateClasses = $388b28168d532d32$var$getStaticStateClasses(stateClasses.current, timeoutHeight);
            // Set starting height and animating classes
            // When animating from 'auto' we first need to set fixed height
            // that change should be animated
            setCurrentHeight(newHeight);
            setOverflow("hidden");
            setUseTransitions(!isCurrentHeightAuto);
            setAnimationStateClassNames(newAnimationStateClassNames);
            // Clear timeouts
            clearTimeout(timeoutID.current);
            clearTimeout(animationClassesTimeoutID.current);
            if (isCurrentHeightAuto) {
                // When animating from 'auto' we use a short timeout to start animation
                // after setting fixed height above
                timeoutUseTransitions = true;
                // Short timeout to allow rendering of the initial animation state first
                timeoutID.current = setTimeout(()=>{
                    setCurrentHeight(timeoutHeight);
                    setOverflow(timeoutOverflow);
                    setUseTransitions(timeoutUseTransitions);
                    // ANIMATION STARTS, run a callback if it exists
                    onHeightAnimationStart === null || onHeightAnimationStart === void 0 || onHeightAnimationStart(timeoutHeight);
                }, 50);
                // Set static classes and remove transitions when animation ends
                animationClassesTimeoutID.current = setTimeout(()=>{
                    setUseTransitions(false);
                    setAnimationStateClassNames(timeoutAnimationStateClasses);
                    // ANIMATION ENDS
                    // Hide content if height is 0 (to prevent tabbing into it)
                    $388b28168d532d32$var$hideContent(contentElement.current, timeoutHeight);
                    // Run a callback if it exists
                    onHeightAnimationEnd === null || onHeightAnimationEnd === void 0 || onHeightAnimationEnd(timeoutHeight);
                }, totalDuration);
            } else {
                // ANIMATION STARTS, run a callback if it exists
                onHeightAnimationStart === null || onHeightAnimationStart === void 0 || onHeightAnimationStart(newHeight);
                // Set end height, classes and remove transitions when animation is complete
                timeoutID.current = setTimeout(()=>{
                    setCurrentHeight(timeoutHeight);
                    setOverflow(timeoutOverflow);
                    setUseTransitions(false);
                    setAnimationStateClassNames(timeoutAnimationStateClasses);
                    // ANIMATION ENDS
                    // If height is auto, don't hide the content
                    // (case when element is empty, therefore height is 0)
                    if (height !== "auto") // Hide content if height is 0 (to prevent tabbing into it)
                    $388b28168d532d32$var$hideContent(contentElement.current, newHeight); // TODO solve newHeight = 0
                    // Run a callback if it exists
                    onHeightAnimationEnd === null || onHeightAnimationEnd === void 0 || onHeightAnimationEnd(newHeight);
                }, totalDuration);
            }
        }
        prevHeight.current = height;
        return ()=>{
            clearTimeout(timeoutID.current);
            clearTimeout(animationClassesTimeoutID.current);
        };
    // This should be explicitly run only on height change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        height
    ]);
    // ------------------ Render
    const componentStyle = Object.assign(Object.assign({}, style), {
        height: currentHeight,
        overflow: overflow || (style === null || style === void 0 ? void 0 : style.overflow)
    });
    if (useTransitions && applyInlineTransitions) {
        componentStyle.transition = `height ${duration}ms ${easing} ${delay}ms`;
        // Include transition passed through styles
        if (style === null || style === void 0 ? void 0 : style.transition) componentStyle.transition = `${style.transition}, ${componentStyle.transition}`;
        // Add webkit vendor prefix still used by opera, blackberry...
        componentStyle.WebkitTransition = componentStyle.transition;
    }
    const contentStyle = {};
    if (animateOpacity) {
        contentStyle.transition = `opacity ${duration}ms ${easing} ${delay}ms`;
        // Add webkit vendor prefix still used by opera, blackberry...
        contentStyle.WebkitTransition = contentStyle.transition;
        if (currentHeight === 0) contentStyle.opacity = 0;
    }
    // Check if user passed aria-hidden prop
    const hasAriaHiddenProp = typeof props["aria-hidden"] !== "undefined";
    const ariaHidden = hasAriaHiddenProp ? props["aria-hidden"] : height === 0;
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", Object.assign({}, props, {
        "aria-hidden": ariaHidden,
        className: `${animationStateClassNames} ${className}`,
        style: componentStyle
    }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        className: contentClassName,
        style: contentStyle,
        ref: contentElement
    }, children));
};
var $388b28168d532d32$export$2e2bcd8739ae039 = $388b28168d532d32$var$AnimateHeight;

});

parcelRequire.register("aWoIV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68c26966491268e6$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $68c26966491268e6$var$SvgTriangleRight = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M10.512 7.61a.5.5 0 0 1 0 .78l-3.7 2.96A.5.5 0 0 1 6 10.96V5.04a.5.5 0 0 1 .812-.39l3.7 2.96Z",
            fill: "currentColor"
        })
    });
var $68c26966491268e6$export$2e2bcd8739ae039 = $68c26966491268e6$var$SvgTriangleRight;

});

parcelRequire.register("gq6DZ", function(module, exports) {

$parcel$export(module.exports, "arrow", function () { return $bf443a685d922ef1$export$f2120bbfa5450bd2; }, function (v) { return $bf443a685d922ef1$export$f2120bbfa5450bd2 = v; });
$parcel$export(module.exports, "container", function () { return $bf443a685d922ef1$export$34e0f9847d4c02dd; }, function (v) { return $bf443a685d922ef1$export$34e0f9847d4c02dd = v; });
$parcel$export(module.exports, "details", function () { return $bf443a685d922ef1$export$41ee12f6f6f05843; }, function (v) { return $bf443a685d922ef1$export$41ee12f6f6f05843 = v; });
$parcel$export(module.exports, "expanded", function () { return $bf443a685d922ef1$export$52105d146316f63c; }, function (v) { return $bf443a685d922ef1$export$52105d146316f63c = v; });
$parcel$export(module.exports, "summary", function () { return $bf443a685d922ef1$export$9a2dbef7a17e2e58; }, function (v) { return $bf443a685d922ef1$export$9a2dbef7a17e2e58 = v; });
var $bf443a685d922ef1$export$f2120bbfa5450bd2;
var $bf443a685d922ef1$export$34e0f9847d4c02dd;
var $bf443a685d922ef1$export$41ee12f6f6f05843;
var $bf443a685d922ef1$export$52105d146316f63c;
var $bf443a685d922ef1$export$bfd64c937657f93a;
var $bf443a685d922ef1$export$4a6dd88bada4e7d2;
var $bf443a685d922ef1$export$9a2dbef7a17e2e58;
$bf443a685d922ef1$export$f2120bbfa5450bd2 = `PkjlTG_arrow`;
$bf443a685d922ef1$export$34e0f9847d4c02dd = `PkjlTG_container`;
$bf443a685d922ef1$export$41ee12f6f6f05843 = `PkjlTG_details`;
$bf443a685d922ef1$export$52105d146316f63c = `PkjlTG_expanded`;
$bf443a685d922ef1$export$bfd64c937657f93a = `PkjlTG_rotating`;
$bf443a685d922ef1$export$4a6dd88bada4e7d2 = `PkjlTG_shimmer`;
$bf443a685d922ef1$export$9a2dbef7a17e2e58 = `PkjlTG_summary`;

});


parcelRequire.register("g0vtZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58ab8bfb6e7ed575$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");

var $5UrGx = parcelRequire("5UrGx");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $e6F08 = parcelRequire("e6F08");

var $bGiNn = parcelRequire("bGiNn");

var $5TsIB = parcelRequire("5TsIB");

var $gC7hG = parcelRequire("gC7hG");

var $jheqv = parcelRequire("jheqv");

var $lTD59 = parcelRequire("lTD59");
function $58ab8bfb6e7ed575$var$NotFound({ className: className }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const theme = (0, $jheqv.default)();
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($lTD59.container, className),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5TsIB.default), {
                titleKey: "errors.page_not_found"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
                className: $lTD59.content,
                children: [
                    theme === (0, $5HVJe.Theme).Light ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $bGiNn.default), {}) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e6F08.default), {}),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $lTD59.message,
                        children: t("errors.page_not_found")
                    })
                ]
            })
        ]
    });
}
var $58ab8bfb6e7ed575$export$2e2bcd8739ae039 = $58ab8bfb6e7ed575$var$NotFound;

});
parcelRequire.register("e6F08", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03f79d0ecd7a7058$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $03f79d0ecd7a7058$var$SvgNotFoundDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 58,
                y: 74,
                width: 140,
                height: 108,
                rx: 12.191,
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "mask0_274_17728",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 58,
                y: 74,
                width: 140,
                height: 108,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                    x: 58,
                    y: 74,
                    width: 140,
                    height: 108,
                    rx: 12.191,
                    fill: "#CABEFF"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M58 86c0-6.627 5.373-12 12-12h116c6.627 0 12 5.373 12 12v8H58v-8Z",
                fill: "#7964C4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M101.687 124.686a4 4 0 0 0 0 5.657l5.657 5.657-5.657 5.657a4 4 0 0 0 5.657 5.657l5.656-5.657 5.657 5.657a4 4 0 0 0 5.657-5.657L118.657 136l5.657-5.657a4 4 0 0 0-5.657-5.657L113 130.343l-5.656-5.657a4 4 0 0 0-5.657 0ZM149.687 124.686a4 4 0 0 0 0 5.657l5.657 5.657-5.657 5.657a4 4 0 0 0 5.657 5.657l5.656-5.657 5.657 5.657a4 4 0 0 0 5.657-5.657L166.657 136l5.657-5.657a4 4 0 0 0-5.657-5.657L161 130.343l-5.656-5.657a4 4 0 0 0-5.657 0Z",
                fill: "#8167EC"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 77,
                cy: 84,
                r: 3,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 87,
                cy: 84,
                r: 3,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 97,
                cy: 84,
                r: 3,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 74,
                y: 102,
                width: 64,
                height: 4,
                rx: 2,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 74,
                y: 109,
                width: 14,
                height: 4,
                rx: 2,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 172,
                y: 109,
                width: 10,
                height: 4,
                rx: 2,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 92,
                y: 109,
                width: 74,
                height: 4,
                rx: 2,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 146,
                y: 102,
                width: 10,
                height: 4,
                rx: 2,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 159,
                y: 102,
                width: 23,
                height: 4,
                rx: 2,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "mask1_274_17728",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 25,
                y: 94,
                width: 91,
                height: 98,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    d: "M116 98.5V94H25.5v97.5H63c13.255 0 24-10.745 24-24v-40c0-8.008 6.492-14.5 14.5-14.5s14.5-6.492 14.5-14.5Z",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("g", {
                mask: "url(#mask1_274_17728)",
                stroke: "#947DFF",
                strokeWidth: 0.8,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    d: "m-4 94 4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.92 8.92 0 0 1 7.991-.002 8.917 8.917 0 0 0 7.985 0L124 94M-4 98l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.971 8.971 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.695 8.695 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.979 8.979 0 0 0 8.016.006 9.027 9.027 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.92 8.92 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 98M-4 102l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 102M-4 106l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 106M-4 110l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 110M-4 114l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 114M-4 118l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 118M-4 122l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 122M-4 126l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 126M-4 130l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 130M-4 134l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 134M-4 138l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 138M-4 142l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 142M-4 146l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 146M-4 150l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 150M-4 154l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 154M-4 158l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 158M-4 162l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 162M-4 166l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 166M-4 170l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 170M-4 174l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 174M-4 178l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 178M-4 182l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 182M-4 186l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 186M-4 190l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 190"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 203.134,
                y: 214.277,
                width: 8,
                height: 8,
                rx: 4,
                transform: "rotate(-35.523 203.134 214.277)",
                fill: "#D194D5"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 167.452,
                y: 52,
                width: 24,
                height: 24,
                rx: 2,
                transform: "rotate(50.249 167.452 52)",
                fill: "#D89BDC"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M205.914 28.209a.21.21 0 0 1 .209-.209h3.755a.21.21 0 0 1 .209.209v6.608l5.723-3.304a.209.209 0 0 1 .285.076l1.877 3.252c.058.1.024.228-.076.285l-5.724 3.305 5.724 3.304a.209.209 0 0 1 .076.285l-1.878 3.252a.208.208 0 0 1-.284.076l-5.723-3.304v6.609a.21.21 0 0 1-.209.208h-3.755a.21.21 0 0 1-.209-.208v-6.61l-5.723 3.305a.208.208 0 0 1-.285-.076l-1.878-3.252a.21.21 0 0 1 .077-.285l5.723-3.304-5.724-3.305a.209.209 0 0 1-.076-.285l1.878-3.252a.208.208 0 0 1 .284-.076l5.724 3.305v-6.61Z",
                fill: "#636685"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M95.914 193.209c0-.116.094-.209.209-.209h3.755c.115 0 .209.093.209.209v6.608l5.723-3.304a.209.209 0 0 1 .285.076l1.877 3.252c.058.1.024.228-.076.285l-5.724 3.305 5.724 3.304a.209.209 0 0 1 .076.285l-1.878 3.252a.207.207 0 0 1-.284.076l-5.723-3.304v6.609a.208.208 0 0 1-.209.208h-3.755a.208.208 0 0 1-.209-.208v-6.609l-5.723 3.304a.208.208 0 0 1-.285-.076l-1.878-3.252a.209.209 0 0 1 .077-.285l5.723-3.304-5.724-3.305a.209.209 0 0 1-.076-.285l1.877-3.252a.209.209 0 0 1 .285-.076l5.724 3.305v-6.609Z",
                fill: "#626685"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M32 53a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
                fill: "#6F6C83"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M194 190c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12Zm0-6a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z",
                fill: "#FFDDB5"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M74.003 47.362a.16.16 0 0 1 .177-.213l17.662 3.035a.16.16 0 0 1 .096.26l-11.46 13.778a.16.16 0 0 1-.273-.046l-6.202-16.814Z",
                fill: "#86BE89"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m117.818 59.546 2.108-4.005a4.525 4.525 0 0 0-1.896-6.112v0a4.525 4.525 0 0 1-1.897-6.113v0a4.525 4.525 0 0 0-1.896-6.112v0a4.525 4.525 0 0 1-1.897-6.113l2.108-4.005",
                stroke: "#839999",
                strokeWidth: 3.2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M43.867 218.692a.07.07 0 0 1 .113-.04l5.913 5.025a.07.07 0 0 1-.021.118l-7.308 2.609a.07.07 0 0 1-.092-.078l1.395-7.634Z",
                fill: "#86BE89"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 75,
                y: 220,
                width: 80,
                height: 4,
                rx: 2,
                fill: "#4E4F75"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 167,
                y: 220,
                width: 19,
                height: 4,
                rx: 2,
                fill: "#4E4F75"
            })
        ]
    });
var $03f79d0ecd7a7058$export$2e2bcd8739ae039 = $03f79d0ecd7a7058$var$SvgNotFoundDark;

});

parcelRequire.register("bGiNn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28d3ab0b36883a11$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $28d3ab0b36883a11$var$SvgNotFound = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 230,
        height: 230,
        viewBox: "0 0 230 230",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        id: "error",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M0 0h230v230H0z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 52.109,
                y: 66.484,
                width: 125.781,
                height: 97.031,
                rx: 10.952,
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "mask0_300_6026",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 52,
                y: 66,
                width: 126,
                height: 98,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                    x: 52.109,
                    y: 66.484,
                    width: 125.781,
                    height: 97.031,
                    rx: 10.952,
                    fill: "#CABEFF"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M52.11 77.266c0-5.955 4.826-10.782 10.78-10.782H167.11c5.955 0 10.782 4.827 10.782 10.782v7.187H52.109v-7.187Z",
                fill: "#5D34F2"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M91.36 112.023a3.593 3.593 0 0 0 0 5.082l5.082 5.082-5.082 5.083a3.593 3.593 0 1 0 5.082 5.082l5.083-5.082 5.082 5.082a3.594 3.594 0 0 0 5.082-5.083l-5.082-5.082 5.082-5.082a3.592 3.592 0 0 0 0-5.082 3.592 3.592 0 0 0-5.082 0l-5.082 5.082-5.083-5.082a3.593 3.593 0 0 0-5.082 0ZM134.485 112.023a3.592 3.592 0 0 0 0 5.082l5.082 5.082-5.082 5.083a3.594 3.594 0 0 0 5.082 5.082l5.083-5.082 5.082 5.082a3.594 3.594 0 0 0 5.082-5.083l-5.082-5.082 5.082-5.082a3.592 3.592 0 0 0 0-5.082 3.592 3.592 0 0 0-5.082 0l-5.082 5.082-5.083-5.082a3.592 3.592 0 0 0-5.082 0Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 69.18,
                cy: 75.469,
                r: 2.695,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 78.164,
                cy: 75.469,
                r: 2.695,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 87.148,
                cy: 75.469,
                r: 2.695,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 66.484,
                y: 91.641,
                width: 57.5,
                height: 3.594,
                rx: 1.797,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 66.484,
                y: 97.93,
                width: 12.578,
                height: 3.594,
                rx: 1.797,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 154.531,
                y: 97.93,
                width: 8.984,
                height: 3.594,
                rx: 1.797,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 82.656,
                y: 97.93,
                width: 66.484,
                height: 3.594,
                rx: 1.797,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 131.172,
                y: 91.641,
                width: 8.984,
                height: 3.594,
                rx: 1.797,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 142.852,
                y: 91.641,
                width: 20.664,
                height: 3.594,
                rx: 1.797,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "mask1_300_6026",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 22,
                y: 84,
                width: 83,
                height: 89,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    d: "M104.219 88.496v-4.043H22.91v87.598h33.692c11.908 0 21.562-9.654 21.562-21.563v-35.937c0-7.195 5.833-13.028 13.027-13.028 7.195 0 13.028-5.832 13.028-13.027Z",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("g", {
                mask: "url(#mask1_300_6026)",
                stroke: "#947DFF",
                strokeWidth: 0.719,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    d: "M-3.594 84.453 0 86.25a8.036 8.036 0 0 0 7.187 0 8.036 8.036 0 0 1 7.188 0 8.036 8.036 0 0 0 7.188 0 8.036 8.036 0 0 1 7.187 0 8.036 8.036 0 0 0 7.188 0 8.06 8.06 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.135a7.81 7.81 0 0 1 6.988.075 7.81 7.81 0 0 0 7.06.038l.079-.04a8.007 8.007 0 0 1 7.15.007 8.067 8.067 0 0 0 7.203.005 8.11 8.11 0 0 1 7.211.004 8.073 8.073 0 0 0 7.187 0 8.012 8.012 0 0 1 7.179-.002 8.01 8.01 0 0 0 7.174 0l3.59-1.798M-3.594 88.047 0 89.844a8.036 8.036 0 0 0 7.187 0 8.036 8.036 0 0 1 7.188 0 8.036 8.036 0 0 0 7.188 0 8.036 8.036 0 0 1 7.187 0 8.036 8.036 0 0 0 7.188 0 8.061 8.061 0 0 1 7.199.006 8.113 8.113 0 0 0 7.17.043l.278-.135a7.81 7.81 0 0 1 6.988.074 7.81 7.81 0 0 0 7.06.039l.079-.04a8.007 8.007 0 0 1 7.15.007 8.068 8.068 0 0 0 7.203.005 8.11 8.11 0 0 1 7.211.003 8.072 8.072 0 0 0 7.187 0 8.013 8.013 0 0 1 7.179-.002 8.01 8.01 0 0 0 7.174 0l3.59-1.797M-3.594 91.64 0 93.439a8.036 8.036 0 0 0 7.187 0 8.036 8.036 0 0 1 7.188 0 8.036 8.036 0 0 0 7.188 0 8.036 8.036 0 0 1 7.187 0 8.036 8.036 0 0 0 7.188 0 8.06 8.06 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.136a7.81 7.81 0 0 1 6.988.075 7.81 7.81 0 0 0 7.06.038l.079-.039a8.007 8.007 0 0 1 7.15.007 8.067 8.067 0 0 0 7.203.004 8.11 8.11 0 0 1 7.211.004 8.073 8.073 0 0 0 7.187 0 8.012 8.012 0 0 1 7.179-.002 8.01 8.01 0 0 0 7.174 0l3.59-1.797M-3.594 95.234 0 97.031a8.036 8.036 0 0 0 7.187 0 8.036 8.036 0 0 1 7.188 0 8.036 8.036 0 0 0 7.188 0 8.036 8.036 0 0 1 7.187 0 8.036 8.036 0 0 0 7.188 0 8.061 8.061 0 0 1 7.199.006 8.113 8.113 0 0 0 7.17.043l.278-.135a7.81 7.81 0 0 1 6.988.075 7.81 7.81 0 0 0 7.06.038l.079-.039a8.007 8.007 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.11 8.11 0 0 1 7.211.004 8.072 8.072 0 0 0 7.187 0 8.013 8.013 0 0 1 7.179-.002 8.01 8.01 0 0 0 7.174 0l3.59-1.797M-3.594 98.828 0 100.625a8.037 8.037 0 0 0 7.187 0 8.036 8.036 0 0 1 7.188 0 8.037 8.037 0 0 0 7.188 0 8.036 8.036 0 0 1 7.187 0 8.037 8.037 0 0 0 7.188 0 8.062 8.062 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.135a7.81 7.81 0 0 1 6.988.074 7.808 7.808 0 0 0 7.06.039l.079-.039a8.007 8.007 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.109 8.109 0 0 1 7.211.004 8.074 8.074 0 0 0 7.187 0 8.012 8.012 0 0 1 7.179-.002 8.015 8.015 0 0 0 7.174 0l3.59-1.798M-3.594 102.422 0 104.219a8.037 8.037 0 0 0 7.187 0 8.037 8.037 0 0 1 7.188 0 8.037 8.037 0 0 0 7.188 0 8.037 8.037 0 0 1 7.187 0 8.037 8.037 0 0 0 7.188 0 8.062 8.062 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.135a7.808 7.808 0 0 1 6.988.074 7.811 7.811 0 0 0 7.06.039l.079-.039a8.004 8.004 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.112 8.112 0 0 1 7.211.003 8.071 8.071 0 0 0 7.187.001 8.01 8.01 0 0 1 7.179-.002 8.015 8.015 0 0 0 7.174 0l3.59-1.798M-3.594 106.016 0 107.813a8.037 8.037 0 0 0 7.187 0 8.03 8.03 0 0 1 7.188 0 8.037 8.037 0 0 0 7.188 0 8.03 8.03 0 0 1 7.187 0 8.037 8.037 0 0 0 7.188 0 8.059 8.059 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.136a7.811 7.811 0 0 1 6.988.075 7.808 7.808 0 0 0 7.06.038l.079-.039a8.007 8.007 0 0 1 7.15.007 8.068 8.068 0 0 0 7.203.004 8.109 8.109 0 0 1 7.211.004 8.074 8.074 0 0 0 7.187.001 8.012 8.012 0 0 1 7.179-.003 8.008 8.008 0 0 0 7.174 0l3.59-1.797M-3.594 109.61 0 111.406a8.03 8.03 0 0 0 7.187 0 8.037 8.037 0 0 1 7.188 0 8.03 8.03 0 0 0 7.188 0 8.037 8.037 0 0 1 7.187 0 8.03 8.03 0 0 0 7.188 0 8.062 8.062 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.044l.278-.136a7.808 7.808 0 0 1 6.988.075 7.808 7.808 0 0 0 7.06.038l.079-.039a8.01 8.01 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.109 8.109 0 0 1 7.211.004 8.071 8.071 0 0 0 7.187 0 8.016 8.016 0 0 1 7.179-.002 8.008 8.008 0 0 0 7.174 0l3.59-1.797M-3.594 113.203 0 115a8.037 8.037 0 0 0 7.187 0 8.037 8.037 0 0 1 7.188 0 8.037 8.037 0 0 0 7.188 0 8.037 8.037 0 0 1 7.187 0 8.037 8.037 0 0 0 7.188 0 8.062 8.062 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.135a7.811 7.811 0 0 1 6.988.074 7.808 7.808 0 0 0 7.06.039l.079-.039a8.007 8.007 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.109 8.109 0 0 1 7.211.004 8.074 8.074 0 0 0 7.187 0 8.012 8.012 0 0 1 7.179-.002 8.015 8.015 0 0 0 7.174 0l3.59-1.798M-3.594 116.797 0 118.594a8.037 8.037 0 0 0 7.187 0 8.037 8.037 0 0 1 7.188 0 8.037 8.037 0 0 0 7.188 0 8.037 8.037 0 0 1 7.187 0 8.037 8.037 0 0 0 7.188 0 8.062 8.062 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.135a7.808 7.808 0 0 1 6.988.074 7.811 7.811 0 0 0 7.06.039l.079-.039a8.004 8.004 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.112 8.112 0 0 1 7.211.003 8.071 8.071 0 0 0 7.187.001 8.01 8.01 0 0 1 7.179-.002 8.015 8.015 0 0 0 7.174 0l3.59-1.798M-3.594 120.391 0 122.188a8.037 8.037 0 0 0 7.187 0 8.03 8.03 0 0 1 7.188 0 8.037 8.037 0 0 0 7.188 0 8.03 8.03 0 0 1 7.187 0 8.037 8.037 0 0 0 7.188 0 8.059 8.059 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.136a7.811 7.811 0 0 1 6.988.075 7.808 7.808 0 0 0 7.06.038l.079-.039a8.007 8.007 0 0 1 7.15.007 8.068 8.068 0 0 0 7.203.004 8.109 8.109 0 0 1 7.211.004 8.074 8.074 0 0 0 7.187.001 8.012 8.012 0 0 1 7.179-.003 8.008 8.008 0 0 0 7.174 0l3.59-1.797M-3.594 123.985 0 125.781a8.03 8.03 0 0 0 7.187 0 8.037 8.037 0 0 1 7.188 0 8.03 8.03 0 0 0 7.188 0 8.037 8.037 0 0 1 7.187 0 8.03 8.03 0 0 0 7.188 0 8.062 8.062 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.044l.278-.136a7.808 7.808 0 0 1 6.988.075 7.808 7.808 0 0 0 7.06.038l.079-.039a8.01 8.01 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.109 8.109 0 0 1 7.211.004 8.071 8.071 0 0 0 7.187 0 8.016 8.016 0 0 1 7.179-.002 8.008 8.008 0 0 0 7.174 0l3.59-1.797M-3.594 127.578 0 129.375a8.037 8.037 0 0 0 7.187 0 8.037 8.037 0 0 1 7.188 0 8.037 8.037 0 0 0 7.188 0 8.037 8.037 0 0 1 7.187 0 8.037 8.037 0 0 0 7.188 0 8.062 8.062 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.135a7.811 7.811 0 0 1 6.988.074 7.808 7.808 0 0 0 7.06.039l.079-.039a8.007 8.007 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.109 8.109 0 0 1 7.211.004 8.074 8.074 0 0 0 7.187 0 8.012 8.012 0 0 1 7.179-.002 8.015 8.015 0 0 0 7.174 0l3.59-1.798M-3.594 131.172 0 132.969a8.037 8.037 0 0 0 7.187 0 8.037 8.037 0 0 1 7.188 0 8.037 8.037 0 0 0 7.188 0 8.037 8.037 0 0 1 7.187 0 8.037 8.037 0 0 0 7.188 0 8.062 8.062 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.135a7.808 7.808 0 0 1 6.988.074 7.811 7.811 0 0 0 7.06.039l.079-.039a8.004 8.004 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.112 8.112 0 0 1 7.211.003 8.071 8.071 0 0 0 7.187.001 8.01 8.01 0 0 1 7.179-.002 8.015 8.015 0 0 0 7.174 0l3.59-1.798M-3.594 134.766 0 136.563a8.037 8.037 0 0 0 7.187 0 8.03 8.03 0 0 1 7.188 0 8.037 8.037 0 0 0 7.188 0 8.03 8.03 0 0 1 7.187 0 8.037 8.037 0 0 0 7.188 0 8.059 8.059 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.136a7.811 7.811 0 0 1 6.988.075 7.808 7.808 0 0 0 7.06.038l.079-.039a8.007 8.007 0 0 1 7.15.007 8.068 8.068 0 0 0 7.203.004 8.109 8.109 0 0 1 7.211.004 8.074 8.074 0 0 0 7.187.001 8.012 8.012 0 0 1 7.179-.003 8.008 8.008 0 0 0 7.174 0l3.59-1.797M-3.594 138.36 0 140.156a8.03 8.03 0 0 0 7.187 0 8.037 8.037 0 0 1 7.188 0 8.03 8.03 0 0 0 7.188 0 8.037 8.037 0 0 1 7.187 0 8.03 8.03 0 0 0 7.188 0 8.062 8.062 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.044l.278-.136a7.808 7.808 0 0 1 6.988.075 7.808 7.808 0 0 0 7.06.038l.079-.039a8.01 8.01 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.109 8.109 0 0 1 7.211.004 8.071 8.071 0 0 0 7.187 0 8.016 8.016 0 0 1 7.179-.002 8.008 8.008 0 0 0 7.174 0l3.59-1.797M-3.594 141.953 0 143.75a8.037 8.037 0 0 0 7.187 0 8.037 8.037 0 0 1 7.188 0 8.037 8.037 0 0 0 7.188 0 8.037 8.037 0 0 1 7.187 0 8.037 8.037 0 0 0 7.188 0 8.062 8.062 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.135a7.811 7.811 0 0 1 6.988.074 7.808 7.808 0 0 0 7.06.039l.079-.039a8.007 8.007 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.109 8.109 0 0 1 7.211.004 8.074 8.074 0 0 0 7.187 0 8.012 8.012 0 0 1 7.179-.002 8.015 8.015 0 0 0 7.174 0l3.59-1.798M-3.594 145.547 0 147.344a8.037 8.037 0 0 0 7.187 0 8.037 8.037 0 0 1 7.188 0 8.037 8.037 0 0 0 7.188 0 8.037 8.037 0 0 1 7.187 0 8.037 8.037 0 0 0 7.188 0 8.062 8.062 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.135a7.808 7.808 0 0 1 6.988.074 7.811 7.811 0 0 0 7.06.039l.079-.039a8.004 8.004 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.112 8.112 0 0 1 7.211.003 8.071 8.071 0 0 0 7.187.001 8.01 8.01 0 0 1 7.179-.002 8.015 8.015 0 0 0 7.174 0l3.59-1.798M-3.594 149.141 0 150.938a8.037 8.037 0 0 0 7.187 0 8.03 8.03 0 0 1 7.188 0 8.037 8.037 0 0 0 7.188 0 8.03 8.03 0 0 1 7.187 0 8.037 8.037 0 0 0 7.188 0 8.059 8.059 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.136a7.811 7.811 0 0 1 6.988.075 7.808 7.808 0 0 0 7.06.038l.079-.039a8.007 8.007 0 0 1 7.15.007 8.068 8.068 0 0 0 7.203.004 8.109 8.109 0 0 1 7.211.004 8.074 8.074 0 0 0 7.187.001 8.012 8.012 0 0 1 7.179-.003 8.008 8.008 0 0 0 7.174 0l3.59-1.797M-3.594 152.735 0 154.531a8.03 8.03 0 0 0 7.187 0 8.037 8.037 0 0 1 7.188 0 8.03 8.03 0 0 0 7.188 0 8.037 8.037 0 0 1 7.187 0 8.03 8.03 0 0 0 7.188 0 8.062 8.062 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.044l.278-.136a7.808 7.808 0 0 1 6.988.075 7.808 7.808 0 0 0 7.06.038l.079-.039a8.01 8.01 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.109 8.109 0 0 1 7.211.004 8.071 8.071 0 0 0 7.187 0 8.016 8.016 0 0 1 7.179-.002 8.008 8.008 0 0 0 7.174 0l3.59-1.797M-3.594 156.328 0 158.125a8.037 8.037 0 0 0 7.187 0 8.037 8.037 0 0 1 7.188 0 8.037 8.037 0 0 0 7.188 0 8.037 8.037 0 0 1 7.187 0 8.037 8.037 0 0 0 7.188 0 8.062 8.062 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.135a7.811 7.811 0 0 1 6.988.074 7.808 7.808 0 0 0 7.06.039l.079-.039a8.007 8.007 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.109 8.109 0 0 1 7.211.004 8.074 8.074 0 0 0 7.187 0 8.012 8.012 0 0 1 7.179-.002 8.015 8.015 0 0 0 7.174 0l3.59-1.798M-3.594 159.922 0 161.719a8.037 8.037 0 0 0 7.187 0 8.037 8.037 0 0 1 7.188 0 8.037 8.037 0 0 0 7.188 0 8.037 8.037 0 0 1 7.187 0 8.037 8.037 0 0 0 7.188 0 8.062 8.062 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.135a7.808 7.808 0 0 1 6.988.074 7.811 7.811 0 0 0 7.06.039l.079-.039a8.004 8.004 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.112 8.112 0 0 1 7.211.003 8.071 8.071 0 0 0 7.187.001 8.01 8.01 0 0 1 7.179-.002 8.015 8.015 0 0 0 7.174 0l3.59-1.798M-3.594 163.516 0 165.313a8.037 8.037 0 0 0 7.187 0 8.03 8.03 0 0 1 7.188 0 8.037 8.037 0 0 0 7.188 0 8.03 8.03 0 0 1 7.187 0 8.037 8.037 0 0 0 7.188 0 8.059 8.059 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.136a7.811 7.811 0 0 1 6.988.075 7.808 7.808 0 0 0 7.06.038l.079-.039a8.007 8.007 0 0 1 7.15.007 8.068 8.068 0 0 0 7.203.004 8.109 8.109 0 0 1 7.211.004 8.074 8.074 0 0 0 7.187.001 8.012 8.012 0 0 1 7.179-.003 8.008 8.008 0 0 0 7.174 0l3.59-1.797M-3.594 167.11 0 168.906a8.03 8.03 0 0 0 7.187 0 8.037 8.037 0 0 1 7.188 0 8.03 8.03 0 0 0 7.188 0 8.037 8.037 0 0 1 7.187 0 8.03 8.03 0 0 0 7.188 0 8.062 8.062 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.044l.278-.136a7.808 7.808 0 0 1 6.988.075 7.808 7.808 0 0 0 7.06.038l.079-.039a8.01 8.01 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.109 8.109 0 0 1 7.211.004 8.071 8.071 0 0 0 7.187 0 8.016 8.016 0 0 1 7.179-.002 8.008 8.008 0 0 0 7.174 0l3.59-1.797M-3.594 170.703 0 172.5a8.037 8.037 0 0 0 7.187 0 8.037 8.037 0 0 1 7.188 0 8.037 8.037 0 0 0 7.188 0 8.037 8.037 0 0 1 7.187 0 8.037 8.037 0 0 0 7.188 0 8.062 8.062 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.135a7.811 7.811 0 0 1 6.988.074 7.808 7.808 0 0 0 7.06.039l.079-.039a8.007 8.007 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.109 8.109 0 0 1 7.211.004 8.074 8.074 0 0 0 7.187 0 8.012 8.012 0 0 1 7.179-.002 8.015 8.015 0 0 0 7.174 0l3.59-1.798"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                transform: "rotate(-35.523 182.503 192.514)",
                fill: "#C4C4C4",
                d: "M182.503 192.514h7.188v7.188h-7.188z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                transform: "rotate(50.249 150.445 46.719)",
                fill: "#FAABFF",
                d: "M150.445 46.719h21.563v21.563h-21.563z",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M185.001 25.344c0-.104.084-.188.187-.188h3.374c.103 0 .187.084.187.188v5.938l5.143-2.97a.187.187 0 0 1 .256.069l1.687 2.922a.187.187 0 0 1-.069.256l-5.142 2.969 5.142 2.968c.089.052.12.167.068.256l-1.687 2.922a.187.187 0 0 1-.256.069l-5.142-2.97v5.938a.187.187 0 0 1-.187.188h-3.374a.187.187 0 0 1-.187-.188v-5.937l-5.142 2.969a.188.188 0 0 1-.256-.069l-1.687-2.922a.188.188 0 0 1 .069-.256l5.142-2.968-5.143-2.97a.188.188 0 0 1-.068-.255l1.687-2.922a.187.187 0 0 1 .256-.069l5.142 2.97v-5.938Z",
                fill: "#E0E3E3"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M86.173 173.586c0-.104.084-.188.187-.188h3.374c.103 0 .187.084.187.188v5.938l5.143-2.969a.188.188 0 0 1 .256.068l1.687 2.922a.187.187 0 0 1-.069.256l-5.142 2.969 5.141 2.969c.09.051.12.166.07.256l-1.688 2.921a.187.187 0 0 1-.256.069l-5.142-2.969v5.938a.187.187 0 0 1-.187.187H86.36a.187.187 0 0 1-.187-.187v-5.938l-5.142 2.969a.187.187 0 0 1-.256-.069l-1.687-2.921a.187.187 0 0 1 .069-.256l5.142-2.969-5.143-2.969a.187.187 0 0 1-.068-.256l1.687-2.922a.188.188 0 0 1 .255-.068l5.143 2.968v-5.937Z",
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M28.75 47.617a7.188 7.188 0 1 0 0-14.375 7.188 7.188 0 0 0 0 14.375Zm0-3.594a3.594 3.594 0 1 0 0-7.187 3.594 3.594 0 0 0 0 7.187Z",
                fill: "#C4C7C7"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M174.297 170.703c5.954 0 10.781-4.827 10.781-10.781 0-5.954-4.827-10.781-10.781-10.781-5.954 0-10.781 4.827-10.781 10.781 0 5.954 4.827 10.781 10.781 10.781Zm0-5.391a5.39 5.39 0 1 0 0-10.781 5.39 5.39 0 0 0 0 10.781Z",
                fill: "#FFDDB5"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M66.487 42.552a.144.144 0 0 1 .16-.191l15.867 2.727a.144.144 0 0 1 .087.233L72.305 57.7a.144.144 0 0 1-.246-.042l-5.572-15.106Z",
                fill: "#68BE6C"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m105.853 53.498 1.893-3.598a4.066 4.066 0 0 0-1.703-5.492v0a4.066 4.066 0 0 1-1.704-5.491v0a4.066 4.066 0 0 0-1.704-5.492v0a4.066 4.066 0 0 1-1.704-5.492l1.894-3.598",
                stroke: "#F7F8F8",
                strokeWidth: 2.875,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m105.853 53.498 1.893-3.598a4.066 4.066 0 0 0-1.703-5.492v0a4.066 4.066 0 0 1-1.704-5.491v0a4.066 4.066 0 0 0-1.704-5.492v0a4.066 4.066 0 0 1-1.704-5.492l1.894-3.598",
                stroke: "#78767F",
                strokeOpacity: 0.02,
                strokeWidth: 2.875,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m105.853 53.498 1.893-3.598a4.066 4.066 0 0 0-1.703-5.492v0a4.066 4.066 0 0 1-1.704-5.491v0a4.066 4.066 0 0 0-1.704-5.492v0a4.066 4.066 0 0 1-1.704-5.492l1.894-3.598",
                stroke: "#5D34F2",
                strokeOpacity: 0.11,
                strokeWidth: 2.875,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M39.411 196.482a.063.063 0 0 1 .102-.037l5.313 4.515a.062.062 0 0 1-.02.106l-6.566 2.344a.062.062 0 0 1-.082-.07l1.253-6.858Z",
                fill: "#68BE6C"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 67.383,
                y: 197.656,
                width: 71.875,
                height: 3.594,
                rx: 1.797,
                fill: "#747778"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 150.039,
                y: 197.656,
                width: 17.07,
                height: 3.594,
                rx: 1.797,
                fill: "#747778"
            })
        ]
    });
var $28d3ab0b36883a11$export$2e2bcd8739ae039 = $28d3ab0b36883a11$var$SvgNotFound;

});

parcelRequire.register("5TsIB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b403669d43e548cf$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");

var $4Mpch = parcelRequire("4Mpch");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
function $b403669d43e548cf$var$PageMeta({ titleKey: titleKey }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const keys = typeof titleKey === "string" ? [
        titleKey
    ] : titleKey;
    const title = keys.map((key)=>t(key)).join(" - ");
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4Mpch.Helmet), {
        title: title
    });
}
var $b403669d43e548cf$export$2e2bcd8739ae039 = $b403669d43e548cf$var$PageMeta;

});
parcelRequire.register("4Mpch", function(module, exports) {

$parcel$export(module.exports, "Helmet", function () { return $37af30c0ae15a94f$export$dcef8f9bb9a41431; });

var $bD9Bx = parcelRequire("bD9Bx");

var $gO8gB = parcelRequire("gO8gB");

var $k73Lj = parcelRequire("k73Lj");

var $jC8Vy = parcelRequire("jC8Vy");

var $lxACS = parcelRequire("lxACS");
var $37af30c0ae15a94f$var$ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $37af30c0ae15a94f$var$TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $37af30c0ae15a94f$var$VALID_TAG_NAMES = Object.keys($37af30c0ae15a94f$var$TAG_NAMES).map(function(name) {
    return $37af30c0ae15a94f$var$TAG_NAMES[name];
});
var $37af30c0ae15a94f$var$TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};
var $37af30c0ae15a94f$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $37af30c0ae15a94f$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $37af30c0ae15a94f$var$HTML_TAG_MAP = Object.keys($37af30c0ae15a94f$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$37af30c0ae15a94f$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $37af30c0ae15a94f$var$SELF_CLOSING_TAGS = [
    $37af30c0ae15a94f$var$TAG_NAMES.NOSCRIPT,
    $37af30c0ae15a94f$var$TAG_NAMES.SCRIPT,
    $37af30c0ae15a94f$var$TAG_NAMES.STYLE
];
var $37af30c0ae15a94f$var$HELMET_ATTRIBUTE = "data-react-helmet";
var $37af30c0ae15a94f$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $37af30c0ae15a94f$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $37af30c0ae15a94f$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $37af30c0ae15a94f$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $37af30c0ae15a94f$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $37af30c0ae15a94f$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $37af30c0ae15a94f$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $37af30c0ae15a94f$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $37af30c0ae15a94f$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $37af30c0ae15a94f$var$getInnermostProperty(propsList, $37af30c0ae15a94f$var$TAG_NAMES.TITLE);
    var innermostTemplate = $37af30c0ae15a94f$var$getInnermostProperty(propsList, $37af30c0ae15a94f$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
    var innermostDefaultTitle = $37af30c0ae15a94f$var$getInnermostProperty(propsList, $37af30c0ae15a94f$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $37af30c0ae15a94f$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $37af30c0ae15a94f$var$getInnermostProperty(propsList, $37af30c0ae15a94f$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $37af30c0ae15a94f$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $37af30c0ae15a94f$var$_extends({}, tagAttrs, current);
    }, {});
};
var $37af30c0ae15a94f$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$37af30c0ae15a94f$var$TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$37af30c0ae15a94f$var$TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $37af30c0ae15a94f$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $37af30c0ae15a94f$var$warn("Helmet: " + tagName + ' should be of type "Array". Instead found type "' + $37af30c0ae15a94f$var$_typeof(props[tagName]) + '"');
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $37af30c0ae15a94f$var$TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $37af30c0ae15a94f$var$TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $37af30c0ae15a94f$var$TAG_PROPERTIES.INNER_HTML || attributeKey === $37af30c0ae15a94f$var$TAG_PROPERTIES.CSS_TEXT || attributeKey === $37af30c0ae15a94f$var$TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, (/*@__PURE__*/$parcel$interopDefault($lxACS)))({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $37af30c0ae15a94f$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $37af30c0ae15a94f$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $37af30c0ae15a94f$var$getBaseTagFromPropsList([
            $37af30c0ae15a94f$var$TAG_PROPERTIES.HREF,
            $37af30c0ae15a94f$var$TAG_PROPERTIES.TARGET
        ], propsList),
        bodyAttributes: $37af30c0ae15a94f$var$getAttributesFromPropsList($37af30c0ae15a94f$var$ATTRIBUTE_NAMES.BODY, propsList),
        defer: $37af30c0ae15a94f$var$getInnermostProperty(propsList, $37af30c0ae15a94f$var$HELMET_PROPS.DEFER),
        encode: $37af30c0ae15a94f$var$getInnermostProperty(propsList, $37af30c0ae15a94f$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $37af30c0ae15a94f$var$getAttributesFromPropsList($37af30c0ae15a94f$var$ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $37af30c0ae15a94f$var$getTagsFromPropsList($37af30c0ae15a94f$var$TAG_NAMES.LINK, [
            $37af30c0ae15a94f$var$TAG_PROPERTIES.REL,
            $37af30c0ae15a94f$var$TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $37af30c0ae15a94f$var$getTagsFromPropsList($37af30c0ae15a94f$var$TAG_NAMES.META, [
            $37af30c0ae15a94f$var$TAG_PROPERTIES.NAME,
            $37af30c0ae15a94f$var$TAG_PROPERTIES.CHARSET,
            $37af30c0ae15a94f$var$TAG_PROPERTIES.HTTPEQUIV,
            $37af30c0ae15a94f$var$TAG_PROPERTIES.PROPERTY,
            $37af30c0ae15a94f$var$TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $37af30c0ae15a94f$var$getTagsFromPropsList($37af30c0ae15a94f$var$TAG_NAMES.NOSCRIPT, [
            $37af30c0ae15a94f$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $37af30c0ae15a94f$var$getOnChangeClientState(propsList),
        scriptTags: $37af30c0ae15a94f$var$getTagsFromPropsList($37af30c0ae15a94f$var$TAG_NAMES.SCRIPT, [
            $37af30c0ae15a94f$var$TAG_PROPERTIES.SRC,
            $37af30c0ae15a94f$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $37af30c0ae15a94f$var$getTagsFromPropsList($37af30c0ae15a94f$var$TAG_NAMES.STYLE, [
            $37af30c0ae15a94f$var$TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $37af30c0ae15a94f$var$getTitleFromPropsList(propsList),
        titleAttributes: $37af30c0ae15a94f$var$getAttributesFromPropsList($37af30c0ae15a94f$var$ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $37af30c0ae15a94f$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $37af30c0ae15a94f$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $37af30c0ae15a94f$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $37af30c0ae15a94f$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $37af30c0ae15a94f$var$rafPolyfill : $parcel$global.requestAnimationFrame || $37af30c0ae15a94f$var$rafPolyfill;
var $37af30c0ae15a94f$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $37af30c0ae15a94f$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $37af30c0ae15a94f$var$cafPolyfill;
var $37af30c0ae15a94f$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $37af30c0ae15a94f$var$_helmetCallback = null;
var $37af30c0ae15a94f$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($37af30c0ae15a94f$var$_helmetCallback) $37af30c0ae15a94f$var$cancelAnimationFrame($37af30c0ae15a94f$var$_helmetCallback);
    if (newState.defer) $37af30c0ae15a94f$var$_helmetCallback = $37af30c0ae15a94f$var$requestAnimationFrame(function() {
        $37af30c0ae15a94f$var$commitTagChanges(newState, function() {
            $37af30c0ae15a94f$var$_helmetCallback = null;
        });
    });
    else {
        $37af30c0ae15a94f$var$commitTagChanges(newState);
        $37af30c0ae15a94f$var$_helmetCallback = null;
    }
};
var $37af30c0ae15a94f$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $37af30c0ae15a94f$var$updateAttributes($37af30c0ae15a94f$var$TAG_NAMES.BODY, bodyAttributes);
    $37af30c0ae15a94f$var$updateAttributes($37af30c0ae15a94f$var$TAG_NAMES.HTML, htmlAttributes);
    $37af30c0ae15a94f$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $37af30c0ae15a94f$var$updateTags($37af30c0ae15a94f$var$TAG_NAMES.BASE, baseTag),
        linkTags: $37af30c0ae15a94f$var$updateTags($37af30c0ae15a94f$var$TAG_NAMES.LINK, linkTags),
        metaTags: $37af30c0ae15a94f$var$updateTags($37af30c0ae15a94f$var$TAG_NAMES.META, metaTags),
        noscriptTags: $37af30c0ae15a94f$var$updateTags($37af30c0ae15a94f$var$TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $37af30c0ae15a94f$var$updateTags($37af30c0ae15a94f$var$TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $37af30c0ae15a94f$var$updateTags($37af30c0ae15a94f$var$TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $37af30c0ae15a94f$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $37af30c0ae15a94f$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $37af30c0ae15a94f$var$flattenArray(title);
    $37af30c0ae15a94f$var$updateAttributes($37af30c0ae15a94f$var$TAG_NAMES.TITLE, attributes);
};
var $37af30c0ae15a94f$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($37af30c0ae15a94f$var$HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($37af30c0ae15a94f$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($37af30c0ae15a94f$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($37af30c0ae15a94f$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $37af30c0ae15a94f$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($37af30c0ae15a94f$var$TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $37af30c0ae15a94f$var$HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $37af30c0ae15a94f$var$TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $37af30c0ae15a94f$var$TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($37af30c0ae15a94f$var$HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $37af30c0ae15a94f$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + '="' + attributes[key] + '"' : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $37af30c0ae15a94f$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $37af30c0ae15a94f$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $37af30c0ae15a94f$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $37af30c0ae15a94f$var$HELMET_ATTRIBUTE + '="true" ' + attributeString + ">" + $37af30c0ae15a94f$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $37af30c0ae15a94f$var$HELMET_ATTRIBUTE + '="true">' + $37af30c0ae15a94f$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $37af30c0ae15a94f$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $37af30c0ae15a94f$var$TAG_PROPERTIES.INNER_HTML || attribute === $37af30c0ae15a94f$var$TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + '="' + $37af30c0ae15a94f$var$encodeSpecialCharacters(tag[attribute], encode) + '"';
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $37af30c0ae15a94f$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $37af30c0ae15a94f$var$HELMET_ATTRIBUTE + '="true" ' + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $37af30c0ae15a94f$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$37af30c0ae15a94f$var$REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $37af30c0ae15a94f$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$37af30c0ae15a94f$var$HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $37af30c0ae15a94f$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$37af30c0ae15a94f$var$HELMET_ATTRIBUTE] = true, _initProps);
    var props = $37af30c0ae15a94f$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement($37af30c0ae15a94f$var$TAG_NAMES.TITLE, props, title)
    ];
};
var $37af30c0ae15a94f$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$37af30c0ae15a94f$var$HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $37af30c0ae15a94f$var$REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $37af30c0ae15a94f$var$TAG_PROPERTIES.INNER_HTML || mappedAttribute === $37af30c0ae15a94f$var$TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement(type, mappedTag);
    });
};
var $37af30c0ae15a94f$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $37af30c0ae15a94f$var$TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $37af30c0ae15a94f$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $37af30c0ae15a94f$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $37af30c0ae15a94f$var$ATTRIBUTE_NAMES.BODY:
        case $37af30c0ae15a94f$var$ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $37af30c0ae15a94f$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $37af30c0ae15a94f$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $37af30c0ae15a94f$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $37af30c0ae15a94f$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $37af30c0ae15a94f$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $37af30c0ae15a94f$var$getMethodsForTag($37af30c0ae15a94f$var$TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $37af30c0ae15a94f$var$getMethodsForTag($37af30c0ae15a94f$var$ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $37af30c0ae15a94f$var$getMethodsForTag($37af30c0ae15a94f$var$ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $37af30c0ae15a94f$var$getMethodsForTag($37af30c0ae15a94f$var$TAG_NAMES.LINK, linkTags, encode),
        meta: $37af30c0ae15a94f$var$getMethodsForTag($37af30c0ae15a94f$var$TAG_NAMES.META, metaTags, encode),
        noscript: $37af30c0ae15a94f$var$getMethodsForTag($37af30c0ae15a94f$var$TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $37af30c0ae15a94f$var$getMethodsForTag($37af30c0ae15a94f$var$TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $37af30c0ae15a94f$var$getMethodsForTag($37af30c0ae15a94f$var$TAG_NAMES.STYLE, styleTags, encode),
        title: $37af30c0ae15a94f$var$getMethodsForTag($37af30c0ae15a94f$var$TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $37af30c0ae15a94f$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $37af30c0ae15a94f$var$inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $37af30c0ae15a94f$var$classCallCheck(this, HelmetWrapper);
            return $37af30c0ae15a94f$var$possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($k73Lj)))(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $37af30c0ae15a94f$var$TAG_NAMES.SCRIPT:
                case $37af30c0ae15a94f$var$TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $37af30c0ae15a94f$var$TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $37af30c0ae15a94f$var$_extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $37af30c0ae15a94f$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _babelHelpers$extends));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $37af30c0ae15a94f$var$TAG_NAMES.TITLE:
                    return $37af30c0ae15a94f$var$_extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = $37af30c0ae15a94f$var$_extends({}, newChildProps), _babelHelpers$extends2));
                case $37af30c0ae15a94f$var$TAG_NAMES.BODY:
                    return $37af30c0ae15a94f$var$_extends({}, newProps, {
                        bodyAttributes: $37af30c0ae15a94f$var$_extends({}, newChildProps)
                    });
                case $37af30c0ae15a94f$var$TAG_NAMES.HTML:
                    return $37af30c0ae15a94f$var$_extends({}, newProps, {
                        htmlAttributes: $37af30c0ae15a94f$var$_extends({}, newChildProps)
                    });
            }
            return $37af30c0ae15a94f$var$_extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = $37af30c0ae15a94f$var$_extends({}, newChildProps), _babelHelpers$extends3));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $37af30c0ae15a94f$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _babelHelpers$extends4;
                newFlattenedProps = $37af30c0ae15a94f$var$_extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $37af30c0ae15a94f$var$objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = $37af30c0ae15a94f$var$convertReactPropstoHtmlAttributes(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $37af30c0ae15a94f$var$TAG_NAMES.LINK:
                    case $37af30c0ae15a94f$var$TAG_NAMES.META:
                    case $37af30c0ae15a94f$var$TAG_NAMES.NOSCRIPT:
                    case $37af30c0ae15a94f$var$TAG_NAMES.SCRIPT:
                    case $37af30c0ae15a94f$var$TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $37af30c0ae15a94f$var$objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $37af30c0ae15a94f$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement(Component, newProps);
        };
        $37af30c0ae15a94f$var$createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set$$1(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).Component), _class.propTypes = {
        base: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).object,
        bodyAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).node
        ]),
        defaultTitle: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).string,
        defer: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).bool,
        encodeSpecialCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).bool,
        htmlAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).object,
        link: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).object),
        meta: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).object),
        noscript: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).object),
        onChangeClientState: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).func,
        script: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).object),
        style: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).object),
        title: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).string,
        titleAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).object,
        titleTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = $37af30c0ae15a94f$var$mapStateOnServer({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $37af30c0ae15a94f$var$NullComponent = function NullComponent() {
    return null;
};
var $37af30c0ae15a94f$var$HelmetSideEffects = (0, (/*@__PURE__*/$parcel$interopDefault($gO8gB)))($37af30c0ae15a94f$var$reducePropsToState, $37af30c0ae15a94f$var$handleClientStateChange, $37af30c0ae15a94f$var$mapStateOnServer)($37af30c0ae15a94f$var$NullComponent);
var $37af30c0ae15a94f$export$dcef8f9bb9a41431 = $37af30c0ae15a94f$var$Helmet($37af30c0ae15a94f$var$HelmetSideEffects);
$37af30c0ae15a94f$export$dcef8f9bb9a41431.renderStatic = $37af30c0ae15a94f$export$dcef8f9bb9a41431.rewind;
var $37af30c0ae15a94f$export$2e2bcd8739ae039 = $37af30c0ae15a94f$export$dcef8f9bb9a41431;

});
parcelRequire.register("gO8gB", function(module, exports) {
"use strict";
function $c3c7ba725e68e13b$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $jC8Vy = parcelRequire("jC8Vy");
var $c3c7ba725e68e13b$var$React__default = $c3c7ba725e68e13b$var$_interopDefault($jC8Vy);
function $c3c7ba725e68e13b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c3c7ba725e68e13b$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $c3c7ba725e68e13b$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $c3c7ba725e68e13b$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== "function") throw new Error("Expected reducePropsToState to be a function.");
    if (typeof handleStateChangeOnClient !== "function") throw new Error("Expected handleStateChangeOnClient to be a function.");
    if (typeof mapStateOnServer !== "undefined" && typeof mapStateOnServer !== "function") throw new Error("Expected mapStateOnServer to either be undefined or a function.");
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== "function") throw new Error("Expected WrappedComponent to be a React component.");
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            $c3c7ba725e68e13b$var$_inheritsLoose(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error("You may only call rewind() on the server. Call peek() to read the current state.");
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $c3c7ba725e68e13b$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($jC8Vy.PureComponent);
        $c3c7ba725e68e13b$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $c3c7ba725e68e13b$var$_defineProperty(SideEffect, "canUseDOM", $c3c7ba725e68e13b$var$canUseDOM);
        return SideEffect;
    };
}
module.exports = $c3c7ba725e68e13b$var$withSideEffect;

});

parcelRequire.register("k73Lj", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $ea476128a0559dd0$var$hasElementType = typeof Element !== "undefined";
var $ea476128a0559dd0$var$hasMap = typeof Map === "function";
var $ea476128a0559dd0$var$hasSet = typeof Set === "function";
var $ea476128a0559dd0$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $ea476128a0559dd0$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$ea476128a0559dd0$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($ea476128a0559dd0$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$ea476128a0559dd0$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($ea476128a0559dd0$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($ea476128a0559dd0$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($ea476128a0559dd0$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$ea476128a0559dd0$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $ea476128a0559dd0$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRequire.register("lxACS", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $fae91736e31a88b6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $fae91736e31a88b6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $fae91736e31a88b6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $fae91736e31a88b6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $fae91736e31a88b6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $fae91736e31a88b6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $fae91736e31a88b6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($fae91736e31a88b6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($fae91736e31a88b6$var$getOwnPropertySymbols) {
            symbols = $fae91736e31a88b6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($fae91736e31a88b6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});



parcelRequire.register("jheqv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88f4280cf843a547$export$2e2bcd8739ae039; });

var $jC8Vy = parcelRequire("jC8Vy");

var $6gkG2 = parcelRequire("6gkG2");
const $88f4280cf843a547$var$useTheme = ()=>{
    const { theme: theme } = (0, $jC8Vy.useContext)((0, $6gkG2.AppThemeContext));
    return theme;
};
var $88f4280cf843a547$export$2e2bcd8739ae039 = $88f4280cf843a547$var$useTheme;

});
parcelRequire.register("6gkG2", function(module, exports) {

$parcel$export(module.exports, "buildDefaultAppearanceMode", function () { return $0e0b0d933ea2b0e8$export$a68e920650595f8e; });
$parcel$export(module.exports, "AppThemeContext", function () { return $0e0b0d933ea2b0e8$export$d671dde48af37475; });
$parcel$export(module.exports, "AppThemeProvider", function () { return $0e0b0d933ea2b0e8$export$5dde40e32fe2bf0; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");
parcelRequire("12bMu");
var $3dBAh = parcelRequire("3dBAh");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("8Mb3E");
var $fb30i = parcelRequire("fb30i");

var $hrP0q = parcelRequire("hrP0q");

var $71C1R = parcelRequire("71C1R");
const $0e0b0d933ea2b0e8$var$darkThemeWatchMedia = window.matchMedia("(prefers-color-scheme: dark)");
const $0e0b0d933ea2b0e8$var$getThemeBySystemConfiguration = ()=>$0e0b0d933ea2b0e8$var$darkThemeWatchMedia.matches ? (0, $5HVJe.Theme).Dark : (0, $5HVJe.Theme).Light;
const $0e0b0d933ea2b0e8$export$a68e920650595f8e = ()=>(0, $3dBAh.trySafe)(()=>(0, $hrP0q.appearanceModeGuard).parse(localStorage.getItem((0, $fb30i.storageKeys).appearanceMode))) ?? (0, $hrP0q.DynamicAppearanceMode).System;
const $0e0b0d933ea2b0e8$var$defaultAppearanceMode = $0e0b0d933ea2b0e8$export$a68e920650595f8e();
const $0e0b0d933ea2b0e8$var$defaultTheme = $0e0b0d933ea2b0e8$var$defaultAppearanceMode === (0, $hrP0q.DynamicAppearanceMode).System ? $0e0b0d933ea2b0e8$var$getThemeBySystemConfiguration() : $0e0b0d933ea2b0e8$var$defaultAppearanceMode;
const $0e0b0d933ea2b0e8$export$d671dde48af37475 = /*#__PURE__*/ (0, $jC8Vy.createContext)({
    theme: $0e0b0d933ea2b0e8$var$defaultTheme,
    setAppearanceMode: (0, $3dBAh.noop),
    setThemeOverride: (0, $3dBAh.noop)
});
function $0e0b0d933ea2b0e8$export$5dde40e32fe2bf0({ children: children }) {
    const [theme, setTheme] = (0, $jC8Vy.useState)($0e0b0d933ea2b0e8$var$defaultTheme);
    const [themeOverride, setThemeOverride] = (0, $jC8Vy.useState)();
    const [mode, setMode] = (0, $jC8Vy.useState)($0e0b0d933ea2b0e8$var$defaultAppearanceMode);
    const setAppearanceMode = (mode)=>{
        setMode(mode);
        localStorage.setItem((0, $fb30i.storageKeys).appearanceMode, mode);
    };
    (0, $jC8Vy.useEffect)(()=>{
        if (themeOverride) {
            setTheme(themeOverride);
            return;
        }
        if (mode !== (0, $hrP0q.DynamicAppearanceMode).System) {
            setTheme(mode);
            return;
        }
        const changeTheme = ()=>{
            setTheme($0e0b0d933ea2b0e8$var$getThemeBySystemConfiguration());
        };
        changeTheme();
        $0e0b0d933ea2b0e8$var$darkThemeWatchMedia.addEventListener("change", changeTheme);
        return ()=>{
            $0e0b0d933ea2b0e8$var$darkThemeWatchMedia.removeEventListener("change", changeTheme);
        };
    }, [
        mode,
        themeOverride
    ]);
    // Set Theme Mode
    (0, $jC8Vy.useEffect)(()=>{
        document.body.classList.remove((0, $7oDSS.conditionalString)($71C1R.light), (0, $7oDSS.conditionalString)($71C1R.dark));
        document.body.classList.add((0, $7oDSS.conditionalString)($71C1R[theme]));
    }, [
        theme
    ]);
    const context = (0, $jC8Vy.useMemo)(()=>({
            theme: theme,
            setAppearanceMode: setAppearanceMode,
            setThemeOverride: setThemeOverride
        }), [
        theme
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsx)($0e0b0d933ea2b0e8$export$d671dde48af37475.Provider, {
        value: context,
        children: children
    });
}

});
parcelRequire.register("hrP0q", function(module, exports) {

$parcel$export(module.exports, "DynamicAppearanceMode", function () { return $335a55f8333397f7$export$203ffecb5d2b1434; });
$parcel$export(module.exports, "appearanceModeGuard", function () { return $335a55f8333397f7$export$d3dadba663a5ce54; });
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");

var $c3dK3 = parcelRequire("c3dK3");
var $335a55f8333397f7$export$203ffecb5d2b1434;
(function(DynamicAppearanceMode) {
    DynamicAppearanceMode["System"] = "system";
})($335a55f8333397f7$export$203ffecb5d2b1434 || ($335a55f8333397f7$export$203ffecb5d2b1434 = {}));
const $335a55f8333397f7$export$d3dadba663a5ce54 = (0, $c3dK3.z).nativeEnum((0, $5HVJe.Theme)).or((0, $c3dK3.z).nativeEnum($335a55f8333397f7$export$203ffecb5d2b1434));

});

parcelRequire.register("71C1R", function(module, exports) {

$parcel$export(module.exports, "dark", function () { return $51d6202e54b7d2c0$export$55ce6f3a06c59543; }, function (v) { return $51d6202e54b7d2c0$export$55ce6f3a06c59543 = v; });
$parcel$export(module.exports, "light", function () { return $51d6202e54b7d2c0$export$a43af521ac8c3202; }, function (v) { return $51d6202e54b7d2c0$export$a43af521ac8c3202 = v; });
var $51d6202e54b7d2c0$export$55ce6f3a06c59543;
var $51d6202e54b7d2c0$export$a43af521ac8c3202;
$51d6202e54b7d2c0$export$55ce6f3a06c59543 = `_2eodma_dark`;
$51d6202e54b7d2c0$export$a43af521ac8c3202 = `_2eodma_light`;

});



parcelRequire.register("lTD59", function(module, exports) {

$parcel$export(module.exports, "container", function () { return $ff0d0ce59cd87340$export$34e0f9847d4c02dd; }, function (v) { return $ff0d0ce59cd87340$export$34e0f9847d4c02dd = v; });
$parcel$export(module.exports, "content", function () { return $ff0d0ce59cd87340$export$a7db06668cad9adb; }, function (v) { return $ff0d0ce59cd87340$export$a7db06668cad9adb = v; });
$parcel$export(module.exports, "message", function () { return $ff0d0ce59cd87340$export$a8ecead220dd38a6; }, function (v) { return $ff0d0ce59cd87340$export$a8ecead220dd38a6 = v; });
var $ff0d0ce59cd87340$export$34e0f9847d4c02dd;
var $ff0d0ce59cd87340$export$a7db06668cad9adb;
var $ff0d0ce59cd87340$export$a8ecead220dd38a6;
var $ff0d0ce59cd87340$export$bfd64c937657f93a;
var $ff0d0ce59cd87340$export$4a6dd88bada4e7d2;
$ff0d0ce59cd87340$export$34e0f9847d4c02dd = `_8LEt0W_container`;
$ff0d0ce59cd87340$export$a7db06668cad9adb = `_8LEt0W_content`;
$ff0d0ce59cd87340$export$a8ecead220dd38a6 = `_8LEt0W_message`;
$ff0d0ce59cd87340$export$bfd64c937657f93a = `_8LEt0W_rotating`;
$ff0d0ce59cd87340$export$4a6dd88bada4e7d2 = `_8LEt0W_shimmer`;

});


parcelRequire.register("4F3tE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95c63e04ecd70d47$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");

var $iIAp5 = parcelRequire("iIAp5");
function $95c63e04ecd70d47$var$StepsSkeleton() {
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $C7mD2.Fragment), {
        children: Array.from({
            length: 5
        }).map((_, stepIndex)=>// eslint-disable-next-line react/no-array-index-key
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $iIAp5.step,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $iIAp5.index
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $iIAp5.wrapper,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $iIAp5.title
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $iIAp5.subtitle
                            })
                        ]
                    })
                ]
            }, stepIndex))
    });
}
var $95c63e04ecd70d47$export$2e2bcd8739ae039 = $95c63e04ecd70d47$var$StepsSkeleton;

});
parcelRequire.register("iIAp5", function(module, exports) {

$parcel$export(module.exports, "index", function () { return $da08930bde1c57b3$export$b610b8812bbcded9; }, function (v) { return $da08930bde1c57b3$export$b610b8812bbcded9 = v; });
$parcel$export(module.exports, "shimmer", function () { return $da08930bde1c57b3$export$4a6dd88bada4e7d2; }, function (v) { return $da08930bde1c57b3$export$4a6dd88bada4e7d2 = v; });
$parcel$export(module.exports, "step", function () { return $da08930bde1c57b3$export$35d34bc0ed591a92; }, function (v) { return $da08930bde1c57b3$export$35d34bc0ed591a92 = v; });
$parcel$export(module.exports, "subtitle", function () { return $da08930bde1c57b3$export$c96745152eb2740f; }, function (v) { return $da08930bde1c57b3$export$c96745152eb2740f = v; });
$parcel$export(module.exports, "title", function () { return $da08930bde1c57b3$export$fb184b623420d9be; }, function (v) { return $da08930bde1c57b3$export$fb184b623420d9be = v; });
$parcel$export(module.exports, "wrapper", function () { return $da08930bde1c57b3$export$cc74dcc53cfce4eb; }, function (v) { return $da08930bde1c57b3$export$cc74dcc53cfce4eb = v; });
var $da08930bde1c57b3$export$b610b8812bbcded9;
var $da08930bde1c57b3$export$bfd64c937657f93a;
var $da08930bde1c57b3$export$4a6dd88bada4e7d2;
var $da08930bde1c57b3$export$35d34bc0ed591a92;
var $da08930bde1c57b3$export$c96745152eb2740f;
var $da08930bde1c57b3$export$fb184b623420d9be;
var $da08930bde1c57b3$export$cc74dcc53cfce4eb;
$da08930bde1c57b3$export$b610b8812bbcded9 = `PpHBxa_index`;
$da08930bde1c57b3$export$bfd64c937657f93a = `PpHBxa_rotating`;
$da08930bde1c57b3$export$4a6dd88bada4e7d2 = `PpHBxa_shimmer`;
$da08930bde1c57b3$export$4a6dd88bada4e7d2;
$da08930bde1c57b3$export$35d34bc0ed591a92 = `PpHBxa_step`;
$da08930bde1c57b3$export$c96745152eb2740f = `PpHBxa_subtitle`;
$da08930bde1c57b3$export$fb184b623420d9be = `PpHBxa_title`;
$da08930bde1c57b3$export$cc74dcc53cfce4eb = `PpHBxa_wrapper`;

});


parcelRequire.register("2DbJo", function(module, exports) {

$parcel$export(module.exports, "actionBar", function () { return $1ea852db2f3a10c0$export$795623e8105ba10a; }, function (v) { return $1ea852db2f3a10c0$export$795623e8105ba10a = v; });
$parcel$export(module.exports, "content", function () { return $1ea852db2f3a10c0$export$a7db06668cad9adb; }, function (v) { return $1ea852db2f3a10c0$export$a7db06668cad9adb = v; });
$parcel$export(module.exports, "layout", function () { return $1ea852db2f3a10c0$export$b3219800bda33a1f; }, function (v) { return $1ea852db2f3a10c0$export$b3219800bda33a1f = v; });
$parcel$export(module.exports, "notFound", function () { return $1ea852db2f3a10c0$export$a33e918cb4258370; }, function (v) { return $1ea852db2f3a10c0$export$a33e918cb4258370 = v; });
var $1ea852db2f3a10c0$export$795623e8105ba10a;
var $1ea852db2f3a10c0$export$a7db06668cad9adb;
var $1ea852db2f3a10c0$export$b3219800bda33a1f;
var $1ea852db2f3a10c0$export$a33e918cb4258370;
var $1ea852db2f3a10c0$export$bfd64c937657f93a;
var $1ea852db2f3a10c0$export$4a6dd88bada4e7d2;
$1ea852db2f3a10c0$export$795623e8105ba10a = `j1GCcq_actionBar`;
$1ea852db2f3a10c0$export$a7db06668cad9adb = `j1GCcq_content`;
$1ea852db2f3a10c0$export$b3219800bda33a1f = `j1GCcq_layout`;
$1ea852db2f3a10c0$export$a33e918cb4258370 = `j1GCcq_notFound`;
$1ea852db2f3a10c0$export$bfd64c937657f93a = `j1GCcq_rotating`;
$1ea852db2f3a10c0$export$4a6dd88bada4e7d2 = `j1GCcq_shimmer`;

});


parcelRequire.register("lWGA3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d91099566d54c98b$export$2e2bcd8739ae039; });
parcelRequire("cuPVN");
var $3zL0M = parcelRequire("3zL0M");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");

var $voszV = parcelRequire("voszV");

var $3rVvj = parcelRequire("3rVvj");

var $8TpMk = parcelRequire("8TpMk");

var $7kooT = parcelRequire("7kooT");
const $d91099566d54c98b$var$useCustomDomain = (autoSync = false)=>{
    const { data: data, error: error, mutate: mutate } = (0, $voszV.default)((0, $8TpMk.isCloud) && "api/domains", (0, $7oDSS.conditional)(autoSync && {
        refreshInterval: (0, $3rVvj.customDomainSyncInterval) * 1000
    }));
    const isLoading = !data && !error;
    /**
   * Note: we can only create a custom domain, and we don't have a default id for it, so the first element of the array is the custom domain.
   */ const customDomain = (0, $jC8Vy.useMemo)(()=>data?.[0], [
        data
    ]);
    const mutateDomain = (0, $jC8Vy.useCallback)((domain)=>{
        mutate(domain ? [
            domain
        ] : undefined);
    }, [
        mutate
    ]);
    const applyDomain = (0, $jC8Vy.useCallback)((url)=>{
        if (customDomain?.status !== (0, $3zL0M.DomainStatus).Active || !(0, $7kooT.isAbsoluteUrl)(url)) return url;
        return url.replace(new URL(url).host, customDomain.domain);
    }, [
        customDomain
    ]);
    return {
        data: customDomain,
        isLoading: isLoading,
        mutate: mutateDomain,
        applyDomain: applyDomain
    };
};
var $d91099566d54c98b$export$2e2bcd8739ae039 = $d91099566d54c98b$var$useCustomDomain;

});
parcelRequire.register("3rVvj", function(module, exports) {

$parcel$export(module.exports, "customDomainSyncInterval", function () { return $7ba0464c95e5e758$export$6358f99c73b6b14e; });
const $7ba0464c95e5e758$export$6358f99c73b6b14e = 10; // In seconds

});


parcelRequire.register("byEIK", function(module, exports) {

$parcel$export(module.exports, "openIdProviderConfigPath", function () { return $58f83d4c8930a069$export$e42f7220a2289cdf; });
const $58f83d4c8930a069$export$e42f7220a2289cdf = "oidc/.well-known/openid-configuration";

});

parcelRequire.register("kMkzL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1637afca2a64471a$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $aqmjm = parcelRequire("aqmjm");

var $aauWp = parcelRequire("aauWp");

var $a92nZ = parcelRequire("a92nZ");
function $1637afca2a64471a$var$MultiTextInputField({ title: title, isRequired: isRequired, tip: tip, formFieldClassName: formFieldClassName, value: value, ...rest }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
        title: title,
        isRequired: isRequired,
        tip: tip,
        className: formFieldClassName,
        headlineClassName: (0, $7oDSS.conditional)(value && value.length > 1 && $a92nZ.headlineWithMultiInputs),
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aauWp.default), {
            title: title,
            value: value,
            ...rest
        })
    });
}
var $1637afca2a64471a$export$2e2bcd8739ae039 = $1637afca2a64471a$var$MultiTextInputField;

});
parcelRequire.register("aauWp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $166b0d47666d1d02$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $kezPv = parcelRequire("kezPv");

var $jyqwk = parcelRequire("jyqwk");

var $jGWQ4 = parcelRequire("jGWQ4");

var $dL4NZ = parcelRequire("dL4NZ");

var $75SRw = parcelRequire("75SRw");

var $fmHmG = parcelRequire("fmHmG");

var $3oS2s = parcelRequire("3oS2s");
function $166b0d47666d1d02$var$MultiTextInput({ title: title, value: value, onChange: onChange, onKeyPress: onKeyPress, error: error, placeholder: placeholder, className: className }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [deleteFieldIndex, setDeleteFieldIndex] = (0, $jC8Vy.useState)();
    const fields = (0, $jC8Vy.useMemo)(()=>{
        if (!value?.length) return [
            ""
        ];
        return value;
    }, [
        value
    ]);
    const handleAdd = ()=>{
        onChange([
            ...fields,
            ""
        ]);
    };
    const handleRemove = (index)=>{
        onChange(fields.filter((_, i)=>i !== index));
    };
    const handleInputChange = (inputValue, index)=>{
        onChange(fields.map((fieldValue, i)=>i === index ? inputValue : fieldValue));
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($3oS2s.multilineInput, className),
        children: [
            fields.map((fieldValue, fieldIndex)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: (0, $7oDSS.conditional)(fields.length > 1 && fieldIndex === 0 && $3oS2s.firstFieldWithMultiInputs),
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                            className: $3oS2s.deletableInput,
                            children: [
                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                    error: Boolean(error?.inputs?.[fieldIndex] ?? (fieldIndex === 0 && error?.required)),
                                    value: fieldValue,
                                    placeholder: placeholder,
                                    onChange: ({ currentTarget: { value: value } })=>{
                                        handleInputChange(value, fieldIndex);
                                    },
                                    onKeyPress: onKeyPress
                                }),
                                fieldIndex > 0 && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                                    onClick: ()=>{
                                        if (fieldValue.trim().length === 0) handleRemove(fieldIndex);
                                        else setDeleteFieldIndex(fieldIndex);
                                    },
                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jyqwk.default), {
                                        className: $3oS2s.minusIcon
                                    })
                                })
                            ]
                        }),
                        fieldIndex === 0 && error?.required && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $3oS2s.error,
                            children: error.required
                        }),
                        error?.inputs?.[fieldIndex] && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $3oS2s.error,
                            children: error.inputs[fieldIndex]
                        })
                    ]
                }, fieldIndex)),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                size: "small",
                type: "text",
                title: "general.add_another",
                className: $3oS2s.addAnother,
                icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $kezPv.default), {}),
                onClick: handleAdd
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dL4NZ.default), {
                isOpen: deleteFieldIndex !== undefined,
                confirmButtonText: "general.delete",
                onCancel: ()=>{
                    setDeleteFieldIndex(undefined);
                },
                onConfirm: ()=>{
                    if (deleteFieldIndex !== undefined) {
                        handleRemove(deleteFieldIndex);
                        setDeleteFieldIndex(undefined);
                    }
                },
                children: t("general.deletion_confirmation", {
                    title: t(title)
                })
            })
        ]
    });
}
var $166b0d47666d1d02$export$2e2bcd8739ae039 = $166b0d47666d1d02$var$MultiTextInput;

});
parcelRequire.register("kezPv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3aee6b72992138ff$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $3aee6b72992138ff$var$SvgCirclePlus = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M8 1.333a6.667 6.667 0 1 0 0 13.334A6.667 6.667 0 0 0 8 1.333Zm0 12A5.333 5.333 0 1 1 8 2.668a5.333 5.333 0 0 1 0 10.665Zm2.667-6h-2v-2a.667.667 0 0 0-1.334 0v2h-2a.667.667 0 0 0 0 1.334h2v2a.667.667 0 1 0 1.334 0v-2h2a.667.667 0 1 0 0-1.334Z",
            fill: "currentColor"
        })
    });
var $3aee6b72992138ff$export$2e2bcd8739ae039 = $3aee6b72992138ff$var$SvgCirclePlus;

});

parcelRequire.register("jyqwk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69e48a44598ea5e8$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $69e48a44598ea5e8$var$SvgMinus = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M10 1.667a8.333 8.333 0 1 0 0 16.666 8.333 8.333 0 0 0 0-16.666Zm0 15a6.666 6.666 0 1 1 0-13.333 6.666 6.666 0 0 1 0 13.333Zm3.333-7.5H6.667a.833.833 0 1 0 0 1.666h6.666a.834.834 0 0 0 0-1.666Z",
            fill: "currentColor"
        })
    });
var $69e48a44598ea5e8$export$2e2bcd8739ae039 = $69e48a44598ea5e8$var$SvgMinus;

});

parcelRequire.register("fmHmG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $667c3456394604a9$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $fzDoK = parcelRequire("fzDoK");

var $cJEhq = parcelRequire("cJEhq");

var $75SRw = parcelRequire("75SRw");

var $47mar = parcelRequire("47mar");
function $667c3456394604a9$var$TextInput({ error: error, icon: icon, suffix: suffix, alwaysShowSuffix: alwaysShowSuffix = false, disabled: disabled, className: className, readOnly: readOnly, type: type = "text", isConfidential: isConfidential = false, inputContainerClassName: inputContainerClassName, ...rest }, reference) {
    const innerRef = (0, $jC8Vy.useRef)(null);
    const [isContentHidden, setIsContentHidden] = (0, $jC8Vy.useState)(true);
    const toggleHiddenContent = ()=>{
        setIsContentHidden((previous)=>!previous);
    };
    const suffixIcon = isConfidential && type === "text" ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
        onClick: toggleHiddenContent,
        children: isContentHidden ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fzDoK.default), {}) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cJEhq.default), {})
    }) : suffix;
    (0, $jC8Vy.useImperativeHandle)(reference, ()=>innerRef.current);
    (0, $jC8Vy.useEffect)(()=>{
        if (type !== "number") return;
        const input = innerRef.current;
        if (!input) return;
        const handleWheel = (event)=>{
            event.preventDefault();
        };
        input.addEventListener("wheel", handleWheel, {
            passive: false
        });
        return ()=>{
            input.removeEventListener("wheel", handleWheel);
        };
    }, [
        type
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($47mar.container, Boolean(error) && $47mar.error, isConfidential && isContentHidden && type === "text" && $47mar.hideTextContainerContent, icon && $47mar.withIcon, disabled && $47mar.disabled, readOnly && $47mar.readOnly, inputContainerClassName),
                children: [
                    icon && /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                        className: $47mar.icon,
                        children: icon
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("input", {
                        type: type,
                        ...rest,
                        ref: innerRef,
                        disabled: disabled,
                        readOnly: readOnly
                    }),
                    suffixIcon && /*#__PURE__*/ (0, $jC8Vy.cloneElement)(suffixIcon, {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))(// Handle by classNames
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                        suffixIcon.props.className, $47mar.suffix, // The view/hide content toggle should always be visible if this is a confidential input
                        (isConfidential || alwaysShowSuffix) && $47mar.visible)
                    })
                ]
            }),
            Boolean(error) && typeof error !== "boolean" && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $47mar.errorMessage,
                children: error
            })
        ]
    });
}
var $667c3456394604a9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $jC8Vy.forwardRef)($667c3456394604a9$var$TextInput);

});
parcelRequire.register("47mar", function(module, exports) {

$parcel$export(module.exports, "container", function () { return $2ff902e11dd97fdf$export$34e0f9847d4c02dd; }, function (v) { return $2ff902e11dd97fdf$export$34e0f9847d4c02dd = v; });
$parcel$export(module.exports, "disabled", function () { return $2ff902e11dd97fdf$export$683472f6198a076e; }, function (v) { return $2ff902e11dd97fdf$export$683472f6198a076e = v; });
$parcel$export(module.exports, "error", function () { return $2ff902e11dd97fdf$export$a3bc9b8ed74fc; }, function (v) { return $2ff902e11dd97fdf$export$a3bc9b8ed74fc = v; });
$parcel$export(module.exports, "errorMessage", function () { return $2ff902e11dd97fdf$export$493b5823483d2c4e; }, function (v) { return $2ff902e11dd97fdf$export$493b5823483d2c4e = v; });
$parcel$export(module.exports, "hideTextContainerContent", function () { return $2ff902e11dd97fdf$export$acecdc67b371cf39; }, function (v) { return $2ff902e11dd97fdf$export$acecdc67b371cf39 = v; });
$parcel$export(module.exports, "icon", function () { return $2ff902e11dd97fdf$export$1ca1ec8b29a4ce27; }, function (v) { return $2ff902e11dd97fdf$export$1ca1ec8b29a4ce27 = v; });
$parcel$export(module.exports, "readOnly", function () { return $2ff902e11dd97fdf$export$b2cbc93d4da94977; }, function (v) { return $2ff902e11dd97fdf$export$b2cbc93d4da94977 = v; });
$parcel$export(module.exports, "suffix", function () { return $2ff902e11dd97fdf$export$559d1204393b53b9; }, function (v) { return $2ff902e11dd97fdf$export$559d1204393b53b9 = v; });
$parcel$export(module.exports, "visible", function () { return $2ff902e11dd97fdf$export$664c6d24e3175067; }, function (v) { return $2ff902e11dd97fdf$export$664c6d24e3175067 = v; });
$parcel$export(module.exports, "withIcon", function () { return $2ff902e11dd97fdf$export$5146850fc0ce88d1; }, function (v) { return $2ff902e11dd97fdf$export$5146850fc0ce88d1 = v; });
var $2ff902e11dd97fdf$export$34e0f9847d4c02dd;
var $2ff902e11dd97fdf$export$683472f6198a076e;
var $2ff902e11dd97fdf$export$a3bc9b8ed74fc;
var $2ff902e11dd97fdf$export$493b5823483d2c4e;
var $2ff902e11dd97fdf$export$acecdc67b371cf39;
var $2ff902e11dd97fdf$export$1ca1ec8b29a4ce27;
var $2ff902e11dd97fdf$export$b2cbc93d4da94977;
var $2ff902e11dd97fdf$export$bfd64c937657f93a;
var $2ff902e11dd97fdf$export$4a6dd88bada4e7d2;
var $2ff902e11dd97fdf$export$559d1204393b53b9;
var $2ff902e11dd97fdf$export$664c6d24e3175067;
var $2ff902e11dd97fdf$export$5146850fc0ce88d1;
$2ff902e11dd97fdf$export$34e0f9847d4c02dd = `NBDOhG_container`;
$2ff902e11dd97fdf$export$683472f6198a076e = `NBDOhG_disabled`;
$2ff902e11dd97fdf$export$a3bc9b8ed74fc = `NBDOhG_error`;
$2ff902e11dd97fdf$export$493b5823483d2c4e = `NBDOhG_errorMessage`;
$2ff902e11dd97fdf$export$acecdc67b371cf39 = `NBDOhG_hideTextContainerContent`;
$2ff902e11dd97fdf$export$1ca1ec8b29a4ce27 = `NBDOhG_icon`;
$2ff902e11dd97fdf$export$b2cbc93d4da94977 = `NBDOhG_readOnly`;
$2ff902e11dd97fdf$export$bfd64c937657f93a = `NBDOhG_rotating`;
$2ff902e11dd97fdf$export$4a6dd88bada4e7d2 = `NBDOhG_shimmer`;
$2ff902e11dd97fdf$export$559d1204393b53b9 = `NBDOhG_suffix`;
$2ff902e11dd97fdf$export$664c6d24e3175067 = `NBDOhG_visible`;
$2ff902e11dd97fdf$export$5146850fc0ce88d1 = `NBDOhG_withIcon`;

});


parcelRequire.register("3oS2s", function(module, exports) {

$parcel$export(module.exports, "addAnother", function () { return $279d87f36c964018$export$ae5f3242c350d062; }, function (v) { return $279d87f36c964018$export$ae5f3242c350d062 = v; });
$parcel$export(module.exports, "deletableInput", function () { return $279d87f36c964018$export$3713a8a23d31e5bc; }, function (v) { return $279d87f36c964018$export$3713a8a23d31e5bc = v; });
$parcel$export(module.exports, "error", function () { return $279d87f36c964018$export$a3bc9b8ed74fc; }, function (v) { return $279d87f36c964018$export$a3bc9b8ed74fc = v; });
$parcel$export(module.exports, "firstFieldWithMultiInputs", function () { return $279d87f36c964018$export$79c35e03af0143d8; }, function (v) { return $279d87f36c964018$export$79c35e03af0143d8 = v; });
$parcel$export(module.exports, "minusIcon", function () { return $279d87f36c964018$export$d46bbadf149c347; }, function (v) { return $279d87f36c964018$export$d46bbadf149c347 = v; });
$parcel$export(module.exports, "multilineInput", function () { return $279d87f36c964018$export$d3195581be2dd5a6; }, function (v) { return $279d87f36c964018$export$d3195581be2dd5a6 = v; });
var $279d87f36c964018$export$ae5f3242c350d062;
var $279d87f36c964018$export$3713a8a23d31e5bc;
var $279d87f36c964018$export$a3bc9b8ed74fc;
var $279d87f36c964018$export$79c35e03af0143d8;
var $279d87f36c964018$export$d46bbadf149c347;
var $279d87f36c964018$export$d3195581be2dd5a6;
var $279d87f36c964018$export$bfd64c937657f93a;
var $279d87f36c964018$export$4a6dd88bada4e7d2;
$279d87f36c964018$export$ae5f3242c350d062 = `SGS0fW_addAnother`;
$279d87f36c964018$export$3713a8a23d31e5bc = `SGS0fW_deletableInput`;
$279d87f36c964018$export$a3bc9b8ed74fc = `SGS0fW_error`;
$279d87f36c964018$export$79c35e03af0143d8 = `SGS0fW_firstFieldWithMultiInputs`;
$279d87f36c964018$export$d46bbadf149c347 = `SGS0fW_minusIcon`;
$279d87f36c964018$export$d3195581be2dd5a6 = `SGS0fW_multilineInput`;
$279d87f36c964018$export$bfd64c937657f93a = `SGS0fW_rotating`;
$279d87f36c964018$export$4a6dd88bada4e7d2 = `SGS0fW_shimmer`;

});


parcelRequire.register("a92nZ", function(module, exports) {

$parcel$export(module.exports, "headlineWithMultiInputs", function () { return $762c986b5bb9e114$export$798dd543c49d0534; }, function (v) { return $762c986b5bb9e114$export$798dd543c49d0534 = v; });
var $762c986b5bb9e114$export$798dd543c49d0534;
var $762c986b5bb9e114$export$bfd64c937657f93a;
var $762c986b5bb9e114$export$4a6dd88bada4e7d2;
$762c986b5bb9e114$export$798dd543c49d0534 = `_5hpe_G_headlineWithMultiInputs`;
$762c986b5bb9e114$export$bfd64c937657f93a = `_5hpe_G_rotating`;
$762c986b5bb9e114$export$4a6dd88bada4e7d2 = `_5hpe_G_shimmer`;

});


parcelRequire.register("5n0rM", function(module, exports) {

$parcel$export(module.exports, "createValidatorForRhf", function () { return $c3a5a79343a7c39b$export$92194fc0a16d24c0; });
$parcel$export(module.exports, "convertRhfErrorMessage", function () { return $c3a5a79343a7c39b$export$be179235d87a3746; });

var $4TsiV = parcelRequire("4TsiV");

var $3RCsa = parcelRequire("3RCsa");

var $fVyJK = parcelRequire("fVyJK");
const $c3a5a79343a7c39b$var$validate = (value, rule)=>{
    if (!rule) return;
    if (!value?.filter(Boolean).length) {
        if (!rule.required) return;
        return {
            required: rule.required
        };
    }
    if (rule.pattern) {
        const { verify: verify, message: message } = rule.pattern;
        const inputErrors = Object.fromEntries(value.map((element, index)=>{
            return [
                index,
                verify(element) ? undefined : message
            ];
        }));
        if (Object.values(inputErrors).some(Boolean)) return {
            inputs: inputErrors
        };
    }
};
const $c3a5a79343a7c39b$export$92194fc0a16d24c0 = (rule)=>(value)=>{
        const error = $c3a5a79343a7c39b$var$validate(value, rule);
        if (error) return JSON.stringify(error);
        return true;
    };
const $c3a5a79343a7c39b$export$be179235d87a3746 = (errorMessage)=>{
    if (!errorMessage) return;
    const jsonParseResult = (0, $3RCsa.safeParseJson)(errorMessage);
    if (!jsonParseResult.success) throw new Error((0, $4TsiV.t)("admin_console.errors.invalid_error_message_format"));
    const result = (0, $fVyJK.multiTextInputErrorGuard).safeParse(jsonParseResult.data);
    if (!result.success) throw new Error((0, $4TsiV.t)("admin_console.errors.invalid_error_message_format"));
    return result.data;
};

});
parcelRequire.register("4TsiV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3902411e290848f7$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "t", function () { return $3902411e290848f7$export$625550452a3fa3ec; });

var $2oi0t = parcelRequire("2oi0t");

var $1IOZg = parcelRequire("1IOZg");

var $lcCFm = parcelRequire("lcCFm");

var $jnNcH = parcelRequire("jnNcH");

var $7RTSE = parcelRequire("7RTSE");

var $cYgL8 = parcelRequire("cYgL8");

var $6DH0b = parcelRequire("6DH0b");

var $azUPN = parcelRequire("azUPN");

var $5B9iO = parcelRequire("5B9iO");
function $3902411e290848f7$var$ownKeys$6(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3902411e290848f7$var$_objectSpread$6(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3902411e290848f7$var$ownKeys$6(Object(source), !0).forEach(function(key) {
            (0, $azUPN.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3902411e290848f7$var$ownKeys$6(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $3902411e290848f7$var$consoleLogger = {
    type: "logger",
    log: function log(args) {
        this.output("log", args);
    },
    warn: function warn(args) {
        this.output("warn", args);
    },
    error: function error(args) {
        this.output("error", args);
    },
    output: function output(type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
var $3902411e290848f7$var$Logger = function() {
    function Logger(concreteLogger) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $1IOZg.default)(this, Logger);
        this.init(concreteLogger, options);
    }
    (0, $lcCFm.default)(Logger, [
        {
            key: "init",
            value: function init(concreteLogger) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                this.prefix = options.prefix || "i18next:";
                this.logger = concreteLogger || $3902411e290848f7$var$consoleLogger;
                this.options = options;
                this.debug = options.debug;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(bool) {
                this.debug = bool;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return this.forward(args, "log", "", true);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return this.forward(args, "warn", "", true);
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                return this.forward(args, "error", "");
            }
        },
        {
            key: "deprecate",
            value: function deprecate() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
            }
        },
        {
            key: "forward",
            value: function forward(args, lvl, prefix, debugOnly) {
                if (debugOnly && !this.debug) return null;
                if (typeof args[0] === "string") args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
                return this.logger[lvl](args);
            }
        },
        {
            key: "create",
            value: function create(moduleName) {
                return new Logger(this.logger, $3902411e290848f7$var$_objectSpread$6($3902411e290848f7$var$_objectSpread$6({}, {
                    prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
                }), this.options));
            }
        },
        {
            key: "clone",
            value: function clone(options) {
                options = options || this.options;
                options.prefix = options.prefix || this.prefix;
                return new Logger(this.logger, options);
            }
        }
    ]);
    return Logger;
}();
var $3902411e290848f7$var$baseLogger = new $3902411e290848f7$var$Logger();
var $3902411e290848f7$var$EventEmitter = function() {
    function EventEmitter() {
        (0, $1IOZg.default)(this, EventEmitter);
        this.observers = {};
    }
    (0, $lcCFm.default)(EventEmitter, [
        {
            key: "on",
            value: function on(events, listener) {
                var _this = this;
                events.split(" ").forEach(function(event) {
                    _this.observers[event] = _this.observers[event] || [];
                    _this.observers[event].push(listener);
                });
                return this;
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                if (!this.observers[event]) return;
                if (!listener) {
                    delete this.observers[event];
                    return;
                }
                this.observers[event] = this.observers[event].filter(function(l) {
                    return l !== listener;
                });
            }
        },
        {
            key: "emit",
            value: function emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (this.observers[event]) {
                    var cloned = [].concat(this.observers[event]);
                    cloned.forEach(function(observer) {
                        observer.apply(void 0, args);
                    });
                }
                if (this.observers["*"]) {
                    var _cloned = [].concat(this.observers["*"]);
                    _cloned.forEach(function(observer) {
                        observer.apply(observer, [
                            event
                        ].concat(args));
                    });
                }
            }
        }
    ]);
    return EventEmitter;
}();
function $3902411e290848f7$var$defer() {
    var res;
    var rej;
    var promise = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $3902411e290848f7$var$makeString(object) {
    if (object == null) return "";
    return "" + object;
}
function $3902411e290848f7$var$copy(a, s, t) {
    a.forEach(function(m) {
        if (s[m]) t[m] = s[m];
    });
}
function $3902411e290848f7$var$getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf("###") > -1 ? key.replace(/###/g, ".") : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === "string";
    }
    var stack = typeof path !== "string" ? [].concat(path) : path.split(".");
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        var key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function $3902411e290848f7$var$setPath(object, path, newValue) {
    var _getLastOfPath = $3902411e290848f7$var$getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    obj[k] = newValue;
}
function $3902411e290848f7$var$pushPath(object, path, newValue, concat) {
    var _getLastOfPath2 = $3902411e290848f7$var$getLastOfPath(object, path, Object), obj = _getLastOfPath2.obj, k = _getLastOfPath2.k;
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function $3902411e290848f7$var$getPath(object, path) {
    var _getLastOfPath3 = $3902411e290848f7$var$getLastOfPath(object, path), obj = _getLastOfPath3.obj, k = _getLastOfPath3.k;
    if (!obj) return undefined;
    return obj[k];
}
function $3902411e290848f7$var$getPathWithDefaults(data, defaultData, key) {
    var value = $3902411e290848f7$var$getPath(data, key);
    if (value !== undefined) return value;
    return $3902411e290848f7$var$getPath(defaultData, key);
}
function $3902411e290848f7$var$deepExtend(target, source, overwrite) {
    for(var prop in source)if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
            if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $3902411e290848f7$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function $3902411e290848f7$var$regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var $3902411e290848f7$var$_entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
function $3902411e290848f7$var$escape(data) {
    if (typeof data === "string") return data.replace(/[&<>"'\/]/g, function(s) {
        return $3902411e290848f7$var$_entityMap[s];
    });
    return data;
}
var $3902411e290848f7$var$isIE10 = typeof window !== "undefined" && window.navigator && typeof window.navigator.userAgentData === "undefined" && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1;
var $3902411e290848f7$var$chars = [
    " ",
    ",",
    "?",
    "!",
    ";"
];
function $3902411e290848f7$var$looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || "";
    keySeparator = keySeparator || "";
    var possibleChars = $3902411e290848f7$var$chars.filter(function(c) {
        return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
    });
    if (possibleChars.length === 0) return true;
    var r = new RegExp("(".concat(possibleChars.map(function(c) {
        return c === "?" ? "\\?" : c;
    }).join("|"), ")"));
    var matched = !r.test(key);
    if (!matched) {
        var ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function $3902411e290848f7$var$deepFind(obj, path) {
    var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    var paths = path.split(keySeparator);
    var current = obj;
    for(var i = 0; i < paths.length; ++i){
        if (!current) return undefined;
        if (typeof current[paths[i]] === "string" && i + 1 < paths.length) return undefined;
        if (current[paths[i]] === undefined) {
            var j = 2;
            var p = paths.slice(i, i + j).join(keySeparator);
            var mix = current[p];
            while(mix === undefined && paths.length > i + j){
                j++;
                p = paths.slice(i, i + j).join(keySeparator);
                mix = current[p];
            }
            if (mix === undefined) return undefined;
            if (mix === null) return null;
            if (path.endsWith(p)) {
                if (typeof mix === "string") return mix;
                if (p && typeof mix[p] === "string") return mix[p];
            }
            var joinedPath = paths.slice(i + j).join(keySeparator);
            if (joinedPath) return $3902411e290848f7$var$deepFind(mix, joinedPath, keySeparator);
            return undefined;
        }
        current = current[paths[i]];
    }
    return current;
}
function $3902411e290848f7$var$ownKeys$5(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3902411e290848f7$var$_objectSpread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3902411e290848f7$var$ownKeys$5(Object(source), !0).forEach(function(key) {
            (0, $azUPN.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3902411e290848f7$var$ownKeys$5(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3902411e290848f7$var$_createSuper$3(Derived) {
    var hasNativeReflectConstruct = $3902411e290848f7$var$_isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = (0, $6DH0b.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $6DH0b.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $cYgL8.default)(this, result);
    };
}
function $3902411e290848f7$var$_isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $3902411e290848f7$var$ResourceStore = function(_EventEmitter) {
    (0, $7RTSE.default)(ResourceStore, _EventEmitter);
    var _super = $3902411e290848f7$var$_createSuper$3(ResourceStore);
    function ResourceStore(data) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        (0, $1IOZg.default)(this, ResourceStore);
        _this = _super.call(this);
        if ($3902411e290848f7$var$isIE10) $3902411e290848f7$var$EventEmitter.call((0, $jnNcH.default)(_this));
        _this.data = data || {};
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        if (_this.options.ignoreJSONStructure === undefined) _this.options.ignoreJSONStructure = true;
        return _this;
    }
    (0, $lcCFm.default)(ResourceStore, [
        {
            key: "addNamespaces",
            value: function addNamespaces(ns) {
                if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
            }
        },
        {
            key: "removeNamespaces",
            value: function removeNamespaces(ns) {
                var index = this.options.ns.indexOf(ns);
                if (index > -1) this.options.ns.splice(index, 1);
            }
        },
        {
            key: "getResource",
            value: function getResource(lng, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
                var path = [
                    lng,
                    ns
                ];
                if (key && typeof key !== "string") path = path.concat(key);
                if (key && typeof key === "string") path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) path = lng.split(".");
                var result = $3902411e290848f7$var$getPath(this.data, path);
                if (result || !ignoreJSONStructure || typeof key !== "string") return result;
                return $3902411e290848f7$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
            }
        },
        {
            key: "addResource",
            value: function addResource(lng, ns, key, value) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
                    silent: false
                };
                var keySeparator = this.options.keySeparator;
                if (keySeparator === undefined) keySeparator = ".";
                var path = [
                    lng,
                    ns
                ];
                if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    value = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                $3902411e290848f7$var$setPath(this.data, path, value);
                if (!options.silent) this.emit("added", lng, ns, key, value);
            }
        },
        {
            key: "addResources",
            value: function addResources(lng, ns, resources) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                    silent: false
                };
                for(var m in resources)if (typeof resources[m] === "string" || Object.prototype.toString.apply(resources[m]) === "[object Array]") this.addResource(lng, ns, m, resources[m], {
                    silent: true
                });
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "addResourceBundle",
            value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
                    silent: false
                };
                var path = [
                    lng,
                    ns
                ];
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    deep = resources;
                    resources = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                var pack = $3902411e290848f7$var$getPath(this.data, path) || {};
                if (deep) $3902411e290848f7$var$deepExtend(pack, resources, overwrite);
                else pack = $3902411e290848f7$var$_objectSpread$5($3902411e290848f7$var$_objectSpread$5({}, pack), resources);
                $3902411e290848f7$var$setPath(this.data, path, pack);
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "removeResourceBundle",
            value: function removeResourceBundle(lng, ns) {
                if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
                this.removeNamespaces(ns);
                this.emit("removed", lng, ns);
            }
        },
        {
            key: "hasResourceBundle",
            value: function hasResourceBundle(lng, ns) {
                return this.getResource(lng, ns) !== undefined;
            }
        },
        {
            key: "getResourceBundle",
            value: function getResourceBundle(lng, ns) {
                if (!ns) ns = this.options.defaultNS;
                if (this.options.compatibilityAPI === "v1") return $3902411e290848f7$var$_objectSpread$5($3902411e290848f7$var$_objectSpread$5({}, {}), this.getResource(lng, ns));
                return this.getResource(lng, ns);
            }
        },
        {
            key: "getDataByLanguage",
            value: function getDataByLanguage(lng) {
                return this.data[lng];
            }
        },
        {
            key: "hasLanguageSomeTranslations",
            value: function hasLanguageSomeTranslations(lng) {
                var data = this.getDataByLanguage(lng);
                var n = data && Object.keys(data) || [];
                return !!n.find(function(v) {
                    return data[v] && Object.keys(data[v]).length > 0;
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.data;
            }
        }
    ]);
    return ResourceStore;
}($3902411e290848f7$var$EventEmitter);
var $3902411e290848f7$var$postProcessor = {
    processors: {},
    addPostProcessor: function addPostProcessor(module) {
        this.processors[module.name] = module;
    },
    handle: function handle(processors, value, key, options, translator) {
        var _this = this;
        processors.forEach(function(processor) {
            if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
function $3902411e290848f7$var$ownKeys$4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3902411e290848f7$var$_objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3902411e290848f7$var$ownKeys$4(Object(source), !0).forEach(function(key) {
            (0, $azUPN.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3902411e290848f7$var$ownKeys$4(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3902411e290848f7$var$_createSuper$2(Derived) {
    var hasNativeReflectConstruct = $3902411e290848f7$var$_isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = (0, $6DH0b.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $6DH0b.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $cYgL8.default)(this, result);
    };
}
function $3902411e290848f7$var$_isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $3902411e290848f7$var$checkedLoadedFor = {};
var $3902411e290848f7$var$Translator = function(_EventEmitter) {
    (0, $7RTSE.default)(Translator, _EventEmitter);
    var _super = $3902411e290848f7$var$_createSuper$2(Translator);
    function Translator(services) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $1IOZg.default)(this, Translator);
        _this = _super.call(this);
        if ($3902411e290848f7$var$isIE10) $3902411e290848f7$var$EventEmitter.call((0, $jnNcH.default)(_this));
        $3902411e290848f7$var$copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, (0, $jnNcH.default)(_this));
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        _this.logger = $3902411e290848f7$var$baseLogger.create("translator");
        return _this;
    }
    (0, $lcCFm.default)(Translator, [
        {
            key: "changeLanguage",
            value: function changeLanguage(lng) {
                if (lng) this.language = lng;
            }
        },
        {
            key: "exists",
            value: function exists(key) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                if (key === undefined || key === null) return false;
                var resolved = this.resolve(key, options);
                return resolved && resolved.res !== undefined;
            }
        },
        {
            key: "extractFromKey",
            value: function extractFromKey(key, options) {
                var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
                if (nsSeparator === undefined) nsSeparator = ":";
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var namespaces = options.ns || this.options.defaultNS || [];
                var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
                var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$3902411e290848f7$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
                if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
                    var m = key.match(this.interpolator.nestingRegexp);
                    if (m && m.length > 0) return {
                        key: key,
                        namespaces: namespaces
                    };
                    var parts = key.split(nsSeparator);
                    if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
                    key = parts.join(keySeparator);
                }
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                return {
                    key: key,
                    namespaces: namespaces
                };
            }
        },
        {
            key: "translate",
            value: function translate(keys, options, lastKey) {
                var _this2 = this;
                if ((0, $2oi0t.default)(options) !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
                if ((0, $2oi0t.default)(options) === "object") options = $3902411e290848f7$var$_objectSpread$4({}, options);
                if (!options) options = {};
                if (keys === undefined || keys === null) return "";
                if (!Array.isArray(keys)) keys = [
                    String(keys)
                ];
                var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options), key = _this$extractFromKey.key, namespaces = _this$extractFromKey.namespaces;
                var namespace = namespaces[namespaces.length - 1];
                var lng = options.lng || this.language;
                var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
                if (lng && lng.toLowerCase() === "cimode") {
                    if (appendNamespaceToCIMode) {
                        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
                        if (returnDetails) return {
                            res: "".concat(namespace).concat(nsSeparator).concat(key),
                            usedKey: key,
                            exactUsedKey: key,
                            usedLng: lng,
                            usedNS: namespace
                        };
                        return "".concat(namespace).concat(nsSeparator).concat(key);
                    }
                    if (returnDetails) return {
                        res: key,
                        usedKey: key,
                        exactUsedKey: key,
                        usedLng: lng,
                        usedNS: namespace
                    };
                    return key;
                }
                var resolved = this.resolve(keys, options);
                var res = resolved && resolved.res;
                var resUsedKey = resolved && resolved.usedKey || key;
                var resExactUsedKey = resolved && resolved.exactUsedKey || key;
                var resType = Object.prototype.toString.apply(res);
                var noObject = [
                    "[object Number]",
                    "[object Function]",
                    "[object RegExp]"
                ];
                var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
                var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
                var handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
                if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && resType === "[object Array]")) {
                    if (!options.returnObjects && !this.options.returnObjects) {
                        if (!this.options.returnedObjectHandler) this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                        var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, $3902411e290848f7$var$_objectSpread$4($3902411e290848f7$var$_objectSpread$4({}, options), {}, {
                            ns: namespaces
                        })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
                        if (returnDetails) {
                            resolved.res = r;
                            return resolved;
                        }
                        return r;
                    }
                    if (keySeparator) {
                        var resTypeIsArray = resType === "[object Array]";
                        var copy = resTypeIsArray ? [] : {};
                        var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                        for(var m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                            var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
                            copy[m] = this.translate(deepKey, $3902411e290848f7$var$_objectSpread$4($3902411e290848f7$var$_objectSpread$4({}, options), {
                                joinArrays: false,
                                ns: namespaces
                            }));
                            if (copy[m] === deepKey) copy[m] = res[m];
                        }
                        res = copy;
                    }
                } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && resType === "[object Array]") {
                    res = res.join(joinArrays);
                    if (res) res = this.extendTranslation(res, keys, options, lastKey);
                } else {
                    var usedDefault = false;
                    var usedKey = false;
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var hasDefaultValue = Translator.hasDefaultValue(options);
                    var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
                    var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
                    if (!this.isValidLookup(res) && hasDefaultValue) {
                        usedDefault = true;
                        res = defaultValue;
                    }
                    if (!this.isValidLookup(res)) {
                        usedKey = true;
                        res = key;
                    }
                    var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
                    var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
                    var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
                    if (usedKey || usedDefault || updateMissing) {
                        this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                        if (keySeparator) {
                            var fk = this.resolve(key, $3902411e290848f7$var$_objectSpread$4($3902411e290848f7$var$_objectSpread$4({}, options), {}, {
                                keySeparator: false
                            }));
                            if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                        }
                        var lngs = [];
                        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                        if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for(var i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                        else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                        else lngs.push(options.lng || this.language);
                        var send = function send(l, k, specificDefaultValue) {
                            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                            if (_this2.options.missingKeyHandler) _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                            else if (_this2.backendConnector && _this2.backendConnector.saveMissing) _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                            _this2.emit("missingKey", l, namespace, k, res);
                        };
                        if (this.options.saveMissing) {
                            if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach(function(language) {
                                _this2.pluralResolver.getSuffixes(language, options).forEach(function(suffix) {
                                    send([
                                        language
                                    ], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                                });
                            });
                            else send(lngs, key, defaultValue);
                        }
                    }
                    res = this.extendTranslation(res, keys, options, resolved, lastKey);
                    if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
                    if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                        if (this.options.compatibilityAPI !== "v1") res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
                        else res = this.options.parseMissingKeyHandler(res);
                    }
                }
                if (returnDetails) {
                    resolved.res = res;
                    return resolved;
                }
                return res;
            }
        },
        {
            key: "extendTranslation",
            value: function extendTranslation(res, key, options, resolved, lastKey) {
                var _this3 = this;
                if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, $3902411e290848f7$var$_objectSpread$4($3902411e290848f7$var$_objectSpread$4({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
                    resolved: resolved
                });
                else if (!options.skipInterpolation) {
                    if (options.interpolation) this.interpolator.init($3902411e290848f7$var$_objectSpread$4($3902411e290848f7$var$_objectSpread$4({}, options), {
                        interpolation: $3902411e290848f7$var$_objectSpread$4($3902411e290848f7$var$_objectSpread$4({}, this.options.interpolation), options.interpolation)
                    }));
                    var skipOnVariables = typeof res === "string" && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
                    var nestBef;
                    if (skipOnVariables) {
                        var nb = res.match(this.interpolator.nestingRegexp);
                        nestBef = nb && nb.length;
                    }
                    var data = options.replace && typeof options.replace !== "string" ? options.replace : options;
                    if (this.options.interpolation.defaultVariables) data = $3902411e290848f7$var$_objectSpread$4($3902411e290848f7$var$_objectSpread$4({}, this.options.interpolation.defaultVariables), data);
                    res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
                    if (skipOnVariables) {
                        var na = res.match(this.interpolator.nestingRegexp);
                        var nestAft = na && na.length;
                        if (nestBef < nestAft) options.nest = false;
                    }
                    if (!options.lng && this.options.compatibilityAPI !== "v1" && resolved && resolved.res) options.lng = resolved.usedLng;
                    if (options.nest !== false) res = this.interpolator.nest(res, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        if (lastKey && lastKey[0] === args[0] && !options.context) {
                            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
                            return null;
                        }
                        return _this3.translate.apply(_this3, args.concat([
                            key
                        ]));
                    }, options);
                    if (options.interpolation) this.interpolator.reset();
                }
                var postProcess = options.postProcess || this.options.postProcess;
                var postProcessorNames = typeof postProcess === "string" ? [
                    postProcess
                ] : postProcess;
                if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $3902411e290848f7$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? $3902411e290848f7$var$_objectSpread$4({
                    i18nResolved: resolved
                }, options) : options, this);
                return res;
            }
        },
        {
            key: "resolve",
            value: function resolve(keys) {
                var _this4 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var found;
                var usedKey;
                var exactUsedKey;
                var usedLng;
                var usedNS;
                if (typeof keys === "string") keys = [
                    keys
                ];
                keys.forEach(function(k) {
                    if (_this4.isValidLookup(found)) return;
                    var extracted = _this4.extractFromKey(k, options);
                    var key = extracted.key;
                    usedKey = key;
                    var namespaces = extracted.namespaces;
                    if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();
                    var needsContextHandling = options.context !== undefined && (typeof options.context === "string" || typeof options.context === "number") && options.context !== "";
                    var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
                    namespaces.forEach(function(ns) {
                        if (_this4.isValidLookup(found)) return;
                        usedNS = ns;
                        if (!$3902411e290848f7$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
                            $3902411e290848f7$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
                            _this4.logger.warn('key "'.concat(usedKey, '" for languages "').concat(codes.join(", "), '" won\'t get resolved as namespace "').concat(usedNS, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                        }
                        codes.forEach(function(code) {
                            if (_this4.isValidLookup(found)) return;
                            usedLng = code;
                            var finalKeys = [
                                key
                            ];
                            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                            else {
                                var pluralSuffix;
                                if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
                                var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");
                                if (needsPluralHandling) {
                                    finalKeys.push(key + pluralSuffix);
                                    if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                                }
                                if (needsContextHandling) {
                                    var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                                    finalKeys.push(contextKey);
                                    if (needsPluralHandling) {
                                        finalKeys.push(contextKey + pluralSuffix);
                                        if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                                    }
                                }
                            }
                            var possibleKey;
                            while(possibleKey = finalKeys.pop())if (!_this4.isValidLookup(found)) {
                                exactUsedKey = possibleKey;
                                found = _this4.getResource(code, ns, possibleKey, options);
                            }
                        });
                    });
                });
                return {
                    res: found,
                    usedKey: usedKey,
                    exactUsedKey: exactUsedKey,
                    usedLng: usedLng,
                    usedNS: usedNS
                };
            }
        },
        {
            key: "isValidLookup",
            value: function isValidLookup(res) {
                return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
            }
        },
        {
            key: "getResource",
            value: function getResource(code, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
                return this.resourceStore.getResource(code, ns, key, options);
            }
        }
    ], [
        {
            key: "hasDefaultValue",
            value: function hasDefaultValue(options) {
                var prefix = "defaultValue";
                for(var option in options){
                    if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
                }
                return false;
            }
        }
    ]);
    return Translator;
}($3902411e290848f7$var$EventEmitter);
function $3902411e290848f7$var$capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var $3902411e290848f7$var$LanguageUtil = function() {
    function LanguageUtil(options) {
        (0, $1IOZg.default)(this, LanguageUtil);
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $3902411e290848f7$var$baseLogger.create("languageUtils");
    }
    (0, $lcCFm.default)(LanguageUtil, [
        {
            key: "getScriptPartFromCode",
            value: function getScriptPartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return null;
                var p = code.split("-");
                if (p.length === 2) return null;
                p.pop();
                if (p[p.length - 1].toLowerCase() === "x") return null;
                return this.formatLanguageCode(p.join("-"));
            }
        },
        {
            key: "getLanguagePartFromCode",
            value: function getLanguagePartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return code;
                var p = code.split("-");
                return this.formatLanguageCode(p[0]);
            }
        },
        {
            key: "formatLanguageCode",
            value: function formatLanguageCode(code) {
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    var specialCases = [
                        "hans",
                        "hant",
                        "latn",
                        "cyrl",
                        "cans",
                        "mong",
                        "arab"
                    ];
                    var p = code.split("-");
                    if (this.options.lowerCaseLng) p = p.map(function(part) {
                        return part.toLowerCase();
                    });
                    else if (p.length === 2) {
                        p[0] = p[0].toLowerCase();
                        p[1] = p[1].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $3902411e290848f7$var$capitalize(p[1].toLowerCase());
                    } else if (p.length === 3) {
                        p[0] = p[0].toLowerCase();
                        if (p[1].length === 2) p[1] = p[1].toUpperCase();
                        if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $3902411e290848f7$var$capitalize(p[1].toLowerCase());
                        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $3902411e290848f7$var$capitalize(p[2].toLowerCase());
                    }
                    return p.join("-");
                }
                return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
            }
        },
        {
            key: "isSupportedCode",
            value: function isSupportedCode(code) {
                if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
                return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
            }
        },
        {
            key: "getBestMatchFromCodes",
            value: function getBestMatchFromCodes(codes) {
                var _this = this;
                if (!codes) return null;
                var found;
                codes.forEach(function(code) {
                    if (found) return;
                    var cleanedLng = _this.formatLanguageCode(code);
                    if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
                });
                if (!found && this.options.supportedLngs) codes.forEach(function(code) {
                    if (found) return;
                    var lngOnly = _this.getLanguagePartFromCode(code);
                    if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
                    found = _this.options.supportedLngs.find(function(supportedLng) {
                        if (supportedLng === lngOnly) return supportedLng;
                        if (supportedLng.indexOf("-") < 0 && lngOnly.indexOf("-") < 0) return;
                        if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
                    });
                });
                if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
                return found;
            }
        },
        {
            key: "getFallbackCodes",
            value: function getFallbackCodes(fallbacks, code) {
                if (!fallbacks) return [];
                if (typeof fallbacks === "function") fallbacks = fallbacks(code);
                if (typeof fallbacks === "string") fallbacks = [
                    fallbacks
                ];
                if (Object.prototype.toString.apply(fallbacks) === "[object Array]") return fallbacks;
                if (!code) return fallbacks["default"] || [];
                var found = fallbacks[code];
                if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
                if (!found) found = fallbacks[this.formatLanguageCode(code)];
                if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
                if (!found) found = fallbacks["default"];
                return found || [];
            }
        },
        {
            key: "toResolveHierarchy",
            value: function toResolveHierarchy(code, fallbackCode) {
                var _this2 = this;
                var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
                var codes = [];
                var addCode = function addCode(c) {
                    if (!c) return;
                    if (_this2.isSupportedCode(c)) codes.push(c);
                    else _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
                };
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
                    if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
                    if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
                } else if (typeof code === "string") addCode(this.formatLanguageCode(code));
                fallbackCodes.forEach(function(fc) {
                    if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
                });
                return codes;
            }
        }
    ]);
    return LanguageUtil;
}();
var $3902411e290848f7$var$sets = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kk",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
var $3902411e290848f7$var$_rulesPluralsTypes = {
    1: function _(n) {
        return Number(n > 1);
    },
    2: function _(n) {
        return Number(n != 1);
    },
    3: function _(n) {
        return 0;
    },
    4: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function _(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function _(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function _(n) {
        return Number(n >= 2);
    },
    10: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function _(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function _(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function _(n) {
        return Number(n !== 0);
    },
    14: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function _(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function _(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
var $3902411e290848f7$var$deprecatedJsonVersions = [
    "v1",
    "v2",
    "v3"
];
var $3902411e290848f7$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function $3902411e290848f7$var$createRules() {
    var rules = {};
    $3902411e290848f7$var$sets.forEach(function(set) {
        set.lngs.forEach(function(l) {
            rules[l] = {
                numbers: set.nr,
                plurals: $3902411e290848f7$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
var $3902411e290848f7$var$PluralResolver = function() {
    function PluralResolver(languageUtils) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $1IOZg.default)(this, PluralResolver);
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $3902411e290848f7$var$baseLogger.create("pluralResolver");
        if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === "v4") && (typeof Intl === "undefined" || !Intl.PluralRules)) {
            this.options.compatibilityJSON = "v3";
            this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.");
        }
        this.rules = $3902411e290848f7$var$createRules();
    }
    (0, $lcCFm.default)(PluralResolver, [
        {
            key: "addRule",
            value: function addRule(lng, obj) {
                this.rules[lng] = obj;
            }
        },
        {
            key: "getRule",
            value: function getRule(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (this.shouldUseIntlApi()) try {
                    return new Intl.PluralRules(code, {
                        type: options.ordinal ? "ordinal" : "cardinal"
                    });
                } catch (_unused) {
                    return;
                }
                return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
            }
        },
        {
            key: "needsPlural",
            value: function needsPlural(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
                return rule && rule.numbers.length > 1;
            }
        },
        {
            key: "getPluralFormsOfKey",
            value: function getPluralFormsOfKey(code, key) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return this.getSuffixes(code, options).map(function(suffix) {
                    return "".concat(key).concat(suffix);
                });
            }
        },
        {
            key: "getSuffixes",
            value: function getSuffixes(code) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (!rule) return [];
                if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort(function(pluralCategory1, pluralCategory2) {
                    return $3902411e290848f7$var$suffixesOrder[pluralCategory1] - $3902411e290848f7$var$suffixesOrder[pluralCategory2];
                }).map(function(pluralCategory) {
                    return "".concat(_this.options.prepend).concat(pluralCategory);
                });
                return rule.numbers.map(function(number) {
                    return _this.getSuffix(code, number, options);
                });
            }
        },
        {
            key: "getSuffix",
            value: function getSuffix(code, count) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var rule = this.getRule(code, options);
                if (rule) {
                    if (this.shouldUseIntlApi()) return "".concat(this.options.prepend).concat(rule.select(count));
                    return this.getSuffixRetroCompatible(rule, count);
                }
                this.logger.warn("no plural rule found for: ".concat(code));
                return "";
            }
        },
        {
            key: "getSuffixRetroCompatible",
            value: function getSuffixRetroCompatible(rule, count) {
                var _this2 = this;
                var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
                var suffix = rule.numbers[idx];
                if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
                    if (suffix === 2) suffix = "plural";
                    else if (suffix === 1) suffix = "";
                }
                var returnSuffix = function returnSuffix() {
                    return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
                };
                if (this.options.compatibilityJSON === "v1") {
                    if (suffix === 1) return "";
                    if (typeof suffix === "number") return "_plural_".concat(suffix.toString());
                    return returnSuffix();
                } else if (this.options.compatibilityJSON === "v2") return returnSuffix();
                else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
                return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
            }
        },
        {
            key: "shouldUseIntlApi",
            value: function shouldUseIntlApi() {
                return !$3902411e290848f7$var$deprecatedJsonVersions.includes(this.options.compatibilityJSON);
            }
        }
    ]);
    return PluralResolver;
}();
function $3902411e290848f7$var$ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3902411e290848f7$var$_objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3902411e290848f7$var$ownKeys$3(Object(source), !0).forEach(function(key) {
            (0, $azUPN.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3902411e290848f7$var$ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3902411e290848f7$var$deepFindWithDefaults(data, defaultData, key) {
    var keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ".";
    var ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var path = $3902411e290848f7$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && typeof key === "string") {
        path = $3902411e290848f7$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $3902411e290848f7$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
}
var $3902411e290848f7$var$Interpolator = function() {
    function Interpolator() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $1IOZg.default)(this, Interpolator);
        this.logger = $3902411e290848f7$var$baseLogger.create("interpolator");
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || function(value) {
            return value;
        };
        this.init(options);
    }
    (0, $lcCFm.default)(Interpolator, [
        {
            key: "init",
            value: function init() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!options.interpolation) options.interpolation = {
                    escapeValue: true
                };
                var iOpts = options.interpolation;
                this.escape = iOpts.escape !== undefined ? iOpts.escape : $3902411e290848f7$var$escape;
                this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
                this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
                this.prefix = iOpts.prefix ? $3902411e290848f7$var$regexEscape(iOpts.prefix) : iOpts.prefixEscaped || "{{";
                this.suffix = iOpts.suffix ? $3902411e290848f7$var$regexEscape(iOpts.suffix) : iOpts.suffixEscaped || "}}";
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
                this.unescapePrefix = iOpts.unescapeSuffix ? "" : iOpts.unescapePrefix || "-";
                this.unescapeSuffix = this.unescapePrefix ? "" : iOpts.unescapeSuffix || "";
                this.nestingPrefix = iOpts.nestingPrefix ? $3902411e290848f7$var$regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || $3902411e290848f7$var$regexEscape("$t(");
                this.nestingSuffix = iOpts.nestingSuffix ? $3902411e290848f7$var$regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || $3902411e290848f7$var$regexEscape(")");
                this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ",";
                this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
                this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
                this.resetRegExp();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.options) this.init(this.options);
            }
        },
        {
            key: "resetRegExp",
            value: function resetRegExp() {
                var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
                this.regexp = new RegExp(regexpStr, "g");
                var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
                this.regexpUnescape = new RegExp(regexpUnescapeStr, "g");
                var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
                this.nestingRegexp = new RegExp(nestingRegexpStr, "g");
            }
        },
        {
            key: "interpolate",
            value: function interpolate(str, data, lng, options) {
                var _this = this;
                var match;
                var value;
                var replaces;
                var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
                function regexSafe(val) {
                    return val.replace(/\$/g, "$$$$");
                }
                var handleFormat = function handleFormat(key) {
                    if (key.indexOf(_this.formatSeparator) < 0) {
                        var path = $3902411e290848f7$var$deepFindWithDefaults(data, defaultData, key, _this.options.keySeparator, _this.options.ignoreJSONStructure);
                        return _this.alwaysFormat ? _this.format(path, undefined, lng, $3902411e290848f7$var$_objectSpread$3($3902411e290848f7$var$_objectSpread$3($3902411e290848f7$var$_objectSpread$3({}, options), data), {}, {
                            interpolationkey: key
                        })) : path;
                    }
                    var p = key.split(_this.formatSeparator);
                    var k = p.shift().trim();
                    var f = p.join(_this.formatSeparator).trim();
                    return _this.format($3902411e290848f7$var$deepFindWithDefaults(data, defaultData, k, _this.options.keySeparator, _this.options.ignoreJSONStructure), f, lng, $3902411e290848f7$var$_objectSpread$3($3902411e290848f7$var$_objectSpread$3($3902411e290848f7$var$_objectSpread$3({}, options), data), {}, {
                        interpolationkey: k
                    }));
                };
                this.resetRegExp();
                var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
                var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
                var todos = [
                    {
                        regex: this.regexpUnescape,
                        safeValue: function safeValue(val) {
                            return regexSafe(val);
                        }
                    },
                    {
                        regex: this.regexp,
                        safeValue: function safeValue(val) {
                            return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
                        }
                    }
                ];
                todos.forEach(function(todo) {
                    replaces = 0;
                    while(match = todo.regex.exec(str)){
                        var matchedVar = match[1].trim();
                        value = handleFormat(matchedVar);
                        if (value === undefined) {
                            if (typeof missingInterpolationHandler === "function") {
                                var temp = missingInterpolationHandler(str, match, options);
                                value = typeof temp === "string" ? temp : "";
                            } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = "";
                            else if (skipOnVariables) {
                                value = match[0];
                                continue;
                            } else {
                                _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));
                                value = "";
                            }
                        } else if (typeof value !== "string" && !_this.useRawValueToEscape) value = $3902411e290848f7$var$makeString(value);
                        var safeValue = todo.safeValue(value);
                        str = str.replace(match[0], safeValue);
                        if (skipOnVariables) {
                            todo.regex.lastIndex += value.length;
                            todo.regex.lastIndex -= match[0].length;
                        } else todo.regex.lastIndex = 0;
                        replaces++;
                        if (replaces >= _this.maxReplaces) break;
                    }
                });
                return str;
            }
        },
        {
            key: "nest",
            value: function nest(str, fc) {
                var _this2 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var match;
                var value;
                var clonedOptions;
                function handleHasOptions(key, inheritedOptions) {
                    var sep = this.nestingOptionsSeparator;
                    if (key.indexOf(sep) < 0) return key;
                    var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
                    var optionsString = "{".concat(c[1]);
                    key = c[0];
                    optionsString = this.interpolate(optionsString, clonedOptions);
                    var matchedSingleQuotes = optionsString.match(/'/g);
                    var matchedDoubleQuotes = optionsString.match(/"/g);
                    if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
                    try {
                        clonedOptions = JSON.parse(optionsString);
                        if (inheritedOptions) clonedOptions = $3902411e290848f7$var$_objectSpread$3($3902411e290848f7$var$_objectSpread$3({}, inheritedOptions), clonedOptions);
                    } catch (e) {
                        this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
                        return "".concat(key).concat(sep).concat(optionsString);
                    }
                    delete clonedOptions.defaultValue;
                    return key;
                }
                while(match = this.nestingRegexp.exec(str)){
                    var formatters = [];
                    clonedOptions = $3902411e290848f7$var$_objectSpread$3({}, options);
                    clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== "string" ? clonedOptions.replace : clonedOptions;
                    clonedOptions.applyPostProcessor = false;
                    delete clonedOptions.defaultValue;
                    var doReduce = false;
                    if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                        var r = match[1].split(this.formatSeparator).map(function(elem) {
                            return elem.trim();
                        });
                        match[1] = r.shift();
                        formatters = r;
                        doReduce = true;
                    }
                    value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
                    if (value && match[0] === str && typeof value !== "string") return value;
                    if (typeof value !== "string") value = $3902411e290848f7$var$makeString(value);
                    if (!value) {
                        this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
                        value = "";
                    }
                    if (doReduce) value = formatters.reduce(function(v, f) {
                        return _this2.format(v, f, options.lng, $3902411e290848f7$var$_objectSpread$3($3902411e290848f7$var$_objectSpread$3({}, options), {}, {
                            interpolationkey: match[1].trim()
                        }));
                    }, value.trim());
                    str = str.replace(match[0], value);
                    this.regexp.lastIndex = 0;
                }
                return str;
            }
        }
    ]);
    return Interpolator;
}();
function $3902411e290848f7$var$ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3902411e290848f7$var$_objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3902411e290848f7$var$ownKeys$2(Object(source), !0).forEach(function(key) {
            (0, $azUPN.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3902411e290848f7$var$ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3902411e290848f7$var$parseFormatStr(formatStr) {
    var formatName = formatStr.toLowerCase().trim();
    var formatOptions = {};
    if (formatStr.indexOf("(") > -1) {
        var p = formatStr.split("(");
        formatName = p[0].toLowerCase().trim();
        var optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === "currency" && optStr.indexOf(":") < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            var opts = optStr.split(";");
            opts.forEach(function(opt) {
                if (!opt) return;
                var _opt$split = opt.split(":"), _opt$split2 = (0, $5B9iO.default)(_opt$split), key = _opt$split2[0], rest = _opt$split2.slice(1);
                var val = rest.join(":").trim().replace(/^'+|'+$/g, "");
                if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
                if (val === "false") formatOptions[key.trim()] = false;
                if (val === "true") formatOptions[key.trim()] = true;
                if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
}
function $3902411e290848f7$var$createCachedFormatter(fn) {
    var cache = {};
    return function invokeFormatter(val, lng, options) {
        var key = lng + JSON.stringify(options);
        var formatter = cache[key];
        if (!formatter) {
            formatter = fn(lng, options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
var $3902411e290848f7$var$Formatter = function() {
    function Formatter() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $1IOZg.default)(this, Formatter);
        this.logger = $3902411e290848f7$var$baseLogger.create("formatter");
        this.options = options;
        this.formats = {
            number: $3902411e290848f7$var$createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.NumberFormat(lng, $3902411e290848f7$var$_objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            currency: $3902411e290848f7$var$createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.NumberFormat(lng, $3902411e290848f7$var$_objectSpread$2($3902411e290848f7$var$_objectSpread$2({}, opt), {}, {
                    style: "currency"
                }));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            datetime: $3902411e290848f7$var$createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.DateTimeFormat(lng, $3902411e290848f7$var$_objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            relativetime: $3902411e290848f7$var$createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.RelativeTimeFormat(lng, $3902411e290848f7$var$_objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val, opt.range || "day");
                };
            }),
            list: $3902411e290848f7$var$createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.ListFormat(lng, $3902411e290848f7$var$_objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            })
        };
        this.init(options);
    }
    (0, $lcCFm.default)(Formatter, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                var iOpts = options.interpolation;
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
            }
        },
        {
            key: "add",
            value: function add(name, fc) {
                this.formats[name.toLowerCase().trim()] = fc;
            }
        },
        {
            key: "addCached",
            value: function addCached(name, fc) {
                this.formats[name.toLowerCase().trim()] = $3902411e290848f7$var$createCachedFormatter(fc);
            }
        },
        {
            key: "format",
            value: function format(value, _format, lng) {
                var _this = this;
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var formats = _format.split(this.formatSeparator);
                var result = formats.reduce(function(mem, f) {
                    var _parseFormatStr = $3902411e290848f7$var$parseFormatStr(f), formatName = _parseFormatStr.formatName, formatOptions = _parseFormatStr.formatOptions;
                    if (_this.formats[formatName]) {
                        var formatted = mem;
                        try {
                            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                            formatted = _this.formats[formatName](mem, l, $3902411e290848f7$var$_objectSpread$2($3902411e290848f7$var$_objectSpread$2($3902411e290848f7$var$_objectSpread$2({}, formatOptions), options), valOptions));
                        } catch (error) {
                            _this.logger.warn(error);
                        }
                        return formatted;
                    } else _this.logger.warn("there was no format function for ".concat(formatName));
                    return mem;
                }, value);
                return result;
            }
        }
    ]);
    return Formatter;
}();
function $3902411e290848f7$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3902411e290848f7$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3902411e290848f7$var$ownKeys$1(Object(source), !0).forEach(function(key) {
            (0, $azUPN.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3902411e290848f7$var$ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3902411e290848f7$var$_createSuper$1(Derived) {
    var hasNativeReflectConstruct = $3902411e290848f7$var$_isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = (0, $6DH0b.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $6DH0b.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $cYgL8.default)(this, result);
    };
}
function $3902411e290848f7$var$_isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $3902411e290848f7$var$removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
var $3902411e290848f7$var$Connector = function(_EventEmitter) {
    (0, $7RTSE.default)(Connector, _EventEmitter);
    var _super = $3902411e290848f7$var$_createSuper$1(Connector);
    function Connector(backend, store, services) {
        var _this;
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        (0, $1IOZg.default)(this, Connector);
        _this = _super.call(this);
        if ($3902411e290848f7$var$isIE10) $3902411e290848f7$var$EventEmitter.call((0, $jnNcH.default)(_this));
        _this.backend = backend;
        _this.store = store;
        _this.services = services;
        _this.languageUtils = services.languageUtils;
        _this.options = options;
        _this.logger = $3902411e290848f7$var$baseLogger.create("backendConnector");
        _this.waitingReads = [];
        _this.maxParallelReads = options.maxParallelReads || 10;
        _this.readingCalls = 0;
        _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        _this.state = {};
        _this.queue = [];
        if (_this.backend && _this.backend.init) _this.backend.init(services, options.backend, options);
        return _this;
    }
    (0, $lcCFm.default)(Connector, [
        {
            key: "queueLoad",
            value: function queueLoad(languages, namespaces, options, callback) {
                var _this2 = this;
                var toLoad = {};
                var pending = {};
                var toLoadLanguages = {};
                var toLoadNamespaces = {};
                languages.forEach(function(lng) {
                    var hasAllNamespaces = true;
                    namespaces.forEach(function(ns) {
                        var name = "".concat(lng, "|").concat(ns);
                        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) _this2.state[name] = 2;
                        else if (_this2.state[name] < 0) ;
                        else if (_this2.state[name] === 1) {
                            if (pending[name] === undefined) pending[name] = true;
                        } else {
                            _this2.state[name] = 1;
                            hasAllNamespaces = false;
                            if (pending[name] === undefined) pending[name] = true;
                            if (toLoad[name] === undefined) toLoad[name] = true;
                            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                        }
                    });
                    if (!hasAllNamespaces) toLoadLanguages[lng] = true;
                });
                if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
                    pending: pending,
                    pendingCount: Object.keys(pending).length,
                    loaded: {},
                    errors: [],
                    callback: callback
                });
                return {
                    toLoad: Object.keys(toLoad),
                    pending: Object.keys(pending),
                    toLoadLanguages: Object.keys(toLoadLanguages),
                    toLoadNamespaces: Object.keys(toLoadNamespaces)
                };
            }
        },
        {
            key: "loaded",
            value: function loaded(name, err, data) {
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                if (err) this.emit("failedLoading", lng, ns, err);
                if (data) this.store.addResourceBundle(lng, ns, data);
                this.state[name] = err ? -1 : 2;
                var loaded = {};
                this.queue.forEach(function(q) {
                    $3902411e290848f7$var$pushPath(q.loaded, [
                        lng
                    ], ns);
                    $3902411e290848f7$var$removePending(q, name);
                    if (err) q.errors.push(err);
                    if (q.pendingCount === 0 && !q.done) {
                        Object.keys(q.loaded).forEach(function(l) {
                            if (!loaded[l]) loaded[l] = {};
                            var loadedKeys = q.loaded[l];
                            if (loadedKeys.length) loadedKeys.forEach(function(n) {
                                if (loaded[l][n] === undefined) loaded[l][n] = true;
                            });
                        });
                        q.done = true;
                        if (q.errors.length) q.callback(q.errors);
                        else q.callback();
                    }
                });
                this.emit("loaded", loaded);
                this.queue = this.queue.filter(function(q) {
                    return !q.done;
                });
            }
        },
        {
            key: "read",
            value: function read(lng, ns, fcName) {
                var _this3 = this;
                var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
                var callback = arguments.length > 5 ? arguments[5] : undefined;
                if (!lng.length) return callback(null, {});
                if (this.readingCalls >= this.maxParallelReads) {
                    this.waitingReads.push({
                        lng: lng,
                        ns: ns,
                        fcName: fcName,
                        tried: tried,
                        wait: wait,
                        callback: callback
                    });
                    return;
                }
                this.readingCalls++;
                var resolver = function resolver(err, data) {
                    _this3.readingCalls--;
                    if (_this3.waitingReads.length > 0) {
                        var next = _this3.waitingReads.shift();
                        _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
                    }
                    if (err && data && tried < _this3.maxRetries) {
                        setTimeout(function() {
                            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
                        }, wait);
                        return;
                    }
                    callback(err, data);
                };
                var fc = this.backend[fcName].bind(this.backend);
                if (fc.length === 2) {
                    try {
                        var r = fc(lng, ns);
                        if (r && typeof r.then === "function") r.then(function(data) {
                            return resolver(null, data);
                        })["catch"](resolver);
                        else resolver(null, r);
                    } catch (err) {
                        resolver(err);
                    }
                    return;
                }
                return fc(lng, ns, resolver);
            }
        },
        {
            key: "prepareLoading",
            value: function prepareLoading(languages, namespaces) {
                var _this4 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var callback = arguments.length > 3 ? arguments[3] : undefined;
                if (!this.backend) {
                    this.logger.warn("No backend was added via i18next.use. Will not load resources.");
                    return callback && callback();
                }
                if (typeof languages === "string") languages = this.languageUtils.toResolveHierarchy(languages);
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                var toLoad = this.queueLoad(languages, namespaces, options, callback);
                if (!toLoad.toLoad.length) {
                    if (!toLoad.pending.length) callback();
                    return null;
                }
                toLoad.toLoad.forEach(function(name) {
                    _this4.loadOne(name);
                });
            }
        },
        {
            key: "load",
            value: function load(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {}, callback);
            }
        },
        {
            key: "reload",
            value: function reload(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {
                    reload: true
                }, callback);
            }
        },
        {
            key: "loadOne",
            value: function loadOne(name) {
                var _this5 = this;
                var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                this.read(lng, ns, "read", undefined, undefined, function(err, data) {
                    if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
                    if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
                    _this5.loaded(name, err, data);
                });
            }
        },
        {
            key: "saveMissing",
            value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function() {};
                if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
                    this.logger.warn('did not save key "'.concat(key, '" as the namespace "').concat(namespace, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                    return;
                }
                if (key === undefined || key === null || key === "") return;
                if (this.backend && this.backend.create) {
                    var opts = $3902411e290848f7$var$_objectSpread$1($3902411e290848f7$var$_objectSpread$1({}, options), {}, {
                        isUpdate: isUpdate
                    });
                    var fc = this.backend.create.bind(this.backend);
                    if (fc.length < 6) try {
                        var r;
                        if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                        else r = fc(languages, namespace, key, fallbackValue);
                        if (r && typeof r.then === "function") r.then(function(data) {
                            return clb(null, data);
                        })["catch"](clb);
                        else clb(null, r);
                    } catch (err) {
                        clb(err);
                    }
                    else fc(languages, namespace, key, fallbackValue, clb, opts);
                }
                if (!languages || !languages[0]) return;
                this.store.addResource(languages[0], namespace, key, fallbackValue);
            }
        }
    ]);
    return Connector;
}($3902411e290848f7$var$EventEmitter);
function $3902411e290848f7$var$get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: true,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            var ret = {};
            if ((0, $2oi0t.default)(args[1]) === "object") ret = args[1];
            if (typeof args[1] === "string") ret.defaultValue = args[1];
            if (typeof args[2] === "string") ret.tDescription = args[2];
            if ((0, $2oi0t.default)(args[2]) === "object" || (0, $2oi0t.default)(args[3]) === "object") {
                var options = args[3] || args[2];
                Object.keys(options).forEach(function(key) {
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: function format(value, _format, lng, options) {
                return value;
            },
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function $3902411e290848f7$var$transformOptions(options) {
    if (typeof options.ns === "string") options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === "string") options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === "string") options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) options.supportedLngs = options.supportedLngs.concat([
        "cimode"
    ]);
    return options;
}
function $3902411e290848f7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3902411e290848f7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3902411e290848f7$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $azUPN.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3902411e290848f7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3902411e290848f7$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $3902411e290848f7$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $6DH0b.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $6DH0b.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $cYgL8.default)(this, result);
    };
}
function $3902411e290848f7$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $3902411e290848f7$var$noop() {}
function $3902411e290848f7$var$bindMemberFunctions(inst) {
    var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach(function(mem) {
        if (typeof inst[mem] === "function") inst[mem] = inst[mem].bind(inst);
    });
}
var $3902411e290848f7$var$I18n = function(_EventEmitter) {
    (0, $7RTSE.default)(I18n, _EventEmitter);
    var _super = $3902411e290848f7$var$_createSuper(I18n);
    function I18n() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callback = arguments.length > 1 ? arguments[1] : undefined;
        (0, $1IOZg.default)(this, I18n);
        _this = _super.call(this);
        if ($3902411e290848f7$var$isIE10) $3902411e290848f7$var$EventEmitter.call((0, $jnNcH.default)(_this));
        _this.options = $3902411e290848f7$var$transformOptions(options);
        _this.services = {};
        _this.logger = $3902411e290848f7$var$baseLogger;
        _this.modules = {
            external: []
        };
        $3902411e290848f7$var$bindMemberFunctions((0, $jnNcH.default)(_this));
        if (callback && !_this.isInitialized && !options.isClone) {
            if (!_this.options.initImmediate) {
                _this.init(options, callback);
                return (0, $cYgL8.default)(_this, (0, $jnNcH.default)(_this));
            }
            setTimeout(function() {
                _this.init(options, callback);
            }, 0);
        }
        return _this;
    }
    (0, $lcCFm.default)(I18n, [
        {
            key: "init",
            value: function init() {
                var _this2 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                if (typeof options === "function") {
                    callback = options;
                    options = {};
                }
                if (!options.defaultNS && options.defaultNS !== false && options.ns) {
                    if (typeof options.ns === "string") options.defaultNS = options.ns;
                    else if (options.ns.indexOf("translation") < 0) options.defaultNS = options.ns[0];
                }
                var defOpts = $3902411e290848f7$var$get();
                this.options = $3902411e290848f7$var$_objectSpread($3902411e290848f7$var$_objectSpread($3902411e290848f7$var$_objectSpread({}, defOpts), this.options), $3902411e290848f7$var$transformOptions(options));
                if (this.options.compatibilityAPI !== "v1") this.options.interpolation = $3902411e290848f7$var$_objectSpread($3902411e290848f7$var$_objectSpread({}, defOpts.interpolation), this.options.interpolation);
                if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
                if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
                function createClassOnDemand(ClassOrObject) {
                    if (!ClassOrObject) return null;
                    if (typeof ClassOrObject === "function") return new ClassOrObject();
                    return ClassOrObject;
                }
                if (!this.options.isClone) {
                    if (this.modules.logger) $3902411e290848f7$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
                    else $3902411e290848f7$var$baseLogger.init(null, this.options);
                    var formatter;
                    if (this.modules.formatter) formatter = this.modules.formatter;
                    else if (typeof Intl !== "undefined") formatter = $3902411e290848f7$var$Formatter;
                    var lu = new $3902411e290848f7$var$LanguageUtil(this.options);
                    this.store = new $3902411e290848f7$var$ResourceStore(this.options.resources, this.options);
                    var s = this.services;
                    s.logger = $3902411e290848f7$var$baseLogger;
                    s.resourceStore = this.store;
                    s.languageUtils = lu;
                    s.pluralResolver = new $3902411e290848f7$var$PluralResolver(lu, {
                        prepend: this.options.pluralSeparator,
                        compatibilityJSON: this.options.compatibilityJSON,
                        simplifyPluralSuffix: this.options.simplifyPluralSuffix
                    });
                    if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                        s.formatter = createClassOnDemand(formatter);
                        s.formatter.init(s, this.options);
                        this.options.interpolation.format = s.formatter.format.bind(s.formatter);
                    }
                    s.interpolator = new $3902411e290848f7$var$Interpolator(this.options);
                    s.utils = {
                        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
                    };
                    s.backendConnector = new $3902411e290848f7$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
                    s.backendConnector.on("*", function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    if (this.modules.languageDetector) {
                        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                        if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
                    }
                    if (this.modules.i18nFormat) {
                        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                        if (s.i18nFormat.init) s.i18nFormat.init(this);
                    }
                    this.translator = new $3902411e290848f7$var$Translator(this.services, this.options);
                    this.translator.on("*", function(event) {
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    this.modules.external.forEach(function(m) {
                        if (m.init) m.init(_this2);
                    });
                }
                this.format = this.options.interpolation.format;
                if (!callback) callback = $3902411e290848f7$var$noop;
                if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
                    var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                    if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
                }
                if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
                var storeApi = [
                    "getResource",
                    "hasResourceBundle",
                    "getResourceBundle",
                    "getDataByLanguage"
                ];
                storeApi.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store;
                        return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
                    };
                });
                var storeApiChained = [
                    "addResource",
                    "addResources",
                    "addResourceBundle",
                    "removeResourceBundle"
                ];
                storeApiChained.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store2;
                        (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
                        return _this2;
                    };
                });
                var deferred = $3902411e290848f7$var$defer();
                var load = function load() {
                    var finish = function finish(err, t) {
                        if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn("init: i18next is already initialized. You should call init just once!");
                        _this2.isInitialized = true;
                        if (!_this2.options.isClone) _this2.logger.log("initialized", _this2.options);
                        _this2.emit("initialized", _this2.options);
                        deferred.resolve(t);
                        callback(err, t);
                    };
                    if (_this2.languages && _this2.options.compatibilityAPI !== "v1" && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
                    _this2.changeLanguage(_this2.options.lng, finish);
                };
                if (this.options.resources || !this.options.initImmediate) load();
                else setTimeout(load, 0);
                return deferred;
            }
        },
        {
            key: "loadResources",
            value: function loadResources(language) {
                var _this3 = this;
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $3902411e290848f7$var$noop;
                var usedCallback = callback;
                var usedLng = typeof language === "string" ? language : this.language;
                if (typeof language === "function") usedCallback = language;
                if (!this.options.resources || this.options.partialBundledLanguages) {
                    if (usedLng && usedLng.toLowerCase() === "cimode") return usedCallback();
                    var toLoad = [];
                    var append = function append(lng) {
                        if (!lng) return;
                        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
                        lngs.forEach(function(l) {
                            if (toLoad.indexOf(l) < 0) toLoad.push(l);
                        });
                    };
                    if (!usedLng) {
                        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                        fallbacks.forEach(function(l) {
                            return append(l);
                        });
                    } else append(usedLng);
                    if (this.options.preload) this.options.preload.forEach(function(l) {
                        return append(l);
                    });
                    this.services.backendConnector.load(toLoad, this.options.ns, function(e) {
                        if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
                        usedCallback(e);
                    });
                } else usedCallback(null);
            }
        },
        {
            key: "reloadResources",
            value: function reloadResources(lngs, ns, callback) {
                var deferred = $3902411e290848f7$var$defer();
                if (!lngs) lngs = this.languages;
                if (!ns) ns = this.options.ns;
                if (!callback) callback = $3902411e290848f7$var$noop;
                this.services.backendConnector.reload(lngs, ns, function(err) {
                    deferred.resolve();
                    callback(err);
                });
                return deferred;
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
                if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
                if (module.type === "backend") this.modules.backend = module;
                if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
                if (module.type === "languageDetector") this.modules.languageDetector = module;
                if (module.type === "i18nFormat") this.modules.i18nFormat = module;
                if (module.type === "postProcessor") $3902411e290848f7$var$postProcessor.addPostProcessor(module);
                if (module.type === "formatter") this.modules.formatter = module;
                if (module.type === "3rdParty") this.modules.external.push(module);
                return this;
            }
        },
        {
            key: "setResolvedLanguage",
            value: function setResolvedLanguage(l) {
                if (!l || !this.languages) return;
                if ([
                    "cimode",
                    "dev"
                ].indexOf(l) > -1) return;
                for(var li = 0; li < this.languages.length; li++){
                    var lngInLngs = this.languages[li];
                    if ([
                        "cimode",
                        "dev"
                    ].indexOf(lngInLngs) > -1) continue;
                    if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                        this.resolvedLanguage = lngInLngs;
                        break;
                    }
                }
            }
        },
        {
            key: "changeLanguage",
            value: function changeLanguage(lng, callback) {
                var _this4 = this;
                this.isLanguageChangingTo = lng;
                var deferred = $3902411e290848f7$var$defer();
                this.emit("languageChanging", lng);
                var setLngProps = function setLngProps(l) {
                    _this4.language = l;
                    _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                    _this4.resolvedLanguage = undefined;
                    _this4.setResolvedLanguage(l);
                };
                var done = function done(err, l) {
                    if (l) {
                        setLngProps(l);
                        _this4.translator.changeLanguage(l);
                        _this4.isLanguageChangingTo = undefined;
                        _this4.emit("languageChanged", l);
                        _this4.logger.log("languageChanged", l);
                    } else _this4.isLanguageChangingTo = undefined;
                    deferred.resolve(function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                    if (callback) callback(err, function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                };
                var setLng = function setLng(lngs) {
                    if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
                    var l = typeof lngs === "string" ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
                    if (l) {
                        if (!_this4.language) setLngProps(l);
                        if (!_this4.translator.language) _this4.translator.changeLanguage(l);
                        if (_this4.services.languageDetector && _this4.services.languageDetector.cacheUserLanguage) _this4.services.languageDetector.cacheUserLanguage(l);
                    }
                    _this4.loadResources(l, function(err) {
                        done(err, l);
                    });
                };
                if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
                else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
                    if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
                    else this.services.languageDetector.detect(setLng);
                } else setLng(lng);
                return deferred;
            }
        },
        {
            key: "getFixedT",
            value: function getFixedT(lng, ns, keyPrefix) {
                var _this5 = this;
                var fixedT = function fixedT(key, opts) {
                    var options;
                    if ((0, $2oi0t.default)(opts) !== "object") {
                        for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                        options = _this5.options.overloadTranslationOptionHandler([
                            key,
                            opts
                        ].concat(rest));
                    } else options = $3902411e290848f7$var$_objectSpread({}, opts);
                    options.lng = options.lng || fixedT.lng;
                    options.lngs = options.lngs || fixedT.lngs;
                    options.ns = options.ns || fixedT.ns;
                    options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
                    var keySeparator = _this5.options.keySeparator || ".";
                    var resultKey;
                    if (options.keyPrefix && Array.isArray(key)) resultKey = key.map(function(k) {
                        return "".concat(options.keyPrefix).concat(keySeparator).concat(k);
                    });
                    else resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
                    return _this5.t(resultKey, options);
                };
                if (typeof lng === "string") fixedT.lng = lng;
                else fixedT.lngs = lng;
                fixedT.ns = ns;
                fixedT.keyPrefix = keyPrefix;
                return fixedT;
            }
        },
        {
            key: "t",
            value: function t() {
                var _this$translator;
                return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
            }
        },
        {
            key: "exists",
            value: function exists() {
                var _this$translator2;
                return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
            }
        },
        {
            key: "setDefaultNamespace",
            value: function setDefaultNamespace(ns) {
                this.options.defaultNS = ns;
            }
        },
        {
            key: "hasLoadedNamespace",
            value: function hasLoadedNamespace(ns) {
                var _this6 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (!this.isInitialized) {
                    this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
                    return false;
                }
                if (!this.languages || !this.languages.length) {
                    this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
                    return false;
                }
                var lng = this.resolvedLanguage || this.languages[0];
                var fallbackLng = this.options ? this.options.fallbackLng : false;
                var lastLng = this.languages[this.languages.length - 1];
                if (lng.toLowerCase() === "cimode") return true;
                var loadNotPending = function loadNotPending(l, n) {
                    var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
                    return loadState === -1 || loadState === 2;
                };
                if (options.precheck) {
                    var preResult = options.precheck(this, loadNotPending);
                    if (preResult !== undefined) return preResult;
                }
                if (this.hasResourceBundle(lng, ns)) return true;
                if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
                if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
                return false;
            }
        },
        {
            key: "loadNamespaces",
            value: function loadNamespaces(ns, callback) {
                var _this7 = this;
                var deferred = $3902411e290848f7$var$defer();
                if (!this.options.ns) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                if (typeof ns === "string") ns = [
                    ns
                ];
                ns.forEach(function(n) {
                    if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
                });
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "loadLanguages",
            value: function loadLanguages(lngs, callback) {
                var deferred = $3902411e290848f7$var$defer();
                if (typeof lngs === "string") lngs = [
                    lngs
                ];
                var preloaded = this.options.preload || [];
                var newLngs = lngs.filter(function(lng) {
                    return preloaded.indexOf(lng) < 0;
                });
                if (!newLngs.length) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                this.options.preload = preloaded.concat(newLngs);
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "dir",
            value: function dir(lng) {
                if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
                if (!lng) return "rtl";
                var rtlLngs = [
                    "ar",
                    "shu",
                    "sqr",
                    "ssh",
                    "xaa",
                    "yhd",
                    "yud",
                    "aao",
                    "abh",
                    "abv",
                    "acm",
                    "acq",
                    "acw",
                    "acx",
                    "acy",
                    "adf",
                    "ads",
                    "aeb",
                    "aec",
                    "afb",
                    "ajp",
                    "apc",
                    "apd",
                    "arb",
                    "arq",
                    "ars",
                    "ary",
                    "arz",
                    "auz",
                    "avl",
                    "ayh",
                    "ayl",
                    "ayn",
                    "ayp",
                    "bbz",
                    "pga",
                    "he",
                    "iw",
                    "ps",
                    "pbt",
                    "pbu",
                    "pst",
                    "prp",
                    "prd",
                    "ug",
                    "ur",
                    "ydd",
                    "yds",
                    "yih",
                    "ji",
                    "yi",
                    "hbo",
                    "men",
                    "xmn",
                    "fa",
                    "jpr",
                    "peo",
                    "pes",
                    "prs",
                    "dv",
                    "sam",
                    "ckb"
                ];
                var languageUtils = this.services && this.services.languageUtils || new $3902411e290848f7$var$LanguageUtil($3902411e290848f7$var$get());
                return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
            }
        },
        {
            key: "cloneInstance",
            value: function cloneInstance() {
                var _this8 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $3902411e290848f7$var$noop;
                var mergedOptions = $3902411e290848f7$var$_objectSpread($3902411e290848f7$var$_objectSpread($3902411e290848f7$var$_objectSpread({}, this.options), options), {
                    isClone: true
                });
                var clone = new I18n(mergedOptions);
                if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
                var membersToCopy = [
                    "store",
                    "services",
                    "language"
                ];
                membersToCopy.forEach(function(m) {
                    clone[m] = _this8[m];
                });
                clone.services = $3902411e290848f7$var$_objectSpread({}, this.services);
                clone.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                clone.translator = new $3902411e290848f7$var$Translator(clone.services, clone.options);
                clone.translator.on("*", function(event) {
                    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
                    clone.emit.apply(clone, [
                        event
                    ].concat(args));
                });
                clone.init(mergedOptions, callback);
                clone.translator.options = clone.options;
                clone.translator.backendConnector.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                return clone;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    options: this.options,
                    store: this.store,
                    language: this.language,
                    languages: this.languages,
                    resolvedLanguage: this.resolvedLanguage
                };
            }
        }
    ]);
    return I18n;
}($3902411e290848f7$var$EventEmitter);
(0, $azUPN.default)($3902411e290848f7$var$I18n, "createInstance", function() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;
    return new $3902411e290848f7$var$I18n(options, callback);
});
var $3902411e290848f7$export$2e2bcd8739ae039 = $3902411e290848f7$var$I18n.createInstance();
$3902411e290848f7$export$2e2bcd8739ae039.createInstance = $3902411e290848f7$var$I18n.createInstance;
var $3902411e290848f7$export$99152e8d49ca4e7d = $3902411e290848f7$export$2e2bcd8739ae039.createInstance;
var $3902411e290848f7$export$147ec2801e896265 = $3902411e290848f7$export$2e2bcd8739ae039.dir;
var $3902411e290848f7$export$2cd8252107eb640b = $3902411e290848f7$export$2e2bcd8739ae039.init;
var $3902411e290848f7$export$d3d08d944062d7e = $3902411e290848f7$export$2e2bcd8739ae039.loadResources;
var $3902411e290848f7$export$a5d9bf5d83fcab09 = $3902411e290848f7$export$2e2bcd8739ae039.reloadResources;
var $3902411e290848f7$export$1f96ae73734a86cc = $3902411e290848f7$export$2e2bcd8739ae039.use;
var $3902411e290848f7$export$61465194746e7fd2 = $3902411e290848f7$export$2e2bcd8739ae039.changeLanguage;
var $3902411e290848f7$export$f90d180fc7da3b3b = $3902411e290848f7$export$2e2bcd8739ae039.getFixedT;
var $3902411e290848f7$export$625550452a3fa3ec = $3902411e290848f7$export$2e2bcd8739ae039.t;
var $3902411e290848f7$export$f7e9f41ea797a17 = $3902411e290848f7$export$2e2bcd8739ae039.exists;
var $3902411e290848f7$export$2b4b218e406d2d00 = $3902411e290848f7$export$2e2bcd8739ae039.setDefaultNamespace;
var $3902411e290848f7$export$93d9ee97c1ad3f31 = $3902411e290848f7$export$2e2bcd8739ae039.hasLoadedNamespace;
var $3902411e290848f7$export$83be934b53fff43b = $3902411e290848f7$export$2e2bcd8739ae039.loadNamespaces;
var $3902411e290848f7$export$8cd7e7a54fa865bc = $3902411e290848f7$export$2e2bcd8739ae039.loadLanguages;

});
parcelRequire.register("jnNcH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1c655233081d608$export$2e2bcd8739ae039; });
function $e1c655233081d608$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRequire.register("7RTSE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ba8d451dd9d5118$export$2e2bcd8739ae039; });

var $lOYtK = parcelRequire("lOYtK");
function $5ba8d451dd9d5118$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $lOYtK.default)(subClass, superClass);
}

});
parcelRequire.register("lOYtK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe2d2e4be2c69238$export$2e2bcd8739ae039; });
function $fe2d2e4be2c69238$export$2e2bcd8739ae039(o, p) {
    $fe2d2e4be2c69238$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $fe2d2e4be2c69238$export$2e2bcd8739ae039(o, p);
}

});


parcelRequire.register("cYgL8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $971816b17da71d44$export$2e2bcd8739ae039; });

var $2oi0t = parcelRequire("2oi0t");

var $jnNcH = parcelRequire("jnNcH");
function $971816b17da71d44$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $2oi0t.default)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $jnNcH.default)(self);
}

});

parcelRequire.register("6DH0b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d57bde3efb52eeb$export$2e2bcd8739ae039; });
function $4d57bde3efb52eeb$export$2e2bcd8739ae039(o) {
    $4d57bde3efb52eeb$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $4d57bde3efb52eeb$export$2e2bcd8739ae039(o);
}

});

parcelRequire.register("5B9iO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41379fbc4972e1bf$export$2e2bcd8739ae039; });

var $gTtSD = parcelRequire("gTtSD");

var $iM0q4 = parcelRequire("iM0q4");

var $7yoNA = parcelRequire("7yoNA");

var $lKy8Z = parcelRequire("lKy8Z");
function $41379fbc4972e1bf$export$2e2bcd8739ae039(arr) {
    return (0, $gTtSD.default)(arr) || (0, $iM0q4.default)(arr) || (0, $7yoNA.default)(arr) || (0, $lKy8Z.default)();
}

});
parcelRequire.register("iM0q4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $daad08f7cddbb13e$export$2e2bcd8739ae039; });
function $daad08f7cddbb13e$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});



parcelRequire.register("3RCsa", function(module, exports) {

$parcel$export(module.exports, "safeParseJson", function () { return $24b858b24b3ba208$export$212f7b749ec4b6d2; });
$parcel$export(module.exports, "safeParseJsonObject", function () { return $24b858b24b3ba208$export$c6c96a2b375defd2; });
parcelRequire("cuPVN");
var $j080Y = parcelRequire("j080Y");

var $4TsiV = parcelRequire("4TsiV");
const $24b858b24b3ba208$export$212f7b749ec4b6d2 = (jsonString)=>{
    try {
        const data = (0, $j080Y.jsonGuard).parse(JSON.parse(jsonString));
        return {
            success: true,
            data: data
        };
    } catch  {
        return {
            success: false,
            error: (0, $4TsiV.t)("admin_console.errors.invalid_json_format")
        };
    }
};
const $24b858b24b3ba208$export$c6c96a2b375defd2 = (jsonString)=>{
    try {
        const data = (0, $j080Y.jsonObjectGuard).parse(JSON.parse(jsonString));
        return {
            success: true,
            data: data
        };
    } catch  {
        return {
            success: false,
            error: (0, $4TsiV.t)("admin_console.errors.invalid_json_format")
        };
    }
};

});

parcelRequire.register("fVyJK", function(module, exports) {

$parcel$export(module.exports, "multiTextInputErrorGuard", function () { return $91f3879d45209ecc$export$afc2be86ec14084c; });

var $c3dK3 = parcelRequire("c3dK3");
const $91f3879d45209ecc$export$afc2be86ec14084c = (0, $c3dK3.z).object({
    required: (0, $c3dK3.z).string().optional(),
    inputs: (0, $c3dK3.z).record((0, $c3dK3.z).number().or((0, $c3dK3.z).string()), (0, $c3dK3.z).string().optional()).optional()
});

});


parcelRequire.register("fmrD5", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", objectTag = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap");
/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */ var nonEnumShadows = !propertyIsEnumerable.call({
    "valueOf": 1
}, "valueOf");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, "callee") && (!propertyIsEnumerable.call(value, "callee") || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function isEmpty(value) {
    if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isArguments(value))) return !value.length;
    var tag = getTag(value);
    if (tag == mapTag || tag == setTag) return !value.size;
    if (nonEnumShadows || isPrototype(value)) return !nativeKeys(value).length;
    for(var key in value){
        if (hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : "";
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEmpty;

});

parcelRequire.register("7bx9V", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT = "Expected a function";
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to compose bitmasks for comparison styles. */ var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", promiseTag = "[object Promise]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, reLeadingDot = /^\./, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Symbol = root.Symbol, Uint8Array = root.Uint8Array, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__["delete"](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */ function baseCreate(proto) {
    return isObject(proto) ? objectCreate(proto) : {};
}
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
        objTag = getTag(object);
        objTag = objTag == argsTag ? objectTag : objTag;
    }
    if (!othIsArr) {
        othTag = getTag(other);
        othTag = othTag == argsTag ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack) : result)) return false;
        }
    }
    return true;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return identity;
    if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
    };
}
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value) {
    return isArray(value) ? value : stringToPath(value);
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) return seen.add(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= UNORDERED_COMPARE_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var result, index = -1, length = path.length;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result) return result;
    var length = object ? object.length : 0;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoize(function(string) {
    string = toString(string);
    var result = [];
    if (reLeadingDot.test(string)) result.push("");
    string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
memoize.Cache = MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, "callee") && (!propertyIsEnumerable.call(value, "callee") || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : "";
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : baseToString(value);
}
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */ function transform(object, iteratee, accumulator) {
    var isArr = isArray(object) || isTypedArray(object);
    iteratee = baseIteratee(iteratee, 4);
    if (accumulator == null) {
        if (isArr || isObject(object)) {
            var Ctor = object.constructor;
            if (isArr) accumulator = isArray(object) ? new Ctor : [];
            else accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        } else accumulator = {};
    }
    (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
    });
    return accumulator;
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = transform;

});

parcelRequire.register("cdnQF", function(module, exports) {









module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("4IKga")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("8bpNg"))
]).then(()=>parcelRequire("8GHj4"));

});

parcelRequire.register("gKITH", function(module, exports) {









module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("IYsSq")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fkk0F"))
]).then(()=>parcelRequire("jZGdY"));

});

parcelRequire.register("7kkSz", function(module, exports) {









module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("4IKga")),
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("1O7r5"))
]).then(()=>parcelRequire("byOEX"));

});

parcelRequire.register("HJdjf", function(module, exports) {









module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("IYsSq")),
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("bEhZX"))
]).then(()=>parcelRequire("j58Da"));

});

parcelRequire.register("5L9hQ", function(module, exports) {









module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("IYsSq")),
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("jtcFZ"))
]).then(()=>parcelRequire("4fq6f"));

});

parcelRequire.register("euAl0", function(module, exports) {









module.exports = Promise.all([
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("IYsSq")),
    (parcelRequire("k6BSO"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("fLa9C")),
    (parcelRequire("jPoCU"))((parcelRequire("2KvlN")).getBundleURL("438uy") + (parcelRequire("h6gOx")).resolve("gGqYs"))
]).then(()=>parcelRequire("5zogn"));

});

parcelRequire.register("2lgsR", function(module, exports) {

$parcel$export(module.exports, "SsoConnectorContext", function () { return $c0359e836a6c2a79$export$166167b5bcb4b320; });
$parcel$export(module.exports, "default", function () { return $c0359e836a6c2a79$export$2e2bcd8739ae039; });

var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");
const $c0359e836a6c2a79$export$166167b5bcb4b320 = /*#__PURE__*/ (0, $jC8Vy.createContext)({});
function $c0359e836a6c2a79$var$SsoConnectorContextProvider({ children: children, ssoConnector: ssoConnector }) {
    const contextValue = (0, $jC8Vy.useMemo)(()=>({
            ssoConnector: ssoConnector
        }), [
        ssoConnector
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsx)($c0359e836a6c2a79$export$166167b5bcb4b320.Provider, {
        value: contextValue,
        children: children
    });
}
var $c0359e836a6c2a79$export$2e2bcd8739ae039 = $c0359e836a6c2a79$var$SsoConnectorContextProvider;

});


var $C7mD2 = parcelRequire("C7mD2");
var $cdc0c574bf943eea$export$882461b6382ed46c;
var $cdc0c574bf943eea$export$757ceba2d55c277e;
"use strict";

var $jH4WR = parcelRequire("jH4WR");
var $cdc0c574bf943eea$var$i;
$cdc0c574bf943eea$export$882461b6382ed46c = $jH4WR.createRoot;
$cdc0c574bf943eea$export$757ceba2d55c277e = $jH4WR.hydrateRoot;



var $kUZ14 = parcelRequire("kUZ14");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("4taJ0");
var $hyigV = parcelRequire("hyigV");
parcelRequire("9zW7e");
var $7pgvg = parcelRequire("7pgvg");
var $gz11x = parcelRequire("gz11x");
var $jSb9j = parcelRequire("jSb9j");
parcelRequire("cuPVN");
var $6hxiJ = parcelRequire("6hxiJ");
var $68782 = parcelRequire("68782");
var $aZIrr = parcelRequire("aZIrr");
var $5TTZn = parcelRequire("5TTZn");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");

var $4Mpch = parcelRequire("4Mpch");

var $6bq3s = parcelRequire("6bq3s");
var $2Phw0 = parcelRequire("2Phw0");





var $C7mD2 = parcelRequire("C7mD2");

var $2Phw0 = parcelRequire("2Phw0");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("9zW7e");
var $jSb9j = parcelRequire("jSb9j");
parcelRequire("12bMu");
var $l0I3U = parcelRequire("l0I3U");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");

var $2Phw0 = parcelRequire("2Phw0");
var $6bq3s = parcelRequire("6bq3s");
parcelRequire("9zW7e");
var $jSb9j = parcelRequire("jSb9j");
parcelRequire("cuPVN");
var $aZIrr = parcelRequire("aZIrr");
parcelRequire("12bMu");
var $3dBAh = parcelRequire("3dBAh");
var $7oDSS = parcelRequire("7oDSS");
var $3d495bcb3543e50f$export$8695620d48fe67d;
(function(RequestMethod) {
    RequestMethod["GET"] = "GET";
    RequestMethod["POST"] = "POST";
    RequestMethod["PUT"] = "PUT";
    RequestMethod["PATCH"] = "PATCH";
    RequestMethod["DELETE"] = "DELETE";
    RequestMethod["COPY"] = "COPY";
    RequestMethod["HEAD"] = "HEAD";
    RequestMethod["OPTIONS"] = "OPTIONS";
})($3d495bcb3543e50f$export$8695620d48fe67d || ($3d495bcb3543e50f$export$8695620d48fe67d = {}));


const $28c798f329c5047e$export$fb003dbd6df95edb = Object.freeze(Object.values((0, $3d495bcb3543e50f$export$8695620d48fe67d)));
const $28c798f329c5047e$export$e960dff2dfff73b8 = Object.freeze($28c798f329c5047e$export$fb003dbd6df95edb.map(// Cannot change the return type of `.toLowerCase()`
// eslint-disable-next-line no-restricted-syntax
(value)=>value.toLowerCase()));
const $28c798f329c5047e$export$b55ee587147d9da1 = Object.freeze({
    json: "application/json"
});



var $9fi9T = parcelRequire("9fi9T");
const $0ac74159a57c5b23$export$8793edee2d425525 = async ()=>{
// Let it go
};
const $0ac74159a57c5b23$export$8f45430ccf837300 = Object.freeze({
    reset: "\x1b[0m",
    bright: "\x1b[1m",
    dim: "\x1b[2m",
    black: "\x1b[30m",
    red: "\x1b[31m",
    green: "\x1b[32m",
    blue: "\x1b[34m",
    magenta: "\x1b[35m",
    cyan: "\x1b[36m",
    yellow: "\x1b[33m"
});
const $0ac74159a57c5b23$export$35e9368ef982300f = (string, color)=>$9fi9T.stdout.isTTY ? $0ac74159a57c5b23$export$8f45430ccf837300[color] + (string ?? "undefined") + $0ac74159a57c5b23$export$8f45430ccf837300.reset : string ?? "undefined";
const $0ac74159a57c5b23$export$bef1f36f5486a6a3 = {
    debug: (...args)=>{
        if ([
            "1",
            "true",
            "y",
            "yes"
        ].includes(undefined ?? "")) console.debug($0ac74159a57c5b23$export$35e9368ef982300f("dbg", "dim"), ...args);
    },
    warn: (...args)=>{
        console.warn($0ac74159a57c5b23$export$35e9368ef982300f("warn", "yellow"), ...args);
    }
};
const $0ac74159a57c5b23$export$a5c6d149b50c1d86 = (pathname)=>"/" + pathname.split("/").filter(Boolean).join("/");
const $0ac74159a57c5b23$export$66bfc51dbade9a33 = (raw)=>raw.toLowerCase().replaceAll("\n", " ").trim().replaceAll(/ {2,}/g, " ");





const $755b24a3f57e744a$export$767cbc91845890d3 = (record)=>{
    const parameters = new URLSearchParams();
    for (const [key, value] of Object.entries(record ?? {})){
        if (Array.isArray(value)) for (const element of value)parameters.append(key, element);
        else parameters.append(key, value);
    }
    return parameters;
};
const $755b24a3f57e744a$export$4369c812aac99591 = (value)=>value !== null && (typeof value === "object" || typeof value === "function") && "then" in value && typeof value.then === "function";





class $33b9cc7fd9279a6b$export$286baf652d0b1206 extends Error {
    constructor(response){
        super(`Response error ${response.status}: ${response.statusText}`);
        this.response = response;
    }
    get status() {
        return this.response.status;
    }
}
class $33b9cc7fd9279a6b$export$2e2bcd8739ae039 {
    constructor(value){
        this.get = this.buildHandler("get");
        this.post = this.buildHandler("post");
        this.put = this.buildHandler("put");
        this.patch = this.buildHandler("patch");
        this.delete = this.buildHandler("delete");
        this.copy = this.buildHandler("copy");
        this.head = this.buildHandler("head");
        this.options = this.buildHandler("options");
        if (typeof value === "string" || value instanceof URL) this.config = Object.freeze({
            baseUrl: new URL(value),
            keepAlive: true
        });
        else {
            const { baseUrl: baseUrl, ...rest } = value;
            this.config = Object.freeze({
                baseUrl: new URL(baseUrl),
                keepAlive: true,
                ...rest
            });
        }
        (0, $0ac74159a57c5b23$export$bef1f36f5486a6a3).debug(this.config);
    }
    buildUrl(pathname, search) {
        const { baseUrl: baseUrl } = this.config;
        const url = new URL((0, $0ac74159a57c5b23$export$a5c6d149b50c1d86)(baseUrl.pathname + pathname), baseUrl.origin);
        // Reassign to search to avoid unexpected `?`
        // eslint-disable-next-line @silverhand/fp/no-mutation
        url.search = (0, $755b24a3f57e744a$export$767cbc91845890d3)(search).toString();
        return url;
    }
    buildPathname(path, parameters) {
        return path.split("/").map((value)=>{
            if (!value.startsWith(":")) return value;
            const key = value.slice(1);
            const parameter = parameters?.[key];
            if (!parameter) throw new TypeError(`URL parameter \`${key}\` not found`);
            return parameter;
        }).join("/");
    }
    async buildHeaders(url, method, body) {
        const { headers: headers } = this.config;
        const needsJson = ![
            (0, $3d495bcb3543e50f$export$8695620d48fe67d).GET,
            (0, $3d495bcb3543e50f$export$8695620d48fe67d).OPTIONS,
            (0, $3d495bcb3543e50f$export$8695620d48fe67d).HEAD
        ].map((value)=>value.toLowerCase()).includes(method) && body !== undefined && body !== null;
        const unwrappedHeaders = typeof headers === "function" ? headers(url, method) : headers;
        return {
            host: url.host,
            accept: (0, $28c798f329c5047e$export$b55ee587147d9da1).json,
            ...needsJson && {
                "content-type": (0, $28c798f329c5047e$export$b55ee587147d9da1).json
            },
            ...(0, $755b24a3f57e744a$export$4369c812aac99591)(unwrappedHeaders) ? await unwrappedHeaders : unwrappedHeaders
        };
    }
    buildHandler(method) {
        const handler = async (path, payload)=>{
            if (typeof path !== "string") throw new TypeError("Path is not string");
            // We treat payload general and use code to make it works as expected
            // Type inference will always fall into the empty object result
            // eslint-disable-next-line no-restricted-syntax
            const { params: params, search: search, body: body } = payload ?? {};
            const pathname = this.buildPathname(path, params);
            const url = this.buildUrl(pathname, search);
            (0, $0ac74159a57c5b23$export$bef1f36f5486a6a3).debug(method.toUpperCase(), url.href);
            const response = await fetch(url, {
                method: method.toUpperCase(),
                headers: await this.buildHeaders(url, method, body),
                body: typeof body === "string" || body === undefined || body === null ? body : JSON.stringify(body)
            });
            if (!response.ok) throw new $33b9cc7fd9279a6b$export$286baf652d0b1206(response);
            if (response.status === 204) // The return type should be `undefined` here since the response code is 204
            // Trust backend since it's a HTTP standard
            // eslint-disable-next-line no-restricted-syntax
            return undefined;
            // Trust backend since it has been guarded
            // eslint-disable-next-line no-restricted-syntax
            return await response.json();
        };
        const withHook = async (...args)=>{
            try {
                return await handler(...args);
            } catch (error) {
                const hook = this.config.before?.error;
                if (!hook) throw error;
                const unwrapped = hook(error);
                const result = (0, $755b24a3f57e744a$export$4369c812aac99591)(unwrapped) ? await unwrapped : unwrapped;
                if (result instanceof Error) throw result;
                throw error;
            }
        };
        return withHook;
    }
}



var $jC8Vy = parcelRequire("jC8Vy");

var $FuhPC = parcelRequire("FuhPC");

var $c3dK3 = parcelRequire("c3dK3");
parcelRequire("8Mb3E");
var $7YcaX = parcelRequire("7YcaX");

var $cDKfs = parcelRequire("cDKfs");
const $1c34cc51be8c93d3$var$responseErrorBodyGuard = (0, $c3dK3.z).object({
    message: (0, $c3dK3.z).string()
});
const $1c34cc51be8c93d3$export$5c32b0b3061e00c4 = async (error)=>(0, $3dBAh.trySafe)(async ()=>{
        // Clone the response to avoid blocking later usage since the response body can only be read once
        const responseBody = await error.response.clone().json();
        return $1c34cc51be8c93d3$var$responseErrorBodyGuard.parse(responseBody);
    });
const $1c34cc51be8c93d3$export$10abc8714a7caf54 = async (error)=>{
    if (error instanceof (0, $33b9cc7fd9279a6b$export$286baf652d0b1206)) {
        const responseBody = await $1c34cc51be8c93d3$export$5c32b0b3061e00c4(error);
        if (responseBody) {
            (0, $FuhPC.toast).error(responseBody.message);
            return;
        }
    }
    (0, $FuhPC.toast)(error instanceof Error ? error.message : String(error));
};
const $1c34cc51be8c93d3$export$7a5c900790855d66 = ({ hideErrorToast: hideErrorToast = false } = {})=>{
    const { isAuthenticated: isAuthenticated, getAccessToken: getAccessToken } = (0, $jSb9j.useLogto)();
    const api = (0, $jC8Vy.useMemo)(()=>new (0, $33b9cc7fd9279a6b$export$2e2bcd8739ae039)({
            baseUrl: window.location.origin,
            headers: async ()=>{
                if (isAuthenticated) return {
                    Authorization: `Bearer ${await getAccessToken((0, $7YcaX.cloudApi).indicator) ?? ""}`
                };
            },
            before: {
                ...(0, $7oDSS.conditional)(!hideErrorToast && {
                    error: $1c34cc51be8c93d3$export$10abc8714a7caf54
                })
            }
        }), [
        getAccessToken,
        hideErrorToast,
        isAuthenticated
    ]);
    return api;
};
const $1c34cc51be8c93d3$export$87a78c52eef20676 = ({ hideErrorToast: hideErrorToast = false, isAuthenticated: isAuthenticated, getOrganizationToken: getOrganizationToken, tenantId: tenantId })=>new (0, $33b9cc7fd9279a6b$export$2e2bcd8739ae039)({
        baseUrl: window.location.origin,
        headers: async ()=>{
            if (isAuthenticated) return {
                Authorization: `Bearer ${await getOrganizationToken((0, $aZIrr.getTenantOrganizationId)(tenantId)) ?? ""}`
            };
        },
        before: {
            ...(0, $7oDSS.conditional)(!hideErrorToast && {
                error: $1c34cc51be8c93d3$export$10abc8714a7caf54
            })
        }
    });
const $1c34cc51be8c93d3$export$ec1abe76789cde12 = ({ hideErrorToast: hideErrorToast = false } = {})=>{
    const { currentTenantId: currentTenantId } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { isAuthenticated: isAuthenticated, getOrganizationToken: getOrganizationToken } = (0, $jSb9j.useLogto)();
    const api = (0, $jC8Vy.useMemo)(()=>$1c34cc51be8c93d3$export$87a78c52eef20676({
            hideErrorToast: hideErrorToast,
            isAuthenticated: isAuthenticated,
            getOrganizationToken: getOrganizationToken,
            tenantId: currentTenantId
        }), [
        currentTenantId,
        getOrganizationToken,
        hideErrorToast,
        isAuthenticated
    ]);
    return api;
};



var $C7mD2 = parcelRequire("C7mD2");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $19cfe35991ba791f$var$SvgLogo = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 154,
        height: 48,
        viewBox: "0 0 154 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2 7.495c0-1.38 0-2.069.267-2.624.236-.489.615-.903 1.092-1.194.542-.33 1.262-.428 2.702-.623L26.596.262c1.864-.254 2.796-.38 3.52-.113.636.235 1.166.67 1.502 1.234.382.642.382 1.535.382 3.32v38.594c0 1.785 0 2.678-.382 3.32-.336.563-.866 1-1.502 1.234-.724.267-1.656.14-3.52-.113L6.06 44.946c-1.44-.195-2.16-.293-2.702-.623a2.854 2.854 0 0 1-1.092-1.194C2 42.574 2 41.884 2 40.505V7.495Zm22 13.013c0-.42 0-.63.07-.796a.788.788 0 0 1 .287-.35c.14-.095.328-.114.701-.152l1.673-.17c.44-.045.66-.067.83.015.15.072.273.198.35.358.089.182.089.43.089.925v7.324c0 .495 0 .743-.088.925a.764.764 0 0 1-.35.358c-.17.082-.39.06-.831.015l-1.673-.17c-.373-.038-.56-.057-.701-.151a.788.788 0 0 1-.287-.35c-.07-.167-.07-.377-.07-.797v-6.984ZM37.644 5H35v39h2.644c1.525 0 2.287 0 2.87-.298.512-.261.928-.679 1.19-1.193.296-.584.296-1.348.296-2.877V9.368c0-1.529 0-2.293-.297-2.877a2.726 2.726 0 0 0-1.19-1.193C39.932 5 39.17 5 37.645 5Z",
                fill: "url(#paint0_linear_1123_6803)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M85.53 36.8c-2.055 0-3.83-.426-5.324-1.28a8.68 8.68 0 0 1-3.443-3.563c-.8-1.548-1.2-3.335-1.2-5.364 0-2.081.413-3.883 1.24-5.404a8.946 8.946 0 0 1 3.483-3.562c1.521-.854 3.296-1.281 5.324-1.281 2.055 0 3.816.427 5.284 1.28a8.947 8.947 0 0 1 3.482 3.563c.828 1.521 1.241 3.31 1.241 5.364 0 2.028-.427 3.816-1.28 5.364-.828 1.548-1.989 2.749-3.483 3.603-1.495.827-3.27 1.254-5.324 1.28Zm.04-3.882c1.12 0 2.081-.28 2.882-.84.8-.561 1.414-1.322 1.841-2.282.454-.961.68-2.042.68-3.243 0-1.227-.213-2.321-.64-3.282-.427-.96-1.04-1.708-1.841-2.242-.8-.56-1.761-.84-2.882-.84-1.067 0-2.015.28-2.842.84-.827.56-1.468 1.321-1.921 2.282-.427.96-.654 2.041-.681 3.242 0 1.228.213 2.322.64 3.283.427.96 1.055 1.72 1.882 2.281.827.534 1.788.8 2.882.8ZM116.582 17.075a.21.21 0 0 0-.209-.209h-4.105a.209.209 0 0 0-.209.21V37.56c0 1.361-.507 2.206-1.521 2.954-.988.747-2.098.991-3.673 1.018-1.094-.027-2.121-.124-3.028-.418a16.907 16.907 0 0 1-2.753-1.103.21.21 0 0 0-.285.098l-1.476 3.146c-.043.09-.015.2.068.256.45.306.977.58 1.58.821a13.9 13.9 0 0 0 2.041.64c.721.187 1.465.343 2.106.423.667.08 1.297.091 1.697.091 2.028 0 3.763-.32 5.204-.96 1.467-.641 2.588-1.549 3.362-2.723.801-1.174 1.201-2.575 1.201-4.203V17.075Zm-3.268 13.259a.214.214 0 0 0-.358-.054c-.785.903-1.583 1.543-2.338 1.957-.801.454-1.722.68-2.762.68-1.068 0-2.002-.266-2.802-.8-.774-.56-1.361-1.32-1.762-2.281-.4-.961-.6-2.069-.6-3.323 0-1.2.2-2.268.6-3.202.401-.96.988-1.721 1.762-2.282.8-.56 1.748-.84 2.842-.84 1.014 0 1.814.213 2.642.64.772.386 1.594 1.268 2.301 2.19.099.127.3.104.363-.045l1.136-2.68a.206.206 0 0 0-.019-.199c-1.434-2.057-3.858-3.75-6.619-3.75-2.001 0-3.58.428-5.048 1.282a8.752 8.752 0 0 0-3.403 3.562c-.773 1.521-1.16 3.296-1.16 5.324 0 2.082.386 3.896 1.16 5.444.774 1.521 1.882 2.709 3.323 3.563 1.468.854 3.202 1.28 5.204 1.28.747 0 1.521-.146 2.321-.44a9.194 9.194 0 0 0 2.402-1.2 9.31 9.31 0 0 0 1.965-1.825.21.21 0 0 0 .029-.21l-1.179-2.791ZM132.061 17.235a.209.209 0 0 0-.209-.209h-4.466a.208.208 0 0 1-.208-.208v-5.46a.21.21 0 0 0-.209-.21h-4.066a.21.21 0 0 0-.209.21v5.46a.208.208 0 0 1-.208.208h-2.72a.21.21 0 0 0-.209.211l.036 3.386a.208.208 0 0 0 .208.206h2.685c.115 0 .208.094.208.209v9.438c0 1.415.281 2.615.841 3.603a5.797 5.797 0 0 0 2.402 2.201c1.014.507 2.241.76 3.682.76.401 0 .828-.053 1.281-.16.481-.106.945-.218 1.345-.379.357-.133 1.054-.483 1.409-.689a.198.198 0 0 0 .07-.269l-1.652-2.912a.215.215 0 0 0-.264-.093 6.283 6.283 0 0 1-.828.251c-.347.08-.694.12-1.04.12-.934 0-1.628-.098-2.082-.712-.454-.64-.68-1.454-.68-2.441v-8.718c0-.115.093-.209.208-.209h4.466a.209.209 0 0 0 .209-.209v-3.385ZM143.913 36.79c-2.055 0-3.83-.426-5.324-1.28a8.68 8.68 0 0 1-3.443-3.563c-.8-1.548-1.201-3.335-1.201-5.364 0-2.081.414-3.882 1.241-5.404a8.949 8.949 0 0 1 3.483-3.562c1.521-.854 3.296-1.281 5.324-1.281 2.055 0 3.816.427 5.284 1.28a8.946 8.946 0 0 1 3.482 3.563c.827 1.522 1.241 3.31 1.241 5.364 0 2.029-.427 3.816-1.281 5.364-.827 1.548-1.988 2.749-3.482 3.603-1.495.827-3.269 1.254-5.324 1.28Zm.04-3.882c1.121 0 2.081-.28 2.882-.84.8-.561 1.414-1.322 1.841-2.282.454-.961.681-2.042.681-3.243 0-1.227-.214-2.321-.641-3.282-.427-.96-1.041-1.708-1.841-2.242-.801-.56-1.761-.84-2.882-.84-1.068 0-2.015.28-2.842.84-.828.56-1.468 1.321-1.922 2.282-.427.96-.654 2.041-.68 3.242 0 1.228.213 2.322.64 3.283.427.96 1.054 1.72 1.882 2.281.827.534 1.788.8 2.882.8ZM73.663 32.758a.209.209 0 0 0-.208-.209H62.652a.209.209 0 0 1-.209-.209V11.314a.209.209 0 0 0-.209-.21H58.21a.209.209 0 0 0-.209.21v25.278c0 .115.093.209.209.209h15.246a.209.209 0 0 0 .208-.21v-3.833Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("defs", {
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                    id: "paint0_linear_1123_6803",
                    x1: -10.381,
                    y1: 33.195,
                    x2: 38.89,
                    y2: 13.054,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            stopColor: "#4B2EFB"
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            offset: 1,
                            stopColor: "#E65FFC"
                        })
                    ]
                })
            })
        ]
    });
var $19cfe35991ba791f$export$2e2bcd8739ae039 = $19cfe35991ba791f$var$SvgLogo;



var $k9Oeh = parcelRequire("k9Oeh");
var $ae5dd494f43693cc$export$34e0f9847d4c02dd;
var $ae5dd494f43693cc$export$bfd64c937657f93a;
var $ae5dd494f43693cc$export$4a6dd88bada4e7d2;
$ae5dd494f43693cc$export$34e0f9847d4c02dd = `FA5ZUG_container`;
$ae5dd494f43693cc$export$bfd64c937657f93a = `FA5ZUG_rotating`;
$ae5dd494f43693cc$export$4a6dd88bada4e7d2 = `FA5ZUG_shimmer`;


function $4c070a72a1cf87ce$var$AppLoading() {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $ae5dd494f43693cc$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $19cfe35991ba791f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $k9Oeh.Daisy), {})
        ]
    });
}
var $4c070a72a1cf87ce$export$2e2bcd8739ae039 = $4c070a72a1cf87ce$var$AppLoading;



var $8Mb3E = parcelRequire("8Mb3E");

var $cDKfs = parcelRequire("cDKfs");

var $azCDQ = parcelRequire("azCDQ");
parcelRequire("12bMu");
var $3dBAh = parcelRequire("3dBAh");

var $c3dK3 = parcelRequire("c3dK3");
parcelRequire("8Mb3E");
var $fb30i = parcelRequire("fb30i");
const $fb6222c61a959560$export$5027ce2731efc4b9 = ()=>{
    const { pathname: pathname, search: search, hash: hash } = window.location;
    sessionStorage.setItem((0, $fb30i.storageKeys).redirectAfterSignIn, JSON.stringify({
        pathname: pathname,
        search: search,
        hash: hash
    }));
};
const $fb6222c61a959560$var$partialPathGuard = (0, $c3dK3.z).object({
    pathname: (0, $c3dK3.z).string(),
    search: (0, $c3dK3.z).string(),
    hash: (0, $c3dK3.z).string()
}).partial();
const $fb6222c61a959560$export$51826bb55f5be139 = ()=>{
    const saved = (0, $3dBAh.trySafe)(()=>$fb6222c61a959560$var$partialPathGuard.parse(JSON.parse(sessionStorage.getItem((0, $fb30i.storageKeys).redirectAfterSignIn) ?? "")));
    if (saved) sessionStorage.removeItem((0, $fb30i.storageKeys).redirectAfterSignIn);
    return saved;
};


function $0479ccdfd7d68c85$export$2e2bcd8739ae039() {
    const api = (0, $1c34cc51be8c93d3$export$7a5c900790855d66)();
    const [searchParameters] = (0, $6bq3s.useSearchParams)();
    const { isAuthenticated: isAuthenticated, isLoading: isLoading, signIn: signIn } = (0, $jSb9j.useLogto)();
    const { isInitComplete: isInitComplete, resetTenants: resetTenants } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const redirectUri = (0, $azCDQ.default)();
    const match = (0, $2Phw0.useMatch)("/accept/:invitationId");
    (0, $jC8Vy.useEffect)(()=>{
        if (!isLoading && !isAuthenticated) {
            (0, $fb6222c61a959560$export$5027ce2731efc4b9)();
            const isInvitationLink = Boolean(match?.pathname.startsWith("/accept/"));
            const isSignUpMode = (0, $l0I3U.yes)(searchParameters.get((0, $8Mb3E.searchKeys).signUp)) || isInvitationLink;
            signIn(redirectUri.href, (0, $7oDSS.conditional)(isSignUpMode && "signUp"));
        }
    }, [
        redirectUri,
        isAuthenticated,
        isLoading,
        searchParameters,
        signIn,
        match?.pathname
    ]);
    (0, $jC8Vy.useEffect)(()=>{
        if (isAuthenticated && !isInitComplete) {
            const loadTenants = async ()=>{
                const data = await api.get("/api/tenants");
                resetTenants(data);
            };
            loadTenants();
        }
    }, [
        api,
        isAuthenticated,
        isInitComplete,
        resetTenants
    ]);
    if (!isInitComplete || !isAuthenticated) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4c070a72a1cf87ce$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Outlet), {});
}



var $cDKfs = parcelRequire("cDKfs");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");

var $jC8Vy = parcelRequire("jC8Vy");

var $2Phw0 = parcelRequire("2Phw0");


var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
parcelRequire("hNGhh");
var $cOUYQ = parcelRequire("cOUYQ");
var $eRB1v = parcelRequire("eRB1v");

var $c3dK3 = parcelRequire("c3dK3");
const $d0ac6062762557f2$var$application = {
    invalid_type: "Nur Maschinen-zu-Maschinen-Anwendungen k\xf6nnen Rollen haben.",
    role_exists: "Die Rolle mit der ID {{roleId}} wurde bereits dieser Anwendung hinzugef\xfcgt.",
    invalid_role_type: "Es ist nicht m\xf6glich, einer Maschinen-zu-Maschinen-Anwendung eine Benutzertyp-Rolle zuzuweisen.",
    invalid_third_party_application_type: "Nur traditionelle Webanwendungen k\xf6nnen als Drittanbieter-App markiert werden.",
    third_party_application_only: "Das Feature ist nur f\xfcr Drittanbieter-Anwendungen verf\xfcgbar.",
    user_consent_scopes_not_found: "Ung\xfcltige Benutzerzustimmungsbereiche.",
    consent_management_api_scopes_not_allowed: "Management API scopes are not allowed.",
    protected_app_metadata_is_required: "Gesch\xfctzte App-Metadaten sind erforderlich.",
    protected_app_not_configured: "Gesch\xfctzter App-Anbieter ist nicht konfiguriert. Dieses Feature ist in der Open-Source-Version nicht verf\xfcgbar.",
    cloudflare_unknown_error: "Fehler unbekannt beim Abrufen der Cloudflare API",
    protected_application_only: "Das Feature ist nur f\xfcr gesch\xfctzte Anwendungen verf\xfcgbar.",
    protected_application_misconfigured: "Gesch\xfctzte Anwendung falsch konfiguriert.",
    protected_application_subdomain_exists: "Die Subdomain der gesch\xfctzten Anwendung wird bereits verwendet.",
    invalid_subdomain: "Ung\xfcltige Subdomain.",
    custom_domain_not_found: "Benutzerdefinierte Domain nicht gefunden.",
    should_delete_custom_domains_first: "Benutzerdefinierte Domains sollten zuerst gel\xf6scht werden."
};
var $d0ac6062762557f2$export$2e2bcd8739ae039 = Object.freeze($d0ac6062762557f2$var$application);


const $d2421d2d5dffebf1$var$auth = {
    authorization_header_missing: "Autorisierungs-Header fehlt.",
    authorization_token_type_not_supported: "Autorisierungs-Typ wird nicht unterst\xfctzt.",
    unauthorized: "Unautorisiert. Bitte \xfcberpr\xfcfe deine Zugangsdaten.",
    forbidden: "Verboten. Bitte \xfcberpr\xfcfe deine Rollen und Berechtigungen.",
    expected_role_not_found: "Erwartete Rolle nicht gefunden. Bitte \xfcberpr\xfcfe deine Rollen und Berechtigungen.",
    jwt_sub_missing: "`sub` fehlt in JWT.",
    require_re_authentication: "Zur Durchf\xfchrung einer gesch\xfctzten Aktion ist eine erneute Authentifizierung erforderlich."
};
var $d2421d2d5dffebf1$export$2e2bcd8739ae039 = Object.freeze($d2421d2d5dffebf1$var$auth);


const $f6cfc410b96e42fc$var$connector = {
    general: "Fehler aufgetreten im Connector: {{errorDescription}}",
    not_found: "Kein verf\xfcgbarer Connector f\xfcr Typ {{type}} gefunden.",
    not_enabled: "Der Connector ist nicht aktiviert.",
    invalid_metadata: "Die Metadaten des Connectors sind ung\xfcltig.",
    invalid_config_guard: "Die Konfiguration des Connectors ist ung\xfcltig.",
    unexpected_type: "Der Typ des Connectors ist unerwartet.",
    invalid_request_parameters: "Die Anfrage enth\xe4lt falsche Eingabeparameter.",
    insufficient_request_parameters: "Die Anfrage enth\xe4lt m\xf6glicherweise nicht alle erforderlichen Eingabeparameter.",
    invalid_config: "Die Konfiguration des Connectors ist ung\xfcltig.",
    invalid_certificate: "Das Zertifikat des Connectors ist ung\xfcltig, bitte stellen Sie sicher, dass das Zertifikat im PEM-Format vorliegt.",
    invalid_response: "Die Antwort des Connectors ist ung\xfcltig.",
    template_not_found: "Die richtige Vorlage in der Connector-Konfiguration konnte nicht gefunden werden.",
    template_not_supported: "Der Connector unterst\xfctzt diesen Vorlagentyp nicht.",
    rate_limit_exceeded: "Ausl\xf6ser-Rate-Limit. Bitte versuchen Sie es sp\xe4ter erneut.",
    not_implemented: "{{method}}: wurde noch nicht implementiert.",
    social_invalid_access_token: "Der Access Token des Connectors ist ung\xfcltig.",
    invalid_auth_code: "Der Authentifizierungscode des Connectors ist ung\xfcltig.",
    social_invalid_id_token: "Der ID-Token des Connectors ist ung\xfcltig.",
    authorization_failed: "Der Autorisierungsprozess des Benutzers war erfolglos.",
    social_auth_code_invalid: "Es konnte kein Access Token abgerufen werden. Bitte pr\xfcfen Sie den Autorisierungscode.",
    more_than_one_sms: "Die Anzahl der SMS-Connectors ist gr\xf6\xdfer als 1.",
    more_than_one_email: "Die Anzahl der E-Mail-Connectors ist gr\xf6\xdfer als 1.",
    more_than_one_connector_factory: "Mehrere Connector-Fabriken gefunden (mit ID {{connectorIds}}). Sie k\xf6nnen unn\xf6tige Fabriken deinstallieren.",
    db_connector_type_mismatch: "Es gibt einen Connector in der Datenbank, der nicht dem Typ entspricht.",
    not_found_with_connector_id: "Connector mit der angegebenen Standard-Connector-ID konnte nicht gefunden werden.",
    multiple_instances_not_supported: "Es k\xf6nnen keine mehreren Instanzen mit dem ausgew\xe4hlten Standard-Connector erstellt werden.",
    invalid_type_for_syncing_profile: "Sie k\xf6nnen nur Benutzerprofile mit sozialen Connectors synchronisieren.",
    can_not_modify_target: "Der 'target'-Connector kann nicht ge\xe4ndert werden.",
    should_specify_target: "Sie sollten den 'target' angeben.",
    multiple_target_with_same_platform: "Sie k\xf6nnen keine mehreren sozialen Connectors haben, die das gleiche Ziel und die gleiche Plattform haben.",
    cannot_overwrite_metadata_for_non_standard_connector: "Die 'Metadaten' dieses Connectors k\xf6nnen nicht \xfcberschrieben werden."
};
var $f6cfc410b96e42fc$export$2e2bcd8739ae039 = Object.freeze($f6cfc410b96e42fc$var$connector);


const $a02aba944128a974$var$domain = {
    not_configured: "Der Domain-Hostname-Anbieter ist nicht konfiguriert.",
    cloudflare_data_missing: "cloudflare_data fehlt, bitte \xfcberpr\xfcfen Sie es.",
    cloudflare_unknown_error: "Beim Anfordern der Cloudflare-API ist ein unbekannter Fehler aufgetreten",
    cloudflare_response_error: "Vom Cloudflare wurde eine unerwartete Antwort erhalten.",
    limit_to_one_domain: "Sie k\xf6nnen nur eine benutzerdefinierte Domain haben.",
    hostname_already_exists: "Diese Domain existiert bereits auf unserem Server.",
    cloudflare_not_found: "Hostname in Cloudflare nicht gefunden",
    domain_is_not_allowed: "Diese Domain ist nicht zul\xe4ssig."
};
var $a02aba944128a974$export$2e2bcd8739ae039 = Object.freeze($a02aba944128a974$var$domain);


const $84a4a05679b3659d$var$entity = {
    invalid_input: "Ung\xfcltige Eingabe. Wertliste darf nicht leer sein.",
    create_failed: "Fehler beim Erstellen von {{name}}.",
    db_constraint_violated: "Datenbankbeschr\xe4nkung verletzt.",
    not_exists: "{{name}} existiert nicht.",
    not_exists_with_id: "{{name}} mit ID `{{id}}` existiert nicht.",
    not_found: "Die Ressource wurde nicht gefunden.",
    relation_foreign_key_not_found: "Ein oder mehrere Fremdschl\xfcssel konnten nicht gefunden werden. Bitte \xfcberpr\xfcfen Sie die Eingabe und stellen Sie sicher, dass alle referenzierten Eintr\xe4ge vorhanden sind.",
    unique_integrity_violation: "Die Entit\xe4t besteht bereits. Bitte \xfcberpr\xfcfen Sie die Eingabe und versuchen Sie es erneut."
};
var $84a4a05679b3659d$export$2e2bcd8739ae039 = Object.freeze($84a4a05679b3659d$var$entity);


const $8a99301d5c1a8e9b$var$guard = {
    invalid_input: "Die Anfrage {{type}} ist ung\xfcltig.",
    invalid_pagination: "Die Paginierung der Anfrage ist ung\xfcltig.",
    can_not_get_tenant_id: "Die tenant_id konnte nicht aus der Anfrage abgerufen werden.",
    file_size_exceeded: "Dateigr\xf6\xdfe \xfcberschritten.",
    mime_type_not_allowed: "Der MIME-Typ ist nicht erlaubt."
};
var $8a99301d5c1a8e9b$export$2e2bcd8739ae039 = Object.freeze($8a99301d5c1a8e9b$var$guard);


const $991604d01e73dd84$var$hook = {
    missing_events: "Sie m\xfcssen mindestens ein Ereignis angeben.",
    send_test_payload_failed: "Fehler beim Senden des Testpayloads: {{message}}",
    endpoint_responded_with_error: "Endpunkt antwortete mit Fehler."
};
var $991604d01e73dd84$export$2e2bcd8739ae039 = Object.freeze($991604d01e73dd84$var$hook);


const $4569e2452c7faf7e$var$jwt_customizer = {
    general: "Bei der Anpassung des JWT-Tokens ist ein Fehler aufgetreten. Bitte versuchen Sie es sp\xe4ter erneut.",
    can_not_create_for_admin_tenant: "Kann keinen JWT-Token-Anpasser f\xfcr den Admin-Mandanten erstellen."
};
var $4569e2452c7faf7e$export$2e2bcd8739ae039 = Object.freeze($4569e2452c7faf7e$var$jwt_customizer);


const $2ead92764c8916c3$var$localization = {
    cannot_delete_default_language: "{{languageTag}} ist die Standard-Sprache und kann nicht gel\xf6scht werden.",
    invalid_translation_structure: "Ung\xfcltige \xdcbersetzungsstruktur. Bitte \xfcberpr\xfcfe deine Eingabe."
};
var $2ead92764c8916c3$export$2e2bcd8739ae039 = Object.freeze($2ead92764c8916c3$var$localization);


const $fa0bcb2d23fa091e$var$log = {
    invalid_type: "Der Log Typ ist ung\xfcltig."
};
var $fa0bcb2d23fa091e$export$2e2bcd8739ae039 = Object.freeze($fa0bcb2d23fa091e$var$log);


const $f10a93204d8a8af9$var$oidc = {
    aborted: "Der Endnutzer hat die Interaktion abgebrochen.",
    invalid_scope: "Ung\xfcltiger Anwendungsbereich: {{error_description}}.",
    invalid_token: "Ung\xfcltiger Token \xfcbermittelt.",
    invalid_client_metadata: "Ung\xfcltige Client Metadaten \xfcbermittelt.",
    insufficient_scope: "Token fehlt den Anwendungsbereich `{{scope}}`.",
    invalid_request: "Anfrage ist ung\xfcltig.",
    invalid_grant: "Grant Anfrage ist ung\xfcltig.",
    invalid_redirect_uri: "`redirect_uri` stimmt nicht mit den registrierten `redirect_uris` des Clients \xfcberein.",
    access_denied: "Zugang verweigert.",
    invalid_target: "Ung\xfcltiger Ressourcenindikator.",
    unsupported_grant_type: "Nicht unterst\xfctzter `grant_type` angefragt.",
    unsupported_response_mode: "Nicht unterst\xfctzter `response_mode` angefragt.",
    unsupported_response_type: "Nicht unterst\xfctzter `response_type` angefragt.",
    provider_error: "OIDC interner Fehler: {{message}}.",
    server_error: "Ein unbekannter OIDC Fehler ist aufgetreten. Bitte versuchen Sie es sp\xe4ter erneut.",
    provider_error_fallback: "Ein OIDC Fehler ist aufgetreten: {{code}}.",
    key_required: "Mindestens ein Schl\xfcssel ist erforderlich.",
    key_not_found: "Der Schl\xfcssel mit der ID {{id}} wurde nicht gefunden."
};
var $f10a93204d8a8af9$export$2e2bcd8739ae039 = Object.freeze($f10a93204d8a8af9$var$oidc);


const $ec624cc27c830a29$var$organization = {
    require_membership: "Der Benutzer muss Mitglied der Organisation sein, um fortzufahren."
};
var $ec624cc27c830a29$export$2e2bcd8739ae039 = Object.freeze($ec624cc27c830a29$var$organization);


const $f0b56bc7def0504c$var$password = {
    unsupported_encryption_method: "Die Verschl\xfcsselungsmethode {{name}} wird nicht unterst\xfctzt.",
    pepper_not_found: "Password pepper not found. Please check your core envs.",
    rejected: "Das Passwort wurde abgelehnt. Bitte \xfcberpr\xfcfen Sie, ob Ihr Passwort den Anforderungen entspricht."
};
var $f0b56bc7def0504c$export$2e2bcd8739ae039 = Object.freeze($f0b56bc7def0504c$var$password);


const $5261c2480d87ac3a$var$request = {
    invalid_input: "Eingabe ist ung\xfcltig. {{details}}",
    general: "Es ist ein Fehler bei der Anfrage aufgetreten."
};
var $5261c2480d87ac3a$export$2e2bcd8739ae039 = Object.freeze($5261c2480d87ac3a$var$request);


const $dceffa45fca9984e$var$resource = {
    resource_identifier_in_use: "Die API-Kennung {{indicator}} wird bereits verwendet",
    cannot_delete_management_api: "Kann das Logto-Management-API nicht l\xf6schen.",
    cannot_modify_management_api: "Kann das Logto-Management-API nicht \xe4ndern."
};
var $dceffa45fca9984e$export$2e2bcd8739ae039 = Object.freeze($dceffa45fca9984e$var$resource);


const $28a7f4b13b5b1f7f$var$role = {
    name_in_use: "Dieser Rollenname {{name}} wird bereits verwendet.",
    scope_exists: "Die Scope-ID {{scopeId}} wurde bereits zu dieser Rolle hinzugef\xfcgt.",
    management_api_scopes_not_assignable_to_user_role: "Kann management API Scopes nicht einem Benutzerrolle zuweisen.",
    user_exists: "Die Benutzer-ID {{userId}} wurde bereits zu dieser Rolle hinzugef\xfcgt.",
    application_exists: "Die Anwendungs-ID {{applicationId}} wurde bereits zu dieser Rolle hinzugef\xfcgt.",
    default_role_missing: "Einige der Standardrollennamen sind in der Datenbank nicht vorhanden. Bitte stellen Sie sicher, dass Sie zuerst Rollen erstellen.",
    internal_role_violation: 'Sie versuchen m\xf6glicherweise, eine interne Rolle zu aktualisieren oder zu l\xf6schen, was von Logto verboten ist. Wenn Sie eine neue Rolle erstellen, versuchen Sie es mit einem anderen Namen, der nicht mit "#internal:" beginnt.'
};
var $28a7f4b13b5b1f7f$export$2e2bcd8739ae039 = Object.freeze($28a7f4b13b5b1f7f$var$role);


const $65763208b635abce$var$scope = {
    name_exists: "Der Scope-Name {{name}} ist bereits in Verwendung",
    name_with_space: "Der Name des Scopes darf keine Leerzeichen enthalten."
};
var $65763208b635abce$export$2e2bcd8739ae039 = Object.freeze($65763208b635abce$var$scope);


const $90d642ef3e5fd5a4$var$session = {
    not_found: "Sitzung nicht gefunden. Bitte melde dich erneut an.",
    invalid_credentials: "Ung\xfcltige Zugangsdaten. \xdcberpr\xfcfe deine Eingaben.",
    invalid_sign_in_method: "Aktuelle Anmeldemethode ist ung\xfcltig.",
    invalid_connector_id: "Connector mit ID {{connectorId}} wurde nicht gefunden.",
    insufficient_info: "Unzureichende Informationen f\xfcr die Anmeldung.",
    connector_id_mismatch: "Connector ID stimmt nicht mit Sitzung \xfcberein.",
    connector_session_not_found: "Connector Sitzung nicht gefunden. Bitte melde dich erneut an.",
    verification_session_not_found: "Die Verifizierung war nicht erfolgreich. Starte die Verifizierung neu und versuche es erneut.",
    verification_expired: "Die Verbindung wurde unterbrochen. Verifiziere erneut, um die Sicherheit deines Kontos zu gew\xe4hrleisten.",
    verification_blocked_too_many_attempts: "Zu viele Versuche in kurzer Zeit. Bitte versuche es erneut {{relativeTime}}.",
    unauthorized: "Bitte melde dich erst an.",
    unsupported_prompt_name: "Nicht unterst\xfctzter prompt Name.",
    forgot_password_not_enabled: "Passwort vergessen ist nicht aktiviert.",
    verification_failed: "Die Verifizierung war nicht erfolgreich. Starte die Verifizierung neu und versuche es erneut.",
    connector_validation_session_not_found: "Die Connector-Sitzung zur Token-Validierung wurde nicht gefunden.",
    identifier_not_found: "Benutzerkennung nicht gefunden. Bitte gehen Sie zur\xfcck und melden Sie sich erneut an.",
    interaction_not_found: "Interaktionssitzung nicht gefunden. Bitte gehen Sie zur\xfcck und starten Sie die Sitzung erneut.",
    not_supported_for_forgot_password: "Diese Operation wird f\xfcr das vergessene Passwort nicht unterst\xfctzt.",
    mfa: {
        require_mfa_verification: "MFA-Verifizierung ist erforderlich, um sich anzumelden.",
        mfa_sign_in_only: "MFA ist nur f\xfcr die Anmeldeinteraktion verf\xfcgbar.",
        pending_info_not_found: "Ausstehende MFA-Informationen nicht gefunden. Bitte initiieren Sie zuerst MFA.",
        invalid_totp_code: "Ung\xfcltiger TOTP-Code.",
        webauthn_verification_failed: "WebAuthn-Verifizierung fehlgeschlagen.",
        webauthn_verification_not_found: "WebAuthn-Verifizierung nicht gefunden.",
        bind_mfa_existed: "MFA ist bereits vorhanden.",
        backup_code_can_not_be_alone: "Backup-Code kann nicht die einzige MFA sein.",
        backup_code_required: "Backup-Code ist erforderlich.",
        invalid_backup_code: "Ung\xfcltiger Backup-Code.",
        mfa_policy_not_user_controlled: "MFA-Richtlinie wird nicht vom Benutzer gesteuert."
    },
    sso_enabled: "Einmaliges Anmelden ist f\xfcr diese gegebene E-Mail aktiviert. Bitte melden Sie sich mit SSO an."
};
var $90d642ef3e5fd5a4$export$2e2bcd8739ae039 = Object.freeze($90d642ef3e5fd5a4$var$session);


const $a4581eb4d29454dc$var$sign_in_experiences = {
    empty_content_url_of_terms_of_use: 'Leere "Nutzungsbedingungen" URL. Bitte f\xfcge die URL hinzu, wenn "Nutzungsbedingungen" aktiviert ist.',
    empty_social_connectors: "Leere Social Connectors. Bitte f\xfcge aktivierte Social Connectoren hinzu, wenn Social Anmeldung aktiviert ist.",
    enabled_connector_not_found: "Aktivierter {{type}} Connector nicht gefunden.",
    not_one_and_only_one_primary_sign_in_method: "Es darf nur eine prim\xe4re Anmeldemethode geben. Bitte \xfcberpr\xfcfe deine Eingabe.",
    username_requires_password: "Muss ein Passwort f\xfcr den Benutzernamen zur Registrierung aktivieren.",
    passwordless_requires_verify: "Muss die Verifizierung f\xfcr die Registrierung per E-Mail/Telefon aktivieren.",
    miss_sign_up_identifier_in_sign_in: "Anmeldeverfahren m\xfcssen den Registrierungs-Identifier enthalten.",
    password_sign_in_must_be_enabled: "Die Passwort-Anmeldung muss aktiviert sein, wenn bei der Registrierung ein Passwort festgelegt wird.",
    code_sign_in_must_be_enabled: "Die Anmeldung mit Best\xe4tigungscode muss aktiviert sein, wenn bei der Registrierung kein Passwort festgelegt wird.",
    unsupported_default_language: "Die Sprache - {{language}} wird momentan nicht unterst\xfctzt.",
    at_least_one_authentication_factor: "Sie m\xfcssen mindestens einen Authentifizierungsfaktor ausw\xe4hlen.",
    backup_code_cannot_be_enabled_alone: "Backup-Code kann nicht alleine aktiviert werden.",
    duplicated_mfa_factors: "Duplizierte MFA-Faktoren."
};
var $a4581eb4d29454dc$export$2e2bcd8739ae039 = Object.freeze($a4581eb4d29454dc$var$sign_in_experiences);


const $6c85bc8e1720b95e$var$single_sign_on = {
    forbidden_domains: "\xd6ffentliche E-Mail-Dom\xe4nen sind nicht erlaubt.",
    duplicated_domains: "Es gibt doppelte Dom\xe4nen.",
    invalid_domain_format: "Ung\xfcltiges Dom\xe4nenformat.",
    duplicate_connector_name: "Connector name already exists. Bitte w\xe4hlen Sie einen anderen Namen."
};
var $6c85bc8e1720b95e$export$2e2bcd8739ae039 = Object.freeze($6c85bc8e1720b95e$var$single_sign_on);


const $69462dfaf33777d6$var$storage = {
    not_configured: "Der Storage-Anbieter ist nicht konfiguriert.",
    missing_parameter: "Fehlender Parameter {{parameter}} f\xfcr den Storage-Anbieter.",
    upload_error: "Das Hochladen der Datei zum Storage-Anbieter ist fehlgeschlagen."
};
var $69462dfaf33777d6$export$2e2bcd8739ae039 = Object.freeze($69462dfaf33777d6$var$storage);


const $08691ca8065e5a23$var$subscription = {
    limit_exceeded: "Sie haben das Limit Ihres Abonnementplans erreicht.",
    get_plan_failed: "Fehler beim Abrufen des Abonnementplans f\xfcr den Mandanten.",
    tenant_suspended: "Mandant ist gesperrt. Bitte kontaktieren Sie Ihren Administrator."
};
var $08691ca8065e5a23$export$2e2bcd8739ae039 = Object.freeze($08691ca8065e5a23$var$subscription);


const $4faf3ee4a0639687$var$swagger = {
    invalid_zod_type: "Ung\xfcltiger Zod Typ. \xdcberpr\xfcfe deine route guard Konfiguration.",
    not_supported_zod_type_for_params: "Nicht unterst\xfctzter Zod Typ f\xfcr diese Parameter. \xdcberpr\xfcfe deine route guard Konfiguration."
};
var $4faf3ee4a0639687$export$2e2bcd8739ae039 = Object.freeze($4faf3ee4a0639687$var$swagger);


const $c56a17fdcec3efa3$var$user = {
    username_already_in_use: "Dieser Benutzername wird bereits verwendet.",
    email_already_in_use: "Diese E-Mail-Adresse ist mit einem vorhandenen Konto verkn\xfcpft.",
    phone_already_in_use: "Diese Telefonnummer ist mit einem vorhandenen Konto verkn\xfcpft.",
    invalid_email: "Ung\xfcltige E-Mail.",
    invalid_phone: "Ung\xfcltige Telefonnummer.",
    email_not_exist: "Die E-Mail wurde noch nicht registriert.",
    phone_not_exist: "Die Telefonnummer wurde noch nicht registriert.",
    identity_not_exist: "Die Identit\xe4t wurde noch nicht registriert.",
    identity_already_in_use: "Die Identit\xe4t wurde registriert.",
    social_account_exists_in_profile: "Sie haben diesen Social-Media-Account bereits verkn\xfcpft.",
    cannot_delete_self: "Du kannst dich nicht selbst l\xf6schen.",
    sign_up_method_not_enabled: "Diese Anmeldeart ist nicht aktiviert.",
    sign_in_method_not_enabled: "Diese Anmeldemethode ist nicht aktiviert.",
    same_password: "Das neue Passwort muss sich vom alten unterscheiden.",
    password_required_in_profile: "Sie m\xfcssen ein Passwort festlegen, bevor Sie sich anmelden k\xf6nnen.",
    new_password_required_in_profile: "Sie m\xfcssen ein neues Passwort festlegen.",
    password_exists_in_profile: "Das Passwort ist bereits in Ihrem Profil vorhanden.",
    username_required_in_profile: "Sie m\xfcssen einen Benutzernamen festlegen, bevor Sie sich anmelden k\xf6nnen.",
    username_exists_in_profile: "Der Benutzername ist bereits in Ihrem Profil vorhanden.",
    email_required_in_profile: "Sie m\xfcssen eine E-Mail-Adresse hinzuf\xfcgen, bevor Sie sich anmelden k\xf6nnen.",
    email_exists_in_profile: "Ihr Profil ist bereits mit einer E-Mail-Adresse verkn\xfcpft.",
    phone_required_in_profile: "Sie m\xfcssen eine Telefonnummer hinzuf\xfcgen, bevor Sie sich anmelden k\xf6nnen.",
    phone_exists_in_profile: "Ihr Profil ist bereits mit einer Telefonnummer verkn\xfcpft.",
    email_or_phone_required_in_profile: "Sie m\xfcssen eine E-Mail-Adresse oder eine Telefonnummer hinzuf\xfcgen, bevor Sie sich anmelden k\xf6nnen.",
    suspended: "Dieses Konto wurde gesperrt.",
    user_not_exist: "Der Benutzer mit {{ identifier }} existiert nicht.",
    missing_profile: "Sie m\xfcssen zus\xe4tzliche Informationen angeben, bevor Sie sich anmelden k\xf6nnen.",
    role_exists: "Die Rollen-ID {{roleId}} wurde diesem Benutzer bereits hinzugef\xfcgt.",
    invalid_role_type: "Ung\xfcltiger Rollentyp, kann keine Maschinen-zu-Maschinen-Rolle einem Benutzer zuweisen.",
    missing_mfa: "Sie m\xfcssen zus\xe4tzliches MFA verbinden, bevor Sie sich anmelden k\xf6nnen.",
    totp_already_in_use: "TOTP wird bereits verwendet.",
    backup_code_already_in_use: "Backup-Code wird bereits verwendet.",
    password_algorithm_required: "Password-Algorithmus ist erforderlich.",
    password_and_digest: "Sie k\xf6nnen nicht sowohl das Passwort im Klartext als auch den Passwort-Hash festlegen."
};
var $c56a17fdcec3efa3$export$2e2bcd8739ae039 = Object.freeze($c56a17fdcec3efa3$var$user);


const $4d8af58c1121acfa$var$verification_code = {
    phone_email_empty: "Sowohl Telefon als auch E-Mail sind leer.",
    not_found: "Best\xe4tigungscode nicht gefunden. Bitte senden Sie zuerst den Best\xe4tigungscode.",
    phone_mismatch: "Telefonnummer stimmt nicht \xfcberein. Bitte fordern Sie einen neuen Best\xe4tigungscode an.",
    email_mismatch: "E-Mail stimmt nicht \xfcberein. Bitte fordern Sie einen neuen Best\xe4tigungscode an.",
    code_mismatch: "Ung\xfcltiger Best\xe4tigungscode.",
    expired: "Best\xe4tigungscode ist abgelaufen. Bitte fordern Sie einen neuen Best\xe4tigungscode an.",
    exceed_max_try: "Die Begrenzung f\xfcr die Anzahl der Best\xe4tigungscode-Wiederholungen wurde \xfcberschritten. Bitte fordern Sie einen neuen Best\xe4tigungscode an."
};
var $4d8af58c1121acfa$export$2e2bcd8739ae039 = Object.freeze($4d8af58c1121acfa$var$verification_code);


const $c4f26808119fd9b9$var$errors = {
    request: $5261c2480d87ac3a$export$2e2bcd8739ae039,
    auth: $d2421d2d5dffebf1$export$2e2bcd8739ae039,
    guard: $8a99301d5c1a8e9b$export$2e2bcd8739ae039,
    oidc: $f10a93204d8a8af9$export$2e2bcd8739ae039,
    user: $c56a17fdcec3efa3$export$2e2bcd8739ae039,
    password: $f0b56bc7def0504c$export$2e2bcd8739ae039,
    session: $90d642ef3e5fd5a4$export$2e2bcd8739ae039,
    connector: $f6cfc410b96e42fc$export$2e2bcd8739ae039,
    verification_code: $4d8af58c1121acfa$export$2e2bcd8739ae039,
    sign_in_experiences: $a4581eb4d29454dc$export$2e2bcd8739ae039,
    jwt_customizer: $4569e2452c7faf7e$export$2e2bcd8739ae039,
    localization: $2ead92764c8916c3$export$2e2bcd8739ae039,
    swagger: $4faf3ee4a0639687$export$2e2bcd8739ae039,
    entity: $84a4a05679b3659d$export$2e2bcd8739ae039,
    log: $fa0bcb2d23fa091e$export$2e2bcd8739ae039,
    role: $28a7f4b13b5b1f7f$export$2e2bcd8739ae039,
    scope: $65763208b635abce$export$2e2bcd8739ae039,
    storage: $69462dfaf33777d6$export$2e2bcd8739ae039,
    resource: $dceffa45fca9984e$export$2e2bcd8739ae039,
    hook: $991604d01e73dd84$export$2e2bcd8739ae039,
    domain: $a02aba944128a974$export$2e2bcd8739ae039,
    subscription: $08691ca8065e5a23$export$2e2bcd8739ae039,
    application: $d0ac6062762557f2$export$2e2bcd8739ae039,
    organization: $ec624cc27c830a29$export$2e2bcd8739ae039,
    single_sign_on: $6c85bc8e1720b95e$export$2e2bcd8739ae039
};
var $c4f26808119fd9b9$export$2e2bcd8739ae039 = Object.freeze($c4f26808119fd9b9$var$errors);


const $a8bf986696df22b5$var$api_resource_details = {
    page_title: "API Ressourcendetails",
    back_to_api_resources: "Zur\xfcck zu API Ressourcen",
    general_tab: "Allgemein",
    permissions_tab: "Berechtigungen",
    settings: "Einstellungen",
    settings_description: "API-Ressourcen, auch Ressourcenindikatoren genannt, geben die Ziel-Dienste oder Ressourcen an, die angefordert werden sollen. H\xe4ufig handelt es sich um eine URI-Formatvariable, die die Identit\xe4t der Ressource darstellt.",
    management_api_settings_description: "Die Logto Management-API ist eine umfassende Sammlung von APIs, die Administratoren bef\xe4higen, eine Vielzahl von Aufgaben im Zusammenhang mit Identit\xe4ten zu verwalten, Sicherheitsrichtlinien durchzusetzen und Vorschriften und Standards einzuhalten.",
    management_api_notice: "Diese API repr\xe4sentiert die Logto-Entit\xe4t und kann nicht ge\xe4ndert oder gel\xf6scht werden. Erstellen Sie eine Maschine-zu-Maschine-App, um die Logto-Management-API aufzurufen. <a>Erfahren Sie mehr</a>",
    token_expiration_time_in_seconds: "Token-Ablaufzeit (in Sekunden)",
    token_expiration_time_in_seconds_placeholder: "Geben Sie die Ablaufzeit des Tokens ein",
    delete_description: "Diese Aktion kann nicht r\xfcckg\xe4ngig gemacht werden. Die API-Ressource wird permanent gel\xf6scht. Bitte geben Sie den API-Ressourcennamen <span>{{name}}</span> zur Best\xe4tigung ein.",
    enter_your_api_resource_name: "Geben Sie einen API-Ressourcennamen ein",
    api_resource_deleted: "Die API-Ressource {{name}} wurde erfolgreich gel\xf6scht",
    permission: {
        create_button: "Berechtigung erstellen",
        create_title: "Berechtigung erstellen",
        create_subtitle: "Definieren Sie die ben\xf6tigten Berechtigungen (Bereiche) f\xfcr diese API.",
        confirm_create: "Berechtigung erstellen",
        edit_title: "Berechtigung bearbeiten",
        edit_subtitle: "Definieren Sie die Berechtigungen (Scopes) der {{resourceName}} API.",
        name: "Berechtigungsname",
        name_placeholder: "read:resource",
        forbidden_space_in_name: "Der Berechtigungsname darf keine Leerzeichen enthalten.",
        description: "Beschreibung",
        description_placeholder: "Zugriff auf Ressourcen lesen",
        permission_created: "Die Berechtigung {{name}} wurde erfolgreich erstellt",
        delete_description: "Wenn diese Berechtigung gel\xf6scht wird, verliert der Benutzer, der diese Berechtigung hatte, den dadurch gew\xe4hrten Zugriff.",
        deleted: 'Die Berechtigung "{{name}}" wurde erfolgreich gel\xf6scht.'
    }
};
var $a8bf986696df22b5$export$2e2bcd8739ae039 = Object.freeze($a8bf986696df22b5$var$api_resource_details);


const $eea4707bd538c192$var$api_resources = {
    page_title: "API-Ressourcen",
    title: "API-Ressourcen",
    subtitle: "Lege APIs an, die du in deinen autorisierten Anwendungen verwenden kannst",
    create: "API-Ressource erstellen",
    api_name: "API-Name",
    api_name_placeholder: "Gib einen API-Namen ein",
    api_identifier: "API-Identifier",
    api_identifier_placeholder: "https://your-api-identifier/",
    api_identifier_tip: "Der eindeutige Identifikator der API-Ressource muss eine absolute URI ohne Fragmentbezeichner (#) sein. Entspricht dem <a>Ressourcenparameter</a> in OAuth 2.0.",
    default_api: "Standard-API",
    default_api_label: "Pro Mandant kann nur eine Standard-API festgelegt werden. Wenn eine Standard-API festgelegt ist, kann der Ressourcenparameter in der Authentifizierungsanfrage weggelassen werden. Folgende Token-Austauschvorg\xe4nge verwenden standardm\xe4\xdfig die API als Publikum, was zur Ausgabe von JWTs f\xfchrt. <a>Erfahren Sie mehr</a>",
    api_resource_created: "Die API-Ressource {{name}} wurde erfolgreich erstellt",
    invalid_resource_indicator_format: "API-Indikator muss eine g\xfcltige absolute URI sein."
};
var $eea4707bd538c192$export$2e2bcd8739ae039 = Object.freeze($eea4707bd538c192$var$api_resources);


const $e73bdc20da610623$var$application_details = {
    page_title: "Anwendungsdaten",
    back_to_applications: "Zur\xfcck zu Anwendungen",
    check_guide: "Zur Anleitung",
    settings: "Einstellungen",
    settings_description: 'Eine "Anwendung" ist eine registrierte Software oder Dienst, die auf Benutzerinformationen zugreifen oder im Namen eines Benutzers agieren kann. Anwendungen helfen dabei, zu erkennen, wer von Logto was verlangt, und behandeln die Anmeldung und Berechtigung. F\xfclle die erforderlichen Felder f\xfcr die Authentifizierung aus.',
    integration: "Integration",
    integration_description: "Implementieren Sie sichere Worker von Logto, die von Cloudflares Edge-Netzwerk betrieben werden, f\xfcr eine erstklassige Leistung und weltweite 0ms-Cold-Starts.",
    service_configuration: "Dienstkonfiguration",
    service_configuration_description: "F\xfchren Sie die erforderlichen Konfigurationen in Ihrem Dienst durch.",
    session: "Sitzung",
    endpoints_and_credentials: "Endpunkte & Anmeldeinformationen",
    endpoints_and_credentials_description: "Verwenden Sie die folgenden Endpunkte und Anmeldeinformationen, um die OIDC-Verbindung in Ihrer Anwendung einzurichten.",
    refresh_token_settings: "Auffrischungstoken",
    refresh_token_settings_description: "Verwalten Sie die Auffrischungstoken-Regeln f\xfcr diese Anwendung.",
    application_roles: "Rollen",
    machine_logs: "Maschinenprotokolle",
    application_name: "Anwendungsname",
    application_name_placeholder: "Meine App",
    description: "Beschreibung",
    description_placeholder: "Gib eine Beschreibung ein",
    config_endpoint: "OpenID Provider Konfigurations-Endpunkt",
    authorization_endpoint: "Autorisierungs-Endpoint",
    authorization_endpoint_tip: "Der Endpunkt, der f\xfcr die Authentifizierung und <a>Authorisierung</a> \xfcber OpenID Connect verwendet wird.",
    show_endpoint_details: "Endpunktdetails anzeigen",
    hide_endpoint_details: "Endpunktdetails ausblenden",
    logto_endpoint: "Logto-Endpunkt",
    application_id: "App-ID",
    application_id_tip: 'Die eindeutige Anwendungs-ID, die normalerweise von Logto generiert wird. Steht auch f\xfcr "<a>client_id</a>" in OpenID Connect.',
    application_secret: "App-Geheimnis",
    redirect_uri: "Umleitungs-URI",
    redirect_uris: "Umleitungs-URIs",
    redirect_uri_placeholder: "https://deine.website.de/app",
    redirect_uri_placeholder_native: "io.logto://callback",
    redirect_uri_tip: "URI, zu dem der Benutzer nach der Anmeldung (egal ob erfolgreich oder nicht) weitergeleitet wird. Siehe OpenID Connect <a>AuthRequest</a> f\xfcr weitere Informationen.",
    post_sign_out_redirect_uri: "Umleitungs-URI nach Abmeldung",
    post_sign_out_redirect_uris: "Umleitungs-URIs nach Abmeldung",
    post_sign_out_redirect_uri_placeholder: "https://deine.website.de/home",
    post_sign_out_redirect_uri_tip: "URI, zu dem der Benutzer nach dem Abmelden weitergeleitet wird (optional). Hat bei einigen Anwendungstypen keine Auswirkungen.",
    cors_allowed_origins: "CORS-erlaubte Urspr\xfcnge",
    cors_allowed_origins_placeholder: "https://deine.website.de",
    cors_allowed_origins_tip: "Standardm\xe4\xdfig sind alle Urspr\xfcnge f\xfcr Umleitungs-URIs zugelassen. In der Regel ist dieses Feld nicht erforderlich. Siehe die <a>MDN-Dokumentation</a> f\xfcr detaillierte Informationen.",
    token_endpoint: "Token-Endpunkt",
    user_info_endpoint: "Benutzerinformations-Endpunkt",
    enable_admin_access: "Admin-Zugriff aktivieren",
    enable_admin_access_label: "Aktivieren oder deaktivieren Sie den Zugriff auf die Management-API. Bei Aktivierung k\xf6nnen Zugriffstoken verwendet werden, um die Management-API im Namen der Anwendung aufzurufen.",
    always_issue_refresh_token: "Immer das Auffrischungstoken ausgeben",
    always_issue_refresh_token_label: 'Durch Aktivierung dieser Konfiguration kann Logto immer Auffrischungstoken ausgeben, unabh\xe4ngig davon, ob "prompt=consent" in der Authentifizierungsanforderung angegeben ist. Diese Praxis wird jedoch nur empfohlen, wenn es notwendig ist, da sie nicht mit OpenID Connect kompatibel ist und m\xf6glicherweise Probleme verursachen kann.',
    refresh_token_ttl: "Ablaufzeit des Auffrischungstokens in Tagen",
    refresh_token_ttl_tip: "Die Zeitdauer, f\xfcr die ein Auffrischungstoken verwendet werden kann, um neue Zugriffstoken anzufordern, bevor es abl\xe4uft und ung\xfcltig wird. Tokenanfragen verl\xe4ngern die Ablaufzeit des Auffrischungstokens auf diesen Wert.",
    rotate_refresh_token: "Auffrischungstoken drehen",
    rotate_refresh_token_label: "Wenn diese Option aktiviert ist, wird Logto ein neues Auffrischungstoken f\xfcr Tokenanfragen ausgeben, wenn 70% der urspr\xfcnglichen Zeit bis zum Ablauf (TTL) verstrichen sind oder bestimmte Bedingungen erf\xfcllt sind. <a>Erfahren Sie mehr</a>",
    delete_description: "Diese Aktion ist nicht umkehrbar. Die Anwendung wird dauerhaft gel\xf6scht. Bitte geben Sie den Anwendungsnamen <span>{{name}}</span> zur Best\xe4tigung ein.",
    enter_your_application_name: "Geben Sie einen Anwendungsnamen ein",
    application_deleted: "Anwendung {{name}} wurde erfolgreich gel\xf6scht",
    redirect_uri_required: "Geben Sie mindestens eine Umleitungs-URI an",
    app_domain_description_1: "Nutzen Sie Ihre Domain mit {{domain}} von Logto, die dauerhaft g\xfcltig ist.",
    app_domain_description_2: "Nutzen Sie Ihre Domain <domain>{{domain}}</domain> die dauerhaft g\xfcltig ist.",
    custom_rules: "Benutzerdefinierte Authentifizierungsregeln",
    custom_rules_placeholder: "^/(admin|privacy)/.+$",
    custom_rules_description: "Legen Sie Regeln mit regul\xe4ren Ausdr\xfccken f\xfcr authentifizierungsbed\xfcrftige Routen fest. Standardm\xe4\xdfig: Vollst\xe4ndiger Schutz der Website, wenn nichts angegeben ist.",
    authentication_routes: "Authentifizierungsrouten",
    custom_rules_tip: "Hier sind zwei Szenarien:<ol><li>Um nur die Routen '/admin' und '/privacy' mit Authentifizierung zu sch\xfctzen: ^/(admin|privacy)/.*</li><li>Um JPG-Bilder von der Authentifizierung auszuschlie\xdfen: ^(?!.*\\.jpg$).*$</li></ol>",
    authentication_routes_description: "Leiten Sie Ihren Authentifizierungsbutton mit den angegebenen Routen weiter. Hinweis: Diese Routen sind unersetzbar.",
    protect_origin_server: "Sch\xfctzen Sie Ihren Herkunftsserver",
    protect_origin_server_description: "Stellen Sie sicher, dass Ihr Herkunftsserver vor direktem Zugriff gesch\xfctzt ist. Beachten Sie die Anleitung f\xfcr weitere <a>detaillierte Anweisungen</a>.",
    session_duration: "Sitzungsdauer (Tage)",
    try_it: "Probieren Sie es aus",
    branding: {
        name: "Branding",
        description: "Passen Sie den Anzeigenamen und das Logo Ihrer Anwendung auf dem Einwilligungsbildschirm an.",
        more_info: "Mehr Infos",
        more_info_description: "Bieten Sie den Benutzern auf dem Einwilligungsbildschirm weitere Informationen \xfcber Ihre Anwendung.",
        display_name: "Anzeigenamen",
        display_logo: "Logo anzeigen",
        display_logo_dark: "Logo anzeigen (dunkel)",
        terms_of_use_url: "URL der Anwendungsbedingungen",
        privacy_policy_url: "URL der Anwendungsdatenschutzbestimmungen"
    },
    permissions: {
        name: "Berechtigungen",
        description: "W\xe4hlen Sie die Berechtigungen aus, die die Drittanbieteranwendung f\xfcr die Benutzerautorisierung zum Zugriff auf bestimmte Datentypen ben\xf6tigt.",
        user_permissions: "Pers\xf6nliche Benutzerdaten",
        organization_permissions: "Zugriff auf Organisation",
        table_name: "Berechtigungen erteilen",
        field_name: "Berechtigung",
        field_description: "Ersccheint auf dem Einwilligungsbildschirm",
        delete_text: "Berechtigung entfernen",
        permission_delete_confirm: "Diese Aktion hebt die der Drittanbieter-App erteilten Berechtigungen auf, was sie daran hindert, Benutzerberechtigung f\xfcr bestimmte Datentypen anzufragen. Sind Sie sicher, dass Sie fortfahren m\xf6chten?",
        permissions_assignment_description: "W\xe4hlen Sie die Berechtigungen aus, die die Drittanbieteranwendung f\xfcr die Benutzerautorisierung zum Zugriff auf bestimmte Datentypen ben\xf6tigt.",
        user_profile: "Benutzerdaten",
        api_permissions: "API-Berechtigungen",
        organization: "Organisationsberechtigungen",
        user_permissions_assignment_form_title: "F\xfcgen Sie die Berechtigungen f\xfcr das Benutzerprofil hinzu",
        organization_permissions_assignment_form_title: "F\xfcgen Sie die Organisationsberechtigungen hinzu",
        api_resource_permissions_assignment_form_title: "F\xfcgen Sie die Berechtigungen f\xfcr die API-Ressource hinzu",
        user_data_permission_description_tips: 'Sie k\xf6nnen die Beschreibung der Berechtigungen f\xfcr personenbezogene Benutzerdaten \xfcber "Anmeldeerfahrung > Inhalt > Sprache verwalten" \xe4ndern.',
        permission_description_tips: "Wenn Logto als Identit\xe4tsanbieter (IdP) f\xfcr die Authentifizierung in Drittanbieter-Apps verwendet wird und Benutzer um Autorisierung gebeten werden, erscheint diese Beschreibung auf dem Einwilligungsbildschirm.",
        user_title: "Benutzer",
        user_description: "W\xe4hlen Sie die Berechtigungen aus, die von der Drittanbieter-App f\xfcr den Zugriff auf bestimmte Benutzerdaten angefordert werden.",
        grant_user_level_permissions: "Berechtigungen f\xfcr Benutzerdaten erteilen",
        organization_title: "Organisation",
        organization_description: "W\xe4hlen Sie die Berechtigungen aus, die von der Drittanbieter-App f\xfcr den Zugriff auf bestimmte Organisationsdaten angefordert werden.",
        grant_organization_level_permissions: "Berechtigungen f\xfcr Organisationdaten erteilen"
    },
    roles: {
        name_column: "Rolle",
        description_column: "Beschreibung",
        assign_button: "Rollen zuweisen",
        delete_description: "Diese Aktion entfernt diese Rolle von dieser Maschinen-zu-Maschinen-App. Die Rolle existiert zwar weiterhin, ist jedoch nicht mehr mit dieser Maschinen-zu-Maschinen-App verkn\xfcpft.",
        deleted: "{{name}} wurde erfolgreich von diesem Benutzer entfernt.",
        assign_title: "Rollen an {{name}} zuweisen",
        assign_subtitle: "{{name}} mit einer oder mehreren Rollen autorisieren",
        assign_role_field: "Rollen zuweisen",
        role_search_placeholder: "Nach Rollennamen suchen",
        added_text: "{{value, number}} hinzugef\xfcgt",
        assigned_app_count: "{{value, number}} Anwendungen",
        confirm_assign: "Rollen zuweisen",
        role_assigned: "Rolle(n) erfolgreich zugewiesen",
        search: "Nach Rollennamen, Beschreibung oder ID suchen",
        empty: "Keine Rollen verf\xfcgbar"
    }
};
var $e73bdc20da610623$export$2e2bcd8739ae039 = Object.freeze($e73bdc20da610623$var$application_details);


const $b9432b8df024f971$var$applications = {
    page_title: "Anwendungen",
    title: "Anwendungen",
    subtitle: "Richte eine native, single-page-, Machine-to-Machine- oder herk\xf6mmliche Anwendung ein, die Logto zur Authentifizierung nutzt.",
    subtitle_with_app_type: "Richte Logto-Authentifizierung f\xfcr deine {{name}}-Anwendung ein",
    create: "Anwendung erstellen",
    create_subtitle_third_party: "Verwende Logto als deinen Identit\xe4tsanbieter (IdP), um leicht mit Anwendungen von Drittanbietern zu integrieren",
    application_name: "Anwendungsname",
    application_name_placeholder: "Meine App",
    application_description: "Anwendungsbeschreibung",
    application_description_placeholder: "Gib eine Beschreibung ein",
    select_application_type: "W\xe4hle einen Anwendungstyp",
    no_application_type_selected: "Du hast noch keinen Anwendungstyp ausgew\xe4hlt",
    application_created: "Die Anwendung wurde erfolgreich erstellt.",
    tab: {
        my_applications: "Meine Apps",
        third_party_applications: "Apps von Drittanbietern"
    },
    app_id: "App-ID",
    type: {
        native: {
            title: "Native App",
            subtitle: "Eine Anwendung, die in einer nativen Umgebung l\xe4uft",
            description: "z.B. iOS-App, Android-App"
        },
        spa: {
            title: "Single-Page-App",
            subtitle: "Eine Anwendung, die im Webbrowser ausgef\xfchrt wird und Daten dynamisch vor Ort aktualisiert",
            description: "z.B. React-DOM-App, Vue-App"
        },
        traditional: {
            title: "Herk\xf6mmliche Website",
            subtitle: "Eine Anwendung, die Seiten allein durch den Webserver rendert und aktualisiert",
            description: "z.B. Next.js, PHP"
        },
        machine_to_machine: {
            title: "Machine-to-Machine",
            subtitle: "Eine Anwendung (normalerweise ein Dienst), die direkt mit Ressourcen kommuniziert",
            description: "z.B. Backend-Dienst"
        },
        protected: {
            title: "Gesch\xfctzte App",
            subtitle: "Eine von Logto gesch\xfctzte App",
            description: "N/A"
        },
        third_party: {
            title: "Drittanbieter-App",
            subtitle: "Eine App, die als Drittanbieter-IdP-Konnektor verwendet wird",
            description: "z.B. OIDC, SAML"
        }
    },
    placeholder_title: "W\xe4hle einen Anwendungstyp, um fortzufahren",
    placeholder_description: "Logto verwendet eine Anwendungs-Entit\xe4t f\xfcr OIDC, um Aufgaben wie die Identifizierung deiner Apps, das Management der Anmeldung und die Erstellung von Pr\xfcfprotokollen zu erleichtern.",
    m2m_role_assignment: {
        title: "App autorisieren mit maschinenbasierten Rollen f\xfcr Berechtigungen",
        subtitle: "Maschine-zu-Maschine-Anwendungen erfordern eine autorisierte Maschine-zu-Maschine-Rolle.",
        role_creation_hint: "K\xf6nnen Sie die richtige Maschine-zu-Maschine-Rolle nicht finden? <a>Erstellen Sie eine Maschine-zu-Maschine-Rolle</a>"
    }
};
var $b9432b8df024f971$export$2e2bcd8739ae039 = Object.freeze($b9432b8df024f971$var$applications);


const $25e641c882c0488c$var$cloud = {
    general: {
        onboarding: "Einf\xfchrung"
    },
    welcome: {
        page_title: "Willkommen",
        title: "Willkommen bei Logto Cloud! Wir m\xf6chten gerne ein bisschen mehr \xfcber Sie erfahren.",
        description: "Machen Sie Ihre Logto-Erfahrung einzigartig, indem Sie uns besser kennenlernen. Ihre Informationen sind bei uns sicher.",
        project_field: "Ich verwende Logto f\xfcr",
        project_options: {
            personal: "Pers\xf6nliches Projekt",
            company: "Unternehmensprojekt"
        },
        company_name_field: "Firmenname",
        company_name_placeholder: "Acme.co",
        stage_field: "In welchem Stadium befindet sich Ihr Produkt derzeit?",
        stage_options: {
            new_product: "Starte ein neues Projekt und suche nach einer schnellen, Out-of-the-Box-L\xf6sung",
            existing_product: "Migration von der derzeitigen Authentifizierung (z. B. selbst erstellt, Auth0, Cognito, Microsoft)",
            target_enterprise_ready: "Ich habe gerade gr\xf6\xdfere Kunden gewonnen und m\xf6chte mein Produkt jetzt bereit machen, um es an Unternehmen zu verkaufen"
        },
        additional_features_field: "Haben Sie noch etwas, das Sie uns wissen lassen m\xf6chten?",
        additional_features_options: {
            customize_ui_and_flow: "Erstellen und verwalten Sie Ihre eigene Benutzeroberfl\xe4che und Ihren eigenen Ablauf, anstatt nur die vorgefertigte und anpassbare L\xf6sung von Logto zu verwenden",
            compliance: "SOC2 und GDPR sind Pflicht",
            export_user_data: "Ben\xf6tigen Sie die M\xf6glichkeit, Benutzerdaten von Logto zu exportieren",
            budget_control: "Ich habe sehr strenge Budgetkontrolle",
            bring_own_auth: "Ich habe eigene Authentifizierungsdienste und ben\xf6tige nur einige Logto-Funktionen",
            others: "Keines der oben genannten"
        }
    },
    sie: {
        page_title: "Meldeeinrichtung anpassen",
        title: "Passen Sie zuerst Ihre Anmeldungserfahrung mit Leichtigkeit an",
        inspire: {
            title: "Erstellen Sie \xfcberzeugende Beispiele",
            description: 'F\xfchlen Sie sich unsicher bei der Anmeldeerfahrung? Klicken Sie einfach auf "Inspire me" und lassen Sie die Magie geschehen!',
            inspire_me: "Inspirieren Sie mich"
        },
        logo_field: "App-Logo",
        color_field: "Markenfarbe",
        identifier_field: "Identifikator",
        identifier_options: {
            email: "E-Mail",
            phone: "Telefon",
            user_name: "Benutzername"
        },
        authn_field: "Authentifizierung",
        authn_options: {
            password: "Passwort",
            verification_code: "Verifizierungscode"
        },
        social_field: "Soziale Anmeldung",
        finish_and_done: "Fertig und erledigt",
        preview: {
            mobile_tab: "Mobil",
            web_tab: "Web"
        },
        connectors: {
            unlocked_later: "Sp\xe4ter entsperrt",
            unlocked_later_tip: "Sobald Sie den Onboarding-Prozess abgeschlossen und das Produkt betreten haben, haben Sie Zugriff auf noch mehr soziale Anmeldeverfahren.",
            notice: "Bitte verwenden Sie den Demo-Connector nicht f\xfcr Produktionszwecke. Sobald Sie mit dem Testen fertig sind, l\xf6schen Sie bitte den Demo-Connector und richten Sie Ihren eigenen Connector mit Ihren Anmeldeinformationen ein."
        }
    },
    socialCallback: {
        title: "Sie haben sich erfolgreich angemeldet",
        description: "Sie haben sich erfolgreich mit Ihrem Social-Account angemeldet. Um eine nahtlose Integration und den Zugriff auf alle Funktionen von Logto zu gew\xe4hrleisten, empfehlen wir Ihnen, Ihren eigenen Social-Connector zu konfigurieren."
    },
    tenant: {
        create_tenant: "Tenant erstellen"
    }
};
var $25e641c882c0488c$export$2e2bcd8739ae039 = Object.freeze($25e641c882c0488c$var$cloud);


const $6d8f94fbd1aa4f19$var$components = {
    uploader: {
        action_description: "Ziehen und Ablegen oder Datei ausw\xe4hlen",
        uploading: "Wird hochgeladen...",
        image_limit: "Lade ein Bild unter {{size, number}}KB hoch, nur {{extensions, list(style: narrow; type: conjunction;)}}.",
        error_upload: "Etwas ist schiefgelaufen. Dateiupload fehlgeschlagen.",
        error_file_size: "Dateigr\xf6\xdfe ist zu gro\xdf. Bitte lade eine Datei unter {{size, number}}KB hoch.",
        error_file_type: "Dateityp wird nicht unterst\xfctzt. Nur {{extensions, list(style: narrow; type: conjunction;)}}.",
        error_file_count: "Sie k\xf6nnen nur 1 Datei hochladen."
    }
};
var $6d8f94fbd1aa4f19$export$2e2bcd8739ae039 = Object.freeze($6d8f94fbd1aa4f19$var$components);


const $fd75e8bd3fe27fe3$var$connector_details = {
    page_title: "Verbindungsdetails",
    back_to_connectors: "Zur\xfcck zu Connectoren",
    check_readme: "Zur README",
    settings: "Allgemeine Einstellungen",
    settings_description: "Connectoren spielen eine wichtige Rolle in Logto. Mit ihrer Hilfe erm\xf6glicht Logto Endbenutzern eine passwortlose Registrierung oder Anmeldung sowie die M\xf6glichkeit, sich mit Social Accounts anzumelden.",
    parameter_configuration: "Parameter-Konfiguration",
    test_connection: "Testen",
    save_error_empty_config: "Bitte f\xfclle die Konfiguration aus",
    send: "Senden",
    send_error_invalid_format: "Ung\xfcltige Eingabe",
    edit_config_label: "Gib deine JSON-Konfiguration ein",
    test_email_sender: "Teste den E-Mail Connector",
    test_sms_sender: "Teste den SMS Connector",
    test_email_placeholder: "john.doe@example.com",
    test_sms_placeholder: "+49 151 12345678",
    test_message_sent: "Testnachricht wurde gesendet",
    test_sender_description: 'Logto verwendet die "Generic"-Vorlage zum Testen. Du erh\xe4ltst eine Nachricht, wenn dein Connector richtig konfiguriert ist.',
    options_change_email: "E-Mail Connector bearbeiten",
    options_change_sms: "SMS Connector bearbeiten",
    connector_deleted: "Der Connector wurde erfolgreich gel\xf6scht",
    type_email: "E-Mail Connector",
    type_sms: "SMS Connector",
    type_social: "Social Connector",
    in_used_social_deletion_description: "Dieser Connector wird in Ihrem Anmeldeerlebnis verwendet. Durch das L\xf6schen wird das Anmeldeerlebnis in den Anmeldeerlebniseinstellungen gel\xf6scht. Wenn Sie ihn wieder hinzuf\xfcgen m\xf6chten, m\xfcssen Sie ihn erneut konfigurieren.",
    in_used_passwordless_deletion_description: "Dieser {{name}} wird in Ihrem Anmeldeerlebnis verwendet. Wenn Sie ihn l\xf6schen, funktioniert Ihr Anmeldeerlebnis nicht ordnungsgem\xe4\xdf, bis Sie das Problem gel\xf6st haben. Wenn Sie ihn wieder hinzuf\xfcgen m\xf6chten, m\xfcssen Sie ihn erneut konfigurieren.",
    deletion_description: "Sie entfernen diesen Connector. Dies kann nicht r\xfcckg\xe4ngig gemacht werden, und Sie m\xfcssen ihn erneut konfigurieren, wenn Sie ihn wieder hinzuf\xfcgen m\xf6chten.",
    logto_email: {
        total_email_sent: "Gesamtanzahl gesendeter E-Mails: {{value, number}}",
        total_email_sent_tip: "Logto verwendet SendGrid f\xfcr sicheren und stabilen integrierten E-Mail-Versand. Es ist komplett kostenlos. <a>Weitere Informationen</a>",
        email_template_title: "E-Mail-Vorlage",
        template_description: "Der integrierte E-Mail-Versand verwendet Standardvorlagen f\xfcr eine nahtlose Zustellung von Verifizierungs-E-Mails. Es ist keine Konfiguration erforderlich, und Sie k\xf6nnen grundlegende Markeninformationen anpassen.",
        template_description_link_text: "Vorlagen anzeigen",
        description_action_text: "Vorlagen anzeigen",
        from_email_field: "Absender-E-Mail",
        sender_name_field: "Sender name",
        sender_name_tip: 'Passen Sie den Absendernamen f\xfcr E-Mails an. Wenn es leer gelassen wird, wird "Verification" als Standardname verwendet.',
        sender_name_placeholder: "Ihr Absendername",
        company_information_field: "Firmeninformationen",
        company_information_description: "Zeigen Sie den Firmennamen, die Adresse oder die Postleitzahl am Ende der E-Mails an, um die Authentizit\xe4t zu erh\xf6hen.",
        company_information_placeholder: "Die grundlegenden Informationen Ihres Unternehmens",
        app_logo_field: "App-Logo",
        app_logo_tip: "Zeigen Sie Ihr Markenlogo oben in E-Mails an. Verwenden Sie dasselbe Bild f\xfcr den hellen und den dunklen Modus.",
        urls_not_allowed: "URLs sind nicht erlaubt",
        test_notes: 'Logto verwendet die "Generic"-Vorlage zum Testen.'
    }
};
var $fd75e8bd3fe27fe3$export$2e2bcd8739ae039 = Object.freeze($fd75e8bd3fe27fe3$var$connector_details);


const $3e2829a0ef0ccc0b$var$connectors = {
    page_title: "Connectoren",
    title: "Connectoren",
    subtitle: "Richte Connectoren ein, um passwortlose und Social-Anmeldung zu aktivieren",
    create: "Social-Connector erstellen",
    config_sie_notice: "Sie haben Connectoren eingerichtet. Stellen Sie sicher, dass Sie ihn in <a>{{link}}</a> konfigurieren.",
    config_sie_link_text: "Anmeldeerfahrung",
    tab_email_sms: "E-Mail und SMS-Connectoren",
    tab_social: "Social-Connectoren",
    connector_name: "Connector-Name",
    demo_tip: "Die maximale Anzahl von Nachrichten f\xfcr diesen Demo-Connector ist auf 100 begrenzt und wird nicht f\xfcr den Einsatz in einer Produktionsumgebung empfohlen.",
    social_demo_tip: "Der Demo-Connector ist ausschlie\xdflich f\xfcr Demonstrationszwecke konzipiert und wird nicht f\xfcr den Einsatz in einer Produktionsumgebung empfohlen.",
    connector_type: "Typ",
    connector_status: "Anmeldeoberfl\xe4che",
    connector_status_in_use: "In Benutzung",
    connector_status_not_in_use: "Nicht in Benutzung",
    not_in_use_tip: {
        content: "Nicht in Benutzung bedeutet, dass Ihre Anmeldeerfahrung diese Anmeldeoption nicht verwendet hat. <a>{{link}}</a>, um diese Anmeldeoption hinzuzuf\xfcgen.",
        go_to_sie: "Zur Anmeldeerfahrung gehen"
    },
    placeholder_title: "Social-Connector",
    placeholder_description: "Logto hat viele weit verbreitete Social-Sign-In-Connectoren bereitgestellt. Inzwischen k\xf6nnen Sie mit Standardprotokollen Ihre eigenen erstellen.",
    save_and_done: "Speichern und fertigstellen",
    type: {
        email: "E-Mail-Connector",
        sms: "SMS-Connector",
        social: "Social-Connector"
    },
    setup_title: {
        email: "E-Mail-Connector einrichten",
        sms: "SMS-Connector einrichten",
        social: "Social-Connector erstellen"
    },
    guide: {
        subtitle: "Eine Schritt-f\xfcr-Schritt-Anleitung zur Konfiguration deines Connectors",
        general_setting: "Allgemeine Einstellungen",
        parameter_configuration: "Parameterkonfiguration",
        test_connection: "Verbindungstest",
        name: "Name f\xfcr Social-Sign-In-Button",
        name_placeholder: "Geben Sie den Namen f\xfcr den Social-Sign-In-Button ein",
        name_tip: 'Der Name des Connector-Buttons wird als "Weiter mit {{name}}" angezeigt. Achten Sie darauf, dass der Name nicht zu lang wird.',
        logo: "Logo-URL f\xfcr Social-Sign-In-Button",
        logo_placeholder: "https://your.cdn.domain/logo.png",
        logo_tip: "Das Logobild wird auf dem Connector angezeigt. Holen Sie sich einen \xf6ffentlich zug\xe4nglichen Bildlink und f\xfcgen Sie den Link hier ein.",
        logo_dark: "Logo-URL f\xfcr Social-Sign-In-Button (Dark mode)",
        logo_dark_placeholder: "https://your.cdn.domain/logo.png",
        logo_dark_tip: "Legen Sie das Logo Ihres Connectors f\xfcr den Dark-Modus fest, nachdem Sie ihn in der Anmeldeerfahrung der Admin Konsole aktiviert haben.",
        logo_dark_collapse: "Zusammenklappen",
        logo_dark_show: "Logo-Einstellung f\xfcr Dark-Modus anzeigen",
        target: "Identity Provider Name",
        target_placeholder: "Geben Sie den Namen des Connector Identity Providers ein",
        target_tip: 'Der Wert von "IdP-Name" kann eine eindeutige Kennung sein, um Ihre Social-Identit\xe4ten zu unterscheiden.',
        target_tip_standard: 'Der Wert von "IdP-Name" kann eine eindeutige Kennung sein, um Ihre Social-Identit\xe4ten zu unterscheiden. Diese Einstellung kann nach der Erstellung des Connectors nicht mehr ge\xe4ndert werden.',
        target_tooltip: "„Target“ in Logto-Social-Connectors bezieht sich auf die „Quelle“ Ihrer Social-Identit\xe4ten. Im Logto-Design akzeptieren wir nicht dasselbe „Target“ einer bestimmten Plattform, um Konflikte zu vermeiden. Sie sollten sehr vorsichtig sein, bevor Sie einen Connector hinzuf\xfcgen, da Sie seinen Wert NICHT \xe4ndern k\xf6nnen, sobald Sie ihn erstellt haben. <a>Erfahren Sie mehr</a>",
        target_conflict: "Der eingegebene IdP-Name stimmt mit dem vorhandenen <span>Namen</span> \xfcberein. Die Verwendung desselben IdP-Namens kann ein unerwartetes Anmeldeverhalten verursachen, bei dem Benutzer \xfcber zwei verschiedene Connectoren auf dasselbe Konto zugreifen k\xf6nnen.",
        target_conflict_line2: 'Wenn Sie den aktuellen Connector durch denselben Identity Provider ersetzen und fr\xfcheren Benutzern erm\xf6glichen m\xf6chten, sich ohne erneute Registrierung anzumelden, l\xf6schen Sie bitte den <span>Namen</span>-Connector und erstellen Sie einen neuen mit dem gleichen "IdP-Namen".',
        target_conflict_line3: 'Wenn Sie sich mit einem anderen Identity Provider verbinden m\xf6chten, \xe4ndern Sie bitte den "IdP-Name" und fahren Sie fort.',
        config: "Geben Sie Ihre Konfigurations-JSON ein",
        sync_profile: "Profilinformationen synchronisieren",
        sync_profile_only_at_sign_up: "Nur bei der Anmeldung synchronisieren",
        sync_profile_each_sign_in: "Bei jeder Anmeldung immer synchronisieren",
        sync_profile_tip: "Synchronisieren Sie das Grundprofil vom Social-Provider, z. B. die Namen der Benutzer und ihre Avatare.",
        callback_uri: "Callback-URI",
        callback_uri_description: "Auch als Redirect-URI bezeichnet, ist die URI in Logto, zu der Benutzer nach der Social-Autorisierung zur\xfcckgesendet werden. Kopieren und f\xfcgen Sie sie in die Konfigurationsseite des Social Providers ein.",
        acs_url: "Assertion Consumer Service URL"
    },
    platform: {
        universal: "Universal",
        web: "Web",
        native: "Nativ"
    },
    add_multi_platform: " unterst\xfctzt mehrere Plattformen. W\xe4hle eine Plattform aus, um fortzufahren",
    drawer_title: "Connector-Anleitung",
    drawer_subtitle: "Folge den Anweisungen, um deinen Connector zu integrieren",
    unknown: "Unbekannter Connector",
    standard_connectors: "Standard-Connectoren"
};
var $3e2829a0ef0ccc0b$export$2e2bcd8739ae039 = Object.freeze($3e2829a0ef0ccc0b$var$connectors);


const $b8702cea4edd3b2b$var$contact = {
    title: "Hilfe erhalten",
    description: "F\xfcr Hilfsanfragen oder Produktfeedback wenden Sie sich bitte \xfcber die folgenden Methoden an uns.",
    discord: {
        title: "Discord community beitreten",
        description: "Mit anderen Entwicklern vernetzen, um L\xf6sungen zu finden",
        button: "Beitreten"
    },
    github: {
        title: "Kommunikation auf GitHub",
        description: "Erstellen Sie ein Problem und reichen Sie es bei GitHub ein",
        button: "\xd6ffnen"
    },
    email: {
        title: "Unterst\xfctzung per E-Mail kontaktieren",
        description: "Senden Sie uns eine E-Mail f\xfcr weitere Informationen und Hilfe",
        button: "Senden"
    },
    reserve: {
        title: "Reservieren Sie Ihre Zeit beim Logto-Team",
        description: "Buchen Sie eine Sitzung f\xfcr einen Live-Chat",
        button: "Buch"
    }
};
var $b8702cea4edd3b2b$export$2e2bcd8739ae039 = Object.freeze($b8702cea4edd3b2b$var$contact);


const $5d26f0008cf429e1$var$dashboard = {
    page_title: "Dashboard",
    title: "Dashboard",
    description: "Verschaffe dir einen \xdcberblick \xfcber die Leistung deiner App",
    total_users: "Gesamtzahl der Benutzer",
    total_users_tip: "Gesamtzahl der Benutzer",
    new_users_today: "Neue Benutzer heute",
    new_users_today_tip: "Neue Benutzer, die sich heute in deinen Anwendungen registriert haben",
    new_users_7_days: "Neue Benutzer in den letzten 7 Tagen",
    new_users_7_days_tip: "Neue Benutzer, die sich in den letzten 7 Tagen in deinen Anwendungen registriert haben",
    daily_active_users: "T\xe4glich aktive Benutzer",
    daily_active_users_tip: "Die Anzahl der einzelnen Benutzer, die heute Token in deinen Anwendungen ausgetauscht haben",
    weekly_active_users: "W\xf6chentlich aktive Benutzer",
    weekly_active_users_tip: "Die Anzahl der einzelnen Benutzer, die in den letzten 7 Tagen Token in deinen Anwendungen ausgetauscht haben",
    monthly_active_users: "Monatlich aktive Benutzer",
    monthly_active_users_tip: "Die Anzahl der einzelnen Benutzer, die in den letzten 30 Tagen Token in deinen Anwendungen ausgetauscht haben"
};
var $5d26f0008cf429e1$export$2e2bcd8739ae039 = Object.freeze($5d26f0008cf429e1$var$dashboard);


const $8887b1cda850cab9$var$domain = {
    status: {
        connecting: "Verbindung wird hergestellt...",
        in_use: "In Benutzung",
        failed_to_connect: "Verbindung fehlgeschlagen"
    },
    update_endpoint_notice: "Vergessen Sie nicht, die Domain f\xfcr die Social-Connector-Callback-URI und den Logto-Endpunkt in Ihrer Anwendung zu aktualisieren, wenn Sie eine benutzerdefinierte Domain f\xfcr die Funktionen verwenden m\xf6chten. <a>{{link}}</a>",
    error_hint: "Stellen Sie sicher, dass Sie Ihre DNS-Eintr\xe4ge aktualisiert haben. Wir werden alle {{value}} Sekunden weiter \xfcberpr\xfcfen.",
    custom: {
        custom_domain: "Benutzerdefinierte Domain",
        custom_domain_description: "Verbessern Sie Ihre Markenbildung durch die Verwendung einer benutzerdefinierten Domain. Diese Domain wird in Ihrem Anmeldeerlebnis verwendet.",
        custom_domain_field: "Benutzerdefinierte Domain",
        custom_domain_placeholder: "ihre.domain.com",
        add_domain: "Domain hinzuf\xfcgen",
        invalid_domain_format: 'Bitte geben Sie eine g\xfcltige Domain-URL mit mindestens drei Teilen an, z. B. "ihre.domain.com."',
        verify_domain: "Domain \xfcberpr\xfcfen",
        enable_ssl: "SSL aktivieren",
        checking_dns_tip: "Nachdem Sie die DNS-Eintr\xe4ge konfiguriert haben, wird der Prozess automatisch ausgef\xfchrt und kann bis zu 24 Stunden dauern. Sie k\xf6nnen diese Oberfl\xe4che verlassen, w\xe4hrend er l\xe4uft.",
        enable_ssl_tip: "SSL aktivieren wird automatisch ausgef\xfchrt und kann bis zu 24 Stunden dauern. Sie k\xf6nnen diese Oberfl\xe4che verlassen, w\xe4hrend er l\xe4uft.",
        generating_dns_records: "DNS-Eintr\xe4ge werden generiert...",
        add_dns_records: "Bitte f\xfcgen Sie diese DNS-Eintr\xe4ge Ihrem DNS-Provider hinzu.",
        dns_table: {
            type_field: "Typ",
            name_field: "Name",
            value_field: "Wert"
        },
        deletion: {
            delete_domain: "Domain l\xf6schen",
            reminder: "Benutzerdefinierte Domain l\xf6schen",
            description: "Sind Sie sicher, dass Sie diese benutzerdefinierte Domain l\xf6schen m\xf6chten?",
            in_used_description: 'Sind Sie sicher, dass Sie diese benutzerdefinierte Domain "<span>{{domain}}</span>" l\xf6schen m\xf6chten?',
            in_used_tip: 'Wenn Sie diese benutzerdefinierte Domain bereits in Ihrem Social-Connector-Provider oder Anwendungs-Endpunkt eingerichtet haben, m\xfcssen Sie die URI zur Logto-Standarddomain "<span>{{domain}}</span>" \xe4ndern. Dies ist notwendig, damit die Social-Sign-In-Schaltfl\xe4che ordnungsgem\xe4\xdf funktioniert.',
            deleted: "Benutzerdefinierte Domain wurde erfolgreich gel\xf6scht!"
        }
    },
    default: {
        default_domain: "Standarddomain",
        default_domain_description: "Logto bietet eine vorkonfigurierte Standarddomain, die ohne zus\xe4tzliche Einrichtung verwendet werden kann. Diese Standarddomain dient als Backup-Option, auch wenn Sie eine benutzerdefinierte Domain aktiviert haben.",
        default_domain_field: "Logto Standard-Domain"
    },
    custom_endpoint_note: 'Sie k\xf6nnen den Domainnamen dieser Endpunkte anpassen, wie Sie m\xf6chten. W\xe4hlen Sie entweder "{{custom}}" oder "{{default}}".',
    custom_social_callback_url_note: 'Sie k\xf6nnen den Domainnamen dieser URI anpassen, um mit dem Endpunkt Ihrer Anwendung \xfcbereinzustimmen. W\xe4hlen Sie entweder "{{custom}}" oder "{{default}}".',
    custom_acs_url_note: 'Sie k\xf6nnen den Domainnamen dieser URI anpassen, um mit der URL Ihres Identit\xe4tsanbieters Assertions-Verbraucherdienst \xfcbereinzustimmen. W\xe4hlen Sie entweder "{{custom}}" oder "{{default}}".'
};
var $8887b1cda850cab9$export$2e2bcd8739ae039 = Object.freeze($8887b1cda850cab9$var$domain);


const $91b71acaf24a6bf6$var$enterprise_sso_details = {
    back_to_sso_connectors: "Zur\xfcck zu den Unternehmens-SSO",
    page_title: "Details zum Unternehmens-SSO-Connector",
    readme_drawer_title: "Unternehmens-SSO",
    readme_drawer_subtitle: "Richten Sie Unternehmens-SSO-Connector ein, um die SSO f\xfcr Endbenutzer zu aktivieren",
    tab_experience: "SSO-Erfahrung",
    tab_connection: "Verbindung",
    general_settings_title: "Allgemein",
    custom_branding_title: "Anzeige",
    custom_branding_description: "Passen Sie den Namen und das Logo an, die im Single Sign-On-Fluss der Endbenutzer angezeigt werden. Wenn leer, werden Standardwerte verwendet.",
    email_domain_field_name: "Unternehmens-E-Mail-Domain",
    email_domain_field_description: "Benutzer mit dieser E-Mail-Domain k\xf6nnen SSO zur Authentifizierung verwenden. Bitte \xfcberpr\xfcfen Sie, ob die Domain dem Unternehmen geh\xf6rt.",
    email_domain_field_placeholder: "E-Mail-Domain",
    sync_profile_field_name: "Profilinformationen vom Identit\xe4tsanbieter synchronisieren",
    sync_profile_option: {
        register_only: "Nur beim ersten Anmelden synchronisieren",
        each_sign_in: "Bei jedem Anmelden immer synchronisieren"
    },
    connector_name_field_name: "Connector-Name",
    display_name_field_name: "Anzeigename",
    connector_logo_field_name: "Anzeigelogo",
    connector_logo_field_description: "Jedes Bild sollte kleiner als 500KB sein, nur SVG, PNG, JPG, JPEG.",
    branding_logo_context: "Logo hochladen",
    branding_logo_error: "Fehler beim Hochladen des Logos: {{error}}",
    branding_light_logo_context: "Logo im hellen Modus hochladen",
    branding_light_logo_error: "Fehler beim Hochladen des Logos im hellen Modus: {{error}}",
    branding_logo_field_name: "Logo",
    branding_logo_field_placeholder: "https://deine.domain/logo.png",
    branding_dark_logo_context: "Logo im dunklen Modus hochladen",
    branding_dark_logo_error: "Fehler beim Hochladen des Logos im dunklen Modus: {{error}}",
    branding_dark_logo_field_name: "Logo (dunkler Modus)",
    branding_dark_logo_field_placeholder: "https://deine.domain/dunkler-modus-logo.png",
    check_connection_guide: "Verbindungshandbuch",
    enterprise_sso_deleted: "Der Unternehmens-SSO-Connector wurde erfolgreich gel\xf6scht",
    delete_confirm_modal_title: "Unternehmens-SSO-Connector l\xf6schen",
    delete_confirm_modal_content: "Sind Sie sicher, dass Sie diesen Unternehmens-Connector l\xf6schen m\xf6chten? Benutzer von Identit\xe4tsanbietern werden das Single Sign-On nicht nutzen.",
    upload_idp_metadata_title_saml: "Metadaten hochladen",
    upload_idp_metadata_description_saml: "Konfigurieren Sie die Metadaten, die vom Identit\xe4tsanbieter kopiert wurden.",
    upload_idp_metadata_title_oidc: "Anmeldeinformationen hochladen",
    upload_idp_metadata_description_oidc: "Konfigurieren Sie die Anmeldeinformationen und OIDC-Tokeninformationen, die vom Identit\xe4tsanbieter kopiert wurden.",
    upload_idp_metadata_button_text: "XML-Datei mit Metadaten hochladen",
    upload_signing_certificate_button_text: "Signaturzertifikatsdatei hochladen",
    configure_domain_field_info_text: "F\xfcgen Sie die E-Mail-Domain hinzu, um Unternehmensbenutzer zu ihrem Identit\xe4tsanbieter f\xfcr das Single Sign-On zu f\xfchren.",
    email_domain_field_required: "Die E-Mail-Domain ist erforderlich, um das Unternehmens-SSO zu aktivieren.",
    upload_saml_idp_metadata_info_text_url: "F\xfcgen Sie die Metadaten-URL vom Identit\xe4tsanbieter ein, um eine Verbindung herzustellen.",
    upload_saml_idp_metadata_info_text_xml: "F\xfcgen Sie die Metadaten vom Identit\xe4tsanbieter ein, um eine Verbindung herzustellen.",
    upload_saml_idp_metadata_info_text_manual: "F\xfcllen Sie die Metadaten vom Identit\xe4tsanbieter aus, um eine Verbindung herzustellen.",
    upload_oidc_idp_info_text: "F\xfcllen Sie die Informationen vom Identit\xe4tsanbieter aus, um eine Verbindung herzustellen.",
    service_provider_property_title: "Konfigurieren im Identit\xe4tsanbieter",
    service_provider_property_description: "Richten Sie eine Anwendungsintegration mit {{protocol}} in Ihrem Identit\xe4tsanbieter ein. Geben Sie die von Logto bereitgestellten Details ein.",
    attribute_mapping_title: "Attributzuordnungen",
    attribute_mapping_description: "Synchronisieren Sie Benutzerprofile vom Identit\xe4tsanbieter, indem Sie die Benutzerattributzumordnung entweder auf der Seite des Identit\xe4tsanbieters oder von Logto konfigurieren.",
    saml_preview: {
        sign_on_url: "Anmeldungs-URL",
        entity_id: "Aussteller",
        x509_certificate: "Signaturzertifikat",
        certificate_content: "L\xe4uft ab {{date}}"
    },
    oidc_preview: {
        authorization_endpoint: "Autorisierungs-Endpunkt",
        token_endpoint: "Token-Endpunkt",
        userinfo_endpoint: "Benutzerinformations-Endpunkt",
        jwks_uri: "JSON Web Key Set-Endpunkt",
        issuer: "Aussteller"
    }
};
var $91b71acaf24a6bf6$export$2e2bcd8739ae039 = Object.freeze($91b71acaf24a6bf6$var$enterprise_sso_details);


const $b4f4140d1c2653ed$var$enterprise_sso = {
    page_title: "Unternehmens-SSO",
    title: "Unternehmens-SSO",
    subtitle: "Verbinden Sie den Unternehmensidentit\xe4tsanbieter und aktivieren Sie das SP-gesteuerte Single Sign-On.",
    create: "Unternehmensconnector hinzuf\xfcgen",
    col_connector_name: "Connector-Name",
    col_type: "Typ",
    col_email_domain: "E-Mail-Domain",
    placeholder_title: "Unternehmensconnector",
    placeholder_description: "Logto hat viele eingebaute Unternehmensidentit\xe4tsanbieter bereitgestellt, Sie k\xf6nnen auch Ihren eigenen mit den SAML- und OIDC-Protokollen erstellen.",
    create_modal: {
        title: "Unternehmensconnector hinzuf\xfcgen",
        text_divider: "Oder Sie k\xf6nnen Ihren Connector mit einem Standardprotokoll anpassen.",
        connector_name_field_title: "Connector-Name",
        connector_name_field_placeholder: "Z.B., \\{Firmenname\\} - \\{Identit\xe4tsanbietername\\}",
        create_button_text: "Connector erstellen"
    },
    guide: {
        subtitle: "Ein schrittweiser Leitfaden zur Verbindung des Unternehmensidentit\xe4tsanbieters.",
        finish_button_text: "Continue"
    },
    basic_info: {
        title: "Konfigurieren Sie Ihren Dienst im IdP",
        description: "Erstellen Sie eine neue Anwendungsintegration per SAML 2.0 in Ihrem {{name}}-Identit\xe4tsanbieter. F\xfcgen Sie dann den folgenden Wert hinzu.",
        saml: {
            acs_url_field_name: "Zieldienst-URL f\xfcr Assertionsverbrauch (Antwort-URL)",
            audience_uri_field_name: "Ziel-URI (SP Entity ID)"
        },
        oidc: {
            redirect_uri_field_name: "Weiterleitungs-URI (Callback-URL)"
        }
    },
    attribute_mapping: {
        title: "Attributzuordnungen",
        description: "`id` und `email` sind erforderlich, um das Benutzerprofil vom IdP zu synchronisieren. Geben Sie den folgenden Claim-Namen und Wert in Ihrem IdP ein.",
        col_sp_claims: "Wert des Dienstanbieters (Logto)",
        col_idp_claims: "Claim-Name des Identit\xe4tsanbieters",
        idp_claim_tooltip: "Der Claim-Name des Identit\xe4tsanbieters"
    },
    metadata: {
        title: "Konfigurieren Sie die IdP-Metadaten",
        description: "Konfigurieren Sie die Metadaten aus dem Identit\xe4tsanbieter",
        dropdown_trigger_text: "Verwenden Sie eine andere Konfigurationsmethode",
        dropdown_title: "W\xe4hlen Sie Ihre Konfigurationsmethode aus",
        metadata_format_url: "Geben Sie die Metadaten-URL ein",
        metadata_format_xml: "Laden Sie die Metadaten-XML-Datei hoch",
        metadata_format_manual: "Geben Sie die Metadaten manuell ein",
        saml: {
            metadata_url_field_name: "Metadaten-URL",
            metadata_url_description: "Daten dynamisch von der Metadaten-URL abrufen und das Zertifikat auf dem neuesten Stand halten.",
            metadata_xml_field_name: "IdP-Metadaten-XML-Datei",
            metadata_xml_uploader_text: "Laden Sie die Metadaten-XML-Datei hoch",
            sign_in_endpoint_field_name: "Anmeldungs-URL",
            idp_entity_id_field_name: "IdP-Entit\xe4ts-ID (Issuer)",
            certificate_field_name: "Signierungszertifikat",
            certificate_placeholder: "Kopieren und f\xfcgen Sie das x509-Zertifikat ein",
            certificate_required: "Das Signierungszertifikat ist erforderlich."
        },
        oidc: {
            client_id_field_name: "Client-ID",
            client_secret_field_name: "Client-Geheimnis",
            issuer_field_name: "Herausgeber",
            scope_field_name: "Umfang"
        }
    }
};
var $b4f4140d1c2653ed$export$2e2bcd8739ae039 = Object.freeze($b4f4140d1c2653ed$var$enterprise_sso);


const $d33b22806c9d18d3$var$errors = {
    something_went_wrong: "Ups, da ist etwas schief gelaufen.",
    page_not_found: "Seite nicht gefunden",
    unknown_server_error: "Unbekannter Serverfehler",
    empty: "Keine Daten verf\xfcgbar",
    missing_total_number: "Total-Number wurde nicht in Response Headern gefunden",
    invalid_uri_format: "Ung\xfcltiges URI-Format",
    invalid_origin_format: "Ung\xfcltiges URI Origin-Format",
    invalid_json_format: "Ung\xfcltiges JSON-Format",
    invalid_regex: "Ung\xfcltiger regul\xe4rer Ausdruck",
    invalid_error_message_format: "Ung\xfcltiges Fehlermeldung-Format.",
    required_field_missing: "Bitte f\xfclle {{field}} aus",
    required_field_missing_plural: "Mindestens ein {{field}} muss ausgef\xfcllt sein",
    more_details: "Mehr Details",
    username_pattern_error: "Der Benutzername sollte nur Buchstaben, Zahlen oder Unterstriche enthalten und nicht mit einer Zahl beginnen.",
    email_pattern_error: "Die E-Mail-Adresse ist ung\xfcltig.",
    phone_pattern_error: "Die Telefonnummer ist ung\xfcltig.",
    insecure_contexts: "Unsichere Kontexte (nicht-HTTPS) werden nicht unterst\xfctzt.",
    unexpected_error: "Ein unerwarteter Fehler ist aufgetreten",
    not_found: "404 nicht gefunden",
    create_internal_role_violation: 'Sie erstellen eine neue interne Rolle, die von Logto verboten ist. Versuchen Sie einen anderen Namen, der nicht mit "#internal:" beginnt.',
    should_be_an_integer: "Sollte eine Ganzzahl sein.",
    number_should_be_between_inclusive: "Die Zahl sollte zwischen {{min}} und {{max}} (beide inklusive) liegen."
};
var $d33b22806c9d18d3$export$2e2bcd8739ae039 = Object.freeze($d33b22806c9d18d3$var$errors);


const $fc6d6c80e93897fc$var$general = {
    placeholder: "Platzhalter",
    submit: "Senden",
    skip: "\xdcberspringen",
    next: "Weiter",
    back: "Zur\xfcck",
    retry: "Erneut versuchen",
    done: "Fertig",
    search: "Suche",
    search_placeholder: "Suchen",
    clear_result: "Ergebnisse l\xf6schen",
    save: "Speichern",
    save_changes: "\xc4nderungen speichern",
    saved: "Gespeichert",
    discard: "Verwerfen",
    loading: "Lade...",
    redirecting: "Weiterleiten...",
    add: "Hinzuf\xfcgen",
    added: "Hinzugef\xfcgt",
    cancel: "Abbrechen",
    confirm: "Best\xe4tigen",
    check_out: "Ansehen",
    create: "Erstellen",
    set_up: "Einrichten",
    customize: "Anpassen",
    enable: "Aktivieren",
    reminder: "Erinnerung",
    edit: "Bearbeiten",
    delete: "L\xf6schen",
    deleted: "Gel\xf6scht",
    more_options: "MEHR OPTIONEN",
    close: "Schlie\xdfen",
    copy: "Kopieren",
    copying: "Kopiere",
    copied: "Kopiert",
    required: "Erforderlich",
    add_another: "Weitere hinzuf\xfcgen",
    create_another: "Erstellen Sie ein anderes",
    deletion_confirmation: "Willst du {{title}} wirklich l\xf6schen?",
    settings_nav: "Einstellungen",
    unsaved_changes_warning: "Du hast ungespeicherte \xc4nderungen. Willst du diese Seite wirklich verlassen?",
    leave_page: "Seite verlassen",
    stay_on_page: "Auf Seite bleiben",
    type_to_search: "Tippe um zu suchen",
    got_it: "Alles klar",
    continue: "Fortsetzen",
    page_info: "{{min, number}}-{{max, number}} von {{total, number}}",
    learn_more: "Mehr erfahren",
    tab_errors: "{{count, number}} Fehler",
    skip_for_now: "Jetzt \xfcberspringen",
    remove: "Entfernen",
    visit: "Besuchen",
    join: "Beitreten",
    try_now: "Jetzt ausprobieren",
    multiple_form_field: "(Mehrere)",
    demo: "Demo",
    unnamed: "Unbenannt",
    view: "Anzeigen",
    open: "\xd6ffnen",
    hide: "Verbergen",
    unknown_error: "Unbekannter Fehler, bitte versuchen Sie es sp\xe4ter erneut.",
    select: "Ausw\xe4hlen",
    contact_us_action: "Kontaktiere uns",
    description: "Beschreibung",
    name: "Name",
    add_field: "F\xfcge {{field}} hinzu",
    create_field: "Erstelle {{field}}",
    edit_field: "Bearbeite {{field}}",
    delete_field: "L\xf6sche {{field}}",
    coming_soon: "Demn\xe4chst verf\xfcgbar",
    or: "Oder"
};
var $fc6d6c80e93897fc$export$2e2bcd8739ae039 = Object.freeze($fc6d6c80e93897fc$var$general);


const $919d3c45ba21a9dc$var$get_started = {
    page_title: "Loslegen",
    title: "Etwas zum Erkunden, um dir zu helfen, erfolgreich zu sein",
    subtitle: "Einige Dinge, die Sie tun k\xf6nnen, um schnell den Wert von Logto zu erhalten",
    develop: {
        title: "Entwicklung: Nehmen Sie sich 5 Minuten Zeit, um Ihre App zu integrieren",
        title_cloud: "Entwicklung: Integrieren Sie Ihre App in Minuten sicher",
        subtitle_cloud: "Oder nehmen Sie 5 Minuten Zeit, um Ihre App mit unseren vorgefertigten SDKs und Tutorials zu integrieren."
    },
    customize: {
        title: "Anpassen: Liefern Sie ein gro\xdfartiges Anmeldeerlebnis",
        preview: {
            title: "\xdcberpr\xfcfen Sie die Live-Vorschau des gerade angepassten Anmeldeerlebnisses",
            subtitle: "Testen Sie jetzt das Logto-Anmeldeerlebnis, um zu sehen, wie es funktioniert"
        },
        connector: {
            title: "F\xfcgen Sie weitere Connectors hinzu, um weitere soziale Anmeldeverfahren zu unterst\xfctzen",
            subtitle: "Probieren Sie die passwortlose Anmeldung aus und erm\xf6glichen Sie Ihren Kunden ein sicheres und reibungsloses Erlebnis"
        },
        continue_customizing: "Mit der Anpassung fortfahren",
        try_now: "Jetzt ausprobieren",
        add_more: "Mehr hinzuf\xfcgen"
    },
    secure: {
        title: "Sichern: Sch\xfctzen Sie Ihre Ressourcen"
    },
    manage: {
        title: "Verwalten: Definieren Sie Zugriffssteuerung f\xfcr Ihr Produkt und Ihre Benutzer",
        rbac: {
            title: "F\xfcgen Sie rollenbasierte Zugriffssteuerung hinzu, um Ihre Ressourcen zu sch\xfctzen",
            subtitle: "Steuern Sie Ihre Ressource durch skalierbare Rollenautorisierung f\xfcr verschiedene Anwendungsf\xe4lle."
        },
        create_roles: "Rollen erstellen"
    },
    view_all: "Alle anzeigen →"
};
var $919d3c45ba21a9dc$export$2e2bcd8739ae039 = Object.freeze($919d3c45ba21a9dc$var$get_started);


const $cf025ba47280454a$var$guide = {
    start_building: "Starten Sie mit dem Aufbau",
    get_started: "Beginnen Sie",
    categories: {
        featured: "Beliebt und f\xfcr dich",
        Traditional: "Traditionelle Webanwendung",
        SPA: "Single-Page-Anwendung",
        Native: "Native",
        MachineToMachine: "Maschinen-zu-Maschinen",
        Protected: "Integration ohne SDK",
        ThirdParty: "Third-party-App"
    },
    filter: {
        title: "Filter-Framework",
        placeholder: "Nach Framework suchen"
    },
    checkout_tutorial: "Tutorial von {{name}} anzeigen",
    do_not_need_tutorial: "Wenn Sie kein Tutorial ben\xf6tigen, k\xf6nnen Sie ohne Anleitung fortfahren",
    finish_and_done: "Fertig und erledigt",
    cannot_find_guide: "Guide nicht gefunden?",
    describe_guide_looking_for: "Beschreiben Sie den Guide, den Sie suchen",
    request_guide_successfully: "Ihre Anfrage wurde erfolgreich \xfcbermittelt. Danke!",
    app: {
        select_framework_or_tutorial: "W\xe4hlen Sie ein Framework oder Tutorial aus",
        guide_modal_title: "Starten Sie mit dem SDK und den Guides",
        modal_subtitle: "Beschleunigen Sie Ihre App-Entwicklung mit unserem vorgefertigten SDK und Tutorials.",
        select_a_framework: "W\xe4hlen Sie ein Framework aus",
        continue_without_framework: "App ohne Framework erstellen",
        describe_guide_looking_for_placeholder: "Zum Beispiel: Ich m\xf6chte Logto in meine Angular-App integrieren."
    },
    api: {
        modal_title: "Starten Sie mit Tutorials",
        modal_subtitle: "Beschleunigen Sie Ihre App-Entwicklung mit unseren vorgefertigten Tutorials.",
        select_a_tutorial: "W\xe4hlen Sie ein Tutorial aus",
        continue_without_tutorial: "Ohne Tutorial fortfahren",
        describe_guide_looking_for_placeholder: "Zum Beispiel: Ich m\xf6chte meine API mit Deno sch\xfctzen."
    }
};
var $cf025ba47280454a$export$2e2bcd8739ae039 = Object.freeze($cf025ba47280454a$var$guide);


const $b1f5188d6d8ec86c$var$invitation = {
    find_your_tenants: "Finde deine Mieter",
    find_tenants_description: "Ihre E-Mail-Adresse ist m\xf6glicherweise bereits bei mehreren Mietern registriert. Sie k\xf6nnen w\xe4hlen, einem vorhandenen beizutreten oder fortfahren, einen neuen zu erstellen.",
    create_new_tenant: "Neuen Mieter erstellen",
    email_not_match_title: "Sie sind derzeit angemeldet als\n{{email}}",
    email_not_match_description: "Melden Sie sich bitte mit dem richtigen Konto an, um die Einladung anzunehmen und Mitglied der Organisation zu werden.",
    switch_account: "An ein anderes Konto anmelden",
    invalid_invitation_status: "Ung\xfcltige Einladung. Bitte kontaktieren Sie den Administrator und versuchen Sie es erneut.",
    invitation_not_found: "Einladung nicht gefunden. Bitte kontaktieren Sie den Administrator."
};
var $b1f5188d6d8ec86c$export$2e2bcd8739ae039 = Object.freeze($b1f5188d6d8ec86c$var$invitation);


const $459973ea43bdff7c$var$jwt_claims = {
    title: "Benutzerdefiniertes JWT",
    description: "Legen Sie benutzerdefinierte JWT-Anspr\xfcche fest, die im Zugriffstoken enthalten sein sollen. Diese Anspr\xfcche k\xf6nnen verwendet werden, um zus\xe4tzliche Informationen an Ihre Anwendung zu \xfcbergeben.",
    user_jwt: {
        card_title: "F\xfcr Benutzer",
        card_field: "Benutzerzugriffstoken",
        card_description: "F\xfcgen Sie benutzerspezifische Daten w\xe4hrend der Ausstellung des Zugriffstokens hinzu.",
        for: "f\xfcr Benutzer"
    },
    machine_to_machine_jwt: {
        card_title: "F\xfcr M2M",
        card_field: "Maschine-zu-Maschine-Token",
        card_description: "F\xfcgen Sie zus\xe4tzliche Daten w\xe4hrend der Ausstellung des Maschine-zu-Maschine-Tokens hinzu.",
        for: "f\xfcr M2M"
    },
    code_editor_title: "Passen Sie die {{token}}-Anspr\xfcche an",
    custom_jwt_create_button: "Benutzerdefinierte Anspr\xfcche hinzuf\xfcgen",
    custom_jwt_item: "Benutzerdefinierte Anspr\xfcche {{for}}",
    delete_modal_title: "Benutzerdefinierte Anspr\xfcche l\xf6schen",
    delete_modal_content: "Sind Sie sicher, dass Sie die benutzerdefinierten Anspr\xfcche l\xf6schen m\xf6chten?",
    clear: "L\xf6schen",
    cleared: "Gel\xf6scht",
    restore: "Standard wiederherstellen",
    restored: "Wiederhergestellt",
    data_source_tab: "Datenquelle",
    test_tab: "Testumgebung",
    jwt_claims_description: "Standardanspr\xfcche werden automatisch im JWT enthalten und k\xf6nnen nicht \xfcberschrieben werden.",
    user_data: {
        title: "Benutzerdaten",
        subtitle: "Verwenden Sie den `data.user` Eingabeparameter, um wichtige Benutzerinformationen bereitzustellen."
    },
    token_data: {
        title: "Token-Daten",
        subtitle: "Verwenden Sie den `token` Eingabeparameter f\xfcr die aktuelle Zugriffstoken-Payload."
    },
    fetch_external_data: {
        title: "Externe Daten abrufen",
        subtitle: "Integrieren Sie Daten direkt aus Ihren externen APIs in die Anspr\xfcche.",
        description: "Verwenden Sie die `fetch`-Funktion, um Ihre externen APIs aufzurufen und die Daten in Ihre benutzerdefinierten Anspr\xfcche einzubeziehen. Beispiel: "
    },
    environment_variables: {
        title: "Umgebungsvariablen festlegen",
        subtitle: "Verwenden Sie Umgebungsvariablen, um vertrauliche Informationen zu speichern.",
        input_field_title: "Umgebungsvariablen hinzuf\xfcgen",
        sample_code: "Zugriff auf Umgebungsvariablen in Ihrem benutzerdefinierten JWT-Anspruchshandler. Beispiel: "
    },
    jwt_claims_hint: "Beschr\xe4nken Sie benutzerdefinierte Anspr\xfcche auf weniger als 50 KB. Standard-JWT-Anspr\xfcche werden automatisch im Token enthalten und k\xf6nnen nicht \xfcberschrieben werden.",
    tester: {
        subtitle: "Mock-Token und Benutzerdaten f\xfcr Tests anpassen.",
        run_button: "Test ausf\xfchren",
        result_title: "Testergebnis"
    },
    form_error: {
        invalid_json: "Ung\xfcltiges JSON-Format"
    }
};
var $459973ea43bdff7c$export$2e2bcd8739ae039 = Object.freeze($459973ea43bdff7c$var$jwt_claims);


const $2b2a8b96e06e14e9$var$log_details = {
    page_title: "Audit Log Details",
    back_to_logs: "Zur\xfcck zu audit logs",
    back_to: "Zur\xfcck zu {{name}}",
    success: "Erfolgreich",
    failed: "Fehlgeschlagen",
    event_key: "Event Schl\xfcssel",
    application: "Anwendung",
    ip_address: "IP-Adresse",
    user: "Benutzer",
    log_id: "Log-ID",
    time: "Zeit",
    user_agent: "User-Agent",
    tab_details: "Details",
    raw_data: "Rohe Daten"
};
var $2b2a8b96e06e14e9$export$2e2bcd8739ae039 = Object.freeze($2b2a8b96e06e14e9$var$log_details);


const $c827eaa2859ce794$var$logs = {
    page_title: "Audit logs",
    title: "Audit logs",
    subtitle: "Anzeige der Log Daten von Authentifizierungsereignissen, die von Admins und Benutzern stammen",
    event: "Event",
    user: "Benutzer",
    application: "Anwendung",
    time: "Zeit",
    filter_by: "Filter nach"
};
var $c827eaa2859ce794$export$2e2bcd8739ae039 = Object.freeze($c827eaa2859ce794$var$logs);


const $4f5f277396ff1226$var$menu = {
    profile: "Profil",
    language: "Sprache",
    appearance: {
        label: "Darstellung",
        light: "Hell",
        dark: "Dunkel",
        system: "Synchonisiere mit Systemeinstellungen"
    },
    sign_out: "Abmelden"
};
var $4f5f277396ff1226$export$2e2bcd8739ae039 = Object.freeze($4f5f277396ff1226$var$menu);


const $edf32b61ff5e4ebb$var$mfa = {
    title: "Zwei-Faktor-Authentifizierung",
    description: "F\xfcgen Sie der Sicherheit Ihrer Anmeldeerfahrung die Zwei-Faktor-Authentifizierung hinzu.",
    factors: "Faktoren",
    multi_factors: "Multi-Faktoren",
    multi_factors_description: "Benutzer m\xfcssen einen der aktivierten Faktoren f\xfcr die Zwei-Schritt-Verifizierung \xfcberpr\xfcfen.",
    totp: "Authenticator-App OTP",
    otp_description: "Verkn\xfcpfen Sie Google Authenticator usw., um Einmalpassw\xf6rter zu \xfcberpr\xfcfen.",
    webauthn: "WebAuthn (Passwort)",
    webauthn_description: "\xdcberpr\xfcfen Sie \xfcber browserunterst\xfctzte Methoden: Biometrie, Handy-Scan oder Sicherheitsschl\xfcssel usw.",
    webauthn_native_tip: "WebAuthn wird f\xfcr native Anwendungen nicht unterst\xfctzt.",
    webauthn_domain_tip: "WebAuthn bindet \xf6ffentliche Schl\xfcssel an die spezifische Domain. Das \xc4ndern Ihrer Servicedomain blockiert Benutzer daran, sich \xfcber vorhandene Passw\xf6rter zu authentifizieren.",
    backup_code: "Backup-Code",
    backup_code_description: "Generieren Sie nach Einrichtung einer beliebigen MFA-Methode 10 einmalige Backup-Codes.",
    backup_code_setup_hint: "Wenn Benutzer die obigen MFA-Faktoren nicht \xfcberpr\xfcfen k\xf6nnen, verwenden Sie die Backup-Option.",
    backup_code_error_hint: "Um einen Backup-Code zu verwenden, ben\xf6tigen Sie mindestens eine weitere MFA-Methode f\xfcr eine erfolgreiche Benutzerauthentifizierung.",
    policy: "Richtlinie",
    policy_description: "Legen Sie die MFA-Richtlinie f\xfcr Anmelde- und Anmeldevorg\xe4nge fest.",
    two_step_sign_in_policy: "Zwei-Schritt-Verifizierungspolitik bei der Anmeldung",
    user_controlled: "Benutzer k\xf6nnen MFA selbst aktivieren oder deaktivieren",
    user_controlled_tip: "Benutzer k\xf6nnen die MFA-Einrichtung beim ersten Mal bei der Anmeldung oder Anmeldung \xfcberspringen oder sie in den Kontoeinstellungen aktivieren/deaktivieren.",
    mandatory: "Benutzer m\xfcssen immer MFA bei der Anmeldung verwenden",
    mandatory_tip: "Benutzer m\xfcssen MFA beim ersten Mal bei der Anmeldung oder Anmeldung einrichten und es f\xfcr alle zuk\xfcnftigen Anmeldungen verwenden."
};
var $edf32b61ff5e4ebb$export$2e2bcd8739ae039 = Object.freeze($edf32b61ff5e4ebb$var$mfa);


const $bfbd8be895c492c8$var$organization_details = {
    page_title: "Organisationsdetails",
    delete_confirmation: "Wenn gel\xf6scht, verlieren alle Mitglieder ihre Mitgliedschaft und Rollen in dieser Organisation. Diese Aktion kann nicht r\xfcckg\xe4ngig gemacht werden.",
    organization_id: "Organisations-ID",
    settings_description: "Organisationen repr\xe4sentieren die Teams, Gesch\xe4ftskunden und Partnerunternehmen, die auf Ihre Anwendungen zugreifen k\xf6nnen.",
    name_placeholder: "Der Name der Organisation, muss nicht eindeutig sein.",
    description_placeholder: "Eine Beschreibung der Organisation.",
    member: "Mitglied",
    member_other: "Mitglieder",
    add_members_to_organization: "Mitglieder zur Organisation {{name}} hinzuf\xfcgen",
    add_members_to_organization_description: "Suchen Sie nach geeigneten Benutzern, indem Sie nach Name, E-Mail, Telefon oder Benutzer-ID suchen. In den Suchergebnissen werden keine bereits vorhandenen Mitglieder angezeigt.",
    add_with_organization_role: "Mit Organisation Rollen hinzuf\xfcgen",
    user: "Benutzer",
    authorize_to_roles: "Berechtige {{name}} auf die folgenden Rollen zuzugreifen:",
    edit_organization_roles: "Organisationsrollen bearbeiten",
    edit_organization_roles_of_user: "Organisationsrollen von {{name}} bearbeiten",
    remove_user_from_organization: "Benutzer von der Organisation entfernen",
    remove_user_from_organization_description: "Wenn entfernt, verliert der Benutzer seine Mitgliedschaft und Rollen in dieser Organisation. Diese Aktion kann nicht r\xfcckg\xe4ngig gemacht werden.",
    search_user_placeholder: "Nach Name, E-Mail, Telefon oder Benutzer-ID suchen",
    at_least_one_user: "Mindestens ein Benutzer ist erforderlich.",
    custom_data: "Benutzerdefinierte Daten",
    custom_data_tip: "Benutzerdefinierte Daten sind ein JSON-Objekt, das verwendet werden kann, um zus\xe4tzliche Daten zu speichern, die mit der Organisation verbunden sind.",
    invalid_json_object: "Ung\xfcltiges JSON-Objekt."
};
var $bfbd8be895c492c8$export$2e2bcd8739ae039 = Object.freeze($bfbd8be895c492c8$var$organization_details);


const $c207008aed6da57a$var$organization_role_details = {
    page_title: "Organisationsrollendetails",
    back_to_org_roles: "Zur\xfcck zu den Organisationsrollen",
    org_role: "Org-Rolle",
    delete_confirm: "Dadurch werden die mit dieser Rolle verbundenen Berechtigungen von den betroffenen Benutzern entfernt und die Beziehungen zwischen Organisationsrollen, Mitgliedern in der Organisation und Organisationsberechtigungen gel\xf6scht.",
    deleted: "Die Organisationsrolle {{name}} wurde erfolgreich gel\xf6scht.",
    permissions: {
        tab: "Berechtigungen",
        name_column: "Berechtigung",
        description_column: "Beschreibung",
        type_column: "Berechtigungstyp",
        type: {
            api: "API-Berechtigung",
            org: "Organisationsberechtigung"
        },
        assign_permissions: "Berechtigungen zuweisen",
        remove_permission: "Berechtigung entfernen",
        remove_confirmation: "Wenn diese Berechtigung entfernt wird, verliert der Benutzer mit dieser Organisationsrolle den Zugriff, der durch diese Berechtigung gew\xe4hrt wurde.",
        removed: "Die Berechtigung {{name}} wurde erfolgreich aus dieser Organisationsrolle entfernt",
        assign_description: "Weisen Sie Berechtigungen den Rollen innerhalb dieser Organisation zu. Diese k\xf6nnen sowohl Organisationsberechtigungen als auch API-Berechtigungen umfassen.",
        organization_permissions: "Organisationsberechtigungen",
        api_permissions: "API-Berechtigungen",
        assign_organization_permissions: "Organisationsberechtigungen zuweisen",
        assign_api_permissions: "API-Berechtigungen zuweisen"
    },
    general: {
        tab: "Allgemein",
        settings: "Einstellungen",
        description: "Die Organisationsrolle ist eine Gruppierung von Berechtigungen, die Benutzern zugewiesen werden k\xf6nnen. Die Berechtigungen k\xf6nnen aus den vordefinierten Organisationsberechtigungen und API-Berechtigungen stammen.",
        name_field: "Name",
        description_field: "Beschreibung",
        description_field_placeholder: "Benutzer mit nur Leseberechtigungen"
    }
};
var $c207008aed6da57a$export$2e2bcd8739ae039 = Object.freeze($c207008aed6da57a$var$organization_role_details);


const $ed0deb3777242617$var$organization_template = {
    title: "Organisationsvorlage",
    subtitle: "In Multi-Tenant-SaaS-Anwendungen definiert eine Organisationsvorlage gemeinsame Zugriffskontrollrichtlinien (Berechtigungen und Rollen) f\xfcr mehrere Organisationen.",
    roles: {
        tab_name: "Org Rollen",
        search_placeholder: "Nach Rollennamen suchen",
        create_title: "Org Rolle erstellen",
        role_column: "Org Rolle",
        permissions_column: "Berechtigungen",
        placeholder_title: "Organisationsrolle",
        placeholder_description: "Eine Organisationsrolle ist eine Gruppierung von Berechtigungen, die Benutzern zugewiesen werden k\xf6nnen. Die Berechtigungen m\xfcssen aus den vordefinierten Organisationsberechtigungen stammen.",
        create_modal: {
            title: "Rolle der Organisation erstellen",
            create: "Rolle erstellen",
            name_field: "Rollenname",
            description_field: "Beschreibung",
            created: "Die Organisationsrolle {{name}} wurde erfolgreich erstellt."
        }
    },
    permissions: {
        tab_name: "Org Berechtigungen",
        search_placeholder: "Nach Berechtigungsnamen suchen",
        create_org_permission: "Org Berechtigung erstellen",
        permission_column: "Organisationsberechtigung",
        description_column: "Beschreibung",
        placeholder_title: "Organisationsberechtigung",
        placeholder_description: "Organisationsberechtigung bezieht sich auf die Autorisierung, auf eine Ressource im Kontext der Organisation zuzugreifen.",
        delete_confirm: "Wenn diese Berechtigung gel\xf6scht wird, verlieren alle Organisationsrollen, die diese Berechtigung beinhalten, diese Berechtigung und Benutzer, die diese Berechtigung hatten, verlieren den Zugang, der durch sie gew\xe4hrt wurde.",
        create_title: "Erstellen von Organisationsberechtigungen",
        edit_title: "Bearbeiten von Organisationsberechtigungen",
        permission_field_name: "Berechtigungsname",
        description_field_name: "Beschreibung",
        description_field_placeholder: "Terminhistorie lesen",
        create_permission: "Berechtigung erstellen",
        created: "Die Organisationsberechtigung {{name}} wurde erfolgreich erstellt."
    }
};
var $ed0deb3777242617$export$2e2bcd8739ae039 = Object.freeze($ed0deb3777242617$var$organization_template);


const $05f9389f0767a3da$var$organizations = {
    organization: "Organisation",
    page_title: "Organisationen",
    title: "Organisationen",
    subtitle: "Organisationen werden \xfcblicherweise in SaaS- oder \xe4hnlichen Mehrbenutzeranwendungen verwendet und repr\xe4sentieren Ihre Kunden, die Teams, Organisationen oder ganze Unternehmen sind. Organisationen fungieren als grundlegende Elemente f\xfcr B2B-Authentifizierung und Autorisierung.",
    organization_template: "Organisationsvorlage",
    organization_id: "Organisations-ID",
    members: "Mitglieder",
    create_organization: "Organisation erstellen",
    setup_organization: "Richten Sie Ihre Organisation ein",
    organization_list_placeholder_title: "Organisation",
    organization_list_placeholder_text: "Organisationen werden in SaaS- oder \xe4hnlichen Mehrbenutzeranwendungen h\xe4ufig als bew\xe4hrte Methode verwendet. Sie erm\xf6glichen es Ihnen, Apps zu entwickeln, die es Kunden erm\xf6glichen, Organisationen zu erstellen und zu verwalten, Mitglieder einzuladen und Rollen zuzuweisen.",
    organization_name_placeholder: "Meine Organisation",
    organization_description_placeholder: "Eine kurze Beschreibung der Organisation",
    organization_permission: "Organisationsberechtigung",
    organization_permission_other: "Organisationsberechtigungen",
    create_permission_placeholder: "Terminkalenderverlauf lesen",
    organization_role: "Organisationsrolle",
    organization_role_other: "Organisationsrollen",
    organization_role_description: "Eine Organisationsrolle ist eine Gruppierung von Berechtigungen, die Benutzern zugewiesen werden k\xf6nnen. Die Berechtigungen m\xfcssen aus den vordefinierten Organisationsberechtigungen stammen.",
    role: "Rolle",
    search_placeholder: "Nach Organisation suchen",
    search_role_placeholder: "Geben Sie zum Suchen und Ausw\xe4hlen von Rollen ein",
    empty_placeholder: "\uD83E\uDD14 Sie haben noch keine {{entity}} eingerichtet.",
    organization_and_member: "Organisation und Mitglied",
    organization_and_member_description: 'Eine Organisation ist eine Gruppe von Benutzern und kann Teams, Gesch\xe4ftskunden und Partnerunternehmen darstellen, wobei jeder Benutzer ein "Mitglied" ist. Diese k\xf6nnen grundlegende Entit\xe4ten sein, um Ihre Multi-Tenant-Anforderungen zu bearbeiten.',
    guide: {
        title: "Beginnen Sie mit Anleitungen",
        subtitle: "Starten Sie Ihre Organisationseinstellungen mit unseren Anleitungen",
        introduction: {
            title: "Verstehen Sie, wie eine Organisation in Logto funktioniert",
            section_1: {
                title: "Eine Organisation ist eine Gruppe von Benutzern (Identit\xe4ten)"
            },
            section_2: {
                title: "Die Organisationsvorlage ist f\xfcr den Zugriff auf Multi-Tenant-Apps konzipiert",
                description: 'In Multi-Tenant-SaaS-Anwendungen teilen h\xe4ufig mehrere Organisationen dieselbe Zugriffskontrollvorlage, zu der Berechtigungen und Rollen geh\xf6ren. In Logto nennen wir es "Organisationsvorlage".',
                permission_description: "Die Organisationsberechtigung bezieht sich auf die Autorisierung zum Zugriff auf eine Ressource im Kontext der Organisation.",
                role_description_deprecated: "Eine Organisationsrolle ist eine Gruppierung von Organisationsberechtigungen, die Benutzern zugewiesen werden k\xf6nnen.",
                role_description: "Die Organisationsrolle ist eine Gruppierung von Organisationsberechtigungen oder API-Berechtigungen, die Mitgliedern zugewiesen werden k\xf6nnen."
            },
            section_3: {
                title: "Kann ich API-Berechtigungen zu Organisationsrollen zuweisen?",
                description: "Ja, Sie k\xf6nnen API-Berechtigungen zu Organisationsrollen zuweisen. Logto bietet die Flexibilit\xe4t, die Rollen Ihrer Organisation effektiv zu verwalten, und erm\xf6glicht es Ihnen, sowohl Organisationsberechtigungen als auch API-Berechtigungen in diese Rollen einzuschlie\xdfen."
            },
            section_4: {
                title: "Interagieren Sie mit der Abbildung, um zu sehen, wie alles zusammenh\xe4ngt",
                description: "Nehmen wir ein Beispiel. John, Sarah sind in verschiedenen Organisationen mit unterschiedlichen Rollen im Kontext verschiedener Organisationen. Fahren Sie mit der Maus \xfcber die verschiedenen Module und sehen Sie, was passiert."
            }
        },
        organization_permissions: "Organisationsberechtigungen",
        organization_roles: "Organisationsrollen",
        admin: "Admin",
        member: "Mitglied",
        guest: "Gast",
        role_description: 'Die Rolle "{{role}}" teilt dieselbe Organisationsvorlage \xfcber verschiedene Organisationen.',
        john: "John",
        john_tip: 'John geh\xf6rt zu zwei Organisationen mit der E-Mail "{{email}}" als eindeutiger Identifikator. Er ist der Administrator von Organisation A sowie der Gast von Organisation B.',
        sarah: "Sarah",
        sarah_tip: 'Sarah geh\xf6rt zu einer Organisation mit der E-Mail "{{email}}" als eindeutiger Identifikator. Sie ist die Administratorin von Organisation B.'
    }
};
var $05f9389f0767a3da$export$2e2bcd8739ae039 = Object.freeze($05f9389f0767a3da$var$organizations);


const $046f66640a010aa0$var$permissions = {
    search_placeholder: "Nach API oder Berechtigungsname suchen",
    search_placeholder_without_api: "Nach Berechtigungsname suchen",
    name_column: "Berechtigung",
    description_column: "Beschreibung",
    api_column: "API",
    placeholder_title: "Berechtigung",
    placeholder_description: "Berechtigung bezieht sich auf die Autorisierung zum Zugriff auf eine Ressource (wir nennen sie API-Ressource).",
    edit: "Bearbeitungsberechtigung",
    delete: "L\xf6schberechtigung",
    remove: "Entfernungsberechtigung",
    edit_title: "API-Berechtigung bearbeiten"
};
var $046f66640a010aa0$export$2e2bcd8739ae039 = Object.freeze($046f66640a010aa0$var$permissions);


const $9a06370431b66da8$var$profile = {
    page_title: "Account-Einstellungen",
    title: "Account-Einstellungen",
    description: "\xc4ndern Sie hier Ihre Kontoeinstellungen und verwalten Sie Ihre pers\xf6nlichen Informationen, um die Sicherheit Ihres Kontos zu gew\xe4hrleisten.",
    settings: {
        title: "PROFIL-EINSTELLUNGEN",
        profile_information: "Profil-Informationen",
        avatar: "Avatar",
        name: "Name",
        username: "Benutzername"
    },
    link_account: {
        title: "KONTO VERKN\xdcPFEN",
        email_sign_in: "E-Mail-Anmeldung",
        email: "Email",
        social_sign_in: "Social-Log-in",
        link_email: "E-Mail verkn\xfcpfen",
        link_email_subtitle: "Verkn\xfcpfen Sie Ihre E-Mail-Adresse, um sich anzumelden oder bei der Wiederherstellung Ihres Kontos zu helfen.",
        email_required: "Email ist erforderlich",
        invalid_email: "Ung\xfcltige E-Mail-Adresse",
        identical_email_address: "Die eingegebene E-Mail-Adresse ist identisch mit der aktuellen.",
        anonymous: "Anonym"
    },
    password: {
        title: "PASSWORT & SICHERHEIT",
        password: "Passwort",
        password_setting: "Passworteinstellungen",
        new_password: "Neues Passwort",
        confirm_password: "Passwort best\xe4tigen",
        enter_password: "Geben Sie das aktuelle Passwort ein",
        enter_password_subtitle: "\xdcberpr\xfcfen Sie, dass es sich um Sie handelt, um die Sicherheit Ihres Kontos zu sch\xfctzen. Bitte geben Sie Ihr aktuelles Passwort ein, bevor Sie es \xe4ndern.",
        set_password: "Passwort festlegen",
        verify_via_password: "\xdcberpr\xfcfen per Passwort",
        show_password: "Passwort zeigen",
        required: "Passwort ist erforderlich",
        do_not_match: "Die Passw\xf6rter stimmen nicht \xfcberein. Bitte versuchen Sie es erneut."
    },
    code: {
        enter_verification_code: "Best\xe4tigungscode eingeben",
        enter_verification_code_subtitle: "Der Best\xe4tigungscode wurde an <strong>{{target}}</strong> gesendet",
        verify_via_code: "\xdcberpr\xfcfen per Best\xe4tigungscode",
        resend: "Best\xe4tigungscode erneut senden",
        resend_countdown: "Erneut senden in {{countdown}} Sekunden"
    },
    delete_account: {
        title: "KONTO L\xd6SCHEN",
        label: "Konto l\xf6schen",
        description: "Wenn Sie Ihr Konto l\xf6schen, werden alle Ihre pers\xf6nlichen Informationen, Benutzerdaten und Konfigurationen entfernt. Diese Aktion kann nicht r\xfcckg\xe4ngig gemacht werden.",
        button: "Konto l\xf6schen",
        dialog_paragraph_1: "Wir bedauern, dass Sie Ihr Konto l\xf6schen m\xf6chten. Das L\xf6schen Ihres Kontos entfernt dauerhaft alle Daten, einschlie\xdflich Benutzerinformationen, Protokolle und Einstellungen, und diese Aktion kann nicht r\xfcckg\xe4ngig gemacht werden. Stellen Sie also sicher, dass Sie wichtige Daten sichern, bevor Sie fortfahren.",
        dialog_paragraph_2: 'Um mit dem Konto-L\xf6schvorgang fortzufahren, senden Sie bitte eine E-Mail an unser Support-Team unter <a>mail</a> mit dem Betreff "Anforderung zur Kontol\xf6schung". Wir werden Ihnen helfen und sicherstellen, dass all Ihre Daten ordnungsgem\xe4\xdf aus unserem System gel\xf6scht werden.',
        dialog_paragraph_3: "Vielen Dank, dass Sie sich f\xfcr Logto Cloud entschieden haben. Wenn Sie weitere Fragen oder Bedenken haben, z\xf6gern Sie bitte nicht, uns zu kontaktieren."
    },
    set: "Festlegen",
    change: "\xc4ndern",
    link: "Verkn\xfcpfen",
    unlink: "Verkn\xfcpfung aufheben",
    not_set: "Nicht festgelegt",
    change_avatar: "Avatar \xe4ndern",
    change_name: "Name \xe4ndern",
    change_username: "Benutzernamen \xe4ndern",
    set_name: "Name festlegen",
    email_changed: "E-Mail ge\xe4ndert.",
    password_changed: "Passwort ge\xe4ndert.",
    updated: "{{target}} aktualisiert.",
    linked: "{{target}} verkn\xfcpft.",
    unlinked: "{{target}} Verkn\xfcpfung aufgehoben.",
    email_exists_reminder: "Diese E-Mail {{email}} ist mit einem bestehenden Konto verkn\xfcpft. Verkn\xfcpfen Sie hier eine andere E-Mail-Adresse.",
    unlink_confirm_text: "Ja, Verkn\xfcpfung aufheben",
    unlink_reminder: "Benutzer k\xf6nnen sich nicht mehr mit dem <span></span>-Konto anmelden, wenn Sie es trennen. M\xf6chten Sie fortfahren?"
};
var $9a06370431b66da8$export$2e2bcd8739ae039 = Object.freeze($9a06370431b66da8$var$profile);


const $7ce2bc49fb6af1be$var$protected_app = {
    name: "Gesch\xfctzte App",
    title: "Erstellen einer gesch\xfctzten App: F\xfcgen Sie Authentifizierung mit Einfachheit und epischer Geschwindigkeit hinzu",
    description: "Die gesch\xfctzte App pflegt Benutzersitzungen sicher und leitet Ihre App-Anfragen weiter. Angetrieben von Cloudflare-Workern, genie\xdfen Sie die erstklassige Leistung und weltweiten 0-ms-Kaltstart. <a> Mehr erfahren </a>",
    fast_create: "Schnell erstellen",
    modal_title: "Gesch\xfctzte App erstellen",
    modal_subtitle: "Aktivieren Sie mit wenigen Klicks sicheren und schnellen Schutz. F\xfcgen Sie Authentifizierung zu Ihrer vorhandenen Web-App hinzu mit Leichtigkeit",
    form: {
        url_field_label: "Ihre Ursprungs-URL",
        url_field_placeholder: "https://domain.com/",
        url_field_description: "Geben Sie die Adresse Ihrer App an, die einen Authentifizierungsschutz ben\xf6tigt.",
        url_field_modification_notice: "\xc4nderungen an der Ursprungs-URL k\xf6nnen bis zu 1-2 Minuten dauern, um weltweit wirksam zu werden.",
        url_field_tooltip: "Geben Sie die Adresse Ihrer Anwendung an, ohne '/pathname'. Nach der Erstellung k\xf6nnen Sie die Routenauthentifizierungsregeln anpassen.\n\nHinweis: Die Ursprungs-URL selbst erfordert keine Authentifizierung; Der Schutz wird ausschlie\xdflich f\xfcr Aufrufe \xfcber die daf\xfcr vorgesehene App-Dom\xe4ne angewendet.",
        domain_field_label: "App-Dom\xe4ne",
        domain_field_placeholder: "ihre-domain",
        domain_field_description: "Diese URL dient als ein Authentifizierungsschutzproxy f\xfcr die originale URL. Nach der Erstellung kann eine benutzerdefinierte Domain angewendet werden.",
        domain_field_description_short: "Diese URL dient als ein Authentifizierungsschutzproxy f\xfcr die originale URL.",
        domain_field_tooltip: "Apps, die von Logto gesch\xfctzt sind, werden standardm\xe4\xdfig unter 'ihre-domain.{{domain}}' gehostet. Eine benutzerdefinierte Domain kann nach der Erstellung angewendet werden.",
        create_application: "Anwendung erstellen",
        create_protected_app: "Schnell erstellen",
        errors: {
            domain_required: "Ihre Domain ist erforderlich.",
            domain_in_use: "Dieser Subdom\xe4nenname wird bereits verwendet.",
            invalid_domain_format: "Ung\xfcltiges Subdom\xe4nenformat: Verwenden Sie nur Kleinbuchstaben, Zahlen und Bindestriche '-'.",
            url_required: "Ursprungs-URL ist erforderlich.",
            invalid_url: "Ung\xfcltiges Ursprungs-URL-Format: Verwenden Sie http:// oder https://. Hinweis: '/pathname' wird derzeit nicht unterst\xfctzt.",
            localhost: "Bitte belichten Sie zun\xe4chst Ihren lokalen Server im Internet. Erfahren Sie mehr \xfcber die <a> lokale Entwicklung </a>."
        }
    },
    success_message: "\uD83C\uDF89 App-Authentifizierung erfolgreich aktiviert! Entdecken Sie die neue Erfahrung Ihrer Webseite."
};
var $7ce2bc49fb6af1be$export$2e2bcd8739ae039 = Object.freeze($7ce2bc49fb6af1be$var$protected_app);


const $1ce3d76963f48b3f$var$role_details = {
    back_to_roles: "Zur\xfcck zu Rollen",
    identifier: "Identifikator",
    delete_description: "Dadurch werden die mit dieser Rolle verbundenen Berechtigungen von den betroffenen Benutzern entfernt und die Zuordnung zwischen Rollen, Benutzern und Berechtigungen gel\xf6scht.",
    role_deleted: "{{name}} wurde erfolgreich gel\xf6scht.",
    general_tab: "Allgemein",
    users_tab: "Benutzer",
    m2m_apps_tab: "Maschinen-zu-Maschinen-Apps",
    permissions_tab: "Berechtigungen",
    settings: "Einstellungen",
    settings_description: "Rollen sind eine Gruppierung von Berechtigungen, die Benutzern zugewiesen werden k\xf6nnen. Sie erm\xf6glichen auch eine Zusammenfassung von Berechtigungen, die f\xfcr verschiedene APIs definiert wurden, was es effizienter macht, Berechtigungen im Vergleich zur individuellen Zuweisung an Benutzer hinzuzuf\xfcgen, zu entfernen oder zu \xe4ndern.",
    field_name: "Name",
    field_description: "Beschreibung",
    field_is_default: "Standardrolle",
    field_is_default_description: "Setze diese Rolle als Standardrolle f\xfcr neue Benutzer. Es k\xf6nnen mehrere Standardrollen festgelegt werden. Dies betrifft auch die Standardrollen f\xfcr Benutzer, die \xfcber die Management-API erstellt wurden.",
    type_m2m_role_tag: "Maschinen-zu-Maschinen-App-Rolle",
    type_user_role_tag: "Benutzerrolle",
    m2m_role_notification: "Weisen Sie dieser Maschinen-zu-Maschinen-Rolle eine Maschinen-zu-Maschinen-App zu, um Zugriff auf die entsprechenden API-Ressourcen zu gew\xe4hren. <a>Erstellen Sie zuerst eine Maschinen-zu-Maschinen-App</a>, wenn Sie noch keine erstellt haben.",
    permission: {
        assign_button: "Berechtigungen zuweisen",
        assign_title: "Berechtigungen zuweisen",
        assign_subtitle: "Weisen Sie dieser Rolle Berechtigungen zu. Die Rolle erh\xe4lt die hinzugef\xfcgten Berechtigungen, und Benutzer mit dieser Rolle erben diese Berechtigungen.",
        assign_form_field: "Berechtigungen zuweisen",
        added_text_one: "Ein Berechtigung hinzugef\xfcgt",
        added_text_other: "{{count, number}} Berechtigungen hinzugef\xfcgt",
        api_permission_count_one: "{{count, number}} Berechtigung",
        api_permission_count_other: "{{count, number}} Berechtigungen",
        confirm_assign: "Berechtigungen zuweisen",
        permission_assigned: "Die ausgew\xe4hlten Berechtigungen wurden dieser Rolle erfolgreich zugewiesen",
        deletion_description: "Wenn diese Berechtigung entfernt wird, verliert der betroffene Benutzer mit dieser Rolle den Zugriff, der durch diese Berechtigung gew\xe4hrt wurde.",
        permission_deleted: 'Die Berechtigung "{{name}}" wurde erfolgreich von dieser Rolle entfernt',
        empty: "Keine Berechtigung verf\xfcgbar"
    },
    users: {
        assign_button: "Benutzer zuweisen",
        name_column: "Benutzer",
        app_column: "App",
        latest_sign_in_column: "Letzte Anmeldung",
        delete_description: "Es bleibt in Ihrer Benutzergruppe, aber verliert die Autorisierung f\xfcr diese Rolle.",
        deleted: "{{name}} wurde erfolgreich von dieser Rolle entfernt",
        assign_title: "Benutzer zuweisen",
        assign_subtitle: "Weisen Sie Benutzer dieser Rolle zu. Finden Sie geeignete Benutzer, indem Sie nach Name, E-Mail, Telefon oder Benutzer-ID suchen.",
        assign_field: "Benutzer zuweisen",
        confirm_assign: "Benutzer zuweisen",
        assigned_toast_text: "Die ausgew\xe4hlten Benutzer wurden erfolgreich dieser Rolle zugewiesen",
        empty: "Kein Benutzer verf\xfcgbar"
    },
    applications: {
        assign_button: "Apps zuweisen",
        name_column: "Anwendung",
        app_column: "Apps",
        description_column: "Beschreibung",
        delete_description: "Es bleibt in Ihrem Anwendungspool, verliert jedoch die Autorisierung f\xfcr diese Rolle.",
        deleted: "{{name}} wurde erfolgreich aus dieser Rolle entfernt",
        assign_title: "Apps zuweisen",
        assign_subtitle: "Weisen Sie dieser Rolle Anwendungen zu. Finden Sie geeignete Anwendungen, indem Sie nach Name, Beschreibung oder App-ID suchen.",
        assign_field: "Apps zuweisen",
        confirm_assign: "Apps zuweisen",
        assigned_toast_text: "Die ausgew\xe4hlten Anwendungen wurden erfolgreich dieser Rolle zugewiesen",
        empty: "Keine Anwendung verf\xfcgbar"
    }
};
var $1ce3d76963f48b3f$export$2e2bcd8739ae039 = Object.freeze($1ce3d76963f48b3f$var$role_details);


const $2db58f4182465a68$var$roles = {
    page_title: "Rollen",
    title: "Rollen",
    subtitle: "Rollen beinhalten Berechtigungen, die bestimmen, was ein Benutzer tun kann. RBAC verwendet Rollen, um Benutzern Zugriff auf Ressourcen f\xfcr bestimmte Aktionen zu geben.",
    create: "Rolle erstellen",
    role_name: "Rollenname",
    role_type: "Rollenart",
    show_role_type_button_text: "Weitere Optionen anzeigen",
    hide_role_type_button_text: "Weitere Optionen ausblenden",
    type_user: "Benutzerrolle",
    type_machine_to_machine: "Maschinen-zu-Maschinen-App-Rolle",
    role_description: "Beschreibung",
    role_name_placeholder: "Geben Sie Ihren Rollennamen ein",
    role_description_placeholder: "Geben Sie Ihre Rollenbeschreibung ein",
    col_roles: "Rollen",
    col_type: "Art",
    col_description: "Beschreibung",
    col_assigned_entities: "Zugewiesen",
    user_counts: "{{count}} Benutzer",
    application_counts: "{{count}} Apps",
    user_count: "{{count}} Benutzer",
    application_count: "{{count}} App",
    assign_permissions: "Berechtigungen zuweisen",
    create_role_title: "Rolle erstellen",
    create_role_description: "Erstellen und verwalten Sie Rollen f\xfcr Ihre Anwendungen. Rollen enthalten Sammlungen von Berechtigungen und k\xf6nnen Benutzern zugewiesen werden.",
    create_role_button: "Rolle erstellen",
    role_created: "Die Rolle {{name}} wurde erfolgreich erstellt.",
    search: "Nach Rollennamen, Beschreibung oder ID suchen",
    placeholder_title: "Rollen",
    placeholder_description: "Rollen sind eine Gruppierung von Berechtigungen, die Benutzern zugewiesen werden k\xf6nnen. Stellen Sie sicher, dass Sie zuerst Berechtigungen hinzuf\xfcgen, bevor Sie Rollen erstellen.",
    assign_user_roles: "Benutzerrollen zuweisen",
    assign_m2m_roles: "Maschinenrollen zuweisen",
    management_api_access_notification: "F\xfcr den Zugriff auf die Logto-Verwaltungs-API w\xe4hlen Sie Rollen mit Verwaltungs-API-Berechtigungen <flag/> aus.",
    with_management_api_access_tip: "Diese Maschinenrollen umfassen Berechtigungen f\xfcr die Logto-Verwaltungs-API"
};
var $2db58f4182465a68$export$2e2bcd8739ae039 = Object.freeze($2db58f4182465a68$var$roles);


const $88dee028fe0936fe$var$session_expired = {
    title: "Sitzung abgelaufen",
    subtitle: "Deine Sitzung ist m\xf6glicherweise abgelaufen und deine Verbindung wurde unterbrochen. Klicke auf die Schaltfl\xe4che unten, um dich erneut an der Admin Konsole anzumelden.",
    button: "Erneut anmelden"
};
var $88dee028fe0936fe$export$2e2bcd8739ae039 = Object.freeze($88dee028fe0936fe$var$session_expired);


const $88d001eeb087acee$var$content = {
    terms_of_use: {
        title: "TERMS",
        terms_of_use: "Terms of use URL",
        terms_of_use_placeholder: "https://your.terms.of.use/",
        privacy_policy: "Privacy policy URL",
        privacy_policy_placeholder: "https://your.privacy.policy/"
    },
    languages: {
        title: "LANGUAGES",
        enable_auto_detect: "Enable auto-detect",
        description: "Your software detects the user's locale setting and switches to the local language. You can add new languages by translating UI from English to another language.",
        manage_language: "Manage language",
        default_language: "Default language",
        default_language_description_auto: "The default language will be used when the detected user language isn’t covered in the current language library.",
        default_language_description_fixed: "When auto-detect is off, the default language is the only language your software will show. Turn on auto-detect for language extension."
    },
    manage_language: {
        title: "Manage language",
        subtitle: "Localize the product experience by adding languages and translations. Your contribution can be set as the default language.",
        add_language: "Add Language",
        logto_provided: "Logto provided",
        key: "Key",
        logto_source_values: "Logto source values",
        custom_values: "Custom values",
        clear_all_tip: "Clear all values",
        unsaved_description: "Changes won’t be saved if you leave this page without saving.",
        deletion_tip: "Delete the language",
        deletion_title: "Do you want to delete the added language?",
        deletion_description: "After deletion, your users won’t be able to browse in that language again.",
        default_language_deletion_title: "Default language can’t be deleted.",
        default_language_deletion_description: "{{language}} is set as your default language and can’t be deleted. "
    }
};
var $88d001eeb087acee$export$2e2bcd8739ae039 = Object.freeze($88d001eeb087acee$var$content);


const $b043da47c515c754$var$password_policy = {
    password_requirements: "Passwortanforderungen",
    minimum_length: "Mindestl\xe4nge",
    minimum_length_description: "NIST schl\xe4gt vor, <a>mindestens 8 Zeichen</a> f\xfcr Webprodukte zu verwenden.",
    minimum_length_error: "Die Mindestl\xe4nge muss zwischen {{min}} und {{max}} (einschlie\xdflich) sein.",
    minimum_required_char_types: "Mindestanzahl erforderlicher Zeichentypen",
    minimum_required_char_types_description: "Zeichentypen: Gro\xdfbuchstaben (A-Z), Kleinbuchstaben (a-z), Zahlen (0-9) und Sonderzeichen ({{symbols}}).",
    password_rejection: "Passwortablehnung",
    compromised_passwords: "Abgelehnte Passw\xf6rter",
    breached_passwords: "Verletzte Passw\xf6rter",
    breached_passwords_description: "Ablehnung von zuvor in den Verletzungsdatenbanken gefundenen Passw\xf6rtern.",
    restricted_phrases: "Einschr\xe4nkung niedrigsicherer Phrasen",
    restricted_phrases_tooltip: "Ihr Passwort sollte diese Phrasen vermeiden, es sei denn, Sie kombinieren sie mit 3 oder mehr zus\xe4tzlichen Zeichen.",
    repetitive_or_sequential_characters: "Wiederholte oder aufeinanderfolgende Zeichen",
    repetitive_or_sequential_characters_description: 'Zum Beispiel "AAAA", "1234" und "abcd".',
    user_information: "Benutzerinformationen",
    user_information_description: "Zum Beispiel E-Mail-Adresse, Telefonnummer, Benutzername, etc.",
    custom_words: "Benutzerdefinierte W\xf6rter",
    custom_words_description: "Personalisierte kontextspezifische W\xf6rter, Gro\xdf-/Kleinschreibung wird nicht beachtet, ein Wort pro Zeile.",
    custom_words_placeholder: "Name Ihres Dienstes, Firmenname, etc."
};
var $b043da47c515c754$export$2e2bcd8739ae039 = Object.freeze($b043da47c515c754$var$password_policy);


const $7a1beb48bbd72d6e$var$sign_up_and_sign_in = {
    identifiers_email: "E-Mail Adresse",
    identifiers_phone: "Telefonnummer",
    identifiers_username: "Benutzername",
    identifiers_email_or_sms: "E-Mail Adresse oder Telefonnummer",
    identifiers_none: "Nicht zutreffend",
    and: "und",
    or: "oder",
    sign_up: {
        title: "ANMELDEN",
        sign_up_identifier: "Anmeldeidentifier",
        identifier_description: "Der Anmeldeidentifier ist erforderlich f\xfcr die Kontoerstellung und muss in Ihrem Anmeldefenster enthalten sein.",
        sign_up_authentication: "Authentifizierungseinstellung f\xfcr die Anmeldung",
        authentication_description: "Alle ausgew\xe4hlten Aktionen sind f\xfcr Benutzer verpflichtend, um den Vorgang abzuschlie\xdfen.",
        set_a_password_option: "Erstellen Sie Ihr Passwort",
        verify_at_sign_up_option: "Bei Anmeldung \xfcberpr\xfcfen",
        social_only_creation_description: "(Dies gilt nur f\xfcr die Erstellung von Social-Accounts)"
    },
    sign_in: {
        title: "ANMELDEN",
        sign_in_identifier_and_auth: "Anmeldeidentifier und Authentifizierungseinstellungen",
        description: "Benutzer k\xf6nnen sich \xfcber jede der verf\xfcgbaren Optionen anmelden. Passen Sie das Layout an, indem Sie die folgenden Optionen per Drag & Drop anordnen.",
        add_sign_in_method: "Anmeldemethode hinzuf\xfcgen",
        password_auth: "Passwort",
        verification_code_auth: "Verifizierungscode",
        auth_swap_tip: "Tauschen Sie die untenstehenden Optionen aus, um zu bestimmen, welche zuerst im Vorgang angezeigt wird.",
        require_auth_factor: "Sie m\xfcssen mindestens einen Authentifizierungsfaktor ausw\xe4hlen."
    },
    social_sign_in: {
        title: "ANMELDEN MIT SOCIAL MEDIA",
        social_sign_in: "Anmelden mit Social Media",
        description: "Abh\xe4ngig von der obligatorischen Identifizierung, die Sie eingerichtet haben, wird Ihr Benutzer m\xf6glicherweise aufgefordert, bei der Anmeldung \xfcber den Social Connector eine Identifizierung bereitzustellen.",
        add_social_connector: "Sozialen Connector hinzuf\xfcgen",
        set_up_hint: {
            not_in_list: "Nicht in der Liste?",
            set_up_more: "Einrichten",
            go_to: "andere Social Connectors jetzt."
        }
    },
    tip: {
        set_a_password: "Ein einmaliges Passwort f\xfcr Ihren Benutzernamen ist ein Muss.",
        verify_at_sign_up: "Wir unterst\xfctzen derzeit nur \xfcberpr\xfcfte E-Mails. Ihre Benutzerbasis kann eine gro\xdfe Anzahl von E-Mail-Adressen von schlechter Qualit\xe4t enthalten, wenn keine Validierung vorliegt.",
        password_auth: "Dies ist unerl\xe4sslich, da Sie die Option zum Setzen eines Passworts w\xe4hrend des Anmeldeprozesses aktiviert haben.",
        verification_code_auth: "Dies ist unerl\xe4sslich, da Sie nur die M\xf6glichkeit aktiviert haben, einen Verifizierungscode bei der Anmeldung bereitzustellen. Sie k\xf6nnen das Kontrollk\xe4stchen deaktivieren, wenn die Passworteinrichtung im Anmeldeprozess erlaubt ist.",
        delete_sign_in_method: "Dies ist unerl\xe4sslich, da Sie {{identifier}} als obligatorischen Identifier ausgew\xe4hlt haben."
    },
    advanced_options: {
        title: "ERWEITERTE OPTIONEN",
        enable_single_sign_on: "Enterprise-Single Sign-On (SSO) aktivieren",
        enable_single_sign_on_description: "Aktivieren Sie Benutzer, sich bei der Anwendung mit Single Sign-On mit ihren Unternehmens-Identit\xe4ten anzumelden.",
        single_sign_on_hint: {
            prefix: "Gehe zu ",
            link: 'Abschnitt "Enterprise SSO"',
            suffix: ", um weitere Unternehmens-Connectors einzurichten."
        },
        enable_user_registration: "Benutzerregistrierung aktivieren",
        enable_user_registration_description: "Aktivieren oder deaktivieren Sie die Benutzerregistrierung. Sobald deaktiviert, k\xf6nnen Benutzer immer noch \xfcber die Admin-Konsole hinzugef\xfcgt werden, aber Benutzer k\xf6nnen keine Konten mehr \xfcber die Anmelde-Benutzeroberfl\xe4che einrichten."
    }
};
var $7a1beb48bbd72d6e$export$2e2bcd8739ae039 = Object.freeze($7a1beb48bbd72d6e$var$sign_up_and_sign_in);


const $f0df82fa720b782c$var$sign_in_exp = {
    page_title: "Anmeldeoberfl\xe4che",
    title: "Anmeldeoberfl\xe4che",
    description: "Passe die Benutzeroberfl\xe4che f\xfcr die Anmeldung an deine Marke an und zeige eine Vorschau in Echtzeit an",
    tabs: {
        branding: "Branding",
        sign_up_and_sign_in: "Anmeldung und Registrierung",
        content: "Inhalt",
        password_policy: "Passwortrichtlinie"
    },
    welcome: {
        title: "Anmeldungs-Erlebnis anpassen",
        description: "Setze schnell deine erste Anmeldung ein. Dieser Leitfaden f\xfchrt dich durch alle notwendigen Einstellungen.",
        get_started: "Erste Schritte",
        apply_remind: "Bitte beachte, dass die Anmeldeoberfl\xe4che f\xfcr alle Anwendungen unter diesem Konto gilt."
    },
    color: {
        title: "FARBE",
        primary_color: "Markenfarbe",
        dark_primary_color: "Markenfarbe (Dunkler Modus)",
        dark_mode: "Aktiviere Dunklen Modus",
        dark_mode_description: "Deine App erh\xe4lt einen automatisch generierten Dunklen Modus, der auf deiner Markenfarbe und dem Logto-Algorithmus basiert. Du kannst diesen nach Belieben anpassen.",
        dark_mode_reset_tip: "Neuberechnung der Farbe des dunklen Modus basierend auf der Markenfarbe.",
        reset: "Neuberechnen"
    },
    branding: {
        title: "BRANDING",
        ui_style: "Stil",
        favicon: "Favicon",
        logo_image_url: "App Logo-URL",
        logo_image_url_placeholder: "https://dein.cdn.domain/logo.png",
        dark_logo_image_url: "App Logo-URL (Dunkler Modus)",
        dark_logo_image_url_placeholder: "https://dein.cdn.domain/logo-dark.png",
        logo_image: "App-Logo",
        dark_logo_image: "App-Logo (Dunkler Modus)",
        logo_image_error: "App-Logo: {{error}}",
        favicon_error: "Favicon: {{error}}"
    },
    custom_css: {
        title: "Benutzerdefiniertes CSS",
        css_code_editor_title: "Personalisiere dein UI mit Benutzerdefiniertem CSS",
        css_code_editor_description1: "Beispiele f\xfcr benutzerdefiniertes CSS anzeigen.",
        css_code_editor_description2: "<a>{{link}}</a>.",
        css_code_editor_description_link_content: "Erfahre mehr",
        css_code_editor_content_placeholder: "Gib dein benutzerdefiniertes CSS ein, um den Stil von allem genau nach deinen Vorgaben zu gestalten. Gib deiner Kreativit\xe4t Ausdruck und hebe dein UI hervor."
    },
    sign_up_and_sign_in: $7a1beb48bbd72d6e$export$2e2bcd8739ae039,
    content: $88d001eeb087acee$export$2e2bcd8739ae039,
    password_policy: $b043da47c515c754$export$2e2bcd8739ae039,
    setup_warning: {
        no_connector_sms: 'Es wurde noch kein SMS-Konnektor eingerichtet. Bevor die Konfiguration abgeschlossen werden kann, k\xf6nnen sich Benutzer nicht mit dieser Methode anmelden. <a>{{link}}</a> in "Verbindungen".',
        no_connector_email: 'Es wurde noch kein E-Mail-Konnektor eingerichtet. Bevor die Konfiguration abgeschlossen werden kann, k\xf6nnen sich Benutzer nicht mit dieser Methode anmelden. <a>{{link}}</a> in "Verbindungen".',
        no_connector_social: 'Sie haben noch keine soziale Verbindung eingerichtet. F\xfcgen Sie zuerst Verbindungen hinzu, um soziale Anmeldeverfahren anzuwenden. <a>{{link}}</a> in "Verbindungen".',
        setup_link: "Einrichtung"
    },
    save_alert: {
        description: "Du implementierst neue Anmelde- und Registrierungsverfahren. Alle deine Benutzer k\xf6nnen von der neuen Einrichtung betroffen sein. Bist du sicher, dass du die \xc4nderung abschlie\xdfen m\xf6chtest?",
        before: "Vorher",
        after: "Nachher",
        sign_up: "Registrierung",
        sign_in: "Anmeldung",
        social: "Sozial"
    },
    preview: {
        title: "Vorschau",
        live_preview: "Live-Vorschau",
        live_preview_tip: "Speichern, um \xc4nderungen anzuzeigen",
        native: "Native",
        desktop_web: "Desktop-Web",
        mobile_web: "Mobile-Web",
        desktop: "Desktop",
        mobile: "Mobilger\xe4t"
    }
};
var $f0df82fa720b782c$export$2e2bcd8739ae039 = Object.freeze($f0df82fa720b782c$var$sign_in_exp);


const $f3a05fb84c1694a6$var$signing_keys = {
    title: "Signierschl\xfcssel",
    description: "Verwalten Sie sicher die Signierschl\xfcssel, die von Ihren Anwendungen verwendet werden.",
    private_key: "OIDC-Privatschl\xfcssel",
    private_keys_description: "OIDC-Privatschl\xfcssel werden zum Signieren von JWT-Token verwendet.",
    cookie_key: "OIDC-Cookieschl\xfcssel",
    cookie_keys_description: "OIDC-Cookieschl\xfcssel werden zum Signieren von Cookies verwendet.",
    private_keys_in_use: "Verwendete private Schl\xfcssel",
    cookie_keys_in_use: "Verwendete Cookie-Schl\xfcssel",
    rotate_private_keys: "Private Schl\xfcssel rotieren",
    rotate_cookie_keys: "Cookie-Schl\xfcssel rotieren",
    rotate_private_keys_description: "Diese Aktion erstellt einen neuen privaten Signierungsschl\xfcssel, rotiert den aktuellen Schl\xfcssel und entfernt Ihren vorherigen Schl\xfcssel. Ihre JWT-Token, die mit dem aktuellen Schl\xfcssel signiert sind, bleiben g\xfcltig, bis sie gel\xf6scht oder erneut rotiert werden.",
    rotate_cookie_keys_description: "Diese Aktion erstellt einen neuen Cookie-Schl\xfcssel, rotiert den aktuellen Schl\xfcssel und entfernt Ihren vorherigen Schl\xfcssel. Ihre Cookies mit dem aktuellen Schl\xfcssel bleiben g\xfcltig, bis sie gel\xf6scht oder erneut rotiert werden.",
    select_private_key_algorithm: "Signierungsalgorithmus f\xfcr den neuen privaten Schl\xfcssel ausw\xe4hlen",
    rotate_button: "Rotieren",
    table_column: {
        id: "ID",
        status: "Status",
        algorithm: "Signierungsschl\xfcssel Algorithmus"
    },
    status: {
        current: "Aktuell",
        previous: "Vorherige"
    },
    reminder: {
        rotate_private_key: "Sind Sie sicher, dass Sie die <strong>OIDC-Private Keys</strong> rotieren m\xf6chten? Neue ausgestellte JWT-Token werden vom neuen Schl\xfcssel signiert. Bestehende JWT-Token bleiben g\xfcltig, bis Sie sie erneut rotieren.",
        rotate_cookie_key: "Sind Sie sicher, dass Sie die <strong>OIDC-Cookie-Keys</strong> rotieren m\xf6chten? Neue Cookies, die in Anmelde-Sitzungen generiert werden, werden mit dem neuen Cookie-Schl\xfcssel signiert. Bestehende Cookies bleiben g\xfcltig, bis Sie sie erneut rotieren.",
        delete_private_key: "Sind Sie sicher, dass Sie den <strong>OIDC-Privaten Schl\xfcssel</strong> l\xf6schen m\xf6chten? Bestehende JWT-Token, die mit diesem privaten Signierungsschl\xfcssel signiert wurden, sind nicht mehr g\xfcltig.",
        delete_cookie_key: "Sind Sie sicher, dass Sie den <strong>OIDC-Cookie-Schl\xfcssel</strong> l\xf6schen m\xf6chten? \xc4ltere Anmelde-Sitzungen mit Cookies, die mit diesem Cookie-Schl\xfcssel signiert wurden, sind nicht mehr g\xfcltig. Eine erneute Authentifizierung ist f\xfcr diese Benutzer erforderlich."
    },
    messages: {
        rotate_key_success: "Signierungsschl\xfcssel erfolgreich rotieren.",
        delete_key_success: "Schl\xfcssel erfolgreich gel\xf6scht."
    }
};
var $f3a05fb84c1694a6$export$2e2bcd8739ae039 = Object.freeze($f3a05fb84c1694a6$var$signing_keys);


const $45070cc30fa6d63b$var$quota_item = {
    tenant_limit: {
        name: "Mandanten",
        limited: "{{count, number}} Mandant",
        limited_other: "{{count, number}} Mandanten",
        unlimited: "Unbegrenzte Mandanten",
        not_eligible: "Entferne deine Mandanten"
    },
    mau_limit: {
        name: "Monatlich aktive Benutzer",
        limited: "{{count, number}} MAU",
        unlimited: "Unbegrenzte MAU",
        not_eligible: "Entferne alle Benutzer"
    },
    token_limit: {
        name: "Tokens",
        limited: "{{count, number}} Token",
        limited_other: "{{count, number}} Tokens",
        unlimited: "Unbegrenzte Tokens",
        not_eligible: "Entferne alle Benutzer, um neue Tokens zu verhindern"
    },
    applications_limit: {
        name: "Anwendungen",
        limited: "{{count, number}} Anwendung",
        limited_other: "{{count, number}} Anwendungen",
        unlimited: "Unbegrenzte Anwendungen",
        not_eligible: "Entferne deine Anwendungen"
    },
    machine_to_machine_limit: {
        name: "Maschine-zu-Maschine",
        limited: "{{count, number}} Maschine-zu-Maschine-App",
        limited_other: "{{count, number}} Maschine-zu-Maschine-Apps",
        unlimited: "Unbegrenzte Maschine-zu-Maschine-Apps",
        not_eligible: "Entferne deine Maschine-zu-Maschine-Apps"
    },
    third_party_applications_limit: {
        name: "Drittanbieter-Apps",
        limited: "{{count, number}} Drittanbieter-App",
        limited_other: "{{count, number}} Drittanbieter-Apps",
        unlimited: "Unbegrenzte Drittanbieter-Apps",
        not_eligible: "Entferne deine Drittanbieter-Apps"
    },
    resources_limit: {
        name: "API-Ressourcen",
        limited: "{{count, number}} API-Ressource",
        limited_other: "{{count, number}} API-Ressourcen",
        unlimited: "Unbegrenzte API-Ressourcen",
        not_eligible: "Entferne deine API-Ressourcen"
    },
    scopes_per_resource_limit: {
        name: "Berechtigungen pro Ressource",
        limited: "{{count, number}} Berechtigung pro Ressource",
        limited_other: "{{count, number}} Berechtigungen pro Ressource",
        unlimited: "Unbegrenzte Berechtigung pro Ressource",
        not_eligible: "Entferne deine Ressourcenberechtigungen"
    },
    custom_domain_enabled: {
        name: "Benutzerdefinierte Domain",
        limited: "Benutzerdefinierte Domain",
        unlimited: "Benutzerdefinierte Domain",
        not_eligible: "Entferne deine benutzerdefinierte Domain"
    },
    omni_sign_in_enabled: {
        name: "Omni-Anmeldung",
        limited: "Omni-Anmeldung",
        unlimited: "Omni-Anmeldung",
        not_eligible: "Deaktiviere deine Omni-Anmeldung"
    },
    built_in_email_connector_enabled: {
        name: "Integrierter E-Mail-Connector",
        limited: "Integrierter E-Mail-Connector",
        unlimited: "Integrierter E-Mail-Connector",
        not_eligible: "Entferne deinen integrierten E-Mail-Connector"
    },
    social_connectors_limit: {
        name: "Soziale Connectoren",
        limited: "{{count, number}} sozialer Connector",
        limited_other: "{{count, number}} soziale Connectoren",
        unlimited: "Unbegrenzte soziale Connectoren",
        not_eligible: "Entferne deine sozialen Connectoren"
    },
    standard_connectors_limit: {
        name: "Kostenlose Standard-Connectoren",
        limited: "{{count, number}} kostenloser Standard-Connector",
        limited_other: "{{count, number}} kostenlose Standard-Connectoren",
        unlimited: "Unbegrenzte Standard-Connectoren",
        not_eligible: "Entferne deine Standard-Connectoren"
    },
    roles_limit: {
        name: "Rollen",
        limited: "{{count, number}} Rolle",
        limited_other: "{{count, number}} Rollen",
        unlimited: "Unbegrenzte Rollen",
        not_eligible: "Entferne deine Rollen"
    },
    machine_to_machine_roles_limit: {
        name: "Machine to machine roles",
        limited: "{{count, number}} machine to machine role",
        limited_other: "{{count, number}} machine to machine roles",
        unlimited: "Unbegrenzte Machine to machine roles",
        not_eligible: "Remove your machine to machine roles"
    },
    scopes_per_role_limit: {
        name: "Berechtigungen pro Rolle",
        limited: "{{count, number}} Berechtigung pro Rolle",
        limited_other: "{{count, number}} Berechtigungen pro Rolle",
        unlimited: "Unbegrenzte Berechtigung pro Rolle",
        not_eligible: "Entferne deine Rollenberechtigungen"
    },
    hooks_limit: {
        name: "Webhooks",
        limited: "{{count, number}} Webhook",
        limited_other: "{{count, number}} Webhooks",
        unlimited: "Unbegrenzte Webhooks",
        not_eligible: "Entferne deine Webhooks"
    },
    organizations_enabled: {
        name: "Organisationen",
        limited: "Organisationen",
        unlimited: "Organisationen",
        not_eligible: "Entferne deine Organisationen"
    },
    audit_logs_retention_days: {
        name: "Audit-Log-Retention",
        limited: "Audit-Log-Retention: {{count, number}} Tag",
        limited_other: "Audit-Log-Retention: {{count, number}} Tage",
        unlimited: "Unbegrenzte Tage",
        not_eligible: "Keine Audit-Logs"
    },
    email_ticket_support: {
        name: "E-Mail-Ticket-Support",
        limited: "{{count, number}} Stunde E-Mail-Ticket-Support",
        limited_other: "{{count, number}} Stunden E-Mail-Ticket-Support",
        unlimited: "E-Mail-Ticket-Support",
        not_eligible: "Kein E-Mail-Ticket-Support"
    },
    mfa_enabled: {
        name: "Zwei-Faktor-Authentifizierung",
        limited: "Zwei-Faktor-Authentifizierung",
        unlimited: "Zwei-Faktor-Authentifizierung",
        not_eligible: "Entfernen Sie Ihre Zwei-Faktor-Authentifizierung"
    },
    sso_enabled: {
        name: "Enterprise SSO",
        limited: "Enterprise SSO",
        unlimited: "Enterprise SSO",
        not_eligible: "Entferne dein Enterprise SSO"
    },
    tenant_members_limit: {
        name: "Mandantenmitglieder",
        limited: "{{count, number}} Mandantenmitglied",
        limited_other: "{{count, number}} Mandantenmitglieder",
        unlimited: "Unbegrenzte Mandantenmitglieder",
        not_eligible: "Remove your tenant members"
    },
    custom_jwt_enabled: {
        name: "Benutzerdefiniertes JWT",
        limited: "Benutzerdefiniertes JWT",
        unlimited: "Benutzerdefiniertes JWT",
        not_eligible: "Remove your JWT claims customizer"
    }
};
var $45070cc30fa6d63b$export$2e2bcd8739ae039 = Object.freeze($45070cc30fa6d63b$var$quota_item);


const $6aa482942b756e93$var$quota_table = {
    quota: {
        title: "Grundlagen",
        base_price: "Grundpreis",
        mau_limit: "MAU-Limit",
        included_tokens: "Inkludierte Tokens"
    },
    application: {
        title: "Anwendungen",
        total: "Gesamtzahl der Anwendungen",
        m2m: "Maschine-zu-Maschine",
        third_party: "Third-party apps"
    },
    resource: {
        title: "API-Ressourcen",
        resource_count: "Ressourcenanzahl",
        scopes_per_resource: "Berechtigungen pro Ressource"
    },
    branding: {
        title: "Benutzeroberfl\xe4che und Branding",
        custom_domain: "Benutzerdefinierte Domain",
        custom_css: "Benutzerdefiniertes CSS",
        app_logo_and_favicon: "App-Logo und Favicon",
        dark_mode: "Dunkler Modus",
        i18n: "Internationalisierung"
    },
    user_authn: {
        title: "Benutzerauthentifizierung",
        omni_sign_in: "Omni-Anmeldung",
        password: "Passwort",
        passwordless: "Passwortlos - E-Mail und SMS",
        email_connector: "E-Mail-Connector",
        sms_connector: "SMS-Connector",
        social_connectors: "Social-Connectors",
        standard_connectors: "Standard-Connectors",
        built_in_email_connector: "Integrierter E-Mail-Connector",
        mfa: "Multi-Faktor-Authentifizierung",
        sso: "Unternehmens-SSO",
        adaptive_mfa: "Adaptive MFA"
    },
    user_management: {
        title: "Benutzerverwaltung",
        user_management: "Benutzerverwaltung",
        roles: "Rollen",
        machine_to_machine_roles: "Maschine-zu-Maschine Rollen",
        scopes_per_role: "Berechtigungen pro Rolle"
    },
    organizations: {
        title: "Organisation",
        organizations: "Organisationen",
        organization: "Organisation",
        organization_count: "Anzahl der Organisationen",
        allowed_users_per_org: "Benutzer pro Organisation",
        invitation: "Einladung (Management-API)",
        org_roles: "Organisationsrollen",
        org_permissions: "Organisationsberechtigungen",
        just_in_time_provisioning: "Bedarfsgesteuerte Bereitstellung"
    },
    support: {
        title: "Compliance und Support",
        community: "Gemeinschaft",
        customer_ticket: "Support-Ticket",
        premium: "Premium",
        email_ticket_support: "E-Mail-Ticket-Support",
        soc2_report: "SOC2-Bericht",
        hipaa_or_baa_report: "HIPAA/BAA-Bericht"
    },
    developers_and_platform: {
        title: "Entwickler und Plattform",
        hooks: "Webhooks",
        audit_logs_retention: "Auditprotokolle Aufbewahrung",
        jwt_claims: "JWT-Anspr\xfcche",
        tenant_members: "Mandantenmitglieder"
    },
    unlimited: "Unbegrenzt",
    contact: "Kontakt",
    monthly_price: "${{value, number}}/Monat",
    days_one: "{{count, number}} Tag",
    days_other: "{{count, number}} Tage",
    add_on: "Zusatzleistung",
    tier: "Stufe{{value, number}}: ",
    paid_token_limit_tip: "Logto wird Geb\xfchren f\xfcr Funktionen erheben, die \xfcber Ihr Kontingent hinausgehen. Sie k\xf6nnen es kostenlos nutzen, bis wir ab dem 2. Quartal 2024 mit der Abrechnung beginnen. Wenn Sie mehr Tokens ben\xf6tigen, setzen Sie sich bitte mit uns in Verbindung. Standardm\xe4\xdfig berechnen wir $80 pro Monat f\xfcr jede Million Tokens.",
    paid_quota_limit_tip: "Logto wird Geb\xfchren f\xfcr Funktionen hinzuf\xfcgen, die \xfcber Ihr Kontingent hinausgehen. Sie k\xf6nnen es kostenlos verwenden, bis wir etwa im 2. Quartal 2024 mit der Berechnung beginnen.",
    paid_add_on_feature_tip: "Dies ist eine Zusatzfunktion. Sie k\xf6nnen sie kostenlos verwenden, bis wir etwa im 2. Quartal 2024 mit der Berechnung beginnen.",
    million: "{{value, number}} Millionen",
    mau_tip: "MAU (monatlich aktive Benutzer) bezeichnet die Anzahl der eindeutigen Benutzer, die in einem Abrechnungszyklus mindestens einen Token mit Logto ausgetauscht haben.",
    tokens_tip: "Alle Arten von Tokens, die von Logto ausgegeben wurden, einschlie\xdflich Zugriffstoken, Aktualisierungstoken, usw.",
    mao_tip: "MAO (Monthly Active Org) bezeichnet die Anzahl der einzigartigen Organisationen, die in einem Abrechnungszyklus mindestens einen MAU (Monthly Active User) haben.",
    third_party_tip: "Verwenden Sie Logto als Ihren OIDC-Identit\xe4tsanbieter f\xfcr Anmeldungen von Drittanbieter-Apps und Berechtigungsvergaben.",
    included: "{{value, number}} inklusive",
    included_mao: "{{value, number}} MAO enthalten",
    extra_quota_price: "Dann ${{value, number}} pro Monat / je danach",
    per_month_each: "${{value, number}} pro Monat / je",
    extra_mao_price: "Dann ${{value, number}} pro MAO",
    per_month: "${{value, number}} pro Monat",
    per_member: "Dann ${{value, number}} pro Mitglied"
};
var $6aa482942b756e93$export$2e2bcd8739ae039 = Object.freeze($6aa482942b756e93$var$quota_table);


const $f5b309f056a7de1e$var$subscription = {
    free_plan: "Kostenloser Plan",
    free_plan_description: "F\xfcr Nebenprojekte und erste Logto-Tests. Keine Kreditkarte erforderlich.",
    pro_plan: "Pro plan",
    pro_plan_description: "F\xfcr Unternehmen, die sorgenfrei von Logto profitieren m\xf6chten.",
    enterprise: "Unternehmen",
    current_plan: "Aktueller Plan",
    current_plan_description: "Hier ist dein aktueller Tarif. Du kannst einfach deinen Tarifverbrauch einsehen, deine anstehende Rechnung \xfcberpr\xfcfen und bei Bedarf \xc4nderungen an deinem Tarif vornehmen.",
    plan_usage: "Plan-Nutzung",
    plan_cycle: "Plan-Zyklus: {{period}}. Die Nutzung wird am {{renewDate}} erneuert.",
    next_bill: "Ihre n\xe4chste Rechnung",
    next_bill_hint: "Weitere Informationen zur Berechnung finden Sie in diesem <a>Artikel</a>.",
    next_bill_tip: "Die hier angezeigten Preise verstehen sich exklusive Steuern. Die Steuer wird auf Grundlage der von Ihnen bereitgestellten Informationen und Ihrer lokalen gesetzlichen Anforderungen berechnet und in Ihren Rechnungen ausgewiesen.",
    manage_payment: "Zahlung verwalten",
    overfill_quota_warning: "Sie haben Ihr Quotenlimit erreicht. Um Probleme zu vermeiden, upgraden Sie den Plan.",
    upgrade_pro: "Pro upgraden",
    update_payment: "Zahlung aktualisieren",
    payment_error: "Es wurde ein Zahlungsproblem festgestellt. Der Betrag von ${{price, number}} f\xfcr den vorherigen Zyklus kann nicht verarbeitet werden. Aktualisieren Sie die Zahlung, um eine Aussetzung des Logto-Dienstes zu vermeiden.",
    downgrade: "Herabstufen",
    current: "Aktuell",
    upgrade: "Upgrade",
    quota_table: $6aa482942b756e93$export$2e2bcd8739ae039,
    billing_history: {
        invoice_column: "Rechnungen",
        status_column: "Status",
        amount_column: "Betrag",
        invoice_created_date_column: "Rechnungsdatum",
        invoice_status: {
            void: "Storniert",
            paid: "Bezahlt",
            open: "Offen",
            uncollectible: "\xdcberf\xe4llig"
        }
    },
    quota_item: $45070cc30fa6d63b$export$2e2bcd8739ae039,
    downgrade_modal: {
        title: "Sind Sie sicher, dass Sie herabstufen m\xf6chten?",
        description: "Wenn Sie sich f\xfcr den Wechsel zum <targetName/> entscheiden, beachten Sie bitte, dass Sie keinen Zugriff mehr auf die Quote und die Funktionen haben, die zuvor in <currentName/> enthalten waren.",
        before: "Vorher: <name/>",
        after: "Nachher: <name />",
        downgrade: "Herabstufen"
    },
    not_eligible_modal: {
        downgrade_title: "Downgrade nicht m\xf6glich",
        downgrade_description: "Stellen Sie sicher, dass Sie die folgenden Kriterien erf\xfcllen, bevor Sie auf <name/> downgraden.",
        downgrade_help_tip: "Hilfe beim Downgrade ben\xf6tigt? <a>Kontaktieren Sie uns</a>.",
        upgrade_title: "Freundliche Erinnerung f\xfcr unsere gesch\xe4tzten Early Adopters",
        upgrade_description: "Sie nutzen derzeit mehr als das, was <name /> erlaubt. Logto ist nun offiziell und bietet Funktionen, die auf jeden Tarif zugeschnitten sind. Bevor Sie ein Upgrade auf den <name /> in Betracht ziehen, stellen Sie sicher, dass Sie die folgenden Kriterien f\xfcr das Upgrade erf\xfcllen.",
        upgrade_pro_tip: " Oder erw\xe4gen Sie ein Upgrade auf den Pro plan.",
        upgrade_help_tip: "Hilfe beim Upgrade ben\xf6tigt? <a>Kontaktieren Sie uns</a>.",
        a_maximum_of: "Maximal <item/>"
    },
    upgrade_success: "Erfolgreich auf <name/> hochgestuft",
    downgrade_success: "Erfolgreich auf <name/> herabgestuft",
    subscription_check_timeout: "Abo-\xdcberpr\xfcfung ist abgelaufen. Bitte sp\xe4ter aktualisieren.",
    no_subscription: "Kein Abonnement"
};
var $f5b309f056a7de1e$export$2e2bcd8739ae039 = Object.freeze($f5b309f056a7de1e$var$subscription);


const $167a373bd21a5cd2$var$tab_sections = {
    overview: "\xdcbersicht",
    authentication: "Authentifizierung",
    authorization: "Autorisierung",
    users: "Benutzer",
    developer: "Entwickler",
    tenant: "Mieter"
};
var $167a373bd21a5cd2$export$2e2bcd8739ae039 = Object.freeze($167a373bd21a5cd2$var$tab_sections);


const $3efc6a4aa896c174$var$tabs = {
    get_started: "Erste Schritte",
    dashboard: "Dashboard",
    applications: "Anwendungen",
    api_resources: "API Ressourcen",
    sign_in_experience: "Anmeldeoberfl\xe4che",
    connectors: "Connectoren",
    enterprise_sso: "Unternehmens-SSO",
    webhooks: "Webhooks",
    organizations: "Organisationen",
    users: "Benutzerverwaltung",
    audit_logs: "Audit-Logs",
    roles: "Rollen",
    docs: "Dokumentation",
    tenant_settings: "Einstellungen",
    mfa: "Multi-Faktor-Authentifizierung",
    customize_jwt: "Benutzerdefiniertes JWT",
    signing_keys: "Signierschl\xfcssel",
    organization_template: "Organisationstemplate"
};
var $3efc6a4aa896c174$export$2e2bcd8739ae039 = Object.freeze($3efc6a4aa896c174$var$tabs);


const $37568a411437176d$var$tenant_members = {
    members: "Mitglieder",
    invitations: "Einladungen",
    invite_members: "Mitglieder einladen",
    user: "Benutzer",
    roles: "Rollen",
    admin: "Administrator",
    collaborator: "Mitarbeiter",
    invitation_status: "Einladungsstatus",
    inviter: "Einlader",
    expiration_date: "Ablaufdatum",
    invite_modal: {
        title: "Lade Leute zu Logto Cloud ein",
        subtitle: "Um Mitglieder zu einer Organisation einzuladen, m\xfcssen sie die Einladung akzeptieren.",
        to: "An",
        added_as: "Hinzugef\xfcgt als Rollen",
        email_input_placeholder: "johndoe@example.com"
    },
    invitation_statuses: {
        pending: "Ausstehend",
        accepted: "Akzeptiert",
        expired: "Abgelaufen",
        revoked: "Zur\xfcckgezogen"
    },
    invitation_empty_placeholder: {
        title: "Teammitglieder einladen",
        description: "Ihr Mandant hat derzeit keine eingeladenen Mitglieder.\nZur Unterst\xfctzung Ihrer Integration sollten Sie weitere Mitglieder oder Administratoren hinzuf\xfcgen."
    },
    menu_options: {
        edit: "Mandantenrolle bearbeiten",
        delete: "Benutzer aus Mandanten entfernen",
        resend_invite: "Einladung erneut senden",
        revoke: "Einladung zur\xfcckziehen",
        delete_invitation_record: "Diesen Einladungsdatensatz l\xf6schen"
    },
    edit_modal: {
        title: "Rollen von {{name}} \xe4ndern"
    },
    delete_user_confirm: "M\xf6chten Sie diesen Benutzer wirklich aus diesem Mandanten entfernen?",
    assign_admin_confirm: "M\xf6chten Sie sicher den/die ausgew\xe4hlten Benutzer zum Administrator machen? Die Gew\xe4hrung von Administratorzugriff gew\xe4hrt den folgenden Berechtigungen:<ul><li>\xc4ndern des Mandantenabrechnungsplans</li><li>Hinzuf\xfcgen oder Entfernen von Mitarbeitern</li><li>L\xf6schen des Mandanten</li></ul>",
    revoke_invitation_confirm: "M\xf6chten Sie diese Einladung wirklich zur\xfcckziehen?",
    delete_invitation_confirm: "M\xf6chten Sie diesen Einladungsdatensatz wirklich l\xf6schen?",
    messages: {
        invitation_sent: "Einladung gesendet.",
        invitation_revoked: "Einladung zur\xfcckgezogen.",
        invitation_resend: "Einladung erneut gesendet.",
        invitation_deleted: "Einladungsdatensatz gel\xf6scht."
    },
    errors: {
        email_required: "E-Mail f\xfcr den Eingeladenen ist erforderlich.",
        email_exists: "Die E-Mail-Adresse existiert bereits.",
        member_exists: "Dieser Benutzer ist bereits Mitglied dieser Organisation.",
        pending_invitation_exists: "Ausstehende Einladung vorhanden. L\xf6schen Sie die entsprechende E-Mail oder widerrufen Sie die Einladung.",
        invalid_email: "Die E-Mail-Adresse ist ung\xfcltig. Stellen Sie sicher, dass sie im richtigen Format vorliegt.",
        max_member_limit: "Sie haben die maximale Anzahl von Mitgliedern ({{limit}}) f\xfcr diesen Mandanten erreicht."
    }
};
var $37568a411437176d$export$2e2bcd8739ae039 = Object.freeze($37568a411437176d$var$tenant_members);


const $9cd5834731377e10$var$tenants = {
    title: "Einstellungen",
    description: "Effizientes Verwalten von Mandanteneinstellungen und Anpassen Ihrer Domain.",
    tabs: {
        settings: "Einstellungen",
        members: "Mitglieder",
        domains: "Dom\xe4nen",
        subscription: "Plan und Abrechnung",
        billing_history: "Abrechnungshistorie"
    },
    settings: {
        title: "EINSTELLUNGEN",
        description: "Legen Sie den Mandantennamen fest und \xfcberpr\xfcfen Sie Ihre gehostete Datenregion und den Mandantentyp.",
        tenant_id: "Mieter-ID",
        tenant_name: "Mietername",
        tenant_region: "Gehostete Region der Daten",
        tenant_region_tip: "Ihre Mandantenressourcen werden in {{region}} gehostet. <a>Mehr erfahren</a>",
        environment_tag_development: "Entw",
        environment_tag_production: "Prod",
        tenant_type: "Mandantentyp",
        development_description: "Nur f\xfcr Tests und sollte nicht in der Produktion verwendet werden. Es ist kein Abonnement erforderlich. Es verf\xfcgt \xfcber alle Pro-Funktionen, hat jedoch Einschr\xe4nkungen wie ein Anmeldebanner. <a>Mehr erfahren</a>",
        production_description: "Vorgesehen f\xfcr Apps, die von Endbenutzern verwendet werden und m\xf6glicherweise ein kostenpflichtiges Abonnement erfordern. <a>Mehr erfahren</a>",
        tenant_info_saved: "Mieterinformationen erfolgreich gespeichert."
    },
    full_env_tag: {
        development: "Entwicklung",
        production: "Produktion"
    },
    deletion_card: {
        title: "L\xd6SCHEN",
        tenant_deletion: "Mieter l\xf6schen",
        tenant_deletion_description: "Das L\xf6schen des Mandanten f\xfchrt zur dauerhaften Entfernung aller zugeh\xf6rigen Benutzerdaten und Konfigurationen. Bitte gehen Sie vorsichtig vor.",
        tenant_deletion_button: "Mieter l\xf6schen"
    },
    leave_tenant_card: {
        title: "VERLASSEN",
        leave_tenant: "Mieter verlassen",
        leave_tenant_description: "Alle Ressourcen im Mandanten bleiben erhalten, aber Sie haben keinen Zugriff mehr auf diesen Mandanten.",
        last_admin_note: "Um diesen Mandanten zu verlassen, stellen Sie sicher, dass mindestens ein weiteres Mitglied die Admin-Rolle hat."
    },
    create_modal: {
        title: "Mieter erstellen",
        tenant_usage_purpose: "Wof\xfcr m\xf6chten Sie diesen Mieter verwenden?",
        development_description: "Nur f\xfcr Tests und sollte nicht in der Produktion verwendet werden. Es ist kein Abonnement erforderlich.",
        development_hint: "Es verf\xfcgt \xfcber alle Pro-Funktionen, hat jedoch Einschr\xe4nkungen wie ein Anmeldebanner.",
        production_description: "F\xfcr die Nutzung durch Endbenutzer und m\xf6glicherweise ein kostenpflichtiges Abonnement.",
        available_plan: "Verf\xfcgbare Pl\xe4ne:",
        create_button: "Mieter erstellen",
        tenant_name_placeholder: "Mein Mieter"
    },
    dev_tenant_migration: {
        title: 'Sie k\xf6nnen jetzt unsere Pro-Funktionen kostenlos testen, indem Sie einen neuen "Entwicklungsmieter" erstellen!',
        affect_title: "Wie betrifft das Sie?",
        hint_1: 'Wir ersetzen die alten <strong> Umgebungstags </strong> durch zwei neue Mandantentypen: <strong> "Entwicklung" </strong> und <strong> "Produktion" </strong>.',
        hint_2: "Um einen reibungslosen \xdcbergang und unterbrechungsfreie Funktionalit\xe4t zu gew\xe4hrleisten, werden alle fr\xfcher erstellten Mandanten zum Mandantentyp <strong> Produktion </strong> mit Ihrem vorherigen Abonnement erh\xf6ht.",
        hint_3: "Keine Sorge, all Ihre anderen Einstellungen bleiben gleich.",
        about_tenant_type: "\xdcber den Mandantentyp"
    },
    delete_modal: {
        title: "Mieter l\xf6schen",
        description_line1: 'Sind Sie sicher, dass Sie Ihren Mandanten "<span>{{name}}</span>" mit dem Umgebungssuffixtag "<span>{{tag}}</span>" l\xf6schen m\xf6chten? Diese Aktion kann nicht r\xfcckg\xe4ngig gemacht werden und f\xfchrt zur dauerhaften L\xf6schung all Ihrer Daten und Mandanteninformationen.',
        description_line2: "Bevor Sie einen Mandanten l\xf6schen, k\xf6nnen wir Ihnen vielleicht helfen. <span><a>Kontaktieren Sie uns per E-Mail</a></span>",
        description_line3: 'Wenn Sie fortfahren m\xf6chten, geben Sie bitte den Mieter-Namen "<span>{{name}}</span>" zur Best\xe4tigung ein.',
        delete_button: "Dauerhaft l\xf6schen",
        cannot_delete_title: "Diesen Mandanten kann nicht gel\xf6scht werden",
        cannot_delete_description: "Entschuldigung, diesen Mandanten k\xf6nnen Sie derzeit nicht l\xf6schen. Stellen Sie sicher, dass Sie sich im kostenlosen Tarif befinden und alle ausstehenden Rechnungen bezahlt haben."
    },
    leave_tenant_modal: {
        description: "Sind Sie sicher, dass Sie diesen Mandanten verlassen m\xf6chten?",
        leave_button: "Verlassen"
    },
    tenant_landing_page: {
        title: "Du hast noch keinen Mandanten erstellt",
        description: "Um Ihr Projekt mit Logto zu konfigurieren, erstellen Sie bitte einen neuen Mandanten. Wenn Sie sich abmelden oder Ihr Konto l\xf6schen m\xf6chten, klicken Sie einfach auf die Avatar-Taste in der oberen rechten Ecke.",
        create_tenant_button: "Mandanten erstellen"
    },
    status: {
        mau_exceeded: "MAU \xfcberschritten",
        suspended: "Gesperrt",
        overdue: "\xdcberf\xe4llig"
    },
    tenant_suspended_page: {
        title: "Mieter gesperrt. Kontaktieren Sie uns, um den Zugriff wiederherzustellen.",
        description_1: "Es tut uns leid, Ihnen mitteilen zu m\xfcssen, dass Ihr Mieterkonto vor\xfcbergehend gesperrt wurde, da es unsachgem\xe4\xdf genutzt wurde. Dies umfasst die \xdcberschreitung der MAU-Grenzen, \xfcberf\xe4llige Zahlungen oder andere unbefugte Aktionen.",
        description_2: "Wenn Sie weitere Informationen w\xfcnschen, Bedenken haben oder die volle Funktionalit\xe4t wiederherstellen und Ihre Mieter entsperren m\xf6chten, z\xf6gern Sie nicht, uns umgehend zu kontaktieren."
    }
};
var $9cd5834731377e10$export$2e2bcd8739ae039 = Object.freeze($9cd5834731377e10$var$tenants);


const $cd708012e582faab$var$topbar = {
    docs: "Dokumente",
    help: "Hilfe"
};
var $cd708012e582faab$export$2e2bcd8739ae039 = Object.freeze($cd708012e582faab$var$topbar);


const $5c433254851d34f6$var$featured_plan_content = {
    mau: {
        free_plan: "Bis zu {{count, number}} MAU",
        pro_plan: "Unbegrenzte MAU"
    },
    m2m: {
        free_plan: "{{count, number}} Maschine-zu-Maschine",
        pro_plan: "Zus\xe4tzliche Maschine-zu-Maschine"
    },
    third_party_apps: "IdP f\xfcr Drittanbieteranwendungen",
    mfa: "Multi-Faktor-Authentifizierung",
    sso: "Unternehmens-SSO",
    role_and_permissions: {
        free_plan: "{{roleCount, number}} Rolle und {{permissionCount, number}} Berechtigung pro Rolle",
        pro_plan: "Unbegrenzte Rollen und Berechtigungen pro Rolle"
    },
    organizations: "Organisationen",
    audit_logs: "Audit-Logs Speicherung: {{count, number}} Tage"
};
var $5c433254851d34f6$export$2e2bcd8739ae039 = Object.freeze($5c433254851d34f6$var$featured_plan_content);


const $57913a7bb8e2c0c1$var$paywall = {
    applications: "{{count, number}} Anwendung von <planName/> erreicht. Plan upgraden, um den Bed\xfcrfnissen Ihres Teams gerecht zu werden. F\xfcr Unterst\xfctzung k\xf6nnen Sie uns gerne <a>kontaktieren</a>.",
    applications_other: "{{count, number}} Anwendungen von <planName/> erreicht. Plan upgraden, um den Bed\xfcrfnissen Ihres Teams gerecht zu werden. F\xfcr Unterst\xfctzung k\xf6nnen Sie uns gerne <a>kontaktieren</a>.",
    machine_to_machine_feature: "Wechseln Sie zum <strong>Pro</strong>-Plan, um zus\xe4tzliche Maschine-zu-Maschine-Anwendungen freizuschalten und alle Premium-Funktionen zu genie\xdfen. <a>Kontaktieren Sie uns</a>, wenn Sie Fragen haben.",
    machine_to_machine: "{{count, number}} Maschine-zu-Maschine-Anwendung von <planName/> erreicht. Plan upgraden, um den Bed\xfcrfnissen Ihres Teams gerecht zu werden. F\xfcr Unterst\xfctzung k\xf6nnen Sie uns gerne <a>kontaktieren</a>.",
    machine_to_machine_other: "{{count, number}} Maschine-zu-Maschine-Anwendungen von <planName/> erreicht. Plan upgraden, um den Bed\xfcrfnissen Ihres Teams gerecht zu werden. F\xfcr Unterst\xfctzung k\xf6nnen Sie uns gerne <a>kontaktieren</a>.",
    resources: "Sie haben das Limit von {{count, number}} <planName/>-API-Ressourcen erreicht. Upgraden Sie Ihren Plan, um den Anforderungen Ihres Teams gerecht zu werden. <a>Kontaktieren Sie uns</a>, wenn Sie Hilfe ben\xf6tigen.",
    resources_other: "Sie haben das Limit von {{count, number}} <planName/>-API-Ressourcen erreicht. Upgraden Sie Ihren Plan, um den Anforderungen Ihres Teams gerecht zu werden. <a>Kontaktieren Sie uns</a>, wenn Sie Hilfe ben\xf6tigen.",
    scopes_per_resource: "Sie haben das Limit von {{count, number}} Berechtigungen pro API-Ressource von <planName/> erreicht. Upgraden Sie jetzt, um zu erweitern. <a>Kontaktieren Sie uns</a>, wenn Sie Hilfe ben\xf6tigen.",
    scopes_per_resource_other: "Sie haben das Limit von {{count, number}} Berechtigungen pro API-Ressource von <planName/> erreicht. Upgraden Sie jetzt, um zu erweitern. <a>Kontaktieren Sie uns</a>, wenn Sie Hilfe ben\xf6tigen.",
    custom_domain: "Freischalten Sie die Funktion f\xfcr benutzerdefinierte Domains, indem Sie auf den <strong>Hobby</strong>- oder <strong>Pro</strong>-Plan upgraden. Z\xf6gern Sie nicht, uns zu <a>kontaktieren</a>, wenn Sie Unterst\xfctzung ben\xf6tigen.",
    social_connectors: "Sie haben das Limit von {{count, number}} <planName/>-Sozialconnectoren erreicht. Upgraden Sie Ihren Plan, um zus\xe4tzliche Sozialconnectoren und die M\xf6glichkeit zur Erstellung eigener Connectoren mit OIDC, OAuth 2.0 und SAML-Protokollen zu erhalten. Z\xf6gern Sie nicht, <a>Kontaktieren Sie uns</a>, wenn Sie Hilfe ben\xf6tigen.",
    social_connectors_other: "Sie haben das Limit von {{count, number}} <planName/>-Sozialconnectoren erreicht. Upgraden Sie Ihren Plan, um zus\xe4tzliche Sozialconnectoren und die M\xf6glichkeit zur Erstellung eigener Connectoren mit OIDC, OAuth 2.0 und SAML-Protokollen zu erhalten. Z\xf6gern Sie nicht, <a>Kontaktieren Sie uns</a>, wenn Sie Hilfe ben\xf6tigen.",
    standard_connectors_feature: "Upgrade auf den <strong>Hobby</strong>- oder <strong>Pro</strong>-Plan, um eigene Connectoren unter Verwendung von OIDC, OAuth 2.0 und SAML-Protokollen zu erstellen, sowie unbegrenzte Sozialconnectoren und alle Premium-Funktionen. Z\xf6gern Sie nicht, uns zu <a>kontaktieren</a>, wenn Sie Hilfe ben\xf6tigen.",
    standard_connectors: "Sie haben das Limit von {{count, number}} <planName/>-Sozialconnectoren erreicht. Upgraden Sie Ihren Plan, um zus\xe4tzliche Sozialconnectoren und die M\xf6glichkeit zur Erstellung eigener Connectoren mit OIDC, OAuth 2.0 und SAML-Protokollen zu erhalten. Z\xf6gern Sie nicht, <a>Kontaktieren Sie uns</a>, wenn Sie Hilfe ben\xf6tigen.",
    standard_connectors_other: "Sie haben das Limit von {{count, number}} <planName/>-Sozialconnectoren erreicht. Upgraden Sie Ihren Plan, um zus\xe4tzliche Sozialconnectoren und die M\xf6glichkeit zur Erstellung eigener Connectoren mit OIDC, OAuth 2.0 und SAML-Protokollen zu erhalten. Z\xf6gern Sie nicht, <a>Kontaktieren Sie uns</a>, wenn Sie Hilfe ben\xf6tigen.",
    standard_connectors_pro: "Sie haben das Limit von {{count, number}} <planName/>-Standardconnectoren erreicht. Upgraden Sie auf den Enterprise-Plan, um zus\xe4tzliche Sozialconnectoren und die M\xf6glichkeit zur Erstellung eigener Connectoren mit OIDC, OAuth 2.0 und SAML-Protokollen zu erhalten. Z\xf6gern Sie nicht, <a>Kontaktieren Sie uns</a>, wenn Sie Hilfe ben\xf6tigen.",
    standard_connectors_pro_other: "Sie haben das Limit von {{count, number}} <planName/>-Standardconnectoren erreicht. Upgraden Sie auf den Enterprise-Plan, um zus\xe4tzliche Sozialconnectoren und die M\xf6glichkeit zur Erstellung eigener Connectoren mit OIDC, OAuth 2.0 und SAML-Protokollen zu erhalten. Z\xf6gern Sie nicht, <a>Kontaktieren Sie uns</a>, wenn Sie Hilfe ben\xf6tigen.",
    roles: "Sie haben das Limit von {{count, number}} <planName/>-Rollen erreicht. Upgraden Sie Ihren Plan, um zus\xe4tzliche Rollen und Berechtigungen hinzuzuf\xfcgen. Z\xf6gern Sie nicht, <a>Kontaktieren Sie uns</a>, wenn Sie Hilfe ben\xf6tigen.",
    roles_other: "Sie haben das Limit von {{count, number}} <planName/>-Rollen erreicht. Upgraden Sie Ihren Plan, um zus\xe4tzliche Rollen und Berechtigungen hinzuzuf\xfcgen. Z\xf6gern Sie nicht, <a>Kontaktieren Sie uns</a>, wenn Sie Hilfe ben\xf6tigen.",
    machine_to_machine_roles: "{{count, number}} Maschine-zu-Maschine-Rolle des Limits von <planName/> erreicht. Upgraden Sie Ihren Plan, um zus\xe4tzliche Rollen und Berechtigungen hinzuzuf\xfcgen. F\xfchlen Sie sich frei, uns zu <a>kontaktieren</a>, wenn Sie Unterst\xfctzung ben\xf6tigen.",
    machine_to_machine_roles_other: "{{count, number}} Maschine-zu-Maschine-Rollen des Limits von <planName/> erreicht. Upgraden Sie Ihren Plan, um zus\xe4tzliche Rollen und Berechtigungen hinzuzuf\xfcgen. F\xfchlen Sie sich frei, uns zu <a>kontaktieren</a>, wenn Sie Unterst\xfctzung ben\xf6tigen.",
    scopes_per_role: "Sie haben das Limit von {{count, number}} Berechtigungen pro Rolle von <planName/> erreicht. Upgraden Sie Ihren Plan, um zus\xe4tzliche Rollen und Berechtigungen hinzuzuf\xfcgen. Bei Fragen stehen wir Ihnen gerne zur Verf\xfcgung. <a>Kontaktieren Sie uns</a>, wenn Sie Hilfe ben\xf6tigen.",
    scopes_per_role_other: "Sie haben das Limit von {{count, number}} Berechtigungen pro Rolle von <planName/> erreicht. Upgraden Sie Ihren Plan, um zus\xe4tzliche Rollen und Berechtigungen hinzuzuf\xfcgen. Bei Fragen stehen wir Ihnen gerne zur Verf\xfcgung. <a>Kontaktieren Sie uns</a>, wenn Sie Hilfe ben\xf6tigen.",
    hooks: "Sie haben das Limit von {{count, number}} <planName/>-Webhooks erreicht. Upgraden Sie Ihren Plan, um mehr Webhooks zu erstellen. Z\xf6gern Sie nicht, <a>Kontaktieren Sie uns</a>, wenn Sie Hilfe ben\xf6tigen.",
    hooks_other: "Sie haben das Limit von {{count, number}} <planName/>-Webhooks erreicht. Upgraden Sie Ihren Plan, um mehr Webhooks zu erstellen. Z\xf6gern Sie nicht, <a>Kontaktieren Sie uns</a>, wenn Sie Hilfe ben\xf6tigen.",
    mfa: "Schalten Sie MFA zur Sicherheits\xfcberpr\xfcfung frei, indem Sie auf einen kostenpflichtigen Plan aktualisieren. Z\xf6gern Sie nicht, uns zu <a>kontaktieren</a>, wenn Sie Unterst\xfctzung ben\xf6tigen.",
    organizations: "Organisationen freischalten, indem Sie auf einen kostenpflichtigen Plan aktualisieren. Z\xf6gern Sie nicht, <a>kontaktieren Sie uns</a>, wenn Sie Unterst\xfctzung ben\xf6tigen.",
    third_party_apps: "Entsperren Sie Logto als IdP f\xfcr Drittanbieter-Apps, indem Sie auf einen kostenpflichtigen Plan aktualisieren. Bei Bedarf k\xf6nnen Sie uns gerne <a>kontaktieren</a>.",
    sso_connectors: "Schalten Sie Enterprise-SSO frei, indem Sie auf einen kostenpflichtigen Plan aktualisieren. Bei Bedarf k\xf6nnen Sie uns gerne <a>kontaktieren</a>.",
    tenant_members: "Aktivieren Sie die Kollaborationsfunktion durch ein Upgrade auf einen kostenpflichtigen Plan. Bei Bedarf k\xf6nnen Sie uns gerne <a>kontaktieren</a>.",
    tenant_members_dev_plan: "Sie haben Ihr Limit von {{limit}} Mitgliedern erreicht. Geben Sie ein Mitglied frei oder widerrufen Sie eine ausstehende Einladung, um jemand neuen hinzuzuf\xfcgen. Ben\xf6tigen Sie mehr Pl\xe4tze? Z\xf6gern Sie nicht, uns zu kontaktieren.",
    custom_jwt: {
        title: "Benutzerdefinierte Claims hinzuf\xfcgen",
        description: "Upgrade auf einen kostenpflichtigen Plan f\xfcr benutzerdefinierte JWT-Funktionalit\xe4t und Premium-Vorteile. Wenn Sie Fragen haben, z\xf6gern Sie nicht, uns zu <a>kontaktieren</a>."
    }
};
var $57913a7bb8e2c0c1$export$2e2bcd8739ae039 = Object.freeze($57913a7bb8e2c0c1$var$paywall);


const $1ec631aad24f4abb$var$upsell = {
    upgrade_plan: "Upgrade-Plan",
    compare_plans: "Pl\xe4ne vergleichen",
    view_plans: "Pl\xe4ne anzeigen",
    create_tenant: {
        title: "W\xe4hlen Sie Ihren Tenant-Plan aus",
        description: "Logto bietet wettbewerbsf\xe4hige Planoptionen mit innovativer und erschwinglicher Preisgestaltung, die f\xfcr wachsende Unternehmen entwickelt wurden. <a>Erfahren Sie mehr</a>",
        base_price: "Grundpreis",
        monthly_price: "{{value, number}}/Monat",
        view_all_features: "Alle Funktionen anzeigen",
        select_plan: "<name/> ausw\xe4hlen",
        free_tenants_limit: "Bis zu {{count, number}} kostenlose Tenant",
        free_tenants_limit_other: "Bis zu {{count, number}} kostenlose Tenants",
        most_popular: "Am beliebtesten",
        upgrade_success: "Erfolgreich auf <name/> upgegradet"
    },
    mau_exceeded_modal: {
        title: "MAU-Limit \xfcberschritten. Upgraden Sie Ihren Plan.",
        notification: "Ihr aktueller MAU hat das Limit von <planName/> \xfcberschritten. Bitte upgraden Sie umgehend auf den Premium-Plan, um die Aussetzung des Logto-Dienstes zu vermeiden.",
        update_plan: "Plan aktualisieren"
    },
    payment_overdue_modal: {
        title: "Zahlungsr\xfcckstand f\xfcr Rechnung",
        notification: "Hoppla! Die Zahlung f\xfcr die Rechnung des Mieters <span>{{name}}</span> ist fehlgeschlagen. Bitte zahlen Sie die Rechnung umgehend, um eine Sperrung des Logto-Dienstes zu vermeiden.",
        unpaid_bills: "Ausstehende Rechnungen",
        update_payment: "Zahlung aktualisieren"
    },
    add_on_quota_item: {
        api_resource: "API-Ressource",
        machine_to_machine: "Machine-to-Machine-Anwendung",
        tokens: "{{limit}}M Token",
        tenant_member: "Mietermitglied"
    },
    charge_notification_for_quota_limit: "Sie haben Ihr {{item}}-Quotenlimit \xfcberschritten. Logto wird Geb\xfchren f\xfcr die Nutzung \xfcber Ihr Quotenlimit hinaus hinzuf\xfcgen. Die Abrechnung beginnt am Tag der Ver\xf6ffentlichung des neuen Add-On-Preisdesigns. <a>Mehr erfahren</a>",
    paywall: $57913a7bb8e2c0c1$export$2e2bcd8739ae039,
    featured_plan_content: $5c433254851d34f6$export$2e2bcd8739ae039
};
var $1ec631aad24f4abb$export$2e2bcd8739ae039 = Object.freeze($1ec631aad24f4abb$var$upsell);


const $d3e0c92deeea6849$var$user_details = {
    page_title: "Benutzerdetails",
    back_to_users: "Zur\xfcck zur Benutzerverwaltung",
    created_title: "Der Benutzer wurde erfolgreich erstellt",
    created_guide: "Hier sind die Informationen, um dem Benutzer bei der Anmeldung zu helfen.",
    created_email: "E-Mail-Adresse:",
    created_phone: "Telefonnummer:",
    created_username: "Benutzername:",
    created_password: "Passwort:",
    menu_delete: "L\xf6schen",
    delete_description: "Diese Aktion kann nicht r\xfcckg\xe4ngig gemacht werden. Der Benutzer wird permanent gel\xf6scht.",
    deleted: "Der Benutzer wurde erfolgreich gel\xf6scht",
    reset_password: {
        reset_password: "Passwort zur\xfccksetzen",
        title: "Willst du das Passwort wirklich zur\xfccksetzen?",
        content: "Diese Aktion kann nicht r\xfcckg\xe4ngig gemacht werden. Das Anmeldeinformationen werden zur\xfcckgesetzt.",
        congratulations: "Der Benutzer wurde erfolgreich zur\xfcckgesetzt",
        new_password: "Neues Passwort:"
    },
    tab_settings: "Einstellungen",
    tab_roles: "Rollen",
    tab_logs: "Benutzer-Logs",
    tab_organizations: "Organisationen",
    authentication: "Authentifizierung",
    authentication_description: "Jeder Benutzer hat ein Profil mit allen Benutzerinformationen. Es besteht aus Basisdaten, sozialen Identit\xe4ten und benutzerdefinierten Daten.",
    user_profile: "Benutzerprofil",
    field_email: "E-Mail-Adresse",
    field_phone: "Telefonnummer",
    field_username: "Benutzername",
    field_name: "Name",
    field_avatar: "Profilbild URL",
    field_avatar_placeholder: "https://dein.cdn.domain/profilbild.png",
    field_custom_data: "Benutzerdefinierte Daten",
    field_custom_data_tip: "Zus\xe4tzliche Benutzerinformationen, die nicht in den vordefinierten Benutzereigenschaften aufgef\xfchrt sind, wie z. B. die vom Benutzer bevorzugte Farbe und Sprache.",
    field_connectors: "Soziale Verbindungen",
    field_sso_connectors: "Unternehmensverbindungen",
    custom_data_invalid: "Benutzerdefinierte Daten m\xfcssen ein g\xfcltiges JSON-Objekt sein.",
    connectors: {
        connectors: "Verbindungen",
        user_id: "Benutzer ID",
        remove: "L\xf6schen",
        connected: "Dieser Benutzer ist mit mehreren sozialen Verbindern verbunden.",
        not_connected: "Der Benutzer ist nicht mit einem sozialen Verbindungsger\xe4t verbunden",
        deletion_confirmation: "Sie entfernen die bestehende Identit\xe4t <name/>. M\xf6chten Sie den Vorgang wirklich fortsetzen?"
    },
    sso_connectors: {
        connectors: "Verbindungen",
        enterprise_id: "Unternehmens-ID",
        connected: "Dieser Benutzer ist mit mehreren Enterprise-Identit\xe4tsanbietern f\xfcr Single Sign-On verbunden.",
        not_connected: "Der Benutzer ist nicht mit einem Unternehmensidentit\xe4tsanbieter f\xfcr Single Sign-On verbunden."
    },
    mfa: {
        field_name: "Zwei-Faktor-Authentifizierung",
        field_description: "Dieser Benutzer hat 2-Stufen-Authentifizierungsfaktoren aktiviert.",
        name_column: "Zwei-Faktor",
        field_description_empty: "Dieser Benutzer hat keine zweistufigen Authentifizierungsfaktoren aktiviert.",
        deletion_confirmation: "Sie entfernen die bestehende <name/> f\xfcr die Zwei-Faktor-Authentifizierung. Sind Sie sicher, dass Sie fortfahren m\xf6chten?"
    },
    suspended: "Gesperrt",
    suspend_user: "Benutzer sperren",
    suspend_user_reminder: "Sind Sie sicher, dass Sie diesen Benutzer sperren m\xf6chten? Der Benutzer kann sich nicht bei Ihrer App anmelden und kann nach Ablauf des aktuellen Tokens kein neues Zugriffstoken mehr erhalten. Au\xdferdem schlagen alle API-Anforderungen von diesem Benutzer fehl.",
    suspend_action: "Sperren",
    user_suspended: "Benutzer wurde gesperrt.",
    reactivate_user: "Benutzer entsperren",
    reactivate_user_reminder: "Sind Sie sicher, dass Sie diesen Benutzer wieder aktivieren m\xf6chten? Dadurch werden alle Anmeldeversuche f\xfcr diesen Benutzer erm\xf6glicht.",
    reactivate_action: "Aktivieren",
    user_reactivated: "Benutzer wurde aktiviert.",
    roles: {
        name_column: "Rolle",
        description_column: "Beschreibung",
        assign_button: "Rollen zuweisen",
        delete_description: "Diese Aktion entfernt diese Rolle von diesem Benutzer. Die Rolle selbst bleibt erhalten, aber sie wird nicht mehr mit diesem Benutzer verkn\xfcpft sein.",
        deleted: "{{name}} wurde erfolgreich von diesem Benutzer entfernt.",
        assign_title: "Rollen an {{name}} zuweisen",
        assign_subtitle: "{{name}} eine oder mehrere Rollen zuweisen",
        assign_role_field: "Rollen zuweisen",
        role_search_placeholder: "Nach Rollennamen suchen",
        added_text: "{{value, number}} hinzugef\xfcgt",
        assigned_user_count: "{{value, number}} Benutzer",
        confirm_assign: "Rollen zuweisen",
        role_assigned: "Rolle(n) erfolgreich zugewiesen",
        search: "Nach Rollennamen, Beschreibung oder ID suchen",
        empty: "Keine Rolle verf\xfcgbar"
    },
    warning_no_sign_in_identifier: "Der Benutzer muss mindestens einen der Anmelde-Identifikatoren (Benutzername, E-Mail, Telefonnummer oder soziales Konto) haben, um sich anzumelden. Sind Sie sicher, dass Sie fortfahren m\xf6chten?",
    organization_roles_tooltip: "Die dem Benutzer innerhalb dieser Organisation zugewiesenen Rollen."
};
var $d3e0c92deeea6849$export$2e2bcd8739ae039 = Object.freeze($d3e0c92deeea6849$var$user_details);


const $a26d869015a1a0f6$var$users = {
    page_title: "Benutzerverwaltung",
    title: "Benutzerverwaltung",
    subtitle: "Verwalten von Benutzeridentit\xe4ten, einschlie\xdflich des Anlegens von Benutzern, Bearbeiten von Benutzerinformationen, Anzeigen von Benutzer-Logs, Zur\xfccksetzen von Passw\xf6rtern und L\xf6schen von Benutzern",
    create: "Benutzer hinzuf\xfcgen",
    create_subtitle: "Um fortzufahren, geben Sie bitte mindestens eines der folgenden Felder an.",
    error_missing_identifier: "Sie m\xfcssen mindestens einen Identifikator eingeben, um einen Benutzer anzulegen",
    user_name: "Benutzername",
    application_name: "Anwendungsname",
    latest_sign_in: "Letzte Anmeldung",
    create_form_username: "Benutzername",
    create_form_password: "Passwort",
    create_form_name: "Name",
    placeholder_name: "Max Mustermann",
    placeholder_email: "max@example.com",
    placeholder_username: "user123",
    placeholder_phone: "+49 (0)123 456789",
    unnamed: "Unbenannt",
    search: "Suche nach Name, E-Mail, Telefon oder Benutzername",
    check_user_detail: "Benutzerdetails \xfcberpr\xfcfen",
    placeholder_title: "Benutzerverwaltung",
    placeholder_description: "Jeder Benutzer hat ein Profil mit allen Benutzerinformationen. Es besteht aus grundlegenden Daten, sozialen Identit\xe4ten und benutzerdefinierten Daten."
};
var $a26d869015a1a0f6$export$2e2bcd8739ae039 = Object.freeze($a26d869015a1a0f6$var$users);


const $6f441e3124b7403c$var$webhook_details = {
    page_title: "Webhook-Details",
    back_to_webhooks: "Zur\xfcck zu Webhooks",
    not_in_use: "Nicht in Nutzung",
    success_rate: "Erfolgsrate",
    requests: "{{value, number}} Requests in 24 Stunden",
    disable_webhook: "Webhook deaktivieren",
    disable_reminder: "Sind Sie sicher, dass Sie diesen Webhook reaktivieren m\xf6chten? Wenn Sie das tun, wird keine HTTP-Anforderung an die Endpunkt-URL gesendet.",
    webhook_disabled: "Der Webhook wurde deaktiviert.",
    webhook_reactivated: "Der Webhook wurde reaktiviert.",
    reactivate_webhook: "Webhook reaktivieren",
    delete_webhook: "Webhook l\xf6schen",
    deletion_reminder: "Sie entfernen diesen Webhook. Nach dem L\xf6schen wird keine HTTP-Anforderung an die Endpunkt-URL gesendet.",
    deleted: "Der Webhook wurde erfolgreich gel\xf6scht.",
    settings_tab: "Einstellungen",
    recent_requests_tab: "Letzte Anforderungen (24h)",
    settings: {
        settings: "Einstellungen",
        settings_description: "Webhooks erm\xf6glichen es Ihnen, Echtzeit-Updates zu bestimmten Ereignissen zu erhalten, indem sie eine POST-Anforderung an Ihre Endpunkt-URL senden. Dies erm\xf6glicht es Ihnen, sofortige Ma\xdfnahmen aufgrund der neuen Informationen zu ergreifen, die Sie erhalten.",
        events: "Ereignisse",
        events_description: "W\xe4hlen Sie die Ausl\xf6serereignisse aus, die Logto die POST-Anforderung senden wird.",
        name: "Name",
        endpoint_url: "Endpunkt-URL",
        signing_key: "Signing Key",
        signing_key_tip: "F\xfcgen Sie den von Logto bereitgestellten geheimen Schl\xfcssel als Anforderungsheader zu Ihrem Endpunkt hinzu, um die Echtheit der Nutzlast des Webhooks sicherzustellen.",
        regenerate: "Neu generieren",
        regenerate_key_title: "Signing Key neu generieren",
        regenerate_key_reminder: "Sind Sie sicher, dass Sie den Signing Key \xe4ndern m\xf6chten? Die Regeneration wird sofort wirksam. Bitte denken Sie daran, den Signing Key synchron in Ihrem Endpunkt zu \xe4ndern.",
        regenerated: "Der Signing Key wurde neu generiert.",
        custom_headers: "Benutzerdefinierte Header",
        custom_headers_tip: "Sie k\xf6nnen optional benutzerdefinierte Header zur Nutzlast des Webhooks hinzuf\xfcgen, um zus\xe4tzlichen Kontext oder Metadaten zum Ereignis bereitzustellen.",
        key_duplicated_error: "Schl\xfcssel k\xf6nnen nicht wiederholt werden.",
        key_missing_error: "Key ist erforderlich.",
        value_missing_error: "Eine Eingabe ist erforderlich.",
        invalid_key_error: "Schl\xfcssel ist ung\xfcltig",
        invalid_value_error: "Wert ist ung\xfcltig",
        test: "Test",
        test_webhook: "Testen Sie Ihren Webhook",
        test_webhook_description: "Konfigurieren Sie den Webhook und testen Sie ihn mit Beispieldaten f\xfcr jede ausgew\xe4hlte Ereigniskategorie, um eine korrekte Empfangs- und Verarbeitungsfunktion zu \xfcberpr\xfcfen.",
        send_test_payload: "Testnutzlast senden",
        test_result: {
            endpoint_url: "Endpunkt-URL: {{url}}",
            message: "Nachricht: {{message}}",
            response_status: "Antwortstatus: {{status, number}}",
            response_body: "Antwortk\xf6rper: {{body}}",
            request_time: "Anforderungszeit: {{time}}",
            test_success: "Der Webhook-Test zum Endpunkt war erfolgreich."
        }
    }
};
var $6f441e3124b7403c$export$2e2bcd8739ae039 = Object.freeze($6f441e3124b7403c$var$webhook_details);


const $a3efd443576ec5c9$var$webhooks = {
    page_title: "Webhooks",
    title: "Webhooks",
    subtitle: "Erstellen Sie Webhooks, um m\xfchelos Echtzeit-Updates zu bestimmten Ereignissen zu empfangen.",
    create: "Webhook erstellen",
    schemas: {
        interaction: "Nutzerinteraktion",
        user: "Benutzer",
        organization: "Organisation",
        role: "Rolle",
        scope: "Berechtigung",
        organization_role: "Organisationsrolle",
        organization_scope: "Organisationsberechtigung"
    },
    table: {
        name: "Name",
        events: "Ereignisse",
        success_rate: "Erfolgsrate (24h)",
        requests: "Anfragen (24h)"
    },
    placeholder: {
        title: "Webhook",
        description: 'Erstellen Sie einen Webhook, um Echtzeit-Updates \xfcber POST-Anfragen an Ihre Endpunkt-URL zu empfangen. Bleiben Sie \xfcber Ereignisse wie "Account erstellen", "Anmelden" und "Passwort zur\xfccksetzen" informiert und ergreifen Sie sofort Ma\xdfnahmen.',
        create_webhook: "Webhook erstellen"
    },
    create_form: {
        title: "Webhook erstellen",
        subtitle: "F\xfcgen Sie den Webhook hinzu, um eine POST-Anfrage an die Endpunkt-URL mit Details zu Ereignissen der Benutzer zu senden.",
        events: "Ereignisse",
        events_description: "W\xe4hlen Sie die Trigger-Ereignisse aus, bei welchen Logto die POST-Anfrage senden soll.",
        name: "Name",
        name_placeholder: "Webhook-Namen eingeben",
        endpoint_url: "Endpunkt-URL",
        endpoint_url_placeholder: "https://Ihre.webhook.endpunkt.url",
        endpoint_url_tip: "Geben Sie die URL Ihres Endpunkts ein, an die ein Payload Ihres Webooks gesendet wird, wenn das Ereignis eintritt.",
        create_webhook: "Webhook erstellen",
        missing_event_error: "Sie m\xfcssen mindestens ein Ereignis ausw\xe4hlen."
    },
    webhook_created: "Der Webhook {{name}} wurde erfolgreich erstellt."
};
var $a3efd443576ec5c9$export$2e2bcd8739ae039 = Object.freeze($a3efd443576ec5c9$var$webhooks);


const $fa700c98ed3d9ce7$var$welcome = {
    title: "Willkommen in der Admin Konsole",
    description: "Die Admin-Konsole ist eine Web-App, mit der du Logto verwalten kannst, ohne programmieren zu m\xfcssen. Legen wir zun\xe4chst ein Konto an. Mit diesem Konto kannst du Logto selbst oder im Namen deines Unternehmens verwalten.",
    create_account: "Konto erstellen"
};
var $fa700c98ed3d9ce7$export$2e2bcd8739ae039 = Object.freeze($fa700c98ed3d9ce7$var$welcome);


const $cadd23334a3830cd$var$admin_console = {
    title: "Admin Konsole",
    admin_user: "Admin",
    system_app: "System",
    menu: $4f5f277396ff1226$export$2e2bcd8739ae039,
    general: $fc6d6c80e93897fc$export$2e2bcd8739ae039,
    errors: $d33b22806c9d18d3$export$2e2bcd8739ae039,
    tab_sections: $167a373bd21a5cd2$export$2e2bcd8739ae039,
    tabs: $3efc6a4aa896c174$export$2e2bcd8739ae039,
    applications: $b9432b8df024f971$export$2e2bcd8739ae039,
    application_details: $e73bdc20da610623$export$2e2bcd8739ae039,
    api_resources: $eea4707bd538c192$export$2e2bcd8739ae039,
    api_resource_details: $a8bf986696df22b5$export$2e2bcd8739ae039,
    connectors: $3e2829a0ef0ccc0b$export$2e2bcd8739ae039,
    connector_details: $fd75e8bd3fe27fe3$export$2e2bcd8739ae039,
    enterprise_sso: $b4f4140d1c2653ed$export$2e2bcd8739ae039,
    enterprise_sso_details: $91b71acaf24a6bf6$export$2e2bcd8739ae039,
    get_started: $919d3c45ba21a9dc$export$2e2bcd8739ae039,
    users: $a26d869015a1a0f6$export$2e2bcd8739ae039,
    user_details: $d3e0c92deeea6849$export$2e2bcd8739ae039,
    contact: $b8702cea4edd3b2b$export$2e2bcd8739ae039,
    sign_in_exp: $f0df82fa720b782c$export$2e2bcd8739ae039,
    dashboard: $5d26f0008cf429e1$export$2e2bcd8739ae039,
    logs: $c827eaa2859ce794$export$2e2bcd8739ae039,
    log_details: $2b2a8b96e06e14e9$export$2e2bcd8739ae039,
    session_expired: $88dee028fe0936fe$export$2e2bcd8739ae039,
    welcome: $fa700c98ed3d9ce7$export$2e2bcd8739ae039,
    roles: $2db58f4182465a68$export$2e2bcd8739ae039,
    role_details: $1ce3d76963f48b3f$export$2e2bcd8739ae039,
    permissions: $046f66640a010aa0$export$2e2bcd8739ae039,
    cloud: $25e641c882c0488c$export$2e2bcd8739ae039,
    profile: $9a06370431b66da8$export$2e2bcd8739ae039,
    components: $6d8f94fbd1aa4f19$export$2e2bcd8739ae039,
    webhooks: $a3efd443576ec5c9$export$2e2bcd8739ae039,
    webhook_details: $6f441e3124b7403c$export$2e2bcd8739ae039,
    domain: $8887b1cda850cab9$export$2e2bcd8739ae039,
    tenants: $9cd5834731377e10$export$2e2bcd8739ae039,
    tenant_members: $37568a411437176d$export$2e2bcd8739ae039,
    topbar: $cd708012e582faab$export$2e2bcd8739ae039,
    subscription: $f5b309f056a7de1e$export$2e2bcd8739ae039,
    upsell: $1ec631aad24f4abb$export$2e2bcd8739ae039,
    guide: $cf025ba47280454a$export$2e2bcd8739ae039,
    mfa: $edf32b61ff5e4ebb$export$2e2bcd8739ae039,
    organizations: $05f9389f0767a3da$export$2e2bcd8739ae039,
    organization_details: $bfbd8be895c492c8$export$2e2bcd8739ae039,
    protected_app: $7ce2bc49fb6af1be$export$2e2bcd8739ae039,
    jwt_claims: $459973ea43bdff7c$export$2e2bcd8739ae039,
    invitation: $b1f5188d6d8ec86c$export$2e2bcd8739ae039,
    signing_keys: $f3a05fb84c1694a6$export$2e2bcd8739ae039,
    organization_template: $ed0deb3777242617$export$2e2bcd8739ae039,
    organization_role_details: $c207008aed6da57a$export$2e2bcd8739ae039
};
var $cadd23334a3830cd$export$2e2bcd8739ae039 = Object.freeze($cadd23334a3830cd$var$admin_console);


const $c967b9a8877efa64$var$demo_app = {
    title: "Sie haben sich erfolgreich bei der Live-Vorschau angemeldet!",
    subtitle: "Hier sind Ihre Anmeldeinformationen:",
    username: "Benutzername: ",
    user_id: "Benutzer ID: ",
    sign_out: "Abmeldung von der Live-Vorschau",
    continue_explore: "Oder weiter zum Entdecken",
    customize_sign_in_experience: "Anmeldeoberfl\xe4che anpassen",
    enable_passwordless: "Passwordless einschalten",
    add_social_connector: "Social Connector hinzuf\xfcgen"
};
var $c967b9a8877efa64$export$2e2bcd8739ae039 = Object.freeze($c967b9a8877efa64$var$demo_app);


const $1ab5190484f4c4be$var$oidc = {
    logout_success: "Sie haben sich erfolgreich abgemeldet."
};
var $1ab5190484f4c4be$export$2e2bcd8739ae039 = Object.freeze($1ab5190484f4c4be$var$oidc);


const $29e20f05d4eb8e5a$var$translation = {
    admin_console: $cadd23334a3830cd$export$2e2bcd8739ae039,
    demo_app: $c967b9a8877efa64$export$2e2bcd8739ae039,
    oidc: $1ab5190484f4c4be$export$2e2bcd8739ae039
};
var $29e20f05d4eb8e5a$export$2e2bcd8739ae039 = Object.freeze($29e20f05d4eb8e5a$var$translation);


const $83a5879ce529224a$var$de = {
    translation: $29e20f05d4eb8e5a$export$2e2bcd8739ae039,
    errors: $c4f26808119fd9b9$export$2e2bcd8739ae039
};
var $83a5879ce529224a$export$2e2bcd8739ae039 = Object.freeze($83a5879ce529224a$var$de);


const $f5fec0f8267a60ac$var$application = {
    invalid_type: "Only machine to machine applications can have associated roles.",
    role_exists: "The role id {{roleId}} is already been added to this application.",
    invalid_role_type: "Can not assign user type role to machine to machine application.",
    invalid_third_party_application_type: "Only traditional web applications can be marked as a third-party app.",
    third_party_application_only: "The feature is only available for third-party applications.",
    user_consent_scopes_not_found: "Invalid user consent scopes.",
    consent_management_api_scopes_not_allowed: "Management API scopes are not allowed.",
    protected_app_metadata_is_required: "Protected app metadata is required.",
    protected_app_not_configured: "Protected app provider is not configured. This feature is not available for open source version.",
    cloudflare_unknown_error: "Got unknown error when requesting Cloudflare API",
    protected_application_only: "The feature is only available for protected applications.",
    protected_application_misconfigured: "Protected application is misconfigured.",
    protected_application_subdomain_exists: "The subdomain of Protected application is already in use.",
    invalid_subdomain: "Invalid subdomain.",
    custom_domain_not_found: "Custom domain not found.",
    should_delete_custom_domains_first: "Should delete custom domains first."
};
var $f5fec0f8267a60ac$export$2e2bcd8739ae039 = Object.freeze($f5fec0f8267a60ac$var$application);


const $06a6dba40a4dd9b5$var$auth = {
    authorization_header_missing: "Authorization header is missing.",
    authorization_token_type_not_supported: "Authorization type is not supported.",
    unauthorized: "Unauthorized. Please check credentials and its scope.",
    forbidden: "Forbidden. Please check your user roles and permissions.",
    expected_role_not_found: "Expected role not found. Please check your user roles and permissions.",
    jwt_sub_missing: "Missing `sub` in JWT.",
    require_re_authentication: "Re-authentication is required to perform a protected action."
};
var $06a6dba40a4dd9b5$export$2e2bcd8739ae039 = Object.freeze($06a6dba40a4dd9b5$var$auth);


const $784182933aa61c9f$var$connector = {
    general: "Error occurred in connector: {{errorDescription}}",
    not_found: "Cannot find any available connector for type: {{type}}.",
    not_enabled: "The connector is not enabled.",
    invalid_metadata: "The connector's metadata is invalid.",
    invalid_config_guard: "The connector's config guard is invalid.",
    unexpected_type: "The connector's type is unexpected.",
    invalid_request_parameters: "The request is with wrong input parameter(s).",
    insufficient_request_parameters: "The request might miss some input parameters.",
    invalid_config: "The connector's config is invalid.",
    invalid_certificate: "The connector's certificate is invalid, please make sure the certificate is in PEM encoding.",
    invalid_response: "The connector's response is invalid.",
    template_not_found: "Unable to find correct template in connector config.",
    template_not_supported: "The connector does not support this template type.",
    rate_limit_exceeded: "Trigger rate limit. Please try again later.",
    not_implemented: "{{method}}: has not been implemented yet.",
    social_invalid_access_token: "The connector's access token is invalid.",
    invalid_auth_code: "The connector's auth code is invalid.",
    social_invalid_id_token: "The connector's id token is invalid.",
    authorization_failed: "The user's authorization process is unsuccessful.",
    social_auth_code_invalid: "Unable to get access token, please check authorization code.",
    more_than_one_sms: "The number of SMS connectors is larger then 1.",
    more_than_one_email: "The number of Email connectors is larger then 1.",
    more_than_one_connector_factory: "Found multiple connector factories (with id {{connectorIds}}), you may uninstall unnecessary ones.",
    db_connector_type_mismatch: "There is a connector in the DB that does not match the type.",
    not_found_with_connector_id: "Can not find connector with given standard connector id.",
    multiple_instances_not_supported: "Can not create multiple instance with picked standard connector.",
    invalid_type_for_syncing_profile: "You can only sync user profile with social connectors.",
    can_not_modify_target: "The connector 'target' can not be modified.",
    should_specify_target: "You should specify 'target'.",
    multiple_target_with_same_platform: "You can not have multiple social connectors that have same target and platform.",
    cannot_overwrite_metadata_for_non_standard_connector: "This connector's 'metadata' cannot be overwritten."
};
var $784182933aa61c9f$export$2e2bcd8739ae039 = Object.freeze($784182933aa61c9f$var$connector);


const $11081f9c8705eb8c$var$domain = {
    not_configured: "Domain hostname provider is not configured.",
    cloudflare_data_missing: "cloudflare_data is missing, please check.",
    cloudflare_unknown_error: "Got unknown error when requesting Cloudflare API",
    cloudflare_response_error: "Got unexpected response from Cloudflare.",
    limit_to_one_domain: "You can only have one custom domain.",
    hostname_already_exists: "This domain already exists in our server.",
    cloudflare_not_found: "Can not find hostname in Cloudflare",
    domain_is_not_allowed: "This domain is not allowed."
};
var $11081f9c8705eb8c$export$2e2bcd8739ae039 = Object.freeze($11081f9c8705eb8c$var$domain);


const $b6d82ca61d3e88e1$var$entity = {
    invalid_input: "Invalid input. Value list must not be empty.",
    create_failed: "Failed to create {{name}}.",
    db_constraint_violated: "Database constraint violated.",
    not_exists: "The {{name}} does not exist.",
    not_exists_with_id: "The {{name}} with ID `{{id}}` does not exist.",
    not_found: "The resource does not exist.",
    relation_foreign_key_not_found: "Cannot find one or more foreign keys. Please check the input and ensure that all referenced entities exist.",
    unique_integrity_violation: "The entity already exists. Please check the input and try again."
};
var $b6d82ca61d3e88e1$export$2e2bcd8739ae039 = Object.freeze($b6d82ca61d3e88e1$var$entity);


const $05743d0fcdba1b2f$var$guard = {
    invalid_input: "The request {{type}} is invalid.",
    invalid_pagination: "The request pagination value is invalid.",
    can_not_get_tenant_id: "Unable to get tenant id from request.",
    file_size_exceeded: "File size exceeded.",
    mime_type_not_allowed: "MIME type is not allowed."
};
var $05743d0fcdba1b2f$export$2e2bcd8739ae039 = Object.freeze($05743d0fcdba1b2f$var$guard);


const $54bc4fa39eb7b9bd$var$hook = {
    missing_events: "You need to provide at least one event.",
    send_test_payload_failed: "Failed to send test payload: {{message}}",
    endpoint_responded_with_error: "Endpoint responded with error."
};
var $54bc4fa39eb7b9bd$export$2e2bcd8739ae039 = Object.freeze($54bc4fa39eb7b9bd$var$hook);


const $496728e57dd7d0e8$var$jwt_customizer = {
    general: "An error occurred while customizing the JWT token. Please try again later.",
    can_not_create_for_admin_tenant: "Cannot create a JWT token customizer for the admin tenant."
};
var $496728e57dd7d0e8$export$2e2bcd8739ae039 = Object.freeze($496728e57dd7d0e8$var$jwt_customizer);


const $d55024d6363f69cd$var$localization = {
    cannot_delete_default_language: "{{languageTag}} is set as your default language and can’t be deleted.",
    invalid_translation_structure: "Invalid data schemas. Please check your input and try again."
};
var $d55024d6363f69cd$export$2e2bcd8739ae039 = Object.freeze($d55024d6363f69cd$var$localization);


const $c81a1f3a00d60a74$var$log = {
    invalid_type: "The log type is invalid."
};
var $c81a1f3a00d60a74$export$2e2bcd8739ae039 = Object.freeze($c81a1f3a00d60a74$var$log);


const $422cddcd2e76a18a$var$oidc = {
    aborted: "The end-user aborted interaction.",
    invalid_scope: "Invalid scope: {{error_description}}.",
    invalid_token: "Invalid token provided.",
    invalid_client_metadata: "Invalid client metadata provided.",
    insufficient_scope: "Token missing scope `{{scope}}`.",
    invalid_request: "Request is invalid.",
    invalid_grant: "Grant request is invalid.",
    invalid_redirect_uri: "`redirect_uri` did not match any of the client's registered `redirect_uris`.",
    access_denied: "Access denied.",
    invalid_target: "Invalid resource indicator.",
    unsupported_grant_type: "Unsupported `grant_type` requested.",
    unsupported_response_mode: "Unsupported `response_mode` requested.",
    unsupported_response_type: "Unsupported `response_type` requested.",
    /** @deprecated Use {@link oidc.server_error} or {@link oidc.provider_error_fallback} instead. */ provider_error: "OIDC Internal Error: {{message}}.",
    server_error: "An unknown OIDC error occurred. Please try again later.",
    provider_error_fallback: "An OIDC error occurred: {{code}}.",
    key_required: "At least one key is required.",
    key_not_found: "Key with ID {{id}} is not found."
};
var $422cddcd2e76a18a$export$2e2bcd8739ae039 = Object.freeze($422cddcd2e76a18a$var$oidc);


const $0001e13b787d7282$var$organizations = {
    require_membership: "The user must be a member of the organization to proceed."
};
var $0001e13b787d7282$export$2e2bcd8739ae039 = Object.freeze($0001e13b787d7282$var$organizations);


const $5614808dc7b9aac2$var$password = {
    unsupported_encryption_method: "The encryption method {{name}} is not supported.",
    pepper_not_found: "Password pepper not found. Please check your core envs.",
    rejected: "Password rejected. Please check if your password meets the requirements."
};
var $5614808dc7b9aac2$export$2e2bcd8739ae039 = Object.freeze($5614808dc7b9aac2$var$password);


const $5aab8b44bd134033$var$request = {
    invalid_input: "Input is invalid. {{details}}",
    general: "Request error occurred."
};
var $5aab8b44bd134033$export$2e2bcd8739ae039 = Object.freeze($5aab8b44bd134033$var$request);


const $b68c4846ea6a9a89$var$resource = {
    resource_identifier_in_use: "The API identifier {{indicator}} is already in use",
    cannot_delete_management_api: "Cannot delete Logto management API.",
    cannot_modify_management_api: "Cannot modify Logto management API."
};
var $b68c4846ea6a9a89$export$2e2bcd8739ae039 = Object.freeze($b68c4846ea6a9a89$var$resource);


const $480bc5607cacba30$var$role = {
    name_in_use: "This role name {{name}} is already in use",
    scope_exists: "The scope id {{scopeId}} has already been added to this role",
    management_api_scopes_not_assignable_to_user_role: "Cannot assign management API scopes to a user role.",
    user_exists: "The user id {{userId}} is already been added to this role",
    application_exists: "The application id {{applicationId}} is already been added to this role",
    default_role_missing: "Some of the default roleNames does not exist in database, please ensure to create roles first",
    internal_role_violation: 'You may be trying to update or delete an internal role which is forbidden by Logto. If you are creating a new role, try another name that does not start with "#internal:".'
};
var $480bc5607cacba30$export$2e2bcd8739ae039 = Object.freeze($480bc5607cacba30$var$role);


const $46bd9a04ab2d3ac7$var$scope = {
    name_exists: "The scope name {{name}} is already in use",
    name_with_space: "The name of the scope cannot contain any spaces."
};
var $46bd9a04ab2d3ac7$export$2e2bcd8739ae039 = Object.freeze($46bd9a04ab2d3ac7$var$scope);


const $db20ac17007c04a9$var$session = {
    not_found: "Session not found. Please go back and sign in again.",
    invalid_credentials: "Incorrect account or password. Please check your input.",
    invalid_sign_in_method: "Current sign-in method is not available.",
    invalid_connector_id: "Unable to find available connector with id {{connectorId}}.",
    insufficient_info: "Insufficient sign-in info.",
    connector_id_mismatch: "The connectorId is mismatched with session record.",
    connector_session_not_found: "Connector session not found. Please go back and sign in again.",
    verification_session_not_found: "The verification was not successful. Restart the verification flow and try again.",
    verification_expired: "The connection has timed out. Verify again to ensure your account safety.",
    verification_blocked_too_many_attempts: "Too many attempts in a short time. Please try again {{relativeTime}}.",
    unauthorized: "Please sign in first.",
    unsupported_prompt_name: "Unsupported prompt name.",
    forgot_password_not_enabled: "Forgot password is not enabled.",
    verification_failed: "The verification was not successful. Restart the verification flow and try again.",
    connector_validation_session_not_found: "The connector session for token validation is not found.",
    identifier_not_found: "User identifier not found. Please go back and sign in again.",
    interaction_not_found: "Interaction session not found. Please go back and start the session again.",
    not_supported_for_forgot_password: "This operation is not supported for forgot password.",
    mfa: {
        require_mfa_verification: "Mfa verification is required to sign in.",
        mfa_sign_in_only: "Mfa is only available for sign-in interaction.",
        pending_info_not_found: "Pending MFA info not found, please initiate MFA first.",
        invalid_totp_code: "Invalid TOTP code.",
        webauthn_verification_failed: "WebAuthn verification failed.",
        webauthn_verification_not_found: "WebAuthn verification not found.",
        bind_mfa_existed: "MFA already exists.",
        backup_code_can_not_be_alone: "Backup code can not be the only MFA.",
        backup_code_required: "Backup code is required.",
        invalid_backup_code: "Invalid backup code.",
        mfa_policy_not_user_controlled: "MFA policy is not user controlled."
    },
    sso_enabled: "Single sign on is enabled for this given email. Please sign in with SSO."
};
var $db20ac17007c04a9$export$2e2bcd8739ae039 = Object.freeze($db20ac17007c04a9$var$session);


const $6093cf112fdc39bf$var$sign_in_experiences = {
    empty_content_url_of_terms_of_use: 'Empty "Terms of use" content URL. Please add the content URL if "Terms of use" is enabled.',
    empty_social_connectors: "Empty social connectors. Please add enabled social connectors when the social sign-in method is enabled.",
    enabled_connector_not_found: "Enabled {{type}} connector not found.",
    not_one_and_only_one_primary_sign_in_method: "There must be one and only one primary sign-in method. Please check your input.",
    username_requires_password: "Must enable set a password for username sign up identifier.",
    passwordless_requires_verify: "Must enable verify for email/phone sign up identifier.",
    miss_sign_up_identifier_in_sign_in: "Sign in methods must contain the sign up identifier.",
    password_sign_in_must_be_enabled: "Password sign in must be enabled when set a password is required in sign up.",
    code_sign_in_must_be_enabled: "Verification code sign in must be enabled when set a password is not required in sign up.",
    unsupported_default_language: "This language - {{language}} is not supported at the moment.",
    at_least_one_authentication_factor: "You have to select at least one authentication factor.",
    backup_code_cannot_be_enabled_alone: "Backup code cannot be enabled alone.",
    duplicated_mfa_factors: "Duplicated MFA factors."
};
var $6093cf112fdc39bf$export$2e2bcd8739ae039 = Object.freeze($6093cf112fdc39bf$var$sign_in_experiences);


const $49e9aed2e00d31e2$var$single_sign_on = {
    forbidden_domains: "Public email domains are not allowed.",
    duplicated_domains: "There are duplicate domains.",
    invalid_domain_format: "Invalid domain format.",
    duplicate_connector_name: "Connector name already exists. Please choose a different name."
};
var $49e9aed2e00d31e2$export$2e2bcd8739ae039 = Object.freeze($49e9aed2e00d31e2$var$single_sign_on);


const $3a01ca7e5628b372$var$storage = {
    not_configured: "Storage provider is not configured.",
    missing_parameter: "Missing parameter {{parameter}} for storage provider.",
    upload_error: "Failed to upload file to the storage provider."
};
var $3a01ca7e5628b372$export$2e2bcd8739ae039 = Object.freeze($3a01ca7e5628b372$var$storage);


const $77cebc1daa1617cf$var$subscription = {
    limit_exceeded: "You have reached the limit of your subscription plan.",
    get_plan_failed: "Unable to get subscription plan for tenant.",
    tenant_suspended: "Tenant is suspended. Please contact your administrator."
};
var $77cebc1daa1617cf$export$2e2bcd8739ae039 = Object.freeze($77cebc1daa1617cf$var$subscription);


const $1f4d42f5d09be243$var$swagger = {
    invalid_zod_type: "Invalid Zod type. Please check route guard config.",
    not_supported_zod_type_for_params: "Not supported Zod type for the parameters. Please check route guard config."
};
var $1f4d42f5d09be243$export$2e2bcd8739ae039 = Object.freeze($1f4d42f5d09be243$var$swagger);


const $5512f8250bd261c5$var$user = {
    username_already_in_use: "This username is already in use.",
    email_already_in_use: "This email is associated with an existing account.",
    phone_already_in_use: "This phone number is associated with an existing account.",
    invalid_email: "Invalid email address.",
    invalid_phone: "Invalid phone number.",
    email_not_exist: "The email address has not been registered yet.",
    phone_not_exist: "The phone number has not been registered yet.",
    identity_not_exist: "The social account has not been registered yet.",
    identity_already_in_use: "The social account has been associated with an existing account.",
    social_account_exists_in_profile: "You have already associated this social account.",
    cannot_delete_self: "You cannot delete yourself.",
    sign_up_method_not_enabled: "This sign-up method is not enabled.",
    sign_in_method_not_enabled: "This sign-in method is not enabled.",
    same_password: "New password cannot be the same as your old password.",
    password_required_in_profile: "You need to set a password before signing-in.",
    new_password_required_in_profile: "You need to set a new password.",
    password_exists_in_profile: "Password already exists in your profile.",
    username_required_in_profile: "You need to set a username before signing-in.",
    username_exists_in_profile: "Username already exists in your profile.",
    email_required_in_profile: "You need to add an email address before signing-in.",
    email_exists_in_profile: "Your profile has already associated with an email address.",
    phone_required_in_profile: "You need to add a phone number before signing-in.",
    phone_exists_in_profile: "Your profile has already associated with a phone number.",
    email_or_phone_required_in_profile: "You need to add an email address or phone number before signing-in.",
    suspended: "This account is suspended.",
    user_not_exist: "User with {{ identifier }} does not exist.",
    missing_profile: "You need to provide additional info before signing-in.",
    role_exists: "The role id {{roleId}} is already been added to this user",
    invalid_role_type: "Invalid role type, can not assign machine-to-machine role to user.",
    missing_mfa: "You need to bind additional MFA before signing-in.",
    totp_already_in_use: "TOTP is already in use.",
    backup_code_already_in_use: "Backup code is already in use.",
    password_algorithm_required: "Password algorithm is required.",
    password_and_digest: "You cannot set both plain text password and password digest."
};
var $5512f8250bd261c5$export$2e2bcd8739ae039 = Object.freeze($5512f8250bd261c5$var$user);


const $83e90866e2a20b47$var$verification_code = {
    phone_email_empty: "Both phone and email are empty.",
    not_found: "Verification code not found. Please send verification code first.",
    phone_mismatch: "Phone mismatch. Please request a new verification code.",
    email_mismatch: "Email mismatch. Please request a new verification code.",
    code_mismatch: "Invalid verification code.",
    expired: "Verification code has expired. Please request a new verification code.",
    exceed_max_try: "Verification code retries limitation exceeded. Please request a new verification code."
};
var $83e90866e2a20b47$export$2e2bcd8739ae039 = Object.freeze($83e90866e2a20b47$var$verification_code);


const $64068e123411e8cd$var$errors = {
    request: $5aab8b44bd134033$export$2e2bcd8739ae039,
    auth: $06a6dba40a4dd9b5$export$2e2bcd8739ae039,
    guard: $05743d0fcdba1b2f$export$2e2bcd8739ae039,
    oidc: $422cddcd2e76a18a$export$2e2bcd8739ae039,
    user: $5512f8250bd261c5$export$2e2bcd8739ae039,
    password: $5614808dc7b9aac2$export$2e2bcd8739ae039,
    session: $db20ac17007c04a9$export$2e2bcd8739ae039,
    connector: $784182933aa61c9f$export$2e2bcd8739ae039,
    verification_code: $83e90866e2a20b47$export$2e2bcd8739ae039,
    sign_in_experiences: $6093cf112fdc39bf$export$2e2bcd8739ae039,
    jwt_customizer: $496728e57dd7d0e8$export$2e2bcd8739ae039,
    localization: $d55024d6363f69cd$export$2e2bcd8739ae039,
    swagger: $1f4d42f5d09be243$export$2e2bcd8739ae039,
    entity: $b6d82ca61d3e88e1$export$2e2bcd8739ae039,
    log: $c81a1f3a00d60a74$export$2e2bcd8739ae039,
    role: $480bc5607cacba30$export$2e2bcd8739ae039,
    scope: $46bd9a04ab2d3ac7$export$2e2bcd8739ae039,
    storage: $3a01ca7e5628b372$export$2e2bcd8739ae039,
    resource: $b68c4846ea6a9a89$export$2e2bcd8739ae039,
    hook: $54bc4fa39eb7b9bd$export$2e2bcd8739ae039,
    domain: $11081f9c8705eb8c$export$2e2bcd8739ae039,
    subscription: $77cebc1daa1617cf$export$2e2bcd8739ae039,
    application: $f5fec0f8267a60ac$export$2e2bcd8739ae039,
    organization: $0001e13b787d7282$export$2e2bcd8739ae039,
    single_sign_on: $49e9aed2e00d31e2$export$2e2bcd8739ae039
};
var $64068e123411e8cd$export$2e2bcd8739ae039 = Object.freeze($64068e123411e8cd$var$errors);


const $74c3a149572daffd$var$api_resource_details = {
    page_title: "API resource details",
    back_to_api_resources: "Back to API resources",
    general_tab: "General",
    permissions_tab: "Permissions",
    settings: "Settings",
    settings_description: "API resources, a.k.a. Resource Indicators, indicate the target services or resources to be requested, usually, a URI format variable representing the resource‘s identity.",
    management_api_settings_description: "The Logto Management API is a comprehensive collection of APIs that empower administrators to manage a wide range of identity-related tasks, enforce security policies, and comply with regulations and standards.",
    management_api_notice: "This API represents Logto entity and cannot be modified or deleted. Create a machine-to-machine app to call Logto management API. <a>Learn more</a>",
    token_expiration_time_in_seconds: "Token expiration time (in seconds)",
    token_expiration_time_in_seconds_placeholder: "Enter your token expiration time",
    delete_description: "This action cannot be undone. It will permanently delete the API resource. Please enter the api resource name <span>{{name}}</span> to confirm.",
    enter_your_api_resource_name: "Enter your API resource name",
    api_resource_deleted: "The API resource {{name}} has been successfully deleted",
    permission: {
        create_button: "Create permission",
        create_title: "Create permission",
        create_subtitle: "Define the permissions (scopes) needed by this API.",
        confirm_create: "Create permission",
        edit_title: "Edit API permission",
        edit_subtitle: "Define the permissions (scopes) needed by the {{resourceName}} API.",
        name: "Permission name",
        name_placeholder: "read:resource",
        forbidden_space_in_name: "The permission name must not contain any spaces.",
        description: "Description",
        description_placeholder: "Able to read the resources",
        permission_created: "The permission {{name}} has been successfully created",
        delete_description: "If this permission is deleted, the user who had this permission will lose the access granted by it.",
        deleted: 'The permission "{{name}}" was successfully deleted.'
    }
};
var $74c3a149572daffd$export$2e2bcd8739ae039 = Object.freeze($74c3a149572daffd$var$api_resource_details);


const $056b526c438e8a45$var$api_resources = {
    page_title: "API resources",
    title: "API resources",
    subtitle: "Define APIs that your authorized applications can utilize",
    create: "Create API resource",
    api_name: "API name",
    api_name_placeholder: "Enter your API name",
    api_identifier: "API Identifier",
    api_identifier_placeholder: "https://your-api-identifier/",
    api_identifier_tip: "The unique identifier to the API resource. It must be an absolute URI and has no fragment (#) component. Equals to the <a>resource parameter</a> in OAuth 2.0.",
    default_api: "Default API",
    default_api_label: "Only zero or one default API can be set per tenant.\nWhen a default API is designated, the resource parameter can be omitted in the auth request. Subsequent token exchanges will use that API as the audience by default, resulting in the issuance of JWTs. <a>Learn more</a>",
    api_resource_created: "The API resource {{name}} has been successfully created",
    invalid_resource_indicator_format: "API indicator must be a valid absolute URI."
};
var $056b526c438e8a45$export$2e2bcd8739ae039 = Object.freeze($056b526c438e8a45$var$api_resources);


const $c432b2cb821ec1d8$var$application_details = {
    page_title: "Application details",
    back_to_applications: "Back to applications",
    check_guide: "Check guide",
    settings: "Settings",
    settings_description: 'An "Application" is a registered software or service that can access user info or act for a user. Applications help recognize who’s asking for what from Logto and handle the sign-in and permission. Fill in the required fields for authentication.',
    integration: "Integration",
    integration_description: "Deploy with Logto secure workers, powered by Cloudflare's edge network for top-tier performance and 0ms cold starts worldwide.",
    service_configuration: "Service configuration",
    service_configuration_description: "Complete the necessary configurations in your service.",
    session: "Session",
    endpoints_and_credentials: "Endpoints & Credentials",
    endpoints_and_credentials_description: "Use the following endpoints and credentials to set up the OIDC connection in your application.",
    refresh_token_settings: "Refresh token",
    refresh_token_settings_description: "Manage the refresh token rules for this application.",
    application_roles: "Roles",
    machine_logs: "Machine logs",
    application_name: "Application name",
    application_name_placeholder: "My App",
    description: "Description",
    description_placeholder: "Enter your application description",
    config_endpoint: "OpenID Provider configuration endpoint",
    authorization_endpoint: "Authorization Endpoint",
    authorization_endpoint_tip: "The endpoint to perform authentication and authorization. It's used for OpenID Connect <a>Authentication</a>.",
    show_endpoint_details: "Show endpoint details",
    hide_endpoint_details: "Hide endpoint details",
    logto_endpoint: "Logto endpoint",
    application_id: "App ID",
    application_id_tip: "The unique application identifier normally generated by Logto. It also stands for “<a>client_id</a>” in OpenID Connect.",
    application_secret: "App Secret",
    redirect_uri: "Redirect URI",
    redirect_uris: "Redirect URIs",
    redirect_uri_placeholder: "https://your.website.com/app",
    redirect_uri_placeholder_native: "io.logto://callback",
    redirect_uri_tip: "The URI redirects after a user sign-in (whether successful or not). See OpenID Connect <a>AuthRequest</a> for more info.",
    post_sign_out_redirect_uri: "Post Sign-out Redirect URI",
    post_sign_out_redirect_uris: "Post Sign-out Redirect URIs",
    post_sign_out_redirect_uri_placeholder: "https://your.website.com/home",
    post_sign_out_redirect_uri_tip: "The URI redirects after a user sign-out (optional). It may have no practical effect in some app types.",
    cors_allowed_origins: "CORS allowed origins",
    cors_allowed_origins_placeholder: "https://your.website.com",
    cors_allowed_origins_tip: "By default, all the origins of Redirect URIs will be allowed. Usually no action is required for this field. See the <a>MDN doc</a> for detailed info.",
    token_endpoint: "Token Endpoint",
    user_info_endpoint: "Userinfo Endpoint",
    enable_admin_access: "Enable admin access",
    enable_admin_access_label: "Enable or disable the access to Management API. Once enabled, you can use access tokens to call Management API on behalf on this application.",
    always_issue_refresh_token: "Always issue Refresh Token",
    always_issue_refresh_token_label: "When enabled, Logto will always issue Refresh Tokens, regardless of whether `prompt=consent` is presented in the authentication request. However, this practice is discouraged unless necessary, as it is not compatible with OpenID Connect and may potentially cause issues.",
    refresh_token_ttl: "Refresh Token Time to Live (TTL) in days",
    refresh_token_ttl_tip: "The duration for which a Refresh Token can be used to request new access tokens before it expires and becomes invalid. Token requests will extend the TTL of the Refresh Token to this value.",
    rotate_refresh_token: "Rotate Refresh Token",
    rotate_refresh_token_label: "When enabled, Logto will issue a new Refresh Token for token requests when 70% of the original Time to Live (TTL) has passed or certain conditions are met. <a>Learn more</a>",
    delete_description: "This action cannot be undone. It will permanently delete the application. Please enter the application name <span>{{name}}</span> to confirm.",
    enter_your_application_name: "Enter your application name",
    application_deleted: "Application {{name}} has been successfully deleted",
    redirect_uri_required: "You must enter at least one redirect URI",
    app_domain_description_1: "Feel free to use your domain with {{domain}} powered by Logto, which is permanently valid.",
    app_domain_description_2: "Feel free to utilize your domain <domain>{{domain}}</domain> which is permanently valid.",
    custom_rules: "Custom authentication rules",
    custom_rules_placeholder: "^/(admin|privacy)/.+$",
    custom_rules_description: "Set rules with regular expressions for authentication-required routes. Default: full-site protection if left blank.",
    authentication_routes: "Authentication routes",
    custom_rules_tip: "Here are two case scenarios:<ol><li>To only protect routes '/admin' and '/privacy' with authentication: ^/(admin|privacy)/.*</li><li>To exclude JPG images from authentication: ^(?!.*\\.jpg$).*$</li></ol>",
    authentication_routes_description: "Redirect your authentication button using the specified routes. Note: These routes are irreplaceable.",
    protect_origin_server: "Protect your origin server",
    protect_origin_server_description: "Ensure to protect your origin server from direct access. Refer to the guide for more <a>detailed instructions</a>.",
    session_duration: "Session duration (days)",
    try_it: "Try it",
    branding: {
        name: "Branding",
        description: "Customize your application's display name and logo on the consent screen.",
        more_info: "More info",
        more_info_description: "Offer users more details about your application on the consent screen.",
        display_name: "Display name",
        display_logo: "Display logo",
        display_logo_dark: "Display logo (dark)",
        terms_of_use_url: "Application terms of use URL",
        privacy_policy_url: "Application privacy policy URL"
    },
    permissions: {
        name: "Permissions",
        description: "Select the permissions that the third-party application requires for user authorization to access specific data types.",
        user_permissions: "Personal user data",
        organization_permissions: "Organization access",
        table_name: "Grant permissions",
        field_name: "Permission",
        field_description: "Displayed in the consent screen",
        delete_text: "Remove permission",
        permission_delete_confirm: "This action will withdraw the permissions granted to the third-party app, preventing it from requesting user authorization for specific data types. Are you sure you want to continue?",
        permissions_assignment_description: "Select the permissions the third-party application requests for user authorization to access specific data types.",
        user_profile: "User data",
        api_permissions: "API permissions",
        organization: "Organization permissions",
        user_permissions_assignment_form_title: "Add the user profile permissions",
        organization_permissions_assignment_form_title: "Add the organization permissions",
        api_resource_permissions_assignment_form_title: "Add the API resource permissions",
        user_data_permission_description_tips: 'You can modify the description of the personal user data permissions via "Sign-in Experience > Content > Manage Language"',
        permission_description_tips: "When Logto is used as an Identity Provider (IdP) for authentication in third-party apps, and users are asked for authorization, this description appears on the consent screen.",
        user_title: "User",
        user_description: "Select the permissions requested by the third-party app for accessing specific user data.",
        grant_user_level_permissions: "Grant permissions of user data",
        organization_title: "Organization",
        organization_description: "Select the permissions requested by the third-party app for accessing specific organization data.",
        grant_organization_level_permissions: "Grant permissions of organization data"
    },
    roles: {
        name_column: "Role",
        description_column: "Description",
        assign_button: "Assign roles",
        delete_description: "This action will remove this role from this machine-to-machine app. The role itself will still exist, but it will no longer be associated with this machine-to-machine app.",
        deleted: "{{name}} was successfully removed from this user.",
        assign_title: "Assign roles to {{name}}",
        assign_subtitle: "Authorize {{name}} one or more roles",
        assign_role_field: "Assign roles",
        role_search_placeholder: "Search by role name",
        added_text: "{{value, number}} added",
        assigned_app_count: "{{value, number}} applications",
        confirm_assign: "Assign roles",
        role_assigned: "Successfully assigned role(s)",
        search: "Search by role name, description or ID",
        empty: "No role available"
    }
};
var $c432b2cb821ec1d8$export$2e2bcd8739ae039 = Object.freeze($c432b2cb821ec1d8$var$application_details);


const $57ecae383e3973da$var$applications = {
    page_title: "Applications",
    title: "Applications",
    subtitle: "Create and manage applications for OIDC authentication.",
    subtitle_with_app_type: "Set up Logto authentication for your {{name}} application",
    create: "Create application",
    create_subtitle_third_party: "Use Logto as your identity provider (IdP) to easily integrate with third-party applications",
    application_name: "Application name",
    application_name_placeholder: "My App",
    application_description: "Application description",
    application_description_placeholder: "Enter your application description",
    select_application_type: "Select an application type",
    no_application_type_selected: "You haven’t selected any application type yet",
    application_created: "Application created successfully.",
    tab: {
        my_applications: "My apps",
        third_party_applications: "Third-party apps"
    },
    app_id: "App ID",
    type: {
        native: {
            title: "Native App",
            subtitle: "An app that runs in a native environment",
            description: "E.g., iOS app, Android app"
        },
        spa: {
            title: "Single Page App",
            subtitle: "An app that runs in a web browser and dynamically updates data in place",
            description: "E.g., React DOM app, Vue app"
        },
        traditional: {
            title: "Traditional Web",
            subtitle: "An app that renders and updates pages by the web server alone",
            description: "E.g., Next.js, PHP"
        },
        machine_to_machine: {
            title: "Machine-to-Machine",
            subtitle: "An app (usually a service) that directly talks to resources",
            description: "E.g., Backend service"
        },
        protected: {
            title: "Protected App",
            subtitle: "An app that is protected by Logto",
            description: "N/A"
        },
        third_party: {
            title: "Third-party App",
            subtitle: "An app that is used as a third-party IdP connector",
            description: "E.g., OIDC, SAML"
        }
    },
    placeholder_title: "Select an application type to continue",
    placeholder_description: "Logto uses an application entity for OIDC to help with tasks such as identifying your apps, managing sign-in, and creating audit logs.",
    m2m_role_assignment: {
        title: "Authorize app with machine-to-machine role for permissions",
        subtitle: "Machine-to-machine applications require authorized machine-to-machine role.",
        role_creation_hint: "Can’t find the right machine-to-machine role? <a>Create a machine-to-machine role</a>"
    }
};
var $57ecae383e3973da$export$2e2bcd8739ae039 = Object.freeze($57ecae383e3973da$var$applications);


const $ab5df1c152c3cacb$var$cloud = {
    general: {
        onboarding: "Onboarding"
    },
    welcome: {
        page_title: "Welcome",
        title: "Welcome to Logto Cloud! We'd love to learn a bit about you.",
        description: "Let's make your Logto experience unique to you by getting to know you better. Your information is safe with us.",
        project_field: "I'm using Logto for",
        project_options: {
            personal: "Personal project",
            company: "Company project"
        },
        company_name_field: "Company name",
        company_name_placeholder: "Acme.co",
        stage_field: "What stage is your product currently in?",
        stage_options: {
            new_product: "Start a new project and looking for a quick, out-of-the-box solution",
            existing_product: "Migrate from current authentication (e.g., self-built, Auth0, Cognito, Microsoft)",
            target_enterprise_ready: "I just landed bigger clients and now make my product ready to sell to enterprises"
        },
        additional_features_field: "Do you have anything else you want us to know?",
        additional_features_options: {
            customize_ui_and_flow: "Build and manage my own UI, not just use Logto pre-built and customizable solution",
            compliance: "SOC2 and GDPR are must-haves",
            export_user_data: "Need the ability to export user data from Logto",
            budget_control: "I have very tight budget control",
            bring_own_auth: "Have my own auth services and just need some Logto features",
            others: "None of these above"
        }
    },
    create_tenant: {
        page_title: "Create tenant",
        title: "Create your first tenant",
        description: "A tenant is an isolated environment where you can manage user identities, applications, and all other Logto resources.",
        invite_collaborators: "Invite your collaborators by email"
    },
    sie: {
        page_title: "Customize sign-in experience",
        title: "Let's first customize your sign-in experience with ease",
        inspire: {
            title: "Create compelling examples",
            description: 'Feeling unsure about sign in experience? Just click the "Inspire Me" and let the magic happen!',
            inspire_me: "Inspire me"
        },
        logo_field: "App Logo",
        color_field: "Brand color",
        identifier_field: "Identifier",
        identifier_options: {
            email: "Email",
            phone: "Phone",
            user_name: "Username"
        },
        authn_field: "Authentication",
        authn_options: {
            password: "Password",
            verification_code: "Verification code"
        },
        social_field: "Social sign-in",
        finish_and_done: "Finish and done",
        preview: {
            mobile_tab: "Mobile",
            web_tab: "Web"
        },
        connectors: {
            unlocked_later: "Unlocked later",
            unlocked_later_tip: "Once you have completed the onboarding process and entered the product, you will have access to even more social sign-in methods.",
            notice: "Please avoid using the demo connector for production purposes. Once you've completed testing, kindly delete the demo connector and set up your own connector with your credentials."
        }
    },
    socialCallback: {
        title: "You've successfully signed in",
        description: "You have successfully signed in using your social account. To ensure seamless integration and access to all the features of Logto, we recommend that you proceed to configure your own social connector."
    },
    tenant: {
        create_tenant: "Create tenant"
    }
};
var $ab5df1c152c3cacb$export$2e2bcd8739ae039 = Object.freeze($ab5df1c152c3cacb$var$cloud);


const $917f1672a74fdea1$var$components = {
    uploader: {
        action_description: "Drag and drop or browse",
        uploading: "Uploading...",
        image_limit: "Upload image under {{size, number}}KB, {{extensions, list(style: narrow; type: conjunction;)}} only.",
        error_upload: "Something went wrong. File upload failed.",
        error_file_size: "File size is too large. Please upload a file under {{size, number}}KB.",
        error_file_type: "File type is not supported. {{extensions, list(style: narrow; type: conjunction;)}} only.",
        error_file_count: "You can only upload 1 file."
    }
};
var $917f1672a74fdea1$export$2e2bcd8739ae039 = Object.freeze($917f1672a74fdea1$var$components);


const $fdfa540e90378d32$var$connector_details = {
    page_title: "Connector details",
    back_to_connectors: "Back to connectors",
    check_readme: "Check README",
    settings: "General settings",
    settings_description: "Connectors play a critical role in Logto. With their help, Logto enables end-users to use passwordless registration or sign-in and the capabilities of signing in with social accounts.",
    parameter_configuration: "Parameter configuration",
    test_connection: "Test",
    save_error_empty_config: "Please enter config",
    send: "Send",
    send_error_invalid_format: "Invalid input",
    edit_config_label: "Enter your JSON here",
    test_email_sender: "Test your email connector",
    test_sms_sender: "Test your SMS connector",
    test_email_placeholder: "john.doe@example.com",
    test_sms_placeholder: "+1 555-123-4567",
    test_message_sent: "Test message sent",
    test_sender_description: 'Logto uses the "Generic" template for testing. You will receive a message if your connector is rightly configured.',
    options_change_email: "Change email connector",
    options_change_sms: "Change SMS connector",
    connector_deleted: "The connector has been successfully deleted",
    type_email: "Email connector",
    type_sms: "SMS connector",
    type_social: "Social connector",
    in_used_social_deletion_description: "This connector is in-use in your sign in experience. By deleting, <name/> sign in experience will be deleted in sign in experience settings. You will need to reconfigure it if you decide to add it back.",
    in_used_passwordless_deletion_description: "This {{name}} is in-use in your sign-in experience. By deleting, your sign-in experience will not work properly until you resolve the conflict. You will need to reconfigure it if you decide to add it back.",
    deletion_description: "You are removing this connector. It cannot be undone, and you will need to reconfigure it if you decide to add it back.",
    logto_email: {
        total_email_sent: "Total email sent: {{value, number}}",
        total_email_sent_tip: "Logto utilizes SendGrid for secure and stable built-in email. It’s completely free to use. <a>Learn more</a>",
        email_template_title: "Email Template",
        template_description: "Built-in email uses default templates for seamless delivery of verification emails. No configuration is required, and you can customize basic brand information.",
        template_description_link_text: "View templates",
        description_action_text: "View templates",
        from_email_field: "From email",
        sender_name_field: "Sender name",
        sender_name_tip: 'Customize the sender name for emails. If left empty, "Verification" will be used as the default name.',
        sender_name_placeholder: "Your sender name",
        company_information_field: "Company information",
        company_information_description: "Display your company name, address, or zip code in the bottom of emails to enhance authenticity.",
        company_information_placeholder: "Your company's basic information",
        app_logo_field: "App Logo",
        app_logo_tip: "Display your brand logo in the top of emails. Use the same image for both light mode and dark mode.",
        urls_not_allowed: "URLs are not allowed",
        test_notes: "Logto uses the “Generic” template for testing."
    }
};
var $fdfa540e90378d32$export$2e2bcd8739ae039 = Object.freeze($fdfa540e90378d32$var$connector_details);


const $5f659c81177b6b3b$var$connectors = {
    page_title: "Connectors",
    title: "Connectors",
    subtitle: "Set up connectors to enable passwordless and social sign-in experience",
    create: "Add Social Connector",
    config_sie_notice: "You’ve set up connectors. Make sure to configure it in <a>{{link}}</a>.",
    config_sie_link_text: "sign in experience",
    tab_email_sms: "Email and SMS connectors",
    tab_social: "Social connectors",
    connector_name: "Connector name",
    demo_tip: "The maximum number of messages allowed for this demo connector is limited to 100 and is not recommended for deployment in a production environment.",
    social_demo_tip: "The demo connector is designed exclusively for demonstration purposes and is not recommended for deployment in a production environment.",
    connector_type: "Type",
    connector_status: "Sign in Experience",
    connector_status_in_use: "In use",
    connector_status_not_in_use: "Not in use",
    not_in_use_tip: {
        content: "Not in use means your sign in experience hasn’t used this sign in method. <a>{{link}}</a> to add this sign in method. ",
        go_to_sie: "Go to sign in experience"
    },
    placeholder_title: "Social connector",
    placeholder_description: "Logto has provided many widely used social sign-in connectors meantime you can create your own with standard protocols.",
    save_and_done: "Save and Done",
    type: {
        email: "Email connector",
        sms: "SMS connector",
        social: "Social connector"
    },
    setup_title: {
        email: "Set up email connector",
        sms: "Set up SMS connector",
        social: "Add Social Connector"
    },
    guide: {
        subtitle: "A step by step guide to configure your connector",
        general_setting: "General settings",
        parameter_configuration: "Parameter configuration",
        test_connection: "Test connection",
        name: "Name for social sign-in button",
        name_placeholder: "Enter name for social sign-in button",
        name_tip: 'The name of the connector button will be displayed as "Continue with {{name}}." Be mindful of the length of the naming in case it gets too long.',
        logo: "Logo URL for social sign-in button",
        logo_placeholder: "https://your.cdn.domain/logo.png",
        logo_tip: "Logo image will show on the connector. Get a publicly accessible image link and insert the link here.",
        logo_dark: "Logo URL for social sign-in button (Dark mode)",
        logo_dark_placeholder: "https://your.cdn.domain/logo.png",
        logo_dark_tip: "Set your connector’s logo for dark mode after enabling it in the sign-in experience.",
        logo_dark_collapse: "Collapse",
        logo_dark_show: "Show logo setting for dark mode",
        target: "Identity provider name",
        target_placeholder: "Enter connector identity provider name",
        target_tip: "The value of “IdP name” can be a unique identifier string to distinguish your social identifies.",
        target_tip_standard: "The value of “IdP name” can be a unique identifier string to distinguish your social identifies. This setting cannot be changed after the connector is built.",
        target_tooltip: '"IdP name" in Logto social connectors refers to the "source" of your social identities. In Logto design, we do not accept the same "IdP name" of a specific platform to avoid conflicts. You should be very careful before you add a connector since you CAN NOT change its value once you create it. <a>Learn more</a>',
        target_conflict: "The IdP name entered matches the existing <span>name</span> connector. Using the same idp name may cause unexpected sign-in behavior where users may access the same account through two different connectors.",
        target_conflict_line2: 'If you\'d like to replace the current connector with the same identity provider and allow previous users to sign in without registering again, please delete the <span>name</span> connector and create a new one with the same "IdP name".',
        target_conflict_line3: 'If you\'d like to connect to a different identity provider, please modify the "IdP name" and proceed.',
        config: "Enter your config JSON",
        sync_profile: "Sync profile information",
        sync_profile_only_at_sign_up: "Only sync at sign-up",
        sync_profile_each_sign_in: "Always do a sync at each sign-in",
        sync_profile_tip: "Sync the basic profile from the social provider, such as users' names and their avatars.",
        callback_uri: "Callback URI",
        callback_uri_description: "Also called redirect URI, is the URI in Logto where users will be sent back after social authorization, copy and paste to the social provider's config page.",
        acs_url: "Assertion consumer service URL"
    },
    platform: {
        universal: "Universal",
        web: "Web",
        native: "Native"
    },
    add_multi_platform: " supports multiple platform, select a platform to continue",
    drawer_title: "Connector Guide",
    drawer_subtitle: "Follow the instructions to integrate your connector",
    unknown: "Unknown Connector",
    standard_connectors: "Standard connectors"
};
var $5f659c81177b6b3b$export$2e2bcd8739ae039 = Object.freeze($5f659c81177b6b3b$var$connectors);


const $04e16c04872158f5$var$contact = {
    title: "Get help",
    description: "For help requests or product feedback, please contact us through the following methods.",
    discord: {
        title: "Join Discord community",
        description: "Connect with other developers to find solutions",
        button: "Join"
    },
    github: {
        title: "Communicate on GitHub",
        description: "Create an issue and submit at GitHub",
        button: "Open"
    },
    email: {
        title: "Contact support via email",
        description: "Send us an email for further information and help",
        button: "Send"
    },
    reserve: {
        title: "Reserve your time with Logto team",
        description: "Quickly book a session for a live chat",
        button: "Book"
    }
};
var $04e16c04872158f5$export$2e2bcd8739ae039 = Object.freeze($04e16c04872158f5$var$contact);


const $a3e243f9d33e7d28$var$dashboard = {
    page_title: "Dashboard",
    title: "Dashboard",
    description: "Get an overview about your app performance",
    total_users: "Total users",
    total_users_tip: "Total users",
    new_users_today: "New users today",
    new_users_today_tip: "The number of new users registered on your apps today",
    new_users_7_days: "New users past 7 days",
    new_users_7_days_tip: "The number of new users registered on your apps in the past 7 days",
    daily_active_users: "Daily active users",
    daily_active_users_tip: "The number of unique users exchanged tokens on your apps today",
    weekly_active_users: "Weekly active users",
    weekly_active_users_tip: "The number of unique users exchanged tokens on your apps in the past 7 days",
    monthly_active_users: "Monthly active users",
    monthly_active_users_tip: "The number of unique users exchanged tokens on your apps in the past 30 days"
};
var $a3e243f9d33e7d28$export$2e2bcd8739ae039 = Object.freeze($a3e243f9d33e7d28$var$dashboard);


const $adac7c05d4552c6c$var$domain = {
    status: {
        connecting: "Connecting...",
        in_use: "In use",
        failed_to_connect: "Failed to connect"
    },
    update_endpoint_notice: "Don’t forget to update the domain for the Social connector callback URI and Logto endpoint in your application if you want to use a custom domain for the features. <a>{{link}}</a>",
    error_hint: "Make sure to update your DNS records. We will continue to check every {{value}} seconds.",
    custom: {
        custom_domain: "Custom Domain",
        custom_domain_description: "Improve your branding by utilizing a custom domain. This domain will be used in your sign-in experience.",
        custom_domain_field: "Custom domain",
        custom_domain_placeholder: "your.domain.com",
        add_domain: "Add domain",
        invalid_domain_format: 'Please provide a valid domain URL with a minimum of three parts, e.g. "your.domain.com."',
        verify_domain: "Verify domain",
        enable_ssl: "Enable SSL",
        checking_dns_tip: "After you configuring the DNS records, the process will run automatically and may take up to 24 hours. You can leave this interface while it’s running.",
        enable_ssl_tip: "Enable SSL will run automatically and may take up to 24 hours. You can leave this interface while it’s running.",
        generating_dns_records: "Generating the DNS records...",
        add_dns_records: "Please add these DNS records to your DNS provider.",
        dns_table: {
            type_field: "Type",
            name_field: "Name",
            value_field: "Value"
        },
        deletion: {
            delete_domain: "Delete domain",
            reminder: "Delete custom domain",
            description: "Are you sure you want to delete this custom domain?",
            in_used_description: 'Are you sure you want to delete this custom domain "<span>{{domain}}</span>"?',
            in_used_tip: 'If you’ve set up this custom domain in your social connector provider or application endpoint before, you’ll need to modify the URI to the Logto default domain "<span>{{domain}}</span>" first. This is necessary for the social sign-in button to work properly.',
            deleted: "Delete custom domain successfully!"
        }
    },
    default: {
        default_domain: "Default domain",
        default_domain_description: "Logto offers a pre-configured default domain, ready to use without any additional setup. This default domain serves as a backup option even if you enabled a custom domain.",
        default_domain_field: "Logto default domain"
    },
    custom_endpoint_note: 'You can customize the domain name of these endpoints as your required. Choose either "{{custom}}" or "{{default}}".',
    custom_social_callback_url_note: 'You can customize the domain name of this URI to match your application’s endpoint. Choose either "{{custom}}" or "{{default}}".',
    custom_acs_url_note: 'You can customize the domain name of this URI to match your identity provider assertion consumer service URL. Choose either "{{custom}}" or "{{default}}".'
};
var $adac7c05d4552c6c$export$2e2bcd8739ae039 = Object.freeze($adac7c05d4552c6c$var$domain);


const $87824b7d88e63a23$var$enterprise_sso_details = {
    back_to_sso_connectors: "Back to enterprise SSO",
    page_title: "Enterprise SSO connector details",
    readme_drawer_title: "Enterprise SSO",
    readme_drawer_subtitle: "Set up enterprise SSO connectors to enable end users SSO",
    tab_experience: "SSO Experience",
    tab_connection: "Connection",
    general_settings_title: "General",
    custom_branding_title: "Display",
    custom_branding_description: "Customize the name and logo displayed in the end users' Single Sign-On flow. When empty, defaults are used.",
    email_domain_field_name: "Enterprise email domain",
    email_domain_field_description: "Users with this email domain can use SSO for authentication. Please verify the domain belongs to the enterprise.",
    email_domain_field_placeholder: "Email domain",
    sync_profile_field_name: "Sync profile information from the identity provider",
    sync_profile_option: {
        register_only: "Only sync at first sign-in",
        each_sign_in: "Always sync at each sign-in"
    },
    connector_name_field_name: "Connector name",
    display_name_field_name: "Display name",
    connector_logo_field_name: "Display logo",
    connector_logo_field_description: "Each image should under 500KB, SVG, PNG, JPG, JPEG only.",
    branding_logo_context: "Upload logo",
    branding_logo_error: "Upload logo error: {{error}}",
    branding_light_logo_context: "Upload light mode logo",
    branding_light_logo_error: "Upload light mode logo error: {{error}}",
    branding_logo_field_name: "Logo",
    branding_logo_field_placeholder: "https://your.domain/logo.png",
    branding_dark_logo_context: "Upload dark mode logo",
    branding_dark_logo_error: "Upload dark mode logo error: {{error}}",
    branding_dark_logo_field_name: "Logo (dark mode)",
    branding_dark_logo_field_placeholder: "https://your.domain/dark-mode-logo.png",
    check_connection_guide: "Connection guide",
    enterprise_sso_deleted: "Enterprise SSO connector has been successfully deleted",
    delete_confirm_modal_title: "Delete enterprise SSO connector",
    delete_confirm_modal_content: "Are you sure you want to delete this enterprise connector? Users from identity providers will not utilize Single Sign-On.",
    upload_idp_metadata_title_saml: "Upload the metadata",
    upload_idp_metadata_description_saml: "Configure the metadata copied from the identity provider.",
    upload_idp_metadata_title_oidc: "Upload the credentials",
    upload_idp_metadata_description_oidc: "Configure the credentials and OIDC token information copied from the identity provider.",
    upload_idp_metadata_button_text: "Upload metadata XML file",
    upload_signing_certificate_button_text: "Upload signing certificate file",
    configure_domain_field_info_text: "Add email domain to guide enterprise users to their identity provider for Single Sign-on.",
    email_domain_field_required: "Email domain is required to enable enterprise SSO.",
    upload_saml_idp_metadata_info_text_url: "Paste the metadata URL from the identity provider to connect.",
    upload_saml_idp_metadata_info_text_xml: "Paste the metadata from the identity provider to connect.",
    upload_saml_idp_metadata_info_text_manual: "Fill in the metadata from the identity provider to connect.",
    upload_oidc_idp_info_text: "Fill in the information from the identity provider to connect.",
    service_provider_property_title: "Configure in the IdP",
    service_provider_property_description: "Set up an application integration using {{protocol}} in your identity provider. Enter the details provided by Logto.",
    attribute_mapping_title: "Attribute mappings",
    attribute_mapping_description: "Sync user profiles from the identity provider by configuring user attribute mapping either on the identity provider to Logto side.",
    saml_preview: {
        sign_on_url: "Sign on URL",
        entity_id: "Issuer",
        x509_certificate: "Signing certificate",
        certificate_content: "Expiring {{date}}"
    },
    oidc_preview: {
        authorization_endpoint: "Authorization endpoint",
        token_endpoint: "Token endpoint",
        userinfo_endpoint: "User information endpoint",
        jwks_uri: "JSON web key set endpoint",
        issuer: "Issuer"
    }
};
var $87824b7d88e63a23$export$2e2bcd8739ae039 = Object.freeze($87824b7d88e63a23$var$enterprise_sso_details);


const $4c00699edda4a863$var$enterprise_sso = {
    page_title: "Enterprise SSO",
    title: "Enterprise SSO",
    subtitle: "Connect the enterprise identity provider and enable SP-initiated Single Sign-On.",
    create: "Add enterprise connector",
    col_connector_name: "Connector name",
    col_type: "Type",
    col_email_domain: "Email domain",
    placeholder_title: "Enterprise connector",
    placeholder_description: "Logto has provided many built-in enterprise identity providers to connect, meantime you can create your own with SAML and OIDC protocols.",
    create_modal: {
        title: "Add enterprise connector",
        text_divider: "Or you can customize your connector by a standard protocol.",
        connector_name_field_title: "Connector name",
        connector_name_field_placeholder: "E.g., {corp. name} - {identity provider name}",
        create_button_text: "Create connector"
    },
    guide: {
        subtitle: "A step by step guide to connect the enterprise identity provider.",
        finish_button_text: "Continue"
    },
    basic_info: {
        title: "Configure your service in the IdP",
        description: "Create a new application integration by SAML 2.0 in your {{name}} identity provider. Then paste the following value to it.",
        saml: {
            acs_url_field_name: "Assertion consumer service URL (Reply URL)",
            audience_uri_field_name: "Audience URI (SP Entity ID)"
        },
        oidc: {
            redirect_uri_field_name: "Redirect URI (Callback URL)"
        }
    },
    attribute_mapping: {
        title: "Attribute mappings",
        description: "`id` and `email` are required to sync user profile from IdP. Enter the following claim name and value in your IdP.",
        col_sp_claims: "Value of service provider (Logto)",
        col_idp_claims: "Claim name of identity provider",
        idp_claim_tooltip: "The claim name of the identity provider"
    },
    metadata: {
        title: "Configure the IdP metadata",
        description: "Configure the metadata from the identity provider",
        dropdown_trigger_text: "Use another configuration method",
        dropdown_title: "select your configuration method",
        metadata_format_url: "Enter the metadata URL",
        metadata_format_xml: "Upload the metadata XML file",
        metadata_format_manual: "Enter metadata details manually",
        saml: {
            metadata_url_field_name: "Metadata URL",
            metadata_url_description: "Dynamically fetch data from the metadata URL and keep certificate up to date.",
            metadata_xml_field_name: "IdP metadata XML file",
            metadata_xml_uploader_text: "Upload metadata XML file",
            sign_in_endpoint_field_name: "Sign on URL",
            idp_entity_id_field_name: "IdP entity ID (Issuer)",
            certificate_field_name: "Signing certificate",
            certificate_placeholder: "Copy and paste the x509 certificate",
            certificate_required: "Signing certificate is required."
        },
        oidc: {
            client_id_field_name: "Client ID",
            client_secret_field_name: "Client secret",
            issuer_field_name: "Issuer",
            scope_field_name: "Scope"
        }
    }
};
var $4c00699edda4a863$export$2e2bcd8739ae039 = Object.freeze($4c00699edda4a863$var$enterprise_sso);


const $3014aa997d6ff55a$var$errors = {
    something_went_wrong: "Oops! Something went wrong.",
    page_not_found: "Page not found",
    unknown_server_error: "Unknown server error occurred",
    empty: "No data",
    missing_total_number: "Unable to find Total-Number in response headers",
    invalid_uri_format: "Invalid URI format",
    invalid_origin_format: "Invalid URI origin format",
    invalid_json_format: "Invalid JSON format",
    invalid_regex: "Invalid regular expression",
    invalid_error_message_format: "The error message format is invalid.",
    required_field_missing: "Please enter {{field}}",
    required_field_missing_plural: "You have to enter at least one {{field}}",
    more_details: "More details",
    username_pattern_error: "Username should only contain letters, numbers, or underscore and should not start with a number.",
    email_pattern_error: "The email address is invalid.",
    phone_pattern_error: "The phone number is invalid.",
    insecure_contexts: "Insecure contexts (non-HTTPS) are not supported.",
    unexpected_error: "An unexpected error occurred.",
    not_found: "404 not found",
    create_internal_role_violation: 'You are creating a new internal role which is forbidden by Logto. Try another name that does not start with "#internal:".',
    should_be_an_integer: "Should be an integer.",
    number_should_be_between_inclusive: "Then number should be between {{min}} and {{max}} (both inclusive)."
};
var $3014aa997d6ff55a$export$2e2bcd8739ae039 = Object.freeze($3014aa997d6ff55a$var$errors);


const $f7c4443375742524$var$general = {
    placeholder: "Placeholder",
    submit: "Submit",
    skip: "Skip",
    next: "Next",
    back: "Back",
    retry: "Try again",
    done: "Done",
    search: "Search",
    search_placeholder: "Search",
    clear_result: "Clear results",
    save: "Save",
    save_changes: "Save changes",
    saved: "Saved",
    discard: "Discard",
    loading: "Loading...",
    redirecting: "Redirecting...",
    add: "Add",
    added: "Added",
    cancel: "Cancel",
    confirm: "Confirm",
    check_out: "Check out",
    create: "Create",
    set_up: "Set up",
    customize: "Customize",
    enable: "Enable",
    reminder: "Reminder",
    edit: "Edit",
    delete: "Delete",
    deleted: "Deleted",
    more_options: "MORE OPTIONS",
    close: "Close",
    copy: "Copy",
    copying: "Copying",
    copied: "Copied",
    required: "Required",
    add_another: "Add another",
    create_another: "Create another",
    deletion_confirmation: "Are you sure you want to delete this {{title}}?",
    settings_nav: "Settings",
    unsaved_changes_warning: "You have made some changes. Are you sure you want to leave this page?",
    leave_page: "Leave page",
    stay_on_page: "Stay on page",
    type_to_search: "Type to search",
    got_it: "Got it",
    continue: "Continue",
    page_info: "{{min, number}}-{{max, number}} of {{total, number}}",
    learn_more: "Learn more",
    tab_errors: "{{count, number}} errors",
    skip_for_now: "Skip for now",
    remove: "Remove",
    visit: "Visit",
    join: "Join",
    try_now: "Try now",
    multiple_form_field: "(Multiple)",
    demo: "Demo",
    unnamed: "Unnamed",
    view: "View",
    open: "Open",
    hide: "Hide",
    unknown_error: "Unknown error, please try again later.",
    select: "Select",
    contact_us_action: "Contact us",
    description: "Description",
    name: "Name",
    add_field: "Add {{field}}",
    create_field: "Create {{field}}",
    edit_field: "Edit {{field}}",
    delete_field: "Delete {{field}}",
    coming_soon: "Coming soon",
    or: "Or"
};
var $f7c4443375742524$export$2e2bcd8739ae039 = Object.freeze($f7c4443375742524$var$general);


const $8e05ee2f8d248676$var$get_started = {
    page_title: "Get started",
    title: "Something to help you succeed",
    subtitle: "A few things you can do to quickly get value of Logto",
    develop: {
        title: "Develop: Take 5 minutes to integrate your app",
        title_cloud: "Develop: Securely integrate your app in minutes",
        subtitle_cloud: "Or take 5 minutes to integrate your app with our pre-built SDKs and tutorials."
    },
    customize: {
        title: "Customize: Deliver a great sign-in experience",
        preview: {
            title: "Check the live preview of the sign-in experience you just customized",
            subtitle: "Try Logto sign-in experience now to see how it works"
        },
        connector: {
            title: "Add more connectors to support more social sign-in methods",
            subtitle: "Try passwordless sign in and enable a secure and frictionless experience for your customers"
        },
        continue_customizing: "Continue customizing",
        try_now: "Try now",
        add_more: "Add more"
    },
    secure: {
        title: "Secure: Protect your resources"
    },
    manage: {
        title: "Manage: Define access control for your product and users",
        rbac: {
            title: "Add role-based access control to protect your resources",
            subtitle: "Control your resource through scalable role authorization for diverse use cases."
        },
        create_roles: "Create roles"
    },
    view_all: "View all →"
};
var $8e05ee2f8d248676$export$2e2bcd8739ae039 = Object.freeze($8e05ee2f8d248676$var$get_started);


const $9678b69467a97cbc$var$guide = {
    start_building: "Start building",
    get_started: "Get started",
    categories: {
        featured: "Popular and for you",
        Traditional: "Traditional web app",
        SPA: "Single page app",
        Native: "Native",
        MachineToMachine: "Machine-to-machine",
        Protected: "Non-SDK Integration",
        ThirdParty: "Third-party app"
    },
    filter: {
        title: "Filter framework",
        placeholder: "Search for framework"
    },
    checkout_tutorial: "Checkout {{name}} tutorial",
    do_not_need_tutorial: "If you don't need a tutorial, you can continue without a framework guide",
    finish_and_done: "Finish and done",
    cannot_find_guide: "Can't find your guide?",
    describe_guide_looking_for: "Describe the guide you are looking for",
    request_guide_successfully: "Your request has been successfully submitted. Thank you!",
    app: {
        select_framework_or_tutorial: "Select a framework or tutorial",
        guide_modal_title: "Start with SDK and guides",
        modal_subtitle: "Jumpstart your app development process with our pre-built SDK and tutorials.",
        select_a_framework: "Select a framework",
        continue_without_framework: "Create app without framework",
        describe_guide_looking_for_placeholder: "E.g., I want to integrate Logto into my Angular app."
    },
    api: {
        modal_title: "Start with tutorials",
        modal_subtitle: "Jumpstart your app development process with our pre-built tutorials.",
        select_a_tutorial: "Select a tutorial",
        continue_without_tutorial: "Continue without tutorial",
        describe_guide_looking_for_placeholder: "E.g., I want to protect my API using deno."
    }
};
var $9678b69467a97cbc$export$2e2bcd8739ae039 = Object.freeze($9678b69467a97cbc$var$guide);


const $638da913d12c7f02$var$invitation = {
    find_your_tenants: "Find your tenants",
    find_tenants_description: "Your email address may already be registered with multiple tenants. You can choose to join the existing ones or continue create a new one.",
    create_new_tenant: "Create a new tenant",
    email_not_match_title: "You are currently signed in as\n{{email}}",
    email_not_match_description: "Please sign in with the correct account to accept the invitation and become a member of the organization.",
    switch_account: "Sign in to another account",
    invalid_invitation_status: "Invalid invitation. Please contact the administrator and try again.",
    invitation_not_found: "Invitation not found. Please contact the administrator."
};
var $638da913d12c7f02$export$2e2bcd8739ae039 = Object.freeze($638da913d12c7f02$var$invitation);


const $1f77ceb8ce3fe670$var$jwt_claims = {
    title: "Custom JWT",
    description: "Set up custom JWT claims to include in the access token. These claims can be used to pass additional information to your application.",
    user_jwt: {
        card_title: "For user",
        card_field: "User access token",
        card_description: "Add user-specific data during access token issuance.",
        for: "for user"
    },
    machine_to_machine_jwt: {
        card_title: "For M2M",
        card_field: "Machine-to-machine token",
        card_description: "Add extra data during machine-to-machine token issuance.",
        for: "for M2M"
    },
    code_editor_title: "Customize the {{token}} claims",
    custom_jwt_create_button: "Add custom claims",
    custom_jwt_item: "Custom claims {{for}}",
    delete_modal_title: "Delete custom claims",
    delete_modal_content: "Are you sure you want to delete the custom claims?",
    clear: "Clear",
    cleared: "Cleared",
    restore: "Restore defaults",
    restored: "Restored",
    data_source_tab: "Data source",
    test_tab: "Test context",
    jwt_claims_description: "Default claims are auto-included in the JWT and cannot be overridden.",
    user_data: {
        title: "User data",
        subtitle: "Use `data.user` input parameter to provide vital user info."
    },
    token_data: {
        title: "Token data",
        subtitle: "Use `token` input parameter for current access token payload. "
    },
    fetch_external_data: {
        title: "Fetch external data",
        subtitle: "Incorporate data from your external APIs directly into claims.",
        description: "Use the `fetch` function to call your external APIs and include the data in your custom claims. Example: "
    },
    environment_variables: {
        title: "Set environment variables",
        subtitle: "Use environment variables to store sensitive information.",
        input_field_title: "Add environment variables",
        sample_code: "Accessing environment variables in your custom JWT claims handler. Example: "
    },
    jwt_claims_hint: "Limit custom claims to under 50KB. Default JWT claims are automatically included in the token and can not be overridden.",
    tester: {
        subtitle: "Adjust mock token and user data for testing.",
        run_button: "Run test",
        result_title: "Test result"
    },
    form_error: {
        invalid_json: "Invalid JSON format"
    }
};
var $1f77ceb8ce3fe670$export$2e2bcd8739ae039 = Object.freeze($1f77ceb8ce3fe670$var$jwt_claims);


const $208a2d7fbeccd7c0$var$log_details = {
    page_title: "Audit log details",
    back_to_logs: "Back to audit logs",
    back_to: "Back to {{name}}",
    success: "Success",
    failed: "Failed",
    event_key: "Event key",
    application: "Application",
    ip_address: "IP address",
    user: "User",
    log_id: "Log ID",
    time: "Time",
    user_agent: "User agent",
    tab_details: "Details",
    raw_data: "Raw data"
};
var $208a2d7fbeccd7c0$export$2e2bcd8739ae039 = Object.freeze($208a2d7fbeccd7c0$var$log_details);


const $451f4545cccf8ead$var$logs = {
    page_title: "Audit logs",
    title: "Audit logs",
    subtitle: "View log data of authentication events made by your users",
    event: "Event",
    user: "User",
    application: "Application",
    time: "Time",
    filter_by: "Filter by"
};
var $451f4545cccf8ead$export$2e2bcd8739ae039 = Object.freeze($451f4545cccf8ead$var$logs);


const $d4851cad2b34e388$var$menu = {
    profile: "Profile",
    language: "Language",
    appearance: {
        label: "Appearance",
        light: "Light mode",
        dark: "Dark mode",
        system: "Sync with system"
    },
    sign_out: "Sign Out"
};
var $d4851cad2b34e388$export$2e2bcd8739ae039 = Object.freeze($d4851cad2b34e388$var$menu);


const $9968929c0a472728$var$mfa = {
    title: "Multi-factor authentication",
    description: "Add multi-factor authentication to elevate the security of your sign-in experience.",
    factors: "Factors",
    multi_factors: "Multi-factors",
    multi_factors_description: "Users need to verify one of the enabled factors for 2-step verification.",
    totp: "Authenticator app OTP",
    otp_description: "Link Google Authenticator, etc., to verify one-time passwords.",
    webauthn: "WebAuthn (Passkey)",
    webauthn_description: "Verify via browser-supported method: biometrics, phone scanning, or security key, etc.",
    webauthn_native_tip: "WebAuthn is not supported for Native applications.",
    webauthn_domain_tip: "WebAuthn binds public keys to the specific domain. Modifying your service domain will block users from authenticating via existing passkeys.",
    backup_code: "Backup code",
    backup_code_description: "Generate 10 one-time backup codes after users set up any MFA method.",
    backup_code_setup_hint: "When users can't verify the above MFA factors, use the backup option.",
    backup_code_error_hint: "To use a backup code, you need at least one more MFA method for successful user authentication.",
    policy: "Policy",
    policy_description: "Set the MFA policy for sign-in and sign-up flows.",
    two_step_sign_in_policy: "2-step verification policy at sign-in",
    user_controlled: "Users can enable or disable MFA on their own",
    user_controlled_tip: "Users can skip the MFA set-up the first time at sign-in or sign-up, or enable/disable it in account settings.",
    mandatory: "Users are always required to use MFA at sign-in",
    mandatory_tip: "Users must set up MFA the first time at sign-in or sign-up, and use it for all future sign-ins."
};
var $9968929c0a472728$export$2e2bcd8739ae039 = Object.freeze($9968929c0a472728$var$mfa);


const $6120082d6cfbceff$var$organization_details = {
    page_title: "Organization details",
    delete_confirmation: "Once deleted, all members will lose their membership and roles in this organization. This action cannot be undone.",
    organization_id: "Organization ID",
    settings_description: "Organizations represent the teams, business customers, and partner companies that can access your applications.",
    name_placeholder: "The name of the organization, not required to be unique.",
    description_placeholder: "A description of the organization.",
    member: "Member",
    member_other: "Members",
    add_members_to_organization: "Add members to organization {{name}}",
    add_members_to_organization_description: "Find appropriate users by searching name, email, phone, or user ID. Existing members are not shown in the search results.",
    add_with_organization_role: "Add with organization role(s)",
    user: "User",
    authorize_to_roles: "Authorize {{name}} to access the following roles:",
    edit_organization_roles: "Edit organization roles",
    edit_organization_roles_of_user: "Edit organization roles of {{name}}",
    remove_user_from_organization: "Remove user from organization",
    remove_user_from_organization_description: "Once removed, the user will lose their membership and roles in this organization. This action cannot be undone.",
    search_user_placeholder: "Search by name, email, phone or user ID",
    at_least_one_user: "At least one user is required.",
    custom_data: "Custom data",
    custom_data_tip: "Custom data is a JSON object that can be used to store additional data associated with the organization.",
    invalid_json_object: "Invalid JSON object."
};
var $6120082d6cfbceff$export$2e2bcd8739ae039 = Object.freeze($6120082d6cfbceff$var$organization_details);


const $3dbbdc7784df70d5$var$organization_role_details = {
    page_title: "Organization role details",
    back_to_org_roles: "Back to organization roles",
    org_role: "Organization role",
    delete_confirm: "Doing so will remove the permissions associated with this role from the affected users and delete the relations among organization roles, members in the organization, and organization permissions.",
    deleted: "Organization role {{name}} was successfully deleted.",
    permissions: {
        tab: "Permissions",
        name_column: "Permission",
        description_column: "Description",
        type_column: "Permission type",
        type: {
            api: "API permission",
            org: "Organization permission"
        },
        assign_permissions: "Assign permissions",
        remove_permission: "Remove permission",
        remove_confirmation: "If this permission is removed, the user with this organization role will lose the access granted by this permission.",
        removed: "The permission {{name}} was successfully removed from this organization role",
        assign_description: "Assign permissions to the roles within this organization. These can include both organization permissions and API permissions.",
        organization_permissions: "Organization permissions",
        api_permissions: "API permissions",
        assign_organization_permissions: "Assign organization permissions",
        assign_api_permissions: "Assign API permissions"
    },
    general: {
        tab: "General",
        settings: "Settings",
        description: "Organization role is a grouping of permissions that can be assigned to users. The permissions can come from the predefined organization permissions and API permission.",
        name_field: "Name",
        description_field: "Description",
        description_field_placeholder: "Users with view-only permissions"
    }
};
var $3dbbdc7784df70d5$export$2e2bcd8739ae039 = Object.freeze($3dbbdc7784df70d5$var$organization_role_details);


const $a8457222812f5e69$var$organization_template = {
    title: "Organization template",
    subtitle: "In multi-tenant SaaS applications, an organization template defines shared access control policies (permissions and roles) for multiple organizations.",
    roles: {
        tab_name: "Organization roles",
        search_placeholder: "Search by role name",
        create_title: "Create organization role",
        role_column: "Organization role",
        permissions_column: "Permissions",
        placeholder_title: "Organization role",
        placeholder_description: "Organization role is a grouping of permissions that can be assigned to users. The permissions must come from the predefined organization permissions.",
        create_modal: {
            title: "Create organization role",
            create: "Create role",
            name_field: "Role name",
            description_field: "Description",
            created: "Organization role {{name}} has been successfully created."
        }
    },
    permissions: {
        tab_name: "Organization permissions",
        search_placeholder: "Search by permission name",
        create_org_permission: "Create organization permission",
        permission_column: "Organization permission",
        description_column: "Description",
        placeholder_title: "Organization permission",
        placeholder_description: "Organization permission refers to the authorization to access a resource in the context of organization.",
        delete_confirm: "If this permission is deleted, all organization roles including this permission will lose this permission, and users who had this permission will lose the access granted by it.",
        create_title: "Create organization permission",
        edit_title: "Edit organization permission",
        permission_field_name: "Permission name",
        description_field_name: "Description",
        description_field_placeholder: "Read appointment history",
        create_permission: "Create permission",
        created: "The organization permission {{name}} has been successfully created."
    }
};
var $a8457222812f5e69$export$2e2bcd8739ae039 = Object.freeze($a8457222812f5e69$var$organization_template);


const $eda45e7cc056d54d$var$organizations = {
    organization: "Organization",
    page_title: "Organizations",
    title: "Organizations",
    subtitle: "Organizations are usually used in SaaS or similar multi-tenant apps and represent your clients which are teams, organizations, or entire companies. Organizations work as a foundational element for B2B authentication and authorization.",
    organization_template: "Organization template",
    organization_id: "Organization ID",
    members: "Members",
    create_organization: "Create organization",
    setup_organization: "Set up your organization",
    organization_list_placeholder_title: "Organization",
    organization_list_placeholder_text: "Organizations are often used in SaaS or similar multi-tenant apps as a best practice. They enable you to develop apps that allow clients to create and manage organizations, invite members, and assign roles.",
    organization_name_placeholder: "My organization",
    organization_description_placeholder: "A brief description of the organization",
    organization_permission: "Organization permission",
    organization_permission_other: "Organization permissions",
    create_permission_placeholder: "Read appointment history",
    organization_role: "Organization role",
    organization_role_other: "Organization roles",
    organization_role_description: "Organization role is a grouping of permissions that can be assigned to users. The permissions must come from the predefined organization permissions.",
    role: "Role",
    search_placeholder: "Search by organization name or ID",
    search_role_placeholder: "Type to search and select roles",
    empty_placeholder: "\uD83E\uDD14 You don’t have any {{entity}} set up yet.",
    organization_and_member: "Organization and member",
    organization_and_member_description: 'Organization is a group of users and can represent the teams, business customers, and partner companies, with each user being a "Member". Those can be fundamental entities to handle your multi-tenant requirements.',
    guide: {
        title: "Start with guides",
        subtitle: "Jumpstart your organization settings with our guides",
        introduction: {
            title: "Let's understand how organization works in Logto",
            section_1: {
                title: "An organization is a group of users (identities)"
            },
            section_2: {
                title: "Organization template is designed for multi-tenant apps access control",
                description: 'In multi-tenant SaaS applications, multiple organizations often share the same access control template, which includes permissions and roles. In Logto, we call it "organization template."',
                permission_description: "Organization permission refers to the authorization to access a resource in the context of organization.",
                role_description_deprecated: "Organization role is a grouping of organization permissions that can be assigned to members.",
                role_description: "Organization role is a grouping of organization permissions or API permissions that can be assigned to members."
            },
            section_3: {
                title: "Can I assign API permissions to organization roles?",
                description: "Yes, you can assign API permissions to organization roles. Logto offers the flexibility to manage your organization's roles effectively, allowing you to include both organization permissions and API permissions within those roles."
            },
            section_4: {
                title: "Interact with the illustration to see how everything connects",
                description: "Let's take an example. John, Sarah are in different organizations with different roles in the context of different organizations. Hover over the different modules and see what happens."
            }
        },
        organization_permissions: "Organization permissions",
        organization_roles: "Organization roles",
        admin: "Admin",
        member: "Member",
        guest: "Guest",
        role_description: 'Role "{{role}}" shares the same organization template across different organizations.',
        john: "John",
        john_tip: 'John belongs to two organizations with the email "john@email.com" as the single identifier. He is the admin of organization A as well as the guest of organization B.',
        sarah: "Sarah",
        sarah_tip: 'Sarah belongs to one organization with the email "sarah@email.com" as the single identifier. She is the admin of organization B.'
    }
};
var $eda45e7cc056d54d$export$2e2bcd8739ae039 = Object.freeze($eda45e7cc056d54d$var$organizations);


const $0292350d6bc9631f$var$permissions = {
    search_placeholder: "Search by API or permission name",
    search_placeholder_without_api: "Search by permission name",
    name_column: "Permission",
    description_column: "Description",
    api_column: "API",
    placeholder_title: "Permission",
    placeholder_description: "Permission refers to the authorization to access a resource (we call it API resource).",
    edit: "Edit permission",
    delete: "Delete permission",
    remove: "Remove permission",
    edit_title: "Edit API permission"
};
var $0292350d6bc9631f$export$2e2bcd8739ae039 = Object.freeze($0292350d6bc9631f$var$permissions);


const $661d83f551ce569b$var$profile = {
    page_title: "Account settings",
    title: "Account settings",
    description: "Change your account settings and manage your personal information here to ensure your account security.",
    settings: {
        title: "PROFILE SETTINGS",
        profile_information: "Profile information",
        avatar: "Avatar",
        name: "Name",
        username: "Username"
    },
    link_account: {
        title: "LINK ACCOUNT",
        email_sign_in: "Email sign-In",
        email: "Email",
        social_sign_in: "Social sign-In",
        link_email: "Link email",
        link_email_subtitle: "Link your email to sign in or help with account recovery.",
        email_required: "Email is required",
        invalid_email: "Invalid email address",
        identical_email_address: "The input email address is identical to the current one",
        anonymous: "Anonymous"
    },
    password: {
        title: "PASSWORD & SECURITY",
        password: "Password",
        password_setting: "Password setting",
        new_password: "New password",
        confirm_password: "Confirm password",
        enter_password: "Enter current password",
        enter_password_subtitle: "Verify it's you to protect your account security. Please enter your current password before changing it.",
        set_password: "Set password",
        verify_via_password: "Verify via password",
        show_password: "Show password",
        required: "Password is required",
        do_not_match: "Passwords do not match. Please try again."
    },
    code: {
        enter_verification_code: "Enter verification code",
        enter_verification_code_subtitle: "The verification code has been sent to <strong>{{target}}</strong>",
        verify_via_code: "Verify via verification code",
        resend: "Resend verification code",
        resend_countdown: "Resend in {{countdown}} seconds"
    },
    delete_account: {
        title: "DELETE ACCOUNT",
        label: "Delete account",
        description: "Deleting your account will remove all of your personal information, user data, and configuration. This action cannot be undone.",
        button: "Delete account",
        dialog_paragraph_1: "We're sorry to hear that you want to delete your account. Deleting your account will permanently remove all data, including user information, logs, and settings, and this action cannot be undone. So please make sure to backup any important data before proceeding.",
        dialog_paragraph_2: "To proceed with the account deletion process, please email our support team at <a>{{mail}}</a> with the subject “Account Deletion Request”. We will assist you and ensure that all of your data is properly deleted from our system.",
        dialog_paragraph_3: "Thank you for choosing Logto Cloud. If you have any further questions or concerns, please do not hesitate to reach out to us."
    },
    set: "Set",
    change: "Change",
    link: "Link",
    unlink: "Unlink",
    not_set: "Not set",
    change_avatar: "Change avatar",
    change_name: "Change name",
    change_username: "Change username",
    set_name: "Set name",
    email_changed: "Email changed.",
    password_changed: "Password changed.",
    updated: "{{target}} updated.",
    linked: "{{target}} linked.",
    unlinked: "{{target}} unlinked.",
    email_exists_reminder: "This email {{email}} is associated with an existing account. Link another email here.",
    unlink_confirm_text: "Yes, unlink",
    unlink_reminder: "Users will not be able to sign in with the <span></span> account if you unlink it. Are you sure to proceed?"
};
var $661d83f551ce569b$export$2e2bcd8739ae039 = Object.freeze($661d83f551ce569b$var$profile);


const $c35ed7437a5ab71f$var$protected_app = {
    name: "Protected App",
    title: "Create a Protected App: Add authentication with simplicity and epic speed",
    description: "Protected App securely maintains user sessions and proxies your app requests. Powered by Cloudflare Workers, enjoy the top-tier performance and 0ms cold start worldwide. <a>Learn more</a>",
    fast_create: "Fast create",
    modal_title: "Create Protected App",
    modal_subtitle: "Enable secure and fast protection with clicks. Add authentication to your existing web app with ease.",
    form: {
        url_field_label: "Your origin URL",
        url_field_placeholder: "https://domain.com/",
        url_field_description: "Provide the address of your app requiring authentication protection.",
        url_field_modification_notice: "Modifications to the origin URL may take up to 1-2 minutes to become effective across global network locations.",
        url_field_tooltip: "Provide the address of your application, excluding any '/pathname'. After creation, you can customize route authentication rules.\n\nNote: The origin URL itself doesn't necessitate authentication; protection is applied exclusively to accesses via the designated app domain.",
        domain_field_label: "App domain",
        domain_field_placeholder: "your-domain",
        domain_field_description: "This URL serves as an authentication protection proxy for the original URL. Custom domain can be applied after creation.",
        domain_field_description_short: "This URL serves as an authentication protection proxy for the original URL.",
        domain_field_tooltip: "Apps protected by Logto will be hosted at 'your-domain.{{domain}}' by default. Custom domain can be applied after creation.",
        create_application: "Create application",
        create_protected_app: "Fast create",
        errors: {
            domain_required: "Your domain is required.",
            domain_in_use: "This subdomain name is already in use.",
            invalid_domain_format: "Invalid subdomain format: use only lowercase letters, numbers, and hyphens '-'.",
            url_required: "Origin URL is required.",
            invalid_url: "Invalid origin URL format: Use http:// or https://. Note: '/pathname' is not currently supported.",
            localhost: "Please expose your local server to the internet first. Learn more about <a>local development</a>."
        }
    },
    success_message: "\uD83C\uDF89 App authentication successfully enabled! Explore the new experience of your website."
};
var $c35ed7437a5ab71f$export$2e2bcd8739ae039 = Object.freeze($c35ed7437a5ab71f$var$protected_app);


const $02b243f20407cb56$var$role_details = {
    back_to_roles: "Back to roles",
    identifier: "Identifier",
    delete_description: "Doing so will remove the permissions associated with this role from the affected users and delete the mapping between roles, users, and permissions.",
    role_deleted: "{{name}} was successfully deleted.",
    general_tab: "General",
    users_tab: "Users",
    m2m_apps_tab: "Machine-to-machine apps",
    permissions_tab: "Permissions",
    settings: "Settings",
    settings_description: "Roles are a grouping of permissions that can be assigned to users. They also provide a way to aggregate permissions defined for different APIs, making it more efficient to add, remove, or adjust permissions compared to assigning them individually to users.",
    field_name: "Name",
    field_description: "Description",
    field_is_default: "Default role",
    field_is_default_description: "Set this role as a default role for new users. Multiple default roles can be set. This will also affect the default roles for users created via Management API.",
    type_m2m_role_tag: "Machine-to-machine app role",
    type_user_role_tag: "User role",
    m2m_role_notification: "Assign this machine-to-machine role to a machine-to-machine app to grant access to the relative API resources. <a>Create a machine-to-machine app</a> first if you haven’t already.",
    permission: {
        assign_button: "Assign permissions",
        assign_title: "Assign permissions",
        assign_subtitle: "Assign permissions to this role. The role will gain the added permissions, and users with this role will inherit these permissions.",
        assign_form_field: "Assign permissions",
        added_text_one: "{{count, number}} permission added",
        added_text_other: "{{count, number}} permissions added",
        api_permission_count_one: "{{count, number}} permission",
        api_permission_count_other: "{{count, number}} permissions",
        confirm_assign: "Assign permissions",
        permission_assigned: "The selected permissions were successfully assigned to this role",
        deletion_description: "If this permission is removed, the affected user with this role will lose the access granted by this permission.",
        permission_deleted: 'The permission "{{name}}" was successfully removed from this role',
        empty: "No permission available"
    },
    users: {
        assign_button: "Assign users",
        name_column: "User",
        app_column: "App",
        latest_sign_in_column: "Latest sign in",
        delete_description: "It will remain in your user pool but lose the authorization for this role.",
        deleted: "{{name}} was successfully removed from this role",
        assign_title: "Assign users",
        assign_subtitle: "Assign users to this role. Find appropriate users by searching name, email, phone, or user ID.",
        assign_field: "Assign users",
        confirm_assign: "Assign users",
        assigned_toast_text: "The selected users were successfully assigned to this role",
        empty: "No user available"
    },
    applications: {
        assign_button: "Assign applications",
        name_column: "Application",
        app_column: "Apps",
        description_column: "Description",
        delete_description: "It will remain in your application pool but lose the authorization for this role.",
        deleted: "{{name}} was successfully removed from this role",
        assign_title: "Assign apps",
        assign_subtitle: "Assign applications to this role. Find appropriate applications by searching name, description or app ID.",
        assign_field: "Assign applications",
        confirm_assign: "Assign applications",
        assigned_toast_text: "The selected applications were successfully assigned to this role",
        empty: "No application available"
    }
};
var $02b243f20407cb56$export$2e2bcd8739ae039 = Object.freeze($02b243f20407cb56$var$role_details);


const $e45b6e6f6a707aa2$var$roles = {
    page_title: "Roles",
    title: "Roles",
    subtitle: "Roles include permissions that determine what a user can do. RBAC uses roles to give users access to resources for specific actions.",
    create: "Create role",
    role_name: "Role name",
    role_type: "Role type",
    show_role_type_button_text: "Show more options",
    hide_role_type_button_text: "Hide more options",
    type_user: "User role",
    type_machine_to_machine: "Machine-to-machine app role",
    role_description: "Description",
    role_name_placeholder: "Enter your role name",
    role_description_placeholder: "Enter your role description",
    col_roles: "Roles",
    col_type: "Type",
    col_description: "Description",
    col_assigned_entities: "Assigned",
    user_counts: "{{count}} users",
    application_counts: "{{count}} apps",
    user_count: "{{count}} user",
    application_count: "{{count}} app",
    assign_permissions: "Assign permissions",
    create_role_title: "Create role",
    create_role_description: "Create and manage roles for your applications. Roles contain collections of permissions and can be assigned to users.",
    create_role_button: "Create role",
    role_created: "The role {{name}} has been successfully created.",
    search: "Search by role name, description or ID",
    placeholder_title: "Roles",
    placeholder_description: "Roles are a grouping of permissions that can be assigned to users. Be sure to add permission first before create roles.",
    assign_user_roles: "Assign user roles",
    assign_m2m_roles: "Assign machine-to-machine roles",
    management_api_access_notification: "For Logto Management API access, select roles with management API permissions <flag/>.",
    with_management_api_access_tip: "This machine-to-machine role includes Logto management API permissions"
};
var $e45b6e6f6a707aa2$export$2e2bcd8739ae039 = Object.freeze($e45b6e6f6a707aa2$var$roles);


const $10ef3b341d550b0d$var$session_expired = {
    title: "Session expired",
    subtitle: "Your session might have expired and you have been disconnected. Click the button below to sign in to admin console again.",
    button: "Sign in again"
};
var $10ef3b341d550b0d$export$2e2bcd8739ae039 = Object.freeze($10ef3b341d550b0d$var$session_expired);


const $a6c36bc025be15d6$var$content = {
    terms_of_use: {
        title: "TERMS",
        terms_of_use: "Terms of use URL",
        terms_of_use_placeholder: "https://your.terms.of.use/",
        privacy_policy: "Privacy policy URL",
        privacy_policy_placeholder: "https://your.privacy.policy/"
    },
    languages: {
        title: "LANGUAGES",
        enable_auto_detect: "Enable auto-detect",
        description: "Your software detects the user's locale setting and switches to the local language. You can add new languages by translating UI from English to another language.",
        manage_language: "Manage language",
        default_language: "Default language",
        default_language_description_auto: "The default language will be used when the detected user language isn’t covered in the current language library.",
        default_language_description_fixed: "When auto-detect is off, the default language is the only language your software will show. Turn on auto-detect for language extension."
    },
    manage_language: {
        title: "Manage language",
        subtitle: "Localize the product experience by adding languages and translations. Your contribution can be set as the default language.",
        add_language: "Add Language",
        logto_provided: "Logto provided",
        key: "Key",
        logto_source_values: "Logto source values",
        custom_values: "Custom values",
        clear_all_tip: "Clear all values",
        unsaved_description: "Changes won’t be saved if you leave this page without saving.",
        deletion_tip: "Delete the language",
        deletion_title: "Do you want to delete the added language?",
        deletion_description: "After deletion, your users won’t be able to browse in that language again.",
        default_language_deletion_title: "Default language can’t be deleted.",
        default_language_deletion_description: "{{language}} is set as your default language and can’t be deleted. "
    }
};
var $a6c36bc025be15d6$export$2e2bcd8739ae039 = Object.freeze($a6c36bc025be15d6$var$content);


const $4bd3ae39a5d33222$var$password_policy = {
    password_requirements: "Password requirements",
    minimum_length: "Minimum length",
    minimum_length_description: "NIST suggests using <a>at least 8 characters</a> for web products.",
    minimum_length_error: "Minimum length must be between {{min}} and {{max}} (inclusive).",
    minimum_required_char_types: "Minimum required character types",
    minimum_required_char_types_description: "Character types: uppercase (A-Z), lowercase (a-z), numbers (0-9), and special symbols ({{symbols}}).",
    password_rejection: "Password rejection",
    compromised_passwords: "Reject compromised password",
    breached_passwords: "Breached passwords",
    breached_passwords_description: "Reject passwords previously found in breach databases.",
    restricted_phrases: "Restrict low-security phrases",
    restricted_phrases_tooltip: "Your password should avoid these phrases unless you combine with 3 or more extra characters.",
    repetitive_or_sequential_characters: "Repetitive or sequential characters",
    repetitive_or_sequential_characters_description: 'E.g., "AAAA", "1234", and "abcd".',
    user_information: "User information",
    user_information_description: "E.g., email address, phone number, username, etc.",
    custom_words: "Custom words",
    custom_words_description: "Personalize context-specific words, case-insensitive, and one per line.",
    custom_words_placeholder: "Your service name, company name, etc."
};
var $4bd3ae39a5d33222$export$2e2bcd8739ae039 = Object.freeze($4bd3ae39a5d33222$var$password_policy);


const $f83988df70408e67$var$sign_up_and_sign_in = {
    identifiers_email: "Email address",
    identifiers_phone: "Phone number",
    identifiers_username: "Username",
    identifiers_email_or_sms: "Email address or phone number",
    identifiers_none: "Not applicable",
    and: "and",
    or: "or",
    sign_up: {
        title: "SIGN UP",
        sign_up_identifier: "Sign-up identifier",
        identifier_description: "The sign-up identifier is required for account creation and must be included in your sign-in screen.",
        sign_up_authentication: "Authentication setting for sign-up",
        authentication_description: "All selected actions will be obligatory for users to complete the flow.",
        set_a_password_option: "Create your password",
        verify_at_sign_up_option: "Verify at sign-up",
        social_only_creation_description: "(This apply to social only account creation)"
    },
    sign_in: {
        title: "SIGN IN",
        sign_in_identifier_and_auth: "Identifier and authentication settings for sign-in",
        description: "Users can sign in using any of the options available. Adjust the layout by drag and dropping below options.",
        add_sign_in_method: "Add sign-in method",
        password_auth: "Password",
        verification_code_auth: "Verification code",
        auth_swap_tip: "Swap the options below to determine which appears first in the flow.",
        require_auth_factor: "You have to select at least one authentication factor."
    },
    social_sign_in: {
        title: "SOCIAL SIGN-IN",
        social_sign_in: "Social sign-in",
        description: "Depending on the mandatory identifier you set up, your user may be asked to provide an identifier when signing up via social connector.",
        add_social_connector: "Add Social Connector",
        set_up_hint: {
            not_in_list: "Not in the list?",
            set_up_more: "Set up",
            go_to: "other social connectors now."
        }
    },
    tip: {
        set_a_password: "A unique set of a password to your username is a must.",
        verify_at_sign_up: "We currently only support verified email. Your user base may contain a large number of poor-quality email addresses if no validation.",
        password_auth: "This is essential as you have enabled the option to set a password during the sign-up process.",
        verification_code_auth: "This is essential as you have only enabled the option to provide verification code when signing up. You’re free to uncheck the box when password set-up is allowed at the sign-up process.",
        delete_sign_in_method: "This is essential as you have selected {{identifier}} as a required identifier."
    },
    advanced_options: {
        title: "ADVANCED OPTIONS",
        enable_single_sign_on: "Enable enterprise Single Sign-On (SSO)",
        enable_single_sign_on_description: "Enable users to sign-in to the application using Single Sign-On with their enterprise identities.",
        single_sign_on_hint: {
            prefix: "Go to ",
            link: '"Enterprise SSO"',
            suffix: "section to set up more enterprise connectors."
        },
        enable_user_registration: "Enable user registration",
        enable_user_registration_description: "Enable or disallow user registration. Once disabled, users can still be added in the admin console but users can no longer establish accounts through the sign-in UI."
    }
};
var $f83988df70408e67$export$2e2bcd8739ae039 = Object.freeze($f83988df70408e67$var$sign_up_and_sign_in);


const $610f6e1e04680ee1$var$sign_in_exp = {
    page_title: "Sign-in experience",
    title: "Sign-in experience",
    description: "Customize the sign in UI to match your brand and view in real time",
    tabs: {
        branding: "Branding",
        sign_up_and_sign_in: "Sign-up and sign-in",
        content: "Content",
        password_policy: "Password policy"
    },
    welcome: {
        title: "Customize sign-in experience",
        description: "Get started fast with your first sign-in setup. This guide walks you through all the necessary settings.",
        get_started: "Get started",
        apply_remind: "Please note that sign-in experience will apply to all applications under this account."
    },
    color: {
        title: "COLOR",
        primary_color: "Brand color",
        dark_primary_color: "Brand color (Dark)",
        dark_mode: "Enable dark mode",
        dark_mode_description: "Your app will have an auto-generated dark mode theme based on your brand color and Logto algorithm. You are free to customize.",
        dark_mode_reset_tip: "Recalculate dark mode color based on brand color.",
        reset: "Recalculate"
    },
    branding: {
        title: "BRANDING AREA",
        ui_style: "Style",
        favicon: "Favicon",
        logo_image_url: "App logo image URL",
        logo_image_url_placeholder: "https://your.cdn.domain/logo.png",
        dark_logo_image_url: "App logo image URL (Dark)",
        dark_logo_image_url_placeholder: "https://your.cdn.domain/logo-dark.png",
        logo_image: "App logo",
        dark_logo_image: "App logo (Dark)",
        logo_image_error: "App logo: {{error}}",
        favicon_error: "Favicon: {{error}}"
    },
    custom_css: {
        title: "Custom CSS",
        css_code_editor_title: "Personalize your UI with custom CSS",
        css_code_editor_description1: "See the example of custom CSS.",
        css_code_editor_description2: "<a>{{link}}</a>",
        css_code_editor_description_link_content: "Learn more",
        css_code_editor_content_placeholder: "Enter your custom CSS to tailor the styles of anything to your exact specifications. Express your creativity and make your UI stand out."
    },
    sign_up_and_sign_in: $f83988df70408e67$export$2e2bcd8739ae039,
    content: $a6c36bc025be15d6$export$2e2bcd8739ae039,
    password_policy: $4bd3ae39a5d33222$export$2e2bcd8739ae039,
    setup_warning: {
        no_connector_sms: 'No SMS connector set-up yet. Before completing the configuration, users will not be able to sign in with this method. <a>{{link}}</a> in "Connectors"',
        no_connector_email: 'No email connector set-up yet. Before completing the configuration, users will not be able to sign in with this method. <a>{{link}}</a> in "Connectors"',
        no_connector_social: "You haven’t set up any social connector yet. Add connectors first to apply social sign-in methods. <a>{{link}}</a> in “Connectors”.",
        setup_link: "Set up"
    },
    save_alert: {
        description: "You are implementing new sign-in and sign-up procedures. All of your users may be affected by the new set-up. Are you sure to commit to the change?",
        before: "Before",
        after: "After",
        sign_up: "Sign-up",
        sign_in: "Sign-in",
        social: "Social"
    },
    preview: {
        title: "Sign-in preview",
        live_preview: "Live preview",
        live_preview_tip: "Save to preview changes",
        native: "Native",
        desktop_web: "Desktop Web",
        mobile_web: "Mobile Web",
        desktop: "Desktop",
        mobile: "Mobile"
    }
};
var $610f6e1e04680ee1$export$2e2bcd8739ae039 = Object.freeze($610f6e1e04680ee1$var$sign_in_exp);


const $70a5b1c65790e496$var$signing_keys = {
    title: "Signing keys",
    description: "Securely manage signing keys used by your applications.",
    private_key: "OIDC private keys",
    private_keys_description: "OIDC private keys are used for signing JWT tokens.",
    cookie_key: "OIDC cookie keys",
    cookie_keys_description: "OIDC cookie keys are used for signing cookies.",
    private_keys_in_use: "Private keys in use",
    cookie_keys_in_use: "Cookie keys in use",
    rotate_private_keys: "Rotate private keys",
    rotate_cookie_keys: "Rotate cookie keys",
    rotate_private_keys_description: "This action will create a new private signing key, rotate the current key, and remove your previous key. Your JWT tokens signed with the current key will remain valid until deletion or another round of rotation.",
    rotate_cookie_keys_description: "This action will create a new cookie key, rotate the current key, and remove your previous key. Your cookies with the current key will remain valid until deletion or another round of rotation.",
    select_private_key_algorithm: "Select signing key algorithm for the new private key",
    rotate_button: "Rotate",
    table_column: {
        id: "ID",
        status: "Status",
        algorithm: "Signing key algorithm"
    },
    status: {
        current: "Current",
        previous: "Previous"
    },
    reminder: {
        rotate_private_key: "Are you sure you want to rotate the <strong>OIDC private keys</strong>? New issued JWT tokens will be signed by the new key. Existing JWT tokens stay valid until you rotate again.",
        rotate_cookie_key: "Are you sure you want to rotate the <strong>OIDC cookie keys</strong>? New cookies generated in sign-in sessions will be signed by the new cookie key. Existing cookies stay valid until you rotate again.",
        delete_private_key: "Are you sure you want to delete the <strong>OIDC private key</strong>? Existing JWT tokens signed with this private signing key will no longer be valid.",
        delete_cookie_key: "Are you sure you want to delete the <strong>OIDC cookie key</strong>? Older sign-in sessions with cookies signed with this cookie key will no longer be valid. A re-authentication is required for these users."
    },
    messages: {
        rotate_key_success: "Signing keys rotated successfully.",
        delete_key_success: "Key deleted successfully."
    }
};
var $70a5b1c65790e496$export$2e2bcd8739ae039 = Object.freeze($70a5b1c65790e496$var$signing_keys);


const $fb5fd90750908479$var$quota_item = {
    tenant_limit: {
        name: "Tenants",
        limited: "{{count, number}} tenant",
        limited_other: "{{count, number}} tenants",
        unlimited: "Unlimited tenants",
        not_eligible: "Remove your tenants"
    },
    mau_limit: {
        name: "Monthly active users",
        limited: "{{count, number}} MAU",
        unlimited: "Unlimited MAU",
        not_eligible: "Remove your all users"
    },
    token_limit: {
        name: "Tokens",
        limited: "{{count, number}} token",
        limited_other: "{{count, number}} tokens",
        unlimited: "Unlimited tokens",
        not_eligible: "Remove your all users to prevent new tokens"
    },
    applications_limit: {
        name: "Applications",
        limited: "{{count, number}} application",
        limited_other: "{{count, number}} applications",
        unlimited: "Unlimited applications",
        not_eligible: "Remove your applications"
    },
    machine_to_machine_limit: {
        name: "Machine to machine",
        limited: "{{count, number}} machine to machine app",
        limited_other: "{{count, number}} machine to machine apps",
        unlimited: "Unlimited machine to machine apps",
        not_eligible: "Remove your machine to machine apps"
    },
    third_party_applications_limit: {
        name: "Third-party apps",
        limited: "{{count, number}} third-party app",
        limited_other: "{{count, number}} third-party apps",
        unlimited: "Unlimited third-party apps",
        not_eligible: "Remove your third-party apps"
    },
    resources_limit: {
        name: "API resources",
        limited: "{{count, number}} API resource",
        limited_other: "{{count, number}} API resources",
        unlimited: "Unlimited API resources",
        not_eligible: "Remove your API resources"
    },
    scopes_per_resource_limit: {
        name: "Resource permissions",
        limited: "{{count, number}} permission per resource",
        limited_other: "{{count, number}} permissions per resource",
        unlimited: "Unlimited permission per resource",
        not_eligible: "Remove your resource permissions"
    },
    custom_domain_enabled: {
        name: "Custom domain",
        limited: "Custom domain",
        unlimited: "Custom domain",
        not_eligible: "Remove your custom domain"
    },
    omni_sign_in_enabled: {
        name: "Omni sign-in",
        limited: "Omni sign-in",
        unlimited: "Omni sign-in",
        not_eligible: "Disable your omni sign-in"
    },
    built_in_email_connector_enabled: {
        name: "Built-in email connector",
        limited: "Built-in email connector",
        unlimited: "Built-in email connector",
        not_eligible: "Remove your built-in email connector"
    },
    social_connectors_limit: {
        name: "Social connectors",
        limited: "{{count, number}} social connector",
        limited_other: "{{count, number}} social connectors",
        unlimited: "Unlimited Social connectors",
        not_eligible: "Remove your social connectors"
    },
    standard_connectors_limit: {
        name: "Free standard connectors",
        limited: "{{count, number}} free standard connector",
        limited_other: "{{count, number}} free standard connectors",
        unlimited: "Unlimited standard connectors",
        not_eligible: "Remove your standard connectors"
    },
    roles_limit: {
        name: "Roles",
        limited: "{{count, number}} role",
        limited_other: "{{count, number}} roles",
        unlimited: "Unlimited roles",
        not_eligible: "Remove your roles"
    },
    machine_to_machine_roles_limit: {
        name: "Machine to machine roles",
        limited: "{{count, number}} machine to machine role",
        limited_other: "{{count, number}} machine to machine roles",
        unlimited: "Unlimited machine to machine roles",
        not_eligible: "Remove your machine to machine roles"
    },
    scopes_per_role_limit: {
        name: "Role permissions",
        limited: "{{count, number}} permission per role",
        limited_other: "{{count, number}} permissions per role",
        unlimited: "Unlimited permission per role",
        not_eligible: "Remove your role permissions"
    },
    hooks_limit: {
        name: "Webhooks",
        limited: "{{count, number}} webhook",
        limited_other: "{{count, number}} webhooks",
        unlimited: "Unlimited webhooks",
        not_eligible: "Remove your webhooks"
    },
    organizations_enabled: {
        name: "Organizations",
        limited: "Organizations",
        unlimited: "Organizations",
        not_eligible: "Remove your organizations"
    },
    audit_logs_retention_days: {
        name: "Audit logs retention",
        limited: "Audit logs retention: {{count, number}} day",
        limited_other: "Audit logs retention: {{count, number}} days",
        unlimited: "Unlimited days",
        not_eligible: "No audit logs"
    },
    email_ticket_support: {
        name: "Email ticket support",
        limited: "{{count, number}} hour email ticket support",
        limited_other: "{{count, number}} hours email ticket support",
        unlimited: "Email ticket support",
        not_eligible: "No email ticket support"
    },
    mfa_enabled: {
        name: "Multi-factor authentication",
        limited: "Multi-factor authentication",
        unlimited: "Multi-factor authentication",
        not_eligible: "Remove your multi-factor authentication"
    },
    sso_enabled: {
        name: "Enterprise SSO",
        limited: "Enterprise SSO",
        unlimited: "Enterprise SSO",
        not_eligible: "Remove your Enterprise SSO"
    },
    tenant_members_limit: {
        name: "Tenant members",
        limited: "{{count, number}} tenant member",
        limited_other: "{{count, number}} tenant members",
        unlimited: "Unlimited tenant members",
        not_eligible: "Remove your tenant members"
    },
    custom_jwt_enabled: {
        name: "Custom JWT",
        limited: "Custom JWT",
        unlimited: "Custom JWT",
        not_eligible: "Remove your JWT claims customizer"
    }
};
var $fb5fd90750908479$export$2e2bcd8739ae039 = Object.freeze($fb5fd90750908479$var$quota_item);


const $d1cadd1d71b9132a$var$quota_table = {
    quota: {
        title: "Basics",
        base_price: "Base price",
        mau_limit: "MAU limit",
        included_tokens: "Included tokens"
    },
    application: {
        title: "Applications",
        total: "Total applications",
        m2m: "Machine-to-machine apps",
        third_party: "Third-party apps"
    },
    resource: {
        title: "API resources",
        resource_count: "Resource count",
        scopes_per_resource: "Permissions per resource"
    },
    branding: {
        title: "UI and branding",
        custom_domain: "Custom domain",
        custom_css: "Custom CSS",
        app_logo_and_favicon: "App logo and favicon",
        dark_mode: "Dark mode",
        i18n: "Internationalization"
    },
    user_authn: {
        title: "User authentication",
        omni_sign_in: "Omni sign-in",
        password: "Password",
        passwordless: "Passwordless - Email and SMS",
        email_connector: "Email connector",
        sms_connector: "SMS connector",
        social_connectors: "Social connectors",
        standard_connectors: "Standard connectors",
        built_in_email_connector: "Built-in email connector",
        mfa: "Multi-factor authentication",
        sso: "Enterprise SSO",
        adaptive_mfa: "Adaptive MFA"
    },
    user_management: {
        title: "User management",
        user_management: "User management",
        roles: "Roles",
        machine_to_machine_roles: "Machine-to-machine roles",
        scopes_per_role: "Permissions per role"
    },
    organizations: {
        title: "Organizations",
        organizations: "Organizations",
        organization: "Organization",
        organization_count: "Organization count",
        allowed_users_per_org: "Users per organization",
        invitation: "Invitation (Management API)",
        org_roles: "Organization roles",
        org_permissions: "Organization permissions",
        just_in_time_provisioning: "Just-in-time provisioning"
    },
    support: {
        title: "Compliance and support",
        community: "Community",
        customer_ticket: "Ticket support",
        premium: "Premium",
        email_ticket_support: "Email ticket support",
        soc2_report: "SOC2 report",
        hipaa_or_baa_report: "HIPAA/BAA report"
    },
    developers_and_platform: {
        title: "Developers and platform",
        hooks: "Webhooks",
        audit_logs_retention: "Audit logs retention",
        jwt_claims: "JWT claims",
        tenant_members: "Tenant members"
    },
    unlimited: "Unlimited",
    contact: "Contact",
    monthly_price: "${{value, number}}/mo",
    days_one: "{{count, number}} day",
    days_other: "{{count, number}} days",
    add_on: "Add-on",
    tier: "Tier{{value, number}}: ",
    paid_token_limit_tip: "Logto will add charges for features that go beyond your quota limit. You can use it at no cost until we're beginning charging around Q2 2024. If you require more tokens, please get in touch with us. By default, we bill $80 per month for every million tokens.",
    paid_quota_limit_tip: "Logto will add charges for features that go beyond your quota limit. You can use it at no cost until we're beginning charging around Q2 2024.",
    paid_add_on_feature_tip: "This is an add-on feature. You can use it at no cost until we're beginning charging around Q2 2024.",
    million: "{{value, number}} million",
    mau_tip: "MAU (monthly active user) means the number of unique users who have exchanged at least one token with Logto in a billing cycle.",
    tokens_tip: "All kinds of tokens that issued by Logto, including access token, refresh token, etc.",
    mao_tip: "MAO (monthly active org) means the number of unique organizations who has at least one MAU (monthly active user) in a billing cycle.",
    third_party_tip: "Use Logto as your OIDC identity provider for third-party app sign-ins and permission grants.",
    included: "{{value, number}} included",
    included_mao: "{{value, number}} MAO included",
    extra_quota_price: "Then ${{value, number}} per mo / ea after",
    per_month_each: "${{value, number}} per mo / ea",
    extra_mao_price: "Then ${{value, number}} per MAO",
    per_month: "${{value, number}} per mo",
    per_member: "Then ${{value, number}} per member"
};
var $d1cadd1d71b9132a$export$2e2bcd8739ae039 = Object.freeze($d1cadd1d71b9132a$var$quota_table);


const $8dfa1777ef80f4d7$var$subscription = {
    free_plan: "Free plan",
    free_plan_description: "For side projects and initial Logto trials. No credit card.",
    pro_plan: "Pro plan",
    pro_plan_description: "For businesses benefit worry-free with Logto.",
    enterprise: "Enterprise",
    current_plan: "Current plan",
    current_plan_description: "Here’s your current plan. You can easily see your plan usage, check your upcoming bill, and make changes to your plan as needed.",
    plan_usage: "Plan usage",
    plan_cycle: "Plan cycle: {{period}}. Usage renews on {{renewDate}}.",
    next_bill: "Your next bill",
    next_bill_hint: "To learn more about the calculation, please refer to this <a>article</a>.",
    next_bill_tip: "The prices displayed here are tax-exclusive. The tax amount will be calculated based on the information you provide and your local regulatory requirements, and will be shown in your invoices.",
    manage_payment: "Manage payment",
    overfill_quota_warning: "You have reached your quota limit. To prevent any issues, upgrade the plan.",
    upgrade_pro: "Upgrade pro",
    update_payment: "Update payment",
    payment_error: "Payment issue detected. Unable to process ${{price, number}} for previous cycle. Update payment to avoid Logto service suspension.",
    downgrade: "Downgrade",
    current: "Current",
    upgrade: "Upgrade",
    quota_table: $d1cadd1d71b9132a$export$2e2bcd8739ae039,
    billing_history: {
        invoice_column: "Invoices",
        status_column: "Status",
        amount_column: "Amount",
        invoice_created_date_column: "Invoice created date",
        invoice_status: {
            void: "Canceled",
            paid: "Paid",
            open: "Open",
            uncollectible: "Overdue"
        }
    },
    quota_item: $fb5fd90750908479$export$2e2bcd8739ae039,
    downgrade_modal: {
        title: "Are you sure you want to downgrade?",
        description: "If you choose to switch to the <targetName/>, please note that you will no longer have access to the quota and features that were previously in <currentName/>.",
        before: "Before: <name/>",
        after: "After: <name />",
        downgrade: "Downgrade"
    },
    not_eligible_modal: {
        downgrade_title: "You are not eligible for downgrade",
        downgrade_description: "Make sure you meet the following criteria before downgrading to the <name/>.",
        downgrade_help_tip: "Need help downgrading? <a>Contact us</a>.",
        upgrade_title: "Friendly reminder for our honoured early adopters",
        upgrade_description: "You’re currently using more than what the <name /> allows. Logto is now official, including features tailored to each plan. Before you consider upgrading to the <name />, make sure you meet the following criteria before upgrading.",
        upgrade_pro_tip: " Or considering upgrading to Pro plan.",
        upgrade_help_tip: "Need help upgrading? <a>Contact us</a>.",
        a_maximum_of: "A maximum of <item/>"
    },
    upgrade_success: "Successfully upgraded to <name/>",
    downgrade_success: "Successfully downgraded to <name/>",
    subscription_check_timeout: "Subscription check timed out. Please refresh later.",
    no_subscription: "No subscription"
};
var $8dfa1777ef80f4d7$export$2e2bcd8739ae039 = Object.freeze($8dfa1777ef80f4d7$var$subscription);


const $fb390a857a4193cc$var$tab_sections = {
    overview: "Overview",
    authentication: "Authentication",
    authorization: "Authorization",
    users: "Users",
    developer: "Developer",
    tenant: "Tenant"
};
var $fb390a857a4193cc$export$2e2bcd8739ae039 = Object.freeze($fb390a857a4193cc$var$tab_sections);


const $94b76f70a15b89ec$var$tabs = {
    get_started: "Get started",
    dashboard: "Dashboard",
    applications: "Applications",
    api_resources: "API resources",
    sign_in_experience: "Sign-in experience",
    connectors: "Connectors",
    enterprise_sso: "Enterprise SSO",
    webhooks: "Webhooks",
    organizations: "Organizations",
    users: "User management",
    audit_logs: "Audit logs",
    roles: "Roles",
    docs: "Docs",
    tenant_settings: "Settings",
    mfa: "Multi-factor auth",
    customize_jwt: "Custom JWT",
    signing_keys: "Signing keys",
    organization_template: "Organization template"
};
var $94b76f70a15b89ec$export$2e2bcd8739ae039 = Object.freeze($94b76f70a15b89ec$var$tabs);


const $a76df04dce20d9c7$var$tenant_members = {
    members: "Members",
    invitations: "Invitations",
    invite_members: "Invite members",
    user: "User",
    roles: "Roles",
    admin: "Admin",
    collaborator: "Collaborator",
    invitation_status: "Invitation status",
    inviter: "Inviter",
    expiration_date: "Expiration date",
    invite_modal: {
        title: "Invite people to Logto Cloud",
        subtitle: "To invite members to an organization, they must accept the invitation.",
        to: "To",
        added_as: "Added as roles",
        email_input_placeholder: "johndoe@example.com"
    },
    invitation_statuses: {
        pending: "Pending",
        accepted: "Accepted",
        expired: "Expired",
        revoked: "Revoked"
    },
    invitation_empty_placeholder: {
        title: "Invite team members",
        description: "Your tenant currently has no members invited.\nTo assist with your integration, consider adding more members or admins."
    },
    menu_options: {
        edit: "Edit tenant role",
        delete: "Remove user from tenant",
        resend_invite: "Resend invitation",
        revoke: "Revoke invitation",
        delete_invitation_record: "Delete this invitation record"
    },
    edit_modal: {
        title: "Change roles of {{name}}"
    },
    delete_user_confirm: "Are you sure you want to remove this user from this tenant?",
    assign_admin_confirm: "Are you sure you want to make the selected user(s) admin? Granting admin access will give the user(s) the following permissions.<ul><li>Change the tenant billing plan</li><li>Add or remove collaborators</li><li>Delete the tenant</li></ul>",
    revoke_invitation_confirm: "Are you sure you want to revoke this invitation?",
    delete_invitation_confirm: "Are you sure you want to delete this invitation record?",
    messages: {
        invitation_sent: "Invitation sent.",
        invitation_revoked: "Invitation revoked.",
        invitation_resend: "Invitation resent.",
        invitation_deleted: "Invitation record deleted."
    },
    errors: {
        email_required: "Invitee email is required.",
        email_exists: "Email address already exists.",
        member_exists: "This user is already a member of this organization.",
        pending_invitation_exists: "Pending invitation exists. Delete related email or revoke the invitation.",
        invalid_email: "Email address is invalid. Please make sure it is in the right format.",
        max_member_limit: "You have reached the maximum number of members ({{limit}}) for this tenant."
    }
};
var $a76df04dce20d9c7$export$2e2bcd8739ae039 = Object.freeze($a76df04dce20d9c7$var$tenant_members);


const $87658ee8bf00d32f$var$tenants = {
    title: "Settings",
    description: "Efficiently manage tenant settings and customize your domain.",
    tabs: {
        settings: "Settings",
        members: "Members",
        domains: "Domains",
        subscription: "Plan and billing",
        billing_history: "Billing history"
    },
    settings: {
        title: "SETTINGS",
        description: "Set the tenant name and view your data hosted region and tenant type.",
        tenant_id: "Tenant ID",
        tenant_name: "Tenant name",
        tenant_region: "Data region",
        tenant_region_description: "The physical location where your tenant resources (users, apps, etc.) are hosted. This cannot be changed after creation.",
        tenant_region_tip: "Your tenant resources are hosted in {{region}}. <a>Learn more</a>",
        environment_tag_development: "Dev",
        environment_tag_production: "Prod",
        tenant_type: "Tenant type",
        development_description: "For testing only and shouldn't be used in production. No subscription is required. It has all the pro features but has limitations like a sign-in banner. <a>Learn more</a>",
        production_description: "Intended for apps that are being used by end-users and may require a paid subscription. <a>Learn more</a>",
        tenant_info_saved: "Tenant information saved successfully."
    },
    full_env_tag: {
        development: "Development",
        production: "Production"
    },
    deletion_card: {
        title: "DELETE",
        tenant_deletion: "Delete tenant",
        tenant_deletion_description: "Deleting the tenant will result in the permanent removal of all associated user data and configuration. Please proceed with caution.",
        tenant_deletion_button: "Delete tenant"
    },
    leave_tenant_card: {
        title: "LEAVE",
        leave_tenant: "Leave tenant",
        leave_tenant_description: "Any resources in the tenant will remain but you no longer have access to this tenant.",
        last_admin_note: "To leave this tenant, ensure at least one more member has the Admin role."
    },
    create_modal: {
        title: "Create tenant",
        subtitle: "Create a new tenant that has isolated resources and users.",
        tenant_usage_purpose: "What do you want to use this tenant for?",
        development_description: "For testing only and shouldn't be used in production. No subscription is required.",
        development_hint: "It has all the pro features but has limitations like a sign-in banner.",
        production_description: "For use by end-users and may require a paid subscription.",
        available_plan: "Available plan:",
        create_button: "Create tenant",
        tenant_name_placeholder: "My tenant",
        tenant_created: "Tenant created successfully.",
        invitation_failed: "Some invitation failed to send. Please try again in Settings -> Members later.",
        tenant_type_description: "This cannot be changed after creation."
    },
    dev_tenant_migration: {
        title: 'You can now try our Pro features for free by creating a new "Development tenant"!',
        affect_title: "How does this affect you?",
        hint_1: "We are replacing the old <strong>environment tags</strong> with two new tenant types: <strong>“Development”</strong> and <strong>“Production”</strong>.",
        hint_2: "To ensure a seamless transition and uninterrupted functionality, all early-created tenants will be elevated to the <strong>Production</strong> tenant type along with your previous subscription.",
        hint_3: "Don't worry, all your other settings will remain the same.",
        about_tenant_type: "About tenant type"
    },
    delete_modal: {
        title: "Delete tenant",
        description_line1: 'Are you sure you want to delete your tenant "<span>{{name}}</span>" with environment suffix tag "<span>{{tag}}</span>"? This action cannot be undone, and will result in the permanent deletion of all your data and tenant information.',
        description_line2: "Before deleting tenant, maybe we can help you. <span><a>Contact us via Email</a></span>",
        description_line3: 'If you would like to proceed, please enter the tenant name "<span>{{name}}</span>" to confirm.',
        delete_button: "Permanently delete",
        cannot_delete_title: "Cannot delete this tenant",
        cannot_delete_description: "Sorry, you can't delete this tenant right now. Please make sure you're on the Free plan and have paid all outstanding billings."
    },
    leave_tenant_modal: {
        description: "Are you sure you want to leave this tenant?",
        leave_button: "Leave"
    },
    tenant_landing_page: {
        title: "You haven't created a tenant yet",
        description: "To start configuring your project with Logto, please create a new tenant. If you need to log out or delete your account, just click on the avatar button in the top right corner.",
        create_tenant_button: "Create tenant"
    },
    status: {
        mau_exceeded: "MAU Exceeded",
        suspended: "Suspended",
        overdue: "Overdue"
    },
    tenant_suspended_page: {
        title: "Tenant suspended. Contact us to restore access.",
        description_1: "We deeply regret to inform you that your tenant account has been temporarily suspended due to improper use, including exceeding MAU limits, overdue payments, or other unauthorized actions.",
        description_2: "If you require further clarification, have any concerns, or wish to restore full functionality and unblock your tenants, please do not hesitate to contact us immediately."
    },
    production_tenant_notification: {
        text: "You're in a dev tenant for free testing. Create a production tenant to go live.",
        action: "Create tenant"
    }
};
var $87658ee8bf00d32f$export$2e2bcd8739ae039 = Object.freeze($87658ee8bf00d32f$var$tenants);


const $a279ca79a0f30880$var$topbar = {
    docs: "Docs",
    help: "Help"
};
var $a279ca79a0f30880$export$2e2bcd8739ae039 = Object.freeze($a279ca79a0f30880$var$topbar);


const $1c7cd33b6735acef$var$featured_plan_content = {
    mau: {
        free_plan: "Up to {{count, number}} MAU",
        pro_plan: "Unlimited MAU"
    },
    m2m: {
        free_plan: "{{count, number}} machine-to-machine",
        pro_plan: "Additional machine-to-machine"
    },
    third_party_apps: "IdP for third-party applications",
    mfa: "Multi-factor authentication",
    sso: "Enterprise SSO",
    role_and_permissions: {
        free_plan: "{{roleCount, number}} role and {{permissionCount, number}} permission per role",
        pro_plan: "Unlimited roles and permissions per role"
    },
    organizations: "Organizations",
    audit_logs: "Audit logs retention: {{count, number}} days"
};
var $1c7cd33b6735acef$export$2e2bcd8739ae039 = Object.freeze($1c7cd33b6735acef$var$featured_plan_content);


const $22b46a961086eeca$var$paywall = {
    applications: "{{count, number}} application of <planName/> limit reached. Upgrade plan to meet your team’s needs. For any assistance, feel free to <a>contact us</a>.",
    applications_other: "{{count, number}} applications of <planName/> limit reached. Upgrade plan to meet your team’s needs. For any assistance, feel free to <a>contact us</a>.",
    machine_to_machine_feature: "Switch to the <strong>Pro</strong> plan to gain extra machine-to-machine applications and enjoy all premium features. <a>Contact us</a> if you have questions.",
    machine_to_machine: "{{count, number}} machine-to-machine application of <planName/> limit reached. Upgrade plan to meet your team’s needs. For any assistance, feel free to <a>contact us</a>.",
    machine_to_machine_other: "{{count, number}} machine-to-machine applications of <planName/> limit reached. Upgrade plan to meet your team’s needs. For any assistance, feel free to <a>contact us</a>.",
    resources: "{{count, number}} API resource of <planName/> limit reached. Upgrade plan to meet your team’s needs. <a>Contact us</a> for any assistant.",
    resources_other: "{{count, number}} API resources of <planName/> limit reached. Upgrade plan to meet your team’s needs. <a>Contact us</a> for any assistant.",
    scopes_per_resource: "{{count, number}} permission per API resource of <planName/> limit reached. Upgrade now to expand. <a>Contact us</a> for any assistant.",
    scopes_per_resource_other: "{{count, number}} permissions per API resource of <planName/> limit reached. Upgrade now to expand. <a>Contact us</a> for any assistant.",
    custom_domain: "Unlock custom domain functionality by upgrading to <strong>Hobby</strong> or <strong>Pro</strong> plan. Don’t hesitate to <a>contact us</a> if you need any assistance.",
    social_connectors: "{{count, number}} social connector of <planName/> limit reached. To meet your team’s needs, upgrade plan for additional social connectors and the ability to create your own connectors using OIDC, OAuth 2.0, and SAML protocols. Feel free to <a>contact us</a> if you need any assistance.",
    social_connectors_other: "{{count, number}} social connectors of <planName/> limit reached. To meet your team’s needs, upgrade plan for additional social connectors and the ability to create your own connectors using OIDC, OAuth 2.0, and SAML protocols. Feel free to <a>contact us</a> if you need any assistance.",
    standard_connectors_feature: "Upgrade to the <strong>Hobby</strong> or <strong>Pro</strong> plan to create your own connectors using OIDC, OAuth 2.0, and SAML protocols, plus unlimited social connectors and all the premium features. Feel free to <a>contact us</a> if you need any assistance.",
    standard_connectors: "{{count, number}} social connector of <planName/> limit reached. To meet your team’s needs, upgrade plan for additional social connectors and the ability to create your own connectors using OIDC, OAuth 2.0, and SAML protocols. Feel free to <a>contact us</a> if you need any assistance.",
    standard_connectors_other: "{{count, number}} social connectors of <planName/> limit reached. To meet your team’s needs, upgrade plan for additional social connectors and the ability to create your own connectors using OIDC, OAuth 2.0, and SAML protocols. Feel free to <a>contact us</a> if you need any assistance.",
    standard_connectors_pro: "{{count, number}} standard connector of <planName/> limit reached. To meet your team’s needs, upgrade to the Enterprise plan for additional social connectors and the ability to create your own connectors using OIDC, OAuth 2.0, and SAML protocols. Feel free to <a>contact us</a> if you need any assistance.",
    standard_connectors_pro_other: "{{count, number}} standard connectors of <planName/> limit reached. To meet your team’s needs, upgrade to the Enterprise plan for additional social connectors and the ability to create your own connectors using OIDC, OAuth 2.0, and SAML protocols. Feel free to <a>contact us</a> if you need any assistance.",
    roles: "{{count, number}} role of <planName/> limit reached. Upgrade plan to add additional roles and permissions. Feel free to <a>contact us</a> if you need any assistance.",
    roles_other: "{{count, number}} roles of <planName/> limit reached. Upgrade plan to add additional roles and permissions. Feel free to <a>contact us</a> if you need any assistance.",
    machine_to_machine_roles: "{{count, number}} machine-to-machine role of <planName/> limit reached. Upgrade plan to add additional roles and permissions. Feel free to <a>contact us</a> if you need any assistance.",
    machine_to_machine_roles_other: "{{count, number}} machine-to-machine roles of <planName/> limit reached. Upgrade plan to add additional roles and permissions. Feel free to <a>contact us</a> if you need any assistance.",
    scopes_per_role: "{{count, number}} permission per role of <planName/> limit reached. Upgrade plan to add additional roles and permissions. For any assistance, feel free to <a>contact us</a>.",
    scopes_per_role_other: "{{count, number}} permissions per role of <planName/> limit reached. Upgrade plan to add additional roles and permissions. For any assistance, feel free to <a>contact us</a>.",
    hooks: "{{count, number}} webhook of <planName/> limit reached. Upgrade plan to create more webhooks. Feel free to <a>contact us</a> if you need any assistance.",
    hooks_other: "{{count, number}} webhooks of <planName/> limit reached. Upgrade plan to create more webhooks. Feel free to <a>contact us</a> if you need any assistance.",
    mfa: "Unlock MFA to verification security by upgrading to a paid plan. Don’t hesitate to <a>contact us</a> if you need any assistance.",
    organizations: "Unlock organizations by upgrading to a paid plan. Don’t hesitate to <a>contact us</a> if you need any assistance.",
    third_party_apps: "Unlock Logto as IdP for third-party apps by upgrading to a paid plan. For any assistance, feel free to <a>contact us</a>.",
    sso_connectors: "Unlock enterprise sso by upgrading to a paid plan. For any assistance, feel free to <a>contact us</a>.",
    tenant_members: "Unlock collaboration feature by upgrading to a paid plan. For any assistance, feel free to <a>contact us</a>.",
    tenant_members_dev_plan: "You've reached your {{limit}}-member limit. Release a member or revoke a pending invitation to add someone new. Need more seats? Feel free to contact us.",
    custom_jwt: {
        title: "Add custom claims",
        description: "Upgrade to a paid plan for custom JWT functionality and premium benefits. Don't hesitate to <a>contact us</a> if you have any questions."
    }
};
var $22b46a961086eeca$export$2e2bcd8739ae039 = Object.freeze($22b46a961086eeca$var$paywall);


const $ff987918c4198c3d$var$upsell = {
    upgrade_plan: "Upgrade plan",
    compare_plans: "Compare plans",
    view_plans: "View plans",
    create_tenant: {
        title: "Select your tenant plan",
        description: "Logto provides competitive plan options with innovative and affordable pricing designed for growing companies. <a>Learn more</a>",
        base_price: "Base price",
        monthly_price: "{{value, number}}/mo",
        view_all_features: "View all features",
        select_plan: "Select <name/>",
        free_tenants_limit: "Up to {{count, number}} free tenant",
        free_tenants_limit_other: "Up to {{count, number}} free tenants",
        most_popular: "Most popular",
        upgrade_success: "Successfully upgraded to <name/>"
    },
    mau_exceeded_modal: {
        title: "MAU has exceeded the limit. Upgrade your plan.",
        notification: "Your current MAU has exceeded the limit of <planName/>. Please upgrade your plan to premium promptly to avoid suspension of Logto service. ",
        update_plan: "Update Plan"
    },
    payment_overdue_modal: {
        title: "Bill payment overdue",
        notification: "Oops! Payment for tenant <span>{{name}}</span> bill failed. Please pay the bill promptly to avoid suspension of Logto service.",
        unpaid_bills: "Unpaid bills",
        update_payment: "Update Payment"
    },
    add_on_quota_item: {
        api_resource: "API resource",
        machine_to_machine: "machine-to-machine application",
        tokens: "{{limit}}M tokens",
        tenant_member: "tenant member"
    },
    charge_notification_for_quota_limit: "You have surpassed your {{item}} quota limit. Logto will add charges for the usage beyond your quota limit. Charging will commence on the day the new add-on pricing design is released. <a>Learn more</a>",
    paywall: $22b46a961086eeca$export$2e2bcd8739ae039,
    featured_plan_content: $1c7cd33b6735acef$export$2e2bcd8739ae039
};
var $ff987918c4198c3d$export$2e2bcd8739ae039 = Object.freeze($ff987918c4198c3d$var$upsell);


const $6b195ea6c035a05c$var$user_details = {
    page_title: "User details",
    back_to_users: "Back to user management",
    created_title: "This user has been successfully created",
    created_guide: "Here’s the information to assist the user with their sign-in process.",
    created_email: "Email address:",
    created_phone: "Phone number:",
    created_username: "Username:",
    created_password: "Password:",
    menu_delete: "Delete",
    delete_description: "This action cannot be undone. It will permanently delete the user.",
    deleted: "The user has been successfully deleted",
    reset_password: {
        reset_password: "Reset password",
        title: "Are you sure you want to reset the password?",
        content: "This action cannot be undone. This will reset the user's log in information.",
        congratulations: "This user has been reset",
        new_password: "New password:"
    },
    tab_settings: "Settings",
    tab_roles: "Roles",
    tab_logs: "User logs",
    tab_organizations: "Organizations",
    authentication: "Authentication",
    authentication_description: "Each user has a profile containing all user information. It consists of basic data, social identities, and custom data.",
    user_profile: "User data",
    field_email: "Email address",
    field_phone: "Phone number",
    field_username: "Username",
    field_name: "Name",
    field_avatar: "Avatar image URL",
    field_avatar_placeholder: "https://your.cdn.domain/avatar.png",
    field_custom_data: "Custom data",
    field_custom_data_tip: "Additional user info not listed in the pre-defined user properties, such as user-preferred color and language.",
    field_connectors: "Social connections",
    field_sso_connectors: "Enterprise connections",
    custom_data_invalid: "Custom data must be a valid JSON object",
    connectors: {
        connectors: "Connectors",
        user_id: "User ID",
        remove: "Remove",
        connected: "This user is connected with multiple social connectors.",
        not_connected: "The user is not connected to any social connector",
        deletion_confirmation: "You are removing the existing <name/> identity. Are you sure you want to continue?"
    },
    sso_connectors: {
        connectors: "Connectors",
        enterprise_id: "Enterprise ID",
        connected: "This user is connected to multiple enterprise identity providers for Single Sign-On.",
        not_connected: "The user is not connected to any enterprise identity providers for Single Sign-On."
    },
    mfa: {
        field_name: "Multi-factor authentication",
        field_description: "This user has enabled 2-step verification factors.",
        name_column: "Multi-Factor",
        field_description_empty: "This user has not enabled 2-step verification factors.",
        deletion_confirmation: "You are removing the existing <name/> for the 2-step verification. Are you sure you want to continue?"
    },
    suspended: "Suspended",
    suspend_user: "Suspend user",
    suspend_user_reminder: "Are you sure you want to suspend this user? The user will be unable to sign in to your app and won’t be able to obtain a new access token after the current one expires. Additionally, any API requests made by this user will fail.",
    suspend_action: "Suspend",
    user_suspended: "User has been suspended.",
    reactivate_user: "Reactivate user",
    reactivate_user_reminder: "Are you sure you want to reactivate this user? Doing so will permit any sign-in attempts for this user.",
    reactivate_action: "Reactivate",
    user_reactivated: "User has been reactivated.",
    roles: {
        name_column: "Role",
        description_column: "Description",
        assign_button: "Assign roles",
        delete_description: "This action will remove this role from this user. The role itself will still exist, but it will no longer be associated with this user.",
        deleted: "{{name}} was successfully removed from this user.",
        assign_title: "Assign roles to {{name}}",
        assign_subtitle: "Authorize {{name}} one or more roles",
        assign_role_field: "Assign roles",
        role_search_placeholder: "Search by role name",
        added_text: "{{value, number}} added",
        assigned_user_count: "{{value, number}} users",
        confirm_assign: "Assign roles",
        role_assigned: "Successfully assigned role(s)",
        search: "Search by role name, description or ID",
        empty: "No role available"
    },
    warning_no_sign_in_identifier: "User needs to have at least one of the sign-in identifiers (username, email, phone number or social) to sign in. Are you sure you want to continue?",
    organization_roles_tooltip: "The roles assigned to the user within this organization."
};
var $6b195ea6c035a05c$export$2e2bcd8739ae039 = Object.freeze($6b195ea6c035a05c$var$user_details);


const $bde81837a54a2a67$var$users = {
    page_title: "User management",
    title: "User management",
    subtitle: "Manage user identities including creating users, editing user information, viewing user logs, password resets and deleting users",
    create: "Add user",
    create_subtitle: "Provide at least one of the following fields to proceed.",
    error_missing_identifier: "You must provide at least one identifier to create a user.",
    user_name: "User",
    application_name: "From application",
    latest_sign_in: "Latest sign in",
    create_form_username: "Username",
    create_form_password: "Password",
    create_form_name: "Full name",
    placeholder_name: "John/Jane Doe",
    placeholder_email: "jdoe@example.com",
    placeholder_username: "user123",
    placeholder_phone: "+1 (555) 555-5555",
    unnamed: "Unnamed",
    search: "Search by name, email, phone or username",
    check_user_detail: "Check user detail",
    placeholder_title: "User management",
    placeholder_description: "Each user has a profile containing all user information. It consists of basic data, social identities, and custom data."
};
var $bde81837a54a2a67$export$2e2bcd8739ae039 = Object.freeze($bde81837a54a2a67$var$users);


const $384a0435961318a5$var$webhook_details = {
    page_title: "Webhook details",
    back_to_webhooks: "Back to webhooks",
    not_in_use: "Not in use",
    success_rate: "success rate",
    requests: "{{value, number}} requests in 24h",
    disable_webhook: "Disable webhook",
    disable_reminder: "Are you sure you want to reactivate this webhook? Doing so will not send HTTP request to endpoint URL.",
    webhook_disabled: "The webhook has been disabled.",
    webhook_reactivated: "The webhook has been reactivated.",
    reactivate_webhook: "Reactivate webhook",
    delete_webhook: "Delete webhook",
    deletion_reminder: "You are removing this webhook. After deleting it will not send HTTP request to endpoint URL.",
    deleted: "The webhook has been successfully deleted.",
    settings_tab: "Settings",
    recent_requests_tab: "Recent requests (24h)",
    settings: {
        settings: "Settings",
        settings_description: "Webhooks allow you to receive real-time updates on specific events as they happen, by sending a POST request to your endpoint URL. This enables you to take immediate actions based on the new information received.",
        events: "Events",
        events_description: "Select the trigger events which Logto will send the POST request.",
        name: "Name",
        endpoint_url: "Endpoint URL",
        signing_key: "Signing key",
        signing_key_tip: "Add the secret key provided by Logto to your endpoint as a request header to ensure the authenticity of the webhook’s payload.",
        regenerate: "Regenerate",
        regenerate_key_title: "Regenerate signing key",
        regenerate_key_reminder: "Are you sure you want to modify the signing key? Regenerating it will take effect immediately. Please remember to modify the signing key synchronously in your endpoint.",
        regenerated: "Signing key has been regenerated.",
        custom_headers: "Custom headers",
        custom_headers_tip: "Optionally, you can add custom headers to the webhook’s payload to provide additional context or metadata about the event.",
        key_duplicated_error: "Key cannot be repeated.",
        key_missing_error: "Key is required.",
        value_missing_error: "Value is required.",
        invalid_key_error: "Key is invalid",
        invalid_value_error: "Value is invalid",
        test: "Test",
        test_webhook: "Test your webhook",
        test_webhook_description: "Configure the webhook, and test it with payload examples for each selected event to verify correct reception and processing.",
        send_test_payload: "Send test payload",
        test_result: {
            endpoint_url: "Endpoint URL: {{url}}",
            message: "Message: {{message}}",
            response_status: "Response status: {{status, number}}",
            response_body: "Response body: {{body}}",
            request_time: "Request time: {{time}}",
            test_success: "The webhook test to the endpoint was successful."
        }
    }
};
var $384a0435961318a5$export$2e2bcd8739ae039 = Object.freeze($384a0435961318a5$var$webhook_details);


const $2e5dd14d99da9385$var$webhooks = {
    page_title: "Webhooks",
    title: "Webhooks",
    subtitle: "Create webhooks to effortlessly receive real-time updates regarding specific events.",
    create: "Create Webhook",
    schemas: {
        interaction: "User interaction",
        user: "User",
        organization: "Organization",
        role: "Role",
        scope: "Permission",
        organization_role: "Organization role",
        organization_scope: "Organization permission"
    },
    table: {
        name: "Name",
        events: "Events",
        success_rate: "Success rate (24h)",
        requests: "Requests (24h)"
    },
    placeholder: {
        title: "Webhook",
        description: 'Create a webhook to receive real-time updates through POST requests to your endpoint URL. Stay informed and take immediate action on events like "Create account", "Sign in", and "Reset password".',
        create_webhook: "Create Webhook"
    },
    create_form: {
        title: "Create Webhook",
        subtitle: "Add the Webhook to send a POST request to the endpoint URL with details of any users events.",
        events: "Events",
        events_description: "Select the trigger events which Logto will send the POST request.",
        name: "Name",
        name_placeholder: "Enter webhook name",
        endpoint_url: "Endpoint URL",
        endpoint_url_placeholder: "https://your.webhook.endpoint.url",
        endpoint_url_tip: "Enter the URL of your endpoint where a webhook’s payload is sent to when the event occurs.",
        create_webhook: "Create webhook",
        missing_event_error: "You have to select at least one event."
    },
    webhook_created: "The webhook {{name}} has been successfully created."
};
var $2e5dd14d99da9385$export$2e2bcd8739ae039 = Object.freeze($2e5dd14d99da9385$var$webhooks);


const $42a4f2c2fe529b7d$var$welcome = {
    title: "Welcome to Admin Console",
    description: "Admin console is a web app to manage Logto without coding requirements. Let’s first create an account. With this account, you can manage Logto by yourself or on behalf of your company.",
    create_account: "Create account"
};
var $42a4f2c2fe529b7d$export$2e2bcd8739ae039 = Object.freeze($42a4f2c2fe529b7d$var$welcome);


const $70182e72ddc9142e$var$admin_console = {
    title: "Admin Console",
    admin_user: "Admin",
    system_app: "System",
    menu: $d4851cad2b34e388$export$2e2bcd8739ae039,
    general: $f7c4443375742524$export$2e2bcd8739ae039,
    errors: $3014aa997d6ff55a$export$2e2bcd8739ae039,
    tab_sections: $fb390a857a4193cc$export$2e2bcd8739ae039,
    tabs: $94b76f70a15b89ec$export$2e2bcd8739ae039,
    applications: $57ecae383e3973da$export$2e2bcd8739ae039,
    application_details: $c432b2cb821ec1d8$export$2e2bcd8739ae039,
    api_resources: $056b526c438e8a45$export$2e2bcd8739ae039,
    api_resource_details: $74c3a149572daffd$export$2e2bcd8739ae039,
    connectors: $5f659c81177b6b3b$export$2e2bcd8739ae039,
    connector_details: $fdfa540e90378d32$export$2e2bcd8739ae039,
    enterprise_sso: $4c00699edda4a863$export$2e2bcd8739ae039,
    enterprise_sso_details: $87824b7d88e63a23$export$2e2bcd8739ae039,
    get_started: $8e05ee2f8d248676$export$2e2bcd8739ae039,
    users: $bde81837a54a2a67$export$2e2bcd8739ae039,
    user_details: $6b195ea6c035a05c$export$2e2bcd8739ae039,
    contact: $04e16c04872158f5$export$2e2bcd8739ae039,
    sign_in_exp: $610f6e1e04680ee1$export$2e2bcd8739ae039,
    dashboard: $a3e243f9d33e7d28$export$2e2bcd8739ae039,
    logs: $451f4545cccf8ead$export$2e2bcd8739ae039,
    log_details: $208a2d7fbeccd7c0$export$2e2bcd8739ae039,
    session_expired: $10ef3b341d550b0d$export$2e2bcd8739ae039,
    welcome: $42a4f2c2fe529b7d$export$2e2bcd8739ae039,
    roles: $e45b6e6f6a707aa2$export$2e2bcd8739ae039,
    role_details: $02b243f20407cb56$export$2e2bcd8739ae039,
    permissions: $0292350d6bc9631f$export$2e2bcd8739ae039,
    cloud: $ab5df1c152c3cacb$export$2e2bcd8739ae039,
    profile: $661d83f551ce569b$export$2e2bcd8739ae039,
    components: $917f1672a74fdea1$export$2e2bcd8739ae039,
    webhooks: $2e5dd14d99da9385$export$2e2bcd8739ae039,
    webhook_details: $384a0435961318a5$export$2e2bcd8739ae039,
    domain: $adac7c05d4552c6c$export$2e2bcd8739ae039,
    tenants: $87658ee8bf00d32f$export$2e2bcd8739ae039,
    tenant_members: $a76df04dce20d9c7$export$2e2bcd8739ae039,
    topbar: $a279ca79a0f30880$export$2e2bcd8739ae039,
    subscription: $8dfa1777ef80f4d7$export$2e2bcd8739ae039,
    upsell: $ff987918c4198c3d$export$2e2bcd8739ae039,
    guide: $9678b69467a97cbc$export$2e2bcd8739ae039,
    mfa: $9968929c0a472728$export$2e2bcd8739ae039,
    organizations: $eda45e7cc056d54d$export$2e2bcd8739ae039,
    organization_details: $6120082d6cfbceff$export$2e2bcd8739ae039,
    protected_app: $c35ed7437a5ab71f$export$2e2bcd8739ae039,
    jwt_claims: $1f77ceb8ce3fe670$export$2e2bcd8739ae039,
    invitation: $638da913d12c7f02$export$2e2bcd8739ae039,
    signing_keys: $70a5b1c65790e496$export$2e2bcd8739ae039,
    organization_template: $a8457222812f5e69$export$2e2bcd8739ae039,
    organization_role_details: $3dbbdc7784df70d5$export$2e2bcd8739ae039
};
var $70182e72ddc9142e$export$2e2bcd8739ae039 = Object.freeze($70182e72ddc9142e$var$admin_console);


const $730032d59b6a7e5e$var$demo_app = {
    title: "You've successfully signed in the live preview!",
    subtitle: "Here is your log in information:",
    username: "Username: ",
    user_id: "User ID: ",
    sign_out: "Sign out the live preview",
    continue_explore: "Or continue to explore",
    customize_sign_in_experience: "Customize sign-in experience",
    enable_passwordless: "Enable passwordless",
    add_social_connector: "Add social connector"
};
var $730032d59b6a7e5e$export$2e2bcd8739ae039 = Object.freeze($730032d59b6a7e5e$var$demo_app);


const $55451b90631761bb$var$oidc = {
    logout_success: "You have successfully signed out."
};
var $55451b90631761bb$export$2e2bcd8739ae039 = Object.freeze($55451b90631761bb$var$oidc);


const $c114ce07c938a2e3$var$translation = {
    admin_console: $70182e72ddc9142e$export$2e2bcd8739ae039,
    demo_app: $730032d59b6a7e5e$export$2e2bcd8739ae039,
    oidc: $55451b90631761bb$export$2e2bcd8739ae039
};
var $c114ce07c938a2e3$export$2e2bcd8739ae039 = Object.freeze($c114ce07c938a2e3$var$translation);


const $1cf82157fc13542a$var$en = {
    translation: $c114ce07c938a2e3$export$2e2bcd8739ae039,
    errors: $64068e123411e8cd$export$2e2bcd8739ae039
};
var $1cf82157fc13542a$export$2e2bcd8739ae039 = Object.freeze($1cf82157fc13542a$var$en);


const $274a1402fb92fb2b$var$application = {
    invalid_type: "Solo las aplicaciones de m\xe1quina a m\xe1quina pueden tener roles asociados.",
    role_exists: "La identificaci\xf3n del rol {{roleId}} ya se ha agregado a esta aplicaci\xf3n.",
    invalid_role_type: "No se puede asignar un rol de tipo usuario a una aplicaci\xf3n de m\xe1quina a m\xe1quina.",
    invalid_third_party_application_type: "Solo las aplicaciones web tradicionales pueden ser marcadas como una aplicaci\xf3n de terceros.",
    third_party_application_only: "La funci\xf3n solo est\xe1 disponible para aplicaciones de terceros.",
    user_consent_scopes_not_found: "\xc1mbitos de consentimiento de usuario no v\xe1lidos.",
    consent_management_api_scopes_not_allowed: "Los \xe1mbitos de la API de administraci\xf3n no est\xe1n permitidos.",
    protected_app_metadata_is_required: "Se requiere metadatos de aplicaci\xf3n protegida.",
    protected_app_not_configured: "El proveedor de aplicaci\xf3n protegida no est\xe1 configurado. Esta funci\xf3n no est\xe1 disponible para la versi\xf3n de c\xf3digo abierto.",
    cloudflare_unknown_error: "Se produjo un error desconocido al solicitar la API de Cloudflare",
    protected_application_only: "La funci\xf3n solo est\xe1 disponible para aplicaciones protegidas.",
    protected_application_misconfigured: "La aplicaci\xf3n protegida est\xe1 mal configurada.",
    protected_application_subdomain_exists: "El subdominio de la aplicaci\xf3n protegida ya est\xe1 en uso.",
    invalid_subdomain: "Subdominio no v\xe1lido.",
    custom_domain_not_found: "Dominio personalizado no encontrado.",
    should_delete_custom_domains_first: "Debe eliminar primero los dominios personalizados."
};
var $274a1402fb92fb2b$export$2e2bcd8739ae039 = Object.freeze($274a1402fb92fb2b$var$application);


const $394029565ee4c19e$var$auth = {
    authorization_header_missing: "Falta encabezado de autorizaci\xf3n.",
    authorization_token_type_not_supported: "Tipo de autorizaci\xf3n no admitido.",
    unauthorized: "No autorizado. Por favor, revise las credenciales y su alcance.",
    forbidden: "Prohibido. Por favor, revise sus roles y permisos de usuario.",
    expected_role_not_found: "Rol esperado no encontrado. Por favor, revise sus roles y permisos de usuario.",
    jwt_sub_missing: "Falta `sub` en JWT.",
    require_re_authentication: "Se requiere una nueva autenticaci\xf3n para realizar una acci\xf3n protegida."
};
var $394029565ee4c19e$export$2e2bcd8739ae039 = Object.freeze($394029565ee4c19e$var$auth);


const $fe708372218c1438$var$connector = {
    general: "Se produjo un error en el conector: {{errorDescription}}",
    not_found: "No se puede encontrar ning\xfan conector disponible para el tipo: {{type}}.",
    not_enabled: "El conector no est\xe1 habilitado.",
    invalid_metadata: "Los metadatos del conector son inv\xe1lidos.",
    invalid_config_guard: "El guardia de configuraci\xf3n del conector es inv\xe1lido.",
    unexpected_type: "El tipo del conector es inesperado.",
    invalid_request_parameters: "La solicitud contiene par\xe1metros de entrada incorrectos.",
    insufficient_request_parameters: "La solicitud puede faltar algunos par\xe1metros de entrada.",
    invalid_config: "La configuraci\xf3n del conector es inv\xe1lida.",
    invalid_certificate: "El certificado del conector es inv\xe1lido, por favor aseg\xfarese de que el certificado est\xe9 codificado en PEM.",
    invalid_response: "La respuesta del conector es inv\xe1lida.",
    template_not_found: "No se puede encontrar la plantilla correcta en la configuraci\xf3n del conector.",
    template_not_supported: "El conector no admite este tipo de plantilla.",
    rate_limit_exceeded: "L\xedmite de frecuencia activado. Por favor, int\xe9ntalo de nuevo m\xe1s tarde.",
    not_implemented: "{{method}}: a\xfan no se ha implementado.",
    social_invalid_access_token: "El token de acceso del conector es inv\xe1lido.",
    invalid_auth_code: "El c\xf3digo de autenticaci\xf3n del conector es inv\xe1lido.",
    social_invalid_id_token: "El token de identificaci\xf3n del conector es inv\xe1lido.",
    authorization_failed: "El proceso de autorizaci\xf3n del usuario no tuvo \xe9xito.",
    social_auth_code_invalid: "No se puede obtener el token de acceso, por favor revise el c\xf3digo de autorizaci\xf3n.",
    more_than_one_sms: "El n\xfamero de conectores de SMS es mayor que 1.",
    more_than_one_email: "El n\xfamero de conectores de correo electr\xf3nico es mayor que 1.",
    more_than_one_connector_factory: "Se encontraron m\xfaltiples f\xe1bricas de conectores (con ID {{connectorIds}}), puede desinstalar las innecesarias.",
    db_connector_type_mismatch: "Hay un conector en la base de datos que no coincide con el tipo.",
    not_found_with_connector_id: "No se puede encontrar el conector con el ID est\xe1ndar de conector proporcionado.",
    multiple_instances_not_supported: "No se pueden crear m\xfaltiples instancias con el conector est\xe1ndar seleccionado.",
    invalid_type_for_syncing_profile: "Solo puede sincronizar el perfil de usuario con conectores sociales.",
    can_not_modify_target: "No se puede modificar el 'objetivo' del conector.",
    should_specify_target: "Debe especificar el 'objetivo'.",
    multiple_target_with_same_platform: "No puede tener m\xfaltiples conectores sociales que tengan el mismo objetivo y plataforma.",
    cannot_overwrite_metadata_for_non_standard_connector: "Los 'metadatos' de este conector no se pueden sobrescribir."
};
var $fe708372218c1438$export$2e2bcd8739ae039 = Object.freeze($fe708372218c1438$var$connector);


const $6951c9ee4b366c49$var$domain = {
    not_configured: "El proveedor de nombres de dominio del host no est\xe1 configurado.",
    cloudflare_data_missing: "cloudflare_data falta, por favor revise.",
    cloudflare_unknown_error: "Se produjo un error desconocido al solicitar la API de Cloudflare",
    cloudflare_response_error: "Recibi\xf3 una respuesta inesperada de Cloudflare.",
    limit_to_one_domain: "Solo puedes tener un dominio personalizado.",
    hostname_already_exists: "Este dominio ya existe en nuestro servidor.",
    cloudflare_not_found: "No se puede encontrar el nombre de host en Cloudflare",
    domain_is_not_allowed: "Este dominio no est\xe1 permitido."
};
var $6951c9ee4b366c49$export$2e2bcd8739ae039 = Object.freeze($6951c9ee4b366c49$var$domain);


const $42a6b00e136db96c$var$entity = {
    invalid_input: "Entrada no v\xe1lida. La lista de valores no debe estar vac\xeda.",
    create_failed: "Fallo al crear {{name}}.",
    db_constraint_violated: "Violaci\xf3n de restricci\xf3n de base de datos.",
    not_exists: "El {{name}} no existe.",
    not_exists_with_id: "El {{name}} con ID `{{id}}` no existe.",
    not_found: "El recurso no existe.",
    relation_foreign_key_not_found: "No se pueden encontrar una o m\xe1s claves for\xe1neas. Por favor, verifique la entrada y aseg\xfarese de que todas las entidades referenciadas existan.",
    unique_integrity_violation: "La entidad ya existe. Por favor, verifique la entrada e intente\\lo de nuevo."
};
var $42a6b00e136db96c$export$2e2bcd8739ae039 = Object.freeze($42a6b00e136db96c$var$entity);


const $195ca26cd221924e$var$guard = {
    invalid_input: "La solicitud {{type}} es inv\xe1lida.",
    invalid_pagination: "El valor de paginaci\xf3n de la solicitud es inv\xe1lido.",
    can_not_get_tenant_id: "No se puede obtener el ID del inquilino de la solicitud.",
    file_size_exceeded: "Se excedi\xf3 el tama\xf1o del archivo.",
    mime_type_not_allowed: "El tipo MIME no est\xe1 permitido."
};
var $195ca26cd221924e$export$2e2bcd8739ae039 = Object.freeze($195ca26cd221924e$var$guard);


const $352c16b084b7bb00$var$hook = {
    missing_events: "Necesita proporcionar al menos un evento.",
    send_test_payload_failed: "Error al enviar carga \xfatil de prueba: {{message}}",
    endpoint_responded_with_error: "El punto de enlace respondi\xf3 con un error."
};
var $352c16b084b7bb00$export$2e2bcd8739ae039 = Object.freeze($352c16b084b7bb00$var$hook);


const $af13a352e3580880$var$jwt_customizer = {
    general: "Ocurri\xf3 un error al personalizar el token JWT. Por favor, int\xe9ntalo de nuevo m\xe1s tarde.",
    can_not_create_for_admin_tenant: "No se puede crear un personalizador de token JWT para el inquilino de administrador."
};
var $af13a352e3580880$export$2e2bcd8739ae039 = Object.freeze($af13a352e3580880$var$jwt_customizer);


const $a3adff3c8c350d26$var$localization = {
    cannot_delete_default_language: "{{languageTag}} est\xe1 establecido como tu idioma predeterminado y no se puede eliminar.",
    invalid_translation_structure: "Estructuras de datos no v\xe1lidas. Por favor, verifica tu entrada e intenta de nuevo."
};
var $a3adff3c8c350d26$export$2e2bcd8739ae039 = Object.freeze($a3adff3c8c350d26$var$localization);


const $deb93b8f0dbfcdab$var$log = {
    invalid_type: "El tipo de registro es inv\xe1lido."
};
var $deb93b8f0dbfcdab$export$2e2bcd8739ae039 = Object.freeze($deb93b8f0dbfcdab$var$log);


const $ad1ff2709f2f3095$var$oidc = {
    aborted: "El usuario final abort\xf3 la interacci\xf3n.",
    invalid_scope: "\xc1mbito no v\xe1lido: {{error_description}}.",
    invalid_token: "Se proporcion\xf3 un token no v\xe1lido.",
    invalid_client_metadata: "Se proporcionaron metadatos de cliente no v\xe1lidos.",
    insufficient_scope: "Falta el \xe1mbito del token `{{scope}}`.",
    invalid_request: "La solicitud no es v\xe1lida.",
    invalid_grant: "La concesi\xf3n no es v\xe1lida.",
    invalid_redirect_uri: "La `redirect_uri` no coincide con ninguna de las `redirect_uris` registradas del cliente.",
    access_denied: "Acceso denegado.",
    invalid_target: "Indicador de recurso no v\xe1lido.",
    unsupported_grant_type: "Se solicit\xf3 un tipo de concesi\xf3n no admitido.",
    unsupported_response_mode: "Se solicit\xf3 un modo de respuesta no compatible.",
    unsupported_response_type: "Se solicit\xf3 un tipo de respuesta no admitido.",
    provider_error: "Error interno de OIDC: {{message}}.",
    server_error: "Ocurri\xf3 un error desconocido de OIDC. Por favor, int\xe9ntelo de nuevo m\xe1s tarde.",
    provider_error_fallback: "Ocurri\xf3 un error de OIDC: {{code}}.",
    key_required: "Se requiere al menos una clave.",
    key_not_found: "No se encuentra la clave con ID {{id}}."
};
var $ad1ff2709f2f3095$export$2e2bcd8739ae039 = Object.freeze($ad1ff2709f2f3095$var$oidc);


const $c12b5fa6e1f15342$var$organization = {
    require_membership: "El usuario debe ser miembro de la organizaci\xf3n para continuar."
};
var $c12b5fa6e1f15342$export$2e2bcd8739ae039 = Object.freeze($c12b5fa6e1f15342$var$organization);


const $bc0f02b49fdd7e02$var$password = {
    unsupported_encryption_method: "El m\xe9todo de encriptaci\xf3n {{name}} no es compatible.",
    pepper_not_found: "No se encontr\xf3 el password pepper. Por favor revisa tus variables de entorno.",
    rejected: "Contrase\xf1a rechazada. Por favor verifica que tu contrase\xf1a cumpla con los requisitos."
};
var $bc0f02b49fdd7e02$export$2e2bcd8739ae039 = Object.freeze($bc0f02b49fdd7e02$var$password);


const $3c4430a9465b7e26$var$request = {
    invalid_input: "La entrada no es v\xe1lida. {{detalles}}",
    general: "Ocurri\xf3 un error en la solicitud."
};
var $3c4430a9465b7e26$export$2e2bcd8739ae039 = Object.freeze($3c4430a9465b7e26$var$request);


const $dd1d2537f3f720df$var$resource = {
    resource_identifier_in_use: '"El identificador de API {{indicator}} ya est\xe1 en uso',
    cannot_delete_management_api: "No se puede eliminar la API de administraci\xf3n de Logto.",
    cannot_modify_management_api: "No se puede modificar la API de administraci\xf3n de Logto."
};
var $dd1d2537f3f720df$export$2e2bcd8739ae039 = Object.freeze($dd1d2537f3f720df$var$resource);


const $cb9acb3247b6b074$var$role = {
    name_in_use: "Este nombre de rol {{name}} ya est\xe1 en uso",
    scope_exists: "El id de alcance {{scopeId}} ya ha sido agregado a este rol",
    management_api_scopes_not_assignable_to_user_role: "No se pueden asignar alcances de API de gesti\xf3n a un rol de usuario.",
    user_exists: "El id de usuario {{userId}} ya ha sido agregado a este rol",
    application_exists: "El id de aplicaci\xf3n {{applicationId}} ya ha sido agregado a este rol",
    default_role_missing: "Algunos de los nombres de roles predeterminados no existen en la base de datos, por favor aseg\xfarese de crear los roles primero",
    internal_role_violation: 'Tal vez est\xe9 intentando actualizar o eliminar un rol interno lo cual es prohibido por Logto. Si est\xe1 creando un nuevo rol, intente con otro nombre que no empiece con "#internal:".'
};
var $cb9acb3247b6b074$export$2e2bcd8739ae039 = Object.freeze($cb9acb3247b6b074$var$role);


const $2b70263ef088e658$var$scope = {
    name_exists: "El nombre del \xe1mbito {{name}} ya est\xe1 en uso",
    name_with_space: "El nombre del \xe1mbito no puede contener espacios."
};
var $2b70263ef088e658$export$2e2bcd8739ae039 = Object.freeze($2b70263ef088e658$var$scope);


const $12510696e34c9a36$var$session = {
    not_found: "Sesi\xf3n no encontrada. Vuelva atr\xe1s e inicie sesi\xf3n nuevamente.",
    invalid_credentials: "Cuenta o contrase\xf1a incorrecta. Verifique su entrada.",
    invalid_sign_in_method: "El m\xe9todo de inicio de sesi\xf3n actual no est\xe1 disponible.",
    invalid_connector_id: "No se puede encontrar un conector disponible con el id {{connectorId}}.",
    insufficient_info: "Informaci\xf3n de inicio de sesi\xf3n insuficiente.",
    connector_id_mismatch: "El identificador del conector no coincide con el registro de la sesi\xf3n.",
    connector_session_not_found: "No se encuentra la sesi\xf3n del conector. Vuelva atr\xe1s e inicie sesi\xf3n nuevamente.",
    verification_session_not_found: "La verificaci\xf3n no se complet\xf3 correctamente. Reinicie el flujo de verificaci\xf3n e intente de nuevo.",
    verification_expired: "La conexi\xf3n ha expirado. Verifique de nuevo para garantizar la seguridad de su cuenta.",
    verification_blocked_too_many_attempts: "Demasiados intentos en poco tiempo. Por favor, int\xe9ntelo de nuevo {{relativeTime}}.",
    unauthorized: "Inicie sesi\xf3n primero, por favor.",
    unsupported_prompt_name: "Nombre de indicaci\xf3n no compatible.",
    forgot_password_not_enabled: "Olvid\xe9 la contrase\xf1a no est\xe1 habilitada.",
    verification_failed: "La verificaci\xf3n no se complet\xf3 correctamente. Reinicie el flujo de verificaci\xf3n e intente de nuevo.",
    connector_validation_session_not_found: "No se encuentra la sesi\xf3n del conector para la validaci\xf3n del token.",
    identifier_not_found: "Identificador de usuario no encontrado. Vuelva atr\xe1s e inicie sesi\xf3n nuevamente.",
    interaction_not_found: "No se encuentra la sesi\xf3n de interacci\xf3n. Vuelva atr\xe1s y vuelva a iniciar la sesi\xf3n.",
    not_supported_for_forgot_password: "Esta operaci\xf3n no es compatible para restablecer la contrase\xf1a.",
    mfa: {
        require_mfa_verification: "Se requiere verificaci\xf3n de MFA para iniciar sesi\xf3n.",
        mfa_sign_in_only: "MFA solo est\xe1 disponible para la interacci\xf3n de inicio de sesi\xf3n.",
        pending_info_not_found: "Informaci\xf3n de MFA pendiente no encontrada, por favor inicie MFA primero.",
        invalid_totp_code: "C\xf3digo TOTP no v\xe1lido.",
        webauthn_verification_failed: "Fallo en la verificaci\xf3n de WebAuthn.",
        webauthn_verification_not_found: "Verificaci\xf3n de WebAuthn no encontrada.",
        bind_mfa_existed: "MFA ya existe.",
        backup_code_can_not_be_alone: "El c\xf3digo de respaldo no puede ser el \xfanico MFA.",
        backup_code_required: "Se requiere el c\xf3digo de respaldo.",
        invalid_backup_code: "C\xf3digo de respaldo no v\xe1lido.",
        mfa_policy_not_user_controlled: "La pol\xedtica de MFA no est\xe1 controlada por el usuario."
    },
    sso_enabled: "El inicio de sesi\xf3n \xfanico est\xe1 habilitado para este correo electr\xf3nico dado. Inicie sesi\xf3n con SSO, por favor."
};
var $12510696e34c9a36$export$2e2bcd8739ae039 = Object.freeze($12510696e34c9a36$var$session);


const $b23f9bd93b1f5449$var$sign_in_experiences = {
    empty_content_url_of_terms_of_use: 'URL de contenido vac\xedo de "T\xe9rminos de uso". Por favor, agregue la URL de contenido si "T\xe9rminos de uso" est\xe1 habilitado.',
    empty_social_connectors: "Conectores sociales vac\xedos. Por favor, agregue conectores sociales habilitados cuando se habilita el m\xe9todo de inicio de sesi\xf3n social.",
    enabled_connector_not_found: "No se encontr\xf3 el conector {{type}} habilitado.",
    not_one_and_only_one_primary_sign_in_method: "Debe haber un \xfanico m\xe9todo de inicio de sesi\xf3n primario. Por favor revise su entrada.",
    username_requires_password: "Debe habilitar la configuraci\xf3n de contrase\xf1a para el identificador de registro de nombre de usuario.",
    passwordless_requires_verify: "Debe habilitar la verificaci\xf3n para el identificador de registro de correo electr\xf3nico/n\xfamero de tel\xe9fono.",
    miss_sign_up_identifier_in_sign_in: "Los m\xe9todos de inicio de sesi\xf3n deben contener el identificador de registro.",
    password_sign_in_must_be_enabled: "La firma de contrase\xf1a debe estar habilitada cuando se requiere una contrase\xf1a en el registro.",
    code_sign_in_must_be_enabled: "La firma de c\xf3digo de verificaci\xf3n debe estar habilitada cuando no se requiere contrase\xf1a en el registro.",
    unsupported_default_language: "Este lenguaje - {{language}} no es compatible en este momento.",
    at_least_one_authentication_factor: "Debe seleccionar al menos un factor de autenticaci\xf3n.",
    backup_code_cannot_be_enabled_alone: "El c\xf3digo de respaldo no se puede habilitar solo.",
    duplicated_mfa_factors: "Factores MFA duplicados."
};
var $b23f9bd93b1f5449$export$2e2bcd8739ae039 = Object.freeze($b23f9bd93b1f5449$var$sign_in_experiences);


const $514cafef22ff3978$var$single_sign_on = {
    forbidden_domains: "Los dominios de correo electr\xf3nico p\xfablico no est\xe1n permitidos.",
    duplicated_domains: "Hay dominios duplicados.",
    invalid_domain_format: "Formato de dominio no v\xe1lido.",
    duplicate_connector_name: "El nombre del conector ya existe. Por favor elige un nombre diferente."
};
var $514cafef22ff3978$export$2e2bcd8739ae039 = Object.freeze($514cafef22ff3978$var$single_sign_on);


const $547d36f71f20ed7d$var$storage = {
    not_configured: "Proveedor de almacenamiento no est\xe1 configurado.",
    missing_parameter: "Falta el par\xe1metro {{parameter}} para el proveedor de almacenamiento.",
    upload_error: "Error al cargar el archivo al proveedor de almacenamiento."
};
var $547d36f71f20ed7d$export$2e2bcd8739ae039 = Object.freeze($547d36f71f20ed7d$var$storage);


const $a1ca92d76a257619$var$subscription = {
    limit_exceeded: "Has alcanzado el l\xedmite de tu plan de suscripci\xf3n.",
    get_plan_failed: "No se pudo obtener el plan de suscripci\xf3n para el inquilino.",
    tenant_suspended: "El inquilino est\xe1 suspendido. Por favor, contacta con tu administrador."
};
var $a1ca92d76a257619$export$2e2bcd8739ae039 = Object.freeze($a1ca92d76a257619$var$subscription);


const $afb65326823e6f8e$var$swagger = {
    invalid_zod_type: "Tipo Zod inv\xe1lido. Por favor, verifique la configuraci\xf3n del guardia de ruta.",
    not_supported_zod_type_for_params: "Tipo Zod no soportado para los par\xe1metros. Por favor, verifique la configuraci\xf3n del guardia de ruta."
};
var $afb65326823e6f8e$export$2e2bcd8739ae039 = Object.freeze($afb65326823e6f8e$var$swagger);


const $34fef5ceceba4bb8$var$user = {
    username_already_in_use: "Este nombre de usuario ya est\xe1 en uso.",
    email_already_in_use: "Este correo electr\xf3nico est\xe1 asociado a una cuenta existente.",
    phone_already_in_use: "Este n\xfamero de tel\xe9fono est\xe1 asociado a una cuenta existente.",
    invalid_email: "Direcci\xf3n de correo electr\xf3nico inv\xe1lida.",
    invalid_phone: "N\xfamero de tel\xe9fono inv\xe1lido.",
    email_not_exist: "La direcci\xf3n de correo electr\xf3nico no ha sido registrada a\xfan.",
    phone_not_exist: "El n\xfamero de tel\xe9fono no ha sido registrado a\xfan.",
    identity_not_exist: "La cuenta social no ha sido registrada a\xfan.",
    identity_already_in_use: "La cuenta social ha sido asociada a una cuenta existente.",
    social_account_exists_in_profile: "Ya has asociado esta cuenta social.",
    cannot_delete_self: "No puedes eliminarte a ti mismo.",
    sign_up_method_not_enabled: "Este m\xe9todo de registro no est\xe1 habilitado.",
    sign_in_method_not_enabled: "Este m\xe9todo de inicio de sesi\xf3n no est\xe1 habilitado.",
    same_password: "La nueva contrase\xf1a no puede ser igual a la anterior.",
    password_required_in_profile: "Debes establecer una contrase\xf1a antes de iniciar sesi\xf3n.",
    new_password_required_in_profile: "Debes establecer una nueva contrase\xf1a.",
    password_exists_in_profile: "La contrase\xf1a ya existe en tu perfil.",
    username_required_in_profile: "Debes establecer un nombre de usuario antes de iniciar sesi\xf3n.",
    username_exists_in_profile: "El nombre de usuario ya existe en tu perfil.",
    email_required_in_profile: "Debes agregar una direcci\xf3n de correo electr\xf3nico antes de iniciar sesi\xf3n.",
    email_exists_in_profile: "Tu perfil ya est\xe1 asociado a una direcci\xf3n de correo electr\xf3nico.",
    phone_required_in_profile: "Debes agregar un n\xfamero de tel\xe9fono antes de iniciar sesi\xf3n.",
    phone_exists_in_profile: "Tu perfil ya est\xe1 asociado a un n\xfamero de tel\xe9fono.",
    email_or_phone_required_in_profile: "Debes agregar una direcci\xf3n de correo electr\xf3nico o un n\xfamero de tel\xe9fono antes de iniciar sesi\xf3n.",
    suspended: "Esta cuenta ha sido suspendida.",
    user_not_exist: "No existe un usuario con {{ identifier }}.",
    missing_profile: "Debes proporcionar informaci\xf3n adicional antes de iniciar sesi\xf3n.",
    role_exists: "El id de rol {{roleId}} ya ha sido agregado a este usuario",
    invalid_role_type: "Tipo de rol no v\xe1lido, no se puede asignar un rol de m\xe1quina a m\xe1quina a un usuario.",
    missing_mfa: "Debes vincular un MFA adicional antes de iniciar sesi\xf3n.",
    totp_already_in_use: "TOTP ya est\xe1 en uso.",
    backup_code_already_in_use: "El c\xf3digo de respaldo ya est\xe1 en uso.",
    password_algorithm_required: "Se requiere algoritmo de contrase\xf1a.",
    password_and_digest: "No puedes establecer una contrase\xf1a en texto plano y en formato resumido al mismo tiempo."
};
var $34fef5ceceba4bb8$export$2e2bcd8739ae039 = Object.freeze($34fef5ceceba4bb8$var$user);


const $4f66d7c794ff527e$var$verification_code = {
    phone_email_empty: "Tanto el tel\xe9fono como el correo electr\xf3nico est\xe1n vac\xedos.",
    not_found: "No se encontr\xf3 el c\xf3digo de verificaci\xf3n. Por favor enviar primero el c\xf3digo de verificaci\xf3n.",
    phone_mismatch: "Tel\xe9fono no coincide. Por favor solicite un nuevo c\xf3digo de verificaci\xf3n.",
    email_mismatch: "Correo electr\xf3nico no coincide. Por favor solicite un nuevo c\xf3digo de verificaci\xf3n.",
    code_mismatch: "C\xf3digo de verificaci\xf3n inv\xe1lido.",
    expired: "El c\xf3digo de verificaci\xf3n ha caducado. Por favor solicite un nuevo c\xf3digo de verificaci\xf3n.",
    exceed_max_try: "Se ha superado el l\xedmite de intentos de verificaci\xf3n de c\xf3digo. Por favor solicite un nuevo c\xf3digo de verificaci\xf3n."
};
var $4f66d7c794ff527e$export$2e2bcd8739ae039 = Object.freeze($4f66d7c794ff527e$var$verification_code);


const $836ff5f4fa48416e$var$errors = {
    request: $3c4430a9465b7e26$export$2e2bcd8739ae039,
    auth: $394029565ee4c19e$export$2e2bcd8739ae039,
    guard: $195ca26cd221924e$export$2e2bcd8739ae039,
    oidc: $ad1ff2709f2f3095$export$2e2bcd8739ae039,
    user: $34fef5ceceba4bb8$export$2e2bcd8739ae039,
    password: $bc0f02b49fdd7e02$export$2e2bcd8739ae039,
    session: $12510696e34c9a36$export$2e2bcd8739ae039,
    connector: $fe708372218c1438$export$2e2bcd8739ae039,
    verification_code: $4f66d7c794ff527e$export$2e2bcd8739ae039,
    sign_in_experiences: $b23f9bd93b1f5449$export$2e2bcd8739ae039,
    jwt_customizer: $af13a352e3580880$export$2e2bcd8739ae039,
    localization: $a3adff3c8c350d26$export$2e2bcd8739ae039,
    swagger: $afb65326823e6f8e$export$2e2bcd8739ae039,
    entity: $42a6b00e136db96c$export$2e2bcd8739ae039,
    log: $deb93b8f0dbfcdab$export$2e2bcd8739ae039,
    role: $cb9acb3247b6b074$export$2e2bcd8739ae039,
    scope: $2b70263ef088e658$export$2e2bcd8739ae039,
    storage: $547d36f71f20ed7d$export$2e2bcd8739ae039,
    resource: $dd1d2537f3f720df$export$2e2bcd8739ae039,
    hook: $352c16b084b7bb00$export$2e2bcd8739ae039,
    domain: $6951c9ee4b366c49$export$2e2bcd8739ae039,
    subscription: $a1ca92d76a257619$export$2e2bcd8739ae039,
    application: $274a1402fb92fb2b$export$2e2bcd8739ae039,
    organization: $c12b5fa6e1f15342$export$2e2bcd8739ae039,
    single_sign_on: $514cafef22ff3978$export$2e2bcd8739ae039
};
var $836ff5f4fa48416e$export$2e2bcd8739ae039 = Object.freeze($836ff5f4fa48416e$var$errors);


const $b6db651553079467$var$api_resource_details = {
    page_title: "Detalles del recurso de la API",
    back_to_api_resources: "Volver a los recursos de la API",
    general_tab: "General",
    permissions_tab: "Permisos",
    settings: "Configuraci\xf3n",
    settings_description: "Los recursos de la API, tambi\xe9n conocidos como indicadores de recurso, indican los servicios o recursos de destino que se solicitar\xe1n, generalmente, una variable de formato URI que representa la identidad del recurso.",
    management_api_settings_description: "La API de administraci\xf3n de Logto es una colecci\xf3n completa de API que permiten a los administradores administrar una amplia gama de tareas relacionadas con la identidad, hacer cumplir pol\xedticas de seguridad y cumplir con regulaciones y est\xe1ndares.",
    management_api_notice: "Esta API representa la entidad Logto y no se puede modificar ni eliminar. Cree una aplicaci\xf3n de m\xe1quina a m\xe1quina para llamar a la API de administraci\xf3n de Logto. <a>Aprende m\xe1s</a>",
    token_expiration_time_in_seconds: "Tiempo de expiraci\xf3n del token (en segundos)",
    token_expiration_time_in_seconds_placeholder: "Ingrese el tiempo de expiraci\xf3n de su token",
    delete_description: "Esta acci\xf3n no se puede deshacer. Eliminar\xe1 permanentemente el recurso de la API. Por favor, ingrese el nombre del recurso de la API <span>{{name}}</span> para confirmar.",
    enter_your_api_resource_name: "Ingrese el nombre de su recurso de API",
    api_resource_deleted: "El recurso de API {{name}} ha sido eliminado exitosamente",
    permission: {
        create_button: "Crear permiso",
        create_title: "Crear permiso",
        create_subtitle: "Define los permisos (scopes) necesarios para esta API.",
        confirm_create: "Crear permiso",
        edit_title: "Editar permiso de API",
        edit_subtitle: "Define los permisos (scopes) necesarios por la API {{resourceName}}.",
        name: "Nombre del permiso",
        name_placeholder: "leer:recurso",
        forbidden_space_in_name: "El nombre del permiso no debe contener espacios.",
        description: "Descripci\xf3n",
        description_placeholder: "Capacidad para leer los recursos",
        permission_created: "El permiso {{name}} se ha creado correctamente",
        delete_description: "Si se elimina este permiso, el usuario que ten\xeda este permiso perder\xe1 el acceso otorgado por \xe9l.",
        deleted: '\xa1El permiso "{{name}}" se elimin\xf3 con \xe9xito.'
    }
};
var $b6db651553079467$export$2e2bcd8739ae039 = Object.freeze($b6db651553079467$var$api_resource_details);


const $605c1ada0725cceb$var$api_resources = {
    page_title: "Recursos de API",
    title: "Recursos de API",
    subtitle: "Define APIs que las aplicaciones autorizadas pueden utilizar",
    create: "Crear recurso de API",
    api_name: "Nombre de la API",
    api_name_placeholder: "Ingrese el nombre de su API",
    api_identifier: "Identificador de API",
    api_identifier_placeholder: "https://su-api-identificador/",
    api_identifier_tip: "El identificador \xfanico para el recurso de API. Debe ser una URI absoluta y no tiene componente de fragmento (#). Es igual al <a>par\xe1metro de recurso</a> en OAuth 2.0.",
    default_api: "API por defecto",
    default_api_label: "S\xf3lo se puede establecer cero o una API por defecto por inquilino. Cuando se designa una API por defecto, el par\xe1metro de recurso se puede omitir en la solicitud de autenticaci\xf3n. Las posteriores intercambios de tokens utilizar\xe1n esa API como audiencia por defecto, lo que dar\xe1 lugar a la emisi\xf3n de JWTs. <a>Obtener m\xe1s informaci\xf3n</a>",
    api_resource_created: "El recurso de API {{name}} se ha creado correctamente",
    invalid_resource_indicator_format: "El indicador de API debe ser una URI absoluta v\xe1lida."
};
var $605c1ada0725cceb$export$2e2bcd8739ae039 = Object.freeze($605c1ada0725cceb$var$api_resources);


const $95e9713dc69dffc6$var$application_details = {
    page_title: "Detalles de la aplicaci\xf3n",
    back_to_applications: "Volver a Aplicaciones",
    check_guide: "Revisar Gu\xeda",
    settings: "Configuraciones",
    settings_description: 'An "Application" is a registered software or service that can access user info or act for a user. Applications help recognize who’s asking for what from Logto and handle the sign-in and permission. Fill in the required fields for authentication.',
    integration: "Integraci\xf3n",
    integration_description: "Despliega con los trabajadores seguros de Logto, potenciados por la red global de Cloudflare para un rendimiento de primer nivel y arranques instant\xe1neos de 0ms a nivel mundial.",
    service_configuration: "Configuraci\xf3n del servicio",
    service_configuration_description: "Completa las configuraciones necesarias en tu servicio.",
    session: "Sesi\xf3n",
    endpoints_and_credentials: "Endpoints y Credenciales",
    endpoints_and_credentials_description: "Utiliza los siguientes endpoints y credenciales para configurar la conexi\xf3n OIDC en tu aplicaci\xf3n.",
    refresh_token_settings: "Token de actualizaci\xf3n",
    refresh_token_settings_description: "Gestiona las reglas del token de actualizaci\xf3n para esta aplicaci\xf3n.",
    application_roles: "Roles de Aplicaci\xf3n",
    machine_logs: "Registros de M\xe1quina",
    application_name: "Nombre de Aplicaci\xf3n",
    application_name_placeholder: "Mi App",
    description: "Descripci\xf3n",
    description_placeholder: "Ingresa la descripci\xf3n de tu aplicaci\xf3n",
    config_endpoint: "Endpoint de configuraci\xf3n del proveedor OpenID",
    authorization_endpoint: "Endpoint de Autorizaci\xf3n",
    authorization_endpoint_tip: "El endpoint para la autenticaci\xf3n y autorizaci\xf3n. Se utiliza para OpenID Connect <a>Autenticaci\xf3n</a>.",
    show_endpoint_details: "Mostrar detalles del endpoint",
    hide_endpoint_details: "Ocultar detalles del endpoint",
    logto_endpoint: "Endpoint de Logto",
    application_id: "ID de Aplicaci\xf3n",
    application_id_tip: "El identificador de aplicaci\xf3n \xfanico normalmente generado por Logto. Tambi\xe9n se conoce como “<a>client_id</a>” en OpenID Connect.",
    application_secret: "Aplicaci\xf3n Secreta",
    redirect_uri: "URI de Redireccionamiento",
    redirect_uris: "URIs de Redireccionamiento",
    redirect_uri_placeholder: "https://tu.pagina.com/app",
    redirect_uri_placeholder_native: "io.logto://callback",
    redirect_uri_tip: "El URI hacia donde se redirecciona despu\xe9s de que un usuario inicie sesi\xf3n (correctamente o no). Consulta OpenID Connect <a>AuthRequest</a> para m\xe1s informaci\xf3n.",
    post_sign_out_redirect_uri: "Post Sign-out URI de Redireccionamiento",
    post_sign_out_redirect_uris: "Post Sign-out URIs de Redireccionamiento",
    post_sign_out_redirect_uri_placeholder: "https://tu.pagina.com/home",
    post_sign_out_redirect_uri_tip: "El URI hacia donde se redirecciona despu\xe9s de que un usuario cierre sesi\xf3n (opcional). Puede que no tenga efecto para algunos tipos de aplicaciones.",
    cors_allowed_origins: "Or\xedgenes permitidos CORS",
    cors_allowed_origins_placeholder: "https://tu.pagina.com",
    cors_allowed_origins_tip: "Por defecto, se permitir\xe1n todos los or\xedgenes de los URIs de Redireccionamiento. Normalmente no es necesario hacer nada en este campo. Consulta la <a>documentaci\xf3n de MDN</a> para obtener informaci\xf3n detallada.",
    token_endpoint: "Endpoint del Token",
    user_info_endpoint: "Endpoint del Usuario",
    enable_admin_access: "Habilitar acceso de administrador",
    enable_admin_access_label: "Habilita o deshabilita el acceso a la API de Gesti\xf3n. Una vez habilitado, puedes utilizar tokens de acceso para llamar a la API de Gesti\xf3n en nombre de esta aplicaci\xf3n.",
    always_issue_refresh_token: "Siempre emitir Token de Refresco",
    always_issue_refresh_token_label: "Al habilitar esta configuraci\xf3n, Logto siempre emitir\xe1 Tokens de Refresco, independientemente de si se presenta o no “prompt=consent” en la solicitud de autenticaci\xf3n. Sin embargo, esta pr\xe1ctica no est\xe1 recomendada a menos que sea necesario, ya que no es compatible con OpenID Connect y puede causar problemas potenciales.",
    refresh_token_ttl: "Tiempo de vida \xfatil del Token de refresco (TTL) en d\xedas",
    refresh_token_ttl_tip: "La duraci\xf3n durante la cual un token de refresco puede ser utilizado para solicitar nuevos tokens de acceso antes de que expire y se vuelva inv\xe1lido. Las solicitudes de tokens extender\xe1n el TTL del token de refresco a este valor.",
    rotate_refresh_token: "Rotar el token de refresco",
    rotate_refresh_token_label: "Cuando est\xe1 habilitado, Logto emitir\xe1 un nuevo token de refresco para las solicitudes de token cuando ha pasado el 70 % del tiempo de vida \xfatil (TTL) original o se cumplen ciertas condiciones. <a>M\xe1s informaci\xf3n</a>",
    delete_description: "Esta acci\xf3n no se puede deshacer. Eliminar\xe1 permanentemente la aplicaci\xf3n. Ingresa el nombre de la aplicaci\xf3n <span>{{name}}</span> para confirmar.",
    enter_your_application_name: "Ingresa el nombre de tu aplicaci\xf3n",
    application_deleted: "Se ha eliminado exitosamente la aplicaci\xf3n {{name}}",
    redirect_uri_required: "Debes ingresar al menos un URI de Redireccionamiento",
    app_domain_description_1: "No dudes en utilizar tu dominio con {{domain}} potenciado por Logto, que es permanentemente v\xe1lido.",
    app_domain_description_2: "No dudes en utilizar tu dominio <domain>{{domain}}</domain>, que es permanentemente v\xe1lido.",
    custom_rules: "Reglas de autenticaci\xf3n personalizadas",
    custom_rules_placeholder: "^/(admin|privacy)/.+$",
    custom_rules_description: "Establece reglas con expresiones regulares para rutas que requieren autenticaci\xf3n. Por defecto: protecci\xf3n de todo el sitio si se deja en blanco.",
    authentication_routes: "Rutas de autenticaci\xf3n",
    custom_rules_tip: "Aqu\xed tienes dos escenarios:<ol><li>Para proteger solo las rutas '/admin' y '/privacy' con autenticaci\xf3n: ^/(admin|privacy)/.*</li><li>Para excluir im\xe1genes JPG de la autenticaci\xf3n: ^(?!.*\\.jpg$).*$</li></ol>",
    authentication_routes_description: "Redirige tu bot\xf3n de autenticaci\xf3n utilizando las rutas especificadas. Nota: Estas rutas son irremplazables.",
    protect_origin_server: "Proteger tu servidor de origen",
    protect_origin_server_description: "Aseg\xfarate de proteger tu servidor de origen contra el acceso directo. Consulta la gu\xeda para obtener m\xe1s <a>instrucciones detalladas</a>.",
    session_duration: "Duraci\xf3n de la sesi\xf3n (d\xedas)",
    try_it: "Probar",
    branding: {
        name: "Marca",
        description: "Personaliza el nombre y el logotipo de tu aplicaci\xf3n en la pantalla de consentimiento.",
        more_info: "M\xe1s informaci\xf3n",
        more_info_description: "Ofrece a los usuarios m\xe1s detalles sobre tu aplicaci\xf3n en la pantalla de consentimiento.",
        display_name: "Nombre a Mostrar",
        display_logo: "Logotipo a Mostrar",
        display_logo_dark: "Logotipo a Mostrar (oscuro)",
        terms_of_use_url: "URL de T\xe9rminos de Uso de la Aplicaci\xf3n",
        privacy_policy_url: "URL de Pol\xedtica de Privacidad de la Aplicaci\xf3n"
    },
    permissions: {
        name: "Permisos",
        description: "Selecciona los permisos que la aplicaci\xf3n de terceros requiere para la autorizaci\xf3n de usuarios a acceder a tipos espec\xedficos de datos.",
        user_permissions: "Datos personales del usuario",
        organization_permissions: "Acceso a la organizaci\xf3n",
        table_name: "Conceder permisos",
        field_name: "Permiso",
        field_description: "Mostrado en la pantalla de consentimiento",
        delete_text: "Eliminar permiso",
        permission_delete_confirm: "Esta acci\xf3n retirar\xe1 los permisos otorgados a la aplicaci\xf3n de terceros, impidiendo que solicite autorizaci\xf3n de usuarios para tipos espec\xedficos de datos. \xbfEst\xe1s seguro de que deseas continuar?",
        permissions_assignment_description: "Selecciona los permisos que la aplicaci\xf3n de terceros solicita para la autorizaci\xf3n de usuarios a acceder a tipos espec\xedficos de datos.",
        user_profile: "Datos del usuario",
        api_permissions: "Permisos de API",
        organization: "Permisos de organizaci\xf3n",
        user_permissions_assignment_form_title: "A\xf1adir permisos del perfil de usuario",
        organization_permissions_assignment_form_title: "A\xf1adir permisos de organizaci\xf3n",
        api_resource_permissions_assignment_form_title: "A\xf1adir permisos de recurso de API",
        user_data_permission_description_tips: 'Puedes modificar la descripci\xf3n de los permisos de datos personales del usuario a trav\xe9s de "Experiencia de Inicio de Sesi\xf3n > Contenido > Administrar Idioma"',
        permission_description_tips: "Cuando Logto es utilizado como un Proveedor de Identidad (IdP) para autenticaci\xf3n en aplicaciones de terceros, y se solicita autorizaci\xf3n a los usuarios, esta descripci\xf3n aparece en la pantalla de consentimiento.",
        user_title: "Usuario",
        user_description: "Selecciona los permisos solicitados por la aplicaci\xf3n de terceros para acceder a datos espec\xedficos del usuario.",
        grant_user_level_permissions: "Conceder permisos de datos de usuario",
        organization_title: "Organizaci\xf3n",
        organization_description: "Selecciona los permisos solicitados por la aplicaci\xf3n de terceros para acceder a datos espec\xedficos de la organizaci\xf3n.",
        grant_organization_level_permissions: "Conceder permisos de datos de organizaci\xf3n"
    },
    roles: {
        name_column: "Rol",
        description_column: "Descripci\xf3n",
        assign_button: "Asignar roles",
        delete_description: "Esta acci\xf3n eliminar\xe1 este rol de esta aplicaci\xf3n de m\xe1quina a m\xe1quina. El rol seguir\xe1 existiendo, pero ya no estar\xe1 asociado con esta aplicaci\xf3n de m\xe1quina a m\xe1quina.",
        deleted: "Se ha eliminado correctamente {{name}} de este usuario.",
        assign_title: "Asignar roles a {{name}}",
        assign_subtitle: "Autorizar {{name}} uno o m\xe1s roles",
        assign_role_field: "Asignar roles",
        role_search_placeholder: "Buscar por nombre de rol",
        added_text: "{{value, number}} a\xf1adido",
        assigned_app_count: "{{value, number}} aplicaciones",
        confirm_assign: "Asignar roles",
        role_assigned: "Rol(es) asignado(s) correctamente",
        search: "Buscar por nombre de rol, descripci\xf3n o ID",
        empty: "No hay roles disponibles"
    }
};
var $95e9713dc69dffc6$export$2e2bcd8739ae039 = Object.freeze($95e9713dc69dffc6$var$application_details);


const $d00b74208f0dd5a4$var$applications = {
    page_title: "Aplicaciones",
    title: "Aplicaciones",
    subtitle: "Configura la autenticaci\xf3n de Logto para tu aplicaci\xf3n nativa, de p\xe1gina \xfanica, de m\xe1quina a m\xe1quina o tradicional",
    subtitle_with_app_type: "Configura la autenticaci\xf3n de Logto para tu aplicaci\xf3n {{name}}",
    create: "Crear aplicaci\xf3n",
    create_subtitle_third_party: "Utiliza Logto como proveedor de identidad (IdP) para integrarte f\xe1cilmente con aplicaciones de terceros",
    application_name: "Nombre de la aplicaci\xf3n",
    application_name_placeholder: "Mi App",
    application_description: "Descripci\xf3n de la aplicaci\xf3n",
    application_description_placeholder: "Introduce la descripci\xf3n de tu aplicaci\xf3n",
    select_application_type: "Seleccionar un tipo de aplicaci\xf3n",
    no_application_type_selected: "A\xfan no has seleccionado ning\xfan tipo de aplicaci\xf3n",
    application_created: "\xa1La aplicaci\xf3n se ha creado correctamente.",
    tab: {
        my_applications: "Mis aplicaciones",
        third_party_applications: "Aplicaciones de terceros"
    },
    app_id: "ID de la aplicaci\xf3n",
    type: {
        native: {
            title: "App nativa",
            subtitle: "Una aplicaci\xf3n que se ejecuta en un entorno nativo",
            description: "Por ejemplo, una app de iOS, una app de Android"
        },
        spa: {
            title: "App de p\xe1gina \xfanica",
            subtitle: "Una aplicaci\xf3n que se ejecuta en un navegador web y actualiza din\xe1micamente los datos en su lugar",
            description: "Por ejemplo, una app de React DOM, una app de Vue"
        },
        traditional: {
            title: "Web tradicional",
            subtitle: "Una aplicaci\xf3n que renderiza y actualiza p\xe1ginas solo por el servidor web",
            description: "Por ejemplo, Next.js, PHP"
        },
        machine_to_machine: {
            title: "M\xe1quina a m\xe1quina",
            subtitle: "Una aplicaci\xf3n (generalmente un servicio) que habla directamente con recursos",
            description: "Por ejemplo, servicio backend"
        },
        protected: {
            title: "App protegida",
            subtitle: "Una aplicaci\xf3n protegida por Logto",
            description: "N/A"
        },
        third_party: {
            title: "App de terceros",
            subtitle: "Una aplicaci\xf3n que se utiliza como conector de proveedor de identidad de terceros",
            description: "Ej.: OIDC, SAML"
        }
    },
    placeholder_title: "Selecciona un tipo de aplicaci\xf3n para continuar",
    placeholder_description: "Logto utiliza una entidad de aplicaci\xf3n para OIDC para ayudar con tareas como la identificaci\xf3n de tus aplicaciones, la gesti\xf3n de inicio de sesi\xf3n y la creaci\xf3n de registros de auditor\xeda.",
    m2m_role_assignment: {
        title: "Autorizar la aplicaci\xf3n con rol de m\xe1quina a m\xe1quina para permisos",
        subtitle: "Las aplicaciones de m\xe1quina a m\xe1quina requieren un rol de m\xe1quina a m\xe1quina autorizado.",
        role_creation_hint: "\xbfNo puede encontrar el rol adecuado de m\xe1quina a m\xe1quina? <a>Crear un rol de m\xe1quina a m\xe1quina</a>"
    }
};
var $d00b74208f0dd5a4$export$2e2bcd8739ae039 = Object.freeze($d00b74208f0dd5a4$var$applications);


const $754ece1eeb859b32$var$cloud = {
    general: {
        onboarding: "Integraci\xf3n"
    },
    welcome: {
        page_title: "Bienvenida",
        title: "\xa1Bienvenido a Logto Cloud! Nos encantar\xeda saber un poco m\xe1s sobre ti.",
        description: "Hagamos que su experiencia de Logto sea \xfanica para usted al conocerlo mejor. Su informaci\xf3n est\xe1 segura con nosotros.",
        project_field: "Estoy usando Logto para:",
        project_options: {
            personal: "Proyecto personal",
            company: "Proyecto empresarial"
        },
        company_name_field: "Nombre de la empresa",
        company_name_placeholder: "Acme.co",
        stage_field: "\xbfEn qu\xe9 etapa se encuentra su producto actualmente?",
        stage_options: {
            new_product: "Comenzar un nuevo proyecto y buscar una soluci\xf3n r\xe1pida y lista para usar",
            existing_product: "Migrar desde una autenticaci\xf3n actual (por ejemplo, creada por uno mismo, Auth0, Cognito, Microsoft)",
            target_enterprise_ready: "Acabo de obtener clientes m\xe1s grandes y ahora debo hacer que mi producto est\xe9 listo para vender a empresas"
        },
        additional_features_field: "\xbfHay algo m\xe1s que desee que sepamos?",
        additional_features_options: {
            customize_ui_and_flow: "Construir y gestionar mi propia interfaz de usuario, no solo usar la soluci\xf3n preconstruida y personalizable de Logto",
            compliance: "SOC2 y GDPR son imprescindibles",
            export_user_data: "Necesito la capacidad de exportar datos de usuario de Logto",
            budget_control: "Tengo un control presupuestario muy ajustado",
            bring_own_auth: "Tengo mis propios servicios de autenticaci\xf3n y solo necesito algunas caracter\xedsticas de Logto",
            others: "Ninguna de las anteriores"
        }
    },
    sie: {
        page_title: "Personalizaci\xf3n de la experiencia de inicio de sesi\xf3n",
        title: "Primero personalicemos su experiencia de inicio de sesi\xf3n con facilidad",
        inspire: {
            title: "Crear ejemplos convincentes",
            description: '\xbfSe siente inseguro acerca de la experiencia de inicio de sesi\xf3n? \xa1Simplemente haga clic en "Insp\xedreme" y deje que suceda la magia!',
            inspire_me: "Insp\xedrame"
        },
        logo_field: "Logotipo de la aplicaci\xf3n",
        color_field: "Color de la marca",
        identifier_field: "Identificador",
        identifier_options: {
            email: "Correo electr\xf3nico",
            phone: "Tel\xe9fono",
            user_name: "Nombre de usuario"
        },
        authn_field: "Autenticaci\xf3n",
        authn_options: {
            password: "Contrase\xf1a",
            verification_code: "C\xf3digo de verificaci\xf3n"
        },
        social_field: "Inicio de sesi\xf3n social",
        finish_and_done: "Terminar y listo",
        preview: {
            mobile_tab: "M\xf3vil",
            web_tab: "Web"
        },
        connectors: {
            unlocked_later: "Desbloqueado m\xe1s adelante",
            unlocked_later_tip: "Una vez que haya completado el proceso de incorporaci\xf3n y haya ingresado al producto, tendr\xe1 acceso a una mayor variedad de m\xe9todos de inicio de sesi\xf3n social.",
            notice: "Evite usar el conector de demostraci\xf3n para fines de producci\xf3n. Una vez completadas las pruebas, elimine amablemente el conector de demostraci\xf3n y configure su propio conector con sus credenciales."
        }
    },
    socialCallback: {
        title: "Ha iniciado sesi\xf3n correctamente",
        description: "Ha iniciado sesi\xf3n correctamente utilizando su cuenta social. Para garantizar una integraci\xf3n perfecta y el acceso a todas las funciones de Logto, recomendamos que proceda a configurar su propio conector social."
    },
    tenant: {
        create_tenant: "Crear inquilino"
    }
};
var $754ece1eeb859b32$export$2e2bcd8739ae039 = Object.freeze($754ece1eeb859b32$var$cloud);


const $607f93a81311623b$var$components = {
    uploader: {
        action_description: "Arrastra y suelta o busca",
        uploading: "Subiendo...",
        image_limit: "Sube im\xe1genes de menos de {{size, number}}KB, solo {{extensions, list(style: narrow; type: conjunction;)}}.",
        error_upload: "Algo sali\xf3 mal. La subida de archivos fall\xf3.",
        error_file_size: "El archivo es demasiado grande. Por favor, sube un archivo de menos de {{size, number}}KB.",
        error_file_type: "El tipo de archivo no es compatible. Solo {{extensions, list(style: narrow; type: conjunction;)}}.",
        error_file_count: "Solo puedes subir 1 archivo."
    }
};
var $607f93a81311623b$export$2e2bcd8739ae039 = Object.freeze($607f93a81311623b$var$components);


const $1bda8871a84aad47$var$connector_details = {
    page_title: "Detalles del conector",
    back_to_connectors: "Volver a conectores",
    check_readme: "Ver el archivo README",
    settings: "Configuraciones generales",
    settings_description: "Los conectores desempe\xf1an un papel fundamental en Logto. Con su ayuda, Logto permite que los usuarios finales utilicen el registro o inicio de sesi\xf3n sin contrase\xf1a y las capacidades para iniciar sesi\xf3n con cuentas sociales.",
    parameter_configuration: "Configuraci\xf3n de par\xe1metros",
    test_connection: "Prueba",
    save_error_empty_config: "Por favor, ingrese la configuraci\xf3n",
    send: "Enviar",
    send_error_invalid_format: "Entrada no v\xe1lida",
    edit_config_label: "Ingrese su JSON aqu\xed",
    test_email_sender: "Probar su conector de correo electr\xf3nico",
    test_sms_sender: "Probar su conector de SMS",
    test_email_placeholder: "john.doe@example.com",
    test_sms_placeholder: "+1 555-123-4567",
    test_message_sent: "Mensaje de prueba enviado",
    test_sender_description: 'Logto utiliza la plantilla "Generic" para realizar pruebas. Recibir\xe1 un mensaje si su conector est\xe1 configurado correctamente.',
    options_change_email: "Cambiar conector de correo electr\xf3nico",
    options_change_sms: "Cambiar conector de SMS",
    connector_deleted: "El conector ha sido eliminado con \xe9xito",
    type_email: "Conector de correo electr\xf3nico",
    type_sms: "Conector de SMS",
    type_social: "Conector social",
    in_used_social_deletion_description: "Este conector se utiliza en su experiencia de inicio de sesi\xf3n. Al eliminarlo, la experiencia de inicio de sesi\xf3n de <name/> se eliminar\xe1 en la configuraci\xf3n de la experiencia de inicio de sesi\xf3n. Deber\xe1 reconfigurarlo si decide agregarlo nuevamente.",
    in_used_passwordless_deletion_description: "Este {{name}} se utiliza en su experiencia de inicio de sesi\xf3n. Al eliminarlo, su experiencia de inicio de sesi\xf3n no funcionar\xe1 correctamente hasta que resuelva el conflicto. Deber\xe1 reconfigurarlo si decide agregarlo nuevamente.",
    deletion_description: "Est\xe1 eliminando este conector. No se puede deshacer, y deber\xe1 reconfigurarlo si decide agregarlo nuevamente.",
    logto_email: {
        total_email_sent: "Total de correos electr\xf3nicos enviados: {{value, number}}",
        total_email_sent_tip: "Logto utiliza SendGrid para correo electr\xf3nico integrado seguro y estable. Es completamente gratuito de usar. <a>M\xe1s informaci\xf3n</a>",
        email_template_title: "Plantilla de correo electr\xf3nico",
        template_description: "El correo electr\xf3nico integrado utiliza plantillas predeterminadas para la entrega sin problemas de correos electr\xf3nicos de verificaci\xf3n. No se requiere configuraci\xf3n, y puede personalizar la informaci\xf3n b\xe1sica de la marca.",
        template_description_link_text: "Ver plantillas",
        description_action_text: "Ver plantillas",
        from_email_field: "Correo electr\xf3nico de origen",
        sender_name_field: "Nombre del remitente",
        sender_name_tip: 'Personalice el nombre del remitente para los correos electr\xf3nicos. Si se deja en blanco, se utilizar\xe1 "Verification" como nombre predeterminado.',
        sender_name_placeholder: "Su nombre de remitente",
        company_information_field: "Informaci\xf3n de la empresa",
        company_information_description: "Muestre el nombre de su empresa, direcci\xf3n o c\xf3digo postal en la parte inferior de los correos electr\xf3nicos para mejorar la autenticidad.",
        company_information_placeholder: "Informaci\xf3n b\xe1sica de su empresa",
        app_logo_field: "Logotipo de la aplicaci\xf3n",
        app_logo_tip: "Muestre el logotipo de su marca en la parte superior de los correos electr\xf3nicos. Utilice la misma imagen para el modo claro y oscuro.",
        urls_not_allowed: "Las URL no est\xe1n permitidas",
        test_notes: 'Logto utiliza la plantilla "Generic" para realizar pruebas.'
    }
};
var $1bda8871a84aad47$export$2e2bcd8739ae039 = Object.freeze($1bda8871a84aad47$var$connector_details);


const $e2370375f0966479$var$connectors = {
    page_title: "Conectores",
    title: "Conectores",
    subtitle: "Configure conectores para habilitar la experiencia de inicio de sesi\xf3n sin contrase\xf1a y con redes sociales",
    create: "Agregar conector social",
    config_sie_notice: "Has configurado conectores. Aseg\xfarate de configurarlo en <a>{{link}}</a>.",
    config_sie_link_text: "experiencia de inicio de sesi\xf3n",
    tab_email_sms: "Conectores de correo electr\xf3nico y SMS",
    tab_social: "Conectores sociales",
    connector_name: "Nombre del conector",
    demo_tip: "El n\xfamero m\xe1ximo de mensajes permitidos para este conector de demostraci\xf3n est\xe1 limitado a 100 y no se recomienda para implementaci\xf3n en un entorno de producci\xf3n.",
    social_demo_tip: "El conector de demostraci\xf3n est\xe1 dise\xf1ado exclusivamente para fines de demostraci\xf3n y no se recomienda para implementaci\xf3n en un entorno de producci\xf3n.",
    connector_type: "Tipo",
    connector_status: "Experiencia de inicio de sesi\xf3n",
    connector_status_in_use: "En uso",
    connector_status_not_in_use: "No en uso",
    not_in_use_tip: {
        content: "No en uso significa que tu experiencia de inicio de sesi\xf3n no ha utilizado este m\xe9todo de inicio de sesi\xf3n. <a>{{link}}</a> para agregar este m\xe9todo de inicio de sesi\xf3n. ",
        go_to_sie: "Ir a la experiencia de inicio de sesi\xf3n"
    },
    placeholder_title: "Conector social",
    placeholder_description: "Logto ha proporcionado muchos conectores de inicio de sesi\xf3n social ampliamente utilizados, mientras tanto, puede crear el suyo con protocolos est\xe1ndar.",
    save_and_done: "Guardar y finalizar",
    type: {
        email: "Conector de correo electr\xf3nico",
        sms: "Conector SMS",
        social: "Conector social"
    },
    setup_title: {
        email: "Configure el conector de correo electr\xf3nico",
        sms: "Configure el conector SMS",
        social: "Agregar conector social"
    },
    guide: {
        subtitle: "Una gu\xeda paso a paso para configurar su conector",
        general_setting: "Configuraciones generales",
        parameter_configuration: "Configuraci\xf3n de par\xe1metros",
        test_connection: "Prueba de conexi\xf3n",
        name: "Nombre para el bot\xf3n de inicio de sesi\xf3n social",
        name_placeholder: "Ingrese el nombre para el bot\xf3n de inicio de sesi\xf3n social",
        name_tip: 'El nombre del bot\xf3n del conector se mostrar\xe1 como "Continuar con {{name}}". Siempre tenga en cuenta la longitud del nombre en caso de que sea demasiado largo.',
        logo: "URL del logotipo para el bot\xf3n de inicio de sesi\xf3n social",
        logo_placeholder: "https://tudominio.cdn/logo.png",
        logo_tip: "La imagen del logotipo se mostrar\xe1 en el conector. Obtenga un enlace de imagen accesible p\xfablicamente e ins\xe9rtelo aqu\xed.",
        logo_dark: "URL del logotipo para el bot\xf3n de inicio de sesi\xf3n social (modo oscuro)",
        logo_dark_placeholder: "https://tudominio.cdn/logo.png",
        logo_dark_tip: "Configure el logotipo de su conector para el modo oscuro despu\xe9s de activarlo en la Experiencia de inicio de sesi\xf3n del Panel de administrador.",
        logo_dark_collapse: "Colapso",
        logo_dark_show: "Mostrar configuraci\xf3n de logotipo para modo oscuro",
        target: "Nombre del proveedor de identidad",
        target_placeholder: "Ingrese el nombre del proveedor de identidad del conector",
        target_tip: 'El valor de "nombre del IdP" puede ser una cadena de identificador \xfanica para distinguir sus identificadores sociales.',
        target_tip_standard: 'El valor de "nombre del IdP" puede ser una cadena de identificador \xfanica para distinguir sus identificadores sociales. Esta configuraci\xf3n no se puede cambiar despu\xe9s de crear el conector.',
        target_tooltip: 'El "nombre del IdP" en los conectores sociales de Logto se refiere a la "fuente" de sus identidades sociales. En el dise\xf1o de Logto, no aceptamos el mismo "nombre del IdP" de una plataforma espec\xedfica para evitar conflictos. Debe ser muy cuidadoso antes de agregar un conector ya que NO PUEDE cambiar su valor una vez que lo crea. <a>Obtener m\xe1s informaci\xf3n</a>',
        target_conflict: "El nombre del IdP ingresado coincide con el conector de nombre <span></span>. Utilizar el mismo nombre del IdP puede provocar un comportamiento de inicio de sesi\xf3n inesperado donde los usuarios pueden acceder a la misma cuenta a trav\xe9s de dos conectores diferentes.",
        target_conflict_line2: 'Si desea reemplazar el conector actual con el mismo proveedor de identidad y permitir que los usuarios anteriores inicien sesi\xf3n sin registrarse nuevamente, elimine el conector <span></span> y cree uno nuevo con el mismo "nombre de IdP".',
        target_conflict_line3: 'Si desea conectarse a un proveedor de identidad diferente, modifique el "nombre del IdP" y contin\xfae.',
        config: "Ingrese su JSON de configuraci\xf3n",
        sync_profile: "Sincronizar informaci\xf3n del perfil",
        sync_profile_only_at_sign_up: "Sincronice solo en el registro",
        sync_profile_each_sign_in: "Siempre sincronice en cada inicio de sesi\xf3n",
        sync_profile_tip: "Sincronice el perfil b\xe1sico del proveedor social, como los nombres de los usuarios y sus avatares.",
        callback_uri: "URI de devoluci\xf3n de llamada",
        callback_uri_description: "Tambi\xe9n llamado URI de redireccionamiento, es la URI en Logto a la que se enviar\xe1n los usuarios despu\xe9s de la autorizaci\xf3n social, copie y pegue en la p\xe1gina de configuraci\xf3n del proveedor social.",
        acs_url: "URL del servicio de consumo de afirmaciones"
    },
    platform: {
        universal: "Universal",
        web: "Web",
        native: "Nativo"
    },
    add_multi_platform: "admite m\xfaltiples plataformas, seleccione una plataforma para continuar",
    drawer_title: "Gu\xeda del conector",
    drawer_subtitle: "Siga las instrucciones para integrar su conector",
    unknown: "Conector desconocido",
    standard_connectors: "Conectores est\xe1ndar"
};
var $e2370375f0966479$export$2e2bcd8739ae039 = Object.freeze($e2370375f0966479$var$connectors);


const $57c56ac0896ba319$var$contact = {
    title: "Obtener ayuda",
    description: "Para solicitudes de ayuda o comentarios sobre el producto, cont\xe1ctenos a trav\xe9s de los siguientes m\xe9todos.",
    discord: {
        title: "\xdanete a la comunidad de Discord",
        description: "Con\xe9ctate con otros desarrolladores para encontrar soluciones",
        button: "\xdanete"
    },
    github: {
        title: "Comunicarse en GitHub",
        description: "Crea un problema y env\xedalo en GitHub",
        button: "Abrir"
    },
    email: {
        title: "Contacta con soporte por correo electr\xf3nico",
        description: "Env\xedanos un correo electr\xf3nico para obtener m\xe1s informaci\xf3n y ayuda.",
        button: "Enviar"
    },
    reserve: {
        title: "Reserve su tiempo con el equipo de Logto",
        description: "Reserve r\xe1pidamente una sesi\xf3n para un chat en vivo",
        button: "Reservar"
    }
};
var $57c56ac0896ba319$export$2e2bcd8739ae039 = Object.freeze($57c56ac0896ba319$var$contact);


const $cd6a4b3c80422e05$var$dashboard = {
    page_title: "Dashboard",
    title: "Dashboard",
    description: "Obt\xe9n una vista general sobre el rendimiento de tu aplicaci\xf3n",
    total_users: "Usuarios totales",
    total_users_tip: "Usuarios totales",
    new_users_today: "Nuevos usuarios hoy",
    new_users_today_tip: "N\xfamero de nuevos usuarios registrados en tu aplicaci\xf3n hoy",
    new_users_7_days: "Nuevos usuarios \xfaltimos 7 d\xedas",
    new_users_7_days_tip: "N\xfamero de nuevos usuarios registrados en tu aplicaci\xf3n en los \xfaltimos 7 d\xedas",
    daily_active_users: "Usuarios activos diarios",
    daily_active_users_tip: "N\xfamero de usuarios \xfanicos que intercambiaron tokens en tu aplicaci\xf3n hoy",
    weekly_active_users: "Usuarios activos semanales",
    weekly_active_users_tip: "N\xfamero de usuarios \xfanicos que intercambiaron tokens en tu aplicaci\xf3n en los \xfaltimos 7 d\xedas",
    monthly_active_users: "Usuarios activos mensuales",
    monthly_active_users_tip: "N\xfamero de usuarios \xfanicos que intercambiaron tokens en tu aplicaci\xf3n en los \xfaltimos 30 d\xedas"
};
var $cd6a4b3c80422e05$export$2e2bcd8739ae039 = Object.freeze($cd6a4b3c80422e05$var$dashboard);


const $4508570636398143$var$domain = {
    status: {
        connecting: "Conectando...",
        in_use: "En uso",
        failed_to_connect: "Error de conexi\xf3n"
    },
    update_endpoint_notice: "No olvide actualizar el dominio para el URI de devoluci\xf3n de llamada del conector social y el punto final de Logto en su aplicaci\xf3n si desea utilizar un dominio personalizado para las funciones. <a>{{link}}</a>",
    error_hint: "Aseg\xfarese de actualizar sus registros DNS. Continuaremos verificando cada {{value}} segundos.",
    custom: {
        custom_domain: "Dominio personalizado",
        custom_domain_description: "Mejore su marca utilizando un dominio personalizado. Este dominio se utilizar\xe1 en su experiencia de inicio de sesi\xf3n.",
        custom_domain_field: "Dominio personalizado",
        custom_domain_placeholder: "tu.dominio.com",
        add_domain: "Agregar dominio",
        invalid_domain_format: 'Por favor, proporcione una URL de dominio v\xe1lida con un m\xednimo de tres partes, por ejemplo, "tu.dominio.com".',
        verify_domain: "Verificar dominio",
        enable_ssl: "Habilitar SSL",
        checking_dns_tip: "Despu\xe9s de configurar los registros DNS, el proceso se ejecutar\xe1 autom\xe1ticamente y puede tardar hasta 24 horas. Puede dejar esta interfaz mientras se est\xe1 ejecutando.",
        enable_ssl_tip: "Habilitar SSL se ejecutar\xe1 autom\xe1ticamente y puede tardar hasta 24 horas. Puede dejar esta interfaz mientras se est\xe1 ejecutando.",
        generating_dns_records: "Generando los registros DNS...",
        add_dns_records: "Agregue estos registros DNS a su proveedor de DNS.",
        dns_table: {
            type_field: "Tipo",
            name_field: "Nombre",
            value_field: "Valor"
        },
        deletion: {
            delete_domain: "Eliminar dominio",
            reminder: "Eliminar dominio personalizado",
            description: "\xbfEst\xe1 seguro de que desea eliminar este dominio personalizado?",
            in_used_description: '\xbfEst\xe1 seguro de que desea eliminar el dominio personalizado "{{domain}}"?',
            in_used_tip: 'Si hab\xeda configurado este dominio personalizado en su proveedor de conector social o punto final de aplicaci\xf3n antes, necesitar\xe1 modificar la URI al dominio predeterminado de Logto "{{dominio}}" primero. Esto es necesario para que el bot\xf3n de inicio de sesi\xf3n social funcione correctamente.',
            deleted: "\xa1Dominio personalizado eliminado con \xe9xito!"
        }
    },
    default: {
        default_domain: "Dominio predeterminado",
        default_domain_description: "Logto ofrece un dominio predeterminado preconfigurado, listo para usar sin ninguna configuraci\xf3n adicional. Este dominio predeterminado sirve como opci\xf3n de respaldo incluso si habilit\xf3 un dominio personalizado.",
        default_domain_field: "Dominio predeterminado de Logto"
    },
    custom_endpoint_note: 'Puede personalizar el nombre de dominio de estos puntos finales seg\xfan sea necesario. Elija "{{custom}}" o "{{default}}".',
    custom_social_callback_url_note: 'Puede personalizar el nombre de dominio de esta URI para que coincida con el punto final de su aplicaci\xf3n. Elija "{{custom}}" o "{{default}}".',
    custom_acs_url_note: 'Puede personalizar el nombre de dominio de esta URI para que coincida con la URL del servicio de consumidor de afirmaciones de su proveedor de identidad. Elija "{{custom}}" o "{{default}}".'
};
var $4508570636398143$export$2e2bcd8739ae039 = Object.freeze($4508570636398143$var$domain);


const $6a94df51f8a55015$var$enterprise_sso_details = {
    back_to_sso_connectors: "Volver a los conectores SSO de la empresa",
    page_title: "Detalles del conector de SSO empresarial",
    readme_drawer_title: "SSO empresarial",
    readme_drawer_subtitle: "Configure los conectores SSO empresariales para habilitar SSO de usuarios finales",
    tab_experience: "Experiencia SSO",
    tab_connection: "Conexi\xf3n",
    general_settings_title: "General",
    custom_branding_title: "Visualizaci\xf3n",
    custom_branding_description: "Personalice el nombre y el logotipo que se muestra en el flujo de inicio de sesi\xf3n \xfanico de los usuarios finales. Cuando est\xe1 vac\xedo, se utilizan los valores predeterminados.",
    email_domain_field_name: "Dominio de correo electr\xf3nico empresarial",
    email_domain_field_description: "Los usuarios con este dominio de correo electr\xf3nico pueden utilizar SSO para la autenticaci\xf3n. Verifique que el dominio pertenezca a la empresa.",
    email_domain_field_placeholder: "Dominio de correo electr\xf3nico",
    sync_profile_field_name: "Sincronizar informaci\xf3n de perfil desde el proveedor de identidad",
    sync_profile_option: {
        register_only: "Solo sincronizar en el primer inicio de sesi\xf3n",
        each_sign_in: "Sincronizar siempre en cada inicio de sesi\xf3n"
    },
    connector_name_field_name: "Nombre del conector",
    display_name_field_name: "Nombre para mostrar",
    connector_logo_field_name: "Mostrar logotipo",
    connector_logo_field_description: "Cada imagen debe ser inferior a 500KB, solo se admiten formatos SVG, PNG, JPG, JPEG.",
    branding_logo_context: "Subir logotipo",
    branding_logo_error: "Error al subir el logotipo: {{error}}",
    branding_light_logo_context: "Subir logotipo del modo claro",
    branding_light_logo_error: "Error al subir el logotipo del modo claro: {{error}}",
    branding_logo_field_name: "Logotipo",
    branding_logo_field_placeholder: "https://tu.domino/logo.png",
    branding_dark_logo_context: "Subir logotipo del modo oscuro",
    branding_dark_logo_error: "Error al subir el logotipo del modo oscuro: {{error}}",
    branding_dark_logo_field_name: "Logotipo (modo oscuro)",
    branding_dark_logo_field_placeholder: "https://tu.domino/logo-modo-oscuro.png",
    check_connection_guide: "Gu\xeda de conexi\xf3n",
    enterprise_sso_deleted: "El conector de SSO empresarial se elimin\xf3 correctamente",
    delete_confirm_modal_title: "Eliminar conector de SSO empresarial",
    delete_confirm_modal_content: "\xbfSeguro que quieres eliminar este conector empresarial? Los usuarios de los proveedores de identidad no utilizar\xe1n el inicio de sesi\xf3n \xfanico.",
    upload_idp_metadata_title_saml: "Cargar los metadatos",
    upload_idp_metadata_description_saml: "Configure los metadatos copiados del proveedor de identidad.",
    upload_idp_metadata_title_oidc: "Cargar las credenciales",
    upload_idp_metadata_description_oidc: "Configure las credenciales y la informaci\xf3n del token OIDC copiados del proveedor de identidad.",
    upload_idp_metadata_button_text: "Cargar archivo XML de metadatos",
    upload_signing_certificate_button_text: "Cargar archivo de certificado de firma",
    configure_domain_field_info_text: "Agregue el dominio de correo electr\xf3nico para guiar a los usuarios empresariales a su proveedor de identidad para el inicio de sesi\xf3n \xfanico.",
    email_domain_field_required: "Se requiere el dominio de correo electr\xf3nico para habilitar el SSO empresarial.",
    upload_saml_idp_metadata_info_text_url: "Pegue la URL de metadatos del proveedor de identidad para conectar.",
    upload_saml_idp_metadata_info_text_xml: "Pegue los metadatos del proveedor de identidad para conectar.",
    upload_saml_idp_metadata_info_text_manual: "Complete los metadatos del proveedor de identidad para conectar.",
    upload_oidc_idp_info_text: "Complete la informaci\xf3n del proveedor de identidad para conectar.",
    service_provider_property_title: "Configurar en el IdP",
    service_provider_property_description: "Configure una integraci\xf3n de aplicaciones utilizando {{protocol}} en su proveedor de identidad. Ingrese los detalles proporcionados por Logto.",
    attribute_mapping_title: "Mapeo de atributos",
    attribute_mapping_description: "Sincronice perfiles de usuario desde el proveedor de identidad configurando el mapeo de atributos de usuario en el proveedor de identidad o en Logto.",
    saml_preview: {
        sign_on_url: "URL de inicio de sesi\xf3n",
        entity_id: "Emisor",
        x509_certificate: "Certificado de firma",
        certificate_content: "Caduca el {{date}}"
    },
    oidc_preview: {
        authorization_endpoint: "Punto de autorizaci\xf3n",
        token_endpoint: "Punto de token",
        userinfo_endpoint: "Punto de informaci\xf3n del usuario",
        jwks_uri: "Punto de conjunto de claves web JSON",
        issuer: "Emisor"
    }
};
var $6a94df51f8a55015$export$2e2bcd8739ae039 = Object.freeze($6a94df51f8a55015$var$enterprise_sso_details);


const $f45f1185b4d55084$var$enterprise_sso = {
    page_title: "SSO de la empresa",
    title: "SSO de la empresa",
    subtitle: "Conecta el proveedor de identidad de la empresa y habilita el inicio de sesi\xf3n \xfanico iniciado por el proveedor de servicios.",
    create: "Agregar conector de la empresa",
    col_connector_name: "Nombre del conector",
    col_type: "Tipo",
    col_email_domain: "Dominio de correo electr\xf3nico",
    placeholder_title: "Conector de la empresa",
    placeholder_description: "Logto ha proporcionado muchos proveedores de identidad empresariales integrados para conectarse, al mismo tiempo, puedes crear uno propio con los protocolos SAML y OIDC.",
    create_modal: {
        title: "Agregar conector de la empresa",
        text_divider: "O puedes personalizar tu conector con un protocolo est\xe1ndar.",
        connector_name_field_title: "Nombre del conector",
        connector_name_field_placeholder: "Por ejemplo, {corp. name} - {nombre del proveedor de identidad}",
        create_button_text: "Crear conector"
    },
    guide: {
        subtitle: "Una gu\xeda paso a paso para conectar el proveedor de identidad de la empresa.",
        finish_button_text: "Continuar"
    },
    basic_info: {
        title: "Configura tu servicio en el IdP",
        description: "Crea una nueva integraci\xf3n de aplicaci\xf3n mediante SAML 2.0 en tu proveedor de identidad {{name}}. Luego pega el siguiente valor en \xe9l.",
        saml: {
            acs_url_field_name: "URL de servicio de consumidor de aserciones (URL de respuesta)",
            audience_uri_field_name: "URI del p\xfablico (ID del SP entidad)"
        },
        oidc: {
            redirect_uri_field_name: "URI de redireccionamiento (URL de devoluci\xf3n de llamada)"
        }
    },
    attribute_mapping: {
        title: "Mapeo de atributos",
        description: "Los campos `id` y `email` son necesarios para sincronizar el perfil del usuario desde el IdP. Ingresa el siguiente nombre de reclamaci\xf3n y valor en tu IdP.",
        col_sp_claims: "Valor del proveedor de servicios (Logto)",
        col_idp_claims: "Nombre de la reclamaci\xf3n del proveedor de identidad",
        idp_claim_tooltip: "El nombre de la reclamaci\xf3n del proveedor de identidad"
    },
    metadata: {
        title: "Configurar los metadatos del IdP",
        description: "Configura los metadatos del proveedor de identidad",
        dropdown_trigger_text: "Usar otro m\xe9todo de configuraci\xf3n",
        dropdown_title: "selecciona tu m\xe9todo de configuraci\xf3n",
        metadata_format_url: "Ingresa la URL de los metadatos",
        metadata_format_xml: "Sube el archivo XML de los metadatos",
        metadata_format_manual: "Ingresa los detalles de los metadatos manualmente",
        saml: {
            metadata_url_field_name: "URL de metadatos",
            metadata_url_description: "Obt\xe9n din\xe1micamente los datos desde la URL de los metadatos y mant\xe9n el certificado actualizado.",
            metadata_xml_field_name: "Archivo XML de los metadatos del IdP",
            metadata_xml_uploader_text: "Subir archivo XML de los metadatos",
            sign_in_endpoint_field_name: "URL de inicio de sesi\xf3n",
            idp_entity_id_field_name: "ID del proveedor de identidad (Emisor)",
            certificate_field_name: "Certificado de firma",
            certificate_placeholder: "Copia y pega el certificado x509",
            certificate_required: "Se requiere un certificado de firma."
        },
        oidc: {
            client_id_field_name: "ID de cliente",
            client_secret_field_name: "Secreto de cliente",
            issuer_field_name: "Emisor",
            scope_field_name: "\xc1mbito"
        }
    }
};
var $f45f1185b4d55084$export$2e2bcd8739ae039 = Object.freeze($f45f1185b4d55084$var$enterprise_sso);


const $c19520b1cb06b2ca$var$errors = {
    something_went_wrong: "\xa1Oops! Algo sali\xf3 mal.",
    page_not_found: "P\xe1gina no encontrada",
    unknown_server_error: "Ocurri\xf3 un error desconocido en el servidor",
    empty: "Sin datos",
    missing_total_number: "No se puede encontrar Total-Number en los encabezados de respuesta",
    invalid_uri_format: "Formato de URI no v\xe1lido",
    invalid_origin_format: "Formato de origen de URI no v\xe1lido",
    invalid_json_format: "Formato JSON no v\xe1lido",
    invalid_regex: "Expresi\xf3n regular no v\xe1lida",
    invalid_error_message_format: "El formato del mensaje de error es inv\xe1lido.",
    required_field_missing: "Por favor ingrese {{field}}",
    required_field_missing_plural: "Tienes que ingresar al menos un {{field}}",
    more_details: "M\xe1s detalles",
    username_pattern_error: "El nombre de usuario solo debe contener letras, n\xfameros o guiones bajos y no debe comenzar con un n\xfamero.",
    email_pattern_error: "La direcci\xf3n de correo electr\xf3nico no es v\xe1lida.",
    phone_pattern_error: "El n\xfamero de tel\xe9fono no es v\xe1lido.",
    insecure_contexts: "Los contextos inseguros (no HTTPS) no son compatibles.",
    unexpected_error: "Ocurri\xf3 un error inesperado.",
    not_found: "404 no encontrado",
    create_internal_role_violation: 'Est\xe1s creando un nuevo rol interno que est\xe1 prohibido por Logto. Prueba con otro nombre que no comience con "#intern:".',
    should_be_an_integer: "Debe ser un n\xfamero entero.",
    number_should_be_between_inclusive: "Entonces el n\xfamero debe estar entre {{min}} y {{max}} (ambos inclusive)."
};
var $c19520b1cb06b2ca$export$2e2bcd8739ae039 = Object.freeze($c19520b1cb06b2ca$var$errors);


const $d3e1c8a7b6ed6e08$var$general = {
    placeholder: "Marcador de posici\xf3n",
    submit: "Enviar",
    skip: "Omitir",
    next: "Siguiente",
    back: "Atr\xe1s",
    retry: "Intentar de Nuevo",
    done: "Hecho",
    search: "Buscar",
    search_placeholder: "Buscar",
    clear_result: "Borrar Resultados",
    save: "Guardar",
    save_changes: "Guardar Cambios",
    saved: "Guardado",
    discard: "Descartar",
    loading: "Cargando...",
    redirecting: "Redirigiendo...",
    add: "Agregar",
    added: "Agregado",
    cancel: "Cancelar",
    confirm: "Confirmar",
    check_out: "Comprar",
    create: "Crear",
    set_up: "Configurar",
    customize: "Personalizar",
    enable: "Habilitar",
    reminder: "Recordatorio",
    edit: "Editar",
    delete: "Eliminar",
    deleted: "Eliminado",
    more_options: "M\xc1S OPCIONES",
    close: "Cerrar",
    copy: "Copiar",
    copying: "Copiando",
    copied: "Copiado",
    required: "Requerido",
    add_another: "Agregar Otro",
    create_another: "Crear otro",
    deletion_confirmation: "\xbfEst\xe1 seguro que desea eliminar este {{title}}?",
    settings_nav: "Configuraci\xf3n",
    unsaved_changes_warning: "Ha realizado algunos cambios. \xbfEst\xe1 seguro que desea salir de esta p\xe1gina?",
    leave_page: "Salir de la P\xe1gina",
    stay_on_page: "Permanecer en la P\xe1gina",
    type_to_search: "Escriba para buscar",
    got_it: "Entendido",
    continue: "Continuar",
    page_info: "{{min, number}}-{{max, number}} de {{total, number}}",
    learn_more: "Saber m\xe1s",
    tab_errors: "{{count, number}} errores",
    skip_for_now: "Omitir por ahora",
    remove: "Eliminar",
    visit: "Visitar",
    join: "Unirse",
    try_now: "Probar Ahora",
    multiple_form_field: "(M\xfaltiple)",
    demo: "Demostraci\xf3n",
    unnamed: "Sin nombre",
    view: "Ver",
    open: "Abrir",
    hide: "Ocultar",
    unknown_error: "Error desconocido, por favor int\xe9ntalo de nuevo m\xe1s tarde.",
    select: "Seleccionar",
    contact_us_action: "Cont\xe1ctanos",
    description: "Descripci\xf3n",
    name: "Nombre",
    add_field: "Agregar {{field}}",
    create_field: "Crear {{field}}",
    edit_field: "Editar {{field}}",
    delete_field: "Eliminar {{field}}",
    coming_soon: "Pr\xf3ximamente",
    or: "O "
};
var $d3e1c8a7b6ed6e08$export$2e2bcd8739ae039 = Object.freeze($d3e1c8a7b6ed6e08$var$general);


const $8591c1bb935bf573$var$get_started = {
    page_title: "Comenzar",
    title: "Algo para explorar que te ayudar\xe1 a tener \xe9xito",
    subtitle: "Algunas cosas que puedes hacer para obtener r\xe1pidamente el valor de Logto",
    develop: {
        title: "Desarrollar: Dedica 5 minutos para integrar tu aplicaci\xf3n",
        title_cloud: "Desarrollar: Integra tu aplicaci\xf3n de forma segura en minutos",
        subtitle_cloud: "O toma 5 minutos para integrar tu aplicaci\xf3n con nuestros SDKs y tutoriales preconstruidos."
    },
    customize: {
        title: "Personalizar: Ofrece una excelente experiencia de inicio de sesi\xf3n",
        preview: {
            title: "Ver la vista previa en directo de la experiencia de inicio de sesi\xf3n que acabas de personalizar",
            subtitle: "Prueba la experiencia de inicio de sesi\xf3n de Logto ahora y ve c\xf3mo funciona"
        },
        connector: {
            title: "A\xf1adir m\xe1s conectores para admitir m\xe1s m\xe9todos de inicio de sesi\xf3n sociales",
            subtitle: "Prueba el inicio de sesi\xf3n sin contrase\xf1a y habilita una experiencia segura y sin fricciones para tus clientes"
        },
        continue_customizing: "Contin\xfaa personalizando",
        try_now: "Pru\xe9balo ahora",
        add_more: "A\xf1adir m\xe1s"
    },
    secure: {
        title: "Seguro: Protege tus recursos"
    },
    manage: {
        title: "Gestionar: Define control de acceso para tu producto y usuarios",
        rbac: {
            title: "Agregar control de acceso basado en roles para proteger tus recursos",
            subtitle: "Controla tus recursos mediante una autorizaci\xf3n de roles escalable para diversos casos de uso"
        },
        create_roles: "Crear roles"
    },
    view_all: "Ver todo →"
};
var $8591c1bb935bf573$export$2e2bcd8739ae039 = Object.freeze($8591c1bb935bf573$var$get_started);


const $21db42fe01da6298$var$guide = {
    start_building: "Comenzar a construir",
    get_started: "Empezar",
    categories: {
        featured: "Popular y para ti",
        Traditional: "Aplicaci\xf3n web tradicional",
        SPA: "Aplicaci\xf3n de una sola p\xe1gina",
        Native: "Nativa",
        MachineToMachine: "M\xe1quina a m\xe1quina",
        Protected: "Integraci\xf3n no oficial",
        ThirdParty: "Aplicaci\xf3n de terceros"
    },
    filter: {
        title: "Filtrar framework",
        placeholder: "Buscar un framework"
    },
    checkout_tutorial: "Ver el tutorial de {{name}}",
    do_not_need_tutorial: "Si no necesitas un tutorial, puedes continuar sin una gu\xeda de framework",
    finish_and_done: "Terminar y finalizar",
    cannot_find_guide: "\xbfNo puedes encontrar tu gu\xeda?",
    describe_guide_looking_for: "Describe la gu\xeda que est\xe1s buscando",
    request_guide_successfully: "Tu solicitud ha sido enviada correctamente. \xa1Gracias!",
    app: {
        select_framework_or_tutorial: "Seleccionar un framework o tutorial",
        guide_modal_title: "Comenzar con el SDK y las gu\xedas",
        modal_subtitle: "Agiliza el proceso de desarrollo de tu aplicaci\xf3n con nuestro SDK preconstruido y tutoriales.",
        select_a_framework: "Seleccionar un framework",
        continue_without_framework: "Crear una aplicaci\xf3n sin framework",
        describe_guide_looking_for_placeholder: "Ej.: Quiero integrar Logto en mi aplicaci\xf3n de Angular."
    },
    api: {
        modal_title: "Comenzar con tutoriales",
        modal_subtitle: "Agiliza el proceso de desarrollo de tu aplicaci\xf3n con nuestros tutoriales preconstruidos.",
        select_a_tutorial: "Seleccionar un tutorial",
        continue_without_tutorial: "Continuar sin tutorial",
        describe_guide_looking_for_placeholder: "Ej.: Quiero proteger mi API utilizando deno."
    }
};
var $21db42fe01da6298$export$2e2bcd8739ae039 = Object.freeze($21db42fe01da6298$var$guide);


const $6850a4b6183cd6cf$var$invitation = {
    find_your_tenants: "Encuentra a tus inquilinos",
    find_tenants_description: "Tu direcci\xf3n de correo electr\xf3nico puede estar registrada con varios inquilinos. Puedes elegir unirte a los existentes o continuar creando uno nuevo.",
    create_new_tenant: "Crear un nuevo inquilino",
    email_not_match_title: "Actualmente has iniciado sesi\xf3n como\n{{email}}",
    email_not_match_description: "Por favor, inicia sesi\xf3n con la cuenta correcta para aceptar la invitaci\xf3n y convertirte en miembro de la organizaci\xf3n.",
    switch_account: "Inicia sesi\xf3n con otra cuenta",
    invalid_invitation_status: "Invitaci\xf3n inv\xe1lida. Por favor contacta al administrador e intenta nuevamente.",
    invitation_not_found: "Invitaci\xf3n no encontrada. Por favor, contacta al administrador."
};
var $6850a4b6183cd6cf$export$2e2bcd8739ae039 = Object.freeze($6850a4b6183cd6cf$var$invitation);


const $b2385dc7019df5f9$var$jwt_claims = {
    title: "JWT Personalizado",
    description: "Configure los reclamos personalizados del JWT para incluir en el token de acceso. Estos reclamos se pueden usar para pasar informaci\xf3n adicional a su aplicaci\xf3n.",
    user_jwt: {
        card_title: "Para usuario",
        card_field: "Token de acceso de usuario",
        card_description: "A\xf1adir datos espec\xedficos del usuario durante la emisi\xf3n del token de acceso.",
        for: "para usuario"
    },
    machine_to_machine_jwt: {
        card_title: "Para M2M",
        card_field: "Token de m\xe1quina a m\xe1quina",
        card_description: "A\xf1adir datos adicionales durante la emisi\xf3n del token de m\xe1quina a m\xe1quina.",
        for: "para M2M"
    },
    code_editor_title: "Personalizar los reclamos de {{token}}",
    custom_jwt_create_button: "A\xf1adir reclamos personalizados",
    custom_jwt_item: "Reclamos personalizados {{for}}",
    delete_modal_title: "Eliminar reclamos personalizados",
    delete_modal_content: "\xbfEst\xe1 seguro de que desea eliminar los reclamos personalizados?",
    clear: "Limpiar",
    cleared: "Limpiado",
    restore: "Restaurar valores predeterminados",
    restored: "Restaurado",
    data_source_tab: "Fuente de datos",
    test_tab: "Contexto de prueba",
    jwt_claims_description: "Los reclamos predeterminados se incluyen autom\xe1ticamente en el JWT y no se pueden anular.",
    user_data: {
        title: "Datos del usuario",
        subtitle: "Utilice el par\xe1metro de entrada `data.user` para proporcionar informaci\xf3n vital del usuario."
    },
    token_data: {
        title: "Datos del token",
        subtitle: "Utilice el par\xe1metro de entrada `token` para la carga \xfatil actual del token de acceso. "
    },
    fetch_external_data: {
        title: "Obtener datos externos",
        subtitle: "Incorpore datos de sus API externas directamente en los reclamos.",
        description: "Utilice la funci\xf3n `fetch` para llamar a sus API externas e incluir los datos en sus reclamos personalizados. Ejemplo: "
    },
    environment_variables: {
        title: "Establecer variables de entorno",
        subtitle: "Utilice variables de entorno para almacenar informaci\xf3n confidencial.",
        input_field_title: "A\xf1adir variables de entorno",
        sample_code: "Acceso a variables de entorno en el gestor de reclamos JWT personalizados. Ejemplo: "
    },
    jwt_claims_hint: "Limite los reclamos personalizados a menos de 50 KB. Los reclamos predeterminados del JWT se incluyen autom\xe1ticamente en el token y no se pueden anular.",
    tester: {
        subtitle: "Ajustar el token simulado y los datos de usuario para pruebas.",
        run_button: "Ejecutar prueba",
        result_title: "Resultado de prueba"
    },
    form_error: {
        invalid_json: "Formato JSON no v\xe1lido"
    }
};
var $b2385dc7019df5f9$export$2e2bcd8739ae039 = Object.freeze($b2385dc7019df5f9$var$jwt_claims);


const $3eb265ad96ad376a$var$log_details = {
    page_title: "Detalle del registro de auditor\xeda",
    back_to_logs: "Volver a los registros de auditor\xeda",
    back_to: "Volver a {{name}}",
    success: "\xc9xito",
    failed: "Fallido",
    event_key: "Clave del evento",
    application: "Aplicaci\xf3n",
    ip_address: "Direcci\xf3n IP",
    user: "Usuario",
    log_id: "ID de registro",
    time: "Tiempo",
    user_agent: "Agente de usuario",
    tab_details: "Detalles",
    raw_data: "Datos sin procesar"
};
var $3eb265ad96ad376a$export$2e2bcd8739ae039 = Object.freeze($3eb265ad96ad376a$var$log_details);


const $11a67ba80eb323b6$var$logs = {
    page_title: "Registros de auditor\xeda",
    title: "Registros de auditor\xeda",
    subtitle: "Ver datos de registro de eventos de autenticaci\xf3n realizados por sus usuarios.",
    event: "Evento",
    user: "Usuario",
    application: "Aplicaci\xf3n",
    time: "Tiempo",
    filter_by: "Filtrar por"
};
var $11a67ba80eb323b6$export$2e2bcd8739ae039 = Object.freeze($11a67ba80eb323b6$var$logs);


const $a8bbf46db54e7de0$var$menu = {
    profile: "Perfil",
    language: "Idioma",
    appearance: {
        label: "Apariencia",
        light: "Modo Claro",
        dark: "Modo Oscuro",
        system: "Sincronizar con el sistema"
    },
    sign_out: "Cerrar sesi\xf3n"
};
var $a8bbf46db54e7de0$export$2e2bcd8739ae039 = Object.freeze($a8bbf46db54e7de0$var$menu);


const $d286ff586698ec2a$var$mfa = {
    title: "Autenticaci\xf3n de m\xfaltiples factores",
    description: "Agrega autenticaci\xf3n de m\xfaltiples factores para elevar la seguridad de tu experiencia de inicio de sesi\xf3n.",
    factors: "Factores",
    multi_factors: "M\xfaltiples factores",
    multi_factors_description: "Los usuarios deben verificar uno de los factores habilitados para la verificaci\xf3n de dos pasos.",
    totp: "OTP de la aplicaci\xf3n autenticadora",
    otp_description: "Vincula Google Authenticator, etc., para verificar contrase\xf1as de un solo uso.",
    webauthn: "WebAuthn (Clave de paso)",
    webauthn_description: "Verifica a trav\xe9s de un m\xe9todo compatible con el navegador: biometr\xeda, escaneo de tel\xe9fono o clave de seguridad, etc.",
    webauthn_native_tip: "WebAuthn no es compatible con aplicaciones nativas.",
    webauthn_domain_tip: "WebAuthn vincula claves p\xfablicas al dominio espec\xedfico. Modificar el dominio del servicio bloquear\xe1 a los usuarios para autenticarse mediante claves de paso existentes.",
    backup_code: "C\xf3digo de respaldo",
    backup_code_description: "Genera 10 c\xf3digos de respaldo de un solo uso despu\xe9s de que los usuarios configuren cualquier m\xe9todo de MFA.",
    backup_code_setup_hint: "Cuando los usuarios no pueden verificar los factores de MFA anteriores, utiliza la opci\xf3n de respaldo.",
    backup_code_error_hint: "Para usar un c\xf3digo de respaldo, necesitas al menos un m\xe9todo de MFA adicional para una autenticaci\xf3n exitosa del usuario.",
    policy: "Pol\xedtica",
    policy_description: "Establece la pol\xedtica de MFA para los flujos de inicio de sesi\xf3n y registro.",
    two_step_sign_in_policy: "Pol\xedtica de verificaci\xf3n de dos pasos al iniciar sesi\xf3n",
    user_controlled: "Los usuarios pueden habilitar o deshabilitar MFA por s\xed mismos",
    user_controlled_tip: "Los usuarios pueden omitir la configuraci\xf3n de MFA la primera vez al iniciar sesi\xf3n o registrarse, o habilitar/deshabilitarla en la configuraci\xf3n de la cuenta.",
    mandatory: "Siempre se requiere que los usuarios usen MFA al iniciar sesi\xf3n",
    mandatory_tip: "Los usuarios deben configurar MFA la primera vez al iniciar sesi\xf3n o registrarse, y usarlo en todas las futuras sesiones de inicio de sesi\xf3n."
};
var $d286ff586698ec2a$export$2e2bcd8739ae039 = Object.freeze($d286ff586698ec2a$var$mfa);


const $c9e33373352f38fb$var$organization_details = {
    page_title: "Detalles de la organizaci\xf3n",
    delete_confirmation: "Una vez eliminada, todos los miembros perder\xe1n su membres\xeda y roles en esta organizaci\xf3n. Esta acci\xf3n no se puede deshacer.",
    organization_id: "ID de la organizaci\xf3n",
    settings_description: "Las organizaciones representan los equipos, clientes comerciales y empresas asociadas que pueden acceder a tus aplicaciones.",
    name_placeholder: "El nombre de la organizaci\xf3n, no es necesario que sea \xfanico.",
    description_placeholder: "Una descripci\xf3n de la organizaci\xf3n.",
    member: "Miembro",
    member_other: "Miembros",
    add_members_to_organization: "Agregar miembros a la organizaci\xf3n {{name}}",
    add_members_to_organization_description: "Encuentra usuarios apropiados buscando nombre, correo electr\xf3nico, tel\xe9fono o ID de usuario. Los miembros existentes no se muestran en los resultados de b\xfasqueda.",
    add_with_organization_role: "Agregar con rol(es) de organizaci\xf3n",
    user: "Usuario",
    authorize_to_roles: "Autorizar a {{name}} para acceder a los siguientes roles:",
    edit_organization_roles: "Editar roles de organizaci\xf3n",
    edit_organization_roles_of_user: "Editar roles de organizaci\xf3n de {{name}}",
    remove_user_from_organization: "Eliminar usuario de la organizaci\xf3n",
    remove_user_from_organization_description: "Una vez eliminado, el usuario perder\xe1 su membres\xeda y roles en esta organizaci\xf3n. Esta acci\xf3n no se puede deshacer.",
    search_user_placeholder: "Buscar por nombre, correo electr\xf3nico, tel\xe9fono o ID de usuario",
    at_least_one_user: "Se requiere al menos un usuario.",
    custom_data: "Datos personalizados",
    custom_data_tip: "Los datos personalizados son un objeto JSON que se puede usar para almacenar datos adicionales asociados con la organizaci\xf3n.",
    invalid_json_object: "Objeto JSON no v\xe1lido."
};
var $c9e33373352f38fb$export$2e2bcd8739ae039 = Object.freeze($c9e33373352f38fb$var$organization_details);


const $78f9166775dacb5f$var$organization_role_details = {
    page_title: "Detalles del rol de la organizaci\xf3n",
    back_to_org_roles: "Volver a los roles de la organizaci\xf3n",
    org_role: "Rol de la organizaci\xf3n",
    delete_confirm: "Al hacerlo, se eliminar\xe1n los permisos asociados con este rol de los usuarios afectados y se borrar\xe1n las relaciones entre roles de organizaci\xf3n, miembros en la organizaci\xf3n y permisos de organizaci\xf3n.",
    deleted: "El rol de organizaci\xf3n {{name}} se elimin\xf3 con \xe9xito.",
    permissions: {
        tab: "Permisos",
        name_column: "Permiso",
        description_column: "Descripci\xf3n",
        type_column: "Tipo de permiso",
        type: {
            api: "Permiso de API",
            org: "Permiso de organizaci\xf3n"
        },
        assign_permissions: "Asignar permisos",
        remove_permission: "Eliminar permiso",
        remove_confirmation: "Si este permiso se elimina, el usuario con este rol de organizaci\xf3n perder\xe1 el acceso otorgado por este permiso.",
        removed: "El permiso {{name}} se elimin\xf3 correctamente de este rol de organizaci\xf3n",
        assign_description: "Asigne permisos a los roles dentro de esta organizaci\xf3n. Estos pueden incluir tanto permisos de organizaci\xf3n como permisos de API.",
        organization_permissions: "Permisos de organizaci\xf3n",
        api_permissions: "Permisos de API",
        assign_organization_permissions: "Asignar permisos de organizaci\xf3n",
        assign_api_permissions: "Asignar permisos de API"
    },
    general: {
        tab: "General",
        settings: "Configuraci\xf3n",
        description: "El rol de organizaci\xf3n es un agrupamiento de permisos que se pueden asignar a los usuarios. Los permisos pueden provenir de los permisos de organizaci\xf3n predefinidos y permisos de API.",
        name_field: "Nombre",
        description_field: "Descripci\xf3n",
        description_field_placeholder: "Usuarios con permisos de solo lectura"
    }
};
var $78f9166775dacb5f$export$2e2bcd8739ae039 = Object.freeze($78f9166775dacb5f$var$organization_role_details);


const $3844caf613a37ac5$var$organization_template = {
    title: "Plantilla de organizaci\xf3n",
    subtitle: "En aplicaciones SaaS multiinquilino, una plantilla de organizaci\xf3n define pol\xedticas de control de acceso compartido (permisos y roles) para m\xfaltiples organizaciones.",
    roles: {
        tab_name: "Roles de org",
        search_placeholder: "Buscar por nombre de rol",
        create_title: "Crear rol de org",
        role_column: "Rol de org",
        permissions_column: "Permisos",
        placeholder_title: "Rol de organizaci\xf3n",
        placeholder_description: "El rol de organizaci\xf3n es un agrupamiento de permisos que se pueden asignar a los usuarios. Los permisos deben provenir de los permisos de organizaci\xf3n predefinidos.",
        create_modal: {
            title: "Crear rol de organizaci\xf3n",
            create: "Crear rol",
            name_field: "Nombre del rol",
            description_field: "Descripci\xf3n",
            created: "El rol de organizaci\xf3n {{name}} se ha creado correctamente."
        }
    },
    permissions: {
        tab_name: "Permisos de org",
        search_placeholder: "Buscar por nombre de permiso",
        create_org_permission: "Crear permiso de org",
        permission_column: "Permiso de organizaci\xf3n",
        description_column: "Descripci\xf3n",
        placeholder_title: "Permiso de organizaci\xf3n",
        placeholder_description: "El permiso de organizaci\xf3n se refiere a la autorizaci\xf3n para acceder a un recurso en el contexto de la organizaci\xf3n.",
        delete_confirm: "Si se elimina este permiso, todos los roles de organizaci\xf3n que incluyan este permiso perder\xe1n dicho permiso, y los usuarios que ten\xedan este permiso perder\xe1n el acceso concedido por \xe9l.",
        create_title: "Crear permiso de organizaci\xf3n",
        edit_title: "Editar permiso de organizaci\xf3n",
        permission_field_name: "Nombre del permiso",
        description_field_name: "Descripci\xf3n",
        description_field_placeholder: "Leer historial de citas",
        create_permission: "Crear permiso",
        created: "Se ha creado correctamente el permiso de organizaci\xf3n {{name}}."
    }
};
var $3844caf613a37ac5$export$2e2bcd8739ae039 = Object.freeze($3844caf613a37ac5$var$organization_template);


const $91a6b3b1b25ee53c$var$organizations = {
    organization: "Organizaci\xf3n",
    page_title: "Organizaciones",
    title: "Organizaciones",
    subtitle: "Las organizaciones suelen utilizarse en aplicaciones SaaS u aplicaciones similares de m\xfaltiples inquilinos y representan a sus clientes que son equipos, organizaciones o empresas enteras. Las organizaciones trabajan como un elemento fundamental para la autenticaci\xf3n y autorizaci\xf3n de B2B.",
    organization_template: "Plantilla de organizaci\xf3n",
    organization_id: "ID de la organizaci\xf3n",
    members: "Miembros",
    create_organization: "Crear organizaci\xf3n",
    setup_organization: "Configurar su organizaci\xf3n",
    organization_list_placeholder_title: "Organizaci\xf3n",
    organization_list_placeholder_text: "Las organizaciones suelen utilizarse en aplicaciones SaaS u aplicaciones similares de m\xfaltiples inquilinos como mejor pr\xe1ctica. Le permiten desarrollar aplicaciones que permiten a los clientes crear y gestionar organizaciones, invitar miembros y asignar roles.",
    organization_name_placeholder: "Mi organizaci\xf3n",
    organization_description_placeholder: "Una breve descripci\xf3n de la organizaci\xf3n",
    organization_permission: "Permiso de la organizaci\xf3n",
    organization_permission_other: "Permisos de la organizaci\xf3n",
    create_permission_placeholder: "Leer historial de citas",
    organization_role: "Rol de la organizaci\xf3n",
    organization_role_other: "Roles de la organizaci\xf3n",
    organization_role_description: "El rol de la organizaci\xf3n es un agrupamiento de permisos que se pueden asignar a los usuarios. Los permisos deben provenir de los permisos de organizaci\xf3n predefinidos.",
    role: "Rol",
    search_placeholder: "Buscar por nombre de organizaci\xf3n o ID",
    search_role_placeholder: "Escribe para buscar y seleccionar roles",
    empty_placeholder: "\uD83E\uDD14 No has configurado ning\xfan {{entity}} todav\xeda.",
    organization_and_member: "Organizaci\xf3n y miembro",
    organization_and_member_description: 'La organizaci\xf3n es un grupo de usuarios y puede representar a los equipos, clientes comerciales y empresas asociadas, siendo cada usuario un "Miembro". Estos pueden ser entidades fundamentales para manejar sus requisitos multinivel.',
    guide: {
        title: "Comience con gu\xedas",
        subtitle: "Inicie la configuraci\xf3n de su organizaci\xf3n con nuestras gu\xedas",
        introduction: {
            title: "Comprenda c\xf3mo funciona la organizaci\xf3n en Logto",
            section_1: {
                title: "Una organizaci\xf3n es un grupo de usuarios (identidades)"
            },
            section_2: {
                title: "La plantilla de organizaci\xf3n est\xe1 dise\xf1ada para el control de acceso de aplicaciones multiinquilino",
                description: 'En aplicaciones SaaS multiinquilino, varias organizaciones a menudo comparten la misma plantilla de control de acceso, que incluye permisos y roles. En Logto, lo llamamos "plantilla de organizaci\xf3n".',
                permission_description: "El permiso de la organizaci\xf3n se refiere a la autorizaci\xf3n para acceder a un recurso en el contexto de la organizaci\xf3n.",
                role_description_deprecated: "El rol de la organizaci\xf3n es un agrupamiento de permisos de organizaci\xf3n que se pueden asignar a los miembros.",
                role_description: "El rol de la organizaci\xf3n es un agrupamiento de permisos de la organizaci\xf3n o permisos de API que se pueden asignar a los miembros."
            },
            section_3: {
                title: "\xbfPuedo asignar permisos de API a roles de organizaci\xf3n?",
                description: "S\xed, puedes asignar permisos de API a roles de organizaci\xf3n. Logto ofrece la flexibilidad para gestionar los roles de tu organizaci\xf3n de manera efectiva, permiti\xe9ndote incluir tanto permisos de organizaci\xf3n como permisos de API dentro de esos roles."
            },
            section_4: {
                title: "Interact\xfae con la ilustraci\xf3n para ver c\xf3mo se conecta todo",
                description: "Tomemos un ejemplo. John y Sarah est\xe1n en diferentes organizaciones con diferentes roles en el contexto de diferentes organizaciones. Despl\xe1cese sobre los diferentes m\xf3dulos y vea qu\xe9 sucede."
            }
        },
        organization_permissions: "Permisos de la organizaci\xf3n",
        organization_roles: "Roles de la organizaci\xf3n",
        admin: "Admin",
        member: "Miembro",
        guest: "Invitado",
        role_description: 'El rol "{{role}}" comparte la misma plantilla de organizaci\xf3n en diferentes organizaciones.',
        john: "John",
        john_tip: 'John pertenece a dos organizaciones con el correo electr\xf3nico "john@email.com" como \xfanico identificador. Es el administrador de la organizaci\xf3n A y tambi\xe9n el invitado de la organizaci\xf3n B.',
        sarah: "Sarah",
        sarah_tip: 'Sarah pertenece a una organizaci\xf3n con el correo electr\xf3nico "sarah@email.com" como \xfanico identificador. Es la administradora de la organizaci\xf3n B.'
    }
};
var $91a6b3b1b25ee53c$export$2e2bcd8739ae039 = Object.freeze($91a6b3b1b25ee53c$var$organizations);


const $7a34105c627dfe70$var$permissions = {
    search_placeholder: "Buscar por API o nombre de permiso",
    search_placeholder_without_api: "Buscar por nombre de permiso",
    name_column: "Permiso",
    description_column: "Descripci\xf3n",
    api_column: "API",
    placeholder_title: "Permiso",
    placeholder_description: "Permiso se refiere a la autorizaci\xf3n para acceder a un recurso (lo llamamos recurso de API).",
    edit: "Permiso de edici\xf3n",
    delete: "Permiso de eliminaci\xf3n",
    remove: "Permiso de remover",
    edit_title: "Editar permiso de API"
};
var $7a34105c627dfe70$export$2e2bcd8739ae039 = Object.freeze($7a34105c627dfe70$var$permissions);


const $2ac73be060061e14$var$profile = {
    page_title: "Configuraci\xf3n de cuenta",
    title: "Configuraci\xf3n de cuenta",
    description: "Cambie su configuraci\xf3n de cuenta y administre su informaci\xf3n personal aqu\xed para garantizar la seguridad de su cuenta.",
    settings: {
        title: "AJUSTES DE PERFIL",
        profile_information: "Informaci\xf3n del perfil",
        avatar: "Avatar",
        name: "Nombre",
        username: "Nombre de usuario"
    },
    link_account: {
        title: "ENLAZAR CUENTA",
        email_sign_in: "Inicio de sesi\xf3n por correo electr\xf3nico",
        email: "Correo electr\xf3nico",
        social_sign_in: "Inicio de sesi\xf3n social",
        link_email: "Vincular correo electr\xf3nico",
        link_email_subtitle: "Vincule su correo electr\xf3nico para iniciar sesi\xf3n o ayudar con la recuperaci\xf3n de la cuenta.",
        email_required: "Se requiere correo electr\xf3nico",
        invalid_email: "Direcci\xf3n de correo electr\xf3nico no v\xe1lida",
        identical_email_address: "La direcci\xf3n de correo electr\xf3nico de entrada es id\xe9ntica a la actual",
        anonymous: "An\xf3nimo"
    },
    password: {
        title: "CONTRASE\xd1A Y SEGURIDAD",
        password: "Contrase\xf1a",
        password_setting: "Configuraci\xf3n de contrase\xf1a",
        new_password: "Nueva contrase\xf1a",
        confirm_password: "Confirmar contrase\xf1a",
        enter_password: "Ingrese la contrase\xf1a actual",
        enter_password_subtitle: "Verifica que eres t\xfa para proteger la seguridad de tu cuenta. Por favor, ingresa tu contrase\xf1a actual antes de cambiarla.",
        set_password: "Establecer contrase\xf1a",
        verify_via_password: "Verificar mediante contrase\xf1a",
        show_password: "Mostrar contrase\xf1a",
        required: "Se requiere contrase\xf1a",
        do_not_match: "Las contrase\xf1as no coinciden. Int\xe9ntelo de nuevo."
    },
    code: {
        enter_verification_code: "Ingrese el c\xf3digo de verificaci\xf3n",
        enter_verification_code_subtitle: "El c\xf3digo de verificaci\xf3n se ha enviado a <strong>{{target}}</strong>",
        verify_via_code: "Verificar mediante el c\xf3digo de verificaci\xf3n",
        resend: "Reenviar c\xf3digo de verificaci\xf3n",
        resend_countdown: "Reenviar en {{countdown}} segundos"
    },
    delete_account: {
        title: "ELIMINAR CUENTA",
        label: "Eliminar cuenta",
        description: "La eliminaci\xf3n de su cuenta eliminar\xe1 toda su informaci\xf3n personal, datos de usuario y configuraci\xf3n. Esta acci\xf3n no se puede deshacer.",
        button: "Eliminar cuenta",
        dialog_paragraph_1: "Lamentamos mucho que quiera eliminar su cuenta. La eliminaci\xf3n de su cuenta eliminar\xe1 permanentemente todos los datos, incluida la informaci\xf3n del usuario, los registros y la configuraci\xf3n, y esta acci\xf3n no se puede deshacer. Por lo tanto, aseg\xfarese de realizar una copia de seguridad de cualquier dato importante antes de continuar.",
        dialog_paragraph_2: 'Para iniciar el proceso de eliminaci\xf3n de la cuenta, env\xede un correo electr\xf3nico a nuestro equipo de soporte en <a>{{mail}}</a> con el asunto "Solicitud de eliminaci\xf3n de cuenta". Le ayudaremos y nos aseguraremos de que todos sus datos se eliminen correctamente de nuestro sistema.',
        dialog_paragraph_3: "Gracias por elegir Logto Cloud. Si tiene m\xe1s preguntas o inquietudes, no dude en comunicarse con nosotros."
    },
    set: "Establecer",
    change: "Cambiar",
    link: "Vincular",
    unlink: "Desvincular",
    not_set: "No configurado",
    change_avatar: "Cambiar avatar",
    change_name: "Cambiar nombre",
    change_username: "Cambiar nombre de usuario",
    set_name: "Establecer nombre",
    email_changed: "\xa1Se cambi\xf3 el correo electr\xf3nico.",
    password_changed: "\xa1Se cambi\xf3 la contrase\xf1a.",
    updated: "\xa1{{target}} actualizado.",
    linked: "\xa1{{target}} vinculado.",
    unlinked: "\xa1{{target}} desvinculado.",
    email_exists_reminder: "Este correo electr\xf3nico {{email}} est\xe1 asociado con una cuenta existente. Vincule otro correo electr\xf3nico aqu\xed.",
    unlink_confirm_text: "S\xed, desvincular",
    unlink_reminder: "Los usuarios no podr\xe1n iniciar sesi\xf3n con la cuenta <span></span> si la desvincula. \xbfEst\xe1s seguro de que quieres continuar?"
};
var $2ac73be060061e14$export$2e2bcd8739ae039 = Object.freeze($2ac73be060061e14$var$profile);


const $4871ac3783482c71$var$protected_app = {
    name: "Aplicaci\xf3n Protegida",
    title: "Crea una Aplicaci\xf3n Protegida: Agrega autenticaci\xf3n con simplicidad y velocidad \xe9pica",
    description: "Aplicaci\xf3n Protegida mantiene las sesiones de usuario de forma segura y redirige las peticiones de tu aplicaci\xf3n. Potenciado por Cloudflare Workers, disfruta del rendimiento de primera clase y 0ms de arranque en fr\xedo en todo el mundo. <a>Aprende m\xe1s</a>",
    fast_create: "Creaci\xf3n r\xe1pida",
    modal_title: "Crear Aplicaci\xf3n Protegida",
    modal_subtitle: "Habilita protecci\xf3n segura y r\xe1pida con solo unos clics. Agrega autenticaci\xf3n a tu aplicaci\xf3n web existente con facilidad.",
    form: {
        url_field_label: "La URL de origen",
        url_field_placeholder: "https://dominio.com/",
        url_field_description: "Proporciona la direcci\xf3n de tu aplicaci\xf3n que requiere protecci\xf3n de autenticaci\xf3n.",
        url_field_modification_notice: "Las modificaciones en la URL de origen pueden tardar de 1 a 2 minutos en ser efectivas en todas las ubicaciones de la red mundial.",
        url_field_tooltip: "Proporciona la direcci\xf3n de tu aplicaci\xf3n, excluyendo '/ruta'. Despu\xe9s de la creaci\xf3n, puedes personalizar las reglas de autenticaci\xf3n en la ruta.\n\nNota: La URL de origen en s\xed no necesita autenticaci\xf3n; la protecci\xf3n se aplica exclusivamente a los accesos a trav\xe9s del dominio de la aplicaci\xf3n designada.",
        domain_field_label: "Dominio de la aplicaci\xf3n",
        domain_field_placeholder: "tu-dominio",
        domain_field_description: "Esta URL sirve como un proxy de protecci\xf3n de autenticaci\xf3n para la URL original. Se puede aplicar un dominio personalizado despu\xe9s de la creaci\xf3n.",
        domain_field_description_short: "Esta URL sirve como un proxy de protecci\xf3n de autenticaci\xf3n para la URL original.",
        domain_field_tooltip: "Las aplicaciones protegidas por Logto se alojar\xe1n en 'tu-dominio.{{dominio}}' de forma predeterminada. Se puede aplicar un dominio personalizado despu\xe9s de la creaci\xf3n.",
        create_application: "Crear aplicaci\xf3n",
        create_protected_app: "Creaci\xf3n r\xe1pida",
        errors: {
            domain_required: "Se requiere tu dominio.",
            domain_in_use: "Este nombre de subdominio ya est\xe1 en uso.",
            invalid_domain_format: "Formato de subdominio no v\xe1lido: usa solo letras min\xfasculas, n\xfameros y guiones '-'.",
            url_required: "La URL de origen es requerida.",
            invalid_url: "Formato de URL de origen no v\xe1lido: Usar http:// o https://. Nota: '/ruta' no es compatible actualmente.",
            localhost: "Por favor, expone tu servidor local a internet primero. Aprende m\xe1s sobre el <a>desarrollo local</a>."
        }
    },
    success_message: "\uD83C\uDF89 \xa1La autenticaci\xf3n de la aplicaci\xf3n se ha habilitado con \xe9xito! Explora la nueva experiencia de tu sitio web."
};
var $4871ac3783482c71$export$2e2bcd8739ae039 = Object.freeze($4871ac3783482c71$var$protected_app);


const $3255a7f9f330adb7$var$role_details = {
    back_to_roles: "Volver a roles",
    identifier: "Identificador",
    delete_description: "Al hacerlo, se eliminar\xe1n los permisos asociados con este rol de los usuarios afectados y se eliminar\xe1 la asignaci\xf3n entre roles, usuarios y permisos.",
    role_deleted: "{{name}} fue eliminado correctamente.",
    general_tab: "General",
    users_tab: "Usuarios",
    m2m_apps_tab: "Aplicaciones de m\xe1quina a m\xe1quina",
    permissions_tab: "Permisos",
    settings: "Configuraci\xf3n",
    settings_description: "Los roles son un agrupamiento de permisos que se pueden asignar a los usuarios. Tambi\xe9n proporcionan una manera de agregar permisos definidos para diferentes APIs, lo que hace m\xe1s eficiente agregar, eliminar o ajustar permisos en comparaci\xf3n con asignarlos individualmente a los usuarios.",
    field_name: "Nombre",
    field_description: "Descripci\xf3n",
    field_is_default: "Rol por defecto",
    field_is_default_description: "Establecer este rol como un rol por defecto para los nuevos usuarios. Se pueden establecer varios roles por defecto. Esto tambi\xe9n afectar\xe1 a los roles por defecto para los usuarios creados a trav\xe9s de la API de gesti\xf3n.",
    type_m2m_role_tag: "Rol de aplicaci\xf3n de m\xe1quina a m\xe1quina",
    type_user_role_tag: "Rol de usuario",
    m2m_role_notification: "Asigne este rol de m\xe1quina a m\xe1quina a una aplicaci\xf3n de m\xe1quina a m\xe1quina para otorgar acceso a los recursos de API relativos. <a>Cree primero una aplicaci\xf3n de m\xe1quina a m\xe1quina</a> si a\xfan no lo ha hecho.",
    permission: {
        assign_button: "Asignar permisos",
        assign_title: "Asignar permisos",
        assign_subtitle: "Asigne permisos a este rol. El rol adquirir\xe1 los permisos agregados y los usuarios con este rol heredar\xe1n estos permisos.",
        assign_form_field: "Asignar permisos",
        added_text_one: "{{count, number}} permiso agregado",
        added_text_other: "{{count, number}} permisos agregados",
        api_permission_count_one: "{{count, number}} permiso",
        api_permission_count_other: "{{count, number}} permisos",
        confirm_assign: "Asignar permisos",
        permission_assigned: "Los permisos seleccionados se asignaron correctamente a este rol",
        deletion_description: "Si se elimina este permiso, el usuario afectado con este rol perder\xe1 el acceso otorgado por este permiso.",
        permission_deleted: 'El permiso "{{name}}" fue eliminado correctamente de este rol',
        empty: "No hay permisos disponibles"
    },
    users: {
        assign_button: "Asignar usuarios",
        name_column: "Usuario",
        app_column: "Aplicaci\xf3n",
        latest_sign_in_column: "\xdaltimo inicio de sesi\xf3n",
        delete_description: "Permanecer\xe1 en su conjunto de usuarios, pero perder\xe1 la autorizaci\xf3n para este rol.",
        deleted: "{{name}} fue eliminado correctamente de este rol",
        assign_title: "Asignar usuarios",
        assign_subtitle: "Asignar usuarios a este rol. Encuentre usuarios apropiados buscando nombre, correo electr\xf3nico, tel\xe9fono o ID de usuario.",
        assign_field: "Asignar usuarios",
        confirm_assign: "Asignar usuarios",
        assigned_toast_text: "Los usuarios seleccionados se asignaron correctamente a este rol",
        empty: "No hay usuarios disponibles"
    },
    applications: {
        assign_button: "Asignar aplicaciones",
        name_column: "Aplicaci\xf3n",
        app_column: "Aplicaciones",
        description_column: "Descripci\xf3n",
        delete_description: "Permanecer\xe1 en su conjunto de aplicaciones, pero perder\xe1 la autorizaci\xf3n para este rol.",
        deleted: "{{name}} se elimin\xf3 correctamente de este rol",
        assign_title: "Asignar aplicaciones",
        assign_subtitle: "Asignar aplicaciones a este rol. Encuentre las aplicaciones adecuadas buscando el nombre, la descripci\xf3n o el ID de la aplicaci\xf3n.",
        assign_field: "Asignar aplicaciones",
        confirm_assign: "Asignar aplicaciones",
        assigned_toast_text: "Las aplicaciones seleccionadas se asignaron correctamente a este rol",
        empty: "No hay aplicaciones disponibles"
    }
};
var $3255a7f9f330adb7$export$2e2bcd8739ae039 = Object.freeze($3255a7f9f330adb7$var$role_details);


const $4b3b76703f91b201$var$roles = {
    page_title: "Roles",
    title: "Roles",
    subtitle: "Los roles incluyen permisos que determinan lo que un usuario puede hacer. RBAC utiliza roles para dar acceso a recursos a los usuarios para acciones espec\xedficas.",
    create: "Crear Rol",
    role_name: "Nombre de rol",
    role_type: "Tipo de rol",
    show_role_type_button_text: "Mostrar m\xe1s opciones",
    hide_role_type_button_text: "Ocultar m\xe1s opciones",
    type_user: "Rol de usuario",
    type_machine_to_machine: "Rol de aplicaci\xf3n de m\xe1quina a m\xe1quina",
    role_description: "Descripci\xf3n",
    role_name_placeholder: "Ingrese el nombre de su rol",
    role_description_placeholder: "Ingrese la descripci\xf3n de su rol",
    col_roles: "Roles",
    col_type: "Tipo",
    col_description: "Descripci\xf3n",
    col_assigned_entities: "Asignados",
    user_counts: "{{count}} usuarios",
    application_counts: "{{count}} aplicaciones",
    user_count: "{{count}} usuario",
    application_count: "{{count}} aplicaci\xf3n",
    assign_permissions: "Asignar permisos",
    create_role_title: "Crear Rol",
    create_role_description: "Cree y administre roles para sus aplicaciones. Los roles contienen colecciones de permisos y pueden asignarse a los usuarios.",
    create_role_button: "Crear Rol",
    role_created: "El rol {{name}} se ha creado satisfactoriamente.",
    search: "Buscar por nombre de rol, descripci\xf3n o ID",
    placeholder_title: "Roles",
    placeholder_description: "Los roles son un grupo de permisos que se pueden asignar a los usuarios. Aseg\xfarese de agregar permisos antes de crear roles.",
    assign_user_roles: "Asignar roles de usuario",
    assign_m2m_roles: "Asignar roles de m\xe1quina a m\xe1quina",
    management_api_access_notification: "Para acceder a la API de gesti\xf3n de Logto, seleccione roles con permisos de API de gesti\xf3n <flag/>.",
    with_management_api_access_tip: "Este rol de m\xe1quina a m\xe1quina incluye permisos para la API de gesti\xf3n de Logto"
};
var $4b3b76703f91b201$export$2e2bcd8739ae039 = Object.freeze($4b3b76703f91b201$var$roles);


const $2e05a5112ca680b0$var$session_expired = {
    title: "Sesi\xf3n expirada",
    subtitle: "Es posible que su sesi\xf3n haya expirado y se haya desconectado. Haga clic en el bot\xf3n de abajo para iniciar sesi\xf3n en la consola de administraci\xf3n nuevamente.",
    button: "Iniciar sesi\xf3n de nuevo"
};
var $2e05a5112ca680b0$export$2e2bcd8739ae039 = Object.freeze($2e05a5112ca680b0$var$session_expired);


const $6dbe463fbb91eac7$var$content = {
    terms_of_use: {
        title: "TERMS",
        terms_of_use: "Terms of use URL",
        terms_of_use_placeholder: "https://your.terms.of.use/",
        privacy_policy: "Privacy policy URL",
        privacy_policy_placeholder: "https://your.privacy.policy/"
    },
    languages: {
        title: "LANGUAGES",
        enable_auto_detect: "Enable auto-detect",
        description: "Your software detects the user's locale setting and switches to the local language. You can add new languages by translating UI from English to another language.",
        manage_language: "Manage language",
        default_language: "Default language",
        default_language_description_auto: "The default language will be used when the detected user language isn’t covered in the current language library.",
        default_language_description_fixed: "When auto-detect is off, the default language is the only language your software will show. Turn on auto-detect for language extension."
    },
    manage_language: {
        title: "Manage language",
        subtitle: "Localize the product experience by adding languages and translations. Your contribution can be set as the default language.",
        add_language: "Add Language",
        logto_provided: "Logto provided",
        key: "Key",
        logto_source_values: "Logto source values",
        custom_values: "Custom values",
        clear_all_tip: "Clear all values",
        unsaved_description: "Changes won’t be saved if you leave this page without saving.",
        deletion_tip: "Delete the language",
        deletion_title: "Do you want to delete the added language?",
        deletion_description: "After deletion, your users won’t be able to browse in that language again.",
        default_language_deletion_title: "Default language can’t be deleted.",
        default_language_deletion_description: "{{language}} is set as your default language and can’t be deleted. "
    }
};
var $6dbe463fbb91eac7$export$2e2bcd8739ae039 = Object.freeze($6dbe463fbb91eac7$var$content);


const $1b2acd0096b882eb$var$password_policy = {
    password_requirements: "Requisitos de contrase\xf1a",
    minimum_length: "Longitud m\xednima",
    minimum_length_description: "NIST sugiere usar <a>al menos 8 caracteres</a> para productos web.",
    minimum_length_error: "La longitud m\xednima debe estar entre {{min}} y {{max}} (inclusive).",
    minimum_required_char_types: "Tipos de caracteres requeridos m\xednimos",
    minimum_required_char_types_description: "Tipos de caracteres: may\xfasculas (A-Z), min\xfasculas (a-z), n\xfameros (0-9) y s\xedmbolos especiales ({{symbols}}).",
    password_rejection: "Rechazo de contrase\xf1a",
    compromised_passwords: "Contrase\xf1as comprometidas",
    breached_passwords: "Contrase\xf1as vulneradas",
    breached_passwords_description: "Rechazar contrase\xf1as encontradas previamente en bases de datos de vulnerabilidad.",
    restricted_phrases: "Restringir frases de baja seguridad",
    restricted_phrases_tooltip: "Su contrase\xf1a debe evitar estas frases a menos que combine con 3 o m\xe1s caracteres adicionales.",
    repetitive_or_sequential_characters: "Caracteres repetitivos o secuenciales",
    repetitive_or_sequential_characters_description: 'Por ejemplo, "AAAA", "1234" y "abcd".',
    user_information: "Informaci\xf3n de usuario",
    user_information_description: "Por ejemplo, direcci\xf3n de correo electr\xf3nico, n\xfamero de tel\xe9fono, nombre de usuario, etc.",
    custom_words: "Palabras personalizadas",
    custom_words_description: "Personaliza las palabras espec\xedficas del contexto, sin importar las may\xfasculas y min\xfasculas, y una por l\xednea.",
    custom_words_placeholder: "Nombre de su servicio, nombre de la empresa, etc."
};
var $1b2acd0096b882eb$export$2e2bcd8739ae039 = Object.freeze($1b2acd0096b882eb$var$password_policy);


const $043ed920080cc79e$var$sign_up_and_sign_in = {
    identifiers_email: "Direcci\xf3n de correo electr\xf3nico",
    identifiers_phone: "N\xfamero de tel\xe9fono",
    identifiers_username: "Nombre de usuario",
    identifiers_email_or_sms: "Direcci\xf3n de correo electr\xf3nico o n\xfamero de tel\xe9fono",
    identifiers_none: "No aplicable",
    and: "y",
    or: "o",
    sign_up: {
        title: "REGISTRARSE",
        sign_up_identifier: "Identificador de registro",
        identifier_description: "El identificador de registro es necesario para la creaci\xf3n de la cuenta y debe incluirse en la pantalla de inicio de sesi\xf3n.",
        sign_up_authentication: "Configuraci\xf3n de autenticaci\xf3n para el registro",
        authentication_description: "Todas las acciones seleccionadas ser\xe1n obligatorias para que los usuarios completen el proceso.",
        set_a_password_option: "Crear una contrase\xf1a",
        verify_at_sign_up_option: "Verificar al registrarse",
        social_only_creation_description: "(Esto se aplica solo a la creaci\xf3n de cuentas mediante redes sociales)"
    },
    sign_in: {
        title: "INICIAR SESI\xd3N",
        sign_in_identifier_and_auth: "Identificador y configuraci\xf3n de autenticaci\xf3n para iniciar sesi\xf3n",
        description: "Los usuarios pueden iniciar sesi\xf3n usando cualquiera de las opciones disponibles. Ajusta el dise\xf1o arrastrando y soltando las opciones a continuaci\xf3n.",
        add_sign_in_method: "Agregar m\xe9todo de inicio de sesi\xf3n",
        password_auth: "Contrase\xf1a",
        verification_code_auth: "C\xf3digo de verificaci\xf3n",
        auth_swap_tip: "Intercambia las opciones a continuaci\xf3n para determinar cu\xe1l aparece primero en el proceso.",
        require_auth_factor: "Debes seleccionar al menos un factor de autenticaci\xf3n."
    },
    social_sign_in: {
        title: "INICIO DE SESI\xd3N SOCIAL",
        social_sign_in: "Inicio de sesi\xf3n social",
        description: "Dependiendo del identificador obligatorio que hayas establecido, se puede solicitar al usuario que proporcione un identificador al registrarse mediante un conector social.",
        add_social_connector: "Agregar conector social",
        set_up_hint: {
            not_in_list: "\xbfNo est\xe1 en la lista?",
            set_up_more: "Configura",
            go_to: "otros conectores sociales ahora."
        }
    },
    tip: {
        set_a_password: "Es esencial que se establezca una contrase\xf1a \xfanica para que coincida con tu nombre de usuario.",
        verify_at_sign_up: "Actualmente solo admitimos correo electr\xf3nico verificado. Tu base de usuarios puede contener un gran n\xfamero de direcciones de correo electr\xf3nico de baja calidad si no se valida.",
        password_auth: "Es esencial ya que has habilitado la opci\xf3n de establecer una contrase\xf1a durante el proceso de registro.",
        verification_code_auth: "Es esencial ya que solo has habilitado la opci\xf3n de proporcionar un c\xf3digo de verificaci\xf3n al registrarse. Se puede desactivar la opci\xf3n si se permite la configuraci\xf3n de contrase\xf1a durante el proceso de registro.",
        delete_sign_in_method: "Es esencial ya que has seleccionado {{identifier}} como identificador obligatorio."
    },
    advanced_options: {
        title: "OPCIONES AVANZADAS",
        enable_single_sign_on: "Habilitar inicio de sesi\xf3n \xfanico de empresa (SSO)",
        enable_single_sign_on_description: "Habilitar a los usuarios para iniciar sesi\xf3n en la aplicaci\xf3n mediante el inicio de sesi\xf3n \xfanico con sus identidades empresariales.",
        single_sign_on_hint: {
            prefix: "Ir a ",
            link: '"Enterprise SSO"',
            suffix: "secci\xf3n para configurar m\xe1s conectores empresariales."
        },
        enable_user_registration: "Habilitar registro de usuario",
        enable_user_registration_description: "Habilitar o deshabilitar el registro de usuarios. Una vez deshabilitado, los usuarios a\xfan se pueden agregar en la consola de administraci\xf3n, pero los usuarios ya no pueden establecer cuentas a trav\xe9s de la interfaz de inicio de sesi\xf3n."
    }
};
var $043ed920080cc79e$export$2e2bcd8739ae039 = Object.freeze($043ed920080cc79e$var$sign_up_and_sign_in);


const $1d14355728cf4850$var$sign_in_exp = {
    page_title: "Experiencia de inicio de sesi\xf3n",
    title: "Experiencia de inicio de sesi\xf3n",
    description: "Personalice la interfaz de inicio de sesi\xf3n para que se adapte a su marca y visualice en tiempo real",
    tabs: {
        branding: "Branding",
        sign_up_and_sign_in: "Registro e inicio de sesi\xf3n",
        content: "Contenido",
        password_policy: "Pol\xedtica de contrase\xf1a"
    },
    welcome: {
        title: "Personalice la experiencia de inicio de sesi\xf3n",
        description: "Comience r\xe1pidamente con su primera configuraci\xf3n de inicio de sesi\xf3n. Esta gu\xeda lo guiar\xe1 a trav\xe9s de todas las configuraciones necesarias.",
        get_started: "Comenzar",
        apply_remind: "Tenga en cuenta que la experiencia de inicio de sesi\xf3n se aplicar\xe1 a todas las aplicaciones de esta cuenta."
    },
    color: {
        title: "COLOR",
        primary_color: "Color de la marca",
        dark_primary_color: "Color de la marca (oscuro)",
        dark_mode: "Habilitar modo oscuro",
        dark_mode_description: "Su aplicaci\xf3n tendr\xe1 un tema de modo oscuro generado autom\xe1ticamente en funci\xf3n del color de su marca y el algoritmo de Logto. Puede personalizarlo libremente.",
        dark_mode_reset_tip: "Vuelva a calcular el color del modo oscuro en funci\xf3n del color de la marca.",
        reset: "Volver a calcular"
    },
    branding: {
        title: "\xc1REA DE BRANDING",
        ui_style: "Estilo",
        favicon: "Favicon",
        logo_image_url: "URL de imagen del logotipo de la aplicaci\xf3n",
        logo_image_url_placeholder: "https://your.cdn.domain/logo.png",
        dark_logo_image_url: "URL de imagen del logotipo de la aplicaci\xf3n (oscuro)",
        dark_logo_image_url_placeholder: "https://your.cdn.domain/logo-dark.png",
        logo_image: "Logotipo de la aplicaci\xf3n",
        dark_logo_image: "Logotipo de la aplicaci\xf3n (oscuro)",
        logo_image_error: "Logotipo de la aplicaci\xf3n: {{error}}",
        favicon_error: "Favicon: {{error}}"
    },
    custom_css: {
        title: "CSS personalizado",
        css_code_editor_title: "Personalice su IU con CSS personalizado",
        css_code_editor_description1: "Vea el ejemplo de CSS personalizado.",
        css_code_editor_description2: "<a>{{link}}</a>",
        css_code_editor_description_link_content: "M\xe1s informaci\xf3n",
        css_code_editor_content_placeholder: "Ingrese su CSS personalizado para adaptar los estilos de cualquier cosa a sus especificaciones exactas. Expresa tu creatividad y haz que tu IU se destaque."
    },
    sign_up_and_sign_in: $043ed920080cc79e$export$2e2bcd8739ae039,
    content: $6dbe463fbb91eac7$export$2e2bcd8739ae039,
    password_policy: $1b2acd0096b882eb$export$2e2bcd8739ae039,
    setup_warning: {
        no_connector_sms: 'A\xfan no se ha configurado el conector SMS. Antes de completar la configuraci\xf3n, los usuarios no podr\xe1n iniciar sesi\xf3n con este m\xe9todo. <a>{{link}}</a> en "Conectores"',
        no_connector_email: 'A\xfan no se ha configurado el conector de correo electr\xf3nico. Antes de completar la configuraci\xf3n, los usuarios no podr\xe1n iniciar sesi\xf3n con este m\xe9todo. <a>{{link}}</a> en "Conectores"',
        no_connector_social: 'Todav\xeda no ha configurado ning\xfan conector social. Agregue conectores primero para aplicar m\xe9todos de inicio de sesi\xf3n social. <a>{{link}}</a> en "Conectores".',
        setup_link: "Configuraci\xf3n"
    },
    save_alert: {
        description: "Est\xe1 implementando nuevos procedimientos de inicio de sesi\xf3n y registro. Todos sus usuarios pueden verse afectados por la nueva configuraci\xf3n. \xbfEst\xe1s seguro de comprometerte con el cambio?",
        before: "Antes",
        after: "Despu\xe9s",
        sign_up: "Registro",
        sign_in: "Inicio de sesi\xf3n",
        social: "Social"
    },
    preview: {
        title: "Previsualizaci\xf3n del inicio de sesi\xf3n",
        live_preview: "Vista previa en vivo",
        live_preview_tip: "Guarde para previsualizar los cambios",
        native: "Nativo",
        desktop_web: "Web de escritorio",
        mobile_web: "Web m\xf3vil",
        desktop: "Escritorio",
        mobile: "M\xf3vil"
    }
};
var $1d14355728cf4850$export$2e2bcd8739ae039 = Object.freeze($1d14355728cf4850$var$sign_in_exp);


const $cf4739cd5a72cd3b$var$signing_keys = {
    title: "Claves de firma",
    description: "Administre de forma segura las claves de firma utilizadas por sus aplicaciones.",
    private_key: "Claves privadas OIDC",
    private_keys_description: "Las claves privadas OIDC se utilizan para firmar tokens JWT.",
    cookie_key: "Claves de cookies OIDC",
    cookie_keys_description: "Las claves de cookies OIDC se utilizan para firmar cookies.",
    private_keys_in_use: "Claves privadas en uso",
    cookie_keys_in_use: "Claves de cookies en uso",
    rotate_private_keys: "Rotar claves privadas",
    rotate_cookie_keys: "Rotar claves de cookies",
    rotate_private_keys_description: "Esta acci\xf3n crear\xe1 una nueva clave de firma privada, rotar\xe1 la clave actual y eliminar\xe1 su clave anterior. Sus tokens JWT firmados con la clave actual seguir\xe1n siendo v\xe1lidos hasta su eliminaci\xf3n o otra rotaci\xf3n.",
    rotate_cookie_keys_description: "Esta acci\xf3n crear\xe1 una nueva clave de cookie, rotar\xe1 la clave actual y eliminar\xe1 su clave anterior. Sus cookies con la clave actual seguir\xe1n siendo v\xe1lidos hasta su eliminaci\xf3n o otra rotaci\xf3n.",
    select_private_key_algorithm: "Seleccione el algoritmo de firma de la nueva clave privada",
    rotate_button: "Rotar",
    table_column: {
        id: "ID",
        status: "Estado",
        algorithm: "Algoritmo de clave de firma"
    },
    status: {
        current: "Actual",
        previous: "Anterior"
    },
    reminder: {
        rotate_private_key: "\xbfEst\xe1s seguro de que deseas rotar las <strong>claves privadas OIDC</strong>? Los nuevos tokens JWT emitidos ser\xe1n firmados por la nueva clave. Los tokens JWT existentes seguir\xe1n siendo v\xe1lidos hasta que los vuelvas a rotar.",
        rotate_cookie_key: "\xbfEst\xe1s seguro de que deseas rotar las <strong>claves de cookies OIDC</strong>? Las nuevas cookies generadas en sesiones de inicio de sesi\xf3n ser\xe1n firmadas por la nueva clave de cookie. Las cookies existentes seguir\xe1n siendo v\xe1lidas hasta que las vuelvas a rotar.",
        delete_private_key: "\xbfEst\xe1s seguro de que deseas eliminar la <strong>clave privada OIDC</strong>? Los tokens JWT existentes firmados con esta clave de firma privada ya no ser\xe1n v\xe1lidos.",
        delete_cookie_key: "\xbfEst\xe1s seguro de que deseas eliminar la <strong>clave de cookies OIDC</strong>? Las sesiones de inicio de sesi\xf3n antiguas con cookies firmadas con esta clave de cookie ya no ser\xe1n v\xe1lidas. Se requiere una reautenticaci\xf3n para estos usuarios."
    },
    messages: {
        rotate_key_success: "Claves de firma rotadas con \xe9xito.",
        delete_key_success: "Clave eliminada con \xe9xito."
    }
};
var $cf4739cd5a72cd3b$export$2e2bcd8739ae039 = Object.freeze($cf4739cd5a72cd3b$var$signing_keys);


const $4f57dd550d4faee5$var$quota_item = {
    tenant_limit: {
        name: "Inquilinos",
        limited: "{{count, number}} inquilino",
        limited_other: "{{count, number}} inquilinos",
        unlimited: "Inquilinos ilimitados",
        not_eligible: "Elimine sus inquilinos"
    },
    mau_limit: {
        name: "Usuarios activos mensuales",
        limited: "{{count, number}} UAM",
        unlimited: "UAM ilimitados",
        not_eligible: "Elimine a todos sus usuarios"
    },
    token_limit: {
        name: "Tokens",
        limited: "{{count, number}} token",
        limited_other: "{{count, number}} tokens",
        unlimited: "Tokens ilimitados",
        not_eligible: "Eliminar todos sus usuarios para evitar nuevos tokens"
    },
    applications_limit: {
        name: "Aplicaciones",
        limited: "{{count, number}} aplicaci\xf3n",
        limited_other: "{{count, number}} aplicaciones",
        unlimited: "Aplicaciones ilimitadas",
        not_eligible: "Elimine sus aplicaciones"
    },
    machine_to_machine_limit: {
        name: "Aplicaciones de dispositivo a dispositivo",
        limited: "{{count, number}} aplicaci\xf3n de dispositivo a dispositivo",
        limited_other: "{{count, number}} aplicaciones de dispositivo a dispositivo",
        unlimited: "Aplicaciones de dispositivo a dispositivo ilimitadas",
        not_eligible: "Elimine sus aplicaciones de dispositivo a dispositivo"
    },
    third_party_applications_limit: {
        name: "Aplicaciones de terceros",
        limited: "{{count, number}} aplicaci\xf3n de terceros",
        limited_other: "{{count, number}} aplicaciones de terceros",
        unlimited: "Aplicaciones de terceros ilimitadas",
        not_eligible: "Elimine sus aplicaciones de terceros"
    },
    resources_limit: {
        name: "Recursos de API",
        limited: "{{count, number}} recurso de API",
        limited_other: "{{count, number}} recursos de API",
        unlimited: "Recursos de API ilimitados",
        not_eligible: "Elimine sus recursos de API"
    },
    scopes_per_resource_limit: {
        name: "Permisos de recursos",
        limited: "{{count, number}} permiso por recurso",
        limited_other: "{{count, number}} permisos por recurso",
        unlimited: "Permiso por recurso ilimitado",
        not_eligible: "Elimine sus permisos de recursos"
    },
    custom_domain_enabled: {
        name: "Dominio personalizado",
        limited: "Dominio personalizado",
        unlimited: "Dominio personalizado",
        not_eligible: "Elimine su dominio personalizado"
    },
    omni_sign_in_enabled: {
        name: "Inicio de sesi\xf3n Omni",
        limited: "Inicio de sesi\xf3n Omni",
        unlimited: "Inicio de sesi\xf3n Omni",
        not_eligible: "Deshabilite su inicio de sesi\xf3n Omni"
    },
    built_in_email_connector_enabled: {
        name: "Conector de correo electr\xf3nico integrado",
        limited: "Conector de correo electr\xf3nico integrado",
        unlimited: "Conector de correo electr\xf3nico integrado",
        not_eligible: "Elimine su conector de correo electr\xf3nico integrado"
    },
    social_connectors_limit: {
        name: "Conectores sociales",
        limited: "{{count, number}} conector social",
        limited_other: "{{count, number}} conectores sociales",
        unlimited: "Conectores sociales ilimitados",
        not_eligible: "Elimine sus conectores sociales"
    },
    standard_connectors_limit: {
        name: "Conectores est\xe1ndar gratuitos",
        limited: "{{count, number}} conector est\xe1ndar gratuito",
        limited_other: "{{count, number}} conectores est\xe1ndar gratuitos",
        unlimited: "Conectores est\xe1ndar ilimitados",
        not_eligible: "Elimine sus conectores est\xe1ndar"
    },
    roles_limit: {
        name: "Roles",
        limited: "{{count, number}} rol",
        limited_other: "{{count, number}} roles",
        unlimited: "Roles ilimitados",
        not_eligible: "Elimine sus roles"
    },
    machine_to_machine_roles_limit: {
        name: "Roles de m\xe1quina a m\xe1quina",
        limited: "{{count, number}} rol de m\xe1quina a m\xe1quina",
        limited_other: "{{count, number}} roles de m\xe1quina a m\xe1quina",
        unlimited: "Roles de m\xe1quina a m\xe1quina ilimitados",
        not_eligible: "Elimine sus roles de m\xe1quina a m\xe1quina"
    },
    scopes_per_role_limit: {
        name: "Permisos de roles",
        limited: "{{count, number}} permiso por rol",
        limited_other: "{{count, number}} permisos por rol",
        unlimited: "Permiso por rol ilimitado",
        not_eligible: "Elimine sus permisos de roles"
    },
    hooks_limit: {
        name: "Webhooks",
        limited: "{{count, number}} webhook",
        limited_other: "{{count, number}} webhooks",
        unlimited: "Webhooks ilimitados",
        not_eligible: "Elimina tus webhooks"
    },
    organizations_enabled: {
        name: "Organizaciones",
        limited: "Organizaciones",
        unlimited: "Organizaciones",
        not_eligible: "Elimine sus organizaciones"
    },
    audit_logs_retention_days: {
        name: "Conservaci\xf3n de registros de auditor\xeda",
        limited: "Conservaci\xf3n de registros de auditor\xeda: {{count, number}} d\xeda",
        limited_other: "Conservaci\xf3n de registros de auditor\xeda: {{count, number}} d\xedas",
        unlimited: "D\xedas ilimitados",
        not_eligible: "Sin registros de auditor\xeda"
    },
    email_ticket_support: {
        name: "Soporte de boletos de correo electr\xf3nico",
        limited: "{{count, number}} hora de soporte de boletos de correo electr\xf3nico",
        limited_other: "{{count, number}} horas de soporte de boletos de correo electr\xf3nico",
        unlimited: "Soporte de boletos de correo electr\xf3nico",
        not_eligible: "Sin soporte de boletos de correo electr\xf3nico"
    },
    mfa_enabled: {
        name: "Autenticaci\xf3n de dos factores",
        limited: "Autenticaci\xf3n de dos factores",
        unlimited: "Autenticaci\xf3n de dos factores",
        not_eligible: "Quitar su autenticaci\xf3n de dos factores"
    },
    sso_enabled: {
        name: "SSO empresarial",
        limited: "SSO empresarial",
        unlimited: "SSO empresarial",
        not_eligible: "Elimine su SSO empresarial"
    },
    tenant_members_limit: {
        name: "Miembros del inquilino",
        limited: "{{count, number}} miembro del inquilino",
        limited_other: "{{count, number}} miembros del inquilino",
        unlimited: "Miembros del inquilino ilimitados",
        not_eligible: "Elimine sus miembros del inquilino"
    },
    custom_jwt_enabled: {
        name: "JWT personalizado",
        limited: "JWT personalizado",
        unlimited: "JWT personalizado",
        not_eligible: "Elimine su personalizador de reclamos JWT"
    }
};
var $4f57dd550d4faee5$export$2e2bcd8739ae039 = Object.freeze($4f57dd550d4faee5$var$quota_item);


const $dd4ce7ba801cf9b5$var$quota_table = {
    quota: {
        title: "Conceptos b\xe1sicos",
        base_price: "Precio base",
        mau_limit: "L\xedmite de MAU",
        included_tokens: "Tokens incluidos"
    },
    application: {
        title: "Aplicaciones",
        total: "Total de aplicaciones",
        m2m: "Aplicaci\xf3n machine-to-machine",
        third_party: "Aplicaciones de terceros"
    },
    resource: {
        title: "Recursos de API",
        resource_count: "Cantidad de recursos",
        scopes_per_resource: "Permisos por recurso"
    },
    branding: {
        title: "Interfaz de usuario y branding",
        custom_domain: "Dominio personalizado",
        custom_css: "CSS personalizado",
        app_logo_and_favicon: "Logo de la aplicaci\xf3n y favicon",
        dark_mode: "Modo oscuro",
        i18n: "Internacionalizaci\xf3n"
    },
    user_authn: {
        title: "Autenticaci\xf3n de usuario",
        omni_sign_in: "Inicio de sesi\xf3n omnicanal",
        password: "Contrase\xf1a",
        passwordless: "Inicio de sesi\xf3n sin contrase\xf1a - Correo electr\xf3nico y SMS",
        email_connector: "Conector de correo electr\xf3nico",
        sms_connector: "Conector de SMS",
        social_connectors: "Conectores sociales",
        standard_connectors: "Conectores est\xe1ndar",
        built_in_email_connector: "Conector de correo electr\xf3nico incorporado",
        mfa: "Autenticaci\xf3n multifactor",
        sso: "SSO empresarial",
        adaptive_mfa: "MFA adaptativo"
    },
    user_management: {
        title: "Gesti\xf3n de usuarios",
        user_management: "Gesti\xf3n de usuarios",
        roles: "Roles",
        machine_to_machine_roles: "Roles de m\xe1quina a m\xe1quina",
        scopes_per_role: "Permisos por rol"
    },
    organizations: {
        title: "Organizaci\xf3n",
        organizations: "Organizaciones",
        organization: "Organizaci\xf3n",
        organization_count: "Cantidad de organizaciones",
        allowed_users_per_org: "Usuarios por organizaci\xf3n",
        invitation: "Invitaci\xf3n (API de gesti\xf3n)",
        org_roles: "Roles de organizaci\xf3n",
        org_permissions: "Permisos de organizaci\xf3n",
        just_in_time_provisioning: "Provisi\xf3n justo a tiempo"
    },
    support: {
        title: "Cumplimiento y soporte",
        community: "Comunidad",
        customer_ticket: "Ticket de soporte",
        premium: "Premium",
        email_ticket_support: "Soporte por ticket de correo electr\xf3nico",
        soc2_report: "Informe SOC2 (Pr\xf3ximamente)",
        hipaa_or_baa_report: "Informe HIPAA/BAA (Pr\xf3ximamente)"
    },
    developers_and_platform: {
        title: "Desarrolladores y plataforma",
        hooks: "Webhooks",
        audit_logs_retention: "Retenci\xf3n de registros de auditor\xeda",
        jwt_claims: "Reclamos JWT",
        tenant_members: "Miembros del inquilino"
    },
    unlimited: "Ilimitado",
    contact: "Contacto",
    monthly_price: "${{value, number}}/mes",
    days_one: "{{count, number}} d\xeda",
    days_other: "{{count, number}} d\xedas",
    add_on: "Complemento",
    tier: "Nivel{{value, number}}: ",
    paid_token_limit_tip: "Logto agregar\xe1 cargos por funciones que superen su l\xedmite de cuota. Puede usarlo sin costo hasta que comencemos a cobrar alrededor del segundo trimestre de 2024. Si necesita m\xe1s tokens, por favor cont\xe1ctenos. Por defecto, cobramos $80 por mes por cada mill\xf3n de tokens.",
    paid_quota_limit_tip: "Logto agregar\xe1 cargos por funciones que excedan su l\xedmite de cuota. Puede usarlo sin costo hasta que comencemos a cobrar aproximadamente en el segundo trimestre de 2024.",
    paid_add_on_feature_tip: "Esta es una caracter\xedstica adicional. Puede usarla sin costo hasta que comencemos a cobrar aproximadamente en el segundo trimestre de 2024.",
    million: "{{value, number}} millones",
    mau_tip: "MAU (usuarios activos mensuales) significa el n\xfamero de usuarios \xfanicos que han intercambiado al menos un token con Logto en un ciclo de facturaci\xf3n.",
    tokens_tip: "Todo tipo de tokens emitidos por Logto, incluyendo tokens de acceso, tokens de actualizaci\xf3n, etc.",
    mao_tip: "MAO (Organizaci\xf3n activa mensual) significa la cantidad de organizaciones \xfanicas que tienen al menos un MAU (usuario activo mensual) en un ciclo de facturaci\xf3n.",
    third_party_tip: "Utilice Logto como su proveedor de identidades OIDC para iniciar sesi\xf3n en aplicaciones de terceros y otorgar permisos.",
    included: "incluido{{value, number}}",
    included_mao: "{{value, number}} MAO incluido",
    extra_quota_price: "Luego ${{value, number}} por mes / cada uno despu\xe9s",
    per_month_each: "${{value, number}} por mes / cada uno",
    extra_mao_price: "Luego ${{value, number}} por MAO",
    per_month: "${{value, number}} por mes",
    per_member: "Luego ${{value, number}} por miembro"
};
var $dd4ce7ba801cf9b5$export$2e2bcd8739ae039 = Object.freeze($dd4ce7ba801cf9b5$var$quota_table);


const $13bad4b43168b9d2$var$subscription = {
    free_plan: "Plan Gratuito",
    free_plan_description: "Para proyectos secundarios y pruebas iniciales de Logto. No se requiere tarjeta de cr\xe9dito.",
    pro_plan: "Plan Pro",
    pro_plan_description: "Benef\xedciese sin preocupaciones con Logto para empresas.",
    enterprise: "Empresa",
    current_plan: "Plan Actual",
    current_plan_description: "Aqu\xed est\xe1 tu plan actual. Puedes ver f\xe1cilmente el uso de tu plan, revisar tu pr\xf3xima factura y hacer cambios en tu plan seg\xfan sea necesario.",
    plan_usage: "Uso del plan",
    plan_cycle: "Ciclo del plan: {{period}}. La renovaci\xf3n del uso se realiza en {{renewDate}}.",
    next_bill: "Su pr\xf3xima factura",
    next_bill_hint: "Para obtener m\xe1s informaci\xf3n sobre el c\xe1lculo, consulte este <a>art\xedculo</a>.",
    next_bill_tip: "Los precios mostrados aqu\xed no incluyen impuestos. El monto de impuestos se calcular\xe1 seg\xfan la informaci\xf3n que proporcione y los requisitos regulatorios locales, y se mostrar\xe1 en sus facturas.",
    manage_payment: "Gestionar el pago",
    overfill_quota_warning: "Ha alcanzado el l\xedmite de su cuota. Para evitar problemas, actualice el plan.",
    upgrade_pro: "Actualizar a Pro",
    update_payment: "Actualizar pago",
    payment_error: "Se ha detectado un problema de pago. No se puede procesar ${ {price, number}} para el ciclo anterior. Actualice el pago para evitar la suspensi\xf3n del servicio Logto.",
    downgrade: "Degradar",
    current: "Actual",
    upgrade: "Actualizar",
    quota_table: $dd4ce7ba801cf9b5$export$2e2bcd8739ae039,
    billing_history: {
        invoice_column: "factura",
        status_column: "estado",
        amount_column: "monto",
        invoice_created_date_column: "Fecha de creaci\xf3n de la factura",
        invoice_status: {
            void: "Cancelada",
            paid: "Pagada",
            open: "Abierta",
            uncollectible: "Vencida"
        }
    },
    quota_item: $4f57dd550d4faee5$export$2e2bcd8739ae039,
    downgrade_modal: {
        title: "\xbfEst\xe1 seguro de que desea degradar?",
        description: "Si elige cambiar a <targetName/>, tenga en cuenta que ya no tendr\xe1 acceso a la cuota y las funciones que ten\xeda anteriormente en <currentName/>.",
        before: "Antes: <name/>",
        after: "Despu\xe9s: <name/>",
        downgrade: "Degradar"
    },
    not_eligible_modal: {
        downgrade_title: "No es posible el cambio a un plan inferior",
        downgrade_description: "Aseg\xfarese de cumplir con los siguientes criterios antes de cambiar al plan <name/>.",
        downgrade_help_tip: "\xbfNecesitas ayuda para cambiar de plan? <a>Cont\xe1ctenos</a>.",
        upgrade_title: "Recordatorio amistoso para nuestros apreciados early adopters",
        upgrade_description: "Actualmente est\xe1s usando m\xe1s de lo permitido por <name />. Logto es ahora oficial e incluye caracter\xedsticas adaptadas a cada plan. Antes de considerar la actualizaci\xf3n al <name />, aseg\xfarate de cumplir con los siguientes criterios antes de hacer el upgrade.",
        upgrade_pro_tip: " O considera actualizar al Plan Pro.",
        upgrade_help_tip: "\xbfNecesitas ayuda para cambiar de plan? <a>Cont\xe1ctenos</a>.",
        a_maximum_of: "Un m\xe1ximo de <item/>"
    },
    upgrade_success: "Actualizado con \xe9xito a <name/>",
    downgrade_success: "Degradado con \xe9xito a <name/>",
    subscription_check_timeout: "La comprobaci\xf3n de suscripci\xf3n expir\xf3. Por favor, actualiza m\xe1s tarde.",
    no_subscription: "Sin suscripci\xf3n"
};
var $13bad4b43168b9d2$export$2e2bcd8739ae039 = Object.freeze($13bad4b43168b9d2$var$subscription);


const $9cbfc9ca485e656b$var$tab_sections = {
    overview: "Visi\xf3n general",
    authentication: "Autenticaci\xf3n",
    authorization: "Autorizaci\xf3n",
    users: "Usuarios",
    developer: "Desarrollador",
    tenant: "Inquilino"
};
var $9cbfc9ca485e656b$export$2e2bcd8739ae039 = Object.freeze($9cbfc9ca485e656b$var$tab_sections);


const $5bc4e5c81e9ac61e$var$tabs = {
    get_started: "Empezar",
    dashboard: "Tablero",
    applications: "Aplicaciones",
    api_resources: "Recursos de API",
    sign_in_experience: "Experiencia de inicio de sesi\xf3n",
    connectors: "Conectores",
    enterprise_sso: "SSO empresarial",
    webhooks: "Webhooks",
    organizations: "Organizaciones",
    users: "Gesti\xf3n de usuarios",
    audit_logs: "Registros de auditor\xeda",
    roles: "Roles",
    docs: "Documentos",
    tenant_settings: "Configuraciones del inquilino",
    mfa: "Autenticaci\xf3n multifactor",
    customize_jwt: "JWT personalizado",
    signing_keys: "Claves de firma",
    organization_template: "Plantilla de organizaci\xf3n"
};
var $5bc4e5c81e9ac61e$export$2e2bcd8739ae039 = Object.freeze($5bc4e5c81e9ac61e$var$tabs);


const $c133ef971b8a28d3$var$tenant_members = {
    members: "Miembros",
    invitations: "Invitaciones",
    invite_members: "Invitar miembros",
    user: "Usuario",
    roles: "Roles",
    admin: "Administrador",
    collaborator: "Colaborador",
    invitation_status: "Estado de la invitaci\xf3n",
    inviter: "Invitador",
    expiration_date: "Fecha de vencimiento",
    invite_modal: {
        title: "Invitar personas a Logto Cloud",
        subtitle: "Para invitar miembros a una organizaci\xf3n, deben aceptar la invitaci\xf3n.",
        to: "Para",
        added_as: "A\xf1adido como roles",
        email_input_placeholder: "johndoe@example.com"
    },
    invitation_statuses: {
        pending: "Pendiente",
        accepted: "Aceptada",
        expired: "Caducada",
        revoked: "Revocada"
    },
    invitation_empty_placeholder: {
        title: "Invitar miembros al equipo",
        description: "Tu inquilino actualmente no tiene miembros invitados.\nPara ayudar con tu integraci\xf3n, considera agregar m\xe1s miembros o administradores."
    },
    menu_options: {
        edit: "Editar rol del inquilino",
        delete: "Eliminar usuario del inquilino",
        resend_invite: "Reenviar invitaci\xf3n",
        revoke: "Revocar invitaci\xf3n",
        delete_invitation_record: "Eliminar este registro de invitaci\xf3n"
    },
    edit_modal: {
        title: "Cambiar roles de {{name}}"
    },
    delete_user_confirm: "\xbfEst\xe1s seguro de que quieres eliminar a este usuario de este inquilino?",
    assign_admin_confirm: "\xbfEst\xe1s seguro de que deseas hacer que el/los usuario(s) seleccionado(s) sea(n) administrador(es)? Otorgar acceso de administrador dar\xe1 al usuario/los usuarios los siguientes permisos.<ul><li>Cambiar el plan de facturaci\xf3n del inquilino</li><li>Agregar o eliminar colaboradores</li><li>Eliminar el inquilino</li></ul>",
    revoke_invitation_confirm: "\xbfEst\xe1s seguro de que quieres revocar esta invitaci\xf3n?",
    delete_invitation_confirm: "\xbfEst\xe1s seguro de que quieres eliminar este registro de invitaci\xf3n?",
    messages: {
        invitation_sent: "Invitaci\xf3n enviada.",
        invitation_revoked: "Invitaci\xf3n revocada.",
        invitation_resend: "Invitaci\xf3n reenviada.",
        invitation_deleted: "Registro de invitaci\xf3n eliminado."
    },
    errors: {
        email_required: "El correo electr\xf3nico del invitado es obligatorio.",
        email_exists: "La direcci\xf3n de correo electr\xf3nico ya existe.",
        member_exists: "Este usuario ya es miembro de esta organizaci\xf3n.",
        pending_invitation_exists: "Existe una invitaci\xf3n pendiente. Elimina el correo electr\xf3nico relacionado o revoca la invitaci\xf3n.",
        invalid_email: "La direcci\xf3n de correo electr\xf3nico es inv\xe1lida. Aseg\xfarate de que est\xe9 en el formato correcto.",
        max_member_limit: "Has alcanzado el n\xfamero m\xe1ximo de miembros ({{limit}}) para este inquilino."
    }
};
var $c133ef971b8a28d3$export$2e2bcd8739ae039 = Object.freeze($c133ef971b8a28d3$var$tenant_members);


const $ca2e9cb50acb0d9a$var$tenants = {
    title: "Configuraciones",
    description: "Administre eficientemente la configuraci\xf3n del inquilino y personalice su dominio.",
    tabs: {
        settings: "Configuraciones",
        members: "Miembros",
        domains: "Dominios",
        subscription: "Plan y facturaci\xf3n",
        billing_history: "Historial de facturaci\xf3n"
    },
    settings: {
        title: "CONFIGURACIONES",
        description: "Establezca el nombre del inquilino y vea la regi\xf3n de alojamiento de sus datos y el tipo de inquilino.",
        tenant_id: "ID del inquilino",
        tenant_name: "Nombre del inquilino",
        tenant_region: "Regi\xf3n de alojamiento de datos",
        tenant_region_tip: "Sus recursos de inquilino se alojan en {{region}}. <a>Obtener m\xe1s informaci\xf3n</a>",
        environment_tag_development: "Desarrollo",
        environment_tag_production: "Producci\xf3n",
        tenant_type: "Tipo de inquilino",
        development_description: "Solo para pruebas y no debe usarse en producci\xf3n. No se requiere suscripci\xf3n. Tiene todas las caracter\xedsticas profesionales pero tiene limitaciones como un banner de inicio de sesi\xf3n. <a>M\xe1s informaci\xf3n</a>",
        production_description: "Destinado para aplicaciones que son utilizadas por usuarios finales y pueden requerir una suscripci\xf3n paga. <a>M\xe1s informaci\xf3n</a>",
        tenant_info_saved: "Informaci\xf3n del inquilino guardada correctamente."
    },
    full_env_tag: {
        development: "Desarrollo",
        production: "Producci\xf3n"
    },
    deletion_card: {
        title: "ELIMINAR",
        tenant_deletion: "Eliminar inquilino",
        tenant_deletion_description: "Eliminar el inquilino resultar\xe1 en la eliminaci\xf3n permanente de todos los datos de usuario y configuraciones asociadas. Por favor, proceda con precauci\xf3n.",
        tenant_deletion_button: "Eliminar inquilino"
    },
    leave_tenant_card: {
        title: "ABANDONAR",
        leave_tenant: "Abandonar inquilino",
        leave_tenant_description: "Cualquier recurso en el inquilino se mantendr\xe1 pero ya no tendr\xe1 acceso a este inquilino.",
        last_admin_note: "Para abandonar este inquilino, aseg\xfarese de que al menos otro miembro tenga el rol de Administrador."
    },
    create_modal: {
        title: "Crear inquilino",
        tenant_usage_purpose: "\xbfPara qu\xe9 desea usar este inquilino?",
        development_description: "Solo para pruebas y no debe usarse en producci\xf3n. No se requiere suscripci\xf3n.",
        development_hint: "Tiene todas las caracter\xedsticas profesionales pero tiene limitaciones como un banner de inicio de sesi\xf3n.",
        production_description: "Para uso de usuarios finales y puede requerir una suscripci\xf3n paga.",
        available_plan: "Plan disponible:",
        create_button: "Crear inquilino",
        tenant_name_placeholder: "Mi inquilino"
    },
    dev_tenant_migration: {
        title: '\xa1Ahora puedes probar nuestras caracter\xedsticas Pro de forma gratuita creando un nuevo "inquilino de Desarrollo"!',
        affect_title: "\xbfC\xf3mo te afecta esto?",
        hint_1: 'Estamos reemplazando las antiguas <strong>etiquetas de entorno</strong> con dos nuevos tipos de inquilinos: <strong>"Desarrollo"</strong> y <strong>"Producci\xf3n"</strong>.',
        hint_2: "Para garantizar una transici\xf3n sin problemas y funcionalidad ininterrumpida, los inquilinos creados anteriormente se elevar\xe1n al tipo de inquilino <strong>Producci\xf3n</strong> junto con su suscripci\xf3n anterior.",
        hint_3: "No te preocupes, todas tus otras configuraciones permanecer\xe1n iguales.",
        about_tenant_type: "Sobre el tipo de inquilino"
    },
    delete_modal: {
        title: "Eliminar inquilino",
        description_line1: '\xbfEst\xe1 seguro de que desea eliminar su inquilino "<span>{{name}}</span>" con la etiqueta de sufijo de entorno "<span>{{tag}}</span>"? Esta acci\xf3n no se puede deshacer y resultar\xe1 en la eliminaci\xf3n permanente de todos sus datos e informaci\xf3n del inquilino.',
        description_line2: "Antes de eliminar el inquilino, tal vez podamos ayudarlo. <span><a>Contacte con nosotros por correo electr\xf3nico</a></span>",
        description_line3: 'Si desea continuar, ingrese el nombre del inquilino "<span>{{name}}</span>" para confirmar.',
        delete_button: "Eliminar permanentemente",
        cannot_delete_title: "No se puede eliminar este inquilino",
        cannot_delete_description: "Lo siento, no puedes eliminar este inquilino en este momento. Aseg\xfarate de estar en el Plan Gratuito y haber pagado todas las facturas pendientes."
    },
    leave_tenant_modal: {
        description: "\xbfEst\xe1 seguro de que desea abandonar este inquilino?",
        leave_button: "Abandonar"
    },
    tenant_landing_page: {
        title: "Todav\xeda no has creado un inquilino",
        description: "Para empezar a configurar tu proyecto con Logto, por favor crea un nuevo inquilino. Si necesitas cerrar la sesi\xf3n o eliminar tu cuenta, simplemente haz clic en el bot\xf3n de avatar en la esquina superior derecha.",
        create_tenant_button: "Crear inquilino"
    },
    status: {
        mau_exceeded: "L\xedmite MAU excedido",
        suspended: "Suspendido",
        overdue: "Vencido"
    },
    tenant_suspended_page: {
        title: "Inquilino suspendido. Cont\xe1ctenos para restaurar el acceso.",
        description_1: "Lamentamos informarle que su cuenta de inquilino ha sido suspendida temporalmente debido a un uso indebido, que incluye exceder los l\xedmites de MAU, pagos atrasados ​​u otras acciones no autorizadas.",
        description_2: "Si necesita aclaraciones adicionales, tiene alguna inquietud o desea restaurar la funcionalidad completa y desbloquear sus inquilinos, no dude en contactarnos de inmediato."
    }
};
var $ca2e9cb50acb0d9a$export$2e2bcd8739ae039 = Object.freeze($ca2e9cb50acb0d9a$var$tenants);


const $1256335fd951153e$var$topbar = {
    docs: "Documentos",
    help: "Ayuda"
};
var $1256335fd951153e$export$2e2bcd8739ae039 = Object.freeze($1256335fd951153e$var$topbar);


const $e68d7d7ea2a28b94$var$featured_plan_content = {
    mau: {
        free_plan: "Hasta {{count, number}} MAU",
        pro_plan: "MAU ilimitados"
    },
    m2m: {
        free_plan: "{{count, number}} de m\xe1quina a m\xe1quina",
        pro_plan: "M\xe1quina a m\xe1quina adicional"
    },
    third_party_apps: "IdP para aplicaciones de terceros",
    mfa: "Autenticaci\xf3n multifactor",
    sso: "SSO empresarial",
    role_and_permissions: {
        free_plan: "{{roleCount, number}} rol y {{permissionCount, number}} permiso por rol",
        pro_plan: "Roles y permisos ilimitados por rol"
    },
    organizations: "Organizaciones",
    audit_logs: "Retenci\xf3n de registros de auditor\xeda: {{count, number}} d\xedas"
};
var $e68d7d7ea2a28b94$export$2e2bcd8739ae039 = Object.freeze($e68d7d7ea2a28b94$var$featured_plan_content);


const $5f3f4d3b456262d9$var$paywall = {
    applications: "Se ha alcanzado el l\xedmite de {{count, number}} aplicaci\xf3n de <planName/>. Actualiza el plan para satisfacer las necesidades de tu equipo. Para cualquier ayuda, no dudes en <a>contactarnos</a>.",
    applications_other: "Se ha alcanzado el l\xedmite de {{count, number}} aplicaciones de <planName/>. Actualiza el plan para satisfacer las necesidades de tu equipo. Para cualquier ayuda, no dudes en <a>contactarnos</a>.",
    machine_to_machine_feature: "Cambia al plan <strong>Pro</strong> para obtener aplicaciones adicionales de m\xe1quina a m\xe1quina y disfrutar de todas las funciones premium. <a>Cont\xe1ctanos</a> si tienes preguntas.",
    machine_to_machine: "Se ha alcanzado el l\xedmite de {{count, number}} aplicaci\xf3n de m\xe1quina a m\xe1quina de <planName/>. Actualiza el plan para satisfacer las necesidades de tu equipo. Para cualquier ayuda, no dudes en <a>contactarnos</a>.",
    machine_to_machine_other: "Se ha alcanzado el l\xedmite de {{count, number}} aplicaciones de m\xe1quina a m\xe1quina de <planName/>. Actualiza el plan para satisfacer las necesidades de tu equipo. Para cualquier ayuda, no dudes en <a>contactarnos</a>.",
    resources: "Has alcanzado el l\xedmite de {{count, number}} recursos de API de <planName/>. Actualiza el plan para satisfacer las necesidades de tu equipo. <a>Cont\xe1ctanos</a> si necesitas asistencia.",
    resources_other: "Has alcanzado el l\xedmite de {{count, number}} recursos de API de <planName/>. Actualiza el plan para satisfacer las necesidades de tu equipo. <a>Cont\xe1ctanos</a> si necesitas asistencia.",
    scopes_per_resource: "Has alcanzado el l\xedmite de {{count, number}} permisos por recurso de API de <planName/>. Actualiza ahora para expandirlo. <a>Cont\xe1ctanos</a> si necesitas asistencia.",
    scopes_per_resource_other: "Has alcanzado el l\xedmite de {{count, number}} permisos por recurso de API de <planName/>. Actualiza ahora para expandirlo. <a>Cont\xe1ctanos</a> si necesitas asistencia.",
    custom_domain: "Desbloquea la funcionalidad de dominio personalizado al actualizar al plan <strong>Hobby</strong> o <strong>Pro</strong>. No dudes en <a>contactarnos</a> si necesitas ayuda.",
    social_connectors: "Has alcanzado el l\xedmite de {{count, number}} conectores sociales de <planName/>. Actualiza el plan para obtener conectores sociales adicionales y la capacidad de crear tus propios conectores usando los protocolos OIDC, OAuth 2.0 y SAML. Si necesitas ayuda, no dudes en <a>contactarnos</a>.",
    social_connectors_other: "Has alcanzado el l\xedmite de {{count, number}} conectores sociales de <planName/>. Actualiza el plan para obtener conectores sociales adicionales y la capacidad de crear tus propios conectores usando los protocolos OIDC, OAuth 2.0 y SAML. Si necesitas ayuda, no dudes en <a>contactarnos</a>.",
    standard_connectors_feature: "Actualiza al plan <strong>Hobby</strong> o <strong>Pro</strong> para crear tus propios conectores usando los protocolos OIDC, OAuth 2.0 y SAML, adem\xe1s de conectores sociales ilimitados y todas las funciones premium. No dudes en <a>contactarnos</a> si necesitas ayuda.",
    standard_connectors: "Has alcanzado el l\xedmite de {{count, number}} conectores sociales de <planName/>. Actualiza el plan para obtener conectores sociales adicionales y la capacidad de crear tus propios conectores usando los protocolos OIDC, OAuth 2.0 y SAML. Si necesitas ayuda, no dudes en <a>contactarnos</a>.",
    standard_connectors_other: "Has alcanzado el l\xedmite de {{count, number}} conectores sociales de <planName/>. Actualiza el plan para obtener conectores sociales adicionales y la capacidad de crear tus propios conectores usando los protocolos OIDC, OAuth 2.0 y SAML. Si necesitas ayuda, no dudes en <a>contactarnos</a>.",
    standard_connectors_pro: "Has alcanzado el l\xedmite de {{count, number}} conectores est\xe1ndar de <planName/>. Actualiza al plan Enterprise para obtener conectores sociales adicionales y la capacidad de crear tus propios conectores usando los protocolos OIDC, OAuth 2.0 y SAML. Si necesitas ayuda, no dudes en <a>contactarnos</a>.",
    standard_connectors_pro_other: "Has alcanzado el l\xedmite de {{count, number}} conectores est\xe1ndar de <planName/>. Actualiza al plan Enterprise para obtener conectores sociales adicionales y la capacidad de crear tus propios conectores usando los protocolos OIDC, OAuth 2.0 y SAML. Si necesitas ayuda, no dudes en <a>contactarnos</a>.",
    roles: "Has alcanzado el l\xedmite de {{count, number}} roles de <planName/>. Actualiza el plan para agregar roles y permisos adicionales. Si necesitas ayuda, no dudes en <a>contactarnos</a>.",
    roles_other: "Has alcanzado el l\xedmite de {{count, number}} roles de <planName/>. Actualiza el plan para agregar roles y permisos adicionales. Si necesitas ayuda, no dudes en <a>contactarnos</a>.",
    machine_to_machine_roles: "{{count, number}} roles de m\xe1quina a m\xe1quina de <planName/> alcanzaron el l\xedmite. Actualiza el plan para agregar roles y permisos adicionales. Si necesitas ayuda, no dudes en <a>contactarnos</a>.",
    machine_to_machine_roles_other: "{{count, number}} roles de m\xe1quina a m\xe1quina de <planName/> alcanzaron el l\xedmite. Actualiza el plan para agregar roles y permisos adicionales. Si necesitas ayuda, no dudes en <a>contactarnos</a>.",
    scopes_per_role: "Has alcanzado el l\xedmite de {{count, number}} permisos por rol de <planName/>. Actualiza el plan para agregar roles y permisos adicionales. Si necesitas ayuda, no dudes en <a>contactarnos</a>.",
    scopes_per_role_other: "Has alcanzado el l\xedmite de {{count, number}} permisos por rol de <planName/>. Actualiza el plan para agregar roles y permisos adicionales. Si necesitas ayuda, no dudes en <a>contactarnos</a>.",
    hooks: "Has alcanzado el l\xedmite de {{count, number}} webhooks de <planName/>. Actualiza el plan para crear m\xe1s webhooks. Si necesitas ayuda, no dudes en <a>contactarnos</a>.",
    hooks_other: "Has alcanzado el l\xedmite de {{count, number}} webhooks de <planName/>. Actualiza el plan para crear m\xe1s webhooks. Si necesitas ayuda, no dudes en <a>contactarnos</a>.",
    mfa: "Desbloquea MFA para verificar la seguridad al actualizar a un plan pago. No dudes en <a>contactarnos</a> si necesitas ayuda.",
    organizations: "Desbloquea las organizaciones al actualizar a un plan pago. No dudes en <a>contactarnos</a> si necesitas ayuda.",
    third_party_apps: "Desbloquea Logto como proveedor de identidades para aplicaciones de terceros al actualizar a un plan de pago. Para cualquier asistencia, no dudes en <a>contactarnos</a>.",
    sso_connectors: "Desbloquea el SSO empresarial al actualizar a un plan de pago. Para cualquier asistencia, no dudes en <a>contactarnos</a>.",
    tenant_members: "Desbloquea la funci\xf3n de colaboraci\xf3n al actualizar a un plan de pago. Para cualquier asistencia, no dudes en <a>contactarnos</a>.",
    tenant_members_dev_plan: "Has alcanzado tu l\xedmite de {{limit}} miembros. Libera a un miembro o revoca una invitaci\xf3n pendiente para agregar a alguien nuevo. \xbfNecesitas m\xe1s puestos? No dudes en contactarnos.",
    custom_jwt: {
        title: "Agregar reclamaciones personalizadas",
        description: "Actualiza a un plan de pago para obtener funcionalidades personalizadas de JWT y beneficios premium. No dudes en <a>contactarnos</a> si tienes alguna pregunta."
    }
};
var $5f3f4d3b456262d9$export$2e2bcd8739ae039 = Object.freeze($5f3f4d3b456262d9$var$paywall);


const $41bc2de94b89dbb0$var$upsell = {
    upgrade_plan: "Plan de actualizaci\xf3n",
    compare_plans: "Comparar planes",
    view_plans: "Ver planes",
    create_tenant: {
        title: "Selecciona tu plan de tenant",
        description: "Logto ofrece opciones de planes competitivos con una innovadora y asequible estructura de precios dise\xf1ada para empresas en crecimiento. <a>M\xe1s informaci\xf3n</a>",
        base_price: "Precio base",
        monthly_price: "{{value, number}}/mes",
        view_all_features: "Ver todas las caracter\xedsticas",
        select_plan: "Seleccionar <name/>",
        free_tenants_limit: "Hasta {{count, number}} tenant gratuito",
        free_tenants_limit_other: "Hasta {{count, number}} tenants gratuitos",
        most_popular: "M\xe1s popular",
        upgrade_success: "Actualizaci\xf3n a <name/> realizada con \xe9xito"
    },
    mau_exceeded_modal: {
        title: "Se ha superado el l\xedmite de MAU. Actualiza tu plan.",
        notification: "Tu MAU actual ha superado el l\xedmite de <planName/>. Por favor, actualiza tu plan a premium a tiempo para evitar la suspensi\xf3n del servicio de Logto.",
        update_plan: "Actualizar plan"
    },
    payment_overdue_modal: {
        title: "Factura con pagos atrasados",
        notification: "\xa1Ups! El pago de la factura del inquilino <span>{{name}}</span> ha fallado. Por favor, pague la factura a tiempo para evitar la suspensi\xf3n del servicio de Logto.",
        unpaid_bills: "Facturas impagas",
        update_payment: "Actualizar pago"
    },
    add_on_quota_item: {
        api_resource: "Recurso de API",
        machine_to_machine: "aplicaci\xf3n de m\xe1quina a m\xe1quina",
        tokens: "{{limit}}M tokens",
        tenant_member: "miembro del tenant"
    },
    charge_notification_for_quota_limit: "Has superado tu l\xedmite de cuota de {{item}}. Logto agregar\xe1 cargos por el uso m\xe1s all\xe1 de tu l\xedmite de cuota. La facturaci\xf3n comenzar\xe1 el d\xeda en que se lance el nuevo dise\xf1o de precios del complemento. <a>M\xe1s informaci\xf3n</a>",
    paywall: $5f3f4d3b456262d9$export$2e2bcd8739ae039,
    featured_plan_content: $e68d7d7ea2a28b94$export$2e2bcd8739ae039
};
var $41bc2de94b89dbb0$export$2e2bcd8739ae039 = Object.freeze($41bc2de94b89dbb0$var$upsell);


const $3fcb48a345079d3f$var$user_details = {
    page_title: "Detalles de usuario",
    back_to_users: "Volver a la gesti\xf3n de usuarios",
    created_title: "Usuario creado con \xe9xito",
    created_guide: "Aqu\xed est\xe1 la informaci\xf3n para ayudar al usuario con su proceso de inicio de sesi\xf3n.",
    created_email: "Direcci\xf3n de correo electr\xf3nico:",
    created_phone: "N\xfamero de tel\xe9fono:",
    created_username: "Nombre de usuario:",
    created_password: "Contrase\xf1a:",
    menu_delete: "Eliminar",
    delete_description: "Esta acci\xf3n no se puede deshacer. Eliminar\xe1 permanentemente al usuario.",
    deleted: "Usuario eliminado con \xe9xito",
    reset_password: {
        reset_password: "Restablecer contrase\xf1a",
        title: "\xbfEst\xe1 seguro de que desea restablecer la contrase\xf1a?",
        content: "Esta acci\xf3n no se puede deshacer. Esto restablecer\xe1 la informaci\xf3n de inicio de sesi\xf3n del usuario.",
        congratulations: "Se ha restablecido la informaci\xf3n de inicio de sesi\xf3n del usuario",
        new_password: "Nueva contrase\xf1a:"
    },
    tab_settings: "Configuraci\xf3n",
    tab_roles: "Roles",
    tab_logs: "Registros de usuario",
    tab_organizations: "Organizaciones",
    authentication: "Autenticaci\xf3n",
    authentication_description: "Cada usuario tiene un perfil que contiene toda la informaci\xf3n del usuario. Consta de datos b\xe1sicos, identidades sociales y datos personalizados.",
    user_profile: "Perfil de usuario",
    field_email: "Direcci\xf3n de correo electr\xf3nico",
    field_phone: "N\xfamero de tel\xe9fono",
    field_username: "Nombre de usuario",
    field_name: "Nombre",
    field_avatar: "URL de imagen de avatar",
    field_avatar_placeholder: "https://tu.dominio.cdn/avatar.png",
    field_custom_data: "Datos personalizados",
    field_custom_data_tip: "Informaci\xf3n adicional del usuario no incluida en las propiedades de usuario predefinidas, como el color y el idioma preferidos del usuario.",
    field_connectors: "Conexiones sociales",
    field_sso_connectors: "Conexiones empresariales",
    custom_data_invalid: "Los datos personalizados deben ser un objeto JSON v\xe1lido",
    connectors: {
        connectors: "Conectores",
        user_id: "ID de usuario",
        remove: "Eliminar",
        connected: "Este usuario est\xe1 conectado con varios conectores sociales.",
        not_connected: "El usuario no est\xe1 conectado a ning\xfan conector social",
        deletion_confirmation: "Est\xe1s eliminando la identidad existente <name/>. \xbfSeguro que quieres continuar?"
    },
    sso_connectors: {
        connectors: "Conectores",
        enterprise_id: "ID de empresa",
        connected: "Este usuario est\xe1 conectado a varios proveedores de identidad empresarial para inicio de sesi\xf3n \xfanico.",
        not_connected: "El usuario no est\xe1 conectado a ninguno de los proveedores de identidad empresarial para inicio de sesi\xf3n \xfanico."
    },
    mfa: {
        field_name: "Autenticaci\xf3n de dos factores",
        field_description: "Este usuario ha habilitado factores de autenticaci\xf3n de 2 pasos.",
        name_column: "Autenticaci\xf3n de dos factores",
        field_description_empty: "Este usuario no ha habilitado factores de autenticaci\xf3n de 2 pasos.",
        deletion_confirmation: "Est\xe1s eliminando la existente <name/> para la verificaci\xf3n en dos pasos. \xbfEst\xe1s seguro/a de que deseas continuar?"
    },
    suspended: "Suspendido",
    suspend_user: "Suspender usuario",
    suspend_user_reminder: "\xbfEst\xe1 seguro de que desea suspender a este usuario? El usuario no podr\xe1 iniciar sesi\xf3n en su aplicaci\xf3n y no podr\xe1 obtener un nuevo token de acceso despu\xe9s de que expire el actual. Adem\xe1s, todas las solicitudes de API realizadas por este usuario fallar\xe1n.",
    suspend_action: "Suspender",
    user_suspended: "El usuario ha sido suspendido.",
    reactivate_user: "Reactivar usuario",
    reactivate_user_reminder: "\xbfEst\xe1 seguro de que desea reactivar a este usuario? Al hacerlo, permitir\xe1 cualquier intento de inicio de sesi\xf3n para este usuario.",
    reactivate_action: "Reactivar",
    user_reactivated: "El usuario ha sido reactivado.",
    roles: {
        name_column: "Rol",
        description_column: "Descripci\xf3n",
        assign_button: "Asignar roles",
        delete_description: "Esta acci\xf3n eliminar\xe1 este rol de este usuario. El rol en s\xed seguir\xe1 existiendo, pero ya no estar\xe1 asociado con este usuario.",
        deleted: 'Se elimin\xf3 "{{name}}" correctamente de este usuario.',
        assign_title: "Asigne roles a {{name}}",
        assign_subtitle: "Autorice {{name}} uno o m\xe1s roles",
        assign_role_field: "Asignar roles",
        role_search_placeholder: "Buscar por nombre de rol",
        added_text: "{{value, number}} agregados",
        assigned_user_count: "{{value, number}} usuarios",
        confirm_assign: "Asignar roles",
        role_assigned: "Rol(es) asignado(s) con \xe9xito",
        search: "Buscar por nombre de rol, descripci\xf3n o ID",
        empty: "No hay roles disponibles"
    },
    warning_no_sign_in_identifier: "El usuario necesita tener al menos uno de los identificadores de inicio de sesi\xf3n (nombre de usuario, correo electr\xf3nico, n\xfamero de tel\xe9fono o red social) para iniciar sesi\xf3n. \xbfEst\xe1s seguro/a de que quieres continuar?",
    organization_roles_tooltip: "Los roles asignados al usuario dentro de esta organizaci\xf3n."
};
var $3fcb48a345079d3f$export$2e2bcd8739ae039 = Object.freeze($3fcb48a345079d3f$var$user_details);


const $ae40df6acb8b8884$var$users = {
    page_title: "Gesti\xf3n de usuarios",
    title: "Gesti\xf3n de usuarios",
    subtitle: "Administrar identidades de usuario, incluyendo la creaci\xf3n de usuarios, la edici\xf3n de informaci\xf3n de usuario, la visualizaci\xf3n de registros de usuario, la restablecimiento de contrase\xf1a y la eliminaci\xf3n de usuarios",
    create: "Agregar usuario",
    create_subtitle: "Proporcione al menos uno de los siguientes campos para continuar.",
    error_missing_identifier: "Debe proporcionar al menos un identificador para crear un usuario.",
    user_name: "Usuario",
    application_name: "De la aplicaci\xf3n",
    latest_sign_in: "\xdaltimo inicio de sesi\xf3n",
    create_form_username: "Nombre de usuario",
    create_form_password: "Contrase\xf1a",
    create_form_name: "Nombre completo",
    placeholder_name: "Fulano de Tal",
    placeholder_email: "fulano@example.com",
    placeholder_username: "user123",
    placeholder_phone: "+34 123 456 789",
    unnamed: "Sin nombre",
    search: "Buscar por nombre, correo electr\xf3nico, tel\xe9fono o nombre de usuario",
    check_user_detail: "Ver detalles del usuario",
    placeholder_title: "Gesti\xf3n de usuarios",
    placeholder_description: "Cada usuario tiene un perfil que contiene toda su informaci\xf3n. Consta de datos b\xe1sicos, identidades sociales y datos personalizados."
};
var $ae40df6acb8b8884$export$2e2bcd8739ae039 = Object.freeze($ae40df6acb8b8884$var$users);


const $e902c86788d1481d$var$webhook_details = {
    page_title: "Detalles de Webhook",
    back_to_webhooks: "Volver a Webhooks",
    not_in_use: "No se est\xe1 usando",
    success_rate: "Tasa de \xe9xito",
    requests: "Solicitudes en 24h: {{value, number}}",
    disable_webhook: "Desactivar webhook",
    disable_reminder: "\xbfEst\xe1 seguro de que desea reactivar este webhook? Al hacerlo, no se enviar\xe1 ninguna solicitud HTTP a la URL de extremo.",
    webhook_disabled: "El webhook se ha desactivado.",
    webhook_reactivated: "El webhook ha sido reactivado.",
    reactivate_webhook: "Reactivar webhook",
    delete_webhook: "Eliminar webhook",
    deletion_reminder: "Est\xe1 eliminando este webhook. Despu\xe9s de eliminarlo, no se enviar\xe1 ninguna solicitud HTTP a la URL de extremo.",
    deleted: "El webhook se ha eliminado correctamente.",
    settings_tab: "Configuraci\xf3n",
    recent_requests_tab: "Solicitudes recientes (24 h)",
    settings: {
        settings: "Configuraci\xf3n",
        settings_description: "Los webhooks le permiten recibir actualizaciones en tiempo real sobre eventos espec\xedficos, enviando una solicitud POST a la URL de su extremo. Esto le permite tomar medidas inmediatas en funci\xf3n de la nueva informaci\xf3n recibida.",
        events: "Eventos",
        events_description: "Seleccione los eventos desencadenantes que Logto enviar\xe1 como solicitud POST.",
        name: "Nombre",
        endpoint_url: "URL del Extremo",
        signing_key: "Clave de firma",
        signing_key_tip: "Agregue la clave secreta proporcionada por Logto a su extremo como encabezado de solicitud para garantizar la autenticidad del payload del webhook.",
        regenerate: "Regenerar",
        regenerate_key_title: "Regenerar clave de firma",
        regenerate_key_reminder: "\xbfEst\xe1 seguro de que desea modificar la clave de firma? Regenerar tendr\xe1 efecto de inmediato. Recuerde modificar la clave de firma de forma s\xedncrona en su endpoint.",
        regenerated: "La clave de firma ha sido regenerada.",
        custom_headers: "Encabezados Personalizados",
        custom_headers_tip: "De manera opcional, puede agregar encabezados personalizados al payload del webhook para proporcionar m\xe1s contexto o metadatos sobre el evento.",
        key_duplicated_error: "Las claves no pueden repetirse.",
        key_missing_error: "Se requiere clave.",
        value_missing_error: "Se requiere valor.",
        invalid_key_error: "La clave no es v\xe1lida",
        invalid_value_error: "El valor no es v\xe1lido",
        test: "Prueba",
        test_webhook: "Probar su webhook",
        test_webhook_description: "Configure el webhook y pru\xe9belo con ejemplos de carga \xfatil para cada evento seleccionado para verificar la recepci\xf3n y el procesamiento correcto.",
        send_test_payload: "Enviar carga \xfatil de prueba",
        test_result: {
            endpoint_url: "URL del punto final: {{url}}",
            message: "Mensaje: {{message}}",
            response_status: "Estado de la respuesta: {{status, number}}",
            response_body: "Cuerpo de la respuesta: {{body}}",
            request_time: "Tiempo de solicitud: {{time}}",
            test_success: "La prueba del webhook en el punto final fue exitosa."
        }
    }
};
var $e902c86788d1481d$export$2e2bcd8739ae039 = Object.freeze($e902c86788d1481d$var$webhook_details);


const $97e3d1578a1cfb15$var$webhooks = {
    page_title: "Webhooks",
    title: "Webhooks",
    subtitle: "Crea webhooks para recibir de manera f\xe1cil actualizaciones en tiempo real sobre eventos espec\xedficos.",
    create: "Crear Webhook",
    schemas: {
        interaction: "Interacci\xf3n de usuario",
        user: "Usuario",
        organization: "Organizaci\xf3n",
        role: "Rol",
        scope: "Permiso",
        organization_role: "Rol de organizaci\xf3n",
        organization_scope: "Permiso de organizaci\xf3n"
    },
    table: {
        name: "Nombre",
        events: "Eventos",
        success_rate: "Tasa de \xe9xito (24 h)",
        requests: "Solicitudes (24 h)"
    },
    placeholder: {
        title: "Webhook",
        description: 'Crea un webhook para recibir actualizaciones en tiempo real a trav\xe9s de solicitudes POST a tu URL de punto final. Mantente informado y toma medidas inmediatas en eventos como "Crear cuenta", "Iniciar sesi\xf3n" y "Restablecer contrase\xf1a".',
        create_webhook: "Crear Webhook"
    },
    create_form: {
        title: "Crear Webhook",
        subtitle: "Agregue el Webhook para enviar una solicitud POST a la URL de punto final con detalles de cualquier evento de usuario.",
        events: "Eventos",
        events_description: "Seleccione los eventos desencadenantes que Logto enviar\xe1 la solicitud POST.",
        name: "Nombre",
        name_placeholder: "Ingrese el nombre del webhook",
        endpoint_url: "URL de punto final",
        endpoint_url_placeholder: "https://su.webhook.endpoint.url",
        endpoint_url_tip: "Ingrese la URL de su punto final a donde se env\xeda la carga \xfatil del webhook cuando ocurre el evento.",
        create_webhook: "Crear webhook",
        missing_event_error: "Debe seleccionar al menos un evento."
    },
    webhook_created: "El webhook {{name}} se ha creado correctamente."
};
var $97e3d1578a1cfb15$export$2e2bcd8739ae039 = Object.freeze($97e3d1578a1cfb15$var$webhooks);


const $c266205a0317641d$var$welcome = {
    title: "Bienvenido a la Consola de Administraci\xf3n",
    description: "La consola de administraci\xf3n es una aplicaci\xf3n web para administrar Logto sin necesidad de conocimientos de programaci\xf3n. Primero creamos una cuenta. Con esta cuenta, puedes administrar Logto por ti mismo o en nombre de tu empresa.",
    create_account: "Crear cuenta"
};
var $c266205a0317641d$export$2e2bcd8739ae039 = Object.freeze($c266205a0317641d$var$welcome);


const $9fcdee248a981c72$var$admin_console = {
    title: "Consola de administraci\xf3n",
    admin_user: "Admin",
    system_app: "Sistema",
    menu: $a8bbf46db54e7de0$export$2e2bcd8739ae039,
    general: $d3e1c8a7b6ed6e08$export$2e2bcd8739ae039,
    errors: $c19520b1cb06b2ca$export$2e2bcd8739ae039,
    tab_sections: $9cbfc9ca485e656b$export$2e2bcd8739ae039,
    tabs: $5bc4e5c81e9ac61e$export$2e2bcd8739ae039,
    applications: $d00b74208f0dd5a4$export$2e2bcd8739ae039,
    application_details: $95e9713dc69dffc6$export$2e2bcd8739ae039,
    api_resources: $605c1ada0725cceb$export$2e2bcd8739ae039,
    api_resource_details: $b6db651553079467$export$2e2bcd8739ae039,
    connectors: $e2370375f0966479$export$2e2bcd8739ae039,
    connector_details: $1bda8871a84aad47$export$2e2bcd8739ae039,
    enterprise_sso: $f45f1185b4d55084$export$2e2bcd8739ae039,
    enterprise_sso_details: $6a94df51f8a55015$export$2e2bcd8739ae039,
    get_started: $8591c1bb935bf573$export$2e2bcd8739ae039,
    users: $ae40df6acb8b8884$export$2e2bcd8739ae039,
    user_details: $3fcb48a345079d3f$export$2e2bcd8739ae039,
    contact: $57c56ac0896ba319$export$2e2bcd8739ae039,
    sign_in_exp: $1d14355728cf4850$export$2e2bcd8739ae039,
    dashboard: $cd6a4b3c80422e05$export$2e2bcd8739ae039,
    logs: $11a67ba80eb323b6$export$2e2bcd8739ae039,
    log_details: $3eb265ad96ad376a$export$2e2bcd8739ae039,
    session_expired: $2e05a5112ca680b0$export$2e2bcd8739ae039,
    welcome: $c266205a0317641d$export$2e2bcd8739ae039,
    roles: $4b3b76703f91b201$export$2e2bcd8739ae039,
    role_details: $3255a7f9f330adb7$export$2e2bcd8739ae039,
    permissions: $7a34105c627dfe70$export$2e2bcd8739ae039,
    cloud: $754ece1eeb859b32$export$2e2bcd8739ae039,
    profile: $2ac73be060061e14$export$2e2bcd8739ae039,
    components: $607f93a81311623b$export$2e2bcd8739ae039,
    webhooks: $97e3d1578a1cfb15$export$2e2bcd8739ae039,
    webhook_details: $e902c86788d1481d$export$2e2bcd8739ae039,
    domain: $4508570636398143$export$2e2bcd8739ae039,
    tenants: $ca2e9cb50acb0d9a$export$2e2bcd8739ae039,
    tenant_members: $c133ef971b8a28d3$export$2e2bcd8739ae039,
    topbar: $1256335fd951153e$export$2e2bcd8739ae039,
    subscription: $13bad4b43168b9d2$export$2e2bcd8739ae039,
    upsell: $41bc2de94b89dbb0$export$2e2bcd8739ae039,
    guide: $21db42fe01da6298$export$2e2bcd8739ae039,
    mfa: $d286ff586698ec2a$export$2e2bcd8739ae039,
    organizations: $91a6b3b1b25ee53c$export$2e2bcd8739ae039,
    organization_details: $c9e33373352f38fb$export$2e2bcd8739ae039,
    protected_app: $4871ac3783482c71$export$2e2bcd8739ae039,
    jwt_claims: $b2385dc7019df5f9$export$2e2bcd8739ae039,
    invitation: $6850a4b6183cd6cf$export$2e2bcd8739ae039,
    signing_keys: $cf4739cd5a72cd3b$export$2e2bcd8739ae039,
    organization_template: $3844caf613a37ac5$export$2e2bcd8739ae039,
    organization_role_details: $78f9166775dacb5f$export$2e2bcd8739ae039
};
var $9fcdee248a981c72$export$2e2bcd8739ae039 = Object.freeze($9fcdee248a981c72$var$admin_console);


const $d97caac75db597ac$var$demo_app = {
    title: "\xa1Ha iniciado sesi\xf3n correctamente en la vista previa en vivo!",
    subtitle: "Aqu\xed est\xe1 su informaci\xf3n de inicio de sesi\xf3n:",
    username: "Nombre de usuario: ",
    user_id: "ID de usuario: ",
    sign_out: "Cerrar sesi\xf3n en la vista previa en vivo",
    continue_explore: "O contin\xfae explorando",
    customize_sign_in_experience: "Personalice la experiencia de inicio de sesi\xf3n",
    enable_passwordless: "Habilitar sin contrase\xf1a",
    add_social_connector: "Agregar conector social"
};
var $d97caac75db597ac$export$2e2bcd8739ae039 = Object.freeze($d97caac75db597ac$var$demo_app);


const $499e099c145adfa0$var$oidc = {
    logout_success: "Ha cerrado sesi\xf3n con \xe9xito."
};
var $499e099c145adfa0$export$2e2bcd8739ae039 = Object.freeze($499e099c145adfa0$var$oidc);


const $ac153cef542ae951$var$translation = {
    admin_console: $9fcdee248a981c72$export$2e2bcd8739ae039,
    demo_app: $d97caac75db597ac$export$2e2bcd8739ae039,
    oidc: $499e099c145adfa0$export$2e2bcd8739ae039
};
var $ac153cef542ae951$export$2e2bcd8739ae039 = Object.freeze($ac153cef542ae951$var$translation);


const $c389f6e746eb8bfb$var$es = {
    translation: $ac153cef542ae951$export$2e2bcd8739ae039,
    errors: $836ff5f4fa48416e$export$2e2bcd8739ae039
};
var $c389f6e746eb8bfb$export$2e2bcd8739ae039 = Object.freeze($c389f6e746eb8bfb$var$es);


const $a63c85ae7bcf3d55$var$application = {
    invalid_type: "Seules les applications machine \xe0 machine peuvent avoir des r\xf4les associ\xe9s.",
    role_exists: "Le r\xf4le d'identifiant {{roleId}} a d\xe9j\xe0 \xe9t\xe9 ajout\xe9 \xe0 cette application.",
    invalid_role_type: "Impossible d'assigner un r\xf4le de type utilisateur \xe0 une application machine \xe0 machine.",
    invalid_third_party_application_type: "Seules les applications Web traditionnelles peuvent \xeatre marqu\xe9es comme une application tierce.",
    third_party_application_only: "La fonctionnalit\xe9 est uniquement disponible pour les applications tierces.",
    user_consent_scopes_not_found: "Port\xe9es de consentement utilisateur invalides.",
    consent_management_api_scopes_not_allowed: "Les scopes de l'API de gestion ne sont pas autoris\xe9s.",
    protected_app_metadata_is_required: "Les m\xe9tadonn\xe9es de l'application prot\xe9g\xe9e sont requises.",
    protected_app_not_configured: "Le fournisseur d'application prot\xe9g\xe9e n'est pas configur\xe9. Cette fonctionnalit\xe9 n'est pas disponible dans la version open source.",
    cloudflare_unknown_error: "Erreur inconnue lors de la requ\xeate \xe0 l'API Cloudflare",
    protected_application_only: "La fonctionnalit\xe9 est uniquement disponible pour les applications prot\xe9g\xe9es.",
    protected_application_misconfigured: "L'application prot\xe9g\xe9e est mal configur\xe9e.",
    protected_application_subdomain_exists: "Le sous-domaine de l'application prot\xe9g\xe9e est d\xe9j\xe0 utilis\xe9.",
    invalid_subdomain: "Sous-domaine invalide.",
    custom_domain_not_found: "Domaine personnalis\xe9 non trouv\xe9.",
    should_delete_custom_domains_first: "Devrait d'abord supprimer les domaines personnalis\xe9s."
};
var $a63c85ae7bcf3d55$export$2e2bcd8739ae039 = Object.freeze($a63c85ae7bcf3d55$var$application);


const $52a6d0b1ee8b8334$var$auth = {
    authorization_header_missing: "L'en-t\xeate d'autorisation est manquant.",
    authorization_token_type_not_supported: "Le type d'autorisation n'est pas pris en charge.",
    unauthorized: "Non autoris\xe9. Veuillez v\xe9rifier les informations d'identification et son champ d'application.",
    forbidden: "Interdit. Veuillez v\xe9rifier vos r\xf4les et autorisations d'utilisateur.",
    expected_role_not_found: "Expected role not found. Please check your user roles and permissions.",
    jwt_sub_missing: "`sub` manquant dans JWT.",
    require_re_authentication: "La r\xe9-authentification est requise pour effectuer une action prot\xe9g\xe9e."
};
var $52a6d0b1ee8b8334$export$2e2bcd8739ae039 = Object.freeze($52a6d0b1ee8b8334$var$auth);


const $0b1bbe0e4cd7c7bb$var$connector = {
    general: "Une erreur s'est produite dans le connecteur : {{errorDescription}}",
    not_found: "Impossible de trouver un connecteur disponible pour le type : {{type}}.",
    not_enabled: "Le connecteur n'est pas activ\xe9.",
    invalid_metadata: "Les m\xe9tadonn\xe9es du connecteur sont invalides.",
    invalid_config_guard: "La configuration du connecteur est invalide.",
    unexpected_type: "Le type de connecteur est inattendu.",
    invalid_request_parameters: "La requ\xeate contient des param\xe8tres d'entr\xe9e incorrects.",
    insufficient_request_parameters: "Certains param\xe8tres peuvent manquer dans la requ\xeate.",
    invalid_config: "La configuration du connecteur n'est pas valide.",
    invalid_certificate: "Le certificat du connecteur est invalide, veuillez vous assurer que le certificat est encod\xe9 en PEM.",
    invalid_response: "La r\xe9ponse du connecteur n'est pas valide.",
    template_not_found: "Impossible de trouver le bon mod\xe8le dans la configuration du connecteur.",
    template_not_supported: "Le connecteur ne prend pas en charge ce type de mod\xe8le.",
    rate_limit_exceeded: "Limite de taux d\xe9pass\xe9e. Veuillez r\xe9essayer plus tard.",
    not_implemented: "{{method}} : n'a pas encore \xe9t\xe9 mis en œuvre.",
    social_invalid_access_token: "Le jeton d'acc\xe8s du connecteur n'est pas valide.",
    invalid_auth_code: "Le code d'authentification du connecteur n'est pas valide.",
    social_invalid_id_token: "Le jeton d'identification du connecteur n'est pas valide.",
    authorization_failed: "Le processus d'autorisation de l'utilisateur n'a pas abouti.",
    social_auth_code_invalid: "Impossible d'obtenir le jeton d'acc\xe8s, veuillez v\xe9rifier le code d'autorisation.",
    more_than_one_sms: "Le nombre de connecteurs SMS est sup\xe9rieur \xe0 1.",
    more_than_one_email: "Le nombre de connecteurs Email est sup\xe9rieur \xe0 1.",
    more_than_one_connector_factory: "Plusieurs fabriques de connecteurs ont \xe9t\xe9 trouv\xe9es (avec les identifiants {{connectorIds}}), vous pouvez d\xe9sinstaller ceux qui ne sont pas n\xe9cessaires.",
    db_connector_type_mismatch: "Il y a un connecteur dans la base de donn\xe9es qui ne correspond pas au type.",
    not_found_with_connector_id: "Impossible de trouver le connecteur avec l'identifiant de connecteur standard fourni.",
    multiple_instances_not_supported: "Impossible de cr\xe9er plusieurs instances avec le connecteur standard s\xe9lectionn\xe9.",
    invalid_type_for_syncing_profile: "Vous ne pouvez synchroniser le profil utilisateur qu'avec les connecteurs sociaux.",
    can_not_modify_target: 'Le "target" du connecteur ne peut pas \xeatre modifi\xe9.',
    should_specify_target: 'Vous devez sp\xe9cifier le "target".',
    multiple_target_with_same_platform: 'Vous ne pouvez pas avoir plusieurs connecteurs sociaux ayant la m\xeame "target" et la m\xeame plateforme.',
    cannot_overwrite_metadata_for_non_standard_connector: 'Les "metadata" de ce connecteur ne peuvent pas \xeatre modifi\xe9s.'
};
var $0b1bbe0e4cd7c7bb$export$2e2bcd8739ae039 = Object.freeze($0b1bbe0e4cd7c7bb$var$connector);


const $a6ec7433f0486a3e$var$domain = {
    not_configured: "Le fournisseur de nom de domaine de l'h\xf4te n'est pas configur\xe9.",
    cloudflare_data_missing: "les donn\xe9es de cloudflare sont manquantes, veuillez v\xe9rifier.",
    cloudflare_unknown_error: "Erreur inconnue lors de la requ\xeate de l'API Cloudflare",
    cloudflare_response_error: "R\xe9ponse inattendue de Cloudflare",
    limit_to_one_domain: "Vous ne pouvez avoir qu'un seul domaine personnalis\xe9",
    hostname_already_exists: "Ce domaine existe d\xe9j\xe0 sur notre serveur.",
    cloudflare_not_found: "Impossible de trouver le nom d'h\xf4te dans Cloudflare",
    domain_is_not_allowed: "Ce domaine n'est pas autoris\xe9."
};
var $a6ec7433f0486a3e$export$2e2bcd8739ae039 = Object.freeze($a6ec7433f0486a3e$var$domain);


const $633f6247fbb871c5$var$entity = {
    invalid_input: "Saisie invalide. La liste des valeurs ne doit pas \xeatre vide.",
    create_failed: "\xc9chec de la cr\xe9ation de {{name}}.",
    db_constraint_violated: "Violations de contraintes de base de donn\xe9es.",
    not_exists: "Le {{name}} n'existe pas.",
    not_exists_with_id: "Le {{name}} avec l'ID `{{id}}` n'existe pas.",
    not_found: "La ressource n'existe pas.",
    relation_foreign_key_not_found: "Impossible de trouver une ou plusieurs cl\xe9s \xe9trang\xe8res. Veuillez v\xe9rifier la saisie et vous assurer que toutes les entit\xe9s r\xe9f\xe9renc\xe9es existent.",
    unique_integrity_violation: "L'entit\xe9 existe d\xe9j\xe0. Veuillez v\xe9rifier la saisie et r\xe9essayer."
};
var $633f6247fbb871c5$export$2e2bcd8739ae039 = Object.freeze($633f6247fbb871c5$var$entity);


const $29af3a89eadcb970$var$guard = {
    invalid_input: "La requ\xeate {{type}} n'est pas valide.",
    invalid_pagination: "La valeur de la pagination de la requ\xeate n'est pas valide.",
    can_not_get_tenant_id: "Impossible de r\xe9cup\xe9rer l'identifiant du locataire \xe0 partir de la demande.",
    file_size_exceeded: "Taille du fichier d\xe9pass\xe9e.",
    mime_type_not_allowed: "Le type MIME n'est pas autoris\xe9."
};
var $29af3a89eadcb970$export$2e2bcd8739ae039 = Object.freeze($29af3a89eadcb970$var$guard);


const $57664c5510d766ee$var$hook = {
    missing_events: "Vous devez fournir au moins un \xe9v\xe9nement.",
    send_test_payload_failed: "\xc9chec de l'envoi de la charge utile de test : {{message}}",
    endpoint_responded_with_error: "Le point de terminaison a r\xe9pondu avec une erreur."
};
var $57664c5510d766ee$export$2e2bcd8739ae039 = Object.freeze($57664c5510d766ee$var$hook);


const $88a9d52a65107a7d$var$jwt_customizer = {
    general: "Une erreur s'est produite lors de la personnalisation du jeton JWT. Veuillez r\xe9essayer ult\xe9rieurement.",
    can_not_create_for_admin_tenant: "Impossible de cr\xe9er un personnaliseur de jeton JWT pour le locataire administratif."
};
var $88a9d52a65107a7d$export$2e2bcd8739ae039 = Object.freeze($88a9d52a65107a7d$var$jwt_customizer);


const $22003cb09d327a7d$var$localization = {
    cannot_delete_default_language: "{{languageTag}} est d\xe9fini comme votre langue par d\xe9faut et ne peut pas \xeatre supprim\xe9.",
    invalid_translation_structure: "Sch\xe9mas de donn\xe9es invalides. Veuillez v\xe9rifier votre entr\xe9e et r\xe9essayer."
};
var $22003cb09d327a7d$export$2e2bcd8739ae039 = Object.freeze($22003cb09d327a7d$var$localization);


const $432c815c21b9d2e4$var$log = {
    invalid_type: "Type de journalisation invalide."
};
var $432c815c21b9d2e4$export$2e2bcd8739ae039 = Object.freeze($432c815c21b9d2e4$var$log);


const $3881dbfd5187a8af$var$oidc = {
    aborted: "L'utilisateur a abandonn\xe9 l'interaction.",
    invalid_scope: "Scope invalide : {{error_description}}.",
    invalid_token: "Jeton fourni invalide.",
    invalid_client_metadata: "Les m\xe9tadonn\xe9es du client fournies sont invalides.",
    insufficient_scope: "Manque de champ `{{scope}}` dans le jeton.",
    invalid_request: "La requ\xeate est invalide.",
    invalid_grant: "La requ\xeate de consentement est invalide.",
    invalid_redirect_uri: "`redirect_uri` ne correspond \xe0 aucun des `redirect_uris` enregistr\xe9s par le client.",
    access_denied: "Acc\xe8s refus\xe9.",
    invalid_target: "Indicateur de ressource invalide.",
    unsupported_grant_type: "Le `grant_type` demand\xe9 n'est pas support\xe9.",
    unsupported_response_mode: "Le `response_mode` demand\xe9 n'est pas support\xe9.",
    unsupported_response_type: "Le `response_type` demand\xe9 n'est pas support\xe9.",
    provider_error: "Erreur interne de l'OIDC : {{message}}.",
    server_error: "Une erreur OIDC inconnue s'est produite. Veuillez r\xe9essayer plus tard.",
    provider_error_fallback: "Une erreur OIDC s'est produite : {{code}}.",
    key_required: "Au moins une cl\xe9 est requise.",
    key_not_found: "La cl\xe9 avec l'ID {{id}} n'est pas trouv\xe9e."
};
var $3881dbfd5187a8af$export$2e2bcd8739ae039 = Object.freeze($3881dbfd5187a8af$var$oidc);


const $af7b2385d5f8ac34$var$organization = {
    require_membership: "L'utilisateur doit \xeatre membre de l'organisation pour continuer."
};
var $af7b2385d5f8ac34$export$2e2bcd8739ae039 = Object.freeze($af7b2385d5f8ac34$var$organization);


const $6bd6e9e6b1547471$var$password = {
    unsupported_encryption_method: "La m\xe9thode de cryptage {{name}} n'est pas prise en charge.",
    pepper_not_found: "Mot de passe pepper non trouv\xe9. Veuillez v\xe9rifier votre environnement de base.",
    rejected: "Mot de passe rejet\xe9. Veuillez v\xe9rifier si votre mot de passe r\xe9pond aux exigences."
};
var $6bd6e9e6b1547471$export$2e2bcd8739ae039 = Object.freeze($6bd6e9e6b1547471$var$password);


const $a4ab8291f3a101e1$var$request = {
    invalid_input: "L'entr\xe9e est invalide. {{details}}",
    general: "Une erreur de requ\xeate s'est produite."
};
var $a4ab8291f3a101e1$export$2e2bcd8739ae039 = Object.freeze($a4ab8291f3a101e1$var$request);


const $c98c9ca4f75187ba$var$resource = {
    resource_identifier_in_use: "L'identifiant d'API {{indicator}} est d\xe9j\xe0 utilis\xe9",
    cannot_delete_management_api: "Impossible de supprimer l'API de gestion de Logto.",
    cannot_modify_management_api: "Impossible de modifier l'API de gestion de Logto."
};
var $c98c9ca4f75187ba$export$2e2bcd8739ae039 = Object.freeze($c98c9ca4f75187ba$var$resource);


const $770851fd9accd371$var$role = {
    name_in_use: "Ce nom de r\xf4le {{name}} est d\xe9j\xe0 utilis\xe9",
    scope_exists: "L'identifiant de port\xe9e {{scopeId}} a d\xe9j\xe0 \xe9t\xe9 ajout\xe9 \xe0 ce r\xf4le",
    management_api_scopes_not_assignable_to_user_role: "Impossible d'attribuer des port\xe9es d'API de gestion \xe0 un r\xf4le utilisateur.",
    user_exists: "L'identifiant d'utilisateur {{userId}} a d\xe9j\xe0 \xe9t\xe9 ajout\xe9 \xe0 ce r\xf4le",
    application_exists: "L'identifiant d'application {{applicationId}} a d\xe9j\xe0 \xe9t\xe9 ajout\xe9 \xe0 ce r\xf4le",
    default_role_missing: "Certains noms de r\xf4les par d\xe9faut n'existent pas dans la base de donn\xe9es, veuillez vous assurer de cr\xe9er d'abord des r\xf4les",
    internal_role_violation: 'Vous essayez peut-\xeatre de mettre \xe0 jour ou de supprimer un r\xf4le interne, ce qui est interdit par Logto. Si vous cr\xe9ez un nouveau r\xf4le, essayez un autre nom qui ne commence pas par "#internal:". '
};
var $770851fd9accd371$export$2e2bcd8739ae039 = Object.freeze($770851fd9accd371$var$role);


const $c7067d3a9c93b7f1$var$scope = {
    name_exists: "Le nom de port\xe9e {{name}} est d\xe9j\xe0 utilis\xe9",
    name_with_space: "Le nom de la port\xe9e ne peut pas contenir d'espace."
};
var $c7067d3a9c93b7f1$export$2e2bcd8739ae039 = Object.freeze($c7067d3a9c93b7f1$var$scope);


const $5a76976a3b4b6aaf$var$session = {
    not_found: "Session non trouv\xe9e. Veuillez revenir en arri\xe8re et vous connecter \xe0 nouveau.",
    invalid_credentials: "Informations d'identification non valides. Veuillez v\xe9rifier votre saisie.",
    invalid_sign_in_method: "La m\xe9thode de connexion actuelle n'est pas disponible.",
    invalid_connector_id: "Impossible de trouver un connecteur disponible avec l'id {{connectorId}}.",
    insufficient_info: "Informations d'identification insuffisantes",
    connector_id_mismatch: "Le connectorId ne correspond pas \xe0 l'enregistrement de la session.",
    connector_session_not_found: "La session du connecteur n'a pas \xe9t\xe9 trouv\xe9e. Veuillez revenir en arri\xe8re et vous connecter \xe0 nouveau.",
    verification_session_not_found: "La v\xe9rification n'a pas abouti. Red\xe9marrez le processus de v\xe9rification et r\xe9essayez.",
    verification_expired: "La connexion a expir\xe9. V\xe9rifiez \xe0 nouveau pour assurer la s\xe9curit\xe9 de votre compte.",
    verification_blocked_too_many_attempts: "Trop de tentatives en peu de temps. Veuillez r\xe9essayer {{relativeTime}}.",
    unauthorized: "Veuillez vous enregistrer d'abord.",
    unsupported_prompt_name: "Nom d'invite non support\xe9.",
    forgot_password_not_enabled: "La fonctionnalit\xe9 de r\xe9initialisation de mot de passe n'est pas activ\xe9e.",
    verification_failed: "La v\xe9rification n'a pas r\xe9ussi. Veuillez recommencer le processus de v\xe9rification.",
    connector_validation_session_not_found: "La session de validation de jeton de connecteur est introuvable.",
    identifier_not_found: "Identifiant utilisateur introuvable. Veuillez retourner en arri\xe8re et vous connecter \xe0 nouveau.",
    interaction_not_found: "Session d'interaction introuvable. Veuillez retourner en arri\xe8re et recommencer la session.",
    not_supported_for_forgot_password: "Cette op\xe9ration n'est pas prise en charge pour la r\xe9initialisation du mot de passe.",
    mfa: {
        require_mfa_verification: "La v\xe9rification MFA est requise pour vous connecter.",
        mfa_sign_in_only: "MFA est uniquement disponible pour l'interaction de connexion.",
        pending_info_not_found: "Informations MFA en attente introuvables, veuillez initier d'abord la MFA.",
        invalid_totp_code: "Code TOTP non valide.",
        webauthn_verification_failed: "\xc9chec de la v\xe9rification WebAuthn.",
        webauthn_verification_not_found: "V\xe9rification WebAuthn introuvable.",
        bind_mfa_existed: "MFA existe d\xe9j\xe0.",
        backup_code_can_not_be_alone: "Le code de sauvegarde ne peut pas \xeatre le seul MFA.",
        backup_code_required: "Le code de sauvegarde est requis.",
        invalid_backup_code: "Code de sauvegarde non valide.",
        mfa_policy_not_user_controlled: "La politique MFA n'est pas contr\xf4l\xe9e par l'utilisateur."
    },
    sso_enabled: "La connexion unique est activ\xe9e pour cet e-mail donn\xe9. Veuillez vous connecter avec SSO."
};
var $5a76976a3b4b6aaf$export$2e2bcd8739ae039 = Object.freeze($5a76976a3b4b6aaf$var$session);


const $ee45d55dc3280fe5$var$sign_in_experiences = {
    empty_content_url_of_terms_of_use: 'URL de contenu "Conditions d\'utilisation" vide. Veuillez ajouter l\'URL du contenu si les "Conditions d\'utilisation" sont activ\xe9es.',
    empty_social_connectors: "Connecteurs sociaux vides. Veuillez ajouter des connecteurs sociaux activ\xe9s lorsque la m\xe9thode de connexion sociale est activ\xe9e.",
    enabled_connector_not_found: "Le connecteur {{type}} activ\xe9 est introuvable.",
    not_one_and_only_one_primary_sign_in_method: "Il doit y avoir une et une seule m\xe9thode de connexion primaire. Veuillez v\xe9rifier votre saisie.",
    username_requires_password: "Vous devez activer la d\xe9finition d'un mot de passe pour l'identifiant d'inscription de nom d'utilisateur.",
    passwordless_requires_verify: "Vous devez activer la v\xe9rification pour l'identifiant d'inscription par e-mail/num\xe9ro de t\xe9l\xe9phone.",
    miss_sign_up_identifier_in_sign_in: "Les m\xe9thodes de connexion doivent contenir l'identifiant d'inscription.",
    password_sign_in_must_be_enabled: "La connexion par mot de passe doit \xeatre activ\xe9e lorsque la d\xe9finition d'un mot de passe est requise lors de l'inscription.",
    code_sign_in_must_be_enabled: "La connexion par code de v\xe9rification doit \xeatre activ\xe9e lorsque la d\xe9finition d'un mot de passe n'est pas requise lors de l'inscription.",
    unsupported_default_language: "Cette langue - {{language}} n'est pas prise en charge pour le moment.",
    at_least_one_authentication_factor: "Vous devez s\xe9lectionner au moins un facteur d'authentification.",
    backup_code_cannot_be_enabled_alone: "Le code de sauvegarde ne peut \xeatre activ\xe9 seul.",
    duplicated_mfa_factors: "Facteurs de MFA en double."
};
var $ee45d55dc3280fe5$export$2e2bcd8739ae039 = Object.freeze($ee45d55dc3280fe5$var$sign_in_experiences);


const $d8449a3d77c26516$var$single_sign_on = {
    forbidden_domains: "Les domaines de messagerie publique ne sont pas autoris\xe9s.",
    duplicated_domains: "Il existe des domaines en double.",
    invalid_domain_format: "Format de domaine invalide.",
    duplicate_connector_name: "Le nom du connecteur existe d\xe9j\xe0. Veuillez choisir un nom diff\xe9rent."
};
var $d8449a3d77c26516$export$2e2bcd8739ae039 = Object.freeze($d8449a3d77c26516$var$single_sign_on);


const $6cfaa2de8cfbc720$var$storage = {
    not_configured: "Le fournisseur de stockage n'est pas configur\xe9.",
    missing_parameter: "Param\xe8tre manquant {{parameter}} pour le fournisseur de stockage.",
    upload_error: "\xc9chec de l'envoi du fichier au fournisseur de stockage."
};
var $6cfaa2de8cfbc720$export$2e2bcd8739ae039 = Object.freeze($6cfaa2de8cfbc720$var$storage);


const $a4fcb5f8011000fe$var$subscription = {
    limit_exceeded: "Vous avez atteint la limite de votre plan d'abonnement.",
    get_plan_failed: "\xc9chec de l'obtention du plan d'abonnement pour le locataire.",
    tenant_suspended: "Le locataire est suspendu. Veuillez contacter votre administrateur."
};
var $a4fcb5f8011000fe$export$2e2bcd8739ae039 = Object.freeze($a4fcb5f8011000fe$var$subscription);


const $7f28487f5e224ac2$var$swagger = {
    invalid_zod_type: "Type Zod non valide. Veuillez v\xe9rifier la configuration du garde-route.",
    not_supported_zod_type_for_params: "Type Zod non support\xe9 pour les param\xe8tres. Veuillez v\xe9rifier la configuration du garde-route."
};
var $7f28487f5e224ac2$export$2e2bcd8739ae039 = Object.freeze($7f28487f5e224ac2$var$swagger);


const $366f5eefee0930ba$var$user = {
    username_already_in_use: "Ce nom d'utilisateur est d\xe9j\xe0 utilis\xe9.",
    email_already_in_use: "Cet e-mail est associ\xe9 \xe0 un compte existant.",
    phone_already_in_use: "Ce num\xe9ro de t\xe9l\xe9phone est associ\xe9 \xe0 un compte existant.",
    invalid_email: "Addresse email incorrecte.",
    invalid_phone: "Num\xe9ro de t\xe9l\xe9phone incorrect.",
    email_not_exist: "L'adresse e-mail n'a pas encore \xe9t\xe9 enregistr\xe9e.",
    phone_not_exist: "Le num\xe9ro de t\xe9l\xe9phone n'a pas encore \xe9t\xe9 enregistr\xe9.",
    identity_not_exist: "Le compte social n'a pas encore \xe9t\xe9 enregistr\xe9.",
    identity_already_in_use: "Le compte social a \xe9t\xe9 enregistr\xe9.",
    social_account_exists_in_profile: "Vous avez d\xe9j\xe0 associ\xe9 ce compte social.",
    cannot_delete_self: "Vous ne pouvez pas vous supprimer vous-m\xeame.",
    sign_up_method_not_enabled: "Cette m\xe9thode d'inscription n'est pas activ\xe9e.",
    sign_in_method_not_enabled: "Cette m\xe9thode de connexion n'est pas activ\xe9e.",
    same_password: "Le nouveau mot de passe ne peut pas \xeatre identique \xe0 l'ancien.",
    password_required_in_profile: "Vous devez d\xe9finir un mot de passe avant de vous connecter.",
    new_password_required_in_profile: "Vous devez d\xe9finir un nouveau mot de passe.",
    password_exists_in_profile: "Le mot de passe existe d\xe9j\xe0 dans votre profil.",
    username_required_in_profile: "Vous devez d\xe9finir un nom d'utilisateur avant de vous connecter.",
    username_exists_in_profile: "Le nom d'utilisateur existe d\xe9j\xe0 dans votre profil.",
    email_required_in_profile: "Vous devez ajouter une adresse e-mail avant de vous connecter.",
    email_exists_in_profile: "Votre profil est d\xe9j\xe0 associ\xe9 \xe0 une adresse e-mail.",
    phone_required_in_profile: "Vous devez ajouter un num\xe9ro de t\xe9l\xe9phone avant de vous connecter.",
    phone_exists_in_profile: "Votre profil est d\xe9j\xe0 associ\xe9 \xe0 un num\xe9ro de t\xe9l\xe9phone.",
    email_or_phone_required_in_profile: "Vous devez ajouter une adresse e-mail ou un num\xe9ro de t\xe9l\xe9phone avant de vous connecter.",
    suspended: "Ce compte est suspendu.",
    user_not_exist: "L'utilisateur avec {{ identifier }} n'existe pas.",
    missing_profile: "Vous devez fournir des informations suppl\xe9mentaires avant de vous connecter.",
    role_exists: "L'ID de r\xf4le {{roleId}} a d\xe9j\xe0 \xe9t\xe9 ajout\xe9 \xe0 cet utilisateur",
    invalid_role_type: 'Le type de r\xf4le est invalide, il est impossible d\'assigner un r\xf4le "machine-to-machine" \xe0 un utilisateur.',
    missing_mfa: "Vous devez lier un MFA suppl\xe9mentaire avant de vous connecter.",
    totp_already_in_use: "TOTP est d\xe9j\xe0 utilis\xe9.",
    backup_code_already_in_use: "Le code de sauvegarde est d\xe9j\xe0 utilis\xe9.",
    password_algorithm_required: "Algorithme de mot de passe est requis.",
    password_and_digest: "Vous ne pouvez pas d\xe9finir \xe0 la fois un mot de passe en texte brut et un digest de mot de passe."
};
var $366f5eefee0930ba$export$2e2bcd8739ae039 = Object.freeze($366f5eefee0930ba$var$user);


const $0941e201d2b9452f$var$verification_code = {
    phone_email_empty: "Les deux le t\xe9l\xe9phone et l'email sont vides.",
    not_found: "Le code de v\xe9rification n'a pas \xe9t\xe9 trouv\xe9. Veuillez d'abord envoyer le code de v\xe9rification.",
    phone_mismatch: "T\xe9l\xe9phone ne correspond pas. Veuillez demander un nouveau code de v\xe9rification.",
    email_mismatch: "Email ne correspond pas. Veuillez demander un nouveau code de v\xe9rification.",
    code_mismatch: "Code de v\xe9rification invalide.",
    expired: "Le code de v\xe9rification a expir\xe9. Veuillez demander un nouveau code de v\xe9rification.",
    exceed_max_try: "La limite de tentatives de code de v\xe9rification a \xe9t\xe9 d\xe9pass\xe9e. Veuillez demander un nouveau code de v\xe9rification."
};
var $0941e201d2b9452f$export$2e2bcd8739ae039 = Object.freeze($0941e201d2b9452f$var$verification_code);


const $62708cc9c01c0866$var$errors = {
    request: $a4ab8291f3a101e1$export$2e2bcd8739ae039,
    auth: $52a6d0b1ee8b8334$export$2e2bcd8739ae039,
    guard: $29af3a89eadcb970$export$2e2bcd8739ae039,
    oidc: $3881dbfd5187a8af$export$2e2bcd8739ae039,
    user: $366f5eefee0930ba$export$2e2bcd8739ae039,
    password: $6bd6e9e6b1547471$export$2e2bcd8739ae039,
    session: $5a76976a3b4b6aaf$export$2e2bcd8739ae039,
    connector: $0b1bbe0e4cd7c7bb$export$2e2bcd8739ae039,
    verification_code: $0941e201d2b9452f$export$2e2bcd8739ae039,
    sign_in_experiences: $ee45d55dc3280fe5$export$2e2bcd8739ae039,
    jwt_customizer: $88a9d52a65107a7d$export$2e2bcd8739ae039,
    localization: $22003cb09d327a7d$export$2e2bcd8739ae039,
    swagger: $7f28487f5e224ac2$export$2e2bcd8739ae039,
    entity: $633f6247fbb871c5$export$2e2bcd8739ae039,
    log: $432c815c21b9d2e4$export$2e2bcd8739ae039,
    role: $770851fd9accd371$export$2e2bcd8739ae039,
    scope: $c7067d3a9c93b7f1$export$2e2bcd8739ae039,
    storage: $6cfaa2de8cfbc720$export$2e2bcd8739ae039,
    resource: $c98c9ca4f75187ba$export$2e2bcd8739ae039,
    hook: $57664c5510d766ee$export$2e2bcd8739ae039,
    domain: $a6ec7433f0486a3e$export$2e2bcd8739ae039,
    subscription: $a4fcb5f8011000fe$export$2e2bcd8739ae039,
    application: $a63c85ae7bcf3d55$export$2e2bcd8739ae039,
    organization: $af7b2385d5f8ac34$export$2e2bcd8739ae039,
    single_sign_on: $d8449a3d77c26516$export$2e2bcd8739ae039
};
var $62708cc9c01c0866$export$2e2bcd8739ae039 = Object.freeze($62708cc9c01c0866$var$errors);


const $491c09e744855fc4$var$api_resource_details = {
    page_title: "D\xe9tails de la ressource API",
    back_to_api_resources: "Retour aux ressources API",
    general_tab: "G\xe9n\xe9ral",
    permissions_tab: "Autorisations",
    settings: "Param\xe8tres",
    settings_description: "Les ressources API, \xe9galement connues sous le nom d'indicateurs de ressource, indiquent les services ou les ressources cibles \xe0 demander, g\xe9n\xe9ralement une variable de format d'URI repr\xe9sentant l'identit\xe9 de la ressource.",
    management_api_settings_description: "La Logto Management API est une collection compl\xe8te d'API qui permettent aux administrateurs de g\xe9rer une large gamme de t\xe2ches li\xe9es \xe0 l'identit\xe9, d'appliquer des politiques de s\xe9curit\xe9 et de se conformer aux r\xe9glementations et normes.",
    management_api_notice: "Cette API repr\xe9sente l'entit\xe9 Logto et ne peut pas \xeatre modifi\xe9e ou supprim\xe9e. Cr\xe9ez une application de machine \xe0 machine pour appeler l'API de gestion de Logto. <a>En savoir plus</a>",
    token_expiration_time_in_seconds: "Temps d'expiration du jeton (en secondes)",
    token_expiration_time_in_seconds_placeholder: "Entrez le d\xe9lai d'expiration de votre jeton",
    delete_description: "Cette action ne peut pas \xeatre annul\xe9e. Elle supprimera d\xe9finitivement la ressource API. Veuillez entrer le nom de la ressource API <span>{{name}}</span> pour confirmer.",
    enter_your_api_resource_name: "Entrez le nom de votre ressource API",
    api_resource_deleted: "La ressource API {{name}} a \xe9t\xe9 supprim\xe9e avec succ\xe8s",
    permission: {
        create_button: "Cr\xe9er une autorisation",
        create_title: "Cr\xe9er une autorisation",
        create_subtitle: "D\xe9finir les autorisations (scopes) requises pour cette API.",
        confirm_create: "Cr\xe9er une autorisation",
        edit_title: "Modifier l'autorisation de l'API",
        edit_subtitle: "D\xe9finir les autorisations (scopes) n\xe9cessaires pour l'API {{resourceName}}.",
        name: "Nom de l'autorisation",
        name_placeholder: "lecture:ressource",
        forbidden_space_in_name: "Le nom de l'autorisation ne doit pas contenir d'espaces.",
        description: "Description",
        description_placeholder: "Capable de lire les ressources",
        permission_created: "L'autorisation {{name}} a \xe9t\xe9 cr\xe9\xe9e avec succ\xe8s",
        delete_description: "Si cette autorisation est supprim\xe9e, l'utilisateur qui avait cette autorisation perdra l'acc\xe8s qui lui a \xe9t\xe9 accord\xe9.",
        deleted: 'L\'autorisation "{{name}}" a \xe9t\xe9 supprim\xe9e avec succ\xe8s.'
    }
};
var $491c09e744855fc4$export$2e2bcd8739ae039 = Object.freeze($491c09e744855fc4$var$api_resource_details);


const $0ff30d9e7c3716dc$var$api_resources = {
    page_title: "Ressources API",
    title: "Ressources API",
    subtitle: "D\xe9finir les API que vous pouvez consommer \xe0 partir de vos applications autoris\xe9es",
    create: "Cr\xe9er une ressource API",
    api_name: "Nom de l'API",
    api_name_placeholder: "Entrez votre nom d'API",
    api_identifier: "Identifiant de l'API",
    api_identifier_placeholder: "https://votre-identifiant-api/",
    api_identifier_tip: "L'identifiant unique de la ressource API. Il doit s'agir d'un URI absolu et ne doit pas comporter de fragment (#). \xc9quivaut au <a>param\xe8tre de ressource</> dans OAuth 2.0.",
    default_api: "API par d\xe9faut",
    default_api_label: "Seulement z\xe9ro ou une API par d\xe9faut peut \xeatre d\xe9finie par tenant. Lorsqu'une API par d\xe9faut est d\xe9sign\xe9e, le param\xe8tre \"resource\" peut \xeatre omis dans la demande d'authentification. Les \xe9changes de jetons ult\xe9rieurs utiliseront cette API comme public cible par d\xe9faut, ce qui entra\xeenera la d\xe9livrance de JWT. <a>En savoir plus</a>",
    api_resource_created: "La ressource API {{name}} a \xe9t\xe9 cr\xe9\xe9e avec succ\xe8s.",
    invalid_resource_indicator_format: "L'indicateur de l'API doit \xeatre un URI absolu valide."
};
var $0ff30d9e7c3716dc$export$2e2bcd8739ae039 = Object.freeze($0ff30d9e7c3716dc$var$api_resources);


const $2b6710c4d360421e$var$application_details = {
    page_title: "D\xe9tails de l'application",
    back_to_applications: "Retour aux applications",
    check_guide: "Consulter le guide",
    settings: "Param\xe8tres",
    settings_description: 'Une "Application" est un logiciel ou un service enregistr\xe9 qui peut acc\xe9der aux infos utilisateur ou agir pour un utilisateur. Les applications aident \xe0 reconna\xeetre qui demande quoi \xe0 Logto et \xe0 g\xe9rer la connexion et les autorisations. Remplissez les champs requis pour l\'authentification.',
    integration: "Int\xe9gration",
    integration_description: "D\xe9ployez avec les travailleurs s\xe9curis\xe9s de Logto, aliment\xe9s par le r\xe9seau Edge de Cloudflare pour des performances de premier plan et des d\xe9marrages \xe0 froid de 0ms dans le monde entier.",
    service_configuration: "Configuration du service",
    service_configuration_description: "Compl\xe9tez les configurations n\xe9cessaires dans votre service.",
    session: "Session",
    endpoints_and_credentials: "Points de terminaison & Informations d'identification",
    endpoints_and_credentials_description: "Utilisez les points de terminaison et les informations d'identification suivants pour configurer la connexion OIDC dans votre application.",
    refresh_token_settings: "Token de rafra\xeechissement",
    refresh_token_settings_description: "G\xe9rez les r\xe8gles du jeton de rafra\xeechissement pour cette application.",
    application_roles: "R\xf4les",
    machine_logs: "Journaux de machine",
    application_name: "Nom de l'application",
    application_name_placeholder: "Mon App",
    description: "Description",
    description_placeholder: "Entrez la description de votre application",
    config_endpoint: "Point de configuration du fournisseur OpenID",
    authorization_endpoint: "Point de terminaison d'autorisation",
    authorization_endpoint_tip: "Le point de terminaison pour effectuer l'authentification et l'autorisation. Il est utilis\xe9 pour <a>l'authentification</a> OpenID Connect.",
    show_endpoint_details: "Afficher les d\xe9tails du point de terminaison",
    hide_endpoint_details: "Masquer les d\xe9tails du point de terminaison",
    logto_endpoint: "Point de terminaison Logto",
    application_id: "ID de l'application",
    application_id_tip: "L'identifiant d'application unique g\xe9n\xe9ralement g\xe9n\xe9r\xe9 par Logto. Il signifie \xe9galement <a>client_id</a> dans OpenID Connect.",
    application_secret: "Secret de l'application",
    redirect_uri: "URI de redirection",
    redirect_uris: "URIs de redirection",
    redirect_uri_placeholder: "https://votre.site.com/app",
    redirect_uri_placeholder_native: "io.logto://callback",
    redirect_uri_tip: "L'URI de redirection apr\xe8s la connexion d'un utilisateur (qu'elle soit r\xe9ussie ou non). Voir OpenID Connect <a>AuthRequest</a> pour plus d'informations.",
    post_sign_out_redirect_uri: "URI de redirection post-d\xe9connexion",
    post_sign_out_redirect_uris: "URI de redirection apr\xe8s la d\xe9connexion",
    post_sign_out_redirect_uri_placeholder: "https://votre.site.com/home",
    post_sign_out_redirect_uri_tip: "L'URI de redirection apr\xe8s la d\xe9connexion de l'utilisateur (facultatif). Cela peut n'avoir aucun effet pratique dans certains types d'applications.",
    cors_allowed_origins: "Origines CORS autoris\xe9es",
    cors_allowed_origins_placeholder: "https://votre.site.com",
    cors_allowed_origins_tip: "Par d\xe9faut, toutes les origines des URI de redirection seront autoris\xe9es. En g\xe9n\xe9ral, aucune action n'est requise pour ce champ. Consultez la documentation <a>MDN</a> pour des informations d\xe9taill\xe9es.",
    token_endpoint: "Point de terminaison du jeton",
    user_info_endpoint: "Point de terminaison de l'utilisateur",
    enable_admin_access: "Activer l'acc\xe8s administrateur",
    enable_admin_access_label: "Activer ou d\xe9sactiver l'acc\xe8s \xe0 l'API de gestion. Une fois activ\xe9, vous pouvez utiliser des jetons d'acc\xe8s pour appeler l'API de gestion au nom de cette application.",
    always_issue_refresh_token: "Toujours \xe9mettre le Refresh Token.",
    always_issue_refresh_token_label: "En activant cette configuration, Logto pourra toujours \xe9mettre des Refresh Tokens, ind\xe9pendamment de la pr\xe9sentation ou non de la demande d'authentification `prompt=consent`. Cependant, cette pratique est d\xe9courag\xe9e sauf si n\xe9cessaire, car elle n'est pas compatible avec OpenID Connect et peut potentiellement causer des probl\xe8mes.",
    refresh_token_ttl: "Dur\xe9e de vie du Refresh Token en jours",
    refresh_token_ttl_tip: "La dur\xe9e pendant laquelle un Refresh Token peut \xeatre utilis\xe9 pour demander de nouveaux jetons d'acc\xe8s avant qu'il n'expire et devienne invalide. Les demandes de jeton \xe9tendront la dur\xe9e de vie du Refresh Token \xe0 cette valeur.",
    rotate_refresh_token: "Tourner le Refresh Token",
    rotate_refresh_token_label: "Lorsqu'elle est activ\xe9e, Logto \xe9mettra un nouveau Refresh Token pour les demandes de jeton lorsque 70% de la dur\xe9e de vie (TTL) d'origine est \xe9coul\xe9e ou que certaines conditions sont remplies. <a>En savoir plus</a>",
    delete_description: "Cette action ne peut \xeatre annul\xe9e. Elle supprimera d\xe9finitivement l'application. Veuillez entrer le nom de l'application <span>{{nom}}</span> pour confirmer.",
    enter_your_application_name: "Entrez le nom de votre application",
    application_deleted: "L'application {{name}} a \xe9t\xe9 supprim\xe9e avec succ\xe8s.",
    redirect_uri_required: "Vous devez entrer au moins un URI de redirection.",
    app_domain_description_1: "N'h\xe9sitez pas \xe0 utiliser votre domaine avec {{domain}} aliment\xe9 par Logto, qui est valide en permanence.",
    app_domain_description_2: "N'h\xe9sitez pas \xe0 utiliser votre domaine <domain>{{domain}}</domain> qui est valide en permanence.",
    custom_rules: "R\xe8gles d'authentification personnalis\xe9es",
    custom_rules_placeholder: "^/(admin|privacy)/.+$",
    custom_rules_description: "D\xe9finissez des r\xe8gles avec des expressions r\xe9guli\xe8res pour les routes n\xe9cessitant une authentification. Par d\xe9faut : protection totale du site si laiss\xe9 vide.",
    authentication_routes: "Routes d'authentification",
    custom_rules_tip: "Voici deux sc\xe9narios possibles :<ol><li>Pour prot\xe9ger uniquement les routes '/admin' et '/privacy' avec une authentification : ^/(admin|privacy)/.*</li><li>Pour exclure les images JPG de l'authentification : ^(?!.*\\.jpg$).*$</li></ol>",
    authentication_routes_description: "Redirigez votre bouton d'authentification en utilisant les routes sp\xe9cifi\xe9es. Remarque : Ces routes sont inchangeables.",
    protect_origin_server: "Prot\xe9ger votre serveur d'origine",
    protect_origin_server_description: "Assurez-vous de prot\xe9ger votre serveur d'origine contre un acc\xe8s direct. R\xe9f\xe9rez-vous au guide pour plus de <a>instructions d\xe9taill\xe9es</a>.",
    session_duration: "Dur\xe9e de la session (jours)",
    try_it: "Essayez",
    branding: {
        name: "Marque",
        description: "Personnalisez le nom d'affichage et le logo de votre application sur l'\xe9cran de consentement.",
        more_info: "Plus d'informations",
        more_info_description: "Offrez aux utilisateurs plus de d\xe9tails sur votre application sur l'\xe9cran de consentement.",
        display_name: "Nom d'affichage",
        display_logo: "Logo d'affichage",
        display_logo_dark: "Logo d'affichage (sombre)",
        terms_of_use_url: "URL des conditions d'utilisation de l'application",
        privacy_policy_url: "URL de la politique de confidentialit\xe9 de l'application"
    },
    permissions: {
        name: "Permissions",
        description: "S\xe9lectionnez les permissions requises par l'application tierce pour l'autorisation de l'utilisateur afin d'acc\xe9der \xe0 des types de donn\xe9es sp\xe9cifiques.",
        user_permissions: "Donn\xe9es personnelles de l'utilisateur",
        organization_permissions: "Acc\xe8s \xe0 l'organisation",
        table_name: "Accorder des permissions",
        field_name: "Permission",
        field_description: "Affich\xe9 \xe0 l'\xe9cran de consentement",
        delete_text: "Supprimer la permission",
        permissions_assignment_description: "S\xe9lectionnez les permissions demand\xe9es par l'application tierce pour l'autorisation de l'utilisateur afin d'acc\xe9der \xe0 des types de donn\xe9es sp\xe9cifiques.",
        user_profile: "Donn\xe9es utilisateur",
        api_permissions: "Permissions d'API",
        organization: "Permissions d'organisation",
        user_permissions_assignment_form_title: "Ajouter les permissions du profil utilisateur",
        organization_permissions_assignment_form_title: "Ajouter les permissions de l'organisation",
        api_resource_permissions_assignment_form_title: "Ajouter les permissions des ressources d'API",
        user_data_permission_description_tips: 'Vous pouvez modifier la description des permissions relatives aux donn\xe9es personnelles des utilisateurs via "Exp\xe9rience de connexion > Contenu > G\xe9rer la langue"',
        permission_description_tips: "Lorsque Logto est utilis\xe9 comme fournisseur d'identit\xe9s (IdP) pour l'authentification dans des applications tierces, et que les utilisateurs doivent donner leur autorisation, cette description appara\xeet sur l'\xe9cran de consentement.",
        user_title: "Utilisateur",
        user_description: "S\xe9lectionnez les permissions demand\xe9es par l'application tierce pour acc\xe9der \xe0 des donn\xe9es utilisateur sp\xe9cifiques.",
        grant_user_level_permissions: "Accorder des permissions des donn\xe9es utilisateur",
        organization_title: "Organisation",
        organization_description: "S\xe9lectionnez les permissions demand\xe9es par l'application tierce pour acc\xe9der \xe0 des donn\xe9es d'organisation sp\xe9cifiques.",
        grant_organization_level_permissions: "Accorder des permissions des donn\xe9es d'organisation"
    },
    roles: {
        name_column: "R\xf4le",
        description_column: "Description",
        assign_button: "Attribuer des r\xf4les",
        delete_description: "Cette action supprimera ce r\xf4le de cette application machine-to-machine. Le r\xf4le lui-m\xeame existera toujours, mais il ne sera plus associ\xe9 \xe0 cette application machine-to-machine.",
        deleted: "{{name}} a \xe9t\xe9 supprim\xe9(e) avec succ\xe8s de cet utilisateur.",
        assign_title: "Attribuer des r\xf4les \xe0 {{name}}",
        assign_subtitle: "Autoriser {{name}} \xe0 un ou plusieurs r\xf4les",
        assign_role_field: "Attribuer des r\xf4les",
        role_search_placeholder: "Rechercher par nom de r\xf4le",
        added_text: "{{value, number}} ajout\xe9(s)",
        assigned_app_count: "{{value, number}} applications",
        confirm_assign: "Assigner des r\xf4les",
        role_assigned: "R\xf4le(s) attribu\xe9(e)s avec succ\xe8s",
        search: "Rechercher par nom de r\xf4le, description ou ID",
        empty: "Aucun r\xf4le disponible"
    }
};
var $2b6710c4d360421e$export$2e2bcd8739ae039 = Object.freeze($2b6710c4d360421e$var$application_details);


const $7df0b84ef2d52bc3$var$applications = {
    page_title: "Applications",
    title: "Applications",
    subtitle: "Configurez une application mobile, une page unique, machine to machine ou une application traditionnelle pour utiliser Logto pour l'authentification.",
    subtitle_with_app_type: "Configurez l'authentification Logto pour votre application {{name}}",
    create: "Cr\xe9er une application",
    create_subtitle_third_party: "Utilisez Logto en tant que votre fournisseur d'identit\xe9 (IdP) pour int\xe9grer facilement avec des applications tierces",
    application_name: "Nom de l'application",
    application_name_placeholder: "Mon app",
    application_description: "Description de l'application",
    application_description_placeholder: "Entrer la description de votre application",
    select_application_type: "S\xe9lectionner un type d'application",
    no_application_type_selected: "Vous n'avez pas encore s\xe9lectionn\xe9 de type d'application",
    application_created: "L'application a \xe9t\xe9 cr\xe9\xe9e avec succ\xe8s.",
    tab: {
        my_applications: "Mes applications",
        third_party_applications: "Applications tierces"
    },
    app_id: "App ID",
    type: {
        native: {
            title: "Application native",
            subtitle: "Une application qui fonctionne dans un environnement natif",
            description: "Exemple: application iOS, application Android"
        },
        spa: {
            title: "Application \xe0 page unique",
            subtitle: "Une application qui s'ex\xe9cute dans un navigateur web et met dynamiquement \xe0 jour les donn\xe9es sur place.",
            description: "Exemple: application React, application Vue"
        },
        traditional: {
            title: "Web traditionnel",
            subtitle: "Une application qui met \xe0 jour les pages par le seul serveur web.",
            description: "Exemple: Next.js, PHP"
        },
        machine_to_machine: {
            title: "Machine-to-Machine",
            subtitle: "Une application (g\xe9n\xe9ralement un service) qui communique directement avec les ressources",
            description: "Par exemple, un service backend"
        },
        protected: {
            title: "Application prot\xe9g\xe9e",
            subtitle: "Une application prot\xe9g\xe9e par Logto",
            description: "N/A"
        },
        third_party: {
            title: "Application tierce",
            subtitle: "Une application utilis\xe9e comme connecteur IdP tiers",
            description: "Par exemple, OIDC, SAML"
        }
    },
    placeholder_title: "S\xe9lectionnez un type d'application pour continuer",
    placeholder_description: "Logto utilise une entit\xe9 d'application pour OIDC pour aider aux t\xe2ches telles que l'identification de vos applications, la gestion de la connexion et la cr\xe9ation de journaux d'audit",
    m2m_role_assignment: {
        title: "Autoriser l'application avec un r\xf4le machine \xe0 machine pour les permissions",
        subtitle: "Les applications machine \xe0 machine n\xe9cessitent un r\xf4le machine \xe0 machine autoris\xe9.",
        role_creation_hint: "Vous ne trouvez pas le bon r\xf4le machine \xe0 machine ? <a>Cr\xe9er un r\xf4le machine \xe0 machine</a>"
    }
};
var $7df0b84ef2d52bc3$export$2e2bcd8739ae039 = Object.freeze($7df0b84ef2d52bc3$var$applications);


const $cfca5ec3ac841d06$var$cloud = {
    general: {
        onboarding: "Int\xe9gration"
    },
    welcome: {
        page_title: "Bienvenue",
        title: "Bienvenue dans Logto Cloud ! Nous aimerions en savoir un peu plus sur vous.",
        description: "Personnalisons votre exp\xe9rience Logto en vous connaissant mieux. Vos informations sont en s\xe9curit\xe9 avec nous.",
        project_field: "J'utilise Logto pour",
        project_options: {
            personal: "Projet personnel",
            company: "Projet d'entreprise"
        },
        company_name_field: "Nom de l'entreprise",
        company_name_placeholder: "Acme.co",
        stage_field: "Dans quelle \xe9tape se trouve actuellement votre produit?",
        stage_options: {
            new_product: "D\xe9marrer un nouveau projet et chercher une solution rapide et pr\xeate \xe0 l'emploi",
            existing_product: "Migrer \xe0 partir d'une authentification actuelle (par exemple, auto-construite, Auth0, Cognito, Microsoft)",
            target_enterprise_ready: "Je viens de conclure des contrats avec des clients plus importants et je veux maintenant rendre mon produit pr\xeat \xe0 \xeatre vendu aux entreprises"
        },
        additional_features_field: "Avez-vous d'autres informations \xe0 nous communiquer?",
        additional_features_options: {
            customize_ui_and_flow: "Construire et g\xe9rer ma propre interface utilisateur, pas seulement utiliser la solution pr\xe9-construite et personnalisable de Logto",
            compliance: "SOC2 et le respect du RGPD sont indispensables",
            export_user_data: "Besoin de la possibilit\xe9 d'exporter des donn\xe9es utilisateur \xe0 partir de Logto",
            budget_control: "Je dois avoir un contr\xf4le de budget tr\xe8s strict",
            bring_own_auth: "J'ai mes propres services d'authentification et j'ai juste besoin de certaines fonctionnalit\xe9s de Logto",
            others: "Aucun de ceux mentionn\xe9s ci-dessus"
        }
    },
    sie: {
        page_title: "Personnalisez l'exp\xe9rience de connexion",
        title: "Personnalisons d'abord votre exp\xe9rience de connexion en toute simplicit\xe9",
        inspire: {
            title: "Cr\xe9ez des exemples convaincants",
            description: 'Vous vous sentez incertain de l\'exp\xe9rience de connexion ? Cliquez simplement sur "Inspirez-moi" et laissez la magie op\xe9rer!',
            inspire_me: "Inspirez-moi"
        },
        logo_field: "Logo de l'application",
        color_field: "Couleur de la marque",
        identifier_field: "Identifiant",
        identifier_options: {
            email: "E-mail",
            phone: "T\xe9l\xe9phone",
            user_name: "Nom d'utilisateur"
        },
        authn_field: "Authentification",
        authn_options: {
            password: "Mot de passe",
            verification_code: "Code de v\xe9rification"
        },
        social_field: "Connexion sociale",
        finish_and_done: "Terminer et termin\xe9",
        preview: {
            mobile_tab: "Mobile",
            web_tab: "Web"
        },
        connectors: {
            unlocked_later: "D\xe9bloqu\xe9 ult\xe9rieurement",
            unlocked_later_tip: "Une fois que vous avez termin\xe9 le processus d'inscription et que vous \xeates entr\xe9 dans le produit, vous aurez acc\xe8s \xe0 encore plus de m\xe9thodes de connexion sociale.",
            notice: "Veuillez \xe9viter d'utiliser le connecteur de d\xe9monstration \xe0 des fins de production. Lorsque vous avez termin\xe9 les tests, veuillez supprimer le connecteur de d\xe9monstration et mettre en place votre propre connecteur avec vos informations d'identification."
        }
    },
    socialCallback: {
        title: "Connexion r\xe9ussie",
        description: "Vous vous \xeates connect\xe9 avec succ\xe8s en utilisant votre compte social. Pour assurer une int\xe9gration fluide et acc\xe9der \xe0 toutes les fonctionnalit\xe9s de Logto, nous vous recommandons de configurer votre propre connecteur social."
    },
    tenant: {
        create_tenant: "Cr\xe9er un locataire"
    }
};
var $cfca5ec3ac841d06$export$2e2bcd8739ae039 = Object.freeze($cfca5ec3ac841d06$var$cloud);


const $5241f87b4d574239$var$components = {
    uploader: {
        action_description: "Glissez-d\xe9posez ou parcourez",
        uploading: "T\xe9l\xe9chargement...",
        image_limit: "T\xe9l\xe9chargez une image de moins de {{size, number}} Ko, uniquement {{extensions, list(style: narrow; type: conjunction;)}}.",
        error_upload: "Quelque chose s'est mal pass\xe9. La t\xe9l\xe9chargement de fichier a \xe9chou\xe9.",
        error_file_size: "La taille du fichier est trop grande. Veuillez t\xe9l\xe9charger un fichier de moins de {{size, number}}Ko.",
        error_file_type: "Le type de fichier n'est pas pris en charge. Uniquement {{extensions, list(style: narrow; type: conjunction;)}}.",
        error_file_count: "Vous ne pouvez t\xe9l\xe9charger qu’un seul fichier."
    }
};
var $5241f87b4d574239$export$2e2bcd8739ae039 = Object.freeze($5241f87b4d574239$var$components);


const $327f435c6480b4a5$var$connector_details = {
    page_title: "D\xe9tails du connecteur",
    back_to_connectors: "Retour \xe0 Connecteurs",
    check_readme: "V\xe9rifier le README",
    settings: "Param\xe8tres g\xe9n\xe9raux",
    settings_description: "Les connecteurs jouent un r\xf4le essentiel dans Logto. Avec leur aide, Logto permet aux utilisateurs finaux d'utiliser une inscription ou une connexion sans mot de passe et les capacit\xe9s de connexion avec des comptes sociaux.",
    parameter_configuration: "Configuration des param\xe8tres",
    test_connection: "Test",
    save_error_empty_config: "Veuillez entrer la configuration",
    send: "Envoyer",
    send_error_invalid_format: "Entr\xe9e non valide",
    edit_config_label: "Entrez votre json ici",
    test_email_sender: "Testez votre connecteur Email",
    test_sms_sender: "Testez votre connecteur SMS",
    test_email_placeholder: "john.doe@example.com",
    test_sms_placeholder: "+33 6 12 34 56 78",
    test_message_sent: "Message de test envoy\xe9",
    test_sender_description: 'Logto utilise le mod\xe8le "Generic" pour les tests. Tu recevras un message si ton connecteur est correctement configur\xe9.',
    options_change_email: "Modifier le connecteur Email",
    options_change_sms: "Changer le connecteur SMS",
    connector_deleted: "Le connecteur a \xe9t\xe9 supprim\xe9 avec succ\xe8s",
    type_email: "Connecteur Email",
    type_sms: "Connecteur SMS",
    type_social: "Connecteur Social",
    in_used_social_deletion_description: "Ce connecteur est utilis\xe9 dans votre exp\xe9rience de connexion. En le supprimant, l’exp\xe9rience de connexion de <name/> sera supprim\xe9e dans les param\xe8tres de l’exp\xe9rience de connexion. Vous devrez le reconfigurer si vous d\xe9cidez de l’ajouter \xe0 nouveau.",
    in_used_passwordless_deletion_description: "Cet {{name}} est utilis\xe9 dans votre exp\xe9rience de connexion. En le supprimant, votre exp\xe9rience de connexion ne fonctionnera pas correctement tant que vous n’aurez pas r\xe9solu le conflit. Vous devrez le reconfigurer si vous d\xe9cidez de l’ajouter \xe0 nouveau.",
    deletion_description: "Vous supprimez ce connecteur. Il ne peut pas \xeatre annul\xe9 et vous devrez le reconfigurer si vous d\xe9cidez de l'ajouter \xe0 nouveau.",
    logto_email: {
        total_email_sent: "Total email envoy\xe9: {{value, number}}",
        total_email_sent_tip: "Logto utilise SendGrid pour une livraison s\xe9curis\xe9e et stable des emails int\xe9gr\xe9s. C'est totalement gratuit. <a>En savoir plus</a>",
        email_template_title: "Mod\xe8le d’email",
        template_description: "L’email int\xe9gr\xe9 utilise des mod\xe8les par d\xe9faut pour une livraison transparente des emails de v\xe9rification. Aucune configuration n’est requise et vous pouvez personnaliser les informations de base de la marque.",
        template_description_link_text: "Voir les mod\xe8les",
        description_action_text: "Voir les mod\xe8les",
        from_email_field: "Email de l’exp\xe9diteur",
        sender_name_field: "Nom de l'exp\xe9diteur",
        sender_name_tip: 'Personnalisez le nom de l’exp\xe9diteur pour les emails. Si vous le laissez vide, "Verification" sera utilis\xe9 comme nom par d\xe9faut.',
        sender_name_placeholder: "Votre nom d’exp\xe9diteur",
        company_information_field: "Informations sur la soci\xe9t\xe9",
        company_information_description: "Affichez le nom de votre entreprise, votre adresse ou votre code postal en bas des emails pour renforcer l'authenticit\xe9.",
        company_information_placeholder: "Les informations de base de votre entreprise",
        app_logo_field: "Logo de l’application",
        app_logo_tip: "Affichez le logo de votre marque en haut des emails. Utilisez la m\xeame image pour le mode clair et le mode sombre.",
        urls_not_allowed: "Les URLs ne sont pas autoris\xe9es",
        test_notes: 'Logto utilise le mod\xe8le "Generic" pour les tests.'
    }
};
var $327f435c6480b4a5$export$2e2bcd8739ae039 = Object.freeze($327f435c6480b4a5$var$connector_details);


const $4a20b40f8fc06de4$var$connectors = {
    page_title: "Connecteurs",
    title: "Connecteurs",
    subtitle: "Configurez des connecteurs pour permettre une exp\xe9rience de connexion sans mot de passe et sociale.",
    create: "Ajouter un connecteur social",
    config_sie_notice: "Vous avez configur\xe9 des connecteurs. Assurez-vous de le configurer dans <a>{{link}}</a>.",
    config_sie_link_text: "exp\xe9rience de connexion",
    tab_email_sms: "Connecteurs Email et SMS",
    tab_social: "Connecteurs sociaux",
    connector_name: "Nom du connecteur",
    demo_tip: "Le nombre maximum de messages autoris\xe9s pour ce connecteur de d\xe9monstration est limit\xe9 \xe0 100 et n'est pas recommand\xe9 pour le d\xe9ploiement dans un environnement de production.",
    social_demo_tip: "Le connecteur de d\xe9monstration est con\xe7u exclusivement \xe0 des fins de d\xe9monstration et n'est pas recommand\xe9 pour le d\xe9ploiement dans un environnement de production.",
    connector_type: "Type",
    connector_status: "Exp\xe9rience de connexion",
    connector_status_in_use: "En cours d'utilisation",
    connector_status_not_in_use: "Non utilis\xe9",
    not_in_use_tip: {
        content: "L'option Non utilis\xe9 signifie que votre exp\xe9rience de connexion n'a pas utilis\xe9 cette m\xe9thode de connexion. <a>{{link}}</a> pour ajouter cette m\xe9thode de connexion.",
        go_to_sie: "Aller \xe0 l'exp\xe9rience de connexion"
    },
    placeholder_title: "Connecteur social",
    placeholder_description: "Logto propose de nombreux connecteurs de connexion sociale couramment utilis\xe9s, mais vous pouvez \xe9galement cr\xe9er le v\xf4tre \xe0 l'aide des protocoles standard.",
    save_and_done: "Sauvegarder et Finis",
    type: {
        email: "Connecteur Email",
        sms: "Connecteur SMS",
        social: "Connecteur Social"
    },
    setup_title: {
        email: "Configurer le connecteur Email",
        sms: "Configurer le connecteur SMS",
        social: "Ajouter un connecteur Social"
    },
    guide: {
        subtitle: "Un guide \xe9tape par \xe9tape pour configurer votre connecteur",
        general_setting: "Param\xe8tres g\xe9n\xe9raux",
        parameter_configuration: "Configuration des param\xe8tres",
        test_connection: "Test de connexion",
        name: "Nom du bouton de connexion sociale",
        name_placeholder: "Entrez un nom pour le bouton de connexion sociale",
        name_tip: 'Le nom du bouton de connexion s\'affichera comme "Continuer avec {{name}}". Tenez compte de la longueur du nom si celui-ci devient trop long.',
        logo: "URL du logo pour le bouton de connexion sociale",
        logo_placeholder: "https://votre.domaine.cdn/logo.png",
        logo_tip: "L'image du logo s'affichera sur le connecteur. Obtenez un lien d'image accessible au public et ins\xe9rez le lien ici.",
        logo_dark: "URL du logo pour le bouton de connexion sociale (mode sombre)",
        logo_dark_placeholder: "https://votre.domaine.cdn/logo.png",
        logo_dark_tip: "D\xe9finissez le logo de votre connecteur pour le mode sombre apr\xe8s l'avoir activ\xe9 dans l'exp\xe9rience de connexion de la console d'administration.",
        logo_dark_collapse: "R\xe9duire",
        logo_dark_show: "Afficher l'option du logo pour le mode sombre",
        target: "Nom du fournisseur d'identit\xe9",
        target_placeholder: "Entrez le nom du fournisseur d'identit\xe9 du connecteur",
        target_tip: "La valeur de \"nom de l'IdP\" peut \xeatre une cha\xeene d'identificateur unique pour distinguer vos identifiants sociaux.",
        target_tip_standard: "La valeur de \"nom de l'IdP\" peut \xeatre une cha\xeene d'identificateur unique pour distinguer vos identifiants sociaux. Ce param\xe8tre ne peut pas \xeatre modifi\xe9 une fois que le connecteur est cr\xe9\xe9.",
        target_tooltip: "\xabCible\xbb dans les connecteurs sociaux de Logto fait r\xe9f\xe9rence \xe0 la \xabsource\xbb de vos identit\xe9s sociales. Dans la conception de Logto, nous n'acceptons pas la m\xeame \xabcible\xbb d'une plateforme sp\xe9cifique pour \xe9viter les conflits. Vous devriez \xeatre tr\xe8s attentif avant d'ajouter un connecteur car vous NE POUVEZ PAS changer sa valeur une fois que vous l'avez cr\xe9\xe9. <a>En savoir plus</a>",
        target_conflict: "Le nom de l'IdP saisi correspond au nom existant <span>nom</span>. Utiliser le m\xeame nom d'IdP peut entra\xeener un comportement de connexion inattendu o\xf9 les utilisateurs peuvent acc\xe9der au m\xeame compte via deux connecteurs diff\xe9rents.",
        target_conflict_line2: "Si vous souhaitez remplacer le connecteur actuel par le m\xeame fournisseur d'identit\xe9 et permettre aux utilisateurs pr\xe9c\xe9dents de se connecter sans s'inscrire \xe0 nouveau, veuillez supprimer le connecteur <span>nom</span> et cr\xe9er un nouveau connecteur avec le m\xeame nom \"IdP\".",
        target_conflict_line3: "Si vous souhaitez vous connecter \xe0 un fournisseur d'identit\xe9 diff\xe9rent, modifiez le \"nom de l'IdP\" et poursuivez.",
        config: "Entrez votre JSON de configuration",
        sync_profile: "Synchroniser les informations de profil",
        sync_profile_only_at_sign_up: "Synchroniser uniquement \xe0 l'inscription",
        sync_profile_each_sign_in: "Toujours effectuer une synchronisation \xe0 chaque connexion",
        sync_profile_tip: "Synchronisez le profil de base du fournisseur social, tel que les noms des utilisateurs et leurs avatars.",
        callback_uri: "URI de rappel",
        callback_uri_description: "\xc9galement appel\xe9e URI de redirection, c'est l'URI dans Logto o\xf9 les utilisateurs seront renvoy\xe9s apr\xe8s l'autorisation sociale, copiez et collez sur la page de configuration du fournisseur social.",
        acs_url: "URL de service de consommation d'assertions"
    },
    platform: {
        universal: "Universel",
        web: "Web",
        native: "Natifs"
    },
    add_multi_platform: " prend en charge plusieurs plateformes, s\xe9lectionnez une plateforme pour continuer",
    drawer_title: "Guide des connecteurs",
    drawer_subtitle: "Suivez les instructions pour int\xe9grer votre connecteur",
    unknown: "Connecteur inconnu",
    standard_connectors: "Connecteurs standard"
};
var $4a20b40f8fc06de4$export$2e2bcd8739ae039 = Object.freeze($4a20b40f8fc06de4$var$connectors);


const $7f0065154772636f$var$contact = {
    title: "Obtenir de l'aide",
    description: "Pour les demandes d'aide ou les commentaires sur le produit, veuillez nous contacter par l'un des moyens suivants.",
    discord: {
        title: "Rejoignez la communaut\xe9 Discord",
        description: "Connectez-vous avec d'autres d\xe9veloppeurs pour trouver des solutions",
        button: "Rejoindre"
    },
    github: {
        title: "Communiquez sur GitHub",
        description: "Cr\xe9ez un probl\xe8me et soumettez-le sur GitHub",
        button: "Ouvrir"
    },
    email: {
        title: "Contacter le support par e-mail",
        description: "Envoyez-nous un e-mail pour obtenir des informations compl\xe9mentaires et de l'aide",
        button: "Envoyer"
    },
    reserve: {
        title: "R\xe9servez votre temps avec l'\xe9quipe Logto",
        description: "R\xe9servez rapidement une session pour un chat en direct",
        button: "R\xe9server"
    }
};
var $7f0065154772636f$export$2e2bcd8739ae039 = Object.freeze($7f0065154772636f$var$contact);


const $c5bca5b7d0e7aa96$var$dashboard = {
    page_title: "Tableau de bord",
    title: "Tableau de bord",
    description: "Obtenez une vue d'ensemble des performances de votre application",
    total_users: "Utilisateurs totaux",
    total_users_tip: "Utilisateurs totaux",
    new_users_today: "Nouveaux utilisateurs aujourd'hui",
    new_users_today_tip: "Le nombre de nouveaux utilisateurs enregistr\xe9s sur vos applications aujourd'hui",
    new_users_7_days: "Nouveaux utilisateurs des 7 derniers jours",
    new_users_7_days_tip: "Le nombre de nouveaux utilisateurs enregistr\xe9s sur vos applications au cours des 7 derniers jours.",
    daily_active_users: "Utilisateurs actifs quotidiens",
    daily_active_users_tip: "Le nombre d'utilisateurs uniques qui ont \xe9chang\xe9 des jetons sur vos applications aujourd'hui.",
    weekly_active_users: "Utilisateurs actifs hebdomadaires",
    weekly_active_users_tip: "Le nombre d'utilisateurs uniques ayant \xe9chang\xe9 des jetons sur vos applications au cours des 7 derniers jours.",
    monthly_active_users: "Utilisateurs actifs mensuels",
    monthly_active_users_tip: "Le nombre d'utilisateurs uniques ayant \xe9chang\xe9 des jetons sur vos applications au cours des 30 derniers jours."
};
var $c5bca5b7d0e7aa96$export$2e2bcd8739ae039 = Object.freeze($c5bca5b7d0e7aa96$var$dashboard);


const $18f14001b4bf30ed$var$domain = {
    status: {
        connecting: "Connexion...",
        in_use: "Utilis\xe9",
        failed_to_connect: "\xc9chec de la connexion"
    },
    update_endpoint_notice: "N’oubliez pas de mettre \xe0 jour le domaine pour l’URI de rappel du connecteur social et le point de terminaison Logto dans votre application si vous souhaitez utiliser un domaine personnalis\xe9 pour les fonctionnalit\xe9s. <a>{{link}}</a>",
    error_hint: "Assurez-vous de mettre \xe0 jour vos enregistrements DNS. Nous continuerons \xe0 v\xe9rifier toutes les {{value}} secondes.",
    custom: {
        custom_domain: "Domaine personnalis\xe9",
        custom_domain_description: "Am\xe9liorez votre image de marque en utilisant un domaine personnalis\xe9. Ce domaine sera utilis\xe9 dans votre exp\xe9rience de connexion.",
        custom_domain_field: "Domaine personnalis\xe9",
        custom_domain_placeholder: "votre.domaine.com",
        add_domain: "Ajouter un domaine",
        invalid_domain_format: 'Veuillez fournir une URL de domaine valide avec un minimum de trois parties, par exemple "votre.domaine.com."',
        verify_domain: "V\xe9rifier le domaine",
        enable_ssl: "Activer SSL",
        checking_dns_tip: "Apr\xe8s avoir configur\xe9 les enregistrements DNS, le processus s’ex\xe9cutera automatiquement et peut prendre jusqu’\xe0 24 heures. Vous pouvez quitter cette interface pendant son ex\xe9cution.",
        enable_ssl_tip: "Activer SSL s’ex\xe9cutera automatiquement et peut prendre jusqu’\xe0 24 heures. Vous pouvez quitter cette interface pendant son ex\xe9cution.",
        generating_dns_records: "G\xe9n\xe9ration des enregistrements DNS...",
        add_dns_records: "Veuillez ajouter ces enregistrements DNS \xe0 votre fournisseur DNS.",
        dns_table: {
            type_field: "Type",
            name_field: "Nom",
            value_field: "Valeur"
        },
        deletion: {
            delete_domain: "Supprimer le domaine",
            reminder: "Supprimer le domaine personnalis\xe9",
            description: "\xcates-vous s\xfbr de vouloir supprimer ce domaine personnalis\xe9 ?",
            in_used_description: '\xcates-vous s\xfbr de vouloir supprimer ce domaine personnalis\xe9 "<span>{{domain}}</span>" ?',
            in_used_tip: 'Si vous avez configur\xe9 ce domaine personnalis\xe9 dans votre fournisseur de connecteur social ou le point de terminaison de l’application avant, vous devrez d’abord modifier l’URI vers le domaine Logto par d\xe9faut "<span>{{domain}}</span>". Ceci est n\xe9cessaire pour que le bouton de connexion sociale fonctionne correctement.',
            deleted: "Suppression du domaine personnalis\xe9 r\xe9ussie !"
        }
    },
    default: {
        default_domain: "Domaine par d\xe9faut",
        default_domain_description: "Logto offre un domaine par d\xe9faut pr\xe9configur\xe9, pr\xeat \xe0 \xeatre utilis\xe9 sans aucune configuration suppl\xe9mentaire. Ce domaine par d\xe9faut sert de solution de secours m\xeame si vous avez activ\xe9 un domaine personnalis\xe9.",
        default_domain_field: "Domaine par d\xe9faut de Logto"
    },
    custom_endpoint_note: 'Vous pouvez personnaliser le nom de domaine de ces points de terminaison selon vos besoins. Choisissez soit "{{custom}}" ou "{{default}}".',
    custom_social_callback_url_note: 'Vous pouvez personnaliser le nom de domaine de cette URI pour correspondre au point de terminaison de votre application. Choisissez soit "{{custom}}" ou "{{default}}".',
    custom_acs_url_note: 'Vous pouvez personnaliser le nom de domaine de cette URI pour correspondre \xe0 l\'URL du service de consommation d\'assertion de votre fournisseur d\'identit\xe9. Choisissez soit "{{custom}}" ou "{{default}}".'
};
var $18f14001b4bf30ed$export$2e2bcd8739ae039 = Object.freeze($18f14001b4bf30ed$var$domain);


const $e68446fbbd6dc544$var$enterprise_sso_details = {
    back_to_sso_connectors: "Retourner aux connecteurs SSO d'entreprise",
    page_title: "D\xe9tails du connecteur SSO d'entreprise",
    readme_drawer_title: "SSO d'entreprise",
    readme_drawer_subtitle: "Configurez des connecteurs SSO d'entreprise pour permettre la connexion unique des utilisateurs finaux",
    tab_experience: "Exp\xe9rience SSO",
    tab_connection: "Connexion",
    general_settings_title: "G\xe9n\xe9ral",
    custom_branding_title: "Affichage",
    custom_branding_description: "Personnalisez le nom et le logo affich\xe9s dans le flux de connexion unique des utilisateurs finaux. Lorsqu'ils sont vides, les valeurs par d\xe9faut sont utilis\xe9es.",
    email_domain_field_name: "Domaine de courrier \xe9lectronique d'entreprise",
    email_domain_field_description: "Les utilisateurs de ce domaine de courrier \xe9lectronique peuvent utiliser SSO pour l'authentification. Veuillez v\xe9rifier que le domaine appartient \xe0 l'entreprise.",
    email_domain_field_placeholder: "Domaine de courrier \xe9lectronique",
    sync_profile_field_name: "Synchroniser les informations du profil \xe0 partir du fournisseur d'identit\xe9",
    sync_profile_option: {
        register_only: "Ne synchroniser qu'\xe0 la premi\xe8re connexion",
        each_sign_in: "Synchroniser toujours \xe0 chaque connexion"
    },
    connector_name_field_name: "Nom du connecteur",
    display_name_field_name: "Nom d'affichage",
    connector_logo_field_name: "Logo d'affichage",
    connector_logo_field_description: "Chaque image doit faire moins de 500 Ko, format SVG, PNG, JPG, JPEG uniquement.",
    branding_logo_context: "T\xe9l\xe9charger le logo",
    branding_logo_error: "Erreur de t\xe9l\xe9versement de logo : {{error}}",
    branding_light_logo_context: "T\xe9l\xe9charger le logo pour le mode clair",
    branding_light_logo_error: "Erreur de t\xe9l\xe9versement de logo pour le mode clair : {{error}}",
    branding_logo_field_name: "Logo",
    branding_logo_field_placeholder: "https://votre.domaine/logo.png",
    branding_dark_logo_context: "T\xe9l\xe9charger le logo pour le mode sombre",
    branding_dark_logo_error: "Erreur de t\xe9l\xe9versement de logo pour le mode sombre : {{error}}",
    branding_dark_logo_field_name: "Logo (mode sombre)",
    branding_dark_logo_field_placeholder: "https://votre.domaine/logo-mode-sombre.png",
    check_connection_guide: "Guide de connexion",
    enterprise_sso_deleted: "Le connecteur SSO d'entreprise a \xe9t\xe9 supprim\xe9 avec succ\xe8s",
    delete_confirm_modal_title: "Supprimer le connecteur SSO d'entreprise",
    delete_confirm_modal_content: "\xcates-vous s\xfbr de vouloir supprimer ce connecteur d'entreprise ? Les utilisateurs des fournisseurs d'identit\xe9 n'utiliseront pas la connexion unique.",
    upload_idp_metadata_title_saml: "T\xe9l\xe9verser les m\xe9tadonn\xe9es",
    upload_idp_metadata_description_saml: "Configurez les m\xe9tadonn\xe9es copi\xe9es du fournisseur d'identit\xe9.",
    upload_idp_metadata_title_oidc: "T\xe9l\xe9verser les informations d'identification",
    upload_idp_metadata_description_oidc: "Configurez les informations d'identification et le jeton OIDC copi\xe9 du fournisseur d'identit\xe9.",
    upload_idp_metadata_button_text: "T\xe9l\xe9verser le fichier XML de m\xe9tadonn\xe9es",
    upload_signing_certificate_button_text: "T\xe9l\xe9verser le fichier de certificat de signature",
    configure_domain_field_info_text: "Ajoutez un domaine de courrier \xe9lectronique pour guider les utilisateurs d'entreprise vers leur fournisseur d'identit\xe9 pour la connexion unique.",
    email_domain_field_required: "Le domaine de messagerie \xe9lectronique est requis pour activer le SSO d'entreprise.",
    upload_saml_idp_metadata_info_text_url: "Collez l'URL des m\xe9tadonn\xe9es du fournisseur d'identit\xe9 pour vous connecter.",
    upload_saml_idp_metadata_info_text_xml: "Collez les m\xe9tadonn\xe9es du fournisseur d'identit\xe9 pour vous connecter.",
    upload_saml_idp_metadata_info_text_manual: "Remplissez les m\xe9tadonn\xe9es du fournisseur d'identit\xe9 pour vous connecter.",
    upload_oidc_idp_info_text: "Remplissez les informations du fournisseur d'identit\xe9 pour vous connecter.",
    service_provider_property_title: "Configurer dans l'IdP",
    service_provider_property_description: "Configurez une int\xe9gration d'application utilisant {{protocol}} dans votre fournisseur d'identit\xe9. Entrez les d\xe9tails fournis par Logto.",
    attribute_mapping_title: "Correspondances d'attributs",
    attribute_mapping_description: "Synchronisez les profils des utilisateurs \xe0 partir du fournisseur d'identit\xe9 en configurant la correspondance des attributs d'utilisateur soit sur le fournisseur d'identit\xe9 soit du c\xf4t\xe9 de Logto.",
    saml_preview: {
        sign_on_url: "URL de connexion",
        entity_id: "\xc9metteur",
        x509_certificate: "Certificat de signature",
        certificate_content: "Expiration {{date}}"
    },
    oidc_preview: {
        authorization_endpoint: "Point de terminaison d'autorisation",
        token_endpoint: "Point de terminaison du jeton",
        userinfo_endpoint: "Point de terminaison des informations utilisateur",
        jwks_uri: "Point de terminaison de l'ensemble de cl\xe9s JSON web",
        issuer: "\xc9metteur"
    }
};
var $e68446fbbd6dc544$export$2e2bcd8739ae039 = Object.freeze($e68446fbbd6dc544$var$enterprise_sso_details);


const $8a876e7a2a25205a$var$enterprise_sso = {
    page_title: "SSO d'entreprise",
    title: "SSO d'entreprise",
    subtitle: "Connectez le fournisseur d'identit\xe9 de l'entreprise et activez la connexion unique initi\xe9e par le fournisseur de services.",
    create: "Ajouter un connecteur d'entreprise",
    col_connector_name: "Nom du connecteur",
    col_type: "Type",
    col_email_domain: "Domaine de messagerie",
    placeholder_title: "Connecteur d'entreprise",
    placeholder_description: "Logto a fourni de nombreux fournisseurs d'identit\xe9s d'entreprise int\xe9gr\xe9s pour une connexion, pendant ce temps, vous pouvez cr\xe9er le v\xf4tre avec les protocoles SAML et OIDC.",
    create_modal: {
        title: "Ajouter un connecteur d'entreprise",
        text_divider: "Ou vous pouvez personnaliser votre connecteur avec un protocole standard.",
        connector_name_field_title: "Nom du connecteur",
        connector_name_field_placeholder: "Par exemple, {corp. name} - {nom du fournisseur d'identit\xe9}",
        create_button_text: "Cr\xe9er un connecteur"
    },
    guide: {
        subtitle: "Un guide pas \xe0 pas pour connecter le fournisseur d'identit\xe9 de l'entreprise.",
        finish_button_text: "Continuer"
    },
    basic_info: {
        title: "Configurez votre service dans l'IdP",
        description: "Cr\xe9ez une nouvelle int\xe9gration d'application par SAML 2.0 dans votre fournisseur d'identit\xe9 {{name}}. Ensuite, collez la valeur suivante.",
        saml: {
            acs_url_field_name: "URL de service de consommation d'assertions (URL de r\xe9ponse)",
            audience_uri_field_name: "URI de l'audience (ID de l'entit\xe9 SP)"
        },
        oidc: {
            redirect_uri_field_name: "URI de redirection (URL de rappel)"
        }
    },
    attribute_mapping: {
        title: "Mappage des attributs",
        description: "`id` et `email` sont n\xe9cessaires pour synchroniser le profil de l'utilisateur \xe0 partir de l'IdP. Entrez le nom et la valeur du champ suivant dans votre IdP.",
        col_sp_claims: "Valeur du fournisseur de services (Logto)",
        col_idp_claims: "Nom de r\xe9clamation du fournisseur d'identit\xe9",
        idp_claim_tooltip: "Le nom de r\xe9clamation du fournisseur d'identit\xe9"
    },
    metadata: {
        title: "Configurer les m\xe9tadonn\xe9es de l'IdP",
        description: "Configurez les m\xe9tadonn\xe9es du fournisseur d'identit\xe9",
        dropdown_trigger_text: "Utiliser un autre m\xe9thode de configuration",
        dropdown_title: "s\xe9lectionnez votre m\xe9thode de configuration",
        metadata_format_url: "Entrez l'URL des m\xe9tadonn\xe9es",
        metadata_format_xml: "T\xe9l\xe9verser le fichier XML des m\xe9tadonn\xe9es",
        metadata_format_manual: "Saisir manuellement les d\xe9tails des m\xe9tadonn\xe9es",
        saml: {
            metadata_url_field_name: "URL des m\xe9tadonn\xe9es",
            metadata_url_description: "R\xe9cup\xe9rez dynamiquement les donn\xe9es \xe0 partir de l'URL des m\xe9tadonn\xe9es et gardez le certificat \xe0 jour.",
            metadata_xml_field_name: "Fichier XML des m\xe9tadonn\xe9es IdP",
            metadata_xml_uploader_text: "T\xe9l\xe9verser le fichier XML des m\xe9tadonn\xe9es",
            sign_in_endpoint_field_name: "URL de connexion",
            idp_entity_id_field_name: "ID de l'entit\xe9 IdP (\xc9metteur)",
            certificate_field_name: "Certificat de signature",
            certificate_placeholder: "Copiez et collez le certificat x509",
            certificate_required: "Le certificat de signature est requis."
        },
        oidc: {
            client_id_field_name: "ID client",
            client_secret_field_name: "Secret client",
            issuer_field_name: "\xc9metteur",
            scope_field_name: "Port\xe9e"
        }
    }
};
var $8a876e7a2a25205a$export$2e2bcd8739ae039 = Object.freeze($8a876e7a2a25205a$var$enterprise_sso);


const $34e4728be94705a1$var$errors = {
    something_went_wrong: "Oups ! Quelque chose a mal tourn\xe9.",
    page_not_found: "Page non trouv\xe9e",
    unknown_server_error: "Une erreur de serveur inconnu s'est produite",
    empty: "Pas de donn\xe9es",
    missing_total_number: "Impossible de trouver le nombre total dans les en-t\xeates de r\xe9ponse",
    invalid_uri_format: "Format d'URI non valide",
    invalid_origin_format: "Format d'origine URI non valide",
    invalid_json_format: "Format JSON non valide",
    invalid_regex: "Expression r\xe9guli\xe8re non valide",
    invalid_error_message_format: "Le format du message d'erreur n'est pas valide.",
    required_field_missing: "Veuillez saisir {{field}}",
    required_field_missing_plural: "Vous devez entrer au moins un {{field}}.",
    more_details: "Plus de d\xe9tails",
    username_pattern_error: "Le nom d'utilisateur ne doit contenir que des lettres, des chiffres ou des traits de soulignement et ne doit pas commencer par un chiffre.",
    email_pattern_error: "L'adresse e-mail n'est pas valide.",
    phone_pattern_error: "Le num\xe9ro de t\xe9l\xe9phone n’est pas valide.",
    insecure_contexts: "Les contextes non s\xe9curis\xe9s (non HTTPS) ne sont pas pris en charge.",
    unexpected_error: "Une erreur inattendue s'est produite",
    not_found: "404 non trouv\xe9",
    create_internal_role_violation: 'Vous cr\xe9ez un nouveau r\xf4le interne qui est interdit par Logto. Essayez un autre nom qui ne commence pas par "#internal:".',
    should_be_an_integer: "Doit \xeatre un entier.",
    number_should_be_between_inclusive: "Le nombre doit \xeatre compris entre {{min}} et {{max}} (inclusivement)."
};
var $34e4728be94705a1$export$2e2bcd8739ae039 = Object.freeze($34e4728be94705a1$var$errors);


const $e97df46329b75237$var$general = {
    placeholder: "Emplacement",
    submit: "Soumettre",
    skip: "Passer",
    next: "Suivant",
    back: "Retourner",
    retry: "Essayez \xe0 nouveau",
    done: "Termin\xe9",
    search: "Recherche",
    search_placeholder: "Recherche...",
    clear_result: "Effacer les r\xe9sultats",
    save: "Sauvegarder",
    save_changes: "Sauvegarder les modifications",
    saved: "Sauvegard\xe9",
    discard: "Abandonner",
    loading: "Chargement...",
    redirecting: "Redirection...",
    add: "Ajouter",
    added: "Ajout\xe9",
    cancel: "Annuler",
    confirm: "Confirmer",
    check_out: "V\xe9rifier",
    create: "Cr\xe9er",
    set_up: "Configurer",
    customize: "Personnaliser",
    enable: "Activer",
    reminder: "Rappel",
    edit: "\xc9diter",
    delete: "Supprimer",
    deleted: "Supprim\xe9",
    more_options: "PLUS D'OPTIONS",
    close: "Fermer",
    copy: "Copier",
    copying: "Copie",
    copied: "Copi\xe9",
    required: "Requis",
    add_another: "Ajouter un autre",
    create_another: "Cr\xe9er un autre",
    deletion_confirmation: "\xcates-vous s\xfbr de vouloir supprimer ce {{title}} ?",
    settings_nav: "Param\xe8tres",
    unsaved_changes_warning: "Vous avez effectu\xe9 des changements. \xcates-vous s\xfbr de vouloir quitter cette page ?",
    leave_page: "Quittez la page",
    stay_on_page: "Rester sur la page",
    type_to_search: "Tapez pour rechercher",
    got_it: "Compris.",
    continue: "Continuez",
    page_info: "{{min, number}}-{{max, number}} de {{total, number}}",
    learn_more: "En savoir plus",
    tab_errors: "{{count, number}} erreurs",
    skip_for_now: "Passer pour l`instant",
    remove: "Supprimer",
    visit: "Visiter",
    join: "Rejoindre",
    try_now: "Essayez maintenant",
    multiple_form_field: "(Multiple)",
    demo: "D\xe9mo",
    unnamed: "Sans nom",
    view: "Vue",
    open: "Ouvrir",
    hide: "Cacher",
    unknown_error: "Erreur inconnue, veuillez r\xe9essayer ult\xe9rieurement.",
    select: "S\xe9lectionner",
    contact_us_action: "Nous contacter",
    description: "Description",
    name: "Nom",
    add_field: "Ajouter {{field}}",
    create_field: "Cr\xe9er {{field}}",
    edit_field: "Modifier {{field}}",
    delete_field: "Supprimer {{field}}",
    coming_soon: "Bient\xf4t disponible",
    or: "Ou"
};
var $e97df46329b75237$export$2e2bcd8739ae039 = Object.freeze($e97df46329b75237$var$general);


const $8f379fd654273f4f$var$get_started = {
    page_title: "Commencer",
    title: "Quelque chose \xe0 explorer pour vous aider \xe0 r\xe9ussir",
    subtitle: "Quelques choses que vous pouvez faire pour obtenir rapidement de la valeur de Logto",
    develop: {
        title: "D\xe9velopper: Prenez 5 minutes pour int\xe9grer votre application",
        title_cloud: "D\xe9velopper: Int\xe9grez votre application de mani\xe8re s\xe9curis\xe9e en quelques minutes",
        subtitle_cloud: "Ou prenez 5 minutes pour int\xe9grer votre application avec nos SDK pr\xe9construits et tutoriels."
    },
    customize: {
        title: "Personnaliser: Offrez une excellente exp\xe9rience de connexion",
        preview: {
            title: "V\xe9rifiez l'aper\xe7u en direct de l'exp\xe9rience de connexion que vous venez de personnaliser",
            subtitle: "Essayez d\xe8s maintenant l'exp\xe9rience de connexion de Logto pour voir comment cela fonctionne"
        },
        connector: {
            title: "Ajoutez plus de connecteurs pour prendre en charge plus de m\xe9thodes de connexion social",
            subtitle: "Essayez la connexion sans mot de passe et activez une exp\xe9rience s\xe9curis\xe9e et sans friction pour vos clients"
        },
        continue_customizing: "Continuer la personnalisation",
        try_now: "Essayez maintenant",
        add_more: "Ajouter plus"
    },
    secure: {
        title: "S\xe9curit\xe9: Prot\xe9gez vos ressources"
    },
    manage: {
        title: "G\xe9rer: D\xe9finir le contr\xf4le d'acc\xe8s pour votre produit et vos utilisateurs",
        rbac: {
            title: "Ajoutez un contr\xf4le d'acc\xe8s bas\xe9 sur les r\xf4les pour prot\xe9ger vos ressources",
            subtitle: "Contr\xf4lez vos ressources gr\xe2ce \xe0 une autorisation de r\xf4le \xe9volutive pour des cas d'utilisation divers"
        },
        create_roles: "Cr\xe9er des r\xf4les"
    },
    view_all: "Tout afficher →"
};
var $8f379fd654273f4f$export$2e2bcd8739ae039 = Object.freeze($8f379fd654273f4f$var$get_started);


const $f138a14e78f0afb1$var$guide = {
    start_building: "Commencer \xe0 construire",
    get_started: "D\xe9marrer",
    categories: {
        featured: "Populaire et pour vous",
        Traditional: "Application web traditionnelle",
        SPA: "Application sur une seule page",
        Native: "Natif",
        MachineToMachine: "Machine-\xe0-machine",
        Protected: "Int\xe9gration non-SDK",
        ThirdParty: "Application tierce"
    },
    filter: {
        title: "Filtrer le framework",
        placeholder: "Rechercher un framework"
    },
    checkout_tutorial: "Voir le tutoriel {{name}}",
    do_not_need_tutorial: "Si vous n'avez pas besoin d'un tutoriel, vous pouvez continuer sans guide de framework",
    finish_and_done: "Terminer et termin\xe9",
    cannot_find_guide: "Impossible de trouver votre guide ?",
    describe_guide_looking_for: "D\xe9crivez le guide que vous recherchez",
    request_guide_successfully: "Votre demande a \xe9t\xe9 soumise avec succ\xe8s. Merci !",
    app: {
        select_framework_or_tutorial: "S\xe9lectionnez un framework ou un tutoriel",
        guide_modal_title: "Commencez avec le SDK et les guides",
        modal_subtitle: "D\xe9marrez le processus de d\xe9veloppement de votre application avec notre SDK et nos tutoriels pr\xe9-construits.",
        select_a_framework: "S\xe9lectionnez un framework",
        continue_without_framework: "Cr\xe9ez une application sans framework",
        describe_guide_looking_for_placeholder: "Par exemple, je veux int\xe9grer Logto dans mon application Angular."
    },
    api: {
        modal_title: "Commencez avec les tutoriels",
        modal_subtitle: "D\xe9marrez le processus de d\xe9veloppement de votre application avec nos tutoriels pr\xe9-construits.",
        select_a_tutorial: "S\xe9lectionnez un tutoriel",
        continue_without_tutorial: "Continuer sans tutoriel",
        describe_guide_looking_for_placeholder: "Par exemple, je veux prot\xe9ger mon API en utilisant deno."
    }
};
var $f138a14e78f0afb1$export$2e2bcd8739ae039 = Object.freeze($f138a14e78f0afb1$var$guide);


const $0ae81fe1103c4e4b$var$invitation = {
    find_your_tenants: "Trouvez vos locataires",
    find_tenants_description: "Votre adresse e-mail peut d\xe9j\xe0 \xeatre enregistr\xe9e avec plusieurs locataires. Vous pouvez choisir de rejoindre les existants ou continuer \xe0 cr\xe9er un nouveau.",
    create_new_tenant: "Cr\xe9er un nouveau locataire",
    email_not_match_title: "Vous \xeates actuellement connect\xe9 en tant que\n{{email}}",
    email_not_match_description: "Veuillez vous connecter avec le compte correct pour accepter l'invitation et devenir un membre de l'organisation.",
    switch_account: "Se connecter \xe0 un autre compte",
    invalid_invitation_status: "Invitation invalide. Veuillez contacter l'administrateur et r\xe9essayer.",
    invitation_not_found: "Invitation non trouv\xe9e. Veuillez contacter l'administrateur."
};
var $0ae81fe1103c4e4b$export$2e2bcd8739ae039 = Object.freeze($0ae81fe1103c4e4b$var$invitation);


const $61f69db229179517$var$jwt_claims = {
    title: "JWT personnalis\xe9",
    description: "Configurer des revendications JWT personnalis\xe9es \xe0 inclure dans le jeton d'acc\xe8s. Ces revendications peuvent \xeatre utilis\xe9es pour transmettre des informations suppl\xe9mentaires \xe0 votre application.",
    user_jwt: {
        card_title: "Pour l'utilisateur",
        card_field: "Jeton d'acc\xe8s utilisateur",
        card_description: "Ajouter des donn\xe9es sp\xe9cifiques \xe0 l'utilisateur lors de l'\xe9mission du jeton d'acc\xe8s.",
        for: "pour l'utilisateur"
    },
    machine_to_machine_jwt: {
        card_title: "Pour M2M",
        card_field: "Jeton machine-\xe0-machine",
        card_description: "Ajouter des donn\xe9es suppl\xe9mentaires lors de l'\xe9mission du jeton machine-\xe0-machine.",
        for: "pour M2M"
    },
    code_editor_title: "Personnalisez les revendications {{token}}",
    custom_jwt_create_button: "Ajouter des revendications personnalis\xe9es",
    custom_jwt_item: "Revendications personnalis\xe9es {{for}}",
    delete_modal_title: "Supprimer les revendications personnalis\xe9es",
    delete_modal_content: "\xcates-vous s\xfbr de vouloir supprimer les revendications personnalis\xe9es ?",
    clear: "Effacer",
    cleared: "Effac\xe9",
    restore: "Restaurer les param\xe8tres par d\xe9faut",
    restored: "Restaur\xe9",
    data_source_tab: "Source de donn\xe9es",
    test_tab: "Contexte de test",
    jwt_claims_description: "Les revendications par d\xe9faut sont automatiquement incluses dans le JWT et ne peuvent pas \xeatre remplac\xe9es.",
    user_data: {
        title: "Donn\xe9es utilisateur",
        subtitle: "Utilisez le param\xe8tre d'entr\xe9e `data.user` pour fournir des informations vitales sur l'utilisateur."
    },
    token_data: {
        title: "Donn\xe9es du jeton",
        subtitle: "Utilisez le param\xe8tre d'entr\xe9e `token` pour le payload du jeton d'acc\xe8s actuel. "
    },
    fetch_external_data: {
        title: "R\xe9cup\xe9rer des donn\xe9es externes",
        subtitle: "Incorporer des donn\xe9es provenant directement de vos API externes dans les revendications.",
        description: "Utilisez la fonction `fetch` pour appeler vos API externes et inclure les donn\xe9es dans vos revendications personnalis\xe9es. Exemple : "
    },
    environment_variables: {
        title: "D\xe9finir des variables d'environnement",
        subtitle: "Utilisez des variables d'environnement pour stocker des informations sensibles.",
        input_field_title: "Ajouter des variables d'environnement",
        sample_code: "Acc\xe8s aux variables d'environnement dans votre gestionnaire de revendications JWT personnalis\xe9es. Exemple : "
    },
    jwt_claims_hint: "Limitez les revendications personnalis\xe9es \xe0 moins de 50 Ko. Les revendications JWT par d\xe9faut sont automatiquement incluses dans le jeton et ne peuvent pas \xeatre remplac\xe9es.",
    tester: {
        subtitle: "Ajustez le jeton et les donn\xe9es utilisateur simul\xe9s pour les tests.",
        run_button: "Ex\xe9cuter le test",
        result_title: "R\xe9sultat du test"
    },
    form_error: {
        invalid_json: "Format JSON invalide"
    }
};
var $61f69db229179517$export$2e2bcd8739ae039 = Object.freeze($61f69db229179517$var$jwt_claims);


const $16c3feeb70eacf17$var$log_details = {
    page_title: "D\xe9tails du journal d'audit",
    back_to_logs: "Retour aux journaux d'audit",
    back_to: "Retour \xe0 {{name}}",
    success: "Succ\xe8s",
    failed: "\xc9chou\xe9",
    event_key: "Cl\xe9 d'\xe9v\xe9nement",
    application: "Application",
    ip_address: "Addresse IP",
    user: "Utilisateur",
    log_id: "ID du journal",
    time: "Temps",
    user_agent: "Agent de l'utilisateur",
    tab_details: "D\xe9tails",
    raw_data: "Donn\xe9es brutes"
};
var $16c3feeb70eacf17$export$2e2bcd8739ae039 = Object.freeze($16c3feeb70eacf17$var$log_details);


const $66c1bccdb61f9148$var$logs = {
    page_title: "Journaux d'audit",
    title: "Journaux d'audit",
    subtitle: "Visualisez les donn\xe9es du journal des \xe9v\xe9nements d'authentification effectu\xe9s par votre administrateur et vos utilisateurs.",
    event: "\xc9v\xe9nement",
    user: "Utilisateur",
    application: "Application",
    time: "Temps",
    filter_by: "Filtrer par"
};
var $66c1bccdb61f9148$export$2e2bcd8739ae039 = Object.freeze($66c1bccdb61f9148$var$logs);


const $6c7d1208b1b4055e$var$menu = {
    profile: "Profile",
    language: "Langue",
    appearance: {
        label: "Apparence",
        light: "Mode clair",
        dark: "Mode sombre",
        system: "Synchronisation avec le syst\xe8me"
    },
    sign_out: "Sign Out"
};
var $6c7d1208b1b4055e$export$2e2bcd8739ae039 = Object.freeze($6c7d1208b1b4055e$var$menu);


const $197f4a31fc615e90$var$mfa = {
    title: "Authentification \xe0 plusieurs facteurs",
    description: "Ajoutez une authentification \xe0 plusieurs facteurs pour renforcer la s\xe9curit\xe9 de votre exp\xe9rience de connexion.",
    factors: "Facteurs",
    multi_factors: "Multi-facteurs",
    multi_factors_description: "Les utilisateurs doivent v\xe9rifier l'un des facteurs activ\xe9s pour la v\xe9rification en deux \xe9tapes.",
    totp: "OTP de l'application authentificatrice",
    otp_description: "Liez Google Authenticator, etc., pour v\xe9rifier les mots de passe \xe0 usage unique.",
    webauthn: "WebAuthn (Passkey)",
    webauthn_description: "V\xe9rifiez via une m\xe9thode prise en charge par le navigateur : biom\xe9trie, scan de t\xe9l\xe9phone ou cl\xe9 de s\xe9curit\xe9, etc.",
    webauthn_native_tip: "WebAuthn n'est pas pris en charge pour les applications natives.",
    webauthn_domain_tip: "WebAuthn lie les cl\xe9s publiques au domaine sp\xe9cifique. Modifier votre domaine de service bloquera les utilisateurs pour l'authentification via les passkeys existantes.",
    backup_code: "Code de secours",
    backup_code_description: "G\xe9n\xe9rez 10 codes de secours \xe0 usage unique apr\xe8s que les utilisateurs aient configur\xe9 une m\xe9thode de MFA.",
    backup_code_setup_hint: "Quand les utilisateurs ne peuvent pas v\xe9rifier les facteurs MFA ci-dessus, utilisez l'option de secours.",
    backup_code_error_hint: "Pour utiliser un code de secours, vous avez besoin d'au moins une autre m\xe9thode de MFA pour une authentification r\xe9ussie de l'utilisateur.",
    policy: "Politique",
    policy_description: "D\xe9finissez la politique de MFA pour les flux de connexion et d'inscription.",
    two_step_sign_in_policy: "Politique de v\xe9rification en deux \xe9tapes \xe0 la connexion",
    user_controlled: "Les utilisateurs peuvent activer ou d\xe9sactiver MFA eux-m\xeames",
    user_controlled_tip: "Les utilisateurs peuvent ignorer la configuration MFA la premi\xe8re fois \xe0 la connexion ou \xe0 l'inscription, ou l'activer/d\xe9sactiver dans les param\xe8tres du compte.",
    mandatory: "Les utilisateurs doivent toujours utiliser MFA \xe0 la connexion",
    mandatory_tip: "Les utilisateurs doivent configurer MFA la premi\xe8re fois \xe0 la connexion ou \xe0 l'inscription, et l'utiliser pour toutes les connexions futures."
};
var $197f4a31fc615e90$export$2e2bcd8739ae039 = Object.freeze($197f4a31fc615e90$var$mfa);


const $60133b80d73fa70b$var$organization_details = {
    page_title: "D\xe9tails de l'organisation",
    delete_confirmation: "Une fois supprim\xe9e, tous les membres perdront leur adh\xe9sion et leurs r\xf4les dans cette organisation. Cette action ne peut pas \xeatre annul\xe9e.",
    organization_id: "Identifiant de l'organisation",
    settings_description: "Les organisations repr\xe9sentent les \xe9quipes, les clients professionnels et les entreprises partenaires qui peuvent acc\xe9der \xe0 vos applications.",
    name_placeholder: "Le nom de l'organisation, pas n\xe9cessairement unique.",
    description_placeholder: "Une description de l'organisation.",
    member: "Membre",
    member_other: "Membres",
    add_members_to_organization: "Ajouter des membres \xe0 l'organisation {{name}}",
    add_members_to_organization_description: "Trouvez les utilisateurs appropri\xe9s en recherchant leur nom, e-mail, t\xe9l\xe9phone ou identifiant d'utilisateur. Les membres existants ne sont pas affich\xe9s dans les r\xe9sultats de la recherche.",
    add_with_organization_role: "Ajouter avec le(s) r\xf4le(s) dans l'organisation",
    user: "Utilisateur",
    authorize_to_roles: "Autoriser {{name}} \xe0 acc\xe9der aux r\xf4les suivants :",
    edit_organization_roles: "Modifier les r\xf4les de l'organisation",
    edit_organization_roles_of_user: "Modifier les r\xf4les de l'organisation de {{name}}",
    remove_user_from_organization: "Retirer l'utilisateur de l'organisation",
    remove_user_from_organization_description: "Une fois retir\xe9, l'utilisateur perdra son adh\xe9sion et ses r\xf4les dans cette organisation. Cette action ne peut pas \xeatre annul\xe9e.",
    search_user_placeholder: "Rechercher par nom, e-mail, t\xe9l\xe9phone ou identifiant d'utilisateur",
    at_least_one_user: "Au moins un utilisateur est requis.",
    custom_data: "Donn\xe9es personnalis\xe9es",
    custom_data_tip: "Les donn\xe9es personnalis\xe9es sont un objet JSON qui peut \xeatre utilis\xe9 pour stocker des donn\xe9es suppl\xe9mentaires associ\xe9es \xe0 l'organisation.",
    invalid_json_object: "Objet JSON non valide."
};
var $60133b80d73fa70b$export$2e2bcd8739ae039 = Object.freeze($60133b80d73fa70b$var$organization_details);


const $6f0f0ea1d29d1dda$var$organization_role_details = {
    page_title: "D\xe9tails du r\xf4le de l'organisation",
    back_to_org_roles: "Retour aux r\xf4les de l'organisation",
    org_role: "R\xf4le de l'organisation",
    delete_confirm: "Cela supprimera les autorisations associ\xe9es \xe0 ce r\xf4le des utilisateurs concern\xe9s et supprimera les relations entre les r\xf4les de l'organisation, les membres de l'organisation et les autorisations de l'organisation.",
    deleted: "Le r\xf4le de l'organisation {{name}} a \xe9t\xe9 supprim\xe9 avec succ\xe8s.",
    permissions: {
        tab: "Autorisations",
        name_column: "Autorisation",
        description_column: "Description",
        type_column: "Type d'autorisation",
        type: {
            api: "Autorisation API",
            org: "Autorisation d'organisation"
        },
        assign_permissions: "Attribuer des autorisations",
        remove_permission: "Supprimer la permission",
        remove_confirmation: "Si cette permission est supprim\xe9e, l'utilisateur avec ce r\xf4le d'organisation perdra l'acc\xe8s accord\xe9 par cette permission.",
        removed: "La permission {{name}} a \xe9t\xe9 supprim\xe9e avec succ\xe8s de ce r\xf4le d'organisation",
        assign_description: "Attribuez des autorisations aux r\xf4les au sein de cette organisation. Celles-ci peuvent inclure \xe0 la fois des autorisations d'organisation et des autorisations d'API.",
        organization_permissions: "Autorisations de l'organisation",
        api_permissions: "Autorisations de l'API",
        assign_organization_permissions: "Attribuer des permissions d’organisation",
        assign_api_permissions: "Attribuer des permissions d’API"
    },
    general: {
        tab: "G\xe9n\xe9ral",
        settings: "R\xe9glages",
        description: "Le r\xf4le d’organisation est un regroupement de permissions qui peuvent \xeatre attribu\xe9es aux utilisateurs. Les permissions peuvent provenir des permissions d’organisation pr\xe9d\xe9finies et des permissions API.",
        name_field: "Nom",
        description_field: "Description",
        description_field_placeholder: "Utenti con permessi di sola visualizzazione"
    }
};
var $6f0f0ea1d29d1dda$export$2e2bcd8739ae039 = Object.freeze($6f0f0ea1d29d1dda$var$organization_role_details);


const $bec7b610e20b7c30$var$organization_template = {
    title: "Mod\xe8le d’organisation",
    subtitle: "Dans les applications SaaS multi-tenant, un mod\xe8le d'organisation d\xe9finit des politiques de contr\xf4le d'acc\xe8s partag\xe9es (permissions et r\xf4les) pour plusieurs organisations.",
    roles: {
        tab_name: "R\xf4les org",
        search_placeholder: "Rechercher par nom de r\xf4le",
        create_title: "Cr\xe9er un r\xf4le org",
        role_column: "R\xf4le org",
        permissions_column: "Permissions",
        placeholder_title: "R\xf4le d’organisation",
        placeholder_description: "Un r\xf4le d’organisation est un groupement de permissions qui peuvent \xeatre attribu\xe9es aux utilisateurs. Les permissions doivent provenir des permissions d’organisation pr\xe9d\xe9finies.",
        create_modal: {
            title: "Cr\xe9er un r\xf4le d'organisation",
            create: "Cr\xe9er un r\xf4le",
            name_field: "Nom du r\xf4le",
            description_field: "Description",
            created: "Le r\xf4le d'organisation {{name}} a \xe9t\xe9 cr\xe9\xe9 avec succ\xe8s."
        }
    },
    permissions: {
        tab_name: "Permissions org",
        search_placeholder: "Rechercher par nom de permission",
        create_org_permission: "Cr\xe9er une permission org",
        permission_column: "Permission de l'organisation",
        description_column: "Description",
        placeholder_title: "Permission d’organisation",
        placeholder_description: "La permission d’organisation se r\xe9f\xe8re \xe0 l’autorisation d’acc\xe9der \xe0 une ressource dans le contexte de l’organisation.",
        delete_confirm: "Si cette permission est supprim\xe9e, tous les r\xf4les d’organisation incluant cette permission perdront cette permission, et les utilisateurs qui avaient cette permission perdront l’acc\xe8s accord\xe9 par celle-ci.",
        create_title: "Cr\xe9er une autorisation d’organisation",
        edit_title: "Modifier une autorisation d’organisation",
        permission_field_name: "Nom de la permission",
        description_field_name: "Description",
        description_field_placeholder: "Lire l'historique des rendez-vous",
        create_permission: "Cr\xe9er une permission",
        created: "La permission d'organisation {{name}} a \xe9t\xe9 cr\xe9\xe9e avec succ\xe8s."
    }
};
var $bec7b610e20b7c30$export$2e2bcd8739ae039 = Object.freeze($bec7b610e20b7c30$var$organization_template);


const $702bb511c8dc4abc$var$organizations = {
    organization: "Organisation",
    page_title: "Organisations",
    title: "Organisations",
    subtitle: "Les organisations sont g\xe9n\xe9ralement utilis\xe9es dans les applications SaaS ou similaires multi-locataires et repr\xe9sentent vos clients qui sont des \xe9quipes, des organisations, ou des entreprises enti\xe8res. Les organisations servent d'\xe9l\xe9ment fondateur pour l'authentification et l'autorisation B2B.",
    organization_template: "Mod\xe8le d'organisation",
    organization_id: "ID de l'organisation",
    members: "Membres",
    create_organization: "Cr\xe9er une organisation",
    setup_organization: "Configurer votre organisation",
    organization_list_placeholder_title: "Organisation",
    organization_list_placeholder_text: "Les organisations sont souvent utilis\xe9es dans les applications SaaS ou similaires multi-locataires comme bonne pratique. Elles vous permettent de d\xe9velopper des applications qui permettent aux clients de cr\xe9er et de g\xe9rer des organisations, d'inviter des membres, et d'assigner des r\xf4les.",
    organization_name_placeholder: "Mon organisation",
    organization_description_placeholder: "Une br\xe8ve description de l'organisation",
    organization_permission: "Autorisation de l'organisation",
    organization_permission_other: "Autorisations de l'organisation",
    create_permission_placeholder: "Lire l'historique des rendez-vous",
    organization_role: "R\xf4le de l'organisation",
    organization_role_other: "R\xf4les de l'organisation",
    organization_role_description: "Le r\xf4le d'organisation est un regroupement d'autorisations pouvant \xeatre attribu\xe9es aux utilisateurs. Les autorisations doivent provenir des autorisations d'organisation pr\xe9d\xe9finies.",
    role: "R\xf4le",
    search_placeholder: "Rechercher par nom ou ID de l'organisation",
    search_role_placeholder: "Tapez pour rechercher et s\xe9lectionner des r\xf4les",
    empty_placeholder: "\uD83E\uDD14 Vous n'avez pas encore configur\xe9 {{entity}}.",
    organization_and_member: "Organisation et membre",
    organization_and_member_description: "L'organisation est un regroupement d'utilisateurs et peut repr\xe9senter les \xe9quipes, les clients professionnels et les entreprises partenaires, chaque utilisateur \xe9tant un \"Membre\". Il s'agit d'entit\xe9s fondamentales pour r\xe9pondre \xe0 vos besoins multi-locataires.",
    guide: {
        title: "Commencez avec les guides",
        subtitle: "D\xe9marrez vos param\xe8tres organisationnels avec nos guides",
        introduction: {
            title: "Comprendre le fonctionnement de l'organisation dans Logto",
            section_1: {
                title: "Une organisation est un groupe d'utilisateurs (identit\xe9s)"
            },
            section_2: {
                title: "Le mod\xe8le d'organisation est con\xe7u pour le contr\xf4le d'acc\xe8s des applications multi-locataires",
                description: "Dans les applications multi-locataires SaaS, plusieurs organisations partagent souvent le m\xeame mod\xe8le de contr\xf4le d'acc\xe8s, comprenant des autorisations et des r\xf4les. Chez Logto, nous l'appelons \"mod\xe8le d'organisation\".",
                permission_description: "L'autorisation d'organisation se r\xe9f\xe8re \xe0 l'autorisation d'acc\xe9der \xe0 une ressource dans le contexte de l'organisation.",
                role_description_deprecated: "Le r\xf4le d'organisation est un regroupement de permissions d'organisation pouvant \xeatre attribu\xe9es aux membres.",
                role_description: "Le r\xf4le de l'organisation est un regroupement de permissions d'organisation ou de permissions API qui peuvent \xeatre attribu\xe9es aux membres."
            },
            section_3: {
                title: "Puis-je attribuer des permissions API aux r\xf4les de l'organisation?",
                description: "Oui, vous pouvez attribuer des permissions API aux r\xf4les de l'organisation. Logto offre la flexibilit\xe9 de g\xe9rer efficacement les r\xf4les de votre organisation, vous permettant d'inclure \xe0 la fois les permissions d'organisation et les permissions API au sein de ces r\xf4les."
            },
            section_4: {
                title: "Interagissez avec l'illustration pour voir comment tout est connect\xe9",
                description: "Prenons un exemple : John, Sarah appartiennent \xe0 diff\xe9rentes organisations avec des r\xf4les diff\xe9rents dans le contexte de diff\xe9rentes organisations. Passez la souris sur les diff\xe9rents modules et voyez ce qui se passe."
            }
        },
        organization_permissions: "Autorisations de l'organisation",
        organization_roles: "R\xf4les de l'organisation",
        admin: "Admin",
        member: "Membre",
        guest: "Invit\xe9",
        role_description: 'Le r\xf4le "{{role}}" partage le m\xeame mod\xe8le d\'organisation dans diff\xe9rentes organisations.',
        john: "John",
        john_tip: "John appartient \xe0 deux organisations avec l'e-mail \"john@email.com\" en tant qu'identifiant unique. Il est l'administrateur de l'organisation A ainsi que l'invit\xe9 de l'organisation B.",
        sarah: "Sarah",
        sarah_tip: "Sarah appartient \xe0 une organisation avec l'e-mail \"sarah@email.com\" en tant qu'identifiant unique. Elle est l'administratrice de l'organisation B."
    }
};
var $702bb511c8dc4abc$export$2e2bcd8739ae039 = Object.freeze($702bb511c8dc4abc$var$organizations);


const $5e3259fe7339543b$var$permissions = {
    search_placeholder: "Rechercher par nom d'API ou de permission",
    search_placeholder_without_api: "Rechercher par nom de permission",
    name_column: "Permission",
    description_column: "Description",
    api_column: "API",
    placeholder_title: "Permission",
    placeholder_description: "La permission fait r\xe9f\xe9rence \xe0 l'autorisation d'acc\xe9der \xe0 une ressource (nous l'appelons ressource d'API).",
    edit: "Permission de modifier",
    delete: "Permission de supprimer",
    remove: "Permission de retirer",
    edit_title: "Modifier l’autorisation de l’API"
};
var $5e3259fe7339543b$export$2e2bcd8739ae039 = Object.freeze($5e3259fe7339543b$var$permissions);


const $4411c296ae06efc2$var$profile = {
    page_title: "Param\xe8tres du compte",
    title: "Param\xe8tres du compte",
    description: "Modifiez les param\xe8tres de votre compte et g\xe9rez vos informations personnelles ici pour garantir la s\xe9curit\xe9 de votre compte.",
    settings: {
        title: "Param\xe8tres du profil",
        profile_information: "Informations du profil",
        avatar: "Avatar",
        name: "Nom",
        username: "Nom d'utilisateur"
    },
    link_account: {
        title: "Lien de compte",
        email_sign_in: "Connexion par e-mail",
        email: "Email",
        social_sign_in: "Connexion sociale",
        link_email: "Lier le courriel",
        link_email_subtitle: "Liez votre e-mail pour vous connecter ou pour vous aider \xe0 r\xe9cup\xe9rer votre compte.",
        email_required: "L'email est obligatoire",
        invalid_email: "Adresse e-mail invalide",
        identical_email_address: "L'adresse e-mail saisie est identique \xe0 celle en cours",
        anonymous: "Anonyme"
    },
    password: {
        title: "Mot de passe et s\xe9curit\xe9",
        password: "Mot de passe",
        password_setting: "Param\xe8tres de mot de passe",
        new_password: "Nouveau mot de passe",
        confirm_password: "Confirmer le mot de passe",
        enter_password: "Entrez le mot de passe actuel",
        enter_password_subtitle: "V\xe9rifiez que c'est vous pour prot\xe9ger la s\xe9curit\xe9 de votre compte. Veuillez saisir votre mot de passe actuel avant de le changer.",
        set_password: "D\xe9finir le mot de passe",
        verify_via_password: "V\xe9rifier via mot de passe",
        show_password: "Afficher le mot de passe",
        required: "Le mot de passe est obligatoire",
        do_not_match: "Les mots de passe ne correspondent pas. Veuillez r\xe9essayer."
    },
    code: {
        enter_verification_code: "Entrez le code de v\xe9rification",
        enter_verification_code_subtitle: "Le code de v\xe9rification a \xe9t\xe9 envoy\xe9 \xe0 <strong>{{target}}</strong>",
        verify_via_code: "V\xe9rifier via code de v\xe9rification",
        resend: "Renvoyer le code de v\xe9rification",
        resend_countdown: "Renvojer dans {{countdown}} secondes"
    },
    delete_account: {
        title: "Supprimer le compte",
        label: "Supprimer le compte",
        description: "La suppression de votre compte supprimera toutes vos informations personnelles, vos donn\xe9es d'utilisateur et votre configuration. Cette action ne peut pas \xeatre annul\xe9e.",
        button: "Supprimer le compte",
        dialog_paragraph_1: "Nous sommes d\xe9sol\xe9s d'entendre que vous souhaitez supprimer votre compte. La suppression de votre compte supprimera d\xe9finitivement toutes les donn\xe9es, y compris les informations d'utilisateur, les journaux et les param\xe8tres, et cette action ne peut pas \xeatre annul\xe9e. Veuillez donc vous assurer de sauvegarder toutes les donn\xe9es importantes avant de continuer.",
        dialog_paragraph_2: "Pour poursuivre le processus de suppression de compte, veuillez envoyer un e-mail \xe0 notre \xe9quipe de support \xe0 l'adresse <a>mail</a> avec l'objet \xab Demande de suppression de compte \xbb. Nous vous aiderons et nous assurerons que toutes vos donn\xe9es sont correctement supprim\xe9es de notre syst\xe8me.",
        dialog_paragraph_3: "Merci d'avoir choisi Logto Cloud. Si vous avez des questions ou des pr\xe9occupations suppl\xe9mentaires, n'h\xe9sitez pas \xe0 nous contacter."
    },
    set: "D\xe9finir",
    change: "Modifier",
    link: "Lier",
    unlink: "D\xe9tacher",
    not_set: "Pas d\xe9fini",
    change_avatar: "Modifier l'avatar",
    change_name: "Modifier le nom",
    change_username: "Modifier le nom d'utilisateur",
    set_name: "D\xe9finir le nom",
    email_changed: "Email modifi\xe9.",
    password_changed: "Mot de passe modifi\xe9.",
    updated: "{{target}} mis \xe0 jour.",
    linked: "{{target}} li\xe9.",
    unlinked: "{{target}} d\xe9tach\xe9.",
    email_exists_reminder: "Cet e-mail {{email}} est associ\xe9 \xe0 un compte existant. Liez un autre e-mail ici.",
    unlink_confirm_text: "Oui, d\xe9tacher",
    unlink_reminder: "Les utilisateurs ne pourront plus se connecter avec le compte <span></span> si vous le d\xe9tachez. \xcates-vous s\xfbr de vouloir continuer ?"
};
var $4411c296ae06efc2$export$2e2bcd8739ae039 = Object.freeze($4411c296ae06efc2$var$profile);


const $1e777d4bff003a14$var$protected_app = {
    name: "Application Prot\xe9g\xe9e",
    title: "Cr\xe9ez une application prot\xe9g\xe9e : ajoutez l'authentification en toute simplicit\xe9 et avec une vitesse \xe9pique",
    description: "L'application prot\xe9g\xe9e maintient de mani\xe8re s\xe9curis\xe9e les sessions utilisateur et redirige les requ\xeates de votre application. Propuls\xe9e par Cloudflare Workers, profitez des performances de premier ordre et d'un d\xe9marrage instantan\xe9 de 0 ms dans le monde entier. <a>En savoir plus</a>",
    fast_create: "Cr\xe9ation rapide",
    modal_title: "Cr\xe9er une Application Prot\xe9g\xe9e",
    modal_subtitle: "Activez une protection s\xe9curis\xe9e et rapide en quelques clics. Ajoutez facilement l'authentification \xe0 votre application web existante.",
    form: {
        url_field_label: "Votre URL d'origine",
        url_field_placeholder: "https://domaine.com/",
        url_field_description: "Indiquez l'adresse de votre application n\xe9cessitant une protection d'authentification.",
        url_field_modification_notice: "Les modifications apport\xe9es \xe0 l'URL d'origine peuvent prendre de 1 \xe0 2 minutes pour \xeatre effectives dans les emplacements du r\xe9seau mondial.",
        url_field_tooltip: "Indiquez l'adresse de votre application, en excluant tout '/chemin'. Apr\xe8s la cr\xe9ation, vous pouvez personnaliser les r\xe8gles d'authentification de routage.\n\nRemarque : l'URL d'origine en elle-m\xeame ne n\xe9cessite pas d'authentification ; la protection est appliqu\xe9e exclusivement aux acc\xe8s via le domaine de l'application d\xe9sign\xe9e.",
        domain_field_label: "Domaine de l'application",
        domain_field_placeholder: "votre-domaine",
        domain_field_description: "Cette URL sert de proxy de protection d'authentification pour l'URL d'origine. Un domaine personnalis\xe9 peut \xeatre appliqu\xe9 apr\xe8s la cr\xe9ation.",
        domain_field_description_short: "Cette URL sert de proxy de protection d'authentification pour l'URL d'origine.",
        domain_field_tooltip: "Les applications prot\xe9g\xe9es par Logto seront h\xe9berg\xe9es par d\xe9faut \xe0 'votre-domaine.{{domain}}'. Un domaine personnalis\xe9 peut \xeatre appliqu\xe9 apr\xe8s la cr\xe9ation.",
        create_application: "Cr\xe9er l'application",
        create_protected_app: "Cr\xe9ation rapide",
        errors: {
            domain_required: "Votre domaine est requis.",
            domain_in_use: "Ce nom de sous-domaine est d\xe9j\xe0 utilis\xe9.",
            invalid_domain_format: "Format de sous-domaine invalide : utilisez uniquement des lettres minuscules, des chiffres et des tirets '-'.",
            url_required: "L'URL d'origine est requise.",
            invalid_url: "Format d'URL d'origine invalide : Utilisez http:// ou https://. Remarque : '/chemin' n'est actuellement pas pris en charge.",
            localhost: "Veuillez exposer votre serveur local \xe0 Internet d'abord. En savoir plus sur le <a>d\xe9veloppement local</a>."
        }
    },
    success_message: "\uD83C\uDF89 Authentification de l'application activ\xe9e avec succ\xe8s ! D\xe9couvrez la nouvelle exp\xe9rience de votre site web."
};
var $1e777d4bff003a14$export$2e2bcd8739ae039 = Object.freeze($1e777d4bff003a14$var$protected_app);


const $58542fdbf9a508b5$var$role_details = {
    back_to_roles: "Retour aux r\xf4les",
    identifier: "Identificateur",
    delete_description: "Cela supprimera les autorisations associ\xe9es \xe0 ce r\xf4le des utilisateurs concern\xe9s et supprimera la correspondance entre les r\xf4les, les utilisateurs et les autorisations.",
    role_deleted: "{{name}} a \xe9t\xe9 supprim\xe9 avec succ\xe8s.",
    general_tab: "G\xe9n\xe9ral",
    users_tab: "Utilisateurs",
    m2m_apps_tab: "Applications machine-\xe0-machine",
    permissions_tab: "Autorisations",
    settings: "Param\xe8tres",
    settings_description: "Les r\xf4les sont un regroupement d'autorisations qui peuvent \xeatre attribu\xe9es aux utilisateurs. Ils fournissent \xe9galement un moyen d'agr\xe9ger les autorisations d\xe9finies pour diff\xe9rentes API, ce qui rend plus efficace l'ajout, la suppression ou l'ajustement des autorisations par rapport \xe0 leur attribution individuelle aux utilisateurs.",
    field_name: "Nom",
    field_description: "Description",
    field_is_default: "R\xf4le par d\xe9faut",
    field_is_default_description: "D\xe9finissez ce r\xf4le comme r\xf4le par d\xe9faut pour les nouveaux utilisateurs. Plusieurs r\xf4les par d\xe9faut peuvent \xeatre d\xe9finis. Cela affectera \xe9galement les r\xf4les par d\xe9faut des utilisateurs cr\xe9\xe9s via l'API de gestion.",
    type_m2m_role_tag: "R\xf4le de l'application machine-\xe0-machine",
    type_user_role_tag: "R\xf4le d'utilisateur",
    m2m_role_notification: "Attribuez ce r\xf4le machine \xe0 machine \xe0 une application machine \xe0 machine pour accorder l'acc\xe8s aux ressources d'API relatives. <a>Cr\xe9ez d'abord une application machine \xe0 machine</a> si ce n'est pas d\xe9j\xe0 fait.",
    permission: {
        assign_button: "Attribuer des autorisations",
        assign_title: "Attribuer des autorisations",
        assign_subtitle: "Attribuez des autorisations \xe0 ce r\xf4le. Le r\xf4le acquerra les autorisations ajout\xe9es, et les utilisateurs avec ce r\xf4le h\xe9riteront de ces autorisations.",
        assign_form_field: "Attribuer des autorisations",
        added_text_one: "{{count, number}} autorisation ajout\xe9e",
        added_text_other: "{{count, number}} autorisations ajout\xe9es",
        api_permission_count_one: "{{count, number}} autorisation",
        api_permission_count_other: "{{count, number}} autorisations",
        confirm_assign: "Attribuer des autorisations",
        permission_assigned: "Les autorisations s\xe9lectionn\xe9es ont \xe9t\xe9 attribu\xe9es avec succ\xe8s \xe0 ce r\xf4le",
        deletion_description: "Si cette autorisation est supprim\xe9e, l'utilisateur concern\xe9 ayant ce r\xf4le perdra l'acc\xe8s accord\xe9 par cette autorisation.",
        permission_deleted: 'L\'autorisation "{{name}}" a \xe9t\xe9 supprim\xe9e avec succ\xe8s de ce r\xf4le',
        empty: "Aucune autorisation disponible"
    },
    users: {
        assign_button: "Attribuer des utilisateurs",
        name_column: "Utilisateur",
        app_column: "Application",
        latest_sign_in_column: "Derni\xe8re connexion",
        delete_description: "Il restera dans votre r\xe9pertoire d'utilisateurs mais perdra l'autorisation pour ce r\xf4le.",
        deleted: "{{name}} a \xe9t\xe9 supprim\xe9 avec succ\xe8s de ce r\xf4le",
        assign_title: "Attribuer des utilisateurs",
        assign_subtitle: "Attribuez des utilisateurs \xe0 ce r\xf4le. Trouvez les utilisateurs appropri\xe9s en recherchant leur nom, leur e-mail, leur num\xe9ro de t\xe9l\xe9phone ou leur ID utilisateur.",
        assign_field: "Assigner des utilisateurs",
        confirm_assign: "Attribuer des utilisateurs",
        assigned_toast_text: "Les utilisateurs s\xe9lectionn\xe9s ont \xe9t\xe9 attribu\xe9s avec succ\xe8s \xe0 ce r\xf4le",
        empty: "Aucun utilisateur disponible"
    },
    applications: {
        assign_button: "Assigner des applications",
        name_column: "Application",
        app_column: "Applications",
        description_column: "Description",
        delete_description: "Elle restera dans votre pool d'applications mais perdra l'autorisation pour ce r\xf4le.",
        deleted: "{{name}} a \xe9t\xe9 supprim\xe9 avec succ\xe8s de ce r\xf4le",
        assign_title: "Assigner des applications",
        assign_subtitle: "Assignez des applications \xe0 ce r\xf4le. Trouvez les applications appropri\xe9es en recherchant par nom, description ou ID de l'application.",
        assign_field: "Assigner des applications",
        confirm_assign: "Assigner des applications",
        assigned_toast_text: "Les applications s\xe9lectionn\xe9es ont \xe9t\xe9 attribu\xe9es avec succ\xe8s \xe0 ce r\xf4le",
        empty: "Aucune application disponible"
    }
};
var $58542fdbf9a508b5$export$2e2bcd8739ae039 = Object.freeze($58542fdbf9a508b5$var$role_details);


const $0aa5f55544aab405$var$roles = {
    page_title: "R\xf4les",
    title: "R\xf4les",
    subtitle: "Les r\xf4les incluent des autorisations qui d\xe9terminent ce qu'un utilisateur peut faire. RBAC utilise des r\xf4les pour donner aux utilisateurs acc\xe8s \xe0 des ressources pour des actions sp\xe9cifiques.",
    create: "Cr\xe9er un r\xf4le",
    role_name: "Nom du r\xf4le",
    role_type: "Type de r\xf4le",
    show_role_type_button_text: "Afficher plus d'options",
    hide_role_type_button_text: "Masquer plus d'options",
    type_user: "R\xf4le utilisateur",
    type_machine_to_machine: "R\xf4le d'application machine-\xe0-machine",
    role_description: "Description",
    role_name_placeholder: "Entrez le nom de votre r\xf4le",
    role_description_placeholder: "Entrez la description de votre r\xf4le",
    col_roles: "R\xf4les",
    col_type: "Type",
    col_description: "Description",
    col_assigned_entities: "Assign\xe9",
    user_counts: "{{count}} utilisateurs",
    application_counts: "{{count}} applications",
    user_count: "{{count}} utilisateur",
    application_count: "{{count}} application",
    assign_permissions: "Assigner des autorisations",
    create_role_title: "Cr\xe9er un r\xf4le",
    create_role_description: "Cr\xe9ez et g\xe9rez des r\xf4les pour vos applications. Les r\xf4les contiennent des collections d'autorisations et peuvent \xeatre assign\xe9s aux utilisateurs.",
    create_role_button: "Cr\xe9er un r\xf4le",
    role_created: "Le r\xf4le {{name}} a \xe9t\xe9 cr\xe9\xe9 avec succ\xe8s.",
    search: "Rechercher par nom de r\xf4le, description ou ID",
    placeholder_title: "R\xf4les",
    placeholder_description: "Les r\xf4les sont un regroupement d'autorisations qui peuvent \xeatre assign\xe9es aux utilisateurs. Assurez-vous d'ajouter d'abord des autorisations avant de cr\xe9er des r\xf4les.",
    assign_user_roles: "Attribuer des r\xf4les utilisateur",
    assign_m2m_roles: "Attribuer des r\xf4les machine \xe0 machine",
    management_api_access_notification: "Pour acc\xe9der \xe0 l'API de gestion de Logto, s\xe9lectionnez des r\xf4les avec les autorisations de l'API de gestion <flag/>.",
    with_management_api_access_tip: "Ce r\xf4le machine \xe0 machine inclut les autorisations de l'API de gestion de Logto"
};
var $0aa5f55544aab405$export$2e2bcd8739ae039 = Object.freeze($0aa5f55544aab405$var$roles);


const $014ba2d58d90d48b$var$session_expired = {
    title: "Session expir\xe9e",
    subtitle: "Votre session a peut-\xeatre expir\xe9 et vous avez \xe9t\xe9 d\xe9connect\xe9. Cliquez sur le bouton ci-dessous pour vous reconnecter \xe0 la console d'administration.",
    button: "Se reconnecter"
};
var $014ba2d58d90d48b$export$2e2bcd8739ae039 = Object.freeze($014ba2d58d90d48b$var$session_expired);


const $cd228cee07965c57$var$content = {
    terms_of_use: {
        title: "TERMS",
        terms_of_use: "Terms of use URL",
        terms_of_use_placeholder: "https://your.terms.of.use/",
        privacy_policy: "Privacy policy URL",
        privacy_policy_placeholder: "https://your.privacy.policy/"
    },
    languages: {
        title: "LANGUAGES",
        enable_auto_detect: "Enable auto-detect",
        description: "Your software detects the user's locale setting and switches to the local language. You can add new languages by translating UI from English to another language.",
        manage_language: "Manage language",
        default_language: "Default language",
        default_language_description_auto: "The default language will be used when the detected user language isn’t covered in the current language library.",
        default_language_description_fixed: "When auto-detect is off, the default language is the only language your software will show. Turn on auto-detect for language extension."
    },
    manage_language: {
        title: "Manage language",
        subtitle: "Localize the product experience by adding languages and translations. Your contribution can be set as the default language.",
        add_language: "Add Language",
        logto_provided: "Logto provided",
        key: "Key",
        logto_source_values: "Logto source values",
        custom_values: "Custom values",
        clear_all_tip: "Clear all values",
        unsaved_description: "Changes won’t be saved if you leave this page without saving.",
        deletion_tip: "Delete the language",
        deletion_title: "Do you want to delete the added language?",
        deletion_description: "After deletion, your users won’t be able to browse in that language again.",
        default_language_deletion_title: "Default language can’t be deleted.",
        default_language_deletion_description: "{{language}} is set as your default language and can’t be deleted. "
    }
};
var $cd228cee07965c57$export$2e2bcd8739ae039 = Object.freeze($cd228cee07965c57$var$content);


const $eac7b251ad82d55b$var$password_policy = {
    password_requirements: "Exigences relatives au mot de passe",
    minimum_length: "Longueur minimale",
    minimum_length_description: "NIST sugg\xe8re d'utiliser <a>au moins 8 caract\xe8res</a> pour les produits web.",
    minimum_length_error: "La longueur minimale doit \xeatre comprise entre {{min}} et {{max}} (inclus).",
    minimum_required_char_types: "Nombre minimum de types de caract\xe8res requis",
    minimum_required_char_types_description: "Types de caract\xe8res : majuscules (A-Z), minuscules (a-z), chiffres (0-9) et symboles sp\xe9ciaux ({{symbols}}).",
    password_rejection: "Rejet du mot de passe",
    compromised_passwords: "Mots de passe compromis",
    breached_passwords: "Mots de passe compromis",
    breached_passwords_description: "Rejeter les mots de passe pr\xe9c\xe9demment trouv\xe9s dans les bases de donn\xe9es de violation.",
    restricted_phrases: "Restreindre les phrases \xe0 faible s\xe9curit\xe9",
    restricted_phrases_tooltip: "Votre mot de passe devrait \xe9viter ces phrases \xe0 moins que vous ne les combiniez avec 3 caract\xe8res suppl\xe9mentaires ou plus.",
    repetitive_or_sequential_characters: "Caract\xe8res r\xe9p\xe9titifs ou s\xe9quentiels",
    repetitive_or_sequential_characters_description: 'Par exemple, "AAAA", "1234" et "abcd".',
    user_information: "Informations utilisateur",
    user_information_description: "Par exemple, adresse e-mail, num\xe9ro de t\xe9l\xe9phone, nom d'utilisateur, etc.",
    custom_words: "Mots personnalis\xe9s",
    custom_words_description: "Personnalisez les mots sp\xe9cifiques au contexte, sans distinction de casse, un par ligne.",
    custom_words_placeholder: "Nom de votre service, nom de votre entreprise, etc."
};
var $eac7b251ad82d55b$export$2e2bcd8739ae039 = Object.freeze($eac7b251ad82d55b$var$password_policy);


const $dcff959eba2297a0$var$sign_up_and_sign_in = {
    identifiers_email: "Adresse e-mail",
    identifiers_phone: "Num\xe9ro de t\xe9l\xe9phone",
    identifiers_username: "Nom d’utilisateur",
    identifiers_email_or_sms: "Adresse e-mail ou num\xe9ro de t\xe9l\xe9phone",
    identifiers_none: "Non applicable",
    and: "et",
    or: "ou",
    sign_up: {
        title: "INSCRIPTION",
        sign_up_identifier: "Identificateur d'inscription",
        identifier_description: "L'identificateur d'inscription est n\xe9cessaire pour la cr\xe9ation de compte et doit \xeatre inclus dans vote \xe9cran de connexion.",
        sign_up_authentication: "Param\xe8tres d'authentification pour l'inscription",
        authentication_description: "Toutes les actions s\xe9lectionn\xe9es seront obligatoires pour que les utilisateurs terminent le processus d'inscription.",
        set_a_password_option: "Cr\xe9er votre mot de passe",
        verify_at_sign_up_option: "V\xe9rifier lors de l'inscription",
        social_only_creation_description: "(Ceci s'applique \xe0 la cr\xe9ation de compte uniquement via un r\xe9seau social)"
    },
    sign_in: {
        title: "CONNEXION",
        sign_in_identifier_and_auth: "Identificateurs et param\xe8tres d'authentification pour la connexion",
        description: "Les utilisateurs peuvent se connecter en utilisant n'importe quelle option disponible. Ajustez la mise en page en faisant glisser et en d\xe9posant les options ci-dessous.",
        add_sign_in_method: "Ajouter une m\xe9thode de connexion",
        password_auth: "Mot de passe",
        verification_code_auth: "Code de v\xe9rification",
        auth_swap_tip: "Echangez les options ci-dessous pour d\xe9terminer celle qui apparait en premier dans le processus.",
        require_auth_factor: "Vous devez s\xe9lectionner au moins un \xe9l\xe9ment d'authentification."
    },
    social_sign_in: {
        title: "CONNEXION VIA R\xc9SEAU SOCIAL",
        social_sign_in: "Connexion via r\xe9seau social",
        description: "Selon l'identificateur obligatoire que vous avez mis en place, votre utilisateur peut \xeatre invit\xe9 \xe0 fournir un identificateur lors de l'inscription via un r\xe9seau social.",
        add_social_connector: "Ajouter un connecteur social",
        set_up_hint: {
            not_in_list: "Pas dans la liste?",
            set_up_more: "Configurer",
            go_to: "d'autres connecteurs sociaux maintenant."
        }
    },
    tip: {
        set_a_password: "Un ensemble unique de mot de passe pour votre nom d'utilisateur est essentiel.",
        verify_at_sign_up: "Nous ne prenons actuellement en charge que les adresses e-mail v\xe9rifi\xe9e. Votre base utilisateur peut contenir un grand nombre d'adresses e-mail de mauvaise qualit\xe9 s'il n'y a pas de validation.",
        password_auth: "Ceci est essentiel car vous avez activ\xe9 l'option de configuration d'un mot de passe au cours du processus d'inscription.",
        verification_code_auth: "Ceci est essentiel car vous avez uniquement activ\xe9 l'option de fourniture d'un code de v\xe9rification lors de l'inscription. Vous pouvez d\xe9cocher la case lorsque la configuration d'un mot de passe est autoris\xe9e lors du processus d'inscription.",
        delete_sign_in_method: "Ceci est essentiel car vous avez s\xe9lectionn\xe9 {{identifier}} comme identificateur requis."
    },
    advanced_options: {
        title: "OPTIONS AVANC\xc9ES",
        enable_single_sign_on: "Activer l'authentification unique en entreprise (SSO)",
        enable_single_sign_on_description: "Permettre aux utilisateurs de se connecter \xe0 l'application en utilisant une authentification unique avec leurs identit\xe9s d'entreprise.",
        single_sign_on_hint: {
            prefix: "Aller \xe0 ",
            link: '"Entreprise SSO"',
            suffix: "section pour configurer d'autres connecteurs d'entreprise."
        },
        enable_user_registration: "Activer l'inscription des utilisateurs",
        enable_user_registration_description: "Activer ou interdire l'inscription des utilisateurs. Une fois d\xe9sactiv\xe9e, les utilisateurs peuvent toujours \xeatre ajout\xe9s \xe0 la console d'administration mais ne peuvent plus cr\xe9er de compte via l'interface de connexion."
    }
};
var $dcff959eba2297a0$export$2e2bcd8739ae039 = Object.freeze($dcff959eba2297a0$var$sign_up_and_sign_in);


const $bfd2c7223b656acc$var$sign_in_exp = {
    page_title: "Exp\xe9rience de connexion",
    title: "Exp\xe9rience de connexion",
    description: "Personnalisez l'interface utilisateur pour qu'elle corresponde \xe0 votre marque et consultez-la en temps r\xe9el.",
    tabs: {
        branding: "Image de marque",
        sign_up_and_sign_in: "Inscription et connexion",
        content: "Contenu",
        password_policy: "Politique de mot de passe"
    },
    welcome: {
        title: "Personnaliser l'exp\xe9rience de connexion",
        description: "D\xe9marrez rapidement avec la premi\xe8re configuration de connexion. Ce guide vous guide \xe0 travers tous les param\xe8tres n\xe9cessaires",
        get_started: "Commencer",
        apply_remind: "Veuillez noter que l'exp\xe9rience de connexion s'appliquera \xe0 toutes les applications sous ce compte."
    },
    color: {
        title: "COULEUR",
        primary_color: "Couleur de la marque",
        dark_primary_color: "Couleur de la marque (Sombre)",
        dark_mode: "Activer le mode sombre",
        dark_mode_description: "Votre application aura un th\xe8me en mode sombre g\xe9n\xe9r\xe9 automatiquement en fonction de la couleur de votre marque et de l'algorithme de Logto. Vous \xeates libre de le personnaliser.",
        dark_mode_reset_tip: "Recalculer la couleur du mode sombre en fonction de la couleur de la marque.",
        reset: "Recalculer"
    },
    branding: {
        title: "ZONE DE MARQUE",
        ui_style: "Style",
        favicon: "Favicon",
        logo_image_url: "URL de l'image du logo de l'application",
        logo_image_url_placeholder: "https://votre.domaine.cdn/logo.png",
        dark_logo_image_url: "URL de l'image du logo de l'application (Sombre)",
        dark_logo_image_url_placeholder: "https://votre.domaine.cdn/logo-dark.png",
        logo_image: "Logo de l'application",
        dark_logo_image: "Logo de l'application (sombre)",
        logo_image_error: "Logo de l'application : {{error}}",
        favicon_error: "Favicon : {{error}}"
    },
    custom_css: {
        title: "CSS personnalis\xe9",
        css_code_editor_title: "Personnalisez votre interface utilisateur avec CSS personnalis\xe9",
        css_code_editor_description1: "Voici un exemple de CSS personnalis\xe9.",
        css_code_editor_description2: "<a>{{link}}</a>",
        css_code_editor_description_link_content: "En savoir plus",
        css_code_editor_content_placeholder: "Entrez votre propre CSS pour adapter les styles de tout \xe9l\xe9ment \xe0 vos sp\xe9cifications exactes. Exprimez votre cr\xe9ativit\xe9 et faites sortir votre interface utilisateur."
    },
    sign_up_and_sign_in: $dcff959eba2297a0$export$2e2bcd8739ae039,
    content: $cd228cee07965c57$export$2e2bcd8739ae039,
    password_policy: $eac7b251ad82d55b$export$2e2bcd8739ae039,
    setup_warning: {
        no_connector_sms: 'Aucun connecteur SMS n\'a \xe9t\xe9 configur\xe9. Avant de terminer la configuration, les utilisateurs ne pourront pas se connecter avec cette m\xe9thode. <a>{{link}}</a> dans "Connecteurs"',
        no_connector_email: "Aucun connecteur d'email n'a \xe9t\xe9 configur\xe9. Avant de terminer la configuration, les utilisateurs ne pourront pas se connecter avec cette m\xe9thode. <a>{{link}}</a> dans \"Connecteurs\"",
        no_connector_social: 'Vous n’avez pas encore configur\xe9 de connecteur social. Ajoutez d’abord des connecteurs pour appliquer des m\xe9thodes de connexion sociale. <a>{{link}}</a> dans "Connecteurs".',
        setup_link: "Configurer"
    },
    save_alert: {
        description: "Vous impl\xe9mentez de nouvelles proc\xe9dures d'inscription et de connexion. Tous vos utilisateurs peuvent \xeatre affect\xe9s par la nouvelle configuration. Voulez-vous vous engager dans le changement?",
        before: "Avant",
        after: "Apr\xe8s",
        sign_up: "Inscription",
        sign_in: "Connexion",
        social: "Social"
    },
    preview: {
        title: "Aper\xe7u de l'exp\xe9rience de connexion",
        live_preview: "Aper\xe7u en direct",
        live_preview_tip: "Enregistrez pour pr\xe9visualiser les modifications",
        native: "Natif",
        desktop_web: "Site web pour ordinateur de bureau",
        mobile_web: "Site web mobile",
        desktop: "Bureau",
        mobile: "Mobile"
    }
};
var $bfd2c7223b656acc$export$2e2bcd8739ae039 = Object.freeze($bfd2c7223b656acc$var$sign_in_exp);


const $4d884384ac096342$var$signing_keys = {
    title: "Cl\xe9s de signature",
    description: "G\xe9rez de mani\xe8re s\xe9curis\xe9e les cl\xe9s de signature utilis\xe9es par vos applications.",
    private_key: "Cl\xe9s priv\xe9es OIDC",
    private_keys_description: "Les cl\xe9s priv\xe9es OIDC sont utilis\xe9es pour signer les jetons JWT.",
    cookie_key: "Cl\xe9s de cookies OIDC",
    cookie_keys_description: "Les cl\xe9s de cookies OIDC sont utilis\xe9es pour signer les cookies.",
    private_keys_in_use: "Cl\xe9s priv\xe9es en cours d'utilisation",
    cookie_keys_in_use: "Cl\xe9s de cookies en cours d'utilisation",
    rotate_private_keys: "Faire tourner les cl\xe9s priv\xe9es",
    rotate_cookie_keys: "Faire tourner les cl\xe9s de cookies",
    rotate_private_keys_description: "Cette action cr\xe9era une nouvelle cl\xe9 de signature priv\xe9e, fera tourner la cl\xe9 actuelle et supprimera votre cl\xe9 pr\xe9c\xe9dente. Vos jetons JWT sign\xe9s avec la cl\xe9 actuelle resteront valides jusqu'\xe0 leur suppression ou une nouvelle rotation.",
    rotate_cookie_keys_description: "Cette action cr\xe9era une nouvelle cl\xe9 de cookie, fera tourner la cl\xe9 actuelle et supprimera votre cl\xe9 pr\xe9c\xe9dente. Vos cookies avec la cl\xe9 actuelle resteront valides jusqu'\xe0 leur suppression ou une nouvelle rotation.",
    select_private_key_algorithm: "S\xe9lectionnez l'algorithme de cl\xe9 de signature pour la nouvelle cl\xe9 priv\xe9e",
    rotate_button: "Faire tourner",
    table_column: {
        id: "ID",
        status: "Statut",
        algorithm: "Algorithme de cl\xe9 de signature"
    },
    status: {
        current: "Actuel",
        previous: "Pr\xe9c\xe9dent"
    },
    reminder: {
        rotate_private_key: "\xcates-vous s\xfbr de vouloir faire tourner les <strong>cl\xe9s priv\xe9es OIDC</strong>? Les nouveaux jetons JWT \xe9mis seront sign\xe9s par la nouvelle cl\xe9. Les jetons JWT existants resteront valides jusqu'\xe0 votre prochaine rotation.",
        rotate_cookie_key: "\xcates-vous s\xfbr de vouloir faire tourner les <strong>cl\xe9s de cookies OIDC</strong>? Les nouveaux cookies g\xe9n\xe9r\xe9s dans les sessions de connexion seront sign\xe9s par la nouvelle cl\xe9 de cookie. Les cookies existants resteront valides jusqu'\xe0 votre prochaine rotation.",
        delete_private_key: "\xcates-vous s\xfbr de vouloir supprimer la <strong>cl\xe9 priv\xe9e OIDC</strong>? Les jetons JWT existants sign\xe9s avec cette cl\xe9 de signature priv\xe9e ne seront plus valides.",
        delete_cookie_key: "\xcates-vous s\xfbr de vouloir supprimer la <strong>cl\xe9 de cookie OIDC</strong>? Les anciennes sessions de connexion avec des cookies sign\xe9s avec cette cl\xe9 de cookie ne seront plus valides. Une r\xe9-authentification est requise pour ces utilisateurs."
    },
    messages: {
        rotate_key_success: "Rotation des cl\xe9s de signature effectu\xe9e avec succ\xe8s.",
        delete_key_success: "Cl\xe9 supprim\xe9e avec succ\xe8s."
    }
};
var $4d884384ac096342$export$2e2bcd8739ae039 = Object.freeze($4d884384ac096342$var$signing_keys);


const $30f13b10e9bd8f38$var$quota_item = {
    tenant_limit: {
        name: "Locataires",
        limited: "{{count, number}} locataire",
        limited_other: "{{count, number}} locataires",
        unlimited: "Illimit\xe9 locataires",
        not_eligible: "Supprimez vos locataires"
    },
    mau_limit: {
        name: "Utilisateurs actifs mensuels",
        limited: "{{count, number}} MAU",
        unlimited: "Illimit\xe9 MAU",
        not_eligible: "Supprimez tous vos utilisateurs"
    },
    token_limit: {
        name: "Tokens",
        limited: "{{count, number}} token",
        limited_other: "{{count, number}} tokens",
        unlimited: "Unlimited tokens",
        not_eligible: "Remove your all users to prevent new tokens"
    },
    applications_limit: {
        name: "Applications",
        limited: "{{count, number}} application",
        limited_other: "{{count, number}} applications",
        unlimited: "Illimit\xe9 applications",
        not_eligible: "Supprimez vos applications"
    },
    machine_to_machine_limit: {
        name: "Machine \xe0 machine",
        limited: "{{count, number}} application machine \xe0 machine",
        limited_other: "{{count, number}} applications machine \xe0 machine",
        unlimited: "Illimit\xe9 applications machine \xe0 machine",
        not_eligible: "Supprimez vos applications machine \xe0 machine"
    },
    third_party_applications_limit: {
        name: "Applications tierces",
        limited: "{{count, number}} application tierce",
        limited_other: "{{count, number}} applications tierces",
        unlimited: "Unlimited third-party apps",
        not_eligible: "Remove your third-party apps"
    },
    resources_limit: {
        name: "Ressources API",
        limited: "{{count, number}} ressource API",
        limited_other: "{{count, number}} ressources API",
        unlimited: "Illimit\xe9 ressources API",
        not_eligible: "Supprimez vos ressources API"
    },
    scopes_per_resource_limit: {
        name: "Permissions de ressource",
        limited: "{{count, number}} autorisation par ressource",
        limited_other: "{{count, number}} autorisations par ressource",
        unlimited: "Illimit\xe9 autorisation par ressource",
        not_eligible: "Supprimez vos permissions de ressource"
    },
    custom_domain_enabled: {
        name: "Domaine personnalis\xe9",
        limited: "Domaine personnalis\xe9",
        unlimited: "Domaine personnalis\xe9",
        not_eligible: "Supprimez votre domaine personnalis\xe9"
    },
    omni_sign_in_enabled: {
        name: "Connexion omni",
        limited: "Connexion omni",
        unlimited: "Connexion omni",
        not_eligible: "D\xe9sactivez votre connexion omni"
    },
    built_in_email_connector_enabled: {
        name: "Connecteur de messagerie int\xe9gr\xe9",
        limited: "Connecteur de messagerie int\xe9gr\xe9",
        unlimited: "Connecteur de messagerie int\xe9gr\xe9",
        not_eligible: "Supprimez votre connecteur de messagerie int\xe9gr\xe9"
    },
    social_connectors_limit: {
        name: "Connecteurs sociaux",
        limited: "{{count, number}} connecteur social",
        limited_other: "{{count, number}} connecteurs sociaux",
        unlimited: "Illimit\xe9 connecteurs sociaux",
        not_eligible: "Supprimez vos connecteurs sociaux"
    },
    standard_connectors_limit: {
        name: "Connecteurs standards gratuits",
        limited: "{{count, number}} connecteur standard gratuit",
        limited_other: "{{count, number}} connecteurs standards gratuits",
        unlimited: "Illimit\xe9 connecteurs standards",
        not_eligible: "Supprimez vos connecteurs standards"
    },
    roles_limit: {
        name: "R\xf4les",
        limited: "{{count, number}} r\xf4le",
        limited_other: "{{count, number}} r\xf4les",
        unlimited: "Illimit\xe9 r\xf4les",
        not_eligible: "Supprimez vos r\xf4les"
    },
    machine_to_machine_roles_limit: {
        name: "Roles Machine \xe0 machine",
        limited: "{{count, number}} r\xf4le machine \xe0 machine",
        limited_other: "{{count, number}} r\xf4les machine \xe0 machine",
        unlimited: "Unlimited machine to machine roles",
        not_eligible: "Remove your machine to machine roles"
    },
    scopes_per_role_limit: {
        name: "Permissions de r\xf4le",
        limited: "{{count, number}} permission par r\xf4le",
        limited_other: "{{count, number}} permissions par r\xf4le",
        unlimited: "Illimit\xe9 permission par r\xf4le",
        not_eligible: "Supprimez vos permissions de r\xf4le"
    },
    hooks_limit: {
        name: "Webhooks",
        limited: "{{count, number}} webhook",
        limited_other: "{{count, number}} webhooks",
        unlimited: "Webhooks illimit\xe9s",
        not_eligible: "Supprimez vos webhooks"
    },
    organizations_enabled: {
        name: "Organisations",
        limited: "Organisations",
        unlimited: "Organisations",
        not_eligible: "Remove your organizations"
    },
    audit_logs_retention_days: {
        name: "Conservation des journaux d'audit",
        limited: "Conservation des journaux d'audit: {{count, number}} jour",
        limited_other: "Conservation des journaux d'audit: {{count, number}} jours",
        unlimited: "Jours illimit\xe9s",
        not_eligible: "Pas de journalisation d'audit"
    },
    email_ticket_support: {
        name: "Assistance par ticket de messagerie \xe9lectronique",
        limited: "{{count, number}} heure d'assistance par ticket de messagerie \xe9lectronique",
        limited_other: "{{count, number}} heures d'assistance par ticket de messagerie \xe9lectronique",
        unlimited: "Assistance par ticket de messagerie \xe9lectronique",
        not_eligible: "Aucune assistance par ticket de messagerie \xe9lectronique"
    },
    mfa_enabled: {
        name: "Authentification \xe0 deux facteurs",
        limited: "Authentification \xe0 deux facteurs",
        unlimited: "Authentification \xe0 deux facteurs",
        not_eligible: "Supprimez votre authentification \xe0 deux facteurs"
    },
    sso_enabled: {
        name: "SSO Entreprise",
        limited: "SSO Entreprise",
        unlimited: "SSO Entreprise",
        not_eligible: "Supprimez votre SSO Entreprise"
    },
    tenant_members_limit: {
        name: "Membres du locataires",
        limited: "{{count, number}} membre du locataire",
        limited_other: "{{count, number}} membres du locataire",
        unlimited: "Unlimited tenant members",
        not_eligible: "Remove your tenant members"
    },
    custom_jwt_enabled: {
        name: "JWT personnalis\xe9",
        limited: "Custom JWT",
        unlimited: "Custom JWT",
        not_eligible: "Remove your JWT claims customizer"
    }
};
var $30f13b10e9bd8f38$export$2e2bcd8739ae039 = Object.freeze($30f13b10e9bd8f38$var$quota_item);


const $9d919291384661e7$var$quota_table = {
    quota: {
        title: "Basiques",
        base_price: "Prix de base",
        mau_limit: "Limite de MAU",
        included_tokens: "Jetons inclus"
    },
    application: {
        title: "Applications",
        total: "Total des applications",
        m2m: "Machine-\xe0-machine",
        third_party: "Applications tierces"
    },
    resource: {
        title: "Ressources API",
        resource_count: "Nombre de ressources",
        scopes_per_resource: "Autorisations par ressource"
    },
    branding: {
        title: "Interface utilisateur et branding",
        custom_domain: "Domaine personnalis\xe9",
        custom_css: "CSS personnalis\xe9",
        app_logo_and_favicon: "Logo et favicon de l'application",
        dark_mode: "Mode sombre",
        i18n: "Internationalisation"
    },
    user_authn: {
        title: "Authentification des utilisateurs",
        omni_sign_in: "Connexion omnicanale",
        password: "Mot de passe",
        passwordless: "Sans mot de passe - Email et SMS",
        email_connector: "Connecteur email",
        sms_connector: "Connecteur SMS",
        social_connectors: "Connecteurs sociaux",
        standard_connectors: "Connecteurs standards",
        built_in_email_connector: "Connecteur email int\xe9gr\xe9",
        mfa: "Authentification multi-facteurs",
        sso: "SSO entreprise",
        adaptive_mfa: "MFA adaptative"
    },
    user_management: {
        title: "Gestion des utilisateurs",
        user_management: "Gestion des utilisateurs",
        roles: "R\xf4les",
        machine_to_machine_roles: "R\xf4les machine-\xe0-machine",
        scopes_per_role: "Autorisations par r\xf4le"
    },
    organizations: {
        title: "Organisation",
        organizations: "Organisations",
        organization: "Organisation",
        organization_count: "Nombre d'organisations",
        allowed_users_per_org: "Utilisateurs par organisation",
        invitation: "Invitation (API de gestion)",
        org_roles: "R\xf4les de l'organisation",
        org_permissions: "Autorisations de l'organisation",
        just_in_time_provisioning: "Fourniture juste-\xe0-temps"
    },
    support: {
        title: "Conformit\xe9 et support",
        community: "Communaut\xe9",
        customer_ticket: "Ticket de support",
        premium: "Premium",
        email_ticket_support: "Support par ticket \xe9lectronique",
        soc2_report: "Rapport SOC2",
        hipaa_or_baa_report: "Rapport HIPAA/BAA"
    },
    developers_and_platform: {
        title: "D\xe9veloppeurs et plateforme",
        hooks: "Webhooks",
        audit_logs_retention: "Conservation des journaux d'audit",
        jwt_claims: "Revendications JWT",
        tenant_members: "Membres du locataire"
    },
    unlimited: "Illimit\xe9",
    contact: "Contact",
    monthly_price: "${{value, number}}/mois",
    days_one: "{{count, number}} jour",
    days_other: "{{count, number}} jours",
    add_on: "Module compl\xe9mentaire",
    tier: "Niveau{{value, number}} :",
    paid_token_limit_tip: "Logto facturera des frais pour les fonctionnalit\xe9s qui d\xe9passent votre limite de quota. Vous pouvez l'utiliser gratuitement jusqu'\xe0 ce que nous commencions \xe0 facturer vers le deuxi\xe8me trimestre 2024. Si vous avez besoin de plus de jetons, veuillez nous contacter. Par d\xe9faut, nous facturons 80 $ par mois pour chaque million de jetons.",
    paid_quota_limit_tip: "Logto ajoutera des frais pour les fonctionnalit\xe9s qui d\xe9passent votre limite de quota. Vous pouvez l'utiliser gratuitement jusqu'\xe0 ce que nous commencions \xe0 facturer vers le deuxi\xe8me trimestre 2024.",
    paid_add_on_feature_tip: "Il s'agit d'une fonctionnalit\xe9 suppl\xe9mentaire. Vous pouvez l'utiliser gratuitement jusqu'\xe0 ce que nous commencions \xe0 facturer vers le deuxi\xe8me trimestre 2024.",
    million: "{{value, number}} million",
    mau_tip: "MAU (utilisateurs actifs mensuels) signifie le nombre d'utilisateurs uniques qui ont \xe9chang\xe9 au moins un jeton avec Logto au cours d'un cycle de facturation.",
    tokens_tip: "Tous types de jetons \xe9mis par Logto, y compris les jetons d'acc\xe8s, les jetons de rafra\xeechissement, etc.",
    mao_tip: "MAO (Organisation active mensuelle) d\xe9signe le nombre d'organisations uniques ayant au moins un MAU (utilisateur actif mensuel) au cours d'un cycle de facturation.",
    third_party_tip: "Utilisez Logto comme votre fournisseur d'identit\xe9 OIDC pour les connexions et les autorisations des applications tierces.",
    included: "{{value, number}} inclus",
    included_mao: "{{value, number}} MAO inclus",
    extra_quota_price: "Ensuite ${{value, number}} par mois / chacun apr\xe8s",
    per_month_each: "${{value, number}} par mois / chacun",
    extra_mao_price: "Ensuite ${{value, number}} par MAO",
    per_month: "${{value, number}} par mois",
    per_member: "Ensuite ${{value, number}} par membre"
};
var $9d919291384661e7$export$2e2bcd8739ae039 = Object.freeze($9d919291384661e7$var$quota_table);


const $fe0990db253243f4$var$subscription = {
    free_plan: "Plan Gratuit",
    free_plan_description: "Pour les projets secondaires et les premiers essais de Logto. Aucune carte de cr\xe9dit.",
    pro_plan: "Plan Professionnel",
    pro_plan_description: "Pour les entreprises qui b\xe9n\xe9ficient de Logto sans soucis.",
    enterprise: "Entreprise",
    current_plan: "Plan Actuel",
    current_plan_description: "Voici votre plan actuel. Vous pouvez facilement consulter l'utilisation de votre plan, v\xe9rifier votre prochaine facture et apporter des modifications \xe0 votre plan si n\xe9cessaire.",
    plan_usage: "Utilisation du plan",
    plan_cycle: "Cycle du plan: {{period}}. L'utilisation est renouvel\xe9e le {{renewDate}}.",
    next_bill: "Votre prochaine facture",
    next_bill_hint: "Pour en savoir plus sur le calcul, veuillez vous r\xe9f\xe9rer \xe0 cet <a>article</a>.",
    next_bill_tip: "Les prix affich\xe9s ici n'incluent pas les taxes. Le montant des taxes sera calcul\xe9 en fonction des informations que vous fournissez et des exigences r\xe9glementaires locales, et sera indiqu\xe9 sur vos factures.",
    manage_payment: "G\xe9rer le Paiement",
    overfill_quota_warning: "Vous avez atteint votre limite de quota. Pour \xe9viter tout probl\xe8me, passez \xe0 un plan sup\xe9rieur.",
    upgrade_pro: "Passer au Plan Professionnel",
    update_payment: "Mettre \xe0 jour le paiement",
    payment_error: "Probl\xe8me de paiement d\xe9tect\xe9. Impossible de traiter ${{price, number}} pour le cycle pr\xe9c\xe9dent. Mettez \xe0 jour le paiement pour \xe9viter la suspension du service Logto.",
    downgrade: "Passer \xe0 un Plan Inf\xe9rieur",
    current: "Actuel",
    upgrade: "Mettre \xe0 niveau",
    quota_table: $9d919291384661e7$export$2e2bcd8739ae039,
    billing_history: {
        invoice_column: "Factures",
        status_column: "Statut",
        amount_column: "Montant",
        invoice_created_date_column: "Date de cr\xe9ation de la facture",
        invoice_status: {
            void: "Annul\xe9e",
            paid: "Pay\xe9e",
            open: "Ouverte",
            uncollectible: "En souffrance"
        }
    },
    quota_item: $30f13b10e9bd8f38$export$2e2bcd8739ae039,
    downgrade_modal: {
        title: "\xcates-vous s\xfbr de vouloir passer \xe0 un Plan Inf\xe9rieur?",
        description: "Si vous choisissez de passer au <targetName/> , notez que vous n'aurez plus acc\xe8s aux quotas et fonctionnalit\xe9s qui se trouvaient auparavant dans <currentName/>. ",
        before: "Avant: <name/>",
        after: "Apr\xe8s: <name />",
        downgrade: "Passer \xe0 un Plan Inf\xe9rieur"
    },
    not_eligible_modal: {
        downgrade_title: "Vous n'\xeates pas \xe9ligible pour une r\xe9trogradation",
        downgrade_description: "Assurez-vous de remplir les crit\xe8res suivants avant de r\xe9trograder vers le plan <name/>.",
        downgrade_help_tip: "Besoin d'aide pour r\xe9trograder ? <a>Contactez-nous</a>.",
        upgrade_title: "Rappel amical pour nos pr\xe9cieux early adopters",
        upgrade_description: "Vous utilisez actuellement plus que ce que <name /> autorise. Logto est d\xe9sormais officiel, avec des fonctionnalit\xe9s adapt\xe9es \xe0 chaque plan. Avant de envisager une mise \xe0 niveau vers <name />, assurez-vous de remplir les crit\xe8res suivants avant de faire la mise \xe0 niveau.",
        upgrade_pro_tip: " Ou envisagez de passer au Plan Pro.",
        upgrade_help_tip: "Besoin d'aide pour la mise \xe0 niveau ? <a>Contactez-nous</a>.",
        a_maximum_of: "Un maximum de <item/>"
    },
    upgrade_success: "Pass\xe9 avec succ\xe8s \xe0 <name/>",
    downgrade_success: "R\xe9trograd\xe9 avec succ\xe8s \xe0 <name/>",
    subscription_check_timeout: "La v\xe9rification d'abonnement a expir\xe9. Veuillez actualiser ult\xe9rieurement.",
    no_subscription: "Aucun abonnement"
};
var $fe0990db253243f4$export$2e2bcd8739ae039 = Object.freeze($fe0990db253243f4$var$subscription);


const $6d747864ac9f0942$var$tab_sections = {
    overview: "Vue d'ensemble",
    authentication: "Authentification",
    authorization: "Autorisation",
    users: "Utilisateurs",
    developer: "D\xe9veloppeur",
    tenant: "Locataire"
};
var $6d747864ac9f0942$export$2e2bcd8739ae039 = Object.freeze($6d747864ac9f0942$var$tab_sections);


const $b7dc96d9cce8be40$var$tabs = {
    get_started: "Commencez",
    dashboard: "Tableau de bord",
    applications: "Applications",
    api_resources: "Ressources API",
    sign_in_experience: "Exp\xe9rience de connexion",
    connectors: "Connecteurs",
    enterprise_sso: "SSO d'entreprise",
    webhooks: "Webhooks",
    organizations: "Organisations",
    users: "Gestion des utilisateurs",
    audit_logs: "Journaux d'audit",
    roles: "R\xf4les",
    docs: "Documentation",
    tenant_settings: "Param\xe8tres du locataire",
    mfa: "Authentification multi-facteur",
    customize_jwt: "Personnaliser JWT",
    signing_keys: "Cl\xe9s de signature",
    organization_template: "Mod\xe8le d'organisation"
};
var $b7dc96d9cce8be40$export$2e2bcd8739ae039 = Object.freeze($b7dc96d9cce8be40$var$tabs);


const $98035f095c152f14$var$tenant_members = {
    members: "Membres",
    invitations: "Invitations",
    invite_members: "Inviter des membres",
    user: "Utilisateur",
    roles: "R\xf4les",
    admin: "Administrateur",
    collaborator: "Collaborateur",
    invitation_status: "Statut de l'invitation",
    inviter: "Invitant",
    expiration_date: "Date d'expiration",
    invite_modal: {
        title: "Inviter des personnes \xe0 Logto Cloud",
        subtitle: "Pour inviter des membres \xe0 une organisation, ils doivent accepter l'invitation.",
        to: "\xc0",
        added_as: "Ajout\xe9 en tant que r\xf4les",
        email_input_placeholder: "johndoe@example.com"
    },
    invitation_statuses: {
        pending: "En attente",
        accepted: "Accept\xe9",
        expired: "Expir\xe9",
        revoked: "R\xe9voqu\xe9"
    },
    invitation_empty_placeholder: {
        title: "Inviter des membres d'\xe9quipe",
        description: "Votre locataire n'a actuellement aucun membre invit\xe9.\nPour aider \xe0 votre int\xe9gration, envisagez d'ajouter plus de membres ou d'administrateurs."
    },
    menu_options: {
        edit: "Modifier le r\xf4le de l'utilisateur",
        delete: "Supprimer l'utilisateur du locataire",
        resend_invite: "Renvoyer l'invitation",
        revoke: "R\xe9voquer l'invitation",
        delete_invitation_record: "Supprimer cet enregistrement d'invitation"
    },
    edit_modal: {
        title: "Modifier les r\xf4les de {{name}}"
    },
    delete_user_confirm: "\xcates-vous s\xfbr de vouloir supprimer cet utilisateur de ce locataire?",
    assign_admin_confirm: "\xcates-vous s\xfbr de vouloir rendre le(s) utilisateur(s) s\xe9lectionn\xe9(s) administrateur? Accorder l'acc\xe8s administrateur donnera au(x) utilisateur(s) les autorisations suivantes.<ul><li>Modifier le plan de facturation du locataire</li><li>Ajouter ou supprimer des collaborateurs</li><li>Supprimer le locataire</li></ul>",
    revoke_invitation_confirm: "\xcates-vous s\xfbr de vouloir r\xe9voquer cette invitation?",
    delete_invitation_confirm: "\xcates-vous s\xfbr de vouloir supprimer cet enregistrement d'invitation?",
    messages: {
        invitation_sent: "Invitation envoy\xe9e.",
        invitation_revoked: "Invitation r\xe9voqu\xe9e.",
        invitation_resend: "Invitation renvoy\xe9e.",
        invitation_deleted: "Enregistrement de l'invitation supprim\xe9."
    },
    errors: {
        email_required: "L'adresse e-mail de l'invit\xe9 est requise.",
        email_exists: "L'adresse e-mail existe d\xe9j\xe0.",
        member_exists: "Cet utilisateur est d\xe9j\xe0 membre de cette organisation.",
        pending_invitation_exists: "Une invitation en attente existe. Supprimez l'e-mail associ\xe9 ou r\xe9voquez l'invitation.",
        invalid_email: "L'adresse e-mail est invalide. Veuillez vous assurer qu'elle est dans le bon format.",
        max_member_limit: "Vous avez atteint le nombre maximum de membres ({{limit}}) pour ce locataire."
    }
};
var $98035f095c152f14$export$2e2bcd8739ae039 = Object.freeze($98035f095c152f14$var$tenant_members);


const $870cdbf97ab76626$var$tenants = {
    title: "Param\xe8tres",
    description: "G\xe9rez efficacement les param\xe8tres du locataire et personnalisez votre domaine.",
    tabs: {
        settings: "Param\xe8tres",
        members: "Membres",
        domains: "Domaines",
        subscription: "Plan et facturation",
        billing_history: "Historique de facturation"
    },
    settings: {
        title: "PARAM\xc8TRES",
        description: "D\xe9finissez le nom du locataire et consultez la r\xe9gion d'h\xe9bergement de vos donn\xe9es et le type de locataire.",
        tenant_id: "ID du locataire",
        tenant_name: "Nom du locataire",
        tenant_region: "R\xe9gion d'h\xe9bergement des donn\xe9es",
        tenant_region_tip: "Vos ressources de locataire sont h\xe9berg\xe9es dans {{region}}. <a>En savoir plus</a>",
        environment_tag_development: "Dev",
        environment_tag_production: "Prod",
        tenant_type: "Type de locataire",
        development_description: "Uniquement pour les tests et ne devrait pas \xeatre utilis\xe9 en production. Aucune souscription n'est requise. Il poss\xe8de toutes les fonctionnalit\xe9s Pro mais pr\xe9sente des limitations telles qu'une banni\xe8re de connexion. <a>En savoir plus</a>",
        production_description: "Destin\xe9 aux applications utilis\xe9es par les utilisateurs finaux et pouvant n\xe9cessiter une souscription payante. <a>En savoir plus</a>",
        tenant_info_saved: "Les informations du locataire ont \xe9t\xe9 enregistr\xe9es avec succ\xe8s."
    },
    full_env_tag: {
        development: "D\xe9veloppement",
        production: "Production"
    },
    deletion_card: {
        title: "SUPPRIMER",
        tenant_deletion: "Supprimer le locataire",
        tenant_deletion_description: "La suppression du locataire entra\xeenera la suppression permanente de toutes les donn\xe9es utilisateur et configurations associ\xe9es. Veuillez proc\xe9der avec prudence.",
        tenant_deletion_button: "Supprimer le locataire"
    },
    leave_tenant_card: {
        title: "QUITTER",
        leave_tenant: "Quitter le locataire",
        leave_tenant_description: "Toutes les ressources du locataire resteront, mais vous n'aurez plus acc\xe8s \xe0 ce locataire.",
        last_admin_note: "Pour quitter ce locataire, assurez-vous qu'au moins un autre membre a le r\xf4le Administrateur."
    },
    create_modal: {
        title: "Cr\xe9er un locataire",
        tenant_usage_purpose: "Dans quel but souhaitez-vous utiliser ce locataire?",
        development_description: "Uniquement pour les tests et ne devrait pas \xeatre utilis\xe9 en production. Aucune souscription n'est requise.",
        development_hint: "Il poss\xe8de toutes les fonctionnalit\xe9s Pro mais pr\xe9sente des limitations telles qu'une banni\xe8re de connexion.",
        production_description: "\xc0 utiliser par les utilisateurs finaux et peut n\xe9cessiter une souscription payante.",
        available_plan: "Plan disponible :",
        create_button: "Cr\xe9er un locataire",
        tenant_name_placeholder: "Mon locataire"
    },
    dev_tenant_migration: {
        title: "Vous pouvez d\xe9sormais essayer nos fonctionnalit\xe9s Pro gratuitement en cr\xe9ant un nouveau \xab locataire de d\xe9veloppement \xbb !",
        affect_title: "Comment cela vous affecte-t-il ?",
        hint_1: "Nous rempla\xe7ons les anciennes <strong>balises d'environnement</strong> par deux nouveaux types de locataires : <strong>\xab D\xe9veloppement \xbb</strong> et <strong>\xab Production \xbb</strong>.",
        hint_2: "Pour garantir une transition sans heurt et un fonctionnement ininterrompu, tous les locataires cr\xe9\xe9s auparavant seront convertis en locataires de type <strong>Production</strong> avec votre pr\xe9c\xe9dente souscription.",
        hint_3: "Ne vous inqui\xe9tez pas, tous vos autres param\xe8tres resteront les m\xeames.",
        about_tenant_type: "\xc0 propos du type de locataire"
    },
    delete_modal: {
        title: "Supprimer le locataire",
        description_line1: '\xcates-vous s\xfbr de vouloir supprimer votre locataire "<span>{{name}}</span>" avec le tag de suffixe d\'environnement "<span>{{tag}}</span>"? Cette action est irr\xe9versible et entra\xeenera la suppression permanente de toutes vos donn\xe9es et informations de locataire.',
        description_line2: "Avant de supprimer le locataire, peut-\xeatre pouvons-nous vous aider. <span><a>Contactez-nous par e-mail</a></span>",
        description_line3: 'Si vous souhaitez continuer, veuillez entrer le nom du locataire "<span>{{name}}</span>" pour confirmer.',
        delete_button: "Supprimer d\xe9finitivement",
        cannot_delete_title: "Impossible de supprimer ce locataire",
        cannot_delete_description: "D\xe9sol\xe9, vous ne pouvez pas supprimer ce locataire pour le moment. Assurez-vous d'\xeatre sur le Plan Gratuit et d'avoir pay\xe9 toutes les factures en cours."
    },
    leave_tenant_modal: {
        description: "\xcates-vous s\xfbr de vouloir quitter ce locataire?",
        leave_button: "Partir"
    },
    tenant_landing_page: {
        title: "Vous n'avez pas encore cr\xe9\xe9 de locataire",
        description: "Pour commencer \xe0 configurer votre projet avec Logto, veuillez cr\xe9er un nouveau locataire. Si vous devez vous d\xe9connecter ou supprimer votre compte, cliquez simplement sur le bouton d'avatar dans le coin sup\xe9rieur droit.",
        create_tenant_button: "Cr\xe9er un locataire"
    },
    status: {
        mau_exceeded: "MAU d\xe9pass\xe9",
        suspended: "Suspendu",
        overdue: "En retard"
    },
    tenant_suspended_page: {
        title: "Locataire suspendu. Contactez-nous pour restaurer l'acc\xe8s.",
        description_1: "Nous regrettons profond\xe9ment de vous informer que votre compte de locataire a \xe9t\xe9 temporairement suspendu en raison d'une utilisation abusive, y compris le d\xe9passement des limites MAU, des paiements en retard ou d'autres actions non autoris\xe9es.",
        description_2: "Si vous avez besoin de clarifications suppl\xe9mentaires, si vous avez des pr\xe9occupations ou si vous souhaitez restaurer la fonctionnalit\xe9 compl\xe8te et d\xe9bloquer vos locataires, n'h\xe9sitez pas \xe0 nous contacter imm\xe9diatement."
    }
};
var $870cdbf97ab76626$export$2e2bcd8739ae039 = Object.freeze($870cdbf97ab76626$var$tenants);


const $9099b554d766dfa6$var$topbar = {
    docs: "Docs",
    help: "Aide"
};
var $9099b554d766dfa6$export$2e2bcd8739ae039 = Object.freeze($9099b554d766dfa6$var$topbar);


const $a9e4d2b28ab9aaf0$var$featured_plan_content = {
    mau: {
        free_plan: "Jusqu'\xe0 {{count, number}} MAU",
        pro_plan: "MAU illimit\xe9s"
    },
    m2m: {
        free_plan: "{{count, number}} machine \xe0 machine",
        pro_plan: "Machine \xe0 machine suppl\xe9mentaire"
    },
    third_party_apps: "IdP pour les applications tierces",
    mfa: "Authentification multi-facteurs",
    sso: "SSO Entreprise",
    role_and_permissions: {
        free_plan: "{{roleCount, number}} r\xf4le et {{permissionCount, number}} permission par r\xf4le",
        pro_plan: "R\xf4les et permissions illimit\xe9s par r\xf4le"
    },
    organizations: "Organisations",
    audit_logs: "Conservation des journaux d'audit: {{count, number}} jours"
};
var $a9e4d2b28ab9aaf0$export$2e2bcd8739ae039 = Object.freeze($a9e4d2b28ab9aaf0$var$featured_plan_content);


const $cb1cf8bbb33d052a$var$paywall = {
    applications: "Limite de {{count, number}} application de <planName/> atteinte. Mettez \xe0 niveau le plan pour r\xe9pondre aux besoins de votre \xe9quipe. Pour toute assistance, n'h\xe9sitez pas \xe0 <a>nous contacter</a>.",
    applications_other: "Limite de {{count, number}} applications de <planName/> atteinte. Mettez \xe0 niveau le plan pour r\xe9pondre aux besoins de votre \xe9quipe. Pour toute assistance, n'h\xe9sitez pas \xe0 <a>nous contacter</a>.",
    machine_to_machine_feature: "Passez au plan <strong>Pro</strong> pour obtenir des applications machine \xe0 machine suppl\xe9mentaires et profiter de toutes les fonctionnalit\xe9s premium. <a>Contactez-nous</a> si vous avez des questions.",
    machine_to_machine: "Limite de {{count, number}} application de machine \xe0 machine de <planName/> atteinte. Mettez \xe0 niveau le plan pour r\xe9pondre aux besoins de votre \xe9quipe. Pour toute assistance, n'h\xe9sitez pas \xe0 <a>nous contacter</a>.",
    machine_to_machine_other: "Limite de {{count, number}} applications de machine \xe0 machine de <planName/> atteinte. Mettez \xe0 niveau le plan pour r\xe9pondre aux besoins de votre \xe9quipe. Pour toute assistance, n'h\xe9sitez pas \xe0 <a>nous contacter</a>.",
    resources: "Vous avez atteint la limite de {{count, number}} ressource API de <planName/>. Mettez \xe0 niveau votre plan pour r\xe9pondre aux besoins de votre \xe9quipe. <a>Contactez-nous</a> pour toute assistance.",
    resources_other: "Vous avez atteint la limite de {{count, number}} ressources API de <planName/>. Mettez \xe0 niveau votre plan pour r\xe9pondre aux besoins de votre \xe9quipe. <a>Contactez-nous</a> pour toute assistance.",
    scopes_per_resource: "Vous avez atteint la limite de {{count, number}} permission par ressource API de <planName/>. Mettez \xe0 niveau maintenant pour \xe9tendre. <a>Contactez-nous</a> pour toute assistance.",
    scopes_per_resource_other: "Vous avez atteint la limite de {{count, number}} permissions par ressource API de <planName/>. Mettez \xe0 niveau maintenant pour \xe9tendre. <a>Contactez-nous</a> pour toute assistance.",
    custom_domain: "D\xe9bloquez la fonctionnalit\xe9 de domaine personnalis\xe9 en mettant \xe0 niveau vers les plans <strong>Hobby</strong> ou <strong>Pro</strong>. N'h\xe9sitez pas \xe0 <a>nous contacter</a> si vous avez besoin d'assistance.",
    social_connectors: "Vous avez atteint la limite de {{count, number}} connecteur social de <planName/>. Pour r\xe9pondre aux besoins de votre \xe9quipe, passez \xe0 un plan sup\xe9rieur pour obtenir des connecteurs sociaux suppl\xe9mentaires et la possibilit\xe9 de cr\xe9er vos propres connecteurs en utilisant les protocoles OIDC, OAuth 2.0 et SAML. N’h\xe9sitez pas \xe0 <a>nous contacter</a> si vous avez besoin d'aide.",
    social_connectors_other: "Vous avez atteint la limite de {{count, number}} connecteurs sociaux de <planName/>. Pour r\xe9pondre aux besoins de votre \xe9quipe, passez \xe0 un plan sup\xe9rieur pour obtenir des connecteurs sociaux suppl\xe9mentaires et la possibilit\xe9 de cr\xe9er vos propres connecteurs en utilisant les protocoles OIDC, OAuth 2.0 et SAML. N’h\xe9sitez pas \xe0 <a>nous contacter</a> si vous avez besoin d'aide.",
    standard_connectors_feature: "Mettez \xe0 niveau vers les plans <strong>Hobby</strong> ou <strong>Pro</strong> pour cr\xe9er vos propres connecteurs en utilisant les protocoles OIDC, OAuth 2.0 et SAML, plus des connecteurs sociaux illimit\xe9s et toutes les fonctionnalit\xe9s premium. N’h\xe9sitez pas \xe0 <a>nous contacter</a> si vous avez besoin d'aide.",
    standard_connectors: "Vous avez atteint la limite de {{count, number}} connecteur social de <planName/>. Pour r\xe9pondre aux besoins de votre \xe9quipe, passez \xe0 un plan sup\xe9rieur pour obtenir des connecteurs sociaux suppl\xe9mentaires et la possibilit\xe9 de cr\xe9er vos propres connecteurs en utilisant les protocoles OIDC, OAuth 2.0 et SAML. N’h\xe9sitez pas \xe0 <a>nous contacter</a> si vous avez besoin d'aide.",
    standard_connectors_other: "Vous avez atteint la limite de {{count, number}} connecteurs sociaux de <planName/>. Pour r\xe9pondre aux besoins de votre \xe9quipe, passez \xe0 un plan sup\xe9rieur pour obtenir des connecteurs sociaux suppl\xe9mentaires et la possibilit\xe9 de cr\xe9er vos propres connecteurs en utilisant les protocoles OIDC, OAuth 2.0 et SAML. N’h\xe9sitez pas \xe0 <a>nous contacter</a> si vous avez besoin d'aide.",
    standard_connectors_pro: "Vous avez atteint la limite de {{count, number}} connecteur standard de <planName/>. Pour r\xe9pondre aux besoins de votre \xe9quipe, passez au plan Entreprise pour obtenir des connecteurs sociaux suppl\xe9mentaires et la possibilit\xe9 de cr\xe9er vos propres connecteurs en utilisant les protocoles OIDC, OAuth 2.0 et SAML. N’h\xe9sitez pas \xe0 <a>nous contacter</a> si vous avez besoin d'aide.",
    standard_connectors_pro_other: "Vous avez atteint la limite de {{count, number}} connecteurs standard de <planName/>. Pour r\xe9pondre aux besoins de votre \xe9quipe, passez au plan Entreprise pour obtenir des connecteurs sociaux suppl\xe9mentaires et la possibilit\xe9 de cr\xe9er vos propres connecteurs en utilisant les protocoles OIDC, OAuth 2.0 et SAML. N’h\xe9sitez pas \xe0 <a>nous contacter</a> si vous avez besoin d'aide.",
    roles: "Vous avez atteint la limite de {{count, number}} r\xf4le de <planName/>. Mettez \xe0 niveau votre plan pour ajouter des r\xf4les et des permissions suppl\xe9mentaires. N’h\xe9sitez pas \xe0 <a>nous contacter</a> si vous avez besoin d'aide.",
    roles_other: "Vous avez atteint la limite de {{count, number}} r\xf4les de <planName/>. Mettez \xe0 niveau votre plan pour ajouter des r\xf4les et des permissions suppl\xe9mentaires. N’h\xe9sitez pas \xe0 <a>nous contacter</a> si vous avez besoin d'aide.",
    machine_to_machine_roles: "{{count, number}} r\xf4le machine \xe0 machine de <planName/> atteint la limite. Mettez \xe0 niveau le plan pour ajouter des r\xf4les et des permissions suppl\xe9mentaires. N’h\xe9sitez pas \xe0 <a>nous contacter</a> si vous avez besoin d'aide.",
    machine_to_machine_roles_other: "{{count, number}} r\xf4les machine \xe0 machine de <planName/> atteints la limite. Mettez \xe0 niveau le plan pour ajouter des r\xf4les et des permissions suppl\xe9mentaires. N’h\xe9sitez pas \xe0 <a>nous contacter</a> si vous avez besoin d'aide.",
    scopes_per_role: "Vous avez atteint la limite de {{count, number}} permission par r\xf4le de <planName/>. Mettez \xe0 niveau votre plan pour ajouter des r\xf4les et des permissions suppl\xe9mentaires. Pour toute assistance, n’h\xe9sitez pas \xe0 <a>nous contacter</a>.",
    scopes_per_role_other: "Vous avez atteint la limite de {{count, number}} permissions par r\xf4le de <planName/>. Mettez \xe0 niveau votre plan pour ajouter des r\xf4les et des permissions suppl\xe9mentaires. Pour toute assistance, n’h\xe9sitez pas \xe0 <a>nous contacter</a>.",
    hooks: "Vous avez atteint la limite de {{count, number}} webhook de <planName/>. Mettez \xe0 niveau votre plan pour cr\xe9er plus de webhooks. N’h\xe9sitez pas \xe0 <a>nous contacter</a> si vous avez besoin d'aide.",
    hooks_other: "Vous avez atteint la limite de {{count, number}} webhooks de <planName/>. Mettez \xe0 niveau votre plan pour cr\xe9er plus de webhooks. N'h\xe9sitez pas \xe0 <a>nous contacter</a> si vous avez besoin d'aide.",
    mfa: "D\xe9verrouillez MFA pour v\xe9rifier la s\xe9curit\xe9 en passant \xe0 un plan payant. N'h\xe9sitez pas \xe0 <a>nous contacter</a> si vous avez besoin d'aide.",
    organizations: "D\xe9bloquez les organisations en passant \xe0 un plan payant. N’h\xe9sitez pas \xe0 <a>nous contacter</a> si vous avez besoin d'aide.",
    third_party_apps: "Unlock Logto as IdP for third-party apps by upgrading to a paid plan. For any assistance, feel free to <a>contact us</a>.",
    sso_connectors: "Unlock enterprise sso by upgrading to a paid plan. For any assistance, feel free to <a>contact us</a>.",
    tenant_members: "Unlock collaboration feature by upgrading to a paid plan. For any assistance, feel free to <a>contact us</a>.",
    tenant_members_dev_plan: "You've reached your {{limit}}-member limit. Release a member or revoke a pending invitation to add someone new. Need more seats? Feel free to contact us.",
    custom_jwt: {
        title: "Add custom claims",
        description: "Upgrade to a paid plan for custom JWT functionality and premium benefits. Don't hesitate to <a>contact us</a> if you have any questions."
    }
};
var $cb1cf8bbb33d052a$export$2e2bcd8739ae039 = Object.freeze($cb1cf8bbb33d052a$var$paywall);


const $181b5ad04611ad61$var$upsell = {
    upgrade_plan: "Mettre \xe0 niveau le plan",
    compare_plans: "Comparer les plans",
    view_plans: "Voir les plans",
    create_tenant: {
        title: "S\xe9lectionnez votre plan pour le locataire",
        description: "Logto propose des options de plan comp\xe9titives avec une tarification innovante et abordable con\xe7ue pour les entreprises en croissance. <a>En savoir plus</a>",
        base_price: "Prix de base",
        monthly_price: "{{value, number}}/mois",
        view_all_features: "Voir toutes les fonctionnalit\xe9s",
        select_plan: "S\xe9lectionnez <name/>",
        free_tenants_limit: "Jusqu'\xe0 {{count, number}} locataire gratuit",
        free_tenants_limit_other: "Jusqu'\xe0 {{count, number}} locataires gratuits",
        most_popular: "Le plus populaire",
        upgrade_success: "Passage r\xe9ussi \xe0 <name/>"
    },
    mau_exceeded_modal: {
        title: "La limite de MAU a \xe9t\xe9 d\xe9pass\xe9e. Mettez \xe0 niveau votre plan.",
        notification: "Votre MAU actuel a d\xe9pass\xe9 la limite de <planName/>. Veuillez mettre \xe0 niveau votre plan pour passer \xe0 la version premium rapidement et \xe9viter la suspension du service Logto.",
        update_plan: "Mettre \xe0 jour le plan"
    },
    payment_overdue_modal: {
        title: "Paiement de facture en retard",
        notification: "Oups ! Le paiement de la facture du locataire <span>{{name}}</span> a \xe9chou\xe9. Veuillez payer la facture rapidement pour \xe9viter la suspension du service Logto.",
        unpaid_bills: "Factures impay\xe9es",
        update_payment: "Mettre \xe0 jour le paiement"
    },
    add_on_quota_item: {
        api_resource: "Ressource API",
        machine_to_machine: "application machine \xe0 machine",
        tokens: "{{limit}}M jetons",
        tenant_member: "membre du locataire"
    },
    charge_notification_for_quota_limit: "Vous avez d\xe9pass\xe9 votre limite de quota {{item}}. Logto ajoutera des frais pour l'utilisation au-del\xe0 de votre limite de quota. La facturation commencera le jour de la publication du nouveau design tarifaire de l'extension. <a>En savoir plus</a>",
    paywall: $cb1cf8bbb33d052a$export$2e2bcd8739ae039,
    featured_plan_content: $a9e4d2b28ab9aaf0$export$2e2bcd8739ae039
};
var $181b5ad04611ad61$export$2e2bcd8739ae039 = Object.freeze($181b5ad04611ad61$var$upsell);


const $6955bf6d2c607d18$var$user_details = {
    page_title: "D\xe9tails de l'utilisateur",
    back_to_users: "Retour \xe0 la gestion des utilisateurs",
    created_title: "Cet utilisateur a \xe9t\xe9 cr\xe9\xe9 avec succ\xe8s",
    created_guide: "Voici les informations pour aider l'utilisateur \xe0 se connecter.",
    created_email: "Adresse email :",
    created_phone: "Num\xe9ro de t\xe9l\xe9phone :",
    created_username: "Nom d'utilisateur :",
    created_password: "Mot de passe :",
    menu_delete: "Supprimer",
    delete_description: "Cette action ne peut \xeatre annul\xe9e. Elle supprimera d\xe9finitivement l'utilisateur.",
    deleted: "L'utilisateur a \xe9t\xe9 supprim\xe9 avec succ\xe8s",
    reset_password: {
        reset_password: "R\xe9initialiser le mot de passe",
        title: "\xcates-vous s\xfbr de vouloir r\xe9initialiser le mot de passe ?",
        content: "Cette action ne peut \xeatre annul\xe9e. Cette action r\xe9initialisera les informations de connexion de l'utilisateur.",
        congratulations: "Cet utilisateur a \xe9t\xe9 r\xe9initialis\xe9",
        new_password: "Nouveau mot de passe :"
    },
    tab_settings: "Param\xe8tres",
    tab_roles: "R\xf4les",
    tab_logs: "Journaux de l'utilisateur",
    tab_organizations: "Organisations",
    authentication: "Authentification",
    authentication_description: "Chaque utilisateur poss\xe8de un profil contenant toutes les informations le concernant. Il se compose de donn\xe9es de base, d'identit\xe9s sociales et de donn\xe9es personnalis\xe9es.",
    user_profile: "Profil utilisateur",
    field_email: "Adresse e-mail",
    field_phone: "Num\xe9ro de t\xe9l\xe9phone",
    field_username: "Nom d'utilisateur",
    field_name: "Nom",
    field_avatar: "URL de l'image avatar",
    field_avatar_placeholder: "https://votre.domaine.cdn/avatar.png",
    field_custom_data: "Donn\xe9es personnalis\xe9es",
    field_custom_data_tip: "Informations suppl\xe9mentaires sur l'utilisateur qui ne figurent pas dans les propri\xe9t\xe9s pr\xe9d\xe9finies de l'utilisateur, telles que la couleur et la langue pr\xe9f\xe9r\xe9es de l'utilisateur.",
    field_connectors: "Connecteurs sociaux",
    field_sso_connectors: "Connexions d'entreprise",
    custom_data_invalid: "Les donn\xe9es personnalis\xe9es doivent \xeatre un objet JSON valide.",
    connectors: {
        connectors: "Connecteurs",
        user_id: "ID utilisateur",
        remove: "Supprimer",
        connected: "Cet utilisateur est connect\xe9 \xe0 plusieurs connecteurs sociaux.",
        not_connected: "L'utilisateur n'est connect\xe9 \xe0 aucun connecteur social.",
        deletion_confirmation: "Vous supprimez l'identit\xe9 existante <name/>. \xcates-vous s\xfbr de vouloir continuer ?"
    },
    sso_connectors: {
        connectors: "Connecteurs",
        enterprise_id: "ID de l'entreprise",
        connected: "Cet utilisateur est connect\xe9 \xe0 plusieurs fournisseurs d'identit\xe9 d'entreprise pour l'authentification unique.",
        not_connected: "L'utilisateur n'est connect\xe9 \xe0 aucun fournisseur d'identit\xe9 d'entreprise pour l'authentification unique."
    },
    mfa: {
        field_name: "Authentification \xe0 deux facteurs",
        field_description: "Cet utilisateur a activ\xe9 des facteurs d'authentification \xe0 2 \xe9tapes.",
        name_column: "Authentification \xe0 deux facteurs",
        field_description_empty: "Cet utilisateur n'a pas activ\xe9 les facteurs d'authentification \xe0 deux \xe9tapes.",
        deletion_confirmation: "Vous supprimez l'existence actuelle de <name/> pour la v\xe9rification en deux \xe9tapes. \xcates-vous s\xfbr(e) de vouloir continuer?"
    },
    suspended: "Suspendu",
    suspend_user: "Suspendre l'utilisateur",
    suspend_user_reminder: "\xcates-vous s\xfbr de vouloir suspendre cet utilisateur ? L'utilisateur ne pourra pas se connecter \xe0 votre application et ne pourra pas obtenir de nouveau jeton d'acc\xe8s apr\xe8s l'expiration de celui en cours. En outre, toutes les demandes d'API effectu\xe9es par cet utilisateur \xe9choueront.",
    suspend_action: "Suspendre",
    user_suspended: "L'utilisateur a \xe9t\xe9 suspendu.",
    reactivate_user: "R\xe9activer l'utilisateur",
    reactivate_user_reminder: "\xcates-vous s\xfbr de vouloir r\xe9activer cet utilisateur ? Cela permettra toute tentative de connexion pour cet utilisateur.",
    reactivate_action: "R\xe9activer",
    user_reactivated: "L'utilisateur a \xe9t\xe9 r\xe9activ\xe9.",
    roles: {
        name_column: "R\xf4le",
        description_column: "Description",
        assign_button: "Attribuer des r\xf4les",
        delete_description: "Cette action supprimera ce r\xf4le de cet utilisateur. Le r\xf4le lui-m\xeame existera toujours, mais il ne sera plus associ\xe9 \xe0 cet utilisateur.",
        deleted: "{{name}} a \xe9t\xe9 retir\xe9 de cet utilisateur.",
        assign_title: "Attribuer des r\xf4les \xe0 {{name}}",
        assign_subtitle: "Autoriser {{name}} un ou plusieurs r\xf4les",
        assign_role_field: "Attribuer des r\xf4les",
        role_search_placeholder: "Recherche par nom de r\xf4le",
        added_text: "{{value, number}} ajout\xe9",
        assigned_user_count: "{{value, number}} utilisateurs",
        confirm_assign: "Attribuer des r\xf4les",
        role_assigned: "R\xf4le(s) attribu\xe9(s) avec succ\xe8s",
        search: "Recherche par nom de r\xf4le, description ou ID",
        empty: "Aucun r\xf4le disponible"
    },
    warning_no_sign_in_identifier: "L'utilisateur doit avoir au moins l'un des identifiants de connexion (nom d'utilisateur, e-mail, num\xe9ro de t\xe9l\xe9phone ou compte social) pour se connecter. \xcates-vous s\xfbr(e) de vouloir continuer?",
    organization_roles_tooltip: "Les r\xf4les attribu\xe9s \xe0 l'utilisateur au sein de cette organisation."
};
var $6955bf6d2c607d18$export$2e2bcd8739ae039 = Object.freeze($6955bf6d2c607d18$var$user_details);


const $a2637ad8a54dda1f$var$users = {
    page_title: "Gestion des utilisateurs",
    title: "Gestion des utilisateurs",
    subtitle: "G\xe9rer les identit\xe9s des utilisateurs, y compris la cr\xe9ation d'utilisateurs, la modification des informations sur les utilisateurs, la consultation des journaux des utilisateurs, la r\xe9initialisation des mots de passe et la suppression des utilisateurs.",
    create: "Ajouter un utilisateur",
    create_subtitle: "Fournir au moins l'un des champs suivants pour continuer.",
    error_missing_identifier: "Vous devez saisir au moins un identifiant pour cr\xe9er un utilisateur.",
    user_name: "Utilisateur",
    application_name: "De l'application",
    latest_sign_in: "Derni\xe8re connexion",
    create_form_username: "Nom d'utilisateur",
    create_form_password: "Mot de passe",
    create_form_name: "Nom complet",
    placeholder_name: "Monsieur/Madame Dupont",
    placeholder_email: "mdupont@example.com",
    placeholder_username: "user123",
    placeholder_phone: "+33 1 23 45 67 89",
    unnamed: "Sans nom",
    search: "Rechercher par nom, email, t\xe9l\xe9phone ou nom d'utilisateur",
    check_user_detail: "V\xe9rifier les d\xe9tails de l'utilisateur",
    placeholder_title: "Gestion des utilisateurs",
    placeholder_description: "Chaque utilisateur a un profil contenant toutes les informations sur l'utilisateur. Il est compos\xe9 de donn\xe9es de base, d'identit\xe9s sociales et de donn\xe9es personnalis\xe9es."
};
var $a2637ad8a54dda1f$export$2e2bcd8739ae039 = Object.freeze($a2637ad8a54dda1f$var$users);


const $9c50cdc29938f447$var$webhook_details = {
    page_title: "D\xe9tails du webhook",
    back_to_webhooks: "Retour aux webhooks",
    not_in_use: "Pas en cours d'utilisation",
    success_rate: "Taux de r\xe9ussite",
    requests: "{{value, number}} requ\xeates en 24h",
    disable_webhook: "D\xe9sactiver le webhook",
    disable_reminder: "\xcates-vous s\xfbr de vouloir r\xe9activer ce webhook? Ceci n'enverra pas de requ\xeate HTTP \xe0 l'URL de l'endpoint.",
    webhook_disabled: "Le webhook a \xe9t\xe9 d\xe9sactiv\xe9.",
    webhook_reactivated: "Le webhook a \xe9t\xe9 r\xe9activ\xe9.",
    reactivate_webhook: "R\xe9activer le webhook",
    delete_webhook: "Supprimer le webhook",
    deletion_reminder: "Vous \xeates en train de supprimer ce webhook. Apr\xe8s suppression, il n'enverra plus de requ\xeate HTTP \xe0 l'endpoint URL.",
    deleted: "Le webhook a \xe9t\xe9 supprim\xe9 avec succ\xe8s.",
    settings_tab: "Param\xe8tres",
    recent_requests_tab: "Demandes r\xe9centes (24 h)",
    settings: {
        settings: "Param\xe8tres",
        settings_description: "Les webhooks vous permettent de recevoir des mises \xe0 jour en temps r\xe9el sur des \xe9v\xe9nements sp\xe9cifiques, en envoyant une requ\xeate POST \xe0 l'URL de votre endpoint. Cela vous permet de prendre des actions imm\xe9diatement en fonction des nouvelles informations re\xe7ues.",
        events: "\xc9v\xe9nements",
        events_description: "S\xe9lectionnez les \xe9v\xe9nements d\xe9clencheurs que Logto enverra la requ\xeate POST.",
        name: "Nom",
        endpoint_url: "URL de l'endpoint",
        signing_key: "Cl\xe9 de signature",
        signing_key_tip: "Ajoutez la cl\xe9 secr\xe8te fournie par Logto \xe0 votre endpoint en tant qu'en-t\xeate de requ\xeate pour garantir l'authenticit\xe9 de la charge utile du webhook.",
        regenerate: "R\xe9g\xe9n\xe9rer",
        regenerate_key_title: "R\xe9g\xe9n\xe9rer la cl\xe9 de signature",
        regenerate_key_reminder: "\xcates-vous s\xfbr de vouloir modifier la cl\xe9 de signature? La r\xe9g\xe9n\xe9ration sera effective imm\xe9diatement. N'oubliez pas de modifier la cl\xe9 de signature synchroniquement dans votre endpoint.",
        regenerated: "La cl\xe9 de signature a \xe9t\xe9 r\xe9g\xe9n\xe9r\xe9e.",
        custom_headers: "En-t\xeates personnalis\xe9s",
        custom_headers_tip: "Optionnellement, vous pouvez ajouter des en-t\xeates personnalis\xe9s \xe0 la charge utile du webhook pour fournir un contexte ou des m\xe9tadonn\xe9es suppl\xe9mentaires sur l'\xe9v\xe9nement.",
        key_duplicated_error: "Les cl\xe9s ne peuvent pas se r\xe9p\xe9ter.",
        key_missing_error: "La cl\xe9 est requise.",
        value_missing_error: "La valeur est requise.",
        invalid_key_error: "Cl\xe9 invalide",
        invalid_value_error: "La valeur est invalide",
        test: "Tester",
        test_webhook: "Tester votre webhook",
        test_webhook_description: "Configurez le webhook, et testez-le avec des exemples de payload pour chaque \xe9v\xe9nement s\xe9lectionn\xe9 pour v\xe9rifier la r\xe9ception et le traitement corrects.",
        send_test_payload: "Envoyer une charge utile de test",
        test_result: {
            endpoint_url: "URL du point de terminaison : {{url}}",
            message: "Message : {{message}}",
            response_status: "Statut de la r\xe9ponse : {{status, number}}",
            response_body: "Corps de la r\xe9ponse : {{body}}",
            request_time: "Temps de la demande : {{time}}",
            test_success: "Le test du webhook vers le point de terminaison a r\xe9ussi."
        }
    }
};
var $9c50cdc29938f447$export$2e2bcd8739ae039 = Object.freeze($9c50cdc29938f447$var$webhook_details);


const $20f5d4a499a5b98e$var$webhooks = {
    page_title: "Webhooks",
    title: "Webhooks",
    subtitle: "Cr\xe9ez des webhooks pour recevoir sans effort des mises \xe0 jour en temps r\xe9el concernant des \xe9v\xe9nements sp\xe9cifiques.",
    create: "Cr\xe9er un webhook",
    schemas: {
        interaction: "Interaction utilisateur",
        user: "Utilisateur",
        organization: "Organisation",
        role: "R\xf4le",
        scope: "Permission",
        organization_role: "R\xf4le de l'organisation",
        organization_scope: "Permission de l'organisation"
    },
    table: {
        name: "Nom",
        events: "\xc9v\xe9nements",
        success_rate: "Taux de r\xe9ussite (24 h)",
        requests: "Demandes (24 h)"
    },
    placeholder: {
        title: "Webhook",
        description: 'Cr\xe9ez un webhook pour recevoir des mises \xe0 jour en temps r\xe9el via des demandes POST vers l\'URL de votre point de terminaison. Restez inform\xe9 et agissez imm\xe9diatement sur des \xe9v\xe9nements tels que "Cr\xe9er un compte", "Se connecter" et "R\xe9initialiser le mot de passe".',
        create_webhook: "Cr\xe9er un webhook"
    },
    create_form: {
        title: "Cr\xe9er un webhook",
        subtitle: "Ajoutez le webhook pour envoyer une demande POST \xe0 l'URL de point de terminaison avec les d\xe9tails de tous les \xe9v\xe9nements des utilisateurs.",
        events: "\xc9v\xe9nements",
        events_description: "S\xe9lectionnez les \xe9v\xe9nements de d\xe9clenchement que Logto enverra la demande POST.",
        name: "Nom",
        name_placeholder: "Entrez le nom du webhook",
        endpoint_url: "URL du point d'extr\xe9mit\xe9",
        endpoint_url_placeholder: "https://votre.url.de.webhook.point.de.terminaison",
        endpoint_url_tip: "Entrez l'URL de votre point de terminaison o\xf9 la charge utile d'un webhook est envoy\xe9e lorsque l'\xe9v\xe9nement se produit.",
        create_webhook: "Cr\xe9er un webhook",
        missing_event_error: "Vous devez s\xe9lectionner au moins un \xe9v\xe9nement."
    },
    webhook_created: "Le webhook {{name}} a \xe9t\xe9 cr\xe9\xe9 avec succ\xe8s."
};
var $20f5d4a499a5b98e$export$2e2bcd8739ae039 = Object.freeze($20f5d4a499a5b98e$var$webhooks);


const $df9c2910f94bb4be$var$welcome = {
    title: "Bienvenue dans la console d'administration",
    description: "La console d'administration est une application web qui permet de g\xe9rer Logto sans avoir \xe0 coder. Commen\xe7ons par cr\xe9er un compte. Avec ce compte, vous pouvez g\xe9rer Logto par vous-m\xeame ou au nom de votre entreprise.",
    create_account: "Cr\xe9er un compte"
};
var $df9c2910f94bb4be$export$2e2bcd8739ae039 = Object.freeze($df9c2910f94bb4be$var$welcome);


const $d5b24edbebb7497a$var$admin_console = {
    title: "Admin Console",
    admin_user: "Admin",
    system_app: "System",
    menu: $6c7d1208b1b4055e$export$2e2bcd8739ae039,
    general: $e97df46329b75237$export$2e2bcd8739ae039,
    errors: $34e4728be94705a1$export$2e2bcd8739ae039,
    tab_sections: $6d747864ac9f0942$export$2e2bcd8739ae039,
    tabs: $b7dc96d9cce8be40$export$2e2bcd8739ae039,
    applications: $7df0b84ef2d52bc3$export$2e2bcd8739ae039,
    application_details: $2b6710c4d360421e$export$2e2bcd8739ae039,
    api_resources: $0ff30d9e7c3716dc$export$2e2bcd8739ae039,
    api_resource_details: $491c09e744855fc4$export$2e2bcd8739ae039,
    connectors: $4a20b40f8fc06de4$export$2e2bcd8739ae039,
    connector_details: $327f435c6480b4a5$export$2e2bcd8739ae039,
    enterprise_sso: $8a876e7a2a25205a$export$2e2bcd8739ae039,
    enterprise_sso_details: $e68446fbbd6dc544$export$2e2bcd8739ae039,
    get_started: $8f379fd654273f4f$export$2e2bcd8739ae039,
    users: $a2637ad8a54dda1f$export$2e2bcd8739ae039,
    user_details: $6955bf6d2c607d18$export$2e2bcd8739ae039,
    contact: $7f0065154772636f$export$2e2bcd8739ae039,
    sign_in_exp: $bfd2c7223b656acc$export$2e2bcd8739ae039,
    dashboard: $c5bca5b7d0e7aa96$export$2e2bcd8739ae039,
    logs: $66c1bccdb61f9148$export$2e2bcd8739ae039,
    log_details: $16c3feeb70eacf17$export$2e2bcd8739ae039,
    session_expired: $014ba2d58d90d48b$export$2e2bcd8739ae039,
    welcome: $df9c2910f94bb4be$export$2e2bcd8739ae039,
    roles: $0aa5f55544aab405$export$2e2bcd8739ae039,
    role_details: $58542fdbf9a508b5$export$2e2bcd8739ae039,
    permissions: $5e3259fe7339543b$export$2e2bcd8739ae039,
    cloud: $cfca5ec3ac841d06$export$2e2bcd8739ae039,
    profile: $4411c296ae06efc2$export$2e2bcd8739ae039,
    components: $5241f87b4d574239$export$2e2bcd8739ae039,
    webhooks: $20f5d4a499a5b98e$export$2e2bcd8739ae039,
    webhook_details: $9c50cdc29938f447$export$2e2bcd8739ae039,
    domain: $18f14001b4bf30ed$export$2e2bcd8739ae039,
    tenants: $870cdbf97ab76626$export$2e2bcd8739ae039,
    tenant_members: $98035f095c152f14$export$2e2bcd8739ae039,
    topbar: $9099b554d766dfa6$export$2e2bcd8739ae039,
    subscription: $fe0990db253243f4$export$2e2bcd8739ae039,
    upsell: $181b5ad04611ad61$export$2e2bcd8739ae039,
    guide: $f138a14e78f0afb1$export$2e2bcd8739ae039,
    mfa: $197f4a31fc615e90$export$2e2bcd8739ae039,
    organizations: $702bb511c8dc4abc$export$2e2bcd8739ae039,
    organization_details: $60133b80d73fa70b$export$2e2bcd8739ae039,
    protected_app: $1e777d4bff003a14$export$2e2bcd8739ae039,
    jwt_claims: $61f69db229179517$export$2e2bcd8739ae039,
    invitation: $0ae81fe1103c4e4b$export$2e2bcd8739ae039,
    signing_keys: $4d884384ac096342$export$2e2bcd8739ae039,
    organization_template: $bec7b610e20b7c30$export$2e2bcd8739ae039,
    organization_role_details: $6f0f0ea1d29d1dda$export$2e2bcd8739ae039
};
var $d5b24edbebb7497a$export$2e2bcd8739ae039 = Object.freeze($d5b24edbebb7497a$var$admin_console);


const $eb7ba85c5f3474c2$var$demo_app = {
    title: "Vous vous \xeates connect\xe9 avec succ\xe8s \xe0 l'aper\xe7u en direct !",
    subtitle: "Voici vos informations de connexion :",
    username: "Nom d'utilisateur :",
    user_id: "ID de l'utilisateur :",
    sign_out: "Se d\xe9connecter de l'aper\xe7u en direct",
    continue_explore: "Ou continuer \xe0 explorer",
    customize_sign_in_experience: "Personnaliser l'exp\xe9rience de connexion",
    enable_passwordless: "Activer la connexion sans mot de passe",
    add_social_connector: "Ajouter un connecteur social"
};
var $eb7ba85c5f3474c2$export$2e2bcd8739ae039 = Object.freeze($eb7ba85c5f3474c2$var$demo_app);


const $b97601ceb0812b3c$var$oidc = {
    logout_success: "Vous vous \xeates d\xe9connect\xe9 avec succ\xe8s."
};
var $b97601ceb0812b3c$export$2e2bcd8739ae039 = Object.freeze($b97601ceb0812b3c$var$oidc);


const $04fd670e97676647$var$translation = {
    admin_console: $d5b24edbebb7497a$export$2e2bcd8739ae039,
    demo_app: $eb7ba85c5f3474c2$export$2e2bcd8739ae039,
    oidc: $b97601ceb0812b3c$export$2e2bcd8739ae039
};
var $04fd670e97676647$export$2e2bcd8739ae039 = Object.freeze($04fd670e97676647$var$translation);


const $4dfc3de6524d3b5b$var$fr = {
    translation: $04fd670e97676647$export$2e2bcd8739ae039,
    errors: $62708cc9c01c0866$export$2e2bcd8739ae039
};
var $4dfc3de6524d3b5b$export$2e2bcd8739ae039 = Object.freeze($4dfc3de6524d3b5b$var$fr);


const $99d76cd6215cdc96$var$application = {
    invalid_type: "Solo le applicazioni da macchina a macchina possono avere ruoli associati.",
    role_exists: "L'ID ruolo {{roleId}} \xe8 gi\xe0 stato aggiunto a questa applicazione.",
    invalid_role_type: "Impossibile assegnare un ruolo di tipo utente all'applicazione da macchina a macchina.",
    invalid_third_party_application_type: "Solo le applicazioni web tradizionali possono essere contrassegnate come applicazione di terze parti.",
    third_party_application_only: "La funzionalit\xe0 \xe8 disponibile solo per le applicazioni di terze parti.",
    user_consent_scopes_not_found: "Scopi di consenso utente non validi.",
    consent_management_api_scopes_not_allowed: "I management API scopes non sono consentiti.",
    protected_app_metadata_is_required: "I metadati dell'applicazione protetta sono obbligatori.",
    protected_app_not_configured: "Il provider dell'applicazione protetta non \xe8 configurato. Questa funzionalit\xe0 non \xe8 disponibile nella versione open source.",
    cloudflare_unknown_error: "Si \xe8 verificato un errore sconosciuto durante la richiesta all'API di Cloudflare",
    protected_application_only: "La funzionalit\xe0 \xe8 disponibile solo per le applicazioni protette.",
    protected_application_misconfigured: "L'applicazione protetta \xe8 configurata in modo errato.",
    protected_application_subdomain_exists: "Il sottodominio dell'applicazione protetta \xe8 gi\xe0 in uso.",
    invalid_subdomain: "Sottodominio non valido.",
    custom_domain_not_found: "Dominio personalizzato non trovato.",
    should_delete_custom_domains_first: "Dovresti eliminare prima i domini personalizzati."
};
var $99d76cd6215cdc96$export$2e2bcd8739ae039 = Object.freeze($99d76cd6215cdc96$var$application);


const $be38a1d51f785fe1$var$auth = {
    authorization_header_missing: "Header Autorizzazione mancante.",
    authorization_token_type_not_supported: "Tipo di autorizzazione non supportato.",
    unauthorized: "Non autorizzato. Controlla le credenziali e il loro ambito.",
    forbidden: "Vietato. Controlla i ruoli e le autorizzazioni dell'utente.",
    expected_role_not_found: "Ruolo atteso non trovato. Controlla i ruoli e le autorizzazioni dell'utente.",
    jwt_sub_missing: "Manca il valore `sub` in JWT.",
    require_re_authentication: "\xc8 necessaria una nuova autenticazione per eseguire un'azione protetta."
};
var $be38a1d51f785fe1$export$2e2bcd8739ae039 = Object.freeze($be38a1d51f785fe1$var$auth);


const $5fc8b38c208197df$var$connector = {
    general: "Si \xe8 verificato un errore nel connettore: {{errorDescription}}",
    not_found: "Impossibile trovare un connettore disponibile per il tipo: {{type}}.",
    not_enabled: "Il connettore non \xe8 abilitato.",
    invalid_metadata: "I metadati del connettore non sono validi.",
    invalid_config_guard: "La guardia di configurazione del connettore non \xe8 valida.",
    unexpected_type: "Il tipo di connettore \xe8 inaspettato.",
    invalid_request_parameters: "La richiesta contiene parametri di input errati.",
    insufficient_request_parameters: "La richiesta potrebbe mancare di alcuni parametri di input.",
    invalid_config: "La configurazione del connettore non \xe8 valida.",
    invalid_certificate: "Il certificato del connettore non \xe8 valido, assicurarsi che il certificato sia codificato in formato PEM.",
    invalid_response: "La risposta del connettore non \xe8 valida.",
    template_not_found: "Impossibile trovare il modello corretto nella configurazione del connettore.",
    template_not_supported: "Il connettore non supporta questo tipo di modello.",
    rate_limit_exceeded: "Limite di frequenza attivato. Riprova pi\xf9 tardi.",
    not_implemented: "{{method}}: non \xe8 stato ancora implementato.",
    social_invalid_access_token: "Il token di accesso del connettore non \xe8 valido.",
    invalid_auth_code: "Il codice di autenticazione del connettore non \xe8 valido.",
    social_invalid_id_token: "Il token ID del connettore non \xe8 valido.",
    authorization_failed: "Il processo di autorizzazione dell'utente non \xe8 riuscito.",
    social_auth_code_invalid: "Impossibile ottenere il token di accesso, controllare il codice di autorizzazione.",
    more_than_one_sms: "Il numero di connettori SMS \xe8 maggiore di 1.",
    more_than_one_email: "Il numero di connettori email \xe8 maggiore di 1.",
    more_than_one_connector_factory: "Trovate pi\xf9 fabbriche di connettori (con id {{connectorIds}}), \xe8 possibile disinstallare quelle non necessarie.",
    db_connector_type_mismatch: "C'\xe8 un connettore nel DB che non corrisponde al tipo.",
    not_found_with_connector_id: "Impossibile trovare il connettore con l'id connettore standard fornito.",
    multiple_instances_not_supported: "Non \xe8 possibile creare pi\xf9 di un'istanza con il connettore standard selezionato.",
    invalid_type_for_syncing_profile: "\xc8 possibile sincronizzare solo il profilo utente con i connettori social.",
    can_not_modify_target: "Non \xe8 possibile modificare il 'target' del connettore.",
    should_specify_target: "Si dovrebbe specificare il 'target'.",
    multiple_target_with_same_platform: "Non \xe8 possibile avere pi\xf9 connettori social con lo stesso target e piattaforma.",
    cannot_overwrite_metadata_for_non_standard_connector: "I 'metadati' di questo connettore non possono essere sovrascritti."
};
var $5fc8b38c208197df$export$2e2bcd8739ae039 = Object.freeze($5fc8b38c208197df$var$connector);


const $75be472e03d770fc$var$domain = {
    not_configured: "Il fornitore del nome di dominio dell'host non \xe8 configurato.",
    cloudflare_data_missing: "Dati cloudflare mancanti, per favore verificare.",
    cloudflare_unknown_error: "Errore sconosciuto durante la richiesta di API Cloudflare",
    cloudflare_response_error: "Ricevuta una risposta non prevista da Cloudflare.",
    limit_to_one_domain: "Puoi avere solo un dominio personalizzato.",
    hostname_already_exists: "Questo dominio esiste gi\xe0 nel nostro server.",
    cloudflare_not_found: "Impossibile trovare il nome host in Cloudflare.",
    domain_is_not_allowed: "Questo dominio non \xe8 permesso."
};
var $75be472e03d770fc$export$2e2bcd8739ae039 = Object.freeze($75be472e03d770fc$var$domain);


const $cdd50ff7d8b9082e$var$entity = {
    invalid_input: "Input non valido. La lista dei valori non deve essere vuota.",
    create_failed: "Impossibile creare {{name}}.",
    db_constraint_violated: "Vincolo del database violato.",
    not_exists: "{{name}} non esiste.",
    not_exists_with_id: "{{name}} con ID `{{id}}` non esiste.",
    not_found: "La risorsa non esiste.",
    relation_foreign_key_not_found: "Impossibile trovare una o pi\xf9 chiavi esterne. Si prega di controllare l'input e assicurarsi che tutte le entit\xe0 referenziate esistano.",
    unique_integrity_violation: "L'entit\xe0 esiste gi\xe0. Si prega di controllare l'input e riprovare."
};
var $cdd50ff7d8b9082e$export$2e2bcd8739ae039 = Object.freeze($cdd50ff7d8b9082e$var$entity);


const $3be5910eda52a911$var$guard = {
    invalid_input: "La richiesta {{type}} non \xe8 valida.",
    invalid_pagination: "Il valore di paginazione della richiesta non \xe8 valido.",
    can_not_get_tenant_id: "Impossibile ottenere l'ID dell'inquilino dalla richiesta.",
    file_size_exceeded: "Dimensione del file superata.",
    mime_type_not_allowed: "Il tipo MIME non \xe8 consentito."
};
var $3be5910eda52a911$export$2e2bcd8739ae039 = Object.freeze($3be5910eda52a911$var$guard);


const $c1ffff7aee7e633e$var$hook = {
    missing_events: "\xc8 necessario fornire almeno un evento.",
    send_test_payload_failed: "Impossibile inviare il payload di prova: {{message}}",
    endpoint_responded_with_error: "Il punto di accesso ha risposto con un errore."
};
var $c1ffff7aee7e633e$export$2e2bcd8739ae039 = Object.freeze($c1ffff7aee7e633e$var$hook);


const $b26a7bb4fa94d846$var$jwt_customizer = {
    general: "Si \xe8 verificato un errore durante la personalizzazione del token JWT. Si prega di riprovare pi\xf9 tardi.",
    can_not_create_for_admin_tenant: "Impossibile creare un personalizzatore di token JWT per l'amministratore del locatario."
};
var $b26a7bb4fa94d846$export$2e2bcd8739ae039 = Object.freeze($b26a7bb4fa94d846$var$jwt_customizer);


const $7c4448c76435b091$var$localization = {
    cannot_delete_default_language: "{{languageTag}} \xe8 impostato come la tua lingua predefinita e non pu\xf2 essere eliminato.",
    invalid_translation_structure: "Schemi di dati non validi. Controlla l'input e riprova."
};
var $7c4448c76435b091$export$2e2bcd8739ae039 = Object.freeze($7c4448c76435b091$var$localization);


const $b594fa85dbb4cd92$var$log = {
    invalid_type: "Il tipo di registro non \xe8 valido."
};
var $b594fa85dbb4cd92$export$2e2bcd8739ae039 = Object.freeze($b594fa85dbb4cd92$var$log);


const $08b47b24fa9b9f9b$var$oidc = {
    aborted: "L'utente finale ha annullato l'interazione.",
    invalid_scope: "Ambito non valido: {{error_description}}.",
    invalid_token: "Token non valido fornito.",
    invalid_client_metadata: "Metadata client non valide fornite.",
    insufficient_scope: "Token mancante dell'ambito `{{scope}}`.",
    invalid_request: "La richiesta non \xe8 valida.",
    invalid_grant: "La richiesta di concessione non \xe8 valida.",
    invalid_redirect_uri: "`redirect_uri` non corrisponde a nessuno dei `redirect_uris` registrati dal client.",
    access_denied: "Accesso negato.",
    invalid_target: "Indicatore di risorsa non valido.",
    unsupported_grant_type: "Tipo di `grant_type` richiesto non supportato.",
    unsupported_response_mode: "Modalit\xe0 di risposta `response_mode` richiesta non supportata.",
    unsupported_response_type: "Tipo di risposta `response_type` richiesto non supportato.",
    provider_error: "Errore interno OIDC: {{message}}.",
    server_error: "Si \xe8 verificato un errore OIDC sconosciuto. Si prega di riprovare pi\xf9 tardi.",
    provider_error_fallback: "Si \xe8 verificato un errore OIDC: {{code}}.",
    key_required: "\xc8 richiesta almeno una chiave.",
    key_not_found: "Chiave con ID {{id}} non trovata."
};
var $08b47b24fa9b9f9b$export$2e2bcd8739ae039 = Object.freeze($08b47b24fa9b9f9b$var$oidc);


const $d2a7e91c7792de94$var$organization = {
    require_membership: "L'utente deve essere un membro dell'organizzazione per procedere."
};
var $d2a7e91c7792de94$export$2e2bcd8739ae039 = Object.freeze($d2a7e91c7792de94$var$organization);


const $43f857483aad2f63$var$password = {
    unsupported_encryption_method: "Il metodo di crittografia {{name}} non \xe8 supportato.",
    pepper_not_found: "Pepper password non trovato. Per favore controlla le tue env di core.",
    rejected: "La password \xe8 stata rifiutata. Per favore verifica se la tua password soddisfa i requisiti."
};
var $43f857483aad2f63$export$2e2bcd8739ae039 = Object.freeze($43f857483aad2f63$var$password);


const $e351116ab109ae5c$var$request = {
    invalid_input: "L'input non \xe8 valido. {{details}}",
    general: "Si \xe8 verificato un errore nella richiesta."
};
var $e351116ab109ae5c$export$2e2bcd8739ae039 = Object.freeze($e351116ab109ae5c$var$request);


const $af97f863605aa248$var$resource = {
    resource_identifier_in_use: "L'identificatore API {{indicator}} \xe8 gi\xe0 in uso",
    cannot_delete_management_api: "Impossibile eliminare l'API di gestione di Logto.",
    cannot_modify_management_api: "Impossibile modificare l'API di gestione di Logto."
};
var $af97f863605aa248$export$2e2bcd8739ae039 = Object.freeze($af97f863605aa248$var$resource);


const $6645ab805be5f0de$var$role = {
    name_in_use: "Il nome di ruolo {{name}} \xe8 gi\xe0 in uso",
    scope_exists: "L'identificatore di ambito {{scopeId}} \xe8 gi\xe0 stato aggiunto a questo ruolo",
    management_api_scopes_not_assignable_to_user_role: "Impossibile assegnare scope dell'API di gestione a un ruolo utente.",
    user_exists: "L'identificatore di utente {{userId}} \xe8 gi\xe0 stato aggiunto a questo ruolo",
    application_exists: "L'ID dell'applicazione {{applicationId}} \xe8 gi\xe0 stato aggiunto a questo ruolo",
    default_role_missing: "Alcuni dei nomi di ruolo predefiniti non esistono nel database, assicurati di creare prima i ruoli",
    internal_role_violation: 'Potresti cercare di aggiornare o eliminare un ruolo interno che \xe8 vietato da Logto. Se stai creando un nuovo ruolo, prova un altro nome che non inizi con "#internal:". '
};
var $6645ab805be5f0de$export$2e2bcd8739ae039 = Object.freeze($6645ab805be5f0de$var$role);


const $40765618beb36be5$var$scope = {
    name_exists: "Il nome dello scope {{name}} \xe8 gi\xe0 in uso",
    name_with_space: "Il nome dello scope non pu\xf2 contenere spazi."
};
var $40765618beb36be5$export$2e2bcd8739ae039 = Object.freeze($40765618beb36be5$var$scope);


const $dffdf7dea7b64bd1$var$session = {
    not_found: "Sessione non trovata. Torna indietro e accedi nuovamente.",
    invalid_credentials: "Account o password non corretti. Controlla le tue credenziali.",
    invalid_sign_in_method: "Metodo di accesso corrente non disponibile.",
    invalid_connector_id: "Impossibile trovare un connettore disponibile con ID {{connectorId}}.",
    insufficient_info: "Informazioni di accesso insufficienti.",
    connector_id_mismatch: "L'ID del connettore non corrisponde con il record della sessione.",
    connector_session_not_found: "Sessione del connettore non trovata. Torna indietro e accedi nuovamente.",
    verification_session_not_found: "La verifica non \xe8 stata completata con successo. Riavvia il processo di verifica e riprova.",
    verification_expired: "La connessione \xe8 scaduta. Verifica di nuovo per garantire la sicurezza del tuo account.",
    verification_blocked_too_many_attempts: "Troppi tentativi in poco tempo. Si prega di riprovare {{relativeTime}}.",
    unauthorized: "Accedi prima di procedere.",
    unsupported_prompt_name: "Nome del prompt non supportato.",
    forgot_password_not_enabled: "Recupero password non abilitato.",
    verification_failed: "La verifica non \xe8 stata completata con successo. Riavvia il processo di verifica e riprova.",
    connector_validation_session_not_found: "Sessione del connettore per la convalida del token non trovata.",
    identifier_not_found: "Identificativo utente non trovato. Torna indietro e accedi nuovamente.",
    interaction_not_found: "Sessione di interazione non trovata. Torna indietro e avvia la sessione nuovamente.",
    not_supported_for_forgot_password: "Questa operazione non \xe8 supportata per il recupero password.",
    mfa: {
        require_mfa_verification: "La verifica MFA \xe8 richiesta per accedere.",
        mfa_sign_in_only: "MFA \xe8 disponibile solo per l'interazione di accesso.",
        pending_info_not_found: "Informazioni MFA in sospeso non trovate, si prega di avviare prima MFA.",
        invalid_totp_code: "Codice TOTP non valido.",
        webauthn_verification_failed: "Verifica WebAuthn non riuscita.",
        webauthn_verification_not_found: "Verifica WebAuthn non trovata.",
        bind_mfa_existed: "MFA esiste gi\xe0.",
        backup_code_can_not_be_alone: "Il codice di backup non pu\xf2 essere l'unica MFA.",
        backup_code_required: "Il codice di backup \xe8 richiesto.",
        invalid_backup_code: "Codice di backup non valido.",
        mfa_policy_not_user_controlled: "La politica MFA non \xe8 controllata dall'utente."
    },
    sso_enabled: "L'accesso singolo \xe8 abilitato per questa email. Accedi con SSO."
};
var $dffdf7dea7b64bd1$export$2e2bcd8739ae039 = Object.freeze($dffdf7dea7b64bd1$var$session);


const $686c8606ca693b19$var$sign_in_experiences = {
    empty_content_url_of_terms_of_use: 'URL di contenuto "Termini di utilizzo" vuoto. Si prega di aggiungere l\'URL del contenuto se "Termini di utilizzo" \xe8 abilitato.',
    empty_social_connectors: "Connettori social vuoti. Si prega di aggiungere connettori social abilitati quando il metodo di accesso social \xe8 abilitato.",
    enabled_connector_not_found: "{{type}} conettore abilitato non trovato.",
    not_one_and_only_one_primary_sign_in_method: "Deve esserci un solo metodo di accesso principale. Si prega di verificare l'input.",
    username_requires_password: "Deve abilitare impostazione di una password per l'identificatore di registrazione dell'username.",
    passwordless_requires_verify: "Deve abilitare la verifica per l'identificatore di registrazione tramite email/telefono.",
    miss_sign_up_identifier_in_sign_in: "I metodi di accesso devono contenere l'identificatore di registrazione.",
    password_sign_in_must_be_enabled: "Il metodo di accesso con password deve essere abilitato quando \xe8 richiesta la creazione di una password nella registrazione.",
    code_sign_in_must_be_enabled: "Il metodo di accesso con codice di verifica deve essere abilitato quando non \xe8 richiesta una password nella registrazione.",
    unsupported_default_language: "Questa lingua - {{language}} non \xe8 supportata al momento.",
    at_least_one_authentication_factor: "Devi selezionare almeno un fattore di autenticazione.",
    backup_code_cannot_be_enabled_alone: "Il codice di backup non pu\xf2 essere abilitato da solo.",
    duplicated_mfa_factors: "Fattori MFA duplicati."
};
var $686c8606ca693b19$export$2e2bcd8739ae039 = Object.freeze($686c8606ca693b19$var$sign_in_experiences);


const $7621f0cb6edc2e73$var$single_sign_on = {
    forbidden_domains: "I domini di posta elettronica pubblica non sono consentiti.",
    duplicated_domains: "Ci sono domini duplicati.",
    invalid_domain_format: "Formato del dominio non valido.",
    duplicate_connector_name: "Il nome del connettore esiste gi\xe0. Si prega di scegliere un nome diverso."
};
var $7621f0cb6edc2e73$export$2e2bcd8739ae039 = Object.freeze($7621f0cb6edc2e73$var$single_sign_on);


const $dac8162ce117c00c$var$storage = {
    not_configured: "Provider di archiviazione non configurato.",
    missing_parameter: "Parametro mancante {{parameter}} per il provider di archiviazione.",
    upload_error: "Impossibile caricare il file sul provider di archiviazione."
};
var $dac8162ce117c00c$export$2e2bcd8739ae039 = Object.freeze($dac8162ce117c00c$var$storage);


const $e9dac9f4fc6ae260$var$subscription = {
    limit_exceeded: "Hai raggiunto il limite del tuo piano di abbonamento.",
    get_plan_failed: "Impossibile ottenere il piano di abbonamento per l'inquilino.",
    tenant_suspended: "L'inquilino \xe8 sospeso. Si prega di contattare l'amministratore."
};
var $e9dac9f4fc6ae260$export$2e2bcd8739ae039 = Object.freeze($e9dac9f4fc6ae260$var$subscription);


const $ee9a2fd979c054be$var$swagger = {
    invalid_zod_type: "Tipo Zod non valido. Controllare la configurazione di guardia del percorso.",
    not_supported_zod_type_for_params: "Tipo Zod non supportato per i parametri. Controllare la configurazione di guardia del percorso."
};
var $ee9a2fd979c054be$export$2e2bcd8739ae039 = Object.freeze($ee9a2fd979c054be$var$swagger);


const $052e4a8954ed8ba7$var$user = {
    username_already_in_use: "Questo nome utente \xe8 gi\xe0 in uso.",
    email_already_in_use: "Questa email \xe8 associata ad un account esistente.",
    phone_already_in_use: "Questo numero di telefono \xe8 associato ad un account esistente.",
    invalid_email: "Indirizzo email non valido.",
    invalid_phone: "Numero di telefono non valido.",
    email_not_exist: "L'indirizzo email non \xe8 stato ancora registrato.",
    phone_not_exist: "Il numero di telefono non \xe8 stato ancora registrato.",
    identity_not_exist: "L'account social non \xe8 stato ancora registrato.",
    identity_already_in_use: "L'account social \xe8 stato associato ad un account esistente.",
    social_account_exists_in_profile: "Hai gi\xe0 associato questo account social.",
    cannot_delete_self: "Non puoi eliminarti da solo.",
    sign_up_method_not_enabled: "Questo metodo di registrazione non \xe8 abilitato.",
    sign_in_method_not_enabled: "Questo metodo di accesso non \xe8 abilitato.",
    same_password: "La nuova password non pu\xf2 essere uguale alla vecchia password.",
    password_required_in_profile: "\xc8 necessario impostare una password prima di accedere.",
    new_password_required_in_profile: "\xc8 necessario impostare una nuova password.",
    password_exists_in_profile: "La password esiste gi\xe0 nel tuo profilo.",
    username_required_in_profile: "\xc8 necessario impostare un nome utente prima di accedere.",
    username_exists_in_profile: "Il nome utente esiste gi\xe0 nel tuo profilo.",
    email_required_in_profile: "\xc8 necessario aggiungere un'indirizzo email prima di accedere.",
    email_exists_in_profile: "Il tuo profilo \xe8 gi\xe0 associato ad un indirizzo email.",
    phone_required_in_profile: "\xc8 necessario aggiungere un numero di telefono prima di accedere.",
    phone_exists_in_profile: "Il tuo profilo \xe8 gi\xe0 associato ad un numero di telefono.",
    email_or_phone_required_in_profile: "\xc8 necessario aggiungere un indirizzo email o un numero di telefono prima di accedere.",
    suspended: "Questo account \xe8 stato sospeso.",
    user_not_exist: "L'utente con {{ identifier }} non esiste.",
    missing_profile: "\xc8 necessario fornire informazioni aggiuntive prima di accedere.",
    role_exists: "L'ID ruolo {{roleId}} \xe8 gi\xe0 stato aggiunto a questo utente",
    invalid_role_type: "Tipo di ruolo non valido, non \xe8 possibile assegnare un ruolo da macchina a utente.",
    missing_mfa: "Devi legare un'ulteriore MFA prima di accedere.",
    totp_already_in_use: "TOTP \xe8 gi\xe0 in uso.",
    backup_code_already_in_use: "Il codice di backup \xe8 gi\xe0 in uso.",
    password_algorithm_required: "L'algoritmo della password \xe8 richiesto.",
    password_and_digest: "Non puoi impostare sia la password in chiaro che il digest della password."
};
var $052e4a8954ed8ba7$export$2e2bcd8739ae039 = Object.freeze($052e4a8954ed8ba7$var$user);


const $d076bfefc5ca8378$var$verification_code = {
    phone_email_empty: "Entrambi il telefono e l'e-mail sono vuoti.",
    not_found: "Codice di verifica non trovato. Si prega di inviare il codice di verifica per primo.",
    phone_mismatch: "Telefono non corrispondente. Si prega di richiedere un nuovo codice di verifica.",
    email_mismatch: "Email non corrispondente. Si prega di richiedere un nuovo codice di verifica.",
    code_mismatch: "Codice di verifica non valido.",
    expired: "Il codice di verifica \xe8 scaduto. Si prega di richiedere un nuovo codice di verifica.",
    exceed_max_try: "Superata la limitazione dei tentativi di codice di verifica. Si prega di richiedere un nuovo codice di verifica."
};
var $d076bfefc5ca8378$export$2e2bcd8739ae039 = Object.freeze($d076bfefc5ca8378$var$verification_code);


const $f83d50b72fc0d8ae$var$errors = {
    request: $e351116ab109ae5c$export$2e2bcd8739ae039,
    auth: $be38a1d51f785fe1$export$2e2bcd8739ae039,
    guard: $3be5910eda52a911$export$2e2bcd8739ae039,
    oidc: $08b47b24fa9b9f9b$export$2e2bcd8739ae039,
    user: $052e4a8954ed8ba7$export$2e2bcd8739ae039,
    password: $43f857483aad2f63$export$2e2bcd8739ae039,
    session: $dffdf7dea7b64bd1$export$2e2bcd8739ae039,
    connector: $5fc8b38c208197df$export$2e2bcd8739ae039,
    verification_code: $d076bfefc5ca8378$export$2e2bcd8739ae039,
    sign_in_experiences: $686c8606ca693b19$export$2e2bcd8739ae039,
    jwt_customizer: $b26a7bb4fa94d846$export$2e2bcd8739ae039,
    localization: $7c4448c76435b091$export$2e2bcd8739ae039,
    swagger: $ee9a2fd979c054be$export$2e2bcd8739ae039,
    entity: $cdd50ff7d8b9082e$export$2e2bcd8739ae039,
    log: $b594fa85dbb4cd92$export$2e2bcd8739ae039,
    role: $6645ab805be5f0de$export$2e2bcd8739ae039,
    scope: $40765618beb36be5$export$2e2bcd8739ae039,
    storage: $dac8162ce117c00c$export$2e2bcd8739ae039,
    resource: $af97f863605aa248$export$2e2bcd8739ae039,
    hook: $c1ffff7aee7e633e$export$2e2bcd8739ae039,
    domain: $75be472e03d770fc$export$2e2bcd8739ae039,
    subscription: $e9dac9f4fc6ae260$export$2e2bcd8739ae039,
    application: $99d76cd6215cdc96$export$2e2bcd8739ae039,
    organization: $d2a7e91c7792de94$export$2e2bcd8739ae039,
    single_sign_on: $7621f0cb6edc2e73$export$2e2bcd8739ae039
};
var $f83d50b72fc0d8ae$export$2e2bcd8739ae039 = Object.freeze($f83d50b72fc0d8ae$var$errors);


const $00e275692131715b$var$api_resource_details = {
    page_title: "Dettagli delle risorse API",
    back_to_api_resources: "Torna alle risorse API",
    general_tab: "Generale",
    permissions_tab: "Autorizzazioni",
    settings: "Impostazioni",
    settings_description: "Le risorse API, anche note come Indicatori di Risorse, indicano i servizi o le risorse di destinazione da richiedere, di solito una variabile di formato URI che rappresenta l'identit\xe0 della risorsa.",
    management_api_settings_description: "La Logto Management API \xe8 una raccolta completa di API che consentono agli amministratori di gestire una vasta gamma di attivit\xe0 relative all'identit\xe0, far rispettare le politiche di sicurezza e conformarsi a regolamenti e standard.",
    management_api_notice: "Questa API rappresenta l'entit\xe0 Logto e non pu\xf2 essere modificata o eliminata. Crea un'app machine-to-machine per chiamare l'API di gestione Logto. <a>Scopri di pi\xf9</a>",
    token_expiration_time_in_seconds: "Tempo di scadenza del token (in secondi)",
    token_expiration_time_in_seconds_placeholder: "Inserisci il tempo di scadenza del tuo token",
    delete_description: "Questa azione non pu\xf2 essere annullata. Eliminer\xe0 definitivamente la risorsa API. Per favore, inserisci il nome della risorsa api <span>{{name}}</span> per confermare.",
    enter_your_api_resource_name: "Inserisci il nome della tua risorsa API",
    api_resource_deleted: "La risorsa API {{name}} \xe8 stata eliminata con successo",
    permission: {
        create_button: "Crea autorizzazione",
        create_title: "crea autorizzazione",
        create_subtitle: "Definire le autorizzazioni (ambiti) necessarie per questa API.",
        confirm_create: "Crea autorizzazione",
        edit_title: "Modifica autorizzazione",
        edit_subtitle: "Definire le autorizzazioni (ambiti) necessarie per la API {{resourceName}}.",
        name: "Nome autorizzazione",
        name_placeholder: "lettura:risorsa",
        forbidden_space_in_name: "Il nome dell'autorizzazione non deve contenere spazi.",
        description: "Descrizione",
        description_placeholder: "In grado di leggere le risorse",
        permission_created: "L'autorizzazione {{name}} \xe8 stata creata con successo",
        delete_description: "Se questa autorizzazione viene eliminata, l'utente che aveva questa autorizzazione perder\xe0 l'accesso concessogli tramite di essa.",
        deleted: 'L\'autorizzazione "{{name}}" \xe8 stata eliminata con successo.'
    }
};
var $00e275692131715b$export$2e2bcd8739ae039 = Object.freeze($00e275692131715b$var$api_resource_details);


const $b690081abf749e16$var$api_resources = {
    page_title: "Risorse API",
    title: "Risorse API",
    subtitle: "Definisci API che le tue applicazioni autorizzate possono utilizzare",
    create: "Crea risorsa API",
    api_name: "Nome API",
    api_name_placeholder: "Inserisci il nome dell'API",
    api_identifier: "Identificatore API",
    api_identifier_placeholder: "https://il-tuo-identificatore-api/",
    api_identifier_tip: "L'identificatore univoco della risorsa API. Deve essere un URI assoluto e non ha componenti di frammento (#). Corrisponde al parametro <a>risorsa</a> in OAuth 2.0.",
    default_api: "API predefinita",
    default_api_label: "Solo zero o una API predefinita possono essere impostate per tenant. Quando viene designata una API predefinita, il parametro di risorsa pu\xf2 essere omesso nella richiesta di autorizzazione. Gli scambi di token successivi utilizzeranno quell API come destinatario per impostazione predefinita, con conseguente rilascio di JWT. <a>Scopri di pi\xf9</a>",
    api_resource_created: "La risorsa API {{name}} \xe8 stata creata con successo",
    invalid_resource_indicator_format: "L'indicatore dell'API deve essere un URI assoluto valido."
};
var $b690081abf749e16$export$2e2bcd8739ae039 = Object.freeze($b690081abf749e16$var$api_resources);


const $72d0e6b446f18320$var$application_details = {
    page_title: "Dettagli dell'applicazione",
    back_to_applications: "Torna alle applicazioni",
    check_guide: "Verifica guida",
    settings: "Impostazioni",
    settings_description: "Un \"Applicazione\" \xe8 un software o servizio registrato che pu\xf2 accedere alle informazioni dell'utente o agire per conto di un utente. Le applicazioni aiutano a riconoscere chi sta chiedendo cosa da Logto e gestiscono l'accesso e le autorizzazioni. Compila i campi obbligatori per l'autenticazione.",
    integration: "Integrazione",
    integration_description: "Implementa con i lavoratori sicuri di Logto, supportati dalla rete perimetrale di Cloudflare per prestazioni di prim'ordine e avviamenti istantanei in tutto il mondo a 0 ms.",
    service_configuration: "Configurazione del servizio",
    service_configuration_description: "Completa le configurazioni necessarie nel tuo servizio.",
    session: "Sessione",
    endpoints_and_credentials: "Endpoint e Credenziali",
    endpoints_and_credentials_description: "Usa i seguenti endpoint e credenziali per configurare la connessione OIDC nella tua applicazione.",
    refresh_token_settings: "Token di aggiornamento",
    refresh_token_settings_description: "Gestisci le regole dei token di aggiornamento per questa applicazione.",
    application_roles: "Ruoli",
    machine_logs: "Log delle macchine",
    application_name: "Nome dell'applicazione",
    application_name_placeholder: "La mia app",
    description: "Descrizione",
    description_placeholder: "Inserisci la descrizione della tua applicazione",
    config_endpoint: "Endpoint di configurazione OpenID Provider",
    authorization_endpoint: "Endpoint di autorizzazione",
    authorization_endpoint_tip: "L'endpoint per effettuare l'autenticazione e l'autorizzazione. Viene utilizzato per la connessione OpenID <a>autenticazione</a>.",
    show_endpoint_details: "Mostra dettagli endpoint",
    hide_endpoint_details: "Nascondi dettagli endpoint",
    logto_endpoint: "Endpoint Logto",
    application_id: "ID App",
    application_id_tip: "L'identificatore univoco dell'applicazione generato normalmente da Logto. Sta anche per \"<a>client_id</a>\" in OpenID Connect.",
    application_secret: "Secret App",
    redirect_uri: "URI di reindirizzamento",
    redirect_uris: "URI di reindirizzamento",
    redirect_uri_placeholder: "https://il-tuo-sito-web.com/la-tua-app",
    redirect_uri_placeholder_native: "io.logto://callback",
    redirect_uri_tip: "Il URI di reindirizzamento dopo il login di un utente (sia riuscito che non). Vedi OpenID Connect autenticazione richiesta per ulteriori informazioni.",
    post_sign_out_redirect_uri: "URI di reindirizzamento post disconnessione",
    post_sign_out_redirect_uris: "URI di reindirizzamento post disconnessione",
    post_sign_out_redirect_uri_placeholder: "https://your.website.com/home",
    post_sign_out_redirect_uri_tip: "Il URI di reindirizzamento dopo la disconnessione dell'utente (facoltativo). Potrebbe non avere alcun effetto pratico in alcuni tipi di app.",
    cors_allowed_origins: "Origini consentite CORS",
    cors_allowed_origins_placeholder: "https://il-tuo-sito-web.com",
    cors_allowed_origins_tip: "Per impostazione predefinita, saranno consentite tutte le origini degli URI di reindirizzamento. Di solito non \xe8 richiesta alcuna azione per questo campo. Vedi la documentazione MDN per informazioni dettagliate.",
    token_endpoint: "Endpoint token",
    user_info_endpoint: "Endpoint informazioni utente",
    enable_admin_access: "Abilita l'accesso amministratore",
    enable_admin_access_label: "Abilita o disabilita l'accesso all'API di gestione. Una volta abilitato, puoi utilizzare i token di accesso per chiamare l'API di gestione a nome di questa applicazione.",
    always_issue_refresh_token: "Rilascia sempre il token di aggiornamento",
    always_issue_refresh_token_label: "Abilitando questa configurazione, Logto potr\xe0 rilasciare sempre token di aggiornamento, anche se `prompt=consent` non viene presentata nella richiesta di autenticazione. Tuttavia, questa pratica \xe8 scoraggiata a meno che non sia necessaria, in quanto non \xe8 compatibile con OpenID Connect e potrebbe potenzialmente causare problemi.",
    refresh_token_ttl: "Tempo di vita del token di aggiornamento in giorni",
    refresh_token_ttl_tip: "La durata per cui un token di aggiornamento pu\xf2 essere utilizzato per richiedere nuovi access token prima che scada e diventa non valido, le richieste di token estenderanno il TTL del token di aggiornamento a questo valore.",
    rotate_refresh_token: "Ruota token di aggiornamento",
    rotate_refresh_token_label: "Quando abilitato, Logto emetter\xe0 un nuovo token di aggiornamento per le richieste di token quando \xe8 passato il 70% del Tempo di vita (TTL) originale o sono soddisfatte determinate condizioni. <a>Ulteriori informazioni</a>",
    delete_description: "Questa azione non pu\xf2 essere annullata. Eliminer\xe0 definitivamente l'applicazione. Inserisci il nome dell'applicazione <span>{{name}}</span> per confermare.",
    enter_your_application_name: "Inserisci il nome della tua applicazione",
    application_deleted: "L'applicazione {{name}} \xe8 stata eliminata con successo",
    redirect_uri_required: "Devi inserire almeno un URI di reindirizzamento",
    app_domain_description_1: "Sentiti libero di utilizzare il tuo dominio con {{domain}} alimentato da Logto, che \xe8 permanentemente valido.",
    app_domain_description_2: "Sentiti libero di utilizzare il tuo dominio <domain>{{domain}}</domain> che \xe8 permanentemente valido.",
    custom_rules: "Regole di autenticazione personalizzate",
    custom_rules_placeholder: "^/(admin|privacy)/.+$",
    custom_rules_description: "Imposta le regole con espressioni regolari per percorsi richiesti per l'autenticazione. Predefinito: protezione completa del sito se lasciato vuoto.",
    authentication_routes: "Percorsi di autenticazione",
    custom_rules_tip: "Ecco due scenari:<ol><li>Per proteggere solo i percorsi '/admin' e '/privacy' con autenticazione: ^/(admin|privacy)/.*</li><li>Per escludere le immagini JPG dall'autenticazione: ^(?!.*\\.jpg$).*$</li></ol>",
    authentication_routes_description: "Reindirizza l'autenticazione del tuo pulsante utilizzando i percorsi specificati. Nota: questi percorsi sono irrimovibili.",
    protect_origin_server: "Proteggi il tuo server di origine",
    protect_origin_server_description: "Assicurati di proteggere il tuo server di origine dall'accesso diretto. Fai riferimento alla guida per ulteriori <a>istruzioni dettagliate</a>.",
    session_duration: "Durata della sessione (giorni)",
    try_it: "Provalo",
    branding: {
        name: "Marchio",
        description: "Personalizza il nome e il logo dell'applicazione sullo schermo del consenso.",
        more_info: "Maggiori informazioni",
        more_info_description: "Offri agli utenti ulteriori dettagli sull'applicazione sullo schermo del consenso.",
        display_name: "Nome visualizzato",
        display_logo: "Logo visualizzato",
        display_logo_dark: "Logo visualizzato (scuro)",
        terms_of_use_url: "URL termini d'uso dell'applicazione",
        privacy_policy_url: "URL politica sulla privacy dell'applicazione"
    },
    permissions: {
        name: "Autorizzazioni",
        description: "Seleziona le autorizzazioni che l'applicazione di terze parti richiede per l'autorizzazione dell'utente all'accesso a tipi di dati specifici.",
        user_permissions: "Dati utente personali",
        organization_permissions: "Accesso organizzazione",
        table_name: "Concedi autorizzazioni",
        field_name: "Autorizzazione",
        field_description: "Visualizzato nello schermo del consenso",
        delete_text: "Rimuovi autorizzazione",
        permission_delete_confirm: "Questa azione revocher\xe0 le autorizzazioni concesse all'applicazione di terze parti, impedendole di richiedere l'autorizzazione dell'utente per tipi di dati specifici. Sei sicuro di voler continuare?",
        permissions_assignment_description: "Seleziona le autorizzazioni richieste dall'applicazione di terze parti per l'autorizzazione dell'utente all'accesso a tipi di dati specifici.",
        user_profile: "Dati utente",
        api_permissions: "Autorizzazioni API",
        organization: "Autorizzazioni organizzazione",
        user_permissions_assignment_form_title: "Aggiungi le autorizzazioni del profilo utente",
        organization_permissions_assignment_form_title: "Aggiungi le autorizzazioni dell'organizzazione",
        api_resource_permissions_assignment_form_title: "Aggiungi le autorizzazioni delle risorse API",
        user_data_permission_description_tips: 'Puoi modificare la descrizione delle autorizzazioni dei dati personali degli utenti tramite "Esperienza di accesso > Contenuto > Gestisci lingue".',
        permission_description_tips: "Quando Logto viene utilizzato come Provider di Identit\xe0 (IdP) per l'autenticazione nelle app di terze parti e agli utenti viene chiesta l'autorizzazione, questa descrizione appare sullo schermo del consenso.",
        user_title: "Utente",
        user_description: "Seleziona le autorizzazioni richieste dall'applicazione di terze parti per accedere a tipi specifici di dati utente.",
        grant_user_level_permissions: "Concedi autorizzazioni dei dati utente",
        organization_title: "Organizzazione",
        organization_description: "Seleziona le autorizzazioni richieste dall'applicazione di terze parti per accedere a tipi specifici di dati organizzazione.",
        grant_organization_level_permissions: "Concedi autorizzazioni dei dati organizzazione"
    },
    roles: {
        name_column: "Ruolo",
        description_column: "Descrizione",
        assign_button: "Assegna ruoli",
        delete_description: "Questa azione rimuover\xe0 questo ruolo da questa applicazione tra macchine. Il ruolo stesso esister\xe0 ancora, ma non sar\xe0 pi\xf9 associato a questa applicazione tra macchine.",
        deleted: "{{name}} \xe8 stato rimosso con successo da questo utente.",
        assign_title: "Assegna ruoli a {{name}}",
        assign_subtitle: "Autorizza {{name}} uno o pi\xf9 ruoli",
        assign_role_field: "Assegna ruoli",
        role_search_placeholder: "Cerca per nome ruolo",
        added_text: "{{value, number}} aggiunti",
        assigned_app_count: "{{value, number}} applicazioni",
        confirm_assign: "Assegna ruoli",
        role_assigned: "Ruolo(i) assegnato con successo",
        search: "Cerca per nome ruolo, descrizione o ID",
        empty: "Nessun ruolo disponibile"
    }
};
var $72d0e6b446f18320$export$2e2bcd8739ae039 = Object.freeze($72d0e6b446f18320$var$application_details);


const $acb3175029a99849$var$applications = {
    page_title: "Applicazioni",
    title: "Applicazioni",
    subtitle: "Configura l'autenticazione Logto per la tua applicazione nativa, a singola pagina, macchina-to-macchina o tradizionale",
    subtitle_with_app_type: "Configura l'autenticazione Logto per la tua applicazione {{name}}",
    create: "Crea Applicazione",
    create_subtitle_third_party: "Utilizza Logto come tuo provider di identit\xe0 (IdP) per integrarti facilmente con applicazioni di terze parti",
    application_name: "Nome applicazione",
    application_name_placeholder: "La mia App",
    application_description: "Descrizione applicazione",
    application_description_placeholder: "Inserisci la descrizione della tua applicazione",
    select_application_type: "Seleziona un tipo di applicazione",
    no_application_type_selected: "Non hai ancora selezionato alcun tipo di applicazione",
    application_created: "L'applicazione \xe8 stata creata con successo.",
    tab: {
        my_applications: "Le mie app",
        third_party_applications: "App di terze parti"
    },
    app_id: "App ID",
    type: {
        native: {
            title: "App Nativa",
            subtitle: "Un'applicazione che viene eseguita in un ambiente nativo",
            description: "E.g., applicazione iOS, applicazione Android"
        },
        spa: {
            title: "Applicazione a Singola Pagina",
            subtitle: "Un'applicazione che viene eseguita in un browser web e aggiorna dinamicamente i dati in maniera localizzata",
            description: "E.g., applicazione React DOM, applicazione Vue"
        },
        traditional: {
            title: "Web Tradizionale",
            subtitle: "Un'applicazione che renderizza e aggiorna le pagine solo attraverso il server web",
            description: "E.g., Next.js, PHP"
        },
        machine_to_machine: {
            title: "Macchina-to-Macchina",
            subtitle: "Un'app (solitamente un servizio) che comunica direttamente con le risorse",
            description: "E.g., servizio backend"
        },
        protected: {
            title: "App Protetta",
            subtitle: "Un app protetta da Logto",
            description: "N/A"
        },
        third_party: {
            title: "App di Terze Parti",
            subtitle: "Un app utilizzata come connettore IdP di terze parti",
            description: "E.g., OIDC, SAML"
        }
    },
    placeholder_title: "Seleziona un tipo di applicazione per continuare",
    placeholder_description: "Logto utilizza un'entit\xe0 applicazione per OIDC per aiutarti in compiti come l'identificazione delle tue app, la gestione dell'accesso e la creazione di registri di audit.",
    m2m_role_assignment: {
        title: "Autorizza l'applicazione con ruolo da macchina a macchina per le autorizzazioni",
        subtitle: "Le applicazioni da macchina a macchina richiedono un ruolo da macchina a macchina autorizzato.",
        role_creation_hint: "Non riesci a trovare il ruolo giusto per macchina a macchina? <a>Crea un ruolo macchina a macchina</a>"
    }
};
var $acb3175029a99849$export$2e2bcd8739ae039 = Object.freeze($acb3175029a99849$var$applications);


const $6c06da46a777c1d7$var$cloud = {
    general: {
        onboarding: "Inizio"
    },
    welcome: {
        page_title: "Benvenuto",
        title: "Benvenuto in Logto Cloud! Ci piacerebbe conoscere un po' di te.",
        description: "Facciamo diventare la tua esperienza Logto unica conoscendoti meglio. Le tue informazioni sono al sicuro con noi.",
        project_field: "Sto usando Logto per",
        project_options: {
            personal: "Progetto personale",
            company: "Progetto aziendale"
        },
        company_name_field: "Nome dell'azienda",
        company_name_placeholder: "Acme.co",
        stage_field: "In quale fase si trova attualmente il tuo prodotto?",
        stage_options: {
            new_product: "Inizia un nuovo progetto e cerca una soluzione rapida e pronta all'uso",
            existing_product: "Migra dall'autenticazione attuale (ad esempio, autenticazione autocostruita, Auth0, Cognito, Microsoft)",
            target_enterprise_ready: "Ho appena acquisito clienti pi\xf9 importanti e ora rendo il mio prodotto pronto per essere venduto alle imprese"
        },
        additional_features_field: "Qualcos'altro che desideri farci sapere?",
        additional_features_options: {
            customize_ui_and_flow: "Costruisci e gestisci la mia stessa interfaccia utente, non solo utilizzo la soluzione predefinita e personalizzabile di Logto",
            compliance: "SOC2 e GDPR sono imprescindibili",
            export_user_data: "Necessit\xe0 di esportare i dati utente da Logto",
            budget_control: "Ho un controllo molto stretto sul budget",
            bring_own_auth: "Ho i miei servizi di autenticazione e ho solo bisogno di alcune funzionalit\xe0 di Logto",
            others: "Nessuna delle opzioni sopra"
        }
    },
    sie: {
        page_title: "Personalizza l'esperienza di accesso",
        title: "Personalizziamo insieme la tua esperienza di accesso",
        inspire: {
            title: "Crea esempi coinvolgenti",
            description: 'Ti senti incerto riguardo l\'esperienza di accesso? Fai clic su "Ispirami" e lascia che la magia accada!',
            inspire_me: "Ispirami"
        },
        logo_field: "Logo dell'app",
        color_field: "Colore del brand",
        identifier_field: "Identificativo",
        identifier_options: {
            email: "Email",
            phone: "Telefono",
            user_name: "Nome utente"
        },
        authn_field: "Autenticazione",
        authn_options: {
            password: "Password",
            verification_code: "Codice di verifica"
        },
        social_field: "Accesso tramite social",
        finish_and_done: "Termina e completato",
        preview: {
            mobile_tab: "Mobile",
            web_tab: "Web"
        },
        connectors: {
            unlocked_later: "Sbloccato in seguito",
            unlocked_later_tip: "Una volta completato il processo di onboarding e inserito il prodotto, avrai accesso a ancora pi\xf9 metodi di accesso tramite social.",
            notice: "Si prega di evitare di utilizzare il connettore demo per scopi di produzione. Una volta completati i test, cancellare gentilmente il connettore demo e configurare il proprio connettore con le proprie credenziali."
        }
    },
    socialCallback: {
        title: "Accesso effettuato con successo",
        description: "Hai effettuato l'accesso con successo utilizzando il tuo account social. Per garantire integrazione senza problemi e accesso a tutte le funzionalit\xe0 di Logto, ti consigliamo di procedere alla configurazione del tuo connettore social."
    },
    tenant: {
        create_tenant: "Crea tenant"
    }
};
var $6c06da46a777c1d7$export$2e2bcd8739ae039 = Object.freeze($6c06da46a777c1d7$var$cloud);


const $eb5a642fe4aefa7e$var$components = {
    uploader: {
        action_description: "Trascina e rilascia o cerca",
        uploading: "Caricamento in corso...",
        image_limit: "Carica immagini sotto i {{size, number}}KB, solo {{extensions, list(style: narrow; type: conjunction;)}}.",
        error_upload: "Qualcosa \xe8 andato storto. Caricamento fallito.",
        error_file_size: "Il file \xe8 troppo grande. Carica un file sotto i {{size, number}}KB.",
        error_file_type: "Formato file non supportato. Sono accettati solo formati {{extensions, list(style: narrow; type: conjunction;)}}.",
        error_file_count: "Puoi caricare solo 1 file."
    }
};
var $eb5a642fe4aefa7e$export$2e2bcd8739ae039 = Object.freeze($eb5a642fe4aefa7e$var$components);


const $d9b858256fe4cc74$var$connector_details = {
    page_title: "Dettagli del connettore",
    back_to_connectors: "Torna ai connettori",
    check_readme: "Verifica README",
    settings: "Impostazioni generali",
    settings_description: "I connettori svolgono un ruolo critico in Logto. Grazie al loro aiuto, Logto consente agli utenti finali di utilizzare la registrazione o l'accesso senza password e le capacit\xe0 di accedere tramite account social.",
    parameter_configuration: "Configurazione dei parametri",
    test_connection: "Test",
    save_error_empty_config: "Inserisci la configurazione",
    send: "Invia",
    send_error_invalid_format: "Input non valido",
    edit_config_label: "Inserisci il tuo JSON qui",
    test_email_sender: "Prova il tuo connettore per email",
    test_sms_sender: "Prova il tuo connettore per SMS",
    test_email_placeholder: "john.doe@example.com",
    test_sms_placeholder: "+1 555-123-4567",
    test_message_sent: "Messaggio di prova inviato",
    test_sender_description: 'Logto utilizza il modello "Generico" per i test. Riceverai un messaggio se il tuo connettore \xe8 correttamente configurato.',
    options_change_email: "Cambia connettore per email",
    options_change_sms: "Cambia connettore per SMS",
    connector_deleted: "Il connettore \xe8 stato eliminato con successo",
    type_email: "Connettore per email",
    type_sms: "Connettore per SMS",
    type_social: "Connettore social",
    in_used_social_deletion_description: "Questo connettore \xe8 in uso nella tua esperienza di accesso. Eliminandolo, l'esperienza di accesso di <name/> verr\xe0 eliminata nelle impostazioni dell'esperienza di accesso. Dovrai riconfigurarlo se decidi di aggiungerlo di nuovo.",
    in_used_passwordless_deletion_description: "Questo {{name}} \xe8 in uso nella tua esperienza di accesso. Eliminandolo, la tua esperienza di accesso non funzioner\xe0 correttamente fino a quando non risolverai il conflitto. Dovrai riconfigurarlo se decidi di aggiungerlo di nuovo.",
    deletion_description: "Stai rimuovendo questo connettore. Non pu\xf2 essere annullato e dovrai riconfigurarlo se decidi di aggiungerlo di nuovo.",
    logto_email: {
        total_email_sent: "Totale email inviate: {{value, number}}",
        total_email_sent_tip: "Logto utilizza SendGrid per l'invio sicuro ed affidabile delle email integrate. \xc8 completamente gratuito da utilizzare. <a>Scopri di pi\xf9</a>",
        email_template_title: "Modello email",
        template_description: "L'email integrata utilizza modelli predefiniti per la consegna senza soluzione di continuit\xe0 delle email di verifica. Non \xe8 richiesta alcuna configurazione e puoi personalizzare le informazioni di base del marchio.",
        template_description_link_text: "Visualizza modelli",
        description_action_text: "Visualizza i modelli",
        from_email_field: "Email mittente",
        sender_name_field: "Nome mittente",
        sender_name_tip: 'Personalizza il nome del mittente per le email. Se lasciato vuoto, verr\xe0 utilizzato "Verification" come nome predefinito.',
        sender_name_placeholder: "Il tuo nome mittente",
        company_information_field: "Informazioni aziendali",
        company_information_description: "Mostra il nome dell'azienda, l'indirizzo o il codice postale in fondo alle email per migliorare l'autenticit\xe0.",
        company_information_placeholder: "Le informazioni di base della tua azienda",
        app_logo_field: "Logo dell'app",
        app_logo_tip: "Mostra il logo del tuo marchio in cima alle email. Utilizza la stessa immagine per la modalit\xe0 chiara e scura.",
        urls_not_allowed: "URL non sono ammessi",
        test_notes: 'Logto utilizza il modello "Generico" per i test.'
    }
};
var $d9b858256fe4cc74$export$2e2bcd8739ae039 = Object.freeze($d9b858256fe4cc74$var$connector_details);


const $d1a7e7cf973e53f7$var$connectors = {
    page_title: "Connettori",
    title: "Connettori",
    subtitle: "Imposta i connettori per abilitare un'esperienza di accesso senza password e tramite social media",
    create: "Aggiungi connettore sociale",
    config_sie_notice: "Hai impostato i connettori. Assicurati di configurarli in <a>{{link}}</a>.",
    config_sie_link_text: "esperienza di accesso",
    tab_email_sms: "Connettori email e SMS",
    tab_social: "Connettori social",
    connector_name: "Nome del connettore",
    demo_tip: "Il numero massimo di messaggi consentiti per questo connettore demo \xe8 limitato a 100 e non \xe8 consigliato per il deployment in un ambiente di produzione.",
    social_demo_tip: "Il connettore demo \xe8 progettato esclusivamente per scopi di dimostrazione e non \xe8 consigliato per il deployment in un ambiente di produzione.",
    connector_type: "Tipo",
    connector_status: "Esperienza di accesso",
    connector_status_in_use: "In uso",
    connector_status_not_in_use: "Non in uso",
    not_in_use_tip: {
        content: "Non in uso significa che la tua esperienza di accesso non ha utilizzato questo metodo di accesso. <a>{{link}}</a> per aggiungere questo metodo di accesso.",
        go_to_sie: "Vai all'esperienza di accesso"
    },
    placeholder_title: "Connettore sociale",
    placeholder_description: "Logto ha fornito molti connettori di accesso condivisi tramite i social media, frattanto puoi creare il tuo usando i protocolli standard.",
    save_and_done: "Salva e Completa",
    type: {
        email: "Connettore email",
        sms: "Connettore SMS",
        social: "Connettore sociale"
    },
    setup_title: {
        email: "Imposta connettore email",
        sms: "Imposta connettore SMS",
        social: "Aggiungi connettore sociale"
    },
    guide: {
        subtitle: "Una guida passo passo per configurare il tuo connettore",
        general_setting: "Impostazioni generali",
        parameter_configuration: "Configurazione dei parametri",
        test_connection: "Prova la connessione",
        name: "Nome per il pulsante di accesso tramite social media",
        name_placeholder: "Inserisci il nome per il pulsante di accesso tramite social media",
        name_tip: 'Il nome del pulsante del connettore verr\xe0 visualizzato come "Continua con {{name}}." Presta attenzione alla lunghezza del nome in caso risulti troppo lungo.',
        logo: "URL del logo per il pulsante di accesso tramite social media",
        logo_placeholder: "https://your.cdn.domain/logo.png",
        logo_tip: "L'immagine del logo verr\xe0 mostrata sul connettore. Otteni un link di immagine pubblicamente accessibile e inserisci qui il link.",
        logo_dark: "URL del logo per il pulsante di accesso tramite social media (modalit\xe0 scura)",
        logo_dark_placeholder: "https://your.cdn.domain/logo.png",
        logo_dark_tip: "Imposta il logo del tuo connettore per la modalit\xe0 scura dopo averla abilitata nell'esperienza di accesso nel Console dell'Amministratore.",
        logo_dark_collapse: "Comprimi",
        logo_dark_show: "Mostra le impostazioni del logo per la modalit\xe0 scura",
        target: "Nome del provider di identit\xe0",
        target_placeholder: "Inserisci il nome del provider di identit\xe0 del connettore",
        target_tip: 'Il valore del "Nome IdP" pu\xf2 essere una stringa di identificatore univoco per distinguere le identit\xe0 social.',
        target_tip_standard: 'Il valore del "Nome IdP" pu\xf2 essere una stringa di identificatore univoco per distinguere le identit\xe0 social. Questa impostazione non pu\xf2 essere cambiata dopo la costruzione del connettore.',
        target_tooltip: "'Nome IdP' nei connettori social di Logto si riferisce alla 'fonte' delle tue identit\xe0 social media. Nel design di Logto, non accettiamo lo stesso 'Nome IdP' di una piattaforma specifica per evitare conflitti. Devi fare molta attenzione prima di aggiungere un connettore, poich\xe9 NON PUOI cambiarne il valore una volta creato. <a>Scopri di pi\xf9</a>",
        target_conflict: "Il nome IdP inserito corrisponde al connettore <span>nome</span> esistente. L'utilizzo dello stesso nome IdP potrebbe causare un comportamento di accesso imprevisto in cui gli utenti possono accedere allo stesso account tramite due connettori diversi.",
        target_conflict_line2: 'Se desideri sostituire il connettore corrente con lo stesso provider di identit\xe0 e consentire agli utenti precedenti di accedere senza registrarsi nuovamente, elimina il connettore <span>nome</span> e crea un nuovo connettore con lo stesso "Nome IdP".',
        target_conflict_line3: 'Se desideri connetterti a un provider di identit\xe0 diverso, modifica il "Nome IdP" e procedi.',
        config: "Inserisci il tuo JSON di configurazione",
        sync_profile: "Sincronizza le informazioni del profilo",
        sync_profile_only_at_sign_up: "Sincronizza solo al momento della registrazione",
        sync_profile_each_sign_in: "Effettua sempre una sincronizzazione ad ogni accesso",
        sync_profile_tip: "Sincronizza il profilo di base dal provider social, ad esempio i nomi degli utenti e le loro immagini del profilo.",
        callback_uri: "URI di callback",
        callback_uri_description: "Anche chiamato URI di reindirizzamento, \xe8 l'URI in Logto dove gli utenti verranno rimandati dopo l'autorizzazione tramite social media, copia e incollalo nella pagina di configurazione del provider social media.",
        acs_url: "URL del servizio consumer di assunzione"
    },
    platform: {
        universal: "Universale",
        web: "Web",
        native: "Native"
    },
    add_multi_platform: "supporta pi\xf9 piattaforme, seleziona una piattaforma per continuare",
    drawer_title: "Guida per il connettore",
    drawer_subtitle: "Segui le istruzioni per integrare il tuo connettore",
    unknown: "Connettore sconosciuto",
    standard_connectors: "Connettori standard"
};
var $d1a7e7cf973e53f7$export$2e2bcd8739ae039 = Object.freeze($d1a7e7cf973e53f7$var$connectors);


const $9c56fe8fa8cd962c$var$contact = {
    title: "Ottieni Aiuto",
    description: "Per richieste di assistenza o commenti sui prodotti, contattaci tramite i seguenti metodi.",
    discord: {
        title: "Unisciti alla community di Discord",
        description: "Connettiti con altri sviluppatori per trovare soluzioni",
        button: "Unisciti"
    },
    github: {
        title: "Comunica su GitHub",
        description: "Crea un problema e invialo su GitHub",
        button: "Apri"
    },
    email: {
        title: "Contattare il supporto tramite e-mail",
        description: "Invia una e-mail per ulteriori informazioni e assistenza",
        button: "Invia"
    },
    reserve: {
        title: "Prenota il tuo tempo con il team Logto",
        description: "Prenota rapidamente una sessione per una chat dal vivo",
        button: "Prenota"
    }
};
var $9c56fe8fa8cd962c$export$2e2bcd8739ae039 = Object.freeze($9c56fe8fa8cd962c$var$contact);


const $e79066ce84b22daa$var$dashboard = {
    page_title: "Dashboard",
    title: "Dashboard",
    description: "Ottieni una panoramica sulle prestazioni della tua app",
    total_users: "Totale utenti",
    total_users_tip: "Totale utenti",
    new_users_today: "Nuovi utenti oggi",
    new_users_today_tip: "Il numero di nuovi utenti registrati sulle tue app oggi",
    new_users_7_days: "Nuovi utenti negli ultimi 7 giorni",
    new_users_7_days_tip: "Il numero di nuovi utenti registrati sulle tue app negli ultimi 7 giorni",
    daily_active_users: "Utenti attivi giornalieri",
    daily_active_users_tip: "Il numero di utenti unici che hanno scambiato token sulle tue app oggi",
    weekly_active_users: "Utenti attivi settimanali",
    weekly_active_users_tip: "Il numero di utenti unici che hanno scambiato token sulle tue app negli ultimi 7 giorni",
    monthly_active_users: "Utenti attivi mensili",
    monthly_active_users_tip: "Il numero di utenti unici che hanno scambiato token sulle tue app negli ultimi 30 giorni"
};
var $e79066ce84b22daa$export$2e2bcd8739ae039 = Object.freeze($e79066ce84b22daa$var$dashboard);


const $3b2700d3bafe9f14$var$domain = {
    status: {
        connecting: "Connessione in corso...",
        in_use: "In uso",
        failed_to_connect: "Connessione fallita"
    },
    update_endpoint_notice: "Non dimenticare di aggiornare il dominio per l'URI di callback del connettore social e l'endpoint Logto nella tua applicazione se vuoi utilizzare un dominio personalizzato per le funzionalit\xe0. <a>{{link}}</a>",
    error_hint: "Assicurati di aggiornare i tuoi record DNS. Continueremo a controllarli ogni {{value}} secondi.",
    custom: {
        custom_domain: "Dominio personalizzato",
        custom_domain_description: "Migliora il tuo branding utilizzando un dominio personalizzato. Questo dominio verr\xe0 utilizzato nella tua esperienza di accesso.",
        custom_domain_field: "Dominio personalizzato",
        custom_domain_placeholder: "il-tuo-dominio.com",
        add_domain: "Aggiungi dominio",
        invalid_domain_format: 'Si prega di fornire un URL di dominio valido con un minimo di tre parti, ad esempio "tuo.dominio.com".',
        verify_domain: "Verifica dominio",
        enable_ssl: "Abilita SSL",
        checking_dns_tip: "Dopo aver configurato i record DNS, il processo verr\xe0 eseguito automaticamente e potrebbe richiedere fino a 24 ore. Puoi lasciare questa interfaccia durante l'esecuzione.",
        enable_ssl_tip: "Abilitare SSL verr\xe0 eseguito automaticamente e potrebbe richiedere fino a 24 ore. Puoi lasciare questa interfaccia durante l'esecuzione.",
        generating_dns_records: "Generazione dei record DNS in corso...",
        add_dns_records: "Inserisci questi record DNS nel tuo provider DNS.",
        dns_table: {
            type_field: "Tipo",
            name_field: "Nome",
            value_field: "Valore"
        },
        deletion: {
            delete_domain: "Elimina dominio",
            reminder: "Elimina dominio personalizzato",
            description: "Sei sicuro di voler eliminare questo dominio personalizzato?",
            in_used_description: 'Sei sicuro di voler eliminare questo dominio personalizzato "<span>{{domain}}</span>"?',
            in_used_tip: "Se hai configurato in precedenza questo dominio personalizzato nel tuo provider di connettore social o endpoint dell'applicazione, dovrai modificare l'URI nel dominio Logto predefinito \"<span>{{domain}}</span>\". \xc8 necessario per il corretto funzionamento del pulsante di accesso social.",
            deleted: "Dominio personalizzato eliminato con successo!"
        }
    },
    default: {
        default_domain: "Dominio predefinito",
        default_domain_description: "Logto offre un dominio preconfigurato predefinito, pronto all'uso senza alcuna configurazione aggiuntiva. Questo dominio predefinito serve come opzione di backup anche se hai abilitato un dominio personalizzato.",
        default_domain_field: "Dominio predefinito Logto"
    },
    custom_endpoint_note: 'Puoi personalizzare il nome di dominio di questi endpoint come richiesto. Scegli "{{custom}}" o "{{default}}".',
    custom_social_callback_url_note: 'Puoi personalizzare il nome di dominio di questo URI per corrispondere all\'endpoint della tua applicazione. Scegli "{{custom}}" o "{{default}}".',
    custom_acs_url_note: 'Puoi personalizzare il nome di dominio di questo URI per corrispondere all\'URL del servizio consumer assertion provider del tuo fornitore di identit\xe0. Scegli "{{custom}}" o "{{default}}".'
};
var $3b2700d3bafe9f14$export$2e2bcd8739ae039 = Object.freeze($3b2700d3bafe9f14$var$domain);


const $f22bf26b8728508b$var$enterprise_sso_details = {
    back_to_sso_connectors: "Torna ai connettori SSO aziendali",
    page_title: "Dettagli del connettore SSO aziendale",
    readme_drawer_title: "SSO aziendale",
    readme_drawer_subtitle: "Configura i connettori SSO aziendali per abilitare l'SSO degli utenti finali",
    tab_experience: "Esperienza SSO",
    tab_connection: "Connessione",
    general_settings_title: "Generale",
    custom_branding_title: "Display",
    custom_branding_description: "Personalizza il nome e il logo visualizzati nel flusso di accesso Single Sign-On degli utenti finali. Quando vuoto, vengono utilizzati i valori predefiniti.",
    email_domain_field_name: "Dominio email aziendale",
    email_domain_field_description: "Gli utenti con questo dominio email possono utilizzare l'SSO per l'autenticazione. Verifica che il dominio appartenga all'azienda.",
    email_domain_field_placeholder: "Dominio email",
    sync_profile_field_name: "Sincronizza le informazioni del profilo dal fornitore di identit\xe0",
    sync_profile_option: {
        register_only: "Sincronizza solo al primo accesso",
        each_sign_in: "Sincronizza sempre ad ogni accesso"
    },
    connector_name_field_name: "Nome connettore",
    display_name_field_name: "Nome visualizzato",
    connector_logo_field_name: "Logo visualizzato",
    connector_logo_field_description: "Ogni immagine deve essere inferiore a 500 KB, solo SVG, PNG, JPG, JPEG.",
    branding_logo_context: "Carica logo",
    branding_logo_error: "Errore caricamento logo: {{error}}",
    branding_light_logo_context: "Carica logo modalit\xe0 chiara",
    branding_light_logo_error: "Errore caricamento logo modalit\xe0 chiara: {{error}}",
    branding_logo_field_name: "Logo",
    branding_logo_field_placeholder: "https://tuo.domino/logo.png",
    branding_dark_logo_context: "Carica logo modalit\xe0 scura",
    branding_dark_logo_error: "Errore caricamento logo modalit\xe0 scura: {{error}}",
    branding_dark_logo_field_name: "Logo (modalit\xe0 scura)",
    branding_dark_logo_field_placeholder: "https://tuo.domino/logo-modalita-scura.png",
    check_connection_guide: "Guida alla connessione",
    enterprise_sso_deleted: "Il connettore SSO aziendale \xe8 stato eliminato con successo",
    delete_confirm_modal_title: "Elimina connettore SSO aziendale",
    delete_confirm_modal_content: "Sei sicuro di voler eliminare questo connettore aziendale? Gli utenti dai fornitori di identit\xe0 non utilizzeranno il Single Sign-On.",
    upload_idp_metadata_title_saml: "Carica i metadati",
    upload_idp_metadata_description_saml: "Configura i metadati copiati dal fornitore di identit\xe0.",
    upload_idp_metadata_title_oidc: "Carica le credenziali",
    upload_idp_metadata_description_oidc: "Configura le credenziali e le informazioni sul token OIDC copiate dal fornitore di identit\xe0.",
    upload_idp_metadata_button_text: "Carica file XML di metadati",
    upload_signing_certificate_button_text: "Carica file del certificato di firma",
    configure_domain_field_info_text: "Aggiungi il dominio email per guidare gli utenti aziendali al loro fornitore di identit\xe0 per il Single Sign-On.",
    email_domain_field_required: "Il dominio email \xe8 obbligatorio per abilitare l'SSO aziendale.",
    upload_saml_idp_metadata_info_text_url: "Incolla l'URL dei metadati dal fornitore di identit\xe0 per collegare.",
    upload_saml_idp_metadata_info_text_xml: "Incolla i metadati dal fornitore di identit\xe0 per collegare.",
    upload_saml_idp_metadata_info_text_manual: "Compila i metadati dal fornitore di identit\xe0 per collegare.",
    upload_oidc_idp_info_text: "Compila le informazioni dal fornitore di identit\xe0 per collegare.",
    service_provider_property_title: "Configura nell'IdP",
    service_provider_property_description: "Configura un'integrazione dell'applicazione utilizzando {{protocol}} nel tuo fornitore di identit\xe0. Inserisci i dettagli forniti da Logto.",
    attribute_mapping_title: "Mappatura attributi",
    attribute_mapping_description: "Sincronizza i profili degli utenti dal fornitore di identit\xe0 configurando la mappatura degli attributi degli utenti sul lato identit\xe0 o sul lato di Logto.",
    saml_preview: {
        sign_on_url: "URL di accesso",
        entity_id: "Emittente",
        x509_certificate: "Certificato di firma",
        certificate_content: "Scadenza {{date}}"
    },
    oidc_preview: {
        authorization_endpoint: "Punto di autorizzazione",
        token_endpoint: "Punto di token",
        userinfo_endpoint: "Punto di informazioni utente",
        jwks_uri: "Punto finale del set di chiavi JSON web",
        issuer: "Emittente"
    }
};
var $f22bf26b8728508b$export$2e2bcd8739ae039 = Object.freeze($f22bf26b8728508b$var$enterprise_sso_details);


const $a48364f807a90bdf$var$enterprise_sso = {
    page_title: "SSO aziendale",
    title: "SSO aziendale",
    subtitle: "Collega il provider di identit\xe0 aziendale e abilita l'accesso unico inizializzato dal fornitore di servizi.",
    create: "Aggiungi connettore aziendale",
    col_connector_name: "Nome connettore",
    col_type: "Tipo",
    col_email_domain: "Dominio email",
    placeholder_title: "Connettore aziendale",
    placeholder_description: "Logto ha fornito molti provider di identit\xe0 aziendale incorporati per connettersi, nel frattempo puoi creare il tuo con i protocolli SAML e OIDC.",
    create_modal: {
        title: "Aggiungi connettore aziendale",
        text_divider: "Oppure puoi personalizzare il tuo connettore con un protocollo standard.",
        connector_name_field_title: "Nome connettore",
        connector_name_field_placeholder: "E.g., {corp. name} - {identity provider name}",
        create_button_text: "Crea connettore"
    },
    guide: {
        subtitle: "Una guida passo passo per connettere il provider di identit\xe0 aziendale.",
        finish_button_text: "Continua"
    },
    basic_info: {
        title: "Configura il tuo servizio nell'IdP",
        description: "Crea una nuova integrazione dell'applicazione tramite SAML 2.0 nel tuo provider di identit\xe0 {{name}}. Quindi incolla il valore seguente.",
        saml: {
            acs_url_field_name: "URL del servizio consumer di asserzioni (URL di risposta)",
            audience_uri_field_name: "URI dell'audience (ID entit\xe0 SP)"
        },
        oidc: {
            redirect_uri_field_name: "URI di reindirizzamento (URL di callback)"
        }
    },
    attribute_mapping: {
        title: "Mappatura degli attributi",
        description: "`id` e `email` sono necessari per sincronizzare il profilo utente da IdP. Immetti il nome del claim e il valore seguenti nel tuo IdP.",
        col_sp_claims: "Valore del fornitore di servizi (Logto)",
        col_idp_claims: "Nome del claim del provider di identit\xe0",
        idp_claim_tooltip: "Il nome del claim del provider di identit\xe0"
    },
    metadata: {
        title: "Configura i metadati IdP",
        description: "Configura i metadati dal provider di identit\xe0",
        dropdown_trigger_text: "Utilizza un altro metodo di configurazione",
        dropdown_title: "seleziona il tuo metodo di configurazione",
        metadata_format_url: "Inserisci l'URL dei metadati",
        metadata_format_xml: "Carica il file XML dei metadati",
        metadata_format_manual: "Inserisci manualmente i dettagli dei metadati",
        saml: {
            metadata_url_field_name: "URL dei metadati",
            metadata_url_description: "Recupera dinamicamente i dati dall'URL dei metadati e mantieni aggiornato il certificato.",
            metadata_xml_field_name: "File XML dei metadati IdP",
            metadata_xml_uploader_text: "Carica il file XML dei metadati",
            sign_in_endpoint_field_name: "URL di accesso",
            idp_entity_id_field_name: "ID entit\xe0 IdP (Emittente)",
            certificate_field_name: "Certificato di firma",
            certificate_placeholder: "Copia e incolla il certificato x509",
            certificate_required: "Il certificato di firma \xe8 richiesto."
        },
        oidc: {
            client_id_field_name: "ID client",
            client_secret_field_name: "Segreto del client",
            issuer_field_name: "Emittente",
            scope_field_name: "Ambito"
        }
    }
};
var $a48364f807a90bdf$export$2e2bcd8739ae039 = Object.freeze($a48364f807a90bdf$var$enterprise_sso);


const $5496d6053f9dcdb1$var$errors = {
    something_went_wrong: "Oops! Si \xe8 verificato un errore.",
    page_not_found: "Pagina non trovata",
    unknown_server_error: "Si \xe8 verificato un errore del server sconosciuto",
    empty: "Nessun dato",
    missing_total_number: "Impossibile trovare Total-Number negli header di risposta",
    invalid_uri_format: "Formato URI non valido",
    invalid_origin_format: "Formato origine URI non valido",
    invalid_json_format: "Formato JSON non valido",
    invalid_regex: "Espressione regolare non valida",
    invalid_error_message_format: "Il formato del messaggio di errore non \xe8 valido.",
    required_field_missing: "Inserisci {{field}}",
    required_field_missing_plural: "Devi inserire almeno un {{field}}",
    more_details: "Ulteriori dettagli",
    username_pattern_error: "Il nome utente dovrebbe contenere solo lettere, numeri, o trattini bassi e non dovrebbe iniziare con un numero.",
    email_pattern_error: "L'indirizzo email non \xe8 valido.",
    phone_pattern_error: "Il numero di telefono non \xe8 valido.",
    insecure_contexts: "I contesti non sicuri (non HTTPS) non sono supportati.",
    unexpected_error: "Si \xe8 verificato un errore inaspettato.",
    not_found: "404 non trovato",
    create_internal_role_violation: "Stai creando un nuovo ruolo interno che \xe8 proibito da Logto. Prova un altro nome che non inizi con '#internal:'.",
    should_be_an_integer: "Deve essere un numero intero.",
    number_should_be_between_inclusive: "Il numero deve essere compreso tra {{min}} e {{max}} (inclusi)."
};
var $5496d6053f9dcdb1$export$2e2bcd8739ae039 = Object.freeze($5496d6053f9dcdb1$var$errors);


const $3bf2bb129e964f4b$var$general = {
    placeholder: "Segnaposto",
    submit: "Invia",
    skip: "Salta",
    next: "Avanti",
    back: "Indietro",
    retry: "Riprova",
    done: "Fatto",
    search: "Cerca",
    search_placeholder: "Cerca",
    clear_result: "Cancella risultati",
    save: "Salva",
    save_changes: "Salva modifiche",
    saved: "Salvato",
    discard: "Elimina",
    loading: "Caricamento...",
    redirecting: "Redirezione...",
    add: "Aggiungi",
    added: "Aggiunto",
    cancel: "Annulla",
    confirm: "Conferma",
    check_out: "Checkout",
    create: "Crea",
    set_up: "Imposta",
    customize: "Personalizza",
    enable: "Abilita",
    reminder: "Promemoria",
    edit: "Modifica",
    delete: "Elimina",
    deleted: "Eliminato",
    more_options: "PI\xd9 OPZIONI",
    close: "Chiudi",
    copy: "Copia",
    copying: "Copiare",
    copied: "Copiato",
    required: "Obbligatorio",
    add_another: "Aggiungi un altro",
    create_another: "Crea un altro",
    deletion_confirmation: "Sei sicuro di voler eliminare questo {{title}}?",
    settings_nav: "Impostazioni",
    unsaved_changes_warning: "Hai apportato alcune modifiche. Sei sicuro di voler lasciare questa pagina?",
    leave_page: "Lascia pagina",
    stay_on_page: "Rimani sulla pagina",
    type_to_search: "Digita per cercare",
    got_it: "Capito",
    continue: "Continua",
    page_info: "{{min, number}}-{{max, number}} di {{total, number}}",
    learn_more: "Scopri di pi\xf9",
    tab_errors: "{{count, number}} errori",
    skip_for_now: "Salta per ora",
    remove: "Rimuovi",
    visit: "Visita",
    join: "Unisciti",
    try_now: "Prova ora",
    multiple_form_field: "(Multiplo)",
    demo: "Demo",
    unnamed: "Senza nome",
    view: "Vista",
    open: "Apri",
    hide: "Nascondi",
    unknown_error: "Errore sconosciuto, riprova pi\xf9 tardi.",
    select: "Seleziona",
    contact_us_action: "Contattaci",
    description: "Descrizione",
    name: "Nome",
    add_field: "Aggiungi {{field}}",
    create_field: "Crea {{field}}",
    edit_field: "Modifica {{field}}",
    delete_field: "Elimina {{field}}",
    coming_soon: "Prossimamente",
    or: "O"
};
var $3bf2bb129e964f4b$export$2e2bcd8739ae039 = Object.freeze($3bf2bb129e964f4b$var$general);


const $3995cd686529f7b4$var$get_started = {
    page_title: "Inizia",
    title: "Esplora per avere successo",
    subtitle: "Alcune cose che puoi fare per ottenere rapidamente il valore di Logto",
    develop: {
        title: "Sviluppa: Dedica 5 minuti per integrare la tua app",
        title_cloud: "Sviluppa: Integra in modo sicuro la tua app in pochi minuti",
        subtitle_cloud: "Oppure impiega 5 minuti per integrare la tua app con i nostri SDK predefiniti e i tutorial."
    },
    customize: {
        title: "Personalizza: Offri un'ottima esperienza di accesso",
        preview: {
            title: "Controlla l'anteprima in tempo reale dell'esperienza di accesso appena personalizzata",
            subtitle: "Prova subito l'esperienza di accesso a Logto per vedere come funziona"
        },
        connector: {
            title: "Aggiungi pi\xf9 connettori per supportare pi\xf9 metodi di accesso sociali",
            subtitle: "Prova l'accesso senza password e abilita un'esperienza sicura e senza attriti per i tuoi clienti"
        },
        continue_customizing: "Continua la personalizzazione",
        try_now: "Prova ora",
        add_more: "Aggiungi altro"
    },
    secure: {
        title: "Sicurezza: Proteggi le tue risorse"
    },
    manage: {
        title: "Gestisci: Definisci il controllo di accesso per il tuo prodotto e gli utenti",
        rbac: {
            title: "Aggiungi il controllo degli accessi basato sui ruoli per proteggere le tue risorse",
            subtitle: "Controlla le tue risorse attraverso l'autorizzazione basata sui ruoli scalabile per casi d'uso diversi."
        },
        create_roles: "Crea ruoli"
    },
    view_all: "Visualizza tutto →"
};
var $3995cd686529f7b4$export$2e2bcd8739ae039 = Object.freeze($3995cd686529f7b4$var$get_started);


const $629be0cdf71a5332$var$guide = {
    start_building: "Inizia a costruire",
    get_started: "Comincia",
    categories: {
        featured: "Popolare e per te",
        Traditional: "Applicazione Web Tradizionale",
        SPA: "App a pagina singola",
        Native: "Nativo",
        MachineToMachine: "Dalla macchina alla macchina",
        Protected: "Integrazione non-SDK",
        ThirdParty: "App di terze parti"
    },
    filter: {
        title: "Filtra framework",
        placeholder: "Cerca framework"
    },
    checkout_tutorial: "Vedi il tutorial di {{name}}",
    do_not_need_tutorial: "Se non hai bisogno di un tutorial, puoi continuare senza una guida al framework",
    finish_and_done: "Termina e fine",
    cannot_find_guide: "Non riesci a trovare la tua guida?",
    describe_guide_looking_for: "Descrivi la guida che stai cercando",
    request_guide_successfully: "Il tuo richiesta \xe8 stata inviata con successo. Grazie!",
    app: {
        select_framework_or_tutorial: "Seleziona un framework o tutorial",
        guide_modal_title: "Inizia con l'SDK e le guide",
        modal_subtitle: "Sblocca il tuo processo di sviluppo dell'app con il nostro SDK e tutorial predefiniti.",
        select_a_framework: "Seleziona un framework",
        continue_without_framework: "Crea un'app senza framework",
        describe_guide_looking_for_placeholder: "Esempio: Voglio integrare Logto nella mia app Angular."
    },
    api: {
        modal_title: "Inizia con i tutorial",
        modal_subtitle: "Sblocca il tuo processo di sviluppo dell'app con i nostri tutorial predefiniti.",
        select_a_tutorial: "Seleziona un tutorial",
        continue_without_tutorial: "Continua senza tutorial",
        describe_guide_looking_for_placeholder: "Esempio: Voglio proteggere la mia API usando deno."
    }
};
var $629be0cdf71a5332$export$2e2bcd8739ae039 = Object.freeze($629be0cdf71a5332$var$guide);


const $03aa8a5c1a100830$var$invitation = {
    find_your_tenants: "Trova i tuoi inquilini",
    find_tenants_description: "Il tuo indirizzo email potrebbe gi\xe0 essere registrato con pi\xf9 inquilini. Puoi scegliere di unirti a quelli esistenti o continuare a crearne uno nuovo.",
    create_new_tenant: "Crea un nuovo inquilino",
    email_not_match_title: "Al momento hai effettuato l'accesso come\n{{email}}",
    email_not_match_description: "Effettua l'accesso con l'account corretto per accettare l'invito e diventare un membro dell'organizzazione.",
    switch_account: "Accedi con un altro account",
    invalid_invitation_status: "Invito non valido. Contatta l'amministratore e riprova.",
    invitation_not_found: "Invito non trovato. Contatta l'amministratore."
};
var $03aa8a5c1a100830$export$2e2bcd8739ae039 = Object.freeze($03aa8a5c1a100830$var$invitation);


const $04e3568b9a5684de$var$jwt_claims = {
    title: "JWT personalizzato",
    description: "Imposta richieste JWT personalizzate da includere nel token di accesso. Queste richieste possono essere utilizzate per passare informazioni aggiuntive alla tua applicazione.",
    user_jwt: {
        card_title: "Per utente",
        card_field: "Token di accesso utente",
        card_description: "Aggiungi dati specifici dell'utente durante l'emissione del token di accesso.",
        for: "per utente"
    },
    machine_to_machine_jwt: {
        card_title: "Per M2M",
        card_field: "Token da macchina a macchina",
        card_description: "Aggiungi dati extra durante l'emissione del token da macchina a macchina.",
        for: "per M2M"
    },
    code_editor_title: "Personalizza le richieste {{token}}",
    custom_jwt_create_button: "Aggiungi richieste personalizzate",
    custom_jwt_item: "Richieste personalizzate {{for}}",
    delete_modal_title: "Elimina richieste personalizzate",
    delete_modal_content: "Sei sicuro di voler eliminare le richieste personalizzate?",
    clear: "Pulisci",
    cleared: "Pulito",
    restore: "Ripristina predefiniti",
    restored: "Ripristinato",
    data_source_tab: "Sorgente dati",
    test_tab: "Contesto di test",
    jwt_claims_description: "Le richieste predefinite sono incluse automaticamente nel JWT e non possono essere sovrascritte.",
    user_data: {
        title: "Dati utente",
        subtitle: "Utilizza il parametro di input `data.user` per fornire informazioni vitali sull'utente."
    },
    token_data: {
        title: "Dati token",
        subtitle: "Utilizza il parametro di input `token` per il payload corrente del token di accesso. "
    },
    fetch_external_data: {
        title: "Recupera dati esterni",
        subtitle: "Incorpora dati direttamente dai tuoi API esterni nelle richieste.",
        description: "Utilizza la funzione `fetch` per chiamare le tue API esterne e includere i dati nelle richieste personalizzate. Esempio: "
    },
    environment_variables: {
        title: "Imposta variabili d'ambiente",
        subtitle: "Utilizza variabili d'ambiente per memorizzare informazioni sensibili.",
        input_field_title: "Aggiungi variabili d'ambiente",
        sample_code: "Accesso alle variabili d'ambiente nel gestore delle richieste JWT personalizzate. Esempio: "
    },
    jwt_claims_hint: "Limita le richieste personalizzate a meno di 50KB. Le richieste JWT predefinite sono incluse automaticamente nel token e non possono essere sovrascritte.",
    tester: {
        subtitle: "Regola il token fittizio e i dati utente per il test.",
        run_button: "Esegui test",
        result_title: "Risultato del test"
    },
    form_error: {
        invalid_json: "Formato JSON non valido"
    }
};
var $04e3568b9a5684de$export$2e2bcd8739ae039 = Object.freeze($04e3568b9a5684de$var$jwt_claims);


const $b9be121f1c40ca21$var$log_details = {
    page_title: "Dettagli registro di verifica",
    back_to_logs: "Torna ai log di verifica",
    back_to: "Torna a {{name}}",
    success: "Successo",
    failed: "Fallito",
    event_key: "Chiave evento",
    application: "Applicazione",
    ip_address: "Indirizzo IP",
    user: "Utente",
    log_id: "ID registro",
    time: "Tempo",
    user_agent: "User agent",
    tab_details: "Dettagli",
    raw_data: "Dati grezzi"
};
var $b9be121f1c40ca21$export$2e2bcd8739ae039 = Object.freeze($b9be121f1c40ca21$var$log_details);


const $fe62f975da263be0$var$logs = {
    page_title: "Log di Audit",
    title: "Log di Audit",
    subtitle: "Visualizza i dati di registro degli eventi di autenticazione effettuati dai tuoi utenti",
    event: "Evento",
    user: "Utente",
    application: "Applicazione",
    time: "Tempo",
    filter_by: "Filtra per"
};
var $fe62f975da263be0$export$2e2bcd8739ae039 = Object.freeze($fe62f975da263be0$var$logs);


const $917e0ed66a9be1c6$var$menu = {
    profile: "Profilo",
    language: "Lingua",
    appearance: {
        label: "Aspetto",
        light: "Modalit\xe0 chiaro",
        dark: "Modalit\xe0 scuro",
        system: "Sincronizza con sistema"
    },
    sign_out: "Esci"
};
var $917e0ed66a9be1c6$export$2e2bcd8739ae039 = Object.freeze($917e0ed66a9be1c6$var$menu);


const $4e9ab97e7db52847$var$mfa = {
    title: "Autenticazione a pi\xf9 fattori",
    description: "Aggiungi l'autenticazione a pi\xf9 fattori per elevare la sicurezza della tua esperienza di accesso.",
    factors: "Fattori",
    multi_factors: "Multi-fattori",
    multi_factors_description: "Gli utenti devono verificare uno dei fattori abilitati per la verifica a due passaggi.",
    totp: "OTP dell'app autenticatore",
    otp_description: "Collega Google Authenticator, ecc., per verificare le password monouso.",
    webauthn: "WebAuthn (Passkey)",
    webauthn_description: "Verifica tramite un metodo supportato dal browser: biometria, scansione del telefono o chiave di sicurezza, ecc.",
    webauthn_native_tip: "WebAuthn non \xe8 supportato per le applicazioni native.",
    webauthn_domain_tip: "WebAuthn lega le chiavi pubbliche al dominio specifico. Modificare il dominio del servizio impedir\xe0 agli utenti di autenticarsi tramite le passkey esistenti.",
    backup_code: "Codice di backup",
    backup_code_description: "Genera 10 codici di backup monouso dopo che gli utenti hanno configurato qualsiasi metodo MFA.",
    backup_code_setup_hint: "Quando gli utenti non possono verificare i suddetti fattori MFA, utilizzare l'opzione di backup.",
    backup_code_error_hint: "Per utilizzare un codice di backup, \xe8 necessario almeno un altro metodo MFA per un'autenticazione utente riuscita.",
    policy: "Politica",
    policy_description: "Imposta la politica MFA per i flussi di accesso e registrazione.",
    two_step_sign_in_policy: "Politica di verifica a due passaggi all'accesso",
    user_controlled: "Gli utenti possono abilitare o disabilitare MFA autonomamente",
    user_controlled_tip: "Gli utenti possono saltare la configurazione MFA la prima volta all'accesso o alla registrazione, o abilitarla/disabilitarla nelle impostazioni dell'account.",
    mandatory: "Gli utenti devono sempre utilizzare MFA all'accesso",
    mandatory_tip: "Gli utenti devono configurare MFA la prima volta all'accesso o alla registrazione, e usarlo per tutti gli accessi futuri."
};
var $4e9ab97e7db52847$export$2e2bcd8739ae039 = Object.freeze($4e9ab97e7db52847$var$mfa);


const $f5a2e3db1982f438$var$organization_details = {
    page_title: "Dettagli dell'organizzazione",
    delete_confirmation: "Una volta eliminato, tutti i membri perderanno la loro iscrizione e ruoli in questa organizzazione. Quest'azione non pu\xf2 essere annullata.",
    organization_id: "ID organizzazione",
    settings_description: "Le organizzazioni rappresentano i team, i clienti aziendali e le societ\xe0 partner che possono accedere alle tue applicazioni.",
    name_placeholder: "Il nome dell'organizzazione, non \xe8 necessario che sia univoco.",
    description_placeholder: "Una descrizione dell'organizzazione.",
    member: "Membro",
    member_other: "Membri",
    add_members_to_organization: "Aggiungi membri all'organizzazione {{name}}",
    add_members_to_organization_description: "Trova gli utenti appropriati cercando per nome, email, telefono o ID utente. Gli utenti gi\xe0 esistenti non vengono mostrati nei risultati della ricerca.",
    add_with_organization_role: "Aggiungi con ruolo(i) dell'organizzazione",
    user: "Utente",
    authorize_to_roles: "Autorizza {{name}} ad accedere ai seguenti ruoli:",
    edit_organization_roles: "Modifica ruoli dell'organizzazione",
    edit_organization_roles_of_user: "Modifica ruoli dell'organizzazione di {{name}}",
    remove_user_from_organization: "Rimuovi utente dall'organizzazione",
    remove_user_from_organization_description: "Una volta rimosso, l'utente perder\xe0 la sua iscrizione e i ruoli in questa organizzazione. Quest'azione non pu\xf2 essere annullata.",
    search_user_placeholder: "Cerca per nome, email, telefono o ID utente",
    at_least_one_user: "\xc8 richiesto almeno un utente.",
    custom_data: "Dati personalizzati",
    custom_data_tip: "I dati personalizzati sono un oggetto JSON che pu\xf2 essere utilizzato per archiviare dati aggiuntivi associati all'organizzazione.",
    invalid_json_object: "Oggetto JSON non valido."
};
var $f5a2e3db1982f438$export$2e2bcd8739ae039 = Object.freeze($f5a2e3db1982f438$var$organization_details);


const $a5e5adc3e7b593d0$var$organization_role_details = {
    page_title: "Dettagli del ruolo dell'organizzazione",
    back_to_org_roles: "Torna ai ruoli dell'organizzazione",
    org_role: "Ruolo dell'organizzazione",
    delete_confirm: "Facendo ci\xf2, verranno rimossi i permessi associati a questo ruolo dagli utenti interessati e verranno eliminati i rapporti tra ruoli organizzativi, membri nell'organizzazione e permessi dell'organizzazione.",
    deleted: "Il ruolo dell'organizzazione {{name}} \xe8 stato cancellato con successo.",
    permissions: {
        tab: "Autorizzazioni",
        name_column: "Autorizzazione",
        description_column: "Descrizione",
        type_column: "Tipo di autorizzazione",
        type: {
            api: "Autorizzazione API",
            org: "Autorizzazione organizzazione"
        },
        assign_permissions: "Assegna autorizzazioni",
        remove_permission: "Rimuovi permesso",
        remove_confirmation: "Se questo permesso viene rimosso, l'utente con questo ruolo organizzativo perder\xe0 l'accesso concessogli da questo permesso.",
        removed: "Il permesso {{name}} \xe8 stato rimosso con successo da questo ruolo organizzativo",
        assign_description: "Assegna le autorizzazioni ai ruoli all'interno di questa organizzazione. Queste possono includere sia autorizzazioni dell'organizzazione che autorizzazioni API.",
        organization_permissions: "Autorizzazioni dell'organizzazione",
        api_permissions: "Autorizzazioni API",
        assign_organization_permissions: "Assegna permessi di organizzazione",
        assign_api_permissions: "Assegna permessi API"
    },
    general: {
        tab: "Generale",
        settings: "Impostazioni",
        description: "Il ruolo dell’organizzazione \xe8 un raggruppamento di permessi che possono essere assegnati agli utenti. I permessi possono derivare dai permessi dell’organizzazione predefiniti e dai permessi API.",
        name_field: "Nome",
        description_field: "Descrizione",
        description_field_placeholder: "Utenti con permessi di sola visualizzazione"
    }
};
var $a5e5adc3e7b593d0$export$2e2bcd8739ae039 = Object.freeze($a5e5adc3e7b593d0$var$organization_role_details);


const $8f2cfb17739b6542$var$organization_template = {
    title: "Modello di organizzazione",
    subtitle: "Nelle applicazioni SaaS multi-tenant, un modello organizzativo definisce politiche di controllo dell'accesso condivise (permessi e ruoli) per molteplici organizzazioni.",
    roles: {
        tab_name: "Ruoli org",
        search_placeholder: "Cerca per nome del ruolo",
        create_title: "Crea ruolo org",
        role_column: "Ruolo org",
        permissions_column: "Permessi",
        placeholder_title: "Ruolo di organizzazione",
        placeholder_description: "Il ruolo di organizzazione \xe8 un raggruppamento di permessi che possono essere assegnati agli utenti. I permessi devono provenire dai permessi di organizzazione predefiniti.",
        create_modal: {
            title: "Crea ruolo dell'organizzazione",
            create: "Crea ruolo",
            name_field: "Nome del ruolo",
            description_field: "Descrizione",
            created: "Il ruolo dell'organizzazione {{name}} \xe8 stato creato con successo."
        }
    },
    permissions: {
        tab_name: "Permessi org",
        search_placeholder: "Cerca per nome del permesso",
        create_org_permission: "Crea permesso org",
        permission_column: "Autorizzazione dell'organizzazione",
        description_column: "Descrizione",
        placeholder_title: "Permesso di organizzazione",
        placeholder_description: "Il permesso di organizzazione si riferisce all’autorizzazione ad accedere a una risorsa nel contesto dell’organizzazione.",
        delete_confirm: "Se questo permesso viene eliminato, tutti i ruoli di organizzazione che includono questo permesso perderanno tale permesso, e gli utenti che avevano questo permesso perderanno l’accesso concesso da esso.",
        create_title: "Crea permesso di organizzazione",
        edit_title: "Modifica permesso di organizzazione",
        permission_field_name: "Nome del permesso",
        description_field_name: "Descrizione",
        description_field_placeholder: "Leggi la cronologia degli appuntamenti",
        create_permission: "Crea permesso",
        created: "Permesso creato con successo"
    }
};
var $8f2cfb17739b6542$export$2e2bcd8739ae039 = Object.freeze($8f2cfb17739b6542$var$organization_template);


const $2fcca328776342ae$var$organizations = {
    organization: "Organizzazione",
    page_title: "Organizzazioni",
    title: "Organizzazioni",
    subtitle: "Le organizzazioni sono solitamente utilizzate in app SaaS o simili multi-tenant e rappresentano i tuoi clienti che sono team, organizzazioni o intere aziende. Le organizzazioni funzionano come elemento fondamentale per l'autenticazione e l'autorizzazione B2B.",
    organization_template: "Modello organizzazione",
    organization_id: "ID organizzazione",
    members: "Membri",
    create_organization: "Crea organizzazione",
    setup_organization: "Configura la tua organizzazione",
    organization_list_placeholder_title: "Organizzazione",
    organization_list_placeholder_text: "Le organizzazioni sono spesso utilizzate in app SaaS o simili multi-tenant come pratica consigliata. Ti consentono di sviluppare app che permettono ai clienti di creare e gestire organizzazioni, invitare membri e assegnare ruoli.",
    organization_name_placeholder: "La mia organizzazione",
    organization_description_placeholder: "Una breve descrizione dell'organizzazione",
    organization_permission: "Permessi organizzazione",
    organization_permission_other: "Permessi organizzazione",
    create_permission_placeholder: "Leggi la cronologia degli appuntamenti",
    organization_role: "Ruolo organizzazione",
    organization_role_other: "Ruoli organizzazione",
    organization_role_description: "Il ruolo organizzativo \xe8 un raggruppamento di permessi che possono essere assegnati agli utenti. I permessi devono provenire dai permessi organizzativi predefiniti.",
    role: "Ruolo",
    search_placeholder: "Cerca per nome o ID dell'organizzazione",
    search_role_placeholder: "Digita per cercare e selezionare i ruoli",
    empty_placeholder: "\uD83E\uDD14 Non hai ancora impostato nessun {{entity}}.",
    organization_and_member: "Organizzazione e membri",
    organization_and_member_description: 'L\'organizzazione \xe8 un gruppo di utenti e pu\xf2 rappresentare i team, i clienti business e le aziende partner, con ciascun utente che \xe8 un "Membro". Queste possono essere entit\xe0 fondamentali per gestire i tuoi requisiti multi-tenant.',
    guide: {
        title: "Inizia con le guide",
        subtitle: "Inizia con le impostazioni dell'organizzazione con le nostre guide",
        introduction: {
            title: "Capire come funziona l'organizzazione in Logto",
            section_1: {
                title: "Un'organizzazione \xe8 un gruppo di utenti (identit\xe0)"
            },
            section_2: {
                title: "Il modello organizzativo \xe8 progettato per il controllo degli accessi alle app multi-tenant",
                description: 'Nelle applicazioni SaaS multi-inquilino, spesso pi\xf9 organizzazioni condividono lo stesso modello di controllo degli accessi, che include permessi e ruoli. In Logto, lo chiamiamo "modello organizzativo".',
                permission_description: "Il permesso organizzativo si riferisce all'autorizzazione per accedere a una risorsa nel contesto dell'organizzazione.",
                role_description_deprecated: "Il ruolo organizzativo \xe8 un raggruppamento di permessi organizzativi che possono essere assegnati ai membri.",
                role_description: "Il ruolo dell'organizzazione \xe8 un raggruppamento di permessi dell'organizzazione o permessi API che possono essere assegnati ai membri."
            },
            section_3: {
                title: "Posso assegnare permessi API ai ruoli dell'organizzazione?",
                description: "S\xec, puoi assegnare permessi API ai ruoli dell'organizzazione. Logto offre la flessibilit\xe0 di gestire efficacemente i ruoli della tua organizzazione, permettendoti di includere sia permessi organizzativi che permessi API in tali ruoli."
            },
            section_4: {
                title: "Interagisci con l'illustrazione per vedere come tutto si collega",
                description: "Prendiamo un esempio. John, Sarah sono in diverse organizzazioni con ruoli diversi nel contesto di organizzazioni diverse. Passa il mouse sui diversi moduli e guarda cosa succede."
            }
        },
        organization_permissions: "Permessi organizzazione",
        organization_roles: "Ruoli organizzazione",
        admin: "Amministratore",
        member: "Membro",
        guest: "Ospite",
        role_description: 'Il ruolo "{{role}}" condivide lo stesso modello organizzativo tra diverse organizzazioni.',
        john: "John",
        john_tip: "John appartiene a due organizzazioni con l'email \"john@email.com\" come unico identificatore. \xc8 l'amministratore dell'organizzazione A e ospite dell'organizzazione B.",
        sarah: "Sarah",
        sarah_tip: "Sarah appartiene a un'organizzazione con l'email \"sarah@email.com\" come unico identificatore. \xc8 l'amministratore dell'organizzazione B."
    }
};
var $2fcca328776342ae$export$2e2bcd8739ae039 = Object.freeze($2fcca328776342ae$var$organizations);


const $09a2539ee8ee92d7$var$permissions = {
    search_placeholder: "Cerca per nome API o permesso",
    search_placeholder_without_api: "Cerca per nome permesso",
    name_column: "Permesso",
    description_column: "Descrizione",
    api_column: "API",
    placeholder_title: "Permesso",
    placeholder_description: "Il permesso si riferisce all'autorizzazione per accedere ad una risorsa (la chiamiamo risorsa API).",
    edit: "Permesso di modifica",
    delete: "Permesso di cancellazione",
    remove: "Permesso di rimozione",
    edit_title: "Modifica permesso API"
};
var $09a2539ee8ee92d7$export$2e2bcd8739ae039 = Object.freeze($09a2539ee8ee92d7$var$permissions);


const $80ddb45b695f48ca$var$profile = {
    page_title: "Impostazioni Account",
    title: "Impostazioni Account",
    description: "Cambia le tue impostazioni account e gestisci le tue informazioni personali qui per garantire la sicurezza del tuo account.",
    settings: {
        title: "IMPOSTAZIONI PROFILO",
        profile_information: "Informazioni profilo",
        avatar: "Avatar",
        name: "Nome",
        username: "Nome utente"
    },
    link_account: {
        title: "COLLEGA ACCOUNT",
        email_sign_in: "Accesso con email",
        email: "Email",
        social_sign_in: "Accesso con social media",
        link_email: "Collega email",
        link_email_subtitle: "Collega la tua email per accedere o per recuperare l'account.",
        email_required: "L'email \xe8 obbligatoria",
        invalid_email: "Indirizzo email non valido",
        identical_email_address: "L'indirizzo email inserito \xe8 identico a quello corrente",
        anonymous: "Anonimo"
    },
    password: {
        title: "PASSWORD E SICUREZZA",
        password: "Password",
        password_setting: "Impostazione password",
        new_password: "Nuova password",
        confirm_password: "Conferma password",
        enter_password: "Inserisci la password attuale",
        enter_password_subtitle: "Verifica che sei tu per proteggere la sicurezza del tuo account. Inserisci la tua password attuale prima di cambiarla.",
        set_password: "Imposta password",
        verify_via_password: "Verifica tramite password",
        show_password: "Mostra password",
        required: "La password \xe8 obbligatoria",
        do_not_match: "Le password non corrispondono. Riprova."
    },
    code: {
        enter_verification_code: "Inserisci il codice di verifica",
        enter_verification_code_subtitle: "Il codice di verifica \xe8 stato inviato a <strong>{{target}}</strong>",
        verify_via_code: "Verifica tramite codice di verifica",
        resend: "Invia nuovamente il codice di verifica",
        resend_countdown: "Invia nuovamente in {{countdown}} secondi"
    },
    delete_account: {
        title: "ELIMINA ACCOUNT",
        label: "Elimina account",
        description: "Eliminando il tuo account, verranno rimossi tutti i tuoi dati personali, le informazioni utente, la configurazione. Questa operazione non pu\xf2 essere annullata.",
        button: "Elimina account",
        dialog_paragraph_1: "Ci dispiace sapere che desideri eliminare il tuo account. L'eliminazione dell'account rimuover\xe0 permanentemente tutti i dati, inclusi le informazioni utente, i log e le impostazioni, e questa azione non pu\xf2 essere annullata. Quindi assicurati di eseguire il backup di eventuali dati importanti prima di procedere.",
        dialog_paragraph_2: "Per procedere con il processo di eliminazione dell'account, invia un'email al nostro team di supporto all'indirizzo <a>{{mail}}</a> con l'oggetto \"Richiesta di eliminazione account\". Ti assisteremo e ci assicureremo che tutti i tuoi dati siano correttamente eliminati dal nostro sistema.",
        dialog_paragraph_3: "Grazie per aver scelto Logto Cloud. Se hai ulteriori domande o dubbi, non esitare a contattarci."
    },
    set: "Imposta",
    change: "Cambia",
    link: "Collega",
    unlink: "Scollega",
    not_set: "Non impostato",
    change_avatar: "Cambia avatar",
    change_name: "Cambia nome",
    change_username: "Cambia nome utente",
    set_name: "Imposta nome",
    email_changed: "Email modificata.",
    password_changed: "Password modificata.",
    updated: "{{target}} aggiornato.",
    linked: "{{target}} collegato.",
    unlinked: "{{target}} scollegato.",
    email_exists_reminder: "Questa email {{email}} \xe8 associata a un account esistente. Collega un'altra email qui.",
    unlink_confirm_text: "S\xec, scollega",
    unlink_reminder: "Gli utenti non potranno pi\xf9 accedere tramite l'account <span></span> se lo scolleghi. Sicuro di procedere?"
};
var $80ddb45b695f48ca$export$2e2bcd8739ae039 = Object.freeze($80ddb45b695f48ca$var$profile);


const $18ab60f0fe1e1ec6$var$protected_app = {
    name: "Applicazione Protetta",
    title: "Crea un'App Protetta: Aggiungi autenticazione con semplicit\xe0 e velocit\xe0 epica",
    description: "L'App protetta mantiene in modo sicuro le sessioni degli utenti e instrada le richieste della tua app. Alimentata da Cloudflare Workers, godi delle prestazioni di alto livello e dell'avvio istantaneo da 0 ms in tutto il mondo. <a>Scopri di pi\xf9</a>",
    fast_create: "Creazione rapida",
    modal_title: "Crea un'App Protetta",
    modal_subtitle: "Abilita una protezione sicura e veloce con pochi clic. Aggiungi facilmente autenticazione alla tua app web esistente.",
    form: {
        url_field_label: "URL di origine",
        url_field_placeholder: "https://dominio.com/",
        url_field_description: "Fornisci l'indirizzo della tua app che richiede protezione tramite autenticazione.",
        url_field_modification_notice: "Le modifiche all'URL di origine possono impiegare da 1 a 2 minuti per diventare effettive in tutte le posizioni della rete globale.",
        url_field_tooltip: "Fornisci l'indirizzo della tua applicazione, escludendo qualsiasi '/percorso'. Dopo la creazione, puoi personalizzare le regole di autenticazione del percorso.\n\nNota: L'URL di origine di per s\xe9 non richiede autenticazione; la protezione \xe8 applicata esclusivamente agli accessi tramite il dominio dell'app designato.",
        domain_field_label: "Dominio dell'App",
        domain_field_placeholder: "tuo-dominio",
        domain_field_description: "Questo URL funge da proxy di protezione dell'autenticazione per l'URL originale. Il dominio personalizzato pu\xf2 essere applicato dopo la creazione.",
        domain_field_description_short: "Questo URL funge da proxy di protezione dell'autenticazione per l'URL originale.",
        domain_field_tooltip: "Le app protette da Logto saranno ospitate di default su 'tuo-dominio.{{domain}}'. Il dominio personalizzato pu\xf2 essere applicato dopo la creazione.",
        create_application: "Crea applicazione",
        create_protected_app: "Creazione rapida",
        errors: {
            domain_required: "Il tuo dominio \xe8 obbligatorio.",
            domain_in_use: "Questo nome sottodominio \xe8 gi\xe0 in uso.",
            invalid_domain_format: "Formato di sottodominio non valido: utilizza solo lettere minuscole, numeri e trattini '-'.",
            url_required: "L'URL di origine \xe8 obbligatorio.",
            invalid_url: "Formato URL di origine non valido: Usa http:// o https://. Nota: '/percorso' non \xe8 attualmente supportato.",
            localhost: "Si prega di esporre prima il proprio server locale su Internet. Scopri di pi\xf9 su <a>sviluppo locale</a>."
        }
    },
    success_message: "\uD83C\uDF89 Autenticazione dell'app abilitata con successo! Esplora la nuova esperienza del tuo sito web."
};
var $18ab60f0fe1e1ec6$export$2e2bcd8739ae039 = Object.freeze($18ab60f0fe1e1ec6$var$protected_app);


const $c441d23561407662$var$role_details = {
    back_to_roles: "Torna ai Ruoli",
    identifier: "Identificatore",
    delete_description: "Ci\xf2 canceller\xe0 anche i permessi associati a questo ruolo dagli utenti coinvolti e canceller\xe0 la corrispondenza tra ruoli, utenti e permessi.",
    role_deleted: "{{name}} \xe8 stato cancellato con successo.",
    general_tab: "Generale",
    users_tab: "Utenti",
    m2m_apps_tab: "App macchina-to-macchina",
    permissions_tab: "Permessi",
    settings: "Impostazioni",
    settings_description: "I ruoli sono un raggruppamento di autorizzazioni che possono essere assegnate agli utenti. Forniscono anche un modo per aggregare le autorizzazioni definite per diverse API, rendendo pi\xf9 efficiente l'aggiunta, la rimozione o la regolazione delle autorizzazioni rispetto all'assegnazione individuale agli utenti.",
    field_name: "Nome",
    field_description: "Descrizione",
    field_is_default: "Ruolo predefinito",
    field_is_default_description: "Imposta questo ruolo come ruolo predefinito per i nuovi utenti. Possono essere impostati pi\xf9 ruoli predefiniti. Ci\xf2 influenzer\xe0 anche i ruoli predefiniti per gli utenti creati tramite l'API di gestione.",
    type_m2m_role_tag: "Ruolo app macchina-to-macchina",
    type_user_role_tag: "Ruolo utente",
    m2m_role_notification: "Assegna questo ruolo di macchina a macchina a un'applicazione di macchina a macchina per concedere l'accesso alle risorse API relative. <a>Crea prima un'applicazione di macchina a macchina</a> se non l'hai ancora fatto.",
    permission: {
        assign_button: "Assegna permessi",
        assign_title: "Assegna permessi",
        assign_subtitle: "Assegna autorizzazioni a questo ruolo. Il ruolo acquisir\xe0 le autorizzazioni aggiunte e gli utenti con questo ruolo erediteranno queste autorizzazioni.",
        assign_form_field: "Assegna permessi",
        added_text_one: "{{count, number}} permesso aggiunto",
        added_text_other: "{{count, number}} autorizzazioni aggiunte",
        api_permission_count_one: "{{count, number}} permesso",
        api_permission_count_other: "{{count, number}} autorizzazioni",
        confirm_assign: "Assegna permessi",
        permission_assigned: "Le autorizzazioni selezionate sono state assegnate con successo a questo ruolo",
        deletion_description: "Se questa autorizzazione viene rimossa, l'utente interessato con questo ruolo perder\xe0 l'accesso garantito da questa autorizzazione.",
        permission_deleted: 'La permissione "{{name}}" \xe8 stata rimossa con successo da questo ruolo',
        empty: "Nessuna autorizzazione disponibile"
    },
    users: {
        assign_button: "Assegna utenti",
        name_column: "Utente",
        app_column: "App",
        latest_sign_in_column: "Ultimo accesso",
        delete_description: "Rester\xe0 nella tua raccolta di utenti ma perder\xe0 l'autorizzazione per questo ruolo.",
        deleted: "{{name}} \xe8 stato rimosso con successo da questo ruolo",
        assign_title: "Assegna utenti",
        assign_subtitle: "Assegna utenti a questo ruolo. Trova utenti appropriati cercando nome, email, telefono o ID utente.",
        assign_field: "Assegna utenti",
        confirm_assign: "Assegna utenti",
        assigned_toast_text: "Gli utenti selezionati sono stati assegnati con successo a questo ruolo",
        empty: "Nessun utente disponibile"
    },
    applications: {
        assign_button: "Assegna applicazioni",
        name_column: "Applicazione",
        app_column: "App",
        description_column: "Descrizione",
        delete_description: "Rimarr\xe0 nel pool delle tue applicazioni ma perder\xe0 l'autorizzazione per questo ruolo.",
        deleted: "{{name}} \xe8 stato rimosso con successo da questo ruolo",
        assign_title: "Assegna applicazioni",
        assign_subtitle: "Assegna applicazioni a questo ruolo. Trova le applicazioni appropriate cercando nome, descrizione o ID app.",
        assign_field: "Assegna applicazioni",
        confirm_assign: "Assegna applicazioni",
        assigned_toast_text: "Le applicazioni selezionate sono state assegnate con successo a questo ruolo",
        empty: "Nessuna applicazione disponibile"
    }
};
var $c441d23561407662$export$2e2bcd8739ae039 = Object.freeze($c441d23561407662$var$role_details);


const $0f3b0968240354d6$var$roles = {
    page_title: "Ruoli",
    title: "Ruoli",
    subtitle: "I ruoli includono le autorizzazioni che determinano ci\xf2 che un utente pu\xf2 fare. RBAC utilizza i ruoli per dare agli utenti l'accesso alle risorse necessarie per specifiche azioni.",
    create: "Crea Ruolo",
    role_name: "Nome ruolo",
    role_type: "Tipo ruolo",
    show_role_type_button_text: "Mostra altre opzioni",
    hide_role_type_button_text: "Nascondi altre opzioni",
    type_user: "Ruolo utente",
    type_machine_to_machine: "Ruolo app M2M",
    role_description: "Descrizione",
    role_name_placeholder: "Inserisci il nome del tuo ruolo",
    role_description_placeholder: "Inserisci la descrizione del tuo ruolo",
    col_roles: "Ruoli",
    col_type: "Tipo",
    col_description: "Descrizione",
    col_assigned_entities: "Assegnati",
    user_counts: "{{count}} utenti",
    application_counts: "{{count}} app",
    user_count: "{{count}} utente",
    application_count: "{{count}} app",
    assign_permissions: "Assegna autorizzazioni",
    create_role_title: "Crea Ruolo",
    create_role_description: "Crea e gestisci ruoli per le tue applicazioni. I ruoli contengono collezioni di autorizzazioni e possono essere assegnati agli utenti.",
    create_role_button: "Crea Ruolo",
    role_created: "Il ruolo {{name}} \xe8 stato creato con successo.",
    search: "Cerca per nome, descrizione o ID del ruolo",
    placeholder_title: "Ruoli",
    placeholder_description: "I ruoli sono un raggruppamento di autorizzazioni che possono essere assegnati agli utenti. Assicurati di aggiungere le autorizzazioni prima di creare i ruoli.",
    assign_user_roles: "Assegna ruoli utente",
    assign_m2m_roles: "Assegna ruoli da macchina a macchina",
    management_api_access_notification: "Per accedere all'API di gestione di Logto, seleziona ruoli con autorizzazioni API di gestione <flag/>.",
    with_management_api_access_tip: "Questo ruolo da macchina a macchina include autorizzazioni per l'API di gestione di Logto"
};
var $0f3b0968240354d6$export$2e2bcd8739ae039 = Object.freeze($0f3b0968240354d6$var$roles);


const $a390cd9da1b5ce1a$var$session_expired = {
    title: "La sessione \xe8 scaduta",
    subtitle: "La tua sessione potrebbe essere scaduta e sei stato disconnesso. Clicca il pulsante qui sotto per accedere di nuovo alla console di amministrazione.",
    button: "Accedi di nuovo"
};
var $a390cd9da1b5ce1a$export$2e2bcd8739ae039 = Object.freeze($a390cd9da1b5ce1a$var$session_expired);


const $461510427baaf807$var$content = {
    terms_of_use: {
        title: "TERMS",
        terms_of_use: "Terms of use URL",
        terms_of_use_placeholder: "https://your.terms.of.use/",
        privacy_policy: "Privacy policy URL",
        privacy_policy_placeholder: "https://your.privacy.policy/"
    },
    languages: {
        title: "LANGUAGES",
        enable_auto_detect: "Enable auto-detect",
        description: "Your software detects the user's locale setting and switches to the local language. You can add new languages by translating UI from English to another language.",
        manage_language: "Manage language",
        default_language: "Default language",
        default_language_description_auto: "The default language will be used when the detected user language isn’t covered in the current language library.",
        default_language_description_fixed: "When auto-detect is off, the default language is the only language your software will show. Turn on auto-detect for language extension."
    },
    manage_language: {
        title: "Manage language",
        subtitle: "Localize the product experience by adding languages and translations. Your contribution can be set as the default language.",
        add_language: "Add Language",
        logto_provided: "Logto provided",
        key: "Key",
        logto_source_values: "Logto source values",
        custom_values: "Custom values",
        clear_all_tip: "Clear all values",
        unsaved_description: "Changes won’t be saved if you leave this page without saving.",
        deletion_tip: "Delete the language",
        deletion_title: "Do you want to delete the added language?",
        deletion_description: "After deletion, your users won’t be able to browse in that language again.",
        default_language_deletion_title: "Default language can’t be deleted.",
        default_language_deletion_description: "{{language}} is set as your default language and can’t be deleted. "
    }
};
var $461510427baaf807$export$2e2bcd8739ae039 = Object.freeze($461510427baaf807$var$content);


const $b217c1d7e297ae97$var$password_policy = {
    password_requirements: "Requisiti per la password",
    minimum_length: "Lunghezza minima",
    minimum_length_description: "NIST consiglia di utilizzare almeno 8 caratteri per i prodotti web.",
    minimum_length_error: "La lunghezza minima deve essere compresa tra {{min}} e {{max}} (inclusi).",
    minimum_required_char_types: "Tipi di caratteri minimi richiesti",
    minimum_required_char_types_description: "Tipi di caratteri: maiuscole (A-Z), minuscole (a-z), numeri (0-9) e simboli speciali ({{symbols}}).",
    password_rejection: "Rifiuto password",
    compromised_passwords: "Rifiuta password compromesse",
    breached_passwords: "Password violate",
    breached_passwords_description: "Rifiuta password trovate in precedenza nei database delle violazioni.",
    restricted_phrases: "Limita frasi poco sicure",
    restricted_phrases_tooltip: "La tua password dovrebbe evitare queste frasi a meno che non le combiniate con 3 o pi\xf9 caratteri extra.",
    repetitive_or_sequential_characters: "Caratteri ripetitivi o sequenziali",
    repetitive_or_sequential_characters_description: 'Ad esempio, "AAAA", "1234" e "abcd".',
    user_information: "Informazioni utente",
    user_information_description: "Ad esempio, indirizzo email, numero di telefono, nome utente, ecc.",
    custom_words: "Parole personalizzate",
    custom_words_description: "Personalizza parole specifiche del contesto, non case-sensitive, una per riga.",
    custom_words_placeholder: "Nome del tuo servizio, nome dell'azienda, ecc."
};
var $b217c1d7e297ae97$export$2e2bcd8739ae039 = Object.freeze($b217c1d7e297ae97$var$password_policy);


const $7bc99db9d416c57e$var$sign_up_and_sign_in = {
    identifiers_email: "Indirizzo email",
    identifiers_phone: "Numero di telefono",
    identifiers_username: "Nome utente",
    identifiers_email_or_sms: "Indirizzo email o numero di telefono",
    identifiers_none: "Non applicabile",
    and: "e",
    or: "o",
    sign_up: {
        title: "REGISTRATI",
        sign_up_identifier: "Identificatore di registrazione",
        identifier_description: "L'identificatore di registrazione \xe8 necessario per la creazione dell'account e deve essere incluso nella schermata di accesso.",
        sign_up_authentication: "Impostazione dell'autenticazione per la registrazione",
        authentication_description: "Tutte le azioni selezionate saranno obbligatorie per gli utenti per completare il flusso.",
        set_a_password_option: "Crea la tua password",
        verify_at_sign_up_option: "Verifica all'atto della registrazione",
        social_only_creation_description: "(Questo si applica solo alla creazione di account con i social)"
    },
    sign_in: {
        title: "ACCEDI",
        sign_in_identifier_and_auth: "Identificatore e impostazioni di autenticazione per l'accesso",
        description: "Gli utenti possono accedere utilizzando una qualsiasi delle opzioni disponibili. Regola il layout trascinando e rilasciando le opzioni sottostanti.",
        add_sign_in_method: "Aggiungi metodo di accesso",
        password_auth: "Password",
        verification_code_auth: "Codice di verifica",
        auth_swap_tip: "Scambia le opzioni sottostanti per determinare quale appare prima nel flusso.",
        require_auth_factor: "Devi selezionare almeno un fattore di autenticazione."
    },
    social_sign_in: {
        title: "ACCESSO CON I SOCIAL",
        social_sign_in: "Accesso ai social",
        description: "A seconda dell'identificatore obbligatorio che hai impostato, all'utente potrebbe essere chiesto di fornire un identificatore durante la registrazione tramite il connettore social.",
        add_social_connector: "Aggiungi connettore social",
        set_up_hint: {
            not_in_list: "Non in lista?",
            set_up_more: "Imposta",
            go_to: "altri connettori social ora."
        }
    },
    tip: {
        set_a_password: "Un set unico di password per il tuo nome utente \xe8 un must.",
        verify_at_sign_up: "Attualmente supportiamo solo la posta elettronica verificata. La tua base utenti potrebbe contenere un gran numero di indirizzi email di bassa qualit\xe0 se non effettui la convalida.",
        password_auth: "Questo \xe8 essenziale poich\xe9 hai abilitato l'opzione di impostazione della password durante il processo di registrazione.",
        verification_code_auth: "Questo \xe8 essenziale poich\xe9 hai abilitato solo l'opzione di fornire un codice di verifica durante la registrazione. Se consenti l'impostazione della password durante il processo di registrazione, puoi deselezionare la casella.",
        delete_sign_in_method: "Questo \xe8 essenziale in quanto hai selezionato {{identifier}} come identificatore obbligatorio."
    },
    advanced_options: {
        title: "OPZIONI AVANZATE",
        enable_single_sign_on: "Abilita Single Sign-On aziendale (SSO)",
        enable_single_sign_on_description: "Consente agli utenti di accedere all'applicazione utilizzando il Single Sign-On con le loro identit\xe0 aziendali.",
        single_sign_on_hint: {
            prefix: "Vai a ",
            link: '"Enterprise SSO"',
            suffix: "sezione per impostare ulteriori connettori aziendali."
        },
        enable_user_registration: "Abilita registrazione utente",
        enable_user_registration_description: "Abilita o disabilita la registrazione degli utenti. Una volta disabilitata, gli utenti possono comunque essere aggiunti nella console di amministrazione, ma gli utenti non possono pi\xf9 creare account tramite l'interfaccia di accesso."
    }
};
var $7bc99db9d416c57e$export$2e2bcd8739ae039 = Object.freeze($7bc99db9d416c57e$var$sign_up_and_sign_in);


const $46d2a32fb9ebcb2a$var$sign_in_exp = {
    page_title: "Esperienza di accesso",
    title: "Esperienza di accesso",
    description: "Personalizza l'interfaccia di accesso per abbinarla al tuo marchio e visualizzala in tempo reale",
    tabs: {
        branding: "Marchio",
        sign_up_and_sign_in: "Registrazione e accesso",
        content: "Contenuto",
        password_policy: "Politica sulla password"
    },
    welcome: {
        title: "Personalizza l'esperienza di accesso",
        description: "Inizia subito con la configurazione del tuo primo accesso. Questa guida ti guider\xe0 attraverso tutte le impostazioni necessarie.",
        get_started: "Inizia",
        apply_remind: "Si prega di notare che l'esperienza di accesso verr\xe0 applicata a tutte le applicazioni in questo account."
    },
    color: {
        title: "COLORE",
        primary_color: "Colore del marchio",
        dark_primary_color: "Colore del marchio (scuro)",
        dark_mode: "Abilita modalit\xe0 scura",
        dark_mode_description: "La tua app avr\xe0 un tema modalit\xe0 scura generato automaticamente in base al tuo colore del marchio e all'algoritmo Logto. Sei libero di personalizzare.",
        dark_mode_reset_tip: "Ricalcola il colore della modalit\xe0 scura in base al colore del marchio.",
        reset: "Ricalcola"
    },
    branding: {
        title: "AREA DI BRANDIZZO",
        ui_style: "Stile",
        favicon: "Favicon",
        logo_image_url: "URL dell'immagine del logo dell'app",
        logo_image_url_placeholder: "https://your.cdn.domain/logo.png",
        dark_logo_image_url: "URL dell'immagine del logo dell'app (scuro)",
        dark_logo_image_url_placeholder: "https://your.cdn.domain/logo-dark.png",
        logo_image: "Logo dell'app",
        dark_logo_image: "Logo dell'app (scuro)",
        logo_image_error: "Logo dell'app: {{error}}",
        favicon_error: "Favicon: {{error}}"
    },
    custom_css: {
        title: "CSS personalizzato",
        css_code_editor_title: "Personalizza la tua interfaccia utente con CSS personalizzato",
        css_code_editor_description1: "Guarda l'esempio di CSS personalizzato.",
        css_code_editor_description2: "<a>{{link}}</a>",
        css_code_editor_description_link_content: "Ulteriori informazioni",
        css_code_editor_content_placeholder: "Inserisci il tuo CSS personalizzato per adattare lo stile di qualsiasi cosa alle tue specifiche. Esprimi la tua creativit\xe0 e fai risaltare la tua interfaccia utente."
    },
    sign_up_and_sign_in: $7bc99db9d416c57e$export$2e2bcd8739ae039,
    content: $461510427baaf807$export$2e2bcd8739ae039,
    password_policy: $b217c1d7e297ae97$export$2e2bcd8739ae039,
    setup_warning: {
        no_connector_sms: 'Nessun connettore SMS ancora configurato. Prima di completare la configurazione, gli utenti non saranno in grado di accedere con questo metodo. <a>{{link}}</a> in "Connettori"',
        no_connector_email: 'Nessun connettore email ancora configurato. Prima di completare la configurazione, gli utenti non saranno in grado di accedere con questo metodo. <a>{{link}}</a> in "Connettori"',
        no_connector_social: 'Non hai ancora configurato nessun connettore sociale. Aggiungi prima i connettori per applicare i metodi di accesso sociale. <a>{{link}}</a> in "Connettori".',
        setup_link: "Configura"
    },
    save_alert: {
        description: "Stai implementando nuove procedure di accesso e registrazione. Tutti i tuoi utenti potrebbero essere influenzati dalla nuova configurazione. Sei sicuro di voler procedere con il cambiamento?",
        before: "Prima",
        after: "Dopo",
        sign_up: "Registrazione",
        sign_in: "Accesso",
        social: "Sociale"
    },
    preview: {
        title: "Anteprima di accesso",
        live_preview: "Anteprima in diretta",
        live_preview_tip: "Salva per visualizzare le modifiche",
        native: "Nat",
        desktop_web: "Web desktop",
        mobile_web: "Web mobile",
        desktop: "Desktop",
        mobile: "Mobile"
    }
};
var $46d2a32fb9ebcb2a$export$2e2bcd8739ae039 = Object.freeze($46d2a32fb9ebcb2a$var$sign_in_exp);


const $b96c982602b11089$var$signing_keys = {
    title: "Chiavi di firma",
    description: "Gestisci in modo sicuro le chiavi di firma utilizzate dalle tue applicazioni.",
    private_key: "Chiavi private OIDC",
    private_keys_description: "Le chiavi private OIDC vengono utilizzate per firmare i token JWT.",
    cookie_key: "Chiavi dei cookie OIDC",
    cookie_keys_description: "Le chiavi dei cookie OIDC vengono utilizzate per firmare i cookie.",
    private_keys_in_use: "Chiavi private in uso",
    cookie_keys_in_use: "Chiavi dei cookie in uso",
    rotate_private_keys: "Ruota le chiavi private",
    rotate_cookie_keys: "Ruota le chiavi dei cookie",
    rotate_private_keys_description: "Questa azione creer\xe0 una nuova chiave di firma privata, ruoter\xe0 la chiave attuale e rimuover\xe0 la chiave precedente. I tuoi token JWT firmati con la chiave attuale rimarranno validi fino alla cancellazione o a un altro ciclo di rotazione.",
    rotate_cookie_keys_description: "Questa azione creer\xe0 una nuova chiave dei cookie, ruoter\xe0 la chiave attuale e rimuover\xe0 la chiave precedente. I tuoi cookie con la chiave attuale rimarranno validi fino alla cancellazione o a un altro ciclo di rotazione.",
    select_private_key_algorithm: "Seleziona l'algoritmo di firma per la nuova chiave privata",
    rotate_button: "Ruota",
    table_column: {
        id: "ID",
        status: "Stato",
        algorithm: "Algoritmo di firma della chiave"
    },
    status: {
        current: "Attuale",
        previous: "Precedente"
    },
    reminder: {
        rotate_private_key: "Sei sicuro di voler ruotare le <strong>chiavi private OIDC</strong>? I nuovi token JWT emessi saranno firmati dalla nuova chiave. I token JWT esistenti rimarranno validi finch\xe9 non ruoti nuovamente.",
        rotate_cookie_key: "Sei sicuro di voler ruotare le <strong>chiavi dei cookie OIDC</strong>? I nuovi cookie generati nelle sessioni di accesso saranno firmati dalla nuova chiave dei cookie. I cookie esistenti rimarranno validi finch\xe9 non ruoti nuovamente.",
        delete_private_key: "Sei sicuro di voler eliminare la <strong>chiave privata OIDC</strong>? I token JWT esistenti firmati con questa chiave privata non saranno pi\xf9 validi.",
        delete_cookie_key: "Sei sicuro di voler eliminare la <strong>chiave dei cookie OIDC</strong>? Le sessioni di accesso precedenti con i cookie firmati con questa chiave dei cookie non saranno pi\xf9 valide. \xc8 richiesta una nuova autenticazione per questi utenti."
    },
    messages: {
        rotate_key_success: "Chiavi di firma ruotate con successo.",
        delete_key_success: "Chiave eliminata con successo."
    }
};
var $b96c982602b11089$export$2e2bcd8739ae039 = Object.freeze($b96c982602b11089$var$signing_keys);


const $f51335d309fa088c$var$quota_item = {
    tenant_limit: {
        name: "Tenanti",
        limited: "{{count, number}} affittuario",
        limited_other: "{{count, number}} affittuari",
        unlimited: "Affittuari illimitati",
        not_eligible: "Rimuovi i tuoi affittuari"
    },
    mau_limit: {
        name: "Utenti attivi mensili",
        limited: "{{count, number}} MAU",
        unlimited: "Utenti attivi mensili illimitati",
        not_eligible: "Rimuovi tutti i tuoi utenti"
    },
    token_limit: {
        name: "Tokens",
        limited: "{{count, number}} token",
        limited_other: "{{count, number}} tokens",
        unlimited: "Tokens illimitati",
        not_eligible: "Rimuovi tutti i tuoi utenti per prevenire i nuovi tokens"
    },
    applications_limit: {
        name: "Applicazioni",
        limited: "{{count, number}} applicazione",
        limited_other: "{{count, number}} applicazioni",
        unlimited: "Applicazioni illimitate",
        not_eligible: "Rimuovi le tue applicazioni"
    },
    machine_to_machine_limit: {
        name: "Applicazioni Machine-to-Machine",
        limited: "{{count, number}} applicazione Machine-to-Machine",
        limited_other: "{{count, number}} applicazioni Machine-to-Machine",
        unlimited: "Applicazioni Machine-to-Machine illimitate",
        not_eligible: "Rimuovi le tue applicazioni Machine-to-Machine"
    },
    third_party_applications_limit: {
        name: "App di terze parti",
        limited: "{{count, number}} app di terze parti",
        limited_other: "{{count, number}} app di terze parti",
        unlimited: "App di terze parti illimitate",
        not_eligible: "Rimuovi le tue app di terze parti"
    },
    resources_limit: {
        name: "Risorse API",
        limited: "{{count, number}} risorsa API",
        limited_other: "{{count, number}} risorse API",
        unlimited: "Risorse API illimitate",
        not_eligible: "Rimuovi le tue risorse API"
    },
    scopes_per_resource_limit: {
        name: "Permessi risorsa",
        limited: "{{count, number}} permesso per risorsa",
        limited_other: "{{count, number}} permessi per risorsa",
        unlimited: "Permesso per risorsa illimitato",
        not_eligible: "Rimuovi i permessi risorsa"
    },
    custom_domain_enabled: {
        name: "Dominio personalizzato",
        limited: "Dominio personalizzato",
        unlimited: "Dominio personalizzato",
        not_eligible: "Rimuovi il tuo dominio personalizzato"
    },
    omni_sign_in_enabled: {
        name: "Omnisign-in",
        limited: "Omnisign-in",
        unlimited: "Omnisign-in",
        not_eligible: "Disabilita il tuo Omnisign-in"
    },
    built_in_email_connector_enabled: {
        name: "Connettore email incorporato",
        limited: "Connettore email incorporato",
        unlimited: "Connettore email incorporato",
        not_eligible: "Rimuovi il tuo connettore email incorporato"
    },
    social_connectors_limit: {
        name: "Connettori sociali",
        limited: "{{count, number}} connettore sociale",
        limited_other: "{{count, number}} connettori sociali",
        unlimited: "Connettori sociali illimitati",
        not_eligible: "Rimuovi i tuoi connettori sociali"
    },
    standard_connectors_limit: {
        name: "Connettori standard gratuiti",
        limited: "{{count, number}} connettore standard gratuito",
        limited_other: "{{count, number}} connettori standard gratuiti",
        unlimited: "Connettori standard illimitati",
        not_eligible: "Rimuovi i tuoi connettori standard"
    },
    roles_limit: {
        name: "Ruoli",
        limited: "{{count, number}} ruolo",
        limited_other: "{{count, number}} ruoli",
        unlimited: "Ruoli illimitati",
        not_eligible: "Rimuovi i tuoi ruoli"
    },
    machine_to_machine_roles_limit: {
        name: "Ruoli di applicazione Machine-to-Machine",
        limited: "{{count, number}} ruolo di applicazione Machine-to-Machine",
        limited_other: "{{count, number}} ruoli di applicazione Machine-to-Machine",
        unlimited: "Ruoli di applicazione Machine-to-Machine illimitati",
        not_eligible: "Rimuovi i tuoi ruoli di applicazione Machine-to-Machine"
    },
    scopes_per_role_limit: {
        name: "Permessi ruolo",
        limited: "{{count, number}} permesso per ruolo",
        limited_other: "{{count, number}} permessi per ruolo",
        unlimited: "Permesso per ruolo illimitato",
        not_eligible: "Rimuovi i permessi ruolo"
    },
    hooks_limit: {
        name: "Webhooks",
        limited: "{{count, number}} webhook",
        limited_other: "{{count, number}} webhooks",
        unlimited: "Webhook illimitati",
        not_eligible: "Rimuovi i tuoi webhook"
    },
    organizations_enabled: {
        name: "Organizzazioni",
        limited: "Organizzazioni",
        unlimited: "Organizzazioni",
        not_eligible: "Rimuovi le tue organizzazioni"
    },
    audit_logs_retention_days: {
        name: "Conservazione log di audit",
        limited: "Conservazione log di audit: {{count, number}} giorno",
        limited_other: "Conservaizone log di audit: {{count, number}} giorni",
        unlimited: "Giorni illimitati",
        not_eligible: "Nessun log di audit"
    },
    email_ticket_support: {
        name: "Supporto tramite ticket email",
        limited: "{{count, number}} ora di supporto tramite ticket email",
        limited_other: "{{count, number}} ore di supporto tramite ticket email",
        unlimited: "Supporto tramite ticket email",
        not_eligible: "Nessun supporto tramite ticket email"
    },
    mfa_enabled: {
        name: "Autenticazione a due fattori",
        limited: "Autenticazione a due fattori",
        unlimited: "Autenticazione a due fattori",
        not_eligible: "Rimuovi la tua autenticazione a due fattori"
    },
    sso_enabled: {
        name: "SSO aziendale",
        limited: "SSO aziendale",
        unlimited: "SSO aziendale",
        not_eligible: "Rimuovi il tuo SSO aziendale"
    },
    tenant_members_limit: {
        name: "Membri Tenant",
        limited: "{{count, number}} membro Tenant",
        limited_other: "{{count, number}} membri Tenant",
        unlimited: "Membri Tenant illimitati",
        not_eligible: "Rimuovi i tuoi membri Tenant"
    },
    custom_jwt_enabled: {
        name: "JWT personalizzato",
        limited: "JWT personalizzato",
        unlimited: "JWT personalizzato",
        not_eligible: "Rimuovi il tuo personalizzatore di claim JWT"
    }
};
var $f51335d309fa088c$export$2e2bcd8739ae039 = Object.freeze($f51335d309fa088c$var$quota_item);


const $e41e8dc22cbd5aa6$var$quota_table = {
    quota: {
        title: "Principi",
        base_price: "Prezzo base",
        mau_limit: "Limite di MAU",
        included_tokens: "Token inclusi"
    },
    application: {
        title: "Applicazioni",
        total: "Totale applicazioni",
        m2m: "Machine-to-machine",
        third_party: "App di terze parti"
    },
    resource: {
        title: "Risorse API",
        resource_count: "Numero di risorse",
        scopes_per_resource: "Permessi per risorsa"
    },
    branding: {
        title: "UI e branding",
        custom_domain: "Dominio personalizzato",
        custom_css: "CSS personalizzato",
        app_logo_and_favicon: "Logo e favicon dell'applicazione",
        dark_mode: "Modalit\xe0 scura",
        i18n: "Internazionalizzazione"
    },
    user_authn: {
        title: "Autenticazione utente",
        omni_sign_in: "Accesso onnicomprensivo",
        password: "Password",
        passwordless: "Senza password - E-mail e SMS",
        email_connector: "Connettore e-mail",
        sms_connector: "Connettore SMS",
        social_connectors: "Connettori sociali",
        standard_connectors: "Connettori standard",
        built_in_email_connector: "Connettore e-mail integrato",
        mfa: "Autenticazione a pi\xf9 fattori",
        sso: "SSO aziendale",
        adaptive_mfa: "MFA adattativa"
    },
    user_management: {
        title: "Gestione utenti",
        user_management: "Gestione utenti",
        roles: "Ruoli",
        machine_to_machine_roles: "Ruoli machine-to-machine",
        scopes_per_role: "Permessi per ruolo"
    },
    organizations: {
        title: "Organizzazione",
        organizations: "Organizzazioni",
        organization: "Organizzazione",
        organization_count: "Conteggio organizzazioni",
        allowed_users_per_org: "Utenti per organizzazione",
        invitation: "Invito (Gestione API)",
        org_roles: "Ruoli organizzazione",
        org_permissions: "Permessi organizzazione",
        just_in_time_provisioning: "Provisioning just-in-time"
    },
    support: {
        title: "Conformit\xe0 e supporto",
        community: "Community",
        customer_ticket: "Ticket di assistenza",
        premium: "Premium",
        email_ticket_support: "Supporto tramite ticket e-mail",
        soc2_report: "Rapporto SOC2",
        hipaa_or_baa_report: "Rapporto HIPAA/BAA"
    },
    developers_and_platform: {
        title: "Sviluppatori e piattaforma",
        hooks: "Webhooks",
        audit_logs_retention: "Conservazione dei log di audit",
        jwt_claims: "JWT claims",
        tenant_members: "Membri del tenant"
    },
    unlimited: "Illimitato",
    contact: "Contatta",
    monthly_price: "${{value, number}}/mese",
    days_one: "{{count, number}} giorno",
    days_other: "{{count, number}} giorni",
    add_on: "Aggiuntiva",
    tier: "Livello{{value, number}}: ",
    paid_token_limit_tip: "Logto addebiter\xe0 tariffe per le funzionalit\xe0 che superano il limite della tua quota. Puoi usarlo gratuitamente fino a quando inizieremo a addebitare circa nel secondo trimestre del 2024. Se hai bisogno di pi\xf9 token, ti preghiamo di contattarci. Per default, addebitiamo $80 al mese per ogni milione di token.",
    paid_quota_limit_tip: "Logto addebiter\xe0 costi per le funzionalit\xe0 che superano il limite della tua quota. Puoi usarlo gratuitamente fino a quando inizieremo a addebitare circa nel secondo trimestre del 2024.",
    paid_add_on_feature_tip: "Questa \xe8 una funzionalit\xe0 aggiuntiva. Puoi usarla gratuitamente fino a quando inizieremo a addebitare circa nel secondo trimestre del 2024.",
    million: "{{value, number}} milioni",
    mau_tip: "MAU (utenti attivi mensili) significa il numero di utenti unici che hanno scambiato almeno un token con Logto in un ciclo di fatturazione.",
    tokens_tip: "Tutti i tipi di token emessi da Logto, inclusi token di accesso, token di aggiornamento, ecc.",
    mao_tip: "MAO (Organizzazione attiva mensile) indica il numero di organizzazioni uniche che hanno almeno un MAU (utente attivo mensile) in un ciclo di fatturazione.",
    third_party_tip: "Usa Logto come provider di identit\xe0 OIDC per l'accesso e il rilascio di permessi di app di terze parti.",
    included: "{{value, number}} incluso",
    included_mao: "{{value, number}} MAO inclusi",
    extra_quota_price: "Quindi ${{value, number}} al mese / ognuno dopo",
    per_month_each: "${{value, number}} al mese / ognuno",
    extra_mao_price: "Quindi ${{value, number}} per MAO",
    per_month: "${{value, number}} al mese",
    per_member: "Quindi ${{value, number}} per membro"
};
var $e41e8dc22cbd5aa6$export$2e2bcd8739ae039 = Object.freeze($e41e8dc22cbd5aa6$var$quota_table);


const $0f13a7d0df2e1eef$var$subscription = {
    free_plan: "Piano gratuito",
    free_plan_description: "Per progetti secondari e prove iniziali di Logto. Nessuna carta di credito.",
    pro_plan: "Piano Pro",
    pro_plan_description: "Per aziende che beneficiano di Logto senza preoccupazioni.",
    enterprise: "Azienda",
    current_plan: "Piano attuale",
    current_plan_description: "Ecco il tuo piano attuale. Puoi facilmente visualizzare l'utilizzo del tuo piano, controllare la tua prossima fattura e apportare modifiche al piano, se necessario.",
    plan_usage: "Utilizzo del piano",
    plan_cycle: "Ciclo del piano: {{period}}. L'utilizzo si rinnova il {{renewDate}}.",
    next_bill: "La tua prossima fattura",
    next_bill_hint: "Per saperne di pi\xf9 sul calcolo, consulta questo <a>articolo</a>.",
    next_bill_tip: "I prezzi visualizzati qui sono esclusi di tasse. L'importo delle tasse sar\xe0 calcolato in base alle informazioni che fornite e ai requisiti normativi locali, e verr\xe0 mostrato nelle vostre fatture.",
    manage_payment: "Gestisci pagamento",
    overfill_quota_warning: "Hai raggiunto il limite del tuo contingente. Per evitare eventuali problemi, esegui l'upgrade del piano.",
    upgrade_pro: "Esegui l'upgrade a Pro",
    update_payment: "Aggiorna pagamento",
    payment_error: "Rilevato un problema di pagamento. Impossibile elaborare ${{price, number}} per il ciclo precedente. Aggiorna il pagamento per evitare la sospensione del servizio Logto.",
    downgrade: "Degrado",
    current: "Attuale",
    upgrade: "Aggiornamento",
    quota_table: $e41e8dc22cbd5aa6$export$2e2bcd8739ae039,
    billing_history: {
        invoice_column: "Fatture",
        status_column: "Stato",
        amount_column: "Importo",
        invoice_created_date_column: "Data di creazione fattura",
        invoice_status: {
            void: "Annullata",
            paid: "Pagata",
            open: "Aperta",
            uncollectible: "Scaduta"
        }
    },
    quota_item: $f51335d309fa088c$export$2e2bcd8739ae039,
    downgrade_modal: {
        title: "Sei sicuro di voler effettuare il degrado?",
        description: "Se scegli di passare a <targetName/>, tieni presente che non avrai pi\xf9 accesso al contingente e alle funzionalit\xe0 che erano presenti in <currentName/>.",
        before: "Prima: <name/>",
        after: "Dopo: <name />",
        downgrade: "Degrado"
    },
    not_eligible_modal: {
        downgrade_title: "Non sei idoneo per il degrado",
        downgrade_description: "Assicurati di soddisfare i seguenti criteri prima di eseguire il degrado al piano <name/>.",
        downgrade_help_tip: "Hai bisogno di aiuto per il degrado? <a>Contattaci</a>.",
        upgrade_title: "Promemoria amichevole per i nostri apprezzati early adopter",
        upgrade_description: "Attualmente stai utilizzando pi\xf9 di quanto consentito da <name />. Logto \xe8 ora ufficiale, con funzionalit\xe0 personalizzate per ciascun piano. Prima di considerare l'aggiornamento al <name />, assicurati di soddisfare i seguenti criteri prima dell'aggiornamento.",
        upgrade_pro_tip: " Oppure valuta l'aggiornamento al Piano Pro.",
        upgrade_help_tip: "Hai bisogno di aiuto per l'aggiornamento? <a>Contattaci</a>.",
        a_maximum_of: "Un massimo di <item/>"
    },
    upgrade_success: "Aggiornamento effettuato con successo a <name/>",
    downgrade_success: "Degrado effettuato con successo a <name/>",
    subscription_check_timeout: "Il controllo dell'abbonamento \xe8 scaduto. Si prega di riprovare pi\xf9 tardi.",
    no_subscription: "Nessuna sottoscrizione"
};
var $0f13a7d0df2e1eef$export$2e2bcd8739ae039 = Object.freeze($0f13a7d0df2e1eef$var$subscription);


const $1de5631198c84f55$var$tab_sections = {
    overview: "Panoramica",
    authentication: "Autenticazione",
    authorization: "Autorizzazione",
    users: "Utenti",
    developer: "Sviluppatore",
    tenant: "Inquilino"
};
var $1de5631198c84f55$export$2e2bcd8739ae039 = Object.freeze($1de5631198c84f55$var$tab_sections);


const $e30ec9dcae37912d$var$tabs = {
    get_started: "Iniziare",
    dashboard: "Dashboard",
    applications: "Applicazioni",
    api_resources: "Risorse API",
    sign_in_experience: "Esperienza di accesso",
    connectors: "Connettori",
    enterprise_sso: "SSO Enterprise",
    webhooks: "Webhooks",
    organizations: "Organizzazioni",
    users: "Gestione utenti",
    audit_logs: "Registri di verifica",
    roles: "Ruoli",
    docs: "Documenti",
    tenant_settings: "Impostazioni",
    mfa: "Autenticazione multi-fattore",
    customize_jwt: "JWT personalizzato",
    signing_keys: "Chiavi di firma",
    organization_template: "Modello di organizzazione"
};
var $e30ec9dcae37912d$export$2e2bcd8739ae039 = Object.freeze($e30ec9dcae37912d$var$tabs);


const $3562999ae1dfb27b$var$tenant_members = {
    members: "Membri",
    invitations: "Inviti",
    invite_members: "Invita membri",
    user: "Utente",
    roles: "Ruoli",
    admin: "Amministratore",
    collaborator: "Collaboratore",
    invitation_status: "Stato invito",
    inviter: "Chi ha invitato",
    expiration_date: "Data di scadenza",
    invite_modal: {
        title: "Invita persone in Logto Cloud",
        subtitle: "Per invitare membri a un'organizzazione, devono accettare l'invito.",
        to: "A",
        added_as: "Aggiunti come ruoli",
        email_input_placeholder: "johndoe@example.com"
    },
    invitation_statuses: {
        pending: "In attesa",
        accepted: "Accettato",
        expired: "Scaduto",
        revoked: "Revocato"
    },
    invitation_empty_placeholder: {
        title: "Invita membri del team",
        description: "Attualmente il tuo inquilino non ha membri invitati.\nPer aiutare con la tua integrazione, considera l'aggiunta di pi\xf9 membri o amministratori."
    },
    menu_options: {
        edit: "Modifica ruolo inquilino",
        delete: "Rimuovi utente dall'inquilino",
        resend_invite: "Rinvia invito",
        revoke: "Revoca invito",
        delete_invitation_record: "Elimina questo record di invito"
    },
    edit_modal: {
        title: "Cambia ruoli di {{name}}"
    },
    delete_user_confirm: "Sei sicuro di voler rimuovere questo utente da questo inquilino?",
    assign_admin_confirm: "Sei sicuro di voler rendere amministratore i(e) ​​utente(i)​​ selezionato(i)​​? Concedere l'accesso da amministratore fornir\xe0 al(i)​​ utente(i)​​ le seguenti autorizzazioni.<ul><li>Cambiare piano di fatturazione dell'inquilino</li><li>Aggiungere o rimuovere collaboratori</li><li>Eliminare l'inquilino</li></ul>",
    revoke_invitation_confirm: "Sei sicuro di voler revocare questo invito?",
    delete_invitation_confirm: "Sei sicuro di voler eliminare questo record di invito?",
    messages: {
        invitation_sent: "Invito inviato.",
        invitation_revoked: "Invito revocato.",
        invitation_resend: "Invito rinviato.",
        invitation_deleted: "Record di invito eliminato."
    },
    errors: {
        email_required: "L'email dell'invitato \xe8 obbligatoria.",
        email_exists: "L'indirizzo email esiste gi\xe0.",
        member_exists: "Questo utente \xe8 gi\xe0 membro di questa organizzazione.",
        pending_invitation_exists: "Esiste un invito in sospeso. Elimina l'email correlata o revoca l'invito.",
        invalid_email: "L'indirizzo email non \xe8 valido. Assicurati che sia nel formato corretto.",
        max_member_limit: "Hai raggiunto il numero massimo di membri ({{limit}}) per questo inquilino."
    }
};
var $3562999ae1dfb27b$export$2e2bcd8739ae039 = Object.freeze($3562999ae1dfb27b$var$tenant_members);


const $9be74053c1b618b3$var$tenants = {
    title: "Impostazioni",
    description: "Gestisci efficacemente le impostazioni dell'inquilino e personalizza il tuo dominio.",
    tabs: {
        settings: "Impostazioni",
        members: "Membri",
        domains: "Domini",
        subscription: "Piano e fatturazione",
        billing_history: "Storico fatturazione"
    },
    settings: {
        title: "IMPOSTAZIONI",
        description: "Imposta il nome dell'inquilino e visualizza la regione in cui sono ospitati i tuoi dati e il tipo di inquilino.",
        tenant_id: "ID Inquilino",
        tenant_name: "Nome Inquilino",
        tenant_region: "Regione di hosting",
        tenant_region_tip: "Le risorse del tuo inquilino sono ospitate in {{region}}. <a>Scopri di pi\xf9</a>",
        environment_tag_development: "Svil",
        environment_tag_production: "Prod",
        tenant_type: "Tipo inquilino",
        development_description: "Solo per scopi di test e non dovrebbe essere utilizzato in produzione. Non \xe8 richiesto alcun abbonamento. Ha tutte le funionalit\xe0 professionali ma ha delle limitazioni come un banner di accesso. <a>Per saperne di pi\xf9</a>",
        production_description: "Destinato alle app utilizzate dagli utenti finali e potrebbe richiedere un abbonamento a pagamento. <a>Per saperne di pi\xf9</a>",
        tenant_info_saved: "Le informazioni dell'inquilino sono state salvate correttamente."
    },
    full_env_tag: {
        development: "Sviluppo",
        production: "Produzione"
    },
    deletion_card: {
        title: "ELIMINA",
        tenant_deletion: "Elimina inquilino",
        tenant_deletion_description: "L'eliminazione dell'inquilino comporter\xe0 la rimozione permanente di tutti i dati utente e le configurazioni associate. Procedere con cautela.",
        tenant_deletion_button: "Elimina inquilino"
    },
    leave_tenant_card: {
        title: "LASCIARE",
        leave_tenant: "Lascia locatario",
        leave_tenant_description: "Eventuali risorse nell'inquilino rimarranno ma non avrai pi\xf9 accesso a questo inquilino.",
        last_admin_note: "Per lasciare questo inquilino, assicurati che almeno un altro membro abbia il ruolo di Amministratore."
    },
    create_modal: {
        title: "Crea nuovo inquilino",
        tenant_usage_purpose: "Per cosa desideri utilizzare questo inquilino?",
        development_description: "Solo per scopi di test e non dovrebbe essere utilizzato in produzione. Non \xe8 richiesto alcun abbonamento.",
        development_hint: "Ha tutte le funzionalit\xe0 professionali ma ha delle limitazioni come un banner di accesso.",
        production_description: "Utilizzato dagli utenti finali e potrebbe richiedere un abbonamento a pagamento.",
        available_plan: "Piano disponibile:",
        create_button: "Crea inquilino",
        tenant_name_placeholder: "Il mio inquilino"
    },
    dev_tenant_migration: {
        title: 'Ora puoi provare gratuitamente le nostre funzionalit\xe0 Pro creando un nuovo "Inquilino di sviluppo"!',
        affect_title: "Come ti influisce questo?",
        hint_1: "Stiamo sostituendo le vecchie <strong>etichette di ambiente</strong> con due nuovi tipi di inquilino: <strong>“Sviluppo”</strong> e <strong>“Produzione”</strong>.",
        hint_2: "Per garantire una transizione senza soluzione di continuit\xe0 e un funzionamento ininterrotto, tutti gli inquilini creati in precedenza saranno elevati al tipo di inquilino <strong>Produzione</strong> insieme al tuo abbonamento precedente.",
        hint_3: "Niente paura, tutte le altre impostazioni rimarranno invariate.",
        about_tenant_type: "Informazioni sul tipo di inquilino"
    },
    delete_modal: {
        title: "Elimina locatario",
        description_line1: 'Sei sicuro di voler eliminare il tuo inquilino "<span>{{name}}</span>" con etichetta di ambiente "<span>{{tag}}</span>"? Questa azione non pu\xf2 essere annullata e comporter\xe0 l\'eliminazione permanente di tutti i tuoi dati e informazioni sull\'inquilino.',
        description_line2: "Prima di eliminare l'inquilino, forse possiamo aiutarti. <span><a>Contattaci via Email</a></span>",
        description_line3: 'Se desideri procedere, inserisci il nome dell\'inquilino "<span>{{name}}</span>" per confermare.',
        delete_button: "Elimina definitivamente",
        cannot_delete_title: "Impossibile eliminare questo locatario",
        cannot_delete_description: "Spiacente, al momento non \xe8 possibile eliminare questo inquilino. Verifica di essere nel Piano Gratuito e di aver saldato tutte le fatture pendenti."
    },
    leave_tenant_modal: {
        description: "Sei sicuro di voler lasciare questo inquilino?",
        leave_button: "Lasciare"
    },
    tenant_landing_page: {
        title: "Non hai ancora creato un inquilino",
        description: "Per iniziare a configurare il tuo progetto con Logto, crea un nuovo inquilino. Se hai bisogno di uscire o eliminare il tuo account, clicca sul pulsante avatar in alto a destra.",
        create_tenant_button: "Crea inquilino"
    },
    status: {
        mau_exceeded: "MAU Superato",
        suspended: "Sospeso",
        overdue: "Scaduto"
    },
    tenant_suspended_page: {
        title: "Locatario sospeso. Contattaci per ripristinare l'accesso.",
        description_1: "Ci dispiace molto informarti che il tuo account inquilino \xe8 stato temporaneamente sospeso a causa di un utilizzo improprio, inclusi superamenti dei limiti di MAU, pagamenti in ritardo o altre azioni non autorizzate.",
        description_2: "Se necessiti ulteriori chiarimenti, hai qualche preoccupazione o desideri ripristinare la funzionalit\xe0 completa e sbloccare i tuoi inquilini, ti preghiamo di contattarci immediatamente."
    }
};
var $9be74053c1b618b3$export$2e2bcd8739ae039 = Object.freeze($9be74053c1b618b3$var$tenants);


const $7da3088847abb01c$var$topbar = {
    docs: "Documentazione",
    help: "Aiuto"
};
var $7da3088847abb01c$export$2e2bcd8739ae039 = Object.freeze($7da3088847abb01c$var$topbar);


const $8e4f7f3f87463d5e$var$featured_plan_content = {
    mau: {
        free_plan: "Fino a {{count, number}} MAU",
        pro_plan: "MAU illimitati"
    },
    m2m: {
        free_plan: "{{count, number}} da macchina a macchina",
        pro_plan: "Macchina a macchina aggiuntiva"
    },
    third_party_apps: "IdP per applicazioni di terze parti",
    mfa: "Autenticazione a pi\xf9 fattori",
    sso: "SSO aziendale",
    role_and_permissions: {
        free_plan: "{{roleCount, number}} ruolo e {{permissionCount, number}} permesso per ruolo",
        pro_plan: "Ruoli e permessi illimitati per ruolo"
    },
    organizations: "Organizzazioni",
    audit_logs: "Conservazione dei log degli audit: {{count, number}} giorni"
};
var $8e4f7f3f87463d5e$export$2e2bcd8739ae039 = Object.freeze($8e4f7f3f87463d5e$var$featured_plan_content);


const $77fbbd39a16f477f$var$paywall = {
    applications: "Limite di {{count, number}} applicazione di <planName/> raggiunto. Aggiorna il piano per soddisfare le esigenze del tuo team. Per qualsiasi assistenza, non esitare a <a>contattarci</a>.",
    applications_other: "Limite di {{count, number}} applicazioni di <planName/> raggiunto. Aggiorna il piano per soddisfare le esigenze del tuo team. Per qualsiasi assistenza, non esitare a <a>contattarci</a>.",
    machine_to_machine_feature: "Passa al piano <strong>Pro</strong> per ottenere applicazioni extra machine-to-machine e goderti tutte le funzionalit\xe0 premium. <a>Contattaci</a> se hai domande.",
    machine_to_machine: "Limite di {{count, number}} applicazione machine-to-machine di <planName/> raggiunto. Aggiorna il piano per soddisfare le esigenze del tuo team. Per qualsiasi assistenza, non esitare a <a>contattarci</a>.",
    machine_to_machine_other: "Limite di {{count, number}} applicazioni machine-to-machine di <planName/> raggiunto. Aggiorna il piano per soddisfare le esigenze del tuo team. Per qualsiasi assistenza, non esitare a <a>contattarci</a>.",
    resources: "Hai raggiunto il limite di {{count, number}} risorse API di <planName/>. Aggiorna il piano per soddisfare le esigenze del tuo team. <a>Contattaci</a> per qualsiasi assistenza.",
    resources_other: "Hai raggiunto il limite di {{count, number}} risorse API di <planName/>. Aggiorna il piano per soddisfare le esigenze del tuo team. <a>Contattaci</a> per qualsiasi assistenza.",
    scopes_per_resource: "Hai raggiunto il limite di {{count, number}} autorizzazioni per risorsa API di <planName/>. Aggiorna ora per espanderlo. <a>Contattaci</a> per qualsiasi assistenza.",
    scopes_per_resource_other: "Hai raggiunto il limite di {{count, number}} autorizzazioni per risorsa API di <planName/>. Aggiorna ora per espanderlo. <a>Contattaci</a> per qualsiasi assistenza.",
    custom_domain: "Sblocca la funzionalit\xe0 del dominio personalizzato passando al piano <strong>Hobby</strong> o <strong>Pro</strong>. Non esitare a <a>contattarci</a> se hai bisogno di assistenza.",
    social_connectors: "Hai raggiunto il limite di {{count, number}} connettori sociali di <planName/>. Passa al piano per ottenere connettori sociali aggiuntivi e la possibilit\xe0 di creare i tuoi connettori utilizzando i protocolli OIDC, OAuth 2.0 e SAML. Non esitare a <a>contattarci</a> se hai bisogno di assistenza.",
    social_connectors_other: "Hai raggiunto il limite di {{count, number}} connettori sociali di <planName/>. Passa al piano per ottenere connettori sociali aggiuntivi e la possibilit\xe0 di creare i tuoi connettori utilizzando i protocolli OIDC, OAuth 2.0 e SAML. Non esitare a <a>contattarci</a> se hai bisogno di assistenza.",
    standard_connectors_feature: "Aggiorna al piano <strong>Hobby</strong> o <strong>Pro</strong> per creare i tuoi connettori utilizzando i protocolli OIDC, OAuth 2.0 e SAML, oltre a connettori sociali illimitati e tutte le funzionalit\xe0 premium. Sentiti libero di <a>contattarci</a> se hai bisogno di assistenza.",
    standard_connectors: "Hai raggiunto il limite di {{count, number}} connettori sociali di <planName/>. Passa al piano per ottenere connettori sociali aggiuntivi e la possibilit\xe0 di creare i tuoi connettori utilizzando i protocolli OIDC, OAuth 2.0 e SAML. Non esitare a <a>contattarci</a> se hai bisogno di assistenza.",
    standard_connectors_other: "Hai raggiunto il limite di {{count, number}} connettori sociali di <planName/>. Passa al piano per ottenere connettori sociali aggiuntivi e la possibilit\xe0 di creare i tuoi connettori utilizzando i protocolli OIDC, OAuth 2.0 e SAML. Non esitare a <a>contattarci</a> se hai bisogno di assistenza.",
    standard_connectors_pro: "Hai raggiunto il limite di {{count, number}} connettori standard di <planName/>. Passa al piano Enterprise per ottenere connettori sociali aggiuntivi e la possibilit\xe0 di creare i tuoi connettori utilizzando i protocolli OIDC, OAuth 2.0 e SAML. Non esitare a <a>contattarci</a> se hai bisogno di assistenza.",
    standard_connectors_pro_other: "Hai raggiunto il limite di {{count, number}} connettori standard di <planName/>. Passa al piano Enterprise per ottenere connettori sociali aggiuntivi e la possibilit\xe0 di creare i tuoi connettori utilizzando i protocolli OIDC, OAuth 2.0 e SAML. Non esitare a <a>contattarci</a> se hai bisogno di assistenza.",
    roles: "Hai raggiunto il limite di {{count, number}} ruoli di <planName/>. Aggiorna il piano per aggiungere ruoli e autorizzazioni aggiuntive. Non esitare a <a>contattarci</a> se hai bisogno di assistenza.",
    roles_other: "Hai raggiunto il limite di {{count, number}} ruoli di <planName/>. Aggiorna il piano per aggiungere ruoli e autorizzazioni aggiuntive. Non esitare a <a>contattarci</a> se hai bisogno di assistenza.",
    machine_to_machine_roles: "{{count, number}} ruolo machine-to-machine di <planName/> raggiunto. Aggiorna il piano per aggiungere ruoli e autorizzazioni aggiuntive. Non esitare a <a>contattarci</a> se hai bisogno di assistenza.",
    machine_to_machine_roles_other: "{{count, number}} ruoli machine-to-machine di <planName/> raggiunti. Aggiorna il piano per aggiungere ruoli e autorizzazioni aggiuntive. Non esitare a <a>contattarci</a> se hai bisogno di assistenza.",
    scopes_per_role: "Hai raggiunto il limite di {{count, number}} autorizzazioni per ruolo di <planName/>. Aggiorna il piano per aggiungere ruoli e autorizzazioni aggiuntive. Non esitare a <a>contattarci</a> se hai bisogno di assistenza.",
    scopes_per_role_other: "Hai raggiunto il limite di {{count, number}} autorizzazioni per ruolo di <planName/>. Aggiorna il piano per aggiungere ruoli e autorizzazioni aggiuntive. Non esitare a <a>contattarci</a> se hai bisogno di assistenza.",
    hooks: "Hai raggiunto il limite di {{count, number}} webhook di <planName/>. Aggiorna il piano per creare altri webhook. Non esitare a <a>contattarci</a> se hai bisogno di assistenza.",
    hooks_other: "Hai raggiunto il limite di {{count, number}} webhook di <planName/>. Aggiorna il piano per creare altri webhook. Non esitare a <a>contattarci</a> se hai bisogno di assistenza.",
    mfa: "Sblocca MFA per verificare la sicurezza passando a un piano a pagamento. Non esitare a <a>contattarci</a> se hai bisogno di assistenza.",
    organizations: "Sblocca le organizzazioni passando a un piano a pagamento. Non esitare a <a>contattarci</a> se hai bisogno di assistenza.",
    third_party_apps: "Sblocca Logto come IdP per applicazioni di terze parti passando a un piano a pagamento. Per qualsiasi assistenza, non esitare a <a>contattarci</a>.",
    sso_connectors: "Sblocca SSO aziendale passando a un piano a pagamento. Per qualsiasi assistenza, non esitare a <a>contattarci</a>.",
    tenant_members: "Sblocca la funzionalit\xe0 di collaborazione passando a un piano a pagamento. Per qualsiasi assistenza, non esitare a <a>contattarci</a>.",
    tenant_members_dev_plan: "Hai raggiunto il limite di {{limit}} membri. Rilascia un membro o revoca un invito in sospeso per aggiungerne uno nuovo. Hai bisogno di pi\xf9 posti? Non esitare a contattarci.",
    custom_jwt: {
        title: "Aggiungi reclami personalizzati",
        description: "Aggiorna a un piano a pagamento per la funzionalit\xe0 JWT personalizzata e benefici premium. Non esitare a <a>contattarci</a> se hai domande."
    }
};
var $77fbbd39a16f477f$export$2e2bcd8739ae039 = Object.freeze($77fbbd39a16f477f$var$paywall);


const $1557735d43be618f$var$upsell = {
    upgrade_plan: "Aggiorna piano",
    compare_plans: "Confronta i piani",
    view_plans: "Visualizza piani",
    create_tenant: {
        title: "Seleziona il piano del tenant",
        description: "Logto offre opzioni competitive di piani con una struttura dei prezzi innovativa e conveniente progettata per le aziende in crescita. <a>Scopri di pi\xf9</a>",
        base_price: "Prezzo base",
        monthly_price: "{{value, number}}/mese",
        view_all_features: "Visualizza tutte le funzionalit\xe0",
        select_plan: "Seleziona <name/>",
        free_tenants_limit: "Fino a {{count, number}} tenant gratuito",
        free_tenants_limit_other: "Fino a {{count, number}} tenant gratuiti",
        most_popular: "Pi\xf9 popolare",
        upgrade_success: "Aggiornamento a <name/> effettuato con successo"
    },
    mau_exceeded_modal: {
        title: "MAU ha superato il limite. Aggiorna il tuo piano.",
        notification: "Il tuo MAU attuale ha superato il limite di <planName/>. Aggiorna al piano premium tempestivamente per evitare la sospensione del servizio Logto.",
        update_plan: "Aggiorna piano"
    },
    payment_overdue_modal: {
        title: "Pagamento della fattura in ritardo",
        notification: "Oops! Il pagamento della fattura dell'affittuario <span>{{name}}</span> \xe8 fallito. Si prega di pagare tempestivamente la fattura per evitare la sospensione del servizio Logto.",
        unpaid_bills: "Fatture non pagate",
        update_payment: "Aggiorna pagamento"
    },
    add_on_quota_item: {
        api_resource: "Risorsa API",
        machine_to_machine: "applicazione macchina-macchina",
        tokens: "{{limit}}M token",
        tenant_member: "membro del tenant"
    },
    charge_notification_for_quota_limit: "Hai superato il limite di quota {{item}}. Logto aggiunger\xe0 addebiti per l'uso oltre il limite di quota. La fatturazione inizier\xe0 il giorno in cui verr\xe0 rilasciato il nuovo design dei prezzi dell'addon. <a>Ulteriori informazioni</a>",
    paywall: $77fbbd39a16f477f$export$2e2bcd8739ae039,
    featured_plan_content: $8e4f7f3f87463d5e$export$2e2bcd8739ae039
};
var $1557735d43be618f$export$2e2bcd8739ae039 = Object.freeze($1557735d43be618f$var$upsell);


const $b976060a1bd024ab$var$user_details = {
    page_title: "Dettagli utente",
    back_to_users: "Torna alla gestione utenti",
    created_title: "Questo utente \xe8 stato creato con successo",
    created_guide: "Ecco le informazioni per aiutare l'utente con il processo di accesso.",
    created_email: "Indirizzo email:",
    created_phone: "Numero di telefono:",
    created_username: "Nome utente:",
    created_password: "Password:",
    menu_delete: "Elimina",
    delete_description: "Questa azione non pu\xf2 essere annullata. Eliminerai l'utente in modo permanente.",
    deleted: "L'utente \xe8 stato eliminato con successo",
    reset_password: {
        reset_password: "Resetta la password",
        title: "Sei sicuro di voler reimpostare la password?",
        content: "Questa azione non pu\xf2 essere annullata. Questo reimposter\xe0 le informazioni di accesso dell'utente.",
        congratulations: "L'utente \xe8 stato reimpostato",
        new_password: "Nuova password:"
    },
    tab_settings: "Impostazioni",
    tab_roles: "Ruoli",
    tab_logs: "Log utente",
    tab_organizations: "Organizzazioni",
    authentication: "Autenticazione",
    authentication_description: "Ogni utente ha un profilo contenente tutte le informazioni dell'utente. \xc8 composto da dati di base, identit\xe0 sociali e dati personalizzati.",
    user_profile: "Profilo utente",
    field_email: "Indirizzo email",
    field_phone: "Numero di telefono",
    field_username: "Nome utente",
    field_name: "Nome",
    field_avatar: "URL dell'immagine dell'avatar",
    field_avatar_placeholder: "https://il-tuo-dominio.cdn/avatar.png",
    field_custom_data: "Dati personalizzati",
    field_custom_data_tip: "Ulteriori informazioni sull'utente non elencate nelle propriet\xe0 utente predefinite, come il colore e la lingua preferiti dall'utente.",
    field_connectors: "Connessioni sociali",
    field_sso_connectors: "Connessioni enterprise",
    custom_data_invalid: "I dati personalizzati devono essere un oggetto JSON valido",
    connectors: {
        connectors: "Connettori",
        user_id: "ID utente",
        remove: "Rimuovi",
        connected: "Questo utente \xe8 connesso con pi\xf9 connettori sociali.",
        not_connected: "L'utente non \xe8 connesso a nessun connettore sociale",
        deletion_confirmation: "Stai rimuovendo l'identit\xe0 esistente <name/>. Sei sicuro di voler continuare?"
    },
    sso_connectors: {
        connectors: "Connettori",
        enterprise_id: "ID enterprise",
        connected: "Questo utente \xe8 connesso a pi\xf9 fornitori di identit\xe0 enterprise per il Single Sign-On.",
        not_connected: "L'utente non \xe8 connesso a nessun fornitore di identit\xe0 enterprise per il Single Sign-On."
    },
    mfa: {
        field_name: "Autenticazione a due fattori",
        field_description: "Questo utente ha abilitato fattori di autenticazione a 2 passaggi.",
        name_column: "Autenticazione a due fattori",
        field_description_empty: "Questo utente non ha abilitato fattori di autenticazione a due fattori.",
        deletion_confirmation: "Stai rimuovendo l'esistente <name/> per la verifica in due passaggi. Sei sicuro di voler continuare?"
    },
    suspended: "Sospeso",
    suspend_user: "Sospendi utente",
    suspend_user_reminder: "Sei sicuro di voler sospendere questo utente? L'utente non potr\xe0 accedere alla tua app e non sar\xe0 in grado di ottenere un nuovo token di accesso dopo la scadenza di quello corrente. Inoltre, qualsiasi richiesta API effettuata da questo utente non avr\xe0 esito.",
    suspend_action: "Sospendi",
    user_suspended: "L'utente \xe8 stato sospeso.",
    reactivate_user: "Riattiva l’utente",
    reactivate_user_reminder: "Sei sicuro di voler riattivare questo utente? Ci\xf2 consentir\xe0 eventuali tentativi di accesso per questo utente.",
    reactivate_action: "Riattiva",
    user_reactivated: "L'utente \xe8 stato riattivato.",
    roles: {
        name_column: "Ruolo",
        description_column: "Descrizione",
        assign_button: "Assegna ruoli",
        delete_description: "Questa azione rimuover\xe0 questo ruolo da questo utente. Il ruolo stesso esister\xe0 ancora, ma non sar\xe0 pi\xf9 associato a questo utente.",
        deleted: "{{nome}} \xe8 stato rimosso con successo da questo utente.",
        assign_title: "Assegna ruoli a {{nome}}",
        assign_subtitle: "Autorizza {{nome}} uno o pi\xf9 ruoli",
        assign_role_field: "Assegna ruoli",
        role_search_placeholder: "Cerca per nome ruolo",
        added_text: "{{value, number}} aggiunti",
        assigned_user_count: "{{value, number}} utenti",
        confirm_assign: "Assegna ruoli",
        role_assigned: "Ruolo(ruoli) assegnati con successo",
        search: "Cerca per nome ruolo, descrizione o ID",
        empty: "Nessun ruolo disponibile"
    },
    warning_no_sign_in_identifier: "L'utente deve avere almeno uno degli identificatori di accesso (nome utente, email, numero di telefono, o social) per accedere. Sei sicuro di voler continuare?",
    organization_roles_tooltip: "I ruoli assegnati all'utente all'interno di questa organizzazione."
};
var $b976060a1bd024ab$export$2e2bcd8739ae039 = Object.freeze($b976060a1bd024ab$var$user_details);


const $9ff2107936c3394e$var$users = {
    page_title: "Gestione utenti",
    title: "Gestione utenti",
    subtitle: "Gestisci le identit\xe0 degli utenti, inclusa la creazione di utenti, la modifica delle informazioni degli utenti, la visualizzazione dei log degli utenti, il ripristino delle password e l'eliminazione degli utenti",
    create: "Aggiungi utente",
    create_subtitle: "Fornire almeno uno dei seguenti campi per procedere.",
    error_missing_identifier: "Devi fornire almeno un identificatore per creare un utente.",
    user_name: "Utente",
    application_name: "Dall'applicazione",
    latest_sign_in: "Ultimo accesso",
    create_form_username: "Nome utente",
    create_form_password: "Password",
    create_form_name: "Nome completo",
    placeholder_name: "Mario Rossi",
    placeholder_email: "mario@example.com",
    placeholder_username: "user123",
    placeholder_phone: "+39 02 1234567",
    unnamed: "Senza nome",
    search: "Cerca per nome, email, telefono o nome utente",
    check_user_detail: "Controlla i dettagli dell'utente",
    placeholder_title: "Gestione utenti",
    placeholder_description: "Ogni utente ha un profilo contenente tutte le informazioni dell'utente. \xc8 composto da dati di base, identit\xe0 sociali e dati personalizzati."
};
var $9ff2107936c3394e$export$2e2bcd8739ae039 = Object.freeze($9ff2107936c3394e$var$users);


const $1ae03e76858a7358$var$webhook_details = {
    page_title: "Dettagli webhook",
    back_to_webhooks: "Torna ai Webhook",
    not_in_use: "Non in uso",
    success_rate: "Tasso di successo",
    requests: "{{value, number}} richieste in 24h",
    disable_webhook: "Disabilita webhook",
    disable_reminder: "Sei sicuro di voler riattivare questo webhook? Farlo non invier\xe0 una richiesta HTTP all'URL dell'endpoint.",
    webhook_disabled: "Il webhook \xe8 stato disattivato.",
    webhook_reactivated: "Il webhook \xe8 stato riattivato.",
    reactivate_webhook: "Riattiva webhook",
    delete_webhook: "Elimina webhook",
    deletion_reminder: "Stai rimuovendo questo webhook. Dopo la cancellazione non invier\xe0 una richiesta HTTP all'URL dell'endpoint.",
    deleted: "Il webhook \xe8 stato eliminato con successo.",
    settings_tab: "Impostazioni",
    recent_requests_tab: "Richieste recenti (24h)",
    settings: {
        settings: "Impostazioni",
        settings_description: "I webhook ti consentono di ricevere aggiornamenti in tempo reale su eventi specifici non appena avvengono, inviando una richiesta POST all'URL dell'endpoint. Ci\xf2 ti consente di agire immediatamente in base alle nuove informazioni ricevute.",
        events: "Eventi",
        events_description: "Seleziona gli eventi trigger che Logto invier\xe0 la richiesta POST.",
        name: "Nome",
        endpoint_url: "Endpoint URL",
        signing_key: "Chiave di firma",
        signing_key_tip: "Aggiungi la chiave segreta fornita da Logto al tuo endpoint come header richiesta per garantire l'autenticit\xe0 del payload del webhook.",
        regenerate: "Rigenera",
        regenerate_key_title: "Rigenera chiave di firma",
        regenerate_key_reminder: "Sei sicuro di voler modificare la chiave di firma? Rigenerandola avr\xe0 immediatamente effetto. Ricorda di modificare in modo sincrono la chiave di firma nel tuo endpoint.",
        regenerated: "La chiave di firma \xe8 stata rigenerata.",
        custom_headers: "Intestazioni personalizzate",
        custom_headers_tip: "Opzionalmente, puoi aggiungere intestazioni personalizzate al payload del webhook per fornire contesto o metadati aggiuntivi sull'evento.",
        key_duplicated_error: "Le chiavi non possono essere ripetute.",
        key_missing_error: "La chiave \xe8 necessaria.",
        value_missing_error: "Il valore \xe8 obbligatorio.",
        invalid_key_error: "Chiave non valida",
        invalid_value_error: "Valore non valido",
        test: "Test",
        test_webhook: "Testa il tuo webhook",
        test_webhook_description: "Configurare il webhook e testarlo con esempi di payload per ciascun evento selezionato al fine di verificare la corretta ricezione e elaborazione.",
        send_test_payload: "Invia Payload di Test",
        test_result: {
            endpoint_url: "URL del punto di arrivo: {{url}}",
            message: "Messaggio: {{message}}",
            response_status: "Stato della risposta: {{status, number}}",
            response_body: "Corpo della risposta: {{body}}",
            request_time: "Tempo di richiesta: {{time}}",
            test_success: "Il test del webhook al punto di arrivo \xe8 stato eseguito con successo."
        }
    }
};
var $1ae03e76858a7358$export$2e2bcd8739ae039 = Object.freeze($1ae03e76858a7358$var$webhook_details);


const $01bddcd1f24a7574$var$webhooks = {
    page_title: "Webhooks",
    title: "Webhooks",
    subtitle: "Crea webhook per ricevere facilmente aggiornamenti in tempo reale relativi a eventi specifici.",
    create: "Crea Webhook",
    schemas: {
        interaction: "Interazione utente",
        user: "Utente",
        organization: "Organizzazione",
        role: "Ruolo",
        scope: "Permesso",
        organization_role: "Ruolo organizzazione",
        organization_scope: "Permesso organizzazione"
    },
    table: {
        name: "Nome",
        events: "Eventi",
        success_rate: "Tasso di successo (24h)",
        requests: "Richieste (24h)"
    },
    placeholder: {
        title: "Webhook",
        description: 'Crea un webhook per ricevere aggiornamenti in tempo reale tramite richieste POST al tuo URL di destinazione. Rimani informato e agisci immediatamente su eventi come "Creazione account", "Accesso" e "Reimposta password".',
        create_webhook: "Crea Webhook"
    },
    create_form: {
        title: "Crea Webhook",
        subtitle: "Aggiungi il Webhook per inviare una richiesta POST all'endpoint URL con i dettagli degli eventi degli utenti.",
        events: "Eventi",
        events_description: "Selezionare gli eventi trigger che Logto invier\xe0 alla richiesta POST.",
        name: "Nome",
        name_placeholder: "Inserisci nome webhook",
        endpoint_url: "Endpoint URL",
        endpoint_url_placeholder: "https://your.webhook.endpoint.url",
        endpoint_url_tip: "Inserisci l'URL del tuo endpoint dove il payload del webhook viene inviato quando si verifica l'evento.",
        create_webhook: "Crea webhook",
        missing_event_error: "Devi selezionare almeno un evento."
    },
    webhook_created: "Il webhook {{name}} \xe8 stato creato con successo."
};
var $01bddcd1f24a7574$export$2e2bcd8739ae039 = Object.freeze($01bddcd1f24a7574$var$webhooks);


const $8f905c7d9fda5551$var$welcome = {
    title: "Benvenuti alla Console di Amministrazione",
    description: "La console di amministrazione \xe8 un'app web per gestire Logto senza alcuna conoscenza di programmazione. Iniziamo creando un account. Con questo account, puoi gestire Logto da solo o per conto della tua azienda.",
    create_account: "Crea account"
};
var $8f905c7d9fda5551$export$2e2bcd8739ae039 = Object.freeze($8f905c7d9fda5551$var$welcome);


const $3e918acc50aa6ff5$var$admin_console = {
    title: "Admin Console",
    admin_user: "Admin",
    system_app: "System",
    menu: $917e0ed66a9be1c6$export$2e2bcd8739ae039,
    general: $3bf2bb129e964f4b$export$2e2bcd8739ae039,
    errors: $5496d6053f9dcdb1$export$2e2bcd8739ae039,
    tab_sections: $1de5631198c84f55$export$2e2bcd8739ae039,
    tabs: $e30ec9dcae37912d$export$2e2bcd8739ae039,
    applications: $acb3175029a99849$export$2e2bcd8739ae039,
    application_details: $72d0e6b446f18320$export$2e2bcd8739ae039,
    api_resources: $b690081abf749e16$export$2e2bcd8739ae039,
    api_resource_details: $00e275692131715b$export$2e2bcd8739ae039,
    connectors: $d1a7e7cf973e53f7$export$2e2bcd8739ae039,
    connector_details: $d9b858256fe4cc74$export$2e2bcd8739ae039,
    enterprise_sso: $a48364f807a90bdf$export$2e2bcd8739ae039,
    enterprise_sso_details: $f22bf26b8728508b$export$2e2bcd8739ae039,
    get_started: $3995cd686529f7b4$export$2e2bcd8739ae039,
    users: $9ff2107936c3394e$export$2e2bcd8739ae039,
    user_details: $b976060a1bd024ab$export$2e2bcd8739ae039,
    contact: $9c56fe8fa8cd962c$export$2e2bcd8739ae039,
    sign_in_exp: $46d2a32fb9ebcb2a$export$2e2bcd8739ae039,
    dashboard: $e79066ce84b22daa$export$2e2bcd8739ae039,
    logs: $fe62f975da263be0$export$2e2bcd8739ae039,
    log_details: $b9be121f1c40ca21$export$2e2bcd8739ae039,
    session_expired: $a390cd9da1b5ce1a$export$2e2bcd8739ae039,
    welcome: $8f905c7d9fda5551$export$2e2bcd8739ae039,
    roles: $0f3b0968240354d6$export$2e2bcd8739ae039,
    role_details: $c441d23561407662$export$2e2bcd8739ae039,
    permissions: $09a2539ee8ee92d7$export$2e2bcd8739ae039,
    cloud: $6c06da46a777c1d7$export$2e2bcd8739ae039,
    profile: $80ddb45b695f48ca$export$2e2bcd8739ae039,
    components: $eb5a642fe4aefa7e$export$2e2bcd8739ae039,
    webhooks: $01bddcd1f24a7574$export$2e2bcd8739ae039,
    webhook_details: $1ae03e76858a7358$export$2e2bcd8739ae039,
    domain: $3b2700d3bafe9f14$export$2e2bcd8739ae039,
    tenants: $9be74053c1b618b3$export$2e2bcd8739ae039,
    tenant_members: $3562999ae1dfb27b$export$2e2bcd8739ae039,
    topbar: $7da3088847abb01c$export$2e2bcd8739ae039,
    subscription: $0f13a7d0df2e1eef$export$2e2bcd8739ae039,
    upsell: $1557735d43be618f$export$2e2bcd8739ae039,
    guide: $629be0cdf71a5332$export$2e2bcd8739ae039,
    mfa: $4e9ab97e7db52847$export$2e2bcd8739ae039,
    organizations: $2fcca328776342ae$export$2e2bcd8739ae039,
    organization_details: $f5a2e3db1982f438$export$2e2bcd8739ae039,
    protected_app: $18ab60f0fe1e1ec6$export$2e2bcd8739ae039,
    jwt_claims: $04e3568b9a5684de$export$2e2bcd8739ae039,
    invitation: $03aa8a5c1a100830$export$2e2bcd8739ae039,
    signing_keys: $b96c982602b11089$export$2e2bcd8739ae039,
    organization_template: $8f2cfb17739b6542$export$2e2bcd8739ae039,
    organization_role_details: $a5e5adc3e7b593d0$export$2e2bcd8739ae039
};
var $3e918acc50aa6ff5$export$2e2bcd8739ae039 = Object.freeze($3e918acc50aa6ff5$var$admin_console);


const $dd0adb0c836856fd$var$demo_app = {
    title: "Hai effettuato l'accesso anteprima live con successo!",
    subtitle: "Ecco le tue informazioni di accesso:",
    username: "Nome utente: ",
    user_id: "ID utente: ",
    sign_out: "Esci dall'anteprima live",
    continue_explore: "O continua ad esplorare",
    customize_sign_in_experience: "Personalizza l'esperienza di accesso",
    enable_passwordless: "Abilita l'accesso senza password",
    add_social_connector: "Aggiungi connettore social"
};
var $dd0adb0c836856fd$export$2e2bcd8739ae039 = Object.freeze($dd0adb0c836856fd$var$demo_app);


const $51dfde3f0eadd32e$var$oidc = {
    logout_success: "Hai effettuato il logout correttamente."
};
var $51dfde3f0eadd32e$export$2e2bcd8739ae039 = Object.freeze($51dfde3f0eadd32e$var$oidc);


const $c9f92b33d8ce902b$var$translation = {
    admin_console: $3e918acc50aa6ff5$export$2e2bcd8739ae039,
    demo_app: $dd0adb0c836856fd$export$2e2bcd8739ae039,
    oidc: $51dfde3f0eadd32e$export$2e2bcd8739ae039
};
var $c9f92b33d8ce902b$export$2e2bcd8739ae039 = Object.freeze($c9f92b33d8ce902b$var$translation);


const $065bef1f90e20d70$var$it = {
    translation: $c9f92b33d8ce902b$export$2e2bcd8739ae039,
    errors: $f83d50b72fc0d8ae$export$2e2bcd8739ae039
};
var $065bef1f90e20d70$export$2e2bcd8739ae039 = Object.freeze($065bef1f90e20d70$var$it);


const $0656efe4325f7e65$var$application = {
    invalid_type: "関連するロールを持つことができるのは、マシン間アプリケーションのみです。",
    role_exists: "ロールID {{roleId}} は、すでにこのアプリケーションに追加されています。",
    invalid_role_type: "ユーザータイプのロールをマシン間アプリケーションに割り当てることはできません。",
    invalid_third_party_application_type: "伝統的なWebアプリケーションにのみ、サードパーティアプリとしてマークできます。",
    third_party_application_only: "この機能はサードパーティアプリケーションにのみ利用可能です。",
    user_consent_scopes_not_found: "無効なユーザー同意スコープ。",
    consent_management_api_scopes_not_allowed: "管理APIスコープは許可されていません。",
    protected_app_metadata_is_required: "保護されたアプリケーションメタデータが必要です。",
    protected_app_not_configured: "保護されたアプリケーションプロバイダーが構成されていません。この機能はオープンソースバージョンでは利用できません。",
    cloudflare_unknown_error: "Cloudflare APIをリクエスト中に不明なエラーが発生しました",
    protected_application_only: "この機能は保護されたアプリケーションにのみ利用可能です。",
    protected_application_misconfigured: "保護されたアプリケーションの設定が間違っています。",
    protected_application_subdomain_exists: "保護されたアプリケーションのサブドメインはすでに使用されています。",
    invalid_subdomain: "無効なサブドメイン。",
    custom_domain_not_found: "カスタムドメインが見つかりません。",
    should_delete_custom_domains_first: "まずカスタムドメインを削除する必要があります。"
};
var $0656efe4325f7e65$export$2e2bcd8739ae039 = Object.freeze($0656efe4325f7e65$var$application);


const $98b7ffe04b8bd2ef$var$auth = {
    authorization_header_missing: "Authorizationヘッダーがありません。",
    authorization_token_type_not_supported: "認証タイプはサポートされていません。",
    unauthorized: "未承認です。資格情報とそのスコープを確認してください。",
    forbidden: "アクセスが拒否されました。ユーザーの役割と権限を確認してください。",
    expected_role_not_found: "期待される役割が見つかりませんでした。ユーザーの役割と権限を確認してください。",
    jwt_sub_missing: "JWT内に`sub`がありません。",
    require_re_authentication: "保護されたアクションを実行するには再認証が必要です。"
};
var $98b7ffe04b8bd2ef$export$2e2bcd8739ae039 = Object.freeze($98b7ffe04b8bd2ef$var$auth);


const $0bd268749330f8e3$var$connector = {
    general: "コネクタでエラーが発生しました：{{errorDescription}}",
    not_found: "タイプ：{{type}}に利用可能なコネクタが見つかりません。",
    not_enabled: "コネクタが有効ではありません。",
    invalid_metadata: "コネクタのメタデータが無効です。",
    invalid_config_guard: "コネクタの設定ガードが無効です。",
    unexpected_type: "コネクタのタイプが予期しないものです。 ",
    invalid_request_parameters: "リクエストに誤った入力パラメータが含まれています。",
    insufficient_request_parameters: "リクエストには、入力パラメータが不足している可能性があります。",
    invalid_config: "コネクタの設定が無効です。",
    invalid_certificate: "コネクタの証明書が無効です。証明書がPEMエンコードされていることを確認してください。",
    invalid_response: "コネクタのレスポンスが無効です。",
    template_not_found: "コネクタ構成から正しいテンプレートを見つけることができませんでした。",
    template_not_supported: "コネクタはこのテンプレートタイプをサポートしていません。",
    rate_limit_exceeded: "トリガーレート制限。後でもう一度お試しください。",
    not_implemented: "{{method}}：まだ実装されていません。",
    social_invalid_access_token: "コネクタのアクセストークンが無効です。",
    invalid_auth_code: "コネクタの認証コードが無効です。",
    social_invalid_id_token: "コネクタのIDトークンが無効です。",
    authorization_failed: "ユーザーの認証プロセスが失敗しました。",
    social_auth_code_invalid: "アクセストークンを取得できません。承認コードを確認してください。",
    more_than_one_sms: "SMSコネクタの数が1より大きいです。",
    more_than_one_email: "電子メールコネクタの数が1より大きいです。",
    more_than_one_connector_factory: "複数のコネクタファクトリ（ID：{{connectorIds}}）が見つかりました。必要のないものはアンインストールできます。",
    db_connector_type_mismatch: "DBには、タイプに一致しないコネクタがあります。",
    not_found_with_connector_id: "指定された標準コネクタIDでコネクタを見つけることができません。",
    multiple_instances_not_supported: "選択した標準コネクタで複数のインスタンスを作成できません。",
    invalid_type_for_syncing_profile: "ソーシャルコネクタを使用してユーザープロファイルを同期できます。",
    can_not_modify_target: "コネクタの「ターゲット」を変更できません。",
    should_specify_target: "'target'を指定する必要があります。",
    multiple_target_with_same_platform: "同じターゲットとプラットフォームを持つ複数のソーシャルコネクタを持つことはできません。",
    cannot_overwrite_metadata_for_non_standard_connector: "このコネクタの「メタデータ」は上書きできません。"
};
var $0bd268749330f8e3$export$2e2bcd8739ae039 = Object.freeze($0bd268749330f8e3$var$connector);


const $69d62cac3dd84120$var$domain = {
    not_configured: "Domain hostname provider が設定されていません。",
    cloudflare_data_missing: "cloudflare_data が見つかりませんでした。確認してください。",
    cloudflare_unknown_error: "Cloudflare API のリクエスト中に未知のエラーが発生しました。",
    cloudflare_response_error: "Cloudflare から予期しない応答がありました。",
    limit_to_one_domain: "カスタムドメインは1つしか持てません。",
    hostname_already_exists: "サーバーには既にこのドメインが存在しています。",
    cloudflare_not_found: "Cloudflare からホスト名が見つかりませんでした。",
    domain_is_not_allowed: "このドメインは許可されていません。"
};
var $69d62cac3dd84120$export$2e2bcd8739ae039 = Object.freeze($69d62cac3dd84120$var$domain);


const $8c93a56e9e8d0955$var$entity = {
    invalid_input: "入力が無効です。値のリストは空であってはなりません。",
    create_failed: "{{name}}の作成に失敗しました。",
    db_constraint_violated: "データベースの制約が違反しました。",
    not_exists: "{{name}}は存在しません。",
    not_exists_with_id: "IDが`{{id}}`の{{name}}は存在しません。",
    not_found: "リソースが存在しません。",
    relation_foreign_key_not_found: "外部キーが1つ以上見つかりません。入力を確認し、すべての参照先エンティティが存在することを確認してください。",
    unique_integrity_violation: "エンティティは既に存在します。入力を確認してもう一度お試しください。"
};
var $8c93a56e9e8d0955$export$2e2bcd8739ae039 = Object.freeze($8c93a56e9e8d0955$var$entity);


const $6f7501b0c143b546$var$guard = {
    invalid_input: "リクエスト{{type}}が無効です。",
    invalid_pagination: "リクエストのページネーション値が無効です。",
    can_not_get_tenant_id: "リクエストからテナントIDを取得できません。",
    file_size_exceeded: "ファイルサイズが超過しました。",
    mime_type_not_allowed: "MIMEタイプが許可されていません。"
};
var $6f7501b0c143b546$export$2e2bcd8739ae039 = Object.freeze($6f7501b0c143b546$var$guard);


const $722e1cd05839b33d$var$hook = {
    missing_events: "少なくとも1つのイベントを提供する必要があります。",
    send_test_payload_failed: "テストペイロードの送信に失敗しました：{{message}}",
    endpoint_responded_with_error: "エンドポイントがエラーで応答しました：{{message}}。"
};
var $722e1cd05839b33d$export$2e2bcd8739ae039 = Object.freeze($722e1cd05839b33d$var$hook);


const $45926cc7077e3c47$var$jwt_customizer = {
    general: "カスタマイズJWTトークン中にエラーが発生しました。後でもう一度お試しください。",
    can_not_create_for_admin_tenant: "管理テナントのJWTトークンカスタマイザを作成できません。"
};
var $45926cc7077e3c47$export$2e2bcd8739ae039 = Object.freeze($45926cc7077e3c47$var$jwt_customizer);


const $08d97cf9c7a51d6e$var$localization = {
    cannot_delete_default_language: "{{languageTag}}はデフォルト言語として設定されており、削除できません。",
    invalid_translation_structure: "データスキーマが無効です。入力を確認して、もう一度お試しください。"
};
var $08d97cf9c7a51d6e$export$2e2bcd8739ae039 = Object.freeze($08d97cf9c7a51d6e$var$localization);


const $c4edb8c5c61d32ba$var$log = {
    invalid_type: "ログタイプが無効です。"
};
var $c4edb8c5c61d32ba$export$2e2bcd8739ae039 = Object.freeze($c4edb8c5c61d32ba$var$log);


const $c93f7873da6e5281$var$oidc = {
    aborted: "エンドユーザが操作を中止しました。",
    invalid_scope: "スコープが無効です: {{error_description}}。",
    invalid_token: "提供されたトークンが無効です。",
    invalid_client_metadata: "提供されたクライアントメタデータが無効です。",
    insufficient_scope: "トークンにスコープ `{{scope}}` が含まれていません。",
    invalid_request: "リクエストが無効です。",
    invalid_grant: "付与リクエストが無効です。",
    invalid_redirect_uri: "`` `redirect_uri`` `は、クライアントが登録したいずれのものとも一致しませんでした```redirect_uris`。",
    access_denied: "アクセスが拒否されました。",
    invalid_target: "無効なリソース指示子です。",
    unsupported_grant_type: "要求された`grant_type`はサポートされていません。",
    unsupported_response_mode: "要求された`response_mode`はサポートされていません。",
    unsupported_response_type: "要求された`response_type`はサポートされていません。",
    provider_error: "OIDC内部エラー:{{message}}。",
    server_error: "不明なOIDCエラーが発生しました。後でもう一度お試しください。",
    provider_error_fallback: "OIDCエラーが発生しました: {{code}}。",
    key_required: "少なくとも1つのキーが必要です。",
    key_not_found: "IDが{{id}}のキーが見つかりません。"
};
var $c93f7873da6e5281$export$2e2bcd8739ae039 = Object.freeze($c93f7873da6e5281$var$oidc);


const $a06d51563dffb57f$var$organization = {
    require_membership: "ユーザーは組織のメンバーである必要があります。"
};
var $a06d51563dffb57f$export$2e2bcd8739ae039 = Object.freeze($a06d51563dffb57f$var$organization);


const $82e222cadd380cc1$var$password = {
    unsupported_encryption_method: "暗号化方式 {{name}} はサポートされていません。",
    pepper_not_found: "パスワードペッパーが見つかりません。コアの環境を確認してください。",
    rejected: "パスワードが拒否されました。パスワードが要件を満たしているか確認してください。"
};
var $82e222cadd380cc1$export$2e2bcd8739ae039 = Object.freeze($82e222cadd380cc1$var$password);


const $6b033d4c26d63d84$var$request = {
    invalid_input: "入力が無効です。 {{details}}",
    general: "リクエストエラーが発生しました。"
};
var $6b033d4c26d63d84$export$2e2bcd8739ae039 = Object.freeze($6b033d4c26d63d84$var$request);


const $1826bca5a276d23f$var$resource = {
    resource_identifier_in_use: "API識別子 {{indicator}} はすでに使用されています",
    cannot_delete_management_api: "Logto管理APIを削除できません。",
    cannot_modify_management_api: "Logto管理APIを変更できません。"
};
var $1826bca5a276d23f$export$2e2bcd8739ae039 = Object.freeze($1826bca5a276d23f$var$resource);


const $f483f1da18002136$var$role = {
    name_in_use: "このロール名{{name}}はすでに使用されています",
    scope_exists: "スコープID {{scopeId}}はすでにこのロールに追加されています",
    management_api_scopes_not_assignable_to_user_role: "ユーザーのロールに管理APIのスコープを割り当てることはできません。",
    user_exists: "ユーザーID{{userId}}はすでにこのロールに追加されています",
    application_exists: "アプリケーション ID {{applicationId}} はすでにこのロールに追加されています",
    default_role_missing: "データベースにデフォルトロール名が存在しないものがあります。ロールを作成してください",
    internal_role_violation: "Logtoによって許可されていない内部ロールの更新または削除を試みている可能性があります。新しいロールを作成する場合は、「#internal：」で始まる別の名前を試してください。"
};
var $f483f1da18002136$export$2e2bcd8739ae039 = Object.freeze($f483f1da18002136$var$role);


const $022a73069865e150$var$scope = {
    name_exists: "スコープ名 {{name}} は既に使用されています",
    name_with_space: "スコープの名前にはスペースを含めることはできません。"
};
var $022a73069865e150$export$2e2bcd8739ae039 = Object.freeze($022a73069865e150$var$scope);


const $ca39558071a884bf$var$session = {
    not_found: "セッションが見つかりません。戻って再度サインインしてください。",
    invalid_credentials: "アカウントまたはパスワードが正しくありません。入力内容を確認してください。",
    invalid_sign_in_method: "現在のサインイン方法は利用できません。",
    invalid_connector_id: "利用可能なid {{connectorId}} のコネクタが見つかりません。",
    insufficient_info: "十分なサインイン情報がありません。",
    connector_id_mismatch: "コネクタIDがセッションレコードと一致しません。",
    connector_session_not_found: "コネクタセッションが見つかりません。戻って再度サインインしてください。",
    verification_session_not_found: "検証が成功しませんでした。検証フローを再開してもう一度やり直してください。",
    verification_expired: "接続がタイムアウトしました。アカウントの安全性を確保するために再度検証してください。",
    verification_blocked_too_many_attempts: "Too many attempts in a short time. Please try again {{relativeTime}}.",
    unauthorized: "最初にサインインしてください。",
    unsupported_prompt_name: "サポートされていないプロンプト名です。",
    forgot_password_not_enabled: "パスワードを忘れた場合の対処が有効になっていません。",
    verification_failed: "検証が成功しませんでした。検証フローを再開してもう一度やり直してください。",
    connector_validation_session_not_found: "トークン検証用のコネクタセッションが見つかりません。",
    identifier_not_found: "ユーザーIDが見つかりません。戻って再度サインインしてください。",
    interaction_not_found: "インタラクションセッションが見つかりません。戻ってセッションを開始してください。",
    not_supported_for_forgot_password: "This operation is not supported for forgot password.",
    mfa: {
        require_mfa_verification: "Mfa verification is required to sign in.",
        mfa_sign_in_only: "Mfa is only available for sign-in interaction.",
        pending_info_not_found: "Pending MFA info not found, please initiate MFA first.",
        invalid_totp_code: "Invalid TOTP code.",
        webauthn_verification_failed: "WebAuthn verification failed.",
        webauthn_verification_not_found: "WebAuthn verification not found.",
        bind_mfa_existed: "MFA already exists.",
        backup_code_can_not_be_alone: "Backup code can not be the only MFA.",
        backup_code_required: "Backup code is required.",
        invalid_backup_code: "Invalid backup code.",
        mfa_policy_not_user_controlled: "MFA policy is not user controlled."
    },
    sso_enabled: "このメールアドレスではシングルサインオンが有効になっています。SSOでサインインしてください。"
};
var $ca39558071a884bf$export$2e2bcd8739ae039 = Object.freeze($ca39558071a884bf$var$session);


const $78128bfc2c19a380$var$sign_in_experiences = {
    empty_content_url_of_terms_of_use: "「利用規約」のコンテンツURLが空です。「利用規約」が有効になっている場合は、コンテンツURLを追加してください。",
    empty_social_connectors: "「ソーシャルサインイン」方式が有効な場合は、有効なソーシャルコネクタを追加してください。",
    enabled_connector_not_found: "{{type}}コネクタが見つかりません。",
    not_one_and_only_one_primary_sign_in_method: "主要なサインイン方式は1つだけにしてください。入力内容を確認してください。",
    username_requires_password: "ユーザー名のサインアップ識別子にはパスワードを設定する必要があります。",
    passwordless_requires_verify: "Eメール/電話番号サインアップ識別子には、検証を有効にする必要があります。",
    miss_sign_up_identifier_in_sign_in: "サインイン方式にはサインアップ識別子を含める必要があります。",
    password_sign_in_must_be_enabled: "サインアップ時にパスワードが必要な場合、パスワードサインインを有効にする必要があります。",
    code_sign_in_must_be_enabled: "サインアップ時にパスワードが不要な場合、検証コードサインインを有効にする必要があります。",
    unsupported_default_language: "この言語- {{language}} は、現時点ではサポートされていません。",
    at_least_one_authentication_factor: "認証ファクタを1つ以上選択する必要があります。",
    backup_code_cannot_be_enabled_alone: "バックアップコードは単独で有効にできません。",
    duplicated_mfa_factors: "重複したMFAファクタです。"
};
var $78128bfc2c19a380$export$2e2bcd8739ae039 = Object.freeze($78128bfc2c19a380$var$sign_in_experiences);


const $eeffc9a59caf90a5$var$single_sign_on = {
    forbidden_domains: "パブリックメールドメインは許可されていません。",
    duplicated_domains: "重複するドメインがあります。",
    invalid_domain_format: "ドメインの形式が無効です。",
    duplicate_connector_name: "コネクタ名が既に存在します。別の名前を選択してください。"
};
var $eeffc9a59caf90a5$export$2e2bcd8739ae039 = Object.freeze($eeffc9a59caf90a5$var$single_sign_on);


const $9dfb5929a2cd3a93$var$storage = {
    not_configured: "ストレージプロバイダが設定されていません。",
    missing_parameter: "ストレージプロバイダの{{parameter}}が欠落しています。",
    upload_error: "ファイルのアップロードに失敗しました。"
};
var $9dfb5929a2cd3a93$export$2e2bcd8739ae039 = Object.freeze($9dfb5929a2cd3a93$var$storage);


const $d27214a9692864f2$var$subscription = {
    limit_exceeded: "定めた定期プランの上限に達しました。",
    get_plan_failed: "テナントのサブスクリプションプランを取得できませんでした。",
    tenant_suspended: "テナントが停止されています。管理者に連絡してください。"
};
var $d27214a9692864f2$export$2e2bcd8739ae039 = Object.freeze($d27214a9692864f2$var$subscription);


const $aac486eb8e64682c$var$swagger = {
    invalid_zod_type: "Zodのタイプが無効です。ルートガード構成を確認してください。",
    not_supported_zod_type_for_params: "パラメータにサポートされていないZodタイプがあります。ルートガード構成を確認してください。"
};
var $aac486eb8e64682c$export$2e2bcd8739ae039 = Object.freeze($aac486eb8e64682c$var$swagger);


const $318d3ea1f59c7b02$var$user = {
    username_already_in_use: "このユーザー名はすでに使用されています。",
    email_already_in_use: "このメールアドレスは既に別のアカウントに関連付けされています。",
    phone_already_in_use: "この電話番号は既に別のアカウントに関連付けされています。",
    invalid_email: "無効なメールアドレスです。",
    invalid_phone: "無効な電話番号です。",
    email_not_exist: "このメールアドレスは登録されていません。",
    phone_not_exist: "この電話番号は登録されていません。",
    identity_not_exist: "このソーシャルアカウントは登録されていません。",
    identity_already_in_use: "このソーシャルアカウントはすでに別のアカウントに関連付けされています。",
    social_account_exists_in_profile: "このソーシャルアカウントはすでに関連付けられています。",
    cannot_delete_self: "自分自身を削除することはできません。",
    sign_up_method_not_enabled: "このサインアップ方法は有効化されていません。",
    sign_in_method_not_enabled: "このサインイン方法は有効化されていません。",
    same_password: "新しいパスワードは、古いパスワードと同じであってはなりません。",
    password_required_in_profile: "サインインする前にパスワードを設定する必要があります。",
    new_password_required_in_profile: "新しいパスワードを設定する必要があります。",
    password_exists_in_profile: "すでにパスワードがプロフィールに存在しています。",
    username_required_in_profile: "サインインする前にユーザー名を設定する必要があります。",
    username_exists_in_profile: "すでにユーザー名がプロフィールに存在しています。",
    email_required_in_profile: "サインインする前にメールアドレスを追加する必要があります。",
    email_exists_in_profile: "すでにメールアドレスがプロフィールに関連付けられています。",
    phone_required_in_profile: "サインインする前に電話番号を追加する必要があります。",
    phone_exists_in_profile: "すでに電話番号がプロフィールに関連付けられています。",
    email_or_phone_required_in_profile: "サインインする前にメールアドレスまたは電話番号を追加する必要があります。",
    suspended: "このアカウントは停止されています。",
    user_not_exist: "{{ identifier }}を持つユーザーは存在しません。",
    missing_profile: "サインインする前に追加情報を提供する必要があります。",
    role_exists: "このユーザーには既に役割ID {{roleId}}が追加されています。",
    invalid_role_type: "役割タイプが無効です。ユーザーにはマシン対マシンの役割を割り当てることはできません。",
    missing_mfa: "MFAを追加してからサインインしてください。",
    totp_already_in_use: "TOTPはすでに使用されています。",
    backup_code_already_in_use: "バックアップコードはすでに使用されています。",
    password_algorithm_required: "Password algorithm is required.",
    password_and_digest: "You cannot set both plain text password and password digest."
};
var $318d3ea1f59c7b02$export$2e2bcd8739ae039 = Object.freeze($318d3ea1f59c7b02$var$user);


const $f22ca79a0002bd2c$var$verification_code = {
    phone_email_empty: "電話番号とEメールの両方が空です。",
    not_found: "検証コードが見つかりません。先に検証コードを送信してください。",
    phone_mismatch: "電話番号が一致しません。新しい検証コードをリクエストしてください。",
    email_mismatch: "Eメールが一致しません。新しい検証コードをリクエストしてください。",
    code_mismatch: "無効な検証コードです。",
    expired: "検証コードの有効期限が切れました。新しい検証コードをリクエストしてください。",
    exceed_max_try: "検証コードのリトライ上限を超えました。新しい検証コードをリクエストしてください。"
};
var $f22ca79a0002bd2c$export$2e2bcd8739ae039 = Object.freeze($f22ca79a0002bd2c$var$verification_code);


const $f0eafb3eaf003f4c$var$errors = {
    request: $6b033d4c26d63d84$export$2e2bcd8739ae039,
    auth: $98b7ffe04b8bd2ef$export$2e2bcd8739ae039,
    guard: $6f7501b0c143b546$export$2e2bcd8739ae039,
    oidc: $c93f7873da6e5281$export$2e2bcd8739ae039,
    user: $318d3ea1f59c7b02$export$2e2bcd8739ae039,
    password: $82e222cadd380cc1$export$2e2bcd8739ae039,
    session: $ca39558071a884bf$export$2e2bcd8739ae039,
    connector: $0bd268749330f8e3$export$2e2bcd8739ae039,
    verification_code: $f22ca79a0002bd2c$export$2e2bcd8739ae039,
    sign_in_experiences: $78128bfc2c19a380$export$2e2bcd8739ae039,
    jwt_customizer: $45926cc7077e3c47$export$2e2bcd8739ae039,
    localization: $08d97cf9c7a51d6e$export$2e2bcd8739ae039,
    swagger: $aac486eb8e64682c$export$2e2bcd8739ae039,
    entity: $8c93a56e9e8d0955$export$2e2bcd8739ae039,
    log: $c4edb8c5c61d32ba$export$2e2bcd8739ae039,
    role: $f483f1da18002136$export$2e2bcd8739ae039,
    scope: $022a73069865e150$export$2e2bcd8739ae039,
    storage: $9dfb5929a2cd3a93$export$2e2bcd8739ae039,
    resource: $1826bca5a276d23f$export$2e2bcd8739ae039,
    hook: $722e1cd05839b33d$export$2e2bcd8739ae039,
    domain: $69d62cac3dd84120$export$2e2bcd8739ae039,
    subscription: $d27214a9692864f2$export$2e2bcd8739ae039,
    application: $0656efe4325f7e65$export$2e2bcd8739ae039,
    organization: $a06d51563dffb57f$export$2e2bcd8739ae039,
    single_sign_on: $eeffc9a59caf90a5$export$2e2bcd8739ae039
};
var $f0eafb3eaf003f4c$export$2e2bcd8739ae039 = Object.freeze($f0eafb3eaf003f4c$var$errors);


const $8b54a90723ae2332$var$api_resource_details = {
    page_title: "APIリソースの詳細",
    back_to_api_resources: "APIリソースに戻る",
    general_tab: "一般",
    permissions_tab: "権限",
    settings: "設定",
    settings_description: "APIリソース、またはリソースインジケータは、通常、リソースの識別子を表すURI形式の変数を表します。",
    management_api_settings_description: "Logto管理APIは、管理者が幅広いID関連タスクを管理し、セキュリティポリシーを強制し、規制や標準に準拠するための包括的なAPIのコレクションです。",
    management_api_notice: "この API は Logto エンティティを表しており、変更や削除はできません。Logto 管理 API を呼び出すには、マシン間アプリケーションを作成してください。 <a>詳細はこちら</a>",
    token_expiration_time_in_seconds: "トークンの有効期限（秒単位）",
    token_expiration_time_in_seconds_placeholder: "トークンの有効期限を入力してください",
    delete_description: "この操作は元に戻すことはできません。APIリソースを完全に削除します。削除を確認するために、APIリソース名を入力してください。 <span>{{name}}</span>",
    enter_your_api_resource_name: "APIリソース名を入力してください",
    api_resource_deleted: "APIリソース {{name}} が正常に削除されました",
    permission: {
        create_button: "権限を作成",
        create_title: "権限の作成",
        create_subtitle: "このAPIで必要な権限（スコープ）を定義します。",
        confirm_create: "権限を作成",
        edit_title: "API権限の編集",
        edit_subtitle: "Define the permissions (scopes) needed by the {{resourceName}} API.",
        name: "権限名",
        name_placeholder: "read:resource",
        forbidden_space_in_name: "権限名にはスペースを含めることはできません。",
        description: "説明",
        description_placeholder: "リソースを読み込むことができます",
        permission_created: "権限 {{name}} が正常に作成されました",
        delete_description: "この権限が削除されると、この権限を持っていたユーザーはそれによって与えられたアクセスを失います。",
        deleted: '権限 "{{name}}" が正常に削除されました。'
    }
};
var $8b54a90723ae2332$export$2e2bcd8739ae039 = Object.freeze($8b54a90723ae2332$var$api_resource_details);


const $8ae794ecafb29286$var$api_resources = {
    page_title: "API リソース",
    title: "API リソース",
    subtitle: "承認されたアプリケーションが利用できるAPIを定義",
    create: "API リソースを作成",
    api_name: "API 名",
    api_name_placeholder: "API 名を入力してください",
    api_identifier: "API Identifier",
    api_identifier_placeholder: "https://your-api-identifier/",
    api_identifier_tip: "API リソースの一意の識別子です。絶対URIで、フラグメント(#)コンポーネントはありません。OAuth 2.0での<a>resource parameter</a>に等しいです。",
    default_api: "デフォルトのAPI",
    default_api_label: "テナントごとにデフォルトのAPIを0または1つだけ設定できます。デフォルトのAPIが指定されている場合、認証リクエストでリソースパラメータを省略できます。その後のトークン交換は、デフォルトのAPIを対象として行われます。それにより、JWTが発行されます。<a>詳細を見る</a>",
    api_resource_created: "APIリソース{{name}}が正常に作成されました",
    invalid_resource_indicator_format: "API indicator must be a valid absolute URI."
};
var $8ae794ecafb29286$export$2e2bcd8739ae039 = Object.freeze($8ae794ecafb29286$var$api_resources);


const $bac2c818ed89de66$var$application_details = {
    page_title: "アプリケーションの詳細",
    back_to_applications: "アプリケーションに戻る",
    check_guide: "ガイドを確認",
    settings: "設定",
    settings_description: 'An "Application" is a registered software or service that can access user info or act for a user. Applications help recognize who’s asking for what from Logto and handle the sign-in and permission. Fill in the required fields for authentication.',
    integration: "統合",
    integration_description: "Deploy with Logto secure workers, powered by Cloudflare's edge network for top-tier performance and 0ms cold starts worldwide.",
    service_configuration: "サービス構成",
    service_configuration_description: "サービスで必要な構成を完了します。",
    session: "セッション",
    endpoints_and_credentials: "エンドポイントと資格情報",
    endpoints_and_credentials_description: "次のエンドポイントと資格情報を使用して、アプリケーションでOIDC接続を設定します。",
    refresh_token_settings: "リフレッシュトークン",
    refresh_token_settings_description: "このアプリケーションのリフレッシュトークン規則を管理します。",
    application_roles: "役割",
    machine_logs: "マシンログ",
    application_name: "アプリケーション名",
    application_name_placeholder: "私のアプリ",
    description: "説明",
    description_placeholder: "アプリケーションの説明を入力してください",
    config_endpoint: "OpenIDプロバイダ構成エンドポイント",
    authorization_endpoint: "認可エンドポイント",
    authorization_endpoint_tip: "認証と認可を実行するエンドポイントです。OpenID Connectの<a>認証</a>に使用されます。",
    show_endpoint_details: "エンドポイントの詳細を表示",
    hide_endpoint_details: "エンドポイントの詳細を非表示",
    logto_endpoint: "Logto エンドポイント",
    application_id: "アプリID",
    application_id_tip: "通常Logtoによって生成される一意のアプリケーション識別子です。OpenID Connectでは「<a>client_id</a>」とも呼ばれます。",
    application_secret: "アプリのシークレット",
    redirect_uri: "リダイレクトURI",
    redirect_uris: "リダイレクトURI",
    redirect_uri_placeholder: "https://your.website.com/app",
    redirect_uri_placeholder_native: "io.logto://callback",
    redirect_uri_tip: "ユーザーがサインイン（成功した場合も失敗した場合も）した後にリダイレクトされるURIです。詳細については、OpenID Connectの<a>AuthRequest</a>を参照してください。",
    post_sign_out_redirect_uri: "サインアウト後のリダイレクトURI",
    post_sign_out_redirect_uris: "サインアウト後のリダイレクトURI",
    post_sign_out_redirect_uri_placeholder: "https://your.website.com/home",
    post_sign_out_redirect_uri_tip: "ユーザーのサインアウト後にリダイレクトされるURIです（オプション）。一部のアプリケーションタイプでは実質的な効果がない可能性があります。",
    cors_allowed_origins: "CORS許可されたオリジン",
    cors_allowed_origins_placeholder: "https://your.website.com",
    cors_allowed_origins_tip: "デフォルトでは、リダイレクトURIのすべてのオリジンが許可されます。通常、このフィールドでは何も行動を必要としません。これについての詳細情報は<a>MDN doc</a>を参照してください。",
    token_endpoint: "トークンエンドポイント",
    user_info_endpoint: "ユーザー情報エンドポイント",
    enable_admin_access: "管理者アクセスを有効にする",
    enable_admin_access_label: "管理APIへのアクセスを有効または無効にします。有効にすると、アクセストークンを使用してこのアプリケーションを代表して管理APIを呼び出すことができます。",
    always_issue_refresh_token: "常にRefresh Tokenを発行する",
    always_issue_refresh_token_label: "この設定を有効にすると、Logtoは、認証要求に「prompt = consent」が提示されたかどうかにかかわらず、常にRefresh Tokenを発行することができます。ただし、OpenID Connectと互換性がないため、必要でない限りこのプラクティスは推奨されず、問題が発生する可能性があります。",
    refresh_token_ttl: "リフレッシュトークンの有効期限（日単位）",
    refresh_token_ttl_tip: "リフレッシュトークンが期限切れになるまでの期間です。トークンリクエストは、リフレッシュトークンのTTLをこの値に延長します。",
    rotate_refresh_token: "Refresh Tokenを切り替える",
    rotate_refresh_token_label: "有効にすると、Logtoは、元のTTLの70％が経過したときまたは特定の条件が満たされた場合、トークン要求で新しいRefresh Tokenを発行します。<a>詳細を見る</a>",
    delete_description: "この操作は元に戻すことはできません。アプリケーション名「<span>{{name}}</span>」を入力して確認してください。",
    enter_your_application_name: "アプリケーション名を入力してください",
    application_deleted: "アプリケーション{{name}}が正常に削除されました",
    redirect_uri_required: "リダイレクトURIを少なくとも1つ入力する必要があります",
    app_domain_description_1: "Feel free to use your domain with {{domain}} powered by Logto, which is permanently valid.",
    app_domain_description_2: "Feel free to utilize your domain <domain>{{domain}}</domain> which is permanently valid.",
    custom_rules: "カスタム認証ルール",
    custom_rules_placeholder: "^/(admin|privacy)/.+",
    custom_rules_description: "Set rules with regular expressions for authentication-required routes. Default: full-site protection if left blank.",
    authentication_routes: "認証ルート",
    custom_rules_tip: "Here are two case scenarios:<ol><li>To only protect routes '/admin' and '/privacy' with authentication: ^/(admin|privacy)/.*</li><li>To exclude JPG images from authentication: ^(?!.*\\.jpg$).*$</li></ol>",
    authentication_routes_description: "Redirect your authentication button using the specified routes. Note: These routes are irreplaceable.",
    protect_origin_server: "オリジンサーバーを保護する",
    protect_origin_server_description: "Ensure to protect your origin server from direct access. Refer to the guide for more <a>detailed instructions</a>.",
    session_duration: "セッション期間（日単位）",
    try_it: "お試しください",
    branding: {
        name: "ブランディング",
        description: "Consent画面上でアプリケーションの表示名とロゴをカスタマイズします。",
        more_info: "詳細",
        more_info_description: "Consent画面上でアプリケーションに関する追加情報を提供します。",
        display_name: "表示名",
        display_logo: "表示ロゴ",
        display_logo_dark: "表示ロゴ（ダーク）",
        terms_of_use_url: "アプリケーション利用規約URL",
        privacy_policy_url: "アプリケーションプライバシーポリシーURL"
    },
    permissions: {
        name: "権限",
        description: "ユーザーが特定のデータタイプにアクセスするためにサードパーティアプリケーションに対して承認される必要がある権限を選択します。",
        user_permissions: "個人ユーザーデータ",
        organization_permissions: "組織アクセス",
        table_name: "権限を許可",
        field_name: "権限",
        field_description: "同意画面に表示",
        delete_text: "権限を削除",
        permission_delete_confirm: "この操作は、ユーザーの特定のデータタイプに対するユーザー認証を要求するアプリケーションに許可された権限を撤回し、続行してもよろしいですか？",
        permissions_assignment_description: "ユーザーが特定のデータタイプにアクセスするためにサードパーティアプリケーションが要求している権限を選択します。",
        user_profile: "ユーザーデータ",
        api_permissions: "API権限",
        organization: "組織権限",
        user_permissions_assignment_form_title: "ユーザープロファイル権限を追加",
        organization_permissions_assignment_form_title: "組織権限を追加",
        api_resource_permissions_assignment_form_title: "APIリソース権限を追加",
        user_data_permission_description_tips: "個人ユーザーデータ権限の説明を「サインイン体験 > コンテンツ > 言語管理」を介して変更できます",
        permission_description_tips: "Logtoがサードパーティアプリケーションの認証プロバイダ（IdP）として使用され、ユーザーに承認を要求される場合、この説明が同意画面に表示されます。",
        user_title: "ユーザー",
        user_description: "特定のユーザーデータにアクセスするためにサードパーティアプリケーションが要求する権限を選択します。",
        grant_user_level_permissions: "ユーザーデータの権限を付与する",
        organization_title: "組織",
        organization_description: "特定の組織データにアクセスするためにサードパーティアプリケーションが要求する権限を選択します。",
        grant_organization_level_permissions: "組織データの権限を付与する"
    },
    roles: {
        name_column: "役割",
        description_column: "説明",
        assign_button: "役割を割り当てる",
        delete_description: "この操作は、このマシン対マシンアプリからこの役割を削除します。役割自体はまだ存在しますが、もはやマシン対マシンアプリに関連付けられていません。",
        deleted: "{{name}} がこのユーザーから正常に削除されました。",
        assign_title: "{{name}} に役割を割り当てる",
        assign_subtitle: "{{name}} に1つ以上の役割を承認する",
        assign_role_field: "役割を割り当てる",
        role_search_placeholder: "役割名で検索",
        added_text: "{{value, number}} 件追加",
        assigned_app_count: "{{value, number}} 個のアプリケーション",
        confirm_assign: "役割を割り当てる",
        role_assigned: "役割の割り当てに成功しました。",
        search: "役割名、説明、または ID で検索",
        empty: "利用可能な役割はありません"
    }
};
var $bac2c818ed89de66$export$2e2bcd8739ae039 = Object.freeze($bac2c818ed89de66$var$application_details);


const $70e8f7d918147951$var$applications = {
    page_title: "アプリケーション ",
    title: "アプリケーション ",
    subtitle: "ネイティブ、シングルページ、マシン・トゥ・マシン、または従来のアプリケーションにLogto認証を設定する",
    subtitle_with_app_type: "あなたの {{name}} アプリケーションに Logto 認証を設定する",
    create: "アプリケーションを作成する",
    create_subtitle_third_party: "LogtoをIdentity Provider（IdP）として使用し、サードパーティアプリケーションと簡単に統合できます",
    application_name: "アプリケーション名",
    application_name_placeholder: "私のアプリ",
    application_description: "アプリケーションの説明",
    application_description_placeholder: "アプリケーションの説明を入力してください",
    select_application_type: "アプリケーションタイプを選択してください",
    no_application_type_selected: "まだアプリケーションタイプが選択されていません",
    application_created: "アプリケーションが正常に作成されました。",
    tab: {
        my_applications: "My apps",
        third_party_applications: "Third-party apps"
    },
    app_id: "App ID",
    type: {
        native: {
            title: "ネイティブアプリ",
            subtitle: "ネイティブ環境で実行されるアプリケーション",
            description: "例：iOSアプリ、Androidアプリ"
        },
        spa: {
            title: "シングルページアプリ",
            subtitle: "Webブラウザで実行され、データを動的に更新するアプリケーション",
            description: "例：React DOMアプリ、Vueアプリ"
        },
        traditional: {
            title: "従来的なWeb",
            subtitle: "Webサーバーのみでページをレンダリングおよび更新するアプリケーション",
            description: "例：Next.js、PHP"
        },
        machine_to_machine: {
            title: "Machine-to-Machine",
            subtitle: "リソースに直接アクセスするアプリケーション（通常はサービス）",
            description: "例：バックエンドサービス"
        },
        protected: {
            title: "Protected App",
            subtitle: "Logtoによって保護されたアプリ",
            description: "N/A"
        },
        third_party: {
            title: "Third-party App",
            subtitle: "サードパーティIdPコネクターとして使用されるアプリ",
            description: "例：OIDC、SAML"
        }
    },
    placeholder_title: "続行するにはアプリケーションタイプを選択してください",
    placeholder_description: "LogtoはOIDCのためにアプリケーションエンティティを使用して、アプリケーションの識別、サインインの管理、監査ログの作成などのタスクをサポートします。",
    m2m_role_assignment: {
        title: "アプリを権限付きのマシン間ロールで認可する",
        subtitle: "マシン間アプリケーションには承認されたマシン間ロールが必要です。",
        role_creation_hint: "適切なマシン間ロールが見つかりませんか？ <a>マシン間ロールを作成する</a>"
    }
};
var $70e8f7d918147951$export$2e2bcd8739ae039 = Object.freeze($70e8f7d918147951$var$applications);


const $5a90bd1235279532$var$cloud = {
    general: {
        onboarding: "オンボーディング"
    },
    welcome: {
        page_title: "ようこそ",
        title: "Logto Cloud へようこそ！あなたについて少し学びたいです。",
        description: "あなたの情報を知ることで、あなたにユニークなLogtoエクスペリエンスを提供します。あなたの情報は安全に保管されます。",
        project_field: "ログトを使用しています",
        project_options: {
            personal: "個人プロジェクト",
            company: "会社プロジェクト"
        },
        company_name_field: "会社名",
        company_name_placeholder: "Acme.co",
        stage_field: "製品は現在どの段階にありますか？",
        stage_options: {
            new_product: "新しいプロジェクトを開始し、素早く立ち上げたい場合",
            existing_product: "現在の認証（例：自社構築、Auth0、Cognito、Microsoft）から移行する",
            target_enterprise_ready: "大きなクライアントを獲得したため、製品を企業向けに販売できるようにしたい"
        },
        additional_features_field: "私たちに伝えたいことはありますか？",
        additional_features_options: {
            customize_ui_and_flow: "自分の UI を構築および管理し、Logto の事前に構築されたカスタマイズ可能なソリューションだけではなく使用する",
            compliance: "SOC2とGDPRは必須です",
            export_user_data: "Logtoからユーザーデータをエクスポートする機能が必要です",
            budget_control: "予算管理が非常に厳しいです",
            bring_own_auth: "独自の認証サービスを持っており、Logtoの機能が必要な場合",
            others: "上記のどれにも該当しません"
        }
    },
    sie: {
        page_title: "サインインエクスペリエンスのカスタマイズ",
        title: "まずは簡単にサインインエクスペリエンスをカスタマイズしましょう",
        inspire: {
            title: "魅力的な例を作成",
            description: "サインインエクスペリエンスに自信がない場合は、「Inspire Me」をクリックして、マジックが行われるのを待ちましょう！",
            inspire_me: "インスパイア"
        },
        logo_field: "アプリのロゴ",
        color_field: "ブランドカラー",
        identifier_field: "識別子",
        identifier_options: {
            email: "メール",
            phone: "電話",
            user_name: "ユーザー名"
        },
        authn_field: "認証",
        authn_options: {
            password: "パスワード",
            verification_code: "検証コード"
        },
        social_field: "ソーシャルサインイン",
        finish_and_done: "完了",
        preview: {
            mobile_tab: "モバイル",
            web_tab: "Web"
        },
        connectors: {
            unlocked_later: "後でロックを解除",
            unlocked_later_tip: "オンボーディングプロセスを完了してプロダクトに入った後、より多くのソーシャルサインイン方法にアクセスできるようになります。",
            notice: "本番目的でのデモコネクタの使用は避けてください。テストを完了したら、デモコネクタを削除し、自分のクレデンシャルを使用して独自のコネクタを設定してください。"
        }
    },
    socialCallback: {
        title: "ログインが成功しました",
        description: "ソーシャルアカウントを使用して正常にサインインしました。Logtoのすべての機能にシームレスにアクセスできるようにするために、独自のソーシャルコネクタを設定することをお勧めします。"
    },
    tenant: {
        create_tenant: "テナントを作成する"
    }
};
var $5a90bd1235279532$export$2e2bcd8739ae039 = Object.freeze($5a90bd1235279532$var$cloud);


const $c9288b8338093d9d$var$components = {
    uploader: {
        action_description: "ドラッグアンドドロップまたはブラウズ",
        uploading: "アップロード中...",
        image_limit: "{{size, number}}KB以下のイメージをアップロードし、{{extensions, list(style: narrow; type: conjunction;)}}のみ許可します。",
        error_upload: "エラーが発生しました。ファイルのアップロードに失敗しました。",
        error_file_size: "{{size, number}}KB以下のファイルをアップロードしてください。",
        error_file_type: "{{extensions, list(style: narrow; type: conjunction;)}}のみサポートされます。",
        error_file_count: "1つのファイルしかアップロードできません。"
    }
};
var $c9288b8338093d9d$export$2e2bcd8739ae039 = Object.freeze($c9288b8338093d9d$var$components);


const $7c873fac3e685b07$var$connector_details = {
    page_title: "コネクターの詳細",
    back_to_connectors: "コネクタに戻る",
    check_readme: "READMEを確認する",
    settings: "一般設定",
    settings_description: "コネクタはLogtoに不可欠です。Logtoはコネクタのおかげでエンドユーザーがパスワードレス登録またはサインインを利用し、ソーシャルアカウントでサインインすることができる機能を提供することができます。",
    parameter_configuration: "パラメーター設定",
    test_connection: "テスト",
    save_error_empty_config: "設定を入力してください",
    send: "送信",
    send_error_invalid_format: "入力が無効です",
    edit_config_label: "JSONを入力してください",
    test_email_sender: "メールコネクタのテスト",
    test_sms_sender: "SMSコネクタのテスト",
    test_email_placeholder: "john.doe@example.com",
    test_sms_placeholder: "+1 555-123-4567",
    test_message_sent: "テストメッセージが送信されました",
    test_sender_description: "Logtoはテストのために「共通」テンプレートを使用しています。コネクタが正しく構成されている場合、メッセージを受信します。",
    options_change_email: "メールコネクタの変更",
    options_change_sms: "SMSコネクタの変更",
    connector_deleted: "コネクタが正常に削除されました",
    type_email: "メールコネクタ",
    type_sms: "SMSコネクタ",
    type_social: "ソーシャルコネクタ",
    in_used_social_deletion_description: "このコネクタはあなたのサインイン体験で使用されています。削除すると、サインイン体験設定のサインイン体験が削除されます。再追加する場合は再設定する必要があります。",
    in_used_passwordless_deletion_description: "この{{name}}はあなたのサインイン体験で使用されています。削除すると、競合が解決されるまでサインイン体験が正常に機能しません。再追加する場合は再設定する必要があります。",
    deletion_description: "このコネクタを削除します。元に戻すことはできず、再追加する場合は再設定する必要があります。",
    logto_email: {
        total_email_sent: "総送信数: {{value, number}}",
        total_email_sent_tip: "Logto はセキュアかつ安定した組み込みメールのために SendGrid を利用しています。完全に無料です。<a>詳細を見る</a>",
        email_template_title: "メールテンプレート",
        template_description: "組み込みのメールは、シームレスな認証メールの配信のためにデフォルトのテンプレートを使用します。設定は必要ありません。基本的なブランド情報をカスタマイズできます。",
        template_description_link_text: "テンプレートを表示",
        description_action_text: "テンプレートを表示",
        from_email_field: "送信元メールアドレス",
        sender_name_field: "送信元名",
        sender_name_tip: "メールの送信元名をカスタマイズします。空白の場合、「Verification」がデフォールト名として使用されます。",
        sender_name_placeholder: "送信元の名前を入力してください",
        company_information_field: "企業情報",
        company_information_description: "メールの下部に会社名、住所、郵便番号などを表示して、真正性を高めます。",
        company_information_placeholder: "会社の基本情報を入力してください",
        app_logo_field: "アプリのロゴ",
        app_logo_tip: "メールの上部にブランドロゴを表示します。ライトモードとダークモードの両方で同じ画像を使用してください。",
        urls_not_allowed: "URLは許可されません",
        test_notes: "Logtoはテストのために「共通」テンプレートを使用しています。"
    }
};
var $7c873fac3e685b07$export$2e2bcd8739ae039 = Object.freeze($7c873fac3e685b07$var$connector_details);


const $b6e7bae4d4939cdd$var$connectors = {
    page_title: "コネクタ",
    title: "コネクタ",
    subtitle: "コネクタを設定して、パスワードレスおよびソーシャルサインイン体験を有効にします",
    create: "ソーシャルコネクタを追加",
    config_sie_notice: "コネクタを設定しました。<a>{{link}}</a>で設定を確認してください。",
    config_sie_link_text: "サインイン体験",
    tab_email_sms: "メールとSMSのコネクタ",
    tab_social: "ソーシャルコネクタ",
    connector_name: "コネクタ名",
    demo_tip: "このデモコネクタの許容される最大メッセージ数は100件に限定されており、本番環境での展開は推奨されません。",
    social_demo_tip: "このデモコネクタは実演目的にのみ使用するように設計されており、本番環境での展開は推奨されません。",
    connector_type: "タイプ",
    connector_status: "サインイン体験",
    connector_status_in_use: "使用中",
    connector_status_not_in_use: "未使用",
    not_in_use_tip: {
        content: "未使用は、サインイン体験でこのサインイン方法が使用されていないことを意味します。<a>{{link}}</a>でこのサインイン方法を追加してください。",
        go_to_sie: "サインイン体験に進む"
    },
    placeholder_title: "ソーシャルコネクタ",
    placeholder_description: "Logtoは、標準プロトコルを使用して独自のソーシャルサインインコネクタを作成できるとともに、多くの一般的に使用されているソーシャルサインインコネクタを提供しています。",
    save_and_done: "保存して完了",
    type: {
        email: "メールコネクタ",
        sms: "SMSコネクタ",
        social: "ソーシャルコネクタ"
    },
    setup_title: {
        email: "メールコネクタの設定",
        sms: "SMSコネクタの設定",
        social: "ソーシャルコネクタを追加"
    },
    guide: {
        subtitle: "コネクタの設定手順",
        general_setting: "全般設定",
        parameter_configuration: "パラメータ設定",
        test_connection: "接続テスト",
        name: "ソーシャルサインインボタンの名前",
        name_placeholder: "ソーシャルサインインボタンの名前を入力",
        name_tip: "コネクタボタンの名前は「{{name}}で続ける」で表示されます。名前が長くなりすぎないように注意してください。",
        logo: "ソーシャルサインインボタンのロゴURL",
        logo_placeholder: "https://your.cdn.domain/logo.png",
        logo_tip: "ロゴ画像はコネクタに表示されます。一般的にアバターやトンマークなどを使用します。公開アクセス可能な画像リンクを取得し、リンクをここに挿入してください。",
        logo_dark: "ソーシャルサインインボタンのロゴURL（ダークモード）",
        logo_dark_placeholder: "https://your.cdn.domain/logo.png",
        logo_dark_tip: "ダークモードでコネクタのロゴを設定してください。",
        logo_dark_collapse: "折りたたむ",
        logo_dark_show: "ダークモード用のロゴ設定を表示",
        target: "Identity Providerの名前",
        target_placeholder: "コネクタIdentity Providerの名前を入力",
        target_tip: "「IdP名」として、ソーシャルIDを識別するための一意の識別子文字列を指定します。",
        target_tip_standard: "「IdP名」として、ソーシャルIDを識別するための一意の識別子文字列を指定します。この設定は、コネクタが作成された後に変更できません。",
        target_tooltip: "Logtoのソーシャルコネクタでの「IdP名」とは、ソーシャルIDの「ソース」を指します。「IdP名」は、Plat formごとに一意でなければならず、同じ名前は許可されません。「IdP名」は一度作成されたコネクタで変更することはできません。<a>詳細を見る</a>",
        target_conflict: "入力されたIdP名は、既存の<span>name</span>コネクタと一致します。同じIdP名を使用すると、ユーザーが2つの異なるコネクタを通じて同じアカウントにアクセスする予期しないサインイン動作が発生する可能性があります。",
        target_conflict_line2: '以前のユーザーが再登録せずにサインインできるように、同じIdentity Providerを持つ現在のコネクタを削除し、新しいコネクタを "IdP名" と同じで作成する場合は、前のユーザーが再登録せずにサインインできるように、同じIdentity Providerを持つ現在のコネクタを削除し、新しいコネクタを "IdP名" で作成してください。',
        target_conflict_line3: "別のIdentity Providerに接続する場合は、「IdP名」を変更して続行してください。",
        config: "構成JSONを入力してください",
        sync_profile: "プロファイル情報の同期",
        sync_profile_only_at_sign_up: "サインアップ時にのみ同期する",
        sync_profile_each_sign_in: "サインインごとに同期する",
        sync_profile_tip: "基本プロファイル（ユーザーの名前やアバターなど）をソーシャルプロバイダから同期します。",
        callback_uri: "Callback URI",
        callback_uri_description: "Redirect URIもしくはコールバックURIとも呼ばれ、Logtoに戻るURIです。コピーしてソーシャルプロバイダの構成ページに貼り付けてください。",
        acs_url: "アサーションコンシューマーサービスURL"
    },
    platform: {
        universal: "ユニバーサル",
        web: "Web",
        native: "ネイティブ"
    },
    add_multi_platform: "は複数のプラットフォームをサポートしています。続行するプラットフォームを選択してください。",
    drawer_title: "コネクターガイド",
    drawer_subtitle: "インテグレーションの手順に従ってください",
    unknown: "不明なコネクタ",
    standard_connectors: "標準コネクタ"
};
var $b6e7bae4d4939cdd$export$2e2bcd8739ae039 = Object.freeze($b6e7bae4d4939cdd$var$connectors);


const $be04ebabae0bf559$var$contact = {
    title: "ヘルプを得る",
    description: "ヘルプ要求または製品フィードバックについては、次の方法を使用してお問い合わせください。",
    discord: {
        title: "Discord コミュニティに参加する",
        description: "他の開発者と連携して解決策を見つける",
        button: "参加する"
    },
    github: {
        title: "GitHub 上でコミュニケーションする",
        description: "GitHubで問題を作成して提案する",
        button: "開く"
    },
    email: {
        title: "メールでサポートに連絡する",
        description: "詳細情報やヘルプをご希望の場合は、私たちにメッセージを送ってください",
        button: "送信する"
    },
    reserve: {
        title: "Logto チームとの会議を予約",
        description: "ライブチャットのためにすぐにセッションを予約する",
        button: "予約する"
    }
};
var $be04ebabae0bf559$export$2e2bcd8739ae039 = Object.freeze($be04ebabae0bf559$var$contact);


const $f1540a1a03aec751$var$dashboard = {
    page_title: "ダッシュボード",
    title: "ダッシュボード",
    description: "アプリのパフォーマンスについての概要を取得",
    total_users: "合計ユーザー数",
    total_users_tip: "合計ユーザー数",
    new_users_today: "本日の新規ユーザー",
    new_users_today_tip: "アプリに本日登録された新規ユーザーの数",
    new_users_7_days: "過去7日間の新規ユーザー",
    new_users_7_days_tip: "アプリに過去7日間に登録された新規ユーザーの数",
    daily_active_users: "1日あたりのアクティブユーザー",
    daily_active_users_tip: "アプリでトークンを交換したユニークユーザーの数",
    weekly_active_users: "週間アクティブユーザー",
    weekly_active_users_tip: "アプリで過去7日間にトークンを交換したユニークユーザーの数",
    monthly_active_users: "月間アクティブユーザー",
    monthly_active_users_tip: "アプリで過去30日間にトークンを交換したユニークユーザーの数"
};
var $f1540a1a03aec751$export$2e2bcd8739ae039 = Object.freeze($f1540a1a03aec751$var$dashboard);


const $a41b7abee5d8fa76$var$domain = {
    status: {
        connecting: "接続中...",
        in_use: "使用中",
        failed_to_connect: "接続に失敗しました"
    },
    update_endpoint_notice: "カスタムドメインを使用する場合は、アプリケーションのソーシャルコネクタコールバックURIとLogtoエンドポイントのドメインを更新することを忘れないでください。 <a>{{link}}</a>",
    error_hint: "{{value}} 秒後にもう一度確認するようにDNSレコードを更新してください。",
    custom: {
        custom_domain: "カスタムドメイン",
        custom_domain_description: "ブランディングを向上させるために、カスタムドメインを利用してください。このドメインは、サインインエクスペリエンスで使用されます。",
        custom_domain_field: "カスタムドメイン",
        custom_domain_placeholder: "your.domain.com",
        add_domain: "ドメインを追加",
        invalid_domain_format: '有効なドメインURLを指定してください。最低3つの部分を含め、例："your.domain.com."',
        verify_domain: "ドメインを検証",
        enable_ssl: "SSLを有効にする",
        checking_dns_tip: "DNSレコードを設定したら、最大で24時間かかる自動プロセスを待つ必要があります。移動中や一時的に中断することができますが、この動作を削除しないでください。",
        enable_ssl_tip: "SSLを有効にするには、自動的に実行され、最大で24時間かかる場合があります。このインターフェースを実行中のままにしておくことができます。",
        generating_dns_records: "DNSレコードを生成しています...",
        add_dns_records: "DNSプロバイダに次のDNSレコードを追加してください。",
        dns_table: {
            type_field: "タイプ",
            name_field: "名前",
            value_field: "値"
        },
        deletion: {
            delete_domain: "ドメインを削除",
            reminder: "カスタムドメインの削除",
            description: "このカスタムドメインを削除してもよろしいですか？",
            in_used_description: "このカスタムドメイン「<span>{{domain}}</span>」を削除してもよろしいですか？",
            in_used_tip: "以前にソーシャルコネクタプロバイダまたはアプリ終了ポイントでこのカスタムドメインを使用して設定した場合、それらのURIをLogtoデフォルトドメイン「<span>{{domain}}</span>」に変更する必要があります。これは、ソーシャルサインインボタンを機能させるために必要です。",
            deleted: "カスタムドメインを正常に削除しました！"
        }
    },
    default: {
        default_domain: "デフォルトドメイン",
        default_domain_description: "Logtoは、追加のセットアップなしで使用できる事前に構成されたデフォルトドメインを提供しています。このデフォルトドメインは、カスタムドメインを有効にしていない場合でもバックアップオプションとして機能します。",
        default_domain_field: "Logtoデフォルトドメイン"
    },
    custom_endpoint_note: 'これらのエンドポイントのドメイン名を必要に応じてカスタマイズできます。 "{{custom}}" または "{{default}}" のいずれかを選択してください。',
    custom_social_callback_url_note: 'このURIのドメイン名をアプリケーションのエンドポイントに合わせてカスタマイズできます。 "{{custom}}" または "{{default}}" のいずれかを選択してください。',
    custom_acs_url_note: 'このURIのドメイン名をアイデンティティプロバイダのアサーションコンシューマーサービスURLに合わせてカスタマイズできます。 "{{custom}}" または "{{default}}" のいずれかを選択してください。'
};
var $a41b7abee5d8fa76$export$2e2bcd8739ae039 = Object.freeze($a41b7abee5d8fa76$var$domain);


const $52b4b1a5cd6a3164$var$enterprise_sso_details = {
    back_to_sso_connectors: "企业SSO返回",
    page_title: "企业SSO连接器详情",
    readme_drawer_title: "企业SSO",
    readme_drawer_subtitle: "设置企业SSO连接器以启用终端用户SSO",
    tab_experience: "SSO体验",
    tab_connection: "连接",
    general_settings_title: "常规",
    custom_branding_title: "显示",
    custom_branding_description: "自定义终端用户单点登录流程中显示的名称和标识。如果为空，将使用默认值。",
    email_domain_field_name: "企业邮箱域",
    email_domain_field_description: "使用此邮箱域的用户可以使用SSO进行身份验证。请验证该域名属于企业。",
    email_domain_field_placeholder: "邮箱域",
    sync_profile_field_name: "从身份提供商同步配置文件信息",
    sync_profile_option: {
        register_only: "仅在首次登录时同步",
        each_sign_in: "每次登录都同步"
    },
    connector_name_field_name: "连接器名称",
    display_name_field_name: "显示名称",
    connector_logo_field_name: "显示标识",
    connector_logo_field_description: "每张图片应不超过500KB，支持SVG、PNG、JPG、JPEG格式。",
    branding_logo_context: "上传标识",
    branding_logo_error: "上传标识错误: {{error}}",
    branding_light_logo_context: "上传浅色模式标识",
    branding_light_logo_error: "上传浅色模式标识错误: {{error}}",
    branding_logo_field_name: "标识",
    branding_logo_field_placeholder: "https://your.domain/logo.png",
    branding_dark_logo_context: "上传深色模式标识",
    branding_dark_logo_error: "上传深色模式标识错误: {{error}}",
    branding_dark_logo_field_name: "标识（深色模式）",
    branding_dark_logo_field_placeholder: "https://your.domain/dark-mode-logo.png",
    check_connection_guide: "连接指南",
    enterprise_sso_deleted: "企业SSO连接器已成功删除",
    delete_confirm_modal_title: "删除企业SSO连接器",
    delete_confirm_modal_content: "您确定要删除此企业连接器吗？来自身份提供商的用户将不会使用单点登录。",
    upload_idp_metadata_title_saml: "上传元数据",
    upload_idp_metadata_description_saml: "配置从身份提供商复制的元数据。",
    upload_idp_metadata_title_oidc: "上传凭证",
    upload_idp_metadata_description_oidc: "配置从身份提供商复制的凭证和OIDC令牌信息。",
    upload_idp_metadata_button_text: "上传元数据XML文件",
    upload_signing_certificate_button_text: "上传签名证书文件",
    configure_domain_field_info_text: "添加邮箱域以引导企业用户到其身份提供商进行单点登录。",
    email_domain_field_required: "要启用企业SSO，需要填写邮箱域。",
    upload_saml_idp_metadata_info_text_url: "粘贴来自身份提供商的元数据URL以连接。",
    upload_saml_idp_metadata_info_text_xml: "粘贴从身份提供商复制的元数据以连接。",
    upload_saml_idp_metadata_info_text_manual: "填写从身份提供商复制的元数据以连接。",
    upload_oidc_idp_info_text: "填写从身份提供商复制的信息以连接。",
    service_provider_property_title: "在身份提供商中配置",
    service_provider_property_description: "通过您的身份提供商使用 {{protocol}} 配置一个应用程序集成。 输入Logto提供的详细信息。",
    attribute_mapping_title: "属性映射",
    attribute_mapping_description: "通过在身份提供商或Logto端配置用户属性映射，从而同步用户配置文件。",
    saml_preview: {
        sign_on_url: "登录URL",
        entity_id: "发行者",
        x509_certificate: "签名证书",
        certificate_content: "到期于{{date}}"
    },
    oidc_preview: {
        authorization_endpoint: "授权端点",
        token_endpoint: "令牌端点",
        userinfo_endpoint: "用户信息端点",
        jwks_uri: "JSON网页密钥集端点",
        issuer: "发行者"
    }
};
var $52b4b1a5cd6a3164$export$2e2bcd8739ae039 = Object.freeze($52b4b1a5cd6a3164$var$enterprise_sso_details);


const $618007b96ad4f33d$var$enterprise_sso = {
    page_title: "エンタープライズSSO",
    title: "エンタープライズSSO",
    subtitle: "企業のアイデンティティプロバイダーとの接続を可能にし、SP主導のシングルサインオンを有効にします。",
    create: "エンタープライズコネクターを追加",
    col_connector_name: "コネクター名",
    col_type: "タイプ",
    col_email_domain: "メールドメイン",
    placeholder_title: "エンタープライズコネクター",
    placeholder_description: "Logtoは、多くの組み込みエンタープライズアイデンティティプロバイダーを提供しており、同時にSAMLおよびOIDCプロトコルを使用して独自のプロバイダーを作成できます。",
    create_modal: {
        title: "エンタープライズコネクターを追加",
        text_divider: "または、標準プロトコルによってカスタマイズされたコネクターを作成できます。",
        connector_name_field_title: "コネクター名",
        connector_name_field_placeholder: "E.g., {corp. name} - {identity provider name}",
        create_button_text: "コネクターを作成"
    },
    guide: {
        subtitle: "企業アイデンティティプロバイダーとの接続の手順ガイド",
        finish_button_text: "続行"
    },
    basic_info: {
        title: "IdPでサービスを構成",
        description: "IdPにてSAML 2.0の新しいアプリケーション連携を作成します。次に以下の値を貼り付けます。",
        saml: {
            acs_url_field_name: "アサーションコンシューマサービスURL（応答URL）",
            audience_uri_field_name: "オーディエンスURI（SPエンティティID）"
        },
        oidc: {
            redirect_uri_field_name: "リダイレクトURI（コールバックURL）"
        }
    },
    attribute_mapping: {
        title: "属性マッピング",
        description: "IdPからのユーザープロファイル同期には`id`と`email`が必要です。次にIdPに以下のクレーム名と値を入力します。",
        col_sp_claims: "サービスプロバイダー（Logto）の値",
        col_idp_claims: "アイデンティティプロバイダーのクレーム名",
        idp_claim_tooltip: "アイデンティティプロバイダーのクレーム名"
    },
    metadata: {
        title: "IdPメタデータを構成",
        description: "アイデンティティプロバイダーのメタデータを構成します",
        dropdown_trigger_text: "別の構成方法を使用する",
        dropdown_title: "構成方法を選択",
        metadata_format_url: "メタデータURLを入力",
        metadata_format_xml: "メタデータXMLファイルをアップロード",
        metadata_format_manual: "メタデータの詳細を手動で入力",
        saml: {
            metadata_url_field_name: "メタデータURL",
            metadata_url_description: "メタデータURLからデータを動的に取得し、証明書を最新の状態に保ちます。",
            metadata_xml_field_name: "IdPメタデータXMLファイル",
            metadata_xml_uploader_text: "メタデータXMLファイルをアップロード",
            sign_in_endpoint_field_name: "サインオンURL",
            idp_entity_id_field_name: "IdPエンティティID（発行者）",
            certificate_field_name: "署名証明書",
            certificate_placeholder: "x509証明書をコピーして貼り付けてください",
            certificate_required: "署名証明書は必須です。"
        },
        oidc: {
            client_id_field_name: "クライアントID",
            client_secret_field_name: "クライアントシークレット",
            issuer_field_name: "発行者",
            scope_field_name: "スコープ"
        }
    }
};
var $618007b96ad4f33d$export$2e2bcd8739ae039 = Object.freeze($618007b96ad4f33d$var$enterprise_sso);


const $56e7f4311309fddf$var$errors = {
    something_went_wrong: "Oops！何か問題が発生しました。",
    page_not_found: "ページが見つかりません",
    unknown_server_error: "不明なサーバーエラーが発生しました",
    empty: "データなし",
    missing_total_number: "レスポンスヘッダーでTotal-Numberが見つかりません",
    invalid_uri_format: "無効なURI形式",
    invalid_origin_format: "無効なURIの起源の形式",
    invalid_json_format: "無効なJSON形式",
    invalid_regex: "無効な正規表現",
    invalid_error_message_format: "エラーメッセージの形式が無効です。",
    required_field_missing: "'{{field}}'を入力してください",
    required_field_missing_plural: "少なくとも1つの'{{field}}'を入力する必要があります",
    more_details: "詳細を見る",
    username_pattern_error: "ユーザー名には、文字、数字、またはアンダースコアしか含めることができず、数字で始めることはできません。",
    email_pattern_error: "メールアドレスが無効です。",
    phone_pattern_error: "電話番号が無効です。",
    insecure_contexts: "安全でないコンテキスト（ノンHTTP）はサポートされていません。",
    unexpected_error: "予期しないエラーが発生しました。",
    not_found: "404が見つかりません",
    create_internal_role_violation: "新しい内部ロールを作成しているため、Logtoによって禁止されています。 「#internal：」で始まらない別の名前を試してください。",
    should_be_an_integer: "整数である必要があります。",
    number_should_be_between_inclusive: "'{{min}}'から'{{max}}'（両方含む）までの数値である必要があります。"
};
var $56e7f4311309fddf$export$2e2bcd8739ae039 = Object.freeze($56e7f4311309fddf$var$errors);


const $d1beffd6e09aca5e$var$general = {
    placeholder: "プレースホルダー",
    submit: "送信",
    skip: "スキップ",
    next: "次へ",
    back: "戻る",
    retry: "もう一度試す",
    done: "完了",
    search: "検索",
    search_placeholder: "検索",
    clear_result: "検索結果をクリアする",
    save: "保存",
    save_changes: "変更を保存する",
    saved: "保存しました",
    discard: "破棄する",
    loading: "読み込み中...",
    redirecting: "リダイレクト中...",
    add: "追加",
    added: "追加されました",
    cancel: "キャンセル",
    confirm: "確認",
    check_out: "チェックアウト",
    create: "作成する",
    set_up: "設定する",
    customize: "カスタマイズする",
    enable: "有効にする",
    reminder: "リマインダー",
    edit: "編集",
    delete: "削除",
    deleted: "削除済",
    more_options: "その他のオプション",
    close: "閉じる",
    copy: "コピーする",
    copying: "コピー中",
    copied: "コピーされました",
    required: "必須",
    add_another: "もう一つ追加",
    create_another: "もう一つ作成する",
    deletion_confirmation: "{{title}}を削除してよろしいですか？",
    settings_nav: "設定",
    unsaved_changes_warning: "変更を加えました。このページを離れてもよろしいですか？",
    leave_page: "ページを離れる",
    stay_on_page: "ページにとどまる",
    type_to_search: "検索する",
    got_it: "了解",
    continue: "続ける",
    page_info: "{{total}}件中{{min}}件〜{{max}}件を表示",
    learn_more: "詳しく見る",
    tab_errors: "{{count}}件のエラーがあります",
    skip_for_now: "今回はスキップする",
    remove: "削除する",
    visit: "訪問する",
    join: "参加する",
    try_now: "今すぐ試す",
    multiple_form_field: "(複数)",
    demo: "デモ",
    unnamed: "名前がありません",
    view: "表示",
    open: "開く",
    hide: "非表示",
    unknown_error: "不明なエラーが発生しました。後で再試行してください。",
    select: "選択する",
    contact_us_action: "お問い合わせ",
    description: "説明",
    name: "名前",
    add_field: "{{field}}を追加",
    create_field: "{{field}}を作成",
    edit_field: "{{field}}を編集",
    delete_field: "{{field}}を削除",
    coming_soon: "近日公開予定",
    or: "または"
};
var $d1beffd6e09aca5e$export$2e2bcd8739ae039 = Object.freeze($d1beffd6e09aca5e$var$general);


const $5684e02660d07c89$var$get_started = {
    page_title: "はじめに",
    title: "あなたの成功を手助けする探索",
    subtitle: "Logtoの価値を迅速に把握するための数つの方法",
    develop: {
        title: "開発: 5分の時間を使ってアプリを統合してみましょう",
        title_cloud: "開発: 数分でアプリを安全に統合する",
        subtitle_cloud: "または、5分間でアプリを当社の事前構築済みSDKおよびチュートリアルで統合してください。"
    },
    customize: {
        title: "カスタマイズ: 素晴らしいサインイン体験を提供する",
        preview: {
            title: "あなたがカスタマイズしたサインイン体験のライブプレビューをチェックしましょう",
            subtitle: "Logtoのサインイン体験を試して、その使い方を確認してください"
        },
        connector: {
            title: "さらなるコネクタを追加して、さまざまなソーシャルサインイン方式をサポートしましょう",
            subtitle: "パスワードレスサインインを試して、顧客に安全かつ摩擦のない体験を提供しましょう"
        },
        continue_customizing: "カスタマイズを続ける",
        try_now: "今すぐ試す",
        add_more: "もっと追加する"
    },
    secure: {
        title: "セキュリティ: リソースを保護する"
    },
    manage: {
        title: "管理: 製品とユーザーのアクセス制御を定義する",
        rbac: {
            title: "ロールベースのアクセス制御を追加して、リソースを保護する",
            subtitle: "多様なユースケースに対してスケーラブルなロールの認可によりリソースを制御します"
        },
        create_roles: "ロールを作成する"
    },
    view_all: "すべての内容を表示 →"
};
var $5684e02660d07c89$export$2e2bcd8739ae039 = Object.freeze($5684e02660d07c89$var$get_started);


const $3a7ae0831dad21fd$var$guide = {
    start_building: "プロジェクトを開始",
    get_started: "はじめる",
    categories: {
        featured: "人気でおすすめ",
        Traditional: "伝統的な Web アプリ",
        SPA: "シングルページアプリ",
        Native: "ネイティブ",
        MachineToMachine: "Machine-to-machine",
        Protected: "非SDK統合",
        ThirdParty: "サードパーティーアプリ"
    },
    filter: {
        title: "フレームワークを絞り込む",
        placeholder: "フレームワークを検索"
    },
    checkout_tutorial: "チュートリアルを確認: {{name}}",
    do_not_need_tutorial: "もしチュートリアルが必要なければ、フレームワークガイドなしで続行できます",
    finish_and_done: "完了",
    cannot_find_guide: "ガイドが見つかりません",
    describe_guide_looking_for: "お探しのガイドの詳細を説明してください",
    request_guide_successfully: "リクエストが送信されました。ありがとうございます！",
    app: {
        select_framework_or_tutorial: "フレームワークまたはチュートリアルを選択",
        guide_modal_title: "SDK とガイドで開始",
        modal_subtitle: "私たちの事前ビルドされた SDK とチュートリアルを使用してアプリ開発プロセスをスタートさせます。",
        select_a_framework: "フレームワークを選択",
        continue_without_framework: "フレームワークなしで作成",
        describe_guide_looking_for_placeholder: "例: Logto を Angular アプリに統合したい"
    },
    api: {
        modal_title: "チュートリアルで開始",
        modal_subtitle: "前もってビルドされたチュートリアルでアプリ開発を加速します",
        select_a_tutorial: "チュートリアルを選択",
        continue_without_tutorial: "チュートリアルなしで続行",
        describe_guide_looking_for_placeholder: "例: API を deno で保護したい"
    }
};
var $3a7ae0831dad21fd$export$2e2bcd8739ae039 = Object.freeze($3a7ae0831dad21fd$var$guide);


const $53019a5b1ae01e50$var$invitation = {
    find_your_tenants: "テナントを見つける",
    find_tenants_description: "あなたのメールアドレスはすでに複数のテナントに登録されているかもしれません。既存のものに参加するか、新しいものを作成し続けるか選択できます。",
    create_new_tenant: "新しいテナントを作成",
    email_not_match_title: "現在サインインされているメールアドレス\n{{email}}",
    email_not_match_description: "招待を受け入れ、組織のメンバーになるには、正しいアカウントでサインインしてください。",
    switch_account: "別のアカウントにサインイン",
    invalid_invitation_status: "招待状が無効です。管理者に問い合わせて、もう一度お試しください。",
    invitation_not_found: "招待が見つかりませんでした。管理者に連絡してください。"
};
var $53019a5b1ae01e50$export$2e2bcd8739ae039 = Object.freeze($53019a5b1ae01e50$var$invitation);


const $a7b721020a61b0a9$var$jwt_claims = {
    title: "カスタムJWT",
    description: "アクセストークンに含めるカスタムJWTクレームを設定します。これらのクレームを使用して、追加の情報をアプリケーションに渡すことができます。",
    user_jwt: {
        card_title: "ユーザー向け",
        card_field: "ユーザーアクセストークン",
        card_description: "アクセストークン発行時にユーザー固有のデータを追加します。",
        for: "ユーザー向け"
    },
    machine_to_machine_jwt: {
        card_title: "M2M向け",
        card_field: "マシン対マシントークン",
        card_description: "マシン対マシントークン発行時に追加データを含めます。",
        for: "M2M向け"
    },
    code_editor_title: "カスタマイズ{{token}}クレーム",
    custom_jwt_create_button: "カスタムクレームを追加",
    custom_jwt_item: "カスタムクレーム{{for}}",
    delete_modal_title: "カスタムクレームを削除",
    delete_modal_content: "カスタムクレームを削除してもよろしいですか？",
    clear: "クリア",
    cleared: "クリアされた",
    restore: "デフォルトに戻す",
    restored: "復元されました",
    data_source_tab: "データソース",
    test_tab: "コンテキストをテスト",
    jwt_claims_description: "デフォルトクレームはJWTに自動的に含まれ、オーバーライドできません。",
    user_data: {
        title: "ユーザーデータ",
        subtitle: "`data.user`入力パラメータを使用して重要なユーザー情報を提供します。"
    },
    token_data: {
        title: "トークンデータ",
        subtitle: "現在のアクセストークンペイロードに対して`token`入力パラメータを使用します。"
    },
    fetch_external_data: {
        title: "外部データを取得",
        subtitle: "外部APIからデータを直接クレームに組み込みます。",
        description: "`fetch`関数を使用して外部APIを呼び出し、データをカスタムクレームに含めます。例："
    },
    environment_variables: {
        title: "環境変数を設定",
        subtitle: "機密情報を保存するために環境変数を使用します。",
        input_field_title: "環境変数を追加",
        sample_code: "カスタムJWTクレームハンドラで環境変数にアクセスする方法。例："
    },
    jwt_claims_hint: "カスタムクレームの制限は50KB未満です。デフォルトのJWTクレームは自動的にトークンに含まれ、オーバーライドできません。",
    tester: {
        subtitle: "テストのためにモックトークンとユーザーデータを調整します。",
        run_button: "テストを実行",
        result_title: "テスト結果"
    },
    form_error: {
        invalid_json: "無効なJSON形式"
    }
};
var $a7b721020a61b0a9$export$2e2bcd8739ae039 = Object.freeze($a7b721020a61b0a9$var$jwt_claims);


const $4879f3bbb04be483$var$log_details = {
    page_title: "監査ログの詳細",
    back_to_logs: "監査ログに戻る",
    back_to: "{{name}}に戻る",
    success: "成功",
    failed: "失敗",
    event_key: "イベントキー",
    application: "アプリケーション",
    ip_address: "IPアドレス",
    user: "ユーザー",
    log_id: "ログID",
    time: "時間",
    user_agent: "ユーザーエージェント",
    tab_details: "詳細",
    raw_data: "生データ"
};
var $4879f3bbb04be483$export$2e2bcd8739ae039 = Object.freeze($4879f3bbb04be483$var$log_details);


const $6df5c08d4ea3569f$var$logs = {
    page_title: "監査ログ",
    title: "監査ログ",
    subtitle: "ユーザーによって行われた認証イベントのログデータを表示します",
    event: "イベント",
    user: "ユーザー",
    application: "アプリケーション",
    time: "時間",
    filter_by: "フィルター"
};
var $6df5c08d4ea3569f$export$2e2bcd8739ae039 = Object.freeze($6df5c08d4ea3569f$var$logs);


const $494b5c9b0867f74c$var$menu = {
    profile: "プロフィール",
    language: "言語",
    appearance: {
        label: "外観",
        light: "ライトモード",
        dark: "ダークモード",
        system: "システムと同期"
    },
    sign_out: "ログアウト"
};
var $494b5c9b0867f74c$export$2e2bcd8739ae039 = Object.freeze($494b5c9b0867f74c$var$menu);


const $9eeb616f4b43bfc0$var$mfa = {
    title: "マルチファクタ認証",
    description: "サインインエクスペリエンスのセキュリティを向上させるためにマルチファクタ認証を追加します。",
    factors: "要因",
    multi_factors: "マルチファクタ",
    multi_factors_description: "ユーザーは2段階認証のために有効になっている要因のうちの1つを検証する必要があります。",
    totp: "認証アプリ OTP",
    otp_description: "Google Authenticatorなどをリンクしてワンタイムパスワードを検証します。",
    webauthn: "WebAuthn（パスキー）",
    webauthn_description: "ブラウザでサポートされている方法を使用して検証します：生体認証、電話のスキャン、またはセキュリティキーなど。",
    webauthn_native_tip: "WebAuthnはネイティブアプリケーションではサポートされていません。",
    webauthn_domain_tip: "WebAuthnは公開鍵を特定のドメインにバインドします。サービスのドメインを変更すると、既存のパスキーを使用したユーザーの認証がブロックされます。",
    backup_code: "バックアップコード",
    backup_code_description: "ユーザーが任意のMFAメソッドを設定した後に10個のワンタイムバックアップコードを生成します。",
    backup_code_setup_hint: "上記のMFA要因を検証できない場合は、バックアップオプションを使用します。",
    backup_code_error_hint: "バックアップコードを使用するには、成功したユーザー認証のために少なくとも1つ以上のMFAメソッドが必要です。",
    policy: "ポリシー",
    policy_description: "サインインおよびサインアップフローのためのMFAポリシーを設定します。",
    two_step_sign_in_policy: "サインイン時の2段階認証ポリシー",
    user_controlled: "ユーザーは自分でMFAを有効または無効にできます",
    user_controlled_tip: "ユーザーは最初のサインインまたはサインアップ時にMFAのセットアップをスキップしたり、アカウント設定で有効/無効にしたりできます。",
    mandatory: "ユーザーは常にサインイン時にMFAの使用が必要です",
    mandatory_tip: "ユーザーは最初のサインインまたはサインアップ時にMFAを設定し、将来のすべてのサインインでそれを使用する必要があります。"
};
var $9eeb616f4b43bfc0$export$2e2bcd8739ae039 = Object.freeze($9eeb616f4b43bfc0$var$mfa);


const $7cdb58d35c0520d6$var$organization_details = {
    page_title: "組織の詳細",
    delete_confirmation: "削除すると、すべてのメンバーが組織内のメンバーシップとロールを失います。この操作は元に戻せません。",
    organization_id: "組織ID",
    settings_description: "組織は、アプリケーションにアクセスできるチーム、ビジネス顧客、およびパートナー企業を表します。",
    name_placeholder: "組織の名前。一意である必要はありません。",
    description_placeholder: "組織の説明。",
    member: "メンバー",
    member_other: "メンバー",
    add_members_to_organization: "組織 {{name}} にメンバーを追加",
    add_members_to_organization_description: "名前、メール、電話、またはユーザーIDで検索して適切なユーザーを見つけます。検索結果には既存のメンバーは表示されません。",
    add_with_organization_role: "組織の役割付きで追加",
    user: "ユーザー",
    authorize_to_roles: "{{name}} に以下の役割へのアクセスを許可",
    edit_organization_roles: "組織の役割を編集",
    edit_organization_roles_of_user: "{{name}} の組織の役割を編集",
    remove_user_from_organization: "組織からユーザーを削除",
    remove_user_from_organization_description: "削除すると、ユーザーは組織内のメンバーシップとロールを失います。この操作は元に戻せません。",
    search_user_placeholder: "名前、メール、電話番号、またはユーザーIDで検索",
    at_least_one_user: "少なくとも1人のユーザーが必要です。",
    custom_data: "カスタムデータ",
    custom_data_tip: "カスタムデータは、組織に関連付けられた追加データを格納するために使用できるJSONオブジェクトです。",
    invalid_json_object: "無効なJSONオブジェクト。"
};
var $7cdb58d35c0520d6$export$2e2bcd8739ae039 = Object.freeze($7cdb58d35c0520d6$var$organization_details);


const $be0c6731ad37b364$var$organization_role_details = {
    page_title: "組織の役割の詳細",
    back_to_org_roles: "組織の役割に戻る",
    org_role: "組織の役割",
    delete_confirm: "これにより、関連するユーザーからこのロールに関連付けられた権限が削除され、組織の役割、組織のメンバー、および組織の権限間の関係が削除されます。",
    deleted: "組織の役割{{name}}が正常に削除されました。",
    permissions: {
        tab: "許可",
        name_column: "許可",
        description_column: "説明",
        type_column: "許可の種類",
        type: {
            api: "API許可",
            org: "組織許可"
        },
        assign_permissions: "許可を割り当てる",
        remove_permission: "権限を削除",
        remove_confirmation: "この権限を削除すると、この組織の役割を持つユーザーはこの権限によって付与されたアクセスを失います。",
        removed: "この組織の役割から権限 {{name}} が正常に削除されました",
        assign_description: "この組織内のロールに権限を割り当てます。これには組織の権限とAPIの権限の両方が含まれる場合があります。",
        organization_permissions: "組織の権限",
        api_permissions: "APIの権限",
        assign_organization_permissions: "組織の権限を割り当てる",
        assign_api_permissions: "APIの権限を割り当てる"
    },
    general: {
        tab: "一般",
        settings: "設定",
        description: "組織ロールは、ユーザーに割り当てることができる権限のグループです。権限は、事前に定義された組織の権限とAPIの権限から来ることがあります。",
        name_field: "名前",
        description_field: "説明",
        description_field_placeholder: "閲覧専用権限を持つユーザー"
    }
};
var $be0c6731ad37b364$export$2e2bcd8739ae039 = Object.freeze($be0c6731ad37b364$var$organization_role_details);


const $50480ecc04b87708$var$organization_template = {
    title: "組織テンプレート",
    subtitle: "マルチテナントSaaSアプリケーションでは、組織テンプレートが複数の組織の共有アクセス制御ポリシー（権限と役割）を定義します。",
    roles: {
        tab_name: "組織の役割",
        search_placeholder: "役割名で検索",
        create_title: "組織の役割を作成",
        role_column: "組織の役割",
        permissions_column: "権限",
        placeholder_title: "組織の役割",
        placeholder_description: "組織の役割は、ユーザーに割り当てることができる権限のグループです。権限は、事前に定義された組織の権限から来なければなりません。",
        create_modal: {
            title: "組織の役割を作成する",
            create: "役割を作成する",
            name_field: "役割名",
            description_field: "説明",
            created: "組織の役割{{name}}が正常に作成されました。"
        }
    },
    permissions: {
        tab_name: "組織の権限",
        search_placeholder: "権限名で検索",
        create_org_permission: "組織の権限を作成",
        permission_column: "組織の許可",
        description_column: "説明",
        placeholder_title: "組織の権限",
        placeholder_description: "組織の権限は、組織の文脈でリソースにアクセスするための認可を指します。",
        delete_confirm: "この権限が削除されると、この権限を含むすべての組織の役割がこの権限を失い、この権限を持っていたユーザーはそれによって与えられたアクセスを失います。",
        create_title: "組織の権限を作成",
        edit_title: "組織の権限を編集",
        permission_field_name: "権限名",
        description_field_name: "説明",
        description_field_placeholder: "予約履歴を読む",
        create_permission: "権限を作成",
        created: "組織権限 {{name}} が正常に作成されました。"
    }
};
var $50480ecc04b87708$export$2e2bcd8739ae039 = Object.freeze($50480ecc04b87708$var$organization_template);


const $0402dd03c3eb7184$var$organizations = {
    organization: "組織",
    page_title: "組織",
    title: "組織",
    subtitle: "組織は通常、SaaSや類似したマルチテナントアプリで使用され、お客様（チーム、組織、または企業全体）を代表します。 組織はB2B認証および承認の基本的な要素として機能します。",
    organization_template: "組織テンプレート",
    organization_id: "組織ID",
    members: "メンバー",
    create_organization: "組織を作成",
    setup_organization: "組織を設定",
    organization_list_placeholder_title: "組織",
    organization_list_placeholder_text: "組織はSaaSや類似したマルチテナントアプリでよく使用され、クライアントが組織を作成・管理し、メンバーを招待し、役割を割り当てるようなアプリを開発できるようにします。",
    organization_name_placeholder: "私の組織",
    organization_description_placeholder: "組織の簡単な説明",
    organization_permission: "組織権限",
    organization_permission_other: "組織権限",
    create_permission_placeholder: "任命履歴を読む",
    organization_role: "組織役割",
    organization_role_other: "組織役割",
    organization_role_description: "組織役割は、ユーザーに割り当てることができる権限のグループ化です。権限は事前に定義された組織権限から取得する必要があります。",
    role: "役割",
    search_placeholder: "組織名またはIDで検索",
    search_role_placeholder: "検索して役割を選択",
    empty_placeholder: "\uD83E\uDD14 あなたはまだ{{entity}}を設定していません。",
    organization_and_member: "組織とメンバー",
    organization_and_member_description: "組織はユーザーのグループであり、チーム、ビジネス顧客、およびパートナー企業を代表し、各ユーザーが「メンバー」です。 これらはマルチテナント要件を処理するための基本的なエンティティです。",
    guide: {
        title: "ガイドで始める",
        subtitle: "ガイドを使って組織設定をスタートしましょう",
        introduction: {
            title: "Logtoで組織がどのように機能するかを理解しましょう",
            section_1: {
                title: "組織はユーザー（アイデンティティ）のグループです"
            },
            section_2: {
                title: "組織テンプレートはマルチテナントアプリのアクセス制御向けに設計されています",
                description: "マルチテナントSaaSアプリケーションでは、複数の組織がしばしば同じアクセス制御テンプレートを共有します。これには権限や役割が含まれます。Logtoではこれを「組織テンプレート」と呼びます。",
                permission_description: "組織権限とは、組織のコンテキストでリソースにアクセスするための承認です。",
                role_description_deprecated: "組織役割は、ユーザーに割り当てることができる権限のグループ化です。権限は事前に定義された組織権限から取得する必要があります。",
                role_description: "組織の役割は、メンバーに割り当てることができる組織の権限またはAPIの権限のグループです。"
            },
            section_3: {
                title: "組織の役割にAPI権限を割り当てることはできますか？",
                description: "はい、組織の役割にAPI権限を割り当てることができます。 Logtoは組織の役割を効果的に管理する柔軟性を提供し、それらの役割に組織権限とAPI権限の両方を含めることができます。"
            },
            section_4: {
                title: "イラストを操作して、接続方法を確認してください",
                description: "例として、John、Sarahは異なる組織に所属し、それぞれ異なる組織のコンテキストで異なる役割を担っています。 異なるモジュールにカーソルを合わせて、それぞれの動作を確認しましょう。"
            }
        },
        organization_permissions: "組織権限",
        organization_roles: "組織役割",
        admin: "管理者",
        member: "メンバー",
        guest: "ゲスト",
        role_description: "役割「{{role}}」は、異なる組織で同じ組織テンプレートを共有しています。",
        john: "John",
        john_tip: "Johnは、異なる組織に所属し、単一の識別子として「john@email.com」のメールアドレスを持っています。 彼は組織Aの管理者であり、組織Bのゲストでもあります。",
        sarah: "Sarah",
        sarah_tip: "Sarahは、単一の識別子として「sarah@email.com」のメールアドレスを持つ1つの組織に属しています。 彼女は組織Bの管理者です。"
    }
};
var $0402dd03c3eb7184$export$2e2bcd8739ae039 = Object.freeze($0402dd03c3eb7184$var$organizations);


const $fcc868cd9ce1ecd2$var$permissions = {
    search_placeholder: "APIまたは権限名で検索",
    search_placeholder_without_api: "権限名で検索",
    name_column: "権限",
    description_column: "説明",
    api_column: "API",
    placeholder_title: "権限",
    placeholder_description: "権限はリソース（APIリソースと呼んでいます）にアクセスするための承認を指します。",
    edit: "編集権限",
    delete: "削除権限",
    remove: "除去権限",
    edit_title: "APIの権限を編集"
};
var $fcc868cd9ce1ecd2$export$2e2bcd8739ae039 = Object.freeze($fcc868cd9ce1ecd2$var$permissions);


const $5e730d60cc40c0f0$var$profile = {
    page_title: "アカウント設定",
    title: "アカウント設定",
    description: "アカウントのセキュリティを確保するため、ここでアカウント設定と個人情報の管理を変更できます。",
    settings: {
        title: "プロファイル設定",
        profile_information: "プロファイル情報",
        avatar: "アバター",
        name: "名前",
        username: "ユーザー名"
    },
    link_account: {
        title: "アカウントをリンク",
        email_sign_in: "Email sign-In",
        email: "Eメール",
        social_sign_in: "ソーシャルサインイン",
        link_email: "Eメールのリンク",
        link_email_subtitle: "ログインにEメールをリンクするか、アカウントの回復をお手伝いします。",
        email_required: "Eメールが必要です",
        invalid_email: "無効なEメールアドレス",
        identical_email_address: "入力したEメールアドレスは現在のものと同じです",
        anonymous: "匿名"
    },
    password: {
        title: "パスワードとセキュリティ",
        password: "パスワード",
        password_setting: "パスワード設定",
        new_password: "新しいパスワード",
        confirm_password: "パスワードの確認",
        enter_password: "現在のパスワードを入力してください",
        enter_password_subtitle: "アカウントのセキュリティを保護するためにあなたが本人であることを確認してください。変更する前に現在のパスワードを入力してください。",
        set_password: "パスワードを設定する",
        verify_via_password: "パスワードを使って確認する",
        show_password: "パスワードを表示する",
        required: "パスワードが必要です",
        do_not_match: "パスワードが一致しません。もう一度お試しください。"
    },
    code: {
        enter_verification_code: "検証コードを入力してください",
        enter_verification_code_subtitle: "検証コードは <strong>{{target}}</strong> に送信されました。",
        verify_via_code: "検証コードを使用して確認する",
        resend: "検証コードを再送信する",
        resend_countdown: "{{countdown}} 秒後に再送信する"
    },
    delete_account: {
        title: "アカウントを削除",
        label: "アカウントを削除",
        description: "アカウントの削除は、すべての個人情報、ユーザーデータ、および設定が削除されます。このアクションは元に戻せません。",
        button: "アカウントを削除",
        dialog_paragraph_1: "アカウントを削除したいというお知らせを受け取りましたこと、残念に思います。 アカウントを削除すると、ユーザー情報、ログ、設定を含むすべてのデータが永久に削除されます。そのため、手続きを進める前に、重要なデータをバックアップすることを必ずお願いします。",
        dialog_paragraph_2: "アカウント削除プロセスを進めるには、「アカウント削除リクエスト」という件名で<a>{{mail}}</a>にメールを送信して、当社のサポートチームにお問い合わせください。私たちはあなたをサポートし、すべてのデータが正しくシステムから削除されるようにします。",
        dialog_paragraph_3: "Logto Cloudをご利用いただきありがとうございます。ご質問やご不明な点がある場合は、お気軽にお問い合わせください。"
    },
    set: "設定する",
    change: "変更する",
    link: "リンクする",
    unlink: "リンクを解除する",
    not_set: "設定されていません",
    change_avatar: "アバターを変更する",
    change_name: "名前を変更する",
    change_username: "ユーザー名を変更する",
    set_name: "名前を設定する",
    email_changed: "Eメールが変更されました。",
    password_changed: "パスワードが変更されました。",
    updated: "{{target}} が更新されました。",
    linked: "{{target}} がリンクされました。",
    unlinked: "{{target}} のリンクが解除されました。",
    email_exists_reminder: "このEメール{{email}}は、既存のアカウントに関連付けられています。ここで別のEメールをリンクしてください。",
    unlink_confirm_text: "はい、リンクを解除します",
    unlink_reminder: "リンクを解除すると、ユーザーは<span></span>アカウントでサインインできなくなります。本当に進めますか？"
};
var $5e730d60cc40c0f0$export$2e2bcd8739ae039 = Object.freeze($5e730d60cc40c0f0$var$profile);


const $4cd53791a5b34fc4$var$protected_app = {
    name: "保護されたアプリ",
    title: "保護されたアプリを作成：シンプルさとエピックなスピードで認証を追加",
    description: "保護されたアプリはユーザーセッションを安全に維持し、アプリのリクエストをプロキシします。Cloudflare Workersによって強力なパフォーマンスと世界中で0msの起動時間をお楽しみください。<a>さらに詳しく</a>",
    fast_create: "高速作成",
    modal_title: "保護されたアプリを作成",
    modal_subtitle: "クリックするだけで安全で高速な保護を有効にします。既存のWebアプリに簡単に認証を追加します。",
    form: {
        url_field_label: "元のURL",
        url_field_placeholder: "https://domain.com/",
        url_field_description: "認証保護が必要なアプリのアドレスを提供してください。",
        url_field_modification_notice: "元のURLへの変更は、グローバルネットワークロケーション全体で有効になるまで1〜2分かかる場合があります。",
        url_field_tooltip: "アプリケーションのアドレスを提供します。'/pathname'を含まないでください。作成後、ルート認証ルールをカスタマイズできます。\n\n注意：元のURLそのものには認証が必要ではありません。指定されたアプリドメイン経由でのアクセスにのみ保護が適用されます。",
        domain_field_label: "アプリドメイン",
        domain_field_placeholder: "your-domain",
        domain_field_description: "このURLは元のURLの認証保護プロキシとして機能します。作成後、カスタムドメインを適用できます。",
        domain_field_description_short: "このURLは元のURLの認証保護プロキシとして機能します。",
        domain_field_tooltip: "Logtoによって保護されたアプリは、デフォルトで 'your-domain.{{domain}}' でホストされます。作成後にカスタムドメインを適用できます。",
        create_application: "アプリケーションを作成",
        create_protected_app: "高速作成",
        errors: {
            domain_required: "アプリドメインが必要です。",
            domain_in_use: "このサブドメイン名は既に使用されています。",
            invalid_domain_format: "無効なサブドメイン形式：小文字のアルファベット、数字、ハイフン「-」のみを使用してください。",
            url_required: "元のURLが必要です。",
            invalid_url: "無効な元のURL形式：http://またはhttps://を使用してください。注：'/pathname' は現在サポートされていません。",
            localhost: "まずローカルサーバーをインターネットに公開してください。<a>ローカル開発についてさらに詳しく</a>。"
        }
    },
    success_message: "\uD83C\uDF89 アプリ認証が正常に有効化されました！Webサイトの新しいエクスペリエンスをご覧ください。"
};
var $4cd53791a5b34fc4$export$2e2bcd8739ae039 = Object.freeze($4cd53791a5b34fc4$var$protected_app);


const $2882e941d5e7e087$var$role_details = {
    back_to_roles: "ロールに戻る",
    identifier: "識別子",
    delete_description: "これを行うと、このロールに関連付けられた許可が影響を受けるユーザーから削除され、ロール、ユーザー、および許可のマッピングが削除されます。",
    role_deleted: "{{name}} は正常に削除されました。",
    general_tab: "一般",
    users_tab: "ユーザー",
    m2m_apps_tab: "機械対機械のアプリ",
    permissions_tab: "許可",
    settings: "設定",
    settings_description: "ロールは、ユーザーに割り当てることができる許可のグループ化です。また、異なるAPIに対して定義された許可を集約する方法を提供し、ユーザーに個別に割り当てるよりも許可を追加、削除、または調整するのに効率的です。",
    field_name: "名前",
    field_description: "説明",
    field_is_default: "デフォルトロール",
    field_is_default_description: "新規ユーザーに対してこのロールをデフォルトロールとして設定します。複数のデフォルトロールを設定できます。これは、管理APIを介して作成されたユーザーのデフォルトロールにも影響します。",
    type_m2m_role_tag: "機械対機械のアプリのロール",
    type_user_role_tag: "ユーザーロール",
    m2m_role_notification: "この機械間ロールを機械間アプリに割り当てて、関連するAPIリソースへのアクセスを許可します。<a>まだ作成していない場合は、まず機械間アプリを作成してください。</a>",
    permission: {
        assign_button: "許可を割り当てる",
        assign_title: "許可の割り当て",
        assign_subtitle: "このロールに許可を割り当てます。ロールに追加された許可がこのロールを持つユーザーにも適用されます。",
        assign_form_field: "許可を割り当てる",
        added_text_one: "{{count, number}} 個の許可が追加されました",
        added_text_other: "{{count, number}} 個の許可が追加されました",
        api_permission_count_one: "{{count, number}} 個の許可",
        api_permission_count_other: "{{count, number}} 個の許可",
        confirm_assign: "許可を割り当てる",
        permission_assigned: "選択した許可はこのロールに正常に割り当てられました。",
        deletion_description: "この許可が削除されると、このロールに属するユーザーが失ったアクセス権に影響を受けます。",
        permission_deleted: '許可 "{{name}}" がこのロールから正常に削除されました。',
        empty: "利用可能な許可はありません。"
    },
    users: {
        assign_button: "ユーザーを割り当てる",
        name_column: "ユーザー",
        app_column: "アプリ",
        latest_sign_in_column: "最新サインイン",
        delete_description: "ユーザープールには残りますが、このロールからのアクセス権は削除されます。",
        deleted: "{{name}} はこのロールから正常に削除されました。",
        assign_title: "ユーザーを割り当てる",
        assign_subtitle: "ユーザーをこのロールに割り当てます。名前、メール、電話、またはユーザーIDで検索して適切なユーザーを見つけます。",
        assign_field: "ユーザーを割り当てる",
        confirm_assign: "ユーザーを割り当てる",
        assigned_toast_text: "選択したユーザーがこのロールに正常に割り当てられました。",
        empty: "利用可能なユーザーはありません。"
    },
    applications: {
        assign_button: "アプリケーションを割り当てる",
        name_column: "アプリケーション",
        app_column: "アプリ",
        description_column: "説明",
        delete_description: "アプリケーションプールには残りますが、このロールからのアクセス権は削除されます。",
        deleted: "{{name}} はこのロールから正常に削除されました。",
        assign_title: "アプリケーションを割り当てる",
        assign_subtitle: "このロールにアプリケーションを割り当てます。名前、説明、またはアプリIDで検索して適切なアプリケーションを見つけます。",
        assign_field: "アプリケーションを割り当てる",
        confirm_assign: "アプリケーションを割り当てる",
        assigned_toast_text: "選択したアプリケーションがこのロールに正常に割り当てられました。",
        empty: "利用可能なアプリケーションはありません。"
    }
};
var $2882e941d5e7e087$export$2e2bcd8739ae039 = Object.freeze($2882e941d5e7e087$var$role_details);


const $a927526ee083943a$var$roles = {
    page_title: "ロール",
    title: "ロール",
    subtitle: "ロールには、ユーザーが実行できるアクションを決定する権限が含まれます。RBACは、特定のアクションのためにリソースにアクセスするためにユーザーに権限を付与するために、ロールを使用します。",
    create: "ロールを作成する",
    role_name: "役割名",
    role_type: "役割タイプ",
    show_role_type_button_text: "さらにオプションを表示",
    hide_role_type_button_text: "さらにオプションを非表示",
    type_user: "ユーザーの役割",
    type_machine_to_machine: "マシン対マシンアプリの役割",
    role_description: "説明",
    role_name_placeholder: "ロールの名前を入力してください",
    role_description_placeholder: "ロールの説明を入力してください",
    col_roles: "ロール",
    col_type: "タイプ",
    col_description: "説明",
    col_assigned_entities: "割り当てられました",
    user_counts: "{{count}} ユーザー",
    application_counts: "{{count}} アプリ",
    user_count: "{{count}} ユーザー",
    application_count: "{{count}} アプリ",
    assign_permissions: "権限の割り当て",
    create_role_title: "ロールを作成する",
    create_role_description: "アプリケーションのロールを作成して管理します。ロールには権限のコレクションが含まれ、ユーザーに割り当てることができます。",
    create_role_button: "ロールを作成する",
    role_created: "{{name}}ロールが正常に作成されました。",
    search: "ロール名、説明、またはIDで検索",
    placeholder_title: "ロール",
    placeholder_description: "ロールは、ユーザーに割り当てられる権限のグループです。ロールを作成する前に、まず権限を追加してください。",
    assign_user_roles: "ユーザー役割を割り当てる",
    assign_m2m_roles: "マシン間役割を割り当てる",
    management_api_access_notification: "Logto管理APIへのアクセスには、管理API権限を持つ役割を選択してください<flag/>。",
    with_management_api_access_tip: "このマシン間役割には、Logto管理APIのアクセス権が含まれています"
};
var $a927526ee083943a$export$2e2bcd8739ae039 = Object.freeze($a927526ee083943a$var$roles);


const $366c1c8c696c4d5a$var$session_expired = {
    title: "セッションの有効期限が切れました",
    subtitle: "セッションの有効期限が切れ、切断されました。以下のボタンをクリックして再度管理コンソールにサインインしてください。",
    button: "再度サインイン"
};
var $366c1c8c696c4d5a$export$2e2bcd8739ae039 = Object.freeze($366c1c8c696c4d5a$var$session_expired);


const $7d5f1015a33415f1$var$content = {
    terms_of_use: {
        title: "TERMS",
        terms_of_use: "Terms of use URL",
        terms_of_use_placeholder: "https://your.terms.of.use/",
        privacy_policy: "Privacy policy URL",
        privacy_policy_placeholder: "https://your.privacy.policy/"
    },
    languages: {
        title: "LANGUAGES",
        enable_auto_detect: "Enable auto-detect",
        description: "Your software detects the user's locale setting and switches to the local language. You can add new languages by translating UI from English to another language.",
        manage_language: "Manage language",
        default_language: "Default language",
        default_language_description_auto: "The default language will be used when the detected user language isn’t covered in the current language library.",
        default_language_description_fixed: "When auto-detect is off, the default language is the only language your software will show. Turn on auto-detect for language extension."
    },
    manage_language: {
        title: "Manage language",
        subtitle: "Localize the product experience by adding languages and translations. Your contribution can be set as the default language.",
        add_language: "Add Language",
        logto_provided: "Logto provided",
        key: "Key",
        logto_source_values: "Logto source values",
        custom_values: "Custom values",
        clear_all_tip: "Clear all values",
        unsaved_description: "Changes won’t be saved if you leave this page without saving.",
        deletion_tip: "Delete the language",
        deletion_title: "Do you want to delete the added language?",
        deletion_description: "After deletion, your users won’t be able to browse in that language again.",
        default_language_deletion_title: "Default language can’t be deleted.",
        default_language_deletion_description: "{{language}} is set as your default language and can’t be deleted. "
    }
};
var $7d5f1015a33415f1$export$2e2bcd8739ae039 = Object.freeze($7d5f1015a33415f1$var$content);


const $426c500ea4ae3dc0$var$password_policy = {
    password_requirements: "パスワードの要件",
    minimum_length: "最小の長さ",
    minimum_length_description: "NISTは、Web製品に対して少なくとも8文字を使用することを提案しています。",
    minimum_length_error: "最小の長さは {{min}} から {{max}}（両方含む）の間でなければなりません。",
    minimum_required_char_types: "必要な文字の種類の最小数",
    minimum_required_char_types_description: "文字の種類：大文字（A-Z）、小文字（a-z）、数字（0-9）、特殊記号（{{symbols}}）。",
    password_rejection: "パスワードの拒否",
    compromised_passwords: "危険なパスワードの拒否",
    breached_passwords: "漏洩したパスワードの拒否",
    breached_passwords_description: "以前に漏洩したデータベースで見つかったパスワードを拒否します。",
    restricted_phrases: "低セキュリティフレーズの制限",
    restricted_phrases_tooltip: "パスワードにこれらのフレーズを使用しないでください。ただし、追加の文字を3文字以上組み合わせる場合は例外です。",
    repetitive_or_sequential_characters: "繰り返しまたは連続する文字",
    repetitive_or_sequential_characters_description: "「AAAA」、「1234」、「abcd」などです。",
    user_information: "ユーザー情報",
    user_information_description: "例: メールアドレス、電話番号、ユーザー名など。",
    custom_words: "カスタムワード",
    custom_words_description: "特定の文脈に関連するワードを、大文字小文字を区別せずに、1つの行に1つずつ追加します。",
    custom_words_placeholder: "サービス名、会社名など"
};
var $426c500ea4ae3dc0$export$2e2bcd8739ae039 = Object.freeze($426c500ea4ae3dc0$var$password_policy);


const $b2fe8c27db874661$var$sign_up_and_sign_in = {
    identifiers_email: "メールアドレス",
    identifiers_phone: "電話番号",
    identifiers_username: "ユーザー名",
    identifiers_email_or_sms: "メールアドレスまたは電話番号",
    identifiers_none: "該当なし",
    and: "および",
    or: "または",
    sign_up: {
        title: "サインアップ",
        sign_up_identifier: "サインアップ識別子",
        identifier_description: "サインアップ識別子はアカウント作成に必要で、サインイン画面に含める必要があります。",
        sign_up_authentication: "サインアップの認証設定",
        authentication_description: "選択したすべてのアクションは、ユーザーがフローを完了するために必須です。",
        set_a_password_option: "パスワードの設定",
        verify_at_sign_up_option: "サインアップ時に確認する",
        social_only_creation_description: "（これはソーシャルアカウント作成に適用されます）"
    },
    sign_in: {
        title: "サインイン",
        sign_in_identifier_and_auth: "サインインの識別子と認証設定",
        description: "ユーザーは利用可能なすべてのオプションを使用してサインインできます。下のオプションをドラッグ＆ドロップしてレイアウトを調整してください。",
        add_sign_in_method: "サインイン方法を追加",
        password_auth: "パスワード",
        verification_code_auth: "確認コード",
        auth_swap_tip: "以下のオプションを交換して、フローで最初に表示されるオプションを決定します。",
        require_auth_factor: "少なくとも1つの認証要素を選択する必要があります。"
    },
    social_sign_in: {
        title: "ソーシャルサインイン",
        social_sign_in: "ソーシャルサインイン",
        description: "設定した必須識別子に応じて、ユーザーはソーシャルコネクタを介してサインアップする際に識別子を提供するよう求められる場合があります。",
        add_social_connector: "ソーシャルコネクタを追加",
        set_up_hint: {
            not_in_list: "一覧にない場合は?",
            set_up_more: "設定",
            go_to: "他のソーシャルコネクタに移動します。"
        }
    },
    tip: {
        set_a_password: "ユーザー名にユニークなパスワードを設定することが重要です。",
        verify_at_sign_up: "現在、検証されたメールアドレスのみをサポートしています。検証がない場合、ユーザーベースには低品質のメールアドレスが多数含まれる場合があります。",
        password_auth: "これは、サインアッププロセス中にパスワードを設定するオプションを有効にした場合に必要です。",
        verification_code_auth: "これは、サインアップ時に確認コードの提供オプションのみを有効にした場合に必要です。サインアッププロセスでパスワード設定を許可する場合は、ボックスのチェックを外してもかまいません。",
        delete_sign_in_method: "これは{{identifier}}を必須の識別子として選択した場合に必要です。"
    },
    advanced_options: {
        title: "高度なオプション",
        enable_single_sign_on: "企業向けシングルサインオン（SSO）を有効にする",
        enable_single_sign_on_description: "ユーザーが企業のアイデンティティを使用してアプリケーションにサインインできるようにします。",
        single_sign_on_hint: {
            prefix: "詳細は、",
            link: '"企業向けSSO"',
            suffix: "セクションをご覧ください。"
        },
        enable_user_registration: "ユーザー登録を有効にする",
        enable_user_registration_description: "ユーザー登録を有効または無効にできます。無効にすると、ユーザーは管理コンソールで追加できますが、サインイン画面でアカウントを作成することはできません。"
    }
};
var $b2fe8c27db874661$export$2e2bcd8739ae039 = Object.freeze($b2fe8c27db874661$var$sign_up_and_sign_in);


const $0ba0096c7a87cc9e$var$sign_in_exp = {
    page_title: "サインインエクスペリエンス",
    title: "サインインエクスペリエンス",
    description: "ブランドに合わせてサインインUIをカスタマイズし、リアルタイムで表示できます。",
    tabs: {
        branding: "ブランディング",
        sign_up_and_sign_in: "サインアップとサインイン",
        content: "内容",
        password_policy: "パスワードポリシー"
    },
    welcome: {
        title: "サインインエクスペリエンスをカスタマイズ",
        description: "最初のサインイン設定をスムーズに始めましょう。このガイドでは、必要なすべての設定を説明します。",
        get_started: "開始",
        apply_remind: "サインインエクスペリエンスは、このアカウントのすべてのアプリケーションに適用されます。"
    },
    color: {
        title: "カラー",
        primary_color: "ブランドカラー",
        dark_primary_color: "ブランドカラー（ダーク）",
        dark_mode: "ダークモードを有効にする",
        dark_mode_description: "あなたのアプリは、ブランドカラーとLogtoアルゴリズムに基づいて自動生成されたダークモードのテーマを持っています。自由にカスタマイズしてください。",
        dark_mode_reset_tip: "ブランドカラーに基づいてダークモードの色を再計算します。",
        reset: "リセット"
    },
    branding: {
        title: "ブランディングエリア",
        ui_style: "スタイル",
        favicon: "ファビコン",
        logo_image_url: "アプリのロゴ画像URL",
        logo_image_url_placeholder: "https://your.cdn.domain/logo.png",
        dark_logo_image_url: "アプリのロゴ画像URL（ダーク）",
        dark_logo_image_url_placeholder: "https://your.cdn.domain/logo-dark.png",
        logo_image: "アプリのロゴ",
        dark_logo_image: "アプリのロゴ（ダーク）",
        logo_image_error: "アプリのロゴ：{{error}}",
        favicon_error: "ファビコン：{{error}}"
    },
    custom_css: {
        title: "カスタムCSS",
        css_code_editor_title: "カスタムCSSでUIをパーソナライズ",
        css_code_editor_description1: "カスタムCSSの例を見てください。",
        css_code_editor_description2: "<a>{{link}}</a>",
        css_code_editor_description_link_content: "さらに詳しく",
        css_code_editor_content_placeholder: "カスタムCSSを入力して、すべてのスタイルをあなたの仕様に合わせて調整します。クリエイティビティを発揮して、UIを際立たせましょう。"
    },
    sign_up_and_sign_in: $b2fe8c27db874661$export$2e2bcd8739ae039,
    content: $7d5f1015a33415f1$export$2e2bcd8739ae039,
    password_policy: $426c500ea4ae3dc0$export$2e2bcd8739ae039,
    setup_warning: {
        no_connector_sms: "まだSMSコネクタが設定されていません。構成を完了する前に、この方法でのサインインはできません。<a>{{link}}</a>「コネクタ」に移動してください",
        no_connector_email: "まだメールコネクタが設定されていません。構成を完了する前に、この方法でのサインインはできません。<a>{{link}}</a>「コネクタ」に移動してください",
        no_connector_social: "まだソーシャルコネクタを設定していません。ソーシャルサインインの方法を適用するには、まずコネクタを追加してください。<a>{{link}}</a> の中で「コネクタ」をご覧ください。",
        setup_link: "設定"
    },
    save_alert: {
        description: "新しいサインイン方法やサインアップ手順を導入しています。すべてのユーザーに影響がある可能性があります。変更を実行する場合は、よろしいですか？",
        before: "変更前",
        after: "変更後",
        sign_up: "サインアップ",
        sign_in: "サインイン",
        social: "ソーシャル"
    },
    preview: {
        title: "サインインプレビュー",
        live_preview: "ライブプレビュー",
        live_preview_tip: "変更を保存してプレビュー",
        native: "ネイティブ",
        desktop_web: "デスクトップWeb",
        mobile_web: "モバイルWeb",
        desktop: "デスクトップ",
        mobile: "モバイル"
    }
};
var $0ba0096c7a87cc9e$export$2e2bcd8739ae039 = Object.freeze($0ba0096c7a87cc9e$var$sign_in_exp);


const $b21993ea3701e644$var$signing_keys = {
    title: "署名キー",
    description: "アプリケーションで使用される署名キーを安全に管理します。",
    private_key: "OIDCプライベートキー",
    private_keys_description: "OIDCプライベートキーはJWTトークンの署名に使用されます。",
    cookie_key: "OIDCクッキーキー",
    cookie_keys_description: "OIDCクッキーキーはクッキーの署名に使用されます。",
    private_keys_in_use: "使用中のプライベートキー",
    cookie_keys_in_use: "使用中のCookieキー",
    rotate_private_keys: "プライベートキーを回転させる",
    rotate_cookie_keys: "Cookieキーを回転させる",
    rotate_private_keys_description: "このアクションは新しいプライベート署名キーを作成し、現在のキーを回転させ、前のキーを削除します。現在のキーで署名されたJWTトークンは、削除または別の回転まで有効です。",
    rotate_cookie_keys_description: "このアクションは新しいCookieキーを作成し、現在のキーを回転させ、前のキーを削除します。現在のキーで生成されたCookieは、削除または別の回転まで有効です。",
    select_private_key_algorithm: "新しいプライベートキーの署名キーアルゴリズムを選択",
    rotate_button: "回転",
    table_column: {
        id: "ID",
        status: "ステータス",
        algorithm: "署名キーアルゴリズム"
    },
    status: {
        current: "現在の",
        previous: "以前の"
    },
    reminder: {
        rotate_private_key: "OIDCプライベートキー</strong>を回転させますか？新しい発行されたJWTトークンは新しいキーで署名されます。既存のJWTトークンは、再度回転するまで有効です。",
        rotate_cookie_key: "OIDC Cookieキー</strong>を回転させますか？新しいCookieで署名されたサインインセッションのCookieが新しいCookieキーで生成されます。既存のCookieは、再度回転するまで有効です。",
        delete_private_key: "OIDCプライベートキー</strong>を削除しますか？このプライベート署名キーで署名された既存のJWTトークンはもはや有効ではありません。",
        delete_cookie_key: "OIDC Cookieキー</strong>を削除しますか？このCookieキーで署名された古いサインインセッションのCookieはもはや有効ではありません。これらのユーザーには再認証が必要です。"
    },
    messages: {
        rotate_key_success: "署名キーが正常に回転されました。",
        delete_key_success: "キーが正常に削除されました。"
    }
};
var $b21993ea3701e644$export$2e2bcd8739ae039 = Object.freeze($b21993ea3701e644$var$signing_keys);


const $9d0c6400a8149e0c$var$quota_item = {
    tenant_limit: {
        name: "テナント",
        limited: "{{count, number}} テナント",
        limited_other: "{{count, number}} テナント",
        unlimited: "無制限のテナント",
        not_eligible: "テナントを削除してください"
    },
    mau_limit: {
        name: "月間アクティブユーザー数",
        limited: "{{count, number}} MAU",
        unlimited: "無制限のMAU",
        not_eligible: "全てのユーザーを削除してください"
    },
    token_limit: {
        name: "トークン",
        limited: "{{count, number}} トークン",
        limited_other: "{{count, number}} トークン",
        unlimited: "無制限のトークン",
        not_eligible: "新しいトークンを防ぐためにすべてのユーザーを削除してください"
    },
    applications_limit: {
        name: "アプリケーション",
        limited: "{{count, number}} アプリケーション",
        limited_other: "{{count, number}} アプリケーション",
        unlimited: "無制限のアプリケーション",
        not_eligible: "アプリケーションを削除してください"
    },
    machine_to_machine_limit: {
        name: "マシン間アプリケーション",
        limited: "{{count, number}} マシン間アプリケーション",
        limited_other: "{{count, number}} マシン間アプリケーション",
        unlimited: "無制限のマシン間アプリケーション",
        not_eligible: "マシン間アプリケーションを削除してください"
    },
    third_party_applications_limit: {
        name: "サードパーティーアプリ",
        limited: "{{count, number}} サードパーティーアプリ",
        limited_other: "{{count, number}} サードパーティーアプリ",
        unlimited: "無制限のサードパーティーアプリ",
        not_eligible: "サードパーティーアプリを削除してください"
    },
    resources_limit: {
        name: "APIリソース",
        limited: "{{count, number}} APIリソース",
        limited_other: "{{count, number}} APIリソース",
        unlimited: "無制限のAPIリソース",
        not_eligible: "APIリソースを削除してください"
    },
    scopes_per_resource_limit: {
        name: "リソースごとのスコープ",
        limited: "{{count, number}} リソースごとのスコープ",
        limited_other: "{{count, number}} リソースごとのスコープ",
        unlimited: "無制限のリソースごとのスコープ",
        not_eligible: "リソースごとのスコープを削除してください"
    },
    custom_domain_enabled: {
        name: "カスタムドメイン",
        limited: "カスタムドメイン",
        unlimited: "カスタムドメイン",
        not_eligible: "カスタムドメインを削除してください"
    },
    omni_sign_in_enabled: {
        name: "Omniサインイン",
        limited: "Omniサインイン",
        unlimited: "Omniサインイン",
        not_eligible: "Omniサインインを無効にしてください"
    },
    built_in_email_connector_enabled: {
        name: "組込みメールコネクタ",
        limited: "組込みメールコネクタ",
        unlimited: "組込みメールコネクタ",
        not_eligible: "組込みメールコネクタを削除してください"
    },
    social_connectors_limit: {
        name: "ソーシャルコネクタ",
        limited: "{{count, number}} ソーシャルコネクタ",
        limited_other: "{{count, number}} ソーシャルコネクタ",
        unlimited: "無制限のソーシャルコネクタ",
        not_eligible: "ソーシャルコネクタを削除してください"
    },
    standard_connectors_limit: {
        name: "無料の標準コネクタ",
        limited: "{{count, number}} 無料の標準コネクタ",
        limited_other: "{{count, number}} 無料の標準コネクタ",
        unlimited: "無制限の標準コネクタ",
        not_eligible: "標準コネクタを削除してください"
    },
    roles_limit: {
        name: "ロール",
        limited: "{{count, number}} ロール",
        limited_other: "{{count, number}} ロール",
        unlimited: "無制限のロール",
        not_eligible: "ロールを削除してください"
    },
    machine_to_machine_roles_limit: {
        name: "マシン間ロール",
        limited: "{{count, number}} マシン間ロール",
        limited_other: "{{count, number}} マシン間ロール",
        unlimited: "無制限のマシン間ロール",
        not_eligible: "マシン間ロールを削除してください"
    },
    scopes_per_role_limit: {
        name: "ロールごとの権限",
        limited: "{{count, number}} ロールごとの権限",
        limited_other: "{{count, number}} ロールごとの権限",
        unlimited: "無制限のロールごとの権限",
        not_eligible: "ロールの権限を削除してください"
    },
    hooks_limit: {
        name: "Webhooks",
        limited: "{{count, number}}個のWebhook",
        limited_other: "{{count, number}}個のWebhook",
        unlimited: "無制限のWebhook",
        not_eligible: "Webhookを削除してください"
    },
    organizations_enabled: {
        name: "組織",
        limited: "組織",
        unlimited: "組織",
        not_eligible: "あなたの組織を削除してください"
    },
    audit_logs_retention_days: {
        name: "監査ログの保持期間",
        limited: "監査ログの保持期間: {{count, number}} 日",
        limited_other: "監査ログの保持期間: {{count, number}} 日",
        unlimited: "無制限の日数",
        not_eligible: "監査ログがありません"
    },
    email_ticket_support: {
        name: "メールチケットサポート",
        limited: "{{count, number}}時間のメールチケットサポート",
        limited_other: "{{count, number}}時間のメールチケットサポート",
        unlimited: "メールチケットサポート",
        not_eligible: "メールチケットサポートなし"
    },
    mfa_enabled: {
        name: "二要素認証",
        limited: "二要素認証",
        unlimited: "二要素認証",
        not_eligible: "二要素認証を削除"
    },
    sso_enabled: {
        name: "エンタープライズSSO",
        limited: "エンタープライズSSO",
        unlimited: "エンタープライズSSO",
        not_eligible: "エンタープライズSSOを削除してください"
    },
    tenant_members_limit: {
        name: "テナントメンバー",
        limited: "{{count, number}} テナントメンバー",
        limited_other: "{{count, number}} テナントメンバー",
        unlimited: "無制限のテナントメンバー",
        not_eligible: "テナントメンバーを削除してください"
    },
    custom_jwt_enabled: {
        name: "カスタムJWT",
        limited: "カスタムJWT",
        unlimited: "カスタムJWT",
        not_eligible: "JWTクレームカスタマイザーを削除してください"
    }
};
var $9d0c6400a8149e0c$export$2e2bcd8739ae039 = Object.freeze($9d0c6400a8149e0c$var$quota_item);


const $e2f3fbf6830fc3e4$var$quota_table = {
    quota: {
        title: "基本",
        base_price: "基本価格",
        mau_limit: "MAU 制限",
        included_tokens: "含まれるトークン"
    },
    application: {
        title: "アプリケーション",
        total: "総アプリケーション数",
        m2m: "マシン・ツー・マシン",
        third_party: "サードパーティーアプリ"
    },
    resource: {
        title: "APIリソース",
        resource_count: "リソース数",
        scopes_per_resource: "リソースごとの権限"
    },
    branding: {
        title: "UIとブランディング",
        custom_domain: "カスタムドメイン",
        custom_css: "カスタムCSS",
        app_logo_and_favicon: "アプリロゴとFavicon",
        dark_mode: "ダークモード",
        i18n: "国際化"
    },
    user_authn: {
        title: "ユーザー認証",
        omni_sign_in: "オムニサインイン",
        password: "パスワード",
        passwordless: "パスワードレス - E-mailとSMS",
        email_connector: "E-mailコネクタ",
        sms_connector: "SMSコネクタ",
        social_connectors: "ソーシャルコネクタ",
        standard_connectors: "スタンダードコネクタ",
        built_in_email_connector: "組み込みE-mailコネクタ",
        mfa: "多要素認証",
        sso: "エンタープライズ SSO",
        adaptive_mfa: "適応型MFA"
    },
    user_management: {
        title: "ユーザー管理",
        user_management: "ユーザー管理",
        roles: "ロール",
        machine_to_machine_roles: "マシン対マシンロール",
        scopes_per_role: "ロールごとの権限"
    },
    organizations: {
        title: "組織",
        organizations: "組織",
        organization: "組織",
        organization_count: "組織数",
        allowed_users_per_org: "組織ごとのユーザー数",
        invitation: "招待（管理API）",
        org_roles: "組織ロール",
        org_permissions: "組織権限",
        just_in_time_provisioning: "ジャストインタイムプロビジョニング"
    },
    support: {
        title: "コンプライアンスとサポート",
        community: "コミュニティ",
        customer_ticket: "カスタマーチケット",
        premium: "プレミアム",
        email_ticket_support: "Emailチケットサポート",
        soc2_report: "SOC2レポート",
        hipaa_or_baa_report: "HIPAA/BAAレポート"
    },
    developers_and_platform: {
        title: "デベロッパーとプラットフォーム",
        hooks: "Webhooks",
        audit_logs_retention: "監査ログの保持",
        jwt_claims: "JWTクレーム",
        tenant_members: "テナントメンバー"
    },
    unlimited: "無制限",
    contact: "お問い合わせ",
    monthly_price: "${{value, number}}/mo",
    days_one: "{{count, number}} 日",
    days_other: "{{count, number}} 日",
    add_on: "アドオン",
    tier: "レベル{{value, number}}: ",
    paid_token_limit_tip: "Logtoは、クォータ制限を超える機能に対して料金を追加します。2024年第2四半期ごろから課金を開始するまで無料でご利用いただけます。トークンがさらに必要な場合は、お問い合わせください。デフォルトでは、100万トークンごとに月額80ドルを請求します。",
    paid_quota_limit_tip: "Logtoはクォータ制限を超える機能に対して料金を追加します。2024年第2四半期ごろまでは無料でご利用いただけます。",
    paid_add_on_feature_tip: "これはアドオン機能です。2024年第2四半期ごろまでは無料でご利用いただけます。",
    million: "{{value, number}} 万",
    mau_tip: "MAU（月間アクティブユーザー）は、請求サイクルでLogtoと少なくとも1つのトークンを交換したユニークユーザーの数を指します。",
    tokens_tip: "Logtoによって発行されたすべての種類のトークン、アクセストークン、リフレッシュトークンなどを含みます。",
    mao_tip: "MAO（月間アクティブ組織）は、請求サイクル内で少なくとも1つのMAU（月間アクティブユーザー）を持つユニークな組織の数を意味します。",
    third_party_tip: "LogtoをOIDCアイデンティティプロバイダーとして使用して、サードパーティーアプリケーションのサインインや権限の付与を行います。",
    included: "{{value, number}} 込み",
    included_mao: "{{value, number}} MAO込み",
    extra_quota_price: "その後、各${{value, number}} / 月ごと",
    per_month_each: "各${{value, number}} / 月ごと",
    extra_mao_price: "その後、MAOごとに${{value, number}}",
    per_month: "${{value, number}} / 月ごと",
    per_member: "メンバーごとに ${{value, number}}"
};
var $e2f3fbf6830fc3e4$export$2e2bcd8739ae039 = Object.freeze($e2f3fbf6830fc3e4$var$quota_table);


const $4345f0791210f418$var$subscription = {
    free_plan: "フリープラン",
    free_plan_description: "サイドプロジェクトや最初のLogtoのトライアルに適しています。クレジットカードは必要ありません。",
    pro_plan: "プロプラン",
    pro_plan_description: "ビジネスが安心してLogtoを利用できるプランです。",
    enterprise: "エンタープライズ",
    current_plan: "現在のプラン",
    current_plan_description: "現在のプランはこちらです。プランの使用状況を簡単に確認したり、次回の請求を確認したり、必要に応じてプランを変更したりできます。",
    plan_usage: "利用状況",
    plan_cycle: "プランサイクル: {{period}}。更新日: {{renewDate}}。",
    next_bill: "次の請求書",
    next_bill_hint: "計算方法については、次の<a>記事</a>を参照してください。",
    next_bill_tip: "ここに表示されている価格には税金が含まれていません。税金は、提供された情報と地元の規制要件に基づいて計算され、請求書に表示されます。",
    manage_payment: "支払い方法の管理",
    overfill_quota_warning: "クォータ制限に到達しました。問題を防ぐために、プランをアップグレードしてください。",
    upgrade_pro: "プロプランにアップグレード",
    update_payment: "支払いを更新する",
    payment_error: "支払いに問題が発生しました。前回のサイクルで ${{price, number}} を処理できませんでした。Logtoのサービス停止を回避するために支払いを更新してください。",
    downgrade: "ダウングレード",
    current: "現在",
    upgrade: "アップグレード",
    quota_table: $e2f3fbf6830fc3e4$export$2e2bcd8739ae039,
    billing_history: {
        invoice_column: "請求書",
        status_column: "ステータス",
        amount_column: "金額",
        invoice_created_date_column: "請求書作成日",
        invoice_status: {
            void: "キャンセル済み",
            paid: "支払済み",
            open: "未処理",
            uncollectible: "延滞"
        }
    },
    quota_item: $9d0c6400a8149e0c$export$2e2bcd8739ae039,
    downgrade_modal: {
        title: "ダウングレードしますか？",
        description: "<targetName/>に切り替える場合、以前の<currentName/>で使用できたクオータや機能は使用できなくなりますので注意してください。",
        before: "前: <name/>",
        after: "後: <name/>",
        downgrade: "ダウングレード"
    },
    not_eligible_modal: {
        downgrade_title: "ダウングレードの対象外です",
        downgrade_description: "<name/>へダウングレードする前に、以下の条件を満たしていることを確認してください。",
        downgrade_help_tip: "ダウングレードのヘルプが必要ですか？<a>お問い合わせください</a>。",
        upgrade_title: "当社の尊敬されるアーリーアダプターの皆様へのフレンドリーなリマインダー",
        upgrade_description: "現在、<name /> の許容範囲を超えて使用しています。Logto は正式にリリースされ、各プランに合わせた機能が提供されています。 <name /> へのアップグレードを検討する前に、アップグレードする前提条件を満たしていることを確認してください。",
        upgrade_pro_tip: " または Pro プランへのアップグレードを検討してください。",
        upgrade_help_tip: "アップグレードのヘルプが必要ですか？<a>お問い合わせください</a>。",
        a_maximum_of: "<item/>の最大数"
    },
    upgrade_success: "正常に<name/>にアップグレードされました",
    downgrade_success: "正常に<name/>にダウングレードされました",
    subscription_check_timeout: "サブスクリプションのチェックがタイムアウトしました。後でもう一度更新してください。",
    no_subscription: "契約なし"
};
var $4345f0791210f418$export$2e2bcd8739ae039 = Object.freeze($4345f0791210f418$var$subscription);


const $9895f2aa2f925d3d$var$tab_sections = {
    overview: "概要",
    authentication: "認証",
    authorization: "認可",
    users: "ユーザー",
    developer: "開発者",
    tenant: "テナント"
};
var $9895f2aa2f925d3d$export$2e2bcd8739ae039 = Object.freeze($9895f2aa2f925d3d$var$tab_sections);


const $997dd4a0af3a846b$var$tabs = {
    get_started: "はじめに",
    dashboard: "ダッシュボード",
    applications: "アプリケーション",
    api_resources: "API リソース",
    sign_in_experience: "サインイン",
    connectors: "コネクタ",
    enterprise_sso: "エンタープライズSSO",
    webhooks: "Webhooks",
    organizations: "組織",
    users: "ユーザー管理",
    audit_logs: "監査ログ",
    roles: "役割",
    docs: "ドキュメント",
    tenant_settings: "設定",
    mfa: "Multi-factor auth",
    customize_jwt: "カスタム JWT",
    signing_keys: "署名キー",
    organization_template: "組織テンプレート"
};
var $997dd4a0af3a846b$export$2e2bcd8739ae039 = Object.freeze($997dd4a0af3a846b$var$tabs);


const $33c6900e9ab747a9$var$tenant_members = {
    members: "メンバー",
    invitations: "招待状",
    invite_members: "メンバーを招待する",
    user: "ユーザー",
    roles: "ロール",
    admin: "管理者",
    collaborator: "共同作業者",
    invitation_status: "招待状のステータス",
    inviter: "招待者",
    expiration_date: "有効期限",
    invite_modal: {
        title: "Logto Cloud への招待",
        subtitle: "組織にメンバーを招待するには、招待を受け入れる必要があります。",
        to: "To",
        added_as: "役割として追加",
        email_input_placeholder: "johndoe@example.com"
    },
    invitation_statuses: {
        pending: "保留中",
        accepted: "受け入れ済み",
        expired: "期限切れ",
        revoked: "取り消された"
    },
    invitation_empty_placeholder: {
        title: "チームメンバーを招待",
        description: "現在、テナントに招待されたメンバーはいません。\n統合の支援のために、メンバーや管理者を追加するかどうか検討してください。"
    },
    menu_options: {
        edit: "テナントロールを編集",
        delete: "テナントからユーザーを削除",
        resend_invite: "招待を再送信",
        revoke: "招待を取り消す",
        delete_invitation_record: "この招待レコードを削除"
    },
    edit_modal: {
        title: "{{name}} の役割を変更"
    },
    delete_user_confirm: "このユーザーをこのテナントから削除してもよろしいですか？",
    assign_admin_confirm: "選択したユーザーを管理者にすることを確認しますか？ 管理者アクセスを付与すると、次の権限がユーザーに付与されます。<ul><li>テナントの課金プランを変更</li><li>共同作業者の追加または削除</li><li>テナントの削除</li></ul>",
    revoke_invitation_confirm: "この招待を取り消してもよろしいですか？",
    delete_invitation_confirm: "この招待レコードを削除してもよろしいですか？",
    messages: {
        invitation_sent: "招待が送信されました。",
        invitation_revoked: "招待が取り消されました。",
        invitation_resend: "招待が再送信されました。",
        invitation_deleted: "招待レコードが削除されました。"
    },
    errors: {
        email_required: "招待対象のメールアドレスは必須です。",
        email_exists: "電子メールアドレスは既に存在します。",
        member_exists: "このユーザーはすでにこの組織のメンバーです。",
        pending_invitation_exists: "保留中の招待が存在します。関連する電子メールを削除するか、招待を取り消してください。",
        invalid_email: "メールアドレスが無効です。正しい形式であることを確認してください。",
        max_member_limit: "このテナントの最大メンバー数（{{limit}}）に達しました。"
    }
};
var $33c6900e9ab747a9$export$2e2bcd8739ae039 = Object.freeze($33c6900e9ab747a9$var$tenant_members);


const $bfb301cf23ef073e$var$tenants = {
    title: "設定",
    description: "テナントの設定を効率的に管理し、ドメインをカスタマイズします。",
    tabs: {
        settings: "設定",
        members: "メンバー",
        domains: "ドメイン",
        subscription: "プランと請求",
        billing_history: "請求履歴"
    },
    settings: {
        title: "設定",
        description: "テナント名を設定し、ホストされているデータの地域とテナントタイプを表示します。",
        tenant_id: "テナントID",
        tenant_name: "テナント名",
        tenant_region: "データがホストされている地域",
        tenant_region_tip: "テナントのリソースは{{region}}にホストされています。 <a>詳細</a>",
        environment_tag_development: "開発",
        environment_tag_production: "本番",
        tenant_type: "テナントタイプ",
        development_description: "テスト用であり、本番で使用すべきではありません。サブスクリプションは必要ありません。すべてのプロの機能がありますが、サインインバナーなどの制限があります。<a>詳細</a>",
        production_description: "エンドユーザーに使用することを意図しており、有料のサブスクリプションが必要なアプリ向け。<a>詳細</a>",
        tenant_info_saved: "テナント情報は正常に保存されました。"
    },
    full_env_tag: {
        development: "開発",
        production: "本番"
    },
    deletion_card: {
        title: "削除",
        tenant_deletion: "テナントの削除",
        tenant_deletion_description: "テナントの削除は、関連するすべてのユーザーデータと設定の永久的な削除につながります。十分に注意して操作してください。",
        tenant_deletion_button: "テナントを削除する"
    },
    leave_tenant_card: {
        title: "退出",
        leave_tenant: "テナントを退出する",
        leave_tenant_description: "テナント内のリソースは保持されますが、これ以上このテナントにアクセスできません。",
        last_admin_note: "このテナントを退出するには、少なくとも1人の他のメンバーが管理者の役割を持つことを確認してください。"
    },
    create_modal: {
        title: "テナントを作成する",
        tenant_usage_purpose: "このテナントを使用する目的は何ですか？",
        development_description: "テスト用であり、本番で使用すべきではありません。サブスクリプションは必要ありません。",
        development_hint: "すべてのプロの機能がありますが、サインインバナーなどの制限があります。",
        production_description: "エンドユーザーに使用することを意図しており、有料のサブスクリプションが必要なアプリ向け。",
        available_plan: "利用可能なプラン:",
        create_button: "テナントを作成する",
        tenant_name_placeholder: "私のテナント"
    },
    dev_tenant_migration: {
        title: "新しい「開発テナント」を作成して、プロの機能を無料でお試しできます！",
        affect_title: "これはあなたにどのように影響しますか？",
        hint_1: "古い<strong>環境タグ</strong>が2つの新しいテナントタイプ<strong>「開発」</strong>および<strong>「本番」</strong>に置き換えられます。",
        hint_2: "シームレスな移行と機能の連続性を保証するため、すべての早期に作成されたテナントは、前のサブスクリプションとともに<strong>「本番」</strong>テナントタイプに昇格されます。",
        hint_3: "ご安心ください、他のすべての設定は変わりません。",
        about_tenant_type: "テナントタイプについて"
    },
    delete_modal: {
        title: "テナントを削除します",
        description_line1: 'あなたはテナント "<span>{{name}}</span>" を環境接尾辞タグ "<span>{{tag}}</span>" と共に削除してもよろしいでしょうか？ この操作は取り消すことができず、すべてのデータとテナント情報が永久に削除されます。',
        description_line2: "テナントを削除する前に、お手伝いできることがあるかもしれません。 <span><a>電子メールでお問い合わせ</a></span>",
        description_line3: '続行する場合は、テナント名 "<span>{{name}}</span>" を入力して確認してください。',
        delete_button: "完全に削除する",
        cannot_delete_title: "このテナントは削除できません",
        cannot_delete_description: "申し訳ありませんが、現時点ではこのテナントを削除できません。無料プランに登録しており、未払いの請求がないことを確認してください。"
    },
    leave_tenant_modal: {
        description: "このテナントを退出してもよろしいですか？",
        leave_button: "退出"
    },
    tenant_landing_page: {
        title: "まだテナントを作成していません",
        description: "Logto でプロジェクトを設定するには、新しいテナントを作成してください。ログアウトまたはアカウントを削除する必要がある場合は、右上隅のアバターボタンをクリックしてください。",
        create_tenant_button: "テナントを作成"
    },
    status: {
        mau_exceeded: "MAUの制限を超えました",
        suspended: "一時停止中",
        overdue: "期限切れ"
    },
    tenant_suspended_page: {
        title: "テナントが一時停止されました。アクセスを復元するにはお問い合わせください。",
        description_1: "誠に申し訳ありませんが、ご利用のテナントアカウントが一時的に停止されました。MAU制限を超えた、支払いの遅延、その他の不正な操作などが原因です。",
        description_2: "詳細な説明や懸念事項がある場合、または機能を完全に復元しテナントをアンブロックする場合は、直ちにお問い合わせください。"
    }
};
var $bfb301cf23ef073e$export$2e2bcd8739ae039 = Object.freeze($bfb301cf23ef073e$var$tenants);


const $14ac93bbc4962591$var$topbar = {
    docs: "ドキュメント",
    help: "ヘルプ"
};
var $14ac93bbc4962591$export$2e2bcd8739ae039 = Object.freeze($14ac93bbc4962591$var$topbar);


const $45a7f2c64e41c780$var$featured_plan_content = {
    mau: {
        free_plan: "{{count, number}} MAUまで",
        pro_plan: "MAU無制限"
    },
    m2m: {
        free_plan: "{{count, number}}機器間",
        pro_plan: "追加の機器間"
    },
    third_party_apps: "サードパーティアプリケーションのIdP",
    mfa: "マルチファクタ認証",
    sso: "企業SSO",
    role_and_permissions: {
        free_plan: "{{roleCount, number}}ロールと{{permissionCount, number}}ロールごとの権限",
        pro_plan: "ロールごとの無制限の役割と権限"
    },
    organizations: "組織",
    audit_logs: "監査ログ保持: {{count, number}} 日間"
};
var $45a7f2c64e41c780$export$2e2bcd8739ae039 = Object.freeze($45a7f2c64e41c780$var$featured_plan_content);


const $219956a6645742e1$var$paywall = {
    applications: "{{count, number}}個の<planName/>アプリケーション制限に達しました。チームのニーズに対応するため、プランをアップグレードしてください。サポートが必要な場合は、お気軽に<a>お問い合わせ</a>ください。",
    applications_other: "{{count, number}}個の<planName/>アプリケーション制限に達しました。チームのニーズに対応するため、プランをアップグレードしてください。サポートが必要な場合は、お気軽に<a>お問い合わせ</a>ください。",
    machine_to_machine_feature: "Switch to the <strong>Pro</strong> plan to gain extra machine-to-machine applications and enjoy all premium features. <a>Contact us</a> if you have questions.",
    machine_to_machine: "{{count, number}}個の<planName/>マシン間アプリケーション制限に達しました。チームのニーズに対応するため、プランをアップグレードしてください。サポートが必要な場合は、お気軽に<a>お問い合わせ</a>ください。",
    machine_to_machine_other: "{{count, number}}個の<planName/>マシン間アプリケーション制限に達しました。チームのニーズに対応するため、プランをアップグレードしてください。サポートが必要な場合は、お気軽に<a>お問い合わせ</a>ください。",
    resources: "{{count, number}}の<planName/> APIリソース制限に達しました。チームのニーズに合わせてプランをアップグレードしてください。<a>お問い合わせ</a>は何かお手伝いが必要な場合はお気軽にどうぞ。",
    resources_other: "{{count, number}}の<planName/> APIリソース制限に達しました。チームのニーズに合わせてプランをアップグレードしてください。<a>お問い合わせ</a>は何かお手伝いが必要な場合はお気軽にどうぞ。",
    scopes_per_resource: "{{count, number}}の<planName/> APIリソースあたりの許可制限に達しました。拡張するには今すぐアップグレードしてください。<a>お問い合わせ</a>は何かお手伝いが必要な場合はお気軽にどうぞ。",
    scopes_per_resource_other: "{{count, number}}の<planName/> APIリソースあたりの許可制限に達しました。拡張するには今すぐアップグレードしてください。<a>お問い合わせ</a>は何かお手伝いが必要な場合はお気軽にどうぞ。",
    custom_domain: "カスタムドメインの機能を解除するには、<strong>Hobby</strong>または<strong>Pro</strong>プランにアップグレードしてください。何かお手伝いが必要な場合は、お気軽に<a>お問い合わせ</a>ください。",
    social_connectors: "{{count, number}}の<planName/>ソーシャルコネクタ制限に達しました。チームのニーズに合わせて有料プランにアップグレードして、OIDC、OAuth 2.0、およびSAMLプロトコルを使用して独自のコネクタを作成できるようにしましょう。<a>お問い合わせ</a>は何かお手伝いが必要な場合はお気軽にどうぞ。",
    social_connectors_other: "{{count, number}}の<planName/>ソーシャルコネクタ制限に達しました。チームのニーズに合わせて有料プランにアップグレードして、OIDC、OAuth 2.0、およびSAMLプロトコルを使用して独自のコネクタを作成できるようにしましょう。<a>お問い合わせ</a>は何かお手伝いが必要な場合はお気軽にどうぞ。",
    standard_connectors_feature: "OIDC、OAuth 2.0、およびSAMLプロトコルを使用して独自のコネクタを作成し、無制限のソーシャルコネクタとすべてのプレミアム機能を利用するには、<strong>Hobby</strong>プランまたは<strong>Pro</strong>プランにアップグレードしてください。どんなお手伝いが必要でも、お気軽に<a>お問い合わせ</a>ください。",
    standard_connectors: "{{count, number}}の<planName/>ソーシャルコネクタ制限に達しました。チームのニーズに合わせて有料プランにアップグレードして、OIDC、OAuth 2.0、およびSAMLプロトコルを使用して独自のコネクタを作成できるようにしましょう。<a>お問い合わせ</a>は何かお手伝いが必要な場合はお気軽にどうぞ。",
    standard_connectors_other: "{{count, number}}の<planName/>ソーシャルコネクタ制限に達しました。チームのニーズに合わせて有料プランにアップグレードして、OIDC、OAuth 2.0、およびSAMLプロトコルを使用して独自のコネクタを作成できるようにしましょう。<a>お問い合わせ</a>は何かお手伝いが必要な場合はお気軽にどうぞ。",
    standard_connectors_pro: "{{count, number}}の<planName/>スタンダードコネクタ制限に達しました。チームのニーズに合わせてエンタープライズプランにアップグレードして、OIDC、OAuth 2.0、およびSAMLプロトコルを使用して独自のコネクタを作成できるようにしましょう。<a>お問い合わせ</a>は何かお手伝いが必要な場合はお気軽にどうぞ。",
    standard_connectors_pro_other: "{{count, number}}の<planName/>スタンダードコネクタ制限に達しました。チームのニーズに合わせてエンタープライズプランにアップグレードして、OIDC、OAuth 2.0、およびSAMLプロトコルを使用して独自のコネクタを作成できるようにしましょう。<a>お問い合わせ</a>は何かお手伝いが必要な場合はお気軽にどうぞ。",
    roles: "{{count, number}}の<planName/>ロール制限に達しました。追加のロールと権限を追加するにはプランをアップグレードしてください。<a>お問い合わせ</a>は何かお手伝いが必要な場合はお気軽にどうぞ。",
    roles_other: "{{count, number}}の<planName/>ロール制限に達しました。追加のロールと権限を追加するにはプランをアップグレードしてください。<a>お問い合わせ</a>は何かお手伝いが必要な場合はお気軽にどうぞ。",
    machine_to_machine_roles: "{{count, number}} machine-to-machine role of <planName/> limit reached. Upgrade plan to add additional roles and permissions. Feel free to <a>contact us</a> if you need any assistance.",
    machine_to_machine_roles_other: "{{count, number}} machine-to-machine roles of <planName/> limit reached. Upgrade plan to add additional roles and permissions. Feel free to <a>contact us</a> if you need any assistance.",
    scopes_per_role: "{{count, number}}の<planName/>ロールあたりの許可制限に達しました。追加のロールと権限を追加するにはプランをアップグレードしてください。<a>お問い合わせ</a>は何かお手伝いが必要な場合はお気軽にどうぞ。",
    scopes_per_role_other: "{{count, number}}の<planName/>ロールあたりの許可制限に達しました。追加のロールと権限を追加するにはプランをアップグレードしてください。<a>お問い合わせ</a>は何かお手伝いが必要な場合はお気軽にどうぞ。",
    hooks: "{{count, number}}の<planName/>ウェブフック制限に達しました。追加のウェブフックを作成するにはプランをアップグレードしてください。<a>お問い合わせ</a>は何かお手伝いが必要な場合はお気軽にどうぞ。",
    hooks_other: "{{count, number}}の<planName/>ウェブフック制限に達しました。追加のウェブフックを作成するにはプランをアップグレードしてください。<a>お問い合わせ</a>は何かお手伝いが必要な場合はお気軽にどうぞ。",
    mfa: "セキュリティを確認するためにMFAを解除して有料プランにアップグレードしてください。ご質問があれば、<a>お問い合わせください</a>。",
    organizations: "Unlock organizations by upgrading to a paid plan. Don’t hesitate to <a>contact us</a> if you need any assistance.",
    third_party_apps: "Unlock Logto as IdP for third-party apps by upgrading to a paid plan. For any assistance, feel free to <a>contact us</a>.",
    sso_connectors: "Unlock enterprise sso by upgrading to a paid plan. For any assistance, feel free to <a>contact us</a>.",
    tenant_members: "Unlock collaboration feature by upgrading to a paid plan. For any assistance, feel free to <a>contact us</a>.",
    tenant_members_dev_plan: "You've reached your {{limit}}-member limit. Release a member or revoke a pending invitation to add someone new. Need more seats? Feel free to contact us.",
    custom_jwt: {
        title: "Add custom claims",
        description: "Upgrade to a paid plan for custom JWT functionality and premium benefits. Don't hesitate to <a>contact us</a> if you have any questions."
    }
};
var $219956a6645742e1$export$2e2bcd8739ae039 = Object.freeze($219956a6645742e1$var$paywall);


const $6fd6ecb2f73ac741$var$upsell = {
    upgrade_plan: "プランをアップグレード",
    compare_plans: "プラン比較",
    view_plans: "プランを見る",
    create_tenant: {
        title: "テナントプランを選択",
        description: "成長中の企業向けに革新的かつ手頃な価格で設計された競争力のあるプランオプションを提供しています。<a>詳細を見る</a>",
        base_price: "基本価格",
        monthly_price: "{{value, number}}/mo",
        view_all_features: "すべての機能を見る",
        select_plan: "<name/>を選択",
        free_tenants_limit: "最大{{count, number}}テナント無料",
        free_tenants_limit_other: "最大{{count, number}}テナント無料",
        most_popular: "最も人気",
        upgrade_success: "<name/>にアップグレードしました"
    },
    mau_exceeded_modal: {
        title: "MAUが制限を超えました。プランをアップグレードしてください。",
        notification: "現在のMAUが<planName/>の制限を超えています。サービスの停止を回避するために、迅速にプレミアムプランにアップグレードしてください。",
        update_plan: "プランを更新"
    },
    payment_overdue_modal: {
        title: "請求書の支払いが期限切れです",
        notification: "おっと！テナント<span>{{name}}</span>の請求書の支払いが失敗しました。Logtoサービスの停止を避けるために、すみやかに請求書をお支払いください。",
        unpaid_bills: "未払いの請求書",
        update_payment: "支払いを更新"
    },
    add_on_quota_item: {
        api_resource: "API リソース",
        machine_to_machine: "マシン対マシンアプリケーション",
        tokens: "{{limit}}M トークン",
        tenant_member: "テナントメンバー"
    },
    charge_notification_for_quota_limit: "{{item}} のクォータ制限を超えています。Logto はクォータ制限を超える利用に対して料金を追加します。新しいアドオン価格設計がリリースされる日から請求が開始されます。 <a>詳細</a>",
    paywall: $219956a6645742e1$export$2e2bcd8739ae039,
    featured_plan_content: $45a7f2c64e41c780$export$2e2bcd8739ae039
};
var $6fd6ecb2f73ac741$export$2e2bcd8739ae039 = Object.freeze($6fd6ecb2f73ac741$var$upsell);


const $def2975ce72e6313$var$user_details = {
    page_title: "ユーザーの詳細",
    back_to_users: "ユーザー管理に戻る",
    created_title: "このユーザーは正常に作成されました",
    created_guide: "ユーザーがサインインプロセスを支援するための情報です。",
    created_email: "メールアドレス：",
    created_phone: "電話番号：",
    created_username: "ユーザー名：",
    created_password: "パスワード：",
    menu_delete: "削除",
    delete_description: "この操作は取り消せません。ユーザーが永久に削除されます。",
    deleted: "ユーザーは正常に削除されました",
    reset_password: {
        reset_password: "パスワードをリセット",
        title: "本当にパスワードをリセットしますか？",
        content: "この操作は取り消せません。ユーザーのログイン情報がリセットされます。",
        congratulations: "このユーザーはリセットされました",
        new_password: "新しいパスワード："
    },
    tab_settings: "設定",
    tab_roles: "役割",
    tab_logs: "ユーザーログ",
    tab_organizations: "組織",
    authentication: "認証",
    authentication_description: "各ユーザーには、すべてのユーザー情報が含まれるプロファイルがあります。基本データ、ソーシャルアイデンティティ、およびカスタムデータで構成されています。",
    user_profile: "ユーザープロファイル",
    field_email: "メールアドレス",
    field_phone: "電話番号",
    field_username: "ユーザー名",
    field_name: "名前",
    field_avatar: "アバター画像のURL",
    field_avatar_placeholder: "https://your.cdn.domain/avatar.png",
    field_custom_data: "カスタムデータ",
    field_custom_data_tip: "プリディフィンドされたユーザープロパティにリストされていない、追加のユーザー情報（ユーザーが好みの色や言語など）。",
    field_connectors: "ソーシャル接続",
    field_sso_connectors: "エンタープライズ接続",
    custom_data_invalid: "カスタムデータは有効なJSONオブジェクトである必要があります",
    connectors: {
        connectors: "コネクタ",
        user_id: "ユーザーID",
        remove: "削除",
        connected: "このユーザーは複数のソーシャルコネクタに接続しています。",
        not_connected: "ユーザーはソーシャルコネクタに接続していません",
        deletion_confirmation: "既存の<name/>アイデンティティを削除しています。本当に続行しますか？"
    },
    sso_connectors: {
        connectors: "接続",
        enterprise_id: "エンタープライズID",
        connected: "このユーザーはシングルサインオンのために複数のエンタープライズアイデンティティプロバイダに接続しています。",
        not_connected: "ユーザーはシングルサインオンのためにいかなるエンタープライズアイデンティティプロバイダにも接続していません。"
    },
    mfa: {
        field_name: "多要素認証",
        field_description: "このユーザーは2段階認証要素を有効にしました。",
        name_column: "多要素認証",
        field_description_empty: "このユーザーは2段階認証の要因を有効にしていません。",
        deletion_confirmation: "2段階認証の既存の<name/>を削除しています。本当に続行しますか？"
    },
    suspended: "停止中",
    suspend_user: "ユーザーを一時停止",
    suspend_user_reminder: "ユーザーを一時停止してよろしいですか？この操作を行うと、ユーザーはアプリにサインインできなくなり、現在のアクセストークンが期限切れになった後、新しいアクセストークンを取得できなくなります。さらに、このユーザーによって行われたすべての API リクエストは失敗します。",
    suspend_action: "一時停止",
    user_suspended: "ユーザーが停止されました。",
    reactivate_user: "ユーザーをリアクティブ化",
    reactivate_user_reminder: "このユーザーをリアクティブ化することを確認しますか？それにより、このユーザーのサインイン試行が許可されます。",
    reactivate_action: "活性化",
    user_reactivated: "ユーザーが再活性化されました。",
    roles: {
        name_column: "役割",
        description_column: "説明",
        assign_button: "役割を割り当てる",
        delete_description: "この操作により、このユーザーからこの役割が削除されます。役割自体はまだ存在しますが、このユーザーに関連付けられなくなります。",
        deleted: "役割 {{name}} はこのユーザーから正常に削除されました。",
        assign_title: "{{name}} に役割を割り当てる",
        assign_subtitle: "{{name}} に1つ以上の役割を承認します",
        assign_role_field: "役割を割り当てる",
        role_search_placeholder: "役割名で検索",
        added_text: "{{value, number}} 追加しました",
        assigned_user_count: "{{value, number}} ユーザー",
        confirm_assign: "役割を割り当てる",
        role_assigned: "役割が正常に割り当てられました",
        search: "ロール名、説明、または ID で検索",
        empty: "利用可能な役割はありません"
    },
    warning_no_sign_in_identifier: "ユーザーは、サインインに少なくとも1つの識別子（ユーザー名、メールアドレス、電話番号、またはソーシャル）を持っている必要があります。続行してよろしいですか？",
    organization_roles_tooltip: "この組織内のユーザーに割り当てられた役割。"
};
var $def2975ce72e6313$export$2e2bcd8739ae039 = Object.freeze($def2975ce72e6313$var$user_details);


const $822afd9f1b449ace$var$users = {
    page_title: "ユーザー管理",
    title: "ユーザー管理",
    subtitle: "ユーザーのアイデンティティを管理する、ユーザーの作成、情報の編集、ユーザーログの表示、パスワードのリセットおよびユーザーの削除を含む",
    create: "ユーザーを追加する",
    create_subtitle: "少なくとも1つの以下のフィールドを提供してください。",
    error_missing_identifier: "ユーザーを作成するには、少なくとも1つの識別子を指定する必要があります。",
    user_name: "ユーザー名",
    application_name: "アプリケーションから",
    latest_sign_in: "最新のサインイン",
    create_form_username: "ユーザー名",
    create_form_password: "パスワード",
    create_form_name: "フルネーム",
    placeholder_name: "山田 太郎",
    placeholder_email: "taroyamada@example.com",
    placeholder_username: "user123",
    placeholder_phone: "+81 3-1234-5678",
    unnamed: "名前がありません",
    search: "名前、メール、電話、またはユーザー名で検索",
    check_user_detail: "ユーザー詳細を確認する",
    placeholder_title: "ユーザー管理",
    placeholder_description: "各ユーザーには、基本データ、ソーシャルアイデンティティ、およびカスタムデータが含まれるプロフィールがあります。"
};
var $822afd9f1b449ace$export$2e2bcd8739ae039 = Object.freeze($822afd9f1b449ace$var$users);


const $14e796a3b0d9eabc$var$webhook_details = {
    page_title: "Webhookの詳細",
    back_to_webhooks: "Webhooksに戻る",
    not_in_use: "使用されていない",
    success_rate: "成功率",
    requests: "24時間に{{value, number}}件のリクエスト",
    disable_webhook: "Webhookを無効にする",
    disable_reminder: "本当にこのWebhookを再度アクティブにしますか？これを行うとエンドポイントURLにHTTPリクエストが送信されなくなります。",
    webhook_disabled: "Webhookは無効になりました。",
    webhook_reactivated: "Webhookが再度有効になりました。",
    reactivate_webhook: "Webhookを再度アクティブにする",
    delete_webhook: "Webhookを削除する",
    deletion_reminder: "このWebhookを削除しています。削除した後はエンドポイントURLにHTTPリクエストが送信されなくなります。",
    deleted: "Webhookは削除されました。",
    settings_tab: "設定",
    recent_requests_tab: "最近のリクエスト（24時間）",
    settings: {
        settings: "設定",
        settings_description: "Webhookは、特定のイベントが発生すると、POSTリクエストをエンドポイントURLに送信することで、リアルタイムのアップデートを受信できるようにするものです。これにより、新しい情報を受信した後、直ちにアクションを起こすことができます。",
        events: "イベント",
        events_description: "LogtoがPOSTリクエストを送信するトリガーイベントを選択します。",
        name: "名前",
        endpoint_url: "エンドポイントURL",
        signing_key: "署名キー",
        signing_key_tip: "ログトから提供されたシークレットキーをエンドポイントにリクエストヘッダーとして追加して、Webhookのペイロードの正当性を保証します。",
        regenerate: "再生成する",
        regenerate_key_title: "署名キーの再生成",
        regenerate_key_reminder: "署名キーを変更してもよろしいですか？再生成すると、すぐに有効になります。エンドポイントに同期して署名キーを変更することを忘れないでください。",
        regenerated: "署名キーが再生成されました。",
        custom_headers: "カスタムヘッダー",
        custom_headers_tip: "オプションで、Webhookのペイロードに追加のコンテキストまたはメタデータを提供するために、カスタムヘッダーを追加できます。",
        key_duplicated_error: "キーは繰り返すことはできません。",
        key_missing_error: "キーは必須です。",
        value_missing_error: "値が必要です。",
        invalid_key_error: "キーが無効です",
        invalid_value_error: "値が無効です",
        test: "テスト",
        test_webhook: "Webhookをテストする",
        test_webhook_description: "Webhookを設定し、各選択したイベントのペイロード例を使用してテストして、正しい受信と処理を確認してください。",
        send_test_payload: "テストペイロードを送信する",
        test_result: {
            endpoint_url: "エンドポイントURL：{{url}}",
            message: "メッセージ：{{message}}",
            response_status: "レスポンスステータス：{{status, number}}",
            response_body: "レスポンスボディ：{{body}}",
            request_time: "リクエスト時間：{{time}}",
            test_success: "エンドポイントへのWebhookテストは成功しました。"
        }
    }
};
var $14e796a3b0d9eabc$export$2e2bcd8739ae039 = Object.freeze($14e796a3b0d9eabc$var$webhook_details);


const $d3226665f85a2a43$var$webhooks = {
    page_title: "Webhooks",
    title: "Webhooks",
    subtitle: "特定のイベントに関するリアルタイムの更新を手軽に受け取るためにWebhookを作成します。",
    create: "Webhookを作成する",
    schemas: {
        interaction: "ユーザーインタラクション",
        user: "ユーザー",
        organization: "組織",
        role: "ロール",
        scope: "権限",
        organization_role: "組織の役割",
        organization_scope: "組織の権限"
    },
    table: {
        name: "名前",
        events: "イベント",
        success_rate: "成功率（24時間）",
        requests: "リクエスト（24時間）"
    },
    placeholder: {
        title: "Webhook",
        description: 'POSTリクエストをエンドポイントURLに送信して、リアルタイムのアップデートを受け取るWebhookを作成します。 "アカウントを作成する"、"サインインする"、"パスワードをリセットする"などのイベントを受け取って、常に最新情報を把握しましょう。',
        create_webhook: "Webhookを作成する"
    },
    create_form: {
        title: "Webhookを作成する",
        subtitle: "Webhookを追加して、エンドポイントURLにPOSTリクエストを送信し、ユーザーイベントの詳細を送信します。",
        events: "イベント",
        events_description: "LogtoがPOSTリクエストを送信するトリガーイベントを選択します。",
        name: "名前",
        name_placeholder: "Webhook名を入力してください",
        endpoint_url: "エンドポイントURL",
        endpoint_url_placeholder: "https://your.webhook.endpoint.url",
        endpoint_url_tip: "Enter the URL of your endpoint where a webhook’s payload is sent to when the event occurs.",
        create_webhook: "Webhookを作成する",
        missing_event_error: "少なくとも1つのイベントを選択する必要があります。"
    },
    webhook_created: "Webhook {{name}}が正常に作成されました。"
};
var $d3226665f85a2a43$export$2e2bcd8739ae039 = Object.freeze($d3226665f85a2a43$var$webhooks);


const $b5c03d8f2acceec2$var$welcome = {
    title: "管理者コンソールへようこそ",
    description: "管理者コンソールは、コーディングの必要がないLogtoを管理するためのWebアプリです。まずはアカウントを作成しましょう。このアカウントで自分自身または会社の代表者としてLogtoを管理することができます。",
    create_account: "アカウントを作成する"
};
var $b5c03d8f2acceec2$export$2e2bcd8739ae039 = Object.freeze($b5c03d8f2acceec2$var$welcome);


const $fb44b5317d095d5b$var$admin_console = {
    title: "Admin Console",
    admin_user: "Admin",
    system_app: "System",
    menu: $494b5c9b0867f74c$export$2e2bcd8739ae039,
    general: $d1beffd6e09aca5e$export$2e2bcd8739ae039,
    errors: $56e7f4311309fddf$export$2e2bcd8739ae039,
    tab_sections: $9895f2aa2f925d3d$export$2e2bcd8739ae039,
    tabs: $997dd4a0af3a846b$export$2e2bcd8739ae039,
    applications: $70e8f7d918147951$export$2e2bcd8739ae039,
    application_details: $bac2c818ed89de66$export$2e2bcd8739ae039,
    api_resources: $8ae794ecafb29286$export$2e2bcd8739ae039,
    api_resource_details: $8b54a90723ae2332$export$2e2bcd8739ae039,
    connectors: $b6e7bae4d4939cdd$export$2e2bcd8739ae039,
    connector_details: $7c873fac3e685b07$export$2e2bcd8739ae039,
    enterprise_sso: $618007b96ad4f33d$export$2e2bcd8739ae039,
    enterprise_sso_details: $52b4b1a5cd6a3164$export$2e2bcd8739ae039,
    get_started: $5684e02660d07c89$export$2e2bcd8739ae039,
    users: $822afd9f1b449ace$export$2e2bcd8739ae039,
    user_details: $def2975ce72e6313$export$2e2bcd8739ae039,
    contact: $be04ebabae0bf559$export$2e2bcd8739ae039,
    sign_in_exp: $0ba0096c7a87cc9e$export$2e2bcd8739ae039,
    dashboard: $f1540a1a03aec751$export$2e2bcd8739ae039,
    logs: $6df5c08d4ea3569f$export$2e2bcd8739ae039,
    log_details: $4879f3bbb04be483$export$2e2bcd8739ae039,
    session_expired: $366c1c8c696c4d5a$export$2e2bcd8739ae039,
    welcome: $b5c03d8f2acceec2$export$2e2bcd8739ae039,
    roles: $a927526ee083943a$export$2e2bcd8739ae039,
    role_details: $2882e941d5e7e087$export$2e2bcd8739ae039,
    permissions: $fcc868cd9ce1ecd2$export$2e2bcd8739ae039,
    cloud: $5a90bd1235279532$export$2e2bcd8739ae039,
    profile: $5e730d60cc40c0f0$export$2e2bcd8739ae039,
    components: $c9288b8338093d9d$export$2e2bcd8739ae039,
    webhooks: $d3226665f85a2a43$export$2e2bcd8739ae039,
    webhook_details: $14e796a3b0d9eabc$export$2e2bcd8739ae039,
    domain: $a41b7abee5d8fa76$export$2e2bcd8739ae039,
    tenants: $bfb301cf23ef073e$export$2e2bcd8739ae039,
    tenant_members: $33c6900e9ab747a9$export$2e2bcd8739ae039,
    topbar: $14ac93bbc4962591$export$2e2bcd8739ae039,
    subscription: $4345f0791210f418$export$2e2bcd8739ae039,
    upsell: $6fd6ecb2f73ac741$export$2e2bcd8739ae039,
    guide: $3a7ae0831dad21fd$export$2e2bcd8739ae039,
    mfa: $9eeb616f4b43bfc0$export$2e2bcd8739ae039,
    organizations: $0402dd03c3eb7184$export$2e2bcd8739ae039,
    organization_details: $7cdb58d35c0520d6$export$2e2bcd8739ae039,
    protected_app: $4cd53791a5b34fc4$export$2e2bcd8739ae039,
    jwt_claims: $a7b721020a61b0a9$export$2e2bcd8739ae039,
    invitation: $53019a5b1ae01e50$export$2e2bcd8739ae039,
    signing_keys: $b21993ea3701e644$export$2e2bcd8739ae039,
    organization_template: $50480ecc04b87708$export$2e2bcd8739ae039,
    organization_role_details: $be0c6731ad37b364$export$2e2bcd8739ae039
};
var $fb44b5317d095d5b$export$2e2bcd8739ae039 = Object.freeze($fb44b5317d095d5b$var$admin_console);


const $71f3be4d9a32c99d$var$demo_app = {
    title: "ライブプレビューへのサインインに成功しました！",
    subtitle: "あなたのログイン情報は以下の通りです：",
    username: "ユーザー名：",
    user_id: "ユーザーID：",
    sign_out: "ライブプレビューからサインアウトする",
    continue_explore: "または続けて探索する",
    customize_sign_in_experience: "サインイン体験のカスタマイズ",
    enable_passwordless: "パスワードレスを有効にする",
    add_social_connector: "ソーシャルコネクターを追加する"
};
var $71f3be4d9a32c99d$export$2e2bcd8739ae039 = Object.freeze($71f3be4d9a32c99d$var$demo_app);


const $8ea3c23ee4944564$var$oidc = {
    logout_success: "正常にログアウトしました。"
};
var $8ea3c23ee4944564$export$2e2bcd8739ae039 = Object.freeze($8ea3c23ee4944564$var$oidc);


const $299a3732a77f74cd$var$translation = {
    admin_console: $fb44b5317d095d5b$export$2e2bcd8739ae039,
    demo_app: $71f3be4d9a32c99d$export$2e2bcd8739ae039,
    oidc: $8ea3c23ee4944564$export$2e2bcd8739ae039
};
var $299a3732a77f74cd$export$2e2bcd8739ae039 = Object.freeze($299a3732a77f74cd$var$translation);


const $2ccc54dc338a0b7a$var$ja = {
    translation: $299a3732a77f74cd$export$2e2bcd8739ae039,
    errors: $f0eafb3eaf003f4c$export$2e2bcd8739ae039
};
var $2ccc54dc338a0b7a$export$2e2bcd8739ae039 = Object.freeze($2ccc54dc338a0b7a$var$ja);


const $2e3762b7894c9e27$var$application = {
    invalid_type: "관련 역할을 가질 수 있는 것은 기계 대 기계 응용 프로그램만 가능합니다.",
    role_exists: "역할 ID {{roleId}} 가 이미이 응용 프로그램에 추가되었습니다.",
    invalid_role_type: "사용자 유형 역할을 기계 대 기계 응용 프로그램에 할당할 수 없습니다.",
    invalid_third_party_application_type: "전통적인 웹 응용 프로그램만 제 3자 앱으로 표시할 수 있습니다.",
    third_party_application_only: "해당 기능은 제 3자 응용프로그램에만 사용할 수 있습니다.",
    user_consent_scopes_not_found: "유효하지 않은 사용자 동의 범위입니다.",
    consent_management_api_scopes_not_allowed: "管理 API 범위 허용되지 않습니다.",
    protected_app_metadata_is_required: "보호된 응용 프로그램 메타데이터가 필요합니다.",
    protected_app_not_configured: "보호된 앱 제공자가 구성되지 않았습니다. 이 기능은 오픈 소스 버전에는 사용할 수 없습니다.",
    cloudflare_unknown_error: "Cloudflare API를 요청할 때 알 수없는 오류가 발생했습니다",
    protected_application_only: "해당 기능은 보호된 응용 프로그램에만 사용할 수 있습니다.",
    protected_application_misconfigured: "보호된 응용 프로그램이 잘못 구성되었습니다.",
    protected_application_subdomain_exists: "보호된 응용 프로그램의 하위 도메인이 이미 사용 중입니다.",
    invalid_subdomain: "잘못된 하위 도메인입니다.",
    custom_domain_not_found: "사용자 정의 도메인을 찾을 수 없습니다.",
    should_delete_custom_domains_first: "먼저 사용자 정의 도메인을 삭제해야 합니다."
};
var $2e3762b7894c9e27$export$2e2bcd8739ae039 = Object.freeze($2e3762b7894c9e27$var$application);


const $94ba5f307e60dfc0$var$auth = {
    authorization_header_missing: "인증 헤더가 존재하지 않아요.",
    authorization_token_type_not_supported: "해당 인증 방법을 지원하지 않아요.",
    unauthorized: "인증되지 않았어요. 로그인 정보와 범위를 확인해 주세요.",
    forbidden: "접근이 금지되었어요. 로그인 권한과 역할을 확인해 주세요.",
    expected_role_not_found: "예상되는 역할을 찾을 수 없어요. 해당 사용자의 권한 또는 역할을 확인해 주세요.",
    jwt_sub_missing: "JWT에서 `sub`를 찾을 수 없어요.",
    require_re_authentication: "보호된 작업을 수행하려면 재인증이 필요해요."
};
var $94ba5f307e60dfc0$export$2e2bcd8739ae039 = Object.freeze($94ba5f307e60dfc0$var$auth);


const $e9c563d72432d03e$var$connector = {
    general: "커넥터에서 오류가 발생했습니다: {{errorDescription}}",
    not_found: "{{type}} 값을 가진 연동 종류를 찾을 수 없어요.",
    not_enabled: "연동이 활성화되지 않았어요.",
    invalid_metadata: "연동 메타데이터가 유효하지 않아요.",
    invalid_config_guard: "연동 설정 데이터가 유효하지 않아요.",
    unexpected_type: "예상하지 않은 연동 종류에요.",
    invalid_request_parameters: "잘못된 요청 파라미터가 있어요.",
    insufficient_request_parameters: "요청 데이터에서 일부 정보가 없어요.",
    invalid_config: "연동 설정이 유효하지 않아요.",
    invalid_certificate: "커넥터의 인증서가 유효하지 않아요. 인증서가 PEM 인코딩되었는지 확인하세요.",
    invalid_response: "연동 응답이 유효하지 않아요.",
    template_not_found: "연동 예제 설정을 찾을 수 없어요.",
    template_not_supported: "연동이 이 템플릿 타입을 지원하지 않아요.",
    rate_limit_exceeded: "트리거 주기 제한. 나중에 다시 시도하세요.",
    not_implemented: "{{method}}은 아직 구현되지 않았어요.",
    social_invalid_access_token: "연동 서비스의 Access 토큰이 유효하지 않아요.",
    invalid_auth_code: "연동 서비스의 Auth 코드가 유효하지 않아요.",
    social_invalid_id_token: "연동 서비스의 ID 토큰이 유효하지 않아요.",
    authorization_failed: "사용자의 인증 과정이 성공적으로 마무리되지 않았어요.",
    social_auth_code_invalid: "Access 토큰을 가져올 수 없어요. Authorization 코드를 확인해 주세요.",
    more_than_one_sms: "SMS 서비스는 1개만 연동되어야 해요.",
    more_than_one_email: "이메일 서비스는 1개만 연동되어야 해요.",
    more_than_one_connector_factory: "다수의 커넥터 팩토리가 발견되었습니다 (ID {{connectorIds}}). 불필요한 팩토리는 제거해주세요.",
    db_connector_type_mismatch: "종류가 일치하지 않은 연동 서비스가 DB에 존재해요.",
    not_found_with_connector_id: "주어진 연동 ID로 연동 설정을 찾을 수 없어요.",
    multiple_instances_not_supported: "선택된 연동 기준으로 여러 인스턴스를 생성할 수 없어요.",
    invalid_type_for_syncing_profile: "소셜 연동만 사용자 프로파일을 동기화 할 수 있어요.",
    can_not_modify_target: "연동 목표를 수정할 수 없어요.",
    should_specify_target: "'목표'를 반드시 지정해야 해요.",
    multiple_target_with_same_platform: "같은 목표와 플랫폼에 여러 소셜 연동을 가질 수 없어요.",
    cannot_overwrite_metadata_for_non_standard_connector: "이 연동의 메타데이터를 덮어쓸 수 없어요."
};
var $e9c563d72432d03e$export$2e2bcd8739ae039 = Object.freeze($e9c563d72432d03e$var$connector);


const $f22d0ff6f5090efe$var$domain = {
    not_configured: "도메인 호스트 이름 공급 업체가 구성되어 있지 않습니다.",
    cloudflare_data_missing: "cloudflare_data 가 없습니다. 확인하십시오.",
    cloudflare_unknown_error: "Cloudflare API 요청시 알 수 없는 오류 발생",
    cloudflare_response_error: "Cloudflare 로부터 예상치 못한 응답을 받았습니다.",
    limit_to_one_domain: "하나의 맞춤 도메인만 사용할 수 있습니다.",
    hostname_already_exists: "이 도메인은 이미 서버에 존재합니다.",
    cloudflare_not_found: "Cloudflare에서 호스트 이름을 찾을 수 없습니다.",
    domain_is_not_allowed: "이 도메인은 허용되지 않습니다."
};
var $f22d0ff6f5090efe$export$2e2bcd8739ae039 = Object.freeze($f22d0ff6f5090efe$var$domain);


const $025c0e938da2ab02$var$entity = {
    invalid_input: "입력이 잘못되었습니다. 값 목록은 비어 있을 수 없습니다.",
    create_failed: "{{name}} 생성을 실패하였어요.",
    db_constraint_violated: "데이터베이스 제약 조건 위반.",
    not_exists: "{{name}}는 존재하지 않아요.",
    not_exists_with_id: "{{id}} ID를 가진 {{name}}는 존재하지 않아요.",
    not_found: "리소스가 존재하지 않아요.",
    relation_foreign_key_not_found: "하나 이상의 외래 키를 찾을 수 없어요. 입력을 확인하고 참조된 모든 엔티티가 있는지 확인해주세요.",
    unique_integrity_violation: "엔티티가 이미 존재해요. 입력을 확인하고 다시 시도해주세요."
};
var $025c0e938da2ab02$export$2e2bcd8739ae039 = Object.freeze($025c0e938da2ab02$var$entity);


const $69ba58e581acbf2d$var$guard = {
    invalid_input: "{{type}} 요청 타입은 유효하지 않아요.",
    invalid_pagination: "요청의 Pagination 값이 유효하지 않아요.",
    can_not_get_tenant_id: "요청에서 테넌트 ID를 가져올 수 없습니다.",
    file_size_exceeded: "파일 크기가 초과되었습니다.",
    mime_type_not_allowed: "MIME 타입이 허용되지 않습니다."
};
var $69ba58e581acbf2d$export$2e2bcd8739ae039 = Object.freeze($69ba58e581acbf2d$var$guard);


const $b99f2f4f29ad058c$var$hook = {
    missing_events: "최소한 하나의 이벤트를 제공해야 합니다.",
    send_test_payload_failed: "테스트 페이로드 보내기 실패: {{message}}",
    endpoint_responded_with_error: "엔드포인트가 오류로 응답했습니다."
};
var $b99f2f4f29ad058c$export$2e2bcd8739ae039 = Object.freeze($b99f2f4f29ad058c$var$hook);


const $e4c2b51e5cf583cc$var$jwt_customizer = {
    general: "JWT 토큰을 사용자 지정하는 중에 오류가 발생했습니다. 나중에 다시 시도해주세요.",
    can_not_create_for_admin_tenant: "관리자 테넌트에 대해 JWT 토큰 사용자 지정을 만들 수 없습니다."
};
var $e4c2b51e5cf583cc$export$2e2bcd8739ae039 = Object.freeze($e4c2b51e5cf583cc$var$jwt_customizer);


const $55a6c7e0dbafbf3f$var$localization = {
    cannot_delete_default_language: "{{languageTag}} 언어는 기본 언어이므로 삭제할 수 없어요.",
    invalid_translation_structure: "유효하지 않은 데이터 스키마예요. 입력된 값을 다시 확인해 주세요."
};
var $55a6c7e0dbafbf3f$export$2e2bcd8739ae039 = Object.freeze($55a6c7e0dbafbf3f$var$localization);


const $a0559e0ea5cc4712$var$log = {
    invalid_type: "로그 종류가 유효하지 않아요."
};
var $a0559e0ea5cc4712$export$2e2bcd8739ae039 = Object.freeze($a0559e0ea5cc4712$var$log);


const $59f3ae9ca482171e$var$oidc = {
    aborted: "End 사용자가 상호 작용을 중단했어요.",
    invalid_scope: "허용되지 않은 범위: {{error_description}}.",
    invalid_token: "유효하지 않은 토큰이 제공되었어요.",
    invalid_client_metadata: "유효하지 않은 클라이언트 메타데이터가 제공되었어요.",
    insufficient_scope: "토큰에 `{{scope}}` 범위가 누락되었어요.",
    invalid_request: "요청이 유효하지 않아요.",
    invalid_grant: "승인 요청이 유효하지 않아요.",
    invalid_redirect_uri: "`redirect_uri`가 등록된 클라이언트의 `redirect_uris`와 일치하지 않아요.",
    access_denied: "접근이 금지되었어요.",
    invalid_target: "유효하지 않은 리소스 표시예요.",
    unsupported_grant_type: "지원하지 않는 `grant_type` 요청이에요.",
    unsupported_response_mode: "지원하지 않는 `response_mode` 요청이에요.",
    unsupported_response_type: "지원하지 않은 `response_type` 요청이에요.",
    provider_error: "OIDC 내부 오류: {{message}}.",
    server_error: "알 수 없는 OIDC 오류가 발생했어요. 나중에 다시 시도해주세요.",
    provider_error_fallback: "OIDC 오류가 발생했어요: {{code}}.",
    key_required: "최소한 하나의 키가 필요해요.",
    key_not_found: "ID가 {{id}}인 키를 찾을 수 없어요."
};
var $59f3ae9ca482171e$export$2e2bcd8739ae039 = Object.freeze($59f3ae9ca482171e$var$oidc);


const $4ab446ea4c85491e$var$organization = {
    require_membership: "사용자는 조직의 구성원이어야 합니다."
};
var $4ab446ea4c85491e$export$2e2bcd8739ae039 = Object.freeze($4ab446ea4c85491e$var$organization);


const $0f59bdc1c6847de3$var$password = {
    unsupported_encryption_method: "{{name}} 암호화 방법을 지원하지 않아요.",
    pepper_not_found: "비밀번호 Pepper를 찾을 수 없어요. Core 환경설정을 확인해 주세요.",
    rejected: "비밀번호가 거부되었습니다. 비밀번호가 요구 사항을 충족하는지 확인해 주세요."
};
var $0f59bdc1c6847de3$export$2e2bcd8739ae039 = Object.freeze($0f59bdc1c6847de3$var$password);


const $972b466df71bcdb4$var$request = {
    invalid_input: "입력된 값이 유효하지 않아요. {{details}}",
    general: "요청 중에 오류가 발생했어요."
};
var $972b466df71bcdb4$export$2e2bcd8739ae039 = Object.freeze($972b466df71bcdb4$var$request);


const $7458077799ddeebb$var$resource = {
    resource_identifier_in_use: "API 식별자 {{indicator}}가 이미 사용 중입니다",
    cannot_delete_management_api: "Logto 管理 API를 삭제할 수 없습니다.",
    cannot_modify_management_api: "Logto 관리 API를 수정할 수 없습니다."
};
var $7458077799ddeebb$export$2e2bcd8739ae039 = Object.freeze($7458077799ddeebb$var$resource);


const $beee6a764160ab57$var$role = {
    name_in_use: "역할 이름 {{name}}이/가 이미 사용 중이에요.",
    scope_exists: "범위 ID {{scopeId}}이/가 이미 이 역할에 추가되어 있어요.",
    management_api_scopes_not_assignable_to_user_role: "用户角色无法分配管理 API 范围。",
    user_exists: "사용자 ID {{userId}}이/가 이미 이 역할에 추가되어 있어요.",
    application_exists: "애플리케이션 ID {{applicationId}} 가 이미 이 역할에 추가되어 있어요.",
    default_role_missing: "기본 역할 이름의 일부가 데이터베이스에 존재하지 않아요. 먼저 역할을 생성해 주세요.",
    internal_role_violation: '내부 역할 위반: Logto에서 금지되는 내부 역할을 업데이트하거나 삭제하려고 할 수 있습니다. 새 역할을 만드는 경우 "#internal:"으로 시작하지 않는 다른 이름을 시도해보세요.'
};
var $beee6a764160ab57$export$2e2bcd8739ae039 = Object.freeze($beee6a764160ab57$var$role);


const $89321f48c6620154$var$scope = {
    name_exists: "범위 이름 {{name}}이/가 이미 사용 중이에요.",
    name_with_space: "범위 이름에 공백을 포함할 수 없어요."
};
var $89321f48c6620154$export$2e2bcd8739ae039 = Object.freeze($89321f48c6620154$var$scope);


const $39f7aa82949ab6cc$var$session = {
    not_found: "세션을 찾을 수 없어요. 다시 로그인해 주세요.",
    invalid_credentials: "유효하지 않은 로그인 정보예요. 입력된 값을 다시 확인해 주세요.",
    invalid_sign_in_method: "현재 로그인 방법을 지원하지 않아요.",
    invalid_connector_id: "소셜 ID {{connectorId}}를 찾을 수 없어요.",
    insufficient_info: "로그인 정보가 충분하지 않아요.",
    connector_id_mismatch: "연동 ID가 세션 정보와 일치하지 않아요.",
    connector_session_not_found: "연동 세션을 찾을 수 없어요. 다시 로그인해 주세요.",
    verification_session_not_found: "검증을 실패했어요. 검증 과정을 다시 시작하고 다시 시도해 주세요.",
    verification_expired: "연결 시간이 초과되었어요. 검증을 다시 시작하고, 계정이 안전한지 확인해 주세요.",
    verification_blocked_too_many_attempts: "Too many attempts in a short time. Please try again {{relativeTime}}.",
    unauthorized: "로그인을 먼저 해 주세요.",
    unsupported_prompt_name: "지원하지 않는 Prompt 이름이에요.",
    forgot_password_not_enabled: "비밀번호 찾기가 활성화되어있지 않아요.",
    verification_failed: "인증이 성공적으로 완료되지 않았어요. 처음부터 다시 인증 과정을 거쳐 주세요.",
    connector_validation_session_not_found: "연동 세션 유효성 검증을 위한 토큰을 찾을 수 없어요.",
    identifier_not_found: "사용자 식별자를 찾을 수 없어요. 처음부터 다시 로그인을 시도해 주세요.",
    interaction_not_found: "인터랙션 세션을 찾을 수 없어요. 처음부터 다시 세션을 시작해 주세요.",
    not_supported_for_forgot_password: "This operation is not supported for forgot password.",
    mfa: {
        require_mfa_verification: "Mfa verification is required to sign in.",
        mfa_sign_in_only: "Mfa is only available for sign-in interaction.",
        pending_info_not_found: "Pending MFA info not found, please initiate MFA first.",
        invalid_totp_code: "Invalid TOTP code.",
        webauthn_verification_failed: "WebAuthn verification failed.",
        webauthn_verification_not_found: "WebAuthn verification not found.",
        bind_mfa_existed: "MFA already exists.",
        backup_code_can_not_be_alone: "Backup code can not be the only MFA.",
        backup_code_required: "Backup code is required.",
        invalid_backup_code: "Invalid backup code.",
        mfa_policy_not_user_controlled: "MFA policy is not user controlled."
    },
    sso_enabled: "이 이메일로는 SSO가 활성화되어 있어요. SSO로 로그인해 주세요."
};
var $39f7aa82949ab6cc$export$2e2bcd8739ae039 = Object.freeze($39f7aa82949ab6cc$var$session);


const $d4f2437b60624d94$var$sign_in_experiences = {
    empty_content_url_of_terms_of_use: "이용 약관 URL이 비어 있어요. 이용 약관이 활성화되어 있다면, 이용 약관 URL를 설정해 주세요.",
    empty_social_connectors: "연동된 소셜이 없어요. 소셜 로그인을 사용한다면, 연동해 주세요.",
    enabled_connector_not_found: "활성된 {{type}} 연동을 찾을 수 없어요.",
    not_one_and_only_one_primary_sign_in_method: "반드시 하나의 메인 로그인 방법이 설정되어야 해요. 입력된 값을 확인해주세요.",
    username_requires_password: "회원가입 식별자에 대한 비밀번호 설정을 사용하도록 설정해야 해요.",
    passwordless_requires_verify: "이메일/휴대전화번호 가입 식별자에 대해 확인을 사용하도록 설정해야 해요.",
    miss_sign_up_identifier_in_sign_in: "로그인 방법에는 회원가입 ID가 포함되어야 해요.",
    password_sign_in_must_be_enabled: "회원가입 시 비밀번호를 설정해야 할 경우 비밀번호 로그인을 사용하도록 설정해야 해요.",
    code_sign_in_must_be_enabled: "비밀번호를 설정할 필요가 없을 때는 인증 코드 로그인을 활성화해야 해요.",
    unsupported_default_language: "{{language}} 언어는 아직 지원하지 않아요.",
    at_least_one_authentication_factor: "최소한 하나의 인증 방법을 선택해야 해요.",
    backup_code_cannot_be_enabled_alone: "백업 코드는 단독으로 활성화할 수 없습니다.",
    duplicated_mfa_factors: "중복된 MFA 인증 요소입니다."
};
var $d4f2437b60624d94$export$2e2bcd8739ae039 = Object.freeze($d4f2437b60624d94$var$sign_in_experiences);


const $ac58d583b36bac86$var$single_sign_on = {
    forbidden_domains: "공개 이메일 도메인은 허용되지 않습니다.",
    duplicated_domains: "중복된 도메인이 있습니다.",
    invalid_domain_format: "도메인 형식이 잘못되었습니다.",
    duplicate_connector_name: "커넥터 이름이 이미 존재합니다. 다른 이름을 선택해 주세요."
};
var $ac58d583b36bac86$export$2e2bcd8739ae039 = Object.freeze($ac58d583b36bac86$var$single_sign_on);


const $495e7963efb09328$var$storage = {
    not_configured: "저장소 공급자가 구성되지 않았습니다.",
    missing_parameter: "저장소 공급자에 대한 누락된 매개변수 {{parameter}}.",
    upload_error: "파일을 저장소 공급자에 업로드하지 못했습니다."
};
var $495e7963efb09328$export$2e2bcd8739ae039 = Object.freeze($495e7963efb09328$var$storage);


const $8894ae23de9ca61b$var$subscription = {
    limit_exceeded: "당신은 구독 플랜 한도에 도달하였습니다.",
    get_plan_failed: "임차인에 대한 구독 플랜을 가져올 수 없습니다.",
    tenant_suspended: "임차인이 정지되었습니다. 관리자에게 문의하십시오."
};
var $8894ae23de9ca61b$export$2e2bcd8739ae039 = Object.freeze($8894ae23de9ca61b$var$subscription);


const $bef720d70e866a91$var$swagger = {
    invalid_zod_type: "유효하지 않은 Zod 종류에요. Route Guard 설정을 확인해 주세요.",
    not_supported_zod_type_for_params: "지원되지 않는 Zod 종류예요. Route Guard 설정을 확인해 주세요."
};
var $bef720d70e866a91$export$2e2bcd8739ae039 = Object.freeze($bef720d70e866a91$var$swagger);


const $e1f1c727abb01ed6$var$user = {
    username_already_in_use: "이 사용자 이름은 다른 사람이 이미 사용 중이에요.",
    email_already_in_use: "이 이메일은 다른 계정에서 이미 사용 중이에요.",
    phone_already_in_use: "이 휴대전화번호는 다른 계정에서 이미 사용 중이에요.",
    invalid_email: "유효하지 않은 이메일이에요.",
    invalid_phone: "유효하지 않은 휴대전화번호예요.",
    email_not_exist: "이메일 주소가 아직 등록되지 않았어요.",
    phone_not_exist: "휴대전화번호가 아직 등록되지 않았어요.",
    identity_not_exist: "소셜 계정이 아직 등록되지 않았어요.",
    identity_already_in_use: "소셜 계정이 이미 등록되어 있어요.",
    social_account_exists_in_profile: "이 소셜 계정은 이미 연동되어 있습니다.",
    cannot_delete_self: "자기 자신을 삭제할 수 없어요.",
    sign_up_method_not_enabled: "이 회원가입 방법은 활성화되어있지 않아요.",
    sign_in_method_not_enabled: "이 로그인 방법은 활성화되어있지 않아요.",
    same_password: "새로운 비밀번호는 이전 비밀번호와 같으면 안 돼요.",
    password_required_in_profile: "로그인 전에 비밀번호를 설정해야 해요.",
    new_password_required_in_profile: "새로운 비밀번호를 설정해야 해요.",
    password_exists_in_profile: "이미 비밀번호가 설정되어 있어요.",
    username_required_in_profile: "로그인 전에 사용자 이름을 설정해야 해요.",
    username_exists_in_profile: "이미 사용자 이름이 설정되어 있어요.",
    email_required_in_profile: "로그인 전에 이메일 주소를 설정해야 해요.",
    email_exists_in_profile: "이미 이메일 주소가 설정되어 있어요.",
    phone_required_in_profile: "로그인 전에 휴대전화번호를 설정해야 해요.",
    phone_exists_in_profile: "이미 휴대전화번호가 설정되어 있어요.",
    email_or_phone_required_in_profile: "로그인 전에 이메일 주소 또는 휴대전화번호를 설정해야 해요.",
    suspended: "이 계정은 일시 정지되었어요.",
    user_not_exist: "{{identifier}}의 사용자가 아직 등록되지 않았어요.",
    missing_profile: "로그인 전에 추가 정보를 제공해야 해요.",
    role_exists: "역할 ID {{roleId}}은/는 이미 이 사용자에게 할당되어 있어요.",
    invalid_role_type: "유효하지 않은 역할 유형입니다. 사용자에게 기계 대 기계 역할을 할당할 수 없습니다.",
    missing_mfa: "You need to bind additional MFA before signing-in.",
    totp_already_in_use: "TOTP is already in use.",
    backup_code_already_in_use: "Backup code is already in use.",
    password_algorithm_required: "비밀번호 알고리즘이 필요합니다.",
    password_and_digest: "You cannot set both plain text password and password digest."
};
var $e1f1c727abb01ed6$export$2e2bcd8739ae039 = Object.freeze($e1f1c727abb01ed6$var$user);


const $84e62814218fcdd3$var$verification_code = {
    phone_email_empty: "전화번호와 이메일이 모두 비어 있어요.",
    not_found: "인증 코드를 찾을 수 없어요. 인증 코드를 먼저 요청하세요.",
    phone_mismatch: "전화번호가 맞지 않아요. 새 인증 코드를 요청해 주세요.",
    email_mismatch: "이메일이 맞지 않아요. 새 인증 코드를 요청해 주세요.",
    code_mismatch: "인증 코드가 일치하지 않아요.",
    expired: "인증 코드가 만료되었어요. 새 인증 코드를 요청해 주세요.",
    exceed_max_try: "인증 코드 재시도 한도에 도달했어요. 새 인증 코드를 요청해 주세요."
};
var $84e62814218fcdd3$export$2e2bcd8739ae039 = Object.freeze($84e62814218fcdd3$var$verification_code);


const $2a1c2b8e7652736e$var$errors = {
    request: $972b466df71bcdb4$export$2e2bcd8739ae039,
    auth: $94ba5f307e60dfc0$export$2e2bcd8739ae039,
    guard: $69ba58e581acbf2d$export$2e2bcd8739ae039,
    oidc: $59f3ae9ca482171e$export$2e2bcd8739ae039,
    user: $e1f1c727abb01ed6$export$2e2bcd8739ae039,
    password: $0f59bdc1c6847de3$export$2e2bcd8739ae039,
    session: $39f7aa82949ab6cc$export$2e2bcd8739ae039,
    connector: $e9c563d72432d03e$export$2e2bcd8739ae039,
    verification_code: $84e62814218fcdd3$export$2e2bcd8739ae039,
    sign_in_experiences: $d4f2437b60624d94$export$2e2bcd8739ae039,
    jwt_customizer: $e4c2b51e5cf583cc$export$2e2bcd8739ae039,
    localization: $55a6c7e0dbafbf3f$export$2e2bcd8739ae039,
    swagger: $bef720d70e866a91$export$2e2bcd8739ae039,
    entity: $025c0e938da2ab02$export$2e2bcd8739ae039,
    log: $a0559e0ea5cc4712$export$2e2bcd8739ae039,
    role: $beee6a764160ab57$export$2e2bcd8739ae039,
    scope: $89321f48c6620154$export$2e2bcd8739ae039,
    storage: $495e7963efb09328$export$2e2bcd8739ae039,
    resource: $7458077799ddeebb$export$2e2bcd8739ae039,
    hook: $b99f2f4f29ad058c$export$2e2bcd8739ae039,
    domain: $f22d0ff6f5090efe$export$2e2bcd8739ae039,
    subscription: $8894ae23de9ca61b$export$2e2bcd8739ae039,
    application: $2e3762b7894c9e27$export$2e2bcd8739ae039,
    organization: $4ab446ea4c85491e$export$2e2bcd8739ae039,
    single_sign_on: $ac58d583b36bac86$export$2e2bcd8739ae039
};
var $2a1c2b8e7652736e$export$2e2bcd8739ae039 = Object.freeze($2a1c2b8e7652736e$var$errors);


const $909a25dd6304e2d7$var$api_resource_details = {
    page_title: "API 리소스 세부 정보",
    back_to_api_resources: "API 리소스로 돌아가기",
    general_tab: "일반",
    permissions_tab: "권한",
    settings: "설정",
    settings_description: "API 리소스(리소스 표시기) - 요청할 대상 서비스 또는 리소스(일반적으로 리소스의 ID를 나타내는 URI 형식 변수)를 나타냅니다.",
    management_api_settings_description: "Logto 관리 API는 관리자가 다양한 ID 관련 작업을 관리하고 보안 정책을 시행하며 규정 및 표준을 준수할 수 있도록 하는 포괄적인 API 컬렉션입니다.",
    management_api_notice: "이 API는 Logto 엔터티를 나타내며 수정 또는 삭제할 수 없습니다. Logto 관리 API를 호출하려면 머신 투 머신 앱을 만드십시오. <a>자세히 알아보기</a>",
    token_expiration_time_in_seconds: "토큰 만료 시간 (초)",
    token_expiration_time_in_seconds_placeholder: "토큰 만료 시간을 입력해주세요",
    delete_description: '이 동작은 취소할 수 없습니다. 해당 API 리소스는 영원히 삭제됩니다. 삭제를 위해 API 리소스 이름 "<span>{{name}}</span>"을 입력해주세요.',
    enter_your_api_resource_name: "API 리소스 이름을 입력해주세요.",
    api_resource_deleted: "{{name}} API 리소스가 성공적으로 삭제되었습니다.",
    permission: {
        create_button: "권한 생성",
        create_title: "권한 생성",
        create_subtitle: "이 API에 필요한 권한을 정의합니다.",
        confirm_create: "권한 생성",
        edit_title: "권한 편집",
        edit_subtitle: "Define the permissions (scopes) needed by the {{resourceName}} API.",
        name: "권한 이름",
        name_placeholder: "read:resource",
        forbidden_space_in_name: "권한 이름에는 공백을 포함할 수 없습니다.",
        description: "설명",
        description_placeholder: "리소스를 볼 수 있는 권한",
        permission_created: "{{name}} 권한이 성공적으로 생성되었습니다.",
        delete_description: "이 권한이 삭제되면, 해당 권한을 가진 사용자는 해당 권한으로 인해 부여받은 접근 권한을 상실하게 됩니다.",
        deleted: '권한 "{{name}}"이 성공적으로 삭제되었습니다.'
    }
};
var $909a25dd6304e2d7$export$2e2bcd8739ae039 = Object.freeze($909a25dd6304e2d7$var$api_resource_details);


const $418fd2c168428ab1$var$api_resources = {
    page_title: "API 리소스",
    title: "API 리소스",
    subtitle: "인증된 어플리케이션에서 사용될 API를 정의해주세요.",
    create: "API 리소스 생성",
    api_name: "API 이름",
    api_name_placeholder: "API 이름 입력",
    api_identifier: "API Identifier",
    api_identifier_placeholder: "https://your-api-identifier/",
    api_identifier_tip: "API 리소스에 대한 고유한 식별자예요. 절대 URI여야 하며 조각 (#) 컴포넌트가 없어야 해요. OAuth 2.0의 <a>resource parameter</a>와 같아요.",
    default_api: "Default API",
    default_api_label: "테넌트 당 기본 API는 0개 또는 1개만 지정 할 수 있어요. 기본 API가 지정되면 인증 요청에서 리소스 매개 변수를 생략할 수 있어요. 이후 토큰 교환이 기본적으로 대상에 해당하는 API를 사용하여 수행되어 JWT가 발급되어요. <a>자세히 알아보기</a>",
    api_resource_created: "{{name}} API 리소스가 성공적으로 생성되었어요.",
    invalid_resource_indicator_format: "API indicator must be a valid absolute URI."
};
var $418fd2c168428ab1$export$2e2bcd8739ae039 = Object.freeze($418fd2c168428ab1$var$api_resources);


const $e7a08b3684fcd75e$var$application_details = {
    page_title: "애플리케이션 세부 정보",
    back_to_applications: "어플리케이션으로 돌아가기",
    check_guide: "가이드 확인",
    settings: "설정",
    settings_description: 'An "Application" is a registered software or service that can access user info or act for a user. Applications help recognize who’s asking for what from Logto and handle the sign-in and permission. Fill in the required fields for authentication.',
    integration: "통합",
    integration_description: "로그토에서 클라우드플레어의 엣지 네트워크로 구동되는 안전한 워커를 사용하여 세계적인 최고 수준의 성능 및 전 세계 0ms의 차가운 시작을 구동합니다.",
    service_configuration: "서비스 구성",
    service_configuration_description: "서비스에서 필요한 구성을 완료하세요.",
    session: "세션",
    endpoints_and_credentials: "엔드포인트 및 자격증명",
    endpoints_and_credentials_description: "이 어플리케이션에서 OIDC 연결 설정을 위해 다음 엔드포인트 및 자격증명을 사용하세요.",
    refresh_token_settings: "Refresh 토큰",
    refresh_token_settings_description: "이 어플리케이션을 위한 Refresh 토큰 규칙을 관리하세요.",
    application_roles: "역할",
    machine_logs: "기계 로그",
    application_name: "어플리케이션 이름",
    application_name_placeholder: "나의 앱",
    description: "설명",
    description_placeholder: "어플리케이션 설명을 적어주세요.",
    config_endpoint: "OpenID Provider 구성 엔드포인트",
    authorization_endpoint: "인증 엔드포인트",
    authorization_endpoint_tip: "인증 및 권한 부여를 진행할 엔드포인트입니다. OpenID Connect <a>인증</a>에서 사용되었던 값입니다.",
    show_endpoint_details: "엔드포인트 세부 정보 표시",
    hide_endpoint_details: "엔드포인트 세부 정보 숨기기",
    logto_endpoint: "로그토 엔드포인트",
    application_id: "앱 ID",
    application_id_tip: '일반적으로 로그토에서 생성되는 고유한 애플리케이션 식별자입니다. OpenID Connect에서 "<a>client_id</a>"의 약어입니다.',
    application_secret: "앱 시크릿",
    redirect_uri: "리디렉트 URI",
    redirect_uris: "리디렉트 URIs",
    redirect_uri_placeholder: "https://your.website.com/app",
    redirect_uri_placeholder_native: "io.logto://callback",
    redirect_uri_tip: "사용자 로그인 후 리디렉트될 URI 경로입니다. 더 자세한 정보는 OpenID Connect <a>인증 요청</a>을 참조하세요.",
    post_sign_out_redirect_uri: "로그아웃 후 리디렉트 URI",
    post_sign_out_redirect_uris: "로그아웃 후 리디렉트 URIs",
    post_sign_out_redirect_uri_placeholder: "https://your.website.com/home",
    post_sign_out_redirect_uri_tip: "로그아웃 후 리디렉트될 URI 경로입니다 (선택 사항). 일부 앱에서는 실제로 작동하지 않을 수 있습니다.",
    cors_allowed_origins: "CORS 허용 오리진",
    cors_allowed_origins_placeholder: "https://your.website.com",
    cors_allowed_origins_tip: "기본적으로 모든 리디렉트 오리진들이 허용됩니다. 일반적으로 이 값을 변경할 필요가 없습니다. 더 자세한 정보는 <a>MDN 문서</a>를 확인하세요.",
    token_endpoint: "토큰 엔드포인트",
    user_info_endpoint: "사용자 정보 엔드포인트",
    enable_admin_access: "관리자 접근 활성화",
    enable_admin_access_label: "관리 API에 대한 접근을 활성화 또는 비활성화할 수 있습니다. 활성화하면, 이 애플리케이션에서 Access 토큰을 통해 관리 API를 사용할 수 있습니다.",
    always_issue_refresh_token: "항상 Refresh 토큰 발급",
    always_issue_refresh_token_label: "다음 구성을 활성화하면 Logto가 인증 요청에 `prompt=consent`가 제시되었는지 여부와 상관없이 항상 Refresh 토큰을 발급할 수 있게 됩니다. 그러나 OpenID Connect와 호환되지 않을 수 있으므로 필요하지 않은 경우에는 이 방식을 권장하지 않습니다.",
    refresh_token_ttl: "Refresh 토큰 수명 (일)",
    refresh_token_ttl_tip: "새로운 Access 토큰을 요청할 수 있는 Refresh 토큰의 기간입니다. 토큰 요청 시 Refresh 토큰의 수명이 이 값으로 연장됩니다.",
    rotate_refresh_token: "Refresh 토큰 회전",
    rotate_refresh_token_label: "활성화하면, 원래 TTL 중 70%가 지난 후 또는 특정 조건이 충족되면 Refresh 토큰 요청에 대해 새로운 Refresh 토큰을 발행합니다. <a>자세히 보기</a>",
    delete_description: "이 행동은 취소할 수 없습니다. 애플리케이션을 영구적으로 삭제할 것입니다. 삭제를 진행하려면 <span>{{name}}</span>를 입력하세요.",
    enter_your_application_name: "어플리케이션 이름을 입력하세요.",
    application_deleted: "{{name}} 애플리케이션이 성공적으로 삭제되었습니다.",
    redirect_uri_required: "최소 하나의 리디렉트 URI를 반드시 입력해야 합니다.",
    app_domain_description_1: "Feel free to use your domain with {{domain}} powered by Logto, which is permanently valid.",
    app_domain_description_2: "Feel free to utilize your domain <domain>{{domain}}</domain> which is permanently valid.",
    custom_rules: "사용자 인증규칙",
    custom_rules_placeholder: "^/(admin|privacy)/.+$",
    custom_rules_description: "사용자 인증이 필요한 라우트에 대한 정규 표현식 규칙을 설정하세요. 기본값: 비어있을 경우 전체 사이트 보호.",
    authentication_routes: "인증 라우트",
    custom_rules_tip: "다음의 두 가지 케이스를 보여드립니다:<ol><li>'/admin' 및 '/privacy' 라우트만 사용자 인증으로 보호하는 경우: ^/(admin|privacy)/.*</li><li>JPG 이미지를 제외한 경우: ^(?!.*\\.jpg$).*$</li></ol>",
    authentication_routes_description: "지정된 라우트를 사용하여 인증 버튼을 리디렉션합니다. 참고: 이 라우트들은 변경할 수 없습니다.",
    protect_origin_server: "원본 서버 보호",
    protect_origin_server_description: "원본 서버를 직접 액세스로부터 보호하세요. 더 많은 <a>자세한 지침</a>을 위해 안내서를 참조하세요.",
    session_duration: "세션 기간 (일)",
    try_it: "해보기",
    branding: {
        name: "브랜딩",
        description: "동의 화면에서 앱의 표시 이름과 로고를 사용자 정의하세요.",
        more_info: "추가 정보",
        more_info_description: "동의 화면에서 사용자에게 앱에 대한 자세한 정보를 제공하세요.",
        display_name: "표시 이름",
        display_logo: "표시 로고",
        display_logo_dark: "표시 로고 (어두운 버전)",
        terms_of_use_url: "애플리케이션 이용 약관 URL",
        privacy_policy_url: "애플리케이션 개인정보 보호정책 URL"
    },
    permissions: {
        name: "권한",
        description: "제3자 애플리케이션이 사용자 인증 특정 데이터 유형에 액세스하기 위해 필요한 권한을 선택하세요.",
        user_permissions: "개인 사용자 데이터",
        organization_permissions: "조직 액세스",
        table_name: "권한 부여",
        field_name: "권한",
        field_description: "동의 화면에서 표시됨",
        delete_text: "권한 제거",
        permission_delete_confirm: "이 작업은 제3자 앱에 부여된 권한을 취소하여 특정 데이터 유형에 대한 사용자 권한 요청을 막습니다. 계속 진행하시겠습니까?",
        permissions_assignment_description: "제3자 애플리케이션이 특정 데이터 유형에 액세스하기 위해 사용자에게 요청하는 권한을 선택하세요.",
        user_profile: "사용자 데이터",
        api_permissions: "API 권한",
        organization: "조직 권한",
        user_permissions_assignment_form_title: "사용자 프로필 권한 추가",
        organization_permissions_assignment_form_title: "조직 권한 추가",
        api_resource_permissions_assignment_form_title: "API 리소스 권한 추가",
        user_data_permission_description_tips: '개인 사용자 데이터 권한에 대한 설명을 "사용자 경험 > 콘텐츠 > 언어 관리"를 통해 수정할 수 있습니다.',
        permission_description_tips: "Logto가 제3자 앱의 인증을 위해 Identity Provider (IdP)로 사용되고 사용자가 권한을 요청하면, 이 설명이 동의 화면에 나타납니다.",
        user_title: "사용자",
        user_description: "제3자 앱에서 특정 사용자 데이터에 액세스하려는 권한을 선택하세요.",
        grant_user_level_permissions: "사용자 데이터의 권한 부여",
        organization_title: "조직",
        organization_description: "제3자 앱에서 특정 조직 데이터에 액세스하려는 권한을 선택하세요.",
        grant_organization_level_permissions: "조직 데이터의 권한 부여"
    },
    roles: {
        name_column: "역할",
        description_column: "설명",
        assign_button: "역할 할당",
        delete_description: "이 작업은 이 장치 간 앱에서이 역할을 제거합니다. 역할 자체는 여전히 존재하지만 이 장치 간 앱과 관련이 없어집니다.",
        deleted: "{{name}} 가 성공적으로 삭제되었습니다.",
        assign_title: "{{name}} 에 역할 할당",
        assign_subtitle: "{{name}} 에게 하나 이상의 역할을 할당하세요.",
        assign_role_field: "역할 할당",
        role_search_placeholder: "역할 이름으로 검색",
        added_text: "{{value, number}} 추가됨",
        assigned_app_count: "{{value, number}} 개의 애플리케이션",
        confirm_assign: "역할 할당",
        role_assigned: "역할이 성공적으로 할당되었습니다.",
        search: "역할 이름, 설명 또는 ID로 검색",
        empty: "사용 가능한 역할이 없습니다."
    }
};
var $e7a08b3684fcd75e$export$2e2bcd8739ae039 = Object.freeze($e7a08b3684fcd75e$var$application_details);


const $99ab39a4b5160849$var$applications = {
    page_title: "어플리케이션",
    title: "어플리케이션",
    subtitle: "인증에 Logto를 사용할 모바일, 단일 페이지, Machine-to-Machine 또는 기존 어플리케이션을 설정할 수 있어요.",
    subtitle_with_app_type: "내 {{name}} 어플리케이션에 대한 Logto 인증 설정",
    create: "어플리케이션 생성",
    create_subtitle_third_party: "Logto를 사용하여 쉽게 서드파티 앱과 통합할 수 있는 식별 공급자(IdP)로 사용하세요",
    application_name: "어플리케이션 이름",
    application_name_placeholder: "나의 앱",
    application_description: "어플리케이션 설명",
    application_description_placeholder: "어플리케이션 설명을 입력해주세요.",
    select_application_type: "어플리케이션 종류 선택",
    no_application_type_selected: "어플리케이션 종류를 선택하지 않았어요.",
    application_created: "어플리케이션이 성공적으로 생성되었어요.",
    tab: {
        my_applications: "내 어플리케이션",
        third_party_applications: "서드파티 앱"
    },
    app_id: "앱 식별자",
    type: {
        native: {
            title: "네이티브 앱",
            subtitle: "네이티브 환경에서 작동하는 어플리케이션",
            description: "예) iOS, Android 앱"
        },
        spa: {
            title: "싱글 페이지 앱",
            subtitle: "웹 브라우저에서 동작하며 한 페이지에서 유동적으로 업데이트되는 웹",
            description: "예) React DOM, Vue 앱"
        },
        traditional: {
            title: "전통적인 웹",
            subtitle: "서버를 통해 웹 페이지가 업데이트되는 앱",
            description: "예) JSP, PHP"
        },
        machine_to_machine: {
            title: "기계 간 앱",
            subtitle: "직접 리소스에 액세스하는 앱(서비스)",
            description: "예) 백엔드 서비스"
        },
        protected: {
            title: "보호된 앱",
            subtitle: "Logto로 보호되는 앱",
            description: "N/A"
        },
        third_party: {
            title: "서드파티 앱",
            subtitle: "서드파티 IdP 커넥터로 사용되는 앱",
            description: "예: OIDC, SAML"
        }
    },
    placeholder_title: "어플리케이션 유형을 선택하여 계속하세요",
    placeholder_description: "Logto는 OIDC용 앱 엔티티를 사용하여 앱 식별, 로그인 관리 및 감사 로그 생성과 같은 작업을 지원합니다.",
    m2m_role_assignment: {
        title: "권한을 위해 기계 간 역할로 앱을 인증합니다",
        subtitle: "기계 간 애플리케이션은 인증된 기계 간 역할이 필요합니다.",
        role_creation_hint: "적절한 머신 투 머신 역할을 찾을 수 없습니까? <a>머신 투 머신 역할 만들기</a>"
    }
};
var $99ab39a4b5160849$export$2e2bcd8739ae039 = Object.freeze($99ab39a4b5160849$var$applications);


const $394d8b00aa8b2385$var$cloud = {
    general: {
        onboarding: "온보딩"
    },
    welcome: {
        page_title: "환영합니다",
        title: "Logto Cloud 에 오신 것을 환영합니다! 조금 더 알고 싶어요.",
        description: "당신에 대해 더 잘 파악하여 Logto 경험을 특별하게 만들어 드릴게요. 정보는 저희가 안전하게 관리해요.",
        project_field: "Logto 를 아래의 목적으로 사용해요",
        project_options: {
            personal: "개인 프로젝트",
            company: "기업 프로젝트"
        },
        company_name_field: "회사 이름",
        company_name_placeholder: "Acme.co",
        stage_field: "지금까지 당신의 제품은 어떤 단계에 있나요?",
        stage_options: {
            new_product: "새로운 프로젝트를 시작하고 빠르고 편리한 솔루션을 찾고 있어요",
            existing_product: "현재 인증을 이전하려고 합니다 (예: 자체 구축, Auth0, Cognito, Microsoft)",
            target_enterprise_ready: "큰 고객들을 얻었으니 제품을 기업에 판매할 준비를 하고 있어요"
        },
        additional_features_field: "알려주고 싶은 다른 사항이 있으세요?",
        additional_features_options: {
            customize_ui_and_flow: "내 UI를 직접 구축하고 관리하려고 하지만 Logto의 미리 구축되고 사용자 정의 가능한 솔루션을 사용하지 않는다",
            compliance: "SOC2와 GDPR가 필수 사항이에요",
            export_user_data: "Logto 에서 사용자 데이터를 내보낼 수 있는 기능이 필요해요",
            budget_control: "매우 엄격한 예산 통제가 있어요",
            bring_own_auth: "내장 인증 서비스가 있고 Logto 기능만 필요해요",
            others: "위에 나열된 것 중에 없어요"
        }
    },
    sie: {
        page_title: "로그인 환경 변경하기",
        title: "먼저 로그인 환경을 간편하게 사용자화해 보세요.",
        inspire: {
            title: "흥미로운 예시 만들기",
            description: '로그인 환경에 대해 확신이 서지 않으시나요? "영감을 주세요"를 클릭하고 마법을 일으켜 보세요!',
            inspire_me: "영감을 주세요"
        },
        logo_field: "앱 로고",
        color_field: "브랜드 색상",
        identifier_field: "식별자",
        identifier_options: {
            email: "이메일",
            phone: "휴대전화",
            user_name: "사용자 이름"
        },
        authn_field: "인증",
        authn_options: {
            password: "비밀번호",
            verification_code: "인증 코드"
        },
        social_field: "소셜 로그인",
        finish_and_done: "완료하고 넘어가기",
        preview: {
            mobile_tab: "모바일",
            web_tab: "웹"
        },
        connectors: {
            unlocked_later: "나중에 잠금 해제",
            unlocked_later_tip: "등록 절차를 완료하고 제품에 가입하면 더 많은 소셜 로그인 방법에 액세스할 수 있습니다.",
            notice: "데모 연동을 실제 운영 목적으로 사용하지 마세요. 테스트를 완료한 후에는 데모 연동을 삭제하고 자격 증명을 사용하여 고유한 연동을 설정하세요."
        }
    },
    socialCallback: {
        title: "성공적으로 로그인했어요",
        description: "소셜 계정을 사용하여 로그인에 성공했어요. Logto의 모든 기능을 원활하게 통합하고 접근하려면 당신의 소셜 연동을 구성하는 것이 좋습니다."
    },
    tenant: {
        create_tenant: "테넌트 생성하기"
    }
};
var $394d8b00aa8b2385$export$2e2bcd8739ae039 = Object.freeze($394d8b00aa8b2385$var$cloud);


const $5d8d0e85d30739c8$var$components = {
    uploader: {
        action_description: "드래그 앤 드롭 또는 탐색하기",
        uploading: "업로드 중...",
        image_limit: "{{size, number}}KB 미만의 {{extensions, list(style: narrow; type: conjunction;)}} 파일만 업로드하세요.",
        error_upload: "오류가 발생했습니다. 파일 업로드에 실패하였습니다.",
        error_file_size: "파일 크기가 너무 커요. {{size, number}}KB 미만의 파일을 업로드해 주세요.",
        error_file_type: "지원되지 않는 파일 유형이에요. {{extensions, list(style: narrow; type: conjunction;)}} 파일만 사용 가능해요.",
        error_file_count: "파일은 1개만 업로드 가능합니다."
    }
};
var $5d8d0e85d30739c8$export$2e2bcd8739ae039 = Object.freeze($5d8d0e85d30739c8$var$components);


const $5338e9a1b24f85fc$var$connector_details = {
    page_title: "커넥터 세부 정보",
    back_to_connectors: "연동으로 돌아가기",
    check_readme: "README 확인",
    settings: "일반 설정",
    settings_description: "Logto에서 연동은 중요한 역할을 해요. 연동 시스템을 통하여, 사용자들에게 비밀번호 없이 회원 가입을 하고 로그인을 할 수 있게 하거나, 소셜 계정을 통하여 로그인을 할 수 있게 도와줘요.",
    parameter_configuration: "매개변수 설정",
    test_connection: "테스트",
    save_error_empty_config: "설정을 입력해 주세요.",
    send: "보내기",
    send_error_invalid_format: "유효하지 않은 입력",
    edit_config_label: "여기에 JSON을 입력해 주세요.",
    test_email_sender: "이메일 연동 테스트",
    test_sms_sender: "SMS 연동 테스트",
    test_email_placeholder: "john.doe@example.com",
    test_sms_placeholder: "+82 10-1234-5678",
    test_message_sent: "테스트 메세지 전송 완료",
    test_sender_description: 'Logto는 "Generic" 템플릿을 사용하여 테스트합니다. 커넥터가 올바르게 구성되면 메시지를 받게 됩니다.',
    options_change_email: "이메일 연동 수정",
    options_change_sms: "SMS 연동 수정",
    connector_deleted: "연동이 성공적으로 제거되었어요.",
    type_email: "이메일 연동",
    type_sms: "SMS 연동",
    type_social: "소셜 연동",
    in_used_social_deletion_description: "이 연동은 로그인 경험에서 사용 중이에요. 삭제하면 로그인 경험 설정에서 <name/> 로그인 경험이 삭제됩니다. 나중에 되돌리려면 다시 구성해야 해요.",
    in_used_passwordless_deletion_description: "{name}}은/는 로그인 경험에서 사용 중이에요. 삭제하면 충돌을 해결할 때까지 로그인 환경이 제대로 작동하지 않을 거예요. 나중에 되돌리려면 다시 구성해야 해요.",
    deletion_description: "이 연동을 삭제하려고 하고 있어요. 이 작업은 돌이킬 수 없으며, 나중에 되돌리려면 다시 구성해야 해요.",
    logto_email: {
        total_email_sent: "전체 이메일 발송: {{value, number}}",
        total_email_sent_tip: "Logto 에서 안전하고 안정적인 내장형 이메일을 위해 SendGrid 를 사용합니다. 완전 무료로 사용할 수 있습니다. <a>자세히 알아보기</a>",
        email_template_title: "이메일 템플릿",
        template_description: "내장형 이메일은 기본 템플릿을 사용하여 검증 이메일을 원활하게 전달합니다. 구성이 필요하지 않으며, 기본 브랜드 정보를 사용자 정의할 수 있습니다.",
        template_description_link_text: "템플릿 보기",
        description_action_text: "템플릿 보기",
        from_email_field: "보내는 이메일",
        sender_name_field: "보내는 사람 이름",
        sender_name_tip: '이메일의 보내는 사람 이름을 사용자 정의합니다. 비워 두면 기본 이름으로 "Verification" 이 사용됩니다.',
        sender_name_placeholder: "보내는 사람 이름을 입력해주세요.",
        company_information_field: "회사 정보",
        company_information_description: "이메일 하단에 회사 이름, 주소 또는 우편번호를 표시하여 신뢰성을 높입니다.",
        company_information_placeholder: "회사의 기본 정보",
        app_logo_field: "앱 로고",
        app_logo_tip: "이메일 상단에 브랜드 로고를 표시합니다. 라이트 모드와 다크 모드에 모두 동일한 이미지를 사용합니다.",
        urls_not_allowed: "URL은 허용되지 않습니다.",
        test_notes: 'Logto는 "Generic" 템플릿을 사용하여 테스트합니다.'
    }
};
var $5338e9a1b24f85fc$export$2e2bcd8739ae039 = Object.freeze($5338e9a1b24f85fc$var$connector_details);


const $56242fe7cfaad683$var$connectors = {
    page_title: "연동",
    title: "연동",
    subtitle: "연동을 통해 비밀번호 없는 로그인이나 소셜 로그인을 제공해 보세요.",
    create: "소셜 연동 추가",
    config_sie_notice: "새로운 연동이 설정되었어요. 다음 링크에서 설정을 마무리해 주세요. <a>{{link}}</a>.",
    config_sie_link_text: "로그인 경험",
    tab_email_sms: "이메일/SMS 연동",
    tab_social: "소셜 연동",
    connector_name: "연동 이름",
    demo_tip: "이 데모 연동에 허용되는 최대 메시지 수는 100개로 제한되며 실제 운영 환경에서의 배포에는 권장되지 않아요.",
    social_demo_tip: "데모 연동은 데모 전용으로 설계되었으며 실제 운영 환경에 배포하는 것은 권장되지 않습니다.",
    connector_type: "종류",
    connector_status: "로그인 경험",
    connector_status_in_use: "사용 중",
    connector_status_not_in_use: "사용 중이 아님",
    not_in_use_tip: {
        content: "사용 중이 아님은 로그인 환경에서 이 로그인 방법을 사용하지 않았음을 의미해요. <a>{{link}}</a> 이 로그인 방법을 추가해주세요.",
        go_to_sie: "로그인 경험으로 가서"
    },
    placeholder_title: "소셜 연동",
    placeholder_description: "Logto는 널리 사용되는 다양한 소셜 로그인 커넥터를 제공하고 있으며, 표준 프로토콜을 사용하여 자신만의 커넥터를 만들 수도 있어요.",
    save_and_done: "저장 및 완료",
    type: {
        email: "이메일 연동",
        sms: "SMS 연동",
        social: "소셜 연동"
    },
    setup_title: {
        email: "이메일 연동 설정",
        sms: "SMS 연동 설정",
        social: "소셜 연동 추가 및 설정"
    },
    guide: {
        subtitle: "단계별 가이드를 따라 연동해 주세요.",
        general_setting: "일반 설정",
        parameter_configuration: "매개변수 설정",
        test_connection: "연결 테스트",
        name: "소셜 로그인 버튼 이름",
        name_placeholder: "소셜 로그인 버튼 이름을 입력하세요",
        name_tip: '다음과 같이 연동 이름이 출력돼요. "{{name}}으로 계속하기".',
        logo: "연동 로고 URL",
        logo_placeholder: "https://your.cdn.domain/logo.png",
        logo_tip: "이 이미지는 연동 버튼에 보여질 거에요.",
        logo_dark: "소셜 로그인에 사용될 로고 URL (다크 모드)",
        logo_dark_placeholder: "https://your.cdn.domain/logo.png",
        logo_dark_tip: "관리자 콘솔의 로그인 경험에서 다크 모드를 위한 로고를 활성화한 후 다크 모드용 연동 로고를 설정해 주세요.",
        logo_dark_collapse: "최소화",
        logo_dark_show: "다크 모드를 위한 로고 설정 보이기",
        target: "연동 ID 공급자",
        target_placeholder: "연동 ID 공급자 이름을 입력하세요",
        target_tip: '"IdP 이름"의 값은 소셜 식별자를 구분하기 위한 고유 식별자 문자열이 될 수 있어요.',
        target_tip_standard: '"IdP 이름"의 값은 소셜 식별자를 구분하기 위한 고유 식별자 문자열이 될 수 있어요. 이 설정은 연동이 만들어진 후에는 변경할 수 없어요.',
        target_tooltip: 'Logto의 소셜 연동에서의 "공급자"는 소셜 정보의 원천을 뜻해요. Logto의 디자인은 충돌을 피하기 위해서 같은 "공급자"를 허용하지 않아요. 연동을 추가한 후에는 값을 변경할 수 없으므로 주의해주세요. <a>자세히 알아보기</a>',
        target_conflict: "입력한 IdP 이름이 기존 <span>name</span>과 일치해요. 동일한 IdP 이름을 사용하면 사용자가 두 개의 다른 커넥터를 통해 동일한 계정에 액세스할 수 있는 예기치 않은 로그인 동작이 발생할 수 있어요.",
        target_conflict_line2: '현재 연동을 동일한 ID 공급자로 바꾸고 이전 사용자가 다시 등록하지 않고도 로그인할 수 있도록 하려면 <span>name</span> 커넥터를 삭제하고 동일한 "IdP 이름"으로 새 커넥터를 만드세요.',
        target_conflict_line3: '다른 ID 공급자에 연결하려면 "IdP 이름"을 수정한 후 계속 진행하세요.',
        config: "여기에 JSON을 입력",
        sync_profile: "프로필 정보 동기화",
        sync_profile_only_at_sign_up: "회원가입할 때 동기화",
        sync_profile_each_sign_in: "로그인할 때마다 동기화",
        sync_profile_tip: "이름과 아바타와 같은 기본적인 사용자 프로필을 동기화해요.",
        callback_uri: "Callback URI",
        callback_uri_description: "리다이렉트 URI라고도 불려요. 사용자의 소셜 인증 이후 되돌아올 Logto URI예요. 소셜 공급자의 설정 페이지에 붙여넣으세요.",
        acs_url: "단언 소비 서비스 URL"
    },
    platform: {
        universal: "일반",
        web: "웹",
        native: "네이티브"
    },
    add_multi_platform: " 다양한 플랫폼 지원, 플랫폼을 선택해주세요.",
    drawer_title: "연동 가이드",
    drawer_subtitle: "연동하기 위해 가이드를 따라 주세요.",
    unknown: "알 수 없는 연동",
    standard_connectors: "기본 커넥터"
};
var $56242fe7cfaad683$export$2e2bcd8739ae039 = Object.freeze($56242fe7cfaad683$var$connectors);


const $314fbccf711b0647$var$contact = {
    title: "지원 받기",
    description: "도움 요청 또는 제품 피드백을 위해서, 아래의 방법을 통해 저희에게 문의해주세요.",
    discord: {
        title: "디스코드 커뮤니티 가입하기",
        description: "다른 개발자들과 솔루션을 찾기 위해 연결하세요.",
        button: "가입하기"
    },
    github: {
        title: "GitHub 에서 소통하기",
        description: "이슈를 작성하고 GitHub에 제출하세요.",
        button: "열기"
    },
    email: {
        title: "이메일로 지원팀과 연락하기",
        description: "더 많은 정보나 도움을 위해 이메일을 보내주세요.",
        button: "보내기"
    },
    reserve: {
        title: "Logto 팀과의 시간을 예약하세요",
        description: "빠르게 대화를 위해 세션 예약",
        button: "예약하기"
    }
};
var $314fbccf711b0647$export$2e2bcd8739ae039 = Object.freeze($314fbccf711b0647$var$contact);


const $e15b81776b2a869f$var$dashboard = {
    page_title: "대시보드",
    title: "대시보드",
    description: "앱 사용자에 대한 개요를 볼 수 있어요.",
    total_users: "전체 사용자",
    total_users_tip: "전체 사용자",
    new_users_today: "새로운 사용자 (오늘)",
    new_users_today_tip: "오늘 앱에 새로 가입한 사용자",
    new_users_7_days: "새로운 사용자 (최근 7일)",
    new_users_7_days_tip: "최근 7일 동안 앱에 새로 가입한 사용자",
    daily_active_users: "활성화 사용자 (오늘)",
    daily_active_users_tip: "오늘 앱을 통하여 Token을 가져간 사용자 수",
    weekly_active_users: "활성화 사용자 (최근 7일)",
    weekly_active_users_tip: "최근 7일 동안 앱을 통하여 Token을 가져간 사용자 수",
    monthly_active_users: "활성화 사용자 (최근 30일)",
    monthly_active_users_tip: "최근 30일 동안 앱을 통하여 Token을 가져간 사용자 수"
};
var $e15b81776b2a869f$export$2e2bcd8739ae039 = Object.freeze($e15b81776b2a869f$var$dashboard);


const $457f94d46d7f6983$var$domain = {
    status: {
        connecting: "연결 중...",
        in_use: "사용 중",
        failed_to_connect: "연결 실패"
    },
    update_endpoint_notice: "사용자 지정 도메인을 사용하려면 애플리케이션에서 소셜 커넥터 콜백 URI 및 Logto 엔드포인트의 도메인을 업데이트해야합니다. <a>{{link}}</a>",
    error_hint: "DNS 레코드를 업데이트해야합니다. {{value}}초마다 체크하도록 계속합니다.",
    custom: {
        custom_domain: "사용자 지정 도메인",
        custom_domain_description: "브랜딩을 개선하고 사용자 지정 도메인을 활용하세요. 이 도메인은 로그인 경험에서 사용됩니다.",
        custom_domain_field: "사용자 지정 도메인",
        custom_domain_placeholder: "your.domain.com",
        add_domain: "도메인 추가",
        invalid_domain_format: '유효한 도메인 URL을 제공해야합니다. 최소 세 부분으로 구성되어야 하며 예를 들어 "your.domain.com."이어야 합니다.',
        verify_domain: "도메인 확인",
        enable_ssl: "SSL 사용",
        checking_dns_tip: "DNS 레코드를 구성한 후 자동 프로세스가 실행되며 최대 24시간이 걸릴 수 있습니다. 인터페이스에서 이 작업을 나갈 수 있습니다.",
        enable_ssl_tip: "SSL 사용은 자동으로 실행되며 최대 24시간이 걸릴 수 있습니다. 이 인터페이스를 나갈 수 있습니다.",
        generating_dns_records: "DNS 레코드 생성 중...",
        add_dns_records: "이 DNS 레코드를 DNS 공급자에 추가하세요.",
        dns_table: {
            type_field: "유형",
            name_field: "이름",
            value_field: "값"
        },
        deletion: {
            delete_domain: "도메인 삭제",
            reminder: "사용자 지정 도메인 삭제",
            description: "이 사용자 지정 도메인을 삭제하시겠습니까?",
            in_used_description: '이 사용자 지정 도메인 "<span>{{domain}}</span>"이 현재 사용 중입니다. 삭제하시겠습니까?',
            in_used_tip: '이전에 소셜 커넥터 공급자나 애플리케이션 엔드포인트에 이 사용자 지정 도메인을 설정한 경우 로그인 버튼이 작동하도록 먼저 Logto 기본 도메인의 "<span>{{domain}}</span>" URI를 수정해야합니다.',
            deleted: "사용자 지정 도메인을 성공적으로 삭제했습니다!"
        }
    },
    default: {
        default_domain: "기본 도메인",
        default_domain_description: "Logto는 추가 구성 없이 사용할 수 있는 미리 구성된 기본 도메인을 제공합니다. 이 기본 도메인은 사용자 지정 도메인을 사용하지 않더라도 백업 옵션으로 사용됩니다.",
        default_domain_field: "Logto 기본 도메인"
    },
    custom_endpoint_note: '이 엔드포인트의 도메인 이름을 필요에 따라 사용자 정의할 수 있습니다. "{{custom}}" 또는 "{{default}}" 중 하나를 선택하세요.',
    custom_social_callback_url_note: '이 URI의 도메인 이름을 애플리케이션 엔드포인트와 일치하도록 사용자 정의할 수 있습니다. "{{custom}}" 또는 "{{default}}" 중 하나를 선택하세요.',
    custom_acs_url_note: '이 URI의 도메인명을 사용자의 ID 공급자 Assertion Consumer 서비스 URL과 일치하도록 사용자 정의할 수 있습니다. "{{custom}}" 또는 "{{default}}" 중 하나를 선택하세요.'
};
var $457f94d46d7f6983$export$2e2bcd8739ae039 = Object.freeze($457f94d46d7f6983$var$domain);


const $360c79467d06cad9$var$enterprise_sso_details = {
    back_to_sso_connectors: "기업 SSO로 돌아가기",
    page_title: "기업 SSO 커넥터 세부 정보",
    readme_drawer_title: "기업 SSO",
    readme_drawer_subtitle: "엔드 유저 SSO를 활성화하려면 기업 SSO 커넥터를 설정하세요",
    tab_experience: "SSO 경험",
    tab_connection: "연결",
    general_settings_title: "일반",
    custom_branding_title: "표시",
    custom_branding_description: "엔드 유저의 단일 로그인 흐름에서 표시되는 이름 및 로고를 사용자 정의하세요. 비어 있으면 기본 사용됩니다.",
    email_domain_field_name: "기업 이메일 도메인",
    email_domain_field_description: "이 이메일 도메인을 가진 사용자는 SSO를 사용하여 인증할 수 있습니다. 도메인이 기업에 속해 있는지 확인해주세요.",
    email_domain_field_placeholder: "이메일 도메인",
    sync_profile_field_name: "아이디 공급자에서 프로필 정보 동기화",
    sync_profile_option: {
        register_only: "첫 번째 로그인 시에만 동기화",
        each_sign_in: "매 로그인 시 항상 동기화"
    },
    connector_name_field_name: "커넥터 이름",
    display_name_field_name: "표시 이름",
    connector_logo_field_name: "표시 로고",
    connector_logo_field_description: "각 이미지는 500KB 이하, SVG, PNG, JPG, JPEG 만 허용됩니다.",
    branding_logo_context: "로고 업로드",
    branding_logo_error: "로고 업로드 오류: {{error}}",
    branding_light_logo_context: "라이트 모드 로고 업로드",
    branding_light_logo_error: "라이트 모드 로고 업로드 오류: {{error}}",
    branding_logo_field_name: "로고",
    branding_logo_field_placeholder: "https://your.domain/logo.png",
    branding_dark_logo_context: "다크 모드 로고 업로드",
    branding_dark_logo_error: "다크 모드 로고 업로드 오류: {{error}}",
    branding_dark_logo_field_name: "로고 (다크 모드)",
    branding_dark_logo_field_placeholder: "https://your.domain/dark-mode-logo.png",
    check_connection_guide: "연결 가이드",
    enterprise_sso_deleted: "기업 SSO 커넥터가 성공적으로 삭제되었습니다",
    delete_confirm_modal_title: "기업 SSO 커넥터 삭제",
    delete_confirm_modal_content: "이 기업 커넥터를 삭제하시겠습니까? 신원 공급자의 사용자는 단일 로그인을 사용하지 않습니다.",
    upload_idp_metadata_title_saml: "메타데이터 업로드",
    upload_idp_metadata_description_saml: "신원 공급자에서 복사한 메타데이터를 구성하세요.",
    upload_idp_metadata_title_oidc: "자격 증명 업로드",
    upload_idp_metadata_description_oidc: "신원 공급자에서 복사한 자격 증명 및 OIDC 토큰 정보를 구성하세요.",
    upload_idp_metadata_button_text: "메타데이터 XML 파일 업로드",
    upload_signing_certificate_button_text: "서명 인증서 파일 업로드",
    configure_domain_field_info_text: "기업 사용자를 단일 로그인을 위해 신원 공급자로 안내하려면 이메일 도메인을 추가하세요.",
    email_domain_field_required: "기업 SSO를 활성화하려면 이메일 도메인이 필요합니다.",
    upload_saml_idp_metadata_info_text_url: "신원 공급자에서 메타데이터 URL을 붙여넣어 연결하세요.",
    upload_saml_idp_metadata_info_text_xml: "신원 공급자에서 메타데이터를 붙여넣어 연결하세요.",
    upload_saml_idp_metadata_info_text_manual: "신원 공급자에서 메타데이터를 작성하여 연결하세요.",
    upload_oidc_idp_info_text: "신원 공급자에서 정보를 작성하여 연결하세요.",
    service_provider_property_title: "IdP에서 구성",
    service_provider_property_description: "신원 공급자에서 {{protocol}}를 사용하여 응용 프로그램 통합을 설정하세요. 로그토에서 제공한 세부 정보를 입력하세요.",
    attribute_mapping_title: "속성 매핑",
    attribute_mapping_description: "신원 공급자에서 사용자 속성 매핑을 구성하여 사용자 프로필을 Logto 쪽에서 동기화하세요.",
    saml_preview: {
        sign_on_url: "로그인 URL",
        entity_id: "발급자",
        x509_certificate: "서명 인증서",
        certificate_content: "만료일 {{date}}"
    },
    oidc_preview: {
        authorization_endpoint: "인증 엔드포인트",
        token_endpoint: "토큰 엔드포인트",
        userinfo_endpoint: "사용자 정보 엔드포인트",
        jwks_uri: "JSON 웹 키 세트 엔드포인트",
        issuer: "발급자"
    }
};
var $360c79467d06cad9$export$2e2bcd8739ae039 = Object.freeze($360c79467d06cad9$var$enterprise_sso_details);


const $977cfb51ff2428a6$var$enterprise_sso = {
    page_title: "기업 SSO",
    title: "기업 SSO",
    subtitle: "기업 신원 공급자를 연결하고 SP-initiated 단일 로그인을 활성화합니다.",
    create: "기업 커넥터 추가",
    col_connector_name: "커넥터 이름",
    col_type: "유형",
    col_email_domain: "이메일 도메인",
    placeholder_title: "기업 커넥터",
    placeholder_description: "Logto는 많은 기본 제공 기업 신원 공급자를 제공했으며, 동시에 SAML 및 OIDC 프로토콜을 사용하여 사용자 지정할 수 있습니다.",
    create_modal: {
        title: "기업 커넥터 추가",
        text_divider: "또는 표준 프로토콜을 사용하여 커넥터를 사용자 정의할 수 있습니다.",
        connector_name_field_title: "커넥터 이름",
        connector_name_field_placeholder: "예: {corp. name} - {identity provider name}",
        create_button_text: "커넥터 생성"
    },
    guide: {
        subtitle: "기업 신원 공급자를 연결할 수 있는 단계별 가이드",
        finish_button_text: "계속"
    },
    basic_info: {
        title: "IdP에서 서비스 구성",
        description: "SAML 2.0을 사용하여 {{name}} 신원 공급자에서 새로운 응용 프로그램 통합을 만듭니다. 그런 다음 다음 값을 붙여 넣습니다.",
        saml: {
            acs_url_field_name: "단언 소비자 서비스 URL (응답 URL)",
            audience_uri_field_name: "대상 URI (SP 엔터티 ID)"
        },
        oidc: {
            redirect_uri_field_name: "리디렉션 URI (콜백 URL)"
        }
    },
    attribute_mapping: {
        title: "속성 매핑",
        description: "`id` 및 `이메일`은 IdP에서 사용자 프로필을 동기화하는 데 필요합니다. IdP에 다음 클레임 이름과 값을 입력합니다.",
        col_sp_claims: "서비스 제공자 (Logto)의 값",
        col_idp_claims: "신원 공급자의 클레임 이름",
        idp_claim_tooltip: "신원 공급자의 클레임 이름"
    },
    metadata: {
        title: "IdP 메타데이터 구성",
        description: "신원 공급자의 메타데이터 구성",
        dropdown_trigger_text: "다른 구성 방법 사용",
        dropdown_title: "구성 방법 선택",
        metadata_format_url: "메타데이터 URL 입력",
        metadata_format_xml: "메타데이터 XML 파일 업로드",
        metadata_format_manual: "메타데이터 세부 정보 수동 입력",
        saml: {
            metadata_url_field_name: "메타데이터 URL",
            metadata_url_description: "메타데이터 URL에서 데이터를 동적으로 가져와 인증서를 최신 상태로 유지합니다.",
            metadata_xml_field_name: "IdP 메타데이터 XML 파일",
            metadata_xml_uploader_text: "메타데이터 XML 파일 업로드",
            sign_in_endpoint_field_name: "로그인 URL",
            idp_entity_id_field_name: "IdP 엔터티 ID (발급자)",
            certificate_field_name: "서명 인증서",
            certificate_placeholder: "x509 인증서를 복사하여 붙여넣기",
            certificate_required: "서명 인증서는 필수입니다."
        },
        oidc: {
            client_id_field_name: "클라이언트 ID",
            client_secret_field_name: "클라이언트 비밀",
            issuer_field_name: "발급자",
            scope_field_name: "범위"
        }
    }
};
var $977cfb51ff2428a6$export$2e2bcd8739ae039 = Object.freeze($977cfb51ff2428a6$var$enterprise_sso);


const $72f40b5871dfd700$var$errors = {
    something_went_wrong: "알 수 없는 오류가 발생했어요.",
    page_not_found: "페이지를 찾을 수 없어요.",
    unknown_server_error: "서버에서 알 수 없는 오류가 발생했어요.",
    empty: "데이터 없음",
    missing_total_number: "Total-Number를 응답 해더에서 찾을 수 없어요.",
    invalid_uri_format: "URI 형식이 유효하지 않음",
    invalid_origin_format: "URI origin 형식이 유효하지 않음",
    invalid_json_format: "JSON 형식이 유효하지 않음",
    invalid_regex: "잘못된 정규 표현식",
    invalid_error_message_format: "오류 메세지 형식이 유효하지 않아요.",
    required_field_missing: "{{field}}을/를 입력해 주세요.",
    required_field_missing_plural: "최소 1개의 {{field}}을/를 입력해야 해요.",
    more_details: "자세히",
    username_pattern_error: "아이디는 반드시 문자, 숫자, _ 만으로 이루어져야 하며, 숫자로 시작하면 안 돼요.",
    email_pattern_error: "이메일 형식이 유효하지 않아요.",
    phone_pattern_error: "전화번호 형식이 유효하지 않아요.",
    insecure_contexts: "비보안 연결(non-HTTPS)는 지원하지 않아요.",
    unexpected_error: "알 수 없는 오류가 발생했어요.",
    not_found: "404 찾을 수 없음",
    create_internal_role_violation: 'Logto에 의해 금지된 내부 역할을 생성하려고 하고 있어요. "#internal:"로 시작하지 않는 다른 이름을 사용하세요.',
    should_be_an_integer: "정수이어야 합니다.",
    number_should_be_between_inclusive: "숫자는 {{min}} 이상 {{max}} 이하이어야 합니다."
};
var $72f40b5871dfd700$export$2e2bcd8739ae039 = Object.freeze($72f40b5871dfd700$var$errors);


const $dc6eab6da5b7de00$var$general = {
    placeholder: "플레이스홀더",
    submit: "제출",
    skip: "건너뛰기",
    next: "다음",
    back: "뒤로",
    retry: "재시도",
    done: "완료",
    search: "검색",
    search_placeholder: "검색",
    clear_result: "결과 지우기",
    save: "저장",
    save_changes: "변경 내용 저장",
    saved: "저장됨",
    discard: "취소",
    loading: "로딩 중...",
    redirecting: "리다이렉트 중...",
    add: "추가",
    added: "추가됨",
    cancel: "취소",
    confirm: "확인",
    check_out: "확인하기",
    create: "생성",
    set_up: "설정",
    customize: "사용자화",
    enable: "활성화",
    reminder: "리마인더",
    edit: "편집",
    delete: "삭제",
    deleted: "삭제됨",
    more_options: "더 많은 설정",
    close: "닫기",
    copy: "복사",
    copying: "복사 중",
    copied: "복사됨",
    required: "필수",
    add_another: "새로 추가",
    create_another: "또 다른 것 만들기",
    deletion_confirmation: "정말로 {{title}}을/를 삭제할까요?",
    settings_nav: "설정",
    unsaved_changes_warning: "수정된 내용이 있어요. 정말로 현재 페이지를 벗어날까요?",
    leave_page: "페이지 나가기",
    stay_on_page: "페이지 유지하기",
    type_to_search: "검색어 입력",
    got_it: "알겠어요",
    continue: "계속하기",
    page_info: "{{min, number}}-{{max, number}} / {{total, number}}",
    learn_more: "더 알아보기",
    tab_errors: "{{count, number}} 오류",
    skip_for_now: "지금은 건너뛰기",
    remove: "삭제",
    visit: "방문하기",
    join: "참여하기",
    try_now: "지금 시도하기",
    multiple_form_field: "(복수 선택)",
    demo: "데모",
    unnamed: "이름없음",
    view: "보기",
    open: "열기",
    hide: "숨기기",
    unknown_error: "알 수 없는 오류가 발생했습니다. 나중에 다시 시도해주세요.",
    select: "선택",
    contact_us_action: "문의하기",
    description: "설명",
    name: "이름",
    add_field: "{{field}} 추가",
    create_field: "{{field}} 만들기",
    edit_field: "{{field}} 편집",
    delete_field: "{{field}} 삭제",
    coming_soon: "곧 출시 예정",
    or: "또는"
};
var $dc6eab6da5b7de00$export$2e2bcd8739ae039 = Object.freeze($dc6eab6da5b7de00$var$general);


const $cfb01c77e5294c57$var$get_started = {
    page_title: "시작하기",
    title: "성공하는 데 도움이 될 탐색 항목",
    subtitle: "Logto의 가치를 빠르게 얻을 수 있는 몇 가지 방법",
    develop: {
        title: "개발: 앱을 통합하는 데 5분이면 충분합니다",
        title_cloud: "개발: 몇 분 안에 앱을 안전하게 통합하기",
        subtitle_cloud: "아니면 미리 만들어진 SDK와 자습서로 앱을 5분만에 통합해 보세요."
    },
    customize: {
        title: "사용자 정의: 훌륭한 로그인 경험 전달하기",
        preview: {
            title: "방금 사용자 정의한 로그인 경험의 실시간 미리보기 확인하기",
            subtitle: "작동 방식을 확인하려면 지금 Logto 로그인 경험을 시도해보세요"
        },
        connector: {
            title: "더 많은 커넥터 추가하여 더 많은 소셜 로그인 방식 지원하기",
            subtitle: "비밀번호 없는 로그인을 시도하고 고객에게 안전하고 원활한 경험을 제공하세요"
        },
        continue_customizing: "사용자 정의 계속하기",
        try_now: "지금 시도해보세요",
        add_more: "더 추가하기"
    },
    secure: {
        title: "보안: 리소스 보호"
    },
    manage: {
        title: "관리: 제품 및 사용자에 대한 액세스 제어 정의",
        rbac: {
            title: "롤 기반 액세스 제어 추가하여 리소스 보호",
            subtitle: "다양한 사용 사례에 대해 확장 가능한 역할 권한부여를 통해 리소스 제어"
        },
        create_roles: "역할 생성"
    },
    view_all: "모두 보기 →"
};
var $cfb01c77e5294c57$export$2e2bcd8739ae039 = Object.freeze($cfb01c77e5294c57$var$get_started);


const $484e8297070da8c8$var$guide = {
    start_building: "시작하기",
    get_started: "시작하기",
    categories: {
        featured: "인기와 당신을 위한",
        Traditional: "전통적인 웹 앱",
        SPA: "싱글 페이지 앱",
        Native: "네이티브",
        MachineToMachine: "기계 간 통신",
        Protected: "SDK 통합이 없는 보호",
        ThirdParty: "타사 앱"
    },
    filter: {
        title: "프레임워크 필터",
        placeholder: "프레임워크 검색하기"
    },
    checkout_tutorial: "튜토리얼 {{name}} 확인하기",
    do_not_need_tutorial: "튜토리얼이 필요하지 않다면, 프레임워크 가이드 없이 계속할 수 있습니다.",
    finish_and_done: "완료",
    cannot_find_guide: "가이드를 찾을 수 없습니다.",
    describe_guide_looking_for: "찾고 계신 가이드에 대해 설명해주세요.",
    request_guide_successfully: "요청이 성공적으로 제출되었습니다. 감사합니다!",
    app: {
        select_framework_or_tutorial: "프레임워크 또는 튜토리얼 선택",
        guide_modal_title: "SDK 및 가이드로 시작하기",
        modal_subtitle: "사전 빌드된 SDK와 튜토리얼로 앱 개발 프로세스를 바로 시작하세요.",
        select_a_framework: "프레임워크 선택하기",
        continue_without_framework: "프레임워크 없이 앱 만들기",
        describe_guide_looking_for_placeholder: "예시: Angular 앱에 Logto 통합하고 싶습니다."
    },
    api: {
        modal_title: "튜토리얼로 시작하기",
        modal_subtitle: "사전 빌드된 튜토리얼로 앱 개발 프로세스를 바로 시작하세요.",
        select_a_tutorial: "튜토리얼 선택하기",
        continue_without_tutorial: "튜토리얼 없이 계속하기",
        describe_guide_looking_for_placeholder: "예시: Deno를 사용하여 API 보호하기"
    }
};
var $484e8297070da8c8$export$2e2bcd8739ae039 = Object.freeze($484e8297070da8c8$var$guide);


const $47b4cceb82f3a773$var$invitation = {
    find_your_tenants: "입주자 찾기",
    find_tenants_description: "귀하의 이메일 주소는 이미 여러 입주자와 등록되어 있을 수 있습니다. 기존 입주자에 가입하거나 새로운 입주자를 생성할 수 있습니다.",
    create_new_tenant: "신규 입주자 생성",
    email_not_match_title: "현재 다음으로\n{{email}}\n사용자로 로그인 중입니다",
    email_not_match_description: "초대장을 수락하고 조직의 구성원이 되려면 올바른 계정으로 로그인하십시오.",
    switch_account: "다른 계정으로 로그인",
    invalid_invitation_status: "잘못된 초대장입니다. 관리자에게 문의하고 다시 시도하십시오.",
    invitation_not_found: "초대장을 찾을 수 없습니다. 관리자에게 문의하십시오."
};
var $47b4cceb82f3a773$export$2e2bcd8739ae039 = Object.freeze($47b4cceb82f3a773$var$invitation);


const $64628f35a1b4b074$var$jwt_claims = {
    title: "사용자 정의 JWT",
    description: "액세스 토큰에 포함할 사용자 정의 JWT 클레임을 설정하세요. 이러한 클레임은 추가 정보를 응용 프로그램에 전달하는 데 사용될 수 있습니다.",
    user_jwt: {
        card_title: "사용자용",
        card_field: "사용자 액세스 토큰",
        card_description: "액세스 토큰 발급 시 사용자별 데이터 추가.",
        for: "사용자용"
    },
    machine_to_machine_jwt: {
        card_title: "M2M용",
        card_field: "기기 간 토큰",
        card_description: "기기 간 토큰 발급 시 추가 데이터 추가.",
        for: "M2M용"
    },
    code_editor_title: "{{$token}} 클레임을 사용자화",
    custom_jwt_create_button: "사용자 정의 클레임 추가",
    custom_jwt_item: "사용자 정의 클레임 {{$for}}",
    delete_modal_title: "사용자 정의 클레임 삭제",
    delete_modal_content: "사용자 정의 클레임을 삭제하시겠습니까?",
    clear: "지우기",
    cleared: "지움",
    restore: "기본값으로 복원",
    restored: "복원됨",
    data_source_tab: "데이터 소스",
    test_tab: "테스트 컨텍스트",
    jwt_claims_description: "기본 클레임은 JWT에 자동으로 추가되며 재정의할 수 없습니다.",
    user_data: {
        title: "사용자 데이터",
        subtitle: "`data.user` 입력 매개변수를 사용하여 중요한 사용자 정보 제공."
    },
    token_data: {
        title: "토큰 데이터",
        subtitle: "현재 액세스 토큰 페이로드에 대한 `token` 입력 매개변수 사용."
    },
    fetch_external_data: {
        title: "외부 데이터 가져오기",
        subtitle: "외부 API에서 데이터 직접 클레임에 통합.",
        description: "`fetch` 함수를 사용하여 외부 API를 호출하고 해당 데이터를 사용자 정의 클레임에 포함시킵니다. 예시: "
    },
    environment_variables: {
        title: "환경 변수 설정",
        subtitle: "중요 정보를 저장하기 위해 환경 변수를 사용하세요.",
        input_field_title: "환경 변수 추가",
        sample_code: "사용자 정의 JWT 클레임 핸들러에서 환경 변수에 접근하는 방법. 예시: "
    },
    jwt_claims_hint: "사용자 정의 클레임을 50KB 미만으로 제한하세요. 기본 JWT 클레임은 토큰에 자동으로 포함되며 재정의할 수 없습니다.",
    tester: {
        subtitle: "테스트를 위해 모의 토큰 및 사용자 데이터 조정.",
        run_button: "테스트 실행",
        result_title: "테스트 결과"
    },
    form_error: {
        invalid_json: "잘못된 JSON 형식"
    }
};
var $64628f35a1b4b074$export$2e2bcd8739ae039 = Object.freeze($64628f35a1b4b074$var$jwt_claims);


const $7a8ffb803720eace$var$log_details = {
    page_title: "감사 로그 세부 정보",
    back_to_logs: "감사 기록으로 돌아가기",
    back_to: "{{name}}으로 돌아가기",
    success: "성공",
    failed: "실패",
    event_key: "이벤트 키",
    application: "어플리케이션",
    ip_address: "IP 주소",
    user: "사용자",
    log_id: "기록 ID",
    time: "시간",
    user_agent: "사용자 Agent",
    tab_details: "상세",
    raw_data: "상세 데이터"
};
var $7a8ffb803720eace$export$2e2bcd8739ae039 = Object.freeze($7a8ffb803720eace$var$log_details);


const $6ae3be79eb86f3d8$var$logs = {
    page_title: "감사 기록",
    title: "감사 기록",
    subtitle: "관리자나 사용자의 인증 기록을 확인해 보세요.",
    event: "활동",
    user: "사용자",
    application: "어플리케이션",
    time: "시간",
    filter_by: "필터"
};
var $6ae3be79eb86f3d8$export$2e2bcd8739ae039 = Object.freeze($6ae3be79eb86f3d8$var$logs);


const $3e5fffb2543b7756$var$menu = {
    profile: "프로필",
    language: "언어",
    appearance: {
        label: "모습",
        light: "라이트 모드",
        dark: "다크 모드",
        system: "시스템과 동기화"
    },
    sign_out: "로그아웃"
};
var $3e5fffb2543b7756$export$2e2bcd8739ae039 = Object.freeze($3e5fffb2543b7756$var$menu);


const $43812b39c2a0877c$var$mfa = {
    title: "다중 인증",
    description: "다중 인증을 추가하여 로그인 경험의 보안을 강화하세요.",
    factors: "요소",
    multi_factors: "다중 요소",
    multi_factors_description: "사용자는 2단계 인증을 위해 활성화된 요소 중 하나를 확인해야 합니다.",
    totp: "인증기 앱 OTP",
    otp_description: "Google Authenticator 등을 연결하여 일회용 암호를 확인합니다.",
    webauthn: "WebAuthn(패스키)",
    webauthn_description: "브라우저에서 지원하는 방법으로 확인합니다: 생체 인식, 휴대폰 스캔 또는 보안 키 등.",
    webauthn_native_tip: "네이티브 애플리케이션에서는 WebAuthn이 지원되지 않습니다.",
    webauthn_domain_tip: "WebAuthn은 공개 키를 특정 도메인에 바인딩합니다. 서비스 도메인을 수정하면 기존 패스키를 사용한 사용자의 인증이 차단됩니다.",
    backup_code: "백업 코드",
    backup_code_description: "사용자가 어떤 MFA 방법을 설정한 후에 10개의 일회용 백업 코드를 생성합니다.",
    backup_code_setup_hint: "사용자가 위의 MFA 요소를 확인할 수 없는 경우 백업 옵션을 사용하세요.",
    backup_code_error_hint: "백업 코드를 사용하려면 성공적인 사용자 인증을 위해 적어도 하나 이상의 MFA 방법이 필요합니다.",
    policy: "정책",
    policy_description: "로그인 및 가입 플로우에 대한 MFA 정책을 설정합니다.",
    two_step_sign_in_policy: "로그인 시 2단계 인증 정책",
    user_controlled: "사용자는 자체적으로 MFA를 활성화 또는 비활성화할 수 있습니다",
    user_controlled_tip: "사용자는 처음 로그인 또는 가입 시에 MFA 설정을 건너 뛰거나 계정 설정에서 활성화/비활성화할 수 있습니다.",
    mandatory: "사용자는 항상 로그인 시 MFA 사용이 필요합니다",
    mandatory_tip: "사용자는 처음 로그인 또는 가입 시에 MFA를 설정하고 모든 향후 로그인에서 그것을 사용해야 합니다."
};
var $43812b39c2a0877c$export$2e2bcd8739ae039 = Object.freeze($43812b39c2a0877c$var$mfa);


const $e651b0b2e5221db9$var$organization_details = {
    page_title: "조직 세부 정보",
    delete_confirmation: "삭제하면 모든 회원이 이 조직에서 멤버십과 역할을 잃게 됩니다. 이 작업은 취소할 수 없습니다.",
    organization_id: "조직 ID",
    settings_description: "조직은 귀하의 응용 프로그램에 액세스할 수 있는 팀, 비즈니스 고객 및 협력업체를 나타냅니다.",
    name_placeholder: "조직의 이름, 고유할 필요는 없습니다.",
    description_placeholder: "조직에 대한 설명입니다.",
    member: "멤버",
    member_other: "멤버",
    add_members_to_organization: "조직 {{name}}에 멤버 추가",
    add_members_to_organization_description: "이름, 이메일, 전화 또는 사용자 ID를 검색하여 적절한 사용자를 찾습니다. 기존 멤버는 검색 결과에 표시되지 않습니다.",
    add_with_organization_role: "조직 역할로 추가",
    user: "사용자",
    authorize_to_roles: "{{name}}에게 다음 역할에 대한 액세스 권한 부여:",
    edit_organization_roles: "조직 역할 편집",
    edit_organization_roles_of_user: "{{name}}의 조직 역할 편집",
    remove_user_from_organization: "사용자를 조직에서 제거",
    remove_user_from_organization_description: "제거하면 사용자가 이 조직에서 멤버십과 역할을 잃습니다. 이 작업은 취소할 수 없습니다.",
    search_user_placeholder: "이름, 이메일, 전화 또는 사용자 ID로 검색",
    at_least_one_user: "최소한 한 명의 사용자가 필요합니다.",
    custom_data: "사용자 정의 데이터",
    custom_data_tip: "사용자 정의 데이터는 조직과 관련된 추가 데이터를 저장하는 데 사용할 수 있는 JSON 객체입니다.",
    invalid_json_object: "잘못된 JSON 객체입니다."
};
var $e651b0b2e5221db9$export$2e2bcd8739ae039 = Object.freeze($e651b0b2e5221db9$var$organization_details);


const $a3951796d3447acd$var$organization_role_details = {
    page_title: "조직 역할 세부 정보",
    back_to_org_roles: "조직 역할로 돌아가기",
    org_role: "조직 역할",
    delete_confirm: "이렇게 하면 해당 역할과 관련된 사용자의 권한이 제거되고 조직 역할, 조직 구성원 및 조직 권한 간의 관계가 삭제됩니다.",
    deleted: "조직 역할 {{name}} 이(가) 성공적으로 삭제되었습니다.",
    permissions: {
        tab: "권한",
        name_column: "권한",
        description_column: "설명",
        type_column: "권한 유형",
        type: {
            api: "API 권한",
            org: "조직 권한"
        },
        assign_permissions: "권한 할당",
        remove_permission: "권한 삭제",
        remove_confirmation: "이 권한을 제거하면이 조직 역할을하는 사용자는이 권한으로 부여된 액세스를 잃게됩니다.",
        removed: "권한 {{name}}이(가)이 조직 역할에서 성공적으로 제거되었습니다",
        assign_description: "이 조직 내의 역할에 권한을 할당합니다. 이는 조직 권한과 API 권한을 모두 포함할 수 있습니다.",
        organization_permissions: "조직 권한",
        api_permissions: "API 권한",
        assign_organization_permissions: "조직 권한 할당",
        assign_api_permissions: "API 권한 할당"
    },
    general: {
        tab: "일반",
        settings: "설정",
        description: "조직 역할은 사용자에게 할당할 수 있는 권한의 그룹입니다. 권한은 사전에 정의된 조직 권한과 API 권한에서 올 수 있습니다.",
        name_field: "이름",
        description_field: "설명",
        description_field_placeholder: "읽기 전용 권한을 가진 사용자"
    }
};
var $a3951796d3447acd$export$2e2bcd8739ae039 = Object.freeze($a3951796d3447acd$var$organization_role_details);


const $156260f1c923cd68$var$organization_template = {
    title: "조직 템플릿",
    subtitle: "멀티 테넌트 SaaS 애플리케이션에서 조직 템플릿은 여러 조직의 공유 액세스 제어 정책(권한 및 역할)을 정의합니다.",
    roles: {
        tab_name: "조직 역할",
        search_placeholder: "역할 이름으로 검색",
        create_title: "조직 역할 생성",
        role_column: "조직 역할",
        permissions_column: "권한",
        placeholder_title: "조직 역할",
        placeholder_description: "조직 역할은 사용자에게 할당될 수 있는 권한의 그룹입니다. 권한은 미리 정의된 조직 권한에서 와야 합니다.",
        create_modal: {
            title: "조직 역할 만들기",
            create: "역할 만들기",
            name_field: "역할 이름",
            description_field: "설명",
            created: "조직 역할 {{name}}이(가) 성공적으로 만들어졌습니다."
        }
    },
    permissions: {
        tab_name: "조직 권한",
        search_placeholder: "권한 이름으로 검색",
        create_org_permission: "조직 권한 생성",
        permission_column: "조직 권한",
        description_column: "설명",
        placeholder_title: "조직 권한",
        placeholder_description: "조직 권한은 조직의 맥락에서 자원에 접근할 수 있는 권한을 의미합니다.",
        delete_confirm: "이 권한이 삭제되면, 이 권한을 포함하는 모든 조직 역할이 이 권한을 잃게 되며, 이 권한을 가진 사용자는 그것에 의해 부여된 접근을 잃게 됩니다.",
        create_title: "조직 권한 생성",
        edit_title: "조직 권한 편집",
        permission_field_name: "권한 이름",
        description_field_name: "설명",
        description_field_placeholder: "약속 기록 읽기",
        create_permission: "권한 생성",
        created: "조직 권한 {{name}}이(가) 성공적으로 생성되었습니다."
    }
};
var $156260f1c923cd68$export$2e2bcd8739ae039 = Object.freeze($156260f1c923cd68$var$organization_template);


const $113288872a6dc781$var$organizations = {
    organization: "조직",
    page_title: "조직",
    title: "조직",
    subtitle: "조직은 일반적으로 SaaS 또는 유사한 멀티 테넌트 앱에서 사용되며 팀, 조직 또는 전체 회사를 나타내는 것으로 클라이언트로서 역할을 하게 됩니다. 조직은 B2B 인증 및 권한 부여를 위한 기본 요소로 작용합니다.",
    organization_template: "조직 템플릿",
    organization_id: "조직 ID",
    members: "회원",
    create_organization: "조직 만들기",
    setup_organization: "조직 설정",
    organization_list_placeholder_title: "조직",
    organization_list_placeholder_text: "조직은 보통 SaaS 또는 유사한 멀티 테넌트 앱에서 모법 사례로 사용됩니다. 이를 통해 클라이언트가 조직을 만들고 관리하며 구성원을 초대하고 역할을 할당할 수 있는 앱을 개발할 수 있습니다.",
    organization_name_placeholder: "내 조직",
    organization_description_placeholder: "조직에 대한 간단한 설명",
    organization_permission: "조직 권한",
    organization_permission_other: "조직 권한",
    create_permission_placeholder: "약속 내용 읽기",
    organization_role: "조직 역할",
    organization_role_other: "조직 역할",
    organization_role_description: "조직 역할은 사용자에게 할당할 수 있는 권한을 그룹화하는 것입니다. 권한은 미리 정의된 조직 권한에서 가져와야 합니다.",
    role: "역할",
    search_placeholder: "조직 이름 또는 ID로 검색",
    search_role_placeholder: "검색하여 역할 선택",
    empty_placeholder: "\uD83E\uDD14 {{entity}}를 아직 설정하지 않았습니다.",
    organization_and_member: "조직 및 구성원",
    organization_and_member_description: '조직은 사용자 그룹으로써 팀, 비즈니스 고객 및 파트너 기업을 나타내며 각 사용자가 "구성원"입니다. 이러한 것들은 B2B 요청 및 권한을 처리하는 데 주요 요소일 수 있습니다.',
    guide: {
        title: "가이드로 시작",
        subtitle: "조직 설정을 빠르게 시작해 보세요.",
        introduction: {
            title: "로그토에서 조직이 작동하는 방식 이해하기",
            section_1: {
                title: "조직은 사용자(아이덴티티) 그룹입니다"
            },
            section_2: {
                title: "조직 템플릿은 멀티 테넌트 앱 액세스 제어에 사용됩니다",
                description: '멀티 테넌트 SaaS 애플리케이션에서 여러 조직이 종종 동일한 액세스 제어 템플릿을 공유합니다. 이를 로그토에서는 "조직 템플릿"이라고 합니다.',
                permission_description: "조직 권한은 리소스에 대한 권한을 나타냅니다.",
                role_description_deprecated: "조직 역할은 구성원에게 할당할 수 있는 조직 권한의 그룹화입니다.",
                role_description: "조직 역할은 구성원에게 할당할 수 있는 조직 권한이나 API 권한의 그룹입니다."
            },
            section_3: {
                title: "조직 역할에 API 권한을 할당할 수 있나요?",
                description: "네, 조직 역할에 API 권한을 할당할 수 있습니다. Logto는 조직 역할에 효과적으로 API 권한을 관리할 수 있는 유연성을 제공합니다."
            },
            section_4: {
                title: "일러스트로 상호 연결 방식 확인하기",
                description: "예를 들어, 존과 사라는 서로 다른 조직에 속하고 각기 다른 역할을 가지고 있습니다. 모듈 위로 마우스를 올려보세요."
            }
        },
        organization_permissions: "조직 권한",
        organization_roles: "조직 역할",
        admin: "관리자",
        member: "구성원",
        guest: "손님",
        role_description: '역할 "{{role}}"은 다른 조직에서도 동일한 조직 템플릿을 공유합니다.',
        john: "존",
        john_tip: '존은 두 조직에 속하며 "john@email.com"라는 단일 식별자를 가지고 있습니다. 그는 조직 A의 관리자이자 조직 B의 게스트입니다.',
        sarah: "사라",
        sarah_tip: '사라는 "sarah@email.com"라는 단일 식별자를 가지고 하나의 조직에 속해 있습니다. 그녀는 조직 B의 관리자입니다.'
    }
};
var $113288872a6dc781$export$2e2bcd8739ae039 = Object.freeze($113288872a6dc781$var$organizations);


const $75cfa3bec577f0bb$var$permissions = {
    search_placeholder: "API 또는 권한 이름으로 검색",
    search_placeholder_without_api: "권한 이름으로 검색",
    name_column: "권한",
    description_column: "설명",
    api_column: "API",
    placeholder_title: "권한",
    placeholder_description: "권한은 리소스(API 리소스라고 함)에 액세스할 수 있는 권한을 의미해요.",
    edit: "편집 권한",
    delete: "삭제 권한",
    remove: "제거 권한",
    edit_title: "API 권한 편집"
};
var $75cfa3bec577f0bb$export$2e2bcd8739ae039 = Object.freeze($75cfa3bec577f0bb$var$permissions);


const $1c27b9221a52610f$var$profile = {
    page_title: "계정 설정",
    title: "계정 설정",
    description: "계정 보안을 위해 여기에서 계정 설정을 변경하고 개인 정보를 관리하세요.",
    settings: {
        title: "프로필 설정",
        profile_information: "프로필 정보",
        avatar: "아바타",
        name: "이름",
        username: "사용자 이름"
    },
    link_account: {
        title: "계정 연동",
        email_sign_in: "이메일 로그인",
        email: "이메일",
        social_sign_in: "소셜 로그인",
        link_email: "이메일 연동",
        link_email_subtitle: "이메일을 연결하여 로그인하거나 계정을 복구할 때 도움을 받으세요.",
        email_required: "이메일 입력 필요",
        invalid_email: "잘못된 이메일 주소",
        identical_email_address: "입력한 이메일 주소가 현재 이메일 주소와 동일해요.",
        anonymous: "익명"
    },
    password: {
        title: "비밀번호 및 보안",
        password: "비밀번호",
        password_setting: "비밀번호 설정",
        new_password: "새 비밀번호",
        confirm_password: "비밀번호 확인",
        enter_password: "현재 비밀번호를 입력하세요",
        enter_password_subtitle: "계정 보안을 위해 본인 확인을 해주세요. 변경하기 전에 현재 비밀번호를 입력해주세요.",
        set_password: "비밀번호 설정",
        verify_via_password: "비밀번호로 인증",
        show_password: "비밀번호 보이기",
        required: "비밀번호 필요",
        do_not_match: "비밀번호가 일치하지 않아요. 다시 시도해 주세요."
    },
    code: {
        enter_verification_code: "인증 코드 입력",
        enter_verification_code_subtitle: "인증 코드가 <strong>{{target}}</strong>(으)로 발송되었어요.",
        verify_via_code: "인증 코드로 인증하기",
        resend: "인증 코드 재전송",
        resend_countdown: "{{countdown}}초 후 재전송"
    },
    delete_account: {
        title: "계정 삭제",
        label: "계정 삭제",
        description: "계정을 삭제하면 모든 개인 정보, 사용자 데이터 및 설정이 삭제돼요. 이 작업은 되돌릴 수 없어요.",
        button: "계정 삭제",
        dialog_paragraph_1: "계정을 삭제하시게 되어 유감입니다. 계정을 삭제하면 사용자 정보, 로그, 설정을 포함한 모든 데이터가 영구적으로 삭제되며, 이 작업은 되돌릴 수 없어요. 따라서 계속 진행하기 전에 중요한 데이터를 백업해 두세요.",
        dialog_paragraph_2: '계정 삭제 절차를 진행하려면 "Account Deletion Request"라는 제목으로 지원팀에 <a>메일</a>을 보내주세요. 당신의 모든 데이터가 시스템에서 올바르게 삭제될 수 있도록 도와드릴게요.',
        dialog_paragraph_3: "Logto Cloud를 선택해 주셔서 감사합니다. 추가 질문이나 우려 사항이 있으시면 언제든지 문의해 주세요."
    },
    set: "설정",
    change: "변경",
    link: "연결",
    unlink: "연결 해제",
    not_set: "설정 안 됨",
    change_avatar: "아바타 변경",
    change_name: "이름 변경",
    change_username: "사용자 이름 변경",
    set_name: "이름 설정",
    email_changed: "이메일이 변경되었어요.",
    password_changed: "비밀번호가 변경되었어요.",
    updated: "{{target}}이/가 수정되었어요.",
    linked: "{{target}}이/가 연결되었어요.",
    unlinked: "{{target}}이/가 연결 해제되었어요.",
    email_exists_reminder: "이메일 {{email}}은/는 이미 존재하는 계정에 연결되어 있어요. 다른 이메일을 연결하세요.",
    unlink_confirm_text: "연결 해제",
    unlink_reminder: "연결을 해제하면 사용자들이 <span></span> 계정으로 로그인하지 못할 거예요. 정말로 진행할까요?"
};
var $1c27b9221a52610f$export$2e2bcd8739ae039 = Object.freeze($1c27b9221a52610f$var$profile);


const $374519b6649d35f0$var$protected_app = {
    name: "보호된 앱",
    title: "보호된 앱 생성: 간편한 인증 및 뛰어난 속도로 추가하세요",
    description: "보호된 앱은 사용자 세션을 안전하게 유지하고 앱 요청을 프록시로 전달합니다. Cloudflare Workers를 통해 제공되며 전 세계에서 최고 수준의 성능과 0ms의 콜드 스타트를 경험하세요. <a>더 알아보기</a>",
    fast_create: "빠르게 생성",
    modal_title: "보호된 앱 생성",
    modal_subtitle: "클릭 몇 번으로 보안 및 빠른 보호 기능을 활성화하세요. 기존 웹 앱에 쉽게 인증을 추가하세요.",
    form: {
        url_field_label: "원본 URL",
        url_field_placeholder: "https://domain.com/",
        url_field_description: "인증 보호가 필요한 앱의 주소를 제공하세요.",
        url_field_modification_notice: "원본 URL에 대한 수정 사항은 전 세계 네트워크 위치에서 효과가 발생하기까지 1-2분이 소요될 수 있습니다.",
        url_field_tooltip: "애플리케이션의 주소를 제공하세요. '/pathname'을 제외한 주소를 제공하세요. 생성 후에는 라우트 인증 규칙을 사용자화할 수 있습니다.\n\n참고: 원본 URL 자체에는 인증이 필요하지 않으며, 보호는 지정된 앱 도메인을 통해 액세스에 배타적으로 적용됩니다.",
        domain_field_label: "앱 도메인",
        domain_field_placeholder: "your-domain",
        domain_field_description: "이 URL은 원본 URL에 대한 인증 보호 프록시로 작동합니다. 생성 후에 사용자 정의 도메인을 적용할 수 있습니다.",
        domain_field_description_short: "이 URL은 원본 URL에 대한 인증 보호 프록시로 작동합니다.",
        domain_field_tooltip: "Logto로 보호된 앱은 기본적으로 'your-domain.{{domain}}'에서 호스팅됩니다. 생성 후에 사용자 정의 도메인을 적용할 수 있습니다.",
        create_application: "애플리케이션 생성",
        create_protected_app: "빠르게 생성",
        errors: {
            domain_required: "도메인을 입력하세요.",
            domain_in_use: "이 서브도메인 이름은 이미 사용 중입니다.",
            invalid_domain_format: "잘못된 서브도메인 형식: 소문자, 숫자, 하이픈 '-'만 사용하세요.",
            url_required: "원본 URL을 입력하세요.",
            invalid_url: "잘못된 원본 URL 형식: http:// 또는 https://를 사용하세요. 참고: '/pathname'은 현재 지원되지 않습니다.",
            localhost: "로컬 서버를 먼저 인터넷에 노출시켜야 합니다. <a>로컬 개발</a>에 대해 더 알아보기."
        }
    },
    success_message: "\uD83C\uDF89 앱 인증이 성공적으로 활성화되었습니다! 새로운 웹 사이트 경험을 탐색하세요."
};
var $374519b6649d35f0$export$2e2bcd8739ae039 = Object.freeze($374519b6649d35f0$var$protected_app);


const $b36d19348d423773$var$role_details = {
    back_to_roles: "역할로 돌아가기",
    identifier: "식별자",
    delete_description: "이렇게 하면 영향을 받는 사용자에게서 이 역할과 관련된 권한이 제거되고 역할, 사용자 및 권한 간의 매핑이 삭제될 걈에요.",
    role_deleted: "{{name}}이 성공적으로 삭제되었어요.",
    general_tab: "일반",
    users_tab: "사용자",
    m2m_apps_tab: "기계 대 기계 앱",
    permissions_tab: "권한",
    settings: "설정",
    settings_description: "역할은 사용자에게 할당된 권한들의 모음이에요. 역할은 다양한 API에 정의된 권한들을 통합하는 방법을 제공하기 때문에, 사용자에게 개별적으로 할당하는 것보다 효율적으로 권한을 추가, 제거, 조정할 수 있어요.",
    field_name: "이름",
    field_description: "설명",
    field_is_default: "기본 역할",
    field_is_default_description: "새 사용자에게 기본 역할로 설정합니다. 여러 기본 역할을 설정할 수 있습니다. 이는 Management API를 통해 생성된 사용자에 대한 기본 역할에도 영향을 미칩니다.",
    type_m2m_role_tag: "기계 대 기계 앱 역할",
    type_user_role_tag: "사용자 역할",
    m2m_role_notification: "이 머신 투 머신 역할을 머신 투 머신 앱에 할당하여 관련 API 리소스에 액세스할 수 있습니다. <a>아직 만들지 않은 경우에는 먼저 머신 투 머신 앱을 만드십시오.</a>",
    permission: {
        assign_button: "권한 할당",
        assign_title: "권한 할당",
        assign_subtitle: "이 역할에 권한을 할당해요. 이 역할은 추가된 권한을 할당받고, 이 역할을 가진 이용자들은 이 권한들을 상속받을 거예요.",
        assign_form_field: "권한 할당",
        added_text_one: "권한 {{count, number}}개 추가됨",
        added_text_other: "권한 {{count, number}}개 추가됨",
        api_permission_count_one: "권한 {{count, number}}개",
        api_permission_count_other: "권한 {{count, number}}개",
        confirm_assign: "권한 할당",
        permission_assigned: "선택된 권한들이 이 역할에 성공적으로 할당되었어요.",
        deletion_description: "이 권한이 삭제되면, 이 역할에 영향을 받는 사용자가 이 권한에 의해 부여된 접근 권한을 잃게 돼요.",
        permission_deleted: '권한 "{{name}}"이 이 역할에서 성공적으로 삭제되었어요.',
        empty: "권한 없음"
    },
    users: {
        assign_button: "사용자 할당",
        name_column: "사용자",
        app_column: "앱",
        latest_sign_in_column: "최근 로그인 시각",
        delete_description: "사용자는 사용자 목록에 남지만 이 역할에 대한 접근 권한을 잃어버릴 거예요.",
        deleted: "{{name}}이 이 역할에서 성공적으로 삭제되었어요.",
        assign_title: "사용자 할당",
        assign_subtitle: "사용자를 이 역할에 할당해요. 이름, 이메일, 전화번호, 사용자 ID 등을 이용하여 적절한 사용자를 찾아 보세요.",
        assign_field: "사용자 할당",
        confirm_assign: "사용자 할당",
        assigned_toast_text: "선택된 사용자가 이 역할에 성공적으로 할당되었어요",
        empty: "사용자 없음"
    },
    applications: {
        assign_button: "앱 할당",
        name_column: "앱",
        app_column: "앱",
        description_column: "설명",
        delete_description: "이 앱은 앱 모음에 남아 있지만 이 역할에 대한 권한을 상실하게 됩니다.",
        deleted: "{{name}} 이(가) 이 역할에서 성공적으로 제거되었습니다.",
        assign_title: "앱 할당",
        assign_subtitle: "이 역할에 앱 할당 적절한 앱을 이름, 설명 또는 앱 ID로 검색하여 찾아보세요.",
        assign_field: "앱 할당",
        confirm_assign: "앱 할당",
        assigned_toast_text: "선택된 앱이 이 역할에 성공적으로 할당되었습니다",
        empty: "사용 가능한 앱 없음"
    }
};
var $b36d19348d423773$export$2e2bcd8739ae039 = Object.freeze($b36d19348d423773$var$role_details);


const $1c07cd620e5546ac$var$roles = {
    page_title: "역할",
    title: "역할",
    subtitle: "역할은 사용자가 무엇을 할 수 있는지를 결정하는 권한을 포함해요. RBAC는 사용자에게 특정 행동에 대한 접근 권한을 부여하기 위해 역할을 사용해요.",
    create: "역할 생성",
    role_name: "역할 이름",
    role_type: "역할 유형",
    show_role_type_button_text: "더 많은 옵션 표시",
    hide_role_type_button_text: "더 많은 옵션 숨기기",
    type_user: "사용자 역할",
    type_machine_to_machine: "기계 간 앱 역할",
    role_description: "설명",
    role_name_placeholder: "역할 이름을 입력하세요",
    role_description_placeholder: "역할 설명을 입력하세요",
    col_roles: "역할들",
    col_type: "유형",
    col_description: "설명",
    col_assigned_entities: "할당됨",
    user_counts: "{{count}} 명의 사용자",
    application_counts: "{{count}} 개의 앱",
    user_count: "{{count}} 명의 사용자",
    application_count: "{{count}} 개의 앱",
    assign_permissions: "권한 할당",
    create_role_title: "역할 생성",
    create_role_description: "당신의 애플리케이션을 위한 역할을 생성하고 관리해요. 역할은 권한들의 모음을 포함하며 사용자에게 할당될 수 있어요.",
    create_role_button: "역할 생성",
    role_created: "역할 {{name}}이 성공적으로 생성되었어요.",
    search: "역할 이름, 설명, ID로 검색",
    placeholder_title: "역할",
    placeholder_description: "역할은 사용자에게 할당할 수 있는 권한의 모임이에요. 역할을 만들기 전에 먼저 권한을 추가해야 해요.",
    assign_user_roles: "사용자 역할 할당",
    assign_m2m_roles: "기계 간 역할 할당",
    management_api_access_notification: "Logto 관리 API 액세스를 위해 관리 API 권한이있는 역할을 선택하십시오 <flag/>.",
    with_management_api_access_tip: "이 기계 간 역할에는 Logto 관리 API 권한이 포함되어 있습니다"
};
var $1c07cd620e5546ac$export$2e2bcd8739ae039 = Object.freeze($1c07cd620e5546ac$var$roles);


const $c685fd44c0ae8513$var$session_expired = {
    title: "세션 만료",
    subtitle: "세션이 만료되었거나, 끊겼어요. 다시 로그인해 주세요.",
    button: "다시 로그인하기"
};
var $c685fd44c0ae8513$export$2e2bcd8739ae039 = Object.freeze($c685fd44c0ae8513$var$session_expired);


const $4009fa4cef10c775$var$content = {
    terms_of_use: {
        title: "TERMS",
        terms_of_use: "Terms of use URL",
        terms_of_use_placeholder: "https://your.terms.of.use/",
        privacy_policy: "Privacy policy URL",
        privacy_policy_placeholder: "https://your.privacy.policy/"
    },
    languages: {
        title: "LANGUAGES",
        enable_auto_detect: "Enable auto-detect",
        description: "Your software detects the user's locale setting and switches to the local language. You can add new languages by translating UI from English to another language.",
        manage_language: "Manage language",
        default_language: "Default language",
        default_language_description_auto: "The default language will be used when the detected user language isn’t covered in the current language library.",
        default_language_description_fixed: "When auto-detect is off, the default language is the only language your software will show. Turn on auto-detect for language extension."
    },
    manage_language: {
        title: "Manage language",
        subtitle: "Localize the product experience by adding languages and translations. Your contribution can be set as the default language.",
        add_language: "Add Language",
        logto_provided: "Logto provided",
        key: "Key",
        logto_source_values: "Logto source values",
        custom_values: "Custom values",
        clear_all_tip: "Clear all values",
        unsaved_description: "Changes won’t be saved if you leave this page without saving.",
        deletion_tip: "Delete the language",
        deletion_title: "Do you want to delete the added language?",
        deletion_description: "After deletion, your users won’t be able to browse in that language again.",
        default_language_deletion_title: "Default language can’t be deleted.",
        default_language_deletion_description: "{{language}} is set as your default language and can’t be deleted. "
    }
};
var $4009fa4cef10c775$export$2e2bcd8739ae039 = Object.freeze($4009fa4cef10c775$var$content);


const $9cfe0a0371eec257$var$password_policy = {
    password_requirements: "비밀번호 요구사항",
    minimum_length: "최소 길이",
    minimum_length_description: "NIST는 <a>최소 8자리</a>를 권장합니다.",
    minimum_length_error: "최소 길이는 {{min}} ~ {{max}}(포함) 사이여야 합니다.",
    minimum_required_char_types: "최소 필요 문자 유형",
    minimum_required_char_types_description: "문자 유형: 대문자(A-Z), 소문자(a-z), 숫자(0-9), 특수 기호({{symbols}}).",
    password_rejection: "비밀번호 거부",
    compromised_passwords: "위험한 비밀번호",
    breached_passwords: "유출된 비밀번호",
    breached_passwords_description: "이전에 유출된 비밀번호를 거부합니다.",
    restricted_phrases: "보안속에 좋지 않은 구구절",
    restricted_phrases_tooltip: "3글자 이상의 다른 글자와 함께 조합하지 않는 한 이러한 구문을 피하세요.",
    repetitive_or_sequential_characters: "반복된 혹은 순차적인 문자",
    repetitive_or_sequential_characters_description: '예: "AAAA", "1234", "abcd" 등.',
    user_information: "사용자 정보",
    user_information_description: "예: 이메일 주소, 전화 번호, 사용자 이름 등.",
    custom_words: "사용자 정의 단어",
    custom_words_description: "컨텍스트에 따라 맞춤형 단어입니다. 대소문자를 구분하지 않으며, 한 줄에 하나씩 작성하세요.",
    custom_words_placeholder: "서비스 이름, 회사 이름 등."
};
var $9cfe0a0371eec257$export$2e2bcd8739ae039 = Object.freeze($9cfe0a0371eec257$var$password_policy);


const $3e69044f91f056f8$var$sign_up_and_sign_in = {
    identifiers_email: "이메일 주소",
    identifiers_phone: "휴대전화번호",
    identifiers_username: "사용자 이름",
    identifiers_email_or_sms: "이메일 주소 또는 휴대전화번호",
    identifiers_none: "해당 없음",
    and: "그리고",
    or: "또는",
    sign_up: {
        title: "회원가입",
        sign_up_identifier: "회원가입 ID",
        identifier_description: "회원가입 ID는 계정을 생성하기 위해 필수이며, 회원가입 화면에서 반드시 포함되어야 해요.",
        sign_up_authentication: "회원가입 인증 설정",
        authentication_description: "선택된 모든 작업들은 사용자가 모두 마무리해야 해요.",
        set_a_password_option: "비밀번호 생성",
        verify_at_sign_up_option: "회원가입 인증",
        social_only_creation_description: "(이것은 소셜 전용 계정 생성에 적용돼요.)"
    },
    sign_in: {
        title: "로그인",
        sign_in_identifier_and_auth: "로그인을 위한 ID 그리고 인증 설정",
        description: "사용자는 주어진 옵션 중에 아무 방법으로 로그인할 수 있어요. 주어진 옵션을 드래그하여 조절해 주세요.",
        add_sign_in_method: "로그인 방법 추가",
        password_auth: "비밀번호",
        verification_code_auth: "인증 코드",
        auth_swap_tip: "아래 옵션을 변경하여 흐름에 가장 먼저 나타나는 옵션을 설정할 수 있어요.",
        require_auth_factor: "반드시 최소 하나의 인증 방법을 선택해야 해요."
    },
    social_sign_in: {
        title: "소셜 로그인",
        social_sign_in: "소셜 로그인",
        description: "설정된 필수 ID에 따라서 사용자가 소셜 연동을 통해 회원가입, 로그인을 할 수 있어요.",
        add_social_connector: "소셜 연동으로",
        set_up_hint: {
            not_in_list: "리스트에 없나요?",
            set_up_more: "다른 소셜 연동",
            go_to: "을 설정해 보세요."
        }
    },
    tip: {
        set_a_password: "사용자 이름에 대한 고유한 암호 집합은 필수예요.",
        verify_at_sign_up: "현재 확인된 이메일만 지원해요. 유효성 검사가 없는 경우 사용자 기반에 품질이 낮은 전자 메일 주소가 많이 포함되어 있을 수 있어요.",
        password_auth: "회원가입 중에 비밀번호를 설정하는 옵션을 사용으로 설정했기 때문에 이 옵션은 필수예요.",
        verification_code_auth: "가입 시 인증 코드를 제공하는 옵션만 활성화했기 때문에 이것은 필수예요. 회원가입에서 비밀번호 설정이 허용되면 이 옵션을 취소할 수 있어요.",
        delete_sign_in_method: "{{identifier}}를 필수 ID로 설정했기 때문에 이 옵션은 필수예요."
    },
    advanced_options: {
        title: "고급 옵션",
        enable_single_sign_on: "Enterprise Single Sign-On (SSO) 활성화",
        enable_single_sign_on_description: "회사 신원 정보와 함께 Single Sign-On을 사용하여 애플리케이션에 로그인할 수 있도록 합니다.",
        single_sign_on_hint: {
            prefix: "다음 위치로 이동: ",
            link: '"기업 SSO"',
            suffix: "영역에서 사업체 커넥터를 추가 설정하세요."
        },
        enable_user_registration: "사용자 등록 활성화",
        enable_user_registration_description: "사용자 등록을 활성화하거나 비활성화합니다. 비활성화된 경우 사용자는 관리 콘솔에서는 추가할 수 있지만 사용자는 더 이상 로그인 UI를 통해 계정을 설정할 수 없습니다."
    }
};
var $3e69044f91f056f8$export$2e2bcd8739ae039 = Object.freeze($3e69044f91f056f8$var$sign_up_and_sign_in);


const $efb1b1f6e211c2c7$var$sign_in_exp = {
    page_title: "로그인 경험",
    title: "로그인 경험",
    description: "로그인 화면을 브랜드에 맞게 사용자화하고 실시간으로 확인해 보세요.",
    tabs: {
        branding: "브랜딩",
        sign_up_and_sign_in: "회원가입/로그인",
        content: "내용",
        password_policy: "암호 정책"
    },
    welcome: {
        title: "로그인 경험 사용자화",
        description: "첫 로그인 설정으로 빠르게 시작하세요. 이 가이드가 필요한 모든 설정에 대해 안내할 거예요.",
        get_started: "시작하기",
        apply_remind: "이 계정이 관리하는 모든 앱의 로그인 경험이 수정되는 것을 주의해 주세요."
    },
    color: {
        title: "색상",
        primary_color: "브랜드 색상",
        dark_primary_color: "브랜드 색상 (다크 모드)",
        dark_mode: "다크 모드 활성화",
        dark_mode_description: "Logto가 브랜드 색상에 알맞게 자동으로 다크 모드 테마를 생성해요.",
        dark_mode_reset_tip: "브랜드 색상에 알맞게 다크 모드 색상",
        reset: "재생성"
    },
    branding: {
        title: "브랜딩 영역",
        ui_style: "스타일",
        favicon: "파비콘",
        logo_image_url: "앱 로고 이미지 URL",
        logo_image_url_placeholder: "https://your.cdn.domain/logo.png",
        dark_logo_image_url: "앱 로고 이미지 URL (다크 모드)",
        dark_logo_image_url_placeholder: "https://your.cdn.domain/logo-dark.png",
        logo_image: "앱 로고",
        dark_logo_image: "앱 로고 (다크 모드)",
        logo_image_error: "앱 로고: {{error}}",
        favicon_error: "파비콘: {{error}}"
    },
    custom_css: {
        title: "사용자 정의 CSS",
        css_code_editor_title: "사용자 정의 CSS로 UI 개인화",
        css_code_editor_description1: "사용자 정의 CSS의 예시를 확인하세요.",
        css_code_editor_description2: "<a>{{link}}</a>",
        css_code_editor_description_link_content: "더 알아보기",
        css_code_editor_content_placeholder: "사용자 정의 CSS를 입력하여 원하는 대로 스타일을 조정할 수 있어요. 창의성을 표현하고 UI를 돋보이게 만드세요."
    },
    sign_up_and_sign_in: $3e69044f91f056f8$export$2e2bcd8739ae039,
    content: $4009fa4cef10c775$export$2e2bcd8739ae039,
    password_policy: $9cfe0a0371eec257$export$2e2bcd8739ae039,
    setup_warning: {
        no_connector_sms: 'SMS 연동 설정이 아직 없어요. 이 구성을 완료하기 전에는 사용자가 이 로그인 방식으로 로그인 할 수 없어요. "연동 설정"에서 <a>{{link}}</a>하세요.',
        no_connector_email: '이메일 연동 설정이 아직 없어요. 이 구성을 완료하기 전에는 사용자가 이 로그인 방식으로 로그인 할 수 없어요. "연동 설정"에서 <a>{{link}}</a>하세요.',
        no_connector_social: '아직 소셜 커넥터를 설정하지 않았습니다. 소셜 로그인 방법을 적용하려면 먼저 커넥터를 추가하십시오. "커넥터"에서 <a>{{link}}</a>을(를) 확인하십시오.',
        setup_link: "설정"
    },
    save_alert: {
        description: "새 로그인 및 회원가입 방법을 추가하고 있어요. 모든 사용자가 새 설정의 영향을 받을 수 있어요. 정말로 추가할까요?",
        before: "이전",
        after: "이후",
        sign_up: "회원가입",
        sign_in: "로그인",
        social: "소셜"
    },
    preview: {
        title: "로그인 화면 미리보기",
        live_preview: "실시간 미리보기",
        live_preview_tip: "저장하여 변경 사항 미리보기",
        native: "네이티브",
        desktop_web: "데스크톱 웹",
        mobile_web: "모바일 웹",
        desktop: "데스크톱",
        mobile: "모바일"
    }
};
var $efb1b1f6e211c2c7$export$2e2bcd8739ae039 = Object.freeze($efb1b1f6e211c2c7$var$sign_in_exp);


const $d8de969cf2afb503$var$signing_keys = {
    title: "서명 키",
    description: "애플리케이션에서 사용되는 서명 키를 안전하게 관리합니다.",
    private_key: "OIDC 개인 키",
    private_keys_description: "OIDC 개인 키는 JWT 토큰을 서명하는 데 사용됩니다.",
    cookie_key: "OIDC 쿠키 키",
    cookie_keys_description: "OIDC 쿠키 키는 쿠키를 서명하는 데 사용됩니다.",
    private_keys_in_use: "사용 중인 개인 키",
    cookie_keys_in_use: "사용 중인 쿠키 키",
    rotate_private_keys: "개인 키 회전",
    rotate_cookie_keys: "쿠키 키 회전",
    rotate_private_keys_description: "이 작업은 새로운 개인 서명 키를 생성하고 현재 키를 회전시키고 이전 키를 삭제합니다. 현재 키로 서명 된 JWT 토큰은 삭제하거나 다른 회전할 때까지 유효합니다.",
    rotate_cookie_keys_description: "이 작업은 새 쿠키 키를 생성하고 현재 키를 회전하며 이전 키를 삭제합니다. 현재 키로 서명 된 쿠키는 삭제하거나 다른 회전할 때까지 유효합니다.",
    select_private_key_algorithm: "새 개인 키의 서명 키 알고리즘 선택",
    rotate_button: "회전",
    table_column: {
        id: "ID",
        status: "상태",
        algorithm: "서명 키 알고리즘"
    },
    status: {
        current: "현재",
        previous: "이전"
    },
    reminder: {
        rotate_private_key: "정말 <strong>OIDC 개인 키</strong>를 회전하시겠습니까? 새로 발급 된 JWT 토큰은 새 키로 서명됩니다. 기존 JWT 토큰은 회전할 때까지 유효합니다.",
        rotate_cookie_key: "정말 <strong>OIDC 쿠키 키</strong>를 회전하시겠습니까? 로그인 세션에서 생성 된 새로운 쿠키는 새 쿠키 키로 서명됩니다. 기존 쿠키는 회전할 때까지 유효합니다.",
        delete_private_key: "정말 <strong>OIDC 개인 키</strong>를 삭제하시겠습니까? 이전에 개인 서명 키로 서명 된 기존 JWT 토큰은 더 이상 유효하지 않게 됩니다.",
        delete_cookie_key: "정말 <strong>OIDC 쿠키 키</strong>를 삭제하시겠습니까? 이전에 이 쿠키 키로 서명 된 로그인 세션은 더 이상 유효하지 않게 될 것입니다. 이 사용자들에게는 다시 인증이 필요합니다."
    },
    messages: {
        rotate_key_success: "서명 키가 성공적으로 회전되었습니다.",
        delete_key_success: "키가 성공적으로 삭제되었습니다."
    }
};
var $d8de969cf2afb503$export$2e2bcd8739ae039 = Object.freeze($d8de969cf2afb503$var$signing_keys);


const $e29abe70df6a351f$var$quota_item = {
    tenant_limit: {
        name: "성주",
        limited: "{{count, number}} 성주",
        limited_other: "{{count, number}} 성주",
        unlimited: "제한 없는 성주",
        not_eligible: "성주를 제거하십시오"
    },
    mau_limit: {
        name: "월간 활성 사용자",
        limited: "{{count, number}} 월간 활성 사용자",
        unlimited: "제한 없는 월간 활성 사용자",
        not_eligible: "모든 사용자를 제거하십시오"
    },
    token_limit: {
        name: "토큰",
        limited: "{{count, number}} 토큰",
        limited_other: "{{count, number}} 토큰",
        unlimited: "제한 없는 토큰",
        not_eligible: "새로운 토큰을 방지하려면 모든 사용자를 제거하십시오"
    },
    applications_limit: {
        name: "애플리케이션",
        limited: "{{count, number}} 애플리케이션",
        limited_other: "{{count, number}} 애플리케이션",
        unlimited: "제한 없는 애플리케이션",
        not_eligible: "애플리케이션을 제거하십시오"
    },
    machine_to_machine_limit: {
        name: "기계 간 통신",
        limited: "{{count, number}} 기계 간 앱",
        limited_other: "{{count, number}} 기계 간 앱",
        unlimited: "제한 없는 기계 간 앱",
        not_eligible: "기계 간 앱을 제거하십시오"
    },
    third_party_applications_limit: {
        name: "타사 앱",
        limited: "{{count, number}} 타사 앱",
        limited_other: "{{count, number}} 타사 앱",
        unlimited: "무제한 타사 앱",
        not_eligible: "타사 앱을 제거하십시오"
    },
    resources_limit: {
        name: "API 리소스",
        limited: "{{count, number}} API 리소스",
        limited_other: "{{count, number}} API 리소스",
        unlimited: "제한 없는 API 리소스",
        not_eligible: "API 리소스를 제거하십시오"
    },
    scopes_per_resource_limit: {
        name: "리소스 권한",
        limited: "{{count, number}} 리소스당 권한",
        limited_other: "{{count, number}} 리소스당 권한",
        unlimited: "제한 없는 리소스당 권한",
        not_eligible: "리소스 권한을 제거하십시오"
    },
    custom_domain_enabled: {
        name: "사용자 정의 도메인",
        limited: "사용자 정의 도메인",
        unlimited: "사용자 정의 도메인",
        not_eligible: "사용자 정의 도메인을 제거하십시오"
    },
    omni_sign_in_enabled: {
        name: "Omin 사인인",
        limited: "Omin 사인인",
        unlimited: "Omin 사인인",
        not_eligible: "Omin 사인인을 비활성화하세요"
    },
    built_in_email_connector_enabled: {
        name: "내장된 이메일 커넥터",
        limited: "내장된 이메일 커넥터",
        unlimited: "내장된 이메일 커넥터",
        not_eligible: "내장된 이메일 커넥터를 제거하십시오"
    },
    social_connectors_limit: {
        name: "소셜 커넥터",
        limited: "{{count, number}} 소셜 커넥터",
        limited_other: "{{count, number}} 소셜 커넥터",
        unlimited: "제한 없는 소셜 커넥터",
        not_eligible: "소셜 커넥터를 제거하십시오"
    },
    standard_connectors_limit: {
        name: "무료 표준 커넥터",
        limited: "{{count, number}} 무료 표준 커넥터",
        limited_other: "{{count, number}} 무료 표준 커넥터",
        unlimited: "제한 없는 표준 커넥터",
        not_eligible: "표준 커넥터를 제거하십시오"
    },
    roles_limit: {
        name: "역할",
        limited: "{{count, number}} 역할",
        limited_other: "{{count, number}} 역할",
        unlimited: "제한 없는 역할",
        not_eligible: "역할을 제거하십시오"
    },
    machine_to_machine_roles_limit: {
        name: "기계 간 역할",
        limited: "{{count, number}} 기계 간 역할",
        limited_other: "{{count, number}} 기계 간 역할",
        unlimited: "제한 없는 기계 간 역할",
        not_eligible: "기계 간 역할을 제거하십시오"
    },
    scopes_per_role_limit: {
        name: "역할 권한",
        limited: "{{count, number}} 역할당 권한",
        limited_other: "{{count, number}} 역할당 권한",
        unlimited: "제한 없는 역할당 권한",
        not_eligible: "역할 권한을 제거하십시오"
    },
    hooks_limit: {
        name: "웹훅",
        limited: "{{count, number}}개의 웹훅",
        limited_other: "{{count, number}}개의 웹훅",
        unlimited: "무제한 웹훅",
        not_eligible: "웹훅을 삭제하세요"
    },
    organizations_enabled: {
        name: "조직",
        limited: "조직",
        unlimited: "조직",
        not_eligible: "조직을 제거하십시오"
    },
    audit_logs_retention_days: {
        name: "감사 로그 보존 기간",
        limited: "감사 로그 보존 기간: {{count, number}} 일",
        limited_other: "감사 로그 보존 기간: {{count, number}} 일",
        unlimited: "제한 없는 기간",
        not_eligible: "감사 로그 없음"
    },
    email_ticket_support: {
        name: "이메일 지원 티켓",
        limited: "{{count, number}}시간 이메일 지원 티켓",
        limited_other: "{{count, number}}시간 이메일 지원 티켓",
        unlimited: "이메일 지원 티켓",
        not_eligible: "이메일 지원 티켓 없음"
    },
    mfa_enabled: {
        name: "다중 인증",
        limited: "다중 인증",
        unlimited: "다중 인증",
        not_eligible: "다중 인증 제거"
    },
    sso_enabled: {
        name: "기업 SSO",
        limited: "기업 SSO",
        unlimited: "기업 SSO",
        not_eligible: "기업 SSO를 제거하십시오"
    },
    tenant_members_limit: {
        name: "테넌트 멤버",
        limited: "{{count, number}} 테넌트 멤버",
        limited_other: "{{count, number}} 테넌트 멤버",
        unlimited: "제한 없는 테넌트 멤버",
        not_eligible: "테넌트 멤버를 제거하십시오"
    },
    custom_jwt_enabled: {
        name: "사용자 정의 JWT",
        limited: "사용자 정의 JWT",
        unlimited: "사용자 정의 JWT",
        not_eligible: "사용자 정의 JWT 클레임 사용자를 제거하십시오"
    }
};
var $e29abe70df6a351f$export$2e2bcd8739ae039 = Object.freeze($e29abe70df6a351f$var$quota_item);


const $db074048717a98f0$var$quota_table = {
    quota: {
        title: "기본",
        base_price: "기본 가격",
        mau_limit: "MAU 한도",
        included_tokens: "포함된 토큰"
    },
    application: {
        title: "애플리케이션",
        total: "총 애플리케이션 수",
        m2m: "머신 투 머신",
        third_party: "타사 앱"
    },
    resource: {
        title: "API 리소스",
        resource_count: "리소스 수",
        scopes_per_resource: "리소스 당 권한"
    },
    branding: {
        title: "UI 및 브랜딩",
        custom_domain: "사용자 정의 도메인",
        custom_css: "사용자 정의 CSS",
        app_logo_and_favicon: "앱 로고와 파비콘",
        dark_mode: "다크 모드",
        i18n: "국제화"
    },
    user_authn: {
        title: "사용자 인증",
        omni_sign_in: "옴니 로그인",
        password: "비밀번호",
        passwordless: "비밀번호 없음 - 이메일 및 SMS",
        email_connector: "이메일 커넥터",
        sms_connector: "SMS 커넥터",
        social_connectors: "소셜 커넥터",
        standard_connectors: "표준 커넥터",
        built_in_email_connector: "내장 이메일 커넥터",
        mfa: "다중 인증",
        sso: "기업 SSO",
        adaptive_mfa: "적응형 MFA"
    },
    user_management: {
        title: "사용자 관리",
        user_management: "사용자 관리",
        roles: "역할",
        machine_to_machine_roles: "머신 투 머신 역할",
        scopes_per_role: "역할 당 권한"
    },
    organizations: {
        title: "조직",
        organizations: "조직",
        organization: "조직",
        organization_count: "조직 수",
        allowed_users_per_org: "조직 당 허용된 사용자",
        invitation: "초대 (Management API)",
        org_roles: "조직 역할",
        org_permissions: "조직 권한",
        just_in_time_provisioning: "적시 프로비저닝"
    },
    support: {
        title: "컴플라이언스 및 지원",
        community: "커뮤니티",
        customer_ticket: "지원 티켓",
        premium: "프리미엄",
        email_ticket_support: "이메일 티켓 지원",
        soc2_report: "SOC2 보고서",
        hipaa_or_baa_report: "HIPAA/BAA 보고서"
    },
    developers_and_platform: {
        title: "개발자와 플랫폼",
        hooks: "웹훅",
        audit_logs_retention: "감사 로그 보존",
        jwt_claims: "JWT 클레임",
        tenant_members: "테넌트 멤버"
    },
    unlimited: "무제한",
    contact: "문의",
    monthly_price: "${{value, number}}/월",
    days_one: "{{count, number}} 일",
    days_other: "{{count, number}} 일",
    add_on: "부가 기능",
    tier: "레벨{{value, number}}: ",
    paid_token_limit_tip: "Logto는 할당량 한도를 초과하는 기능에 대해 요금을 부과할 것입니다. 2024년 제2분기부터 요금이 부과될 때까지 무료로 사용할 수 있습니다. 더 많은 토큰이 필요한 경우 저희에게 문의하십시오. 기본적으로 100만 토큰 당 월 $80을 청구합니다.",
    paid_quota_limit_tip: "Logto는 할당량 제한을 초과하는 기능에 대해 요금을 부과할 것입니다. 2024년 제2분기까지는 무료로 사용할 수 있습니다.",
    paid_add_on_feature_tip: "이것은 부가 기능입니다. 2024년 제2분기까지는 무료로 사용할 수 있습니다.",
    million: "{{value, number}} 백만",
    mau_tip: "MAU (월간 활성 사용자)는 청구 주기 동안 Logto와 적어도 하나의 토큰을 교환한 고유 사용자 수를 의미합니다.",
    tokens_tip: "Logto에서 발행한 모든 종류의 토큰, 액세스 토큰, 리프레시 토큰 등을 포함합니다.",
    mao_tip: "MAO (월간 활성 조직)는 빌링 주기 내에서 적어도 하나의 MAU (월간 활성 사용자)를 가진 고유한 조직의 수를 의미합니다.",
    third_party_tip: "타사 앱의 로그인 및 권한 부여에 대해 OIDC ID 공급자로서 Logto를 사용합니다.",
    included: "{{value, number}} 포함",
    included_mao: "{{value, number}} MAO 포함",
    extra_quota_price: "이후 월당 ${{value, number}} / 각각",
    per_month_each: "월당 ${{value, number}} / 각각",
    extra_mao_price: "이후 MAO당 ${{value, number}}",
    per_month: "월당 ${{value, number}}",
    per_member: "그런 다음 ${{value, number}} / 회원"
};
var $db074048717a98f0$export$2e2bcd8739ae039 = Object.freeze($db074048717a98f0$var$quota_table);


const $8d413a3b4ecb5114$var$subscription = {
    free_plan: "무료 요금제",
    free_plan_description: "사이드 프로젝트 및 초기 Logto 시험용. 신용 카드 없음.",
    pro_plan: "프로 요금제",
    pro_plan_description: "Logto와 함께 걱정 없이 비즈니스 혜택을 받으세요.",
    enterprise: "기업용",
    current_plan: "현재 요금제",
    current_plan_description: "현재 사용중인 요금제 정보입니다. 요금제 사용 내역을 쉽게 확인하고, 다가오는 청구서를 확인하며 필요에 따라 요금제를 변경할 수 있습니다.",
    plan_usage: "요금제 사용량",
    plan_cycle: "Plan cycle: {{period}}. 사용량은 {{renewDate}}에 갱신됩니다.",
    next_bill: "다음 청구서",
    next_bill_hint: "계산에 대해 자세히 알아보려면 이 <a>게시물</a>을 참조하세요.",
    next_bill_tip: "여기에 표시된 가격은 세금이 포함되어 있지 않습니다. 세금은 제공하는 정보와 지역 규정 요건을 기반으로 계산되어 청구서에 표시됩니다.",
    manage_payment: "결제 관리",
    overfill_quota_warning: "할당량 한도에 도달했습니다. 문제를 방지하기 위해 요금제를 업그레이드하세요.",
    upgrade_pro: "프로 업그레이드",
    update_payment: "결제 정보 업데이트",
    payment_error: "결제 문제가 발생했습니다. 이전 주기에 ${{price, number}}을(를) 처리할 수 없습니다. Logto 서비스 중단을 피하기 위해 결제를 업데이트하세요.",
    downgrade: "다운그레이드",
    current: "현재",
    upgrade: "업그레이드",
    quota_table: $db074048717a98f0$export$2e2bcd8739ae039,
    billing_history: {
        invoice_column: "송장",
        status_column: "상태",
        amount_column: "금액",
        invoice_created_date_column: "송장 생성 날짜",
        invoice_status: {
            void: "취소됨",
            paid: "지불 완료",
            open: "미결제",
            uncollectible: "연체"
        }
    },
    quota_item: $e29abe70df6a351f$export$2e2bcd8739ae039,
    downgrade_modal: {
        title: "다운그레이드하시겠습니까?",
        description: "<targetName />으로 전환하는 경우 이전에 <currentName />에 있던 할당량과 기능에 더 이상 액세스할 수 없음을 알려드립니다.",
        before: "이전: <name />",
        after: "이후: <name />",
        downgrade: "다운그레이드"
    },
    not_eligible_modal: {
        downgrade_title: "다운그레이드할 수 없습니다",
        downgrade_description: "<name/>로 다운그레이드하기 전에 다음 기준을 충족하는지 확인하세요.",
        downgrade_help_tip: "다운그레이드 도움이 필요하세요? <a>문의하세요</a>.",
        upgrade_title: "우리의 존경받는 초기 사용자를 위한 친절한 리마인더",
        upgrade_description: "현재 <name />이 허용하는 양보다 더 많이 사용하고 있습니다. 로그토는 이제 공식적으로 출시되었으며 각 플랜에 맞게 설계된 기능을 제공합니다. <name />로 업그레이드를 고려하기 전에, 업그레이드하기 전에 다음 기준을 충족하는지 확인하세요.",
        upgrade_pro_tip: " 또는 프로 플랜으로 업그레이드를 고려하세요.",
        upgrade_help_tip: "업그레이드 도움이 필요하세요? <a>문의하세요</a>.",
        a_maximum_of: "<item/> 최대 한도"
    },
    upgrade_success: "성공적으로 <name/>으로 업그레이드되었습니다.",
    downgrade_success: "성공적으로 <name/>으로 다운그레이드되었습니다.",
    subscription_check_timeout: "구독 확인이 타임아웃되었습니다. 나중에 다시 확인해주세요.",
    no_subscription: "구독 없음"
};
var $8d413a3b4ecb5114$export$2e2bcd8739ae039 = Object.freeze($8d413a3b4ecb5114$var$subscription);


const $49b0baa4cad414d4$var$tab_sections = {
    overview: "개요",
    authentication: "인증",
    authorization: "인가",
    users: "사용자",
    developer: "개발자",
    tenant: "임차인"
};
var $49b0baa4cad414d4$export$2e2bcd8739ae039 = Object.freeze($49b0baa4cad414d4$var$tab_sections);


const $e32f5683a378a07e$var$tabs = {
    get_started: "시작하기",
    dashboard: "대시보드",
    applications: "어플리케이션",
    api_resources: "API 리소스",
    sign_in_experience: "로그인 경험",
    connectors: "연동",
    enterprise_sso: "기업 SSO",
    webhooks: "웹훅",
    organizations: "조직",
    users: "사용자 관리",
    audit_logs: "감사 기록",
    roles: "역할",
    docs: "문서",
    tenant_settings: "테넌트 설정",
    mfa: "다중 요소 인증",
    customize_jwt: "사용자 지정 JWT",
    signing_keys: "서명 키",
    organization_template: "조직 템플릿"
};
var $e32f5683a378a07e$export$2e2bcd8739ae039 = Object.freeze($e32f5683a378a07e$var$tabs);


const $b0767094a851a889$var$tenant_members = {
    members: "멤버",
    invitations: "초대",
    invite_members: "멤버 초대",
    user: "사용자",
    roles: "역할",
    admin: "관리자",
    collaborator: "협력자",
    invitation_status: "초대 상태",
    inviter: "초대자",
    expiration_date: "만료 날짜",
    invite_modal: {
        title: "Logto Cloud로 사람 초대",
        subtitle: "조직에 멤버를 초대하려면 초대를 수락해야 합니다.",
        to: "받는 사람",
        added_as: "역할로 추가됨",
        email_input_placeholder: "johndoe@example.com"
    },
    invitation_statuses: {
        pending: "보류 중",
        accepted: "수락함",
        expired: "만료됨",
        revoked: "철회됨"
    },
    invitation_empty_placeholder: {
        title: "팀 멤버 초대",
        description: "귀하의 테넌트에는 현재 초대받은 멤버가 없습니다.\n통합에 도움을 주려면 더 많은 멤버나 관리자를 추가하세요."
    },
    menu_options: {
        edit: "테넌트 역할 편집",
        delete: "테넌트에서 사용자 제거",
        resend_invite: "초대 다시 보내기",
        revoke: "초대 철회",
        delete_invitation_record: "이 초대 기록 삭제"
    },
    edit_modal: {
        title: "{{name}}의 역할 변경"
    },
    delete_user_confirm: "이 사용자를 이 테넌트에서 제거하시겠습니까?",
    assign_admin_confirm: "선택한 사용자를 관리자로 지정하시겠습니까? 관리자 액세스 부여시 다음 권한이 부여됩니다.<ul><li>테넌트 요금제 변경</li><li>협력자 추가 또는 제거</li><li>테넌트 삭제</li></ul>",
    revoke_invitation_confirm: "이 초대를 철회하시겠습니까?",
    delete_invitation_confirm: "이 초대 기록을 삭제하시겠습니까?",
    messages: {
        invitation_sent: "초대가 전송되었습니다.",
        invitation_revoked: "초대가 철회되었습니다.",
        invitation_resend: "초대가 다시 전송되었습니다.",
        invitation_deleted: "초대 기록이 삭제되었습니다."
    },
    errors: {
        email_required: "초대 받는 사람 이메일은 필수입니다.",
        email_exists: "이메일 주소가 이미 존재합니다.",
        member_exists: "이 사용자는 이미 이 조직의 멤버입니다.",
        pending_invitation_exists: "보류 중인 초대가 있습니다. 관련 이메일을 삭제하거나 초대를 철회하세요.",
        invalid_email: "이메일 주소가 잘못되었습니다. 올바른 형식인지 확인하세요.",
        max_member_limit: "이 테넌트의 최대 멤버 수({{limit}}명)에 도달했습니다."
    }
};
var $b0767094a851a889$export$2e2bcd8739ae039 = Object.freeze($b0767094a851a889$var$tenant_members);


const $b5bc31ef22ed393b$var$tenants = {
    title: "설정",
    description: "테넌트 설정을 효율적으로 관리하고 도메인을 사용자 정의합니다.",
    tabs: {
        settings: "설정",
        members: "멤버",
        domains: "도메인",
        subscription: "구독 및 청구",
        billing_history: "청구 내역"
    },
    settings: {
        title: "설정",
        description: "테넌트 이름 설정 및 호스팅된 데이터 영역 및 테넌트 유형을 확인합니다.",
        tenant_id: "테넌트 ID",
        tenant_name: "테넌트 이름",
        tenant_region: "데이터 호스팅 영역",
        tenant_region_tip: "당신의 테넌트 자원은 {{region}}에 호스팅됩니다. <a>자세히 알아보기</a>",
        environment_tag_development: "개발",
        environment_tag_production: "프로드",
        tenant_type: "테넌트 유형",
        development_description: "테스트 용이며 프로덕션에서 사용하지 마십시오. 구독이 필요하지 않습니다. 모든 프로 기능이 있지만 로그인 배너와 같은 제한이 있습니다. <a>더 알아보기</a>",
        production_description: "최종 사용자가 사용하는 앱을 위한 것으로 유료 구독이 필요할 수 있습니다. <a>더 알아보기</a>",
        tenant_info_saved: "테넌트 정보가 성공적으로 저장되었습니다."
    },
    full_env_tag: {
        development: "개발",
        production: "프로드"
    },
    deletion_card: {
        title: "삭제",
        tenant_deletion: "테넌트 삭제",
        tenant_deletion_description: "테넌트를 삭제하면 관련된 모든 사용자 데이터와 설정이 영구적으로 삭제됩니다. 신중하게 진행해주십시오.",
        tenant_deletion_button: "테넌트 삭제"
    },
    leave_tenant_card: {
        title: "나가기",
        leave_tenant: "테넌트 나가기",
        leave_tenant_description: "테넌트에 속한 모든 리소스는 그대로 유지되지만 해당 테넌트에 더 이상 액세스할 수 없습니다.",
        last_admin_note: "테넌트에서 나가려면 최소 한 명 이상의 관리자가 있어야 합니다."
    },
    create_modal: {
        title: "테넌트 만들기",
        tenant_usage_purpose: "이 테넌트를 사용하는 목적은 무엇입니까?",
        development_description: "테스트 용으로만 사용하고 프로덕션에서 사용하지 마십시오. 구독이 필요하지 않습니다.",
        development_hint: "로그인 배너와 같은 제한이 있지만 모든 프로 기능이 있습니다.",
        production_description: "최종 사용자가 사용하기 위한 것으로 유료 구독이 필요할 수 있습니다.",
        available_plan: "사용 가능한 요금제:",
        create_button: "테넌트 만들기",
        tenant_name_placeholder: "내 테넌트"
    },
    dev_tenant_migration: {
        title: "사용자 정의 테넌트로 전환하여 Pro 기능을 무료로 이용할 수 있습니다!",
        affect_title: "이로 인한 영향은?",
        hint_1: "우리는 이전의 <strong>환경 태그</strong>를 <strong>“개발”</strong> 및 <strong>“프로드”</strong> 두 가지 새 테넌트 유형으로 대체합니다.",
        hint_2: "원활한 전환과 기능의 중단 없이 모든 초기 생성 된 테넌트가 이전 구독과 함께 <strong>프로드</strong> 테넌트 유형으로 상승합니다.",
        hint_3: "걱정 마세요. 다른 설정은 그대로 유지됩니다.",
        about_tenant_type: "테넌트 유형 정보"
    },
    delete_modal: {
        title: "테넌트 삭제",
        description_line1: '테넌트 "<span>{{name}}</span>" 을(를) 환경 접미사 태그 "<span>{{tag}}</span>" 와 함께 삭제하시겠습니까? 이 작업은 되돌릴 수 없으며 모든 데이터 및 테넌트 정보가 영구적으로 삭제됩니다.',
        description_line2: "테넌트 삭제 전에 도움을 받을 수도 있습니다. <span><a>이메일을 통해 문의하십시오</a></span>",
        description_line3: '확인하려는 테넌트 이름 "<span>{{name}}</span>" 을(를) 입력하십시오.',
        delete_button: "영구 삭제",
        cannot_delete_title: "이 테넌트를 삭제할 수 없습니다",
        cannot_delete_description: "죄송합니다. 현재이 테넌트를 삭제할 수 없습니다. 무료 플랜에 있고 미결제 청구서가 없는지 확인하십시오."
    },
    leave_tenant_modal: {
        description: "이 테넌트를 나가시겠습니까?",
        leave_button: "나가기"
    },
    tenant_landing_page: {
        title: "아직 테넌트를 만들지 않았습니다.",
        description: "Logto 를 사용하여 프로젝트를 구성하려면 새 테넌트를 만드세요. 로그아웃하거나 계정을 삭제하려면 오른쪽 상단 모서리에있는 아바타 버튼을 클릭하세요.",
        create_tenant_button: "테넌트 만들기"
    },
    status: {
        mau_exceeded: "MAU 초과",
        suspended: "정지됨",
        overdue: "만료됨"
    },
    tenant_suspended_page: {
        title: "테넌트 정지. 접근을 복구하려면 문의하세요.",
        description_1: "매우 유감스럽게도 테넌트 계정이 일시적으로 정지되었으며, MAU 한도 초과, 연체된 결제 또는 다른 무단 조치 등 부적절한 사용으로 인한 것입니다.",
        description_2: "자세한 설명이 필요한 경우, 우려 사항이 있거나 기능을 완전히 복원하고 테넌트를 차단 해제하려면 바로 연락 주시기 바랍니다."
    }
};
var $b5bc31ef22ed393b$export$2e2bcd8739ae039 = Object.freeze($b5bc31ef22ed393b$var$tenants);


const $0fbd8bf35a2dee73$var$topbar = {
    docs: "문서",
    help: "도움말"
};
var $0fbd8bf35a2dee73$export$2e2bcd8739ae039 = Object.freeze($0fbd8bf35a2dee73$var$topbar);


const $35ce519512ca27c0$var$featured_plan_content = {
    mau: {
        free_plan: "{{count, number}} MAU까지",
        pro_plan: "무제한 MAU"
    },
    m2m: {
        free_plan: "{{count, number}} 기기 간 통신",
        pro_plan: "추가 기기 간 통신"
    },
    third_party_apps: "타사 응용 프로그램을위한 IdP",
    mfa: "다중 인증",
    sso: "기업 SSO",
    role_and_permissions: {
        free_plan: "{{roleCount, number}} 역할 및 {{permissionCount, number}} 역할당 권한",
        pro_plan: "역할당 무제한 역할 및 권한"
    },
    organizations: "조직",
    audit_logs: "감사 로그 보존: {{count, number}} 일"
};
var $35ce519512ca27c0$export$2e2bcd8739ae039 = Object.freeze($35ce519512ca27c0$var$featured_plan_content);


const $f841edfe7692a6e3$var$paywall = {
    applications: "<planName/>의 {{count, number}}개 애플리케이션 제한에 도달했습니다. 팀의 요구를 충족하기 위해 플랜을 업그레이드하십시오. 도움이 필요하면 <a>문의</a>해 주시기 바랍니다.",
    applications_other: "<planName/>의 {{count, number}}개 애플리케이션 제한에 도달했습니다. 팀의 요구를 충족하기 위해 플랜을 업그레이드하십시오. 도움이 필요하면 <a>문의</a>해 주시기 바랍니다.",
    machine_to_machine_feature: "Switch to the <strong>Pro</strong> plan to gain extra machine-to-machine applications and enjoy all premium features. <a>Contact us</a> if you have questions.",
    machine_to_machine: "<planName/>의 {{count, number}}개 기계 간 애플리케이션 제한에 도달했습니다. 팀의 요구를 충족하기 위해 플랜을 업그레이드하십시오. 도움이 필요하면 <a>문의</a>해 주시기 바랍니다.",
    machine_to_machine_other: "<planName/>의 {{count, number}}개 기계 간 애플리케이션 제한에 도달했습니다. 팀의 요구를 충족하기 위해 플랜을 업그레이드하십시오. 도움이 필요하면 <a>문의</a>해 주시기 바랍니다.",
    resources: "<planName/>의 {{count, number}}개 API 리소스 한도에 도달했습니다. 팀의 요구를 충족시키기 위해 플랜을 업그레이드하세요. 도움이 필요하면 <a>문의하기</a>로 연락 주세요.",
    resources_other: "<planName/>의 {{count, number}}개 API 리소스 한도에 도달했습니다. 팀의 요구를 충족시키기 위해 플랜을 업그레이드하세요. 도움이 필요하면 <a>문의하기</a>로 연락 주세요.",
    scopes_per_resource: "<planName/>의 {{count, number}}개 API 리소스 당 권한 한도에 도달했습니다. 확장을 위해 지금 업그레이드하세요. 도움이 필요하면 <a>문의하기</a>로 연락 주세요.",
    scopes_per_resource_other: "<planName/>의 {{count, number}}개 API 리소스 당 권한 한도에 도달했습니다. 확장을 위해 지금 업그레이드하세요. 도움이 필요하면 <a>문의하기</a>로 연락 주세요.",
    custom_domain: "사용자 정의 도메인 기능을 잠금 해제하려면 <strong>Hobby</strong> 또는 <strong>Pro</strong> 플랜으로 업그레이드하세요. 도움이 필요하면 <a>문의</a>해 주시기 바랍니다.",
    social_connectors: "<planName/>의 {{count, number}}개 소셜 커넥터 한도에 도달했습니다. 팀의 요구를 충족시키기 위해 플랜을 업그레이드하고 OIDC, OAuth 2.0, SAML 프로토콜을 사용하여 고유한 커넥터를 생성할 수 있도록 하세요. 도움이 필요하면 <a>문의하기</a>로 연락 주세요.",
    social_connectors_other: "<planName/>의 {{count, number}}개 소셜 커넥터 한도에 도달했습니다. 팀의 요구를 충족시키기 위해 플랜을 업그레이드하고 OIDC, OAuth 2.0, SAML 프로토콜을 사용하여 고유한 커넥터를 생성할 수 있도록 하세요. 도움이 필요하면 <a>문의하기</a>로 연락 주세요.",
    standard_connectors_feature: "<strong>Hobby</strong> 또는 <strong>Pro</strong> 플랜으로 업그레이드하여 OIDC, OAuth 2.0, SAML 프로토콜을 사용하여 고유한 커넥터를 생성하고 모든 프리미엄 기능과 무제한 소셜 커넥터를 사용하십시오. 도움이 필요하면 <a>문의</a>해 주시기 바랍니다.",
    standard_connectors: "<planName/>의 {{count, number}}개 소셜 커넥터 한도에 도달했습니다. 팀의 요구를 충족시키기 위해 플랜을 업그레이드하고 OIDC, OAuth 2.0, SAML 프로토콜을 사용하여 고유한 커넥터를 생성할 수 있도록 하세요. 도움이 필요하면 <a>문의하기</a>로 연락 주세요.",
    standard_connectors_other: "<planName/>의 {{count, number}}개 소셜 커넥터 한도에 도달했습니다. 팀의 요구를 충족시키기 위해 플랜을 업그레이드하고 OIDC, OAuth 2.0, SAML 프로토콜을 사용하여 고유한 커넥터를 생성할 수 있도록 하세요. 도움이 필요하면 <a>문의하기</a>로 연락 주세요.",
    standard_connectors_pro: "<planName/>의 {{count, number}}개 표준 커넥터 한도에 도달했습니다. 팀의 요구를 충족시키기 위해 엔터프라이즈 플랜으로 업그레이드하고 OIDC, OAuth 2.0, SAML 프로토콜을 사용하여 고유한 커넥터를 생성할 수 있도록 하세요. 도움이 필요하면 <a>문의하기</a>로 연락 주세요.",
    standard_connectors_pro_other: "<planName/>의 {{count, number}}개 표준 커넥터 한도에 도달했습니다. 팀의 요구를 충족시키기 위해 엔터프라이즈 플랜으로 업그레이드하고 OIDC, OAuth 2.0, SAML 프로토콜을 사용하여 고유한 커넥터를 생성할 수 있도록 하세요. 도움이 필요하면 <a>문의하기</a>로 연락 주세요.",
    roles: "<planName/>의 {{count, number}}개 역할 한도에 도달했습니다. 플랜을 업그레이드하여 추가 역할과 권한을 추가하세요. 도움이 필요하면 <a>문의하기</a>로 연락 주세요.",
    roles_other: "<planName/>의 {{count, number}}개 역할 한도에 도달했습니다. 플랜을 업그레이드하여 추가 역할과 권한을 추가하세요. 도움이 필요하면 <a>문의하기</a>로 연락 주세요.",
    machine_to_machine_roles: "{{count, number}} machine-to-machine role of <planName/> limit reached. Upgrade plan to add additional roles and permissions. Feel free to <a>contact us</a> if you need any assistance.",
    machine_to_machine_roles_other: "{{count, number}} machine-to-machine roles of <planName/> limit reached. Upgrade plan to add additional roles and permissions. Feel free to <a>contact us</a> if you need any assistance.",
    scopes_per_role: "<planName/>의 {{count, number}}개 역할 당 권한 한도에 도달했습니다. 플랜을 업그레이드하여 추가 역할과 권한을 추가하세요. 도움이 필요하면 <a>문의하기</a>로 연락 주세요.",
    scopes_per_role_other: "<planName/>의 {{count, number}}개 역할 당 권한 한도에 도달했습니다. 플랜을 업그레이드하여 추가 역할과 권한을 추가하세요. 도움이 필요하면 <a>문의하기</a>로 연락 주세요.",
    hooks: "<planName/>의 {{count, number}}개 웹훅 한도에 도달했습니다. 더 많은 웹훅을 생성하려면 플랜을 업그레이드하세요. 도움이 필요하면 <a>문의하기</a>로 연락 주세요.",
    hooks_other: "<planName/>의 {{count, number}}개 웹훅 한도에 도달했습니다. 더 많은 웹훅을 생성하려면 플랜을 업그레이드하세요. 도움이 필요하면 <a>문의하기</a>로 연락 주세요.",
    mfa: "보안을 확인하기 위해 MFA를 잠금 해제하여 유료 플랜으로 업그레이드하세요. 궁금한 점이 있으면 <a>문의하세요</a>.",
    organizations: "Unlock organizations by upgrading to a paid plan. Don’t hesitate to <a>contact us</a> if you need any assistance.",
    third_party_apps: "로그토를 IdP로서 타사 앱에 대해 잠금 해제하려면 유료 플랜으로 업그레이드하세요. 도움이 필요하면 <a>문의하세요</a>.",
    sso_connectors: "엔터프라이즈 SSO를 잠금 해제하려면 유료 플랜으로 업그레이드하세요. 도움이 필요하면 <a>문의하세요</a>.",
    tenant_members: "협력 기능을 잠금 해제하려면 유료 플랜으로 업그레이드하세요. 도움이 필요하면 <a>문의하세요</a>.",
    tenant_members_dev_plan: "회원 제한에 도달했습니다. 새로운 회원을 추가하려면 회원을 해제하거나 보류 중인 초대를 철회하십시오. 더 많은 좌석이 필요하면 문의하십시오.",
    custom_jwt: {
        title: "사용자 정의 클레임 추가",
        description: "사용자 정의 JWT 기능 및 프리미엄 혜택을 위해 유료 플랜으로 업그레이드하세요. 궁금한 점이 있으면 <a>문의하세요</a>."
    }
};
var $f841edfe7692a6e3$export$2e2bcd8739ae039 = Object.freeze($f841edfe7692a6e3$var$paywall);


const $676b196904bfb723$var$upsell = {
    upgrade_plan: "플랜 업그레이드",
    compare_plans: "플랜 비교",
    view_plans: "플랜 보기",
    create_tenant: {
        title: "테넌트 플랜 선택하기",
        description: "Logto는 성장 중인 기업을 위해 혁신적이고 저렴한 가격으로 디자인된 경쟁력 있는 플랜 옵션을 제공합니다. <a>더 알아보기</a>",
        base_price: "기본 가격",
        monthly_price: "{{value, number}}/월",
        view_all_features: "모든 기능 보기",
        select_plan: "<name/> 선택",
        free_tenants_limit: "최대 {{count, number}}개 무료 테넌트",
        free_tenants_limit_other: "최대 {{count, number}}개 무료 테넌트",
        most_popular: "가장 인기 있는 플랜",
        upgrade_success: "<name/>으로 업그레이드 성공!"
    },
    mau_exceeded_modal: {
        title: "MAU 한도를 초과했습니다. 플랜을 업그레이드하세요.",
        notification: "현재 MAU가 <planName/>의 한도를 초과했습니다. 로그토 서비스 중단을 피하기 위해 프리미엄으로 플랜을 업그레이드하세요.",
        update_plan: "플랜 업데이트"
    },
    payment_overdue_modal: {
        title: "청구서 지불 연체",
        notification: "이런! 테넌트 <span>{{name}}</span>의 청구서 결제에 실패했습니다. Logto 서비스 중단을 피하기 위해 즉시 청구서를 지불하십시오.",
        unpaid_bills: "미납 청구서",
        update_payment: "지불 업데이트"
    },
    add_on_quota_item: {
        api_resource: "API 리소스",
        machine_to_machine: "머신 투 머신 애플리케이션",
        tokens: "{{limit}}M 토큰",
        tenant_member: "tenant 회원"
    },
    charge_notification_for_quota_limit: "{{item}} 할당량 한도를 초과했습니다. Logto는 할당량을 초과하는 사용에 대한 요금을 추가합니다. 새로운 애드온 가격 디자인이 출시된 날부터 청구가 시작됩니다. <a>더 알아보기</a>",
    paywall: $f841edfe7692a6e3$export$2e2bcd8739ae039,
    featured_plan_content: $35ce519512ca27c0$export$2e2bcd8739ae039
};
var $676b196904bfb723$export$2e2bcd8739ae039 = Object.freeze($676b196904bfb723$var$upsell);


const $0ff911b31c6e7a26$var$user_details = {
    page_title: "사용자 세부 정보",
    back_to_users: "사용자 관리로 돌아가기",
    created_title: "새로운 사용자가 생성되었어요.",
    created_guide: "사용자가 로그인하는데 도움이 되는 정보를 확인해보세요.",
    created_email: "이메일 주소:",
    created_phone: "휴대전화 번호:",
    created_username: "사용자 이름:",
    created_password: "비밀번호:",
    menu_delete: "삭제",
    delete_description: "이 사용자를 영원히 삭제할까요? 이 행동은 취소될 수 없어요.",
    deleted: "해당 사용자가 성공적으로 삭제되었어요.",
    reset_password: {
        reset_password: "비밀번호 초기화",
        title: "정말로 비밀번호를 초기화 할까요?",
        content: "정말로 비밀번호를 초기화 할까요? 이 행동은 취소될 수 없어요.",
        congratulations: "해당 사용자의 비밀번호가 성공적으로 초기화 되었어요.",
        new_password: "새로운 비밀번호:"
    },
    tab_settings: "설정",
    tab_roles: "역할",
    tab_logs: "사용자 기록",
    tab_organizations: "조직",
    authentication: "인증",
    authentication_description: "각 사용자는 모든 사용자 정보를 포함하는 프로파일을 가지고 있어요. 프로파일은 기본 데이터, 소셜 ID, 사용자 정의 데이터로 구성되어 있어요.",
    user_profile: "사용자 프로필",
    field_email: "이메일 주소",
    field_phone: "휴대전화 번호",
    field_username: "사용자 이름",
    field_name: "이름",
    field_avatar: "아바타 이미지 URL",
    field_avatar_placeholder: "https://your.cdn.domain/avatar.png",
    field_custom_data: "사용자 정의 데이터",
    field_custom_data_tip: "사용자 정의 색상 및 언어와 같은 미리 정의되지 않은 추가적인 사용자의 정보를 의미해요.",
    field_connectors: "연동된 소셜",
    field_sso_connectors: "기업 연결",
    custom_data_invalid: "사용자 정의 데이터는 반드시 유효한 JSON 객체여야 해요.",
    connectors: {
        connectors: "연동",
        user_id: "사용자 ID",
        remove: "삭제",
        connected: "이 사용자는 여러 소셜 연동에 연결되어 있어요.",
        not_connected: "이 사용자는 아직 소셜에 연동되지 않았아요.",
        deletion_confirmation: "기존 <name/> 신원을 제거하고 있습니다. 계속 진행하시겠습니까?"
    },
    sso_connectors: {
        connectors: "연결",
        enterprise_id: "기업 ID",
        connected: "이 사용자는 단일 로그인을 위한 여러 기업 신원 제공자에 연결되어 있어요.",
        not_connected: "이 사용자는 단일 로그인을 위한 어떤 기업 신원 제공자에도 연결되어 있지 않아요."
    },
    mfa: {
        field_name: "다단계 인증",
        field_description: "이 사용자는 2단계 인증 요소를 활성화했습니다.",
        name_column: "다단계 인증",
        field_description_empty: "이 사용자는 2단계 인증 요소를 활성화하지 않았습니다.",
        deletion_confirmation: "기존의 2단계 인증에서 <name/>을(를) 제거하고 있습니다. 계속 진행하시겠습니까?"
    },
    suspended: "정지됨",
    suspend_user: "사용자 정지",
    suspend_user_reminder: "이 사용자를 정지하시겠습니까? 사용자는 앱에 로그인할 수 없으며 현재 액세스 토큰이 만료된 후 새 액세스 토큰을 얻을 수 없게 됩니다. 또한 이 사용자가 수행한 모든 API 요청이 실패합니다.",
    suspend_action: "정지",
    user_suspended: "사용자가 정지되었습니다.",
    reactivate_user: "사용자 재활성화",
    reactivate_user_reminder: "이 사용자를 다시 활성화하시겠습니까? 이렇게 하면이 사용자에 대한 로그인 시도가 허용됩니다.",
    reactivate_action: "재활성화",
    user_reactivated: "사용자가 재활성화되었습니다.",
    roles: {
        name_column: "역할",
        description_column: "설명",
        assign_button: "역할 할당",
        delete_description: "이 행동은 사용자에게서 이 역할을 삭제할 거예요. 역할은 그대로 존재하지만, 이 사용자에게 더 이상 할당되지 않아요.",
        deleted: "{{name}}이/가 성공적으로 이 사용자에게서 제거되었어요.",
        assign_title: "{{name}}에게 역할 할당",
        assign_subtitle: "{{name}}에게 하나 이상의 역할을 할당하세요",
        assign_role_field: "역할 할당",
        role_search_placeholder: "역할 이름으로 검색",
        added_text: "{{value, number}}이/가 추가되었어요",
        assigned_user_count: "사용자 {{value, number}}명",
        confirm_assign: "역할 할당",
        role_assigned: "역할을 성공적으로 할당했어요",
        search: "역할 이름, 설명, ID로 검색",
        empty: "역할 없음"
    },
    warning_no_sign_in_identifier: "사용자는 로그인 식별자(사용자 이름, 이메일, 전화 번호 또는 소셜) 중 적어도 하나를 갖고 로그인해야 합니다. 계속 하시겠습니까?",
    organization_roles_tooltip: "조직 내에서 사용자에게 할당된 역할."
};
var $0ff911b31c6e7a26$export$2e2bcd8739ae039 = Object.freeze($0ff911b31c6e7a26$var$user_details);


const $ce99b86f04ad1f88$var$users = {
    page_title: "사용자 관리",
    title: "사용자 관리",
    subtitle: "사용자의 신원을 추가, 삭제, 수정, 조회하여 관리해보세요.",
    create: "사용자 추가",
    create_subtitle: "다음 중 적어도 하나의 필드를 제공해주세요.",
    error_missing_identifier: "사용자를 생성하려면 적어도 하나의 식별자를 제공해야 합니다.",
    user_name: "사용자",
    application_name: "어플리케이션으로부터",
    latest_sign_in: "최근 로그인 시각",
    create_form_username: "사용자 이름",
    create_form_password: "비밀번호",
    create_form_name: "이름",
    placeholder_name: "홍길동",
    placeholder_email: "honggildong@example.com",
    placeholder_username: "user123",
    placeholder_phone: "+82 2-1234-5678",
    unnamed: "이름없음",
    search: "이름, 이메일, 전화번호, ID로 검색",
    check_user_detail: "사용자 상세정보 확인",
    placeholder_title: "사용자 관리",
    placeholder_description: "각 사용자에게는 모든 사용자 정보가 포함된 프로필이 있어요. 프로필은 기본 데이터, 소셜 인증, 사용자 지정 데이터로 구성돼요."
};
var $ce99b86f04ad1f88$export$2e2bcd8739ae039 = Object.freeze($ce99b86f04ad1f88$var$users);


const $47ab545a64bf0764$var$webhook_details = {
    page_title: "Webhook 담당자",
    back_to_webhooks: "Webhooks로 돌아가기",
    not_in_use: "사용 중이 아님",
    success_rate: "성공율",
    requests: "24시간 동안 {{value, number}}개의 요청",
    disable_webhook: "Webhook 비활성화",
    disable_reminder: "이 webhook을 재활성화 하시겠습니까? 그렇게 한다면 엔드포인트 URL에 HTTP request를 보내지 않습니다.",
    webhook_disabled: "Webhook이 비활성화 되었습니다.",
    webhook_reactivated: "Webhook이 다시 활성화되었습니다.",
    reactivate_webhook: "Webhook 재활성화",
    delete_webhook: "Webhook 삭제",
    deletion_reminder: "이 webhook을 삭제하고 있습니다. 삭제 후, 엔드포인트 URL에 HTTP request를 보내지 않습니다.",
    deleted: "Webhook이 성공적으로 삭제되었습니다.",
    settings_tab: "설정",
    recent_requests_tab: "최근 요청 (24시간)",
    settings: {
        settings: "설정",
        settings_description: "Webhooks를 통해 이벤트가 발생할 때마다 POST request를 내 엔드포인트 URL로 보내 변경 실시간으로 확인 할 수 있습니다.",
        events: "이벤트",
        events_description: "Logto에서 POST request를 보낼 이벤트를 선택하세요.",
        name: "이름",
        endpoint_url: "엔드포인트 URL",
        signing_key: "Signing key",
        signing_key_tip: "Logto에서 제공된 시크릿 키를 사용하여 엔드포인트에 요청 헤더로 추가하여 웹훅 페이로드의 진위성 보장",
        regenerate: "재생성",
        regenerate_key_title: "Signing key 재생성",
        regenerate_key_reminder: "Signing key를 수정하시겠습니까? 재생성하면 즉시 적용됩니다. 엔드포인트에서 Signing key를 동기화 하시기 바랍니다.",
        regenerated: "Signing key가 재생성되었습니다.",
        custom_headers: "사용자 지정 헤더",
        custom_headers_tip: "이벤트에 대한 컨텍스트 또는 메타데이터를 제공하기 위해 webhook 페이로드에 사용자 지정 헤더를 추가할 수 있습니다.",
        key_duplicated_error: "키는 반복될 수 없습니다.",
        key_missing_error: "키는 필수 값입니다.",
        value_missing_error: "값은 필수 값입니다.",
        invalid_key_error: "키가 유효하지 않습니다",
        invalid_value_error: "값이 유효하지 않습니다",
        test: "테스트",
        test_webhook: "Webhook 테스트",
        test_webhook_description: "웹훅을 구성하고 각 선택한 이벤트의 페이로드 예제로 검증하여 올바른 수신 및 처리를 확인하세요.",
        send_test_payload: "테스트 페이로드 보내기",
        test_result: {
            endpoint_url: "엔드포인트 URL: {{url}}",
            message: "메시지: {{message}}",
            response_status: "응답 상태: {{status, number}}",
            response_body: "응답 본문: {{body}}",
            request_time: "요청 시간: {{time}}",
            test_success: "엔드포인트로의 웹훅 테스트가 성공했습니다."
        }
    }
};
var $47ab545a64bf0764$export$2e2bcd8739ae039 = Object.freeze($47ab545a64bf0764$var$webhook_details);


const $d6b3aca8cfc68779$var$webhooks = {
    page_title: "웹훅",
    title: "웹훅",
    subtitle: "특정 이벤트에 대한 실시간 업데이트를 쉽게 수신할 수 있는 웹훅을 생성하세요.",
    create: "웹훅 생성",
    schemas: {
        interaction: "사용자 상호 작용",
        user: "사용자",
        organization: "조직",
        role: "역할",
        scope: "권한",
        organization_role: "조직 역할",
        organization_scope: "조직 권한"
    },
    table: {
        name: "이름",
        events: "이벤트",
        success_rate: "성공률 (24시간)",
        requests: "요청 (24시간)"
    },
    placeholder: {
        title: "웹훅",
        description: 'POST 요청을 통해 엔드포인트 URL로 실시간 업데이트를 수신할 수 있는 웹훅을 생성하세요. "계정 만들기", "로그인" 및 "비밀번호 재설정"과 같은 이벤트에서 정보를 받고 즉시 조치하세요.',
        create_webhook: "웹훅 생성"
    },
    create_form: {
        title: "웹훅 생성",
        subtitle: "사용자 이벤트에 대한 세부 정보가 포함된 POST 요청을 엔드포인트 URL로 보내는 Webhook을 추가합니다.",
        events: "이벤트",
        events_description: "Logto가 POST 요청을 보낼 트리거 이벤트를 선택합니다.",
        name: "이름",
        name_placeholder: "웹훅 이름 입력",
        endpoint_url: "엔드포인트 URL",
        endpoint_url_placeholder: "https://your.webhook.endpoint.url",
        endpoint_url_tip: "이벤트가 발생할 때 웹훅의 페이로드가 전송되는 엔드포인트 URL을 입력하세요.",
        create_webhook: "웹훅 생성",
        missing_event_error: "하나 이상의 이벤트를 선택해야 합니다."
    },
    webhook_created: "웹훅 {{name}} 가 성공적으로 생성되었습니다."
};
var $d6b3aca8cfc68779$export$2e2bcd8739ae039 = Object.freeze($d6b3aca8cfc68779$var$webhooks);


const $5b8b6984ff53e134$var$welcome = {
    title: "관리자 콘솔에 오신 것을 환영해요",
    description: "관리자 콘솔를 통해 프로그래밍 없이 Logto를 관리할 수 있어요. 새로 계정을 생성하고, Logto를 당신의 회사에 알맞게 수정해 보세요.",
    create_account: "계정 생성"
};
var $5b8b6984ff53e134$export$2e2bcd8739ae039 = Object.freeze($5b8b6984ff53e134$var$welcome);


const $3f482950682cd61d$var$admin_console = {
    title: "관리자 콘솔",
    admin_user: "관리자",
    system_app: "시스템",
    menu: $3e5fffb2543b7756$export$2e2bcd8739ae039,
    general: $dc6eab6da5b7de00$export$2e2bcd8739ae039,
    errors: $72f40b5871dfd700$export$2e2bcd8739ae039,
    tab_sections: $49b0baa4cad414d4$export$2e2bcd8739ae039,
    tabs: $e32f5683a378a07e$export$2e2bcd8739ae039,
    applications: $99ab39a4b5160849$export$2e2bcd8739ae039,
    application_details: $e7a08b3684fcd75e$export$2e2bcd8739ae039,
    api_resources: $418fd2c168428ab1$export$2e2bcd8739ae039,
    api_resource_details: $909a25dd6304e2d7$export$2e2bcd8739ae039,
    connectors: $56242fe7cfaad683$export$2e2bcd8739ae039,
    connector_details: $5338e9a1b24f85fc$export$2e2bcd8739ae039,
    enterprise_sso: $977cfb51ff2428a6$export$2e2bcd8739ae039,
    enterprise_sso_details: $360c79467d06cad9$export$2e2bcd8739ae039,
    get_started: $cfb01c77e5294c57$export$2e2bcd8739ae039,
    users: $ce99b86f04ad1f88$export$2e2bcd8739ae039,
    user_details: $0ff911b31c6e7a26$export$2e2bcd8739ae039,
    contact: $314fbccf711b0647$export$2e2bcd8739ae039,
    sign_in_exp: $efb1b1f6e211c2c7$export$2e2bcd8739ae039,
    dashboard: $e15b81776b2a869f$export$2e2bcd8739ae039,
    logs: $6ae3be79eb86f3d8$export$2e2bcd8739ae039,
    log_details: $7a8ffb803720eace$export$2e2bcd8739ae039,
    session_expired: $c685fd44c0ae8513$export$2e2bcd8739ae039,
    welcome: $5b8b6984ff53e134$export$2e2bcd8739ae039,
    roles: $1c07cd620e5546ac$export$2e2bcd8739ae039,
    role_details: $b36d19348d423773$export$2e2bcd8739ae039,
    permissions: $75cfa3bec577f0bb$export$2e2bcd8739ae039,
    cloud: $394d8b00aa8b2385$export$2e2bcd8739ae039,
    profile: $1c27b9221a52610f$export$2e2bcd8739ae039,
    components: $5d8d0e85d30739c8$export$2e2bcd8739ae039,
    webhooks: $d6b3aca8cfc68779$export$2e2bcd8739ae039,
    webhook_details: $47ab545a64bf0764$export$2e2bcd8739ae039,
    domain: $457f94d46d7f6983$export$2e2bcd8739ae039,
    tenants: $b5bc31ef22ed393b$export$2e2bcd8739ae039,
    tenant_members: $b0767094a851a889$export$2e2bcd8739ae039,
    topbar: $0fbd8bf35a2dee73$export$2e2bcd8739ae039,
    subscription: $8d413a3b4ecb5114$export$2e2bcd8739ae039,
    upsell: $676b196904bfb723$export$2e2bcd8739ae039,
    guide: $484e8297070da8c8$export$2e2bcd8739ae039,
    mfa: $43812b39c2a0877c$export$2e2bcd8739ae039,
    organizations: $113288872a6dc781$export$2e2bcd8739ae039,
    organization_details: $e651b0b2e5221db9$export$2e2bcd8739ae039,
    protected_app: $374519b6649d35f0$export$2e2bcd8739ae039,
    jwt_claims: $64628f35a1b4b074$export$2e2bcd8739ae039,
    invitation: $47b4cceb82f3a773$export$2e2bcd8739ae039,
    signing_keys: $d8de969cf2afb503$export$2e2bcd8739ae039,
    organization_template: $156260f1c923cd68$export$2e2bcd8739ae039,
    organization_role_details: $a3951796d3447acd$export$2e2bcd8739ae039
};
var $3f482950682cd61d$export$2e2bcd8739ae039 = Object.freeze($3f482950682cd61d$var$admin_console);


const $f5d642512fec879f$var$demo_app = {
    title: "Live Preview에 성공적으로 로그인했습니다!",
    subtitle: "여기 로그인 정보가 있어요:",
    username: "사용자 이름: ",
    user_id: "사용자 ID: ",
    sign_out: "Live Preview에서 로그아웃",
    continue_explore: "또는 계속해서 살펴보기",
    customize_sign_in_experience: "로그인 경험 커스터마이징",
    enable_passwordless: "비밀번호 없는 로그인 활성화",
    add_social_connector: "소셜 연동 추가"
};
var $f5d642512fec879f$export$2e2bcd8739ae039 = Object.freeze($f5d642512fec879f$var$demo_app);


const $ff5284169ad16397$var$oidc = {
    logout_success: "성공적으로 로그아웃했습니다."
};
var $ff5284169ad16397$export$2e2bcd8739ae039 = Object.freeze($ff5284169ad16397$var$oidc);


const $89c51ecaca6e4750$var$translation = {
    admin_console: $3f482950682cd61d$export$2e2bcd8739ae039,
    demo_app: $f5d642512fec879f$export$2e2bcd8739ae039,
    oidc: $ff5284169ad16397$export$2e2bcd8739ae039
};
var $89c51ecaca6e4750$export$2e2bcd8739ae039 = Object.freeze($89c51ecaca6e4750$var$translation);


const $e5e7327eaf56d643$var$ko = {
    translation: $89c51ecaca6e4750$export$2e2bcd8739ae039,
    errors: $2a1c2b8e7652736e$export$2e2bcd8739ae039
};
var $e5e7327eaf56d643$export$2e2bcd8739ae039 = Object.freeze($e5e7327eaf56d643$var$ko);


const $83ce7b2e81878aaa$var$application = {
    invalid_type: "Tylko aplikacje maszyna-do-maszyny mogą mieć przypisane role.",
    role_exists: "Rola o identyfikatorze {{roleId}} została już dodana do tej aplikacji.",
    invalid_role_type: "Nie można przypisać roli typu użytkownika do aplikacji maszyna-do-maszyny.",
    invalid_third_party_application_type: "Tylko tradycyjne aplikacje internetowe mogą być oznaczone jako aplikacja zewnętrzna.",
    third_party_application_only: "Ta funkcja jest dostępna tylko dla aplikacji zewnętrznych.",
    user_consent_scopes_not_found: "Nieprawidłowe zakresy zgody użytkownika.",
    consent_management_api_scopes_not_allowed: "Nie są dozwolone zakresy API zarządzania.",
    protected_app_metadata_is_required: "Wymagane jest zabezpieczone metadane aplikacji.",
    protected_app_not_configured: "Dostawca aplikacji zabezpieczonej nie jest skonfigurowany. Ta funkcja nie jest dostępna dla wersji open source.",
    cloudflare_unknown_error: "Wystąpił nieznany błąd podczas żądania interfejsu API Cloudflare",
    protected_application_only: "Ta funkcja jest dostępna tylko dla aplikacji chronionych.",
    protected_application_misconfigured: "Aplikacja chroniona jest źle skonfigurowana.",
    protected_application_subdomain_exists: "Subdomena aplikacji chronionej jest już w użyciu.",
    invalid_subdomain: "Nieprawidłowa subdomena.",
    custom_domain_not_found: "Nie znaleziono niestandardowej domeny.",
    should_delete_custom_domains_first: "Należy najpierw usunąć niestandardowe domeny."
};
var $83ce7b2e81878aaa$export$2e2bcd8739ae039 = Object.freeze($83ce7b2e81878aaa$var$application);


const $36ad94d6f3534eff$var$auth = {
    authorization_header_missing: "Brak nagł\xf3wka autoryzacji",
    authorization_token_type_not_supported: "Nieobsługiwany typ autoryzacji",
    unauthorized: "Brak autoryzacji. Sprawdź swoje dane logowania i ich zakres.",
    forbidden: "Brak dostępu. Sprawdź swoje role użytkownika oraz uprawnienia.",
    expected_role_not_found: "Nie znaleziono oczekiwanej roli. Sprawdź swoje role użytkownika oraz uprawnienia.",
    jwt_sub_missing: "Brak `sub` w JWT.",
    require_re_authentication: "Wymagane ponowne uwierzytelnienie, aby wykonać chronione działanie."
};
var $36ad94d6f3534eff$export$2e2bcd8739ae039 = Object.freeze($36ad94d6f3534eff$var$auth);


const $64193af2d9cb7dd0$var$connector = {
    general: "Wystąpił błąd włącznika: {{errorDescription}}",
    not_found: "Nie można znaleźć dostępnego łącznika dla typu: {{type}}.",
    not_enabled: "Łącznik nie jest włączony.",
    invalid_metadata: "Metadane łącznika są nieprawidłowe.",
    invalid_config_guard: "Ochrona konfiguracji łącznika jest nieprawidłowa.",
    unexpected_type: "Typ łącznika jest nieoczekiwany.",
    invalid_request_parameters: "Żądanie jest z nieprawidłowym parametrem wejściowym/lub parametrami wejściowymi.",
    insufficient_request_parameters: "Żądanie może nie zawierać niekt\xf3rych parametr\xf3w wejściowych.",
    invalid_config: "Konfiguracja łącznika jest nieprawidłowa.",
    invalid_certificate: "Certyfikat łącznika jest nieprawidłowy, upewnij się, że certyfikat jest w kodowaniu PEM.",
    invalid_response: "Odpowiedź łącznika jest nieprawidłowa.",
    template_not_found: "Nie można znaleźć poprawnego szablonu w konfiguracji łącznika.",
    template_not_supported: "Łącznik nie obsługuje tego typu szablonu.",
    rate_limit_exceeded: "Ograniczenie szybkości wywołań. Spr\xf3buj ponownie p\xf3źniej.",
    not_implemented: "{{method}}: jeszcze nie zaimplementowano.",
    social_invalid_access_token: "Token dostępu łącznika jest nieprawidłowy.",
    invalid_auth_code: "Kod autoryzacji łącznika jest nieprawidłowy.",
    social_invalid_id_token: "Token ID łącznika jest nieprawidłowy.",
    authorization_failed: "Proces autoryzacji użytkownika zakończył się niepowodzeniem.",
    social_auth_code_invalid: "Nie udało się uzyskać tokenu dostępu, proszę sprawdzić kod autoryzacji.",
    more_than_one_sms: "Ilość łącznik\xf3w SMS jest większa niż 1.",
    more_than_one_email: "Ilość łącznik\xf3w e-mail jest większa niż 1.",
    more_than_one_connector_factory: "Znaleziono wiele fabryk łącznik\xf3w (z id {{connectorIds}}), możesz odinstalować niepotrzebne.",
    db_connector_type_mismatch: "W bazie danych znajduje się łącznik, kt\xf3ry nie pasuje do typu.",
    not_found_with_connector_id: "Nie można odnaleźć łącznika o podanym standardowym identyfikatorze łącznika.",
    multiple_instances_not_supported: "Nie można utworzyć wielu instancji z wybranym standardowym łącznikiem.",
    invalid_type_for_syncing_profile: "Możesz tylko synchronizować profil użytkownika z łącznikami społecznościowymi.",
    can_not_modify_target: "Nie można modyfikować 'target' łącznika.",
    should_specify_target: "Powinieneś/na/lno określić 'target'.",
    multiple_target_with_same_platform: "Nie można mieć wielu łącznik\xf3w społecznościowych z takim samym 'platforma i target'.",
    cannot_overwrite_metadata_for_non_standard_connector: 'Nie można nadpisać "metadata" tego łącznika, kt\xf3ry nie należy do standardu.'
};
var $64193af2d9cb7dd0$export$2e2bcd8739ae039 = Object.freeze($64193af2d9cb7dd0$var$connector);


const $0b7e4d0f02e13b7e$var$domain = {
    not_configured: "Dostawca nazw domen dla hosta nie jest skonfigurowany.",
    cloudflare_data_missing: "brak danych cloudflare, proszę sprawdzić.",
    cloudflare_unknown_error: "Otrzymano nieznany błąd podczas żądania API Cloudflare",
    cloudflare_response_error: "Otrzymano nieoczekiwaną odpowiedź od Cloudflare.",
    limit_to_one_domain: "Możesz mieć tylko jedną niestandardową domenę.",
    hostname_already_exists: "Ta domena już istnieje na naszym serwerze.",
    cloudflare_not_found: "Nie można znaleźć nazwy hosta w Cloudflare",
    domain_is_not_allowed: "Ta domena nie jest dozwolona."
};
var $0b7e4d0f02e13b7e$export$2e2bcd8739ae039 = Object.freeze($0b7e4d0f02e13b7e$var$domain);


const $74424b863b7730da$var$entity = {
    invalid_input: "Nieprawidłowe dane. Lista wartości nie może być pusta.",
    create_failed: "Nie udało się utworzyć {{name}}.",
    db_constraint_violated: "Constraint naruszenie bazy danych.",
    not_exists: "{{name}} nie istnieje.",
    not_exists_with_id: "{{name}} o identyfikatorze `{{id}}` nie istnieje.",
    not_found: "Zas\xf3b nie istnieje.",
    relation_foreign_key_not_found: "Nie można odnaleźć jednego lub więcej kluczy obcych. Proszę sprawdzić dane wejściowe i upewnić się, że wszystkie odwołane encje istnieją.",
    unique_integrity_violation: "Encja już istnieje. Proszę sprawdzić dane wejściowe i spr\xf3bować ponownie."
};
var $74424b863b7730da$export$2e2bcd8739ae039 = Object.freeze($74424b863b7730da$var$entity);


const $858200d7149c4343$var$guard = {
    invalid_input: "Żądanie {{type}} jest nieprawidłowe.",
    invalid_pagination: "Nieprawidłowa wartość paginacji żądania.",
    can_not_get_tenant_id: "Nie można pobrać identyfikatora najemcy z żądania.",
    file_size_exceeded: "Przekroczono rozmiar pliku.",
    mime_type_not_allowed: "Nie dozwolony typ MIME."
};
var $858200d7149c4343$export$2e2bcd8739ae039 = Object.freeze($858200d7149c4343$var$guard);


const $503ffd837cd57099$var$hook = {
    missing_events: "Musisz podać przynajmniej jedno zdarzenie.",
    send_test_payload_failed: "Błąd podczas wysyłania testowego ładunku: {{message}}",
    endpoint_responded_with_error: "Punkt końcowy odpowiedział błędem."
};
var $503ffd837cd57099$export$2e2bcd8739ae039 = Object.freeze($503ffd837cd57099$var$hook);


const $7373d1836c2b788f$var$jwt_customizer = {
    general: "Wystąpił błąd podczas dostosowywania tokenu JWT. Spr\xf3buj ponownie p\xf3źniej.",
    can_not_create_for_admin_tenant: "Nie można utworzyć dostosowywania tokenu JWT dla administratora."
};
var $7373d1836c2b788f$export$2e2bcd8739ae039 = Object.freeze($7373d1836c2b788f$var$jwt_customizer);


const $6c8394977f91a0a7$var$localization = {
    cannot_delete_default_language: "{{languageTag}} jest ustawiony jako Tw\xf3j język domyślny i nie można go usunąć.",
    invalid_translation_structure: "Nieprawidłowe schematy danych. Sprawdź swoje dane wejściowe i spr\xf3buj ponownie."
};
var $6c8394977f91a0a7$export$2e2bcd8739ae039 = Object.freeze($6c8394977f91a0a7$var$localization);


const $6f1225e2b521e916$var$log = {
    invalid_type: "Typ dziennika jest nieprawidłowy."
};
var $6f1225e2b521e916$export$2e2bcd8739ae039 = Object.freeze($6f1225e2b521e916$var$log);


const $9f99de84e40941c9$var$oidc = {
    aborted: "Koniec interakcji z użytkownikiem.",
    invalid_scope: "Nieprawidłowy zakres: {{error_description}}.",
    invalid_token: "Podano nieprawidłowy token.",
    invalid_client_metadata: "Podano nieprawidłowe metadane klienta.",
    insufficient_scope: "Token nie zawiera zakresu `{{scope}}`.",
    invalid_request: "Żądanie jest nieprawidłowe.",
    invalid_grant: "Żądanie przyznania jest nieprawidłowe.",
    invalid_redirect_uri: "Adres URL `redirect_uri` nie pasuje do zarejestrowanych przez klienta `redirect_uris`.",
    access_denied: "Odmowa dostępu.",
    invalid_target: "Nieprawidłowy wskaźnik zasob\xf3w.",
    unsupported_grant_type: "Żądany typ `grant_type` nie jest obsługiwany.",
    unsupported_response_mode: "Żądany tryb `response_mode` nie jest obsługiwany.",
    unsupported_response_type: "Żądany typ `response_type` nie jest obsługiwany.",
    provider_error: "Wewnętrzny błąd OIDC: {{message}}.",
    server_error: "Wystąpił nieznany błąd OIDC. Spr\xf3buj ponownie p\xf3źniej.",
    provider_error_fallback: "Wystąpił błąd OIDC: {{code}}.",
    key_required: "Wymagany jest co najmniej jeden klucz.",
    key_not_found: "Nie znaleziono klucza o ID {{id}}."
};
var $9f99de84e40941c9$export$2e2bcd8739ae039 = Object.freeze($9f99de84e40941c9$var$oidc);


const $f55900733f96b804$var$organization = {
    require_membership: "Użytkownik musi być członkiem organizacji, aby kontynuować."
};
var $f55900733f96b804$export$2e2bcd8739ae039 = Object.freeze($f55900733f96b804$var$organization);


const $42d840f12edf1840$var$password = {
    unsupported_encryption_method: "Metoda szyfrowania {{name}} nie jest obsługiwana.",
    pepper_not_found: "Nie znaleziono wartości pepper dla hasła. Sprawdź swoje zmienne środowiskowe.",
    rejected: "Odrzucono hasło. Sprawdź, czy spełnia ono wymagania."
};
var $42d840f12edf1840$export$2e2bcd8739ae039 = Object.freeze($42d840f12edf1840$var$password);


const $0866dc0b5c814880$var$request = {
    invalid_input: "Nieprawidłowe dane wejściowe. {{details}}",
    general: "Wystąpił błąd żądania."
};
var $0866dc0b5c814880$export$2e2bcd8739ae039 = Object.freeze($0866dc0b5c814880$var$request);


const $1bef125a648aa61b$var$resource = {
    resource_identifier_in_use: "Identyfikator API {{indicator}} jest już używany",
    cannot_delete_management_api: "Nie można usunąć interfejsu API zarządzania Logto.",
    cannot_modify_management_api: "Nie można modyfikować interfejsu API zarządzania Logto."
};
var $1bef125a648aa61b$export$2e2bcd8739ae039 = Object.freeze($1bef125a648aa61b$var$resource);


const $017e10f867e5d979$var$role = {
    name_in_use: "Ta nazwa roli {{name}} jest już w użyciu",
    scope_exists: "Identyfikator zakresu {{scopeId}} został już dodany do tej roli",
    management_api_scopes_not_assignable_to_user_role: "Nie można przypisać zakres\xf3w API zarządzania do roli użytkownika.",
    user_exists: "Identyfikator użytkownika {{userId}} został już dodany do tej roli",
    application_exists: "Identyfikator aplikacji {{applicationId}} został już dodany do tej roli",
    default_role_missing: "Niekt\xf3re z domyślnych nazw r\xf3l nie istnieją w bazie danych, upewnij się, że najpierw utworzysz role",
    internal_role_violation: 'Możesz pr\xf3bować zaktualizować lub usunąć rolę wewnętrzną, co jest zabronione przez Logto. Jeśli tworzysz nową rolę, spr\xf3buj innej nazwy, kt\xf3ra nie zaczyna się od "#internal:".\uFEFF'
};
var $017e10f867e5d979$export$2e2bcd8739ae039 = Object.freeze($017e10f867e5d979$var$role);


const $82f76e0b4a499c8b$var$scope = {
    name_exists: "Nazwa zakresu {{name}} jest już używana",
    name_with_space: "Nazwa zakresu nie może zawierać spacji."
};
var $82f76e0b4a499c8b$export$2e2bcd8739ae039 = Object.freeze($82f76e0b4a499c8b$var$scope);


const $20deb6413688bd43$var$session = {
    not_found: "Nie znaleziono sesji. Proszę wr\xf3cić i zalogować się ponownie.",
    invalid_credentials: "Niepoprawne konto lub hasło. Sprawdź swoje dane wejściowe.",
    invalid_sign_in_method: "Aktualna metoda logowania jest niedostępna.",
    invalid_connector_id: "Nie można znaleźć dostępnego łącznika o id {{connectorId}}.",
    insufficient_info: "Niewystarczające informacje do zalogowania.",
    connector_id_mismatch: "Id łącznika nie pasuje do rekordu sesji.",
    connector_session_not_found: "Nie znaleziono sesji łącznika. Proszę wr\xf3ć i zaloguj ponownie.",
    verification_session_not_found: "Weryfikacja nie powiodła się. Uruchom proces weryfikacji ponownie i spr\xf3buj ponownie.",
    verification_expired: "Połączenie wygasło. Zweryfikuj ponownie, aby zapewnić bezpieczeństwo Twojego konta.",
    verification_blocked_too_many_attempts: "Zbyt wiele pr\xf3b w kr\xf3tkim czasie. Proszę spr\xf3buj ponownie {{relativeTime}}.",
    unauthorized: "Proszę się najpierw zalogować.",
    unsupported_prompt_name: "Nieobsługiwana nazwa podpowiedzi.",
    forgot_password_not_enabled: "Odzyskiwanie hasła nie jest włączone.",
    verification_failed: "Weryfikacja nie powiodła się. Uruchom proces weryfikacji ponownie i spr\xf3buj ponownie.",
    connector_validation_session_not_found: "Nie znaleziono sesji łącznika dla weryfikacji tokena.",
    identifier_not_found: "Nie znaleziono identyfikatora użytkownika. Proszę wr\xf3ć i zaloguj się ponownie.",
    interaction_not_found: "Nie znaleziono sesji interakcji. Proszę wr\xf3ć i rozpocznij sesję ponownie.",
    not_supported_for_forgot_password: "Ta operacja nie jest obsługiwana dla zapomnienia hasła.",
    mfa: {
        require_mfa_verification: "Wymagana jest weryfikacja MFA, aby się zalogować.",
        mfa_sign_in_only: "MFA jest dostępne tylko dla interakcji logowania.",
        pending_info_not_found: "Nie znaleziono oczekujących informacji MFA, proszę najpierw zainicjować MFA.",
        invalid_totp_code: "Nieprawidłowy kod TOTP.",
        webauthn_verification_failed: "Weryfikacja WebAuthn nie powiodła się.",
        webauthn_verification_not_found: "Nie znaleziono weryfikacji WebAuthn.",
        bind_mfa_existed: "MFA już istnieje.",
        backup_code_can_not_be_alone: "Kod zapasowy nie może być jedyną MFA.",
        backup_code_required: "Kod zapasowy jest wymagany.",
        invalid_backup_code: "Nieprawidłowy kod zapasowy.",
        mfa_policy_not_user_controlled: "Polityka MFA nie jest kontrolowana przez użytkownika."
    },
    sso_enabled: "Single sign on jest włączony dla tego adresu e-mail. Zaloguj się za pomocą SSO."
};
var $20deb6413688bd43$export$2e2bcd8739ae039 = Object.freeze($20deb6413688bd43$var$session);


const $23bef486ccc238fa$var$sign_in_experiences = {
    empty_content_url_of_terms_of_use: 'Pusty adres URL zawartości "Regulaminu". Proszę dodać adres URL zawartości, jeśli funkcja "Regulamin" jest włączona.',
    empty_social_connectors: "Brak skojarzonych kont społecznościowych. Proszę dodać skojarzone konta społecznościowe, gdy metoda logowania za pomocą sieci społecznościowej jest włączona.",
    enabled_connector_not_found: "Nie znaleziono aktywowanego łącznika typu {{type}}.",
    not_one_and_only_one_primary_sign_in_method: "Musi istnieć jedna i tylko jedna podstawowa metoda logowania. Proszę sprawdzić swoje dane wejściowe.",
    username_requires_password: "Należy włączyć ustawienie hasła dla identyfikatora rejestracji nazwy użytkownika.",
    passwordless_requires_verify: "Należy włączyć weryfikację dla identyfikatora rejestracji adresu e-mail/telefonu.",
    miss_sign_up_identifier_in_sign_in: "Metody logowania muszą zawierać identyfikator rejestracji.",
    password_sign_in_must_be_enabled: "Logowanie za pomocą hasła musi być włączone, gdy w rejestracji wymagane jest ustawienie hasła.",
    code_sign_in_must_be_enabled: "Logowanie za pomocą kodu weryfikacyjnego musi być włączone, gdy w rejestracji nie jest wymagane ustawienie hasła.",
    unsupported_default_language: "Ten język - {{language}} nie jest obecnie obsługiwany.",
    at_least_one_authentication_factor: "Musisz wybrać co najmniej jeden czynnik uwierzytelniający.",
    backup_code_cannot_be_enabled_alone: "Kod zapasowy nie może być włączony samodzielnie.",
    duplicated_mfa_factors: "Powielone czynniki MFA."
};
var $23bef486ccc238fa$export$2e2bcd8739ae039 = Object.freeze($23bef486ccc238fa$var$sign_in_experiences);


const $db852cf9df5c4cfe$var$single_sign_on = {
    forbidden_domains: "Nie są dozwolone publiczne domeny e-mail.",
    duplicated_domains: "Istnieją zduplikowane domeny.",
    invalid_domain_format: "Nieprawidłowy format domeny.",
    duplicate_connector_name: "Nazwa łącznika już istnieje. Proszę wybrać inną nazwę."
};
var $db852cf9df5c4cfe$export$2e2bcd8739ae039 = Object.freeze($db852cf9df5c4cfe$var$single_sign_on);


const $fccde7800f8907fb$var$storage = {
    not_configured: "Nie skonfigurowano dostawcy magazynu.",
    missing_parameter: "Brak parametru {{parameter}} dla dostawcy magazynu.",
    upload_error: "Nie udało się przesłać pliku do dostawcy magazynu."
};
var $fccde7800f8907fb$export$2e2bcd8739ae039 = Object.freeze($fccde7800f8907fb$var$storage);


const $3f49fb16e354bc69$var$subscription = {
    limit_exceeded: "Osiągnąłeś limit swojego planu subskrypcji.",
    get_plan_failed: "Nie można pobrać planu subskrypcji dla najemcy.",
    tenant_suspended: "Najemca jest zawieszony. Skontaktuj się z administratorem."
};
var $3f49fb16e354bc69$export$2e2bcd8739ae039 = Object.freeze($3f49fb16e354bc69$var$subscription);


const $87c0b77d33d9f643$var$swagger = {
    invalid_zod_type: "Nieprawidłowy typ Zod. Sprawdź konfigurację straży routy.",
    not_supported_zod_type_for_params: "Nieobsługiwany typ Zod dla parametr\xf3w. Sprawdź konfigurację straży routy."
};
var $87c0b77d33d9f643$export$2e2bcd8739ae039 = Object.freeze($87c0b77d33d9f643$var$swagger);


const $eda55b4bf583611b$var$user = {
    username_already_in_use: "Nazwa użytkownika jest już zajęta.",
    email_already_in_use: "Ten email jest już powiązany z istniejącym kontem.",
    phone_already_in_use: "Ten numer telefonu jest już powiązany z istniejącym kontem.",
    invalid_email: "Nieprawidłowy adres email.",
    invalid_phone: "Nieprawidłowy numer telefonu.",
    email_not_exist: "Podany adres email nie został jeszcze zarejestrowany.",
    phone_not_exist: "Podany numer telefonu nie został jeszcze zarejestrowany.",
    identity_not_exist: "Konto społecznościowe nie zostało jeszcze zarejestrowane.",
    identity_already_in_use: "Konto społecznościowe zostało już powiązane z istniejącym kontem.",
    social_account_exists_in_profile: "To konto społecznościowe zostało już powiązane z Twoim profilem.",
    cannot_delete_self: "Nie możesz usunąć swojego konta.",
    sign_up_method_not_enabled: "Rejestracja tym sposobem jest wyłączona.",
    sign_in_method_not_enabled: "Logowanie tym sposobem jest wyłączone.",
    same_password: "Nowe hasło nie może być takie samo jak stare hasło.",
    password_required_in_profile: "Musisz ustawić hasło przed zalogowaniem.",
    new_password_required_in_profile: "Musisz ustawić nowe hasło.",
    password_exists_in_profile: "Hasło już istnieje w Twoim profilu.",
    username_required_in_profile: "Musisz ustawić nazwę użytkownika przed zalogowaniem.",
    username_exists_in_profile: "Nazwa użytkownika już istnieje w Twoim profilu.",
    email_required_in_profile: "Musisz dodać adres email przed zalogowaniem.",
    email_exists_in_profile: "Tw\xf3j profil jest już powiązany z adresem email.",
    phone_required_in_profile: "Musisz dodać numer telefonu przed zalogowaniem.",
    phone_exists_in_profile: "Tw\xf3j profil jest już powiązany z numerem telefonu.",
    email_or_phone_required_in_profile: "Musisz dodać adres email lub numer telefonu przed zalogowaniem.",
    suspended: "To konto jest zawieszone.",
    user_not_exist: "Użytkownik z identyfikatorem {{ identifier }} nie istnieje.",
    missing_profile: "Musisz podać dodatkowe informacje przed zalogowaniem.",
    role_exists: "Identyfikator roli {{roleId}} jest już dodany do tego użytkownika",
    invalid_role_type: "Nieprawidłowy typ roli, nie można przypisać roli maszynowej do użytkownika.",
    missing_mfa: "Musisz podłączyć dodatkowe MFA przed zalogowaniem.",
    totp_already_in_use: "TOTP jest już w użyciu.",
    backup_code_already_in_use: "Kod zapasowy jest już w użyciu.",
    password_algorithm_required: "Wymagany jest algorytm hasła.",
    password_and_digest: "Nie możesz ustawić zar\xf3wno hasła w postaci tekstu jawnego, jak i skr\xf3tu hasła."
};
var $eda55b4bf583611b$export$2e2bcd8739ae039 = Object.freeze($eda55b4bf583611b$var$user);


const $583c034c568df66d$var$verification_code = {
    phone_email_empty: "Oba pola telefonu i emaila są puste.",
    not_found: "Nie znaleziono kodu weryfikacyjnego. Proszę najpierw wysłać kod weryfikacyjny.",
    phone_mismatch: "Niepoprawny numer telefonu. Proszę poprosić o nowy kod weryfikacyjny.",
    email_mismatch: "Niepoprawny adres email. Proszę poprosić o nowy kod weryfikacyjny.",
    code_mismatch: "Nieprawidłowy kod weryfikacyjny.",
    expired: "Kod weryfikacyjny wygasł. Proszę poprosić o nowy kod weryfikacyjny.",
    exceed_max_try: "Osiągnięto limit pr\xf3b kodu weryfikacyjnego. Proszę poprosić o nowy kod weryfikacyjny."
};
var $583c034c568df66d$export$2e2bcd8739ae039 = Object.freeze($583c034c568df66d$var$verification_code);


const $71c0b6375fb312d0$var$errors = {
    request: $0866dc0b5c814880$export$2e2bcd8739ae039,
    auth: $36ad94d6f3534eff$export$2e2bcd8739ae039,
    guard: $858200d7149c4343$export$2e2bcd8739ae039,
    oidc: $9f99de84e40941c9$export$2e2bcd8739ae039,
    user: $eda55b4bf583611b$export$2e2bcd8739ae039,
    password: $42d840f12edf1840$export$2e2bcd8739ae039,
    session: $20deb6413688bd43$export$2e2bcd8739ae039,
    connector: $64193af2d9cb7dd0$export$2e2bcd8739ae039,
    verification_code: $583c034c568df66d$export$2e2bcd8739ae039,
    sign_in_experiences: $23bef486ccc238fa$export$2e2bcd8739ae039,
    jwt_customizer: $7373d1836c2b788f$export$2e2bcd8739ae039,
    localization: $6c8394977f91a0a7$export$2e2bcd8739ae039,
    swagger: $87c0b77d33d9f643$export$2e2bcd8739ae039,
    entity: $74424b863b7730da$export$2e2bcd8739ae039,
    log: $6f1225e2b521e916$export$2e2bcd8739ae039,
    role: $017e10f867e5d979$export$2e2bcd8739ae039,
    scope: $82f76e0b4a499c8b$export$2e2bcd8739ae039,
    storage: $fccde7800f8907fb$export$2e2bcd8739ae039,
    resource: $1bef125a648aa61b$export$2e2bcd8739ae039,
    hook: $503ffd837cd57099$export$2e2bcd8739ae039,
    domain: $0b7e4d0f02e13b7e$export$2e2bcd8739ae039,
    subscription: $3f49fb16e354bc69$export$2e2bcd8739ae039,
    application: $83ce7b2e81878aaa$export$2e2bcd8739ae039,
    organization: $f55900733f96b804$export$2e2bcd8739ae039,
    single_sign_on: $db852cf9df5c4cfe$export$2e2bcd8739ae039
};
var $71c0b6375fb312d0$export$2e2bcd8739ae039 = Object.freeze($71c0b6375fb312d0$var$errors);


const $65ab7d08e1ba50a8$var$api_resource_details = {
    page_title: "Szczeg\xf3ły zasob\xf3w API",
    back_to_api_resources: "Powr\xf3ć do zasob\xf3w API",
    general_tab: "Og\xf3lne",
    permissions_tab: "Uprawnienia",
    settings: "Ustawienia",
    settings_description: "Zasoby API, tzw. wskaźniki zasob\xf3w, wskazują na usługi lub zasoby docelowe, kt\xf3re mają być żądane, zwykle w zmiennej formatu URI reprezentującej tożsamość zasobu.",
    management_api_settings_description: "Logto Management API to kompleksowa kolekcja interfejs\xf3w API, kt\xf3re umożliwiają administratorom zarządzanie szerokim zakresem zadań związanych z tożsamością, egzekwowanie polityk bezpieczeństwa oraz przestrzeganie przepis\xf3w i standard\xf3w.",
    management_api_notice: "Ta API reprezentuje jednostkę Logto i nie może być modyfikowana ani usuwana. Utw\xf3rz aplikację maszyna-do-maszyny, aby wywołać Logto Management API. <a>Dowiedz się więcej</a>",
    token_expiration_time_in_seconds: "Czas wygaśnięcia tokenu (w sekundach)",
    token_expiration_time_in_seconds_placeholder: "Wprowadź czas wygaśnięcia tokenu",
    delete_description: "Tej akcji nie można cofnąć. Spowoduje to trwałe usunięcie zasobu API. Wpisz nazwę zasobu API <span>{{name}}</span>, aby potwierdzić.",
    enter_your_api_resource_name: "Wprowadź nazwę swojego zasobu API",
    api_resource_deleted: "Zas\xf3b API {{name}} został pomyślnie usunięty",
    permission: {
        create_button: "Utw\xf3rz uprawnienie",
        create_title: "Utw\xf3rz uprawnienie",
        create_subtitle: "Zdefiniuj uprawnienia (zakresy) wymagane przez to API.",
        confirm_create: "Utw\xf3rz uprawnienie",
        edit_title: "Edytuj uprawnienie",
        edit_subtitle: "Zdefiniuj uprawnienia (zakresy) wymagane przez API {{resourceName}}.",
        name: "Nazwa uprawnienia",
        name_placeholder: "ready:resource",
        forbidden_space_in_name: "Nazwa uprawnienia nie może zawierać spacji.",
        description: "Opis",
        description_placeholder: "Możliwość odczytu zasob\xf3w",
        permission_created: "Uprawnienie {{name}} zostało pomyślnie utworzone",
        delete_description: "Jeśli to uprawnienie zostanie usunięte, użytkownik, kt\xf3ry miał to uprawnienie, straci dostęp przyznany przez nie.",
        deleted: 'Uprawnienie "{{name}}" zostało pomyślnie usunięte.'
    }
};
var $65ab7d08e1ba50a8$export$2e2bcd8739ae039 = Object.freeze($65ab7d08e1ba50a8$var$api_resource_details);


const $1b943d35be7236c0$var$api_resources = {
    page_title: "Zasoby API",
    title: "Zasoby API",
    subtitle: "Definiuj API, z kt\xf3rych korzystać mogą twoje autoryzowane aplikacje",
    create: "Utw\xf3rz zas\xf3b API",
    api_name: "Nazwa API",
    api_name_placeholder: "Wprowadź nazwę swojego API",
    api_identifier: "Identyfikator API",
    api_identifier_placeholder: "https://tw\xf3j-identyfikator-api/",
    api_identifier_tip: "Unikalny identyfikator zasobu API. Musi to być bezwzględny adres URI bez składnika fragmentu (#). Jest r\xf3wny <a>parametrowi zasobu</a> w standardzie OAuth 2.0.",
    default_api: "Domyślne API",
    default_api_label: "Tylko jedno API domyślne może być ustawione na jeden najem. Kiedy określone zostanie API domyślne, parametr zasobu może zostać pominięty w żądaniu autoryzacji. Następujące procesy wymiany tokenu będą domyślnie korzystać z tego API, co umożliwi wydanie JWT. <a>Dowiedz się więcej</a>",
    api_resource_created: "Zas\xf3b API {{name}} został pomyślnie utworzony",
    invalid_resource_indicator_format: "Identyfikator API musi być poprawnym bezwzględnym adresem URI."
};
var $1b943d35be7236c0$export$2e2bcd8739ae039 = Object.freeze($1b943d35be7236c0$var$api_resources);


const $b56333da034cd769$var$application_details = {
    page_title: "Szczeg\xf3ły aplikacji",
    back_to_applications: "Powr\xf3t do aplikacji",
    check_guide: "Sprawdź przewodnik",
    settings: "Ustawienia",
    settings_description: "Aplikacja to zarejestrowane oprogramowanie lub usługa, kt\xf3ra może uzyskać dostęp do informacji użytkownika lub działać w imieniu użytkownika. Aplikacje pomagają rozpoznać, kto czego od Logto żąda i obsługują proces logowania oraz udzielania uprawnień. Wypełnij wymagane pola dla uwierzytelniania.",
    integration: "Integracja",
    integration_description: "Wdrożenie zabezpieczonych worker\xf3w Logto, zasilanych przez sieć rozproszoną Cloudflare, zapewniających najlepszą wydajność i zerowy czas uruchamiania odwołań na całym świecie.",
    service_configuration: "Konfiguracja usługi",
    service_configuration_description: "Uzupełnij niezbędne konfiguracje w swojej usłudze.",
    session: "Sesja",
    endpoints_and_credentials: "Punkty końcowe i dane uwierzytelniające",
    endpoints_and_credentials_description: "Użyj poniższych punkt\xf3w końcowych i danych uwierzytelniających do skonfigurowania połączenia OIDC w Twojej aplikacji.",
    refresh_token_settings: "Token odświeżania",
    refresh_token_settings_description: "Zarządzaj zasadami dotyczącymi tokena odświeżania dla tej aplikacji.",
    application_roles: "Role",
    machine_logs: "Dzienniki maszynowe",
    application_name: "Nazwa aplikacji",
    application_name_placeholder: "Moja aplikacja",
    description: "Opis",
    description_placeholder: "Wpisz opis swojej aplikacji",
    config_endpoint: "Konfiguracja punktu końcowego OpenID Provider",
    authorization_endpoint: "Endpoint autoryzacji",
    authorization_endpoint_tip: "Punkt końcowy wykorzystywany do uwierzytelniania i autoryzacji. Jest używany do OpenID Connect <a>uwierzytelniania</a>.",
    show_endpoint_details: "Pokaż szczeg\xf3ły punktu końcowego",
    hide_endpoint_details: "Ukryj szczeg\xf3ły punktu końcowego",
    logto_endpoint: "Punkt końcowy Logto",
    application_id: "ID aplikacji",
    application_id_tip: "Unikalny identyfikator aplikacji, kt\xf3ry zazwyczaj jest generowany przez Logto. Oznacza r\xf3wnież „<a>client_id</a>” w OpenID Connect.",
    application_secret: "Tajny kod aplikacji",
    redirect_uri: "Adres URL przekierowania",
    redirect_uris: "Adresy URL przekierowania",
    redirect_uri_placeholder: "https://twoja.strona.com/aplikacja",
    redirect_uri_placeholder_native: "io.logto://callback",
    redirect_uri_tip: "Adres URL, na kt\xf3ry użytkownik jest przekierowywany po zalogowaniu (zar\xf3wno pozytywnym, jak i negatywnym). Zobacz OpenID Connect <a>AuthRequest</a> po więcej informacji.",
    post_sign_out_redirect_uri: "Adres URL przekierowania po wylogowaniu",
    post_sign_out_redirect_uris: "Adresy URL przekierowania po wylogowaniu",
    post_sign_out_redirect_uri_placeholder: "https://twoja.strona.com/strona-startowa",
    post_sign_out_redirect_uri_tip: "Adres URL, na kt\xf3ry użytkownik jest przekierowywany po wylogowaniu (opcjonalnie). W niekt\xf3rych rodzajach aplikacji może to nie mieć praktycznego znaczenia.",
    cors_allowed_origins: "Dozwolone źr\xf3dła CORS",
    cors_allowed_origins_placeholder: "https://twoja.strona.com",
    cors_allowed_origins_tip: "Domyślnie dozwolone są wszystkie źr\xf3dła z adres\xf3w URL przekierowania. Zazwyczaj nie wymaga to żadnych działań. Zobacz <a>dokumentację MDN</a> dla szczeg\xf3łowych informacji.",
    token_endpoint: "Punkt końcowy tokena",
    user_info_endpoint: "Punkt końcowy informacji o użytkowniku",
    enable_admin_access: "Włącz dostęp administratora",
    enable_admin_access_label: "Włącz lub wyłącz dostęp do interfejsu API zarządzania. Po włączeniu możesz używać token\xf3w dostępu do wywoływania interfejsu API zarządzania w imieniu tej aplikacji.",
    always_issue_refresh_token: "Zawsze wydawaj token odświeżania",
    always_issue_refresh_token_label: "Ta konfiguracja umożliwia Logto zawsze wydawanie cewecznych token\xf3w, niezależnie od tego, czy w żądaniu autoryzacji został przekazany `prompt=consent`. Jednak ta praktyka jest odstraszana, chyba że konieczna, ponieważ nie jest w pełni zgodna z OpenID Connect i potencjalnie może powodować problemy.",
    refresh_token_ttl: "Czas życia tokena odświeżania w dniach",
    refresh_token_ttl_tip: "Okres, przez kt\xf3ry można używać tokena odświeżania do żądania nowych token\xf3w dostępu, zanim wygaśnie i zostanie unieważniony. Wymaga to przedłużenia czasu życia żądanego tokena.",
    rotate_refresh_token: "Obr\xf3ć token odświeżania",
    rotate_refresh_token_label: "Po włączeniu tej opcji Logto wydaje nowy token odświeżania dla żądań token\xf3w, gdy upłynęło 70% oryginalnego czasu życia (TTL) lub spełnione są określone warunki. <a>Dowiedz się więcej</a>",
    delete_description: "Ta operacja nie może zostać cofnięta. Spowoduje trwałe usunięcie aplikacji. Aby potwierdzić, wpisz nazwę aplikacji <span>{{name}}</span>.",
    enter_your_application_name: "Wpisz nazwę swojej aplikacji",
    application_deleted: "Aplikacja {{name}} została pomyślnie usunięta",
    redirect_uri_required: "Musisz podać co najmniej jeden adres URL przekierowania",
    app_domain_description_1: "Skorzystaj z domeny {{domain}} obsługiwanej przez Logto, kt\xf3ra jest trwale ważna.",
    app_domain_description_2: "Skorzystaj z domeny <domain>{{domain}}</domain>, kt\xf3ra jest trwale ważna.",
    custom_rules: "Niestandardowe zasady uwierzytelniania",
    custom_rules_placeholder: "^/(admin|privacy)/.+$",
    custom_rules_description: "Ustaw zasady z wyrażeniami regularnymi dla wymaganych tras wymagających uwierzytelniania. Domyślnie: ochrona całej strony, jeśli pole jest puste.",
    authentication_routes: "Trasy uwierzytelniania",
    custom_rules_tip: "Oto dwa scenariusze:<ol><li>Aby chronić tylko trasy „/admin” i „/privacy” za pomocą uwierzytelniania: ^/(admin|privacy)/.*</li><li>Aby wykluczyć obrazy JPG z uwierzytelniania: ^(?!.*\\.jpg$).*$</li></ol>",
    authentication_routes_description: "Przekieruj przycisk uwierzytelniania, korzystając z określonych tras. Uwaga: te trasy są niezastąpione.",
    protect_origin_server: "Zabezpiecz sw\xf3j serwer źr\xf3dłowy",
    protect_origin_server_description: "Upewnij się, że chronisz sw\xf3j serwer źr\xf3dłowy przed bezpośrednim dostępem. Odniesienie do przewodnika dla więcej <a>szczeg\xf3łowych instrukcji</a>.",
    session_duration: "Czas trwania sesji (dni)",
    try_it: "Wypr\xf3buj",
    branding: {
        name: "Branding",
        description: "Dostosuj nazwę i logo aplikacji na ekranie zgody.",
        more_info: "Więcej informacji",
        more_info_description: "Zaoferuj użytkownikom więcej szczeg\xf3ł\xf3w na temat Twojej aplikacji na ekranie zgody.",
        display_name: "Nazwa wyświetlana",
        display_logo: "Wyświetl logo",
        display_logo_dark: "Wyświetl logo (ciemne)",
        terms_of_use_url: "Adres URL warunk\xf3w użytkowania aplikacji",
        privacy_policy_url: "Adres URL polityki prywatności aplikacji"
    },
    permissions: {
        name: "Uprawnienia",
        description: "Wybierz uprawnienia, kt\xf3rych wymaga aplikacja innych firm do autoryzacji użytkownika w celu uzyskania dostępu do określonych typ\xf3w danych.",
        user_permissions: "Dane osobowe użytkownika",
        organization_permissions: "Dostęp do organizacji",
        table_name: "Udziel uprawnień",
        field_name: "Uprawnienie",
        field_description: "Wyświetlane na ekranie zgody",
        delete_text: "Usuń uprawnienie",
        permission_delete_confirm: "Ta czynność odwoła nadane uprawnienia dla aplikacji innej firmy, uniemożliwiając jej żądanie autoryzacji użytkownika do określonych typ\xf3w danych. Czy na pewno chcesz kontynuować?",
        permissions_assignment_description: "Wybierz uprawnienia, kt\xf3re aplikacja innej firmy ma żądać do uzyskania autoryzacji użytkownika do określonych typ\xf3w danych.",
        user_profile: "Dane użytkownika",
        api_permissions: "Uprawnienia API",
        organization: "Uprawnienia organizacyjne",
        user_permissions_assignment_form_title: "Dodaj uprawnienia do profilu użytkownika",
        organization_permissions_assignment_form_title: "Dodaj uprawnienia organizacji",
        api_resource_permissions_assignment_form_title: "Dodaj uprawnienia zasob\xf3w API",
        user_data_permission_description_tips: "Możesz zmodyfikować opis uprawnień do danych osobowych użytkownika za pomocą „Doświadczenia przy logowaniu > Zas\xf3b > Zarządzaj Językiem”",
        permission_description_tips: "Gdy Logto jest wykorzystywane jako Dostawca Tożsamości (IdP) do uwierzytelniania w aplikacjach innych firm, a użytkownicy są proszeni o autoryzację, ten opis pojawia się na ekranie zgody.",
        user_title: "Użytkownik",
        user_description: "Wybierz uprawnienia żądane przez aplikację innej firmy do uzyskania dostępu do określonych danych użytkownika.",
        grant_user_level_permissions: "Udziel uprawnień do danych użytkownika",
        organization_title: "Organizacja",
        organization_description: "Wybierz uprawnienia żądane przez aplikację innej firmy do uzyskania dostępu do określonych danych organizacyjnych.",
        grant_organization_level_permissions: "Udziel uprawnień do danych organizacyjnych"
    },
    roles: {
        name_column: "Rola",
        description_column: "Opis",
        assign_button: "Przypisz role",
        delete_description: "Ta czynność usunie tę rolę z tej aplikacji machine-to-machine. Rola ta nadal istnieje, ale nie będzie już powiązana z tą aplikacją machine-to-machine.",
        deleted: "{{name}} został(a) pomyślnie usunięty(ą) z tego użytkownika.",
        assign_title: "Przypisz role dla {{name}}",
        assign_subtitle: "Autoryzuj {{name}} jedną lub więcej r\xf3l",
        assign_role_field: "Przypisz role",
        role_search_placeholder: "Wyszukaj według nazwy roli",
        added_text: "{{value, number}} dodane",
        assigned_app_count: "{{value, number}} aplikacje",
        confirm_assign: "Przypisz role",
        role_assigned: "Pomyślnie przypisano rolę(y)",
        search: "Wyszukaj według nazwy roli, opisu lub ID",
        empty: "Brak dostępnych r\xf3l"
    }
};
var $b56333da034cd769$export$2e2bcd8739ae039 = Object.freeze($b56333da034cd769$var$application_details);


const $4298a44acb80bbe5$var$applications = {
    page_title: "Aplikacje",
    title: "Aplikacje",
    subtitle: "Skonfiguruj uwierzytelnianie Logto dla Twojej aplikacji natywnej, jednostronicowej, komunikującej się bezpośrednio z zasobami lub tradycyjnej",
    subtitle_with_app_type: "Skonfiguruj uwierzytelnianie Logto dla twojej aplikacji {{name}}",
    create: "Utw\xf3rz aplikację",
    create_subtitle_third_party: "Użyj Logto jako swojego dostawcy tożsamości (IdP), aby łatwo integrować się z aplikacjami stron trzecich",
    application_name: "Nazwa aplikacji",
    application_name_placeholder: "Moja aplikacja",
    application_description: "Opis aplikacji",
    application_description_placeholder: "Wprowadź opis swojej aplikacji",
    select_application_type: "Wybierz typ aplikacji",
    no_application_type_selected: "Nie wybrałeś jeszcze żadnego typu aplikacji",
    application_created: "Aplikacja została pomyślnie utworzona.",
    tab: {
        my_applications: "Moje aplikacje",
        third_party_applications: "Aplikacje stron trzecich"
    },
    app_id: "App ID",
    type: {
        native: {
            title: "Aplikacja natywna",
            subtitle: "Aplikacja uruchamiana w środowisku natywnym",
            description: "Na przykład aplikacja na iOS, aplikacja na Androida"
        },
        spa: {
            title: "Aplikacja jednostronicowa",
            subtitle: "Aplikacja uruchamiana w przeglądarce internetowej i dynamicznie aktualizująca dane na miejscu",
            description: "Na przykład aplikacja React DOM, aplikacja Vue"
        },
        traditional: {
            title: "Tradycyjna strona internetowa",
            subtitle: "Aplikacja, kt\xf3ra renderuje i aktualizuje strony tylko przez serwer internetowy",
            description: "Na przykład Next.js, PHP"
        },
        machine_to_machine: {
            title: "Komunikacja maszyna-do-maszyny",
            subtitle: "Aplikacja (zazwyczaj usługa), kt\xf3ra bezpośrednio komunikuje się z zasobami",
            description: "Na przykład usługa backendowa"
        },
        protected: {
            title: "Chroniona aplikacja",
            subtitle: "Aplikacja chroniona przez Logto",
            description: "N/A"
        },
        third_party: {
            title: "Aplikacja stron trzecich",
            subtitle: "Aplikacja używana jako łącznik do dostawcy tożsamości stron trzecich",
            description: "Np. OIDC, SAML"
        }
    },
    placeholder_title: "Wybierz typ aplikacji, aby kontynuować",
    placeholder_description: "Logto używa jednostki aplikacji dla OIDC, aby pom\xf3c w takich zadaniach jak identyfikowanie Twoich aplikacji, zarządzanie logowaniem i tworzenie dziennik\xf3w audytu.",
    m2m_role_assignment: {
        title: "Autoryzuj aplikację z rolą maszyny do maszyny dla uprawnień",
        subtitle: "Aplikacje maszyna-do-maszyna wymagają autoryzowanej roli maszyna-do-maszyna.",
        role_creation_hint: "Nie możesz znaleźć odpowiedniej roli maszyna-maszyna? <a>Utw\xf3rz rolę maszyna-maszyna</a>"
    }
};
var $4298a44acb80bbe5$export$2e2bcd8739ae039 = Object.freeze($4298a44acb80bbe5$var$applications);


const $47e15bedc191623a$var$cloud = {
    general: {
        onboarding: "Wdrażanie"
    },
    welcome: {
        page_title: "Witamy",
        title: "Witaj w chmurze Logto! Chcielibyśmy dowiedzieć się trochę o Tobie.",
        description: "Stw\xf3rz indywidualne wrażenia z Logto dzięki naszej wiedzy na temat Ciebie. Twoje informacje są bezpieczne u nas.",
        project_field: "Używam Logto do",
        project_options: {
            personal: "Projektu osobistego",
            company: "Projektu firmowego"
        },
        company_name_field: "Nazwa firmy",
        company_name_placeholder: "Acme.co",
        stage_field: "W jakim etapie jest Tw\xf3j produkt aktualnie?",
        stage_options: {
            new_product: "Rozpocznij nowy projekt i szukasz szybkiego, gotowego rozwiązania",
            existing_product: "Migracja z bieżącej autoryzacji (np. własna autoryzacja, Auth0, Cognito, Microsoft)",
            target_enterprise_ready: "Właśnie pozyskałem większych klient\xf3w i teraz przygotowuję m\xf3j produkt do sprzedaży dla przedsiębiorstw"
        },
        additional_features_field: "Czy masz coś jeszcze, o czym chcesz, żebyśmy wiedzieli?",
        additional_features_options: {
            customize_ui_and_flow: "Zbuduj i zarządzaj własnym interfejsem użytkownika, nie tylko korzystaj z gotowego i dostosowywalnego rozwiązania Logto",
            compliance: "SOC2 i GDPR są konieczne",
            export_user_data: "Potrzebuję możliwości eksportu danych użytkownika z Logto",
            budget_control: "Mam bardzo ściśłą kontrolę budżetu",
            bring_own_auth: "Mam swoje własne usługi autoryzacji i potrzebuję tylko niekt\xf3rych funkcji Logto",
            others: "Nic z powyższych"
        }
    },
    sie: {
        page_title: "Dostosuj doświadczenie logowania",
        title: "Najpierw dostosuj swoje doświadczenie logowania",
        inspire: {
            title: "Stw\xf3rz przykłady",
            description: 'Nie jesteś pewien swojego doświadczenia logowania? Kliknij "Zainspiruj mnie" i pozw\xf3l, żeby magia się stała!',
            inspire_me: "Zainspiruj mnie"
        },
        logo_field: "Logo aplikacji",
        color_field: "Kolor marki",
        identifier_field: "Identyfikator",
        identifier_options: {
            email: "E-mail",
            phone: "Telefon",
            user_name: "Nazwa użytkownika"
        },
        authn_field: "Uwierzytelnianie",
        authn_options: {
            password: "Hasło",
            verification_code: "Kod weryfikacyjny"
        },
        social_field: "Logowanie społecznościowe",
        finish_and_done: "Skończone i gotowe",
        preview: {
            mobile_tab: "Mobilny",
            web_tab: "Sieć"
        },
        connectors: {
            unlocked_later: "Zostanie odblokowane p\xf3źniej",
            unlocked_later_tip: "Po ukończeniu procesu wprowadzenia do użytku i wejściu do produktu będziesz mieć dostęp do jeszcze większej liczby metod logowania społecznościowego",
            notice: "Prosimy, unikaj korzystania z demo konektora do cel\xf3w produkcyjnych. Po zakończeniu test\xf3w, uprzejmie usuń demokonwerter i skonfiguruj sw\xf3j własny konektor z własnymi poświadczeniami."
        }
    },
    socialCallback: {
        title: "Zalogowałeś się pomyślnie",
        description: "Zalogowałeś się pomyślnie używając swojego konta społecznościowego. Aby zapewnić bezproblemową integrację i dostęp do wszystkich funkcji Logto, zalecamy przejście do konfiguracji własnego konektora społecznościowego."
    },
    tenant: {
        create_tenant: "Stw\xf3rz najemcę"
    }
};
var $47e15bedc191623a$export$2e2bcd8739ae039 = Object.freeze($47e15bedc191623a$var$cloud);


const $d18d33a638f9b5f9$var$components = {
    uploader: {
        action_description: "Przeciągnij i upuść lub przeszukaj",
        uploading: "Wysyłanie...",
        image_limit: "Wyślij obraz o rozmiarze mniejszym niż {{size, number}}KB, tylko w formacie {{extensions, list(style: narrow; type: conjunction;)}}.",
        error_upload: "Coś poszło nie tak. Nie udało się wysłać pliku.",
        error_file_size: "Plik jest zbyt duży. Wyślij plik o rozmiarze mniejszym niż {{size, number}}KB.",
        error_file_type: "Ten typ pliku nie jest obsługiwany. Obsługiwane formaty to {{extensions, list(style: narrow; type: conjunction;)}}.",
        error_file_count: "Możesz przesłać tylko 1 plik."
    }
};
var $d18d33a638f9b5f9$export$2e2bcd8739ae039 = Object.freeze($d18d33a638f9b5f9$var$components);


const $392f292d5a43ceac$var$connector_details = {
    page_title: "Szczeg\xf3ły konektora",
    back_to_connectors: "Powr\xf3t do konektor\xf3w",
    check_readme: "Sprawdź README",
    settings: "Ustawienia og\xf3lne",
    settings_description: "Konektory odgrywają kluczową rolę w Logto. Dzięki nim, Logto umożliwia użytkownikom końcowym korzystanie z rejestracji lub logowania bez hasła oraz możliwości logowania się za pomocą kont społecznościowych.",
    parameter_configuration: "Konfiguracja parametru",
    test_connection: "Test",
    save_error_empty_config: "Proszę wprowadzić konfigurację",
    send: "Wyślij",
    send_error_invalid_format: "Nieprawidłowy format danych wejściowych",
    edit_config_label: "Wprowadź swoje dane JSON tutaj",
    test_email_sender: "Wypr\xf3buj konektor e-mail",
    test_sms_sender: "Wypr\xf3buj konektor SMS",
    test_email_placeholder: "jan.kowalski@example.com",
    test_sms_placeholder: "+48 123-456-789",
    test_message_sent: "Wiadomość testowa została wysłana",
    test_sender_description: 'Logto używa szablonu "Og\xf3lny" do test\xf3w. Otrzymasz wiadomość, jeśli tw\xf3j konektor jest prawidłowo skonfigurowany.',
    options_change_email: "Zmień konektor e-mail",
    options_change_sms: "Zmień konektor SMS",
    connector_deleted: "Konektor został pomyślnie usunięty",
    type_email: "Konektor e-mail",
    type_sms: "Konektor SMS",
    type_social: "Konektor społecznościowy",
    in_used_social_deletion_description: "Ten konektor jest używany w Twoim procesie logowania. Usunięcie spowoduje usunięcie doświadczenia logowania <name/> w ustawieniach doświadczenia logowania. Będziesz musiał go ponownie skonfigurować, jeśli zdecydujesz się go dodać z powrotem.",
    in_used_passwordless_deletion_description: "Ten {{name}} jest używany w Twoim procesie logowania. Usunięcie spowoduje, że Twoje doświadczenie logowania nie będzie działać poprawnie, dop\xf3ki nie rozwiążesz konfliktu. Będziesz musiał go ponownie skonfigurować, jeśli zdecydujesz się go dodać z powrotem.",
    deletion_description: "Usuwasz ten konektor. Nie można tego cofnąć, będziesz musiał go ponownie skonfigurować, jeśli zdecydujesz się go ponownie dodać.",
    logto_email: {
        total_email_sent: "Wysłano łącznie emaili: {{value, number}}",
        total_email_sent_tip: "Logto wykorzystuje SendGrid do bezpiecznej i stabilnej wysyłki wbudowanych wiadomości e-mail. Jest to całkowicie darmowe do użytku. <a>Więcej informacji</a>",
        email_template_title: "Szablon e-maila",
        template_description: "Wbudowany e-mail używa domyślnych szablon\xf3w dla bezproblemowej dostawy wiadomości weryfikacyjnych. Nie wymaga to konfiguracji, a podstawowe informacje o marce można dostosować.",
        template_description_link_text: "Wyświetl szablony",
        description_action_text: "Wyświetl szablony",
        from_email_field: "Adres e-mail nadawcy",
        sender_name_field: "Nazwa nadawcy",
        sender_name_tip: 'Dostosuj nazwę nadawcy dla wiadomości e-mail. Jeśli pozostawisz to pole puste, domyślnie użyta zostanie nazwa "Verification".',
        sender_name_placeholder: "Nazwa nadawcy",
        company_information_field: "Informacje o firmie",
        company_information_description: "Wyświetlaj nazwę firmy, adres lub kod pocztowy na dole wiadomości e-mail, aby zwiększyć autentyczność.",
        company_information_placeholder: "Podstawowe informacje o Twojej firmie",
        app_logo_field: "Logo aplikacji",
        app_logo_tip: "Wyświetlaj logo marki na g\xf3rze wiadomości e-mail. Użyj tego samego obrazu zar\xf3wno dla trybu jasnego, jak i ciemnego.",
        urls_not_allowed: "Nie dozwolone adresy URL",
        test_notes: 'Logto używa szablonu "Og\xf3lny" do test\xf3w.'
    }
};
var $392f292d5a43ceac$export$2e2bcd8739ae039 = Object.freeze($392f292d5a43ceac$var$connector_details);


const $b25eeec043c77ec4$var$connectors = {
    page_title: "Łączniki",
    title: "Łączniki",
    subtitle: "Skonfiguruj łączniki, aby umożliwić bezhasłowe i społecznościowe logowanie",
    create: "Dodaj łącznik społecznościowy",
    config_sie_notice: "Ustawiono łączniki. Upewnij się, że skonfigurowałeś to w <a>{{link}}</a>.",
    config_sie_link_text: "doświadczenie logowania",
    tab_email_sms: "Łączniki e-mail i SMS",
    tab_social: "Łączniki społecznościowe",
    connector_name: "Nazwa łącznika",
    demo_tip: "Maksymalna liczba wiadomości dozwolona dla tego Łącznika demonstracyjnego wynosi 100 i nie jest zalecana do wdrożenia w środowisku produkcyjnym.",
    social_demo_tip: "Łącznik demonstracyjny został zaprojektowany wyłącznie dla cel\xf3w demonstracyjnych i nie jest zalecany do wdrożenia w środowisku produkcyjnym.",
    connector_type: "Typ",
    connector_status: "Doświadczenie logowania",
    connector_status_in_use: "W użyciu",
    connector_status_not_in_use: "Nie w użyciu",
    not_in_use_tip: {
        content: "Nie w użyciu oznacza, że Twoje doświadczenie logowania nie użyło tej metody logowania. <a>{{link}}</a> aby dodać tę metodę logowania.",
        go_to_sie: "Przejdź do doświadczenia logowania"
    },
    placeholder_title: "Łącznik społecznościowy",
    placeholder_description: "Logto dostarczył wiele powszechnie używanych łącznik\xf3w społecznościowych, tymczasem możesz utworzyć własne z wykorzystaniem standardowych protokoł\xf3w.",
    save_and_done: "Zapisz i zakończ",
    type: {
        email: "Łącznik e-mail",
        sms: "Łącznik SMS",
        social: "Łącznik społecznościowy"
    },
    setup_title: {
        email: "Skonfiguruj łącznik e-mail",
        sms: "Skonfiguruj łącznik SMS",
        social: "Dodaj łącznik społecznościowy"
    },
    guide: {
        subtitle: "Przewodnik krok po kroku do konfiguracji Twojego łącznika",
        general_setting: "Ustawienia og\xf3lne",
        parameter_configuration: "Konfiguracja parametr\xf3w",
        test_connection: "Testuj połączenie",
        name: "Nazwa przycisku logowania społecznościowego",
        name_placeholder: "Wpisz nazwę przycisku logowania społecznościowego",
        name_tip: 'Nazwa przycisku łącznika będzie wyświetlana jako "Kontynuuj z {{name}}." Uwzględnij długość nazwy, gdyż może stać się zbyt długa.',
        logo: "Logo URL łącznika społecznościowego",
        logo_placeholder: "https://your.cdn.domain/logo.png",
        logo_tip: "Obraz logo zostanie wyświetlony na łączniku. Uzyskaj publicznie dostępny link do obrazu i wklej tutaj link.",
        logo_dark: "Logo URL łącznika społecznościowego (tryb ciemny)",
        logo_dark_placeholder: "https://your.cdn.domain/logo.png",
        logo_dark_tip: "Ustaw logo łącznika dla trybu ciemnego po jego włączeniu w Doświadczeniu logowania w Konsoli Admina.",
        logo_dark_collapse: "Zwiń",
        logo_dark_show: "Pokaż ustawienia logo dla trybu ciemnego",
        target: "Nazwa dostawcy tożsamości",
        target_placeholder: "Wpisz nazwę dostawcy tożsamości łącznika",
        target_tip: "Wartość „Nazwy dostawcy tożsamości” może być unikalnym ciągiem identyfikującym, kt\xf3ry odr\xf3żnia Twoje tożsamości społecznościowe.",
        target_tip_standard: "Wartość „Nazwy dostawcy tożsamości” może być unikalnym ciągiem identyfikującym, kt\xf3ry odr\xf3żnia Twoje tożsamości społecznościowe. Po utworzeniu łącznika nie możesz go zmienić.",
        target_tooltip: '„Nazwa dostawcy tożsamości” w łącznikach społecznościowych Logto odnosi się do "źr\xf3dła" Twoich tożsamości społecznościowych. W projektowaniu Logto nie akceptujemy tych samych „Nazw dostawc\xf3w tożsamości” konkretnej platformy, aby uniknąć konflikt\xf3w. Powinieneś bardzo uważać przed dodaniem łącznika, ponieważ NIE MOŻESZ zmienić jego wartości po utworzeniu. <a>Dowiedz się więcej</a>',
        target_conflict: "Wprowadzona nazwa IdP pasuje do istniejącego łącznika <span>nazwa</span>. Użycie tej samej nazwy IdP może spowodować nieoczekiwane zachowanie logowania, gdzie użytkownicy mogą uzyskać dostęp do tego samego konta za pośrednictwem dw\xf3ch r\xf3żnych łącznik\xf3w.",
        target_conflict_line2: "Jeśli chcesz zastąpić aktualny łącznik tym samym dostawcą tożsamości i umożliwić poprzednim użytkownikom logowanie bez rejestracji ponownie, usuń łącznik <span>nazwa</span> i utw\xf3rz nowy z tą samą „Nazwą dostawcy tożsamości”.",
        target_conflict_line3: "Jeśli chcesz połączyć się z innym dostawcą tożsamości, zmodyfikuj „Nazwę dostawcy tożsamości” i kontynuuj.",
        config: "Wprowadź sw\xf3j JSON konfiguracji",
        sync_profile: "Synchronizuj informacje profilowe",
        sync_profile_only_at_sign_up: "Synchronizuj tylko podczas rejestracji",
        sync_profile_each_sign_in: "Zawsze wykonaj synchronizację przy każdym logowaniu",
        sync_profile_tip: "Synchronizuje podstawowy profil z dostawcy usług społecznościowych, takie jak nazwy użytkownik\xf3w i ich awatary.",
        callback_uri: "URI zwrotu (Callback)",
        callback_uri_description: "Nazywany także URI przekierowania, to URI w Logto, do kt\xf3rego użytkownicy zostaną przesłani po autoryzacji społecznej; skopiuj i wklej na stronie konfiguracyjnej dostawcy usług społecznościowych.",
        acs_url: "Assertion consumer service URL"
    },
    platform: {
        universal: "Uniwersalny",
        web: "Web",
        native: "Natywny"
    },
    add_multi_platform: "obsługuje wiele platform, wybierz platformę, aby kontynuować",
    drawer_title: "Poradnik łącznika",
    drawer_subtitle: "Postępuj zgodnie z instrukcjami, aby zintegrować sw\xf3j łącznik",
    unknown: "Nieznany Łącznik",
    standard_connectors: "Standardowe łączniki"
};
var $b25eeec043c77ec4$export$2e2bcd8739ae039 = Object.freeze($b25eeec043c77ec4$var$connectors);


const $88d45429660685b0$var$contact = {
    title: "Zdobądź pomoc",
    description: "W przypadku żądań pomocy lub opinii na temat produktu, skontaktuj się z nami za pomocą następujących metod.",
    discord: {
        title: "Dołącz do społeczności Discord",
        description: "Połącz się z innymi deweloperami, aby znaleźć rozwiązania",
        button: "Dołącz"
    },
    github: {
        title: "Komunikuj się na GitHub",
        description: "Utw\xf3rz zgłoszenie i opublikuj na GitHub",
        button: "Otw\xf3rz"
    },
    email: {
        title: "Skontaktuj się z pomocą techniczną przez e-mail",
        description: "Wyślij do nas e-maila w celu uzyskania dalszych informacji i pomocy",
        button: "Wyślij"
    },
    reserve: {
        title: "Zarezerwuj sw\xf3j czas z zespołem Logto",
        description: "Szybko zarezerwuj sesję czatu na żywo",
        button: "Rezerwuj"
    }
};
var $88d45429660685b0$export$2e2bcd8739ae039 = Object.freeze($88d45429660685b0$var$contact);


const $6df00a3eebaa20be$var$dashboard = {
    page_title: "Panel",
    title: "Panel",
    description: "Przegląd wydajności Twojej aplikacji",
    total_users: "Wszyscy użytkownicy",
    total_users_tip: "Wszyscy użytkownicy",
    new_users_today: "Nowi użytkownicy dzisiaj",
    new_users_today_tip: "Liczba nowych użytkownik\xf3w zarejestrowanych dzisiaj",
    new_users_7_days: "Nowi użytkownicy w ciągu ostatnich 7 dni",
    new_users_7_days_tip: "Liczba nowych użytkownik\xf3w zarejestrowanych w ciągu ostatnich 7 dni",
    daily_active_users: "Dziennie aktywni użytkownicy",
    daily_active_users_tip: "Liczba unikalnych użytkownik\xf3w wymieniających tokeny na Twojej aplikacji dziś",
    weekly_active_users: "Tygodniowo aktywni użytkownicy",
    weekly_active_users_tip: "Liczba unikalnych użytkownik\xf3w wymieniających tokeny na Twojej aplikacji w ciągu ostatnich 7 dni",
    monthly_active_users: "Miesięcznie aktywni użytkownicy",
    monthly_active_users_tip: "Liczba unikalnych użytkownik\xf3w wymieniających tokeny na Twojej aplikacji w ciągu ostatnich 30 dni"
};
var $6df00a3eebaa20be$export$2e2bcd8739ae039 = Object.freeze($6df00a3eebaa20be$var$dashboard);


const $b584132712ebb622$var$domain = {
    status: {
        connecting: "Łączenie...",
        in_use: "W użyciu",
        failed_to_connect: "Nieudane połączenie"
    },
    update_endpoint_notice: "Nie zapomnij zaktualizować domeny dla URI wywołania łącznika społecznego i punktu końcowego Logto w swojej aplikacji, jeśli chcesz używać niestandardowej domeny dla funkcji. <a>{{link}}</a>",
    error_hint: "Upewnij się, że zaktualizowałeś swoje rekordy DNS. Będziemy nadal sprawdzać co {{value}} sekund.",
    custom: {
        custom_domain: "Niestandardowa domena",
        custom_domain_description: "Ulepsz swoją markę, wykorzystując niestandardową domenę. Ta domena będzie używana w Twoim procesie logowania.",
        custom_domain_field: "Niestandardowa domena",
        custom_domain_placeholder: "twoja.domena.com",
        add_domain: "Dodaj domenę",
        invalid_domain_format: 'Proszę podać poprawny adres URL domeny z co najmniej trzema częściami, np. "twoja.domena.com."',
        verify_domain: "Zweryfikuj domenę",
        enable_ssl: "Włącz SSL",
        checking_dns_tip: "Po skonfigurowaniu rekord\xf3w DNS proces zostanie uruchomiony automatycznie i może potrwać do 24 godzin. Możesz opuścić ten interfejs podczas jego działania.",
        enable_ssl_tip: "Włączenie SSL zostanie uruchomione automatycznie i może potrwać do 24 godzin. Możesz opuścić ten interfejs podczas jego działania.",
        generating_dns_records: "Generowanie rekord\xf3w DNS...",
        add_dns_records: "Dodaj te rekordy DNS do swojego dostawcy DNS.",
        dns_table: {
            type_field: "Typ",
            name_field: "Nazwa",
            value_field: "Wartość"
        },
        deletion: {
            delete_domain: "Usuń domenę",
            reminder: "Usuń niestandardową domenę",
            description: "Czy na pewno chcesz usunąć tę niestandardową domenę?",
            in_used_description: 'Czy na pewno chcesz usunąć tę niestandardową domenę "<span>{{domain}}</span>"?',
            in_used_tip: 'Jeśli wcześniej skonfigurowałeś tę niestandardową domenę w dostawcy łącznik\xf3w społecznościowych lub zakończeniu aplikacji, musisz najpierw zmodyfikować adres URI na domyślną domenę Logto "<span>{{domain}}</span>". Jest to niezbędne do poprawnego działania przycisku logowania społecznego.',
            deleted: "Niestandardowa domena została pomyślnie usunięta!"
        }
    },
    default: {
        default_domain: "Domyślna domena",
        default_domain_description: "Logto oferuje prekonfigurowaną domenę domyślną, gotową do użycia bez dodatkowej konfiguracji. Ta domyślna domena służy jako opcja zapasowa, nawet jeśli włączyłeś niestandardową domenę.",
        default_domain_field: "Domyślna domena Logto"
    },
    custom_endpoint_note: 'Możesz dostosować nazwę domeny tych punkt\xf3w końcowych według swoich wymagań. Wybierz "{{custom}}" lub "{{default}}".',
    custom_social_callback_url_note: 'Możesz dostosować nazwę domeny tego adresu URI, aby dopasować ją do punktu końcowego Twojej aplikacji. Wybierz "{{custom}}" lub "{{default}}".',
    custom_acs_url_note: 'Możesz dostosować nazwę domeny tego URI, aby dopasować ją do adresu URL usługi konsumenta oświadczeń Twojego dostawcy tożsamości. Wybierz "{{custom}}" lub "{{default}}".'
};
var $b584132712ebb622$export$2e2bcd8739ae039 = Object.freeze($b584132712ebb622$var$domain);


const $4855454da986656d$var$enterprise_sso_details = {
    back_to_sso_connectors: "Powr\xf3t do jednokrotnego logowania przedsiębiorstwa",
    page_title: "Szczeg\xf3ły konektora jednokrotnego logowania przedsiębiorstwa",
    readme_drawer_title: "Jednokrotne logowanie przedsiębiorstwa",
    readme_drawer_subtitle: "Skonfiguruj konektory jednokrotnego logowania przedsiębiorstwa, aby umożliwić jednokrotne logowanie końcowym użytkownikom",
    tab_experience: "Doświadczenie SSO",
    tab_connection: "Połączenie",
    general_settings_title: "Og\xf3lne",
    custom_branding_title: "Wyświetlanie",
    custom_branding_description: "Dostosuj nazwę i logo wyświetlane w przepływie jednokrotnego logowania końcowych użytkownik\xf3w. Przy braku wartości domyślne są używane.",
    email_domain_field_name: "Domena e-mail przedsiębiorstwa",
    email_domain_field_description: "Użytkownicy z tą domeną e-mail mogą używać SSO do uwierzytelniania. Proszę zweryfikować, czy domena należy do przedsiębiorstwa.",
    email_domain_field_placeholder: "Domena e-mail",
    sync_profile_field_name: "Synchronizuj informacje profilu z dostawcy tożsamości",
    sync_profile_option: {
        register_only: "Tylko synchronizuj przy pierwszym logowaniu",
        each_sign_in: "Zawsze synchronizuj przy każdym logowaniu"
    },
    connector_name_field_name: "Nazwa konektora",
    display_name_field_name: "Nazwa wyświetlana",
    connector_logo_field_name: "Logo wyświetlane",
    connector_logo_field_description: "Każdy obraz powinien mieć mniej niż 500KB, tylko SVG, PNG, JPG, JPEG.",
    branding_logo_context: "Prześlij logo",
    branding_logo_error: "Błąd przesyłania logo: {{error}}",
    branding_light_logo_context: "Prześlij logo w trybie jasnym",
    branding_light_logo_error: "Błąd przesyłania logo w trybie jasnym: {{error}}",
    branding_logo_field_name: "Logo",
    branding_logo_field_placeholder: "https://twoja.domena/logo.png",
    branding_dark_logo_context: "Prześlij logo w trybie ciemnym",
    branding_dark_logo_error: "Błąd przesyłania logo w trybie ciemnym: {{error}}",
    branding_dark_logo_field_name: "Logo (tryb ciemny)",
    branding_dark_logo_field_placeholder: "https://twoja.domena/logo-tryb-ciemny.png",
    check_connection_guide: "Poradnik połączenia",
    enterprise_sso_deleted: "Konektor jednokrotnego logowania przedsiębiorstwa został pomyślnie usunięty",
    delete_confirm_modal_title: "Usuń konektor jednokrotnego logowania przedsiębiorstwa",
    delete_confirm_modal_content: "Czy na pewno chcesz usunąć ten konektor przedsiębiorstwa? Użytkownicy z dostawc\xf3w tożsamości nie będą korzystać z jednokrotnego logowania.",
    upload_idp_metadata_title_saml: "Prześlij metadane",
    upload_idp_metadata_description_saml: "Skonfiguruj metadane skopiowane z dostawcy tożsamości.",
    upload_idp_metadata_title_oidc: "Prześlij dane uwierzytelniania",
    upload_idp_metadata_description_oidc: "Skonfiguruj dane uwierzytelniania i informacje o tokenie OIDC skopiowane z dostawcy tożsamości.",
    upload_idp_metadata_button_text: "Prześlij plik XML metadanych",
    upload_signing_certificate_button_text: "Prześlij plik certyfikatu podpisującego",
    configure_domain_field_info_text: "Dodaj domenę e-mail, aby przeprowadzić użytkownik\xf3w przedsiębiorstwa do ich dostawcy tożsamości dla jednokrotnego logowania.",
    email_domain_field_required: "Domena e-mail jest wymagana do włączenia SSO dla przedsiębiorstwa.",
    upload_saml_idp_metadata_info_text_url: "Wklej URL metadanych z dostawcy tożsamości, aby połączyć.",
    upload_saml_idp_metadata_info_text_xml: "Wklej metadane z dostawcy tożsamości, aby połączyć.",
    upload_saml_idp_metadata_info_text_manual: "Wypełnij metadane z dostawcy tożsamości, aby połączyć.",
    upload_oidc_idp_info_text: "Wypełnij informacje z dostawcy tożsamości, aby połączyć.",
    service_provider_property_title: "Konfiguruj w IdP",
    service_provider_property_description: "Skonfiguruj integrację aplikacji za pomocą {{protocol}} w dostawcy tożsamości. Wprowadź szczeg\xf3ły podane przez Logto.",
    attribute_mapping_title: "Mapowanie atrybut\xf3w",
    attribute_mapping_description: "Synchronizuj profile użytkownik\xf3w z dostawcy tożsamości, konfigurując mapowanie atrybut\xf3w użytkownika zar\xf3wno po stronie dostawcy tożsamości, jak i po stronie Logto.",
    saml_preview: {
        sign_on_url: "URL logowania",
        entity_id: "Wydawca",
        x509_certificate: "Certyfikat podpisujący",
        certificate_content: "Wygasa: {{date}}"
    },
    oidc_preview: {
        authorization_endpoint: "Punkt końcowy autoryzacji",
        token_endpoint: "Punkt końcowy tokena",
        userinfo_endpoint: "Punkt końcowy informacji użytkownika",
        jwks_uri: "Punkt końcowy kluczy web JSON",
        issuer: "Wydawca"
    }
};
var $4855454da986656d$export$2e2bcd8739ae039 = Object.freeze($4855454da986656d$var$enterprise_sso_details);


const $59c7d1daeacf3e1e$var$enterprise_sso = {
    page_title: "Jednolite logowanie dla przedsiębiorstw",
    title: "Jednolite logowanie dla przedsiębiorstw",
    subtitle: "Połącz dostawcę tożsamości przedsiębiorstwa i włącz jednostronne logowanie jednolitego.",
    create: "Dodaj łącznik przedsiębiorstwa",
    col_connector_name: "Nazwa łącznika",
    col_type: "Typ",
    col_email_domain: "Domena e-mail",
    placeholder_title: "Łącznik przedsiębiorstwa",
    placeholder_description: "Logto dostarczył wiele wbudowanych dostawc\xf3w tożsamości przedsiębiorstwa do połączenia, w międzyczasie możesz także stworzyć własny za pomocą protokoł\xf3w SAML i OIDC.",
    create_modal: {
        title: "Dodaj łącznik przedsiębiorstwa",
        text_divider: "Albo możesz dostosować sw\xf3j łącznik za pomocą standardowego protokołu.",
        connector_name_field_title: "Nazwa łącznika",
        connector_name_field_placeholder: "Np. {nazwa firmy} - {nazwa dostawcy tożsamości}",
        create_button_text: "Stw\xf3rz łącznik"
    },
    guide: {
        subtitle: "Przewodnik krok po kroku dotyczący połączenia dostawcy tożsamości przedsiębiorstwa.",
        finish_button_text: "Kontynuuj"
    },
    basic_info: {
        title: "Skonfiguruj swoją usługę w IdP",
        description: "Utw\xf3rz nową integrację aplikacji za pomocą SAML 2.0 w dostawcy tożsamości {{name}}. Następnie wklej poniższą wartość.",
        saml: {
            acs_url_field_name: "Adres URL usługi konsumenta twierdzeń (Adres URL odpowiedzi)",
            audience_uri_field_name: "URI odbiorcy (ID podmiotu SP)"
        },
        oidc: {
            redirect_uri_field_name: "Adres URL przekierowania (Adres URL wywołania zwrotnego)"
        }
    },
    attribute_mapping: {
        title: "Wiązanie atrybut\xf3w",
        description: "`id` i `email` są wymagane do synchronizacji profilu użytkownika z IdP. Wprowadź następującą nazwę i wartość twierdzenia w swoim IdP.",
        col_sp_claims: "Wartość dostawcy usług (Logto)",
        col_idp_claims: "Nazwa twierdzenia dostawcy tożsamości",
        idp_claim_tooltip: "Nazwa twierdzenia dostawcy tożsamości"
    },
    metadata: {
        title: "Skonfiguruj metadane IdP",
        description: "Skonfiguruj metadane z dostawcy tożsamości",
        dropdown_trigger_text: "Użyj innej metody konfiguracji",
        dropdown_title: "wybierz swoją metodę konfiguracji",
        metadata_format_url: "Wprowadź adres URL metadanych",
        metadata_format_xml: "Prześlij plik XML metadanych",
        metadata_format_manual: "Ręcznie wprowadź szczeg\xf3ły metadanych",
        saml: {
            metadata_url_field_name: "Adres URL metadanych",
            metadata_url_description: "Pobierz dynamicznie dane z adresu URL metadanych i bądź na bieżąco z certyfikatem.",
            metadata_xml_field_name: "Plik XML metadanych IdP",
            metadata_xml_uploader_text: "Prześlij plik XML metadanych",
            sign_in_endpoint_field_name: "Adres URL logowania",
            idp_entity_id_field_name: "Identyfikator jednostki IdP (Wydawca)",
            certificate_field_name: "Certyfikat podpisujący",
            certificate_placeholder: "Skopiuj i wklej certyfikat x509",
            certificate_required: "Certyfikat podpisujący jest wymagany."
        },
        oidc: {
            client_id_field_name: "ID klienta",
            client_secret_field_name: "Tajny klucz klienta",
            issuer_field_name: "Wydawca",
            scope_field_name: "Zakres"
        }
    }
};
var $59c7d1daeacf3e1e$export$2e2bcd8739ae039 = Object.freeze($59c7d1daeacf3e1e$var$enterprise_sso);


const $8f1d0e92e54d25a2$var$errors = {
    something_went_wrong: "Ups! Coś poszło nie tak.",
    page_not_found: "Nie znaleziono strony",
    unknown_server_error: "Wystąpił nieznany błąd serwera",
    empty: "Brak danych",
    missing_total_number: "Nie można znaleźć wartości Total-Number w nagł\xf3wkach odpowiedzi",
    invalid_uri_format: "Nieprawidłowy format URI",
    invalid_origin_format: "Nieprawidłowy format pochodzenia URI",
    invalid_json_format: "Nieprawidłowy format JSON",
    invalid_regex: "Nieprawidłowe wyrażenie regularne",
    invalid_error_message_format: "Nieprawidłowy format komunikatu błędu.",
    required_field_missing: "Wpisz {{field}}",
    required_field_missing_plural: "Musisz wprowadzić przynajmniej jeden {{field}}",
    more_details: "Więcej szczeg\xf3ł\xf3w",
    username_pattern_error: "Nazwa użytkownika powinna zawierać tylko litery, cyfry lub znak podkreślenia i nie powinna zaczynać się od cyfry.",
    email_pattern_error: "Adres e-mail jest nieprawidłowy.",
    phone_pattern_error: "Numer telefonu jest nieprawidłowy.",
    insecure_contexts: "Nieobsługiwane są niebezpieczne konteksty (non-HTTPS).",
    unexpected_error: "Wystąpił nieoczekiwany błąd.",
    not_found: "404 nie znaleziono",
    create_internal_role_violation: 'Tworzysz nową wewnętrzną rolę, co jest zabronione przez Logto. Spr\xf3buj użyć innego nazwy, kt\xf3ra nie zaczyna się od "#internal:". ',
    should_be_an_integer: "Powinno być liczbą całkowitą.",
    number_should_be_between_inclusive: "Następnie liczba powinna być między {{min}} a {{max}} (włącznie)."
};
var $8f1d0e92e54d25a2$export$2e2bcd8739ae039 = Object.freeze($8f1d0e92e54d25a2$var$errors);


const $6a7dd7cf7aa9a02c$var$general = {
    placeholder: "Miejsce na tekst",
    submit: "Wyślij",
    skip: "Pomiń",
    next: "Dalej",
    back: "Wstecz",
    retry: "Spr\xf3buj ponownie",
    done: "Gotowe",
    search: "Szukaj",
    search_placeholder: "Szukaj",
    clear_result: "Wyczyść Wyniki",
    save: "Zapisz",
    save_changes: "Zapisz zmiany",
    saved: "Zapisane",
    discard: "Porzuć",
    loading: "Trwa ładowanie...",
    redirecting: "Przekierowywanie...",
    add: "Dodaj",
    added: "Dodano",
    cancel: "Anuluj",
    confirm: "Potwierdź",
    check_out: "Zapłać i wyjdź",
    create: "Stw\xf3rz",
    set_up: "Skonfiguruj",
    customize: "Dostosuj",
    enable: "Włącz",
    reminder: "Przypomnienie",
    edit: "Edytuj",
    delete: "Usuń",
    deleted: "Usunięto",
    more_options: "WIĘCEJ OPCJI",
    close: "Zamknij",
    copy: "Kopiuj",
    copying: "Kopiowanie",
    copied: "Skopiowano",
    required: "Wymagane",
    add_another: "Dodaj kolejny",
    create_another: "Stw\xf3rz kolejny",
    deletion_confirmation: "Czy na pewno chcesz usunąć {{title}}?",
    settings_nav: "Ustawienia",
    unsaved_changes_warning: "Wprowadzono zmiany. Czy na pewno chcesz opuścić tę stronę?",
    leave_page: "Opuść stronę",
    stay_on_page: "Pozostań na stronie",
    type_to_search: "Szukaj",
    got_it: "Zrozumiałe(a)m",
    continue: "Kontynuuj",
    page_info: "{{min, number}}-{{max, number}} z {{total, number}}",
    learn_more: "Dowiedz się więcej",
    tab_errors: "{{count, number}} błęd\xf3w",
    skip_for_now: "Pomiń na teraz",
    remove: "Usuń",
    visit: "Odwiedź",
    join: "Dołącz",
    try_now: "Wypr\xf3buj teraz",
    multiple_form_field: "(Wiele)",
    demo: "Demo",
    unnamed: "Bez nazwy",
    view: "Pokaż",
    open: "Otw\xf3rz",
    hide: "Ukryj",
    unknown_error: "Nieznany błąd, spr\xf3buj ponownie p\xf3źniej.",
    select: "Wybierz",
    contact_us_action: "Skontaktuj się z nami",
    description: "Opis",
    name: "Nazwa",
    add_field: "Dodaj {{field}}",
    create_field: "Utw\xf3rz {{field}}",
    edit_field: "Edytuj {{field}}",
    delete_field: "Usuń {{field}}",
    coming_soon: "Wkr\xf3tce dostępne",
    or: "Lub"
};
var $6a7dd7cf7aa9a02c$export$2e2bcd8739ae039 = Object.freeze($6a7dd7cf7aa9a02c$var$general);


const $6edfd18b56e8a603$var$get_started = {
    page_title: "Rozpocznij",
    title: "Coś do odkrycia, aby pom\xf3c ci odnieść sukces",
    subtitle: "Kilka rzeczy, kt\xf3re możesz zrobić, aby szybko uzyskać wartość Logto",
    develop: {
        title: "Develop: Zajmie to 5 minut, aby zintegrować swoją aplikację",
        title_cloud: "Develop: Bezpiecznie zintegruj swoją aplikację w kilka minut",
        subtitle_cloud: "Lub poświęć 5 minut na integrację swojej aplikacji za pomocą naszych gotowych SDK\xf3w i samouczk\xf3w."
    },
    customize: {
        title: "Customize: Dostarcz świetne doświadczenie logowania",
        preview: {
            title: "Sprawdź podgląd na żywo doświadczenia logowania, kt\xf3re właśnie spersonalizowałeś",
            subtitle: "Wypr\xf3buj teraz Logto, aby zobaczyć, jak działa"
        },
        connector: {
            title: "Dodaj więcej konektor\xf3w, aby obsługiwać r\xf3żne metody logowania społecznego",
            subtitle: "Wypr\xf3buj logowanie bez hasła i włącz bezpieczne i bezproblemowe doświadczenie dla swoich klient\xf3w"
        },
        continue_customizing: "Kontynuuj dostosowywanie",
        try_now: "Wypr\xf3buj teraz",
        add_more: "Dodaj więcej"
    },
    secure: {
        title: "Zabezpiecz: Chron swoje zasoby"
    },
    manage: {
        title: "Zarządzaj: Określ kontrolę dostępu do swojego produktu i użytkownik\xf3w",
        rbac: {
            title: "Dodaj oparte na rolach zarządzanie dostępem, aby chronić swoje zasoby",
            subtitle: "Kontroluj swoje zasoby za pomocą skalowalnej autoryzacji opartej na rolach dla r\xf3żnych przypadk\xf3w użycia"
        },
        create_roles: "Tw\xf3rz role"
    },
    view_all: "Zobacz wszystkie →"
};
var $6edfd18b56e8a603$export$2e2bcd8739ae039 = Object.freeze($6edfd18b56e8a603$var$get_started);


const $0e3bce49b0c6e520$var$guide = {
    start_building: "Rozpocznij budowanie",
    get_started: "Zacznij teraz",
    categories: {
        featured: "Popularne i dla Ciebie",
        Traditional: "Tradycyjna aplikacja internetowa",
        SPA: "Aplikacja na jednej stronie",
        Native: "Natywna",
        MachineToMachine: "Maszyna-do-maszyny",
        Protected: "Integracja zewnętrzna",
        ThirdParty: "Aplikacja innej firmy"
    },
    filter: {
        title: "Filtr Framework",
        placeholder: "Szukaj framework"
    },
    checkout_tutorial: "Sprawdź samouczek {{name}}",
    do_not_need_tutorial: "Jeśli nie potrzebujesz samouczka, możesz kontynuować bez przewodnika frameworku",
    finish_and_done: "Zakończ i zrobione",
    cannot_find_guide: "Nie mogę znaleźć przewodnika?",
    describe_guide_looking_for: "Opisz przewodnik, kt\xf3rego szukasz",
    request_guide_successfully: "Twoje zgłoszenie zostało pomyślnie przesłane. Dziękujemy!",
    app: {
        select_framework_or_tutorial: "Wybierz framework lub samouczek",
        guide_modal_title: "Zacznij z SDK i przewodnikami",
        modal_subtitle: "Przyspiesz sw\xf3j proces rozwoju aplikacji za pomocą naszych prezentacji SDK i samouczk\xf3w.",
        select_a_framework: "Wybierz framework",
        continue_without_framework: "Utw\xf3rz aplikację bez frameworku",
        describe_guide_looking_for_placeholder: "Na przykład, chcę zintegrować Logto z moją aplikacją Angular."
    },
    api: {
        modal_title: "Zacznij od samouczk\xf3w",
        modal_subtitle: "Przyspiesz sw\xf3j proces rozwoju aplikacji za pomocą naszych prezentacji samouczk\xf3w.",
        select_a_tutorial: "Wybierz samouczek",
        continue_without_tutorial: "Kontynuuj bez samouczka",
        describe_guide_looking_for_placeholder: "Na przykład, chcę chronić moje API przy użyciu deno."
    }
};
var $0e3bce49b0c6e520$export$2e2bcd8739ae039 = Object.freeze($0e3bce49b0c6e520$var$guide);


const $e8457923b8ba4963$var$invitation = {
    find_your_tenants: "Znajdź swoich najemc\xf3w",
    find_tenants_description: "Tw\xf3j adres e-mailowy może być już zarejestrowany u wielu najemc\xf3w. Możesz wybrać dołączenie do istniejących lub kontynuować tworzenie nowego.",
    create_new_tenant: "Utw\xf3rz nowego najemcę",
    email_not_match_title: "Jesteś obecnie zalogowany jako\n{{email}}",
    email_not_match_description: "Zaloguj się na poprawne konto, aby zaakceptować zaproszenie i stać się członkiem organizacji.",
    switch_account: "Zaloguj się na inne konto",
    invalid_invitation_status: "Nieprawidłowe zaproszenie. Skontaktuj się z administratorem i spr\xf3buj ponownie.",
    invitation_not_found: "Zaproszenie nie znalezione. Skontaktuj się z administratorem."
};
var $e8457923b8ba4963$export$2e2bcd8739ae039 = Object.freeze($e8457923b8ba4963$var$invitation);


const $faa859f68848f324$var$jwt_claims = {
    title: "Niestandardowe JWT",
    description: "Ustaw niestandardowe roszczenia JWT, kt\xf3re mają być dołączone do tokenu dostępowego. Te roszczenia mogą być wykorzystane do przekazywania dodatkowych informacji do Twojej aplikacji.",
    user_jwt: {
        card_title: "Dla użytkownika",
        card_field: "Token dostępowy użytkownika",
        card_description: "Dodaj dane specyficzne dla użytkownika podczas wydawania tokenu dostępowego.",
        for: "dla użytkownika"
    },
    machine_to_machine_jwt: {
        card_title: "Dla M2M",
        card_field: "Token maszynowy do maszyny",
        card_description: "Dodaj dodatkowe dane podczas wydawania tokena maszynowego do maszyny.",
        for: "dla M2M"
    },
    code_editor_title: "Dostosuj roszczenia {{token}}",
    custom_jwt_create_button: "Dodaj niestandardowe roszczenia",
    custom_jwt_item: "Niestandardowe roszczenia {{for}}",
    delete_modal_title: "Usuń niestandardowe roszczenia",
    delete_modal_content: "Czy na pewno chcesz usunąć niestandardowe roszczenia?",
    clear: "Wyczyść",
    cleared: "Wyczyszczono",
    restore: "Przywr\xf3ć domyślne",
    restored: "Przywr\xf3cono",
    data_source_tab: "Źr\xf3dło danych",
    test_tab: "Kontekst testowy",
    jwt_claims_description: "Domyślne roszczenia są automatycznie dołączane do JWT i nie mogą być nadpisane.",
    user_data: {
        title: "Dane użytkownika",
        subtitle: "Użyj parametru wejściowego `data.user`, aby dostarczyć istotne informacje o użytkowniku."
    },
    token_data: {
        title: "Dane tokenu",
        subtitle: "Użyj parametru wejściowego `token`, aby uzyskać bieżący ładunek tokenu dostępu."
    },
    fetch_external_data: {
        title: "Pobierz zewnętrzne dane",
        subtitle: "Wł\xf3ż dane bezpośrednio z Twoich zewnętrznych API do roszczeń.",
        description: "Użyj funkcji `fetch`, aby wywołać Twoje zewnętrzne API i dołączyć dane do niestandardowych roszczeń. Przykład: "
    },
    environment_variables: {
        title: "Ustaw zmienne środowiskowe",
        subtitle: "Użyj zmiennych środowiskowych do przechowywania poufnych informacji.",
        input_field_title: "Dodaj zmienne środowiskowe",
        sample_code: "Dostęp do zmiennych środowiskowych w twoim programie obsługi niestandardowych roszczeń JWT. Przykład: "
    },
    jwt_claims_hint: "Ogranicz niestandardowe roszczenia do mniej niż 50 KB. Domyślne roszczenia JWT są automatycznie dołączane do tokenu i nie mogą być nadpisane.",
    tester: {
        subtitle: "Dostosuj fałszywy token i dane użytkownika do testowania.",
        run_button: "Uruchom test",
        result_title: "Wynik testu"
    },
    form_error: {
        invalid_json: "Nieprawidłowy format JSON"
    }
};
var $faa859f68848f324$export$2e2bcd8739ae039 = Object.freeze($faa859f68848f324$var$jwt_claims);


const $f87898fc77f59136$var$log_details = {
    page_title: "Szczeg\xf3ły dziennika audytu",
    back_to_logs: "Powr\xf3ć do dziennika audytu",
    back_to: "Powr\xf3ć do {{name}}",
    success: "Sukces",
    failed: "Niepowodzenie",
    event_key: "Klucz zdarzenia",
    application: "Aplikacja",
    ip_address: "Adres IP",
    user: "Użytkownik",
    log_id: "ID dziennika",
    time: "Czas",
    user_agent: "Użytkownik agent",
    tab_details: "Szczeg\xf3ły",
    raw_data: "Surowe dane"
};
var $f87898fc77f59136$export$2e2bcd8739ae039 = Object.freeze($f87898fc77f59136$var$log_details);


const $cfa36bdd1dc289f6$var$logs = {
    page_title: "Dziennik audytu",
    title: "Dziennik audytu",
    subtitle: "Wyświetl dane dziennika dotyczące zdarzeń uwierzytelnienia dokonywanych przez Twoich użytkownik\xf3w",
    event: "Zdarzenie",
    user: "Użytkownik",
    application: "Aplikacja",
    time: "Czas",
    filter_by: "Filtruj według"
};
var $cfa36bdd1dc289f6$export$2e2bcd8739ae039 = Object.freeze($cfa36bdd1dc289f6$var$logs);


const $b8d68fcc47556038$var$menu = {
    profile: "Profil",
    language: "Język",
    appearance: {
        label: "Wygląd",
        light: "Tryb jasny",
        dark: "Tryb ciemny",
        system: "Synchronizuj z systemem"
    },
    sign_out: "Wyloguj się"
};
var $b8d68fcc47556038$export$2e2bcd8739ae039 = Object.freeze($b8d68fcc47556038$var$menu);


const $4ce337c2d440cc95$var$mfa = {
    title: "Wielopoziomowe uwierzytelnianie",
    description: "Dodaj wielopoziomowe uwierzytelnianie, aby zwiększyć bezpieczeństwo swojego doświadczenia z logowaniem.",
    factors: "Czynniki",
    multi_factors: "Wieloczynniki",
    multi_factors_description: "Użytkownicy muszą zweryfikować jeden z włączonych czynnik\xf3w podczas dwustopniowej weryfikacji.",
    totp: "Aplikacja autentykacyjna OTP",
    otp_description: "Połącz Google Authenticator itp., aby zweryfikować jednorazowe hasła.",
    webauthn: "WebAuthn (Klucz przechodni)",
    webauthn_description: "Zweryfikuj za pomocą metody obsługiwanej przez przeglądarkę: biometria, skanowanie telefonem lub klucz zabezpieczeń, itp.",
    webauthn_native_tip: "WebAuthn nie jest obsługiwane dla aplikacji natywnych.",
    webauthn_domain_tip: "WebAuthn łączy klucze publiczne z konkretną domeną. Modyfikacja domeny usługi zablokuje użytkownik\xf3w przed uwierzytelnianiem za pomocą istniejących kluczy przechodnich.",
    backup_code: "Kod zapasowy",
    backup_code_description: "Generuj 10 jednorazowych kod\xf3w zapasowych po skonfigurowaniu dowolnej metody MFA przez użytkownik\xf3w.",
    backup_code_setup_hint: "Gdy użytkownicy nie mogą zweryfikować powyższych czynnik\xf3w MFA, skorzystaj z opcji kopii zapasowej.",
    backup_code_error_hint: "Aby użyć kodu zapasowego, potrzebujesz co najmniej jednej kolejnej metody MFA do pomyślnego uwierzytelniania użytkownika.",
    policy: "Polityka",
    policy_description: "Ustaw politykę MFA dla proces\xf3w logowania i rejestracji.",
    two_step_sign_in_policy: "Polityka weryfikacji dwuetapowej podczas logowania",
    user_controlled: "Użytkownicy mogą samodzielnie włączać lub wyłączać MFA",
    user_controlled_tip: "Użytkownicy mogą pominąć konfigurację MFA podczas pierwszego logowania lub rejestracji lub włączyć/wyłączyć ją w ustawieniach konta.",
    mandatory: "Użytkownicy zawsze muszą korzystać z MFA podczas logowania",
    mandatory_tip: "Użytkownicy muszą skonfigurować MFA podczas pierwszego logowania lub rejestracji i używać go przy każdym kolejnym logowaniu."
};
var $4ce337c2d440cc95$export$2e2bcd8739ae039 = Object.freeze($4ce337c2d440cc95$var$mfa);


const $51e63832d04722bc$var$organization_details = {
    page_title: "Szczeg\xf3ły organizacji",
    delete_confirmation: "Po usunięciu wszyscy członkowie stracą swoje członkostwo i role w tej organizacji. Tego działania nie można cofnąć.",
    organization_id: "ID organizacji",
    settings_description: "Organizacje reprezentują zespoły, klient\xf3w biznesowych i partner\xf3w, kt\xf3rzy mogą mieć dostęp do Twoich aplikacji.",
    name_placeholder: "Nazwa organizacji, nie musi być unikalna.",
    description_placeholder: "Opis organizacji.",
    member: "Członek",
    member_other: "Członkowie",
    add_members_to_organization: "Dodaj członk\xf3w do organizacji {{name}}",
    add_members_to_organization_description: "Znajdź odpowiednich użytkownik\xf3w, wyszukując nazwę, adres e-mail, numer telefonu lub identyfikator użytkownika. Istniejący członkowie nie są wyświetlani w wynikach wyszukiwania.",
    add_with_organization_role: "Dodaj z rolą(ami) organizacji",
    user: "Użytkownik",
    authorize_to_roles: "Autoryzuj {{name}} dostęp do następujących r\xf3l:",
    edit_organization_roles: "Edytuj role organizacji",
    edit_organization_roles_of_user: "Edytuj role organizacji użytkownika {{name}}",
    remove_user_from_organization: "Usuń użytkownika z organizacji",
    remove_user_from_organization_description: "Po usunięciu użytkownik straci swoje członkostwo i role w tej organizacji. Tego działania nie można cofnąć.",
    search_user_placeholder: "Wyszukaj według nazwy, adresu e-mail, numeru telefonu lub identyfikatora użytkownika",
    at_least_one_user: "Wymagany jest co najmniej jeden użytkownik.",
    custom_data: "Dane niestandardowe",
    custom_data_tip: "Dane niestandardowe to obiekt JSON, kt\xf3ry może być wykorzystany do przechowywania dodatkowych danych związanych z organizacją.",
    invalid_json_object: "Nieprawidłowy obiekt JSON."
};
var $51e63832d04722bc$export$2e2bcd8739ae039 = Object.freeze($51e63832d04722bc$var$organization_details);


const $f50b4028500e1df6$var$organization_role_details = {
    page_title: "Szczeg\xf3ły roli organizacji",
    back_to_org_roles: "Powr\xf3t do r\xf3l organizacyjnych",
    org_role: "Rola organizacji",
    delete_confirm: "W wyniku tego zostaną usunięte uprawnienia związane z tą rolą od dotkniętych użytkownik\xf3w i zostaną usunięte związki między rolami organizacyjnymi, członkami organizacji a uprawnieniami organizacji.",
    deleted: "Rola organizacji {{name}} została pomyślnie usunięta.",
    permissions: {
        tab: "Uprawnienia",
        name_column: "Uprawnienie",
        description_column: "Opis",
        type_column: "Typ uprawnienia",
        type: {
            api: "Uprawnienie API",
            org: "Uprawnienia organizacyjne"
        },
        assign_permissions: "Przypisz uprawnienia",
        remove_permission: "Usuń uprawnienie",
        remove_confirmation: "Jeśli to uprawnienie zostanie usunięte, użytkownik z tą rolą organizacyjną utraci dostęp udzielony przez to uprawnienie.",
        removed: "Uprawnienie {{name}} zostało pomyślnie usunięte z tej roli organizacyjnej",
        assign_description: "Przypisz uprawnienia do r\xf3l w tej organizacji. Mogą one obejmować zar\xf3wno uprawnienia organizacyjne, jak i uprawnienia interfejsu API.",
        organization_permissions: "Uprawnienia organizacyjne",
        api_permissions: "Uprawnienia interfejsu API",
        assign_organization_permissions: "Przydziel uprawnienia organizacyjne",
        assign_api_permissions: "Przydziel uprawnienia API"
    },
    general: {
        tab: "Og\xf3lne",
        settings: "Ustawienia",
        description: "Rola organizacyjna to grupowanie uprawnień, kt\xf3re mogą być przypisane użytkownikom. Uprawnienia mogą pochodzić z predefiniowanych uprawnień organizacyjnych i uprawnień API.",
        name_field: "Nazwa",
        description_field: "Opis",
        description_field_placeholder: "Użytkownicy z uprawnieniami tylko do odczytu"
    }
};
var $f50b4028500e1df6$export$2e2bcd8739ae039 = Object.freeze($f50b4028500e1df6$var$organization_role_details);


const $e438f89f7fe68702$var$organization_template = {
    title: "Szablon organizacji",
    subtitle: "W aplikacjach SaaS wielonajemniczych szablon organizacji definiuje wsp\xf3lne zasady kontroli dostępu (uprawnienia i role) dla wielu organizacji.",
    roles: {
        tab_name: "Role org",
        search_placeholder: "Szukaj po nazwie roli",
        create_title: "Utw\xf3rz rolę org",
        role_column: "Rola org",
        permissions_column: "Uprawnienia",
        placeholder_title: "Rola organizacyjna",
        placeholder_description: "Rola organizacyjna to grupowanie uprawnień, kt\xf3re można przypisać użytkownikom. Uprawnienia muszą pochodzić z wcześniej zdefiniowanych uprawnień organizacyjnych.",
        create_modal: {
            title: "Utw\xf3rz rolę organizacji",
            create: "Utw\xf3rz rolę",
            name_field: "Nazwa roli",
            description_field: "Opis",
            created: "Rola organizacji {{name}} została pomyślnie utworzona."
        }
    },
    permissions: {
        tab_name: "Uprawnienia org",
        search_placeholder: "Szukaj po nazwie uprawnienia",
        create_org_permission: "Utw\xf3rz uprawnienie org",
        permission_column: "Uprawnienie organizacji",
        description_column: "Opis",
        placeholder_title: "Uprawnienie organizacyjne",
        placeholder_description: "Uprawnienie organizacyjne odnosi się do autoryzacji dostępu do zasobu w kontekście organizacji.",
        delete_confirm: "Jeśli to uprawnienie zostanie usunięte, wszystkie role organizacyjne zawierające to uprawnienie stracą je, a użytkownicy, kt\xf3rzy mieli to uprawnienie, stracą dostęp przyznany przez nie.",
        create_title: "Utw\xf3rz uprawnienie organizacji",
        edit_title: "Edytuj uprawnienie organizacji",
        permission_field_name: "Nazwa uprawnienia",
        description_field_name: "Opis",
        description_field_placeholder: "Przeczytaj historię spotkań",
        create_permission: "Utw\xf3rz uprawnienie",
        created: "Uprawnienie organizacji {{name}} zostało pomyślnie utworzone."
    }
};
var $e438f89f7fe68702$export$2e2bcd8739ae039 = Object.freeze($e438f89f7fe68702$var$organization_template);


const $7f7a36c0888fb76f$var$organizations = {
    organization: "Organizacja",
    page_title: "Organizacje",
    title: "Organizacje",
    subtitle: "Organizacje są zazwyczaj używane w aplikacjach typu SaaS lub podobnych dla wielu najemc\xf3w i reprezentują Twoich klient\xf3w, kt\xf3rzy są zespołami, organizacjami lub całymi firmami. Organizacje są podstawowym elementem do uwierzytelniania i autoryzacji B2B.",
    organization_template: "Szablon organizacji",
    organization_id: "ID organizacji",
    members: "Członkowie",
    create_organization: "Utw\xf3rz organizację",
    setup_organization: "Skonfiguruj swoją organizację",
    organization_list_placeholder_title: "Organizacja",
    organization_list_placeholder_text: "Organizacje są często wykorzystywane w aplikacjach typu SaaS lub podobnych jako praktyka najlepsza. Pozwalają one tworzyć aplikacje, kt\xf3re umożliwiają klientom tworzenie i zarządzanie organizacjami, zapraszanie członk\xf3w oraz przypisywanie r\xf3l.",
    organization_name_placeholder: "Moja organizacja",
    organization_description_placeholder: "Kr\xf3tki opis organizacji",
    organization_permission: "Uprawnienie organizacji",
    organization_permission_other: "Uprawnienia organizacji",
    create_permission_placeholder: "Odczyt historii spotkań",
    organization_role: "Rola organizacji",
    organization_role_other: "Role organizacji",
    organization_role_description: "Rola organizacji to grupowanie uprawnień, kt\xf3re można przypisać użytkownikom. Uprawnienia muszą pochodzić z wcześniej zdefiniowanych uprawnień organizacji.",
    role: "Rola",
    search_placeholder: "Wyszukaj według nazwy lub ID organizacji",
    search_role_placeholder: "Wpisz, aby wyszukać i wybrać role",
    empty_placeholder: "\uD83E\uDD14 Nie masz jeszcze ustawionego żadnego {{entity}}.",
    organization_and_member: "Organizacja i członek",
    organization_and_member_description: 'Organizacja to grupa użytkownik\xf3w i może reprezentować zespoły, klient\xf3w biznesowych i partner\xf3w firm, z kt\xf3rych każdy użytkownik jest "Członkiem". Mogą to być podstawowe jednostki do obsługi wymagań wielomandantowych.',
    guide: {
        title: "Zacznij od przewodnik\xf3w",
        subtitle: "Wł\xf3ż kł\xf3dę pod stopy swoich ustawień organizacji za pomocą naszych przewodnik\xf3w",
        introduction: {
            title: "Zrozum, jak działa organizacja w Logto",
            section_1: {
                title: "Organizacja to grupa użytkownik\xf3w (tożsamości)"
            },
            section_2: {
                title: "Szablon organizacji jest przeznaczony do kontroli dostępu do aplikacji wielomandantowych",
                description: 'W wielomandantowych aplikacjach typu SaaS, wiele organizacji często dzieli ten sam szablon kontroli dostępu, kt\xf3ry obejmuje uprawnienia i role. W Logto nazywamy to "szablonem organizacji".',
                permission_description: "Uprawnienie organizacji odnosi się do autoryzacji dostępu do zasob\xf3w w kontekście organizacji.",
                role_description_deprecated: "Rola organizacji to grupowanie uprawnień organizacji, kt\xf3re można przypisać członkom.",
                role_description: "Rola organizacyjna to grupowanie uprawnień organizacyjnych lub uprawnień API, kt\xf3re mogą być przypisane do członk\xf3w."
            },
            section_3: {
                title: "Czy mogę przypisać uprawnienia API do r\xf3l organizacyjnych?",
                description: "Tak, możesz przypisać uprawnienia API do r\xf3l organizacyjnych. Logto oferuje elastyczność w skutecznym zarządzaniu rolami w organizacji, pozwalając na włączenie zar\xf3wno uprawnień organizacyjnych, jak i uprawnień API do tych r\xf3l."
            },
            section_4: {
                title: "Zaangażuj się w ilustrację, aby zobaczyć jak to wszystko się łączy",
                description: "Przyjmijmy przykład. John, Sarah należą do r\xf3żnych organizacji z r\xf3żnymi rolami w kontekście r\xf3żnych organizacji. Najedź kursorem na r\xf3żne moduły i zobacz co się stanie."
            }
        },
        organization_permissions: "Uprawnienia organizacji",
        organization_roles: "Role organizacji",
        admin: "Administrator",
        member: "Członek",
        guest: "Gość",
        role_description: 'Rola "{{role}}" dzieli ten sam szablon organizacji między r\xf3żnymi organizacjami.',
        john: "John",
        john_tip: 'John należy do dw\xf3ch organizacji, a jedynym identyfikatorem jest adres e-mail "john@email.com". Jest administratorem organizacji A oraz gościem organizacji B.',
        sarah: "Sarah",
        sarah_tip: 'Sarah należy do jednej organizacji, a jedynym identyfikatorem jest adres e-mail "sarah@email.com". Jest administratorem organizacji B.'
    }
};
var $7f7a36c0888fb76f$export$2e2bcd8739ae039 = Object.freeze($7f7a36c0888fb76f$var$organizations);


const $a7cad30ae766db5d$var$permissions = {
    search_placeholder: "Szukaj według API lub nazwy uprawnienia",
    search_placeholder_without_api: "Szukaj według nazwy uprawnienia",
    name_column: "Uprawnienie",
    description_column: "Opis",
    api_column: "API",
    placeholder_title: "Uprawnienie",
    placeholder_description: "Uprawnienie odnosi się do autoryzacji dostępu do zasobu (nazywamy go zasobem API).",
    edit: "Uprawnienia do edycji",
    delete: "Uprawnienia do usunięcia",
    remove: "Uprawnienia do usunięcia",
    edit_title: "Edytuj uprawnienia API"
};
var $a7cad30ae766db5d$export$2e2bcd8739ae039 = Object.freeze($a7cad30ae766db5d$var$permissions);


const $dcd805ed03305ef6$var$profile = {
    page_title: "Ustawienia konta",
    title: "Ustawienia konta",
    description: "Zmień swoje ustawienia konta i zarządzaj swoimi danymi osobistymi tutaj, aby zapewnić bezpieczeństwo Twojego konta.",
    settings: {
        title: "USTAWIENIA PROFILU",
        profile_information: "Informacje o profilu",
        avatar: "Awatar",
        name: "Nazwa",
        username: "Nazwa użytkownika"
    },
    link_account: {
        title: "POŁĄCZ KONTO",
        email_sign_in: "Zaloguj się przez e-mail",
        email: "Email",
        social_sign_in: "Zaloguj się przez media społecznościowe",
        link_email: "Połącz email",
        link_email_subtitle: "Połącz sw\xf3j email, aby się zalogować lub pom\xf3c w odzyskiwaniu konta.",
        email_required: "Email jest wymagany",
        invalid_email: "Nieprawidłowy adres email",
        identical_email_address: "Adres email jest taki sam jak obecny",
        anonymous: "Anonimowy"
    },
    password: {
        title: "HASŁO I BEZPIECZEŃSTWO",
        password: "Hasło",
        password_setting: "Ustawienia hasła",
        new_password: "Nowe hasło",
        confirm_password: "Potwierdź hasło",
        enter_password: "Wprowadź obecne hasło",
        enter_password_subtitle: "Zweryfikuj swoją tożsamość, aby chronić bezpieczeństwo swojego konta. Przed zmianą proszę wprowadzić swoje aktualne hasło.",
        set_password: "Ustaw hasło",
        verify_via_password: "Zweryfikuj za pomocą hasła",
        show_password: "Pokaż hasło",
        required: "Hasło jest wymagane",
        do_not_match: "Hasła nie pasują do siebie. Spr\xf3buj ponownie."
    },
    code: {
        enter_verification_code: "Wprowadź kod weryfikacyjny",
        enter_verification_code_subtitle: "Kod weryfikacyjny został wysłany na adres <strong>{{target}}</strong>",
        verify_via_code: "Zweryfikuj za pomocą kodu weryfikacyjnego",
        resend: "Wyślij ponownie kod weryfikacyjny",
        resend_countdown: "Wyślij ponownie za {{countdown}} sekund"
    },
    delete_account: {
        title: "USUŃ KONTO",
        label: "Usuń konto",
        description: "Usunięcie twojego konta spowoduje usunięcie wszystkich twoich danych osobistych, danych użytkownika i konfiguracji. Ta operacja nie może być cofnięta.",
        button: "Usuń konto",
        dialog_paragraph_1: "Żałujemy, że chcesz usunąć swoje konto. Usunięcie twojego konta spowoduje trwałe usunięcie wszystkich danych, w tym informacji o użytkowniku, log\xf3w i ustawień, i ta operacja nie może być cofnięta. Przed dokonaniem tej operacji zalecamy wykonanie kopii zapasowych ważnych danych.",
        dialog_paragraph_2: 'Aby przejść do procesu usuwania konta, wyślij email do naszego zespołu wsparcia na adres <a>{{mail}}</a> z tematem "Żądanie usunięcia konta". Pomożemy Ci i zapewnimy, że wszystkie twoje dane zostaną poprawnie usunięte z naszego systemu.',
        dialog_paragraph_3: "Dziękujemy za wybranie chmury Logto. Jeśli masz jakieś dodatkowe pytania lub wątpliwości, skontaktuj się z nami."
    },
    set: "Ustaw",
    change: "Zmień",
    link: "Połącz",
    unlink: "Odłącz",
    not_set: "Nie ustawione",
    change_avatar: "Zmień awatar",
    change_name: "Zmień nazwę",
    change_username: "Zmień nazwę użytkownika",
    set_name: "Ustaw nazwę",
    email_changed: "Adres email został zmieniony.",
    password_changed: "Hasło zostało zmienione.",
    updated: "{{target}} zaktualizowane.",
    linked: "{{target}} połączone.",
    unlinked: "{{target}} rozłączone.",
    email_exists_reminder: "Ten adres e-mail {{email}} jest powiązany z istniejącym kontem. Połącz inny e-mail tutaj.",
    unlink_confirm_text: "Tak, odłącz",
    unlink_reminder: "Użytkownicy nie będą mogli się zalogować z kontem <span></span>, jeśli je odłączysz. Czy na pewno chcesz kontynuować?"
};
var $dcd805ed03305ef6$export$2e2bcd8739ae039 = Object.freeze($dcd805ed03305ef6$var$profile);


const $3161b081879d39fd$var$protected_app = {
    name: "Aplikacja chroniona",
    title: "Stw\xf3rz aplikację zabezpieczoną: Dodaj uwierzytelnienie w prosty spos\xf3b i z dużą prędkością",
    description: "Aplikacja chroniona bezpiecznie zarządza sesjami użytkownik\xf3w i przekierowuje żądania Twojej aplikacji. Dzięki Cloudflare Workers, ciesz się wydajnością najwyższej klasy i zerowym czasem uruchamiania globalnie. <a>Dowiedz się więcej</a>",
    fast_create: "Szybkie tworzenie",
    modal_title: "Utw\xf3rz aplikację chronioną",
    modal_subtitle: "Włącz bezpieczną i szybką ochronę za pomocą kilku kliknięć. Dodaj uwierzytelnienie do istniejącej aplikacji internetowej z łatwością.",
    form: {
        url_field_label: "Tw\xf3j adres URL źr\xf3dłowy",
        url_field_placeholder: "https://domena.com/",
        url_field_description: "Podaj adres swojej aplikacji wymagającej ochrony uwierzytelnienia.",
        url_field_modification_notice: "Modyfikacje w adresie URL źr\xf3dłowym mogą potrwać od 1 do 2 minut, aby zacząć działać na całym globalnym sieciowym miejscu.",
        url_field_tooltip: "Podaj adres swojej aplikacji, pomijając wszelkie '/ścieżki'. Po utworzeniu możesz dostosować zasady uwierzytelniania trasy.\n\nUwaga: Sam adres URL źr\xf3dłowy nie wymaga uwierzytelnienia; ochrona jest stosowana wyłącznie do dostęp\xf3w poprzez wyznaczoną domenę aplikacji.",
        domain_field_label: "Domena aplikacji",
        domain_field_placeholder: "twoja-domena",
        domain_field_description: "Ten adres URL służy jako proxy ochrony uwierzytelnienia dla oryginalnego URL. Domena niestandardowa może zostać zastosowana po utworzeniu.",
        domain_field_description_short: "Ten adres URL służy jako proxy ochrony uwierzytelnienia dla oryginalnego URL.",
        domain_field_tooltip: "Aplikacje chronione przez Logto będą hostowane domyślnie pod adresem 'twoja-domena.{{domain}}'. Domena niestandardowa może zostać zastosowana po utworzeniu.",
        create_application: "Stw\xf3rz aplikację",
        create_protected_app: "Szybkie tworzenie",
        errors: {
            domain_required: "Twoja domena jest wymagana.",
            domain_in_use: "Ta nazwa poddomeny jest już w użyciu.",
            invalid_domain_format: "Nieprawidłowy format poddomeny: użyj tylko małych liter, liczb i myślnik\xf3w '-'.",
            url_required: "Adres URL źr\xf3dłowy jest wymagany.",
            invalid_url: "Nieprawidłowy format adresu URL źr\xf3dłowego: Użyj http:// lub https://. Uwaga: '/ścieżka' nie jest obecnie obsługiwana.",
            localhost: "Najpierw wystaw sw\xf3j lokalny serwer do internetu. Dowiedz się więcej o <a>lokalnym rozwoju</a>."
        }
    },
    success_message: "\uD83C\uDF89 Uwierzytelnienie aplikacji pomyślnie włączone! Odkryj nowe doświadczenia Twojej strony internetowej."
};
var $3161b081879d39fd$export$2e2bcd8739ae039 = Object.freeze($3161b081879d39fd$var$protected_app);


const $7e83dc7daa2a4008$var$role_details = {
    back_to_roles: "Powr\xf3t do r\xf3l",
    identifier: "Identyfikator",
    delete_description: "Usunięcie tej roli usunie uprawnienia z nią związane od użytkownik\xf3w i usunie odwzorowanie między rolami, użytkownikami i uprawnieniami.",
    role_deleted: "{{name}} został pomyślnie usunięty.",
    general_tab: "Og\xf3lne",
    users_tab: "Użytkownicy",
    m2m_apps_tab: "Maszyny do maszyn",
    permissions_tab: "Uprawnienia",
    settings: "Ustawienia",
    settings_description: "Role to grupowanie uprawnień, kt\xf3re mogą być przypisywane do użytkownik\xf3w. Zapewniają r\xf3wnież spos\xf3b agregacji uprawnień zdefiniowanych dla r\xf3żnych interfejs\xf3w API, co umożliwia bardziej efektywne dodawanie, usuwanie lub modyfikowanie uprawnień w por\xf3wnaniu z przypisywaniem ich do użytkownik\xf3w indywidualnie.",
    field_name: "Nazwa",
    field_description: "Opis",
    field_is_default: "Domyślna rola",
    field_is_default_description: "Ustaw tę rolę jako domyślną rolę dla nowych użytkownik\xf3w. Można ustawić wiele domyślnych r\xf3l. To r\xf3wnież wpłynie na domyślne role dla użytkownik\xf3w utworzonych za pomocą interfejsu API zarządzania.",
    type_m2m_role_tag: "Rola aplikacji maszynowych",
    type_user_role_tag: "Rola użytkownika",
    m2m_role_notification: "Przypisz tę rolę maszyny do maszyny do aplikacji maszyny do maszyny, aby umożliwić dostęp do odpowiednich zasob\xf3w API. <a>Najpierw utw\xf3rz aplikację maszyny do maszyny</a>, jeśli jeszcze tego nie zrobiłeś.",
    permission: {
        assign_button: "Przypisz uprawnienia",
        assign_title: "Przypisz uprawnienia",
        assign_subtitle: "Przypisz uprawnienia do tej roli. Rola zyska dodane uprawnienia, a użytkownicy z tą rolą odziedziczą te uprawnienia.",
        assign_form_field: "Przypisz uprawnienia",
        added_text_one: "{{count, number}} uprawnienie dodane",
        added_text_other: "{{count, number}} uprawnień dodanych",
        api_permission_count_one: "{{count, number}} uprawnienie",
        api_permission_count_other: "{{count, number}} uprawnień",
        confirm_assign: "Przypisz uprawnienia",
        permission_assigned: "Wybrane uprawnienia zostały pomyślnie przypisane do tej roli",
        deletion_description: "Jeśli to uprawnienie zostanie usunięte, dotknięty użytkownik z tą rolą straci dostęp przyznany przez to uprawnienie.",
        permission_deleted: 'Uprawnienie "{{name}}" zostało pomyślnie usunięte z tej roli',
        empty: "Brak dostępnych uprawnień"
    },
    users: {
        assign_button: "Przydziel użytkownik\xf3w",
        name_column: "Użytkownik",
        app_column: "Aplikacja",
        latest_sign_in_column: "Ostatnie logowanie",
        delete_description: "Osoba pozostanie w bazie użytkownik\xf3w, ale straci autoryzację dla tej roli.",
        deleted: "{{name}} został pomyślnie usunięty z tej roli",
        assign_title: "Przydziel użytkownik\xf3w",
        assign_subtitle: "Przydziel użytkownik\xf3w do tej roli. Znajdź odpowiednich użytkownik\xf3w, wyszukując po nazwie, adresie e-mail, numerze telefonu lub identyfikatorze użytkownika.",
        assign_field: "Przydziel użytkownik\xf3w",
        confirm_assign: "Przydziel użytkownik\xf3w",
        assigned_toast_text: "Wybrani użytkownicy zostali pomyślnie przydzieleni do tej roli",
        empty: "Brak dostępnych użytkownik\xf3w"
    },
    applications: {
        assign_button: "Przypisz aplikacje",
        name_column: "Aplikacja",
        app_column: "Aplikacje",
        description_column: "Opis",
        delete_description: "Aplikacja pozostanie w puli Twoich aplikacji, ale utraci autoryzację dla tej roli.",
        deleted: "{{name}} został pomyślnie usunięty z tej roli",
        assign_title: "Przypisz aplikacje",
        assign_subtitle: "Przypisz aplikacje do tej roli. Znajdź odpowiednie aplikacje, wyszukując po nazwie, opisie lub identyfikatorze aplikacji.",
        assign_field: "Przypisz aplikacje",
        confirm_assign: "Przypisz aplikacje",
        assigned_toast_text: "Wybrane aplikacje zostały pomyślnie przypisane do tej roli",
        empty: "Brak dostępnych aplikacji"
    }
};
var $7e83dc7daa2a4008$export$2e2bcd8739ae039 = Object.freeze($7e83dc7daa2a4008$var$role_details);


const $c3eebc6de985f043$var$roles = {
    page_title: "Rola",
    title: "Rola",
    subtitle: "Rola zawiera uprawnienia określające, co użytkownik może robić. RBAC wykorzystuje role do udostępniania użytkownikom zasob\xf3w do określonych działań.",
    create: "Utw\xf3rz rolę",
    role_name: "Nazwa roli",
    role_type: "Typ roli",
    show_role_type_button_text: "Pokaż więcej opcji",
    hide_role_type_button_text: "Ukryj więcej opcji",
    type_user: "Rola użytkownika",
    type_machine_to_machine: "Rola aplikacji Machine-to-Machine",
    role_description: "Opis",
    role_name_placeholder: "Wprowadź nazwę swojej roli",
    role_description_placeholder: "Wprowadź opis swojej roli",
    col_roles: "Role",
    col_type: "Typ",
    col_description: "Opis",
    col_assigned_entities: "Przypisane",
    user_counts: "{{count}} użytkownicy",
    application_counts: "{{count}} aplikacje",
    user_count: "{{count}} użytkownik",
    application_count: "{{count}} aplikacja",
    assign_permissions: "Przypisz uprawnienia",
    create_role_title: "Utw\xf3rz rolę",
    create_role_description: "Utw\xf3rz i zarządzaj rolami dla swoich aplikacji. Role zawierają zbiory uprawnień i mogą być przypisywane użytkownikom.",
    create_role_button: "Utw\xf3rz rolę",
    role_created: "Rola {{name}} została pomyślnie utworzona.",
    search: "Wyszukaj po nazwie roli, opisie lub identyfikatorze",
    placeholder_title: "Role",
    placeholder_description: "Role są grupowaniem uprawnień, kt\xf3re mogą być przypisywane użytkownikom. Upewnij się, że najpierw dodasz uprawnienie, zanim utworzysz role.",
    assign_user_roles: "Przypisz role użytkownika",
    assign_m2m_roles: "Przypisz role od maszyny do maszyny",
    management_api_access_notification: "Aby uzyskać dostęp do interfejsu API zarządzania Logto, wybierz role z uprawnieniami do interfejsu API zarządzania <flag/>.",
    with_management_api_access_tip: "Ta rola maszyny do maszyny zawiera uprawnienia do interfejsu API zarządzania Logto"
};
var $c3eebc6de985f043$export$2e2bcd8739ae039 = Object.freeze($c3eebc6de985f043$var$roles);


const $5d02266997a13771$var$session_expired = {
    title: "Sesja wygasła",
    subtitle: "Twoja sesja mogła wygasnąć i zostałeś odłączony. Kliknij poniższy przycisk, aby ponownie się zalogować do konsoli administracyjnej.",
    button: "Zaloguj się ponownie"
};
var $5d02266997a13771$export$2e2bcd8739ae039 = Object.freeze($5d02266997a13771$var$session_expired);


const $652ee235f98fe7de$var$content = {
    terms_of_use: {
        title: "TERMS",
        terms_of_use: "Terms of use URL",
        terms_of_use_placeholder: "https://your.terms.of.use/",
        privacy_policy: "Privacy policy URL",
        privacy_policy_placeholder: "https://your.privacy.policy/"
    },
    languages: {
        title: "LANGUAGES",
        enable_auto_detect: "Enable auto-detect",
        description: "Your software detects the user's locale setting and switches to the local language. You can add new languages by translating UI from English to another language.",
        manage_language: "Manage language",
        default_language: "Default language",
        default_language_description_auto: "The default language will be used when the detected user language isn’t covered in the current language library.",
        default_language_description_fixed: "When auto-detect is off, the default language is the only language your software will show. Turn on auto-detect for language extension."
    },
    manage_language: {
        title: "Manage language",
        subtitle: "Localize the product experience by adding languages and translations. Your contribution can be set as the default language.",
        add_language: "Add Language",
        logto_provided: "Logto provided",
        key: "Key",
        logto_source_values: "Logto source values",
        custom_values: "Custom values",
        clear_all_tip: "Clear all values",
        unsaved_description: "Changes won’t be saved if you leave this page without saving.",
        deletion_tip: "Delete the language",
        deletion_title: "Do you want to delete the added language?",
        deletion_description: "After deletion, your users won’t be able to browse in that language again.",
        default_language_deletion_title: "Default language can’t be deleted.",
        default_language_deletion_description: "{{language}} is set as your default language and can’t be deleted. "
    }
};
var $652ee235f98fe7de$export$2e2bcd8739ae039 = Object.freeze($652ee235f98fe7de$var$content);


const $4561db89a154f4e1$var$password_policy = {
    password_requirements: "Wymagania dotyczące hasła",
    minimum_length: "Minimalna długość",
    minimum_length_description: "NIST sugeruje użycie <a>co najmniej 8 znak\xf3w</a> dla produkt\xf3w internetowych.",
    minimum_length_error: "Minimalna długość musi wynosić od {{min}} do {{max}} (włącznie).",
    minimum_required_char_types: "Minimalna liczba wymaganych typ\xf3w znak\xf3w",
    minimum_required_char_types_description: "Typy znak\xf3w: wielkie litery (A-Z), małe litery (a-z), cyfry (0-9) i znaki specjalne ({{symbols}}).",
    password_rejection: "Odrzucanie hasła",
    compromised_passwords: "Odrzucaj skompromitowane hasła",
    breached_passwords: "Odrzucaj naruszone hasła",
    breached_passwords_description: "Odrzucaj hasła, kt\xf3re wcześniej zostały znalezione w bazach naruszeń.",
    restricted_phrases: "Ogranicz niskie zabezpieczenia",
    restricted_phrases_tooltip: "Twoje hasło powinno omijać te frazy, chyba że zestawisz je z 3 lub więcej dodatkowymi znakami.",
    repetitive_or_sequential_characters: "Powtarzające się lub sekwencyjne znaki",
    repetitive_or_sequential_characters_description: 'Na przykład "AAAA", "1234" i "abcd".',
    user_information: "Informacje użytkownika",
    user_information_description: "Na przykład adres e-mail, numer telefonu, nazwa użytkownika itp.",
    custom_words: "Niestandardowe słowa",
    custom_words_description: "Słowa kontekstowe, niezależne od wielkości liter, jeden na linię.",
    custom_words_placeholder: "Nazwa twojej usługi, nazwa firmy itp."
};
var $4561db89a154f4e1$export$2e2bcd8739ae039 = Object.freeze($4561db89a154f4e1$var$password_policy);


const $ece81f0d64a262f8$var$sign_up_and_sign_in = {
    identifiers_email: "Adres e-mail",
    identifiers_phone: "Numer telefonu",
    identifiers_username: "Nazwa użytkownika",
    identifiers_email_or_sms: "Adres e-mail lub numer telefonu",
    identifiers_none: "Nie dotyczy",
    and: "i",
    or: "lub",
    sign_up: {
        title: "REJESTRACJA",
        sign_up_identifier: "Identyfikator rejestracji",
        identifier_description: "Identyfikator rejestracji jest wymagany do utworzenia konta i musi być uwzględniony na ekranie logowania.",
        sign_up_authentication: "Ustawienia uwierzytelniania dla rejestracji",
        authentication_description: "Wszystkie wybrane czynności będą obowiązkowe dla użytkownik\xf3w, aby ukończyć proces rejestracji.",
        set_a_password_option: "Utw\xf3rz hasło",
        verify_at_sign_up_option: "Weryfikuj podczas rejestracji",
        social_only_creation_description: "(Stosuje się tylko do tworzenia kont społecznościowych)"
    },
    sign_in: {
        title: "LOGOWANIE",
        sign_in_identifier_and_auth: "Identyfikator i ustawienia uwierzytelniania dla logowania",
        description: "Użytkownicy mogą się zalogować za pomocą dowolnej dostępnej opcji. Dostosuj układ, przeciągając i upuszczając poniżej opcji.",
        add_sign_in_method: "Dodaj metodę logowania",
        password_auth: "Hasło",
        verification_code_auth: "Kod weryfikacyjny",
        auth_swap_tip: "Zamień poniższe opcje, aby określić, kt\xf3ra pojawia się jako pierwsza w procesie.",
        require_auth_factor: "Musisz wybrać co najmniej jeden czynnik uwierzytelniający."
    },
    social_sign_in: {
        title: "LOGOWANIE SPOŁECZNOŚCIOWE",
        social_sign_in: "Logowanie społecznościowe",
        description: "W zależności od obowiązkowego identyfikatora, kt\xf3rego ustawisz, użytkownik może zostać poproszony o podanie identyfikatora podczas rejestracji za pośrednictwem łącznika społecznościowego.",
        add_social_connector: "Dodaj łącznik społecznościowy",
        set_up_hint: {
            not_in_list: "Nie ma na liście?",
            set_up_more: "Ustaw",
            go_to: "inne łączniki społecznościowe teraz."
        }
    },
    tip: {
        set_a_password: "Unikatowe hasło dla nazwy użytkownika jest konieczne.",
        verify_at_sign_up: "Obecnie obsługujemy tylko weryfikowany adres e-mail. Twoja baza użytkownik\xf3w może zawierać dużą liczbę adres\xf3w e-mail niskiej jakości, jeśli nie dokonasz walidacji.",
        password_auth: "Jest to istotne, ponieważ umożliwiłeś opcję tworzenia hasła podczas procesu rejestracji.",
        verification_code_auth: "Jest to istotne, ponieważ umożliwiłeś wyłącznie opcję podania kodu weryfikacyjnego podczas rejestracji. Możesz odznaczyć pole wyboru, gdy dozwolone jest ustawienie hasła podczas procesu rejestracji.",
        delete_sign_in_method: "Jest to istotne, ponieważ wybrałeś {{identifier}} jako wymagany identyfikator."
    },
    advanced_options: {
        title: "USTAWIENIA ZAAWANSOWANE",
        enable_single_sign_on: "Włącz jednokrotne logowanie przedsiębiorstwa (SSO)",
        enable_single_sign_on_description: "Enable users to sign-in to the application using Single Sign-On with their enterprise identities.",
        single_sign_on_hint: {
            prefix: "Przejdź do ",
            link: '"Enterprise SSO"',
            suffix: "sekcji, aby skonfigurować więcej łącznik\xf3w przedsiębiorstwa."
        },
        enable_user_registration: "Włącz rejestrację użytkownik\xf3w",
        enable_user_registration_description: "Włącz lub wyłącz rejestrację użytkownik\xf3w. Po wyłączeniu użytkownicy nadal mogą być dodawani w konsoli administratora, ale nie mogą już zakładać kont za pomocą interfejsu logowania."
    }
};
var $ece81f0d64a262f8$export$2e2bcd8739ae039 = Object.freeze($ece81f0d64a262f8$var$sign_up_and_sign_in);


const $7d53ae443eafbfaf$var$sign_in_exp = {
    page_title: "Doświadczenie logowania",
    title: "Doświadczenie logowania",
    description: "Dostosuj interfejs logowania, aby pasował do Twojej marki i wyświetlaj w czasie rzeczywistym",
    tabs: {
        branding: "Marka",
        sign_up_and_sign_in: "Rejestracja i logowanie",
        content: "Treść",
        password_policy: "Polityka hasła"
    },
    welcome: {
        title: "Dostosuj swoje doświadczenie logowania",
        description: "Szybkie uruchomienie Twojego pierwszego logowania. Ten przewodnik po krokach przeprowadzi Cię przez wszystkie niezbędne ustawienia.",
        get_started: "Rozpocznij",
        apply_remind: "Należy pamiętać, że doświadczenie logowania będzie stosowane do wszystkich aplikacji w tej sekcji."
    },
    color: {
        title: "KOLOR",
        primary_color: "Kolor marki",
        dark_primary_color: "Kolor marki (ciemny)",
        dark_mode: "Włącz tryb ciemny",
        dark_mode_description: "Twoja aplikacja będzie miała automatycznie wygenerowany szablon trybu ciemnego na podstawie koloru marki i algorytmu Logto. Możesz go swobodnie dostosować.",
        dark_mode_reset_tip: "Przelicz kolor trybu ciemnego na podstawie koloru marki.",
        reset: "Przelicz"
    },
    branding: {
        title: "OPCJE BRANDINGU",
        ui_style: "Styl",
        favicon: "Favicon",
        logo_image_url: "Adres URL obrazka logo aplikacji",
        logo_image_url_placeholder: "https://twoja.domena.cdn/logo.png",
        dark_logo_image_url: "Adres URL obrazka logo aplikacji (Ciemny)",
        dark_logo_image_url_placeholder: "https://twoja.domena.cdn/logo-ciemny.png",
        logo_image: "Logo aplikacji",
        dark_logo_image: "Logo aplikacji (Ciemny)",
        logo_image_error: "Logo aplikacji: {{error}}",
        favicon_error: "Favicon: {{error}}"
    },
    custom_css: {
        title: "Niestandardowe CSS",
        css_code_editor_title: "Dostosuj sw\xf3j interfejs użytkownika niestandardowym CSS",
        css_code_editor_description1: "Zobacz przykład niestandardowego CSS.",
        css_code_editor_description2: "<a>{{link}}</a>",
        css_code_editor_description_link_content: "Dowiedz się więcej",
        css_code_editor_content_placeholder: "Wprowadź swoje niestandardowe CSS, aby dostosować style czegokolwiek do swoich dokładnych specyfikacji. Wyraź swoją kreatywność i wyr\xf3żnij sw\xf3j interfejs użytkownika."
    },
    sign_up_and_sign_in: $ece81f0d64a262f8$export$2e2bcd8739ae039,
    content: $652ee235f98fe7de$export$2e2bcd8739ae039,
    password_policy: $4561db89a154f4e1$export$2e2bcd8739ae039,
    setup_warning: {
        no_connector_sms: "Nie ustawiono jeszcze łącznika SMS. Przed zakończeniem konfiguracji użytkownicy nie będą mogli się zalogować przy użyciu tej metody. <a>{{link}}</a> w sekcji „Łączniki“",
        no_connector_email: "Nie ustawiono jeszcze łącznika e-mail. Przed zakończeniem konfiguracji użytkownicy nie będą mogli się zalogować przy użyciu tej metody. <a>{{link}}</a> w sekcji „Łączniki“",
        no_connector_social: 'Nie skonfigurowałeś jeszcze żadnego konektora społecznościowego. Najpierw dodaj konektory, aby zastosować metody logowania społecznościowego. <a>{{link}}</a> w "Konektory".',
        setup_link: "Konfiguracja"
    },
    save_alert: {
        description: "Wdrażasz nowe procedury logowania i rejestracji. Wszyscy Twoi użytkownicy mogą być dotknięci nową konfiguracją. Czy na pewno zdecydowałeś się na zmiany?",
        before: "Przed",
        after: "Po",
        sign_up: "Rejestracja",
        sign_in: "Logowanie",
        social: "Społecznościowy"
    },
    preview: {
        title: "Podgląd logowania",
        live_preview: "Podgląd na żywo",
        live_preview_tip: "Zapisz, aby obejrzeć zmiany",
        native: "Aplikacja natywna",
        desktop_web: "Wersja desktopowa",
        mobile_web: "Wersja mobilna",
        desktop: "Komputer",
        mobile: "Telefon"
    }
};
var $7d53ae443eafbfaf$export$2e2bcd8739ae039 = Object.freeze($7d53ae443eafbfaf$var$sign_in_exp);


const $ff9bd0fe7a92f31f$var$signing_keys = {
    title: "Klucze podpisu",
    description: "Bezpiecznie zarządzaj kluczami podpis\xf3w używanymi przez twoje aplikacje.",
    private_key: "Prywatne klucze OIDC",
    private_keys_description: "Prywatne klucze OIDC są używane do podpisywania token\xf3w JWT.",
    cookie_key: "Klucze cookie OIDC",
    cookie_keys_description: "Klucze cookie OIDC są używane do podpisywania plik\xf3w cookie.",
    private_keys_in_use: "Używane klucze prywatne",
    cookie_keys_in_use: "Używane klucze ciasteczek",
    rotate_private_keys: "Obr\xf3ć klucze prywatne",
    rotate_cookie_keys: "Obr\xf3ć klucze ciasteczek",
    rotate_private_keys_description: "Ta akcja spowoduje utworzenie nowego klucza prywatnego do podpisywania, obr\xf3cenie bieżącego klucza i usunięcie poprzedniego klucza. Twoje tokeny JWT podpisane aktualnym kluczem pozostaną ważne do czasu usunięcia lub kolejnego obrotu.",
    rotate_cookie_keys_description: "Ta akcja spowoduje utworzenie nowego klucza ciasteczka, obr\xf3cenie bieżącego klucza i usunięcie poprzedniego klucza. Twoje ciasteczka z aktualnym kluczem pozostaną ważne do czasu usunięcia lub kolejnego obrotu.",
    select_private_key_algorithm: "Wybierz algorytm podpisywania klucza dla nowego klucza prywatnego",
    rotate_button: "Obr\xf3ć",
    table_column: {
        id: "ID",
        status: "Status",
        algorithm: "Algorytm podpisywania klucza"
    },
    status: {
        current: "Bieżący",
        previous: "Poprzedni"
    },
    reminder: {
        rotate_private_key: "Czy na pewno chcesz obr\xf3cić <strong>Klucze prywatne OIDC</strong>? Nowo wydane tokeny JWT będą podpisywane nowym kluczem. Istniejące tokeny JWT pozostają ważne do czasu ponownego obrotu.",
        rotate_cookie_key: "Czy na pewno chcesz obr\xf3cić <strong>Klucze ciasteczek OIDC</strong>? Nowo generowane ciasteczka w sesjach logowania będą podpisywane nowym kluczem ciasteczka. Istniejące ciasteczka pozostają ważne do czasu ponownego obrotu.",
        delete_private_key: "Czy na pewno chcesz usunąć <strong>Klucz prywatny OIDC</strong>? Istniejące tokeny JWT podpisane tym kluczem prywatnym przestaną być ważne.",
        delete_cookie_key: "Czy na pewno chcesz usunąć <strong>Klucz ciasteczka OIDC</strong>? Starsze sesje logowania z ciasteczkami podpisanymi tym kluczem ciasteczka przestaną być ważne. Wymagane będzie ponowne uwierzytelnienie tych użytkownik\xf3w."
    },
    messages: {
        rotate_key_success: "Klucze podpisu obr\xf3cone pomyślnie.",
        delete_key_success: "Klucz usunięty pomyślnie."
    }
};
var $ff9bd0fe7a92f31f$export$2e2bcd8739ae039 = Object.freeze($ff9bd0fe7a92f31f$var$signing_keys);


const $711f63ae276d0245$var$quota_item = {
    tenant_limit: {
        name: "Liczba Najemc\xf3w",
        limited: "{{count, number}} najemca",
        limited_other: "{{count, number}} najemcy",
        unlimited: "Nieograniczona liczba najemc\xf3w",
        not_eligible: "Usuń swoich najemc\xf3w"
    },
    mau_limit: {
        name: "Miesięczna liczba aktywnych użytkownik\xf3w",
        limited: "{{count, number}} MAU",
        unlimited: "Nieograniczona liczba MAU",
        not_eligible: "Usuń wszystkich użytkownik\xf3w"
    },
    token_limit: {
        name: "Tokens",
        limited: "{{count, number}} token",
        limited_other: "{{count, number}} tokens",
        unlimited: "Nieograniczona liczba token\xf3w",
        not_eligible: "Usuń wszystkich użytkownik\xf3w, aby zapobiec nowym tokenom"
    },
    applications_limit: {
        name: "Liczba aplikacji",
        limited: "{{count, number}} aplikacja",
        limited_other: "{{count, number}} aplikacje",
        unlimited: "Nieograniczona liczba aplikacji",
        not_eligible: "Usuń swoje aplikacje"
    },
    machine_to_machine_limit: {
        name: "Machine to machine",
        limited: "{{count, number}} aplikacja machine to machine",
        limited_other: "{{count, number}} aplikacje machine to machine",
        unlimited: "Nieograniczona liczba aplikacji machine to machine",
        not_eligible: "Usuń swoje aplikacje machine to machine"
    },
    third_party_applications_limit: {
        name: "Aplikacje os\xf3b trzecich",
        limited: "{{count, number}} aplikacja os\xf3b trzecich",
        limited_other: "{{count, number}} aplikacje os\xf3b trzecich",
        unlimited: "Nieograniczona liczba aplikacji os\xf3b trzecich",
        not_eligible: "Usuń swoje aplikacje os\xf3b trzecich"
    },
    resources_limit: {
        name: "Zasoby API",
        limited: "{{count, number}} zas\xf3b API",
        limited_other: "{{count, number}} zasoby API",
        unlimited: "Nieograniczona liczba zasob\xf3w API",
        not_eligible: "Usuń swoje zasoby API"
    },
    scopes_per_resource_limit: {
        name: "Uprawnienia zasobu",
        limited: "{{count, number}} uprawnienie na zas\xf3b",
        limited_other: "{{count, number}} uprawnienia na zas\xf3b",
        unlimited: "Nieograniczone uprawnienie na zas\xf3b",
        not_eligible: "Usuń swoje uprawnienia zasobu"
    },
    custom_domain_enabled: {
        name: "Niestandardowy domena",
        limited: "Niestandardowy domena",
        unlimited: "Niestandardowy domena",
        not_eligible: "Usuń swoją niestandardową domenę"
    },
    omni_sign_in_enabled: {
        name: "Omni logowanie",
        limited: "Omni logowanie",
        unlimited: "Omni logowanie",
        not_eligible: "Wyłącz swoje omni logowanie"
    },
    built_in_email_connector_enabled: {
        name: "Wbudowany konektor e-mail",
        limited: "Wbudowany konektor e-mail",
        unlimited: "Wbudowany konektor e-mail",
        not_eligible: "Usuń sw\xf3j wbudowany konektor e-mail"
    },
    social_connectors_limit: {
        name: "Konektory społecznościowe",
        limited: "{{count, number}} konektor społecznościowy",
        limited_other: "{{count, number}} konektory społecznościowe",
        unlimited: "Nieograniczone konektory społecznościowe",
        not_eligible: "Usuń swoje konektory społecznościowe"
    },
    standard_connectors_limit: {
        name: "Darmowe standardowe konektory",
        limited: "{{count, number}} darmowy standardowy konektor",
        limited_other: "{{count, number}} darmowe standardowe konektory",
        unlimited: "Nieograniczone standardowe konektory",
        not_eligible: "Usuń swoje standardowe konektory"
    },
    roles_limit: {
        name: "Role",
        limited: "{{count, number}} rola",
        limited_other: "{{count, number}} role",
        unlimited: "Nieograniczona liczba r\xf3l",
        not_eligible: "Usuń swoje role"
    },
    machine_to_machine_roles_limit: {
        name: "Machine to machine roles",
        limited: "{{count, number}} machine to machine role",
        limited_other: "{{count, number}} machine to machine roles",
        unlimited: "Nieograniczona liczba r\xf3l machine to machine",
        not_eligible: "Usuń swoje role machine to machine"
    },
    scopes_per_role_limit: {
        name: "Uprawnienia roli",
        limited: "{{count, number}} uprawnienie na rolę",
        limited_other: "{{count, number}} uprawnienia na rolę",
        unlimited: "Nieograniczone uprawnienia na rolę",
        not_eligible: "Usuń swoje uprawnienia roli"
    },
    hooks_limit: {
        name: "Webhooks",
        limited: "{{count, number}} webhook",
        limited_other: "{{count, number}} webhooki",
        unlimited: "Nieograniczona liczba webhook\xf3w",
        not_eligible: "Usuń swoje webhooki"
    },
    organizations_enabled: {
        name: "Organizations",
        limited: "Organizations",
        unlimited: "Organizations",
        not_eligible: "Remove your organizations"
    },
    audit_logs_retention_days: {
        name: "Przechowywanie dziennik\xf3w audytowych",
        limited: "Przechowywanie dziennik\xf3w audytowych: {{count, number}} dzień",
        limited_other: "Przechowywanie dziennik\xf3w audytowych: {{count, number}} dni",
        unlimited: "Nieograniczona liczba dni",
        not_eligible: "Brak dziennik\xf3w audytowych"
    },
    email_ticket_support: {
        name: "Wsparcie poprzez e-maile",
        limited: "{{count, number}} godzina wsparcia poprzez e-maile",
        limited_other: "{{count, number}} godziny wsparcia poprzez e-maile",
        unlimited: "Wsparcie poprzez e-maile",
        not_eligible: "Brak wsparcia poprzez e-maile"
    },
    mfa_enabled: {
        name: "Wielopoziomowe uwierzytelnianie",
        limited: "Wielopoziomowe uwierzytelnianie",
        unlimited: "Wielopoziomowe uwierzytelnianie",
        not_eligible: "Usuń swoje wielopoziomowe uwierzytelnianie"
    },
    sso_enabled: {
        name: "SSO przedsiębiorstwa",
        limited: "SSO przedsiębiorstwa",
        unlimited: "SSO przedsiębiorstwa",
        not_eligible: "Usuń swoje SSO przedsiębiorstwa"
    },
    tenant_members_limit: {
        name: "Członkowie najemcy",
        limited: "{{count, number}} członek najemcy",
        limited_other: "{{count, number}} członk\xf3w najemcy",
        unlimited: "Nieograniczona liczba członk\xf3w najemcy",
        not_eligible: "Usuń swoich członk\xf3w najemcy"
    },
    custom_jwt_enabled: {
        name: "Niestandardowy JWT",
        limited: "Niestandardowy JWT",
        unlimited: "Niestandardowy JWT",
        not_eligible: "Usuń swoje niestandardowe narzędzie tworzące JWT"
    }
};
var $711f63ae276d0245$export$2e2bcd8739ae039 = Object.freeze($711f63ae276d0245$var$quota_item);


const $3202f8300c4585fd$var$quota_table = {
    quota: {
        title: "Podstawy",
        base_price: "Cena podstawowa",
        mau_limit: "Limit MAU",
        included_tokens: "Zawarte tokeny"
    },
    application: {
        title: "Aplikacje",
        total: "Liczba aplikacji",
        m2m: "Aplikacja typu maszyna-maszyna",
        third_party: "Aplikacje firm trzecich"
    },
    resource: {
        title: "Zasoby API",
        resource_count: "Liczba zasob\xf3w",
        scopes_per_resource: "Uprawnienia na zas\xf3b"
    },
    branding: {
        title: "Interfejs użytkownika i branding",
        custom_domain: "Domena niestandardowa",
        custom_css: "Niestandardowy CSS",
        app_logo_and_favicon: "Logo aplikacji i ikona",
        dark_mode: "Tryb ciemny",
        i18n: "Internacjonalizacja"
    },
    user_authn: {
        title: "Uwierzytelnianie użytkownik\xf3w",
        omni_sign_in: "Omni logowanie",
        password: "Hasło",
        passwordless: "Logowanie bez hasła - E-mail i SMS",
        email_connector: "Podłączenie e-mail",
        sms_connector: "Podłączenie SMS",
        social_connectors: "Podłączenia społecznościowe",
        standard_connectors: "Standardowe podłączenia",
        built_in_email_connector: "Wbudowane podłączenie e-mail",
        mfa: "Wielopoziomowa autentykacja",
        sso: "SSO przedsiębiorstwowe",
        adaptive_mfa: "MFA adaptacyjne"
    },
    user_management: {
        title: "Zarządzanie użytkownikami",
        user_management: "Zarządzanie użytkownikami",
        roles: "Role",
        machine_to_machine_roles: "Role maszyna-maszyna",
        scopes_per_role: "Uprawnienia na rolę"
    },
    organizations: {
        title: "Organizacja",
        organizations: "Organizacje",
        organization: "Organizacja",
        organization_count: "Liczba organizacji",
        allowed_users_per_org: "Użytkownicy na organizację",
        invitation: "Zaproszenia (API zarządzania)",
        org_roles: "Role organizacji",
        org_permissions: "Uprawnienia organizacyjne",
        just_in_time_provisioning: "Provisioning w trybie just-in-time"
    },
    support: {
        title: "Zgodność i wsparcie",
        community: "Społeczność",
        customer_ticket: "Zgłoszenie wsparcia",
        premium: "Premium",
        email_ticket_support: "Wsparcie za pośrednictwem bilet\xf3w e-mail",
        soc2_report: "Raport SOC2",
        hipaa_or_baa_report: "Raport HIPAA/BAA"
    },
    developers_and_platform: {
        title: "Deweloperzy i platforma",
        hooks: "Webhooks",
        audit_logs_retention: "Retention log\xf3w audit",
        jwt_claims: "Pretensje JWT",
        tenant_members: "Członkowie najemcy"
    },
    unlimited: "Nieograniczone",
    contact: "Kontakt",
    monthly_price: "${{value, number}}/mies.",
    days_one: "{{count, number}} dzień",
    days_other: "{{count, number}} dni",
    add_on: "Dodatkowy",
    tier: "Poziom{{value, number}}: ",
    paid_token_limit_tip: "Logto doliczy opłaty za funkcje, kt\xf3re przekraczają Tw\xf3j limit kwoty. Możesz go używać bezpłatnie do momentu rozpoczęcia naliczania opłat około II kwartału 2024 roku. Jeśli potrzebujesz więcej token\xf3w, skontaktuj się z nami. Domyślnie naliczamy $80 miesięcznie za milion token\xf3w.",
    paid_quota_limit_tip: "Logto będzie naliczać opłaty za funkcje przekraczające limit kontyngentu. Możesz go używać bezpłatnie do czasu rozpoczęcia naliczania opłat, około II kwartał 2024 roku.",
    paid_add_on_feature_tip: "To jest funkcja dodatkowa. Możesz z niej korzystać bezpłatnie do czasu rozpoczęcia naliczania opłat, około II kwartał 2024 roku.",
    million: "{{value, number}} milion",
    mau_tip: "MAU (aktywni użytkownicy miesięczni) oznacza liczbę unikalnych użytkownik\xf3w, kt\xf3rzy wymienili co najmniej jeden token z Logto w cyklu rozliczeniowym.",
    tokens_tip: "Wszystkie rodzaje token\xf3w wydanych przez Logto, w tym tokeny dostępu, tokeny odświeżania, itp.",
    mao_tip: "MAO (aktywna organizacja miesięczna) oznacza liczbę unikalnych organizacji, kt\xf3re mają co najmniej jednego aktywnego użytkownika miesięcznie w cyklu rozliczeniowym.",
    third_party_tip: "Używaj Logto jako dostawcy tożsamości OIDC do logowania firm trzecich i udzielania zg\xf3d.",
    included: "{{value, number}} zawarte",
    included_mao: "{{value, number}} MAO wliczone",
    extra_quota_price: "Następnie ${{value, number}} za miesiąc / każdy po",
    per_month_each: "${{value, number}} za miesiąc / każdy",
    extra_mao_price: "Następnie ${{value, number}} za MAO",
    per_month: "${{value, number}} za miesiąc",
    per_member: "Następnie ${{value, number}} za członka"
};
var $3202f8300c4585fd$export$2e2bcd8739ae039 = Object.freeze($3202f8300c4585fd$var$quota_table);


const $bc3f2b2b2d2c9219$var$subscription = {
    free_plan: "Darmowy plan",
    free_plan_description: "Dla projekt\xf3w pobocznych i początkowych pr\xf3b Logto. Brak wymaganej karty kredytowej.",
    pro_plan: "Plan Pro",
    pro_plan_description: "Dla firm, ciesz się bezstresową obsługą Logto.",
    enterprise: "Przedsiębiorstwo",
    current_plan: "Obecny plan",
    current_plan_description: "Oto Tw\xf3j obecny plan. Łatwo możesz sprawdzić wykorzystanie swojego planu, sprawdzić nadchodzący rachunek i dokonać zmian w planie, jeśli jest to konieczne.",
    plan_usage: "Wykorzystanie planu",
    plan_cycle: "Cykl planu: {{period}}. Użycie odnawiane w dniu {{renewDate}}.",
    next_bill: "Twoje następne rozliczenie",
    next_bill_hint: "Aby dowiedzieć się więcej o obliczeniach, zapoznaj się z tym <a>artykułem</a>.",
    next_bill_tip: "Tutaj wyświetlane ceny nie obejmują podatk\xf3w. Kwota podatku będzie obliczana na podstawie dostarczonych przez Ciebie informacji oraz lokalnych wymagań regulacyjnych i będzie widoczna na Twoich fakturach.",
    manage_payment: "Zarządzanie płatnościami",
    overfill_quota_warning: "Osiągnąłeś limit swojej puli. Aby uniknąć problem\xf3w, zaktualizuj sw\xf3j plan.",
    upgrade_pro: "Uaktualnij do Pro",
    update_payment: "Zaktualizuj płatność",
    payment_error: "Wykryto problem z płatnością. Nie można przetworzyć ${{price, number}} za poprzedni cykl. Zaktualizuj płatność, aby uniknąć zawieszenia usługi Logto.",
    downgrade: "Zdegradować",
    current: "Obecnie",
    upgrade: "Aktualizacja",
    quota_table: $3202f8300c4585fd$export$2e2bcd8739ae039,
    billing_history: {
        invoice_column: "Faktury",
        status_column: "Status",
        amount_column: "Kwota",
        invoice_created_date_column: "Data utworzenia faktury",
        invoice_status: {
            void: "Anulowana",
            paid: "Opłacona",
            open: "Otwarta",
            uncollectible: "Zaległa"
        }
    },
    quota_item: $711f63ae276d0245$export$2e2bcd8739ae039,
    downgrade_modal: {
        title: "Czy na pewno chcesz zdegradować?",
        description: "Jeśli zdecydujesz się przełączyć na <targetName/>, pamiętaj, że nie będziesz już mieć dostępu do przyznanych wcześniej limit\xf3w i funkcji w <currentName/>. ",
        before: "Przed: <name/>",
        after: "Po: <name />",
        downgrade: "Zdegradować"
    },
    not_eligible_modal: {
        downgrade_title: "Nie spełniasz warunk\xf3w do zmniejszenia",
        downgrade_description: "Upewnij się, że spełniasz następujące kryteria przed zmniejszeniem do <name/>.",
        downgrade_help_tip: "Potrzebna pomoc przy zmniejszaniu? <a>Skontaktuj się z nami</a>.",
        upgrade_title: "Przyjazne przypomnienie dla naszych szanowanych wczesnych użytkownik\xf3w",
        upgrade_description: "Obecnie używasz więcej niż to, co pozwala <name />. Logto jest teraz oficjalne, z funkcjami dostosowanymi do każdego planu. Zanim rozważysz aktualizację do <name />, upewnij się, że spełniasz poniższe kryteria przed dokonaniem aktualizacji.",
        upgrade_pro_tip: " Lub rozważ aktualizację do Planu Pro.",
        upgrade_help_tip: "Potrzebna pomoc przy zwiększaniu? <a>Skontaktuj się z nami</a>.",
        a_maximum_of: "Maksymalnie <item/>"
    },
    upgrade_success: "Pomyślnie uaktualniono do <name/>",
    downgrade_success: "Pomyślnie zdegradowano do <name/>",
    subscription_check_timeout: "Czas sprawdzenia subskrypcji wygasł. Proszę odświeżyć p\xf3źniej.",
    no_subscription: "Brak subskrypcji"
};
var $bc3f2b2b2d2c9219$export$2e2bcd8739ae039 = Object.freeze($bc3f2b2b2d2c9219$var$subscription);


const $4bf2a50c267721d4$var$tab_sections = {
    overview: "Przegląd",
    authentication: "Uwierzytelnianie",
    authorization: "Autoryzacja",
    users: "Użytkownicy",
    developer: "Deweloper",
    tenant: "Najemca"
};
var $4bf2a50c267721d4$export$2e2bcd8739ae039 = Object.freeze($4bf2a50c267721d4$var$tab_sections);


const $22811f99cdd3a4e3$var$tabs = {
    get_started: "Rozpocznij",
    dashboard: "Panel",
    applications: "Aplikacje",
    api_resources: "Zasoby API",
    sign_in_experience: "Doświadczenie przy logowaniu",
    connectors: "Konnektory",
    enterprise_sso: "Enterprise SSO",
    webhooks: "Webhooki",
    organizations: "Organizacje",
    users: "Zarządzanie użytkownikami",
    audit_logs: "Dzienniki audytu",
    roles: "Role",
    docs: "Dokumentacja",
    tenant_settings: "Ustawienia",
    mfa: "Multi-factor auth",
    customize_jwt: "Niestandardowy JWT",
    signing_keys: "Klucze do podpisu",
    organization_template: "Szablon organizacji"
};
var $22811f99cdd3a4e3$export$2e2bcd8739ae039 = Object.freeze($22811f99cdd3a4e3$var$tabs);


const $36271a4ef826160a$var$tenant_members = {
    members: "Członkowie",
    invitations: "Zaproszenia",
    invite_members: "Zaproś członk\xf3w",
    user: "Użytkownik",
    roles: "Role",
    admin: "Administrator",
    collaborator: "Wsp\xf3łpracownik",
    invitation_status: "Status zaproszenia",
    inviter: "Zapraszający",
    expiration_date: "Data wygaśnięcia",
    invite_modal: {
        title: "Zaproś ludzi do Logto Cloud",
        subtitle: "Aby zaprosić członk\xf3w do organizacji, muszą zaakceptować zaproszenie.",
        to: "Do",
        added_as: "Dodany jako role",
        email_input_placeholder: "janekkowalski@przykład.com"
    },
    invitation_statuses: {
        pending: "Oczekujące",
        accepted: "Zaakceptowane",
        expired: "Wygasłe",
        revoked: "Anulowane"
    },
    invitation_empty_placeholder: {
        title: "Zaproś członk\xf3w zespołu",
        description: "Twoja dzierżawa obecnie nie ma zaproszonych członk\xf3w.\nAby pom\xf3c w integracji, rozważ dodanie więcej członk\xf3w lub administrator\xf3w."
    },
    menu_options: {
        edit: "Edytuj rolę dzierżawy",
        delete: "Usuń użytkownika z dzierżawy",
        resend_invite: "Ponownieś w zaproszenie",
        revoke: "Anuluj zaproszenie",
        delete_invitation_record: "Usuń ten rekord zaproszenia"
    },
    edit_modal: {
        title: "Zmień role dla {{name}}"
    },
    delete_user_confirm: "Czy na pewno chcesz usunąć tego użytkownika z tej dzierżawy?",
    assign_admin_confirm: "Czy na pewno chcesz uczynić wybranego użytkownika/\xf3w administratorem? Przyznanie uprawnień administratora spowoduje nadanie użytkownikowi/om następujących uprawnień.<ul><li>Zmiana planu rozliczeniowego dzierżawy</li><li>Dodawanie lub usuwanie wsp\xf3łpracownik\xf3w</li><li>Usunięcie dzierżawy</li></ul>",
    revoke_invitation_confirm: "Czy na pewno chcesz anulować to zaproszenie?",
    delete_invitation_confirm: "Czy na pewno chcesz usunąć ten rekord zaproszenia?",
    messages: {
        invitation_sent: "Zaproszenie wysłane.",
        invitation_revoked: "Zaproszenie anulowane.",
        invitation_resend: "Zaproszenie wysłane ponownie.",
        invitation_deleted: "Rekord zaproszenia usunięty."
    },
    errors: {
        email_required: "E-mail zapraszanego jest wymagany.",
        email_exists: "Adres e-mail już istnieje.",
        member_exists: "Ten użytkownik jest już członkiem tej organizacji.",
        pending_invitation_exists: "Istnieje oczekujące zaproszenie. Usuń powiązany adres e-mail lub anuluj zaproszenie.",
        invalid_email: "Adres e-mail jest nieprawidłowy. Upewnij się, że jest w odpowiednim formacie.",
        max_member_limit: "Osiągnąłeś limit maksymalnej liczby członk\xf3w ({{limit}}) dla tej dzierżawy."
    }
};
var $36271a4ef826160a$export$2e2bcd8739ae039 = Object.freeze($36271a4ef826160a$var$tenant_members);


const $f1766c97a710c713$var$tenants = {
    title: "Ustawienia",
    description: "Skuteczne zarządzanie ustawieniami najemcy i dostosowywanie domeny.",
    tabs: {
        settings: "Ustawienia",
        members: "Członkowie",
        domains: "Domeny",
        subscription: "Plan i rozliczenia",
        billing_history: "Historia rozliczeń"
    },
    settings: {
        title: "USTAWIENIA",
        description: "Ustaw nazwę najemcy i wyświetl informacje o regionie hostowania danych oraz typie najemcy.",
        tenant_id: "ID Najemcy",
        tenant_name: "Nazwa Najemcy",
        tenant_region: "Region hostowania danych",
        tenant_region_tip: "Twoje zasoby najemcy są hostowane w {{region}}. <a>Uzyskaj więcej informacji</a>",
        environment_tag_development: "Dev",
        environment_tag_production: "Prod",
        tenant_type: "Typ najemcy",
        development_description: "Wyłącznie do test\xf3w i nie powinien być używany w produkcji. Nie jest wymagana subskrypcja. Posiada wszystkie funkcje Pro, ale ma ograniczenia, takie jak baner logowania. <a>Uzyskaj więcej informacji</a>",
        production_description: "Przeznaczony dla aplikacji używanych przez użytkownik\xf3w końcowych i może wymagać płatnej subskrypcji. <a>Uzyskaj więcej informacji</a>",
        tenant_info_saved: "Informacje o najemcy zostały pomyślnie zapisane."
    },
    full_env_tag: {
        development: "Development",
        production: "Production"
    },
    deletion_card: {
        title: "USUWANIE",
        tenant_deletion: "Usuń najemcę",
        tenant_deletion_description: "Usunięcie najemcy spowoduje trwałe usunięcie wszystkich powiązanych danych użytkownik\xf3w i konfiguracji. Proszę postępować ostrożnie.",
        tenant_deletion_button: "Usuń najemcę"
    },
    leave_tenant_card: {
        title: "OPUŚĆ",
        leave_tenant: "Opuść najemcę",
        leave_tenant_description: "Any resources in the tenant will remain but you no longer have access to this tenant.",
        last_admin_note: "Aby opuścić tego najemcę, upewnij się, że co najmniej jeszcze jeden członek ma rolę Administrator."
    },
    create_modal: {
        title: "Utw\xf3rz nowego najemcę",
        tenant_usage_purpose: "Co chcesz zrobić z tym najemcą?",
        development_description: "Wyłącznie do test\xf3w i nie powinien być używany w produkcji. Nie jest wymagana subskrypcja.",
        development_hint: "Posiada wszystkie funkcje Pro, ale ma ograniczenia, takie jak baner logowania.",
        production_description: "Przeznaczony dla użytkownik\xf3w końcowych i może wymagać płatnej subskrypcji.",
        available_plan: "Dostępny plan:",
        create_button: "Utw\xf3rz najemcę",
        tenant_name_placeholder: "M\xf3j najemca"
    },
    dev_tenant_migration: {
        title: 'Teraz możesz przetestować nasze funkcje Pro, tworząc nowego "Najemcę w trybie deweloperskim"!',
        affect_title: "Jak to wpłynie na Ciebie?",
        hint_1: "Zastępujemy stare <strong>tagi środowiska</strong> dwoma nowymi typami najemc\xf3w: <strong>„Development”</strong> i <strong>„Production”</strong>.",
        hint_2: "Aby zapewnić płynne przejście i nieprzerwaną funkcjonalność, wszystkie wcześniej utworzone najemcy zostaną podniesione do typu najemcy <strong>Production</strong> wraz z Twoją poprzednią subskrypcją.",
        hint_3: "Nie martw się, wszystkie inne ustawienia pozostaną takie same.",
        about_tenant_type: "O typie najemcy"
    },
    delete_modal: {
        title: "Usuń najemcę",
        description_line1: 'Are you sure you want to delete your tenant "<span>{{name}}</span>" with environment suffix tag "<span>{{tag}}</span>"? This action cannot be undone, and will result in the permanent deletion of all your data and tenant information.',
        description_line2: "Before deleting tenant, maybe we can help you. <span><a>Contact us via Email</a></span>",
        description_line3: 'Jeśli chcesz kontynuować, wprowadź nazwę najemcy "<span>{{name}}</span>" w celu potwierdzenia.',
        delete_button: "Usuń na stałe",
        cannot_delete_title: "Nie można usunąć tego najemcy",
        cannot_delete_description: "Przepraszam, nie możesz teraz usunąć tego najemcy. Upewnij się, że korzystasz z planu darmowego i uregulowałeś wszystkie zaległe płatności."
    },
    leave_tenant_modal: {
        description: "Czy na pewno chcesz opuścić tego najemcę?",
        leave_button: "Opuść"
    },
    tenant_landing_page: {
        title: "Nie utworzyłeś jeszcze najemcy",
        description: "Aby rozpocząć konfigurowanie projektu z Logto, utw\xf3rz nowego najemcę. Jeśli musisz się wylogować lub usunąć swoje konto, wystarczy kliknąć przycisk awatara w prawym g\xf3rnym rogu.",
        create_tenant_button: "Utw\xf3rz najemcę"
    },
    status: {
        mau_exceeded: "Przekroczono limit MAU",
        suspended: "Zawieszony",
        overdue: "Op\xf3źnienie w płatnościach"
    },
    tenant_suspended_page: {
        title: "Konto najemcy zawieszone. Skontaktuj się z nami, aby przywr\xf3cić dostęp.",
        description_1: "Z głębokim żalem informujemy, że twoje konto najemcy zostało tymczasowo zawieszone z powodu nieprawidłowego korzystania, w tym przekroczenia limit\xf3w MAU, op\xf3źnionych płatności lub innych nieautoryzowanych działań.",
        description_2: "Jeśli potrzebujesz dalszych wyjaśnień, masz jakiekolwiek obawy lub chcesz przywr\xf3cić pełną funkcjonalność i odblokować swoje najemce, nie wahaj się skontaktować z nami natychmiast."
    }
};
var $f1766c97a710c713$export$2e2bcd8739ae039 = Object.freeze($f1766c97a710c713$var$tenants);


const $abb56ce080623c41$var$topbar = {
    docs: "Dokumentacja",
    help: "Pomoc"
};
var $abb56ce080623c41$export$2e2bcd8739ae039 = Object.freeze($abb56ce080623c41$var$topbar);


const $a7533251d6766f1f$var$featured_plan_content = {
    mau: {
        free_plan: "Do {{count, number}} MAU",
        pro_plan: "Nieograniczony MAU"
    },
    m2m: {
        free_plan: "{{count, number}} urządzenia do urządzenia",
        pro_plan: "Dodatkowe urządzenie do urządzenia"
    },
    third_party_apps: "IdP dla aplikacji innych firm",
    mfa: "Autoryzacja wieloskładnikowa",
    sso: "SSO dla przedsiębiorstw",
    role_and_permissions: {
        free_plan: "{{roleCount, number}} rola i {{permissionCount, number}} uprawnienie na rolę",
        pro_plan: "Nieograniczone role i uprawnienia na rolę"
    },
    organizations: "Organizacje",
    audit_logs: "Przechowywanie dziennik\xf3w audytu: {{count, number}} dni"
};
var $a7533251d6766f1f$export$2e2bcd8739ae039 = Object.freeze($a7533251d6766f1f$var$featured_plan_content);


const $1c8836ec680d4563$var$paywall = {
    applications: "Osiągnięto limit {{count, number}} aplikacji dla <planName/>. Zaktualizuj plan, aby sprostać potrzebom zespołu. W razie potrzeby pomocy, proszę <a>skontaktuj się z nami</a>.",
    applications_other: "Osiągnięto limit {{count, number}} aplikacji dla <planName/>. Zaktualizuj plan, aby sprostać potrzebom zespołu. W razie potrzeby pomocy, proszę <a>skontaktuj się z nami</a>.",
    machine_to_machine_feature: "Przełącz się na plan <strong>Pro</strong>, aby uzyskać dodatkowe aplikacje maszynowe i korzystać ze wszystkich funkcji premium. <a>Skontaktuj się z nami</a>, jeśli masz pytania.",
    machine_to_machine: "Osiągnięto limit {{count, number}} aplikacji maszynowych dla <planName/>. Zaktualizuj plan, aby sprostać potrzebom zespołu. W razie potrzeby pomocy, proszę <a>skontaktuj się z nami</a>.",
    machine_to_machine_other: "Osiągnięto limit {{count, number}} aplikacji maszynowych dla <planName/>. Zaktualizuj plan, aby sprostać potrzebom zespołu. W razie potrzeby pomocy, proszę <a>skontaktuj się z nami</a>.",
    resources: "Osiągnięto limit {{count, number}} zasob\xf3w API w planie <planName/>. Ulepsz plan, aby sprostać potrzebom twojego zespołu. Skontaktuj się z nami <a>tutaj</a>, jeśli potrzebujesz pomocy.",
    resources_other: "Osiągnięto limit {{count, number}} zasob\xf3w API w planie <planName/>. Ulepsz plan, aby sprostać potrzebom twojego zespołu. Skontaktuj się z nami <a>tutaj</a>, jeśli potrzebujesz pomocy.",
    scopes_per_resource: "Osiągnięto limit {{count, number}} uprawnień na zas\xf3b API w planie <planName/>. Zaktualizuj plan, aby rozszerzyć. Skontaktuj się z nami <a>tutaj</a>, jeśli potrzebujesz pomocy.",
    scopes_per_resource_other: "Osiągnięto limit {{count, number}} uprawnień na zas\xf3b API w planie <planName/>. Zaktualizuj plan, aby rozszerzyć. Skontaktuj się z nami <a>tutaj</a>, jeśli potrzebujesz pomocy.",
    custom_domain: "Odblokuj funkcję niestandardowej domeny, ulepszając do planu <strong>Hobby</strong> lub <strong>Pro</strong>. Nie wahaj się <a>skontaktować z nami</a>, jeśli potrzebujesz pomocy.",
    social_connectors: "Osiągnięto limit {{count, number}} konektor\xf3w społecznościowych w planie <planName/>. Aby sprostać potrzebom twojego zespołu, ulepsz plan, aby uzyskać dodatkowe konektory społecznościowe oraz możliwość tworzenia własnych konektor\xf3w za pomocą protokoł\xf3w OIDC, OAuth 2.0 i SAML. Jeśli potrzebujesz pomocy, nie wahaj się <a>skontaktować z nami</a>.",
    social_connectors_other: "Osiągnięto limit {{count, number}} konektor\xf3w społecznościowych w planie <planName/>. Aby sprostać potrzebom twojego zespołu, ulepsz plan, aby uzyskać dodatkowe konektory społecznościowe oraz możliwość tworzenia własnych konektor\xf3w za pomocą protokoł\xf3w OIDC, OAuth 2.0 i SAML. Jeśli potrzebujesz pomocy, nie wahaj się <a>skontaktować z nami</a>.",
    standard_connectors_feature: "Ulepsz do planu <strong>Hobby</strong> lub <strong>Pro</strong>, aby tworzyć własne konektory za pomocą protokoł\xf3w OIDC, OAuth 2.0 i SAML, plus nieograniczone konektory społecznościowe i wszystkie funkcje premium. Jeśli potrzebujesz pomocy, nie wahaj się <a>skontaktować z nami</a>.",
    standard_connectors: "Osiągnięto limit {{count, number}} konektor\xf3w społecznościowych w planie <planName/>. Aby sprostać potrzebom twojego zespołu, ulepsz plan, aby uzyskać dodatkowe konektory społecznościowe oraz możliwość tworzenia własnych konektor\xf3w za pomocą protokoł\xf3w OIDC, OAuth 2.0 i SAML. Jeśli potrzebujesz pomocy, nie wahaj się <a>skontaktować z nami</a>.",
    standard_connectors_other: "Osiągnięto limit {{count, number}} konektor\xf3w społecznościowych w planie <planName/>. Aby sprostać potrzebom twojego zespołu, ulepsz plan, aby uzyskać dodatkowe konektory społecznościowe oraz możliwość tworzenia własnych konektor\xf3w za pomocą protokoł\xf3w OIDC, OAuth 2.0 i SAML. Jeśli potrzebujesz pomocy, nie wahaj się <a>skontaktować z nami</a>.",
    standard_connectors_pro: "Osiągnięto limit {{count, number}} standardowych konektor\xf3w w planie <planName/>. Aby sprostać potrzebom twojego zespołu, ulepsz do planu Enterprise, aby uzyskać dodatkowe konektory społecznościowe oraz możliwość tworzenia własnych konektor\xf3w za pomocą protokoł\xf3w OIDC, OAuth 2.0 i SAML. Jeśli potrzebujesz pomocy, nie wahaj się <a>skontaktować z nami</a>.",
    standard_connectors_pro_other: "Osiągnięto limit {{count, number}} standardowych konektor\xf3w w planie <planName/>. Aby sprostać potrzebom twojego zespołu, ulepsz do planu Enterprise, aby uzyskać dodatkowe konektory społecznościowe oraz możliwość tworzenia własnych konektor\xf3w za pomocą protokoł\xf3w OIDC, OAuth 2.0 i SAML. Jeśli potrzebujesz pomocy, nie wahaj się <a>skontaktować z nami</a>.",
    roles: "Osiągnięto limit {{count, number}} r\xf3l w planie <planName/>. Ulepsz plan, aby dodać dodatkowe role i uprawnienia. Jeśli potrzebujesz pomocy, nie wahaj się <a>skontaktować z nami</a>.",
    roles_other: "Osiągnięto limit {{count, number}} r\xf3l w planie <planName/>. Ulepsz plan, aby dodać dodatkowe role i uprawnienia. Jeśli potrzebujesz pomocy, nie wahaj się <a>skontaktować z nami</a>.",
    machine_to_machine_roles: "{{count, number}} role maszynowa przekroczyła limit w planie <planName/>. Ulepsz plan, aby dodać dodatkowe role i uprawnienia. Skontaktuj się z nami <a>tutaj</a>, jeśli potrzebujesz pomocy.",
    machine_to_machine_roles_other: "{{count, number}} role maszynowa przekroczyły limit w planie <planName/>. Ulepsz plan, aby dodać dodatkowe role i uprawnienia. Skontaktuj się z nami <a>tutaj</a>, jeśli potrzebujesz pomocy.",
    scopes_per_role: "Osiągnięto limit {{count, number}} uprawnień na rolę w planie <planName/>. Ulepsz plan, aby dodać dodatkowe role i uprawnienia. W razie potrzeb, skontaktuj się z nami <a>tutaj</a>.",
    scopes_per_role_other: "Osiągnięto limit {{count, number}} uprawnień na rolę w planie <planName/>. Ulepsz plan, aby dodać dodatkowe role i uprawnienia. W razie potrzeb, skontaktuj się z nami <a>tutaj</a>.",
    hooks: "Osiągnięto limit {{count, number}} webhook\xf3w w planie <planName/>. Ulepsz plan, aby tworzyć więcej webhook\xf3w. Jeśli potrzebujesz pomocy, nie wahaj się <a>skontaktować z nami</a>.",
    hooks_other: "Osiągnięto limit {{count, number}} webhook\xf3w w planie <planName/>. Ulepsz plan, aby tworzyć więcej webhook\xf3w. Jeśli potrzebujesz pomocy, nie wahaj się <a>skontaktować z nami</a>.",
    mfa: "Odblokuj MFA, aby zweryfikować bezpieczeństwo, przechodząc na płatny plan. Nie wahaj się <a>skontaktować z nami</a>, jeśli potrzebujesz pomocy.",
    organizations: "Odblokuj organizacje, ulepszając do płatnego planu. Nie wahaj się <a>skontaktować z nami</a>, jeśli potrzebujesz pomocy.",
    third_party_apps: "Odblokuj Logto jako IdP dla aplikacji stron trzecich, ulepszając do płatnego planu. W razie potrzeby pomocy, proszę <a>skontaktuj się z nami</a>.",
    sso_connectors: "Odblokuj logowanie jednokrotne dla przedsiębiorstw, ulepszając do płatnego planu. W razie potrzeby pomocy, proszę <a>skontaktuj się z nami</a>.",
    tenant_members: "Odblokuj funkcję wsp\xf3łpracy, ulepszając do płatnego planu. W razie potrzeby pomocy, proszę <a>skontaktuj się z nami</a>.",
    tenant_members_dev_plan: "Osiągnąłeś limit {{limit}} członk\xf3w. Zwolnij członka lub anuluj oczekiwanie na zaproszenie, aby dodać nowego. Potrzebujesz więcej miejsc? Proszę skontaktować się z nami.",
    custom_jwt: {
        title: "Dodaj niestandardowe twierdzenia",
        description: "Ulepsz do płatnego planu, aby uzyskać funkcjonalność niestandardowego JWT i korzyści premium. Jeśli masz jakieś pytania, nie wahaj się <a>skontaktować z nami</a>."
    }
};
var $1c8836ec680d4563$export$2e2bcd8739ae039 = Object.freeze($1c8836ec680d4563$var$paywall);


const $467c2ddc7b38364e$var$upsell = {
    upgrade_plan: "Ulepsz plan",
    compare_plans: "Por\xf3wnaj plany",
    view_plans: "Zobacz plany",
    create_tenant: {
        title: "Wybierz sw\xf3j plan najemcy",
        description: "Logto oferuje konkurencyjne opcje plan\xf3w z innowacyjnym i przystępnym cenowo modelem dla rozwijających się firm. <a>Dowiedz się więcej</a>",
        base_price: "Cena podstawowa",
        monthly_price: "{{value, number}}/mies.",
        view_all_features: "Zobacz wszystkie funkcje",
        select_plan: "Wybierz <name/>",
        free_tenants_limit: "Do {{count, number}} bezpłatnego najemcy",
        free_tenants_limit_other: "Do {{count, number}} bezpłatnych najemc\xf3w",
        most_popular: "Najpopularniejszy",
        upgrade_success: "Pomyślnie ulepszono do <name/>"
    },
    mau_exceeded_modal: {
        title: "MAU przekroczyło limit. Ulepsz sw\xf3j plan.",
        notification: "Obecna liczba MAU przekroczyła limit planu <planName/>. Proszę natychmiast zaktualizować sw\xf3j plan na wersję premium, aby uniknąć zawieszenia usługi Logto.",
        update_plan: "Zaktualizuj plan"
    },
    payment_overdue_modal: {
        title: "Opłata za fakturę zaległa",
        notification: "Ups! Płatność za fakturę najemcy <span>{{name}}</span> nie powiodła się. Proszę zapłacić fakturę w odpowiednim terminie, aby uniknąć zawieszenia usługi Logto.",
        unpaid_bills: "Nieuregulowane faktury",
        update_payment: "Zaktualizuj płatność"
    },
    add_on_quota_item: {
        api_resource: "Zas\xf3b API",
        machine_to_machine: "aplikacja od maszyny do maszyny",
        tokens: "{{limit}}M token\xf3w",
        tenant_member: "członek najemcy"
    },
    charge_notification_for_quota_limit: "Przekroczyłeś limit kwoty {{item}}. Logto doliczy opłaty za korzystanie poza limitem. Fakturowanie rozpocznie się w dniu wprowadzenia nowego projektu cenowego dodatku. <a>Dowiedz się więcej</a>",
    paywall: $1c8836ec680d4563$export$2e2bcd8739ae039,
    featured_plan_content: $a7533251d6766f1f$export$2e2bcd8739ae039
};
var $467c2ddc7b38364e$export$2e2bcd8739ae039 = Object.freeze($467c2ddc7b38364e$var$upsell);


const $2262ab69a8086c95$var$user_details = {
    page_title: "Szczeg\xf3ły użytkownika",
    back_to_users: "Powr\xf3t do zarządzania użytkownikami",
    created_title: "Ten użytkownik został pomyślnie utworzony",
    created_guide: "Oto informacje, kt\xf3re pomogą użytkownikowi w procesie logowania.",
    created_email: "Adres email:",
    created_phone: "Numer telefonu:",
    created_username: "Nazwa użytkownika:",
    created_password: "Hasło:",
    menu_delete: "Usuń",
    delete_description: "Tej akcji nie można cofnąć. Usunie to użytkownika na stałe.",
    deleted: "Użytkownik został pomyślnie usunięty",
    reset_password: {
        reset_password: "Zresetuj hasło",
        title: "Czy na pewno chcesz zresetować hasło?",
        content: "Tej akcji nie można cofnąć. To zresetuje informacje o logowaniu użytkownika.",
        congratulations: "Ten użytkownik został zresetowany",
        new_password: "Nowe hasło:"
    },
    tab_settings: "Ustawienia",
    tab_roles: "Role",
    tab_logs: "Logi użytkownika",
    tab_organizations: "Organizacje",
    authentication: "Autoryzacja",
    authentication_description: "Każdy użytkownik ma profil zawierający wszystkie informacje o użytkowniku. Składa się on z podstawowych danych, tożsamości społecznościowych i niestandardowych danych.",
    user_profile: "Profil użytkownika",
    field_email: "Adres e-mail",
    field_phone: "Numer telefonu",
    field_username: "Nazwa użytkownika",
    field_name: "Imię i nazwisko",
    field_avatar: "Adres URL obrazka awatara",
    field_avatar_placeholder: "https://twoja.domena/cdn/avatar.png",
    field_custom_data: "Dane niestandardowe",
    field_custom_data_tip: "Dodatkowe informacje o użytkowniku niewymienione jako właściwości predefiniowane, takie jak preferowany przez użytkownika kolor i język.",
    field_connectors: "Połączenia społecznościowe",
    field_sso_connectors: "Połączenia przedsiębiorstwa",
    custom_data_invalid: "Nieprawidłowe dane niestandardowe JSON",
    connectors: {
        connectors: "Połączenia",
        user_id: "Identyfikator użytkownika",
        remove: "Usuń",
        connected: "Ten użytkownik jest połączony z wieloma społecznymi konektorami.",
        not_connected: "Użytkownik nie jest połączony z żadnym społecznym konektorem",
        deletion_confirmation: "Usuwasz istniejącą tożsamość <name/>. Czy na pewno chcesz kontynuować?"
    },
    sso_connectors: {
        connectors: "Konektory",
        enterprise_id: "ID przedsiębiorstwa",
        connected: "Ten użytkownik jest połączony z kilkoma dostawcami tożsamości przedsiębiorstwa do jednokrotnego uwierzytelniania.",
        not_connected: "Użytkownik nie jest połączony z żadnym dostawcą tożsamości przedsiębiorstwa do jednokrotnego uwierzytelniania."
    },
    mfa: {
        field_name: "Wieloetapowa autoryzacja",
        field_description: "Ten użytkownik włączył autoryzację dwuetapową.",
        name_column: "Wieloetapowa autoryzacja",
        field_description_empty: "Ten użytkownik nie włączył autoryzacji dwuetapowej.",
        deletion_confirmation: "Usuwasz istniejące <name/> w celu weryfikacji dwuetapowej. Czy na pewno chcesz kontynuować?"
    },
    suspended: "Zawieszony",
    suspend_user: "Zawieś użytkownika",
    suspend_user_reminder: "Czy na pewno chcesz zawiesić tego użytkownika? Użytkownik nie będzie m\xf3gł zalogować się do Twojej aplikacji i nie uzyska nowego tokena dostępu po wygaśnięciu obecnego. Ponadto jakiekolwiek żądania API złożone przez tego użytkownika będą nieudane.",
    suspend_action: "Zawieś",
    user_suspended: "Użytkownik został zawieszony.",
    reactivate_user: "Aktywuj użytkownika",
    reactivate_user_reminder: "Czy na pewno chcesz aktywować tego użytkownika? Umożliwi to wszystkie pr\xf3by logowania dla tego użytkownika.",
    reactivate_action: "Aktywuj",
    user_reactivated: "Użytkownik został aktywowany.",
    roles: {
        name_column: "Rola",
        description_column: "Opis",
        assign_button: "Przypisz rolę",
        delete_description: "Ta akcja usunie tę rolę z tego użytkownika. Rola nadal będzie istnieć, ale nie będzie już przypisana do tego użytkownika.",
        deleted: "{{name}} została usunięta z tego użytkownika.",
        assign_title: "Przypisz rolę dla {{name}}",
        assign_subtitle: "Przypisz {{name}} jedną lub wiele r\xf3l",
        assign_role_field: "Przypisz rolę",
        role_search_placeholder: "Szukaj po nazwie roli",
        added_text: "{{value, number}} dodanych",
        assigned_user_count: "{{value, number}} użytkownik\xf3w",
        confirm_assign: "Przypisz rolę",
        role_assigned: "Pomyślnie przypisano rolę(y)",
        search: "Szukaj po nazwie roli, opisie lub ID",
        empty: "Brak dostępnej roli"
    },
    warning_no_sign_in_identifier: "Aby się zalogować, użytkownik musi mieć co najmniej jeden identyfikator logowania (nazwa użytkownika, e-mail, numer telefonu lub konto społecznościowe). Czy na pewno chcesz kontynuować?",
    organization_roles_tooltip: "Role przypisane użytkownikowi w ramach tej organizacji."
};
var $2262ab69a8086c95$export$2e2bcd8739ae039 = Object.freeze($2262ab69a8086c95$var$user_details);


const $f57df583ecc33e32$var$users = {
    page_title: "Zarządzanie użytkownikami",
    title: "Zarządzanie użytkownikami",
    subtitle: "Zarządzaj tożsamościami użytkownik\xf3w, w tym tworzeniem użytkownik\xf3w, edycją informacji o użytkownikach, przeglądaniem dziennik\xf3w użytkownik\xf3w, resetowaniem hasła i usuwaniem użytkownik\xf3w.",
    create: "Dodaj użytkownika",
    create_subtitle: "Podaj co najmniej jedno z poniższych p\xf3l, aby kontynuować.",
    error_missing_identifier: "Aby utworzyć użytkownika, musisz podać co najmniej jeden identyfikator.",
    user_name: "Użytkownik",
    application_name: "Z aplikacji",
    latest_sign_in: "Najnowsze logowanie",
    create_form_username: "Nazwa użytkownika",
    create_form_password: "Hasło",
    create_form_name: "Imię i nazwisko",
    placeholder_name: "Jan Kowalski",
    placeholder_email: "jkowalski@example.com",
    placeholder_username: "user123",
    placeholder_phone: "+48 123 456 789",
    unnamed: "Bez nazwy",
    search: "Wyszukaj według nazwy, e-maila, numeru telefonu lub nazwy użytkownika",
    check_user_detail: "Sprawdź szczeg\xf3ły użytkownika",
    placeholder_title: "Zarządzanie użytkownikami",
    placeholder_description: "Każdy użytkownik ma profil zawierający wszystkie informacje o użytkowniku. Składa się z podstawowych danych, tożsamości społecznych i niestandardowych danych."
};
var $f57df583ecc33e32$export$2e2bcd8739ae039 = Object.freeze($f57df583ecc33e32$var$users);


const $6850a565a193dece$var$webhook_details = {
    page_title: "Szczeg\xf3ły webhooka",
    back_to_webhooks: "Wr\xf3ć do Webhooks",
    not_in_use: "Nieaktywne",
    success_rate: "Stosunek sukces\xf3w",
    requests: "{{value, number}} żądań w ciągu 24h",
    disable_webhook: "Wyłącz webhook",
    disable_reminder: "Czy na pewno chcesz przestać wyłączać ten webhook? Taki postęp nie będzie wysyłał żądania HTTP do adresu URL końcowego.",
    webhook_disabled: "Webhook został wyłączony.",
    webhook_reactivated: "Webhook został ponownie aktywowany.",
    reactivate_webhook: "Aktywuj ponownie webhooka",
    delete_webhook: "Usuń webhook",
    deletion_reminder: "Usuwasz ten webhook. Po jego usunięciu nie będzie wysyłany żaden żądanie HTTP do adresu URL końcowego.",
    deleted: "Webhook został pomyślnie usunięty.",
    settings_tab: "Ustawienia",
    recent_requests_tab: "Najnowsze żądania (24h)",
    settings: {
        settings: "Ustawienia",
        settings_description: "Webhootsy pozwalają na otrzymywanie aktualizacji w czasie rzeczywistym z określonych zdarzeń, wysyłając żądanie POST na Tw\xf3j adres URL końcowy. Dzięki temu możesz natychmiast podjąć działania na podstawie otrzymanych nowych informacji.",
        events: "Zdarzenia",
        events_description: "Wybierz zdarzenia wywołujące, kt\xf3re Logto wyśle żądanie POST.",
        name: "Nazwa",
        endpoint_url: "Adres URL końcowego",
        signing_key: "Klucz podpisu",
        signing_key_tip: "Dodaj klucz sekretny dostarczony przez Logto do swojego endpointu jako nagł\xf3wek żądania, aby zapewnić autentyczność ładunku webhooka.",
        regenerate: "Przebuduj",
        regenerate_key_title: "Wygeneruj ponownie klucz podpisu",
        regenerate_key_reminder: "Czy na pewno chcesz zmodyfikować klucz podpisu? Regenerowanie spowoduje natychmiastowe wprowadzenie zmian. Pamiętaj, aby synchronicznie zmienić klucz podpisu w swoim endpointcie.",
        regenerated: "Klucz podpisu został przebudowany.",
        custom_headers: "Niestandardowe nagł\xf3wki",
        custom_headers_tip: "Opcjonalnie możesz dodać niestandardowe nagł\xf3wki w ładunku webhooka, aby dostarczyć dodatkowy kontekst lub metadane na temat zdarzenia.",
        key_duplicated_error: "Klucze nie mogą się powtarzać.",
        key_missing_error: "Klucz jest wymagany.",
        value_missing_error: "Wartość jest wymagana.",
        invalid_key_error: "Klucz jest nieprawidłowy",
        invalid_value_error: "Wartość jest nieprawidłowa",
        test: "Test",
        test_webhook: "Wypr\xf3buj sw\xf3j webhook",
        test_webhook_description: "Skonfiguruj webhooka i przetestuj go przy użyciu przykład\xf3w ładunku dla każdego wybranego zdarzenia, aby sprawdzić poprawne odbieranie i przetwarzanie.",
        send_test_payload: "Wyślij testowy ładunek",
        test_result: {
            endpoint_url: "URL punktu końcowego: {{url}}",
            message: "Wiadomość: {{message}}",
            response_status: "Status odpowiedzi: {{status, number}}",
            response_body: "Treść odpowiedzi: {{body}}",
            request_time: "Czas żądania: {{time}}",
            test_success: "Test webhooka do punktu końcowego zakończył się powodzeniem."
        }
    }
};
var $6850a565a193dece$export$2e2bcd8739ae039 = Object.freeze($6850a565a193dece$var$webhook_details);


const $926ee1843970cfc3$var$webhooks = {
    page_title: "Wejścia",
    title: "Webhooki",
    subtitle: "Utw\xf3rz webhooki, aby bez wysiłku otrzymywać aktualizacje w czasie rzeczywistym dotyczące określonych zdarzeń.",
    create: "Utw\xf3rz webhook",
    schemas: {
        interaction: "Interakcja użytkownika",
        user: "Użytkownik",
        organization: "Organizacja",
        role: "Rola",
        scope: "Uprawnienie",
        organization_role: "Rola w organizacji",
        organization_scope: "Uprawnienie w organizacji"
    },
    table: {
        name: "Nazwa",
        events: "Zdarzenia",
        success_rate: "Wskaźnik sukcesu (24h)",
        requests: "Żądania (24h)"
    },
    placeholder: {
        title: "Webhook",
        description: 'Utw\xf3rz webhook, aby otrzymywać aktualizacje w czasie rzeczywistym za pomocą żądań POST na adres URL punktu końcowego. Bądź informowany i podejmuj natychmiastowe działania w przypadku zdarzeń takich jak "Utw\xf3rz konto", "Zaloguj się" i "Zresetuj hasło".',
        create_webhook: "Utw\xf3rz webhook"
    },
    create_form: {
        title: "Utw\xf3rz Webhook",
        subtitle: "Dodaj Webhook aby wysyłać żądania POST na endpoint URL z detalami o zdarzeniach użytkownik\xf3w.",
        events: "Zdarzenia",
        events_description: "Wybierz zdarzenia wyzwalające kt\xf3re Logto wykorzysta do wysłania żądania POST.",
        name: "Nazwa",
        name_placeholder: "Wprowadź nazwę webhooka",
        endpoint_url: "URL punktu końcowego",
        endpoint_url_placeholder: "https://twoj.webhook.endpoint.url",
        endpoint_url_tip: "Wprowadź adres URL punktu końcowego, do kt\xf3rego wysyłane będzie obciążenie webhooka, gdy wydarzenie ma miejsce.",
        create_webhook: "Utw\xf3rz webhook",
        missing_event_error: "Musisz wybrać przynajmniej jedno zdarzenie."
    },
    webhook_created: "Webhook {{name}} został pomyślnie utworzony."
};
var $926ee1843970cfc3$export$2e2bcd8739ae039 = Object.freeze($926ee1843970cfc3$var$webhooks);


const $f4d8d6c4aa5d2f1c$var$welcome = {
    title: "Witaj w konsoli administracyjnej",
    description: "Konsola administracyjna to aplikacja internetowa umożliwiająca zarządzanie Logto bez wymagania znajomości kodowania. Najpierw zał\xf3ż konto. Dzięki temu kontu możesz zarządzać Logto samodzielnie lub w imieniu swojej firmy.",
    create_account: "Zał\xf3ż konto"
};
var $f4d8d6c4aa5d2f1c$export$2e2bcd8739ae039 = Object.freeze($f4d8d6c4aa5d2f1c$var$welcome);


const $b42714649623b94f$var$admin_console = {
    title: "관리자 콘솔",
    admin_user: "관리자",
    system_app: "시스템",
    menu: $b8d68fcc47556038$export$2e2bcd8739ae039,
    general: $6a7dd7cf7aa9a02c$export$2e2bcd8739ae039,
    errors: $8f1d0e92e54d25a2$export$2e2bcd8739ae039,
    tab_sections: $4bf2a50c267721d4$export$2e2bcd8739ae039,
    tabs: $22811f99cdd3a4e3$export$2e2bcd8739ae039,
    applications: $4298a44acb80bbe5$export$2e2bcd8739ae039,
    application_details: $b56333da034cd769$export$2e2bcd8739ae039,
    api_resources: $1b943d35be7236c0$export$2e2bcd8739ae039,
    api_resource_details: $65ab7d08e1ba50a8$export$2e2bcd8739ae039,
    connectors: $b25eeec043c77ec4$export$2e2bcd8739ae039,
    connector_details: $392f292d5a43ceac$export$2e2bcd8739ae039,
    enterprise_sso: $59c7d1daeacf3e1e$export$2e2bcd8739ae039,
    enterprise_sso_details: $4855454da986656d$export$2e2bcd8739ae039,
    get_started: $6edfd18b56e8a603$export$2e2bcd8739ae039,
    users: $f57df583ecc33e32$export$2e2bcd8739ae039,
    user_details: $2262ab69a8086c95$export$2e2bcd8739ae039,
    contact: $88d45429660685b0$export$2e2bcd8739ae039,
    sign_in_exp: $7d53ae443eafbfaf$export$2e2bcd8739ae039,
    dashboard: $6df00a3eebaa20be$export$2e2bcd8739ae039,
    logs: $cfa36bdd1dc289f6$export$2e2bcd8739ae039,
    log_details: $f87898fc77f59136$export$2e2bcd8739ae039,
    session_expired: $5d02266997a13771$export$2e2bcd8739ae039,
    welcome: $f4d8d6c4aa5d2f1c$export$2e2bcd8739ae039,
    roles: $c3eebc6de985f043$export$2e2bcd8739ae039,
    role_details: $7e83dc7daa2a4008$export$2e2bcd8739ae039,
    permissions: $a7cad30ae766db5d$export$2e2bcd8739ae039,
    cloud: $47e15bedc191623a$export$2e2bcd8739ae039,
    profile: $dcd805ed03305ef6$export$2e2bcd8739ae039,
    components: $d18d33a638f9b5f9$export$2e2bcd8739ae039,
    webhooks: $926ee1843970cfc3$export$2e2bcd8739ae039,
    webhook_details: $6850a565a193dece$export$2e2bcd8739ae039,
    domain: $b584132712ebb622$export$2e2bcd8739ae039,
    tenants: $f1766c97a710c713$export$2e2bcd8739ae039,
    tenant_members: $36271a4ef826160a$export$2e2bcd8739ae039,
    topbar: $abb56ce080623c41$export$2e2bcd8739ae039,
    subscription: $bc3f2b2b2d2c9219$export$2e2bcd8739ae039,
    upsell: $467c2ddc7b38364e$export$2e2bcd8739ae039,
    guide: $0e3bce49b0c6e520$export$2e2bcd8739ae039,
    mfa: $4ce337c2d440cc95$export$2e2bcd8739ae039,
    organizations: $7f7a36c0888fb76f$export$2e2bcd8739ae039,
    organization_details: $51e63832d04722bc$export$2e2bcd8739ae039,
    protected_app: $3161b081879d39fd$export$2e2bcd8739ae039,
    jwt_claims: $faa859f68848f324$export$2e2bcd8739ae039,
    invitation: $e8457923b8ba4963$export$2e2bcd8739ae039,
    signing_keys: $ff9bd0fe7a92f31f$export$2e2bcd8739ae039,
    organization_template: $e438f89f7fe68702$export$2e2bcd8739ae039,
    organization_role_details: $f50b4028500e1df6$export$2e2bcd8739ae039
};
var $b42714649623b94f$export$2e2bcd8739ae039 = Object.freeze($b42714649623b94f$var$admin_console);


const $814e2e0dcfac6490$var$demo_app = {
    title: "Pomyślnie zalogowałeś się do podglądu na żywo!",
    subtitle: "Oto twoje informacje logowania:",
    username: "Nazwa użytkownika: ",
    user_id: "ID użytkownika: ",
    sign_out: "Wyloguj się z podglądu na żywo",
    continue_explore: "Lub kontynuuj przeglądanie",
    customize_sign_in_experience: "Dostosuj wrażenia z logowania",
    enable_passwordless: "Włącz logowanie bez hasła",
    add_social_connector: "Dodaj złącze społecznościowe"
};
var $814e2e0dcfac6490$export$2e2bcd8739ae039 = Object.freeze($814e2e0dcfac6490$var$demo_app);


const $a98e0e36e55e405b$var$oidc = {
    logout_success: "Pomyślnie zostałeś wylogowany."
};
var $a98e0e36e55e405b$export$2e2bcd8739ae039 = Object.freeze($a98e0e36e55e405b$var$oidc);


const $e5ca7cc9d22e2e73$var$translation = {
    admin_console: $b42714649623b94f$export$2e2bcd8739ae039,
    demo_app: $814e2e0dcfac6490$export$2e2bcd8739ae039,
    oidc: $a98e0e36e55e405b$export$2e2bcd8739ae039
};
var $e5ca7cc9d22e2e73$export$2e2bcd8739ae039 = Object.freeze($e5ca7cc9d22e2e73$var$translation);


const $7e791e71534d736a$var$pl_pl = {
    translation: $e5ca7cc9d22e2e73$export$2e2bcd8739ae039,
    errors: $71c0b6375fb312d0$export$2e2bcd8739ae039
};
var $7e791e71534d736a$export$2e2bcd8739ae039 = Object.freeze($7e791e71534d736a$var$pl_pl);


const $db586a7be87b94ae$var$application = {
    invalid_type: "Apenas aplica\xe7\xf5es de m\xe1quina para m\xe1quina podem ter fun\xe7\xf5es associadas.",
    role_exists: "O id da fun\xe7\xe3o {{roleId}} j\xe1 foi adicionado a este aplicativo.",
    invalid_role_type: "N\xe3o \xe9 poss\xedvel atribuir uma fun\xe7\xe3o de tipo de usu\xe1rio a um aplicativo de m\xe1quina para m\xe1quina.",
    invalid_third_party_application_type: "Apenas aplicativos da web tradicionais podem ser marcados como um aplicativo de terceiros.",
    third_party_application_only: "O recurso est\xe1 dispon\xedvel apenas para aplicativos de terceiros.",
    user_consent_scopes_not_found: "Escopos de consentimento do usu\xe1rio inv\xe1lidos.",
    consent_management_api_scopes_not_allowed: "Os escopos da API de gerenciamento n\xe3o s\xe3o permitidos.",
    protected_app_metadata_is_required: "Protegido metadados do app \xe9 necess\xe1rio.",
    protected_app_not_configured: "Provedor de app protegido n\xe3o est\xe1 configurado. Este recurso n\xe3o est\xe1 dispon\xedvel na vers\xe3o de c\xf3digo aberto.",
    cloudflare_unknown_error: "Erro desconhecido ao solicitar a API do Cloudflare",
    protected_application_only: "O recurso est\xe1 dispon\xedvel apenas para aplicativos protegidos.",
    protected_application_misconfigured: "O aplicativo protegido est\xe1 mal configurado.",
    protected_application_subdomain_exists: "O subdom\xednio do aplicativo protegido j\xe1 est\xe1 em uso.",
    invalid_subdomain: "Subdom\xednio inv\xe1lido.",
    custom_domain_not_found: "Dom\xednio personalizado n\xe3o encontrado.",
    should_delete_custom_domains_first: "Deve excluir os dom\xednios personalizados primeiro."
};
var $db586a7be87b94ae$export$2e2bcd8739ae039 = Object.freeze($db586a7be87b94ae$var$application);


const $d6c2605468ee554e$var$auth = {
    authorization_header_missing: "O cabe\xe7alho de autoriza\xe7\xe3o est\xe1 ausente.",
    authorization_token_type_not_supported: "O tipo de autoriza\xe7\xe3o n\xe3o \xe9 suportado.",
    unauthorized: "N\xe3o autorizado. Verifique as credenciais e seu escopo.",
    forbidden: "Proibido. Verifique suas fun\xe7\xf5es e permiss\xf5es de usu\xe1rio.",
    expected_role_not_found: "Regra esperada n\xe3o encontrada. Verifique suas regras e permiss\xf5es de usu\xe1rio.",
    jwt_sub_missing: "`sub` ausente no JWT.",
    require_re_authentication: "A reautentica\xe7\xe3o \xe9 necess\xe1ria para executar uma a\xe7\xe3o protegida."
};
var $d6c2605468ee554e$export$2e2bcd8739ae039 = Object.freeze($d6c2605468ee554e$var$auth);


const $3043915aa129ea44$var$connector = {
    general: "Ocorreu um erro no conector: {{errorDescription}}",
    not_found: "N\xe3o foi poss\xedvel encontrar nenhum conector dispon\xedvel para o tipo: {{type}}.",
    not_enabled: "O conector n\xe3o est\xe1 ativado.",
    invalid_metadata: "Os metadados do conector s\xe3o inv\xe1lidos.",
    invalid_config_guard: "A prote\xe7\xe3o de configura\xe7\xe3o do conector \xe9 inv\xe1lida.",
    unexpected_type: "O tipo do conector \xe9 inesperado.",
    invalid_request_parameters: "A solicita\xe7\xe3o est\xe1 com par\xe2metro(s) de entrada incorreto(s).",
    insufficient_request_parameters: "A solicita\xe7\xe3o pode perder alguns par\xe2metros de entrada.",
    invalid_config: "A configura\xe7\xe3o do conector \xe9 inv\xe1lida.",
    invalid_certificate: "O certificado do conector \xe9 inv\xe1lido, certifique-se de que o certificado est\xe1 codificado em PEM.",
    invalid_response: "A resposta do conector \xe9 inv\xe1lida.",
    template_not_found: "N\xe3o foi poss\xedvel encontrar o modelo correto na configura\xe7\xe3o do conector.",
    template_not_supported: "O conector n\xe3o suporta esse tipo de modelo.",
    rate_limit_exceeded: "Limite de taxa de acionamento. Tente novamente mais tarde.",
    not_implemented: "{{method}}: ainda n\xe3o foi implementado.",
    social_invalid_access_token: "O token de acesso do conector \xe9 inv\xe1lido.",
    invalid_auth_code: "O c\xf3digo de autentica\xe7\xe3o do conector \xe9 inv\xe1lido.",
    social_invalid_id_token: "O token de id do conector \xe9 inv\xe1lido.",
    authorization_failed: "O processo de autoriza\xe7\xe3o do usu\xe1rio n\xe3o foi bem-sucedido.",
    social_auth_code_invalid: "N\xe3o foi poss\xedvel obter o token de acesso, verifique o c\xf3digo de autoriza\xe7\xe3o.",
    more_than_one_sms: "O n\xfamero de conectores SMS \xe9 maior que 1.",
    more_than_one_email: "O n\xfamero de conectores de e-mail \xe9 maior que 1.",
    more_than_one_connector_factory: "Foram encontradas v\xe1rias f\xe1bricas de conectores (com os ids {{connectorIds}}), voc\xea pode desinstalar as desnecess\xe1rias.",
    db_connector_type_mismatch: "Existe um conector no banco de dados que n\xe3o corresponde ao tipo.",
    not_found_with_connector_id: "N\xe3o \xe9 poss\xedvel encontrar o conector com o ID de conector padr\xe3o fornecido.",
    multiple_instances_not_supported: "N\xe3o \xe9 poss\xedvel criar v\xe1rias inst\xe2ncias com conector padr\xe3o escolhido.",
    invalid_type_for_syncing_profile: "Voc\xea s\xf3 pode sincronizar o perfil do usu\xe1rio com conectores sociais.",
    can_not_modify_target: "O destino do conector n\xe3o pode ser modificado.",
    should_specify_target: "Voc\xea deve especificar o 'destino'.",
    multiple_target_with_same_platform: "Voc\xea n\xe3o pode ter v\xe1rios conectores sociais com o mesmo destino e plataforma.",
    cannot_overwrite_metadata_for_non_standard_connector: "Esta 'metadata' do conector n\xe3o pode ser sobrescrita."
};
var $3043915aa129ea44$export$2e2bcd8739ae039 = Object.freeze($3043915aa129ea44$var$connector);


const $1a8a3682c9ab8aed$var$domain = {
    not_configured: "O provedor de nome de dom\xednio do host n\xe3o est\xe1 configurado.",
    cloudflare_data_missing: "cloudflare_data est\xe1 faltando, por favor verifique.",
    cloudflare_unknown_error: "Recebido erro desconhecido ao solicitar API do Cloudflare",
    cloudflare_response_error: "Recebido resposta inesperada do Cloudflare.",
    limit_to_one_domain: "Voc\xea s\xf3 pode ter um dom\xednio personalizado.",
    hostname_already_exists: "Este dom\xednio j\xe1 existe em nosso servidor.",
    cloudflare_not_found: "N\xe3o \xe9 poss\xedvel encontrar o nome do host no Cloudflare",
    domain_is_not_allowed: "Este dom\xednio n\xe3o \xe9 permitido."
};
var $1a8a3682c9ab8aed$export$2e2bcd8739ae039 = Object.freeze($1a8a3682c9ab8aed$var$domain);


const $bbf109314fbf9608$var$entity = {
    invalid_input: "Entrada inv\xe1lida. A lista de valores n\xe3o deve estar vazia.",
    create_failed: "Falha ao criar {{name}}.",
    db_constraint_violated: "Viola\xe7\xe3o de restri\xe7\xe3o do banco de dados.",
    not_exists: "O {{name}} n\xe3o existe.",
    not_exists_with_id: "O {{name}} com ID `{{id}}` n\xe3o existe.",
    not_found: "O recurso n\xe3o existe.",
    relation_foreign_key_not_found: "N\xe3o \xe9 poss\xedvel encontrar uma ou mais chaves estrangeiras. Por favor, verifique a entrada e garanta que todas as entidades referenciadas existam.",
    unique_integrity_violation: "A entidade j\xe1 existe. Por favor, verifique a entrada e tente novamente."
};
var $bbf109314fbf9608$export$2e2bcd8739ae039 = Object.freeze($bbf109314fbf9608$var$entity);


const $154e036361f8515b$var$guard = {
    invalid_input: "A solicita\xe7\xe3o {{type}} \xe9 inv\xe1lida.",
    invalid_pagination: "O valor de pagina\xe7\xe3o da solicita\xe7\xe3o \xe9 inv\xe1lido.",
    can_not_get_tenant_id: "N\xe3o foi poss\xedvel obter o ID do inquilino na solicita\xe7\xe3o.",
    file_size_exceeded: "Tamanho do arquivo excedido.",
    mime_type_not_allowed: "Tipo MIME n\xe3o permitido."
};
var $154e036361f8515b$export$2e2bcd8739ae039 = Object.freeze($154e036361f8515b$var$guard);


const $62e626d263811076$var$hook = {
    missing_events: "Voc\xea precisa fornecer pelo menos um evento.",
    send_test_payload_failed: "Falha ao enviar uma carga de teste: {{message}}",
    endpoint_responded_with_error: "O ponto de extremidade respondeu com erro."
};
var $62e626d263811076$export$2e2bcd8739ae039 = Object.freeze($62e626d263811076$var$hook);


const $a1a1397f2c8897a6$var$jwt_customizer = {
    general: "Ocorreu um erro ao personalizar o token JWT. Por favor, tente novamente mais tarde.",
    can_not_create_for_admin_tenant: "N\xe3o \xe9 poss\xedvel criar um personalizador de token JWT para o inquilino admin."
};
var $a1a1397f2c8897a6$export$2e2bcd8739ae039 = Object.freeze($a1a1397f2c8897a6$var$jwt_customizer);


const $4222bb2d8062b8e7$var$localization = {
    cannot_delete_default_language: "{{languageTag}} est\xe1 definido como seu idioma padr\xe3o e n\xe3o pode ser exclu\xeddo.",
    invalid_translation_structure: "Esquemas de dados inv\xe1lidos. Verifique sua entrada e tente novamente."
};
var $4222bb2d8062b8e7$export$2e2bcd8739ae039 = Object.freeze($4222bb2d8062b8e7$var$localization);


const $24e7e3fdd40fab12$var$log = {
    invalid_type: "O tipo de registro \xe9 inv\xe1lido."
};
var $24e7e3fdd40fab12$export$2e2bcd8739ae039 = Object.freeze($24e7e3fdd40fab12$var$log);


const $ccdb70daedb4deec$var$oidc = {
    aborted: "A intera\xe7\xe3o foi abortada pelo usu\xe1rio final",
    invalid_scope: "Escopo inv\xe1lido: {{error_description}}.",
    invalid_token: "Token inv\xe1lido.",
    invalid_client_metadata: "Metadados do cliente inv\xe1lidos.",
    insufficient_scope: "Token sem escopo `{{scope}}`.",
    invalid_request: "A solicita\xe7\xe3o \xe9 inv\xe1lida.",
    invalid_grant: "A concess\xe3o \xe9 inv\xe1lida.",
    invalid_redirect_uri: "`redirect_uri` n\xe3o corresponde a nenhum `redirect_uris` registrado do cliente.",
    access_denied: "Acesso negado.",
    invalid_target: "Indicador de recurso inv\xe1lido.",
    unsupported_grant_type: "`grant_type` n\xe3o suportado.",
    unsupported_response_mode: "`response_mode` n\xe3o suportado.",
    unsupported_response_type: "`response_type` n\xe3o suportado.",
    provider_error: "Erro interno OIDC: {{message}}.",
    server_error: "Ocorreu um erro OIDC desconhecido. Por favor, tente novamente mais tarde.",
    provider_error_fallback: "Ocorreu um erro OIDC: {{code}}.",
    key_required: "Pelo menos uma chave \xe9 necess\xe1ria.",
    key_not_found: "Chave com ID {{id}} n\xe3o encontrada."
};
var $ccdb70daedb4deec$export$2e2bcd8739ae039 = Object.freeze($ccdb70daedb4deec$var$oidc);


const $d5aca72dd011aff8$var$organization = {
    require_membership: "O usu\xe1rio deve ser um membro da organiza\xe7\xe3o para continuar."
};
var $d5aca72dd011aff8$export$2e2bcd8739ae039 = Object.freeze($d5aca72dd011aff8$var$organization);


const $aeb725e9daa9e0f7$var$password = {
    unsupported_encryption_method: "O m\xe9todo de criptografia {{name}} n\xe3o \xe9 suportado.",
    pepper_not_found: "Password pepper n\xe3o encontrada. Por favor, verifique seus envs principais.",
    rejected: "Senha rejeitada. Por favor, verifique se sua senha atende aos requisitos."
};
var $aeb725e9daa9e0f7$export$2e2bcd8739ae039 = Object.freeze($aeb725e9daa9e0f7$var$password);


const $a6fe0aacb22ddd3b$var$request = {
    invalid_input: "Entrada inv\xe1lida. {{details}}",
    general: "Ocorreu um erro no pedido."
};
var $a6fe0aacb22ddd3b$export$2e2bcd8739ae039 = Object.freeze($a6fe0aacb22ddd3b$var$request);


const $b34075831a639c93$var$resource = {
    resource_identifier_in_use: "O identificador de API {{indicator}} j\xe1 est\xe1 em uso",
    cannot_delete_management_api: "N\xe3o \xe9 poss\xedvel excluir a API de gerenciamento da Logto.",
    cannot_modify_management_api: "N\xe3o \xe9 poss\xedvel modificar a API de gerenciamento da Logto."
};
var $b34075831a639c93$export$2e2bcd8739ae039 = Object.freeze($b34075831a639c93$var$resource);


const $bd88726b00f02266$var$role = {
    name_in_use: "Este nome de papel {{name}} j\xe1 est\xe1 em uso",
    scope_exists: "O id de escopo {{scopeId}} j\xe1 foi adicionado a este papel",
    management_api_scopes_not_assignable_to_user_role: "N\xe3o \xe9 poss\xedvel atribuir escopos da API de gerenciamento a uma fun\xe7\xe3o de usu\xe1rio.",
    user_exists: "O id de usu\xe1rio {{userId}} j\xe1 foi adicionado a este papel",
    application_exists: "O id do aplicativo {{applicationId}} j\xe1 foi adicionado a este papel",
    default_role_missing: "Alguns dos nomes de fun\xe7\xe3o padr\xe3o n\xe3o existem no banco de dados, certifique-se de criar fun\xe7\xf5es primeiro",
    internal_role_violation: 'Voc\xea pode estar tentando atualizar ou excluir uma fun\xe7\xe3o interna que \xe9 proibida pelo Logto. Se voc\xea estiver criando uma nova fun\xe7\xe3o, tente outro nome que n\xe3o comece com "#internal:".'
};
var $bd88726b00f02266$export$2e2bcd8739ae039 = Object.freeze($bd88726b00f02266$var$role);


const $68e4a635067ded84$var$scope = {
    name_exists: "O nome do escopo {{name}} j\xe1 est\xe1 em uso",
    name_with_space: "O nome do escopo n\xe3o pode conter espa\xe7os."
};
var $68e4a635067ded84$export$2e2bcd8739ae039 = Object.freeze($68e4a635067ded84$var$scope);


const $8dc0787af5603207$var$session = {
    not_found: "Sess\xe3o n\xe3o encontrada. Volte e fa\xe7a login novamente.",
    invalid_credentials: "Credenciais inv\xe1lidas. Verifique sua entrada.",
    invalid_sign_in_method: "O m\xe9todo de login atual n\xe3o est\xe1 dispon\xedvel.",
    invalid_connector_id: "N\xe3o foi poss\xedvel encontrar o conector dispon\xedvel com id {{connectorId}}.",
    insufficient_info: "Informa\xe7\xf5es de login insuficientes.",
    connector_id_mismatch: "O connectorId \xe9 incompat\xedvel com o registro da sess\xe3o.",
    connector_session_not_found: "Sess\xe3o do conector n\xe3o encontrada. Volte e fa\xe7a login novamente.",
    verification_session_not_found: "A verifica\xe7\xe3o n\xe3o foi bem-sucedida. Reinicie o fluxo de verifica\xe7\xe3o e tente novamente.",
    verification_expired: "A conex\xe3o expirou. Verifique novamente para garantir a seguran\xe7a da sua conta.",
    verification_blocked_too_many_attempts: "Muitas tentativas em um curto per\xedodo de tempo. Por favor, tente novamente {{relativeTime}}.",
    unauthorized: "Fa\xe7a login primeiro.",
    unsupported_prompt_name: "Nome do prompt incompat\xedvel.",
    forgot_password_not_enabled: "Esqueceu a senha n\xe3o est\xe1 ativado.",
    verification_failed: "A verifica\xe7\xe3o n\xe3o foi bem-sucedida. Reinicie o fluxo de verifica\xe7\xe3o e tente novamente.",
    connector_validation_session_not_found: "A sess\xe3o de valida\xe7\xe3o do token do conector n\xe3o foi encontrada.",
    identifier_not_found: "Identificador de usu\xe1rio n\xe3o encontrado. Por favor, volte e fa\xe7a o login novamente.",
    interaction_not_found: "Sess\xe3o de intera\xe7\xe3o n\xe3o encontrada. Por favor, volte e inicie a sess\xe3o novamente.",
    not_supported_for_forgot_password: "Esta opera\xe7\xe3o n\xe3o \xe9 suportada para recupera\xe7\xe3o de senha.",
    mfa: {
        require_mfa_verification: "Verifica\xe7\xe3o MFA \xe9 necess\xe1ria para fazer login.",
        mfa_sign_in_only: "MFA est\xe1 dispon\xedvel apenas para intera\xe7\xe3o de login.",
        pending_info_not_found: "Informa\xe7\xf5es MFA pendentes n\xe3o encontradas, por favor inicie MFA primeiro.",
        invalid_totp_code: "C\xf3digo TOTP inv\xe1lido.",
        webauthn_verification_failed: "Falha na verifica\xe7\xe3o do WebAuthn.",
        webauthn_verification_not_found: "Verifica\xe7\xe3o WebAuthn n\xe3o encontrada.",
        bind_mfa_existed: "MFA j\xe1 existe.",
        backup_code_can_not_be_alone: "O c\xf3digo de backup n\xe3o pode ser o \xfanico MFA.",
        backup_code_required: "O c\xf3digo de backup \xe9 obrigat\xf3rio.",
        invalid_backup_code: "C\xf3digo de backup inv\xe1lido.",
        mfa_policy_not_user_controlled: "A pol\xedtica de MFA n\xe3o \xe9 controlada pelo usu\xe1rio."
    },
    sso_enabled: "O login \xfanico est\xe1 habilitado para este e-mail fornecido. Fa\xe7a login com SSO, por favor."
};
var $8dc0787af5603207$export$2e2bcd8739ae039 = Object.freeze($8dc0787af5603207$var$session);


const $8b302d8fb54e6d14$var$sign_in_experiences = {
    empty_content_url_of_terms_of_use: 'URL de conte\xfado "Termos de uso" vazia. Adicione o URL do conte\xfado se "Termos de uso" estiver ativado.',
    empty_social_connectors: "Conectores sociais vazios. Adicione conectores sociais ativados quando o m\xe9todo de login social estiver ativado.",
    enabled_connector_not_found: "Conector {{type}} ativado n\xe3o encontrado.",
    not_one_and_only_one_primary_sign_in_method: "Deve haver um m\xe9todo de login principal. Verifique sua entrada.",
    username_requires_password: "Deve permitir definir uma senha para o identificador de inscri\xe7\xe3o do nome de usu\xe1rio.",
    passwordless_requires_verify: "Deve ativar a verifica\xe7\xe3o do identificador de inscri\xe7\xe3o de e-mail/telefone.",
    miss_sign_up_identifier_in_sign_in: "Os m\xe9todos de login devem conter o identificador de inscri\xe7\xe3o.",
    password_sign_in_must_be_enabled: "O login com senha deve ser ativado quando definir uma senha \xe9 necess\xe1ria na inscri\xe7\xe3o.",
    code_sign_in_must_be_enabled: "O login do c\xf3digo de verifica\xe7\xe3o deve ser ativado quando definir uma senha n\xe3o \xe9 necess\xe1ria na inscri\xe7\xe3o.",
    unsupported_default_language: "Este idioma - {{language}} n\xe3o \xe9 suportado no momento.",
    at_least_one_authentication_factor: "Voc\xea deve selecionar pelo menos um fator de autentica\xe7\xe3o.",
    backup_code_cannot_be_enabled_alone: "C\xf3digo de backup n\xe3o pode ser ativado sozinho.",
    duplicated_mfa_factors: "Fatores MFA duplicados."
};
var $8b302d8fb54e6d14$export$2e2bcd8739ae039 = Object.freeze($8b302d8fb54e6d14$var$sign_in_experiences);


const $965a95c624a41324$var$single_sign_on = {
    forbidden_domains: "Dom\xednios de e-mail p\xfablico n\xe3o s\xe3o permitidos.",
    duplicated_domains: "Existem dom\xednios duplicados.",
    invalid_domain_format: "Formato de dom\xednio inv\xe1lido.",
    duplicate_connector_name: "O nome do conector j\xe1 existe. Por favor, escolha um nome diferente."
};
var $965a95c624a41324$export$2e2bcd8739ae039 = Object.freeze($965a95c624a41324$var$single_sign_on);


const $a73dee7a19a5925c$var$storage = {
    not_configured: "O provedor de armazenamento n\xe3o est\xe1 configurado.",
    missing_parameter: "Par\xe2metro {{parameter}} ausente para o provedor de armazenamento.",
    upload_error: "Falha ao fazer upload do arquivo para o provedor de armazenamento."
};
var $a73dee7a19a5925c$export$2e2bcd8739ae039 = Object.freeze($a73dee7a19a5925c$var$storage);


const $9a9b824992f913e3$var$subscription = {
    limit_exceeded: "Voc\xea atingiu o limite do seu plano de assinatura.",
    get_plan_failed: "N\xe3o foi poss\xedvel obter o plano de assinatura para o inquilino.",
    tenant_suspended: "O inquilino est\xe1 suspenso. Por favor, entre em contato com o administrador."
};
var $9a9b824992f913e3$export$2e2bcd8739ae039 = Object.freeze($9a9b824992f913e3$var$subscription);


const $ccbae3ba62cbc23a$var$swagger = {
    invalid_zod_type: "Zod type inv\xe1lido. Verifique a configura\xe7\xe3o do protetor de rota.",
    not_supported_zod_type_for_params: "Zod type n\xe3o suportado para os par\xe2metros. Verifique a configura\xe7\xe3o do protetor de rota."
};
var $ccbae3ba62cbc23a$export$2e2bcd8739ae039 = Object.freeze($ccbae3ba62cbc23a$var$swagger);


const $67504b95e9f9bffd$var$user = {
    username_already_in_use: "Este nome de usu\xe1rio j\xe1 est\xe1 em uso.",
    email_already_in_use: "Este e-mail est\xe1 associado a uma conta existente.",
    phone_already_in_use: "Este n\xfamero de telefone est\xe1 associado a uma conta existente.",
    invalid_email: "Endere\xe7o de e-mail inv\xe1lido.",
    invalid_phone: "N\xfamero de telefone inv\xe1lido.",
    email_not_exist: "O endere\xe7o de e-mail ainda n\xe3o foi registrado.",
    phone_not_exist: "O n\xfamero de telefone ainda n\xe3o foi registrado.",
    identity_not_exist: "A conta social ainda n\xe3o foi registrada.",
    identity_already_in_use: "A conta social foi associada a uma conta existente.",
    social_account_exists_in_profile: "A conta social j\xe1 est\xe1 associada ao seu perfil.",
    cannot_delete_self: "Voc\xea n\xe3o pode excluir a si mesmo.",
    sign_up_method_not_enabled: "Este m\xe9todo de inscri\xe7\xe3o n\xe3o est\xe1 ativado",
    sign_in_method_not_enabled: "Este m\xe9todo de login n\xe3o est\xe1 habilitado.",
    same_password: "A nova senha n\xe3o pode ser igual \xe0 senha antiga.",
    password_required_in_profile: "Voc\xea precisa definir uma senha antes de entrar.",
    new_password_required_in_profile: "Voc\xea precisa definir uma nova senha.",
    password_exists_in_profile: "A senha j\xe1 existe em seu perfil.",
    username_required_in_profile: "Voc\xea precisa definir um nome de usu\xe1rio antes de entrar.",
    username_exists_in_profile: "O nome de usu\xe1rio j\xe1 existe em seu perfil.",
    email_required_in_profile: "Voc\xea precisa adicionar um endere\xe7o de e-mail antes de fazer login.",
    email_exists_in_profile: "Seu perfil j\xe1 foi associado a um endere\xe7o de e-mail.",
    phone_required_in_profile: "Voc\xea precisa adicionar um n\xfamero de telefone antes de fazer login.",
    phone_exists_in_profile: "Seu perfil j\xe1 foi associado a um n\xfamero de telefone.",
    email_or_phone_required_in_profile: "Voc\xea precisa adicionar um endere\xe7o de e-mail ou n\xfamero de telefone antes de fazer login.",
    suspended: "Esta conta est\xe1 suspensa.",
    user_not_exist: "O usu\xe1rio com {{ identifier }} n\xe3o existe",
    missing_profile: "Voc\xea precisa fornecer informa\xe7\xf5es adicionais antes de fazer login.",
    role_exists: "O id da fun\xe7\xe3o {{roleId}} j\xe1 foi adicionado a este usu\xe1rio",
    invalid_role_type: "Tipo de fun\xe7\xe3o inv\xe1lido, n\xe3o \xe9 poss\xedvel atribuir uma fun\xe7\xe3o m\xe1quina a usu\xe1rio.",
    missing_mfa: "Voc\xea precisa vincular MFA adicional antes de fazer login.",
    totp_already_in_use: "TOTP j\xe1 est\xe1 em uso.",
    backup_code_already_in_use: "O c\xf3digo de backup j\xe1 est\xe1 em uso.",
    password_algorithm_required: "Algoritmo de senha \xe9 necess\xe1rio.",
    password_and_digest: "Voc\xea n\xe3o pode definir tanto senha de texto simples quanto digest de senha."
};
var $67504b95e9f9bffd$export$2e2bcd8739ae039 = Object.freeze($67504b95e9f9bffd$var$user);


const $3c954e3a7852c62b$var$verification_code = {
    phone_email_empty: "Tanto o telefone quanto o e-mail est\xe3o vazios.",
    not_found: "C\xf3digo de verifica\xe7\xe3o n\xe3o encontrado. Por favor, envie um c\xf3digo de verifica\xe7\xe3o primeiro.",
    phone_mismatch: "Telefone n\xe3o corresponde. Por favor, solicite um novo c\xf3digo de verifica\xe7\xe3o.",
    email_mismatch: "E-mail n\xe3o corresponde. Por favor, solicite um novo c\xf3digo de verifica\xe7\xe3o.",
    code_mismatch: "C\xf3digo de verifica\xe7\xe3o inv\xe1lido.",
    expired: "O c\xf3digo de verifica\xe7\xe3o expirou. Por favor, solicite um novo c\xf3digo de verifica\xe7\xe3o.",
    exceed_max_try: "Excedido o limite de tentativas de c\xf3digo de verifica\xe7\xe3o. Por favor, solicite um novo c\xf3digo de verifica\xe7\xe3o."
};
var $3c954e3a7852c62b$export$2e2bcd8739ae039 = Object.freeze($3c954e3a7852c62b$var$verification_code);


const $70def3d24916b1e6$var$errors = {
    request: $a6fe0aacb22ddd3b$export$2e2bcd8739ae039,
    auth: $d6c2605468ee554e$export$2e2bcd8739ae039,
    guard: $154e036361f8515b$export$2e2bcd8739ae039,
    oidc: $ccdb70daedb4deec$export$2e2bcd8739ae039,
    user: $67504b95e9f9bffd$export$2e2bcd8739ae039,
    password: $aeb725e9daa9e0f7$export$2e2bcd8739ae039,
    session: $8dc0787af5603207$export$2e2bcd8739ae039,
    connector: $3043915aa129ea44$export$2e2bcd8739ae039,
    verification_code: $3c954e3a7852c62b$export$2e2bcd8739ae039,
    sign_in_experiences: $8b302d8fb54e6d14$export$2e2bcd8739ae039,
    jwt_customizer: $a1a1397f2c8897a6$export$2e2bcd8739ae039,
    localization: $4222bb2d8062b8e7$export$2e2bcd8739ae039,
    swagger: $ccbae3ba62cbc23a$export$2e2bcd8739ae039,
    entity: $bbf109314fbf9608$export$2e2bcd8739ae039,
    log: $24e7e3fdd40fab12$export$2e2bcd8739ae039,
    role: $bd88726b00f02266$export$2e2bcd8739ae039,
    scope: $68e4a635067ded84$export$2e2bcd8739ae039,
    storage: $a73dee7a19a5925c$export$2e2bcd8739ae039,
    resource: $b34075831a639c93$export$2e2bcd8739ae039,
    hook: $62e626d263811076$export$2e2bcd8739ae039,
    domain: $1a8a3682c9ab8aed$export$2e2bcd8739ae039,
    subscription: $9a9b824992f913e3$export$2e2bcd8739ae039,
    application: $db586a7be87b94ae$export$2e2bcd8739ae039,
    organization: $d5aca72dd011aff8$export$2e2bcd8739ae039,
    single_sign_on: $965a95c624a41324$export$2e2bcd8739ae039
};
var $70def3d24916b1e6$export$2e2bcd8739ae039 = Object.freeze($70def3d24916b1e6$var$errors);


const $3f6fa30a95077bd9$var$api_resource_details = {
    page_title: "Detalhes do Recurso da API",
    back_to_api_resources: "Voltar para os recursos da API",
    general_tab: "Geral",
    permissions_tab: "Permiss\xf5es",
    settings: "Configura\xe7\xf5es",
    settings_description: "Os recursos da API, tamb\xe9m conhecidos como Indicadores de recursos, indicam os servi\xe7os ou recursos de destino a serem solicitados, geralmente uma vari\xe1vel de formato de URI que representa a identidade do recurso.",
    management_api_settings_description: "A API de Gerenciamento do Logto \xe9 uma cole\xe7\xe3o abrangente de APIs que capacitam os administradores a gerenciar uma ampla gama de tarefas relacionadas \xe0 identidade, aplicar pol\xedticas de seguran\xe7a e cumprir regulamentos e padr\xf5es.",
    management_api_notice: "Esta API representa a entidade Logto e n\xe3o pode ser modificada ou exclu\xedda. Crie um aplicativo de m\xe1quina para m\xe1quina para chamar a API de gerenciamento do Logto. <a>Saiba mais</a>",
    token_expiration_time_in_seconds: "Tempo de expira\xe7\xe3o do token (em segundos)",
    token_expiration_time_in_seconds_placeholder: "Digite o tempo de expira\xe7\xe3o do seu token",
    delete_description: "Essa a\xe7\xe3o n\xe3o pode ser desfeita. Isso excluir\xe1 permanentemente o recurso da API. Insira o nome do recurso da API <span>{{name}}</span> para confirmar.",
    enter_your_api_resource_name: "Digite o nome do recurso da API",
    api_resource_deleted: "O recurso da API {{name}} foi exclu\xeddo com sucesso",
    permission: {
        create_button: "Criar Permiss\xe3o",
        create_title: "Criar permiss\xe3o",
        create_subtitle: "Define as permiss\xf5es (escopos) necess\xe1rias para esta API.",
        confirm_create: "Criar permiss\xe3o",
        edit_title: "Editar permiss\xe3o de API",
        edit_subtitle: "Define as permiss\xf5es (escopos) necess\xe1rias pela API {{resourceName}}.",
        name: "Nome da permiss\xe3o",
        name_placeholder: "ler:recurso",
        forbidden_space_in_name: "O nome da permiss\xe3o n\xe3o deve conter espa\xe7os.",
        description: "Descri\xe7\xe3o",
        description_placeholder: "Capaz de ler os recursos",
        permission_created: "A permiss\xe3o {{name}} foi criada com sucesso",
        delete_description: "Se essa permiss\xe3o for exclu\xedda, o usu\xe1rio que tinha essa permiss\xe3o perder\xe1 o acesso concedido por ela.",
        deleted: 'A permiss\xe3o "{{name}}" foi exclu\xedda com sucesso.'
    }
};
var $3f6fa30a95077bd9$export$2e2bcd8739ae039 = Object.freeze($3f6fa30a95077bd9$var$api_resource_details);


const $e01c41c79c8628d6$var$api_resources = {
    page_title: "Recursos da API",
    title: "Recursos da API",
    subtitle: "Defina APIs que voc\xea pode consumir de seus aplicativos autorizados",
    create: "Criar recurso de API",
    api_name: "Nome da API",
    api_name_placeholder: "Digite o nome da sua API",
    api_identifier: "Identificador da API",
    api_identifier_placeholder: "https://seu-identificador-de-api/",
    api_identifier_tip: "O identificador exclusivo para o recurso da API. Deve ser um URI absoluto e n\xe3o ter nenhum componente de fragmento (#). Igual ao <a>par\xe2metro de recurso</a> em OAuth 2.0.",
    default_api: "API padr\xe3o",
    default_api_label: "Apenas uma API padr\xe3o pode ser definida por locat\xe1rio. Quando uma API padr\xe3o \xe9 definida, o par\xe2metro de recurso pode ser omitido na solicita\xe7\xe3o de autentica\xe7\xe3o. As trocas de token subsequentes usar\xe3o essa API como audi\xeancia por padr\xe3o, resultando na emiss\xe3o de JWTs. <a>Saiba mais</a>",
    api_resource_created: "O recurso da API {{name}} foi criado com sucesso",
    invalid_resource_indicator_format: "O indicador da API deve ser um URI absoluto v\xe1lido."
};
var $e01c41c79c8628d6$export$2e2bcd8739ae039 = Object.freeze($e01c41c79c8628d6$var$api_resources);


const $f89e6b8a93a11cc7$var$application_details = {
    page_title: "Detalhes da aplica\xe7\xe3o",
    back_to_applications: "Voltar para Aplicativos",
    check_guide: "Visualizar o guia",
    settings: "Configura\xe7\xf5es",
    settings_description: 'Uma "Aplica\xe7\xe3o" \xe9 um software ou servi\xe7o registrado que pode acessar informa\xe7\xf5es do usu\xe1rio ou atuar em nome de um usu\xe1rio. As aplica\xe7\xf5es ajudam a reconhecer quem est\xe1 solicitando o qu\xea do Logto e lidam com o login e permiss\xe3o. Preencha os campos necess\xe1rios para a autentica\xe7\xe3o.',
    integration: "Integra\xe7\xe3o",
    integration_description: "Implemente com trabalhadores seguros do Logto, alimentados pela rede de borda da Cloudflare para desempenho de primeira linha e inicializa\xe7\xf5es instant\xe2neas de 0ms em todo o mundo.",
    service_configuration: "Configura\xe7\xe3o de servi\xe7o",
    service_configuration_description: "Conclua as configura\xe7\xf5es necess\xe1rias em seu servi\xe7o.",
    session: "Sess\xe3o",
    endpoints_and_credentials: "Endpoints e Credenciais",
    endpoints_and_credentials_description: "Use os seguintes endpoints e credenciais para configurar a conex\xe3o OIDC em sua aplica\xe7\xe3o.",
    refresh_token_settings: "Token de atualiza\xe7\xe3o",
    refresh_token_settings_description: "Gerencie as regras do token de atualiza\xe7\xe3o para esta aplica\xe7\xe3o.",
    application_roles: "Fun\xe7\xf5es do aplicativo",
    machine_logs: "Logs da m\xe1quina",
    application_name: "Nome do aplicativo",
    application_name_placeholder: "Meu aplicativo",
    description: "Descri\xe7\xe3o",
    description_placeholder: "Digite a descri\xe7\xe3o do seu aplicativo",
    config_endpoint: "Endpoint de configura\xe7\xe3o do OpenID Provider",
    authorization_endpoint: "Endpoint de autoriza\xe7\xe3o",
    authorization_endpoint_tip: "O endpoint para execu\xe7\xe3o de autentica\xe7\xe3o e autoriza\xe7\xe3o. \xc9 usado para <a>autentica\xe7\xe3o</a> OpenID Connect.",
    show_endpoint_details: "Mostrar detalhes do endpoint",
    hide_endpoint_details: "Ocultar detalhes do endpoint",
    logto_endpoint: "Endpoint do Logto",
    application_id: "ID da aplica\xe7\xe3o",
    application_id_tip: "O identificador exclusivo da aplica\xe7\xe3o normalmente gerado pelo Logto. Tamb\xe9m conhecido como “<a>client_id</a>” no OpenID Connect.",
    application_secret: "Segredo da aplica\xe7\xe3o",
    redirect_uri: "URI de redirecionamento",
    redirect_uris: "URIs de redirecionamento",
    redirect_uri_placeholder: "https://seusite.com.br/app",
    redirect_uri_placeholder_native: "io.logto://retorno",
    redirect_uri_tip: "O URI para o redirecionamento ap\xf3s o login do usu\xe1rio (seja bem-sucedido ou n\xe3o). Consulte <a>AuthRequest</a> OpenID Connect para mais informa\xe7\xf5es.",
    post_sign_out_redirect_uri: "URI de redirecionamento ap\xf3s sa\xedda",
    post_sign_out_redirect_uris: "URIs de redirecionamento ap\xf3s sa\xedda",
    post_sign_out_redirect_uri_placeholder: "https://seusite.com.br/home",
    post_sign_out_redirect_uri_tip: "O URI para redirecionamento ap\xf3s o usu\xe1rio sair (opcional). Pode n\xe3o ter efeito pr\xe1tico em alguns tipos de aplicativos.",
    cors_allowed_origins: "Origens permitidas pelo CORS",
    cors_allowed_origins_placeholder: "https://seusite.com.br",
    cors_allowed_origins_tip: "Por padr\xe3o, todas as origens dos URIs de redirecionamento ser\xe3o permitidas. Normalmente, nenhuma a\xe7\xe3o \xe9 necess\xe1ria para este campo. Confira a <a>documenta\xe7\xe3o MDN</a> para informa\xe7\xf5es detalhadas.",
    token_endpoint: "Token Endpoint",
    user_info_endpoint: "Userinfo Endpoint",
    enable_admin_access: "Ativar acesso de administrador",
    enable_admin_access_label: "Ative ou desative o acesso \xe0 API de gerenciamento. Uma vez ativado, voc\xea pode usar tokens de acesso para chamar a API de gerenciamento em nome deste aplicativo.",
    always_issue_refresh_token: "Emitir sempre o token de atualiza\xe7\xe3o",
    always_issue_refresh_token_label: 'Ativar esta configura\xe7\xe3o permitir\xe1 que o Logto emita sempre tokens de atualiza\xe7\xe3o, independentemente de "prompt=consent" ser apresentado na solicita\xe7\xe3o de autentica\xe7\xe3o. No entanto, essa pr\xe1tica \xe9 desencorajada, a menos que seja necess\xe1ria, pois n\xe3o \xe9 compat\xedvel com o OpenID Connect e pode potencialmente causar problemas.',
    refresh_token_ttl: "Tempo de vida do token de atualiza\xe7\xe3o em dias",
    refresh_token_ttl_tip: "A dura\xe7\xe3o para a qual um token de atualiza\xe7\xe3o pode ser usado para solicitar novos tokens de acesso antes de expirar e se tornar inv\xe1lido. As solicita\xe7\xf5es de token estender\xe3o o TTL do token de atualiza\xe7\xe3o para este valor.",
    rotate_refresh_token: "Rotacionar token de atualiza\xe7\xe3o",
    rotate_refresh_token_label: "Quando ativado, o Logto emitir\xe1 um novo token de atualiza\xe7\xe3o para solicita\xe7\xf5es de token quando 70% do tempo de vida original (TTL) tiver passado ou certas condi\xe7\xf5es forem atendidas. <a>Saiba mais</a>",
    delete_description: "Esta a\xe7\xe3o n\xe3o pode ser desfeita. Isso excluir\xe1 permanentemente o aplicativo. Insira o nome do aplicativo <span>{{name}}</span> para confirmar.",
    enter_your_application_name: "Digite o nome do seu aplicativo",
    application_deleted: "O aplicativo {{name}} foi exclu\xeddo com sucesso",
    redirect_uri_required: "Voc\xea deve inserir pelo menos um URI de redirecionamento",
    app_domain_description_1: "Sinta-se \xe0 vontade para usar seu dom\xednio com {{domain}} alimentado pelo Logto, que \xe9 permanentemente v\xe1lido.",
    app_domain_description_2: "Sinta-se \xe0 vontade para utilizar seu dom\xednio <domain>{{domain}}</domain> que \xe9 permanentemente v\xe1lido.",
    custom_rules: "Regras de autentica\xe7\xe3o personalizadas",
    custom_rules_placeholder: "^/(admin|privacy)/.+$",
    custom_rules_description: "Defina regras com express\xf5es regulares para rotas que requerem autentica\xe7\xe3o. Padr\xe3o: prote\xe7\xe3o de todo o site se deixado em branco.",
    authentication_routes: "Rotas de autentica\xe7\xe3o",
    custom_rules_tip: "Aqui est\xe3o dois cen\xe1rios de exemplo:<ol><li>Para proteger apenas as rotas '/admin' e '/privacy' com autentica\xe7\xe3o: ^/(admin|privacy)/.*</li><li>Para excluir imagens JPG da autentica\xe7\xe3o: ^(?!.*\\.jpg$).*$</li></ol>",
    authentication_routes_description: "Redirecione seu bot\xe3o de autentica\xe7\xe3o usando as rotas especificadas. Observa\xe7\xe3o: Essas rotas s\xe3o irsubstitu\xedveis.",
    protect_origin_server: "Proteger seu servidor de origem",
    protect_origin_server_description: "Garanta proteger seu servidor de origem contra acesso direto. Consulte o guia para mais <a>instru\xe7\xf5es detalhadas</a>.",
    session_duration: "Dura\xe7\xe3o da sess\xe3o (dias)",
    try_it: "Tente",
    branding: {
        name: "Branding",
        description: "Personalize o nome e logotipo da exibi\xe7\xe3o de sua aplica\xe7\xe3o na tela de consentimento.",
        more_info: "Mais informa\xe7\xf5es",
        more_info_description: "Ofere\xe7a aos usu\xe1rios mais detalhes sobre sua aplica\xe7\xe3o na tela de consentimento.",
        display_name: "Nome de exibi\xe7\xe3o",
        display_logo: "Logotipo de exibi\xe7\xe3o",
        display_logo_dark: "Logotipo de exibi\xe7\xe3o (escuro)",
        terms_of_use_url: "URL dos termos de uso da aplica\xe7\xe3o",
        privacy_policy_url: "URL da pol\xedtica de privacidade da aplica\xe7\xe3o"
    },
    permissions: {
        name: "Permiss\xf5es",
        description: "Selecione as permiss\xf5es que o aplicativo de terceiros requer para autoriza\xe7\xe3o do usu\xe1rio para acessar tipos espec\xedficos de dados.",
        user_permissions: "Dados pessoais do usu\xe1rio",
        organization_permissions: "Acesso \xe0 organiza\xe7\xe3o",
        table_name: "Conceder permiss\xf5es",
        field_name: "Permiss\xe3o",
        field_description: "Exibido na tela de consentimento",
        delete_text: "Remover permiss\xe3o",
        permission_delete_confirm: "Esta a\xe7\xe3o retirar\xe1 as permiss\xf5es concedidas ao aplicativo de terceiros, impedindo-o de solicitar autoriza\xe7\xe3o do usu\xe1rio para tipos espec\xedficos de dados. Tem certeza de que deseja continuar?",
        permissions_assignment_description: "Selecione as permiss\xf5es solicitadas pelo aplicativo de terceiros para autoriza\xe7\xe3o do usu\xe1rio para acessar tipos espec\xedficos de dados.",
        user_profile: "Dados do usu\xe1rio",
        api_permissions: "Permiss\xf5es de API",
        organization: "Permiss\xf5es da organiza\xe7\xe3o",
        user_permissions_assignment_form_title: "Adicionar as permiss\xf5es do perfil do usu\xe1rio",
        organization_permissions_assignment_form_title: "Adicionar as permiss\xf5es da organiza\xe7\xe3o",
        api_resource_permissions_assignment_form_title: "Adicionar as permiss\xf5es de recursos da API",
        user_data_permission_description_tips: 'Voc\xea pode modificar a descri\xe7\xe3o das permiss\xf5es de dados pessoais do usu\xe1rio via "Experi\xeancia de Login > Conte\xfado > Gerenciar Idioma"',
        permission_description_tips: "Quando o Logto \xe9 usado como Provedor de Identidade (IdP) para autentica\xe7\xe3o em aplicativos de terceiros, e os usu\xe1rios s\xe3o solicitados para autoriza\xe7\xe3o, esta descri\xe7\xe3o aparece na tela de consentimento.",
        user_title: "Usu\xe1rio",
        user_description: "Selecione as permiss\xf5es solicitadas pelo aplicativo de terceiros para acessar tipos espec\xedficos de dados do usu\xe1rio.",
        grant_user_level_permissions: "Conceder permiss\xf5es de dados de usu\xe1rio",
        organization_title: "Organiza\xe7\xe3o",
        organization_description: "Selecione as permiss\xf5es solicitadas pelo aplicativo de terceiros para acessar tipos espec\xedficos de dados da organiza\xe7\xe3o.",
        grant_organization_level_permissions: "Conceder permiss\xf5es de dados da organiza\xe7\xe3o"
    },
    roles: {
        name_column: "Fun\xe7\xe3o",
        description_column: "Descri\xe7\xe3o",
        assign_button: "Atribuir fun\xe7\xf5es",
        delete_description: "Esta a\xe7\xe3o remover\xe1 esta fun\xe7\xe3o deste aplicativo m\xe1quina-a-m\xe1quina. A fun\xe7\xe3o ainda existir\xe1, mas n\xe3o ser\xe1 mais associada a este aplicativo m\xe1quina-a-m\xe1quina.",
        deleted: "{{name}} foi removido com sucesso deste usu\xe1rio.",
        assign_title: "Atribuir fun\xe7\xf5es a {{name}}",
        assign_subtitle: "Autorizar {{name}} uma ou mais fun\xe7\xf5es",
        assign_role_field: "Atribuir fun\xe7\xf5es",
        role_search_placeholder: "Pesquisar pelo nome da fun\xe7\xe3o",
        added_text: "{{value, number}} adicionados",
        assigned_app_count: "{{value, number}} aplicativos",
        confirm_assign: "Atribuir fun\xe7\xf5es",
        role_assigned: "Fun\xe7\xe3o(s) atribu\xedda(s) com sucesso",
        search: "Pesquisar pelo nome, descri\xe7\xe3o ou ID da fun\xe7\xe3o",
        empty: "Nenhuma fun\xe7\xe3o dispon\xedvel"
    }
};
var $f89e6b8a93a11cc7$export$2e2bcd8739ae039 = Object.freeze($f89e6b8a93a11cc7$var$application_details);


const $39b874f7fa413902$var$applications = {
    page_title: "Aplicativos",
    title: "Aplicativos",
    subtitle: "Configure um aplicativo m\xf3vel, de p\xe1gina \xfanica, m\xe1quina a m\xe1quina ou tradicional para usar o Logto para autentica\xe7\xe3o",
    subtitle_with_app_type: "Configure a autentica\xe7\xe3o Logto para o seu aplicativo {{name}}",
    create: "Criar aplicativo",
    create_subtitle_third_party: "Use o Logto como seu provedor de identidade (IdP) para integrar facilmente com aplicativos de terceiros",
    application_name: "Nome do Aplicativo",
    application_name_placeholder: "Meu aplicativo",
    application_description: "Descri\xe7\xe3o do aplicativo",
    application_description_placeholder: "Digite a descri\xe7\xe3o do seu aplicativo",
    select_application_type: "Selecione um tipo de aplicativo",
    no_application_type_selected: "Voc\xea ainda n\xe3o selecionou nenhum tipo de aplicativo",
    application_created: "O aplicativo foi criado com sucesso.",
    tab: {
        my_applications: "Meus aplicativos",
        third_party_applications: "Aplicativos de terceiros"
    },
    app_id: "ID do App",
    type: {
        native: {
            title: "Aplicativo Nativo",
            subtitle: "Um aplicativo executado em um ambiente nativo",
            description: "Ex: aplicativo iOS, aplicativo Android"
        },
        spa: {
            title: "Aplicativo de P\xe1gina \xdanica",
            subtitle: "Um aplicativo que \xe9 executado em um navegador da Web e atualiza dinamicamente os dados no local",
            description: "Ex: aplicativo React DOM, aplicativo Vue"
        },
        traditional: {
            title: "Web Tradicional",
            subtitle: "Um aplicativo que renderiza e atualiza p\xe1ginas apenas pelo servidor da web",
            description: "Ex: aplicativo Next.js, PHP"
        },
        machine_to_machine: {
            title: "M\xe1quina a M\xe1quina",
            subtitle: "Um aplicativo (geralmente um servi\xe7o) que fala diretamente com os recursos",
            description: "Ex: servi\xe7o de backend"
        },
        protected: {
            title: "Aplicativo Protegido",
            subtitle: "Um aplicativo protegido pelo Logto",
            description: "N/A"
        },
        third_party: {
            title: "Aplicativo de Terceiros",
            subtitle: "Um aplicativo usado como conector de IdP de terceiros",
            description: "Ex.: OIDC, SAML"
        }
    },
    placeholder_title: "Selecione um tipo de aplicativo para continuar",
    placeholder_description: "O Logto usa uma entidade de aplicativo para OIDC para ajudar nas tarefas, como identificar seus aplicativos, gerenciar o login e criar logs de auditoria.",
    m2m_role_assignment: {
        title: "Autorizar aplicativo com fun\xe7\xe3o de m\xe1quina para m\xe1quina para permiss\xf5es",
        subtitle: "Aplicativos de m\xe1quina para m\xe1quina requerem uma fun\xe7\xe3o de m\xe1quina para m\xe1quina autorizada.",
        role_creation_hint: "N\xe3o consegue encontrar o papel correto de m\xe1quina para m\xe1quina? <a>Crie um papel de m\xe1quina para m\xe1quina</a>"
    }
};
var $39b874f7fa413902$export$2e2bcd8739ae039 = Object.freeze($39b874f7fa413902$var$applications);


const $073902651c95b268$var$cloud = {
    general: {
        onboarding: "Integra\xe7\xe3o"
    },
    welcome: {
        page_title: "Bem-vindo",
        title: "Bem-vindo ao Logto Cloud! Gostar\xedamos de conhecer um pouco sobre voc\xea.",
        description: "Vamos tornar sua experi\xeancia Logto \xfanica, conhecendo voc\xea melhor. Suas informa\xe7\xf5es est\xe3o seguras conosco.",
        project_field: "Estou usando o Logto para",
        project_options: {
            personal: "Projeto pessoal",
            company: "Projeto da empresa"
        },
        company_name_field: "Nome da empresa",
        company_name_placeholder: "Acme.co",
        stage_field: "Em qual est\xe1gio seu produto est\xe1 atualmente?",
        stage_options: {
            new_product: "Iniciar um novo projeto e procurar por uma solu\xe7\xe3o r\xe1pida e pronta para uso",
            existing_product: "Migrar da autentica\xe7\xe3o atual (por exemplo, constru\xedda internamente, Auth0, Cognito, Microsoft)",
            target_enterprise_ready: "Acabei de conseguir clientes maiores e agora estou preparando meu produto para vender para empresas"
        },
        additional_features_field: "Voc\xea tem mais alguma coisa que deseja que saibamos?",
        additional_features_options: {
            customize_ui_and_flow: "Construir e gerenciar minha pr\xf3pria interface de usu\xe1rio, e n\xe3o apenas usar a solu\xe7\xe3o pr\xe9-constru\xedda e personaliz\xe1vel do Logto",
            compliance: "SOC2 e GDPR s\xe3o imprescind\xedveis",
            export_user_data: "Preciso da capacidade de exportar dados do usu\xe1rio do Logto",
            budget_control: "Tenho controle de or\xe7amento muito r\xedgido",
            bring_own_auth: "Tenho meus pr\xf3prios servi\xe7os de autentica\xe7\xe3o e apenas preciso de alguns recursos do Logto",
            others: "Nenhuma das op\xe7\xf5es acima"
        }
    },
    sie: {
        page_title: "Personalize a experi\xeancia de logon",
        title: "Vamos personalizar sua experi\xeancia de logon facilmente",
        inspire: {
            title: "Crie exemplos convincentes",
            description: 'Sentindo-se inseguro sobre a experi\xeancia de login? Basta clicar em "Inspirar-me" e deixar a m\xe1gica acontecer!',
            inspire_me: "Inspirar-me"
        },
        logo_field: "Logotipo do aplicativo",
        color_field: "Cor da marca",
        identifier_field: "Identificador",
        identifier_options: {
            email: "E-mail",
            phone: "Telefone",
            user_name: "Nome de usu\xe1rio"
        },
        authn_field: "Autentica\xe7\xe3o",
        authn_options: {
            password: "Senha",
            verification_code: "C\xf3digo de verifica\xe7\xe3o"
        },
        social_field: "Login social",
        finish_and_done: "Finalizar e feito",
        preview: {
            mobile_tab: "Celular",
            web_tab: "Internet"
        },
        connectors: {
            unlocked_later: "Desbloqueado mais tarde",
            unlocked_later_tip: "Assim que voc\xea concluir o processo de integra\xe7\xe3o e entrar no produto, ter\xe1 acesso a ainda mais m\xe9todos de login social.",
            notice: "Evite usar o conector de demonstra\xe7\xe3o para fins de produ\xe7\xe3o. Depois de conclu\xeddos os testes, exclua gentilmente o conector de demonstra\xe7\xe3o e configure seu pr\xf3prio conector com suas credenciais."
        }
    },
    socialCallback: {
        title: "Voc\xea entrou com sucesso",
        description: "Voc\xea entrou com sucesso usando sua conta social. Para garantir a integra\xe7\xe3o perfeita e o acesso a todos os recursos do Logto, recomendamos que voc\xea prossiga para configurar seu pr\xf3prio conector social."
    },
    tenant: {
        create_tenant: "Criar inquilino"
    }
};
var $073902651c95b268$export$2e2bcd8739ae039 = Object.freeze($073902651c95b268$var$cloud);


const $9ba10ff630fb95a3$var$components = {
    uploader: {
        action_description: "Arraste e solte ou procure",
        uploading: "Enviando...",
        image_limit: "Carregue imagens abaixo de {{size, number}}KB, apenas {{extensions, list(style: narrow; type: conjunction;)}}.",
        error_upload: "Algo deu errado. Falha ao enviar arquivo.",
        error_file_size: "Tamanho do arquivo \xe9 muito grande. Por favor, envie um arquivo abaixo de {{size, number}}KB.",
        error_file_type: "Tipo de arquivo n\xe3o \xe9 suportado. Apenas {{extensions, list(style: narrow; type: conjunction;)}}.",
        error_file_count: "Voc\xea s\xf3 pode enviar 1 arquivo."
    }
};
var $9ba10ff630fb95a3$export$2e2bcd8739ae039 = Object.freeze($9ba10ff630fb95a3$var$components);


const $40e167684167c12e$var$connector_details = {
    page_title: "Detalhes do conector",
    back_to_connectors: "Voltar para Conectores",
    check_readme: "Visualize o README",
    settings: "Configura\xe7\xf5es gerais",
    settings_description: "Os conectores desempenham um papel cr\xedtico no Logto. Com a ajuda deles, a Logto permite que os usu\xe1rios finais usem o registro ou login sem senha e os recursos de login com contas sociais.",
    parameter_configuration: "Configura\xe7\xe3o de par\xe2metros",
    test_connection: "Testar conex\xe3o",
    save_error_empty_config: "Por favor insira a configura\xe7\xe3o",
    send: "Enviar",
    send_error_invalid_format: "Campo inv\xe1lido",
    edit_config_label: "Digite seu json aqui",
    test_email_sender: "Testar conex\xe3o de e-mail",
    test_sms_sender: "Testar conex\xe3o SMS",
    test_email_placeholder: "john.doe@example.com",
    test_sms_placeholder: "+55 11 9 1234-5678",
    test_message_sent: "Mensagem de teste enviada",
    test_sender_description: 'O Logto utiliza o modelo "Generic" para testes. Voc\xea receber\xe1 uma mensagem se o seu conector estiver configurado corretamente.',
    options_change_email: "Alterar conector de e-mail",
    options_change_sms: "Alterar conector de SMS",
    connector_deleted: "O conector foi exclu\xeddo com sucesso",
    type_email: "Conector de e-mail",
    type_sms: "Conector de SMS",
    type_social: "Conector social",
    in_used_social_deletion_description: "Este conector est\xe1 em uso em sua experi\xeancia de login. Ao exclu\xed-lo, a experi\xeancia de login <name/> ser\xe1 exclu\xedda nas configura\xe7\xf5es de experi\xeancia de login. Voc\xea precisar\xe1 reconfigur\xe1-lo se decidir adicion\xe1-lo novamente.",
    in_used_passwordless_deletion_description: "Este {{name}} est\xe1 em uso em sua experi\xeancia de login. Ao exclu\xed-lo, sua experi\xeancia de login n\xe3o funcionar\xe1 corretamente at\xe9 que voc\xea resolva o conflito. Voc\xea precisar\xe1 reconfigur\xe1-lo se decidir adicion\xe1-lo novamente.",
    deletion_description: "Voc\xea est\xe1 removendo este conector. Isso n\xe3o pode ser desfeito e voc\xea precisar\xe1 reconfigur\xe1-lo se decidir adicion\xe1-lo novamente.",
    logto_email: {
        total_email_sent: "Total de e-mails enviados: {{value, number}}",
        total_email_sent_tip: "Logto utiliza SendGrid para envio seguro e est\xe1vel de e-mails integrados. \xc9 completamente gratuito para uso. <a>Saiba mais</a>",
        email_template_title: "Modelo de e-mail",
        template_description: "O e-mail integrado usa modelos padr\xe3o para entrega perfeita de e-mails de verifica\xe7\xe3o. Nenhuma configura\xe7\xe3o \xe9 necess\xe1ria e voc\xea pode personalizar informa\xe7\xf5es b\xe1sicas da marca.",
        template_description_link_text: "Visualizar modelos",
        description_action_text: "Ver modelos",
        from_email_field: "E-mail do remetente",
        sender_name_field: "Nome do remetente",
        sender_name_tip: 'Personalize o nome do remetente para e-mails. Se deixado em branco, "Verification" ser\xe1 usado como nome padr\xe3o.',
        sender_name_placeholder: "Seu nome de remetente",
        company_information_field: "Informa\xe7\xf5es da empresa",
        company_information_description: "Exiba o nome da sua empresa, endere\xe7o ou c\xf3digo postal no final dos e-mails para melhorar a autenticidade.",
        company_information_placeholder: "Informa\xe7\xf5es b\xe1sicas da sua empresa",
        app_logo_field: "Logotipo do aplicativo",
        app_logo_tip: "Exiba o logotipo da sua marca no topo dos e-mails. Use a mesma imagem para o modo claro e escuro.",
        urls_not_allowed: "URLs n\xe3o permitidas",
        test_notes: 'Logto utiliza o modelo "Gen\xe9rico" para testes.'
    }
};
var $40e167684167c12e$export$2e2bcd8739ae039 = Object.freeze($40e167684167c12e$var$connector_details);


const $4ac1ead7f222b1ab$var$connectors = {
    page_title: "Conectores",
    title: "Conectores",
    subtitle: "Configure conectores para habilitar a experi\xeancia de login social e sem senha",
    create: "Adicionar conector social",
    config_sie_notice: "Voc\xea configurou os conectores. Certifique-se de configur\xe1-lo em <a>{{link}}</a>.",
    config_sie_link_text: "experi\xeancia de login",
    tab_email_sms: "Conectores de E-mail e SMS",
    tab_social: "Conectores sociais",
    connector_name: "Nome do conector",
    demo_tip: "O n\xfamero m\xe1ximo de mensagens permitidas para este conector de demonstra\xe7\xe3o \xe9 limitado a 100 e n\xe3o \xe9 recomendado para implanta\xe7\xe3o em um ambiente de produ\xe7\xe3o.",
    social_demo_tip: "O conector de demonstra\xe7\xe3o \xe9 projetado exclusivamente para fins de demonstra\xe7\xe3o e n\xe3o \xe9 recomendado para implanta\xe7\xe3o em um ambiente de produ\xe7\xe3o.",
    connector_type: "Tipo",
    connector_status: "Experi\xeancia de login",
    connector_status_in_use: "Em uso",
    connector_status_not_in_use: "Fora de uso",
    not_in_use_tip: {
        content: "Fora de uso significa que sua experi\xeancia de login n\xe3o usou esse m\xe9todo de login. <a>{{link}}</a> para adicionar este m\xe9todo de login. ",
        go_to_sie: "V\xe1 para a experi\xeancia de login"
    },
    placeholder_title: "Conector social",
    placeholder_description: "Logto tem fornecido muitos conectores de login social amplamente utilizados enquanto voc\xea pode criar o seu pr\xf3prio com padr\xf5es padr\xe3o.",
    save_and_done: "Salvar e completar",
    type: {
        email: "Conector de e-mail",
        sms: "Conector de SMS",
        social: "Conector social"
    },
    setup_title: {
        email: "Configurar conector de e-mail",
        sms: "Configurar conector SMS",
        social: "Adicionar conector social"
    },
    guide: {
        subtitle: "Um guia passo a passo para configurar seu conector",
        general_setting: "Configura\xe7\xf5es gerais",
        parameter_configuration: "Configura\xe7\xe3o de par\xe2metros",
        test_connection: "Teste de conex\xe3o",
        name: "Nome do bot\xe3o de login social",
        name_placeholder: "Insira o nome do bot\xe3o de login social",
        name_tip: 'O nome do bot\xe3o do conector ser\xe1 exibido como "Continuar com {{Nome do Conector}}".',
        logo: "URL do logo para o bot\xe3o de login social",
        logo_placeholder: "https://your.cdn.domain/logo.png",
        logo_tip: "A imagem do logotipo tamb\xe9m ser\xe1 exibida no bot\xe3o do conector.",
        logo_dark: "URL do logo para o bot\xe3o de login social (modo escuro)",
        logo_dark_placeholder: "https://your.cdn.domain/logo.png",
        logo_dark_tip: "Defina o logotipo do seu conector para o modo escuro depois de ativ\xe1-lo na Experi\xeancia de login do Console de Administra\xe7\xe3o.",
        logo_dark_collapse: "Expandir",
        logo_dark_show: "Mostrar configura\xe7\xe3o de logotipo para modo escuro",
        target: "Nome do fornecedor de identidade",
        target_placeholder: "Insira o nome do fornecedor de identidade do conector",
        target_tip: 'O valor de "Nome do fornecedor de identidade" pode ser uma string de identificador exclusiva para distinguir suas identidades sociais.',
        target_tip_standard: 'O valor de "Nome do fornecedor de identidade" pode ser uma string de identificador exclusiva para distinguir suas identidades sociais. Essa configura\xe7\xe3o n\xe3o pode ser alterada ap\xf3s a cria\xe7\xe3o do conector.',
        target_tooltip: '"Target" nos conectores sociais Logto refere-se \xe0 "origem" de suas identidades sociais. No design do Logto, n\xe3o aceitamos o mesmo "target" de uma plataforma espec\xedfica para evitar conflitos. Voc\xea deve tomar muito cuidado antes de adicionar um conector, pois N\xc3O PODE mudar seu valor depois de cri\xe1-lo. <a>Saiba mais</a>',
        target_conflict: "O nome de IdP inserido corresponde ao <span>nome</span> existente. Usar o mesmo nome do IDP pode causar comportamento inesperado ao entrar onde os usu\xe1rios podem acessar a mesma conta por meio de dois conectores diferentes.",
        target_conflict_line2: 'Se voc\xea deseja substituir o conector atual pelo mesmo fornecedor de identidade e permitir que usu\xe1rios antigos fa\xe7am login sem se registrar novamente, exclua o conector <span>nome</span> e crie um novo com o mesmo "Nome do fornecedor de identidade".',
        target_conflict_line3: 'Se voc\xea deseja se conectar a um provedor de identidade diferente, modifique o "Nome do fornecedor de identidade" e prossiga.',
        config: "Digite seu JSON aqui",
        sync_profile: "Sincronizar informa\xe7\xf5es de perfil",
        sync_profile_only_at_sign_up: "Sincronizar apenas no registro",
        sync_profile_each_sign_in: "Sempre sincronizar a cada login",
        sync_profile_tip: "Sincronize o perfil b\xe1sico do provedor social, como os nomes dos usu\xe1rios e seus avatares.",
        callback_uri: "URI de retorno do chamado",
        callback_uri_description: "Tamb\xe9m chamado de URI de redirecionamento, \xe9 a URI no Logto para a qual os usu\xe1rios ser\xe3o enviados de volta ap\xf3s a autoriza\xe7\xe3o social; copie e cole na p\xe1gina de configura\xe7\xe3o do provedor social.",
        acs_url: "URL do servi\xe7o de consumo de afirma\xe7\xf5es"
    },
    platform: {
        universal: "Universal",
        web: "Web",
        native: "Nativo"
    },
    add_multi_platform: "suporta v\xe1rias plataformas, selecione uma plataforma para continuar",
    drawer_title: "Guia do Conector",
    drawer_subtitle: "Siga as instru\xe7\xf5es para integrar seu conector",
    unknown: "Conector desconhecido",
    standard_connectors: "Conectores padr\xe3o"
};
var $4ac1ead7f222b1ab$export$2e2bcd8739ae039 = Object.freeze($4ac1ead7f222b1ab$var$connectors);


const $99383f3da569ace2$var$contact = {
    title: "Obter ajuda",
    description: "Para solicita\xe7\xf5es de ajuda ou feedback do produto, entre em contato conosco pelos seguintes m\xe9todos.",
    discord: {
        title: "Participe da comunidade Discord",
        description: "Conecte-se com outros desenvolvedores para encontrar solu\xe7\xf5es",
        button: "Participar"
    },
    github: {
        title: "Comunique-se no GitHub",
        description: "Crie um problema e envie-o no GitHub",
        button: "Abrir"
    },
    email: {
        title: "Entre em contato com o suporte via email",
        description: "Envie um email para obter mais informa\xe7\xf5es e ajuda",
        button: "Enviar"
    },
    reserve: {
        title: "Reserve seu hor\xe1rio com a equipe da Logto",
        description: "Agende uma sess\xe3o para um bate-papo ao vivo",
        button: "Agendar"
    }
};
var $99383f3da569ace2$export$2e2bcd8739ae039 = Object.freeze($99383f3da569ace2$var$contact);


const $f7789614396c8f1c$var$dashboard = {
    page_title: "Painel",
    title: "Painel",
    description: "Obtenha uma vis\xe3o geral sobre o desempenho do seu aplicativo",
    total_users: "Total de usu\xe1rios",
    total_users_tip: "Total de usu\xe1rios",
    new_users_today: "Novos usu\xe1rios hoje",
    new_users_today_tip: "O n\xfamero de novos usu\xe1rios registrados em seus aplicativos hoje",
    new_users_7_days: "Novos usu\xe1rios nos \xfaltimos 7 dias",
    new_users_7_days_tip: "O n\xfamero de novos usu\xe1rios registrados em seus aplicativos nos \xfaltimos 7 dias",
    daily_active_users: "Usu\xe1rios ativos diariamente",
    daily_active_users_tip: "O n\xfamero de tokens trocados por usu\xe1rios \xfanicos em seus aplicativos hoje",
    weekly_active_users: "Usu\xe1rios ativos semanalmente",
    weekly_active_users_tip: "O n\xfamero de tokens trocados por usu\xe1rios \xfanicos em seus aplicativos nos \xfaltimos 7 dias",
    monthly_active_users: "Usu\xe1rios ativos mensais",
    monthly_active_users_tip: "O n\xfamero de tokens trocados por usu\xe1rios \xfanicos em seus aplicativos nos \xfaltimos 30 dias"
};
var $f7789614396c8f1c$export$2e2bcd8739ae039 = Object.freeze($f7789614396c8f1c$var$dashboard);


const $bb85c21e09776d55$var$domain = {
    status: {
        connecting: "Conectando...",
        in_use: "Em uso",
        failed_to_connect: "Falha na conex\xe3o"
    },
    update_endpoint_notice: "N\xe3o se esque\xe7a de atualizar o dom\xednio para o URI de retorno do conector social e o ponto de extremidade de logto em seu aplicativo se voc\xea quiser usar um dom\xednio personalizado para os recursos. <a>{{link}}</a>",
    error_hint: "Certifique-se de atualizar seus registros DNS. N\xf3s continuaremos a verifica\xe7\xe3o a cada {{value}} segundos.",
    custom: {
        custom_domain: "Dom\xednio personalizado",
        custom_domain_description: "Melhore sua marca utilizando um dom\xednio personalizado. Este dom\xednio ser\xe1 utilizado em sua experi\xeancia de login.",
        custom_domain_field: "Dom\xednio personalizado",
        custom_domain_placeholder: "seu.dom\xednio.com",
        add_domain: "Adicionar dom\xednio",
        invalid_domain_format: 'Por favor, forne\xe7a uma URL de dom\xednio v\xe1lida com um m\xednimo de tr\xeas partes, por exemplo, "seu.dom\xednio.com."',
        verify_domain: "Verificar dom\xednio",
        enable_ssl: "Habilitar SSL",
        checking_dns_tip: "Ap\xf3s configurar os registros DNS, o processo ser\xe1 iniciado automaticamente e pode levar at\xe9 24 horas. Voc\xea pode deixar esta interface enquanto o processo \xe9 executado.",
        enable_ssl_tip: "Habilitar SSL ser\xe1 executado automaticamente e pode levar at\xe9 24 horas. Voc\xea pode deixar esta interface enquanto o processo \xe9 executado.",
        generating_dns_records: "Gerando os registros DNS...",
        add_dns_records: "Por favor, adicione estes registros DNS ao seu provedor DNS.",
        dns_table: {
            type_field: "Tipo",
            name_field: "Nome",
            value_field: "Valor"
        },
        deletion: {
            delete_domain: "Excluir dom\xednio",
            reminder: "Excluir dom\xednio personalizado",
            description: "Tem certeza de que deseja excluir este dom\xednio personalizado?",
            in_used_description: 'Tem certeza de que deseja excluir este dom\xednio personalizado "<span>{{domain}}</span>"?',
            in_used_tip: 'Se voc\xea configurou este dom\xednio personalizado em seu provedor de conex\xe3o social ou ponto de extremidade de aplicativo antes, voc\xea precisar\xe1 modificar a URI para o dom\xednio padr\xe3o do Logto "<span>{{domain}}</span>" primeiro. Isso \xe9 necess\xe1rio para que o bot\xe3o de login social funcione corretamente.',
            deleted: "Dom\xednio personalizado exclu\xeddo com sucesso!"
        }
    },
    default: {
        default_domain: "Dom\xednio padr\xe3o",
        default_domain_description: "Logto oferece um dom\xednio padr\xe3o pr\xe9-configurado, pronto para uso sem nenhuma configura\xe7\xe3o adicional. Este dom\xednio padr\xe3o serve como uma op\xe7\xe3o de backup mesmo se voc\xea habilitou um dom\xednio personalizado.",
        default_domain_field: "Dom\xednio padr\xe3o do Logto"
    },
    custom_endpoint_note: 'Voc\xea pode personalizar o nome de dom\xednio desses endpoints conforme necess\xe1rio. Escolha "{{custom}}" ou "{{default}}".',
    custom_social_callback_url_note: 'Voc\xea pode personalizar o nome de dom\xednio desta URI para corresponder ao endpoint de seu aplicativo. Escolha "{{custom}}" ou "{{default}}".',
    custom_acs_url_note: 'Voc\xea pode personalizar o nome de dom\xednio desta URI para corresponder \xe0 URL do servi\xe7o consumidor de assertividade de seu provedor de identidade. Escolha "{{custom}}" ou "{{default}}".'
};
var $bb85c21e09776d55$export$2e2bcd8739ae039 = Object.freeze($bb85c21e09776d55$var$domain);


const $861acb201b104c88$var$enterprise_sso_details = {
    back_to_sso_connectors: "Voltar para os conectores de SSO empresarial",
    page_title: "Detalhes do conector de SSO empresarial",
    readme_drawer_title: "SSO empresarial",
    readme_drawer_subtitle: "Configurar conectores de SSO empresarial para habilitar o SSO dos usu\xe1rios finais",
    tab_experience: "Experi\xeancia de SSO",
    tab_connection: "Conex\xe3o",
    general_settings_title: "Geral",
    custom_branding_title: "Exibi\xe7\xe3o",
    custom_branding_description: "Personalize o nome e o logotipo exibidos no fluxo de Logon \xdanico dos usu\xe1rios finais. Quando vazio, os padr\xf5es s\xe3o usados.",
    email_domain_field_name: "Dom\xednio de e-mail da empresa",
    email_domain_field_description: "Usu\xe1rios com este dom\xednio de e-mail podem usar SSO para autentica\xe7\xe3o. Verifique se o dom\xednio pertence \xe0 empresa.",
    email_domain_field_placeholder: "Dom\xednio do e-mail",
    sync_profile_field_name: "Sincronizar informa\xe7\xf5es de perfil do provedor de identidade",
    sync_profile_option: {
        register_only: "Apenas sincronizar no primeiro logon",
        each_sign_in: "Sempre sincronizar a cada logon"
    },
    connector_name_field_name: "Nome do conector",
    display_name_field_name: "Nome de exibi\xe7\xe3o",
    connector_logo_field_name: "Logotipo de exibi\xe7\xe3o",
    connector_logo_field_description: "Cada imagem deve ter no m\xe1ximo 500KB, apenas SVG, PNG, JPG, JPEG.",
    branding_logo_context: "Fazer upload do logotipo",
    branding_logo_error: "Erro ao fazer upload do logotipo: {{error}}",
    branding_light_logo_context: "Fazer upload do logotipo do modo claro",
    branding_light_logo_error: "Erro ao fazer upload do logotipo do modo claro: {{error}}",
    branding_logo_field_name: "Logotipo",
    branding_logo_field_placeholder: "https://seu.dom\xednio/logo.png",
    branding_dark_logo_context: "Fazer upload do logotipo do modo escuro",
    branding_dark_logo_error: "Erro ao fazer upload do logotipo do modo escuro: {{error}}",
    branding_dark_logo_field_name: "Logotipo (modo escuro)",
    branding_dark_logo_field_placeholder: "https://seu.dom\xednio/logomodo-escuro.png",
    check_connection_guide: "Guia de conex\xe3o",
    enterprise_sso_deleted: "O conector de SSO empresarial foi exclu\xeddo com sucesso",
    delete_confirm_modal_title: "Excluir conector de SSO empresarial",
    delete_confirm_modal_content: "Tem certeza de que deseja excluir este conector empresarial? Os usu\xe1rios dos provedores de identidade n\xe3o utilizar\xe3o o Logon \xdanico.",
    upload_idp_metadata_title_saml: "Fazer upload dos metadados",
    upload_idp_metadata_description_saml: "Configurar os metadados copiados do provedor de identidade.",
    upload_idp_metadata_title_oidc: "Fazer upload das credenciais",
    upload_idp_metadata_description_oidc: "Configurar as credenciais e as informa\xe7\xf5es de token OIDC copiadas do provedor de identidade.",
    upload_idp_metadata_button_text: "Fazer upload do arquivo XML de metadados",
    upload_signing_certificate_button_text: "Fazer upload do arquivo de certificado de assinatura",
    configure_domain_field_info_text: "Adicionar dom\xednio de e-mail para orientar os usu\xe1rios empresariais para seu provedor de identidade para Logon \xdanico.",
    email_domain_field_required: "O dom\xednio de e-mail \xe9 obrigat\xf3rio para habilitar o SSO empresarial.",
    upload_saml_idp_metadata_info_text_url: "Cole a URL dos metadados do provedor de identidade para conectar.",
    upload_saml_idp_metadata_info_text_xml: "Cole os metadados do provedor de identidade para conectar.",
    upload_saml_idp_metadata_info_text_manual: "Preencha os metadados do provedor de identidade para conectar.",
    upload_oidc_idp_info_text: "Preencha as informa\xe7\xf5es do provedor de identidade para conectar.",
    service_provider_property_title: "Configurar no IdP",
    service_provider_property_description: "Configure uma integra\xe7\xe3o de aplicativos usando {{protocol}} em seu provedor de identidade. Insira os detalhes fornecidos pela Logto.",
    attribute_mapping_title: "Mapeamento de atributos",
    attribute_mapping_description: "Sincronize perfis de usu\xe1rio do provedor de identidade configurando o mapeamento de atributos do usu\xe1rio no lado do provedor de identidade para Logto.",
    saml_preview: {
        sign_on_url: "URL de logon",
        entity_id: "Emissor",
        x509_certificate: "Certificado de assinatura",
        certificate_content: "Expira em {{date}}"
    },
    oidc_preview: {
        authorization_endpoint: "Endpoint de autoriza\xe7\xe3o",
        token_endpoint: "Endpoint de token",
        userinfo_endpoint: "Endpoint de informa\xe7\xf5es do usu\xe1rio",
        jwks_uri: "Endpoint do conjunto de chaves JSON web",
        issuer: "Emissor"
    }
};
var $861acb201b104c88$export$2e2bcd8739ae039 = Object.freeze($861acb201b104c88$var$enterprise_sso_details);


const $f150d5061fa85a4a$var$enterprise_sso = {
    page_title: "SSO Empresarial",
    title: "SSO Empresarial",
    subtitle: "Conecte-se ao provedor de identidade empresarial e habilite o Logon \xdanico iniciado pelo provedor de servi\xe7o (SP).",
    create: "Adicionar conector empresarial",
    col_connector_name: "Nome do conector",
    col_type: "Tipo",
    col_email_domain: "Dom\xednio de e-mail",
    placeholder_title: "Conector empresarial",
    placeholder_description: "O Logto forneceu muitos provedores de identidade corporativa integrados para conex\xe3o. Ao mesmo tempo, voc\xea pode criar o seu pr\xf3prio com os protocolos SAML e OIDC.",
    create_modal: {
        title: "Adicionar conector empresarial",
        text_divider: "Ou voc\xea pode personalizar seu conector usando um protocolo padr\xe3o.",
        connector_name_field_title: "Nome do conector",
        connector_name_field_placeholder: "Por exemplo, {nome da empresa} - {nome do provedor de identidade}",
        create_button_text: "Criar conector"
    },
    guide: {
        subtitle: "Um guia passo a passo para conectar o provedor de identidade empresarial.",
        finish_button_text: "Continuar"
    },
    basic_info: {
        title: "Configure seu servi\xe7o no IdP",
        description: "Crie uma nova integra\xe7\xe3o de aplicativo por SAML 2.0 em seu provedor de identidade {{name}}. Em seguida, cole o seguinte valor nele.",
        saml: {
            acs_url_field_name: "URL do servi\xe7o de consumidor de afirma\xe7\xf5es (URL de resposta)",
            audience_uri_field_name: "URI da audi\xeancia (ID da Entidade do SP)"
        },
        oidc: {
            redirect_uri_field_name: "URL de redirecionamento (URL de retorno de chamada)"
        }
    },
    attribute_mapping: {
        title: "Mapeamento de atributos",
        description: "`id` e `email` s\xe3o necess\xe1rios para sincronizar o perfil do usu\xe1rio do IdP. Insira o seguinte nome de reivindica\xe7\xe3o e valor no seu IdP.",
        col_sp_claims: "Valor do provedor de servi\xe7os (Logto)",
        col_idp_claims: "Nome da reivindica\xe7\xe3o do provedor de identidade",
        idp_claim_tooltip: "O nome da reivindica\xe7\xe3o do provedor de identidade"
    },
    metadata: {
        title: "Configure os metadados do IdP",
        description: "Configure os metadados do provedor de identidade",
        dropdown_trigger_text: "Usar outro m\xe9todo de configura\xe7\xe3o",
        dropdown_title: "selecione seu m\xe9todo de configura\xe7\xe3o",
        metadata_format_url: "Insira a URL do metadado",
        metadata_format_xml: "Enviar o arquivo XML de metadados",
        metadata_format_manual: "Insira os detalhes dos metadados manualmente",
        saml: {
            metadata_url_field_name: "URL do metadado",
            metadata_url_description: "Buscar dinamicamente dados da URL do metadado e manter o certificado atualizado.",
            metadata_xml_field_name: "Arquivo XML de metadados do IdP",
            metadata_xml_uploader_text: "Enviar arquivo XML de metadados",
            sign_in_endpoint_field_name: "URL de logon",
            idp_entity_id_field_name: "ID da entidade do IdP (Emissor)",
            certificate_field_name: "Certificado de assinatura",
            certificate_placeholder: "Copie e cole o certificado x509",
            certificate_required: "O certificado de assinatura \xe9 obrigat\xf3rio."
        },
        oidc: {
            client_id_field_name: "ID do cliente",
            client_secret_field_name: "Segredo do cliente",
            issuer_field_name: "Emissor",
            scope_field_name: "Escopo"
        }
    }
};
var $f150d5061fa85a4a$export$2e2bcd8739ae039 = Object.freeze($f150d5061fa85a4a$var$enterprise_sso);


const $01a60c7c1354d5d4$var$errors = {
    something_went_wrong: "Ops! Algo deu errado.",
    page_not_found: "P\xe1gina n\xe3o encontrada",
    unknown_server_error: "Ocorreu um erro desconhecido no servidor",
    empty: "Sem dados",
    missing_total_number: "N\xe3o foi poss\xedvel encontrar Total-Number nos cabe\xe7alhos de resposta",
    invalid_uri_format: "Formato de URI inv\xe1lido",
    invalid_origin_format: "Formato de origem de URI inv\xe1lido",
    invalid_json_format: "Formato JSON inv\xe1lido",
    invalid_regex: "Express\xe3o regular inv\xe1lida",
    invalid_error_message_format: "O formato da mensagem de erro \xe9 inv\xe1lido.",
    required_field_missing: "Por favor, insira {{field}}",
    required_field_missing_plural: "Voc\xea deve inserir pelo menos um {{field}}",
    more_details: "Mais detalhes",
    username_pattern_error: "O nome de usu\xe1rio deve conter apenas letras, n\xfameros ou sublinhado e n\xe3o deve come\xe7ar com um n\xfamero.",
    email_pattern_error: "O endere\xe7o de e-mail \xe9 inv\xe1lido.",
    phone_pattern_error: "O n\xfamero de telefone \xe9 inv\xe1lido.",
    insecure_contexts: "Contextos inseguros (n\xe3o-HTTPS) n\xe3o s\xe3o suportados.",
    unexpected_error: "Um erro inesperado ocorreu",
    not_found: "404 n\xe3o encontrado",
    create_internal_role_violation: 'Voc\xea est\xe1 criando uma nova fun\xe7\xe3o interna que \xe9 proibida pela Logto. Tente outro nome que n\xe3o comece com "#internal:".',
    should_be_an_integer: "Deveria ser um inteiro.",
    number_should_be_between_inclusive: "Ent\xe3o o n\xfamero deve estar entre {{min}} e {{max}} (ambos inclusive)."
};
var $01a60c7c1354d5d4$export$2e2bcd8739ae039 = Object.freeze($01a60c7c1354d5d4$var$errors);


const $9035e1e484773d59$var$general = {
    placeholder: "Espa\xe7o reservado",
    submit: "Enviar",
    skip: "Pular",
    next: "Pr\xf3ximo",
    back: "Voltar",
    retry: "Tentar novamente",
    done: "Feito",
    search: "Buscar",
    search_placeholder: "Buscar",
    clear_result: "Limpar resultados",
    save: "Salvar",
    save_changes: "Salvar altera\xe7\xf5es",
    saved: "Salvo",
    discard: "Descartar",
    loading: "Carregando...",
    redirecting: "Redirecionando...",
    add: "Adicionar",
    added: "Adicionado",
    cancel: "Cancelar",
    confirm: "Confirmar",
    check_out: "Finalizar compra",
    create: "Criar",
    set_up: "Configurar",
    customize: "Personalizar",
    enable: "Habilitar",
    reminder: "Lembrete",
    edit: "Editar",
    delete: "Excluir",
    deleted: "Exclu\xeddo",
    more_options: "MAIS OP\xc7\xd5ES",
    close: "Fechar",
    copy: "Copiar",
    copying: "Copiando",
    copied: "Copiado",
    required: "Obrigat\xf3rio",
    add_another: "Adicionar outro",
    create_another: "Criar outro",
    deletion_confirmation: "Tem certeza de que deseja excluir este {{title}}?",
    settings_nav: "Configura\xe7\xf5es",
    unsaved_changes_warning: "Voc\xea fez algumas altera\xe7\xf5es. Tem certeza de que deseja sair desta p\xe1gina?",
    leave_page: "Sair da p\xe1gina",
    stay_on_page: "Permanecer na p\xe1gina",
    type_to_search: "Digite para pesquisar",
    got_it: "Entendi",
    continue: "Continuar",
    page_info: "{{min, number}}-{{max, number}} de {{total, number}}",
    learn_more: "Saiba mais",
    tab_errors: "{{count, number}} erros",
    skip_for_now: "Pular por agora",
    remove: "Remover",
    visit: "Visitar",
    join: "Entrar",
    try_now: "Experimentar agora",
    multiple_form_field: "(M\xfaltiplo)",
    demo: "Demo",
    unnamed: "Sem nome",
    view: "Ver",
    open: "Abrir",
    hide: "Ocultar",
    unknown_error: "Erro desconhecido, por favor tente novamente mais tarde.",
    select: "Selecionar",
    contact_us_action: "Contate-nos",
    description: "Descri\xe7\xe3o",
    name: "Nome",
    add_field: "Adicionar {{field}}",
    create_field: "Criar {{field}}",
    edit_field: "Editar {{field}}",
    delete_field: "Excluir {{field}}",
    coming_soon: "Em breve",
    or: "Ou"
};
var $9035e1e484773d59$export$2e2bcd8739ae039 = Object.freeze($9035e1e484773d59$var$general);


const $6b92ab5713c519c7$var$get_started = {
    page_title: "Come\xe7ar",
    title: "Algo para explorar para ajud\xe1-lo a ter sucesso",
    subtitle: "Algumas coisas que voc\xea pode fazer para obter rapidamente valor do Logto",
    develop: {
        title: "Desenvolva: Dedique 5 minutos para integrar o seu aplicativo",
        title_cloud: "Desenvolver: Integre com seguran\xe7a seu aplicativo em minutos",
        subtitle_cloud: "Ou leve 5 minutos para integrar seu aplicativo com nossos SDKs pr\xe9-constru\xeddos e tutoriais."
    },
    customize: {
        title: "Personalize: Ofere\xe7a uma \xf3tima experi\xeancia de login",
        preview: {
            title: "Verifique a visualiza\xe7\xe3o ao vivo da experi\xeancia de login que voc\xea acabou de personalizar",
            subtitle: "Experimente agora a experi\xeancia de login do Logto para ver como ela funciona"
        },
        connector: {
            title: "Adicione mais conectores para oferecer mais m\xe9todos de login social",
            subtitle: "Experimente o login sem senha e habilite uma experi\xeancia segura e sem atritos para seus clientes"
        },
        continue_customizing: "Continuar personalizando",
        try_now: "Experimente agora",
        add_more: "Adicionar mais"
    },
    secure: {
        title: "Seguran\xe7a: Proteja seus recursos"
    },
    manage: {
        title: "Gerencie: Defina o controle de acesso para seu produto e usu\xe1rios",
        rbac: {
            title: "Adicione controle de acesso baseado em fun\xe7\xf5es para proteger seus recursos",
            subtitle: "Controle seus recursos por meio de autoriza\xe7\xe3o baseada em fun\xe7\xe3o escal\xe1vel para diversos casos de uso."
        },
        create_roles: "Criar fun\xe7\xf5es"
    },
    view_all: "Ver todos →"
};
var $6b92ab5713c519c7$export$2e2bcd8739ae039 = Object.freeze($6b92ab5713c519c7$var$get_started);


const $f12aa1ab64d42de8$var$guide = {
    start_building: "Come\xe7ar a construir",
    get_started: "Iniciar",
    categories: {
        featured: "Popular e para voc\xea",
        Traditional: "Aplicativo web tradicional",
        SPA: "Aplicativo de p\xe1gina \xfanica",
        Native: "Nativo",
        MachineToMachine: "M\xe1quina a m\xe1quina",
        Protected: "Integra\xe7\xe3o sem SDK",
        ThirdParty: "Aplicativo de terceiros"
    },
    filter: {
        title: "Filtrar framework",
        placeholder: "Pesquisar framework"
    },
    checkout_tutorial: "Verificar tutorial {{name}}",
    do_not_need_tutorial: "Se voc\xea n\xe3o precisa de um tutorial, voc\xea pode continuar sem um guia de framework",
    finish_and_done: "Concluir e finalizado",
    cannot_find_guide: "N\xe3o \xe9 poss\xedvel encontrar seu guia?",
    describe_guide_looking_for: "Descreva o guia que voc\xea est\xe1 procurando",
    request_guide_successfully: "Sua solicita\xe7\xe3o foi enviada com sucesso. Obrigado!",
    app: {
        select_framework_or_tutorial: "Selecionar um framework ou tutorial",
        guide_modal_title: "Iniciar com SDK e guias",
        modal_subtitle: "Inicie seu processo de desenvolvimento de aplicativo com nosso SDK pr\xe9-constru\xeddo e tutoriais.",
        select_a_framework: "Selecionar um framework",
        continue_without_framework: "Criar aplicativo sem framework",
        describe_guide_looking_for_placeholder: "Por exemplo, eu quero integrar o Logto ao meu aplicativo Angular."
    },
    api: {
        modal_title: "Iniciar com tutoriais",
        modal_subtitle: "Inicie seu processo de desenvolvimento de aplicativo com nossos tutoriais pr\xe9-constru\xeddos.",
        select_a_tutorial: "Selecionar um tutorial",
        continue_without_tutorial: "Continuar sem tutorial",
        describe_guide_looking_for_placeholder: "Por exemplo, eu quero proteger minha API usando Deno."
    }
};
var $f12aa1ab64d42de8$export$2e2bcd8739ae039 = Object.freeze($f12aa1ab64d42de8$var$guide);


const $ac0a54c5f3e9518d$var$invitation = {
    find_your_tenants: "Encontre seus inquilinos",
    find_tenants_description: "Seu endere\xe7o de e-mail pode j\xe1 estar registrado em v\xe1rios inquilinos. Voc\xea pode escolher se juntar aos existentes ou continuar e criar um novo.",
    create_new_tenant: "Criar um novo inquilino",
    email_not_match_title: "Voc\xea est\xe1 atualmente conectado como\n{{email}}",
    email_not_match_description: "Por favor, fa\xe7a login com a conta correta para aceitar o convite e se tornar um membro da organiza\xe7\xe3o.",
    switch_account: "Entrar com outra conta",
    invalid_invitation_status: "Convite inv\xe1lido. Entre em contato com o administrador e tente novamente.",
    invitation_not_found: "Convite n\xe3o encontrado. Por favor, entre em contato com o administrador."
};
var $ac0a54c5f3e9518d$export$2e2bcd8739ae039 = Object.freeze($ac0a54c5f3e9518d$var$invitation);


const $d6388afe697f99ef$var$jwt_claims = {
    title: "JWT Personalizado",
    description: "Configure reivindica\xe7\xf5es personalizadas no JWT para incluir no token de acesso. Essas reivindica\xe7\xf5es podem ser usadas para passar informa\xe7\xf5es adicionais para sua aplica\xe7\xe3o.",
    user_jwt: {
        card_title: "Para usu\xe1rio",
        card_field: "Token de acesso do usu\xe1rio",
        card_description: "Adicione dados espec\xedficos do usu\xe1rio durante a emiss\xe3o do token de acesso.",
        for: "para usu\xe1rio"
    },
    machine_to_machine_jwt: {
        card_title: "Para M2M",
        card_field: "Token de m\xe1quina para m\xe1quina",
        card_description: "Adicione dados extras durante a emiss\xe3o do token de m\xe1quina para m\xe1quina.",
        for: "para M2M"
    },
    code_editor_title: "Personalizar as reivindica\xe7\xf5es {{token}}",
    custom_jwt_create_button: "Adicionar reivindica\xe7\xf5es personalizadas",
    custom_jwt_item: "Reivindica\xe7\xf5es personalizadas {{for}}",
    delete_modal_title: "Excluir reivindica\xe7\xf5es personalizadas",
    delete_modal_content: "Tem certeza de que deseja excluir as reivindica\xe7\xf5es personalizadas?",
    clear: "Limpar",
    cleared: "Limpado",
    restore: "Restaurar padr\xf5es",
    restored: "Restaurado",
    data_source_tab: "Fonte de dados",
    test_tab: "Contexto de teste",
    jwt_claims_description: "As reivindica\xe7\xf5es padr\xe3o s\xe3o automaticamente inclu\xeddas no JWT e n\xe3o podem ser substitu\xeddas.",
    user_data: {
        title: "Dados do usu\xe1rio",
        subtitle: "Use o par\xe2metro de entrada `data.user` para fornecer informa\xe7\xf5es vitais do usu\xe1rio."
    },
    token_data: {
        title: "Dados do token",
        subtitle: "Use o par\xe2metro de entrada `token` para a carga \xfatil do token de acesso atual. "
    },
    fetch_external_data: {
        title: "Buscar dados externos",
        subtitle: "Incorpore dados de suas APIs externas diretamente nas reivindica\xe7\xf5es.",
        description: "Use a fun\xe7\xe3o `fetch` para chamar suas APIs externas e incluir os dados em suas reivindica\xe7\xf5es personalizadas. Exemplo: "
    },
    environment_variables: {
        title: "Definir vari\xe1veis de ambiente",
        subtitle: "Use vari\xe1veis de ambiente para armazenar informa\xe7\xf5es confidenciais.",
        input_field_title: "Adicionar vari\xe1veis de ambiente",
        sample_code: "Acessando vari\xe1veis de ambiente no manipulador de reivindica\xe7\xf5es JWT personalizado. Exemplo: "
    },
    jwt_claims_hint: "Limite as reivindica\xe7\xf5es personalizadas a menos de 50KB. As reivindica\xe7\xf5es padr\xe3o do JWT s\xe3o inclu\xeddas automaticamente no token e n\xe3o podem ser substitu\xeddas.",
    tester: {
        subtitle: "Ajuste o token simulado e os dados do usu\xe1rio para testar.",
        run_button: "Executar teste",
        result_title: "Resultado do teste"
    },
    form_error: {
        invalid_json: "Formato JSON inv\xe1lido"
    }
};
var $d6388afe697f99ef$export$2e2bcd8739ae039 = Object.freeze($d6388afe697f99ef$var$jwt_claims);


const $0a9fb3d52bf22407$var$log_details = {
    page_title: "Detalhes do registro de auditoria",
    back_to_logs: "Voltar para registros",
    back_to: "Voltar para {{name}}",
    success: "Sucesso",
    failed: "Falhou",
    event_key: "Chave do evento",
    application: "Aplicativo",
    ip_address: "Endere\xe7o de IP",
    user: "Usu\xe1rio",
    log_id: "ID do registro",
    time: "Tempo",
    user_agent: "Agente do usu\xe1rio",
    tab_details: "Detalhes",
    raw_data: "Dados completos"
};
var $0a9fb3d52bf22407$export$2e2bcd8739ae039 = Object.freeze($0a9fb3d52bf22407$var$log_details);


const $158fa9935f408042$var$logs = {
    page_title: "Audit logs",
    title: "Audit logs",
    subtitle: "Visualize os dados de log dos eventos de autentica\xe7\xe3o feitos por seu administrador e usu\xe1rios",
    event: "Evento",
    user: "Usu\xe1rio",
    application: "Aplicativo",
    time: "Tempo",
    filter_by: "Filtrar por"
};
var $158fa9935f408042$export$2e2bcd8739ae039 = Object.freeze($158fa9935f408042$var$logs);


const $92df6a4348df81df$var$menu = {
    profile: "Perfil",
    language: "Idioma",
    appearance: {
        label: "Apar\xeancia",
        light: "Modo claro",
        dark: "Modo escuro",
        system: "Sincronizar com o sistema"
    },
    sign_out: "Sair"
};
var $92df6a4348df81df$export$2e2bcd8739ae039 = Object.freeze($92df6a4348df81df$var$menu);


const $8b79fd6785f8fa3a$var$mfa = {
    title: "Autentica\xe7\xe3o de m\xfaltipiplos fatores",
    description: "Adicione autentica\xe7\xe3o de m\xfaltiplos fatores para aumentar a seguran\xe7a da sua experi\xeancia de login.",
    factors: "Fatores",
    multi_factors: "M\xfaltiplos fatores",
    multi_factors_description: "Os usu\xe1rios precisam verificar um dos fatores habilitados para verifica\xe7\xe3o em duas etapas.",
    totp: "OTP do aplicativo autenticador",
    otp_description: "Vincule o Google Authenticator, etc., para verificar senhas de uso \xfanico.",
    webauthn: "WebAuthn (Senha)",
    webauthn_description: "Verifique via m\xe9todo suportado pelo navegador: biometria, digitaliza\xe7\xe3o de telefone ou chave de seguran\xe7a, etc.",
    webauthn_native_tip: "O WebAuthn n\xe3o \xe9 suportado para aplicativos nativos.",
    webauthn_domain_tip: "O WebAuthn vincula chaves p\xfablicas ao dom\xednio espec\xedfico. Modificar o dom\xednio do servi\xe7o bloquear\xe1 os usu\xe1rios de autenticar atrav\xe9s das senhas existentes.",
    backup_code: "C\xf3digo de backup",
    backup_code_description: "Gere 10 c\xf3digos de backup \xfanicos ap\xf3s os usu\xe1rios configurarem qualquer m\xe9todo MFA.",
    backup_code_setup_hint: "Quando os usu\xe1rios n\xe3o puderem verificar os fatores MFA acima, use a op\xe7\xe3o de backup.",
    backup_code_error_hint: "Para usar um c\xf3digo de backup, voc\xea precisa de pelo menos mais um m\xe9todo MFA para autentica\xe7\xe3o bem-sucedida do usu\xe1rio.",
    policy: "Pol\xedtica",
    policy_description: "Defina a pol\xedtica MFA para fluxos de login e inscri\xe7\xe3o.",
    two_step_sign_in_policy: "Pol\xedtica de verifica\xe7\xe3o em duas etapas no login",
    user_controlled: "Os usu\xe1rios podem habilitar ou desabilitar o MFA por conta pr\xf3pria",
    user_controlled_tip: "Os usu\xe1rios podem pular a configura\xe7\xe3o do MFA na primeira vez do login ou inscri\xe7\xe3o, ou habilitar/desabilitar nas configura\xe7\xf5es da conta.",
    mandatory: "Os usu\xe1rios sempre precisam usar o MFA no login",
    mandatory_tip: "Os usu\xe1rios devem configurar o MFA na primeira vez do login ou inscri\xe7\xe3o e us\xe1-lo em todos os logins futuros."
};
var $8b79fd6785f8fa3a$export$2e2bcd8739ae039 = Object.freeze($8b79fd6785f8fa3a$var$mfa);


const $74755dc2bd7d2338$var$organization_details = {
    page_title: "Detalhes da organiza\xe7\xe3o",
    delete_confirmation: "Uma vez exclu\xedda, todos os membros perder\xe3o sua associa\xe7\xe3o e cargos nesta organiza\xe7\xe3o. Essa a\xe7\xe3o n\xe3o pode ser desfeita.",
    organization_id: "ID da organiza\xe7\xe3o",
    settings_description: "Organiza\xe7\xf5es representam as equipes, clientes empresariais e empresas parceiras que podem acessar suas aplica\xe7\xf5es.",
    name_placeholder: "O nome da organiza\xe7\xe3o, n\xe3o \xe9 necess\xe1rio ser \xfanico.",
    description_placeholder: "Uma descri\xe7\xe3o da organiza\xe7\xe3o.",
    member: "Membro",
    member_other: "Membros",
    add_members_to_organization: "Adicionar membros \xe0 organiza\xe7\xe3o {{name}}",
    add_members_to_organization_description: "Encontre usu\xe1rios apropriados pesquisando nome, e-mail, telefone ou ID do usu\xe1rio. Membros existentes n\xe3o s\xe3o mostrados nos resultados da pesquisa.",
    add_with_organization_role: "Adicionar com fun\xe7\xe3o(\xf5es) na organiza\xe7\xe3o",
    user: "Usu\xe1rio",
    authorize_to_roles: "Autorizar {{name}} a acessar os seguintes cargos:",
    edit_organization_roles: "Editar cargos da organiza\xe7\xe3o",
    edit_organization_roles_of_user: "Editar cargos da organiza\xe7\xe3o de {{name}}",
    remove_user_from_organization: "Remover usu\xe1rio da organiza\xe7\xe3o",
    remove_user_from_organization_description: "Uma vez removido, o usu\xe1rio perder\xe1 sua associa\xe7\xe3o e cargos nesta organiza\xe7\xe3o. Essa a\xe7\xe3o n\xe3o pode ser desfeita.",
    search_user_placeholder: "Pesquisar por nome, e-mail, telefone ou ID do usu\xe1rio",
    at_least_one_user: "Pelo menos um usu\xe1rio \xe9 necess\xe1rio.",
    custom_data: "Dados personalizados",
    custom_data_tip: "Dados personalizados \xe9 um objeto JSON que pode ser usado para armazenar dados adicionais associados \xe0 organiza\xe7\xe3o.",
    invalid_json_object: "Objeto JSON inv\xe1lido."
};
var $74755dc2bd7d2338$export$2e2bcd8739ae039 = Object.freeze($74755dc2bd7d2338$var$organization_details);


const $7a688219d5468ed3$var$organization_role_details = {
    page_title: "Detalhes da fun\xe7\xe3o da organiza\xe7\xe3o",
    back_to_org_roles: "Voltar para os pap\xe9is da organiza\xe7\xe3o",
    org_role: "Fun\xe7\xe3o da organiza\xe7\xe3o",
    delete_confirm: "Ao fazer isso, os privil\xe9gios associados a esta fun\xe7\xe3o ser\xe3o removidos dos usu\xe1rios afetados e as rela\xe7\xf5es entre fun\xe7\xf5es da organiza\xe7\xe3o, membros na organiza\xe7\xe3o e permiss\xf5es da organiza\xe7\xe3o ser\xe3o exclu\xeddas.",
    deleted: "O papel da organiza\xe7\xe3o {{name}} foi exclu\xeddo com sucesso.",
    permissions: {
        tab: "Permiss\xf5es",
        name_column: "Permiss\xe3o",
        description_column: "Descri\xe7\xe3o",
        type_column: "Tipo de permiss\xe3o",
        type: {
            api: "Permiss\xe3o da API",
            org: "Permiss\xe3o da organiza\xe7\xe3o"
        },
        assign_permissions: "Atribuir permiss\xf5es",
        remove_permission: "Remover permiss\xe3o",
        remove_confirmation: "Se esta permiss\xe3o for removida, o usu\xe1rio com essa fun\xe7\xe3o organizacional perder\xe1 o acesso concedido por esta permiss\xe3o.",
        removed: "A permiss\xe3o {{name}} foi removida com sucesso desta fun\xe7\xe3o organizacional",
        assign_description: "Atribua permiss\xf5es aos pap\xe9is dentro desta organiza\xe7\xe3o. Estas podem incluir tanto permiss\xf5es de organiza\xe7\xe3o quanto permiss\xf5es de API.",
        organization_permissions: "Permiss\xf5es de organiza\xe7\xe3o",
        api_permissions: "Permiss\xf5es de API",
        assign_organization_permissions: "Atribuir permiss\xf5es de organiza\xe7\xe3o",
        assign_api_permissions: "Atribuir permiss\xf5es de API"
    },
    general: {
        tab: "Geral",
        settings: "Configura\xe7\xf5es",
        description: "Fun\xe7\xe3o de organiza\xe7\xe3o \xe9 um agrupamento de permiss\xf5es que podem ser atribu\xeddas aos usu\xe1rios. As permiss\xf5es podem vir das permiss\xf5es de organiza\xe7\xe3o pr\xe9-definidas e permiss\xf5es de API.",
        name_field: "Nome",
        description_field: "Descri\xe7\xe3o",
        description_field_placeholder: "Usu\xe1rios com permiss\xf5es somente de visualiza\xe7\xe3o"
    }
};
var $7a688219d5468ed3$export$2e2bcd8739ae039 = Object.freeze($7a688219d5468ed3$var$organization_role_details);


const $dcb5a970f07f87b3$var$organization_template = {
    title: "Template de organiza\xe7\xe3o",
    subtitle: "Em aplica\xe7\xf5es SaaS multi-inquilino, um template organizacional define pol\xedticas de controle de acesso compartilhado (permiss\xf5es e pap\xe9is) para v\xe1rias organiza\xe7\xf5es.",
    roles: {
        tab_name: "Pap\xe9is da org",
        search_placeholder: "Buscar por nome do papel",
        create_title: "Criar papel da org",
        role_column: "Papel da org",
        permissions_column: "Permiss\xf5es",
        placeholder_title: "Papel da organiza\xe7\xe3o",
        placeholder_description: "Papel da organiza\xe7\xe3o \xe9 um agrupamento de permiss\xf5es que podem ser atribu\xeddas aos usu\xe1rios. As permiss\xf5es devem vir das permiss\xf5es organizacionais predefinidas.",
        create_modal: {
            title: "Criar fun\xe7\xe3o da organiza\xe7\xe3o",
            create: "Criar fun\xe7\xe3o",
            name_field: "Nome da fun\xe7\xe3o",
            description_field: "Descri\xe7\xe3o",
            created: "A fun\xe7\xe3o da organiza\xe7\xe3o {{name}} foi criada com sucesso."
        }
    },
    permissions: {
        tab_name: "Permiss\xf5es da org",
        search_placeholder: "Buscar por nome da permiss\xe3o",
        create_org_permission: "Criar permiss\xe3o da org",
        permission_column: "Permiss\xe3o da organiza\xe7\xe3o",
        description_column: "Descri\xe7\xe3o",
        placeholder_title: "Permiss\xe3o da organiza\xe7\xe3o",
        placeholder_description: "Permiss\xe3o da organiza\xe7\xe3o refere-se \xe0 autoriza\xe7\xe3o para acessar um recurso no contexto da organiza\xe7\xe3o.",
        delete_confirm: "Se esta permiss\xe3o for deletada, todos os pap\xe9is da organiza\xe7\xe3o que inclu\xedrem esta permiss\xe3o perder\xe3o a mesma, e usu\xe1rios que tinham esta permiss\xe3o perder\xe3o o acesso concedido por ela.",
        create_title: "Criar permiss\xe3o de organiza\xe7\xe3o",
        edit_title: "Editar permiss\xe3o de organiza\xe7\xe3o",
        permission_field_name: "Nome da permiss\xe3o",
        description_field_name: "Descri\xe7\xe3o",
        description_field_placeholder: "Ler hist\xf3rico de compromissos",
        create_permission: "Criar permiss\xe3o",
        created: "A permiss\xe3o de organiza\xe7\xe3o {{name}} foi criada com sucesso."
    }
};
var $dcb5a970f07f87b3$export$2e2bcd8739ae039 = Object.freeze($dcb5a970f07f87b3$var$organization_template);


const $4510f26c956f1e83$var$organizations = {
    organization: "Organiza\xe7\xe3o",
    page_title: "Organiza\xe7\xf5es",
    title: "Organiza\xe7\xf5es",
    subtitle: "Organiza\xe7\xf5es s\xe3o normalmente utilizadas em aplicativos SaaS ou aplicativos semelhantes de v\xe1rios inquilinos e representam seus clientes que s\xe3o equipes, organiza\xe7\xf5es ou empresas inteiras. Organiza\xe7\xf5es funcionam como um elemento fundamental para autentica\xe7\xe3o e autoriza\xe7\xe3o B2B.",
    organization_template: "Modelo de organiza\xe7\xe3o",
    organization_id: "ID da organiza\xe7\xe3o",
    members: "Membros",
    create_organization: "Criar organiza\xe7\xe3o",
    setup_organization: "Configurar sua organiza\xe7\xe3o",
    organization_list_placeholder_title: "Organiza\xe7\xe3o",
    organization_list_placeholder_text: "Organiza\xe7\xf5es s\xe3o frequentemente usadas em aplicativos SaaS ou aplicativos semelhantes de v\xe1rios inquilinos como uma pr\xe1tica recomendada. Elas permitem que voc\xea desenvolva aplicativos que permitem aos clientes criar e gerenciar organiza\xe7\xf5es, convidar membros e atribuir fun\xe7\xf5es.",
    organization_name_placeholder: "Minha organiza\xe7\xe3o",
    organization_description_placeholder: "Uma breve descri\xe7\xe3o da organiza\xe7\xe3o",
    organization_permission: "Permiss\xe3o da organiza\xe7\xe3o",
    organization_permission_other: "Permiss\xf5es da organiza\xe7\xe3o",
    create_permission_placeholder: "Ler hist\xf3rico de compromissos",
    organization_role: "Papel da organiza\xe7\xe3o",
    organization_role_other: "Pap\xe9is da organiza\xe7\xe3o",
    organization_role_description: "O papel da organiza\xe7\xe3o \xe9 um agrupamento de permiss\xf5es que podem ser atribu\xeddas aos usu\xe1rios. As permiss\xf5es devem vir das permiss\xf5es de organiza\xe7\xe3o predefinidas.",
    role: "Fun\xe7\xe3o",
    search_placeholder: "Pesquisar por nome ou ID da organiza\xe7\xe3o",
    search_role_placeholder: "Digite para pesquisar e selecionar fun\xe7\xf5es",
    empty_placeholder: "\uD83E\uDD14 Voc\xea ainda n\xe3o configurou nenhum {{entity}}.",
    organization_and_member: "Organiza\xe7\xe3o e membro",
    organization_and_member_description: 'A organiza\xe7\xe3o \xe9 um grupo de usu\xe1rios e pode representar as equipes, clientes comerciais e empresas parceiras, sendo que cada usu\xe1rio \xe9 um "Membro".  Esses podem ser entidades fundamentais para lidar com seus requisitos de multi-inquilino.',
    guide: {
        title: "Comece com guias",
        subtitle: "Inicie as configura\xe7\xf5es da sua organiza\xe7\xe3o com nossos guias",
        introduction: {
            title: "Vamos entender como a organiza\xe7\xe3o funciona no Logto",
            section_1: {
                title: "Uma organiza\xe7\xe3o \xe9 um grupo de usu\xe1rios (identidades)"
            },
            section_2: {
                title: "O modelo de organiza\xe7\xe3o \xe9 projetado para controle de acesso de aplicativos multi-inquilino",
                description: 'Em aplicativos SaaS multi-inquilino, v\xe1rias organiza\xe7\xf5es frequentemente compartilham o mesmo modelo de controle de acesso, que inclui permiss\xf5es e pap\xe9is. No Logto, chamamos isso de "modelo de organiza\xe7\xe3o".',
                permission_description: "A permiss\xe3o da organiza\xe7\xe3o refere-se \xe0 autoriza\xe7\xe3o para acessar um recurso no contexto da organiza\xe7\xe3o.",
                role_description_deprecated: "O papel da organiza\xe7\xe3o \xe9 um agrupamento de permiss\xf5es da organiza\xe7\xe3o que podem ser atribu\xeddas aos membros.",
                role_description: "A fun\xe7\xe3o da organiza\xe7\xe3o \xe9 um agrupamento de permiss\xf5es da organiza\xe7\xe3o ou permiss\xf5es de API que podem ser atribu\xeddas aos membros."
            },
            section_3: {
                title: "Posso atribuir permiss\xf5es de API a fun\xe7\xf5es de organiza\xe7\xe3o?",
                description: "Sim, voc\xea pode atribuir permiss\xf5es de API a fun\xe7\xf5es de organiza\xe7\xe3o. A Logto oferece flexibilidade para gerenciar as fun\xe7\xf5es da sua organiza\xe7\xe3o de forma eficaz, permitindo que voc\xea inclua tanto as permiss\xf5es da organiza\xe7\xe3o quanto as permiss\xf5es de API nessas fun\xe7\xf5es."
            },
            section_4: {
                title: "Interaja com a ilustra\xe7\xe3o para ver como tudo se conecta",
                description: "Vamos dar um exemplo. John, Sarah est\xe3o em diferentes organiza\xe7\xf5es com diferentes pap\xe9is no contexto de organiza\xe7\xf5es diferentes. Passe o mouse sobre os diferentes m\xf3dulos e veja o que acontece."
            }
        },
        organization_permissions: "Permiss\xf5es da organiza\xe7\xe3o",
        organization_roles: "Pap\xe9is da organiza\xe7\xe3o",
        admin: "Administrador",
        member: "Membro",
        guest: "Convidado",
        role_description: 'O papel "{{role}}" compartilha o mesmo modelo de organiza\xe7\xe3o em diferentes organiza\xe7\xf5es.',
        john: "John",
        john_tip: 'John pertence a duas organiza\xe7\xf5es com o email "john@email.com" como \xfanico identificador. Ele \xe9 o administrador da organiza\xe7\xe3o A, bem como o convidado da organiza\xe7\xe3o B.',
        sarah: "Sarah",
        sarah_tip: 'Sarah pertence a uma organiza\xe7\xe3o com o email "sarah@email.com" como \xfanico identificador. Ela \xe9 a administradora da organiza\xe7\xe3o B.'
    }
};
var $4510f26c956f1e83$export$2e2bcd8739ae039 = Object.freeze($4510f26c956f1e83$var$organizations);


const $edd93ac01b3e6dcd$var$permissions = {
    search_placeholder: "Procurar por nome de API ou permiss\xe3o",
    search_placeholder_without_api: "Procurar por nome de permiss\xe3o",
    name_column: "Permiss\xe3o",
    description_column: "Descri\xe7\xe3o",
    api_column: "API",
    placeholder_title: "Permiss\xe3o",
    placeholder_description: "Permiss\xe3o refere-se \xe0 autoriza\xe7\xe3o para acessar um recurso (chamamos de recurso de API).",
    edit: "Permiss\xe3o de edi\xe7\xe3o",
    delete: "Permiss\xe3o de exclus\xe3o",
    remove: "Permiss\xe3o de remo\xe7\xe3o",
    edit_title: "Editar permiss\xe3o de API"
};
var $edd93ac01b3e6dcd$export$2e2bcd8739ae039 = Object.freeze($edd93ac01b3e6dcd$var$permissions);


const $8e16c88a5e3df8d7$var$profile = {
    page_title: "Configura\xe7\xf5es da conta",
    title: "Configura\xe7\xf5es da conta",
    description: "Altere suas configura\xe7\xf5es de conta e gerencie suas informa\xe7\xf5es pessoais aqui para garantir a seguran\xe7a da sua conta.",
    settings: {
        title: "CONFIGURA\xc7\xd5ES DO PERFIL",
        profile_information: "Informa\xe7\xf5es do perfil",
        avatar: "Avatar",
        name: "Nome",
        username: "Nome de usu\xe1rio"
    },
    link_account: {
        title: "LINKAR CONTA",
        email_sign_in: "Login por e-mail",
        email: "E-mail",
        social_sign_in: "Login social",
        link_email: "Vincular e-mail",
        link_email_subtitle: "Vincule seu e-mail para fazer login ou ajudar na recupera\xe7\xe3o da conta.",
        email_required: "E-mail obrigat\xf3rio",
        invalid_email: "Endere\xe7o de e-mail inv\xe1lido",
        identical_email_address: "O endere\xe7o de e-mail inserido \xe9 id\xeantico ao atual",
        anonymous: "An\xf4nimo"
    },
    password: {
        title: "SENHA E SEGURAN\xc7A",
        password: "Senha",
        password_setting: "Configura\xe7\xe3o de senha",
        new_password: "Nova senha",
        confirm_password: "Confirme a senha",
        enter_password: "Digite a senha atual",
        enter_password_subtitle: "Verifique se \xe9 voc\xea para proteger a seguran\xe7a da sua conta. Por favor, digite sua senha atual antes de alter\xe1-la.",
        set_password: "Definir senha",
        verify_via_password: "Verificar via senha",
        show_password: "Mostrar senha",
        required: "Senha obrigat\xf3ria",
        do_not_match: "As senhas n\xe3o coincidem. Tente novamente."
    },
    code: {
        enter_verification_code: "Digite o c\xf3digo de verifica\xe7\xe3o",
        enter_verification_code_subtitle: "O c\xf3digo de verifica\xe7\xe3o foi enviado para <strong>{{target}}</strong>",
        verify_via_code: "Verificar via c\xf3digo de verifica\xe7\xe3o",
        resend: "Reenviar c\xf3digo de verifica\xe7\xe3o",
        resend_countdown: "Reenviar em {{countdown}} segundos"
    },
    delete_account: {
        title: "EXCLUIR CONTA",
        label: "Excluir conta",
        description: "Excluir sua conta remover\xe1 todas as suas informa\xe7\xf5es pessoais, dados do usu\xe1rio e configura\xe7\xf5es. Essa a\xe7\xe3o n\xe3o pode ser desfeita.",
        button: "Excluir conta",
        dialog_paragraph_1: "Lamentamos saber que voc\xea deseja excluir sua conta. A exclus\xe3o de sua conta remover\xe1 permanentemente todos os dados, incluindo informa\xe7\xf5es do usu\xe1rio, logs e configura\xe7\xf5es, e essa a\xe7\xe3o n\xe3o pode ser desfeita. Portanto, certifique-se de fazer backup de qualquer dado importante antes de prosseguir.",
        dialog_paragraph_2: 'Para prosseguir com o processo de exclus\xe3o de conta, envie um e-mail para nossa equipe de suporte em <a>mail</a> com o assunto "Pedido de exclus\xe3o de conta". N\xf3s o ajudaremos e garantiremos que todos os seus dados sejam exclu\xeddos corretamente de nosso sistema.',
        dialog_paragraph_3: "Agradecemos por escolher o Logto Cloud. Se voc\xea tiver outras d\xfavidas ou preocupa\xe7\xf5es, n\xe3o hesite em nos contatar."
    },
    set: "Configurar",
    change: "Alterar",
    link: "Linkar",
    unlink: "Deslinkar",
    not_set: "N\xe3o definido",
    change_avatar: "Alterar avatar",
    change_name: "Alterar nome",
    change_username: "Alterar nome de usu\xe1rio",
    set_name: "Definir nome",
    email_changed: "E-mail alterado.",
    password_changed: "Senha alterada.",
    updated: "{{target}} atualizado.",
    linked: "{{target}} conectada.",
    unlinked: "{{target}} desconectada.",
    email_exists_reminder: "Este e-mail {{email}} est\xe1 associado a uma conta existente. Vincule outro e-mail aqui.",
    unlink_confirm_text: "Sim, deslinkar",
    unlink_reminder: "Os usu\xe1rios n\xe3o poder\xe3o fazer login com a conta <span></span> se voc\xea deslink\xe1-la. Tem certeza de que deseja prosseguir?"
};
var $8e16c88a5e3df8d7$export$2e2bcd8739ae039 = Object.freeze($8e16c88a5e3df8d7$var$profile);


const $27af751e543aa0f0$var$protected_app = {
    name: "Aplicativo Protegido",
    title: "Crie um Aplicativo Protegido: Adicione autentica\xe7\xe3o com simplicidade e velocidade incr\xedvel",
    description: "O Aplicativo Protegido mant\xe9m sess\xf5es de usu\xe1rios de forma segura e encaminha as solicita\xe7\xf5es do seu aplicativo. Potencializado pelos Cloudflare Workers, desfrute do desempenho de alto n\xedvel e in\xedcio instant\xe2neo de 0ms em todo o mundo. <a> Aprenda mais </a>",
    fast_create: "Cria\xe7\xe3o r\xe1pida",
    modal_title: "Criar Aplicativo Protegido",
    modal_subtitle: "Ative a prote\xe7\xe3o segura e r\xe1pida com alguns cliques. Adicione autentica\xe7\xe3o ao seu aplicativo web existente com facilidade.",
    form: {
        url_field_label: "Seu URL de origem",
        url_field_placeholder: "https://dominio.com/",
        url_field_description: "Informe o endere\xe7o do seu aplicativo que requer prote\xe7\xe3o de autentica\xe7\xe3o.",
        url_field_modification_notice: "As modifica\xe7\xf5es no URL de origem podem levar de 1 a 2 minutos para se tornarem efetivas em todas as localiza\xe7\xf5es da rede global.",
        url_field_tooltip: "Forne\xe7a o endere\xe7o da sua aplica\xe7\xe3o, excluindo '/caminho'. Ap\xf3s a cria\xe7\xe3o, voc\xea pode personalizar as regras de autentica\xe7\xe3o da rota.\n\nNota: O URL de origem em si n\xe3o exige autentica\xe7\xe3o; a prote\xe7\xe3o \xe9 aplicada exclusivamente aos acessos por meio do dom\xednio do aplicativo designado.",
        domain_field_label: "Dom\xednio do aplicativo",
        domain_field_placeholder: "seu-dom\xednio",
        domain_field_description: "Este URL funciona como um proxy de prote\xe7\xe3o de autentica\xe7\xe3o para o URL original. Dom\xednio personalizado pode ser aplicado ap\xf3s a cria\xe7\xe3o.",
        domain_field_description_short: "Este URL funciona como um proxy de prote\xe7\xe3o de autentica\xe7\xe3o para o URL original.",
        domain_field_tooltip: "Aplicativos protegidos pela Logto ser\xe3o hospedados em 'seu-dom\xednio.{{domain}}' por padr\xe3o. Dom\xednio personalizado pode ser aplicado ap\xf3s a cria\xe7\xe3o.",
        create_application: "Criar aplicativo",
        create_protected_app: "Cria\xe7\xe3o r\xe1pida",
        errors: {
            domain_required: "O seu dom\xednio \xe9 obrigat\xf3rio.",
            domain_in_use: "Este nome de subdom\xednio j\xe1 est\xe1 em uso.",
            invalid_domain_format: "Formato de subdom\xednio inv\xe1lido: use apenas letras min\xfasculas, n\xfameros e h\xedfens '-'.",
            url_required: "O URL de origem \xe9 obrigat\xf3rio.",
            invalid_url: "Formato de URL de origem inv\xe1lido: Use http:// ou https://. Observa\xe7\xe3o: '/caminho' n\xe3o \xe9 suportado atualmente.",
            localhost: "Por favor, exponha seu servidor local para a Internet primeiro. Saiba mais sobre o <a> desenvolvimento local </a>."
        }
    },
    success_message: "\uD83C\uDF89 Autentica\xe7\xe3o de aplicativo habilitada com sucesso! Explore a nova experi\xeancia do seu site."
};
var $27af751e543aa0f0$export$2e2bcd8739ae039 = Object.freeze($27af751e543aa0f0$var$protected_app);


const $63df4373eafb12c0$var$role_details = {
    back_to_roles: "Voltar para os Pap\xe9is",
    identifier: "Identificador",
    delete_description: "Faz\xea-lo remover\xe1 as permiss\xf5es associadas a este papel dos usu\xe1rios afetados e excluir\xe1 o mapeamento entre pap\xe9is, usu\xe1rios e permiss\xf5es.",
    role_deleted: "{{name}} foi exclu\xeddo com sucesso.",
    general_tab: "Geral",
    users_tab: "Usu\xe1rios",
    m2m_apps_tab: "Aplicativos m\xe1quina-a-m\xe1quina",
    permissions_tab: "Permiss\xf5es",
    settings: "Configura\xe7\xf5es",
    settings_description: "Os pap\xe9is s\xe3o um agrupamento de permiss\xf5es que podem ser atribu\xeddas a usu\xe1rios. Eles tamb\xe9m fornecem uma maneira de agregar permiss\xf5es definidas para diferentes APIs, tornando mais eficiente a adi\xe7\xe3o, remo\xe7\xe3o ou ajuste de permiss\xf5es em compara\xe7\xe3o com a atribui\xe7\xe3o individual a usu\xe1rios.",
    field_name: "Nome",
    field_description: "Descri\xe7\xe3o",
    field_is_default: "Fun\xe7\xe3o padr\xe3o",
    field_is_default_description: "Defina este papel como um papel padr\xe3o para novos usu\xe1rios. V\xe1rios pap\xe9is padr\xe3o podem ser definidos. Isso tamb\xe9m afetar\xe1 os pap\xe9is padr\xe3o para usu\xe1rios criados via API de Gerenciamento.",
    type_m2m_role_tag: "Fun\xe7\xe3o de aplicativo m\xe1quina-a-m\xe1quina",
    type_user_role_tag: "Fun\xe7\xe3o de usu\xe1rio",
    m2m_role_notification: "Atribua essa fun\xe7\xe3o de m\xe1quina para m\xe1quina a um aplicativo de m\xe1quina para m\xe1quina para conceder acesso aos recursos de API relativos. <a>Crie primeiro um aplicativo de m\xe1quina para m\xe1quina</a> se ainda n\xe3o o fez.",
    permission: {
        assign_button: "Atribuir permiss\xf5es",
        assign_title: "Atribuir permiss\xf5es",
        assign_subtitle: "Atribua permiss\xf5es a este papel. O papel adquirir\xe1 as permiss\xf5es adicionadas e os usu\xe1rios com este papel herdar\xe3o essas permiss\xf5es.",
        assign_form_field: "Atribuir permiss\xf5es",
        added_text_one: "{{count, number}} permiss\xe3o adicionada",
        added_text_other: "{{count, number}} permiss\xf5es adicionadas",
        api_permission_count_one: "{{count, number}} permiss\xe3o",
        api_permission_count_other: "{{count, number}} permiss\xf5es",
        confirm_assign: "Atribuir permiss\xf5es",
        permission_assigned: "As permiss\xf5es selecionadas foram atribu\xeddas com sucesso a este papel",
        deletion_description: "Se esta permiss\xe3o for removida, o usu\xe1rio afetado com este papel perder\xe1 o acesso concedido por esta permiss\xe3o.",
        permission_deleted: 'A permiss\xe3o "{{name}}" foi removida com sucesso deste papel',
        empty: "Nenhuma permiss\xe3o dispon\xedvel"
    },
    users: {
        assign_button: "Atribuir usu\xe1rios",
        name_column: "Usu\xe1rio",
        app_column: "Aplicativo",
        latest_sign_in_column: "\xdaltimo acesso",
        delete_description: "Ele permanecer\xe1 no seu pool de usu\xe1rios, mas perder\xe1 a autoriza\xe7\xe3o para este papel.",
        deleted: "{{name}} foi removido com sucesso deste papel",
        assign_title: "Atribuir usu\xe1rios",
        assign_subtitle: "Atribuir usu\xe1rios a este papel. Encontre usu\xe1rios adequados pesquisando nome, e-mail, telefone ou ID do usu\xe1rio.",
        assign_field: "Atribuir usu\xe1rios",
        confirm_assign: "Atribuir usu\xe1rios",
        assigned_toast_text: "Os usu\xe1rios selecionados foram atribu\xeddos com sucesso a este papel",
        empty: "Nenhum usu\xe1rio dispon\xedvel"
    },
    applications: {
        assign_button: "Atribuir aplicativos",
        name_column: "Aplicativo",
        app_column: "Aplicativos",
        description_column: "Descri\xe7\xe3o",
        delete_description: "Ele permanecer\xe1 em seu pool de aplicativos, mas perder\xe1 a autoriza\xe7\xe3o para este papel.",
        deleted: "{{name}} foi removido com sucesso deste papel",
        assign_title: "Atribuir aplicativos",
        assign_subtitle: "Atribuir aplicativos a este papel. Encontre os aplicativos adequados pesquisando por nome, descri\xe7\xe3o ou ID do aplicativo.",
        assign_field: "Atribuir aplicativos",
        confirm_assign: "Atribuir aplicativos",
        assigned_toast_text: "Os aplicativos selecionados foram atribu\xeddos com sucesso a este papel",
        empty: "Nenhum aplicativo dispon\xedvel"
    }
};
var $63df4373eafb12c0$export$2e2bcd8739ae039 = Object.freeze($63df4373eafb12c0$var$role_details);


const $6b2863304ed8dfe2$var$roles = {
    page_title: "T\xedtulos das fun\xe7\xf5es",
    title: "Fun\xe7\xf5es",
    subtitle: "As fun\xe7\xf5es incluem permiss\xf5es que determinam o que um usu\xe1rio pode fazer. O RBAC usa fun\xe7\xf5es para dar aos usu\xe1rios acesso a recursos para a\xe7\xf5es espec\xedficas.",
    create: "Criar fun\xe7\xe3o",
    role_name: "Nome da fun\xe7\xe3o",
    role_type: "Tipo de fun\xe7\xe3o",
    show_role_type_button_text: "Mostrar mais op\xe7\xf5es",
    hide_role_type_button_text: "Esconder mais op\xe7\xf5es",
    type_user: "Fun\xe7\xe3o do usu\xe1rio",
    type_machine_to_machine: "Fun\xe7\xe3o de aplicativo de m\xe1quina para m\xe1quina",
    role_description: "Descri\xe7\xe3o",
    role_name_placeholder: "Insira o nome da sua fun\xe7\xe3o",
    role_description_placeholder: "Insira a descri\xe7\xe3o da sua fun\xe7\xe3o",
    col_roles: "Fun\xe7\xf5es",
    col_type: "Tipo",
    col_description: "Descri\xe7\xe3o",
    col_assigned_entities: "Atribu\xeddo",
    user_counts: "{{count}} usu\xe1rios",
    application_counts: "{{count}} aplicativos",
    user_count: "{{count}} usu\xe1rio",
    application_count: "{{count}} aplicativo",
    assign_permissions: "Atribuir permiss\xf5es",
    create_role_title: "Criar fun\xe7\xe3o",
    create_role_description: "Crie e gerencie fun\xe7\xf5es para suas aplica\xe7\xf5es. As fun\xe7\xf5es cont\xeam cole\xe7\xf5es de permiss\xf5es e podem ser atribu\xeddas a usu\xe1rios.",
    create_role_button: "Criar fun\xe7\xe3o",
    role_created: "A fun\xe7\xe3o {{name}} foi criada com sucesso.",
    search: "Pesquisar pelo nome, descri\xe7\xe3o ou ID da fun\xe7\xe3o",
    placeholder_title: "Fun\xe7\xf5es",
    placeholder_description: "As fun\xe7\xf5es s\xe3o um agrupamento de permiss\xf5es que podem ser atribu\xeddas a usu\xe1rios. Certifique-se de adicionar as permiss\xf5es antes de criar fun\xe7\xf5es.",
    assign_user_roles: "Atribuir fun\xe7\xf5es de usu\xe1rio",
    assign_m2m_roles: "Atribuir fun\xe7\xf5es de m\xe1quina para m\xe1quina",
    management_api_access_notification: "Para acessar a API de gerenciamento do Logto, selecione fun\xe7\xf5es com permiss\xf5es de API de gerenciamento <flag/>.",
    with_management_api_access_tip: "Esta fun\xe7\xe3o de m\xe1quina para m\xe1quina inclui permiss\xf5es para a API de gerenciamento do Logto"
};
var $6b2863304ed8dfe2$export$2e2bcd8739ae039 = Object.freeze($6b2863304ed8dfe2$var$roles);


const $ff8098dc48d8addc$var$session_expired = {
    title: "Sess\xe3o expirada",
    subtitle: "Sua sess\xe3o pode ter expirado e voc\xea foi desconectado. Clique no bot\xe3o abaixo para fazer login no Admin Console novamente.",
    button: "Entrar novamente"
};
var $ff8098dc48d8addc$export$2e2bcd8739ae039 = Object.freeze($ff8098dc48d8addc$var$session_expired);


const $0dcf8bf40ab7aaa1$var$content = {
    terms_of_use: {
        title: "TERMS",
        terms_of_use: "Terms of use URL",
        terms_of_use_placeholder: "https://your.terms.of.use/",
        privacy_policy: "Privacy policy URL",
        privacy_policy_placeholder: "https://your.privacy.policy/"
    },
    languages: {
        title: "LANGUAGES",
        enable_auto_detect: "Enable auto-detect",
        description: "Your software detects the user's locale setting and switches to the local language. You can add new languages by translating UI from English to another language.",
        manage_language: "Manage language",
        default_language: "Default language",
        default_language_description_auto: "The default language will be used when the detected user language isn’t covered in the current language library.",
        default_language_description_fixed: "When auto-detect is off, the default language is the only language your software will show. Turn on auto-detect for language extension."
    },
    manage_language: {
        title: "Manage language",
        subtitle: "Localize the product experience by adding languages and translations. Your contribution can be set as the default language.",
        add_language: "Add Language",
        logto_provided: "Logto provided",
        key: "Key",
        logto_source_values: "Logto source values",
        custom_values: "Custom values",
        clear_all_tip: "Clear all values",
        unsaved_description: "Changes won’t be saved if you leave this page without saving.",
        deletion_tip: "Delete the language",
        deletion_title: "Do you want to delete the added language?",
        deletion_description: "After deletion, your users won’t be able to browse in that language again.",
        default_language_deletion_title: "Default language can’t be deleted.",
        default_language_deletion_description: "{{language}} is set as your default language and can’t be deleted. "
    }
};
var $0dcf8bf40ab7aaa1$export$2e2bcd8739ae039 = Object.freeze($0dcf8bf40ab7aaa1$var$content);


const $9a0a77f8fd15aa18$var$password_policy = {
    password_requirements: "Requisitos de senha",
    minimum_length: "Comprimento m\xednimo",
    minimum_length_description: "O NIST sugere o uso de <a>pelo menos 8 caracteres</a> para produtos na web.",
    minimum_length_error: "O comprimento m\xednimo deve estar entre {{min}} e {{max}} (inclusive).",
    minimum_required_char_types: "Tipos de caracteres m\xednimos necess\xe1rios",
    minimum_required_char_types_description: "Tipos de caracteres: mai\xfasculas (A-Z), min\xfasculas (a-z), n\xfameros (0-9) e s\xedmbolos especiais ({{symbols}}).",
    password_rejection: "Rejei\xe7\xe3o de senha",
    compromised_passwords: "Senhas comprometidas",
    breached_passwords: "Senhas comprometidas",
    breached_passwords_description: "Rejeitar senhas encontradas em bancos de dados de viola\xe7\xf5es anteriores.",
    restricted_phrases: "Restringir frases de baixa seguran\xe7a",
    restricted_phrases_tooltip: "Sua senha deve evitar essas frases, a menos que voc\xea combine com 3 ou mais caracteres extras.",
    repetitive_or_sequential_characters: "Caracteres repetitivos ou sequenciais",
    repetitive_or_sequential_characters_description: 'Por exemplo, "AAAA", "1234" e "abcd".',
    user_information: "Informa\xe7\xf5es do usu\xe1rio",
    user_information_description: "Por exemplo, endere\xe7o de e-mail, n\xfamero de telefone, nome de usu\xe1rio, etc.",
    custom_words: "Palavras personalizadas",
    custom_words_description: "Personalize palavras espec\xedficas do contexto, sem diferencia\xe7\xe3o de mai\xfasculas e min\xfasculas, e uma por linha.",
    custom_words_placeholder: "Nome do seu servi\xe7o, nome da empresa, etc."
};
var $9a0a77f8fd15aa18$export$2e2bcd8739ae039 = Object.freeze($9a0a77f8fd15aa18$var$password_policy);


const $cf1c17823bddc7b1$var$sign_up_and_sign_in = {
    identifiers_email: "Endere\xe7o de e-mail",
    identifiers_phone: "N\xfamero de telefone",
    identifiers_username: "Nome de usu\xe1rio",
    identifiers_email_or_sms: "Endere\xe7o de e-mail ou n\xfamero de telefone",
    identifiers_none: "N\xe3o aplic\xe1vel",
    and: "e",
    or: "ou",
    sign_up: {
        title: "INSCREVER-SE",
        sign_up_identifier: "Identificador de inscri\xe7\xe3o",
        identifier_description: "O identificador de inscri\xe7\xe3o \xe9 necess\xe1rio para a cria\xe7\xe3o da conta e deve ser inclu\xeddo na tela de login.",
        sign_up_authentication: "Configura\xe7\xe3o de autentica\xe7\xe3o para inscri\xe7\xe3o",
        authentication_description: "Todas as a\xe7\xf5es selecionadas ser\xe3o obrigat\xf3rias para os usu\xe1rios completarem o fluxo.",
        set_a_password_option: "Crie sua senha",
        verify_at_sign_up_option: "Visualize na inscri\xe7\xe3o",
        social_only_creation_description: "(Isso se aplica apenas \xe0 cria\xe7\xe3o de contas sociais)"
    },
    sign_in: {
        title: "ENTRAR",
        sign_in_identifier_and_auth: "Configura\xe7\xf5es de identificador e autentica\xe7\xe3o para login",
        description: "Os usu\xe1rios podem entrar usando qualquer uma das op\xe7\xf5es dispon\xedveis. Ajuste o layout arrastando e soltando as op\xe7\xf5es abaixo.",
        add_sign_in_method: "Adicionar m\xe9todo de login",
        password_auth: "Senha",
        verification_code_auth: "C\xf3digo de verifica\xe7\xe3o",
        auth_swap_tip: "Troque as op\xe7\xf5es abaixo para determinar qual aparece primeiro no fluxo.",
        require_auth_factor: "Voc\xea deve selecionar pelo menos um fator de autentica\xe7\xe3o."
    },
    social_sign_in: {
        title: "LOGIN SOCIAL",
        social_sign_in: "Login social",
        description: "Dependendo do identificador obrigat\xf3rio que voc\xea configurou, seu usu\xe1rio pode ser solicitado a fornecer um identificador ao se inscrever via conector social.",
        add_social_connector: "Adicionar Conector Social",
        set_up_hint: {
            not_in_list: "N\xe3o est\xe1 na lista?",
            set_up_more: "Configurar",
            go_to: "outros conectores sociais agora."
        }
    },
    tip: {
        set_a_password: "Um conjunto exclusivo de uma senha para o seu nome de usu\xe1rio \xe9 obrigat\xf3rio.",
        verify_at_sign_up: "No momento, suportamos apenas e-mail verificado. Sua base de usu\xe1rios pode conter um grande n\xfamero de endere\xe7os de e-mail de baixa qualidade se n\xe3o houver valida\xe7\xe3o.",
        password_auth: "Isso \xe9 essencial, pois voc\xea habilitou a op\xe7\xe3o de definir uma senha durante o processo de inscri\xe7\xe3o.",
        verification_code_auth: "Isso \xe9 essencial, pois voc\xea habilitou apenas a op\xe7\xe3o de fornecer o c\xf3digo de verifica\xe7\xe3o ao se inscrever. Voc\xea pode desmarcar a caixa quando a configura\xe7\xe3o de senha for permitida no processo de inscri\xe7\xe3o.",
        delete_sign_in_method: "Isso \xe9 essencial, pois voc\xea selecionou {{identifier}} como um identificador obrigat\xf3rio."
    },
    advanced_options: {
        title: "OP\xc7\xd5ES AVAN\xc7ADAS",
        enable_single_sign_on: "Habilitar logon \xfanico corporativo (SSO)",
        enable_single_sign_on_description: "Habilitar usu\xe1rios a acessar o aplicativo usando o logon \xfanico com suas identidades empresariais.",
        single_sign_on_hint: {
            prefix: "Acesse ",
            link: '"Enterprise SSO"',
            suffix: " para configurar mais conectores corporativos."
        },
        enable_user_registration: "Habilitar registro de usu\xe1rio",
        enable_user_registration_description: "Habilitar ou desabilitar o registro de usu\xe1rios. Depois de desabilitado, os usu\xe1rios ainda podem ser adicionados no console de administra\xe7\xe3o, mas os usu\xe1rios n\xe3o poder\xe3o mais criar contas atrav\xe9s da interface de login."
    }
};
var $cf1c17823bddc7b1$export$2e2bcd8739ae039 = Object.freeze($cf1c17823bddc7b1$var$sign_up_and_sign_in);


const $220604ad58f200b1$var$sign_in_exp = {
    page_title: "Experi\xeancia de login",
    title: "Experi\xeancia de login",
    description: "Personalize a interface do usu\xe1rio de login para corresponder \xe0 sua marca e visualize em tempo real",
    tabs: {
        branding: "Marca",
        sign_up_and_sign_in: "Inscreva-se e fa\xe7a login",
        content: "Conte\xfado",
        password_policy: "Pol\xedtica de senhas"
    },
    welcome: {
        title: "Personalize a experi\xeancia de login",
        description: "Comece rapidamente com a configura\xe7\xe3o do seu primeiro login. Este guia o acompanhar\xe1 em todas as configura\xe7\xf5es necess\xe1rias.",
        get_started: "Come\xe7ar",
        apply_remind: "Observe que a experi\xeancia de login ser\xe1 aplicada a todos os aplicativos nesta conta."
    },
    color: {
        title: "COR",
        primary_color: "Cor da marca",
        dark_primary_color: "Cor da marca (Escuro)",
        dark_mode: "Ativar modo escuro",
        dark_mode_description: "Seu aplicativo ter\xe1 um tema de modo escuro gerado automaticamente com base na cor da sua marca e no algoritmo Logto. Voc\xea \xe9 livre para personalizar.",
        dark_mode_reset_tip: "Recalcule a cor do modo escuro com base na cor da marca.",
        reset: "Recalcular"
    },
    branding: {
        title: "\xc1REA DE MARCA",
        ui_style: "Estilo",
        favicon: "Favicon",
        logo_image_url: "URL da imagem do logotipo do aplicativo",
        logo_image_url_placeholder: "https://your.cdn.domain/logo.png",
        dark_logo_image_url: "URL da imagem do logotipo do aplicativo (Escuro)",
        dark_logo_image_url_placeholder: "https://your.cdn.domain/logo-dark.png",
        logo_image: "Logotipo do aplicativo",
        dark_logo_image: "Logotipo do aplicativo (Escuro)",
        logo_image_error: "Logotipo do aplicativo: {{error}}",
        favicon_error: "Favicon: {{error}}"
    },
    custom_css: {
        title: "CSS personalizado",
        css_code_editor_title: "Personalize sua UI com CSS personalizado",
        css_code_editor_description1: "Veja o exemplo de CSS personalizado.",
        css_code_editor_description2: "<a>{{link}}</a>",
        css_code_editor_description_link_content: "Saiba mais",
        css_code_editor_content_placeholder: "Digite seu CSS personalizado para personalizar os estilos de qualquer coisa de acordo com suas especifica\xe7\xf5es exatas. Expresse sua criatividade e fa\xe7a sua IU se destacar."
    },
    sign_up_and_sign_in: $cf1c17823bddc7b1$export$2e2bcd8739ae039,
    content: $0dcf8bf40ab7aaa1$export$2e2bcd8739ae039,
    password_policy: $9a0a77f8fd15aa18$export$2e2bcd8739ae039,
    setup_warning: {
        no_connector_sms: 'Nenhum conector SMS configurado ainda. At\xe9 terminar de configurar seu conector SMS, seus usu\xe1rios n\xe3o poder\xe3o fazer login. <a>{{link}}</a> em "Conectores"',
        no_connector_email: 'Nenhum conector de e-mail configurado ainda. At\xe9 terminar de configurar seu conector de e-mail, seus usu\xe1rios n\xe3o poder\xe3o fazer login. <a>{{link}}</a> em "Conectores"',
        no_connector_social: 'Voc\xea ainda n\xe3o configurou nenhum conector social. Adicione conectores primeiro para aplicar m\xe9todos de login social. <a>{{link}}</a> em "Conectores".',
        setup_link: "Configurar"
    },
    save_alert: {
        description: "Voc\xea est\xe1 implementando novos procedimentos de entrada e inscri\xe7\xe3o. Todos os seus usu\xe1rios podem ser afetados pela nova configura\xe7\xe3o. Tem certeza de se comprometer com a mudan\xe7a?",
        before: "Antes",
        after: "Depois",
        sign_up: "Inscrever-se",
        sign_in: "Entrar",
        social: "Social"
    },
    preview: {
        title: "Visualiza\xe7\xe3o de login",
        live_preview: "Visualiza\xe7\xe3o em tempo real",
        live_preview_tip: "Salve para visualizar as altera\xe7\xf5es",
        native: "Nativo",
        desktop_web: "Web Desktop",
        mobile_web: "Web Mobile",
        desktop: "\xc1rea de trabalho",
        mobile: "M\xf3vel"
    }
};
var $220604ad58f200b1$export$2e2bcd8739ae039 = Object.freeze($220604ad58f200b1$var$sign_in_exp);


const $b476870cdbe98a47$var$signing_keys = {
    title: "Chaves de assinatura",
    description: "Gerencie com seguran\xe7a as chaves de assinatura usadas por suas aplica\xe7\xf5es.",
    private_key: "Chaves privadas OIDC",
    private_keys_description: "As chaves privadas OIDC s\xe3o usadas para assinar tokens JWT.",
    cookie_key: "Chaves de cookie OIDC",
    cookie_keys_description: "As chaves de cookie OIDC s\xe3o usadas para assinar cookies.",
    private_keys_in_use: "Chaves privadas em uso",
    cookie_keys_in_use: "Chaves de cookie em uso",
    rotate_private_keys: "Girar chaves privadas",
    rotate_cookie_keys: "Girar chaves de cookie",
    rotate_private_keys_description: "Esta a\xe7\xe3o criar\xe1 uma nova chave privada de assinatura, girar\xe1 a chave atual e remover\xe1 sua chave anterior. Seus tokens JWT assinados com a chave atual permanecer\xe3o v\xe1lidos at\xe9 a exclus\xe3o ou outra rodada de rota\xe7\xe3o.",
    rotate_cookie_keys_description: "Esta a\xe7\xe3o criar\xe1 uma nova chave de cookie, girar\xe1 a chave atual e remover\xe1 sua chave anterior. Seus cookies com a chave atual permanecer\xe3o v\xe1lidos at\xe9 a exclus\xe3o ou outra rodada de rota\xe7\xe3o.",
    select_private_key_algorithm: "Selecione o algoritmo de assinatura para a nova chave privada",
    rotate_button: "Girar",
    table_column: {
        id: "ID",
        status: "Status",
        algorithm: "Algoritmo de assinatura"
    },
    status: {
        current: "Atual",
        previous: "Anterior"
    },
    reminder: {
        rotate_private_key: "Tem certeza de que deseja girar as <strong>chaves privadas do OIDC</strong>? Os novos tokens JWT emitidos ser\xe3o assinados pela nova chave. Os tokens JWT existentes permanecem v\xe1lidos at\xe9 voc\xea girar novamente.",
        rotate_cookie_key: "Tem certeza de que deseja girar as <strong>chaves de cookie do OIDC</strong>? Novos cookies gerados em sess\xf5es de login ser\xe3o assinados pela nova chave de cookie. Os cookies existentes permanecem v\xe1lidos at\xe9 voc\xea girar novamente.",
        delete_private_key: "Tem certeza de que deseja excluir a <strong>chave privada do OIDC</strong>? Tokens JWT existentes assinados com esta chave privada de assinatura n\xe3o ser\xe3o mais v\xe1lidos.",
        delete_cookie_key: "Tem certeza de que deseja excluir a <strong>chave de cookie do OIDC</strong>? As sess\xf5es de login mais antigas com cookies assinados com esta chave de cookie n\xe3o ser\xe3o mais v\xe1lidas. Ser\xe1 necess\xe1ria uma nova autentica\xe7\xe3o para esses usu\xe1rios."
    },
    messages: {
        rotate_key_success: "Chaves de assinatura giradas com sucesso.",
        delete_key_success: "Chave exclu\xedda com sucesso."
    }
};
var $b476870cdbe98a47$export$2e2bcd8739ae039 = Object.freeze($b476870cdbe98a47$var$signing_keys);


const $195ce01959928f7c$var$quota_item = {
    tenant_limit: {
        name: "Locat\xe1rios",
        limited: "{{count, number}} locat\xe1rio",
        limited_other: "{{count, number}} locat\xe1rios",
        unlimited: "Locat\xe1rios ilimitados",
        not_eligible: "Remova seus locat\xe1rios"
    },
    mau_limit: {
        name: "Usu\xe1rios ativos mensais",
        limited: "{{count, number}} UAM",
        unlimited: "UAM ilimitados",
        not_eligible: "Remova todos seus usu\xe1rios"
    },
    token_limit: {
        name: "Tokens",
        limited: "{{count, number}} token",
        limited_other: "{{count, number}} tokens",
        unlimited: "Tokens ilimitados",
        not_eligible: "Remova todos os seus usu\xe1rios para evitar novos tokens"
    },
    applications_limit: {
        name: "Aplica\xe7\xf5es",
        limited: "{{count, number}} aplica\xe7\xe3o",
        limited_other: "{{count, number}} aplica\xe7\xf5es",
        unlimited: "Aplica\xe7\xf5es ilimitadas",
        not_eligible: "Remova suas aplica\xe7\xf5es"
    },
    machine_to_machine_limit: {
        name: "Aplica\xe7\xf5es de m\xe1quina a m\xe1quina",
        limited: "{{count, number}} aplica\xe7\xe3o de m\xe1quina a m\xe1quina",
        limited_other: "{{count, number}} aplica\xe7\xf5es de m\xe1quina a m\xe1quina",
        unlimited: "Aplica\xe7\xf5es de m\xe1quina a m\xe1quina ilimitadas",
        not_eligible: "Remova suas aplica\xe7\xf5es de m\xe1quina a m\xe1quina"
    },
    third_party_applications_limit: {
        name: "Aplicativos de terceiros",
        limited: "{{count, number}} aplicativo de terceiros",
        limited_other: "{{count, number}} aplicativos de terceiros",
        unlimited: "Aplicativos de terceiros ilimitados",
        not_eligible: "Remova seus aplicativos de terceiros"
    },
    resources_limit: {
        name: "Recursos da API",
        limited: "{{count, number}} recurso da API",
        limited_other: "{{count, number}} recursos da API",
        unlimited: "Recursos da API ilimitados",
        not_eligible: "Remova seus recursos da API"
    },
    scopes_per_resource_limit: {
        name: "Permiss\xf5es de recursos",
        limited: "{{count, number}} permiss\xe3o por recurso",
        limited_other: "{{count, number}} permiss\xf5es por recurso",
        unlimited: "Permiss\xe3o por recurso ilimitada",
        not_eligible: "Remova suas permiss\xf5es de recursos"
    },
    custom_domain_enabled: {
        name: "Dom\xednio personalizado",
        limited: "Dom\xednio personalizado",
        unlimited: "Dom\xednio personalizado",
        not_eligible: "Remova seu dom\xednio personalizado"
    },
    omni_sign_in_enabled: {
        name: "Omni sign-in",
        limited: "Omni sign-in",
        unlimited: "Omni sign-in",
        not_eligible: "Desabilite seu omni sign-in"
    },
    built_in_email_connector_enabled: {
        name: "Conector de email incorporado",
        limited: "Conector de email incorporado",
        unlimited: "Conector de email incorporado",
        not_eligible: "Remova seu conector de email incorporado"
    },
    social_connectors_limit: {
        name: "Conectores sociais",
        limited: "{{count, number}} conector social",
        limited_other: "{{count, number}} conectores sociais",
        unlimited: "Conectores sociais ilimitados",
        not_eligible: "Remova seus conectores sociais"
    },
    standard_connectors_limit: {
        name: "Conectores padr\xe3o gratuitos",
        limited: "{{count, number}} conector padr\xe3o gratuito",
        limited_other: "{{count, number}} conectores padr\xe3o gratuitos",
        unlimited: "Conectores padr\xe3o ilimitados",
        not_eligible: "Remova seus conectores padr\xe3o"
    },
    roles_limit: {
        name: "Fun\xe7\xf5es",
        limited: "{{count, number}} fun\xe7\xe3o",
        limited_other: "{{count, number}} fun\xe7\xf5es",
        unlimited: "Fun\xe7\xf5es ilimitadas",
        not_eligible: "Remova suas fun\xe7\xf5es"
    },
    machine_to_machine_roles_limit: {
        name: "Fun\xe7\xf5es de m\xe1quina a m\xe1quina",
        limited: "{{count, number}} fun\xe7\xe3o de m\xe1quina a m\xe1quina",
        limited_other: "{{count, number}} fun\xe7\xf5es de m\xe1quina a m\xe1quina",
        unlimited: "Fun\xe7\xf5es de m\xe1quina a m\xe1quina ilimitadas",
        not_eligible: "Remova suas fun\xe7\xf5es de m\xe1quina a m\xe1quina"
    },
    scopes_per_role_limit: {
        name: "Permiss\xf5es de fun\xe7\xf5es",
        limited: "{{count, number}} permiss\xe3o por fun\xe7\xe3o",
        limited_other: "{{count, number}} permiss\xf5es por fun\xe7\xe3o",
        unlimited: "Permiss\xe3o por fun\xe7\xe3o ilimitada",
        not_eligible: "Remova suas permiss\xf5es de fun\xe7\xe3o"
    },
    hooks_limit: {
        name: "Webhooks",
        limited: "{{count, number}} webhook",
        limited_other: "{{count, number}} webhooks",
        unlimited: "Webhooks ilimitados",
        not_eligible: "Remova seus webhooks"
    },
    organizations_enabled: {
        name: "Organiza\xe7\xf5es",
        limited: "Organiza\xe7\xf5es",
        unlimited: "Organiza\xe7\xf5es",
        not_eligible: "Remova suas organiza\xe7\xf5es"
    },
    audit_logs_retention_days: {
        name: "Perman\xeancia de registros de auditoria",
        limited: "Perman\xeancia de registros de auditoria: {{count, number}} dia",
        limited_other: "Perman\xeancia de registros de auditoria: {{count, number}} dias",
        unlimited: "Dias ilimitados",
        not_eligible: "Nenhum registro de auditoria"
    },
    email_ticket_support: {
        name: "Suporte de ingressos de e-mail",
        limited: "{{count, number}} hora de suporte de ingressos de e-mail",
        limited_other: "{{count, number}} horas de suporte de ingressos de e-mail",
        unlimited: "Suporte de ingressos de e-mail",
        not_eligible: "Nenhum suporte de ingressos de e-mail"
    },
    mfa_enabled: {
        name: "Autentica\xe7\xe3o de dois fatores",
        limited: "Autentica\xe7\xe3o de dois fatores",
        unlimited: "Autentica\xe7\xe3o de dois fatores",
        not_eligible: "Remova sua autentica\xe7\xe3o de dois fatores"
    },
    sso_enabled: {
        name: "SSO Empresarial",
        limited: "SSO Empresarial",
        unlimited: "SSO Empresarial",
        not_eligible: "Remova seu Enterprise SSO"
    },
    tenant_members_limit: {
        name: "Membros do locat\xe1rio",
        limited: "{{count, number}} membro do locat\xe1rio",
        limited_other: "{{count, number}} membros do locat\xe1rio",
        unlimited: "Membros do locat\xe1rio ilimitados",
        not_eligible: "Remova seus membros do locat\xe1rio"
    },
    custom_jwt_enabled: {
        name: "JWT personalizado",
        limited: "JWT personalizado",
        unlimited: "JWT personalizado",
        not_eligible: "Remova seu personalizador de declara\xe7\xf5es JWT"
    }
};
var $195ce01959928f7c$export$2e2bcd8739ae039 = Object.freeze($195ce01959928f7c$var$quota_item);


const $d8126730f532cadc$var$quota_table = {
    quota: {
        title: "B\xe1sico",
        base_price: "Pre\xe7o base",
        mau_limit: "Limite de MAU",
        included_tokens: "Tokens inclu\xeddos"
    },
    application: {
        title: "Aplica\xe7\xf5es",
        total: "Total de aplica\xe7\xf5es",
        m2m: "Aplica\xe7\xe3o m\xe1quina-a-m\xe1quina",
        third_party: "Aplicativos de terceiros"
    },
    resource: {
        title: "Recursos de API",
        resource_count: "Contagem de recursos",
        scopes_per_resource: "Permiss\xf5es por recurso"
    },
    branding: {
        title: "Interface de usu\xe1rio e branding",
        custom_domain: "Dom\xednio personalizado",
        custom_css: "CSS personalizado",
        app_logo_and_favicon: "Logotipo da aplica\xe7\xe3o e favicon",
        dark_mode: "Modo escuro",
        i18n: "Internacionaliza\xe7\xe3o"
    },
    user_authn: {
        title: "Autentica\xe7\xe3o de usu\xe1rio",
        omni_sign_in: "Entrada Omni",
        password: "Senha",
        passwordless: "Sem senha - E-mail e SMS",
        email_connector: "Conector de e-mail",
        sms_connector: "Conector de SMS",
        social_connectors: "Conectores sociais",
        standard_connectors: "Conectores padr\xe3o",
        built_in_email_connector: "Conector de e-mail integrado",
        mfa: "Autentica\xe7\xe3o multifator",
        sso: "SSO Empresarial",
        adaptive_mfa: "MFA adaptativo"
    },
    user_management: {
        title: "Gerenciamento de usu\xe1rios",
        user_management: "Gerenciamento de usu\xe1rios",
        roles: "Fun\xe7\xf5es",
        machine_to_machine_roles: "Fun\xe7\xf5es de m\xe1quina-a-m\xe1quina",
        scopes_per_role: "Permiss\xf5es por fun\xe7\xe3o"
    },
    organizations: {
        title: "Organiza\xe7\xe3o",
        organizations: "Organiza\xe7\xf5es",
        organization: "Organiza\xe7\xe3o",
        organization_count: "Contagem de organiza\xe7\xf5es",
        allowed_users_per_org: "Usu\xe1rios por organiza\xe7\xe3o",
        invitation: "Convite (API de Gerenciamento)",
        org_roles: "Fun\xe7\xf5es da organiza\xe7\xe3o",
        org_permissions: "Permiss\xf5es da organiza\xe7\xe3o",
        just_in_time_provisioning: "Provisionamento just-in-time"
    },
    support: {
        title: "Conformidade e suporte",
        community: "Comunidade",
        customer_ticket: "Ticket de suporte",
        premium: "Premium",
        email_ticket_support: "Suporte por e-mail",
        soc2_report: "Relat\xf3rio SOC2",
        hipaa_or_baa_report: "Relat\xf3rio HIPAA/BAA"
    },
    developers_and_platform: {
        title: "Desenvolvedores e plataforma",
        hooks: "Webhooks",
        audit_logs_retention: "Reten\xe7\xe3o de logs de auditoria",
        jwt_claims: "Reivindica\xe7\xf5es JWT",
        tenant_members: "Membros do locat\xe1rio"
    },
    unlimited: "Ilimitado",
    contact: "Contato",
    monthly_price: "${ { value, number } }/m\xeas",
    days_one: "${ { count, number } } dia",
    days_other: "${ { count, number } } dias",
    add_on: "Adicional",
    tier: "N\xedvel${ { value, number } }:",
    paid_token_limit_tip: "O Logto adicionar\xe1 cobran\xe7as para recursos que ultrapassem o limite da sua cota. Voc\xea pode us\xe1-lo gratuitamente at\xe9 come\xe7armos a cobrar por volta do segundo trimestre de 2024. Se precisar de mais tokens, entre em contato conosco. Por padr\xe3o, cobramos $80 por m\xeas para cada milh\xe3o de tokens.",
    paid_quota_limit_tip: "O Logto adicionar\xe1 cobran\xe7as por recursos que ultrapassarem seu limite de cota. Voc\xea pode us\xe1-lo gratuitamente at\xe9 come\xe7armos a cobrar, aproximadamente no segundo trimestre de 2024.",
    paid_add_on_feature_tip: "Esta \xe9 uma fun\xe7\xe3o adicional. Voc\xea pode us\xe1-la gratuitamente at\xe9 come\xe7armos a cobrar, aproximadamente no segundo trimestre de 2024.",
    million: "{{value, number}} milh\xe3o",
    mau_tip: "MAU (usu\xe1rios ativos mensais) significa o n\xfamero de usu\xe1rios \xfanicos que trocaram pelo menos um token com o Logto em um ciclo de faturamento.",
    tokens_tip: "Todos os tipos de tokens emitidos pelo Logto, incluindo token de acesso, token de atualiza\xe7\xe3o, etc.",
    mao_tip: "MAO (Organiza\xe7\xe3o Ativa Mensal) significa o n\xfamero de organiza\xe7\xf5es \xfanicas que t\xeam pelo menos um MAU (Usu\xe1rio Ativo Mensal) em um ciclo de faturamento.",
    third_party_tip: "Use Logto como seu provedor de identidade OIDC para logins e concess\xf5es de permiss\xe3o de aplicativos de terceiros.",
    included: "inclu\xeddo{{value, number}}",
    included_mao: "{{value, number}} MAO inclu\xeddo",
    extra_quota_price: "Ent\xe3o ${{value, number}} por m\xeas / cada depois",
    per_month_each: "${{value, number}} por m\xeas / cada",
    extra_mao_price: "Ent\xe3o ${{value, number}} por MAO",
    per_month: "${{value, number}} por m\xeas",
    per_member: "Ent\xe3o ${{value, number}} por membro"
};
var $d8126730f532cadc$export$2e2bcd8739ae039 = Object.freeze($d8126730f532cadc$var$quota_table);


const $051b48358fff0590$var$subscription = {
    free_plan: "Plano Gratuito",
    free_plan_description: "Para projetos pessoais e avalia\xe7\xf5es iniciais do Logto. Sem cart\xe3o de cr\xe9dito.",
    pro_plan: "Plano Pro",
    pro_plan_description: "Para empresas se beneficiarem tranquilo com o Logto.",
    enterprise: "Empresa",
    current_plan: "Plano Atual",
    current_plan_description: "Aqui est\xe1 o seu plano atual. Voc\xea pode facilmente ver o uso do seu plano, verificar a sua pr\xf3xima fatura e fazer altera\xe7\xf5es no plano, conforme necess\xe1rio.",
    plan_usage: "Uso do plano",
    plan_cycle: "Ciclo do plano: {{period}}. O uso \xe9 renovado em {{renewDate}}.",
    next_bill: "Sua pr\xf3xima fatura",
    next_bill_hint: "Para saber mais sobre o c\xe1lculo, consulte este <a>artigo</a>.",
    next_bill_tip: "Os pre\xe7os exibidos aqui n\xe3o incluem impostos. O valor do imposto ser\xe1 calculado com base nas informa\xe7\xf5es que voc\xea fornecer e nos requisitos regulat\xf3rios locais, e ser\xe1 mostrado nas suas faturas.",
    manage_payment: "Gerenciar pagamento",
    overfill_quota_warning: "Voc\xea atingiu o limite de cota. Para evitar problemas, fa\xe7a upgrade do plano.",
    upgrade_pro: "Upgrade Pro",
    update_payment: "Atualizar pagamento",
    payment_error: "Detectado um problema de pagamento. N\xe3o \xe9 poss\xedvel processar $ {{price, number}} para o ciclo anterior. Atualize o pagamento para evitar a suspens\xe3o do servi\xe7o Logto.",
    downgrade: "Downgrade",
    current: "Atual",
    upgrade: "Atualizar",
    quota_table: $d8126730f532cadc$export$2e2bcd8739ae039,
    billing_history: {
        invoice_column: "Faturas",
        status_column: "Status",
        amount_column: "Valor",
        invoice_created_date_column: "Data de cria\xe7\xe3o da fatura",
        invoice_status: {
            void: "Cancelada",
            paid: "Paga",
            open: "Em aberto",
            uncollectible: "Vencida"
        }
    },
    quota_item: $195ce01959928f7c$export$2e2bcd8739ae039,
    downgrade_modal: {
        title: "Tem certeza de que deseja fazer downgrade?",
        description: "Se voc\xea escolher mudar para o <targetName/>, observe que voc\xea n\xe3o ter\xe1 mais acesso \xe0 cota e aos recursos que estavam anteriormente no <currentName/>.",
        before: "Antes: <name/>",
        after: "Depois: <name />",
        downgrade: "Downgrade"
    },
    not_eligible_modal: {
        downgrade_title: "Voc\xea n\xe3o \xe9 eleg\xedvel para fazer downgrade",
        downgrade_description: "Certifique-se de atender aos seguintes crit\xe9rios antes de fazer o downgrade para o plano <name/>.",
        downgrade_help_tip: "Precisa de ajuda com o downgrade? <a>Contate-nos</a>.",
        upgrade_title: "Lembrete amig\xe1vel para nossos honrados early adopters",
        upgrade_description: "Voc\xea est\xe1 usando atualmente mais do que o permitido pelo <name />. O Logto agora \xe9 oficial, incluindo recursos adaptados a cada plano. Antes de considerar a atualiza\xe7\xe3o para o <name />, verifique se voc\xea atende aos seguintes crit\xe9rios antes de fazer o upgrade.",
        upgrade_pro_tip: " Ou considere fazer o upgrade para o Plano Pro.",
        upgrade_help_tip: "Precisa de ajuda com o upgrade? <a>Contate-nos</a>.",
        a_maximum_of: "Um m\xe1ximo de <item/>"
    },
    upgrade_success: "Atualizado com sucesso para <name/>",
    downgrade_success: "Downgrade realizado com sucesso para <name/>",
    subscription_check_timeout: "A verifica\xe7\xe3o de assinatura expirou. Por favor, atualize mais tarde.",
    no_subscription: "Nenhuma assinatura"
};
var $051b48358fff0590$export$2e2bcd8739ae039 = Object.freeze($051b48358fff0590$var$subscription);


const $7676c845979ecee5$var$tab_sections = {
    overview: "Vis\xe3o geral",
    authentication: "Autentica\xe7\xe3o",
    authorization: "Autoriza\xe7\xe3o",
    users: "Usu\xe1rios",
    developer: "Desenvolvedor",
    tenant: "Inquilino"
};
var $7676c845979ecee5$export$2e2bcd8739ae039 = Object.freeze($7676c845979ecee5$var$tab_sections);


const $68dfff0ac466f267$var$tabs = {
    get_started: "Primeiros passos",
    dashboard: "Painel",
    applications: "Aplicativos",
    api_resources: "Recursos da API",
    sign_in_experience: "Experi\xeancia de login",
    connectors: "Conectores",
    enterprise_sso: "Enterprise SSO",
    webhooks: "Webhooks",
    organizations: "Organiza\xe7\xf5es",
    users: "Usu\xe1rios",
    audit_logs: "Logs",
    roles: "Registros",
    docs: "Documenta\xe7\xe3o",
    tenant_settings: "Configura\xe7\xf5es",
    mfa: "Autentica\xe7\xe3o de multi-fator",
    customize_jwt: "JWT Personalizado",
    signing_keys: "Chaves de assinatura",
    organization_template: "Modelo de organiza\xe7\xe3o"
};
var $68dfff0ac466f267$export$2e2bcd8739ae039 = Object.freeze($68dfff0ac466f267$var$tabs);


const $aa2be20dfc7206c1$var$tenant_members = {
    members: "Membros",
    invitations: "Convites",
    invite_members: "Convidar membros",
    user: "Usu\xe1rio",
    roles: "Fun\xe7\xf5es",
    admin: "Administrador",
    collaborator: "Colaborador",
    invitation_status: "Status do convite",
    inviter: "Convidador",
    expiration_date: "Data de expira\xe7\xe3o",
    invite_modal: {
        title: "Convidar pessoas para Logto Cloud",
        subtitle: "Para convidar membros para uma organiza\xe7\xe3o, eles devem aceitar o convite.",
        to: "Para",
        added_as: "Adicionados como fun\xe7\xf5es",
        email_input_placeholder: "johndoe@example.com"
    },
    invitation_statuses: {
        pending: "Pendente",
        accepted: "Aceito",
        expired: "Expirado",
        revoked: "Revogado"
    },
    invitation_empty_placeholder: {
        title: "Convidar membros da equipe",
        description: "Seu locat\xe1rio atualmente n\xe3o possui membros convidados.\nPara ajudar com sua integra\xe7\xe3o, considere adicionar mais membros ou administradores."
    },
    menu_options: {
        edit: "Editar fun\xe7\xe3o do locat\xe1rio",
        delete: "Remover usu\xe1rio do locat\xe1rio",
        resend_invite: "Reenviar convite",
        revoke: "Revogar convite",
        delete_invitation_record: "Excluir este registro de convite"
    },
    edit_modal: {
        title: "Alterar fun\xe7\xf5es de {{name}}"
    },
    delete_user_confirm: "Tem certeza de que deseja remover este usu\xe1rio deste locat\xe1rio?",
    assign_admin_confirm: "Tem certeza de que deseja tornar o(s) usu\xe1rio(s) selecionado(s) como administrador? Conceder acesso de administrador dar\xe1 ao(s) usu\xe1rio(s) as seguintes permiss\xf5es.<ul><li>Alterar o plano de cobran\xe7a do locat\xe1rio</li><li>Adicionar ou remover colaboradores</li><li>Excluir o locat\xe1rio</li></ul>",
    revoke_invitation_confirm: "Tem certeza de que deseja revogar este convite?",
    delete_invitation_confirm: "Tem certeza de que deseja excluir este registro de convite?",
    messages: {
        invitation_sent: "Convite enviado.",
        invitation_revoked: "Convite revogado.",
        invitation_resend: "Convite reenviado.",
        invitation_deleted: "Registro de convite exclu\xeddo."
    },
    errors: {
        email_required: "O e-mail do convidado \xe9 obrigat\xf3rio.",
        email_exists: "O endere\xe7o de e-mail j\xe1 existe.",
        member_exists: "Este usu\xe1rio j\xe1 \xe9 membro desta organiza\xe7\xe3o.",
        pending_invitation_exists: "Convite pendente existe. Exclua o e-mail relacionado ou revogue o convite.",
        invalid_email: "O endere\xe7o de e-mail \xe9 inv\xe1lido. Certifique-se de que est\xe1 no formato correto.",
        max_member_limit: "Voc\xea atingiu o n\xfamero m\xe1ximo de membros ({{limit}}) para este locat\xe1rio."
    }
};
var $aa2be20dfc7206c1$export$2e2bcd8739ae039 = Object.freeze($aa2be20dfc7206c1$var$tenant_members);


const $89b6d692762b7796$var$tenants = {
    title: "Configura\xe7\xf5es",
    description: "Gerencie eficientemente as configura\xe7\xf5es do locat\xe1rio e personalize seu dom\xednio.",
    tabs: {
        settings: "Configura\xe7\xf5es",
        members: "Membros",
        domains: "Dom\xednios",
        subscription: "Plano e faturamento",
        billing_history: "Hist\xf3rico de faturamento"
    },
    settings: {
        title: "CONFIGURA\xc7\xd5ES",
        description: "Defina o nome do locat\xe1rio e visualize a regi\xe3o de hospedagem dos seus dados e o tipo de locat\xe1rio.",
        tenant_id: "ID do Locat\xe1rio",
        tenant_name: "Nome do Locat\xe1rio",
        tenant_region: "Regi\xe3o de hospedagem",
        tenant_region_tip: "Seus recursos do locat\xe1rio est\xe3o hospedados na regi\xe3o {{region}}. <a>Veja mais</a>",
        environment_tag_development: "Desenvolvimento",
        environment_tag_production: "Produ\xe7\xe3o",
        tenant_type: "Tipo de locat\xe1rio",
        development_description: "Apenas para testes e n\xe3o deve ser usado em produ\xe7\xe3o. Nenhuma assinatura \xe9 necess\xe1ria. Possui todos os recursos profissionais, mas com limita\xe7\xf5es como um banner de entrada. <a>Veja mais</a>",
        production_description: "Destinado a aplicativos usados por usu\xe1rios finais e que podem exigir uma assinatura paga. <a>Veja mais</a>",
        tenant_info_saved: "As informa\xe7\xf5es do locat\xe1rio foram salvas com sucesso."
    },
    full_env_tag: {
        development: "Desenvolvimento",
        production: "Produ\xe7\xe3o"
    },
    deletion_card: {
        title: "EXCLUIR",
        tenant_deletion: "Excluir locat\xe1rio",
        tenant_deletion_description: "A exclus\xe3o do locat\xe1rio resultar\xe1 na remo\xe7\xe3o permanente de todos os dados de usu\xe1rio e configura\xe7\xe3o associados. Por favor, prossiga com cuidado.",
        tenant_deletion_button: "Excluir locat\xe1rio"
    },
    leave_tenant_card: {
        title: "SAIR",
        leave_tenant: "Sair do locat\xe1rio",
        leave_tenant_description: "Quaisquer recursos no locat\xe1rio permanecer\xe3o, mas voc\xea n\xe3o ter\xe1 mais acesso a este locat\xe1rio.",
        last_admin_note: "Para sair deste locat\xe1rio, certifique-se de que pelo menos mais um membro tenha a fun\xe7\xe3o de Administrador."
    },
    create_modal: {
        title: "Criar inquilino",
        tenant_usage_purpose: "Para que voc\xea deseja usar este locat\xe1rio?",
        development_description: "Apenas para testes e n\xe3o deve ser usado em produ\xe7\xe3o. Nenhuma assinatura \xe9 necess\xe1ria.",
        development_hint: "Possui todos os recursos profissionais, mas com limita\xe7\xf5es como um banner de entrada.",
        production_description: "Para uso por usu\xe1rios finais e pode exigir uma assinatura paga.",
        available_plan: "Plano dispon\xedvel:",
        create_button: "Criar inquilino",
        tenant_name_placeholder: "Meu inquilino"
    },
    dev_tenant_migration: {
        title: "Agora voc\xea pode experimentar nossos recursos Pro gratuitamente criando um novo “locat\xe1rio de desenvolvimento”!",
        affect_title: "Como isso afeta voc\xea?",
        hint_1: "Estamos substituindo as antigas <strong>etiquetas de ambiente</strong> por dois novos tipos de locat\xe1rio: <strong>“Desenvolvimento”</strong> e <strong>“Produ\xe7\xe3o”</strong>.",
        hint_2: "Para garantir uma transi\xe7\xe3o cont\xednua e funcionalidade ininterrupta, todos os locat\xe1rios criados anteriormente ser\xe3o elevados ao tipo de locat\xe1rio <strong>Produ\xe7\xe3o</strong> juntamente com sua assinatura anterior.",
        hint_3: "N\xe3o se preocupe, todas as suas outras configura\xe7\xf5es permanecer\xe3o as mesmas.",
        about_tenant_type: "Sobre o tipo de locat\xe1rio"
    },
    delete_modal: {
        title: "Excluir locat\xe1rio",
        description_line1: 'Tem certeza de que deseja excluir o seu locat\xe1rio "<span>{{name}}</span>" com a etiqueta de sufixo de ambiente "<span>{{tag}}</span>"? Esta a\xe7\xe3o n\xe3o pode ser desfeita e resultar\xe1 na exclus\xe3o permanente de todos os seus dados e informa\xe7\xf5es do locat\xe1rio.',
        description_line2: "Antes de excluir o locat\xe1rio, talvez possamos ajudar voc\xea. <span><a>Entre em contato conosco por e-mail</a></span>",
        description_line3: 'Se deseja prosseguir, digite o nome do locat\xe1rio "<span>{{name}}</span>" para confirmar.',
        delete_button: "Excluir permanentemente",
        cannot_delete_title: "N\xe3o \xe9 poss\xedvel excluir este inquilino",
        cannot_delete_description: "Desculpe, no momento voc\xea n\xe3o pode excluir este locat\xe1rio. Certifique-se de que est\xe1 no Plano Gratuito e tenha pago todas as faturas pendentes."
    },
    leave_tenant_modal: {
        description: "Tem certeza de que deseja sair deste locat\xe1rio?",
        leave_button: "Sair"
    },
    tenant_landing_page: {
        title: "Voc\xea ainda n\xe3o criou um inquilino",
        description: "Para come\xe7ar a configurar seu projeto com o Logto, crie um novo inquilino. Se voc\xea precisar fazer logout ou excluir sua conta, basta clicar no bot\xe3o do avatar no canto superior direito.",
        create_tenant_button: "Criar inquilino"
    },
    status: {
        mau_exceeded: "MAU Excedido",
        suspended: "Suspenso",
        overdue: "Atrasado"
    },
    tenant_suspended_page: {
        title: "Locat\xe1rio suspenso. Entre em contato para restaurar o acesso.",
        description_1: "Lamentamos informar que sua conta de locat\xe1rio foi temporariamente suspensa devido a uso indevido, incluindo exceder os limites de MAU, pagamentos em atraso ou outras a\xe7\xf5es n\xe3o autorizadas.",
        description_2: "Se precisar de mais esclarecimentos, tiver alguma preocupa\xe7\xe3o ou desejar restaurar a funcionalidade total e desbloquear seus locat\xe1rios, entre em contato conosco imediatamente."
    }
};
var $89b6d692762b7796$export$2e2bcd8739ae039 = Object.freeze($89b6d692762b7796$var$tenants);


const $6d462ce0bd0843ff$var$topbar = {
    docs: "Documenta\xe7\xe3o",
    help: "Ajuda"
};
var $6d462ce0bd0843ff$export$2e2bcd8739ae039 = Object.freeze($6d462ce0bd0843ff$var$topbar);


const $e6bb71cb606305b1$var$featured_plan_content = {
    mau: {
        free_plan: "At\xe9 {{count, number}} MAU",
        pro_plan: "MAU ilimitados"
    },
    m2m: {
        free_plan: "{{count, number}} de m\xe1quina para m\xe1quina",
        pro_plan: "M\xe1quina para m\xe1quina adicional"
    },
    third_party_apps: "IdP para aplicativos de terceiros",
    mfa: "Autentica\xe7\xe3o de v\xe1rios fatores",
    sso: "SSO empresarial",
    role_and_permissions: {
        free_plan: "{{roleCount, number}} fun\xe7\xe3o e {{permissionCount, number}} permiss\xe3o por fun\xe7\xe3o",
        pro_plan: "Fun\xe7\xf5es e permiss\xf5es ilimitadas por fun\xe7\xe3o"
    },
    organizations: "Organiza\xe7\xf5es",
    audit_logs: "Reten\xe7\xe3o de logs de auditoria: {{count, number}} dias"
};
var $e6bb71cb606305b1$export$2e2bcd8739ae039 = Object.freeze($e6bb71cb606305b1$var$featured_plan_content);


const $aa671a65de6d8f94$var$paywall = {
    applications: "Limite de {{count, number}} aplica\xe7\xe3o do <planName/> atingido. Atualize o plano para atender \xe0s necessidades da sua equipe. Para obter qualquer ajuda, sinta-se \xe0 vontade para <a>entrar em contato conosco</a>.",
    applications_other: "Limite de {{count, number}} aplica\xe7\xf5es do <planName/> atingido. Atualize o plano para atender \xe0s necessidades da sua equipe. Para obter qualquer ajuda, sinta-se \xe0 vontade para <a>entrar em contato conosco</a>.",
    machine_to_machine_feature: "Altere para o plano <strong>Pro</strong> para ganhar aplicativos adicionais de m\xe1quina para m\xe1quina e aproveitar todos os recursos premium. <a>Entre em contato conosco</a> se tiver d\xfavidas.",
    machine_to_machine: "Limite de {{count, number}} aplica\xe7\xe3o de m\xe1quina para m\xe1quina do <planName/> atingido. Atualize o plano para atender \xe0s necessidades da sua equipe. Para obter qualquer ajuda, sinta-se \xe0 vontade para <a>entrar em contato conosco</a>.",
    machine_to_machine_other: "Limite de {{count, number}} aplica\xe7\xf5es de m\xe1quina para m\xe1quina do <planName/> atingido. Atualize o plano para atender \xe0s necessidades da sua equipe. Para obter qualquer ajuda, sinta-se \xe0 vontade para <a>entrar em contato conosco</a>.",
    resources: "Atingiu o limite de {{count, number}} recursos de API de <planName/>. Atualize o plano para satisfazer as necessidades da sua equipe. <a>Entre em contato conosco</a> se precisar de assist\xeancia.",
    resources_other: "Atingiu o limite de {{count, number}} recursos de API de <planName/>. Atualize o plano para satisfazer as necessidades da sua equipe. <a>Entre em contato conosco</a> se precisar de assist\xeancia.",
    scopes_per_resource: "Atingiu o limite de {{count, number}} permiss\xf5es por recurso de API de <planName/>. Atualize agora para expandir. <a>Entre em contato conosco</a> se precisar de assist\xeancia.",
    scopes_per_resource_other: "Atingiu o limite de {{count, number}} permiss\xf5es por recurso de API de <planName/>. Atualize agora para expandir. <a>Entre em contato conosco</a> se precisar de assist\xeancia.",
    custom_domain: "Desbloqueie a funcionalidade de dom\xednio personalizado ao atualizar para o plano <strong>Hobby</strong> ou <strong>Pro</strong>. N\xe3o hesite em <a>entrar em contato conosco</a> se precisar de alguma ajuda.",
    social_connectors: "Atingiu o limite de {{count, number}} conectores sociais de <planName/>. Atualize o plano para obter conectores sociais adicionais e a capacidade de criar os seus pr\xf3prios conectores usando os protocolos OIDC, OAuth 2.0 e SAML. N\xe3o hesite em <a>Entre em contato conosco</a> se precisar de ajuda.",
    social_connectors_other: "Atingiu o limite de {{count, number}} conectores sociais de <planName/>. Atualize o plano para obter conectores sociais adicionais e a capacidade de criar os seus pr\xf3prios conectores usando os protocolos OIDC, OAuth 2.0 e SAML. N\xe3o hesite em <a>Entre em contato conosco</a> se precisar de ajuda.",
    standard_connectors_feature: "Atualize para o plano <strong>Hobby</strong> ou <strong>Pro</strong> para criar seus pr\xf3prios conectores usando os protocolos OIDC, OAuth 2.0 e SAML, al\xe9m de conectores sociais ilimitados e todos os recursos premium. Sinta-se \xe0 vontade para <a>entrar em contato conosco</a> se precisar de qualquer ajuda.",
    standard_connectors: "Atingiu o limite de {{count, number}} conectores sociais de <planName/>. Atualize o plano para obter conectores sociais adicionais e a capacidade de criar os seus pr\xf3prios conectores usando os protocolos OIDC, OAuth 2.0 e SAML. N\xe3o hesite em <a>Entre em contato conosco</a> se precisar de ajuda.",
    standard_connectors_other: "Atingiu o limite de {{count, number}} conectores sociais de <planName/>. Atualize o plano para obter conectores sociais adicionais e a capacidade de criar os seus pr\xf3prios conectores usando os protocolos OIDC, OAuth 2.0 e SAML. N\xe3o hesite em <a>Entre em contato conosco</a> se precisar de ajuda.",
    standard_connectors_pro: "Atingiu o limite de {{count, number}} conectores padr\xe3o de <planName/>. Atualize para o plano Empresarial para obter conectores sociais adicionais e a capacidade de criar os seus pr\xf3prios conectores usando os protocolos OIDC, OAuth 2.0 e SAML. N\xe3o hesite em <a>Entre em contato conosco</a> se precisar de ajuda.",
    standard_connectors_pro_other: "Atingiu o limite de {{count, number}} conectores padr\xe3o de <planName/>. Atualize para o plano Empresarial para obter conectores sociais adicionais e a capacidade de criar os seus pr\xf3prios conectores usando os protocolos OIDC, OAuth 2.0 e SAML. N\xe3o hesite em <a>Entre em contato conosco</a> se precisar de ajuda.",
    roles: "Atingiu o limite de {{count, number}} fun\xe7\xf5es de <planName/>. Atualize o plano para adicionar fun\xe7\xf5es e permiss\xf5es adicionais. N\xe3o hesite em <a>Entre em contato conosco</a> se precisar de ajuda.",
    roles_other: "Atingiu o limite de {{count, number}} fun\xe7\xf5es de <planName/>. Atualize o plano para adicionar fun\xe7\xf5es e permiss\xf5es adicionais. N\xe3o hesite em <a>Entre em contato conosco</a> se precisar de ajuda.",
    machine_to_machine_roles: "{{count, number}} fun\xe7\xf5es de m\xe1quina para m\xe1quina do <planName/> atingiram o limite. Atualize o plano para adicionar fun\xe7\xf5es e permiss\xf5es adicionais. Sinta-se \xe0 vontade para <a>entrar em contato conosco</a> se precisar de alguma ajuda.",
    machine_to_machine_roles_other: "{{count, number}} fun\xe7\xf5es de m\xe1quina para m\xe1quina do <planName/> atingiram o limite. Atualize o plano para adicionar fun\xe7\xf5es e permiss\xf5es adicionais. Sinta-se \xe0 vontade para <a>entrar em contato conosco</a> se precisar de alguma ajuda.",
    scopes_per_role: "Atingiu o limite de {{count, number}} permiss\xf5es por fun\xe7\xe3o de <planName/>. Atualize o plano para adicionar fun\xe7\xf5es e permiss\xf5es adicionais. N\xe3o hesite em <a>Entre em contato conosco</a> se precisar de ajuda.",
    scopes_per_role_other: "Atingiu o limite de {{count, number}} permiss\xf5es por fun\xe7\xe3o de <planName/>. Atualize o plano para adicionar fun\xe7\xf5es e permiss\xf5es adicionais. N\xe3o hesite em <a>Entre em contato conosco</a> se precisar de ajuda.",
    hooks: "Atingiu o limite de {{count, number}} webhooks de <planName/>. Atualize o plano para criar mais webhooks. N\xe3o hesite em <a>Entre em contato conosco</a> se precisar de ajuda.",
    hooks_other: "Atingiu o limite de {{count, number}} webhooks de <planName/>. Atualize o plano para criar mais webhooks. N\xe3o hesite em <a>Entre em contato conosco</a> se precisar de ajuda.",
    mfa: "Desbloqueie o MFA para verificar a seguran\xe7a, fazendo upgrade para um plano pago. N\xe3o hesite em <a>nos contatar</a> se precisar de alguma assist\xeancia.",
    organizations: "Desbloqueie organiza\xe7\xf5es ao fazer upgrade para um plano pago. N\xe3o hesite em <a>entrar em contato conosco</a> se precisar de alguma assist\xeancia.",
    third_party_apps: "Desbloqueie Logto como provedor de identidade para aplicativos de terceiros, ao fazer upgrade para um plano pago. Para qualquer ajuda, sinta-se \xe0 vontade para <a>entrar em contato conosco</a>.",
    sso_connectors: "Desbloqueie SSO corporativo ao fazer upgrade para um plano pago. Para qualquer ajuda, sinta-se \xe0 vontade para <a>entrar em contato conosco</a>.",
    tenant_members: "Desbloqueie a funcionalidade de colabora\xe7\xe3o ao fazer upgrade para um plano pago. Para qualquer ajuda, sinta-se \xe0 vontade para <a>entrar em contato conosco</a>.",
    tenant_members_dev_plan: "Voc\xea atingiu seu limite de {{limit}} membros. Libere um membro ou revogue um convite pendente para adicionar algu\xe9m novo. Precisa de mais vagas? Fale conosco.",
    custom_jwt: {
        title: "Adicionar reivindica\xe7\xf5es personalizadas",
        description: "Atualize para um plano pago para funcionalidades de JWT personalizadas e benef\xedcios premium. N\xe3o hesite em <a>entrar em contato conosco</a> se tiver alguma d\xfavida."
    }
};
var $aa671a65de6d8f94$export$2e2bcd8739ae039 = Object.freeze($aa671a65de6d8f94$var$paywall);


const $6af8106b7e856e5d$var$upsell = {
    upgrade_plan: "Atualizar plano",
    compare_plans: "Comparar planos",
    view_plans: "Ver planos",
    create_tenant: {
        title: "Selecione o seu plano de inquilino",
        description: "O Logto oferece op\xe7\xf5es competitivas de planos com pre\xe7os inovadores e acess\xedveis, especialmente concebidos para empresas em crescimento. <a>Saiba mais</a>",
        base_price: "Pre\xe7o base",
        monthly_price: "{{value, number}}/m\xeas",
        view_all_features: "Ver todas as funcionalidades",
        select_plan: "Selecionar <name/>",
        free_tenants_limit: "At\xe9 {{count, number}} inquilino gratuito",
        free_tenants_limit_other: "At\xe9 {{count, number}} inquilinos gratuitos",
        most_popular: "Mais popular",
        upgrade_success: "Atualiza\xe7\xe3o para <name/> bem-sucedida"
    },
    mau_exceeded_modal: {
        title: "MAU excedeu o limite. Atualize o seu plano.",
        notification: "O seu MAU atual excedeu o limite de <planName/>. Por favor, atualize para o plano premium a tempo para evitar a suspens\xe3o do servi\xe7o do Logto.",
        update_plan: "Atualizar plano"
    },
    payment_overdue_modal: {
        title: "Pagamento da fatura em atraso",
        notification: "Oops! O pagamento da fatura do inquilino <span>{{name}}</span> falhou. Por favor, pague a fatura prontamente para evitar a suspens\xe3o do servi\xe7o Logto.",
        unpaid_bills: "Faturas n\xe3o pagas",
        update_payment: "Atualizar pagamento"
    },
    add_on_quota_item: {
        api_resource: "Recurso de API",
        machine_to_machine: "aplica\xe7\xe3o m\xe1quina a m\xe1quina",
        tokens: "{{limit}}M tokens",
        tenant_member: "membro do inquilino"
    },
    charge_notification_for_quota_limit: "Voc\xea ultrapassou o limite de sua cota de {{item}}. O Logto adicionar\xe1 cobran\xe7as pelo uso al\xe9m do limite da cota. A cobran\xe7a come\xe7ar\xe1 no dia em que o novo design de pre\xe7os do complemento for lan\xe7ado. <a>Saiba mais</a>",
    paywall: $aa671a65de6d8f94$export$2e2bcd8739ae039,
    featured_plan_content: $e6bb71cb606305b1$export$2e2bcd8739ae039
};
var $6af8106b7e856e5d$export$2e2bcd8739ae039 = Object.freeze($6af8106b7e856e5d$var$upsell);


const $327d69d308573a5e$var$user_details = {
    page_title: "Detalhes do usu\xe1rio",
    back_to_users: "Voltar para gerenciamento de usu\xe1rios",
    created_title: "Este usu\xe1rio foi criado com sucesso",
    created_guide: "Aqui est\xe1 a informa\xe7\xe3o para ajudar o usu\xe1rio com o processo de login.",
    created_email: "Endere\xe7o de e-mail:",
    created_phone: "N\xfamero de telefone:",
    created_username: "Nome de usu\xe1rio:",
    created_password: "Senha:",
    menu_delete: "Excluir",
    delete_description: "Essa a\xe7\xe3o n\xe3o pode ser desfeita. Isso excluir\xe1 permanentemente o usu\xe1rio.",
    deleted: "O usu\xe1rio foi exclu\xeddo com sucesso",
    reset_password: {
        reset_password: "Redefinir senha",
        title: "Tem certeza de que deseja redefinir a senha?",
        content: "Essa a\xe7\xe3o n\xe3o pode ser desfeita. Isso redefinir\xe1 as informa\xe7\xf5es de login do usu\xe1rio.",
        congratulations: "Este usu\xe1rio foi redefinido",
        new_password: "Nova senha:"
    },
    tab_settings: "Configura\xe7\xf5es",
    tab_roles: "Fun\xe7\xf5es",
    tab_logs: "Registros",
    tab_organizations: "Organiza\xe7\xf5es",
    authentication: "Autentica\xe7\xe3o",
    authentication_description: "Cada usu\xe1rio tem um perfil contendo todas as informa\xe7\xf5es do usu\xe1rio. Consiste em dados b\xe1sicos, identidades sociais e dados personalizados.",
    user_profile: "Perfil do usu\xe1rio",
    field_email: "Endere\xe7o de e-mail",
    field_phone: "N\xfamero de telefone",
    field_username: "Nome de usu\xe1rio",
    field_name: "Nome",
    field_avatar: "URL da imagem do avatar",
    field_avatar_placeholder: "https://your.cdn.domain/avatar.png",
    field_custom_data: "Dados personalizados",
    field_custom_data_tip: "Informa\xe7\xf5es adicionais do usu\xe1rio n\xe3o listadas nas propriedades de usu\xe1rio predefinidas, como cor e idioma preferidos do usu\xe1rio.",
    field_connectors: "Conectores de login sociais",
    field_sso_connectors: "Conex\xf5es empresariais",
    custom_data_invalid: "Os dados personalizados devem ser um objeto JSON v\xe1lido",
    connectors: {
        connectors: "Conectores",
        user_id: "ID do usu\xe1rio",
        remove: "Remover",
        connected: "Este usu\xe1rio est\xe1 conectado com v\xe1rios conectores sociais.",
        not_connected: "O usu\xe1rio n\xe3o est\xe1 conectado a nenhum conector social",
        deletion_confirmation: "Voc\xea est\xe1 removendo a identidade existente <name/>. Tem certeza de que deseja continuar?"
    },
    sso_connectors: {
        connectors: "Conectores",
        enterprise_id: "ID da empresa",
        connected: "Este usu\xe1rio est\xe1 conectado a v\xe1rios fornecedores de identidade empresarial para Entrada \xdanica.",
        not_connected: "O usu\xe1rio n\xe3o est\xe1 conectado a nenhum provedor de identidade empresarial para Entrada \xdanica."
    },
    mfa: {
        field_name: "Autentica\xe7\xe3o de dois fatores",
        field_description: "Este usu\xe1rio habilitou fatores de autentica\xe7\xe3o de 2 etapas.",
        name_column: "Autentica\xe7\xe3o de dois fatores",
        field_description_empty: "Este usu\xe1rio n\xe3o habilitou fatores de autentica\xe7\xe3o em duas etapas.",
        deletion_confirmation: "Voc\xea est\xe1 removendo o existente <name/> para a verifica\xe7\xe3o em duas etapas. Tem certeza de que deseja continuar?"
    },
    suspended: "Suspenso",
    suspend_user: "Suspender usu\xe1rio",
    suspend_user_reminder: "Tem certeza de que deseja suspender este usu\xe1rio? O usu\xe1rio n\xe3o poder\xe1 entrar em seu aplicativo e n\xe3o poder\xe1 obter um novo token de acesso ap\xf3s a expira\xe7\xe3o do atual. Al\xe9m disso, qualquer solicita\xe7\xe3o de API feita por este usu\xe1rio falhar\xe1.",
    suspend_action: "Suspender",
    user_suspended: "O usu\xe1rio foi suspenso",
    reactivate_user: "Reativar usu\xe1rio",
    reactivate_user_reminder: "Tem certeza de que deseja reativar este usu\xe1rio? Fazendo isso permitir\xe1 quaisquer tentativas de login para este usu\xe1rio.",
    reactivate_action: "Reativar",
    user_reactivated: "O usu\xe1rio foi reativado",
    roles: {
        name_column: "Fun\xe7\xe3o",
        description_column: "Descri\xe7\xe3o",
        assign_button: "Atribuir fun\xe7\xf5es",
        delete_description: "Esta a\xe7\xe3o remover\xe1 esta fun\xe7\xe3o deste usu\xe1rio. A fun\xe7\xe3o em si ainda existir\xe1, mas n\xe3o estar\xe1 mais associada a este usu\xe1rio.",
        deleted: "{{name}} foi removido com sucesso deste usu\xe1rio.",
        assign_title: "Atribuir fun\xe7\xf5es para {{name}}",
        assign_subtitle: "Autorizar {{name}} uma ou mais fun\xe7\xf5es",
        assign_role_field: "Atribuir fun\xe7\xf5es",
        role_search_placeholder: "Pesquisar por nome de fun\xe7\xe3o",
        added_text: "{{value, number}} adicionado(s)",
        assigned_user_count: "{{value, number}} usu\xe1rios",
        confirm_assign: "Atribuir fun\xe7\xf5es",
        role_assigned: "Fun\xe7\xe3o(\xf5es) atribu\xedda(s) com sucesso",
        search: "Pesquisar por nome de fun\xe7\xe3o, descri\xe7\xe3o ou ID",
        empty: "Nenhuma fun\xe7\xe3o dispon\xedvel"
    },
    warning_no_sign_in_identifier: "O usu\xe1rio precisa ter pelo menos um dos identificadores de login (nome de usu\xe1rio, e-mail, n\xfamero de telefone ou social) para fazer login. Tem certeza de que deseja continuar?",
    organization_roles_tooltip: "As fun\xe7\xf5es atribu\xeddas ao usu\xe1rio dentro desta organiza\xe7\xe3o."
};
var $327d69d308573a5e$export$2e2bcd8739ae039 = Object.freeze($327d69d308573a5e$var$user_details);


const $f45a5f3fea49bcb4$var$users = {
    page_title: "Gerenciamento de usu\xe1rios",
    title: "Gerenciamento de usu\xe1rios",
    subtitle: "Gerenciar identidades de usu\xe1rios, visualiza\xe7\xe3o de logs de usu\xe1rios, redefini\xe7\xf5es de senha e exclus\xe3o de usu\xe1rios",
    create: "Adicionar usu\xe1rio",
    create_subtitle: "Fornecer pelo menos um dos seguintes campos para prosseguir.",
    error_missing_identifier: "Voc\xea deve fornecer pelo menos um identificador para criar um usu\xe1rio.",
    user_name: "Nome de usu\xe1rio",
    application_name: "Aplicativo",
    latest_sign_in: "\xdaltimo login",
    create_form_username: "Nome de usu\xe1rio",
    create_form_password: "Senha",
    create_form_name: "Nome completo",
    placeholder_name: "Jo\xe3o da Silva",
    placeholder_email: "jsilva@example.com",
    placeholder_username: "user123",
    placeholder_phone: "+55 (11) 1234-5678",
    unnamed: "Sem nome",
    search: "Busca por nome, e-mail, telefone ou nome de usu\xe1rio",
    check_user_detail: "Detalhes do usu\xe1rio",
    placeholder_title: "Gerenciamento de usu\xe1rios",
    placeholder_description: "Cada usu\xe1rio possui um perfil contendo todas as informa\xe7\xf5es do usu\xe1rio. Ele \xe9 composto por dados b\xe1sicos, identidades sociais e dados personalizados."
};
var $f45a5f3fea49bcb4$export$2e2bcd8739ae039 = Object.freeze($f45a5f3fea49bcb4$var$users);


const $c9c6a066a6bb628b$var$webhook_details = {
    page_title: "Detalhes do webhook",
    back_to_webhooks: "Voltar para Webhooks",
    not_in_use: "N\xe3o em uso",
    success_rate: "Taxa de sucesso",
    requests: "{{value, number}} requisi\xe7\xf5es em 24h",
    disable_webhook: "Desativar webhook",
    disable_reminder: "Tem certeza de que deseja reativar este webhook? Isso n\xe3o enviar\xe1 uma solicita\xe7\xe3o HTTP para o URL do endpoint.",
    webhook_disabled: "O webhook foi desativado.",
    webhook_reactivated: "O webhook foi reativado.",
    reactivate_webhook: "Reativar webhook",
    delete_webhook: "Excluir webhook",
    deletion_reminder: "Voc\xea est\xe1 removendo este webhook. Depois de exclu\xed-lo, n\xe3o enviar\xe1 solicita\xe7\xe3o HTTP para o URL do endpoint.",
    deleted: "O webhook foi exclu\xeddo com sucesso.",
    settings_tab: "Configura\xe7\xf5es",
    recent_requests_tab: "Solicita\xe7\xf5es recentes (24h)",
    settings: {
        settings: "Configura\xe7\xf5es",
        settings_description: "Os webhooks permitem que voc\xea receba atualiza\xe7\xf5es em tempo real sobre eventos espec\xedficos conforme eles ocorrem, enviando uma solicita\xe7\xe3o POST para o URL do seu endpoint. Isso permite que voc\xea tome a\xe7\xf5es imediatas com base nas novas informa\xe7\xf5es recebidas.",
        events: "Eventos",
        events_description: "Selecione os eventos de gatilho que o Logto enviar\xe1 a solicita\xe7\xe3o POST.",
        name: "Nome",
        endpoint_url: "URL do Endpoint",
        signing_key: "Chave de assinatura",
        signing_key_tip: "Adicione a chave secreta fornecida pelo Logto ao seu endpoint como um cabe\xe7alho de solicita\xe7\xe3o para garantir a autenticidade do payload do webhook.",
        regenerate: "Regenerar",
        regenerate_key_title: "Regenerar chave de assinatura",
        regenerate_key_reminder: "Tem certeza de que deseja modificar a chave de assinatura? A regenera\xe7\xe3o ter\xe1 efeito imediato. Lembre-se de modificar a chave de assinatura de forma s\xedncrona em seu endpoint.",
        regenerated: "A chave de assinatura foi regenerada.",
        custom_headers: "Cabe\xe7alhos personalizados",
        custom_headers_tip: "Opcionalmente, voc\xea pode adicionar cabe\xe7alhos personalizados ao payload do webhook para fornecer contexto ou metadados adicionais sobre o evento.",
        key_duplicated_error: "As chaves n\xe3o podem ser repetidas.",
        key_missing_error: "A chave \xe9 obrigat\xf3ria.",
        value_missing_error: "O valor \xe9 obrigat\xf3rio.",
        invalid_key_error: "Chave inv\xe1lida",
        invalid_value_error: "O valor \xe9 inv\xe1lido",
        test: "Testar",
        test_webhook: "Teste seu webhook",
        test_webhook_description: "Configure o webhook e teste-o com exemplos de carga para cada evento selecionado para verifica\xe7\xe3o da recep\xe7\xe3o e processamento corretos.",
        send_test_payload: "Enviar carga de teste",
        test_result: {
            endpoint_url: "URL do ponto de extremidade: {{url}}",
            message: "Mensagem: {{message}}",
            response_status: "Status da resposta: {{status, number}}",
            response_body: "Corpo da resposta: {{body}}",
            request_time: "Tempo da solicita\xe7\xe3o: {{time}}",
            test_success: "O teste de webhook para o ponto de extremidade foi bem-sucedido."
        }
    }
};
var $c9c6a066a6bb628b$export$2e2bcd8739ae039 = Object.freeze($c9c6a066a6bb628b$var$webhook_details);


const $c7618dfe3472317f$var$webhooks = {
    page_title: "Webhooks",
    title: "Webhooks",
    subtitle: "Crie ganchos da web para receber atualiza\xe7\xf5es em tempo real sobre eventos espec\xedficos sem esfor\xe7o.",
    create: "Criar Webhook",
    schemas: {
        interaction: "Interac\xe7\xe3o do usu\xe1rio",
        user: "Usu\xe1rio",
        organization: "Organiza\xe7\xe3o",
        role: "Fun\xe7\xe3o",
        scope: "Permiss\xe3o",
        organization_role: "Fun\xe7\xe3o da organiza\xe7\xe3o",
        organization_scope: "Permiss\xe3o da organiza\xe7\xe3o"
    },
    table: {
        name: "Nome",
        events: "Eventos",
        success_rate: "Taxa de sucesso (24h)",
        requests: "Requisi\xe7\xf5es (24h)"
    },
    placeholder: {
        title: "Webhook",
        description: 'Crie um webhook para receber atualiza\xe7\xf5es em tempo real por meio de solicita\xe7\xf5es POST para o URL do seu ponto de extremidade. Fique informado e tome medidas imediatas em eventos como "Criar conta", "Entrar" e "Redefinir senha".',
        create_webhook: "Criar Webhook"
    },
    create_form: {
        title: "Criar Webhook",
        subtitle: "Adicione o Webhook para enviar uma solicita\xe7\xe3o POST para o URL do endpoint com detalhes de quaisquer eventos de usu\xe1rios.",
        events: "Eventos",
        events_description: "Selecione os eventos de gatilho que o Logto enviar\xe1 a solicita\xe7\xe3o POST.",
        name: "Nome",
        name_placeholder: "Digite o nome do webhook",
        endpoint_url: "URL de endpoint",
        endpoint_url_placeholder: "https://seu.url.endpoint.do.webhook",
        endpoint_url_tip: "Insira o URL do seu ponto de extremidade para o qual a carga \xfatil de um webhook \xe9 enviada quando o evento ocorre.",
        create_webhook: "Criar webhook",
        missing_event_error: "Voc\xea precisa selecionar pelo menos um evento."
    },
    webhook_created: "O webhook {{name}} foi criado com sucesso."
};
var $c7618dfe3472317f$export$2e2bcd8739ae039 = Object.freeze($c7618dfe3472317f$var$webhooks);


const $b0341b1170ae4dd1$var$welcome = {
    title: "Bem-vindo ao Admin Console",
    description: "O Admin Console \xe9 um aplicativo da web para gerenciar o Logto sem requisitos de codifica\xe7\xe3o. Vamos primeiro criar uma conta. Com esta conta, voc\xea pode gerenciar o Logto sozinho ou em nome de sua empresa.",
    create_account: "Criar uma conta"
};
var $b0341b1170ae4dd1$export$2e2bcd8739ae039 = Object.freeze($b0341b1170ae4dd1$var$welcome);


const $0dab43134d6f5b4e$var$admin_console = {
    title: "Admin Console",
    admin_user: "Administrador",
    system_app: "Sistema",
    menu: $92df6a4348df81df$export$2e2bcd8739ae039,
    general: $9035e1e484773d59$export$2e2bcd8739ae039,
    errors: $01a60c7c1354d5d4$export$2e2bcd8739ae039,
    tab_sections: $7676c845979ecee5$export$2e2bcd8739ae039,
    tabs: $68dfff0ac466f267$export$2e2bcd8739ae039,
    applications: $39b874f7fa413902$export$2e2bcd8739ae039,
    application_details: $f89e6b8a93a11cc7$export$2e2bcd8739ae039,
    api_resources: $e01c41c79c8628d6$export$2e2bcd8739ae039,
    api_resource_details: $3f6fa30a95077bd9$export$2e2bcd8739ae039,
    connectors: $4ac1ead7f222b1ab$export$2e2bcd8739ae039,
    connector_details: $40e167684167c12e$export$2e2bcd8739ae039,
    enterprise_sso: $f150d5061fa85a4a$export$2e2bcd8739ae039,
    enterprise_sso_details: $861acb201b104c88$export$2e2bcd8739ae039,
    get_started: $6b92ab5713c519c7$export$2e2bcd8739ae039,
    users: $f45a5f3fea49bcb4$export$2e2bcd8739ae039,
    user_details: $327d69d308573a5e$export$2e2bcd8739ae039,
    contact: $99383f3da569ace2$export$2e2bcd8739ae039,
    sign_in_exp: $220604ad58f200b1$export$2e2bcd8739ae039,
    dashboard: $f7789614396c8f1c$export$2e2bcd8739ae039,
    logs: $158fa9935f408042$export$2e2bcd8739ae039,
    log_details: $0a9fb3d52bf22407$export$2e2bcd8739ae039,
    session_expired: $ff8098dc48d8addc$export$2e2bcd8739ae039,
    welcome: $b0341b1170ae4dd1$export$2e2bcd8739ae039,
    roles: $6b2863304ed8dfe2$export$2e2bcd8739ae039,
    role_details: $63df4373eafb12c0$export$2e2bcd8739ae039,
    permissions: $edd93ac01b3e6dcd$export$2e2bcd8739ae039,
    cloud: $073902651c95b268$export$2e2bcd8739ae039,
    profile: $8e16c88a5e3df8d7$export$2e2bcd8739ae039,
    components: $9ba10ff630fb95a3$export$2e2bcd8739ae039,
    webhooks: $c7618dfe3472317f$export$2e2bcd8739ae039,
    webhook_details: $c9c6a066a6bb628b$export$2e2bcd8739ae039,
    domain: $bb85c21e09776d55$export$2e2bcd8739ae039,
    tenants: $89b6d692762b7796$export$2e2bcd8739ae039,
    tenant_members: $aa2be20dfc7206c1$export$2e2bcd8739ae039,
    topbar: $6d462ce0bd0843ff$export$2e2bcd8739ae039,
    subscription: $051b48358fff0590$export$2e2bcd8739ae039,
    upsell: $6af8106b7e856e5d$export$2e2bcd8739ae039,
    guide: $f12aa1ab64d42de8$export$2e2bcd8739ae039,
    mfa: $8b79fd6785f8fa3a$export$2e2bcd8739ae039,
    organizations: $4510f26c956f1e83$export$2e2bcd8739ae039,
    organization_details: $74755dc2bd7d2338$export$2e2bcd8739ae039,
    protected_app: $27af751e543aa0f0$export$2e2bcd8739ae039,
    jwt_claims: $d6388afe697f99ef$export$2e2bcd8739ae039,
    invitation: $ac0a54c5f3e9518d$export$2e2bcd8739ae039,
    signing_keys: $b476870cdbe98a47$export$2e2bcd8739ae039,
    organization_template: $dcb5a970f07f87b3$export$2e2bcd8739ae039,
    organization_role_details: $7a688219d5468ed3$export$2e2bcd8739ae039
};
var $0dab43134d6f5b4e$export$2e2bcd8739ae039 = Object.freeze($0dab43134d6f5b4e$var$admin_console);


const $1607e954437cfff9$var$demo_app = {
    title: "You've successfully signed in the live preview!",
    subtitle: "Aqui est\xe3o suas informa\xe7\xf5es de login:",
    username: "Nome de usu\xe1rio: ",
    user_id: "ID do usu\xe1rio: ",
    sign_out: "Sair da Visualiza\xe7\xe3o ao Vivo",
    continue_explore: "Ou continuar a navega\xe7\xe3o",
    customize_sign_in_experience: "Personalize a experi\xeancia de login",
    enable_passwordless: "Ativar acesso livre",
    add_social_connector: "Adicionar conector social"
};
var $1607e954437cfff9$export$2e2bcd8739ae039 = Object.freeze($1607e954437cfff9$var$demo_app);


const $64b296ea12f67667$var$oidc = {
    logout_success: "Voc\xea saiu com sucesso."
};
var $64b296ea12f67667$export$2e2bcd8739ae039 = Object.freeze($64b296ea12f67667$var$oidc);


const $640bbd36249b14bf$var$translation = {
    admin_console: $0dab43134d6f5b4e$export$2e2bcd8739ae039,
    demo_app: $1607e954437cfff9$export$2e2bcd8739ae039,
    oidc: $64b296ea12f67667$export$2e2bcd8739ae039
};
var $640bbd36249b14bf$export$2e2bcd8739ae039 = Object.freeze($640bbd36249b14bf$var$translation);


const $d677fbe04b3e7ff4$var$pt_br = {
    translation: $640bbd36249b14bf$export$2e2bcd8739ae039,
    errors: $70def3d24916b1e6$export$2e2bcd8739ae039
};
var $d677fbe04b3e7ff4$export$2e2bcd8739ae039 = Object.freeze($d677fbe04b3e7ff4$var$pt_br);


const $8db96022be1f4625$var$application = {
    invalid_type: "Apenas as aplica\xe7\xf5es de m\xe1quina a m\xe1quina podem ter fun\xe7\xf5es associadas.",
    role_exists: "O id da fun\xe7\xe3o {{roleId}} j\xe1 foi adicionado a esta aplica\xe7\xe3o.",
    invalid_role_type: "N\xe3o \xe9 poss\xedvel atribuir uma fun\xe7\xe3o de tipo de utilizador a uma aplica\xe7\xe3o de m\xe1quina a m\xe1quina.",
    invalid_third_party_application_type: "Apenas aplica\xe7\xf5es web tradicionais podem ser marcadas como uma aplica\xe7\xe3o de terceiros.",
    third_party_application_only: "A funcionalidade s\xf3 est\xe1 dispon\xedvel para aplica\xe7\xf5es de terceiros.",
    user_consent_scopes_not_found: "Escopos de consentimento de utilizador inv\xe1lidos.",
    consent_management_api_scopes_not_allowed: "Os escopos de API de gest\xe3o n\xe3o s\xe3o permitidos.",
    protected_app_metadata_is_required: "Metadados de aplica\xe7\xe3o protegida s\xe3o necess\xe1rios.",
    protected_app_not_configured: "O provedor de aplica\xe7\xe3o protegida n\xe3o est\xe1 configurado. Esta funcionalidade n\xe3o est\xe1 dispon\xedvel na vers\xe3o de c\xf3digo aberto.",
    cloudflare_unknown_error: "Erro desconhecido ao solicitar API da Cloudflare",
    protected_application_only: "A funcionalidade s\xf3 est\xe1 dispon\xedvel para aplica\xe7\xf5es protegidas.",
    protected_application_misconfigured: "Aplica\xe7\xe3o protegida est\xe1 mal configurada.",
    protected_application_subdomain_exists: "O subdom\xednio da aplica\xe7\xe3o protegida j\xe1 est\xe1 em uso.",
    invalid_subdomain: "Subdom\xednio inv\xe1lido.",
    custom_domain_not_found: "Dom\xednio personalizado n\xe3o encontrado.",
    should_delete_custom_domains_first: "Deve eliminar primeiro os dom\xednios personalizados."
};
var $8db96022be1f4625$export$2e2bcd8739ae039 = Object.freeze($8db96022be1f4625$var$application);


const $8b270c1b79507a6a$var$auth = {
    authorization_header_missing: "O cabe\xe7alho de autoriza\xe7\xe3o est\xe1 ausente.",
    authorization_token_type_not_supported: "O tipo de autoriza\xe7\xe3o n\xe3o \xe9 suportado.",
    unauthorized: "N\xe3o autorizado. Verifique as credenciais e o scope.",
    forbidden: "Proibido. Verifique os seus cargos e permiss\xf5es.",
    expected_role_not_found: "Role esperado n\xe3o encontrado. Verifique os seus cargos e permiss\xf5es.",
    jwt_sub_missing: "Campo `sub` est\xe1 ausente no JWT.",
    require_re_authentication: "\xc9 necess\xe1ria uma nova autentica\xe7\xe3o para executar uma a\xe7\xe3o protegida."
};
var $8b270c1b79507a6a$export$2e2bcd8739ae039 = Object.freeze($8b270c1b79507a6a$var$auth);


const $174703ad7c909878$var$connector = {
    general: "Ocorreu um erro no conector: {{errorDescription}}",
    not_found: "N\xe3o \xe9 poss\xedvel encontrar nenhum conector dispon\xedvel para o tipo: {{type}}.",
    not_enabled: "O conector n\xe3o est\xe1 ativo.",
    invalid_metadata: "Os metadados do conector s\xe3o inv\xe1lidos.",
    invalid_config_guard: "A configura\xe7\xe3o de prote\xe7\xe3o do conector \xe9 inv\xe1lida.",
    unexpected_type: "O tipo do conector \xe9 inesperado.",
    invalid_request_parameters: "O pedido tem par\xe2metros de entrada inv\xe1lidos.",
    insufficient_request_parameters: "A solicita\xe7\xe3o pode perder alguns par\xe2metros de entrada.",
    invalid_config: "A configura\xe7\xe3o do conector \xe9 inv\xe1lida.",
    invalid_certificate: "O certificado do conector \xe9 inv\xe1lido, certifique-se de que o certificado est\xe1 codificado em PEM.",
    invalid_response: "A resposta do conector \xe9 inv\xe1lida.",
    template_not_found: "N\xe3o foi poss\xedvel encontrar o modelo correto na configura\xe7\xe3o do conector.",
    template_not_supported: "O conector n\xe3o suporta este tipo de modelo.",
    rate_limit_exceeded: "Limite de taxa de ativa\xe7\xe3o. Por favor, tente novamente mais tarde.",
    not_implemented: "{{method}}: ainda n\xe3o foi implementado.",
    social_invalid_access_token: "O token de acesso do conector \xe9 inv\xe1lido.",
    invalid_auth_code: "O c\xf3digo de autentica\xe7\xe3o do conector \xe9 inv\xe1lido.",
    social_invalid_id_token: "O token de ID do conector \xe9 inv\xe1lido.",
    authorization_failed: "O processo de autoriza\xe7\xe3o do usu\xe1rio n\xe3o foi bem-sucedido.",
    social_auth_code_invalid: "N\xe3o foi poss\xedvel obter o token de acesso, verifique o c\xf3digo de autoriza\xe7\xe3o.",
    more_than_one_sms: "O n\xfamero de conectores SMS \xe9 maior que 1.",
    more_than_one_email: "O n\xfamero de conectores de e-mail \xe9 maior que 1.",
    more_than_one_connector_factory: "Foram encontradas v\xe1rias f\xe1bricas de conectores (com id {{connectorIds}}), pode desinstalar as desnecess\xe1rias.",
    db_connector_type_mismatch: "H\xe1 um conector no banco de dados que n\xe3o corresponde ao tipo.",
    not_found_with_connector_id: "N\xe3o foi poss\xedvel encontrar o conector com o id do conector padr\xe3o fornecido.",
    multiple_instances_not_supported: "N\xe3o \xe9 poss\xedvel criar v\xe1rias inst\xe2ncias com o conector padr\xe3o selecionado.",
    invalid_type_for_syncing_profile: "Voc\xea s\xf3 pode sincronizar o perfil do usu\xe1rio com conectores sociais.",
    can_not_modify_target: "O 'target' do conector n\xe3o pode ser modificado.",
    should_specify_target: "Voc\xea deve especificar o alvo (target).",
    multiple_target_with_same_platform: "N\xe3o \xe9 poss\xedvel ter v\xe1rios conectores sociais com o mesmo alvo e plataforma.",
    cannot_overwrite_metadata_for_non_standard_connector: "Os metadados deste conector n\xe3o podem ser sobrescritos."
};
var $174703ad7c909878$export$2e2bcd8739ae039 = Object.freeze($174703ad7c909878$var$connector);


const $8c8ad93033bac908$var$domain = {
    not_configured: "O provedor de nome de host de dom\xednio n\xe3o est\xe1 configurado.",
    cloudflare_data_missing: "cloudflare_data est\xe1 faltando, por favor verifique.",
    cloudflare_unknown_error: "Obteve um erro desconhecido ao solicitar a API Cloudflare",
    cloudflare_response_error: "Obteve uma resposta inesperada da Cloudflare.",
    limit_to_one_domain: "Voc\xea s\xf3 pode ter um dom\xednio personalizado.",
    hostname_already_exists: "Este dom\xednio j\xe1 existe em nosso servidor.",
    cloudflare_not_found: "N\xe3o \xe9 poss\xedvel encontrar o nome de host no Cloudflare",
    domain_is_not_allowed: "Este dom\xednio n\xe3o \xe9 permitido."
};
var $8c8ad93033bac908$export$2e2bcd8739ae039 = Object.freeze($8c8ad93033bac908$var$domain);


const $7fc5b39891f2ff0c$var$entity = {
    invalid_input: "Entrada inv\xe1lida. A lista de valores n\xe3o deve estar vazia.",
    create_failed: "Falha ao criar {{name}}.",
    db_constraint_violated: "Restri\xe7\xe3o do banco de dados violada.",
    not_exists: "{{name}} n\xe3o existe.",
    not_exists_with_id: "{{name}} com o ID '{{id}}' n\xe3o existe.",
    not_found: "O recurso n\xe3o existe.",
    relation_foreign_key_not_found: "N\xe3o \xe9 poss\xedvel encontrar uma ou mais chaves estrangeiras. Por favor, verifique a entrada e certifique-se de que todas as entidades referenciadas existam.",
    unique_integrity_violation: "A entidade j\xe1 existe. Por favor, verifique a entrada e tente novamente."
};
var $7fc5b39891f2ff0c$export$2e2bcd8739ae039 = Object.freeze($7fc5b39891f2ff0c$var$entity);


const $2d286ff984f8fdcc$var$guard = {
    invalid_input: "O pedido {{type}} \xe9 inv\xe1lido.",
    invalid_pagination: "O valor de pagina\xe7\xe3o enviado \xe9 inv\xe1lido.",
    can_not_get_tenant_id: "N\xe3o \xe9 poss\xedvel obter o ID do inquilino a partir do pedido.",
    file_size_exceeded: "Tamanho do ficheiro excedido.",
    mime_type_not_allowed: "Tipo MIME n\xe3o permitido."
};
var $2d286ff984f8fdcc$export$2e2bcd8739ae039 = Object.freeze($2d286ff984f8fdcc$var$guard);


const $088475afb8b40a1a$var$hook = {
    missing_events: "Voc\xea precisa fornecer pelo menos um evento.",
    send_test_payload_failed: "Falha ao enviar carga de teste: {{message}}",
    endpoint_responded_with_error: "O ponto de extremidade respondeu com erro."
};
var $088475afb8b40a1a$export$2e2bcd8739ae039 = Object.freeze($088475afb8b40a1a$var$hook);


const $a23c597436262538$var$jwt_customizer = {
    general: "Ocorreu um erro ao personalizar o token JWT. Por favor, tente novamente mais tarde.",
    can_not_create_for_admin_tenant: "N\xe3o \xe9 poss\xedvel criar um personalizador de token JWT para o inquilino administrativo."
};
var $a23c597436262538$export$2e2bcd8739ae039 = Object.freeze($a23c597436262538$var$jwt_customizer);


const $b108df222bef8d46$var$localization = {
    cannot_delete_default_language: "{{languageTag}} \xe9 o seu idioma padr\xe3o e n\xe3o pode ser exclu\xeddo.",
    invalid_translation_structure: "Estrutura de dados inv\xe1lida. Verifique sua entrada e tente novamente."
};
var $b108df222bef8d46$export$2e2bcd8739ae039 = Object.freeze($b108df222bef8d46$var$localization);


const $ef306fd815ff809c$var$log = {
    invalid_type: "O tipo de registro \xe9 inv\xe1lido."
};
var $ef306fd815ff809c$export$2e2bcd8739ae039 = Object.freeze($ef306fd815ff809c$var$log);


const $4bfa74a6454c609f$var$oidc = {
    aborted: "O utilizador final abortou a intera\xe7\xe3o.",
    invalid_scope: "\xc2mbito inv\xe1lido: {{error_description}}.",
    invalid_token: "O Token fornecido \xe9 inv\xe1lido.",
    invalid_client_metadata: "Metadados de cliente inv\xe1lidos fornecidos.",
    insufficient_scope: "Token em falta com \xe2mbito `{{scope}}`.",
    invalid_request: "Pedido inv\xe1lido.",
    invalid_grant: "Pedido Grant inv\xe1lido.",
    invalid_redirect_uri: "`redirect_uri` n\xe3o correspondeu a nenhum dos `redirect_uris` registados.",
    access_denied: "Acesso negado.",
    invalid_target: "Indicador de recurso inv\xe1lido.",
    unsupported_grant_type: "`grant_type` solicitado n\xe3o \xe9 suportado.",
    unsupported_response_mode: "`response_mode` solicitado n\xe3o \xe9 suportado.",
    unsupported_response_type: "`response_type` solicitado n\xe3o \xe9 suportado.",
    provider_error: "Erro interno OIDC: {{message}}.",
    server_error: "Ocorreu um erro OIDC desconhecido. Por favor, tente novamente mais tarde.",
    provider_error_fallback: "Ocorreu um erro OIDC: {{code}}.",
    key_required: "Pelo menos uma chave \xe9 necess\xe1ria.",
    key_not_found: "A chave com ID {{id}} n\xe3o foi encontrada."
};
var $4bfa74a6454c609f$export$2e2bcd8739ae039 = Object.freeze($4bfa74a6454c609f$var$oidc);


const $f4f09f4fd26c1242$var$organization = {
    require_membership: "O utilizador deve ser membro da organiza\xe7\xe3o para avan\xe7ar."
};
var $f4f09f4fd26c1242$export$2e2bcd8739ae039 = Object.freeze($f4f09f4fd26c1242$var$organization);


const $6c4aa2a642ff1dd7$var$password = {
    unsupported_encryption_method: "O m\xe9todo de encripta\xe7\xe3o {{name}} n\xe3o \xe9 suportado.",
    pepper_not_found: "pepper da Password n\xe3o encontrada. Por favor, verifique os envs.",
    rejected: "Senha rejeitada. Por favor, verifique se sua senha atende aos requisitos."
};
var $6c4aa2a642ff1dd7$export$2e2bcd8739ae039 = Object.freeze($6c4aa2a642ff1dd7$var$password);


const $d92d6d8e14d25b93$var$request = {
    invalid_input: "Input inv\xe1lido. {{details}}",
    general: "Ocorreu um erro no pedido."
};
var $d92d6d8e14d25b93$export$2e2bcd8739ae039 = Object.freeze($d92d6d8e14d25b93$var$request);


const $0bc3f9a44e35d77c$var$resource = {
    resource_identifier_in_use: "O identificador da API {{indicator}} j\xe1 est\xe1 em uso",
    cannot_delete_management_api: "N\xe3o \xe9 poss\xedvel excluir a API de gest\xe3o do Logto.",
    cannot_modify_management_api: "N\xe3o \xe9 poss\xedvel modificar a API de gest\xe3o do Logto."
};
var $0bc3f9a44e35d77c$export$2e2bcd8739ae039 = Object.freeze($0bc3f9a44e35d77c$var$resource);


const $abdc17ac27be27d2$var$role = {
    name_in_use: "Este nome de fun\xe7\xe3o {{name}} j\xe1 est\xe1 em uso",
    scope_exists: "O id do escopo {{scopeId}} j\xe1 foi adicionado a esta fun\xe7\xe3o",
    management_api_scopes_not_assignable_to_user_role: "N\xe3o \xe9 poss\xedvel atribuir escopos da API de gest\xe3o a uma fun\xe7\xe3o de usu\xe1rio.",
    user_exists: "O id do usu\xe1rio {{userId}} j\xe1 foi adicionado a esta fun\xe7\xe3o",
    application_exists: "O id de aplica\xe7\xe3o {{applicationId}} j\xe1 foi adicionado a esta fun\xe7\xe3o",
    default_role_missing: "Alguns dos nomes de fun\xe7\xe3o padr\xe3o n\xe3o existem no banco de dados, por favor, certifique-se de criar as fun\xe7\xf5es primeiro",
    internal_role_violation: 'Voc\xea pode estar tentando atualizar ou excluir uma fun\xe7\xe3o interna que \xe9 proibida pelo Logto. Se voc\xea estiver criando uma nova fun\xe7\xe3o, tente outro nome que n\xe3o comece com "#internal:". '
};
var $abdc17ac27be27d2$export$2e2bcd8739ae039 = Object.freeze($abdc17ac27be27d2$var$role);


const $7985704c34f1666f$var$scope = {
    name_exists: "O nome do escopo {{name}} j\xe1 est\xe1 em uso",
    name_with_space: "O nome do escopo n\xe3o pode conter espa\xe7os."
};
var $7985704c34f1666f$export$2e2bcd8739ae039 = Object.freeze($7985704c34f1666f$var$scope);


const $e62476e0f0089a50$var$session = {
    not_found: "Sess\xe3o n\xe3o encontrada. Por favor, volte e fa\xe7a login novamente.",
    invalid_credentials: "Credenciais inv\xe1lidas. Por favor, verifique os dados.",
    invalid_sign_in_method: "O m\xe9todo de login atual n\xe3o est\xe1 dispon\xedvel.",
    invalid_connector_id: "N\xe3o foi poss\xedvel encontrar um conector dispon\xedvel com o id {{connectorId}}.",
    insufficient_info: "Informa\xe7\xf5es de login insuficientes.",
    connector_id_mismatch: "O connectorId n\xe3o corresponde ao registado na sess\xe3o.",
    connector_session_not_found: "Sess\xe3o do conector n\xe3o encontrada. Por favor, volte e fa\xe7a login novamente.",
    verification_session_not_found: "A verifica\xe7\xe3o n\xe3o foi bem-sucedida. Reinicie o processo de verifica\xe7\xe3o e tente novamente.",
    verification_expired: "A conex\xe3o expirou. Verifique novamente para garantir a seguran\xe7a de sua conta.",
    verification_blocked_too_many_attempts: "Muitas tentativas em um curto per\xedodo de tempo. Por favor, tente novamente {{relativeTime}}.",
    unauthorized: "Fa\xe7a login primeiro.",
    unsupported_prompt_name: "Nome de prompt n\xe3o suportado.",
    forgot_password_not_enabled: "Recupera\xe7\xe3o de senha n\xe3o est\xe1 habilitada.",
    verification_failed: "A verifica\xe7\xe3o n\xe3o foi bem-sucedida. Reinicie o processo de verifica\xe7\xe3o e tente novamente.",
    connector_validation_session_not_found: "A sess\xe3o do conector para valida\xe7\xe3o do token n\xe3o foi encontrada.",
    identifier_not_found: "Identificador do usu\xe1rio n\xe3o encontrado. Por favor, volte e fa\xe7a login novamente.",
    interaction_not_found: "Sess\xe3o de intera\xe7\xe3o n\xe3o encontrada. Por favor, volte e inicie a sess\xe3o novamente.",
    not_supported_for_forgot_password: "Esta opera\xe7\xe3o n\xe3o \xe9 suportada para recupera\xe7\xe3o de senha.",
    mfa: {
        require_mfa_verification: "Verifica\xe7\xe3o MFA \xe9 necess\xe1ria para efetuar login.",
        mfa_sign_in_only: "MFA est\xe1 dispon\xedvel apenas para intera\xe7\xe3o de login.",
        pending_info_not_found: "Informa\xe7\xf5es de MFA pendentes n\xe3o encontradas, por favor, inicie o MFA primeiro.",
        invalid_totp_code: "C\xf3digo TOTP inv\xe1lido.",
        webauthn_verification_failed: "A verifica\xe7\xe3o WebAuthn falhou.",
        webauthn_verification_not_found: "Verifica\xe7\xe3o WebAuthn n\xe3o encontrada.",
        bind_mfa_existed: "MFA j\xe1 existe.",
        backup_code_can_not_be_alone: "O c\xf3digo de backup n\xe3o pode ser o \xfanico MFA.",
        backup_code_required: "O c\xf3digo de backup \xe9 necess\xe1rio.",
        invalid_backup_code: "C\xf3digo de backup inv\xe1lido.",
        mfa_policy_not_user_controlled: "A pol\xedtica MFA n\xe3o \xe9 controlada pelo usu\xe1rio."
    },
    sso_enabled: "O login \xfanico est\xe1 habilitado para este e-mail fornecido. Fa\xe7a login com SSO, por favor."
};
var $e62476e0f0089a50$export$2e2bcd8739ae039 = Object.freeze($e62476e0f0089a50$var$session);


const $ad7f3edca83b9653$var$sign_in_experiences = {
    empty_content_url_of_terms_of_use: 'URL dos "Termos de uso" vazio. Adicione o URL se os "Termos de uso" estiverem ativados.',
    empty_social_connectors: "Conectores sociais vazios. Adicione conectores sociais e ative os quando o m\xe9todo de login social estiver ativado.",
    enabled_connector_not_found: "Conector {{type}} ativado n\xe3o encontrado.",
    not_one_and_only_one_primary_sign_in_method: "Deve haver um e apenas um m\xe9todo de login principal. Por favor, verifique sua entrada.",
    username_requires_password: "\xc9 necess\xe1rio habilitar a configura\xe7\xe3o de uma senha para o identificador de inscri\xe7\xe3o por nome de usu\xe1rio.",
    passwordless_requires_verify: "\xc9 necess\xe1rio habilitar a verifica\xe7\xe3o para o identificador de inscri\xe7\xe3o por e-mail/telefone.",
    miss_sign_up_identifier_in_sign_in: "Os m\xe9todos de login devem conter o identificador de inscri\xe7\xe3o.",
    password_sign_in_must_be_enabled: "O login com senha deve ser habilitado quando \xe9 requerido configurar uma senha na inscri\xe7\xe3o.",
    code_sign_in_must_be_enabled: "O login com c\xf3digo de verifica\xe7\xe3o deve ser habilitado quando n\xe3o \xe9 requerido configurar uma senha na inscri\xe7\xe3o.",
    unsupported_default_language: "Este idioma - {{language}} n\xe3o \xe9 suportado no momento.",
    at_least_one_authentication_factor: "Voc\xea deve selecionar pelo menos um fator de autentica\xe7\xe3o.",
    backup_code_cannot_be_enabled_alone: "O c\xf3digo de backup n\xe3o pode ser ativado sozinho.",
    duplicated_mfa_factors: "Fatores MFA duplicados."
};
var $ad7f3edca83b9653$export$2e2bcd8739ae039 = Object.freeze($ad7f3edca83b9653$var$sign_in_experiences);


const $9f48b20349eae86b$var$single_sign_on = {
    forbidden_domains: "Os dom\xednios de email p\xfablico n\xe3o s\xe3o permitidos.",
    duplicated_domains: "Existem dom\xednios duplicados.",
    invalid_domain_format: "Formato de dom\xednio inv\xe1lido.",
    duplicate_connector_name: "O nome do conector j\xe1 existe. Por favor, escolha um nome diferente."
};
var $9f48b20349eae86b$export$2e2bcd8739ae039 = Object.freeze($9f48b20349eae86b$var$single_sign_on);


const $5d2f8edf2024a982$var$storage = {
    not_configured: "O provedor de armazenamento n\xe3o est\xe1 configurado.",
    missing_parameter: "Faltando o par\xe2metro {{parameter}} para o provedor de armazenamento.",
    upload_error: "Falha ao enviar o arquivo para o provedor de armazenamento."
};
var $5d2f8edf2024a982$export$2e2bcd8739ae039 = Object.freeze($5d2f8edf2024a982$var$storage);


const $a05a1a037c258cda$var$subscription = {
    limit_exceeded: "Voc\xea atingiu o limite do seu plano de assinatura.",
    get_plan_failed: "N\xe3o foi poss\xedvel obter o plano de assinatura para o inquilino.",
    tenant_suspended: "O inquilino est\xe1 suspenso. Por favor, entre em contato com o administrador."
};
var $a05a1a037c258cda$export$2e2bcd8739ae039 = Object.freeze($a05a1a037c258cda$var$subscription);


const $6887547cbd266c2b$var$swagger = {
    invalid_zod_type: "Tipo de Zod inv\xe1lido. Verifique a configura\xe7\xe3o do protetor de rota.",
    not_supported_zod_type_for_params: "Tipo Zod n\xe3o suportado para os par\xe2metros. Verifique a configura\xe7\xe3o do protetor de rota."
};
var $6887547cbd266c2b$export$2e2bcd8739ae039 = Object.freeze($6887547cbd266c2b$var$swagger);


const $7b14e3d0f1a6a49b$var$user = {
    username_already_in_use: "Este nome de utilizador j\xe1 est\xe1 em uso.",
    email_already_in_use: "Este email j\xe1 est\xe1 associado a uma conta existente.",
    phone_already_in_use: "Este n\xfamero de telefone j\xe1 est\xe1 associado a uma conta existente.",
    invalid_email: "Endere\xe7o de email inv\xe1lido.",
    invalid_phone: "N\xfamero de telefone inv\xe1lido.",
    email_not_exist: "O endere\xe7o de email ainda n\xe3o foi registado.",
    phone_not_exist: "O n\xfamero de telefone ainda n\xe3o foi registado.",
    identity_not_exist: "A conta social ainda n\xe3o foi registada.",
    identity_already_in_use: "A conta social foi registada.",
    social_account_exists_in_profile: "A conta social j\xe1 foi associada a este perfil.",
    cannot_delete_self: "N\xe3o se pode remover a si mesmo.",
    sign_up_method_not_enabled: "Este m\xe9todo de registo n\xe3o est\xe1 ativo.",
    sign_in_method_not_enabled: "Este m\xe9todo de in\xedcio de sess\xe3o n\xe3o est\xe1 ativo.",
    same_password: "A nova palavra-passe n\xe3o pode ser igual \xe0 antiga.",
    password_required_in_profile: "Precisa de definir uma palavra-passe antes de iniciar sess\xe3o.",
    new_password_required_in_profile: "Precisa de definir uma nova palavra-passe.",
    password_exists_in_profile: "A palavra-passe j\xe1 existe no seu perfil.",
    username_required_in_profile: "Precisa de definir um nome de utilizador antes de iniciar sess\xe3o.",
    username_exists_in_profile: "O nome de utilizador j\xe1 existe no seu perfil.",
    email_required_in_profile: "Precisa de adicionar um endere\xe7o de email antes de iniciar sess\xe3o.",
    email_exists_in_profile: "O seu perfil j\xe1 est\xe1 associado a um endere\xe7o de email.",
    phone_required_in_profile: "Precisa de adicionar um n\xfamero de telefone antes de iniciar sess\xe3o.",
    phone_exists_in_profile: "O seu perfil j\xe1 est\xe1 associado a um n\xfamero de telefone.",
    email_or_phone_required_in_profile: "Precisa de adicionar um endere\xe7o de email ou um n\xfamero de telefone antes de iniciar sess\xe3o.",
    suspended: "Esta conta est\xe1 suspensa.",
    user_not_exist: "O utilizador com {{ identifier }} n\xe3o existe.",
    missing_profile: "Precisa de fornecer informa\xe7\xf5es adicionais antes de iniciar sess\xe3o.",
    role_exists: "O id da fun\xe7\xe3o {{roleId}} j\xe1 foi adicionado a este utilizador.",
    invalid_role_type: "Tipo de fun\xe7\xe3o inv\xe1lido, n\xe3o \xe9 poss\xedvel atribuir uma fun\xe7\xe3o m\xe1quina a m\xe1quina ao utilizador.",
    missing_mfa: "You need to bind additional MFA before signing-in.",
    totp_already_in_use: "TOTP is already in use.",
    backup_code_already_in_use: "Backup code is already in use.",
    password_algorithm_required: "Password algorithm is required.",
    password_and_digest: "You cannot set both plain text password and password digest."
};
var $7b14e3d0f1a6a49b$export$2e2bcd8739ae039 = Object.freeze($7b14e3d0f1a6a49b$var$user);


const $a84d6b23f4417b68$var$verification_code = {
    phone_email_empty: "Tanto o telefone como o e-mail est\xe3o vazios.",
    not_found: "C\xf3digo de verifica\xe7\xe3o n\xe3o encontrado. Por favor, envie primeiro o c\xf3digo de verifica\xe7\xe3o.",
    phone_mismatch: "Telefone n\xe3o corresponde. Por favor, solicite um novo c\xf3digo de verifica\xe7\xe3o.",
    email_mismatch: "E-mail n\xe3o corresponde. Por favor, solicite um novo c\xf3digo de verifica\xe7\xe3o.",
    code_mismatch: "C\xf3digo de verifica\xe7\xe3o inv\xe1lido.",
    expired: "O c\xf3digo de verifica\xe7\xe3o expirou. Por favor, solicite um novo c\xf3digo de verifica\xe7\xe3o.",
    exceed_max_try: "Limite m\xe1ximo de tentativas de verifica\xe7\xe3o excedido. Por favor, solicite um novo c\xf3digo de verifica\xe7\xe3o."
};
var $a84d6b23f4417b68$export$2e2bcd8739ae039 = Object.freeze($a84d6b23f4417b68$var$verification_code);


const $4954da1eb2d7780c$var$errors = {
    request: $d92d6d8e14d25b93$export$2e2bcd8739ae039,
    auth: $8b270c1b79507a6a$export$2e2bcd8739ae039,
    guard: $2d286ff984f8fdcc$export$2e2bcd8739ae039,
    oidc: $4bfa74a6454c609f$export$2e2bcd8739ae039,
    user: $7b14e3d0f1a6a49b$export$2e2bcd8739ae039,
    password: $6c4aa2a642ff1dd7$export$2e2bcd8739ae039,
    session: $e62476e0f0089a50$export$2e2bcd8739ae039,
    connector: $174703ad7c909878$export$2e2bcd8739ae039,
    verification_code: $a84d6b23f4417b68$export$2e2bcd8739ae039,
    sign_in_experiences: $ad7f3edca83b9653$export$2e2bcd8739ae039,
    jwt_customizer: $a23c597436262538$export$2e2bcd8739ae039,
    localization: $b108df222bef8d46$export$2e2bcd8739ae039,
    swagger: $6887547cbd266c2b$export$2e2bcd8739ae039,
    entity: $7fc5b39891f2ff0c$export$2e2bcd8739ae039,
    log: $ef306fd815ff809c$export$2e2bcd8739ae039,
    role: $abdc17ac27be27d2$export$2e2bcd8739ae039,
    scope: $7985704c34f1666f$export$2e2bcd8739ae039,
    storage: $5d2f8edf2024a982$export$2e2bcd8739ae039,
    resource: $0bc3f9a44e35d77c$export$2e2bcd8739ae039,
    hook: $088475afb8b40a1a$export$2e2bcd8739ae039,
    domain: $8c8ad93033bac908$export$2e2bcd8739ae039,
    subscription: $a05a1a037c258cda$export$2e2bcd8739ae039,
    application: $8db96022be1f4625$export$2e2bcd8739ae039,
    organization: $f4f09f4fd26c1242$export$2e2bcd8739ae039,
    single_sign_on: $9f48b20349eae86b$export$2e2bcd8739ae039
};
var $4954da1eb2d7780c$export$2e2bcd8739ae039 = Object.freeze($4954da1eb2d7780c$var$errors);


const $e529bf5fac8cc41e$var$api_resource_details = {
    page_title: "Detalhes do recurso da API",
    back_to_api_resources: "Voltar aos recursos da API",
    general_tab: "Geral",
    permissions_tab: "Permiss\xf5es",
    settings: "Defini\xe7\xf5es",
    settings_description: "Os recursos da API, tamb\xe9m conhecidos como indicadores de recursos, indicam os servi\xe7os ou recursos de destino a serem solicitados, geralmente uma vari\xe1vel no formato URI que representa a identidade do recurso.",
    management_api_settings_description: "A API de Gest\xe3o do Logto \xe9 uma cole\xe7\xe3o abrangente de APIs que capacitam os administradores a gerenciar uma ampla gama de tarefas relacionadas \xe0 identidade, aplicar pol\xedticas de seguran\xe7a e cumprir regulamentos e padr\xf5es.",
    management_api_notice: "Esta API representa a entidade Logto e n\xe3o pode ser modificada ou eliminada. Crie uma aplica\xe7\xe3o de m\xe1quina para m\xe1quina para chamar a API de gest\xe3o do Logto. <a>Saiba mais</a>",
    token_expiration_time_in_seconds: "Tempo de expira\xe7\xe3o do token (em segundos)",
    token_expiration_time_in_seconds_placeholder: "Insira o tempo de expira\xe7\xe3o do token",
    delete_description: "Esta a\xe7\xe3o n\xe3o pode ser desfeita. Isso ir\xe1 eliminar permanentemente o recurso da API. Insira o nome do recurso <span>{{name}}</span> para confirmar.",
    enter_your_api_resource_name: "Digite o nome do recurso da API",
    api_resource_deleted: "O recurso da API {{name}} foi eliminado com sucesso",
    permission: {
        create_button: "Criar permiss\xe3o",
        create_title: "Criar permiss\xe3o",
        create_subtitle: "Define as permiss\xf5es (escopos) necess\xe1rios para essa API.",
        confirm_create: "Criar permiss\xe3o",
        edit_title: "Editar permiss\xe3o da API",
        edit_subtitle: "Define as permiss\xf5es (escopos) necess\xe1rios pela API {{resourceName}}.",
        name: "Nome da permiss\xe3o",
        name_placeholder: "leitura:recurso",
        forbidden_space_in_name: "O nome da permiss\xe3o n\xe3o pode conter espa\xe7os.",
        description: "Descri\xe7\xe3o",
        description_placeholder: "Capaz de ler os recursos",
        permission_created: "A permiss\xe3o {{name}} foi criada com sucesso",
        delete_description: "Se esta permiss\xe3o for exclu\xedda, o usu\xe1rio que tinha esta permiss\xe3o perder\xe1 o acesso concedido por ela.",
        deleted: 'A permiss\xe3o "{{name}}" foi exclu\xedda com sucesso.'
    }
};
var $e529bf5fac8cc41e$export$2e2bcd8739ae039 = Object.freeze($e529bf5fac8cc41e$var$api_resource_details);


const $7a207964d707de8f$var$api_resources = {
    page_title: "Recursos da API",
    title: "Recursos da API",
    subtitle: "Defina as APIs que podem ser consumidas pelas aplica\xe7\xf5es autorizadas",
    create: "Criar recurso da API",
    api_name: "Nome da API",
    api_name_placeholder: "Insira o nome da sua API",
    api_identifier: "Identificador da API",
    api_identifier_placeholder: "https://seu-identificador-de-api/",
    api_identifier_tip: "O identificador exclusivo para o recurso da API. Deve ser um URI absoluto e n\xe3o ter um componente de fragmento (#). Igual ao <a>par\xe2metro resource</a> no OAuth 2.0.",
    default_api: "API padr\xe3o",
    default_api_label: "Apenas uma API padr\xe3o pode ser definida por inquilino. Quando uma API padr\xe3o \xe9 definida, o par\xe2metro de recurso pode ser omitido na solicita\xe7\xe3o de autoriza\xe7\xe3o. Subsequentes trocas de token usar\xe3o essa API como audi\xeancia por padr\xe3o, resultando na emiss\xe3o de JWTs. <a>Saiba mais</a>",
    api_resource_created: "O recurso da API {{name}} foi criado com sucesso",
    invalid_resource_indicator_format: "O indicador da API deve ser um URI absoluto v\xe1lido."
};
var $7a207964d707de8f$export$2e2bcd8739ae039 = Object.freeze($7a207964d707de8f$var$api_resources);


const $70ab11b5b69b13b1$var$application_details = {
    page_title: "Detalhes da aplica\xe7\xe3o",
    back_to_applications: "Voltar para aplica\xe7\xf5es",
    check_guide: "Guia de verifica\xe7\xe3o",
    settings: "Defini\xe7\xf5es",
    settings_description: 'Uma "Aplica\xe7\xe3o" \xe9 um software ou servi\xe7o registado que pode aceder \xe0s informa\xe7\xf5es do utilizador ou agir em nome de um utilizador. As aplica\xe7\xf5es ajudam a reconhecer quem est\xe1 a pedir o qu\xea \xe0 Logto e a gerir o in\xedcio de sess\xe3o e as permiss\xf5es. Preencha os campos obrigat\xf3rios para autentica\xe7\xe3o.',
    integration: "Integra\xe7\xe3o",
    integration_description: "Implemente com os trabalhadores seguros da Logto, alimentados pela rede de borda da Cloudflare para um desempenho de primeira classe e in\xedcios instant\xe2neos a 0ms em todo o mundo.",
    service_configuration: "Configura\xe7\xe3o do servi\xe7o",
    service_configuration_description: "Complete as configura\xe7\xf5es necess\xe1rias no seu servi\xe7o.",
    session: "Sess\xe3o",
    endpoints_and_credentials: "Endpoints & Credenciais",
    endpoints_and_credentials_description: "Utilize os seguintes endpoints e credenciais para configurar a liga\xe7\xe3o OIDC na sua aplica\xe7\xe3o.",
    refresh_token_settings: "Token de atualiza\xe7\xe3o",
    refresh_token_settings_description: "Gerir as regras de token de atualiza\xe7\xe3o para esta aplica\xe7\xe3o.",
    application_roles: "Fun\xe7\xf5es da aplica\xe7\xe3o",
    machine_logs: "Registos da m\xe1quina",
    application_name: "Nome da aplica\xe7\xe3o",
    application_name_placeholder: "Ex: Site da Empresa",
    description: "Descri\xe7\xe3o",
    description_placeholder: "Insira a descri\xe7\xe3o da sua aplica\xe7\xe3o",
    config_endpoint: "Endpoint de configura\xe7\xe3o do Provedor de ID Aberto",
    authorization_endpoint: "Endpoint de autoriza\xe7\xe3o",
    authorization_endpoint_tip: "O endpoint para realizar a autentica\xe7\xe3o e autoriza\xe7\xe3o. \xc9 usado para <a>autentica\xe7\xe3o</a> OpenID Connect.",
    show_endpoint_details: "Mostrar detalhes do endpoint",
    hide_endpoint_details: "Ocultar detalhes do endpoint",
    logto_endpoint: "Endpoint Logto",
    application_id: "ID da aplica\xe7\xe3o",
    application_id_tip: "O identificador exclusivo da aplica\xe7\xe3o normalmente gerado pelo Logto. Tamb\xe9m representa “<a>client_id</a>” no OpenID Connect.",
    application_secret: "Segredo da aplica\xe7\xe3o",
    redirect_uri: "URI de redirecionamento",
    redirect_uris: "URIs de redirecionamento",
    redirect_uri_placeholder: "https://seusite.com/app",
    redirect_uri_placeholder_native: "io.logto://callback",
    redirect_uri_tip: "O URI para redirecionar ap\xf3s o in\xedcio de sess\xe3o de um utilizador (com sucesso ou insucesso). Consulte a <a>AuthRequest</a> do OpenID Connect para obter mais informa\xe7\xf5es.",
    post_sign_out_redirect_uri: "URI de redirecionamento p\xf3s-sa\xedda",
    post_sign_out_redirect_uris: "URIs de redirecionamento p\xf3s-sa\xedda",
    post_sign_out_redirect_uri_placeholder: "https://seusite.com/home",
    post_sign_out_redirect_uri_tip: "O URI para redirecionar ap\xf3s a sa\xedda de um utilizador (opcional). Pode n\xe3o ter efeito pr\xe1tico em alguns tipos de aplica\xe7\xf5es.",
    cors_allowed_origins: "Origens permitidas pelo CORS",
    cors_allowed_origins_placeholder: "https://seusite.com",
    cors_allowed_origins_tip: "Por padr\xe3o, todas as origens de redirecionamento s\xe3o permitidas. Recomenda-se restringi-las. Consulte a <a>documenta\xe7\xe3o MDN</a> para obter informa\xe7\xf5es detalhadas.",
    token_endpoint: "Endpoint do token",
    user_info_endpoint: "Endpoint do Utilizador",
    enable_admin_access: "Ativar o acesso de administrador",
    enable_admin_access_label: "Ativar ou desativar o acesso \xe0 API de gest\xe3o. Uma vez ativado, pode utilizar tokens de acesso para chamar a API de gest\xe3o em nome desta aplica\xe7\xe3o.",
    always_issue_refresh_token: "Sempre emitir token de atualiza\xe7\xe3o",
    always_issue_refresh_token_label: "Ao ativar essa configura\xe7\xe3o, a Logto sempre emitir\xe1 tokens de atualiza\xe7\xe3o, independentemente de `prompt = consent` ser apresentado na solicita\xe7\xe3o de autentica\xe7\xe3o. No entanto, essa pr\xe1tica \xe9 desencorajada, a menos que seja necess\xe1ria, pois n\xe3o \xe9 compat\xedvel com OpenID Connect e pode causar problemas.",
    refresh_token_ttl: "Tempo de vida do token de atualiza\xe7\xe3o em dias",
    refresh_token_ttl_tip: "O tempo pelo qual um token de atualiza\xe7\xe3o pode ser usado para solicitar novos tokens de acesso antes de expirar e se tornar inv\xe1lido. As solicita\xe7\xf5es de token estender\xe3o o TTL do token de atualiza\xe7\xe3o para esse valor.",
    rotate_refresh_token: "Rotacionar o token de atualiza\xe7\xe3o",
    rotate_refresh_token_label: "Quando ativado, o Logto emitir\xe1 um novo token de atualiza\xe7\xe3o para solicita\xe7\xf5es de token quando 70% do tempo de vida original (TTL) tiver passado ou certas condi\xe7\xf5es forem atendidas. <a>Saiba mais</a>",
    delete_description: "Esta a\xe7\xe3o n\xe3o pode ser revertida. Esta a\xe7\xe3o ir\xe1 eliminar permanentemente a aplica\xe7\xe3o. Insira o nome da aplica\xe7\xe3o <span>{{name}}</span> para confirmar.",
    enter_your_application_name: "Insira o nome da aplica\xe7\xe3o",
    application_deleted: "Aplica\xe7\xe3o {{name}} eliminada com sucesso",
    redirect_uri_required: "Deve inserir pelo menos um URI de redirecionamento",
    app_domain_description_1: "Sinta-se \xe0 vontade para utilizar o seu dom\xednio com {{domain}} alimentado pela Logto, que \xe9 permanentemente v\xe1lido.",
    app_domain_description_2: "Sinta-se \xe0 vontade para utilizar o seu dom\xednio <domain>{{domain}}</domain> que \xe9 permanentemente v\xe1lido.",
    custom_rules: "Regras de autentica\xe7\xe3o personalizadas",
    custom_rules_placeholder: "^/(admin|privacy)/.+$",
    custom_rules_description: "Defina regras com express\xf5es regulares para rotas que requerem autentica\xe7\xe3o. Padr\xe3o: prote\xe7\xe3o de todo o site se ficar em branco.",
    authentication_routes: "Rotas de autentica\xe7\xe3o",
    custom_rules_tip: "Aqui est\xe3o dois cen\xe1rios poss\xedveis:<ol><li>Para proteger apenas as rotas '/admin' e '/privacy' com autentica\xe7\xe3o: ^/(admin|privacy)/.*</li><li>Para excluir imagens JPG da autentica\xe7\xe3o: ^(?!.*\\.jpg$).*$</li></ol>",
    authentication_routes_description: "Redirecione o seu bot\xe3o de autentica\xe7\xe3o usando as rotas especificadas. Nota: Estas rotas s\xe3o irsubstitu\xedveis.",
    protect_origin_server: "Proteja o seu servidor de origem",
    protect_origin_server_description: "Assegure-se de proteger o seu servidor de origem do acesso direto. Consulte o guia para mais <a>instru\xe7\xf5es detalhadas</a>.",
    session_duration: "Dura\xe7\xe3o da sess\xe3o (dias)",
    try_it: "Experimente",
    branding: {
        name: "Marca",
        description: "Personalize o nome e o log\xf3tipo da sua aplica\xe7\xe3o no ecr\xe3 de consentimento.",
        more_info: "Mais informa\xe7\xf5es",
        more_info_description: "Ofere\xe7a aos utilizadores mais detalhes sobre a sua aplica\xe7\xe3o no ecr\xe3 de consentimento.",
        display_name: "Nome a apresentar",
        display_logo: "Log\xf3tipo a apresentar",
        display_logo_dark: "Log\xf3tipo a apresentar (escuro)",
        terms_of_use_url: "URL dos termos de utiliza\xe7\xe3o da aplica\xe7\xe3o",
        privacy_policy_url: "URL da pol\xedtica de privacidade da aplica\xe7\xe3o"
    },
    permissions: {
        name: "Permiss\xf5es",
        description: "Selecione as permiss\xf5es que a aplica\xe7\xe3o de terceiros requer para a autoriza\xe7\xe3o do utilizador para aceder a tipos espec\xedficos de dados.",
        user_permissions: "Dados pessoais do utilizador",
        organization_permissions: "Acesso \xe0 organiza\xe7\xe3o",
        table_name: "Conceder permiss\xf5es",
        field_name: "Permiss\xe3o",
        field_description: "Mostrado no ecr\xe3 de consentimento",
        delete_text: "Remover permiss\xe3o",
        permission_delete_confirm: "Esta a\xe7\xe3o ir\xe1 retirar as permiss\xf5es concedidas \xe0 aplica\xe7\xe3o de terceiros, impedindo-a de solicitar a autoriza\xe7\xe3o do utilizador para tipos espec\xedficos de dados. Tem a certeza de que deseja continuar?",
        permissions_assignment_description: "Selecione as permiss\xf5es que a aplica\xe7\xe3o de terceiros solicita para a autoriza\xe7\xe3o do utilizador para aceder a tipos espec\xedficos de dados.",
        user_profile: "Dados do utilizador",
        api_permissions: "Permiss\xf5es de API",
        organization: "Permiss\xf5es da organiza\xe7\xe3o",
        user_permissions_assignment_form_title: "Adicionar permiss\xf5es de perfil de utilizador",
        organization_permissions_assignment_form_title: "Adicionar permiss\xf5es da organiza\xe7\xe3o",
        api_resource_permissions_assignment_form_title: "Adicionar permiss\xf5es de recurso da API",
        user_data_permission_description_tips: 'Pode modificar a descri\xe7\xe3o das permiss\xf5es de dados pessoais do utilizador atrav\xe9s de "Experi\xeancia de In\xedcio de Sess\xe3o > Conte\xfado > Gerir Idioma"',
        permission_description_tips: "Quando o Logto \xe9 usado como um Prestador de Identidades (IdP) para autentica\xe7\xe3o em aplica\xe7\xf5es de terceiros, e os utilizadores s\xe3o solicitados para autoriza\xe7\xe3o, esta descri\xe7\xe3o aparece no ecr\xe3 de consentimento.",
        user_title: "Utilizador",
        user_description: "Selecione as permiss\xf5es solicitadas pela aplica\xe7\xe3o de terceiros para aceder a dados espec\xedficos do utilizador.",
        grant_user_level_permissions: "Conceder permiss\xf5es de dados do utilizador",
        organization_title: "Organiza\xe7\xe3o",
        organization_description: "Selecione as permiss\xf5es solicitadas pela aplica\xe7\xe3o de terceiros para aceder a dados espec\xedficos da organiza\xe7\xe3o.",
        grant_organization_level_permissions: "Conceder permiss\xf5es de dados da organiza\xe7\xe3o"
    },
    roles: {
        name_column: "Nome da fun\xe7\xe3o",
        description_column: "Descri\xe7\xe3o",
        assign_button: "Atribuir fun\xe7\xf5es",
        delete_description: "Esta a\xe7\xe3o ir\xe1 remover esta fun\xe7\xe3o desta aplica\xe7\xe3o entre m\xe1quinas. A fun\xe7\xe3o em si ainda existir\xe1, mas n\xe3o ser\xe1 mais associada a esta aplica\xe7\xe3o entre as m\xe1quinas.",
        deleted: "{{name}} foi removido com sucesso deste utilizador.",
        assign_title: "Atribuir fun\xe7\xf5es a {{name}}",
        assign_subtitle: "Autorizar {{name}} uma ou mais fun\xe7\xf5es",
        assign_role_field: "Atribuir fun\xe7\xf5es",
        role_search_placeholder: "Pesquisar por nome de fun\xe7\xe3o",
        added_text: "{{value, number}} adicionado",
        assigned_app_count: "{{value, number}} aplica\xe7\xf5es",
        confirm_assign: "Atribuir fun\xe7\xf5es",
        role_assigned: "Fun\xe7\xe3o(s) atribu\xedda(s) com sucesso",
        search: "Pesquisar por nome, descri\xe7\xe3o ou ID da fun\xe7\xe3o",
        empty: "Nenhuma fun\xe7\xe3o dispon\xedvel"
    }
};
var $70ab11b5b69b13b1$export$2e2bcd8739ae039 = Object.freeze($70ab11b5b69b13b1$var$application_details);


const $89a61c8b2caed3ff$var$applications = {
    page_title: "Aplica\xe7\xf5es",
    title: "Aplica\xe7\xf5es",
    subtitle: "Configure uma aplica\xe7\xe3o m\xf3vel, de p\xe1gina \xfanica, m\xe1quina a m\xe1quina ou tradicional para utilizar o Logto para autentica\xe7\xe3o",
    subtitle_with_app_type: "Configurar autentica\xe7\xe3o Logto para a aplica\xe7\xe3o {{name}}",
    create: "Criar aplica\xe7\xe3o",
    create_subtitle_third_party: "Utilize o Logto como seu fornecedor de identidade (IdP) para integrar facilmente com aplica\xe7\xf5es de terceiros",
    application_name: "Nome da aplica\xe7\xe3o",
    application_name_placeholder: "Ex: Site Empresa",
    application_description: "Descri\xe7\xe3o da aplica\xe7\xe3o",
    application_description_placeholder: "Insira a descri\xe7\xe3o da sua aplica\xe7\xe3o",
    select_application_type: "Selecione o tipo de aplica\xe7\xe3o",
    no_application_type_selected: "Ainda n\xe3o selecionou nenhum tipo de aplica\xe7\xe3o",
    application_created: "A aplica\xe7\xe3o foi criada com sucesso.",
    tab: {
        my_applications: "As minhas apps",
        third_party_applications: "Apps de terceiros"
    },
    app_id: "ID da App",
    type: {
        native: {
            title: "Nativo",
            subtitle: "Uma aplica\xe7\xe3o que \xe9 executada num ambiente nativo",
            description: "Ex.: App iOS, App Android"
        },
        spa: {
            title: "P\xe1gina \xfanica (SPAs)",
            subtitle: "Uma aplica\xe7\xe3o que \xe9 executada num navegador e atualiza dinamicamente os dados",
            description: "Ex.: App React, App VueJS"
        },
        traditional: {
            title: "Web tradicional",
            subtitle: "Uma aplica\xe7\xe3o que renderiza e atualiza p\xe1ginas apenas pelo servidor web",
            description: "Ex.: Next.js, PHP"
        },
        machine_to_machine: {
            title: "M\xe1quina a M\xe1quina",
            subtitle: "Uma aplica\xe7\xe3o (normalmente um servi\xe7o) que comunica diretamente com recursos",
            description: "Ex.: servi\xe7o back-end"
        },
        protected: {
            title: "App Protegida",
            subtitle: "Uma aplica\xe7\xe3o protegida pelo Logto",
            description: "N/A"
        },
        third_party: {
            title: "App de Terceiros",
            subtitle: "Uma aplica\xe7\xe3o utilizada como conetor de IdP de terceiros",
            description: "E.g., OIDC, SAML"
        }
    },
    placeholder_title: "Selecione um tipo de aplica\xe7\xe3o para continuar",
    placeholder_description: "O Logto usa uma entidade de aplicativo para OIDC para ajudar em tarefas como identificar seus aplicativos, gerenciar o registro e criar registros de auditoria.",
    m2m_role_assignment: {
        title: "Autorizar aplica\xe7\xe3o com papel de m\xe1quina para m\xe1quina para permiss\xf5es",
        subtitle: "Aplica\xe7\xf5es de m\xe1quina para m\xe1quina requerem uma fun\xe7\xe3o de m\xe1quina para m\xe1quina autorizada.",
        role_creation_hint: "N\xe3o consegue encontrar o papel correto de m\xe1quina para m\xe1quina? <a>Crie um papel de m\xe1quina para m\xe1quina</a>"
    }
};
var $89a61c8b2caed3ff$export$2e2bcd8739ae039 = Object.freeze($89a61c8b2caed3ff$var$applications);


const $e309a88fea8ae403$var$cloud = {
    general: {
        onboarding: "Introdu\xe7\xe3o"
    },
    welcome: {
        page_title: "Bem-vindo",
        title: "Bem-vindo ao Logto Cloud! Gostar\xedamos de aprender um pouco sobre si.",
        description: "Vamos tornar a experi\xeancia da Logto \xfanica para si conhecendo-o melhor. As suas informa\xe7\xf5es est\xe3o seguras connosco.",
        project_field: "Estou a usar a Logto para",
        project_options: {
            personal: "Projeto pessoal",
            company: "Projeto da empresa"
        },
        company_name_field: "Nome da empresa",
        company_name_placeholder: "Acme.co",
        stage_field: "Em que fase est\xe1 atualmente o seu produto?",
        stage_options: {
            new_product: "Iniciar um novo projeto e procurar uma solu\xe7\xe3o r\xe1pida e pronta a usar",
            existing_product: "Migrar da autentica\xe7\xe3o atual (p. ex., autentica\xe7\xe3o feita por si, Auth0, Cognito, Microsoft)",
            target_enterprise_ready: "Acabei de conquistar clientes mais importantes e agora pretendo preparar o meu produto para vender a empresas"
        },
        additional_features_field: "Tem algo mais que queira que saibamos?",
        additional_features_options: {
            customize_ui_and_flow: "Construir e gerir a minha pr\xf3pria IU, n\xe3o apenas usar a solu\xe7\xe3o pr\xe9-constru\xedda e personaliz\xe1vel da Logto",
            compliance: "A conformidade SOC2 e GDPR s\xe3o imprescind\xedveis",
            export_user_data: "Necessidade de exportar dados de utilizadores da Logto",
            budget_control: "Tenho um controlo or\xe7amental muito apertado",
            bring_own_auth: "Tenho os meus pr\xf3prios servi\xe7os de autentica\xe7\xe3o e s\xf3 preciso de algumas funcionalidades da Logto",
            others: "Nenhuma das acima mencionadas"
        }
    },
    sie: {
        page_title: "Personalize a Experi\xeancia de Login",
        title: "Vamos personalizar a sua experi\xeancia de login com facilidade",
        inspire: {
            title: "Crie exemplos convincentes",
            description: 'Sentindo-se inseguro/a sobre a experi\xeancia de login? Basta clicar em "Me inspire" e deixar a m\xe1gica acontecer!',
            inspire_me: "Me inspire"
        },
        logo_field: "Logotipo do aplicativo",
        color_field: "Cor da marca",
        identifier_field: "Identificador",
        identifier_options: {
            email: "E-mail",
            phone: "Telefone",
            user_name: "Nome de utilizador"
        },
        authn_field: "Autentica\xe7\xe3o",
        authn_options: {
            password: "Senha",
            verification_code: "C\xf3digo de verifica\xe7\xe3o"
        },
        social_field: "Login social",
        finish_and_done: "Terminar e pronto",
        preview: {
            mobile_tab: "Telem\xf3vel",
            web_tab: "Web"
        },
        connectors: {
            unlocked_later: "Desbloqueado mais tarde",
            unlocked_later_tip: "Depois de concluir o processo de integra\xe7\xe3o e entrar no produto, voc\xea ter\xe1 acesso a ainda mais m\xe9todos de login social.",
            notice: "Evite usar o conector de demonstra\xe7\xe3o para fins de produ\xe7\xe3o. Depois de conclu\xeddo o teste, exclua gentilmente o conector de demonstra\xe7\xe3o e configure o seu pr\xf3prio conector com suas credenciais."
        }
    },
    socialCallback: {
        title: "Entrou com Sucesso",
        description: "Entrou com sucesso usando a sua conta social. Para garantir uma integra\xe7\xe3o perfeita e acesso a todos os recursos da Logto, recomendamos que prossiga para configurar o seu pr\xf3prio conector social."
    },
    tenant: {
        create_tenant: "Criar novo inquilino"
    }
};
var $e309a88fea8ae403$export$2e2bcd8739ae039 = Object.freeze($e309a88fea8ae403$var$cloud);


const $28ff60618714c527$var$components = {
    uploader: {
        action_description: "Arraste e solte ou navegue",
        uploading: "A enviar...",
        image_limit: "Carregue imagens com menos de {{size, number}}KB, s\xf3 {{extensions, list(style: narrow; type: conjunction;)}}.",
        error_upload: "Algo correu mal. O carregamento do ficheiro falhou.",
        error_file_size: "O ficheiro \xe9 demasiado grande. Por favor carregue um ficheiro com menos de {{size, number}}KB.",
        error_file_type: "O tipo de ficheiro n\xe3o \xe9 suportado. Apenas {{extensions, list(style: narrow; type: conjunction;)}}.",
        error_file_count: "S\xf3 \xe9 poss\xedvel carregar 1 ficheiro."
    }
};
var $28ff60618714c527$export$2e2bcd8739ae039 = Object.freeze($28ff60618714c527$var$components);


const $9b255c0ab102f4aa$var$connector_details = {
    page_title: "Detalhes do conector",
    back_to_connectors: "Voltar para Conectores",
    check_readme: "Verifique o README",
    settings: "Configura\xe7\xf5es gerais",
    settings_description: "Os conectores desempenham um papel cr\xedtico no Logto. Com a sua ajuda, o Logto permite aos utilizadores finais utilizar o registo ou o in\xedcio de sess\xe3o sem palavra-passe e as capacidades de iniciar sess\xe3o com contas sociais.",
    parameter_configuration: "Configura\xe7\xe3o de par\xe2metros",
    test_connection: "Testar",
    save_error_empty_config: "Por favor, insira a configura\xe7\xe3o",
    send: "Enviar",
    send_error_invalid_format: "Entrada inv\xe1lida",
    edit_config_label: "Introduza o JSON aqui",
    test_email_sender: "Testar o conector de e-mail",
    test_sms_sender: "Testar o conector de SMS",
    test_email_placeholder: "john.doe@example.com",
    test_sms_placeholder: "+351 912 345 678",
    test_message_sent: "Mensagem de teste enviada",
    test_sender_description: 'O Logto utiliza o modelo "Gen\xe9rico" para os testes. Voc\xea receber\xe1 uma mensagem se o seu conector estiver configurado corretamente.',
    options_change_email: "Alterar conector de e-mail",
    options_change_sms: "Alterar conector de SMS",
    connector_deleted: "O conector foi removido com sucesso",
    type_email: "Conector de E-mail",
    type_sms: "Conector de SMS",
    type_social: "Conector Social",
    in_used_social_deletion_description: "Este conector est\xe1 em uso na sua experi\xeancia de in\xedcio de sess\xe3o. Ao excluir, a experi\xeancia de in\xedcio de sess\xe3o <name/> ser\xe1 exclu\xedda nas configura\xe7\xf5es da experi\xeancia de in\xedcio de sess\xe3o. Voc\xea precisar\xe1 reconfigur\xe1-lo se decidir adicion\xe1-lo de volta.",
    in_used_passwordless_deletion_description: "Este {{name}} est\xe1 em uso na sua experi\xeancia de in\xedcio de sess\xe3o. Ao excluir, sua experi\xeancia de in\xedcio de sess\xe3o n\xe3o funcionar\xe1 corretamente at\xe9 que voc\xea resolva o conflito. Voc\xea precisar\xe1 reconfigur\xe1-lo se decidir adicion\xe1-lo de volta.",
    deletion_description: "Voc\xea est\xe1 removendo este conector. Isso n\xe3o pode ser desfeito, e voc\xea precisar\xe1 reconfigur\xe1-lo se decidir adicion\xe1-lo de volta.",
    logto_email: {
        total_email_sent: "Total de emails enviados: {{value, number}}",
        total_email_sent_tip: "Logto utiliza o SendGrid para e-mail interno seguro e est\xe1vel. \xc9 completamente gratuito para usar. <a>Saiba mais</a>",
        email_template_title: "Modelo de e-mail",
        template_description: "O e-mail integrado usa modelos padr\xe3o para entrega perfeita de e-mails de verifica\xe7\xe3o. Nenhuma configura\xe7\xe3o \xe9 necess\xe1ria e voc\xea pode personalizar informa\xe7\xf5es b\xe1sicas da marca.",
        template_description_link_text: "Ver modelos",
        description_action_text: "Ver modelos",
        from_email_field: "De e-mail",
        sender_name_field: "Nome do remetente",
        sender_name_tip: 'Personalize o nome do remetente para e-mails. Se deixado em branco, "Verification" ser\xe1 usado como nome padr\xe3o.',
        sender_name_placeholder: "Seu nome do remetente",
        company_information_field: "Informa\xe7\xe3o da empresa",
        company_information_description: "Exiba o nome da sua empresa, endere\xe7o ou c\xf3digo postal no rodap\xe9 dos e-mails para aumentar a autenticidade.",
        company_information_placeholder: "Informa\xe7\xe3o b\xe1sica da empresa",
        app_logo_field: "Logotipo do aplicativo",
        app_logo_tip: "Exiba o logotipo da sua marca no topo dos e-mails. Utilize a mesma imagem para o modo claro e escuro.",
        urls_not_allowed: "Os URLs n\xe3o s\xe3o permitidos",
        test_notes: 'O Logto utiliza o modelo "Gen\xe9rico" para os testes.'
    }
};
var $9b255c0ab102f4aa$export$2e2bcd8739ae039 = Object.freeze($9b255c0ab102f4aa$var$connector_details);


const $33070ac41faa0a19$var$connectors = {
    page_title: "Conectores",
    title: "Conectores",
    subtitle: "Configure conectores para habilitar a experi\xeancia de login social e sem senha",
    create: "Adicionar conector social",
    config_sie_notice: "Voc\xea configurou conectores. Certifique-se de configur\xe1-lo em <a>{{link}}</a>.",
    config_sie_link_text: "experi\xeancia de login",
    tab_email_sms: "Conectores de Email e SMS",
    tab_social: "Conectores sociais",
    connector_name: "Nome do conector",
    demo_tip: "O n\xfamero m\xe1ximo de mensagens permitido para este conector de demonstra\xe7\xe3o \xe9 limitado a 100 e n\xe3o \xe9 recomendado para implanta\xe7\xe3o em um ambiente de produ\xe7\xe3o.",
    social_demo_tip: "O conector de demonstra\xe7\xe3o \xe9 projetado exclusivamente para fins de demonstra\xe7\xe3o e n\xe3o \xe9 recomendado para implanta\xe7\xe3o em um ambiente de produ\xe7\xe3o.",
    connector_type: "Tipo",
    connector_status: "Experi\xeancia de login",
    connector_status_in_use: "Em uso",
    connector_status_not_in_use: "Fora de uso",
    not_in_use_tip: {
        content: "N\xe3o em uso significa que sua experi\xeancia de login n\xe3o usou esse m\xe9todo de login. <a>{{link}}</a> para adicionar este m\xe9todo de login.",
        go_to_sie: "Ir para experi\xeancia de login"
    },
    placeholder_title: "Conector social",
    placeholder_description: "O Logto forneceu muitos conectores de login social amplamente usados, enquanto isso, voc\xea pode criar o seu pr\xf3prio com protocolos padr\xe3o.",
    save_and_done: "Guardar",
    type: {
        email: "Email",
        sms: "SMS",
        social: "Social"
    },
    setup_title: {
        email: "Configurar o conector de email",
        sms: "Configurar o conector de SMS",
        social: "Adicionar conector social"
    },
    guide: {
        subtitle: "Um guia passo a passo para configurar o conector",
        general_setting: "Configura\xe7\xf5es gerais",
        parameter_configuration: "Configura\xe7\xe3o de par\xe2metros",
        test_connection: "Teste de conex\xe3o",
        name: "Nome do bot\xe3o de login social",
        name_placeholder: "Insira o nome do bot\xe3o de login social",
        name_tip: 'O nome do bot\xe3o do conector ser\xe1 exibido como "Continuar com {{name}}." Esteja atento ao comprimento da nomenclatura caso ela fique muito longa.',
        logo: "URL do logo para o bot\xe3o de login social",
        logo_placeholder: "https://your.cdn.domain/logo.png",
        logo_tip: "A imagem do logo ser\xe1 exibida no conector. Obtenha um link de imagem publicamente acess\xedvel e insira o link aqui.",
        logo_dark: "URL do logo para o bot\xe3o de login social (modo escuro)",
        logo_dark_placeholder: "https://your.cdn.domain/logo.png",
        logo_dark_tip: "Defina o logo do seu conector para o modo escuro depois de ativ\xe1-lo na Experi\xeancia de login no Console do administrador.",
        logo_dark_collapse: "Fechar",
        logo_dark_show: "Exibir configura\xe7\xf5es de logo para o modo escuro",
        target: "Nome do provedor de identidade",
        target_placeholder: "Insira o nome do provedor de identidade do conector",
        target_tip: 'O valor do "nome do IdP" pode ser uma string de identificador exclusivo para distinguir suas identidades sociais.',
        target_tip_standard: 'O valor do "nome do IdP" pode ser uma string de identificador exclusivo para distinguir suas identidades sociais. Esta configura\xe7\xe3o n\xe3o pode ser alterada depois que o conector for criado.',
        target_tooltip: '"Target" nos conectores sociais do Logto refere-se \xe0 "origem" de suas identidades sociais. No design do Logto, n\xe3o aceitamos o mesmo "alvo" de uma plataforma espec\xedfica para evitar conflitos. Voc\xea deve ter muito cuidado antes de adicionar um conector, pois N\xc3O PODE alterar seu valor depois de cri\xe1-lo. <a>Saiba mais</a>',
        target_conflict: "O nome do IdP inserido corresponde ao <span>nome</span> existente. Usar o mesmo nome de idp pode causar um comportamento de login inesperado em que os usu\xe1rios podem acessar a mesma conta por meio de dois conectores diferentes.",
        target_conflict_line2: 'Se voc\xea deseja substituir o conector atual pelo mesmo provedor de identidade e permitir que os usu\xe1rios anteriores fa\xe7am login sem se registrar novamente, exclua o conector <span>nome</span> e crie um novo com o mesmo "nome do IdP".',
        target_conflict_line3: 'Se voc\xea deseja se conectar a um provedor de identidade diferente, modifique o "nome do IdP" e prossiga.',
        config: "Insira o seu JSON de configura\xe7\xe3o",
        sync_profile: "Sincronizar informa\xe7\xf5es do perfil",
        sync_profile_only_at_sign_up: "Sincronizar apenas no registro",
        sync_profile_each_sign_in: "Sempre sincronizar em cada login",
        sync_profile_tip: "Sincronize o perfil b\xe1sico do provedor social, como os nomes dos usu\xe1rios e seus avatares.",
        callback_uri: "URI de retorno",
        callback_uri_description: "Tamb\xe9m chamado de URI de redirecionamento, \xe9 a URI no Logto para onde os usu\xe1rios ser\xe3o enviados ap\xf3s a autoriza\xe7\xe3o social, copie e cole na p\xe1gina de configura\xe7\xe3o do provedor social.",
        acs_url: "URL do servi\xe7o do consumidor de afirma\xe7\xe3o"
    },
    platform: {
        universal: "Universal",
        web: "Web",
        native: "Nativo"
    },
    add_multi_platform: "suporta v\xe1rias plataformas, selecione uma plataforma para continuar",
    drawer_title: "Guia do conector",
    drawer_subtitle: "Siga as instru\xe7\xf5es para integrar o conector",
    unknown: "Conector desconhecido",
    standard_connectors: "Conectores padr\xe3o"
};
var $33070ac41faa0a19$export$2e2bcd8739ae039 = Object.freeze($33070ac41faa0a19$var$connectors);


const $392a0b2c5bc47156$var$contact = {
    title: "Obter ajuda",
    description: "Para solicita\xe7\xf5es de ajuda ou feedback do produto, entre em contato conosco atrav\xe9s dos seguintes m\xe9todos.",
    discord: {
        title: "Participe da comunidade Discord",
        description: "Conecte-se com outros desenvolvedores para encontrar solu\xe7\xf5es",
        button: "Entrar"
    },
    github: {
        title: "Comunique-se no GitHub",
        description: "Crie uma issue e envie no GitHub",
        button: "Abrir"
    },
    email: {
        title: "Contato com suporte via e-mail",
        description: "Envie-nos um e-mail para obter mais informa\xe7\xf5es e ajuda",
        button: "Enviar"
    },
    reserve: {
        title: "Agende seu hor\xe1rio com a equipe Logto",
        description: "Agende uma sess\xe3o para um chat ao vivo",
        button: "Agendar"
    }
};
var $392a0b2c5bc47156$export$2e2bcd8739ae039 = Object.freeze($392a0b2c5bc47156$var$contact);


const $134ef03cd5cd2c6f$var$dashboard = {
    page_title: "Painel",
    title: "Painel",
    description: "Obtenha uma vis\xe3o geral sobre o desempenho da sua aplica\xe7\xe3o",
    total_users: "Utilizadores totais",
    total_users_tip: "N\xba de Utilizadores registados",
    new_users_today: "Novos utilizadores hoje",
    new_users_today_tip: "O n\xfamero de novos utilizadores registados nas suas aplica\xe7\xf5es hoje",
    new_users_7_days: "Novos utilizadores nos \xfaltimos 7 dias",
    new_users_7_days_tip: "O n\xfamero de novos utilizadores registados nas suas aplica\xe7\xf5es nos \xfaltimos sete dias",
    daily_active_users: "Utilizadores ativos diariamente",
    daily_active_users_tip: "O n\xfamero de utilizadores \xfanicos que efetuaram login nas suas aplica\xe7\xf5es hoje",
    weekly_active_users: "Utilizadores ativos semanalmente",
    weekly_active_users_tip: "O n\xfamero de utilizadores \xfanicos que efetuaram login nas suas aplica\xe7\xf5es nos \xfaltimos sete dias",
    monthly_active_users: "Utilizadores ativos mensais",
    monthly_active_users_tip: "O n\xfamero de utilizadores \xfanicos que efetuaram login nas suas aplica\xe7\xf5es nos \xfaltimos 30 dias"
};
var $134ef03cd5cd2c6f$export$2e2bcd8739ae039 = Object.freeze($134ef03cd5cd2c6f$var$dashboard);


const $96daa617edf7837b$var$domain = {
    status: {
        connecting: "A conectar...",
        in_use: "Em uso",
        failed_to_connect: "Falha ao conectar"
    },
    update_endpoint_notice: "N\xe3o se esque\xe7a de atualizar o dom\xednio para o URI de retorno do conector social e o endpoint de Logto na sua aplica\xe7\xe3o se quiser usar um dom\xednio personalizado para as funcionalidades. <a>{{link}}</a>",
    error_hint: "Certifique-se de atualizar os seus registos DNS. Continuaremos a verificar a cada {{value}} segundos.",
    custom: {
        custom_domain: "Dom\xednio personalizado",
        custom_domain_description: "Melhore a sua marca utilizando um dom\xednio personalizado. Este dom\xednio ser\xe1 utilizado na sua experi\xeancia de in\xedcio de sess\xe3o.",
        custom_domain_field: "Dom\xednio personalizado",
        custom_domain_placeholder: "seu.dominio.com",
        add_domain: "Adicionar dom\xednio",
        invalid_domain_format: 'Por favor, forne\xe7a um URL de dom\xednio v\xe1lido com um m\xednimo de tr\xeas partes, por exemplo, "seu.dominio.com."',
        verify_domain: "Verificar dom\xednio",
        enable_ssl: "Ativar SSL",
        checking_dns_tip: "Ap\xf3s a configura\xe7\xe3o dos registos DNS, o processo ser\xe1 executado automaticamente e pode demorar at\xe9 24 horas. Pode sair desta interface enquanto o processo estiver em execu\xe7\xe3o.",
        enable_ssl_tip: "Ativar SSL ser\xe1 executado automaticamente e pode demorar at\xe9 24 horas. Pode sair desta interface enquanto o processo estiver em execu\xe7\xe3o.",
        generating_dns_records: "Gerando os registos DNS...",
        add_dns_records: "Adicione estes registos DNS ao seu provedor de DNS.",
        dns_table: {
            type_field: "Tipo",
            name_field: "Nome",
            value_field: "Valor"
        },
        deletion: {
            delete_domain: "Eliminar dom\xednio",
            reminder: "Eliminar dom\xednio personalizado",
            description: "Tem a certeza de que pretende eliminar este dom\xednio personalizado?",
            in_used_description: 'Tem a certeza de que pretende eliminar este dom\xednio personalizado "<span>{{domain}}</span>"?',
            in_used_tip: 'Se j\xe1 configurou este dom\xednio personalizado no seu fornecedor de conector social ou extremidade de aplica\xe7\xe3o antes, ter\xe1 de modificar a URI para o dom\xednio padr\xe3o do Logto "<span>{{domain}}</span>" primeiro. Isto \xe9 necess\xe1rio para que o bot\xe3o de in\xedcio de sess\xe3o social funcione corretamente.',
            deleted: "Dom\xednio personalizado eliminado com sucesso!"
        }
    },
    default: {
        default_domain: "Dom\xednio predefinido",
        default_domain_description: "Logto oferece um dom\xednio predefinido pr\xe9-configurado, pronto para usar sem qualquer configura\xe7\xe3o adicional. Este dom\xednio predefinido serve como op\xe7\xe3o de backup mesmo que tenha ativado um dom\xednio personalizado.",
        default_domain_field: "Dom\xednio predefinido da Logto"
    },
    custom_endpoint_note: 'Pode personalizar o nome de dom\xednio desses endpoints conforme necess\xe1rio. Escolha "{{custom}}" ou "{{default}}".',
    custom_social_callback_url_note: 'Pode personalizar o nome de dom\xednio deste URI para corresponder ao endpoint da sua aplica\xe7\xe3o. Escolha "{{custom}}" ou "{{default}}".',
    custom_acs_url_note: 'Pode personalizar o nome de dom\xednio deste URI para corresponder ao URL do servi\xe7o de consumidor de confirma\xe7\xe3o do seu fornecedor de identidade. Escolha "{{custom}}" ou "{{default}}".'
};
var $96daa617edf7837b$export$2e2bcd8739ae039 = Object.freeze($96daa617edf7837b$var$domain);


const $f8d518177572eb59$var$enterprise_sso_details = {
    back_to_sso_connectors: "Voltar aos conectores SSO empresariais",
    page_title: "Detalhes do conector SSO empresarial",
    readme_drawer_title: "SSO empresarial",
    readme_drawer_subtitle: "Configurar conectores SSO empresariais para permitir SSO para os utilizadores finais",
    tab_experience: "Experi\xeancia SSO",
    tab_connection: "Conex\xe3o",
    general_settings_title: "Geral",
    custom_branding_title: "Exibi\xe7\xe3o",
    custom_branding_description: "Personalize o nome e o log\xf3tipo exibidos no fluxo de In\xedcio de Sess\xe3o \xdanica dos utilizadores finais. Quando vazio, s\xe3o usados os predefinidos.",
    email_domain_field_name: "Dom\xednio de email empresarial",
    email_domain_field_description: "Utilizadores com este dom\xednio de email podem usar SSO para autentica\xe7\xe3o. Por favor, verifique se o dom\xednio pertence \xe0 empresa.",
    email_domain_field_placeholder: "Dom\xednio do email",
    sync_profile_field_name: "Sincronizar informa\xe7\xf5es do perfil do fornecedor de identidade",
    sync_profile_option: {
        register_only: "Apenas sincronizar no primeiro in\xedcio de sess\xe3o",
        each_sign_in: "Sincronizar sempre em cada in\xedcio de sess\xe3o"
    },
    connector_name_field_name: "Nome do conector",
    display_name_field_name: "Nome a exibir",
    connector_logo_field_name: "Log\xf3tipo a exibir",
    connector_logo_field_description: "Cada imagem deve ter no m\xe1ximo 500KB, apenas SVG, PNG, JPG, JPEG.",
    branding_logo_context: "Enviar log\xf3tipo",
    branding_logo_error: "Erro ao enviar log\xf3tipo: {{error}}",
    branding_light_logo_context: "Enviar log\xf3tipo modo claro",
    branding_light_logo_error: "Erro ao enviar log\xf3tipo modo claro: {{error}}",
    branding_logo_field_name: "Log\xf3tipo",
    branding_logo_field_placeholder: "https://your.domain/logo.png",
    branding_dark_logo_context: "Enviar log\xf3tipo modo escuro",
    branding_dark_logo_error: "Erro ao enviar log\xf3tipo modo escuro: {{error}}",
    branding_dark_logo_field_name: "Log\xf3tipo (modo escuro)",
    branding_dark_logo_field_placeholder: "https://your.domain/dark-mode-logo.png",
    check_connection_guide: "Guia de conex\xe3o",
    enterprise_sso_deleted: "O conector SSO empresarial foi eliminado com sucesso",
    delete_confirm_modal_title: "Eliminar conector SSO empresarial",
    delete_confirm_modal_content: "Tem a certeza de que deseja eliminar este conector empresarial? Os utilizadores dos fornecedores de identidade n\xe3o utilizar\xe3o In\xedcio de Sess\xe3o \xdanica.",
    upload_idp_metadata_title_saml: "Enviar os metadados",
    upload_idp_metadata_description_saml: "Configurar os metadados copiados do fornecedor de identidade.",
    upload_idp_metadata_title_oidc: "Enviar as credenciais",
    upload_idp_metadata_description_oidc: "Configurar as credenciais e informa\xe7\xf5es do token OIDC copiadas do fornecedor de identidade.",
    upload_idp_metadata_button_text: "Enviar ficheiro XML de metadados",
    upload_signing_certificate_button_text: "Enviar ficheiro de certificado de assinatura",
    configure_domain_field_info_text: "Adicione o dom\xednio de email para orientar os utilizadores empresariais para o respetivo fornecedor de identidade para In\xedcio de Sess\xe3o \xdanica.",
    email_domain_field_required: "O dom\xednio de email \xe9 obrigat\xf3rio para ativar o SSO empresarial.",
    upload_saml_idp_metadata_info_text_url: "Cole o URL dos metadados do fornecedor de identidade para conectar.",
    upload_saml_idp_metadata_info_text_xml: "Cole os metadados do fornecedor de identidade para conectar.",
    upload_saml_idp_metadata_info_text_manual: "Preencha os metadados do fornecedor de identidade para conectar.",
    upload_oidc_idp_info_text: "Preencha as informa\xe7\xf5es do fornecedor de identidade para conectar.",
    service_provider_property_title: "Configurar no IdP",
    service_provider_property_description: "Configure uma integra\xe7\xe3o de aplica\xe7\xe3o usando {{protocol}} no seu fornecedor de identidade. Introduza os detalhes fornecidos pela Logto.",
    attribute_mapping_title: "Mapeamento de atributos",
    attribute_mapping_description: "Sincronize perfis de utilizadores do fornecedor de identidade configurando o mapeamento de atributos do utilizador, quer no fornecedor de identidade, quer no lado da Logto.",
    saml_preview: {
        sign_on_url: "URL de in\xedcio de sess\xe3o",
        entity_id: "Emissor",
        x509_certificate: "Certificado de assinatura",
        certificate_content: "A expirar {{date}}"
    },
    oidc_preview: {
        authorization_endpoint: "Ponto de autoriza\xe7\xe3o",
        token_endpoint: "Ponto de token",
        userinfo_endpoint: "Ponto de informa\xe7\xe3o do utilizador",
        jwks_uri: "Ponto de conjunto de chaves JSON",
        issuer: "Emissor"
    }
};
var $f8d518177572eb59$export$2e2bcd8739ae039 = Object.freeze($f8d518177572eb59$var$enterprise_sso_details);


const $de87b0e74653befa$var$enterprise_sso = {
    page_title: "SSO Empresarial",
    title: "SSO Empresarial",
    subtitle: "Conecte o fornecedor de identidade empresarial e ative o Logon \xdanico iniciado pelo SP.",
    create: "Adicionar conector empresarial",
    col_connector_name: "Nome do conector",
    col_type: "Tipo",
    col_email_domain: "Dom\xednio do email",
    placeholder_title: "Conector empresarial",
    placeholder_description: "Logto disponibilizou muitos provedores de identidade empresarial integrados para conex\xe3o, entretanto, voc\xea pode criar o seu pr\xf3prio com os protocolos SAML e OIDC.",
    create_modal: {
        title: "Adicionar conector empresarial",
        text_divider: "Ou voc\xea pode personalizar seu conector por um protocolo padr\xe3o.",
        connector_name_field_title: "Nome do conector",
        connector_name_field_placeholder: "E.g., {corp. name} - {identity provider name}",
        create_button_text: "Criar conector"
    },
    guide: {
        subtitle: "Um guia passo a passo para conectar o provedor de identidade empresarial.",
        finish_button_text: "Continuar"
    },
    basic_info: {
        title: "Configurar o seu servi\xe7o no IdP",
        description: "Crie uma nova integra\xe7\xe3o de aplicativo usando SAML 2.0 no seu provedor de identidade {{name}}. Em seguida, cole o seguinte valor nele.",
        saml: {
            acs_url_field_name: "URL do servi\xe7o de consumo de afirma\xe7\xe3o (URL de resposta)",
            audience_uri_field_name: "URI do p\xfablico (ID da entidade do SP)"
        },
        oidc: {
            redirect_uri_field_name: "URI de redirecionamento (URL de retorno)"
        }
    },
    attribute_mapping: {
        title: "Mapeamento de atributos",
        description: "`id` e `email` s\xe3o necess\xe1rios para sincronizar o perfil do utilizador do IdP. Insira o seguinte nome de reivindica\xe7\xe3o e valor no seu IdP.",
        col_sp_claims: "Valor do provedor de servi\xe7os (Logto)",
        col_idp_claims: "Nome da reivindica\xe7\xe3o do provedor de identidade",
        idp_claim_tooltip: "O nome da reivindica\xe7\xe3o do provedor de identidade"
    },
    metadata: {
        title: "Configurar os metadados do IdP",
        description: "Configure os metadados do provedor de identidade",
        dropdown_trigger_text: "Utilizar outro m\xe9todo de configura\xe7\xe3o",
        dropdown_title: "selecione o seu m\xe9todo de configura\xe7\xe3o",
        metadata_format_url: "Introduza o URL do metadado",
        metadata_format_xml: "Carregue o ficheiro XML do metadado",
        metadata_format_manual: "Introduza detalhes do metadado manualmente",
        saml: {
            metadata_url_field_name: "URL do metadado",
            metadata_url_description: "Busque dinamicamente os dados a partir do URL do metadado e mantenha o certificado atualizado.",
            metadata_xml_field_name: "Ficheiro XML dos metadados do IdP",
            metadata_xml_uploader_text: "Carregar ficheiro XML dos metadados",
            sign_in_endpoint_field_name: "URL de in\xedcio de sess\xe3o",
            idp_entity_id_field_name: "ID da entidade do IdP (Emissor)",
            certificate_field_name: "Certificado de assinatura",
            certificate_placeholder: "Copie e cole o certificado x509",
            certificate_required: "O certificado de assinatura \xe9 obrigat\xf3rio."
        },
        oidc: {
            client_id_field_name: "ID de cliente",
            client_secret_field_name: "Segredo de cliente",
            issuer_field_name: "Emissor",
            scope_field_name: "\xc2mbito"
        }
    }
};
var $de87b0e74653befa$export$2e2bcd8739ae039 = Object.freeze($de87b0e74653befa$var$enterprise_sso);


const $6204eab1bceb9557$var$errors = {
    something_went_wrong: "Ops! Algo deu errado.",
    page_not_found: "P\xe1gina n\xe3o encontrada",
    unknown_server_error: "Ocorreu um erro de servidor desconhecido",
    empty: "Sem dados",
    missing_total_number: "N\xe3o foi poss\xedvel encontrar `Total-Number` nos cabe\xe7alhos da resposta",
    invalid_uri_format: "Formato de URI inv\xe1lido",
    invalid_origin_format: "Formato de origem de URI inv\xe1lido",
    invalid_json_format: "Formato JSON inv\xe1lido",
    invalid_regex: "Express\xe3o regular inv\xe1lida",
    invalid_error_message_format: "O formato da mensagem de erro \xe9 inv\xe1lido.",
    required_field_missing: "Por favor, introduza {{field}}",
    required_field_missing_plural: "Deve inserir pelo menos um {{field}}",
    more_details: "Mais detalhes",
    username_pattern_error: "O nome de utilizador deve conter apenas letras, n\xfameros ou underscores e n\xe3o deve come\xe7ar com um n\xfamero.",
    email_pattern_error: "O endere\xe7o de e-mail \xe9 inv\xe1lido.",
    phone_pattern_error: "O n\xfamero de telefone \xe9 inv\xe1lido.",
    insecure_contexts: "Contextos inseguros (n\xe3o HTTPS) n\xe3o s\xe3o compat\xedveis.",
    unexpected_error: "Ocorreu um erro inesperado",
    not_found: "404 p\xe1gina n\xe3o encontrada",
    create_internal_role_violation: 'Est\xe1 a criar uma nova fun\xe7\xe3o interna que \xe9 proibida pelo Logto. Tente outro nome que n\xe3o comece com "#internal:".',
    should_be_an_integer: "Deve ser um inteiro.",
    number_should_be_between_inclusive: "Ent\xe3o o n\xfamero deve estar entre {{min}} e {{max}} (ambos inclusivos)."
};
var $6204eab1bceb9557$export$2e2bcd8739ae039 = Object.freeze($6204eab1bceb9557$var$errors);


const $027da547666039b3$var$general = {
    placeholder: "Espa\xe7o reservado",
    submit: "Submeter",
    skip: "Saltar",
    next: "Seguinte",
    back: "Voltar",
    retry: "Tentar novamente",
    done: "Conclu\xeddo",
    search: "Pesquisar",
    search_placeholder: "Pesquisar",
    clear_result: "Limpar resultados",
    save: "Guardar",
    save_changes: "Guardar altera\xe7\xf5es",
    saved: "Guardado",
    discard: "Descartar",
    loading: "A carregar...",
    redirecting: "A redirecionar...",
    add: "Adicionar",
    added: "Adicionado",
    cancel: "Cancelar",
    confirm: "Confirmar",
    check_out: "Finalizar",
    create: "Criar",
    set_up: "Configurar",
    customize: "Personalizar",
    enable: "Ativar",
    reminder: "Lembrete",
    edit: "Editar",
    delete: "Eliminar",
    deleted: "Deleted",
    more_options: "MAIS OP\xc7\xd5ES",
    close: "Fechar",
    copy: "Copiar",
    copying: "A copiar",
    copied: "Copiado",
    required: "Obrigat\xf3rio",
    add_another: "Adicionar outro",
    create_another: "Criar outro",
    deletion_confirmation: "Tem a certeza que deseja eliminar isso {{title}}?",
    settings_nav: "Defini\xe7\xf5es",
    unsaved_changes_warning: "Fez algumas altera\xe7\xf5es. Tem a certeza que deseja sair desta p\xe1gina?",
    leave_page: "Sair da p\xe1gina",
    stay_on_page: "Permanecer na p\xe1gina",
    type_to_search: "Digite para pesquisar",
    got_it: "Entendi",
    continue: "Continuar",
    page_info: "{{min, number}}-{{max, number}} de {{total, number}}",
    learn_more: "Saber mais",
    tab_errors: "{{count, number}} erros",
    skip_for_now: "Saltar por agora",
    remove: "Remover",
    visit: "Visitar",
    join: "Participar",
    try_now: "Experimente agora",
    multiple_form_field: "(M\xfaltiplo)",
    demo: "Demonstra\xe7\xe3o",
    unnamed: "Sem nome",
    view: "Ver",
    open: "Abrir",
    hide: "Esconder",
    unknown_error: "Erro desconhecido, por favor tente novamente mais tarde.",
    select: "Selecionar",
    contact_us_action: "Contacte-nos",
    description: "Descri\xe7\xe3o",
    name: "Nome",
    add_field: "Adicionar {{field}}",
    create_field: "Criar {{field}}",
    edit_field: "Editar {{field}}",
    delete_field: "Eliminar {{field}}",
    coming_soon: "Em breve",
    or: "Ou"
};
var $027da547666039b3$export$2e2bcd8739ae039 = Object.freeze($027da547666039b3$var$general);


const $25538d8abb8371bd$var$get_started = {
    page_title: "Come\xe7ar",
    title: "Algo para explorar para o ajudar a ter sucesso",
    subtitle: "Algumas coisas que voc\xea pode fazer para obter rapidamente valor do Logto",
    develop: {
        title: "Desenvolver: Dedique 5 minutos para integrar o seu aplicativo",
        title_cloud: "Desenvolver: Integre o seu aplicativo de forma segura em minutos",
        subtitle_cloud: "Ou leve 5 minutos para integrar o seu aplicativo com os nossos SDKs predefinidos e tutoriais."
    },
    customize: {
        title: "Personalizar: Ofere\xe7a uma \xf3tima experi\xeancia de login",
        preview: {
            title: "Verifique a pr\xe9-visualiza\xe7\xe3o ao vivo da experi\xeancia de login que voc\xea acabou de personalizar",
            subtitle: "Experimente agora a experi\xeancia de login do Logto para ver como funciona"
        },
        connector: {
            title: "Adicione mais conectores para suportar mais m\xe9todos de login social",
            subtitle: "Experimente o login sem senha e ofere\xe7a uma experi\xeancia segura e sem atritos para seus clientes"
        },
        continue_customizing: "Continue personalizando",
        try_now: "Experimente agora",
        add_more: "Adicione mais"
    },
    secure: {
        title: "Seguran\xe7a: Proteja seus recursos"
    },
    manage: {
        title: "Gerenciar: Defina o controle de acesso para seu produto e usu\xe1rios",
        rbac: {
            title: "Adicione controle de acesso baseado em fun\xe7\xe3o para proteger seus recursos",
            subtitle: "Controle seu recurso por meio de autoriza\xe7\xe3o de fun\xe7\xe3o escal\xe1vel para diversos casos de uso."
        },
        create_roles: "Criar fun\xe7\xf5es"
    },
    view_all: "Ver tudo →"
};
var $25538d8abb8371bd$export$2e2bcd8739ae039 = Object.freeze($25538d8abb8371bd$var$get_started);


const $ede4c99ec817ee78$var$guide = {
    start_building: "Come\xe7ar a construir",
    get_started: "Come\xe7ar",
    categories: {
        featured: "Popular e para ti",
        Traditional: "Aplica\xe7\xe3o web tradicional",
        SPA: "Aplica\xe7\xe3o de p\xe1gina \xfanica",
        Native: "Nativo",
        MachineToMachine: "M\xe1quina-a-m\xe1quina",
        Protected: "Integra\xe7\xe3o n\xe3o-SDK",
        ThirdParty: "Aplica\xe7\xe3o de terceiros"
    },
    filter: {
        title: "Filtrar framework",
        placeholder: "Procurar framework"
    },
    checkout_tutorial: "Ver tutorial de {{name}}",
    do_not_need_tutorial: "Se n\xe3o precisares de um tutorial, podes continuar sem um guia de framework",
    finish_and_done: "Terminar e concluir",
    cannot_find_guide: "N\xe3o encontras o teu guia?",
    describe_guide_looking_for: "Descreve o guia que procuras",
    request_guide_successfully: "O teu pedido foi enviado com sucesso. Obrigado!",
    app: {
        select_framework_or_tutorial: "Seleciona um framework ou tutorial",
        guide_modal_title: "Come\xe7ar com SDK e guias",
        modal_subtitle: "Inicia o processo de desenvolvimento da tua aplica\xe7\xe3o com o nosso SDK pr\xe9-constru\xeddo e tutoriais.",
        select_a_framework: "Seleciona um framework",
        continue_without_framework: "Criar aplica\xe7\xe3o sem framework",
        describe_guide_looking_for_placeholder: "Por exemplo, quero integrar o Logto na minha aplica\xe7\xe3o Angular."
    },
    api: {
        modal_title: "Come\xe7ar com tutoriais",
        modal_subtitle: "Inicia o processo de desenvolvimento da tua aplica\xe7\xe3o com os nossos tutoriais pr\xe9-constru\xeddos.",
        select_a_tutorial: "Seleciona um tutorial",
        continue_without_tutorial: "Continuar sem tutorial",
        describe_guide_looking_for_placeholder: "Por exemplo, quero proteger a minha API usando Deno."
    }
};
var $ede4c99ec817ee78$export$2e2bcd8739ae039 = Object.freeze($ede4c99ec817ee78$var$guide);


const $014e3f3a600fdeb9$var$invitation = {
    find_your_tenants: "Encontre os seus inquilinos",
    find_tenants_description: "O seu endere\xe7o de email pode j\xe1 estar registado em v\xe1rios inquilinos. Pode optar por juntar-se aos existentes ou continuar a criar um novo.",
    create_new_tenant: "Criar um novo inquilino",
    email_not_match_title: "Atualmente iniciou sess\xe3o como\n{{email}}",
    email_not_match_description: "Por favor inicie sess\xe3o com a conta correta para aceitar o convite e tornar-se membro da organiza\xe7\xe3o.",
    switch_account: "Iniciar sess\xe3o com outra conta",
    invalid_invitation_status: "Convite inv\xe1lido. Por favor contacte o administrador e tente novamente.",
    invitation_not_found: "Convite n\xe3o encontrado. Por favor contacte o administrador."
};
var $014e3f3a600fdeb9$export$2e2bcd8739ae039 = Object.freeze($014e3f3a600fdeb9$var$invitation);


const $0857e7fa44283649$var$jwt_claims = {
    title: "JWT Personalizado",
    description: "Configure reivindica\xe7\xf5es JWT personalizadas a incluir no token de acesso. Estas reivindica\xe7\xf5es podem ser usadas para passar informa\xe7\xf5es adicionais para a sua aplica\xe7\xe3o.",
    user_jwt: {
        card_title: "Para utilizador",
        card_field: "Token de acesso do utilizador",
        card_description: "Adicione dados espec\xedficos do utilizador durante a emiss\xe3o do token de acesso.",
        for: "para utilizador"
    },
    machine_to_machine_jwt: {
        card_title: "Para M2M",
        card_field: "Token de m\xe1quina a m\xe1quina",
        card_description: "Adicione dados extras durante a emiss\xe3o do token de m\xe1quina a m\xe1quina.",
        for: "para M2M"
    },
    code_editor_title: "Personalizar as reivindica\xe7\xf5es {{token}}",
    custom_jwt_create_button: "Adicionar reivindica\xe7\xf5es personalizadas",
    custom_jwt_item: "Reivindica\xe7\xf5es personalizadas {{for}}",
    delete_modal_title: "Eliminar reivindica\xe7\xf5es personalizadas",
    delete_modal_content: "Tens a certeza de que queres eliminar as reivindica\xe7\xf5es personalizadas?",
    clear: "Limpar",
    cleared: "Limpo",
    restore: "Restaurar predefini\xe7\xf5es",
    restored: "Restaurado",
    data_source_tab: "Fonte de dados",
    test_tab: "Contexto de teste",
    jwt_claims_description: "As reivindica\xe7\xf5es predefinidas s\xe3o automaticamente inclu\xeddas no JWT e n\xe3o podem ser substitu\xeddas.",
    user_data: {
        title: "Dados do utilizador",
        subtitle: "Utilize o par\xe2metro de entrada `data.user` para fornecer informa\xe7\xf5es vitais do utilizador."
    },
    token_data: {
        title: "Dados do token",
        subtitle: "Utilize o par\xe2metro de entrada `token` para a carga util atual do token de acesso."
    },
    fetch_external_data: {
        title: "Obter dados externos",
        subtitle: "Incorpore dados das suas APIs externas diretamente nas reivindica\xe7\xf5es.",
        description: "Utilize a fun\xe7\xe3o `fetch` para chamar as suas APIs externas e incluir os dados nas suas reivindica\xe7\xf5es personalizadas. Exemplo: "
    },
    environment_variables: {
        title: "Definir vari\xe1veis de ambiente",
        subtitle: "Utilize vari\xe1veis de ambiente para armazenar informa\xe7\xf5es confidenciais.",
        input_field_title: "Adicionar vari\xe1veis de ambiente",
        sample_code: "Acedendo a vari\xe1veis de ambiente no manipulador de reivindica\xe7\xf5es JWT personalizadas. Exemplo: "
    },
    jwt_claims_hint: "Limite as reivindica\xe7\xf5es personalizadas a menos de 50KB. As reivindica\xe7\xf5es JWT predefinidas s\xe3o automaticamente inclu\xeddas no token e n\xe3o podem ser substitu\xeddas.",
    tester: {
        subtitle: "Ajustar token falso e dados do utilizador para teste.",
        run_button: "Executar teste",
        result_title: "Resultado do teste"
    },
    form_error: {
        invalid_json: "Formato JSON inv\xe1lido"
    }
};
var $0857e7fa44283649$export$2e2bcd8739ae039 = Object.freeze($0857e7fa44283649$var$jwt_claims);


const $7bb9765af82a388f$var$log_details = {
    page_title: "Detalhes do registo de auditoria",
    back_to_logs: "Voltar aos registos de auditoria",
    back_to: "Voltar para {{name}}",
    success: "Sucesso",
    failed: "Falha",
    event_key: "Chave do Evento",
    application: "Aplica\xe7\xe3o",
    ip_address: "Endere\xe7o IP",
    user: "Utilizador",
    log_id: "ID do registo",
    time: "Hora",
    user_agent: "User agent",
    tab_details: "Detalhes",
    raw_data: "Dados n\xe3o tratados"
};
var $7bb9765af82a388f$export$2e2bcd8739ae039 = Object.freeze($7bb9765af82a388f$var$log_details);


const $76e4b75ec67840c4$var$logs = {
    page_title: "Registos de auditoria",
    title: "Registos de auditoria",
    subtitle: "Visualize logs de autentica\xe7\xe3o feitos por administradores e utilizadores",
    event: "Evento",
    user: "Utilizador",
    application: "Aplica\xe7\xe3o",
    time: "Hora",
    filter_by: "Filtrar pors"
};
var $76e4b75ec67840c4$export$2e2bcd8739ae039 = Object.freeze($76e4b75ec67840c4$var$logs);


const $3de4faeea85ff3a1$var$menu = {
    profile: "Perfil",
    language: "Linguagem",
    appearance: {
        label: "Apar\xeancia",
        light: "Claro",
        dark: "Escuro",
        system: "Sincronizar com o sistemam"
    },
    sign_out: "Terminar sess\xe3o"
};
var $3de4faeea85ff3a1$export$2e2bcd8739ae039 = Object.freeze($3de4faeea85ff3a1$var$menu);


const $9b3e9b53931f42e4$var$mfa = {
    title: "Autentica\xe7\xe3o de v\xe1rios fatores",
    description: "Adicione autentica\xe7\xe3o de v\xe1rios fatores para aumentar a seguran\xe7a da sua experi\xeancia de login.",
    factors: "Fatores",
    multi_factors: "V\xe1rios fatores",
    multi_factors_description: "Os usu\xe1rios precisam verificar um dos fatores habilitados para a verifica\xe7\xe3o em duas etapas.",
    totp: "OTP do aplicativo autenticador",
    otp_description: "Vincule o Google Authenticator, etc., para verificar senhas \xfanicas.",
    webauthn: "WebAuthn (Senha)",
    webauthn_description: "Verifique por meio de um m\xe9todo suportado pelo navegador: biometria, digitaliza\xe7\xe3o de telefone ou chave de seguran\xe7a, etc.",
    webauthn_native_tip: "O WebAuthn n\xe3o \xe9 suportado para aplicativos nativos.",
    webauthn_domain_tip: "O WebAuthn vincula chaves p\xfablicas ao dom\xednio espec\xedfico. Modificar o dom\xednio do seu servi\xe7o bloquear\xe1 usu\xe1rios de autenticar via senhas existentes.",
    backup_code: "C\xf3digo de backup",
    backup_code_description: "Gere 10 c\xf3digos de backup \xfanicos ap\xf3s os usu\xe1rios configurarem qualquer m\xe9todo MFA.",
    backup_code_setup_hint: "Quando os usu\xe1rios n\xe3o podem verificar os fatores MFA acima, use a op\xe7\xe3o de backup.",
    backup_code_error_hint: "Para usar um c\xf3digo de backup, voc\xea precisa de pelo menos mais um m\xe9todo MFA para autentica\xe7\xe3o bem-sucedida do usu\xe1rio.",
    policy: "Pol\xedtica",
    policy_description: "Defina a pol\xedtica MFA para fluxos de login e inscri\xe7\xe3o.",
    two_step_sign_in_policy: "Pol\xedtica de verifica\xe7\xe3o em duas etapas no login",
    user_controlled: "Os usu\xe1rios podem ativar ou desativar o MFA por conta pr\xf3pria",
    user_controlled_tip: "Os usu\xe1rios podem pular a configura\xe7\xe3o do MFA na primeira vez no login ou inscri\xe7\xe3o, ou ativar/desativar nas configura\xe7\xf5es da conta.",
    mandatory: "Os usu\xe1rios sempre precisam usar o MFA no login",
    mandatory_tip: "Os usu\xe1rios devem configurar o MFA na primeira vez no login ou inscri\xe7\xe3o e us\xe1-lo em todos os logins futuros."
};
var $9b3e9b53931f42e4$export$2e2bcd8739ae039 = Object.freeze($9b3e9b53931f42e4$var$mfa);


const $acb537eda4a0a04a$var$organization_details = {
    page_title: "Detalhes da organiza\xe7\xe3o",
    delete_confirmation: "Uma vez eliminada, todos os membros perder\xe3o a sua ades\xe3o e fun\xe7\xf5es nesta organiza\xe7\xe3o. Esta a\xe7\xe3o n\xe3o pode ser desfeita.",
    organization_id: "ID da organiza\xe7\xe3o",
    settings_description: "As organiza\xe7\xf5es representam as equipas, clientes empresariais e empresas parceiras que podem aceder \xe0s suas aplica\xe7\xf5es.",
    name_placeholder: "O nome da organiza\xe7\xe3o, n\xe3o \xe9 necess\xe1rio ser \xfanico.",
    description_placeholder: "Uma descri\xe7\xe3o da organiza\xe7\xe3o.",
    member: "Membro",
    member_other: "Membros",
    add_members_to_organization: "Adicionar membros \xe0 organiza\xe7\xe3o {{name}}",
    add_members_to_organization_description: "Encontre utilizadores adequados pesquisando por nome, email, telefone ou ID de utilizador. Os membros existentes n\xe3o s\xe3o mostrados nos resultados da pesquisa.",
    add_with_organization_role: "Adicionar com fun\xe7\xe3o(\xf5es) de organiza\xe7\xe3o",
    user: "Utilizador",
    authorize_to_roles: "Autorizar {{name}} a aceder \xe0s seguintes fun\xe7\xf5es:",
    edit_organization_roles: "Editar fun\xe7\xf5es da organiza\xe7\xe3o",
    edit_organization_roles_of_user: "Editar fun\xe7\xf5es da organiza\xe7\xe3o de {{name}}",
    remove_user_from_organization: "Remover utilizador da organiza\xe7\xe3o",
    remove_user_from_organization_description: "Uma vez removido, o utilizador perder\xe1 a sua ades\xe3o e fun\xe7\xf5es nesta organiza\xe7\xe3o. Esta a\xe7\xe3o n\xe3o pode ser desfeita.",
    search_user_placeholder: "Pesquisar por nome, email, telefone ou ID de utilizador",
    at_least_one_user: "Pelo menos um utilizador \xe9 necess\xe1rio.",
    custom_data: "Dados personalizados",
    custom_data_tip: "Dados personalizados \xe9 um objeto JSON que pode ser usado para armazenar dados adicionais associados \xe0 organiza\xe7\xe3o.",
    invalid_json_object: "Objeto JSON inv\xe1lido."
};
var $acb537eda4a0a04a$export$2e2bcd8739ae039 = Object.freeze($acb537eda4a0a04a$var$organization_details);


const $a863effa5707138d$var$organization_role_details = {
    page_title: "Detalhes da fun\xe7\xe3o da organiza\xe7\xe3o",
    back_to_org_roles: "Voltar aos pap\xe9is da organiza\xe7\xe3o",
    org_role: "Fun\xe7\xe3o da organiza\xe7\xe3o",
    delete_confirm: "Ao faz\xea-lo, ser\xe3o removidas as permiss\xf5es associadas a esta fun\xe7\xe3o dos utilizadores afetados e ser\xe3o eliminadas as rela\xe7\xf5es entre fun\xe7\xf5es da organiza\xe7\xe3o, membros na organiza\xe7\xe3o e permiss\xf5es da organiza\xe7\xe3o.",
    deleted: "O papel da organiza\xe7\xe3o {{name}} foi eliminado com sucesso.",
    permissions: {
        tab: "Permiss\xf5es",
        name_column: "Permiss\xe3o",
        description_column: "Descri\xe7\xe3o",
        type_column: "Tipo de permiss\xe3o",
        type: {
            api: "Permiss\xe3o da API",
            org: "Permiss\xe3o da organiza\xe7\xe3o"
        },
        assign_permissions: "Atribuir permiss\xf5es",
        remove_permission: "Remover permiss\xe3o",
        remove_confirmation: "Se esta permiss\xe3o for removida, o utilizador com esta fun\xe7\xe3o organizacional perder\xe1 o acesso concedido por esta permiss\xe3o.",
        removed: "A permiss\xe3o {{name}} foi removida com sucesso desta fun\xe7\xe3o organizacional",
        assign_description: "Atribuir permiss\xf5es aos cargos dentro desta organiza\xe7\xe3o. Estas podem incluir permiss\xf5es de organiza\xe7\xe3o e permiss\xf5es de API.",
        organization_permissions: "Permiss\xf5es de organiza\xe7\xe3o",
        api_permissions: "Permiss\xf5es de API",
        assign_organization_permissions: "Atribuir permiss\xf5es de organiza\xe7\xe3o",
        assign_api_permissions: "Atribuir permiss\xf5es de API"
    },
    general: {
        tab: "Geral",
        settings: "Configura\xe7\xf5es",
        description: "O papel da organiza\xe7\xe3o \xe9 um agrupamento de permiss\xf5es que podem ser atribu\xeddas aos utilizadores. As permiss\xf5es podem provir das permiss\xf5es da organiza\xe7\xe3o pr\xe9-definidas e permiss\xf5es de API.",
        name_field: "Nome",
        description_field: "Descri\xe7\xe3o",
        description_field_placeholder: "Utilizadores com permiss\xf5es apenas de visualiza\xe7\xe3o"
    }
};
var $a863effa5707138d$export$2e2bcd8739ae039 = Object.freeze($a863effa5707138d$var$organization_role_details);


const $57a51078645e52de$var$organization_template = {
    title: "Modelo de organiza\xe7\xe3o",
    subtitle: "Em aplica\xe7\xf5es SaaS multi-inquilino, um modelo organizacional define pol\xedticas de controlo de acesso partilhado (permiss\xf5es e pap\xe9is) para v\xe1rias organiza\xe7\xf5es.",
    roles: {
        tab_name: "Pap\xe9is da org",
        search_placeholder: "Procurar por nome do papel",
        create_title: "Criar papel da org",
        role_column: "Papel da org",
        permissions_column: "Permiss\xf5es",
        placeholder_title: "Papel da organiza\xe7\xe3o",
        placeholder_description: "O papel da organiza\xe7\xe3o \xe9 um agrupamento de permiss\xf5es que podem ser atribu\xeddas a utilizadores. As permiss\xf5es devem provir das permiss\xf5es organizacionais predefinidas.",
        create_modal: {
            title: "Criar fun\xe7\xe3o da organiza\xe7\xe3o",
            create: "Criar fun\xe7\xe3o",
            name_field: "Nome da fun\xe7\xe3o",
            description_field: "Descri\xe7\xe3o",
            created: "A fun\xe7\xe3o da organiza\xe7\xe3o {{name}} foi criada com sucesso."
        }
    },
    permissions: {
        tab_name: "Permiss\xf5es da org",
        search_placeholder: "Procurar por nome da permiss\xe3o",
        create_org_permission: "Criar permiss\xe3o da org",
        permission_column: "Permiss\xe3o da organiza\xe7\xe3o",
        description_column: "Descri\xe7\xe3o",
        placeholder_title: "Permiss\xe3o da organiza\xe7\xe3o",
        placeholder_description: "A permiss\xe3o da organiza\xe7\xe3o refere-se \xe0 autoriza\xe7\xe3o para aceder a um recurso no contexto da organiza\xe7\xe3o.",
        delete_confirm: "Se esta permiss\xe3o for apagada, todos os pap\xe9is da organiza\xe7\xe3o que incluam esta permiss\xe3o perder\xe3o a mesma, e utilizadores que tinham esta permiss\xe3o perder\xe3o o acesso concedido por ela.",
        create_title: "Criar permiss\xe3o de organiza\xe7\xe3o",
        edit_title: "Editar permiss\xe3o de organiza\xe7\xe3o",
        permission_field_name: "Nome da permiss\xe3o",
        description_field_name: "Descri\xe7\xe3o",
        description_field_placeholder: "Ler hist\xf3rico de compromissos",
        create_permission: "Criar permiss\xe3o",
        created: "A permiss\xe3o de organiza\xe7\xe3o {{name}} foi criada com sucesso."
    }
};
var $57a51078645e52de$export$2e2bcd8739ae039 = Object.freeze($57a51078645e52de$var$organization_template);


const $d2f2161c18e01f25$var$organizations = {
    organization: "Organiza\xe7\xe3o",
    page_title: "Organiza\xe7\xf5es",
    title: "Organiza\xe7\xf5es",
    subtitle: "As organiza\xe7\xf5es s\xe3o geralmente usadas em aplica\xe7\xf5es SaaS ou similares de m\xfaltiplos inquilinos e representam os seus clientes, que podem ser equipas, organiza\xe7\xf5es ou empresas inteiras. As organiza\xe7\xf5es funcionam como um elemento fundamental para a autentica\xe7\xe3o e autoriza\xe7\xe3o B2B.",
    organization_template: "Modelo de organiza\xe7\xe3o",
    organization_id: "ID da organiza\xe7\xe3o",
    members: "Membros",
    create_organization: "Criar organiza\xe7\xe3o",
    setup_organization: "Configurar a sua organiza\xe7\xe3o",
    organization_list_placeholder_title: "Organiza\xe7\xe3o",
    organization_list_placeholder_text: "As organiza\xe7\xf5es s\xe3o frequentemente utilizadas em aplica\xe7\xf5es SaaS ou similares de m\xfaltiplos inquilinos como uma pr\xe1tica recomendada. Permitem-lhe desenvolver aplica\xe7\xf5es que permitem aos clientes criar e gerir organiza\xe7\xf5es, convidar membros e atribuir fun\xe7\xf5es.",
    organization_name_placeholder: "A minha organiza\xe7\xe3o",
    organization_description_placeholder: "Uma breve descri\xe7\xe3o da organiza\xe7\xe3o",
    organization_permission: "Permiss\xe3o da organiza\xe7\xe3o",
    organization_permission_other: "Permiss\xf5es da organiza\xe7\xe3o",
    create_permission_placeholder: "Ler hist\xf3rico de compromissos",
    organization_role: "Papel da organiza\xe7\xe3o",
    organization_role_other: "Fun\xe7\xf5es da organiza\xe7\xe3o",
    organization_role_description: "O papel da organiza\xe7\xe3o \xe9 um agrupamento de permiss\xf5es que podem ser atribu\xeddas a utilizadores. As permiss\xf5es devem provir das permiss\xf5es de organiza\xe7\xe3o predefinidas.",
    role: "Fun\xe7\xe3o",
    search_placeholder: "Pesquisar por nome ou ID da organiza\xe7\xe3o",
    search_role_placeholder: "Digite para pesquisar e selecionar fun\xe7\xf5es",
    empty_placeholder: "\uD83E\uDD14 Ainda n\xe3o configurou nenhum {{entity}}.",
    organization_and_member: "Organiza\xe7\xe3o e membro",
    organization_and_member_description: 'A organiza\xe7\xe3o \xe9 um grupo de utilizadores e pode representar as equipas, clientes empresariais e empresas parceiras, sendo que cada utilizador \xe9 um "Membro". Estas podem ser entidades fundamentais para lidar com os requisitos de m\xfaltiplos inquilinos.',
    guide: {
        title: "Comece com guias",
        subtitle: "Inicie as configura\xe7\xf5es da sua organiza\xe7\xe3o com os nossos guias",
        introduction: {
            title: "Vamos entender como uma organiza\xe7\xe3o funciona na Logto",
            section_1: {
                title: "Uma organiza\xe7\xe3o \xe9 um grupo de utilizadores (identidades)"
            },
            section_2: {
                title: "O modelo de organiza\xe7\xe3o \xe9 projetado para o controlo de acesso a aplica\xe7\xf5es multi-inquilinos",
                description: 'Nas aplica\xe7\xf5es SaaS multi-inquilinos, muitas organiza\xe7\xf5es frequentemente partilham o mesmo modelo de controlo de acesso, que inclui permiss\xf5es e fun\xe7\xf5es. Na Logto, chamamos-lhe "modelo de organiza\xe7\xe3o."',
                permission_description: "A permiss\xe3o da organiza\xe7\xe3o refere-se \xe0 autoriza\xe7\xe3o para aceder a um recurso no contexto da organiza\xe7\xe3o.",
                role_description_deprecated: "O papel da organiza\xe7\xe3o \xe9 um agrupamento de permiss\xf5es da organiza\xe7\xe3o que podem ser atribu\xeddas aos membros.",
                role_description: "O papel da organiza\xe7\xe3o \xe9 um agrupamento de permiss\xf5es da organiza\xe7\xe3o ou permiss\xf5es de API que podem ser atribu\xeddas aos membros."
            },
            section_3: {
                title: "Posso atribuir permiss\xf5es de API a pap\xe9is de organiza\xe7\xe3o?",
                description: "Sim, pode atribuir permiss\xf5es de API a pap\xe9is de organiza\xe7\xe3o. O Logto oferece a flexibilidade para gerir eficazmente os pap\xe9is da sua organiza\xe7\xe3o, permitindo incluir tanto permiss\xf5es de organiza\xe7\xe3o como permiss\xf5es de API nesses pap\xe9is."
            },
            section_4: {
                title: "Interaja com a ilustra\xe7\xe3o para ver como tudo est\xe1 conectado",
                description: "Vamos ver um exemplo. John, Sarah pertencem a diferentes organiza\xe7\xf5es com fun\xe7\xf5es diferentes no contexto das organiza\xe7\xf5es diferentes. Passe o rato sobre os diferentes m\xf3dulos e veja o que acontece."
            }
        },
        organization_permissions: "Permiss\xf5es da organiza\xe7\xe3o",
        organization_roles: "Fun\xe7\xf5es da organiza\xe7\xe3o",
        admin: "Administrador",
        member: "Membro",
        guest: "Convidado",
        role_description: 'O papel "{{role}}" partilha o mesmo modelo de organiza\xe7\xe3o entre diferentes organiza\xe7\xf5es.',
        john: "John",
        john_tip: 'John pertence a duas organiza\xe7\xf5es com o email "john@email.com" como \xfanico identificador. Ele \xe9 o administrador da organiza\xe7\xe3o A e o convidado da organiza\xe7\xe3o B.',
        sarah: "Sarah",
        sarah_tip: 'Sarah pertence a uma organiza\xe7\xe3o com o email "sarah@email.com" como \xfanico identificador. Ela \xe9 a administradora da organiza\xe7\xe3o B.'
    }
};
var $d2f2161c18e01f25$export$2e2bcd8739ae039 = Object.freeze($d2f2161c18e01f25$var$organizations);


const $21ecc2c444e8d033$var$permissions = {
    search_placeholder: "Pesquisar por nome de API ou permiss\xe3o",
    search_placeholder_without_api: "Pesquisar por nome de permiss\xe3o",
    name_column: "Permiss\xe3o",
    description_column: "Descri\xe7\xe3o",
    api_column: "API",
    placeholder_title: "Permiss\xe3o",
    placeholder_description: "Permiss\xe3o refere-se \xe0 autoriza\xe7\xe3o para acessar um recurso (que chamamos de recurso da API).",
    edit: "Permiss\xe3o de edi\xe7\xe3o",
    delete: "Permiss\xe3o de elimina\xe7\xe3o",
    remove: "Permiss\xe3o para remover",
    edit_title: "Editar permiss\xe3o da API"
};
var $21ecc2c444e8d033$export$2e2bcd8739ae039 = Object.freeze($21ecc2c444e8d033$var$permissions);


const $293d5cd7140dd0e3$var$profile = {
    page_title: "Defini\xe7\xf5es da conta",
    title: "Defini\xe7\xf5es da conta",
    description: "Altere as suas defini\xe7\xf5es de conta e gerencie suas informa\xe7\xf5es pessoais aqui para garantir a seguran\xe7a da sua conta.",
    settings: {
        title: "DEFINI\xc7\xd5ES DO PERFIL",
        profile_information: "Informa\xe7\xe3o do perfil",
        avatar: "Avatar",
        name: "Nome",
        username: "Nome de usu\xe1rio"
    },
    link_account: {
        title: "LIGAR CONTA",
        email_sign_in: "Registo de email",
        email: "Email",
        social_sign_in: "Registo social",
        link_email: "Ligar email",
        link_email_subtitle: "Ligue o seu e-mail para fazer login ou ajudar na recupera\xe7\xe3o da sua conta.",
        email_required: "Email \xe9 obrigat\xf3rio",
        invalid_email: "Endere\xe7o de email inv\xe1lido",
        identical_email_address: "O endere\xe7o de email inserido \xe9 id\xeantico ao atual",
        anonymous: "An\xf3nimo"
    },
    password: {
        title: "PALAVRA-PASSE E SEGURAN\xc7A",
        password: "Palavra-passe",
        password_setting: "Configura\xe7\xe3o da palavra-passe",
        new_password: "Nova palavra-passe",
        confirm_password: "Confirmar palavra-passe",
        enter_password: "Introduza a palavra-passe atual",
        enter_password_subtitle: "Verifique se \xe9 realmente voc\xea para proteger a seguran\xe7a da sua conta. Por favor, introduza a sua palavra-passe atual antes de a alterar.",
        set_password: "Definir palavra-passe",
        verify_via_password: "Verificar atrav\xe9s da palavra-passe",
        show_password: "Mostrar palavra-passe",
        required: "Palavra-passe \xe9 obrigat\xf3ria",
        do_not_match: "As palavras-passe n\xe3o correspondem. Por favor, tente novamente."
    },
    code: {
        enter_verification_code: "Introduzir c\xf3digo de verifica\xe7\xe3o",
        enter_verification_code_subtitle: "O c\xf3digo de verifica\xe7\xe3o foi enviado para <strong>{{target}}</strong>",
        verify_via_code: "Verificar atrav\xe9s do c\xf3digo de verifica\xe7\xe3o",
        resend: "Reenviar c\xf3digo de verifica\xe7\xe3o",
        resend_countdown: "Reenviar em {{countdown}} segundos"
    },
    delete_account: {
        title: "APAGAR CONTA",
        label: "Apagar conta",
        description: "Apagar a sua conta ir\xe1 remover todas as suas informa\xe7\xf5es pessoais, dados de usu\xe1rio e configura\xe7\xf5es. Esta a\xe7\xe3o n\xe3o pode ser desfeita.",
        button: "Apagar conta",
        dialog_paragraph_1: "Lamentamos saber que deseja apagar sua conta. A exclus\xe3o da sua conta ir\xe1 remover permanentemente todos os dados, incluindo informa\xe7\xf5es de usu\xe1rio, logs e configura\xe7\xf5es, e esta a\xe7\xe3o n\xe3o pode ser desfeita. Portanto, por favor, fa\xe7a backup de qualquer dado importante antes de prosseguir.",
        dialog_paragraph_2: "Para prosseguir com o processo de exclus\xe3o de conta, envie um e-mail para nossa equipe de suporte em <a>mail</a> com o assunto “Solicita\xe7\xe3o de exclus\xe3o de conta”. Vamos ajud\xe1-lo e garantir que todos os seus dados sejam devidamente exclu\xeddos do nosso sistema.",
        dialog_paragraph_3: "Obrigado por escolher o Logto Cloud. Se tiver alguma d\xfavida ou preocupa\xe7\xe3o, n\xe3o hesite em entrar em contato connosco."
    },
    set: "Definir",
    change: "Mudar",
    link: "Ligar",
    unlink: "Desligar",
    not_set: "N\xe3o definido",
    change_avatar: "Mudar avatar",
    change_name: "Mudar nome",
    change_username: "Mudar nome de usu\xe1rio",
    set_name: "Definir nome",
    email_changed: "Email alterado.",
    password_changed: "Palavra-passe alterada.",
    updated: "{{target}} atualizado.",
    linked: "{{target}} ligado.",
    unlinked: "{{target}} desligado.",
    email_exists_reminder: "Este email {{email}} est\xe1 associado a uma conta existente. Conecte outro email aqui.",
    unlink_confirm_text: "Sim, desligar",
    unlink_reminder: "Os usu\xe1rios n\xe3o poder\xe3o entrar com a conta <span></span> se voc\xea a desligar. Tem a certeza de que deseja prosseguir?"
};
var $293d5cd7140dd0e3$export$2e2bcd8739ae039 = Object.freeze($293d5cd7140dd0e3$var$profile);


const $d667fe40fc31d1a0$var$protected_app = {
    name: "App Protegida",
    title: "Crie uma App Protegida: Adicione autentica\xe7\xe3o com simplicidade e velocidade \xe9pica",
    description: "A App Protegida mant\xe9m as sess\xf5es de usu\xe1rio de forma segura e redireciona as solicita\xe7\xf5es do seu aplicativo. Alimentado pelos Cloudflare Workers, desfrute do desempenho de primeira classe e da inicializa\xe7\xe3o instant\xe2nea em todo o mundo. <a>Saiba mais</a>",
    fast_create: "Criar rapidamente",
    modal_title: "Criar App Protegida",
    modal_subtitle: "Habilitar prote\xe7\xe3o segura e r\xe1pida com alguns cliques. Adicione autentica\xe7\xe3o ao seu aplicativo da web existente com facilidade.",
    form: {
        url_field_label: "O URL de origem",
        url_field_placeholder: "https://dom\xednio.com/",
        url_field_description: "Forne\xe7a o endere\xe7o do seu aplicativo que necessita de prote\xe7\xe3o de autentica\xe7\xe3o.",
        url_field_modification_notice: "Modifica\xe7\xf5es no URL de origem podem levar de 1-2 minutos para se tornarem eficazes em todas as localiza\xe7\xf5es da rede global.",
        url_field_tooltip: "Forne\xe7a o endere\xe7o da sua aplica\xe7\xe3o, excluindo qualquer '/caminho'. Ap\xf3s a cria\xe7\xe3o, voc\xea pode personalizar as regras de autentica\xe7\xe3o de rota.\n\nObserva\xe7\xe3o: O pr\xf3prio URL de origem n\xe3o necessita de autentica\xe7\xe3o; a prote\xe7\xe3o \xe9 aplicada exclusivamente a acessos via o dom\xednio do aplicativo designado.",
        domain_field_label: "Dom\xednio do aplicativo",
        domain_field_placeholder: "seu-dom\xednio",
        domain_field_description: "Este URL serve como um proxy de prote\xe7\xe3o de autentica\xe7\xe3o para o URL original. O dom\xednio personalizado pode ser aplicado ap\xf3s a cria\xe7\xe3o.",
        domain_field_description_short: "Este URL serve como um proxy de prote\xe7\xe3o de autentica\xe7\xe3o para o URL original.",
        domain_field_tooltip: "Apps protegidos pelo Logto ser\xe3o hospedados em 'seu-dom\xednio.{{domain}}' por padr\xe3o. O dom\xednio personalizado pode ser aplicado ap\xf3s a cria\xe7\xe3o.",
        create_application: "Criar aplicativo",
        create_protected_app: "Criar rapidamente",
        errors: {
            domain_required: "O seu dom\xednio \xe9 obrigat\xf3rio.",
            domain_in_use: "Este nome de subdom\xednio j\xe1 est\xe1 em uso.",
            invalid_domain_format: "Formato de subdom\xednio inv\xe1lido: use apenas letras min\xfasculas, n\xfameros e h\xedfens '-'.",
            url_required: "O URL de origem \xe9 obrigat\xf3rio.",
            invalid_url: "Formato de URL de origem inv\xe1lido: Use http:// ou https://. Observa\xe7\xe3o: '/caminho' n\xe3o \xe9 suportado atualmente.",
            localhost: "Por favor, exponha primeiro o seu servidor local \xe0 internet. Saiba mais sobre o <a>desenvolvimento local</a>."
        }
    },
    success_message: "\uD83C\uDF89 Autentica\xe7\xe3o do aplicativo habilitada com sucesso! Explore a nova experi\xeancia do seu site."
};
var $d667fe40fc31d1a0$export$2e2bcd8739ae039 = Object.freeze($d667fe40fc31d1a0$var$protected_app);


const $47b13feabc161324$var$role_details = {
    back_to_roles: "Voltar para Fun\xe7\xf5es",
    identifier: "Identificador",
    delete_description: "Ao faz\xea-lo, ser\xe3o removidas as permiss\xf5es associadas a esta fun\xe7\xe3o dos utilizadores afetados e eliminado o mapeamento entre fun\xe7\xf5es, utilizadores e permiss\xf5es.",
    role_deleted: "{{name}} foi eliminada com sucesso.",
    general_tab: "Geral",
    users_tab: "Utilizadores",
    m2m_apps_tab: "Aplica\xe7\xf5es de m\xe1quina para m\xe1quina",
    permissions_tab: "Permiss\xf5es",
    settings: "Defini\xe7\xf5es",
    settings_description: "As fun\xe7\xf5es s\xe3o um agrupamento de permiss\xf5es que podem ser atribu\xeddas aos utilizadores. Elas tamb\xe9m proporcionam uma forma de agregar permiss\xf5es definidas para diferentes APIs, tornando mais eficiente adicionar, remover ou ajustar permiss\xf5es comparativamente \xe0 sua atribui\xe7\xe3o individual a utilizadores.",
    field_name: "Nome",
    field_description: "Descri\xe7\xe3o",
    field_is_default: "Fun\xe7\xe3o predefinida",
    field_is_default_description: "Defina esta fun\xe7\xe3o como uma fun\xe7\xe3o predefinida para novos utilizadores. Podem ser definidas v\xe1rias fun\xe7\xf5es predefinidas. Isto tamb\xe9m afetar\xe1 as fun\xe7\xf5es predefinidas para utilizadores criados atrav\xe9s da API de Gest\xe3o.",
    type_m2m_role_tag: "Fun\xe7\xe3o de aplica\xe7\xe3o de m\xe1quina para m\xe1quina",
    type_user_role_tag: "Fun\xe7\xe3o de utilizador",
    m2m_role_notification: "Atribua esta fun\xe7\xe3o de m\xe1quina para m\xe1quina a uma aplica\xe7\xe3o de m\xe1quina para m\xe1quina para conceder acesso aos recursos de API relativos. <a>Crie primeiro uma aplica\xe7\xe3o de m\xe1quina para m\xe1quina</a> se ainda n\xe3o o fez.",
    permission: {
        assign_button: "Atribuir Permiss\xf5es",
        assign_title: "Atribuir permiss\xf5es",
        assign_subtitle: "Atribua permiss\xf5es a esta fun\xe7\xe3o. A fun\xe7\xe3o ir\xe1 obter as permiss\xf5es adicionadas e os utilizadores com esta fun\xe7\xe3o herdar\xe3o essas permiss\xf5es.",
        assign_form_field: "Atribuir permiss\xf5es",
        added_text_one: "{{count, number}} permiss\xe3o adicionada",
        added_text_other: "{{count, number}} permiss\xf5es adicionadas",
        api_permission_count_one: "{{count, number}} permiss\xe3o",
        api_permission_count_other: "{{count, number}} permiss\xf5es",
        confirm_assign: "Atribuir Permiss\xf5es",
        permission_assigned: "As permiss\xf5es selecionadas foram atribu\xeddas com sucesso a esta fun\xe7\xe3o",
        deletion_description: "Se esta permiss\xe3o for removida, o utilizador afetado com esta fun\xe7\xe3o perder\xe1 o acesso concedido por esta permiss\xe3o.",
        permission_deleted: 'A permiss\xe3o "{{name}}" foi removida com sucesso desta fun\xe7\xe3o',
        empty: "Nenhuma permiss\xe3o dispon\xedvel"
    },
    users: {
        assign_button: "Atribuir Utilizadores",
        name_column: "Utilizador",
        app_column: "Aplica\xe7\xe3o",
        latest_sign_in_column: "\xdaltima sess\xe3o iniciada",
        delete_description: "Permanecer\xe1 no seu conjunto de utilizadores, mas perder\xe1 a autoriza\xe7\xe3o para esta fun\xe7\xe3o.",
        deleted: "{{name}} foi removido com sucesso desta fun\xe7\xe3o",
        assign_title: "Atribuir utilizadores",
        assign_subtitle: "Atribua utilizadores a esta fun\xe7\xe3o. Encontre utilizadores apropriados pesquisando pelo nome, e-mail, telefone ou ID de utilizador.",
        assign_field: "Atribuir utilizadores",
        confirm_assign: "Atribuir utilizadores",
        assigned_toast_text: "Os utilizadores selecionados foram atribu\xeddos com sucesso a esta fun\xe7\xe3o",
        empty: "Nenhum utilizador dispon\xedvel"
    },
    applications: {
        assign_button: "Atribuir aplica\xe7\xf5es",
        name_column: "Aplica\xe7\xe3o",
        app_column: "Aplica\xe7\xf5es",
        description_column: "Descri\xe7\xe3o",
        delete_description: "Permanecer\xe1 no seu conjunto de aplica\xe7\xf5es, mas perder\xe1 a autoriza\xe7\xe3o para esta fun\xe7\xe3o.",
        deleted: "{{name}} foi removido com sucesso desta fun\xe7\xe3o",
        assign_title: "Atribuir aplica\xe7\xf5es",
        assign_subtitle: "Atribua aplica\xe7\xf5es a esta fun\xe7\xe3o. Encontre aplica\xe7\xf5es apropriadas pesquisando pelo nome, descri\xe7\xe3o ou ID da aplica\xe7\xe3o.",
        assign_field: "Atribuir aplica\xe7\xf5es",
        confirm_assign: "Atribuir aplica\xe7\xf5es",
        assigned_toast_text: "As aplica\xe7\xf5es selecionadas foram atribu\xeddas com sucesso a esta fun\xe7\xe3o",
        empty: "Nenhuma aplica\xe7\xe3o dispon\xedvel"
    }
};
var $47b13feabc161324$export$2e2bcd8739ae039 = Object.freeze($47b13feabc161324$var$role_details);


const $752155db6d1aa86b$var$roles = {
    page_title: "Pap\xe9is",
    title: "Pap\xe9is",
    subtitle: "Os pap\xe9is incluem permiss\xf5es que determinam o que um usu\xe1rio pode fazer. RBAC usa pap\xe9is para conceder acesso a recursos para a\xe7\xf5es espec\xedficas.",
    create: "Criar papel",
    role_name: "Nome do papel",
    role_type: "Tipo de papel",
    show_role_type_button_text: "Mostrar mais op\xe7\xf5es",
    hide_role_type_button_text: "Esconder mais op\xe7\xf5es",
    type_user: "Fun\xe7\xe3o de usu\xe1rio",
    type_machine_to_machine: "Fun\xe7\xe3o de aplica\xe7\xe3o m\xe1quina-a-m\xe1quina",
    role_description: "Descri\xe7\xe3o",
    role_name_placeholder: "Digite o nome do papel",
    role_description_placeholder: "Digite a descri\xe7\xe3o do papel",
    col_roles: "Pap\xe9is",
    col_type: "Tipo",
    col_description: "Descri\xe7\xe3o",
    col_assigned_entities: "Atribu\xeddo",
    user_counts: "{{count}} utilizadores",
    application_counts: "{{count}} aplica\xe7\xf5es",
    user_count: "{{count}} utilizador",
    application_count: "{{count}} aplica\xe7\xe3o",
    assign_permissions: "Atribuir permiss\xf5es",
    create_role_title: "Criar papel",
    create_role_description: "Crie e gerencie pap\xe9is para as suas aplica\xe7\xf5es. Os pap\xe9is cont\xeam cole\xe7\xf5es de permiss\xf5es e podem ser atribu\xeddos a utilizadores.",
    create_role_button: "Criar papel",
    role_created: "O papel {{name}} foi criado com sucesso.",
    search: "Pesquisar por nome do papel, descri\xe7\xe3o ou ID",
    placeholder_title: "Pap\xe9is",
    placeholder_description: "Os pap\xe9is s\xe3o um agrupamento de permiss\xf5es que podem ser atribu\xeddas a utilizadores. Certifique-se de adicionar permiss\xf5es antes de criar pap\xe9is.",
    assign_user_roles: "Atribuir fun\xe7\xf5es de utilizador",
    assign_m2m_roles: "Atribuir fun\xe7\xf5es de m\xe1quina para m\xe1quina",
    management_api_access_notification: "Para aceder \xe0 API de gest\xe3o do Logto, selecione fun\xe7\xf5es com permiss\xf5es de API de gest\xe3o <flag/>.",
    with_management_api_access_tip: "Esta fun\xe7\xe3o de m\xe1quina para m\xe1quina inclui permiss\xf5es para a API de gest\xe3o do Logto"
};
var $752155db6d1aa86b$export$2e2bcd8739ae039 = Object.freeze($752155db6d1aa86b$var$roles);


const $8af123a28347c579$var$session_expired = {
    title: "Sess\xe3o expirada",
    subtitle: "A sua sess\xe3o pode ter expirado  foi desconectado. Clique no bot\xe3o abaixo para fazer login novamente.",
    button: "Entrar novamente"
};
var $8af123a28347c579$export$2e2bcd8739ae039 = Object.freeze($8af123a28347c579$var$session_expired);


const $5038f3cdf276d6c1$var$content = {
    terms_of_use: {
        title: "TERMS",
        terms_of_use: "Terms of use URL",
        terms_of_use_placeholder: "https://your.terms.of.use/",
        privacy_policy: "Privacy policy URL",
        privacy_policy_placeholder: "https://your.privacy.policy/"
    },
    languages: {
        title: "LANGUAGES",
        enable_auto_detect: "Enable auto-detect",
        description: "Your software detects the user's locale setting and switches to the local language. You can add new languages by translating UI from English to another language.",
        manage_language: "Manage language",
        default_language: "Default language",
        default_language_description_auto: "The default language will be used when the detected user language isn’t covered in the current language library.",
        default_language_description_fixed: "When auto-detect is off, the default language is the only language your software will show. Turn on auto-detect for language extension."
    },
    manage_language: {
        title: "Manage language",
        subtitle: "Localize the product experience by adding languages and translations. Your contribution can be set as the default language.",
        add_language: "Add Language",
        logto_provided: "Logto provided",
        key: "Key",
        logto_source_values: "Logto source values",
        custom_values: "Custom values",
        clear_all_tip: "Clear all values",
        unsaved_description: "Changes won’t be saved if you leave this page without saving.",
        deletion_tip: "Delete the language",
        deletion_title: "Do you want to delete the added language?",
        deletion_description: "After deletion, your users won’t be able to browse in that language again.",
        default_language_deletion_title: "Default language can’t be deleted.",
        default_language_deletion_description: "{{language}} is set as your default language and can’t be deleted. "
    }
};
var $5038f3cdf276d6c1$export$2e2bcd8739ae039 = Object.freeze($5038f3cdf276d6c1$var$content);


const $5977d31600325a3f$var$password_policy = {
    password_requirements: "Requisitos de password",
    minimum_length: "Comprimento m\xednimo",
    minimum_length_description: "O NIST sugere o uso de <a>pelo menos 8 caracteres</a> para produtos web.",
    minimum_length_error: "O comprimento m\xednimo deve estar entre {{min}} e {{max}} (inclusive).",
    minimum_required_char_types: "Tipos de caracteres m\xednimos necess\xe1rios",
    minimum_required_char_types_description: "Tipos de caracteres: letras mai\xfasculas (A-Z), letras min\xfasculas (a-z), n\xfameros (0-9) e s\xedmbolos especiais ({{symbols}}).",
    password_rejection: "Rejei\xe7\xe3o de password",
    compromised_passwords: "Passwords comprometidos",
    breached_passwords: "Passwords violados",
    breached_passwords_description: "Recusar passwords encontradas anteriormente em bancos de dados de viola\xe7\xe3o.",
    restricted_phrases: "Frases de baixa seguran\xe7a restritas",
    restricted_phrases_tooltip: "Your password should avoid these phrases unless you combine with 3 or more extra characters.",
    repetitive_or_sequential_characters: "Caracteres repetitivos ou sequenciais",
    repetitive_or_sequential_characters_description: 'Ex., "AAAA", "1234" e "abcd".',
    user_information: "Informa\xe7\xf5es do utilizador",
    user_information_description: "Ex., endere\xe7o de email, n\xfamero de telefone, nome de utilizador, etc.",
    custom_words: "Palavras personalizadas",
    custom_words_description: "Personalize palavras espec\xedficas do contexto, n\xe3o diferenciando mai\xfasculas de min\xfasculas e uma por linha.",
    custom_words_placeholder: "Nome de seu servi\xe7o, nome da empresa, etc."
};
var $5977d31600325a3f$export$2e2bcd8739ae039 = Object.freeze($5977d31600325a3f$var$password_policy);


const $6995bfdd50a83853$var$sign_up_and_sign_in = {
    identifiers_email: "Endere\xe7o de email",
    identifiers_phone: "N\xfamero de telefone",
    identifiers_username: "Nome de utilizador",
    identifiers_email_or_sms: "Endere\xe7o de email ou n\xfamero de telefone",
    identifiers_none: "N\xe3o aplic\xe1vel",
    and: "e",
    or: "ou",
    sign_up: {
        title: "REGISTO",
        sign_up_identifier: "Identificador de registo",
        identifier_description: "O identificador de registo \xe9 necess\xe1rio para a cria\xe7\xe3o de conta e deve ser inclu\xeddo no ecr\xe3 de in\xedcio de sess\xe3o.",
        sign_up_authentication: "Defini\xe7\xe3o de autentica\xe7\xe3o para registo",
        authentication_description: "Todas as a\xe7\xf5es selecionadas ser\xe3o obrigat\xf3rias para os utilizadores concluir o processo de registo.",
        set_a_password_option: "Criar uma senha",
        verify_at_sign_up_option: "Verificar durante o registo",
        social_only_creation_description: "(Aplica-se apenas \xe0 cria\xe7\xe3o de contas sociais)"
    },
    sign_in: {
        title: "INICIAR SESS\xc3O",
        sign_in_identifier_and_auth: "Identificador e defini\xe7\xf5es de autentica\xe7\xe3o para in\xedcio de sess\xe3o",
        description: "Os utilizadores podem iniciar sess\xe3o usando qualquer uma das op\xe7\xf5es dispon\xedveis. Ajuste a disposi\xe7\xe3o arrastando e soltando as op\xe7\xf5es abaixo.",
        add_sign_in_method: "Adicionar M\xe9todo de In\xedcio de Sess\xe3o",
        password_auth: "Senha",
        verification_code_auth: "C\xf3digo de verifica\xe7\xe3o",
        auth_swap_tip: "Alterne as op\xe7\xf5es abaixo para determinar qual aparece primeiro no processo.",
        require_auth_factor: "Tem de selecionar pelo menos um fator de autentica\xe7\xe3o."
    },
    social_sign_in: {
        title: "IN\xcdCIO DE SESS\xc3O SOCIAL",
        social_sign_in: "In\xedcio de sess\xe3o social",
        description: "Dependendo do identificador obrigat\xf3rio que configurou, o utilizador pode ser solicitado a fornecer um identificador ao registar-se atrav\xe9s do conector social.",
        add_social_connector: "Adicionar Conector Social",
        set_up_hint: {
            not_in_list: "N\xe3o est\xe1 na lista?",
            set_up_more: "Configurar",
            go_to: "outros conectores sociais agora."
        }
    },
    tip: {
        set_a_password: "Um conjunto \xfanico de uma senha para o seu nome de utilizador \xe9 obrigat\xf3rio.",
        verify_at_sign_up: "Atualmente, apenas suportamos email verificado. A sua base de utilizadores pode conter um grande n\xfamero de endere\xe7os de email de m\xe1 qualidade se n\xe3o houver valida\xe7\xe3o.",
        password_auth: "Isto \xe9 essencial uma vez que ativou a op\xe7\xe3o de criar uma senha durante o processo de registo.",
        verification_code_auth: "Isto \xe9 essencial uma vez que apenas ativou a op\xe7\xe3o de fornecer um c\xf3digo de verifica\xe7\xe3o ao registar-se. \xc9 livre de desmarcar a caixa quando a configura\xe7\xe3o da senha \xe9 permitida durante o processo de registo.",
        delete_sign_in_method: "Isto \xe9 essencial uma vez que selecionou {{identifier}} como um identificador obrigat\xf3rio."
    },
    advanced_options: {
        title: "OP\xc7\xd5ES AVAN\xc7ADAS",
        enable_single_sign_on: "Ativar in\xedcio de sess\xe3o \xfanico da empresa (SSO)",
        enable_single_sign_on_description: "Permite aos utilizadores iniciar sess\xe3o na aplica\xe7\xe3o utilizando a autentica\xe7\xe3o \xfanica com as suas identidades empresariais.",
        single_sign_on_hint: {
            prefix: "Ir para ",
            link: '"SSO Empresarial"',
            suffix: "se\xe7\xe3o para configurar mais conectores empresariais."
        },
        enable_user_registration: "Ativar registo de utilizadores",
        enable_user_registration_description: "Ativar ou desativar o registo de utilizadores. Uma vez desativado, os utilizadores ainda podem ser adicionados na consola de administra\xe7\xe3o, mas os utilizadores n\xe3o podem mais estabelecer contas atrav\xe9s da interface de in\xedcio de sess\xe3o."
    }
};
var $6995bfdd50a83853$export$2e2bcd8739ae039 = Object.freeze($6995bfdd50a83853$var$sign_up_and_sign_in);


const $b28f951d6bc1dbc7$var$sign_in_exp = {
    page_title: "Experi\xeancia de login",
    title: "Experi\xeancia de login",
    description: "Personalize a interface de login para corresponder a sua marca e visualize em tempo real",
    tabs: {
        branding: "Marca",
        sign_up_and_sign_in: "Registo e login",
        content: "Conte\xfado",
        password_policy: "Pol\xedtica de senha"
    },
    welcome: {
        title: "Personalize a experi\xeancia de in\xedcio de sess\xe3o",
        description: "Comece rapidamente com a configura\xe7\xe3o do seu primeiro in\xedcio de sess\xe3o. Este guia orienta-o atrav\xe9s de todas as defini\xe7\xf5es necess\xe1rias.",
        get_started: "Come\xe7ar",
        apply_remind: "Observe que a experi\xeancia de login ser\xe1 aplicada a todos os apps nesta conta."
    },
    color: {
        title: "COR",
        primary_color: "Cor da marca",
        dark_primary_color: "Cor da marca (tema escuro)",
        dark_mode: "Ativar tema escuro",
        dark_mode_description: "O app ter\xe1 um tema escuro gerado automaticamente com base na cor da marca e no algoritmo Logto. contudo \xe9 livre de personalizar.",
        dark_mode_reset_tip: "Recalcular a cor do tema escuro com base na cor da marca.",
        reset: "Recalcular"
    },
    branding: {
        title: "\xc1REA DE MARCA",
        ui_style: "Estilo",
        favicon: "Favicon",
        logo_image_url: "URL do logotipo da app",
        logo_image_url_placeholder: "https://your.cdn.domain/logo.png",
        dark_logo_image_url: "URL do logotipo da app (tema escuro)",
        dark_logo_image_url_placeholder: "https://your.cdn.domain/logo-dark.png",
        logo_image: "Log\xf3tipo da aplica\xe7\xe3o",
        dark_logo_image: "Log\xf3tipo da aplica\xe7\xe3o (escuro)",
        logo_image_error: "Log\xf3tipo da aplica\xe7\xe3o: {{error}}",
        favicon_error: "Favicon: {{error}}"
    },
    custom_css: {
        title: "CSS Personalizado",
        css_code_editor_title: "Personalize a sua IU com CSS personalizado",
        css_code_editor_description1: "Veja o exemplo de CSS personalizado.",
        css_code_editor_description2: "<a>{{link}}</a>",
        css_code_editor_description_link_content: "Saiba mais",
        css_code_editor_content_placeholder: "Insira o seu CSS personalizado para personalizar os estilos de qualquer elemento para as suas especifica\xe7\xf5es exatas. Expresse a sua criatividade e fa\xe7a a sua interface destacar-se."
    },
    sign_up_and_sign_in: $6995bfdd50a83853$export$2e2bcd8739ae039,
    content: $5038f3cdf276d6c1$export$2e2bcd8739ae039,
    password_policy: $5977d31600325a3f$export$2e2bcd8739ae039,
    setup_warning: {
        no_connector_sms: 'Ainda n\xe3o foi configurado nenhum conector SMS. Antes de concluir a configura\xe7\xe3o, os utilizadores n\xe3o poder\xe3o iniciar sess\xe3o com este m\xe9todo. <a>{{link}}</a> em "Conectores"',
        no_connector_email: 'Ainda n\xe3o foi configurado qualquer conector de email. Antes de concluir a configura\xe7\xe3o, os utilizadores n\xe3o poder\xe3o iniciar sess\xe3o com este m\xe9todo. <a>{{link}}</a> em "Conectores"',
        no_connector_social: 'Voc\xea ainda n\xe3o configurou nenhum conector social. Adicione conectores primeiro para aplicar m\xe9todos de login social. <a>{{link}}</a> em "Conectores".',
        setup_link: "Configurar"
    },
    save_alert: {
        description: "Est\xe1 a implementar novos procedimentos de in\xedcio de sess\xe3o e registo. Todos os seus utilizadores podem ser afetados pela nova configura\xe7\xe3o. Tem a certeza de que quer confirmar a altera\xe7\xe3o?",
        before: "Antes",
        after: "Depois",
        sign_up: "Registo",
        sign_in: "Iniciar sess\xe3o",
        social: "Social"
    },
    preview: {
        title: "Visualiza\xe7\xe3o pr\xe9via do login",
        live_preview: "Visualiza\xe7\xe3o ao vivo",
        live_preview_tip: "Guardar para visualizar as altera\xe7\xf5es",
        native: "App nativa",
        desktop_web: "Web no computador",
        mobile_web: "Web no telem\xf3vel",
        desktop: "Ambiente de trabalho",
        mobile: "M\xf3vel"
    }
};
var $b28f951d6bc1dbc7$export$2e2bcd8739ae039 = Object.freeze($b28f951d6bc1dbc7$var$sign_in_exp);


const $1fded70e277501a8$var$signing_keys = {
    title: "Chaves de assinatura",
    description: "Gerir de forma segura as chaves de assinatura utilizadas pelas suas aplica\xe7\xf5es.",
    private_key: "Chaves privadas OIDC",
    private_keys_description: "As chaves privadas OIDC s\xe3o usadas para assinar tokens JWT.",
    cookie_key: "Chaves de cookie OIDC",
    cookie_keys_description: "As chaves de cookie OIDC s\xe3o usadas para assinar cookies.",
    private_keys_in_use: "Chaves privadas em uso",
    cookie_keys_in_use: "Chaves de cookies em uso",
    rotate_private_keys: "Rodar chaves privadas",
    rotate_cookie_keys: "Rodar chaves de cookies",
    rotate_private_keys_description: "Esta a\xe7\xe3o criar\xe1 uma nova chave privada de assinatura, rodar\xe1 a chave atual e remover\xe1 a chave anterior. Os seus tokens JWT assinados com a chave atual permanecer\xe3o v\xe1lidos at\xe9 \xe0 elimina\xe7\xe3o ou outra rodada de rota\xe7\xe3o.",
    rotate_cookie_keys_description: "Esta a\xe7\xe3o criar\xe1 uma nova chave de cookie, rodar\xe1 a chave atual e remover\xe1 a chave anterior. Os seus cookies com a chave atual permanecer\xe3o v\xe1lidos at\xe9 \xe0 elimina\xe7\xe3o ou outra rodada de rota\xe7\xe3o.",
    select_private_key_algorithm: "Selecionar o algoritmo de assinatura para a nova chave privada",
    rotate_button: "Rodar",
    table_column: {
        id: "ID",
        status: "Estado",
        algorithm: "Algoritmo de assinatura da chave"
    },
    status: {
        current: "Atual",
        previous: "Anterior"
    },
    reminder: {
        rotate_private_key: "Tem a certeza de que pretende rodar as <strong>chaves privadas OIDC</strong>? Os novos tokens JWT emitidos ser\xe3o assinados pela nova chave. Os tokens JWT existentes permanecem v\xe1lidos at\xe9 rodar novamente.",
        rotate_cookie_key: "Tem a certeza de que pretende rodar as <strong>chaves de cookies OIDC</strong>? Os novos cookies gerados em sess\xf5es de login ser\xe3o assinados pela nova chave de cookie. Os cookies existentes permanecem v\xe1lidos at\xe9 rodar novamente.",
        delete_private_key: "Tem a certeza de que pretende eliminar a <strong>chave privada OIDC</strong>? Os tokens JWT existentes assinados com esta chave de assinatura privada deixar\xe3o de ser v\xe1lidos.",
        delete_cookie_key: "Tem a certeza de que pretende eliminar a <strong>chave de cookie OIDC</strong>? As sess\xf5es de login antigas com cookies assinados com esta chave de cookie deixar\xe3o de ser v\xe1lidas. \xc9 necess\xe1ria uma nova autentica\xe7\xe3o para estes utilizadores."
    },
    messages: {
        rotate_key_success: "Chaves de assinatura rodadas com sucesso.",
        delete_key_success: "Chave eliminada com sucesso."
    }
};
var $1fded70e277501a8$export$2e2bcd8739ae039 = Object.freeze($1fded70e277501a8$var$signing_keys);


const $e95d253984fd1605$var$quota_item = {
    tenant_limit: {
        name: "Inquilinos",
        limited: "{{count, number}} inquilino",
        limited_other: "{{count, number}} inquilinos",
        unlimited: "Inquilinos ilimitados",
        not_eligible: "Eliminar tus inquilinos"
    },
    mau_limit: {
        name: "Utilizadores ativos mensais",
        limited: "{{count, number}} MAU",
        unlimited: "Utilizadores ativos mensais ilimitados",
        not_eligible: "Remover todos os utilizadores"
    },
    token_limit: {
        name: "Tokens",
        limited: "{{count, number}} token",
        limited_other: "{{count, number}} tokens",
        unlimited: "Tokens ilimitados",
        not_eligible: "Remover os teus utilizadores para evitar novos tokens"
    },
    applications_limit: {
        name: "Aplica\xe7\xf5es",
        limited: "{{count, number}} aplica\xe7\xe3o",
        limited_other: "{{count, number}} aplica\xe7\xf5es",
        unlimited: "Aplica\xe7\xf5es ilimitadas",
        not_eligible: "Remover as tuas aplica\xe7\xf5es"
    },
    machine_to_machine_limit: {
        name: "M\xe1quina para m\xe1quina",
        limited: "{{count, number}} aplica\xe7\xe3o de m\xe1quina para m\xe1quina",
        limited_other: "{{count, number}} aplica\xe7\xf5es de m\xe1quina para m\xe1quina",
        unlimited: "Aplica\xe7\xf5es de m\xe1quina para m\xe1quina ilimitadas",
        not_eligible: "Remover as tuas aplica\xe7\xf5es de m\xe1quina para m\xe1quina"
    },
    third_party_applications_limit: {
        name: "Aplica\xe7\xf5es de terceiros",
        limited: "{{count, number}} aplica\xe7\xe3o de terceiros",
        limited_other: "{{count, number}} aplica\xe7\xf5es de terceiros",
        unlimited: "Aplica\xe7\xf5es de terceiros ilimitadas",
        not_eligible: "Remover as tuas aplica\xe7\xf5es de terceiros"
    },
    resources_limit: {
        name: "Recursos de API",
        limited: "{{count, number}} recurso de API",
        limited_other: "{{count, number}} recursos de API",
        unlimited: "Recursos de API ilimitados",
        not_eligible: "Remover os teus recursos de API"
    },
    scopes_per_resource_limit: {
        name: "Permiss\xf5es de recursos",
        limited: "{{count, number}} permiss\xe3o por recurso",
        limited_other: "{{count, number}} permiss\xf5es por recurso",
        unlimited: "Permiss\xe3o por recurso ilimitada",
        not_eligible: "Remover as tuas permiss\xf5es de recurso"
    },
    custom_domain_enabled: {
        name: "Dom\xednio personalizado",
        limited: "Dom\xednio personalizado",
        unlimited: "Dom\xednio personalizado",
        not_eligible: "Remover o teu dom\xednio personalizado"
    },
    omni_sign_in_enabled: {
        name: "Omni sign-in",
        limited: "Omni sign-in",
        unlimited: "Omni sign-in",
        not_eligible: "Desativar o teu omni sign-in"
    },
    built_in_email_connector_enabled: {
        name: "Conector de e-mail incorporado",
        limited: "Conector de e-mail incorporado",
        unlimited: "Conector de e-mail incorporado",
        not_eligible: "Remover o teu conector de e-mail incorporado"
    },
    social_connectors_limit: {
        name: "Conectores sociais",
        limited: "{{count, number}} conector social",
        limited_other: "{{count, number}} conectores sociais",
        unlimited: "Conectores sociais ilimitados",
        not_eligible: "Remover os teus conectores sociais"
    },
    standard_connectors_limit: {
        name: "Conectores padr\xe3o gratuitos",
        limited: "{{count, number}} conector padr\xe3o gratuito",
        limited_other: "{{count, number}} conectores padr\xe3o gratuitos",
        unlimited: "Conectores padr\xe3o ilimitados",
        not_eligible: "Remover os teus conectores padr\xe3o"
    },
    roles_limit: {
        name: "Fun\xe7\xf5es",
        limited: "{{count, number}} fun\xe7\xe3o",
        limited_other: "{{count, number}} fun\xe7\xf5es",
        unlimited: "Fun\xe7\xf5es ilimitadas",
        not_eligible: "Remover as tuas fun\xe7\xf5es"
    },
    machine_to_machine_roles_limit: {
        name: "Fun\xe7\xf5es de m\xe1quina para m\xe1quina",
        limited: "{{count, number}} fun\xe7\xe3o de m\xe1quina para m\xe1quina",
        limited_other: "{{count, number}} fun\xe7\xf5es de m\xe1quina para m\xe1quina",
        unlimited: "Fun\xe7\xf5es de m\xe1quina para m\xe1quina ilimitadas",
        not_eligible: "Remover as tuas fun\xe7\xf5es de m\xe1quina para m\xe1quina"
    },
    scopes_per_role_limit: {
        name: "Permiss\xf5es de fun\xe7\xe3o",
        limited: "{{count, number}} permiss\xe3o por fun\xe7\xe3o",
        limited_other: "{{count, number}} permiss\xf5es por fun\xe7\xe3o",
        unlimited: "Permiss\xe3o por fun\xe7\xe3o ilimitada",
        not_eligible: "Remover as tuas permiss\xf5es de fun\xe7\xe3o"
    },
    hooks_limit: {
        name: "Webhooks",
        limited: "{{count, number}} webhook",
        limited_other: "{{count, number}} webhooks",
        unlimited: "Webhooks ilimitados",
        not_eligible: "Remova os teus webhooks"
    },
    organizations_enabled: {
        name: "Organiza\xe7\xf5es",
        limited: "Organiza\xe7\xf5es",
        unlimited: "Organiza\xe7\xf5es",
        not_eligible: "Remover as tuas organiza\xe7\xf5es"
    },
    audit_logs_retention_days: {
        name: "Conserva\xe7\xe3o de registos de auditoria",
        limited: "Conserva\xe7\xe3o de registos de auditoria: {{count, number}} dia",
        limited_other: "Conserva\xe7\xe3o de registos de auditoria: {{count, number}} dias",
        unlimited: "Dias ilimitados",
        not_eligible: "Sem registos de auditoria"
    },
    email_ticket_support: {
        name: "Suporte por e-mail",
        limited: "{{count, number}} horas de suporte por e-mail",
        limited_other: "{{count, number}} horas de suporte por e-mail",
        unlimited: "Suporte por e-mail",
        not_eligible: "Sem suporte por e-mail"
    },
    mfa_enabled: {
        name: "Autentica\xe7\xe3o de dois fatores",
        limited: "Autentica\xe7\xe3o de dois fatores",
        unlimited: "Autentica\xe7\xe3o de dois fatores",
        not_eligible: "Remova a sua autentica\xe7\xe3o de dois fatores"
    },
    sso_enabled: {
        name: "SSO Empresarial",
        limited: "SSO Empresarial",
        unlimited: "SSO Empresarial",
        not_eligible: "Remover o teu SSO Empresarial"
    },
    tenant_members_limit: {
        name: "Membros do inquilino",
        limited: "{{count, number}} membro do inquilino",
        limited_other: "{{count, number}} membros do inquilino",
        unlimited: "Membros do inquilino ilimitados",
        not_eligible: "Remove os teus membros do inquilino"
    },
    custom_jwt_enabled: {
        name: "JWT personalizado",
        limited: "JWT personalizado",
        unlimited: "JWT personalizado",
        not_eligible: "Remove o teu personalizador de reivindica\xe7\xf5es JWT"
    }
};
var $e95d253984fd1605$export$2e2bcd8739ae039 = Object.freeze($e95d253984fd1605$var$quota_item);


const $9cc3f95e930feb5c$var$quota_table = {
    quota: {
        title: "B\xe1sicos",
        base_price: "Pre\xe7o base",
        mau_limit: "Limite de MAU",
        included_tokens: "Tokens inclu\xeddos"
    },
    application: {
        title: "Aplica\xe7\xf5es",
        total: "Total de aplica\xe7\xf5es",
        m2m: "Aplica\xe7\xf5es de m\xe1quina para m\xe1quina",
        third_party: "Aplica\xe7\xf5es de terceiros"
    },
    resource: {
        title: "Recursos da API",
        resource_count: "Contagem de recursos",
        scopes_per_resource: "Permiss\xf5es por recurso"
    },
    branding: {
        title: "UI e branding",
        custom_domain: "Dom\xednio personalizado",
        custom_css: "CSS personalizado",
        app_logo_and_favicon: "Log\xf3tipo da aplica\xe7\xe3o e favicon",
        dark_mode: "Modo escuro",
        i18n: "Internacionaliza\xe7\xe3o"
    },
    user_authn: {
        title: "Autentica\xe7\xe3o do utilizador",
        omni_sign_in: "In\xedcio de sess\xe3o Omni",
        password: "Palavra-passe",
        passwordless: "Sem palavra-passe - E-mail e SMS",
        email_connector: "Conector de e-mail",
        sms_connector: "Conector de SMS",
        social_connectors: "Conectores sociais",
        standard_connectors: "Conectores padr\xe3o",
        built_in_email_connector: "Conector de e-mail incorporado",
        mfa: "Autentica\xe7\xe3o de v\xe1rios fatores",
        sso: "SSO Empresarial",
        adaptive_mfa: "MFA adaptativo"
    },
    user_management: {
        title: "Gest\xe3o de utilizadores",
        user_management: "Gest\xe3o de utilizadores",
        roles: "Fun\xe7\xf5es",
        machine_to_machine_roles: "Fun\xe7\xf5es de m\xe1quina para m\xe1quina",
        scopes_per_role: "Permiss\xf5es por fun\xe7\xe3o"
    },
    organizations: {
        title: "Organiza\xe7\xe3o",
        organizations: "Organiza\xe7\xf5es",
        organization: "Organiza\xe7\xe3o",
        organization_count: "Contagem de organiza\xe7\xf5es",
        allowed_users_per_org: "Utilizadores por organiza\xe7\xe3o",
        invitation: "Convite (Management API)",
        org_roles: "Fun\xe7\xf5es da organiza\xe7\xe3o",
        org_permissions: "Permiss\xf5es da organiza\xe7\xe3o",
        just_in_time_provisioning: "Provisionamento just-in-time"
    },
    support: {
        title: "Conformidade e suporte",
        community: "Comunidade",
        customer_ticket: "Bilhete de suporte",
        premium: "Premium",
        email_ticket_support: "Suporte por bilhete de e-mail",
        soc2_report: "Relat\xf3rio SOC2",
        hipaa_or_baa_report: "Relat\xf3rio HIPAA/BAA"
    },
    developers_and_platform: {
        title: "Programadores e plataforma",
        hooks: "Webhooks",
        audit_logs_retention: "Reten\xe7\xe3o de registos de auditoria",
        jwt_claims: "Reivindica\xe7\xf5es JWT",
        tenant_members: "Membros do inquilino"
    },
    unlimited: "Ilimitado",
    contact: "Contactar",
    monthly_price: "${{value, number}}/m\xeas",
    days_one: "{{count, number}} dia",
    days_other: "{{count, number}} dias",
    add_on: "Suplemento",
    tier: "N\xedvel{{value, number}}: ",
    paid_token_limit_tip: "O Logto adicionar\xe1 cobran\xe7as para funcionalidades que ultrapassem o limite da sua quota. Pode utiliz\xe1-lo gratuitamente at\xe9 come\xe7armos a cobrar por volta do segundo trimestre de 2024. Se precisar de mais tokens, por favor, entre em contacto connosco. Por padr\xe3o, cobramos $80 por m\xeas por cada milh\xe3o de tokens.",
    paid_quota_limit_tip: "O Logto adicionar\xe1 encargos por funcionalidades que ultrapassem o seu limite de quota. Pode utiliz\xe1-lo sem custos at\xe9 come\xe7armos a cobrar, aproximadamente no segundo trimestre de 2024.",
    paid_add_on_feature_tip: "Esta \xe9 uma funcionalidade adicional. Pode utiliz\xe1-la sem custos at\xe9 come\xe7armos a cobrar, aproximadamente no segundo trimestre de 2024.",
    million: "{{value, number}} milh\xe3o",
    mau_tip: "MAU (utilizadores ativos mensais) significa o n\xfamero de utilizadores \xfanicos que trocaram pelo menos um token com o Logto num ciclo de fatura\xe7\xe3o.",
    tokens_tip: "Todos os tipos de tokens emitidos pelo Logto, incluindo token de acesso, token de atualiza\xe7\xe3o, etc.",
    mao_tip: "MAO (Organiza\xe7\xe3o Ativa Mensal) significa o n\xfamero de organiza\xe7\xf5es \xfanicas que t\xeam pelo menos um MAU (Utilizador Ativo Mensal) num ciclo de fatura\xe7\xe3o.",
    third_party_tip: "Utilize o Logto como o seu fornecedor de identidade OIDC para in\xedcios de sess\xe3o de aplica\xe7\xf5es de terceiros e outorga de permiss\xf5es.",
    included: "inclu\xeddo{{value, number}}",
    included_mao: "{{value, number}} MAO inclu\xedda",
    extra_quota_price: "Depois ${{value, number}} por m\xeas / cada um depois",
    per_month_each: "${{value, number}} por m\xeas / cada um",
    extra_mao_price: "Depois ${{value, number}} por MAO",
    per_month: "${{value, number}} por m\xeas",
    per_member: "Depois ${{value, number}} por membro"
};
var $9cc3f95e930feb5c$export$2e2bcd8739ae039 = Object.freeze($9cc3f95e930feb5c$var$quota_table);


const $5d009e80787392a3$var$subscription = {
    free_plan: "Plano Gratuito",
    free_plan_description: "Para projetos secund\xe1rios e testes iniciais do Logto. Sem cart\xe3o de cr\xe9dito.",
    pro_plan: "Plano Pro",
    pro_plan_description: "Para empresas que desejam se beneficiar sem preocupa\xe7\xf5es com o Logto.",
    enterprise: "Empresa",
    current_plan: "Plano Atual",
    current_plan_description: "Aqui est\xe1 o seu plano atual. Pode facilmente verificar a utiliza\xe7\xe3o do seu plano, verificar a sua pr\xf3xima fatura e efetuar altera\xe7\xf5es no seu plano, conforme necess\xe1rio.",
    plan_usage: "Uso do plano",
    plan_cycle: "Ciclo do plano: {{period}}. O uso \xe9 renovado em {{renewDate}}.",
    next_bill: "Sua pr\xf3xima fatura",
    next_bill_hint: "Para saber mais sobre o c\xe1lculo, consulte este <a>artigo</a>.",
    next_bill_tip: "Os pre\xe7os exibidos aqui n\xe3o incluem impostos. O valor do imposto ser\xe1 calculado com base nas informa\xe7\xf5es que voc\xea fornecer e nos requisitos regulat\xf3rios locais, e ser\xe1 mostrado nas suas faturas.",
    manage_payment: "Gerenciar pagamento",
    overfill_quota_warning: "Voc\xea atingiu o limite da sua cota. Para evitar problemas, fa\xe7a upgrade do plano.",
    upgrade_pro: "Atualizar para Pro",
    update_payment: "Atualizar pagamento",
    payment_error: "Problema de pagamento detectado. N\xe3o \xe9 poss\xedvel processar ${{price, number}} para o ciclo anterior. Atualize o pagamento para evitar a suspens\xe3o do servi\xe7o Logto.",
    downgrade: "Downgrade",
    current: "Atual",
    upgrade: "Atualiza\xe7\xe3o",
    quota_table: $9cc3f95e930feb5c$export$2e2bcd8739ae039,
    billing_history: {
        invoice_column: "Faturas",
        status_column: "Status",
        amount_column: "Valor",
        invoice_created_date_column: "Data de cria\xe7\xe3o da fatura",
        invoice_status: {
            void: "Cancelada",
            paid: "Paga",
            open: "Em aberto",
            uncollectible: "Vencida"
        }
    },
    quota_item: $e95d253984fd1605$export$2e2bcd8739ae039,
    downgrade_modal: {
        title: "Tem certeza de que deseja fazer o downgrade?",
        description: "Se voc\xea escolher mudar para o <targetName/>, observe que voc\xea n\xe3o ter\xe1 mais acesso \xe0 cota e \xe0s funcionalidades que estavam anteriormente no <currentName/>.",
        before: "Antes: <name/>",
        after: "Depois: <name />",
        downgrade: "Downgrade"
    },
    not_eligible_modal: {
        downgrade_title: "N\xe3o \xe9 poss\xedvel fazer downgrade",
        downgrade_description: "Certifique-se de cumprir os seguintes crit\xe9rios antes de efetuar o downgrade para o plano <name/>.",
        downgrade_help_tip: "Precisa de ajuda com o downgrade? <a>Contacte-nos</a>.",
        upgrade_title: "Lembrete amig\xe1vel para os nossos honrados early adopters",
        upgrade_description: "Est\xe1s atualmente a utilizar mais do que o permitido pelo <name />. O Logto \xe9 agora oficial, incluindo funcionalidades adequadas a cada plano. Antes de considerares a atualiza\xe7\xe3o para o <name />, certifica-te de que preenches os seguintes crit\xe9rios antes de proceder \xe0 atualiza\xe7\xe3o.",
        upgrade_pro_tip: " Ou considera a atualiza\xe7\xe3o para o Plano Pro.",
        upgrade_help_tip: "Precisa de ajuda com o upgrade? <a>Contacte-nos</a>.",
        a_maximum_of: "Um m\xe1ximo de <item/>"
    },
    upgrade_success: "Atualizou com sucesso para <name/>",
    downgrade_success: "Downgrade conclu\xeddo com sucesso para <name/>",
    subscription_check_timeout: "A verifica\xe7\xe3o de subscri\xe7\xe3o expirou. Por favor, atualize mais tarde.",
    no_subscription: "Sem subscri\xe7\xe3o"
};
var $5d009e80787392a3$export$2e2bcd8739ae039 = Object.freeze($5d009e80787392a3$var$subscription);


const $d281f9a4a7b70b9b$var$tab_sections = {
    overview: "Vis\xe3o geral",
    authentication: "Autentica\xe7\xe3o",
    authorization: "Autoriza\xe7\xe3o",
    users: "Utilizadores",
    developer: "Desenvolvedor",
    tenant: "Inquilino"
};
var $d281f9a4a7b70b9b$export$2e2bcd8739ae039 = Object.freeze($d281f9a4a7b70b9b$var$tab_sections);


const $f22afcf9ba5a3872$var$tabs = {
    get_started: "Come\xe7o",
    dashboard: "Painel",
    applications: "Aplica\xe7\xf5es",
    api_resources: "Recursos API",
    sign_in_experience: "Experi\xeancia de login",
    connectors: "Conectores",
    enterprise_sso: "SSO empresarial",
    webhooks: "Webhooks",
    organizations: "Organiza\xe7\xf5es",
    users: "Gest\xe3o de utilizadores",
    audit_logs: "Registos de auditoria",
    roles: "Fun\xe7\xf5es",
    docs: "Documenta\xe7\xe3o",
    tenant_settings: "Defini\xe7\xf5es do inquilino",
    mfa: "Autentica\xe7\xe3o multi-fator",
    customize_jwt: "JWT personalizado",
    signing_keys: "Chaves de assinatura",
    organization_template: "Modelo de organiza\xe7\xe3o"
};
var $f22afcf9ba5a3872$export$2e2bcd8739ae039 = Object.freeze($f22afcf9ba5a3872$var$tabs);


const $b89d2b6f66431404$var$tenant_members = {
    members: "Membros",
    invitations: "Convites",
    invite_members: "Convidar membros",
    user: "Utilizador",
    roles: "Fun\xe7\xf5es",
    admin: "Administrador",
    collaborator: "Colaborador",
    invitation_status: "Estado do convite",
    inviter: "Convidante",
    expiration_date: "Data de expira\xe7\xe3o",
    invite_modal: {
        title: "Convidar pessoas para Logto Cloud",
        subtitle: "Para convidar membros para uma organiza\xe7\xe3o, eles devem aceitar o convite.",
        to: "Para",
        added_as: "Adicionado como fun\xe7\xf5es",
        email_input_placeholder: "johndoe@example.com"
    },
    invitation_statuses: {
        pending: "Pendente",
        accepted: "Aceite",
        expired: "Expirado",
        revoked: "Revogado"
    },
    invitation_empty_placeholder: {
        title: "Convidar membros da equipa",
        description: "Neste momento, o seu espa\xe7o inquilino n\xe3o tem membros convidados.\nPara ajudar na integra\xe7\xe3o, considere adicionar mais membros ou administradores."
    },
    menu_options: {
        edit: "Editar fun\xe7\xe3o do inquilino",
        delete: "Remover utilizador do inquilino",
        resend_invite: "Reenviar convite",
        revoke: "Revogar convite",
        delete_invitation_record: "Eliminar este registo de convite"
    },
    edit_modal: {
        title: "Alterar fun\xe7\xf5es de {{name}}"
    },
    delete_user_confirm: "Tem a certeza de que deseja remover este utilizador deste inquilino?",
    assign_admin_confirm: "Tem a certeza de que deseja tornar o(s) utilizador(es) selecionado(s) administrador(es)? Ao conceder acesso de administrador, o(s) utilizador(es) ter\xe3o as seguintes permiss\xf5es.<ul><li>Alterar o plano de fatura\xe7\xe3o do inquilino</li><li>Adicionar ou remover colaboradores</li><li>Eliminar o inquilino</li></ul>",
    revoke_invitation_confirm: "Tem a certeza de que deseja revogar este convite?",
    delete_invitation_confirm: "Tem a certeza de que deseja eliminar este registo de convite?",
    messages: {
        invitation_sent: "Convite enviado.",
        invitation_revoked: "Convite revogado.",
        invitation_resend: "Convite reenviado.",
        invitation_deleted: "Registo de convite eliminado."
    },
    errors: {
        email_required: "O email do convidado \xe9 obrigat\xf3rio.",
        email_exists: "O endere\xe7o de email j\xe1 existe.",
        member_exists: "Este utilizador j\xe1 \xe9 membro desta organiza\xe7\xe3o.",
        pending_invitation_exists: "Convite pendente existente. Elimine o email relacionado ou revogue o convite.",
        invalid_email: "Endere\xe7o de email \xe9 inv\xe1lido. Certifique-se de que est\xe1 no formato correto.",
        max_member_limit: "Atingiu o n\xfamero m\xe1ximo de membros ({{limit}}) para este inquilino."
    }
};
var $b89d2b6f66431404$export$2e2bcd8739ae039 = Object.freeze($b89d2b6f66431404$var$tenant_members);


const $00412d46ff9db48b$var$tenants = {
    title: "Defini\xe7\xf5es",
    description: "Gerir eficientemente as configura\xe7\xf5es do inquilino e personalizar o seu dom\xednio.",
    tabs: {
        settings: "Defini\xe7\xf5es",
        members: "Membros",
        domains: "Dom\xednios",
        subscription: "Plano e fatura\xe7\xe3o",
        billing_history: "Hist\xf3rico de fatura\xe7\xe3o"
    },
    settings: {
        title: "DEFINI\xc7\xd5ES",
        description: "Defina o nome do inquilino e veja a regi\xe3o de hospedagem dos seus dados e o tipo de inquilino.",
        tenant_id: "ID do Inquilino",
        tenant_name: "Nome do Inquilino",
        tenant_region: "Regi\xe3o de hospedagem",
        tenant_region_tip: "Os recursos do seu inquilino s\xe3o hospedados na regi\xe3o {{region}}. <a>Learn more</a>",
        environment_tag_development: "Dev",
        environment_tag_production: "Prod",
        tenant_type: "Tipo de inquilino",
        development_description: "Apenas para testes e n\xe3o deve ser usado em produ\xe7\xe3o. N\xe3o \xe9 necess\xe1rio nenhum plano de subscri\xe7\xe3o. Tem todas as funcionalidades profissionais, mas tem limita\xe7\xf5es, como um banner de in\xedcio de sess\xe3o. <a>Learn more</a>",
        production_description: "Destinado a aplica\xe7\xf5es que est\xe3o a ser utilizadas por utilizadores finais e que podem exigir uma subscri\xe7\xe3o paga. <a>Learn more</a>",
        tenant_info_saved: "A informa\xe7\xe3o do inquilino foi guardada com sucesso."
    },
    full_env_tag: {
        development: "Desenvolvimento",
        production: "Produ\xe7\xe3o"
    },
    deletion_card: {
        title: "ELIMINAR",
        tenant_deletion: "Eliminar inquilino",
        tenant_deletion_description: "A elimina\xe7\xe3o do inquilino resultar\xe1 na remo\xe7\xe3o permanente de todos os dados de utilizador e configura\xe7\xe3o associados. Por favor, proceda com cuidado.",
        tenant_deletion_button: "Eliminar inquilino"
    },
    leave_tenant_card: {
        title: "SAIR",
        leave_tenant: "Sair do inquilino",
        leave_tenant_description: "Quaisquer recursos no inquilino permanecer\xe3o, mas deixar\xe1 de ter acesso a este inquilino.",
        last_admin_note: "Para sair deste inquilino, certifique-se de que pelo menos mais um membro tem a fun\xe7\xe3o de Administrador."
    },
    create_modal: {
        title: "Criar inquilino",
        tenant_usage_purpose: "Para que pretende utilizar este inquilino?",
        development_description: "Apenas para testes e n\xe3o deve ser usado em produ\xe7\xe3o. N\xe3o \xe9 necess\xe1rio nenhum plano de subscri\xe7\xe3o.",
        development_hint: "Tem todas as funcionalidades profissionais, mas tem limita\xe7\xf5es, como um banner de in\xedcio de sess\xe3o.",
        production_description: "Para uso por utilizadores finais e pode exigir uma subscri\xe7\xe3o paga.",
        available_plan: "Plano dispon\xedvel:",
        create_button: "Criar inquilino",
        tenant_name_placeholder: "Meu inquilino"
    },
    dev_tenant_migration: {
        title: 'Agora pode experimentar gratuitamente as nossas funcionalidades Pro ao criar um novo "inquilino de desenvolvimento"!',
        affect_title: "Como isto o afeta?",
        hint_1: "Estamos a substituir as antigas <strong>etiquetas de ambiente</strong> por dois novos tipos de inquilino: <strong>“Desenvolvimento”</strong> e <strong>“Produ\xe7\xe3o”</strong>.",
        hint_2: "Para garantir uma transi\xe7\xe3o sem problemas e funcionalidade ininterrupta, todos os inquilinos criados anteriormente ser\xe3o elevados ao tipo de inquilino <strong>Produ\xe7\xe3o</strong> juntamente com a sua subscri\xe7\xe3o anterior.",
        hint_3: "N\xe3o se preocupe, todas as outras defini\xe7\xf5es permanecer\xe3o as mesmas.",
        about_tenant_type: "Sobre o tipo de inquilino"
    },
    delete_modal: {
        title: "Eliminar inquilino",
        description_line1: 'Tem a certeza de que deseja eliminar o seu inquilino "<span>{{name}}</span>" com a etiqueta de sufixo de ambiente "<span>{{tag}}</span>"? Esta a\xe7\xe3o n\xe3o pode ser desfeita e resultar\xe1 na elimina\xe7\xe3o permanente de todos os seus dados e informa\xe7\xf5es do inquilino.',
        description_line2: "Antes de excluir o inquilino, talvez possamos ajud\xe1-lo. <span><a>Contacte-nos por email</a></span>",
        description_line3: 'Se quiser continuar, introduza o nome do inquilino "<span>{{name}}</span>" para confirmar.',
        delete_button: "Eliminar permanentemente",
        cannot_delete_title: "N\xe3o \xe9 poss\xedvel apagar este inquilino",
        cannot_delete_description: "Desculpe, n\xe3o \xe9 poss\xedvel apagar este inquilino neste momento. Certifique-se de estar no Plano Gratuito e ter pago todas as faturas em atraso."
    },
    leave_tenant_modal: {
        description: "Tem a certeza de que deseja sair deste inquilino?",
        leave_button: "Sair"
    },
    tenant_landing_page: {
        title: "Ainda n\xe3o criou um inquilino",
        description: "Para come\xe7ar a configurar o seu projeto com o Logto, crie um novo inquilino. Se precisar de fazer logout ou excluir a sua conta, basta clicar no bot\xe3o avatar no canto superior direito.",
        create_tenant_button: "Criar inquilino"
    },
    status: {
        mau_exceeded: "Limite MAU Excedido",
        suspended: "Suspenso",
        overdue: "Atrasado"
    },
    tenant_suspended_page: {
        title: "Inquilino suspenso. Contacte-nos para restaurar o acesso.",
        description_1: "Lamentamos informar que a sua conta de inquilino foi temporariamente suspensa devido a uso indevido, incluindo exceder os limites de MAU, pagamentos em atraso ou outras a\xe7\xf5es n\xe3o autorizadas.",
        description_2: "Se precisar de mais esclarecimentos, tiver alguma preocupa\xe7\xe3o ou desejar restaurar a funcionalidade completa e desbloquear os seus inquilinos, n\xe3o hesite em contactar-nos imediatamente."
    }
};
var $00412d46ff9db48b$export$2e2bcd8739ae039 = Object.freeze($00412d46ff9db48b$var$tenants);


const $c0833d397f5e6acb$var$topbar = {
    docs: "Documentos",
    help: "Ajuda"
};
var $c0833d397f5e6acb$export$2e2bcd8739ae039 = Object.freeze($c0833d397f5e6acb$var$topbar);


const $c553b7c47a1a23e3$var$featured_plan_content = {
    mau: {
        free_plan: "At\xe9 {{count, number}} MAU",
        pro_plan: "MAU ilimitados"
    },
    m2m: {
        free_plan: "{{count, number}} de m\xe1quina para m\xe1quina",
        pro_plan: "M\xe1quina para m\xe1quina adicional"
    },
    third_party_apps: "IdP para aplica\xe7\xf5es de terceiros",
    mfa: "Autentica\xe7\xe3o de v\xe1rios fatores",
    sso: "SSO empresarial",
    role_and_permissions: {
        free_plan: "{{roleCount, number}} fun\xe7\xe3o e {{permissionCount, number}} permiss\xe3o por fun\xe7\xe3o",
        pro_plan: "Fun\xe7\xf5es e permiss\xf5es ilimitadas por fun\xe7\xe3o"
    },
    organizations: "Organiza\xe7\xf5es",
    audit_logs: "Reten\xe7\xe3o de logs de auditoria: {{count, number}} dias"
};
var $c553b7c47a1a23e3$export$2e2bcd8739ae039 = Object.freeze($c553b7c47a1a23e3$var$featured_plan_content);


const $fecc935ef8b98576$var$paywall = {
    applications: "Limite de {{count, number}} aplica\xe7\xe3o do plano <planName/> atingido. Atualize o plano para atender \xe0s necessidades da sua equipa. Para obter qualquer ajuda, sinta-se \xe0 vontade para <a>entrar em contacto connosco</a>.",
    applications_other: "Limite de {{count, number}} aplica\xe7\xf5es do plano <planName/> atingido. Atualize o plano para atender \xe0s necessidades da sua equipa. Para obter qualquer ajuda, sinta-se \xe0 vontade para <a>entrar em contacto connosco</a>.",
    machine_to_machine_feature: "Mude para o plano <strong>Pro</strong> para obter aplica\xe7\xf5es adicionais de m\xe1quina a m\xe1quina e aproveitar todos os recursos premium. <a>Entre em contacto connosco</a> se tiver d\xfavidas.",
    machine_to_machine: "Limite de {{count, number}} aplica\xe7\xe3o de m\xe1quina a m\xe1quina do plano <planName/> atingido. Atualize o plano para atender \xe0s necessidades da sua equipa. Para obter qualquer ajuda, sinta-se \xe0 vontade para <a>entrar em contacto connosco</a>.",
    machine_to_machine_other: "Limite de {{count, number}} aplica\xe7\xf5es de m\xe1quina a m\xe1quina do plano <planName/> atingido. Atualize o plano para atender \xe0s necessidades da sua equipa. Para obter qualquer ajuda, sinta-se \xe0 vontade para <a>entrar em contacto connosco</a>.",
    resources: "Atingiu o limite de {{count, number}} recursos de API do plano <planName/>. Atualize o plano para satisfazer as necessidades da sua equipa. <a>Contacte-nos</a> se precisar de assist\xeancia.",
    resources_other: "Atingiu o limite de {{count, number}} recursos de API do plano <planName/>. Atualize o plano para satisfazer as necessidades da sua equipa. <a>Contacte-nos</a> se precisar de assist\xeancia.",
    scopes_per_resource: "Atingiu o limite de {{count, number}} permiss\xf5es por recurso de API do plano <planName/>. Atualize agora para expandir. <a>Contacte-nos</a> se precisar de assist\xeancia.",
    scopes_per_resource_other: "Atingiu o limite de {{count, number}} permiss\xf5es por recurso de API do plano <planName/>. Atualize agora para expandir. <a>Contacte-nos</a> se precisar de assist\xeancia.",
    custom_domain: "Desbloqueie a funcionalidade de dom\xednio personalizado ao atualizar para o plano <strong>Hobby</strong> ou <strong>Pro</strong>. N\xe3o hesite em <a>entrar em contacto connosco</a> se precisar de qualquer assist\xeancia.",
    social_connectors: "Atingiu o limite de {{count, number}} conectores sociais do plano <planName/>. Atualize o plano para obter conectores sociais adicionais e a capacidade de criar os seus pr\xf3prios conectores usando os protocolos OIDC, OAuth 2.0 e SAML. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    social_connectors_other: "Atingiu o limite de {{count, number}} conectores sociais do plano <planName/>. Atualize o plano para obter conectores sociais adicionais e a capacidade de criar os seus pr\xf3prios conectores usando os protocolos OIDC, OAuth 2.0 e SAML. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    standard_connectors_feature: "Upgrade para os planos <strong>Hobby</strong> ou <strong>Pro</strong> para criar os seus pr\xf3prios conectores usando os protocolos OIDC, OAuth 2.0 e SAML, al\xe9m de conectores sociais ilimitados e todos os recursos premium. Sinta-se \xe0 vontade para <a>entrar em contacto connosco</a> se precisar de qualquer assist\xeancia.",
    standard_connectors: "Atingiu o limite de {{count, number}} conectores sociais do plano <planName/>. Atualize o plano para obter conectores sociais adicionais e a capacidade de criar os seus pr\xf3prios conectores usando os protocolos OIDC, OAuth 2.0 e SAML. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    standard_connectors_other: "Atingiu o limite de {{count, number}} conectores sociais do plano <planName/>. Atualize o plano para obter conectores sociais adicionais e a capacidade de criar os seus pr\xf3prios conectores usando os protocolos OIDC, OAuth 2.0 e SAML. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    standard_connectors_pro: "Atingiu o limite de {{count, number}} conectores padr\xe3o do plano <planName/>. Atualize para o plano Empresarial para obter conectores sociais adicionais e a capacidade de criar os seus pr\xf3prios conectores usando os protocolos OIDC, OAuth 2.0 e SAML. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    standard_connectors_pro_other: "Atingiu o limite de {{count, number}} conectores padr\xe3o do plano <planName/>. Atualize para o plano Empresarial para obter conectores sociais adicionais e a capacidade de criar os seus pr\xf3prios conectores usando os protocolos OIDC, OAuth 2.0 e SAML. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    roles: "Atingiu o limite de {{count, number}} fun\xe7\xf5es do plano <planName/>. Atualize o plano para adicionar fun\xe7\xf5es e permiss\xf5es adicionais. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    roles_other: "Atingiu o limite de {{count, number}} fun\xe7\xf5es do plano <planName/>. Atualize o plano para adicionar fun\xe7\xf5es e permiss\xf5es adicionais. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    machine_to_machine_roles: "{{count, number}} papel de m\xe1quina a m\xe1quina do plano <planName/> atingido. Atualize o plano para adicionar pap\xe9is e permiss\xf5es adicionais. Sinta-se \xe0 vontade para <a>entrar em contacto connosco</a> se precisar de ajuda.",
    machine_to_machine_roles_other: "{{count, number}} pap\xe9is de m\xe1quina a m\xe1quina do plano <planName/> atingidos. Atualize o plano para adicionar pap\xe9is e permiss\xf5es adicionais. Sinta-se \xe0 vontade para <a>entrar em contacto connosco</a> se precisar de ajuda.",
    scopes_per_role: "Atingiu o limite de {{count, number}} permiss\xf5es por fun\xe7\xe3o do plano <planName/>. Atualize o plano para adicionar fun\xe7\xf5es e permiss\xf5es adicionais. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    scopes_per_role_other: "Atingiu o limite de {{count, number}} permiss\xf5es por fun\xe7\xe3o do plano <planName/>. Atualize o plano para adicionar fun\xe7\xf5es e permiss\xf5es adicionais. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    hooks: "Atingiu o limite de {{count, number}} webhooks do plano <planName/>. Atualize o plano para criar mais webhooks. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    hooks_other: "Atingiu o limite de {{count, number}} webhooks do plano <planName/>. Atualize o plano para criar mais webhooks. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    mfa: "Desbloqueie o MFA para a verifica\xe7\xe3o de seguran\xe7a ao atualizar para um plano pago. N\xe3o hesite em <a>entrar em contacto connosco</a> se precisar de assist\xeancia.",
    organizations: "Desbloquear organiza\xe7\xf5es ao atualizar para um plano pago. N\xe3o hesite em <a>entrar em contacto connosco</a> se precisar de assist\xeancia.",
    third_party_apps: "Desbloqueie o Logto como IdP para aplica\xe7\xf5es de terceiros ao atualizar para um plano pago. Para qualquer assist\xeancia, sinta-se \xe0 vontade para <a>contactar-nos</a>.",
    sso_connectors: "Desbloqueie o SSO empresarial ao atualizar para um plano pago. Para qualquer assist\xeancia, sinta-se \xe0 vontade para <a>contactar-nos</a>.",
    tenant_members: "Desbloqueie a funcionalidade de colabora\xe7\xe3o ao atualizar para um plano pago. Para qualquer assist\xeancia, sinta-se \xe0 vontade para <a>contactar-nos</a>.",
    tenant_members_dev_plan: "Chegou ao seu limite de {{limit}} membros. Liberte um membro ou revoque um convite pendente para adicionar algu\xe9m novo. Precisa de mais lugares? Sinta-se \xe0 vontade para contactar-nos.",
    custom_jwt: {
        title: "Adicionar alega\xe7\xf5es personalizadas",
        description: "Atualize para um plano pago para funcionalidade personalizada JWT e benef\xedcios premium. N\xe3o hesite em <a>contactar-nos</a> se tiver alguma d\xfavida."
    }
};
var $fecc935ef8b98576$export$2e2bcd8739ae039 = Object.freeze($fecc935ef8b98576$var$paywall);


const $25ca2dcf74f4730c$var$upsell = {
    upgrade_plan: "Atualizar plano",
    compare_plans: "Comparar planos",
    view_plans: "Ver planos",
    create_tenant: {
        title: "Selecione o seu plano de inquilino",
        description: "O Logto oferece op\xe7\xf5es competitivas de planos com pre\xe7os inovadores e acess\xedveis, especialmente concebidos para empresas em crescimento. <a>Saiba mais</a>",
        base_price: "Pre\xe7o base",
        monthly_price: "{{value, number}}/m\xeas",
        view_all_features: "Ver todas as funcionalidades",
        select_plan: "Selecionar <name/>",
        free_tenants_limit: "At\xe9 {{count, number}} inquilino gratuito",
        free_tenants_limit_other: "At\xe9 {{count, number}} inquilinos gratuitos",
        most_popular: "Mais popular",
        upgrade_success: "Atualiza\xe7\xe3o para <name/> bem-sucedida"
    },
    mau_exceeded_modal: {
        title: "MAU excedeu o limite. Atualize o seu plano.",
        notification: "O seu MAU atual excedeu o limite de <planName/>. Por favor, atualize para o plano premium a tempo para evitar a suspens\xe3o do servi\xe7o do Logto.",
        update_plan: "Atualizar plano"
    },
    payment_overdue_modal: {
        title: "Pagamento da fatura em atraso",
        notification: "Oops! O pagamento da fatura do inquilino <span>{{name}}</span> falhou. Por favor, pague a fatura prontamente para evitar a suspens\xe3o do servi\xe7o Logto.",
        unpaid_bills: "Faturas n\xe3o pagas",
        update_payment: "Atualizar pagamento"
    },
    add_on_quota_item: {
        api_resource: "Recurso de API",
        machine_to_machine: "aplica\xe7\xe3o m\xe1quina a m\xe1quina",
        tokens: "{{limit}}M tokens",
        tenant_member: "membro do inquilino"
    },
    charge_notification_for_quota_limit: "Voc\xea ultrapassou o limite de sua cota de {{item}}. O Logto adicionar\xe1 cobran\xe7as pelo uso al\xe9m do limite da cota. A cobran\xe7a come\xe7ar\xe1 no dia em que o novo design de pre\xe7os do complemento for lan\xe7ado. <a>Saiba mais</a>",
    paywall: $fecc935ef8b98576$export$2e2bcd8739ae039,
    featured_plan_content: $c553b7c47a1a23e3$export$2e2bcd8739ae039
};
var $25ca2dcf74f4730c$export$2e2bcd8739ae039 = Object.freeze($25ca2dcf74f4730c$var$upsell);


const $762f13a9ba81372e$var$user_details = {
    page_title: "Detalhes do utilizador",
    back_to_users: "Voltar \xe0 gest\xe3o de utilizadores",
    created_title: "Este utilizador foi criado com sucesso",
    created_guide: "Aqui est\xe1 a informa\xe7\xe3o para ajudar o utilizador no processo de login.",
    created_email: "Endere\xe7o de email:",
    created_phone: "N\xfamero de telefone:",
    created_username: "Nome de utilizador:",
    created_password: "Palavra-passe:",
    menu_delete: "eliminar",
    delete_description: "Esta a\xe7\xe3o n\xe3o pode ser desfeita. Isso ir\xe1 eliminar o utilizador permanentemente.",
    deleted: "O utilizador foi eliminado com sucesso",
    reset_password: {
        reset_password: "Redefinir palavra-passe",
        title: "Tem a certeza de que deseja redefinir a palavra-passe?",
        content: "Esta a\xe7\xe3o n\xe3o pode ser desfeita. Isso ir\xe1 redefinir as informa\xe7\xf5es de login do utilizador.",
        congratulations: "Este utilizador foi redefinido",
        new_password: "Nova palavra-passe:"
    },
    tab_settings: "Defini\xe7\xf5es",
    tab_roles: "Fun\xe7\xf5es",
    tab_logs: "Registos do utilizador",
    tab_organizations: "Organiza\xe7\xf5es",
    authentication: "Autentica\xe7\xe3o",
    authentication_description: "Cada utilizador tem um perfil que cont\xe9m todas as informa\xe7\xf5es do utilizador. Consiste em dados b\xe1sicos, identidades sociais e dados personalizados.",
    user_profile: "Perfil de utilizador",
    field_email: "Endere\xe7o de email",
    field_phone: "N\xfamero de telefone",
    field_username: "Nome de utilizador",
    field_name: "Nome",
    field_avatar: "URL da imagem do avatar",
    field_avatar_placeholder: "https://your.cdn.domain/avatar.png",
    field_custom_data: "Dados personalizados",
    field_custom_data_tip: "Informa\xe7\xf5es adicionais do utilizador n\xe3o listadas nas propriedades predefinidas, ex: idioma preferido pelo utilizador.",
    field_connectors: "Conex\xf5es sociais",
    field_sso_connectors: "Conex\xf5es empresariais",
    custom_data_invalid: "Os dados personalizados devem ser um objeto JSON v\xe1lido",
    connectors: {
        connectors: "Conectores",
        user_id: "ID do utilizador",
        remove: "Remover",
        connected: "Este utilizador est\xe1 conectado a m\xfaltiplos conectores sociais.",
        not_connected: "O utilizador n\xe3o est\xe1 conectado a nenhum conector social",
        deletion_confirmation: "Est\xe1 a remover a identidade existente <name/>. Tem a certeza de que deseja continuar?"
    },
    sso_connectors: {
        connectors: "Conetores",
        enterprise_id: "ID da empresa",
        connected: "Este utilizador est\xe1 conectado a m\xfaltiplos provedores de identidade empresarial para In\xedcio de Sess\xe3o \xdanico.",
        not_connected: "O utilizador n\xe3o est\xe1 conectado a nenhum provedor de identidade empresarial para In\xedcio de Sess\xe3o \xdanico."
    },
    mfa: {
        field_name: "Autentica\xe7\xe3o de dois fatores",
        field_description: "Este utilizador ativou fatores de autentica\xe7\xe3o de 2 etapas.",
        name_column: "Autentica\xe7\xe3o de dois fatores",
        field_description_empty: "Este utilizador n\xe3o ativou fatores de autentica\xe7\xe3o de 2 passos.",
        deletion_confirmation: "Est\xe1 a remover o existente <name/> para a verifica\xe7\xe3o em duas etapas. Tem a certeza de que deseja continuar?"
    },
    suspended: "suspenso",
    suspend_user: "Suspender utilizador",
    suspend_user_reminder: "Tem a certeza de que deseja suspender este utilizador? O utilizador n\xe3o conseguir\xe1 entrar na sua aplica\xe7\xe3o e n\xe3o ser\xe1 capaz de obter um novo Token de acesso ap\xf3s o termo atual. Al\xe9m disso, qualquer pedido API feito por este utilizador ir\xe1 falhar.",
    suspend_action: "Suspender",
    user_suspended: "O utilizador foi suspenso.",
    reactivate_user: "Reativar utilizador",
    reactivate_user_reminder: "Tem a certeza de que deseja reativar este utilizador? Isso permitir\xe1 tentativas de login para este utilizador.",
    reactivate_action: "Reativar",
    user_reactivated: "O utilizador foi reativado.",
    roles: {
        name_column: "Fun\xe7\xe3o",
        description_column: "Descri\xe7\xe3o",
        assign_button: "Atribuir fun\xe7\xf5es",
        delete_description: "Esta a\xe7\xe3o ir\xe1 remover esta fun\xe7\xe3o deste utilizador. A fun\xe7\xe3o em si ainda existir\xe1, mas n\xe3o estar\xe1 mais associada a este utilizador.",
        deleted: "{{name}} foi removido do utilizador com sucesso.",
        assign_title: "Atribuir fun\xe7\xf5es a {{name}}",
        assign_subtitle: "Autorize {{name}} uma ou mais fun\xe7\xf5es",
        assign_role_field: "Atribuir fun\xe7\xf5es",
        role_search_placeholder: "Pesquisar pelo nome da fun\xe7\xe3o",
        added_text: "{{value, number}} adicionados",
        assigned_user_count: "{{value, number}} utilizador(es)",
        confirm_assign: "Atribuir fun\xe7\xf5es",
        role_assigned: "Fun\xe7\xe3o(\xf5es) atribu\xedda(s) com sucesso",
        search: "Pesquisar pelo nome, descri\xe7\xe3o ou ID da fun\xe7\xe3o",
        empty: "Nenhuma fun\xe7\xe3o dispon\xedvel"
    },
    warning_no_sign_in_identifier: "O utilizador precisa de ter pelo menos um dos identificadores de in\xedcio de sess\xe3o (nome de utilizador, e-mail, n\xfamero de telefone ou redes sociais) para iniciar sess\xe3o. Tem a certeza de que quer continuar?",
    organization_roles_tooltip: "As fun\xe7\xf5es atribu\xeddas ao utilizador dentro desta organiza\xe7\xe3o."
};
var $762f13a9ba81372e$export$2e2bcd8739ae039 = Object.freeze($762f13a9ba81372e$var$user_details);


const $a44be6fd15b8c113$var$users = {
    page_title: "Gest\xe3o de utilizadores",
    title: "Gest\xe3o de utilizadores",
    subtitle: "Gerencie os utilizadores, incluindo a cria\xe7\xe3o, edi\xe7\xe3o de informa\xe7\xf5es, visualiza\xe7\xe3o de logs, recupera\xe7\xf5es de password e exclus\xf5es",
    create: "Adicionar usu\xe1rio",
    create_subtitle: "Fornecer pelo menos um dos seguintes campos para proceder.",
    error_missing_identifier: "Tem de fornecer pelo menos um identificador para criar um utilizador.",
    user_name: "Utilizador",
    application_name: "Do aplicativo",
    latest_sign_in: "\xdaltimo login",
    create_form_username: "Utilizador",
    create_form_password: "Palavra-passe",
    create_form_name: "Nome completo",
    placeholder_name: "Z\xe9 Ningu\xe9m",
    placeholder_email: "zninguem@example.com",
    placeholder_username: "user123",
    placeholder_phone: "+351 21 234 5678",
    unnamed: "Sem nome",
    search: "Procurar por nome, email, telefone ou nome de utilizador",
    check_user_detail: "Ver detalhes do utilizador",
    placeholder_title: "Gest\xe3o de utilizadores",
    placeholder_description: "Cada utilizador tem um perfil contendo todas as informa\xe7\xf5es do utilizador. Consiste em dados b\xe1sicos, identidades sociais e dados personalizados"
};
var $a44be6fd15b8c113$export$2e2bcd8739ae039 = Object.freeze($a44be6fd15b8c113$var$users);


const $e253cf8c6590e1c8$var$webhook_details = {
    page_title: "Detalhes do webhook",
    back_to_webhooks: "Voltar para Webhooks",
    not_in_use: "N\xe3o est\xe1 em uso",
    success_rate: "Taxa de sucesso",
    requests: "{{value, number}} solicita\xe7\xf5es em 24h",
    disable_webhook: "Desativar o webhook",
    disable_reminder: "Tem certeza de que deseja reativar este webhook? Faz\xea-lo n\xe3o enviar\xe1 solicita\xe7\xe3o HTTP para o URL do endpoint.",
    webhook_disabled: "O webhook foi desativado.",
    webhook_reactivated: "O webhook foi reativado.",
    reactivate_webhook: "Reativar webhook",
    delete_webhook: "Excluir webhook",
    deletion_reminder: "Voc\xea est\xe1 removendo este webhook. Depois de exclu\xed-lo, ele n\xe3o enviar\xe1 solicita\xe7\xe3o HTTP para o URL do endpoint.",
    deleted: "O webhook foi exclu\xeddo com sucesso.",
    settings_tab: "Configura\xe7\xf5es",
    recent_requests_tab: "Solicita\xe7\xf5es recentes (24h)",
    settings: {
        settings: "Configura\xe7\xf5es",
        settings_description: "Os webhooks permitem que voc\xea receba atualiza\xe7\xf5es em tempo real sobre eventos espec\xedficos conforme eles ocorrem, enviando uma solicita\xe7\xe3o POST para seu URL de endpoint. Isso permite que voc\xea tome a\xe7\xf5es imediatas com base nas novas informa\xe7\xf5es recebidas.",
        events: "Eventos",
        events_description: "Selecione os eventos de gatilho que o Logto enviar\xe1 a solicita\xe7\xe3o POST.",
        name: "Nome",
        endpoint_url: "URL do endpoint",
        signing_key: "Chave de assinatura",
        signing_key_tip: "Adicione a chave secreta fornecida pelo Logto ao seu endpoint como um cabe\xe7alho de solicita\xe7\xe3o para garantir a autenticidade do corpo do webhook.",
        regenerate: "Regenerar",
        regenerate_key_title: "Regenerar a chave de assinatura",
        regenerate_key_reminder: "Voc\xea tem certeza de que deseja modificar a chave de assinatura? A regenera\xe7\xe3o entrar\xe1 em vigor imediatamente. Lembre-se de modificar a chave de assinatura de forma s\xedncrona em seu endpoint.",
        regenerated: "A chave de assinatura foi regenerada.",
        custom_headers: "Cabe\xe7alhos personalizados",
        custom_headers_tip: "Opcionalmente, voc\xea pode adicionar cabe\xe7alhos personalizados ao corpo do webhook para fornecer contexto ou metadados adicionais sobre o evento.",
        key_duplicated_error: "As chaves n\xe3o podem ser repetidas.",
        key_missing_error: "Key \xe9 obrigat\xf3rio.",
        value_missing_error: "O valor \xe9 obrigat\xf3rio.",
        invalid_key_error: "Chave inv\xe1lida",
        invalid_value_error: "Valor inv\xe1lido",
        test: "Teste",
        test_webhook: "Teste seu webhook",
        test_webhook_description: "Configure o webhook e teste-o com exemplos de carga \xfatil para cada evento selecionado para verificar a recep\xe7\xe3o e o processamento corretos.",
        send_test_payload: "Enviar carga de teste",
        test_result: {
            endpoint_url: "URL do ponto de extremidade: {{url}}",
            message: "Mensagem: {{message}}",
            response_status: "Estado da resposta: {{status, number}}",
            response_body: "Corpo da resposta: {{body}}",
            request_time: "Tempo da solicita\xe7\xe3o: {{time}}",
            test_success: "O teste de webhook para o ponto de extremidade foi bem-sucedido."
        }
    }
};
var $e253cf8c6590e1c8$export$2e2bcd8739ae039 = Object.freeze($e253cf8c6590e1c8$var$webhook_details);


const $df4f1aad26b08783$var$webhooks = {
    page_title: "Webhooks",
    title: "Webhooks",
    subtitle: "Crie webhooks para receber atualiza\xe7\xf5es em tempo real sobre eventos espec\xedficos.",
    create: "Criar Webhook",
    schemas: {
        interaction: "Intera\xe7\xe3o do utilizador",
        user: "Utilizador",
        organization: "Organiza\xe7\xe3o",
        role: "Fun\xe7\xe3o",
        scope: "Permiss\xe3o",
        organization_role: "Fun\xe7\xe3o da organiza\xe7\xe3o",
        organization_scope: "Permiss\xe3o da organiza\xe7\xe3o"
    },
    table: {
        name: "Nome",
        events: "Eventos",
        success_rate: "Taxa de sucesso (24h)",
        requests: "Solicita\xe7\xf5es (24h)"
    },
    placeholder: {
        title: "Webhook",
        description: 'Crie um webhook para receber atualiza\xe7\xf5es em tempo real por meio de solicita\xe7\xf5es POST para sua URL de endpoint. Fique informado e tome medidas imediatas em eventos como "Criar conta", "Entrar" e "Redefinir senha".',
        create_webhook: "Criar Webhook"
    },
    create_form: {
        title: "Criar Webhook",
        subtitle: "Adicione o Webhook para enviar uma solicita\xe7\xe3o POST para o URL do ponto final com detalhes de quaisquer eventos de utilizadores.",
        events: "Eventos",
        events_description: "Selecione os eventos de gatilho nos quais o Logto enviar\xe1 a solicita\xe7\xe3o POST.",
        name: "Nome",
        name_placeholder: "Digite o nome do webhook",
        endpoint_url: "URL do ponto final",
        endpoint_url_placeholder: "https://seu.url.de.ponto.final/webhook",
        endpoint_url_tip: "Digite o URL do seu ponto final para onde o payload do webhook \xe9 enviado quando o evento ocorre.",
        create_webhook: "Criar webhook",
        missing_event_error: "Voc\xea deve selecionar pelo menos um evento."
    },
    webhook_created: "O webhook {{name}} foi criado com sucesso."
};
var $df4f1aad26b08783$export$2e2bcd8739ae039 = Object.freeze($df4f1aad26b08783$var$webhooks);


const $3cd09384933a90ad$var$welcome = {
    title: "Bem-vindo a consola de Administrador",
    description: "A consola de Administrador \xe9 o lugar para gerenciar o Logto sem ter conhecimentos de programa\xe7\xe3o. Vamos primeiro criar uma conta. Com esta conta, pode gerir o Logto por conta pr\xf3pria ou em nome da empresa.",
    create_account: "Criar uma conta"
};
var $3cd09384933a90ad$export$2e2bcd8739ae039 = Object.freeze($3cd09384933a90ad$var$welcome);


const $5eaddd2e37e002b4$var$admin_console = {
    title: "Consola de Administrador",
    admin_user: "Administrador",
    system_app: "Sistema",
    menu: $3de4faeea85ff3a1$export$2e2bcd8739ae039,
    general: $027da547666039b3$export$2e2bcd8739ae039,
    errors: $6204eab1bceb9557$export$2e2bcd8739ae039,
    tab_sections: $d281f9a4a7b70b9b$export$2e2bcd8739ae039,
    tabs: $f22afcf9ba5a3872$export$2e2bcd8739ae039,
    applications: $89a61c8b2caed3ff$export$2e2bcd8739ae039,
    application_details: $70ab11b5b69b13b1$export$2e2bcd8739ae039,
    api_resources: $7a207964d707de8f$export$2e2bcd8739ae039,
    api_resource_details: $e529bf5fac8cc41e$export$2e2bcd8739ae039,
    connectors: $33070ac41faa0a19$export$2e2bcd8739ae039,
    connector_details: $9b255c0ab102f4aa$export$2e2bcd8739ae039,
    enterprise_sso: $de87b0e74653befa$export$2e2bcd8739ae039,
    enterprise_sso_details: $f8d518177572eb59$export$2e2bcd8739ae039,
    get_started: $25538d8abb8371bd$export$2e2bcd8739ae039,
    users: $a44be6fd15b8c113$export$2e2bcd8739ae039,
    user_details: $762f13a9ba81372e$export$2e2bcd8739ae039,
    contact: $392a0b2c5bc47156$export$2e2bcd8739ae039,
    sign_in_exp: $b28f951d6bc1dbc7$export$2e2bcd8739ae039,
    dashboard: $134ef03cd5cd2c6f$export$2e2bcd8739ae039,
    logs: $76e4b75ec67840c4$export$2e2bcd8739ae039,
    log_details: $7bb9765af82a388f$export$2e2bcd8739ae039,
    session_expired: $8af123a28347c579$export$2e2bcd8739ae039,
    welcome: $3cd09384933a90ad$export$2e2bcd8739ae039,
    roles: $752155db6d1aa86b$export$2e2bcd8739ae039,
    role_details: $47b13feabc161324$export$2e2bcd8739ae039,
    permissions: $21ecc2c444e8d033$export$2e2bcd8739ae039,
    cloud: $e309a88fea8ae403$export$2e2bcd8739ae039,
    profile: $293d5cd7140dd0e3$export$2e2bcd8739ae039,
    components: $28ff60618714c527$export$2e2bcd8739ae039,
    webhooks: $df4f1aad26b08783$export$2e2bcd8739ae039,
    webhook_details: $e253cf8c6590e1c8$export$2e2bcd8739ae039,
    domain: $96daa617edf7837b$export$2e2bcd8739ae039,
    tenants: $00412d46ff9db48b$export$2e2bcd8739ae039,
    tenant_members: $b89d2b6f66431404$export$2e2bcd8739ae039,
    topbar: $c0833d397f5e6acb$export$2e2bcd8739ae039,
    subscription: $5d009e80787392a3$export$2e2bcd8739ae039,
    upsell: $25ca2dcf74f4730c$export$2e2bcd8739ae039,
    guide: $ede4c99ec817ee78$export$2e2bcd8739ae039,
    mfa: $9b3e9b53931f42e4$export$2e2bcd8739ae039,
    organizations: $d2f2161c18e01f25$export$2e2bcd8739ae039,
    organization_details: $acb537eda4a0a04a$export$2e2bcd8739ae039,
    protected_app: $d667fe40fc31d1a0$export$2e2bcd8739ae039,
    jwt_claims: $0857e7fa44283649$export$2e2bcd8739ae039,
    invitation: $014e3f3a600fdeb9$export$2e2bcd8739ae039,
    signing_keys: $1fded70e277501a8$export$2e2bcd8739ae039,
    organization_template: $57a51078645e52de$export$2e2bcd8739ae039,
    organization_role_details: $a863effa5707138d$export$2e2bcd8739ae039
};
var $5eaddd2e37e002b4$export$2e2bcd8739ae039 = Object.freeze($5eaddd2e37e002b4$var$admin_console);


const $29ee569ae86115db$var$demo_app = {
    title: "Iniciou sess\xe3o com sucesso na pr\xe9-visualiza\xe7\xe3o ao vivo!",
    subtitle: "Aqui est\xe3o as suas informa\xe7\xf5es de login:",
    username: "Utilizador: ",
    user_id: "ID de utilizador: ",
    sign_out: "Terminar sess\xe3o na visualiza\xe7\xe3o ao vivo",
    continue_explore: "Ou continue a explorar",
    customize_sign_in_experience: "Personalizar a experi\xeancia de login",
    enable_passwordless: "Ativar o login sem password (passwordless)",
    add_social_connector: "Adicionar conector social"
};
var $29ee569ae86115db$export$2e2bcd8739ae039 = Object.freeze($29ee569ae86115db$var$demo_app);


const $0d1da1af72f68d4d$var$oidc = {
    logout_success: "Sess\xe3o terminada com sucesso."
};
var $0d1da1af72f68d4d$export$2e2bcd8739ae039 = Object.freeze($0d1da1af72f68d4d$var$oidc);


const $63730387eb4518a7$var$translation = {
    admin_console: $5eaddd2e37e002b4$export$2e2bcd8739ae039,
    demo_app: $29ee569ae86115db$export$2e2bcd8739ae039,
    oidc: $0d1da1af72f68d4d$export$2e2bcd8739ae039
};
var $63730387eb4518a7$export$2e2bcd8739ae039 = Object.freeze($63730387eb4518a7$var$translation);


const $b575aefd79f4bc71$var$pt_pt = {
    translation: $63730387eb4518a7$export$2e2bcd8739ae039,
    errors: $4954da1eb2d7780c$export$2e2bcd8739ae039
};
var $b575aefd79f4bc71$export$2e2bcd8739ae039 = Object.freeze($b575aefd79f4bc71$var$pt_pt);


const $d2c6943c7d236c08$var$application = {
    invalid_type: 'Только приложения типа "от машины к машине" могут иметь связанные роли.',
    role_exists: "Роль с идентификатором {{roleId}} уже добавлена в это приложение.",
    invalid_role_type: 'Невозможно назначить роль типа "пользователь" для приложения типа "от машины к машине".',
    invalid_third_party_application_type: "Только традиционные веб-приложения могут быть помечены как приложения сторонних разработчиков.",
    third_party_application_only: "Эта функция доступна только для приложений сторонних разработчиков.",
    user_consent_scopes_not_found: "Недействительные области согласия пользователя.",
    consent_management_api_scopes_not_allowed: "API-области управления не разрешены.",
    protected_app_metadata_is_required: "Требуется защищенная метаданные приложения.",
    protected_app_not_configured: "Поставщик защищенного приложения не настроен. Эта функция недоступна для версии с открытым исходным кодом.",
    cloudflare_unknown_error: "Получена неизвестная ошибка при запросе к API Cloudflare",
    protected_application_only: "Эта функция доступна только для защищенных приложений.",
    protected_application_misconfigured: "Защищенное приложение настроено неверно.",
    protected_application_subdomain_exists: "Поддомен защищенного приложения уже используется.",
    invalid_subdomain: "Недопустимый поддомен.",
    custom_domain_not_found: "Пользовательский домен не найден.",
    should_delete_custom_domains_first: "Сначала следует удалить пользоватские домены."
};
var $d2c6943c7d236c08$export$2e2bcd8739ae039 = Object.freeze($d2c6943c7d236c08$var$application);


const $b6dd92e5722b59a9$var$auth = {
    authorization_header_missing: "Отсутствует заголовок авторизации.",
    authorization_token_type_not_supported: "Тип авторизации не поддерживается.",
    unauthorized: "Не авторизованы. Пожалуйста, проверьте учетные данные и его область действия.",
    forbidden: "Запрещено. Пожалуйста, проверьте свои роли и разрешения пользователей.",
    expected_role_not_found: "Ожидаемая роль не найдена. Пожалуйста, проверьте свои роли и разрешения пользователей.",
    jwt_sub_missing: "Отсутствует `sub` в JWT.",
    require_re_authentication: "Для выполнения защищенного действия требуется повторная аутентификация."
};
var $b6dd92e5722b59a9$export$2e2bcd8739ae039 = Object.freeze($b6dd92e5722b59a9$var$auth);


const $86057240ee88fcdd$var$connector = {
    general: "Ошибка произошла в коннекторе: {{errorDescription}}",
    not_found: "Не найден доступный коннектор для типа: {{type}}.",
    not_enabled: "Коннектор не включен.",
    invalid_metadata: "Метаданные коннектора недействительны.",
    invalid_config_guard: "Защита конфигурации коннектора недействительна.",
    unexpected_type: "Тип коннектора неожиданный.",
    invalid_request_parameters: "Запрос содержит неверный входной параметр (ы).",
    insufficient_request_parameters: "В запросе может не хватать некоторых входных параметров.",
    invalid_config: "Конфигурация коннектора недействительна.",
    invalid_certificate: "Сертификат коннектора недействителен, убедитесь, что сертификат в кодировке PEM.",
    invalid_response: "Ответ коннектора недействителен.",
    template_not_found: "Невозможно найти правильный шаблон в конфигурации коннектора.",
    template_not_supported: "Коннектор не поддерживает этот тип шаблона.",
    rate_limit_exceeded: "Превышен лимит запросов. Пожалуйста, попробуйте позже.",
    not_implemented: "{{method}}: еще не реализован.",
    social_invalid_access_token: "Токен доступа коннектора недействителен.",
    invalid_auth_code: "Код аутентификации коннектора недействителен.",
    social_invalid_id_token: "Токен идентификатора коннектора недействителен.",
    authorization_failed: "Процесс авторизации пользователя неудачный.",
    social_auth_code_invalid: "Не удалось получить токен доступа, проверьте код авторизации.",
    more_than_one_sms: "Количество SMS-коннекторов больше 1.",
    more_than_one_email: "Количество email-коннекторов больше 1.",
    more_than_one_connector_factory: "Обнаружено несколько фабрик коннекторов (с идентификаторами {{connectorIds}}), можно удалить ненужные.",
    db_connector_type_mismatch: "В базе данных есть коннектор, не соответствующий типу.",
    not_found_with_connector_id: "Не удается найти коннектор с заданным стандартным идентификатором коннектора.",
    multiple_instances_not_supported: "Нельзя создавать несколько экземпляров с выбранным стандартным коннектором.",
    invalid_type_for_syncing_profile: "Вы можете синхронизировать профиль пользователя только с социальными коннекторами.",
    can_not_modify_target: "Цель коннектора не может быть изменена.",
    should_specify_target: "Вы должны указать 'target'.",
    multiple_target_with_same_platform: "Вы не можете иметь несколько социальных коннекторов с одной и той же целью и платформой.",
    cannot_overwrite_metadata_for_non_standard_connector: "Метаданные этого коннектора не могут быть перезаписаны."
};
var $86057240ee88fcdd$export$2e2bcd8739ae039 = Object.freeze($86057240ee88fcdd$var$connector);


const $d4c115a26002d490$var$domain = {
    not_configured: "Провайдер доменных имен хоста не настроен.",
    cloudflare_data_missing: "cloudflare_data отсутствует, проверьте, пожалуйста.",
    cloudflare_unknown_error: "Получена неизвестная ошибка при запросе к API Cloudflare",
    cloudflare_response_error: "Получен неожиданный ответ от Cloudflare.",
    limit_to_one_domain: "Вы можете использовать только один пользовательский домен.",
    hostname_already_exists: "Этот домен уже существует на нашем сервере.",
    cloudflare_not_found: "Не удается найти имя хоста в Cloudflare",
    domain_is_not_allowed: "Этот домен не разрешен."
};
var $d4c115a26002d490$export$2e2bcd8739ae039 = Object.freeze($d4c115a26002d490$var$domain);


const $113903e326c31ffe$var$entity = {
    invalid_input: "Неверный ввод. Список значений не должен быть пустым.",
    create_failed: "Не удалось создать {{name}}.",
    db_constraint_violated: "Нарушено ограничение базы данных.",
    not_exists: "{{name}} не существует.",
    not_exists_with_id: "{{name}} с ID '{{id}}' не существует.",
    not_found: "Ресурс не существует.",
    relation_foreign_key_not_found: "Не удается найти один или несколько внешних ключей. Пожалуйста, проверьте ввод и убедитесь, что все ссылочные сущности существуют.",
    unique_integrity_violation: "Сущность уже существует. Пожалуйста, проверьте ввод и попробуйте снова."
};
var $113903e326c31ffe$export$2e2bcd8739ae039 = Object.freeze($113903e326c31ffe$var$entity);


const $a32dd6c20d528b2f$var$guard = {
    invalid_input: "Запрос {{type}} неверный.",
    invalid_pagination: "Значение разбиения на страницы неверно.",
    can_not_get_tenant_id: "Невозможно получить идентификатор арендатора из запроса.",
    file_size_exceeded: "Превышен размер файла.",
    mime_type_not_allowed: "MIME-тип не разрешен."
};
var $a32dd6c20d528b2f$export$2e2bcd8739ae039 = Object.freeze($a32dd6c20d528b2f$var$guard);


const $759585576ae3b84b$var$hook = {
    missing_events: "Вы должны предоставить как минимум одно событие.",
    send_test_payload_failed: "Не удалось отправить тестовую нагрузку: {{message}}",
    endpoint_responded_with_error: "Конечная точка ответила ошибкой."
};
var $759585576ae3b84b$export$2e2bcd8739ae039 = Object.freeze($759585576ae3b84b$var$hook);


const $9677ee08c7467a8f$var$jwt_customizer = {
    general: "Произошла ошибка при настройке JWT-токена. Пожалуйста, попробуйте снова позже.",
    can_not_create_for_admin_tenant: "Невозможно создать настраиваемый JWT-токен для административного арендатора."
};
var $9677ee08c7467a8f$export$2e2bcd8739ae039 = Object.freeze($9677ee08c7467a8f$var$jwt_customizer);


const $4e22d411becb822f$var$localization = {
    cannot_delete_default_language: "{{languageTag}} установлен как язык по умолчанию и не может быть удален.",
    invalid_translation_structure: "Неверная структура данных. Пожалуйста, проверьте ввод и повторите попытку."
};
var $4e22d411becb822f$export$2e2bcd8739ae039 = Object.freeze($4e22d411becb822f$var$localization);


const $501b4c98294deb02$var$log = {
    invalid_type: "Тип журнала недействительный."
};
var $501b4c98294deb02$export$2e2bcd8739ae039 = Object.freeze($501b4c98294deb02$var$log);


const $d2bea1ab7aa068f0$var$oidc = {
    aborted: "Конечный пользователь прервал взаимодействие.",
    invalid_scope: "Недопустимая область: {{error_description}}.",
    invalid_token: "Недействительный токен.",
    invalid_client_metadata: "Недопустимые метаданные клиента.",
    insufficient_scope: "Отсутствует область токена `{{scope}}`.",
    invalid_request: "Недопустимый запрос.",
    invalid_grant: "Недопустимый запрос на предоставление прав.",
    invalid_redirect_uri: "redirect_uri не соответствует ни одному зарегистрированному redirect_uris клиента.",
    access_denied: "Доступ запрещен.",
    invalid_target: "Недопустимый указатель ресурса.",
    unsupported_grant_type: "Запрошенный grant_type не поддерживается.",
    unsupported_response_mode: "Запрошенный response_mode не поддерживается.",
    unsupported_response_type: "Запрошенный response_type не поддерживается.",
    provider_error: "Внутренняя ошибка OIDC: {{message}}.",
    server_error: "Произошла неизвестная ошибка OIDC. Пожалуйста, попробуйте снова позже.",
    provider_error_fallback: "Произошла ошибка OIDC: {{code}}.",
    key_required: "Требуется как минимум один ключ.",
    key_not_found: "Ключ с идентификатором {{id}} не найден."
};
var $d2bea1ab7aa068f0$export$2e2bcd8739ae039 = Object.freeze($d2bea1ab7aa068f0$var$oidc);


const $ba017f721b95148c$var$organization = {
    require_membership: "Пользователь должен быть участником организации, чтобы продолжить."
};
var $ba017f721b95148c$export$2e2bcd8739ae039 = Object.freeze($ba017f721b95148c$var$organization);


const $e437362b588bce68$var$password = {
    unsupported_encryption_method: "Метод шифрования {{name}} не поддерживается.",
    pepper_not_found: "Не найден пепер пароля. Пожалуйста, проверьте ваши основные envs.",
    rejected: "Пароль отклонен. Пожалуйста, проверьте, соответствует ли ваш пароль требованиям."
};
var $e437362b588bce68$export$2e2bcd8739ae039 = Object.freeze($e437362b588bce68$var$password);


const $3e942de405b5624b$var$request = {
    invalid_input: "Неверный ввод. {{details}}",
    general: "Произошла ошибка запроса."
};
var $3e942de405b5624b$export$2e2bcd8739ae039 = Object.freeze($3e942de405b5624b$var$request);


const $a128ad8407c4f87c$var$resource = {
    resource_identifier_in_use: "Идентификатор API {{indicator}} уже используется",
    cannot_delete_management_api: "Не удается удалить управляемый API Logto.",
    cannot_modify_management_api: "Не удается изменить управляемый API Logto."
};
var $a128ad8407c4f87c$export$2e2bcd8739ae039 = Object.freeze($a128ad8407c4f87c$var$resource);


const $af86c6ec854772b6$var$role = {
    name_in_use: "Это имя роли {{name}} уже используется",
    scope_exists: "Идентификатор области действия {{scopeId}} уже был добавлен в эту роль",
    management_api_scopes_not_assignable_to_user_role: "Не удается назначить области управления API пользовательской роли.",
    user_exists: "Идентификатор пользователя {{userId}} уже был добавлен в эту роль",
    application_exists: "Идентификатор приложения {{applicationId}} уже был добавлен в эту роль",
    default_role_missing: "Некоторые имена ролей по умолчанию отсутствуют в базе данных, пожалуйста, убедитесь в том, что сначала создали роли",
    internal_role_violation: 'Возможно, вы пытаетесь обновить или удалить внутреннюю роль, что запрещено Logto. Если вы создаете новую роль, попробуйте другое имя, которое не начинается с "#internal:".'
};
var $af86c6ec854772b6$export$2e2bcd8739ae039 = Object.freeze($af86c6ec854772b6$var$role);


const $961cba2aabd0d255$var$scope = {
    name_exists: "Имя области {{name}} уже используется",
    name_with_space: "Имя области не может содержать пробелы."
};
var $961cba2aabd0d255$export$2e2bcd8739ae039 = Object.freeze($961cba2aabd0d255$var$scope);


const $4c70543758ab1d93$var$session = {
    not_found: "Сессия не найдена. Вернитесь и войдите в систему снова.",
    invalid_credentials: "Неправильный аккаунт или пароль. Проверьте ввод.",
    invalid_sign_in_method: "Текущий метод входа в систему недоступен.",
    invalid_connector_id: "Не удалось найти доступный коннектор с идентификатором {{connectorId}}.",
    insufficient_info: "Недостаточно информации для входа в систему.",
    connector_id_mismatch: "Идентификатор коннектора не соответствует записи сессии.",
    connector_session_not_found: "Сессия коннектора не найдена. Вернитесь и войдите в систему снова.",
    verification_session_not_found: "Верификация не прошла успешно. Перезапустите процесс верификации и попробуйте еще раз.",
    verification_expired: "Соединение истекло. Повторите верификацию, чтобы обеспечить безопасность вашей учетной записи.",
    verification_blocked_too_many_attempts: "Слишком много попыток за короткое время. Пожалуйста, попробуйте снова {{relativeTime}}.",
    unauthorized: "Сначала войдите в систему.",
    unsupported_prompt_name: "Неподдерживаемое имя подсказки.",
    forgot_password_not_enabled: "Забыли пароль не включен.",
    verification_failed: "Верификация не прошла успешно. Перезапустите процесс верификации и попробуйте еще раз.",
    connector_validation_session_not_found: "Сеанс коннектора для проверки токена не найден.",
    identifier_not_found: "Идентификатор пользователя не найден. Вернитесь и войдите в систему снова.",
    interaction_not_found: "Сессия взаимодействия не найдена. Вернитесь и начните сессию заново.",
    not_supported_for_forgot_password: "Эта операция не поддерживается для забытого пароля.",
    mfa: {
        require_mfa_verification: "Требуется проверка MFA для входа в систему.",
        mfa_sign_in_only: "Mfa доступен только для взаимодействия при входе в систему.",
        pending_info_not_found: "Информация о ожидающем MFA не найдена, пожалуйста, сначала инициируйте MFA.",
        invalid_totp_code: "Недействительный код TOTP.",
        webauthn_verification_failed: " Проверка WebAuthn не удалась.",
        webauthn_verification_not_found: "Проверка WebAuthn не найдена.",
        bind_mfa_existed: "MFA уже существует.",
        backup_code_can_not_be_alone: "Резервный код не может быть единственным MFA.",
        backup_code_required: "Требуется резервный код.",
        invalid_backup_code: "Недействительный резервный код.",
        mfa_policy_not_user_controlled: "Политика многофакторной аутентификации не контролируется пользователем."
    },
    sso_enabled: "Единый вход в систему включен для этого указанного адреса электронной почты. Войдите в систему с помощью SSO."
};
var $4c70543758ab1d93$export$2e2bcd8739ae039 = Object.freeze($4c70543758ab1d93$var$session);


const $1478f93a18453895$var$sign_in_experiences = {
    empty_content_url_of_terms_of_use: 'Пустой URL-адрес контента "Условия использования". Пожалуйста, добавьте URL-адрес контента, если "Условия использования" включены.',
    empty_social_connectors: "Пустые социальные коннекторы. Пожалуйста, добавьте включенные социальные коннекторы, когда включен метод входа в систему через социальные сети.",
    enabled_connector_not_found: "Включенный коннектор {{type}} не найден.",
    not_one_and_only_one_primary_sign_in_method: "Должен быть один и только один первичный метод входа в систему. Пожалуйста, проверьте свой ввод.",
    username_requires_password: "Необходимо включить установку пароля для идентификатора создания имени пользователя.",
    passwordless_requires_verify: "Необходимо включить проверку для идентификатора создания учетной записи по электронной почте/телефону без пароля.",
    miss_sign_up_identifier_in_sign_in: "Методы входа в систему должны содержать идентификаторы создания учетной записи.",
    password_sign_in_must_be_enabled: "Вход в систему по паролю должен быть включен, когда для создания учетной записи требуется установка пароля.",
    code_sign_in_must_be_enabled: "Вход в систему по коду проверки должен быть включен, когда для создания учетной записи не требуется установка пароля.",
    unsupported_default_language: "Этот язык - {{language}} не поддерживается в данный момент.",
    at_least_one_authentication_factor: "Вы должны выбрать как минимум один фактор аутентификации.",
    backup_code_cannot_be_enabled_alone: "Резервный код не может быть включен самостоятельно.",
    duplicated_mfa_factors: "Факторы MFA не должны повторяться."
};
var $1478f93a18453895$export$2e2bcd8739ae039 = Object.freeze($1478f93a18453895$var$sign_in_experiences);


const $3ca82ec0886b0aef$var$single_sign_on = {
    forbidden_domains: "Недопустимы публичные домены электронной почты.",
    duplicated_domains: "Есть дублирующиеся домены.",
    invalid_domain_format: "Недопустимый формат домена.",
    duplicate_connector_name: "Имя коннектора уже существует. Пожалуйста, выберите другое имя."
};
var $3ca82ec0886b0aef$export$2e2bcd8739ae039 = Object.freeze($3ca82ec0886b0aef$var$single_sign_on);


const $d70d37109c65b4ed$var$storage = {
    not_configured: "Провайдер хранилища не настроен.",
    missing_parameter: "Отсутствует параметр {{parameter}} для провайдера хранилища.",
    upload_error: "Не удалось загрузить файл в провайдер хранилища."
};
var $d70d37109c65b4ed$export$2e2bcd8739ae039 = Object.freeze($d70d37109c65b4ed$var$storage);


const $70c5ab74ac0a708e$var$subscription = {
    limit_exceeded: "Вы достигли лимита вашего плана подписки.",
    get_plan_failed: "Не удалось получить план подписки для арендатора.",
    tenant_suspended: "Арендатор приостановлен. Пожалуйста, свяжитесь с администратором."
};
var $70c5ab74ac0a708e$export$2e2bcd8739ae039 = Object.freeze($70c5ab74ac0a708e$var$subscription);


const $8d47018eb3ca4f72$var$swagger = {
    invalid_zod_type: "Неверный тип Zod. Пожалуйста, проверьте конфигурацию защиты маршрута.",
    not_supported_zod_type_for_params: "Неподдерживаемый тип Zod для параметров. Пожалуйста, проверьте конфигурацию защиты маршрута."
};
var $8d47018eb3ca4f72$export$2e2bcd8739ae039 = Object.freeze($8d47018eb3ca4f72$var$swagger);


const $9eaac2ad1be1d6e7$var$user = {
    username_already_in_use: "Это имя пользователя уже используется.",
    email_already_in_use: "Этот адрес электронной почты связан с существующей учетной записью.",
    phone_already_in_use: "Этот номер телефона связан с существующей учетной записью.",
    invalid_email: "Некорректный адрес электронной почты.",
    invalid_phone: "Некорректный номер телефона.",
    email_not_exist: "Адрес электронной почты не зарегистрирован.",
    phone_not_exist: "Номер телефона не зарегистрирован.",
    identity_not_exist: "Учетная запись социальной сети не зарегистрирована.",
    identity_already_in_use: "Учетная запись в социальной сети связана с существующей учетной записью.",
    social_account_exists_in_profile: "Вы уже связали эту учетную запись с социальной сетью.",
    cannot_delete_self: "Вы не можете удалить свою собственную учетную запись.",
    sign_up_method_not_enabled: "Этот метод регистрации не включен.",
    sign_in_method_not_enabled: "Этот метод входа не включен.",
    same_password: "Новый пароль не может совпадать со старым паролем.",
    password_required_in_profile: "Вы должны установить пароль перед входом в систему.",
    new_password_required_in_profile: "Вы должны установить новый пароль.",
    password_exists_in_profile: "Пароль уже существует в вашем профиле.",
    username_required_in_profile: "Вы должны установить имя пользователя перед входом в систему.",
    username_exists_in_profile: "Имя пользователя уже существует в вашем профиле.",
    email_required_in_profile: "Вы должны добавить адрес электронной почты перед входом в систему.",
    email_exists_in_profile: "Ваш профиль уже связан с адресом электронной почты.",
    phone_required_in_profile: "Вы должны добавить номер телефона перед входом в систему.",
    phone_exists_in_profile: "Ваш профиль уже связан с номером телефона.",
    email_or_phone_required_in_profile: "Вы должны добавить адрес электронной почты или номер телефона перед входом в систему.",
    suspended: "Эта учетная запись приостановлена.",
    user_not_exist: "Пользователя с {{ identifier }} не существует.",
    missing_profile: "Вы должны предоставить дополнительную информацию перед входом в систему.",
    role_exists: "Идентификатор роли {{roleId}} уже добавлен в этого пользователя",
    invalid_role_type: "Недопустимый тип роли, роль машины к машине нельзя назначить пользователю.",
    missing_mfa: "You need to bind additional MFA before signing-in.",
    totp_already_in_use: "TOTP is already in use.",
    backup_code_already_in_use: "Backup code is already in use.",
    password_algorithm_required: "Требуется алгоритм пароля.",
    password_and_digest: "Вы не можете установить как обычный пароль, так и дайджест пароля."
};
var $9eaac2ad1be1d6e7$export$2e2bcd8739ae039 = Object.freeze($9eaac2ad1be1d6e7$var$user);


const $72788d9fe9ab7da8$var$verification_code = {
    phone_email_empty: 'Оба поля "телефон" и "эл. почта" пустые.',
    not_found: "Код верификации не найден. Пожалуйста, сначала отправьте код верификации.",
    phone_mismatch: "Телефон не соответствует. Пожалуйста, запросите новый код верификации.",
    email_mismatch: "Эл. почта не соответствует. Пожалуйста, запросите новый код верификации.",
    code_mismatch: "Недействительный код верификации.",
    expired: "Срок действия кода верификации истек. Пожалуйста, запросите новый код верификации.",
    exceed_max_try: "Превышено ограничение на количество попыток ввода кода верификации. Пожалуйста, запросите новый код верификации."
};
var $72788d9fe9ab7da8$export$2e2bcd8739ae039 = Object.freeze($72788d9fe9ab7da8$var$verification_code);


const $4c204eec5e08003f$var$errors = {
    request: $3e942de405b5624b$export$2e2bcd8739ae039,
    auth: $b6dd92e5722b59a9$export$2e2bcd8739ae039,
    guard: $a32dd6c20d528b2f$export$2e2bcd8739ae039,
    oidc: $d2bea1ab7aa068f0$export$2e2bcd8739ae039,
    user: $9eaac2ad1be1d6e7$export$2e2bcd8739ae039,
    password: $e437362b588bce68$export$2e2bcd8739ae039,
    session: $4c70543758ab1d93$export$2e2bcd8739ae039,
    connector: $86057240ee88fcdd$export$2e2bcd8739ae039,
    verification_code: $72788d9fe9ab7da8$export$2e2bcd8739ae039,
    sign_in_experiences: $1478f93a18453895$export$2e2bcd8739ae039,
    jwt_customizer: $9677ee08c7467a8f$export$2e2bcd8739ae039,
    localization: $4e22d411becb822f$export$2e2bcd8739ae039,
    swagger: $8d47018eb3ca4f72$export$2e2bcd8739ae039,
    entity: $113903e326c31ffe$export$2e2bcd8739ae039,
    log: $501b4c98294deb02$export$2e2bcd8739ae039,
    role: $af86c6ec854772b6$export$2e2bcd8739ae039,
    scope: $961cba2aabd0d255$export$2e2bcd8739ae039,
    storage: $d70d37109c65b4ed$export$2e2bcd8739ae039,
    resource: $a128ad8407c4f87c$export$2e2bcd8739ae039,
    hook: $759585576ae3b84b$export$2e2bcd8739ae039,
    domain: $d4c115a26002d490$export$2e2bcd8739ae039,
    subscription: $70c5ab74ac0a708e$export$2e2bcd8739ae039,
    application: $d2c6943c7d236c08$export$2e2bcd8739ae039,
    organization: $ba017f721b95148c$export$2e2bcd8739ae039,
    single_sign_on: $3ca82ec0886b0aef$export$2e2bcd8739ae039
};
var $4c204eec5e08003f$export$2e2bcd8739ae039 = Object.freeze($4c204eec5e08003f$var$errors);


const $e8adcef97d98657b$var$api_resource_details = {
    page_title: "Детали ресурса API",
    back_to_api_resources: "Вернуться к Ресурсам API",
    general_tab: "Общее",
    permissions_tab: "Разрешения",
    settings: "Настройки",
    settings_description: "Ресурсы API, также известные как индикаторы ресурсов, указывают целевые службы или ресурсы, запрашиваемые обычно в виде переменной формата URI, представляющей идентификатор ресурса.",
    management_api_settings_description: "Logto Management API - это комплексный набор API, который дает администраторам возможность управлять широким спектром задач, связанных с идентификацией, обеспечивать политику безопасности и соблюдать требования и стандарты.",
    management_api_notice: "Bu API, Logto varlığını temsil eder ve değiştirilemez veya silinemez. Logto y\xf6netim API'sini \xe7ağırmak i\xe7in makineden makineye bir uygulama oluşturun. <a>Daha fazla bilgi edinin</a>",
    token_expiration_time_in_seconds: "Время истечения токена (в секундах)",
    token_expiration_time_in_seconds_placeholder: "Введите время истечения вашего токена",
    delete_description: "Это действие нельзя отменить. Оно навсегда удалит ресурс API. Пожалуйста, введите имя ресурса API <span> {{имя}} </span>, чтобы подтвердить.",
    enter_your_api_resource_name: "Введите название своего ресурса API",
    api_resource_deleted: "Ресурс API {{name}} был успешно удален",
    permission: {
        create_button: "Создать разрешение",
        create_title: "Создать разрешение",
        create_subtitle: "Определите необходимые разрешения (области) для этого API.",
        confirm_create: "Создать разрешение",
        edit_title: "Изменить разрешение API",
        edit_subtitle: "Определите необходимые разрешения (области) для API {{resourceName}}.",
        name: "Название разрешения",
        name_placeholder: "read:resource",
        forbidden_space_in_name: "Название разрешения не должно содержать пробелов.",
        description: "Описание",
        description_placeholder: "Можно читать ресурсы",
        permission_created: "Разрешение {{название}} создано успешно",
        delete_description: "Если это разрешение будет удалено, пользователь, у которого оно было, потеряет доступ, предоставленный им.",
        deleted: 'Разрешение "{{название}}" успешно удалено.'
    }
};
var $e8adcef97d98657b$export$2e2bcd8739ae039 = Object.freeze($e8adcef97d98657b$var$api_resource_details);


const $6829fa582a65ca4b$var$api_resources = {
    page_title: "Ресурсы API",
    title: "Ресурсы API",
    subtitle: "Определите API, которые могут использовать ваши авторизованные приложения",
    create: "Создать ресурс API",
    api_name: "Название API",
    api_name_placeholder: "Введите название вашего API",
    api_identifier: "Идентификатор API",
    api_identifier_placeholder: "https://your-api-identifier/",
    api_identifier_tip: "Уникальный идентификатор для ресурса API. Он должен быть абсолютным URI и не иметь фрагмента (#). Равен параметру <a>resource</a> в OAuth 2.0.",
    default_api: "API по умолчанию",
    default_api_label: "В каждом арендаторе может быть только один API по умолчанию. Когда устанавливается API по умолчанию, можно опустить параметр <a>resource</a> в запросе на аутентификацию. Последующие запросы на обмен токенами будут использовать указанное API в качестве аудитории по умолчанию, что приведет к выдаче JWT. <a>Узнать больше</a>",
    api_resource_created: "Ресурс API {{name}} был успешно создан",
    invalid_resource_indicator_format: "Формат индикатора API должен быть допустимым абсолютным URI."
};
var $6829fa582a65ca4b$export$2e2bcd8739ae039 = Object.freeze($6829fa582a65ca4b$var$api_resources);


const $3acf9b763ec0db6f$var$application_details = {
    page_title: "Детали приложения",
    back_to_applications: "Вернуться к приложениям",
    check_guide: "Проверить гид",
    settings: "Настройки",
    settings_description: "\xabПриложение\xbb — это зарегистрированное программное обеспечение или сервис, которое может получать доступ к информации пользователя либо действовать от его имени. Приложения помогают узнавать, кто запрашивает какие данные у Logto и обрабатывать вход и разрешения. Заполните необходимые поля для аутентификации.",
    integration: "Интеграция",
    integration_description: "Развертывайте защищенные рабочие процессы Logto, работающие на сети реберного узла Cloudflare, для обеспечения высочайшей производительности и нулевого времени запуска в любой точке мира.",
    service_configuration: "Конфигурация службы",
    service_configuration_description: "Завершите необходимые настройки в своем сервисе.",
    session: "Сессия",
    endpoints_and_credentials: "Конечные точки и учетные данные",
    endpoints_and_credentials_description: "Используйте следующие конечные точки и учетные данные для настройки соединения OIDC в своем приложении.",
    refresh_token_settings: "Обновить токен",
    refresh_token_settings_description: "Управляйте правилами обновления токенов для этого приложения.",
    application_roles: "Роли",
    machine_logs: "Машинные журналы",
    application_name: "Название приложения",
    application_name_placeholder: "Мое приложение",
    description: "Описание",
    description_placeholder: "Введите описание своего приложения",
    config_endpoint: "Конечная точка конфигурации OpenID Provider",
    authorization_endpoint: "Конечная точка авторизации",
    authorization_endpoint_tip: "Конечная точка для аутентификации и авторизации. Он используется для аутентификации <a>OpenID Connect</a>.",
    show_endpoint_details: "Показать подробности конечной точки",
    hide_endpoint_details: "Скрыть подробности конечной точки",
    logto_endpoint: "Конечная точка Logto",
    application_id: "ID приложения",
    application_id_tip: "Уникальный идентификатор приложения, обычно генерируемый Logto. Он также означает \xab<a>client_id</a>\xbb в OpenID Connect.",
    application_secret: "Секрет приложения",
    redirect_uri: "URI перенаправления",
    redirect_uris: "URI перенаправления",
    redirect_uri_placeholder: "https://ваш.вебсайт.com/приложение",
    redirect_uri_placeholder_native: "io.logto://callback",
    redirect_uri_tip: "URI перенаправляется после входа пользователя (успешного или нет). См. OpenID Connect <a>AuthRequest</a> для получения дополнительной информации.",
    post_sign_out_redirect_uri: "URI перенаправления после выхода из системы",
    post_sign_out_redirect_uris: "URI перенаправления после выхода из системы",
    post_sign_out_redirect_uri_placeholder: "https://ваш.вебсайт.com/домашняя страница",
    post_sign_out_redirect_uri_tip: "URI перенаправляется после выхода пользователя (необязательно). Это может не иметь практического эффекта в некоторых типах приложений.",
    cors_allowed_origins: "Разрешенные источники CORS",
    cors_allowed_origins_placeholder: "https://ваш.вебсайт.com",
    cors_allowed_origins_tip: "По умолчанию разрешены все источники URI перенаправления. Обычно для этого поля не требуется никаких действий. См. <a>Документацию MDN</a> для получения подробной информации.",
    token_endpoint: "Конечная точка токена",
    user_info_endpoint: "Конечная точка информации о пользователе",
    enable_admin_access: "Включить доступ администратора",
    enable_admin_access_label: "Включить или отключить доступ к API управления. После включения вы можете использовать токены доступа для вызова API управления от имени этого приложения.",
    always_issue_refresh_token: "Всегда выдавать Refresh Token",
    always_issue_refresh_token_label: "Включение этой настройки позволит Logto всегда выдавать Refresh Tokens, независимо от того, была ли в запросе на аутентификацию предложена команда `prompt=consent`. Однако данная практика не рекомендуется, если это необходимо, поскольку она несовместима с OpenID Connect и может вызвать проблемы.",
    refresh_token_ttl: "Time to Live (TTL) Refresh Token в днях",
    refresh_token_ttl_tip: "Продолжительность, на протяжении которой Refresh Token может использоваться для запроса новых токенов доступа, прежде чем он истечет и станет недействительным. Запросы токенов будут продлевать TTL Refresh Token до этого значения.",
    rotate_refresh_token: "Поворот Refresh Token",
    rotate_refresh_token_label: "При включении Logto будет выдавать новый Refresh Token для запросов токенов, когда пройдет 70% изначального Time to Live (TTL) или будут выполнены определенные условия. <a>Узнать больше</a>",
    delete_description: "Это действие нельзя отменить. Оно навсегда удалит приложение. Введите название приложения <span> {{name}} </span>, чтобы подтвердить.",
    enter_your_application_name: "Введите название своего приложения",
    application_deleted: "Приложение {{name}} успешно удалено",
    redirect_uri_required: "Вы должны ввести по крайней мере один URI перенаправления",
    app_domain_description_1: "Не стесняйтесь использовать ваш домен с {{domain}}, под управлением Logto, который имеет постоянную действительность.",
    app_domain_description_2: "Смело используйте ваш домен <domain>{{domain}}</domain>, который имеет постоянную действительность.",
    custom_rules: "Пользовательские правила аутентификации",
    custom_rules_placeholder: "^/(admin|privacy)/.+$",
    custom_rules_description: "Установите правила с использованием регулярных выражений для требуемых маршрутов, требующих аутентификации. По умолчанию: защита всего сайта, если оставить пустым.",
    authentication_routes: "Маршруты аутентификации",
    custom_rules_tip: "Вот два варианта сценариев:<ol><li>Для защиты только маршрутов '/admin' и '/privacy' аутентификацией: ^/(admin|privacy)/.*</li><li>Для исключения из аутентификации изображений JPG: ^(?!.*\\.jpg$).*$</li></ol>",
    authentication_routes_description: "Перенаправьте вашу кнопку аутентификации, используя указанные маршруты. Примечание: Эти маршруты незаменяемы.",
    protect_origin_server: "Защита вашего исходного сервера",
    protect_origin_server_description: "Обеспечьте защиту вашего исходного сервера от прямого доступа. Обратитесь к руководству для получения более <a>подробных инструкций</a>.",
    session_duration: "Продолжительность сеанса (дни)",
    try_it: "Попробуйте",
    branding: {
        name: "Брендинг",
        description: "Настройте отображаемое имя и логотип вашего приложения на экране согласия.",
        more_info: "Дополнительная информация",
        more_info_description: "Предлагайте пользователям больше информации о вашем приложении на экране согласия.",
        display_name: "Отображаемое имя",
        display_logo: "Отображаемый логотип",
        display_logo_dark: "Отображаемый логотип (темный)",
        terms_of_use_url: "URL условий использования приложения",
        privacy_policy_url: "URL политики конфиденциальности приложения"
    },
    permissions: {
        name: "Разрешения",
        description: "Выберите разрешения, которые требуются стороннему приложению для получения авторизации пользователя на доступ к определенным типам данных.",
        user_permissions: "Персональные данные пользователя",
        organization_permissions: "Доступ организации",
        table_name: "Предоставление разрешений",
        field_name: "Разрешение",
        field_description: "Отображается на экране согласия",
        delete_text: "Удалить разрешение",
        permission_delete_confirm: "Это действие отозвет предоставленные разрешения стороннему приложению, препятствуя запросу пользователя на авторизацию к определенным типам данных. Вы уверены, что хотите продолжить?",
        permissions_assignment_description: "Выберите разрешения, которые стороннее приложение запрашивает для авторизации пользователя к определенным типам данных.",
        user_profile: "Данные пользователя",
        api_permissions: "API-разрешения",
        organization: "Разрешения организации",
        user_permissions_assignment_form_title: "Добавить разрешения на профиль пользователя",
        organization_permissions_assignment_form_title: "Добавить разрешения на организацию",
        api_resource_permissions_assignment_form_title: "Добавить разрешения на ресурс API",
        user_data_permission_description_tips: 'Вы можете изменить описание персональных данных пользователя через "Опыт входа -> Содержание -> Управление языком".',
        permission_description_tips: "Когда Logto используется в качестве поставщика идентификации (IdP) для аутентификации в сторонних приложениях, и пользователи запрашивают авторизацию, данное описание отображается на экране согласия.",
        user_title: "Пользователь",
        user_description: "Выберите разрешения, запрошенные сторонним приложением для доступа к определенным данным пользователя.",
        grant_user_level_permissions: "Предоставить разрешения на данные пользователя",
        organization_title: "Организация",
        organization_description: "Выберите разрешения, которые запрашиваются сторонним приложением для доступа к определенным данным организации.",
        grant_organization_level_permissions: "Предоставить разрешения на данные организации"
    },
    roles: {
        name_column: "Роль",
        description_column: "Описание",
        assign_button: "Назначить роли",
        delete_description: "Это действие удалит эту роль из этого приложения. Сама роль останется, но больше не будет связана с этим приложением.",
        deleted: "{{name}} успешно удалено у этого пользователя.",
        assign_title: "Назначить роли для {{name}}",
        assign_subtitle: "Авторизовать {{name}} одну или несколько ролей",
        assign_role_field: "Назначить роли",
        role_search_placeholder: "Поиск по названию роли",
        added_text: "{{value, number}} добавлено",
        assigned_app_count: "{{value, number}} приложений",
        confirm_assign: "Назначить роли",
        role_assigned: "Роль(и) успешно назначены",
        search: "Поиск по названию роли, описанию или ID",
        empty: "Нет доступных ролей"
    }
};
var $3acf9b763ec0db6f$export$2e2bcd8739ae039 = Object.freeze($3acf9b763ec0db6f$var$application_details);


const $b34dd16aff95b3fe$var$applications = {
    page_title: "Заявки",
    title: "Заявки",
    subtitle: "Настроить аутентификацию Logto для вашего нативного, одностраничного, машина-машина или традиционного приложения.",
    subtitle_with_app_type: "Настроить аутентификацию Logto для вашего приложения {{name}}",
    create: "Создать заявку",
    create_subtitle_third_party: "Используйте Logto в качестве поставщика идентификации (IdP) для простой интеграции с приложениями сторонних разработчиков",
    application_name: "Название приложения",
    application_name_placeholder: "Мое приложение",
    application_description: "Описание приложения",
    application_description_placeholder: "Введите описание вашего приложения",
    select_application_type: "Выбрать тип приложения",
    no_application_type_selected: "Вы еще не выбрали тип приложения",
    application_created: "Приложение успешно создано.",
    tab: {
        my_applications: "Мои приложения",
        third_party_applications: "Приложения сторонних разработчиков"
    },
    app_id: "Идентификатор приложения",
    type: {
        native: {
            title: "Нативное приложение",
            subtitle: "Приложение, работающее в нативной среде",
            description: "Например, приложение для iOS, приложение для Android"
        },
        spa: {
            title: "Одностраничное приложение",
            subtitle: "Приложение, работающее в веб-браузере и динамически обновляющее данные на месте",
            description: "Например, приложение React DOM, приложение Vue"
        },
        traditional: {
            title: "Традиционное веб-приложение",
            subtitle: "Приложение, которое отображает и обновляет страницы только через веб-сервер",
            description: "Например, Next.js, PHP"
        },
        machine_to_machine: {
            title: "Машина-машина",
            subtitle: "Приложение (обычно сервис), которое напрямую общается с ресурсами",
            description: "Например, бэкэнд-сервис"
        },
        protected: {
            title: "Защищенное приложение",
            subtitle: "Приложение, защищенное Logto",
            description: "N/А"
        },
        third_party: {
            title: "Приложение сторонних разработчиков",
            subtitle: "Приложение, используемое в качестве коннектора стороннего поставщика идентификации",
            description: "Например, OIDC, SAML"
        }
    },
    placeholder_title: "Выберите тип приложения, чтобы продолжить",
    placeholder_description: "Logto использует сущность приложения для OIDC для выполнения задач, таких как идентификация ваших приложений, управление входом в систему и создание журналов аудита.",
    m2m_role_assignment: {
        title: "Авторизовать приложение с ролью от машины к машине для разрешений",
        subtitle: "Приложения от машины к машине требуют авторизованной роли от машины к машине.",
        role_creation_hint: "Не можете найти подходящую роль машина-машина? <a>Создайте роль машина-машина</a>"
    }
};
var $b34dd16aff95b3fe$export$2e2bcd8739ae039 = Object.freeze($b34dd16aff95b3fe$var$applications);


const $dcdaab7b21e44e47$var$cloud = {
    general: {
        onboarding: "Вводный курс"
    },
    welcome: {
        page_title: "Добро пожаловать",
        title: "Добро пожаловать в облако Logto! Мы хотели бы узнать вас получше.",
        description: "Сделайте свой опыт работы с Logto уникальным для вас, узнав вас получше. Ваша информация надежно защищена.",
        project_field: "Я использую Logto для",
        project_options: {
            personal: "Личного проекта",
            company: "Компании"
        },
        company_name_field: "Название компании",
        company_name_placeholder: "Acme.co",
        stage_field: "На каком этапе находится ваш продукт сейчас?",
        stage_options: {
            new_product: "Начать новый проект и ищете быстрое, заранее созданное решение",
            existing_product: "Миграция с текущей аутентификации (например, собственная разработка, Auth0, Cognito, Microsoft)",
            target_enterprise_ready: "Я только что получил больших клиентов и теперь готовлю свой продукт к продаже предприятиям"
        },
        additional_features_field: "Хотели бы вы сообщить нам что-то еще?",
        additional_features_options: {
            customize_ui_and_flow: "Построить и управлять своим собственным пользовательским интерфейсом, а не просто использовать заранее созданное и настраиваемое решение Logto",
            compliance: "SOC2 и GDPR - обязательные требования",
            export_user_data: "Необходима возможность экспортировать данные пользователей из Logto",
            budget_control: "У меня очень тщательный контроль над бюджетом",
            bring_own_auth: "Имею собственные службы аутентификации и просто нужны некоторые возможности Logto",
            others: "Ничего из вышеперечисленного"
        }
    },
    sie: {
        page_title: "Настройка опыта входа",
        title: "Давайте сначала легко настроим ваш опыт входа",
        inspire: {
            title: "Создайте убедительные примеры",
            description: "Чувствуете неуверенность в опыте входа? Просто нажмите \xabВдохновить меня\xbb и позвольте волшебству совершиться!",
            inspire_me: "Вдохнови меня"
        },
        logo_field: "Логотип приложения",
        color_field: "Цвет бренда",
        identifier_field: "Идентификатор",
        identifier_options: {
            email: "Электронная почта",
            phone: "Номер телефона",
            user_name: "Имя пользователя"
        },
        authn_field: "Аутентификация",
        authn_options: {
            password: "Пароль",
            verification_code: "Код подтверждения"
        },
        social_field: "Вход через социальную сеть",
        finish_and_done: "Готово",
        preview: {
            mobile_tab: "Мобильный",
            web_tab: "Веб"
        },
        connectors: {
            unlocked_later: "Разблокируется позже",
            unlocked_later_tip: "После того, как завершите процесс настройки и войдете в продукт, у вас появится доступ к большему количеству методов входа через социальные сети.",
            notice: "Пожалуйста, не используйте демонстрационный коннектор для производственных целей. После тестирования удалите демонстрационный коннектор и настройте собственный коннектор со своими учетными данными."
        }
    },
    socialCallback: {
        title: "Вход выполнен успешно",
        description: "Вы успешно вошли, используя свою учетную запись в социальной сети. Чтобы обеспечить безпроблемную интеграцию и доступ ко всем функциям Logto, рекомендуем настроить свой собственный социальный коннектор."
    },
    tenant: {
        create_tenant: "Создать арендатора"
    }
};
var $dcdaab7b21e44e47$export$2e2bcd8739ae039 = Object.freeze($dcdaab7b21e44e47$var$cloud);


const $caa796cb4f52c8f6$var$components = {
    uploader: {
        action_description: "Перетащите или выберите файл",
        uploading: "Загрузка...",
        image_limit: "Загрузите изображение размером менее {{size, number}} КБ, только {{extensions, list(style: narrow; type: conjunction;)}}.",
        error_upload: "Что-то пошло не так. Загрузка файла не удалась.",
        error_file_size: "Размер файла слишком большой. Пожалуйста, загрузите файл размером менее {{size, number}} КБ.",
        error_file_type: "Тип файла не поддерживается. Допустимы только файлы типа {{extensions, list(style: narrow; type: conjunction;)}}.",
        error_file_count: "Вы можете загрузить только 1 файл."
    }
};
var $caa796cb4f52c8f6$export$2e2bcd8739ae039 = Object.freeze($caa796cb4f52c8f6$var$components);


const $243d7fd77ce6d7dd$var$connector_details = {
    page_title: "Детали подключения",
    back_to_connectors: "Вернуться к подключениям",
    check_readme: "Проверить README",
    settings: "Общие настройки",
    settings_description: "Коннекторы играют критическую роль в Logto. С их помощью, Logto позволяет конечным пользователям использовать беспарольную регистрацию или вход и возможности входа с социальными аккаунтами.",
    parameter_configuration: "Конфигурация параметра",
    test_connection: "Тестирование",
    save_error_empty_config: "Пожалуйста, введите конфигурацию",
    send: "Отправить",
    send_error_invalid_format: "Неверный ввод",
    edit_config_label: "Введите ваш JSON здесь",
    test_email_sender: "Протестируйте ваш электронный коннектор",
    test_sms_sender: "Протестируйте ваш SMS коннектор",
    test_email_placeholder: "john.doe@example.com",
    test_sms_placeholder: "+1 555-123-4567",
    test_message_sent: "Тестовое сообщение отправлено",
    test_sender_description: 'Logto использует шаблон "Общий" для тестирования. Вы получите сообщение, если ваш коннектор правильно настроен.',
    options_change_email: "Изменить электронный коннектор",
    options_change_sms: "Изменить SMS коннектор",
    connector_deleted: "Коннектор успешно удален",
    type_email: "Электронный коннектор",
    type_sms: "SMS коннектор",
    type_social: "Социальный коннектор",
    in_used_social_deletion_description: "Этот коннектор используется в вашем опыте входа в систему. При удалении опыт входа в систему <name/> будет удален в настройках опыта входа в систему. Вы должны повторно настроить его, если решите добавить его обратно.",
    in_used_passwordless_deletion_description: "Этот {{name}} используется в вашем опыте входа в систему. При удалении опыт входа в систему не будет работать правильно, пока не будет решен конфликт. Вы должны повторно настроить его, если решите добавить его обратно.",
    deletion_description: "Вы удаляете этот коннектор. Он не может быть отменен, и вы должны повторно настроить его, если решите добавить его обратно.",
    logto_email: {
        total_email_sent: "Всего отправлено электронных писем: {{value, number}}",
        total_email_sent_tip: "Logto использует SendGrid для безопасной и стабильной встроенной электронной почты. Полностью бесплатно. <a>Узнать больше</a>",
        email_template_title: "Шаблон электронной почты",
        template_description: "Встроенная электронная почта использует шаблоны по умолчанию для безшовной доставки писем с подтверждением. Никакой дополнительной настройки не требуется, и вы можете настроить базовую информацию о бренде.",
        template_description_link_text: "Просмотреть шаблоны",
        description_action_text: "Просмотреть шаблоны",
        from_email_field: "Отправитель",
        sender_name_field: "Имя отправителя",
        sender_name_tip: 'Настройте имя отправителя для электронных писем. Если оставить пустым, будет использоваться "Verification" в качестве имени по умолчанию.',
        sender_name_placeholder: "Введите имя отправителя здесь",
        company_information_field: "Информация о компании",
        company_information_description: "Отображайте имя вашей компании, адрес или почтовый код внизу электронных писем, чтобы улучшить подлинность.",
        company_information_placeholder: "Основная информация о вашей компании",
        app_logo_field: "Логотип приложения",
        app_logo_tip: "Отобразите логотип вашего бренда в верхней части электронных писем. Используйте одно и то же изображение для светлого и темного режимов.",
        urls_not_allowed: "URL-адреса не разрешены",
        test_notes: 'Logto использует шаблон "Общий" для тестирования.'
    }
};
var $243d7fd77ce6d7dd$export$2e2bcd8739ae039 = Object.freeze($243d7fd77ce6d7dd$var$connector_details);


const $12c9b5f9022280ad$var$connectors = {
    page_title: "Коннекторы",
    title: "Коннекторы",
    subtitle: "Настройте коннекторы, чтобы включить опыт без пароля и социального входа в систему",
    create: "Добавить социальный коннектор",
    config_sie_notice: "Вы настроили коннекторы. Убедитесь, что вы настроили их в <a>{{link}}</a>.",
    config_sie_link_text: "опыте входа в систему",
    tab_email_sms: "Коннекторы электронной почты и SMS",
    tab_social: "Социальные коннекторы",
    connector_name: "Имя коннектора",
    demo_tip: "Максимальное количество сообщений для этого демонстрационного коннектора ограничено 100 и не рекомендуется для развертывания в производственной среде.",
    social_demo_tip: "Демонстрационный коннектор предназначен исключительно для демонстрационных целей и не рекомендуется для развертывания в производственной среде.",
    connector_type: "Тип",
    connector_status: "Опыт входа в систему",
    connector_status_in_use: "Используется",
    connector_status_not_in_use: "Не используется",
    not_in_use_tip: {
        content: "Не используется означает, что ваш опыт входа в систему не использовал этот метод входа. <a>{{link}}</a>, чтобы добавить этот метод входа.",
        go_to_sie: "Перейти к опыту входа в систему"
    },
    placeholder_title: "Социальный коннектор",
    placeholder_description: "Logto предоставляет множество широко используемых коннекторов для входа через социальные сети, в то время как вы можете создать свой с помощью стандартных протоколов.",
    save_and_done: "Сохранить и завершить",
    type: {
        email: "Коннектор электронной почты",
        sms: "Коннектор SMS",
        social: "Социальный коннектор"
    },
    setup_title: {
        email: "Настройка коннектора электронной почты",
        sms: "Настройка коннектора SMS",
        social: "Добавить социальный коннектор"
    },
    guide: {
        subtitle: "Пошаговое руководство по настройке вашего коннектора",
        general_setting: "Общие настройки",
        parameter_configuration: "Конфигурация параметров",
        test_connection: "Тестовое соединение",
        name: "Имя для кнопки входа через социальные сети",
        name_placeholder: "Введите имя для кнопки входа через социальные сети",
        name_tip: 'Имя кнопки коннектора будет отображаться как "Продолжить с {{name}}". Будьте внимательны к длине названия, в случае, если оно станет слишком длинным.',
        logo: "URL логотипа для кнопки входа через социальные сети",
        logo_placeholder: "https://your.cdn.domain/logo.png",
        logo_tip: "Логотип будет отображаться на коннекторе. Получите публично доступную ссылку на изображение и вставьте ссылку сюда.",
        logo_dark: "URL логотипа для кнопки входа через социальные сети (Темный режим)",
        logo_dark_placeholder: "https://your.cdn.domain/logo.png",
        logo_dark_tip: "Установите логотип коннектора для темного режима после его включения в опыте входа в систему в Административной консоли.",
        logo_dark_collapse: "Свернуть",
        logo_dark_show: "Показать настройки логотипа для темного режима",
        target: "Имя поставщика идентификации",
        target_placeholder: "Введите имя поставщика идентификации коннектора",
        target_tip: "Значение \xabНазвание поставщика идентификации\xbb может быть строкой уникального идентификатора, чтобы отличать ваших социальных пользователей.",
        target_tip_standard: "Значение \xabНазвание поставщика идентификации\xbb может быть строкой уникального идентификатора, чтобы отличать ваших социальных пользователей. Эта настройка не может быть изменена после создания коннектора.",
        target_tooltip: '"Название поставщика идентификации" в социальных коннекторах Logto относится к "источнику" ваших социальных пользователей. В дизайне Logto мы не принимаем то же самое "название поставщика идентификации" для определенной платформы, чтобы избежать конфликтов. Вы должны быть очень внимательны, прежде чем добавлять коннектор, так как вы НЕ МОЖЕТЕ изменить его значение после создания. <a>Узнать больше</a>',
        target_conflict: "Введенное имя поставщика идентификации совпадает с существующим коннектором <span>name</span>. Использование того же имени поставщика идентификации может вызвать неожиданное поведение входа в систему, когда пользователи могут получить доступ к одной учетной записи через два разных коннектора.",
        target_conflict_line2: "Если вы хотите заменить текущий коннектор на тот же поставщик идентификации и разрешить предыдущим пользователям войти без регистрации заново, удалите коннектор <span>name</span> и создайте новый с тем же \xabНазванием поставщика идентификации\xbb.",
        target_conflict_line3: "Если вы хотите подключиться к другому поставщику идентификации, измените \xabНазвание поставщика идентификации\xbb и продолжайте.",
        config: "Введите свой JSON-конфиг",
        sync_profile: "Синхронизировать информацию профиля",
        sync_profile_only_at_sign_up: "Синхронизировать только при регистрации",
        sync_profile_each_sign_in: "Всегда синхронизировать при каждом входе",
        sync_profile_tip: "Синхронизируйте базовый профиль из социального провайдера, такой как имена пользователей и их аватары.",
        callback_uri: "URI обратного вызова",
        callback_uri_description: "Также называется URI перенаправления, это URI в Logto, на который пользователи будут отправлены после социальной авторизации. Скопируйте и вставьте его на странице настройки социального провайдера.",
        acs_url: "URL сервиса подтверждения утверждений"
    },
    platform: {
        universal: "Универсальная",
        web: "Web",
        native: "Мобильное приложение"
    },
    add_multi_platform: "поддерживает несколько платформ, выберите платформу для продолжения",
    drawer_title: "Руководство Коннектора",
    drawer_subtitle: "Следуйте инструкциям, чтобы интегрировать свой коннектор",
    unknown: "Неизвестный коннектор",
    standard_connectors: "стандартные разъемы"
};
var $12c9b5f9022280ad$export$2e2bcd8739ae039 = Object.freeze($12c9b5f9022280ad$var$connectors);


const $7c110e837f47fc58$var$contact = {
    title: "Получить помощь",
    description: "Для запросов на помощь и отзывов о продукте, свяжитесь с нами через следующие методы.",
    discord: {
        title: "Присоединиться к сообществу Discord",
        description: "Свяжитесь с другими разработчиками, чтобы найти решения",
        button: "Присоединиться"
    },
    github: {
        title: "Общение на GitHub",
        description: "Создайте проблему и отправьте на GitHub",
        button: "Открыть"
    },
    email: {
        title: "Связаться с поддержкой по электронной почте",
        description: "Отправьте нам электронное письмо для получения дополнительной информации и помощи",
        button: "Отправить"
    },
    reserve: {
        title: "Запишитесь на встречу с командой Logto",
        description: "Быстро запишитесь на сессию для онлайн-чата",
        button: "Записаться"
    }
};
var $7c110e837f47fc58$export$2e2bcd8739ae039 = Object.freeze($7c110e837f47fc58$var$contact);


const $65870f9375ef7fc3$var$dashboard = {
    page_title: "Dashboard",
    title: "Dashboard",
    description: "Получите обзор о производительности вашего приложения",
    total_users: "Всего пользователей",
    total_users_tip: "Всего пользователей",
    new_users_today: "Новые пользователи сегодня",
    new_users_today_tip: "Количество новых пользователей, зарегистрировавшихся сегодня в вашем приложении",
    new_users_7_days: "Новые пользователи за последние 7 дней",
    new_users_7_days_tip: "Количество новых пользователей, зарегистрировавшихся за последние 7 дней в вашем приложении",
    daily_active_users: "Ежедневные активные пользователи",
    daily_active_users_tip: "Количество уникальных пользователей, обменивающих токены в вашем приложении сегодня",
    weekly_active_users: "Еженедельные активные пользователи",
    weekly_active_users_tip: "Количество уникальных пользователей, обменивающих токены в вашем приложении за последние 7 дней",
    monthly_active_users: "Ежемесячные активные пользователи",
    monthly_active_users_tip: "Количество уникальных пользователей, обменивающих токены в вашем приложении за последние 30 дней"
};
var $65870f9375ef7fc3$export$2e2bcd8739ae039 = Object.freeze($65870f9375ef7fc3$var$dashboard);


const $cddf12b8cd6380ff$var$domain = {
    status: {
        connecting: "Соединение...",
        in_use: "Используется",
        failed_to_connect: "Не удалось соединиться"
    },
    update_endpoint_notice: "Не забудьте обновить домен для обратного вызова социального коннектора и конечной точки Logto в вашем приложении, если вы хотите использовать пользовательский домен для функций. <a>{{link}}</a>",
    error_hint: "Убедитесь, что вы обновили свои DNS записи. Мы будем проверять каждые {{value}} секунд.",
    custom: {
        custom_domain: "Пользовательский домен",
        custom_domain_description: "Улучшите свой брендинг, используя пользовательский домен. Этот домен будет использоваться в вашем процессе входа.",
        custom_domain_field: "Пользовательский домен",
        custom_domain_placeholder: "Ваш.домен.com",
        add_domain: "Добавить домен",
        invalid_domain_format: 'Please provide a valid domain URL with a minimum of three parts, e.g. "your.domain.com."',
        verify_domain: "Проверить домен",
        enable_ssl: "Включить SSL",
        checking_dns_tip: "После настройки DNS, процесс запустится автоматически и может занять до 24-х часов. Вы можете выйти из этого интерфейса во время его работы.",
        enable_ssl_tip: "Включение SSL запустится автоматически и может занять до 24-х часов. Вы можете выйти из этого интерфейса во время его работы.",
        generating_dns_records: "Генерация DNS записей...",
        add_dns_records: "Пожалуйста, добавьте следующие DNS-записи в Ваш DNS-провайдер.",
        dns_table: {
            type_field: "Тип",
            name_field: "Имя",
            value_field: "Значение"
        },
        deletion: {
            delete_domain: "Удалить домен",
            reminder: "Удалить пользовательский домен",
            description: "Вы уверены, что хотите удалить этот пользовательский домен?",
            in_used_description: 'Вы уверены, что хотите удалить этот пользовательский домен "<span>{{domain}}</span>"?',
            in_used_tip: 'Если ранее вы настраивали этот пользовательский домен в своём провайдере социальных коннекторов или конечной точке приложения, вам нужно сначала изменить URI на домен по умолчанию Logto "<span>{{domain}}</span>". Это необходимо для правильной работы кнопки социальной авторизации.',
            deleted: "Пользовательский домен успешно удалён!"
        }
    },
    default: {
        default_domain: "Домен по умолчанию",
        default_domain_description: "Logto предлагает предварительно настроенный домен по умолчанию, готовый к использованию без дополнительной настройки. Этот домен по умолчанию служит как резервный вариант, даже если вы включили пользовательский домен.",
        default_domain_field: "Домен по умолчанию Logto"
    },
    custom_endpoint_note: 'Вы можете настроить имя домена этих конечных точек по своему усмотрению. Выберите "{{custom}}" или "{{default}}".',
    custom_social_callback_url_note: 'Вы можете настроить имя домена этого URI, чтобы соответствовать конечной точке вашего приложения. Выберите "{{custom}}" или "{{default}}".',
    custom_acs_url_note: 'You can customize the domain name of this URI to match your identity provider assertion consumer service URL. Choose either "{{custom}}" or "{{default}}".'
};
var $cddf12b8cd6380ff$export$2e2bcd8739ae039 = Object.freeze($cddf12b8cd6380ff$var$domain);


const $abff6803bb322157$var$enterprise_sso_details = {
    back_to_sso_connectors: "Вернуться к единой системе аутентификации предприятия",
    page_title: "Подробности коннектора единой системы аутентификации предприятия",
    readme_drawer_title: "Единая система аутентификации предприятия",
    readme_drawer_subtitle: "Настройте коннекторы единой системы аутентификации предприятия для включения единого входа пользователей",
    tab_experience: "Опыт единого входа",
    tab_connection: "Подключение",
    general_settings_title: "Общие настройки",
    custom_branding_title: "Отображение",
    custom_branding_description: "Настройте имя и логотип, отображаемые в потоке единого входа для конечных пользователей. При пустом значении используются значения по умолчанию.",
    email_domain_field_name: "Домен электронной почты предприятия",
    email_domain_field_description: "Пользователи с этим доменом электронной почты могут использовать единую систему аутентификации для аутентификации. Пожалуйста, убедитесь, что домен принадлежит предприятию.",
    email_domain_field_placeholder: "Домен электронной почты",
    sync_profile_field_name: "Синхронизация профиля информации из поставщика идентичности",
    sync_profile_option: {
        register_only: "Синхронизировать только при первом входе",
        each_sign_in: "Всегда синхронизировать при каждом входе"
    },
    connector_name_field_name: "Имя коннектора",
    display_name_field_name: "Отображаемое имя",
    connector_logo_field_name: "Отображаемый логотип",
    connector_logo_field_description: "Каждое изображение должно быть не более 500KB в форматах SVG, PNG, JPG, JPEG.",
    branding_logo_context: "Загрузить логотип",
    branding_logo_error: "Ошибка загрузки логотипа: {{error}}",
    branding_light_logo_context: "Загрузить логотип в светлом режиме",
    branding_light_logo_error: "Ошибка загрузки логотипа в светлом режиме: {{error}}",
    branding_logo_field_name: "Логотип",
    branding_logo_field_placeholder: "https://ваш.домен/логотип.png",
    branding_dark_logo_context: "Загрузить логотип в темном режиме",
    branding_dark_logo_error: "Ошибка загрузки логотипа в темном режиме: {{error}}",
    branding_dark_logo_field_name: "Логотип (темный режим)",
    branding_dark_logo_field_placeholder: "https://ваш.домен/логотип-темного-режима.png",
    check_connection_guide: "Руководство по подключению",
    enterprise_sso_deleted: "Коннектор единой системы аутентификации предприятия успешно удален",
    delete_confirm_modal_title: "Удалить коннектор единой системы аутентификации предприятия",
    delete_confirm_modal_content: "Вы уверены, что хотите удалить этот коннектор предприятия? Пользователи от поставщиков идентичности не будут использовать единую систему аутентификации.",
    upload_idp_metadata_title_saml: "Загрузить метаданные",
    upload_idp_metadata_description_saml: "Настройте метаданные, скопированные из поставщика идентичности.",
    upload_idp_metadata_title_oidc: "Загрузить учетные данные",
    upload_idp_metadata_description_oidc: "Настройте учетные данные и информацию об OIDC-токене, скопированные из поставщика идентичности.",
    upload_idp_metadata_button_text: "Загрузить файл метаданных XML",
    upload_signing_certificate_button_text: "Загрузить файл сертификата подписи",
    configure_domain_field_info_text: "Добавьте домен электронной почты, чтобы направить предприятийзапросы к поставщику идентичности для единого входа.",
    email_domain_field_required: "Требуется домен электронной почты для включения единой системы аутентификации предприятия.",
    upload_saml_idp_metadata_info_text_url: "Вставьте URL метаданных от поставщика идентичности для подключения.",
    upload_saml_idp_metadata_info_text_xml: "Вставьте метаданные от поставщика идентичности для подключения.",
    upload_saml_idp_metadata_info_text_manual: "Заполните метаданные от поставщика идентичности для подключения.",
    upload_oidc_idp_info_text: "Заполните информацию от поставщика идентичности для подключения.",
    service_provider_property_title: "Настройка в поставщике идентичности",
    service_provider_property_description: "Настройте интеграцию приложения, используя {{protocol}} в вашем поставщике идентичности. Введите детали, предоставленные Logto.",
    attribute_mapping_title: "Отображение атрибутов",
    attribute_mapping_description: "Синхронизация профилей пользователей из поставщика идентичности путем настройки отображения атрибутов пользователя либо на стороне поставщика идентичности, либо на стороне Logto.",
    saml_preview: {
        sign_on_url: "URL входа",
        entity_id: "Издатель",
        x509_certificate: "Сертификат подписи",
        certificate_content: "Истекает {{date}}"
    },
    oidc_preview: {
        authorization_endpoint: "Конечная точка авторизации",
        token_endpoint: "Конечная точка токена",
        userinfo_endpoint: "Конечная точка информации о пользователе",
        jwks_uri: "Конечная точка набора ключей JSON Web",
        issuer: "Издатель"
    }
};
var $abff6803bb322157$export$2e2bcd8739ae039 = Object.freeze($abff6803bb322157$var$enterprise_sso_details);


const $fa612d11d99097f6$var$enterprise_sso = {
    page_title: "Единый вход в предприятие",
    title: "Единый вход в предприятие",
    subtitle: "Подключите поставщика идентификации предприятия и включите одностороннюю аутентификацию с инициацией службы.",
    create: "Добавить предприятий коннектор",
    col_connector_name: "Имя коннектора",
    col_type: "Тип",
    col_email_domain: "Домен электронной почты",
    placeholder_title: "Коннектор предприятия",
    placeholder_description: "Logto предоставляет множество встроенных поставщиков идентичности предприятия для подключения, в то же время вы можете создать собственного поставщика с использованием протоколов SAML и OIDC.",
    create_modal: {
        title: "Добавить коннектор предприятия",
        text_divider: "Или вы можете настроить свой коннектор по стандартному протоколу.",
        connector_name_field_title: "Имя коннектора",
        connector_name_field_placeholder: "Например, {corp. name} - {identity provider name}",
        create_button_text: "Создать коннектор"
    },
    guide: {
        subtitle: "Пошаговое руководство по подключению поставщика идентичности предприятия.",
        finish_button_text: "Продолжить"
    },
    basic_info: {
        title: "Настройка вашего сервиса в IdP",
        description: "Создайте новую интеграцию приложения с помощью SAML 2.0 в вашем провайдере идентичности {{name}}. Затем вставьте следующее значение в него.",
        saml: {
            acs_url_field_name: "URL потребителя утверждений (URL ответа)",
            audience_uri_field_name: "Адрес аудиенции (SP Entity ID)"
        },
        oidc: {
            redirect_uri_field_name: "URI перенаправления (URL обратного вызова)"
        }
    },
    attribute_mapping: {
        title: "Сопоставление атрибутов",
        description: "`id` и `email` обязательны для синхронизации профиля пользователя из IdP. Введите следующее имя и значение утверждения в своем IdP.",
        col_sp_claims: "Значение поставщика услуг (Logto)",
        col_idp_claims: "Имя утверждения поставщика идентичности",
        idp_claim_tooltip: "Имя утверждения поставщика идентичности"
    },
    metadata: {
        title: "Настройка метаданных IdP",
        description: "Настройте метаданные от провайдера идентичности",
        dropdown_trigger_text: "Использовать другой метод конфигурации",
        dropdown_title: "выберите метод конфигурации",
        metadata_format_url: "Введите URL метаданных",
        metadata_format_xml: "Загрузить файл метаданных XML",
        metadata_format_manual: "Ввести детали метаданных вручную",
        saml: {
            metadata_url_field_name: "URL метаданных",
            metadata_url_description: "Динамически извлекать данные из URL метаданных и поддерживать сертификат в актуальном состоянии.",
            metadata_xml_field_name: "Файл метаданных IdP",
            metadata_xml_uploader_text: "Загрузить файл метаданных XML",
            sign_in_endpoint_field_name: "URL входа",
            idp_entity_id_field_name: "IdP идентификатор сущности (Издатель)",
            certificate_field_name: "Сертификат подписи",
            certificate_placeholder: "Скопируйте и вставьте сертификат x509",
            certificate_required: "Сертификат подписи обязателен."
        },
        oidc: {
            client_id_field_name: "Идентификатор клиента",
            client_secret_field_name: "Секрет клиента",
            issuer_field_name: "Издатель",
            scope_field_name: "Область"
        }
    }
};
var $fa612d11d99097f6$export$2e2bcd8739ae039 = Object.freeze($fa612d11d99097f6$var$enterprise_sso);


const $f393b85b66f67402$var$errors = {
    something_went_wrong: "Упс! Что-то пошло не так.",
    page_not_found: "Страница не найдена",
    unknown_server_error: "Произошла неизвестная ошибка сервера",
    empty: "Нет данных",
    missing_total_number: "Не удалось найти Total-Number в заголовках ответа",
    invalid_uri_format: "Неверный формат URI",
    invalid_origin_format: "Неверный формат URI-оригинала",
    invalid_json_format: "Неверный формат JSON",
    invalid_regex: "Неверное регулярное выражение",
    invalid_error_message_format: "Неверный формат сообщения об ошибке.",
    required_field_missing: "Пожалуйста, введите {{field}}",
    required_field_missing_plural: "Вы должны ввести хотя бы одно {{field}}",
    more_details: "Больше информации",
    username_pattern_error: "Имя пользователя должно состоять только из букв, цифр или подчеркивания и не должно начинаться с цифры.",
    email_pattern_error: "Адрес электронной почты недействителен.",
    phone_pattern_error: "Номер телефона недействителен.",
    insecure_contexts: "Небезопасные контексты (нет HTTPS) не поддерживаются.",
    unexpected_error: "Произошла непредвиденная ошибка.",
    not_found: "404 не найдено",
    create_internal_role_violation: 'Вы создаете новую внутреннюю роль, что запрещено Logto. Попробуйте другое имя, которое не начинается с "#internal:".',
    should_be_an_integer: "Должно быть целым числом.",
    number_should_be_between_inclusive: "Тогда число должно быть между {{min}} и {{max}} (включительно)."
};
var $f393b85b66f67402$export$2e2bcd8739ae039 = Object.freeze($f393b85b66f67402$var$errors);


const $b1c1268f1639bc42$var$general = {
    placeholder: "Заполнитель",
    submit: "Отправить",
    skip: "Пропустить",
    next: "Следующий",
    back: "Назад",
    retry: "Повторить попытку",
    done: "Готово",
    search: "Поиск",
    search_placeholder: "Поиск",
    clear_result: "Очистить результаты",
    save: "Сохранить",
    save_changes: "Сохранить изменения",
    saved: "Сохранено",
    discard: "Отказаться",
    loading: "Загрузка...",
    redirecting: "Перенаправление...",
    add: "Добавить",
    added: "Добавлено",
    cancel: "Отмена",
    confirm: "Подтвердить",
    check_out: "Оформить заказ",
    create: "Создать",
    set_up: "Настроить",
    customize: "Настроить",
    enable: "Включить",
    reminder: "Напоминание",
    edit: "Редактировать",
    delete: "Удалить",
    deleted: "Удалено",
    more_options: "Дополнительные опции",
    close: "Закрыть",
    copy: "Копировать",
    copying: "Копирование",
    copied: "Скопировано",
    required: "Обязательное",
    add_another: "Добавить ещё",
    create_another: "Создать ещё",
    deletion_confirmation: "Вы действительно хотите удалить этот {{title}}?",
    settings_nav: "Настройки",
    unsaved_changes_warning: "Вы внесли изменения. Вы действительно хотите покинуть эту страницу?",
    leave_page: "Покинуть страницу",
    stay_on_page: "Остаться на странице",
    type_to_search: "Введите для поиска",
    got_it: "Понятно",
    continue: "Продолжить",
    page_info: "{{min, number}}-{{max, number}} из {{total, number}}",
    learn_more: "Узнать больше",
    tab_errors: "{{count, number}} ошибок",
    skip_for_now: "Пропустить",
    remove: "Удалить",
    visit: "Посетить",
    join: "Присоединиться",
    try_now: "Попробуйте сейчас",
    multiple_form_field: "(Несколько)",
    demo: "Демо",
    unnamed: "Без названия",
    view: "Просмотр",
    open: "Открыть",
    hide: "Скрыть",
    unknown_error: "Неизвестная ошибка, пожалуйста, попробуйте позже.",
    select: "Выбрать",
    contact_us_action: "Связаться с нами",
    description: "Описание",
    name: "Имя",
    add_field: "Добавить {{field}}",
    create_field: "Создать {{field}}",
    edit_field: "Изменить {{field}}",
    delete_field: "Удалить {{field}}",
    coming_soon: "Скоро",
    or: "Или"
};
var $b1c1268f1639bc42$export$2e2bcd8739ae039 = Object.freeze($b1c1268f1639bc42$var$general);


const $bcef5062847ba19a$var$get_started = {
    page_title: "Начало работы",
    title: "Что-то, что поможет вам добиться успеха",
    subtitle: "Несколько вещей, которые вы можете сделать, чтобы быстро получить ценность от Logto",
    develop: {
        title: "Разработка: Вам понадобится 5 минут, чтобы интегрировать ваше приложение",
        title_cloud: "Разработка: Безопасная интеграция вашего приложения за минуты",
        subtitle_cloud: "Или займет 5 минут для интеграции вашего приложения с нашими готовыми SDK и руководствами."
    },
    customize: {
        title: "Настроить: Создайте отличный вариант входа в систему",
        preview: {
            title: "Проверьте живую трансляцию присоединения к системе, которое вы только что настроили",
            subtitle: "Попробуйте пробный вариант входа в систему Logto, чтобы узнать, как это работает"
        },
        connector: {
            title: "Добавьте больше коннекторов, чтобы поддерживать больше способов входа через социальные сети",
            subtitle: "Попробуйте вход без пароля и включите защищенный и плавный опыт для ваших клиентов"
        },
        continue_customizing: "Продолжайте настройку",
        try_now: "Попробуйте сейчас",
        add_more: "Добавьте еще"
    },
    secure: {
        title: "Защита: Защитите свои ресурсы"
    },
    manage: {
        title: "Управление: Определите контроль доступа для вашего продукта и пользователей",
        rbac: {
            title: "Добавьте управление доступом на основе ролей, чтобы защитить ваши ресурсы",
            subtitle: "Управляйте вашим ресурсом через масштабируемую авторизацию ролей для различных случаев использования"
        },
        create_roles: "Создать роли"
    },
    view_all: "Посмотреть все →"
};
var $bcef5062847ba19a$export$2e2bcd8739ae039 = Object.freeze($bcef5062847ba19a$var$get_started);


const $50c444e331e06f95$var$guide = {
    start_building: "Начать строить",
    get_started: "Начать",
    categories: {
        featured: "Популярные и для вас",
        Traditional: "Традиционное веб-приложение",
        SPA: "Одностраничное приложение",
        Native: "Нативное",
        MachineToMachine: "Машина к машине",
        Protected: "Интеграция без SDK",
        ThirdParty: "Third-party app"
    },
    filter: {
        title: "Фильтры фреймворков",
        placeholder: "Поиск фреймворка"
    },
    checkout_tutorial: "Посмотреть руководство по {{name}}",
    do_not_need_tutorial: "Если вам не нужно руководство, вы можете продолжить без руководства по фреймворку",
    finish_and_done: "Завершить и закончить",
    cannot_find_guide: "Не удается найти ваше руководство?",
    describe_guide_looking_for: "Опишите руководство, которое вы ищете",
    request_guide_successfully: "Ваш запрос был успешно отправлен. Спасибо!",
    app: {
        select_framework_or_tutorial: "Выберите фреймворк или руководство",
        guide_modal_title: "Начните с SDK и руководств",
        modal_subtitle: "Ускорьте процесс разработки приложения с нашими готовыми SDK и руководствами.",
        select_a_framework: "Выберите фреймворк",
        continue_without_framework: "Создайте приложение без фреймворка",
        describe_guide_looking_for_placeholder: "Например, я хочу интегрировать Logto в мое Angular приложение."
    },
    api: {
        modal_title: "Начните с руководств",
        modal_subtitle: "Ускорьте процесс разработки приложения с нашими готовыми руководствами.",
        select_a_tutorial: "Выберите руководство",
        continue_without_tutorial: "Продолжить без руководства",
        describe_guide_looking_for_placeholder: "Например, я хочу защитить мое API с помощью deno."
    }
};
var $50c444e331e06f95$export$2e2bcd8739ae039 = Object.freeze($50c444e331e06f95$var$guide);


const $374cfc38a5421b43$var$invitation = {
    find_your_tenants: "Найти своих арендаторов",
    find_tenants_description: "Ваш адрес электронной почты может уже быть зарегистрирован у нескольких арендаторов. Вы можете выбрать присоединиться к уже существующим или продолжить создание нового.",
    create_new_tenant: "Создать нового арендатора",
    email_not_match_title: "Вы вошли в систему как\n{{email}}",
    email_not_match_description: "Пожалуйста, войдите под правильной учетной записью, чтобы принять приглашение и стать участником организации.",
    switch_account: "Войти под другой учетной записью",
    invalid_invitation_status: "Недействительное приглашение. Пожалуйста, свяжитесь с администратором и повторите попытку.",
    invitation_not_found: "Приглашение не найдено. Пожалуйста, свяжитесь с администратором."
};
var $374cfc38a5421b43$export$2e2bcd8739ae039 = Object.freeze($374cfc38a5421b43$var$invitation);


const $f0490263f21fc8c1$var$jwt_claims = {
    title: "Пользовательский JWT",
    description: "Настройте пользовательские утверждения JWT для включения в токен доступа. Эти утверждения могут использоваться для передачи дополнительной информации в ваше приложение.",
    user_jwt: {
        card_title: "Для пользователя",
        card_field: "Токен доступа пользователя",
        card_description: "Добавление специфичных для пользователя данных во время выдачи токена доступа.",
        for: "для пользователя"
    },
    machine_to_machine_jwt: {
        card_title: "Для М2М",
        card_field: "Токен от машины к машине",
        card_description: "Добавление дополнительных данных во время выдачи токена от машины к машине.",
        for: "для М2М"
    },
    code_editor_title: "Настройка своих утверждений {{token}}",
    custom_jwt_create_button: "Добавить пользовательские утверждения",
    custom_jwt_item: "Пользовательские утверждения {{for}}",
    delete_modal_title: "Удалить пользовательские утверждения",
    delete_modal_content: "Вы уверены, что хотите удалить пользовательские утверждения?",
    clear: "Очистить",
    cleared: "Очищено",
    restore: "Восстановить по умолчанию",
    restored: "Восстановлено",
    data_source_tab: "Источник данных",
    test_tab: "Тестовый контекст",
    jwt_claims_description: "Утверждения по умолчанию автоматически включаются в JWT и не могут быть переопределены.",
    user_data: {
        title: "Данные пользователя",
        subtitle: "Используйте параметр ввода `data.user` для предоставления важной информации о пользователе."
    },
    token_data: {
        title: "Данные токена",
        subtitle: "Используйте параметр ввода `token` для полезной нагрузки текущего токена доступа. "
    },
    fetch_external_data: {
        title: "Получение внешних данных",
        subtitle: "Интегрирование данных непосредственно из ваших внешних API в утверждения.",
        description: "Используйте функцию `fetch` для вызова ваших внешних API и включения данных в ваши пользовательские утверждения. Пример: "
    },
    environment_variables: {
        title: "Установка переменных среды",
        subtitle: "Используйте переменные среды для хранения конфиденциальной информации.",
        input_field_title: "Добавить переменные среды",
        sample_code: "Доступ к переменным среды в вашем обработчике утверждений JWT. Пример: "
    },
    jwt_claims_hint: "Ограничьте пользовательские утверждения до 50 КБ. Утверждения по умолчанию JWT автоматически включаются в токен и не могут быть переопределены.",
    tester: {
        subtitle: "Настройте макетный токен и данные пользователя для тестирования.",
        run_button: "Запустить тест",
        result_title: "Результат теста"
    },
    form_error: {
        invalid_json: "Недопустимый формат JSON"
    }
};
var $f0490263f21fc8c1$export$2e2bcd8739ae039 = Object.freeze($f0490263f21fc8c1$var$jwt_claims);


const $5532a03587426ff0$var$log_details = {
    page_title: "Детали журнала аудита",
    back_to_logs: "Назад к журналу аудита",
    back_to: "Назад к {{name}}",
    success: "Успешно",
    failed: "Не удалось",
    event_key: "Ключ события",
    application: "Приложение",
    ip_address: "IP адрес",
    user: "Пользователь",
    log_id: "ID журнала",
    time: "Время",
    user_agent: "User agent",
    tab_details: "Детали",
    raw_data: "Raw data"
};
var $5532a03587426ff0$export$2e2bcd8739ae039 = Object.freeze($5532a03587426ff0$var$log_details);


const $d3d5b5f42d55ab16$var$logs = {
    page_title: "Записи аудита",
    title: "Записи аудита",
    subtitle: "Просмотр данных журнала событий аутентификации, сделанных вашими пользователями",
    event: "Событие",
    user: "Пользователь",
    application: "Приложение",
    time: "Время",
    filter_by: "Фильтр по"
};
var $d3d5b5f42d55ab16$export$2e2bcd8739ae039 = Object.freeze($d3d5b5f42d55ab16$var$logs);


const $5c345d0b1b94ad84$var$menu = {
    profile: "Профиль",
    language: "Язык",
    appearance: {
        label: "Внешний вид",
        light: "Светлый режим",
        dark: "Темный режим",
        system: "Синхронизация с системой"
    },
    sign_out: "Выйти"
};
var $5c345d0b1b94ad84$export$2e2bcd8739ae039 = Object.freeze($5c345d0b1b94ad84$var$menu);


const $7649d2091fc8be27$var$mfa = {
    title: "Многократная аутентификация",
    description: "Добавьте многократную аутентификацию, чтобы повысить безопасность вашего опыта входа в систему.",
    factors: "Факторы",
    multi_factors: "Множественные факторы",
    multi_factors_description: "Пользователям необходимо проверить один из включенных факторов для двухэтапной верификации.",
    totp: "OTP приложения аутентификации",
    otp_description: "Привяжите Google Authenticator и др., чтобы проверять одноразовые пароли.",
    webauthn: "WebAuthn (Пароль)",
    webauthn_description: "Проверьте через метод, поддерживаемый браузером: биометрия, сканирование телефона или ключ безопасности и т.д.",
    webauthn_native_tip: "WebAuthn не поддерживается для приложений Native.",
    webauthn_domain_tip: "WebAuthn привязывает открытые ключи к конкретному домену. Изменение домена службы блокирует пользователей от аутентификации через существующие пароли.",
    backup_code: "Резервный код",
    backup_code_description: "Генерируйте 10 одноразовых резервных кодов после настройки любого метода MFA.",
    backup_code_setup_hint: "Когда пользователи не могут проверить вышеупомянутые факторы MFA, используйте резервный вариант.",
    backup_code_error_hint: "Для использования резервного кода вам нужен как минимум еще один метод MFA для успешной аутентификации пользователя.",
    policy: "Политика",
    policy_description: "Установите политику MFA для процессов входа и регистрации.",
    two_step_sign_in_policy: "Политика двухэтапной верификации при входе",
    user_controlled: "Пользователи могут самостоятельно включать или отключать MFA",
    user_controlled_tip: "Пользователи могут пропустить настройку MFA при первом входе или регистрации, либо включить/отключить его в настройках учетной записи.",
    mandatory: "Пользователям всегда нужно использовать MFA при входе",
    mandatory_tip: "Пользователи должны настроить MFA при первом входе или регистрации и использовать его для всех последующих входов."
};
var $7649d2091fc8be27$export$2e2bcd8739ae039 = Object.freeze($7649d2091fc8be27$var$mfa);


const $822147bb4287c1c3$var$organization_details = {
    page_title: "Детали организации",
    delete_confirmation: "После удаления все участники потеряют свою членство и роли в данной организации. Это действие нельзя отменить.",
    organization_id: "Идентификатор организации",
    settings_description: "Организации представляют команды, бизнес-клиентов и партнерские компании, которые могут получить доступ к вашим приложениям.",
    name_placeholder: "Название организации, не обязательно должно быть уникальным.",
    description_placeholder: "Описание организации.",
    member: "Участник",
    member_other: "Участники",
    add_members_to_organization: "Добавить участников в организацию {{name}}",
    add_members_to_organization_description: "Найдите подходящих пользователей, выполнив поиск по имени, электронной почте, телефону или идентификатору пользователя. Существующие участники не отображаются в результатах поиска.",
    add_with_organization_role: "Добавить с ролями организации",
    user: "Пользователь",
    authorize_to_roles: "Разрешить {{name}} доступ к следующим ролям:",
    edit_organization_roles: "Редактирование ролей организации",
    edit_organization_roles_of_user: "Редактирование ролей организации для {{name}}",
    remove_user_from_organization: "Удалить пользователя из организации",
    remove_user_from_organization_description: "После удаления пользователь потеряет свое членство и роли в этой организации. Это действие нельзя отменить.",
    search_user_placeholder: "Поиск по имени, электронной почте, телефону или идентификатору пользователя",
    at_least_one_user: "Необходимо указать хотя бы одного пользователя.",
    custom_data: "Кастомные данные",
    custom_data_tip: "Кастомные данные представляют собой JSON-объект, который может использоваться для хранения дополнительных данных, связанных с организацией.",
    invalid_json_object: "Некорректный JSON-объект."
};
var $822147bb4287c1c3$export$2e2bcd8739ae039 = Object.freeze($822147bb4287c1c3$var$organization_details);


const $994bfa9afb1a08b2$var$organization_role_details = {
    page_title: "Детали роли организации",
    back_to_org_roles: "Вернуться к ролям в организации",
    org_role: "Роль организации",
    delete_confirm: "При этом будут удалены разрешения, связанные с этой ролью, у затронутых пользователей, и будут удалены связи между ролями организации, членами организации и правами организации.",
    deleted: "Роль в организации {{name}} была успешно удалена.",
    permissions: {
        tab: "Разрешения",
        name_column: "Разрешение",
        description_column: "Описание",
        type_column: "Тип разрешения",
        type: {
            api: "Разрешение API",
            org: "Разрешение организации"
        },
        assign_permissions: "Назначить разрешения",
        remove_permission: "Удалить разрешение",
        remove_confirmation: "Если это разрешение будет удалено, пользователь с этой организационной ролью потеряет доступ, предоставленный этим разрешением.",
        removed: "Разрешение {{name}} успешно удалено из этой организационной роли",
        assign_description: "Назначьте разрешения ролям в этой организации. Они могут включать как организационные разрешения, так и разрешения API.",
        organization_permissions: "Организационные разрешения",
        api_permissions: "Разрешения API",
        assign_organization_permissions: "Назначить разрешения организации",
        assign_api_permissions: "Назначить разрешения API"
    },
    general: {
        tab: "Общее",
        settings: "Настройки",
        description: "Роль организации - это группировка разрешений, которые можно назначить пользователям. Разрешения могут исходить из предопределенных разрешений организации и разрешений API.",
        name_field: "Имя",
        description_field: "Описание",
        description_field_placeholder: "Пользователи с правами только на просмотр"
    }
};
var $994bfa9afb1a08b2$export$2e2bcd8739ae039 = Object.freeze($994bfa9afb1a08b2$var$organization_role_details);


const $7464860111bd7e70$var$organization_template = {
    title: "Шаблон организации",
    subtitle: "В многоарендных SaaS-приложениях шаблон организации определяет общие политики контроля доступа (разрешения и роли) для нескольких организаций.",
    roles: {
        tab_name: "Роли орг",
        search_placeholder: "Поиск по названию роли",
        create_title: "Создать роль орг",
        role_column: "Роль орг",
        permissions_column: "Разрешения",
        placeholder_title: "Роль организации",
        placeholder_description: "Роль организации - это группировка разрешений, которые могут быть назначены пользователям. Разрешения должны происходить из предопределенных разрешений организации.",
        create_modal: {
            title: "Создать роль организации",
            create: "Создать роль",
            name_field: "Название роли",
            description_field: "Описание",
            created: "Роль организации {{name}} успешно создана."
        }
    },
    permissions: {
        tab_name: "Разрешения орг",
        search_placeholder: "Поиск по названию разрешения",
        create_org_permission: "Создать разрешение орг",
        permission_column: "Разрешение организации",
        description_column: "Описание",
        placeholder_title: "Разрешение организации",
        placeholder_description: "Разрешение организации относится к авторизации на доступ к ресурсу в контексте организации.",
        delete_confirm: "Если это разрешение будет удалено, все роли организации, включающие это разрешение, потеряют его, и пользователи, имевшие это разрешение, потеряют доступ, предоставленный им.",
        create_title: "Создание разрешения организации",
        edit_title: "Редактирование разрешения организации",
        permission_field_name: "Название разрешения",
        description_field_name: "Описание",
        description_field_placeholder: "Читать историю назначений",
        create_permission: "Создать разрешение",
        created: "Разрешение для организации {{name}} успешно создано."
    }
};
var $7464860111bd7e70$export$2e2bcd8739ae039 = Object.freeze($7464860111bd7e70$var$organization_template);


const $590f30097268b07f$var$organizations = {
    organization: "Организация",
    page_title: "Организации",
    title: "Организации",
    subtitle: "Организации обычно используются в SaaS или подобных многоклиентских приложениях и представляют ваших клиентов - это команды, организации или целые компании. Организации действуют как основной элемент для аутентификации и авторизации B2B.",
    organization_template: "Шаблон организации",
    organization_id: "Идентификатор организации",
    members: "Участники",
    create_organization: "Создать организацию",
    setup_organization: "Настройка вашей организации",
    organization_list_placeholder_title: "Организация",
    organization_list_placeholder_text: "Организации часто используются в SaaS или подобных многоклиентских приложениях как лучшая практика. Они позволяют вам разрабатывать приложения, которые позволяют клиентам создавать и управлять организациями, приглашать участников и назначать роли.",
    organization_name_placeholder: "Моя организация",
    organization_description_placeholder: "Краткое описание организации",
    organization_permission: "Разрешение организации",
    organization_permission_other: "Разрешения организации",
    create_permission_placeholder: "Чтение истории назначений",
    organization_role: "Роль организации",
    organization_role_other: "Роли организации",
    organization_role_description: "Роль организации - это группировка разрешений, которые могут быть назначены пользователям. Разрешения должны быть взяты из предопределенных разрешений организации.",
    role: "Роль",
    search_placeholder: "Поиск по названию организации или ID",
    search_role_placeholder: "Начните вводить для поиска и выбора ролей",
    empty_placeholder: "\uD83E\uDD14 У вас пока нет никаких {{entity}}.",
    organization_and_member: "Организация и участник",
    organization_and_member_description: 'Организация - это группа пользователей, представляющая команды, деловых клиентов и партнерские компании, причем каждый пользователь является "Участником". Эти сущности могут быть фундаментальными для удовлетворения ваших требований мультиаренды.',
    guide: {
        title: "Начать с руководств",
        subtitle: "Начните настройку вашей организации с наших руководств",
        introduction: {
            title: "Давайте разберем, как устроена организация в Logto",
            section_1: {
                title: "Организация - это группа пользователей (идентификаторов)"
            },
            section_2: {
                title: "Шаблон организации предназначен для контроля доступа мультиарендных приложений",
                description: 'В мультиарендных SaaS-приложениях несколько организаций часто разделяют один и тот же шаблон контроля доступа, включая разрешения и роли. В Logto мы называем это "шаблон организации".',
                permission_description: "Разрешение организации относится к авторизации доступа к ресурсу в контексте организации.",
                role_description_deprecated: "Роль организации - это группировка разрешений организации, которые могут быть назначены участникам.",
                role_description: "Роль организации представляет собой группировку организационных разрешений или разрешений API, которые могут быть назначены членам."
            },
            section_3: {
                title: "Могу ли я назначить разрешения API организационным ролям?",
                description: "Да, вы можете назначить разрешения API организационным ролям. Logto предоставляет гибкость в управлении ролями вашей организации, позволяя включать в эти роли как организационные, так и разрешения API."
            },
            section_4: {
                title: "Взаимодействие с иллюстрацией для просмотра связей",
                description: "Давайте рассмотрим пример. Джон и Сара находятся в разных организациях с разными ролями в контексте разных организаций. Наведите указатель на различные модули и посмотрите, что происходит."
            }
        },
        organization_permissions: "Разрешения организации",
        organization_roles: "Роли организации",
        admin: "Администратор",
        member: "Участник",
        guest: "Гость",
        role_description: 'Роль "{{role}}" использует один и тот же шаблон организации для различных организаций.',
        john: "Джон",
        john_tip: 'Джон принадлежит двум организациям с адресом электронной почты "john@email.com" в качестве единственного идентификатора. Он является администратором организации A, а также гостем организации B.',
        sarah: "Сара",
        sarah_tip: 'Сара принадлежит одной организации с адресом электронной почты "sarah@email.com" в качестве единственного идентификатора. Она является администратором организации B.'
    }
};
var $590f30097268b07f$export$2e2bcd8739ae039 = Object.freeze($590f30097268b07f$var$organizations);


const $d84bfedea0694de2$var$permissions = {
    search_placeholder: "Поиск по имени API или разрешению",
    search_placeholder_without_api: "Поиск по наименованию разрешения",
    name_column: "Разрешение",
    description_column: "Описание",
    api_column: "API",
    placeholder_title: "Разрешение",
    placeholder_description: "Разрешение относится к авторизации доступа к ресурсу (мы называем это ресурсом API).",
    edit: "Разрешение на редактирование",
    delete: "Разрешение на удаление",
    remove: "Разрешение на удаление",
    edit_title: "Редактировать разрешение API"
};
var $d84bfedea0694de2$export$2e2bcd8739ae039 = Object.freeze($d84bfedea0694de2$var$permissions);


const $b70e0efc8fd1be21$var$profile = {
    page_title: "Настройки аккаунта",
    title: "Настройки аккаунта",
    description: "Измените настройки своего аккаунта и управляйте своей личной информацией здесь, чтобы обеспечить безопасность своего аккаунта.",
    settings: {
        title: "Настройки профиля",
        profile_information: "Информация профиля",
        avatar: "Аватар",
        name: "Имя",
        username: "Имя пользователя"
    },
    link_account: {
        title: "СВЯЗАТЬ АККАУНТ",
        email_sign_in: "Войти по электронной почте",
        email: "Электронная почта",
        social_sign_in: "Войти через социальные сети",
        link_email: "Связать адрес электронной почты",
        link_email_subtitle: "Свяжите свою электронную почту для входа или помощи в восстановлении аккаунта.",
        email_required: "Адрес электронной почты обязателен",
        invalid_email: "Неправильный адрес электронной почты",
        identical_email_address: "Введенный адрес электронной почты идентичен текущему",
        anonymous: "Анонимный"
    },
    password: {
        title: "ПАРОЛЬ И БЕЗОПАСНОСТЬ",
        password: "Пароль",
        password_setting: "Настройка пароля",
        new_password: "Новый пароль",
        confirm_password: "Подтвердите пароль",
        enter_password: "Введите текущий пароль",
        enter_password_subtitle: "Для защиты безопасности вашей учетной записи подтвердите, что это вы. Пожалуйста, введите ваш текущий пароль перед изменением.",
        set_password: "Установить пароль",
        verify_via_password: "Проверить через пароль",
        show_password: "Показать пароль",
        required: "Пароль обязателен",
        do_not_match: "Пароли не совпадают. Попробуйте еще раз."
    },
    code: {
        enter_verification_code: "Введите код подтверждения",
        enter_verification_code_subtitle: "Код подтверждения был отправлен на <strong>{{target}}</strong>",
        verify_via_code: "Проверить через код подтверждения",
        resend: "Повторно отправить код подтверждения",
        resend_countdown: "Отправить повторно через {{countdown}} секунд"
    },
    delete_account: {
        title: "УДАЛИТЬ АККАУНТ",
        label: "Удалить аккаунт",
        description: "Удаление вашего аккаунта приведет к удалению всей вашей личной информации, пользовательских данных и конфигураций. Это действие нельзя будет отменить.",
        button: "Удалить аккаунт",
        dialog_paragraph_1: "Мы сожалеем, что вы хотите удалить свой аккаунт. Удаление вашего аккаунта навсегда удалит всю информацию, включая данные пользователя, журналы и настройки, и это действие нельзя будет отменить. Пожалуйста, сделайте резервную копию важных данных перед продолжением.",
        dialog_paragraph_2: "Чтобы продолжить процесс удаления аккаунта, отправьте электронное письмо в нашу службу поддержки на адрес <a>{{mail}}</a> с темой \xabЗапрос на удаление аккаунта\xbb. Мы поможем и убедимся в правильном удалении всех ваших данных из нашей системы.",
        dialog_paragraph_3: "Благодарим вас за выбор облачного сервиса Logto. Если у вас есть какие-либо дополнительные вопросы или проблемы, не стесняйтесь обращаться к нам."
    },
    set: "Установить",
    change: "Изменить",
    link: "Связать",
    unlink: "Разъединить",
    not_set: "Не установлено",
    change_avatar: "Изменить аватар",
    change_name: "Изменить имя",
    change_username: "Изменить имя пользователя",
    set_name: "Установить имя",
    email_changed: "Адрес электронной почты изменен.",
    password_changed: "Пароль изменен.",
    updated: "{{target}} обновлен.",
    linked: "{{target}} связан.",
    unlinked: "{{target}} разъединен.",
    email_exists_reminder: "Этот адрес электронной почты {{email}} связан с существующим аккаунтом. Свяжите другой адрес электронной почты здесь.",
    unlink_confirm_text: "Да, разъединить",
    unlink_reminder: "Пользователи не смогут войти в аккаунт с помощью <span></span> , если вы его отсоедините. Вы уверены, что хотите продолжить?"
};
var $b70e0efc8fd1be21$export$2e2bcd8739ae039 = Object.freeze($b70e0efc8fd1be21$var$profile);


const $2b41369265e114a4$var$protected_app = {
    name: "Защищенное приложение",
    title: "Создайте защищенное приложение: добавьте аутентификацию с простотой и эпической скоростью",
    description: "Защищенное приложение безопасно сохраняет сеансы пользователей и проксирует запросы вашего приложения. Построенное на Cloudflare Workers, наслаждайтесь высочайшей производительностью и мгновенным запуском по всему миру. <a>Узнайте больше</a>",
    fast_create: "Быстрое создание",
    modal_title: "Создать защищенное приложение",
    modal_subtitle: "Включите безопасную и быструю защиту всего в несколько кликов. Легко добавьте аутентификацию к вашему существующему веб-приложению.",
    form: {
        url_field_label: "Ваш URL-адрес источника",
        url_field_placeholder: "https://domain.com/",
        url_field_description: "Укажите адрес вашего приложения, требующего защиты аутентификации.",
        url_field_modification_notice: "Изменения в исходном URL могут потребовать до 1-2 минут для активации по всему мировому сетевому оборудованию.",
        url_field_tooltip: "Укажите адрес вашего приложения, за исключением любых '/pathname'. После создания вы сможете настроить правила аутентификации маршрутов.\n\nПримечание: сам по себе исходный URL не требует защиты аутентификации; защита применяется исключительно к доступам через указанный домен приложения.",
        domain_field_label: "Домен приложения",
        domain_field_placeholder: "your-domain",
        domain_field_description: "Этот URL служит прокси для исходного URL с защитой аутентификации. Пользовательский домен может быть применен после создания.",
        domain_field_description_short: "Этот URL служит прокси для исходного URL с защитой аутентификации.",
        domain_field_tooltip: "Приложения, защищенные через Logto, будут размещены по адресу 'your-domain.{{domain}}' по умолчанию. После создания может быть применен пользовательский домен.",
        create_application: "Создать приложение",
        create_protected_app: "Быстрое создание",
        errors: {
            domain_required: "Требуется ваш домен.",
            domain_in_use: "Это поддомен уже используется.",
            invalid_domain_format: "Недопустимый формат поддомена: используйте только строчные буквы, цифры и дефисы '-'.",
            url_required: "Требуется исходный URL.",
            invalid_url: "Недопустимый формат исходного URL: используйте http:// или https://. Примечание: '/pathname' в настоящее время не поддерживается.",
            localhost: "Пожалуйста, сначала дайте доступ к вашему локальному серверу из интернета. Узнайте больше о <a>локальной разработке</a>."
        }
    },
    success_message: "\uD83C\uDF89 Аутентификация приложения успешно включена! Исследуйте новый опыт вашего веб-сайта."
};
var $2b41369265e114a4$export$2e2bcd8739ae039 = Object.freeze($2b41369265e114a4$var$protected_app);


const $f4eef9be483a64a9$var$role_details = {
    back_to_roles: "Назад к Ролям",
    identifier: "Идентификатор",
    delete_description: "Это действие удалит все соответствующие разрешения данной роли у затронутых пользователей и удалит отображение между ролями, пользователями и разрешениями.",
    role_deleted: "{{name}} был успешно удален.",
    general_tab: "Общие",
    users_tab: "Пользователи",
    m2m_apps_tab: "Машинные приложения",
    permissions_tab: "Разрешения",
    settings: "Настройки",
    settings_description: "Роли - это группировка разрешений, которые могут быть назначены пользователям. Они также обеспечивают способ объединения разрешений, определенных для разных API, что делает более эффективным добавление, удаление или корректировку разрешений по сравнению с назначением их отдельно пользователям.",
    field_name: "Имя",
    field_description: "Описание",
    field_is_default: "Стандартная роль",
    field_is_default_description: "Установить эту роль как стандартную для новых пользователей. Можно установить несколько стандартных ролей. Это также повлияет на стандартные роли для пользователей, созданных с использованием API управления.",
    type_m2m_role_tag: "Роль машинного приложения",
    type_user_role_tag: "Роль пользователя",
    m2m_role_notification: "Назначьте эту роль машина-машина приложению машина-машина, чтобы предоставить доступ к соответствующим ресурсам API. <a>Сначала создайте приложение машина-машина</a>, если еще этого не сделали.",
    permission: {
        assign_button: "Назначить Разрешения",
        assign_title: "Назначить разрешения",
        assign_subtitle: "Назначить разрешения этой роли. Роли будут получать добавленные разрешения, а пользователи с этой ролью будут наследовать эти разрешения.",
        assign_form_field: "Назначить разрешения",
        added_text_one: "{{count, number}} разрешение добавлено",
        added_text_other: "{{count, number}} разрешений добавлено",
        api_permission_count_one: "{{count, number}} разрешение",
        api_permission_count_other: "{{count, number}} разрешений",
        confirm_assign: "Назначить Разрешения",
        permission_assigned: "Выбранные разрешения были успешно назначены этой роли",
        deletion_description: "Если это право будет удалено, затронутый пользователь с этой ролью потеряет доступ, предоставленный этим разрешением.",
        permission_deleted: 'Разрешение "{{name}}" было успешно удалено из этой роли',
        empty: "Нет доступных разрешений"
    },
    users: {
        assign_button: "Назначить Пользователей",
        name_column: "Пользователь",
        app_column: "Приложение",
        latest_sign_in_column: "Последняя авторизация",
        delete_description: "Это действие приведет к потере авторизации на эту роль, но пользователь останется в вашем пуле пользователей.",
        deleted: "{{name}} был успешно удален из этой роли",
        assign_title: "Назначить пользователей",
        assign_subtitle: "Назначить пользователей на эту роль. Найдите подходящих пользователей, используя поиск по имени, электронной почте, номеру телефона или идентификатору пользователя.",
        assign_field: "Назначить пользователей",
        confirm_assign: "Назначить пользователей",
        assigned_toast_text: "Выбранные пользователи были успешно назначены на эту роль",
        empty: "Нет доступных пользователей"
    },
    applications: {
        assign_button: "Назначить приложения",
        name_column: "Приложение",
        app_column: "Приложения",
        description_column: "Описание",
        delete_description: "Оно останется в вашем пуле приложений, но потеряет авторизацию для этой роли.",
        deleted: "{{name}} был успешно удален из этой роли",
        assign_title: "Назначить приложения",
        assign_subtitle: "Назначить приложения на эту роль. Найдите подходящие приложения, используя поиск по имени, описанию или идентификатору приложения.",
        assign_field: "Назначить приложения",
        confirm_assign: "Назначить приложения",
        assigned_toast_text: "Выбранные приложения были успешно назначены на эту роль",
        empty: "Нет доступных приложений"
    }
};
var $f4eef9be483a64a9$export$2e2bcd8739ae039 = Object.freeze($f4eef9be483a64a9$var$role_details);


const $9231b9bd6d8d058a$var$roles = {
    page_title: "Роли",
    title: "Роли",
    subtitle: "Роли включают права доступа, которые определяют, что может делать пользователь. RBAC использует роли для предоставления пользователям доступа к ресурсам для конкретных действий.",
    create: "Создать роль",
    role_name: "Имя роли",
    role_type: "Тип роли",
    show_role_type_button_text: "Показать дополнительные варианты",
    hide_role_type_button_text: "Скрыть дополнительные варианты",
    type_user: "Роль пользователя",
    type_machine_to_machine: "Роль приложения между машинами",
    role_description: "Описание",
    role_name_placeholder: "Введите название роли",
    role_description_placeholder: "Введите описание роли",
    col_roles: "Роли",
    col_type: "Тип",
    col_description: "Описание",
    col_assigned_entities: "Назначенные",
    user_counts: "{{count}} пользователей",
    application_counts: "{{count}} приложений",
    user_count: "{{count}} пользователь",
    application_count: "{{count}} приложение",
    assign_permissions: "Назначить права доступа",
    create_role_title: "Создать роль",
    create_role_description: "Создание и управление ролями для ваших приложений. Роли содержат коллекции прав доступа и могут быть назначены пользователям.",
    create_role_button: "Создать роль",
    role_created: 'Роль "{{name}}" успешно создана.',
    search: "Поиск по названию роли, описанию или ID",
    placeholder_title: "Роли",
    placeholder_description: "Роли являются группировкой разрешений, которые могут быть назначены пользователям. Необходимо добавить разрешения, прежде чем создать роли.",
    assign_user_roles: "Назначить роли пользователя",
    assign_m2m_roles: "Назначить роли от машины к машине",
    management_api_access_notification: "Для доступа к API управления Logto выберите роли с разрешениями API управления <flag/>.",
    with_management_api_access_tip: "Эта роль от машины к машине включает разрешения для API управления Logto"
};
var $9231b9bd6d8d058a$export$2e2bcd8739ae039 = Object.freeze($9231b9bd6d8d058a$var$roles);


const $c66dd7115e4a1e96$var$session_expired = {
    title: "Истекло время сеанса",
    subtitle: "Ваш сеанс, возможно, истек и вы были отключены. Нажмите кнопку ниже, чтобы снова войти в консоль администратора.",
    button: "Войти снова"
};
var $c66dd7115e4a1e96$export$2e2bcd8739ae039 = Object.freeze($c66dd7115e4a1e96$var$session_expired);


const $d6387d341b4f71fc$var$content = {
    terms_of_use: {
        title: "TERMS",
        terms_of_use: "Terms of use URL",
        terms_of_use_placeholder: "https://your.terms.of.use/",
        privacy_policy: "Privacy policy URL",
        privacy_policy_placeholder: "https://your.privacy.policy/"
    },
    languages: {
        title: "LANGUAGES",
        enable_auto_detect: "Enable auto-detect",
        description: "Your software detects the user's locale setting and switches to the local language. You can add new languages by translating UI from English to another language.",
        manage_language: "Manage language",
        default_language: "Default language",
        default_language_description_auto: "The default language will be used when the detected user language isn’t covered in the current language library.",
        default_language_description_fixed: "When auto-detect is off, the default language is the only language your software will show. Turn on auto-detect for language extension."
    },
    manage_language: {
        title: "Manage language",
        subtitle: "Localize the product experience by adding languages and translations. Your contribution can be set as the default language.",
        add_language: "Add Language",
        logto_provided: "Logto provided",
        key: "Key",
        logto_source_values: "Logto source values",
        custom_values: "Custom values",
        clear_all_tip: "Clear all values",
        unsaved_description: "Changes won’t be saved if you leave this page without saving.",
        deletion_tip: "Delete the language",
        deletion_title: "Do you want to delete the added language?",
        deletion_description: "After deletion, your users won’t be able to browse in that language again.",
        default_language_deletion_title: "Default language can’t be deleted.",
        default_language_deletion_description: "{{language}} is set as your default language and can’t be deleted. "
    }
};
var $d6387d341b4f71fc$export$2e2bcd8739ae039 = Object.freeze($d6387d341b4f71fc$var$content);


const $5c9d2598b4545b55$var$password_policy = {
    password_requirements: "Требования к паролю",
    minimum_length: "Минимальная длина",
    minimum_length_description: "NIST предлагает использовать <a>не менее 8 символов</a> для веб-продуктов.",
    minimum_length_error: "Минимальная длина должна быть от {{min}} до {{max}} (включительно).",
    minimum_required_char_types: "Минимальное количество типов символов",
    minimum_required_char_types_description: "Типы символов: прописные (A-Z), строчные (a-z), цифры (0-9) и специальные символы ({{symbols}}).",
    password_rejection: "Отклонение пароля",
    compromised_passwords: "Отклонить скомпрометированный пароль",
    breached_passwords: "Сломанные пароли",
    breached_passwords_description: "Отвергнуть пароли, найденные ранее в базах данных нарушений.",
    restricted_phrases: "Ограничение низкобезопасных фраз",
    restricted_phrases_tooltip: "Ваш пароль должен избегать эти фразы, если не сопровождаются еще 3 или более символами.",
    repetitive_or_sequential_characters: "Повторяющиеся или последовательные символы",
    repetitive_or_sequential_characters_description: 'Например, "AAAA", "1234" и "abcd".',
    user_information: "Информация пользователя",
    user_information_description: "Например, адрес электронной почты, номер телефона, имя пользователя и т.д.",
    custom_words: "Пользовательские слова",
    custom_words_description: "Персонализируйте слова, специфичные для контекста, без учета регистра, одно на строку.",
    custom_words_placeholder: "Имя вашей службы, название компании и т. д."
};
var $5c9d2598b4545b55$export$2e2bcd8739ae039 = Object.freeze($5c9d2598b4545b55$var$password_policy);


const $ee41e17f915ceeb8$var$sign_up_and_sign_in = {
    identifiers_email: "Адрес электронной почты",
    identifiers_phone: "Номер телефона",
    identifiers_username: "Имя пользователя",
    identifiers_email_or_sms: "Адрес электронной почты или номер телефона",
    identifiers_none: "Не применимо",
    and: "и",
    or: "или",
    sign_up: {
        title: "РЕГИСТРАЦИЯ",
        sign_up_identifier: "Идентификатор регистрации",
        identifier_description: "Идентификатор регистрации необходим для создания учетной записи и должен быть включен на экране входа в систему.",
        sign_up_authentication: "Настройки аутентификации для регистрации",
        authentication_description: "Все выбранные действия будут обязательны для выполнения пользователем.",
        set_a_password_option: "Создайте пароль",
        verify_at_sign_up_option: "Подтвердить при регистрации",
        social_only_creation_description: "(Применяется только к созданию учетной записи в социальных сетях)"
    },
    sign_in: {
        title: "ВХОД",
        sign_in_identifier_and_auth: "Идентификатор и настройки аутентификации для входа",
        description: "Пользователи могут войти, используя любой из доступных вариантов. Настройте расположение, перетаскивая ниже указанные опции.",
        add_sign_in_method: "Добавить способ входа",
        password_auth: "Пароль",
        verification_code_auth: "Код подтверждения",
        auth_swap_tip: "Переставьте варианты ниже, чтобы определить, какой появится первым в потоке.",
        require_auth_factor: "Вы должны выбрать хотя бы один фактор аутентификации."
    },
    social_sign_in: {
        title: "ВХОД С ПОМОЩЬЮ СОЦИАЛЬНЫХ СЕТЕЙ",
        social_sign_in: "Вход через социальные сети",
        description: "В зависимости от обязательного идентификатора, который вы настроили, ваш пользователь может быть попрошен предоставить идентификатор при регистрации через социальный коннектор.",
        add_social_connector: "Добавить социальный коннектор",
        set_up_hint: {
            not_in_list: "Не найден в списке?",
            set_up_more: "Настроить",
            go_to: "другие социальные коннекторы."
        }
    },
    tip: {
        set_a_password: "Уникальный пароль для вашего имени пользователя является обязательным.",
        verify_at_sign_up: "В настоящее время мы поддерживаем только подтвержденный электронный адрес. Ваша база пользователей может содержать большое количество адресов электронной почты низкого качества, если не производится проверка.",
        password_auth: "Это необходимо, так как вы включили опцию установки пароля в процессе регистрации.",
        verification_code_auth: "Это необходимо, так как вы включили только опцию предоставления кода подтверждения при регистрации. Вы можете снять флажок, когда установка пароля разрешена в процессе регистрации.",
        delete_sign_in_method: "Это необходимо, так как вы выбрали {{identifier}} в качестве обязательного идентификатора."
    },
    advanced_options: {
        title: "ДОПОЛНИТЕЛЬНЫЕ ОПЦИИ",
        enable_single_sign_on: "Включить единую авторизацию (SSO) для предприятий",
        enable_single_sign_on_description: "Включить возможность входа пользователей в систему с помощью единой авторизации с использованием их корпоративных учетных данных.",
        single_sign_on_hint: {
            prefix: "Перейти в раздел ",
            link: '"Единая авторизация для предприятий"',
            suffix: " для настройки дополнительных корпоративных коннекторов."
        },
        enable_user_registration: "Включить регистрацию пользователей",
        enable_user_registration_description: "Включить или отключить регистрацию пользователей. После отключения пользователи все равно могут быть добавлены через консоль администратора, но больше создавать учетные записи через пользовательский интерфейс регистрации не могут."
    }
};
var $ee41e17f915ceeb8$export$2e2bcd8739ae039 = Object.freeze($ee41e17f915ceeb8$var$sign_up_and_sign_in);


const $c489d1443dd328ad$var$sign_in_exp = {
    page_title: "Опыт входа в систему",
    title: "Опыт входа в систему",
    description: "Настройте пользовательский интерфейс входа в систему в соответствии с вашим брендом и просматривайте в режиме реального времени",
    tabs: {
        branding: "Брендирование",
        sign_up_and_sign_in: "Регистрация и вход в систему",
        content: "Содержание",
        password_policy: "Политика пароля"
    },
    welcome: {
        title: "Настройка входа в систему",
        description: "Начните быстро с настройки первого входа в систему. Это руководство поможет вам пройти все необходимые настройки.",
        get_started: "Начать",
        apply_remind: "Обратите внимание, что опыт входа в систему будет применяться для всех приложений в этой учетной записи."
    },
    color: {
        title: "ЦВЕТ",
        primary_color: "Цвет бренда",
        dark_primary_color: "Цвет бренда (темный)",
        dark_mode: "Включить темный режим",
        dark_mode_description: "Ваше приложение будет иметь автоматически созданную темную тему на основе цвета вашего бренда и алгоритма Logto. Вы можете настроить ее по своему вкусу.",
        dark_mode_reset_tip: "Пересчитать цвет темного режима на основе цвета бренда.",
        reset: "Пересчитать"
    },
    branding: {
        title: "ЗОНА БРЕНДИНГА",
        ui_style: "Стиль",
        favicon: "Фавикон",
        logo_image_url: "URL изображения логотипа приложения",
        logo_image_url_placeholder: "https://your.cdn.domain/logo.png",
        dark_logo_image_url: "URL изображения логотипа приложения (темный)",
        dark_logo_image_url_placeholder: "https://your.cdn.domain/logo-dark.png",
        logo_image: "Логотип приложения",
        dark_logo_image: "Логотип приложения (темный)",
        logo_image_error: "Ошибка логотипа приложения: {{error}}",
        favicon_error: "Ошибка фавикона: {{error}}"
    },
    custom_css: {
        title: "Пользовательский CSS",
        css_code_editor_title: "Настройте ваш пользовательский интерфейс с помощью пользовательского CSS",
        css_code_editor_description1: "Смотрите пример пользовательского CSS.",
        css_code_editor_description2: "<a>{{link}}</a>",
        css_code_editor_description_link_content: "Подробнее",
        css_code_editor_content_placeholder: "Введите ваш пользовательский CSS, чтобы настроить стили для чего-угодно в соответствии с вашими требованиями. Выражайте свою креативность и выделяйте свой пользовательский интерфейс."
    },
    sign_up_and_sign_in: $ee41e17f915ceeb8$export$2e2bcd8739ae039,
    content: $d6387d341b4f71fc$export$2e2bcd8739ae039,
    password_policy: $5c9d2598b4545b55$export$2e2bcd8739ae039,
    setup_warning: {
        no_connector_sms: "Еще не настроен коннектор SMS. Пока не завершено настройка, пользователи не смогут войти с помощью этого метода. <a>{{link}}</a> в \xabКоннекторах\xbb",
        no_connector_email: "Еще не настроен коннектор по электронной почте. Пока не завершено настройка, пользователи не смогут войти с помощью этого метода. <a>{{link}}</a> в \xabКоннекторах\xbb",
        no_connector_social: 'Вы еще не настроили социальный коннектор. Сначала добавьте коннекторы, чтобы применить методы социальной авторизации. <a>{{link}}</a> в разделе "Коннекторы".',
        setup_link: "Настройка"
    },
    save_alert: {
        description: "Вы внедряете новые процедуры входа и регистрации. Все ваши пользователи могут быть затронуты новой настройкой. Вы точно хотите внести изменения?",
        before: "До",
        after: "После",
        sign_up: "Регистрация",
        sign_in: "Вход",
        social: "Социальный"
    },
    preview: {
        title: "Предварительный просмотр входа в систему",
        live_preview: "Прямой эфир",
        live_preview_tip: "Сохранить для просмотра изменений",
        native: "Нативный",
        desktop_web: "Веб на рабочем столе",
        mobile_web: "Мобильный веб",
        desktop: "Рабочий стол",
        mobile: "Мобильный"
    }
};
var $c489d1443dd328ad$export$2e2bcd8739ae039 = Object.freeze($c489d1443dd328ad$var$sign_in_exp);


const $68d61f3d598416e2$var$signing_keys = {
    title: "Ключи подписи",
    description: "Безопасное управление ключами подписи, используемыми вашими приложениями.",
    private_key: "Приватные ключи OIDC",
    private_keys_description: "Приватные ключи OIDC используются для подписи токенов JWT.",
    cookie_key: "Ключи куки OIDC",
    cookie_keys_description: "Ключи куки OIDC используются для подписи куки.",
    private_keys_in_use: "Используемые закрытые ключи",
    cookie_keys_in_use: "Используемые ключи cookie",
    rotate_private_keys: "Повернуть закрытые ключи",
    rotate_cookie_keys: "Повернуть ключи cookie",
    rotate_private_keys_description: "Это действие создаст новый закрытый ключ подписи, повернет текущий ключ и удалит предыдущий. Ваши JWT-токены, подписанные текущим ключом, останутся действительными до удаления или следующего раунда поворота.",
    rotate_cookie_keys_description: "Это действие создаст новый ключ cookie, повернет текущий ключ и удалит предыдущий. Ваши файлы cookie с текущим ключом останутся действительными до удаления или следующего раунда поворота.",
    select_private_key_algorithm: "Выберите алгоритм подписи ключа для нового закрытого ключа",
    rotate_button: "Повернуть",
    table_column: {
        id: "ID",
        status: "Статус",
        algorithm: "Алгоритм подписи ключа"
    },
    status: {
        current: "Текущий",
        previous: "Предыдущий"
    },
    reminder: {
        rotate_private_key: "Вы уверены, что хотите повернуть <strong>OIDC закрытые ключи</strong>? Новые выданные JWT-токены будут подписаны новым ключом. Существующие JWT-токены останутся действительными до следующего поворота.",
        rotate_cookie_key: "Вы уверены, что хотите повернуть <strong>Ключи cookie OIDC</strong>? Новые файлы cookie, созданные в сеансах входа в систему, будут подписаны новым ключом cookie. Существующие файлы cookie останутся действительными до следующего поворота.",
        delete_private_key: "Вы уверены, что хотите удалить <strong>OIDC закрытый ключ</strong>? Существующие JWT-токены, подписанные этим закрытым ключом, больше не будут действительными.",
        delete_cookie_key: "Вы уверены, что хотите удалить <strong>Ключ cookie OIDC</strong>? Более старые сеансы входа в систему с файлами cookie, подписанными этим ключом cookie, больше не будут действительными. Для этих пользователей требуется повторная авторизация."
    },
    messages: {
        rotate_key_success: "Ключи подписи успешно повернуты.",
        delete_key_success: "Ключ успешно удален."
    }
};
var $68d61f3d598416e2$export$2e2bcd8739ae039 = Object.freeze($68d61f3d598416e2$var$signing_keys);


const $81cedad68bb7e6b9$var$quota_item = {
    tenant_limit: {
        name: "Арендаторы",
        limited: "{{count, number}} арендатор",
        limited_other: "{{count, number}} арендаторов",
        unlimited: "Неограниченное количество арендаторов",
        not_eligible: "Удалите свои арендаторы"
    },
    mau_limit: {
        name: "Активные пользователи в месяц",
        limited: "{{count, number}} пользователей в месяц",
        unlimited: "Неограниченное количество пользователей в месяц",
        not_eligible: "Удалите всех своих пользователей"
    },
    token_limit: {
        name: "Токены",
        limited: "{{count, number}} токен",
        limited_other: "{{count, number}} токенов",
        unlimited: "Неограниченное количество токенов",
        not_eligible: "Удалите всех пользователей, чтобы предотвратить создание новых токенов"
    },
    applications_limit: {
        name: "Приложения",
        limited: "{{count, number}} приложение",
        limited_other: "{{count, number}} приложений",
        unlimited: "Неограниченное количество приложений",
        not_eligible: "Удалите свои приложения"
    },
    machine_to_machine_limit: {
        name: "Машина ко машине",
        limited: "{{count, number}} приложение для машины ко машине",
        limited_other: "{{count, number}} приложения для машин ко машине",
        unlimited: "Неограниченное количество приложений для машин ко машине",
        not_eligible: "Удалите свои приложения для машин ко машине"
    },
    third_party_applications_limit: {
        name: "Приложения сторонних разработчиков",
        limited: "{{count, number}} приложение сторонних разработчиков",
        limited_other: "{{count, number}} приложения сторонних разработчиков",
        unlimited: "Неограниченное количество приложений сторонних разработчиков",
        not_eligible: "Удалите свои приложения сторонних разработчиков"
    },
    resources_limit: {
        name: "API ресурсы",
        limited: "{{count, number}} API ресурс",
        limited_other: "{{count, number}} API ресурсов",
        unlimited: "Неограниченное количество API ресурсов",
        not_eligible: "Удалите свои API ресурсы"
    },
    scopes_per_resource_limit: {
        name: "Разрешения ресурса",
        limited: "{{count, number}} разрешение на ресурс",
        limited_other: "{{count, number}} разрешений на ресурс",
        unlimited: "Неограниченное количество разрешений на ресурс",
        not_eligible: "Удалите свои разрешения ресурса"
    },
    custom_domain_enabled: {
        name: "Пользовательский домен",
        limited: "Пользовательский домен",
        unlimited: "Пользовательский домен",
        not_eligible: "Удалите свой пользовательский домен"
    },
    omni_sign_in_enabled: {
        name: "Omni-вход",
        limited: "Omni-вход",
        unlimited: "Omni-вход",
        not_eligible: "Выключите свой Omni-вход"
    },
    built_in_email_connector_enabled: {
        name: "Встроенный электронный коннектор",
        limited: "Встроенный электронный коннектор",
        unlimited: "Встроенный электронный коннектор",
        not_eligible: "Удалите свой встроенный электронный коннектор"
    },
    social_connectors_limit: {
        name: "Социальные коннекторы",
        limited: "{{count, number}} социальный коннектор",
        limited_other: "{{count, number}} социальных коннекторов",
        unlimited: "Неограниченное количество социальных коннекторов",
        not_eligible: "Удалите свои социальные коннекторы"
    },
    standard_connectors_limit: {
        name: "Бесплатные стандартные коннекторы",
        limited: "{{count, number}} бесплатный стандартный коннектор",
        limited_other: "{{count, number}} бесплатных стандартных коннекторов",
        unlimited: "Неограниченное количество стандартных коннекторов",
        not_eligible: "Удалите свои стандартные коннекторы"
    },
    roles_limit: {
        name: "Роли",
        limited: "{{count, number}} роль",
        limited_other: "{{count, number}} ролей",
        unlimited: "Неограниченное количество ролей",
        not_eligible: "Удалите свои роли"
    },
    machine_to_machine_roles_limit: {
        name: "Роли для машины ко машине",
        limited: "{{count, number}} роль для машины ко машине",
        limited_other: "{{count, number}} ролей для машин ко машине",
        unlimited: "Неограниченное количество ролей для машин ко машине",
        not_eligible: "Удалите свои роли для машин ко машине"
    },
    scopes_per_role_limit: {
        name: "Разрешения роли",
        limited: "{{count, number}} разрешение на роль",
        limited_other: "{{count, number}} разрешений на роль",
        unlimited: "Неограниченное количество разрешений на роль",
        not_eligible: "Удалите свои разрешения роли"
    },
    hooks_limit: {
        name: "Webhooks",
        limited: "{{count, number}} webhook",
        limited_other: "{{count, number}} webhooks",
        unlimited: "Неограниченное количество вебхуков",
        not_eligible: "Удалите ваши вебхуки"
    },
    organizations_enabled: {
        name: "Организации",
        limited: "Организации",
        unlimited: "Организации",
        not_eligible: "Удалите свои организации"
    },
    audit_logs_retention_days: {
        name: "Время хранения аудит-логов",
        limited: "Время хранения аудит-логов: {{count, number}} день",
        limited_other: "Время хранения аудит-логов: {{count, number}} дней",
        unlimited: "Неограниченное количество дней",
        not_eligible: "Без аудит-логов"
    },
    email_ticket_support: {
        name: "Поддержка по электронной почте",
        limited: "{{count, number}} час поддержки по электронной почте",
        limited_other: "{{count, number}} часов поддержки по электронной почте",
        unlimited: "Поддержка по электронной почте",
        not_eligible: "Без поддержки по электронной почте"
    },
    mfa_enabled: {
        name: "Двухфакторная аутентификация",
        limited: "Двухфакторная аутентификация",
        unlimited: "Двухфакторная аутентификация",
        not_eligible: "Удалите свою двухфакторную аутентификацию"
    },
    sso_enabled: {
        name: "Единый вход для предприятий",
        limited: "Единый вход для предприятий",
        unlimited: "Единый вход для предприятий",
        not_eligible: "Удалите свой Единый вход для предприятий"
    },
    tenant_members_limit: {
        name: "Участники арендаторов",
        limited: "{{count, number}} участник арендатора",
        limited_other: "{{count, number}} участников арендатора",
        unlimited: "Неограниченное количество участников арендатора",
        not_eligible: "Удалите своих участников арендатора"
    },
    custom_jwt_enabled: {
        name: "Пользовательский JWT",
        limited: "Пользовательский JWT",
        unlimited: "Пользовательский JWT",
        not_eligible: "Удалите свой настраиваемый создатель токенов JWT"
    }
};
var $81cedad68bb7e6b9$export$2e2bcd8739ae039 = Object.freeze($81cedad68bb7e6b9$var$quota_item);


const $3ebaf82b46ca0062$var$quota_table = {
    quota: {
        title: "Основы",
        base_price: "Базовая цена",
        mau_limit: "Лимит MAU",
        included_tokens: "Включенные токены"
    },
    application: {
        title: "Приложения",
        total: "Всего приложений",
        m2m: 'Приложения "машина-машина"',
        third_party: "Приложения третьих сторон"
    },
    resource: {
        title: "Ресурсы API",
        resource_count: "Количество ресурсов",
        scopes_per_resource: "Разрешения на ресурс"
    },
    branding: {
        title: "Интерфейс и брендинг",
        custom_domain: "Пользовательский домен",
        custom_css: "Пользовательский CSS",
        app_logo_and_favicon: "Логотип и фавикон приложения",
        dark_mode: "Темный режим",
        i18n: "Интернационализация"
    },
    user_authn: {
        title: "Проверка подлинности пользователя",
        omni_sign_in: "Многочисленные входы",
        password: "Пароль",
        passwordless: "Без пароля - Электронная почта и SMS",
        email_connector: "Подключение электронной почты",
        sms_connector: "Подключение SMS",
        social_connectors: "Социальные подключения",
        standard_connectors: "Стандартные подключения",
        built_in_email_connector: "Встроенное подключение электронной почты",
        mfa: "Многофакторная аутентификация",
        sso: "Единый вход в корпоративные системы",
        adaptive_mfa: "Адаптивный MFA"
    },
    user_management: {
        title: "Управление пользователями",
        user_management: "Управление пользователями",
        roles: "Роли",
        machine_to_machine_roles: "Роли машины-машины",
        scopes_per_role: "Разрешения на роль"
    },
    organizations: {
        title: "Организация",
        organizations: "Организации",
        organization: "Организация",
        organization_count: "Количество организаций",
        allowed_users_per_org: "Пользователей на организацию",
        invitation: "Приглашение (Management API)",
        org_roles: "Роли организации",
        org_permissions: "Права организации",
        just_in_time_provisioning: "Пакетная настройка по запросу"
    },
    support: {
        title: "Соблюдение и поддержка",
        community: "Сообщество",
        customer_ticket: "Техническая поддержка",
        premium: "Премиум",
        email_ticket_support: "Поддержка по электронной почте",
        soc2_report: "Отчет SOC2",
        hipaa_or_baa_report: "Отчет HIPAA/BAA"
    },
    developers_and_platform: {
        title: "Разработчики и платформа",
        hooks: "Webhooks",
        audit_logs_retention: "Сохранение журналов аудита",
        jwt_claims: "JWT утверждения",
        tenant_members: "Члены арендаторов"
    },
    unlimited: "Неограниченно",
    contact: "Связаться",
    monthly_price: "$ {{value, number}} /мес.",
    days_one: "{{count, number}} день",
    days_other: "{{count, number}} дней",
    add_on: "Дополнительно",
    tier: "Уровень {{value, number}}: ",
    paid_token_limit_tip: "Logto будет взимать плату за функции, выходящие за пределы вашего квоты. Вы можете использовать его бесплатно до начала начисления сборов, примерно со второго квартала 2024 года. Если вам нужны дополнительные токены, свяжитесь с нами. По умолчанию мы выставляем счет в $80 в месяц за каждый миллион токенов.",
    paid_quota_limit_tip: "Logto добавит плату за функции, выходящие за пределы вашего лимита квоты. Вы можете использовать его бесплатно до начала взимания платы, примерно с 2 квартала 2024 года.",
    paid_add_on_feature_tip: "Это дополнительная функция. Вы можете использовать ее бесплатно до начала взимания платы, примерно с 2 квартала 2024 года.",
    million: "{{value, number}} миллионов",
    mau_tip: "MAU (месячно активные пользователи) означает количество уникальных пользователей, которые обменивались как минимум одним токеном с Logto в биллинговом цикле.",
    tokens_tip: "Все виды токенов, выпущенных Logto, включая токены доступа, токены обновления и т. д.",
    mao_tip: "MAO (ежемесячно активная организация) означает количество уникальных организаций, у которых есть хотя бы один MAU (ежемесячно активный пользователь) в биллинговом цикле.",
    third_party_tip: "Используйте Logto в качестве поставщика идентификации OIDC для входа в сторонние приложения и предоставления разрешений.",
    included: "включено {{value, number}}",
    included_mao: "{{value, number}} MAO включено",
    extra_quota_price: "Затем $ {{value, number}} в месяц / за каждый после",
    per_month_each: "$ {{value, number}} в месяц / за каждый",
    extra_mao_price: "Затем $ {{value, number}} за MAO",
    per_month: "$ {{value, number}} в месяц",
    per_member: "Затем $ {{value, number}} за участника"
};
var $3ebaf82b46ca0062$export$2e2bcd8739ae039 = Object.freeze($3ebaf82b46ca0062$var$quota_table);


const $e94bde71537d60c7$var$subscription = {
    free_plan: "Бесплатный план",
    free_plan_description: "Для побочных проектов и начальных испытаний Logto. Без кредитной карты.",
    pro_plan: "Про план",
    pro_plan_description: "Позволяет бизнесу использовать Logto без забот.",
    enterprise: "Enterprise",
    current_plan: "Текущий план",
    current_plan_description: "Вот ваш текущий тарифный план. Вы можете легко просмотреть использование вашего тарифа, проверить предстоящий счет и вносить изменения в тариф по мере необходимости.",
    plan_usage: "Использование плана",
    plan_cycle: "Цикл плана: {{period}}. Использование обновляется {{renewDate}}.",
    next_bill: "Ваш следующий счет",
    next_bill_hint: "Чтобы узнать больше о расчете, ознакомьтесь с этой <a>статьей</a>.",
    next_bill_tip: "Цены, отображаемые здесь, не включают налоги. Сумма налога будет рассчитана на основе предоставленной вами информации и местных требований регулирования, и будет указана в ваших счетах.",
    manage_payment: "Управление платежами",
    overfill_quota_warning: "Вы достигли лимита вашего квоты. Чтобы избежать возможных проблем, повысьте план.",
    upgrade_pro: "Повысить уровень до Pro",
    update_payment: "Обновить платеж",
    payment_error: "Обнаружена ошибка платежа. Невозможно обработать сумму ${{price, number}} за предыдущий цикл. Обновите платежную информацию, чтобы избежать блокировки сервиса Logto.",
    downgrade: "Понизить уровень",
    current: "Текущий",
    upgrade: "Обновить",
    quota_table: $3ebaf82b46ca0062$export$2e2bcd8739ae039,
    billing_history: {
        invoice_column: "Счета",
        status_column: "Статус",
        amount_column: "Сумма",
        invoice_created_date_column: "Дата создания счета",
        invoice_status: {
            void: "Отменено",
            paid: "Оплачено",
            open: "Открыто",
            uncollectible: "Просрочено"
        }
    },
    quota_item: $81cedad68bb7e6b9$export$2e2bcd8739ae039,
    downgrade_modal: {
        title: "Вы действительно хотите понизить уровень?",
        description: "Если вы выберете переключиться на <targetName/>, обратите внимание, что у вас больше не будет доступа к квотам и функциям, которые были ранее в <currentName/>.",
        before: "Позднее: <name/>",
        after: "После: <name />",
        downgrade: "Понизить уровень"
    },
    not_eligible_modal: {
        downgrade_title: "Вы не можете понизить уровень тарифа",
        downgrade_description: "Перед понижением до тарифа <name/>, убедитесь, что соответствуете следующим критериям.",
        downgrade_help_tip: "Нужна помощь в понижении? <a>Свяжитесь с нами</a>.",
        upgrade_title: "Дружественное напоминание нашим уважаемым ранним пользователям",
        upgrade_description: "В данный момент вы используете больше, чем позволяет <name />. Logto теперь официально, включая функции, специально разработанные для каждого тарифного плана. Прежде чем рассматривать обновление до <name />, убедитесь, что вы соответствуете следующим критериям перед обновлением.",
        upgrade_pro_tip: " Или рассмотрите обновление до Про-плана.",
        upgrade_help_tip: "Нужна помощь в повышении? <a>Свяжитесь с нами</a>.",
        a_maximum_of: "Максимум <item/>"
    },
    upgrade_success: "Успешно повышен до <name/>",
    downgrade_success: "Успешно понижен до <name/>",
    subscription_check_timeout: "Время проверки подписки истекло. Пожалуйста, обновите позже.",
    no_subscription: "Нет подписки"
};
var $e94bde71537d60c7$export$2e2bcd8739ae039 = Object.freeze($e94bde71537d60c7$var$subscription);


const $7dd4a758f2cbd900$var$tab_sections = {
    overview: "Обзор",
    authentication: "Аутентификация",
    authorization: "Авторизация",
    users: "Пользователи",
    developer: "Разработчик",
    tenant: "Арендатор"
};
var $7dd4a758f2cbd900$export$2e2bcd8739ae039 = Object.freeze($7dd4a758f2cbd900$var$tab_sections);


const $4a0aa280bca9476a$var$tabs = {
    get_started: "Начало",
    dashboard: "Панель управления",
    applications: "Приложения",
    api_resources: "Ресурсы API",
    sign_in_experience: "Опыт входа в систему",
    connectors: "Коннекторы",
    enterprise_sso: "Единый вход в систему предприятия",
    webhooks: "Webhooks",
    organizations: "Организации",
    users: "Управление пользователями",
    audit_logs: "Журналы аудита",
    roles: "Роли",
    docs: "Документация",
    tenant_settings: "Настройки",
    mfa: "Multi-factor auth",
    customize_jwt: "Пользовательский JWT",
    signing_keys: "Ключи подписи",
    organization_template: "Шаблон организации"
};
var $4a0aa280bca9476a$export$2e2bcd8739ae039 = Object.freeze($4a0aa280bca9476a$var$tabs);


const $feaa1919a942baed$var$tenant_members = {
    members: "Участники",
    invitations: "Приглашения",
    invite_members: "Пригласить участников",
    user: "Пользователь",
    roles: "Роли",
    admin: "Администратор",
    collaborator: "Соавтор",
    invitation_status: "Статус приглашения",
    inviter: "Пригласивший",
    expiration_date: "Дата окончания",
    invite_modal: {
        title: "Пригласить людей в Logto Cloud",
        subtitle: "Для приглашения участников в организацию они должны принять приглашение.",
        to: "Кому",
        added_as: "Добавлено как роль",
        email_input_placeholder: "johndoe@example.com"
    },
    invitation_statuses: {
        pending: "В ожидании",
        accepted: "Принято",
        expired: "Истекло",
        revoked: "Отозвано"
    },
    invitation_empty_placeholder: {
        title: "Пригласить членов команды",
        description: "Ваша организация пока что не пригласила никаких участников.\nДля помощи в вашем интеграции рассмотрите возможность добавления большего количества участников или администраторов."
    },
    menu_options: {
        edit: "Изменить роль арендатора",
        delete: "Удалить пользователя из арендатора",
        resend_invite: "Отправить приглашение повторно",
        revoke: "Отозвать приглашение",
        delete_invitation_record: "Удалить эту запись о приглашении"
    },
    edit_modal: {
        title: "Изменить роли у {{name}}"
    },
    delete_user_confirm: "Вы уверены, что хотите удалить этого пользователя из данного арендатора?",
    assign_admin_confirm: "Вы уверены, что хотите сделать выбранного пользовател(ей) администратором? Предоставление прав админа даст пользователю(ям) следующие разрешения.<ul><li>Изменить тарифный план арендатора</li><li>Добавлять или удалять соавторов</li><li>Удалять арендатора</li></ul>",
    revoke_invitation_confirm: "Вы уверены, что хотите отозвать это приглашение?",
    delete_invitation_confirm: "Вы уверены, что хотите удалить эту запись о приглашении?",
    messages: {
        invitation_sent: "Приглашение отправлено.",
        invitation_revoked: "Приглашение отозвано.",
        invitation_resend: "Приглашение отправлено повторно.",
        invitation_deleted: "Запись о приглашении удалена."
    },
    errors: {
        email_required: "Электронная почта приглашенного обязательна.",
        email_exists: "Адрес электронной почты уже существует.",
        member_exists: "Этот пользователь уже является участником этой организации.",
        pending_invitation_exists: "Существует незавершенное приглашение. Удалите связанный адрес электронной почты или отзовите приглашение.",
        invalid_email: "Адрес электронной почты недействителен. Пожалуйста, убедитесь, что он находится в правильном формате.",
        max_member_limit: "Вы достигли максимального количества участников ({{limit}}) для этого арендатора."
    }
};
var $feaa1919a942baed$export$2e2bcd8739ae039 = Object.freeze($feaa1919a942baed$var$tenant_members);


const $eee67bc591cca691$var$tenants = {
    title: "Настройки",
    description: "Эффективное управление настройками арендатора и настройка вашего домена.",
    tabs: {
        settings: "Настройки",
        members: "Участники",
        domains: "Домены",
        subscription: "План и выставление счетов",
        billing_history: "История выставления счетов"
    },
    settings: {
        title: "НАСТРОЙКИ",
        description: "Установите имя арендатора и просмотрите регион размещения данных и тип арендатора.",
        tenant_id: "ID арендатора",
        tenant_name: "Имя арендатора",
        tenant_region: "Регион размещения данных",
        tenant_region_tip: "Ваши ресурсы арендатора размещаются в {{region}}. <a>Узнайте больше</a>",
        environment_tag_development: "Разр",
        environment_tag_production: "Прод",
        tenant_type: "Тип арендатора",
        development_description: "Только для тестирования и не должно использоваться в производстве. Подписка не требуется. Он имеет все профессиональные функции, но с ограничениями, такими как баннер входа. <a>Узнайте больше</a>",
        production_description: "Предназначен для приложений, используемых конечными пользователями и может потребовать платную подписку. <a>Узнайте больше</a>",
        tenant_info_saved: "Информация о квартиросъемщике успешно сохранена."
    },
    full_env_tag: {
        development: "Разработка",
        production: "Производство"
    },
    deletion_card: {
        title: "УДАЛИТЬ",
        tenant_deletion: "Удаление арендатора",
        tenant_deletion_description: "Удаление арендатора приведет к окончательному удалению всех связанных пользовательских данных и настроек. Пожалуйста, действуйте осторожно.",
        tenant_deletion_button: "Удалить арендатора"
    },
    leave_tenant_card: {
        title: "ПОКИНУТЬ",
        leave_tenant: "Покинуть арендатора",
        leave_tenant_description: "Любые ресурсы арендатора останутся, но у вас больше не будет доступа к этому арендатору.",
        last_admin_note: "Чтобы покинуть этот квартиросъемщик, убедитесь, что у еще как минимум одного участника есть роль администратора."
    },
    create_modal: {
        title: "Создать арендатора",
        tenant_usage_purpose: "Для чего вы хотите использовать этот арендатор?",
        development_description: "Только для тестирования и не должно использоваться в производстве. Подписка не требуется.",
        development_hint: "Он имеет все профессиональные функции, но с ограничениями, такими как баннер входа.",
        production_description: "Для использования конечными пользователями и может потребовать платную подписку.",
        available_plan: "Доступный план:",
        create_button: "Создать арендатора",
        tenant_name_placeholder: "Мой арендатор"
    },
    dev_tenant_migration: {
        title: 'Теперь вы можете бесплатно попробовать наши профессиональные функции, создав новый "Development tenant"!',
        affect_title: "Как это повлияет на вас?",
        hint_1: "Мы заменяем старые <strong>теги окружения</strong> двумя новыми типами арендаторов: <strong>\xabDevelopment\xbb</strong> и <strong>\xabProduction\xbb</strong>.",
        hint_2: "Для обеспечения бесперебойной работы и непрерывной функциональности все заранее созданные арендаторы будут переведены в тип арендатора <strong>Production</strong> вместе с вашей предыдущей подпиской.",
        hint_3: "Не волнуйтесь, все ваши другие настройки останутся неизменными.",
        about_tenant_type: "Об типе арендатора"
    },
    delete_modal: {
        title: "Удалить арендатора",
        description_line1: 'Вы уверены, что хотите удалить вашего арендатора "<span>{{name}}</span>" с тегом окружения "<span>{{tag}}</span>"? Это действие нельзя отменить и приведет к окончательному удалению всех ваших данных и информации об арендаторе.',
        description_line2: "Прежде чем удалять арендатора, возможно, мы можем вам помочь. <span><a>Связаться с нами по электронной почте</a></span>",
        description_line3: 'If you want to proceed, enter the tenant name "<span>{{name}}</span>" for confirmation.',
        delete_button: "Навсегда удалить",
        cannot_delete_title: "Нельзя удалить этого арендатора",
        cannot_delete_description: "Извините, вы не можете удалить этого арендатора прямо сейчас. Пожалуйста, убедитесь, что вы используете бесплатный план и оплатили все невыполненные счета."
    },
    leave_tenant_modal: {
        description: "Вы уверены, что хотите покинуть этого арендатора?",
        leave_button: "Покинуть"
    },
    tenant_landing_page: {
        title: "Вы еще не создали арендатора",
        description: "Чтобы начать настройку вашего проекта с помощью Logto, создайте нового арендатора. Если вам нужно выйти из системы или удалить свою учетную запись, просто нажмите на кнопку аватара в правом верхнем углу.",
        create_tenant_button: "Создать арендатора"
    },
    status: {
        mau_exceeded: "Превышение MAU",
        suspended: "Приостановлен",
        overdue: "Прошлый срок"
    },
    tenant_suspended_page: {
        title: "Приостановленный арендатор. Свяжитесь с нами, чтобы восстановить доступ.",
        description_1: "Очень сожалеем, но ваша учетная запись арендатора временно заблокирована из-за неправильного использования, включая превышение MAU-лимитов, просроченные платежи или другие неавторизованные действия.",
        description_2: "Если вам нужна дополнительная информация или у вас возникли какие-либо вопросы или вы хотите восстановить полную функциональность и разблокировать своих арендаторов, не стесняйтесь немедленно связаться с нами."
    }
};
var $eee67bc591cca691$export$2e2bcd8739ae039 = Object.freeze($eee67bc591cca691$var$tenants);


const $56a1d427e3c86044$var$topbar = {
    docs: "Документы",
    help: "Помощь"
};
var $56a1d427e3c86044$export$2e2bcd8739ae039 = Object.freeze($56a1d427e3c86044$var$topbar);


const $7aaef11ea0be1fdb$var$featured_plan_content = {
    mau: {
        free_plan: "До {{count, number}} MAU",
        pro_plan: "Неограниченные MAU"
    },
    m2m: {
        free_plan: "{{count, number}} от устройства к устройству",
        pro_plan: "Дополнительное устройство к устройству"
    },
    third_party_apps: "IdP для сторонних приложений",
    mfa: "Многофакторная аутентификация",
    sso: "Корпоративный SSO",
    role_and_permissions: {
        free_plan: "{{roleCount, number}} роль и {{permissionCount, number}} разрешение на роль",
        pro_plan: "Неограниченные роли и разрешения на роль"
    },
    organizations: "Организации",
    audit_logs: "Хранение журналов аудита: {{count, number}} дней"
};
var $7aaef11ea0be1fdb$export$2e2bcd8739ae039 = Object.freeze($7aaef11ea0be1fdb$var$featured_plan_content);


const $50401788ad1e095e$var$paywall = {
    applications: "Достигнут лимит {{count, number}} приложения(й) для <planName/>. Обновите план, чтобы удовлетворить потребности вашей команды. При необходимости помощи, не стесняйтесь <a>связаться с нами</a>.",
    applications_other: "Достигнут лимит {{count, number}} приложений для <planName/>. Обновите план, чтобы удовлетворить потребности вашей команды. При необходимости помощи, не стесняйтесь <a>связаться с нами</a>.",
    machine_to_machine_feature: "Переключитесь на план <strong>Pro</strong>, чтобы получить дополнительные машинные приложения и воспользоваться всеми премиальными функциями. <a>Свяжитесь с нами</a>, если у вас есть вопросы.",
    machine_to_machine: "Достигнут лимит {{count, number}} машинных приложений для <planName/>. Обновите план, чтобы удовлетворить потребности вашей команды. При необходимости помощи, не стесняйтесь <a>связаться с нами</a>.",
    machine_to_machine_other: "Достигнут лимит {{count, number}} машинных приложений для <planName/>. Обновите план, чтобы удовлетворить потребности вашей команды. При необходимости помощи, не стесняйтесь <a>связаться с нами</a>.",
    resources: "Достигнут лимит {{count, number}} ресурсов API в плане <planName/>. Повысьте план, чтобы удовлетворить потребности вашей команды. <a>Свяжитесь с нами</a> для получения помощи.",
    resources_other: "Достигнут лимит {{count, number}} ресурсов API в плане <planName/>. Повысьте план, чтобы удовлетворить потребности вашей команды. <a>Свяжитесь с нами</a> для получения помощи.",
    scopes_per_resource: "Достигнут лимит {{count, number}} разрешений на ресурс API в плане <planName/>. Повысьте план, чтобы увеличить количество разрешений. <a>Свяжитесь с нами</a> для получения помощи.",
    scopes_per_resource_other: "Достигнут лимит {{count, number}} разрешений на ресурс API в плане <planName/>. Повысьте план, чтобы увеличить количество разрешений. <a>Свяжитесь с нами</a> для получения помощи.",
    custom_domain: "Разблокируйте функцию настраиваемого домена, обновив план до <strong>Hobby</strong> или <strong>Pro</strong>. Не стесняйтесь <a>связаться с нами</a>, если вам нужна помощь.",
    social_connectors: "Достигнут лимит {{count, number}} социальных коннекторов в плане <planName/>. Для удовлетворения потребностей вашей команды повысьте план, чтобы получить дополнительные социальные коннекторы и возможность создания собственных коннекторов с использованием протоколов OIDC, OAuth 2.0 и SAML. Если вам нужна помощь, не стесняйтесь <a>связаться с нами</a>.",
    social_connectors_other: "Достигнут лимит {{count, number}} социальных коннекторов в плане <planName/>. Для удовлетворения потребностей вашей команды повысьте план, чтобы получить дополнительные социальные коннекторы и возможность создания собственных коннекторов с использованием протоколов OIDC, OAuth 2.0 и SAML. Если вам нужна помощь, не стесняйтесь <a>связаться с нами</a>.",
    standard_connectors_feature: "Обновите план до <strong>Hobby</strong> или <strong>Pro</strong>, чтобы создавать собственные коннекторы с использованием протоколов OIDC, OAuth 2.0 и SAML, а также получить неограниченное количество социальных коннекторов и все премиальные функции. Не стесняйтесь <a>связаться с нами</a>, если вам нужна помощь.",
    standard_connectors: "Достигнут лимит {{count, number}} социальных коннекторов в плане <planName/>. Для удовлетворения потребностей вашей команды повысьте план, чтобы получить дополнительные социальные коннекторы и возможность создания собственных коннекторов с использованием протоколов OIDC, OAuth 2.0 и SAML. Если вам нужна помощь, не стесняйтесь <a>связаться с нами</a>.",
    standard_connectors_other: "Достигнут лимит {{count, number}} социальных коннекторов в плане <planName/>. Для удовлетворения потребностей вашей команды повысьте план, чтобы получить дополнительные социальные коннекторы и возможность создания собственных коннекторов с использованием протоколов OIDC, OAuth 2.0 и SAML. Если вам нужна помощь, не стесняйтесь <a>связаться с нами</a>.",
    standard_connectors_pro: "Достигнут лимит {{count, number}} стандартных коннекторов в плане <planName/>. Для удовлетворения потребностей вашей команды повысьте план до Плана предприятия, чтобы получить дополнительные социальные коннекторы и возможность создания собственных коннекторов с использованием протоколов OIDC, OAuth 2.0 и SAML. Если вам нужна помощь, не стесняйтесь <a>связаться с нами</a>.",
    standard_connectors_pro_other: "Достигнут лимит {{count, number}} стандартных коннекторов в плане <planName/>. Для удовлетворения потребностей вашей команды повысьте план до Плана предприятия, чтобы получить дополнительные социальные коннекторы и возможность создания собственных коннекторов с использованием протоколов OIDC, OAuth 2.0 и SAML. Если вам нужна помощь, не стесняйтесь <a>связаться с нами</a>.",
    roles: "Достигнут лимит {{count, number}} ролей в плане <planName/>. Повысьте план, чтобы добавить дополнительные роли и разрешения. Если вам нужна помощь, не стесняйтесь <a>связаться с нами</a>.",
    roles_other: "Достигнут лимит {{count, number}} ролей в плане <planName/>. Повысьте план, чтобы добавить дополнительные роли и разрешения. Если вам нужна помощь, не стесняйтесь <a>связаться с нами</a>.",
    machine_to_machine_roles: "{{count, number}} роль для машинного приложения в пределах <planName/> достигла лимита. Повысьте план, чтобы добавить дополнительные роли и разрешения. Не стесняйтесь <a>связаться с нами</a>, если вам нужна помощь.",
    machine_to_machine_roles_other: "{{count, number}} ролей для машинного приложения в пределах <planName/> достигли лимита. Повысьте план, чтобы добавить дополнительные роли и разрешения. Не стесняйтесь <a>связаться с нами</a>, если вам нужна помощь.",
    scopes_per_role: "Достигнут лимит {{count, number}} разрешений на роль в плане <planName/>. Повысьте план, чтобы добавить дополнительные роли и разрешения. Если вам нужна помощь, не стесняйтесь <a>связаться с нами</a>.",
    scopes_per_role_other: "Достигнут лимит {{count, number}} разрешений на роль в плане <planName/>. Повысьте план, чтобы добавить дополнительные роли и разрешения. Если вам нужна помощь, не стесняйтесь <a>связаться с нами</a>.",
    hooks: "Достигнут лимит {{count, number}} вебхуков в плане <planName/>. Повысьте план, чтобы создать больше вебхуков. Если вам нужна помощь, не стесняйтесь <a>связаться с нами</a>.",
    hooks_other: "Достигнут лимит {{count, number}} вебхуков в плане <planName/>. Повысьте план, чтобы создать больше вебхуков. Если вам нужна помощь, не стесняйтесь <a>связаться с нами</a>.",
    mfa: "Разблокируйте MFA для повышения безопасности с помощью перехода на платный план. Не стесняйтесь <a>связаться с нами</a>, если вам нужна помощь.",
    organizations: "Разблокируйте организации, перейдя на платный план. Не стесняйтесь <a>связаться с нами</a>, если вам нужна помощь.",
    third_party_apps: "Разблокируйте Logto как IdP для сторонних приложений, обновив план до платного. Для получения помощи не стесняйтесь <a>связаться с нами</a>.",
    sso_connectors: "Разблокируйте единые серверы аутентификации для предприятия, перейдя на платный план. Для получения помощи не стесняйтесь <a>связаться с нами</a>.",
    tenant_members: "Разблокируйте функцию сотрудничества, перейдя на платный план. Для получения помощи не стесняйтесь <a>связаться с нами</a>.",
    tenant_members_dev_plan: "Вы достигли лимита {{limit}} участников. Освободите место для новых участников или отмените ожидающее приглашение. Нужны дополнительные места? Не стесняйтесь <a>связаться с нами</a>.",
    custom_jwt: {
        title: "Добавить пользовательские претензии",
        description: "Обновите платный план для функциональности пользовательского JWT и дополнительных премиальных возможностей. Если у вас есть вопросы, не стесняйтесь <a>связаться с нами</a>."
    }
};
var $50401788ad1e095e$export$2e2bcd8739ae039 = Object.freeze($50401788ad1e095e$var$paywall);


const $9f2b7af8994bff9a$var$upsell = {
    upgrade_plan: "Повысить план",
    compare_plans: "Сравнить планы",
    view_plans: "Просмотреть планы",
    create_tenant: {
        title: "Выберите план арендатора",
        description: "Logto предоставляет конкурентные варианты планов с инновационной и доступной ценой, специально разработанными для растущих компаний. <a>Узнать больше</a>",
        base_price: "Базовая цена",
        monthly_price: "{{value, number}}/мес.",
        view_all_features: "Просмотреть все функции",
        select_plan: "Выбрать <name/>",
        free_tenants_limit: "До {{count, number}} бесплатного арендатора",
        free_tenants_limit_other: "До {{count, number}} бесплатных арендаторов",
        most_popular: "Самый популярный",
        upgrade_success: "Успешно повышен до <name/>"
    },
    mau_exceeded_modal: {
        title: "Превышено количество активных пользователей (MAU). Повысьте свой план.",
        notification: "Текущее количество активных пользователей (MAU) превысило лимит в плане <planName/>. Пожалуйста, незамедлительно обновите свой план до премиум-версии, чтобы избежать приостановки сервиса Logto.",
        update_plan: "Обновить план"
    },
    payment_overdue_modal: {
        title: "Просрочен платеж за счет",
        notification: "Упс! Оплата счета арендатора <span>{{name}}</span> не удалась. Пожалуйста, оплатите счет немедленно, чтобы избежать приостановки сервиса Logto.",
        unpaid_bills: "Неоплаченные счета",
        update_payment: "Обновить платеж"
    },
    add_on_quota_item: {
        api_resource: "API-ресурс",
        machine_to_machine: 'приложение "машина-машина"',
        tokens: "{{limit}}M токенов",
        tenant_member: "член арендатора"
    },
    charge_notification_for_quota_limit: "Вы превысили лимит вашей квоты по {{item}}. Logto начнет взимать плату за использование сверх вашей квоты. Начисление начнется в день выпуска нового дизайна цен на дополнение. <a>Узнать больше</a>",
    paywall: $50401788ad1e095e$export$2e2bcd8739ae039,
    featured_plan_content: $7aaef11ea0be1fdb$export$2e2bcd8739ae039
};
var $9f2b7af8994bff9a$export$2e2bcd8739ae039 = Object.freeze($9f2b7af8994bff9a$var$upsell);


const $5b94b5736f82375f$var$user_details = {
    page_title: "Детали пользователя",
    back_to_users: "Вернуться к управлению пользователями",
    created_title: "Пользователь успешно создан",
    created_guide: "Вот информация, которая поможет пользователю в процессе входа в систему.",
    created_email: "Адрес электронной почты:",
    created_phone: "Номер телефона:",
    created_username: "Имя пользователя:",
    created_password: "Пароль:",
    menu_delete: "Удалить",
    delete_description: "Это действие нельзя отменить. Оно окончательно удалит пользователя.",
    deleted: "Пользователь успешно удален",
    reset_password: {
        reset_password: "Сбросить пароль",
        title: "Вы уверены, что хотите сбросить пароль?",
        content: "Это действие нельзя отменить. Это сбросит информацию для входа пользователя.",
        congratulations: "Пользователь был сброшен",
        new_password: "Новый пароль:"
    },
    tab_settings: "Настройки",
    tab_roles: "Роли",
    tab_logs: "Журналы пользователя",
    tab_organizations: "Организации",
    authentication: "Аутентификация",
    authentication_description: "У каждого пользователя есть профиль, содержащий всю информацию о пользователе. Он состоит из основных данных, социальных идентификаторов и пользовательских данных.",
    user_profile: "Профиль пользователя",
    field_email: "Адрес электронной почты",
    field_phone: "Номер телефона",
    field_username: "Имя пользователя",
    field_name: "Имя",
    field_avatar: "URL изображения аватара",
    field_avatar_placeholder: "https://your.cdn.domain/avatar.png",
    field_custom_data: "Пользовательские данные",
    field_custom_data_tip: "Дополнительная информация о пользователе, не указанная в заранее определенных свойствах пользователя, таких как предпочтительный цвет и язык пользователя.",
    field_connectors: "Социальные подключения",
    field_sso_connectors: "Корпоративные подключения",
    custom_data_invalid: "Пользовательские данные должны быть допустимым JSON-объектом",
    connectors: {
        connectors: "Подключения",
        user_id: "ID пользователя",
        remove: "Удалить",
        connected: "Этот пользователь подключен к нескольким социальным подключениям.",
        not_connected: "Пользователь не подключен к социальным подключениям",
        deletion_confirmation: "Вы удаляете существующую личность <name/>. Вы уверены, что хотите продолжить?"
    },
    sso_connectors: {
        connectors: "Подключения",
        enterprise_id: "ID корпорации",
        connected: "Этот пользователь подключен к нескольким поставщикам корпоративной идентификации для однократного входа.",
        not_connected: "Пользователь не подключен к поставщикам корпоративного идентификатора для однократного входа."
    },
    mfa: {
        field_name: "Двухфакторная аутентификация",
        field_description: "Этот пользователь включил двухэтапные факторы аутентификации.",
        name_column: "Двухфакторная аутентификация",
        field_description_empty: "Этот пользователь не включил двухфакторную аутентификацию.",
        deletion_confirmation: "Вы удаляете существующий <name/> для двухэтапной верификации. Вы уверены, что хотите продолжить?"
    },
    suspended: "Приостановлен",
    suspend_user: "Приостановить пользователя",
    suspend_user_reminder: "Вы уверены, что хотите приостановить этого пользователя? Пользователь не сможет войти в ваше приложение, и он не сможет получить новый токен доступа после истечения срока действия текущего токена. Кроме того, любые API-запросы, сделанные этим пользователем, завершатся неудачей.",
    suspend_action: "Приостановить",
    user_suspended: "Пользователь был приостановлен.",
    reactivate_user: "Возобновить пользователя",
    reactivate_user_reminder: "Вы уверены, что хотите возобновить этого пользователя? Это позволит любые попытки входа в систему для этого пользователя.",
    reactivate_action: "Возобновить",
    user_reactivated: "Пользователь был возобновлен.",
    roles: {
        name_column: "Роль",
        description_column: "Описание",
        assign_button: "Назначить роли",
        delete_description: "Это действие удалит эту роль у данного пользователя. Роль все еще будет существовать, но она больше не будет связана с этим пользователем.",
        deleted: "{{name}} был(а) успешно удален(а) из этого пользователя.",
        assign_title: "Назначить роли {{name}}",
        assign_subtitle: "Авторизовать {{name}} в одной или нескольких ролях",
        assign_role_field: "Назначить роли",
        role_search_placeholder: "Поиск по названию роли",
        added_text: "{{value, number}} добавлен(а)",
        assigned_user_count: "{{value, number}} пользователей",
        confirm_assign: "Назначить роли",
        role_assigned: "Роль(и) успешно назначена(ы)",
        search: "Поиск по названию роли, описанию или ID",
        empty: "Нет доступных ролей"
    },
    warning_no_sign_in_identifier: "Пользователь должен иметь хотя бы один из идентификаторов входа (имя пользователя, электронная почта, номер телефона или социальная сеть), чтобы войти. Вы уверены, что хотите продолжить?",
    organization_roles_tooltip: "Роли, назначенные пользователю в этой организации."
};
var $5b94b5736f82375f$export$2e2bcd8739ae039 = Object.freeze($5b94b5736f82375f$var$user_details);


const $75862e82db42273c$var$users = {
    page_title: "Управление пользователями",
    title: "Управление пользователями",
    subtitle: "Управление идентификацией пользователей, включая создание пользователей, редактирование информации о пользователях, просмотр журналов пользователей, сброс пароля и удаление пользователей",
    create: "Добавить пользователя",
    create_subtitle: "Введите хотя бы одно из следующих полей для продолжения.",
    error_missing_identifier: "Чтобы создать пользователя, вам нужно указать хотя бы один идентификатор.",
    user_name: "Пользователь",
    application_name: "От приложения",
    latest_sign_in: "Последний вход",
    create_form_username: "Имя пользователя",
    create_form_password: "Пароль",
    create_form_name: "Полное имя",
    placeholder_name: "Иван Иванов",
    placeholder_email: "ivan@example.com",
    placeholder_username: "user123",
    placeholder_phone: "+7 (123) 456-78-90",
    unnamed: "Без имени",
    search: "Поиск по имени, электронной почте, телефону или имени пользователя",
    check_user_detail: "Просмотреть информацию о пользователе",
    placeholder_title: "Управление пользователями",
    placeholder_description: "Каждый пользователь имеет профиль, содержащий всю информацию о пользователе. Он состоит из базовых данных, социальных идентификаторов и настраиваемых данных."
};
var $75862e82db42273c$export$2e2bcd8739ae039 = Object.freeze($75862e82db42273c$var$users);


const $f1b85e525828b33c$var$webhook_details = {
    page_title: "Данные вебхука",
    back_to_webhooks: "Вернуться к вебхукам",
    not_in_use: "Не используется",
    success_rate: "Коэффициент успешности",
    requests: "{{value, number}} запросов за 24 часа",
    disable_webhook: "Отключить вебхук",
    disable_reminder: "Вы уверены, что хотите включить этот вебхук? Это не приведет к отправке HTTP-запроса на URL-адрес точки доступа.",
    webhook_disabled: "Вебхук был отключен.",
    webhook_reactivated: "Вебхук был перезапущен.",
    reactivate_webhook: "Перезапустить вебхук",
    delete_webhook: "Удалить вебхук",
    deletion_reminder: "Вы удаляете этот вебхук. После удаления он не будет отправлять HTTP-запрос на URL-адрес точки доступа.",
    deleted: "Вебхук был успешно удален.",
    settings_tab: "Настройки",
    recent_requests_tab: "Недавние запросы (за 24ч)",
    settings: {
        settings: "Настройки",
        settings_description: "Вебхуки позволяют получать обновления в режиме реального времени по конкретным событиям по мере их возникновения, отправляя POST-запрос на ваш URL-адрес точки доступа. Это позволяет вам немедленно выполнять действия на основе новой информации.",
        events: "События",
        events_description: "Выберите события триггеров, которые Logto будет отправлять POST-запрос.",
        name: "Имя",
        endpoint_url: "URL-адрес точки доступа",
        signing_key: "Ключ подписи",
        signing_key_tip: "Добавьте секретный ключ, предоставленный Logto, к своей конечной точке в виде заголовка запроса, чтобы обеспечить подлинность нагрузки вебхука.",
        regenerate: "Регенерировать",
        regenerate_key_title: "Регенерировать ключ подписи",
        regenerate_key_reminder: "Вы уверены, что хотите изменить ключ подписи? Регенерация приведет к немедленному вступлению в силу. Пожалуйста, не забудьте синхронно изменить ключ подписи в своей конечной точке.",
        regenerated: "Ключ подписи был обновлен.",
        custom_headers: "Пользовательские заголовки",
        custom_headers_tip: "При желании вы можете добавлять пользовательские заголовки к нагрузке вебхука, чтобы предоставить дополнительный контекст или метаданные о событии.",
        key_duplicated_error: "Ключи не могут повторяться.",
        key_missing_error: "Ключ обязателен.",
        value_missing_error: "Значение обязательно",
        invalid_key_error: "Ключ недействителен",
        invalid_value_error: "Значение недействительно",
        test: "Тестирование",
        test_webhook: "Протестировать ваш вебхук",
        test_webhook_description: "Настройте вебхук и протестируйте его с примерами нагрузки для каждого выбранного события, чтобы проверить правильный прием и обработку.",
        send_test_payload: "Отправить тестовую нагрузку",
        test_result: {
            endpoint_url: "URL конечной точки: {{url}}",
            message: "Сообщение: {{message}}",
            response_status: "Статус ответа: {{status, number}}",
            response_body: "Тело ответа: {{body}}",
            request_time: "Время запроса: {{time}}",
            test_success: "Тест вебхука на конечную точку прошел успешно."
        }
    }
};
var $f1b85e525828b33c$export$2e2bcd8739ae039 = Object.freeze($f1b85e525828b33c$var$webhook_details);


const $d991c3ca128c35f3$var$webhooks = {
    page_title: "Вебхуки",
    title: "Вебхуки",
    subtitle: "Создайте вебхуки, чтобы легко получать обновления в реальном времени относительно определенных событий.",
    create: "Создать вебхук",
    schemas: {
        interaction: "Взаимодействие пользователя",
        user: "Пользователь",
        organization: "Организация",
        role: "Роль",
        scope: "Разрешение",
        organization_role: "Роль организации",
        organization_scope: "Разрешение организации"
    },
    table: {
        name: "Имя",
        events: "События",
        success_rate: "Коэффициент успешности (за 24ч)",
        requests: "Запросы (за 24ч)"
    },
    placeholder: {
        title: "Вебхук",
        description: 'Создайте вебхук для получения обновлений в реальном времени через POST-запросы на URL-адрес вашей конечной точки. Будьте в курсе событий и мгновенно реагируйте на события, такие как "Создание учетной записи", "Вход" и "Сброс пароля".',
        create_webhook: "Создать вебхук"
    },
    create_form: {
        title: "Создать вебхук",
        subtitle: "Добавьте вебхук, чтобы отправлять запросы POST на URL-адрес конечной точки с деталями любых событий пользователей.",
        events: "События",
        events_description: "Выберите события-триггеры, при которых Logto будет отправлять запросы POST.",
        name: "Имя",
        name_placeholder: "Введите имя вебхука",
        endpoint_url: "URL-адрес конечной точки",
        endpoint_url_placeholder: "https://ваш.url.адрес.вебхука",
        endpoint_url_tip: "Введите URL вашей конечной точки, на который будет отправлено тело вебхука, когда произойдет событие.",
        create_webhook: "Создать вебхук",
        missing_event_error: "Вы должны выбрать как минимум одно событие."
    },
    webhook_created: "Вебхук {{name}} был успешно создан."
};
var $d991c3ca128c35f3$export$2e2bcd8739ae039 = Object.freeze($d991c3ca128c35f3$var$webhooks);


const $a4cbe86ae5f4e26b$var$welcome = {
    title: "Добро пожаловать в административную консоль",
    description: "Административная консоль - это веб-приложение для управления Logto без требований к кодированию. Давайте сначала создадим учетную запись. С этой учетной записью вы можете управлять Logto самостоятельно или от имени вашей компании.",
    create_account: "Создать учетную запись"
};
var $a4cbe86ae5f4e26b$export$2e2bcd8739ae039 = Object.freeze($a4cbe86ae5f4e26b$var$welcome);


const $d94a86ba3334d158$var$admin_console = {
    title: "Консоль администратора",
    admin_user: "Администратор",
    system_app: "Система",
    menu: $5c345d0b1b94ad84$export$2e2bcd8739ae039,
    general: $b1c1268f1639bc42$export$2e2bcd8739ae039,
    errors: $f393b85b66f67402$export$2e2bcd8739ae039,
    tab_sections: $7dd4a758f2cbd900$export$2e2bcd8739ae039,
    tabs: $4a0aa280bca9476a$export$2e2bcd8739ae039,
    applications: $b34dd16aff95b3fe$export$2e2bcd8739ae039,
    application_details: $3acf9b763ec0db6f$export$2e2bcd8739ae039,
    api_resources: $6829fa582a65ca4b$export$2e2bcd8739ae039,
    api_resource_details: $e8adcef97d98657b$export$2e2bcd8739ae039,
    connectors: $12c9b5f9022280ad$export$2e2bcd8739ae039,
    connector_details: $243d7fd77ce6d7dd$export$2e2bcd8739ae039,
    enterprise_sso: $fa612d11d99097f6$export$2e2bcd8739ae039,
    enterprise_sso_details: $abff6803bb322157$export$2e2bcd8739ae039,
    get_started: $bcef5062847ba19a$export$2e2bcd8739ae039,
    users: $75862e82db42273c$export$2e2bcd8739ae039,
    user_details: $5b94b5736f82375f$export$2e2bcd8739ae039,
    contact: $7c110e837f47fc58$export$2e2bcd8739ae039,
    sign_in_exp: $c489d1443dd328ad$export$2e2bcd8739ae039,
    dashboard: $65870f9375ef7fc3$export$2e2bcd8739ae039,
    logs: $d3d5b5f42d55ab16$export$2e2bcd8739ae039,
    log_details: $5532a03587426ff0$export$2e2bcd8739ae039,
    session_expired: $c66dd7115e4a1e96$export$2e2bcd8739ae039,
    welcome: $a4cbe86ae5f4e26b$export$2e2bcd8739ae039,
    roles: $9231b9bd6d8d058a$export$2e2bcd8739ae039,
    role_details: $f4eef9be483a64a9$export$2e2bcd8739ae039,
    permissions: $d84bfedea0694de2$export$2e2bcd8739ae039,
    cloud: $dcdaab7b21e44e47$export$2e2bcd8739ae039,
    profile: $b70e0efc8fd1be21$export$2e2bcd8739ae039,
    components: $caa796cb4f52c8f6$export$2e2bcd8739ae039,
    webhooks: $d991c3ca128c35f3$export$2e2bcd8739ae039,
    webhook_details: $f1b85e525828b33c$export$2e2bcd8739ae039,
    domain: $cddf12b8cd6380ff$export$2e2bcd8739ae039,
    tenants: $eee67bc591cca691$export$2e2bcd8739ae039,
    tenant_members: $feaa1919a942baed$export$2e2bcd8739ae039,
    topbar: $56a1d427e3c86044$export$2e2bcd8739ae039,
    subscription: $e94bde71537d60c7$export$2e2bcd8739ae039,
    upsell: $9f2b7af8994bff9a$export$2e2bcd8739ae039,
    guide: $50c444e331e06f95$export$2e2bcd8739ae039,
    mfa: $7649d2091fc8be27$export$2e2bcd8739ae039,
    organizations: $590f30097268b07f$export$2e2bcd8739ae039,
    organization_details: $822147bb4287c1c3$export$2e2bcd8739ae039,
    protected_app: $2b41369265e114a4$export$2e2bcd8739ae039,
    jwt_claims: $f0490263f21fc8c1$export$2e2bcd8739ae039,
    invitation: $374cfc38a5421b43$export$2e2bcd8739ae039,
    signing_keys: $68d61f3d598416e2$export$2e2bcd8739ae039,
    organization_template: $7464860111bd7e70$export$2e2bcd8739ae039,
    organization_role_details: $994bfa9afb1a08b2$export$2e2bcd8739ae039
};
var $d94a86ba3334d158$export$2e2bcd8739ae039 = Object.freeze($d94a86ba3334d158$var$admin_console);


const $e839632d0cf7d947$var$demo_app = {
    title: "Вы успешно вошли в живой просмотр!",
    subtitle: "Вот ваши данные для входа:",
    username: "Имя пользователя: ",
    user_id: "Идентификатор пользователя: ",
    sign_out: "Выйти из живого просмотра",
    continue_explore: "Или продолжить исследование",
    customize_sign_in_experience: "Настройте опыт входа в систему",
    enable_passwordless: "Включить безпарольный вход",
    add_social_connector: "Добавить социальный коннектор"
};
var $e839632d0cf7d947$export$2e2bcd8739ae039 = Object.freeze($e839632d0cf7d947$var$demo_app);


const $6b751ec7616f026d$var$oidc = {
    logout_success: "Вы успешно вышли из системы."
};
var $6b751ec7616f026d$export$2e2bcd8739ae039 = Object.freeze($6b751ec7616f026d$var$oidc);


const $1303cea2d352a599$var$translation = {
    admin_console: $d94a86ba3334d158$export$2e2bcd8739ae039,
    demo_app: $e839632d0cf7d947$export$2e2bcd8739ae039,
    oidc: $6b751ec7616f026d$export$2e2bcd8739ae039
};
var $1303cea2d352a599$export$2e2bcd8739ae039 = Object.freeze($1303cea2d352a599$var$translation);


const $bc9372e03e528245$var$ru = {
    translation: $1303cea2d352a599$export$2e2bcd8739ae039,
    errors: $4c204eec5e08003f$export$2e2bcd8739ae039
};
var $bc9372e03e528245$export$2e2bcd8739ae039 = Object.freeze($bc9372e03e528245$var$ru);


const $75c8d9b53f39794c$var$application = {
    invalid_type: "Sadece makine ile makine uygulamaları rollerle ilişkilendirilebilir.",
    role_exists: "Bu uygulamaya zaten {{roleId}} kimlikli bir rol eklenmiş.",
    invalid_role_type: "Kullanıcı tipi rol\xfc makine ile makine uygulamasına atayamaz.",
    invalid_third_party_application_type: "Sadece geleneksel web uygulamaları \xfc\xe7\xfcnc\xfc taraf uygulaması olarak işaretlenebilir.",
    third_party_application_only: "Bu \xf6zellik sadece \xfc\xe7\xfcnc\xfc taraf uygulamalar i\xe7in ge\xe7erlidir.",
    user_consent_scopes_not_found: "Ge\xe7ersiz kullanıcı onay kapsamları.",
    consent_management_api_scopes_not_allowed: "Y\xf6netim API kapsamları izin verilmiyor.",
    protected_app_metadata_is_required: "Korunan uygulama meta verileri gereklidir.",
    protected_app_not_configured: "Korunan uygulama sağlayıcısı yapılandırılmamıştır. Bu \xf6zellik a\xe7ık kaynak s\xfcr\xfcm\xfc i\xe7in mevcut değil.",
    cloudflare_unknown_error: "Cloudflare API isteği sırasında bilinmeyen hata alındı",
    protected_application_only: "\xd6zellik sadece korunan uygulamalar i\xe7in ge\xe7erlidir.",
    protected_application_misconfigured: "Korunan uygulama yanlış yapılandırılmış.",
    protected_application_subdomain_exists: "Korunan uygulama alt alan adı zaten kullanımda.",
    invalid_subdomain: "Ge\xe7ersiz alt alan adı.",
    custom_domain_not_found: "\xd6zel domain bulunamadı.",
    should_delete_custom_domains_first: "\xd6zel domainleri \xf6nce silmelisiniz."
};
var $75c8d9b53f39794c$export$2e2bcd8739ae039 = Object.freeze($75c8d9b53f39794c$var$application);


const $55c91be25e1621d1$var$auth = {
    authorization_header_missing: "Yetkilendirme başlığı eksik.",
    authorization_token_type_not_supported: "Yetkilendirme tipi desteklenmiyor.",
    unauthorized: "Yetki yok. L\xfctfen kimlik bilgilerini ve kapsamını kontrol edin.",
    forbidden: "Yasak. L\xfctfen kullanıcı rollerinizi ve izinlerinizi kontrol edin.",
    expected_role_not_found: "Expected role not found. Please check your user roles and permissions.",
    jwt_sub_missing: "JWTde `sub` eksik.",
    require_re_authentication: "Korumalı bir işlem ger\xe7ekleştirmek i\xe7in yeniden doğrulama gereklidir."
};
var $55c91be25e1621d1$export$2e2bcd8739ae039 = Object.freeze($55c91be25e1621d1$var$auth);


const $8272743d5d5937c6$var$connector = {
    general: "Bağdaştırıcıda bir hata oluştu: {{errorDescription}}",
    not_found: "{{type}} tipi i\xe7in uygun bağlayıcı bulunamadı.",
    not_enabled: "Bağlayıcı etkin değil.",
    invalid_metadata: "Bağlayıcının meta verileri ge\xe7ersizdir.",
    invalid_config_guard: "Bağlayıcının yapılandırma koruyucusu ge\xe7ersizdir.",
    unexpected_type: "Bağlayıcının t\xfcr\xfc beklenmedik.",
    invalid_request_parameters: "İstek yanlış girdi parametreleri ile g\xf6nderildi.",
    insufficient_request_parameters: "İstek, bazı input parametrelerini atlayabilir.",
    invalid_config: "Bağlayıcının ayarları ge\xe7ersiz.",
    invalid_certificate: "Bağlayıcının sertifikası ge\xe7ersiz, l\xfctfen sertifikasının PEM kodlamasında olduğundan emin olun.",
    invalid_response: "Bağlayıcının yanıtı ge\xe7ersiz.",
    template_not_found: "Bağlayıcı yapılandırmasında doğru şablon bulunamıyor.",
    template_not_supported: "Bağlayıcı bu şablon t\xfcr\xfcn\xfc desteklemiyor.",
    rate_limit_exceeded: "Tetikleyici oran sınırına ulaşıldı. L\xfctfen daha sonra tekrar deneyin.",
    not_implemented: "{{method}}: hen\xfcz uygulanmadı.",
    social_invalid_access_token: "Bağlayıcının erişim belirteci ge\xe7ersiz.",
    invalid_auth_code: "Bağlayıcının yetki kodu ge\xe7ersiz.",
    social_invalid_id_token: "Bağlayıcının kimliği ge\xe7ersiz.",
    authorization_failed: "Kullanıcının yetkilendirme işlemi başarısız oldu.",
    social_auth_code_invalid: "Erişim belirtici alınamıyor, l\xfctfen yetkilendirme kodunu kontrol edin.",
    more_than_one_sms: "SMS bağlayıcılarının sayısı 1'den fazla.",
    more_than_one_email: "E-posta adresi bağlayıcılarının sayısı 1'den fazla.",
    more_than_one_connector_factory: "Birden fazla bağlayıcı fabrikası bulundu ({{connectorIds}} ID numarasıyla), gereksiz olanları kaldırabilirsiniz.",
    db_connector_type_mismatch: "Dbde t\xfcrle eşleşmeyen bir bağlayıcı var.",
    not_found_with_connector_id: "Belirtilen standart bağlayıcı kimliğiyle bağlayıcı bulunamadı.",
    multiple_instances_not_supported: "Se\xe7ilen standart bağlayıcı ile birden fazla \xf6rnek oluşturulamaz.",
    invalid_type_for_syncing_profile: "Kullanıcı profili yalnızca sosyal bağlayıcılarla senkronize edilebilir.",
    can_not_modify_target: "'Hedef' bağlayıcı değiştirilemez.",
    should_specify_target: "'Hedef' belirtilmelidir.",
    multiple_target_with_same_platform: "Aynı hedefe ve platforma sahip birden fazla sosyal bağlayıcıya sahip olamazsınız.",
    cannot_overwrite_metadata_for_non_standard_connector: "Bu bağlayıcının 'metadata'sı \xfczerine yazılamaz."
};
var $8272743d5d5937c6$export$2e2bcd8739ae039 = Object.freeze($8272743d5d5937c6$var$connector);


const $61a1595ddbc2e92f$var$domain = {
    not_configured: "Alan adı ana bilgisayar sağlayıcısı yapılandırılmamış.",
    cloudflare_data_missing: "cloudflare_data eksik, l\xfctfen kontrol edin.",
    cloudflare_unknown_error: "Cloudflare API isteği yapılırken bilinmeyen bir hata oluştu.",
    cloudflare_response_error: "Cloudflare’dan beklenmeyen bir yanıt alındı.",
    limit_to_one_domain: "Sadece bir \xf6zel alan adınız olabilir.",
    hostname_already_exists: "Bu alan adı sunucumuzda zaten mevcut.",
    cloudflare_not_found: "Cloudflare'da alan adı bulunamadı.",
    domain_is_not_allowed: "Bu alan adı izin verilen değildir."
};
var $61a1595ddbc2e92f$export$2e2bcd8739ae039 = Object.freeze($61a1595ddbc2e92f$var$domain);


const $e4b084550e5d15bf$var$entity = {
    invalid_input: "Ge\xe7ersiz giriş. Değer listesi boş olmamalıdır.",
    create_failed: "{{name}} oluşturulamadı.",
    db_constraint_violated: "Veritabanı kısıtı ihlal edildi.",
    not_exists: "{{name}} mevcut değil.",
    not_exists_with_id: " `{{id}}` id kimliğine sahip {{name}} mevcut değil.",
    not_found: "Kaynak mevcut değil.",
    relation_foreign_key_not_found: "Bir veya daha fazla yabancı anahtar bulunamıyor. L\xfctfen girişi kontrol edin ve t\xfcm referans edilen varlıkların var olduğundan emin olun.",
    unique_integrity_violation: "Varlık zaten mevcut. L\xfctfen girişi kontrol edin ve tekrar deneyin."
};
var $e4b084550e5d15bf$export$2e2bcd8739ae039 = Object.freeze($e4b084550e5d15bf$var$entity);


const $16fed6015bc54369$var$guard = {
    invalid_input: "İstek {{type}} ge\xe7ersiz.",
    invalid_pagination: "İstenen sayfalandırma değeri ge\xe7ersiz.",
    can_not_get_tenant_id: "İstekten kiracı kimliği alınamadı.",
    file_size_exceeded: "Dosya boyutu aşıldı.",
    mime_type_not_allowed: "MIME t\xfcr\xfc izin verilmiyor."
};
var $16fed6015bc54369$export$2e2bcd8739ae039 = Object.freeze($16fed6015bc54369$var$guard);


const $263af8799a1ad7bc$var$hook = {
    missing_events: "En az bir etkinlik sağlamanız gerekiyor.",
    send_test_payload_failed: "Test y\xfck\xfc g\xf6nderilemedi: {{message}}",
    endpoint_responded_with_error: "Nokta yanıt verdi hatayla."
};
var $263af8799a1ad7bc$export$2e2bcd8739ae039 = Object.freeze($263af8799a1ad7bc$var$hook);


const $fb767ac307a6f55b$var$jwt_customizer = {
    general: "JWT belirteci \xf6zelleştirilirken bir hata oluştu. L\xfctfen daha sonra tekrar deneyin.",
    can_not_create_for_admin_tenant: "Y\xf6netici kiracı i\xe7in bir JWT belirteci \xf6zelleştirelemez."
};
var $fb767ac307a6f55b$export$2e2bcd8739ae039 = Object.freeze($fb767ac307a6f55b$var$jwt_customizer);


const $8e2210e7d11627bb$var$localization = {
    cannot_delete_default_language: "{{languageTag}} varsayılan dil olarak ayarlanmıştır ve silinemez.",
    invalid_translation_structure: "Ge\xe7ersiz veri şemaları. L\xfctfen girdilerinizi kontrol edin ve tekrar deneyin."
};
var $8e2210e7d11627bb$export$2e2bcd8739ae039 = Object.freeze($8e2210e7d11627bb$var$localization);


const $392f6ca4e56a6712$var$log = {
    invalid_type: "Ge\xe7ersiz g\xfcnl\xfck t\xfcr\xfc."
};
var $392f6ca4e56a6712$export$2e2bcd8739ae039 = Object.freeze($392f6ca4e56a6712$var$log);


const $16235597cdd6e484$var$oidc = {
    aborted: "Son kullanıcı etkileşimi iptal etti.",
    invalid_scope: "Kapsam ge\xe7ersiz: {{error_description}}.",
    invalid_token: "Sağlanan belirte\xe7 ge\xe7ersiz.",
    invalid_client_metadata: "Sağlanan istemci meta verisi ge\xe7ersiz.",
    insufficient_scope: "Token'ın `{{scope}}` kapsamı eksik.",
    invalid_request: "Ge\xe7ersiz istek.",
    invalid_grant: "Ge\xe7ersiz hibe.",
    invalid_redirect_uri: "Sağlanan `redirect_uri`, istemcilerin kayıtlı `redirect_uris`'lerinden hi\xe7biriyle eşleşmiyor",
    access_denied: "Erişim reddedildi.",
    invalid_target: "Ge\xe7ersiz hedef.",
    unsupported_grant_type: "Desteklenmeyen `grant_type` isteği.",
    unsupported_response_mode: "Desteklenmeyen `response_mode` isteği.",
    unsupported_response_type: "Desteklenmeyen `response_type` isteği.",
    provider_error: "Dahili OIDC Hatası: {{message}}.",
    server_error: "Bilinmeyen bir OIDC hatası oluştu. L\xfctfen daha sonra tekrar deneyin.",
    provider_error_fallback: "Bir OIDC hatası oluştu: {{code}}.",
    key_required: "En az bir anahtar gereklidir.",
    key_not_found: "ID'si {{id}} olan anahtar bulunamadı."
};
var $16235597cdd6e484$export$2e2bcd8739ae039 = Object.freeze($16235597cdd6e484$var$oidc);


const $c7304cc9134aeaaf$var$organization = {
    require_membership: "Kullanıcının devam etmek i\xe7in organizasyonun bir \xfcyesi olması gerekir."
};
var $c7304cc9134aeaaf$export$2e2bcd8739ae039 = Object.freeze($c7304cc9134aeaaf$var$organization);


const $542b9b743f89f4e0$var$password = {
    unsupported_encryption_method: "{{name}} şifreleme metodu desteklenmiyor.",
    pepper_not_found: "Şifre pepperı bulunamadı. L\xfctfen core envs.i kontrol edin.",
    rejected: "Şifre reddedildi. L\xfctfen şifrenizin gereksinimleri karşıladığından emin olun."
};
var $542b9b743f89f4e0$export$2e2bcd8739ae039 = Object.freeze($542b9b743f89f4e0$var$password);


const $2d6b448a946929dc$var$request = {
    invalid_input: "Girdi ge\xe7ersiz. {{details}}",
    general: "İstek hatası oluştu."
};
var $2d6b448a946929dc$export$2e2bcd8739ae039 = Object.freeze($2d6b448a946929dc$var$request);


const $5d1134c46ba3630d$var$resource = {
    resource_identifier_in_use: "API tanımlayıcısı {{indicator}} zaten kullanımda",
    cannot_delete_management_api: "Logto y\xf6netim API'sini silemezsiniz.",
    cannot_modify_management_api: "Logto y\xf6netim API'sini değiştiremezsiniz."
};
var $5d1134c46ba3630d$export$2e2bcd8739ae039 = Object.freeze($5d1134c46ba3630d$var$resource);


const $dd4cc076468d2f97$var$role = {
    name_in_use: "Bu rol adı {{name}} zaten kullanımda",
    scope_exists: "Bu kapsam kimliği {{scopeId}} zaten bu role eklendi",
    management_api_scopes_not_assignable_to_user_role: "Kullanıcı rol\xfcne y\xf6netim API kapsamları atanamaz.",
    user_exists: "Bu kullanıcı kimliği {{userId}} zaten bu role eklendi",
    application_exists: "Bu uygulama kimliği {{applicationId}} zaten bu role eklendi",
    default_role_missing: "Varsayılan rol adlarından bazıları veritabanında mevcut değil, l\xfctfen \xf6nce rolleri oluşturduğunuzdan emin olun",
    internal_role_violation: 'Logto tarafından yasaklanan dahili bir rol\xfc g\xfcncelleme veya silmeye \xe7alışıyor olabilirsiniz. Yeni bir rol oluşturuyorsanız, "#internal:" ile başlamayan başka bir isim deneyin.'
};
var $dd4cc076468d2f97$export$2e2bcd8739ae039 = Object.freeze($dd4cc076468d2f97$var$role);


const $98e20d6b22b6a48c$var$scope = {
    name_exists: "Bu kapsam adı {{name}} zaten kullanımda",
    name_with_space: "Kapsam adı boşluk i\xe7eremez."
};
var $98e20d6b22b6a48c$export$2e2bcd8739ae039 = Object.freeze($98e20d6b22b6a48c$var$scope);


const $c864b6ced1d28c87$var$session = {
    not_found: "Oturum bulunamadı. L\xfctfen geri d\xf6n\xfcp giriş yapınız.",
    invalid_credentials: "Ge\xe7ersiz kimlik bilgileri. L\xfctfen girdinizi kontrol ediniz.",
    invalid_sign_in_method: "Ge\xe7erli oturum a\xe7ma y\xf6ntemi kullanılamıyor.",
    invalid_connector_id: "{{connectorId}} idsi ile kullanılabilir bağlayıcı bulunamıyor.",
    insufficient_info: "Yetersiz oturum a\xe7ma bilgisi.",
    connector_id_mismatch: "connectorId, oturum kaydı ile eşleşmiyor.",
    connector_session_not_found: "Bağlayıcı oturum bulunamadı. L\xfctfen geri d\xf6n\xfcp tekrardan giriş yapınız.",
    verification_session_not_found: "Doğrulama başarısız oldu. L\xfctfen doğrulama işlemini yeniden başlatın ve tekrar deneyin.",
    verification_expired: "Bağlantı zaman aşımına uğradı. Hesap g\xfcvenliğiniz i\xe7in yeniden doğrulama yapın.",
    verification_blocked_too_many_attempts: "Too many attempts in a short time. Please try again {{relativeTime}}.",
    unauthorized: "L\xfctfen \xf6nce oturum a\xe7ın.",
    unsupported_prompt_name: "Desteklenmeyen prompt adı.",
    forgot_password_not_enabled: "Parolamı unuttum \xf6zelliği etkin değil.",
    verification_failed: "Doğrulama başarısız oldu. L\xfctfen doğrulama işlemini yeniden başlatın ve tekrar deneyin.",
    connector_validation_session_not_found: "Token doğrulama i\xe7in bağlayıcı oturumu bulunamadı.",
    identifier_not_found: "Kullanıcı kimliği bulunamadı. L\xfctfen geri gidin ve yeniden giriş yapın.",
    interaction_not_found: "Etkileşim oturumu bulunamadı. L\xfctfen geri gidin ve oturumu yeniden başlatın.",
    not_supported_for_forgot_password: "This operation is not supported for forgot password.",
    mfa: {
        require_mfa_verification: "Mfa verification is required to sign in.",
        mfa_sign_in_only: "Mfa is only available for sign-in interaction.",
        pending_info_not_found: "Pending MFA info not found, please initiate MFA first.",
        invalid_totp_code: "Invalid TOTP code.",
        webauthn_verification_failed: "WebAuthn verification failed.",
        webauthn_verification_not_found: "WebAuthn verification not found.",
        bind_mfa_existed: "MFA already exists.",
        backup_code_can_not_be_alone: "Backup code can not be the only MFA.",
        backup_code_required: "Backup code is required.",
        invalid_backup_code: "Invalid backup code.",
        mfa_policy_not_user_controlled: "MFA policy is not user controlled."
    },
    sso_enabled: "Bu e-posta i\xe7in tek oturum a\xe7ma etkin. L\xfctfen SSO ile oturum a\xe7ın."
};
var $c864b6ced1d28c87$export$2e2bcd8739ae039 = Object.freeze($c864b6ced1d28c87$var$session);


const $be78073dab12303d$var$sign_in_experiences = {
    empty_content_url_of_terms_of_use: "Kullanım Koşulları İ\xe7erik URL'i yok. L\xfctfen Kullanım Koşulları etkinse i\xe7erik URL'i ekleyiniz.",
    empty_social_connectors: "Sosyal bağlayıcılar yok. Sosyal oturum a\xe7ma y\xf6ntemi etkinleştirildiğinde l\xfctfen etkin sosyal bağlayıcıları ekleyiniz.",
    enabled_connector_not_found: "Etkin {{type}} bağlayıcı bulunamadı.",
    not_one_and_only_one_primary_sign_in_method: "Yalnızca bir tane birincil oturum a\xe7ma y\xf6ntemi olmalıdır. L\xfctfen inputu kontrol ediniz.",
    username_requires_password: "Kullanıcı adı kayıt kimliği i\xe7in bir şifre belirlemek zorunludur.",
    passwordless_requires_verify: "E-posta/telefon kayıt kimliği i\xe7in doğrulama etkinleştirilmelidir.",
    miss_sign_up_identifier_in_sign_in: "Oturum a\xe7ma y\xf6ntemleri, kayıt kimliğini i\xe7ermelidir.",
    password_sign_in_must_be_enabled: "Kayıtta şifre belirleme zorunlu olduğunda şifreyle oturum a\xe7ma etkinleştirilmelidir.",
    code_sign_in_must_be_enabled: "Kayıtta şifre belirleme zorunlu olmadığında doğrulama koduyla oturum a\xe7ma etkinleştirilmelidir.",
    unsupported_default_language: "Bu dil - {{language}}, şu anda desteklenmemektedir.",
    at_least_one_authentication_factor: "En az bir doğrulama fakt\xf6r\xfc se\xe7melisiniz.",
    backup_code_cannot_be_enabled_alone: "Yedek kod yalnız başına etkinleştirilemez.",
    duplicated_mfa_factors: "Yinelenen MFA fakt\xf6rleri."
};
var $be78073dab12303d$export$2e2bcd8739ae039 = Object.freeze($be78073dab12303d$var$sign_in_experiences);


const $4a51a38c4ae4deb3$var$single_sign_on = {
    forbidden_domains: "Genel e-posta alanı domainleri izin verilmiyor.",
    duplicated_domains: "Yinelenmiş domainler bulunmaktadır.",
    invalid_domain_format: "Ge\xe7ersiz domain formatı.",
    duplicate_connector_name: "Bağlayıcı adı zaten var. L\xfctfen farklı bir ad se\xe7in."
};
var $4a51a38c4ae4deb3$export$2e2bcd8739ae039 = Object.freeze($4a51a38c4ae4deb3$var$single_sign_on);


const $9f52171c3f5a1b94$var$storage = {
    not_configured: "Depolama sağlayıcısı yapılandırılmamış.",
    missing_parameter: "Depolama sağlayıcısı i\xe7in eksik parametre {{parameter}}.",
    upload_error: "Dosya y\xfcklenemedi."
};
var $9f52171c3f5a1b94$export$2e2bcd8739ae039 = Object.freeze($9f52171c3f5a1b94$var$storage);


const $df6f44c52fb58b10$var$subscription = {
    limit_exceeded: "Abonelik planınızın limitine ulaştınız.",
    get_plan_failed: "Abonelik planınızı almak i\xe7in başarısız oldu.",
    tenant_suspended: "Kiracı askıya alındı. L\xfctfen y\xf6neticinize başvurun."
};
var $df6f44c52fb58b10$export$2e2bcd8739ae039 = Object.freeze($df6f44c52fb58b10$var$subscription);


const $7957a667325d5064$var$swagger = {
    invalid_zod_type: "Ge\xe7ersiz Zod tipi. L\xfctfen y\xf6nlendirici koruma yapılandırmasını kontrol ediniz.",
    not_supported_zod_type_for_params: "Parametreler i\xe7in desteklenmeyen Zod tipi. L\xfctfen y\xf6nlendirici koruma yapılandırmasını kontrol ediniz."
};
var $7957a667325d5064$export$2e2bcd8739ae039 = Object.freeze($7957a667325d5064$var$swagger);


const $1dd8933b6b0d889b$var$user = {
    username_already_in_use: "Bu kullanıcı adı zaten kullanımda.",
    email_already_in_use: "Bu e-posta mevcut bir hesapla ilişkilendirilmiştir.",
    phone_already_in_use: "Bu telefon numarası mevcut bir hesapla ilişkilendirilmiştir.",
    invalid_email: "Ge\xe7ersiz e-posta adresi.",
    invalid_phone: "Ge\xe7ersiz telefon numarası.",
    email_not_exist: "E-posta adresi hen\xfcz kaydedilmedi.",
    phone_not_exist: "Telefon numarası hen\xfcz kaydedilmedi",
    identity_not_exist: "Sosyal platform hesabı hen\xfcz kaydedilmedi.",
    identity_already_in_use: "Sosyal platform hesabı kaydedildi.",
    social_account_exists_in_profile: "Bu sosyal hesap zaten ilişkilendirilmiş.",
    cannot_delete_self: "Kendinizi silemezsiniz.",
    sign_up_method_not_enabled: "Bu kayıt y\xf6ntemi etkin değil.",
    sign_in_method_not_enabled: "Bu oturum a\xe7ma y\xf6ntemi etkin değil.",
    same_password: "Yeni şifre, eski şifrenizle aynı olamaz.",
    password_required_in_profile: "Oturum a\xe7madan \xf6nce bir şifre belirlemeniz gerekiyor.",
    new_password_required_in_profile: "Yeni bir şifre belirlemeniz gerekiyor.",
    password_exists_in_profile: "Şifre profilinizde zaten mevcut.",
    username_required_in_profile: "Oturum a\xe7madan \xf6nce bir kullanıcı adı belirlemeniz gerekiyor.",
    username_exists_in_profile: "Kullanıcı adı profilinizde zaten mevcut.",
    email_required_in_profile: "Oturum a\xe7madan \xf6nce bir e-posta adresi eklemeniz gerekiyor.",
    email_exists_in_profile: "Profiliniz zaten bir e-posta adresi ile ilişkilendirilmiştir.",
    phone_required_in_profile: "Oturum a\xe7madan \xf6nce bir telefon numarası eklemeniz gerekiyor.",
    phone_exists_in_profile: "Profiliniz zaten bir telefon numarası ile ilişkilendirilmiştir.",
    email_or_phone_required_in_profile: "Oturum a\xe7madan \xf6nce bir e-posta adresi veya telefon numarası eklemeniz gerekiyor.",
    suspended: "Bu hesap askıya alındı.",
    user_not_exist: "{{identifier}} kimliğine sahip kullanıcı mevcut değil.",
    missing_profile: "Oturum a\xe7madan \xf6nce ek bilgi sağlamanız gerekiyor.",
    role_exists: "{{roleId}} rol kimliği bu kullanıcıya zaten eklenmiştir.",
    invalid_role_type: "Ge\xe7ersiz rol t\xfcr\xfc, makine-makine rol\xfc kullanıcıya atanamaz.",
    missing_mfa: "Oturum a\xe7madan \xf6nce ekstra MFA bağlamanız gerekiyor.",
    totp_already_in_use: "TOTP zaten kullanımda.",
    backup_code_already_in_use: "Yedek kod zaten kullanımda.",
    password_algorithm_required: "Şifre algoritması gereklidir.",
    password_and_digest: "D\xfcz metin şifresini ve şifre \xf6zetini aynı anda belirleyemezsiniz."
};
var $1dd8933b6b0d889b$export$2e2bcd8739ae039 = Object.freeze($1dd8933b6b0d889b$var$user);


const $441bebd87867bb5f$var$verification_code = {
    phone_email_empty: "Telefon ve e-posta alanları boş.",
    not_found: "Doğrulama kodu bulunamadı. L\xfctfen \xf6nce doğrulama kodu g\xf6nderin.",
    phone_mismatch: "Telefon eşleşmiyor. L\xfctfen yeni bir doğrulama kodu isteyin.",
    email_mismatch: "E-posta eşleşmiyor. L\xfctfen yeni bir doğrulama kodu isteyin.",
    code_mismatch: "Ge\xe7ersiz doğrulama kodu.",
    expired: "Doğrulama kodu s\xfcresi dolmuştur. L\xfctfen yeni bir doğrulama kodu isteyin.",
    exceed_max_try: "Doğrulama kodu deneme sınırı aşıldı. L\xfctfen yeni bir doğrulama kodu isteyin."
};
var $441bebd87867bb5f$export$2e2bcd8739ae039 = Object.freeze($441bebd87867bb5f$var$verification_code);


const $896bf99d747efcd1$var$errors = {
    request: $2d6b448a946929dc$export$2e2bcd8739ae039,
    auth: $55c91be25e1621d1$export$2e2bcd8739ae039,
    guard: $16fed6015bc54369$export$2e2bcd8739ae039,
    oidc: $16235597cdd6e484$export$2e2bcd8739ae039,
    user: $1dd8933b6b0d889b$export$2e2bcd8739ae039,
    password: $542b9b743f89f4e0$export$2e2bcd8739ae039,
    session: $c864b6ced1d28c87$export$2e2bcd8739ae039,
    connector: $8272743d5d5937c6$export$2e2bcd8739ae039,
    verification_code: $441bebd87867bb5f$export$2e2bcd8739ae039,
    sign_in_experiences: $be78073dab12303d$export$2e2bcd8739ae039,
    jwt_customizer: $fb767ac307a6f55b$export$2e2bcd8739ae039,
    localization: $8e2210e7d11627bb$export$2e2bcd8739ae039,
    swagger: $7957a667325d5064$export$2e2bcd8739ae039,
    entity: $e4b084550e5d15bf$export$2e2bcd8739ae039,
    log: $392f6ca4e56a6712$export$2e2bcd8739ae039,
    role: $dd4cc076468d2f97$export$2e2bcd8739ae039,
    scope: $98e20d6b22b6a48c$export$2e2bcd8739ae039,
    storage: $9f52171c3f5a1b94$export$2e2bcd8739ae039,
    resource: $5d1134c46ba3630d$export$2e2bcd8739ae039,
    hook: $263af8799a1ad7bc$export$2e2bcd8739ae039,
    domain: $61a1595ddbc2e92f$export$2e2bcd8739ae039,
    subscription: $df6f44c52fb58b10$export$2e2bcd8739ae039,
    application: $75c8d9b53f39794c$export$2e2bcd8739ae039,
    organization: $c7304cc9134aeaaf$export$2e2bcd8739ae039,
    single_sign_on: $4a51a38c4ae4deb3$export$2e2bcd8739ae039
};
var $896bf99d747efcd1$export$2e2bcd8739ae039 = Object.freeze($896bf99d747efcd1$var$errors);


const $1e7ab13a00977c97$var$api_resource_details = {
    page_title: "API Kaynak detayları",
    back_to_api_resources: "API Kaynaklarına geri d\xf6n",
    general_tab: "Genel",
    permissions_tab: "İzinler",
    settings: "Ayarlar",
    settings_description: "API kaynakları, Resource g\xf6stergeleri olarak da bilinir. Genellikle, kaynağın kimliğini temsil eden bir URI formatındaki değişkeni i\xe7erir.",
    management_api_settings_description: "Logto Y\xf6netim API'si, y\xf6neticilerin kimlikle ilgili bir\xe7ok g\xf6revi y\xf6netmelerine, g\xfcvenlik politikalarını uygulamalarına ve y\xf6netmeliklere ve standartlara uyum sağlamalarına olanak tanıyan kapsamlı bir API koleksiyonudur.",
    management_api_notice: "Bu API, Logto varlığını temsil eder ve değiştirilemez veya silinemez. Logto y\xf6netim API'sini \xe7ağırmak i\xe7in makineden makineye bir uygulama oluşturun. <a>Daha fazla bilgi edinin</a>",
    token_expiration_time_in_seconds: "Token sona erme s\xfcresi (saniye)",
    token_expiration_time_in_seconds_placeholder: "Token zaman aşım s\xfcresini giriniz",
    delete_description: "Bu eylem geri alınamaz. API kaynakları kalıcı olarak silinecektir. L\xfctfen onaylamak i\xe7in API kaynak adını <span>{{name}}</span> giriniz.",
    enter_your_api_resource_name: "API kaynak adını giriniz.",
    api_resource_deleted: "{{name}} API kaynağı başarıyla silindi",
    permission: {
        create_button: "İzin Oluştur",
        create_title: "İzin Oluştur",
        create_subtitle: "Bu API tarafından gerektirilen izinleri (kapsamları) tanımlayın.",
        confirm_create: "İzin Oluştur",
        edit_title: "API iznini d\xfczenle",
        edit_subtitle: "API tarafından gereken izinleri (kapsamları) tanımlayın.",
        name: "İzin adı",
        name_placeholder: "read:kaynak",
        forbidden_space_in_name: "İzin adı boşluk i\xe7ermemelidir.",
        description: "A\xe7ıklama",
        description_placeholder: "Kaynakları okuyabilir.",
        permission_created: "{{name}} İzni başarıyla oluşturuldu.",
        delete_description: "Bu izin silinirse, bu iznin sağladığı erişimi alan kullanıcı da erişimi kaybedecektir.",
        deleted: '"{{name}}" izni başarıyla silindi.'
    }
};
var $1e7ab13a00977c97$export$2e2bcd8739ae039 = Object.freeze($1e7ab13a00977c97$var$api_resource_details);


const $cc86108e59b08891$var$api_resources = {
    page_title: "API Kaynakları",
    title: "API Kaynakları",
    subtitle: "Yetkili uygulamalarınızdan kullanabileceğiniz API'leri tanımlayınız",
    create: "API Kaynağı oluştur",
    api_name: "API Adı",
    api_name_placeholder: "API adını giriniz",
    api_identifier: "API Identifier",
    api_identifier_placeholder: "https://your-api-identifier/",
    api_identifier_tip: "Api kaynağına \xf6zg\xfcn belirte\xe7. Mutlak URI olmalı ve par\xe7a bileşeni (#) i\xe7ermemeli. OAuth 2.0deki <a>kaynak parametresine</a> eşittir.",
    default_api: "Varsayılan API",
    default_api_label: "Mandant başına sadece sıfır veya bir varsayılan API ayarlanabilir. Varsayılan bir API belirlendiğinde, auth isteğindeki kaynak parametresi \xe7ıkarılabilir. Sonraki token değişimlerinde varsayılan olarak bu API hedef alınarak JWTler oluşturulur. <a>Daha fazla bilgi edinin</a>",
    api_resource_created: "{{name}} API kaynağı başarıyla oluşturuldu",
    invalid_resource_indicator_format: "API indicator must be a valid absolute URI."
};
var $cc86108e59b08891$export$2e2bcd8739ae039 = Object.freeze($cc86108e59b08891$var$api_resources);


const $70f58986885fc354$var$application_details = {
    page_title: "Uygulama detayları",
    back_to_applications: "Uygulamalara geri d\xf6n",
    check_guide: "Kılavuza G\xf6z At",
    settings: "Ayarlar",
    settings_description: 'Bir "Uygulama", kullanıcı bilgilerine erişebilen veya bir kullanıcı adına hareket edebilen kayıtlı bir yazılım veya hizmettir. Uygulamalar, Kimin Logto\'dan ne istediğini tanımaya yardımcı olur ve giriş yapma ve izinleri işlemek i\xe7in yardımcı olur. Kimlik doğrulaması i\xe7in gerekli alanları doldurun.',
    integration: "Entegrasyon",
    integration_description: "Cloudflare'ın kenar ağı tarafından desteklenen ve d\xfcnya \xe7apında en \xfcst d\xfczey performans ve 0ms soğuk başlangı\xe7larla Logto g\xfcvenli \xe7alışanlarla dağıtım yapın.",
    service_configuration: "Hizmet yapılandırması",
    service_configuration_description: "Servisinizde gerekli yapılandırmaları tamamlayın.",
    session: "Oturum",
    endpoints_and_credentials: "Bitiş Noktaları ve Kimlik Bilgileri",
    endpoints_and_credentials_description: "Uygulamanızda OIDC bağlantısını kurmak i\xe7in aşağıdaki bitiş noktalarını ve kimlik bilgilerini kullanın.",
    refresh_token_settings: "Yenileme belirteci",
    refresh_token_settings_description: "Bu uygulama i\xe7in yenileme belirteci kurallarını y\xf6netin.",
    application_roles: "Roller",
    machine_logs: "Makine g\xfcnl\xfckleri",
    application_name: "Uygulama Adı",
    application_name_placeholder: "Uygulamam",
    description: "A\xe7ıklama",
    description_placeholder: "Uygulama a\xe7ıklamasını giriniz",
    config_endpoint: "OpenID Sağlayıcı yapılandırma bitiş noktası",
    authorization_endpoint: "Yetkilendirme bitiş noktası",
    authorization_endpoint_tip: "Kimlik doğrulama ve yetkilendirme i\xe7in bir bitiş noktası. OpenID Connect <a>Authentication</a> i\xe7in kullanılır.",
    show_endpoint_details: "Bitiş noktası ayrıntılarını g\xf6ster",
    hide_endpoint_details: "Bitiş noktası ayrıntılarını gizle",
    logto_endpoint: "Logto bitiş noktası",
    application_id: "Uygulama IDsi",
    application_id_tip: 'Genellikle Logto tarafından oluşturulan benzersiz bir uygulama tanımlayıcısıdır. Ayrıca OpenID Connect "client_id" anlamına gelir.',
    application_secret: "Uygulama Sırrı",
    redirect_uri: "Y\xf6nlendirme URIı",
    redirect_uris: "Y\xf6nlendirme URIları",
    redirect_uri_placeholder: "https://siteniz.com/uygulama",
    redirect_uri_placeholder_native: "io.logto://callback",
    redirect_uri_tip: "Kullanıcının oturum a\xe7ma işlemi tamamlandıktan sonra (başarılı olsa da olmasa da) y\xf6nlendirilen bir URI. Daha fazla bilgi i\xe7in OpenID Connect <a>AuthRequesta</a> bakınız.",
    post_sign_out_redirect_uri: "Oturumdan \xc7ıkış sonrası y\xf6nlendirme URIı",
    post_sign_out_redirect_uris: "Oturumdan \xc7ıkış sonrası y\xf6nlendirme URIları",
    post_sign_out_redirect_uri_placeholder: "https://siteniz.com/anasayfa",
    post_sign_out_redirect_uri_tip: "URI, Oturumdan \xc7ıkış sonrası y\xf6nlendirme yapar (isteğe bağlıdır). Bazı uygulama t\xfcrlerinde pratik bir etkisi olmayabilir.",
    cors_allowed_origins: "CORS izinli originler",
    cors_allowed_origins_placeholder: "https://siteniz.com",
    cors_allowed_origins_tip: "Varsayılan olarak, Y\xf6nlendirme URIlerinin t\xfcm originlerine izin verilir. Genellikle bu alan i\xe7in herhangi bir işlem gerekmez. Ayrıntılı bilgi i\xe7in <a>MDN doc</a> sayfasına bakın.",
    token_endpoint: "Belirte\xe7 bitiş noktası",
    user_info_endpoint: "Kullanıcı bilgileri bitiş noktası",
    enable_admin_access: "Y\xf6netici erişimini etkinleştir",
    enable_admin_access_label: "Y\xf6netim API erişimine izin verme veya engel. Etkinleştirildikten sonra, bu uygulama adına y\xf6netim API'sini \xe7ağırmak i\xe7in erişim belirte\xe7leri kullanabilirsiniz.",
    always_issue_refresh_token: "Her zaman Yenileme Belirteci ver",
    always_issue_refresh_token_label: "Bu yapılandırmayı etkinleştirmek, Logto'nun OpenID Connect ile uyumlu olmayan ve olası sorunlara neden olabilecek her zaman Yenileme Belirteği \xe7ıkarmasına izin verir `prompt=consent` kimlik doğrulama isteğinin sunulup sunulmadığına bakılmaksızın. Ancak, bu uygulama sadece gerekli olduğunda caydırılmayan bir uygulamadır.",
    refresh_token_ttl: "Yenileme Belirteci s\xfcresi (g\xfcn cinsinden)",
    refresh_token_ttl_tip: "Yeni erişim belirteği talepleri i\xe7in Yenileme Belirteği kullanılabilecek s\xfcre. Belirteğin s\xfcresi dolmadan \xf6nce yapılan talepler belirteğin \xf6mr\xfcn\xfc uzatacaktır.",
    rotate_refresh_token: "Yenileme Belirteci değiştir",
    rotate_refresh_token_label: "Bu se\xe7enek etkinleştirildiğinde, Logto Yenileme Belirteği Bitiş S\xfcresinin %70'i ge\xe7ildiğinde veya belirli koşullar sağlandığında yeni bir Yenileme Belirteği verecektir. <a>Daha fazlası i\xe7in tıklayın</a>",
    delete_description: "Bu eylem geri alınamaz. Uygulama kalıcı olarak silinecektir. L\xfctfen onaylamak i\xe7in uygulama adı <span>{{name}}</span> girin.",
    enter_your_application_name: "Uygulama adı giriniz",
    application_deleted: "{{name}} Uygulaması başarıyla silindi",
    redirect_uri_required: "En az 1 y\xf6nlendirme URIı girmelisiniz",
    app_domain_description_1: "{{domain}} destekli Logto ile alanınızı \xf6zg\xfcrce kullanın, bu s\xfcrekli ge\xe7erlidir.",
    app_domain_description_2: "Kalıcı olarak ge\xe7erli olan <domain>{{domain}}</domain> alanınızı \xf6zg\xfcrce kullanabilirsiniz.",
    custom_rules: "\xd6zel kimlik doğrulama kuralları",
    custom_rules_placeholder: "^/(admin|privacy)/.+",
    custom_rules_description: "Kimlik doğrulaması gerektiren rotalar i\xe7in d\xfczenli ifadelerle kurallar belirleyin. Varsayılan: boş bırakılırsa t\xfcm site koruması.",
    authentication_routes: "Kimlik doğrulama rotaları",
    custom_rules_tip: "İki durum senaryosu burada:<ol><li>Sadece '/admin' ve '/privacy' rotalarını kimlik doğrulama ile korumak i\xe7in: ^/(admin|privacy)/.*</li><li>JPG resimlerini kimlik doğrulamadan hari\xe7 tutmak i\xe7in: ^(?!.*\\.jpg$).*$</li></ol>",
    authentication_routes_description: "Belirtilen rotaları kullanarak kimlik doğrulama d\xfcğmesinizi y\xf6nlendirin. Not: Bu rotalar değiştirilemez.",
    protect_origin_server: "Orjın sunucunu koru",
    protect_origin_server_description: "Orjın sunucunuzu doğrudan erişimden korumaya emin olun. Daha fazla <a>a\xe7ıklamalı talimatlar</a> i\xe7in kılavuza bakın.",
    session_duration: "Oturum s\xfcresi (g\xfcn cinsinden)",
    try_it: "Deneyin",
    branding: {
        name: "Markalama",
        description: "Uygulamanızın adını ve logosunu a\xe7ıklama ekranında \xf6zelleştirin.",
        more_info: "Daha fazla bilgi",
        more_info_description: "Uygulamanız hakkında kullanıcılara a\xe7ıklama ekranında daha fazla bilgi sunun.",
        display_name: "Adı g\xf6ster",
        display_logo: "Logoyu g\xf6ster",
        display_logo_dark: "Logoyu g\xf6ster (koyu)",
        terms_of_use_url: "Kullanım Koşulları URLsi",
        privacy_policy_url: "Gizlilik Politikası URLsi"
    },
    permissions: {
        name: "İzinler",
        description: "\xdc\xe7\xfcnc\xfc taraf uygulamanın belirli veri t\xfcrlerine erişim i\xe7in kullanıcı yetkilendirmesi i\xe7in gereken izinleri se\xe7in.",
        user_permissions: "Kişisel kullanıcı verileri",
        organization_permissions: "Organizasyon erişimi",
        table_name: "İzin ver",
        field_name: "İzin",
        field_description: "A\xe7ıklama ekranında g\xf6sterilir",
        delete_text: "İzni kaldır",
        permission_delete_confirm: "Bu işlem, \xfc\xe7\xfcnc\xfc taraf uygulamaya verilen izinleri geri \xe7ekecek ve belirli veri tipleri i\xe7in kullanıcı yetkilendirmesi istemesini engelleyecektir. Devam etmek istediğinizden emin misiniz?",
        permissions_assignment_description: "\xdc\xe7\xfcnc\xfc taraf uygulamanın belirli veri t\xfcrlerine erişim i\xe7in kullanıcı yetkilendirme istediği izinleri se\xe7in.",
        user_profile: "Kullanıcı verileri",
        api_permissions: "API izinleri",
        organization: "Organizasyon izinleri",
        user_permissions_assignment_form_title: "Kullanıcı profili izinlerini ekleyin",
        organization_permissions_assignment_form_title: "Organizasyon izinlerini ekleyin",
        api_resource_permissions_assignment_form_title: "API kaynağı izinlerini ekleyin",
        user_data_permission_description_tips: 'Kişisel kullanıcı veri izinlerinin a\xe7ıklamasını "Oturum A\xe7ma Deneyimi > İ\xe7erik > Dil Y\xf6netimi" aracılığıyla değiştirebilirsiniz.',
        permission_description_tips: "Logto, \xfc\xe7\xfcnc\xfc taraf uygulamalar i\xe7in kimlik sağlayıcı (IdP) olarak kullanıldığında ve kullanıcılardan yetkilendirme istendiğinde, bu a\xe7ıklama a\xe7ıklama ekranında g\xf6r\xfcn\xfcr.",
        user_title: "Kullanıcı",
        user_description: "\xdc\xe7\xfcnc\xfc taraf uygulamanın belirli kullanıcı verilerine erişmek i\xe7in istediği izinleri se\xe7in.",
        grant_user_level_permissions: "Kullanıcı veri izinlerini ver",
        organization_title: "Organizasyon",
        organization_description: "\xdc\xe7\xfcnc\xfc taraf uygulamanın belirli organizasyon verilerine erişmek i\xe7in istediği izinleri se\xe7in.",
        grant_organization_level_permissions: "Organizasyon veri izinlerini ver"
    },
    roles: {
        name_column: "Rol",
        description_column: "A\xe7ıklama",
        assign_button: "Rolleri Ata",
        delete_description: "Bu işlem bu rol\xfc bu makine g\xfcnl\xfcğ\xfcnden kaldıracaktır. Rol kendisi hala var olacak, ancak artık makine-makine uygulamasıyla ilişkilendirilmeyecektir.",
        deleted: "{{name}}, bu kullanıcıdan başarıyla kaldırıldı.",
        assign_title: "{{name}}'a rolleri atayın",
        assign_subtitle: "{{name}} i\xe7in bir veya daha fazla rol yetkilendirin",
        assign_role_field: "Rolleri Ata",
        role_search_placeholder: "Rol adıyla arama yapın",
        added_text: "{{value, number}} eklendi",
        assigned_app_count: "{{value, number}} uygulamalar",
        confirm_assign: "Rolleri Ata",
        role_assigned: "Başarıyla rol(ler) atandı",
        search: "Rol adı, a\xe7ıklaması veya ID'si ile arama yapın",
        empty: "Mevcut rol yok"
    }
};
var $70f58986885fc354$export$2e2bcd8739ae039 = Object.freeze($70f58986885fc354$var$application_details);


const $fc0472b7f0a8cba8$var$applications = {
    page_title: "Uygulamalar",
    title: "Uygulamalar",
    subtitle: "Kimlik doğrulaması i\xe7in Logtoyu kullanmak \xfczere mobil, tek sayfa, machine to machine veya geleneksel bir uygulama ayarlayınız",
    subtitle_with_app_type: "Logto Doğrulamasını {{name}} uygulamanız i\xe7in yapılandırın",
    create: "Uygulama oluştur",
    create_subtitle_third_party: "Logto'yu kimlik sağlayıcısı (IdP) olarak kullanarak \xfc\xe7\xfcnc\xfc taraf uygulamalarla kolayca entegre olun",
    application_name: "Uygulama adı",
    application_name_placeholder: "Uygulamam",
    application_description: "Uygulama a\xe7ıklaması",
    application_description_placeholder: "Uygulama a\xe7ıklaması giriniz",
    select_application_type: "Uygulama tipi se\xe7iniz",
    no_application_type_selected: "Hen\xfcz bir uygulama tipi se\xe7mediniz",
    application_created: "Uygulama başarıyla oluşturuldu.",
    tab: {
        my_applications: "Benim uygulamalarım",
        third_party_applications: "\xdc\xe7\xfcnc\xfc taraf uygulamaları"
    },
    app_id: "Uygulama ID'si",
    type: {
        native: {
            title: "Yerel Uygulama",
            subtitle: "Nativede \xe7alışan bir uygulama ",
            description: "\xd6rneğin, iOS uygulaması, Android uygulaması"
        },
        spa: {
            title: "Tek Sayfalı Uygulama",
            subtitle: "Bir web tarayıcısında \xe7alışan ve verileri yerinde dinamik olarak g\xfcncelleyen bir uygulama",
            description: "\xd6rneğin, React DOM uygulaması, Vue uygulaması"
        },
        traditional: {
            title: "Geleneksel Web",
            subtitle: "Sayfaları yalnızca web sunucusu tarafından işleyen ve g\xfcncelleyen bir uygulama",
            description: "\xd6rneğin, JSP, PHP"
        },
        machine_to_machine: {
            title: "Makine-Makine",
            subtitle: "Kaynaklarla doğrudan iletişim kuran bir uygulama (genellikle bir servis)",
            description: "\xd6rneğin, Backend servisi"
        },
        protected: {
            title: "Korunan Uygulama",
            subtitle: "Logto tarafından korunan bir uygulama",
            description: "N/A"
        },
        third_party: {
            title: "\xdc\xe7\xfcnc\xfc Taraf Uygulama",
            subtitle: "\xdc\xe7\xfcnc\xfc taraf bir IdP bağlayıcısı olarak kullanılan bir uygulama",
            description: "\xd6r., OIDC, SAML"
        }
    },
    placeholder_title: "Devam etmek i\xe7in bir uygulama tipi se\xe7in",
    placeholder_description: "Logto, uygulamanızı tanımlamaya, oturum a\xe7mayı y\xf6netmeye ve denetim kayıtları oluşturmaya yardımcı olmak i\xe7in OIDC i\xe7in bir uygulama varlığı kullanır.",
    m2m_role_assignment: {
        title: "İzinler i\xe7in makineye \xf6zel rolle uygulamayı yetkilendir",
        subtitle: "Makine-makine uygulamaları yetkilendirilmiş bir makine-makine rol\xfc gerektirir.",
        role_creation_hint: "Doğru makineden makineye rol\xfcn\xfc bulamıyor musunuz? <a>Makineden makineye rol oluşturun</a>"
    }
};
var $fc0472b7f0a8cba8$export$2e2bcd8739ae039 = Object.freeze($fc0472b7f0a8cba8$var$applications);


const $385c4fb45af75173$var$cloud = {
    general: {
        onboarding: "Başlatma"
    },
    welcome: {
        page_title: "Hoş geldiniz",
        title: "Logto Cloud'a hoş geldiniz! Sizi biraz tanımak istiyoruz.",
        description: "Sizi daha iyi tanıyarak Logto deneyiminizi size \xf6zel hale getirelim. Bilgileriniz bizimle g\xfcvende.",
        project_field: "Logto'yu kullanıyorum \xe7\xfcnk\xfc",
        project_options: {
            personal: "Kişisel proje",
            company: "Şirket projesi"
        },
        company_name_field: "Şirket adı",
        company_name_placeholder: "Acme.co",
        stage_field: "\xdcr\xfcn\xfcn\xfcz şu anda hangi aşamada?",
        stage_options: {
            new_product: "Yeni bir proje başlatmak ve hızlı, hazır bir \xe7\xf6z\xfcm arıyorum",
            existing_product: "Mevcut kimlik doğrulamadan g\xf6\xe7 etmek (\xf6r. \xf6zelleştirilmiş, Auth0, Cognito, Microsoft)",
            target_enterprise_ready: "Yeni b\xfcy\xfck m\xfcşteriler kazandım ve \xfcr\xfcn\xfcm\xfc şimdi kurumsal m\xfcşterilere satılabilir hale getiriyorum"
        },
        additional_features_field: "Bilmemizi istediğiniz başka bir şey var mı?",
        additional_features_options: {
            customize_ui_and_flow: "Kendi UI'ımı inşa etmek ve y\xf6netmek, sadece Logto'nun \xf6nceden yapılandırılmış ve \xf6zelleştirilebilir \xe7\xf6z\xfcm\xfcn\xfc kullanmamak",
            compliance: "SOC2 ve GDPR olmazsa olmaz",
            export_user_data: "Kullanıcı verilerini Logto'dan dışa aktarma yeteneğine ihtiyacım var",
            budget_control: "\xc7ok sıkı bir b\xfct\xe7e kontrol\xfcm var",
            bring_own_auth: "Kendi kimlik doğrulama hizmetlerim var ve sadece bazı Logto \xf6zelliklerine ihtiyacım var",
            others: "Yukarıdakilerden hi\xe7biri"
        }
    },
    sie: {
        page_title: "Oturum a\xe7ma deneyimini \xf6zelleştirin",
        title: "\xd6ncelikle giriş deneyiminizi kolaylıkla \xf6zelleştirin",
        inspire: {
            title: "Etkileyici \xf6rnekler oluşturun",
            description: 'Giriş deneyiminizden emin değilseniz, sadece "Beni İlhamla"ya tıklayın ve sihrin ger\xe7ekleşmesine izin verin!',
            inspire_me: "Beni ilhamla"
        },
        logo_field: "Uygulama Logosu",
        color_field: "Marka rengi",
        identifier_field: "Tanımlayıcı",
        identifier_options: {
            email: "E-posta",
            phone: "Telefon",
            user_name: "Kullanıcı adı"
        },
        authn_field: "Kimlik doğrulama",
        authn_options: {
            password: "Şifre",
            verification_code: "Doğrulama kodu"
        },
        social_field: "Sosyal oturum a\xe7ma",
        finish_and_done: "Bitir ve tamamla",
        preview: {
            mobile_tab: "Mobil",
            web_tab: "Web"
        },
        connectors: {
            unlocked_later: "Daha sonra kilidi a\xe7ılacak",
            unlocked_later_tip: "Onboarding s\xfcrecini tamamladıktan ve \xfcr\xfcne girdikten sonra, daha fazla sosyal oturum a\xe7ma y\xf6ntemine erişiminiz olacaktır.",
            notice: "L\xfctfen \xfcretim ama\xe7lı olarak demo konekt\xf6r\xfcn\xfc kullanmaktan ka\xe7ının. Testi tamamladıktan sonra l\xfctfen demo konekt\xf6r\xfcn\xfc silin ve kendi kimlik bilgilerinizle kendi konekt\xf6r\xfcn\xfcz\xfc ayarlayın."
        }
    },
    socialCallback: {
        title: "Başarıyla giriş yaptınız",
        description: "Sosyal hesabınızı kullanarak başarılı bir şekilde giriş yaptınız. Logto'nun t\xfcm \xf6zelliklerine sorunsuz entegrasyon ve erişim sağlamak i\xe7in kendi sosyal konekt\xf6r\xfcn\xfcz\xfc yapılandırmaya devam etmenizi \xf6neririz."
    },
    tenant: {
        create_tenant: "Kiracı Oluştur"
    }
};
var $385c4fb45af75173$export$2e2bcd8739ae039 = Object.freeze($385c4fb45af75173$var$cloud);


const $32fbf463afd3721b$var$components = {
    uploader: {
        action_description: "S\xfcr\xfckle ve bırak veya g\xf6zat",
        uploading: "Y\xfckleniyor...",
        image_limit: "{{size, number}}KB altındaki resimleri y\xfckleyin, yalnızca {{extensions, list(style: narrow; type: conjunction;)}} dosyaları kabul edilir.",
        error_upload: "Bir şeyler yanlış gitti. Dosya y\xfcklenemedi.",
        error_file_size: "Dosya boyutu \xe7ok b\xfcy\xfck. L\xfctfen {{size, number}}KB altında bir dosya y\xfckleyin.",
        error_file_type: "Dosya t\xfcr\xfc desteklenmiyor. Yalnızca {{extensions, list(style: narrow; type: conjunction;)}} dosyaları kabul edilir.",
        error_file_count: "Sadece 1 dosya y\xfckleyebilirsiniz."
    }
};
var $32fbf463afd3721b$export$2e2bcd8739ae039 = Object.freeze($32fbf463afd3721b$var$components);


const $e6f631ffa28d00d5$var$connector_details = {
    page_title: "Bağdaştırıcı ayrıntıları",
    back_to_connectors: "Bağdaştırıcılara geri d\xf6n",
    check_readme: "READMEye bak",
    settings: "Genel ayarlar",
    settings_description: "Bağdaştırıcılar Logto'da kritik bir rol oynar. Onların yardımıyla, Logto son kullanıcıların şifresiz kayıt veya giriş yapmasını ve sosyal hesaplarla giriş yapabilme \xf6zelliklerini sağlar.",
    parameter_configuration: "Parametre yapılandırması",
    test_connection: "Bağlantıyı test et",
    save_error_empty_config: "L\xfctfen yapılandırmayı girin",
    send: "G\xf6nder",
    send_error_invalid_format: "Ge\xe7ersiz giriş",
    edit_config_label: "Json girin",
    test_email_sender: "Eposta bağdaştırıcınızı test edin",
    test_sms_sender: "SMS bağdaştırıcınızı test edin",
    test_email_placeholder: "john.doe@example.com",
    test_sms_placeholder: "+90 555 123 45 67",
    test_message_sent: "Test mesajı g\xf6nderildi",
    test_sender_description: 'Logto testler i\xe7in "Generic" şablonunu kullanır. Bağlantınız doğru şekilde yapılandırılmışsa bir mesaj alacaksınız.',
    options_change_email: "Eposta bağdaştırıcınızı değiştirin",
    options_change_sms: "SMS bağdaştırıcınızı değiştirin",
    connector_deleted: "Bağdaştırıcı başarıyla silindi",
    type_email: "Eposta bağdaştırıcısı",
    type_sms: "SMS bağdaştırıcısı",
    type_social: "Sosyal bağdaştırıcı",
    in_used_social_deletion_description: "Bu bağdaştırıcı, giriş deneyiminizde kullanımda. Silerek, <name/> giriş deneyiminiz, giriş deneyimi ayarlarında silinecektir. Geri eklemeye karar verirseniz yeniden yapılandırmanız gerekecektir.",
    in_used_passwordless_deletion_description: "Bu {{name}} giriş deneyiminizde kullanımda. Silerek, giriş deneyiminiz \xe7\xf6z\xfcl\xfcnceye kadar doğru \xe7alışmayacaktır. Geri eklemeye karar verirseniz yeniden yapılandırmanız gerekecektir.",
    deletion_description: "Bu bağdaştırıcıyı kaldırıyorsunuz. Geri alınamaz ve geri eklemeye karar verirseniz yeniden yapılandırmanız gerekecektir.",
    logto_email: {
        total_email_sent: "Toplam e-posta g\xf6nderildi: {{value, number}}",
        total_email_sent_tip: "Logto dahili e-posta i\xe7in g\xfcvenli ve stabil SendGrid kullanır. Tamamen \xfccretsizdir. <a>Daha fazla bilgi edinin</a>",
        email_template_title: "E-posta Şablonu",
        template_description: "Yerleşik e-posta, doğrulama e-postalarının sorunsuz teslimi i\xe7in varsayılan şablonları kullanır. Herhangi bir yapılandırma gerektirmez ve temel marka bilgilerini \xf6zelleştirebilirsiniz.",
        template_description_link_text: "Şablonları g\xf6r\xfcnt\xfcle",
        description_action_text: "Şablonları g\xf6r\xfcnt\xfcle",
        from_email_field: "Kimden e-posta",
        sender_name_field: "G\xf6nderen adı",
        sender_name_tip: 'E-postalar i\xe7in g\xf6nderen adını \xf6zelleştirin. Boş bırakılırsa, varsayılan ad olarak "Verification" kullanılacaktır.',
        sender_name_placeholder: "G\xf6nderen adınızı girin",
        company_information_field: "Şirket bilgileri",
        company_information_description: "E-postaların alt kısmında şirket adınızı, adresinizi veya posta kodunuzu g\xf6r\xfcnt\xfcleyin.",
        company_information_placeholder: "Şirketinizin temel bilgileri",
        app_logo_field: "Uygulama Logosu",
        app_logo_tip: "E-postaların \xfcst\xfcnde marka logosunu g\xf6r\xfcnt\xfcleyin. Aynı g\xf6r\xfcnt\xfcy\xfc a\xe7ık mod ve karanlık mod i\xe7in kullanın.",
        urls_not_allowed: "URLler izin verilmez",
        test_notes: 'Logto testler i\xe7in "Generic" şablonunu kullanır.'
    }
};
var $e6f631ffa28d00d5$export$2e2bcd8739ae039 = Object.freeze($e6f631ffa28d00d5$var$connector_details);


const $97490d84dc811a15$var$connectors = {
    page_title: "Bağlayıcılar",
    title: "Bağlayıcılar",
    subtitle: "Şifresiz ve sosyal oturum a\xe7ma deneyimini etkinleştirmek i\xe7in bağlayıcıları yapılandırın.",
    create: "Sosyal Bağlayıcı ekle",
    config_sie_notice: "Bağlayıcıları yapılandırdınız. <a>{{link}}</a> i\xe7inde yapılandırmayı yapın.",
    config_sie_link_text: "oturum a\xe7ma deneyimi",
    tab_email_sms: "E-posta ve SMS bağlayıcıları",
    tab_social: "Sosyal bağlayıcılar",
    connector_name: "Bağlayıcı adı",
    demo_tip: "Bu demo bağlayıcı i\xe7in izin verilen maksimum mesaj sayısı 100 ile sınırlıdır ve \xfcretim ortamında dağıtılması \xf6nerilmez.",
    social_demo_tip: "Demo bağlayıcı sadece g\xf6sterim ama\xe7lı tasarlanmıştır ve \xfcretim ortamında uygulanması \xf6nerilmez.",
    connector_type: "Tip",
    connector_status: "Oturum a\xe7ma deneyimi",
    connector_status_in_use: "Kullanımda",
    connector_status_not_in_use: "Kullanımda değil",
    not_in_use_tip: {
        content: "Kullanımda değil, oturum a\xe7ma deneyiminiz bu oturum a\xe7ma y\xf6ntemini kullanmamış demektir. <a>{{link}}</a> bağlantısını kullanarak bu oturum a\xe7ma y\xf6ntemini ekleyin.",
        go_to_sie: "Oturum a\xe7ma deneyimine git"
    },
    placeholder_title: "Sosyal bağlayıcı",
    placeholder_description: "Logto, \xe7ok sayıda kullanılan sosyal oturum a\xe7ma bağlayıcısı sağlamıştır. Bu arada, standart protokollerle kendi bağlayıcınızı oluşturabilirsiniz.",
    save_and_done: "Kaydet ve bitir",
    type: {
        email: "E-posta bağlayıcısı",
        sms: "SMS bağlayıcısı",
        social: "Sosyal bağlayıcı"
    },
    setup_title: {
        email: "E-posta bağlayıcısı ayarla",
        sms: "SMS bağlayıcısı ayarla",
        social: "Sosyal Bağlayıcı ekle"
    },
    guide: {
        subtitle: "Bağlayıcıyı yapılandırmak i\xe7in adım adım kılavuz",
        general_setting: "Genel ayarlar",
        parameter_configuration: "Parametre konfig\xfcrasyonu",
        test_connection: "Bağlantıyı test et",
        name: "Sosyal oturum a\xe7ma d\xfcğmesi i\xe7in ad",
        name_placeholder: "Sosyal oturum a\xe7ma d\xfcğmesi i\xe7in ad girin",
        name_tip: 'Bağlayıcı d\xfcğmesinin adı "{{name}} ile devam et" olarak g\xf6r\xfcnt\xfclenecektir. İsimlendirmenin uzunluğuna dikkat edin, \xe7ok uzun olursa bir sorun oluşabilir.',
        logo: "Sosyal oturum a\xe7ma d\xfcğmesi i\xe7in logo URL",
        logo_placeholder: "https://your.cdn.domain/logo.png",
        logo_tip: "Logo resmi bağlantısı d\xfcğmede g\xf6r\xfcnt\xfclenecektir. Herkese a\xe7ık bir bağlantı alın ve bağlantıyı buraya yapıştırın.",
        logo_dark: "Sosyal oturum a\xe7ma d\xfcğmesi i\xe7in logo URL (Karanlık mod)",
        logo_dark_placeholder: "https://your.cdn.domain/logo.png",
        logo_dark_tip: "Karanlık modu etkinleştikten sonra bağlayıcı logonuzu ayarlayın.",
        logo_dark_collapse: "Daralt",
        logo_dark_show: "Karanlık mod logu ayarını g\xf6ster",
        target: "Kimlik sağlayıcısı adı",
        target_placeholder: "Bağlayıcı kimlik sağlayıcısı adını girin",
        target_tip: "“IdP adı” değeri, sosyal kimliklerinizi ayırt etmek i\xe7in benzersiz bir tanımlayıcı dize olabilir.",
        target_tip_standard: "“IdP adı” değeri, sosyal kimliklerinizi ayırt etmek i\xe7in benzersiz bir tanımlayıcı dize olabilir. Bu ayar, bağlayıcı oluşturulduktan sonra değiştirilemez.",
        target_tooltip: 'Logto sosyal bağlayıcılarındaki "Hedef", sosyal kimliklerinizin "kaynağı" na işaret eder. Logto tasarımında, aynı bir platformun "hedef" i kabul edilmez ve \xe7akışmaları \xf6nlemek i\xe7in benzersiz olmalıdır. Bir bağlayıcı eklemeniz gerektiğinde \xe7ok dikkatli olmalısınız \xe7\xfcnk\xfc oluşturulduktan sonra "hedef" değerini DEĞİŞTİREMEZSİNİZ. <a>Daha fazla bilgi edinin</a>',
        target_conflict: "Kullanılan IdP adı, <span>adı</span> ile eşleşmektedir. Aynı idp adını kullanmak, kullanıcıların iki farklı bağlayıcı aracılığıyla aynı hesaba erişebileceği şekilde beklenmeyen oturum a\xe7ma davranışına neden olabilir.",
        target_conflict_line2: 'Eski kullanıcıların yeniden kayıt olma olmadan oturum a\xe7masına izin vermek i\xe7in \xf6nceki <span>adı</span> bağlayıcıyı silerek aynı "IdP adı" ile yeni bir bağlayıcı oluşturmak isterseniz yapın.',
        target_conflict_line3: 'Farklı bir kimlik sağlayıcıya bağlanmak isterseniz, "IdP adı" nı değiştirin ve devam edin.',
        config: "Konfig\xfcrasyon JSON'ınızı girin",
        sync_profile: "Profil bilgisini senkronize et",
        sync_profile_only_at_sign_up: "Sadece kayıtta senkronize et",
        sync_profile_each_sign_in: "Her oturum a\xe7mada her zaman senkronize et",
        sync_profile_tip: "Sosyal sağlayıcıdan temel profil (kullanıcıların adları ve avatarları gibi) senkronize edilsin.",
        callback_uri: "Geri d\xf6n\xfcş URI",
        callback_uri_description: "Ayrıca y\xf6nlendirme URI'si olarak adlandırılır, kullanıcıların sosyal yetkilendirmeden sonra Logto'ya geri g\xf6nderilecekleri URI'dir, ve sosyal sağlayıcının yapılandırma sayfasına kopyalayın yapıştırın.",
        acs_url: "Assertion consumer service URL"
    },
    platform: {
        universal: "Evrensel",
        web: "Web",
        native: "Native"
    },
    add_multi_platform: " birden fazla platformu destekler, devam etmek i\xe7in bir platform se\xe7in",
    drawer_title: "Bağlayıcı Kılavuzu",
    drawer_subtitle: "Bağlayıcıyı entegre etmek i\xe7in y\xf6nergeleri izleyin",
    unknown: "Bilinmeyen bağlayıcı",
    standard_connectors: "Standart bağlayıcılar"
};
var $97490d84dc811a15$export$2e2bcd8739ae039 = Object.freeze($97490d84dc811a15$var$connectors);


const $24a454ed257b3451$var$contact = {
    title: "Yardım alın",
    description: "Yardım istekleri veya \xfcr\xfcn geribildirimleri i\xe7in l\xfctfen aşağıdaki y\xf6ntemlerle bizimle iletişime ge\xe7in.",
    discord: {
        title: "Discord topluluğuna katıl",
        description: "Diğer geliştiricilerle bağlantı kurup \xe7\xf6z\xfcmler bulun",
        button: "Katıl"
    },
    github: {
        title: "GitHub \xfczerinden iletişim kurun",
        description: "Bir sorun oluşturun ve GitHub'a g\xf6nderin",
        button: "A\xe7ık"
    },
    email: {
        title: "E-posta ile destek iletişimi",
        description: "Daha fazla bilgi ve yardım i\xe7in bize e-posta g\xf6nderin",
        button: "Send"
    },
    reserve: {
        title: "Logto ekibiyle zaman ayırın",
        description: "Hızlı bir g\xf6r\xfcşme i\xe7in oturum ayırın",
        button: "Programa al"
    }
};
var $24a454ed257b3451$export$2e2bcd8739ae039 = Object.freeze($24a454ed257b3451$var$contact);


const $9d74f8b9efd77f62$var$dashboard = {
    page_title: "G\xf6sterge Paneli",
    title: "G\xf6sterge Paneli",
    description: "Uygulamanızın performansı hakkında genel bir bakış elde edin",
    total_users: "T\xfcm Kullanıcılar",
    total_users_tip: "T\xfcm kullanıcılar",
    new_users_today: "Bug\xfcn katılan kullanıcılar",
    new_users_today_tip: "Uygulamamıza bug\xfcn katılan yeni kullanıcı sayısı",
    new_users_7_days: "Son 7 g\xfcnde katılan kullanıcılar",
    new_users_7_days_tip: "Uygulamamıza son 7 g\xfcnde katılan kullanıcı sayısı",
    daily_active_users: "G\xfcnl\xfck aktif kullanıcılar",
    daily_active_users_tip: "Bug\xfcn uygulamalarınızda token değişiminde bulunan \xf6zg\xfcn kullanıcı sayısı",
    weekly_active_users: "Haftalık aktif kullanıcılar",
    weekly_active_users_tip: "Son 7 g\xfcnde uygulamalarınızda token değişiminde bulunan \xf6zg\xfcn kullanıcı sayısı",
    monthly_active_users: "Aylık aktif kullanıcılar",
    monthly_active_users_tip: "Son 30 g\xfcnde uygulamalarınızda token değişiminde bulunan \xf6zg\xfcn kullanıcı sayısı"
};
var $9d74f8b9efd77f62$export$2e2bcd8739ae039 = Object.freeze($9d74f8b9efd77f62$var$dashboard);


const $c57668d477eded7a$var$domain = {
    status: {
        connecting: "Bağlanıyor...",
        in_use: "Kullanımda",
        failed_to_connect: "Bağlantı başarısız oldu"
    },
    update_endpoint_notice: "\xd6zellikleri i\xe7in \xf6zel bir alan adı kullanmak istiyorsanız, uygulamanızda Sosyal bağlayıcı geri \xe7ağrı URI ve Logto u\xe7 noktası i\xe7in alan adını g\xfcncellemeyi unutmayın. <a>{{link}}</a>",
    error_hint: "DNS kayıtlarınızı g\xfcncellediğinizden emin olunuz. {{value}} saniyede bir kontrol edeceğiz.",
    custom: {
        custom_domain: "\xd6zel Alan Adı",
        custom_domain_description: "Markalaşmanızı geliştirin ve \xf6zel bir alan adı kullanın. Bu alan adı oturum a\xe7ma deneyiminizde kullanılacaktır.",
        custom_domain_field: "\xd6zel alan adı",
        custom_domain_placeholder: "alan_adınız.com",
        add_domain: "Alan Adı Ekle",
        invalid_domain_format: 'L\xfctfen ge\xe7erli bir alan adı URL\'si sağlayın, en az \xfc\xe7 par\xe7aya sahip olmalıdır, \xf6rneğin "alanınız.com."',
        verify_domain: "Alan adınızı doğrulayın",
        enable_ssl: "SSL etkinleştirilsin mi",
        checking_dns_tip: "DNS kayıtlarını yapılandırdıktan sonra, işlem otomatik olarak \xe7alışır ve 24 saate kadar s\xfcrebilir. Bu aray\xfczden ayrılabilirsiniz.",
        enable_ssl_tip: "SSL etkinleştirilsin mi otomatik olarak \xe7alışır ve 24 saate kadar s\xfcrebilir. Bu aray\xfczden ayrılabilirsiniz.",
        generating_dns_records: "DNS kayıtları oluşturuluyor...",
        add_dns_records: "L\xfctfen bu DNS kayıtlarını DNS sağlayıcınıza ekleyin.",
        dns_table: {
            type_field: "Tip",
            name_field: "İsim",
            value_field: "Değer"
        },
        deletion: {
            delete_domain: "Alan Adını Sil",
            reminder: "\xd6zel Alan Adını Sil",
            description: "Bu \xf6zel alan adını silmek istediğinizden emin misiniz?",
            in_used_description: 'Bu "<span>{{domain}}</span>" adlı \xf6zel alan adını silmek istediğinizden emin misiniz?',
            in_used_tip: 'Bu \xf6zel alan adını \xf6nce sosyal bağlantı sağlayıcınızda veya uygulama u\xe7 noktasında yapılandırdıysanız, URI\'yi \xf6nce Logto varsayılan alan adı olan "<span>{{domain}}</span>" olarak değiştirmeniz gerekir. Bu, sosyal giriş d\xfcğmesinin d\xfczg\xfcn \xe7alışması i\xe7in gereklidir.',
            deleted: "\xd6zel alan adı başarıyla silindi!"
        }
    },
    default: {
        default_domain: "Varsayılan Alan Adı",
        default_domain_description: "Logto, ek bir yapılandırma olmadan kullanıma hazır \xf6nceden yapılandırılmış bir varsayılan alan adı sunar. Bu varsayılan alan adı, \xf6zel bir alan adı etkinleştirdiyseniz bile yedek se\xe7eneği olarak hizmet verir.",
        default_domain_field: "Logto varsayılan alan adı"
    },
    custom_endpoint_note: 'Bu u\xe7 noktaların alan adını \xf6zelleştirebilirsiniz. "{{custom}}" veya "{{default}}" se\xe7eneklerinden birini se\xe7in.',
    custom_social_callback_url_note: 'Bu URI\'nin alan adını uygulamanızın u\xe7 noktasıyla eşleştirmek i\xe7in \xf6zelleştirebilirsiniz. "{{custom}}" veya "{{default}}" se\xe7eneklerinden birini se\xe7in.',
    custom_acs_url_note: 'Bu URI\'nin alan adını kimlik sağlayıcısı Assertion Consumer Service URL\'inizle eşleştirmek \xfczere \xf6zelleştirebilirsiniz. "{{custom}}" veya "{{default}}" se\xe7eneklerinden birini se\xe7in.'
};
var $c57668d477eded7a$export$2e2bcd8739ae039 = Object.freeze($c57668d477eded7a$var$domain);


const $fcfd78887c5d3de4$var$enterprise_sso_details = {
    back_to_sso_connectors: "Kurumsal SSO'ya geri d\xf6n",
    page_title: "Kurumsal SSO bağlayıcı ayrıntıları",
    readme_drawer_title: "Kurumsal SSO",
    readme_drawer_subtitle: "Son kullanıcı SSO'yu etkinleştirmek i\xe7in kurumsal SSO bağlayıcılarını kurun",
    tab_experience: "SSO Deneyimi",
    tab_connection: "Bağlantı",
    general_settings_title: "Genel",
    custom_branding_title: "Ekran",
    custom_branding_description: "Son kullanıcıların Tek Oturum A\xe7ma akışında g\xf6sterilen adı ve logoyu \xf6zelleştirin. Boş olduğunda varsayılanlar kullanılır.",
    email_domain_field_name: "Kurumsal e-posta etki alanı",
    email_domain_field_description: "Bu e-posta etki alanına sahip kullanıcılar SSO'yu kimlik doğrulamak i\xe7in kullanabilir. L\xfctfen etki alanının kurumunuza ait olduğunu doğrulayın.",
    email_domain_field_placeholder: "E-posta etki alanı",
    sync_profile_field_name: "Profil bilgilerini kimlik sağlayıcıdan senkronize et",
    sync_profile_option: {
        register_only: "Yalnızca ilk oturum a\xe7mada senkronize et",
        each_sign_in: "Her oturum a\xe7mada her zaman senkronize et"
    },
    connector_name_field_name: "Bağlayıcı adı",
    display_name_field_name: "G\xf6r\xfcnt\xfcleme adı",
    connector_logo_field_name: "G\xf6r\xfcnt\xfcleme logosu",
    connector_logo_field_description: "Her resim 500KB'ın altında olmalıdır, yalnızca SVG, PNG, JPG, JPEG kullanılabilir.",
    branding_logo_context: "Logo y\xfckle",
    branding_logo_error: "Logo y\xfckleme hatası: {{error}}",
    branding_light_logo_context: "A\xe7ık mod logo y\xfckle",
    branding_light_logo_error: "A\xe7ık mod logo y\xfckleme hatası: {{error}}",
    branding_logo_field_name: "Logo",
    branding_logo_field_placeholder: "https://sizin.domain/logo.png",
    branding_dark_logo_context: "Koyu mod logo y\xfckle",
    branding_dark_logo_error: "Koyu mod logo y\xfckleme hatası: {{error}}",
    branding_dark_logo_field_name: "Logo (koyu mod)",
    branding_dark_logo_field_placeholder: "https://sizin.domain/koyu-mod-logo.png",
    check_connection_guide: "Bağlantı rehberi",
    enterprise_sso_deleted: "Kurumsal SSO bağlayıcısı başarıyla silindi",
    delete_confirm_modal_title: "Kurumsal SSO bağlayıcısını sil",
    delete_confirm_modal_content: "Bu kurumsal bağlayıcıyı silmek istediğinizden emin misiniz? Kimlik sağlayıcılardan gelen kullanıcılar Tek Oturum A\xe7ma'yı kullanmayacaklar.",
    upload_idp_metadata_title_saml: "Metadata'y\xfc y\xfckle",
    upload_idp_metadata_description_saml: "Kimlik sağlayıcıdan kopyalanan metadatayı yapılandırın.",
    upload_idp_metadata_title_oidc: "Kimlik sağlayıcıdan kimlik bilgilerini y\xfckle",
    upload_idp_metadata_description_oidc: "Kimlik sağlayıcıdan kopyalanan kimlik bilgileri ve OIDC belirte\xe7 bilgilerini yapılandırın.",
    upload_idp_metadata_button_text: "Metadatayı XML dosyası olarak y\xfckle",
    upload_signing_certificate_button_text: "Imza sertifikası dosyası y\xfckle",
    configure_domain_field_info_text: "Kurumsal kullanıcıları Tek Oturum A\xe7ma i\xe7in kimlik sağlayıcılarına y\xf6nlendirmek i\xe7in e-posta etki alanı ekleyin.",
    email_domain_field_required: "Kurumsal SSO'yu etkinleştirmek i\xe7in e-posta etki alanı gereklidir.",
    upload_saml_idp_metadata_info_text_url: "Kimlik sağlayıcıdan gelen metin URL'sini yapıştırarak bağlanın.",
    upload_saml_idp_metadata_info_text_xml: "Kimlik sağlayıcıdan gelen metin bilgilerini yapıştırarak bağlanın.",
    upload_saml_idp_metadata_info_text_manual: "Kimlik sağlayıcıdan gelen metin bilgilerini doldurarak bağlanın.",
    upload_oidc_idp_info_text: "Kimlik sağlayıcıdan gelen bilgileri doldurarak bağlanın.",
    service_provider_property_title: "IdP'de yapılandırın",
    service_provider_property_description: "Kimlik sağlayıcınızda {{protocol}} kullanarak bir uygulama entegrasyonu kurun. Logto tarafından sağlanan ayrıntıları girin.",
    attribute_mapping_title: "\xd6zellik eşlemeleri",
    attribute_mapping_description: "Kimlik sağlayıcıdan kullanıcı profillerini kullanıcı \xf6zelliği eşlemesini yapılandırarak Logto tarafına senkronize edin.",
    saml_preview: {
        sign_on_url: "Oturum a\xe7ma URL'si",
        entity_id: "Deyici",
        x509_certificate: "Imza sertifikası",
        certificate_content: "Sonlanma {{date}}"
    },
    oidc_preview: {
        authorization_endpoint: "Yetkilendirme son noktası",
        token_endpoint: "Belirte\xe7 son noktası",
        userinfo_endpoint: "Kullanıcı bilgisi son noktası",
        jwks_uri: "JSON web anahtarı k\xfcmesi son noktası",
        issuer: "Deyici"
    }
};
var $fcfd78887c5d3de4$export$2e2bcd8739ae039 = Object.freeze($fcfd78887c5d3de4$var$enterprise_sso_details);


const $db79c3f39bade2b2$var$enterprise_sso = {
    page_title: "Kurumsal SSO",
    title: "Kurumsal SSO",
    subtitle: "Kurumsal kimlik sağlayıcısını bağlayın ve SP başlatmalı Tek Oturum A\xe7mayı etkinleştirin.",
    create: "Kurumsal bağlayıcı ekle",
    col_connector_name: "Bağlayıcı adı",
    col_type: "T\xfcr",
    col_email_domain: "E-posta etki alanı",
    placeholder_title: "Kurumsal bağlayıcı",
    placeholder_description: "Logto, bir\xe7ok yerleşik kurumsal kimlik sağlayıcı sağlamıştır, aynı zamanda SAML ve OIDC protokolleri ile kendi sahip olduğunuzu oluşturabilirsiniz.",
    create_modal: {
        title: "Kurumsal bağlayıcı ekle",
        text_divider: "Ya da standart bir protokol ile bağlayıcınızı \xf6zelleştirebilirsiniz.",
        connector_name_field_title: "Bağlayıcı adı",
        connector_name_field_placeholder: "\xd6r., {şirket adı} - {kimlik sağlayıcı adı}",
        create_button_text: "Bağlayıcı Oluştur"
    },
    guide: {
        subtitle: "Kurumsal kimlik sağlayıcıyı bağlamak i\xe7in adım adım kılavuz.",
        finish_button_text: "Devam"
    },
    basic_info: {
        title: "İdP'de hizmetinizi yapılandırın",
        description: "Yeni bir uygulama entegrasyonu oluşturun, {{name}} kimlik sağlayıcınızda SAML 2.0 ile. Ardından aşağıdaki değeri yapıştırın.",
        saml: {
            acs_url_field_name: "Assertion consumer service URL (Reply URL)",
            audience_uri_field_name: "Audience URI (SP Entity ID)"
        },
        oidc: {
            redirect_uri_field_name: "Y\xf6nlendirme URI'si (Geri \xe7ağrı URL'si)"
        }
    },
    attribute_mapping: {
        title: "\xd6zellik eşlemeleri",
        description: "`id` ve `email`, kullanıcı profilini IdP'den senkronize etmek i\xe7in gereklidir. IdP'nizde aşağıdaki talep adı ve değeri girin.",
        col_sp_claims: "Hizmet sağlayıcı değeri (Logto)",
        col_idp_claims: "Kimlik sağlayıcı talep adı",
        idp_claim_tooltip: "Kimlik sağlayıcı talep adı"
    },
    metadata: {
        title: "İdP metadatasını yapılandırın",
        description: "Kimlik sağlayıcıdan metadatasını yapılandırın",
        dropdown_trigger_text: "Başka bir yapılandırma y\xf6ntemi kullan",
        dropdown_title: "Yapılandırma y\xf6nteminizi se\xe7in",
        metadata_format_url: "Metadatası URL'sini girin",
        metadata_format_xml: "Metadatası XML dosyasını y\xfckleyin",
        metadata_format_manual: "Metadatayı manuel olarak girin",
        saml: {
            metadata_url_field_name: "Metadatası URL'si",
            metadata_url_description: "Metadatası URL'den verileri dinamik olarak alın ve sertifikayı g\xfcncel tutun.",
            metadata_xml_field_name: "IdP metadatası XML dosyası",
            metadata_xml_uploader_text: "Metadatası XML dosyasını y\xfckle",
            sign_in_endpoint_field_name: "Giriş URL'si",
            idp_entity_id_field_name: "IdP varlık kimliği (Yayıncı)",
            certificate_field_name: "İmza sertifikası",
            certificate_placeholder: "x509 sertifikasını kopyalayıp yapıştırın",
            certificate_required: "İmza sertifikası gerekli."
        },
        oidc: {
            client_id_field_name: "M\xfcşteri kimliği",
            client_secret_field_name: "M\xfcşteri parolası",
            issuer_field_name: "Yayıncı",
            scope_field_name: "Kapsam"
        }
    }
};
var $db79c3f39bade2b2$export$2e2bcd8739ae039 = Object.freeze($db79c3f39bade2b2$var$enterprise_sso);


const $4b20afd35c7e8517$var$errors = {
    something_went_wrong: "Hata! Bir şeyler yanlış gitti.",
    page_not_found: "Sayfa bulunamadı",
    unknown_server_error: "Bilinmeyen sunucu hatası oluştu",
    empty: "Veri yok",
    missing_total_number: "Yanıt başlıklarında Toplam Sayı bulunamadı",
    invalid_uri_format: "Ge\xe7ersiz URI bi\xe7imi",
    invalid_origin_format: "Ge\xe7ersiz URI kaynak bi\xe7imi",
    invalid_json_format: "Ge\xe7ersiz JSON bi\xe7imi",
    invalid_regex: "Ge\xe7ersiz d\xfczenli ifade",
    invalid_error_message_format: "Hata mesajı bi\xe7imi ge\xe7ersiz.",
    required_field_missing: "L\xfctfen {{field}} giriniz",
    required_field_missing_plural: "En az bir {{field}} girmek zorundasınız.",
    more_details: "Daha \xe7ok detay",
    username_pattern_error: "Kullanıcı adı yalnızca harf, sayı veya alt \xe7izgi i\xe7ermeli ve bir sayı ile başlamamalıdır.",
    email_pattern_error: "E-posta adresi ge\xe7ersiz.",
    phone_pattern_error: "Telefon numarası ge\xe7ersiz.",
    insecure_contexts: "G\xfcvenli olmayan bağlamlar (HTTPS olmayan) desteklenmez.",
    unexpected_error: "Beklenmedik bir hata oluştu",
    not_found: "404 bulunamadı",
    create_internal_role_violation: 'Yeni bir dahili rol oluşturuyorsunuz, bu Logto tarafından yasaklanmıştır. "#internal:" ile başlamayan başka bir ad deneyin.',
    should_be_an_integer: "Tamsayı olmalıdır.",
    number_should_be_between_inclusive: "Sayı {{min}} ve {{max}} arasında (her ikisi de dahil) olmalıdır."
};
var $4b20afd35c7e8517$export$2e2bcd8739ae039 = Object.freeze($4b20afd35c7e8517$var$errors);


const $c794ebcd6896fd8f$var$general = {
    placeholder: "Yer tutucu",
    submit: "G\xf6nder",
    skip: "Atla",
    next: "Sonraki",
    back: "Geri",
    retry: "Tekrar Deneyin",
    done: "Bitti",
    search: "Ara",
    search_placeholder: "Ara",
    clear_result: "Sonu\xe7ları Temizle",
    save: "Kaydet",
    save_changes: "Değişiklikleri Kaydet",
    saved: "Kaydedildi",
    discard: "At",
    loading: "Y\xfckleniyor...",
    redirecting: "Y\xf6nlendiriliyor...",
    add: "Ekle",
    added: "Eklendi",
    cancel: "İptal Et",
    confirm: "Onayla",
    check_out: "G\xf6z At",
    create: "Oluştur",
    set_up: "Kur",
    customize: "\xd6zelleştir",
    enable: "Etkinleştir",
    reminder: "Hatırlatıcı",
    edit: "D\xfczenle",
    delete: "Sil",
    deleted: "Silindi",
    more_options: "DAHA FAZLA SE\xc7ENEK",
    close: "Kapat",
    copy: "Kopyala",
    copying: "Kopyalanıyor",
    copied: "Kopyalandı",
    required: "Gerekli",
    add_another: "Bir tane daha ekle",
    create_another: "Başka bir tane oluştur",
    deletion_confirmation: "Bu dosyayı silmek istediğinize emin misiniz: {{title}}?",
    settings_nav: "Ayarlar",
    unsaved_changes_warning: "Bazı değişiklikler yaptınız. Bu sayfadan ayrılmak istediğine emin misin?",
    leave_page: "Sayfayı terk et",
    stay_on_page: "Bu sayfada kal",
    type_to_search: "Aramak i\xe7in yazın",
    got_it: "Anladım",
    continue: "Devam et",
    page_info: "{{min, number}}-{{max, number}} / {{total, number}}",
    learn_more: "Daha fazla bilgi edinin",
    tab_errors: "{{count, number}} hata",
    skip_for_now: "Şimdilik atla",
    remove: "Kaldır",
    visit: "Ziyaret et",
    join: "Katıl",
    try_now: "Şimdi dene",
    multiple_form_field: "(\xc7oklu)",
    demo: "Demo",
    unnamed: "İsimsiz",
    view: "G\xf6r\xfcn\xfcm",
    open: "A\xe7",
    hide: "Gizle",
    unknown_error: "Bilinmeyen hata, l\xfctfen daha sonra tekrar deneyin.",
    select: "Se\xe7",
    contact_us_action: "Bizimle İletişime Ge\xe7in",
    description: "A\xe7ıklama",
    name: "Ad",
    add_field: "{{field}} Ekle",
    create_field: "{{field}} Oluştur",
    edit_field: "{{field}} D\xfczenle",
    delete_field: "{{field}} Sil",
    coming_soon: "Yakında",
    or: "Veya"
};
var $c794ebcd6896fd8f$export$2e2bcd8739ae039 = Object.freeze($c794ebcd6896fd8f$var$general);


const $550ae3ba16945f9d$var$get_started = {
    page_title: "Başlangıca Başlayın",
    title: "Başarınızı Desteklemek İ\xe7in Keşfedilecek Bir Şey",
    subtitle: "Logto'nun değerini hızla elde etmek i\xe7in yapabileceğiniz birka\xe7 şey",
    develop: {
        title: "Geliştir: Uygulamanızı entegre etmek i\xe7in 5 dakika ayırın",
        title_cloud: "Geliştir: Uygulamanızı dakikalar i\xe7inde g\xfcvenli bir şekilde entegre edin",
        subtitle_cloud: "Veya uygulamanızı hazır SDK'larımız ve rehberlerimizle entegre etmek i\xe7in 5 dakika ayırın."
    },
    customize: {
        title: "\xd6zelleştir: Harika bir oturum a\xe7ma deneyimi sunun",
        preview: {
            title: "Yeni \xf6zelleştirdiğiniz oturum a\xe7ma deneyiminin canlı \xf6nizlemesini kontrol edin",
            subtitle: "Nasıl \xe7alıştığını g\xf6rmek i\xe7in şimdi Logto oturum a\xe7ma deneyimini deneyin"
        },
        connector: {
            title: "Daha fazla bağdaştırıcı ekleyerek daha fazla sosyal oturum a\xe7ma y\xf6ntemini destekleyin",
            subtitle: "Şifresiz oturum a\xe7mayı deneyin ve m\xfcşterileriniz i\xe7in g\xfcvenli ve s\xfcrt\xfcnmesiz bir deneyim sağlayın"
        },
        continue_customizing: "\xd6zelleştirmeye devam et",
        try_now: "Şimdi deneyin",
        add_more: "Daha fazla ekle"
    },
    secure: {
        title: "G\xfcvenli: Kaynaklarınızı koruyun"
    },
    manage: {
        title: "Y\xf6net: \xdcr\xfcn\xfcn\xfcz ve kullanıcılarınız i\xe7in erişim denetimi tanımlayın",
        rbac: {
            title: "Diverse kullanım durumları i\xe7in \xf6l\xe7eklenebilir rol yetkilendirmesi ile kaynaklarınızı koruyun",
            subtitle: "Kaynağınızı kontrol edin"
        },
        create_roles: "Roller oluştur"
    },
    view_all: "Hepsini g\xf6r\xfcnt\xfcle →"
};
var $550ae3ba16945f9d$export$2e2bcd8739ae039 = Object.freeze($550ae3ba16945f9d$var$get_started);


const $1c9591cad9c0d037$var$guide = {
    start_building: "Yapmaya başla",
    get_started: "Başlarken",
    categories: {
        featured: "Pop\xfcler ve size \xf6zel",
        Traditional: "Geleneksel web uygulaması",
        SPA: "Tek sayfalık uygulama",
        Native: "Doğal",
        MachineToMachine: "Makineden makineye",
        Protected: "SDK Entegrasyonu Olmayan",
        ThirdParty: "\xdc\xe7\xfcnc\xfc taraf uygulama"
    },
    filter: {
        title: "Framework'\xfc filtrele",
        placeholder: "Framework ara"
    },
    checkout_tutorial: "\xd6ğreticiyi kontrol et {{name}}",
    do_not_need_tutorial: "Eğer bir \xf6ğreticiye ihtiyacınız yoksa, \xe7er\xe7eve kılavuzu olmadan devam edebilirsiniz",
    finish_and_done: "Bitir ve tamamla",
    cannot_find_guide: "Kılavuzunuzu bulamıyor musunuz?",
    describe_guide_looking_for: "Aramakta olduğunuz kılavuzu a\xe7ıklayın",
    request_guide_successfully: "Talebiniz başarıyla g\xf6nderildi. Teşekk\xfcr ederim!",
    app: {
        select_framework_or_tutorial: "Bir \xe7er\xe7eve veya \xf6ğretici se\xe7in",
        guide_modal_title: "SDK ve kılavuzlarla başlayın",
        modal_subtitle: "\xd6nceden oluşturulmuş SDK ve \xf6ğreticilerimizle uygulama geliştirme s\xfcrecinize hız kazandırın.",
        select_a_framework: "Bir \xe7er\xe7eve se\xe7in",
        continue_without_framework: "\xc7er\xe7evesiz uygulama oluştur",
        describe_guide_looking_for_placeholder: "\xd6rneğin, Logto'u Angular uygulamama entegre etmek istiyorum."
    },
    api: {
        modal_title: "\xd6ğreticilerle başlayın",
        modal_subtitle: "\xd6nceden oluşturulmuş \xf6ğreticilerimizle uygulama geliştirme s\xfcrecinize hız kazandırın.",
        select_a_tutorial: "Bir \xf6ğretici se\xe7in",
        continue_without_tutorial: "\xd6ğretici olmadan devam et",
        describe_guide_looking_for_placeholder: "\xd6rneğin, API'mı deno ile korumak istiyorum."
    }
};
var $1c9591cad9c0d037$export$2e2bcd8739ae039 = Object.freeze($1c9591cad9c0d037$var$guide);


const $a0d147c459b0e610$var$invitation = {
    find_your_tenants: "Kiracılarınızı Bulun",
    find_tenants_description: "E-posta adresiniz zaten birden fazla kiracı ile kayıtlı olabilir. Var olanlara katılabilir veya devam ederek yeni bir tane oluşturabilirsiniz.",
    create_new_tenant: "Yeni Kiracı Oluştur",
    email_not_match_title: "Şu anda\n{{email}} olarak oturum a\xe7tınız",
    email_not_match_description: "Daveti kabul etmek ve organizasyonun bir \xfcyesi olmak i\xe7in doğru hesapla oturum a\xe7ınız.",
    switch_account: "Başka bir hesaba oturum a\xe7ın",
    invalid_invitation_status: "Ge\xe7ersiz davet. L\xfctfen y\xf6neticiyle iletişime ge\xe7erek tekrar deneyin.",
    invitation_not_found: "Davet bulunamadı. L\xfctfen y\xf6neticiyle iletişime ge\xe7in."
};
var $a0d147c459b0e610$export$2e2bcd8739ae039 = Object.freeze($a0d147c459b0e610$var$invitation);


const $e3731def965f01ec$var$jwt_claims = {
    title: "\xd6zel JWT",
    description: "Erişim belgesine dahil edilecek \xf6zel JWT iddialarını ayarlayın. Bu iddialar, uygulamanıza ek bilgi iletmek i\xe7in kullanılabilir.",
    user_jwt: {
        card_title: "Kullanıcı İ\xe7in",
        card_field: "Kullanıcı erişim belgesi",
        card_description: "Erişim belgesi verilirken kullanıcıya \xf6zg\xfc veri ekleyin.",
        for: "kullanıcı i\xe7in"
    },
    machine_to_machine_jwt: {
        card_title: "Makine i\xe7in",
        card_field: "Makine-makine belgesi",
        card_description: "Makine-makine belgesi verilirken ek veri ekleyin.",
        for: "M2M i\xe7in"
    },
    code_editor_title: "\xd6zel {{token}} iddialarını \xf6zelleştirin",
    custom_jwt_create_button: "\xd6zel iddialar ekle",
    custom_jwt_item: "\xd6zel iddialar {{for}}",
    delete_modal_title: "\xd6zel iddiaları sil",
    delete_modal_content: "\xd6zel iddiaları silmek istediğinizden emin misiniz?",
    clear: "Temizle",
    cleared: "Temizlendi",
    restore: "Varsayılanları geri y\xfckle",
    restored: "Geri y\xfcklendi",
    data_source_tab: "Veri kaynağı",
    test_tab: "Test bağlamı",
    jwt_claims_description: "Varsayılan iddialar JWT'de otomatik olarak dahil edilir ve ge\xe7ersiz kılınabilir.",
    user_data: {
        title: "Kullanıcı verisi",
        subtitle: "`veri.kullanıcı` giriş parametresini kullanarak \xf6nemli kullanıcı bilgilerini sağlayın."
    },
    token_data: {
        title: "Belge verisi",
        subtitle: "`belge` giriş parametresini mevcut erişim belgesi y\xfck\xfc i\xe7in kullanın. "
    },
    fetch_external_data: {
        title: "Harici veri al",
        subtitle: "Harici API'larınızdan verileri doğrudan iddialara dahil edin.",
        description: "`fetch` işlevini kullanarak harici API'larınızı \xe7ağırın ve verileri \xf6zel iddialarınıza dahil edin. \xd6rnek: "
    },
    environment_variables: {
        title: "Ortam değişkenlerini ayarla",
        subtitle: "Hassas bilgileri depolamak i\xe7in ortam değişkenlerini kullanın.",
        input_field_title: "Ortam değişkenleri ekle",
        sample_code: "\xd6zel JWT iddialarınızı ele alan ortam değişkenlerine erişim. \xd6rnek: "
    },
    jwt_claims_hint: "\xd6zel iddiaları 50KB'ın altında tutun. Varsayılan JWT iddiaları otomatik olarak belgeye dahil edilir ve ge\xe7ersiz kılınamazlar.",
    tester: {
        subtitle: "Test i\xe7in sahte belge ve kullanıcı verilerini ayarlayın.",
        run_button: "Testi \xc7alıştır",
        result_title: "Test sonucu"
    },
    form_error: {
        invalid_json: "Ge\xe7ersiz JSON bi\xe7imi"
    }
};
var $e3731def965f01ec$export$2e2bcd8739ae039 = Object.freeze($e3731def965f01ec$var$jwt_claims);


const $7f0efc6338ef7361$var$log_details = {
    page_title: "Denetim Kaydı Detayları",
    back_to_logs: "Denetim Kayıtlarına Geri D\xf6n",
    back_to: "{{name}}'in Kayıtlarına Geri D\xf6n",
    success: "Başarılı",
    failed: "Başarısız",
    event_key: "Olay Anahtarı",
    application: "Uygulama",
    ip_address: "IP Adresi",
    user: "Kullanıcı",
    log_id: "Kayıt Kimliği",
    time: "S\xfcre",
    user_agent: "Kullanıcı Aracısı",
    tab_details: "Detaylar",
    raw_data: "Ham Veri"
};
var $7f0efc6338ef7361$export$2e2bcd8739ae039 = Object.freeze($7f0efc6338ef7361$var$log_details);


const $a147d1326a2ae3f1$var$logs = {
    page_title: "Denetim Kayıtları",
    title: "Denetim Kayıtları",
    subtitle: "Y\xf6neticiniz ve kullanıcılarınız tarafından yapılan kimlik doğrulama olaylarının kayıt verilerini g\xf6r\xfcnt\xfcleyin",
    event: "Durum",
    user: "Kullanıcı",
    application: "Uygulama",
    time: "S\xfcre",
    filter_by: "G\xf6re filtrele"
};
var $a147d1326a2ae3f1$export$2e2bcd8739ae039 = Object.freeze($a147d1326a2ae3f1$var$logs);


const $948329c3173c8a83$var$menu = {
    profile: "Profil",
    language: "Dil",
    appearance: {
        label: "G\xf6r\xfcn\xfcm",
        light: "A\xe7ık mod",
        dark: "Koyu mod",
        system: "Sistemle senkronize et"
    },
    sign_out: "\xc7ıkış Yap"
};
var $948329c3173c8a83$export$2e2bcd8739ae039 = Object.freeze($948329c3173c8a83$var$menu);


const $7dc1ef7e511c3479$var$mfa = {
    title: "\xc7ok fakt\xf6rl\xfc kimlik doğrulama",
    description: "Kimlik doğrulama deneyiminizin g\xfcvenliğini artırmak i\xe7in \xe7ok fakt\xf6rl\xfc kimlik doğrulamayı ekleyin.",
    factors: "Fakt\xf6rler",
    multi_factors: "\xc7oklu fakt\xf6rler",
    multi_factors_description: "Kullanıcılar, 2 aşamalı doğrulama i\xe7in etkinleştirilmiş fakt\xf6rlerden birini doğrulamalıdır.",
    totp: "Authenticator uygulama OTP",
    otp_description: "Google Authenticator vb. bağlayarak tek kullanımlık şifreleri doğrulamak i\xe7in.",
    webauthn: "WebAuthn (Pas anahtarı)",
    webauthn_description: "Tarayıcı tarafından desteklenen y\xf6ntemle doğrulama yapın: biyometri, telefon tarama veya g\xfcvenlik anahtarı vb.",
    webauthn_native_tip: "WebAuthn, Native uygulamalar i\xe7in desteklenmiyor.",
    webauthn_domain_tip: "WebAuthn, genel anahtarları belirli bir alanla ilişkilendirir. Hizmet alanınızı değiştirmek, kullanıcıların mevcut ge\xe7iş anahtarları aracılığıyla kimlik doğrulamasını engeller.",
    backup_code: "Yedek kod",
    backup_code_description: "Kullanıcılar herhangi bir MFA y\xf6ntemini ayarladıktan sonra 10 tek kullanımlık yedek kod \xfcretir.",
    backup_code_setup_hint: "Kullanıcılar yukarıdaki MFA fakt\xf6rlerini doğrulayamadığında yedek se\xe7eneğini kullanın.",
    backup_code_error_hint: "Bir yedek kodu kullanmak i\xe7in başarılı kullanıcı kimlik doğrulaması i\xe7in en az bir daha fazla MFA y\xf6nteme ihtiyacınız vardır.",
    policy: "Politika",
    policy_description: "Giriş ve kaydolma akışları i\xe7in MFA politikasını belirleyin.",
    two_step_sign_in_policy: "Girişte 2 aşamalı doğrulama politikası",
    user_controlled: "Kullanıcılar MFA'yı kendi başlarına etkinleştirebilir veya devre dışı bırakabilir",
    user_controlled_tip: "Kullanıcılar, giriş veya kayıt sırasında ilk kez MFA kurulumunu atlayabilir veya hesap ayarlarında etkinleştirebilir/devre dışı bırakabilir.",
    mandatory: "Kullanıcılar her zaman girişte MFA kullanmak zorundadır",
    mandatory_tip: "Kullanıcılar, ilk kez giriş veya kayıt sırasında MFA kurmalı ve t\xfcm gelecekteki girişlerde kullanmalıdır."
};
var $7dc1ef7e511c3479$export$2e2bcd8739ae039 = Object.freeze($7dc1ef7e511c3479$var$mfa);


const $ab0bd55f066e9561$var$organization_details = {
    page_title: "Kuruluş detayları",
    delete_confirmation: "Silindiğinde, t\xfcm \xfcyeler bu kuruluştaki \xfcyeliklerini ve rollerini kaybedecek. Bu işlem geri alınamaz.",
    organization_id: "Kuruluş Kimliği",
    settings_description: "Organizasyonlar, uygulamalarınıza erişebilen ekipleri, iş m\xfcşterilerini ve iş ortaklarını temsil eder.",
    name_placeholder: "Kuruluşun adı, benzersiz olması gerekli değildir.",
    description_placeholder: "Kuruluşun a\xe7ıklaması.",
    member: "\xdcye",
    member_other: "\xdcyeler",
    add_members_to_organization: '\xdcyeleri "{{name}}" kuruluşuna ekle',
    add_members_to_organization_description: "İsim, e-posta, telefon veya kullanıcı kimliği arayarak uygun kullanıcıları bulun. Var olan \xfcyeler arama sonu\xe7larında g\xf6sterilmez.",
    add_with_organization_role: "Kuruluş rol(ler)i ile ekle",
    user: "Kullanıcı",
    authorize_to_roles: '"{{name}}"a aşağıdaki rolleri erişim yetkisi verin:',
    edit_organization_roles: "Kuruluş rollerini d\xfczenle",
    edit_organization_roles_of_user: '"{{name}}"ın kuruluş rollerini d\xfczenle',
    remove_user_from_organization: "Kullanıcıyı kuruluştan kaldır",
    remove_user_from_organization_description: "Kaldırıldığında, kullanıcı bu kuruluşta \xfcyeliğini ve rollerini kaybedecek. Bu işlem geri alınamaz.",
    search_user_placeholder: "İsim, e-posta, telefon veya kullanıcı kimliği ile ara",
    at_least_one_user: "En az bir kullanıcı gereklidir.",
    custom_data: "\xd6zel veri",
    custom_data_tip: "\xd6zel veri, kuruluşla ilişkili ek verileri depolamak i\xe7in kullanılabilen bir JSON nesnesidir.",
    invalid_json_object: "Ge\xe7ersiz JSON nesnesi."
};
var $ab0bd55f066e9561$export$2e2bcd8739ae039 = Object.freeze($ab0bd55f066e9561$var$organization_details);


const $58e43da1d5984646$var$organization_role_details = {
    page_title: "Kuruluş rol\xfc ayrıntıları",
    back_to_org_roles: "Organizasyon rollerine geri d\xf6n",
    org_role: "Kuruluş rol\xfc",
    delete_confirm: "Bunu yapmak, etkilenen kullanıcılardan bu role ilişkilendirilen izinleri kaldıracak ve organizasyon rolleri, organizasyon \xfcyeleri ve organizasyon izinleri arasındaki ilişkileri silecektir.",
    deleted: "Kuruluş rol\xfc {{name}} başarıyla silindi.",
    permissions: {
        tab: "İzinler",
        name_column: "İzin",
        description_column: "A\xe7ıklama",
        type_column: "İzin t\xfcr\xfc",
        type: {
            api: "API izni",
            org: "Organizasyon izni"
        },
        assign_permissions: "İzinleri atama",
        remove_permission: "İzni kaldır",
        remove_confirmation: "Bu izin kaldırılırsa, bu organizasyon rol\xfcne sahip kullanıcı bu izin tarafından verilen erişimi kaybeder.",
        removed: "{{name}} izni bu organizasyon rol\xfcnden başarıyla kaldırıldı",
        assign_description: "Bu organizasyon i\xe7indeki roller i\xe7in izinleri atayın. Bunlar hem organizasyon izinlerini hem de API izinlerini i\xe7erebilir.",
        organization_permissions: "Organizasyon izinleri",
        api_permissions: "API izinleri",
        assign_organization_permissions: "Kuruluş izinleri ata",
        assign_api_permissions: "API izinleri ata"
    },
    general: {
        tab: "Genel",
        settings: "Ayarlar",
        description: "Organizasyon rol\xfc, kullanıcılara atanabilecek izinlerin bir gruplandırılmasıdır. İzinler, \xf6nceden tanımlanmış organizasyon izinlerinden ve API izinlerinden gelebilir.",
        name_field: "Adı",
        description_field: "A\xe7ıklama",
        description_field_placeholder: "Yalnızca g\xf6r\xfcnt\xfcleme izinlerine sahip kullanıcılar"
    }
};
var $58e43da1d5984646$export$2e2bcd8739ae039 = Object.freeze($58e43da1d5984646$var$organization_role_details);


const $37441e4d8fe69044$var$organization_template = {
    title: "Organizasyon şablonu",
    subtitle: "\xc7ok kiracılı SaaS uygulamalarında, bir organizasyon şablonu birden fazla organizasyon i\xe7in paylaşılan erişim kontrol politikalarını (izinler ve roller) tanımlar.",
    roles: {
        tab_name: "Org rolleri",
        search_placeholder: "Role adı ile ara",
        create_title: "Org rol\xfc oluştur",
        role_column: "Org rol\xfc",
        permissions_column: "İzinler",
        placeholder_title: "Organizasyon rol\xfc",
        placeholder_description: "Organizasyon rol\xfc, kullanıcılara atanabilecek izinlerin bir gruplamasıdır. İzinler, \xf6nceden belirlenmiş organizasyon izinlerinden gelmelidir.",
        create_modal: {
            title: "Kuruluş rol\xfc oluştur",
            create: "Rol oluştur",
            name_field: "Rol adı",
            description_field: "A\xe7ıklama",
            created: "Kuruluş rol\xfc {{name}} başarıyla oluşturuldu."
        }
    },
    permissions: {
        tab_name: "Org izinleri",
        search_placeholder: "İzin adı ile ara",
        create_org_permission: "Org izni oluştur",
        permission_column: "Разрешение организации",
        description_column: "A\xe7ıklama",
        placeholder_title: "Organizasyon izni",
        placeholder_description: "Organizasyon izni, organizasyon bağlamında bir kaynağa erişim yetkisi anlamına gelir.",
        delete_confirm: "Bu izin silinirse, bu izni i\xe7eren t\xfcm organizasyon rolleri bu izni kaybeder ve bu izne sahip kullanıcılar, bu izin tarafından verilen erişimi kaybeder.",
        create_title: "Organizasyon izni oluştur",
        edit_title: "Organizasyon iznini d\xfczenle",
        permission_field_name: "İzin adı",
        description_field_name: "A\xe7ıklama",
        description_field_placeholder: "Randevu ge\xe7mişini oku",
        create_permission: "İzin oluştur",
        created: "Kuruluş izni {{name}} başarıyla oluşturuldu."
    }
};
var $37441e4d8fe69044$export$2e2bcd8739ae039 = Object.freeze($37441e4d8fe69044$var$organization_template);


const $d47b7018f04912b1$var$organizations = {
    organization: "Kuruluş",
    page_title: "Kuruluşlar",
    title: "Kuruluşlar",
    subtitle: "Organizasyonlar genellikle SaaS veya benzeri \xe7ok kiracılı uygulamalarda kullanılır ve m\xfcşterilerinizi, takımları, kuruluşları veya tam şirketleri temsil eder. Kuruluşlar, B2B kimlik doğrulama ve yetkilendirme i\xe7in temel bir unsur olarak işler.",
    organization_template: "Kuruluş şablonu",
    organization_id: "Kuruluş Kimliği",
    members: "\xdcyeler",
    create_organization: "Kuruluş oluştur",
    setup_organization: "Kuruluşunuzu ayarlayın",
    organization_list_placeholder_title: "Kuruluş",
    organization_list_placeholder_text: "Organizasyonlar genellikle SaaS veya benzeri \xe7ok kiracılı uygulamalarda iyi bir uygulama olarak kullanılır. Bu, m\xfcşterilerin kuruluşlar oluşturmasına ve y\xf6netmesine, \xfcyeleri davet etmesine ve roller atanmasına olanak tanır.",
    organization_name_placeholder: "Benim kuruluşum",
    organization_description_placeholder: "Kuruluşun kısa a\xe7ıklaması",
    organization_permission: "Kuruluş izni",
    organization_permission_other: "Kuruluş izinleri",
    create_permission_placeholder: "Randevu ge\xe7mişini oku",
    organization_role: "Kuruluş rol\xfc",
    organization_role_other: "Kuruluş rolleri",
    organization_role_description: "Kuruluş rol\xfc, kullanıcılara atanabilen izinlerin bir gruplamasıdır. İzinler \xf6nceden tanımlanmış kuruluş izinlerinden gelmelidir.",
    role: "Rol",
    search_placeholder: "Kuruluş adı veya kimliğine g\xf6re ara",
    search_role_placeholder: "Rolleri arayın ve se\xe7in",
    empty_placeholder: "\uD83E\uDD14 Herhangi bir {{entity}} hen\xfcz ayarlanmamış.",
    organization_and_member: "Kuruluş ve \xfcye",
    organization_and_member_description: 'Kuruluşlar, kullanıcı gruplarıdır ve ekipleri, iş m\xfcşterilerini ve iş ortaklarını temsil edebilir. Her kullanıcı bir "\xdcye" olabilir. Bunlar, \xe7ok kiracılı gereksinimlerinizi ele almak i\xe7in temel varlıklar olabilir.',
    guide: {
        title: "Kılavuzlarla başlayın",
        subtitle: "Kılavuzlarımızla kuruluş ayarlarınızı hızlandırın",
        introduction: {
            title: "Logto'da kuruluşun nasıl \xe7alıştığını anlayalım",
            section_1: {
                title: "Kuruluş, bir kullanıcı (kimlik) grubudur"
            },
            section_2: {
                title: "Kuruluş şablonu, \xe7ok kiracılı uygulamaların erişim denetimleri i\xe7in tasarlanmıştır",
                description: '\xc7ok kiracılı SaaS uygulamalarında, birden \xe7ok kuruluş genellikle aynı erişim kontrol şablonunu paylaşır; bu şablon izinleri ve rolleri i\xe7erir. Logto\'da buna "kuruluş şablonu" diyoruz.',
                permission_description: "Kuruluş izni, kuruluş bağlamında bir kaynağa erişim izni anlamına gelir.",
                role_description_deprecated: "Kuruluş rol\xfc, kullanıcılara atanabilen kuruluş izinlerinin bir gruplamasıdır.",
                role_description: "Kuruluş rol\xfc, \xfcyelere atanabilecek kuruluş izinlerinin veya API izinlerinin bir gruplamasıdır."
            },
            section_3: {
                title: "API izinlerini organizasyon rollerine atayabilir miyim?",
                description: "Evet, API izinlerini organizasyon rollerine atayabilirsiniz. Logto, organizasyonunuzun rollerini etkili bir şekilde y\xf6netme esnekliği sunar, bu roller i\xe7inde hem organizasyon izinlerini hem de API izinlerini i\xe7erecek şekilde izin verir."
            },
            section_4: {
                title: "Her şeyin nasıl bağlandığını g\xf6rmek i\xe7in ill\xfcstrasyonla etkileşim",
                description: "\xd6rnek alalım. John, Sarah farklı kuruluşlara farklı rollerle farklı kuruluş bağlamlarında bulunmaktadır. Farklı mod\xfcllerin \xfczerine gelerek neler olduğunu g\xf6rebilirsiniz."
            }
        },
        organization_permissions: "Kuruluş izinleri",
        organization_roles: "Kuruluş rolleri",
        admin: "Y\xf6netici",
        member: "\xdcye",
        guest: "Misafir",
        role_description: 'Rol "{{role}}" farklı kuruluşlar bağlamında aynı kuruluş şablonunu paylaşır.',
        john: "John",
        john_tip: "John, \"john@email.com\" adresiyle tek bir kimlik belirleyicisi olarak farklı kuruluşlara aittir. Ayrıca kuruluş A'nın y\xf6neticisidir ve kuruluş B'nin misafiridir.",
        sarah: "Sarah",
        sarah_tip: 'Sarah, "sarah@email.com" adresiyle tek bir kimlik belirleyicisi olarak bir kuruluşa aittir. Kuruluş B\'nin y\xf6neticisidir.'
    }
};
var $d47b7018f04912b1$export$2e2bcd8739ae039 = Object.freeze($d47b7018f04912b1$var$organizations);


const $62f3bda2d2584a65$var$permissions = {
    search_placeholder: "API veya izin adına g\xf6re ara",
    search_placeholder_without_api: "İzin adına g\xf6re ara",
    name_column: "İzin",
    description_column: "A\xe7ıklama",
    api_column: "API",
    placeholder_title: "İzin",
    placeholder_description: "İzin, bir kaynağa erişmek i\xe7in yetki verme durumunu ifade eder (biz buna API kaynağı diyoruz).",
    edit: "D\xfczenleme izni",
    delete: "Silme izni",
    remove: "Kaldırma izni",
    edit_title: "API iznini d\xfczenle"
};
var $62f3bda2d2584a65$export$2e2bcd8739ae039 = Object.freeze($62f3bda2d2584a65$var$permissions);


const $62308cb1b42bca92$var$profile = {
    page_title: "Hesap Ayarları",
    title: "Hesap Ayarları",
    description: "Hesap g\xfcvenliğinizi sağlamak i\xe7in hesap ayarlarınızı değiştirin ve kişisel bilgilerinizi y\xf6netin.",
    settings: {
        title: "PROFİL AYARLARI",
        profile_information: "Profil bilgisi",
        avatar: "Avatar",
        name: "İsim",
        username: "Kullanıcı adı"
    },
    link_account: {
        title: "HESABI BAĞLA",
        email_sign_in: "E-posta ile giriş",
        email: "E-posta",
        social_sign_in: "Sosyal medya hesabıyla giriş",
        link_email: "E-postayı bağla",
        link_email_subtitle: "Giriş yapmak veya hesap kurtarımında yardımcı olmak i\xe7in e-postanızı bağlayın.",
        email_required: "E-posta gerekli",
        invalid_email: "Ge\xe7ersiz e-posta adresi",
        identical_email_address: "Girilen e-posta adresi mevcut olanla aynı",
        anonymous: "Anonim"
    },
    password: {
        title: "ŞİFRE VE G\xdcVENLİK",
        password: "Şifre",
        password_setting: "Şifre ayarları",
        new_password: "Yeni şifre",
        confirm_password: "Şifreyi onayla",
        enter_password: "Ge\xe7erli şifreyi girin",
        enter_password_subtitle: "Hesap g\xfcvenliğinizi korumak i\xe7in kendinizi doğrulayın. Değiştirmeden \xf6nce l\xfctfen mevcut şifrenizi girin.",
        set_password: "Şifre oluştur",
        verify_via_password: "Şifre ile doğrula",
        show_password: "Şifreyi g\xf6ster",
        required: "Şifre gerekli",
        do_not_match: "Şifreler eşleşmiyor. Tekrar deneyin."
    },
    code: {
        enter_verification_code: "Doğrulama kodu girin",
        enter_verification_code_subtitle: "Doğrulama kodu, <strong>{{target}}</strong> adresine g\xf6nderildi.",
        verify_via_code: "Doğrulama kodu ile doğrula",
        resend: "Doğrulama kodunu tekrar g\xf6nder",
        resend_countdown: "{{countdown}} saniye i\xe7inde tekrar g\xf6nder"
    },
    delete_account: {
        title: "HESABI SİL",
        label: "Hesabı sil",
        description: "Hesabınızın t\xfcm kişisel bilgileri, kullanıcı verileri ve yapılandırması silinecektir. Bu işlem geri alınamaz.",
        button: "Hesabı sil",
        dialog_paragraph_1: "Hesabınızı silmek istediğinize \xfczg\xfcn\xfcz. Hesabınız kalıcı olarak t\xfcm verileri, kullanıcı bilgileri, kayıtlar ve ayarlar dahil olmak \xfczere silinecektir ve bu işlem geri alınamaz. Bu nedenle, devam etmeden \xf6nce \xf6nemli verilerinizi yedeklediğinizden emin olun.",
        dialog_paragraph_2: "Hesap silme işlemine devam etmek i\xe7in, l\xfctfen destek ekibimize, <a>mail</a> adresine “Hesap Silme İsteği” konulu e-posta g\xf6nderin. Size yardımcı olacağız ve t\xfcm verilerinizin sistemimizden uygun şekilde silineceğinden emin olacağız.",
        dialog_paragraph_3: "Logto Cloud’u tercih ettiğiniz i\xe7in teşekk\xfcr ederiz. Herhangi bir sorunuz veya endişeniz varsa, bizimle iletişime ge\xe7mekten \xe7ekinmeyin."
    },
    set: "Ayarla",
    change: "Değiştir",
    link: "Bağla",
    unlink: "Bağlantıyı kes",
    not_set: "Belirtilmemiş",
    change_avatar: "Avatarı değiştir",
    change_name: "İsmi değiştir",
    change_username: "Kullanıcı adını değiştir",
    set_name: "İsmi ayarla",
    email_changed: "E-posta değiştirildi.",
    password_changed: "Şifre değiştirildi.",
    updated: "{{target}} g\xfcncellendi.",
    linked: "{{target}} bağlandı.",
    unlinked: "{{target}} bağlantısı kesildi.",
    email_exists_reminder: "Bu e-posta {{email}}, mevcut bir hesapla ilişkilendirilmiştir. Başka bir e-posta bağlayın.",
    unlink_confirm_text: "Evet, bağlantıyı kes",
    unlink_reminder: "Bağlantıyı keserseniz, kullanıcılar <span></span> hesabıyla giriş yapamazlar. Devam etmek istediğinizden emin misiniz?"
};
var $62308cb1b42bca92$export$2e2bcd8739ae039 = Object.freeze($62308cb1b42bca92$var$profile);


const $9f76d28bc6baffc9$var$protected_app = {
    name: "Korunaklı Uygulama",
    title: "Korunaklı Bir Uygulama Oluştur: Kimlik doğrulamayı basitlik ve epik hızla ekleyin",
    description: "Korunaklı Uygulama g\xfcvenli bir şekilde kullanıcı oturumlarını korur ve uygulama isteklerinizi proxyler. Cloudflare Workers tarafından desteklenerek, d\xfcnya \xe7apında \xfcst\xfcn performanstan ve 0 ms soğuk başlatmadan faydalanın. <a>Daha fazlasını \xf6ğrenin</a>",
    fast_create: "Hızlı oluştur",
    modal_title: "Korunaklı Uygulama Oluştur",
    modal_subtitle: "Tıklamalarla g\xfcvenli ve hızlı koruma etkinleştirin. Mevcut web uygulamanıza kolayca kimlik doğrulama ekleyin.",
    form: {
        url_field_label: "Orijin URL'iniz",
        url_field_placeholder: "https://domain.com/",
        url_field_description: "Kimlik doğrulama koruması gereken uygulamanızın adresini sağlayın.",
        url_field_modification_notice: "Orijin URL'sinde yapılan değişiklikler, k\xfcresel ağ konumlarında etkin olmak i\xe7in 1-2 dakika s\xfcrebilir.",
        url_field_tooltip: "Uygulamanızın adresini sağlayın, '/dizinadı' hari\xe7. Oluşturduktan sonra, rotanızın kimlik doğrulama kurallarını \xf6zelleştirebilirsiniz.\n\nNot: Orijinal URL kendisi kimlik doğrulamayı gerektirmiyor; koruma yalnızca belirlenmiş uygulama alanı \xfczerinden erişimlere uygulanır.",
        domain_field_label: "Uygulama alanı",
        domain_field_placeholder: "alan-adınız",
        domain_field_description: "Bu URL, orijinal URL i\xe7in bir kimlik doğrulama koruma proxyi olarak hizmet verir. \xd6zel alan oluşturulduktan sonra uygulanabilir.",
        domain_field_description_short: "Bu URL, orijinal URL i\xe7in bir kimlik doğrulama koruma proxyi olarak hizmet verir.",
        domain_field_tooltip: "Logto tarafından korunan uygulamalar varsayılan olarak 'alan-adınız.{{domain}}' şeklinde barındırılacaktır. \xd6zel alan oluşturulduktan sonra uygulanabilir.",
        create_application: "Uygulama oluştur",
        create_protected_app: "Hızlı oluştur",
        errors: {
            domain_required: "Alan adınız gereklidir.",
            domain_in_use: "Bu alt alan adı zaten kullanılıyor.",
            invalid_domain_format: "Ge\xe7ersiz alt alan adı formatı: sadece k\xfc\xe7\xfck harfler, sayılar ve kısa \xe7izgiler '-' kullanın.",
            url_required: "Orijin URL'si gereklidir.",
            invalid_url: "Ge\xe7ersiz orijin URL formatı: http:// veya https:// kullanın. Not: '/dizinadı' şu anda desteklenmiyor.",
            localhost: "L\xfctfen \xf6nce yerel sunucunuzu internete a\xe7ın. <a>Yerel geliştirme</a> hakkında daha fazla bilgi edinin."
        }
    },
    success_message: "\uD83C\uDF89 Uygulama kimlik doğrulaması başarıyla etkinleştirildi! Web sitenizin yeni deneyimini keşfedin."
};
var $9f76d28bc6baffc9$export$2e2bcd8739ae039 = Object.freeze($9f76d28bc6baffc9$var$protected_app);


const $f751ed1cb73876e5$var$role_details = {
    back_to_roles: "Rollere D\xf6n",
    identifier: "Tanımlayıcı",
    delete_description: "Bunu yapmak, rolle ilişkili izinleri etkilenen kullanıcılardan kaldırır ve roller, kullanıcılar ve izinler arasındaki eşleştirmeyi siler.",
    role_deleted: "{{name}} başarıyla silindi.",
    general_tab: "Genel",
    users_tab: "Kullanıcılar",
    m2m_apps_tab: "Makine-makine uygulamaları",
    permissions_tab: "İzinler",
    settings: "Ayarlar",
    settings_description: "Roller, kullanıcılara atanabilen izinlerin bir gruplamasıdır. Ayrıca, farklı API'ler i\xe7in tanımlanan izinleri biriktirmek i\xe7in bir yol sağladıkları i\xe7in, izinleri kullanıcılara bireysel olarak atamaktan daha verimli bir şekilde eklemek, kaldırmak veya ayarlamak i\xe7in bir yoldur.",
    field_name: "Adı",
    field_description: "A\xe7ıklama",
    field_is_default: "Varsayılan rol",
    field_is_default_description: "Bu rol\xfc yeni kullanıcılar i\xe7in varsayılan rol olarak ayarla. Birden \xe7ok varsayılan rol belirlenebilir. Bu ayrıca Y\xf6netim API'si aracılığıyla oluşturulan kullanıcılar i\xe7in varsayılan rolleri etkiler.",
    type_m2m_role_tag: "Makine-makine uygulama rol\xfc",
    type_user_role_tag: "Kullanıcı rol\xfc",
    m2m_role_notification: "Bu makineye makine rol\xfcn\xfc ilgili API kaynaklarına erişim sağlamak i\xe7in bir makineye makine uygulamasına atayın. <a>Hen\xfcz yapmadıysanız \xf6nce bir makineye makine uygulaması oluşturun.</a>",
    permission: {
        assign_button: "İzinleri Ata",
        assign_title: "İzinleri Ata",
        assign_subtitle: "Bu role izinler atanır. Rol, eklenen izinleri alır ve bu role sahip kullanıcılar bu izinleri devralır.",
        assign_form_field: "İzinleri Ata",
        added_text_one: "{{count, number}} izin eklendi",
        added_text_other: "{{count, number}} izinler eklendi",
        api_permission_count_one: "{{count, number}} izin",
        api_permission_count_other: "{{count, number}} izinler",
        confirm_assign: "İzinleri Ata",
        permission_assigned: "Se\xe7ilen izinler bu role başarıyla atandı",
        deletion_description: "Bu izin kaldırılırsa, bu role sahip etkilenen kullanıcı sahip olduğu erişimi kaybeder.",
        permission_deleted: 'İzin "{{name}}" bu rol i\xe7in başarıyla kaldırıldı',
        empty: "Mevcut izin yok"
    },
    users: {
        assign_button: "Kullanıcıları Ata",
        name_column: "Kullanıcı",
        app_column: "Uygulama",
        latest_sign_in_column: "Son giriş",
        delete_description: "Bu rol i\xe7in yetkilendirme kaybeder ancak kullanıcı havuzunuzda kalır.",
        deleted: "{{name}} bu rolden başarıyla kaldırıldı",
        assign_title: "Kullanıcılar Ata",
        assign_subtitle: "Kullanıcıları bu role atayın. İsim, e-posta, telefon veya kullanıcı kimliği arayarak uygun kullanıcıları bulun.",
        assign_field: "Kullanıcıları Ata",
        confirm_assign: "Kullanıcıları Ata",
        assigned_toast_text: "Se\xe7ilen kullanıcılar bu role başarıyla atandı",
        empty: "Mevcut kullanıcı yok"
    },
    applications: {
        assign_button: "Uygulamaları Ata",
        name_column: "Uygulama",
        app_column: "Uygulamalar",
        description_column: "A\xe7ıklama",
        delete_description: "Bunu yaparsanız, uygulama havuzunuzda kalır, ancak bu role ait yetkileri kaybeder.",
        deleted: "{{name}} bu rolden başarıyla kaldırıldı",
        assign_title: "Uygulamaları Ata",
        assign_subtitle: "Bu role uygulamaları atayın. İsim, a\xe7ıklama veya uygulama kimliği arayarak uygun uygulamaları bulun.",
        assign_field: "Uygulamaları Ata",
        confirm_assign: "Uygulamaları Ata",
        assigned_toast_text: "Se\xe7ilen uygulamalar bu role başarıyla atandı",
        empty: "Mevcut uygulama yok"
    }
};
var $f751ed1cb73876e5$export$2e2bcd8739ae039 = Object.freeze($f751ed1cb73876e5$var$role_details);


const $5a3935ab16797ad5$var$roles = {
    page_title: "Roller",
    title: "Roller",
    subtitle: "Roller, bir kullanıcının ne yapabileceğini belirleyen izinleri i\xe7erir. RBAC, kullanıcılara belirli işlemler i\xe7in kaynaklara erişim vermek i\xe7in roller kullanır.",
    create: "Rol Oluştur",
    role_name: "Rol adı",
    role_type: "Rol tipi",
    show_role_type_button_text: "Daha fazla se\xe7enek g\xf6ster",
    hide_role_type_button_text: "Daha fazla se\xe7eneği gizle",
    type_user: "Kullanıcı rol\xfc",
    type_machine_to_machine: "Makine-makine uygulama rol\xfc",
    role_description: "A\xe7ıklama",
    role_name_placeholder: "Rol adınızı girin",
    role_description_placeholder: "Rol a\xe7ıklamanızı girin",
    col_roles: "Roller",
    col_type: "T\xfcr",
    col_description: "A\xe7ıklama",
    col_assigned_entities: "Atanan",
    user_counts: "{{count}} kullanıcılar",
    application_counts: "{{count}} uygulamalar",
    user_count: "{{count}} kullanıcı",
    application_count: "{{count}} uygulama",
    assign_permissions: "İzinleri Ata",
    create_role_title: "Rol Oluştur",
    create_role_description: "Uygulamalarınız i\xe7in rolleri oluşturun ve y\xf6netin. Roller, izin koleksiyonlarını i\xe7erir ve kullanıcılara atanabilir.",
    create_role_button: "Rol Oluştur",
    role_created: "{{name}} rol\xfc başarıyla oluşturuldu.",
    search: "Rol adı, a\xe7ıklama veya kimlik numarasına g\xf6re arama yapın",
    placeholder_title: "Roller",
    placeholder_description: "Roller, kullanıcılara atanabilecek izinlerin gruplandırmasıdır. Rolleri oluşturmadan \xf6nce izin eklediğinizden emin olun.",
    assign_user_roles: "Kullanıcı rolleri atayın",
    assign_m2m_roles: "Makine ile makine rolleri atayın",
    management_api_access_notification: "Logto Y\xf6netim API erişimi i\xe7in y\xf6netim API izinleri olan rolleri se\xe7in <flag/>.",
    with_management_api_access_tip: "Bu makine ile makine rol\xfc, Logto y\xf6netim API izinlerini i\xe7erir"
};
var $5a3935ab16797ad5$export$2e2bcd8739ae039 = Object.freeze($5a3935ab16797ad5$var$roles);


const $236d7e12288124a1$var$session_expired = {
    title: "Oturum S\xfcresi Doldu",
    subtitle: "Oturumunuzun s\xfcresi dolmuş ve bağlantınız kesilmiş olabilir. Y\xf6netici konsolunda tekrar oturum a\xe7mak i\xe7in aşağıdaki butona tıklayınız.",
    button: "Yeniden Giriş Yap"
};
var $236d7e12288124a1$export$2e2bcd8739ae039 = Object.freeze($236d7e12288124a1$var$session_expired);


const $18fe7f0e49bc926d$var$content = {
    terms_of_use: {
        title: "TERMS",
        terms_of_use: "Terms of use URL",
        terms_of_use_placeholder: "https://your.terms.of.use/",
        privacy_policy: "Privacy policy URL",
        privacy_policy_placeholder: "https://your.privacy.policy/"
    },
    languages: {
        title: "LANGUAGES",
        enable_auto_detect: "Enable auto-detect",
        description: "Your software detects the user's locale setting and switches to the local language. You can add new languages by translating UI from English to another language.",
        manage_language: "Manage language",
        default_language: "Default language",
        default_language_description_auto: "The default language will be used when the detected user language isn’t covered in the current language library.",
        default_language_description_fixed: "When auto-detect is off, the default language is the only language your software will show. Turn on auto-detect for language extension."
    },
    manage_language: {
        title: "Manage language",
        subtitle: "Localize the product experience by adding languages and translations. Your contribution can be set as the default language.",
        add_language: "Add Language",
        logto_provided: "Logto provided",
        key: "Key",
        logto_source_values: "Logto source values",
        custom_values: "Custom values",
        clear_all_tip: "Clear all values",
        unsaved_description: "Changes won’t be saved if you leave this page without saving.",
        deletion_tip: "Delete the language",
        deletion_title: "Do you want to delete the added language?",
        deletion_description: "After deletion, your users won’t be able to browse in that language again.",
        default_language_deletion_title: "Default language can’t be deleted.",
        default_language_deletion_description: "{{language}} is set as your default language and can’t be deleted. "
    }
};
var $18fe7f0e49bc926d$export$2e2bcd8739ae039 = Object.freeze($18fe7f0e49bc926d$var$content);


const $fa47cf03fe9e3b57$var$password_policy = {
    password_requirements: "Parola gereksinimleri",
    minimum_length: "Minimum uzunluk",
    minimum_length_description: "NIST \xf6nerilerine g\xf6re, web \xfcr\xfcnleri i\xe7in en az <a>8 karakter</a> kullanın.",
    minimum_length_error: "Minimum uzunluk {{min}} ile {{max}} (dahil) arasında olmalıdır.",
    minimum_required_char_types: "Minimum gereken karakter tipleri",
    minimum_required_char_types_description: "Karakter tipleri: b\xfcy\xfck harfler (A-Z), k\xfc\xe7\xfck harfler (a-z), sayılar (0-9) ve \xf6zel semboller ({{symbols}}).",
    password_rejection: "Parola reddi",
    compromised_passwords: "Etkilenen şifreleri reddet",
    breached_passwords: "Veri tabanında yer alan şifreleri reddet",
    breached_passwords_description: "Daha \xf6nceki ihlal veritabanlarında bulunan şifreleri reddet.",
    restricted_phrases: "D\xfcş\xfck g\xfcvenlikli ifadeleri kısıtla",
    restricted_phrases_tooltip: "Parolanız 3 ya da daha fazla karakterle birleştirilmediği s\xfcrece bu ifadelerden ka\xe7ınmalıdır.",
    repetitive_or_sequential_characters: "Tekrarlayan veya ardışık karakterler",
    repetitive_or_sequential_characters_description: '\xd6rn., "AAAA", "1234" ve "abcd".',
    user_information: "Kullanıcı bilgisi",
    user_information_description: "\xd6rn., e-posta adresi, telefon numarası, kullanıcı adı vb.",
    custom_words: "\xd6zel kelimeler",
    custom_words_description: "Bağlamla ilgili kelimeleri kişiselleştirin, k\xfc\xe7\xfck/b\xfcy\xfck harf duyarsız ve satır başına bir kelime olacak şekilde.",
    custom_words_placeholder: "Servis adınız, şirket adınız, vb."
};
var $fa47cf03fe9e3b57$export$2e2bcd8739ae039 = Object.freeze($fa47cf03fe9e3b57$var$password_policy);


const $659caaaec289f32e$var$sign_up_and_sign_in = {
    identifiers_email: "E-posta adresi",
    identifiers_phone: "Telefon numarası",
    identifiers_username: "Kullanıcı adı",
    identifiers_email_or_sms: "E-posta adresi veya telefon numarası",
    identifiers_none: "Ge\xe7ersiz",
    and: "ve",
    or: "veya",
    sign_up: {
        title: "KAYDOL",
        sign_up_identifier: "Kayıt tanımlayıcı",
        identifier_description: "Hesap oluşturmak i\xe7in kayıt tanımlayıcı gereklidir ve giriş ekranınıza dahil edilmelidir.",
        sign_up_authentication: "Kaydolma doğrulama ayarları",
        authentication_description: "Se\xe7ilen t\xfcm işlemler, kullanıcıların akışı tamamlamaları zorunlu olacaktır.",
        set_a_password_option: "Şifrenizi oluşturun",
        verify_at_sign_up_option: "Kaydolduğunuzda doğrulayın",
        social_only_creation_description: "(Bu sadece sosyal hesap yaratımı i\xe7in ge\xe7erlidir)"
    },
    sign_in: {
        title: "OTURUM A\xc7IN",
        sign_in_identifier_and_auth: "Oturum a\xe7ma tanımlayıcısı ve doğrulama ayarları",
        description: "Kullanıcılar mevcut se\xe7eneklerden herhangi biriyle oturum a\xe7abilir. Aşağıdaki se\xe7enekleri s\xfcr\xfckleyip bırakarak d\xfczenleyin.",
        add_sign_in_method: "Oturum a\xe7ma y\xf6ntemi ekle",
        password_auth: "Şifre",
        verification_code_auth: "Doğrulama kodu",
        auth_swap_tip: "Akışta ilk olarak hangisinin g\xf6r\xfcnd\xfcğ\xfcn\xfc belirlemek i\xe7in se\xe7eneklerin yerlerini değiştirin.",
        require_auth_factor: "En az bir doğrulama fakt\xf6r\xfc se\xe7meniz gerekiyor."
    },
    social_sign_in: {
        title: "SOSYAL MEDYA İLE OTURUM A\xc7IN",
        social_sign_in: "Sosyal medya ile oturum a\xe7ın",
        description: "Kullanıcı, sosyal bağlantı noktası aracılığıyla kaydolurken belirlediğiniz zorunlu tanımlayıcıya bağlı olarak bir tanımlayıcı sağlaması istenebilir.",
        add_social_connector: "Sosyal Bağlantı Noktası Ekle",
        set_up_hint: {
            not_in_list: "Listede değil mi?",
            set_up_more: "Daha fazlasını kur",
            go_to: "şimdi farklı sosyal bağlantı noktalarına."
        }
    },
    tip: {
        set_a_password: "Kullanıcı adınıza benzersiz bir şifre belirlemek şarttır.",
        verify_at_sign_up: "Şu anda yalnızca doğrulanmış e-postayı destekliyoruz. Doğrulama yapılmazsa kullanıcı kitleniz d\xfcş\xfck kaliteli e-posta adreslerini i\xe7erebilir.",
        password_auth: "Bu, kaydolma işlemi sırasında bir şifre belirleme se\xe7eneğini etkinleştirdiğiniz i\xe7in \xf6nemlidir.",
        verification_code_auth: "Bu, yalnızca doğrulama kodu sağlama se\xe7eneğini etkinleştirdiğiniz i\xe7in \xf6nemlidir. Kayıt işlemi sırasında şifre oluşturma izni verildiğinde kutuyu kaldırabilirsiniz.",
        delete_sign_in_method: "Bu, {{identifier}} gerekliliğini belirlediğiniz i\xe7in \xf6nemlidir."
    },
    advanced_options: {
        title: "GELİŞMİŞ SE\xc7ENEKLER",
        enable_single_sign_on: "Kurumsal Tek Oturum A\xe7mayı Etkinleştir (SSO)",
        enable_single_sign_on_description: "Kullanıcıların kurumsal kimlikleriyle Tek Oturum A\xe7mayı etkinleştirin.",
        single_sign_on_hint: {
            prefix: "Şuraya git: ",
            link: '"Kurumsal Tek Oturum A\xe7ma"',
            suffix: "b\xf6l\xfcm\xfcne daha fazla kurumsal bağlantı noktası kurmak i\xe7in."
        },
        enable_user_registration: "Kullanıcı Kaydını Etkinleştir",
        enable_user_registration_description: "Kullanıcı kaydını etkinleştir veya devre dışı bırak. Devre dışı bırakıldığında, kullanıcılar y\xf6netici konsolunda hala eklenilebilir, ancak kullanıcılar artık oturum a\xe7ma aray\xfcz\xfc \xfczerinden hesap oluşturamaz."
    }
};
var $659caaaec289f32e$export$2e2bcd8739ae039 = Object.freeze($659caaaec289f32e$var$sign_up_and_sign_in);


const $076a21ada18324dd$var$sign_in_exp = {
    page_title: "Oturum A\xe7ma Deneyimi",
    title: "Oturum A\xe7ma Deneyimi",
    description: "Oturum a\xe7ma kullanıcı aray\xfcz\xfcn\xfc markanıza uyacak şekilde \xf6zelleştirin ve ger\xe7ek zamanlı olarak g\xf6r\xfcnt\xfcleyin",
    tabs: {
        branding: "Markalaşma",
        sign_up_and_sign_in: "Kaydol ve Oturum A\xe7",
        content: "İ\xe7erik",
        password_policy: "Şifre politikası"
    },
    welcome: {
        title: "Oturum a\xe7ma deneyimini \xf6zelleştirin",
        description: "İlk oturum a\xe7ma işleminizi hızlı bir şekilde başlatın. Bu kılavuz, t\xfcm gerekli ayarları size anlatır.",
        get_started: "Başla",
        apply_remind: "L\xfctfen unutmayın ki, oturum a\xe7ma deneyimi bu hesap altındaki t\xfcm uygulamalar i\xe7in ge\xe7erli olacaktır."
    },
    color: {
        title: "RENK",
        primary_color: "Marka rengi",
        dark_primary_color: "Marka rengi (Koyu)",
        dark_mode: "Koyu modu etkinleştir",
        dark_mode_description: "Uygulamanız, markanızın rengine ve logo algoritmasına g\xf6re otomatik olarak oluşturulmuş bir koyu mod temasına sahip olacaktır. \xd6zelleştirmekte \xf6zg\xfcrs\xfcn\xfcz.",
        dark_mode_reset_tip: "Marka rengine g\xf6re koyu mod rengini yeniden hesaplayınız.",
        reset: "Yeniden hesapla"
    },
    branding: {
        title: "MARKA ALANI",
        ui_style: "Stil",
        favicon: "Favicon",
        logo_image_url: "Uygulama logosu resim URLi",
        logo_image_url_placeholder: "https://your.cdn.domain/logo.png",
        dark_logo_image_url: "Uygulama logosu resim URLi (Koyu)",
        dark_logo_image_url_placeholder: "https://your.cdn.domain/logo-dark.png",
        logo_image: "Uygulama logosu",
        dark_logo_image: "Uygulama logosu (Koyu)",
        logo_image_error: "Uygulama logosu: {{error}}",
        favicon_error: "Favicon: {{error}}"
    },
    custom_css: {
        title: "\xd6zel CSS",
        css_code_editor_title: "UI'ınızı \xd6zel CSS ile kişiselleştirin",
        css_code_editor_description1: "\xd6zel CSS \xf6rneğini g\xf6r\xfcnt\xfcleyin.",
        css_code_editor_description2: "<a>{{link}}</a>.",
        css_code_editor_description_link_content: "Daha fazlası i\xe7in buraya tıklayın",
        css_code_editor_content_placeholder: "Tam olarak istediğiniz gibi o herhangi bir şeyin stilini kişiselleştirmek i\xe7in \xf6zel CSS'nizi girin. Yaratıcılığınızı ifade edin ve UI'ınızın dikkat \xe7ekmesini sağlayın."
    },
    sign_up_and_sign_in: $659caaaec289f32e$export$2e2bcd8739ae039,
    content: $18fe7f0e49bc926d$export$2e2bcd8739ae039,
    password_policy: $fa47cf03fe9e3b57$export$2e2bcd8739ae039,
    setup_warning: {
        no_connector_sms: 'Hen\xfcz SMS konekt\xf6r\xfc kurulmadı. Yapılandırmayı tamamlamadan \xf6nce, kullanıcılar bu y\xf6ntemle oturum a\xe7amazlar. "Konekt\xf6rler"deki <a>{{link}}</a>',
        no_connector_email: 'Hen\xfcz e-posta konekt\xf6r\xfc kurulmadı. Yapılandırmayı tamamlamadan \xf6nce, kullanıcılar bu y\xf6ntemle oturum a\xe7amazlar. "Konekt\xf6rler"deki <a>{{link}}</a>',
        no_connector_social: 'Hen\xfcz hi\xe7bir sosyal bağlayıcıyı ayarlamadınız. Sosyal giriş y\xf6ntemlerini uygulamak i\xe7in \xf6nce bağlayıcı ekleyin. "Bağlayıcılar" b\xf6l\xfcm\xfcnde <a>{{link}}</a> g\xf6r\xfcnt\xfcleyin.',
        setup_link: "Kurulum yapın"
    },
    save_alert: {
        description: "Yeni oturum a\xe7ma ve kaydolma prosed\xfcrlerini uygulamaktasınız. T\xfcm kullanıcılarınız yeni kurulumdan etkilenebilirler. Değişikliği ger\xe7ekleştirmek istediğinize emin misiniz?",
        before: "\xd6nce",
        after: "Sonra",
        sign_up: "Kaydolma",
        sign_in: "Oturum A\xe7ma",
        social: "Sosyal"
    },
    preview: {
        title: "Oturum A\xe7ma \xd6nizlemesi",
        live_preview: "Canlı \xf6nizleme",
        live_preview_tip: "Değişiklikleri g\xf6rmek i\xe7in kaydedin",
        native: "Doğal",
        desktop_web: "Masa\xfcst\xfc Web",
        mobile_web: "Mobil Web",
        desktop: "Masa\xfcst\xfc",
        mobile: "Mobil"
    }
};
var $076a21ada18324dd$export$2e2bcd8739ae039 = Object.freeze($076a21ada18324dd$var$sign_in_exp);


const $faa9ff4a05896d87$var$signing_keys = {
    title: "İmza Anahtarları",
    description: "Uygulamalarınız tarafından kullanılan imza anahtarlarını g\xfcvenli bir şekilde y\xf6netin.",
    private_key: "OIDC \xf6zel anahtarları",
    private_keys_description: "OIDC \xf6zel anahtarları JWT belgelerini imzalamak i\xe7in kullanılır.",
    cookie_key: "OIDC \xe7erez anahtarları",
    cookie_keys_description: "OIDC \xe7erez anahtarları \xe7erezleri imzalamak i\xe7in kullanılır.",
    private_keys_in_use: "Kullanılan \xf6zel anahtarlar",
    cookie_keys_in_use: "Kullanılan \xe7erez anahtarları",
    rotate_private_keys: "\xd6zel anahtarları d\xf6nd\xfcr",
    rotate_cookie_keys: "\xc7erez anahtarlarını d\xf6nd\xfcr",
    rotate_private_keys_description: "Bu işlem yeni bir \xf6zel imzalama anahtarı oluşturacak, mevcut anahtarı d\xf6nd\xfcrecek ve \xf6nceki anahtarınızı kaldıracak. G\xfcncel anahtar ile imzalanmış JWT jetonlarınız silinene veya başka bir d\xf6nd\xfcrme turuna kadar ge\xe7erli kalacaktır.",
    rotate_cookie_keys_description: "Bu işlem yeni bir \xe7erez anahtarı oluşturacak, mevcut anahtarı d\xf6nd\xfcrecek ve \xf6nceki anahtarınızı kaldıracak. G\xfcncel anahtar ile imzalanmış \xe7erezleriniz silinene veya başka bir d\xf6nd\xfcrme turuna kadar ge\xe7erli kalacaktır.",
    select_private_key_algorithm: "Yeni \xf6zel anahtar i\xe7in imzalama anahtar algoritmasını se\xe7in",
    rotate_button: "D\xf6nd\xfcr",
    table_column: {
        id: "Kimlik",
        status: "Durum",
        algorithm: "İmzalama anahtar algoritması"
    },
    status: {
        current: "Ge\xe7erli",
        previous: "\xd6nceki"
    },
    reminder: {
        rotate_private_key: "<strong>OIDC \xf6zel anahtarlarını</strong> d\xf6nd\xfcrmek istediğinizden emin misiniz? Yeni verilen JWT jetonları yeni anahtarla imzalanacaktır. Var olan JWT jetonları, tekrar d\xf6nd\xfcr\xfcnceye kadar ge\xe7erli kalacaktır.",
        rotate_cookie_key: "<strong>OIDC \xe7erez anahtarlarını</strong> d\xf6nd\xfcrmek istediğinizden emin misiniz? Oturum a\xe7ma oturumlarında yeni oluşturulan \xe7erezler yeni \xe7erez anahtarıyla imzalanacaktır. Var olan \xe7erezler, tekrar d\xf6nd\xfcr\xfcnceye kadar ge\xe7erli kalacaktır.",
        delete_private_key: "<strong>OIDC \xf6zel anahtarını</strong> silmek istediğinizden emin misiniz? Bu \xf6zel imzalama anahtarı ile imzalanan mevcut JWT jetonları artık ge\xe7erli olmayacaktır.",
        delete_cookie_key: "<strong>OIDC \xe7erez anahtarını</strong> silmek istediğinizden emin misiniz? Bu \xe7erez anahtarı ile imzalanan eski oturum a\xe7ma oturumları artık ge\xe7erli olmayacaktır. Bu kullanıcılar i\xe7in yeniden kimlik doğrulaması gereklidir."
    },
    messages: {
        rotate_key_success: "İmzalama anahtarları başarıyla d\xf6nd\xfc",
        delete_key_success: "Anahtar başarıyla silindi"
    }
};
var $faa9ff4a05896d87$export$2e2bcd8739ae039 = Object.freeze($faa9ff4a05896d87$var$signing_keys);


const $69c15100c9b82293$var$quota_item = {
    tenant_limit: {
        name: "Kiracilar",
        limited: "{{count, number}} kiracı",
        limited_other: "{{count, number}} kiracılar",
        unlimited: "Sınırsız kiracılar",
        not_eligible: "Kiracılarınızı kaldırın"
    },
    mau_limit: {
        name: "Aylık aktif kullanıcılar",
        limited: "{{count, number}} MAU",
        unlimited: "Sınırsız MAU",
        not_eligible: "T\xfcm kullanıcılarınızı kaldırın"
    },
    token_limit: {
        name: "Tokenlar",
        limited: "{{count, number}} token",
        limited_other: "{{count, number}} tokenlar",
        unlimited: "Sınırsız tokenlar",
        not_eligible: "Yeni tokenları \xf6nlemek i\xe7in t\xfcm kullanıcılarınızı kaldırın"
    },
    applications_limit: {
        name: "Uygulamalar",
        limited: "{{count, number}} uygulama",
        limited_other: "{{count, number}} uygulamalar",
        unlimited: "Sınırsız uygulamalar",
        not_eligible: "Uygulamalarınızı kaldırın"
    },
    machine_to_machine_limit: {
        name: "Makineye makine",
        limited: "{{count, number}} makineye makine uygulama",
        limited_other: "{{count, number}} makineye makine uygulamalar",
        unlimited: "Sınırsız makineye makine uygulamalar",
        not_eligible: "Makineye makine uygulamalarınızı kaldırın"
    },
    third_party_applications_limit: {
        name: "\xdc\xe7\xfcnc\xfc taraf uygulamalar",
        limited: "{{count, number}} \xfc\xe7\xfcnc\xfc taraf uygulama",
        limited_other: "{{count, number}} \xfc\xe7\xfcnc\xfc taraf uygulamalar",
        unlimited: "Sınırsız \xfc\xe7\xfcnc\xfc taraf uygulamalar",
        not_eligible: "\xdc\xe7\xfcnc\xfc taraf uygulamalarınızı kaldırın"
    },
    resources_limit: {
        name: "API kaynakları",
        limited: "{{count, number}} API kaynak",
        limited_other: "{{count, number}} API kaynakları",
        unlimited: "Sınırsız API kaynakları",
        not_eligible: "API kaynaklarınızı kaldırın"
    },
    scopes_per_resource_limit: {
        name: "Kaynak izinleri",
        limited: "{{count, number}} izin kaynak başına",
        limited_other: "{{count, number}} izinler kaynak başına",
        unlimited: "Sınırsız izin kaynak başına",
        not_eligible: "Kaynak izinlerinizi kaldırın"
    },
    custom_domain_enabled: {
        name: "\xd6zel alan adı",
        limited: "\xd6zel alan adı",
        unlimited: "\xd6zel alan adı",
        not_eligible: "\xd6zel alan adınızı kaldırın"
    },
    omni_sign_in_enabled: {
        name: "Omni oturumu a\xe7",
        limited: "Omni oturumu a\xe7",
        unlimited: "Omni oturumu a\xe7",
        not_eligible: "Omni oturumunu devre dışı bırakın"
    },
    built_in_email_connector_enabled: {
        name: "Dahili e-posta bağlayıcı",
        limited: "Dahili e-posta bağlayıcı",
        unlimited: "Dahili e-posta bağlayıcı",
        not_eligible: "Dahili e-posta bağlayıcınızı kaldırın"
    },
    social_connectors_limit: {
        name: "Sosyal bağlayıcılar",
        limited: "{{count, number}} sosyal bağlayıcı",
        limited_other: "{{count, number}} sosyal bağlayıcılar",
        unlimited: "Sınırsız sosyal bağlayıcılar",
        not_eligible: "Sosyal bağlayıcılarınızı kaldırın"
    },
    standard_connectors_limit: {
        name: "\xdccretsiz standart bağlayıcılar",
        limited: "{{count, number}} \xfccretsiz standart bağlayıcı",
        limited_other: "{{count, number}} \xfccretsiz standart bağlayıcılar",
        unlimited: "Sınırsız standart bağlayıcılar",
        not_eligible: "Standart bağlayıcılarınızı kaldırın"
    },
    roles_limit: {
        name: "Roller",
        limited: "{{count, number}} rol",
        limited_other: "{{count, number}} roller",
        unlimited: "Sınırsız roller",
        not_eligible: "Rollerinizi kaldırın"
    },
    machine_to_machine_roles_limit: {
        name: "Makineye makine rolleri",
        limited: "{{count, number}} makineye makine rol\xfc",
        limited_other: "{{count, number}} makineye makine rolleri",
        unlimited: "Sınırsız makineye makine rolleri",
        not_eligible: "Makineye makine rollerinizi kaldırın"
    },
    scopes_per_role_limit: {
        name: "Rol izinleri",
        limited: "{{count, number}} izin rol başına",
        limited_other: "{{count, number}} izinler rol başına",
        unlimited: "Sınırsız izin rol başına",
        not_eligible: "Rol izinlerinizi kaldırın"
    },
    hooks_limit: {
        name: "Webhooks",
        limited: "{{count, number}} webhook",
        limited_other: "{{count, number}} webhooks",
        unlimited: "Sınırsız webhooklar",
        not_eligible: "Webhooklarınızı kaldırın"
    },
    organizations_enabled: {
        name: "Organizasyonlar",
        limited: "Organizasyonlar",
        unlimited: "Organizasyonlar",
        not_eligible: "Organizasyonlarınızı kaldırın"
    },
    audit_logs_retention_days: {
        name: "Denetim g\xfcnl\xfckleri saklama s\xfcresi",
        limited: "Denetim g\xfcnl\xfckleri saklama s\xfcresi: {{count, number}} g\xfcn",
        limited_other: "Denetim g\xfcnl\xfckleri saklama s\xfcresi: {{count, number}} g\xfcn",
        unlimited: "Sınırsız g\xfcnler",
        not_eligible: "Denetim g\xfcnl\xfcğ\xfcn\xfcz yok"
    },
    email_ticket_support: {
        name: "E-posta bilet desteği",
        limited: "{{count, number}} saat e-posta bilet desteği",
        limited_other: "{{count, number}} saat e-posta bilet desteği",
        unlimited: "E-posta bilet desteği",
        not_eligible: "E-posta bilet desteği yok"
    },
    mfa_enabled: {
        name: "\xc7ok fakt\xf6rl\xfc kimlik doğrulama",
        limited: "\xc7ok fakt\xf6rl\xfc kimlik doğrulama",
        unlimited: "\xc7ok fakt\xf6rl\xfc kimlik doğrulama",
        not_eligible: "\xc7ok fakt\xf6rl\xfc kimlik doğrulamanızı kaldırın"
    },
    sso_enabled: {
        name: "Kurumsal SSO",
        limited: "Kurumsal SSO",
        unlimited: "Kurumsal SSO",
        not_eligible: "Kurumsal SSO'nuzu kaldırın"
    },
    tenant_members_limit: {
        name: "Kiracı \xfcyeleri",
        limited: "{{count, number}} kiracı \xfcyesi",
        limited_other: "{{count, number}} kiracı \xfcyeleri",
        unlimited: "Sınırsız kiracı \xfcyeleri",
        not_eligible: "Kiracı \xfcyelerinizi kaldırın"
    },
    custom_jwt_enabled: {
        name: "\xd6zel JWT",
        limited: "\xd6zel JWT",
        unlimited: "\xd6zel JWT",
        not_eligible: "JWT taleplerinizin \xf6zelleştiricisini kaldırın"
    }
};
var $69c15100c9b82293$export$2e2bcd8739ae039 = Object.freeze($69c15100c9b82293$var$quota_item);


const $51b53f7ef5850776$var$quota_table = {
    quota: {
        title: "Temel",
        base_price: "Temel fiyat",
        mau_limit: "MAU limiti",
        included_tokens: "Dahil olan jetonlar"
    },
    application: {
        title: "Uygulamalar",
        total: "Toplam uygulama sayısı",
        m2m: "Makine-makine uygulamaları",
        third_party: "\xdc\xe7\xfcnc\xfc taraf uygulamalar"
    },
    resource: {
        title: "API Kaynakları",
        resource_count: "Kaynak sayısı",
        scopes_per_resource: "Kaynak başına izinler"
    },
    branding: {
        title: "Kullanıcı Aray\xfcz\xfc ve Markalama",
        custom_domain: "\xd6zel alan adı",
        custom_css: "\xd6zel CSS",
        app_logo_and_favicon: "Uygulama logoları ve favicon",
        dark_mode: "Karanlık mod",
        i18n: "Uluslararasılaştırma"
    },
    user_authn: {
        title: "Kullanıcı Kimlik Doğrulama",
        omni_sign_in: "\xc7oklu oturum a\xe7ma",
        password: "Parola",
        passwordless: "Parolasız - E-posta ve SMS",
        email_connector: "E-posta bağlayıcı",
        sms_connector: "SMS bağlayıcı",
        social_connectors: "Sosyal bağlayıcılar",
        standard_connectors: "Standart bağlayıcılar",
        built_in_email_connector: "Dahili e-posta bağlayıcısı",
        mfa: "\xc7oklu fakt\xf6rl\xfc kimlik doğrulama",
        sso: "Kurumsal SSO",
        adaptive_mfa: "Uyarlamalı MFA"
    },
    user_management: {
        title: "Kullanıcı Y\xf6netimi",
        user_management: "Kullanıcı Y\xf6netimi",
        roles: "Roller",
        machine_to_machine_roles: "Makine-makine rolleri",
        scopes_per_role: "Rol başına izinler"
    },
    organizations: {
        title: "Organizasyon",
        organizations: "Organizasyonlar",
        organization: "Organizasyon",
        organization_count: "Organizasyon sayısı",
        allowed_users_per_org: "Organizasyon başına kullanıcılar",
        invitation: "Davet (Management API)",
        org_roles: "Organizasyon rolleri",
        org_permissions: "Organizasyon izinleri",
        just_in_time_provisioning: "İstisnai olana kadar temin"
    },
    support: {
        title: "Uyumluluk ve destek",
        community: "Topluluk",
        customer_ticket: "M\xfcşteri destek bileti",
        premium: "Premium",
        email_ticket_support: "E-posta bileti desteği",
        soc2_report: "SOC2 raporu",
        hipaa_or_baa_report: "HIPAA/BAA raporu"
    },
    developers_and_platform: {
        title: "Geliştiriciler ve platform",
        hooks: "Webhooks",
        audit_logs_retention: "Denetim kayıtları saklama",
        jwt_claims: "JWT iddiaları",
        tenant_members: "Kiracı \xfcyeleri"
    },
    unlimited: "Sınırsız",
    contact: "İletişim",
    monthly_price: "${{value, number}} / ay",
    days_one: "{{count, number}} g\xfcn",
    days_other: "{{count, number}} g\xfcn",
    add_on: "Ek Hizmet",
    tier: "Seviye{{value, number}}: ",
    paid_token_limit_tip: "Logto, kota sınırlarını aşan \xf6zellikler i\xe7in \xfccretlendirme ekleyecektir. 2024 ikinci \xe7eyreğinde başlamak \xfczere \xfccretlendirmeye kadar \xfccretsiz kullanabilirsiniz. Daha fazla tokena ihtiyacınız varsa l\xfctfen bizimle iletişime ge\xe7in. Varsayılan olarak her milyon token i\xe7in aylık $80 fatura kesmekteyiz.",
    paid_quota_limit_tip: "Logto, kota limitinizi aşan \xf6zellikler i\xe7in \xfccretlendirme ekleyecektir. Şarjımıza başlamadan \xf6nce, yaklaşık olarak 2024 Q2'ye kadar \xfccretsiz olarak kullanabilirsiniz.",
    paid_add_on_feature_tip: "Bu bir ek \xf6zelliktir. Şarjımıza başlamadan \xf6nce, yaklaşık olarak 2024 Q2'ye kadar \xfccretsiz olarak kullanabilirsiniz.",
    million: "{{value, number}} milyon",
    mau_tip: "MAU (aylık aktif kullanıcı) Logto ile en az bir jeton değiştirmiş olan benzersiz kullanıcı sayısını ifade eder.",
    tokens_tip: "Logto tarafından ihra\xe7 edilen erişim tokeni, yenileme tokeni vb. dahil olmak \xfczere t\xfcm token t\xfcrleri.",
    mao_tip: "MAO (aylık aktif kuruluş) bir fatura d\xf6ng\xfcs\xfcnde en az bir MAU'ya (aylık aktif kullanıcı) sahip olan benzersiz kuruluşların sayısını ifade eder.",
    third_party_tip: "Logto'yu \xfc\xe7\xfcnc\xfc taraf uygulama oturum a\xe7ma ve izin verme i\xe7in OIDC kimlik sağlayıcısı olarak kullanın.",
    included: "{{value, number}} dahil",
    included_mao: "{{value, number}} MAO dahil",
    extra_quota_price: "Sonra aylık ${{value, number}} / sonrasında her biri",
    per_month_each: "Aylık ${{value, number}} / her biri",
    extra_mao_price: "Sonra MAO başına ${{value, number}}",
    per_month: "Aylık ${{value, number}}",
    per_member: "Sonra ${{value, number}} her \xfcye"
};
var $51b53f7ef5850776$export$2e2bcd8739ae039 = Object.freeze($51b53f7ef5850776$var$quota_table);


const $fc61c71978a3b862$var$subscription = {
    free_plan: "\xdccretsiz Plan",
    free_plan_description: "Yan projeler ve başlangı\xe7 Logto denemeleri i\xe7in. Kredi kartı gerektirmez.",
    pro_plan: "Pro plan",
    pro_plan_description: "Endişesiz bir şekilde Logto'dan faydalanan işletmeler i\xe7in.",
    enterprise: "Kurumsal",
    current_plan: "Mevcut Plan",
    current_plan_description: "İşte mevcut planınız. Plan kullanımınızı kolayca g\xf6rebilir, \xf6n\xfcm\xfczdeki faturanızı kontrol edebilir ve ihtiya\xe7 duyduk\xe7a planınızda değişiklikler yapabilirsiniz.",
    plan_usage: "Plan kullanımı",
    plan_cycle: "Plan d\xf6ng\xfcs\xfc: {{period}}. Kullanım {{renewDate}} tarihinde yenilenir.",
    next_bill: "Bir sonraki faturanız",
    next_bill_hint: "Hesaplama hakkında daha fazla bilgi i\xe7in l\xfctfen bu <a>makaleye</a> başvurun.",
    next_bill_tip: "Burada g\xf6r\xfcnen fiyatlar vergileri i\xe7ermez. Vergi tutarı, sağladığınız bilgilere ve yerel d\xfczenleyici gereksinimlere dayalı olarak hesaplanacak ve faturalarınızda g\xf6sterilecektir.",
    manage_payment: "\xd6demeleri d\xfczenle",
    overfill_quota_warning: "Kota sınırınıza ulaştınız. Herhangi bir sorunu \xf6nlemek i\xe7in planı y\xfckseltin.",
    upgrade_pro: "Pro'ya y\xfckselt",
    update_payment: "\xd6demeyi G\xfcncelle",
    payment_error: "\xd6deme hatası tespit edildi. \xd6nceki d\xf6ng\xfc i\xe7in ${{price, number}} işlenemedi. Logto hizmeti askıya alınmasını \xf6nlemek i\xe7in \xf6demeleri g\xfcncelleyin.",
    downgrade: "D\xfcş\xfcr",
    current: "Mevcut",
    upgrade: "Y\xfckselt",
    quota_table: $51b53f7ef5850776$export$2e2bcd8739ae039,
    billing_history: {
        invoice_column: "Faturalar",
        status_column: "Durum",
        amount_column: "Miktar",
        invoice_created_date_column: "Fatura oluşturma tarihi",
        invoice_status: {
            void: "İptal Edildi",
            paid: "\xd6dendi",
            open: "A\xe7ık",
            uncollectible: "Gecikmiş"
        }
    },
    quota_item: $69c15100c9b82293$export$2e2bcd8739ae039,
    downgrade_modal: {
        title: "Emin misiniz, d\xfcş\xfcrmek istediğinize?",
        description: "Eğer <targetName/>'e ge\xe7meyi se\xe7erseniz, \xf6nceki <currentName/> i\xe7indeki kotalara ve \xf6zelliklere artık erişiminiz olmayacağını unutmayın.",
        before: "\xd6nce: <name/>",
        after: "Sonra: <name />",
        downgrade: "D\xfcş\xfcr"
    },
    not_eligible_modal: {
        downgrade_title: "D\xfcş\xfcrme i\xe7in uygun değilsiniz",
        downgrade_description: "<name/> planına d\xfcş\xfcrmeden \xf6nce aşağıdaki kriterleri sağladığınızdan emin olun.",
        downgrade_help_tip: "D\xfcş\xfcrme konusunda yardıma mı ihtiyacınız var? <a>Bizimle iletişime ge\xe7in</a>.",
        upgrade_title: "Saygıdeğer erken benimseyenlerimiz i\xe7in dostane hatırlatma",
        upgrade_description: "Şu anda <name /> tarafından izin verilenden daha fazlasını kullanıyorsunuz. Logto artık resmi olarak kullanılabilir durumda ve her plana \xf6zel \xf6zellikler sunuyor. <name />'e y\xfckseltmeyi d\xfcş\xfcnmeden \xf6nce, y\xfckseltme \xf6ncesinde aşağıdaki kriterleri karşıladığınızdan emin olun.",
        upgrade_pro_tip: " Ya da Pro plan'a ge\xe7meyi d\xfcş\xfcn\xfcn.",
        upgrade_help_tip: "Y\xfckseltme konusunda yardıma mı ihtiyacınız var? <a>Bizimle iletişime ge\xe7in</a>.",
        a_maximum_of: "<item/> i\xe7in maksimum"
    },
    upgrade_success: "Successfully upgraded to <name/>",
    downgrade_success: "Successfully downgraded to <name/>",
    subscription_check_timeout: "Abonelik kontrol\xfc zaman aşımına uğradı. L\xfctfen daha sonra yenileyin.",
    no_subscription: "Abonelik bulunamadı"
};
var $fc61c71978a3b862$export$2e2bcd8739ae039 = Object.freeze($fc61c71978a3b862$var$subscription);


const $cb975d1a064afe0e$var$tab_sections = {
    overview: "Genel Bakış",
    authentication: "Kimlik doğrulama",
    authorization: "Yetkilendirme",
    users: "Kullanıcılar",
    developer: "Geliştirici",
    tenant: "Kiracı"
};
var $cb975d1a064afe0e$export$2e2bcd8739ae039 = Object.freeze($cb975d1a064afe0e$var$tab_sections);


const $53013f07d6ece444$var$tabs = {
    get_started: "Başla",
    dashboard: "G\xf6sterge Paneli",
    applications: "Uygulamalar",
    api_resources: "API Kaynakları",
    sign_in_experience: "Oturum A\xe7ma Deneyimi",
    connectors: "Connectors",
    enterprise_sso: "Kurumsal SSO",
    webhooks: "Webhooks",
    organizations: "Organizasyonlar",
    users: "Kullanıcı Y\xf6netimi",
    audit_logs: "Denetim Kayıtları",
    roles: "Roller",
    docs: "D\xf6k\xfcmanlar",
    tenant_settings: "Ayarlar",
    mfa: "\xc7oklu fakt\xf6rl\xfc kimlik doğrulama",
    customize_jwt: "\xd6zel JWT",
    signing_keys: "İmza anahtarları",
    organization_template: "Kuruluş şablonu"
};
var $53013f07d6ece444$export$2e2bcd8739ae039 = Object.freeze($53013f07d6ece444$var$tabs);


const $481b32d550841d26$var$tenant_members = {
    members: "\xdcyeler",
    invitations: "Davetiyeler",
    invite_members: "\xdcyeleri davet et",
    user: "Kullanıcı",
    roles: "Roller",
    admin: "Y\xf6netici",
    collaborator: "İşbirlik\xe7i",
    invitation_status: "Davet durumu",
    inviter: "Davet eden",
    expiration_date: "Son kullanma tarihi",
    invite_modal: {
        title: "Logto Cloud'e Kişileri Davet Et",
        subtitle: "Bir kuruluşa \xfcye davet etmek i\xe7in daveti kabul etmeleri gerekmektedir.",
        to: "Kime",
        added_as: "Şu rollerle eklendi",
        email_input_placeholder: "johndoe@example.com"
    },
    invitation_statuses: {
        pending: "Beklemede",
        accepted: "Kabul edildi",
        expired: "S\xfcresi doldu",
        revoked: "İptal Edildi"
    },
    invitation_empty_placeholder: {
        title: "Takım \xfcyelerini davet et",
        description: "Kurumunuz şu anda davet edilen \xfcyesi bulunmamaktadır.\nEntegrasyonunuzda yardımcı olmak i\xe7in daha fazla \xfcye veya y\xf6netici eklemeyi d\xfcş\xfcn\xfcn."
    },
    menu_options: {
        edit: "Kullanıcı rol\xfcn\xfc d\xfczenle",
        delete: "Kullanıcıyı kiracıdan kaldır",
        resend_invite: "Daveti tekrar g\xf6nder",
        revoke: "Daveti iptal et",
        delete_invitation_record: "Bu davet kaydını sil"
    },
    edit_modal: {
        title: "{{name}}'in rollerini değiştir"
    },
    delete_user_confirm: "Bu kullanıcıyı kiracıdan kaldırmak istediğinizden emin misiniz?",
    assign_admin_confirm: "Se\xe7ilen kullanıcı(ları) y\xf6netici yapmak istediğinizden emin misiniz? Y\xf6netici erişimi vermek aşağıdaki izinleri verecektir.<ul><li>Kiracı fatura planını değiştirme</li><li>İşbirlik\xe7ileri ekleme veya kaldırma</li><li>Kiracıyı silme</li></ul>",
    revoke_invitation_confirm: "Bu daveti iptal etmek istediğinizden emin misiniz?",
    delete_invitation_confirm: "Bu davet kaydını silmek istediğinizden emin misiniz?",
    messages: {
        invitation_sent: "Davet g\xf6nderildi.",
        invitation_revoked: "Davet iptal edildi.",
        invitation_resend: "Davet tekrar g\xf6nderildi.",
        invitation_deleted: "Davet kaydı silindi."
    },
    errors: {
        email_required: "Davet edilen e-posta gerekli.",
        email_exists: "E-posta adresi zaten mevcut.",
        member_exists: "Bu kullanıcı zaten bu kuruluşun bir \xfcyesidir.",
        pending_invitation_exists: "Bekleyen davet mevcut. İlgili e-postayı silin veya daveti iptal edin.",
        invalid_email: "E-posta adresi ge\xe7ersiz. L\xfctfen doğru formatta olduğundan emin olun.",
        max_member_limit: "Bu kiracı i\xe7in maksimum \xfcye sayısına ulaştınız ({{limit}})."
    }
};
var $481b32d550841d26$export$2e2bcd8739ae039 = Object.freeze($481b32d550841d26$var$tenant_members);


const $40f46fb641c1b07f$var$tenants = {
    title: "Ayarlar",
    description: "Kiracı ayarlarını verimli bir şekilde y\xf6netin ve alan adınızı \xf6zelleştirin.",
    tabs: {
        settings: "Ayarlar",
        members: "\xdcyeler",
        domains: "Alan adları",
        subscription: "Plan ve faturalandırma",
        billing_history: "Fatura ge\xe7mişi"
    },
    settings: {
        title: "AYARLAR",
        description: "Kiracı adını ayarlayın ve verilerinizin barındırıldığı b\xf6lgeyi g\xf6r\xfcnt\xfcleyin.",
        tenant_id: "Kiracı Kimliği",
        tenant_name: "Kiracı Adı",
        tenant_region: "Veriler barındırılan b\xf6lge",
        tenant_region_tip: "Kiracı kaynaklarınız {{region}} b\xf6lgesinde barındırılır. <a>Daha fazla bilgi</a>",
        environment_tag_development: "Geliş",
        environment_tag_production: "Prod",
        tenant_type: "Kiracı t\xfcr\xfc",
        development_description: "Yalnızca test amacıyla ve \xfcretimde kullanılmamalıdır. Abonelik gerekli değildir. T\xfcm pro \xf6zelliklere sahiptir ancak giriş banner'ı gibi bazı sınırlamaları bulunmaktadır. <a>Daha fazla bilgi</a>",
        production_description: "Son kullanıcılar tarafından kullanılan uygulamalar i\xe7in tasarlanmıştır ve \xfccretli abonelik gerektirebilir. <a>Daha fazla bilgi</a>",
        tenant_info_saved: "Kiracı bilgileri başarıyla kaydedildi."
    },
    full_env_tag: {
        development: "Geliştirme",
        production: "Prod"
    },
    deletion_card: {
        title: "SİL",
        tenant_deletion: "Kiracıyı Sil",
        tenant_deletion_description: "Kiracının silinmesi, t\xfcm ilişkili kullanıcı verilerinin ve yapılandırmalarının kalıcı olarak silinmesine neden olur. L\xfctfen dikkatli bir şekilde devam edin.",
        tenant_deletion_button: "Kiracıyı Sil"
    },
    leave_tenant_card: {
        title: "AYRIL",
        leave_tenant: "Kiracıyı Ayrıl",
        leave_tenant_description: "Kiracıda kalan t\xfcm kaynaklarınız kalır, ancak artık bu kiracıya erişiminiz olmaz.",
        last_admin_note: "Bu kiracıdan ayrılmak i\xe7in, en az bir başka \xfcyenin Y\xf6netici rol\xfcne sahip olduğundan emin olun."
    },
    create_modal: {
        title: "Kiracı Oluştur",
        tenant_usage_purpose: "Bu kiracıyı ne i\xe7in kullanmak istiyorsunuz?",
        development_description: "Yalnızca test amacıyla ve \xfcretimde kullanılmamalıdır. Abonelik gerekli değildir.",
        development_hint: "T\xfcm pro \xf6zelliklere sahiptir ancak giriş bannerı gibi bazı sınırlamaları bulunmaktadır.",
        production_description: "Son kullanıcılar tarafından kullanılmak \xfczere tasarlanmıştır ve \xfccretli bir abonelik gerekebilir.",
        available_plan: "Mevcut plan:",
        create_button: "Kiracı oluştur",
        tenant_name_placeholder: "Benim kiracım"
    },
    dev_tenant_migration: {
        title: 'Pro \xf6zelliklerimizi \xfccretsiz olarak deneyebilirsiniz, yeni "Geliştirme kiracısı" oluşturarak!',
        affect_title: "Bunu denemenin sizin i\xe7in bir etkisi var mı?",
        hint_1: "Eski <strong>ortam etiketlerini</strong> iki yeni kiracı t\xfcr\xfc ile değiştiriyoruz: <strong>“Gelişme”</strong> ve <strong>“Prod”</strong>.",
        hint_2: "Sorunsuz bir ge\xe7iş ve kesintisiz işlevsellik sağlamak i\xe7in, t\xfcm erken oluşturulan kiracılarınız \xf6nceki aboneliğinizle birlikte <strong>Prod</strong> kiracı t\xfcr\xfcne y\xfckseltilecektir.",
        hint_3: "Endişelenmeyin, diğer t\xfcm ayarlarınız aynı kalacak.",
        about_tenant_type: "Kiracı t\xfcr\xfc hakkında"
    },
    delete_modal: {
        title: "Kiracıyı Sil",
        description_line1: 'Kiracınız "<span>{{name}}</span>" ve ortam ek etiketi "<span>{{tag}}</span>" ile kalıcı olarak silmek istediğinize emin misiniz? Bu işlem geri alınamaz ve t\xfcm veri ve kiracı bilgilerinizin kalıcı olarak silinmesine neden olacaktır.',
        description_line2: "Kiracıyı silmeden \xf6nce size yardımcı olabiliriz. <span><a>E-posta yoluyla bizimle iletişime ge\xe7in</a></span>",
        description_line3: '"{{name}}" kiracı adını doğrulamak i\xe7in devam edin',
        delete_button: "Kalıcı olarak sil",
        cannot_delete_title: "Bu kiracı silinemez",
        cannot_delete_description: "\xdczg\xfcn\xfcm, şu anda bu kiracıyı silemezsiniz. \xdccretsiz aboneliğinizde olmadığınızdan ve t\xfcm faturalarınızın \xf6dendiğinden emin olun."
    },
    leave_tenant_modal: {
        description: "Bu kiracıdan ayrılmak istediğinize emin misiniz?",
        leave_button: "Ayrıl"
    },
    tenant_landing_page: {
        title: "Hen\xfcz bir kiracı oluşturmadınız",
        description: "Logto ile projenizi yapılandırmaya başlamak i\xe7in l\xfctfen yeni bir kiracı oluşturun. Hesabınızdan \xe7ıkış yapmanız veya hesabınızı silmeniz gerekiyorsa, sağ \xfcst k\xf6şedeki avatar d\xfcğmesine tıklayın.",
        create_tenant_button: "Kiracı oluştur"
    },
    status: {
        mau_exceeded: "MAU Sınırı Aşıldı",
        suspended: "Askıya Alındı",
        overdue: "Ge\xe7mişte"
    },
    tenant_suspended_page: {
        title: "Kiracı Askıya Alındı. Erişimi geri y\xfcklemek i\xe7in bizimle iletişime ge\xe7in.",
        description_1: "\xdcz\xfclerek bildirmekten \xfcz\xfcnt\xfc duyoyruz, kiracı hesabınız şu anda ge\xe7ici olarak askıya alınmıştır. Bunun nedeni, MAU sınırlarını aşmak, gecikmiş \xf6demeler veya diğer izinsiz işlemler gibi yanlış kullanımdır.",
        description_2: "Daha fazla a\xe7ıklama, endişeleriniz veya işlevselliği tamamen geri y\xfcklemek ve kiracılarınızı engellemek isterseniz, l\xfctfen derhal bizimle iletişime ge\xe7mekten \xe7ekinmeyin."
    }
};
var $40f46fb641c1b07f$export$2e2bcd8739ae039 = Object.freeze($40f46fb641c1b07f$var$tenants);


const $5a5280af02dce553$var$topbar = {
    docs: "Belgeler",
    help: "Yardım"
};
var $5a5280af02dce553$export$2e2bcd8739ae039 = Object.freeze($5a5280af02dce553$var$topbar);


const $50185a19bf7b3947$var$featured_plan_content = {
    mau: {
        free_plan: "{{count, number}} MAU'ya kadar",
        pro_plan: "Sınırsız MAU"
    },
    m2m: {
        free_plan: "{{count, number}} makineye makineye",
        pro_plan: "Ek makineye makineye"
    },
    third_party_apps: "\xdc\xe7\xfcnc\xfc taraf uygulamalar i\xe7in IdP",
    mfa: "\xc7ok fakt\xf6rl\xfc kimlik doğrulama",
    sso: "Kurumsal SSO",
    role_and_permissions: {
        free_plan: "{{roleCount, number}} rol ve {{permissionCount, number}} izin başına rol",
        pro_plan: "Rol başına sınırsız roller ve izinler"
    },
    organizations: "Organizasyonlar",
    audit_logs: "Denetim g\xfcnl\xfckleri saklama: {{count, number}} g\xfcn"
};
var $50185a19bf7b3947$export$2e2bcd8739ae039 = Object.freeze($50185a19bf7b3947$var$featured_plan_content);


const $8714c3aaf95946ac$var$paywall = {
    applications: "<planName/> limitine ulaşılan {{count, number}} başvuru. Ekibinizin ihtiya\xe7larını karşılamak i\xe7in planı y\xfckseltin. Yardım i\xe7in l\xfctfen <a>bizimle iletişime ge\xe7in</a>.",
    applications_other: "<planName/> limitine ulaşılan {{count, number}} başvurular. Ekibinizin ihtiya\xe7larını karşılamak i\xe7in planı y\xfckseltin. Yardım i\xe7in l\xfctfen <a>bizimle iletişime ge\xe7in</a>.",
    machine_to_machine_feature: "Kendi başvurularınızı oluşturun ve t\xfcm \xf6zelliklerin keyfini \xe7ıkarın Sunucu <a>bizimle iletişime ge\xe7in</a>.",
    machine_to_machine: "<planName/> limitine ulaşılan {{count, number}} makine-makine başvurusu. Ekibinizin ihtiya\xe7larını karşılamak i\xe7in planı y\xfckseltin. Yardım i\xe7in l\xfctfen <a>bizimle iletişime ge\xe7in</a>.",
    machine_to_machine_other: "<planName/> limitine ulaşılan {{count, number}} makine-makine başvuruları. Ekibinizin ihtiya\xe7larını karşılamak i\xe7in planı y\xfckseltin. Yardım i\xe7in l\xfctfen <a>bizimle iletişime ge\xe7in</a>.",
    resources: "{{count, number}} <planName/> API kaynağı sınırına ulaşıldı. Ekibinizin ihtiya\xe7larını karşılamak i\xe7in planı y\xfckseltin. Yardıma ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    resources_other: "{{count, number}} <planName/> API kaynağı sınırına ulaşıldı. Ekibinizin ihtiya\xe7larını karşılamak i\xe7in planı y\xfckseltin. Yardıma ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    scopes_per_resource: "{{count, number}} <planName/> API kaynağı başına izin sınırına ulaşıldı. Genişletmek i\xe7in şimdi y\xfckseltin. Yardıma ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    scopes_per_resource_other: "{{count, number}} <planName/> API kaynağı başına izin sınırına ulaşıldı. Genişletmek i\xe7in şimdi y\xfckseltin. Yardıma ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    custom_domain: "\xd6zel alan işlevselliğini kilidini a\xe7mak i\xe7in <strong>Hobiyi</strong> veya <strong>Pro’yu</strong> y\xfckseltin. Yardım i\xe7in <a>bizimle iletişime ge\xe7in</a> ihtiyacınız varsa.",
    social_connectors: "{{count, number}} <planName/> sosyal bağlayıcı sınırına ulaşıldı. Ekibinizin ihtiya\xe7larını karşılamak i\xe7in planı y\xfckseltin ve OIDC, OAuth 2.0 ve SAML protokolleri kullanarak kendi bağlayıcılarınızı oluşturma yeteneğine sahip olun. Yardım i\xe7in ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    social_connectors_other: "{{count, number}} <planName/> sosyal bağlayıcı sınırına ulaşıldı. Ekibinizin ihtiya\xe7larını karşılamak i\xe7in planı y\xfckseltin ve OIDC, OAuth 2.0 ve SAML protokolleri kullanarak kendi bağlayıcılarınızı oluşturma yeteneğine sahip olun. Yardım i\xe7in ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    standard_connectors_feature: "<strong>Hobi</strong> veya <strong>Pro</strong> planına y\xfckselerek OIDC, OAuth 2.0 ve SAML protokollerini kullanarak kendi bağlayıcılarınızı oluşturun, sınırsız sosyal bağlayıcılara ve t\xfcm \xf6zelliklere sahip olun. Yardım i\xe7in ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    standard_connectors: "{{count, number}} <planName/> sosyal bağlayıcı sınırına ulaşıldı. Ekibinizin ihtiya\xe7larını karşılamak i\xe7in planı y\xfckseltin ve OIDC, OAuth 2.0 ve SAML protokolleri kullanarak kendi bağlayıcılarınızı oluşturma yeteneğine sahip olun. Yardım i\xe7in ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    standard_connectors_other: "{{count, number}} <planName/> sosyal bağlayıcı sınırına ulaşıldı. Ekibinizin ihtiya\xe7larını karşılamak i\xe7in planı y\xfckseltin ve OIDC, OAuth 2.0 ve SAML protokolleri kullanarak kendi bağlayıcılarınızı oluşturma yeteneğine sahip olun. Yardım i\xe7in ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    standard_connectors_pro: "{{count, number}} <planName/> standart bağlayıcı sınırına ulaşıldı. Ekibinizin ihtiya\xe7larını karşılamak i\xe7in Kurumsal plana y\xfckseltin ve OIDC, OAuth 2.0 ve SAML protokolleri kullanarak kendi bağlayıcılarınızı oluşturma yeteneğine sahip olun. Yardım i\xe7in ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    standard_connectors_pro_other: "{{count, number}} <planName/> standart bağlayıcı sınırına ulaşıldı. Ekibinizin ihtiya\xe7larını karşılamak i\xe7in Kurumsal plana y\xfckseltin ve OIDC, OAuth 2.0 ve SAML protokolleri kullanarak kendi bağlayıcılarınızı oluşturma yeteneğine sahip olun. Yardım i\xe7in ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    roles: "{{count, number}} <planName/> rol sınırına ulaşıldı. İlave roller ve izinler eklemek i\xe7in planı y\xfckseltin. Yardım i\xe7in ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    roles_other: "{{count, number}} <planName/> rol sınırına ulaşıldı. İlave roller ve izinler eklemek i\xe7in planı y\xfckseltin. Yardım i\xe7in ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    machine_to_machine_roles: "{{count, number}} machine-to-machine role of <planName/> limit reached. Upgrade plan to add additional roles and permissions. Feel free to <a>contact us</a> if you need any assistance.",
    machine_to_machine_roles_other: "{{count, number}} machine-to-machine roles of <planName/> limit reached. Upgrade plan to add additional roles and permissions. Feel free to <a>contact us</a> if you need any assistance.",
    scopes_per_role: "{{count, number}} <planName/> rol başına izin sınırına ulaşıldı. İlave roller ve izinler eklemek i\xe7in planı y\xfckseltin. Yardım i\xe7in ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    scopes_per_role_other: "{{count, number}} <planName/> rol başına izin sınırına ulaşıldı. İlave roller ve izinler eklemek i\xe7in planı y\xfckseltin. Yardım i\xe7in ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    hooks: "{{count, number}} <planName/> webhook sınırına ulaşıldı. Daha fazla webhook oluşturmak i\xe7in planı y\xfckseltin. Yardım i\xe7in ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    hooks_other: "{{count, number}} <planName/> webhook sınırına ulaşıldı. Daha fazla webhook oluşturmak i\xe7in planı y\xfckseltin. Yardım i\xe7in ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    mfa: "G\xfcvenliği kontrol etmek i\xe7in MFA'yı bir \xfccretli plana ge\xe7erek kilidini a\xe7ın. Yardım i\xe7in bize <a>iletişim kurmaktan</a> \xe7ekinmeyin.",
    organizations: "Unlock organizations \xf6zelliğini a\xe7mak i\xe7in \xfccretli bir plana y\xfckseltin. Yardım i\xe7in <a>iletişime ge\xe7in</a> ihtiyacınız olursa.",
    third_party_apps: "\xdc\xe7\xfcnc\xfc taraf uygulamalar i\xe7in Logto'yu IdP olarak kilidini a\xe7mak i\xe7in \xfccretli bir plana y\xfckseltin. Yardım i\xe7in <a>iletişime ge\xe7in</a> ihtiyacınız olursa.",
    sso_connectors: "İşletme SSO'yu kilidini a\xe7mak i\xe7in \xfccretli bir plana y\xfckseltin. Yardım i\xe7in <a>iletişime ge\xe7in</a> ihtiyacınız olursa.",
    tenant_members: "İşbirliği \xf6zelliğini kilidini a\xe7mak i\xe7in \xfccretli bir plana y\xfckseltin. Yardım i\xe7in <a>iletişime ge\xe7in</a> ihtiyacınız olursa.",
    tenant_members_dev_plan: "Sınırınıza ulaştınız {{limit}}-\xfcye limit. Yeni birini eklemek i\xe7in bir \xfcyeyi serbest bırakın veya reddedilen bir daveti geri \xe7ekin. Daha fazla kontenjana mı ihtiyacınız var? İletişim kurmaktan \xe7ekinmeyin.",
    custom_jwt: {
        title: "\xd6zel iddialar ekle",
        description: "\xd6zel JWT işlevselliği ve prim avantajları i\xe7in \xfccretli bir plana y\xfckseltin. Sorularınız varsa, \xe7ekinmeden <a>iletişime ge\xe7in</a>."
    }
};
var $8714c3aaf95946ac$export$2e2bcd8739ae039 = Object.freeze($8714c3aaf95946ac$var$paywall);


const $dda74579501101bb$var$upsell = {
    upgrade_plan: "Planı Y\xfckselt",
    compare_plans: "Planları Karşılaştır",
    view_plans: "Planları G\xf6r\xfcnt\xfcle",
    create_tenant: {
        title: "Kiracı planınızı se\xe7in",
        description: "Logto, b\xfcy\xfcyen şirketler i\xe7in tasarlanmış yenilik\xe7i ve uygun fiyatlı fiyatlandırma se\xe7enekleri sunar. <a>Daha fazla bilgi edinin</a>",
        base_price: "Temel Fiyat",
        monthly_price: "{{value, number}}/ay",
        view_all_features: "T\xfcm \xf6zellikleri g\xf6r\xfcnt\xfcle",
        select_plan: "'<name/>'ı Se\xe7in",
        free_tenants_limit: "En fazla {{count, number}} \xfccretsiz kiracı",
        free_tenants_limit_other: "En fazla {{count, number}} \xfccretsiz kiracı",
        most_popular: "En Pop\xfcler",
        upgrade_success: "'<name/>'a Başarıyla Y\xfckseltildi"
    },
    mau_exceeded_modal: {
        title: "MAU sınırı aşıldı. Planınızı y\xfckseltin.",
        notification: "Mevcut MAU, <planName/> sınırını aştı. Logto hizmetinin askıya alınmasını \xf6nlemek i\xe7in premium plana hemen y\xfckseltin.",
        update_plan: "Planı G\xfcncelle"
    },
    payment_overdue_modal: {
        title: "Fatura \xf6demesi gecikti",
        notification: "Oops! Kiracı <span>{{name}}</span> faturasının \xf6demesi başarısız oldu. Logto hizmetinin askıya alınmaması i\xe7in faturayı zamanında \xf6deyin.",
        unpaid_bills: "\xd6denmemiş faturalar",
        update_payment: "\xd6demeyi G\xfcncelle"
    },
    add_on_quota_item: {
        api_resource: "API kaynağı",
        machine_to_machine: "makine-makine uygulaması",
        tokens: "{{limit}}M jeton",
        tenant_member: "kiracı \xfcyesi"
    },
    charge_notification_for_quota_limit: "{{item}} kota sınırını aştınız. Logto, kota sınırınızın \xf6tesindeki kullanım i\xe7in \xfccret ekleyecektir. Yeni ek paket fiyatlandırma tasarımı g\xfcn\xfcn\xfczde başlayacaktır. <a>Daha fazla bilgi</a>",
    paywall: $8714c3aaf95946ac$export$2e2bcd8739ae039,
    featured_plan_content: $50185a19bf7b3947$export$2e2bcd8739ae039
};
var $dda74579501101bb$export$2e2bcd8739ae039 = Object.freeze($dda74579501101bb$var$upsell);


const $fff6cae9328b8c7e$var$user_details = {
    page_title: "Kullanıcı detayları",
    back_to_users: "Kullanıcı Y\xf6netimine Geri D\xf6n",
    created_title: "Bu kullanıcı başarıyla oluşturuldu",
    created_guide: "Kullanıcının oturum a\xe7ma s\xfcrecinde yardımcı olacak bilgiler burada.",
    created_email: "E-posta adresi:",
    created_phone: "Telefon numarası:",
    created_username: "Kullanıcı Adı:",
    created_password: "Şifre:",
    menu_delete: "Sil",
    delete_description: "Bu işlem geri alınamaz. Kullanıcıyı kalıcı olarak siler.",
    deleted: "Kullanıcı başarıyla silindi.",
    reset_password: {
        reset_password: "Şifreyi sıfırla",
        title: "Şifreyi sıfırlamak istediğinizden emin misiniz?",
        content: "Bu işlem geri alınamaz. Bu, kullanıcının oturum a\xe7ma bilgilerini sıfırlayacaktır.",
        congratulations: "Bu kullanıcı sıfırlandı",
        new_password: "Yeni şifre:"
    },
    tab_settings: "Ayarlar",
    tab_roles: "Roller",
    tab_logs: "Kullanıcı kayıtları",
    tab_organizations: "Organizasyonlar",
    authentication: "Kimlik doğrulama",
    authentication_description: "Her kullanıcının, temel veriler, sosyal kimlikler ve \xf6zel verilerden oluşan t\xfcm kullanıcı bilgilerini i\xe7eren bir profil vardır.",
    user_profile: "Kullanıcı profili",
    field_email: "Eposta adresi",
    field_phone: "Telefon numarası",
    field_username: "Kullanıcı Adı",
    field_name: "İsim",
    field_avatar: "Avatar resmi URLi",
    field_avatar_placeholder: "https://your.cdn.domain/avatar.png",
    field_custom_data: "\xd6zel veriler",
    field_custom_data_tip: "Kullanıcı tarafından tercih edilen renk ve dil gibi \xf6nceden tanımlanmış kullanıcı \xf6zelliklerinde listelenmeyen ek kullanıcı bilgileri.",
    field_connectors: "Sosyal bağlayıcılar",
    field_sso_connectors: "İş bağlantıları",
    custom_data_invalid: "\xd6zel veriler ge\xe7erli bir JSON nesnesi olmalıdır",
    connectors: {
        connectors: "Bağlayıcılar",
        user_id: "Kullanıcı IDsi",
        remove: "Kaldır",
        connected: "Bu kullanıcı birden fazla sosyal bağlayıcıya bağlıdır.",
        not_connected: "Kullanıcı herhangi bir sosyal bağlayıcıya bağlı değil",
        deletion_confirmation: "Mevcut <name/> kimliğini kaldırıyorsunuz. Devam etmek istediğinizden emin misiniz?"
    },
    sso_connectors: {
        connectors: "Bağlayıcılar",
        enterprise_id: "Şirket ID",
        connected: "Bu kullanıcı, Tek Oturum Kimliği i\xe7in birden \xe7ok kurumsal kimlik sağlayıcıya bağlıdır.",
        not_connected: "Kullanıcı, Tek Oturum Kimliği i\xe7in herhangi bir kurumsal kimlik sağlayıcıya bağlı değil."
    },
    mfa: {
        field_name: "\xc7ok fakt\xf6rl\xfc kimlik doğrulama",
        field_description: "Bu kullanıcı 2 adımlı kimlik doğrulama fakt\xf6rlerini etkinleştirdi.",
        name_column: "\xc7ok Fakt\xf6rl\xfc Kimlik Doğrulama",
        field_description_empty: "Bu kullanıcı 2 aşamalı kimlik doğrulama fakt\xf6rlerini etkinleştirmedi.",
        deletion_confirmation: "Varolan 2 aşamalı doğrulama i\xe7in <name/> kaldırıyorsunuz. Devam etmek istediğinizden emin misiniz?"
    },
    suspended: "Askıya alınmış",
    suspend_user: "Kullanıcıyı Askıya Al",
    suspend_user_reminder: "Bu kullanıcıyı askıya almak istediğinizden emin misiniz? Kullanıcı uygulamanıza giriş yapamayacak ve mevcut erişim belirteci s\xfcresi dolduktan sonra yeni bir erişim belirteci alamayacak. Ayrıca bu kullanıcı tarafından yapılan herhangi bir API isteği başarısız olacaktır.",
    suspend_action: "Askıya Al",
    user_suspended: "Kullanıcı askıya alındı.",
    reactivate_user: "Kullanıcıyı Yeniden Etkinleştir",
    reactivate_user_reminder: "Bu kullanıcının yeniden etkinleştirmek istediğinizden emin misiniz? B\xf6yle yapmak, bu kullanıcı i\xe7in giriş girişimlerine izin verecektir.",
    reactivate_action: "Yeniden Etkinleştir",
    user_reactivated: "Kullanıcı yeniden etkinleştirildi.",
    roles: {
        name_column: "Rol",
        description_column: "A\xe7ıklama",
        assign_button: "Rolleri Ata",
        delete_description: "Bu işlem, bu rol\xfc bu kullanıcıdan kaldıracaktır. Rol kendisi hala var olacaktır, ancak artık bu kullanıcıyla ilişkili olmayacaktır.",
        deleted: "{{name}} bu kullanıcıdan başarıyla kaldırıldı.",
        assign_title: "{{name}} kullanıcısına roller atayın",
        assign_subtitle: "{{name}} bir veya daha fazla rol\xfc yetkilendirin",
        assign_role_field: "Rolleri ata",
        role_search_placeholder: "Rol adına g\xf6re arama yapın",
        added_text: "{{value, number}} eklendi",
        assigned_user_count: "{{value, number}} kullanıcı",
        confirm_assign: "Rolleri ata",
        role_assigned: "Rol(ler) başarıyla atandı",
        search: "Rol adına, a\xe7ıklamasına veya Kimliğine g\xf6re arama yapın",
        empty: "Uygun rol yok"
    },
    warning_no_sign_in_identifier: "Kullanıcının giriş yapmak i\xe7in en az bir oturum a\xe7ma kimliği (kullanıcı adı, e-posta, telefon numarası, veya sosyal) olması gerekiyor. Devam etmek istediğinizden emin misiniz?",
    organization_roles_tooltip: "Bu organizasyon i\xe7inde kullanıcıya atanan roller."
};
var $fff6cae9328b8c7e$export$2e2bcd8739ae039 = Object.freeze($fff6cae9328b8c7e$var$user_details);


const $fd12866778858a22$var$users = {
    page_title: "Kullanıcı Y\xf6netimi",
    title: "Kullanıcı Y\xf6netimi",
    subtitle: "Kullanıcı oluşturma, kullanıcı bilgilerini d\xfczenleme, kullanıcı kayıtlarını g\xf6r\xfcnt\xfcleme, parola sıfırlama ve kullanıcıları silme dahil olmak \xfczere kullanıcı kimliklerini y\xf6netin",
    create: "Kullanıcı ekle",
    create_subtitle: "Devam etmek i\xe7in en az bir alanı sağlayın.",
    error_missing_identifier: "Bir kullanıcı oluşturmak i\xe7in en az bir tanımlayıcı sağlamanız gerekir.",
    user_name: "Kullanıcı",
    application_name: "Uygulamadan",
    latest_sign_in: "En son oturum a\xe7ma",
    create_form_username: "Kullanıcı Adı",
    create_form_password: "Şifre",
    create_form_name: "Ad Soyad",
    placeholder_name: "Ali Veli",
    placeholder_email: "aveli@example.com",
    placeholder_username: "user123",
    placeholder_phone: "+90 212 345 67 89",
    unnamed: "İsimsiz",
    search: "İsim, email, telefon veya kullanıcı adına g\xf6re arama",
    check_user_detail: "Kullanıcı detaylarını kontrol et",
    placeholder_title: "Kullanıcı y\xf6netimi",
    placeholder_description: "Her kullanıcının temel verileri, sosyal kimlikleri ve \xf6zel verilerini i\xe7eren bir profil vardır."
};
var $fd12866778858a22$export$2e2bcd8739ae039 = Object.freeze($fd12866778858a22$var$users);


const $b680aaf9bf90eb3a$var$webhook_details = {
    page_title: "Webhook ayrıntıları",
    back_to_webhooks: "Webhooklara geri d\xf6n",
    not_in_use: "Kullanılmıyor",
    success_rate: "başarı oranı",
    requests: "24 saatte {{value, number}} istek",
    disable_webhook: "Webhooku devre dışı bırak",
    disable_reminder: "Bu webhooku yeniden etkinleştirmek istediğinizden emin misiniz? B\xf6yle yapmak, HTTP isteğini u\xe7 nokta URL’ye g\xf6ndermeyecektir.",
    webhook_disabled: "Webhook devre dışı bırakıldı.",
    webhook_reactivated: "Webhook tekrar etkinleştirildi.",
    reactivate_webhook: "Webhooku yeniden etkinleştir",
    delete_webhook: "Webhooku sil",
    deletion_reminder: "Bu webhook’u kaldırıyorsunuz. Silindikten sonra, HTTP isteği u\xe7 nokta URL’ye g\xf6nderilmeyecektir.",
    deleted: "Webhook başarıyla silindi.",
    settings_tab: "Ayarlar",
    recent_requests_tab: "Son istekler (24s)",
    settings: {
        settings: "Ayarlar",
        settings_description: "Webhooklar, belirli olaylarla ilgili ger\xe7ek zamanlı g\xfcncellemeleri almanızı sağlar, sağladıkları POST isteği Logto’daki u\xe7 nokta URL’nize g\xf6ndererek. Bu, yeni alınan bilgilere dayalı hemen harekete ge\xe7menizi sağlar.",
        events: "Olaylar",
        events_description: "Logto’nun POST isteğini g\xf6ndereceği tetikleyici olayları se\xe7in.",
        name: "İsim",
        endpoint_url: "U\xe7 nokta URL’si",
        signing_key: "İmza anahtarı",
        signing_key_tip: "Webhook’un y\xfck\xfc i\xe7in kimliğinin doğruluğunu sağlamak i\xe7in Logto tarafından sağlanan gizli anahtarın istek başlığı olarak u\xe7 noktanızda ekleyin.",
        regenerate: "Yeniden oluştur",
        regenerate_key_title: "İmza anahtarını yeniden oluştur",
        regenerate_key_reminder: "İmza anahtarını değiştirmek istediğinizden emin misiniz? Yeniden oluşturmak hemen etki edecektir. L\xfctfen u\xe7 noktanızdaki imza anahtarını senkronize olarak değiştirmeyi unutmayın.",
        regenerated: "İmza anahtarı yeniden oluşturuldu.",
        custom_headers: "\xd6zel başlıklar",
        custom_headers_tip: "İsteğin bir par\xe7ası olarak webhook’un y\xfck\xfcne isteğin bağlamı veya meta verileri sağlamak i\xe7in isteğe bağlı olarak \xf6zel başlıklar ekleyebilirsiniz.",
        key_duplicated_error: "Anahtarlar tekrarlanamaz.",
        key_missing_error: "Anahtar gereklidir.",
        value_missing_error: "Değer gereklidir.",
        invalid_key_error: "Anahtar ge\xe7ersiz",
        invalid_value_error: "Değer ge\xe7ersiz",
        test: "Test",
        test_webhook: "Webhook’unuzu test edin",
        test_webhook_description: "Webhook’u yapılandırın ve her se\xe7ilen olay i\xe7in y\xfck \xf6rnekleriyle test ederek doğru alma ve işleme işlemini doğrulayın.",
        send_test_payload: "Test y\xfck\xfcn\xfc g\xf6nder",
        test_result: {
            endpoint_url: "Son nokta URL: {{url}}",
            message: "Mesaj: {{message}}",
            response_status: "Yanıt durumu: {{status, number}}",
            response_body: "Yanıt g\xf6vdesi: {{body}}",
            request_time: "İstek zamanı: {{time}}",
            test_success: "Son noktaya yapılan webhook testi başarılı oldu."
        }
    }
};
var $b680aaf9bf90eb3a$export$2e2bcd8739ae039 = Object.freeze($b680aaf9bf90eb3a$var$webhook_details);


const $c3b69313f3ccf444$var$webhooks = {
    page_title: "Webhooklar",
    title: "Webhooklar",
    subtitle: "Belirli olaylarla ilgili ger\xe7ek zamanlı g\xfcncellemeler almak i\xe7in webhooklar oluşturun.",
    create: "Webhook Oluştur",
    schemas: {
        interaction: "Kullanıcı etkileşimi",
        user: "Kullanıcı",
        organization: "Kuruluş",
        role: "Rol",
        scope: "İzin",
        organization_role: "Kuruluş rol\xfc",
        organization_scope: "Kuruluş izni"
    },
    table: {
        name: "Adı",
        events: "Olaylar",
        success_rate: "Başarı Oranı (24s)",
        requests: "İstekler (24s)"
    },
    placeholder: {
        title: "Webhook",
        description: 'POST istekleri aracılığıyla u\xe7 nokta URL\'nıza ger\xe7ek zamanlı g\xfcncellemeler almak i\xe7in bir webhook oluşturun. "Hesap Oluşturma", "Oturum A\xe7ma" ve "Şifre Sıfırlama" gibi olayların etkinliklerini takip edin ve hemen harekete ge\xe7in.',
        create_webhook: "Webhook Oluştur"
    },
    create_form: {
        title: "Webhook Oluştur",
        subtitle: "Webhook ekleyerek, Logto’nun kullanıcı eylemlerinin ayrıntılarını POST isteğiyle u\xe7 nokta URL’nıza g\xf6ndermesini sağlayabilirsiniz.",
        events: "Olaylar",
        events_description: "Logto’nun POST isteğini g\xf6ndermesi i\xe7in tetikleyici olayları se\xe7in.",
        name: "Adı",
        name_placeholder: "Webhook adını girin",
        endpoint_url: "U\xe7 Nokta URL’si",
        endpoint_url_placeholder: "https://your.webhook.endpoint.url",
        endpoint_url_tip: "Enter the URL of your endpoint where a webhook’s payload is sent to when the event occurs.",
        create_webhook: "Webhook Oluştur",
        missing_event_error: "En az bir olay se\xe7meniz gerekiyor."
    },
    webhook_created: "Webhook {{name}} başarıyla oluşturuldu."
};
var $c3b69313f3ccf444$export$2e2bcd8739ae039 = Object.freeze($c3b69313f3ccf444$var$webhooks);


const $7e050e8f0bbac3e3$var$welcome = {
    title: "Y\xf6netici Paneline Hoş Geldiniz",
    description: "Y\xf6netici paneli, kodlama bilgisi olmadan Logtoyu y\xf6netmek i\xe7in bir web uygulamasıdır. \xd6nce, bir hesap oluşturalım. Bu hesapla Logtoyu kendiniz veya şirketiniz adına y\xf6netebilirsiniz.",
    create_account: "Hesap Oluştur"
};
var $7e050e8f0bbac3e3$export$2e2bcd8739ae039 = Object.freeze($7e050e8f0bbac3e3$var$welcome);


const $693749b07238a94b$var$admin_console = {
    title: "Y\xf6netici Paneli",
    admin_user: "Y\xf6netici",
    system_app: "Sistem",
    menu: $948329c3173c8a83$export$2e2bcd8739ae039,
    general: $c794ebcd6896fd8f$export$2e2bcd8739ae039,
    errors: $4b20afd35c7e8517$export$2e2bcd8739ae039,
    tab_sections: $cb975d1a064afe0e$export$2e2bcd8739ae039,
    tabs: $53013f07d6ece444$export$2e2bcd8739ae039,
    applications: $fc0472b7f0a8cba8$export$2e2bcd8739ae039,
    application_details: $70f58986885fc354$export$2e2bcd8739ae039,
    api_resources: $cc86108e59b08891$export$2e2bcd8739ae039,
    api_resource_details: $1e7ab13a00977c97$export$2e2bcd8739ae039,
    connectors: $97490d84dc811a15$export$2e2bcd8739ae039,
    connector_details: $e6f631ffa28d00d5$export$2e2bcd8739ae039,
    enterprise_sso: $db79c3f39bade2b2$export$2e2bcd8739ae039,
    enterprise_sso_details: $fcfd78887c5d3de4$export$2e2bcd8739ae039,
    get_started: $550ae3ba16945f9d$export$2e2bcd8739ae039,
    users: $fd12866778858a22$export$2e2bcd8739ae039,
    user_details: $fff6cae9328b8c7e$export$2e2bcd8739ae039,
    contact: $24a454ed257b3451$export$2e2bcd8739ae039,
    sign_in_exp: $076a21ada18324dd$export$2e2bcd8739ae039,
    dashboard: $9d74f8b9efd77f62$export$2e2bcd8739ae039,
    logs: $a147d1326a2ae3f1$export$2e2bcd8739ae039,
    log_details: $7f0efc6338ef7361$export$2e2bcd8739ae039,
    session_expired: $236d7e12288124a1$export$2e2bcd8739ae039,
    welcome: $7e050e8f0bbac3e3$export$2e2bcd8739ae039,
    roles: $5a3935ab16797ad5$export$2e2bcd8739ae039,
    role_details: $f751ed1cb73876e5$export$2e2bcd8739ae039,
    permissions: $62f3bda2d2584a65$export$2e2bcd8739ae039,
    cloud: $385c4fb45af75173$export$2e2bcd8739ae039,
    profile: $62308cb1b42bca92$export$2e2bcd8739ae039,
    components: $32fbf463afd3721b$export$2e2bcd8739ae039,
    webhooks: $c3b69313f3ccf444$export$2e2bcd8739ae039,
    webhook_details: $b680aaf9bf90eb3a$export$2e2bcd8739ae039,
    domain: $c57668d477eded7a$export$2e2bcd8739ae039,
    tenants: $40f46fb641c1b07f$export$2e2bcd8739ae039,
    tenant_members: $481b32d550841d26$export$2e2bcd8739ae039,
    topbar: $5a5280af02dce553$export$2e2bcd8739ae039,
    subscription: $fc61c71978a3b862$export$2e2bcd8739ae039,
    upsell: $dda74579501101bb$export$2e2bcd8739ae039,
    guide: $1c9591cad9c0d037$export$2e2bcd8739ae039,
    mfa: $7dc1ef7e511c3479$export$2e2bcd8739ae039,
    organizations: $d47b7018f04912b1$export$2e2bcd8739ae039,
    organization_details: $ab0bd55f066e9561$export$2e2bcd8739ae039,
    protected_app: $9f76d28bc6baffc9$export$2e2bcd8739ae039,
    jwt_claims: $e3731def965f01ec$export$2e2bcd8739ae039,
    invitation: $a0d147c459b0e610$export$2e2bcd8739ae039,
    signing_keys: $faa9ff4a05896d87$export$2e2bcd8739ae039,
    organization_template: $37441e4d8fe69044$export$2e2bcd8739ae039,
    organization_role_details: $58e43da1d5984646$export$2e2bcd8739ae039
};
var $693749b07238a94b$export$2e2bcd8739ae039 = Object.freeze($693749b07238a94b$var$admin_console);


const $8f1444ad00303488$var$demo_app = {
    title: "Canlı \xf6nizlemede başarıyla oturum a\xe7tınız!",
    subtitle: "Sisteme giriş bilgileriniz:",
    username: "Kullanıcı Adı: ",
    user_id: "Kullanıcı Kimliği: ",
    sign_out: "Canlı \xd6nizlemeyi Kapat",
    continue_explore: "Veya keşfetmeye devam et",
    customize_sign_in_experience: "Oturum A\xe7ma Deneyimini \xd6zelleştir",
    enable_passwordless: "Şifresiz Etkinleştir",
    add_social_connector: "Sosyal Bağlantı Ekle"
};
var $8f1444ad00303488$export$2e2bcd8739ae039 = Object.freeze($8f1444ad00303488$var$demo_app);


const $2077fe4b67bd2c1d$var$oidc = {
    logout_success: "Başarıyla \xe7ıkış yaptınız."
};
var $2077fe4b67bd2c1d$export$2e2bcd8739ae039 = Object.freeze($2077fe4b67bd2c1d$var$oidc);


const $21c8b514aaa33507$var$translation = {
    admin_console: $693749b07238a94b$export$2e2bcd8739ae039,
    demo_app: $8f1444ad00303488$export$2e2bcd8739ae039,
    oidc: $2077fe4b67bd2c1d$export$2e2bcd8739ae039
};
var $21c8b514aaa33507$export$2e2bcd8739ae039 = Object.freeze($21c8b514aaa33507$var$translation);


const $c069507bcce8337d$var$tr_tr = {
    translation: $21c8b514aaa33507$export$2e2bcd8739ae039,
    errors: $896bf99d747efcd1$export$2e2bcd8739ae039
};
var $c069507bcce8337d$export$2e2bcd8739ae039 = Object.freeze($c069507bcce8337d$var$tr_tr);


const $8d7a421ef246a668$var$application = {
    invalid_type: "只有机器对机器应用程序可以有关联角色。",
    role_exists: "角色 ID {{roleId}} 已添加到此应用程序。",
    invalid_role_type: "无法将用户类型角色分配给机器对机器应用程序。",
    invalid_third_party_application_type: "只有传统网络应用程序可以标记为第三方应用。",
    third_party_application_only: "该功能仅适用于第三方应用程序。",
    user_consent_scopes_not_found: "无效的用户同意范围。",
    consent_management_api_scopes_not_allowed: "管理 API 范围不允许。",
    protected_app_metadata_is_required: "需要保护的应用程序元数据。",
    protected_app_not_configured: "受保护的应用程序提供程序未配置。 此功能不适用于开源版本。",
    cloudflare_unknown_error: "请求 Cloudflare API 时发生未知错误",
    protected_application_only: "该功能仅适用于受保护的应用程序。",
    protected_application_misconfigured: "受保护的应用程序配置不正确。",
    protected_application_subdomain_exists: "受保护的应用程序子域名已在使用中。",
    invalid_subdomain: "无效的子域名。",
    custom_domain_not_found: "未找到自定义域。",
    should_delete_custom_domains_first: "应先删除自定义域。"
};
var $8d7a421ef246a668$export$2e2bcd8739ae039 = Object.freeze($8d7a421ef246a668$var$application);


const $62b6bfcd89a958e4$var$auth = {
    authorization_header_missing: "Authorization 请求头缺失。",
    authorization_token_type_not_supported: "Authorization token 类型不支持",
    unauthorized: "未经授权。请检查凭据及其范围。",
    forbidden: "禁止访问。请检查用户 role 与权限。",
    expected_role_not_found: "未找到期望的 role。请检查用户 role 与权限。",
    jwt_sub_missing: "JWT 缺失 `sub`",
    require_re_authentication: "需要重新认证以进行受保护操作。"
};
var $62b6bfcd89a958e4$export$2e2bcd8739ae039 = Object.freeze($62b6bfcd89a958e4$var$auth);


const $30117fd670229f0d$var$connector = {
    general: "连接器发生错误：{{errorDescription}}",
    not_found: "找不到可用的 {{type}} 类型的连接器",
    not_enabled: "连接器尚未启用",
    invalid_metadata: "连接器 metadata 参数错误",
    invalid_config_guard: "连接器配置 guard 错误",
    unexpected_type: "连接器类型错误",
    invalid_request_parameters: "请求参数错误",
    insufficient_request_parameters: "请求参数缺失",
    invalid_config: "连接器配置错误",
    invalid_certificate: "连接器的证书无效，请确保证书采用PEM编码。",
    invalid_response: "连接器错误响应",
    template_not_found: "无法从连接器配置中找到对应的模板",
    template_not_supported: "连接器不支持此模板类型。",
    rate_limit_exceeded: "触发速率限制。请稍后再试。",
    not_implemented: "方法 {{method}} 尚未实现",
    social_invalid_access_token: "当前连接器的 access_token 无效",
    invalid_auth_code: "当前连接器的授权码无效",
    social_invalid_id_token: "当前连接器的 id_token 无效",
    authorization_failed: "用户授权流程失败",
    social_auth_code_invalid: "无法获取 access_token，请检查授权 code 是否有效",
    more_than_one_sms: "同时存在超过 1 个短信连接器",
    more_than_one_email: "同时存在超过 1 个邮件连接器",
    more_than_one_connector_factory: "找到多个连接器工厂（id 为 {{connectorIds}}），请删除多余项。",
    db_connector_type_mismatch: "数据库中存在一个类型不匹配的连接。",
    not_found_with_connector_id: "找不到所给 connector id 对应的连接器",
    multiple_instances_not_supported: "你选择的连接器不支持创建多实例。",
    invalid_type_for_syncing_profile: "只有社交连接器可以开启用户档案同步。",
    can_not_modify_target: "不可修改连接器 target。",
    should_specify_target: "你需要声明 target 的值。",
    multiple_target_with_same_platform: "同一平台上，多个社交连接器不能重复使用相同的 “Target”。",
    cannot_overwrite_metadata_for_non_standard_connector: "不可覆盖该连接器的 metadata 参数。"
};
var $30117fd670229f0d$export$2e2bcd8739ae039 = Object.freeze($30117fd670229f0d$var$connector);


const $1183b65e2cefea1b$var$domain = {
    not_configured: "域名主机提供商尚未配置。",
    cloudflare_data_missing: "cloudflare_data 缺失，请检查。",
    cloudflare_unknown_error: "请求 Cloudflare API 时出现未知错误。",
    cloudflare_response_error: "从 Cloudflare 得到意外的响应。",
    limit_to_one_domain: "仅限一个自定义域名。",
    hostname_already_exists: "该域名在我们的服务器中已存在。",
    cloudflare_not_found: "在 Cloudflare 中找不到主机名",
    domain_is_not_allowed: "该域名不允许。"
};
var $1183b65e2cefea1b$export$2e2bcd8739ae039 = Object.freeze($1183b65e2cefea1b$var$domain);


const $092d957c80a77e9b$var$entity = {
    invalid_input: "无效输入。值列表不能为空。",
    create_failed: "创建 {{name}} 失败。",
    db_constraint_violated: "数据库约束被破坏。",
    not_exists: "该 {{name}} 不存在。",
    not_exists_with_id: "ID 为 `{{id}}` 的 {{name}} 不存在。",
    not_found: "该资源不存在。",
    relation_foreign_key_not_found: "无法找到一个或多个外键。请检查输入，并确保所有引用的实体都存在。",
    unique_integrity_violation: "The entity already exists. Please check the input and try again."
};
var $092d957c80a77e9b$export$2e2bcd8739ae039 = Object.freeze($092d957c80a77e9b$var$entity);


const $62e17bee68291af9$var$guard = {
    invalid_input: "请求中 {{type}} 无效",
    invalid_pagination: "分页参数无效",
    can_not_get_tenant_id: "无法从请求中获取租户 ID。",
    file_size_exceeded: "文件大小超过限制。",
    mime_type_not_allowed: "不允许使用此 MIME 类型。"
};
var $62e17bee68291af9$export$2e2bcd8739ae039 = Object.freeze($62e17bee68291af9$var$guard);


const $2f25b742549ef1cb$var$hook = {
    missing_events: "你需要提供至少一个事件。",
    send_test_payload_failed: "无法发送测试内容：{{message}}",
    endpoint_responded_with_error: "端点返回了错误。"
};
var $2f25b742549ef1cb$export$2e2bcd8739ae039 = Object.freeze($2f25b742549ef1cb$var$hook);


const $18546defb5000aac$var$jwt_customizer = {
    general: "定制JWT令牌时出错。请稍后再试。",
    can_not_create_for_admin_tenant: "无法为管理员租户创建JWT令牌定制器。"
};
var $18546defb5000aac$export$2e2bcd8739ae039 = Object.freeze($18546defb5000aac$var$jwt_customizer);


const $b094d5ca8260db2c$var$localization = {
    cannot_delete_default_language: "你已设置 {{languageTag}} 为你的默认语言，你无法删除默认语言。",
    invalid_translation_structure: "无效的数据格式，请检查你的输入并重试。"
};
var $b094d5ca8260db2c$export$2e2bcd8739ae039 = Object.freeze($b094d5ca8260db2c$var$localization);


const $193100b02ce3d74b$var$log = {
    invalid_type: "日志类型无效。"
};
var $193100b02ce3d74b$export$2e2bcd8739ae039 = Object.freeze($193100b02ce3d74b$var$log);


const $a6d10ee620507be0$var$oidc = {
    aborted: "用户终止了交互。",
    invalid_scope: "无效的范围: {{error_description}}。",
    invalid_token: "Token 无效",
    invalid_client_metadata: "无效的客户端元数据",
    insufficient_scope: "Token 缺少范围 `{{scope}}`.",
    invalid_request: "请求无效",
    invalid_grant: "授权请求无效",
    invalid_redirect_uri: "无效返回链接, 该 redirect_uri 未被此应用注册。",
    access_denied: "访问被拒绝",
    invalid_target: "请求资源无效",
    unsupported_grant_type: "不支持的 grant_type",
    unsupported_response_mode: "不支持的 response_mode",
    unsupported_response_type: "不支持的 response_type",
    provider_error: "OIDC 内部错误: {{message}}",
    server_error: "发生了未知的 OIDC 错误。请稍后再试。",
    provider_error_fallback: "发生了 OIDC 错误: {{code}}。",
    key_required: "至少需要一个密钥。",
    key_not_found: "未找到 ID 为 {{id}} 的密钥。"
};
var $a6d10ee620507be0$export$2e2bcd8739ae039 = Object.freeze($a6d10ee620507be0$var$oidc);


const $7a036310fe8f74a8$var$organization = {
    require_membership: "用户必须是组织的成员才能继续。"
};
var $7a036310fe8f74a8$export$2e2bcd8739ae039 = Object.freeze($7a036310fe8f74a8$var$organization);


const $c1adf350dabfc5d2$var$password = {
    unsupported_encryption_method: "不支持的加密方法 {{name}}",
    pepper_not_found: "密码 pepper 未找到。请检查 core 的环境变量。",
    rejected: "密码被拒绝。请检查密码是否符合要求。"
};
var $c1adf350dabfc5d2$export$2e2bcd8739ae039 = Object.freeze($c1adf350dabfc5d2$var$password);


const $936c24479fb6141f$var$request = {
    invalid_input: "输入无效。{{details}}",
    general: "发生请求错误。"
};
var $936c24479fb6141f$export$2e2bcd8739ae039 = Object.freeze($936c24479fb6141f$var$request);


const $b1c953d4356f9875$var$resource = {
    resource_identifier_in_use: "API 标识符 {{indicator}} 已被使用",
    cannot_delete_management_api: "无法删除 Logto 管理 API。",
    cannot_modify_management_api: "无法修改 Logto 管理 API。"
};
var $b1c953d4356f9875$export$2e2bcd8739ae039 = Object.freeze($b1c953d4356f9875$var$resource);


const $60ab99e532fcf3e4$var$role = {
    name_in_use: "此角色名称 {{name}} 已被使用",
    scope_exists: "作用域 ID {{scopeId}} 已添加到此角色",
    management_api_scopes_not_assignable_to_user_role: "无法将管理 API 作用域分配给用户角色。",
    user_exists: "用户 ID {{userId}} 已添加到此角色",
    application_exists: "应用程序 ID {{applicationId}} 已添加到此角色",
    default_role_missing: "某些默认角色名称在数据库中不存在，请确保先创建角色",
    internal_role_violation: "你可能正在尝试更新或删除 Logto 禁止的内部角色。如果你要创建新角色，请尝试使用不以“#internal:”开头的名称。"
};
var $60ab99e532fcf3e4$export$2e2bcd8739ae039 = Object.freeze($60ab99e532fcf3e4$var$role);


const $1077b09a9020ca36$var$scope = {
    name_exists: "此作用域名称 {{name}} 已被使用",
    name_with_space: "作用域名称不能包含任何空格。"
};
var $1077b09a9020ca36$export$2e2bcd8739ae039 = Object.freeze($1077b09a9020ca36$var$scope);


const $044813020f07efe8$var$session = {
    not_found: "未找到会话。请返回并重新登录。",
    invalid_credentials: "账号或密码错误，请重新输入。",
    invalid_sign_in_method: "当前登录方式不可用",
    invalid_connector_id: "找不到 ID 为 {{connectorId}} 的可用连接器。",
    insufficient_info: "登录信息缺失，请检查你的输入。",
    connector_id_mismatch: "传入的连接器 ID 与 session 中保存的记录不一致",
    connector_session_not_found: "无法找到连接器登录信息，请尝试重新登录。",
    verification_session_not_found: "验证失败，请重新验证。",
    verification_expired: "当前页面已超时。为确保你的账号安全，请重新验证。",
    verification_blocked_too_many_attempts: "Too many attempts in a short time. Please try again {{relativeTime}}.",
    unauthorized: "请先登录",
    unsupported_prompt_name: "不支持的 prompt name",
    forgot_password_not_enabled: "忘记密码功能没有开启。",
    verification_failed: "验证失败，请重新验证。",
    connector_validation_session_not_found: "找不到连接器用于验证 token 的信息。",
    identifier_not_found: "找不到用户标识符。请返回并重新登录。",
    interaction_not_found: "找不到交互会话。请返回并重新开始会话。",
    not_supported_for_forgot_password: "This operation is not supported for forgot password.",
    mfa: {
        require_mfa_verification: "Mfa verification is required to sign in.",
        mfa_sign_in_only: "Mfa is only available for sign-in interaction.",
        pending_info_not_found: "Pending MFA info not found, please initiate MFA first.",
        invalid_totp_code: "Invalid TOTP code.",
        webauthn_verification_failed: "WebAuthn verification failed.",
        webauthn_verification_not_found: "WebAuthn verification not found.",
        bind_mfa_existed: "MFA already exists.",
        backup_code_can_not_be_alone: "Backup code can not be the only MFA.",
        backup_code_required: "Backup code is required.",
        invalid_backup_code: "Invalid backup code.",
        mfa_policy_not_user_controlled: "MFA policy is not user controlled."
    },
    sso_enabled: "该邮箱已开启单点登录，请使用 SSO 登录。"
};
var $044813020f07efe8$export$2e2bcd8739ae039 = Object.freeze($044813020f07efe8$var$session);


const $bce58fc4b37f3891$var$sign_in_experiences = {
    empty_content_url_of_terms_of_use: "你启用了“使用条款”，请添加使用条款 URL。",
    empty_social_connectors: "你启用了社交登录的方式。请至少选择一个社交连接器。",
    enabled_connector_not_found: "未找到已启用的 {{type}} 连接器",
    not_one_and_only_one_primary_sign_in_method: "主要的登录方式必须有且仅有一个，请检查你的输入。",
    username_requires_password: "必须为用户名注册标识符启用设置密码。",
    passwordless_requires_verify: "必须为电子邮件/电话注册标识符启用验证。",
    miss_sign_up_identifier_in_sign_in: "登录方法必须包含注册标识符。",
    password_sign_in_must_be_enabled: "必须在注册中要求设置密码时启用密码登录。",
    code_sign_in_must_be_enabled: "必须在注册中不要求设置密码时启用验证码登录。",
    unsupported_default_language: "{{language}} 无法选择为默认语言。",
    at_least_one_authentication_factor: "至少要选择一个登录要素",
    backup_code_cannot_be_enabled_alone: "无法仅启用备份代码。",
    duplicated_mfa_factors: "重复的 MFA 要素。"
};
var $bce58fc4b37f3891$export$2e2bcd8739ae039 = Object.freeze($bce58fc4b37f3891$var$sign_in_experiences);


const $98879f9094f750ae$var$single_sign_on = {
    forbidden_domains: "不允许使用公共电子邮件域名。",
    duplicated_domains: "存在重复的域名。",
    invalid_domain_format: "无效的域名格式。",
    duplicate_connector_name: "连接器名称已存在。请选择不同的名称。"
};
var $98879f9094f750ae$export$2e2bcd8739ae039 = Object.freeze($98879f9094f750ae$var$single_sign_on);


const $6060e1ac77c5e0d5$var$storage = {
    not_configured: "未配置存储提供程序。",
    missing_parameter: "存储提供程序缺少参数 {{parameter}}。",
    upload_error: "无法将文件上传到存储提供程序。"
};
var $6060e1ac77c5e0d5$export$2e2bcd8739ae039 = Object.freeze($6060e1ac77c5e0d5$var$storage);


const $7fc9eb3b0ddbf8bf$var$subscription = {
    limit_exceeded: "您已达到订阅计划的限制。",
    get_plan_failed: "无法获取租户的订阅计划。",
    tenant_suspended: "租户已被暂停。 请联系您的管理员。"
};
var $7fc9eb3b0ddbf8bf$export$2e2bcd8739ae039 = Object.freeze($7fc9eb3b0ddbf8bf$var$subscription);


const $9ba48ab37bc700af$var$swagger = {
    invalid_zod_type: "无效的 Zod 类型，请检查路由 guard 配置。",
    not_supported_zod_type_for_params: "请求参数不支持的 Zod 类型，请检查路由 guard 配置。"
};
var $9ba48ab37bc700af$export$2e2bcd8739ae039 = Object.freeze($9ba48ab37bc700af$var$swagger);


const $b2cd574e6174a458$var$user = {
    username_already_in_use: "该用户名已被使用。",
    email_already_in_use: "该邮箱地址已被使用。",
    phone_already_in_use: "该手机号码已被使用。",
    invalid_email: "邮箱地址不正确。",
    invalid_phone: "手机号码不正确。",
    email_not_exist: "邮箱地址尚未注册。",
    phone_not_exist: "手机号码尚未注册。",
    identity_not_exist: "该社交帐号尚未注册。",
    identity_already_in_use: "该社交帐号已被注册。",
    social_account_exists_in_profile: "你已绑定当前社交账号，无需重复操作。",
    cannot_delete_self: "无法删除自己的账户。",
    sign_up_method_not_enabled: "注册方式尚未启用。",
    sign_in_method_not_enabled: "登录方式尚未启用。",
    same_password: "为确保账户安全，新密码不能与旧密码一致。",
    password_required_in_profile: "请设置登录密码。",
    new_password_required_in_profile: "请设置新密码。",
    password_exists_in_profile: "当前用户已设置密码，无需重复操作。",
    username_required_in_profile: "请设置用户名。",
    username_exists_in_profile: "当前用户已设置用户名，无需重复操作。",
    email_required_in_profile: "请绑定邮箱地址",
    email_exists_in_profile: "当前用户已绑定邮箱，无需重复操作。",
    phone_required_in_profile: "请绑定手机号码。",
    phone_exists_in_profile: "当前用户已绑定手机号，无需重复操作。",
    email_or_phone_required_in_profile: "请绑定邮箱地址或手机号码。",
    suspended: "账号已被禁用。",
    user_not_exist: "未找到与 {{identifier}} 相关联的用户。",
    missing_profile: "请于登录时提供必要的用户补充信息。",
    role_exists: "角色 ID {{roleId}} 已添加到此用户",
    invalid_role_type: "无效的角色类型，无法将机器到机器角色分配给用户。",
    missing_mfa: "你需要在登录之前绑定额外的MFA。",
    totp_already_in_use: "TOTP已在使用中。",
    backup_code_already_in_use: "备用代码已在使用中。",
    password_algorithm_required: "密码算法是必需的。",
    password_and_digest: "You cannot set both plain text password and password digest."
};
var $b2cd574e6174a458$export$2e2bcd8739ae039 = Object.freeze($b2cd574e6174a458$var$user);


const $de4cee7993795ba4$var$verification_code = {
    phone_email_empty: "手机号与邮箱地址均为空",
    not_found: "验证码不存在，请先请求发送验证码",
    phone_mismatch: "手机号码不匹配，请尝试请求新的验证码。",
    email_mismatch: "邮箱地址不匹配，请尝试请求新的验证码。",
    code_mismatch: "验证码不正确",
    expired: "验证码已过期，请尝试请求新的验证码。",
    exceed_max_try: "超过最大验证次数，请尝试请求新的验证码。"
};
var $de4cee7993795ba4$export$2e2bcd8739ae039 = Object.freeze($de4cee7993795ba4$var$verification_code);


const $4f237da72834e0e0$var$errors = {
    request: $936c24479fb6141f$export$2e2bcd8739ae039,
    auth: $62b6bfcd89a958e4$export$2e2bcd8739ae039,
    guard: $62e17bee68291af9$export$2e2bcd8739ae039,
    oidc: $a6d10ee620507be0$export$2e2bcd8739ae039,
    user: $b2cd574e6174a458$export$2e2bcd8739ae039,
    password: $c1adf350dabfc5d2$export$2e2bcd8739ae039,
    session: $044813020f07efe8$export$2e2bcd8739ae039,
    connector: $30117fd670229f0d$export$2e2bcd8739ae039,
    verification_code: $de4cee7993795ba4$export$2e2bcd8739ae039,
    sign_in_experiences: $bce58fc4b37f3891$export$2e2bcd8739ae039,
    jwt_customizer: $18546defb5000aac$export$2e2bcd8739ae039,
    localization: $b094d5ca8260db2c$export$2e2bcd8739ae039,
    swagger: $9ba48ab37bc700af$export$2e2bcd8739ae039,
    entity: $092d957c80a77e9b$export$2e2bcd8739ae039,
    log: $193100b02ce3d74b$export$2e2bcd8739ae039,
    role: $60ab99e532fcf3e4$export$2e2bcd8739ae039,
    scope: $1077b09a9020ca36$export$2e2bcd8739ae039,
    storage: $6060e1ac77c5e0d5$export$2e2bcd8739ae039,
    resource: $b1c953d4356f9875$export$2e2bcd8739ae039,
    hook: $2f25b742549ef1cb$export$2e2bcd8739ae039,
    domain: $1183b65e2cefea1b$export$2e2bcd8739ae039,
    subscription: $7fc9eb3b0ddbf8bf$export$2e2bcd8739ae039,
    application: $8d7a421ef246a668$export$2e2bcd8739ae039,
    organization: $7a036310fe8f74a8$export$2e2bcd8739ae039,
    single_sign_on: $98879f9094f750ae$export$2e2bcd8739ae039
};
var $4f237da72834e0e0$export$2e2bcd8739ae039 = Object.freeze($4f237da72834e0e0$var$errors);


const $7f5a8d8e0be6b33a$var$api_resource_details = {
    page_title: "API 资源详情",
    back_to_api_resources: "返回 API 资源",
    general_tab: "常规",
    permissions_tab: "权限",
    settings: "设置",
    settings_description: "API 资源，又称资源指示器，表示要请求的目标服务或资源，通常是表示资源身份的 URI 格式变量。",
    management_api_settings_description: "Logto 管理 API 是一组全面的 API，使管理员能够管理各种与身份相关的任务，执行安全策略并遵守法规和标准。",
    management_api_notice: "此 API 表示 Logto 实体，无法修改或删除。创建机器对机器应用程序以调用 Logto 管理 API。<a>了解更多</a>",
    token_expiration_time_in_seconds: "Token 过期时间（秒）",
    token_expiration_time_in_seconds_placeholder: "请输入你的 token 过期时间",
    delete_description: "本操作会永久性地删除该 API 资源，且不可撤销。输入 API 资源名称 <span>{{name}}</span> 确认。",
    enter_your_api_resource_name: "输入 API 资源名称",
    api_resource_deleted: " API 资源 {{name}} 已删除.",
    permission: {
        create_button: "创建权限",
        create_title: "创建权限",
        create_subtitle: "定义此 API 所需的权限 (scope)。",
        confirm_create: "创建权限",
        edit_title: "编辑 API 权限",
        edit_subtitle: "定义 {{resourceName}} API 需要的权限（范围）。",
        name: "权限名称",
        name_placeholder: "read:resource",
        forbidden_space_in_name: "权限名称不能包含空格。",
        description: "描述",
        description_placeholder: "能够读取资源",
        permission_created: '权限 "{{name}}" 已成功创建',
        delete_description: "如果删除此权限，拥有该权限的用户将失去由此权限授予的访问权限。",
        deleted: '成功删除权限 "{{name}}"。'
    }
};
var $7f5a8d8e0be6b33a$export$2e2bcd8739ae039 = Object.freeze($7f5a8d8e0be6b33a$var$api_resource_details);


const $bb05b9d4a8dab6e9$var$api_resources = {
    page_title: "API资源",
    title: "API资源",
    subtitle: "定义可以从已授权的应用程序中使用的API",
    create: "创建API资源",
    api_name: "API名称",
    api_name_placeholder: "输入API名称",
    api_identifier: "API标识符",
    api_identifier_placeholder: "https://your-api-identifier/",
    api_identifier_tip: "对于API资源的唯一标识符。它必须是一个绝对URI并没有fragment(#)组件。等价于OAuth 2.0中的<a>资源参数</a>。",
    default_api: "默认API",
    default_api_label: "每个租户只能设置零个或一个默认API。当指定默认API时，可以在认证请求中省略资源参数。后续令牌交换将默认使用该API作为Audience，从而签发JWT。<a>了解更多</a>",
    api_resource_created: "API资源{{name}}已成功创建。",
    invalid_resource_indicator_format: "API标识符必须是有效的绝对URI。"
};
var $bb05b9d4a8dab6e9$export$2e2bcd8739ae039 = Object.freeze($bb05b9d4a8dab6e9$var$api_resources);


const $dae1a2e86d6c3547$var$application_details = {
    page_title: "应用详情",
    back_to_applications: "返回全部应用",
    check_guide: "查看指南",
    settings: "设置",
    settings_description: 'An "Application" is a registered software or service that can access user info or act for a user. Applications help recognize who’s asking for what from Logto and handle the sign-in and permission. Fill in the required fields for authentication.',
    integration: "集成",
    integration_description: "使用由 Cloudflare 边缘网络提供动力的 Logto 安全工作者部署，实现世界各地的一流性能和 0ms 冷启动。",
    service_configuration: "服务配置",
    service_configuration_description: "在您的服务中完成必要的配置。",
    session: "会话",
    endpoints_and_credentials: "端点和凭据",
    endpoints_and_credentials_description: "使用以下端点和凭据在应用程序中设置 OIDC 连接。",
    refresh_token_settings: "刷新令牌设置",
    refresh_token_settings_description: "管理此应用程序的刷新令牌规则。",
    application_roles: "角色",
    machine_logs: "机器日志",
    application_name: "应用名称",
    application_name_placeholder: "我的应用",
    description: "描述",
    description_placeholder: "请输入应用描述",
    config_endpoint: "OpenID Provider 配置端点",
    authorization_endpoint: "授权端点",
    authorization_endpoint_tip: "进行鉴权与授权的端点。用于 OpenID Connect 中的 <a>鉴权</a> 流程。",
    show_endpoint_details: "显示端点详细信息",
    hide_endpoint_details: "隐藏端点详细信息",
    logto_endpoint: "Logto 端点",
    application_id: "应用 ID",
    application_id_tip: "应用的唯一标识，通常由 Logto 生成。等价于 OpenID Connect 中的 <a>client_id</a>。",
    application_secret: "应用密钥",
    redirect_uri: "重定向 URI",
    redirect_uris: "重定向 URIs",
    redirect_uri_placeholder: "https://your.website.com/app",
    redirect_uri_placeholder_native: "io.logto://callback",
    redirect_uri_tip: "在用户登录完成（不论成功与否）后重定向的目标 URI。参见 OpenID Connect <a>AuthRequest</a> 以了解更多。",
    post_sign_out_redirect_uri: "退出登录后重定向 URI",
    post_sign_out_redirect_uris: "退出登录后重定向 URIs",
    post_sign_out_redirect_uri_placeholder: "https://your.website.com/home",
    post_sign_out_redirect_uri_tip: "在用户退出登录后重定向的目标 URI（可选）。在某些应用类型中可能无实质作用。",
    cors_allowed_origins: "CORS 允许的来源",
    cors_allowed_origins_placeholder: "https://your.website.com",
    cors_allowed_origins_tip: "所有重定向 URI 的来源将默认被允许。通常不需要对此字段进行操作。参见 <a>MDN 文档</a> 以了解更多。",
    token_endpoint: "Token 端点",
    user_info_endpoint: "用户信息端点",
    enable_admin_access: "启用管理访问",
    enable_admin_access_label: "启用或禁用对管理 API 的访问。启用后，你可以使用访问令牌代表该应用程序调用管理 API。",
    always_issue_refresh_token: "总是颁发刷新令牌",
    always_issue_refresh_token_label: "启用此配置将允许 Logto 始终颁发刷新令牌，无论身份验证请求中是否呈现 `prompt=consent`。 然而，除非必要，否则不推荐这样做，因为它与 OpenID Connect 不兼容，可能会导致问题。",
    refresh_token_ttl: "刷新令牌有效期（天）",
    refresh_token_ttl_tip: "可用于请求新访问令牌的刷新令牌在过期之前的时间段。访问令牌请求将把刷新令牌的时效延长到此值。",
    rotate_refresh_token: "轮换刷新令牌",
    rotate_refresh_token_label: "启用后，当原先的刷新令牌的时效已经过去 70%，或者满足一定条件时，Logto 将会为访问令牌请求发放新的刷新令牌。<a>了解更多</a>",
    delete_description: "本操作会永久性地删除该应用，且不可撤销。输入 <span>{{name}}</span> 确认。",
    enter_your_application_name: "输入你的应用名称",
    application_deleted: "应用 {{name}} 成功删除。",
    redirect_uri_required: "至少需要输入一个重定向 URI。",
    app_domain_description_1: "随时使用由 Logto 提供支持的 {{domain}} 域名，永久有效。",
    app_domain_description_2: "随时使用您的域名 <domain>{{domain}}</domain>，永久有效。",
    custom_rules: "自定义认证规则",
    custom_rules_placeholder: "^/(admin|privacy)/.+$",
    custom_rules_description: "使用正则表达式为需要认证的路由设置规则。默认情况下：如果留空，则对整个站点进行保护。",
    authentication_routes: "认证路由",
    custom_rules_tip: "以下是两种案例场景：<ol><li>仅对'/admin'和'/privacy'路由进行认证保护：^/(admin|privacy)/.*</li><li>排除 JPG 图像的认证：^(?!.*\\.jpg$).*$</li></ol>",
    authentication_routes_description: "通过指定的路由来重定向您的认证按钮。注意：这些路由是不可替代的。",
    protect_origin_server: "保护您的源服务器",
    protect_origin_server_description: "确保保护源服务器免受直接访问。请参阅指南了解更多<a>详细说明</a>。",
    session_duration: "会话持续时间（天）",
    try_it: "试一下",
    branding: {
        name: "品牌化",
        description: "在授权屏幕上自定义应用程序的显示名称和标识。",
        more_info: "更多信息",
        more_info_description: "在授权屏幕上为用户提供关于您的应用程序的更多详细信息。",
        display_name: "显示名称",
        display_logo: "显示标识",
        display_logo_dark: "显示标识（深色）",
        terms_of_use_url: "应用程序使用条款 URL",
        privacy_policy_url: "应用程序隐私政策 URL"
    },
    permissions: {
        name: "权限",
        description: "选择第三方应用程序需要的权限，以便用户授权访问特定数据类型。",
        user_permissions: "个人用户数据",
        organization_permissions: "组织访问",
        table_name: "授予权限",
        field_name: "权限",
        field_description: "在授权屏幕中显示",
        delete_text: "删除权限",
        permission_delete_confirm: "此操作将会撤回授予第三方应用程序的权限，阻止其请求特定数据类型的用户授权。您确定要继续吗？",
        permissions_assignment_description: "选择第三方应用程序请求用于用户授权访问特定数据类型的权限。",
        user_profile: "用户数据",
        api_permissions: "API 权限",
        organization: "组织权限",
        user_permissions_assignment_form_title: "添加用户个人资料权限",
        organization_permissions_assignment_form_title: "添加组织权限",
        api_resource_permissions_assignment_form_title: "添加 API 资源权限",
        user_data_permission_description_tips: "您可以通过“登录体验 > 内容 > 管理语言”修改个人用户数据权限的描述。",
        permission_description_tips: "当 Logto 作为第三方应用程序中的身份提供者（IdP）用于授权时，用户被要求授权时，此描述会显示在授权屏幕上。",
        user_title: "用户",
        user_description: "选择第三方应用程序需要访问特定用户数据的权限。",
        grant_user_level_permissions: "授予用户数据权限",
        organization_title: "组织",
        organization_description: "选择第三方应用程序需要访问特定组织数据的权限。",
        grant_organization_level_permissions: "授予组织数据权限"
    },
    roles: {
        name_column: "角色",
        description_column: "描述",
        assign_button: "分配角色",
        delete_description: "此操作将会从此应用中移除此角色。角色本身仍然存在，但不再与此应用关联。",
        deleted: "成功从此用户中移除 {{name}}。",
        assign_title: "为 {{name}} 分配角色",
        assign_subtitle: "授权 {{name}} 一个或多个角色",
        assign_role_field: "分配角色",
        role_search_placeholder: "按角色名称搜索",
        added_text: "{{value, number}}个已添加",
        assigned_app_count: "{{value, number}}个应用",
        confirm_assign: "分配角色",
        role_assigned: "成功分配角色",
        search: "按角色名称、描述或 ID 搜索",
        empty: "没有可用的角色"
    }
};
var $dae1a2e86d6c3547$export$2e2bcd8739ae039 = Object.freeze($dae1a2e86d6c3547$var$application_details);


const $2d891c6305341353$var$applications = {
    page_title: "全部应用",
    title: "全部应用",
    subtitle: "创建一个移动、单页、machine-to-machine 或传统 web 应用程序，并通过 Logto 进行身份验证",
    subtitle_with_app_type: "为你的 {{name}} 应用程序设置 Logto 身份验证",
    create: "创建应用",
    create_subtitle_third_party: "使用 Logto 作为你的身份提供者（IdP）来轻松集成第三方应用程序",
    application_name: "应用名称",
    application_name_placeholder: "我的应用",
    application_description: "应用描述",
    application_description_placeholder: "请输入应用描述",
    select_application_type: "选择应用类型",
    no_application_type_selected: "你还没有选择应用类型",
    application_created: "创建应用成功。",
    tab: {
        my_applications: "我的应用",
        third_party_applications: "第三方应用"
    },
    app_id: "App ID",
    type: {
        native: {
            title: "原生应用",
            subtitle: "在原生环境中运行的应用程序",
            description: "例如 iOS 应用程序，Android 应用程序"
        },
        spa: {
            title: "单页应用",
            subtitle: "在浏览器中运行并动态更新数据的应用程序",
            description: "例如 React DOM 应用程序，Vue 应用程序"
        },
        traditional: {
            title: "传统网页应用",
            subtitle: "仅由 Web 服务器渲染和更新的应用程序",
            description: "例如 Next.js, PHP"
        },
        machine_to_machine: {
            title: "机器对机器",
            subtitle: "直接与资源对话的应用程序（通常是服务）",
            description: "例如后端服务"
        },
        protected: {
            title: "受保护的应用",
            subtitle: "受 Logto 保护的应用程序",
            description: "N/A"
        },
        third_party: {
            title: "第三方应用",
            subtitle: "用作第三方 IdP 连接器的应用程序",
            description: "例如，OIDC，SAML"
        }
    },
    placeholder_title: "选择应用程序类型以继续",
    placeholder_description: "Logto 使用 OIDC 的应用程序实体来帮助识别你的应用程序、管理登录和创建审计日志等任务。",
    m2m_role_assignment: {
        title: "使用机器到机器角色授权应用程序以获取权限",
        subtitle: "机器对机器应用程序需要经过授权的机器对机器角色。",
        role_creation_hint: "找不到合适的机器对机器角色？<a>创建一个机器对机器角色</a>"
    }
};
var $2d891c6305341353$export$2e2bcd8739ae039 = Object.freeze($2d891c6305341353$var$applications);


const $85d4b35dc2a9fd35$var$cloud = {
    general: {
        onboarding: "入门"
    },
    welcome: {
        page_title: "欢迎",
        title: "欢迎来到 Logto Cloud！我们很想了解你。",
        description: "通过更好地了解你，我们可以使你的 Logto 体验更加个性化。你的信息是安全的。",
        project_field: "我使用 Logto 是为了",
        project_options: {
            personal: "个人项目",
            company: "公司项目"
        },
        company_name_field: "公司名称",
        company_name_placeholder: "Acme.co",
        stage_field: "你的产品目前处于哪个阶段？",
        stage_options: {
            new_product: "开始一个新项目，寻找一个快速的即插即用解决方案",
            existing_product: "从当前的身份验证系统迁移（例如，自建、Auth0、Cognito、Microsoft）",
            target_enterprise_ready: "我刚刚赢得了更大的客户，现在希望让我的产品适应企业销售"
        },
        additional_features_field: "你还有其他想告诉我们的信息么？",
        additional_features_options: {
            customize_ui_and_flow: "构建并管理我的 UI，而不仅仅使用 Logto 预构建和可定制的解决方案",
            compliance: "SOC2 和 GDPR 是必须的",
            export_user_data: "需要能够从 Logto 导出用户数据",
            budget_control: "我有非常严格的预算控制",
            bring_own_auth: "有自己的身份验证服务，只需要一些 Logto 功能",
            others: "以上都不是"
        }
    },
    sie: {
        page_title: "定制登录体验",
        title: "让我们轻松定制你的登录体验",
        inspire: {
            title: "创建引人入胜的示例",
            description: "对登录体验不确定吗？只需点击“启发我”，让魔法发生！",
            inspire_me: "来点灵感"
        },
        logo_field: "应用商标",
        color_field: "品牌颜色",
        identifier_field: "标识符",
        identifier_options: {
            email: "电子邮件",
            phone: "电话",
            user_name: "用户名"
        },
        authn_field: "身份验证",
        authn_options: {
            password: "密码",
            verification_code: "验证码"
        },
        social_field: "社交登录",
        finish_and_done: "完成并完成",
        preview: {
            mobile_tab: "移动端",
            web_tab: "网页端"
        },
        connectors: {
            unlocked_later: "稍后解锁",
            unlocked_later_tip: "完成入门流程并进入产品后，你将获得访问更多社交登录方式的权限。",
            notice: "请勿将演示连接器用于生产目的。 完成测试后，请删除演示连接器并使用你的凭证设置自己的连接器。"
        }
    },
    socialCallback: {
        title: "你已成功登录",
        description: "你已成功使用社交账户登录。为确保与 Logto 的无缝集成并获得所有功能的访问权限，我们建议你继续配置自己的社交连接器。"
    },
    tenant: {
        create_tenant: "创建租户"
    }
};
var $85d4b35dc2a9fd35$export$2e2bcd8739ae039 = Object.freeze($85d4b35dc2a9fd35$var$cloud);


const $445cde5ca6ec918f$var$components = {
    uploader: {
        action_description: "拖放或浏览上传",
        uploading: "上传中...",
        image_limit: "上传图片大小不能超过 {{size, number}}KB，只支持 {{extensions, list(style: narrow; type: conjunction;)}} 格式的文件。",
        error_upload: "哎呀，出了些问题。文件上传失败。",
        error_file_size: "文件太大了，请上传小于 {{size, number}}KB 的文件。",
        error_file_type: "不支持该文件类型。只支持 {{extensions, list(style: narrow; type: conjunction;)}} 格式的文件。",
        error_file_count: "只能上传一个文件。"
    }
};
var $445cde5ca6ec918f$export$2e2bcd8739ae039 = Object.freeze($445cde5ca6ec918f$var$components);


const $c7a793818a97173c$var$connector_details = {
    page_title: "连接器详情",
    back_to_connectors: "返回连接器",
    check_readme: "查看 README",
    settings: "通用设置",
    settings_description: "连接器在 Logto 中扮演着至关重要的角色。借助它们的帮助，Logto 使终端用户能够使用无密码注册或登录的功能以及使用社交帐户登录的功能。",
    parameter_configuration: "参数配置",
    test_connection: "测试",
    save_error_empty_config: "请输入配置内容",
    send: "发送",
    send_error_invalid_format: "无效输入",
    edit_config_label: "请在此输入你的 JSON 配置",
    test_email_sender: "测试你的邮件连接器",
    test_sms_sender: "测试你的短信连接器",
    test_email_placeholder: "john.doe@example.com",
    test_sms_placeholder: "+86 131 1234 5678",
    test_message_sent: "测试信息已发送",
    test_sender_description: 'Logto 使用 "Generic" 模板进行测试。如果你的连接器正确配置，你将收到一条消息。',
    options_change_email: "更换邮件连接器",
    options_change_sms: "更换短信连接器",
    connector_deleted: "成功删除连接器",
    type_email: "邮件连接器",
    type_sms: "短信连接器",
    type_social: "社交连接器",
    in_used_social_deletion_description: "你的登录体验正在使用这个连接器。删除后，<name/> 登录体验将在登录体验设置中被删除，再次添加需重新配置。",
    in_used_passwordless_deletion_description: "你的登录体验正在使用 {{name}} 连接器。删除后，你的登录体验将无法正常工作，直到你解决冲突，再次添加需重新配置。",
    deletion_description: "你将删除此连接器。此操作不可撤销，再次添加需重新配置。",
    logto_email: {
        total_email_sent: "已发送邮件总数: {{value, number}}",
        total_email_sent_tip: "Logto 使用 SendGrid 进行安全稳定的内置电子邮件功能。此功能完全免费使用。<a>了解更多</a>",
        email_template_title: "电子邮件模板",
        template_description: "内置电子邮件使用默认模板，无需配置即可无缝发送验证电子邮件。您可以自定义基本品牌信息。",
        template_description_link_text: "查看模板",
        description_action_text: "查看模板",
        from_email_field: "发件人电子邮件",
        sender_name_field: "发件人姓名",
        sender_name_tip: "自定义电子邮件的发件人姓名。如果留空，则默认使用「Verification」作为名称。",
        sender_name_placeholder: "发件人姓名",
        company_information_field: "公司信息",
        company_information_description: "在电子邮件底部显示您公司的名称、地址或邮编，以增强真实性。",
        company_information_placeholder: "你公司的基本信息",
        app_logo_field: "应用程序标志",
        app_logo_tip: "在电子邮件顶部显示您的品牌标志。在浅色模式和深色模式下使用相同的图像。",
        urls_not_allowed: "不允许使用 URL",
        test_notes: 'Logto 使用 "通用" 模板进行测试。'
    }
};
var $c7a793818a97173c$export$2e2bcd8739ae039 = Object.freeze($c7a793818a97173c$var$connector_details);


const $b47102bc8e498fb4$var$connectors = {
    page_title: "连接器",
    title: "连接器",
    subtitle: "设置连接器，开启无密码和社交登录",
    create: "添加社交连接器",
    config_sie_notice: "你已经配置了社交连接器，记得在<a>{{link}}</a>上添加使之生效。",
    config_sie_link_text: "登录体验",
    tab_email_sms: "短信和邮件连接器",
    tab_social: "社交连接器",
    connector_name: "连接器名称",
    demo_tip: "演示连接器仅用于演示且最多只能发送 100 条消息，不建议在生产环境中部署。",
    social_demo_tip: "演示连接器仅用于演示目的，不建议在生产环境中部署。",
    connector_type: "类型",
    connector_status: "登录体验",
    connector_status_in_use: "使用中",
    connector_status_not_in_use: "未使用",
    not_in_use_tip: {
        content: "未使用意味着你的登录体验并没有使用这个登录方式。<a>{{link}}</a>去添加。",
        go_to_sie: "前往登录体验"
    },
    placeholder_title: "社交连接器",
    placeholder_description: "Logto 提供了许多广泛使用的社交登录连接器，同时你还可以使用标准协议创建自己的连接器。",
    save_and_done: "保存并完成",
    type: {
        email: "邮件连接器",
        sms: "短信连接器",
        social: "社交连接器"
    },
    setup_title: {
        email: "设置邮件连接器",
        sms: "设置短信连接器",
        social: "添加社交连接器"
    },
    guide: {
        subtitle: "参考以下步骤完成你的连接器设置",
        general_setting: "通用设置",
        parameter_configuration: "参数配置",
        test_connection: "连接测试",
        name: "社交登录按钮的名称",
        name_placeholder: "输入社交登录按钮的名称",
        name_tip: "按钮上将展示「通过 {{name}} 继续」。名字不宜过长而导致信息无法展示完整。",
        logo: "社交登录按钮的 Logo 图片链接",
        logo_placeholder: "https://your.cdn.domain/logo.png",
        logo_tip: "该图片将用于连接器的展示。获取图片链接后粘贴在此处。",
        logo_dark: "社交登录按钮的 Logo 图片链接（深色模式）",
        logo_dark_placeholder: "https://your.cdn.domain/logo.png",
        logo_dark_tip: "在管理控制台的登录体验中启用“深色模式”后，可设置此连接器 Logo 用于深色模式。",
        logo_dark_collapse: "收起",
        logo_dark_show: "展开深色模式 Logo 设置",
        target: "身份提供商名称",
        target_placeholder: "输入身份提供商的名称",
        target_tip: "在“身份供应商名称”字段中输入唯一的标识符字符串，用于区分社交身份来源。",
        target_tip_standard: "在“身份供应商名称”字段中输入唯一的标识符字符串，用于区分社交身份来源。注意，在连接器创建成功后，无法再次修改此设置。",
        target_tooltip: "Logto 社交连接器的「target」指的是社交身份的「来源」。在 Logto 的设计里，我们不允许某一平台的连接器中有相同的「target」以避免身份的冲突。在添加连接器时，你需要格外小心，我们「不允许」用户在创建之后更改「target」的值。<a>了解更多</a>",
        target_conflict: "此「身份供应商名称」值与现有的 <span>name</span> 连接器相同。使用相同的身份供应商名称会导致不符合预期的登录行为，用户可能通过两个不同的连接器访问同一个帐户。",
        target_conflict_line2: "如果你想替换当前的连接器，并连接相同的身份提供商（IdP），以便先前的用户可以直接登录而无需重新注册，请先删除 <span>name</span> 连接器，再创建一个新的连接器并使用相同的「身份供应商名称」值。",
        target_conflict_line3: "如果你想连接一个新的身份验证提供程序，请修改「身份供应商名称」并继续。",
        config: "粘贴你的 JSON 代码",
        sync_profile: "开启用户资料同步",
        sync_profile_only_at_sign_up: "首次注册时同步",
        sync_profile_each_sign_in: "每次登录时同步",
        sync_profile_tip: "同步用户的用户名、头像等个人资料信息",
        callback_uri: "Callback URI",
        callback_uri_description: "也称为重定向 URI，在社交授权后，用户将被发送回 Logto 的 URI，复制并粘贴到社交提供者的配置页面中。",
        acs_url: "断言消费服务 URL"
    },
    platform: {
        universal: "通用",
        web: "网页",
        native: "原生"
    },
    add_multi_platform: "支持多平台，选择一个平台继续",
    drawer_title: "连接器配置指南",
    drawer_subtitle: "参考以下步骤完善或修改你的连接器设置",
    unknown: "未知连接器",
    standard_connectors: "标准连接器"
};
var $b47102bc8e498fb4$export$2e2bcd8739ae039 = Object.freeze($b47102bc8e498fb4$var$connectors);


const $192bc810cf6d0dfd$var$contact = {
    title: "获取帮助",
    description: "有关帮助请求或产品反馈，请通过以下方式与我们联系。",
    discord: {
        title: "加入 Discord 社区",
        description: "与其他开发人员建立联系以找到解决方案",
        button: "加入"
    },
    github: {
        title: "在 GitHub 上交流",
        description: "在 GitHub 上创建问题并提交",
        button: "打开"
    },
    email: {
        title: "通过邮件联系支持",
        description: "发送电子邮件以获取更多信息和帮助",
        button: "发送"
    },
    reserve: {
        title: "与 Logto 团队预定时间",
        description: "快速预定一次在线聊天",
        button: "预定"
    }
};
var $192bc810cf6d0dfd$export$2e2bcd8739ae039 = Object.freeze($192bc810cf6d0dfd$var$contact);


const $3b4080e29790582f$var$dashboard = {
    page_title: "仪表盘",
    title: "仪表盘",
    description: "查看所有应用的数据概况",
    total_users: "总用户",
    total_users_tip: "总用户",
    new_users_today: "今日新增",
    new_users_today_tip: "今日注册到你应用上的新用户数",
    new_users_7_days: "7 日新增",
    new_users_7_days_tip: "最近 7 日注册到你应用上的新用户数",
    daily_active_users: "日活用户",
    daily_active_users_tip: "今日在你的应用上交换过 token 的独立用户数",
    weekly_active_users: "周活用户",
    weekly_active_users_tip: "最近 7 日在你的应用上交换过 token 的独立用户数",
    monthly_active_users: "月活用户",
    monthly_active_users_tip: "最近 30 日在你的应用上交换过 token 的独立用户数"
};
var $3b4080e29790582f$export$2e2bcd8739ae039 = Object.freeze($3b4080e29790582f$var$dashboard);


const $7045a227834c0537$var$domain = {
    status: {
        connecting: "连接中...",
        in_use: "使用中",
        failed_to_connect: "连接失败"
    },
    update_endpoint_notice: "如果你想使用自定义域名，请不要忘记在应用程序中更新社交连接器回调 URI 和 Logto 终结点的域名。 <a>{{link}}</a>",
    error_hint: "请确保更新你的 DNS 记录。我们将继续每 {{value}} 秒检查一次。",
    custom: {
        custom_domain: "自定义域名",
        custom_domain_description: "通过使用自定义域名来提高品牌形象。此域名将用于你的登录体验。",
        custom_domain_field: "自定义域名",
        custom_domain_placeholder: "your.domain.com",
        add_domain: "添加域名",
        invalid_domain_format: '请提供一个有效的域名 URL，至少有三个部分，例如 "your.domain.com."',
        verify_domain: "验证域名",
        enable_ssl: "启用 SSL",
        checking_dns_tip: "DNS 记录已配置，请等待最长 24 小时，以使变更生效。在域名是否有效期间，你可以离开此界面。",
        enable_ssl_tip: "启用 SSL 将自动运行，可能需要最长 24 小时。在运行期间，你可以离开此界面。",
        generating_dns_records: "正在生成 DNS 记录...",
        add_dns_records: "请将以下 DNS 记录添加到你的 DNS 服务提供商。",
        dns_table: {
            type_field: "类型",
            name_field: "名称",
            value_field: "值"
        },
        deletion: {
            delete_domain: "删除域名",
            reminder: "删除自定义域名",
            description: "你确定要删除此自定义域名吗？",
            in_used_description: '你确定要删除此自定义域名 "<span>{{domain}}</span>" 吗？',
            in_used_tip: '如果你之前已在社交连接器提供商或应用程序终结点中设置了此自定义域名，则需要先将 URI 修改为 Logto 默认域名 "<span>{{domain}}</span>"。这对于社交登录按钮的正常工作是必要的。',
            deleted: "自定义域名删除成功！"
        }
    },
    default: {
        default_domain: "默认域名",
        default_domain_description: "Logto 提供了一个预配置的默认域名，无需任何其他设置即可使用。即使你启用了自定义域名，此默认域名也可作为备用选项。",
        default_domain_field: "Logto 默认域名"
    },
    custom_endpoint_note: '你可以根据需要自定义这些端点的域名。选择 "{{custom}}" 或 "{{default}}"。',
    custom_social_callback_url_note: '你可以根据需要自定义此 URI 的域名，以匹配你的应用程序端点。选择 "{{custom}}" 或 "{{default}}"。',
    custom_acs_url_note: '您可以根据需要自定义此 URI 的域名，以匹配您的身份提供方断言使用者服务 URL。选择 "{{custom}}" 或 "{{default}}"。'
};
var $7045a227834c0537$export$2e2bcd8739ae039 = Object.freeze($7045a227834c0537$var$domain);


const $abf0cde9323debea$var$enterprise_sso_details = {
    back_to_sso_connectors: "返回企业SSO",
    page_title: "企业SSO连接器详情",
    readme_drawer_title: "企业SSO",
    readme_drawer_subtitle: "设置企业SSO连接器以启用最终用户SSO",
    tab_experience: "SSO体验",
    tab_connection: "连接",
    general_settings_title: "常规",
    custom_branding_title: "显示",
    custom_branding_description: "自定义在最终用户单点登录流程中显示的名称和标识。如果为空，则使用默认值。",
    email_domain_field_name: "企业电子邮件域",
    email_domain_field_description: "拥有此电子邮件域的用户可以使用SSO进行身份验证。请验证该域名属于企业。",
    email_domain_field_placeholder: "邮箱域",
    sync_profile_field_name: "从身份提供者同步个人资料信息",
    sync_profile_option: {
        register_only: "仅在首次登录时同步",
        each_sign_in: "每次登录时始终同步"
    },
    connector_name_field_name: "连接器名称",
    display_name_field_name: "显示名称",
    connector_logo_field_name: "显示标识",
    connector_logo_field_description: "每个图像应不超过500KB，仅支持SVG、PNG、JPG、JPEG。",
    branding_logo_context: "上传标识",
    branding_logo_error: "上传标识错误：{{error}}",
    branding_light_logo_context: "上传浅色主题标识",
    branding_light_logo_error: "上传浅色主题标识错误：{{error}}",
    branding_logo_field_name: "标识",
    branding_logo_field_placeholder: "https://your.domain/logo.png",
    branding_dark_logo_context: "上传深色主题标识",
    branding_dark_logo_error: "上传深色主题标识错误：{{error}}",
    branding_dark_logo_field_name: "标识（深色主题）",
    branding_dark_logo_field_placeholder: "https://your.domain/dark-mode-logo.png",
    check_connection_guide: "连接指南",
    enterprise_sso_deleted: "企业SSO连接器已成功删除",
    delete_confirm_modal_title: "删除企业SSO连接器",
    delete_confirm_modal_content: "您确定要删除此企业连接器吗？来自身份提供者的用户将不能使用单点登录。",
    upload_idp_metadata_title_saml: "上传元数据",
    upload_idp_metadata_description_saml: "配置从身份提供者复制的元数据。",
    upload_idp_metadata_title_oidc: "上传凭证",
    upload_idp_metadata_description_oidc: "配置从身份提供者复制的凭证和OIDC令牌信息。",
    upload_idp_metadata_button_text: "上传元数据XML文件",
    upload_signing_certificate_button_text: "上传签名证书文件",
    configure_domain_field_info_text: "添加电子邮件域以指导企业用户到其身份提供者进行单点登录。",
    email_domain_field_required: "必须提供电子邮件域以启用企业SSO。",
    upload_saml_idp_metadata_info_text_url: "粘贴从身份提供者获取的元数据URL进行连接。",
    upload_saml_idp_metadata_info_text_xml: "粘贴从身份提供者获取的元数据进行连接。",
    upload_saml_idp_metadata_info_text_manual: "填写从身份提供者获取的元数据进行连接。",
    upload_oidc_idp_info_text: "填写来自身份提供者的信息进行连接。",
    service_provider_property_title: "在IdP中配置",
    service_provider_property_description: "在您的身份提供者中使用{{protocol}}设置应用程序集成。输入Logto提供的详细信息。",
    attribute_mapping_title: "属性映射",
    attribute_mapping_description: "通过在身份提供者或Logto端配置用户属性映射，从身份提供者同步用户配置文件。",
    saml_preview: {
        sign_on_url: "登录URL",
        entity_id: "发行者",
        x509_certificate: "签名证书",
        certificate_content: "将于{{date}}到期"
    },
    oidc_preview: {
        authorization_endpoint: "授权端点",
        token_endpoint: "令牌端点",
        userinfo_endpoint: "用户信息端点",
        jwks_uri: "JSON Web Key集端点",
        issuer: "发行者"
    }
};
var $abf0cde9323debea$export$2e2bcd8739ae039 = Object.freeze($abf0cde9323debea$var$enterprise_sso_details);


const $5611aec88253e630$var$enterprise_sso = {
    page_title: "企业单点登录",
    title: "企业单点登录",
    subtitle: "连接企业身份提供者并启用SP启动的单点登录。",
    create: "添加企业连接器",
    col_connector_name: "连接器名称",
    col_type: "类型",
    col_email_domain: "电子邮件域",
    placeholder_title: "企业连接器",
    placeholder_description: "Logto提供了许多内置的企业身份提供者，与之连接，与此同时您可以使用SAML和OIDC协议创建自己的企业身份提供者。",
    create_modal: {
        title: "添加企业连接器",
        text_divider: "或者您可以通过标准协议自定义您的连接器。",
        connector_name_field_title: "连接器名称",
        connector_name_field_placeholder: "E.g., {corp. name} - {identity provider name}",
        create_button_text: "创建连接器"
    },
    guide: {
        subtitle: "连接企业身份提供者的逐步指南。",
        finish_button_text: "继续"
    },
    basic_info: {
        title: "在IdP中配置您的服务",
        description: "在{{name}}身份提供者中通过SAML 2.0创建一个新的应用集成。然后将以下值粘贴到其中。",
        saml: {
            acs_url_field_name: "断言消费者服务URL（回复URL）",
            audience_uri_field_name: "受众URI（SP实体ID）"
        },
        oidc: {
            redirect_uri_field_name: "重定向URI（回调URL）"
        }
    },
    attribute_mapping: {
        title: "属性映射",
        description: "需要`id`和`email`来同步用户配置文件。在IdP中输入以下声明名称和值。",
        col_sp_claims: "服务提供商（Logto）的值",
        col_idp_claims: "身份提供者的声明名称",
        idp_claim_tooltip: "身份提供者的声明名称"
    },
    metadata: {
        title: "配置IdP元数据",
        description: "配置来自身份提供者的元数据",
        dropdown_trigger_text: "使用其他配置方法",
        dropdown_title: "选择您的配置方法",
        metadata_format_url: "输入元数据URL",
        metadata_format_xml: "上传元数据XML文件",
        metadata_format_manual: "手动输入元数据详细信息",
        saml: {
            metadata_url_field_name: "元数据URL",
            metadata_url_description: "动态地从元数据URL获取数据并更新证书。",
            metadata_xml_field_name: "IdP元数据XML文件",
            metadata_xml_uploader_text: "上传元数据XML文件",
            sign_in_endpoint_field_name: "登录URL",
            idp_entity_id_field_name: "IdP实体ID（发行者）",
            certificate_field_name: "签名证书",
            certificate_placeholder: "复制并粘贴x509证书",
            certificate_required: "需要签名证书。"
        },
        oidc: {
            client_id_field_name: "客户端ID",
            client_secret_field_name: "客户端密钥",
            issuer_field_name: "发行者",
            scope_field_name: "范围"
        }
    }
};
var $5611aec88253e630$export$2e2bcd8739ae039 = Object.freeze($5611aec88253e630$var$enterprise_sso);


const $91d4d70592305c26$var$errors = {
    something_went_wrong: "哎呀，出错了！",
    page_not_found: "找不到页面",
    unknown_server_error: "服务器发生未知错误",
    empty: "没有数据",
    missing_total_number: "无法从返回的头部信息中找到 Total-Number",
    invalid_uri_format: "无效的 URI 格式",
    invalid_origin_format: "无效的 URI origin 格式",
    invalid_json_format: "无效的 JSON 格式",
    invalid_regex: "无效的正则表达式",
    invalid_error_message_format: "非法的错误信息格式",
    required_field_missing: "请输入{{field}}",
    required_field_missing_plural: "至少需要输入一个{{field}}",
    more_details: "查看详情",
    username_pattern_error: "用户名只能包含英文字母、数字或下划线，且不以数字开头。",
    email_pattern_error: "邮箱地址无效",
    phone_pattern_error: "手机号码无效",
    insecure_contexts: "不支持不安全的上下文（非 HTTPS）。",
    unexpected_error: "发生未知错误",
    not_found: "404 找不到资源",
    create_internal_role_violation: '你正在创建一个被 Logto 禁止内部角色。尝试使用不以 "#internal:" 开头的其他名称。',
    should_be_an_integer: "应该是整数。",
    number_should_be_between_inclusive: "然后数字应该在 {{min}} 到 {{max}} 之间（两端都包括）。"
};
var $91d4d70592305c26$export$2e2bcd8739ae039 = Object.freeze($91d4d70592305c26$var$errors);


const $a45cbefa4e7d488a$var$general = {
    placeholder: "占位符",
    submit: "提交",
    skip: "跳过",
    next: "下一步",
    back: "上一步",
    retry: "重试",
    done: "完成",
    search: "搜索",
    search_placeholder: "搜索",
    clear_result: "清除结果",
    save: "保存",
    save_changes: "保存更改",
    saved: "保存成功",
    discard: "放弃",
    loading: "读取中...",
    redirecting: "页面跳转中...",
    add: "添加",
    added: "已添加",
    cancel: "取消",
    confirm: "确认",
    check_out: "查看",
    create: "创建",
    set_up: "配置",
    customize: "自定义",
    enable: "启用",
    reminder: "提示",
    edit: "编辑",
    delete: "删除",
    deleted: "已删除",
    more_options: "更多选项",
    close: "关闭",
    copy: "复制",
    copying: "复制中",
    copied: "已复制",
    required: "必填",
    add_another: "新增",
    create_another: "创建另一个",
    deletion_confirmation: "你确定要删除这个 {{title}} 吗?",
    settings_nav: "设置",
    unsaved_changes_warning: "还有未保存的变更, 确定要离开吗？",
    leave_page: "离开此页",
    stay_on_page: "留在此页",
    type_to_search: "输入搜索",
    got_it: "知道了",
    continue: "继续",
    page_info: "{{min, number}}-{{max, number}} 共 {{total, number}} 条",
    learn_more: "了解更多",
    tab_errors: "{{count, number}} 个错误",
    skip_for_now: "先跳过",
    remove: "移除",
    visit: "访问",
    join: "加入",
    try_now: "现在试试",
    multiple_form_field: "（多选）",
    demo: "演示",
    unnamed: "未命名",
    view: "查看",
    open: "打开",
    hide: "隐藏",
    unknown_error: "未知错误，请稍后重试。",
    select: "选择",
    contact_us_action: "联系我们",
    description: "描述",
    name: "名称",
    add_field: "添加{{field}}",
    create_field: "创建{{field}}",
    edit_field: "编辑{{field}}",
    delete_field: "删除{{field}}",
    coming_soon: "即将上线",
    or: "或"
};
var $a45cbefa4e7d488a$export$2e2bcd8739ae039 = Object.freeze($a45cbefa4e7d488a$var$general);


const $632fa2112af850d4$var$get_started = {
    page_title: "开始上手",
    title: "成功开发身份方案，我们先来探索一番",
    subtitle: "一些你可以做的事情，以快速获取 Logto 的价值",
    develop: {
        title: "开发：花 5 分钟集成你的应用",
        title_cloud: "Develop: 安全地在几分钟内集成您的应用",
        subtitle_cloud: "或花 5 分钟用我们预构建的 SDK 和教程集成您的应用。"
    },
    customize: {
        title: "自定义：提供出色的登录体验",
        preview: {
            title: "实时预览定制的登录体验",
            subtitle: "立刻尝试 Logto 登录体验，看看它是如何工作的"
        },
        connector: {
            title: "添加更多连接器来支持更多社交登录方式",
            subtitle: "尝试免密码登录，为您的客户提供安全、无摩擦的体验"
        },
        continue_customizing: "继续定制",
        try_now: "立即尝试",
        add_more: "添加更多"
    },
    secure: {
        title: "安全：保护你的资源"
    },
    manage: {
        title: "管理：为你的产品和用户定义访问控制",
        rbac: {
            title: "为你的资源添加基于角色的访问控制",
            subtitle: "通过可扩展的角色授权控制你的资源，应对不同的使用场景。"
        },
        create_roles: "创建角色"
    },
    view_all: "查看全部 →"
};
var $632fa2112af850d4$export$2e2bcd8739ae039 = Object.freeze($632fa2112af850d4$var$get_started);


const $0e3e6b2c8d3aa5da$var$guide = {
    start_building: "开始构建",
    get_started: "立即开始",
    categories: {
        featured: "推荐热门开发框架",
        Traditional: "传统网页应用",
        SPA: "单页应用",
        Native: "原生应用",
        MachineToMachine: "Machine-to-machine",
        Protected: "非 SDK 集成",
        ThirdParty: "第三方应用"
    },
    filter: {
        title: "筛选框架",
        placeholder: "搜索框架"
    },
    checkout_tutorial: "查看 {{name}} 教程",
    do_not_need_tutorial: "如果你现在不需要教程，可以点击右侧按钮继续创建应用",
    finish_and_done: "完成",
    cannot_find_guide: "找不到你想要的教程？",
    describe_guide_looking_for: "描述你正在寻找的教程",
    request_guide_successfully: "请求已成功提交，谢谢！",
    app: {
        select_framework_or_tutorial: "选择一个框架或教程",
        guide_modal_title: "从 SDK 和指南开始",
        modal_subtitle: "使用我们提供的 SDK 和集成教程加速你的应用开发过程。",
        select_a_framework: "选择一个框架",
        continue_without_framework: "跳过教程直接创建应用",
        describe_guide_looking_for_placeholder: "例如：我想将 Logto 集成到我的 Angular 应用程序中。"
    },
    api: {
        modal_title: "首先从教程开始",
        modal_subtitle: "使用我们提供的教程来加速你的应用程序开发过程。",
        select_a_tutorial: "选择一个教程",
        continue_without_tutorial: "跳过教程直接创建 API 资源",
        describe_guide_looking_for_placeholder: "例如：我想使用 deno 框架为我的 API 鉴权。"
    }
};
var $0e3e6b2c8d3aa5da$export$2e2bcd8739ae039 = Object.freeze($0e3e6b2c8d3aa5da$var$guide);


const $217560c9df26045c$var$invitation = {
    find_your_tenants: "找到你的租户",
    find_tenants_description: "您的电子邮件地址可能已经注册了多个租户。您可以选择加入现有租户或继续创建一个新租户。",
    create_new_tenant: "创建一个新的租户",
    email_not_match_title: "您当前以\n{{email}}\n登录",
    email_not_match_description: "请使用正确的帐户登录以接受邀请并成为组织的成员。",
    switch_account: "切换到另一个帐户登录",
    invalid_invitation_status: "无效的邀请。请联系管理员并重试。",
    invitation_not_found: "未找到邀请。请联系管理员。"
};
var $217560c9df26045c$export$2e2bcd8739ae039 = Object.freeze($217560c9df26045c$var$invitation);


const $03dd0602c603535c$var$jwt_claims = {
    title: "自定义JWT",
    description: "设置自定义JWT声明以包含在访问令牌中。这些声明可以用于向应用程序传递附加信息。",
    user_jwt: {
        card_title: "对于用户",
        card_field: "用户访问令牌",
        card_description: "在访问令牌发放期间添加用户特定数据。",
        for: "给用户"
    },
    machine_to_machine_jwt: {
        card_title: "对于M2M",
        card_field: "机器间令牌",
        card_description: "在机器间令牌发放期间添加额外数据。",
        for: "给M2M"
    },
    code_editor_title: "自定义{{token}}声明",
    custom_jwt_create_button: "添加自定义声明",
    custom_jwt_item: "自定义声明{{for}}",
    delete_modal_title: "删除自定义声明",
    delete_modal_content: "您确定要删除自定义声明吗？",
    clear: "清除",
    cleared: "已清除",
    restore: "恢复默认",
    restored: "已恢复",
    data_source_tab: "数据来源",
    test_tab: "测试上下文",
    jwt_claims_description: "默认声明会自动包含在JWT中，不能被覆盖。",
    user_data: {
        title: "用户数据",
        subtitle: "使用`data.user`输入参数提供重要用户信息。"
    },
    token_data: {
        title: "令牌数据",
        subtitle: "使用`token`输入参数查看当前访问令牌负载。"
    },
    fetch_external_data: {
        title: "获取外部数据",
        subtitle: "直接将外部API中的数据纳入声明。",
        description: "使用`fetch`函数调用外部API并将数据包含在自定义声明中。示例："
    },
    environment_variables: {
        title: "设置环境变量",
        subtitle: "使用环境变量存储敏感信息。",
        input_field_title: "添加环境变量",
        sample_code: "在自定义JWT声明处理程序中访问环境变量。示例："
    },
    jwt_claims_hint: "将自定义声明限制在50KB以下。默认JWT声明会自动包含在令牌中，无法覆盖。",
    tester: {
        subtitle: "调整模拟令牌和用户数据进行测试。",
        run_button: "运行测试",
        result_title: "测试结果"
    },
    form_error: {
        invalid_json: "JSON格式无效"
    }
};
var $03dd0602c603535c$export$2e2bcd8739ae039 = Object.freeze($03dd0602c603535c$var$jwt_claims);


const $ba82f649c3cb55ee$var$log_details = {
    page_title: "审计日志详情",
    back_to_logs: "返回审计日志",
    back_to: "返回 {{name}}",
    success: "成功",
    failed: "失败",
    event_key: "事件 Key",
    application: "应用",
    ip_address: "IP 地址",
    user: "用户",
    log_id: "日志 ID",
    time: "时间",
    user_agent: "用户代理",
    tab_details: "详情",
    raw_data: "原始数据"
};
var $ba82f649c3cb55ee$export$2e2bcd8739ae039 = Object.freeze($ba82f649c3cb55ee$var$log_details);


const $1fe801bdf61636c3$var$logs = {
    page_title: "审计日志",
    title: "审计日志",
    subtitle: "查看用户行为和事件",
    event: "事件",
    user: "用户",
    application: "应用",
    time: "时间",
    filter_by: "过滤"
};
var $1fe801bdf61636c3$export$2e2bcd8739ae039 = Object.freeze($1fe801bdf61636c3$var$logs);


const $e506dc278a48241e$var$menu = {
    profile: "帐户管理",
    language: "语言",
    appearance: {
        label: "主题",
        light: "浅色模式",
        dark: "深色模式",
        system: "跟随系统"
    },
    sign_out: "退出登录"
};
var $e506dc278a48241e$export$2e2bcd8739ae039 = Object.freeze($e506dc278a48241e$var$menu);


const $36b0a464f3706a06$var$mfa = {
    title: "多因素身份验证",
    description: "添加多因素身份验证以提升您登录体验的安全性。",
    factors: "因素",
    multi_factors: "多因素",
    multi_factors_description: "用户需要验证启用的两步验证中的一个因素。",
    totp: "身份验证器应用 OTP",
    otp_description: "将Google Authenticator等链接，以验证一次性密码。",
    webauthn: "WebAuthn（通行证）",
    webauthn_description: "通过浏览器支持的方法进行验证：生物识别、手机扫描或安全密钥等。",
    webauthn_native_tip: "WebAuthn不支持原生应用。",
    webauthn_domain_tip: "WebAuthn将公钥绑定到特定域。修改服务域将阻止用户通过现有的密码进行身份验证。",
    backup_code: "备份代码",
    backup_code_description: "用户设置任何MFA方法后生成10个一次性备份代码。",
    backup_code_setup_hint: "当用户无法验证上述MFA因素时，请使用备份选项。",
    backup_code_error_hint: "要使用备份代码，您需要至少再添加一种MFA方法以成功验证用户。",
    policy: "策略",
    policy_description: "为登录和注册流程设置MFA策略。",
    two_step_sign_in_policy: "登录时的两步验证策略",
    user_controlled: "用户可以自行启用或禁用MFA",
    user_controlled_tip: "用户可以在首次登录或注册时跳过MFA设置，或在账户设置中启用/禁用MFA。",
    mandatory: "用户始终需要在登录时使用MFA",
    mandatory_tip: "用户必须在首次登录或注册时设置MFA，并在所有未来的登录中使用它。"
};
var $36b0a464f3706a06$export$2e2bcd8739ae039 = Object.freeze($36b0a464f3706a06$var$mfa);


const $84c093d7ef579102$var$organization_details = {
    page_title: "机构详情",
    delete_confirmation: "一旦删除，所有成员将失去他们在这个机构中的成员资格和角色。此操作将无法撤销。",
    organization_id: "机构编号",
    settings_description: "机构代表可以访问您的应用程序的团队、业务客户和合作伙伴公司。",
    name_placeholder: "组织名称，不需要是唯一的。",
    description_placeholder: "机构的描述。",
    member: "成员",
    member_other: "成员",
    add_members_to_organization: "向机构{{name}}添加成员",
    add_members_to_organization_description: "通过姓名、电子邮件、电话或用户ID搜索合适的用户。搜索结果中不显示现有成员。",
    add_with_organization_role: "以机构角色加入",
    user: "用户",
    authorize_to_roles: "授权{{name}}访问以下角色:",
    edit_organization_roles: "编辑机构角色",
    edit_organization_roles_of_user: "编辑{{name}}的机构角色",
    remove_user_from_organization: "从机构中移除用户",
    remove_user_from_organization_description: "一旦移除，用户将失去他们在这个机构中的成员资格和角色。此操作将无法撤销。",
    search_user_placeholder: "按名称、电子邮件、电话或用户ID搜索",
    at_least_one_user: "至少需要一个用户。",
    custom_data: "自定义数据",
    custom_data_tip: "自定义数据是一个 JSON 对象，可用于存储与机构关联的附加数据。",
    invalid_json_object: "无效的 JSON 对象。"
};
var $84c093d7ef579102$export$2e2bcd8739ae039 = Object.freeze($84c093d7ef579102$var$organization_details);


const $c4a89d7d9e2fd3af$var$organization_role_details = {
    page_title: "组织角色详情",
    back_to_org_roles: "返回组织角色",
    org_role: "组织角色",
    delete_confirm: "这样做将从受影响的用户中删除与此角色关联的权限，并删除组织角色、组织成员和组织权限之间的关系。",
    deleted: "组织角色 {{name}} 已成功删除。",
    permissions: {
        tab: "权限",
        name_column: "权限",
        description_column: "描述",
        type_column: "权限类型",
        type: {
            api: "API 权限",
            org: "组织权限"
        },
        assign_permissions: "分配权限",
        remove_permission: "移除权限",
        remove_confirmation: "如果移除此权限，拥有此组织角色的用户将失去此权限授予的访问权限。",
        removed: "权限 {{name}} 已成功从此组织角色中移除",
        assign_description: "为此组织中的角色分配权限。这些权限可以包括组织权限和 API 权限。",
        organization_permissions: "组织权限",
        api_permissions: "API 权限",
        assign_organization_permissions: "分配组织权限",
        assign_api_permissions: "分配API权限"
    },
    general: {
        tab: "常规",
        settings: "设置",
        description: "组织角色是可以分配给用户的权限的分组。权限可以来自预定义的组织权限和API权限。",
        name_field: "名称",
        description_field: "描述",
        description_field_placeholder: "仅具有查看权限的用户"
    }
};
var $c4a89d7d9e2fd3af$export$2e2bcd8739ae039 = Object.freeze($c4a89d7d9e2fd3af$var$organization_role_details);


const $9f60594a57ce854c$var$organization_template = {
    title: "组织模板",
    subtitle: "在多租户 SaaS 应用中，组织模板定义了多个组织的共享访问控制政策（权限和角色）。",
    roles: {
        tab_name: "组织角色",
        search_placeholder: "按角色名称搜索",
        create_title: "创建组织角色",
        role_column: "组织角色",
        permissions_column: "权限",
        placeholder_title: "组织角色",
        placeholder_description: "组织角色是一组可以分配给用户的权限。权限必须来自预定义的组织权限。",
        create_modal: {
            title: "创建组织角色",
            create: "创建角色",
            name_field: "角色名称",
            description_field: "描述",
            created: "成功创建组织角色 {{name}}。"
        }
    },
    permissions: {
        tab_name: "组织权限",
        search_placeholder: "按权限名称搜索",
        create_org_permission: "创建组织权限",
        permission_column: "组织权限",
        description_column: "描述",
        placeholder_title: "组织权限",
        placeholder_description: "组织权限指的是在组织上下文中访问资源的授权。",
        delete_confirm: "如果删除此权限，包括此权限的所有组织角色都将失去此权限，拥有此权限的用户将失去由此权限授予的访问权限。",
        create_title: "创建组织权限",
        edit_title: "编辑组织权限",
        permission_field_name: "权限名称",
        description_field_name: "描述",
        description_field_placeholder: "阅读预约历史",
        create_permission: "创建权限",
        created: "组织权限 {{name}} 已成功创建。"
    }
};
var $9f60594a57ce854c$export$2e2bcd8739ae039 = Object.freeze($9f60594a57ce854c$var$organization_template);


const $ffa7216161ac0802$var$organizations = {
    organization: "组织",
    page_title: "组织",
    title: "组织",
    subtitle: "组织通常在SaaS或类似的多租户应用程序中使用，代表您的客户，这些客户可以是团队、组织或整个公司。组织作为B2B身份验证和授权的基础元素。",
    organization_template: "组织模板",
    organization_id: "组织 ID",
    members: "成员",
    create_organization: "创建组织",
    setup_organization: "设置您的组织",
    organization_list_placeholder_title: "组织",
    organization_list_placeholder_text: "在SaaS或类似的多租户应用程序中，通常作为最佳实践使用组织。它们使您能够开发允许客户创建和管理组织、邀请成员并分配角色的应用程序。",
    organization_name_placeholder: "我的组织",
    organization_description_placeholder: "组织的简要描述",
    organization_permission: "组织权限",
    organization_permission_other: "组织权限",
    create_permission_placeholder: "读取预约历史",
    organization_role: "组织角色",
    organization_role_other: "组织角色",
    organization_role_description: "组织角色是可分配给用户的权限组。这些权限必须来自预定义的组织权限。",
    role: "角色",
    search_placeholder: "按组织名称或ID搜索",
    search_role_placeholder: "输入以搜索和选择角色",
    empty_placeholder: "\uD83E\uDD14 你还没有设置任何{{entity}}。",
    organization_and_member: "组织和成员",
    organization_and_member_description: "组织是一个用户组，可以代表团队、业务客户和合作伙伴公司，每个用户都是“成员”。这些可以是处理您的多租户需求的基本实体。",
    guide: {
        title: "从指南开始",
        subtitle: "使用我们的指南快速开始组织设置",
        introduction: {
            title: "让我们了解Logto中的组织工作原理",
            section_1: {
                title: "组织是一组用户（身份）"
            },
            section_2: {
                title: "组织模板专为多租户应用程序访问控制而设计",
                description: "在多租户SaaS应用程序中，多个组织通常共享相同的访问控制模板，包括权限和角色。在Logto中，我们称之为“组织模板”。",
                permission_description: "组织权限是指在组织上下文中访问资源的授权。",
                role_description_deprecated: "组织角色是可分配给成员的组织权限组。",
                role_description: "组织角色是可以分配给成员的组织权限或API权限的分组。"
            },
            section_3: {
                title: "我可以将API权限分配给组织角色吗？",
                description: "是的，您可以将API权限分配给组织角色。Logto提供灵活性，有效管理您组织的角色，允许您在这些角色中包括组织权限和API权限。"
            },
            section_4: {
                title: "交互插图以查看所有关系",
                description: "让我们举个例子。约翰、莎拉位于不同的组织中，其在不同组织上下文中拥有不同的角色。将鼠标悬停在不同模块上，看看会发生什么。"
            }
        },
        organization_permissions: "组织权限",
        organization_roles: "组织角色",
        admin: "管理员",
        member: "成员",
        guest: "访客",
        role_description: "角色“{{role}}”在不同组织中共享相同的组织模板。",
        john: "约翰",
        john_tip: "约翰隶属于两个组织，以电子邮件“john@email.com”作为唯一标识。他是组织A的管理员，也是组织B的访客。",
        sarah: "莎拉",
        sarah_tip: "莎拉隶属于一个组织，以电子邮件“sarah@email.com”作为唯一标识。她是组织B的管理员。"
    }
};
var $ffa7216161ac0802$export$2e2bcd8739ae039 = Object.freeze($ffa7216161ac0802$var$organizations);


const $4e7b2dff7d121a5f$var$permissions = {
    search_placeholder: "通过 API 或权限名称搜索",
    search_placeholder_without_api: "通过权限名称搜索",
    name_column: "权限",
    description_column: "描述",
    api_column: "API",
    placeholder_title: "权限",
    placeholder_description: "权限是指访问资源的授权（我们称其为 API 资源）。",
    edit: "编辑权限",
    delete: "删除权限",
    remove: "移除权限",
    edit_title: "编辑 API 权限"
};
var $4e7b2dff7d121a5f$export$2e2bcd8739ae039 = Object.freeze($4e7b2dff7d121a5f$var$permissions);


const $9671b7c4954ce98c$var$profile = {
    page_title: "账户管理",
    title: "账户管理",
    description: "在这里，你可以修改账户设置和管理个人信息，以确保账户安全。",
    settings: {
        title: "账户设置",
        profile_information: "个人信息",
        avatar: "头像",
        name: "姓名",
        username: "用户名"
    },
    link_account: {
        title: "关联账户",
        email_sign_in: "邮件登录",
        email: "邮件",
        social_sign_in: "社交账号登录",
        link_email: "绑定邮箱",
        link_email_subtitle: "绑定邮箱以便登录或帮助恢复账户。",
        email_required: "邮箱不能为空",
        invalid_email: "无效的邮箱地址",
        identical_email_address: "输入的邮箱地址与当前邮箱地址相同",
        anonymous: "匿名"
    },
    password: {
        title: "密码与安全",
        password: "密码",
        password_setting: "密码设置",
        new_password: "新密码",
        confirm_password: "确认密码",
        enter_password: "输入当前密码",
        enter_password_subtitle: "为确保账户安全，在修改密码前，请先输入当前密码以通过身份验证。",
        set_password: "设置密码",
        verify_via_password: "通过密码验证",
        show_password: "显示密码",
        required: "密码不能为空",
        do_not_match: "密码不匹配，请重新输入。"
    },
    code: {
        enter_verification_code: "输入验证码",
        enter_verification_code_subtitle: "验证码已发送至 <strong>{{target}}</strong>",
        verify_via_code: "通过邮箱验证码验证",
        resend: "重新发送验证码",
        resend_countdown: "在 {{countdown}} 秒后重新发送"
    },
    delete_account: {
        title: "删除账户",
        label: "删除账户",
        description: "删除账户将会删除所有个人信息、用户数据和配置。此操作无法撤销。",
        button: "删除账户",
        dialog_paragraph_1: "很抱歉听到你想要删除你的帐户。删除你的帐户将永久删除所有数据，包括用户信息、日志和设置，此操作无法撤销。因此，请确保在继续之前备份任何重要数据。",
        dialog_paragraph_2: "要继续删除帐户的删除过程，请通过 <a>mail</a> 向我们的支持团队发送主题为“帐户删除请求”的邮件。我们将协助你并确保所有数据都已从我们的系统中正确删除。",
        dialog_paragraph_3: "感谢你选择 Logto Cloud。如果你有任何进一步的问题或疑虑，请随时与我们联系。"
    },
    set: "设置",
    change: "修改",
    link: "关联",
    unlink: "取消关联",
    not_set: "未设置",
    change_avatar: "修改头像",
    change_name: "修改姓名",
    change_username: "修改用户名",
    set_name: "设置姓名",
    email_changed: "已成功绑定邮箱。",
    password_changed: "已重置密码。",
    updated: "{{target}}更改成功。",
    linked: "{{target}}账号绑定成功。",
    unlinked: "{{target}}账号解绑成功。",
    email_exists_reminder: "该邮箱 {{email}} 已被其他账号绑定，请更换邮箱。",
    unlink_confirm_text: "确定解绑",
    unlink_reminder: "解绑后，用户将无法使用该 <span></span> 账号进行登录。确定要解绑吗？"
};
var $9671b7c4954ce98c$export$2e2bcd8739ae039 = Object.freeze($9671b7c4954ce98c$var$profile);


const $a7b798b7d155638b$var$protected_app = {
    name: "受保护的应用",
    title: "创建受保护的应用：简单快速地添加身份验证",
    description: "受保护的应用安全地维护用户会话并代理您的应用请求。由 Cloudflare Workers 提供支持，全球范围内享受一流性能和 0 毫秒冷启动。 <a>了解更多</a>",
    fast_create: "快速创建",
    modal_title: "创建受保护的应用",
    modal_subtitle: "点击即可启用安全且快速的保护。轻松为现有 Web 应用添加身份验证。",
    form: {
        url_field_label: "您的源 URL",
        url_field_placeholder: "https://domain.com/",
        url_field_description: "提供需要身份验证保护的应用地址。",
        url_field_modification_notice: "对源 URL 的修改可能需要 1-2 分钟在全球网络位置生效。",
        url_field_tooltip: "提供您应用的地址，不包括任何 '/pathname'。创建后，您可以自定义路由身份验证规则。\n\n请注意：源 URL 本身不需要进行验证；保护仅适用于通过指定应用域名访问。",
        domain_field_label: "应用域名",
        domain_field_placeholder: "your-domain",
        domain_field_description: "此 URL 用作原始 URL 的身份验证保护代理。创建后可申请自定义域。",
        domain_field_description_short: "此 URL 用作原始 URL 的身份验证保护代理。",
        domain_field_tooltip: "通过 Logto 保护的应用默认将托管在'your-domain.{{domain}}'. 创建后可申请自定义域。",
        create_application: "创建应用",
        create_protected_app: "快速创建",
        errors: {
            domain_required: "需要您的域名。",
            domain_in_use: "此子域名已被使用。",
            invalid_domain_format: "无效的子域名格式：仅使用小写字母、数字和短横线 '-'。",
            url_required: "需要源 URL。",
            invalid_url: "无效的源 URL 格式：使用 http:// 或 https://。请注意：暂不支持 '/pathname'。",
            localhost: "请首先将本地服务器暴露到互联网上。了解有关<a>本地开发</a>的更多信息。"
        }
    },
    success_message: "\uD83C\uDF89 应用身份验证成功启用！尽情探索您网站的新体验。"
};
var $a7b798b7d155638b$export$2e2bcd8739ae039 = Object.freeze($a7b798b7d155638b$var$protected_app);


const $bc56de7ea04a5450$var$role_details = {
    back_to_roles: "返回角色",
    identifier: "标识符",
    delete_description: "这样做将从受影响的用户中删除与该角色关联的权限，并删除角色、用户和权限之间的映射关系。",
    role_deleted: "{{name}} 已成功删除。",
    general_tab: "常规",
    users_tab: "用户",
    m2m_apps_tab: "机器对机器应用",
    permissions_tab: "权限",
    settings: "设置",
    settings_description: "角色是一组权限，可以分配给用户。它们还提供了一种聚合不同 API 定义的权限的方法，使得添加、删除或调整权限比将其单独分配给用户更有效率。",
    field_name: "名称",
    field_description: "描述",
    field_is_default: "默认角色",
    field_is_default_description: "将此角色设为新用户的默认角色。可以设置多个默认角色。这也会影响通过管理 API 创建的用户的默认角色。",
    type_m2m_role_tag: "机器对机器应用角色",
    type_user_role_tag: "用户角色",
    m2m_role_notification: "将此机器到机器角色分配给机器到机器应用程序，以授予对相关API资源的访问权限。如果尚未创建，请<a>首先创建机器到机器应用程序</a>。",
    permission: {
        assign_button: "分配权限",
        assign_title: "分配权限",
        assign_subtitle: "将权限分配给此角色。角色将获得添加的权限，具有此角色的用户将继承这些权限。",
        assign_form_field: "分配权限",
        added_text_one: "添加了 {{count, number}} 个权限",
        added_text_other: "添加了 {{count, number}} 个权限",
        api_permission_count_one: "{{count, number}} 个权限",
        api_permission_count_other: "{{count, number}} 个权限",
        confirm_assign: "分配权限",
        permission_assigned: "所选的权限已成功分配给此角色",
        deletion_description: "如果删除此权限，则具有此角色的受影响用户将失去此权限授予的访问权限。",
        permission_deleted: "权限 {{name}} 已成功从此角色中删除",
        empty: "无可用权限"
    },
    users: {
        assign_button: "分配用户",
        name_column: "用户",
        app_column: "应用",
        latest_sign_in_column: "最近登录",
        delete_description: "它将保留在你的用户池中，但失去此角色的授权。",
        deleted: "{{name}} 已成功从此角色中删除",
        assign_title: "分配用户",
        assign_subtitle: "将用户分配给此角色。通过搜索名称、电子邮件、电话或用户 ID 查找适当的用户。",
        assign_field: "分配用户",
        confirm_assign: "分配用户",
        assigned_toast_text: "所选的用户已成功分配给此角色",
        empty: "无可用用户"
    },
    applications: {
        assign_button: "分配应用",
        name_column: "应用",
        app_column: "应用",
        description_column: "描述",
        delete_description: "应用将保留在你的应用池中，但将失去此角色的授权。",
        deleted: "{{name}} 已成功从此角色中删除",
        assign_title: "分配应用",
        assign_subtitle: "将应用分配给此角色。通过搜索名称、描述或应用 ID 查找适当的应用。",
        assign_field: "分配应用",
        confirm_assign: "分配应用",
        assigned_toast_text: "所选的应用已成功分配给此角色",
        empty: "无可用应用"
    }
};
var $bc56de7ea04a5450$export$2e2bcd8739ae039 = Object.freeze($bc56de7ea04a5450$var$role_details);


const $20621146ddb22173$var$roles = {
    page_title: "角色",
    title: "角色",
    subtitle: "RBAC 是一种访问控制方法，它使用角色来决定用户可以做什么事情，包括授予用户访问特定资源的权限。",
    create: "创建角色",
    role_name: "角色名称",
    role_type: "角色类型",
    show_role_type_button_text: "展示更多选项",
    hide_role_type_button_text: "隐藏更多选项",
    type_user: "用户角色",
    type_machine_to_machine: "机器对机器应用程序角色",
    role_description: "描述",
    role_name_placeholder: "输入你的角色名称",
    role_description_placeholder: "输入你的角色描述",
    col_roles: "角色",
    col_type: "类型",
    col_description: "描述",
    col_assigned_entities: "已分配",
    user_counts: "{{count}} 用户",
    application_counts: "{{count}} 应用",
    user_count: "{{count}} 用户",
    application_count: "{{count}} 应用",
    assign_permissions: "分配权限",
    create_role_title: "创建角色",
    create_role_description: "为你的应用程序创建和管理角色。角色包含权限集合，并可以分配给用户。",
    create_role_button: "创建角色",
    role_created: "角色 {{name}} 已成功创建。",
    search: "按角色名称、描述或 ID 搜索",
    placeholder_title: "角色",
    placeholder_description: "角色是可以分配给用户的权限分组。在创建角色之前，请确保先添加权限。",
    assign_user_roles: "分配用户角色",
    assign_m2m_roles: "分配机器到机器角色",
    management_api_access_notification: "要访问Logto管理API，请选择具有管理API权限的角色<flag/>。",
    with_management_api_access_tip: "此机器到机器角色包括Logto管理API权限"
};
var $20621146ddb22173$export$2e2bcd8739ae039 = Object.freeze($20621146ddb22173$var$roles);


const $6c3e1727430f481b$var$session_expired = {
    title: "会话已过期",
    subtitle: "会话可能已过期，你已被退出登录。请点击下方按钮重新登录到管理控制台。",
    button: "重新登录"
};
var $6c3e1727430f481b$export$2e2bcd8739ae039 = Object.freeze($6c3e1727430f481b$var$session_expired);


const $dc09ba3a96a258d2$var$content = {
    terms_of_use: {
        title: "TERMS",
        terms_of_use: "Terms of use URL",
        terms_of_use_placeholder: "https://your.terms.of.use/",
        privacy_policy: "Privacy policy URL",
        privacy_policy_placeholder: "https://your.privacy.policy/"
    },
    languages: {
        title: "LANGUAGES",
        enable_auto_detect: "Enable auto-detect",
        description: "Your software detects the user's locale setting and switches to the local language. You can add new languages by translating UI from English to another language.",
        manage_language: "Manage language",
        default_language: "Default language",
        default_language_description_auto: "The default language will be used when the detected user language isn’t covered in the current language library.",
        default_language_description_fixed: "When auto-detect is off, the default language is the only language your software will show. Turn on auto-detect for language extension."
    },
    manage_language: {
        title: "Manage language",
        subtitle: "Localize the product experience by adding languages and translations. Your contribution can be set as the default language.",
        add_language: "Add Language",
        logto_provided: "Logto provided",
        key: "Key",
        logto_source_values: "Logto source values",
        custom_values: "Custom values",
        clear_all_tip: "Clear all values",
        unsaved_description: "Changes won’t be saved if you leave this page without saving.",
        deletion_tip: "Delete the language",
        deletion_title: "Do you want to delete the added language?",
        deletion_description: "After deletion, your users won’t be able to browse in that language again.",
        default_language_deletion_title: "Default language can’t be deleted.",
        default_language_deletion_description: "{{language}} is set as your default language and can’t be deleted. "
    }
};
var $dc09ba3a96a258d2$export$2e2bcd8739ae039 = Object.freeze($dc09ba3a96a258d2$var$content);


const $c850f2c7137af33c$var$password_policy = {
    password_requirements: "密码要求",
    minimum_length: "最小长度",
    minimum_length_description: "NIST 建议在 Web 产品中使用至少 8 个字符。",
    minimum_length_error: "最小长度必须在 {{min}} 和 {{max}} 之间（包括 {{min}} 和 {{max}}）。",
    minimum_required_char_types: "最小要求字符类型",
    minimum_required_char_types_description: "字符类型：大写字母（A-Z），小写字母（a-z），数字（0-9）以及特殊字符（{{symbols}}）。",
    password_rejection: "密码拒绝",
    compromised_passwords: "拒绝已泄露的密码",
    breached_passwords: "泄露的密码",
    breached_passwords_description: "拒绝之前在泄露数据库中发现的密码。",
    restricted_phrases: "限制低安全性短语",
    restricted_phrases_tooltip: "密码应避免使用这些短语，除非结合 3 个或更多额外字符。",
    repetitive_or_sequential_characters: "重复或连续字符",
    repetitive_or_sequential_characters_description: "例如，“AAAA”、“1234”和“abcd”。",
    user_information: "用户信息",
    user_information_description: "例如，电子邮件地址，电话号码，用户名等。",
    custom_words: "自定义词汇",
    custom_words_description: "个性化上下文相关的词汇，不区分大小写，每行一个。",
    custom_words_placeholder: "您的服务名称，公司名称等。"
};
var $c850f2c7137af33c$export$2e2bcd8739ae039 = Object.freeze($c850f2c7137af33c$var$password_policy);


const $ab2baa0a9110e673$var$sign_up_and_sign_in = {
    identifiers_email: "邮件地址",
    identifiers_phone: "手机号码",
    identifiers_username: "用户名",
    identifiers_email_or_sms: "邮件地址或手机号码",
    identifiers_none: "无",
    and: "与",
    or: "或",
    sign_up: {
        title: "注册",
        sign_up_identifier: "注册标识",
        identifier_description: "创建账户时你需要设定注册标识。这些信息在用户登录时，属于必选项。",
        sign_up_authentication: "注册身份认证设置",
        authentication_description: "注册时，你的用户将要完成以下所有勾选的任务。",
        set_a_password_option: "创建密码",
        verify_at_sign_up_option: "注册时验证身份",
        social_only_creation_description: "（仅对社交注册用户适用）"
    },
    sign_in: {
        title: "登录",
        sign_in_identifier_and_auth: "登录标识和身份认证设置",
        description: "用户可以使用任何可用的选项进行登录。拖拽选项即可调整页面布局。",
        add_sign_in_method: "添加登录方式",
        password_auth: "密码",
        verification_code_auth: "验证码",
        auth_swap_tip: "交换以下选项的位置即可设定它们在用户登录流程中出现的先后。",
        require_auth_factor: "请至少选择一种认证方式。"
    },
    social_sign_in: {
        title: "社交登录",
        social_sign_in: "社交登录",
        description: "你已设定特定的标识。用户在通过社交连接器注册时可能会被要求提供一个对应的标识。",
        add_social_connector: "添加社交连接器",
        set_up_hint: {
            not_in_list: "没有你想要的连接器？",
            set_up_more: "立即设置",
            go_to: "其他社交连接器。"
        }
    },
    tip: {
        set_a_password: "启用户名注册，必须设置密码。",
        verify_at_sign_up: "我们目前仅支持经过验证的邮件地址登录。如果没有验证，你的用户信息中可能出现大量无效电子邮件地址。",
        password_auth: "因注册设置里你启用了用户名密码标识。这个信息在用户登录时，属于必选项。",
        verification_code_auth: "因注册设置里你启用了验证码标识，验证码属于用户必选项。开启密码注册后，你可以选择关闭验证码登录。",
        delete_sign_in_method: "因注册设置里你启用了{{identifier}}标识。这些信息在用户登录时，属于必选项。"
    },
    advanced_options: {
        title: "高级选项",
        enable_single_sign_on: "启用企业单点登录（SSO）",
        enable_single_sign_on_description: "启用用户使用他们的企业身份进行单点登录到应用程序。",
        single_sign_on_hint: {
            prefix: "前往",
            link: '"企业SSO"',
            suffix: "部分以设置更多企业连接器。"
        },
        enable_user_registration: "启用用户注册",
        enable_user_registration_description: "启用或禁用用户注册。禁用后，管理员仍然可以添加用户，但用户无法通过登录界面建立账户。"
    }
};
var $ab2baa0a9110e673$export$2e2bcd8739ae039 = Object.freeze($ab2baa0a9110e673$var$sign_up_and_sign_in);


const $cb9906fb836b4c8c$var$sign_in_exp = {
    page_title: "登录体验",
    title: "登录体验",
    description: "自定义登录界面，并实时预览真实效果",
    tabs: {
        branding: "品牌",
        sign_up_and_sign_in: "注册与登录",
        content: "内容",
        password_policy: "密码策略"
    },
    welcome: {
        title: "自定义登录体验",
        description: "通过首次登录设置快速入门。本指南将带领你完成所有必要的设置。",
        get_started: "开始",
        apply_remind: "请注意，登录体验将会应用到当前帐户下的所有应用。"
    },
    color: {
        title: "颜色",
        primary_color: "品牌颜色",
        dark_primary_color: "品牌颜色 (深色)",
        dark_mode: "开启深色模式",
        dark_mode_description: "基于品牌颜色和 Logto 的算法，应用将会有一个自动生成的深色模式。当然，你可以自定义和修改。",
        dark_mode_reset_tip: "基于品牌颜色，重新生成深色模式颜色。",
        reset: "重新生成"
    },
    branding: {
        title: "品牌定制区",
        ui_style: "样式",
        favicon: "浏览器地址栏图标",
        logo_image_url: "Logo 图片 URL",
        logo_image_url_placeholder: "https://your.cdn.domain/logo.png",
        dark_logo_image_url: "Logo 图片 URL (深色)",
        dark_logo_image_url_placeholder: "https://your.cdn.domain/logo-dark.png",
        logo_image: "Logo 图片",
        dark_logo_image: "Logo 图片(深色)",
        logo_image_error: "应用 Logo：{{error}}",
        favicon_error: "Favicon：{{error}}"
    },
    custom_css: {
        title: "自定义 CSS",
        css_code_editor_title: "自定义 CSS 个性化你的用户界面",
        css_code_editor_description1: "查看自定义 CSS 的例子。",
        css_code_editor_description2: "<a>{{link}}</a>",
        css_code_editor_description_link_content: "了解更多",
        css_code_editor_content_placeholder: "输入 CSS 代码，修改颜色、字体、组件样式、布局，定制你的登录、注册、忘记密码等页面。充分发挥创造力，让你的用户界面脱颖而出。"
    },
    sign_up_and_sign_in: $ab2baa0a9110e673$export$2e2bcd8739ae039,
    content: $dc09ba3a96a258d2$export$2e2bcd8739ae039,
    password_policy: $c850f2c7137af33c$export$2e2bcd8739ae039,
    setup_warning: {
        no_connector_sms: "尚未设置 SMS 短信连接器。在完成该配置前，用户将无法通过此登录方式登录。<a>{{link}}</a>连接器。",
        no_connector_email: "尚未设置电子邮件连接器。在完成该配置前，用户将无法通过此登录方式登录。<a>{{link}}</a>连接器。",
        no_connector_social: "您还没有设置任何社交连接器。首先添加连接器以应用社交登录方法。<a>{{link}}</a>连接器。",
        setup_link: "立即设置"
    },
    save_alert: {
        description: "你正在进行登录注册设置的变更。当前你的所有用户会受到新设置的影响。确认保存该设置吗？",
        before: "设置前",
        after: "设置后",
        sign_up: "注册",
        sign_in: "登录",
        social: "社交"
    },
    preview: {
        title: "登录预览",
        live_preview: "实时预览",
        live_preview_tip: "保存以预览更改",
        native: "移动原生",
        desktop_web: "桌面网页",
        mobile_web: "移动网页",
        desktop: "桌面网页",
        mobile: "移动设备"
    }
};
var $cb9906fb836b4c8c$export$2e2bcd8739ae039 = Object.freeze($cb9906fb836b4c8c$var$sign_in_exp);


const $ec6b2ca7fad93561$var$signing_keys = {
    title: "签名密钥",
    description: "安全管理应用程序使用的签名密钥。",
    private_key: "OIDC 私钥",
    private_keys_description: "OIDC 私钥用于签署 JWT 令牌。",
    cookie_key: "OIDC Cookie 密钥",
    cookie_keys_description: "OIDC Cookie 密钥用于签署 Cookie。",
    private_keys_in_use: "正在使用的私钥",
    cookie_keys_in_use: "正在使用的 Cookie 密钥",
    rotate_private_keys: "旋转私钥",
    rotate_cookie_keys: "旋转 Cookie 密钥",
    rotate_private_keys_description: "此操作将创建一个新的私钥，旋转当前密钥，并删除之前的密钥。使用当前密钥签名的JWT令牌将在删除或另一轮旋转之前保持有效。",
    rotate_cookie_keys_description: "此操作将创建一个新的Cookie密钥，旋转当前密钥，并删除之前的密钥。使用当前密钥签名的Cookie将在删除或另一轮旋转之前保持有效。",
    select_private_key_algorithm: "为新的私钥选择签名密钥算法",
    rotate_button: "旋转",
    table_column: {
        id: "ID",
        status: "状态",
        algorithm: "签名密钥算法"
    },
    status: {
        current: "当前",
        previous: "之前"
    },
    reminder: {
        rotate_private_key: "您确定要旋转<strong>OIDC私钥</strong>吗？新发布的JWT令牌将由新密钥签名。使用当前密钥签名的现有JWT令牌将在您再次旋转之前保持有效。",
        rotate_cookie_key: "您确定要旋转<strong>OIDC Cookie密钥</strong>吗？登录会话生成的新Cookie将由新Cookie密钥签名。使用当前密钥签名的现有Cookie将在您再次旋转之前保持有效。",
        delete_private_key: "您确定要删除<strong>OIDC私钥</strong>吗？使用此私有签名密钥签名的现有JWT令牌将不再有效。",
        delete_cookie_key: "您确定要删除<strong>OIDC Cookie密钥</strong>吗？用此Cookie密钥签名的旧登录会话将不再有效。这些用户需要重新验证。"
    },
    messages: {
        rotate_key_success: "签名密钥旋转成功。",
        delete_key_success: "密钥已成功删除。"
    }
};
var $ec6b2ca7fad93561$export$2e2bcd8739ae039 = Object.freeze($ec6b2ca7fad93561$var$signing_keys);


const $ec8a8f909aaf0ba8$var$quota_item = {
    tenant_limit: {
        name: "租户",
        limited: "{{count, number}} 个租户",
        limited_other: "{{count, number}} 个租户",
        unlimited: "无限制租户",
        not_eligible: "移除你的租户"
    },
    mau_limit: {
        name: "月活跃用户",
        limited: "{{count, number}} MAU",
        unlimited: "无限制 MAU",
        not_eligible: "移除你的所有用户"
    },
    token_limit: {
        name: "令牌",
        limited: "{{count, number}} 个令牌",
        limited_other: "{{count, number}} 个令牌",
        unlimited: "无限制令牌",
        not_eligible: "移除你的所有用户以防止生成新令牌"
    },
    applications_limit: {
        name: "应用",
        limited: "{{count, number}} 个应用",
        limited_other: "{{count, number}} 个应用",
        unlimited: "无限制应用",
        not_eligible: "移除你的应用"
    },
    machine_to_machine_limit: {
        name: "机器到机器",
        limited: "{{count, number}} 个机器到机器应用",
        limited_other: "{{count, number}} 个机器到机器应用",
        unlimited: "无限制机器到机器应用",
        not_eligible: "移除你的机器到机器应用"
    },
    third_party_applications_limit: {
        name: "第三方应用",
        limited: "{{count, number}} 第三方应用",
        limited_other: "{{count, number}} 第三方应用",
        unlimited: "无限制第三方应用",
        not_eligible: "移除你的第三方应用"
    },
    resources_limit: {
        name: "API 资源",
        limited: "{{count, number}} 个 API 资源",
        limited_other: "{{count, number}} 个 API 资源",
        unlimited: "无限制 API 资源",
        not_eligible: "移除你的 API 资源"
    },
    scopes_per_resource_limit: {
        name: "资源权限",
        limited: "{{count, number}} 个权限每个资源",
        limited_other: "{{count, number}} 个权限每个资源",
        unlimited: "无限制权限每个资源",
        not_eligible: "移除你的资源权限"
    },
    custom_domain_enabled: {
        name: "自定义域名",
        limited: "自定义域名",
        unlimited: "自定义域名",
        not_eligible: "移除你的自定义域名"
    },
    omni_sign_in_enabled: {
        name: "全渠道登录",
        limited: "全渠道登录",
        unlimited: "全渠道登录",
        not_eligible: "禁用全渠道登录"
    },
    built_in_email_connector_enabled: {
        name: "内置电子邮件连接器",
        limited: "内置电子邮件连接器",
        unlimited: "内置电子邮件连接器",
        not_eligible: "移除你的内置电子邮件连接器"
    },
    social_connectors_limit: {
        name: "社交连接器",
        limited: "{{count, number}} 个社交连接器",
        limited_other: "{{count, number}} 个社交连接器",
        unlimited: "无限制社交连接器",
        not_eligible: "移除你的社交连接器"
    },
    standard_connectors_limit: {
        name: "免费标准连接器",
        limited: "{{count, number}} 个免费标准连接器",
        limited_other: "{{count, number}} 个免费标准连接器",
        unlimited: "无限制标准连接器",
        not_eligible: "移除你的标准连接器"
    },
    roles_limit: {
        name: "角色",
        limited: "{{count, number}} 个角色",
        limited_other: "{{count, number}} 个角色",
        unlimited: "无限制角色",
        not_eligible: "移除你的角色"
    },
    machine_to_machine_roles_limit: {
        name: "机器到机器角色",
        limited: "{{count, number}} 个机器到机器角色",
        limited_other: "{{count, number}} 个机器到机器角色",
        unlimited: "无限制机器到机器角色",
        not_eligible: "移除你的机器到机器角色"
    },
    scopes_per_role_limit: {
        name: "角色权限",
        limited: "{{count, number}} 个权限每个角色",
        limited_other: "{{count, number}} 个权限每个角色",
        unlimited: "无限制权限每个角色",
        not_eligible: "移除你的角色权限"
    },
    hooks_limit: {
        name: "Webhooks",
        limited: "{{count, number}} 个 Webhook",
        limited_other: "{{count, number}} 个 Webhook",
        unlimited: "无限制的 Webhook",
        not_eligible: "移除你的 Webhook"
    },
    organizations_enabled: {
        name: "组织",
        limited: "组织",
        unlimited: "组织",
        not_eligible: "移除你的组织"
    },
    audit_logs_retention_days: {
        name: "审计日志保留",
        limited: "审计日志保留：{{count, number}} 天",
        limited_other: "审计日志保留：{{count, number}} 天",
        unlimited: "无限制天数",
        not_eligible: "无审计日志"
    },
    email_ticket_support: {
        name: "电子邮件支持",
        limited: "{{count, number}} 小时电子邮件支持",
        limited_other: "{{count, number}} 小时电子邮件支持",
        unlimited: "电子邮件支持",
        not_eligible: "无电子邮件支持"
    },
    mfa_enabled: {
        name: "多因素认证",
        limited: "多因素认证",
        unlimited: "多因素认证",
        not_eligible: "移除您的多因素认证"
    },
    sso_enabled: {
        name: "企业SSO",
        limited: "企业SSO",
        unlimited: "企业SSO",
        not_eligible: "移除你的 企业SSO"
    },
    tenant_members_limit: {
        name: "租户成员",
        limited: "{{count, number}} 个租户成员",
        limited_other: "{{count, number}} 个租户成员",
        unlimited: "无限制租户成员",
        not_eligible: "移除你的租户成员"
    },
    custom_jwt_enabled: {
        name: "自定义 JWT",
        limited: "自定义 JWT",
        unlimited: "自定义 JWT",
        not_eligible: "移除你的 JWT 声明自定义器"
    }
};
var $ec8a8f909aaf0ba8$export$2e2bcd8739ae039 = Object.freeze($ec8a8f909aaf0ba8$var$quota_item);


const $2a99cc2bfc4a6ada$var$quota_table = {
    quota: {
        title: "基础",
        base_price: "基础价格",
        mau_limit: "MAU 限制",
        included_tokens: "包含的令牌"
    },
    application: {
        title: "应用",
        total: "总应用数",
        m2m: "机器对机器",
        third_party: "第三方应用"
    },
    resource: {
        title: "API 资源",
        resource_count: "资源数量",
        scopes_per_resource: "每资源权限"
    },
    branding: {
        title: "界面与品牌",
        custom_domain: "自定义域名",
        custom_css: "自定义 CSS",
        app_logo_and_favicon: "应用图标与网站图标",
        dark_mode: "深色模式",
        i18n: "国际化"
    },
    user_authn: {
        title: "用户认证",
        omni_sign_in: "全渠道登录",
        password: "密码",
        passwordless: "免密码登录 - 电子邮件和短信",
        email_connector: "电子邮件连接器",
        sms_connector: "短信连接器",
        social_connectors: "社交连接器",
        standard_connectors: "标准连接器",
        built_in_email_connector: "内置电子邮件连接器",
        mfa: "多因素认证",
        sso: "企业 SSO",
        adaptive_mfa: "自适应MFA"
    },
    user_management: {
        title: "用户管理",
        user_management: "用户管理",
        roles: "角色",
        machine_to_machine_roles: "机器对机器角色",
        scopes_per_role: "每角色权限"
    },
    organizations: {
        title: "组织",
        organizations: "组织",
        organization: "组织",
        organization_count: "组织数量",
        allowed_users_per_org: "每个组织的用户数",
        invitation: "邀请（管理 API）",
        org_roles: "组织角色",
        org_permissions: "组织权限",
        just_in_time_provisioning: "即时配置"
    },
    support: {
        title: "合规与支持",
        community: "社区",
        customer_ticket: "客户支持票据",
        premium: "高级版",
        email_ticket_support: "邮件支持票据",
        soc2_report: "SOC2报告",
        hipaa_or_baa_report: "HIPAA/BAA报告"
    },
    developers_and_platform: {
        title: "开发者与平台",
        hooks: "Webhooks",
        audit_logs_retention: "审计日志保留",
        jwt_claims: "JWT声明",
        tenant_members: "租户成员"
    },
    unlimited: "无限制",
    contact: "联系",
    monthly_price: "${{value, number}} / 月",
    days_one: "{{count, number}} 天",
    days_other: "{{count, number}} 天",
    add_on: "附加功能",
    tier: "层级{{value, number}}：",
    paid_token_limit_tip: "Logto将为超出您配额限制的功能收费。您可以在2024年第二季度左右开始收费之前免费使用它。如果您需要更多的令牌，请与我们联系。默认情况下，我们每月为每百万令牌收费80美元。",
    paid_quota_limit_tip: "Logto将为超出配额限制的功能添加费用。在我们从2024年第二季度开始收费之前，您可以免费使用它。",
    paid_add_on_feature_tip: "这是一个附加功能。在我们从2024年第二季度开始收费之前，您可以免费使用它。",
    million: "{{value, number}} 百万",
    mau_tip: "MAU（月活跃用户）是指在计费周期内与Logto交换过至少一个令牌的独立用户数量。",
    tokens_tip: "Logto 发行的所有类型令牌，包括访问令牌、刷新令牌等。",
    mao_tip: "MAO（月度活跃组织）是指在计费周期内至少有一个MAU（月度活跃用户）的独特组织数量。",
    third_party_tip: "将Logto用作您的OIDC身份提供程序，用于第三方应用的登录和权限授予。",
    included: "已包含{{value, number}}",
    included_mao: "已包含 {{value, number}} MAO",
    extra_quota_price: "然后每月 ${{value, number}} / 每个之后",
    per_month_each: "每月 ${{value, number}} / 每个",
    extra_mao_price: "然后每 MAO ${{value, number}}",
    per_month: "每月 ${{value, number}}",
    per_member: "然后每成员 ${{value, number}}"
};
var $2a99cc2bfc4a6ada$export$2e2bcd8739ae039 = Object.freeze($2a99cc2bfc4a6ada$var$quota_table);


const $44711a1d0b185e33$var$subscription = {
    free_plan: "免费计划",
    free_plan_description: "适用于边项目和初始 Logto 试用，无需信用卡。",
    pro_plan: "专业计划",
    pro_plan_description: "适用于企业付费无忧。",
    enterprise: "企业",
    current_plan: "当前计划",
    current_plan_description: "以下是您当前的计划。您可以轻松查看计划使用情况，检查即将到来的账单，并根据需要对计划进行更改。",
    plan_usage: "计划使用情况",
    plan_cycle: "计划周期：{{period}}，使用情况将于{{renewDate}}续订。",
    next_bill: "您的下一个账单",
    next_bill_hint: "要了解有关计算的更多信息，请参阅此<a>文章</a>。",
    next_bill_tip: "此处显示的价格不包含税款。税款将根据您提供的信息和当地法规要求进行计算，并将显示在您的发票中。",
    manage_payment: "管理付款",
    overfill_quota_warning: "您已达到配额限制。为防止任何问题，请升级计划。",
    upgrade_pro: "升级专业计划",
    update_payment: "更新付款信息",
    payment_error: "检测到付款问题。无法处理前一周期的{{price, number}}美元。更新付款以避免 Logto 服务中断。",
    downgrade: "降级",
    current: "当前",
    upgrade: "升级",
    quota_table: $2a99cc2bfc4a6ada$export$2e2bcd8739ae039,
    billing_history: {
        invoice_column: "发票",
        status_column: "状态",
        amount_column: "金额",
        invoice_created_date_column: "发票创建日期",
        invoice_status: {
            void: "已取消",
            paid: "已支付",
            open: "未完成",
            uncollectible: "逾期未付"
        }
    },
    quota_item: $ec8a8f909aaf0ba8$export$2e2bcd8739ae039,
    downgrade_modal: {
        title: "确认要降级吗？",
        description: "如果您选择切换到 <targetName/>，请注意您将不再可以使用以前在 <currentName/> 中的配额和功能。",
        before: "之前：<name/>",
        after: "之后：<name />",
        downgrade: "降级"
    },
    not_eligible_modal: {
        downgrade_title: "您不符合降级条件",
        downgrade_description: "降级到<name/>前，请确保满足以下条件。",
        downgrade_help_tip: "需要降级帮助？<a>联系我们</a>。",
        upgrade_title: "致尊敬的早期采用者的友善提醒",
        upgrade_description: "您当前的使用量超过了 <name /> 允许的范围。Logto 现已正式发布，包括针对每个计划量身定制的功能。在考虑升级到 <name /> 之前，请确保您满足以下升级条件。",
        upgrade_pro_tip: " 或者考虑升级到专业版计划。",
        upgrade_help_tip: "需要升级帮助？<a>联系我们</a>。",
        a_maximum_of: "最多<item/>"
    },
    upgrade_success: "成功升级到 <name/>",
    downgrade_success: "成功降级到 <name/>",
    subscription_check_timeout: "订阅检查超时，请稍后刷新。",
    no_subscription: "无订阅"
};
var $44711a1d0b185e33$export$2e2bcd8739ae039 = Object.freeze($44711a1d0b185e33$var$subscription);


const $46e80e2d675206c0$var$tab_sections = {
    overview: "概览",
    authentication: "身份验证",
    authorization: "授权",
    users: "用户",
    developer: "开发者",
    tenant: "租户"
};
var $46e80e2d675206c0$export$2e2bcd8739ae039 = Object.freeze($46e80e2d675206c0$var$tab_sections);


const $b1a165fb52f4780d$var$tabs = {
    get_started: "开始上手",
    dashboard: "仪表盘",
    applications: "全部应用",
    api_resources: "API 资源",
    sign_in_experience: "登录体验",
    connectors: "连接器",
    enterprise_sso: "企业SSO",
    webhooks: "Webhooks",
    organizations: "组织",
    users: "用户管理",
    audit_logs: "审计日志",
    roles: "角色",
    docs: "文档",
    tenant_settings: "租户设置",
    mfa: "多因素认证",
    customize_jwt: "自定义 JWT",
    signing_keys: "签名密钥",
    organization_template: "组织模板"
};
var $b1a165fb52f4780d$export$2e2bcd8739ae039 = Object.freeze($b1a165fb52f4780d$var$tabs);


const $2b9059ce958568bf$var$tenant_members = {
    members: "成员",
    invitations: "邀请",
    invite_members: "邀请成员",
    user: "用户",
    roles: "角色",
    admin: "管理员",
    collaborator: "合作者",
    invitation_status: "邀请状态",
    inviter: "邀请者",
    expiration_date: "到期日期",
    invite_modal: {
        title: "邀请加入 Logto Cloud",
        subtitle: "要邀请成员加入组织，他们必须接受邀请。",
        to: "至",
        added_as: "作为角色添加",
        email_input_placeholder: "johndoe@example.com"
    },
    invitation_statuses: {
        pending: "待处理",
        accepted: "已接受",
        expired: "已过期",
        revoked: "已撤销"
    },
    invitation_empty_placeholder: {
        title: "邀请团队成员",
        description: "您的租户当前没有邀请的成员。为了协助您的集成，请考虑添加更多成员或管理员。"
    },
    menu_options: {
        edit: "编辑租户角色",
        delete: "从租户中删除用户",
        resend_invite: "重新发送邀请",
        revoke: "撤销邀请",
        delete_invitation_record: "删除此邀请记录"
    },
    edit_modal: {
        title: "更改{{name}}的角色"
    },
    delete_user_confirm: "您确定要从此租户中删除此用户吗？",
    assign_admin_confirm: "您确定要将所选用户设为管理员吗？授予管理员访问权限将为用户提供以下权限。<ul><li>更改租户计费计划</li><li>添加或删除合作者</li><li>删除租户</li></ul>",
    revoke_invitation_confirm: "您确定要撤销此邀请吗？",
    delete_invitation_confirm: "您确定要删除此邀请记录吗？",
    messages: {
        invitation_sent: "已发送邀请。",
        invitation_revoked: "已撤销邀请。",
        invitation_resend: "已重新发送邀请。",
        invitation_deleted: "已删除邀请记录。"
    },
    errors: {
        email_required: "邀请人员的电子邮件地址是必需的。",
        email_exists: "电子邮件地址已存在。",
        member_exists: "此用户已是此组织的成员。",
        pending_invitation_exists: "存在待处理的邀请。删除相关电子邮件或撤销邀请。",
        invalid_email: "电子邮件地址无效。请确保其格式正确。",
        max_member_limit: "您已达到此租户的最大成员数（{{limit}}）。"
    }
};
var $2b9059ce958568bf$export$2e2bcd8739ae039 = Object.freeze($2b9059ce958568bf$var$tenant_members);


const $8509694ef957dfd1$var$tenants = {
    title: "设置",
    description: "高效管理租户设置并自定义您的域名。",
    tabs: {
        settings: "设置",
        members: "成员",
        domains: "域名管理",
        subscription: "套餐与计费",
        billing_history: "历史账单"
    },
    settings: {
        title: "设置",
        description: "设置租户名称并查看您的数据托管地区和租户类型。",
        tenant_id: "租户 ID",
        tenant_name: "租户名称",
        tenant_region: "数据托管地区",
        tenant_region_tip: "您的租户资源托管在 {{region}}。 <a>了解更多</a>",
        environment_tag_development: "开发",
        environment_tag_production: "产品",
        tenant_type: "租户类型",
        development_description: "仅用于测试，不应在生产环境中使用。不需要订阅。它具有所有专业功能，但有像登录横幅之类的限制。<a>了解更多</a>",
        production_description: "适用于由最终用户使用且可能需要付费订阅的应用程序。<a>了解更多</a>",
        tenant_info_saved: "租户信息成功保存。"
    },
    full_env_tag: {
        development: "开发",
        production: "产品"
    },
    deletion_card: {
        title: "删除",
        tenant_deletion: "删除租户",
        tenant_deletion_description: "删除租户将导致永久删除所有相关的用户数据和配置。请谨慎操作。",
        tenant_deletion_button: "删除租户"
    },
    leave_tenant_card: {
        title: "离开",
        leave_tenant: "离开租户",
        leave_tenant_description: "租户中的任何资源将保留，但您将不再能访问此租户。",
        last_admin_note: "要离开此租户，请确保至少还有一名成员具有管理员角色。"
    },
    create_modal: {
        title: "创建租户",
        tenant_usage_purpose: "您想要使用此租户做什么?",
        development_description: "仅用于测试，不应在生产环境中使用。不需要订阅。",
        development_hint: "它具有所有专业功能，但有像登录横幅之类的限制。",
        production_description: "用于最终用户使用，可能需要付费订阅。",
        available_plan: "可用方案：",
        create_button: "创建租户",
        tenant_name_placeholder: "我的租户"
    },
    dev_tenant_migration: {
        title: "您现在可以通过创建新的“开发租户”免费尝试我们的专业功能！",
        affect_title: "这对您有什么影响?",
        hint_1: "我们正在用两个新的租户类型：<strong>“开发”</strong>和<strong>“产品”</strong>替换旧的<strong>环境标签</strong>。",
        hint_2: "为了确保顺畅过渡和功能不中断，所有早期创建的租户将被提升到<strong>产品</strong>租户类型，同时保留之前的订阅。",
        hint_3: "不用担心，您的所有其他设置将保持不变。",
        about_tenant_type: "关于租户类型"
    },
    delete_modal: {
        title: "删除租户",
        description_line1: '您确定要删除您的租户 "<span>{{name}}</span>" 以及环境后缀标签 "<span>{{tag}}</span>" 吗？此操作无法撤销，将永久删除您的所有数据和租户信息。',
        description_line2: "在删除租户之前，也许我们可以帮助您。<span><a>通过电子邮件与我们联系</a></span>",
        description_line3: '如果您确定要继续，请输入租户名称 "<span>{{name}}</span>" 确认。',
        delete_button: "永久删除",
        cannot_delete_title: "无法删除此租户",
        cannot_delete_description: "抱歉，您现在无法删除此租户。请确保您处于免费计划并已支付所有未结账单。"
    },
    leave_tenant_modal: {
        description: "确定要离开此租户吗?",
        leave_button: "离开"
    },
    tenant_landing_page: {
        title: "您还没有创建租户",
        description: "要开始使用Logto配置项目，请创建一个新的租户。如果您需要注销或删除您的帐户，只需单击右上角的头像按钮。",
        create_tenant_button: "创建租户"
    },
    status: {
        mau_exceeded: "超出 MAU 限制",
        suspended: "已暂停",
        overdue: "逾期"
    },
    tenant_suspended_page: {
        title: "租户已暂停，请联系我们以恢复访问。",
        description_1: "我们非常遗憾地通知您，由于不当使用，包括超出MAU限制、逾期付款或其他未经授权的操作，您的租户帐户已被临时停用。",
        description_2: "如果您需要进一步澄清、有任何疑虑或希望恢复全部功能并解锁您的租户，请立即联系我们。"
    }
};
var $8509694ef957dfd1$export$2e2bcd8739ae039 = Object.freeze($8509694ef957dfd1$var$tenants);


const $0df8245419e23fc9$var$topbar = {
    docs: "文档",
    help: "帮助"
};
var $0df8245419e23fc9$export$2e2bcd8739ae039 = Object.freeze($0df8245419e23fc9$var$topbar);


const $e39d0755e8e59e64$var$featured_plan_content = {
    mau: {
        free_plan: "最多{{count, number}} MAU",
        pro_plan: "无限 MAU"
    },
    m2m: {
        free_plan: "{{count, number}} 机器对机器",
        pro_plan: "额外的机器对机器"
    },
    third_party_apps: "第三方应用的 IdP",
    mfa: "多因素认证",
    sso: "企业单点登录",
    role_and_permissions: {
        free_plan: "{{roleCount, number}} 角色和每个角色 {{permissionCount, number}} 权限",
        pro_plan: "无限角色和每个角色权限"
    },
    organizations: "组织",
    audit_logs: "审计日志保留：{{count, number}} 天"
};
var $e39d0755e8e59e64$export$2e2bcd8739ae039 = Object.freeze($e39d0755e8e59e64$var$featured_plan_content);


const $251e2dda51eac321$var$paywall = {
    applications: "已达到 <planName/> 的{{count, number}}个应用限制。升级计划以满足团队需求。如需帮助，请随时 <a>联系我们</a>。",
    applications_other: "已达到 <planName/> 的{{count, number}}个应用限制。升级计划以满足团队需求。如需帮助，请随时 <a>联系我们</a>。",
    machine_to_machine_feature: "升级至 <strong>Pro</strong> 套餐，解锁额外机器对机器应用，享受所有高级功能。 <a>如果有疑问，请联系我们</a>。",
    machine_to_machine: "已达到 <planName/> 的{{count, number}}个机器对机器应用限制。升级计划以满足团队需求。如需帮助，请随时 <a>联系我们</a>。",
    machine_to_machine_other: "已达到 <planName/> 的{{count, number}}个机器对机器应用限制。升级计划以满足团队需求。如需帮助，请随时 <a>联系我们</a>。",
    resources: "已达到 <planName/> 的{{count, number}}个 API 资源限制。升级计划以满足您团队的需求。 <a>联系我们</a> 寻求帮助。",
    resources_other: "已达到 <planName/> 的{{count, number}}个 API 资源限制。升级计划以满足您团队的需求。 <a>联系我们</a> 寻求帮助。",
    scopes_per_resource: "已达到 <planName/> 的{{count, number}}个 API 资源每个权限限制。立即升级以扩展。如需任何帮助，请 <a>联系我们</a>。",
    scopes_per_resource_other: "已达到 <planName/> 的{{count, number}}个 API 资源每个权限限制。立即升级以扩展。如需任何帮助，请 <a>联系我们</a>。",
    custom_domain: "升级至 <strong>Hobby</strong> 或 <strong>Pro</strong> 套餐，解锁自定义域功能。如有任何需要，请不要犹豫 <a>联系我们</a>。",
    social_connectors: "已达到 <planName/> 的{{count, number}}个社交连接器限制。为满足您团队的需求，请升级计划以获取额外的社交连接器，并可以使用 OIDC、OAuth 2.0 和 SAML 协议创建您自己的连接器。如需任何帮助，请 <a>联系我们</a>。",
    social_connectors_other: "已达到 <planName/> 的{{count, number}}个社交连接器限制。为满足您团队的需求，请升级计划以获取额外的社交连接器，并可以使用 OIDC、OAuth 2.0 和 SAML 协议创建您自己的连接器。如需任何帮助，请 <a>联系我们</a>。",
    standard_connectors_feature: "升级至 <strong>Hobby</strong> 或 <strong>Pro</strong> 套餐，创建自己的连接器，可使用 OIDC、OAuth 2.0 和 SAML 协议，还可以享受无限社交连接器和所有高级功能。需要任何帮助，请随时 <a>联系我们</a>。",
    standard_connectors: "已达到 <planName/> 的{{count, number}}个社交连接器限制。为满足您团队的需求，请升级计划以获取额外的社交连接器，并可以使用 OIDC、OAuth 2.0 和 SAML 协议创建您自己的连接器。如需任何帮助，请 <a>联系我们</a>。",
    standard_connectors_other: "已达到 <planName/> 的{{count, number}}个社交连接器限制。为满足您团队的需求，请升级计划以获取额外的社交连接器，并可以使用 OIDC、OAuth 2.0 和 SAML 协议创建您自己的连接器。如需任何帮助，请 <a>联系我们</a>。",
    standard_connectors_pro: "已达到 <planName/> 的{{count, number}}个标准连接器限制。为满足您团队的需求，请升级至企业版计划以获取额外的社交连接器，并可以使用 OIDC、OAuth 2.0 和 SAML 协议创建您自己的连接器。如需任何帮助，请 <a>联系我们</a>。",
    standard_connectors_pro_other: "已达到 <planName/> 的{{count, number}}个标准连接器限制。为满足您团队的需求，请升级至企业版计划以获取额外的社交连接器，并可以使用 OIDC、OAuth 2.0 和 SAML 协议创建您自己的连接器。如需任何帮助，请 <a>联系我们</a>。",
    roles: "已达到 <planName/> 的{{count, number}}个角色限制。升级计划以添加额外的角色和权限。如需任何帮助，请 <a>联系我们</a>。",
    roles_other: "已达到 <planName/> 的{{count, number}}个角色限制。升级计划以添加额外的角色和权限。如需任何帮助，请 <a>联系我们</a>。",
    machine_to_machine_roles: "{{count, number}} 个机器对机器角色已达到 <planName/> 的限制。升级计划以添加额外的角色和权限。如需任何帮助，请 <a>联系我们</a>。",
    machine_to_machine_roles_other: "{{count, number}} 个机器对机器角色已达到 <planName/> 的限制。升级计划以添加额外的角色和权限。如需任何帮助，请 <a>联系我们</a>。",
    scopes_per_role: "已达到 <planName/> 的{{count, number}}个角色每个权限限制。升级计划以添加额外的角色和权限。如需任何帮助，请 <a>联系我们</a>。",
    scopes_per_role_other: "已达到 <planName/> 的{{count, number}}个角色每个权限限制。升级计划以添加额外的角色和权限。如需任何帮助，请 <a>联系我们</a>。",
    hooks: "已达到 <planName/> 的{{count, number}}个 Webhook 限制。升级计划以创建更多 Webhook。如需任何帮助，请 <a>联系我们</a>。",
    hooks_other: "已达到 <planName/> 的{{count, number}}个 Webhook 限制。升级计划以创建更多 Webhook。如需任何帮助，请 <a>联系我们</a>。",
    mfa: "升级到付费计划以解锁 MFA 进行安全验证。如果需要任何帮助，请随时 <a>联系我们</a>。",
    organizations: "升级到付费计划以解锁组织功能。如有任何需要，请不要犹豫 <a>联系我们</a>。",
    third_party_apps: "通过升级到付费计划，可将 Logto 解锁为第三方应用的 IdP。如需任何帮助，请随时 <a>联系我们</a>。",
    sso_connectors: "通过升级到付费计划，可解锁企业 SSO 功能。如需任何帮助，请随时 <a>联系我们</a>。",
    tenant_members: "通过升级到付费计划，可解锁协作功能。如需任何帮助，请随时 <a>联系我们</a>。",
    tenant_members_dev_plan: "您已达到 {{limit}}-成员限制。释放一个成员或撤销待定邀请以添加新成员。需要更多名额？请随时联系我们。",
    custom_jwt: {
        title: "添加自定义声明",
        description: "升级到付费计划以获取自定义 JWT 功能和高级福利。如有任何问题，请不要犹豫 <a>联系我们</a>。"
    }
};
var $251e2dda51eac321$export$2e2bcd8739ae039 = Object.freeze($251e2dda51eac321$var$paywall);


const $74f822820212344f$var$upsell = {
    upgrade_plan: "升级计划",
    compare_plans: "比较计划",
    view_plans: "查看计划",
    create_tenant: {
        title: "选择您的租户计划",
        description: "Logto 提供创新且经济实惠的定价计划，旨在为不断发展的公司提供竞争优势。 <a>了解更多</a>",
        base_price: "基础价格",
        monthly_price: "每月 {{value, number}}",
        view_all_features: "查看所有功能",
        select_plan: "选择<name/>",
        free_tenants_limit: "最多{{count, number}}个免费租户",
        free_tenants_limit_other: "最多{{count, number}}个免费租户",
        most_popular: "最受欢迎",
        upgrade_success: "成功升级至<name/>"
    },
    mau_exceeded_modal: {
        title: "MAU 超过限制，请升级您的计划。",
        notification: "您当前的 MAU 已超过<planName/>的限制。请立即升级到高级计划，以避免 Logto 服务的暂停。",
        update_plan: "更新计划"
    },
    payment_overdue_modal: {
        title: "账单逾期未付",
        notification: "糟糕！租户<span>{{name}}</span>的账单支付失败。请尽快支付账单，以避免Logto服务中止。",
        unpaid_bills: "未付账单",
        update_payment: "更新支付"
    },
    add_on_quota_item: {
        api_resource: "API 资源",
        machine_to_machine: "机器对机器应用",
        tokens: "{{limit}}M 令牌",
        tenant_member: "租户成员"
    },
    charge_notification_for_quota_limit: "您已超过{{item}}配额限制。Logto将为超出配额限制的使用添加费用。计费将从新的附加定价设计发布当天开始。 <a>了解更多</a>",
    paywall: $251e2dda51eac321$export$2e2bcd8739ae039,
    featured_plan_content: $e39d0755e8e59e64$export$2e2bcd8739ae039
};
var $74f822820212344f$export$2e2bcd8739ae039 = Object.freeze($74f822820212344f$var$upsell);


const $f9f1d578cbcfac20$var$user_details = {
    page_title: "用户详情",
    back_to_users: "返回用户管理",
    created_title: "用户创建成功",
    created_guide: "这是用户登录过程中的信息。",
    created_email: "邮箱地址：",
    created_phone: "手机号码：",
    created_username: "用户名：",
    created_password: "密码：",
    menu_delete: "删除用户",
    delete_description: "本操作将永久删除该用户，且无法撤销。",
    deleted: "用户已成功删除。",
    reset_password: {
        reset_password: "重置密码",
        title: "确定要重置密码？",
        content: "本操作不可撤销，将会重置用户的登录信息。",
        congratulations: "该用户已被重置",
        new_password: "新密码："
    },
    tab_settings: "设置",
    tab_roles: "角色",
    tab_logs: "用户日志",
    tab_organizations: "组织",
    authentication: "认证",
    authentication_description: "每个用户都有一个包含所有用户信息的个人资料。它由基本数据、社交身份和自定义数据组成。",
    user_profile: "用户资料",
    field_email: "邮箱地址",
    field_phone: "手机号码",
    field_username: "用户名",
    field_name: "姓名",
    field_avatar: "头像图片链接",
    field_avatar_placeholder: "https://your.cdn.domain/avatar.png",
    field_custom_data: "自定义数据",
    field_custom_data_tip: "预定义属性之外的用户信息，例如用户偏好的颜色和语言。",
    field_connectors: "社交帐号",
    field_sso_connectors: "企业连接",
    custom_data_invalid: "自定义数据必须是有效的 JSON 对象",
    connectors: {
        connectors: "连接器",
        user_id: "用户ID",
        remove: "删除",
        connected: "该用户已连接多个社交连接。",
        not_connected: "该用户还没有绑定社交帐号",
        deletion_confirmation: "您正在删除现有的<name/>身份。你确定要继续吗？"
    },
    sso_connectors: {
        connectors: "连接器",
        enterprise_id: "企业ID",
        connected: "该用户已连接多个企业身份提供者进行单点登录。",
        not_connected: "该用户尚未与任何企业身份提供者连接进行单点登录。"
    },
    mfa: {
        field_name: "多因素认证",
        field_description: "该用户已启用2步认证因素。",
        name_column: "多因素认证",
        field_description_empty: "此用户尚未启用两步身份验证因素。",
        deletion_confirmation: "您正在删除现有的两步验证中的 <name/>。你确定要继续吗？"
    },
    suspended: "已禁用",
    suspend_user: "禁用用户",
    suspend_user_reminder: "确定要禁用该用户吗？该用户将无法登录到你的应用程序，并且在当前访问令牌过期后，将无法获取新的访问令牌。此外，此用户发出的任何 API 请求都将失败。",
    suspend_action: "禁用",
    user_suspended: "用户已被停用。",
    reactivate_user: "重新启用用户",
    reactivate_user_reminder: "确定要重新启用该用户吗？这样做将允许该用户的任何登录尝试。",
    reactivate_action: "重新启用",
    user_reactivated: "用户已重新启用。",
    roles: {
        name_column: "角色名称",
        description_column: "描述",
        assign_button: "分配角色",
        delete_description: "此操作将从此用户中删除此角色。角色本身仍将存在，但不再与此用户相关联。",
        deleted: "已成功将 {{name}} 从此用户中删除。",
        assign_title: "将角色分配给 {{name}}",
        assign_subtitle: "为 {{name}} 授权一个或多个角色",
        assign_role_field: "分配角色",
        role_search_placeholder: "按角色名称搜索",
        added_text: "添加了 {{value, number}} 个",
        assigned_user_count: "{{value, number}} 个用户",
        confirm_assign: "分配角色",
        role_assigned: "已成功分配角色",
        search: "按角色名称、描述或 ID 搜索",
        empty: "无可用角色"
    },
    warning_no_sign_in_identifier: "用户需要至少拥有一个登录标识（用户名、邮箱、手机号或社交账户）才能登录。确定要继续吗？",
    organization_roles_tooltip: "用户在该组织内分配的角色。"
};
var $f9f1d578cbcfac20$export$2e2bcd8739ae039 = Object.freeze($f9f1d578cbcfac20$var$user_details);


const $21a1446e63fceca0$var$users = {
    page_title: "用户管理",
    title: "用户管理",
    subtitle: "管理你的用户，包括创建新用户，编辑用户资料，查看用户日志，以及重新设置密码和删除用户",
    create: "添加用户",
    create_subtitle: "提供以下至少一项字段才能继续。",
    error_missing_identifier: "你必须提供至少一个注册标识来创建用户。",
    user_name: "用户",
    application_name: "注册应用",
    latest_sign_in: "最后登录",
    create_form_username: "用户名",
    create_form_password: "密码",
    create_form_name: "姓名",
    placeholder_name: "李雷",
    placeholder_email: "lilei@example.com",
    placeholder_username: "user123",
    placeholder_phone: "+86 123 4567 8901",
    unnamed: "未命名",
    search: "按姓名、电子邮件、电话或用户名搜索",
    check_user_detail: "查看用户详情",
    placeholder_title: "用户管理",
    placeholder_description: "每个用户都有一个包含所有用户信息的个人资料。它由基本数据、社交身份和自定义数据组成。"
};
var $21a1446e63fceca0$export$2e2bcd8739ae039 = Object.freeze($21a1446e63fceca0$var$users);


const $591489b3aef62b9b$var$webhook_details = {
    page_title: "Webhook 详情",
    back_to_webhooks: "返回 Webhooks",
    not_in_use: "未使用",
    success_rate: "成功率",
    requests: "24 小时内请求次数：{{value, number}}",
    disable_webhook: "禁用 Webhook",
    disable_reminder: "是否确定重新激活此 Webhook？重新激活后将不会向端点 URL 发送 HTTP 请求。",
    webhook_disabled: "Webhook 已被禁用。",
    webhook_reactivated: "Webhook 已经重新激活。",
    reactivate_webhook: "重新激活 Webhook",
    delete_webhook: "删除 Webhook",
    deletion_reminder: "您正在删除此 Webhook。删除后，将不会向端点 URL 发送 HTTP 请求。",
    deleted: "Webhook 已成功删除。",
    settings_tab: "设置",
    recent_requests_tab: "最近请求（24小时）",
    settings: {
        settings: "设置",
        settings_description: "Webhook 允许您通过向端点 URL 发送 POST 请求，实时接收特定事件的更新。这使您可以根据接收到的新信息立即采取行动。",
        events: "事件",
        events_description: "选择 Logto 将发送 POST 请求的触发事件。",
        name: "名称",
        endpoint_url: "端点 URL",
        signing_key: "签名密钥",
        signing_key_tip: "将由 Logto 提供的密钥作为请求标头添加到您的端点中，以确保 Webhook 负载的真实性。",
        regenerate: "重新生成",
        regenerate_key_title: "重新生成签名密钥",
        regenerate_key_reminder: "是否确定要修改签名密钥？重新生成后将立即生效。请在您的端点中同步修改签名密钥。",
        regenerated: "签名密钥已重新生成。",
        custom_headers: "自定义标头",
        custom_headers_tip: "选择性地，您可以向 Webhook 负载添加自定义标头，以提供事件的其他上下文或元数据。",
        key_duplicated_error: "Key 不能重复。",
        key_missing_error: "必须填写 Key。",
        value_missing_error: "必须填写值。",
        invalid_key_error: " Key 无效",
        invalid_value_error: "值无效",
        test: "测试",
        test_webhook: "测试您的 Webhook",
        test_webhook_description: "配置 Webhook，并使用每个选定事件的负载示例进行测试，以验证正确的接收和处理。",
        send_test_payload: "发送测试负载",
        test_result: {
            endpoint_url: "端点 URL：{{url}}",
            message: "消息：{{message}}",
            response_status: "响应状态：{{status, number}}",
            response_body: "响应主体：{{body}}",
            request_time: "请求时间：{{time}}",
            test_success: "向端点发起的 webhook 测试成功。"
        }
    }
};
var $591489b3aef62b9b$export$2e2bcd8739ae039 = Object.freeze($591489b3aef62b9b$var$webhook_details);


const $1de07c9d3899b3b7$var$webhooks = {
    page_title: "Webhooks",
    title: "Webhooks",
    subtitle: "创建 Webhooks 以轻松接收有关特定事件的实时更新。",
    create: "创建 Webhook",
    schemas: {
        interaction: "用户交互",
        user: "用户",
        organization: "组织",
        role: "角色",
        scope: "权限",
        organization_role: "组织角色",
        organization_scope: "组织权限"
    },
    table: {
        name: "名称",
        events: "事件",
        success_rate: "成功率（24小时）",
        requests: "请求数（24小时）"
    },
    placeholder: {
        title: "Webhook",
        description: "创建一个Webhook以通过POST请求将实时更新发送到您的端点URL。了解并立即采取有关“创建账户”、“登录”和“重置密码”等事件的操作。",
        create_webhook: "创建 Webhook"
    },
    create_form: {
        title: "创建 Webhook",
        subtitle: "添加 Webhook 以将 POST 请求发送到端点 URL，并附带任何用户事件的详细信息。",
        events: "事件",
        events_description: "选择触发事件，Logto 将发送 POST 请求。",
        name: "名称",
        name_placeholder: "输入 Webhook 名称",
        endpoint_url: "端点 URL",
        endpoint_url_placeholder: "https://your.webhook.endpoint.url",
        endpoint_url_tip: "输入您的端点 URL，在事件发生时 Webhook 的数据将被发送到该 URL。",
        create_webhook: "创建 Webhook",
        missing_event_error: "您必须至少选择一个事件。"
    },
    webhook_created: "Webhook {{name}} 已成功创建。"
};
var $1de07c9d3899b3b7$export$2e2bcd8739ae039 = Object.freeze($1de07c9d3899b3b7$var$webhooks);


const $cbf8f5688b0aa88f$var$welcome = {
    title: "欢迎来到管理控制台",
    description: "管理控制台是一个无需代码操作的应用。你可以用它来管理登录体验。让我们首先创建一个帐号。你可以用它以个人或公司的身份管理 Logto。",
    create_account: "创建帐号"
};
var $cbf8f5688b0aa88f$export$2e2bcd8739ae039 = Object.freeze($cbf8f5688b0aa88f$var$welcome);


const $91dc185c162219ba$var$admin_console = {
    title: "管理控制台",
    admin_user: "管理员",
    system_app: "系统应用",
    menu: $e506dc278a48241e$export$2e2bcd8739ae039,
    general: $a45cbefa4e7d488a$export$2e2bcd8739ae039,
    errors: $91d4d70592305c26$export$2e2bcd8739ae039,
    tab_sections: $46e80e2d675206c0$export$2e2bcd8739ae039,
    tabs: $b1a165fb52f4780d$export$2e2bcd8739ae039,
    applications: $2d891c6305341353$export$2e2bcd8739ae039,
    application_details: $dae1a2e86d6c3547$export$2e2bcd8739ae039,
    api_resources: $bb05b9d4a8dab6e9$export$2e2bcd8739ae039,
    api_resource_details: $7f5a8d8e0be6b33a$export$2e2bcd8739ae039,
    connectors: $b47102bc8e498fb4$export$2e2bcd8739ae039,
    connector_details: $c7a793818a97173c$export$2e2bcd8739ae039,
    enterprise_sso: $5611aec88253e630$export$2e2bcd8739ae039,
    enterprise_sso_details: $abf0cde9323debea$export$2e2bcd8739ae039,
    get_started: $632fa2112af850d4$export$2e2bcd8739ae039,
    users: $21a1446e63fceca0$export$2e2bcd8739ae039,
    user_details: $f9f1d578cbcfac20$export$2e2bcd8739ae039,
    contact: $192bc810cf6d0dfd$export$2e2bcd8739ae039,
    sign_in_exp: $cb9906fb836b4c8c$export$2e2bcd8739ae039,
    dashboard: $3b4080e29790582f$export$2e2bcd8739ae039,
    logs: $1fe801bdf61636c3$export$2e2bcd8739ae039,
    log_details: $ba82f649c3cb55ee$export$2e2bcd8739ae039,
    session_expired: $6c3e1727430f481b$export$2e2bcd8739ae039,
    welcome: $cbf8f5688b0aa88f$export$2e2bcd8739ae039,
    roles: $20621146ddb22173$export$2e2bcd8739ae039,
    role_details: $bc56de7ea04a5450$export$2e2bcd8739ae039,
    permissions: $4e7b2dff7d121a5f$export$2e2bcd8739ae039,
    cloud: $85d4b35dc2a9fd35$export$2e2bcd8739ae039,
    profile: $9671b7c4954ce98c$export$2e2bcd8739ae039,
    components: $445cde5ca6ec918f$export$2e2bcd8739ae039,
    webhooks: $1de07c9d3899b3b7$export$2e2bcd8739ae039,
    webhook_details: $591489b3aef62b9b$export$2e2bcd8739ae039,
    domain: $7045a227834c0537$export$2e2bcd8739ae039,
    tenants: $8509694ef957dfd1$export$2e2bcd8739ae039,
    tenant_members: $2b9059ce958568bf$export$2e2bcd8739ae039,
    topbar: $0df8245419e23fc9$export$2e2bcd8739ae039,
    subscription: $44711a1d0b185e33$export$2e2bcd8739ae039,
    upsell: $74f822820212344f$export$2e2bcd8739ae039,
    guide: $0e3e6b2c8d3aa5da$export$2e2bcd8739ae039,
    mfa: $36b0a464f3706a06$export$2e2bcd8739ae039,
    organizations: $ffa7216161ac0802$export$2e2bcd8739ae039,
    organization_details: $84c093d7ef579102$export$2e2bcd8739ae039,
    protected_app: $a7b798b7d155638b$export$2e2bcd8739ae039,
    jwt_claims: $03dd0602c603535c$export$2e2bcd8739ae039,
    invitation: $217560c9df26045c$export$2e2bcd8739ae039,
    signing_keys: $ec6b2ca7fad93561$export$2e2bcd8739ae039,
    organization_template: $9f60594a57ce854c$export$2e2bcd8739ae039,
    organization_role_details: $c4a89d7d9e2fd3af$export$2e2bcd8739ae039
};
var $91dc185c162219ba$export$2e2bcd8739ae039 = Object.freeze($91dc185c162219ba$var$admin_console);


const $cb7a3c91a0cad68f$var$demo_app = {
    title: "你已成功登录实时预览！",
    subtitle: "以下是本次登录的用户信息：",
    username: "用户名：",
    user_id: "用户 ID：",
    sign_out: "退出实时预览",
    continue_explore: "或继续探索",
    customize_sign_in_experience: "自定义登录体验",
    enable_passwordless: "启用无密码登录",
    add_social_connector: "添加社交连接器"
};
var $cb7a3c91a0cad68f$export$2e2bcd8739ae039 = Object.freeze($cb7a3c91a0cad68f$var$demo_app);


const $75c73a02d439c4cc$var$oidc = {
    logout_success: "你已经成功登出。"
};
var $75c73a02d439c4cc$export$2e2bcd8739ae039 = Object.freeze($75c73a02d439c4cc$var$oidc);


const $42f5562da238a342$var$translation = {
    admin_console: $91dc185c162219ba$export$2e2bcd8739ae039,
    demo_app: $cb7a3c91a0cad68f$export$2e2bcd8739ae039,
    oidc: $75c73a02d439c4cc$export$2e2bcd8739ae039
};
var $42f5562da238a342$export$2e2bcd8739ae039 = Object.freeze($42f5562da238a342$var$translation);


const $82da0d93a871d7f2$var$zh_cn = {
    translation: $42f5562da238a342$export$2e2bcd8739ae039,
    errors: $4f237da72834e0e0$export$2e2bcd8739ae039
};
var $82da0d93a871d7f2$export$2e2bcd8739ae039 = Object.freeze($82da0d93a871d7f2$var$zh_cn);


const $758b70d60848a3c1$var$application = {
    invalid_type: "只有機器對機器應用程式才能有相關職能。",
    role_exists: "角色 ID {{roleId}} 已經被添加到此應用程式中。",
    invalid_role_type: "無法將使用者類型的角色分配給機器對機器應用程式。",
    invalid_third_party_application_type: "只有傳統網頁應用程式才能被標記為第三方應用程式。",
    third_party_application_only: "此功能只適用於第三方應用程式。",
    user_consent_scopes_not_found: "無效的使用者同意範圍。",
    consent_management_api_scopes_not_allowed: "管理 API 範圍不被允許。",
    protected_app_metadata_is_required: "保護應用程式元數據是必需的。",
    protected_app_not_configured: "未配置保護應用程式提供商。此功能對開源版本不可用。",
    cloudflare_unknown_error: "請求 Cloudflare API 時發生未知錯誤",
    protected_application_only: "此功能僅適用於保護應用程式。",
    protected_application_misconfigured: "保護應用程式配置錯誤。",
    protected_application_subdomain_exists: "保護應用程式子域名已在使用中。",
    invalid_subdomain: "無效的子域名。",
    custom_domain_not_found: "自訂域名未找到。",
    should_delete_custom_domains_first: "應該先刪除自訂域名。"
};
var $758b70d60848a3c1$export$2e2bcd8739ae039 = Object.freeze($758b70d60848a3c1$var$application);


const $9bff7d1b980f2854$var$auth = {
    authorization_header_missing: "Authorization 請求頭缺失。",
    authorization_token_type_not_supported: "Authorization token 類型不支援",
    unauthorized: "未經授權。請檢查憑證及其範圍。",
    forbidden: "禁止訪問。請檢查用戶 role 與權限。",
    expected_role_not_found: "未找到期望的 role。請檢查用戶 role 與權限。",
    jwt_sub_missing: "JWT 缺失 `sub`",
    require_re_authentication: "需要重新認證以進行受保護操作。"
};
var $9bff7d1b980f2854$export$2e2bcd8739ae039 = Object.freeze($9bff7d1b980f2854$var$auth);


const $0a5462a781c94aef$var$connector = {
    general: "連接器發生錯誤：{{errorDescription}}",
    not_found: "找不到可用的 {{type}} 型別的連接器",
    not_enabled: "連接器尚未啟用",
    invalid_metadata: "連接器 metadata 參數錯誤",
    invalid_config_guard: "連接器配置 guard 錯誤",
    unexpected_type: "連接器型別錯誤",
    invalid_request_parameters: "請求參數錯誤",
    insufficient_request_parameters: "請求參數缺失",
    invalid_config: "連接器配置錯誤",
    invalid_certificate: "連接器的證書無效，請確保證書是以 PEM 編碼。",
    invalid_response: "連接器錯誤響應",
    template_not_found: "無法從連接器配置中找到對應的模板",
    template_not_supported: "連接器不支援此模板類型。",
    rate_limit_exceeded: "觸發速率限制。請稍後再試。",
    not_implemented: "方法 {{method}} 尚未實現",
    social_invalid_access_token: "當前連接器的 access_token 無效",
    invalid_auth_code: "當前連接器的授權碼無效",
    social_invalid_id_token: "當前連接器的 id_token 無效",
    authorization_failed: "用戶授權流程失敗",
    social_auth_code_invalid: "無法獲取 access_token，請檢查授權 code 是否有效",
    more_than_one_sms: "同時存在超過 1 個短信連接器",
    more_than_one_email: "同時存在超過 1 個郵件連接器",
    more_than_one_connector_factory: "找到多個連接器工廠（id 為 {{connectorIds}}），請刪除多餘項目。",
    db_connector_type_mismatch: "資料庫中存在一個型別不匹配的連接。",
    not_found_with_connector_id: "找不到所給 connector id 對應的連接器",
    multiple_instances_not_supported: "你選擇的連接器不支援創建多實例。",
    invalid_type_for_syncing_profile: "只有社交連接器可以開啟用戶檔案同步。",
    can_not_modify_target: "不可修改連接器 target。",
    should_specify_target: "你需要聲明 target 的值。",
    multiple_target_with_same_platform: "同一平台上，多個社交連接器不能重複使用相同的 “Target”。",
    cannot_overwrite_metadata_for_non_standard_connector: "不可覆蓋該連接器的 metadata 參數。"
};
var $0a5462a781c94aef$export$2e2bcd8739ae039 = Object.freeze($0a5462a781c94aef$var$connector);


const $6f77d7f493b0fe7f$var$domain = {
    not_configured: "域名主機供應商未設定。",
    cloudflare_data_missing: "cloudflare_data 缺失，請檢查。",
    cloudflare_unknown_error: "獲取 Cloudflare API 時發生未知錯誤",
    cloudflare_response_error: "從 Cloudflare 獲取到意外的響應",
    limit_to_one_domain: "你只能擁有一個自訂域名。",
    hostname_already_exists: "此域名已存在於我們的伺服器中。",
    cloudflare_not_found: "無法在 Cloudflare 中找到主機名",
    domain_is_not_allowed: "這個域名不被允許。"
};
var $6f77d7f493b0fe7f$export$2e2bcd8739ae039 = Object.freeze($6f77d7f493b0fe7f$var$domain);


const $f6b8e7a83d7a6e8f$var$entity = {
    invalid_input: "無效輸入。值列表不能為空。",
    create_failed: "創建 {{name}} 失敗。",
    db_constraint_violated: "數據庫約束違反。",
    not_exists: "該 {{name}} 不存在。",
    not_exists_with_id: "ID 為 `{{id}}` 的 {{name}} 不存在。",
    not_found: "該資源不存在。",
    relation_foreign_key_not_found: "找不到一個或多個外鍵。請檢查輸入並確保所有參照的實體都存在。",
    unique_integrity_violation: "The entity already exists. Please check the input and try again."
};
var $f6b8e7a83d7a6e8f$export$2e2bcd8739ae039 = Object.freeze($f6b8e7a83d7a6e8f$var$entity);


const $8a35da048b1f9581$var$guard = {
    invalid_input: "請求中 {{type}} 無效",
    invalid_pagination: "分頁參數無效",
    can_not_get_tenant_id: "無法從請求中獲取租戶 ID。",
    file_size_exceeded: "文件大小超過限制。",
    mime_type_not_allowed: "不允許使用此 MIME 類型。"
};
var $8a35da048b1f9581$export$2e2bcd8739ae039 = Object.freeze($8a35da048b1f9581$var$guard);


const $9bf0e6b22656243f$var$hook = {
    missing_events: "你需要至少提供一個事件。",
    send_test_payload_failed: "無法發送測試内容：{{message}}",
    endpoint_responded_with_error: "端點返回了錯誤。"
};
var $9bf0e6b22656243f$export$2e2bcd8739ae039 = Object.freeze($9bf0e6b22656243f$var$hook);


const $6f1a6c0cf98ef894$var$jwt_customizer = {
    general: "自定義 JWT 標記時發生錯誤。請稍後再試。",
    can_not_create_for_admin_tenant: "無法為管理租戶創建 JWT 標記自定義器。"
};
var $6f1a6c0cf98ef894$export$2e2bcd8739ae039 = Object.freeze($6f1a6c0cf98ef894$var$jwt_customizer);


const $0d20df073eaf2736$var$localization = {
    cannot_delete_default_language: "你已設置 {{languageTag}} 為你的預設語言，你無法刪除預設語言。",
    invalid_translation_structure: "無效的資料格式，請檢查你的輸入並重試。"
};
var $0d20df073eaf2736$export$2e2bcd8739ae039 = Object.freeze($0d20df073eaf2736$var$localization);


const $15a18b1610d436b0$var$log = {
    invalid_type: "日誌類型無效。"
};
var $15a18b1610d436b0$export$2e2bcd8739ae039 = Object.freeze($15a18b1610d436b0$var$log);


const $ad102abb04cd6d36$var$oidc = {
    aborted: "用戶終止了交互。",
    invalid_scope: "無效範圍: {{error_description}}.",
    invalid_token: "Token 無效",
    invalid_client_metadata: "無效的客戶端元數據",
    insufficient_scope: "缺少權限範圍 `{{scope}}`。",
    invalid_request: "請求無效",
    invalid_grant: "授權請求無效",
    invalid_redirect_uri: "無效返回鏈接, 該 redirect_uri 未被此應用注冊。",
    access_denied: "拒絶訪問",
    invalid_target: "請求資源無效",
    unsupported_grant_type: "不支持的 grant_type",
    unsupported_response_mode: "不支持的 response_mode",
    unsupported_response_type: "不支持的 response_type",
    provider_error: "OIDC 內部錯誤: {{message}}",
    server_error: "發生了未知的 OIDC 錯誤。請稍後重試。",
    provider_error_fallback: "發生了 OIDC 錯誤: {{code}}.",
    key_required: "至少需要一個金鑰。",
    key_not_found: "未找到 ID 為 {{id}} 的金鑰。"
};
var $ad102abb04cd6d36$export$2e2bcd8739ae039 = Object.freeze($ad102abb04cd6d36$var$oidc);


const $6f07de2c3714a021$var$organization = {
    require_membership: "用戶必須是組織的成員才能繼續。"
};
var $6f07de2c3714a021$export$2e2bcd8739ae039 = Object.freeze($6f07de2c3714a021$var$organization);


const $57fbf36de1da370c$var$password = {
    unsupported_encryption_method: "不支持的加密方法 {{name}}",
    pepper_not_found: "密碼 pepper 未找到。請檢查 core 的環境變量。",
    rejected: "密碼被拒絕。請檢查您的密碼是否符合要求。"
};
var $57fbf36de1da370c$export$2e2bcd8739ae039 = Object.freeze($57fbf36de1da370c$var$password);


const $135f1bf8ddff3e56$var$request = {
    invalid_input: "輸入無效。{{details}}",
    general: "發生請求錯誤。"
};
var $135f1bf8ddff3e56$export$2e2bcd8739ae039 = Object.freeze($135f1bf8ddff3e56$var$request);


const $e3576ab187d1ceae$var$resource = {
    resource_identifier_in_use: "API 識別碼 {{indicator}} 已經被使用",
    cannot_delete_management_api: "無法刪除 Logto 管理 API。",
    cannot_modify_management_api: "無法修改 Logto 管理 API。"
};
var $e3576ab187d1ceae$export$2e2bcd8739ae039 = Object.freeze($e3576ab187d1ceae$var$resource);


const $ba54f78ce796b5d0$var$role = {
    name_in_use: "此角色名稱 {{name}} 已被使用",
    scope_exists: "作用域 ID {{scopeId}} 已添加到此角色",
    management_api_scopes_not_assignable_to_user_role: "無法將管理 API 作用域分配給用戶角色。",
    user_exists: "用戶 ID {{userId}} 已添加到此角色",
    application_exists: "應用程式 ID {{applicationId}} 已添加到此角色",
    default_role_missing: "某些默認角色名稱在數據庫中不存在，請確保先創建角色",
    internal_role_violation: "你可能正在嘗試更新或刪除 Logto 禁止的內部角色。如果你要創建新角色，請嘗試使用不以“#internal:”開頭的名稱。"
};
var $ba54f78ce796b5d0$export$2e2bcd8739ae039 = Object.freeze($ba54f78ce796b5d0$var$role);


const $2ea22098dd64311f$var$scope = {
    name_exists: "此作用域名稱 {{name}} 已被使用",
    name_with_space: "作用域名稱不能包含任何空格。"
};
var $2ea22098dd64311f$export$2e2bcd8739ae039 = Object.freeze($2ea22098dd64311f$var$scope);


const $800ba1a5ca513be6$var$session = {
    not_found: "未找到會話。請返回並重新登錄。",
    invalid_credentials: "賬號或密碼錯誤，請重新輸入。",
    invalid_sign_in_method: "當前登錄方式不可用",
    invalid_connector_id: "找不到 ID 為 {{connectorId}} 的可用連接器。",
    insufficient_info: "登錄信息缺失，請檢查你的輸入。",
    connector_id_mismatch: "傳入的連接器 ID 與 session 中保存的記錄不一致",
    connector_session_not_found: "無法找到連接器登錄信息，請嘗試重新登錄。",
    verification_session_not_found: "驗證失敗，請重新驗證。",
    verification_expired: "當前頁面已超時。為確保你的賬號安全，請重新驗證。",
    verification_blocked_too_many_attempts: "短時間內嘗試次數太多。請過一會再試 {{relativeTime}}。",
    unauthorized: "請先登錄",
    unsupported_prompt_name: "不支持的 prompt name",
    forgot_password_not_enabled: "忘記密碼功能沒有開啟。",
    verification_failed: "驗證失敗，請重新驗證。",
    connector_validation_session_not_found: "找不到連接器用於驗證 token 的信息。",
    identifier_not_found: "找不到用戶標識符。請返回並重新登錄。",
    interaction_not_found: "找不到互動會話。請返回並重新開始會話。",
    not_supported_for_forgot_password: "此操作不支援忘記密碼。",
    mfa: {
        require_mfa_verification: "需要 MFA 驗證才能登錄。",
        mfa_sign_in_only: "MFA 只能用於登錄互動。",
        pending_info_not_found: "未找到等待中的 MFA 資訊，請先啟動 MFA。",
        invalid_totp_code: "無效的 TOTP 驗證碼。",
        webauthn_verification_failed: "WebAuthn 驗證失敗。",
        webauthn_verification_not_found: "未找到 WebAuthn 驗證。",
        bind_mfa_existed: "MFA 已存在。",
        backup_code_can_not_be_alone: "備用碼不能作為唯一 MFA。",
        backup_code_required: "備用碼是必需的。",
        invalid_backup_code: "無效的備用碼。",
        mfa_policy_not_user_controlled: "MFA 政策不受使用者控制。"
    },
    sso_enabled: "該郵箱已開啟單點登錄，請使用 SSO 登錄。"
};
var $800ba1a5ca513be6$export$2e2bcd8739ae039 = Object.freeze($800ba1a5ca513be6$var$session);


const $6650aac0ec0a08fb$var$sign_in_experiences = {
    empty_content_url_of_terms_of_use: "你啟用了「使用條款」，請加入使用條款 URL。",
    empty_social_connectors: "你啟用了社交登錄的方式。請至少選擇一個社交連接器。",
    enabled_connector_not_found: "未找到已啟用的 {{type}} 連接器",
    not_one_and_only_one_primary_sign_in_method: "主要的登錄方式一定要有且只能有一個，請檢查你的輸入。",
    username_requires_password: "必須為用戶名註冊標識符啟用設置密碼。",
    passwordless_requires_verify: "必須為電郵/電話註冊標識符啟用驗證。",
    miss_sign_up_identifier_in_sign_in: "登錄方法一定要包含註冊標識符。",
    password_sign_in_must_be_enabled: "必須在註冊中要求設置密碼時啟用密碼登錄。",
    code_sign_in_must_be_enabled: "必須在註冊中不要求設置密碼時啟用驗證碼登錄。",
    unsupported_default_language: "{{language}} 無法選擇作為默認語言。",
    at_least_one_authentication_factor: "至少要選擇一個登錄要素",
    backup_code_cannot_be_enabled_alone: "Backup code cannot be enabled alone.",
    duplicated_mfa_factors: "Duplicated MFA factors."
};
var $6650aac0ec0a08fb$export$2e2bcd8739ae039 = Object.freeze($6650aac0ec0a08fb$var$sign_in_experiences);


const $8163563b36f2feb3$var$single_sign_on = {
    forbidden_domains: "不允許使用公共電郵域名。",
    duplicated_domains: "存在重複的域名。",
    invalid_domain_format: "無效的域名格式。",
    duplicate_connector_name: "連接器名稱已存在。請選擇不同的名稱。"
};
var $8163563b36f2feb3$export$2e2bcd8739ae039 = Object.freeze($8163563b36f2feb3$var$single_sign_on);


const $37e910854c015f37$var$storage = {
    not_configured: "未配置存儲提供程序。",
    missing_parameter: "存儲提供程序缺少參數 {{parameter}}。",
    upload_error: "無法將文件上載到存儲提供程序。"
};
var $37e910854c015f37$export$2e2bcd8739ae039 = Object.freeze($37e910854c015f37$var$storage);


const $da060f67b61db621$var$subscription = {
    limit_exceeded: "您已達到訂閱計劃的限制。",
    get_plan_failed: "無法取得租戶的訂閱計劃。",
    tenant_suspended: "租戶已被暫停。 請聯繫您的管理員。"
};
var $da060f67b61db621$export$2e2bcd8739ae039 = Object.freeze($da060f67b61db621$var$subscription);


const $25a75cd63c765df5$var$swagger = {
    invalid_zod_type: "無效的 Zod 類型，請檢查路由 guard 配置。",
    not_supported_zod_type_for_params: "請求參數不支援的 Zod 類型，請檢查路由 guard 配置。"
};
var $25a75cd63c765df5$export$2e2bcd8739ae039 = Object.freeze($25a75cd63c765df5$var$swagger);


const $d47c90b1ac800925$var$user = {
    username_already_in_use: "該使用者名稱已被使用。",
    email_already_in_use: "該電子郵件地址已被使用。",
    phone_already_in_use: "該手機號碼已被使用。",
    invalid_email: "電子郵件地址不正確。",
    invalid_phone: "手機號碼不正確。",
    email_not_exist: "電子郵件地址尚未註冊。",
    phone_not_exist: "手機號碼尚未註冊。",
    identity_not_exist: "該社交帳號尚未註冊。",
    identity_already_in_use: "該社交帳號已被註冊。",
    social_account_exists_in_profile: "你已綁定當前社交帳號，無需重複操作。",
    cannot_delete_self: "無法刪除自己的帳戶。",
    sign_up_method_not_enabled: "註冊方式尚未啟用。",
    sign_in_method_not_enabled: "登錄方式尚未啟用。",
    same_password: "為確保帳戶安全，新密碼不能與舊密碼一致。",
    password_required_in_profile: "請設置登錄密碼。",
    new_password_required_in_profile: "請設置新密碼。",
    password_exists_in_profile: "當前使用者已設置密碼，無需重複操作。",
    username_required_in_profile: "請設置使用者名稱。",
    username_exists_in_profile: "當前使用者已設置使用者名稱，無需重複操作。",
    email_required_in_profile: "請綁定電子郵件地址",
    email_exists_in_profile: "當前使用者已綁定電子郵件，無需重複操作。",
    phone_required_in_profile: "請綁定手機號碼。",
    phone_exists_in_profile: "當前使用者已綁定手機號碼，無需重複操作。",
    email_or_phone_required_in_profile: "請綁定電子郵件地址或手機號碼。",
    suspended: "帳戶已被禁用。",
    user_not_exist: "未找到與 {{identifier}} 相關聯的使用者。",
    missing_profile: "請於登錄時提供必要的使用者補充資訊。",
    role_exists: "角色 ID {{roleId}} 已添加到此使用者",
    invalid_role_type: "無法設置機械到機械角色給使用者。",
    missing_mfa: "你需要在登錄前綁定額外的 MFA。",
    totp_already_in_use: "TOTP 已經在使用中。",
    backup_code_already_in_use: "備份代碼已經在使用中。",
    password_algorithm_required: "密碼算法為必填項。",
    password_and_digest: "你不能同時設置明文密碼和密碼摘要。"
};
var $d47c90b1ac800925$export$2e2bcd8739ae039 = Object.freeze($d47c90b1ac800925$var$user);


const $afc67096f753e094$var$verification_code = {
    phone_email_empty: "手機號碼與電子郵件地址均為空",
    not_found: "驗證碼不存在，請先請求發送驗證碼",
    phone_mismatch: "手機號碼不匹配，請嘗試請求新的驗證碼。",
    email_mismatch: "電子郵件地址不匹配，請嘗試請求新的驗證碼。",
    code_mismatch: "驗證碼不正確",
    expired: "驗證碼已過期，請嘗試請求新的驗證碼。",
    exceed_max_try: "超過最大驗證次數，請嘗試請求新的驗證碼。"
};
var $afc67096f753e094$export$2e2bcd8739ae039 = Object.freeze($afc67096f753e094$var$verification_code);


const $196e73e03d8ae230$var$errors = {
    request: $135f1bf8ddff3e56$export$2e2bcd8739ae039,
    auth: $9bff7d1b980f2854$export$2e2bcd8739ae039,
    guard: $8a35da048b1f9581$export$2e2bcd8739ae039,
    oidc: $ad102abb04cd6d36$export$2e2bcd8739ae039,
    user: $d47c90b1ac800925$export$2e2bcd8739ae039,
    password: $57fbf36de1da370c$export$2e2bcd8739ae039,
    session: $800ba1a5ca513be6$export$2e2bcd8739ae039,
    connector: $0a5462a781c94aef$export$2e2bcd8739ae039,
    verification_code: $afc67096f753e094$export$2e2bcd8739ae039,
    sign_in_experiences: $6650aac0ec0a08fb$export$2e2bcd8739ae039,
    jwt_customizer: $6f1a6c0cf98ef894$export$2e2bcd8739ae039,
    localization: $0d20df073eaf2736$export$2e2bcd8739ae039,
    swagger: $25a75cd63c765df5$export$2e2bcd8739ae039,
    entity: $f6b8e7a83d7a6e8f$export$2e2bcd8739ae039,
    log: $15a18b1610d436b0$export$2e2bcd8739ae039,
    role: $ba54f78ce796b5d0$export$2e2bcd8739ae039,
    scope: $2ea22098dd64311f$export$2e2bcd8739ae039,
    storage: $37e910854c015f37$export$2e2bcd8739ae039,
    resource: $e3576ab187d1ceae$export$2e2bcd8739ae039,
    hook: $9bf0e6b22656243f$export$2e2bcd8739ae039,
    domain: $6f77d7f493b0fe7f$export$2e2bcd8739ae039,
    subscription: $da060f67b61db621$export$2e2bcd8739ae039,
    application: $758b70d60848a3c1$export$2e2bcd8739ae039,
    organization: $6f07de2c3714a021$export$2e2bcd8739ae039,
    single_sign_on: $8163563b36f2feb3$export$2e2bcd8739ae039
};
var $196e73e03d8ae230$export$2e2bcd8739ae039 = Object.freeze($196e73e03d8ae230$var$errors);


const $090ca0b8d4490cce$var$api_resource_details = {
    page_title: "API 資源詳情",
    back_to_api_resources: "返回 API 資源",
    general_tab: "常規",
    permissions_tab: "權限",
    settings: "設置",
    settings_description: "API 資源，又稱資源指示器，表示要請求的目標服務或資源，通常是表示資源身份的 URI 格式變數。",
    management_api_settings_description: "Logto 管理 API 是一個全面的 API 集合，使管理員能夠管理各種與身份有關的任務，執行安全策略，並遵守法規和標準。",
    management_api_notice: "此 API 代表 Logto 實體，不能修改或刪除。創建機器對機器應用程式以調用 Logto 管理 API。<a>了解更多</a>",
    token_expiration_time_in_seconds: "Token 過期時間（秒）",
    token_expiration_time_in_seconds_placeholder: "請輸入你的 token 過期時間",
    delete_description: "本操作會永久性地刪除該 API 資源，且不可撤銷。輸入 API 資源名稱 <span>{{name}}</span> 確認。",
    enter_your_api_resource_name: "輸入 API 資源名稱",
    api_resource_deleted: " API 資源 {{name}} 已刪除.",
    permission: {
        create_button: "創建權限",
        create_title: "創建權限",
        create_subtitle: "定義此 API 所需的權限 (scope)。",
        confirm_create: "創建權限",
        edit_title: "編輯 API 權限",
        edit_subtitle: "定義 {{resourceName}} API 需要的權限 (範圍)。",
        name: "權限名稱",
        name_placeholder: "read:resource",
        forbidden_space_in_name: "權限名稱不能包含空格。",
        description: "描述",
        description_placeholder: "能夠讀取資源",
        permission_created: '權限 "{{name}}" 已成功創建',
        delete_description: "如果刪除此權限，擁有該權限的用戶將失去由此權限授予的訪問權限。",
        deleted: '成功刪除權限 "{{name}}"。'
    }
};
var $090ca0b8d4490cce$export$2e2bcd8739ae039 = Object.freeze($090ca0b8d4490cce$var$api_resource_details);


const $be682ae4597e2fa5$var$api_resources = {
    page_title: "API 資源",
    title: "API 資源",
    subtitle: "定義可以從已授權的應用程序中使用的 API",
    create: "創建 API 資源",
    api_name: "API 名稱",
    api_name_placeholder: "輸入 API 名稱",
    api_identifier: "API 描述符",
    api_identifier_placeholder: "https://your-api-identifier/",
    api_identifier_tip: "對於 API 資源的唯一標識符。它必須是一個絕對 URI 並沒有 fragment (#) 組件。等價於 OAuth 2.0 中的 <a>resource parameter</a>。",
    default_api: "預設的 API",
    default_api_label: "一个租户只能设置零或一个默认 API。當指定預設的 API 時，可以在身份驗證請求中省略資源參數，還可以使用該 API 作為預設受眾方進行令牌交換，從而發放 JWT。<a>了解更多</a>",
    api_resource_created: " API 資源 {{name}} 已成功創建。",
    invalid_resource_indicator_format: "API 描述符必須是有效的絕對 URI。"
};
var $be682ae4597e2fa5$export$2e2bcd8739ae039 = Object.freeze($be682ae4597e2fa5$var$api_resources);


const $b98fd4f61936c8fb$var$application_details = {
    page_title: "應用程式詳情",
    back_to_applications: "返回全部應用程式",
    check_guide: "查看指南",
    settings: "設定",
    settings_description: "一個「應用程式」是一個註冊的軟體或服務，可以存取使用者資訊或代表使用者操作。應用程式有助於識別 Logto 的使用者要求的內容，並處理登入和權限。填寫所需的身份驗證欄位。",
    integration: "整合",
    integration_description: "使用 Logto 安全工作者，由 Cloudflare 的邊緣網路提供支持，實現頂級性能和全球 0 毫秒冷啟動。",
    service_configuration: "服務配置",
    service_configuration_description: "在您的服務中完成必要的配置。",
    session: "會話",
    endpoints_and_credentials: "端點與憑證",
    endpoints_and_credentials_description: "使用以下端點和憑證在您的應用程式中設置 OIDC 連接。",
    refresh_token_settings: "刷新令牌",
    refresh_token_settings_description: "管理此應用程式的刷新令牌規則。",
    application_roles: "角色",
    machine_logs: "機器日誌",
    application_name: "應用程式名稱",
    application_name_placeholder: "我的應用程式",
    description: "描述",
    description_placeholder: "請輸入應用程式描述",
    config_endpoint: "OpenID Provider 配置端點",
    authorization_endpoint: "授權端點",
    authorization_endpoint_tip: "進行驗證和授權的端點。用於 OpenID Connect 中的 <a>驗證</a> 流程。",
    show_endpoint_details: "顯示端點詳情",
    hide_endpoint_details: "隱藏端點詳情",
    logto_endpoint: "Logto 端點",
    application_id: "應用程式 ID",
    application_id_tip: "應用程式的唯一標識，通常由 Logto 生成。等同於 OpenID Connect 中的 <a>client_id</a>。",
    application_secret: "應用程式密鑰",
    redirect_uri: "重定向 URI",
    redirect_uris: "重定向 URI",
    redirect_uri_placeholder: "https://your.website.com/app",
    redirect_uri_placeholder_native: "io.logto://callback",
    redirect_uri_tip: "在使用者登入完成（不論成功與否）後重定向的目標 URI。參見 OpenID Connect <a>AuthRequest</a> 以瞭解更多。",
    post_sign_out_redirect_uri: "登出後重定向 URI",
    post_sign_out_redirect_uris: "登出後重定向 URI",
    post_sign_out_redirect_uri_placeholder: "https://your.website.com/home",
    post_sign_out_redirect_uri_tip: "在使用者登出後重定向的目標 URI（可選）。在某些應用程式類型中可能無實質作用。",
    cors_allowed_origins: "CORS 允許的來源",
    cors_allowed_origins_placeholder: "https://your.website.com",
    cors_allowed_origins_tip: "所有重定向 URI 的來源將預設被允許。通常不需要對此欄位進行操作。參見 <a>MDN 文檔</a> 以瞭解更多。",
    token_endpoint: "令牌端點",
    user_info_endpoint: "用戶信息端點",
    enable_admin_access: "啟用管理訪問",
    enable_admin_access_label: "啟用或禁用對管理 API 的訪問。啟用後，你可以使用訪問權杖代表該應用程式調用管理 API。",
    always_issue_refresh_token: "始終發行刷新令牌",
    always_issue_refresh_token_label: "啟用此配置將允許 Logto 發行刷新令牌，無論是否在驗證請求中提供 `prompt=consent`。但是，除非必要，否則不建議這樣做，因為它不兼容 OpenID Connect，可能會引起問題。",
    refresh_token_ttl: "刷新令牌的有效期（天）",
    refresh_token_ttl_tip: "刷新令牌可用於在其過期之前請求新的訪問權杖的持續時間。訪問令牌將將默認的 TTL 延長到此值。",
    rotate_refresh_token: "旋轉刷新令牌",
    rotate_refresh_token_label: "啟用後，當原始 TTL 達到 70% 或滿足某些條件時就可以在令牌請求中為刷新令牌發行新的刷新令牌。 <a>了解更多。</a>",
    delete_description: "本操作會永久性地刪除該應用，且不可撤銷。輸入 <span>{{name}}</span> 確認。",
    enter_your_application_name: "輸入你的應用程式名稱",
    application_deleted: "應用 {{name}} 成功刪除。",
    redirect_uri_required: "至少需要輸入一個重定向 URL。",
    app_domain_description_1: "隨時使用由 Logto 提供支持的 {{domain}} 網域，它是永久有效的。",
    app_domain_description_2: "隨時使用您的網域 <domain>{{domain}}</domain>，它是永久有效的。",
    custom_rules: "自定義驗證規則",
    custom_rules_placeholder: "^/(admin|privacy)/.+$",
    custom_rules_description: "使用正則表達式設置需要驗證的路由規則。默認情況下：如果留空，將保護整個網站。",
    authentication_routes: "驗證路由",
    custom_rules_tip: "以下是兩個案例：<ol><li>只保護需要驗證的路由 '/admin' 和 '/privacy'：^/(admin|privacy)/.*</li><li>排除 JPG 圖片不需要驗證：^(?!.*\\.jpg$).*$</li></ol>",
    authentication_routes_description: "使用指定的路由重定向您的驗證按鈕。注意：這些路由是不可替代的。",
    protect_origin_server: "保護您的源伺服器",
    protect_origin_server_description: "確保保護您的源伺服器免受直接訪問。有關更多 <a>詳細指示</a>，請參見指南。",
    session_duration: "會話持續時間（天）",
    try_it: "試試看",
    branding: {
        name: "品牌推廣",
        description: "在同意屏幕上自訂您應用程式的顯示名稱和標誌。",
        more_info: "更多資訊",
        more_info_description: "在同意屏幕上提供有關您應用程式的更多詳細資訊。",
        display_name: "顯示名稱",
        display_logo: "顯示標誌",
        display_logo_dark: "顯示標誌（深色）",
        terms_of_use_url: "應用程式使用條款網址",
        privacy_policy_url: "應用程式隱私政策網址"
    },
    permissions: {
        name: "權限",
        description: "選擇第三方應用程式所需的權限，用於授權訪問特定數據類型的使用者。",
        user_permissions: "個人用戶數據",
        organization_permissions: "組織訪問",
        table_name: "授予權限",
        field_name: "權限",
        field_description: "在同意屏幕中顯示",
        delete_text: "刪除權限",
        permission_delete_confirm: "此操作將撤銷對第三方應用程式所授予的權限，防止其為特定數據類型請求用戶授權。是否確定要繼續？",
        permissions_assignment_description: "選擇第三方應用程式請求授權訪問特定數據類型所需的權限。",
        user_profile: "用戶數據",
        api_permissions: "API 權限",
        organization: "組織權限",
        user_permissions_assignment_form_title: "添加用戶配置權限",
        organization_permissions_assignment_form_title: "添加組織權限",
        api_resource_permissions_assignment_form_title: "添加 API 資源權限",
        user_data_permission_description_tips: '您可以通過 "登入體驗 > 內容 > 管理語言" 修改個人用戶數據權限的描述',
        permission_description_tips: "當 Logto 用作第三方應用程式的身份提供者（IdP）用於授權時，以及用戶被要求授權時，此描述將在同意屏幕上顯示。",
        user_title: "用戶",
        user_description: "選擇第三方應用程式為存取特定用戶數據所需的權限。",
        grant_user_level_permissions: "授予用戶數據的權限",
        organization_title: "組織",
        organization_description: "選擇第三方應用程式為存取特定組織數據所需的權限。",
        grant_organization_level_permissions: "授予組織數據的權限"
    },
    roles: {
        name_column: "角色",
        description_column: "描述",
        assign_button: "指派角色",
        delete_description: "該操作將從此機器對機器應用程式中刪除該角色。該角色本身仍然存在，但不再與此機器對機器應用程式相關聯。",
        deleted: "{{name}} 已成功從此使用者中刪除。",
        assign_title: "為 {{name}} 指派角色",
        assign_subtitle: "授權 {{name}} 至少一個角色",
        assign_role_field: "指派角色",
        role_search_placeholder: "按角色名稱搜索",
        added_text: "{{value, number}} 已添加",
        assigned_app_count: "{{value, number}} 個應用程式",
        confirm_assign: "指派角色",
        role_assigned: "成功指派角色",
        search: "按角色名稱、描述或 ID 搜索",
        empty: "無可用角色"
    }
};
var $b98fd4f61936c8fb$export$2e2bcd8739ae039 = Object.freeze($b98fd4f61936c8fb$var$application_details);


const $da9aa0c64e2a327b$var$applications = {
    page_title: "全部應用",
    title: "全部應用",
    subtitle: "創建一個移動、單頁、machine-to-machine 或傳統 web 應用程序，並通過 Logto 進行身份驗證",
    subtitle_with_app_type: "為你的 {{name}} 應用程序設置 Logto 身份驗證",
    create: "創建應用",
    create_subtitle_third_party: "使用 Logto 作為您的身份提供者（IdP）輕鬆與第三方應用程序集成",
    application_name: "應用名稱",
    application_name_placeholder: "我的應用",
    application_description: "應用描述",
    application_description_placeholder: "請輸入應用描述",
    select_application_type: "選擇應用類型",
    no_application_type_selected: "你還沒有選擇應用類型",
    application_created: "應用創建成功。",
    tab: {
        my_applications: "我的應用",
        third_party_applications: "第三方應用程式"
    },
    app_id: "應用程式 ID",
    type: {
        native: {
            title: "原生應用",
            subtitle: "在原生環境中運行的應用程序",
            description: "例如 iOS app，Android app"
        },
        spa: {
            title: "單頁應用",
            subtitle: "在瀏覽器中運行並動態更新數據的應用程序",
            description: "例如 React DOM app，Vue app"
        },
        traditional: {
            title: "傳統網頁應用",
            subtitle: "僅由 Web 服務器渲染和更新的應用程序",
            description: "例如 Next.js, PHP"
        },
        machine_to_machine: {
            title: "Machine-to-Machine",
            subtitle: "直接與資源對話的應用程序（通常是服務）",
            description: "例如，後端服務"
        },
        protected: {
            title: "受保護應用程序",
            subtitle: "透過 Logto 保護的應用程序",
            description: "N/A"
        },
        third_party: {
            title: "第三方應用程序",
            subtitle: "作為第三方 IdP 連接器使用的應用程序",
            description: "例如 OIDC，SAML"
        }
    },
    placeholder_title: "選擇應用程式類型以繼續",
    placeholder_description: "Logto 使用 OIDC 的應用程式實體來幫助識別您的應用程式、管理登錄和創建審核日誌等任務。",
    m2m_role_assignment: {
        title: "使用機器到機器角色為應用程式授權權限",
        subtitle: "機器對機器應用程式需要經過授權的機器對機器角色。",
        role_creation_hint: "找不到合適的機器對機器角色？<a>創建一個機器對機器角色</a>"
    }
};
var $da9aa0c64e2a327b$export$2e2bcd8739ae039 = Object.freeze($da9aa0c64e2a327b$var$applications);


const $d2bfd3397c147b9c$var$cloud = {
    general: {
        onboarding: "入門"
    },
    welcome: {
        page_title: "歡迎",
        title: "歡迎來到 Logto Cloud！我們很想了解你的一些信息。",
        description: "通過更好地了解你，我們可以使你的 Logto 體驗更加個性化。你的信息是安全的。",
        project_field: "我使用 Logto 是為了",
        project_options: {
            personal: "個人專案",
            company: "公司專案"
        },
        company_name_field: "公司名稱",
        company_name_placeholder: "Acme.co",
        stage_field: "你的產品目前處於哪個階段？",
        stage_options: {
            new_product: "啟動新項目並尋找快速、開箱即用的解決方案",
            existing_product: "從當前身份驗證 (例如自建、Auth0、Cognito、Microsoft) 遷移",
            target_enterprise_ready: "我剛剛贏得了更大的客戶，現在要讓我的產品準備面向企業銷售"
        },
        additional_features_field: "你還有其他事情要告訴我們嗎？",
        additional_features_options: {
            customize_ui_and_flow: "構建並管理自己的 UI，而不僅僅使用 Logto 預先構建和可定製的解決方案",
            compliance: "SOC2 和 GDPR 是必不可少的",
            export_user_data: "需要從 Logto 導出用戶數據的能力",
            budget_control: "我有非常嚴格的預算控制",
            bring_own_auth: "有自己的身份驗證服務，只需要一些 Logto 功能",
            others: "以上都不是"
        }
    },
    sie: {
        page_title: "定制登錄體驗",
        title: "讓我們輕鬆定制你的登錄體驗",
        inspire: {
            title: "創建引人入勝的示例",
            description: "對登錄體驗不確定嗎？只需點擊“啟發我”，讓魔法發生！",
            inspire_me: "來點靈感"
        },
        logo_field: "應用商標",
        color_field: "品牌顏色",
        identifier_field: "標識符",
        identifier_options: {
            email: "電子郵件",
            phone: "電話",
            user_name: "用戶名"
        },
        authn_field: "身份驗證",
        authn_options: {
            password: "密碼",
            verification_code: "驗證碼"
        },
        social_field: "社交登錄",
        finish_and_done: "完成並完成",
        preview: {
            mobile_tab: "移動端",
            web_tab: "網頁端"
        },
        connectors: {
            unlocked_later: "稍後解鎖",
            unlocked_later_tip: "完成入門流程並進入產品後，你將獲得訪問更多社交登錄方式的權限。",
            notice: "請勿將演示連接器用於生產目的。完成測試後，請刪除演示連接器並使用你的憑證設置自己的連接器。"
        }
    },
    socialCallback: {
        title: "你已成功登錄",
        description: "你已成功使用社交帳戶登錄。為確保與 Logto 的無縫集成並獲得所有功能的訪問權限，我們建議你繼續配置自己的社交連接器。"
    },
    tenant: {
        create_tenant: "創建租戶"
    }
};
var $d2bfd3397c147b9c$export$2e2bcd8739ae039 = Object.freeze($d2bfd3397c147b9c$var$cloud);


const $127555e2e87bf8c3$var$components = {
    uploader: {
        action_description: "拖放或瀏覽上傳",
        uploading: "上傳中...",
        image_limit: "上傳圖片大小不能超過 {{size, number}}KB，只支援 {{extensions, list(style: narrow; type: conjunction;)}} 格式的檔案。",
        error_upload: "哎呀，出了些問題。檔案上傳失敗。",
        error_file_size: "檔案太大了，請上傳小於 {{size, number}}KB 的檔案。",
        error_file_type: "不支援該檔案格式，只支援 {{extensions, list(style: narrow; type: conjunction;)}} 格式的檔案。",
        error_file_count: "你只能上載一個檔案。"
    }
};
var $127555e2e87bf8c3$export$2e2bcd8739ae039 = Object.freeze($127555e2e87bf8c3$var$components);


const $cdd326ba357e40f2$var$connector_details = {
    page_title: "連接器詳情",
    back_to_connectors: "返回連接器",
    check_readme: "查看 README",
    settings: "通用設置",
    settings_description: "連接器在 Logto 中扮演著至關重要的角色。借助它們的幫助，Logto 使終端用戶能夠使用無密碼註冊或登錄的功能以及使用社交帳戶登錄的功能。",
    parameter_configuration: "參數配置",
    test_connection: "測試",
    save_error_empty_config: "請輸入配置內容",
    send: "發送",
    send_error_invalid_format: "無效輸入",
    edit_config_label: "請在此輸入你的 JSON 配置",
    test_email_sender: "測試你的郵件連接器",
    test_sms_sender: "測試你的短信連接器",
    test_email_placeholder: "john.doe@example.com",
    test_sms_placeholder: "+86 131 1234 5678",
    test_message_sent: "測試信息已發送",
    test_sender_description: 'Logto 使用 "Generic" 模板進行測試。如果你的連接器正確配置，你將收到一條消息。',
    options_change_email: "更換郵件連接器",
    options_change_sms: "更換短信連接器",
    connector_deleted: "成功刪除連接器",
    type_email: "郵件連接器",
    type_sms: "短信連接器",
    type_social: "社交連接器",
    in_used_social_deletion_description: "你的登錄體驗正在使用這個連接器。刪除後，<name/> 登錄體驗將在登錄體驗設置中被刪除，再次添加需重新配置。",
    in_used_passwordless_deletion_description: "你的登錄體驗正在使用 {{name}} 連接器。刪除後，你的登錄體驗將無法正常工作，直到你解決衝突，再次添加需重新配置。",
    deletion_description: "你將刪除此連接器。此操作不可撤銷，再次添加需重新配置。",
    logto_email: {
        total_email_sent: "總發送郵件數：{{value, number}}",
        total_email_sent_tip: "Logto 使用 SendGrid 進行安全穩定的內建電子郵件。完全免費使用。<a>了解更多</a>",
        email_template_title: "郵件模板",
        template_description: "內建郵件使用默認模板實現無縫交付驗證郵件。無需配置，您可以自定義基本品牌信息。",
        template_description_link_text: "查看模板",
        description_action_text: "查看模板",
        from_email_field: "發件人郵箱",
        sender_name_field: "發件人姓名",
        sender_name_tip: "自定義郵件發件人姓名。如果未填寫，將使用「Verification」作為默認姓名。",
        sender_name_placeholder: "您的發送人姓名",
        company_information_field: "公司信息",
        company_information_description: "在郵件底部顯示您的公司名稱、地址或郵政編碼，以增強真實性。",
        company_information_placeholder: "您公司的基本信息",
        app_logo_field: "應用程序標誌",
        app_logo_tip: "在郵件頂部顯示您的品牌標誌。在淺色模式和深色模式下使用相同的圖像。",
        urls_not_allowed: "不允許使用 URL",
        test_notes: 'Logto 使用 "通用" 模板進行測試。'
    }
};
var $cdd326ba357e40f2$export$2e2bcd8739ae039 = Object.freeze($cdd326ba357e40f2$var$connector_details);


const $f4535a3f3b4caee5$var$connectors = {
    page_title: "連接器",
    title: "連接器",
    subtitle: "設置連接器，啟動無密碼和社交登錄",
    create: "添加社交連接器",
    config_sie_notice: "你已經配置了社交連接器，記得在<a>{{link}}</a>上添加使之生效。",
    config_sie_link_text: "登錄體驗",
    tab_email_sms: "短信和郵件連接器",
    tab_social: "社交連接器",
    connector_name: "連接器名稱",
    demo_tip: "演示連接器僅用於演示且最多只能發送 100 條消息，不建議在生產環境中部署。",
    social_demo_tip: "演示連接器僅用於演示目的，不建議在生產璃廠中部署。",
    connector_type: "類型",
    connector_status: "登錄體驗",
    connector_status_in_use: "使用中",
    connector_status_not_in_use: "未使用",
    not_in_use_tip: {
        content: "未使用意味著你的登錄體驗並沒有使用這個登錄方式。<a>{{link}}</a>去添加。",
        go_to_sie: "前往登錄體驗"
    },
    placeholder_title: "社交連接器",
    placeholder_description: "Logto 提供了許多廣泛使用的社交登錄連接器，同時你還可以使用標準協議創建自己的連接器。",
    save_and_done: "保存並完成",
    type: {
        email: "郵件連接器",
        sms: "短信連接器",
        social: "社交連接器"
    },
    setup_title: {
        email: "設置郵件連接器",
        sms: "設置短信連接器",
        social: "添加社交連接器"
    },
    guide: {
        subtitle: "參考以下步驟完成你的連接器設置",
        general_setting: "通用設置",
        parameter_configuration: "參數配置",
        test_connection: "連接測試",
        name: "社交登錄按鈕的名稱",
        name_placeholder: "輸入社交登錄按鈕的名稱",
        name_tip: "按鈕上將展示「通過 {{name}} 繼續」。名字不宜過長而導致信息無法展示完整。",
        logo: "社交登錄按鈕的 Logo 圖片鏈接",
        logo_placeholder: "https://your.cdn.domain/logo.png",
        logo_tip: "該圖片將用於連接器的展示。獲取圖片鏈接後粘貼在此處。",
        logo_dark: "社交登錄按鈕的 Logo 圖片鏈接（深色模式）",
        logo_dark_placeholder: "https://your.cdn.domain/logo.png",
        logo_dark_tip: "在管理控制臺的登錄體驗中啟用“深色模式”後，可設置此連接器 Logo 用於深色模式。",
        logo_dark_collapse: "收起",
        logo_dark_show: "展開深色模式 Logo 設置",
        target: "身份提供商名稱",
        target_placeholder: "輸入身份提供商的名稱",
        target_tip: "在“身份供應商名稱”字段中輸入唯一的標識符字符串，用於區分社交身份來源。",
        target_tip_standard: "在“身份供應商名稱”字段中輸入唯一的標識符字符串，用於區分社交身份來源。注意，在連接器創建成功後，無法再次修改此設置。",
        target_tooltip: "Logto 社交連接器的「target」指的是社交身份的「來源」。在 Logto 的設計裡，我們不允許某一平臺的連接器中有相同的「target」以避免身份的衝突。在添加連接器時，你需要格外小心，我們「不允許」用戶在創建之後更改「target」的值。<a>了解更多</a>",
        target_conflict: "此「身份供應商名稱」值與現有的 <span>name</span> 連接器相同。使用相同的身份提供商名稱會導致不符合預期的登錄行為，用戶可能通過兩個不同的連接器訪問同一個帳戶。",
        target_conflict_line2: "如果你想替換當前的連接器，並連接相同的身份提供商（IdP），以便先前的用戶可以直接登錄而無需重新註冊，請先刪除 <span>name</span> 連接器，再創建一個新的連接器並使用相同的「身份供應商名稱」值。",
        target_conflict_line3: "如果你想連接一個新的身份驗證提供程序，請修改「身份供應商名稱」並繼續。",
        config: "粘貼你的 JSON 代碼",
        sync_profile: "開啟用戶資料同步",
        sync_profile_only_at_sign_up: "首次註冊時同步",
        sync_profile_each_sign_in: "每次登錄時同步",
        sync_profile_tip: "同步用戶的用戶名、頭像等個人資料信息",
        callback_uri: "Callback URI",
        callback_uri_description: "也稱為重定向 URI，在社交授權後，用戶將被發送回 Logto 的 URI，復制並粘貼到社交提供者的配置頁面中。",
        acs_url: "Assertion consumer service URL"
    },
    platform: {
        universal: "通用",
        web: "網頁",
        native: "原生"
    },
    add_multi_platform: "支持多平臺，選擇一個平臺繼續",
    drawer_title: "連接器配置指南",
    drawer_subtitle: "參考以下步驟完善或修改你的連接器設置",
    unknown: "未知連接器",
    standard_connectors: "標準連接器"
};
var $f4535a3f3b4caee5$export$2e2bcd8739ae039 = Object.freeze($f4535a3f3b4caee5$var$connectors);


const $abf52697d8011a9c$var$contact = {
    title: "獲得幫助",
    description: "欲查詢幫助或提供產品反饋，請透過以下方式聯絡我們。",
    discord: {
        title: "加入 Discord 社群",
        description: "與其他開發人員交流，尋找解決方案",
        button: "加入"
    },
    github: {
        title: "在 GitHub 上溝通",
        description: "創建問題並提交到 GitHub",
        button: "打開"
    },
    email: {
        title: "透過電子郵件聯絡客服支援",
        description: "發送電子郵件以獲取進一步信息和幫助",
        button: "發送"
    },
    reserve: {
        title: "與 Logto 團隊預定時間",
        description: "快速預定一個會話內容",
        button: "預定"
    }
};
var $abf52697d8011a9c$export$2e2bcd8739ae039 = Object.freeze($abf52697d8011a9c$var$contact);


const $33c72ba49c7cf396$var$dashboard = {
    page_title: "儀表板",
    title: "儀表板",
    description: "查看所有應用的數據概況",
    total_users: "總用戶",
    total_users_tip: "總用戶",
    new_users_today: "今日新增",
    new_users_today_tip: "今日註冊到你應用上的新用戶數",
    new_users_7_days: "7 日新增",
    new_users_7_days_tip: "最近 7 日註冊到你應用上的新用戶數",
    daily_active_users: "日活用戶",
    daily_active_users_tip: "今日在你的應用上交換過 token 的獨立用戶數",
    weekly_active_users: "周活用戶",
    weekly_active_users_tip: "最近 7 日在你的應用上交換過 token 的獨立用戶數",
    monthly_active_users: "月活用戶",
    monthly_active_users_tip: "最近 30 日在你的應用上交換過 token 的獨立用戶數"
};
var $33c72ba49c7cf396$export$2e2bcd8739ae039 = Object.freeze($33c72ba49c7cf396$var$dashboard);


const $315b3156051368a1$var$domain = {
    status: {
        connecting: "正在連接...",
        in_use: "使用中",
        failed_to_connect: "連接失敗"
    },
    update_endpoint_notice: "不要忘記在應用程序中更新社交連接器回調URI和Logto端點的域名，如果你想使用自定義域名進行功能。 <a>{{link}}</a>",
    error_hint: "確保更新您的 DNS 記錄。我們將繼續每 {{value}} 秒檢查。",
    custom: {
        custom_domain: "自定義域名",
        custom_domain_description: "提高品牌形象，使用自定義域名。此域名將用於您的登錄體驗。",
        custom_domain_field: "自定義域名",
        custom_domain_placeholder: "your.domain.com",
        add_domain: "添加域名",
        invalid_domain_format: '請提供有效的域名 URL，至少有三部分，例如 "your.domain.com."',
        verify_domain: "驗證域名",
        enable_ssl: "啟用 SSL",
        checking_dns_tip: "配置 DNS 記錄後，此程序將自動運行，可能需要長達 24 個小時。不影響執行，可離開此界面。",
        enable_ssl_tip: "啟用 SSL 將自動運行，可能需要長達 24 個小時。您可以在運行期間離開此界面。",
        generating_dns_records: "正在生成 DNS 記錄...",
        add_dns_records: "請將以下 DNS 記錄添加到 DNS 提供者。",
        dns_table: {
            type_field: "類型",
            name_field: "名稱",
            value_field: "內容"
        },
        deletion: {
            delete_domain: "刪除域名",
            reminder: "刪除自定義域名",
            description: "確定刪除此自定義域名嗎？",
            in_used_description: '確定刪除此自定義域名"<span>{{domain}}</span>"嗎？',
            in_used_tip: '如果在之前的社交記錄或應用程式終端點中配置了此自定義域名，您需要先使用 Logto 默認域名"<span>{{domain}}</span>" 修改 URI，使社交組件可以正常使用。',
            deleted: "成功刪除自定義域名！"
        }
    },
    default: {
        default_domain: "默認域名",
        default_domain_description: "Logto 提供預配置的默認域名，無需進行任何其他設置即可使用。即使啟用了自定義域名，此默認域名也可作為備用選項。",
        default_domain_field: "Logto 默認域名"
    },
    custom_endpoint_note: "您可以根據需要自定義這些端點的域名。選擇“{{custom}}”或“{{default}}”。",
    custom_social_callback_url_note: "您可以自定義此 URI 的域名以匹配您的應用程序端點。選擇“{{custom}}”或“{{default}}”。",
    custom_acs_url_note: "您可以自定義這個 URI 的域名以匹配您的身份提供者斷言使用者服務 URL。選擇“{{custom}}”或“{{default}}”。"
};
var $315b3156051368a1$export$2e2bcd8739ae039 = Object.freeze($315b3156051368a1$var$domain);


const $c6fbcea9de7823bb$var$enterprise_sso_details = {
    back_to_sso_connectors: "返回企業SSO",
    page_title: "企業SSO連接器詳細信息",
    readme_drawer_title: "企業SSO",
    readme_drawer_subtitle: "設置企業SSO連接器以啟用終端用戶SSO",
    tab_experience: "SSO體驗",
    tab_connection: "連接",
    general_settings_title: "一般",
    custom_branding_title: "顯示",
    custom_branding_description: "自定義在終端用戶單點登錄流程中顯示的名稱和圖標。 當為空時，將使用默認值。",
    email_domain_field_name: "企業郵箱域",
    email_domain_field_description: "使用此郵箱域的用戶可以使用SSO進行身份驗證。 請驗證該域是否屬於企業。",
    email_domain_field_placeholder: "郵箱域",
    sync_profile_field_name: "將配置文件信息從身份提供者同步",
    sync_profile_option: {
        register_only: "僅在首次登錄時同步",
        each_sign_in: "每次登錄時始終同步"
    },
    connector_name_field_name: "連接器名稱",
    display_name_field_name: "顯示名稱",
    connector_logo_field_name: "顯示圖標",
    connector_logo_field_description: "每個圖像應小於500KB，僅支援SVG，PNG，JPG，JPEG。",
    branding_logo_context: "上傳圖標",
    branding_logo_error: "上傳圖標錯誤：{{error}}",
    branding_light_logo_context: "上傳淺色模式圖標",
    branding_light_logo_error: "上傳淺色模式圖標錯誤：{{error}}",
    branding_logo_field_name: "圖標",
    branding_logo_field_placeholder: "https://your.domain/logo.png",
    branding_dark_logo_context: "上傳深色模式圖標",
    branding_dark_logo_error: "上傳深色模式圖標錯誤：{{error}}",
    branding_dark_logo_field_name: "圖標（深色模式）",
    branding_dark_logo_field_placeholder: "https://your.domain/dark-mode-logo.png",
    check_connection_guide: "連接指南",
    enterprise_sso_deleted: "企業SSO連接器已成功刪除",
    delete_confirm_modal_title: "刪除企業SSO連接器",
    delete_confirm_modal_content: "您確定要刪除此企業連接器嗎？ 身份提供者的用戶將無法使用單點登錄。",
    upload_idp_metadata_title_saml: "上傳元數據",
    upload_idp_metadata_description_saml: "配置從身份提供者複製的元數據。",
    upload_idp_metadata_title_oidc: "上傳憑證",
    upload_idp_metadata_description_oidc: "配置從身份提供者複製的憑證和OIDC令牌信息。",
    upload_idp_metadata_button_text: "上傳元數據XML文件",
    upload_signing_certificate_button_text: "上傳簽名憑證文件",
    configure_domain_field_info_text: "添加電子郵件域以引導企業用戶到其身份提供者進行單點登錄。",
    email_domain_field_required: "需要填寫電子郵件域以啟用企業SSO。",
    upload_saml_idp_metadata_info_text_url: "粘貼來自身份提供者的元數據URL以進行連接。",
    upload_saml_idp_metadata_info_text_xml: "粘貼來自身份提供者的元數據以進行連接。",
    upload_saml_idp_metadata_info_text_manual: "填寫來自身份提供者的元數據以進行連接。",
    upload_oidc_idp_info_text: "填寫來自身份提供者的信息以進行連接。",
    service_provider_property_title: "在IdP中配置",
    service_provider_property_description: "使用{{protocol}}在身份提供者中設置應用程序集成。 輸入Logto提供的詳細信息。",
    attribute_mapping_title: "屬性映射",
    attribute_mapping_description: "通過在身份提供者或Logto端配置用戶屬性映射來從身份提供者同步用戶配置文件。",
    saml_preview: {
        sign_on_url: "登錄URL",
        entity_id: "發行者",
        x509_certificate: "簽名憑證",
        certificate_content: "到期{{date}}"
    },
    oidc_preview: {
        authorization_endpoint: "授權端點",
        token_endpoint: "令牌端點",
        userinfo_endpoint: "用戶信息端點",
        jwks_uri: "JSON Web鍵集端點",
        issuer: "發行者"
    }
};
var $c6fbcea9de7823bb$export$2e2bcd8739ae039 = Object.freeze($c6fbcea9de7823bb$var$enterprise_sso_details);


const $e1b7cd172ad1f73d$var$enterprise_sso = {
    page_title: "企業單一登入 (SSO)",
    title: "企業單一登入 (SSO)",
    subtitle: "連接企業身份提供者並啟用服務提供者啟動的單一登入。",
    create: "新增企業連接器",
    col_connector_name: "連接器名稱",
    col_type: "類型",
    col_email_domain: "電子郵件域名",
    placeholder_title: "企業連接器",
    placeholder_description: "Logto 提供了許多內置的企業身份提供者來連接，同時您可以使用 SAML 和 OIDC 協定創建自己的。",
    create_modal: {
        title: "新增企業連接器",
        text_divider: "或者您可以通過標準協議自定義您的連接器。",
        connector_name_field_title: "連接器名稱",
        connector_name_field_placeholder: "例如，{corp. name} - {identity provider name}",
        create_button_text: "創建連接器"
    },
    guide: {
        subtitle: "一個關於連接企業身份提供者的分步指南。",
        finish_button_text: "繼續"
    },
    basic_info: {
        title: "在 IdP 中配置您的服務",
        description: "在您的{{name}}身份提供者中通過 SAML 2.0 創建新應用集成。然後將以下值貼到其中。",
        saml: {
            acs_url_field_name: "斷言消費服務 URL (回複 URL)",
            audience_uri_field_name: "受眾 URI (SP 實體 ID)"
        },
        oidc: {
            redirect_uri_field_name: "重定向 URI（回調 URL）"
        }
    },
    attribute_mapping: {
        title: "屬性映射",
        description: "同步用戶概要從 IdP 需要 `id` 和 `email`。在您的 IdP 中輸入以下聲明名稱和值。",
        col_sp_claims: "服務提供者（Logto）的值",
        col_idp_claims: "身份提供者的聲明名稱",
        idp_claim_tooltip: "身份提供者的聲明名稱"
    },
    metadata: {
        title: "配置 IdP 元數據",
        description: "從身份提供者配置元數據",
        dropdown_trigger_text: "使用其他配置方法",
        dropdown_title: "選擇您的配置方法",
        metadata_format_url: "輸入元數據 URL",
        metadata_format_xml: "上傳元數據 XML 文件",
        metadata_format_manual: "手動輸入元數據細節",
        saml: {
            metadata_url_field_name: "元數據 URL",
            metadata_url_description: "動態從元數據 URL 檢索數據並保持證書最新。",
            metadata_xml_field_name: "IdP 元數據 XML 文件",
            metadata_xml_uploader_text: "上傳元數據 XML 文件",
            sign_in_endpoint_field_name: "登錄 URL",
            idp_entity_id_field_name: "IdP 實體 ID（發行者）",
            certificate_field_name: "簽名證書",
            certificate_placeholder: "複製並粘貼 x509 憑證",
            certificate_required: "需要簽名證書。"
        },
        oidc: {
            client_id_field_name: "客戶端 ID",
            client_secret_field_name: "客戶端密鑰",
            issuer_field_name: "發行者",
            scope_field_name: "範圍"
        }
    }
};
var $e1b7cd172ad1f73d$export$2e2bcd8739ae039 = Object.freeze($e1b7cd172ad1f73d$var$enterprise_sso);


const $b467a2153f0be437$var$errors = {
    something_went_wrong: "哎呀，出錯了！",
    page_not_found: "找不到頁面",
    unknown_server_error: "伺服器發生未知錯誤",
    empty: "沒有數據",
    missing_total_number: "無法從返回的標頭信息中找到 Total-Number",
    invalid_uri_format: "無效的 URI 格式",
    invalid_origin_format: "無效的 URI origin 格式",
    invalid_json_format: "無效的 JSON 格式",
    invalid_regex: "無效的正則表達式",
    invalid_error_message_format: "非法的錯誤信息格式",
    required_field_missing: "請輸入{{field}}",
    required_field_missing_plural: "至少需要輸入一個{{field}}",
    more_details: "查看詳情",
    username_pattern_error: "用戶名只能包含英文字母、數字或下劃線，且不以數字開頭。",
    email_pattern_error: "郵箱地址無效",
    phone_pattern_error: "手機號碼無效",
    insecure_contexts: "不支持不安全的上下文（非 HTTPS）。",
    unexpected_error: "發生未知錯誤",
    not_found: "404 找不到資源",
    create_internal_role_violation: '你正在創建一個被 Logto 禁止內部角色。嘗試使用不以 "#internal:" 開頭的其他名稱。',
    should_be_an_integer: "必須為整數。",
    number_should_be_between_inclusive: "數值必須在{{min}}和{{max}}之間（包括{{min}}和{{max}}）"
};
var $b467a2153f0be437$export$2e2bcd8739ae039 = Object.freeze($b467a2153f0be437$var$errors);


const $88a222d09dbb19ad$var$general = {
    placeholder: "占位符",
    submit: "提交",
    skip: "跳過",
    next: "下一步",
    back: "上一步",
    retry: "重試",
    done: "完成",
    search: "搜索",
    search_placeholder: "搜索",
    clear_result: "清除結果",
    save: "儲存",
    save_changes: "儲存變更",
    saved: "已儲存",
    discard: "放棄",
    loading: "讀取中...",
    redirecting: "頁面跳轉中...",
    add: "添加",
    added: "已添加",
    cancel: "取消",
    confirm: "確認",
    check_out: "查看",
    create: "創建",
    set_up: "配置",
    customize: "自定義",
    enable: "啟用",
    reminder: "提示",
    edit: "編輯",
    delete: "刪除",
    deleted: "已刪除",
    more_options: "更多選項",
    close: "關閉",
    copy: "複製",
    copying: "複製中",
    copied: "已複製",
    required: "必填",
    add_another: "新增",
    create_another: "創建另一個",
    deletion_confirmation: "你確定要刪除這個 {{title}} 嗎?",
    settings_nav: "設置",
    unsaved_changes_warning: "還有未儲存的變更,確定要離開嗎？",
    leave_page: "離開此頁",
    stay_on_page: "留在此頁",
    type_to_search: "輸入搜索",
    got_it: "知道了",
    continue: "繼續",
    page_info: "{{min, number}}-{{max, number}} 共 {{total, number}} 條",
    learn_more: "了解更多",
    tab_errors: "{{count, number}} 個錯誤",
    skip_for_now: "先跳過",
    remove: "移除",
    visit: "訪問",
    join: "加入",
    try_now: "現在試試",
    multiple_form_field: "（多選）",
    demo: "演示",
    unnamed: "未命名",
    view: "查看",
    open: "打開",
    hide: "隱藏",
    unknown_error: "未知錯誤，請稍後重試。",
    select: "選擇",
    contact_us_action: "聯絡我們",
    description: "描述",
    name: "名稱",
    add_field: "新增{{field}}",
    create_field: "創建{{field}}",
    edit_field: "編輯{{field}}",
    delete_field: "刪除{{field}}",
    coming_soon: "即將推出",
    or: "或"
};
var $88a222d09dbb19ad$export$2e2bcd8739ae039 = Object.freeze($88a222d09dbb19ad$var$general);


const $bf53312e972d3730$var$get_started = {
    page_title: "開始上手",
    title: "成功開發身份方案，我們先來探索一番",
    subtitle: "一些你可以做的事情，以快速獲取 Logto 的價值",
    develop: {
        title: "開發：花 5 分鐘將你的應用集成進來",
        title_cloud: "開發：花 5 分鐘將你的應用安全集成進來",
        subtitle_cloud: "或花 5 分鐘將你的應用與我們預先構建的 SDK 和教程集成。"
    },
    customize: {
        title: "定制：提供出色的登錄體驗",
        preview: {
            title: "查看剛剛定制的登錄體驗的實時預覽",
            subtitle: "現在嘗試 Logto 登錄體驗，看看它如何運作"
        },
        connector: {
            title: "添加更多連接器以支持更多社交登錄方式",
            subtitle: "試一試無密碼登錄，為你的客戶提供安全、無摩擦的體驗"
        },
        continue_customizing: "繼續定制",
        try_now: "立即試用",
        add_more: "添加更多"
    },
    secure: {
        title: "安全：保護你的資源"
    },
    manage: {
        title: "管理：為你的產品和用戶定義存取控制",
        rbac: {
            title: "為你的資源添加基於角色的存取控制",
            subtitle: "通過可擴展的角色授權，控制你的資源，滿足不同的使用場景"
        },
        create_roles: "創建角色"
    },
    view_all: "查看全部 →"
};
var $bf53312e972d3730$export$2e2bcd8739ae039 = Object.freeze($bf53312e972d3730$var$get_started);


const $da8f2160c1a2435f$var$guide = {
    start_building: "開始構建",
    get_started: "立即開始",
    categories: {
        featured: "推薦熱門開發框架",
        Traditional: "傳統網頁應用",
        SPA: "單頁應用",
        Native: "原生應用",
        MachineToMachine: "機器對機器",
        Protected: "非 SDK 整合",
        ThirdParty: "第三方應用程式"
    },
    filter: {
        title: "篩選框架",
        placeholder: "搜索框架"
    },
    checkout_tutorial: "查看 {{name}} 教程",
    do_not_need_tutorial: "如果你現在不需要教程，可以點擊右側按鈕繼續創建應用",
    finish_and_done: "完成",
    cannot_find_guide: "找不到你想要的教程？",
    describe_guide_looking_for: "描述你正在尋找的教程",
    request_guide_successfully: "請求已成功提交，謝謝！",
    app: {
        select_framework_or_tutorial: "選擇一個框架或教程",
        guide_modal_title: "從 SDK 和指南開始",
        modal_subtitle: "使用我們提供的 SDK 和集成教程加速你的應用開發過程。",
        select_a_framework: "選擇一個框架",
        continue_without_framework: "跳過教程直接創建應用",
        describe_guide_looking_for_placeholder: "例如：我想將 Logto 集成到我的 Angular 應用程式中。"
    },
    api: {
        modal_title: "首先從教程開始",
        modal_subtitle: "使用我們提供的教程來加速你的應用程式開發過程。",
        select_a_tutorial: "選擇一個教程",
        continue_without_tutorial: "跳過教程直接創建 API 資源",
        describe_guide_looking_for_placeholder: "例如：我想使用 deno 框架驗證我的 API。"
    }
};
var $da8f2160c1a2435f$export$2e2bcd8739ae039 = Object.freeze($da8f2160c1a2435f$var$guide);


const $c8381dc327f13331$var$invitation = {
    find_your_tenants: "尋找你的承租人",
    find_tenants_description: "您的電子郵件地址可能已在多個租戶中註冊。您可以選擇加入現有租戶或繼續創建新的。",
    create_new_tenant: "建立新租戶",
    email_not_match_title: "您目前是以\n{{email}}\n登入",
    email_not_match_description: "請使用正確的帳戶登入以接受邀請並成為組織的成員。",
    switch_account: "切換帳號",
    invalid_invitation_status: "無效的邀請。請聯絡管理員並重試。",
    invitation_not_found: "找不到邀請。請聯絡管理員。"
};
var $c8381dc327f13331$export$2e2bcd8739ae039 = Object.freeze($c8381dc327f13331$var$invitation);


const $a57dcdc48554d048$var$jwt_claims = {
    title: "自訂 JWT",
    description: "設定自訂 JWT 声明以包含在存取權杖中。這些声明可用於將額外信息傳遞給您的應用程式。",
    user_jwt: {
        card_title: "用於用戶",
        card_field: "用戶存取權杖",
        card_description: "在發行存取權杖期間添加用戶特定數據。",
        for: "用於用戶"
    },
    machine_to_machine_jwt: {
        card_title: "用於 M2M",
        card_field: "機器對機器權杖",
        card_description: "在發行機器對機器權杖期間添加額外數據。",
        for: "用於 M2M"
    },
    code_editor_title: "自訂 {{token}} 声明",
    custom_jwt_create_button: "添加自訂声明",
    custom_jwt_item: "自訂声明 {{for}}",
    delete_modal_title: "刪除自訂声明",
    delete_modal_content: "您確定要刪除自訂声明嗎？",
    clear: "清空",
    cleared: "已清空",
    restore: "恢復預設值",
    restored: "已恢復",
    data_source_tab: "數據來源",
    test_tab: "測試上下文",
    jwt_claims_description: "默認声明會自動包含在 JWT 中，無法覆蓋。",
    user_data: {
        title: "用戶數據",
        subtitle: "使用 `data.user` 輸入參數提供重要用戶信息。"
    },
    token_data: {
        title: "權杖數據",
        subtitle: "使用 `token` 輸入參數查看當前存取權杖有效負載。"
    },
    fetch_external_data: {
        title: "提取外部數據",
        subtitle: "將來自外部 API 的數據直接導入声明。",
        description: "使用 `fetch` 函數調用您的外部 API 並將數據包含在自訂声明中。例如："
    },
    environment_variables: {
        title: "設置環境變數",
        subtitle: "使用環境變數存儲敏感信息。",
        input_field_title: "添加環境變數",
        sample_code: "在您的自訂 JWT 声明處理程序中訪問環境變數。例如："
    },
    jwt_claims_hint: "將自訂声明限制在 50KB 以下。默認 JWT 声明會自動包含在權杖中，不能被覆蓋。",
    tester: {
        subtitle: "調整模擬權杖和用戶數據以進行測試。",
        run_button: "運行測試",
        result_title: "測試結果"
    },
    form_error: {
        invalid_json: "無效的 JSON 格式"
    }
};
var $a57dcdc48554d048$export$2e2bcd8739ae039 = Object.freeze($a57dcdc48554d048$var$jwt_claims);


const $33ccb2b30b51404f$var$log_details = {
    page_title: "審計日誌詳情",
    back_to_logs: "返回審計日誌",
    back_to: "返回 {{name}}",
    success: "成功",
    failed: "失敗",
    event_key: "事件 Key",
    application: "應用",
    ip_address: "IP 地址",
    user: "用戶",
    log_id: "日誌 ID",
    time: "時間",
    user_agent: "用戶代理",
    tab_details: "詳細",
    raw_data: "原始數據"
};
var $33ccb2b30b51404f$export$2e2bcd8739ae039 = Object.freeze($33ccb2b30b51404f$var$log_details);


const $455f16fc6aa7fe59$var$logs = {
    page_title: "審計日誌",
    title: "審計日誌",
    subtitle: "查看用戶行為和事件",
    event: "事件",
    user: "用戶",
    application: "應用",
    time: "時間",
    filter_by: "過濾"
};
var $455f16fc6aa7fe59$export$2e2bcd8739ae039 = Object.freeze($455f16fc6aa7fe59$var$logs);


const $0e67359395531835$var$menu = {
    profile: "帳戶管理",
    language: "語言",
    appearance: {
        label: "主題",
        light: "淺色模式",
        dark: "深色模式",
        system: "跟隨系統"
    },
    sign_out: "退出登錄"
};
var $0e67359395531835$export$2e2bcd8739ae039 = Object.freeze($0e67359395531835$var$menu);


const $b4ab6b3fb34b00c6$var$mfa = {
    title: "多因素身份驗證",
    description: "添加多因素身份驗證以提升您登錄體驗的安全性。",
    factors: "因素",
    multi_factors: "多因素",
    multi_factors_description: "用戶需要驗證啟用的其中一個因素以進行兩步驗證。",
    totp: "身份驗證應用 OTP",
    otp_description: "將 Google Authenticator 等連接起來，以驗證一次性密碼。",
    webauthn: "WebAuthn（通行證）",
    webauthn_description: "通過瀏覽器支持的方法進行驗證：生物識別、手機掃描或安全密鑰等。",
    webauthn_native_tip: "本地應用不支持 WebAuthn。",
    webauthn_domain_tip: "WebAuthn將公共密鑰綁定到特定域。修改服務域將阻止用戶通過現有通行證進行身份驗證。",
    backup_code: "備份代碼",
    backup_code_description: "在用戶設置任何MFA方法後生成10個一次性備份代碼。",
    backup_code_setup_hint: "當用戶無法驗證上述MFA因素時，使用備份選項。",
    backup_code_error_hint: "要使用備份代碼，您需要至少再添加一種MFA方法以成功進行用戶身份驗證。",
    policy: "策略",
    policy_description: "設置登錄和註冊流程的MFA策略。",
    two_step_sign_in_policy: "登錄時的雙步驗證策略",
    user_controlled: "用戶可以自行啟用或禁用MFA",
    user_controlled_tip: "用戶可以在首次登錄或註冊時跳過MFA設置，或在帳戶設置中啟用/禁用它。",
    mandatory: "用戶總是需要在登錄時使用MFA",
    mandatory_tip: "用戶必須在首次登錄或註冊時設置MFA，並在以後的所有登錄中使用它。"
};
var $b4ab6b3fb34b00c6$export$2e2bcd8739ae039 = Object.freeze($b4ab6b3fb34b00c6$var$mfa);


const $aec4f9b1d68ad9f1$var$organization_details = {
    page_title: "組織詳細資料",
    delete_confirmation: "刪除後，所有成員將失去他們在此組織的成員資格和角色。此操作無法撤銷。",
    organization_id: "組織 ID",
    settings_description: "組織代表可以訪問您的應用程式的團隊、商業客戶和合作夥伴公司。",
    name_placeholder: "組織的名稱，不需要是唯一的。",
    description_placeholder: "組織的描述。",
    member: "成員",
    member_other: "成員",
    add_members_to_organization: "將成員新增至組織 {{name}}",
    add_members_to_organization_description: "通過搜索姓名、電子郵件、電話或使用者 ID 尋找合適的使用者。現有成員不會顯示在搜尋結果中。",
    add_with_organization_role: "以組織角色添加",
    user: "使用者",
    authorize_to_roles: "授權 {{name}} 存取以下角色：",
    edit_organization_roles: "編輯組織角色",
    edit_organization_roles_of_user: "編輯 {{name}} 的組織角色",
    remove_user_from_organization: "從組織中移除使用者",
    remove_user_from_organization_description: "移除後，使用者將失去他們在此組織的成員資格和角色。此操作無法撤銷。",
    search_user_placeholder: "按姓名、電子郵件、電話或使用者 ID 搜尋",
    at_least_one_user: "至少需要一名使用者。",
    custom_data: "自訂資料",
    custom_data_tip: "自訂資料是一個 JSON 物件，可用於存儲與組織相關的附加資料。",
    invalid_json_object: "無效的 JSON 物件。"
};
var $aec4f9b1d68ad9f1$export$2e2bcd8739ae039 = Object.freeze($aec4f9b1d68ad9f1$var$organization_details);


const $c77a2e45b552fad5$var$organization_role_details = {
    page_title: "組織角色詳情",
    back_to_org_roles: "返回組織角色",
    org_role: "組織角色",
    delete_confirm: "這樣做將會從受影響的使用者中移除與此角色相關聯的權限，並刪除組織角色、組織成員和組織權限之間的關係。",
    deleted: "組織角色 {{name}} 已成功刪除。",
    permissions: {
        tab: "權限",
        name_column: "權限",
        description_column: "描述",
        type_column: "權限類型",
        type: {
            api: "API 權限",
            org: "組織權限"
        },
        assign_permissions: "分配權限",
        remove_permission: "移除權限",
        remove_confirmation: "如果移除此權限，擁有此組織角色的使用者將失去此權限所授予的存取權。",
        removed: "權限 {{name}} 已成功從此組織角色中移除",
        assign_description: "為此組織中的角色分配權限。這些可以包括組織權限和 API 權限。",
        organization_permissions: "組織權限",
        api_permissions: "API 權限",
        assign_organization_permissions: "分配組織權限",
        assign_api_permissions: "分配API權限"
    },
    general: {
        tab: "一般",
        settings: "設置",
        description: "組織角色是可以分配給用戶的權限分組。權限可以來自預定義的組織權限和API權限。",
        name_field: "名稱",
        description_field: "描述",
        description_field_placeholder: "僅擁有檢視權限的使用者"
    }
};
var $c77a2e45b552fad5$export$2e2bcd8739ae039 = Object.freeze($c77a2e45b552fad5$var$organization_role_details);


const $5e8b37ba6445c875$var$organization_template = {
    title: "組織模板",
    subtitle: "在多租戶 SaaS 應用中，組織範本定義了多個組織的共享訪問控制政策（權限和角色）。",
    roles: {
        tab_name: "組織角色",
        search_placeholder: "按角色名稱搜索",
        create_title: "創建組織角色",
        role_column: "組織角色",
        permissions_column: "權限",
        placeholder_title: "組織角色",
        placeholder_description: "組織角色是一組可以分配給用戶的權限。權限必須來自預定義的組織權限。",
        create_modal: {
            title: "建立組織角色",
            create: "建立角色",
            name_field: "角色名稱",
            description_field: "描述",
            created: "成功建立組織角色 {{name}}。"
        }
    },
    permissions: {
        tab_name: "組織權限",
        search_placeholder: "按權限名稱搜索",
        create_org_permission: "創建組織權限",
        permission_column: "組織權限",
        description_column: "描述",
        placeholder_title: "組織權限",
        placeholder_description: "組織權限指的是在組織上下文中訪問資源的授權。",
        delete_confirm: "如果刪除此權限，包括此權限的所有組織角色都將失去此權限，擁有此權限的用戶將失去由此權限授予的訪問權限。",
        create_title: "創建組織權限",
        edit_title: "編輯組織權限",
        permission_field_name: "權限名稱",
        description_field_name: "描述",
        description_field_placeholder: "閱讀約會歷史",
        create_permission: "創建權限",
        created: "組織權限 {{name}} 已成功建立。"
    }
};
var $5e8b37ba6445c875$export$2e2bcd8739ae039 = Object.freeze($5e8b37ba6445c875$var$organization_template);


const $909bb62a85fa0376$var$organizations = {
    organization: "組織",
    page_title: "組織",
    title: "組織",
    subtitle: "組織通常用於 SaaS 或類似的多租戶應用程式，代表您的客戶團隊、組織或整個公司。組織作為 B2B 認證和授權的基礎要素。",
    organization_template: "組織模板",
    organization_id: "組織 ID",
    members: "成員",
    create_organization: "建立組織",
    setup_organization: "設定您的組織",
    organization_list_placeholder_title: "組織",
    organization_list_placeholder_text: "組織通常在 SaaS 或類似的多租戶應用程式中是最佳實踐。它們讓您開發應用程式，讓客戶可以建立和管理組織、邀請成員並分配角色。",
    organization_name_placeholder: "我的組織",
    organization_description_placeholder: "組織的簡要描述",
    organization_permission: "組織權限",
    organization_permission_other: "組織權限",
    create_permission_placeholder: "讀取預約歷史",
    organization_role: "組織角色",
    organization_role_other: "組織角色",
    organization_role_description: "組織角色是可以分配給用戶的權限的分組。權限必須來自預定義的組織權限。",
    role: "角色",
    search_placeholder: "按組織名稱或 ID 搜索",
    search_role_placeholder: "輸入並搜索選擇角色",
    empty_placeholder: "\uD83E\uDD14 你尚未設置任何 {{entity}}。",
    organization_and_member: "組織和成員",
    organization_and_member_description: "組織是一組用戶，可以代表團隊、商業客戶和合作夥伴公司，每個用戶都是「成員」。這些可以是處理多租戶需求的基本實體。",
    guide: {
        title: "開始使用指南",
        subtitle: "通過我們的指南快速設置您的組織設定",
        introduction: {
            title: "讓我們一起了解 Logto 中的組織運作",
            section_1: {
                title: "組織是一組用戶（身份）"
            },
            section_2: {
                title: "組織模板專為多租戶應用程式訪問控制而設計",
                description: "在多租戶 SaaS 應用程式中，多個組織通常共用相同的訪問控制模板，其中包括權限和角色。在 Logto 中，我們稱之為「組織模板」。",
                permission_description: "組織權限指授權在組織上下文中存取資源。",
                role_description_deprecated: "組織角色是可以分配給成員的組織權限的分組。",
                role_description: "組繇角色是可以分配給成員的組繇權限或API權限的分組。"
            },
            section_3: {
                title: "我可以將API權限分配給組織角色嗎？",
                description: "是的，您可以將API權限分配給組織角色。Logto提供靈活性，有效管理您組織的角色，允許您在這些角色中包括組織權限和API權限。"
            },
            section_4: {
                title: "交互示意圖，看看它們之間的關係",
                description: "讓我們舉個例子。John、Sarah 屬於不同的組織，在不同組織的上下文中具有不同的角色。懸停在不同的模塊上，看看會發生什麼。"
            }
        },
        organization_permissions: "組織權限",
        organization_roles: "組織角色",
        admin: "管理員",
        member: "成員",
        guest: "訪客",
        role_description: "角色「{{role}}」在不同組織間共享相同的組織模板。",
        john: "約翰",
        john_tip: '約翰使用 "john@email.com" 作為唯一標識屬於兩個組織。他是組織 A 的管理員，同時是組織 B 的訪客。',
        sarah: "莎拉",
        sarah_tip: '莎拉使用 "sarah@email.com" 作為唯一標識屬於一個組織。她是組織 B 的管理員。'
    }
};
var $909bb62a85fa0376$export$2e2bcd8739ae039 = Object.freeze($909bb62a85fa0376$var$organizations);


const $5c7b52ca1b13206f$var$permissions = {
    search_placeholder: "通過 API 或權限名稱搜索",
    search_placeholder_without_api: "通過權限名稱搜索",
    name_column: "權限",
    description_column: "描述",
    api_column: "API",
    placeholder_title: "權限",
    placeholder_description: "權限是指訪問資源的授權（我們稱其為 API 資源）。",
    edit: "編輯權限",
    delete: "刪除權限",
    remove: "移除權限",
    edit_title: "編輯 API 權限"
};
var $5c7b52ca1b13206f$export$2e2bcd8739ae039 = Object.freeze($5c7b52ca1b13206f$var$permissions);


const $f0bb1f321aadd9bf$var$profile = {
    page_title: "賬戶管理",
    title: "賬戶管理",
    description: "在這裡，你可以修改賬戶設置和管理個人信息，以確保賬戶安全。",
    settings: {
        title: "賬戶設置",
        profile_information: "個人信息",
        avatar: "頭像",
        name: "姓名",
        username: "用戶名"
    },
    link_account: {
        title: "關聯賬戶",
        email_sign_in: "郵件登錄",
        email: "郵件",
        social_sign_in: "社交賬號登錄",
        link_email: "綁定郵箱",
        link_email_subtitle: "綁定郵箱以便登錄或幫助恢復賬戶。",
        email_required: "郵箱不能為空",
        invalid_email: "無效的郵箱地址",
        identical_email_address: "輸入的郵箱地址與當前郵箱地址相同",
        anonymous: "匿名"
    },
    password: {
        title: "密碼與安全",
        password: "密碼",
        password_setting: "密碼設置",
        new_password: "新密碼",
        confirm_password: "確認密碼",
        enter_password: "輸入當前密碼",
        enter_password_subtitle: "為確保帳戶安全，在修改密碼前，請先輸入當前密碼以通過身份驗證。",
        set_password: "設置密碼",
        verify_via_password: "通過密碼驗證",
        show_password: "顯示密碼",
        required: "密碼不能為空",
        do_not_match: "密碼不匹配，請重新輸入。"
    },
    code: {
        enter_verification_code: "輸入驗證碼",
        enter_verification_code_subtitle: "驗證碼已發送至 <strong>{{target}}</strong>",
        verify_via_code: "通過郵箱驗證碼驗證",
        resend: "重新發送驗證碼",
        resend_countdown: "在 {{countdown}} 秒後重新發送"
    },
    delete_account: {
        title: "刪除賬戶",
        label: "刪除賬戶",
        description: "刪除賬戶將會刪除所有個人信息、用戶數據和配置。此操作無法撤銷。",
        button: "刪除賬戶",
        dialog_paragraph_1: "很抱歉聽到你想要刪除你的帳戶。刪除你的帳戶將永久刪除所有數據，包括用戶信息、日誌和設置，此操作無法撤銷。因此，請確保在繼續之前備份任何重要數據。",
        dialog_paragraph_2: "要繼續刪除帳戶的刪除過程，請通過 <a>mail</a> 向我們的支持團隊發送主題為“帳戶刪除請求”的郵件。我們將協助你並確保所有數據都已從我們的系統中正確刪除。",
        dialog_paragraph_3: "感謝你選擇 Logto Cloud。如果你有任何進一步的問題或疑慮，請隨時與我們聯繫。"
    },
    set: "設置",
    change: "修改",
    link: "關聯",
    unlink: "取消關聯",
    not_set: "未設置",
    change_avatar: "修改頭像",
    change_name: "修改姓名",
    change_username: "修改用戶名",
    set_name: "設置姓名",
    email_changed: "已成功綁定郵箱。",
    password_changed: "已重置密碼。",
    updated: "{{target}}更改成功。",
    linked: "{{target}}賬號綁定成功。",
    unlinked: "{{target}}賬號解綁成功。",
    email_exists_reminder: "該郵箱 {{email}} 已被其他賬號綁定，請更換郵箱。",
    unlink_confirm_text: "確定解綁",
    unlink_reminder: "解綁後，用戶將無法使用該 <span></span> 賬號進行登錄。確定要解綁嗎？"
};
var $f0bb1f321aadd9bf$export$2e2bcd8739ae039 = Object.freeze($f0bb1f321aadd9bf$var$profile);


const $5c080427b454bf4a$var$protected_app = {
    name: "受保護應用程式",
    title: "建立一個受保護的應用程式: 透過簡潔和極速添加身分驗證",
    description: "受保護的應用程式安全地維護使用者會話並代理您的應用程式請求。由 Cloudflare Workers 提供支援，享受全球頂尖性能和 0 毫秒的全球啟動速度。 <a>了解更多</a>",
    fast_create: "快速建立",
    modal_title: "建立受保護的應用程式",
    modal_subtitle: "透過點擊啟用安全和快速保護。輕鬆為您現有的網絡應用程式添加身分驗證功能。",
    form: {
        url_field_label: "您的原始網址",
        url_field_placeholder: "https://domain.com/",
        url_field_description: "提供需要身分驗證保護的應用程式地址。",
        url_field_modification_notice: "對原始網址的修訂可能需要 1-2 分鐘才能在全球網絡位置上生效。",
        url_field_tooltip: "提供您應用程式的地址，不包括任何 '/pathname'。創建後，您可以自定義路由身分驗證規則。\n\n注意: 原始網址本身並不需要身分驗證; 受保護僅適用於通過指定應用程式域訪問的情況。",
        domain_field_label: "應用程式域名",
        domain_field_placeholder: "your-domain",
        domain_field_description: "此 URL 將作為原始 URL 的身分驗證保護代理。創建後可以應用自訂域名。",
        domain_field_description_short: "此 URL 將作為原始 URL 的身分驗證保護代理。",
        domain_field_tooltip: "受 Logto 保護的應用程式將默認托管在 'your-domain.{{domain}}' 上。創建後可以應用自訂域名。",
        create_application: "創建應用程式",
        create_protected_app: "快速建立",
        errors: {
            domain_required: "您的域名是必填的。",
            domain_in_use: "這個子域名已經被使用。",
            invalid_domain_format: "無效的子域名格式: 只能使用小寫字母、數字和連字符 '-'。",
            url_required: "原始 URL 是必填的。",
            invalid_url: "無效的原始 URL 格式: 僅支援 http:// 或 https://。注意: 目前不支援 '/pathname'。",
            localhost: "請先將本地伺服器暴露到互聯網。了解更多關於 <a>本地開發</a>。"
        }
    },
    success_message: "\uD83C\uDF89 應用程式身分驗證成功啟用！探索您的網站的全新體驗。"
};
var $5c080427b454bf4a$export$2e2bcd8739ae039 = Object.freeze($5c080427b454bf4a$var$protected_app);


const $640f7e501c5093f7$var$role_details = {
    back_to_roles: "返回角色",
    identifier: "標識符",
    delete_description: "這樣做將從受影響的用戶中刪除與該角色關聯的權限，並刪除角色、用戶和權限之間的映射關聯。",
    role_deleted: "{{name}} 已成功刪除。",
    general_tab: "常規",
    users_tab: "用戶",
    m2m_apps_tab: "機器對機器應用",
    permissions_tab: "權限",
    settings: "設置",
    settings_description: "角色是一組權限，可以分配給用戶。它們還提供了一種聚合不同 API 定義的權限的方法，使得添加、刪除或調整權限比將其單獨分配給用戶更有效率。",
    field_name: "名稱",
    field_description: "描述",
    field_is_default: "默认角色",
    field_is_default_description: "將此角色設置為新用戶的默认角色。可以設置多個默認角色。這也會影響通過管理 API 創建的用戶的默认角色。",
    type_m2m_role_tag: "機器對機器應用角色",
    type_user_role_tag: "用戶角色",
    m2m_role_notification: "將此機器對機器角色分配給機器對機器應用程式，以授予相關API資源的存取權限。如果尚未建立，請<a>先建立機器對機器應用程式</a>。",
    permission: {
        assign_button: "分配權限",
        assign_title: "分配權限",
        assign_subtitle: "將權限分配給此角色。角色將獲得添加的權限，具有此角色的用戶將繼承這些權限。",
        assign_form_field: "分配權限",
        added_text_one: "添加了 {{count, number}} 個權限",
        added_text_other: "添加了 {{count, number}} 個權限",
        api_permission_count_one: "{{count, number}} 個權限",
        api_permission_count_other: "{{count, number}} 個權限",
        confirm_assign: "分配權限",
        permission_assigned: "所選的權限已成功分配給此角色",
        deletion_description: "如果刪除此權限，則具有此角色的受影響用戶將失去此權限授予的訪問權限。",
        permission_deleted: "權限 {{name}} 已成功從此角色中刪除",
        empty: "無可用權限"
    },
    users: {
        assign_button: "分配用戶",
        name_column: "用戶",
        app_column: "應用",
        latest_sign_in_column: "最近登錄",
        delete_description: "它將保留在你的用戶池中，但失去此角色的授權。",
        deleted: "{{name}} 已成功從此角色中刪除",
        assign_title: "分配用戶",
        assign_subtitle: "將用戶分配給此角色。通過搜索名稱、電子郵件、電話或用戶 ID 查找適當的用戶。",
        assign_field: "分配用戶",
        confirm_assign: "分配用戶",
        assigned_toast_text: "所選的用戶已成功分配給此角色",
        empty: "無可用用戶"
    },
    applications: {
        assign_button: "分配應用",
        name_column: "應用",
        app_column: "應用",
        description_column: "描述",
        delete_description: "它將保留在您的應用池中，但失去此角色的授權。",
        deleted: "{{name}} 已成功從此角色中刪除",
        assign_title: "分配應用",
        assign_subtitle: "將應用分配給此角色。通過搜索名稱、描述或應用 ID 查找適當的應用。",
        assign_field: "分配應用",
        confirm_assign: "分配應用",
        assigned_toast_text: "所選的應用已成功分配給此角色",
        empty: "無可用應用"
    }
};
var $640f7e501c5093f7$export$2e2bcd8739ae039 = Object.freeze($640f7e501c5093f7$var$role_details);


const $a279d2a8f2da70b0$var$roles = {
    page_title: "角色",
    title: "角色",
    subtitle: "RBAC 是一種訪問控制方法，它使用角色來決定用戶可以做什麼事情，包括授予用戶訪問特定資源的權限。",
    create: "創建角色",
    role_name: "角色名稱",
    role_type: "角色類型",
    show_role_type_button_text: "顯示更多選項",
    hide_role_type_button_text: "隱藏更多選項",
    type_user: "用戶角色",
    type_machine_to_machine: "機器到機器應用程式角色",
    role_description: "描述",
    role_name_placeholder: "輸入你的角色名稱",
    role_description_placeholder: "輸入你的角色描述",
    col_roles: "角色",
    col_type: "類型",
    col_description: "描述",
    col_assigned_entities: "已分配",
    user_counts: "{{count}} 位用戶",
    application_counts: "{{count}} 個應用程式",
    user_count: "{{count}} 位用戶",
    application_count: "{{count}} 個應用程式",
    assign_permissions: "分配權限",
    create_role_title: "創建角色",
    create_role_description: "為你的應用程式創建和管理角色。角色包含權限集合，並可以分配給用戶。",
    create_role_button: "創建角色",
    role_created: "角色 {{name}} 已成功創建。",
    search: "按角色名稱、描述或 ID 搜索",
    placeholder_title: "角色",
    placeholder_description: "角色是可以分配給用戶的權限分組。在創建角色之前，請確保先添加權限。",
    assign_user_roles: "分配使用者角色",
    assign_m2m_roles: "分配機器對機器角色",
    management_api_access_notification: "要訪問Logto管理API，請選擇具有管理API權限的角色<flag/>。",
    with_management_api_access_tip: "此機器對機器角色包含Logto管理API權限"
};
var $a279d2a8f2da70b0$export$2e2bcd8739ae039 = Object.freeze($a279d2a8f2da70b0$var$roles);


const $92ec031578c6d0df$var$session_expired = {
    title: "會話已過期",
    subtitle: "會話可能已過期，你已被退出登錄。請點擊下方按鈕重新登錄到管理控制台。",
    button: "重新登錄"
};
var $92ec031578c6d0df$export$2e2bcd8739ae039 = Object.freeze($92ec031578c6d0df$var$session_expired);


const $e37d11d31d1d55b6$var$content = {
    terms_of_use: {
        title: "TERMS",
        terms_of_use: "Terms of use URL",
        terms_of_use_placeholder: "https://your.terms.of.use/",
        privacy_policy: "Privacy policy URL",
        privacy_policy_placeholder: "https://your.privacy.policy/"
    },
    languages: {
        title: "LANGUAGES",
        enable_auto_detect: "Enable auto-detect",
        description: "Your software detects the user's locale setting and switches to the local language. You can add new languages by translating UI from English to another language.",
        manage_language: "Manage language",
        default_language: "Default language",
        default_language_description_auto: "The default language will be used when the detected user language isn’t covered in the current language library.",
        default_language_description_fixed: "When auto-detect is off, the default language is the only language your software will show. Turn on auto-detect for language extension."
    },
    manage_language: {
        title: "Manage language",
        subtitle: "Localize the product experience by adding languages and translations. Your contribution can be set as the default language.",
        add_language: "Add Language",
        logto_provided: "Logto provided",
        key: "Key",
        logto_source_values: "Logto source values",
        custom_values: "Custom values",
        clear_all_tip: "Clear all values",
        unsaved_description: "Changes won’t be saved if you leave this page without saving.",
        deletion_tip: "Delete the language",
        deletion_title: "Do you want to delete the added language?",
        deletion_description: "After deletion, your users won’t be able to browse in that language again.",
        default_language_deletion_title: "Default language can’t be deleted.",
        default_language_deletion_description: "{{language}} is set as your default language and can’t be deleted. "
    }
};
var $e37d11d31d1d55b6$export$2e2bcd8739ae039 = Object.freeze($e37d11d31d1d55b6$var$content);


const $9fcc22e54a22ec3f$var$password_policy = {
    password_requirements: "密碼要求",
    minimum_length: "最小長度",
    minimum_length_description: "NIST 建議在 Web 產品中使用至少 8 個字符。",
    minimum_length_error: "最小長度必須介於{{min}}和{{max}}之間（包括{{min}}和{{max}}）。",
    minimum_required_char_types: "最小所需字符類型",
    minimum_required_char_types_description: "字符類型：大寫字母（A-Z）、小寫字母（a-z）、數字（0-9）和特殊符號（{{symbols}}）。",
    password_rejection: "密碼拒絕設置",
    compromised_passwords: "拒絕被破解的密碼",
    breached_passwords: "洩露的密碼",
    breached_passwords_description: "拒絕之前在洩露數據庫中出現的密碼。",
    restricted_phrases: "限制低安全性短語",
    restricted_phrases_tooltip: "密碼應該避免使用這些短語，除非結合至少 3 個或更多的額外字符。",
    repetitive_or_sequential_characters: "重複或連續字符",
    repetitive_or_sequential_characters_description: '例如："AAAA"、"1234"和"abcd"。',
    user_information: "用戶信息",
    user_information_description: "例如：郵件地址、電話號碼、用戶名等等。",
    custom_words: "自定義詞彙",
    custom_words_description: "個性化上下文特定的詞彙，不區分大小寫，每行一個詞。",
    custom_words_placeholder: "您的服務名稱、公司名稱等等。"
};
var $9fcc22e54a22ec3f$export$2e2bcd8739ae039 = Object.freeze($9fcc22e54a22ec3f$var$password_policy);


const $c28d66fba787e1dc$var$sign_up_and_sign_in = {
    identifiers_email: "郵件地址",
    identifiers_phone: "手機號碼",
    identifiers_username: "用戶名",
    identifiers_email_or_sms: "郵件地址或手機號碼",
    identifiers_none: "無",
    and: "與",
    or: "或",
    sign_up: {
        title: "註冊",
        sign_up_identifier: "註冊標識",
        identifier_description: "創建帳戶時你需要設定註冊標識。這些資訊在用戶登錄時，屬於必選項。",
        sign_up_authentication: "註冊身份認證設置",
        authentication_description: "註冊時，你的用戶將要完成以下所有勾選的任務。",
        set_a_password_option: "創建密碼",
        verify_at_sign_up_option: "註冊時驗證身份",
        social_only_creation_description: "（僅對社交註冊用戶適用）"
    },
    sign_in: {
        title: "登錄",
        sign_in_identifier_and_auth: "登錄標識和身份認證設置",
        description: "用戶可以使用任何可用的選項進行登錄。拖拽選項即可調整頁面佈局。",
        add_sign_in_method: "添加登錄方式",
        password_auth: "密碼",
        verification_code_auth: "驗證碼",
        auth_swap_tip: "交換以下選項的位置即可設定它們在用戶登錄流程中出現的先後。",
        require_auth_factor: "請至少選擇一種認證方式。"
    },
    social_sign_in: {
        title: "社交登錄",
        social_sign_in: "社交登錄",
        description: "你已設定特定的標識。用戶在通過社交連接器註冊時可能會被要求提供一個對應的標識。",
        add_social_connector: "添加社交連接器",
        set_up_hint: {
            not_in_list: "沒有你想要的連接器？",
            set_up_more: "立即設置",
            go_to: "其他社交連接器。"
        }
    },
    tip: {
        set_a_password: "啟用用戶名註冊，必須設置密碼。",
        verify_at_sign_up: "我們目前僅支持經過驗證的郵件地址登錄。如果沒有驗證，你的用戶信息中可能出現大量無效電子郵件地址。",
        password_auth: "因註冊設置裏你啟用了用戶名密碼標識。這個資訊在用戶登錄時，屬於必選項。",
        verification_code_auth: "因註冊設置裏你啟用了驗證碼標識，驗證碼屬於用戶必選項。開啟密碼註冊後，你可以選擇關閉驗證碼登錄。",
        delete_sign_in_method: "因註冊設置裏你啟用了{{identifier}}標識。這些資訊在用戶登錄時，屬於必選項。"
    },
    advanced_options: {
        title: "進階選項",
        enable_single_sign_on: "啟用企業單一登錄 (SSO)",
        enable_single_sign_on_description: "啟用用戶使用企業身份進行應用程式的單一登錄。",
        single_sign_on_hint: {
            prefix: "前往",
            link: "“企業SSO”",
            suffix: "部分設置更多企業連接器。"
        },
        enable_user_registration: "啟用用戶註冊",
        enable_user_registration_description: "啟用或禁止用戶註冊。禁用後，管理控制臺仍然可以添加用戶，但用戶無法通過登錄界面建立帳戶。"
    }
};
var $c28d66fba787e1dc$export$2e2bcd8739ae039 = Object.freeze($c28d66fba787e1dc$var$sign_up_and_sign_in);


const $142335f0ca735549$var$sign_in_exp = {
    page_title: "登錄體驗",
    title: "登錄體驗",
    description: "自定義登錄界面，並實時預覽真實效果",
    tabs: {
        branding: "品牌",
        sign_up_and_sign_in: "註冊與登錄",
        content: "內容",
        password_policy: "密碼政策"
    },
    welcome: {
        title: "自定義登錄體驗",
        description: "通過首次登錄設置快速入門。本指南將帶領您完成所有必要的設置。",
        get_started: "開始",
        apply_remind: "請注意，登錄體驗將會應用到當前帳戶下的所有應用。"
    },
    color: {
        title: "顏色",
        primary_color: "品牌顏色",
        dark_primary_color: "品牌顏色 (深色)",
        dark_mode: "開啟深色模式",
        dark_mode_description: "基於品牌顏色和 Logto 的算法，應用將會有一個自動生成的深色模式。當然，您可以自定義和修改。",
        dark_mode_reset_tip: "基於品牌顏色，重新生成深色模式顏色。",
        reset: "重新生成"
    },
    branding: {
        title: "品牌定制區",
        ui_style: "樣式",
        favicon: "瀏覽器地址欄圖標",
        logo_image_url: "Logo 圖片 URL",
        logo_image_url_placeholder: "https://your.cdn.domain/logo.png",
        dark_logo_image_url: "Logo 圖片 URL (深色)",
        dark_logo_image_url_placeholder: "https://your.cdn.domain/logo-dark.png",
        logo_image: "Logo 圖片",
        dark_logo_image: "Logo 圖片(深色)",
        logo_image_error: "應用 Logo：{{error}}",
        favicon_error: "Favicon：{{error}}"
    },
    custom_css: {
        title: "自定義 CSS",
        css_code_editor_title: "自定義 CSS 個性化您的用戶界面",
        css_code_editor_description1: "查看自定義 CSS 的例子。",
        css_code_editor_description2: "<a>{{link}}</a>",
        css_code_editor_description_link_content: "了解更多",
        css_code_editor_content_placeholder: "輸入 CSS 代碼，修改顏色、字體、組件樣式、佈局，定制您的登錄、註冊、忘記密碼等頁面。充分發揮創造力，讓您的用戶界面脫穎而出。"
    },
    sign_up_and_sign_in: $c28d66fba787e1dc$export$2e2bcd8739ae039,
    content: $e37d11d31d1d55b6$export$2e2bcd8739ae039,
    password_policy: $9fcc22e54a22ec3f$export$2e2bcd8739ae039,
    setup_warning: {
        no_connector_sms: "尚未設置 SMS 短信連接器。在完成該配置前，用戶將無法通過此登錄方式登錄。<a>{{link}}</a>連接器。",
        no_connector_email: "尚未設置電子郵件連接器。在完成該配置前，用戶將無法通過此登錄方式登錄。<a>{{link}}</a>連接器。",
        no_connector_social: "您還沒有設置任何社交連接器。首先添加連接器以應用社交登錄方法。<a>{{link}}</a>連接器。",
        setup_link: "立即設置"
    },
    save_alert: {
        description: "您正在進行登錄註冊設置的變更。當前您的所有用戶會受到新設置的影響。確認保存該設置嗎？",
        before: "設置前",
        after: "設置後",
        sign_up: "註冊",
        sign_in: "登錄",
        social: "社交"
    },
    preview: {
        title: "登錄預覽",
        live_preview: "實時預覽",
        live_preview_tip: "保存以預覽更改",
        native: "移動原生",
        desktop_web: "桌面網頁",
        mobile_web: "移動網頁",
        desktop: "桌面網頁",
        mobile: "移動設備"
    }
};
var $142335f0ca735549$export$2e2bcd8739ae039 = Object.freeze($142335f0ca735549$var$sign_in_exp);


const $d5e8e91726aa6778$var$signing_keys = {
    title: "簽名密鑰",
    description: "安全管理應用程式使用的簽名密鑰。",
    private_key: "OIDC 私鑰",
    private_keys_description: "OIDC 私鑰用於簽署 JWT 令牌。",
    cookie_key: "OIDC cookie 密鑰",
    cookie_keys_description: "OIDC cookie 密鑰用於簽署 cookie。",
    private_keys_in_use: "正在使用的私密金鑰",
    cookie_keys_in_use: "正在使用的 Cookie 金鑰",
    rotate_private_keys: "旋轉私密金鑰",
    rotate_cookie_keys: "旋轉 Cookie 金鑰",
    rotate_private_keys_description: "此操作將創建一個新的私密簽署金鑰，旋轉當前金鑰並刪除以前的金鑰。您的使用當前金鑰簽署的 JWT 標記將保持有效，直到刪除或再次旋轉。",
    rotate_cookie_keys_description: "此操作將創建一個新的 cookie 金鑰，旋轉當前金鑰並刪除以前的金鑰。使用當前金鑰簽署的 cookie 將保持有效，直到刪除或再次旋轉。",
    select_private_key_algorithm: "選擇新私密金鑰的簽署算法",
    rotate_button: "旋轉",
    table_column: {
        id: "ID",
        status: "狀態",
        algorithm: "簽署金鑰算法"
    },
    status: {
        current: "當前",
        previous: "之前"
    },
    reminder: {
        rotate_private_key: "您確定要旋轉<strong>OIDC私密金鑰</strong>嗎？使用新金鑰發放的 JWT 標記將由新金鑰簽署。使用當前金鑰簽署的 JWT 標記將保持有效，直到您再次旋轉。",
        rotate_cookie_key: "您確定要旋轉<strong>OIDC Cookie金鑰</strong>嗎？在登錄會話中生成的新 cookie 將由新cookie金鑰簽署。使用當前金鑰簽署的cookie將保持有效，直到您再次旋轉。",
        delete_private_key: "您確定要刪除<strong>OIDC私密金鑰</strong>嗎？使用此私密簽署金鑰簽署的現有 JWT 標記將不再有效。",
        delete_cookie_key: "您確定要刪除<strong>OIDC Cookie金鑰</strong>嗎？使用此cookie金鑰簽署的較舊的登錄會話中的cookie不再有效，這些用戶需要重新驗證。"
    },
    messages: {
        rotate_key_success: "簽署金鑰成功旋轉。",
        delete_key_success: "金鑰成功刪除。"
    }
};
var $d5e8e91726aa6778$export$2e2bcd8739ae039 = Object.freeze($d5e8e91726aa6778$var$signing_keys);


const $1022efc2f9102717$var$quota_item = {
    tenant_limit: {
        name: "租戶",
        limited: "{{count, number}} 個租戶",
        limited_other: "{{count, number}} 個租戶",
        unlimited: "無限租戶",
        not_eligible: "刪除您的租戶"
    },
    mau_limit: {
        name: "月活躍用戶",
        limited: "{{count, number}} 個月活躍用戶",
        unlimited: "無限月活躍用戶",
        not_eligible: "刪除您的所有用戶"
    },
    token_limit: {
        name: "令牌",
        limited: "{{count, number}} 個令牌",
        limited_other: "{{count, number}} 個令牌",
        unlimited: "無限令牌",
        not_eligible: "刪除您的所有用戶以防止新增令牌"
    },
    applications_limit: {
        name: "應用程式",
        limited: "{{count, number}} 個應用程式",
        limited_other: "{{count, number}} 個應用程式",
        unlimited: "無限應用程式",
        not_eligible: "刪除您的應用程式"
    },
    machine_to_machine_limit: {
        name: "機器對機器應用程式",
        limited: "{{count, number}} 個機器對機器應用程式",
        limited_other: "{{count, number}} 個機器對機器應用程式",
        unlimited: "無限機器對機器應用程式",
        not_eligible: "刪除您的機器對機器應用程式"
    },
    third_party_applications_limit: {
        name: "第三方應用程式",
        limited: "{{count, number}} 第三方應用程式",
        limited_other: "{{count, number}} 第三方應用程式",
        unlimited: "無限第三方應用程式",
        not_eligible: "刪除您的第三方應用程式"
    },
    resources_limit: {
        name: "API 資源",
        limited: "{{count, number}} 個 API 資源",
        limited_other: "{{count, number}} 個 API 資源",
        unlimited: "無限 API 資源",
        not_eligible: "刪除您的 API 資源"
    },
    scopes_per_resource_limit: {
        name: "資源範圍",
        limited: "{{count, number}} 個資源範圍",
        limited_other: "{{count, number}} 個資源範圍",
        unlimited: "無限資源範圍",
        not_eligible: "刪除您的資源範圍"
    },
    custom_domain_enabled: {
        name: "自定義域名",
        limited: "自定義域名",
        unlimited: "自定義域名",
        not_eligible: "刪除您的自定義域名"
    },
    omni_sign_in_enabled: {
        name: "統一登入",
        limited: "統一登入",
        unlimited: "統一登入",
        not_eligible: "停用統一登入"
    },
    built_in_email_connector_enabled: {
        name: "內建電子郵件連接器",
        limited: "內建電子郵件連接器",
        unlimited: "內建電子郵件連接器",
        not_eligible: "刪除您的內建電子郵件連接器"
    },
    social_connectors_limit: {
        name: "社交連接器",
        limited: "{{count, number}} 個社交連接器",
        limited_other: "{{count, number}} 個社交連接器",
        unlimited: "無限社交連接器",
        not_eligible: "刪除您的社交連接器"
    },
    standard_connectors_limit: {
        name: "標準連接器限量",
        limited: "{{count, number}} 個標準連接器",
        limited_other: "{{count, number}} 個標準連接器",
        unlimited: "無限標準連接器",
        not_eligible: "刪除您的標準連接器"
    },
    roles_limit: {
        name: "角色",
        limited: "{{count, number}} 個角色",
        limited_other: "{{count, number}} 個角色",
        unlimited: "無限角色",
        not_eligible: "刪除您的角色"
    },
    machine_to_machine_roles_limit: {
        name: "機器對機器角色",
        limited: "{{count, number}} 個機器對機器角色",
        limited_other: "{{count, number}} 個機器對機器角色",
        unlimited: "無限機器對機器角色",
        not_eligible: "刪除您的機器對機器角色"
    },
    scopes_per_role_limit: {
        name: "角色範圍",
        limited: "{{count, number}} 個角色範圍",
        limited_other: "{{count, number}} 個角色範圍",
        unlimited: "無限角色範圍",
        not_eligible: "刪除您的角色範圍"
    },
    hooks_limit: {
        name: "Webhooks",
        limited: "{{count, number}} 個 Webhook",
        limited_other: "{{count, number}} 個 Webhook",
        unlimited: "無限制的 Webhook",
        not_eligible: "移除您的 Webhook"
    },
    organizations_enabled: {
        name: "組織",
        limited: "組織",
        unlimited: "組織",
        not_eligible: "刪除您的組織"
    },
    audit_logs_retention_days: {
        name: "審計日誌保留",
        limited: "審計日誌保留：{{count, number}} 天",
        limited_other: "審計日誌保留：{{count, number}} 天",
        unlimited: "無限天數",
        not_eligible: "無審計日誌"
    },
    email_ticket_support: {
        name: "電子郵件票務支援",
        limited: "{{count, number}} 小時電子郵件票務支援",
        limited_other: "{{count, number}} 小時電子郵件票務支援",
        unlimited: "電子郵件票務支援",
        not_eligible: "無電子郵件票務支援"
    },
    mfa_enabled: {
        name: "多因素認證",
        limited: "多因素認證",
        unlimited: "多因素認證",
        not_eligible: "移除您的多因素認證"
    },
    sso_enabled: {
        name: "企業SSO",
        limited: "企業SSO",
        unlimited: "企業SSO",
        not_eligible: "移除您的企業單一登入"
    },
    tenant_members_limit: {
        name: "租戶成員",
        limited: "{{count, number}} 租戶成員",
        limited_other: "{{count, number}} 租戶成員",
        unlimited: "無限租戶成員",
        not_eligible: "刪除您的租戶成員"
    },
    custom_jwt_enabled: {
        name: "自定義JWT",
        limited: "自定義JWT",
        unlimited: "自定義JWT",
        not_eligible: "刪除您的JWT聲明自訂程式"
    }
};
var $1022efc2f9102717$export$2e2bcd8739ae039 = Object.freeze($1022efc2f9102717$var$quota_item);


const $65b107413304a0eb$var$quota_table = {
    quota: {
        title: "基本",
        base_price: "基本價格",
        mau_limit: "MAU 限制",
        included_tokens: "包含的令牌"
    },
    application: {
        title: "應用程式",
        total: "應用程式總數",
        m2m: "機器到機器",
        third_party: "第三方應用程式"
    },
    resource: {
        title: "API 資源",
        resource_count: "資源數量",
        scopes_per_resource: "每資源權限"
    },
    branding: {
        title: "用戶界面與品牌",
        custom_domain: "自訂網域",
        custom_css: "自訂 CSS",
        app_logo_and_favicon: "應用程式徽標和網站圖示",
        dark_mode: "深色模式",
        i18n: "國際化"
    },
    user_authn: {
        title: "用戶認證",
        omni_sign_in: "全渠道登錄",
        password: "密碼",
        passwordless: "免密碼登錄 - 電子郵件和短信",
        email_connector: "電子郵件連接器",
        sms_connector: "短信連接器",
        social_connectors: "社交連接器",
        standard_connectors: "標準連接器",
        built_in_email_connector: "內置電子郵件連接器",
        mfa: "多因素認證",
        sso: "企業 SSO",
        adaptive_mfa: "自適應MFA"
    },
    user_management: {
        title: "用戶管理",
        user_management: "用戶管理",
        roles: "角色",
        machine_to_machine_roles: "機器對機器角色",
        scopes_per_role: "每角色權限"
    },
    organizations: {
        title: "組織",
        organizations: "組織",
        organization: "組織",
        organization_count: "組織數量",
        allowed_users_per_org: "每組織的用戶數",
        invitation: "邀請（管理 API）",
        org_roles: "組織角色",
        org_permissions: "組織權限",
        just_in_time_provisioning: "即時規定"
    },
    support: {
        title: "合規和支援",
        community: "社群",
        customer_ticket: "客戶支援票據",
        premium: "高級版",
        email_ticket_support: "電子郵件票務支援",
        soc2_report: "SOC2報告",
        hipaa_or_baa_report: "HIPAA/BAA報告"
    },
    developers_and_platform: {
        title: "開發者和平台",
        hooks: "Webhooks",
        audit_logs_retention: "審計日誌保留",
        jwt_claims: "JWT聲明",
        tenant_members: "租戶成員"
    },
    unlimited: "無限制",
    contact: "聯絡",
    monthly_price: "${{value, number}} /月",
    days_one: "{{count, number}} 天",
    days_other: "{{count, number}} 天",
    add_on: "附加功能",
    tier: "層級{{value, number}}：",
    paid_token_limit_tip: "Logto將為超出您配額限制的功能收費。您可以在2024年第二季度左右開始收費之前免費使用它。如果您需要更多的令牌，請與我們聯繫。默認情況下，我們每月為每百萬令牌收費80美元。",
    paid_quota_limit_tip: "Logto將為超出配額限制的功能添加費用。在我們從2024年第二季度開始收費之前，您可以免費使用它。",
    paid_add_on_feature_tip: "這是一個附加功能。在我們從2024年第二季度開始收費之前，您可以免費使用它。",
    million: "{{value, number}} 百萬",
    mau_tip: "MAU（每月活躍用戶）是指在計費週期內與Logto交換過至少一個令牌的獨立用戶數量。",
    tokens_tip: "Logto 發行的所有類型令牌，包括訪問令牌、刷新令牌等。",
    mao_tip: "MAO（月度活躍組織）指的是在計費週期內至少有一個MAU（月度活躍用戶）的獨特組織數量。",
    third_party_tip: "使用Logto作為您的OIDC身份提供者，用於第三方應用程式的登錄和權限授予。",
    included: "已包含 {{value, number}}",
    included_mao: "已包含 {{value, number}} MAO",
    extra_quota_price: "然後每月 ${{value, number}} / 每個之後",
    per_month_each: "每月 ${{value, number}} / 每個",
    extra_mao_price: "然後每 MAO ${{value, number}}",
    per_month: "每月 ${{value, number}}",
    per_member: "然後 ${{value, number}} 每個成員"
};
var $65b107413304a0eb$export$2e2bcd8739ae039 = Object.freeze($65b107413304a0eb$var$quota_table);


const $2d1f1e776a9e940e$var$subscription = {
    free_plan: "免費計劃",
    free_plan_description: "用於側建項目和Logto初試。無需信用卡。",
    pro_plan: "專業計劃",
    pro_plan_description: "供企業放心使用Logto。",
    enterprise: "企業",
    current_plan: "當前計劃",
    current_plan_description: "以下是您目前的計劃。您可以輕鬆查看計劃使用情況，檢查即將到來的帳單，並根據需要進行變更。",
    plan_usage: "計劃使用情況",
    plan_cycle: "計劃週期：{{period}}。使用情況將在{{renewDate}}重新啟動。",
    next_bill: "您的下個帳單",
    next_bill_hint: "要了解有關計算的更多信息，請參閱這篇<a>文章</a>。",
    next_bill_tip: "這裡顯示的價格不包括稅款。稅款將根據您提供的信息和當地法規要求進行計算，並顯示在您的發票中。",
    manage_payment: "管理付款",
    overfill_quota_warning: "您已達到配額限制。請升級計劃以防止任何問題。",
    upgrade_pro: "升級到專業版",
    update_payment: "更新付款信息",
    payment_error: "檢測到付款問題。無法處理前一個週期的$ {{price, number}}。更新付款以避免Logto服務暫停。",
    downgrade: "降級",
    current: "當前",
    upgrade: "升級",
    quota_table: $65b107413304a0eb$export$2e2bcd8739ae039,
    billing_history: {
        invoice_column: "發票",
        status_column: "狀態",
        amount_column: "金額",
        invoice_created_date_column: "發票創建日期",
        invoice_status: {
            void: "已取消",
            paid: "已付款",
            open: "未結算",
            uncollectible: "逾期未付款"
        }
    },
    quota_item: $1022efc2f9102717$export$2e2bcd8739ae039,
    downgrade_modal: {
        title: "確定要降級嗎？",
        description: "如果您選擇切換到<targetName/>，請注意您將不再能夠訪問以前在<currentName/>中的配額和功能。",
        before: "之前：<name/>",
        after: "之後：<name/>",
        downgrade: "降級"
    },
    not_eligible_modal: {
        downgrade_title: "您不符合降級條件",
        downgrade_description: "降級到<name/>前，請確保符合以下條件。",
        downgrade_help_tip: "需要降級幫助？<a>聯絡我們</a>。",
        upgrade_title: "致尊敬的早期採用者的友善提醒",
        upgrade_description: "您目前的使用量超過了 <name /> 允許的範圍。Logto 現已正式發布，包括針對每個計劃量身定制的功能。在考慮升級到 <name /> 之前，請確保您符合以下升級條件。",
        upgrade_pro_tip: " 或者考慮升級到專業版計劃。",
        upgrade_help_tip: "需要升級幫助？<a>聯絡我們</a>。",
        a_maximum_of: "最多<item/>"
    },
    upgrade_success: "升級成功至<name/>",
    downgrade_success: "成功降級至<name/>",
    subscription_check_timeout: "訂閱檢查已逾時，請稍後重新刷新。",
    no_subscription: "沒有訂閱"
};
var $2d1f1e776a9e940e$export$2e2bcd8739ae039 = Object.freeze($2d1f1e776a9e940e$var$subscription);


const $08de68b3ed207785$var$tab_sections = {
    overview: "概覽",
    authentication: "身份驗證",
    authorization: "授權",
    users: "用戶",
    developer: "開發者",
    tenant: "租戶"
};
var $08de68b3ed207785$export$2e2bcd8739ae039 = Object.freeze($08de68b3ed207785$var$tab_sections);


const $8aceacbea3fddeff$var$tabs = {
    get_started: "開始上手",
    dashboard: "儀表板",
    applications: "全部應用",
    api_resources: "API 資源",
    sign_in_experience: "登錄體驗",
    connectors: "連接器",
    enterprise_sso: "企業SSO",
    webhooks: "Webhooks",
    organizations: "組織",
    users: "用戶管理",
    audit_logs: "審計日誌",
    roles: "角色",
    docs: "文檔",
    tenant_settings: "租戶設置",
    mfa: "多重認證",
    customize_jwt: "自定義 JWT",
    signing_keys: "簽署密鑰",
    organization_template: "組織模板"
};
var $8aceacbea3fddeff$export$2e2bcd8739ae039 = Object.freeze($8aceacbea3fddeff$var$tabs);


const $eed682ab5365bf01$var$tenant_members = {
    members: "成員",
    invitations: "邀請",
    invite_members: "邀請成員",
    user: "用戶",
    roles: "角色",
    admin: "管理員",
    collaborator: "協作者",
    invitation_status: "邀請狀態",
    inviter: "邀請者",
    expiration_date: "到期日期",
    invite_modal: {
        title: "邀請加入 Logto Cloud",
        subtitle: "要邀請組織成員，他們必須接受邀請。",
        to: "到",
        added_as: "被添加為角色",
        email_input_placeholder: "johndoe@example.com"
    },
    invitation_statuses: {
        pending: "待定",
        accepted: "已接受",
        expired: "已過期",
        revoked: "已撤銷"
    },
    invitation_empty_placeholder: {
        title: "邀請團隊成員",
        description: "您的租戶目前沒有被邀請的成員。\n為了協助您的整合，請考慮添加更多成員或管理員。"
    },
    menu_options: {
        edit: "編輯租戶角色",
        delete: "從租戶中移除用戶",
        resend_invite: "重新發送邀請",
        revoke: "撤銷邀請",
        delete_invitation_record: "刪除此邀請記錄"
    },
    edit_modal: {
        title: "更改 {{name}} 的角色"
    },
    delete_user_confirm: "您確定要從此租戶中刪除此用戶嗎？",
    assign_admin_confirm: "您確定要將所選用戶設為管理員嗎？授予管理員訪問權限將賦予用戶如下權限。<ul><li>更改租戶計費計劃</li><li>添加或移除協作者</li><li>刪除租戶</li></ul>",
    revoke_invitation_confirm: "您確定要撤銷此邀請嗎？",
    delete_invitation_confirm: "您確定要刪除此邀請記錄嗎？",
    messages: {
        invitation_sent: "已發送邀請。",
        invitation_revoked: "邀請已撤銷。",
        invitation_resend: "邀請已重新發送。",
        invitation_deleted: "邀請記錄已刪除。"
    },
    errors: {
        email_required: "需要邀請者的電子郵件。",
        email_exists: "電子郵件地址已經存在。",
        member_exists: "此用戶已經是此組織的成員。",
        pending_invitation_exists: "存在待定的邀請。請刪除相關郵件或撤銷邀請。",
        invalid_email: "電子郵件地址無效。請確保其格式正確。",
        max_member_limit: "您已達到此租戶的最大成員數量（{{limit}}）。"
    }
};
var $eed682ab5365bf01$export$2e2bcd8739ae039 = Object.freeze($eed682ab5365bf01$var$tenant_members);


const $e595ff2d5087715b$var$tenants = {
    title: "設置",
    description: "高效管理租戶設置並自訂您的域名。",
    tabs: {
        settings: "設定",
        members: "成員",
        domains: "網域",
        subscription: "方案與計費",
        billing_history: "帳單記錄"
    },
    settings: {
        title: "設定",
        description: "設置租戶名稱並查看您的數據托管區域和租戶類型。",
        tenant_id: "租戶ID",
        tenant_name: "租戶名稱",
        tenant_region: "數據托管區域",
        tenant_region_tip: "您的租戶資源托管在{{region}}。 <a>了解更多</a>",
        environment_tag_development: "開發",
        environment_tag_production: "生產",
        tenant_type: "租戶類型",
        development_description: "僅供測試使用，不應在生產中使用。無需訂閱。它具有所有專業功能，但存在限制，例如登錄橫幅。<a>了解更多</a>",
        production_description: "用於最終用戶使用並可能需要付費訂閱。<a>了解更多</a>",
        tenant_info_saved: "租戶信息成功保存。"
    },
    full_env_tag: {
        development: "開發",
        production: "生產"
    },
    deletion_card: {
        title: "刪除",
        tenant_deletion: "刪除租戶",
        tenant_deletion_description: "刪除租戶將導致永久刪除所有相關的用戶數據和配置。請謹慎操作。",
        tenant_deletion_button: "刪除租戶"
    },
    leave_tenant_card: {
        title: "離開",
        leave_tenant: "離開租戶",
        leave_tenant_description: "租戶內的任何資源將保留，但您將無法再訪問此租戶。",
        last_admin_note: "要離開此租戶，請確保至少還有一個成員具有管理員角色。"
    },
    create_modal: {
        title: "創建租戶",
        tenant_usage_purpose: "您希望使用此租戶做什麼？",
        development_description: "僅供測試使用，不應在生產中使用。無需訂閱。",
        development_hint: "它具有所有專業功能，但存在限制，例如登錄橫幅。",
        production_description: "用於最終用戶使用並可能需要付費訂閱。",
        available_plan: "可用方案：",
        create_button: "創建租戶",
        tenant_name_placeholder: "我的租戶"
    },
    dev_tenant_migration: {
        title: "現在，您可以通過創建新的“開發租戶”免費試用我們的專業功能！",
        affect_title: "這對您有什麼影響？",
        hint_1: "我們正在將舊的<strong>環境標籤</strong>替換為兩種新的租戶類型：<strong>“開發”</strong>和<strong>“生產”</strong>。",
        hint_2: "為確保平滑過渡和功能不中斷，所有早期創建的租戶將晉升為<strong>生產</strong>租戶類型，您的以前的訂閱也將保留。",
        hint_3: "別擔心，您的其他設置將保持不變。",
        about_tenant_type: "關於租戶類型"
    },
    delete_modal: {
        title: "刪除租戶",
        description_line1: "您確定要刪除您的租戶“<span>{{name}}</span>”和環境後綴標記“<span>{{tag}}</span>” 嗎？此操作無法撤銷，將永久刪除所有您的數據和租戶信息。",
        description_line2: "在刪除租戶之前，也許我們可以幫助您。<span><a>通過電子郵件與我們聯繫</a></span>",
        description_line3: "如果您確定要繼續，請輸入租戶名“<span>{{name}}</span>” 以進行確認。",
        delete_button: "永久刪除",
        cannot_delete_title: "無法刪除此租戶",
        cannot_delete_description: "抱歉，您現在無法刪除此租戶。請確保您處於免費計劃並已支付所有未結賬單。"
    },
    leave_tenant_modal: {
        description: "您確定要離開此租戶？",
        leave_button: "離開"
    },
    tenant_landing_page: {
        title: "您尚未建立租戶",
        description: "要開始使用 Logto 配置您的項目，請創建一個新的租戶。如果您需要退出或刪除您的帳戶，只需單擊右上角的頭像按鈕。",
        create_tenant_button: "創建租戶"
    },
    status: {
        mau_exceeded: "超出 MAU 限制",
        suspended: "已暫停",
        overdue: "逾期未付款"
    },
    tenant_suspended_page: {
        title: "租戶已暫停。請聯繫我們恢復訪問。",
        description_1: "很遺憾地通知您，由於不當使用（包括超出 MAU 限制、逾期付款或其他未經授權的操作等），您的租戶帳戶已被暫時停用。",
        description_2: "如果您需要進一步了解，有任何疑慮或希望恢復完整功能並解鎖您的租戶，請立即與我們聯繫。"
    }
};
var $e595ff2d5087715b$export$2e2bcd8739ae039 = Object.freeze($e595ff2d5087715b$var$tenants);


const $29e0684583eeebd6$var$topbar = {
    docs: "文件",
    help: "幫助"
};
var $29e0684583eeebd6$export$2e2bcd8739ae039 = Object.freeze($29e0684583eeebd6$var$topbar);


const $d5be6a1c338b6a40$var$featured_plan_content = {
    mau: {
        free_plan: "最多{{count, number}} MAU",
        pro_plan: "無限 MAU"
    },
    m2m: {
        free_plan: "{{count, number}} 機器對機器",
        pro_plan: "額外的機器對機器"
    },
    third_party_apps: "第三方應用的 IdP",
    mfa: "多因素認證",
    sso: "企業單點登錄",
    role_and_permissions: {
        free_plan: "{{roleCount, number}} 角色和每個角色 {{permissionCount, number}} 權限",
        pro_plan: "無限角色和每個角色權限"
    },
    organizations: "組織",
    audit_logs: "審計日誌保留：{{count, number}} 天"
};
var $d5be6a1c338b6a40$export$2e2bcd8739ae039 = Object.freeze($d5be6a1c338b6a40$var$featured_plan_content);


const $281f6415b81755ec$var$paywall = {
    applications: "已達到 <planName/> 的{{count, number}}個應用程式限制。升級計劃以滿足團隊需求。如需任何協助，歡迎<a>聯絡我們</a>。",
    applications_other: "已達到 <planName/> 的{{count, number}}個應用程式限制。升級計劃以滿足團隊需求。如需任何協助，歡迎<a>聯絡我們</a>。",
    machine_to_machine_feature: "升級至<strong>Pro</strong>方案，以獲取額外的機器對機器應用程式和享受所有高級功能。如有疑問，請<a>聯繫我們</a>。",
    machine_to_machine: "已達到 <planName/> 的{{count, number}}個機器對機器應用程式限制。升級計劃以滿足團隊需求。如需任何協助，歡迎<a>聯絡我們</a>。",
    machine_to_machine_other: "已達到 <planName/> 的{{count, number}}個機器對機器應用程式限制。升級計劃以滿足團隊需求。如需任何協助，歡迎<a>聯絡我們</a>。",
    resources: "已達到<planName/>的{{count, number}}個 API 資源限制。升級計劃以滿足您團隊的需求。<a>聯繫我們</a>尋求幫助。",
    resources_other: "已達到<planName/>的{{count, number}}個 API 資源限制。升級計劃以滿足您團隊的需求。<a>聯繫我們</a>尋求幫助。",
    scopes_per_resource: "已達到<planName/>的{{count, number}}個 API 資源每個權限限制。立即升級以擴展。如需任何幫助，請<a>聯繫我們</a>。",
    scopes_per_resource_other: "已達到<planName/>的{{count, number}}個 API 資源每個權限限制。立即升級以擴展。如需任何幫助，請<a>聯繫我們</a>。",
    custom_domain: "升級至<strong>Hobby</strong>或<strong>Pro</strong>方案以解鎖自定義域功能。如需要任何協助，歡迎<a>聯絡我們</a>。",
    social_connectors: "已達到<planName/>的{{count, number}}個社交連接器限制。為滿足您團隊的需求，請升級計劃以獲取額外的社交連接器，並可以使用 OIDC、OAuth 2.0 和 SAML 協議創建您自己的連接器。如需任何幫助，請<a>聯繫我們</a>。",
    social_connectors_other: "已達到<planName/>的{{count, number}}個社交連接器限制。為滿足您團隊的需求，請升級計劃以獲取額外的社交連接器，並可以使用 OIDC、OAuth 2.0 和 SAML 協議創建您自己的連接器。如需任何幫助，請<a>聯繫我們</a>。",
    standard_connectors_feature: "升級至<strong>Hobby</strong>或<strong>Pro</strong>計劃，使用 OIDC、OAuth 2.0 和 SAML 協議創建您自己的連接器，無限制的社交連接器以及所有高級功能。如需任何協助，歡迎<a>聯絡我們</a>。",
    standard_connectors: "已達到<planName/>的{{count, number}}個社交連接器限制。為滿足您團隊的需求，請升級計劃以獲取額外的社交連接器，並可以使用 OIDC、OAuth 2.0 和 SAML 協議創建您自己的連接器。如需任何協助，請<a>聯絡我們</a>。",
    standard_connectors_other: "已達到<planName/>的{{count, number}}個社交連接器限制。為滿足您團隊的需求，請升級計劃以獲取額外的社交連接器，並可以使用 OIDC、OAuth 2.0 和 SAML 協議創建您自己的連接器。如需任何協助，請<a>聯繫我們</a>。",
    standard_connectors_pro: "已達到<planName/>的{{count, number}}個標準連接器限制。為滿足您團隊的需求，請升級至企業版計劃以獲取額外的社交連接器，並可以使用 OIDC、OAuth 2.0 和 SAML 協議創建您自己的連接器。如需任何協助，歡迎<a>聯絡我們</a>。",
    standard_connectors_pro_other: "已達到<planName/>的{{count, number}}個標準連接器限制。為滿足您團隊的需求，請升級至企業版計劃以獲取額外的社交連接器，並可以使用 OIDC、OAuth 2.0 和 SAML 協議創建您自己的連接器。如需任何協助，歡迎<a>聯繫我們</a>。",
    roles: "已達到<planName/>的{{count, number}}個角色限制。升級計劃以添加額外的角色和權限。如需任何協助，歡迎<a>聯絡我們</a>。",
    roles_other: "已達到<planName/>的{{count, number}}個角色限制。升級計劃以添加額外的角色和權限。如需任何協助，歡迎<a>聯絡我們</a>。",
    machine_to_machine_roles: "{{count, number}}個機器對機器角色達到了<planName/>的限制。升級計劃以添加額外的角色和權限。如需要任何協助，請隨時<a>聯絡我們</a>。",
    machine_to_machine_roles_other: "{{count, number}}個機器對機器角色達到了<planName/>的限制。升級計劃以添加額外的角色和權限。如需要任何協助，請隨時<a>聯絡我們</a>。",
    scopes_per_role: "已達到<planName/>的{{count, number}}個角色每個權限限制。升級計劃以添加額外的角色和權限。如需任何協助，歡迎<a>聯絡我們</a>。",
    scopes_per_role_other: "已達到<planName/>的{{count, number}}個角色每個權限限制。升級計劃以添加額外的角色和權限。如需任何協助，歡迎<a>聯絡我們</a>。",
    hooks: "已達到<planName/>的{{count, number}}個 Webhook 限制。升級計劃以創建更多 Webhook。如需任何協助，歡迎<a>聯絡我們</a>。",
    hooks_other: "已達到<planName/>的{{count, number}}個 Webhook 限制。升級計劃以創建更多 Webhook。如需任何幫助，請<a>聯絡我們</a>。",
    mfa: "升級到付費計劃以解鎖MFA以提高安全性。如果需要任何協助，請隨時<a>聯絡我們</a>。",
    organizations: "升級至付費計劃以解鎖組織。如需要任何協助，請隨時<a>聯絡我們</a>。",
    third_party_apps: "藉由升級至付費計劃，將 Logto 解鎖為第三方應用程式的 IdP。如需任何協助，歡迎<a>聯絡我們</a>。",
    sso_connectors: "升級至付費計劃以解鎖企業單一登錄（SSO）。如需要任何協助，歡迎<a>聯絡我們</a>。",
    tenant_members: "透過升級至付費計劃，解鎖協作功能。如需要任何協助，歡迎<a>聯絡我們</a>。",
    tenant_members_dev_plan: "您已達到 {{limit}} 的成員限制。釋放一位成員或撤回待定邀請以新增新成員。需要更多席位？歡迎隨時聯絡我們。",
    custom_jwt: {
        title: "新增自訂聲索",
        description: "升級至付費計劃以獲得自訂 JWT 功能和專業服務。如有任何問題，歡迎隨時<a>聯絡我們</a>。"
    }
};
var $281f6415b81755ec$export$2e2bcd8739ae039 = Object.freeze($281f6415b81755ec$var$paywall);


const $1c93bb051f46b3a5$var$upsell = {
    upgrade_plan: "升級計劃",
    compare_plans: "比較計劃",
    view_plans: "查看計劃",
    create_tenant: {
        title: "選擇您的租戶計劃",
        description: "Logto 提供創新且經濟實惠的定價計劃，旨在為不斷發展的公司提供競爭優勢。 <a>了解更多</a>",
        base_price: "基礎價格",
        monthly_price: "每月 {{value, number}}",
        view_all_features: "查看所有功能",
        select_plan: "選擇<name/>",
        free_tenants_limit: "最多{{count, number}}個免費租戶",
        free_tenants_limit_other: "最多{{count, number}}個免費租戶",
        most_popular: "最受歡迎",
        upgrade_success: "成功升級至<name/>"
    },
    mau_exceeded_modal: {
        title: "MAU 超出限制，請升級您的計劃。",
        notification: "您當前的 MAU 已超過<planName/>的限制。請立即升級到高級計劃，以避免 Logto 服務的暫停。",
        update_plan: "更新計劃"
    },
    payment_overdue_modal: {
        title: "賬單逾期未付",
        notification: "糟糕！租戶<span>{{name}}</span>的賬單支付失敗。請儘快支付賬單，以避免Logto服務中止。",
        unpaid_bills: "未付賬單",
        update_payment: "更新支付"
    },
    add_on_quota_item: {
        api_resource: "API 資源",
        machine_to_machine: "機器對機器應用",
        tokens: "{{limit}}M 令牌",
        tenant_member: "租戶成員"
    },
    charge_notification_for_quota_limit: "您已超出{{item}}配額限制。Logto將為超出配額限制的使用添加費用。計費將從新的附加定價設計發布當天開始。 <a>了解更多</a>",
    paywall: $281f6415b81755ec$export$2e2bcd8739ae039,
    featured_plan_content: $d5be6a1c338b6a40$export$2e2bcd8739ae039
};
var $1c93bb051f46b3a5$export$2e2bcd8739ae039 = Object.freeze($1c93bb051f46b3a5$var$upsell);


const $8354c4ca2c07a07f$var$user_details = {
    page_title: "用戶詳情",
    back_to_users: "返回用戶管理",
    created_title: "用戶創建成功",
    created_guide: "這是用戶登錄過程中的信息。",
    created_email: "電子郵箱地址：",
    created_phone: "手機號碼：",
    created_username: "用戶名：",
    created_password: "密碼：",
    menu_delete: "刪除用戶",
    delete_description: "本操作將永久刪除該用戶，且無法撤銷。",
    deleted: "用戶已成功刪除。",
    reset_password: {
        reset_password: "重置密碼",
        title: "確定要重置密碼？",
        content: "本操作不可撤銷，將會重置用戶的登錄信息。",
        congratulations: "該用戶已被重置",
        new_password: "新密碼："
    },
    tab_settings: "設置",
    tab_roles: "角色",
    tab_logs: "用戶日誌",
    tab_organizations: "組織",
    authentication: "驗證",
    authentication_description: "每個用戶都有一個包含所有用戶信息的個人資料。它由基本數據、社交身份和自定義數據組成。",
    user_profile: "用戶資料",
    field_email: "電子郵箱",
    field_phone: "手機號碼",
    field_username: "用戶名",
    field_name: "姓名",
    field_avatar: "頭像圖片鏈接",
    field_avatar_placeholder: "https://your.cdn.domain/avatar.png",
    field_custom_data: "自定義數據",
    field_custom_data_tip: "預設屬性之外的用戶信息，例如用戶偏好的顏色和語言。",
    field_connectors: "社交帳號",
    field_sso_connectors: "企業連接",
    custom_data_invalid: "自定義數據必須是有效的 JSON 對象",
    connectors: {
        connectors: "連接器",
        user_id: "用戶 ID",
        remove: "刪除",
        connected: "此用戶已連接多個社交連接器。",
        not_connected: "該用戶還沒有綁定社交帳號",
        deletion_confirmation: "您正在刪除現有的<name/>身份。你確定要繼續嗎？"
    },
    sso_connectors: {
        connectors: "連接器",
        enterprise_id: "企業 ID",
        connected: "此用戶已連接到多個企業身份提供者以進行單點登錄。",
        not_connected: "該用戶未連接到任何企業身份提供者以進行單點登錄。"
    },
    mfa: {
        field_name: "多重因素驗證",
        field_description: "這個使用者已啟用 2 步驗證因素。",
        name_column: "多重因素驗證",
        field_description_empty: "此用戶尚未啟用兩步驟身份驗證因素。",
        deletion_confirmation: "您正在刪除現有的雙步驗證中的 <name/>。你確定要繼續嗎？"
    },
    suspended: "已禁用",
    suspend_user: "禁用用戶",
    suspend_user_reminder: "你確定要禁用該用戶？該用戶將無法登錄您的應用程序，並在當前令牌過期後將無法獲取新的訪問令牌。此外，該用戶發出的任何 API 請求都將失敗。",
    suspend_action: "禁用",
    user_suspended: "用戶已被臨時禁用。",
    reactivate_user: "重新啟用用戶",
    reactivate_user_reminder: "你確定要重新啟用該用戶？這樣做將允許該用戶的任何登錄嘗試。",
    reactivate_action: "重新啟用",
    user_reactivated: "用戶已重新啟用。",
    roles: {
        name_column: "角色名稱",
        description_column: "描述",
        assign_button: "分配角色",
        delete_description: "此操作將從此用戶中刪除此角色。角色本身仍將存在，但不再與此用戶相關聯。",
        deleted: "已成功從此用戶中刪除 {{name}}。",
        assign_title: "將角色分配給 {{name}}",
        assign_subtitle: "為 {{name}} 授權一個或多個角色",
        assign_role_field: "分配角色",
        role_search_placeholder: "按角色名稱搜索",
        added_text: "添加了 {{value, number}} 個",
        assigned_user_count: "{{value, number}} 個用戶",
        confirm_assign: "分配角色",
        role_assigned: "已成功分配角色",
        search: "按角色名稱、描述或 ID 搜索",
        empty: "無可用角色"
    },
    warning_no_sign_in_identifier: "用戶需要至少擁有一個登錄標識（用戶名、電子郵件、電話號碼或社交帳號）才能登錄。確定要繼續嗎？",
    organization_roles_tooltip: "The roles assigned to the user within this organization."
};
var $8354c4ca2c07a07f$export$2e2bcd8739ae039 = Object.freeze($8354c4ca2c07a07f$var$user_details);


const $bdc1bec4acb14643$var$users = {
    page_title: "用戶管理",
    title: "用戶管理",
    subtitle: "管理你的用戶，包括創建新用戶，編輯用戶資料，查看用戶日誌，以及重新設置密碼和刪除用戶",
    create: "添加用戶",
    create_subtitle: "至少提供以下其中一個字段以繼續進行。",
    error_missing_identifier: "你必須提供至少一個註冊標識來創建用戶。",
    user_name: "用戶",
    application_name: "註冊應用",
    latest_sign_in: "最後登錄",
    create_form_username: "用戶名",
    create_form_password: "密碼",
    create_form_name: "姓名",
    placeholder_name: "無名氏",
    placeholder_email: "moumingsi@example.com",
    placeholder_username: "user123",
    placeholder_phone: "+852 9123 4567",
    unnamed: "未命名",
    search: "按姓名、電子郵件、電話或用戶名搜索",
    check_user_detail: "查看用戶詳情",
    placeholder_title: "用戶管理",
    placeholder_description: "每個用戶都有一個包含所有用戶信息的個人資料。它由基本數據、社交身份和自定義數據組成。"
};
var $bdc1bec4acb14643$export$2e2bcd8739ae039 = Object.freeze($bdc1bec4acb14643$var$users);


const $9e62b2fe76256923$var$webhook_details = {
    page_title: "Webhook 詳細資料",
    back_to_webhooks: "返回 Webhooks",
    not_in_use: "未啟用",
    success_rate: "成功率",
    requests: "24 小時內收到 {{value, number}} 個請求",
    disable_webhook: "停用 webhook",
    disable_reminder: "確定要重新啟用此 webhook？重新啟用後，不會對端點 URL 發送 HTTP 請求。",
    webhook_disabled: "Webhook 已停用。",
    webhook_reactivated: "Webhook 已重新啟用。",
    reactivate_webhook: "重新啟用 webhook",
    delete_webhook: "刪除 webhook",
    deletion_reminder: "您正在刪除此 webhook。刪除後，不會對端點 URL 發送 HTTP 請求。",
    deleted: "Webhook 已成功刪除。",
    settings_tab: "設置",
    recent_requests_tab: "最新請求（24h）",
    settings: {
        settings: "設置",
        settings_description: "Webhooks 允許您即時接收特定事件的更新，通過將 POST 請求發送到您的端點 URL。這使您能夠根據收到的新信息立即採取行動。",
        events: "事件",
        events_description: "選擇 Logto 將發送 POST 請求的觸發事件。",
        name: "名稱",
        endpoint_url: "端點 URL",
        signing_key: "簽名密鑰",
        signing_key_tip: "添加 Logto 提供的秘密金鑰作為請求標題至您的端點，以確保 webhook 負載的真實性。",
        regenerate: "重新生成",
        regenerate_key_title: "重新生成簽名密鑰",
        regenerate_key_reminder: "是否確定要修改簽名密鑰？重新生成後立即生效。請記得同步在端點中修改簽名密鑰。",
        regenerated: "簽名密鑰已重新生成。",
        custom_headers: "自定義標頭",
        custom_headers_tip: "您可以選擇添加自定義標頭到 webhook 的負載，提供有關事件的更多上下文或元數據。",
        key_duplicated_error: "Key 不能重複。",
        key_missing_error: "必須填寫 Key。",
        value_missing_error: "未填寫值。",
        invalid_key_error: "Key 無效",
        invalid_value_error: "值無效",
        test: "測試",
        test_webhook: "測試您的 webhook",
        test_webhook_description: "配置 webhook，並使用每個選定事件的負載示例進行測試，以驗證正確接收和處理。",
        send_test_payload: "發送測試負載",
        test_result: {
            endpoint_url: "端點URL：{{url}}",
            message: "消息：{{message}}",
            response_status: "響應狀態：{{status, number}}",
            response_body: "響應主體：{{body}}",
            request_time: "請求時間：{{time}}",
            test_success: "向端點發起的 webhook 測試成功。"
        }
    }
};
var $9e62b2fe76256923$export$2e2bcd8739ae039 = Object.freeze($9e62b2fe76256923$var$webhook_details);


const $95220b6bfcd14a3e$var$webhooks = {
    page_title: "Webhooks",
    title: "Webhooks",
    subtitle: "創建 Webhooks，輕鬆地接收有關特定事件的實時更新。",
    create: "創建 Webhook",
    schemas: {
        interaction: "用戶互動",
        user: "用戶",
        organization: "組織",
        role: "角色",
        scope: "權限",
        organization_role: "組織角色",
        organization_scope: "組織權限"
    },
    table: {
        name: "名稱",
        events: "事件",
        success_rate: "成功率（24h）",
        requests: "請求（24h）"
    },
    placeholder: {
        title: "Webhook",
        description: "創建 Webhook 以通過 POST 請求向您的端點 URL 接收實時更新。了解詳情並針對“創建帳戶”、“登錄”和“重置密碼”等事件立即採取行動。",
        create_webhook: "創建 Webhook"
    },
    create_form: {
        title: "創建 Webhook",
        subtitle: "添加 Webhook 以向 endpoint URL 發送 POST 請求，將詳細信息推送到任何用戶事件。",
        events: "事件",
        events_description: "選擇需要 Logto 發送 POST 請求的觸發事件。",
        name: "名稱",
        name_placeholder: "輸入 webhook 名稱",
        endpoint_url: "Endpoint URL",
        endpoint_url_placeholder: "https://your.webhook.endpoint.url",
        endpoint_url_tip: "輸入您的端點 URL，當事件發生時向其發送 Webhook 的有效負載。",
        create_webhook: "創建 Webhook",
        missing_event_error: "您必須至少選擇一個事件。"
    },
    webhook_created: "Webhook {{name}} 成功創建。"
};
var $95220b6bfcd14a3e$export$2e2bcd8739ae039 = Object.freeze($95220b6bfcd14a3e$var$webhooks);


const $3bb0522e3aa3b0c0$var$welcome = {
    title: "歡迎來到管理控制台",
    description: "管理控制台是一個無需代碼操作的應用。你可以用它來管理登錄體驗。讓我們首先創建一個帳號。你可以用它以個人或公司的身份管理 Logto。",
    create_account: "創建帳號"
};
var $3bb0522e3aa3b0c0$export$2e2bcd8739ae039 = Object.freeze($3bb0522e3aa3b0c0$var$welcome);


const $1206382da4f74fd4$var$admin_console = {
    title: "管理控制台",
    admin_user: "管理員",
    system_app: "系統應用",
    menu: $0e67359395531835$export$2e2bcd8739ae039,
    general: $88a222d09dbb19ad$export$2e2bcd8739ae039,
    errors: $b467a2153f0be437$export$2e2bcd8739ae039,
    tab_sections: $08de68b3ed207785$export$2e2bcd8739ae039,
    tabs: $8aceacbea3fddeff$export$2e2bcd8739ae039,
    applications: $da9aa0c64e2a327b$export$2e2bcd8739ae039,
    application_details: $b98fd4f61936c8fb$export$2e2bcd8739ae039,
    api_resources: $be682ae4597e2fa5$export$2e2bcd8739ae039,
    api_resource_details: $090ca0b8d4490cce$export$2e2bcd8739ae039,
    connectors: $f4535a3f3b4caee5$export$2e2bcd8739ae039,
    connector_details: $cdd326ba357e40f2$export$2e2bcd8739ae039,
    enterprise_sso: $e1b7cd172ad1f73d$export$2e2bcd8739ae039,
    enterprise_sso_details: $c6fbcea9de7823bb$export$2e2bcd8739ae039,
    get_started: $bf53312e972d3730$export$2e2bcd8739ae039,
    users: $bdc1bec4acb14643$export$2e2bcd8739ae039,
    user_details: $8354c4ca2c07a07f$export$2e2bcd8739ae039,
    contact: $abf52697d8011a9c$export$2e2bcd8739ae039,
    sign_in_exp: $142335f0ca735549$export$2e2bcd8739ae039,
    dashboard: $33c72ba49c7cf396$export$2e2bcd8739ae039,
    logs: $455f16fc6aa7fe59$export$2e2bcd8739ae039,
    log_details: $33ccb2b30b51404f$export$2e2bcd8739ae039,
    session_expired: $92ec031578c6d0df$export$2e2bcd8739ae039,
    welcome: $3bb0522e3aa3b0c0$export$2e2bcd8739ae039,
    roles: $a279d2a8f2da70b0$export$2e2bcd8739ae039,
    role_details: $640f7e501c5093f7$export$2e2bcd8739ae039,
    permissions: $5c7b52ca1b13206f$export$2e2bcd8739ae039,
    cloud: $d2bfd3397c147b9c$export$2e2bcd8739ae039,
    profile: $f0bb1f321aadd9bf$export$2e2bcd8739ae039,
    components: $127555e2e87bf8c3$export$2e2bcd8739ae039,
    webhooks: $95220b6bfcd14a3e$export$2e2bcd8739ae039,
    webhook_details: $9e62b2fe76256923$export$2e2bcd8739ae039,
    domain: $315b3156051368a1$export$2e2bcd8739ae039,
    tenants: $e595ff2d5087715b$export$2e2bcd8739ae039,
    tenant_members: $eed682ab5365bf01$export$2e2bcd8739ae039,
    topbar: $29e0684583eeebd6$export$2e2bcd8739ae039,
    subscription: $2d1f1e776a9e940e$export$2e2bcd8739ae039,
    upsell: $1c93bb051f46b3a5$export$2e2bcd8739ae039,
    guide: $da8f2160c1a2435f$export$2e2bcd8739ae039,
    mfa: $b4ab6b3fb34b00c6$export$2e2bcd8739ae039,
    organizations: $909bb62a85fa0376$export$2e2bcd8739ae039,
    organization_details: $aec4f9b1d68ad9f1$export$2e2bcd8739ae039,
    protected_app: $5c080427b454bf4a$export$2e2bcd8739ae039,
    jwt_claims: $a57dcdc48554d048$export$2e2bcd8739ae039,
    invitation: $c8381dc327f13331$export$2e2bcd8739ae039,
    signing_keys: $d5e8e91726aa6778$export$2e2bcd8739ae039,
    organization_template: $5e8b37ba6445c875$export$2e2bcd8739ae039,
    organization_role_details: $c77a2e45b552fad5$export$2e2bcd8739ae039
};
var $1206382da4f74fd4$export$2e2bcd8739ae039 = Object.freeze($1206382da4f74fd4$var$admin_console);


const $cb5011798824ef9f$var$demo_app = {
    title: "你已成功登錄實時預覽！",
    subtitle: "以下是本次登錄的用戶信息：",
    username: "用戶名：",
    user_id: "用戶 ID：",
    sign_out: "退出實時預覽",
    continue_explore: "或繼續探索",
    customize_sign_in_experience: "自定義登錄體驗",
    enable_passwordless: "啟用無密碼登錄",
    add_social_connector: "添加社交連接器"
};
var $cb5011798824ef9f$export$2e2bcd8739ae039 = Object.freeze($cb5011798824ef9f$var$demo_app);


const $caa849930eb32c6d$var$oidc = {
    logout_success: "你已經成功登出。"
};
var $caa849930eb32c6d$export$2e2bcd8739ae039 = Object.freeze($caa849930eb32c6d$var$oidc);


const $705ce38319019b3f$var$translation = {
    admin_console: $1206382da4f74fd4$export$2e2bcd8739ae039,
    demo_app: $cb5011798824ef9f$export$2e2bcd8739ae039,
    oidc: $caa849930eb32c6d$export$2e2bcd8739ae039
};
var $705ce38319019b3f$export$2e2bcd8739ae039 = Object.freeze($705ce38319019b3f$var$translation);


const $e52623e587726891$var$zh_hk = {
    translation: $705ce38319019b3f$export$2e2bcd8739ae039,
    errors: $196e73e03d8ae230$export$2e2bcd8739ae039
};
var $e52623e587726891$export$2e2bcd8739ae039 = Object.freeze($e52623e587726891$var$zh_hk);


const $fd42f9e50f12a044$var$application = {
    invalid_type: "僅允許機器對機器應用程式附加角色。",
    role_exists: "該角色 ID {{roleId}} 已被添加至此應用程式。",
    invalid_role_type: "無法將使用者類型的角色指派給機器對機器應用程式。",
    invalid_third_party_application_type: "僅傳統網路應用程式可以標記為第三方應用程式。",
    third_party_application_only: "該功能僅適用於第三方應用程式。",
    user_consent_scopes_not_found: "無效的使用者同意範圍。",
    consent_management_api_scopes_not_allowed: "管理 API 範圍不被允許。",
    protected_app_metadata_is_required: "需要保護應用程式元數據。",
    protected_app_not_configured: "保護應用程式提供者未配置。此功能不適用於開源版本。",
    cloudflare_unknown_error: "在請求 Cloudflare API 時發生未知錯誤",
    protected_application_only: "該功能僅適用於受保護的應用程式。",
    protected_application_misconfigured: "受保護的應用程式配置錯誤。",
    protected_application_subdomain_exists: "受保護應用程式的子域名已被使用。",
    invalid_subdomain: "無效的子域名。",
    custom_domain_not_found: "找不到自訂域名。",
    should_delete_custom_domains_first: "應先刪除自訂域名。"
};
var $fd42f9e50f12a044$export$2e2bcd8739ae039 = Object.freeze($fd42f9e50f12a044$var$application);


const $bd793ae810286685$var$auth = {
    authorization_header_missing: "Authorization 請求頭缺失。",
    authorization_token_type_not_supported: "Authorization token 類型不支持",
    unauthorized: "未經授權。請檢查憑證及其範圍。",
    forbidden: "禁止訪問。請檢查用戶 role 與權限。",
    expected_role_not_found: "未找到期望的 role。請檢查用戶 role 與權限。",
    jwt_sub_missing: "JWT 缺失 `sub`",
    require_re_authentication: "需要重新認證以進行受保護操作。"
};
var $bd793ae810286685$export$2e2bcd8739ae039 = Object.freeze($bd793ae810286685$var$auth);


const $87cd18aff9d5d87e$var$connector = {
    general: "連接器發生錯誤：{{errorDescription}}",
    not_found: "找不到可用的 {{type}} 類型的連接器",
    not_enabled: "連接器尚未啟用",
    invalid_metadata: "連接器 metadata 參數錯誤",
    invalid_config_guard: "連接器配置 guard 錯誤",
    unexpected_type: "連接器類型錯誤",
    invalid_request_parameters: "請求參數錯誤",
    insufficient_request_parameters: "請求參數缺失",
    invalid_config: "連接器配置錯誤",
    invalid_certificate: "連接器的憑證無效，請確保憑證使用 PEM 編碼。",
    invalid_response: "連接器錯誤響應",
    template_not_found: "無法從連接器配置中找到對應的模板",
    template_not_supported: "連接器不支援此模板類型",
    rate_limit_exceeded: "觸發速率限制。請稍後再試。",
    not_implemented: "方法 {{method}} 尚未實現",
    social_invalid_access_token: "當前連接器的 access_token 無效",
    invalid_auth_code: "當前連接器的授權碼無效",
    social_invalid_id_token: "當前連接器的 id_token 無效",
    authorization_failed: "用戶授權流程失敗",
    social_auth_code_invalid: "無法獲取 access_token，請檢查授權 code 是否有效",
    more_than_one_sms: "同時存在超過 1 個短信連接器",
    more_than_one_email: "同時存在超過 1 個郵件連接器",
    more_than_one_connector_factory: "找到多個連接器工廠（id 為 {{connectorIds}}），請刪除多餘項。",
    db_connector_type_mismatch: "數據庫中存在一個類型不匹配的連接。",
    not_found_with_connector_id: "找不到所給 connector id 對應的連接器",
    multiple_instances_not_supported: "你選擇的連接器不支持創建多實例。",
    invalid_type_for_syncing_profile: "只有社交連接器可以開啟用戶檔案同步。",
    can_not_modify_target: "不可修改連接器 target。",
    should_specify_target: "你需要聲明 target 的值。",
    multiple_target_with_same_platform: "同一平台上，多個社交連接器不能重複使用相同的 “Target”。",
    cannot_overwrite_metadata_for_non_standard_connector: "不可覆蓋該連接器的 metadata 參數。"
};
var $87cd18aff9d5d87e$export$2e2bcd8739ae039 = Object.freeze($87cd18aff9d5d87e$var$connector);


const $eb9bcca6abfc53de$var$domain = {
    not_configured: "域名主機名稱提供者未配置。",
    cloudflare_data_missing: "cloudflare_data 缺失，請確認。",
    cloudflare_unknown_error: "在請求 Cloudflare API 時出現未知錯誤",
    cloudflare_response_error: "從 Cloudflare 收到意外回應",
    limit_to_one_domain: "您只能擁有一個自訂網域。",
    hostname_already_exists: "此網域名稱已經存在我們的伺服器中。",
    cloudflare_not_found: "無法找到 Cloudflare 中的主機名",
    domain_is_not_allowed: "這個網域不允許。"
};
var $eb9bcca6abfc53de$export$2e2bcd8739ae039 = Object.freeze($eb9bcca6abfc53de$var$domain);


const $8c68501152a09426$var$entity = {
    invalid_input: "無效的輸入。值列表不能為空。",
    create_failed: "建立 {{name}} 失敗。",
    db_constraint_violated: "數據庫限制違反。",
    not_exists: "{{name}} 不存在。",
    not_exists_with_id: "ID 為 `{{id}}` 的 {{name}} 不存在。",
    not_found: "資源不存在。",
    relation_foreign_key_not_found: "無法找到一個或多個外鍵。請檢查輸入並確保所有參考的實體都存在。",
    unique_integrity_violation: "The entity already exists. Please check the input and try again."
};
var $8c68501152a09426$export$2e2bcd8739ae039 = Object.freeze($8c68501152a09426$var$entity);


const $49729c18dfed1864$var$guard = {
    invalid_input: "請求中 {{type}} 無效",
    invalid_pagination: "分頁參數無效",
    can_not_get_tenant_id: "無法從請求中獲取租戶 ID。",
    file_size_exceeded: "文件大小超過限制。",
    mime_type_not_allowed: "不允許使用此 MIME 類型。"
};
var $49729c18dfed1864$export$2e2bcd8739ae039 = Object.freeze($49729c18dfed1864$var$guard);


const $b7cd374d2557f372$var$hook = {
    missing_events: "你需要至少提供一個事件。",
    send_test_payload_failed: "無法发送測試内容：{{message}}",
    endpoint_responded_with_error: "端點返回了錯誤。"
};
var $b7cd374d2557f372$export$2e2bcd8739ae039 = Object.freeze($b7cd374d2557f372$var$hook);


const $f60cc9d2de3bed35$var$jwt_customizer = {
    general: "在自訂 JWT 權杖時發生錯誤。請稍後再試。",
    can_not_create_for_admin_tenant: "無法為管理員租戶建立 JWT 權杖自訂程式。"
};
var $f60cc9d2de3bed35$export$2e2bcd8739ae039 = Object.freeze($f60cc9d2de3bed35$var$jwt_customizer);


const $e13c207e01842ec1$var$localization = {
    cannot_delete_default_language: "你已設置 {{languageTag}} 為你的預設語言，你無法刪除預設語言。",
    invalid_translation_structure: "無效的數據格式，請檢查你的輸入並重試。"
};
var $e13c207e01842ec1$export$2e2bcd8739ae039 = Object.freeze($e13c207e01842ec1$var$localization);


const $124f0097826a050e$var$log = {
    invalid_type: "日誌類型無效。"
};
var $124f0097826a050e$export$2e2bcd8739ae039 = Object.freeze($124f0097826a050e$var$log);


const $252506b219018263$var$oidc = {
    aborted: "使用者終止了互動。",
    invalid_scope: "無效的範圍: {{error_description}}。",
    invalid_token: "Token 無效",
    invalid_client_metadata: "無效的用戶端元數據",
    insufficient_scope: "Token 缺少範圍 `{{scope}}`。",
    invalid_request: "請求無效",
    invalid_grant: "授權請求無效",
    invalid_redirect_uri: "無效返回連結, 该 redirect_uri 未被此應用註冊。",
    access_denied: "拒絕訪問",
    invalid_target: "請求資源無效",
    unsupported_grant_type: "不支援的 grant_type",
    unsupported_response_mode: "不支援的 response_mode",
    unsupported_response_type: "不支援的 response_type",
    provider_error: "OIDC 內部錯誤: {{message}}",
    server_error: "發生未知的 OIDC 錯誤。請稍後再試。",
    provider_error_fallback: "發生了一個 OIDC 錯誤: {{code}}。",
    key_required: "至少需要一個金鑰。",
    key_not_found: "未找到 ID 為 {{id}} 的金鑰。"
};
var $252506b219018263$export$2e2bcd8739ae039 = Object.freeze($252506b219018263$var$oidc);


const $f8159f0a98e7fcbc$var$organization = {
    require_membership: "使用者必須是該組織的成員才能繼續。"
};
var $f8159f0a98e7fcbc$export$2e2bcd8739ae039 = Object.freeze($f8159f0a98e7fcbc$var$organization);


const $052a6eb69e4cf193$var$password = {
    unsupported_encryption_method: "不支持的加密方法 {{name}}",
    pepper_not_found: "密碼 pepper 未找到。請檢查 core 的環境變數。",
    rejected: "密碼被拒絕。請檢查密碼是否符合要求。"
};
var $052a6eb69e4cf193$export$2e2bcd8739ae039 = Object.freeze($052a6eb69e4cf193$var$password);


const $9f332cdf71a94b70$var$request = {
    invalid_input: "輸入無效。{{details}}",
    general: "發生請求錯誤。"
};
var $9f332cdf71a94b70$export$2e2bcd8739ae039 = Object.freeze($9f332cdf71a94b70$var$request);


const $b2840f120e2bc869$var$resource = {
    resource_identifier_in_use: "API 識別碼 {{indicator}} 已經被使用",
    cannot_delete_management_api: "無法刪除 Logto 管理 API。",
    cannot_modify_management_api: "無法修改 Logto 管理 API。"
};
var $b2840f120e2bc869$export$2e2bcd8739ae039 = Object.freeze($b2840f120e2bc869$var$resource);


const $e9a2b88f7d5bd288$var$role = {
    name_in_use: "此角色名稱 {{name}} 已被使用",
    scope_exists: "作用域 ID {{scopeId}} 已添加到此角色",
    management_api_scopes_not_assignable_to_user_role: "無法將管理 API 作用域分配給用戶角色。",
    user_exists: "用戶 ID {{userId}} 已添加到此角色",
    application_exists: "已經將應用程式 ID {{applicationId}} 添加到此角色",
    default_role_missing: "某些預設角色名稱在資料庫中不存在，請確保先創建角色",
    internal_role_violation: "你可能正在嘗試更新或刪除 Logto 禁止的內部角色。如果你要創建新角色，請嘗試使用不以“#internal:”開頭的名稱。"
};
var $e9a2b88f7d5bd288$export$2e2bcd8739ae039 = Object.freeze($e9a2b88f7d5bd288$var$role);


const $d9921572e90a2036$var$scope = {
    name_exists: "此作用域名稱 {{name}} 已被使用",
    name_with_space: "作用域名稱不能包含任何空格。"
};
var $d9921572e90a2036$export$2e2bcd8739ae039 = Object.freeze($d9921572e90a2036$var$scope);


const $ca6dc745e968e9f7$var$session = {
    not_found: "未找到會話。請返回並重新登錄。",
    invalid_credentials: "帳號或密碼錯誤，請重新輸入。",
    invalid_sign_in_method: "當前登錄方式不可用",
    invalid_connector_id: "找不到 ID 為 {{connectorId}} 的可用連接器。",
    insufficient_info: "登錄信息缺失，請檢查你的輸入。",
    connector_id_mismatch: "傳入的連接器 ID 與 session 中保存的記錄不一致",
    connector_session_not_found: "無法找到連接器登錄信息，請嘗試重新登錄。",
    verification_session_not_found: "驗證失敗，請重新驗證。",
    verification_expired: "當前頁面已超時。為確保你的帳號安全，請重新驗證。",
    verification_blocked_too_many_attempts: "在短時間內嘗試次數過多。請於{{relativeTime}}後再試。",
    unauthorized: "請先登錄",
    unsupported_prompt_name: "不支援的 prompt 名稱",
    forgot_password_not_enabled: "忘記密碼功能沒有開啟。",
    verification_failed: "驗證失敗，請重新驗證。",
    connector_validation_session_not_found: "找不到用於驗證 token 的連接器資訊。",
    identifier_not_found: "找不到使用者識別碼。請返回並重新登錄。",
    interaction_not_found: "找不到交互會話。請返回並重新開始會話。",
    not_supported_for_forgot_password: "該操作不支援忘記密碼。",
    mfa: {
        require_mfa_verification: "需要 MFA 驗證才能登錄。",
        mfa_sign_in_only: "MFA 只能用於登錄交互。",
        pending_info_not_found: "未找到尚未處理的 MFA 資訊，請先初始化 MFA。",
        invalid_totp_code: "無效的 TOTP 驗證碼。",
        webauthn_verification_failed: "WebAuthn 驗證失敗。",
        webauthn_verification_not_found: "找不到 WebAuthn 驗證。",
        bind_mfa_existed: "MFA 已存在。",
        backup_code_can_not_be_alone: "備份碼不能作為唯一的 MFA。",
        backup_code_required: "需要備份碼。",
        invalid_backup_code: "無效的備份碼。",
        mfa_policy_not_user_controlled: "MFA 策略不受用戶控制。"
    },
    sso_enabled: "該郵箱已開啟單點登錄，請使用 SSO 登錄。"
};
var $ca6dc745e968e9f7$export$2e2bcd8739ae039 = Object.freeze($ca6dc745e968e9f7$var$session);


const $b125e601894cd536$var$sign_in_experiences = {
    empty_content_url_of_terms_of_use: "你啟用了“使用條款”，請添加使用條款 URL。",
    empty_social_connectors: "你啟用了社交登錄的方式。請至少選擇一個社交連接器。",
    enabled_connector_not_found: "未找到已啟用的 {{type}} 連接器",
    not_one_and_only_one_primary_sign_in_method: "主要的登錄方式必須有且僅有一個，請檢查你的輸入。",
    username_requires_password: "必須為用戶名註冊識別符啟用設置密碼。",
    passwordless_requires_verify: "必須為電子郵件/電話註冊識別符啟用驗證。",
    miss_sign_up_identifier_in_sign_in: "登錄方法必須包含註冊識別符。",
    password_sign_in_must_be_enabled: "必須在註冊中要求設置密碼時啟用密碼登錄。",
    code_sign_in_must_be_enabled: "必須在註冊中不要求設置密碼時啟用驗證碼登錄。",
    unsupported_default_language: "{{language}} 無法選擇為默認語言。",
    at_least_one_authentication_factor: "至少要選擇一個登錄要素",
    backup_code_cannot_be_enabled_alone: "備份碼不能單獨啟用。",
    duplicated_mfa_factors: "重複的MFA要素。"
};
var $b125e601894cd536$export$2e2bcd8739ae039 = Object.freeze($b125e601894cd536$var$sign_in_experiences);


const $a5865bbb018f2ed8$var$single_sign_on = {
    forbidden_domains: "不允許使用公共電子郵件域名。",
    duplicated_domains: "存在重複的域名。",
    invalid_domain_format: "無效的域名格式。",
    duplicate_connector_name: "連接器名稱已存在。請選擇不同的名稱。"
};
var $a5865bbb018f2ed8$export$2e2bcd8739ae039 = Object.freeze($a5865bbb018f2ed8$var$single_sign_on);


const $5df46b544b07a7d4$var$storage = {
    not_configured: "未配置存儲提供程序。",
    missing_parameter: "存儲提供程序缺少參數 {{parameter}}。",
    upload_error: "無法將檔案上傳到存儲提供程序。"
};
var $5df46b544b07a7d4$export$2e2bcd8739ae039 = Object.freeze($5df46b544b07a7d4$var$storage);


const $b8313f9f8e20d95a$var$subscription = {
    limit_exceeded: "您已達到訂閱計劃的限制。",
    get_plan_failed: "無法為租戶獲取訂閱計劃。",
    tenant_suspended: "租戶已被暫停。 請聯繫您的管理員。"
};
var $b8313f9f8e20d95a$export$2e2bcd8739ae039 = Object.freeze($b8313f9f8e20d95a$var$subscription);


const $0574d702b4698585$var$swagger = {
    invalid_zod_type: "無效的 Zod 類型，請檢查路由 guard 配置。",
    not_supported_zod_type_for_params: "請求參數不支持的 Zod 類型，請檢查路由 guard 配置。"
};
var $0574d702b4698585$export$2e2bcd8739ae039 = Object.freeze($0574d702b4698585$var$swagger);


const $2dd28df9f398bdb7$var$user = {
    username_already_in_use: "該用戶名已被使用。",
    email_already_in_use: "該電子郵件地址已被使用。",
    phone_already_in_use: "該手機號碼已被使用。",
    invalid_email: "電子郵件地址不正確。",
    invalid_phone: "手機號碼不正確。",
    email_not_exist: "電子郵件地址尚未註冊。",
    phone_not_exist: "手機號碼尚未註冊。",
    identity_not_exist: "該社交帳號尚未註冊。",
    identity_already_in_use: "該社交帳號已被註冊。",
    social_account_exists_in_profile: "你已綁定當前社交帳號，無需重複操作。",
    cannot_delete_self: "無法刪除自己的帳戶。",
    sign_up_method_not_enabled: "註冊方式尚未啟用。",
    sign_in_method_not_enabled: "登錄方式尚未啟用。",
    same_password: "為確保帳戶安全，新密碼不能與舊密碼一致。",
    password_required_in_profile: "請設置登錄密碼。",
    new_password_required_in_profile: "請設置新密碼。",
    password_exists_in_profile: "當前用戶已設置密碼，無需重複操作。",
    username_required_in_profile: "請設置用戶名。",
    username_exists_in_profile: "當前用戶已設置用戶名，無需重複操作。",
    email_required_in_profile: "請綁定電子郵件地址",
    email_exists_in_profile: "當前用戶已綁定電子郵件，無需重複操作。",
    phone_required_in_profile: "請綁定手機號碼。",
    phone_exists_in_profile: "當前用戶已綁定手機號碼，無需重複操作。",
    email_or_phone_required_in_profile: "請綁定電子郵件地址或手機號碼。",
    suspended: "帳戶已被禁用。",
    user_not_exist: "未找到與 {{identifier}} 相關聯的用戶。",
    missing_profile: "請於登錄時提供必要的用戶補充信息。",
    role_exists: "角色 ID {{roleId}} 已添加到此用戶",
    invalid_role_type: "無效角色類型，無法將機器對機器角色分配給用戶。",
    missing_mfa: "在登錄前需要綁定額外的多因素驗證。",
    totp_already_in_use: "TOTP 已經在使用中。",
    backup_code_already_in_use: "備份代碼已經在使用中。",
    password_algorithm_required: "Password algorithm is required.",
    password_and_digest: "You cannot set both plain text password and password digest."
};
var $2dd28df9f398bdb7$export$2e2bcd8739ae039 = Object.freeze($2dd28df9f398bdb7$var$user);


const $a4ba4c21d6c9cb36$var$verification_code = {
    phone_email_empty: "手機號與電子郵件地址均為空",
    not_found: "驗證碼不存在，請先請求發送驗證碼",
    phone_mismatch: "手機號碼不匹配，請嘗試請求新的驗證碼。",
    email_mismatch: "電子郵件地址不匹配，請嘗試請求新的驗證碼。",
    code_mismatch: "驗證碼不正確",
    expired: "驗證碼已過期，請嘗試請求新的驗證碼。",
    exceed_max_try: "超過最大驗證次數，請嘗試請求新的驗證碼。"
};
var $a4ba4c21d6c9cb36$export$2e2bcd8739ae039 = Object.freeze($a4ba4c21d6c9cb36$var$verification_code);


const $5ef01ca316b15147$var$errors = {
    request: $9f332cdf71a94b70$export$2e2bcd8739ae039,
    auth: $bd793ae810286685$export$2e2bcd8739ae039,
    guard: $49729c18dfed1864$export$2e2bcd8739ae039,
    oidc: $252506b219018263$export$2e2bcd8739ae039,
    user: $2dd28df9f398bdb7$export$2e2bcd8739ae039,
    password: $052a6eb69e4cf193$export$2e2bcd8739ae039,
    session: $ca6dc745e968e9f7$export$2e2bcd8739ae039,
    connector: $87cd18aff9d5d87e$export$2e2bcd8739ae039,
    verification_code: $a4ba4c21d6c9cb36$export$2e2bcd8739ae039,
    sign_in_experiences: $b125e601894cd536$export$2e2bcd8739ae039,
    jwt_customizer: $f60cc9d2de3bed35$export$2e2bcd8739ae039,
    localization: $e13c207e01842ec1$export$2e2bcd8739ae039,
    swagger: $0574d702b4698585$export$2e2bcd8739ae039,
    entity: $8c68501152a09426$export$2e2bcd8739ae039,
    log: $124f0097826a050e$export$2e2bcd8739ae039,
    role: $e9a2b88f7d5bd288$export$2e2bcd8739ae039,
    scope: $d9921572e90a2036$export$2e2bcd8739ae039,
    storage: $5df46b544b07a7d4$export$2e2bcd8739ae039,
    resource: $b2840f120e2bc869$export$2e2bcd8739ae039,
    hook: $b7cd374d2557f372$export$2e2bcd8739ae039,
    domain: $eb9bcca6abfc53de$export$2e2bcd8739ae039,
    subscription: $b8313f9f8e20d95a$export$2e2bcd8739ae039,
    application: $fd42f9e50f12a044$export$2e2bcd8739ae039,
    organization: $f8159f0a98e7fcbc$export$2e2bcd8739ae039,
    single_sign_on: $a5865bbb018f2ed8$export$2e2bcd8739ae039
};
var $5ef01ca316b15147$export$2e2bcd8739ae039 = Object.freeze($5ef01ca316b15147$var$errors);


const $58c178aa35c151b4$var$api_resource_details = {
    page_title: "API 資源詳情",
    back_to_api_resources: "返回 API 資源",
    general_tab: "常規",
    permissions_tab: "權限",
    settings: "設定",
    settings_description: "API 資源，又稱資源指標，表示要請求的目標服務或資源，通常是表示資源身份的 URI 格式變數。",
    management_api_settings_description: "Logto 管理 API 是一個全面的 API 集合，使管理員能夠管理各種與身份有關的任務，執行安全策略，並遵守法規和標準。",
    management_api_notice: "此 API 代表 Logto 實體，無法修改或刪除。創建機器對機器應用程式以調用 Logto 管理 API。<a>了解更多</a>",
    token_expiration_time_in_seconds: "Token 過期時間（秒）",
    token_expiration_time_in_seconds_placeholder: "請輸入你的 token 過期時間",
    delete_description: "本操作會永久性地刪除該 API 資源，且不可撤銷。輸入 API 資源名稱 <span>{{name}}</span> 確認。",
    enter_your_api_resource_name: "輸入 API 資源名稱",
    api_resource_deleted: " API 資源 {{name}} 已刪除.",
    permission: {
        create_button: "建立權限",
        create_title: "建立權限",
        create_subtitle: "定義此 API 所需的權限 (scope)。",
        confirm_create: "建立權限",
        edit_title: "編輯 API 權限",
        edit_subtitle: "定義 {{resourceName}} API 所需的權限 (scopes)。",
        name: "權限名稱",
        name_placeholder: "read:resource",
        forbidden_space_in_name: "權限名稱不能包含空格。",
        description: "描述",
        description_placeholder: "能夠讀取資源",
        permission_created: '權限 "{{name}}" 已成功建立',
        delete_description: "如果刪除此權限，擁有該權限的使用者將失去由此權限授予的存取權限。",
        deleted: '成功刪除權限 "{{name}}"。'
    }
};
var $58c178aa35c151b4$export$2e2bcd8739ae039 = Object.freeze($58c178aa35c151b4$var$api_resource_details);


const $fc40e76dd560688e$var$api_resources = {
    page_title: "API 資源",
    title: "API 資源",
    subtitle: "定義可以從已授權的應用程序中使用的 API",
    create: "創建 API 資源",
    api_name: "API 名稱",
    api_name_placeholder: "輸入API名稱",
    api_identifier: "API Identifier",
    api_identifier_placeholder: "https://your-api-identifier/",
    api_identifier_tip: "對於 API 資源的唯一標識符。它必須是一個絕對 URI，並沒有 fragment (#) 組件。等價於 OAuth 2.0 中的 <a>resource parameter</a>。",
    default_api: "預設 API",
    default_api_label: "一個租戶只能設定零個或一個預設 API。當指定了預設 API 後，可以在授權請求中省略 `resource` 參數。隨後的令牌交換將使用該 API 作為默認的 Audience，從而產生 JWT。<a>了解更多</a>",
    api_resource_created: " API 資源 {{name}} 已成功創建。",
    invalid_resource_indicator_format: "API indicator must be a valid absolute URI."
};
var $fc40e76dd560688e$export$2e2bcd8739ae039 = Object.freeze($fc40e76dd560688e$var$api_resources);


const $4a839e31ce65cf6f$var$application_details = {
    page_title: "應用詳細資料",
    back_to_applications: "返回全部應用",
    check_guide: "查看指南",
    settings: "設置",
    settings_description: "一個「應用程式」是一個已註冊的軟體或服務，可以存取使用者資訊或代表使用者進行操作。應用程式有助於辨識是誰向 Logto 要求什麼，並處理登入和權限問題。填寫驗證所需的字段。",
    integration: "整合",
    integration_description: "使用由 Cloudflare 邊緣網路提供動力的 Logto 安全工作者部署，實現全球頂級性能和 0 毫秒全球冷啟動。",
    service_configuration: "服務配置",
    service_configuration_description: "在您的服務中完成必要的配置。",
    session: "會話",
    endpoints_and_credentials: "端點與憑證",
    endpoints_and_credentials_description: "使用以下端點和憑證設置應用程式中的 OIDC 連接。",
    refresh_token_settings: "刷新令牌",
    refresh_token_settings_description: "管理此應用程式的刷新令牌規則。",
    application_roles: "角色",
    machine_logs: "機器日誌",
    application_name: "應用程式姓名",
    application_name_placeholder: "我的應用程式",
    description: "說明",
    description_placeholder: "請輸入應用程式說明",
    config_endpoint: "OpenID Provider 配置端點",
    authorization_endpoint: "授權端點",
    authorization_endpoint_tip: "進行驗證與授權的端點。用於 OpenID Connect 中的 <a>驗證</a> 流程。",
    show_endpoint_details: "顯示端點詳情",
    hide_endpoint_details: "隱藏端點詳情",
    logto_endpoint: "Logto 端點",
    application_id: "應用程式 ID",
    application_id_tip: "應用程式的唯一標識，通常由 Logto 生成。相當於 OpenID Connect 中的 <a>client_id</a>。",
    application_secret: "應用程式秘鑰",
    redirect_uri: "重定向 URI",
    redirect_uris: "重定向 URIs",
    redirect_uri_placeholder: "https://your.website.com/app",
    redirect_uri_placeholder_native: "io.logto://callback",
    redirect_uri_tip: "在用戶登錄完成（不論成功與否）後，重新導向的目標 URI。參見 OpenID Connect <a>AuthRequest</a> 以了解更多。",
    post_sign_out_redirect_uri: "登出後重定向的 URI",
    post_sign_out_redirect_uris: "登出後重定向的 URIs",
    post_sign_out_redirect_uri_placeholder: "https://your.website.com/home",
    post_sign_out_redirect_uri_tip: "在用戶登出後，重新導向的目標 URI（可選）。在某些應用程式類型中可能無實質作用。",
    cors_allowed_origins: "CORS 允許的來源",
    cors_allowed_origins_placeholder: "https://your.website.com",
    cors_allowed_origins_tip: "所有重新導向 URI 的來源都將默認被允許。通常不需要對此欄位進行操作。參見 <a>MDN 文件</a> 以了解更多。",
    token_endpoint: "Token 端點",
    user_info_endpoint: "用戶資訊端點",
    enable_admin_access: "啟用管理訪問",
    enable_admin_access_label: "啟用或禁用對管理 API 的訪問。啟用後，你可以使用訪問令牌代表該應用程式調用管理 API。",
    always_issue_refresh_token: "始終發放 Refresh Token",
    always_issue_refresh_token_label: "啟用此配置將使 Logto 無論在驗證請求中是否提供 prompt=consent，都能始終發放 Refresh Token。然而，除非必要，否則不鼓勵這種做法，因為它與 OpenID Connect 不相容並可能引起問題。",
    refresh_token_ttl: "Refresh Token 有效期（天數）",
    refresh_token_ttl_tip: "Refresh Token 可用來獲取新的訪問令牌，失效日期之前可用。獲取訪問令牌時，該令牌的期限將被延長至此值。",
    rotate_refresh_token: "旋轉 Refresh Token",
    rotate_refresh_token_label: "啟用此配置將使 Logto 当 Refresh Token 的原始有效期剩下 70% 时或当满足某些条件时，授予新的 Refresh Token 以獲取新的 Access Token。<a>了解更多</a>",
    delete_description: "本操作會永久性地刪除該應用程式，且不可撤銷。輸入 <span>{{name}}</span> 確認。",
    enter_your_application_name: "輸入你的應用程式姓名",
    application_deleted: "應用 {{name}} 成功刪除。",
    redirect_uri_required: "至少需要輸入一個重定向 URL。",
    app_domain_description_1: "隨時使用由 Logto 提供動力的 {{domain}} 域，其永久有效。",
    app_domain_description_2: "隨時使用您的域 <domain>{{domain}}</domain>，其永久有效。",
    custom_rules: "自定義身份驗證規則",
    custom_rules_placeholder: "^/(admin|privacy)/.+$",
    custom_rules_description: "使用正則表達式設置需要身份驗證的路徑規則。預設: 若留空則全站保護。",
    authentication_routes: "身份驗證路徑",
    custom_rules_tip: "這裡有兩個案例：<ol><li>僅對 '/admin' 和 '/privacy' 路徑進行身份驗證: ^/(admin|privacy)/.*</li><li>排除 JPG 圖片不進行身份驗證: ^(?!.*\\.jpg$).*$</li></ol>",
    authentication_routes_description: "使用指定路徑重新導向您的身份驗證按鈕。注意: 這些路徑不可替代。",
    protect_origin_server: "保護您的源伺服器",
    protect_origin_server_description: "確保保護您的源伺服器免受直接訪問。請參閱指南以獲取更多 <a>詳細說明</a>。",
    session_duration: "會話持續時間（天數）",
    try_it: "試試看",
    branding: {
        name: "品牌",
        description: "在同意畫面上自訂應用程式的顯示名稱和標誌。",
        more_info: "更多資訊",
        more_info_description: "在同意畫面上提供有關您的應用程式的更多詳細資訊。",
        display_name: "顯示名稱",
        display_logo: "顯示標誌",
        display_logo_dark: "顯示標誌（深色）",
        terms_of_use_url: "應用程式使用條款網址",
        privacy_policy_url: "應用程式隱私政策網址"
    },
    permissions: {
        name: "權限",
        description: "選擇第三方應用程式需要的許可權，以便用戶授權訪問特定資料類型。",
        user_permissions: "個人用戶資料",
        organization_permissions: "組織訪問",
        table_name: "授予權限",
        field_name: "權限",
        field_description: "在同意畫面上顯示",
        delete_text: "刪除權限",
        permission_delete_confirm: "此操作將撤銷授予第三方應用程式的權限，防止其要求授權訪問特定資料類型。確定要繼續嗎？",
        permissions_assignment_description: "選擇第三方應用程式請求用戶授權訪問特定資料類型的權限。",
        user_profile: "用戶資料",
        api_permissions: "API 權限",
        organization: "組織權限",
        user_permissions_assignment_form_title: "添加用戶資料權限",
        organization_permissions_assignment_form_title: "添加組織權限",
        api_resource_permissions_assignment_form_title: "添加 API 资源權限",
        user_data_permission_description_tips: "您可以通過「登入體驗 > 內容 > 管理語言」修改個人用戶資料權限的描述。",
        permission_description_tips: "當 Logto 作為第三方應用程式中的身份提供者（IdP）用於身份驗證時，用戶被要求授權，此描述將顯示在同意畫面上。",
        user_title: "用戶",
        user_description: "選擇由第三方應用程式請求的用於訪問特定用戶資料的權限。",
        grant_user_level_permissions: "授予用戶資料權限",
        organization_title: "組織",
        organization_description: "選擇由第三方應用程式請求的用於訪問特定組織資料的權限。",
        grant_organization_level_permissions: "授予組織資料權限"
    },
    roles: {
        name_column: "角色",
        description_column: "描述",
        assign_button: "分配角色",
        delete_description: "此操作將從此機器到機器應用程式中刪除該角色。該角色本身仍然存在，但不再與此機器到機器應用程式關聯。",
        deleted: "已成功從此用戶中刪除 {{name}}。",
        assign_title: "將角色分配給 {{name}}",
        assign_subtitle: "授權 {{name}} 一個或多個角色",
        assign_role_field: "分配角色",
        role_search_placeholder: "按角色名稱搜索",
        added_text: "{{value, number}} 已添加",
        assigned_app_count: "{{value, number}} 應用程式",
        confirm_assign: "分配角色",
        role_assigned: "成功分配角色",
        search: "按角色名稱、描述或 ID 搜索",
        empty: "沒有可用的角色"
    }
};
var $4a839e31ce65cf6f$export$2e2bcd8739ae039 = Object.freeze($4a839e31ce65cf6f$var$application_details);


const $06694227b27334d5$var$applications = {
    page_title: "全部應用",
    title: "全部應用",
    subtitle: "創建一個移動、單頁、machine-to-machine 或傳統 web 應用程序，並通過 Logto 進行身份驗證",
    subtitle_with_app_type: "設置 {{name}} 應用程序的 Logto 身份驗證",
    create: "創建應用",
    create_subtitle_third_party: "使用 Logto 作為您的身份提供者（IdP），輕鬆集成第三方應用程式",
    application_name: "應用名稱",
    application_name_placeholder: "我的應用",
    application_description: "應用描述",
    application_description_placeholder: "請輸入應用描述",
    select_application_type: "選擇應用類型",
    no_application_type_selected: "你還沒有選擇應用類型",
    application_created: "應用創建成功。",
    tab: {
        my_applications: "我的應用",
        third_party_applications: "第三方應用程式"
    },
    app_id: "App ID",
    type: {
        native: {
            title: "原生應用",
            subtitle: "在原生環境中運行的應用程序",
            description: "例如 iOS 應用程式，Android 應用程式"
        },
        spa: {
            title: "單頁應用",
            subtitle: "在瀏覽器中運行並動態更新數據的應用程式",
            description: "例如 React DOM 應用程式，Vue 應用程式"
        },
        traditional: {
            title: "傳統網頁應用",
            subtitle: "僅由 Web 伺服器渲染和更新的應用程式",
            description: "例如 Next.js，PHP"
        },
        machine_to_machine: {
            title: "Machine-to-Machine",
            subtitle: "直接與資源對話的應用程式（通常是服務）",
            description: "例如，後端服務"
        },
        protected: {
            title: "受保護應用",
            subtitle: "受 Logto 保護的應用",
            description: "N/A"
        },
        third_party: {
            title: "第三方應用程式",
            subtitle: "作為第三方 IdP 連接器使用的應用程式",
            description: "例如，OIDC、SAML"
        }
    },
    placeholder_title: "選擇應用程式類型以繼續",
    placeholder_description: "Logto 使用 OIDC 的應用程式實體來幫助識別你的應用程式、管理登入和創建審計日誌等任務。",
    m2m_role_assignment: {
        title: "使用機器到機器角色為應用程式授權權限",
        subtitle: "機器對機器應用程式需要經過授權的機器對機器角色。",
        role_creation_hint: "找不到合適的機器對機器角色？<a>創建一個機器對機器角色</a>"
    }
};
var $06694227b27334d5$export$2e2bcd8739ae039 = Object.freeze($06694227b27334d5$var$applications);


const $816b0112de7e6cc8$var$cloud = {
    general: {
        onboarding: "入門"
    },
    welcome: {
        page_title: "歡迎",
        title: "歡迎來到 Logto Cloud！我們很想了解一些關於你的資訊。",
        description: "通過更好地了解你，我們可以使你的 Logto 體驗更加個性化。你的信息是安全的。",
        project_field: "我使用 Logto 是為了",
        project_options: {
            personal: "個人專案",
            company: "公司專案"
        },
        company_name_field: "公司名稱",
        company_name_placeholder: "Acme.co",
        stage_field: "你的產品目前處於什麼階段？",
        stage_options: {
            new_product: "啟動新項目並尋找快速、即插即用的解決方案",
            existing_product: "從當前身份驗證進行遷移（例如自行建立、Auth0、Cognito、Microsoft）",
            target_enterprise_ready: "我剛剛簽下了更大的客戶，現在要使我的產品能夠銷售給企業"
        },
        additional_features_field: "你還有其他想讓我們知道的事情嗎？",
        additional_features_options: {
            customize_ui_and_flow: "構建和管理我的自己的 UI，而不僅僅是使用 Logto 預製和可定制的解決方案",
            compliance: "SOC2 和 GDPR 是必不可少的",
            export_user_data: "需要從 Logto 導出用戶數據的能力",
            budget_control: "我有非常嚴格的預算控制",
            bring_own_auth: "擁有自己的身份驗證服務，只需要一些 Logto 功能",
            others: "以上都不是"
        }
    },
    sie: {
        page_title: "定制登錄體驗",
        title: "讓我們輕鬆定制你的登錄體驗",
        inspire: {
            title: "創建引人入勝的示例",
            description: "對登錄體驗不確定嗎？只需點擊“啓發我”，讓魔法發生！",
            inspire_me: "來點靈感"
        },
        logo_field: "應用商標",
        color_field: "品牌顏色",
        identifier_field: "標識符",
        identifier_options: {
            email: "電子郵件",
            phone: "電話",
            user_name: "用戶名"
        },
        authn_field: "身份驗證",
        authn_options: {
            password: "密碼",
            verification_code: "驗證碼"
        },
        social_field: "社交登錄",
        finish_and_done: "完成並完成",
        preview: {
            mobile_tab: "移動端",
            web_tab: "網頁端"
        },
        connectors: {
            unlocked_later: "稍後解鎖",
            unlocked_later_tip: "完成入門流程並進入產品後，你將獲得訪問更多社交登錄方式的權限。",
            notice: "請勿將演示連接器用於生產目的。完成測試後，請刪除演示連接器並使用你的憑證設置自己的連接器。"
        }
    },
    socialCallback: {
        title: "你已成功登錄",
        description: "你已成功使用社交帳戶登錄。為確保與 Logto 的無縫集成並獲得所有功能的訪問權限，我們建議你繼續配置自己的社交連接器。"
    },
    tenant: {
        create_tenant: "新增租戶"
    }
};
var $816b0112de7e6cc8$export$2e2bcd8739ae039 = Object.freeze($816b0112de7e6cc8$var$cloud);


const $a385faa741008cfb$var$components = {
    uploader: {
        action_description: "拖放或瀏覽上傳",
        uploading: "上傳中...",
        image_limit: "上傳圖片大小不能超過 {{size, number}}KB，只支持 {{extensions, list(style: narrow; type: conjunction;)}} 格式的文件。",
        error_upload: "哎呀，出了些問題。文件上傳失敗。",
        error_file_size: "文件太大了，請上傳小於 {{size, number}}KB 的文件。",
        error_file_type: "不支持該文件類型。只支持 {{extensions, list(style: narrow; type: conjunction;)}} 格式的文件。",
        error_file_count: "您只能上傳一個檔案。"
    }
};
var $a385faa741008cfb$export$2e2bcd8739ae039 = Object.freeze($a385faa741008cfb$var$components);


const $fd5ddc5207821bd7$var$connector_details = {
    page_title: "連結器詳情",
    back_to_connectors: "返回連結器",
    check_readme: "檢視 README",
    settings: "通用設定",
    settings_description: "連結器在 Logto 中扮演著至關重要的角色。借助它們的幫助，Logto 使終端用戶能夠使用無密碼註冊或登錄的功能以及使用社交帳戶登錄的功能。",
    parameter_configuration: "參數配置",
    test_connection: "測試",
    save_error_empty_config: "請輸入配置內容",
    send: "傳送",
    send_error_invalid_format: "無效輸入",
    edit_config_label: "請在此輸入您的 JSON 配置",
    test_email_sender: "測試您的郵件連結器",
    test_sms_sender: "測試您的短信連結器",
    test_email_placeholder: "john.doe@example.com",
    test_sms_placeholder: "+86 131 1234 5678",
    test_message_sent: "測試訊息已傳送",
    test_sender_description: "Logto 使用「通用」模板進行測試。如果您的連結器正確配置，您將收到一條訊息。",
    options_change_email: "更換郵件連結器",
    options_change_sms: "更換短信連結器",
    connector_deleted: "成功刪除連結器",
    type_email: "郵件連結器",
    type_sms: "短信連結器",
    type_social: "社交連結器",
    in_used_social_deletion_description: "您的登入體驗正在使用這個連結器。刪除後，<name/> 登入體驗將在登入體驗設定中被刪除，再次添加需重新配置。",
    in_used_passwordless_deletion_description: "您的登入體驗正在使用 {{name}} 連結器。刪除後，您的登入體驗將無法正常工作，直到您解決衝突，再次添加需重新配置。",
    deletion_description: "您將刪除此連結器。此操作不可撤銷，再次添加需重新配置。",
    logto_email: {
        total_email_sent: "總發送郵件數：{{value, number}}",
        total_email_sent_tip: "在 Logto 中，使用 SendGrid 進行安全、穩定的內建郵件發送。完全免費使用。<a>了解更多</a>",
        email_template_title: "郵件模板",
        template_description: "內置郵件使用默認模板實現無縫交付驗證郵件。無需配置，您可以自定義基本品牌信息。",
        template_description_link_text: "查看模板",
        description_action_text: "查看模板",
        from_email_field: "發件人郵箱",
        sender_name_field: "寄件人姓名",
        sender_name_tip: "自定義郵件發件人姓名。如果未填寫，將使用「Verification」作為默認姓名。",
        sender_name_placeholder: "您的發件人姓名",
        company_information_field: "公司信息",
        company_information_description: "在郵件底部顯示您的公司名稱、地址或郵編，以提高真實性。",
        company_information_placeholder: "您的公司基本信息",
        app_logo_field: "應用程式標誌",
        app_logo_tip: "在郵件頂部顯示您的品牌標誌。在淺色模式和深色模式下使用相同的圖像。",
        urls_not_allowed: "不允許使用 URL",
        test_notes: "Logto 使用「通用」模板進行測試。"
    }
};
var $fd5ddc5207821bd7$export$2e2bcd8739ae039 = Object.freeze($fd5ddc5207821bd7$var$connector_details);


const $559e9fb8c669cafb$var$connectors = {
    page_title: "連接器",
    title: "連接器",
    subtitle: "設置連接器，啟用無密碼和社交登錄",
    create: "添加社交連接器",
    config_sie_notice: "你已經配置了社交連接器，記得在<a>{{link}}</a>上添加使之生效。",
    config_sie_link_text: "登錄體驗",
    tab_email_sms: "短信和郵件連接器",
    tab_social: "社交連接器",
    connector_name: "連接器名稱",
    demo_tip: "演示連接器僅用於演示且最多只能發送 100 條消息，不建議在生產環境中部署。",
    social_demo_tip: "演示連接器僅用於演示目的，不建議在生產環境中部署。",
    connector_type: "類型",
    connector_status: "登錄體驗",
    connector_status_in_use: "使用中",
    connector_status_not_in_use: "未使用",
    not_in_use_tip: {
        content: "未使用意味著你的登錄體驗並沒有使用這個登錄方式。<a>{{link}}</a>去添加。",
        go_to_sie: "前往登錄體驗"
    },
    placeholder_title: "社交連接器",
    placeholder_description: "Logto 提供了許多廣泛使用的社交登錄連接器，同時你還可以使用標準協議創建自己的連接器。",
    save_and_done: "保存並完成",
    type: {
        email: "郵件連接器",
        sms: "短信連接器",
        social: "社交連接器"
    },
    setup_title: {
        email: "設置郵件連接器",
        sms: "設置短信連接器",
        social: "添加社交連接器"
    },
    guide: {
        subtitle: "參考以下步驟完成你的連接器設置",
        general_setting: "通用設置",
        parameter_configuration: "參數配置",
        test_connection: "連接測試",
        name: "社交登錄按鈕的名稱",
        name_placeholder: "輸入社交登錄按鈕的名稱",
        name_tip: "按鈕上將展示「通過 {{name}} 繼續」。名字不宜過長而導致信息無法展示完整。",
        logo: "社交登錄按鈕的 Logo 圖片鏈接",
        logo_placeholder: "https://your.cdn.domain/logo.png",
        logo_tip: "該圖片將用於連接器的展示。獲取圖片鏈接後粘貼在此處。",
        logo_dark: "社交登錄按鈕的 Logo 圖片鏈接（深色模式）",
        logo_dark_placeholder: "https://your.cdn.domain/logo.png",
        logo_dark_tip: "在管理控制台的登錄體驗中啟用“深色模式”後，可設置此連接器 Logo 用於深色模式。",
        logo_dark_collapse: "收起",
        logo_dark_show: "展開深色模式 Logo 設置",
        target: "身份提供商名稱",
        target_placeholder: "輸入身份提供商的名稱",
        target_tip: "在“身份供應商名稱”字段中輸入唯一的標識符字符串，用於區分社交身份來源。",
        target_tip_standard: "在“身份供應商名稱”字段中輸入唯一的標識符字符串，用於區分社交身份來源。注意，在連接器創建成功後，無法再次修改此設置。",
        target_tooltip: "Logto 社交連接器的「target」指的是社交身份的「來源」。在 Logto 的設計裡，我們不允許某一平台的連接器中有相同的「target」以避免身份的衝突。在添加連接器時，你需要格外小心，我們「不允許」用戶在創建之後更改「target」的值。<a>了解更多</a>",
        target_conflict: "此「身份供應商名稱」值與現有的 <span>name</span> 連接器相同。使用相同的身份供應商名稱會導致不符合預期的登錄行為，用戶可能通過兩個不同的連接器訪問同一個帳戶。",
        target_conflict_line2: "如果你想替換當前的連接器，並連接相同的身份提供商（IdP），以便先前的用戶可以直接登錄而無需重新註冊，請先刪除 <span>name</span> 連接器，再創建一個新的連接器並使用相同的「身份供應商名稱」值。",
        target_conflict_line3: "如果你想連接一個新的身份驗證提供程序，請修改「身份供應商名稱」並繼續。",
        config: "粘貼你的 JSON 代碼",
        sync_profile: "開啟用戶資料同步",
        sync_profile_only_at_sign_up: "首次註冊時同步",
        sync_profile_each_sign_in: "每次登錄時同步",
        sync_profile_tip: "同步用戶的用戶名、頭像等個人資料信息",
        callback_uri: "Callback URI",
        callback_uri_description: "也稱為重定向 URI，在社交授權後，用戶將被發送回 Logto 的 URI，複製並粘貼到社交提供者的配置頁面中。",
        acs_url: "斷言消費者服務網址"
    },
    platform: {
        universal: "通用",
        web: "網頁",
        native: "原生"
    },
    add_multi_platform: "支持多平臺，選擇一個平臺繼續",
    drawer_title: "連接器配置指南",
    drawer_subtitle: "參考以下步驟完善或修改你的連接器設置",
    unknown: "未知連接器",
    standard_connectors: "標準連接器"
};
var $559e9fb8c669cafb$export$2e2bcd8739ae039 = Object.freeze($559e9fb8c669cafb$var$connectors);


const $f958125aab43cddb$var$contact = {
    title: "取得協助",
    description: "若需協助申請或產品反饋，請透過下列方法與我們聯繫。",
    discord: {
        title: "加入 Discord 社群",
        description: "與其他開發人員一起尋找解決方案",
        button: "加入"
    },
    github: {
        title: "在 GitHub 上溝通",
        description: "在 GitHub 建立一個問題並提交",
        button: "開啟"
    },
    email: {
        title: "透過電子郵件聯繫支援",
        description: "發送電子郵件以獲得更多資訊和協助",
        button: "發送"
    },
    reserve: {
        title: "與 Logto 團隊預定時間",
        description: "快速預定與我們團隊的一對一會話",
        button: "預定"
    }
};
var $f958125aab43cddb$export$2e2bcd8739ae039 = Object.freeze($f958125aab43cddb$var$contact);


const $f4302758b0846479$var$dashboard = {
    page_title: "儀表板",
    title: "儀表板",
    description: "查看所有應用的數據概況",
    total_users: "總用戶",
    total_users_tip: "總用戶",
    new_users_today: "今日新增",
    new_users_today_tip: "今日註冊到你應用上的新用戶數",
    new_users_7_days: "7 日新增",
    new_users_7_days_tip: "最近 7 日註冊到你應用上的新用戶數",
    daily_active_users: "日活用戶",
    daily_active_users_tip: "今日在你的應用上交換過 token 的獨立用戶數",
    weekly_active_users: "周活用戶",
    weekly_active_users_tip: "最近 7 日在你的應用上交換過 token 的獨立用戶數",
    monthly_active_users: "月活用戶",
    monthly_active_users_tip: "最近 30 日在你的應用上交換過 token 的獨立用戶數"
};
var $f4302758b0846479$export$2e2bcd8739ae039 = Object.freeze($f4302758b0846479$var$dashboard);


const $ed804ace730657d8$var$domain = {
    status: {
        connecting: "連線中...",
        in_use: "使用中",
        failed_to_connect: "連線失敗"
    },
    update_endpoint_notice: "不要忘記在應用程序中更新社交連接器回調 URI 和 Logto 端點的域，如果您想使用自定義域來使用這些功能。<a>{{link}}</a>",
    error_hint: "請確保您更新了您的 DNS 記錄。 我們將繼續每{{value}}秒檢查一次。",
    custom: {
        custom_domain: "自訂網域",
        custom_domain_description: "提高品牌形象，使用自訂網域。此網域將用於您的登錄體驗。",
        custom_domain_field: "自訂網域",
        custom_domain_placeholder: "your.domain.com",
        add_domain: "新增網域",
        invalid_domain_format: '請提供一個有效的域名網址，至少包含三個部分，例如 "your.domain.com."',
        verify_domain: "驗證網域",
        enable_ssl: "啟用 SSL",
        checking_dns_tip: "當您配置 DNS 記錄後，這個過程將自動運行，它可能需要長達 24 小時。 您可以在運行期間離開這個介面。",
        enable_ssl_tip: "啟用 SSL 將自動運行，可能需要長達 24 小時。您可以在運行期間離開此介面。",
        generating_dns_records: "正在生成 DNS 記錄...",
        add_dns_records: "請將這些 DNS 記錄添加到您的 DNS 供應商。",
        dns_table: {
            type_field: "類型",
            name_field: "名稱",
            value_field: "值"
        },
        deletion: {
            delete_domain: "刪除網域",
            reminder: "刪除自定義網域",
            description: "您確定要刪除此自定義網域嗎？",
            in_used_description: '您確定要刪除此自定義網域 "<span>{{domain}}</span>" 嗎？',
            in_used_tip: '如果您以前在社交聯繫運營商或應用端點中設置了此自定義網域，則需要先將 URI 更改為 Logto 默認網域"<span>{{domain}}</span>"。 這是社交登錄按鈕正常工作所必需的。',
            deleted: "成功刪除自定義網域！"
        }
    },
    default: {
        default_domain: "預設網域",
        default_domain_description: "Logto 提供預先配置的預設網域，無需進行任何其他設置即可使用。即使啟用了自訂網域，此預設網域也可作為備用選項。",
        default_domain_field: "Logto 默認網域"
    },
    custom_endpoint_note: "您可以根據需要自定義這些端點的域名。選擇“{{custom}}”或“{{default}}”。",
    custom_social_callback_url_note: "您可以自定義此 URI 的域名以匹配您的應用程序端點。選擇“{{custom}}”或“{{default}}”。",
    custom_acs_url_note: "您可以自訂此 URI 的域名以匹配您的身份提供者斷言使用者服務 URL。選擇“{{custom}}”或“{{default}}”。"
};
var $ed804ace730657d8$export$2e2bcd8739ae039 = Object.freeze($ed804ace730657d8$var$domain);


const $2dc0f227dd098204$var$enterprise_sso_details = {
    back_to_sso_connectors: "返回企業SSO",
    page_title: "企業SSO連接器詳細資料",
    readme_drawer_title: "企業SSO",
    readme_drawer_subtitle: "設置企業SSO連接器以啟用最終用戶SSO",
    tab_experience: "SSO體驗",
    tab_connection: "連接",
    general_settings_title: "一般",
    custom_branding_title: "顯示",
    custom_branding_description: "自定义在最终用户單點登錄流程中顯示的名稱和標識。 為空時，將使用默認值。",
    email_domain_field_name: "企業郵箱域",
    email_domain_field_description: "擁有此郵箱域的用戶可以使用SSO進行身份驗證。 請驗證該域是否屬於企業。",
    email_domain_field_placeholder: "郵箱域",
    sync_profile_field_name: "從身份提供者同步配置文件信息",
    sync_profile_option: {
        register_only: "僅在首次登錄時同步",
        each_sign_in: "每次登錄時都同步"
    },
    connector_name_field_name: "連接器名稱",
    display_name_field_name: "顯示名稱",
    connector_logo_field_name: "顯示標識",
    connector_logo_field_description: "每個圖像應該小於500KB，僅支持SVG、PNG、JPG、JPEG。",
    branding_logo_context: "上傳標識",
    branding_logo_error: "上傳標識錯誤: {{error}}",
    branding_light_logo_context: "上傳亮色模式標識",
    branding_light_logo_error: "上傳亮色模式標識錯誤: {{error}}",
    branding_logo_field_name: "標識",
    branding_logo_field_placeholder: "https://your.domain/logo.png",
    branding_dark_logo_context: "上傳暗色模式標識",
    branding_dark_logo_error: "上傳暗色模式標識錯誤: {{error}}",
    branding_dark_logo_field_name: "標識（暗色模式）",
    branding_dark_logo_field_placeholder: "https://your.domain/dark-mode-logo.png",
    check_connection_guide: "連接指南",
    enterprise_sso_deleted: "企業SSO連接器已成功刪除",
    delete_confirm_modal_title: "刪除企業SSO連接器",
    delete_confirm_modal_content: "您確定要刪除此企業連接器嗎？ 身份提供者的用戶將不會利用單點登錄。",
    upload_idp_metadata_title_saml: "上傳元數據",
    upload_idp_metadata_description_saml: "配置從身份提供者複製的元數據。",
    upload_idp_metadata_title_oidc: "上傳憑證",
    upload_idp_metadata_description_oidc: "配置從身份提供者複製的憑證和OIDC令牌信息。",
    upload_idp_metadata_button_text: "上傳元數據XML文件",
    upload_signing_certificate_button_text: "上傳簽名憑證文件",
    configure_domain_field_info_text: "添加郵箱域以指導企業用戶到其身份提供者進行單點登錄。",
    email_domain_field_required: "需要郵箱域以啟用企業SSO。",
    upload_saml_idp_metadata_info_text_url: "將身份提供者的元數據URL粘貼到此處以進行連接。",
    upload_saml_idp_metadata_info_text_xml: "粘貼來自身份提供者的元數據以進行連接。",
    upload_saml_idp_metadata_info_text_manual: "填寫來自身份提供者的元數據以進行連接。",
    upload_oidc_idp_info_text: "填寫來自身份提供者的信息以進行連接。",
    service_provider_property_title: "在IdP中進行配置",
    service_provider_property_description: "使用{{protocol}}在您的身份提供者中設置應用程序集成。 輸入Logto提供的詳細信息。",
    attribute_mapping_title: "屬性映射",
    attribute_mapping_description: "通過在身份提供者或Logto端配置用戶屬性映射，從身份提供者同步用戶配置文件。",
    saml_preview: {
        sign_on_url: "登錄URL",
        entity_id: "發行者",
        x509_certificate: "簽名憑證",
        certificate_content: "過期於{{date}}"
    },
    oidc_preview: {
        authorization_endpoint: "授權終點",
        token_endpoint: "令牌終點",
        userinfo_endpoint: "用戶信息終點",
        jwks_uri: "JSON Web金鑰集終點",
        issuer: "發行者"
    }
};
var $2dc0f227dd098204$export$2e2bcd8739ae039 = Object.freeze($2dc0f227dd098204$var$enterprise_sso_details);


const $ba5e935b43967a28$var$enterprise_sso = {
    page_title: "企業單一登入",
    title: "企業單一登入",
    subtitle: "連接企業身份提供者，啟用 SP 啟動的單一登入。",
    create: "新增企業連接器",
    col_connector_name: "連接器名稱",
    col_type: "類型",
    col_email_domain: "電子郵件域",
    placeholder_title: "企業連接器",
    placeholder_description: "Logto 提供了許多內置的企業身份提供者，同時你也可以使用 SAML 和 OIDC 協議自定義自己的連接器。",
    create_modal: {
        title: "新增企業連接器",
        text_divider: "或者你可以按照標準協議自定義你的連接器。",
        connector_name_field_title: "連接器名稱",
        connector_name_field_placeholder: "例如，{企業名稱} - {身份提供者名稱}",
        create_button_text: "創建連接器"
    },
    guide: {
        subtitle: "一個逐步指南，連接企業身份提供者。",
        finish_button_text: "繼續"
    },
    basic_info: {
        title: "在 IdP 中配置您的服務",
        description: "在您的 {{name}} 身份提供者中使用 SAML 2.0 建立新的應用集成。然後將以下值粘貼到其中。",
        saml: {
            acs_url_field_name: "斷言消費服務 URL（回覆 URL）",
            audience_uri_field_name: "受眾 URI（SP 實體 ID）"
        },
        oidc: {
            redirect_uri_field_name: "重定向 URI（回撥 URL）"
        }
    },
    attribute_mapping: {
        title: "屬性映射",
        description: "需要`id`和`email`來同步用戶檔案從 IdP。 在您的 IdP 中輸入以下聲明名稱和值。",
        col_sp_claims: "服務提供者（Logto）的值",
        col_idp_claims: "身份提供者的聲明名稱",
        idp_claim_tooltip: "身份提供者的聲明名稱"
    },
    metadata: {
        title: "配置 IdP 元數據",
        description: "從身份提供者配置元數據",
        dropdown_trigger_text: "使用其他配置方法",
        dropdown_title: "選擇你的配置方法",
        metadata_format_url: "輸入元數據 URL",
        metadata_format_xml: "上傳元數據 XML 檔案",
        metadata_format_manual: "手動輸入元數據細節",
        saml: {
            metadata_url_field_name: "元數據 URL",
            metadata_url_description: "動態從元數據 URL 中獲取數據並保持憑證最新。",
            metadata_xml_field_name: "IdP 元數據 XML 檔案",
            metadata_xml_uploader_text: "上傳元數據 XML 檔案",
            sign_in_endpoint_field_name: "登錄 URL",
            idp_entity_id_field_name: "IdP 實體 ID（發行者）",
            certificate_field_name: "簽名憑證",
            certificate_placeholder: "複製並粘貼 x509 憑證",
            certificate_required: "簽名憑證是必需的。"
        },
        oidc: {
            client_id_field_name: "客戶端 ID",
            client_secret_field_name: "客戶端密鑰",
            issuer_field_name: "發行者",
            scope_field_name: "範圍"
        }
    }
};
var $ba5e935b43967a28$export$2e2bcd8739ae039 = Object.freeze($ba5e935b43967a28$var$enterprise_sso);


const $edbec39baf6fbea8$var$errors = {
    something_went_wrong: "哎呀，出錯了！",
    page_not_found: "找不到頁面",
    unknown_server_error: "伺服器發生未知錯誤",
    empty: "沒有資料",
    missing_total_number: "無法從返回的頭部訊息中找到 Total-Number",
    invalid_uri_format: "無效的 URI 格式",
    invalid_origin_format: "無效的 URI origin 格式",
    invalid_json_format: "無效的 JSON 格式",
    invalid_regex: "非法的正則表達式",
    invalid_error_message_format: "非法的錯誤訊息格式",
    required_field_missing: "請輸入{{field}}",
    required_field_missing_plural: "至少需要輸入一個{{field}}",
    more_details: "查看詳情",
    username_pattern_error: "用戶名只能包含英文字母、數字或下劃線，且不以數字開頭。",
    email_pattern_error: "郵箱地址無效",
    phone_pattern_error: "手機號碼無效",
    insecure_contexts: "不支援不安全的上下文（非 HTTPS）。",
    unexpected_error: "發生未知錯誤",
    not_found: "404 找不到資源",
    create_internal_role_violation: '你正在創建一個被 Logto 禁止的內部角色。嘗試使用不以 "#internal:" 開頭的其他名稱。',
    should_be_an_integer: "應該是整數。",
    number_should_be_between_inclusive: "數字應該在 {{min}} 和 {{max}} 之間（均包含）。"
};
var $edbec39baf6fbea8$export$2e2bcd8739ae039 = Object.freeze($edbec39baf6fbea8$var$errors);


const $41e60829fa1c9f87$var$general = {
    placeholder: "占位符",
    submit: "提交",
    skip: "跳過",
    next: "下一步",
    back: "上一步",
    retry: "重試",
    done: "完成",
    search: "搜索",
    search_placeholder: "搜索",
    clear_result: "清除結果",
    save: "儲存",
    save_changes: "儲存更改",
    saved: "儲存成功",
    discard: "放棄",
    loading: "讀取中...",
    redirecting: "頁面跳轉中...",
    add: "新增",
    added: "已新增",
    cancel: "取消",
    confirm: "確認",
    check_out: "查看",
    create: "建立",
    set_up: "設置",
    customize: "自定義",
    enable: "啟用",
    reminder: "提示",
    edit: "編輯",
    delete: "刪除",
    deleted: "已刪除",
    more_options: "更多選項",
    close: "關閉",
    copy: "複製",
    copying: "複製中",
    copied: "已複製",
    required: "必填",
    add_another: "新增",
    create_another: "創建另一個",
    deletion_confirmation: "你確定要刪除這個 {{title}} 嗎?",
    settings_nav: "設置",
    unsaved_changes_warning: "還有未儲存的變更, 確定要離開嗎？",
    leave_page: "離開此頁",
    stay_on_page: "留在此頁",
    type_to_search: "輸入搜尋",
    got_it: "知道了",
    continue: "繼續",
    page_info: "{{min, number}}-{{max, number}} 共 {{total, number}} 條",
    learn_more: "了解更多",
    tab_errors: "{{count, number}} 個錯誤",
    skip_for_now: "先跳過",
    remove: "移除",
    visit: "訪問",
    join: "加入",
    try_now: "現在試試",
    multiple_form_field: "（多選）",
    demo: "演示",
    unnamed: "未命名",
    view: "查看",
    open: "打開",
    hide: "隱藏",
    unknown_error: "未知錯誤，請稍後重試。",
    select: "選擇",
    contact_us_action: "聯絡我們",
    description: "描述",
    name: "名稱",
    add_field: "新增{{field}}",
    create_field: "創建{{field}}",
    edit_field: "編輯{{field}}",
    delete_field: "刪除{{field}}",
    coming_soon: "即將上線",
    or: "或"
};
var $41e60829fa1c9f87$export$2e2bcd8739ae039 = Object.freeze($41e60829fa1c9f87$var$general);


const $62ed43ab0d0a99a2$var$get_started = {
    page_title: "開始上手",
    title: "成功開發身份方案，我們先來探索一番",
    subtitle: "一些快速獲取 Logto 價值的事情",
    develop: {
        title: "開發：花 5 分鐘集成您的應用程式",
        title_cloud: "開發：在幾分鐘內安全集成您的應用程式",
        subtitle_cloud: "或花 5 分鐘用我們預先構建的 SDK 和教程集成您的應用程式。"
    },
    customize: {
        title: "自訂：提供出色的登錄體驗",
        preview: {
            title: "查看您剛自訂的登錄體驗的實時預覽",
            subtitle: "立即嘗試 Logto 登錄體驗，了解其工作原理"
        },
        connector: {
            title: "添加更多連接器以支持更多社交登錄方式",
            subtitle: "嘗試無密碼登錄，為您的客戶啟用安全、無摩擦的體驗"
        },
        continue_customizing: "繼續自訂",
        try_now: "立即嘗試",
        add_more: "添加更多"
    },
    secure: {
        title: "安全：保護您的資源"
    },
    manage: {
        title: "管理：為您的產品和用戶定義訪問控制",
        rbac: {
            title: "添加基於角色的訪問控制以保護您的資源",
            subtitle: "通過可擴展的角色授權，來控制不同用例的資源"
        },
        create_roles: "創建角色"
    },
    view_all: "查看全部 →"
};
var $62ed43ab0d0a99a2$export$2e2bcd8739ae039 = Object.freeze($62ed43ab0d0a99a2$var$get_started);


const $36747702ec29a5da$var$guide = {
    start_building: "開始構建",
    get_started: "立即開始",
    categories: {
        featured: "推薦熱門開發框架",
        Traditional: "傳統網頁應用",
        SPA: "單頁應用",
        Native: "原生應用",
        MachineToMachine: "機器對機器",
        Protected: "非 SDK 整合",
        ThirdParty: "第三方應用程式"
    },
    filter: {
        title: "篩選框架",
        placeholder: "搜索框架"
    },
    checkout_tutorial: "查看 {{name}} 教程",
    do_not_need_tutorial: "如果你現在不需要教程，可以點擊右側按鈕繼續創建應用",
    finish_and_done: "完成",
    cannot_find_guide: "找不到你想要的教程？",
    describe_guide_looking_for: "描述你正在尋找的教程",
    request_guide_successfully: "請求已成功提交，謝謝！",
    app: {
        select_framework_or_tutorial: "選擇一個框架或教程",
        guide_modal_title: "從 SDK 和指南開始",
        modal_subtitle: "使用我們提供的 SDK 和集成教程加速你的應用開發過程。",
        select_a_framework: "選擇一個框架",
        continue_without_framework: "跳過教程直接創建應用",
        describe_guide_looking_for_placeholder: "例如：我想將 Logto 集成到我的 Angular 應用程式中。"
    },
    api: {
        modal_title: "首先從教程開始",
        modal_subtitle: "使用我們提供的教程來加速你的應用程式開發過程。",
        select_a_tutorial: "選擇一個教程",
        continue_without_tutorial: "跳過教程直接創建 API 資源",
        describe_guide_looking_for_placeholder: "例如：我想使用 deno 框架驗證我的 API。"
    }
};
var $36747702ec29a5da$export$2e2bcd8739ae039 = Object.freeze($36747702ec29a5da$var$guide);


const $09faac63a871b242$var$invitation = {
    find_your_tenants: "尋找你的租戶",
    find_tenants_description: "你的電子郵件地址可能已被多個租戶註冊。您可以選擇加入現有的租戶或繼續建立一個新的。",
    create_new_tenant: "建立新租戶",
    email_not_match_title: "您目前以\n{{email}}\n登錄",
    email_not_match_description: "請使用正確的帳戶登入以接受邀請並成為組織成員。",
    switch_account: "登入到另一個帳戶",
    invalid_invitation_status: "無效的邀請。請聯繫管理員並重試。",
    invitation_not_found: "找不到邀請。請聯繫管理員。"
};
var $09faac63a871b242$export$2e2bcd8739ae039 = Object.freeze($09faac63a871b242$var$invitation);


const $564e7dade36ed9f5$var$jwt_claims = {
    title: "自定義 JWT",
    description: "設置自定義 JWT 声明以包含在訪問令牌中。這些聲明可用於向應用程序傳遞附加信息。",
    user_jwt: {
        card_title: "針對用戶",
        card_field: "用戶訪問令牌",
        card_description: "在發出訪問令牌時添加用戶特定數據。",
        for: "針對用戶"
    },
    machine_to_machine_jwt: {
        card_title: "針對 M2M",
        card_field: "機器對機器令牌",
        card_description: "在發出機器對機器令牌時添加額外數據。",
        for: "針對 M2M"
    },
    code_editor_title: "自定義 {{token}} 声明",
    custom_jwt_create_button: "添加自定義声明",
    custom_jwt_item: "自定義声明 {{for}}",
    delete_modal_title: "刪除自定義声明",
    delete_modal_content: "您確定要刪除自定義声明嗎？",
    clear: "清除",
    cleared: "已清除",
    restore: "恢復默認值",
    restored: "已恢復",
    data_source_tab: "數據源",
    test_tab: "測試上下文",
    jwt_claims_description: "默認声明自動包含在 JWT 中，無法覆蓋。",
    user_data: {
        title: "用戶數據",
        subtitle: "使用 `data.user` 輸入參數提供重要用戶信息。"
    },
    token_data: {
        title: "令牌數據",
        subtitle: "使用 `token` 輸入參數獲取當前訪問令牌有效載荷。"
    },
    fetch_external_data: {
        title: "提取外部數據",
        subtitle: "直接將來自外部 APIs 的數據合併到声明中。",
        description: "使用 `fetch` 函數調用外部 APIs 並將數據包含在您的自定義声明中。示例："
    },
    environment_variables: {
        title: "設置環境變量",
        subtitle: "使用環境變量存儲敏感信息。",
        input_field_title: "添加環境變量",
        sample_code: "在自定義 JWT 声明處理程序中訪問環境變量。示例："
    },
    jwt_claims_hint: "將自定義声明限制在 50KB 以下。默認 JWT 声明將自動包含在令牌中，無法覆蓋。",
    tester: {
        subtitle: "調整測試用的模擬令牌和用戶數據。",
        run_button: "運行測試",
        result_title: "測試結果"
    },
    form_error: {
        invalid_json: "無效的 JSON 格式"
    }
};
var $564e7dade36ed9f5$export$2e2bcd8739ae039 = Object.freeze($564e7dade36ed9f5$var$jwt_claims);


const $8db5c39afdfb6615$var$log_details = {
    page_title: "審計日誌詳情",
    back_to_logs: "返回審計日誌",
    back_to: "返回 {{name}}",
    success: "成功",
    failed: "失敗",
    event_key: "事件 Key",
    application: "應用",
    ip_address: "IP 地址",
    user: "使用者",
    log_id: "日誌 ID",
    time: "時間",
    user_agent: "使用者代理",
    tab_details: "詳情",
    raw_data: "原始資料"
};
var $8db5c39afdfb6615$export$2e2bcd8739ae039 = Object.freeze($8db5c39afdfb6615$var$log_details);


const $6976b54da3b20715$var$logs = {
    page_title: "審計日誌",
    title: "審計日誌",
    subtitle: "查看使用者行為和事件",
    event: "事件",
    user: "使用者",
    application: "應用程式",
    time: "時間",
    filter_by: "過濾"
};
var $6976b54da3b20715$export$2e2bcd8739ae039 = Object.freeze($6976b54da3b20715$var$logs);


const $d7f0df2de9c64bb8$var$menu = {
    profile: "帳戶管理",
    language: "語言",
    appearance: {
        label: "主題",
        light: "淺色模式",
        dark: "深色模式",
        system: "跟隨系統"
    },
    sign_out: "退出登錄"
};
var $d7f0df2de9c64bb8$export$2e2bcd8739ae039 = Object.freeze($d7f0df2de9c64bb8$var$menu);


const $5bbc4569e18770ad$var$mfa = {
    title: "多因素身份驗證",
    description: "添加多因素身份驗證以提升您登錄體驗的安全性。",
    factors: "因素",
    multi_factors: "多因素",
    multi_factors_description: "用戶需要驗證啟用的其中一個因素以進行兩步驗證。",
    totp: "身份驗證應用 OTP",
    otp_description: "將 Google Authenticator 等連接起來，以驗證一次性密碼。",
    webauthn: "WebAuthn（通行證）",
    webauthn_description: "通過瀏覽器支持的方法進行驗證：生物識別、手機掃描或安全密鑰等。",
    webauthn_native_tip: "本地應用不支持 WebAuthn。",
    webauthn_domain_tip: "WebAuthn將公共密鑰綁定到特定域。修改服務域將阻止用戶通過現有通行證進行身份驗證。",
    backup_code: "備份代碼",
    backup_code_description: "在用戶設置任何MFA方法後生成10個一次性備份代碼。",
    backup_code_setup_hint: "當用戶無法驗證上述MFA因素時，使用備份選項。",
    backup_code_error_hint: "要使用備份代碼，您需要至少再添加一種MFA方法以成功進行用戶身份驗證。",
    policy: "策略",
    policy_description: "設置登錄和註冊流程的MFA策略。",
    two_step_sign_in_policy: "登錄時的雙步驗證策略",
    user_controlled: "用戶可以自行啟用或禁用MFA",
    user_controlled_tip: "用戶可以在首次登錄或註冊時跳過MFA設置，或在帳戶設置中啟用/禁用它。",
    mandatory: "用戶總是需要在登錄時使用MFA",
    mandatory_tip: "用戶必須在首次登錄或註冊時設置MFA，並在以後的所有登錄中使用它。"
};
var $5bbc4569e18770ad$export$2e2bcd8739ae039 = Object.freeze($5bbc4569e18770ad$var$mfa);


const $b3b43326165a975b$var$organization_details = {
    page_title: "組織詳情",
    delete_confirmation: "刪除後，所有成員將失去在這個組織中的成員資格和角色。此操作無法撤銷。",
    organization_id: "組織編號",
    settings_description: "組織代表可以訪問您的應用程序的團隊、業務客戶和合作夥伴公司。",
    name_placeholder: "組織名稱，不需要是唯一的。",
    description_placeholder: "組織的描述。",
    member: "成員",
    member_other: "成員",
    add_members_to_organization: "將成員添加到 {{name}} 組織",
    add_members_to_organization_description: "通過搜索名稱、電子郵件、電話或用戶ID來查找適合的用戶。現有成員不會顯示在搜索結果中。",
    add_with_organization_role: "添加組織角色",
    user: "用戶",
    authorize_to_roles: "授權 {{name}} 訪問以下角色：",
    edit_organization_roles: "編輯組織角色",
    edit_organization_roles_of_user: "編輯 {{name}} 的組織角色",
    remove_user_from_organization: "從組織中刪除用戶",
    remove_user_from_organization_description: "刪除後，用戶將失去在這個組織中的成員資格和角色。此操作無法撤銷。",
    search_user_placeholder: "按名稱、電子郵件、電話或用戶ID搜尋",
    at_least_one_user: "至少需要一個用戶。",
    custom_data: "自訂數據",
    custom_data_tip: "自訂數據是一個可用於存儲與組織相關的附加數據的 JSON 對象。",
    invalid_json_object: "無效的 JSON 對象。"
};
var $b3b43326165a975b$export$2e2bcd8739ae039 = Object.freeze($b3b43326165a975b$var$organization_details);


const $71ce3e454b641231$var$organization_role_details = {
    page_title: "組織角色詳情",
    back_to_org_roles: "返回組織角色",
    org_role: "組織角色",
    delete_confirm: "這樣做將會從受影響的使用者中移除與此角色相關聯的權限，並刪除組織角色、組織成員和組織權限之間的關係。",
    deleted: "組織角色 {{name}} 已成功刪除。",
    permissions: {
        tab: "權限",
        name_column: "權限",
        description_column: "描述",
        type_column: "權限類型",
        type: {
            api: "API 權限",
            org: "組織權限"
        },
        assign_permissions: "分配權限",
        remove_permission: "移除權限",
        remove_confirmation: "如果移除此權限，擁有此組織角色的使用者將失去此權限所授予的存取權。",
        removed: "權限 {{name}} 已成功從此組織角色中移除",
        assign_description: "為此組織中的角色分配權限。這些可以包括組織權限和 API 權限。",
        organization_permissions: "組織權限",
        api_permissions: "API 權限",
        assign_organization_permissions: "分配組織權限",
        assign_api_permissions: "分配API許可權"
    },
    general: {
        tab: "一般",
        settings: "設置",
        description: "組織角色是可以分配給用戶的權限分組。權限可以來自預設的組織權限和API權限。",
        name_field: "名稱",
        description_field: "描述",
        description_field_placeholder: "僅具有查看權限的使用者"
    }
};
var $71ce3e454b641231$export$2e2bcd8739ae039 = Object.freeze($71ce3e454b641231$var$organization_role_details);


const $c1f1f2ae473ba592$var$organization_template = {
    title: "組織模板",
    subtitle: "在多租戶 SaaS 應用中，組織範本定義了多個組織的共享訪問控制政策（權限和角色）。",
    roles: {
        tab_name: "組織角色",
        search_placeholder: "按角色名稱搜尋",
        create_title: "創建組織角色",
        role_column: "組織角色",
        permissions_column: "權限",
        placeholder_title: "組織角色",
        placeholder_description: "組織角色是一組可以分配給使用者的權限。權限必須來自預定義的組織權限。",
        create_modal: {
            title: "建立組織角色",
            create: "建立角色",
            name_field: "角色名稱",
            description_field: "描述",
            created: "成功建立組織角色 {{name}}。"
        }
    },
    permissions: {
        tab_name: "組織權限",
        search_placeholder: "按權限名稱搜尋",
        create_org_permission: "創建組織權限",
        permission_column: "組織權限",
        description_column: "描述",
        placeholder_title: "組織權限",
        placeholder_description: "組織權限指的是在組織上下文中訪問資源的授權。",
        delete_confirm: "如果刪除此權限，包括此權限的所有組織角色都將失去此權限，擁有此權限的使用者將失去由此權限授予的訪問權限。",
        create_title: "創建組織權限",
        edit_title: "編輯組織權限",
        permission_field_name: "權限名稱",
        description_field_name: "描述",
        description_field_placeholder: "閱讀預約歷史",
        create_permission: "創建權限",
        created: "組織權限 {{name}} 已成功建立。"
    }
};
var $c1f1f2ae473ba592$export$2e2bcd8739ae039 = Object.freeze($c1f1f2ae473ba592$var$organization_template);


const $1607c2e3d28d805e$var$organizations = {
    organization: "組織",
    page_title: "組織",
    title: "組織",
    subtitle: "組織通常在SaaS或類似的多租戶應用程式中使用，代表您的客戶，這些客戶可以是團隊、組織或整個公司。 組織作為B2B身份驗證和授權的基本元素。",
    organization_template: "組織模板",
    organization_id: "組繹 ID",
    members: "成員",
    create_organization: "建立組繹",
    setup_organization: "設立您的組繹",
    organization_list_placeholder_title: "組繹",
    organization_list_placeholder_text: "組繹通常在SaaS或類似的多租戶應用程式中作為最佳做法使用。 它們使您能夠開發應用程式，讓客戶可以創建和管理組繹、邀請成員並分配角色。",
    organization_name_placeholder: "我的組繹",
    organization_description_placeholder: "組繹的簡要描述",
    organization_permission: "組繹權限",
    organization_permission_other: "組繹權限",
    create_permission_placeholder: "瀏覽預約歷史",
    organization_role: "組繹角色",
    organization_role_other: "組繹角色",
    organization_role_description: "組繹角色是一組可以分配給用戶的權限。 這些權限必須來自預定義的組繹權限。",
    role: "角色",
    search_placeholder: "按組繹名稱或 ID 搜索",
    search_role_placeholder: "輸入搜索並選擇角色",
    empty_placeholder: "\uD83E\uDD14 你目前尚未設置任何 {{entity}}。",
    organization_and_member: "組繹和成員",
    organization_and_member_description: "組繹是一個用戶組的群組，可以代表團隊、商業客戶和合作夥伴公司，每個用戶都是一個「成員」。 這些可以是處理多租戶需求的基本實體。",
    guide: {
        title: "從指南開始",
        subtitle: "使用我們的指南快速開始組繹設定",
        introduction: {
            title: "讓我們了解組繹在 Logto 中的運作方式",
            section_1: {
                title: "組繹是一組用戶(身分)組成的集團"
            },
            section_2: {
                title: "組繹模板旨在用於多租戶應用程式存取控制",
                description: "在多租戶SaaS應用程式中，多個組繹通常共用相同的存取控制模板，其中包括權限和角色。 在Logto中，我們稱之為「組繹模板」。",
                permission_description: "組繹權限是指在組繹上下文中訪問資源的授權。",
                role_description_deprecated: "組繭角色是一組組繹權限，可以分配給成員。",
                role_description: "組繹角色是可以分配給成員的組繹權限或API權限的分組。"
            },
            section_3: {
                title: "我可以將API權限指派給組繹角色嗎？",
                description: "是的，您可以將API權限指派給組繭角色。 Logto提供彈性，有效管理您組繹的角色，允許您在這些角色中包含組繭權限和API權限。"
            },
            section_4: {
                title: "與插圖互動，查看所有連結如何互相連接",
                description: "讓我們舉個例子。約翰、莎拉屬於不同的組繫，並在不同組繫的上下文中擔任不同角色。 將滑鼠指針懸停在不同的模塊上並觀察會發生什麼。"
            }
        },
        organization_permissions: "組繹權限",
        organization_roles: "組繹角色",
        admin: "管理員",
        member: "成員",
        guest: "訪客",
        role_description: '角色 "{{role}}" 在不同的組繭中共用相同的組繹模板。',
        john: "約翰",
        john_tip: '約翰的電子郵件地址為 "john@email.com"，他屬於兩個組繹，分別作為組繹 A 的管理員和組繹 B 的訪客。',
        sarah: "莎拉",
        sarah_tip: '莎拉的電子郵件地址為 "sarah@email.com"，她屬於一個組繹，並擔任組繹 B 的管理員。'
    }
};
var $1607c2e3d28d805e$export$2e2bcd8739ae039 = Object.freeze($1607c2e3d28d805e$var$organizations);


const $9bf007323fb4ac90$var$permissions = {
    search_placeholder: "通過 API 或權限名稱搜索",
    search_placeholder_without_api: "通過權限名稱搜索",
    name_column: "權限",
    description_column: "描述",
    api_column: "API",
    placeholder_title: "權限",
    placeholder_description: "權限是指訪問資源的授權（我們稱其為 API 資源）。",
    edit: "編輯權限",
    delete: "刪除權限",
    remove: "移除權限",
    edit_title: "編輯 API 權限"
};
var $9bf007323fb4ac90$export$2e2bcd8739ae039 = Object.freeze($9bf007323fb4ac90$var$permissions);


const $50edca06f3e6dc78$var$profile = {
    page_title: "賬戶管理",
    title: "賬戶管理",
    description: "在這裡，你可以修改賬戶設置和管理個人信息，以確保賬戶安全。",
    settings: {
        title: "賬戶設置",
        profile_information: "個人信息",
        avatar: "頭像",
        name: "姓名",
        username: "用戶名"
    },
    link_account: {
        title: "關聯賬戶",
        email_sign_in: "郵件登錄",
        email: "郵件",
        social_sign_in: "社交賬號登錄",
        link_email: "綁定郵箱",
        link_email_subtitle: "綁定郵箱以便登錄或幫助恢復賬戶。",
        email_required: "郵箱不能為空",
        invalid_email: "無效的郵箱地址",
        identical_email_address: "輸入的郵箱地址與當前郵箱地址相同",
        anonymous: "匿名"
    },
    password: {
        title: "密碼與安全",
        password: "密碼",
        password_setting: "密碼設置",
        new_password: "新密碼",
        confirm_password: "確認密碼",
        enter_password: "輸入目前密碼",
        enter_password_subtitle: "為確保帳戶安全，在修改密碼前，請先輸入目前密碼以通過身份驗證。",
        set_password: "設置密碼",
        verify_via_password: "通過密碼驗證",
        show_password: "顯示密碼",
        required: "密碼不能為空",
        do_not_match: "密碼不匹配，請重新輸入。"
    },
    code: {
        enter_verification_code: "輸入驗證碼",
        enter_verification_code_subtitle: "驗證碼已發送至 <strong>{{target}}</strong>",
        verify_via_code: "通過郵箱驗證碼驗證",
        resend: "重新發送驗證碼",
        resend_countdown: "在 {{countdown}} 秒後重新發送"
    },
    delete_account: {
        title: "刪除賬戶",
        label: "刪除賬戶",
        description: "刪除賬戶將會刪除所有個人信息、用戶數據和配置。此操作無法撤銷。",
        button: "刪除賬戶",
        dialog_paragraph_1: "很抱歉聽到你想要刪除你的帳户。刪除你的帳户將永久刪除所有數據，包括用戶信息、日誌和設置，此操作無法撤銷。因此，請確保在繼續之前備份任何重要數據。",
        dialog_paragraph_2: "要繼續刪除帳戶的刪除過程，請通過 <a>電子郵件</a> 向我們的支持團隊發送主題為“帳戶刪除請求”的郵件。我們將協助你並確保所有數據都已從我們的系統中正確刪除。",
        dialog_paragraph_3: "感謝你選擇 Logto Cloud。如果你有任何進一步的問題或疑慮，請隨時與我們聯繫。"
    },
    set: "設置",
    change: "修改",
    link: "關聯",
    unlink: "取消關聯",
    not_set: "未設置",
    change_avatar: "修改頭像",
    change_name: "修改姓名",
    change_username: "修改用戶名",
    set_name: "設置姓名",
    email_changed: "已成功綁定郵箱。",
    password_changed: "已重置密碼。",
    updated: "{{target}}更改成功。",
    linked: "{{target}}賬號綁定成功。",
    unlinked: "{{target}}賬號解綁成功。",
    email_exists_reminder: "該郵箱 {{email}} 已被其他賬號綁定，請更換郵箱。",
    unlink_confirm_text: "確定解綁",
    unlink_reminder: "解綁後，用戶將無法使用該 <span></span> 賬號進行登錄。確定要解綁嗎？"
};
var $50edca06f3e6dc78$export$2e2bcd8739ae039 = Object.freeze($50edca06f3e6dc78$var$profile);


const $126f6d7da7b456f3$var$protected_app = {
    name: "受保護應用程式",
    title: "建立受保護應用程式：使用簡單和極速添加身份驗證",
    description: "受保護應用程式安全地維護使用者會話並代理您的應用程式請求。由 Cloudflare Workers 提供支持，享受全球頂尖性能和 0ms 全球即開啟速度。<a>了解更多</a>",
    fast_create: "快速創建",
    modal_title: "建立受保護應用程式",
    modal_subtitle: "點擊啟用安全且高速的保護。輕鬆地為現有的 Web 應用程式添加身份驗證。",
    form: {
        url_field_label: "您的原始 URL",
        url_field_placeholder: "https://domain.com/",
        url_field_description: "提供需要身份驗證保護的應用程式地址。",
        url_field_modification_notice: "對原始 URL 的修改可能需要 1-2 分鐘在全球網絡位置生效。",
        url_field_tooltip: "提供應用程式的地址，不包括任何 '/pathname'。創建後，您可以自定義路由身份驗證規則。\n\n注意：原始 URL 本身不需要身份驗證；保護僅應用於通過指定應用程式域訪問的操作。",
        domain_field_label: "應用程式域",
        domain_field_placeholder: "your-domain",
        domain_field_description: "此 URL 用作原始 URL 的身份驗證保護代理。創建後可以應用自定義域。",
        domain_field_description_short: "此 URL 用作原始 URL 的身份驗證保護代理。",
        domain_field_tooltip: "由 Logto 保護的應用程式將默認托管在 'your-domain.{{domain}}'。創建後可以應用自定義域。",
        create_application: "創建應用程式",
        create_protected_app: "快速創建",
        errors: {
            domain_required: "需要您的域。",
            domain_in_use: "此子域名已在使用中。",
            invalid_domain_format: "無效的子域名格式：僅使用小寫字母、數字和破折號 '-'。",
            url_required: "需要原始 URL。",
            invalid_url: "無效的原始 URL 格式：使用 http:// 或 https://。注意：目前不支持 '/pathname'。",
            localhost: "請先將您的本地服務器暴露到互聯網上。了解有關<a>本地開發</a>的更多信息。"
        }
    },
    success_message: "\uD83C\uDF89 應用程式身份驗證已成功啟用！探索您的網站的新體驗。"
};
var $126f6d7da7b456f3$export$2e2bcd8739ae039 = Object.freeze($126f6d7da7b456f3$var$protected_app);


const $e41468785eb37aac$var$role_details = {
    back_to_roles: "返回角色",
    identifier: "識別符",
    delete_description: "這樣做將從受影響的用戶中刪除與該角色關聯的權限，並刪除角色、用戶和權限之間的映射關係。",
    role_deleted: "{{name}} 已成功刪除。",
    general_tab: "常規",
    users_tab: "用戶",
    m2m_apps_tab: "機器對機器應用",
    permissions_tab: "權限",
    settings: "設置",
    settings_description: "角色是一組權限，可以分配給用戶。它們還提供了一種聚合不同 API 定義的權限的方法，使得添加、刪除或調整權限比將其單獨分配給用戶更有效率。",
    field_name: "名稱",
    field_description: "描述",
    field_is_default: "默認角色",
    field_is_default_description: "將此角色設置為新用戶的默認角色。可以設置多個默認角色。這也將影響通過管理 API 創建的用戶的默認角色。",
    type_m2m_role_tag: "機器對機器應用角色",
    type_user_role_tag: "用戶角色",
    m2m_role_notification: "將此機器對機器角色分配給機器對機器應用程式，以授予相關API資源的存取權限。如果尚未建立，請<a>先建立機器對機器應用程式</a>。",
    permission: {
        assign_button: "分配權限",
        assign_title: "分配權限",
        assign_subtitle: "將權限分配給此角色。角色將獲得添加的權限，具有此角色的用戶將繼承這些權限。",
        assign_form_field: "分配權限",
        added_text_one: "添加了 {{count, number}} 個權限",
        added_text_other: "添加了 {{count, number}} 個權限",
        api_permission_count_one: "{{count, number}} 個權限",
        api_permission_count_other: "{{count, number}} 個權限",
        confirm_assign: "分配權限",
        permission_assigned: "所選的權限已成功分配給此角色",
        deletion_description: "如果刪除此權限，則具有此角色的受影響用戶將失去此權限授予的訪問權限。",
        permission_deleted: "權限 {{name}} 已成功從此角色中刪除",
        empty: "無可用權限"
    },
    users: {
        assign_button: "分配用戶",
        name_column: "用戶",
        app_column: "應用",
        latest_sign_in_column: "最近登錄",
        delete_description: "它將保留在您的用戶池中，但失去此角色的授權。",
        deleted: "{{name}} 已成功從此角色中刪除",
        assign_title: "分配用戶",
        assign_subtitle: "將用戶分配給此角色。通過搜索名稱、電子郵件、電話或用戶 ID 尋找適當的用戶。",
        assign_field: "分配用戶",
        confirm_assign: "分配用戶",
        assigned_toast_text: "所選用戶已成功分配給此角色",
        empty: "無可用用戶"
    },
    applications: {
        assign_button: "分配應用",
        name_column: "應用",
        app_column: "應用",
        description_column: "描述",
        delete_description: "它將保留在您的應用程式集區中，但喪失此角色的授權。",
        deleted: "{{name}} 已從此角色中成功刪除",
        assign_title: "分配應用",
        assign_subtitle: "將應用程式分配給此角色。通過搜索名稱、描述或應用程式 ID 尋找合適的應用程式。",
        assign_field: "分配應用",
        confirm_assign: "分配應用",
        assigned_toast_text: "所選應用程式已成功分配給此角色",
        empty: "沒有可用的應用程式"
    }
};
var $e41468785eb37aac$export$2e2bcd8739ae039 = Object.freeze($e41468785eb37aac$var$role_details);


const $493b56588bfaacc5$var$roles = {
    page_title: "角色",
    title: "角色",
    subtitle: "RBAC 是一種訪問控制方法，它使用角色來決定用戶可以做什麼事情，包括授予用戶訪問特定資源的權限。",
    create: "建立角色",
    role_name: "角色名稱",
    role_type: "角色類型",
    show_role_type_button_text: "顯示更多選項",
    hide_role_type_button_text: "隱藏更多選項",
    type_user: "使用者角色",
    type_machine_to_machine: "機器對機器應用角色",
    role_description: "描述",
    role_name_placeholder: "輸入你的角色名稱",
    role_description_placeholder: "輸入你的角色描述",
    col_roles: "角色",
    col_type: "類型",
    col_description: "描述",
    col_assigned_entities: "已分配",
    user_counts: "{{count}} 個使用者",
    application_counts: "{{count}} 個應用程式",
    user_count: "{{count}} 個使用者",
    application_count: "{{count}} 個應用程式",
    assign_permissions: "分配權限",
    create_role_title: "建立角色",
    create_role_description: "為你的應用程式建立和管理角色。角色包含權限集合，並可以分配給使用者。",
    create_role_button: "建立角色",
    role_created: "角色 {{name}} 已成功建立。",
    search: "按角色名稱、描述或 ID 搜尋",
    placeholder_title: "角色",
    placeholder_description: "角色是可以分配給使用者的權限分組。在建立角色之前，請確保先新增權限。",
    assign_user_roles: "分配使用者角色",
    assign_m2m_roles: "分配機器對機器角色",
    management_api_access_notification: "要訪問Logto管理API，請選擇具有管理API權限的角色<flag/>。",
    with_management_api_access_tip: "此機器對機器角色包含Logto管理API權限"
};
var $493b56588bfaacc5$export$2e2bcd8739ae039 = Object.freeze($493b56588bfaacc5$var$roles);


const $b6e01975c7e3d003$var$session_expired = {
    title: "會話已過期",
    subtitle: "會話可能已過期，你已被退出登錄。請點選下方按鈕重新登錄到管理控制臺。",
    button: "重新登錄"
};
var $b6e01975c7e3d003$export$2e2bcd8739ae039 = Object.freeze($b6e01975c7e3d003$var$session_expired);


const $0efe7b65353e3ee3$var$content = {
    terms_of_use: {
        title: "TERMS",
        terms_of_use: "Terms of use URL",
        terms_of_use_placeholder: "https://your.terms.of.use/",
        privacy_policy: "Privacy policy URL",
        privacy_policy_placeholder: "https://your.privacy.policy/"
    },
    languages: {
        title: "LANGUAGES",
        enable_auto_detect: "Enable auto-detect",
        description: "Your software detects the user's locale setting and switches to the local language. You can add new languages by translating UI from English to another language.",
        manage_language: "Manage language",
        default_language: "Default language",
        default_language_description_auto: "The default language will be used when the detected user language isn’t covered in the current language library.",
        default_language_description_fixed: "When auto-detect is off, the default language is the only language your software will show. Turn on auto-detect for language extension."
    },
    manage_language: {
        title: "Manage language",
        subtitle: "Localize the product experience by adding languages and translations. Your contribution can be set as the default language.",
        add_language: "Add Language",
        logto_provided: "Logto provided",
        key: "Key",
        logto_source_values: "Logto source values",
        custom_values: "Custom values",
        clear_all_tip: "Clear all values",
        unsaved_description: "Changes won’t be saved if you leave this page without saving.",
        deletion_tip: "Delete the language",
        deletion_title: "Do you want to delete the added language?",
        deletion_description: "After deletion, your users won’t be able to browse in that language again.",
        default_language_deletion_title: "Default language can’t be deleted.",
        default_language_deletion_description: "{{language}} is set as your default language and can’t be deleted. "
    }
};
var $0efe7b65353e3ee3$export$2e2bcd8739ae039 = Object.freeze($0efe7b65353e3ee3$var$content);


const $c42378fa21e38551$var$password_policy = {
    password_requirements: "密碼需求",
    minimum_length: "最小長度",
    minimum_length_description: "美國國家標準與技術研究所 (NIST) 建議網路產品需至少使用 <a>8 個字元</a>。",
    minimum_length_error: "最小長度必須介於 {{min}} 到 {{max}}（包括）之間。",
    minimum_required_char_types: "最低需要的字元類型",
    minimum_required_char_types_description: "字元類型：大寫字母（A-Z）、小寫字母（a-z）、數字（0-9）和特殊符號（{{symbols}}）。",
    password_rejection: "拒絕密碼",
    compromised_passwords: "拒絕已破解的密碼",
    breached_passwords: "遭破解的密碼",
    breached_passwords_description: "拒絕之前在密碼洩漏資料庫中找到的密碼。",
    restricted_phrases: "限制低安全性片語",
    restricted_phrases_tooltip: "除非您結合 3 個或更多的額外字元，否則密碼應避免使用這些片語。",
    repetitive_or_sequential_characters: "重複或連續字元",
    repetitive_or_sequential_characters_description: "例如：“AAAA”，“1234”，和“abcd”。",
    user_information: "用戶資訊",
    user_information_description: "例如，電子郵件地址，電話號碼，用戶名等。",
    custom_words: "自訂字詞",
    custom_words_description: "個性化上下文相關的字詞，不區分大小寫，每行一個。",
    custom_words_placeholder: "您的服務名稱，公司名稱等。"
};
var $c42378fa21e38551$export$2e2bcd8739ae039 = Object.freeze($c42378fa21e38551$var$password_policy);


const $5c0b8f1a29580d8e$var$sign_up_and_sign_in = {
    identifiers_email: "郵件地址",
    identifiers_phone: "手機號碼",
    identifiers_username: "使用者名稱",
    identifiers_email_or_sms: "郵件地址或手機號碼",
    identifiers_none: "無",
    and: "與",
    or: "或",
    sign_up: {
        title: "註冊",
        sign_up_identifier: "註冊標誌",
        identifier_description: "在建立帳戶時，您需要設定註冊標誌。在使用者登錄時，這些資訊是必填的。",
        sign_up_authentication: "註冊身分驗證設置",
        authentication_description: "在註冊時，您的使用者將必須完成所有勾選的任務。",
        set_a_password_option: "建立密碼",
        verify_at_sign_up_option: "驗證身分",
        social_only_creation_description: "（僅適用於社交註冊使用者）"
    },
    sign_in: {
        title: "登入",
        sign_in_identifier_and_auth: "登入標誌和身分驗證設置",
        description: "使用者可以使用任何可用的選項進行登入。拖曳選項即可調整頁面佈局。",
        add_sign_in_method: "新增登入方式",
        password_auth: "密碼",
        verification_code_auth: "驗證碼",
        auth_swap_tip: "交換以下選項的位置即可設定它們在使用者登入流程中出現的先後順序。",
        require_auth_factor: "請至少選擇一種驗證方式。"
    },
    social_sign_in: {
        title: "社交登入",
        social_sign_in: "社交登入",
        description: "您已設定特定的標誌。使用者在通過社交連結器註冊時可能會被要求提供一個對應的標誌。",
        add_social_connector: "新增社交連結器",
        set_up_hint: {
            not_in_list: "沒有你想要的連結器？",
            set_up_more: "立即設定",
            go_to: "參考其他的社交連結器。"
        }
    },
    tip: {
        set_a_password: "啟用使用者名稱註冊，必須設定密碼。",
        verify_at_sign_up: "目前我們僅支持經過驗證的郵件地址登入。如果沒有驗證，你的使用者信息中可能出現大量無效的電子郵件地址。",
        password_auth: "因註冊設置啟用了使用者名稱密碼標誌。在使用者登入時，這個資訊是必填的。",
        verification_code_auth: "因註冊設置啟用了驗證碼標誌，驗證碼屬於使用者必選項，啟用密碼註冊後，你可以選擇關閉驗證碼登入。",
        delete_sign_in_method: "因註冊設置啟用了{{identifier}}標誌。在使用者登入時，這些資訊是必填的。"
    },
    advanced_options: {
        title: "進階選項",
        enable_single_sign_on: "啟用企業單一登入 (SSO)",
        enable_single_sign_on_description: "啟用使用者透過其企業身份以單一登入的方式登入應用程式。",
        single_sign_on_hint: {
            prefix: "前往 ",
            link: '"Enterprise SSO"',
            suffix: "區段以設定更多企業連結器。"
        },
        enable_user_registration: "啟用使用者註冊",
        enable_user_registration_description: "啟用或禁止使用者註冊。禁用後，管理員仍然可以新增使用者，但無法透過登入界面建立帳戶。"
    }
};
var $5c0b8f1a29580d8e$export$2e2bcd8739ae039 = Object.freeze($5c0b8f1a29580d8e$var$sign_up_and_sign_in);


const $16ff48fec2c71151$var$sign_in_exp = {
    page_title: "登錄體驗",
    title: "登錄體驗",
    description: "自定義登錄界面，並實時預覽真實效果",
    tabs: {
        branding: "品牌",
        sign_up_and_sign_in: "註冊與登錄",
        content: "內容",
        password_policy: "密碼規則"
    },
    welcome: {
        title: "自定義登錄體驗",
        description: "通過首次登錄設置快速入門。本指南將帶領你完成所有必要的設置。",
        get_started: "開始",
        apply_remind: "請注意，登錄體驗將會應用到當前帳戶下的所有應用。"
    },
    color: {
        title: "顏色",
        primary_color: "品牌顏色",
        dark_primary_color: "品牌顏色 (深色)",
        dark_mode: "開啟深色模式",
        dark_mode_description: "基於品牌顏色和 Logto 的算法，應用將會有一個自動生成的深色模式。當然，你可以自定義和修改。",
        dark_mode_reset_tip: "基於品牌顏色，重新生成深色模式顏色。",
        reset: "重新生成"
    },
    branding: {
        title: "品牌定制區",
        ui_style: "樣式",
        favicon: "瀏覽器地址欄圖標",
        logo_image_url: "Logo 圖片 URL",
        logo_image_url_placeholder: "https://your.cdn.domain/logo.png",
        dark_logo_image_url: "Logo 圖片 URL (深色)",
        dark_logo_image_url_placeholder: "https://your.cdn.domain/logo-dark.png",
        logo_image: "Logo 圖片",
        dark_logo_image: "Logo 圖片(深色)",
        logo_image_error: "應用 Logo：{{error}}",
        favicon_error: "Favicon：{{error}}"
    },
    custom_css: {
        title: "自定義 CSS",
        css_code_editor_title: "自定義 CSS 個性化你的用戶界面",
        css_code_editor_description1: "查看自定義 CSS 的例子。",
        css_code_editor_description2: "<a>{{link}}</a>",
        css_code_editor_description_link_content: "了解更多",
        css_code_editor_content_placeholder: "輸入 CSS 代碼，修改顏色、字體、組件樣式、布局，定制你的登錄、註冊、忘記密碼等頁面。充分發揮創造力，讓你的用戶界面脫穎而出。"
    },
    sign_up_and_sign_in: $5c0b8f1a29580d8e$export$2e2bcd8739ae039,
    content: $0efe7b65353e3ee3$export$2e2bcd8739ae039,
    password_policy: $c42378fa21e38551$export$2e2bcd8739ae039,
    setup_warning: {
        no_connector_sms: "尚未設置 SMS 短信連接器。在完成該配置前，用戶將無法通過此登錄方式登錄。<a>{{link}}</a>連接器。",
        no_connector_email: "尚未設置電子郵件連接器。在完成該配置前，用戶將無法通過此登錄方式登錄。<a>{{link}}</a>連接器。",
        no_connector_social: "您還沒有設置任何社交連接器。首先添加連接器以應用社交登錄方法。<a>{{link}}</a>連接器。",
        setup_link: "立即設置"
    },
    save_alert: {
        description: "你正在進行登錄註冊設置的變更。當前你的所有用戶會受到新設置的影響。確認保存該設置嗎？",
        before: "設置前",
        after: "設置後",
        sign_up: "註冊",
        sign_in: "登錄",
        social: "社交"
    },
    preview: {
        title: "登錄預覽",
        live_preview: "實時預覽",
        live_preview_tip: "保存以預覽更改",
        native: "移動原生",
        desktop_web: "桌面網頁",
        mobile_web: "移動網頁",
        desktop: "桌面網頁",
        mobile: "行動裝置"
    }
};
var $16ff48fec2c71151$export$2e2bcd8739ae039 = Object.freeze($16ff48fec2c71151$var$sign_in_exp);


const $4e4066825406fcc2$var$signing_keys = {
    title: "簽名密鑰",
    description: "安全管理應用程式使用的簽名密鑰。",
    private_key: "OIDC 私鑰",
    private_keys_description: "OIDC 私鑰用於簽署 JWT 令牌。",
    cookie_key: "OIDC cookie 密鑰",
    cookie_keys_description: "OIDC cookie 密鑰用於簽署 cookie。",
    private_keys_in_use: "正在使用的私鑰",
    cookie_keys_in_use: "正在使用的 Cookie 密鑰",
    rotate_private_keys: "輪換私鑰",
    rotate_cookie_keys: "輪換 Cookie 密鑰",
    rotate_private_keys_description: "此操作將創建一個新的私密簽名密鑰，輪換當前密鑰並刪除之前的密鑰。您的使用當前密鑰簽署的 JWT 憑證在刪除或另一輪輪換之前仍然有效。",
    rotate_cookie_keys_description: "此操作將創建一個新的 Cookie 密鑰，輪換當前密鑰並刪除之前的密鑰。使用當前密鑰簽署的 Cookie 將在刪除或另一輪輪換之前仍然有效。",
    select_private_key_algorithm: "選擇新私鑰的簽名演算法",
    rotate_button: "輪換",
    table_column: {
        id: "ID",
        status: "狀態",
        algorithm: "簽名演算法"
    },
    status: {
        current: "當前的",
        previous: "之前的"
    },
    reminder: {
        rotate_private_key: "您確定要輪換<strong>OIDC私鑰</strong>嗎？新發放的 JWT 憑證將由新的密鑰簽署。現有的 JWT 憑證仍然有效，直到下一輪輪換或刪除。",
        rotate_cookie_key: "您確定要輪換<strong>OIDC Cookie 密鑰</strong>嗎？在登入會話中生成的新 Cookie 將由新的 Cookie 密鑰簽署。現有 Cookie 在下一輪輪換或刪除之前仍然有效。",
        delete_private_key: "您確定要刪除<strong>OIDC私鑰</strong>嗎？使用此私密簽名密鑰簽署的現有 JWT 憑證將不再有效。",
        delete_cookie_key: "您確定要刪除<strong>OIDC Cookie 密鑰</strong>嗎？用此 Cookie 密鑰簽署的舊登入會話將不再有效。這些使用者需要重新驗證。"
    },
    messages: {
        rotate_key_success: "密鑰輪換成功。",
        delete_key_success: "密鑰刪除成功。"
    }
};
var $4e4066825406fcc2$export$2e2bcd8739ae039 = Object.freeze($4e4066825406fcc2$var$signing_keys);


const $6ad7b2a0dacae286$var$quota_item = {
    tenant_limit: {
        name: "租戶",
        limited: "{{count, number}} 租戶",
        limited_other: "{{count, number}} 租戶",
        unlimited: "不限租戶數",
        not_eligible: "移除你的租戶"
    },
    mau_limit: {
        name: "月活用戶",
        limited: "{{count, number}} 月活用戶",
        unlimited: "不限月活用戶數",
        not_eligible: "移除你的所有用戶"
    },
    token_limit: {
        name: "令牌",
        limited: "{{count, number}} 令牌",
        limited_other: "{{count, number}} 令牌",
        unlimited: "不限令牌數",
        not_eligible: "移除你的所有用戶以防止新增令牌"
    },
    applications_limit: {
        name: "應用程式",
        limited: "{{count, number}} 應用程式",
        limited_other: "{{count, number}} 應用程式",
        unlimited: "不限應用程式數",
        not_eligible: "移除你的應用程式"
    },
    machine_to_machine_limit: {
        name: "機器對機器應用程式",
        limited: "{{count, number}} 機器對機器應用程式",
        limited_other: "{{count, number}} 機器對機器應用程式",
        unlimited: "不限機器對機器應用程式數",
        not_eligible: "移除你的機器對機器應用程式"
    },
    third_party_applications_limit: {
        name: "第三方應用程式",
        limited: "{{count, number}} 第三方應用程式",
        limited_other: "{{count, number}} 第三方應用程式",
        unlimited: "不限第三方應用程式數",
        not_eligible: "移除你的第三方應用程式"
    },
    resources_limit: {
        name: "API 資源",
        limited: "{{count, number}} API 資源",
        limited_other: "{{count, number}} API 資源",
        unlimited: "不限 API 資源數",
        not_eligible: "移除你的 API 資源"
    },
    scopes_per_resource_limit: {
        name: "資源權限",
        limited: "{{count, number}} 權限每資源",
        limited_other: "{{count, number}} 權限每資源",
        unlimited: "不限權限每資源數",
        not_eligible: "移除你的資源權限"
    },
    custom_domain_enabled: {
        name: "自訂網域",
        limited: "自訂網域",
        unlimited: "自訂網域",
        not_eligible: "移除你的自訂網域"
    },
    omni_sign_in_enabled: {
        name: "全渠道登入",
        limited: "全渠道登入",
        unlimited: "全渠道登入",
        not_eligible: "停用全渠道登入"
    },
    built_in_email_connector_enabled: {
        name: "內建電子郵件連接程式",
        limited: "內建電子郵件連接程式",
        unlimited: "內建電子郵件連接程式",
        not_eligible: "移除你的內建電子郵件連接程式"
    },
    social_connectors_limit: {
        name: "社交連接程式",
        limited: "{{count, number}} 社交連接程式",
        limited_other: "{{count, number}} 社交連接程式",
        unlimited: "不限社交連接程式數",
        not_eligible: "移除你的社交連接程式"
    },
    standard_connectors_limit: {
        name: "免費標準連接程式",
        limited: "{{count, number}} 免費標準連接程式",
        limited_other: "{{count, number}} 免費標準連接程式",
        unlimited: "不限標準連接程式數",
        not_eligible: "移除你的標準連接程式"
    },
    roles_limit: {
        name: "角色",
        limited: "{{count, number}} 角色",
        limited_other: "{{count, number}} 角色",
        unlimited: "不限角色數",
        not_eligible: "移除你的角色"
    },
    machine_to_machine_roles_limit: {
        name: "機器對機器角色",
        limited: "{{count, number}} 機器對機器角色",
        limited_other: "{{count, number}} 機器對機器角色",
        unlimited: "不限機器對機器角色數",
        not_eligible: "移除你的機器對機器角色"
    },
    scopes_per_role_limit: {
        name: "角色權限",
        limited: "{{count, number}} 權限每角色",
        limited_other: "{{count, number}} 權限每角色",
        unlimited: "不限權限每角色數",
        not_eligible: "移除你的角色權限"
    },
    hooks_limit: {
        name: "Webhooks",
        limited: "{{count, number}}個 Webhook",
        limited_other: "{{count, number}}個 Webhooks",
        unlimited: "無限制的 Webhooks",
        not_eligible: "移除你的 Webhooks"
    },
    organizations_enabled: {
        name: "組織",
        limited: "組織",
        unlimited: "組織",
        not_eligible: "移除你的組織"
    },
    audit_logs_retention_days: {
        name: "審計記錄保留天數",
        limited: "審計記錄保留天數：{{count, number}} 天",
        limited_other: "審計記錄保留天數：{{count, number}} 天",
        unlimited: "不限天數",
        not_eligible: "無審計記錄"
    },
    email_ticket_support: {
        name: "電子郵件票務支援",
        limited: "{{count, number}}小時的電子郵件票務支援",
        limited_other: "{{count, number}}小時的電子郵件票務支援",
        unlimited: "電子郵件票務支援",
        not_eligible: "無電子郵件票務支援"
    },
    mfa_enabled: {
        name: "多因素認證",
        limited: "多因素認證",
        unlimited: "多因素認證",
        not_eligible: "移除你的多因素認證"
    },
    sso_enabled: {
        name: "企業單一登錄",
        limited: "企業單一登錄",
        unlimited: "企業單一登錄",
        not_eligible: "移除你的 企業單一登錄"
    },
    tenant_members_limit: {
        name: "租戶成員",
        limited: "{{count, number}} 租戶成員",
        limited_other: "{{count, number}} 租戶成員",
        unlimited: "不限租戶成員數",
        not_eligible: "移除你的租戶成員"
    },
    custom_jwt_enabled: {
        name: "自訂 JWT",
        limited: "自訂 JWT",
        unlimited: "自訂 JWT",
        not_eligible: "移除你的 JWT 声明自訂器"
    }
};
var $6ad7b2a0dacae286$export$2e2bcd8739ae039 = Object.freeze($6ad7b2a0dacae286$var$quota_item);


const $a7af14762c643c0b$var$quota_table = {
    quota: {
        title: "基本",
        base_price: "基本價格",
        mau_limit: "MAU 限制",
        included_tokens: "包含的令牌"
    },
    application: {
        title: "應用程式",
        total: "總應用程式數",
        m2m: "機器對機器",
        third_party: "第三方應用程式"
    },
    resource: {
        title: "API 資源",
        resource_count: "資源數量",
        scopes_per_resource: "每資源權限"
    },
    branding: {
        title: "使用者介面和品牌塑造",
        custom_domain: "自訂網域",
        custom_css: "自訂 CSS",
        app_logo_and_favicon: "應用程式標誌和網站圖示",
        dark_mode: "深色模式",
        i18n: "國際化"
    },
    user_authn: {
        title: "使用者認證",
        omni_sign_in: "全渠道登錄",
        password: "密碼",
        passwordless: "免密碼登入 - 電子郵件和簡訊",
        email_connector: "電子郵件連接器",
        sms_connector: "簡訊連接器",
        social_connectors: "社交連接器",
        standard_connectors: "標準連接器",
        built_in_email_connector: "內建電子郵件連接器",
        mfa: "多因素認證",
        sso: "企業 SSO",
        adaptive_mfa: "自適應MFA"
    },
    user_management: {
        title: "使用者管理",
        user_management: "使用者管理",
        roles: "角色",
        machine_to_machine_roles: "機器對機器角色",
        scopes_per_role: "每角色權限"
    },
    organizations: {
        title: "組織",
        organizations: "組織",
        organization: "組織",
        organization_count: "組織數量",
        allowed_users_per_org: "組織允許的用戶",
        invitation: "邀請 (管理 API)",
        org_roles: "組織角色",
        org_permissions: "組織權限",
        just_in_time_provisioning: "即時供應管理"
    },
    support: {
        title: "合規性與支援",
        community: "社群",
        customer_ticket: "客戶支援票證",
        premium: "進階版",
        email_ticket_support: "郵件票證支援",
        soc2_report: "SOC2 報告",
        hipaa_or_baa_report: "HIPAA/BAA 報告"
    },
    developers_and_platform: {
        title: "開發人員與平台",
        hooks: "Webhooks",
        audit_logs_retention: "審計日誌保留",
        jwt_claims: "JWT 声明",
        tenant_members: "租戶成員"
    },
    unlimited: "無限制",
    contact: "聯絡",
    monthly_price: "${{value, number}} / 月",
    days_one: "{{count, number}} 天",
    days_other: "{{count, number}} 天",
    add_on: "附加功能",
    tier: "層級{{value, number}}：",
    paid_token_limit_tip: "Logto將為超出您額度限制的功能收費。您可以在2024年第二季度左右開始收費之前免費使用它。如果您需要更多的令牌，請與我們聯繫。默認情況下，我們每月為每百萬令牌收費80美元。",
    paid_quota_limit_tip: "Logto將為超出配額限制的功能添加費用。在我們從2024年第二季度開始收費之前，您可以免費使用它。",
    paid_add_on_feature_tip: "這是一個附加功能。在我們從2024年第二季度開始收費之前，您可以免費使用它。",
    million: "{{value, number}} 百萬",
    mau_tip: "MAU（每月活躍用戶）是指在計費週期內與Logto交換過至少一個令牌的獨立用戶數量。",
    tokens_tip: "Logto 發行的所有類型令牌，包括訪問令牌、刷新令牌等。",
    mao_tip: "MAO（月度活躍組織）指的是在計費週期內至少有一個MAU（月度活躍用戶）的獨特組織數量。",
    third_party_tip: "使用Logto作為您的OIDC身份提供程序，以便第三方應用程式進行登錄和權限授予。",
    included: "已包含 {{value, number}}",
    included_mao: "已包含 {{value, number}} MAO",
    extra_quota_price: "然後每月 ${{value, number}} / 每個之後",
    per_month_each: "每月 ${{value, number}} / 每個",
    extra_mao_price: "然後每 MAO ${{value, number}}",
    per_month: "每月 ${{value, number}}",
    per_member: "然後每位會員 ${{value, number}}"
};
var $a7af14762c643c0b$export$2e2bcd8739ae039 = Object.freeze($a7af14762c643c0b$var$quota_table);


const $fd82732a08dcbeae$var$subscription = {
    free_plan: "免費方案",
    free_plan_description: "適用於旁邊項目和開始使用 Logto 的試用。無需信用卡。",
    pro_plan: "專業方案",
    pro_plan_description: "企業無憂享受 Logto 服務。",
    enterprise: "企業版",
    current_plan: "當前方案",
    current_plan_description: "這是您目前的方案。您可以輕鬆查看您的方案使用情況，檢查即將到來的帳單，並根據需要進行變更。",
    plan_usage: "計劃使用情況",
    plan_cycle: "計劃週期：{{period}}。使用情況訂閱日期為{{renewDate}}。",
    next_bill: "您的下一個帳單",
    next_bill_hint: "要了解更多計算方法，請參閱本<a>文章</a>。",
    next_bill_tip: "這裡顯示的價格不包括稅款。稅款將根據您提供的信息和當地法規要求進行計算，並顯示在您的發票中。",
    manage_payment: "管理付款",
    overfill_quota_warning: "您已達到配額限制。為防止出現問題，請升級計畫。",
    upgrade_pro: "升級專業",
    update_payment: "更新付款信息",
    payment_error: "偵測到付款問題。無法處理以前週期的 {{price, number}}$ 。更新付款以避免 Logto 服務中止。",
    downgrade: "降級",
    current: "當前",
    upgrade: "升級",
    quota_table: $a7af14762c643c0b$export$2e2bcd8739ae039,
    billing_history: {
        invoice_column: "發票",
        status_column: "狀態",
        amount_column: "金額",
        invoice_created_date_column: "發票創建日期",
        invoice_status: {
            void: "已取消",
            paid: "已付款",
            open: "未完成",
            uncollectible: "逾期未付款"
        }
    },
    quota_item: $6ad7b2a0dacae286$export$2e2bcd8739ae039,
    downgrade_modal: {
        title: "您確定要降級嗎？",
        description: "如果您選擇切換到 <targetName/>，請注意您將不再使用之前在 <currentName/> 中的配額和功能。",
        before: "在此之前：<name/>",
        after: "在此之後：<name/>",
        downgrade: "降級"
    },
    not_eligible_modal: {
        downgrade_title: "您不符合降級條件",
        downgrade_description: "降級到<name/>前，請確保符合以下條件。",
        downgrade_help_tip: "需要降級幫助？<a>聯絡我們</a>。",
        upgrade_title: "致尊敬的早期採用者的友善提醒",
        upgrade_description: "您目前的使用量超過了 <name /> 允許的範圍。Logto 現已正式發布，包括針對每個計劃量身定制的功能。在考慮升級到 <name /> 之前，請確保您符合以下升級條件。",
        upgrade_pro_tip: " 或者考慮升級到專業版計劃。",
        upgrade_help_tip: "需要升級幫助？<a>聯絡我們</a>。",
        a_maximum_of: "最多<item/>"
    },
    upgrade_success: "已成功升級到 <name/>",
    downgrade_success: "已成功降級到 <name/>",
    subscription_check_timeout: "訂閱檢查已逾時，請稍後重新刷新。",
    no_subscription: "無訂閱"
};
var $fd82732a08dcbeae$export$2e2bcd8739ae039 = Object.freeze($fd82732a08dcbeae$var$subscription);


const $844b67280d67d711$var$tab_sections = {
    overview: "概觀",
    authentication: "身份驗證",
    authorization: "授權",
    users: "用戶",
    developer: "開發者",
    tenant: "租戶"
};
var $844b67280d67d711$export$2e2bcd8739ae039 = Object.freeze($844b67280d67d711$var$tab_sections);


const $c2ee44eafabd0766$var$tabs = {
    get_started: "開始上手",
    dashboard: "儀表板",
    applications: "全部應用",
    api_resources: "API 資源",
    sign_in_experience: "登入體驗",
    connectors: "連接器",
    enterprise_sso: "Enterprise SSO",
    webhooks: "Webhooks",
    organizations: "組織",
    users: "使用者管理",
    audit_logs: "稽核日誌",
    roles: "角色",
    docs: "文件",
    tenant_settings: "租戶設定",
    mfa: "多重認證",
    customize_jwt: "自訂 JWT",
    signing_keys: "簽署密鑰",
    organization_template: "組織模板"
};
var $c2ee44eafabd0766$export$2e2bcd8739ae039 = Object.freeze($c2ee44eafabd0766$var$tabs);


const $63fb3e8e20a63f63$var$tenant_members = {
    members: "成員",
    invitations: "邀請函",
    invite_members: "邀請成員",
    user: "使用者",
    roles: "角色",
    admin: "管理員",
    collaborator: "合作夥伴",
    invitation_status: "邀請狀態",
    inviter: "邀請者",
    expiration_date: "到期日期",
    invite_modal: {
        title: "邀請加入 Logto Cloud",
        subtitle: "要邀請成員加入組織，必須接受邀請。",
        to: "寄至",
        added_as: "以角色新增",
        email_input_placeholder: "johndoe@example.com"
    },
    invitation_statuses: {
        pending: "待處理",
        accepted: "已接受",
        expired: "已過期",
        revoked: "已撤銷"
    },
    invitation_empty_placeholder: {
        title: "邀請團隊成員",
        description: "您的租戶目前沒有邀請的成員。\n為了協助您的整合，請考慮增加更多成員或管理員。"
    },
    menu_options: {
        edit: "編輯租戶角色",
        delete: "從租戶中刪除使用者",
        resend_invite: "重新發送邀請",
        revoke: "撤銷邀請",
        delete_invitation_record: "刪除此邀請記錄"
    },
    edit_modal: {
        title: "更改 {{name}} 的角色"
    },
    delete_user_confirm: "您確定要從此租戶中刪除這個使用者嗎？",
    assign_admin_confirm: "您確定要將所選使用者設為管理員嗎？授予管理員訪問權限將賦予使用者以下權限。<ul><li>更改租戶計費方案</li><li>新增或刪除合作夥伴</li><li>刪除租戶</li></ul>",
    revoke_invitation_confirm: "您確定要撤銷此邀請嗎？",
    delete_invitation_confirm: "您確定要刪除此邀請記錄嗎？",
    messages: {
        invitation_sent: "邀請已發送。",
        invitation_revoked: "邀請已撤銷。",
        invitation_resend: "邀請已重新發送。",
        invitation_deleted: "邀請記錄已刪除。"
    },
    errors: {
        email_required: "邀請人電子郵件為必填欄位。",
        email_exists: "電子郵件地址已存在。",
        member_exists: "此使用者已是組織的成員。",
        pending_invitation_exists: "存在待處理的邀請。刪除相關電子郵件或撤銷邀請。",
        invalid_email: "電子郵件地址無效。請確保其格式正確。",
        max_member_limit: "您已達到此租戶的最大成員數限制（{{limit}}）。"
    }
};
var $63fb3e8e20a63f63$export$2e2bcd8739ae039 = Object.freeze($63fb3e8e20a63f63$var$tenant_members);


const $61b58fa2a07602b5$var$tenants = {
    title: "設置",
    description: "高效管理租戶設定並自訂您的網域。",
    tabs: {
        settings: "設置",
        members: "成員",
        domains: "網域",
        subscription: "方案與計費",
        billing_history: "帳單歷史記錄"
    },
    settings: {
        title: "設定",
        description: "設定租戶名稱並查看您的資料托管區域和租戶類型。",
        tenant_id: "租戶 ID",
        tenant_name: "租戶名稱",
        tenant_region: "資料托管地區",
        tenant_region_tip: "您的租戶資源托管於 {{region}}。 <a>了解更多</a>",
        environment_tag_development: "開發",
        environment_tag_production: "產品",
        tenant_type: "租戶類型",
        development_description: "僅供測試，不應在生產環境中使用。無需訂閱。它擁有所有專業功能，但存在限制，如登入橫幅。 <a>瞭解更多</a>",
        production_description: "旨在供最終用戶使用，可能需要付費訂閱。 <a>瞭解更多</a>",
        tenant_info_saved: "租戶資訊成功儲存。"
    },
    full_env_tag: {
        development: "開發",
        production: "產品"
    },
    deletion_card: {
        title: "刪除",
        tenant_deletion: "刪除租戶",
        tenant_deletion_description: "刪除租戶將導致所有相關的使用者資料和設定永久移除。請謹慎進行。",
        tenant_deletion_button: "刪除租戶"
    },
    leave_tenant_card: {
        title: "離開",
        leave_tenant: "離開租戶",
        leave_tenant_description: "在租戶中的任何資源將保留，但您將不再有權訪問此租戶。",
        last_admin_note: "要離開此租戶，請確保至少還有一位成員具有管理員角色。"
    },
    create_modal: {
        title: "建立客戶",
        tenant_usage_purpose: "您希望將此租戶用於什麼目的？",
        development_description: "僅供測試，不應在生產環境中使用。無需訂閱。",
        development_hint: "它擁有所有專業功能，但存在限制，如登入橫幅。",
        production_description: "供最終用戶使用，可能需要付費訂閱。",
        available_plan: "可用方案：",
        create_button: "建立租戶",
        tenant_name_placeholder: "我的租戶"
    },
    dev_tenant_migration: {
        title: '您現在可以通過創建新的 "開發租戶" 免費試用我們的專業功能！',
        affect_title: "這對您有什麼影響？",
        hint_1: "我們正將舊的<strong>環境標籤</strong>替換為兩種新的租戶類型：<strong>“開發</strong>”和<strong>“產品</strong>”。",
        hint_2: "為確保無縫過渡和不間斷的功能，所有早期創建的租戶將提升為<strong>產品</strong>租戶類型，並附上先前的訂閱。",
        hint_3: "別擔心，您的其他設置將保持不變。",
        about_tenant_type: "關於租戶類型"
    },
    delete_modal: {
        title: "刪除租戶",
        description_line1: '您確定要刪除您的租戶 "<span>{{name}}</span>" 以及環境標籤 "<span>{{tag}}</span>" 嗎？此操作無法撤銷，並將導致永久刪除所有資料和租戶資訊。',
        description_line2: "在刪除租戶之前，也許我們可以幫助您。 <span><a>透過電子郵件與我們聯繫</a></span>",
        description_line3: '如果確定要繼續，請輸入租戶名稱 "<span>{{name}}</span>" 以確認。',
        delete_button: "永久刪除",
        cannot_delete_title: "無法刪除此租戶",
        cannot_delete_description: "抱歉，您現在無法刪除此租戶。請確保您處於免費方案並已支付所有未結賬單。"
    },
    leave_tenant_modal: {
        description: "您確定要離開此租戶？",
        leave_button: "離開"
    },
    tenant_landing_page: {
        title: "您尚未建立租戶",
        description: "要開始使用 Logto 配置您的項目，請創建一個新租戶。如果您需要登出或刪除您的帳戶，只需點擊右上角的頭像按鈕。",
        create_tenant_button: "創建租戶"
    },
    status: {
        mau_exceeded: "超過 MAU 限制",
        suspended: "暫停",
        overdue: "逾期"
    },
    tenant_suspended_page: {
        title: "租戶暫停。聯繫我們以恢復存取。",
        description_1: "很抱歉通知您，由於不當使用，包括超過 MAU 限制、逾期付款或其他未經授權的操作，您的租戶帳戶已被暫時停用。",
        description_2: "如果您需要進一步的說明、有任何疑慮或希望恢復全部功能並解鎖您的租戶，請立即聯絡我們。"
    }
};
var $61b58fa2a07602b5$export$2e2bcd8739ae039 = Object.freeze($61b58fa2a07602b5$var$tenants);


const $d93b7967f91c17ee$var$topbar = {
    docs: "文件",
    help: "幫助"
};
var $d93b7967f91c17ee$export$2e2bcd8739ae039 = Object.freeze($d93b7967f91c17ee$var$topbar);


const $c631f6d7c7228386$var$featured_plan_content = {
    mau: {
        free_plan: "最多{{count, number}} MAU",
        pro_plan: "無限 MAU"
    },
    m2m: {
        free_plan: "{{count, number}} 機器對機器",
        pro_plan: "額外的機器對機器"
    },
    third_party_apps: "第三方應用的 IdP",
    mfa: "多因素認證",
    sso: "企業單點登錄",
    role_and_permissions: {
        free_plan: "{{roleCount, number}} 角色和每個角色 {{permissionCount, number}} 權限",
        pro_plan: "無限角色和每個角色權限"
    },
    organizations: "組織",
    audit_logs: "審計日誌保留：{{count, number}} 天"
};
var $c631f6d7c7228386$export$2e2bcd8739ae039 = Object.freeze($c631f6d7c7228386$var$featured_plan_content);


const $9ff04ede3ab576b4$var$paywall = {
    applications: "已達到 <planName/> 的{{count, number}}個應用程式限制。升級計劃以滿足團隊需求。如需任何協助，歡迎<a>聯絡我們</a>。",
    applications_other: "已達到 <planName/> 的{{count, number}}個應用程式限制。升級計劃以滿足團隊需求。如需任何協助，歡迎<a>聯絡我們</a>。",
    machine_to_machine_feature: "升級至 <strong>Pro</strong> 計劃以獲得額外的機器對機器應用程式並享受所有高級功能。如有任何問題，請<a>聯絡我們</a>。",
    machine_to_machine: "已達到 <planName/> 的{{count, number}}個機器對機器應用程式限制。升級計劃以滿足團隊需求。如需任何協助，歡迎<a>聯絡我們</a>。",
    machine_to_machine_other: "已達到 <planName/> 的{{count, number}}個機器對機器應用程式限制。升級計劃以滿足團隊需求。如需任何協助，歡迎<a>聯絡我們</a>。",
    resources: "已達到<planName/>的{{count, number}}個 API 資源限制。升級計劃以滿足您團隊的需求。<a>聯繫我們</a>尋求幫助。",
    resources_other: "已達到<planName/>的{{count, number}}個 API 資源限制。升級計劃以滿足您團隊的需求。<a>聯繫我們</a>尋求幫助。",
    scopes_per_resource: "已達到<planName/>的{{count, number}}個 API 資源每個權限限制。立即升級以擴展。如需任何幫助，請<a>聯繫我們</a>。",
    scopes_per_resource_other: "已達到<planName/>的{{count, number}}個 API 資源每個權限限制。立即升級以擴展。如需任何幫助，請<a>聯繫我們</a>。",
    custom_domain: "升級至 <strong>Hobby</strong> 或 <strong>Pro</strong> 計劃以解鎖自訂網域功能。如有任何需要協助，請隨時<a>聯繫我們</a>。",
    social_connectors: "已達到<planName/>的{{count, number}}個社交連接器限制。為滿足您團隊的需求，請升級計劃以獲取額外的社交連接器，並可以使用 OIDC、OAuth 2.0 和 SAML 協議創建您自己的連接器。如需任何幫助，請<a>聯繫我們</a>。",
    social_connectors_other: "已達到<planName/>的{{count, number}}個社交連接器限制。為滿足您團隊的需求，請升級計劃以獲取額外的社交連接器，並可以使用 OIDC、OAuth 2.0 和 SAML 協議創建您自己的連接器。如需任何幫助，請<a>聯繫我們</a>。",
    standard_connectors_feature: "升級至 <strong>Hobby</strong> 或 <strong>Pro</strong> 計劃以使用 OIDC、OAuth 2.0 和 SAML 協議創建您自己的連接器，享有無限社交連接器和所有高級功能。如需任何協助，歡迎<a>聯繫我們</a>。",
    standard_connectors: "已達到<planName/>的{{count, number}}個社交連接器限制。為滿足您團隊的需求，請升級計劃以獲取額外的社交連接器，並可以使用 OIDC、OAuth 2.0 和 SAML 協議創建您自己的連接器。如需任何幫助，請<a>聯繫我們</a>。",
    standard_connectors_other: "已達到<planName/>的{{count, number}}個社交連接器限制。為滿足您團隊的需求，請升級計劃以獲取額外的社交連接器，並可以使用 OIDC、OAuth 2.0 和 SAML 協議創建您自己的連接器。如需任何幫助，請<a>聯繫我們</a>。",
    standard_connectors_pro: "已達到<planName/>的{{count, number}}個標準連接器限制。為滿足您團隊的需求，請升級至企業版計劃以獲取額外的社交連接器，並可以使用 OIDC、OAuth 2.0 和 SAML 協議創建您自己的連接器。如需任何幫助，請<a>聯絡我們</a>。",
    standard_connectors_pro_other: "已達到<planName/>的{{count, number}}個標準連接器限制。為滿足您團隊的需求，請升級至企業版計劃以獲取額外的社交連接器，並可以使用 OIDC、OAuth 2.0 和 SAML 協議創建您自己的連接器。如需任何幫助，請<a>聯繫我們</a>。",
    roles: "已達到<planName/>的{{count, number}}個角色限制。升級計劃以添加額外的角色和權限。如需任何幫助，請<a>聯繫我們</a>。",
    roles_other: "已達到<planName/>的{{count, number}}個角色限制。升級計劃以添加額外的角色和權限。如需任何幫助，請<a>聯繫我們</a>。",
    machine_to_machine_roles: "{{count, number}} machine-to-machine角色已達到<planName/>的限制。升級計劃以添加額外的角色和權限。如果需要任何幫助，請隨時<a>聯絡我們</a>。",
    machine_to_machine_roles_other: "{{count, number}} machine-to-machine角色已達到<planName/>的限制。升級計劃以添加額外的角色和權限。如果需要任何幫助，請隨時<a>聯絡我們</a>。",
    scopes_per_role: "已達到<planName/>的{{count, number}}個角色每個權限限制。升級計劃以添加額外的角色和權限。如需任何幫助，請<a>聯繫我們</a>。",
    scopes_per_role_other: "已達到<planName/>的{{count, number}}個角色每個權限限制。升級計劃以添加額外的角色和權限。如需任何幫助，請<a>聯繫我們</a>。",
    hooks: "已達到<planName/>的{{count, number}}個 Webhook 限制。升級計劃以創建更多 Webhook。如需任何幫助，請<a>聯繹我們</a>。",
    hooks_other: "已達到<planName/>的{{count, number}}個 Webhook 限制。升級計劃以創建更多 Webhook。如需任何幫助，請<a>聯繹我們</a>。",
    mfa: "升級到付費計劃以解鎖MFA以提高安全性。如果需要任何協助，請隨時<a>聯絡我們</a>。",
    organizations: "升級到付費計劃以解鎖組織。如果需要任何協助，請隨時<a>聯繹我們</a>。",
    third_party_apps: "透過升級到付費計劃將Logto解鎖為第三方應用程式的IdP。如需任何協助，歡迎<a>聯繹我們</a>。",
    sso_connectors: "通過升級到付費計劃來解鎖企業SSO。如需任何協助，歡迎<a>聯繹我們</a>。",
    tenant_members: "通過升級到付費計劃來解鎖合作功能。如需任何協助，歡迎<a>聯繹我們</a>。",
    tenant_members_dev_plan: "您已達到{{limit}}成員限制。釋放一個成員，或撤銷一個待處理的邀請以添加新成員。需要更多名額？歡迎隨時聯繹我們。",
    custom_jwt: {
        title: "新增自訂claim",
        description: "升級至付費計劃以解鎖自訂JWT功能和高級福利。如果有任何問題，請隨時<a>聯繹我們</a>。"
    }
};
var $9ff04ede3ab576b4$export$2e2bcd8739ae039 = Object.freeze($9ff04ede3ab576b4$var$paywall);


const $086524beb8470e0b$var$upsell = {
    upgrade_plan: "升級計劃",
    compare_plans: "比較計劃",
    view_plans: "查看計劃",
    create_tenant: {
        title: "選擇您的租戶計劃",
        description: "Logto 提供創新且經濟實惠的定價計劃，旨在為不斷發展的公司提供競爭優勢。 <a>了解更多</a>",
        base_price: "基礎價格",
        monthly_price: "每月 {{value, number}}",
        view_all_features: "查看所有功能",
        select_plan: "選擇<name/>",
        free_tenants_limit: "最多{{count, number}}個免費租戶",
        free_tenants_limit_other: "最多{{count, number}}個免費租戶",
        most_popular: "最受歡迎",
        upgrade_success: "成功升級至<name/>"
    },
    mau_exceeded_modal: {
        title: "MAU 超過限制，請升級您的計劃。",
        notification: "您當前的 MAU 已超過<planName/>的限制。請立即升級到高級計劃，以避免 Logto 服務的暫停。",
        update_plan: "更新計劃"
    },
    payment_overdue_modal: {
        title: "賬單逾期未付",
        notification: "糟糕！租戶<span>{{name}}</span>的賬單支付失敗。請儘快支付賬單，以避免 Logto 服務的中止。",
        unpaid_bills: "未付賬單",
        update_payment: "更新支付"
    },
    add_on_quota_item: {
        api_resource: "API 資源",
        machine_to_machine: "機器對機器應用",
        tokens: "{{limit}}M 令牌",
        tenant_member: "租戶成員"
    },
    charge_notification_for_quota_limit: "您已超出{{item}}額度限制。Logto將為超出額度限制的使用添加費用。計費將從新的附加價格設計發布當天開始。 <a>了解更多</a>",
    paywall: $9ff04ede3ab576b4$export$2e2bcd8739ae039,
    featured_plan_content: $c631f6d7c7228386$export$2e2bcd8739ae039
};
var $086524beb8470e0b$export$2e2bcd8739ae039 = Object.freeze($086524beb8470e0b$var$upsell);


const $209dd7083952bee2$var$user_details = {
    page_title: "用戶詳情",
    back_to_users: "返回用戶管理",
    created_title: "用戶創建成功",
    created_guide: "這是用戶登錄過程中的信息。",
    created_email: "電子郵箱地址：",
    created_phone: "手機號碼：",
    created_username: "用戶名：",
    created_password: "密碼：",
    menu_delete: "刪除用戶",
    delete_description: "本操作將永久刪除該用戶，且無法撤銷。",
    deleted: "用戶已成功刪除。",
    reset_password: {
        reset_password: "重置密碼",
        title: "確定要重置密碼？",
        content: "本操作不可撤銷，將會重置用戶的登入資訊。",
        congratulations: "該用戶已被重置",
        new_password: "新密碼："
    },
    tab_settings: "設定",
    tab_roles: "角色",
    tab_logs: "用戶日誌",
    tab_organizations: "組織",
    authentication: "身份驗證",
    authentication_description: "每個用戶都有一個包含所有用戶資訊的個人資料。它由基本數據、社交身份和自定義數據組成。",
    user_profile: "使用者檔案",
    field_email: "電子郵箱",
    field_phone: "手機號碼",
    field_username: "用戶名",
    field_name: "姓名",
    field_avatar: "頭像圖片連結",
    field_avatar_placeholder: "https://your.cdn.domain/avatar.png",
    field_custom_data: "自定義數據",
    field_custom_data_tip: "預定義屬性之外的用戶資訊，例如用戶偏好的顏色和語言。",
    field_connectors: "社交帳號",
    field_sso_connectors: "企業連接",
    custom_data_invalid: "自定義數據必須是有效的 JSON 對象",
    connectors: {
        connectors: "連接器",
        user_id: "用戶ID",
        remove: "刪除",
        connected: "該用戶已連接多個社交連接器。",
        not_connected: "該用戶還沒有綁定社交帳號",
        deletion_confirmation: "您正在刪除現有的<name/>身份。你確定要繼續嗎？"
    },
    sso_connectors: {
        connectors: "連接器",
        enterprise_id: "企業ID",
        connected: "該用戶已連接至多個企業身份提供者進行單一登錄。",
        not_connected: "該用戶尚未連接到任何企業身份提供者進行單一登錄。"
    },
    mfa: {
        field_name: "多因素驗證",
        field_description: "這個用戶已啟用2步驗證因素。",
        name_column: "多因素驗證",
        field_description_empty: "此使用者尚未啟用兩步驗證因素。",
        deletion_confirmation: "您正在刪除現有的雙步驗證中的 <name/>。你確定要繼續嗎？"
    },
    suspended: "已禁用",
    suspend_user: "禁用用戶",
    suspend_user_reminder: "你確定要禁用這個用戶嗎？用戶將無法登錄你的應用程式，並且在當前令牌過期後將無法獲取新的訪問令牌。此外，此用戶發出的任何 API 請求都將失敗。",
    suspend_action: "禁用",
    user_suspended: "用戶已被禁用。",
    reactivate_user: "啟用用戶",
    reactivate_user_reminder: "你確定要啟用這個用戶嗎？這將允許該用戶的任何登錄嘗試。",
    reactivate_action: "啟用",
    user_reactivated: "用戶已被啟用。",
    roles: {
        name_column: "角色名稱",
        description_column: "描述",
        assign_button: "分配角色",
        delete_description: "此操作將從此用戶中刪除此角色。角色本身仍將存在，但不再與此用戶相關聯。",
        deleted: "已成功將 {{name}} 從此用戶中刪除。",
        assign_title: "將角色分配給 {{name}}",
        assign_subtitle: "為 {{name}} 授權一個或多個角色",
        assign_role_field: "分配角色",
        role_search_placeholder: "按角色名稱搜索",
        added_text: "添加了 {{value, number}} 個",
        assigned_user_count: "{{value, number}} 個用戶",
        confirm_assign: "分配角色",
        role_assigned: "已成功分配角色",
        search: "按角色名稱、描述或 ID 搜索",
        empty: "無可用角色"
    },
    warning_no_sign_in_identifier: "使用者需要至少擁有一個登入標識（使用者名稱、電子郵件、電話號碼或社交帳號）才能登入。確定要繼續嗎？",
    organization_roles_tooltip: "該組織中分配給該用戶的角色。"
};
var $209dd7083952bee2$export$2e2bcd8739ae039 = Object.freeze($209dd7083952bee2$var$user_details);


const $031a63ccb878898c$var$users = {
    page_title: "用戶管理",
    title: "用戶管理",
    subtitle: "管理你的用戶，包括創建新用戶，編輯用戶資料，查看用戶日誌，以及重新設置密碼和刪除用戶",
    create: "添加用戶",
    create_subtitle: "請至少提供以下其中一個欄位以繼續操作。",
    error_missing_identifier: "你必須提供至少一個註冊標識來創建用戶。",
    user_name: "用戶",
    application_name: "註冊應用",
    latest_sign_in: "最後登錄",
    create_form_username: "用戶名",
    create_form_password: "密碼",
    create_form_name: "姓名",
    placeholder_name: "張三",
    placeholder_email: "example@example.com",
    placeholder_username: "user123",
    placeholder_phone: "+886 2 1234 5678",
    unnamed: "未命名",
    search: "按姓名、電子郵件、電話或用戶名搜索",
    check_user_detail: "查看用戶詳情",
    placeholder_title: "用戶管理",
    placeholder_description: "每個用戶都有一個包含所有用戶信息的個人資料。它由基本數據、社交身份和自定義數據組成。"
};
var $031a63ccb878898c$export$2e2bcd8739ae039 = Object.freeze($031a63ccb878898c$var$users);


const $e1ffc7149d504daa$var$webhook_details = {
    page_title: "Webhook 詳情",
    back_to_webhooks: "返回 Webhooks",
    not_in_use: "未使用",
    success_rate: "成功率",
    requests: "24 小時內 {{value, number}} 個請求",
    disable_webhook: "停用 Webhook",
    disable_reminder: "確定要重新啟用此 Webhook 嗎？繼續操作後，將不會向端點 URL 發送 HTTP 請求。",
    webhook_disabled: "Webhook 已成功停用。",
    webhook_reactivated: "Webhook 已成功重新啟用。",
    reactivate_webhook: "重新啟用 Webhook",
    delete_webhook: "刪除 Webhook",
    deletion_reminder: "您正在移除此 Webhook。刪除後，將不會向端點 URL 發送 HTTP 請求。",
    deleted: "Webhook 已成功刪除。",
    settings_tab: "設置",
    recent_requests_tab: "最近的請求 (24h)",
    settings: {
        settings: "設置",
        settings_description: "Webhooks 允許您即時接收特定事件的更新，通過向您的端點 URL 發送 POST 請求。這使您能夠根據接收到的新信息立即採取行動。",
        events: "事件",
        events_description: "選擇觸發 Logto 發送 POST 請求的觸發器事件。",
        name: "名稱",
        endpoint_url: "端點 URL",
        signing_key: "簽名密鑰",
        signing_key_tip: "將 Logto 提供的密鑰添加到您的端點作為請求標頭，以確保 Webhook 的有效載荷的真實性。",
        regenerate: "重新生成",
        regenerate_key_title: "重新生成簽名密鑰",
        regenerate_key_reminder: "您確定要修改簽名密鑰嗎？重新生成將立即生效。請記得同步修改端點中的簽名密鑰。",
        regenerated: "簽名密鑰已重新生成。",
        custom_headers: "自定義標頭",
        custom_headers_tip: "您可以選擇將自定義標頭添加到有效載荷中，以提供有關事件的其他上下文或元數據。",
        key_duplicated_error: "Key 不能重複。",
        key_missing_error: "必須填寫 Key。",
        value_missing_error: "未填寫值。",
        invalid_key_error: "Key 無效",
        invalid_value_error: "值無效",
        test: "測試",
        test_webhook: "測試您的 Webhook",
        test_webhook_description: "配置 Webhook，並使用每個選定事件的有效載荷示例進行測試，以驗證正確的接收和處理。",
        send_test_payload: "發送測試有效載荷",
        test_result: {
            endpoint_url: "端點URL：{{url}}",
            message: "訊息：{{message}}",
            response_status: "回應狀態：{{status, number}}",
            response_body: "回應主體：{{body}}",
            request_time: "請求時間：{{time}}",
            test_success: "向端點發起的 webhook 測試成功。"
        }
    }
};
var $e1ffc7149d504daa$export$2e2bcd8739ae039 = Object.freeze($e1ffc7149d504daa$var$webhook_details);


const $4876a5c42776d99c$var$webhooks = {
    page_title: "Webhooks",
    title: "Webhooks",
    subtitle: "創建 Webhook 以輕鬆收到特定事件的即時更新。",
    create: "創建 Webhook",
    schemas: {
        interaction: "使用者互動",
        user: "使用者",
        organization: "組織",
        role: "角色",
        scope: "權限",
        organization_role: "組織角色",
        organization_scope: "組織權限"
    },
    table: {
        name: "名稱",
        events: "事件",
        success_rate: "成功率 (24h)",
        requests: "請求數量 (24h)"
    },
    placeholder: {
        title: "Webhook",
        description: "創建 Webhook 以收到通過 POST 請求發送到您的端點 URL 的即時更新。保持資訊，對「創建帳戶」「登錄」和「重置密碼」等事件立即採取行動。",
        create_webhook: "創建 Webhook"
    },
    create_form: {
        title: "創建 Webhook",
        subtitle: "添加 Webhook 以發送 POST 請求到端點 URL，包含任何使用者事件的詳細資訊。",
        events: "事件",
        events_description: "選擇 Logto 將發送 POST 請求的觸發事件。",
        name: "名稱",
        name_placeholder: "輸入 webhook 名稱",
        endpoint_url: "端點 URL",
        endpoint_url_placeholder: "https://your.webhook.endpoint.url",
        endpoint_url_tip: "輸入您的端點 URL，當事件發生時會將 Webhook 的載荷發送到該 URL。",
        create_webhook: "創建 webhook",
        missing_event_error: "您需要選擇至少一個事件。"
    },
    webhook_created: "Webhook {{name}} 已成功創建。"
};
var $4876a5c42776d99c$export$2e2bcd8739ae039 = Object.freeze($4876a5c42776d99c$var$webhooks);


const $f3f802ebc6b68244$var$welcome = {
    title: "歡迎來到管理控制台",
    description: "管理控制台是一個無需代碼操作的應用。你可以用它來管理登入體驗。讓我們首先創建一個帳號。你可以用它以個人或公司的身份管理 Logto。",
    create_account: "創建帳號"
};
var $f3f802ebc6b68244$export$2e2bcd8739ae039 = Object.freeze($f3f802ebc6b68244$var$welcome);


const $b713dbb4b43d6d78$var$admin_console = {
    title: "管理控制台",
    admin_user: "管理員",
    system_app: "系統應用",
    menu: $d7f0df2de9c64bb8$export$2e2bcd8739ae039,
    general: $41e60829fa1c9f87$export$2e2bcd8739ae039,
    errors: $edbec39baf6fbea8$export$2e2bcd8739ae039,
    tab_sections: $844b67280d67d711$export$2e2bcd8739ae039,
    tabs: $c2ee44eafabd0766$export$2e2bcd8739ae039,
    applications: $06694227b27334d5$export$2e2bcd8739ae039,
    application_details: $4a839e31ce65cf6f$export$2e2bcd8739ae039,
    api_resources: $fc40e76dd560688e$export$2e2bcd8739ae039,
    api_resource_details: $58c178aa35c151b4$export$2e2bcd8739ae039,
    connectors: $559e9fb8c669cafb$export$2e2bcd8739ae039,
    connector_details: $fd5ddc5207821bd7$export$2e2bcd8739ae039,
    enterprise_sso: $ba5e935b43967a28$export$2e2bcd8739ae039,
    enterprise_sso_details: $2dc0f227dd098204$export$2e2bcd8739ae039,
    get_started: $62ed43ab0d0a99a2$export$2e2bcd8739ae039,
    users: $031a63ccb878898c$export$2e2bcd8739ae039,
    user_details: $209dd7083952bee2$export$2e2bcd8739ae039,
    contact: $f958125aab43cddb$export$2e2bcd8739ae039,
    sign_in_exp: $16ff48fec2c71151$export$2e2bcd8739ae039,
    dashboard: $f4302758b0846479$export$2e2bcd8739ae039,
    logs: $6976b54da3b20715$export$2e2bcd8739ae039,
    log_details: $8db5c39afdfb6615$export$2e2bcd8739ae039,
    session_expired: $b6e01975c7e3d003$export$2e2bcd8739ae039,
    welcome: $f3f802ebc6b68244$export$2e2bcd8739ae039,
    roles: $493b56588bfaacc5$export$2e2bcd8739ae039,
    role_details: $e41468785eb37aac$export$2e2bcd8739ae039,
    permissions: $9bf007323fb4ac90$export$2e2bcd8739ae039,
    cloud: $816b0112de7e6cc8$export$2e2bcd8739ae039,
    profile: $50edca06f3e6dc78$export$2e2bcd8739ae039,
    components: $a385faa741008cfb$export$2e2bcd8739ae039,
    webhooks: $4876a5c42776d99c$export$2e2bcd8739ae039,
    webhook_details: $e1ffc7149d504daa$export$2e2bcd8739ae039,
    domain: $ed804ace730657d8$export$2e2bcd8739ae039,
    tenants: $61b58fa2a07602b5$export$2e2bcd8739ae039,
    tenant_members: $63fb3e8e20a63f63$export$2e2bcd8739ae039,
    topbar: $d93b7967f91c17ee$export$2e2bcd8739ae039,
    subscription: $fd82732a08dcbeae$export$2e2bcd8739ae039,
    upsell: $086524beb8470e0b$export$2e2bcd8739ae039,
    guide: $36747702ec29a5da$export$2e2bcd8739ae039,
    mfa: $5bbc4569e18770ad$export$2e2bcd8739ae039,
    organizations: $1607c2e3d28d805e$export$2e2bcd8739ae039,
    organization_details: $b3b43326165a975b$export$2e2bcd8739ae039,
    protected_app: $126f6d7da7b456f3$export$2e2bcd8739ae039,
    jwt_claims: $564e7dade36ed9f5$export$2e2bcd8739ae039,
    invitation: $09faac63a871b242$export$2e2bcd8739ae039,
    signing_keys: $4e4066825406fcc2$export$2e2bcd8739ae039,
    organization_template: $c1f1f2ae473ba592$export$2e2bcd8739ae039,
    organization_role_details: $71ce3e454b641231$export$2e2bcd8739ae039
};
var $b713dbb4b43d6d78$export$2e2bcd8739ae039 = Object.freeze($b713dbb4b43d6d78$var$admin_console);


const $f1360871181c5ac1$var$demo_app = {
    title: "你已成功登錄實時預覽！",
    subtitle: "以下是本次登錄的用戶信息：",
    username: "用戶名：",
    user_id: "用戶 ID：",
    sign_out: "退出實時預覽",
    continue_explore: "或繼續探索",
    customize_sign_in_experience: "自定義登錄體驗",
    enable_passwordless: "啟用無密碼登錄",
    add_social_connector: "添加社交連接器"
};
var $f1360871181c5ac1$export$2e2bcd8739ae039 = Object.freeze($f1360871181c5ac1$var$demo_app);


const $f65a931e5146f146$var$oidc = {
    logout_success: "你已經成功登出。"
};
var $f65a931e5146f146$export$2e2bcd8739ae039 = Object.freeze($f65a931e5146f146$var$oidc);


const $3f5874ebfca18fab$var$translation = {
    admin_console: $b713dbb4b43d6d78$export$2e2bcd8739ae039,
    demo_app: $f1360871181c5ac1$export$2e2bcd8739ae039,
    oidc: $f65a931e5146f146$export$2e2bcd8739ae039
};
var $3f5874ebfca18fab$export$2e2bcd8739ae039 = Object.freeze($3f5874ebfca18fab$var$translation);


const $a6dd4b79f58c0844$var$zh_tw = {
    translation: $3f5874ebfca18fab$export$2e2bcd8739ae039,
    errors: $5ef01ca316b15147$export$2e2bcd8739ae039
};
var $a6dd4b79f58c0844$export$2e2bcd8739ae039 = Object.freeze($a6dd4b79f58c0844$var$zh_tw);


const $b350636e94694953$export$651548ae3cf5e245 = [
    "de",
    "en",
    "es",
    "fr",
    "it",
    "ja",
    "ko",
    "pl-PL",
    "pt-BR",
    "pt-PT",
    "ru",
    "tr-TR",
    "zh-CN",
    "zh-HK",
    "zh-TW"
];
const $b350636e94694953$export$91d555a17bb93dc7 = $b350636e94694953$export$651548ae3cf5e245.map((languageTag)=>({
        value: languageTag,
        title: (0, $cOUYQ.languages)[languageTag]
    }));
const $b350636e94694953$export$5ac61cba82e41a23 = (0, $c3dK3.z).enum($b350636e94694953$export$651548ae3cf5e245);
const $b350636e94694953$export$559ef0bafb7e082f = (languages)=>$b350636e94694953$export$5ac61cba82e41a23.or((0, $eRB1v.fallback)("en")).parse(languages);
const $b350636e94694953$export$562f9b4f03c85f6c = (language)=>$b350636e94694953$export$5ac61cba82e41a23.safeParse(language).success;
const $b350636e94694953$var$resource = {
    de: $83a5879ce529224a$export$2e2bcd8739ae039,
    en: $1cf82157fc13542a$export$2e2bcd8739ae039,
    es: $c389f6e746eb8bfb$export$2e2bcd8739ae039,
    fr: $4dfc3de6524d3b5b$export$2e2bcd8739ae039,
    it: $065bef1f90e20d70$export$2e2bcd8739ae039,
    ja: $2ccc54dc338a0b7a$export$2e2bcd8739ae039,
    ko: $e5e7327eaf56d643$export$2e2bcd8739ae039,
    "pl-PL": (0, $7e791e71534d736a$export$2e2bcd8739ae039),
    "pt-BR": (0, $d677fbe04b3e7ff4$export$2e2bcd8739ae039),
    "pt-PT": (0, $b575aefd79f4bc71$export$2e2bcd8739ae039),
    ru: $bc9372e03e528245$export$2e2bcd8739ae039,
    "tr-TR": (0, $c069507bcce8337d$export$2e2bcd8739ae039),
    "zh-CN": (0, $82da0d93a871d7f2$export$2e2bcd8739ae039),
    "zh-HK": (0, $e52623e587726891$export$2e2bcd8739ae039),
    "zh-TW": (0, $a6dd4b79f58c0844$export$2e2bcd8739ae039)
};
var $b350636e94694953$export$2e2bcd8739ae039 = $b350636e94694953$var$resource;



var $jC8Vy = parcelRequire("jC8Vy");

var $c3dK3 = parcelRequire("c3dK3");

var $6gkG2 = parcelRequire("6gkG2");

var $hrP0q = parcelRequire("hrP0q");
parcelRequire("9zW7e");
var $jSb9j = parcelRequire("jSb9j");

var $jC8Vy = parcelRequire("jC8Vy");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $voszV = parcelRequire("voszV");
parcelRequire("8Mb3E");
var $ku6YN = parcelRequire("ku6YN");
var $7YcaX = parcelRequire("7YcaX");

var $7VnwS = parcelRequire("7VnwS");

var $5cXXM = parcelRequire("5cXXM");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $7VnwS = parcelRequire("7VnwS");
const $04c74fc7d2f91811$var$useSwrFetcher = (api)=>{
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const fetcher = (0, $jC8Vy.useCallback)(async (resource)=>{
        try {
            const response = await api.get(resource);
            const data = await response.json();
            if (typeof resource === "string" && resource.includes("?")) {
                const parameters = new URLSearchParams(resource.split("?")[1]);
                if (parameters.get("page") && parameters.get("page_size")) {
                    const number = response.headers.get("Total-Number");
                    if (!number) throw new Error(t("errors.missing_total_number"));
                    return [
                        data,
                        Number(number)
                    ];
                }
            }
            return data;
        } catch (error) {
            if (error instanceof (0, $5cXXM.HTTPError)) {
                const { response: response } = error;
                // See https://stackoverflow.com/questions/53511974/javascript-fetch-failed-to-execute-json-on-response-body-stream-is-locked
                // for why `.clone()` is needed
                throw new (0, $7VnwS.RequestError)(response.status, await response.clone().json());
            }
            throw error;
        }
    }, [
        api,
        t
    ]);
    return fetcher;
};
var $04c74fc7d2f91811$export$2e2bcd8739ae039 = $04c74fc7d2f91811$var$useSwrFetcher;


const $8dc2d4d6918e57ba$var$useCurrentUser = ()=>{
    const { isAuthenticated: isAuthenticated } = (0, $jSb9j.useLogto)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const api = (0, $7VnwS.useStaticApi)({
        prefixUrl: (0, $ku6YN.adminTenantEndpoint),
        resourceIndicator: (0, $7YcaX.meApi).indicator
    });
    const fetcher = (0, $04c74fc7d2f91811$export$2e2bcd8739ae039)(api);
    const { data: user, error: error, isLoading: isLoading, mutate: mutate } = (0, $voszV.default)(isAuthenticated && "me", fetcher);
    const updateCustomData = (0, $jC8Vy.useCallback)(async (customData)=>{
        if (!user) {
            (0, $FuhPC.toast).error(t("errors.unexpected_error"));
            return;
        }
        await mutate({
            ...user,
            customData: await api.patch(`me/custom-data`, {
                json: customData
            }).json()
        });
    }, [
        api,
        mutate,
        t,
        user
    ]);
    return {
        user: user,
        isLoading: isLoading,
        error: error,
        isLoaded: !isLoading && !error,
        reload: mutate,
        customData: user?.customData,
        updateCustomData: /** Patch (shallow merge) the custom data of the current user. */ updateCustomData
    };
};
var $8dc2d4d6918e57ba$export$2e2bcd8739ae039 = $8dc2d4d6918e57ba$var$useCurrentUser;


const $c83ac2f0f8302d6c$var$adminConsolePreferencesKey = "adminConsolePreferences";
const $c83ac2f0f8302d6c$var$userPreferencesGuard = (0, $c3dK3.z).object({
    language: (0, $c3dK3.z).enum((0, $b350636e94694953$export$651548ae3cf5e245)).optional(),
    appearanceMode: (0, $hrP0q.appearanceModeGuard).optional(),
    experienceNoticeConfirmed: (0, $c3dK3.z).boolean().optional(),
    connectorSieNoticeConfirmed: (0, $c3dK3.z).boolean().optional(),
    managementApiAcknowledged: (0, $c3dK3.z).boolean().optional(),
    roleWithManagementApiAccessNotificationAcknowledged: (0, $c3dK3.z).boolean().optional(),
    m2mRoleNotificationAcknowledged: (0, $c3dK3.z).boolean().optional()
});
const $c83ac2f0f8302d6c$var$defaultUserPreferences = {
    appearanceMode: (0, $6gkG2.buildDefaultAppearanceMode)(),
    language: "en"
};
const $c83ac2f0f8302d6c$var$useUserPreferences = ()=>{
    const { customData: customData, error: error, isLoading: isLoading, isLoaded: isLoaded, updateCustomData: updateCustomData } = (0, $8dc2d4d6918e57ba$export$2e2bcd8739ae039)();
    const { setAppearanceMode: setAppearanceMode } = (0, $jC8Vy.useContext)((0, $6gkG2.AppThemeContext));
    const userPreferences = (0, $jC8Vy.useMemo)(()=>{
        const parsed = (0, $c3dK3.z).object({
            [$c83ac2f0f8302d6c$var$adminConsolePreferencesKey]: $c83ac2f0f8302d6c$var$userPreferencesGuard
        }).safeParse(customData);
        return parsed.success ? {
            ...$c83ac2f0f8302d6c$var$defaultUserPreferences,
            ...parsed.data[$c83ac2f0f8302d6c$var$adminConsolePreferencesKey]
        } : $c83ac2f0f8302d6c$var$defaultUserPreferences;
    }, [
        customData
    ]);
    const update = async (data)=>{
        await updateCustomData({
            [$c83ac2f0f8302d6c$var$adminConsolePreferencesKey]: {
                ...userPreferences,
                ...data
            }
        });
    };
    (0, $jC8Vy.useEffect)(()=>{
        setAppearanceMode(userPreferences.appearanceMode);
    }, [
        setAppearanceMode,
        userPreferences.appearanceMode
    ]);
    return {
        isLoading: isLoading,
        isLoaded: isLoaded,
        data: userPreferences,
        update: update,
        error: error
    };
};
var $c83ac2f0f8302d6c$export$2e2bcd8739ae039 = $c83ac2f0f8302d6c$var$useUserPreferences;


function $d7b7c71669250da7$var$AppBoundary({ children: children }) {
    const { data: { language: language } } = (0, $c83ac2f0f8302d6c$export$2e2bcd8739ae039)();
    const { i18n: i18n } = (0, $5OuPq.useTranslation)();
    (0, $jC8Vy.useEffect)(()=>{
        i18n.changeLanguage(language);
    }, [
        i18n,
        language
    ]);
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $C7mD2.Fragment), {
        children: children
    });
}
var $d7b7c71669250da7$export$2e2bcd8739ae039 = $d7b7c71669250da7$var$AppBoundary;



var $6gkG2 = parcelRequire("6gkG2");

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $FuhPC = parcelRequire("FuhPC");

var $4vbce = parcelRequire("4vbce");

var $kjc8Y = parcelRequire("kjc8Y");
var $643c4e1da357a916$export$a3bc9b8ed74fc;
var $643c4e1da357a916$export$5c452ff88e35e47d;
var $643c4e1da357a916$export$a8ecead220dd38a6;
var $643c4e1da357a916$export$bfd64c937657f93a;
var $643c4e1da357a916$export$4a6dd88bada4e7d2;
var $643c4e1da357a916$export$fe7c49d056ea1d88;
var $643c4e1da357a916$export$b410431fab84fa58;
$643c4e1da357a916$export$a3bc9b8ed74fc = `i5jzhG_error`;
$643c4e1da357a916$export$5c452ff88e35e47d = `i5jzhG_image`;
$643c4e1da357a916$export$a8ecead220dd38a6 = `i5jzhG_message`;
$643c4e1da357a916$export$bfd64c937657f93a = `i5jzhG_rotating`;
$643c4e1da357a916$export$4a6dd88bada4e7d2 = `i5jzhG_shimmer`;
$643c4e1da357a916$export$fe7c49d056ea1d88 = `i5jzhG_success`;
$643c4e1da357a916$export$b410431fab84fa58 = `i5jzhG_toast`;


function $8f6fee413997db41$var$Toast() {
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $FuhPC.Toaster), {
        toastOptions: {
            className: $643c4e1da357a916$export$b410431fab84fa58,
            success: {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($643c4e1da357a916$export$b410431fab84fa58, $643c4e1da357a916$export$fe7c49d056ea1d88),
                icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $kjc8Y.default), {})
            },
            error: {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($643c4e1da357a916$export$b410431fab84fa58, $643c4e1da357a916$export$a3bc9b8ed74fc),
                icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4vbce.default), {})
            }
        },
        children: (toastInstance)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: toastInstance.className,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $643c4e1da357a916$export$5c452ff88e35e47d,
                        children: toastInstance.icon
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $643c4e1da357a916$export$a8ecead220dd38a6,
                        children: (0, $FuhPC.resolveValue)(toastInstance.message, toastInstance)
                    })
                ]
            })
    });
}
var $8f6fee413997db41$export$2e2bcd8739ae039 = $8f6fee413997db41$var$Toast;


parcelRequire("12bMu");
var $gcHb7 = parcelRequire("gcHb7");
var $7819d3e6243755ec$exports = {};
/* eslint-env browser */ /**
 * This is the web browser implementation of `debug()`.
 */ 
var $9fi9T = parcelRequire("9fi9T");
$7819d3e6243755ec$exports.formatArgs = $7819d3e6243755ec$var$formatArgs;
$7819d3e6243755ec$exports.save = $7819d3e6243755ec$var$save;
$7819d3e6243755ec$exports.load = $7819d3e6243755ec$var$load;
$7819d3e6243755ec$exports.useColors = $7819d3e6243755ec$var$useColors;
$7819d3e6243755ec$exports.storage = $7819d3e6243755ec$var$localstorage();
$7819d3e6243755ec$exports.destroy = (()=>{
    let warned = false;
    return ()=>{
        if (!warned) {
            warned = true;
            console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
        }
    };
})();
/**
 * Colors.
 */ $7819d3e6243755ec$exports.colors = [
    "#0000CC",
    "#0000FF",
    "#0033CC",
    "#0033FF",
    "#0066CC",
    "#0066FF",
    "#0099CC",
    "#0099FF",
    "#00CC00",
    "#00CC33",
    "#00CC66",
    "#00CC99",
    "#00CCCC",
    "#00CCFF",
    "#3300CC",
    "#3300FF",
    "#3333CC",
    "#3333FF",
    "#3366CC",
    "#3366FF",
    "#3399CC",
    "#3399FF",
    "#33CC00",
    "#33CC33",
    "#33CC66",
    "#33CC99",
    "#33CCCC",
    "#33CCFF",
    "#6600CC",
    "#6600FF",
    "#6633CC",
    "#6633FF",
    "#66CC00",
    "#66CC33",
    "#9900CC",
    "#9900FF",
    "#9933CC",
    "#9933FF",
    "#99CC00",
    "#99CC33",
    "#CC0000",
    "#CC0033",
    "#CC0066",
    "#CC0099",
    "#CC00CC",
    "#CC00FF",
    "#CC3300",
    "#CC3333",
    "#CC3366",
    "#CC3399",
    "#CC33CC",
    "#CC33FF",
    "#CC6600",
    "#CC6633",
    "#CC9900",
    "#CC9933",
    "#CCCC00",
    "#CCCC33",
    "#FF0000",
    "#FF0033",
    "#FF0066",
    "#FF0099",
    "#FF00CC",
    "#FF00FF",
    "#FF3300",
    "#FF3333",
    "#FF3366",
    "#FF3399",
    "#FF33CC",
    "#FF33FF",
    "#FF6600",
    "#FF6633",
    "#FF9900",
    "#FF9933",
    "#FFCC00",
    "#FFCC33"
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ // eslint-disable-next-line complexity
function $7819d3e6243755ec$var$useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== "undefined" && window.process && (window.process.type === "renderer" || window.process.__nwjs)) return true;
    // Internet Explorer and Edge do not support colors.
    if (typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return false;
    // Is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return typeof document !== "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function $7819d3e6243755ec$var$formatArgs(args) {
    args[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + args[0] + (this.useColors ? "%c " : " ") + "+" + $7819d3e6243755ec$exports.humanize(this.diff);
    if (!this.useColors) return;
    const c = "color: " + this.color;
    args.splice(1, 0, c, "color: inherit");
    // The final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    let index = 0;
    let lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, (match)=>{
        if (match === "%%") return;
        index++;
        if (match === "%c") // We only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.debug()` when available.
 * No-op when `console.debug` is not a "function".
 * If `console.debug` is not available, falls back
 * to `console.log`.
 *
 * @api public
 */ $7819d3e6243755ec$exports.log = console.debug || console.log || (()=>{});
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function $7819d3e6243755ec$var$save(namespaces) {
    try {
        if (namespaces) $7819d3e6243755ec$exports.storage.setItem("debug", namespaces);
        else $7819d3e6243755ec$exports.storage.removeItem("debug");
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function $7819d3e6243755ec$var$load() {
    let r;
    try {
        r = $7819d3e6243755ec$exports.storage.getItem("debug");
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    if (!r && typeof $9fi9T !== "undefined" && "env" in $9fi9T) r = undefined;
    return r;
}
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function $7819d3e6243755ec$var$localstorage() {
    try {
        // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
        // The Browser also has localStorage in the global context.
        return localStorage;
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}

$7819d3e6243755ec$exports = (parcelRequire("bawJt"))($7819d3e6243755ec$exports);
const { formatters: $7819d3e6243755ec$var$formatters } = $7819d3e6243755ec$exports;
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ $7819d3e6243755ec$var$formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (error) {
        return "[UnexpectedJSONParseError]: " + error.message;
    }
};



var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("6bq3s");
var $2Phw0 = parcelRequire("2Phw0");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

const $34139a4008fff4d0$var$log = (0, (/*@__PURE__*/$parcel$interopDefault($7819d3e6243755ec$exports)))("conversion");
const $34139a4008fff4d0$export$7e9b8aa268c9f6e = "AW-11124811245";
var $34139a4008fff4d0$export$a3b35db81871225;
(function(GtagConversionId) {
    GtagConversionId[/** This ID indicates a user has truly signed up for Logto Cloud. */ "SignUp"] = "AW-11192640559/ZuqUCLvNpasYEK_IiNkp";
    GtagConversionId[/** This ID indicates a user has created their first app. */ "CreateFirstApp"] = "AW-11192640559/jbsaCPS67q8ZEK_IiNkp";
    GtagConversionId[/** This ID indicates a user has created a production tenant. */ "CreateProductionTenant"] = "AW-11192640559/m04fCMDrxI0ZEK_IiNkp";
    GtagConversionId[/** This ID indicates a user has purchased a Pro plan. */ "PurchaseProPlan"] = "AW-11192640559/WjCtCKHCtpgZEK_IiNkp";
})($34139a4008fff4d0$export$a3b35db81871225 || ($34139a4008fff4d0$export$a3b35db81871225 = {}));
const $34139a4008fff4d0$export$1a0493764955a0a9 = "t2_ggt11omdo";
const $34139a4008fff4d0$export$cfa05c56c26bdd8f = "logto.io";
const $34139a4008fff4d0$var$logtoProductionHostname = "logto.io";
const $34139a4008fff4d0$export$e4409b62080e611 = window.location.hostname.endsWith("." + $34139a4008fff4d0$var$logtoProductionHostname);
const $34139a4008fff4d0$var$sha256 = async (message)=>{
    const hash = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(message));
    // https://stackoverflow.com/questions/40031688/javascript-arraybuffer-to-hex
    return [
        ...new Uint8Array(hash)
    ].map((value)=>value.toString(16).padStart(2, "0")).join("");
};
const $34139a4008fff4d0$export$2cb26a492a43576c = async (email)=>{
    if (!email) return;
    const splitEmail = email.toLocaleLowerCase().trim().split("@");
    const [localPart, domain] = splitEmail;
    if (!localPart || !domain || splitEmail.length > 2) return;
    // eslint-disable-next-line unicorn/prefer-string-replace-all
    const canonicalizedEmail = `${localPart.replace(/\./g, "").replace(/\+.*/, "")}@${domain}`;
    return $34139a4008fff4d0$var$sha256(canonicalizedEmail);
};
const $34139a4008fff4d0$var$reportToReddit = (redditType)=>{
    if (!window.rdt) {
        $34139a4008fff4d0$var$log("report:", "window.rdt is not available");
        return false;
    }
    $34139a4008fff4d0$var$log("report:", "redditType =", redditType);
    window.rdt("track", redditType);
    return true;
};
const $34139a4008fff4d0$export$f1adda6fc3c8905c = (gtagId, { transactionId: transactionId } = {})=>{
    if (!window.gtag) {
        $34139a4008fff4d0$var$log("report:", "window.gtag is not available");
        return false;
    }
    const run = async ()=>{
        const transaction = (0, $7oDSS.cond)(transactionId && {
            transaction_id: await $34139a4008fff4d0$var$sha256(transactionId)
        });
        $34139a4008fff4d0$var$log("report:", "gtagId =", gtagId, "transaction =", transaction);
        window.gtag?.("event", "conversion", {
            send_to: gtagId,
            ...transaction
        });
    };
    run();
    return true;
};
const $34139a4008fff4d0$export$4d684b225153f74e = ({ gtagId: gtagId, redditType: redditType, transactionId: transactionId })=>{
    if (!$34139a4008fff4d0$export$e4409b62080e611) {
        $34139a4008fff4d0$var$log("skip reporting conversion:", {
            gtagId: gtagId,
            redditType: redditType,
            transactionId: transactionId
        });
        return;
    }
    if (gtagId) $34139a4008fff4d0$export$f1adda6fc3c8905c(gtagId, {
        transactionId: transactionId
    });
    if (redditType) $34139a4008fff4d0$var$reportToReddit(redditType);
};


parcelRequire("2Phw0");
var $4szZx = parcelRequire("4szZx");
const $021fc6959406fb20$export$d738435097971c09 = (pathname, routes)=>{
    // Remove the first segment of the pathname, which is the tenant ID.
    const normalized = pathname.replace(/^\/[^/]+/, "");
    const matches = (0, $4szZx.matchRoutes)(routes, normalized) ?? [];
    return "/" + matches.filter((match)=>!match.route.index).flatMap(({ route: { path: path }, params: params })=>{
        // Path could have multiple segments, e.g. 'api-resources/:id/*'.
        const segments = path?.split("/") ?? [];
        return segments.map((segment)=>{
            if (segment === "*") return params["*"] ?? segment;
            // If the path is not a parameter, or it's an ID parameter, use the path as is.
            // Exception: For `:guideId`, we want to use the parameter value for better analytics.
            if (segment !== ":guideId" && (!segment.startsWith(":") || segment.endsWith("Id") || segment.endsWith("id"))) return segment;
            // Otherwise, use the parameter value.
            return params[segment.slice(1)] ?? segment;
        });
    }).join("/");
};


const $77d0d5b50790ecf4$var$log = (0, (/*@__PURE__*/$parcel$interopDefault($7819d3e6243755ec$exports)))("usePlausiblePageview");
const $77d0d5b50790ecf4$export$751a22e57b65a4b5 = (routes, prefix)=>{
    const { pathname: pathname } = (0, $2Phw0.useLocation)();
    (0, $jC8Vy.useEffect)(()=>{
        const routePattern = (0, $021fc6959406fb20$export$d738435097971c09)(pathname, routes);
        $77d0d5b50790ecf4$var$log("pageview", routePattern);
        // https://plausible.io/docs/custom-locations#3-specify-a-custom-location
        window.plausible?.("pageview", {
            u: (0, $gcHb7.appendPath)(new URL("https://" + (0, $34139a4008fff4d0$export$cfa05c56c26bdd8f)), prefix, routePattern).href + window.location.search
        });
    }, [
        pathname,
        prefix,
        routes
    ]);
};



var $C7mD2 = parcelRequire("C7mD2");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $27da1c1f41f71409$var$SvgCloudLogo = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 90,
        height: 28,
        viewBox: "0 0 90 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1.167 4.372c0-.804 0-1.207.156-1.53.137-.286.358-.528.637-.697.316-.192.735-.25 1.575-.364L15.515.153c1.087-.148 1.63-.222 2.053-.066.37.137.68.391.876.72.223.374.223.895.223 1.936v22.514c0 1.041 0 1.562-.223 1.936a1.702 1.702 0 0 1-.876.72c-.423.156-.966.082-2.054-.066L3.535 26.22c-.84-.114-1.26-.172-1.575-.364-.279-.17-.5-.411-.637-.697-.156-.323-.156-.726-.156-1.53V4.372ZM14 11.962c0-.244 0-.367.041-.463a.459.459 0 0 1 .167-.205c.082-.055.191-.066.41-.088l.975-.1c.257-.025.385-.038.484.01.087.042.16.115.205.209.051.106.051.25.051.539v4.272c0 .289 0 .433-.051.54a.446.446 0 0 1-.205.209c-.099.047-.227.034-.484.008l-.976-.1c-.218-.021-.327-.032-.409-.087a.459.459 0 0 1-.167-.205C14 16.405 14 16.282 14 16.037v-4.074Zm7.96-9.045h-1.543v22.75h1.542c.89 0 1.334 0 1.674-.174a1.59 1.59 0 0 0 .694-.696c.173-.34.173-.786.173-1.678V5.465c0-.892 0-1.338-.173-1.679a1.59 1.59 0 0 0-.694-.696c-.34-.173-.784-.173-1.674-.173Z",
                fill: "url(#paint0_linear_193_5093)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M49.892 21.467c-1.198 0-2.233-.25-3.105-.747a5.063 5.063 0 0 1-2.008-2.078c-.467-.903-.7-1.946-.7-3.13 0-1.214.24-2.264.723-3.152a5.218 5.218 0 0 1 2.032-2.078c.887-.498 1.922-.747 3.105-.747 1.199 0 2.226.249 3.082.747a5.218 5.218 0 0 1 2.032 2.078c.482.888.724 1.93.724 3.13 0 1.182-.25 2.225-.748 3.128a5.18 5.18 0 0 1-2.031 2.102c-.872.482-1.907.731-3.106.747Zm.024-2.265c.654 0 1.214-.164 1.681-.49.467-.327.825-.77 1.074-1.331.265-.56.397-1.191.397-1.892 0-.716-.124-1.354-.374-1.914-.249-.56-.607-.997-1.074-1.308-.467-.327-1.027-.49-1.68-.49-.624 0-1.176.163-1.659.49-.482.327-.856.77-1.12 1.33-.25.561-.382 1.192-.398 1.892 0 .716.125 1.355.374 1.915a3.08 3.08 0 0 0 1.097 1.331c.483.311 1.044.467 1.682.467ZM68.006 9.96a.122.122 0 0 0-.122-.121H65.49a.122.122 0 0 0-.121.121v11.95c0 .794-.296 1.288-.888 1.724-.576.435-1.224.578-2.142.593-.638-.015-1.237-.072-1.766-.243a9.862 9.862 0 0 1-1.607-.644.123.123 0 0 0-.166.057l-.86 1.835a.119.119 0 0 0 .04.15c.262.178.569.338.92.479.39.155.787.28 1.191.373.42.11.855.2 1.228.247.39.047.757.053.99.053 1.184 0 2.196-.187 3.036-.56.856-.374 1.51-.903 1.962-1.588.467-.685.7-1.502.7-2.452V9.96ZM66.1 17.695a.125.125 0 0 0-.209-.032c-.458.527-.923.9-1.364 1.142-.467.265-1.004.397-1.611.397-.623 0-1.168-.156-1.635-.467a3.047 3.047 0 0 1-1.027-1.331c-.234-.56-.35-1.206-.35-1.938 0-.7.116-1.323.35-1.868a3.047 3.047 0 0 1 1.027-1.331c.467-.327 1.02-.49 1.658-.49.592 0 1.059.124 1.541.373.45.226.93.74 1.343 1.277.057.075.175.061.212-.026l.662-1.563a.12.12 0 0 0-.011-.116c-.836-1.2-2.25-2.187-3.86-2.187-1.168 0-2.09.249-2.946.747a5.105 5.105 0 0 0-1.985 2.078c-.451.888-.677 1.923-.677 3.106 0 1.214.226 2.273.677 3.176a4.996 4.996 0 0 0 1.938 2.078c.857.498 1.869.747 3.036.747.436 0 .887-.086 1.354-.257.483-.156.95-.39 1.401-.7a5.414 5.414 0 0 0 1.147-1.065.12.12 0 0 0 .016-.122l-.687-1.628ZM77.036 10.054a.122.122 0 0 0-.122-.122h-2.605a.122.122 0 0 1-.122-.122V6.625a.122.122 0 0 0-.122-.122h-2.371a.122.122 0 0 0-.122.122V9.81a.122.122 0 0 1-.122.122h-1.587a.122.122 0 0 0-.121.123l.02 1.975c.001.066.055.12.122.12h1.566c.067 0 .122.055.122.122v5.506c0 .825.163 1.525.49 2.101.343.56.81.989 1.401 1.284.592.296 1.308.444 2.148.444.234 0 .483-.031.748-.093.28-.063.55-.128.784-.222a7.28 7.28 0 0 0 .822-.402.115.115 0 0 0 .04-.157l-.963-1.698a.125.125 0 0 0-.154-.055 3.67 3.67 0 0 1-.483.147c-.202.047-.405.07-.607.07-.545 0-.95-.057-1.214-.415-.265-.374-.397-.849-.397-1.425v-5.085c0-.067.054-.122.122-.122h2.605a.122.122 0 0 0 .122-.122v-1.974ZM83.95 21.461c-1.2 0-2.235-.249-3.106-.747a5.063 5.063 0 0 1-2.009-2.078c-.467-.903-.7-1.946-.7-3.13 0-1.213.241-2.264.724-3.152a5.218 5.218 0 0 1 2.031-2.078c.888-.498 1.923-.747 3.106-.747 1.198 0 2.226.25 3.082.747a5.219 5.219 0 0 1 2.031 2.079c.483.887.724 1.93.724 3.128 0 1.183-.249 2.226-.747 3.13a5.18 5.18 0 0 1-2.031 2.1c-.872.483-1.907.733-3.106.748Zm.022-2.265c.654 0 1.215-.163 1.682-.49.467-.327.825-.77 1.074-1.331.264-.56.397-1.191.397-1.892 0-.716-.125-1.354-.374-1.914-.249-.56-.607-.997-1.074-1.308-.467-.327-1.027-.49-1.681-.49-.623 0-1.175.163-1.658.49a3.24 3.24 0 0 0-1.12 1.331c-.25.56-.382 1.191-.398 1.891 0 .716.125 1.355.374 1.915a3.08 3.08 0 0 0 1.097 1.331c.483.312 1.043.467 1.681.467ZM42.97 19.109a.122.122 0 0 0-.121-.122h-6.302a.122.122 0 0 1-.122-.122V6.599a.122.122 0 0 0-.122-.121h-2.348a.122.122 0 0 0-.122.121v14.746c0 .067.055.122.122.122h8.894a.122.122 0 0 0 .121-.122V19.11Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("defs", {
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                    id: "paint0_linear_193_5093",
                    x1: -6.056,
                    y1: 19.364,
                    x2: 22.686,
                    y2: 7.615,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            stopColor: "#4B2EFB"
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            offset: 1,
                            stopColor: "#E65FFC"
                        })
                    ]
                })
            })
        ]
    });
var $27da1c1f41f71409$export$2e2bcd8739ae039 = $27da1c1f41f71409$var$SvgCloudLogo;


var $5498e42612c2b836$export$db3c28d99448dcff;
var $5498e42612c2b836$export$bfd64c937657f93a;
var $5498e42612c2b836$export$4a6dd88bada4e7d2;
var $5498e42612c2b836$export$42c68d6252221cac;
$5498e42612c2b836$export$db3c28d99448dcff = `LvYW9G_logo`;
$5498e42612c2b836$export$bfd64c937657f93a = `LvYW9G_rotating`;
$5498e42612c2b836$export$4a6dd88bada4e7d2 = `LvYW9G_shimmer`;
$5498e42612c2b836$export$42c68d6252221cac = `LvYW9G_topbar`;


function $309a71316332eab7$var$Topbar() {
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: $5498e42612c2b836$export$42c68d6252221cac,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $27da1c1f41f71409$export$2e2bcd8739ae039), {
            className: $5498e42612c2b836$export$db3c28d99448dcff
        })
    });
}
var $309a71316332eab7$export$2e2bcd8739ae039 = $309a71316332eab7$var$Topbar;


parcelRequire("cuPVN");
var $dNkWp = parcelRequire("dNkWp");

var $jC8Vy = parcelRequire("jC8Vy");

var $c3dK3 = parcelRequire("c3dK3");

var $8TpMk = parcelRequire("8TpMk");

const $ce45228420657e93$var$useUserOnboardingData = ()=>{
    const { customData: customData, error: error, isLoading: isLoading, isLoaded: isLoaded, updateCustomData: updateCustomData } = (0, $8dc2d4d6918e57ba$export$2e2bcd8739ae039)();
    const userOnboardingData = (0, $jC8Vy.useMemo)(()=>{
        const parsed = (0, $c3dK3.z).object({
            [(0, $dNkWp.userOnboardingDataKey)]: (0, $dNkWp.userOnboardingDataGuard)
        }).safeParse(customData);
        return parsed.success ? parsed.data[0, $dNkWp.userOnboardingDataKey] : {};
    }, [
        customData
    ]);
    const isOnboarding = (0, $jC8Vy.useMemo)(()=>{
        if (!(0, $8TpMk.isCloud)) return false;
        return !userOnboardingData.isOnboardingDone;
    }, [
        userOnboardingData.isOnboardingDone
    ]);
    const update = (0, $jC8Vy.useCallback)(async (data)=>{
        await updateCustomData({
            [(0, $dNkWp.userOnboardingDataKey)]: {
                ...userOnboardingData,
                ...data
            }
        });
    }, [
        updateCustomData,
        userOnboardingData
    ]);
    return {
        data: userOnboardingData,
        error: error,
        isLoading: isLoading,
        isLoaded: isLoaded,
        isOnboarding: isOnboarding,
        update: update
    };
};
var $ce45228420657e93$export$2e2bcd8739ae039 = $ce45228420657e93$var$useUserOnboardingData;


var $85d8df6e048c6090$export$729c8b7179294ba;
var $85d8df6e048c6090$export$a7db06668cad9adb;
var $85d8df6e048c6090$export$bfd64c937657f93a;
var $85d8df6e048c6090$export$4a6dd88bada4e7d2;
$85d8df6e048c6090$export$729c8b7179294ba = `E9EZ-a_app`;
$85d8df6e048c6090$export$a7db06668cad9adb = `E9EZ-a_content`;
$85d8df6e048c6090$export$bfd64c937657f93a = `E9EZ-a_rotating`;
$85d8df6e048c6090$export$4a6dd88bada4e7d2 = `E9EZ-a_shimmer`;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("4taJ0");
var $9vrm1 = parcelRequire("9vrm1");
parcelRequire("9zW7e");
var $jSb9j = parcelRequire("jSb9j");
parcelRequire("cuPVN");
var $aZIrr = parcelRequire("aZIrr");
var $5HVJe = parcelRequire("5HVJe");
parcelRequire("12bMu");
var $gcHb7 = parcelRequire("gcHb7");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $41ec666b40f91547$var$SvgCreateTenantHeaderDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 5,
                cy: 15,
                r: 1.5,
                stroke: "#78767F"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 37.707,
                y: 7.828,
                width: 3,
                height: 3,
                rx: 0.5,
                transform: "rotate(-45 37.707 7.828)",
                stroke: "#78767F"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 42,
                cy: 32,
                r: 1.5,
                stroke: "#78767F"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M11 24.674 21.996 14.8a3 3 0 0 1 4.008 0l10 8.98A3 3 0 0 1 37 26.011V36a3 3 0 0 1-3 3H14a3 3 0 0 1-3-3V24.674Z",
                fill: "#F7ACCF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M11 24.674 21.996 14.8a3 3 0 0 1 4.008 0l10 8.98A3 3 0 0 1 37 26.011V36a3 3 0 0 1-3 3H14a3 3 0 0 1-3-3V24.674Z",
                fill: "url(#paint0_linear_8217_107638)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M26.174 9.679a3 3 0 0 0-3.907-.007L6.652 23.023a2 2 0 0 0-.108 2.942l.747.74a2 2 0 0 0 2.707.099l12.863-10.997a2 2 0 0 1 2.6 0L38 26.529a2 2 0 0 0 2.708-.099l.752-.745a2 2 0 0 0-.103-2.937L26.174 9.678Z",
                fill: "url(#paint1_linear_8217_107638)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                filter: "url(#filter0_i_8217_107638)",
                fillRule: "evenodd",
                clipRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M24 25a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4-1a4.001 4.001 0 0 1-2.5 3.71V30h.5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-.5v1.5a1.5 1.5 0 0 1-3 0v-6.79A4.001 4.001 0 1 1 28 24Z",
                        fill: "#5E35F3"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M24 25a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4-1a4.001 4.001 0 0 1-2.5 3.71V30h.5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-.5v1.5a1.5 1.5 0 0 1-3 0v-6.79A4.001 4.001 0 1 1 28 24Z",
                        fill: "url(#paint2_linear_8217_107638)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_8217_107638",
                        x1: 21.396,
                        y1: 12.2,
                        x2: 16.152,
                        y2: 38.805,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FFF06A"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FDA8BF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_8217_107638",
                        x1: 12.357,
                        y1: 24.511,
                        x2: 23.593,
                        y2: 2.781,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAABFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint2_linear_8217_107638",
                        x1: 20,
                        y1: 33.107,
                        x2: 33.232,
                        y2: 32.307,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAABFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("filter", {
                        id: "filter0_i_8217_107638",
                        x: 20,
                        y: 20,
                        width: 8,
                        height: 18,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feOffset", {
                                dy: 2
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feGaussianBlur", {
                                stdDeviation: 1
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: -1,
                                k3: 1
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feBlend", {
                                in2: "shape",
                                result: "effect1_innerShadow_8217_107638"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $41ec666b40f91547$export$2e2bcd8739ae039 = $41ec666b40f91547$var$SvgCreateTenantHeaderDark;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $be12ee274bf4d860$var$SvgCreateTenantHeader = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 5,
                cy: 15,
                r: 1.5,
                stroke: "#FFD5FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 37.707,
                y: 7.828,
                width: 3,
                height: 3,
                rx: 0.5,
                transform: "rotate(-45 37.707 7.828)",
                stroke: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 42,
                cy: 32,
                r: 1.5,
                stroke: "#FFD5FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M11 24.674 21.996 14.8a3 3 0 0 1 4.008 0l10 8.98A3 3 0 0 1 37 26.011V36a3 3 0 0 1-3 3H14a3 3 0 0 1-3-3V24.674Z",
                fill: "#F7ACCF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M11 24.674 21.996 14.8a3 3 0 0 1 4.008 0l10 8.98A3 3 0 0 1 37 26.011V36a3 3 0 0 1-3 3H14a3 3 0 0 1-3-3V24.674Z",
                fill: "url(#paint0_linear_480_32283)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M26.174 9.679a3 3 0 0 0-3.907-.007L6.652 23.023a2 2 0 0 0-.108 2.942l.747.74a2 2 0 0 0 2.707.099l12.863-10.997a2 2 0 0 1 2.6 0L38 26.529a2 2 0 0 0 2.708-.099l.752-.745a2 2 0 0 0-.103-2.937L26.174 9.678Z",
                fill: "url(#paint1_linear_480_32283)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                filter: "url(#filter0_i_480_32283)",
                fillRule: "evenodd",
                clipRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M24 25a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4-1a4.001 4.001 0 0 1-2.5 3.71V30h.5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-.5v1.5a1.5 1.5 0 0 1-3 0v-6.79A4.001 4.001 0 1 1 28 24Z",
                        fill: "#5E35F3"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M24 25a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4-1a4.001 4.001 0 0 1-2.5 3.71V30h.5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-.5v1.5a1.5 1.5 0 0 1-3 0v-6.79A4.001 4.001 0 1 1 28 24Z",
                        fill: "url(#paint2_linear_480_32283)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_480_32283",
                        x1: 21.396,
                        y1: 12.2,
                        x2: 16.152,
                        y2: 38.805,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FFF06A"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FDA8BF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_480_32283",
                        x1: 12.357,
                        y1: 24.511,
                        x2: 23.593,
                        y2: 2.781,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAABFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint2_linear_480_32283",
                        x1: 20,
                        y1: 33.107,
                        x2: 33.232,
                        y2: 32.307,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAABFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("filter", {
                        id: "filter0_i_480_32283",
                        x: 20,
                        y: 20,
                        width: 8,
                        height: 18,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feOffset", {
                                dy: 2
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feGaussianBlur", {
                                stdDeviation: 1
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: -1,
                                k3: 1
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feBlend", {
                                in2: "shape",
                                result: "effect1_innerShadow_480_32283"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $be12ee274bf4d860$export$2e2bcd8739ae039 = $be12ee274bf4d860$var$SvgCreateTenantHeader;




var $C7mD2 = parcelRequire("C7mD2");

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");
var $e64c9bec4fd2b48b$export$89da14300d534261;
var $e64c9bec4fd2b48b$export$9d1298853f0e77f7;
var $e64c9bec4fd2b48b$export$bfd64c937657f93a;
var $e64c9bec4fd2b48b$export$4a6dd88bada4e7d2;
var $e64c9bec4fd2b48b$export$bb815eb3cca9af81;
$e64c9bec4fd2b48b$export$89da14300d534261 = `rhjZ5G_active`;
$e64c9bec4fd2b48b$export$9d1298853f0e77f7 = `rhjZ5G_progressBar`;
$e64c9bec4fd2b48b$export$bfd64c937657f93a = `rhjZ5G_rotating`;
$e64c9bec4fd2b48b$export$4a6dd88bada4e7d2 = `rhjZ5G_shimmer`;
$e64c9bec4fd2b48b$export$bb815eb3cca9af81 = `rhjZ5G_stepIndicator`;


function $ce66022e75a8ff18$var$ProgressBar({ currentStep: currentStep, totalSteps: totalSteps }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: $e64c9bec4fd2b48b$export$9d1298853f0e77f7,
        children: Array.from({
            length: totalSteps
        }, (_, i)=>i + 1).map((step)=>/*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($e64c9bec4fd2b48b$export$bb815eb3cca9af81, step <= currentStep && $e64c9bec4fd2b48b$export$89da14300d534261)
            }, step))
    });
}
var $ce66022e75a8ff18$export$2e2bcd8739ae039 = $ce66022e75a8ff18$var$ProgressBar;


var $904dee81bdce44d8$export$e324594224ef24da;
var $904dee81bdce44d8$export$34e0f9847d4c02dd;
var $904dee81bdce44d8$export$bfd64c937657f93a;
var $904dee81bdce44d8$export$4a6dd88bada4e7d2;
$904dee81bdce44d8$export$e324594224ef24da = `V_YYMW_actions`;
$904dee81bdce44d8$export$34e0f9847d4c02dd = `V_YYMW_container`;
$904dee81bdce44d8$export$bfd64c937657f93a = `V_YYMW_rotating`;
$904dee81bdce44d8$export$4a6dd88bada4e7d2 = `V_YYMW_shimmer`;


function $d5ec2c6fd251ac7a$var$ActionBar({ step: step, totalSteps: totalSteps, children: children }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $904dee81bdce44d8$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ce66022e75a8ff18$export$2e2bcd8739ae039), {
                currentStep: step,
                totalSteps: totalSteps
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $904dee81bdce44d8$export$e324594224ef24da,
                children: children
            })
        ]
    });
}
var $d5ec2c6fd251ac7a$export$2e2bcd8739ae039 = $d5ec2c6fd251ac7a$var$ActionBar;



var $5TsIB = parcelRequire("5TsIB");

var $56db5 = parcelRequire("56db5");

var $8TpMk = parcelRequire("8TpMk");

var $cDKfs = parcelRequire("cDKfs");

var $jGWQ4 = parcelRequire("jGWQ4");

var $8R7rc = parcelRequire("8R7rc");

var $aqmjm = parcelRequire("aqmjm");

var $aTllQ = parcelRequire("aTllQ");

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $66ixW = parcelRequire("66ixW");
var $370dacf4d1214969$exports = {};

$parcel$export($370dacf4d1214969$exports, "card", function () { return $370dacf4d1214969$export$aa3e815946b80764; }, function (v) { return $370dacf4d1214969$export$aa3e815946b80764 = v; });
$parcel$export($370dacf4d1214969$exports, "checked", function () { return $370dacf4d1214969$export$b96bb35bc88d6fa; }, function (v) { return $370dacf4d1214969$export$b96bb35bc88d6fa = v; });
$parcel$export($370dacf4d1214969$exports, "compact", function () { return $370dacf4d1214969$export$8e16b83750b44988; }, function (v) { return $370dacf4d1214969$export$8e16b83750b44988 = v; });
$parcel$export($370dacf4d1214969$exports, "content", function () { return $370dacf4d1214969$export$a7db06668cad9adb; }, function (v) { return $370dacf4d1214969$export$a7db06668cad9adb = v; });
$parcel$export($370dacf4d1214969$exports, "disabled", function () { return $370dacf4d1214969$export$683472f6198a076e; }, function (v) { return $370dacf4d1214969$export$683472f6198a076e = v; });
$parcel$export($370dacf4d1214969$exports, "disabledLabel", function () { return $370dacf4d1214969$export$75ab0831e3bea081; }, function (v) { return $370dacf4d1214969$export$75ab0831e3bea081 = v; });
$parcel$export($370dacf4d1214969$exports, "icon", function () { return $370dacf4d1214969$export$1ca1ec8b29a4ce27; }, function (v) { return $370dacf4d1214969$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($370dacf4d1214969$exports, "indicator", function () { return $370dacf4d1214969$export$e897cab68364f2de; }, function (v) { return $370dacf4d1214969$export$e897cab68364f2de = v; });
$parcel$export($370dacf4d1214969$exports, "plain", function () { return $370dacf4d1214969$export$58d971314ad6cab; }, function (v) { return $370dacf4d1214969$export$58d971314ad6cab = v; });
$parcel$export($370dacf4d1214969$exports, "radio", function () { return $370dacf4d1214969$export$b56dc0f160585b86; }, function (v) { return $370dacf4d1214969$export$b56dc0f160585b86 = v; });
$parcel$export($370dacf4d1214969$exports, "rotating", function () { return $370dacf4d1214969$export$bfd64c937657f93a; }, function (v) { return $370dacf4d1214969$export$bfd64c937657f93a = v; });
$parcel$export($370dacf4d1214969$exports, "shimmer", function () { return $370dacf4d1214969$export$4a6dd88bada4e7d2; }, function (v) { return $370dacf4d1214969$export$4a6dd88bada4e7d2 = v; });
$parcel$export($370dacf4d1214969$exports, "small", function () { return $370dacf4d1214969$export$3c17b0e969a90510; }, function (v) { return $370dacf4d1214969$export$3c17b0e969a90510 = v; });
$parcel$export($370dacf4d1214969$exports, "trailingIcon", function () { return $370dacf4d1214969$export$74dc5dd4e622afa8; }, function (v) { return $370dacf4d1214969$export$74dc5dd4e622afa8 = v; });
var $370dacf4d1214969$export$aa3e815946b80764;
var $370dacf4d1214969$export$b96bb35bc88d6fa;
var $370dacf4d1214969$export$8e16b83750b44988;
var $370dacf4d1214969$export$a7db06668cad9adb;
var $370dacf4d1214969$export$683472f6198a076e;
var $370dacf4d1214969$export$75ab0831e3bea081;
var $370dacf4d1214969$export$1ca1ec8b29a4ce27;
var $370dacf4d1214969$export$e897cab68364f2de;
var $370dacf4d1214969$export$58d971314ad6cab;
var $370dacf4d1214969$export$b56dc0f160585b86;
var $370dacf4d1214969$export$bfd64c937657f93a;
var $370dacf4d1214969$export$4a6dd88bada4e7d2;
var $370dacf4d1214969$export$3c17b0e969a90510;
var $370dacf4d1214969$export$74dc5dd4e622afa8;
$370dacf4d1214969$export$aa3e815946b80764 = `-PZGtG_card`;
$370dacf4d1214969$export$b96bb35bc88d6fa = `-PZGtG_checked`;
$370dacf4d1214969$export$8e16b83750b44988 = `-PZGtG_compact`;
$370dacf4d1214969$export$a7db06668cad9adb = `-PZGtG_content`;
$370dacf4d1214969$export$683472f6198a076e = `-PZGtG_disabled`;
$370dacf4d1214969$export$75ab0831e3bea081 = `-PZGtG_disabledLabel`;
$370dacf4d1214969$export$1ca1ec8b29a4ce27 = `-PZGtG_icon`;
$370dacf4d1214969$export$e897cab68364f2de = `-PZGtG_indicator`;
$370dacf4d1214969$export$58d971314ad6cab = `-PZGtG_plain`;
$370dacf4d1214969$export$b56dc0f160585b86 = `-PZGtG_radio`;
$370dacf4d1214969$export$bfd64c937657f93a = `-PZGtG_rotating`;
$370dacf4d1214969$export$4a6dd88bada4e7d2 = `-PZGtG_shimmer`;
$370dacf4d1214969$export$3c17b0e969a90510 = `-PZGtG_small`;
$370dacf4d1214969$export$74dc5dd4e622afa8 = `-PZGtG_trailingIcon`;


function $b4b7cf2a2e4180e8$var$Check() {
    return /*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: "17",
        height: "16",
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M8.66666 1.33334C4.99999 1.33334 1.99999 4.33334 1.99999 8.00001C1.99999 11.6667 4.99999 14.6667 8.66666 14.6667C12.3333 14.6667 15.3333 11.6667 15.3333 8.00001C15.3333 4.33334 12.3333 1.33334 8.66666 1.33334ZM11.4667 6.86668L8.26666 10.0667C7.99999 10.3333 7.59999 10.3333 7.33333 10.0667L5.86666 8.60001C5.59999 8.33334 5.59999 7.93334 5.86666 7.66668C6.13333 7.40001 6.53333 7.40001 6.79999 7.66668L7.79999 8.66668L10.5333 5.93334C10.8 5.66668 11.2 5.66668 11.4667 5.93334C11.7333 6.20001 11.7333 6.60001 11.4667 6.86668Z",
            fill: "#5D34F2"
        })
    });
}
function $b4b7cf2a2e4180e8$var$Radio({ className: className, value: value, title: title, name: name, children: children, isChecked: isChecked, onClick: onClick, tabIndex: tabIndex, type: type = "plain", isDisabled: isDisabled, disabledLabel: disabledLabel, icon: icon, trailingIcon: trailingIcon, hasCheckIconForCard: hasCheckIconForCard = true }) {
    const handleKeyPress = (0, $jC8Vy.useCallback)((event)=>{
        if (isDisabled) return;
        if ([
            " ",
            "Enter"
        ].includes(event.key)) {
            onClick?.();
            event.preventDefault();
        }
    }, [
        isDisabled,
        onClick
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($370dacf4d1214969$exports.radio, $370dacf4d1214969$exports[type], isChecked && $370dacf4d1214969$exports.checked, isDisabled && $370dacf4d1214969$exports.disabled, className),
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "radio",
        tabIndex: tabIndex,
        onClick: isDisabled ? undefined : onClick,
        onKeyPress: handleKeyPress,
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
            className: $370dacf4d1214969$exports.content,
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsx)("input", {
                    readOnly: true,
                    disabled: true,
                    type: "radio",
                    name: name,
                    value: value,
                    checked: isChecked
                }),
                type === "card" && hasCheckIconForCard && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $370dacf4d1214969$exports.indicator,
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)($b4b7cf2a2e4180e8$var$Check, {})
                }),
                children,
                type === "plain" && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $370dacf4d1214969$exports.indicator
                }),
                icon && /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                    className: $370dacf4d1214969$exports.icon,
                    children: icon
                }),
                title && (typeof title === "string" ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                    forKey: title
                }) : title),
                trailingIcon && /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                    className: $370dacf4d1214969$exports.trailingIcon,
                    children: trailingIcon
                }),
                isDisabled && disabledLabel && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($370dacf4d1214969$exports.indicator, $370dacf4d1214969$exports.disabledLabel),
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                        forKey: disabledLabel
                    })
                })
            ]
        })
    });
}
var $b4b7cf2a2e4180e8$export$2e2bcd8739ae039 = $b4b7cf2a2e4180e8$var$Radio;


var $2f7be9a73922936c$exports = {};

$parcel$export($2f7be9a73922936c$exports, "compact", function () { return $2f7be9a73922936c$export$8e16b83750b44988; }, function (v) { return $2f7be9a73922936c$export$8e16b83750b44988 = v; });
$parcel$export($2f7be9a73922936c$exports, "radioGroup", function () { return $2f7be9a73922936c$export$7246d22ab0922ede; }, function (v) { return $2f7be9a73922936c$export$7246d22ab0922ede = v; });
$parcel$export($2f7be9a73922936c$exports, "rotating", function () { return $2f7be9a73922936c$export$bfd64c937657f93a; }, function (v) { return $2f7be9a73922936c$export$bfd64c937657f93a = v; });
$parcel$export($2f7be9a73922936c$exports, "shimmer", function () { return $2f7be9a73922936c$export$4a6dd88bada4e7d2; }, function (v) { return $2f7be9a73922936c$export$4a6dd88bada4e7d2 = v; });
$parcel$export($2f7be9a73922936c$exports, "small", function () { return $2f7be9a73922936c$export$3c17b0e969a90510; }, function (v) { return $2f7be9a73922936c$export$3c17b0e969a90510 = v; });
var $2f7be9a73922936c$export$8e16b83750b44988;
var $2f7be9a73922936c$export$7246d22ab0922ede;
var $2f7be9a73922936c$export$bfd64c937657f93a;
var $2f7be9a73922936c$export$4a6dd88bada4e7d2;
var $2f7be9a73922936c$export$3c17b0e969a90510;
$2f7be9a73922936c$export$8e16b83750b44988 = `ewusyq_compact`;
$2f7be9a73922936c$export$7246d22ab0922ede = `ewusyq_radioGroup`;
$2f7be9a73922936c$export$bfd64c937657f93a = `ewusyq_rotating`;
$2f7be9a73922936c$export$4a6dd88bada4e7d2 = `ewusyq_shimmer`;
$2f7be9a73922936c$export$3c17b0e969a90510 = `ewusyq_small`;


function $c8e461321115642d$var$RadioGroup({ name: name, children: children, value: value, className: className, onChange: onChange, type: type = "plain" }, ref) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($2f7be9a73922936c$exports.radioGroup, $2f7be9a73922936c$exports[type], className),
        children: (0, $jC8Vy.Children).map(children, (child)=>{
            if (!child || !/*#__PURE__*/ (0, $jC8Vy.isValidElement)(child) || child.type !== (0, $b4b7cf2a2e4180e8$export$2e2bcd8739ae039)) {
                // As typescript still cannot restrict React children to specific component types, we need to alert the error in runtime.
                // Reference: https://github.com/microsoft/TypeScript/issues/21699
                console.error("Invalid child type for RadioGroup:", child ? child.type : child, ". Expecting Radio components.");
                // Do not render child if not a valid Radio component
                return null;
            }
            return /*#__PURE__*/ (0, $jC8Vy.cloneElement)(child, {
                name: name,
                isChecked: value === child.props.value,
                onClick: ()=>{
                    onChange?.(child.props.value);
                },
                tabIndex: 0,
                type: type
            });
        })
    });
}
var $c8e461321115642d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $jC8Vy.forwardRef)($c8e461321115642d$var$RadioGroup);



var $fmHmG = parcelRequire("fmHmG");

var $4ZcUR = parcelRequire("4ZcUR");

var $jheqv = parcelRequire("jheqv");
var $150021613750da2d$export$a7db06668cad9adb;
var $150021613750da2d$export$8f981dffec84ba52;
var $150021613750da2d$export$6d59db4903f20f7d;
var $150021613750da2d$export$523fb3936f49e028;
var $150021613750da2d$export$bfd64c937657f93a;
var $150021613750da2d$export$4a6dd88bada4e7d2;
var $150021613750da2d$export$fb184b623420d9be;
$150021613750da2d$export$a7db06668cad9adb = `_3zvtua_content`;
$150021613750da2d$export$8f981dffec84ba52 = `_3zvtua_contentContainer`;
$150021613750da2d$export$6d59db4903f20f7d = `_3zvtua_description`;
$150021613750da2d$export$523fb3936f49e028 = `_3zvtua_page`;
$150021613750da2d$export$bfd64c937657f93a = `_3zvtua_rotating`;
$150021613750da2d$export$4a6dd88bada4e7d2 = `_3zvtua_shimmer`;
$150021613750da2d$export$fb184b623420d9be = `_3zvtua_title`;


var $6556ae972ac34d69$export$329ee42b27a3306e;
(function(OnboardingRoute) {
    OnboardingRoute["Onboarding"] = "onboarding";
})($6556ae972ac34d69$export$329ee42b27a3306e || ($6556ae972ac34d69$export$329ee42b27a3306e = {}));
var $6556ae972ac34d69$export$1572a1adf9290869;
(function(OnboardingPage) {
    OnboardingPage["Welcome"] = "welcome";
    OnboardingPage["CreateTenant"] = "create-tenant";
    OnboardingPage["SignInExperience"] = "sign-in-experience";
})($6556ae972ac34d69$export$1572a1adf9290869 || ($6556ae972ac34d69$export$1572a1adf9290869 = {}));



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("4taJ0");
var $9vrm1 = parcelRequire("9vrm1");
parcelRequire("ajkVG");
var $7WNrO = parcelRequire("7WNrO");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");

var $HHYyb = parcelRequire("HHYyb");

var $75SRw = parcelRequire("75SRw");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $5UrGx = parcelRequire("5UrGx");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $10eea442689aa670$var$SvgFailed = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "m14.266 11.994 5.266-5.266a1.598 1.598 0 1 0-2.26-2.26l-5.265 5.265L6.74 4.468a1.598 1.598 0 1 0-2.26 2.26l5.265 5.266-5.278 5.278a1.598 1.598 0 0 0 2.26 2.26l5.278-5.278 5.265 5.265a1.593 1.593 0 0 0 2.26 0 1.597 1.597 0 0 0 0-2.26l-5.265-5.265Z",
            fill: "currentColor"
        })
    });
var $10eea442689aa670$export$2e2bcd8739ae039 = $10eea442689aa670$var$SvgFailed;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $863c8122c7186617$var$SvgSuccess = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M19.677 4.222a1.375 1.375 0 0 0-1.902.405l-7.707 11.88-3.759-3.476a1.375 1.375 0 1 0-1.867 2.02l4.935 4.562s.141.122.207.165a1.375 1.375 0 0 0 1.903-.405l8.595-13.249a1.375 1.375 0 0 0-.405-1.902Z",
            fill: "currentColor"
        })
    });
var $863c8122c7186617$export$2e2bcd8739ae039 = $863c8122c7186617$var$SvgSuccess;


var $0b6794b85d33ee82$exports = {};

$parcel$export($0b6794b85d33ee82$exports, "alert", function () { return $0b6794b85d33ee82$export$5ea928c9faf85bd3; }, function (v) { return $0b6794b85d33ee82$export$5ea928c9faf85bd3 = v; });
$parcel$export($0b6794b85d33ee82$exports, "cell", function () { return $0b6794b85d33ee82$export$e2e1361cdc35271d; }, function (v) { return $0b6794b85d33ee82$export$e2e1361cdc35271d = v; });
$parcel$export($0b6794b85d33ee82$exports, "error", function () { return $0b6794b85d33ee82$export$a3bc9b8ed74fc; }, function (v) { return $0b6794b85d33ee82$export$a3bc9b8ed74fc = v; });
$parcel$export($0b6794b85d33ee82$exports, "icon", function () { return $0b6794b85d33ee82$export$1ca1ec8b29a4ce27; }, function (v) { return $0b6794b85d33ee82$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($0b6794b85d33ee82$exports, "info", function () { return $0b6794b85d33ee82$export$a80b3bd66acc52ff; }, function (v) { return $0b6794b85d33ee82$export$a80b3bd66acc52ff = v; });
$parcel$export($0b6794b85d33ee82$exports, "outlined", function () { return $0b6794b85d33ee82$export$fd128913e5eb5cb1; }, function (v) { return $0b6794b85d33ee82$export$fd128913e5eb5cb1 = v; });
$parcel$export($0b6794b85d33ee82$exports, "resultIcon", function () { return $0b6794b85d33ee82$export$1c9d9b61ae557bde; }, function (v) { return $0b6794b85d33ee82$export$1c9d9b61ae557bde = v; });
$parcel$export($0b6794b85d33ee82$exports, "rotating", function () { return $0b6794b85d33ee82$export$bfd64c937657f93a; }, function (v) { return $0b6794b85d33ee82$export$bfd64c937657f93a = v; });
$parcel$export($0b6794b85d33ee82$exports, "shimmer", function () { return $0b6794b85d33ee82$export$4a6dd88bada4e7d2; }, function (v) { return $0b6794b85d33ee82$export$4a6dd88bada4e7d2 = v; });
$parcel$export($0b6794b85d33ee82$exports, "small", function () { return $0b6794b85d33ee82$export$3c17b0e969a90510; }, function (v) { return $0b6794b85d33ee82$export$3c17b0e969a90510 = v; });
$parcel$export($0b6794b85d33ee82$exports, "tag", function () { return $0b6794b85d33ee82$export$2b067c6666111485; }, function (v) { return $0b6794b85d33ee82$export$2b067c6666111485 = v; });
var $0b6794b85d33ee82$export$5ea928c9faf85bd3;
var $0b6794b85d33ee82$export$e2e1361cdc35271d;
var $0b6794b85d33ee82$export$a3bc9b8ed74fc;
var $0b6794b85d33ee82$export$1ca1ec8b29a4ce27;
var $0b6794b85d33ee82$export$a80b3bd66acc52ff;
var $0b6794b85d33ee82$export$fd128913e5eb5cb1;
var $0b6794b85d33ee82$export$1c9d9b61ae557bde;
var $0b6794b85d33ee82$export$bfd64c937657f93a;
var $0b6794b85d33ee82$export$4a6dd88bada4e7d2;
var $0b6794b85d33ee82$export$3c17b0e969a90510;
var $0b6794b85d33ee82$export$2b067c6666111485;
$0b6794b85d33ee82$export$5ea928c9faf85bd3 = `RLtn4W_alert`;
$0b6794b85d33ee82$export$e2e1361cdc35271d = `RLtn4W_cell`;
$0b6794b85d33ee82$export$a3bc9b8ed74fc = `RLtn4W_error`;
$0b6794b85d33ee82$export$1ca1ec8b29a4ce27 = `RLtn4W_icon`;
$0b6794b85d33ee82$export$a80b3bd66acc52ff = `RLtn4W_info`;
$0b6794b85d33ee82$export$fd128913e5eb5cb1 = `RLtn4W_outlined`;
$0b6794b85d33ee82$export$1c9d9b61ae557bde = `RLtn4W_resultIcon`;
$0b6794b85d33ee82$export$bfd64c937657f93a = `RLtn4W_rotating`;
$0b6794b85d33ee82$export$4a6dd88bada4e7d2 = `RLtn4W_shimmer`;
$0b6794b85d33ee82$export$3c17b0e969a90510 = `RLtn4W_small`;
$0b6794b85d33ee82$export$2b067c6666111485 = `RLtn4W_tag`;


const $2a497e719fce103a$var$ResultIconMap = {
    success: (0, $863c8122c7186617$export$2e2bcd8739ae039),
    error: (0, $10eea442689aa670$export$2e2bcd8739ae039)
};
function $2a497e719fce103a$var$Tag({ type: type = "property", status: status = "info", variant: variant = "outlined", size: size = "medium", className: className, children: children, ...rest }) {
    const ResultIcon = (0, $7oDSS.conditional)(type === "result" && $2a497e719fce103a$var$ResultIconMap[status]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($0b6794b85d33ee82$exports.tag, $0b6794b85d33ee82$exports[status], $0b6794b85d33ee82$exports[variant], $0b6794b85d33ee82$exports[size], className),
        ...rest,
        children: [
            type === "state" && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $0b6794b85d33ee82$exports.icon
            }),
            ResultIcon && /*#__PURE__*/ (0, $C7mD2.jsx)(ResultIcon, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($0b6794b85d33ee82$exports.icon, $0b6794b85d33ee82$exports.resultIcon)
            }),
            children
        ]
    });
}
var $2a497e719fce103a$export$2e2bcd8739ae039 = $2a497e719fce103a$var$Tag;



var $bnkR4 = parcelRequire("bnkR4");
var $2e6207e1d2cfac41$exports = {};

$parcel$export($2e6207e1d2cfac41$exports, "close", function () { return $2e6207e1d2cfac41$export$8360e631d277ea4d; }, function (v) { return $2e6207e1d2cfac41$export$8360e631d277ea4d = v; });
$parcel$export($2e6207e1d2cfac41$exports, "delete", function () { return $2e6207e1d2cfac41$export$1822828d790e23ee; }, function (v) { return $2e6207e1d2cfac41$export$1822828d790e23ee = v; });
$parcel$export($2e6207e1d2cfac41$exports, "error", function () { return $2e6207e1d2cfac41$export$a3bc9b8ed74fc; }, function (v) { return $2e6207e1d2cfac41$export$a3bc9b8ed74fc = v; });
$parcel$export($2e6207e1d2cfac41$exports, "errorMessage", function () { return $2e6207e1d2cfac41$export$493b5823483d2c4e; }, function (v) { return $2e6207e1d2cfac41$export$493b5823483d2c4e = v; });
$parcel$export($2e6207e1d2cfac41$exports, "focused", function () { return $2e6207e1d2cfac41$export$4c2b230493b2b322; }, function (v) { return $2e6207e1d2cfac41$export$4c2b230493b2b322 = v; });
$parcel$export($2e6207e1d2cfac41$exports, "input", function () { return $2e6207e1d2cfac41$export$b7e3ae3d7c15e42e; }, function (v) { return $2e6207e1d2cfac41$export$b7e3ae3d7c15e42e = v; });
$parcel$export($2e6207e1d2cfac41$exports, "rotating", function () { return $2e6207e1d2cfac41$export$bfd64c937657f93a; }, function (v) { return $2e6207e1d2cfac41$export$bfd64c937657f93a = v; });
$parcel$export($2e6207e1d2cfac41$exports, "shimmer", function () { return $2e6207e1d2cfac41$export$4a6dd88bada4e7d2; }, function (v) { return $2e6207e1d2cfac41$export$4a6dd88bada4e7d2 = v; });
$parcel$export($2e6207e1d2cfac41$exports, "tag", function () { return $2e6207e1d2cfac41$export$2b067c6666111485; }, function (v) { return $2e6207e1d2cfac41$export$2b067c6666111485 = v; });
$parcel$export($2e6207e1d2cfac41$exports, "wrapper", function () { return $2e6207e1d2cfac41$export$cc74dcc53cfce4eb; }, function (v) { return $2e6207e1d2cfac41$export$cc74dcc53cfce4eb = v; });
var $2e6207e1d2cfac41$export$8360e631d277ea4d;
var $2e6207e1d2cfac41$export$1822828d790e23ee;
var $2e6207e1d2cfac41$export$a3bc9b8ed74fc;
var $2e6207e1d2cfac41$export$493b5823483d2c4e;
var $2e6207e1d2cfac41$export$4c2b230493b2b322;
var $2e6207e1d2cfac41$export$b7e3ae3d7c15e42e;
var $2e6207e1d2cfac41$export$bfd64c937657f93a;
var $2e6207e1d2cfac41$export$4a6dd88bada4e7d2;
var $2e6207e1d2cfac41$export$2b067c6666111485;
var $2e6207e1d2cfac41$export$cc74dcc53cfce4eb;
$2e6207e1d2cfac41$export$8360e631d277ea4d = `XZrzhG_close`;
$2e6207e1d2cfac41$export$1822828d790e23ee = `XZrzhG_delete`;
$2e6207e1d2cfac41$export$a3bc9b8ed74fc = `XZrzhG_error`;
$2e6207e1d2cfac41$export$493b5823483d2c4e = `XZrzhG_errorMessage`;
$2e6207e1d2cfac41$export$4c2b230493b2b322 = `XZrzhG_focused`;
$2e6207e1d2cfac41$export$b7e3ae3d7c15e42e = `XZrzhG_input`;
$2e6207e1d2cfac41$export$bfd64c937657f93a = `XZrzhG_rotating`;
$2e6207e1d2cfac41$export$4a6dd88bada4e7d2 = `XZrzhG_shimmer`;
$2e6207e1d2cfac41$export$2b067c6666111485 = `XZrzhG_tag`;
$2e6207e1d2cfac41$export$cc74dcc53cfce4eb = `XZrzhG_wrapper`;


/**
 * The body-2 font declared in @logto/core-kit/scss/fonts. It is referenced here to calculate
 * the width of the input text, which determines the minimum width of the input field.
 */ const $258de3c548691e45$var$fontBody2 = "400 14px / 20px -apple-system, system-ui, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji";
function $258de3c548691e45$var$InviteEmailsInput({ formName: formName = "emails", className: className, values: values, onChange: rawOnChange, error: error, placeholder: placeholder, parseEmailOptions: parseEmailOptions }) {
    const ref = (0, $jC8Vy.useRef)(null);
    const [focusedValueId, setFocusedValueId] = (0, $jC8Vy.useState)(null);
    const [currentValue, setCurrentValue] = (0, $jC8Vy.useState)("");
    const { setError: setError, clearErrors: clearErrors } = (0, $codQP.useFormContext)();
    const [minInputWidth, setMinInputWidth] = (0, $jC8Vy.useState)(0);
    const canvasRef = (0, $jC8Vy.useRef)(null);
    (0, $jC8Vy.useEffect)(()=>{
        // Render placeholder text in canvas to calculate its width in CSS pixels.
        const ctx = canvasRef.current?.getContext("2d");
        if (!ctx) return;
        ctx.font = $258de3c548691e45$var$fontBody2;
        setMinInputWidth(ctx.measureText(currentValue).width);
    }, [
        currentValue
    ]);
    const onChange = (values)=>{
        const { values: parsedValues, errorMessage: errorMessage } = parseEmailOptions(values);
        if (errorMessage) {
            setError(formName, {
                type: "custom",
                message: errorMessage
            });
            return false;
        }
        clearErrors(formName);
        rawOnChange(parsedValues);
        return true;
    };
    const handleAdd = (value)=>{
        const newValues = [
            ...values,
            {
                value: value,
                id: (0, $7WNrO.generateStandardShortId)(),
                ...(0, $7oDSS.conditional)(!(0, $9vrm1.emailRegEx).test(value) && {
                    status: "error"
                })
            }
        ];
        if (onChange(newValues)) {
            setCurrentValue("");
            ref.current?.focus();
        }
    };
    const handleDelete = (option)=>{
        onChange(values.filter(({ id: id })=>id !== option.id));
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($2e6207e1d2cfac41$exports.input, Boolean(error) && $2e6207e1d2cfac41$exports.error, className),
                role: "button",
                tabIndex: 0,
                onKeyDown: (0, $bnkR4.onKeyDownHandler)(()=>{
                    ref.current?.focus();
                }),
                onClick: ()=>{
                    ref.current?.focus();
                },
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: $2e6207e1d2cfac41$exports.wrapper,
                    children: [
                        values.map((option)=>/*#__PURE__*/ (0, $C7mD2.jsxs)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
                                variant: "cell",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($2e6207e1d2cfac41$exports.tag, option.status && $2e6207e1d2cfac41$exports[option.status], option.id === focusedValueId && $2e6207e1d2cfac41$exports.focused),
                                onClick: ()=>{
                                    ref.current?.focus();
                                },
                                children: [
                                    option.value,
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                                        className: $2e6207e1d2cfac41$exports.delete,
                                        size: "small",
                                        onClick: ()=>{
                                            handleDelete(option);
                                        },
                                        onKeyDown: (0, $bnkR4.onKeyDownHandler)(()=>{
                                            handleDelete(option);
                                        }),
                                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $HHYyb.default), {
                                            className: $2e6207e1d2cfac41$exports.close
                                        })
                                    })
                                ]
                            }, option.id)),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("input", {
                            ref: ref,
                            placeholder: (0, $7oDSS.conditional)(values.length === 0 && placeholder),
                            value: currentValue,
                            style: {
                                minWidth: `${minInputWidth + 10}px`
                            },
                            onKeyDown: (event)=>{
                                if (event.key === "Backspace" && currentValue === "") {
                                    if (focusedValueId) {
                                        onChange(values.filter(({ id: id })=>id !== focusedValueId));
                                        setFocusedValueId(null);
                                    } else setFocusedValueId(values.at(-1)?.id ?? null);
                                    ref.current?.focus();
                                }
                                if (event.key === " " || event.code === "Space" || event.key === "Enter") {
                                    // Focusing on input
                                    if (currentValue !== "" && document.activeElement === ref.current) handleAdd(currentValue);
                                    // Do not react to "Enter"
                                    event.preventDefault();
                                }
                            },
                            onChange: ({ currentTarget: { value: value } })=>{
                                setCurrentValue(value);
                                setFocusedValueId(null);
                            },
                            onFocus: ()=>{
                                ref.current?.focus();
                            },
                            onBlur: ()=>{
                                if (currentValue !== "") handleAdd(currentValue);
                                setFocusedValueId(null);
                            }
                        })
                    ]
                })
            }),
            Boolean(error) && typeof error === "string" && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $2e6207e1d2cfac41$exports.errorMessage,
                children: error
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("canvas", {
                ref: canvasRef
            })
        ]
    });
}
var $258de3c548691e45$export$2e2bcd8739ae039 = $258de3c548691e45$var$InviteEmailsInput;



var $5OcFi = parcelRequire("5OcFi");
function $94cf3eea58eb6b99$var$CreateTenant() {
    const methods = (0, $codQP.useForm)({
        defaultValues: {
            regionName: (0, $56db5.RegionName).EU,
            collaboratorEmails: []
        }
    });
    const { control: control, handleSubmit: handleSubmit, formState: { errors: errors, isSubmitting: isSubmitting }, register: register } = methods;
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const { prependTenant: prependTenant } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const theme = (0, $jheqv.default)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const parseEmailOptions = (0, $jC8Vy.useCallback)((values)=>{
        const validEmails = values.filter(({ value: value })=>(0, $9vrm1.emailRegEx).test(value));
        return {
            values: validEmails,
            errorMessage: values.length === validEmails.length ? undefined : t("tenant_members.errors.invalid_email")
        };
    }, [
        t
    ]);
    const { isAuthenticated: isAuthenticated, getOrganizationToken: getOrganizationToken } = (0, $jSb9j.useLogto)();
    const cloudApi = (0, $1c34cc51be8c93d3$export$7a5c900790855d66)();
    const onCreateClick = handleSubmit((0, $5OcFi.trySubmitSafe)(async ({ name: name, regionName: regionName, collaboratorEmails: collaboratorEmails })=>{
        const newTenant = await cloudApi.post("/api/tenants", {
            body: {
                name: name || "My project",
                regionName: regionName
            }
        });
        prependTenant(newTenant);
        (0, $FuhPC.toast).success(t("tenants.create_modal.tenant_created"));
        const tenantCloudApi = (0, $1c34cc51be8c93d3$export$87a78c52eef20676)({
            hideErrorToast: true,
            isAuthenticated: isAuthenticated,
            getOrganizationToken: getOrganizationToken,
            tenantId: newTenant.id
        });
        // Should not block the onboarding flow if the invitation fails.
        try {
            await Promise.all(collaboratorEmails.map(async (email)=>tenantCloudApi.post("/api/tenants/:tenantId/invitations", {
                    params: {
                        tenantId: newTenant.id
                    },
                    body: {
                        invitee: email.value,
                        roleName: (0, $aZIrr.TenantRole).Collaborator
                    }
                })));
            (0, $FuhPC.toast).success(t("tenant_members.messages.invitation_sent"));
        } catch  {
            (0, $FuhPC.toast).error(t("tenants.create_modal.invitation_failed", {
                duration: 5
            }));
        }
        navigate((0, $gcHb7.joinPath)((0, $6556ae972ac34d69$export$329ee42b27a3306e).Onboarding, newTenant.id, (0, $6556ae972ac34d69$export$1572a1adf9290869).SignInExperience));
    }));
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $150021613750da2d$export$523fb3936f49e028,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5TsIB.default), {
                titleKey: [
                    "cloud.create_tenant.page_title",
                    "cloud.general.onboarding"
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aTllQ.default), {
                className: $150021613750da2d$export$8f981dffec84ba52,
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: $150021613750da2d$export$a7db06668cad9adb,
                    children: [
                        theme === (0, $5HVJe.Theme).Light ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $be12ee274bf4d860$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $41ec666b40f91547$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $150021613750da2d$export$fb184b623420d9be,
                            children: t("cloud.create_tenant.title")
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $150021613750da2d$export$6d59db4903f20f7d,
                            children: t("cloud.create_tenant.description")
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $codQP.FormProvider), {
                            ...methods,
                            children: [
                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                    title: "tenants.settings.tenant_name",
                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                        // eslint-disable-next-line jsx-a11y/no-autofocus
                                        autoFocus: true,
                                        placeholder: "My project",
                                        disabled: isSubmitting,
                                        ...register("name"),
                                        error: Boolean(errors.name)
                                    })
                                }),
                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                    title: "tenants.settings.tenant_region",
                                    tip: t("tenants.settings.tenant_region_description"),
                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                                        control: control,
                                        name: "regionName",
                                        rules: {
                                            required: true
                                        },
                                        render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $c8e461321115642d$export$2e2bcd8739ae039), {
                                                type: "small",
                                                name: name,
                                                value: value,
                                                onChange: onChange,
                                                children: [
                                                    (0, $56db5.RegionName).EU,
                                                    (0, $56db5.RegionName).US
                                                ].map((region)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $b4b7cf2a2e4180e8$export$2e2bcd8739ae039), {
                                                        title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8R7rc.default), {
                                                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $56db5.default), {
                                                                regionName: region,
                                                                isComingSoon: !(0, $8TpMk.isDevFeaturesEnabled) && region !== (0, $56db5.RegionName).EU
                                                            })
                                                        }),
                                                        value: region,
                                                        isDisabled: isSubmitting || !(0, $8TpMk.isDevFeaturesEnabled) && region !== (0, $56db5.RegionName).EU
                                                    }, region))
                                            })
                                    })
                                }),
                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                    title: "cloud.create_tenant.invite_collaborators",
                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                                        name: "collaboratorEmails",
                                        control: control,
                                        rules: {
                                            validate: (value)=>{
                                                return parseEmailOptions(value).errorMessage ?? true;
                                            }
                                        },
                                        render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $258de3c548691e45$export$2e2bcd8739ae039), {
                                                formName: "collaboratorEmails",
                                                values: value,
                                                error: errors.collaboratorEmails?.message,
                                                placeholder: t("tenant_members.invite_modal.email_input_placeholder"),
                                                parseEmailOptions: parseEmailOptions,
                                                onChange: onChange
                                            })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $d5ec2c6fd251ac7a$export$2e2bcd8739ae039), {
                step: 2,
                totalSteps: 3,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                    title: "general.create",
                    type: "primary",
                    disabled: isSubmitting,
                    onClick: onCreateClick
                })
            })
        ]
    });
}
var $94cf3eea58eb6b99$export$2e2bcd8739ae039 = $94cf3eea58eb6b99$var$CreateTenant;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("oK7kD");
var $kowfT = parcelRequire("kowfT");
var $7YxsJ = parcelRequire("7YxsJ");
parcelRequire("cuPVN");
var $8lyC3 = parcelRequire("8lyC3");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $2Phw0 = parcelRequire("2Phw0");

var $voszV = parcelRequire("voszV");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $e1377b7b6e8b94be$var$SvgTools = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M12.13 13.1a1 1 0 0 1 1.414-1.414l9.193 9.193-1.414 1.414-9.192-9.193Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M8.596 10.98a2 2 0 1 1 2.828-2.828l2.829 2.827a2 2 0 1 1-2.829 2.828L8.596 10.98Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m17.082 25.122 8.485-8.486 12.728 12.728a6 6 0 0 1-8.485 8.485L17.082 25.122Z",
                fill: "url(#paint0_linear_389_78280)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 22.031,
                y: 25.829,
                width: 2,
                height: 16,
                rx: 1,
                transform: "rotate(-45 22.031 25.829)",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 24.859,
                y: 23,
                width: 2,
                height: 16,
                rx: 1,
                transform: "rotate(-45 24.86 23)",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M23.295 16.05a4 4 0 0 1 5.656 0l1.415 1.415a4 4 0 0 1 0 5.657L14.809 38.678a4 4 0 0 1-5.657 0l-1.414-1.414a4 4 0 0 1 0-5.657l15.557-15.556Z",
                fill: "url(#paint1_linear_389_78280)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 21.174,
                y: 23.829,
                width: 2,
                height: 16,
                rx: 1,
                transform: "rotate(45 21.174 23.83)",
                fill: "#B545CA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                opacity: 0.64,
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M24.002 22.415c3.905 3.905 10.237 3.905 14.142 0a9.976 9.976 0 0 0 2.906-7.754c-.098-1.439-1.808-1.83-2.827-.81l-2.908 2.907a2 2 0 0 1-2.828 0l-2.829-2.828a2 2 0 0 1 0-2.829l2.908-2.907c1.02-1.02.628-2.73-.81-2.827a9.977 9.977 0 0 0-7.754 2.906c-3.906 3.905-3.906 10.237 0 14.142Z",
                fill: "#F07EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 7,
                cy: 19,
                r: 1.5,
                stroke: "#FFD5FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 42,
                cy: 27,
                r: 1.5,
                stroke: "#F7F8F8"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 42,
                cy: 27,
                r: 1.5,
                stroke: "#78767F",
                strokeOpacity: 0.02
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 42,
                cy: 27,
                r: 1.5,
                stroke: "#5D34F2",
                strokeOpacity: 0.14
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 36.879,
                y: 7,
                width: 3,
                height: 3,
                rx: 0.5,
                transform: "rotate(-45 36.879 7)",
                stroke: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 19.879,
                y: 40,
                width: 3,
                height: 3,
                rx: 0.5,
                transform: "rotate(-45 19.879 40)",
                stroke: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_389_78280",
                        x1: 33.213,
                        y1: 38.336,
                        x2: 37.634,
                        y2: 23.745,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAABFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_389_78280",
                        x1: 28.793,
                        y1: 16.207,
                        x2: 3.058,
                        y2: 23.267,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FFF06A"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 0.5,
                                stopColor: "#FC85E9"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E264F7"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $e1377b7b6e8b94be$export$2e2bcd8739ae039 = $e1377b7b6e8b94be$var$SvgTools;





var $5TsIB = parcelRequire("5TsIB");

var $fG7L1 = parcelRequire("fG7L1");

var $jGWQ4 = parcelRequire("jGWQ4");

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $jC8Vy = parcelRequire("jC8Vy");
var $081a95961b0cb73f$exports = {};
"use strict";
Object.defineProperty($081a95961b0cb73f$exports, "__esModule", {
    value: true
});
$081a95961b0cb73f$exports.ReactCSS = $081a95961b0cb73f$exports.loop = $081a95961b0cb73f$exports.handleActive = $081a95961b0cb73f$exports.handleHover = $081a95961b0cb73f$exports.hover = undefined;
var $1e68a7299fc478d6$exports = {};
"use strict";
Object.defineProperty($1e68a7299fc478d6$exports, "__esModule", {
    value: true
});
$1e68a7299fc478d6$exports.flattenNames = undefined;
var $3719ffca02e94280$exports = {};
var $d607e1880b829c8a$exports = {};
var $a0e007488b23f5fe$exports = {};

var $jKHUh = parcelRequire("jKHUh");
/** Built-in value references. */ var $a0e007488b23f5fe$var$Symbol = $jKHUh.Symbol;
$a0e007488b23f5fe$exports = $a0e007488b23f5fe$var$Symbol;


var $b4e60bfb78002251$exports = {};

/** Used for built-in method references. */ var $b4e60bfb78002251$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b4e60bfb78002251$var$hasOwnProperty = $b4e60bfb78002251$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b4e60bfb78002251$var$nativeObjectToString = $b4e60bfb78002251$var$objectProto.toString;
/** Built-in value references. */ var $b4e60bfb78002251$var$symToStringTag = $a0e007488b23f5fe$exports ? $a0e007488b23f5fe$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $b4e60bfb78002251$var$getRawTag(value) {
    var isOwn = $b4e60bfb78002251$var$hasOwnProperty.call(value, $b4e60bfb78002251$var$symToStringTag), tag = value[$b4e60bfb78002251$var$symToStringTag];
    try {
        value[$b4e60bfb78002251$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $b4e60bfb78002251$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$b4e60bfb78002251$var$symToStringTag] = tag;
        else delete value[$b4e60bfb78002251$var$symToStringTag];
    }
    return result;
}
$b4e60bfb78002251$exports = $b4e60bfb78002251$var$getRawTag;


var $eb3df0164e499eea$exports = {};
/** Used for built-in method references. */ var $eb3df0164e499eea$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $eb3df0164e499eea$var$nativeObjectToString = $eb3df0164e499eea$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $eb3df0164e499eea$var$objectToString(value) {
    return $eb3df0164e499eea$var$nativeObjectToString.call(value);
}
$eb3df0164e499eea$exports = $eb3df0164e499eea$var$objectToString;


/** `Object#toString` result references. */ var $d607e1880b829c8a$var$nullTag = "[object Null]", $d607e1880b829c8a$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $d607e1880b829c8a$var$symToStringTag = $a0e007488b23f5fe$exports ? $a0e007488b23f5fe$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $d607e1880b829c8a$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $d607e1880b829c8a$var$undefinedTag : $d607e1880b829c8a$var$nullTag;
    return $d607e1880b829c8a$var$symToStringTag && $d607e1880b829c8a$var$symToStringTag in Object(value) ? $b4e60bfb78002251$exports(value) : $eb3df0164e499eea$exports(value);
}
$d607e1880b829c8a$exports = $d607e1880b829c8a$var$baseGetTag;


var $0fe4a5546443a34c$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0fe4a5546443a34c$var$isArray = Array.isArray;
$0fe4a5546443a34c$exports = $0fe4a5546443a34c$var$isArray;


var $a35b73cb295f324c$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $a35b73cb295f324c$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$a35b73cb295f324c$exports = $a35b73cb295f324c$var$isObjectLike;


/** `Object#toString` result references. */ var $3719ffca02e94280$var$stringTag = "[object String]";
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $3719ffca02e94280$var$isString(value) {
    return typeof value == "string" || !$0fe4a5546443a34c$exports(value) && $a35b73cb295f324c$exports(value) && $d607e1880b829c8a$exports(value) == $3719ffca02e94280$var$stringTag;
}
$3719ffca02e94280$exports = $3719ffca02e94280$var$isString;


var $1e68a7299fc478d6$var$_isString3 = $1e68a7299fc478d6$var$_interopRequireDefault($3719ffca02e94280$exports);
var $a545443a7331cfb0$exports = {};
var $48b10c759085c7c7$exports = {};
var $623829cac7e9fc20$exports = {};
var $5ea2c3ed28e40177$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $5ea2c3ed28e40177$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$5ea2c3ed28e40177$exports = $5ea2c3ed28e40177$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $623829cac7e9fc20$var$baseFor = $5ea2c3ed28e40177$exports();
$623829cac7e9fc20$exports = $623829cac7e9fc20$var$baseFor;


var $322e4354daac4308$exports = {};
var $7ef7f908fe37cd53$exports = {};
var $7a43d810c9502a32$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $7a43d810c9502a32$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$7a43d810c9502a32$exports = $7a43d810c9502a32$var$baseTimes;


var $740020e1b6465003$exports = {};
var $9efc13aad760bb92$exports = {};


/** `Object#toString` result references. */ var $9efc13aad760bb92$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $9efc13aad760bb92$var$baseIsArguments(value) {
    return $a35b73cb295f324c$exports(value) && $d607e1880b829c8a$exports(value) == $9efc13aad760bb92$var$argsTag;
}
$9efc13aad760bb92$exports = $9efc13aad760bb92$var$baseIsArguments;



/** Used for built-in method references. */ var $740020e1b6465003$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $740020e1b6465003$var$hasOwnProperty = $740020e1b6465003$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $740020e1b6465003$var$propertyIsEnumerable = $740020e1b6465003$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $740020e1b6465003$var$isArguments = $9efc13aad760bb92$exports(function() {
    return arguments;
}()) ? $9efc13aad760bb92$exports : function(value) {
    return $a35b73cb295f324c$exports(value) && $740020e1b6465003$var$hasOwnProperty.call(value, "callee") && !$740020e1b6465003$var$propertyIsEnumerable.call(value, "callee");
};
$740020e1b6465003$exports = $740020e1b6465003$var$isArguments;




var $ca1Sy = parcelRequire("ca1Sy");
var $8fea83d6de918b08$exports = {};
/** Used as references for various `Number` constants. */ var $8fea83d6de918b08$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $8fea83d6de918b08$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $8fea83d6de918b08$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $8fea83d6de918b08$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $8fea83d6de918b08$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$8fea83d6de918b08$exports = $8fea83d6de918b08$var$isIndex;


var $4bc71926a418ef11$exports = {};
var $1b9c88bd51938827$exports = {};

var $1db3e574198d6e84$exports = {};
/** Used as references for various `Number` constants. */ var $1db3e574198d6e84$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $1db3e574198d6e84$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $1db3e574198d6e84$var$MAX_SAFE_INTEGER;
}
$1db3e574198d6e84$exports = $1db3e574198d6e84$var$isLength;



/** `Object#toString` result references. */ var $1b9c88bd51938827$var$argsTag = "[object Arguments]", $1b9c88bd51938827$var$arrayTag = "[object Array]", $1b9c88bd51938827$var$boolTag = "[object Boolean]", $1b9c88bd51938827$var$dateTag = "[object Date]", $1b9c88bd51938827$var$errorTag = "[object Error]", $1b9c88bd51938827$var$funcTag = "[object Function]", $1b9c88bd51938827$var$mapTag = "[object Map]", $1b9c88bd51938827$var$numberTag = "[object Number]", $1b9c88bd51938827$var$objectTag = "[object Object]", $1b9c88bd51938827$var$regexpTag = "[object RegExp]", $1b9c88bd51938827$var$setTag = "[object Set]", $1b9c88bd51938827$var$stringTag = "[object String]", $1b9c88bd51938827$var$weakMapTag = "[object WeakMap]";
var $1b9c88bd51938827$var$arrayBufferTag = "[object ArrayBuffer]", $1b9c88bd51938827$var$dataViewTag = "[object DataView]", $1b9c88bd51938827$var$float32Tag = "[object Float32Array]", $1b9c88bd51938827$var$float64Tag = "[object Float64Array]", $1b9c88bd51938827$var$int8Tag = "[object Int8Array]", $1b9c88bd51938827$var$int16Tag = "[object Int16Array]", $1b9c88bd51938827$var$int32Tag = "[object Int32Array]", $1b9c88bd51938827$var$uint8Tag = "[object Uint8Array]", $1b9c88bd51938827$var$uint8ClampedTag = "[object Uint8ClampedArray]", $1b9c88bd51938827$var$uint16Tag = "[object Uint16Array]", $1b9c88bd51938827$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $1b9c88bd51938827$var$typedArrayTags = {};
$1b9c88bd51938827$var$typedArrayTags[$1b9c88bd51938827$var$float32Tag] = $1b9c88bd51938827$var$typedArrayTags[$1b9c88bd51938827$var$float64Tag] = $1b9c88bd51938827$var$typedArrayTags[$1b9c88bd51938827$var$int8Tag] = $1b9c88bd51938827$var$typedArrayTags[$1b9c88bd51938827$var$int16Tag] = $1b9c88bd51938827$var$typedArrayTags[$1b9c88bd51938827$var$int32Tag] = $1b9c88bd51938827$var$typedArrayTags[$1b9c88bd51938827$var$uint8Tag] = $1b9c88bd51938827$var$typedArrayTags[$1b9c88bd51938827$var$uint8ClampedTag] = $1b9c88bd51938827$var$typedArrayTags[$1b9c88bd51938827$var$uint16Tag] = $1b9c88bd51938827$var$typedArrayTags[$1b9c88bd51938827$var$uint32Tag] = true;
$1b9c88bd51938827$var$typedArrayTags[$1b9c88bd51938827$var$argsTag] = $1b9c88bd51938827$var$typedArrayTags[$1b9c88bd51938827$var$arrayTag] = $1b9c88bd51938827$var$typedArrayTags[$1b9c88bd51938827$var$arrayBufferTag] = $1b9c88bd51938827$var$typedArrayTags[$1b9c88bd51938827$var$boolTag] = $1b9c88bd51938827$var$typedArrayTags[$1b9c88bd51938827$var$dataViewTag] = $1b9c88bd51938827$var$typedArrayTags[$1b9c88bd51938827$var$dateTag] = $1b9c88bd51938827$var$typedArrayTags[$1b9c88bd51938827$var$errorTag] = $1b9c88bd51938827$var$typedArrayTags[$1b9c88bd51938827$var$funcTag] = $1b9c88bd51938827$var$typedArrayTags[$1b9c88bd51938827$var$mapTag] = $1b9c88bd51938827$var$typedArrayTags[$1b9c88bd51938827$var$numberTag] = $1b9c88bd51938827$var$typedArrayTags[$1b9c88bd51938827$var$objectTag] = $1b9c88bd51938827$var$typedArrayTags[$1b9c88bd51938827$var$regexpTag] = $1b9c88bd51938827$var$typedArrayTags[$1b9c88bd51938827$var$setTag] = $1b9c88bd51938827$var$typedArrayTags[$1b9c88bd51938827$var$stringTag] = $1b9c88bd51938827$var$typedArrayTags[$1b9c88bd51938827$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $1b9c88bd51938827$var$baseIsTypedArray(value) {
    return $a35b73cb295f324c$exports(value) && $1db3e574198d6e84$exports(value.length) && !!$1b9c88bd51938827$var$typedArrayTags[$d607e1880b829c8a$exports(value)];
}
$1b9c88bd51938827$exports = $1b9c88bd51938827$var$baseIsTypedArray;


var $6a1e4a18512710bb$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $6a1e4a18512710bb$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$6a1e4a18512710bb$exports = $6a1e4a18512710bb$var$baseUnary;



var $4noEQ = parcelRequire("4noEQ");
/* Node.js helper references. */ var $4bc71926a418ef11$var$nodeIsTypedArray = $4noEQ && $4noEQ.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $4bc71926a418ef11$var$isTypedArray = $4bc71926a418ef11$var$nodeIsTypedArray ? $6a1e4a18512710bb$exports($4bc71926a418ef11$var$nodeIsTypedArray) : $1b9c88bd51938827$exports;
$4bc71926a418ef11$exports = $4bc71926a418ef11$var$isTypedArray;


/** Used for built-in method references. */ var $7ef7f908fe37cd53$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7ef7f908fe37cd53$var$hasOwnProperty = $7ef7f908fe37cd53$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $7ef7f908fe37cd53$var$arrayLikeKeys(value, inherited) {
    var isArr = $0fe4a5546443a34c$exports(value), isArg = !isArr && $740020e1b6465003$exports(value), isBuff = !isArr && !isArg && $ca1Sy(value), isType = !isArr && !isArg && !isBuff && $4bc71926a418ef11$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $7a43d810c9502a32$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $7ef7f908fe37cd53$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $8fea83d6de918b08$exports(key, length)))) result.push(key);
    return result;
}
$7ef7f908fe37cd53$exports = $7ef7f908fe37cd53$var$arrayLikeKeys;


var $961a32f4ab069930$exports = {};
var $d8bce8a27fc077c6$exports = {};
/** Used for built-in method references. */ var $d8bce8a27fc077c6$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $d8bce8a27fc077c6$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $d8bce8a27fc077c6$var$objectProto;
    return value === proto;
}
$d8bce8a27fc077c6$exports = $d8bce8a27fc077c6$var$isPrototype;


var $82484a8729e71c1c$exports = {};
var $7cc80dc1e409d4e6$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $7cc80dc1e409d4e6$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$7cc80dc1e409d4e6$exports = $7cc80dc1e409d4e6$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $82484a8729e71c1c$var$nativeKeys = $7cc80dc1e409d4e6$exports(Object.keys, Object);
$82484a8729e71c1c$exports = $82484a8729e71c1c$var$nativeKeys;


/** Used for built-in method references. */ var $961a32f4ab069930$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $961a32f4ab069930$var$hasOwnProperty = $961a32f4ab069930$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $961a32f4ab069930$var$baseKeys(object) {
    if (!$d8bce8a27fc077c6$exports(object)) return $82484a8729e71c1c$exports(object);
    var result = [];
    for(var key in Object(object))if ($961a32f4ab069930$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
$961a32f4ab069930$exports = $961a32f4ab069930$var$baseKeys;


var $263ae7db1776a88c$exports = {};
var $88ef20dc5b761d7c$exports = {};

var $cdeebba9a3c50f33$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $cdeebba9a3c50f33$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$cdeebba9a3c50f33$exports = $cdeebba9a3c50f33$var$isObject;


/** `Object#toString` result references. */ var $88ef20dc5b761d7c$var$asyncTag = "[object AsyncFunction]", $88ef20dc5b761d7c$var$funcTag = "[object Function]", $88ef20dc5b761d7c$var$genTag = "[object GeneratorFunction]", $88ef20dc5b761d7c$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $88ef20dc5b761d7c$var$isFunction(value) {
    if (!$cdeebba9a3c50f33$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $d607e1880b829c8a$exports(value);
    return tag == $88ef20dc5b761d7c$var$funcTag || tag == $88ef20dc5b761d7c$var$genTag || tag == $88ef20dc5b761d7c$var$asyncTag || tag == $88ef20dc5b761d7c$var$proxyTag;
}
$88ef20dc5b761d7c$exports = $88ef20dc5b761d7c$var$isFunction;



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $263ae7db1776a88c$var$isArrayLike(value) {
    return value != null && $1db3e574198d6e84$exports(value.length) && !$88ef20dc5b761d7c$exports(value);
}
$263ae7db1776a88c$exports = $263ae7db1776a88c$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $322e4354daac4308$var$keys(object) {
    return $263ae7db1776a88c$exports(object) ? $7ef7f908fe37cd53$exports(object) : $961a32f4ab069930$exports(object);
}
$322e4354daac4308$exports = $322e4354daac4308$var$keys;


/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $48b10c759085c7c7$var$baseForOwn(object, iteratee) {
    return object && $623829cac7e9fc20$exports(object, iteratee, $322e4354daac4308$exports);
}
$48b10c759085c7c7$exports = $48b10c759085c7c7$var$baseForOwn;


var $beaf40415433db61$exports = {};
var $57b7bffe2f9def0f$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $57b7bffe2f9def0f$var$identity(value) {
    return value;
}
$57b7bffe2f9def0f$exports = $57b7bffe2f9def0f$var$identity;


/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $beaf40415433db61$var$castFunction(value) {
    return typeof value == "function" ? value : $57b7bffe2f9def0f$exports;
}
$beaf40415433db61$exports = $beaf40415433db61$var$castFunction;


/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $a545443a7331cfb0$var$forOwn(object, iteratee) {
    return object && $48b10c759085c7c7$exports(object, $beaf40415433db61$exports(iteratee));
}
$a545443a7331cfb0$exports = $a545443a7331cfb0$var$forOwn;


var $1e68a7299fc478d6$var$_forOwn3 = $1e68a7299fc478d6$var$_interopRequireDefault($a545443a7331cfb0$exports);
var $d86d9c04f1d20b21$exports = {};

var $6869910f8d4be8cc$exports = {};

/** Built-in value references. */ var $6869910f8d4be8cc$var$getPrototype = $7cc80dc1e409d4e6$exports(Object.getPrototypeOf, Object);
$6869910f8d4be8cc$exports = $6869910f8d4be8cc$var$getPrototype;



/** `Object#toString` result references. */ var $d86d9c04f1d20b21$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $d86d9c04f1d20b21$var$funcProto = Function.prototype, $d86d9c04f1d20b21$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $d86d9c04f1d20b21$var$funcToString = $d86d9c04f1d20b21$var$funcProto.toString;
/** Used to check objects for own properties. */ var $d86d9c04f1d20b21$var$hasOwnProperty = $d86d9c04f1d20b21$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $d86d9c04f1d20b21$var$objectCtorString = $d86d9c04f1d20b21$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $d86d9c04f1d20b21$var$isPlainObject(value) {
    if (!$a35b73cb295f324c$exports(value) || $d607e1880b829c8a$exports(value) != $d86d9c04f1d20b21$var$objectTag) return false;
    var proto = $6869910f8d4be8cc$exports(value);
    if (proto === null) return true;
    var Ctor = $d86d9c04f1d20b21$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $d86d9c04f1d20b21$var$funcToString.call(Ctor) == $d86d9c04f1d20b21$var$objectCtorString;
}
$d86d9c04f1d20b21$exports = $d86d9c04f1d20b21$var$isPlainObject;


var $1e68a7299fc478d6$var$_isPlainObject3 = $1e68a7299fc478d6$var$_interopRequireDefault($d86d9c04f1d20b21$exports);
var $8c69ba69485f4ea5$exports = {};
var $fdb8f9af1091eb2c$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $fdb8f9af1091eb2c$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$fdb8f9af1091eb2c$exports = $fdb8f9af1091eb2c$var$arrayMap;


var $958e35cadb69881a$exports = {};
var $faaabf04dab5825c$exports = {};
var $a085d11994ce7307$exports = {};
var $cd6a7fdc60b1cb13$exports = {};
var $37e4435101686cab$exports = {};
var $fcb38fa977f6b813$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $fcb38fa977f6b813$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$fcb38fa977f6b813$exports = $fcb38fa977f6b813$var$listCacheClear;


var $2591d6e9884b0eb6$exports = {};
var $417dff25b1abc6cf$exports = {};
var $2d67364ed6c1926e$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $2d67364ed6c1926e$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$2d67364ed6c1926e$exports = $2d67364ed6c1926e$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $417dff25b1abc6cf$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($2d67364ed6c1926e$exports(array[length][0], key)) return length;
    }
    return -1;
}
$417dff25b1abc6cf$exports = $417dff25b1abc6cf$var$assocIndexOf;


/** Used for built-in method references. */ var $2591d6e9884b0eb6$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $2591d6e9884b0eb6$var$splice = $2591d6e9884b0eb6$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $2591d6e9884b0eb6$var$listCacheDelete(key) {
    var data = this.__data__, index = $417dff25b1abc6cf$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $2591d6e9884b0eb6$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$2591d6e9884b0eb6$exports = $2591d6e9884b0eb6$var$listCacheDelete;


var $23125992642c2db3$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $23125992642c2db3$var$listCacheGet(key) {
    var data = this.__data__, index = $417dff25b1abc6cf$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$23125992642c2db3$exports = $23125992642c2db3$var$listCacheGet;


var $fadbe11091a77263$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fadbe11091a77263$var$listCacheHas(key) {
    return $417dff25b1abc6cf$exports(this.__data__, key) > -1;
}
$fadbe11091a77263$exports = $fadbe11091a77263$var$listCacheHas;


var $595df35b930d9b11$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $595df35b930d9b11$var$listCacheSet(key, value) {
    var data = this.__data__, index = $417dff25b1abc6cf$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$595df35b930d9b11$exports = $595df35b930d9b11$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $37e4435101686cab$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$37e4435101686cab$var$ListCache.prototype.clear = $fcb38fa977f6b813$exports;
$37e4435101686cab$var$ListCache.prototype["delete"] = $2591d6e9884b0eb6$exports;
$37e4435101686cab$var$ListCache.prototype.get = $23125992642c2db3$exports;
$37e4435101686cab$var$ListCache.prototype.has = $fadbe11091a77263$exports;
$37e4435101686cab$var$ListCache.prototype.set = $595df35b930d9b11$exports;
$37e4435101686cab$exports = $37e4435101686cab$var$ListCache;


var $798249f626785361$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $798249f626785361$var$stackClear() {
    this.__data__ = new $37e4435101686cab$exports;
    this.size = 0;
}
$798249f626785361$exports = $798249f626785361$var$stackClear;


var $ae1281894b16009f$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ae1281894b16009f$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
$ae1281894b16009f$exports = $ae1281894b16009f$var$stackDelete;


var $fcdca539f1c7516e$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $fcdca539f1c7516e$var$stackGet(key) {
    return this.__data__.get(key);
}
$fcdca539f1c7516e$exports = $fcdca539f1c7516e$var$stackGet;


var $ce63dea90a105fe6$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $ce63dea90a105fe6$var$stackHas(key) {
    return this.__data__.has(key);
}
$ce63dea90a105fe6$exports = $ce63dea90a105fe6$var$stackHas;


var $c8948e6479d3e5c3$exports = {};

var $1a3dc13f1ac8078e$exports = {};
var $d9506f24890283ad$exports = {};
var $c7c467af66221c54$exports = {};

var $7fa3b7e36387e851$exports = {};
var $bd99189286766da7$exports = {};

var $jKHUh = parcelRequire("jKHUh");
/** Used to detect overreaching core-js shims. */ var $bd99189286766da7$var$coreJsData = $jKHUh["__core-js_shared__"];
$bd99189286766da7$exports = $bd99189286766da7$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $7fa3b7e36387e851$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($bd99189286766da7$exports && $bd99189286766da7$exports.keys && $bd99189286766da7$exports.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $7fa3b7e36387e851$var$isMasked(func) {
    return !!$7fa3b7e36387e851$var$maskSrcKey && $7fa3b7e36387e851$var$maskSrcKey in func;
}
$7fa3b7e36387e851$exports = $7fa3b7e36387e851$var$isMasked;



var $abb953636807dadf$exports = {};
/** Used for built-in method references. */ var $abb953636807dadf$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $abb953636807dadf$var$funcToString = $abb953636807dadf$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $abb953636807dadf$var$toSource(func) {
    if (func != null) {
        try {
            return $abb953636807dadf$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
$abb953636807dadf$exports = $abb953636807dadf$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $c7c467af66221c54$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $c7c467af66221c54$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $c7c467af66221c54$var$funcProto = Function.prototype, $c7c467af66221c54$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $c7c467af66221c54$var$funcToString = $c7c467af66221c54$var$funcProto.toString;
/** Used to check objects for own properties. */ var $c7c467af66221c54$var$hasOwnProperty = $c7c467af66221c54$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $c7c467af66221c54$var$reIsNative = RegExp("^" + $c7c467af66221c54$var$funcToString.call($c7c467af66221c54$var$hasOwnProperty).replace($c7c467af66221c54$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $c7c467af66221c54$var$baseIsNative(value) {
    if (!$cdeebba9a3c50f33$exports(value) || $7fa3b7e36387e851$exports(value)) return false;
    var pattern = $88ef20dc5b761d7c$exports(value) ? $c7c467af66221c54$var$reIsNative : $c7c467af66221c54$var$reIsHostCtor;
    return pattern.test($abb953636807dadf$exports(value));
}
$c7c467af66221c54$exports = $c7c467af66221c54$var$baseIsNative;


var $949f3761ea3bcc83$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $949f3761ea3bcc83$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$949f3761ea3bcc83$exports = $949f3761ea3bcc83$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $d9506f24890283ad$var$getNative(object, key) {
    var value = $949f3761ea3bcc83$exports(object, key);
    return $c7c467af66221c54$exports(value) ? value : undefined;
}
$d9506f24890283ad$exports = $d9506f24890283ad$var$getNative;



var $jKHUh = parcelRequire("jKHUh");
/* Built-in method references that are verified to be native. */ var $1a3dc13f1ac8078e$var$Map = $d9506f24890283ad$exports($jKHUh, "Map");
$1a3dc13f1ac8078e$exports = $1a3dc13f1ac8078e$var$Map;


var $2a4976f96881a074$exports = {};
var $057b9fde23a619c3$exports = {};
var $cfaf711c9d079a0a$exports = {};
var $83593186e1b5b498$exports = {};
var $80b4e941360cde01$exports = {};

/* Built-in method references that are verified to be native. */ var $80b4e941360cde01$var$nativeCreate = $d9506f24890283ad$exports(Object, "create");
$80b4e941360cde01$exports = $80b4e941360cde01$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $83593186e1b5b498$var$hashClear() {
    this.__data__ = $80b4e941360cde01$exports ? $80b4e941360cde01$exports(null) : {};
    this.size = 0;
}
$83593186e1b5b498$exports = $83593186e1b5b498$var$hashClear;


var $e1db068752ec4fa6$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e1db068752ec4fa6$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$e1db068752ec4fa6$exports = $e1db068752ec4fa6$var$hashDelete;


var $ba8bae43f521e9ee$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $ba8bae43f521e9ee$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $ba8bae43f521e9ee$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ba8bae43f521e9ee$var$hasOwnProperty = $ba8bae43f521e9ee$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ba8bae43f521e9ee$var$hashGet(key) {
    var data = this.__data__;
    if ($80b4e941360cde01$exports) {
        var result = data[key];
        return result === $ba8bae43f521e9ee$var$HASH_UNDEFINED ? undefined : result;
    }
    return $ba8bae43f521e9ee$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$ba8bae43f521e9ee$exports = $ba8bae43f521e9ee$var$hashGet;


var $cee8d6da0ca9bb76$exports = {};

/** Used for built-in method references. */ var $cee8d6da0ca9bb76$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cee8d6da0ca9bb76$var$hasOwnProperty = $cee8d6da0ca9bb76$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $cee8d6da0ca9bb76$var$hashHas(key) {
    var data = this.__data__;
    return $80b4e941360cde01$exports ? data[key] !== undefined : $cee8d6da0ca9bb76$var$hasOwnProperty.call(data, key);
}
$cee8d6da0ca9bb76$exports = $cee8d6da0ca9bb76$var$hashHas;


var $4b39d70fb222e4a6$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $4b39d70fb222e4a6$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $4b39d70fb222e4a6$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $80b4e941360cde01$exports && value === undefined ? $4b39d70fb222e4a6$var$HASH_UNDEFINED : value;
    return this;
}
$4b39d70fb222e4a6$exports = $4b39d70fb222e4a6$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $cfaf711c9d079a0a$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$cfaf711c9d079a0a$var$Hash.prototype.clear = $83593186e1b5b498$exports;
$cfaf711c9d079a0a$var$Hash.prototype["delete"] = $e1db068752ec4fa6$exports;
$cfaf711c9d079a0a$var$Hash.prototype.get = $ba8bae43f521e9ee$exports;
$cfaf711c9d079a0a$var$Hash.prototype.has = $cee8d6da0ca9bb76$exports;
$cfaf711c9d079a0a$var$Hash.prototype.set = $4b39d70fb222e4a6$exports;
$cfaf711c9d079a0a$exports = $cfaf711c9d079a0a$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $057b9fde23a619c3$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $cfaf711c9d079a0a$exports,
        "map": new ($1a3dc13f1ac8078e$exports || $37e4435101686cab$exports),
        "string": new $cfaf711c9d079a0a$exports
    };
}
$057b9fde23a619c3$exports = $057b9fde23a619c3$var$mapCacheClear;


var $f69d454cfd124a11$exports = {};
var $0de23841b05a7510$exports = {};
var $847908a7c4ebb50b$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $847908a7c4ebb50b$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
$847908a7c4ebb50b$exports = $847908a7c4ebb50b$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $0de23841b05a7510$var$getMapData(map, key) {
    var data = map.__data__;
    return $847908a7c4ebb50b$exports(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
$0de23841b05a7510$exports = $0de23841b05a7510$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $f69d454cfd124a11$var$mapCacheDelete(key) {
    var result = $0de23841b05a7510$exports(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
$f69d454cfd124a11$exports = $f69d454cfd124a11$var$mapCacheDelete;


var $5c1df64030407267$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $5c1df64030407267$var$mapCacheGet(key) {
    return $0de23841b05a7510$exports(this, key).get(key);
}
$5c1df64030407267$exports = $5c1df64030407267$var$mapCacheGet;


var $451434ef5dc14939$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $451434ef5dc14939$var$mapCacheHas(key) {
    return $0de23841b05a7510$exports(this, key).has(key);
}
$451434ef5dc14939$exports = $451434ef5dc14939$var$mapCacheHas;


var $5e7acb021451bd05$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $5e7acb021451bd05$var$mapCacheSet(key, value) {
    var data = $0de23841b05a7510$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$5e7acb021451bd05$exports = $5e7acb021451bd05$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $2a4976f96881a074$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$2a4976f96881a074$var$MapCache.prototype.clear = $057b9fde23a619c3$exports;
$2a4976f96881a074$var$MapCache.prototype["delete"] = $f69d454cfd124a11$exports;
$2a4976f96881a074$var$MapCache.prototype.get = $5c1df64030407267$exports;
$2a4976f96881a074$var$MapCache.prototype.has = $451434ef5dc14939$exports;
$2a4976f96881a074$var$MapCache.prototype.set = $5e7acb021451bd05$exports;
$2a4976f96881a074$exports = $2a4976f96881a074$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $c8948e6479d3e5c3$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $c8948e6479d3e5c3$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $37e4435101686cab$exports) {
        var pairs = data.__data__;
        if (!$1a3dc13f1ac8078e$exports || pairs.length < $c8948e6479d3e5c3$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $2a4976f96881a074$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$c8948e6479d3e5c3$exports = $c8948e6479d3e5c3$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $cd6a7fdc60b1cb13$var$Stack(entries) {
    var data = this.__data__ = new $37e4435101686cab$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$cd6a7fdc60b1cb13$var$Stack.prototype.clear = $798249f626785361$exports;
$cd6a7fdc60b1cb13$var$Stack.prototype["delete"] = $ae1281894b16009f$exports;
$cd6a7fdc60b1cb13$var$Stack.prototype.get = $fcdca539f1c7516e$exports;
$cd6a7fdc60b1cb13$var$Stack.prototype.has = $ce63dea90a105fe6$exports;
$cd6a7fdc60b1cb13$var$Stack.prototype.set = $c8948e6479d3e5c3$exports;
$cd6a7fdc60b1cb13$exports = $cd6a7fdc60b1cb13$var$Stack;


var $1c23a95357bef7bf$exports = {};
var $5b55498dfa4625cc$exports = {};

var $e38f100a3ec40a0c$exports = {};
var $8eed56c9d2454110$exports = {};

var $b5a0bf71793b020d$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $b5a0bf71793b020d$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $b5a0bf71793b020d$var$setCacheAdd(value) {
    this.__data__.set(value, $b5a0bf71793b020d$var$HASH_UNDEFINED);
    return this;
}
$b5a0bf71793b020d$exports = $b5a0bf71793b020d$var$setCacheAdd;


var $f283cece682b6f45$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $f283cece682b6f45$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$f283cece682b6f45$exports = $f283cece682b6f45$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $8eed56c9d2454110$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $2a4976f96881a074$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$8eed56c9d2454110$var$SetCache.prototype.add = $8eed56c9d2454110$var$SetCache.prototype.push = $b5a0bf71793b020d$exports;
$8eed56c9d2454110$var$SetCache.prototype.has = $f283cece682b6f45$exports;
$8eed56c9d2454110$exports = $8eed56c9d2454110$var$SetCache;


var $5d099b7c8da75d83$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $5d099b7c8da75d83$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$5d099b7c8da75d83$exports = $5d099b7c8da75d83$var$arraySome;


var $a1dfcc27fe23b4c8$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $a1dfcc27fe23b4c8$var$cacheHas(cache, key) {
    return cache.has(key);
}
$a1dfcc27fe23b4c8$exports = $a1dfcc27fe23b4c8$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $e38f100a3ec40a0c$var$COMPARE_PARTIAL_FLAG = 1, $e38f100a3ec40a0c$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $e38f100a3ec40a0c$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $e38f100a3ec40a0c$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $e38f100a3ec40a0c$var$COMPARE_UNORDERED_FLAG ? new $8eed56c9d2454110$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$5d099b7c8da75d83$exports(other, function(othValue, othIndex) {
                if (!$a1dfcc27fe23b4c8$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
$e38f100a3ec40a0c$exports = $e38f100a3ec40a0c$var$equalArrays;


var $6b28e2d7769337e3$exports = {};

var $de729f53a969f0c1$exports = {};

var $jKHUh = parcelRequire("jKHUh");
/** Built-in value references. */ var $de729f53a969f0c1$var$Uint8Array = $jKHUh.Uint8Array;
$de729f53a969f0c1$exports = $de729f53a969f0c1$var$Uint8Array;




var $3228c3117ffc2186$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $3228c3117ffc2186$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$3228c3117ffc2186$exports = $3228c3117ffc2186$var$mapToArray;


var $c5e3ee766fd09634$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $c5e3ee766fd09634$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$c5e3ee766fd09634$exports = $c5e3ee766fd09634$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $6b28e2d7769337e3$var$COMPARE_PARTIAL_FLAG = 1, $6b28e2d7769337e3$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $6b28e2d7769337e3$var$boolTag = "[object Boolean]", $6b28e2d7769337e3$var$dateTag = "[object Date]", $6b28e2d7769337e3$var$errorTag = "[object Error]", $6b28e2d7769337e3$var$mapTag = "[object Map]", $6b28e2d7769337e3$var$numberTag = "[object Number]", $6b28e2d7769337e3$var$regexpTag = "[object RegExp]", $6b28e2d7769337e3$var$setTag = "[object Set]", $6b28e2d7769337e3$var$stringTag = "[object String]", $6b28e2d7769337e3$var$symbolTag = "[object Symbol]";
var $6b28e2d7769337e3$var$arrayBufferTag = "[object ArrayBuffer]", $6b28e2d7769337e3$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $6b28e2d7769337e3$var$symbolProto = $a0e007488b23f5fe$exports ? $a0e007488b23f5fe$exports.prototype : undefined, $6b28e2d7769337e3$var$symbolValueOf = $6b28e2d7769337e3$var$symbolProto ? $6b28e2d7769337e3$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $6b28e2d7769337e3$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $6b28e2d7769337e3$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $6b28e2d7769337e3$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $de729f53a969f0c1$exports(object), new $de729f53a969f0c1$exports(other))) return false;
            return true;
        case $6b28e2d7769337e3$var$boolTag:
        case $6b28e2d7769337e3$var$dateTag:
        case $6b28e2d7769337e3$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $2d67364ed6c1926e$exports(+object, +other);
        case $6b28e2d7769337e3$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $6b28e2d7769337e3$var$regexpTag:
        case $6b28e2d7769337e3$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $6b28e2d7769337e3$var$mapTag:
            var convert = $3228c3117ffc2186$exports;
        case $6b28e2d7769337e3$var$setTag:
            var isPartial = bitmask & $6b28e2d7769337e3$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $c5e3ee766fd09634$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $6b28e2d7769337e3$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $e38f100a3ec40a0c$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $6b28e2d7769337e3$var$symbolTag:
            if ($6b28e2d7769337e3$var$symbolValueOf) return $6b28e2d7769337e3$var$symbolValueOf.call(object) == $6b28e2d7769337e3$var$symbolValueOf.call(other);
    }
    return false;
}
$6b28e2d7769337e3$exports = $6b28e2d7769337e3$var$equalByTag;


var $b0382f5f371a3878$exports = {};
var $80d0f1bf29a411be$exports = {};
var $4cdfe017bbdcf0e3$exports = {};
var $5ca68c0f8b43df56$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $5ca68c0f8b43df56$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$5ca68c0f8b43df56$exports = $5ca68c0f8b43df56$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $4cdfe017bbdcf0e3$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $0fe4a5546443a34c$exports(object) ? result : $5ca68c0f8b43df56$exports(result, symbolsFunc(object));
}
$4cdfe017bbdcf0e3$exports = $4cdfe017bbdcf0e3$var$baseGetAllKeys;


var $74a2b658310a8f7a$exports = {};
var $a139b50d5fb2d608$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $a139b50d5fb2d608$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$a139b50d5fb2d608$exports = $a139b50d5fb2d608$var$arrayFilter;


var $155cc9e3123196a8$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $155cc9e3123196a8$var$stubArray() {
    return [];
}
$155cc9e3123196a8$exports = $155cc9e3123196a8$var$stubArray;


/** Used for built-in method references. */ var $74a2b658310a8f7a$var$objectProto = Object.prototype;
/** Built-in value references. */ var $74a2b658310a8f7a$var$propertyIsEnumerable = $74a2b658310a8f7a$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $74a2b658310a8f7a$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $74a2b658310a8f7a$var$getSymbols = !$74a2b658310a8f7a$var$nativeGetSymbols ? $155cc9e3123196a8$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $a139b50d5fb2d608$exports($74a2b658310a8f7a$var$nativeGetSymbols(object), function(symbol) {
        return $74a2b658310a8f7a$var$propertyIsEnumerable.call(object, symbol);
    });
};
$74a2b658310a8f7a$exports = $74a2b658310a8f7a$var$getSymbols;



/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $80d0f1bf29a411be$var$getAllKeys(object) {
    return $4cdfe017bbdcf0e3$exports(object, $322e4354daac4308$exports, $74a2b658310a8f7a$exports);
}
$80d0f1bf29a411be$exports = $80d0f1bf29a411be$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $b0382f5f371a3878$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $b0382f5f371a3878$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b0382f5f371a3878$var$hasOwnProperty = $b0382f5f371a3878$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $b0382f5f371a3878$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $b0382f5f371a3878$var$COMPARE_PARTIAL_FLAG, objProps = $80d0f1bf29a411be$exports(object), objLength = objProps.length, othProps = $80d0f1bf29a411be$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $b0382f5f371a3878$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
$b0382f5f371a3878$exports = $b0382f5f371a3878$var$equalObjects;


var $609d8c339d16de4d$exports = {};
var $6adbcccec7f99f85$exports = {};


var $jKHUh = parcelRequire("jKHUh");
/* Built-in method references that are verified to be native. */ var $6adbcccec7f99f85$var$DataView = $d9506f24890283ad$exports($jKHUh, "DataView");
$6adbcccec7f99f85$exports = $6adbcccec7f99f85$var$DataView;



var $e5723f7d8c792393$exports = {};


var $jKHUh = parcelRequire("jKHUh");
/* Built-in method references that are verified to be native. */ var $e5723f7d8c792393$var$Promise = $d9506f24890283ad$exports($jKHUh, "Promise");
$e5723f7d8c792393$exports = $e5723f7d8c792393$var$Promise;


var $f1e5d3aa10f9181f$exports = {};


var $jKHUh = parcelRequire("jKHUh");
/* Built-in method references that are verified to be native. */ var $f1e5d3aa10f9181f$var$Set = $d9506f24890283ad$exports($jKHUh, "Set");
$f1e5d3aa10f9181f$exports = $f1e5d3aa10f9181f$var$Set;


var $4b1fabf6d72d138a$exports = {};


var $jKHUh = parcelRequire("jKHUh");
/* Built-in method references that are verified to be native. */ var $4b1fabf6d72d138a$var$WeakMap = $d9506f24890283ad$exports($jKHUh, "WeakMap");
$4b1fabf6d72d138a$exports = $4b1fabf6d72d138a$var$WeakMap;




/** `Object#toString` result references. */ var $609d8c339d16de4d$var$mapTag = "[object Map]", $609d8c339d16de4d$var$objectTag = "[object Object]", $609d8c339d16de4d$var$promiseTag = "[object Promise]", $609d8c339d16de4d$var$setTag = "[object Set]", $609d8c339d16de4d$var$weakMapTag = "[object WeakMap]";
var $609d8c339d16de4d$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $609d8c339d16de4d$var$dataViewCtorString = $abb953636807dadf$exports($6adbcccec7f99f85$exports), $609d8c339d16de4d$var$mapCtorString = $abb953636807dadf$exports($1a3dc13f1ac8078e$exports), $609d8c339d16de4d$var$promiseCtorString = $abb953636807dadf$exports($e5723f7d8c792393$exports), $609d8c339d16de4d$var$setCtorString = $abb953636807dadf$exports($f1e5d3aa10f9181f$exports), $609d8c339d16de4d$var$weakMapCtorString = $abb953636807dadf$exports($4b1fabf6d72d138a$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $609d8c339d16de4d$var$getTag = $d607e1880b829c8a$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($6adbcccec7f99f85$exports && $609d8c339d16de4d$var$getTag(new $6adbcccec7f99f85$exports(new ArrayBuffer(1))) != $609d8c339d16de4d$var$dataViewTag || $1a3dc13f1ac8078e$exports && $609d8c339d16de4d$var$getTag(new $1a3dc13f1ac8078e$exports) != $609d8c339d16de4d$var$mapTag || $e5723f7d8c792393$exports && $609d8c339d16de4d$var$getTag($e5723f7d8c792393$exports.resolve()) != $609d8c339d16de4d$var$promiseTag || $f1e5d3aa10f9181f$exports && $609d8c339d16de4d$var$getTag(new $f1e5d3aa10f9181f$exports) != $609d8c339d16de4d$var$setTag || $4b1fabf6d72d138a$exports && $609d8c339d16de4d$var$getTag(new $4b1fabf6d72d138a$exports) != $609d8c339d16de4d$var$weakMapTag) $609d8c339d16de4d$var$getTag = function(value) {
    var result = $d607e1880b829c8a$exports(value), Ctor = result == $609d8c339d16de4d$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $abb953636807dadf$exports(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $609d8c339d16de4d$var$dataViewCtorString:
            return $609d8c339d16de4d$var$dataViewTag;
        case $609d8c339d16de4d$var$mapCtorString:
            return $609d8c339d16de4d$var$mapTag;
        case $609d8c339d16de4d$var$promiseCtorString:
            return $609d8c339d16de4d$var$promiseTag;
        case $609d8c339d16de4d$var$setCtorString:
            return $609d8c339d16de4d$var$setTag;
        case $609d8c339d16de4d$var$weakMapCtorString:
            return $609d8c339d16de4d$var$weakMapTag;
    }
    return result;
};
$609d8c339d16de4d$exports = $609d8c339d16de4d$var$getTag;




var $ca1Sy = parcelRequire("ca1Sy");

/** Used to compose bitmasks for value comparisons. */ var $5b55498dfa4625cc$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $5b55498dfa4625cc$var$argsTag = "[object Arguments]", $5b55498dfa4625cc$var$arrayTag = "[object Array]", $5b55498dfa4625cc$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $5b55498dfa4625cc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5b55498dfa4625cc$var$hasOwnProperty = $5b55498dfa4625cc$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $5b55498dfa4625cc$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $0fe4a5546443a34c$exports(object), othIsArr = $0fe4a5546443a34c$exports(other), objTag = objIsArr ? $5b55498dfa4625cc$var$arrayTag : $609d8c339d16de4d$exports(object), othTag = othIsArr ? $5b55498dfa4625cc$var$arrayTag : $609d8c339d16de4d$exports(other);
    objTag = objTag == $5b55498dfa4625cc$var$argsTag ? $5b55498dfa4625cc$var$objectTag : objTag;
    othTag = othTag == $5b55498dfa4625cc$var$argsTag ? $5b55498dfa4625cc$var$objectTag : othTag;
    var objIsObj = objTag == $5b55498dfa4625cc$var$objectTag, othIsObj = othTag == $5b55498dfa4625cc$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $ca1Sy(object)) {
        if (!$ca1Sy(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $cd6a7fdc60b1cb13$exports);
        return objIsArr || $4bc71926a418ef11$exports(object) ? $e38f100a3ec40a0c$exports(object, other, bitmask, customizer, equalFunc, stack) : $6b28e2d7769337e3$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $5b55498dfa4625cc$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $5b55498dfa4625cc$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $5b55498dfa4625cc$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $cd6a7fdc60b1cb13$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $cd6a7fdc60b1cb13$exports);
    return $b0382f5f371a3878$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$5b55498dfa4625cc$exports = $5b55498dfa4625cc$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $1c23a95357bef7bf$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$a35b73cb295f324c$exports(value) && !$a35b73cb295f324c$exports(other)) return value !== value && other !== other;
    return $5b55498dfa4625cc$exports(value, other, bitmask, customizer, $1c23a95357bef7bf$var$baseIsEqual, stack);
}
$1c23a95357bef7bf$exports = $1c23a95357bef7bf$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $a085d11994ce7307$var$COMPARE_PARTIAL_FLAG = 1, $a085d11994ce7307$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $a085d11994ce7307$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $cd6a7fdc60b1cb13$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $1c23a95357bef7bf$exports(srcValue, objValue, $a085d11994ce7307$var$COMPARE_PARTIAL_FLAG | $a085d11994ce7307$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$a085d11994ce7307$exports = $a085d11994ce7307$var$baseIsMatch;


var $3387dca1c12fc64f$exports = {};
var $ef922c63960fc4ce$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $ef922c63960fc4ce$var$isStrictComparable(value) {
    return value === value && !$cdeebba9a3c50f33$exports(value);
}
$ef922c63960fc4ce$exports = $ef922c63960fc4ce$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $3387dca1c12fc64f$var$getMatchData(object) {
    var result = $322e4354daac4308$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $ef922c63960fc4ce$exports(value)
        ];
    }
    return result;
}
$3387dca1c12fc64f$exports = $3387dca1c12fc64f$var$getMatchData;


var $b836451eb10b2ac9$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $b836451eb10b2ac9$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$b836451eb10b2ac9$exports = $b836451eb10b2ac9$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $faaabf04dab5825c$var$baseMatches(source) {
    var matchData = $3387dca1c12fc64f$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $b836451eb10b2ac9$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $a085d11994ce7307$exports(object, source, matchData);
    };
}
$faaabf04dab5825c$exports = $faaabf04dab5825c$var$baseMatches;


var $3e87036bee038196$exports = {};

var $2cd7f9f9c3b27772$exports = {};
var $c57b97e716b5dbef$exports = {};
var $a82f7e98205168be$exports = {};

var $a50379d0bea6f57a$exports = {};

var $bd288f840efc8d52$exports = {};


/** `Object#toString` result references. */ var $bd288f840efc8d52$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $bd288f840efc8d52$var$isSymbol(value) {
    return typeof value == "symbol" || $a35b73cb295f324c$exports(value) && $d607e1880b829c8a$exports(value) == $bd288f840efc8d52$var$symbolTag;
}
$bd288f840efc8d52$exports = $bd288f840efc8d52$var$isSymbol;


/** Used to match property names within property paths. */ var $a50379d0bea6f57a$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $a50379d0bea6f57a$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $a50379d0bea6f57a$var$isKey(value, object) {
    if ($0fe4a5546443a34c$exports(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $bd288f840efc8d52$exports(value)) return true;
    return $a50379d0bea6f57a$var$reIsPlainProp.test(value) || !$a50379d0bea6f57a$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$a50379d0bea6f57a$exports = $a50379d0bea6f57a$var$isKey;


var $dda1857d97a5de1e$exports = {};
var $d260dfa98be05bcc$exports = {};
var $4e7d0668fc0bed92$exports = {};

/** Error message constants. */ var $4e7d0668fc0bed92$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $4e7d0668fc0bed92$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($4e7d0668fc0bed92$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($4e7d0668fc0bed92$var$memoize.Cache || $2a4976f96881a074$exports);
    return memoized;
}
// Expose `MapCache`.
$4e7d0668fc0bed92$var$memoize.Cache = $2a4976f96881a074$exports;
$4e7d0668fc0bed92$exports = $4e7d0668fc0bed92$var$memoize;


/** Used as the maximum memoize cache size. */ var $d260dfa98be05bcc$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $d260dfa98be05bcc$var$memoizeCapped(func) {
    var result = $4e7d0668fc0bed92$exports(func, function(key) {
        if (cache.size === $d260dfa98be05bcc$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$d260dfa98be05bcc$exports = $d260dfa98be05bcc$var$memoizeCapped;


/** Used to match property names within property paths. */ var $dda1857d97a5de1e$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $dda1857d97a5de1e$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $dda1857d97a5de1e$var$stringToPath = $d260dfa98be05bcc$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($dda1857d97a5de1e$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($dda1857d97a5de1e$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
$dda1857d97a5de1e$exports = $dda1857d97a5de1e$var$stringToPath;


var $72438828c89ad894$exports = {};
var $2313b2097425cbfc$exports = {};




/** Used as references for various `Number` constants. */ var $2313b2097425cbfc$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $2313b2097425cbfc$var$symbolProto = $a0e007488b23f5fe$exports ? $a0e007488b23f5fe$exports.prototype : undefined, $2313b2097425cbfc$var$symbolToString = $2313b2097425cbfc$var$symbolProto ? $2313b2097425cbfc$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $2313b2097425cbfc$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($0fe4a5546443a34c$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $fdb8f9af1091eb2c$exports(value, $2313b2097425cbfc$var$baseToString) + "";
    if ($bd288f840efc8d52$exports(value)) return $2313b2097425cbfc$var$symbolToString ? $2313b2097425cbfc$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$2313b2097425cbfc$var$INFINITY ? "-0" : result;
}
$2313b2097425cbfc$exports = $2313b2097425cbfc$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $72438828c89ad894$var$toString(value) {
    return value == null ? "" : $2313b2097425cbfc$exports(value);
}
$72438828c89ad894$exports = $72438828c89ad894$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $a82f7e98205168be$var$castPath(value, object) {
    if ($0fe4a5546443a34c$exports(value)) return value;
    return $a50379d0bea6f57a$exports(value, object) ? [
        value
    ] : $dda1857d97a5de1e$exports($72438828c89ad894$exports(value));
}
$a82f7e98205168be$exports = $a82f7e98205168be$var$castPath;


var $aa726c11dcda9fc7$exports = {};

/** Used as references for various `Number` constants. */ var $aa726c11dcda9fc7$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $aa726c11dcda9fc7$var$toKey(value) {
    if (typeof value == "string" || $bd288f840efc8d52$exports(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$aa726c11dcda9fc7$var$INFINITY ? "-0" : result;
}
$aa726c11dcda9fc7$exports = $aa726c11dcda9fc7$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $c57b97e716b5dbef$var$baseGet(object, path) {
    path = $a82f7e98205168be$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$aa726c11dcda9fc7$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$c57b97e716b5dbef$exports = $c57b97e716b5dbef$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $2cd7f9f9c3b27772$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $c57b97e716b5dbef$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$2cd7f9f9c3b27772$exports = $2cd7f9f9c3b27772$var$get;


var $ada71fe4639b8e2c$exports = {};
var $29a05972da204ba6$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $29a05972da204ba6$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$29a05972da204ba6$exports = $29a05972da204ba6$var$baseHasIn;


var $eae9a59aa8162be7$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $eae9a59aa8162be7$var$hasPath(object, path, hasFunc) {
    path = $a82f7e98205168be$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $aa726c11dcda9fc7$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $1db3e574198d6e84$exports(length) && $8fea83d6de918b08$exports(key, length) && ($0fe4a5546443a34c$exports(object) || $740020e1b6465003$exports(object));
}
$eae9a59aa8162be7$exports = $eae9a59aa8162be7$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $ada71fe4639b8e2c$var$hasIn(object, path) {
    return object != null && $eae9a59aa8162be7$exports(object, path, $29a05972da204ba6$exports);
}
$ada71fe4639b8e2c$exports = $ada71fe4639b8e2c$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $3e87036bee038196$var$COMPARE_PARTIAL_FLAG = 1, $3e87036bee038196$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $3e87036bee038196$var$baseMatchesProperty(path, srcValue) {
    if ($a50379d0bea6f57a$exports(path) && $ef922c63960fc4ce$exports(srcValue)) return $b836451eb10b2ac9$exports($aa726c11dcda9fc7$exports(path), srcValue);
    return function(object) {
        var objValue = $2cd7f9f9c3b27772$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $ada71fe4639b8e2c$exports(object, path) : $1c23a95357bef7bf$exports(srcValue, objValue, $3e87036bee038196$var$COMPARE_PARTIAL_FLAG | $3e87036bee038196$var$COMPARE_UNORDERED_FLAG);
    };
}
$3e87036bee038196$exports = $3e87036bee038196$var$baseMatchesProperty;




var $918885cc7d1f0765$exports = {};
var $89bbfe81cb79a979$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $89bbfe81cb79a979$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$89bbfe81cb79a979$exports = $89bbfe81cb79a979$var$baseProperty;


var $a7959fe3fd827260$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $a7959fe3fd827260$var$basePropertyDeep(path) {
    return function(object) {
        return $c57b97e716b5dbef$exports(object, path);
    };
}
$a7959fe3fd827260$exports = $a7959fe3fd827260$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $918885cc7d1f0765$var$property(path) {
    return $a50379d0bea6f57a$exports(path) ? $89bbfe81cb79a979$exports($aa726c11dcda9fc7$exports(path)) : $a7959fe3fd827260$exports(path);
}
$918885cc7d1f0765$exports = $918885cc7d1f0765$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $958e35cadb69881a$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $57b7bffe2f9def0f$exports;
    if (typeof value == "object") return $0fe4a5546443a34c$exports(value) ? $3e87036bee038196$exports(value[0], value[1]) : $faaabf04dab5825c$exports(value);
    return $918885cc7d1f0765$exports(value);
}
$958e35cadb69881a$exports = $958e35cadb69881a$var$baseIteratee;


var $e4efdf6d5bdd69dc$exports = {};
var $f08c47d4f9033453$exports = {};

var $3a0db783383863a7$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $3a0db783383863a7$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$263ae7db1776a88c$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$3a0db783383863a7$exports = $3a0db783383863a7$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $f08c47d4f9033453$var$baseEach = $3a0db783383863a7$exports($48b10c759085c7c7$exports);
$f08c47d4f9033453$exports = $f08c47d4f9033453$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $e4efdf6d5bdd69dc$var$baseMap(collection, iteratee) {
    var index = -1, result = $263ae7db1776a88c$exports(collection) ? Array(collection.length) : [];
    $f08c47d4f9033453$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$e4efdf6d5bdd69dc$exports = $e4efdf6d5bdd69dc$var$baseMap;



/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $8c69ba69485f4ea5$var$map(collection, iteratee) {
    var func = $0fe4a5546443a34c$exports(collection) ? $fdb8f9af1091eb2c$exports : $e4efdf6d5bdd69dc$exports;
    return func(collection, $958e35cadb69881a$exports(iteratee, 3));
}
$8c69ba69485f4ea5$exports = $8c69ba69485f4ea5$var$map;


var $1e68a7299fc478d6$var$_map3 = $1e68a7299fc478d6$var$_interopRequireDefault($8c69ba69485f4ea5$exports);
function $1e68a7299fc478d6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1e68a7299fc478d6$var$flattenNames = $1e68a7299fc478d6$exports.flattenNames = function flattenNames() {
    var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var names = [];
    (0, $1e68a7299fc478d6$var$_map3.default)(things, function(thing) {
        if (Array.isArray(thing)) flattenNames(thing).map(function(name) {
            return names.push(name);
        });
        else if ((0, $1e68a7299fc478d6$var$_isPlainObject3.default)(thing)) (0, $1e68a7299fc478d6$var$_forOwn3.default)(thing, function(value, key) {
            value === true && names.push(key);
            names.push(key + "-" + value);
        });
        else if ((0, $1e68a7299fc478d6$var$_isString3.default)(thing)) names.push(thing);
    });
    return names;
};
$1e68a7299fc478d6$exports.default = $1e68a7299fc478d6$var$flattenNames;


var $081a95961b0cb73f$var$_flattenNames2 = $081a95961b0cb73f$var$_interopRequireDefault($1e68a7299fc478d6$exports);
var $8ee5599c7a3f144c$exports = {};
"use strict";
Object.defineProperty($8ee5599c7a3f144c$exports, "__esModule", {
    value: true
});
$8ee5599c7a3f144c$exports.mergeClasses = undefined;

var $8ee5599c7a3f144c$var$_forOwn3 = $8ee5599c7a3f144c$var$_interopRequireDefault($a545443a7331cfb0$exports);
var $7515c800aeb45689$exports = {};
var $dedf4319d925ab72$exports = {};

var $2f65dd5e37e6162b$exports = {};
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $2f65dd5e37e6162b$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
$2f65dd5e37e6162b$exports = $2f65dd5e37e6162b$var$arrayEach;


var $23d01ff6833d6944$exports = {};
var $03aeaa7f27e7b78e$exports = {};
var $5984e4c2489c8c28$exports = {};

var $5984e4c2489c8c28$var$defineProperty = function() {
    try {
        var func = $d9506f24890283ad$exports(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
$5984e4c2489c8c28$exports = $5984e4c2489c8c28$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $03aeaa7f27e7b78e$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $5984e4c2489c8c28$exports) $5984e4c2489c8c28$exports(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
$03aeaa7f27e7b78e$exports = $03aeaa7f27e7b78e$var$baseAssignValue;



/** Used for built-in method references. */ var $23d01ff6833d6944$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $23d01ff6833d6944$var$hasOwnProperty = $23d01ff6833d6944$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $23d01ff6833d6944$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($23d01ff6833d6944$var$hasOwnProperty.call(object, key) && $2d67364ed6c1926e$exports(objValue, value)) || value === undefined && !(key in object)) $03aeaa7f27e7b78e$exports(object, key, value);
}
$23d01ff6833d6944$exports = $23d01ff6833d6944$var$assignValue;


var $3f4adc36bb205d1c$exports = {};
var $c213f42dd90eb0b6$exports = {};


/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $c213f42dd90eb0b6$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $03aeaa7f27e7b78e$exports(object, key, newValue);
        else $23d01ff6833d6944$exports(object, key, newValue);
    }
    return object;
}
$c213f42dd90eb0b6$exports = $c213f42dd90eb0b6$var$copyObject;



/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $3f4adc36bb205d1c$var$baseAssign(object, source) {
    return object && $c213f42dd90eb0b6$exports(source, $322e4354daac4308$exports(source), object);
}
$3f4adc36bb205d1c$exports = $3f4adc36bb205d1c$var$baseAssign;


var $c8027e6828bbc076$exports = {};

var $5589b8f6a83de59f$exports = {};

var $dc9bf7d777379145$exports = {};


var $c70896baefc24fa2$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $c70896baefc24fa2$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$c70896baefc24fa2$exports = $c70896baefc24fa2$var$nativeKeysIn;


/** Used for built-in method references. */ var $dc9bf7d777379145$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dc9bf7d777379145$var$hasOwnProperty = $dc9bf7d777379145$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $dc9bf7d777379145$var$baseKeysIn(object) {
    if (!$cdeebba9a3c50f33$exports(object)) return $c70896baefc24fa2$exports(object);
    var isProto = $d8bce8a27fc077c6$exports(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$dc9bf7d777379145$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$dc9bf7d777379145$exports = $dc9bf7d777379145$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $5589b8f6a83de59f$var$keysIn(object) {
    return $263ae7db1776a88c$exports(object) ? $7ef7f908fe37cd53$exports(object, true) : $dc9bf7d777379145$exports(object);
}
$5589b8f6a83de59f$exports = $5589b8f6a83de59f$var$keysIn;


/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $c8027e6828bbc076$var$baseAssignIn(object, source) {
    return object && $c213f42dd90eb0b6$exports(source, $5589b8f6a83de59f$exports(source), object);
}
$c8027e6828bbc076$exports = $c8027e6828bbc076$var$baseAssignIn;



var $83wuy = parcelRequire("83wuy");
var $7bfe08991d8e8165$exports = {};
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $7bfe08991d8e8165$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$7bfe08991d8e8165$exports = $7bfe08991d8e8165$var$copyArray;


var $655b3585dee1c9e2$exports = {};


/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $655b3585dee1c9e2$var$copySymbols(source, object) {
    return $c213f42dd90eb0b6$exports(source, $74a2b658310a8f7a$exports(source), object);
}
$655b3585dee1c9e2$exports = $655b3585dee1c9e2$var$copySymbols;


var $4b3e4d33f0bd5f0e$exports = {};

var $eec5f945e617654d$exports = {};




/* Built-in method references for those with the same name as other `lodash` methods. */ var $eec5f945e617654d$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $eec5f945e617654d$var$getSymbolsIn = !$eec5f945e617654d$var$nativeGetSymbols ? $155cc9e3123196a8$exports : function(object) {
    var result = [];
    while(object){
        $5ca68c0f8b43df56$exports(result, $74a2b658310a8f7a$exports(object));
        object = $6869910f8d4be8cc$exports(object);
    }
    return result;
};
$eec5f945e617654d$exports = $eec5f945e617654d$var$getSymbolsIn;


/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $4b3e4d33f0bd5f0e$var$copySymbolsIn(source, object) {
    return $c213f42dd90eb0b6$exports(source, $eec5f945e617654d$exports(source), object);
}
$4b3e4d33f0bd5f0e$exports = $4b3e4d33f0bd5f0e$var$copySymbolsIn;



var $2e0a842597f3e494$exports = {};



/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $2e0a842597f3e494$var$getAllKeysIn(object) {
    return $4cdfe017bbdcf0e3$exports(object, $5589b8f6a83de59f$exports, $eec5f945e617654d$exports);
}
$2e0a842597f3e494$exports = $2e0a842597f3e494$var$getAllKeysIn;



var $2180ab41db3ba410$exports = {};
/** Used for built-in method references. */ var $2180ab41db3ba410$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2180ab41db3ba410$var$hasOwnProperty = $2180ab41db3ba410$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $2180ab41db3ba410$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $2180ab41db3ba410$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
$2180ab41db3ba410$exports = $2180ab41db3ba410$var$initCloneArray;


var $3efca2267472e930$exports = {};
var $b3054ef8c74512c2$exports = {};

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $b3054ef8c74512c2$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $de729f53a969f0c1$exports(result).set(new $de729f53a969f0c1$exports(arrayBuffer));
    return result;
}
$b3054ef8c74512c2$exports = $b3054ef8c74512c2$var$cloneArrayBuffer;


var $85e2c0e42c5cb7f7$exports = {};

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $85e2c0e42c5cb7f7$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $b3054ef8c74512c2$exports(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
$85e2c0e42c5cb7f7$exports = $85e2c0e42c5cb7f7$var$cloneDataView;


var $3cd4c2ad50efe0a8$exports = {};
/** Used to match `RegExp` flags from their coerced string values. */ var $3cd4c2ad50efe0a8$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $3cd4c2ad50efe0a8$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $3cd4c2ad50efe0a8$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
$3cd4c2ad50efe0a8$exports = $3cd4c2ad50efe0a8$var$cloneRegExp;


var $2edb3840ef0eeaf0$exports = {};

/** Used to convert symbols to primitives and strings. */ var $2edb3840ef0eeaf0$var$symbolProto = $a0e007488b23f5fe$exports ? $a0e007488b23f5fe$exports.prototype : undefined, $2edb3840ef0eeaf0$var$symbolValueOf = $2edb3840ef0eeaf0$var$symbolProto ? $2edb3840ef0eeaf0$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $2edb3840ef0eeaf0$var$cloneSymbol(symbol) {
    return $2edb3840ef0eeaf0$var$symbolValueOf ? Object($2edb3840ef0eeaf0$var$symbolValueOf.call(symbol)) : {};
}
$2edb3840ef0eeaf0$exports = $2edb3840ef0eeaf0$var$cloneSymbol;


var $7a4a99ac3fe7eef6$exports = {};

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $7a4a99ac3fe7eef6$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $b3054ef8c74512c2$exports(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
$7a4a99ac3fe7eef6$exports = $7a4a99ac3fe7eef6$var$cloneTypedArray;


/** `Object#toString` result references. */ var $3efca2267472e930$var$boolTag = "[object Boolean]", $3efca2267472e930$var$dateTag = "[object Date]", $3efca2267472e930$var$mapTag = "[object Map]", $3efca2267472e930$var$numberTag = "[object Number]", $3efca2267472e930$var$regexpTag = "[object RegExp]", $3efca2267472e930$var$setTag = "[object Set]", $3efca2267472e930$var$stringTag = "[object String]", $3efca2267472e930$var$symbolTag = "[object Symbol]";
var $3efca2267472e930$var$arrayBufferTag = "[object ArrayBuffer]", $3efca2267472e930$var$dataViewTag = "[object DataView]", $3efca2267472e930$var$float32Tag = "[object Float32Array]", $3efca2267472e930$var$float64Tag = "[object Float64Array]", $3efca2267472e930$var$int8Tag = "[object Int8Array]", $3efca2267472e930$var$int16Tag = "[object Int16Array]", $3efca2267472e930$var$int32Tag = "[object Int32Array]", $3efca2267472e930$var$uint8Tag = "[object Uint8Array]", $3efca2267472e930$var$uint8ClampedTag = "[object Uint8ClampedArray]", $3efca2267472e930$var$uint16Tag = "[object Uint16Array]", $3efca2267472e930$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $3efca2267472e930$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $3efca2267472e930$var$arrayBufferTag:
            return $b3054ef8c74512c2$exports(object);
        case $3efca2267472e930$var$boolTag:
        case $3efca2267472e930$var$dateTag:
            return new Ctor(+object);
        case $3efca2267472e930$var$dataViewTag:
            return $85e2c0e42c5cb7f7$exports(object, isDeep);
        case $3efca2267472e930$var$float32Tag:
        case $3efca2267472e930$var$float64Tag:
        case $3efca2267472e930$var$int8Tag:
        case $3efca2267472e930$var$int16Tag:
        case $3efca2267472e930$var$int32Tag:
        case $3efca2267472e930$var$uint8Tag:
        case $3efca2267472e930$var$uint8ClampedTag:
        case $3efca2267472e930$var$uint16Tag:
        case $3efca2267472e930$var$uint32Tag:
            return $7a4a99ac3fe7eef6$exports(object, isDeep);
        case $3efca2267472e930$var$mapTag:
            return new Ctor;
        case $3efca2267472e930$var$numberTag:
        case $3efca2267472e930$var$stringTag:
            return new Ctor(object);
        case $3efca2267472e930$var$regexpTag:
            return $3cd4c2ad50efe0a8$exports(object);
        case $3efca2267472e930$var$setTag:
            return new Ctor;
        case $3efca2267472e930$var$symbolTag:
            return $2edb3840ef0eeaf0$exports(object);
    }
}
$3efca2267472e930$exports = $3efca2267472e930$var$initCloneByTag;


var $d2e85317f4990ee2$exports = {};
var $31914e7e570fc4f2$exports = {};

/** Built-in value references. */ var $31914e7e570fc4f2$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $31914e7e570fc4f2$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$cdeebba9a3c50f33$exports(proto)) return {};
        if ($31914e7e570fc4f2$var$objectCreate) return $31914e7e570fc4f2$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
$31914e7e570fc4f2$exports = $31914e7e570fc4f2$var$baseCreate;




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $d2e85317f4990ee2$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !$d8bce8a27fc077c6$exports(object) ? $31914e7e570fc4f2$exports($6869910f8d4be8cc$exports(object)) : {};
}
$d2e85317f4990ee2$exports = $d2e85317f4990ee2$var$initCloneObject;




var $ca1Sy = parcelRequire("ca1Sy");
var $3eddd50ff03f2822$exports = {};
var $53663610eb761f85$exports = {};


/** `Object#toString` result references. */ var $53663610eb761f85$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $53663610eb761f85$var$baseIsMap(value) {
    return $a35b73cb295f324c$exports(value) && $609d8c339d16de4d$exports(value) == $53663610eb761f85$var$mapTag;
}
$53663610eb761f85$exports = $53663610eb761f85$var$baseIsMap;




var $4noEQ = parcelRequire("4noEQ");
/* Node.js helper references. */ var $3eddd50ff03f2822$var$nodeIsMap = $4noEQ && $4noEQ.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $3eddd50ff03f2822$var$isMap = $3eddd50ff03f2822$var$nodeIsMap ? $6a1e4a18512710bb$exports($3eddd50ff03f2822$var$nodeIsMap) : $53663610eb761f85$exports;
$3eddd50ff03f2822$exports = $3eddd50ff03f2822$var$isMap;



var $c6fd2f2cdb161c78$exports = {};
var $b67e70bedc1a4fab$exports = {};


/** `Object#toString` result references. */ var $b67e70bedc1a4fab$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $b67e70bedc1a4fab$var$baseIsSet(value) {
    return $a35b73cb295f324c$exports(value) && $609d8c339d16de4d$exports(value) == $b67e70bedc1a4fab$var$setTag;
}
$b67e70bedc1a4fab$exports = $b67e70bedc1a4fab$var$baseIsSet;




var $4noEQ = parcelRequire("4noEQ");
/* Node.js helper references. */ var $c6fd2f2cdb161c78$var$nodeIsSet = $4noEQ && $4noEQ.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $c6fd2f2cdb161c78$var$isSet = $c6fd2f2cdb161c78$var$nodeIsSet ? $6a1e4a18512710bb$exports($c6fd2f2cdb161c78$var$nodeIsSet) : $b67e70bedc1a4fab$exports;
$c6fd2f2cdb161c78$exports = $c6fd2f2cdb161c78$var$isSet;




/** Used to compose bitmasks for cloning. */ var $dedf4319d925ab72$var$CLONE_DEEP_FLAG = 1, $dedf4319d925ab72$var$CLONE_FLAT_FLAG = 2, $dedf4319d925ab72$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $dedf4319d925ab72$var$argsTag = "[object Arguments]", $dedf4319d925ab72$var$arrayTag = "[object Array]", $dedf4319d925ab72$var$boolTag = "[object Boolean]", $dedf4319d925ab72$var$dateTag = "[object Date]", $dedf4319d925ab72$var$errorTag = "[object Error]", $dedf4319d925ab72$var$funcTag = "[object Function]", $dedf4319d925ab72$var$genTag = "[object GeneratorFunction]", $dedf4319d925ab72$var$mapTag = "[object Map]", $dedf4319d925ab72$var$numberTag = "[object Number]", $dedf4319d925ab72$var$objectTag = "[object Object]", $dedf4319d925ab72$var$regexpTag = "[object RegExp]", $dedf4319d925ab72$var$setTag = "[object Set]", $dedf4319d925ab72$var$stringTag = "[object String]", $dedf4319d925ab72$var$symbolTag = "[object Symbol]", $dedf4319d925ab72$var$weakMapTag = "[object WeakMap]";
var $dedf4319d925ab72$var$arrayBufferTag = "[object ArrayBuffer]", $dedf4319d925ab72$var$dataViewTag = "[object DataView]", $dedf4319d925ab72$var$float32Tag = "[object Float32Array]", $dedf4319d925ab72$var$float64Tag = "[object Float64Array]", $dedf4319d925ab72$var$int8Tag = "[object Int8Array]", $dedf4319d925ab72$var$int16Tag = "[object Int16Array]", $dedf4319d925ab72$var$int32Tag = "[object Int32Array]", $dedf4319d925ab72$var$uint8Tag = "[object Uint8Array]", $dedf4319d925ab72$var$uint8ClampedTag = "[object Uint8ClampedArray]", $dedf4319d925ab72$var$uint16Tag = "[object Uint16Array]", $dedf4319d925ab72$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $dedf4319d925ab72$var$cloneableTags = {};
$dedf4319d925ab72$var$cloneableTags[$dedf4319d925ab72$var$argsTag] = $dedf4319d925ab72$var$cloneableTags[$dedf4319d925ab72$var$arrayTag] = $dedf4319d925ab72$var$cloneableTags[$dedf4319d925ab72$var$arrayBufferTag] = $dedf4319d925ab72$var$cloneableTags[$dedf4319d925ab72$var$dataViewTag] = $dedf4319d925ab72$var$cloneableTags[$dedf4319d925ab72$var$boolTag] = $dedf4319d925ab72$var$cloneableTags[$dedf4319d925ab72$var$dateTag] = $dedf4319d925ab72$var$cloneableTags[$dedf4319d925ab72$var$float32Tag] = $dedf4319d925ab72$var$cloneableTags[$dedf4319d925ab72$var$float64Tag] = $dedf4319d925ab72$var$cloneableTags[$dedf4319d925ab72$var$int8Tag] = $dedf4319d925ab72$var$cloneableTags[$dedf4319d925ab72$var$int16Tag] = $dedf4319d925ab72$var$cloneableTags[$dedf4319d925ab72$var$int32Tag] = $dedf4319d925ab72$var$cloneableTags[$dedf4319d925ab72$var$mapTag] = $dedf4319d925ab72$var$cloneableTags[$dedf4319d925ab72$var$numberTag] = $dedf4319d925ab72$var$cloneableTags[$dedf4319d925ab72$var$objectTag] = $dedf4319d925ab72$var$cloneableTags[$dedf4319d925ab72$var$regexpTag] = $dedf4319d925ab72$var$cloneableTags[$dedf4319d925ab72$var$setTag] = $dedf4319d925ab72$var$cloneableTags[$dedf4319d925ab72$var$stringTag] = $dedf4319d925ab72$var$cloneableTags[$dedf4319d925ab72$var$symbolTag] = $dedf4319d925ab72$var$cloneableTags[$dedf4319d925ab72$var$uint8Tag] = $dedf4319d925ab72$var$cloneableTags[$dedf4319d925ab72$var$uint8ClampedTag] = $dedf4319d925ab72$var$cloneableTags[$dedf4319d925ab72$var$uint16Tag] = $dedf4319d925ab72$var$cloneableTags[$dedf4319d925ab72$var$uint32Tag] = true;
$dedf4319d925ab72$var$cloneableTags[$dedf4319d925ab72$var$errorTag] = $dedf4319d925ab72$var$cloneableTags[$dedf4319d925ab72$var$funcTag] = $dedf4319d925ab72$var$cloneableTags[$dedf4319d925ab72$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $dedf4319d925ab72$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $dedf4319d925ab72$var$CLONE_DEEP_FLAG, isFlat = bitmask & $dedf4319d925ab72$var$CLONE_FLAT_FLAG, isFull = bitmask & $dedf4319d925ab72$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$cdeebba9a3c50f33$exports(value)) return value;
    var isArr = $0fe4a5546443a34c$exports(value);
    if (isArr) {
        result = $2180ab41db3ba410$exports(value);
        if (!isDeep) return $7bfe08991d8e8165$exports(value, result);
    } else {
        var tag = $609d8c339d16de4d$exports(value), isFunc = tag == $dedf4319d925ab72$var$funcTag || tag == $dedf4319d925ab72$var$genTag;
        if ($ca1Sy(value)) return $83wuy(value, isDeep);
        if (tag == $dedf4319d925ab72$var$objectTag || tag == $dedf4319d925ab72$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $d2e85317f4990ee2$exports(value);
            if (!isDeep) return isFlat ? $4b3e4d33f0bd5f0e$exports(value, $c8027e6828bbc076$exports(result, value)) : $655b3585dee1c9e2$exports(value, $3f4adc36bb205d1c$exports(result, value));
        } else {
            if (!$dedf4319d925ab72$var$cloneableTags[tag]) return object ? value : {};
            result = $3efca2267472e930$exports(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $cd6a7fdc60b1cb13$exports);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($c6fd2f2cdb161c78$exports(value)) value.forEach(function(subValue) {
        result.add($dedf4319d925ab72$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($3eddd50ff03f2822$exports(value)) value.forEach(function(subValue, key) {
        result.set(key, $dedf4319d925ab72$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $2e0a842597f3e494$exports : $80d0f1bf29a411be$exports : isFlat ? $5589b8f6a83de59f$exports : $322e4354daac4308$exports;
    var props = isArr ? undefined : keysFunc(value);
    $2f65dd5e37e6162b$exports(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $23d01ff6833d6944$exports(result, key, $dedf4319d925ab72$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
$dedf4319d925ab72$exports = $dedf4319d925ab72$var$baseClone;


/** Used to compose bitmasks for cloning. */ var $7515c800aeb45689$var$CLONE_DEEP_FLAG = 1, $7515c800aeb45689$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $7515c800aeb45689$var$cloneDeep(value) {
    return $dedf4319d925ab72$exports(value, $7515c800aeb45689$var$CLONE_DEEP_FLAG | $7515c800aeb45689$var$CLONE_SYMBOLS_FLAG);
}
$7515c800aeb45689$exports = $7515c800aeb45689$var$cloneDeep;


var $8ee5599c7a3f144c$var$_cloneDeep3 = $8ee5599c7a3f144c$var$_interopRequireDefault($7515c800aeb45689$exports);
var $8ee5599c7a3f144c$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $8ee5599c7a3f144c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8ee5599c7a3f144c$var$mergeClasses = $8ee5599c7a3f144c$exports.mergeClasses = function mergeClasses(classes) {
    var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var styles = classes.default && (0, $8ee5599c7a3f144c$var$_cloneDeep3.default)(classes.default) || {};
    activeNames.map(function(name) {
        var toMerge = classes[name];
        if (toMerge) (0, $8ee5599c7a3f144c$var$_forOwn3.default)(toMerge, function(value, key) {
            if (!styles[key]) styles[key] = {};
            styles[key] = $8ee5599c7a3f144c$var$_extends({}, styles[key], toMerge[key]);
        });
        return name;
    });
    return styles;
};
$8ee5599c7a3f144c$exports.default = $8ee5599c7a3f144c$var$mergeClasses;


var $081a95961b0cb73f$var$_mergeClasses2 = $081a95961b0cb73f$var$_interopRequireDefault($8ee5599c7a3f144c$exports);
var $8447fe7cc9914a58$exports = {};
"use strict";
Object.defineProperty($8447fe7cc9914a58$exports, "__esModule", {
    value: true
});
$8447fe7cc9914a58$exports.autoprefix = undefined;

var $8447fe7cc9914a58$var$_forOwn3 = $8447fe7cc9914a58$var$_interopRequireDefault($a545443a7331cfb0$exports);
var $8447fe7cc9914a58$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $8447fe7cc9914a58$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8447fe7cc9914a58$var$transforms = {
    borderRadius: function borderRadius(value) {
        return {
            msBorderRadius: value,
            MozBorderRadius: value,
            OBorderRadius: value,
            WebkitBorderRadius: value,
            borderRadius: value
        };
    },
    boxShadow: function boxShadow(value) {
        return {
            msBoxShadow: value,
            MozBoxShadow: value,
            OBoxShadow: value,
            WebkitBoxShadow: value,
            boxShadow: value
        };
    },
    userSelect: function userSelect(value) {
        return {
            WebkitTouchCallout: value,
            KhtmlUserSelect: value,
            MozUserSelect: value,
            msUserSelect: value,
            WebkitUserSelect: value,
            userSelect: value
        };
    },
    flex: function flex(value) {
        return {
            WebkitBoxFlex: value,
            MozBoxFlex: value,
            WebkitFlex: value,
            msFlex: value,
            flex: value
        };
    },
    flexBasis: function flexBasis(value) {
        return {
            WebkitFlexBasis: value,
            flexBasis: value
        };
    },
    justifyContent: function justifyContent(value) {
        return {
            WebkitJustifyContent: value,
            justifyContent: value
        };
    },
    transition: function transition(value) {
        return {
            msTransition: value,
            MozTransition: value,
            OTransition: value,
            WebkitTransition: value,
            transition: value
        };
    },
    transform: function transform(value) {
        return {
            msTransform: value,
            MozTransform: value,
            OTransform: value,
            WebkitTransform: value,
            transform: value
        };
    },
    absolute: function absolute(value) {
        var direction = value && value.split(" ");
        return {
            position: "absolute",
            top: direction && direction[0],
            right: direction && direction[1],
            bottom: direction && direction[2],
            left: direction && direction[3]
        };
    },
    extend: function extend(name, otherElementStyles) {
        var otherStyle = otherElementStyles[name];
        if (otherStyle) return otherStyle;
        return {
            "extend": name
        };
    }
};
var $8447fe7cc9914a58$var$autoprefix = $8447fe7cc9914a58$exports.autoprefix = function autoprefix(elements) {
    var prefixed = {};
    (0, $8447fe7cc9914a58$var$_forOwn3.default)(elements, function(styles, element) {
        var expanded = {};
        (0, $8447fe7cc9914a58$var$_forOwn3.default)(styles, function(value, key) {
            var transform = $8447fe7cc9914a58$var$transforms[key];
            if (transform) expanded = $8447fe7cc9914a58$var$_extends({}, expanded, transform(value));
            else expanded[key] = value;
        });
        prefixed[element] = expanded;
    });
    return prefixed;
};
$8447fe7cc9914a58$exports.default = $8447fe7cc9914a58$var$autoprefix;


var $081a95961b0cb73f$var$_autoprefix2 = $081a95961b0cb73f$var$_interopRequireDefault($8447fe7cc9914a58$exports);
var $2751eccbb7fa71ae$exports = {};
"use strict";
Object.defineProperty($2751eccbb7fa71ae$exports, "__esModule", {
    value: true
});
$2751eccbb7fa71ae$exports.hover = undefined;
var $2751eccbb7fa71ae$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $jC8Vy = parcelRequire("jC8Vy");
var $2751eccbb7fa71ae$var$_react2 = $2751eccbb7fa71ae$var$_interopRequireDefault($jC8Vy);
function $2751eccbb7fa71ae$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2751eccbb7fa71ae$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2751eccbb7fa71ae$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $2751eccbb7fa71ae$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $2751eccbb7fa71ae$var$hover = $2751eccbb7fa71ae$exports.hover = function hover(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "span";
    return function(_React$Component) {
        $2751eccbb7fa71ae$var$_inherits(Hover, _React$Component);
        function Hover() {
            var _ref;
            var _temp, _this, _ret;
            $2751eccbb7fa71ae$var$_classCallCheck(this, Hover);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $2751eccbb7fa71ae$var$_possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                hover: false
            }, _this.handleMouseOver = function() {
                return _this.setState({
                    hover: true
                });
            }, _this.handleMouseOut = function() {
                return _this.setState({
                    hover: false
                });
            }, _this.render = function() {
                return $2751eccbb7fa71ae$var$_react2.default.createElement(Span, {
                    onMouseOver: _this.handleMouseOver,
                    onMouseOut: _this.handleMouseOut
                }, $2751eccbb7fa71ae$var$_react2.default.createElement(Component, $2751eccbb7fa71ae$var$_extends({}, _this.props, _this.state)));
            }, _temp), $2751eccbb7fa71ae$var$_possibleConstructorReturn(_this, _ret);
        }
        return Hover;
    }($2751eccbb7fa71ae$var$_react2.default.Component);
};
$2751eccbb7fa71ae$exports.default = $2751eccbb7fa71ae$var$hover;


var $081a95961b0cb73f$var$_hover3 = $081a95961b0cb73f$var$_interopRequireDefault($2751eccbb7fa71ae$exports);
var $c4ebf2577f1333d2$exports = {};
"use strict";
Object.defineProperty($c4ebf2577f1333d2$exports, "__esModule", {
    value: true
});
$c4ebf2577f1333d2$exports.active = undefined;
var $c4ebf2577f1333d2$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $jC8Vy = parcelRequire("jC8Vy");
var $c4ebf2577f1333d2$var$_react2 = $c4ebf2577f1333d2$var$_interopRequireDefault($jC8Vy);
function $c4ebf2577f1333d2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c4ebf2577f1333d2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c4ebf2577f1333d2$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $c4ebf2577f1333d2$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $c4ebf2577f1333d2$var$active = $c4ebf2577f1333d2$exports.active = function active(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "span";
    return function(_React$Component) {
        $c4ebf2577f1333d2$var$_inherits(Active, _React$Component);
        function Active() {
            var _ref;
            var _temp, _this, _ret;
            $c4ebf2577f1333d2$var$_classCallCheck(this, Active);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $c4ebf2577f1333d2$var$_possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                active: false
            }, _this.handleMouseDown = function() {
                return _this.setState({
                    active: true
                });
            }, _this.handleMouseUp = function() {
                return _this.setState({
                    active: false
                });
            }, _this.render = function() {
                return $c4ebf2577f1333d2$var$_react2.default.createElement(Span, {
                    onMouseDown: _this.handleMouseDown,
                    onMouseUp: _this.handleMouseUp
                }, $c4ebf2577f1333d2$var$_react2.default.createElement(Component, $c4ebf2577f1333d2$var$_extends({}, _this.props, _this.state)));
            }, _temp), $c4ebf2577f1333d2$var$_possibleConstructorReturn(_this, _ret);
        }
        return Active;
    }($c4ebf2577f1333d2$var$_react2.default.Component);
};
$c4ebf2577f1333d2$exports.default = $c4ebf2577f1333d2$var$active;


var $081a95961b0cb73f$var$_active2 = $081a95961b0cb73f$var$_interopRequireDefault($c4ebf2577f1333d2$exports);
var $81a0e737bf81c971$exports = {};
"use strict";
Object.defineProperty($81a0e737bf81c971$exports, "__esModule", {
    value: true
});
var $81a0e737bf81c971$var$loopable = function loopable(i, length) {
    var props = {};
    var setProp = function setProp(name) {
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        props[name] = value;
    };
    i === 0 && setProp("first-child");
    i === length - 1 && setProp("last-child");
    (i === 0 || i % 2 === 0) && setProp("even");
    Math.abs(i % 2) === 1 && setProp("odd");
    setProp("nth-child", i);
    return props;
};
$81a0e737bf81c971$exports.default = $81a0e737bf81c971$var$loopable;


var $081a95961b0cb73f$var$_loop3 = $081a95961b0cb73f$var$_interopRequireDefault($81a0e737bf81c971$exports);
function $081a95961b0cb73f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$081a95961b0cb73f$exports.hover = $081a95961b0cb73f$var$_hover3.default;
$081a95961b0cb73f$exports.handleHover = $081a95961b0cb73f$var$_hover3.default;
$081a95961b0cb73f$exports.handleActive = $081a95961b0cb73f$var$_active2.default;
$081a95961b0cb73f$exports.loop = $081a95961b0cb73f$var$_loop3.default;
var $081a95961b0cb73f$var$ReactCSS = $081a95961b0cb73f$exports.ReactCSS = function ReactCSS(classes) {
    for(var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)activations[_key - 1] = arguments[_key];
    var activeNames = (0, $081a95961b0cb73f$var$_flattenNames2.default)(activations);
    var merged = (0, $081a95961b0cb73f$var$_mergeClasses2.default)(classes, activeNames);
    return (0, $081a95961b0cb73f$var$_autoprefix2.default)(merged);
};
$081a95961b0cb73f$exports.default = $081a95961b0cb73f$var$ReactCSS;



var $jC8Vy = parcelRequire("jC8Vy");

var $c6a4bd06ec5cbb1c$export$a056a977bf6a9a3c = function calculateChange(e, hsl, direction, initialA, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === "vertical") {
        var a = void 0;
        if (top < 0) a = 0;
        else if (top > containerHeight) a = 1;
        else a = Math.round(top * 100 / containerHeight) / 100;
        if (hsl.a !== a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: a,
            source: "rgb"
        };
    } else {
        var _a = void 0;
        if (left < 0) _a = 0;
        else if (left > containerWidth) _a = 1;
        else _a = Math.round(left * 100 / containerWidth) / 100;
        if (initialA !== _a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: _a,
            source: "rgb"
        };
    }
    return null;
};



var $jC8Vy = parcelRequire("jC8Vy");

var $59a844f666708549$var$checkboardCache = {};
var $59a844f666708549$export$b3890eb0ae9dca99 = function render(c1, c2, size, serverCanvas) {
    if (typeof document === "undefined" && !serverCanvas) return null;
    var canvas = serverCanvas ? new serverCanvas() : document.createElement("canvas");
    canvas.width = size * 2;
    canvas.height = size * 2;
    var ctx = canvas.getContext("2d");
    if (!ctx) return null;
     // If no context can be found, return early.
    ctx.fillStyle = c1;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = c2;
    ctx.fillRect(0, 0, size, size);
    ctx.translate(size, size);
    ctx.fillRect(0, 0, size, size);
    return canvas.toDataURL();
};
var $59a844f666708549$export$3988ae62b71be9a3 = function get(c1, c2, size, serverCanvas) {
    var key = c1 + "-" + c2 + "-" + size + (serverCanvas ? "-server" : "");
    if ($59a844f666708549$var$checkboardCache[key]) return $59a844f666708549$var$checkboardCache[key];
    var checkboard = $59a844f666708549$export$b3890eb0ae9dca99(c1, c2, size, serverCanvas);
    $59a844f666708549$var$checkboardCache[key] = checkboard;
    return checkboard;
};


var $06778ce7e366f6d8$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $06778ce7e366f6d8$export$457ff74489f64b4a = function Checkboard(_ref) {
    var white = _ref.white, grey = _ref.grey, size = _ref.size, renderers = _ref.renderers, borderRadius = _ref.borderRadius, boxShadow = _ref.boxShadow, children = _ref.children;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))({
        "default": {
            grid: {
                borderRadius: borderRadius,
                boxShadow: boxShadow,
                absolute: "0px 0px 0px 0px",
                background: "url(" + $59a844f666708549$export$3988ae62b71be9a3(white, grey, size, renderers.canvas) + ") center left"
            }
        }
    });
    return (0, $jC8Vy.isValidElement)(children) ? (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).cloneElement(children, $06778ce7e366f6d8$var$_extends({}, children.props, {
        style: $06778ce7e366f6d8$var$_extends({}, children.props.style, styles.grid)
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.grid
    });
};
$06778ce7e366f6d8$export$457ff74489f64b4a.defaultProps = {
    size: 8,
    white: "transparent",
    grey: "rgba(0,0,0,.08)",
    renderers: {}
};
var $06778ce7e366f6d8$export$2e2bcd8739ae039 = $06778ce7e366f6d8$export$457ff74489f64b4a;


var $c7fcad7bb70c839d$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $c7fcad7bb70c839d$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $c7fcad7bb70c839d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c7fcad7bb70c839d$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $c7fcad7bb70c839d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $c7fcad7bb70c839d$export$b3d0ceb706f8af43 = function(_ref) {
    $c7fcad7bb70c839d$var$_inherits(Alpha, _ref);
    function Alpha() {
        var _ref2;
        var _temp, _this, _ret;
        $c7fcad7bb70c839d$var$_classCallCheck(this, Alpha);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $c7fcad7bb70c839d$var$_possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = $c6a4bd06ec5cbb1c$export$a056a977bf6a9a3c(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
            change && typeof _this.props.onChange === "function" && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener("mousemove", _this.handleChange);
            window.addEventListener("mouseup", _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _this.unbindEventListeners = function() {
            window.removeEventListener("mousemove", _this.handleChange);
            window.removeEventListener("mouseup", _this.handleMouseUp);
        }, _temp), $c7fcad7bb70c839d$var$_possibleConstructorReturn(_this, _ret);
    }
    $c7fcad7bb70c839d$var$_createClass(Alpha, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var rgb = this.props.rgb;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))({
                    "default": {
                        alpha: {
                            absolute: "0px 0px 0px 0px",
                            borderRadius: this.props.radius
                        },
                        checkboard: {
                            absolute: "0px 0px 0px 0px",
                            overflow: "hidden",
                            borderRadius: this.props.radius
                        },
                        gradient: {
                            absolute: "0px 0px 0px 0px",
                            background: "linear-gradient(to right, rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 0) 0%,\n           rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 1) 100%)",
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        container: {
                            position: "relative",
                            height: "100%",
                            margin: "0 3px"
                        },
                        pointer: {
                            position: "absolute",
                            left: rgb.a * 100 + "%"
                        },
                        slider: {
                            width: "4px",
                            borderRadius: "1px",
                            height: "8px",
                            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
                            background: "#fff",
                            marginTop: "1px",
                            transform: "translateX(-2px)"
                        }
                    },
                    "vertical": {
                        gradient: {
                            background: "linear-gradient(to bottom, rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 0) 0%,\n           rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 1) 100%)"
                        },
                        pointer: {
                            left: 0,
                            top: rgb.a * 100 + "%"
                        }
                    },
                    "overwrite": $c7fcad7bb70c839d$var$_extends({}, this.props.style)
                }, {
                    vertical: this.props.direction === "vertical",
                    overwrite: true
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.alpha
                }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.checkboard
                }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $06778ce7e366f6d8$export$2e2bcd8739ae039), {
                    renderers: this.props.renderers
                })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.gradient
                }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.pointer
                }, this.props.pointer ? (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement(this.props.pointer, this.props) : (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Alpha;
}((0, $jC8Vy.PureComponent) || (0, $jC8Vy.Component));
var $c7fcad7bb70c839d$export$2e2bcd8739ae039 = $c7fcad7bb70c839d$export$b3d0ceb706f8af43;




var $jC8Vy = parcelRequire("jC8Vy");

var $aa68fc673938b317$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $aa68fc673938b317$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $aa68fc673938b317$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $aa68fc673938b317$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $aa68fc673938b317$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $aa68fc673938b317$var$DEFAULT_ARROW_OFFSET = 1;
var $aa68fc673938b317$var$UP_KEY_CODE = 38;
var $aa68fc673938b317$var$DOWN_KEY_CODE = 40;
var $aa68fc673938b317$var$VALID_KEY_CODES = [
    $aa68fc673938b317$var$UP_KEY_CODE,
    $aa68fc673938b317$var$DOWN_KEY_CODE
];
var $aa68fc673938b317$var$isValidKeyCode = function isValidKeyCode(keyCode) {
    return $aa68fc673938b317$var$VALID_KEY_CODES.indexOf(keyCode) > -1;
};
var $aa68fc673938b317$var$getNumberValue = function getNumberValue(value) {
    return Number(String(value).replace(/%/g, ""));
};
var $aa68fc673938b317$var$idCounter = 1;
var $aa68fc673938b317$export$bfb3cbb78d3c298 = function(_ref) {
    $aa68fc673938b317$var$_inherits(EditableInput, _ref);
    function EditableInput(props) {
        $aa68fc673938b317$var$_classCallCheck(this, EditableInput);
        var _this = $aa68fc673938b317$var$_possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));
        _this.handleBlur = function() {
            if (_this.state.blurValue) _this.setState({
                value: _this.state.blurValue,
                blurValue: null
            });
        };
        _this.handleChange = function(e) {
            _this.setUpdatedValue(e.target.value, e);
        };
        _this.handleKeyDown = function(e) {
            // In case `e.target.value` is a percentage remove the `%` character
            // and update accordingly with a percentage
            // https://github.com/casesandberg/react-color/issues/383
            var value = $aa68fc673938b317$var$getNumberValue(e.target.value);
            if (!isNaN(value) && $aa68fc673938b317$var$isValidKeyCode(e.keyCode)) {
                var offset = _this.getArrowOffset();
                var updatedValue = e.keyCode === $aa68fc673938b317$var$UP_KEY_CODE ? value + offset : value - offset;
                _this.setUpdatedValue(updatedValue, e);
            }
        };
        _this.handleDrag = function(e) {
            if (_this.props.dragLabel) {
                var newValue = Math.round(_this.props.value + e.movementX);
                if (newValue >= 0 && newValue <= _this.props.dragMax) _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
            }
        };
        _this.handleMouseDown = function(e) {
            if (_this.props.dragLabel) {
                e.preventDefault();
                _this.handleDrag(e);
                window.addEventListener("mousemove", _this.handleDrag);
                window.addEventListener("mouseup", _this.handleMouseUp);
            }
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.unbindEventListeners = function() {
            window.removeEventListener("mousemove", _this.handleDrag);
            window.removeEventListener("mouseup", _this.handleMouseUp);
        };
        _this.state = {
            value: String(props.value).toUpperCase(),
            blurValue: String(props.value).toUpperCase()
        };
        _this.inputId = "rc-editable-input-" + $aa68fc673938b317$var$idCounter++;
        return _this;
    }
    $aa68fc673938b317$var$_createClass(EditableInput, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
                    if (this.input === document.activeElement) this.setState({
                        blurValue: String(this.props.value).toUpperCase()
                    });
                    else this.setState({
                        value: String(this.props.value).toUpperCase(),
                        blurValue: !this.state.blurValue && String(this.props.value).toUpperCase()
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: "getValueObjectWithLabel",
            value: function getValueObjectWithLabel(value) {
                return $aa68fc673938b317$var$_defineProperty({}, this.props.label, value);
            }
        },
        {
            key: "getArrowOffset",
            value: function getArrowOffset() {
                return this.props.arrowOffset || $aa68fc673938b317$var$DEFAULT_ARROW_OFFSET;
            }
        },
        {
            key: "setUpdatedValue",
            value: function setUpdatedValue(value, e) {
                var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
                this.props.onChange && this.props.onChange(onChangeValue, e);
                this.setState({
                    value: value
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))({
                    "default": {
                        wrap: {
                            position: "relative"
                        }
                    },
                    "user-override": {
                        wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
                        input: this.props.style && this.props.style.input ? this.props.style.input : {},
                        label: this.props.style && this.props.style.label ? this.props.style.label : {}
                    },
                    "dragLabel-true": {
                        label: {
                            cursor: "ew-resize"
                        }
                    }
                }, {
                    "user-override": true
                }, this.props);
                return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.wrap
                }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("input", {
                    id: this.inputId,
                    style: styles.input,
                    ref: function ref(input) {
                        return _this2.input = input;
                    },
                    value: this.state.value,
                    onKeyDown: this.handleKeyDown,
                    onChange: this.handleChange,
                    onBlur: this.handleBlur,
                    placeholder: this.props.placeholder,
                    spellCheck: "false"
                }), this.props.label && !this.props.hideLabel ? (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("label", {
                    htmlFor: this.inputId,
                    style: styles.label,
                    onMouseDown: this.handleMouseDown
                }, this.props.label) : null);
            }
        }
    ]);
    return EditableInput;
}((0, $jC8Vy.PureComponent) || (0, $jC8Vy.Component));
var $aa68fc673938b317$export$2e2bcd8739ae039 = $aa68fc673938b317$export$bfb3cbb78d3c298;



var $jC8Vy = parcelRequire("jC8Vy");

var $b92180bb78e948f4$export$a056a977bf6a9a3c = function calculateChange(e, direction, hsl, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === "vertical") {
        var h = void 0;
        if (top < 0) h = 359;
        else if (top > containerHeight) h = 0;
        else {
            var percent = -(top * 100 / containerHeight) + 100;
            h = 360 * percent / 100;
        }
        if (hsl.h !== h) return {
            h: h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: "hsl"
        };
    } else {
        var _h = void 0;
        if (left < 0) _h = 0;
        else if (left > containerWidth) _h = 359;
        else {
            var _percent = left * 100 / containerWidth;
            _h = 360 * _percent / 100;
        }
        if (hsl.h !== _h) return {
            h: _h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: "hsl"
        };
    }
    return null;
};


var $38476a9de322d712$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $38476a9de322d712$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $38476a9de322d712$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $38476a9de322d712$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $38476a9de322d712$export$3e22a96a58989a47 = function(_ref) {
    $38476a9de322d712$var$_inherits(Hue, _ref);
    function Hue() {
        var _ref2;
        var _temp, _this, _ret;
        $38476a9de322d712$var$_classCallCheck(this, Hue);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $38476a9de322d712$var$_possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = $b92180bb78e948f4$export$a056a977bf6a9a3c(e, _this.props.direction, _this.props.hsl, _this.container);
            change && typeof _this.props.onChange === "function" && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener("mousemove", _this.handleChange);
            window.addEventListener("mouseup", _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _temp), $38476a9de322d712$var$_possibleConstructorReturn(_this, _ret);
    }
    $38476a9de322d712$var$_createClass(Hue, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: "unbindEventListeners",
            value: function unbindEventListeners() {
                window.removeEventListener("mousemove", this.handleChange);
                window.removeEventListener("mouseup", this.handleMouseUp);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _props$direction = this.props.direction, direction = _props$direction === undefined ? "horizontal" : _props$direction;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))({
                    "default": {
                        hue: {
                            absolute: "0px 0px 0px 0px",
                            borderRadius: this.props.radius,
                            boxShadow: this.props.shadow
                        },
                        container: {
                            padding: "0 2px",
                            position: "relative",
                            height: "100%",
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: "absolute",
                            left: this.props.hsl.h * 100 / 360 + "%"
                        },
                        slider: {
                            marginTop: "1px",
                            width: "4px",
                            borderRadius: "1px",
                            height: "8px",
                            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
                            background: "#fff",
                            transform: "translateX(-2px)"
                        }
                    },
                    "vertical": {
                        pointer: {
                            left: "0px",
                            top: -(this.props.hsl.h * 100 / 360) + 100 + "%"
                        }
                    }
                }, {
                    vertical: direction === "vertical"
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.hue
                }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    className: "hue-" + direction,
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("style", null, "\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          "), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.pointer
                }, this.props.pointer ? (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement(this.props.pointer, this.props) : (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Hue;
}((0, $jC8Vy.PureComponent) || (0, $jC8Vy.Component));
var $38476a9de322d712$export$2e2bcd8739ae039 = $38476a9de322d712$export$3e22a96a58989a47;



var $jC8Vy = parcelRequire("jC8Vy");

var $bD9Bx = parcelRequire("bD9Bx");

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $f7a2782431691b3b$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $f7a2782431691b3b$export$2e2bcd8739ae039 = $f7a2782431691b3b$var$listCacheClear;


/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $42b14d7baa041ed1$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $42b14d7baa041ed1$export$2e2bcd8739ae039 = $42b14d7baa041ed1$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e78041b43c988d12$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $42b14d7baa041ed1$export$2e2bcd8739ae039)(array[length][0], key)) return length;
    }
    return -1;
}
var $e78041b43c988d12$export$2e2bcd8739ae039 = $e78041b43c988d12$var$assocIndexOf;


/** Used for built-in method references. */ var $ca1bbec1348689a9$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $ca1bbec1348689a9$var$splice = $ca1bbec1348689a9$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ca1bbec1348689a9$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $e78041b43c988d12$export$2e2bcd8739ae039)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $ca1bbec1348689a9$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $ca1bbec1348689a9$export$2e2bcd8739ae039 = $ca1bbec1348689a9$var$listCacheDelete;



/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $c669564a7b07ebd1$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $e78041b43c988d12$export$2e2bcd8739ae039)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $c669564a7b07ebd1$export$2e2bcd8739ae039 = $c669564a7b07ebd1$var$listCacheGet;



/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $323e6b8ed5b1a64e$var$listCacheHas(key) {
    return (0, $e78041b43c988d12$export$2e2bcd8739ae039)(this.__data__, key) > -1;
}
var $323e6b8ed5b1a64e$export$2e2bcd8739ae039 = $323e6b8ed5b1a64e$var$listCacheHas;



/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $287e66f5611aa7e9$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $e78041b43c988d12$export$2e2bcd8739ae039)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $287e66f5611aa7e9$export$2e2bcd8739ae039 = $287e66f5611aa7e9$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4598850b67add3e0$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$4598850b67add3e0$var$ListCache.prototype.clear = (0, $f7a2782431691b3b$export$2e2bcd8739ae039);
$4598850b67add3e0$var$ListCache.prototype["delete"] = (0, $ca1bbec1348689a9$export$2e2bcd8739ae039);
$4598850b67add3e0$var$ListCache.prototype.get = (0, $c669564a7b07ebd1$export$2e2bcd8739ae039);
$4598850b67add3e0$var$ListCache.prototype.has = (0, $323e6b8ed5b1a64e$export$2e2bcd8739ae039);
$4598850b67add3e0$var$ListCache.prototype.set = (0, $287e66f5611aa7e9$export$2e2bcd8739ae039);
var $4598850b67add3e0$export$2e2bcd8739ae039 = $4598850b67add3e0$var$ListCache;



/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $309c86918baf6ec0$var$stackClear() {
    this.__data__ = new (0, $4598850b67add3e0$export$2e2bcd8739ae039);
    this.size = 0;
}
var $309c86918baf6ec0$export$2e2bcd8739ae039 = $309c86918baf6ec0$var$stackClear;


/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $4a2560280acb844a$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
var $4a2560280acb844a$export$2e2bcd8739ae039 = $4a2560280acb844a$var$stackDelete;


/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $7e1e2b0d7663fa1d$var$stackGet(key) {
    return this.__data__.get(key);
}
var $7e1e2b0d7663fa1d$export$2e2bcd8739ae039 = $7e1e2b0d7663fa1d$var$stackGet;


/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b44dce38f0f76986$var$stackHas(key) {
    return this.__data__.has(key);
}
var $b44dce38f0f76986$export$2e2bcd8739ae039 = $b44dce38f0f76986$var$stackHas;




var $kXc8K = parcelRequire("kXc8K");
/** Built-in value references. */ var $7a90d7abbf553945$var$Symbol = (0, $kXc8K.default).Symbol;
var $7a90d7abbf553945$export$2e2bcd8739ae039 = $7a90d7abbf553945$var$Symbol;



/** Used for built-in method references. */ var $71de0845edd1095c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $71de0845edd1095c$var$hasOwnProperty = $71de0845edd1095c$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $71de0845edd1095c$var$nativeObjectToString = $71de0845edd1095c$var$objectProto.toString;
/** Built-in value references. */ var $71de0845edd1095c$var$symToStringTag = (0, $7a90d7abbf553945$export$2e2bcd8739ae039) ? (0, $7a90d7abbf553945$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $71de0845edd1095c$var$getRawTag(value) {
    var isOwn = $71de0845edd1095c$var$hasOwnProperty.call(value, $71de0845edd1095c$var$symToStringTag), tag = value[$71de0845edd1095c$var$symToStringTag];
    try {
        value[$71de0845edd1095c$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $71de0845edd1095c$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$71de0845edd1095c$var$symToStringTag] = tag;
        else delete value[$71de0845edd1095c$var$symToStringTag];
    }
    return result;
}
var $71de0845edd1095c$export$2e2bcd8739ae039 = $71de0845edd1095c$var$getRawTag;


/** Used for built-in method references. */ var $a9c0350b5afef34e$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $a9c0350b5afef34e$var$nativeObjectToString = $a9c0350b5afef34e$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $a9c0350b5afef34e$var$objectToString(value) {
    return $a9c0350b5afef34e$var$nativeObjectToString.call(value);
}
var $a9c0350b5afef34e$export$2e2bcd8739ae039 = $a9c0350b5afef34e$var$objectToString;


/** `Object#toString` result references. */ var $d246294e778b9804$var$nullTag = "[object Null]", $d246294e778b9804$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $d246294e778b9804$var$symToStringTag = (0, $7a90d7abbf553945$export$2e2bcd8739ae039) ? (0, $7a90d7abbf553945$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $d246294e778b9804$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $d246294e778b9804$var$undefinedTag : $d246294e778b9804$var$nullTag;
    return $d246294e778b9804$var$symToStringTag && $d246294e778b9804$var$symToStringTag in Object(value) ? (0, $71de0845edd1095c$export$2e2bcd8739ae039)(value) : (0, $a9c0350b5afef34e$export$2e2bcd8739ae039)(value);
}
var $d246294e778b9804$export$2e2bcd8739ae039 = $d246294e778b9804$var$baseGetTag;


/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $ec27e620fc242dbd$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
var $ec27e620fc242dbd$export$2e2bcd8739ae039 = $ec27e620fc242dbd$var$isObject;


/** `Object#toString` result references. */ var $b8862f6ed7008e89$var$asyncTag = "[object AsyncFunction]", $b8862f6ed7008e89$var$funcTag = "[object Function]", $b8862f6ed7008e89$var$genTag = "[object GeneratorFunction]", $b8862f6ed7008e89$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $b8862f6ed7008e89$var$isFunction(value) {
    if (!(0, $ec27e620fc242dbd$export$2e2bcd8739ae039)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $d246294e778b9804$export$2e2bcd8739ae039)(value);
    return tag == $b8862f6ed7008e89$var$funcTag || tag == $b8862f6ed7008e89$var$genTag || tag == $b8862f6ed7008e89$var$asyncTag || tag == $b8862f6ed7008e89$var$proxyTag;
}
var $b8862f6ed7008e89$export$2e2bcd8739ae039 = $b8862f6ed7008e89$var$isFunction;



var $kXc8K = parcelRequire("kXc8K");
/** Used to detect overreaching core-js shims. */ var $34f94dcac89a414e$var$coreJsData = (0, $kXc8K.default)["__core-js_shared__"];
var $34f94dcac89a414e$export$2e2bcd8739ae039 = $34f94dcac89a414e$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $349dfeb4aa6b094f$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $34f94dcac89a414e$export$2e2bcd8739ae039) && (0, $34f94dcac89a414e$export$2e2bcd8739ae039).keys && (0, $34f94dcac89a414e$export$2e2bcd8739ae039).keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $349dfeb4aa6b094f$var$isMasked(func) {
    return !!$349dfeb4aa6b094f$var$maskSrcKey && $349dfeb4aa6b094f$var$maskSrcKey in func;
}
var $349dfeb4aa6b094f$export$2e2bcd8739ae039 = $349dfeb4aa6b094f$var$isMasked;



/** Used for built-in method references. */ var $5474618e5d31375a$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $5474618e5d31375a$var$funcToString = $5474618e5d31375a$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $5474618e5d31375a$var$toSource(func) {
    if (func != null) {
        try {
            return $5474618e5d31375a$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
var $5474618e5d31375a$export$2e2bcd8739ae039 = $5474618e5d31375a$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $a2a18425b5fc87c2$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $a2a18425b5fc87c2$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $a2a18425b5fc87c2$var$funcProto = Function.prototype, $a2a18425b5fc87c2$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $a2a18425b5fc87c2$var$funcToString = $a2a18425b5fc87c2$var$funcProto.toString;
/** Used to check objects for own properties. */ var $a2a18425b5fc87c2$var$hasOwnProperty = $a2a18425b5fc87c2$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $a2a18425b5fc87c2$var$reIsNative = RegExp("^" + $a2a18425b5fc87c2$var$funcToString.call($a2a18425b5fc87c2$var$hasOwnProperty).replace($a2a18425b5fc87c2$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $a2a18425b5fc87c2$var$baseIsNative(value) {
    if (!(0, $ec27e620fc242dbd$export$2e2bcd8739ae039)(value) || (0, $349dfeb4aa6b094f$export$2e2bcd8739ae039)(value)) return false;
    var pattern = (0, $b8862f6ed7008e89$export$2e2bcd8739ae039)(value) ? $a2a18425b5fc87c2$var$reIsNative : $a2a18425b5fc87c2$var$reIsHostCtor;
    return pattern.test((0, $5474618e5d31375a$export$2e2bcd8739ae039)(value));
}
var $a2a18425b5fc87c2$export$2e2bcd8739ae039 = $a2a18425b5fc87c2$var$baseIsNative;


/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $f0374d9cd8dfee29$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $f0374d9cd8dfee29$export$2e2bcd8739ae039 = $f0374d9cd8dfee29$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $79e89c97b0c86ca3$var$getNative(object, key) {
    var value = (0, $f0374d9cd8dfee29$export$2e2bcd8739ae039)(object, key);
    return (0, $a2a18425b5fc87c2$export$2e2bcd8739ae039)(value) ? value : undefined;
}
var $79e89c97b0c86ca3$export$2e2bcd8739ae039 = $79e89c97b0c86ca3$var$getNative;



var $kXc8K = parcelRequire("kXc8K");
/* Built-in method references that are verified to be native. */ var $b8dd1aafcb3f0e01$var$Map = (0, $79e89c97b0c86ca3$export$2e2bcd8739ae039)((0, $kXc8K.default), "Map");
var $b8dd1aafcb3f0e01$export$2e2bcd8739ae039 = $b8dd1aafcb3f0e01$var$Map;



/* Built-in method references that are verified to be native. */ var $022c83246bd72eae$var$nativeCreate = (0, $79e89c97b0c86ca3$export$2e2bcd8739ae039)(Object, "create");
var $022c83246bd72eae$export$2e2bcd8739ae039 = $022c83246bd72eae$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $78ea8c4c2205dd85$var$hashClear() {
    this.__data__ = (0, $022c83246bd72eae$export$2e2bcd8739ae039) ? (0, $022c83246bd72eae$export$2e2bcd8739ae039)(null) : {};
    this.size = 0;
}
var $78ea8c4c2205dd85$export$2e2bcd8739ae039 = $78ea8c4c2205dd85$var$hashClear;


/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $430cbdb768324010$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $430cbdb768324010$export$2e2bcd8739ae039 = $430cbdb768324010$var$hashDelete;



/** Used to stand-in for `undefined` hash values. */ var $f404cef020a9d7ee$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $f404cef020a9d7ee$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f404cef020a9d7ee$var$hasOwnProperty = $f404cef020a9d7ee$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $f404cef020a9d7ee$var$hashGet(key) {
    var data = this.__data__;
    if (0, $022c83246bd72eae$export$2e2bcd8739ae039) {
        var result = data[key];
        return result === $f404cef020a9d7ee$var$HASH_UNDEFINED ? undefined : result;
    }
    return $f404cef020a9d7ee$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $f404cef020a9d7ee$export$2e2bcd8739ae039 = $f404cef020a9d7ee$var$hashGet;



/** Used for built-in method references. */ var $d87d03375db964c8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d87d03375db964c8$var$hasOwnProperty = $d87d03375db964c8$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d87d03375db964c8$var$hashHas(key) {
    var data = this.__data__;
    return (0, $022c83246bd72eae$export$2e2bcd8739ae039) ? data[key] !== undefined : $d87d03375db964c8$var$hasOwnProperty.call(data, key);
}
var $d87d03375db964c8$export$2e2bcd8739ae039 = $d87d03375db964c8$var$hashHas;



/** Used to stand-in for `undefined` hash values. */ var $ec95ea872d077b11$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $ec95ea872d077b11$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $022c83246bd72eae$export$2e2bcd8739ae039) && value === undefined ? $ec95ea872d077b11$var$HASH_UNDEFINED : value;
    return this;
}
var $ec95ea872d077b11$export$2e2bcd8739ae039 = $ec95ea872d077b11$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f5680223254b277f$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$f5680223254b277f$var$Hash.prototype.clear = (0, $78ea8c4c2205dd85$export$2e2bcd8739ae039);
$f5680223254b277f$var$Hash.prototype["delete"] = (0, $430cbdb768324010$export$2e2bcd8739ae039);
$f5680223254b277f$var$Hash.prototype.get = (0, $f404cef020a9d7ee$export$2e2bcd8739ae039);
$f5680223254b277f$var$Hash.prototype.has = (0, $d87d03375db964c8$export$2e2bcd8739ae039);
$f5680223254b277f$var$Hash.prototype.set = (0, $ec95ea872d077b11$export$2e2bcd8739ae039);
var $f5680223254b277f$export$2e2bcd8739ae039 = $f5680223254b277f$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $be04a85280ce0043$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new (0, $f5680223254b277f$export$2e2bcd8739ae039),
        "map": new ((0, $b8dd1aafcb3f0e01$export$2e2bcd8739ae039) || (0, $4598850b67add3e0$export$2e2bcd8739ae039)),
        "string": new (0, $f5680223254b277f$export$2e2bcd8739ae039)
    };
}
var $be04a85280ce0043$export$2e2bcd8739ae039 = $be04a85280ce0043$var$mapCacheClear;


/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $35de7e4656ab36a5$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var $35de7e4656ab36a5$export$2e2bcd8739ae039 = $35de7e4656ab36a5$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $4ae2505a06919369$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $35de7e4656ab36a5$export$2e2bcd8739ae039)(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var $4ae2505a06919369$export$2e2bcd8739ae039 = $4ae2505a06919369$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $79c3b88b744d47b5$var$mapCacheDelete(key) {
    var result = (0, $4ae2505a06919369$export$2e2bcd8739ae039)(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $79c3b88b744d47b5$export$2e2bcd8739ae039 = $79c3b88b744d47b5$var$mapCacheDelete;



/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $45541949b772143c$var$mapCacheGet(key) {
    return (0, $4ae2505a06919369$export$2e2bcd8739ae039)(this, key).get(key);
}
var $45541949b772143c$export$2e2bcd8739ae039 = $45541949b772143c$var$mapCacheGet;



/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $429713c95275be1d$var$mapCacheHas(key) {
    return (0, $4ae2505a06919369$export$2e2bcd8739ae039)(this, key).has(key);
}
var $429713c95275be1d$export$2e2bcd8739ae039 = $429713c95275be1d$var$mapCacheHas;



/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $df23ce2ad560509b$var$mapCacheSet(key, value) {
    var data = (0, $4ae2505a06919369$export$2e2bcd8739ae039)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $df23ce2ad560509b$export$2e2bcd8739ae039 = $df23ce2ad560509b$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $3cb6dd6160304c5d$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$3cb6dd6160304c5d$var$MapCache.prototype.clear = (0, $be04a85280ce0043$export$2e2bcd8739ae039);
$3cb6dd6160304c5d$var$MapCache.prototype["delete"] = (0, $79c3b88b744d47b5$export$2e2bcd8739ae039);
$3cb6dd6160304c5d$var$MapCache.prototype.get = (0, $45541949b772143c$export$2e2bcd8739ae039);
$3cb6dd6160304c5d$var$MapCache.prototype.has = (0, $429713c95275be1d$export$2e2bcd8739ae039);
$3cb6dd6160304c5d$var$MapCache.prototype.set = (0, $df23ce2ad560509b$export$2e2bcd8739ae039);
var $3cb6dd6160304c5d$export$2e2bcd8739ae039 = $3cb6dd6160304c5d$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $2b711926512d0eb2$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $2b711926512d0eb2$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $4598850b67add3e0$export$2e2bcd8739ae039)) {
        var pairs = data.__data__;
        if (!(0, $b8dd1aafcb3f0e01$export$2e2bcd8739ae039) || pairs.length < $2b711926512d0eb2$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $3cb6dd6160304c5d$export$2e2bcd8739ae039)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $2b711926512d0eb2$export$2e2bcd8739ae039 = $2b711926512d0eb2$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $08752089301ca501$var$Stack(entries) {
    var data = this.__data__ = new (0, $4598850b67add3e0$export$2e2bcd8739ae039)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$08752089301ca501$var$Stack.prototype.clear = (0, $309c86918baf6ec0$export$2e2bcd8739ae039);
$08752089301ca501$var$Stack.prototype["delete"] = (0, $4a2560280acb844a$export$2e2bcd8739ae039);
$08752089301ca501$var$Stack.prototype.get = (0, $7e1e2b0d7663fa1d$export$2e2bcd8739ae039);
$08752089301ca501$var$Stack.prototype.has = (0, $b44dce38f0f76986$export$2e2bcd8739ae039);
$08752089301ca501$var$Stack.prototype.set = (0, $2b711926512d0eb2$export$2e2bcd8739ae039);
var $08752089301ca501$export$2e2bcd8739ae039 = $08752089301ca501$var$Stack;



var $afc32e5caed41e91$var$defineProperty = function() {
    try {
        var func = (0, $79e89c97b0c86ca3$export$2e2bcd8739ae039)(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
var $afc32e5caed41e91$export$2e2bcd8739ae039 = $afc32e5caed41e91$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $4731eebc7260a307$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && (0, $afc32e5caed41e91$export$2e2bcd8739ae039)) (0, $afc32e5caed41e91$export$2e2bcd8739ae039)(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
var $4731eebc7260a307$export$2e2bcd8739ae039 = $4731eebc7260a307$var$baseAssignValue;



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $612845709e34cf50$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !(0, $42b14d7baa041ed1$export$2e2bcd8739ae039)(object[key], value) || value === undefined && !(key in object)) (0, $4731eebc7260a307$export$2e2bcd8739ae039)(object, key, value);
}
var $612845709e34cf50$export$2e2bcd8739ae039 = $612845709e34cf50$var$assignMergeValue;


/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $03e53dffeeafc139$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
var $03e53dffeeafc139$export$2e2bcd8739ae039 = $03e53dffeeafc139$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $dd8fc41a07806065$var$baseFor = (0, $03e53dffeeafc139$export$2e2bcd8739ae039)();
var $dd8fc41a07806065$export$2e2bcd8739ae039 = $dd8fc41a07806065$var$baseFor;




var $fkQSb = parcelRequire("fkQSb");

var $kXc8K = parcelRequire("kXc8K");
/** Built-in value references. */ var $bc55c02022434aed$var$Uint8Array = (0, $kXc8K.default).Uint8Array;
var $bc55c02022434aed$export$2e2bcd8739ae039 = $bc55c02022434aed$var$Uint8Array;


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $2c521181fc499039$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $bc55c02022434aed$export$2e2bcd8739ae039)(result).set(new (0, $bc55c02022434aed$export$2e2bcd8739ae039)(arrayBuffer));
    return result;
}
var $2c521181fc499039$export$2e2bcd8739ae039 = $2c521181fc499039$var$cloneArrayBuffer;


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $bf42482155a2ca19$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $2c521181fc499039$export$2e2bcd8739ae039)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $bf42482155a2ca19$export$2e2bcd8739ae039 = $bf42482155a2ca19$var$cloneTypedArray;


/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $000d51666d223e1d$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $000d51666d223e1d$export$2e2bcd8739ae039 = $000d51666d223e1d$var$copyArray;



/** Built-in value references. */ var $2b95593c792cb8eb$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $2b95593c792cb8eb$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $ec27e620fc242dbd$export$2e2bcd8739ae039)(proto)) return {};
        if ($2b95593c792cb8eb$var$objectCreate) return $2b95593c792cb8eb$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $2b95593c792cb8eb$export$2e2bcd8739ae039 = $2b95593c792cb8eb$var$baseCreate;


/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $54ef5539b320309d$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $54ef5539b320309d$export$2e2bcd8739ae039 = $54ef5539b320309d$var$overArg;


/** Built-in value references. */ var $86c8fae5fac0f6c1$var$getPrototype = (0, $54ef5539b320309d$export$2e2bcd8739ae039)(Object.getPrototypeOf, Object);
var $86c8fae5fac0f6c1$export$2e2bcd8739ae039 = $86c8fae5fac0f6c1$var$getPrototype;


/** Used for built-in method references. */ var $6f5bba4895c48efd$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $6f5bba4895c48efd$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $6f5bba4895c48efd$var$objectProto;
    return value === proto;
}
var $6f5bba4895c48efd$export$2e2bcd8739ae039 = $6f5bba4895c48efd$var$isPrototype;


/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $7a6c7ea2ebc29f0b$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !(0, $6f5bba4895c48efd$export$2e2bcd8739ae039)(object) ? (0, $2b95593c792cb8eb$export$2e2bcd8739ae039)((0, $86c8fae5fac0f6c1$export$2e2bcd8739ae039)(object)) : {};
}
var $7a6c7ea2ebc29f0b$export$2e2bcd8739ae039 = $7a6c7ea2ebc29f0b$var$initCloneObject;



/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $2b336945ce04d6f5$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $2b336945ce04d6f5$export$2e2bcd8739ae039 = $2b336945ce04d6f5$var$isObjectLike;


/** `Object#toString` result references. */ var $a5ed7497565306cc$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $a5ed7497565306cc$var$baseIsArguments(value) {
    return (0, $2b336945ce04d6f5$export$2e2bcd8739ae039)(value) && (0, $d246294e778b9804$export$2e2bcd8739ae039)(value) == $a5ed7497565306cc$var$argsTag;
}
var $a5ed7497565306cc$export$2e2bcd8739ae039 = $a5ed7497565306cc$var$baseIsArguments;



/** Used for built-in method references. */ var $5a45a1a3c9961159$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5a45a1a3c9961159$var$hasOwnProperty = $5a45a1a3c9961159$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $5a45a1a3c9961159$var$propertyIsEnumerable = $5a45a1a3c9961159$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $5a45a1a3c9961159$var$isArguments = (0, $a5ed7497565306cc$export$2e2bcd8739ae039)(function() {
    return arguments;
}()) ? (0, $a5ed7497565306cc$export$2e2bcd8739ae039) : function(value) {
    return (0, $2b336945ce04d6f5$export$2e2bcd8739ae039)(value) && $5a45a1a3c9961159$var$hasOwnProperty.call(value, "callee") && !$5a45a1a3c9961159$var$propertyIsEnumerable.call(value, "callee");
};
var $5a45a1a3c9961159$export$2e2bcd8739ae039 = $5a45a1a3c9961159$var$isArguments;


/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $b759d94d9c1fbe90$var$isArray = Array.isArray;
var $b759d94d9c1fbe90$export$2e2bcd8739ae039 = $b759d94d9c1fbe90$var$isArray;



/** Used as references for various `Number` constants. */ var $d120ce1abe70411f$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $d120ce1abe70411f$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $d120ce1abe70411f$var$MAX_SAFE_INTEGER;
}
var $d120ce1abe70411f$export$2e2bcd8739ae039 = $d120ce1abe70411f$var$isLength;


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $bb78877ef87aa1da$var$isArrayLike(value) {
    return value != null && (0, $d120ce1abe70411f$export$2e2bcd8739ae039)(value.length) && !(0, $b8862f6ed7008e89$export$2e2bcd8739ae039)(value);
}
var $bb78877ef87aa1da$export$2e2bcd8739ae039 = $bb78877ef87aa1da$var$isArrayLike;



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $ca69ae96aa010e8b$var$isArrayLikeObject(value) {
    return (0, $2b336945ce04d6f5$export$2e2bcd8739ae039)(value) && (0, $bb78877ef87aa1da$export$2e2bcd8739ae039)(value);
}
var $ca69ae96aa010e8b$export$2e2bcd8739ae039 = $ca69ae96aa010e8b$var$isArrayLikeObject;



var $2wMWH = parcelRequire("2wMWH");





/** `Object#toString` result references. */ var $7778cddcaf21c66e$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $7778cddcaf21c66e$var$funcProto = Function.prototype, $7778cddcaf21c66e$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $7778cddcaf21c66e$var$funcToString = $7778cddcaf21c66e$var$funcProto.toString;
/** Used to check objects for own properties. */ var $7778cddcaf21c66e$var$hasOwnProperty = $7778cddcaf21c66e$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $7778cddcaf21c66e$var$objectCtorString = $7778cddcaf21c66e$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $7778cddcaf21c66e$var$isPlainObject(value) {
    if (!(0, $2b336945ce04d6f5$export$2e2bcd8739ae039)(value) || (0, $d246294e778b9804$export$2e2bcd8739ae039)(value) != $7778cddcaf21c66e$var$objectTag) return false;
    var proto = (0, $86c8fae5fac0f6c1$export$2e2bcd8739ae039)(value);
    if (proto === null) return true;
    var Ctor = $7778cddcaf21c66e$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $7778cddcaf21c66e$var$funcToString.call(Ctor) == $7778cddcaf21c66e$var$objectCtorString;
}
var $7778cddcaf21c66e$export$2e2bcd8739ae039 = $7778cddcaf21c66e$var$isPlainObject;





/** `Object#toString` result references. */ var $6be798df06f9e695$var$argsTag = "[object Arguments]", $6be798df06f9e695$var$arrayTag = "[object Array]", $6be798df06f9e695$var$boolTag = "[object Boolean]", $6be798df06f9e695$var$dateTag = "[object Date]", $6be798df06f9e695$var$errorTag = "[object Error]", $6be798df06f9e695$var$funcTag = "[object Function]", $6be798df06f9e695$var$mapTag = "[object Map]", $6be798df06f9e695$var$numberTag = "[object Number]", $6be798df06f9e695$var$objectTag = "[object Object]", $6be798df06f9e695$var$regexpTag = "[object RegExp]", $6be798df06f9e695$var$setTag = "[object Set]", $6be798df06f9e695$var$stringTag = "[object String]", $6be798df06f9e695$var$weakMapTag = "[object WeakMap]";
var $6be798df06f9e695$var$arrayBufferTag = "[object ArrayBuffer]", $6be798df06f9e695$var$dataViewTag = "[object DataView]", $6be798df06f9e695$var$float32Tag = "[object Float32Array]", $6be798df06f9e695$var$float64Tag = "[object Float64Array]", $6be798df06f9e695$var$int8Tag = "[object Int8Array]", $6be798df06f9e695$var$int16Tag = "[object Int16Array]", $6be798df06f9e695$var$int32Tag = "[object Int32Array]", $6be798df06f9e695$var$uint8Tag = "[object Uint8Array]", $6be798df06f9e695$var$uint8ClampedTag = "[object Uint8ClampedArray]", $6be798df06f9e695$var$uint16Tag = "[object Uint16Array]", $6be798df06f9e695$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $6be798df06f9e695$var$typedArrayTags = {};
$6be798df06f9e695$var$typedArrayTags[$6be798df06f9e695$var$float32Tag] = $6be798df06f9e695$var$typedArrayTags[$6be798df06f9e695$var$float64Tag] = $6be798df06f9e695$var$typedArrayTags[$6be798df06f9e695$var$int8Tag] = $6be798df06f9e695$var$typedArrayTags[$6be798df06f9e695$var$int16Tag] = $6be798df06f9e695$var$typedArrayTags[$6be798df06f9e695$var$int32Tag] = $6be798df06f9e695$var$typedArrayTags[$6be798df06f9e695$var$uint8Tag] = $6be798df06f9e695$var$typedArrayTags[$6be798df06f9e695$var$uint8ClampedTag] = $6be798df06f9e695$var$typedArrayTags[$6be798df06f9e695$var$uint16Tag] = $6be798df06f9e695$var$typedArrayTags[$6be798df06f9e695$var$uint32Tag] = true;
$6be798df06f9e695$var$typedArrayTags[$6be798df06f9e695$var$argsTag] = $6be798df06f9e695$var$typedArrayTags[$6be798df06f9e695$var$arrayTag] = $6be798df06f9e695$var$typedArrayTags[$6be798df06f9e695$var$arrayBufferTag] = $6be798df06f9e695$var$typedArrayTags[$6be798df06f9e695$var$boolTag] = $6be798df06f9e695$var$typedArrayTags[$6be798df06f9e695$var$dataViewTag] = $6be798df06f9e695$var$typedArrayTags[$6be798df06f9e695$var$dateTag] = $6be798df06f9e695$var$typedArrayTags[$6be798df06f9e695$var$errorTag] = $6be798df06f9e695$var$typedArrayTags[$6be798df06f9e695$var$funcTag] = $6be798df06f9e695$var$typedArrayTags[$6be798df06f9e695$var$mapTag] = $6be798df06f9e695$var$typedArrayTags[$6be798df06f9e695$var$numberTag] = $6be798df06f9e695$var$typedArrayTags[$6be798df06f9e695$var$objectTag] = $6be798df06f9e695$var$typedArrayTags[$6be798df06f9e695$var$regexpTag] = $6be798df06f9e695$var$typedArrayTags[$6be798df06f9e695$var$setTag] = $6be798df06f9e695$var$typedArrayTags[$6be798df06f9e695$var$stringTag] = $6be798df06f9e695$var$typedArrayTags[$6be798df06f9e695$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $6be798df06f9e695$var$baseIsTypedArray(value) {
    return (0, $2b336945ce04d6f5$export$2e2bcd8739ae039)(value) && (0, $d120ce1abe70411f$export$2e2bcd8739ae039)(value.length) && !!$6be798df06f9e695$var$typedArrayTags[(0, $d246294e778b9804$export$2e2bcd8739ae039)(value)];
}
var $6be798df06f9e695$export$2e2bcd8739ae039 = $6be798df06f9e695$var$baseIsTypedArray;


/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $3a9fa63dca0cce91$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $3a9fa63dca0cce91$export$2e2bcd8739ae039 = $3a9fa63dca0cce91$var$baseUnary;



var $gIKSS = parcelRequire("gIKSS");
/* Node.js helper references. */ var $1d71fc388743cb76$var$nodeIsTypedArray = (0, $gIKSS.default) && (0, $gIKSS.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $1d71fc388743cb76$var$isTypedArray = $1d71fc388743cb76$var$nodeIsTypedArray ? (0, $3a9fa63dca0cce91$export$2e2bcd8739ae039)($1d71fc388743cb76$var$nodeIsTypedArray) : (0, $6be798df06f9e695$export$2e2bcd8739ae039);
var $1d71fc388743cb76$export$2e2bcd8739ae039 = $1d71fc388743cb76$var$isTypedArray;


/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $5a37b525dc67a1ba$var$safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
var $5a37b525dc67a1ba$export$2e2bcd8739ae039 = $5a37b525dc67a1ba$var$safeGet;




/** Used for built-in method references. */ var $a187c2ddfbf10612$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a187c2ddfbf10612$var$hasOwnProperty = $a187c2ddfbf10612$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $a187c2ddfbf10612$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($a187c2ddfbf10612$var$hasOwnProperty.call(object, key) && (0, $42b14d7baa041ed1$export$2e2bcd8739ae039)(objValue, value)) || value === undefined && !(key in object)) (0, $4731eebc7260a307$export$2e2bcd8739ae039)(object, key, value);
}
var $a187c2ddfbf10612$export$2e2bcd8739ae039 = $a187c2ddfbf10612$var$assignValue;



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $3029191873fe4e71$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $4731eebc7260a307$export$2e2bcd8739ae039)(object, key, newValue);
        else (0, $a187c2ddfbf10612$export$2e2bcd8739ae039)(object, key, newValue);
    }
    return object;
}
var $3029191873fe4e71$export$2e2bcd8739ae039 = $3029191873fe4e71$var$copyObject;


/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $729b906eb8566f3f$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $729b906eb8566f3f$export$2e2bcd8739ae039 = $729b906eb8566f3f$var$baseTimes;





var $2wMWH = parcelRequire("2wMWH");
/** Used as references for various `Number` constants. */ var $a593f61a340433a9$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $a593f61a340433a9$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $a593f61a340433a9$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $a593f61a340433a9$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $a593f61a340433a9$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $a593f61a340433a9$export$2e2bcd8739ae039 = $a593f61a340433a9$var$isIndex;



/** Used for built-in method references. */ var $5a462f6231d72885$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5a462f6231d72885$var$hasOwnProperty = $5a462f6231d72885$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $5a462f6231d72885$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $b759d94d9c1fbe90$export$2e2bcd8739ae039)(value), isArg = !isArr && (0, $5a45a1a3c9961159$export$2e2bcd8739ae039)(value), isBuff = !isArr && !isArg && (0, $2wMWH.default)(value), isType = !isArr && !isArg && !isBuff && (0, $1d71fc388743cb76$export$2e2bcd8739ae039)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $729b906eb8566f3f$export$2e2bcd8739ae039)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $5a462f6231d72885$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    (0, $a593f61a340433a9$export$2e2bcd8739ae039)(key, length)))) result.push(key);
    return result;
}
var $5a462f6231d72885$export$2e2bcd8739ae039 = $5a462f6231d72885$var$arrayLikeKeys;




/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $98438f33ae6ac4e1$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $98438f33ae6ac4e1$export$2e2bcd8739ae039 = $98438f33ae6ac4e1$var$nativeKeysIn;


/** Used for built-in method references. */ var $94fa17195d306bd8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $94fa17195d306bd8$var$hasOwnProperty = $94fa17195d306bd8$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $94fa17195d306bd8$var$baseKeysIn(object) {
    if (!(0, $ec27e620fc242dbd$export$2e2bcd8739ae039)(object)) return (0, $98438f33ae6ac4e1$export$2e2bcd8739ae039)(object);
    var isProto = (0, $6f5bba4895c48efd$export$2e2bcd8739ae039)(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$94fa17195d306bd8$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $94fa17195d306bd8$export$2e2bcd8739ae039 = $94fa17195d306bd8$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $b77d8a18f612177f$var$keysIn(object) {
    return (0, $bb78877ef87aa1da$export$2e2bcd8739ae039)(object) ? (0, $5a462f6231d72885$export$2e2bcd8739ae039)(object, true) : (0, $94fa17195d306bd8$export$2e2bcd8739ae039)(object);
}
var $b77d8a18f612177f$export$2e2bcd8739ae039 = $b77d8a18f612177f$var$keysIn;


/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $2c628207f84bf903$var$toPlainObject(value) {
    return (0, $3029191873fe4e71$export$2e2bcd8739ae039)(value, (0, $b77d8a18f612177f$export$2e2bcd8739ae039)(value));
}
var $2c628207f84bf903$export$2e2bcd8739ae039 = $2c628207f84bf903$var$toPlainObject;


/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $c0aa01a29d839a47$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = (0, $5a37b525dc67a1ba$export$2e2bcd8739ae039)(object, key), srcValue = (0, $5a37b525dc67a1ba$export$2e2bcd8739ae039)(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        (0, $612845709e34cf50$export$2e2bcd8739ae039)(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = (0, $b759d94d9c1fbe90$export$2e2bcd8739ae039)(srcValue), isBuff = !isArr && (0, $2wMWH.default)(srcValue), isTyped = !isArr && !isBuff && (0, $1d71fc388743cb76$export$2e2bcd8739ae039)(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ((0, $b759d94d9c1fbe90$export$2e2bcd8739ae039)(objValue)) newValue = objValue;
            else if ((0, $ca69ae96aa010e8b$export$2e2bcd8739ae039)(objValue)) newValue = (0, $000d51666d223e1d$export$2e2bcd8739ae039)(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = (0, $fkQSb.default)(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = (0, $bf42482155a2ca19$export$2e2bcd8739ae039)(srcValue, true);
            } else newValue = [];
        } else if ((0, $7778cddcaf21c66e$export$2e2bcd8739ae039)(srcValue) || (0, $5a45a1a3c9961159$export$2e2bcd8739ae039)(srcValue)) {
            newValue = objValue;
            if ((0, $5a45a1a3c9961159$export$2e2bcd8739ae039)(objValue)) newValue = (0, $2c628207f84bf903$export$2e2bcd8739ae039)(objValue);
            else if (!(0, $ec27e620fc242dbd$export$2e2bcd8739ae039)(objValue) || (0, $b8862f6ed7008e89$export$2e2bcd8739ae039)(objValue)) newValue = (0, $7a6c7ea2ebc29f0b$export$2e2bcd8739ae039)(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    (0, $612845709e34cf50$export$2e2bcd8739ae039)(object, key, newValue);
}
var $c0aa01a29d839a47$export$2e2bcd8739ae039 = $c0aa01a29d839a47$var$baseMergeDeep;





/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $dfd64f237aed525c$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    (0, $dd8fc41a07806065$export$2e2bcd8739ae039)(source, function(srcValue, key) {
        stack || (stack = new (0, $08752089301ca501$export$2e2bcd8739ae039));
        if ((0, $ec27e620fc242dbd$export$2e2bcd8739ae039)(srcValue)) (0, $c0aa01a29d839a47$export$2e2bcd8739ae039)(object, source, key, srcIndex, $dfd64f237aed525c$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer((0, $5a37b525dc67a1ba$export$2e2bcd8739ae039)(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            (0, $612845709e34cf50$export$2e2bcd8739ae039)(object, key, newValue);
        }
    }, (0, $b77d8a18f612177f$export$2e2bcd8739ae039));
}
var $dfd64f237aed525c$export$2e2bcd8739ae039 = $dfd64f237aed525c$var$baseMerge;


/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $887eb084408f9cca$var$identity(value) {
    return value;
}
var $887eb084408f9cca$export$2e2bcd8739ae039 = $887eb084408f9cca$var$identity;


/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $e2dcfa7a97b844a7$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
var $e2dcfa7a97b844a7$export$2e2bcd8739ae039 = $e2dcfa7a97b844a7$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $1daced388da4040f$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $1daced388da4040f$var$overRest(func, start, transform) {
    start = $1daced388da4040f$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $1daced388da4040f$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, $e2dcfa7a97b844a7$export$2e2bcd8739ae039)(func, this, otherArgs);
    };
}
var $1daced388da4040f$export$2e2bcd8739ae039 = $1daced388da4040f$var$overRest;


/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $f1876446ce597b0b$var$constant(value) {
    return function() {
        return value;
    };
}
var $f1876446ce597b0b$export$2e2bcd8739ae039 = $f1876446ce597b0b$var$constant;




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $01b972ad4bda9c17$var$baseSetToString = !(0, $afc32e5caed41e91$export$2e2bcd8739ae039) ? (0, $887eb084408f9cca$export$2e2bcd8739ae039) : function(func, string) {
    return (0, $afc32e5caed41e91$export$2e2bcd8739ae039)(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": (0, $f1876446ce597b0b$export$2e2bcd8739ae039)(string),
        "writable": true
    });
};
var $01b972ad4bda9c17$export$2e2bcd8739ae039 = $01b972ad4bda9c17$var$baseSetToString;


/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $08929c9cd1c388a7$var$HOT_COUNT = 800, $08929c9cd1c388a7$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $08929c9cd1c388a7$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $08929c9cd1c388a7$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $08929c9cd1c388a7$var$nativeNow(), remaining = $08929c9cd1c388a7$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $08929c9cd1c388a7$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
var $08929c9cd1c388a7$export$2e2bcd8739ae039 = $08929c9cd1c388a7$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $2d6129d0fe7499cb$var$setToString = (0, $08929c9cd1c388a7$export$2e2bcd8739ae039)((0, $01b972ad4bda9c17$export$2e2bcd8739ae039));
var $2d6129d0fe7499cb$export$2e2bcd8739ae039 = $2d6129d0fe7499cb$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $40578b0e4375a21a$var$baseRest(func, start) {
    return (0, $2d6129d0fe7499cb$export$2e2bcd8739ae039)((0, $1daced388da4040f$export$2e2bcd8739ae039)(func, start, (0, $887eb084408f9cca$export$2e2bcd8739ae039)), func + "");
}
var $40578b0e4375a21a$export$2e2bcd8739ae039 = $40578b0e4375a21a$var$baseRest;






/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $db7fb9ff856cdfba$var$isIterateeCall(value, index, object) {
    if (!(0, $ec27e620fc242dbd$export$2e2bcd8739ae039)(object)) return false;
    var type = typeof index;
    if (type == "number" ? (0, $bb78877ef87aa1da$export$2e2bcd8739ae039)(object) && (0, $a593f61a340433a9$export$2e2bcd8739ae039)(index, object.length) : type == "string" && index in object) return (0, $42b14d7baa041ed1$export$2e2bcd8739ae039)(object[index], value);
    return false;
}
var $db7fb9ff856cdfba$export$2e2bcd8739ae039 = $db7fb9ff856cdfba$var$isIterateeCall;


/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $0ef9adb6797f9cf4$var$createAssigner(assigner) {
    return (0, $40578b0e4375a21a$export$2e2bcd8739ae039)(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && (0, $db7fb9ff856cdfba$export$2e2bcd8739ae039)(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
var $0ef9adb6797f9cf4$export$2e2bcd8739ae039 = $0ef9adb6797f9cf4$var$createAssigner;


/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $248c37d10097eba3$var$merge = (0, $0ef9adb6797f9cf4$export$2e2bcd8739ae039)(function(object, source, srcIndex) {
    (0, $dfd64f237aed525c$export$2e2bcd8739ae039)(object, source, srcIndex);
});
var $248c37d10097eba3$export$2e2bcd8739ae039 = $248c37d10097eba3$var$merge;


var $741d377d9dbb89cf$export$5eec0980ed568dae = function Raised(_ref) {
    var zDepth = _ref.zDepth, radius = _ref.radius, background = _ref.background, children = _ref.children, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))((0, $248c37d10097eba3$export$2e2bcd8739ae039)({
        "default": {
            wrap: {
                position: "relative",
                display: "inline-block"
            },
            content: {
                position: "relative"
            },
            bg: {
                absolute: "0px 0px 0px 0px",
                boxShadow: "0 " + zDepth + "px " + zDepth * 4 + "px rgba(0,0,0,.24)",
                borderRadius: radius,
                background: background
            }
        },
        "zDepth-0": {
            bg: {
                boxShadow: "none"
            }
        },
        "zDepth-1": {
            bg: {
                boxShadow: "0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)"
            }
        },
        "zDepth-2": {
            bg: {
                boxShadow: "0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)"
            }
        },
        "zDepth-3": {
            bg: {
                boxShadow: "0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)"
            }
        },
        "zDepth-4": {
            bg: {
                boxShadow: "0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)"
            }
        },
        "zDepth-5": {
            bg: {
                boxShadow: "0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)"
            }
        },
        "square": {
            bg: {
                borderRadius: "0"
            }
        },
        "circle": {
            bg: {
                borderRadius: "50%"
            }
        }
    }, passedStyles), {
        "zDepth-1": zDepth === 1
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.wrap
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.bg
    }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.content
    }, children));
};
$741d377d9dbb89cf$export$5eec0980ed568dae.propTypes = {
    background: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).string,
    zDepth: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).oneOf([
        0,
        1,
        2,
        3,
        4,
        5
    ]),
    radius: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).number,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).object
};
$741d377d9dbb89cf$export$5eec0980ed568dae.defaultProps = {
    background: "#fff",
    zDepth: 1,
    radius: 2,
    styles: {}
};
var $741d377d9dbb89cf$export$2e2bcd8739ae039 = $741d377d9dbb89cf$export$5eec0980ed568dae;



var $jC8Vy = parcelRequire("jC8Vy");



var $kXc8K = parcelRequire("kXc8K");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $f558be9cc1673e81$var$now = function() {
    return (0, $kXc8K.default).Date.now();
};
var $f558be9cc1673e81$export$2e2bcd8739ae039 = $f558be9cc1673e81$var$now;


/** Used to match a single whitespace character. */ var $3947eb48a6750779$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $3947eb48a6750779$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $3947eb48a6750779$var$reWhitespace.test(string.charAt(index)));
    return index;
}
var $3947eb48a6750779$export$2e2bcd8739ae039 = $3947eb48a6750779$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $7a31e25f975e83ce$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $7a31e25f975e83ce$var$baseTrim(string) {
    return string ? string.slice(0, (0, $3947eb48a6750779$export$2e2bcd8739ae039)(string) + 1).replace($7a31e25f975e83ce$var$reTrimStart, "") : string;
}
var $7a31e25f975e83ce$export$2e2bcd8739ae039 = $7a31e25f975e83ce$var$baseTrim;





/** `Object#toString` result references. */ var $782455e108dc8bc3$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $782455e108dc8bc3$var$isSymbol(value) {
    return typeof value == "symbol" || (0, $2b336945ce04d6f5$export$2e2bcd8739ae039)(value) && (0, $d246294e778b9804$export$2e2bcd8739ae039)(value) == $782455e108dc8bc3$var$symbolTag;
}
var $782455e108dc8bc3$export$2e2bcd8739ae039 = $782455e108dc8bc3$var$isSymbol;


/** Used as references for various `Number` constants. */ var $ab67272c870cfd41$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $ab67272c870cfd41$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $ab67272c870cfd41$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $ab67272c870cfd41$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $ab67272c870cfd41$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $ab67272c870cfd41$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ((0, $782455e108dc8bc3$export$2e2bcd8739ae039)(value)) return $ab67272c870cfd41$var$NAN;
    if ((0, $ec27e620fc242dbd$export$2e2bcd8739ae039)(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = (0, $ec27e620fc242dbd$export$2e2bcd8739ae039)(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = (0, $7a31e25f975e83ce$export$2e2bcd8739ae039)(value);
    var isBinary = $ab67272c870cfd41$var$reIsBinary.test(value);
    return isBinary || $ab67272c870cfd41$var$reIsOctal.test(value) ? $ab67272c870cfd41$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $ab67272c870cfd41$var$reIsBadHex.test(value) ? $ab67272c870cfd41$var$NAN : +value;
}
var $ab67272c870cfd41$export$2e2bcd8739ae039 = $ab67272c870cfd41$var$toNumber;


/** Error message constants. */ var $786c65489b59f27c$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $786c65489b59f27c$var$nativeMax = Math.max, $786c65489b59f27c$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $786c65489b59f27c$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($786c65489b59f27c$var$FUNC_ERROR_TEXT);
    wait = (0, $ab67272c870cfd41$export$2e2bcd8739ae039)(wait) || 0;
    if ((0, $ec27e620fc242dbd$export$2e2bcd8739ae039)(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $786c65489b59f27c$var$nativeMax((0, $ab67272c870cfd41$export$2e2bcd8739ae039)(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $786c65489b59f27c$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = (0, $f558be9cc1673e81$export$2e2bcd8739ae039)();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge((0, $f558be9cc1673e81$export$2e2bcd8739ae039)());
    }
    function debounced() {
        var time = (0, $f558be9cc1673e81$export$2e2bcd8739ae039)(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $786c65489b59f27c$export$2e2bcd8739ae039 = $786c65489b59f27c$var$debounce;



/** Error message constants. */ var $b9ef44ca6fe6a442$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $b9ef44ca6fe6a442$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($b9ef44ca6fe6a442$var$FUNC_ERROR_TEXT);
    if ((0, $ec27e620fc242dbd$export$2e2bcd8739ae039)(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return (0, $786c65489b59f27c$export$2e2bcd8739ae039)(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
var $b9ef44ca6fe6a442$export$2e2bcd8739ae039 = $b9ef44ca6fe6a442$var$throttle;


var $36cefa3047aecda3$export$a056a977bf6a9a3c = function calculateChange(e, hsl, container) {
    var _container$getBoundin = container.getBoundingClientRect(), containerWidth = _container$getBoundin.width, containerHeight = _container$getBoundin.height;
    var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (left < 0) left = 0;
    else if (left > containerWidth) left = containerWidth;
    if (top < 0) top = 0;
    else if (top > containerHeight) top = containerHeight;
    var saturation = left / containerWidth;
    var bright = 1 - top / containerHeight;
    return {
        h: hsl.h,
        s: saturation,
        v: bright,
        a: hsl.a,
        source: "hsv"
    };
};


var $97e77a17c0f73a8b$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $97e77a17c0f73a8b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $97e77a17c0f73a8b$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $97e77a17c0f73a8b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $97e77a17c0f73a8b$export$c4dbe12ffaee3c8e = function(_ref) {
    $97e77a17c0f73a8b$var$_inherits(Saturation, _ref);
    function Saturation(props) {
        $97e77a17c0f73a8b$var$_classCallCheck(this, Saturation);
        var _this = $97e77a17c0f73a8b$var$_possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));
        _this.handleChange = function(e) {
            typeof _this.props.onChange === "function" && _this.throttle(_this.props.onChange, $36cefa3047aecda3$export$a056a977bf6a9a3c(e, _this.props.hsl, _this.container), e);
        };
        _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            var renderWindow = _this.getContainerRenderWindow();
            renderWindow.addEventListener("mousemove", _this.handleChange);
            renderWindow.addEventListener("mouseup", _this.handleMouseUp);
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.throttle = (0, $b9ef44ca6fe6a442$export$2e2bcd8739ae039)(function(fn, data, e) {
            fn(data, e);
        }, 50);
        return _this;
    }
    $97e77a17c0f73a8b$var$_createClass(Saturation, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.throttle.cancel();
                this.unbindEventListeners();
            }
        },
        {
            key: "getContainerRenderWindow",
            value: function getContainerRenderWindow() {
                var container = this.container;
                var renderWindow = window;
                while(!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow)renderWindow = renderWindow.parent;
                return renderWindow;
            }
        },
        {
            key: "unbindEventListeners",
            value: function unbindEventListeners() {
                var renderWindow = this.getContainerRenderWindow();
                renderWindow.removeEventListener("mousemove", this.handleChange);
                renderWindow.removeEventListener("mouseup", this.handleMouseUp);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _ref2 = this.props.style || {}, color = _ref2.color, white = _ref2.white, black = _ref2.black, pointer = _ref2.pointer, circle = _ref2.circle;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))({
                    "default": {
                        color: {
                            absolute: "0px 0px 0px 0px",
                            background: "hsl(" + this.props.hsl.h + ",100%, 50%)",
                            borderRadius: this.props.radius
                        },
                        white: {
                            absolute: "0px 0px 0px 0px",
                            borderRadius: this.props.radius
                        },
                        black: {
                            absolute: "0px 0px 0px 0px",
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: "absolute",
                            top: -(this.props.hsv.v * 100) + 100 + "%",
                            left: this.props.hsv.s * 100 + "%",
                            cursor: "default"
                        },
                        circle: {
                            width: "4px",
                            height: "4px",
                            boxShadow: "0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)",
                            borderRadius: "50%",
                            cursor: "hand",
                            transform: "translate(-2px, -2px)"
                        }
                    },
                    "custom": {
                        color: color,
                        white: white,
                        black: black,
                        pointer: pointer,
                        circle: circle
                    }
                }, {
                    "custom": !!this.props.style
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.color,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("style", null, "\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        "), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.white,
                    className: "saturation-white"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.black,
                    className: "saturation-black"
                }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.pointer
                }, this.props.pointer ? (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement(this.props.pointer, this.props) : (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.circle
                }))));
            }
        }
    ]);
    return Saturation;
}((0, $jC8Vy.PureComponent) || (0, $jC8Vy.Component));
var $97e77a17c0f73a8b$export$2e2bcd8739ae039 = $97e77a17c0f73a8b$export$c4dbe12ffaee3c8e;



var $jC8Vy = parcelRequire("jC8Vy");

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $83b090e712c3e475$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $83b090e712c3e475$export$2e2bcd8739ae039 = $83b090e712c3e475$var$arrayEach;






/* Built-in method references for those with the same name as other `lodash` methods. */ var $455996dcbaab18c2$var$nativeKeys = (0, $54ef5539b320309d$export$2e2bcd8739ae039)(Object.keys, Object);
var $455996dcbaab18c2$export$2e2bcd8739ae039 = $455996dcbaab18c2$var$nativeKeys;


/** Used for built-in method references. */ var $1e21696186ebf522$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1e21696186ebf522$var$hasOwnProperty = $1e21696186ebf522$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $1e21696186ebf522$var$baseKeys(object) {
    if (!(0, $6f5bba4895c48efd$export$2e2bcd8739ae039)(object)) return (0, $455996dcbaab18c2$export$2e2bcd8739ae039)(object);
    var result = [];
    for(var key in Object(object))if ($1e21696186ebf522$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
var $1e21696186ebf522$export$2e2bcd8739ae039 = $1e21696186ebf522$var$baseKeys;



/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $8a7e0c9ba0b2489f$var$keys(object) {
    return (0, $bb78877ef87aa1da$export$2e2bcd8739ae039)(object) ? (0, $5a462f6231d72885$export$2e2bcd8739ae039)(object) : (0, $1e21696186ebf522$export$2e2bcd8739ae039)(object);
}
var $8a7e0c9ba0b2489f$export$2e2bcd8739ae039 = $8a7e0c9ba0b2489f$var$keys;


/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $05c1d9a2b6f9a470$var$baseForOwn(object, iteratee) {
    return object && (0, $dd8fc41a07806065$export$2e2bcd8739ae039)(object, iteratee, (0, $8a7e0c9ba0b2489f$export$2e2bcd8739ae039));
}
var $05c1d9a2b6f9a470$export$2e2bcd8739ae039 = $05c1d9a2b6f9a470$var$baseForOwn;



/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $5a27f5cda600eb21$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!(0, $bb78877ef87aa1da$export$2e2bcd8739ae039)(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
var $5a27f5cda600eb21$export$2e2bcd8739ae039 = $5a27f5cda600eb21$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $33f2d457f4113761$var$baseEach = (0, $5a27f5cda600eb21$export$2e2bcd8739ae039)((0, $05c1d9a2b6f9a470$export$2e2bcd8739ae039));
var $33f2d457f4113761$export$2e2bcd8739ae039 = $33f2d457f4113761$var$baseEach;



/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $87307add53b9304e$var$castFunction(value) {
    return typeof value == "function" ? value : (0, $887eb084408f9cca$export$2e2bcd8739ae039);
}
var $87307add53b9304e$export$2e2bcd8739ae039 = $87307add53b9304e$var$castFunction;



/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $b54885b9209d0b2e$var$forEach(collection, iteratee) {
    var func = (0, $b759d94d9c1fbe90$export$2e2bcd8739ae039)(collection) ? (0, $83b090e712c3e475$export$2e2bcd8739ae039) : (0, $33f2d457f4113761$export$2e2bcd8739ae039);
    return func(collection, (0, $87307add53b9304e$export$2e2bcd8739ae039)(iteratee));
}
var $b54885b9209d0b2e$export$2e2bcd8739ae039 = $b54885b9209d0b2e$var$forEach;


// This file is autogenerated. It's used to publish ESM to npm.
function $dfe376b89801a77b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $dfe376b89801a77b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $dfe376b89801a77b$var$_typeof(obj);
}
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License
var $dfe376b89801a77b$var$trimLeft = /^\s+/;
var $dfe376b89801a77b$var$trimRight = /\s+$/;
function $dfe376b89801a77b$export$2e2bcd8739ae039(color, opts) {
    color = color ? color : "";
    opts = opts || {};
    // If input is already a tinycolor, return itself
    if (color instanceof $dfe376b89801a77b$export$2e2bcd8739ae039) return color;
    // If we are called as a function, call using new instead
    if (!(this instanceof $dfe376b89801a77b$export$2e2bcd8739ae039)) return new $dfe376b89801a77b$export$2e2bcd8739ae039(color, opts);
    var rgb = $dfe376b89801a77b$var$inputToRGB(color);
    this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;
    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) this._r = Math.round(this._r);
    if (this._g < 1) this._g = Math.round(this._g);
    if (this._b < 1) this._b = Math.round(this._b);
    this._ok = rgb.ok;
}
$dfe376b89801a77b$export$2e2bcd8739ae039.prototype = {
    isDark: function isDark() {
        return this.getBrightness() < 128;
    },
    isLight: function isLight() {
        return !this.isDark();
    },
    isValid: function isValid() {
        return this._ok;
    },
    getOriginalInput: function getOriginalInput() {
        return this._originalInput;
    },
    getFormat: function getFormat() {
        return this._format;
    },
    getAlpha: function getAlpha() {
        return this._a;
    },
    getBrightness: function getBrightness() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function getLuminance() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r / 255;
        GsRGB = rgb.g / 255;
        BsRGB = rgb.b / 255;
        if (RsRGB <= 0.03928) R = RsRGB / 12.92;
        else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
        if (GsRGB <= 0.03928) G = GsRGB / 12.92;
        else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
        if (BsRGB <= 0.03928) B = BsRGB / 12.92;
        else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    },
    setAlpha: function setAlpha(value) {
        this._a = $dfe376b89801a77b$var$boundAlpha(value);
        this._roundA = Math.round(100 * this._a) / 100;
        return this;
    },
    toHsv: function toHsv() {
        var hsv = $dfe376b89801a77b$var$rgbToHsv(this._r, this._g, this._b);
        return {
            h: hsv.h * 360,
            s: hsv.s,
            v: hsv.v,
            a: this._a
        };
    },
    toHsvString: function toHsvString() {
        var hsv = $dfe376b89801a77b$var$rgbToHsv(this._r, this._g, this._b);
        var h = Math.round(hsv.h * 360), s = Math.round(hsv.s * 100), v = Math.round(hsv.v * 100);
        return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
    },
    toHsl: function toHsl() {
        var hsl = $dfe376b89801a77b$var$rgbToHsl(this._r, this._g, this._b);
        return {
            h: hsl.h * 360,
            s: hsl.s,
            l: hsl.l,
            a: this._a
        };
    },
    toHslString: function toHslString() {
        var hsl = $dfe376b89801a77b$var$rgbToHsl(this._r, this._g, this._b);
        var h = Math.round(hsl.h * 360), s = Math.round(hsl.s * 100), l = Math.round(hsl.l * 100);
        return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
    },
    toHex: function toHex(allow3Char) {
        return $dfe376b89801a77b$var$rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function toHexString(allow3Char) {
        return "#" + this.toHex(allow3Char);
    },
    toHex8: function toHex8(allow4Char) {
        return $dfe376b89801a77b$var$rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function toHex8String(allow4Char) {
        return "#" + this.toHex8(allow4Char);
    },
    toRgb: function toRgb() {
        return {
            r: Math.round(this._r),
            g: Math.round(this._g),
            b: Math.round(this._b),
            a: this._a
        };
    },
    toRgbString: function toRgbString() {
        return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function toPercentageRgb() {
        return {
            r: Math.round($dfe376b89801a77b$var$bound01(this._r, 255) * 100) + "%",
            g: Math.round($dfe376b89801a77b$var$bound01(this._g, 255) * 100) + "%",
            b: Math.round($dfe376b89801a77b$var$bound01(this._b, 255) * 100) + "%",
            a: this._a
        };
    },
    toPercentageRgbString: function toPercentageRgbString() {
        return this._a == 1 ? "rgb(" + Math.round($dfe376b89801a77b$var$bound01(this._r, 255) * 100) + "%, " + Math.round($dfe376b89801a77b$var$bound01(this._g, 255) * 100) + "%, " + Math.round($dfe376b89801a77b$var$bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round($dfe376b89801a77b$var$bound01(this._r, 255) * 100) + "%, " + Math.round($dfe376b89801a77b$var$bound01(this._g, 255) * 100) + "%, " + Math.round($dfe376b89801a77b$var$bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function toName() {
        if (this._a === 0) return "transparent";
        if (this._a < 1) return false;
        return $dfe376b89801a77b$var$hexNames[$dfe376b89801a77b$var$rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function toFilter(secondColor) {
        var hex8String = "#" + $dfe376b89801a77b$var$rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";
        if (secondColor) {
            var s = $dfe376b89801a77b$export$2e2bcd8739ae039(secondColor);
            secondHex8String = "#" + $dfe376b89801a77b$var$rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }
        return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
    },
    toString: function toString(format) {
        var formatSet = !!format;
        format = format || this._format;
        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) return this.toName();
            return this.toRgbString();
        }
        if (format === "rgb") formattedString = this.toRgbString();
        if (format === "prgb") formattedString = this.toPercentageRgbString();
        if (format === "hex" || format === "hex6") formattedString = this.toHexString();
        if (format === "hex3") formattedString = this.toHexString(true);
        if (format === "hex4") formattedString = this.toHex8String(true);
        if (format === "hex8") formattedString = this.toHex8String();
        if (format === "name") formattedString = this.toName();
        if (format === "hsl") formattedString = this.toHslString();
        if (format === "hsv") formattedString = this.toHsvString();
        return formattedString || this.toHexString();
    },
    clone: function clone() {
        return $dfe376b89801a77b$export$2e2bcd8739ae039(this.toString());
    },
    _applyModification: function _applyModification(fn, args) {
        var color = fn.apply(null, [
            this
        ].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function lighten() {
        return this._applyModification($dfe376b89801a77b$var$_lighten, arguments);
    },
    brighten: function brighten() {
        return this._applyModification($dfe376b89801a77b$var$_brighten, arguments);
    },
    darken: function darken() {
        return this._applyModification($dfe376b89801a77b$var$_darken, arguments);
    },
    desaturate: function desaturate() {
        return this._applyModification($dfe376b89801a77b$var$_desaturate, arguments);
    },
    saturate: function saturate() {
        return this._applyModification($dfe376b89801a77b$var$_saturate, arguments);
    },
    greyscale: function greyscale() {
        return this._applyModification($dfe376b89801a77b$var$_greyscale, arguments);
    },
    spin: function spin() {
        return this._applyModification($dfe376b89801a77b$var$_spin, arguments);
    },
    _applyCombination: function _applyCombination(fn, args) {
        return fn.apply(null, [
            this
        ].concat([].slice.call(args)));
    },
    analogous: function analogous() {
        return this._applyCombination($dfe376b89801a77b$var$_analogous, arguments);
    },
    complement: function complement() {
        return this._applyCombination($dfe376b89801a77b$var$_complement, arguments);
    },
    monochromatic: function monochromatic() {
        return this._applyCombination($dfe376b89801a77b$var$_monochromatic, arguments);
    },
    splitcomplement: function splitcomplement() {
        return this._applyCombination($dfe376b89801a77b$var$_splitcomplement, arguments);
    },
    // Disabled until https://github.com/bgrins/TinyColor/issues/254
    // polyad: function (number) {
    //   return this._applyCombination(polyad, [number]);
    // },
    triad: function triad() {
        return this._applyCombination($dfe376b89801a77b$var$polyad, [
            3
        ]);
    },
    tetrad: function tetrad() {
        return this._applyCombination($dfe376b89801a77b$var$polyad, [
            4
        ]);
    }
};
// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
$dfe376b89801a77b$export$2e2bcd8739ae039.fromRatio = function(color, opts) {
    if ($dfe376b89801a77b$var$_typeof(color) == "object") {
        var newColor = {};
        for(var i in color)if (color.hasOwnProperty(i)) {
            if (i === "a") newColor[i] = color[i];
            else newColor[i] = $dfe376b89801a77b$var$convertToPercentage(color[i]);
        }
        color = newColor;
    }
    return $dfe376b89801a77b$export$2e2bcd8739ae039(color, opts);
};
// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function $dfe376b89801a77b$var$inputToRGB(color) {
    var rgb = {
        r: 0,
        g: 0,
        b: 0
    };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color == "string") color = $dfe376b89801a77b$var$stringInputToObject(color);
    if ($dfe376b89801a77b$var$_typeof(color) == "object") {
        if ($dfe376b89801a77b$var$isValidCSSUnit(color.r) && $dfe376b89801a77b$var$isValidCSSUnit(color.g) && $dfe376b89801a77b$var$isValidCSSUnit(color.b)) {
            rgb = $dfe376b89801a77b$var$rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        } else if ($dfe376b89801a77b$var$isValidCSSUnit(color.h) && $dfe376b89801a77b$var$isValidCSSUnit(color.s) && $dfe376b89801a77b$var$isValidCSSUnit(color.v)) {
            s = $dfe376b89801a77b$var$convertToPercentage(color.s);
            v = $dfe376b89801a77b$var$convertToPercentage(color.v);
            rgb = $dfe376b89801a77b$var$hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        } else if ($dfe376b89801a77b$var$isValidCSSUnit(color.h) && $dfe376b89801a77b$var$isValidCSSUnit(color.s) && $dfe376b89801a77b$var$isValidCSSUnit(color.l)) {
            s = $dfe376b89801a77b$var$convertToPercentage(color.s);
            l = $dfe376b89801a77b$var$convertToPercentage(color.l);
            rgb = $dfe376b89801a77b$var$hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }
        if (color.hasOwnProperty("a")) a = color.a;
    }
    a = $dfe376b89801a77b$var$boundAlpha(a);
    return {
        ok: ok,
        format: color.format || format,
        r: Math.min(255, Math.max(rgb.r, 0)),
        g: Math.min(255, Math.max(rgb.g, 0)),
        b: Math.min(255, Math.max(rgb.b, 0)),
        a: a
    };
}
// Conversion Functions
// --------------------
// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function $dfe376b89801a77b$var$rgbToRgb(r, g, b) {
    return {
        r: $dfe376b89801a77b$var$bound01(r, 255) * 255,
        g: $dfe376b89801a77b$var$bound01(g, 255) * 255,
        b: $dfe376b89801a77b$var$bound01(b, 255) * 255
    };
}
// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function $dfe376b89801a77b$var$rgbToHsl(r, g, b) {
    r = $dfe376b89801a77b$var$bound01(r, 255);
    g = $dfe376b89801a77b$var$bound01(g, 255);
    b = $dfe376b89801a77b$var$bound01(b, 255);
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, l = (max + min) / 2;
    if (max == min) h = s = 0; // achromatic
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        l: l
    };
}
// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function $dfe376b89801a77b$var$hslToRgb(h, s, l) {
    var r, g, b;
    h = $dfe376b89801a77b$var$bound01(h, 360);
    s = $dfe376b89801a77b$var$bound01(s, 100);
    l = $dfe376b89801a77b$var$bound01(l, 100);
    function hue2rgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 0.5) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    }
    if (s === 0) r = g = b = l; // achromatic
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function $dfe376b89801a77b$var$rgbToHsv(r, g, b) {
    r = $dfe376b89801a77b$var$bound01(r, 255);
    g = $dfe376b89801a77b$var$bound01(g, 255);
    b = $dfe376b89801a77b$var$bound01(b, 255);
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, v = max;
    var d = max - min;
    s = max === 0 ? 0 : d / max;
    if (max == min) h = 0; // achromatic
    else {
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        v: v
    };
}
// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function $dfe376b89801a77b$var$hsvToRgb(h, s, v) {
    h = $dfe376b89801a77b$var$bound01(h, 360) * 6;
    s = $dfe376b89801a77b$var$bound01(s, 100);
    v = $dfe376b89801a77b$var$bound01(v, 100);
    var i = Math.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [
        v,
        q,
        p,
        p,
        t,
        v
    ][mod], g = [
        t,
        v,
        v,
        q,
        p,
        p
    ][mod], b = [
        p,
        p,
        t,
        v,
        v,
        q
    ][mod];
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function $dfe376b89801a77b$var$rgbToHex(r, g, b, allow3Char) {
    var hex = [
        $dfe376b89801a77b$var$pad2(Math.round(r).toString(16)),
        $dfe376b89801a77b$var$pad2(Math.round(g).toString(16)),
        $dfe376b89801a77b$var$pad2(Math.round(b).toString(16))
    ];
    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    return hex.join("");
}
// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function $dfe376b89801a77b$var$rgbaToHex(r, g, b, a, allow4Char) {
    var hex = [
        $dfe376b89801a77b$var$pad2(Math.round(r).toString(16)),
        $dfe376b89801a77b$var$pad2(Math.round(g).toString(16)),
        $dfe376b89801a77b$var$pad2(Math.round(b).toString(16)),
        $dfe376b89801a77b$var$pad2($dfe376b89801a77b$var$convertDecimalToHex(a))
    ];
    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    return hex.join("");
}
// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function $dfe376b89801a77b$var$rgbaToArgbHex(r, g, b, a) {
    var hex = [
        $dfe376b89801a77b$var$pad2($dfe376b89801a77b$var$convertDecimalToHex(a)),
        $dfe376b89801a77b$var$pad2(Math.round(r).toString(16)),
        $dfe376b89801a77b$var$pad2(Math.round(g).toString(16)),
        $dfe376b89801a77b$var$pad2(Math.round(b).toString(16))
    ];
    return hex.join("");
}
// `equals`
// Can be called with any tinycolor input
$dfe376b89801a77b$export$2e2bcd8739ae039.equals = function(color1, color2) {
    if (!color1 || !color2) return false;
    return $dfe376b89801a77b$export$2e2bcd8739ae039(color1).toRgbString() == $dfe376b89801a77b$export$2e2bcd8739ae039(color2).toRgbString();
};
$dfe376b89801a77b$export$2e2bcd8739ae039.random = function() {
    return $dfe376b89801a77b$export$2e2bcd8739ae039.fromRatio({
        r: Math.random(),
        g: Math.random(),
        b: Math.random()
    });
};
// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
function $dfe376b89801a77b$var$_desaturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $dfe376b89801a77b$export$2e2bcd8739ae039(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = $dfe376b89801a77b$var$clamp01(hsl.s);
    return $dfe376b89801a77b$export$2e2bcd8739ae039(hsl);
}
function $dfe376b89801a77b$var$_saturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $dfe376b89801a77b$export$2e2bcd8739ae039(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = $dfe376b89801a77b$var$clamp01(hsl.s);
    return $dfe376b89801a77b$export$2e2bcd8739ae039(hsl);
}
function $dfe376b89801a77b$var$_greyscale(color) {
    return $dfe376b89801a77b$export$2e2bcd8739ae039(color).desaturate(100);
}
function $dfe376b89801a77b$var$_lighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $dfe376b89801a77b$export$2e2bcd8739ae039(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = $dfe376b89801a77b$var$clamp01(hsl.l);
    return $dfe376b89801a77b$export$2e2bcd8739ae039(hsl);
}
function $dfe376b89801a77b$var$_brighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var rgb = $dfe376b89801a77b$export$2e2bcd8739ae039(color).toRgb();
    rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
    rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
    rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
    return $dfe376b89801a77b$export$2e2bcd8739ae039(rgb);
}
function $dfe376b89801a77b$var$_darken(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $dfe376b89801a77b$export$2e2bcd8739ae039(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = $dfe376b89801a77b$var$clamp01(hsl.l);
    return $dfe376b89801a77b$export$2e2bcd8739ae039(hsl);
}
// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function $dfe376b89801a77b$var$_spin(color, amount) {
    var hsl = $dfe376b89801a77b$export$2e2bcd8739ae039(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return $dfe376b89801a77b$export$2e2bcd8739ae039(hsl);
}
// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
function $dfe376b89801a77b$var$_complement(color) {
    var hsl = $dfe376b89801a77b$export$2e2bcd8739ae039(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return $dfe376b89801a77b$export$2e2bcd8739ae039(hsl);
}
function $dfe376b89801a77b$var$polyad(color, number) {
    if (isNaN(number) || number <= 0) throw new Error("Argument to polyad must be a positive number");
    var hsl = $dfe376b89801a77b$export$2e2bcd8739ae039(color).toHsl();
    var result = [
        $dfe376b89801a77b$export$2e2bcd8739ae039(color)
    ];
    var step = 360 / number;
    for(var i = 1; i < number; i++)result.push($dfe376b89801a77b$export$2e2bcd8739ae039({
        h: (hsl.h + i * step) % 360,
        s: hsl.s,
        l: hsl.l
    }));
    return result;
}
function $dfe376b89801a77b$var$_splitcomplement(color) {
    var hsl = $dfe376b89801a77b$export$2e2bcd8739ae039(color).toHsl();
    var h = hsl.h;
    return [
        $dfe376b89801a77b$export$2e2bcd8739ae039(color),
        $dfe376b89801a77b$export$2e2bcd8739ae039({
            h: (h + 72) % 360,
            s: hsl.s,
            l: hsl.l
        }),
        $dfe376b89801a77b$export$2e2bcd8739ae039({
            h: (h + 216) % 360,
            s: hsl.s,
            l: hsl.l
        })
    ];
}
function $dfe376b89801a77b$var$_analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;
    var hsl = $dfe376b89801a77b$export$2e2bcd8739ae039(color).toHsl();
    var part = 360 / slices;
    var ret = [
        $dfe376b89801a77b$export$2e2bcd8739ae039(color)
    ];
    for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
        hsl.h = (hsl.h + part) % 360;
        ret.push($dfe376b89801a77b$export$2e2bcd8739ae039(hsl));
    }
    return ret;
}
function $dfe376b89801a77b$var$_monochromatic(color, results) {
    results = results || 6;
    var hsv = $dfe376b89801a77b$export$2e2bcd8739ae039(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;
    while(results--){
        ret.push($dfe376b89801a77b$export$2e2bcd8739ae039({
            h: h,
            s: s,
            v: v
        }));
        v = (v + modification) % 1;
    }
    return ret;
}
// Utility Functions
// ---------------------
$dfe376b89801a77b$export$2e2bcd8739ae039.mix = function(color1, color2, amount) {
    amount = amount === 0 ? 0 : amount || 50;
    var rgb1 = $dfe376b89801a77b$export$2e2bcd8739ae039(color1).toRgb();
    var rgb2 = $dfe376b89801a77b$export$2e2bcd8739ae039(color2).toRgb();
    var p = amount / 100;
    var rgba = {
        r: (rgb2.r - rgb1.r) * p + rgb1.r,
        g: (rgb2.g - rgb1.g) * p + rgb1.g,
        b: (rgb2.b - rgb1.b) * p + rgb1.b,
        a: (rgb2.a - rgb1.a) * p + rgb1.a
    };
    return $dfe376b89801a77b$export$2e2bcd8739ae039(rgba);
};
// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
$dfe376b89801a77b$export$2e2bcd8739ae039.readability = function(color1, color2) {
    var c1 = $dfe376b89801a77b$export$2e2bcd8739ae039(color1);
    var c2 = $dfe376b89801a77b$export$2e2bcd8739ae039(color2);
    return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
};
// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
$dfe376b89801a77b$export$2e2bcd8739ae039.isReadable = function(color1, color2, wcag2) {
    var readability = $dfe376b89801a77b$export$2e2bcd8739ae039.readability(color1, color2);
    var wcag2Parms, out;
    out = false;
    wcag2Parms = $dfe376b89801a77b$var$validateWCAG2Parms(wcag2);
    switch(wcag2Parms.level + wcag2Parms.size){
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;
};
// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
$dfe376b89801a77b$export$2e2bcd8739ae039.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors;
    level = args.level;
    size = args.size;
    for(var i = 0; i < colorList.length; i++){
        readability = $dfe376b89801a77b$export$2e2bcd8739ae039.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = $dfe376b89801a77b$export$2e2bcd8739ae039(colorList[i]);
        }
    }
    if ($dfe376b89801a77b$export$2e2bcd8739ae039.isReadable(baseColor, bestColor, {
        level: level,
        size: size
    }) || !includeFallbackColors) return bestColor;
    else {
        args.includeFallbackColors = false;
        return $dfe376b89801a77b$export$2e2bcd8739ae039.mostReadable(baseColor, [
            "#fff",
            "#000"
        ], args);
    }
};
// Big List of Colors
// ------------------
// <https://www.w3.org/TR/css-color-4/#named-colors>
var $dfe376b89801a77b$var$names = $dfe376b89801a77b$export$2e2bcd8739ae039.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};
// Make it easy to access colors via `hexNames[hex]`
var $dfe376b89801a77b$var$hexNames = $dfe376b89801a77b$export$2e2bcd8739ae039.hexNames = $dfe376b89801a77b$var$flip($dfe376b89801a77b$var$names);
// Utilities
// ---------
// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function $dfe376b89801a77b$var$flip(o) {
    var flipped = {};
    for(var i in o)if (o.hasOwnProperty(i)) flipped[o[i]] = i;
    return flipped;
}
// Return a valid alpha value [0,1] with all invalid values being set to 1
function $dfe376b89801a77b$var$boundAlpha(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) a = 1;
    return a;
}
// Take input from [0, n] and return it as [0, 1]
function $dfe376b89801a77b$var$bound01(n, max) {
    if ($dfe376b89801a77b$var$isOnePointZero(n)) n = "100%";
    var processPercent = $dfe376b89801a77b$var$isPercentage(n);
    n = Math.min(max, Math.max(0, parseFloat(n)));
    // Automatically convert percentage into number
    if (processPercent) n = parseInt(n * max, 10) / 100;
    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) return 1;
    // Convert into [0, 1] range if it isn't already
    return n % max / parseFloat(max);
}
// Force a number between 0 and 1
function $dfe376b89801a77b$var$clamp01(val) {
    return Math.min(1, Math.max(0, val));
}
// Parse a base-16 hex value into a base-10 integer
function $dfe376b89801a77b$var$parseIntFromHex(val) {
    return parseInt(val, 16);
}
// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function $dfe376b89801a77b$var$isOnePointZero(n) {
    return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
}
// Check to see if string passed in is a percentage
function $dfe376b89801a77b$var$isPercentage(n) {
    return typeof n === "string" && n.indexOf("%") != -1;
}
// Force a hex value to have 2 characters
function $dfe376b89801a77b$var$pad2(c) {
    return c.length == 1 ? "0" + c : "" + c;
}
// Replace a decimal with it's percentage value
function $dfe376b89801a77b$var$convertToPercentage(n) {
    if (n <= 1) n = n * 100 + "%";
    return n;
}
// Converts a decimal to a hex value
function $dfe376b89801a77b$var$convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function $dfe376b89801a77b$var$convertHexToDecimal(h) {
    return $dfe376b89801a77b$var$parseIntFromHex(h) / 255;
}
var $dfe376b89801a77b$var$matchers = function() {
    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";
    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
}();
// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function $dfe376b89801a77b$var$isValidCSSUnit(color) {
    return !!$dfe376b89801a77b$var$matchers.CSS_UNIT.exec(color);
}
// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function $dfe376b89801a77b$var$stringInputToObject(color) {
    color = color.replace($dfe376b89801a77b$var$trimLeft, "").replace($dfe376b89801a77b$var$trimRight, "").toLowerCase();
    var named = false;
    if ($dfe376b89801a77b$var$names[color]) {
        color = $dfe376b89801a77b$var$names[color];
        named = true;
    } else if (color == "transparent") return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: "name"
    };
    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if (match = $dfe376b89801a77b$var$matchers.rgb.exec(color)) return {
        r: match[1],
        g: match[2],
        b: match[3]
    };
    if (match = $dfe376b89801a77b$var$matchers.rgba.exec(color)) return {
        r: match[1],
        g: match[2],
        b: match[3],
        a: match[4]
    };
    if (match = $dfe376b89801a77b$var$matchers.hsl.exec(color)) return {
        h: match[1],
        s: match[2],
        l: match[3]
    };
    if (match = $dfe376b89801a77b$var$matchers.hsla.exec(color)) return {
        h: match[1],
        s: match[2],
        l: match[3],
        a: match[4]
    };
    if (match = $dfe376b89801a77b$var$matchers.hsv.exec(color)) return {
        h: match[1],
        s: match[2],
        v: match[3]
    };
    if (match = $dfe376b89801a77b$var$matchers.hsva.exec(color)) return {
        h: match[1],
        s: match[2],
        v: match[3],
        a: match[4]
    };
    if (match = $dfe376b89801a77b$var$matchers.hex8.exec(color)) return {
        r: $dfe376b89801a77b$var$parseIntFromHex(match[1]),
        g: $dfe376b89801a77b$var$parseIntFromHex(match[2]),
        b: $dfe376b89801a77b$var$parseIntFromHex(match[3]),
        a: $dfe376b89801a77b$var$convertHexToDecimal(match[4]),
        format: named ? "name" : "hex8"
    };
    if (match = $dfe376b89801a77b$var$matchers.hex6.exec(color)) return {
        r: $dfe376b89801a77b$var$parseIntFromHex(match[1]),
        g: $dfe376b89801a77b$var$parseIntFromHex(match[2]),
        b: $dfe376b89801a77b$var$parseIntFromHex(match[3]),
        format: named ? "name" : "hex"
    };
    if (match = $dfe376b89801a77b$var$matchers.hex4.exec(color)) return {
        r: $dfe376b89801a77b$var$parseIntFromHex(match[1] + "" + match[1]),
        g: $dfe376b89801a77b$var$parseIntFromHex(match[2] + "" + match[2]),
        b: $dfe376b89801a77b$var$parseIntFromHex(match[3] + "" + match[3]),
        a: $dfe376b89801a77b$var$convertHexToDecimal(match[4] + "" + match[4]),
        format: named ? "name" : "hex8"
    };
    if (match = $dfe376b89801a77b$var$matchers.hex3.exec(color)) return {
        r: $dfe376b89801a77b$var$parseIntFromHex(match[1] + "" + match[1]),
        g: $dfe376b89801a77b$var$parseIntFromHex(match[2] + "" + match[2]),
        b: $dfe376b89801a77b$var$parseIntFromHex(match[3] + "" + match[3]),
        format: named ? "name" : "hex"
    };
    return false;
}
function $dfe376b89801a77b$var$validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {
        level: "AA",
        size: "small"
    };
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") level = "AA";
    if (size !== "small" && size !== "large") size = "small";
    return {
        level: level,
        size: size
    };
}


var $576ec6501ba2ee42$export$4837207a530c7f21 = function simpleCheckForValidColor(data) {
    var keysToCheck = [
        "r",
        "g",
        "b",
        "a",
        "h",
        "s",
        "l",
        "v"
    ];
    var checked = 0;
    var passed = 0;
    (0, $b54885b9209d0b2e$export$2e2bcd8739ae039)(keysToCheck, function(letter) {
        if (data[letter]) {
            checked += 1;
            if (!isNaN(data[letter])) passed += 1;
            if (letter === "s" || letter === "l") {
                var percentPatt = /^\d+%$/;
                if (percentPatt.test(data[letter])) passed += 1;
            }
        }
    });
    return checked === passed ? data : false;
};
var $576ec6501ba2ee42$export$6bed283375899438 = function toState(data, oldHue) {
    var color = data.hex ? (0, $dfe376b89801a77b$export$2e2bcd8739ae039)(data.hex) : (0, $dfe376b89801a77b$export$2e2bcd8739ae039)(data);
    var hsl = color.toHsl();
    var hsv = color.toHsv();
    var rgb = color.toRgb();
    var hex = color.toHex();
    if (hsl.s === 0) {
        hsl.h = oldHue || 0;
        hsv.h = oldHue || 0;
    }
    var transparent = hex === "000000" && rgb.a === 0;
    return {
        hsl: hsl,
        hex: transparent ? "transparent" : "#" + hex,
        rgb: rgb,
        hsv: hsv,
        oldHue: data.h || oldHue || hsl.h,
        source: data.source
    };
};
var $576ec6501ba2ee42$export$944f75ec5697b362 = function isValidHex(hex) {
    if (hex === "transparent") return true;
    // disable hex4 and hex8
    var lh = String(hex).charAt(0) === "#" ? 1 : 0;
    return hex.length !== 4 + lh && hex.length < 7 + lh && (0, $dfe376b89801a77b$export$2e2bcd8739ae039)(hex).isValid();
};
var $576ec6501ba2ee42$export$3609eb1d7e55dec = function getContrastingColor(data) {
    if (!data) return "#fff";
    var col = $576ec6501ba2ee42$export$6bed283375899438(data);
    if (col.hex === "transparent") return "rgba(0,0,0,0.4)";
    var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
    return yiq >= 128 ? "#000" : "#fff";
};
var $576ec6501ba2ee42$export$a90204d1394caf30 = {
    hsl: {
        a: 1,
        h: 0,
        l: 0.5,
        s: 1
    },
    hex: "#ff0000",
    rgb: {
        r: 255,
        g: 0,
        b: 0,
        a: 1
    },
    hsv: {
        h: 0,
        s: 1,
        v: 1,
        a: 1
    }
};
var $576ec6501ba2ee42$export$e76ec4c5b3cadd73 = function isvalidColorString(string, type) {
    var stringWithoutDegree = string.replace("\xb0", "");
    return (0, $dfe376b89801a77b$export$2e2bcd8739ae039)(type + " (" + stringWithoutDegree + ")")._ok;
};


var $0b94bdc4c9eeec33$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $0b94bdc4c9eeec33$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $0b94bdc4c9eeec33$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0b94bdc4c9eeec33$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $0b94bdc4c9eeec33$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $0b94bdc4c9eeec33$export$68265aef2e61bec7 = function ColorWrap(Picker) {
    var ColorPicker = function(_ref) {
        $0b94bdc4c9eeec33$var$_inherits(ColorPicker, _ref);
        function ColorPicker(props) {
            $0b94bdc4c9eeec33$var$_classCallCheck(this, ColorPicker);
            var _this = $0b94bdc4c9eeec33$var$_possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));
            _this.handleChange = function(data, event) {
                var isValidColor = $576ec6501ba2ee42$export$4837207a530c7f21(data);
                if (isValidColor) {
                    var colors = $576ec6501ba2ee42$export$6bed283375899438(data, data.h || _this.state.oldHue);
                    _this.setState(colors);
                    _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
                    _this.props.onChange && _this.props.onChange(colors, event);
                }
            };
            _this.handleSwatchHover = function(data, event) {
                var isValidColor = $576ec6501ba2ee42$export$4837207a530c7f21(data);
                if (isValidColor) {
                    var colors = $576ec6501ba2ee42$export$6bed283375899438(data, data.h || _this.state.oldHue);
                    _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
                }
            };
            _this.state = $0b94bdc4c9eeec33$var$_extends({}, $576ec6501ba2ee42$export$6bed283375899438(props.color, 0));
            _this.debounce = (0, $786c65489b59f27c$export$2e2bcd8739ae039)(function(fn, data, event) {
                fn(data, event);
            }, 100);
            return _this;
        }
        $0b94bdc4c9eeec33$var$_createClass(ColorPicker, [
            {
                key: "render",
                value: function render() {
                    var optionalEvents = {};
                    if (this.props.onSwatchHover) optionalEvents.onSwatchHover = this.handleSwatchHover;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement(Picker, $0b94bdc4c9eeec33$var$_extends({}, this.props, this.state, {
                        onChange: this.handleChange
                    }, optionalEvents));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(nextProps, state) {
                    return $0b94bdc4c9eeec33$var$_extends({}, $576ec6501ba2ee42$export$6bed283375899438(nextProps.color, state.oldHue));
                }
            }
        ]);
        return ColorPicker;
    }((0, $jC8Vy.PureComponent) || (0, $jC8Vy.Component));
    ColorPicker.propTypes = $0b94bdc4c9eeec33$var$_extends({}, Picker.propTypes);
    ColorPicker.defaultProps = $0b94bdc4c9eeec33$var$_extends({}, Picker.defaultProps, {
        color: {
            h: 250,
            s: 0.50,
            l: 0.20,
            a: 1
        }
    });
    return ColorPicker;
};
var $0b94bdc4c9eeec33$export$2e2bcd8739ae039 = $0b94bdc4c9eeec33$export$68265aef2e61bec7;



var $jC8Vy = parcelRequire("jC8Vy");


var $jC8Vy = parcelRequire("jC8Vy");
var $41aca6541ba186b7$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $41aca6541ba186b7$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $41aca6541ba186b7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $41aca6541ba186b7$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $41aca6541ba186b7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $41aca6541ba186b7$export$185584c64f36588 = function handleFocus(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "span";
    return function(_React$Component) {
        $41aca6541ba186b7$var$_inherits(Focus, _React$Component);
        function Focus() {
            var _ref;
            var _temp, _this, _ret;
            $41aca6541ba186b7$var$_classCallCheck(this, Focus);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $41aca6541ba186b7$var$_possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                focus: false
            }, _this.handleFocus = function() {
                return _this.setState({
                    focus: true
                });
            }, _this.handleBlur = function() {
                return _this.setState({
                    focus: false
                });
            }, _temp), $41aca6541ba186b7$var$_possibleConstructorReturn(_this, _ret);
        }
        $41aca6541ba186b7$var$_createClass(Focus, [
            {
                key: "render",
                value: function render() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement(Span, {
                        onFocus: this.handleFocus,
                        onBlur: this.handleBlur
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement(Component, $41aca6541ba186b7$var$_extends({}, this.props, this.state)));
                }
            }
        ]);
        return Focus;
    }((0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).Component);
};



var $f6e39602c7ca87c2$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $f6e39602c7ca87c2$var$ENTER = 13;
var $f6e39602c7ca87c2$export$c463048d6131b309 = function Swatch(_ref) {
    var color = _ref.color, style = _ref.style, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onHover = _ref.onHover, _ref$title = _ref.title, title = _ref$title === undefined ? color : _ref$title, children = _ref.children, focus = _ref.focus, _ref$focusStyle = _ref.focusStyle, focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;
    var transparent = color === "transparent";
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))({
        default: {
            swatch: $f6e39602c7ca87c2$var$_extends({
                background: color,
                height: "100%",
                width: "100%",
                cursor: "pointer",
                position: "relative",
                outline: "none"
            }, style, focus ? focusStyle : {})
        }
    });
    var handleClick = function handleClick(e) {
        return onClick(color, e);
    };
    var handleKeyDown = function handleKeyDown(e) {
        return e.keyCode === $f6e39602c7ca87c2$var$ENTER && onClick(color, e);
    };
    var handleHover = function handleHover(e) {
        return onHover(color, e);
    };
    var optionalEvents = {};
    if (onHover) optionalEvents.onMouseOver = handleHover;
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", $f6e39602c7ca87c2$var$_extends({
        style: styles.swatch,
        onClick: handleClick,
        title: title,
        tabIndex: 0,
        onKeyDown: handleKeyDown
    }, optionalEvents), children, transparent && (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $06778ce7e366f6d8$export$2e2bcd8739ae039), {
        borderRadius: styles.swatch.borderRadius,
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.1)"
    }));
};
var $f6e39602c7ca87c2$export$2e2bcd8739ae039 = (0, $41aca6541ba186b7$export$185584c64f36588)($f6e39602c7ca87c2$export$c463048d6131b309);





var $jC8Vy = parcelRequire("jC8Vy");

var $74501c5a4abcf540$export$5bbd8091d1d0e224 = function AlphaPointer(_ref) {
    var direction = _ref.direction;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))({
        "default": {
            picker: {
                width: "18px",
                height: "18px",
                borderRadius: "50%",
                transform: "translate(-9px, -1px)",
                backgroundColor: "rgb(248, 248, 248)",
                boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
            }
        },
        "vertical": {
            picker: {
                transform: "translate(-3px, -9px)"
            }
        }
    }, {
        vertical: direction === "vertical"
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.picker
    });
};
var $74501c5a4abcf540$export$2e2bcd8739ae039 = $74501c5a4abcf540$export$5bbd8091d1d0e224;


var $f90158126a14ddd8$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $f90158126a14ddd8$export$421d2c1bdabf8a68 = function AlphaPicker(_ref) {
    var rgb = _ref.rgb, hsl = _ref.hsl, width = _ref.width, height = _ref.height, onChange = _ref.onChange, direction = _ref.direction, style = _ref.style, renderers = _ref.renderers, pointer = _ref.pointer, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))({
        "default": {
            picker: {
                position: "relative",
                width: width,
                height: height
            },
            alpha: {
                radius: "2px",
                style: style
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.picker,
        className: "alpha-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $c7fcad7bb70c839d$export$2e2bcd8739ae039), $f90158126a14ddd8$var$_extends({}, styles.alpha, {
        rgb: rgb,
        hsl: hsl,
        pointer: pointer,
        renderers: renderers,
        onChange: onChange,
        direction: direction
    })));
};
$f90158126a14ddd8$export$421d2c1bdabf8a68.defaultProps = {
    width: "316px",
    height: "16px",
    direction: "horizontal",
    pointer: (0, $74501c5a4abcf540$export$2e2bcd8739ae039)
};
var $f90158126a14ddd8$export$2e2bcd8739ae039 = (0, $0b94bdc4c9eeec33$export$2e2bcd8739ae039)($f90158126a14ddd8$export$421d2c1bdabf8a68);



var $jC8Vy = parcelRequire("jC8Vy");

var $bD9Bx = parcelRequire("bD9Bx");





var $jC8Vy = parcelRequire("jC8Vy");

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $4e133024d4ffa31e$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $4e133024d4ffa31e$export$2e2bcd8739ae039 = $4e133024d4ffa31e$var$arrayMap;





/** Used to stand-in for `undefined` hash values. */ var $42b85d4eb9273712$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $42b85d4eb9273712$var$setCacheAdd(value) {
    this.__data__.set(value, $42b85d4eb9273712$var$HASH_UNDEFINED);
    return this;
}
var $42b85d4eb9273712$export$2e2bcd8739ae039 = $42b85d4eb9273712$var$setCacheAdd;


/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $63639cdc8ebfff53$var$setCacheHas(value) {
    return this.__data__.has(value);
}
var $63639cdc8ebfff53$export$2e2bcd8739ae039 = $63639cdc8ebfff53$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $194764d9591c5950$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, $3cb6dd6160304c5d$export$2e2bcd8739ae039);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$194764d9591c5950$var$SetCache.prototype.add = $194764d9591c5950$var$SetCache.prototype.push = (0, $42b85d4eb9273712$export$2e2bcd8739ae039);
$194764d9591c5950$var$SetCache.prototype.has = (0, $63639cdc8ebfff53$export$2e2bcd8739ae039);
var $194764d9591c5950$export$2e2bcd8739ae039 = $194764d9591c5950$var$SetCache;


/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $d57b78c0940d4176$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
var $d57b78c0940d4176$export$2e2bcd8739ae039 = $d57b78c0940d4176$var$arraySome;


/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $971598e47612c568$var$cacheHas(cache, key) {
    return cache.has(key);
}
var $971598e47612c568$export$2e2bcd8739ae039 = $971598e47612c568$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $e355d6e4cf798686$var$COMPARE_PARTIAL_FLAG = 1, $e355d6e4cf798686$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $e355d6e4cf798686$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $e355d6e4cf798686$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $e355d6e4cf798686$var$COMPARE_UNORDERED_FLAG ? new (0, $194764d9591c5950$export$2e2bcd8739ae039) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, $d57b78c0940d4176$export$2e2bcd8739ae039)(other, function(othValue, othIndex) {
                if (!(0, $971598e47612c568$export$2e2bcd8739ae039)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
var $e355d6e4cf798686$export$2e2bcd8739ae039 = $e355d6e4cf798686$var$equalArrays;






/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $32c088d5c2f35667$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
var $32c088d5c2f35667$export$2e2bcd8739ae039 = $32c088d5c2f35667$var$mapToArray;


/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $e2eb94ecc43268f0$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
var $e2eb94ecc43268f0$export$2e2bcd8739ae039 = $e2eb94ecc43268f0$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $9428bb32a2bf8b20$var$COMPARE_PARTIAL_FLAG = 1, $9428bb32a2bf8b20$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $9428bb32a2bf8b20$var$boolTag = "[object Boolean]", $9428bb32a2bf8b20$var$dateTag = "[object Date]", $9428bb32a2bf8b20$var$errorTag = "[object Error]", $9428bb32a2bf8b20$var$mapTag = "[object Map]", $9428bb32a2bf8b20$var$numberTag = "[object Number]", $9428bb32a2bf8b20$var$regexpTag = "[object RegExp]", $9428bb32a2bf8b20$var$setTag = "[object Set]", $9428bb32a2bf8b20$var$stringTag = "[object String]", $9428bb32a2bf8b20$var$symbolTag = "[object Symbol]";
var $9428bb32a2bf8b20$var$arrayBufferTag = "[object ArrayBuffer]", $9428bb32a2bf8b20$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $9428bb32a2bf8b20$var$symbolProto = (0, $7a90d7abbf553945$export$2e2bcd8739ae039) ? (0, $7a90d7abbf553945$export$2e2bcd8739ae039).prototype : undefined, $9428bb32a2bf8b20$var$symbolValueOf = $9428bb32a2bf8b20$var$symbolProto ? $9428bb32a2bf8b20$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $9428bb32a2bf8b20$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $9428bb32a2bf8b20$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $9428bb32a2bf8b20$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, $bc55c02022434aed$export$2e2bcd8739ae039)(object), new (0, $bc55c02022434aed$export$2e2bcd8739ae039)(other))) return false;
            return true;
        case $9428bb32a2bf8b20$var$boolTag:
        case $9428bb32a2bf8b20$var$dateTag:
        case $9428bb32a2bf8b20$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, $42b14d7baa041ed1$export$2e2bcd8739ae039)(+object, +other);
        case $9428bb32a2bf8b20$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $9428bb32a2bf8b20$var$regexpTag:
        case $9428bb32a2bf8b20$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $9428bb32a2bf8b20$var$mapTag:
            var convert = (0, $32c088d5c2f35667$export$2e2bcd8739ae039);
        case $9428bb32a2bf8b20$var$setTag:
            var isPartial = bitmask & $9428bb32a2bf8b20$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, $e2eb94ecc43268f0$export$2e2bcd8739ae039));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $9428bb32a2bf8b20$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, $e355d6e4cf798686$export$2e2bcd8739ae039)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $9428bb32a2bf8b20$var$symbolTag:
            if ($9428bb32a2bf8b20$var$symbolValueOf) return $9428bb32a2bf8b20$var$symbolValueOf.call(object) == $9428bb32a2bf8b20$var$symbolValueOf.call(other);
    }
    return false;
}
var $9428bb32a2bf8b20$export$2e2bcd8739ae039 = $9428bb32a2bf8b20$var$equalByTag;


/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $a21b1cf0a5c9f1bc$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $a21b1cf0a5c9f1bc$export$2e2bcd8739ae039 = $a21b1cf0a5c9f1bc$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $1924909eddd163cd$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $b759d94d9c1fbe90$export$2e2bcd8739ae039)(object) ? result : (0, $a21b1cf0a5c9f1bc$export$2e2bcd8739ae039)(result, symbolsFunc(object));
}
var $1924909eddd163cd$export$2e2bcd8739ae039 = $1924909eddd163cd$var$baseGetAllKeys;


/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $ec1f8c71a1b215d7$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $ec1f8c71a1b215d7$export$2e2bcd8739ae039 = $ec1f8c71a1b215d7$var$arrayFilter;


/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $f1ed4ee9ffba6952$var$stubArray() {
    return [];
}
var $f1ed4ee9ffba6952$export$2e2bcd8739ae039 = $f1ed4ee9ffba6952$var$stubArray;


/** Used for built-in method references. */ var $a77d8e4d9aac7971$var$objectProto = Object.prototype;
/** Built-in value references. */ var $a77d8e4d9aac7971$var$propertyIsEnumerable = $a77d8e4d9aac7971$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a77d8e4d9aac7971$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $a77d8e4d9aac7971$var$getSymbols = !$a77d8e4d9aac7971$var$nativeGetSymbols ? (0, $f1ed4ee9ffba6952$export$2e2bcd8739ae039) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $ec1f8c71a1b215d7$export$2e2bcd8739ae039)($a77d8e4d9aac7971$var$nativeGetSymbols(object), function(symbol) {
        return $a77d8e4d9aac7971$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $a77d8e4d9aac7971$export$2e2bcd8739ae039 = $a77d8e4d9aac7971$var$getSymbols;



/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $58bd789cbcc0151f$var$getAllKeys(object) {
    return (0, $1924909eddd163cd$export$2e2bcd8739ae039)(object, (0, $8a7e0c9ba0b2489f$export$2e2bcd8739ae039), (0, $a77d8e4d9aac7971$export$2e2bcd8739ae039));
}
var $58bd789cbcc0151f$export$2e2bcd8739ae039 = $58bd789cbcc0151f$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $8aebad0e1b9421c0$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $8aebad0e1b9421c0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8aebad0e1b9421c0$var$hasOwnProperty = $8aebad0e1b9421c0$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $8aebad0e1b9421c0$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $8aebad0e1b9421c0$var$COMPARE_PARTIAL_FLAG, objProps = (0, $58bd789cbcc0151f$export$2e2bcd8739ae039)(object), objLength = objProps.length, othProps = (0, $58bd789cbcc0151f$export$2e2bcd8739ae039)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $8aebad0e1b9421c0$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
var $8aebad0e1b9421c0$export$2e2bcd8739ae039 = $8aebad0e1b9421c0$var$equalObjects;




var $kXc8K = parcelRequire("kXc8K");
/* Built-in method references that are verified to be native. */ var $290140902f1b6fac$var$DataView = (0, $79e89c97b0c86ca3$export$2e2bcd8739ae039)((0, $kXc8K.default), "DataView");
var $290140902f1b6fac$export$2e2bcd8739ae039 = $290140902f1b6fac$var$DataView;





var $kXc8K = parcelRequire("kXc8K");
/* Built-in method references that are verified to be native. */ var $c2c953ccc9d96186$var$Promise = (0, $79e89c97b0c86ca3$export$2e2bcd8739ae039)((0, $kXc8K.default), "Promise");
var $c2c953ccc9d96186$export$2e2bcd8739ae039 = $c2c953ccc9d96186$var$Promise;




var $kXc8K = parcelRequire("kXc8K");
/* Built-in method references that are verified to be native. */ var $c41ecb0095bb1bff$var$Set = (0, $79e89c97b0c86ca3$export$2e2bcd8739ae039)((0, $kXc8K.default), "Set");
var $c41ecb0095bb1bff$export$2e2bcd8739ae039 = $c41ecb0095bb1bff$var$Set;




var $kXc8K = parcelRequire("kXc8K");
/* Built-in method references that are verified to be native. */ var $bde60ebead7f7321$var$WeakMap = (0, $79e89c97b0c86ca3$export$2e2bcd8739ae039)((0, $kXc8K.default), "WeakMap");
var $bde60ebead7f7321$export$2e2bcd8739ae039 = $bde60ebead7f7321$var$WeakMap;




/** `Object#toString` result references. */ var $7d00407428c9f183$var$mapTag = "[object Map]", $7d00407428c9f183$var$objectTag = "[object Object]", $7d00407428c9f183$var$promiseTag = "[object Promise]", $7d00407428c9f183$var$setTag = "[object Set]", $7d00407428c9f183$var$weakMapTag = "[object WeakMap]";
var $7d00407428c9f183$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $7d00407428c9f183$var$dataViewCtorString = (0, $5474618e5d31375a$export$2e2bcd8739ae039)((0, $290140902f1b6fac$export$2e2bcd8739ae039)), $7d00407428c9f183$var$mapCtorString = (0, $5474618e5d31375a$export$2e2bcd8739ae039)((0, $b8dd1aafcb3f0e01$export$2e2bcd8739ae039)), $7d00407428c9f183$var$promiseCtorString = (0, $5474618e5d31375a$export$2e2bcd8739ae039)((0, $c2c953ccc9d96186$export$2e2bcd8739ae039)), $7d00407428c9f183$var$setCtorString = (0, $5474618e5d31375a$export$2e2bcd8739ae039)((0, $c41ecb0095bb1bff$export$2e2bcd8739ae039)), $7d00407428c9f183$var$weakMapCtorString = (0, $5474618e5d31375a$export$2e2bcd8739ae039)((0, $bde60ebead7f7321$export$2e2bcd8739ae039));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $7d00407428c9f183$var$getTag = (0, $d246294e778b9804$export$2e2bcd8739ae039);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $290140902f1b6fac$export$2e2bcd8739ae039) && $7d00407428c9f183$var$getTag(new (0, $290140902f1b6fac$export$2e2bcd8739ae039)(new ArrayBuffer(1))) != $7d00407428c9f183$var$dataViewTag || (0, $b8dd1aafcb3f0e01$export$2e2bcd8739ae039) && $7d00407428c9f183$var$getTag(new (0, $b8dd1aafcb3f0e01$export$2e2bcd8739ae039)) != $7d00407428c9f183$var$mapTag || (0, $c2c953ccc9d96186$export$2e2bcd8739ae039) && $7d00407428c9f183$var$getTag((0, $c2c953ccc9d96186$export$2e2bcd8739ae039).resolve()) != $7d00407428c9f183$var$promiseTag || (0, $c41ecb0095bb1bff$export$2e2bcd8739ae039) && $7d00407428c9f183$var$getTag(new (0, $c41ecb0095bb1bff$export$2e2bcd8739ae039)) != $7d00407428c9f183$var$setTag || (0, $bde60ebead7f7321$export$2e2bcd8739ae039) && $7d00407428c9f183$var$getTag(new (0, $bde60ebead7f7321$export$2e2bcd8739ae039)) != $7d00407428c9f183$var$weakMapTag) $7d00407428c9f183$var$getTag = function(value) {
    var result = (0, $d246294e778b9804$export$2e2bcd8739ae039)(value), Ctor = result == $7d00407428c9f183$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $5474618e5d31375a$export$2e2bcd8739ae039)(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $7d00407428c9f183$var$dataViewCtorString:
            return $7d00407428c9f183$var$dataViewTag;
        case $7d00407428c9f183$var$mapCtorString:
            return $7d00407428c9f183$var$mapTag;
        case $7d00407428c9f183$var$promiseCtorString:
            return $7d00407428c9f183$var$promiseTag;
        case $7d00407428c9f183$var$setCtorString:
            return $7d00407428c9f183$var$setTag;
        case $7d00407428c9f183$var$weakMapCtorString:
            return $7d00407428c9f183$var$weakMapTag;
    }
    return result;
};
var $7d00407428c9f183$export$2e2bcd8739ae039 = $7d00407428c9f183$var$getTag;




var $2wMWH = parcelRequire("2wMWH");

/** Used to compose bitmasks for value comparisons. */ var $2b782167868f2d12$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $2b782167868f2d12$var$argsTag = "[object Arguments]", $2b782167868f2d12$var$arrayTag = "[object Array]", $2b782167868f2d12$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $2b782167868f2d12$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2b782167868f2d12$var$hasOwnProperty = $2b782167868f2d12$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $2b782167868f2d12$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, $b759d94d9c1fbe90$export$2e2bcd8739ae039)(object), othIsArr = (0, $b759d94d9c1fbe90$export$2e2bcd8739ae039)(other), objTag = objIsArr ? $2b782167868f2d12$var$arrayTag : (0, $7d00407428c9f183$export$2e2bcd8739ae039)(object), othTag = othIsArr ? $2b782167868f2d12$var$arrayTag : (0, $7d00407428c9f183$export$2e2bcd8739ae039)(other);
    objTag = objTag == $2b782167868f2d12$var$argsTag ? $2b782167868f2d12$var$objectTag : objTag;
    othTag = othTag == $2b782167868f2d12$var$argsTag ? $2b782167868f2d12$var$objectTag : othTag;
    var objIsObj = objTag == $2b782167868f2d12$var$objectTag, othIsObj = othTag == $2b782167868f2d12$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, $2wMWH.default)(object)) {
        if (!(0, $2wMWH.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, $08752089301ca501$export$2e2bcd8739ae039));
        return objIsArr || (0, $1d71fc388743cb76$export$2e2bcd8739ae039)(object) ? (0, $e355d6e4cf798686$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack) : (0, $9428bb32a2bf8b20$export$2e2bcd8739ae039)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $2b782167868f2d12$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $2b782167868f2d12$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $2b782167868f2d12$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, $08752089301ca501$export$2e2bcd8739ae039));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, $08752089301ca501$export$2e2bcd8739ae039));
    return (0, $8aebad0e1b9421c0$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack);
}
var $2b782167868f2d12$export$2e2bcd8739ae039 = $2b782167868f2d12$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $6830b221350b9738$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, $2b336945ce04d6f5$export$2e2bcd8739ae039)(value) && !(0, $2b336945ce04d6f5$export$2e2bcd8739ae039)(other)) return value !== value && other !== other;
    return (0, $2b782167868f2d12$export$2e2bcd8739ae039)(value, other, bitmask, customizer, $6830b221350b9738$var$baseIsEqual, stack);
}
var $6830b221350b9738$export$2e2bcd8739ae039 = $6830b221350b9738$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $35a7b16c55e6617f$var$COMPARE_PARTIAL_FLAG = 1, $35a7b16c55e6617f$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $35a7b16c55e6617f$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new (0, $08752089301ca501$export$2e2bcd8739ae039);
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? (0, $6830b221350b9738$export$2e2bcd8739ae039)(srcValue, objValue, $35a7b16c55e6617f$var$COMPARE_PARTIAL_FLAG | $35a7b16c55e6617f$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
var $35a7b16c55e6617f$export$2e2bcd8739ae039 = $35a7b16c55e6617f$var$baseIsMatch;



/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $01bb6be0ca40a4d4$var$isStrictComparable(value) {
    return value === value && !(0, $ec27e620fc242dbd$export$2e2bcd8739ae039)(value);
}
var $01bb6be0ca40a4d4$export$2e2bcd8739ae039 = $01bb6be0ca40a4d4$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $cff0ba77ac2d30a3$var$getMatchData(object) {
    var result = (0, $8a7e0c9ba0b2489f$export$2e2bcd8739ae039)(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            (0, $01bb6be0ca40a4d4$export$2e2bcd8739ae039)(value)
        ];
    }
    return result;
}
var $cff0ba77ac2d30a3$export$2e2bcd8739ae039 = $cff0ba77ac2d30a3$var$getMatchData;


/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $6bae3d3c0f6827c8$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
var $6bae3d3c0f6827c8$export$2e2bcd8739ae039 = $6bae3d3c0f6827c8$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $ae1f31a4b8dc6579$var$baseMatches(source) {
    var matchData = (0, $cff0ba77ac2d30a3$export$2e2bcd8739ae039)(source);
    if (matchData.length == 1 && matchData[0][2]) return (0, $6bae3d3c0f6827c8$export$2e2bcd8739ae039)(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || (0, $35a7b16c55e6617f$export$2e2bcd8739ae039)(object, source, matchData);
    };
}
var $ae1f31a4b8dc6579$export$2e2bcd8739ae039 = $ae1f31a4b8dc6579$var$baseMatches;






/** Used to match property names within property paths. */ var $9726a7313ab7bf4b$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $9726a7313ab7bf4b$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $9726a7313ab7bf4b$var$isKey(value, object) {
    if ((0, $b759d94d9c1fbe90$export$2e2bcd8739ae039)(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || (0, $782455e108dc8bc3$export$2e2bcd8739ae039)(value)) return true;
    return $9726a7313ab7bf4b$var$reIsPlainProp.test(value) || !$9726a7313ab7bf4b$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
var $9726a7313ab7bf4b$export$2e2bcd8739ae039 = $9726a7313ab7bf4b$var$isKey;



/** Error message constants. */ var $093838080865c127$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $093838080865c127$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($093838080865c127$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($093838080865c127$var$memoize.Cache || (0, $3cb6dd6160304c5d$export$2e2bcd8739ae039));
    return memoized;
}
// Expose `MapCache`.
$093838080865c127$var$memoize.Cache = (0, $3cb6dd6160304c5d$export$2e2bcd8739ae039);
var $093838080865c127$export$2e2bcd8739ae039 = $093838080865c127$var$memoize;


/** Used as the maximum memoize cache size. */ var $af48491c9a8b1a6e$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $af48491c9a8b1a6e$var$memoizeCapped(func) {
    var result = (0, $093838080865c127$export$2e2bcd8739ae039)(func, function(key) {
        if (cache.size === $af48491c9a8b1a6e$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $af48491c9a8b1a6e$export$2e2bcd8739ae039 = $af48491c9a8b1a6e$var$memoizeCapped;


/** Used to match property names within property paths. */ var $150ce9cc12c8ebe2$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $150ce9cc12c8ebe2$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $150ce9cc12c8ebe2$var$stringToPath = (0, $af48491c9a8b1a6e$export$2e2bcd8739ae039)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($150ce9cc12c8ebe2$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($150ce9cc12c8ebe2$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
var $150ce9cc12c8ebe2$export$2e2bcd8739ae039 = $150ce9cc12c8ebe2$var$stringToPath;






/** Used as references for various `Number` constants. */ var $61056b87296468f3$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $61056b87296468f3$var$symbolProto = (0, $7a90d7abbf553945$export$2e2bcd8739ae039) ? (0, $7a90d7abbf553945$export$2e2bcd8739ae039).prototype : undefined, $61056b87296468f3$var$symbolToString = $61056b87296468f3$var$symbolProto ? $61056b87296468f3$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $61056b87296468f3$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ((0, $b759d94d9c1fbe90$export$2e2bcd8739ae039)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $4e133024d4ffa31e$export$2e2bcd8739ae039)(value, $61056b87296468f3$var$baseToString) + "";
    if ((0, $782455e108dc8bc3$export$2e2bcd8739ae039)(value)) return $61056b87296468f3$var$symbolToString ? $61056b87296468f3$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$61056b87296468f3$var$INFINITY ? "-0" : result;
}
var $61056b87296468f3$export$2e2bcd8739ae039 = $61056b87296468f3$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $da9ca767b90528a7$var$toString(value) {
    return value == null ? "" : (0, $61056b87296468f3$export$2e2bcd8739ae039)(value);
}
var $da9ca767b90528a7$export$2e2bcd8739ae039 = $da9ca767b90528a7$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $f4d30cf12d9068e4$var$castPath(value, object) {
    if ((0, $b759d94d9c1fbe90$export$2e2bcd8739ae039)(value)) return value;
    return (0, $9726a7313ab7bf4b$export$2e2bcd8739ae039)(value, object) ? [
        value
    ] : (0, $150ce9cc12c8ebe2$export$2e2bcd8739ae039)((0, $da9ca767b90528a7$export$2e2bcd8739ae039)(value));
}
var $f4d30cf12d9068e4$export$2e2bcd8739ae039 = $f4d30cf12d9068e4$var$castPath;



/** Used as references for various `Number` constants. */ var $654370f0d44da7d2$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $654370f0d44da7d2$var$toKey(value) {
    if (typeof value == "string" || (0, $782455e108dc8bc3$export$2e2bcd8739ae039)(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$654370f0d44da7d2$var$INFINITY ? "-0" : result;
}
var $654370f0d44da7d2$export$2e2bcd8739ae039 = $654370f0d44da7d2$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $09fe84ab49f83c87$var$baseGet(object, path) {
    path = (0, $f4d30cf12d9068e4$export$2e2bcd8739ae039)(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[(0, $654370f0d44da7d2$export$2e2bcd8739ae039)(path[index++])];
    return index && index == length ? object : undefined;
}
var $09fe84ab49f83c87$export$2e2bcd8739ae039 = $09fe84ab49f83c87$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $9ff8dd7db1846d18$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : (0, $09fe84ab49f83c87$export$2e2bcd8739ae039)(object, path);
    return result === undefined ? defaultValue : result;
}
var $9ff8dd7db1846d18$export$2e2bcd8739ae039 = $9ff8dd7db1846d18$var$get;


/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $18cd26272a32b7f8$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
var $18cd26272a32b7f8$export$2e2bcd8739ae039 = $18cd26272a32b7f8$var$baseHasIn;








/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $4868c748b8316b78$var$hasPath(object, path, hasFunc) {
    path = (0, $f4d30cf12d9068e4$export$2e2bcd8739ae039)(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = (0, $654370f0d44da7d2$export$2e2bcd8739ae039)(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && (0, $d120ce1abe70411f$export$2e2bcd8739ae039)(length) && (0, $a593f61a340433a9$export$2e2bcd8739ae039)(key, length) && ((0, $b759d94d9c1fbe90$export$2e2bcd8739ae039)(object) || (0, $5a45a1a3c9961159$export$2e2bcd8739ae039)(object));
}
var $4868c748b8316b78$export$2e2bcd8739ae039 = $4868c748b8316b78$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $c3b44fd8635f7fa6$var$hasIn(object, path) {
    return object != null && (0, $4868c748b8316b78$export$2e2bcd8739ae039)(object, path, (0, $18cd26272a32b7f8$export$2e2bcd8739ae039));
}
var $c3b44fd8635f7fa6$export$2e2bcd8739ae039 = $c3b44fd8635f7fa6$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $62eddd72e97c8499$var$COMPARE_PARTIAL_FLAG = 1, $62eddd72e97c8499$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $62eddd72e97c8499$var$baseMatchesProperty(path, srcValue) {
    if ((0, $9726a7313ab7bf4b$export$2e2bcd8739ae039)(path) && (0, $01bb6be0ca40a4d4$export$2e2bcd8739ae039)(srcValue)) return (0, $6bae3d3c0f6827c8$export$2e2bcd8739ae039)((0, $654370f0d44da7d2$export$2e2bcd8739ae039)(path), srcValue);
    return function(object) {
        var objValue = (0, $9ff8dd7db1846d18$export$2e2bcd8739ae039)(object, path);
        return objValue === undefined && objValue === srcValue ? (0, $c3b44fd8635f7fa6$export$2e2bcd8739ae039)(object, path) : (0, $6830b221350b9738$export$2e2bcd8739ae039)(srcValue, objValue, $62eddd72e97c8499$var$COMPARE_PARTIAL_FLAG | $62eddd72e97c8499$var$COMPARE_UNORDERED_FLAG);
    };
}
var $62eddd72e97c8499$export$2e2bcd8739ae039 = $62eddd72e97c8499$var$baseMatchesProperty;




/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $43e96c4d11702e7c$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
var $43e96c4d11702e7c$export$2e2bcd8739ae039 = $43e96c4d11702e7c$var$baseProperty;



/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $e66b962b2bf0af22$var$basePropertyDeep(path) {
    return function(object) {
        return (0, $09fe84ab49f83c87$export$2e2bcd8739ae039)(object, path);
    };
}
var $e66b962b2bf0af22$export$2e2bcd8739ae039 = $e66b962b2bf0af22$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $eea44bc07b1c311c$var$property(path) {
    return (0, $9726a7313ab7bf4b$export$2e2bcd8739ae039)(path) ? (0, $43e96c4d11702e7c$export$2e2bcd8739ae039)((0, $654370f0d44da7d2$export$2e2bcd8739ae039)(path)) : (0, $e66b962b2bf0af22$export$2e2bcd8739ae039)(path);
}
var $eea44bc07b1c311c$export$2e2bcd8739ae039 = $eea44bc07b1c311c$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $06121811183b1ad8$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return 0, $887eb084408f9cca$export$2e2bcd8739ae039;
    if (typeof value == "object") return (0, $b759d94d9c1fbe90$export$2e2bcd8739ae039)(value) ? (0, $62eddd72e97c8499$export$2e2bcd8739ae039)(value[0], value[1]) : (0, $ae1f31a4b8dc6579$export$2e2bcd8739ae039)(value);
    return (0, $eea44bc07b1c311c$export$2e2bcd8739ae039)(value);
}
var $06121811183b1ad8$export$2e2bcd8739ae039 = $06121811183b1ad8$var$baseIteratee;




/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $6bcf407070ca9094$var$baseMap(collection, iteratee) {
    var index = -1, result = (0, $bb78877ef87aa1da$export$2e2bcd8739ae039)(collection) ? Array(collection.length) : [];
    (0, $33f2d457f4113761$export$2e2bcd8739ae039)(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
var $6bcf407070ca9094$export$2e2bcd8739ae039 = $6bcf407070ca9094$var$baseMap;



/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $55201e71335337d3$var$map(collection, iteratee) {
    var func = (0, $b759d94d9c1fbe90$export$2e2bcd8739ae039)(collection) ? (0, $4e133024d4ffa31e$export$2e2bcd8739ae039) : (0, $6bcf407070ca9094$export$2e2bcd8739ae039);
    return func(collection, (0, $06121811183b1ad8$export$2e2bcd8739ae039)(iteratee, 3));
}
var $55201e71335337d3$export$2e2bcd8739ae039 = $55201e71335337d3$var$map;



var $676c38f8b76156d8$export$2ce88c5250e54734 = function BlockSwatches(_ref) {
    var colors = _ref.colors, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))({
        "default": {
            swatches: {
                marginRight: "-10px"
            },
            swatch: {
                width: "22px",
                height: "22px",
                float: "left",
                marginRight: "10px",
                marginBottom: "10px",
                borderRadius: "4px"
            },
            clear: {
                clear: "both"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.swatches
    }, (0, $55201e71335337d3$export$2e2bcd8739ae039)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $f6e39602c7ca87c2$export$2e2bcd8739ae039), {
            key: c,
            color: c,
            style: styles.swatch,
            onClick: onClick,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: "0 0 4px " + c
            }
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.clear
    }));
};
var $676c38f8b76156d8$export$2e2bcd8739ae039 = $676c38f8b76156d8$export$2ce88c5250e54734;


var $79d1d1486e3f1f63$export$d96a8827a60d6b69 = function Block(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex = _ref.hex, colors = _ref.colors, width = _ref.width, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var transparent = hex === "transparent";
    var handleChange = function handleChange(hexCode, e) {
        $576ec6501ba2ee42$export$944f75ec5697b362(hexCode) && onChange({
            hex: hexCode,
            source: "hex"
        }, e);
    };
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))((0, $248c37d10097eba3$export$2e2bcd8739ae039)({
        "default": {
            card: {
                width: width,
                background: "#fff",
                boxShadow: "0 1px rgba(0,0,0,.1)",
                borderRadius: "6px",
                position: "relative"
            },
            head: {
                height: "110px",
                background: hex,
                borderRadius: "6px 6px 0 0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative"
            },
            body: {
                padding: "10px"
            },
            label: {
                fontSize: "18px",
                color: $576ec6501ba2ee42$export$3609eb1d7e55dec(hex),
                position: "relative"
            },
            triangle: {
                width: "0px",
                height: "0px",
                borderStyle: "solid",
                borderWidth: "0 10px 10px 10px",
                borderColor: "transparent transparent " + hex + " transparent",
                position: "absolute",
                top: "-10px",
                left: "50%",
                marginLeft: "-10px"
            },
            input: {
                width: "100%",
                fontSize: "12px",
                color: "#666",
                border: "0px",
                outline: "none",
                height: "22px",
                boxShadow: "inset 0 0 0 1px #ddd",
                borderRadius: "4px",
                padding: "0 7px",
                boxSizing: "border-box"
            }
        },
        "hide-triangle": {
            triangle: {
                display: "none"
            }
        }
    }, passedStyles), {
        "hide-triangle": triangle === "hide"
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.card,
        className: "block-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.triangle
    }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.head
    }, transparent && (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $06778ce7e366f6d8$export$2e2bcd8739ae039), {
        borderRadius: "6px 6px 0 0"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.label
    }, hex)), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.body
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $676c38f8b76156d8$export$2e2bcd8739ae039), {
        colors: colors,
        onClick: handleChange,
        onSwatchHover: onSwatchHover
    }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
        style: {
            input: styles.input
        },
        value: hex,
        onChange: handleChange
    })));
};
$79d1d1486e3f1f63$export$d96a8827a60d6b69.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).number
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).string),
    triangle: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).oneOf([
        "top",
        "hide"
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).object
};
$79d1d1486e3f1f63$export$d96a8827a60d6b69.defaultProps = {
    width: 170,
    colors: [
        "#D9E3F0",
        "#F47373",
        "#697689",
        "#37D67A",
        "#2CCCE4",
        "#555555",
        "#dce775",
        "#ff8a65",
        "#ba68c8"
    ],
    triangle: "top",
    styles: {}
};
var $79d1d1486e3f1f63$export$2e2bcd8739ae039 = (0, $0b94bdc4c9eeec33$export$2e2bcd8739ae039)($79d1d1486e3f1f63$export$d96a8827a60d6b69);



var $jC8Vy = parcelRequire("jC8Vy");

var $bD9Bx = parcelRequire("bD9Bx");



var $433034794868c5fe$export$a90204d1394caf30 = {
    "50": "#ffebee",
    "100": "#ffcdd2",
    "200": "#ef9a9a",
    "300": "#e57373",
    "400": "#ef5350",
    "500": "#f44336",
    "600": "#e53935",
    "700": "#d32f2f",
    "800": "#c62828",
    "900": "#b71c1c",
    "a100": "#ff8a80",
    "a200": "#ff5252",
    "a400": "#ff1744",
    "a700": "#d50000"
};
var $433034794868c5fe$export$47853bc718611763 = {
    "50": "#fce4ec",
    "100": "#f8bbd0",
    "200": "#f48fb1",
    "300": "#f06292",
    "400": "#ec407a",
    "500": "#e91e63",
    "600": "#d81b60",
    "700": "#c2185b",
    "800": "#ad1457",
    "900": "#880e4f",
    "a100": "#ff80ab",
    "a200": "#ff4081",
    "a400": "#f50057",
    "a700": "#c51162"
};
var $433034794868c5fe$export$e13cce2a2d16a9d4 = {
    "50": "#f3e5f5",
    "100": "#e1bee7",
    "200": "#ce93d8",
    "300": "#ba68c8",
    "400": "#ab47bc",
    "500": "#9c27b0",
    "600": "#8e24aa",
    "700": "#7b1fa2",
    "800": "#6a1b9a",
    "900": "#4a148c",
    "a100": "#ea80fc",
    "a200": "#e040fb",
    "a400": "#d500f9",
    "a700": "#aa00ff"
};
var $433034794868c5fe$export$51ef95b19086af57 = {
    "50": "#ede7f6",
    "100": "#d1c4e9",
    "200": "#b39ddb",
    "300": "#9575cd",
    "400": "#7e57c2",
    "500": "#673ab7",
    "600": "#5e35b1",
    "700": "#512da8",
    "800": "#4527a0",
    "900": "#311b92",
    "a100": "#b388ff",
    "a200": "#7c4dff",
    "a400": "#651fff",
    "a700": "#6200ea"
};
var $433034794868c5fe$export$3e6ccc7b8562d453 = {
    "50": "#e8eaf6",
    "100": "#c5cae9",
    "200": "#9fa8da",
    "300": "#7986cb",
    "400": "#5c6bc0",
    "500": "#3f51b5",
    "600": "#3949ab",
    "700": "#303f9f",
    "800": "#283593",
    "900": "#1a237e",
    "a100": "#8c9eff",
    "a200": "#536dfe",
    "a400": "#3d5afe",
    "a700": "#304ffe"
};
var $433034794868c5fe$export$2aa0182783e7e9de = {
    "50": "#e3f2fd",
    "100": "#bbdefb",
    "200": "#90caf9",
    "300": "#64b5f6",
    "400": "#42a5f5",
    "500": "#2196f3",
    "600": "#1e88e5",
    "700": "#1976d2",
    "800": "#1565c0",
    "900": "#0d47a1",
    "a100": "#82b1ff",
    "a200": "#448aff",
    "a400": "#2979ff",
    "a700": "#2962ff"
};
var $433034794868c5fe$export$7b0d29b70b435c21 = {
    "50": "#e1f5fe",
    "100": "#b3e5fc",
    "200": "#81d4fa",
    "300": "#4fc3f7",
    "400": "#29b6f6",
    "500": "#03a9f4",
    "600": "#039be5",
    "700": "#0288d1",
    "800": "#0277bd",
    "900": "#01579b",
    "a100": "#80d8ff",
    "a200": "#40c4ff",
    "a400": "#00b0ff",
    "a700": "#0091ea"
};
var $433034794868c5fe$export$7474046f446842ee = {
    "50": "#e0f7fa",
    "100": "#b2ebf2",
    "200": "#80deea",
    "300": "#4dd0e1",
    "400": "#26c6da",
    "500": "#00bcd4",
    "600": "#00acc1",
    "700": "#0097a7",
    "800": "#00838f",
    "900": "#006064",
    "a100": "#84ffff",
    "a200": "#18ffff",
    "a400": "#00e5ff",
    "a700": "#00b8d4"
};
var $433034794868c5fe$export$8bf7dff220b82b4a = {
    "50": "#e0f2f1",
    "100": "#b2dfdb",
    "200": "#80cbc4",
    "300": "#4db6ac",
    "400": "#26a69a",
    "500": "#009688",
    "600": "#00897b",
    "700": "#00796b",
    "800": "#00695c",
    "900": "#004d40",
    "a100": "#a7ffeb",
    "a200": "#64ffda",
    "a400": "#1de9b6",
    "a700": "#00bfa5"
};
var $433034794868c5fe$export$955a2ebd2fb142ae = {
    "50": "#e8f5e9",
    "100": "#c8e6c9",
    "200": "#a5d6a7",
    "300": "#81c784",
    "400": "#66bb6a",
    "500": "#4caf50",
    "600": "#43a047",
    "700": "#388e3c",
    "800": "#2e7d32",
    "900": "#1b5e20",
    "a100": "#b9f6ca",
    "a200": "#69f0ae",
    "a400": "#00e676",
    "a700": "#00c853"
};
var $433034794868c5fe$export$559a8c00376dc936 = {
    "50": "#f1f8e9",
    "100": "#dcedc8",
    "200": "#c5e1a5",
    "300": "#aed581",
    "400": "#9ccc65",
    "500": "#8bc34a",
    "600": "#7cb342",
    "700": "#689f38",
    "800": "#558b2f",
    "900": "#33691e",
    "a100": "#ccff90",
    "a200": "#b2ff59",
    "a400": "#76ff03",
    "a700": "#64dd17"
};
var $433034794868c5fe$export$221d31baf2636aad = {
    "50": "#f9fbe7",
    "100": "#f0f4c3",
    "200": "#e6ee9c",
    "300": "#dce775",
    "400": "#d4e157",
    "500": "#cddc39",
    "600": "#c0ca33",
    "700": "#afb42b",
    "800": "#9e9d24",
    "900": "#827717",
    "a100": "#f4ff81",
    "a200": "#eeff41",
    "a400": "#c6ff00",
    "a700": "#aeea00"
};
var $433034794868c5fe$export$594c5a8758200c32 = {
    "50": "#fffde7",
    "100": "#fff9c4",
    "200": "#fff59d",
    "300": "#fff176",
    "400": "#ffee58",
    "500": "#ffeb3b",
    "600": "#fdd835",
    "700": "#fbc02d",
    "800": "#f9a825",
    "900": "#f57f17",
    "a100": "#ffff8d",
    "a200": "#ffff00",
    "a400": "#ffea00",
    "a700": "#ffd600"
};
var $433034794868c5fe$export$7c1ecc66643fdbd6 = {
    "50": "#fff8e1",
    "100": "#ffecb3",
    "200": "#ffe082",
    "300": "#ffd54f",
    "400": "#ffca28",
    "500": "#ffc107",
    "600": "#ffb300",
    "700": "#ffa000",
    "800": "#ff8f00",
    "900": "#ff6f00",
    "a100": "#ffe57f",
    "a200": "#ffd740",
    "a400": "#ffc400",
    "a700": "#ffab00"
};
var $433034794868c5fe$export$ad766f34ace1cafd = {
    "50": "#fff3e0",
    "100": "#ffe0b2",
    "200": "#ffcc80",
    "300": "#ffb74d",
    "400": "#ffa726",
    "500": "#ff9800",
    "600": "#fb8c00",
    "700": "#f57c00",
    "800": "#ef6c00",
    "900": "#e65100",
    "a100": "#ffd180",
    "a200": "#ffab40",
    "a400": "#ff9100",
    "a700": "#ff6d00"
};
var $433034794868c5fe$export$1ceed3dd9ec11704 = {
    "50": "#fbe9e7",
    "100": "#ffccbc",
    "200": "#ffab91",
    "300": "#ff8a65",
    "400": "#ff7043",
    "500": "#ff5722",
    "600": "#f4511e",
    "700": "#e64a19",
    "800": "#d84315",
    "900": "#bf360c",
    "a100": "#ff9e80",
    "a200": "#ff6e40",
    "a400": "#ff3d00",
    "a700": "#dd2c00"
};
var $433034794868c5fe$export$b6e6178d3f565007 = {
    "50": "#efebe9",
    "100": "#d7ccc8",
    "200": "#bcaaa4",
    "300": "#a1887f",
    "400": "#8d6e63",
    "500": "#795548",
    "600": "#6d4c41",
    "700": "#5d4037",
    "800": "#4e342e",
    "900": "#3e2723"
};
var $433034794868c5fe$export$e4c89085febbc618 = {
    "50": "#fafafa",
    "100": "#f5f5f5",
    "200": "#eeeeee",
    "300": "#e0e0e0",
    "400": "#bdbdbd",
    "500": "#9e9e9e",
    "600": "#757575",
    "700": "#616161",
    "800": "#424242",
    "900": "#212121"
};
var $433034794868c5fe$export$7c2da42d08c019c9 = {
    "50": "#eceff1",
    "100": "#cfd8dc",
    "200": "#b0bec5",
    "300": "#90a4ae",
    "400": "#78909c",
    "500": "#607d8b",
    "600": "#546e7a",
    "700": "#455a64",
    "800": "#37474f",
    "900": "#263238"
};
var $433034794868c5fe$export$b413907788b50267 = {
    "primary": "rgba(0, 0, 0, 0.87)",
    "secondary": "rgba(0, 0, 0, 0.54)",
    "disabled": "rgba(0, 0, 0, 0.38)",
    "dividers": "rgba(0, 0, 0, 0.12)"
};
var $433034794868c5fe$export$c962f8177a273028 = {
    "primary": "rgba(255, 255, 255, 1)",
    "secondary": "rgba(255, 255, 255, 0.7)",
    "disabled": "rgba(255, 255, 255, 0.5)",
    "dividers": "rgba(255, 255, 255, 0.12)"
};
var $433034794868c5fe$export$969f6c634341b5cf = {
    "active": "rgba(0, 0, 0, 0.54)",
    "inactive": "rgba(0, 0, 0, 0.38)"
};
var $433034794868c5fe$export$6b4a43519c60f4b1 = {
    "active": "rgba(255, 255, 255, 1)",
    "inactive": "rgba(255, 255, 255, 0.5)"
};
var $433034794868c5fe$export$8fa4e5556fd77a60 = "#ffffff";
var $433034794868c5fe$export$c073df10e766abfa = "#000000";
var $433034794868c5fe$export$2e2bcd8739ae039 = {
    red: $433034794868c5fe$export$a90204d1394caf30,
    pink: $433034794868c5fe$export$47853bc718611763,
    purple: $433034794868c5fe$export$e13cce2a2d16a9d4,
    deepPurple: $433034794868c5fe$export$51ef95b19086af57,
    indigo: $433034794868c5fe$export$3e6ccc7b8562d453,
    blue: $433034794868c5fe$export$2aa0182783e7e9de,
    lightBlue: $433034794868c5fe$export$7b0d29b70b435c21,
    cyan: $433034794868c5fe$export$7474046f446842ee,
    teal: $433034794868c5fe$export$8bf7dff220b82b4a,
    green: $433034794868c5fe$export$955a2ebd2fb142ae,
    lightGreen: $433034794868c5fe$export$559a8c00376dc936,
    lime: $433034794868c5fe$export$221d31baf2636aad,
    yellow: $433034794868c5fe$export$594c5a8758200c32,
    amber: $433034794868c5fe$export$7c1ecc66643fdbd6,
    orange: $433034794868c5fe$export$ad766f34ace1cafd,
    deepOrange: $433034794868c5fe$export$1ceed3dd9ec11704,
    brown: $433034794868c5fe$export$b6e6178d3f565007,
    grey: $433034794868c5fe$export$e4c89085febbc618,
    blueGrey: $433034794868c5fe$export$7c2da42d08c019c9,
    darkText: $433034794868c5fe$export$b413907788b50267,
    lightText: $433034794868c5fe$export$c962f8177a273028,
    darkIcons: $433034794868c5fe$export$969f6c634341b5cf,
    lightIcons: $433034794868c5fe$export$6b4a43519c60f4b1,
    white: $433034794868c5fe$export$8fa4e5556fd77a60,
    black: $433034794868c5fe$export$c073df10e766abfa
};




var $jC8Vy = parcelRequire("jC8Vy");


var $6a4b29d656bba719$export$945d5c8ebb42b0ff = function CircleSwatch(_ref) {
    var color = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, hover = _ref.hover, active = _ref.active, circleSize = _ref.circleSize, circleSpacing = _ref.circleSpacing;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))({
        "default": {
            swatch: {
                width: circleSize,
                height: circleSize,
                marginRight: circleSpacing,
                marginBottom: circleSpacing,
                transform: "scale(1)",
                transition: "100ms transform ease"
            },
            Swatch: {
                borderRadius: "50%",
                background: "transparent",
                boxShadow: "inset 0 0 0 " + (circleSize / 2 + 1) + "px " + color,
                transition: "100ms box-shadow ease"
            }
        },
        "hover": {
            swatch: {
                transform: "scale(1.2)"
            }
        },
        "active": {
            Swatch: {
                boxShadow: "inset 0 0 0 3px " + color
            }
        }
    }, {
        hover: hover,
        active: active
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $f6e39602c7ca87c2$export$2e2bcd8739ae039), {
        style: styles.Swatch,
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: styles.Swatch.boxShadow + ", 0 0 5px " + color
        }
    }));
};
$6a4b29d656bba719$export$945d5c8ebb42b0ff.defaultProps = {
    circleSize: 28,
    circleSpacing: 14
};
var $6a4b29d656bba719$export$2e2bcd8739ae039 = (0, $081a95961b0cb73f$exports.handleHover)($6a4b29d656bba719$export$945d5c8ebb42b0ff);


var $1d8454edf0b618af$export$c89a927ffc67e6fa = function Circle(_ref) {
    var width = _ref.width, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, circleSize = _ref.circleSize, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, circleSpacing = _ref.circleSpacing, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))((0, $248c37d10097eba3$export$2e2bcd8739ae039)({
        "default": {
            card: {
                width: width,
                display: "flex",
                flexWrap: "wrap",
                marginRight: -circleSpacing,
                marginBottom: -circleSpacing
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(hexCode, e) {
        return onChange({
            hex: hexCode,
            source: "hex"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.card,
        className: "circle-picker " + className
    }, (0, $55201e71335337d3$export$2e2bcd8739ae039)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $6a4b29d656bba719$export$2e2bcd8739ae039), {
            key: c,
            color: c,
            onClick: handleChange,
            onSwatchHover: onSwatchHover,
            active: hex === c.toLowerCase(),
            circleSize: circleSize,
            circleSpacing: circleSpacing
        });
    }));
};
$1d8454edf0b618af$export$c89a927ffc67e6fa.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).number
    ]),
    circleSize: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).number,
    circleSpacing: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).number,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).object
};
$1d8454edf0b618af$export$c89a927ffc67e6fa.defaultProps = {
    width: 252,
    circleSize: 28,
    circleSpacing: 14,
    colors: [
        $433034794868c5fe$export$a90204d1394caf30["500"],
        $433034794868c5fe$export$47853bc718611763["500"],
        $433034794868c5fe$export$e13cce2a2d16a9d4["500"],
        $433034794868c5fe$export$51ef95b19086af57["500"],
        $433034794868c5fe$export$3e6ccc7b8562d453["500"],
        $433034794868c5fe$export$2aa0182783e7e9de["500"],
        $433034794868c5fe$export$7b0d29b70b435c21["500"],
        $433034794868c5fe$export$7474046f446842ee["500"],
        $433034794868c5fe$export$8bf7dff220b82b4a["500"],
        $433034794868c5fe$export$955a2ebd2fb142ae["500"],
        $433034794868c5fe$export$559a8c00376dc936["500"],
        $433034794868c5fe$export$221d31baf2636aad["500"],
        $433034794868c5fe$export$594c5a8758200c32["500"],
        $433034794868c5fe$export$7c1ecc66643fdbd6["500"],
        $433034794868c5fe$export$ad766f34ace1cafd["500"],
        $433034794868c5fe$export$1ceed3dd9ec11704["500"],
        $433034794868c5fe$export$b6e6178d3f565007["500"],
        $433034794868c5fe$export$7c2da42d08c019c9["500"]
    ],
    styles: {}
};
var $1d8454edf0b618af$export$2e2bcd8739ae039 = (0, $0b94bdc4c9eeec33$export$2e2bcd8739ae039)($1d8454edf0b618af$export$c89a927ffc67e6fa);



var $jC8Vy = parcelRequire("jC8Vy");

var $bD9Bx = parcelRequire("bD9Bx");




var $jC8Vy = parcelRequire("jC8Vy");


/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $c389a5cd0e2075e1$var$isUndefined(value) {
    return value === undefined;
}
var $c389a5cd0e2075e1$export$2e2bcd8739ae039 = $c389a5cd0e2075e1$var$isUndefined;



var $8f6958c66edce4ca$exports = {};
"use strict";
Object.defineProperty($8f6958c66edce4ca$exports, "__esModule", {
    value: true
});
var $8f6958c66edce4ca$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $jC8Vy = parcelRequire("jC8Vy");
var $8f6958c66edce4ca$var$_react2 = $8f6958c66edce4ca$var$_interopRequireDefault($jC8Vy);
function $8f6958c66edce4ca$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8f6958c66edce4ca$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $8f6958c66edce4ca$var$DEFAULT_SIZE = 24;
$8f6958c66edce4ca$exports.default = function(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === undefined ? "currentColor" : _ref$fill, _ref$width = _ref.width, width = _ref$width === undefined ? $8f6958c66edce4ca$var$DEFAULT_SIZE : _ref$width, _ref$height = _ref.height, height = _ref$height === undefined ? $8f6958c66edce4ca$var$DEFAULT_SIZE : _ref$height, _ref$style = _ref.style, style = _ref$style === undefined ? {} : _ref$style, props = $8f6958c66edce4ca$var$_objectWithoutProperties(_ref, [
        "fill",
        "width",
        "height",
        "style"
    ]);
    return $8f6958c66edce4ca$var$_react2.default.createElement("svg", $8f6958c66edce4ca$var$_extends({
        viewBox: "0 0 " + $8f6958c66edce4ca$var$DEFAULT_SIZE + " " + $8f6958c66edce4ca$var$DEFAULT_SIZE,
        style: $8f6958c66edce4ca$var$_extends({
            fill: fill,
            width: width,
            height: height
        }, style)
    }, props), $8f6958c66edce4ca$var$_react2.default.createElement("path", {
        d: "M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z"
    }));
};


var $129a3e4b0546ae01$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $129a3e4b0546ae01$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $129a3e4b0546ae01$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $129a3e4b0546ae01$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $129a3e4b0546ae01$export$71685d48a2432635 = function(_React$Component) {
    $129a3e4b0546ae01$var$_inherits(ChromeFields, _React$Component);
    function ChromeFields(props) {
        $129a3e4b0546ae01$var$_classCallCheck(this, ChromeFields);
        var _this = $129a3e4b0546ae01$var$_possibleConstructorReturn(this, (ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call(this));
        _this.toggleViews = function() {
            if (_this.state.view === "hex") _this.setState({
                view: "rgb"
            });
            else if (_this.state.view === "rgb") _this.setState({
                view: "hsl"
            });
            else if (_this.state.view === "hsl") {
                if (_this.props.hsl.a === 1) _this.setState({
                    view: "hex"
                });
                else _this.setState({
                    view: "rgb"
                });
            }
        };
        _this.handleChange = function(data, e) {
            if (data.hex) $576ec6501ba2ee42$export$944f75ec5697b362(data.hex) && _this.props.onChange({
                hex: data.hex,
                source: "hex"
            }, e);
            else if (data.r || data.g || data.b) _this.props.onChange({
                r: data.r || _this.props.rgb.r,
                g: data.g || _this.props.rgb.g,
                b: data.b || _this.props.rgb.b,
                source: "rgb"
            }, e);
            else if (data.a) {
                if (data.a < 0) data.a = 0;
                else if (data.a > 1) data.a = 1;
                _this.props.onChange({
                    h: _this.props.hsl.h,
                    s: _this.props.hsl.s,
                    l: _this.props.hsl.l,
                    a: Math.round(data.a * 100) / 100,
                    source: "rgb"
                }, e);
            } else if (data.h || data.s || data.l) {
                // Remove any occurances of '%'.
                if (typeof data.s === "string" && data.s.includes("%")) data.s = data.s.replace("%", "");
                if (typeof data.l === "string" && data.l.includes("%")) data.l = data.l.replace("%", "");
                // We store HSL as a unit interval so we need to override the 1 input to 0.01
                if (data.s == 1) data.s = 0.01;
                else if (data.l == 1) data.l = 0.01;
                _this.props.onChange({
                    h: data.h || _this.props.hsl.h,
                    s: Number(!(0, $c389a5cd0e2075e1$export$2e2bcd8739ae039)(data.s) ? data.s : _this.props.hsl.s),
                    l: Number(!(0, $c389a5cd0e2075e1$export$2e2bcd8739ae039)(data.l) ? data.l : _this.props.hsl.l),
                    source: "hsl"
                }, e);
            }
        };
        _this.showHighlight = function(e) {
            e.currentTarget.style.background = "#eee";
        };
        _this.hideHighlight = function(e) {
            e.currentTarget.style.background = "transparent";
        };
        if (props.hsl.a !== 1 && props.view === "hex") _this.state = {
            view: "rgb"
        };
        else _this.state = {
            view: props.view
        };
        return _this;
    }
    $129a3e4b0546ae01$var$_createClass(ChromeFields, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))({
                    "default": {
                        wrap: {
                            paddingTop: "16px",
                            display: "flex"
                        },
                        fields: {
                            flex: "1",
                            display: "flex",
                            marginLeft: "-6px"
                        },
                        field: {
                            paddingLeft: "6px",
                            width: "100%"
                        },
                        alpha: {
                            paddingLeft: "6px",
                            width: "100%"
                        },
                        toggle: {
                            width: "32px",
                            textAlign: "right",
                            position: "relative"
                        },
                        icon: {
                            marginRight: "-4px",
                            marginTop: "12px",
                            cursor: "pointer",
                            position: "relative"
                        },
                        iconHighlight: {
                            position: "absolute",
                            width: "24px",
                            height: "28px",
                            background: "#eee",
                            borderRadius: "4px",
                            top: "10px",
                            left: "12px",
                            display: "none"
                        },
                        input: {
                            fontSize: "11px",
                            color: "#333",
                            width: "100%",
                            borderRadius: "2px",
                            border: "none",
                            boxShadow: "inset 0 0 0 1px #dadada",
                            height: "21px",
                            textAlign: "center"
                        },
                        label: {
                            textTransform: "uppercase",
                            fontSize: "11px",
                            lineHeight: "11px",
                            color: "#969696",
                            textAlign: "center",
                            display: "block",
                            marginTop: "12px"
                        },
                        svg: {
                            fill: "#333",
                            width: "24px",
                            height: "24px",
                            border: "1px transparent solid",
                            borderRadius: "5px"
                        }
                    },
                    "disableAlpha": {
                        alpha: {
                            display: "none"
                        }
                    }
                }, this.props, this.state);
                var fields = void 0;
                if (this.state.view === "hex") fields = (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.fields,
                    className: "flexbox-fix"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "hex",
                    value: this.props.hex,
                    onChange: this.handleChange
                })));
                else if (this.state.view === "rgb") fields = (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.fields,
                    className: "flexbox-fix"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "r",
                    value: this.props.rgb.r,
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "g",
                    value: this.props.rgb.g,
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "b",
                    value: this.props.rgb.b,
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.alpha
                }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "a",
                    value: this.props.rgb.a,
                    arrowOffset: 0.01,
                    onChange: this.handleChange
                })));
                else if (this.state.view === "hsl") fields = (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.fields,
                    className: "flexbox-fix"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "h",
                    value: Math.round(this.props.hsl.h),
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "s",
                    value: Math.round(this.props.hsl.s * 100) + "%",
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "l",
                    value: Math.round(this.props.hsl.l * 100) + "%",
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.alpha
                }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "a",
                    value: this.props.hsl.a,
                    arrowOffset: 0.01,
                    onChange: this.handleChange
                })));
                return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.wrap,
                    className: "flexbox-fix"
                }, fields, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.toggle
                }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.icon,
                    onClick: this.toggleViews,
                    ref: function ref(icon) {
                        return _this2.icon = icon;
                    }
                }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8f6958c66edce4ca$exports))), {
                    style: styles.svg,
                    onMouseOver: this.showHighlight,
                    onMouseEnter: this.showHighlight,
                    onMouseOut: this.hideHighlight
                }))));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, state) {
                if (nextProps.hsl.a !== 1 && state.view === "hex") return {
                    view: "rgb"
                };
                return null;
            }
        }
    ]);
    return ChromeFields;
}((0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).Component);
$129a3e4b0546ae01$export$71685d48a2432635.defaultProps = {
    view: "hex"
};
var $129a3e4b0546ae01$export$2e2bcd8739ae039 = $129a3e4b0546ae01$export$71685d48a2432635;



var $jC8Vy = parcelRequire("jC8Vy");

var $84ee9e98ee08e5c7$export$a632586f9a957100 = function ChromePointer() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))({
        "default": {
            picker: {
                width: "12px",
                height: "12px",
                borderRadius: "6px",
                transform: "translate(-6px, -1px)",
                backgroundColor: "rgb(248, 248, 248)",
                boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.picker
    });
};
var $84ee9e98ee08e5c7$export$2e2bcd8739ae039 = $84ee9e98ee08e5c7$export$a632586f9a957100;



var $jC8Vy = parcelRequire("jC8Vy");

var $3a4ab89bf1bae9bc$export$190c1afe887f7ef7 = function ChromePointerCircle() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))({
        "default": {
            picker: {
                width: "12px",
                height: "12px",
                borderRadius: "6px",
                boxShadow: "inset 0 0 0 1px #fff",
                transform: "translate(-6px, -6px)"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.picker
    });
};
var $3a4ab89bf1bae9bc$export$2e2bcd8739ae039 = $3a4ab89bf1bae9bc$export$190c1afe887f7ef7;


var $51c725fe6c2d70f1$export$31a305e9779b48b4 = function Chrome(_ref) {
    var width = _ref.width, onChange = _ref.onChange, disableAlpha = _ref.disableAlpha, rgb = _ref.rgb, hsl = _ref.hsl, hsv = _ref.hsv, hex = _ref.hex, renderers = _ref.renderers, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className, defaultView = _ref.defaultView;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))((0, $248c37d10097eba3$export$2e2bcd8739ae039)({
        "default": {
            picker: {
                width: width,
                background: "#fff",
                borderRadius: "2px",
                boxShadow: "0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)",
                boxSizing: "initial",
                fontFamily: "Menlo"
            },
            saturation: {
                width: "100%",
                paddingBottom: "55%",
                position: "relative",
                borderRadius: "2px 2px 0 0",
                overflow: "hidden"
            },
            Saturation: {
                radius: "2px 2px 0 0"
            },
            body: {
                padding: "16px 16px 12px"
            },
            controls: {
                display: "flex"
            },
            color: {
                width: "32px"
            },
            swatch: {
                marginTop: "6px",
                width: "16px",
                height: "16px",
                borderRadius: "8px",
                position: "relative",
                overflow: "hidden"
            },
            active: {
                absolute: "0px 0px 0px 0px",
                borderRadius: "8px",
                boxShadow: "inset 0 0 0 1px rgba(0,0,0,.1)",
                background: "rgba(" + rgb.r + ", " + rgb.g + ", " + rgb.b + ", " + rgb.a + ")",
                zIndex: "2"
            },
            toggles: {
                flex: "1"
            },
            hue: {
                height: "10px",
                position: "relative",
                marginBottom: "8px"
            },
            Hue: {
                radius: "2px"
            },
            alpha: {
                height: "10px",
                position: "relative"
            },
            Alpha: {
                radius: "2px"
            }
        },
        "disableAlpha": {
            color: {
                width: "22px"
            },
            alpha: {
                display: "none"
            },
            hue: {
                marginBottom: "0px"
            },
            swatch: {
                width: "10px",
                height: "10px",
                marginTop: "0px"
            }
        }
    }, passedStyles), {
        disableAlpha: disableAlpha
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.picker,
        className: "chrome-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.saturation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $97e77a17c0f73a8b$export$2e2bcd8739ae039), {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        pointer: (0, $3a4ab89bf1bae9bc$export$2e2bcd8739ae039),
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.body
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.controls,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.active
    }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $06778ce7e366f6d8$export$2e2bcd8739ae039), {
        renderers: renderers
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.toggles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $38476a9de322d712$export$2e2bcd8739ae039), {
        style: styles.Hue,
        hsl: hsl,
        pointer: (0, $84ee9e98ee08e5c7$export$2e2bcd8739ae039),
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.alpha
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $c7fcad7bb70c839d$export$2e2bcd8739ae039), {
        style: styles.Alpha,
        rgb: rgb,
        hsl: hsl,
        pointer: (0, $84ee9e98ee08e5c7$export$2e2bcd8739ae039),
        renderers: renderers,
        onChange: onChange
    })))), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $129a3e4b0546ae01$export$2e2bcd8739ae039), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        view: defaultView,
        onChange: onChange,
        disableAlpha: disableAlpha
    })));
};
$51c725fe6c2d70f1$export$31a305e9779b48b4.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).number
    ]),
    disableAlpha: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).bool,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).object,
    defaultView: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).oneOf([
        "hex",
        "rgb",
        "hsl"
    ])
};
$51c725fe6c2d70f1$export$31a305e9779b48b4.defaultProps = {
    width: 225,
    disableAlpha: false,
    styles: {}
};
var $51c725fe6c2d70f1$export$2e2bcd8739ae039 = (0, $0b94bdc4c9eeec33$export$2e2bcd8739ae039)($51c725fe6c2d70f1$export$31a305e9779b48b4);



var $jC8Vy = parcelRequire("jC8Vy");

var $bD9Bx = parcelRequire("bD9Bx");






var $jC8Vy = parcelRequire("jC8Vy");



var $c1983d6ee2646705$export$df654652e5203306 = function CompactColor(_ref) {
    var color = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))({
        "default": {
            color: {
                background: color,
                width: "15px",
                height: "15px",
                float: "left",
                marginRight: "5px",
                marginBottom: "5px",
                position: "relative",
                cursor: "pointer"
            },
            dot: {
                absolute: "5px 5px 5px 5px",
                background: $576ec6501ba2ee42$export$3609eb1d7e55dec(color),
                borderRadius: "50%",
                opacity: "0"
            }
        },
        "active": {
            dot: {
                opacity: "1"
            }
        },
        "color-#FFFFFF": {
            color: {
                boxShadow: "inset 0 0 0 1px #ddd"
            },
            dot: {
                background: "#000"
            }
        },
        "transparent": {
            dot: {
                background: "#000"
            }
        }
    }, {
        active: active,
        "color-#FFFFFF": color === "#FFFFFF",
        "transparent": color === "transparent"
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $f6e39602c7ca87c2$export$2e2bcd8739ae039), {
        style: styles.color,
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: "0 0 4px " + color
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.dot
    }));
};
var $c1983d6ee2646705$export$2e2bcd8739ae039 = $c1983d6ee2646705$export$df654652e5203306;



var $jC8Vy = parcelRequire("jC8Vy");


var $cbd676230d43193d$export$11cdb14a03223d9c = function CompactFields(_ref) {
    var hex = _ref.hex, rgb = _ref.rgb, onChange = _ref.onChange;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))({
        "default": {
            fields: {
                display: "flex",
                paddingBottom: "6px",
                paddingRight: "5px",
                position: "relative"
            },
            active: {
                position: "absolute",
                top: "6px",
                left: "5px",
                height: "9px",
                width: "9px",
                background: hex
            },
            HEXwrap: {
                flex: "6",
                position: "relative"
            },
            HEXinput: {
                width: "80%",
                padding: "0px",
                paddingLeft: "20%",
                border: "none",
                outline: "none",
                background: "none",
                fontSize: "12px",
                color: "#333",
                height: "16px"
            },
            HEXlabel: {
                display: "none"
            },
            RGBwrap: {
                flex: "3",
                position: "relative"
            },
            RGBinput: {
                width: "70%",
                padding: "0px",
                paddingLeft: "30%",
                border: "none",
                outline: "none",
                background: "none",
                fontSize: "12px",
                color: "#333",
                height: "16px"
            },
            RGBlabel: {
                position: "absolute",
                top: "3px",
                left: "0px",
                lineHeight: "16px",
                textTransform: "uppercase",
                fontSize: "12px",
                color: "#999"
            }
        }
    });
    var handleChange = function handleChange(data, e) {
        if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: "rgb"
        }, e);
        else onChange({
            hex: data.hex,
            source: "hex"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.fields,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.active
    }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: "hex",
        value: hex,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "r",
        value: rgb.r,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "g",
        value: rgb.g,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "b",
        value: rgb.b,
        onChange: handleChange
    }));
};
var $cbd676230d43193d$export$2e2bcd8739ae039 = $cbd676230d43193d$export$11cdb14a03223d9c;


var $8c45db7c797db79e$export$6479582a9c9e50ce = function Compact(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, rgb = _ref.rgb, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))((0, $248c37d10097eba3$export$2e2bcd8739ae039)({
        "default": {
            Compact: {
                background: "#f6f6f6",
                radius: "4px"
            },
            compact: {
                paddingTop: "5px",
                paddingLeft: "5px",
                boxSizing: "initial",
                width: "240px"
            },
            clear: {
                clear: "both"
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        if (data.hex) $576ec6501ba2ee42$export$944f75ec5697b362(data.hex) && onChange({
            hex: data.hex,
            source: "hex"
        }, e);
        else onChange(data, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $741d377d9dbb89cf$export$2e2bcd8739ae039), {
        style: styles.Compact,
        styles: passedStyles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.compact,
        className: "compact-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", null, (0, $55201e71335337d3$export$2e2bcd8739ae039)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $c1983d6ee2646705$export$2e2bcd8739ae039), {
            key: c,
            color: c,
            active: c.toLowerCase() === hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.clear
    })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $cbd676230d43193d$export$2e2bcd8739ae039), {
        hex: hex,
        rgb: rgb,
        onChange: handleChange
    })));
};
$8c45db7c797db79e$export$6479582a9c9e50ce.propTypes = {
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).string),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).object
};
$8c45db7c797db79e$export$6479582a9c9e50ce.defaultProps = {
    colors: [
        "#4D4D4D",
        "#999999",
        "#FFFFFF",
        "#F44E3B",
        "#FE9200",
        "#FCDC00",
        "#DBDF00",
        "#A4DD00",
        "#68CCCA",
        "#73D8FF",
        "#AEA1FF",
        "#FDA1FF",
        "#333333",
        "#808080",
        "#cccccc",
        "#D33115",
        "#E27300",
        "#FCC400",
        "#B0BC00",
        "#68BC00",
        "#16A5A5",
        "#009CE0",
        "#7B64FF",
        "#FA28FF",
        "#000000",
        "#666666",
        "#B3B3B3",
        "#9F0500",
        "#C45100",
        "#FB9E00",
        "#808900",
        "#194D33",
        "#0C797D",
        "#0062B1",
        "#653294",
        "#AB149E"
    ],
    styles: {}
};
var $8c45db7c797db79e$export$2e2bcd8739ae039 = (0, $0b94bdc4c9eeec33$export$2e2bcd8739ae039)($8c45db7c797db79e$export$6479582a9c9e50ce);



var $jC8Vy = parcelRequire("jC8Vy");

var $bD9Bx = parcelRequire("bD9Bx");





var $jC8Vy = parcelRequire("jC8Vy");


var $f91ee3853601001d$export$d653c538b92bb84f = function GithubSwatch(_ref) {
    var hover = _ref.hover, color = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
    var hoverSwatch = {
        position: "relative",
        zIndex: "2",
        outline: "2px solid #fff",
        boxShadow: "0 0 5px 2px rgba(0,0,0,0.25)"
    };
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))({
        "default": {
            swatch: {
                width: "25px",
                height: "25px",
                fontSize: "0"
            }
        },
        "hover": {
            swatch: hoverSwatch
        }
    }, {
        hover: hover
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $f6e39602c7ca87c2$export$2e2bcd8739ae039), {
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: hoverSwatch
    }));
};
var $f91ee3853601001d$export$2e2bcd8739ae039 = (0, $081a95961b0cb73f$exports.handleHover)($f91ee3853601001d$export$d653c538b92bb84f);


var $531c46207e35a238$export$61d478c2aba5d9a5 = function Github(_ref) {
    var width = _ref.width, colors = _ref.colors, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))((0, $248c37d10097eba3$export$2e2bcd8739ae039)({
        "default": {
            card: {
                width: width,
                background: "#fff",
                border: "1px solid rgba(0,0,0,0.2)",
                boxShadow: "0 3px 12px rgba(0,0,0,0.15)",
                borderRadius: "4px",
                position: "relative",
                padding: "5px",
                display: "flex",
                flexWrap: "wrap"
            },
            triangle: {
                position: "absolute",
                border: "7px solid transparent",
                borderBottomColor: "#fff"
            },
            triangleShadow: {
                position: "absolute",
                border: "8px solid transparent",
                borderBottomColor: "rgba(0,0,0,0.15)"
            }
        },
        "hide-triangle": {
            triangle: {
                display: "none"
            },
            triangleShadow: {
                display: "none"
            }
        },
        "top-left-triangle": {
            triangle: {
                top: "-14px",
                left: "10px"
            },
            triangleShadow: {
                top: "-16px",
                left: "9px"
            }
        },
        "top-right-triangle": {
            triangle: {
                top: "-14px",
                right: "10px"
            },
            triangleShadow: {
                top: "-16px",
                right: "9px"
            }
        },
        "bottom-left-triangle": {
            triangle: {
                top: "35px",
                left: "10px",
                transform: "rotate(180deg)"
            },
            triangleShadow: {
                top: "37px",
                left: "9px",
                transform: "rotate(180deg)"
            }
        },
        "bottom-right-triangle": {
            triangle: {
                top: "35px",
                right: "10px",
                transform: "rotate(180deg)"
            },
            triangleShadow: {
                top: "37px",
                right: "9px",
                transform: "rotate(180deg)"
            }
        }
    }, passedStyles), {
        "hide-triangle": triangle === "hide",
        "top-left-triangle": triangle === "top-left",
        "top-right-triangle": triangle === "top-right",
        "bottom-left-triangle": triangle === "bottom-left",
        "bottom-right-triangle": triangle === "bottom-right"
    });
    var handleChange = function handleChange(hex, e) {
        return onChange({
            hex: hex,
            source: "hex"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.card,
        className: "github-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.triangleShadow
    }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.triangle
    }), (0, $55201e71335337d3$export$2e2bcd8739ae039)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $f91ee3853601001d$export$2e2bcd8739ae039), {
            color: c,
            key: c,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }));
};
$531c46207e35a238$export$61d478c2aba5d9a5.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).number
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).string),
    triangle: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).oneOf([
        "hide",
        "top-left",
        "top-right",
        "bottom-left",
        "bottom-right"
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).object
};
$531c46207e35a238$export$61d478c2aba5d9a5.defaultProps = {
    width: 200,
    colors: [
        "#B80000",
        "#DB3E00",
        "#FCCB00",
        "#008B02",
        "#006B76",
        "#1273DE",
        "#004DCF",
        "#5300EB",
        "#EB9694",
        "#FAD0C3",
        "#FEF3BD",
        "#C1E1C5",
        "#BEDADC",
        "#C4DEF6",
        "#BED3F3",
        "#D4C4FB"
    ],
    triangle: "top-left",
    styles: {}
};
var $531c46207e35a238$export$2e2bcd8739ae039 = (0, $0b94bdc4c9eeec33$export$2e2bcd8739ae039)($531c46207e35a238$export$61d478c2aba5d9a5);



var $jC8Vy = parcelRequire("jC8Vy");

var $bD9Bx = parcelRequire("bD9Bx");




var $jC8Vy = parcelRequire("jC8Vy");

var $c797b5f6f6b0b51e$export$9c10b52c64965f67 = function SliderPointer(_ref) {
    var direction = _ref.direction;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))({
        "default": {
            picker: {
                width: "18px",
                height: "18px",
                borderRadius: "50%",
                transform: "translate(-9px, -1px)",
                backgroundColor: "rgb(248, 248, 248)",
                boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
            }
        },
        "vertical": {
            picker: {
                transform: "translate(-3px, -9px)"
            }
        }
    }, {
        vertical: direction === "vertical"
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.picker
    });
};
var $c797b5f6f6b0b51e$export$2e2bcd8739ae039 = $c797b5f6f6b0b51e$export$9c10b52c64965f67;


var $3473263423126464$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $3473263423126464$export$f176087feb20230e = function HuePicker(_ref) {
    var width = _ref.width, height = _ref.height, onChange = _ref.onChange, hsl = _ref.hsl, direction = _ref.direction, pointer = _ref.pointer, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))((0, $248c37d10097eba3$export$2e2bcd8739ae039)({
        "default": {
            picker: {
                position: "relative",
                width: width,
                height: height
            },
            hue: {
                radius: "2px"
            }
        }
    }, passedStyles));
    // Overwrite to provide pure hue color
    var handleChange = function handleChange(data) {
        return onChange({
            a: 1,
            h: data.h,
            l: 0.5,
            s: 1
        });
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.picker,
        className: "hue-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $38476a9de322d712$export$2e2bcd8739ae039), $3473263423126464$var$_extends({}, styles.hue, {
        hsl: hsl,
        pointer: pointer,
        onChange: handleChange,
        direction: direction
    })));
};
$3473263423126464$export$f176087feb20230e.propTypes = {
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).object
};
$3473263423126464$export$f176087feb20230e.defaultProps = {
    width: "316px",
    height: "16px",
    direction: "horizontal",
    pointer: (0, $c797b5f6f6b0b51e$export$2e2bcd8739ae039),
    styles: {}
};
var $3473263423126464$export$2e2bcd8739ae039 = (0, $0b94bdc4c9eeec33$export$2e2bcd8739ae039)($3473263423126464$export$f176087feb20230e);



var $jC8Vy = parcelRequire("jC8Vy");




var $78b1b5acb77c45f6$export$a2d8b23205c25948 = function Material(_ref) {
    var onChange = _ref.onChange, hex = _ref.hex, rgb = _ref.rgb, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))((0, $248c37d10097eba3$export$2e2bcd8739ae039)({
        "default": {
            material: {
                width: "98px",
                height: "98px",
                padding: "16px",
                fontFamily: "Roboto"
            },
            HEXwrap: {
                position: "relative"
            },
            HEXinput: {
                width: "100%",
                marginTop: "12px",
                fontSize: "15px",
                color: "#333",
                padding: "0px",
                border: "0px",
                borderBottom: "2px solid " + hex,
                outline: "none",
                height: "30px"
            },
            HEXlabel: {
                position: "absolute",
                top: "0px",
                left: "0px",
                fontSize: "11px",
                color: "#999999",
                textTransform: "capitalize"
            },
            Hex: {
                style: {}
            },
            RGBwrap: {
                position: "relative"
            },
            RGBinput: {
                width: "100%",
                marginTop: "12px",
                fontSize: "15px",
                color: "#333",
                padding: "0px",
                border: "0px",
                borderBottom: "1px solid #eee",
                outline: "none",
                height: "30px"
            },
            RGBlabel: {
                position: "absolute",
                top: "0px",
                left: "0px",
                fontSize: "11px",
                color: "#999999",
                textTransform: "capitalize"
            },
            split: {
                display: "flex",
                marginRight: "-10px",
                paddingTop: "11px"
            },
            third: {
                flex: "1",
                paddingRight: "10px"
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        if (data.hex) $576ec6501ba2ee42$export$944f75ec5697b362(data.hex) && onChange({
            hex: data.hex,
            source: "hex"
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: "rgb"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $741d377d9dbb89cf$export$2e2bcd8739ae039), {
        styles: passedStyles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.material,
        className: "material-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: "hex",
        value: hex,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.split,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.third
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "r",
        value: rgb.r,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.third
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "g",
        value: rgb.g,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.third
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "b",
        value: rgb.b,
        onChange: handleChange
    })))));
};
var $78b1b5acb77c45f6$export$2e2bcd8739ae039 = (0, $0b94bdc4c9eeec33$export$2e2bcd8739ae039)($78b1b5acb77c45f6$export$a2d8b23205c25948);



var $jC8Vy = parcelRequire("jC8Vy");

var $bD9Bx = parcelRequire("bD9Bx");




var $jC8Vy = parcelRequire("jC8Vy");



var $893f5bf6ca4adc3b$export$b1808ee9bfa8f4d0 = function PhotoshopPicker(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsv = _ref.hsv, hex = _ref.hex;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))({
        "default": {
            fields: {
                paddingTop: "5px",
                paddingBottom: "9px",
                width: "80px",
                position: "relative"
            },
            divider: {
                height: "5px"
            },
            RGBwrap: {
                position: "relative"
            },
            RGBinput: {
                marginLeft: "40%",
                width: "40%",
                height: "18px",
                border: "1px solid #888888",
                boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
                marginBottom: "5px",
                fontSize: "13px",
                paddingLeft: "3px",
                marginRight: "10px"
            },
            RGBlabel: {
                left: "0px",
                top: "0px",
                width: "34px",
                textTransform: "uppercase",
                fontSize: "13px",
                height: "18px",
                lineHeight: "22px",
                position: "absolute"
            },
            HEXwrap: {
                position: "relative"
            },
            HEXinput: {
                marginLeft: "20%",
                width: "80%",
                height: "18px",
                border: "1px solid #888888",
                boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
                marginBottom: "6px",
                fontSize: "13px",
                paddingLeft: "3px"
            },
            HEXlabel: {
                position: "absolute",
                top: "0px",
                left: "0px",
                width: "14px",
                textTransform: "uppercase",
                fontSize: "13px",
                height: "18px",
                lineHeight: "22px"
            },
            fieldSymbols: {
                position: "absolute",
                top: "5px",
                right: "-7px",
                fontSize: "13px"
            },
            symbol: {
                height: "20px",
                lineHeight: "22px",
                paddingBottom: "7px"
            }
        }
    });
    var handleChange = function handleChange(data, e) {
        if (data["#"]) $576ec6501ba2ee42$export$944f75ec5697b362(data["#"]) && onChange({
            hex: data["#"],
            source: "hex"
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: "rgb"
        }, e);
        else if (data.h || data.s || data.v) onChange({
            h: data.h || hsv.h,
            s: data.s || hsv.s,
            v: data.v || hsv.v,
            source: "hsv"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.fields
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "h",
        value: Math.round(hsv.h),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "s",
        value: Math.round(hsv.s * 100),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "v",
        value: Math.round(hsv.v * 100),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.divider
    }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "r",
        value: rgb.r,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "g",
        value: rgb.g,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "b",
        value: rgb.b,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.divider
    }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: "#",
        value: hex.replace("#", ""),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.fieldSymbols
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.symbol
    }, "\xb0"), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.symbol
    }, "%"), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.symbol
    }, "%")));
};
var $893f5bf6ca4adc3b$export$2e2bcd8739ae039 = $893f5bf6ca4adc3b$export$b1808ee9bfa8f4d0;



var $jC8Vy = parcelRequire("jC8Vy");

var $e397d1957112f57c$export$123b96ff8455915 = function PhotoshopPointerCircle(_ref) {
    var hsl = _ref.hsl;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))({
        "default": {
            picker: {
                width: "12px",
                height: "12px",
                borderRadius: "6px",
                boxShadow: "inset 0 0 0 1px #fff",
                transform: "translate(-6px, -6px)"
            }
        },
        "black-outline": {
            picker: {
                boxShadow: "inset 0 0 0 1px #000"
            }
        }
    }, {
        "black-outline": hsl.l > 0.5
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.picker
    });
};
var $e397d1957112f57c$export$2e2bcd8739ae039 = $e397d1957112f57c$export$123b96ff8455915;



var $jC8Vy = parcelRequire("jC8Vy");

var $a0e01a3a019bd287$export$123b96ff8455915 = function PhotoshopPointerCircle() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))({
        "default": {
            triangle: {
                width: 0,
                height: 0,
                borderStyle: "solid",
                borderWidth: "4px 0 4px 6px",
                borderColor: "transparent transparent transparent #fff",
                position: "absolute",
                top: "1px",
                left: "1px"
            },
            triangleBorder: {
                width: 0,
                height: 0,
                borderStyle: "solid",
                borderWidth: "5px 0 5px 8px",
                borderColor: "transparent transparent transparent #555"
            },
            left: {
                Extend: "triangleBorder",
                transform: "translate(-13px, -4px)"
            },
            leftInside: {
                Extend: "triangle",
                transform: "translate(-8px, -5px)"
            },
            right: {
                Extend: "triangleBorder",
                transform: "translate(20px, -14px) rotate(180deg)"
            },
            rightInside: {
                Extend: "triangle",
                transform: "translate(-8px, -5px)"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.pointer
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.left
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.leftInside
    })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.right
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.rightInside
    })));
};
var $a0e01a3a019bd287$export$2e2bcd8739ae039 = $a0e01a3a019bd287$export$123b96ff8455915;



var $jC8Vy = parcelRequire("jC8Vy");

var $ac090f558e0d2ba9$export$f7d38a0bd3b98717 = function PhotoshopButton(_ref) {
    var onClick = _ref.onClick, label = _ref.label, children = _ref.children, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))({
        "default": {
            button: {
                backgroundImage: "linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)",
                border: "1px solid #878787",
                borderRadius: "2px",
                height: "20px",
                boxShadow: "0 1px 0 0 #EAEAEA",
                fontSize: "14px",
                color: "#000",
                lineHeight: "20px",
                textAlign: "center",
                marginBottom: "10px",
                cursor: "pointer"
            }
        },
        "active": {
            button: {
                boxShadow: "0 0 0 1px #878787"
            }
        }
    }, {
        active: active
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.button,
        onClick: onClick
    }, label || children);
};
var $ac090f558e0d2ba9$export$2e2bcd8739ae039 = $ac090f558e0d2ba9$export$f7d38a0bd3b98717;



var $jC8Vy = parcelRequire("jC8Vy");

var $a32083068bb458a2$export$ce0d7acd66f46f2b = function PhotoshopPreviews(_ref) {
    var rgb = _ref.rgb, currentColor = _ref.currentColor;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))({
        "default": {
            swatches: {
                border: "1px solid #B3B3B3",
                borderBottom: "1px solid #F0F0F0",
                marginBottom: "2px",
                marginTop: "1px"
            },
            new: {
                height: "34px",
                background: "rgb(" + rgb.r + "," + rgb.g + ", " + rgb.b + ")",
                boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000"
            },
            current: {
                height: "34px",
                background: currentColor,
                boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000"
            },
            label: {
                fontSize: "14px",
                color: "#000",
                textAlign: "center"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.label
    }, "new"), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.swatches
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.new
    }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.current
    })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.label
    }, "current"));
};
var $a32083068bb458a2$export$2e2bcd8739ae039 = $a32083068bb458a2$export$ce0d7acd66f46f2b;


var $ce9b82f67cc9e89a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $ce9b82f67cc9e89a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ce9b82f67cc9e89a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $ce9b82f67cc9e89a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $ce9b82f67cc9e89a$export$4ed116dea8ad5956 = function(_React$Component) {
    $ce9b82f67cc9e89a$var$_inherits(Photoshop, _React$Component);
    function Photoshop(props) {
        $ce9b82f67cc9e89a$var$_classCallCheck(this, Photoshop);
        var _this = $ce9b82f67cc9e89a$var$_possibleConstructorReturn(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));
        _this.state = {
            currentColor: props.hex
        };
        return _this;
    }
    $ce9b82f67cc9e89a$var$_createClass(Photoshop, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, _props$styles = _props.styles, passedStyles = _props$styles === undefined ? {} : _props$styles, _props$className = _props.className, className = _props$className === undefined ? "" : _props$className;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))((0, $248c37d10097eba3$export$2e2bcd8739ae039)({
                    "default": {
                        picker: {
                            background: "#DCDCDC",
                            borderRadius: "4px",
                            boxShadow: "0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)",
                            boxSizing: "initial",
                            width: "513px"
                        },
                        head: {
                            backgroundImage: "linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)",
                            borderBottom: "1px solid #B1B1B1",
                            boxShadow: "inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)",
                            height: "23px",
                            lineHeight: "24px",
                            borderRadius: "4px 4px 0 0",
                            fontSize: "13px",
                            color: "#4D4D4D",
                            textAlign: "center"
                        },
                        body: {
                            padding: "15px 15px 0",
                            display: "flex"
                        },
                        saturation: {
                            width: "256px",
                            height: "256px",
                            position: "relative",
                            border: "2px solid #B3B3B3",
                            borderBottom: "2px solid #F0F0F0",
                            overflow: "hidden"
                        },
                        hue: {
                            position: "relative",
                            height: "256px",
                            width: "19px",
                            marginLeft: "10px",
                            border: "2px solid #B3B3B3",
                            borderBottom: "2px solid #F0F0F0"
                        },
                        controls: {
                            width: "180px",
                            marginLeft: "10px"
                        },
                        top: {
                            display: "flex"
                        },
                        previews: {
                            width: "60px"
                        },
                        actions: {
                            flex: "1",
                            marginLeft: "20px"
                        }
                    }
                }, passedStyles));
                return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.picker,
                    className: "photoshop-picker " + className
                }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.head
                }, this.props.header), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.body,
                    className: "flexbox-fix"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.saturation
                }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $97e77a17c0f73a8b$export$2e2bcd8739ae039), {
                    hsl: this.props.hsl,
                    hsv: this.props.hsv,
                    pointer: (0, $e397d1957112f57c$export$2e2bcd8739ae039),
                    onChange: this.props.onChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.hue
                }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $38476a9de322d712$export$2e2bcd8739ae039), {
                    direction: "vertical",
                    hsl: this.props.hsl,
                    pointer: (0, $a0e01a3a019bd287$export$2e2bcd8739ae039),
                    onChange: this.props.onChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.controls
                }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.top,
                    className: "flexbox-fix"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.previews
                }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $a32083068bb458a2$export$2e2bcd8739ae039), {
                    rgb: this.props.rgb,
                    currentColor: this.state.currentColor
                })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    style: styles.actions
                }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $ac090f558e0d2ba9$export$2e2bcd8739ae039), {
                    label: "OK",
                    onClick: this.props.onAccept,
                    active: true
                }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $ac090f558e0d2ba9$export$2e2bcd8739ae039), {
                    label: "Cancel",
                    onClick: this.props.onCancel
                }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $893f5bf6ca4adc3b$export$2e2bcd8739ae039), {
                    onChange: this.props.onChange,
                    rgb: this.props.rgb,
                    hsv: this.props.hsv,
                    hex: this.props.hex
                }))))));
            }
        }
    ]);
    return Photoshop;
}((0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).Component);
$ce9b82f67cc9e89a$export$4ed116dea8ad5956.propTypes = {
    header: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).string,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).object
};
$ce9b82f67cc9e89a$export$4ed116dea8ad5956.defaultProps = {
    header: "Color Picker",
    styles: {}
};
var $ce9b82f67cc9e89a$export$2e2bcd8739ae039 = (0, $0b94bdc4c9eeec33$export$2e2bcd8739ae039)($ce9b82f67cc9e89a$export$4ed116dea8ad5956);



var $jC8Vy = parcelRequire("jC8Vy");

var $bD9Bx = parcelRequire("bD9Bx");



/* eslint-disable no-param-reassign */ 
var $jC8Vy = parcelRequire("jC8Vy");



var $2754958a590d5ab2$export$a9bdb1170868e062 = function SketchFields(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hex = _ref.hex, disableAlpha = _ref.disableAlpha;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))({
        "default": {
            fields: {
                display: "flex",
                paddingTop: "4px"
            },
            single: {
                flex: "1",
                paddingLeft: "6px"
            },
            alpha: {
                flex: "1",
                paddingLeft: "6px"
            },
            double: {
                flex: "2"
            },
            input: {
                width: "80%",
                padding: "4px 10% 3px",
                border: "none",
                boxShadow: "inset 0 0 0 1px #ccc",
                fontSize: "11px"
            },
            label: {
                display: "block",
                textAlign: "center",
                fontSize: "11px",
                color: "#222",
                paddingTop: "3px",
                paddingBottom: "4px",
                textTransform: "capitalize"
            }
        },
        "disableAlpha": {
            alpha: {
                display: "none"
            }
        }
    }, {
        disableAlpha: disableAlpha
    });
    var handleChange = function handleChange(data, e) {
        if (data.hex) $576ec6501ba2ee42$export$944f75ec5697b362(data.hex) && onChange({
            hex: data.hex,
            source: "hex"
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            a: rgb.a,
            source: "rgb"
        }, e);
        else if (data.a) {
            if (data.a < 0) data.a = 0;
            else if (data.a > 100) data.a = 100;
            data.a /= 100;
            onChange({
                h: hsl.h,
                s: hsl.s,
                l: hsl.l,
                a: data.a,
                source: "rgb"
            }, e);
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.fields,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.double
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "hex",
        value: hex.replace("#", ""),
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "r",
        value: rgb.r,
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "255"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "g",
        value: rgb.g,
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "255"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "b",
        value: rgb.b,
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "255"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.alpha
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "a",
        value: Math.round(rgb.a * 100),
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "100"
    })));
};
var $2754958a590d5ab2$export$2e2bcd8739ae039 = $2754958a590d5ab2$export$a9bdb1170868e062;



var $jC8Vy = parcelRequire("jC8Vy");

var $bD9Bx = parcelRequire("bD9Bx");


var $2421270f98de4cad$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $2421270f98de4cad$export$cc78acae6744db3b = function SketchPresetColors(_ref) {
    var colors = _ref.colors, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))({
        "default": {
            colors: {
                margin: "0 -10px",
                padding: "10px 0 0 10px",
                borderTop: "1px solid #eee",
                display: "flex",
                flexWrap: "wrap",
                position: "relative"
            },
            swatchWrap: {
                width: "16px",
                height: "16px",
                margin: "0 10px 10px 0"
            },
            swatch: {
                borderRadius: "3px",
                boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15)"
            }
        },
        "no-presets": {
            colors: {
                display: "none"
            }
        }
    }, {
        "no-presets": !colors || !colors.length
    });
    var handleClick = function handleClick(hex, e) {
        onClick({
            hex: hex,
            source: "hex"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.colors,
        className: "flexbox-fix"
    }, colors.map(function(colorObjOrString) {
        var c = typeof colorObjOrString === "string" ? {
            color: colorObjOrString
        } : colorObjOrString;
        var key = "" + c.color + (c.title || "");
        return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
            key: key,
            style: styles.swatchWrap
        }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $f6e39602c7ca87c2$export$2e2bcd8739ae039), $2421270f98de4cad$var$_extends({}, c, {
            style: styles.swatch,
            onClick: handleClick,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px " + c.color
            }
        })));
    }));
};
$2421270f98de4cad$export$cc78acae6744db3b.propTypes = {
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).shape({
            color: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).string,
            title: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).string
        })
    ])).isRequired
};
var $2421270f98de4cad$export$2e2bcd8739ae039 = $2421270f98de4cad$export$cc78acae6744db3b;


var $7a77c34194842d33$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $7a77c34194842d33$export$361fce2090be193f = function Sketch(_ref) {
    var width = _ref.width, rgb = _ref.rgb, hex = _ref.hex, hsv = _ref.hsv, hsl = _ref.hsl, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, disableAlpha = _ref.disableAlpha, presetColors = _ref.presetColors, renderers = _ref.renderers, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))((0, $248c37d10097eba3$export$2e2bcd8739ae039)({
        "default": $7a77c34194842d33$var$_extends({
            picker: {
                width: width,
                padding: "10px 10px 0",
                boxSizing: "initial",
                background: "#fff",
                borderRadius: "4px",
                boxShadow: "0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)"
            },
            saturation: {
                width: "100%",
                paddingBottom: "75%",
                position: "relative",
                overflow: "hidden"
            },
            Saturation: {
                radius: "3px",
                shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
            },
            controls: {
                display: "flex"
            },
            sliders: {
                padding: "4px 0",
                flex: "1"
            },
            color: {
                width: "24px",
                height: "24px",
                position: "relative",
                marginTop: "4px",
                marginLeft: "4px",
                borderRadius: "3px"
            },
            activeColor: {
                absolute: "0px 0px 0px 0px",
                borderRadius: "2px",
                background: "rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + "," + rgb.a + ")",
                boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
            },
            hue: {
                position: "relative",
                height: "10px",
                overflow: "hidden"
            },
            Hue: {
                radius: "2px",
                shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
            },
            alpha: {
                position: "relative",
                height: "10px",
                marginTop: "4px",
                overflow: "hidden"
            },
            Alpha: {
                radius: "2px",
                shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
            }
        }, passedStyles),
        "disableAlpha": {
            color: {
                height: "10px"
            },
            hue: {
                height: "10px"
            },
            alpha: {
                display: "none"
            }
        }
    }, passedStyles), {
        disableAlpha: disableAlpha
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.picker,
        className: "sketch-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.saturation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $97e77a17c0f73a8b$export$2e2bcd8739ae039), {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.controls,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.sliders
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $38476a9de322d712$export$2e2bcd8739ae039), {
        style: styles.Hue,
        hsl: hsl,
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.alpha
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $c7fcad7bb70c839d$export$2e2bcd8739ae039), {
        style: styles.Alpha,
        rgb: rgb,
        hsl: hsl,
        renderers: renderers,
        onChange: onChange
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $06778ce7e366f6d8$export$2e2bcd8739ae039), null), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.activeColor
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $2754958a590d5ab2$export$2e2bcd8739ae039), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        onChange: onChange,
        disableAlpha: disableAlpha
    }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $2421270f98de4cad$export$2e2bcd8739ae039), {
        colors: presetColors,
        onClick: onChange,
        onSwatchHover: onSwatchHover
    }));
};
$7a77c34194842d33$export$361fce2090be193f.propTypes = {
    disableAlpha: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).bool,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).number
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).object
};
$7a77c34194842d33$export$361fce2090be193f.defaultProps = {
    disableAlpha: false,
    width: 200,
    styles: {},
    presetColors: [
        "#D0021B",
        "#F5A623",
        "#F8E71C",
        "#8B572A",
        "#7ED321",
        "#417505",
        "#BD10E0",
        "#9013FE",
        "#4A90E2",
        "#50E3C2",
        "#B8E986",
        "#000000",
        "#4A4A4A",
        "#9B9B9B",
        "#FFFFFF"
    ]
};
var $7a77c34194842d33$export$2e2bcd8739ae039 = (0, $0b94bdc4c9eeec33$export$2e2bcd8739ae039)($7a77c34194842d33$export$361fce2090be193f);



var $jC8Vy = parcelRequire("jC8Vy");

var $bD9Bx = parcelRequire("bD9Bx");




var $jC8Vy = parcelRequire("jC8Vy");


var $jC8Vy = parcelRequire("jC8Vy");

var $47284f5d4bf20640$export$5c11afa672411de4 = function SliderSwatch(_ref) {
    var hsl = _ref.hsl, offset = _ref.offset, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, active = _ref.active, first = _ref.first, last = _ref.last;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))({
        "default": {
            swatch: {
                height: "12px",
                background: "hsl(" + hsl.h + ", 50%, " + offset * 100 + "%)",
                cursor: "pointer"
            }
        },
        "first": {
            swatch: {
                borderRadius: "2px 0 0 2px"
            }
        },
        "last": {
            swatch: {
                borderRadius: "0 2px 2px 0"
            }
        },
        "active": {
            swatch: {
                transform: "scaleY(1.8)",
                borderRadius: "3.6px/2px"
            }
        }
    }, {
        active: active,
        first: first,
        last: last
    });
    var handleClick = function handleClick(e) {
        return onClick({
            h: hsl.h,
            s: 0.5,
            l: offset,
            source: "hsl"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.swatch,
        onClick: handleClick
    });
};
var $47284f5d4bf20640$export$2e2bcd8739ae039 = $47284f5d4bf20640$export$5c11afa672411de4;


var $a3e01c7420ce8159$export$48f49e32c66cdd61 = function SliderSwatches(_ref) {
    var onClick = _ref.onClick, hsl = _ref.hsl;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))({
        "default": {
            swatches: {
                marginTop: "20px"
            },
            swatch: {
                boxSizing: "border-box",
                width: "20%",
                paddingRight: "1px",
                float: "left"
            },
            clear: {
                clear: "both"
            }
        }
    });
    // Acceptible difference in floating point equality
    var epsilon = 0.1;
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.swatches
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $47284f5d4bf20640$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: ".80",
        active: Math.abs(hsl.l - 0.80) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        first: true
    })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $47284f5d4bf20640$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: ".65",
        active: Math.abs(hsl.l - 0.65) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $47284f5d4bf20640$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: ".50",
        active: Math.abs(hsl.l - 0.50) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $47284f5d4bf20640$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: ".35",
        active: Math.abs(hsl.l - 0.35) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $47284f5d4bf20640$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: ".20",
        active: Math.abs(hsl.l - 0.20) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        last: true
    })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.clear
    }));
};
var $a3e01c7420ce8159$export$2e2bcd8739ae039 = $a3e01c7420ce8159$export$48f49e32c66cdd61;



var $jC8Vy = parcelRequire("jC8Vy");

var $1afd51bfae00101a$export$9c10b52c64965f67 = function SliderPointer() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))({
        "default": {
            picker: {
                width: "14px",
                height: "14px",
                borderRadius: "6px",
                transform: "translate(-7px, -1px)",
                backgroundColor: "rgb(248, 248, 248)",
                boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.picker
    });
};
var $1afd51bfae00101a$export$2e2bcd8739ae039 = $1afd51bfae00101a$export$9c10b52c64965f67;


var $95f9996587ec3a0e$export$472062a354075cee = function Slider(_ref) {
    var hsl = _ref.hsl, onChange = _ref.onChange, pointer = _ref.pointer, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))((0, $248c37d10097eba3$export$2e2bcd8739ae039)({
        "default": {
            hue: {
                height: "12px",
                position: "relative"
            },
            Hue: {
                radius: "2px"
            }
        }
    }, passedStyles));
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.wrap || {},
        className: "slider-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $38476a9de322d712$export$2e2bcd8739ae039), {
        style: styles.Hue,
        hsl: hsl,
        pointer: pointer,
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.swatches
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $a3e01c7420ce8159$export$2e2bcd8739ae039), {
        hsl: hsl,
        onClick: onChange
    })));
};
$95f9996587ec3a0e$export$472062a354075cee.propTypes = {
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).object
};
$95f9996587ec3a0e$export$472062a354075cee.defaultProps = {
    pointer: (0, $1afd51bfae00101a$export$2e2bcd8739ae039),
    styles: {}
};
var $95f9996587ec3a0e$export$2e2bcd8739ae039 = (0, $0b94bdc4c9eeec33$export$2e2bcd8739ae039)($95f9996587ec3a0e$export$472062a354075cee);



var $jC8Vy = parcelRequire("jC8Vy");

var $bD9Bx = parcelRequire("bD9Bx");






var $jC8Vy = parcelRequire("jC8Vy");



var $jC8Vy = parcelRequire("jC8Vy");



var $f2ae163d88ac8cc1$exports = {};
"use strict";
Object.defineProperty($f2ae163d88ac8cc1$exports, "__esModule", {
    value: true
});
var $f2ae163d88ac8cc1$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $jC8Vy = parcelRequire("jC8Vy");
var $f2ae163d88ac8cc1$var$_react2 = $f2ae163d88ac8cc1$var$_interopRequireDefault($jC8Vy);
function $f2ae163d88ac8cc1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f2ae163d88ac8cc1$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $f2ae163d88ac8cc1$var$DEFAULT_SIZE = 24;
$f2ae163d88ac8cc1$exports.default = function(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === undefined ? "currentColor" : _ref$fill, _ref$width = _ref.width, width = _ref$width === undefined ? $f2ae163d88ac8cc1$var$DEFAULT_SIZE : _ref$width, _ref$height = _ref.height, height = _ref$height === undefined ? $f2ae163d88ac8cc1$var$DEFAULT_SIZE : _ref$height, _ref$style = _ref.style, style = _ref$style === undefined ? {} : _ref$style, props = $f2ae163d88ac8cc1$var$_objectWithoutProperties(_ref, [
        "fill",
        "width",
        "height",
        "style"
    ]);
    return $f2ae163d88ac8cc1$var$_react2.default.createElement("svg", $f2ae163d88ac8cc1$var$_extends({
        viewBox: "0 0 " + $f2ae163d88ac8cc1$var$DEFAULT_SIZE + " " + $f2ae163d88ac8cc1$var$DEFAULT_SIZE,
        style: $f2ae163d88ac8cc1$var$_extends({
            fill: fill,
            width: width,
            height: height
        }, style)
    }, props), $f2ae163d88ac8cc1$var$_react2.default.createElement("path", {
        d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"
    }));
};


var $99eaa5f019fa59e9$export$af5303fde6798b43 = function SwatchesColor(_ref) {
    var color = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover, first = _ref.first, last = _ref.last, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))({
        "default": {
            color: {
                width: "40px",
                height: "24px",
                cursor: "pointer",
                background: color,
                marginBottom: "1px"
            },
            check: {
                color: $576ec6501ba2ee42$export$3609eb1d7e55dec(color),
                marginLeft: "8px",
                display: "none"
            }
        },
        "first": {
            color: {
                overflow: "hidden",
                borderRadius: "2px 2px 0 0"
            }
        },
        "last": {
            color: {
                overflow: "hidden",
                borderRadius: "0 0 2px 2px"
            }
        },
        "active": {
            check: {
                display: "block"
            }
        },
        "color-#FFFFFF": {
            color: {
                boxShadow: "inset 0 0 0 1px #ddd"
            },
            check: {
                color: "#333"
            }
        },
        "transparent": {
            check: {
                color: "#333"
            }
        }
    }, {
        first: first,
        last: last,
        active: active,
        "color-#FFFFFF": color === "#FFFFFF",
        "transparent": color === "transparent"
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $f6e39602c7ca87c2$export$2e2bcd8739ae039), {
        color: color,
        style: styles.color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: "0 0 4px " + color
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.check
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f2ae163d88ac8cc1$exports))), null)));
};
var $99eaa5f019fa59e9$export$2e2bcd8739ae039 = $99eaa5f019fa59e9$export$af5303fde6798b43;


var $5f6bcbe52223ee31$export$354a0399ec1ad469 = function SwatchesGroup(_ref) {
    var onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, group = _ref.group, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))({
        "default": {
            group: {
                paddingBottom: "10px",
                width: "40px",
                float: "left",
                marginRight: "10px"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.group
    }, (0, $55201e71335337d3$export$2e2bcd8739ae039)(group, function(color, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $99eaa5f019fa59e9$export$2e2bcd8739ae039), {
            key: color,
            color: color,
            active: color.toLowerCase() === active,
            first: i === 0,
            last: i === group.length - 1,
            onClick: onClick,
            onSwatchHover: onSwatchHover
        });
    }));
};
var $5f6bcbe52223ee31$export$2e2bcd8739ae039 = $5f6bcbe52223ee31$export$354a0399ec1ad469;


var $0e830ad4002d4172$export$81ebbfd13e06b049 = function Swatches(_ref) {
    var width = _ref.width, height = _ref.height, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))((0, $248c37d10097eba3$export$2e2bcd8739ae039)({
        "default": {
            picker: {
                width: width,
                height: height
            },
            overflow: {
                height: height,
                overflowY: "scroll"
            },
            body: {
                padding: "16px 0 6px 16px"
            },
            clear: {
                clear: "both"
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        return onChange({
            hex: data,
            source: "hex"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.picker,
        className: "swatches-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $741d377d9dbb89cf$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.overflow
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.body
    }, (0, $55201e71335337d3$export$2e2bcd8739ae039)(colors, function(group) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $5f6bcbe52223ee31$export$2e2bcd8739ae039), {
            key: group.toString(),
            group: group,
            active: hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.clear
    })))));
};
$0e830ad4002d4172$export$81ebbfd13e06b049.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).number
    ]),
    height: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).number
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).string)),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).object
};
$0e830ad4002d4172$export$81ebbfd13e06b049.defaultProps = {
    width: 320,
    height: 240,
    colors: [
        [
            $433034794868c5fe$export$a90204d1394caf30["900"],
            $433034794868c5fe$export$a90204d1394caf30["700"],
            $433034794868c5fe$export$a90204d1394caf30["500"],
            $433034794868c5fe$export$a90204d1394caf30["300"],
            $433034794868c5fe$export$a90204d1394caf30["100"]
        ],
        [
            $433034794868c5fe$export$47853bc718611763["900"],
            $433034794868c5fe$export$47853bc718611763["700"],
            $433034794868c5fe$export$47853bc718611763["500"],
            $433034794868c5fe$export$47853bc718611763["300"],
            $433034794868c5fe$export$47853bc718611763["100"]
        ],
        [
            $433034794868c5fe$export$e13cce2a2d16a9d4["900"],
            $433034794868c5fe$export$e13cce2a2d16a9d4["700"],
            $433034794868c5fe$export$e13cce2a2d16a9d4["500"],
            $433034794868c5fe$export$e13cce2a2d16a9d4["300"],
            $433034794868c5fe$export$e13cce2a2d16a9d4["100"]
        ],
        [
            $433034794868c5fe$export$51ef95b19086af57["900"],
            $433034794868c5fe$export$51ef95b19086af57["700"],
            $433034794868c5fe$export$51ef95b19086af57["500"],
            $433034794868c5fe$export$51ef95b19086af57["300"],
            $433034794868c5fe$export$51ef95b19086af57["100"]
        ],
        [
            $433034794868c5fe$export$3e6ccc7b8562d453["900"],
            $433034794868c5fe$export$3e6ccc7b8562d453["700"],
            $433034794868c5fe$export$3e6ccc7b8562d453["500"],
            $433034794868c5fe$export$3e6ccc7b8562d453["300"],
            $433034794868c5fe$export$3e6ccc7b8562d453["100"]
        ],
        [
            $433034794868c5fe$export$2aa0182783e7e9de["900"],
            $433034794868c5fe$export$2aa0182783e7e9de["700"],
            $433034794868c5fe$export$2aa0182783e7e9de["500"],
            $433034794868c5fe$export$2aa0182783e7e9de["300"],
            $433034794868c5fe$export$2aa0182783e7e9de["100"]
        ],
        [
            $433034794868c5fe$export$7b0d29b70b435c21["900"],
            $433034794868c5fe$export$7b0d29b70b435c21["700"],
            $433034794868c5fe$export$7b0d29b70b435c21["500"],
            $433034794868c5fe$export$7b0d29b70b435c21["300"],
            $433034794868c5fe$export$7b0d29b70b435c21["100"]
        ],
        [
            $433034794868c5fe$export$7474046f446842ee["900"],
            $433034794868c5fe$export$7474046f446842ee["700"],
            $433034794868c5fe$export$7474046f446842ee["500"],
            $433034794868c5fe$export$7474046f446842ee["300"],
            $433034794868c5fe$export$7474046f446842ee["100"]
        ],
        [
            $433034794868c5fe$export$8bf7dff220b82b4a["900"],
            $433034794868c5fe$export$8bf7dff220b82b4a["700"],
            $433034794868c5fe$export$8bf7dff220b82b4a["500"],
            $433034794868c5fe$export$8bf7dff220b82b4a["300"],
            $433034794868c5fe$export$8bf7dff220b82b4a["100"]
        ],
        [
            "#194D33",
            $433034794868c5fe$export$955a2ebd2fb142ae["700"],
            $433034794868c5fe$export$955a2ebd2fb142ae["500"],
            $433034794868c5fe$export$955a2ebd2fb142ae["300"],
            $433034794868c5fe$export$955a2ebd2fb142ae["100"]
        ],
        [
            $433034794868c5fe$export$559a8c00376dc936["900"],
            $433034794868c5fe$export$559a8c00376dc936["700"],
            $433034794868c5fe$export$559a8c00376dc936["500"],
            $433034794868c5fe$export$559a8c00376dc936["300"],
            $433034794868c5fe$export$559a8c00376dc936["100"]
        ],
        [
            $433034794868c5fe$export$221d31baf2636aad["900"],
            $433034794868c5fe$export$221d31baf2636aad["700"],
            $433034794868c5fe$export$221d31baf2636aad["500"],
            $433034794868c5fe$export$221d31baf2636aad["300"],
            $433034794868c5fe$export$221d31baf2636aad["100"]
        ],
        [
            $433034794868c5fe$export$594c5a8758200c32["900"],
            $433034794868c5fe$export$594c5a8758200c32["700"],
            $433034794868c5fe$export$594c5a8758200c32["500"],
            $433034794868c5fe$export$594c5a8758200c32["300"],
            $433034794868c5fe$export$594c5a8758200c32["100"]
        ],
        [
            $433034794868c5fe$export$7c1ecc66643fdbd6["900"],
            $433034794868c5fe$export$7c1ecc66643fdbd6["700"],
            $433034794868c5fe$export$7c1ecc66643fdbd6["500"],
            $433034794868c5fe$export$7c1ecc66643fdbd6["300"],
            $433034794868c5fe$export$7c1ecc66643fdbd6["100"]
        ],
        [
            $433034794868c5fe$export$ad766f34ace1cafd["900"],
            $433034794868c5fe$export$ad766f34ace1cafd["700"],
            $433034794868c5fe$export$ad766f34ace1cafd["500"],
            $433034794868c5fe$export$ad766f34ace1cafd["300"],
            $433034794868c5fe$export$ad766f34ace1cafd["100"]
        ],
        [
            $433034794868c5fe$export$1ceed3dd9ec11704["900"],
            $433034794868c5fe$export$1ceed3dd9ec11704["700"],
            $433034794868c5fe$export$1ceed3dd9ec11704["500"],
            $433034794868c5fe$export$1ceed3dd9ec11704["300"],
            $433034794868c5fe$export$1ceed3dd9ec11704["100"]
        ],
        [
            $433034794868c5fe$export$b6e6178d3f565007["900"],
            $433034794868c5fe$export$b6e6178d3f565007["700"],
            $433034794868c5fe$export$b6e6178d3f565007["500"],
            $433034794868c5fe$export$b6e6178d3f565007["300"],
            $433034794868c5fe$export$b6e6178d3f565007["100"]
        ],
        [
            $433034794868c5fe$export$7c2da42d08c019c9["900"],
            $433034794868c5fe$export$7c2da42d08c019c9["700"],
            $433034794868c5fe$export$7c2da42d08c019c9["500"],
            $433034794868c5fe$export$7c2da42d08c019c9["300"],
            $433034794868c5fe$export$7c2da42d08c019c9["100"]
        ],
        [
            "#000000",
            "#525252",
            "#969696",
            "#D9D9D9",
            "#FFFFFF"
        ]
    ],
    styles: {}
};
var $0e830ad4002d4172$export$2e2bcd8739ae039 = (0, $0b94bdc4c9eeec33$export$2e2bcd8739ae039)($0e830ad4002d4172$export$81ebbfd13e06b049);



var $jC8Vy = parcelRequire("jC8Vy");

var $bD9Bx = parcelRequire("bD9Bx");





var $1ad89b9220431399$export$9e389cdad32a5b7a = function Twitter(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex = _ref.hex, colors = _ref.colors, width = _ref.width, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))((0, $248c37d10097eba3$export$2e2bcd8739ae039)({
        "default": {
            card: {
                width: width,
                background: "#fff",
                border: "0 solid rgba(0,0,0,0.25)",
                boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
                borderRadius: "4px",
                position: "relative"
            },
            body: {
                padding: "15px 9px 9px 15px"
            },
            label: {
                fontSize: "18px",
                color: "#fff"
            },
            triangle: {
                width: "0px",
                height: "0px",
                borderStyle: "solid",
                borderWidth: "0 9px 10px 9px",
                borderColor: "transparent transparent #fff transparent",
                position: "absolute"
            },
            triangleShadow: {
                width: "0px",
                height: "0px",
                borderStyle: "solid",
                borderWidth: "0 9px 10px 9px",
                borderColor: "transparent transparent rgba(0,0,0,.1) transparent",
                position: "absolute"
            },
            hash: {
                background: "#F0F0F0",
                height: "30px",
                width: "30px",
                borderRadius: "4px 0 0 4px",
                float: "left",
                color: "#98A1A4",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            },
            input: {
                width: "100px",
                fontSize: "14px",
                color: "#666",
                border: "0px",
                outline: "none",
                height: "28px",
                boxShadow: "inset 0 0 0 1px #F0F0F0",
                boxSizing: "content-box",
                borderRadius: "0 4px 4px 0",
                float: "left",
                paddingLeft: "8px"
            },
            swatch: {
                width: "30px",
                height: "30px",
                float: "left",
                borderRadius: "4px",
                margin: "0 6px 6px 0"
            },
            clear: {
                clear: "both"
            }
        },
        "hide-triangle": {
            triangle: {
                display: "none"
            },
            triangleShadow: {
                display: "none"
            }
        },
        "top-left-triangle": {
            triangle: {
                top: "-10px",
                left: "12px"
            },
            triangleShadow: {
                top: "-11px",
                left: "12px"
            }
        },
        "top-right-triangle": {
            triangle: {
                top: "-10px",
                right: "12px"
            },
            triangleShadow: {
                top: "-11px",
                right: "12px"
            }
        }
    }, passedStyles), {
        "hide-triangle": triangle === "hide",
        "top-left-triangle": triangle === "top-left",
        "top-right-triangle": triangle === "top-right"
    });
    var handleChange = function handleChange(hexcode, e) {
        $576ec6501ba2ee42$export$944f75ec5697b362(hexcode) && onChange({
            hex: hexcode,
            source: "hex"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.card,
        className: "twitter-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.triangleShadow
    }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.triangle
    }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.body
    }, (0, $55201e71335337d3$export$2e2bcd8739ae039)(colors, function(c, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $f6e39602c7ca87c2$export$2e2bcd8739ae039), {
            key: i,
            color: c,
            hex: c,
            style: styles.swatch,
            onClick: handleChange,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: "0 0 4px " + c
            }
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.hash
    }, "#"), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
        label: null,
        style: {
            input: styles.input
        },
        value: hex.replace("#", ""),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.clear
    })));
};
$1ad89b9220431399$export$9e389cdad32a5b7a.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).number
    ]),
    triangle: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).oneOf([
        "hide",
        "top-left",
        "top-right"
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).string),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).object
};
$1ad89b9220431399$export$9e389cdad32a5b7a.defaultProps = {
    width: 276,
    colors: [
        "#FF6900",
        "#FCB900",
        "#7BDCB5",
        "#00D084",
        "#8ED1FC",
        "#0693E3",
        "#ABB8C3",
        "#EB144C",
        "#F78DA7",
        "#9900EF"
    ],
    triangle: "top-left",
    styles: {}
};
var $1ad89b9220431399$export$2e2bcd8739ae039 = (0, $0b94bdc4c9eeec33$export$2e2bcd8739ae039)($1ad89b9220431399$export$9e389cdad32a5b7a);



var $jC8Vy = parcelRequire("jC8Vy");

var $bD9Bx = parcelRequire("bD9Bx");




var $jC8Vy = parcelRequire("jC8Vy");


var $bD9Bx = parcelRequire("bD9Bx");
var $faff0ef48db468bc$export$a928e0fe8b70765d = function GooglePointerCircle(props) {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))({
        "default": {
            picker: {
                width: "20px",
                height: "20px",
                borderRadius: "22px",
                border: "2px #fff solid",
                transform: "translate(-12px, -13px)",
                background: "hsl(" + Math.round(props.hsl.h) + ", " + Math.round(props.hsl.s * 100) + "%, " + Math.round(props.hsl.l * 100) + "%)"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.picker
    });
};
$faff0ef48db468bc$export$a928e0fe8b70765d.propTypes = {
    hsl: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).shape({
        h: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).number,
        s: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).number,
        l: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).number,
        a: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).number
    })
};
$faff0ef48db468bc$export$a928e0fe8b70765d.defaultProps = {
    hsl: {
        a: 1,
        h: 249.94,
        l: 0.2,
        s: 0.50
    }
};
var $faff0ef48db468bc$export$2e2bcd8739ae039 = $faff0ef48db468bc$export$a928e0fe8b70765d;



var $jC8Vy = parcelRequire("jC8Vy");


var $bD9Bx = parcelRequire("bD9Bx");
var $0fe4b8844429d323$export$9de61b9626feed9a = function GooglePointer(props) {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))({
        "default": {
            picker: {
                width: "20px",
                height: "20px",
                borderRadius: "22px",
                transform: "translate(-10px, -7px)",
                background: "hsl(" + Math.round(props.hsl.h) + ", 100%, 50%)",
                border: "2px white solid"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.picker
    });
};
$0fe4b8844429d323$export$9de61b9626feed9a.propTypes = {
    hsl: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).shape({
        h: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).number,
        s: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).number,
        l: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).number,
        a: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).number
    })
};
$0fe4b8844429d323$export$9de61b9626feed9a.defaultProps = {
    hsl: {
        a: 1,
        h: 249.94,
        l: 0.2,
        s: 0.50
    }
};
var $0fe4b8844429d323$export$2e2bcd8739ae039 = $0fe4b8844429d323$export$9de61b9626feed9a;



var $jC8Vy = parcelRequire("jC8Vy");



var $b8dd9905bc7cdd7c$export$e50902ed332e5599 = function GoogleFields(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hex = _ref.hex, hsv = _ref.hsv;
    var handleChange = function handleChange(data, e) {
        if (data.hex) $576ec6501ba2ee42$export$944f75ec5697b362(data.hex) && onChange({
            hex: data.hex,
            source: "hex"
        }, e);
        else if (data.rgb) {
            var values = data.rgb.split(",");
            $576ec6501ba2ee42$export$e76ec4c5b3cadd73(data.rgb, "rgb") && onChange({
                r: values[0],
                g: values[1],
                b: values[2],
                a: 1,
                source: "rgb"
            }, e);
        } else if (data.hsv) {
            var _values = data.hsv.split(",");
            if ($576ec6501ba2ee42$export$e76ec4c5b3cadd73(data.hsv, "hsv")) {
                _values[2] = _values[2].replace("%", "");
                _values[1] = _values[1].replace("%", "");
                _values[0] = _values[0].replace("\xb0", "");
                if (_values[1] == 1) _values[1] = 0.01;
                else if (_values[2] == 1) _values[2] = 0.01;
                onChange({
                    h: Number(_values[0]),
                    s: Number(_values[1]),
                    v: Number(_values[2]),
                    source: "hsv"
                }, e);
            }
        } else if (data.hsl) {
            var _values2 = data.hsl.split(",");
            if ($576ec6501ba2ee42$export$e76ec4c5b3cadd73(data.hsl, "hsl")) {
                _values2[2] = _values2[2].replace("%", "");
                _values2[1] = _values2[1].replace("%", "");
                _values2[0] = _values2[0].replace("\xb0", "");
                if (hsvValue[1] == 1) hsvValue[1] = 0.01;
                else if (hsvValue[2] == 1) hsvValue[2] = 0.01;
                onChange({
                    h: Number(_values2[0]),
                    s: Number(_values2[1]),
                    v: Number(_values2[2]),
                    source: "hsl"
                }, e);
            }
        }
    };
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))({
        "default": {
            wrap: {
                display: "flex",
                height: "100px",
                marginTop: "4px"
            },
            fields: {
                width: "100%"
            },
            column: {
                paddingTop: "10px",
                display: "flex",
                justifyContent: "space-between"
            },
            double: {
                padding: "0px 4.4px",
                boxSizing: "border-box"
            },
            input: {
                width: "100%",
                height: "38px",
                boxSizing: "border-box",
                padding: "4px 10% 3px",
                textAlign: "center",
                border: "1px solid #dadce0",
                fontSize: "11px",
                textTransform: "lowercase",
                borderRadius: "5px",
                outline: "none",
                fontFamily: "Roboto,Arial,sans-serif"
            },
            input2: {
                height: "38px",
                width: "100%",
                border: "1px solid #dadce0",
                boxSizing: "border-box",
                fontSize: "11px",
                textTransform: "lowercase",
                borderRadius: "5px",
                outline: "none",
                paddingLeft: "10px",
                fontFamily: "Roboto,Arial,sans-serif"
            },
            label: {
                textAlign: "center",
                fontSize: "12px",
                background: "#fff",
                position: "absolute",
                textTransform: "uppercase",
                color: "#3c4043",
                width: "35px",
                top: "-6px",
                left: "0",
                right: "0",
                marginLeft: "auto",
                marginRight: "auto",
                fontFamily: "Roboto,Arial,sans-serif"
            },
            label2: {
                left: "10px",
                textAlign: "center",
                fontSize: "12px",
                background: "#fff",
                position: "absolute",
                textTransform: "uppercase",
                color: "#3c4043",
                width: "32px",
                top: "-6px",
                fontFamily: "Roboto,Arial,sans-serif"
            },
            single: {
                flexGrow: "1",
                margin: "0px 4.4px"
            }
        }
    });
    var rgbValue = rgb.r + ", " + rgb.g + ", " + rgb.b;
    var hslValue = Math.round(hsl.h) + "\xb0, " + Math.round(hsl.s * 100) + "%, " + Math.round(hsl.l * 100) + "%";
    var hsvValue = Math.round(hsv.h) + "\xb0, " + Math.round(hsv.s * 100) + "%, " + Math.round(hsv.v * 100) + "%";
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.wrap,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.fields
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.double
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "hex",
        value: hex,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.column
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: "rgb",
        value: rgbValue,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: "hsv",
        value: hsvValue,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa68fc673938b317$export$2e2bcd8739ae039), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: "hsl",
        value: hslValue,
        onChange: handleChange
    })))));
};
var $b8dd9905bc7cdd7c$export$2e2bcd8739ae039 = $b8dd9905bc7cdd7c$export$e50902ed332e5599;


var $eefca741b85d7cef$export$347eee6e8bf67997 = function Google(_ref) {
    var width = _ref.width, onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hsv = _ref.hsv, hex = _ref.hex, header = _ref.header, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($081a95961b0cb73f$exports)))((0, $248c37d10097eba3$export$2e2bcd8739ae039)({
        "default": {
            picker: {
                width: width,
                background: "#fff",
                border: "1px solid #dfe1e5",
                boxSizing: "initial",
                display: "flex",
                flexWrap: "wrap",
                borderRadius: "8px 8px 0px 0px"
            },
            head: {
                height: "57px",
                width: "100%",
                paddingTop: "16px",
                paddingBottom: "16px",
                paddingLeft: "16px",
                fontSize: "20px",
                boxSizing: "border-box",
                fontFamily: "Roboto-Regular,HelveticaNeue,Arial,sans-serif"
            },
            saturation: {
                width: "70%",
                padding: "0px",
                position: "relative",
                overflow: "hidden"
            },
            swatch: {
                width: "30%",
                height: "228px",
                padding: "0px",
                background: "rgba(" + rgb.r + ", " + rgb.g + ", " + rgb.b + ", 1)",
                position: "relative",
                overflow: "hidden"
            },
            body: {
                margin: "auto",
                width: "95%"
            },
            controls: {
                display: "flex",
                boxSizing: "border-box",
                height: "52px",
                paddingTop: "22px"
            },
            color: {
                width: "32px"
            },
            hue: {
                height: "8px",
                position: "relative",
                margin: "0px 16px 0px 16px",
                width: "100%"
            },
            Hue: {
                radius: "2px"
            }
        }
    }, passedStyles));
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.picker,
        className: "google-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.head
    }, header), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.swatch
    }), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.saturation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $97e77a17c0f73a8b$export$2e2bcd8739ae039), {
        hsl: hsl,
        hsv: hsv,
        pointer: (0, $faff0ef48db468bc$export$2e2bcd8739ae039),
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.body
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.controls,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $38476a9de322d712$export$2e2bcd8739ae039), {
        style: styles.Hue,
        hsl: hsl,
        radius: "4px",
        pointer: (0, $0fe4b8844429d323$export$2e2bcd8739ae039),
        onChange: onChange
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $b8dd9905bc7cdd7c$export$2e2bcd8739ae039), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        hsv: hsv,
        onChange: onChange
    })));
};
$eefca741b85d7cef$export$347eee6e8bf67997.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).number
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).object,
    header: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).string
};
$eefca741b85d7cef$export$347eee6e8bf67997.defaultProps = {
    width: 652,
    styles: {},
    header: "Color picker"
};
var $eefca741b85d7cef$export$2e2bcd8739ae039 = (0, $0b94bdc4c9eeec33$export$2e2bcd8739ae039)($eefca741b85d7cef$export$347eee6e8bf67997);






var $bnkR4 = parcelRequire("bnkR4");

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $kUZ14 = parcelRequire("kUZ14");

var $d1oKd = parcelRequire("d1oKd");

var $bnkR4 = parcelRequire("bnkR4");

var $aTllQ = parcelRequire("aTllQ");
var $d56fc90f91fe62ca$export$a7db06668cad9adb;
var $d56fc90f91fe62ca$export$a3681dba3470c8c4;
var $d56fc90f91fe62ca$export$5c0b849e0a083a5;
var $d56fc90f91fe62ca$export$29dd17c7f3c81c36;
var $d56fc90f91fe62ca$export$bfd64c937657f93a;
var $d56fc90f91fe62ca$export$4a6dd88bada4e7d2;
var $d56fc90f91fe62ca$export$fb184b623420d9be;
$d56fc90f91fe62ca$export$a7db06668cad9adb = `zAZJ6a_content`;
$d56fc90f91fe62ca$export$a3681dba3470c8c4 = `zAZJ6a_dropdownContainer`;
$d56fc90f91fe62ca$export$5c0b849e0a083a5 = `zAZJ6a_onTop`;
$d56fc90f91fe62ca$export$29dd17c7f3c81c36 = `zAZJ6a_overlay`;
$d56fc90f91fe62ca$export$bfd64c937657f93a = `zAZJ6a_rotating`;
$d56fc90f91fe62ca$export$4a6dd88bada4e7d2 = `zAZJ6a_shimmer`;
$d56fc90f91fe62ca$export$fb184b623420d9be = `zAZJ6a_title`;



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $bnkR4 = parcelRequire("bnkR4");
var $d6f376abc9214be2$exports = {};

$parcel$export($d6f376abc9214be2$exports, "danger", function () { return $d6f376abc9214be2$export$7c4df8d735fa2705; }, function (v) { return $d6f376abc9214be2$export$7c4df8d735fa2705 = v; });
$parcel$export($d6f376abc9214be2$exports, "icon", function () { return $d6f376abc9214be2$export$1ca1ec8b29a4ce27; }, function (v) { return $d6f376abc9214be2$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($d6f376abc9214be2$exports, "item", function () { return $d6f376abc9214be2$export$7061c75fc5af8b7e; }, function (v) { return $d6f376abc9214be2$export$7061c75fc5af8b7e = v; });
$parcel$export($d6f376abc9214be2$exports, "rotating", function () { return $d6f376abc9214be2$export$bfd64c937657f93a; }, function (v) { return $d6f376abc9214be2$export$bfd64c937657f93a = v; });
$parcel$export($d6f376abc9214be2$exports, "shimmer", function () { return $d6f376abc9214be2$export$4a6dd88bada4e7d2; }, function (v) { return $d6f376abc9214be2$export$4a6dd88bada4e7d2 = v; });
var $d6f376abc9214be2$export$7c4df8d735fa2705;
var $d6f376abc9214be2$export$1ca1ec8b29a4ce27;
var $d6f376abc9214be2$export$7061c75fc5af8b7e;
var $d6f376abc9214be2$export$bfd64c937657f93a;
var $d6f376abc9214be2$export$4a6dd88bada4e7d2;
$d6f376abc9214be2$export$7c4df8d735fa2705 = `_Mz4GG_danger`;
$d6f376abc9214be2$export$1ca1ec8b29a4ce27 = `_Mz4GG_icon`;
$d6f376abc9214be2$export$7061c75fc5af8b7e = `_Mz4GG_item`;
$d6f376abc9214be2$export$bfd64c937657f93a = `_Mz4GG_rotating`;
$d6f376abc9214be2$export$4a6dd88bada4e7d2 = `_Mz4GG_shimmer`;


function $6c006ec422465f6f$var$DropdownItem({ onClick: onClick, className: className, children: children, icon: icon, iconClassName: iconClassName, type: type = "default" }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($d6f376abc9214be2$exports.item, $d6f376abc9214be2$exports[type], className),
        role: "menuitem",
        tabIndex: 0,
        onMouseDown: (event)=>{
            event.preventDefault();
        },
        onKeyDown: (0, $bnkR4.onKeyDownHandler)(onClick),
        onClick: onClick,
        children: [
            icon && /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($d6f376abc9214be2$exports.icon, iconClassName),
                children: icon
            }),
            children
        ]
    });
}
var $6c006ec422465f6f$export$2e2bcd8739ae039 = $6c006ec422465f6f$var$DropdownItem;


function $f90dea65844a9f7a$var$Div({ children: children, ...rest }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        ...rest,
        children: children
    });
}
function $f90dea65844a9f7a$var$Dropdown({ children: children, title: title, isOpen: isOpen, onClose: onClose, anchorRef: anchorRef, isFullWidth: isFullWidth, className: className, titleClassName: titleClassName, horizontalAlign: horizontalAlign = "end", hasOverflowContent: hasOverflowContent, noOverlay: noOverlay }) {
    const overlayRef = (0, $jC8Vy.useRef)(null);
    const { position: position, positionState: positionState, mutate: mutate } = (0, $d1oKd.default)({
        verticalAlign: "bottom",
        horizontalAlign: horizontalAlign,
        offset: {
            vertical: 4,
            horizontal: 0
        },
        anchorRef: anchorRef,
        overlayRef: overlayRef
    });
    const WrapperComponent = hasOverflowContent ? $f90dea65844a9f7a$var$Div : (0, $aTllQ.default);
    return(// Using `ReactModal` will cause accessibility issues for multi-select since the dropdown is
    // not a child or sibling of the input element. Thus the tab order will be broken. Consider
    // using something else instead.
    /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        shouldCloseOnOverlayClick: true,
        isOpen: isOpen,
        style: {
            content: {
                zIndex: 103,
                width: isFullWidth && anchorRef.current ? anchorRef.current.getBoundingClientRect().width : undefined,
                ...!position && {
                    opacity: 0
                },
                ...position
            }
        },
        shouldFocusAfterRender: false,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($d56fc90f91fe62ca$export$a7db06668cad9adb, positionState.verticalAlign === "top" && $d56fc90f91fe62ca$export$5c0b849e0a083a5),
        overlayClassName: $d56fc90f91fe62ca$export$29dd17c7f3c81c36,
        overlayElement: noOverlay && ((_, contentElement)=>contentElement),
        onRequestClose: (event)=>{
            /**
         * Note:
         * we should stop propagation to prevent the event from bubbling up when we click on the overlay to close the dropdown.
         */ event.stopPropagation();
            onClose?.();
        },
        onAfterOpen: mutate,
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
            ref: overlayRef,
            className: $d56fc90f91fe62ca$export$a3681dba3470c8c4,
            children: [
                title && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($d56fc90f91fe62ca$export$fb184b623420d9be, titleClassName),
                    children: title
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)(WrapperComponent, {
                    className: className,
                    role: "menu",
                    tabIndex: 0,
                    onClick: onClose,
                    onKeyDown: (0, $bnkR4.onKeyDownHandler)({
                        Enter: onClose,
                        Esc: onClose
                    }),
                    children: children
                })
            ]
        })
    }));
}
var $f90dea65844a9f7a$export$2e2bcd8739ae039 = $f90dea65844a9f7a$var$Dropdown;


var $bda11bb8da85fae5$export$1ba6601fde3bb0d0;
var $bda11bb8da85fae5$export$34e0f9847d4c02dd;
var $bda11bb8da85fae5$export$e4043f67d36cbb26;
var $bda11bb8da85fae5$export$bfd64c937657f93a;
var $bda11bb8da85fae5$export$4a6dd88bada4e7d2;
$bda11bb8da85fae5$export$1ba6601fde3bb0d0 = `_51AnG_brick`;
$bda11bb8da85fae5$export$34e0f9847d4c02dd = `_51AnG_container`;
$bda11bb8da85fae5$export$e4043f67d36cbb26 = `_51AnG_highlight`;
$bda11bb8da85fae5$export$bfd64c937657f93a = `_51AnG_rotating`;
$bda11bb8da85fae5$export$4a6dd88bada4e7d2 = `_51AnG_shimmer`;


function $41f023d5b4e5db66$var$ColorPicker({ onChange: onChange, value: value = "#000000" }) {
    const anchorRef = (0, $jC8Vy.useRef)(null);
    const [isOpen, setIsOpen] = (0, $jC8Vy.useState)(false);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        tabIndex: 0,
        role: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($bda11bb8da85fae5$export$34e0f9847d4c02dd, isOpen && $bda11bb8da85fae5$export$e4043f67d36cbb26),
        onClick: ()=>{
            setIsOpen(true);
        },
        onKeyDown: (0, $bnkR4.onKeyDownHandler)(()=>{
            setIsOpen(true);
        }),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                ref: anchorRef,
                className: $bda11bb8da85fae5$export$1ba6601fde3bb0d0,
                style: {
                    backgroundColor: value
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                children: value.toUpperCase()
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f90dea65844a9f7a$export$2e2bcd8739ae039), {
                anchorRef: anchorRef,
                isOpen: isOpen,
                horizontalAlign: "start",
                onClose: ()=>{
                    setIsOpen(false);
                },
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $51c725fe6c2d70f1$export$2e2bcd8739ae039), {
                    color: value,
                    onChange: ({ hex: hex })=>{
                        onChange(hex);
                    }
                })
            })
        ]
    });
}
var $41f023d5b4e5db66$export$2e2bcd8739ae039 = $41f023d5b4e5db66$var$ColorPicker;



var $aqmjm = parcelRequire("aqmjm");

var $aTllQ = parcelRequire("aTllQ");

var $fmHmG = parcelRequire("fmHmG");

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
parcelRequire("12bMu");
var $6cnHd = parcelRequire("6cnHd");
const $e533312e67e1435e$export$d098614ac05972c2 = Object.freeze({
    "image/jpeg": [
        "jpeg",
        "jpg"
    ],
    "image/png": [
        "png"
    ],
    "image/gif": [
        "gif"
    ],
    "image/vnd.microsoft.icon": [
        "ico"
    ],
    "image/x-icon": [
        "ico"
    ],
    "image/svg+xml": [
        "svg"
    ],
    "image/tiff": [
        "tif",
        "tiff"
    ],
    "image/webp": [
        "webp"
    ],
    "image/bmp": [
        "bmp"
    ]
});


const $9c2fc023cf60b41b$export$e3d6b5f79f02cd5b = (mimeTypes)=>(0, $6cnHd.deduplicate)(mimeTypes.flatMap((type)=>(0, $e533312e67e1435e$export$d098614ac05972c2)[type]).map((extension)=>extension.toUpperCase()));


const $75ebfd707e0e1bc0$export$7b487c2956dcad6 = 512000; // 500 KB
const $75ebfd707e0e1bc0$var$allowedImageMimeTypes = [
    "image/svg+xml",
    "image/png",
    "image/jpeg",
    "image/vnd.microsoft.icon",
    "image/x-icon"
];
const $75ebfd707e0e1bc0$var$useImageMimeTypes = (mimeTypes)=>{
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const allowedMimeTypes = (0, $jC8Vy.useMemo)(()=>{
        return mimeTypes?.length ? mimeTypes : $75ebfd707e0e1bc0$var$allowedImageMimeTypes;
    }, [
        mimeTypes
    ]);
    const description = (0, $jC8Vy.useMemo)(()=>{
        return t("components.uploader.image_limit", {
            size: $75ebfd707e0e1bc0$export$7b487c2956dcad6 / 1024,
            extensions: (0, $9c2fc023cf60b41b$export$e3d6b5f79f02cd5b)(allowedMimeTypes)
        });
    }, [
        allowedMimeTypes,
        t
    ]);
    return {
        allowedMimeTypes: allowedMimeTypes,
        description: description
    };
};
var $75ebfd707e0e1bc0$export$2e2bcd8739ae039 = $75ebfd707e0e1bc0$var$useImageMimeTypes;



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $3aa588de5c8665f2$var$SvgDelete = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M8.333 15a.833.833 0 0 0 .834-.833v-5a.833.833 0 1 0-1.667 0v5a.833.833 0 0 0 .833.833Zm8.334-10h-3.334v-.833a2.5 2.5 0 0 0-2.5-2.5H9.167a2.5 2.5 0 0 0-2.5 2.5V5H3.333a.833.833 0 0 0 0 1.667h.834v9.166a2.5 2.5 0 0 0 2.5 2.5h6.666a2.5 2.5 0 0 0 2.5-2.5V6.667h.834a.833.833 0 0 0 0-1.667Zm-8.334-.833a.833.833 0 0 1 .834-.834h1.666a.833.833 0 0 1 .834.834V5H8.333v-.833Zm5.834 11.666a.833.833 0 0 1-.834.834H6.667a.833.833 0 0 1-.834-.834V6.667h8.334v9.166Zm-2.5-.833a.833.833 0 0 0 .833-.833v-5a.833.833 0 1 0-1.667 0v5a.833.833 0 0 0 .834.833Z",
            fill: "currentColor"
        })
    });
var $3aa588de5c8665f2$export$2e2bcd8739ae039 = $3aa588de5c8665f2$var$SvgDelete;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");

var $jC8Vy = parcelRequire("jC8Vy");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $c17620527a1ae008$var$SvgBrokenImageDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M10 9a4 4 0 0 1 4-4h6.5l1.452 2-1.049 2 2.29 3.5-1.048 2 1.952 2L24.5 19l.903-2.5-1.048-2 1.951-2-1.21-3.5 1.952-2-.548-2H34a4 4 0 0 1 4 4v30a4 4 0 0 1-4 4H17.454a1 1 0 0 1-.753-.342l-6.454-7.375a1 1 0 0 1-.247-.659V9Z",
                fill: "#FFFBFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m10 35 7 8v-6a2 2 0 0 0-2-2h-5Z",
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.024 20.025a.5.5 0 0 0 0 .707L17.79 22.5l-1.767 1.768a.5.5 0 1 0 .707.707l1.768-1.768 1.767 1.768a.5.5 0 1 0 .708-.707L19.206 22.5l1.767-1.768a.5.5 0 1 0-.707-.707L18.5 21.793l-1.768-1.768a.5.5 0 0 0-.707 0ZM27.024 20.025a.5.5 0 0 0 0 .707L28.79 22.5l-1.767 1.768a.5.5 0 1 0 .707.707l1.768-1.768 1.767 1.768a.5.5 0 1 0 .708-.707L30.206 22.5l1.767-1.768a.5.5 0 1 0-.707-.707L29.5 21.793l-1.768-1.768a.5.5 0 0 0-.707 0Z",
                fill: "#ADAAB4"
            })
        ]
    });
var $c17620527a1ae008$export$2e2bcd8739ae039 = $c17620527a1ae008$var$SvgBrokenImageDark;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $8b4ec79fcff184ef$var$SvgBrokenImageLight = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M10 9a4 4 0 0 1 4-4h6.5l1.452 2-1.049 2 2.29 3.5-1.048 2 1.952 2L24.5 19l.903-2.5-1.048-2 1.951-2-1.21-3.5 1.952-2-.548-2H34a4 4 0 0 1 4 4v30a4 4 0 0 1-4 4H17.454a1 1 0 0 1-.753-.342l-6.454-7.375a1 1 0 0 1-.247-.659V9Z",
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m10 35 7 8v-6a2 2 0 0 0-2-2h-5Z",
                fill: "#FBF9FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.024 20.025a.5.5 0 0 0 0 .707L17.79 22.5l-1.767 1.768a.5.5 0 1 0 .707.707l1.768-1.768 1.767 1.768a.5.5 0 1 0 .708-.707L19.206 22.5l1.767-1.768a.5.5 0 1 0-.707-.707L18.5 21.793l-1.768-1.768a.5.5 0 0 0-.707 0ZM27.024 20.025a.5.5 0 0 0 0 .707L28.79 22.5l-1.767 1.768a.5.5 0 1 0 .707.707l1.768-1.768 1.767 1.768a.5.5 0 1 0 .708-.707L30.206 22.5l1.767-1.768a.5.5 0 1 0-.707-.707L29.5 21.793l-1.768-1.768a.5.5 0 0 0-.707 0Z",
                fill: "#78767F"
            })
        ]
    });
var $8b4ec79fcff184ef$export$2e2bcd8739ae039 = $8b4ec79fcff184ef$var$SvgBrokenImageLight;



var $jheqv = parcelRequire("jheqv");
function $dbaecc0d7fe55772$var$ImageWithErrorFallback({ src: src, alt: alt, className: className, containerClassName: containerClassName, fallbackElement: fallbackElement, ...props }) {
    const [hasError, setHasError] = (0, $jC8Vy.useState)(false);
    const theme = (0, $jheqv.default)();
    const DefaultFallback = theme === (0, $5HVJe.Theme).Light ? (0, $8b4ec79fcff184ef$export$2e2bcd8739ae039) : (0, $c17620527a1ae008$export$2e2bcd8739ae039);
    const errorHandler = ()=>{
        setHasError(true);
    };
    if (!src || hasError) return fallbackElement ? /*#__PURE__*/ (0, $jC8Vy.cloneElement)(fallbackElement, {
        className: className
    }) : /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: containerClassName,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)(DefaultFallback, {
            className: className
        })
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: containerClassName,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("img", {
            className: className,
            src: src,
            alt: alt,
            onError: errorHandler,
            ...props
        })
    });
}
var $dbaecc0d7fe55772$export$2e2bcd8739ae039 = $dbaecc0d7fe55772$var$ImageWithErrorFallback;




var $75SRw = parcelRequire("75SRw");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $2rWG7 = parcelRequire("2rWG7");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $jC8Vy = parcelRequire("jC8Vy");

var $bD9Bx = parcelRequire("bD9Bx");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $84bcae256326ef52$var$extendStatics = function(d, b) {
    $84bcae256326ef52$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $84bcae256326ef52$var$extendStatics(d, b);
};
function $84bcae256326ef52$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $84bcae256326ef52$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $84bcae256326ef52$export$18ce0697a983be9b = function() {
    $84bcae256326ef52$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $84bcae256326ef52$export$18ce0697a983be9b.apply(this, arguments);
};
function $84bcae256326ef52$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $84bcae256326ef52$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $84bcae256326ef52$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $84bcae256326ef52$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.push(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.push(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $84bcae256326ef52$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $84bcae256326ef52$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $84bcae256326ef52$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $84bcae256326ef52$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $84bcae256326ef52$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $84bcae256326ef52$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $84bcae256326ef52$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $84bcae256326ef52$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $84bcae256326ef52$export$45d3717a4c69092e(o, m, p);
}
function $84bcae256326ef52$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $84bcae256326ef52$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $84bcae256326ef52$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($84bcae256326ef52$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $84bcae256326ef52$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $84bcae256326ef52$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $84bcae256326ef52$export$10c90e4f7922046c(v) {
    return this instanceof $84bcae256326ef52$export$10c90e4f7922046c ? (this.v = v, this) : new $84bcae256326ef52$export$10c90e4f7922046c(v);
}
function $84bcae256326ef52$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $84bcae256326ef52$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $84bcae256326ef52$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $84bcae256326ef52$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $84bcae256326ef52$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $84bcae256326ef52$export$19a8beecd37a4c45 === "function" ? $84bcae256326ef52$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $84bcae256326ef52$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $84bcae256326ef52$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $84bcae256326ef52$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $84bcae256326ef52$export$45d3717a4c69092e(result, mod, k);
    }
    $84bcae256326ef52$var$__setModuleDefault(result, mod);
    return result;
}
function $84bcae256326ef52$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $84bcae256326ef52$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $84bcae256326ef52$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $84bcae256326ef52$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


var $31438a3d7ee9a7d8$export$db0345794bfc14ed = new Map([
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
    [
        "aac",
        "audio/aac"
    ],
    [
        "abw",
        "application/x-abiword"
    ],
    [
        "arc",
        "application/x-freearc"
    ],
    [
        "avif",
        "image/avif"
    ],
    [
        "avi",
        "video/x-msvideo"
    ],
    [
        "azw",
        "application/vnd.amazon.ebook"
    ],
    [
        "bin",
        "application/octet-stream"
    ],
    [
        "bmp",
        "image/bmp"
    ],
    [
        "bz",
        "application/x-bzip"
    ],
    [
        "bz2",
        "application/x-bzip2"
    ],
    [
        "cda",
        "application/x-cdf"
    ],
    [
        "csh",
        "application/x-csh"
    ],
    [
        "css",
        "text/css"
    ],
    [
        "csv",
        "text/csv"
    ],
    [
        "doc",
        "application/msword"
    ],
    [
        "docx",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ],
    [
        "eot",
        "application/vnd.ms-fontobject"
    ],
    [
        "epub",
        "application/epub+zip"
    ],
    [
        "gz",
        "application/gzip"
    ],
    [
        "gif",
        "image/gif"
    ],
    [
        "heic",
        "image/heic"
    ],
    [
        "heif",
        "image/heif"
    ],
    [
        "htm",
        "text/html"
    ],
    [
        "html",
        "text/html"
    ],
    [
        "ico",
        "image/vnd.microsoft.icon"
    ],
    [
        "ics",
        "text/calendar"
    ],
    [
        "jar",
        "application/java-archive"
    ],
    [
        "jpeg",
        "image/jpeg"
    ],
    [
        "jpg",
        "image/jpeg"
    ],
    [
        "js",
        "text/javascript"
    ],
    [
        "json",
        "application/json"
    ],
    [
        "jsonld",
        "application/ld+json"
    ],
    [
        "mid",
        "audio/midi"
    ],
    [
        "midi",
        "audio/midi"
    ],
    [
        "mjs",
        "text/javascript"
    ],
    [
        "mp3",
        "audio/mpeg"
    ],
    [
        "mp4",
        "video/mp4"
    ],
    [
        "mpeg",
        "video/mpeg"
    ],
    [
        "mpkg",
        "application/vnd.apple.installer+xml"
    ],
    [
        "odp",
        "application/vnd.oasis.opendocument.presentation"
    ],
    [
        "ods",
        "application/vnd.oasis.opendocument.spreadsheet"
    ],
    [
        "odt",
        "application/vnd.oasis.opendocument.text"
    ],
    [
        "oga",
        "audio/ogg"
    ],
    [
        "ogv",
        "video/ogg"
    ],
    [
        "ogx",
        "application/ogg"
    ],
    [
        "opus",
        "audio/opus"
    ],
    [
        "otf",
        "font/otf"
    ],
    [
        "png",
        "image/png"
    ],
    [
        "pdf",
        "application/pdf"
    ],
    [
        "php",
        "application/x-httpd-php"
    ],
    [
        "ppt",
        "application/vnd.ms-powerpoint"
    ],
    [
        "pptx",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    ],
    [
        "rar",
        "application/vnd.rar"
    ],
    [
        "rtf",
        "application/rtf"
    ],
    [
        "sh",
        "application/x-sh"
    ],
    [
        "svg",
        "image/svg+xml"
    ],
    [
        "swf",
        "application/x-shockwave-flash"
    ],
    [
        "tar",
        "application/x-tar"
    ],
    [
        "tif",
        "image/tiff"
    ],
    [
        "tiff",
        "image/tiff"
    ],
    [
        "ts",
        "video/mp2t"
    ],
    [
        "ttf",
        "font/ttf"
    ],
    [
        "txt",
        "text/plain"
    ],
    [
        "vsd",
        "application/vnd.visio"
    ],
    [
        "wav",
        "audio/wav"
    ],
    [
        "weba",
        "audio/webm"
    ],
    [
        "webm",
        "video/webm"
    ],
    [
        "webp",
        "image/webp"
    ],
    [
        "woff",
        "font/woff"
    ],
    [
        "woff2",
        "font/woff2"
    ],
    [
        "xhtml",
        "application/xhtml+xml"
    ],
    [
        "xls",
        "application/vnd.ms-excel"
    ],
    [
        "xlsx",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ],
    [
        "xml",
        "application/xml"
    ],
    [
        "xul",
        "application/vnd.mozilla.xul+xml"
    ],
    [
        "zip",
        "application/zip"
    ],
    [
        "7z",
        "application/x-7z-compressed"
    ],
    // Others
    [
        "mkv",
        "video/x-matroska"
    ],
    [
        "mov",
        "video/quicktime"
    ],
    [
        "msg",
        "application/vnd.ms-outlook"
    ]
]);
function $31438a3d7ee9a7d8$export$8cc09085015f0dc7(file, path) {
    var f = $31438a3d7ee9a7d8$var$withMimeType(file);
    if (typeof f.path !== "string") {
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, "path", {
            value: typeof path === "string" ? path : typeof webkitRelativePath === "string" && webkitRelativePath.length > 0 ? webkitRelativePath : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function $31438a3d7ee9a7d8$var$withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf(".") !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split(".").pop().toLowerCase();
        var type = $31438a3d7ee9a7d8$export$db0345794bfc14ed.get(ext);
        if (type) Object.defineProperty(file, "type", {
            value: type,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return file;
}


var $85f12d3970e2d369$var$FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    ".DS_Store",
    "Thumbs.db" // Windows
];
function $85f12d3970e2d369$export$a36e16046ae8f1bb(evt) {
    return (0, $84bcae256326ef52$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $84bcae256326ef52$export$67ebef60e6f28a6)(this, function(_a) {
            if ($85f12d3970e2d369$var$isObject(evt) && $85f12d3970e2d369$var$isDataTransfer(evt.dataTransfer)) return [
                2 /*return*/ ,
                $85f12d3970e2d369$var$getDataTransferFiles(evt.dataTransfer, evt.type)
            ];
            else if ($85f12d3970e2d369$var$isChangeEvt(evt)) return [
                2 /*return*/ ,
                $85f12d3970e2d369$var$getInputFiles(evt)
            ];
            else if (Array.isArray(evt) && evt.every(function(item) {
                return "getFile" in item && typeof item.getFile === "function";
            })) return [
                2 /*return*/ ,
                $85f12d3970e2d369$var$getFsHandleFiles(evt)
            ];
            return [
                2 /*return*/ ,
                []
            ];
        });
    });
}
function $85f12d3970e2d369$var$isDataTransfer(value) {
    return $85f12d3970e2d369$var$isObject(value);
}
function $85f12d3970e2d369$var$isChangeEvt(value) {
    return $85f12d3970e2d369$var$isObject(value) && $85f12d3970e2d369$var$isObject(value.target);
}
function $85f12d3970e2d369$var$isObject(v) {
    return typeof v === "object" && v !== null;
}
function $85f12d3970e2d369$var$getInputFiles(evt) {
    return $85f12d3970e2d369$var$fromList(evt.target.files).map(function(file) {
        return (0, $31438a3d7ee9a7d8$export$8cc09085015f0dc7)(file);
    });
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function $85f12d3970e2d369$var$getFsHandleFiles(handles) {
    return (0, $84bcae256326ef52$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var files;
        return (0, $84bcae256326ef52$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        Promise.all(handles.map(function(h) {
                            return h.getFile();
                        }))
                    ];
                case 1:
                    files = _a.sent();
                    return [
                        2 /*return*/ ,
                        files.map(function(file) {
                            return (0, $31438a3d7ee9a7d8$export$8cc09085015f0dc7)(file);
                        })
                    ];
            }
        });
    });
}
function $85f12d3970e2d369$var$getDataTransferFiles(dt, type) {
    return (0, $84bcae256326ef52$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var items, files;
        return (0, $84bcae256326ef52$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!dt.items) return [
                        3 /*break*/ ,
                        2
                    ];
                    items = $85f12d3970e2d369$var$fromList(dt.items).filter(function(item) {
                        return item.kind === "file";
                    });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== "drop") return [
                        2 /*return*/ ,
                        items
                    ];
                    return [
                        4 /*yield*/ ,
                        Promise.all(items.map($85f12d3970e2d369$var$toFilePromises))
                    ];
                case 1:
                    files = _a.sent();
                    return [
                        2 /*return*/ ,
                        $85f12d3970e2d369$var$noIgnoredFiles($85f12d3970e2d369$var$flatten(files))
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        $85f12d3970e2d369$var$noIgnoredFiles($85f12d3970e2d369$var$fromList(dt.files).map(function(file) {
                            return (0, $31438a3d7ee9a7d8$export$8cc09085015f0dc7)(file);
                        }))
                    ];
            }
        });
    });
}
function $85f12d3970e2d369$var$noIgnoredFiles(files) {
    return files.filter(function(file) {
        return $85f12d3970e2d369$var$FILES_TO_IGNORE.indexOf(file.name) === -1;
    });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function $85f12d3970e2d369$var$fromList(items) {
    if (items === null) return [];
    var files = [];
    // tslint:disable: prefer-for-of
    for(var i = 0; i < items.length; i++){
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function $85f12d3970e2d369$var$toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== "function") return $85f12d3970e2d369$var$fromDataTransferItem(item);
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) return $85f12d3970e2d369$var$fromDirEntry(entry);
    return $85f12d3970e2d369$var$fromDataTransferItem(item);
}
function $85f12d3970e2d369$var$flatten(items) {
    return items.reduce(function(acc, files) {
        return (0, $84bcae256326ef52$export$1216008129fb82ed)((0, $84bcae256326ef52$export$1216008129fb82ed)([], (0, $84bcae256326ef52$export$8d051b38c9118094)(acc), false), (0, $84bcae256326ef52$export$8d051b38c9118094)(Array.isArray(files) ? $85f12d3970e2d369$var$flatten(files) : [
            files
        ]), false);
    }, []);
}
function $85f12d3970e2d369$var$fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) return Promise.reject("".concat(item, " is not a File"));
    var fwp = (0, $31438a3d7ee9a7d8$export$8cc09085015f0dc7)(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function $85f12d3970e2d369$var$fromEntry(entry) {
    return (0, $84bcae256326ef52$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $84bcae256326ef52$export$67ebef60e6f28a6)(this, function(_a) {
            return [
                2 /*return*/ ,
                entry.isDirectory ? $85f12d3970e2d369$var$fromDirEntry(entry) : $85f12d3970e2d369$var$fromFileEntry(entry)
            ];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function $85f12d3970e2d369$var$fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function(resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function(batch) {
                return (0, $84bcae256326ef52$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                    var files, err_1, items;
                    return (0, $84bcae256326ef52$export$67ebef60e6f28a6)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!!batch.length) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    Promise.all(entries)
                                ];
                            case 2:
                                files = _a.sent();
                                resolve(files);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                err_1 = _a.sent();
                                reject(err_1);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 4:
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case 5:
                                items = Promise.all(batch.map($85f12d3970e2d369$var$fromEntry));
                                entries.push(items);
                                // Continue reading
                                readEntries();
                                _a.label = 6;
                            case 6:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, function(err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function $85f12d3970e2d369$var$fromFileEntry(entry) {
    return (0, $84bcae256326ef52$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $84bcae256326ef52$export$67ebef60e6f28a6)(this, function(_a) {
            return [
                2 /*return*/ ,
                new Promise(function(resolve, reject) {
                    entry.file(function(file) {
                        var fwp = (0, $31438a3d7ee9a7d8$export$8cc09085015f0dc7)(file, entry.fullPath);
                        resolve(fwp);
                    }, function(err) {
                        reject(err);
                    });
                })
            ];
        });
    });
}




var $bd3342888d0bb2fe$export$1e511d4a378977f5;
var $bd3342888d0bb2fe$export$2e2bcd8739ae039;
"use strict";
$bd3342888d0bb2fe$export$1e511d4a378977f5 = true;
$bd3342888d0bb2fe$export$2e2bcd8739ae039 = function(file, acceptedFiles) {
    if (file && acceptedFiles) {
        var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(",");
        var fileName = file.name || "";
        var mimeType = (file.type || "").toLowerCase();
        var baseMimeType = mimeType.replace(/\/.*$/, "");
        return acceptedFilesArray.some(function(type) {
            var validType = type.trim().toLowerCase();
            if (validType.charAt(0) === ".") return fileName.toLowerCase().endsWith(validType);
            else if (validType.endsWith("/*")) // This is something like a image/* mime type
            return baseMimeType === validType.replace(/\/.*$/, "");
            return mimeType === validType;
        });
    }
    return true;
};


function $16bd9a4d101e8e29$var$_toConsumableArray(arr) {
    return $16bd9a4d101e8e29$var$_arrayWithoutHoles(arr) || $16bd9a4d101e8e29$var$_iterableToArray(arr) || $16bd9a4d101e8e29$var$_unsupportedIterableToArray(arr) || $16bd9a4d101e8e29$var$_nonIterableSpread();
}
function $16bd9a4d101e8e29$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $16bd9a4d101e8e29$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $16bd9a4d101e8e29$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $16bd9a4d101e8e29$var$_arrayLikeToArray(arr);
}
function $16bd9a4d101e8e29$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $16bd9a4d101e8e29$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $16bd9a4d101e8e29$var$ownKeys(Object(source), !0).forEach(function(key) {
            $16bd9a4d101e8e29$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $16bd9a4d101e8e29$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $16bd9a4d101e8e29$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $16bd9a4d101e8e29$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $16bd9a4d101e8e29$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $16bd9a4d101e8e29$var$_typeof(obj);
}
function $16bd9a4d101e8e29$var$_slicedToArray(arr, i) {
    return $16bd9a4d101e8e29$var$_arrayWithHoles(arr) || $16bd9a4d101e8e29$var$_iterableToArrayLimit(arr, i) || $16bd9a4d101e8e29$var$_unsupportedIterableToArray(arr, i) || $16bd9a4d101e8e29$var$_nonIterableRest();
}
function $16bd9a4d101e8e29$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $16bd9a4d101e8e29$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $16bd9a4d101e8e29$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $16bd9a4d101e8e29$var$_arrayLikeToArray(o, minLen);
}
function $16bd9a4d101e8e29$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $16bd9a4d101e8e29$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $16bd9a4d101e8e29$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $16bd9a4d101e8e29$export$d2c35cc369247232 = "file-invalid-type";
var $16bd9a4d101e8e29$export$d7bd1185abe1e87c = "file-too-large";
var $16bd9a4d101e8e29$export$8bd5ec6ed990dc9 = "file-too-small";
var $16bd9a4d101e8e29$export$3271ef1d2dd155f9 = "too-many-files";
var $16bd9a4d101e8e29$export$d4e71bc0b80dc0fb = {
    FileInvalidType: $16bd9a4d101e8e29$export$d2c35cc369247232,
    FileTooLarge: $16bd9a4d101e8e29$export$d7bd1185abe1e87c,
    FileTooSmall: $16bd9a4d101e8e29$export$8bd5ec6ed990dc9,
    TooManyFiles: $16bd9a4d101e8e29$export$3271ef1d2dd155f9
}; // File Errors
var $16bd9a4d101e8e29$export$bc0bbda045f09b5a = function getInvalidTypeRejectionErr(accept) {
    accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
    var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
    return {
        code: $16bd9a4d101e8e29$export$d2c35cc369247232,
        message: "File type must be ".concat(messageSuffix)
    };
};
var $16bd9a4d101e8e29$export$b70c322af07b9d49 = function getTooLargeRejectionErr(maxSize) {
    return {
        code: $16bd9a4d101e8e29$export$d7bd1185abe1e87c,
        message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
    };
};
var $16bd9a4d101e8e29$export$d61cfd6dff5a3e22 = function getTooSmallRejectionErr(minSize) {
    return {
        code: $16bd9a4d101e8e29$export$8bd5ec6ed990dc9,
        message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
    };
};
var $16bd9a4d101e8e29$export$1e1e1b6120329fe = {
    code: $16bd9a4d101e8e29$export$3271ef1d2dd155f9,
    message: "Too many files"
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
function $16bd9a4d101e8e29$export$b511db3632effe58(file, accept) {
    var isAcceptable = file.type === "application/x-moz-file" || (0, $bd3342888d0bb2fe$export$2e2bcd8739ae039)(file, accept);
    return [
        isAcceptable,
        isAcceptable ? null : $16bd9a4d101e8e29$export$bc0bbda045f09b5a(accept)
    ];
}
function $16bd9a4d101e8e29$export$860631d45ba43fd9(file, minSize, maxSize) {
    if ($16bd9a4d101e8e29$var$isDefined(file.size)) {
        if ($16bd9a4d101e8e29$var$isDefined(minSize) && $16bd9a4d101e8e29$var$isDefined(maxSize)) {
            if (file.size > maxSize) return [
                false,
                $16bd9a4d101e8e29$export$b70c322af07b9d49(maxSize)
            ];
            if (file.size < minSize) return [
                false,
                $16bd9a4d101e8e29$export$d61cfd6dff5a3e22(minSize)
            ];
        } else if ($16bd9a4d101e8e29$var$isDefined(minSize) && file.size < minSize) return [
            false,
            $16bd9a4d101e8e29$export$d61cfd6dff5a3e22(minSize)
        ];
        else if ($16bd9a4d101e8e29$var$isDefined(maxSize) && file.size > maxSize) return [
            false,
            $16bd9a4d101e8e29$export$b70c322af07b9d49(maxSize)
        ];
    }
    return [
        true,
        null
    ];
}
function $16bd9a4d101e8e29$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $16bd9a4d101e8e29$export$6a0bb4322c81a197(_ref) {
    var files = _ref.files, accept = _ref.accept, minSize = _ref.minSize, maxSize = _ref.maxSize, multiple = _ref.multiple, maxFiles = _ref.maxFiles, validator = _ref.validator;
    if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) return false;
    return files.every(function(file) {
        var _fileAccepted = $16bd9a4d101e8e29$export$b511db3632effe58(file, accept), _fileAccepted2 = $16bd9a4d101e8e29$var$_slicedToArray(_fileAccepted, 1), accepted = _fileAccepted2[0];
        var _fileMatchSize = $16bd9a4d101e8e29$export$860631d45ba43fd9(file, minSize, maxSize), _fileMatchSize2 = $16bd9a4d101e8e29$var$_slicedToArray(_fileMatchSize, 1), sizeMatch = _fileMatchSize2[0];
        var customErrors = validator ? validator(file) : null;
        return accepted && sizeMatch && !customErrors;
    });
} // React's synthetic events has event.isPropagationStopped,
function $16bd9a4d101e8e29$export$8d6d6472146de265(event) {
    if (typeof event.isPropagationStopped === "function") return event.isPropagationStopped();
    else if (typeof event.cancelBubble !== "undefined") return event.cancelBubble;
    return false;
}
function $16bd9a4d101e8e29$export$52f1fc875a1e5986(event) {
    if (!event.dataTransfer) return !!event.target && !!event.target.files;
     // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file
    return Array.prototype.some.call(event.dataTransfer.types, function(type) {
        return type === "Files" || type === "application/x-moz-file";
    });
}
function $16bd9a4d101e8e29$export$f9006bf02b243736(item) {
    return $16bd9a4d101e8e29$var$_typeof(item) === "object" && item !== null && item.kind === "file";
} // allow the entire document to be a drag target
function $16bd9a4d101e8e29$export$2ead263d6635cecc(event) {
    event.preventDefault();
}
function $16bd9a4d101e8e29$var$isIe(userAgent) {
    return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function $16bd9a4d101e8e29$var$isEdge(userAgent) {
    return userAgent.indexOf("Edge/") !== -1;
}
function $16bd9a4d101e8e29$export$d3498e653911f962() {
    var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
    return $16bd9a4d101e8e29$var$isIe(userAgent) || $16bd9a4d101e8e29$var$isEdge(userAgent);
}
function $16bd9a4d101e8e29$export$b9ecd428b558ff10() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(event) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return fns.some(function(fn) {
            if (!$16bd9a4d101e8e29$export$8d6d6472146de265(event) && fn) fn.apply(void 0, [
                event
            ].concat(args));
            return $16bd9a4d101e8e29$export$8d6d6472146de265(event);
        });
    };
}
function $16bd9a4d101e8e29$export$858af2af50e1eaf8() {
    return "showOpenFilePicker" in window;
}
function $16bd9a4d101e8e29$export$8ce4bd13c494743e(accept) {
    if ($16bd9a4d101e8e29$var$isDefined(accept)) {
        var acceptForPicker = Object.entries(accept).filter(function(_ref2) {
            var _ref3 = $16bd9a4d101e8e29$var$_slicedToArray(_ref2, 2), mimeType = _ref3[0], ext = _ref3[1];
            var ok = true;
            if (!$16bd9a4d101e8e29$export$69c8ec3250e1cfbf(mimeType)) {
                console.warn('Skipped "'.concat(mimeType, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.'));
                ok = false;
            }
            if (!Array.isArray(ext) || !ext.every($16bd9a4d101e8e29$export$42c2be5a6d408120)) {
                console.warn('Skipped "'.concat(mimeType, '" because an invalid file extension was provided.'));
                ok = false;
            }
            return ok;
        }).reduce(function(agg, _ref4) {
            var _ref5 = $16bd9a4d101e8e29$var$_slicedToArray(_ref4, 2), mimeType = _ref5[0], ext = _ref5[1];
            return $16bd9a4d101e8e29$var$_objectSpread($16bd9a4d101e8e29$var$_objectSpread({}, agg), {}, $16bd9a4d101e8e29$var$_defineProperty({}, mimeType, ext));
        }, {});
        return [
            {
                // description is required due to https://crbug.com/1264708
                description: "Files",
                accept: acceptForPicker
            }
        ];
    }
    return accept;
}
function $16bd9a4d101e8e29$export$1278288bcefb97b9(accept) {
    if ($16bd9a4d101e8e29$var$isDefined(accept)) return Object.entries(accept).reduce(function(a, _ref6) {
        var _ref7 = $16bd9a4d101e8e29$var$_slicedToArray(_ref6, 2), mimeType = _ref7[0], ext = _ref7[1];
        return [].concat($16bd9a4d101e8e29$var$_toConsumableArray(a), [
            mimeType
        ], $16bd9a4d101e8e29$var$_toConsumableArray(ext));
    }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
    .filter(function(v) {
        return $16bd9a4d101e8e29$export$69c8ec3250e1cfbf(v) || $16bd9a4d101e8e29$export$42c2be5a6d408120(v);
    }).join(",");
    return undefined;
}
function $16bd9a4d101e8e29$export$72580c77a176a18f(v) {
    return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
function $16bd9a4d101e8e29$export$c4f82d4432e209a9(v) {
    return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
function $16bd9a4d101e8e29$export$69c8ec3250e1cfbf(v) {
    return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || /\w+\/[-+.\w]+/g.test(v);
}
function $16bd9a4d101e8e29$export$42c2be5a6d408120(v) {
    return /^.*\.[\w]+$/.test(v);
} /**
 * @typedef {Object.<string, string[]>} AcceptProp
 */  /**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */  /**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */ 



var $9d9dd5baa20d706c$var$_excluded = [
    "children"
], $9d9dd5baa20d706c$var$_excluded2 = [
    "open"
], $9d9dd5baa20d706c$var$_excluded3 = [
    "refKey",
    "role",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onClick",
    "onDragEnter",
    "onDragOver",
    "onDragLeave",
    "onDrop"
], $9d9dd5baa20d706c$var$_excluded4 = [
    "refKey",
    "onChange",
    "onClick"
];
function $9d9dd5baa20d706c$var$_toConsumableArray(arr) {
    return $9d9dd5baa20d706c$var$_arrayWithoutHoles(arr) || $9d9dd5baa20d706c$var$_iterableToArray(arr) || $9d9dd5baa20d706c$var$_unsupportedIterableToArray(arr) || $9d9dd5baa20d706c$var$_nonIterableSpread();
}
function $9d9dd5baa20d706c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9d9dd5baa20d706c$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $9d9dd5baa20d706c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $9d9dd5baa20d706c$var$_arrayLikeToArray(arr);
}
function $9d9dd5baa20d706c$var$_slicedToArray(arr, i) {
    return $9d9dd5baa20d706c$var$_arrayWithHoles(arr) || $9d9dd5baa20d706c$var$_iterableToArrayLimit(arr, i) || $9d9dd5baa20d706c$var$_unsupportedIterableToArray(arr, i) || $9d9dd5baa20d706c$var$_nonIterableRest();
}
function $9d9dd5baa20d706c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9d9dd5baa20d706c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9d9dd5baa20d706c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9d9dd5baa20d706c$var$_arrayLikeToArray(o, minLen);
}
function $9d9dd5baa20d706c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9d9dd5baa20d706c$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $9d9dd5baa20d706c$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $9d9dd5baa20d706c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9d9dd5baa20d706c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9d9dd5baa20d706c$var$ownKeys(Object(source), !0).forEach(function(key) {
            $9d9dd5baa20d706c$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9d9dd5baa20d706c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9d9dd5baa20d706c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9d9dd5baa20d706c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9d9dd5baa20d706c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9d9dd5baa20d706c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */ var $9d9dd5baa20d706c$var$Dropzone = /*#__PURE__*/ (0, $jC8Vy.forwardRef)(function(_ref, ref) {
    var children = _ref.children, params = $9d9dd5baa20d706c$var$_objectWithoutProperties(_ref, $9d9dd5baa20d706c$var$_excluded);
    var _useDropzone = $9d9dd5baa20d706c$export$cd49c0ecc5be9f36(params), open = _useDropzone.open, props = $9d9dd5baa20d706c$var$_objectWithoutProperties(_useDropzone, $9d9dd5baa20d706c$var$_excluded2);
    (0, $jC8Vy.useImperativeHandle)(ref, function() {
        return {
            open: open
        };
    }, [
        open
    ]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $jC8Vy.Fragment), null, children($9d9dd5baa20d706c$var$_objectSpread($9d9dd5baa20d706c$var$_objectSpread({}, props), {}, {
        open: open
    })));
});
$9d9dd5baa20d706c$var$Dropzone.displayName = "Dropzone"; // Add default props for react-docgen
var $9d9dd5baa20d706c$var$defaultProps = {
    disabled: false,
    getFilesFromEvent: (0, $85f12d3970e2d369$export$a36e16046ae8f1bb),
    maxSize: Infinity,
    minSize: 0,
    multiple: true,
    maxFiles: 0,
    preventDropOnDocument: true,
    noClick: false,
    noKeyboard: false,
    noDrag: false,
    noDragEventsBubbling: false,
    validator: null,
    useFsAccessApi: true,
    autoFocus: false
};
$9d9dd5baa20d706c$var$Dropzone.defaultProps = $9d9dd5baa20d706c$var$defaultProps;
$9d9dd5baa20d706c$var$Dropzone.propTypes = {
    /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).func,
    /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */ accept: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).string)),
    /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).bool,
    /**
   * If false, allow dropped items to take over the current browser window
   */ preventDropOnDocument: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).bool,
    /**
   * If true, disables click to open the native file selection dialog
   */ noClick: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).bool,
    /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */ noKeyboard: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).bool,
    /**
   * If true, disables drag 'n' drop
   */ noDrag: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).bool,
    /**
   * If true, stops drag event propagation to parents
   */ noDragEventsBubbling: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).bool,
    /**
   * Minimum file size (in bytes)
   */ minSize: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).number,
    /**
   * Maximum file size (in bytes)
   */ maxSize: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).number,
    /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */ maxFiles: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).number,
    /**
   * Enable/disable the dropzone
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).bool,
    /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ getFilesFromEvent: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).func,
    /**
   * Cb for when closing the file dialog with no selection
   */ onFileDialogCancel: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).func,
    /**
   * Cb for when opening the file dialog
   */ onFileDialogOpen: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).func,
    /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */ useFsAccessApi: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).bool,
    /**
   * Set to true to focus the root element on render
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).bool,
    /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */ onDragEnter: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).func,
    /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */ onDragLeave: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).func,
    /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */ onDragOver: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ onDrop: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */ onDropAccepted: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */ onDropRejected: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).func,
    /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).func,
    /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */ validator: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).func
};
var $9d9dd5baa20d706c$export$2e2bcd8739ae039 = $9d9dd5baa20d706c$var$Dropzone;
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */ /**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */ /**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */ var $9d9dd5baa20d706c$var$initialState = {
    isFocused: false,
    isFileDialogActive: false,
    isDragActive: false,
    isDragAccept: false,
    isDragReject: false,
    acceptedFiles: [],
    fileRejections: []
};
function $9d9dd5baa20d706c$export$cd49c0ecc5be9f36() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _defaultProps$props = $9d9dd5baa20d706c$var$_objectSpread($9d9dd5baa20d706c$var$_objectSpread({}, $9d9dd5baa20d706c$var$defaultProps), props), accept = _defaultProps$props.accept, disabled = _defaultProps$props.disabled, getFilesFromEvent = _defaultProps$props.getFilesFromEvent, maxSize = _defaultProps$props.maxSize, minSize = _defaultProps$props.minSize, multiple = _defaultProps$props.multiple, maxFiles = _defaultProps$props.maxFiles, onDragEnter = _defaultProps$props.onDragEnter, onDragLeave = _defaultProps$props.onDragLeave, onDragOver = _defaultProps$props.onDragOver, onDrop = _defaultProps$props.onDrop, onDropAccepted = _defaultProps$props.onDropAccepted, onDropRejected = _defaultProps$props.onDropRejected, onFileDialogCancel = _defaultProps$props.onFileDialogCancel, onFileDialogOpen = _defaultProps$props.onFileDialogOpen, useFsAccessApi = _defaultProps$props.useFsAccessApi, autoFocus = _defaultProps$props.autoFocus, preventDropOnDocument = _defaultProps$props.preventDropOnDocument, noClick = _defaultProps$props.noClick, noKeyboard = _defaultProps$props.noKeyboard, noDrag = _defaultProps$props.noDrag, noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling, onError = _defaultProps$props.onError, validator = _defaultProps$props.validator;
    var acceptAttr = (0, $jC8Vy.useMemo)(function() {
        return (0, $16bd9a4d101e8e29$export$1278288bcefb97b9)(accept);
    }, [
        accept
    ]);
    var pickerTypes = (0, $jC8Vy.useMemo)(function() {
        return (0, $16bd9a4d101e8e29$export$8ce4bd13c494743e)(accept);
    }, [
        accept
    ]);
    var onFileDialogOpenCb = (0, $jC8Vy.useMemo)(function() {
        return typeof onFileDialogOpen === "function" ? onFileDialogOpen : $9d9dd5baa20d706c$var$noop;
    }, [
        onFileDialogOpen
    ]);
    var onFileDialogCancelCb = (0, $jC8Vy.useMemo)(function() {
        return typeof onFileDialogCancel === "function" ? onFileDialogCancel : $9d9dd5baa20d706c$var$noop;
    }, [
        onFileDialogCancel
    ]);
    /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */ var rootRef = (0, $jC8Vy.useRef)(null);
    var inputRef = (0, $jC8Vy.useRef)(null);
    var _useReducer = (0, $jC8Vy.useReducer)($9d9dd5baa20d706c$var$reducer, $9d9dd5baa20d706c$var$initialState), _useReducer2 = $9d9dd5baa20d706c$var$_slicedToArray(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive;
    var fsAccessApiWorksRef = (0, $jC8Vy.useRef)(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && (0, $16bd9a4d101e8e29$export$858af2af50e1eaf8)()); // Update file dialog active state when the window is focused on
    var onWindowFocus = function onWindowFocus() {
        // Execute the timeout only if the file dialog is opened in the browser
        if (!fsAccessApiWorksRef.current && isFileDialogActive) setTimeout(function() {
            if (inputRef.current) {
                var files = inputRef.current.files;
                if (!files.length) {
                    dispatch({
                        type: "closeDialog"
                    });
                    onFileDialogCancelCb();
                }
            }
        }, 300);
    };
    (0, $jC8Vy.useEffect)(function() {
        window.addEventListener("focus", onWindowFocus, false);
        return function() {
            window.removeEventListener("focus", onWindowFocus, false);
        };
    }, [
        inputRef,
        isFileDialogActive,
        onFileDialogCancelCb,
        fsAccessApiWorksRef
    ]);
    var dragTargetsRef = (0, $jC8Vy.useRef)([]);
    var onDocumentDrop = function onDocumentDrop(event) {
        if (rootRef.current && rootRef.current.contains(event.target)) // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
        event.preventDefault();
        dragTargetsRef.current = [];
    };
    (0, $jC8Vy.useEffect)(function() {
        if (preventDropOnDocument) {
            document.addEventListener("dragover", (0, $16bd9a4d101e8e29$export$2ead263d6635cecc), false);
            document.addEventListener("drop", onDocumentDrop, false);
        }
        return function() {
            if (preventDropOnDocument) {
                document.removeEventListener("dragover", (0, $16bd9a4d101e8e29$export$2ead263d6635cecc));
                document.removeEventListener("drop", onDocumentDrop);
            }
        };
    }, [
        rootRef,
        preventDropOnDocument
    ]); // Auto focus the root when autoFocus is true
    (0, $jC8Vy.useEffect)(function() {
        if (!disabled && autoFocus && rootRef.current) rootRef.current.focus();
        return function() {};
    }, [
        rootRef,
        autoFocus,
        disabled
    ]);
    var onErrCb = (0, $jC8Vy.useCallback)(function(e) {
        if (onError) onError(e);
        else // Let the user know something's gone wrong if they haven't provided the onError cb.
        console.error(e);
    }, [
        onError
    ]);
    var onDragEnterCb = (0, $jC8Vy.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [].concat($9d9dd5baa20d706c$var$_toConsumableArray(dragTargetsRef.current), [
            event.target
        ]);
        if ((0, $16bd9a4d101e8e29$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $16bd9a4d101e8e29$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            var fileCount = files.length;
            var isDragAccept = fileCount > 0 && (0, $16bd9a4d101e8e29$export$6a0bb4322c81a197)({
                files: files,
                accept: acceptAttr,
                minSize: minSize,
                maxSize: maxSize,
                multiple: multiple,
                maxFiles: maxFiles,
                validator: validator
            });
            var isDragReject = fileCount > 0 && !isDragAccept;
            dispatch({
                isDragAccept: isDragAccept,
                isDragReject: isDragReject,
                isDragActive: true,
                type: "setDraggedFiles"
            });
            if (onDragEnter) onDragEnter(event);
        }).catch(function(e) {
            return onErrCb(e);
        });
    }, [
        getFilesFromEvent,
        onDragEnter,
        onErrCb,
        noDragEventsBubbling,
        acceptAttr,
        minSize,
        maxSize,
        multiple,
        maxFiles,
        validator
    ]);
    var onDragOverCb = (0, $jC8Vy.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event);
        var hasFiles = (0, $16bd9a4d101e8e29$export$52f1fc875a1e5986)(event);
        if (hasFiles && event.dataTransfer) try {
            event.dataTransfer.dropEffect = "copy";
        } catch (_unused) {}
        if (hasFiles && onDragOver) onDragOver(event);
        return false;
    }, [
        onDragOver,
        noDragEventsBubbling
    ]);
    var onDragLeaveCb = (0, $jC8Vy.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event); // Only deactivate once the dropzone and all children have been left
        var targets = dragTargetsRef.current.filter(function(target) {
            return rootRef.current && rootRef.current.contains(target);
        }); // Make sure to remove a target present multiple times only once
        // (Firefox may fire dragenter/dragleave multiple times on the same element)
        var targetIdx = targets.indexOf(event.target);
        if (targetIdx !== -1) targets.splice(targetIdx, 1);
        dragTargetsRef.current = targets;
        if (targets.length > 0) return;
        dispatch({
            type: "setDraggedFiles",
            isDragActive: false,
            isDragAccept: false,
            isDragReject: false
        });
        if ((0, $16bd9a4d101e8e29$export$52f1fc875a1e5986)(event) && onDragLeave) onDragLeave(event);
    }, [
        rootRef,
        onDragLeave,
        noDragEventsBubbling
    ]);
    var setFiles = (0, $jC8Vy.useCallback)(function(files, event) {
        var acceptedFiles = [];
        var fileRejections = [];
        files.forEach(function(file) {
            var _fileAccepted = (0, $16bd9a4d101e8e29$export$b511db3632effe58)(file, acceptAttr), _fileAccepted2 = $9d9dd5baa20d706c$var$_slicedToArray(_fileAccepted, 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1];
            var _fileMatchSize = (0, $16bd9a4d101e8e29$export$860631d45ba43fd9)(file, minSize, maxSize), _fileMatchSize2 = $9d9dd5baa20d706c$var$_slicedToArray(_fileMatchSize, 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1];
            var customErrors = validator ? validator(file) : null;
            if (accepted && sizeMatch && !customErrors) acceptedFiles.push(file);
            else {
                var errors = [
                    acceptError,
                    sizeError
                ];
                if (customErrors) errors = errors.concat(customErrors);
                fileRejections.push({
                    file: file,
                    errors: errors.filter(function(e) {
                        return e;
                    })
                });
            }
        });
        if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
            // Reject everything and empty accepted files
            acceptedFiles.forEach(function(file) {
                fileRejections.push({
                    file: file,
                    errors: [
                        (0, $16bd9a4d101e8e29$export$1e1e1b6120329fe)
                    ]
                });
            });
            acceptedFiles.splice(0);
        }
        dispatch({
            acceptedFiles: acceptedFiles,
            fileRejections: fileRejections,
            type: "setFiles"
        });
        if (onDrop) onDrop(acceptedFiles, fileRejections, event);
        if (fileRejections.length > 0 && onDropRejected) onDropRejected(fileRejections, event);
        if (acceptedFiles.length > 0 && onDropAccepted) onDropAccepted(acceptedFiles, event);
    }, [
        dispatch,
        multiple,
        acceptAttr,
        minSize,
        maxSize,
        maxFiles,
        onDrop,
        onDropAccepted,
        onDropRejected,
        validator
    ]);
    var onDropCb = (0, $jC8Vy.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [];
        if ((0, $16bd9a4d101e8e29$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $16bd9a4d101e8e29$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            setFiles(files, event);
        }).catch(function(e) {
            return onErrCb(e);
        });
        dispatch({
            type: "reset"
        });
    }, [
        getFilesFromEvent,
        setFiles,
        onErrCb,
        noDragEventsBubbling
    ]); // Fn for opening the file dialog programmatically
    var openFileDialog = (0, $jC8Vy.useCallback)(function() {
        // No point to use FS access APIs if context is not secure
        // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
        if (fsAccessApiWorksRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
            var opts = {
                multiple: multiple,
                types: pickerTypes
            };
            window.showOpenFilePicker(opts).then(function(handles) {
                return getFilesFromEvent(handles);
            }).then(function(files) {
                setFiles(files, null);
                dispatch({
                    type: "closeDialog"
                });
            }).catch(function(e) {
                // AbortError means the user canceled
                if ((0, $16bd9a4d101e8e29$export$72580c77a176a18f)(e)) {
                    onFileDialogCancelCb(e);
                    dispatch({
                        type: "closeDialog"
                    });
                } else if ((0, $16bd9a4d101e8e29$export$c4f82d4432e209a9)(e)) {
                    fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
                    // Try using the input
                    if (inputRef.current) {
                        inputRef.current.value = null;
                        inputRef.current.click();
                    } else onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
                } else onErrCb(e);
            });
            return;
        }
        if (inputRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb();
            inputRef.current.value = null;
            inputRef.current.click();
        }
    }, [
        dispatch,
        onFileDialogOpenCb,
        onFileDialogCancelCb,
        useFsAccessApi,
        setFiles,
        onErrCb,
        pickerTypes,
        multiple
    ]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone
    var onKeyDownCb = (0, $jC8Vy.useCallback)(function(event) {
        // Ignore keyboard events bubbling up the DOM tree
        if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) return;
        if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
            event.preventDefault();
            openFileDialog();
        }
    }, [
        rootRef,
        openFileDialog
    ]); // Update focus state for the dropzone
    var onFocusCb = (0, $jC8Vy.useCallback)(function() {
        dispatch({
            type: "focus"
        });
    }, []);
    var onBlurCb = (0, $jC8Vy.useCallback)(function() {
        dispatch({
            type: "blur"
        });
    }, []); // Cb to open the file dialog when click occurs on the dropzone
    var onClickCb = (0, $jC8Vy.useCallback)(function() {
        if (noClick) return;
         // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
        // to ensure React can handle state changes
        // See: https://github.com/react-dropzone/react-dropzone/issues/450
        if ((0, $16bd9a4d101e8e29$export$d3498e653911f962)()) setTimeout(openFileDialog, 0);
        else openFileDialog();
    }, [
        noClick,
        openFileDialog
    ]);
    var composeHandler = function composeHandler(fn) {
        return disabled ? null : fn;
    };
    var composeKeyboardHandler = function composeKeyboardHandler(fn) {
        return noKeyboard ? null : composeHandler(fn);
    };
    var composeDragHandler = function composeDragHandler(fn) {
        return noDrag ? null : composeHandler(fn);
    };
    var stopPropagation = function stopPropagation(event) {
        if (noDragEventsBubbling) event.stopPropagation();
    };
    var getRootProps = (0, $jC8Vy.useMemo)(function() {
        return function() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$refKey = _ref2.refKey, refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey, role = _ref2.role, onKeyDown = _ref2.onKeyDown, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, onClick = _ref2.onClick, onDragEnter = _ref2.onDragEnter, onDragOver = _ref2.onDragOver, onDragLeave = _ref2.onDragLeave, onDrop = _ref2.onDrop, rest = $9d9dd5baa20d706c$var$_objectWithoutProperties(_ref2, $9d9dd5baa20d706c$var$_excluded3);
            return $9d9dd5baa20d706c$var$_objectSpread($9d9dd5baa20d706c$var$_objectSpread($9d9dd5baa20d706c$var$_defineProperty({
                onKeyDown: composeKeyboardHandler((0, $16bd9a4d101e8e29$export$b9ecd428b558ff10)(onKeyDown, onKeyDownCb)),
                onFocus: composeKeyboardHandler((0, $16bd9a4d101e8e29$export$b9ecd428b558ff10)(onFocus, onFocusCb)),
                onBlur: composeKeyboardHandler((0, $16bd9a4d101e8e29$export$b9ecd428b558ff10)(onBlur, onBlurCb)),
                onClick: composeHandler((0, $16bd9a4d101e8e29$export$b9ecd428b558ff10)(onClick, onClickCb)),
                onDragEnter: composeDragHandler((0, $16bd9a4d101e8e29$export$b9ecd428b558ff10)(onDragEnter, onDragEnterCb)),
                onDragOver: composeDragHandler((0, $16bd9a4d101e8e29$export$b9ecd428b558ff10)(onDragOver, onDragOverCb)),
                onDragLeave: composeDragHandler((0, $16bd9a4d101e8e29$export$b9ecd428b558ff10)(onDragLeave, onDragLeaveCb)),
                onDrop: composeDragHandler((0, $16bd9a4d101e8e29$export$b9ecd428b558ff10)(onDrop, onDropCb)),
                role: typeof role === "string" && role !== "" ? role : "presentation"
            }, refKey, rootRef), !disabled && !noKeyboard ? {
                tabIndex: 0
            } : {}), rest);
        };
    }, [
        rootRef,
        onKeyDownCb,
        onFocusCb,
        onBlurCb,
        onClickCb,
        onDragEnterCb,
        onDragOverCb,
        onDragLeaveCb,
        onDropCb,
        noKeyboard,
        noDrag,
        disabled
    ]);
    var onInputElementClick = (0, $jC8Vy.useCallback)(function(event) {
        event.stopPropagation();
    }, []);
    var getInputProps = (0, $jC8Vy.useMemo)(function() {
        return function() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, onChange = _ref3.onChange, onClick = _ref3.onClick, rest = $9d9dd5baa20d706c$var$_objectWithoutProperties(_ref3, $9d9dd5baa20d706c$var$_excluded4);
            var inputProps = $9d9dd5baa20d706c$var$_defineProperty({
                accept: acceptAttr,
                multiple: multiple,
                type: "file",
                style: {
                    display: "none"
                },
                onChange: composeHandler((0, $16bd9a4d101e8e29$export$b9ecd428b558ff10)(onChange, onDropCb)),
                onClick: composeHandler((0, $16bd9a4d101e8e29$export$b9ecd428b558ff10)(onClick, onInputElementClick)),
                tabIndex: -1
            }, refKey, inputRef);
            return $9d9dd5baa20d706c$var$_objectSpread($9d9dd5baa20d706c$var$_objectSpread({}, inputProps), rest);
        };
    }, [
        inputRef,
        accept,
        multiple,
        onDropCb,
        disabled
    ]);
    return $9d9dd5baa20d706c$var$_objectSpread($9d9dd5baa20d706c$var$_objectSpread({}, state), {}, {
        isFocused: isFocused && !disabled,
        getRootProps: getRootProps,
        getInputProps: getInputProps,
        rootRef: rootRef,
        inputRef: inputRef,
        open: composeHandler(openFileDialog)
    });
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */ function $9d9dd5baa20d706c$var$reducer(state, action) {
    /* istanbul ignore next */ switch(action.type){
        case "focus":
            return $9d9dd5baa20d706c$var$_objectSpread($9d9dd5baa20d706c$var$_objectSpread({}, state), {}, {
                isFocused: true
            });
        case "blur":
            return $9d9dd5baa20d706c$var$_objectSpread($9d9dd5baa20d706c$var$_objectSpread({}, state), {}, {
                isFocused: false
            });
        case "openDialog":
            return $9d9dd5baa20d706c$var$_objectSpread($9d9dd5baa20d706c$var$_objectSpread({}, $9d9dd5baa20d706c$var$initialState), {}, {
                isFileDialogActive: true
            });
        case "closeDialog":
            return $9d9dd5baa20d706c$var$_objectSpread($9d9dd5baa20d706c$var$_objectSpread({}, state), {}, {
                isFileDialogActive: false
            });
        case "setDraggedFiles":
            return $9d9dd5baa20d706c$var$_objectSpread($9d9dd5baa20d706c$var$_objectSpread({}, state), {}, {
                isDragActive: action.isDragActive,
                isDragAccept: action.isDragAccept,
                isDragReject: action.isDragReject
            });
        case "setFiles":
            return $9d9dd5baa20d706c$var$_objectSpread($9d9dd5baa20d706c$var$_objectSpread({}, state), {}, {
                acceptedFiles: action.acceptedFiles,
                fileRejections: action.fileRejections
            });
        case "reset":
            return $9d9dd5baa20d706c$var$_objectSpread({}, $9d9dd5baa20d706c$var$initialState);
        default:
            return state;
    }
}
function $9d9dd5baa20d706c$var$noop() {}


parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $fbedeff6d2a860db$var$SvgUpload = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "m7.258 6.425 1.909-1.917V12.5a.833.833 0 1 0 1.666 0V4.508l1.909 1.917a.834.834 0 0 0 1.365-.271.833.833 0 0 0-.182-.912l-3.333-3.334a.833.833 0 0 0-.275-.175.833.833 0 0 0-.634 0 .833.833 0 0 0-.275.175L6.075 5.242a.837.837 0 0 0 1.183 1.183ZM17.5 11.667a.833.833 0 0 0-.833.833v3.333a.833.833 0 0 1-.834.834H4.167a.834.834 0 0 1-.834-.834V12.5a.833.833 0 0 0-1.666 0v3.333a2.5 2.5 0 0 0 2.5 2.5h11.666a2.5 2.5 0 0 0 2.5-2.5V12.5a.833.833 0 0 0-.833-.833Z",
            fill: "currentColor"
        })
    });
var $fbedeff6d2a860db$export$2e2bcd8739ae039 = $fbedeff6d2a860db$var$SvgUpload;



var $7VnwS = parcelRequire("7VnwS");


var $k9Oeh = parcelRequire("k9Oeh");
var $0ba6b249b88ae881$export$3cd962a22a1283f7;
var $0ba6b249b88ae881$export$9add80a8a1d26c03;
var $0ba6b249b88ae881$export$1ca1ec8b29a4ce27;
var $0ba6b249b88ae881$export$c7187bbd1a7a9244;
var $0ba6b249b88ae881$export$bfd64c937657f93a;
var $0ba6b249b88ae881$export$4a6dd88bada4e7d2;
var $0ba6b249b88ae881$export$7472b0d4ff79ef04;
var $0ba6b249b88ae881$export$478d35d0482051bc;
var $0ba6b249b88ae881$export$68adaa21ca97498a;
$0ba6b249b88ae881$export$3cd962a22a1283f7 = `_7kuApa_actionDescription`;
$0ba6b249b88ae881$export$9add80a8a1d26c03 = `_7kuApa_dragActive`;
$0ba6b249b88ae881$export$1ca1ec8b29a4ce27 = `_7kuApa_icon`;
$0ba6b249b88ae881$export$c7187bbd1a7a9244 = `_7kuApa_placeholder`;
$0ba6b249b88ae881$export$bfd64c937657f93a = `_7kuApa_rotating`;
$0ba6b249b88ae881$export$4a6dd88bada4e7d2 = `_7kuApa_shimmer`;
$0ba6b249b88ae881$export$7472b0d4ff79ef04 = `_7kuApa_uploader`;
$0ba6b249b88ae881$export$478d35d0482051bc = `_7kuApa_uploaderError`;
$0ba6b249b88ae881$export$68adaa21ca97498a = `_7kuApa_uploadingIcon`;


function $73711a10c31ea3e5$var$FileUploader({ maxSize: maxSize, allowedMimeTypes: allowedMimeTypes, actionDescription: actionDescription, onCompleted: onCompleted, onUploadErrorChange: onUploadErrorChange, className: className, apiInstance: apiInstance, uploadUrl: uploadUrl = "api/user-assets" }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [isUploading, setIsUploading] = (0, $jC8Vy.useState)(false);
    const [uploadError, setUploadError] = (0, $jC8Vy.useState)();
    (0, $jC8Vy.useEffect)(()=>{
        onUploadErrorChange(uploadError);
        return ()=>{
            onUploadErrorChange(undefined);
        };
    }, [
        onUploadErrorChange,
        uploadError
    ]);
    const api = (0, $7VnwS.default)();
    const onDrop = (0, $jC8Vy.useCallback)(async (acceptedFiles = [], fileRejection = [])=>{
        setUploadError(undefined);
        if (fileRejection.length > 1) {
            setUploadError(t("components.uploader.error_file_count"));
            return;
        }
        const rejectedFile = fileRejection[0]?.file;
        if (rejectedFile) {
            /**
         * Note:
         * We need to display this invalid file type error, since the user can select an invalid file type by modifying the file input dialog settings.
         */ if (!allowedMimeTypes.map(String).includes(rejectedFile.type)) setUploadError(t("components.uploader.error_file_type", {
                extensions: (0, $9c2fc023cf60b41b$export$e3d6b5f79f02cd5b)(allowedMimeTypes)
            }));
            return;
        }
        const acceptedFile = acceptedFiles[0];
        if (!acceptedFile) return;
        const fileSizeLimit = Math.min(maxSize, (0, $2rWG7.maxUploadFileSize));
        if (acceptedFile.size > fileSizeLimit) {
            setUploadError(t("components.uploader.error_file_size", {
                size: fileSizeLimit / 1024
            }));
            return;
        }
        const formData = new FormData();
        formData.append("file", acceptedFile);
        try {
            setIsUploading(true);
            const uploadApi = apiInstance ?? api;
            const { url: url } = await uploadApi.post(uploadUrl, {
                body: formData
            }).json();
            onCompleted(url);
        } catch  {
            setUploadError(t("components.uploader.error_upload"));
        } finally{
            setIsUploading(false);
        }
    }, [
        api,
        apiInstance,
        allowedMimeTypes,
        maxSize,
        onCompleted,
        t,
        uploadUrl
    ]);
    const { getRootProps: getRootProps, getInputProps: getInputProps, isDragActive: isDragActive } = (0, $9d9dd5baa20d706c$export$cd49c0ecc5be9f36)({
        onDrop: onDrop,
        disabled: isUploading,
        multiple: false,
        accept: Object.fromEntries(allowedMimeTypes.map((mimeType)=>[
                mimeType,
                []
            ]))
    });
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        ...getRootProps(),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($0ba6b249b88ae881$export$7472b0d4ff79ef04, Boolean(uploadError) && $0ba6b249b88ae881$export$478d35d0482051bc, isDragActive && $0ba6b249b88ae881$export$9add80a8a1d26c03, className),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("input", {
                ...getInputProps()
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $0ba6b249b88ae881$export$c7187bbd1a7a9244,
                children: isUploading ? /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $k9Oeh.Ring), {
                            className: $0ba6b249b88ae881$export$68adaa21ca97498a
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $0ba6b249b88ae881$export$3cd962a22a1283f7,
                            children: t("components.uploader.uploading")
                        })
                    ]
                }) : /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fbedeff6d2a860db$export$2e2bcd8739ae039), {
                            className: $0ba6b249b88ae881$export$1ca1ec8b29a4ce27
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $0ba6b249b88ae881$export$3cd962a22a1283f7,
                            children: actionDescription ?? t("components.uploader.action_description")
                        })
                    ]
                })
            })
        ]
    });
}
var $73711a10c31ea3e5$export$2e2bcd8739ae039 = $73711a10c31ea3e5$var$FileUploader;


var $1f7633ac0edb8e53$export$34e0f9847d4c02dd;
var $1f7633ac0edb8e53$export$1822828d790e23ee;
var $1f7633ac0edb8e53$export$4586892ac4b071a;
var $1f7633ac0edb8e53$export$bfd64c937657f93a;
var $1f7633ac0edb8e53$export$4a6dd88bada4e7d2;
$1f7633ac0edb8e53$export$34e0f9847d4c02dd = `_1lFu6a_container`;
$1f7633ac0edb8e53$export$1822828d790e23ee = `_1lFu6a_delete`;
$1f7633ac0edb8e53$export$4586892ac4b071a = `_1lFu6a_imageUploader`;
$1f7633ac0edb8e53$export$bfd64c937657f93a = `_1lFu6a_rotating`;
$1f7633ac0edb8e53$export$4a6dd88bada4e7d2 = `_1lFu6a_shimmer`;


function $d986fdd56af49b28$var$ImageUploader({ name: name, value: value, onDelete: onDelete, allowedMimeTypes: imageMimeTypes, className: className, ...rest }) {
    const { allowedMimeTypes: allowedMimeTypes } = (0, $75ebfd707e0e1bc0$export$2e2bcd8739ae039)(imageMimeTypes);
    return value ? /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($1f7633ac0edb8e53$export$4586892ac4b071a, className),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dbaecc0d7fe55772$export$2e2bcd8739ae039), {
                containerClassName: $1f7633ac0edb8e53$export$34e0f9847d4c02dd,
                src: value,
                alt: name,
                /**
         * Some social connectors like Google will block the references to its image resource,
         * without specifying the referrerPolicy attribute. Reference:
         * https://stackoverflow.com/questions/40570117/http403-forbidden-error-when-trying-to-load-img-src-with-google-profile-pic
         */ referrerPolicy: "no-referrer"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                className: $1f7633ac0edb8e53$export$1822828d790e23ee,
                onClick: ()=>{
                    onDelete();
                },
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3aa588de5c8665f2$export$2e2bcd8739ae039), {})
            })
        ]
    }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $73711a10c31ea3e5$export$2e2bcd8739ae039), {
        allowedMimeTypes: allowedMimeTypes,
        maxSize: (0, $75ebfd707e0e1bc0$export$7b487c2956dcad6),
        className: className,
        ...rest
    });
}
var $d986fdd56af49b28$export$2e2bcd8739ae039 = $d986fdd56af49b28$var$ImageUploader;


var $af4e3ffd27d16e15$export$6d59db4903f20f7d;
var $af4e3ffd27d16e15$export$a3bc9b8ed74fc;
var $af4e3ffd27d16e15$export$bfd64c937657f93a;
var $af4e3ffd27d16e15$export$4a6dd88bada4e7d2;
$af4e3ffd27d16e15$export$6d59db4903f20f7d = `K0z4Jq_description`;
$af4e3ffd27d16e15$export$a3bc9b8ed74fc = `K0z4Jq_error`;
$af4e3ffd27d16e15$export$bfd64c937657f93a = `K0z4Jq_rotating`;
$af4e3ffd27d16e15$export$4a6dd88bada4e7d2 = `K0z4Jq_shimmer`;


function $ab5b5e61d391674b$var$ImageUploaderField({ onChange: onChange, allowedMimeTypes: mimeTypes, ...rest }) {
    const { allowedMimeTypes: allowedMimeTypes, description: limitDescription } = (0, $75ebfd707e0e1bc0$export$2e2bcd8739ae039)(mimeTypes);
    const [uploadError, setUploadError] = (0, $jC8Vy.useState)();
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $d986fdd56af49b28$export$2e2bcd8739ae039), {
                allowedMimeTypes: allowedMimeTypes,
                onCompleted: onChange,
                onUploadErrorChange: setUploadError,
                onDelete: ()=>{
                    onChange("");
                },
                ...rest
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($af4e3ffd27d16e15$export$6d59db4903f20f7d, Boolean(uploadError) && $af4e3ffd27d16e15$export$a3bc9b8ed74fc),
                children: uploadError ?? limitDescription
            })
        ]
    });
}
var $ab5b5e61d391674b$export$2e2bcd8739ae039 = $ab5b5e61d391674b$var$ImageUploaderField;



parcelRequire("6bq3s");
var $2Phw0 = parcelRequire("2Phw0");

var $Xh5AE = parcelRequire("Xh5AE");
parcelRequire("8Mb3E");
var $ku6YN = parcelRequire("ku6YN");
var $7YcaX = parcelRequire("7YcaX");

var $8TpMk = parcelRequire("8TpMk");

var $cDKfs = parcelRequire("cDKfs");

var $7VnwS = parcelRequire("7VnwS");

const $04111409d75abad4$var$useUserAssetsService = ()=>{
    const adminApi = (0, $7VnwS.useStaticApi)({
        prefixUrl: (0, $ku6YN.adminTenantEndpoint),
        resourceIndicator: (0, $7YcaX.meApi).indicator
    });
    const api = (0, $7VnwS.default)();
    const { pathname: pathname } = (0, $2Phw0.useLocation)();
    const isProfilePage = pathname === (0, $cDKfs.GlobalRoute).Profile || pathname.startsWith((0, $cDKfs.GlobalRoute).Profile + "/");
    const shouldUseAdminApi = (0, $8TpMk.isCloud) && isProfilePage;
    const fetcher = (0, $04c74fc7d2f91811$export$2e2bcd8739ae039)(shouldUseAdminApi ? adminApi : api);
    const { data: data, error: error } = (0, $Xh5AE.default)(`${shouldUseAdminApi ? "me" : "api"}/user-assets/service-status`, fetcher);
    return {
        isReady: data?.status === "ready",
        isLoading: !error && !data
    };
};
var $04111409d75abad4$export$2e2bcd8739ae039 = $04111409d75abad4$var$useUserAssetsService;



var $C7mD2 = parcelRequire("C7mD2");

function $8b9fbd483153db2c$var$CardSelector({ name: name, value: value, options: options, onChange: onChange, optionClassName: optionClassName }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c8e461321115642d$export$2e2bcd8739ae039), {
        type: "compact",
        value: value,
        name: name,
        onChange: onChange,
        children: options.map(({ value: optionValue, title: title, icon: icon })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $b4b7cf2a2e4180e8$export$2e2bcd8739ae039), {
                icon: icon,
                title: title,
                value: optionValue,
                className: optionClassName
            }, optionValue))
    });
}
var $8b9fbd483153db2c$export$2e2bcd8739ae039 = $8b9fbd483153db2c$var$CardSelector;



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $5UrGx = parcelRequire("5UrGx");

var $66ixW = parcelRequire("66ixW");
parcelRequire("fIF1D");
var $16GE9 = parcelRequire("16GE9");

var $bnkR4 = parcelRequire("bnkR4");
var $27f89d6429d86912$export$a7db06668cad9adb;
var $27f89d6429d86912$export$683472f6198a076e;
var $27f89d6429d86912$export$1ca1ec8b29a4ce27;
var $27f89d6429d86912$export$7061c75fc5af8b7e;
var $27f89d6429d86912$export$bfd64c937657f93a;
var $27f89d6429d86912$export$d90250155de6d7e7;
var $27f89d6429d86912$export$4a6dd88bada4e7d2;
var $27f89d6429d86912$export$2b067c6666111485;
var $27f89d6429d86912$export$eb0a821c2940f274;
$27f89d6429d86912$export$a7db06668cad9adb = `RkZH6W_content`;
$27f89d6429d86912$export$683472f6198a076e = `RkZH6W_disabled`;
$27f89d6429d86912$export$1ca1ec8b29a4ce27 = `RkZH6W_icon`;
$27f89d6429d86912$export$7061c75fc5af8b7e = `RkZH6W_item`;
$27f89d6429d86912$export$bfd64c937657f93a = `RkZH6W_rotating`;
$27f89d6429d86912$export$d90250155de6d7e7 = `RkZH6W_selected`;
$27f89d6429d86912$export$4a6dd88bada4e7d2 = `RkZH6W_shimmer`;
$27f89d6429d86912$export$2b067c6666111485 = `RkZH6W_tag`;
$27f89d6429d86912$export$eb0a821c2940f274 = `RkZH6W_trailingTag`;


function $bd9304df1b90a33d$var$CardItem({ option: { icon: icon, title: title, value: value, tag: tag, trailingTag: trailingTag, isDisabled: isDisabled, disabledTip: disabledTip }, isSelected: isSelected, onClick: onClick, className: className }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $16GE9.default), {
        content: (0, $7oDSS.conditional)(isDisabled && disabledTip && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
            forKey: disabledTip
        })),
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
            role: "button",
            tabIndex: 0,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($27f89d6429d86912$export$7061c75fc5af8b7e, isDisabled && $27f89d6429d86912$export$683472f6198a076e, isSelected && $27f89d6429d86912$export$d90250155de6d7e7, className),
            onClick: ()=>{
                if (isDisabled) return;
                onClick(value);
            },
            onKeyDown: (0, $bnkR4.onKeyDownHandler)(()=>{
                if (isDisabled) return;
                onClick(value);
            }),
            children: [
                icon && /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                    className: $27f89d6429d86912$export$1ca1ec8b29a4ce27,
                    children: icon
                }),
                /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: $27f89d6429d86912$export$a7db06668cad9adb,
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                            children: [
                                typeof title === "string" ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                    forKey: title
                                }) : title,
                                trailingTag && /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($27f89d6429d86912$export$2b067c6666111485, $27f89d6429d86912$export$eb0a821c2940f274),
                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                        forKey: trailingTag
                                    })
                                })
                            ]
                        }),
                        tag && /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                            className: $27f89d6429d86912$export$2b067c6666111485,
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                forKey: tag
                            })
                        })
                    ]
                })
            ]
        }, value)
    });
}
var $bd9304df1b90a33d$export$2e2bcd8739ae039 = $bd9304df1b90a33d$var$CardItem;


var $ccdbc8f8d2f81871$export$bfd64c937657f93a;
var $ccdbc8f8d2f81871$export$aea217a45095ce11;
var $ccdbc8f8d2f81871$export$4a6dd88bada4e7d2;
$ccdbc8f8d2f81871$export$bfd64c937657f93a = `-XdXDW_rotating`;
$ccdbc8f8d2f81871$export$aea217a45095ce11 = `-XdXDW_selector`;
$ccdbc8f8d2f81871$export$4a6dd88bada4e7d2 = `-XdXDW_shimmer`;


function $9326dcdf6e771d52$var$MultiCardSelector({ options: options, value: selectedValues, onChange: onChange, isNotAllowEmpty: isNotAllowEmpty = false, className: className, optionClassName: optionClassName }) {
    const onToggle = (value)=>{
        if (selectedValues.includes(value) && selectedValues.length === 1 && isNotAllowEmpty) return;
        onChange(selectedValues.includes(value) ? selectedValues.filter((selected)=>selected !== value) : [
            ...selectedValues,
            value
        ]);
    };
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($ccdbc8f8d2f81871$export$aea217a45095ce11, className),
        children: options.map((option)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $bd9304df1b90a33d$export$2e2bcd8739ae039), {
                option: option,
                isSelected: selectedValues.includes(option.value),
                className: optionClassName,
                onClick: onToggle
            }, option.value))
    });
}
var $9326dcdf6e771d52$export$2e2bcd8739ae039 = $9326dcdf6e771d52$var$MultiCardSelector;




parcelRequire("4taJ0");
var $hyigV = parcelRequire("hyigV");
parcelRequire("cuPVN");
var $aZIrr = parcelRequire("aZIrr");
parcelRequire("12bMu");
var $gcHb7 = parcelRequire("gcHb7");

var $jC8Vy = parcelRequire("jC8Vy");

var $2Phw0 = parcelRequire("2Phw0");

var $7VnwS = parcelRequire("7VnwS");
/**
 * A hook to get a Ky instance with the current tenant's Management API prefix URL. Note this hook
 * can only be used in a route with a `:tenantId` param.
 */ const $c1b7f9ae52d4d5d8$var$useTenantApi = (props = {})=>{
    const { tenantId: currentTenantId } = (0, $2Phw0.useParams)();
    if (!currentTenantId) throw new Error("No tenant ID param found in the current route. This hook should be used in a route with a tenant ID param.");
    const config = (0, $jC8Vy.useMemo)(()=>({
            prefixUrl: (0, $gcHb7.appendPath)(new URL(window.location.origin), "m", currentTenantId),
            resourceIndicator: (0, $hyigV.buildOrganizationUrn)((0, $aZIrr.getTenantOrganizationId)(currentTenantId))
        }), [
        currentTenantId
    ]);
    return (0, $7VnwS.useStaticApi)({
        ...props,
        ...config
    });
};
var $c1b7f9ae52d4d5d8$export$2e2bcd8739ae039 = $c1b7f9ae52d4d5d8$var$useTenantApi;



var $jC8Vy = parcelRequire("jC8Vy");


var $7VnwS = parcelRequire("7VnwS");
const $d3d6bc7d2607318c$export$9ea285d0c158d4f1 = (options)=>{
    return (error)=>{
        if (error instanceof (0, $7VnwS.RequestError)) {
            const { status: status } = error;
            const { ignore: ignore } = options ?? {};
            return !ignore?.includes(status);
        }
        return true;
    };
};



/**
 * A hook to get the SWR options for the current tenant by reading the `:tenantId` param from the
 * route.
 */ const $43f1764fabec2aae$var$useTenantSwrOptions = ()=>{
    const api = (0, $c1b7f9ae52d4d5d8$export$2e2bcd8739ae039)();
    const fetcher = (0, $04c74fc7d2f91811$export$2e2bcd8739ae039)(api);
    const config = (0, $jC8Vy.useMemo)(()=>({
            fetcher: fetcher,
            shouldRetryOnError: (0, $d3d6bc7d2607318c$export$9ea285d0c158d4f1)({
                ignore: [
                    401,
                    403
                ]
            })
        }), [
        fetcher
    ]);
    return config;
};
var $43f1764fabec2aae$export$2e2bcd8739ae039 = $43f1764fabec2aae$var$useTenantSwrOptions;



var $Xh5AE = parcelRequire("Xh5AE");


/**
 * A hook to check if the current tenant's user assets service is ready. The tenant ID is read from
 * `:tenantId` param in the route.
 */ const $0075be353fe024d3$var$useTenantUserAssetsService = ()=>{
    const api = (0, $c1b7f9ae52d4d5d8$export$2e2bcd8739ae039)();
    const fetcher = (0, $04c74fc7d2f91811$export$2e2bcd8739ae039)(api);
    const { data: data, error: error } = (0, $Xh5AE.default)("api/user-assets/service-status", fetcher);
    return {
        isReady: data?.status === "ready",
        isLoading: !error && !data
    };
};
var $0075be353fe024d3$export$2e2bcd8739ae039 = $0075be353fe024d3$var$useTenantUserAssetsService;





var $5OcFi = parcelRequire("5OcFi");

var $7kooT = parcelRequire("7kooT");

var $cRLgg = parcelRequire("cRLgg");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("oK7kD");
var $kowfT = parcelRequire("kowfT");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $4ab96380b630a7ab$var$SvgBulb = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M16.072 5.457a6.4 6.4 0 0 0-5.344-1.328 6.4 6.4 0 0 0-5.016 5.056 6.456 6.456 0 0 0 1.376 5.32c.563.635.886 1.448.912 2.296v2.4a2.4 2.4 0 0 0 2.4 2.4h3.2a2.4 2.4 0 0 0 2.4-2.4v-2.248c.027-.937.371-1.836.976-2.552a6.4 6.4 0 0 0-.904-8.96v.016ZM14.4 19.201a.8.8 0 0 1-.8.8h-3.2a.8.8 0 0 1-.8-.8v-.8h4.8v.8Z",
                fill: "url(#paint0_linear_1175_2653)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M16.072 5.457a6.4 6.4 0 0 0-5.344-1.328 6.4 6.4 0 0 0-5.016 5.056 6.456 6.456 0 0 0 1.376 5.32c.563.635.886 1.448.912 2.296v2.4a2.4 2.4 0 0 0 2.4 2.4h3.2a2.4 2.4 0 0 0 2.4-2.4v-2.248a4.137 4.137 0 0 1 .976-2.552 6.4 6.4 0 0 0-.904-8.96v.016ZM14.4 19.201a.8.8 0 0 1-.8.8h-3.2a.8.8 0 0 1-.8-.8v-.8h4.8v.8Zm1.336-5.792a5.704 5.704 0 0 0-1.336 3.392h-1.6v-2.4a.8.8 0 0 0-1.6 0v2.4H9.6a5.2 5.2 0 0 0-1.28-3.328 4.8 4.8 0 0 1 4.823-7.736A4.8 4.8 0 0 1 16.8 10.4a4.711 4.711 0 0 1-1.064 3.008Z",
                fill: "#191C1D"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("defs", {
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                    id: "paint0_linear_1175_2653",
                    x1: 5.6,
                    y1: 12.8,
                    x2: 18.399,
                    y2: 12.8,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            stopColor: "#FF930F"
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            offset: 1,
                            stopColor: "#FFF95B"
                        })
                    ]
                })
            })
        ]
    });
var $4ab96380b630a7ab$export$2e2bcd8739ae039 = $4ab96380b630a7ab$var$SvgBulb;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $1ffe829310381ee9$var$SvgLightBulb = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M16.072 5.457a6.4 6.4 0 0 0-5.344-1.328 6.4 6.4 0 0 0-5.016 5.056 6.456 6.456 0 0 0 1.376 5.32c.563.635.886 1.448.912 2.296v2.4a2.4 2.4 0 0 0 2.4 2.4h3.2a2.4 2.4 0 0 0 2.4-2.4v-2.248a4.136 4.136 0 0 1 .976-2.552 6.4 6.4 0 0 0-.904-8.96v.016ZM14.4 19.201a.8.8 0 0 1-.8.8h-3.2a.8.8 0 0 1-.8-.8v-.8h4.8v.8Z",
                fill: "url(#paint0_linear_691_82122)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M16.072 5.457a6.4 6.4 0 0 0-5.344-1.328 6.4 6.4 0 0 0-5.016 5.056 6.456 6.456 0 0 0 1.376 5.32c.563.635.886 1.448.912 2.296v2.4a2.4 2.4 0 0 0 2.4 2.4h3.2a2.4 2.4 0 0 0 2.4-2.4v-2.248c.027-.937.371-1.836.976-2.552a6.4 6.4 0 0 0-.904-8.96v.016ZM14.4 19.201a.8.8 0 0 1-.8.8h-3.2a.8.8 0 0 1-.8-.8v-.8h4.8v.8Zm1.336-5.792a5.704 5.704 0 0 0-1.336 3.392h-1.6v-2.4a.8.8 0 0 0-1.6 0v2.4H9.6a5.2 5.2 0 0 0-1.28-3.328 4.8 4.8 0 0 1 4.823-7.736A4.8 4.8 0 0 1 16.8 10.4a4.712 4.712 0 0 1-1.064 3.008Z",
                fill: "#191C1D"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 4.616,
                y: 2.202,
                width: 3,
                height: 1.5,
                rx: 0.75,
                transform: "rotate(45 4.616 2.202)",
                fill: "#191C1D"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 1.3,
                y: 8.202,
                width: 3,
                height: 1.5,
                rx: 0.75,
                fill: "#191C1D"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 19.429,
                y: 8.202,
                width: 3,
                height: 1.5,
                rx: 0.75,
                fill: "#191C1D"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 11.429,
                y: 3,
                width: 3,
                height: 1.5,
                rx: 0.75,
                transform: "rotate(-90 11.429 3)",
                fill: "#191C1D"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 3,
                height: 1.5,
                rx: 0.75,
                transform: "scale(1 -1) rotate(45 15.636 19.987)",
                fill: "#191C1D"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("defs", {
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                    id: "paint0_linear_691_82122",
                    x1: 5.6,
                    y1: 12.8,
                    x2: 18.399,
                    y2: 12.8,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            stopColor: "#FF930F"
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            offset: 1,
                            stopColor: "#FFF95B"
                        })
                    ]
                })
            })
        ]
    });
var $1ffe829310381ee9$export$2e2bcd8739ae039 = $1ffe829310381ee9$var$SvgLightBulb;



var $jGWQ4 = parcelRequire("jGWQ4");

var $jC8Vy = parcelRequire("jC8Vy");

var $voszV = parcelRequire("voszV");
parcelRequire("8Mb3E");
var $lmQmj = parcelRequire("lmQmj");
parcelRequire("cuPVN");
var $kowfT = parcelRequire("kowfT");
const $be65b460d85f5eb9$export$48daf4eb8bb4366e = (connectors)=>{
    return connectors.reduce((previous, item)=>{
        const groupIndex = previous.findIndex(// Only group social connectors
        ({ target: target })=>target === item.target && item.type === (0, $kowfT.ConnectorType).Social);
        if (groupIndex === -1) return [
            ...previous,
            {
                id: item.id,
                isDemo: item.isDemo,
                name: item.name,
                logo: item.logo,
                logoDark: item.logoDark,
                description: item.description,
                target: item.target,
                type: item.type,
                isStandard: item.isStandard,
                connectors: [
                    item
                ]
            }
        ];
        return previous.map((group, index)=>{
            if (index !== groupIndex) return group;
            return {
                ...group,
                connectors: [
                    ...group.connectors,
                    item
                ]
            };
        });
    }, []);
};
const $be65b460d85f5eb9$export$3e690d7c9decfaaa = (markdown)=>{
    const match = /# (.*)/.exec(markdown);
    const title = (match ? match[1] : "") ?? "";
    return {
        title: title,
        content: markdown.replace(title, "")
    };
};


// Group connectors by target
const $9d72639ba10eaeeb$var$useConnectorGroups = ()=>{
    const { data: data, ...rest } = (0, $voszV.default)("api/connectors");
    const groups = (0, $jC8Vy.useMemo)(()=>{
        if (!data) return;
        return (0, $be65b460d85f5eb9$export$48daf4eb8bb4366e)(data);
    }, [
        data
    ]);
    const hasSupportNativePlatformTarget = (0, $jC8Vy.useMemo)(()=>groups?.some(({ target: target })=>(0, $lmQmj.supportNativePlatformTargets).includes(target)) ?? false, [
        groups
    ]);
    return {
        ...rest,
        data: groups,
        connectors: data,
        hasSupportNativePlatformTarget: hasSupportNativePlatformTarget
    };
};
var $9d72639ba10eaeeb$export$2e2bcd8739ae039 = $9d72639ba10eaeeb$var$useConnectorGroups;


parcelRequire("cuPVN");
var $8lyC3 = parcelRequire("8lyC3");
var $bae4bf33bd28496f$export$d9e3c9dc7eaad0c3;
(function(Authentication) {
    Authentication["Password"] = "password";
    Authentication["VerificationCode"] = "verificationCode";
})($bae4bf33bd28496f$export$d9e3c9dc7eaad0c3 || ($bae4bf33bd28496f$export$d9e3c9dc7eaad0c3 = {}));


const $85819ac33b2e3a2e$var$assetsUrl = "https://logtodev.blob.core.windows.net/public-blobs/admin/BY4BCq8GvfBF/2023/03/10";
const $85819ac33b2e3a2e$export$c382f0fc4604f07b = {
    color: "#5D34F2",
    identifier: (0, $8lyC3.SignInIdentifier).Email,
    authentications: [
        (0, $bae4bf33bd28496f$export$d9e3c9dc7eaad0c3).Password
    ]
};
// Email + password sign-up; password sign-in
const $85819ac33b2e3a2e$var$formDataTemplate1 = {
    logo: `${$85819ac33b2e3a2e$var$assetsUrl}/tVCAHjAB/logo1.png`,
    color: "#19BEFD",
    identifier: (0, $8lyC3.SignInIdentifier).Email,
    authentications: [
        (0, $bae4bf33bd28496f$export$d9e3c9dc7eaad0c3).Password
    ]
};
// Email + password sign-up; password + code sign-in
const $85819ac33b2e3a2e$var$formDataTemplate2 = {
    logo: `${$85819ac33b2e3a2e$var$assetsUrl}/IcI0snBP/logo3.png`,
    color: "#FF5449",
    identifier: (0, $8lyC3.SignInIdentifier).Email,
    authentications: [
        (0, $bae4bf33bd28496f$export$d9e3c9dc7eaad0c3).Password,
        (0, $bae4bf33bd28496f$export$d9e3c9dc7eaad0c3).VerificationCode
    ]
};
// Email + code sign-up; code sign-in
const $85819ac33b2e3a2e$var$formDataTemplate3 = {
    logo: `${$85819ac33b2e3a2e$var$assetsUrl}/7UQyvuFc/logo4.png`,
    color: "#CA4E96",
    identifier: (0, $8lyC3.SignInIdentifier).Email,
    authentications: [
        (0, $bae4bf33bd28496f$export$d9e3c9dc7eaad0c3).VerificationCode
    ]
};
// Username sign-up; password sign-in
const $85819ac33b2e3a2e$var$formDataTemplate4 = {
    logo: `${$85819ac33b2e3a2e$var$assetsUrl}/uLoMzrlz/logo7.png`,
    color: "#FF5449",
    identifier: (0, $8lyC3.SignInIdentifier).Username,
    authentications: [
        (0, $bae4bf33bd28496f$export$d9e3c9dc7eaad0c3).Password
    ]
};
const $85819ac33b2e3a2e$var$formDataTemplates = [
    $85819ac33b2e3a2e$var$formDataTemplate1,
    $85819ac33b2e3a2e$var$formDataTemplate2,
    $85819ac33b2e3a2e$var$formDataTemplate3,
    $85819ac33b2e3a2e$var$formDataTemplate4
];
const $85819ac33b2e3a2e$export$4a6b8e314fa90f7e = (lastTemplateIndex, availableSocialTargets)=>{
    // Get random template
    const randomIndex = Math.floor(Math.random() * $85819ac33b2e3a2e$var$formDataTemplates.length);
    const index = randomIndex === lastTemplateIndex ? (randomIndex + 1) % $85819ac33b2e3a2e$var$formDataTemplates.length : randomIndex;
    const template = $85819ac33b2e3a2e$var$formDataTemplates[index] ?? $85819ac33b2e3a2e$var$formDataTemplate1;
    // Get 2 or 3 random social targets
    const randomCount = Math.floor(Math.random() * 2) + 2;
    // Take the first randomCount after shuffling.
    const socialTargets = availableSocialTargets.slice().sort(()=>0.5 - Math.random()).slice(0, randomCount);
    return {
        template: {
            ...template,
            socialTargets: socialTargets
        },
        templateIndex: index
    };
};


var $911eccbebb4dea71$export$2ba01fb71ed41cb6;
var $911eccbebb4dea71$export$3186f5fc4c1ebb22;
var $911eccbebb4dea71$export$f373648514ea4dec;
var $911eccbebb4dea71$export$19721b61a25b4f6d;
var $911eccbebb4dea71$export$2c9f719e4a309fb5;
var $911eccbebb4dea71$export$bfd64c937657f93a;
var $911eccbebb4dea71$export$4a6dd88bada4e7d2;
$911eccbebb4dea71$export$2ba01fb71ed41cb6 = `jPstRq_button`;
$911eccbebb4dea71$export$3186f5fc4c1ebb22 = `jPstRq_inspire`;
$911eccbebb4dea71$export$f373648514ea4dec = `jPstRq_inspireContent`;
$911eccbebb4dea71$export$19721b61a25b4f6d = `jPstRq_inspireDescription`;
$911eccbebb4dea71$export$2c9f719e4a309fb5 = `jPstRq_inspireTitle`;
$911eccbebb4dea71$export$bfd64c937657f93a = `jPstRq_rotating`;
$911eccbebb4dea71$export$4a6dd88bada4e7d2 = `jPstRq_shimmer`;


function $1c7123eb3990bc17$var$InspireMe({ onInspired: onInspired }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [isButtonHover, setIsButtonHover] = (0, $jC8Vy.useState)(false);
    const BulbIcon = isButtonHover ? (0, $1ffe829310381ee9$export$2e2bcd8739ae039) : (0, $4ab96380b630a7ab$export$2e2bcd8739ae039);
    const [lastTemplateIndex, setLastTemplateIndex] = (0, $jC8Vy.useState)();
    const { data: connectorData, error: error } = (0, $9d72639ba10eaeeb$export$2e2bcd8739ae039)();
    const availableSocialTargets = error ? [] : connectorData?.filter(({ type: type })=>type === (0, $kowfT.ConnectorType).Social).map(({ target: target })=>target) ?? [];
    const handleInspire = ()=>{
        const { template: template, templateIndex: templateIndex } = (0, $85819ac33b2e3a2e$export$4a6b8e314fa90f7e)(lastTemplateIndex, availableSocialTargets);
        setLastTemplateIndex(templateIndex);
        onInspired(template);
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $911eccbebb4dea71$export$3186f5fc4c1ebb22,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $911eccbebb4dea71$export$f373648514ea4dec,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $911eccbebb4dea71$export$2c9f719e4a309fb5,
                        children: t("cloud.sie.inspire.title")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $911eccbebb4dea71$export$19721b61a25b4f6d,
                        children: t("cloud.sie.inspire.description")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                icon: /*#__PURE__*/ (0, $C7mD2.jsx)(BulbIcon, {}),
                size: "large",
                className: $911eccbebb4dea71$export$2ba01fb71ed41cb6,
                title: "cloud.sie.inspire.inspire_me",
                onMouseEnter: ()=>{
                    setIsButtonHover(true);
                },
                onMouseLeave: ()=>{
                    setIsButtonHover(false);
                },
                onClick: handleInspire
            })
        ]
    });
}
var $1c7123eb3990bc17$export$2e2bcd8739ae039 = $1c7123eb3990bc17$var$InspireMe;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $kowfT = parcelRequire("kowfT");
var $5HVJe = parcelRequire("5HVJe");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $5UrGx = parcelRequire("5UrGx");
function $fdee7867c390df1d$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}


function $6a9e2f9eec726308$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6a9e2f9eec726308$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6a9e2f9eec726308$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6a9e2f9eec726308$var$_typeof(obj);
}
function $6a9e2f9eec726308$export$2e2bcd8739ae039(value) {
    (0, $fdee7867c390df1d$export$2e2bcd8739ae039)(1, arguments);
    return value instanceof Date || $6a9e2f9eec726308$var$_typeof(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}



function $454e9ddbf20cd33b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $454e9ddbf20cd33b$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $454e9ddbf20cd33b$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $454e9ddbf20cd33b$var$_typeof(obj);
}
function $454e9ddbf20cd33b$export$2e2bcd8739ae039(argument) {
    (0, $fdee7867c390df1d$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date
    if (argument instanceof Date || $454e9ddbf20cd33b$var$_typeof(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"); // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $60c6adb4b27d9137$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fdee7867c390df1d$export$2e2bcd8739ae039)(1, arguments);
    if (!(0, $6a9e2f9eec726308$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, $454e9ddbf20cd33b$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(Number(date));
}


function $ff8252852ed6c1cc$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}




function $d39062a55e716cbc$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $fdee7867c390df1d$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $454e9ddbf20cd33b$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $ff8252852ed6c1cc$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}




function $f369781a96a0445b$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $fdee7867c390df1d$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $ff8252852ed6c1cc$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $d39062a55e716cbc$export$2e2bcd8739ae039)(dirtyDate, -amount);
}





var $a26e7420ca978f6b$var$MILLISECONDS_IN_DAY = 86400000;
function $a26e7420ca978f6b$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fdee7867c390df1d$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $454e9ddbf20cd33b$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $a26e7420ca978f6b$var$MILLISECONDS_IN_DAY) + 1;
}





function $45db8e365d65a299$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fdee7867c390df1d$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $454e9ddbf20cd33b$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}





function $53a76064ec655563$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fdee7867c390df1d$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $454e9ddbf20cd33b$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $45db8e365d65a299$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $45db8e365d65a299$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $c98f1a1c1a59098c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fdee7867c390df1d$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $53a76064ec655563$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $45db8e365d65a299$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $b8733fdc72cd4b2f$var$MILLISECONDS_IN_WEEK = 604800000;
function $b8733fdc72cd4b2f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $fdee7867c390df1d$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $454e9ddbf20cd33b$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $45db8e365d65a299$export$2e2bcd8739ae039)(date).getTime() - (0, $c98f1a1c1a59098c$export$2e2bcd8739ae039)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $b8733fdc72cd4b2f$var$MILLISECONDS_IN_WEEK) + 1;
}







var $a61d6811766fedbe$var$defaultOptions = {};
function $a61d6811766fedbe$export$430a3269e24b912e() {
    return $a61d6811766fedbe$var$defaultOptions;
}
function $a61d6811766fedbe$export$95365be1b0704abc(newOptions) {
    $a61d6811766fedbe$var$defaultOptions = newOptions;
}


function $92a35f1f9da17854$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $fdee7867c390df1d$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $a61d6811766fedbe$export$430a3269e24b912e)();
    var weekStartsOn = (0, $ff8252852ed6c1cc$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $454e9ddbf20cd33b$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}







function $05616308620d87d1$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $fdee7867c390df1d$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $454e9ddbf20cd33b$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $a61d6811766fedbe$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $ff8252852ed6c1cc$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $92a35f1f9da17854$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $92a35f1f9da17854$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $628c6b33b6ae95e7$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $fdee7867c390df1d$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $a61d6811766fedbe$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $ff8252852ed6c1cc$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $05616308620d87d1$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $92a35f1f9da17854$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $53dfe721b3f1050c$var$MILLISECONDS_IN_WEEK = 604800000;
function $53dfe721b3f1050c$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $fdee7867c390df1d$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $454e9ddbf20cd33b$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $92a35f1f9da17854$export$2e2bcd8739ae039)(date, options).getTime() - (0, $628c6b33b6ae95e7$export$2e2bcd8739ae039)(date, options).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $53dfe721b3f1050c$var$MILLISECONDS_IN_WEEK) + 1;
}



function $e10141b67cfba8ae$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}



/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $b174d2e3e6cd734b$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $e10141b67cfba8ae$export$2e2bcd8739ae039)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, $e10141b67cfba8ae$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $e10141b67cfba8ae$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $e10141b67cfba8ae$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $e10141b67cfba8ae$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $e10141b67cfba8ae$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $e10141b67cfba8ae$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $e10141b67cfba8ae$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $b174d2e3e6cd734b$export$2e2bcd8739ae039 = $b174d2e3e6cd734b$var$formatters;


var $f1ff660910886881$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $f1ff660910886881$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $b174d2e3e6cd734b$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $05616308620d87d1$export$2e2bcd8739ae039)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $e10141b67cfba8ae$export$2e2bcd8739ae039)(twoDigitYear, 2);
        } // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
         // Padding
        return (0, $e10141b67cfba8ae$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $53a76064ec655563$export$2e2bcd8739ae039)(date); // Padding
        return (0, $e10141b67cfba8ae$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $e10141b67cfba8ae$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $e10141b67cfba8ae$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $e10141b67cfba8ae$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $b174d2e3e6cd734b$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $e10141b67cfba8ae$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $53dfe721b3f1050c$export$2e2bcd8739ae039)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $e10141b67cfba8ae$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $b8733fdc72cd4b2f$export$2e2bcd8739ae039)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $e10141b67cfba8ae$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, $b174d2e3e6cd734b$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $a26e7420ca978f6b$export$2e2bcd8739ae039)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $e10141b67cfba8ae$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $e10141b67cfba8ae$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $e10141b67cfba8ae$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $e10141b67cfba8ae$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $f1ff660910886881$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $f1ff660910886881$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $f1ff660910886881$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $f1ff660910886881$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $f1ff660910886881$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $f1ff660910886881$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $b174d2e3e6cd734b$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, $b174d2e3e6cd734b$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $e10141b67cfba8ae$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $e10141b67cfba8ae$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, $b174d2e3e6cd734b$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, $b174d2e3e6cd734b$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $b174d2e3e6cd734b$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $f1ff660910886881$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return $f1ff660910886881$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $f1ff660910886881$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $f1ff660910886881$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return $f1ff660910886881$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $f1ff660910886881$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $f1ff660910886881$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $f1ff660910886881$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $f1ff660910886881$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $f1ff660910886881$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $e10141b67cfba8ae$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $e10141b67cfba8ae$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $f1ff660910886881$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, $e10141b67cfba8ae$export$2e2bcd8739ae039)(minutes, 2);
}
function $f1ff660910886881$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $e10141b67cfba8ae$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $f1ff660910886881$var$formatTimezone(offset, dirtyDelimiter);
}
function $f1ff660910886881$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $e10141b67cfba8ae$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $e10141b67cfba8ae$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $f1ff660910886881$export$2e2bcd8739ae039 = $f1ff660910886881$var$formatters;


var $067c65a199fb548b$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $067c65a199fb548b$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $067c65a199fb548b$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $067c65a199fb548b$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $067c65a199fb548b$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $067c65a199fb548b$var$timeLongFormatter(timePattern, formatLong));
};
var $067c65a199fb548b$var$longFormatters = {
    p: $067c65a199fb548b$var$timeLongFormatter,
    P: $067c65a199fb548b$var$dateTimeLongFormatter
};
var $067c65a199fb548b$export$2e2bcd8739ae039 = $067c65a199fb548b$var$longFormatters;


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $3d1149e213825e1d$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}


var $9a6ff6630220d1ca$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $9a6ff6630220d1ca$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $9a6ff6630220d1ca$export$c6cc36aa33304772(token) {
    return $9a6ff6630220d1ca$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $9a6ff6630220d1ca$export$c6b49d6dceb604a1(token) {
    return $9a6ff6630220d1ca$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $9a6ff6630220d1ca$export$8073c1ae88f0e727(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}





var $5360151e3014f354$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $5360151e3014f354$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $5360151e3014f354$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $5360151e3014f354$export$2e2bcd8739ae039 = $5360151e3014f354$var$formatDistance;


function $9d0c470ee3dadb7d$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $b8a564f13eedbc5f$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $b8a564f13eedbc5f$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $b8a564f13eedbc5f$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $b8a564f13eedbc5f$var$formatLong = {
    date: (0, $9d0c470ee3dadb7d$export$2e2bcd8739ae039)({
        formats: $b8a564f13eedbc5f$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $9d0c470ee3dadb7d$export$2e2bcd8739ae039)({
        formats: $b8a564f13eedbc5f$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $9d0c470ee3dadb7d$export$2e2bcd8739ae039)({
        formats: $b8a564f13eedbc5f$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $b8a564f13eedbc5f$export$2e2bcd8739ae039 = $b8a564f13eedbc5f$var$formatLong;


var $f7455fbabd93c579$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $f7455fbabd93c579$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $f7455fbabd93c579$var$formatRelativeLocale[token];
};
var $f7455fbabd93c579$export$2e2bcd8739ae039 = $f7455fbabd93c579$var$formatRelative;


function $adf0fe5ce57f61b4$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $22fb07d1a6e162a3$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $22fb07d1a6e162a3$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $22fb07d1a6e162a3$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $22fb07d1a6e162a3$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $22fb07d1a6e162a3$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $22fb07d1a6e162a3$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $22fb07d1a6e162a3$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $22fb07d1a6e162a3$var$localize = {
    ordinalNumber: $22fb07d1a6e162a3$var$ordinalNumber,
    era: (0, $adf0fe5ce57f61b4$export$2e2bcd8739ae039)({
        values: $22fb07d1a6e162a3$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $adf0fe5ce57f61b4$export$2e2bcd8739ae039)({
        values: $22fb07d1a6e162a3$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $adf0fe5ce57f61b4$export$2e2bcd8739ae039)({
        values: $22fb07d1a6e162a3$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $adf0fe5ce57f61b4$export$2e2bcd8739ae039)({
        values: $22fb07d1a6e162a3$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $adf0fe5ce57f61b4$export$2e2bcd8739ae039)({
        values: $22fb07d1a6e162a3$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $22fb07d1a6e162a3$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $22fb07d1a6e162a3$export$2e2bcd8739ae039 = $22fb07d1a6e162a3$var$localize;


function $d7071e83e37a420f$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $d7071e83e37a420f$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $d7071e83e37a420f$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $d7071e83e37a420f$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $d7071e83e37a420f$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $f5e0b06004c2b232$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $3043cb1271b7bffc$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $3043cb1271b7bffc$var$parseOrdinalNumberPattern = /\d+/i;
var $3043cb1271b7bffc$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $3043cb1271b7bffc$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $3043cb1271b7bffc$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $3043cb1271b7bffc$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $3043cb1271b7bffc$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $3043cb1271b7bffc$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $3043cb1271b7bffc$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $3043cb1271b7bffc$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $3043cb1271b7bffc$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $3043cb1271b7bffc$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $3043cb1271b7bffc$var$match = {
    ordinalNumber: (0, $f5e0b06004c2b232$export$2e2bcd8739ae039)({
        matchPattern: $3043cb1271b7bffc$var$matchOrdinalNumberPattern,
        parsePattern: $3043cb1271b7bffc$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d7071e83e37a420f$export$2e2bcd8739ae039)({
        matchPatterns: $3043cb1271b7bffc$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3043cb1271b7bffc$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d7071e83e37a420f$export$2e2bcd8739ae039)({
        matchPatterns: $3043cb1271b7bffc$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3043cb1271b7bffc$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d7071e83e37a420f$export$2e2bcd8739ae039)({
        matchPatterns: $3043cb1271b7bffc$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3043cb1271b7bffc$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d7071e83e37a420f$export$2e2bcd8739ae039)({
        matchPatterns: $3043cb1271b7bffc$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3043cb1271b7bffc$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d7071e83e37a420f$export$2e2bcd8739ae039)({
        matchPatterns: $3043cb1271b7bffc$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $3043cb1271b7bffc$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $3043cb1271b7bffc$export$2e2bcd8739ae039 = $3043cb1271b7bffc$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $a4ad8a55c9da4196$var$locale = {
    code: "en-US",
    formatDistance: (0, $5360151e3014f354$export$2e2bcd8739ae039),
    formatLong: (0, $b8a564f13eedbc5f$export$2e2bcd8739ae039),
    formatRelative: (0, $f7455fbabd93c579$export$2e2bcd8739ae039),
    localize: (0, $22fb07d1a6e162a3$export$2e2bcd8739ae039),
    match: (0, $3043cb1271b7bffc$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
var $a4ad8a55c9da4196$export$2e2bcd8739ae039 = $a4ad8a55c9da4196$var$locale;


var $58928befce1e9884$export$2e2bcd8739ae039 = (0, $a4ad8a55c9da4196$export$2e2bcd8739ae039);


// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $9aa0641d843cb9a1$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $9aa0641d843cb9a1$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $9aa0641d843cb9a1$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $9aa0641d843cb9a1$var$doubleQuoteRegExp = /''/g;
var $9aa0641d843cb9a1$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $9aa0641d843cb9a1$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $fdee7867c390df1d$export$2e2bcd8739ae039)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $a61d6811766fedbe$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $58928befce1e9884$export$2e2bcd8739ae039);
    var firstWeekContainsDate = (0, $ff8252852ed6c1cc$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $ff8252852ed6c1cc$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, $454e9ddbf20cd33b$export$2e2bcd8739ae039)(dirtyDate);
    if (!(0, $60c6adb4b27d9137$export$2e2bcd8739ae039)(originalDate)) throw new RangeError("Invalid time value");
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $3d1149e213825e1d$export$2e2bcd8739ae039)(originalDate);
    var utcDate = (0, $f369781a96a0445b$export$2e2bcd8739ae039)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($9aa0641d843cb9a1$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, $067c65a199fb548b$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($9aa0641d843cb9a1$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $9aa0641d843cb9a1$var$cleanEscapedString(substring);
        var formatter = (0, $f1ff660910886881$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $9a6ff6630220d1ca$export$c6b49d6dceb604a1)(substring)) (0, $9a6ff6630220d1ca$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $9a6ff6630220d1ca$export$c6cc36aa33304772)(substring)) (0, $9a6ff6630220d1ca$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($9aa0641d843cb9a1$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $9aa0641d843cb9a1$var$cleanEscapedString(input) {
    var matched = input.match($9aa0641d843cb9a1$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($9aa0641d843cb9a1$var$doubleQuoteRegExp, "'");
}



var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $voszV = parcelRequire("voszV");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $103ec52349a309e9$var$SvgPhoneInfo = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 55,
        height: 10,
        viewBox: "0 0 55 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                opacity: 0.35,
                d: "M35.2 3c0-.957.776-1.733 1.734-1.733h13.333C51.224 1.267 52 2.043 52 3v4.8c0 .957-.776 1.733-1.733 1.733H36.934A1.733 1.733 0 0 1 35.2 7.8V3Z",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                opacity: 0.4,
                d: "M53.2 3.8V7a1.736 1.736 0 0 0 0-3.2Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M36.4 3.533c0-.589.478-1.066 1.067-1.066h12.267c.589 0 1.066.477 1.066 1.066v3.734c0 .589-.477 1.066-1.066 1.066H37.467c-.589 0-1.067-.477-1.067-1.066V3.533ZM24.665 2.686c1.772 0 3.477.682 4.762 1.903a.246.246 0 0 0 .346-.003l.925-.933a.257.257 0 0 0-.002-.365 8.718 8.718 0 0 0-12.064 0 .257.257 0 0 0-.002.365l.925.933c.095.096.25.098.346.003a6.913 6.913 0 0 1 4.764-1.903Zm0 3.037c.973 0 1.913.362 2.634 1.016.098.093.252.09.347-.005l.924-.933a.258.258 0 0 0-.004-.367 5.728 5.728 0 0 0-7.802 0 .257.257 0 0 0-.003.367l.923.933a.248.248 0 0 0 .347.005 3.926 3.926 0 0 1 2.633-1.016Zm1.85 2.043a.251.251 0 0 1-.075.185l-1.598 1.612a.25.25 0 0 1-.355 0l-1.598-1.612a.251.251 0 0 1 .008-.366 2.737 2.737 0 0 1 3.535 0 .252.252 0 0 1 .083.181ZM13.734 1.133h-.8a.8.8 0 0 0-.8.8v6.934a.8.8 0 0 0 .8.8h.8a.8.8 0 0 0 .8-.8V1.933a.8.8 0 0 0-.8-.8ZM9.2 3h.8a.8.8 0 0 1 .8.8v5.067a.8.8 0 0 1-.8.8h-.8a.8.8 0 0 1-.8-.8V3.8a.8.8 0 0 1 .8-.8ZM6.267 4.867h-.8a.8.8 0 0 0-.8.8v3.2a.8.8 0 0 0 .8.8h.8a.8.8 0 0 0 .8-.8v-3.2a.8.8 0 0 0-.8-.8Zm-3.733 1.6h-.8a.8.8 0 0 0-.8.8v1.6a.8.8 0 0 0 .8.8h.8a.8.8 0 0 0 .8-.8v-1.6a.8.8 0 0 0-.8-.8Z",
                fill: "currentColor"
            })
        ]
    });
var $103ec52349a309e9$export$2e2bcd8739ae039 = $103ec52349a309e9$var$SvgPhoneInfo;



var $fG7L1 = parcelRequire("fG7L1");
parcelRequire("hNGhh");
var $cOUYQ = parcelRequire("cOUYQ");
var $eRB1v = parcelRequire("eRB1v");

var $c3dK3 = parcelRequire("c3dK3");
const $da4738e86067beec$var$action = {
    sign_in: "Anmelden",
    continue: "Weiter",
    create_account: "Konto erstellen",
    create_account_without_linking: "Erstelle ein Konto ohne Verkn\xfcpfung",
    create: "Erstellen",
    enter_passcode: "Best\xe4tigungscode eingeben",
    confirm: "Best\xe4tigen",
    cancel: "Abbrechen",
    save_password: "Passwort speichern",
    bind: "Mit {{address}} verkn\xfcpfen",
    bind_and_continue: "Verkn\xfcpfen und weiter",
    back: "Gehe zur\xfcck",
    nav_back: "Zur\xfcck",
    nav_skip: "\xdcberspringen",
    agree: "Zustimmen",
    got_it: "Alles klar",
    sign_in_with: "Mit {{name}} anmelden",
    forgot_password: "Passwort vergessen?",
    switch_to: "Zu {{method}} wechseln",
    sign_in_via_passcode: "Mit Best\xe4tigungscode anmelden",
    sign_in_via_password: "Mit Passwort anmelden",
    change: "{{method}} \xe4ndern",
    link_another_email: "Andere Email verkn\xfcpfen",
    link_another_phone: "Andere Telefonnummer verkn\xfcpfen",
    link_another_email_or_phone: "Andere Email oder Telefonnummer verkn\xfcpfen",
    show_password: "Passwort anzeigen",
    copy: "Kopieren",
    verify_via_passkey: "\xdcberpr\xfcfen \xfcber Passkey",
    download: "Herunterladen",
    single_sign_on: "Single Sign-On",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $da4738e86067beec$export$2e2bcd8739ae039 = Object.freeze($da4738e86067beec$var$action);


const $ed1f50f6589010b9$var$description = {
    email: "Email",
    phone_number: "Telefonnummer",
    username: "Benutzername",
    reminder: "Erinnerung",
    not_found: "404 Nicht gefunden",
    agree_with_terms: "Ich akzeptiere die ",
    agree_with_terms_modal: "Bitte akzeptiere die <link></link>.",
    terms_of_use: "Nutzungsbedingungen",
    sign_in: "Anmelden",
    privacy_policy: "Datenschutzrichtlinien",
    create_account: "Konto erstellen",
    or: "oder",
    and: "und",
    enter_passcode: "Der Best\xe4tigungscode wurde an deine {{address}} gesendet",
    passcode_sent: "Der Best\xe4tigungscode wurde erneut gesendet",
    resend_after_seconds: "Nach <span>{{seconds}}</span> Sekunden erneut senden",
    resend_passcode: "Best\xe4tigungscode erneut senden",
    create_account_id_exists: "Das Konto mit {{type}} {{value}} existiert bereits, m\xf6chtest du dich anmelden?",
    link_account_id_exists: "Das Konto mit {{type}} {{value}} existiert bereits, m\xf6chtest du es mit deinem Konto verkn\xfcpfen?",
    sign_in_id_does_not_exist: "Das Konto mit {{type}} {{value}} existiert nicht, m\xf6chtest du ein neues Konto erstellen?",
    sign_in_id_does_not_exist_alert: "Das Konto mit {{type}} {{value}} existiert nicht",
    create_account_id_exists_alert: "Das Konto mit {{type}} {{value}} ist mit einem anderen Konto verkn\xfcpft. Bitte versuche es mit einem anderen {{type}} erneut",
    social_identity_exist: "{{type}} {{value}} ist mit einem anderen Konto verkn\xfcpft. Bitte versuche ein(e(n)) andere(n/s) {{type}}",
    bind_account_title: "Verlinke oder erstelle ein Konto",
    social_create_account: "Sie k\xf6nnen ein neues Konto erstellen.",
    social_link_email: "Du kannst eine weitere Email verkn\xfcpfen",
    social_link_phone: "Du kannst eine weitere Telefonnummer verkn\xfcpfen",
    social_link_email_or_phone: "Du kannst eine weitere Email oder Telefonnummer verkn\xfcpfen",
    social_bind_with_existing: "Wir haben ein verwandtes Konto gefunden, du kannst es direkt verkn\xfcpfen.",
    reset_password: "Passwort vergessen",
    reset_password_description: "Gib die {{types, list(type: disjunction;)}} deines Kontos ein und wir senden dir einen Best\xe4tigungscode um dein Passwort zur\xfcckzusetzen.",
    new_password: "Neues Passwort",
    set_password: "Passwort setzen",
    password_changed: "Passwort ge\xe4ndert",
    no_account: "Noch kein Konto? ",
    have_account: "Hast du schon ein Konto?",
    enter_password: "Passwort eingeben",
    enter_password_for: "Passwort f\xfcr {{method}} {{value}} eingeben",
    enter_username: "Benutzernamen festlegen",
    enter_username_description: "Der Benutzername kann f\xfcr die Anmeldung verwendet werden. Der Benutzername darf nur Buchstaben, Zahlen und Unterstriche enthalten.",
    link_email: "Email verkn\xfcpfen",
    link_phone: "Telefonnummer verkn\xfcpfen",
    link_email_or_phone: "Email oder Telefonnummer verkn\xfcpfen",
    link_email_description: "F\xfcr zus\xe4tzliche Sicherheit, verkn\xfcpfe bitte deine Email mit dem Konto.",
    link_phone_description: "F\xfcr zus\xe4tzliche Sicherheit, verkn\xfcpfe bitte deine Telefonnummer mit dem Konto.",
    link_email_or_phone_description: "F\xfcr zus\xe4tzliche Sicherheit, verkn\xfcpfe bitte deine Email oder Telefonnummer mit dem Konto.",
    continue_with_more_information: "F\xfcr zus\xe4tzliche Sicherheit, vervollst\xe4ndige bitte deine Informationen.",
    create_your_account: "Erstelle dein Konto",
    sign_in_to_your_account: "Melde dich in deinem Konto an",
    no_region_code_found: "Kein Regionencode gefunden",
    verify_email: "Best\xe4tige deine E-Mail-Adresse",
    verify_phone: "Best\xe4tige deine Telefonnummer",
    password_requirements: "Passwort {{items, list}}.",
    password_requirement: {
        length_one: "erfordert mindestens {{count}} Zeichen",
        length_other: "erfordert mindestens {{count}} Zeichen",
        character_types_one: "sollte mindestens {{count}} Kategorie der folgenden Zeichenarten enthalten: Gro\xdfbuchstaben, Kleinbuchstaben, Zahlen und Symbole",
        character_types_other: "sollte mindestens {{count}} Kategorien der folgenden Zeichenarten enthalten: Gro\xdfbuchstaben, Kleinbuchstaben, Zahlen und Symbole"
    },
    use: "Verwenden",
    single_sign_on_email_form: "Gib deine Unternehmens-E-Mail-Adresse ein.",
    single_sign_on_connectors_list: "Ihr Unternehmen hat Single Sign-On f\xfcr das E-Mail-Konto {{email}} aktiviert. Sie k\xf6nnen sich weiterhin mit den folgenden SSO-Anbietern anmelden.",
    single_sign_on_enabled: "Single Sign-On ist f\xfcr dieses Konto aktiviert",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ authorize_personal_data_usage: "Authorize the use of your personal data:",
    /** UNTRANSLATED */ authorize_organization_access: "Authorize access to the specific organization:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: `By authorizing the access, you agree to the {{name}}'s <link></link>.`,
    /** UNTRANSLATED */ authorize_agreement_with_redirect: `By authorizing the access, you agree to the {{name}}'s <link></link>, and will be redirected to {{uri}}.`,
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $ed1f50f6589010b9$export$2e2bcd8739ae039 = Object.freeze($ed1f50f6589010b9$var$description);


const $ea163181e5d39425$var$development_tenant = {
    notification: "Du befindest dich im Entwicklungsmodus"
};
var $ea163181e5d39425$export$2e2bcd8739ae039 = Object.freeze($ea163181e5d39425$var$development_tenant);


const $2d479d93ee579adf$var$password_rejected = {
    too_short: "Die minimale L\xe4nge betr\xe4gt {{min}}.",
    too_long: "Die maximale L\xe4nge betr\xe4gt {{max}}.",
    character_types: "Mindestens {{min}} Arten von Zeichen sind erforderlich.",
    unsupported_characters: "Nicht unterst\xfctztes Zeichen gefunden.",
    pwned: "Verwenden Sie keine einfachen Passw\xf6rter, die leicht zu erraten sind.",
    restricted_found: "Vermeiden Sie \xfcberm\xe4\xdfigen Gebrauch von {{list, list}}.",
    restricted: {
        repetition: "wiederholte Zeichen",
        sequence: "sequenzielle Zeichen",
        user_info: "Ihre pers\xf6nlichen Informationen",
        words: "Produktkontext"
    }
};
var $2d479d93ee579adf$export$2e2bcd8739ae039 = Object.freeze($2d479d93ee579adf$var$password_rejected);


const $fb4445e63d175b11$var$error = {
    general_required: "{{types, list(type: disjunction;)}} ist erforderlich",
    general_invalid: "Die {{types, list(type: disjunction;)}} is ung\xfcltig",
    username_required: "Benutzername ist erforderlich",
    password_required: "Passwort ist erforderlich",
    username_exists: "Benutzername existiert bereits",
    username_should_not_start_with_number: "Benutzername darf nicht mit einer Zahl beginnen",
    username_invalid_charset: "Benutzername darf nur Buchstaben, Zahlen und Unterstriche enthalten",
    invalid_email: "Die Email ist ung\xfcltig",
    invalid_phone: "Die Telefonnummer ist ung\xfcltig",
    passwords_do_not_match: "Passw\xf6rter stimmen nicht \xfcberein",
    invalid_passcode: "Der Best\xe4tigungscode ist ung\xfcltig",
    invalid_connector_auth: "Die Autorisierung ist ung\xfcltig",
    invalid_connector_request: "Connector Daten sind ung\xfcltig",
    unknown: "Unbekannter Fehler. Versuche es sp\xe4ter noch einmal.",
    invalid_session: "Die Sitzung ist ung\xfcltig. Bitte melde dich erneut an.",
    timeout: "Zeit\xfcberschreitung. Bitte melde dich erneut an.",
    password_rejected: $2d479d93ee579adf$export$2e2bcd8739ae039,
    sso_not_enabled: "Single Sign-On ist f\xfcr dieses E-Mail-Konto nicht aktiviert."
};
var $fb4445e63d175b11$export$2e2bcd8739ae039 = Object.freeze($fb4445e63d175b11$var$error);


const $30785be03dd0139f$var$input = {
    username: "Benutzername",
    password: "Passwort",
    email: "Email",
    phone_number: "Telefonnummer",
    confirm_password: "Passwort best\xe4tigen",
    search_region_code: "Suche region code",
    backup_code: "Backup-Code"
};
var $30785be03dd0139f$export$2e2bcd8739ae039 = Object.freeze($30785be03dd0139f$var$input);


const $b70f1f10b435cd0f$var$list = {
    or: "oder",
    and: "und",
    separator: ","
};
var $b70f1f10b435cd0f$export$2e2bcd8739ae039 = Object.freeze($b70f1f10b435cd0f$var$list);


const $1db0b837a5ba1f0f$var$mfa = {
    totp: "Authenticator-App-OTP",
    webauthn: "Passkey",
    backup_code: "Backup-Code",
    link_totp_description: "z.B. Google Authenticator usw.",
    link_webauthn_description: "Verkn\xfcpfen Sie Ihr Ger\xe4t oder USB-Hardware",
    link_backup_code_description: "Backup-Code generieren",
    verify_totp_description: "Geben Sie den Einmalcode in der App ein",
    verify_webauthn_description: "Verifizieren Sie Ihr Ger\xe4t oder Ihre USB-Hardware",
    verify_backup_code_description: "F\xfcgen Sie den gespeicherten Backup-Code ein",
    add_mfa_factors: "2-Schritte-Verifizierung hinzuf\xfcgen",
    add_mfa_description: "Die Zwei-Faktor-Verifizierung ist aktiviert. W\xe4hlen Sie Ihre zweite Verifizierungsmethode f\xfcr sicheres Anmelden aus.",
    verify_mfa_factors: "2-Schritte-Verifizierung",
    verify_mfa_description: "Die 2-Schritte-Verifizierung ist f\xfcr dieses Konto aktiviert. Bitte w\xe4hlen Sie die zweite Methode zur Verifizierung Ihrer Identit\xe4t aus.",
    add_authenticator_app: "Authenticator-App hinzuf\xfcgen",
    step: "Schritt {{step, number}}: {{content}}",
    scan_qr_code: "Scannen Sie diesen QR-Code",
    scan_qr_code_description: "Scannen Sie den folgenden QR-Code mit Ihrer Authenticator-App, wie z.B. Google Authenticator, Duo Mobile, Authy usw.",
    qr_code_not_available: "Kann den QR-Code nicht scannen?",
    copy_and_paste_key: "Schl\xfcssel kopieren und einf\xfcgen",
    copy_and_paste_key_description: "Kopieren Sie den folgenden Schl\xfcssel und f\xfcgen Sie ihn in Ihre Authenticator-App ein, wie z.B. Google Authenticator, Duo Mobile, Authy usw.",
    want_to_scan_qr_code: "M\xf6chten Sie den QR-Code scannen?",
    enter_one_time_code: "Einmalcode eingeben",
    enter_one_time_code_link_description: "Geben Sie den 6-stelligen Verifizierungscode ein, der von der Authenticator-App generiert wurde.",
    enter_one_time_code_description: "F\xfcr dieses Konto wurde die Zwei-Faktor-Authentifizierung aktiviert. Bitte geben Sie den einmaligen Code ein, der in Ihrer verkn\xfcpften Authentifizierungs-App angezeigt wird.",
    link_another_mfa_factor: "Zu einer anderen Methode wechseln",
    save_backup_code: "Backup-Code speichern",
    save_backup_code_description: "Sie k\xf6nnen einen dieser Backup-Codes verwenden, um auf Ihr Konto zuzugreifen, wenn Sie w\xe4hrend der 2-Schritte-Verifizierung auf andere Weise Probleme haben. Jeder Code kann nur einmal verwendet werden.",
    backup_code_hint: "Stellen Sie sicher, dass Sie sie kopieren und an einem sicheren Ort speichern.",
    enter_a_backup_code: "Backup-Code eingeben",
    enter_backup_code_description: "Geben Sie den Backup-Code ein, den Sie gespeichert haben, als die 2-Schritte-Verifizierung initial aktiviert wurde.",
    create_a_passkey: "Passkey erstellen",
    create_passkey_description: "Registrieren Sie Ihren Passkey mit biometrischen Daten, Sicherheitsschl\xfcsseln (z.B. YubiKey) oder anderen verf\xfcgbaren Methoden.",
    try_another_verification_method: "Versuchen Sie eine andere Methode zur Verifizierung",
    verify_via_passkey: "\xdcber Passkey verifizieren",
    verify_via_passkey_description: "Verwenden Sie den Passkey zur Verifizierung durch Ihr Ger\xe4tepasswort oder Biometrie, zum Scannen des QR-Codes oder zum Verwenden eines USB-Sicherheitsschl\xfcssels wie YubiKey.",
    secret_key_copied: "Geheimer Schl\xfcssel kopiert.",
    backup_code_copied: "Backup-Code kopiert.",
    webauthn_not_ready: "WebAuthn ist noch nicht bereit. Bitte versuchen Sie es sp\xe4ter erneut.",
    webauthn_not_supported: "WebAuthn wird in diesem Browser nicht unterst\xfctzt.",
    webauthn_failed_to_create: "Erstellung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    webauthn_failed_to_verify: "Verifizierung fehlgeschlagen. Bitte versuchen Sie es erneut."
};
var $1db0b837a5ba1f0f$export$2e2bcd8739ae039 = Object.freeze($1db0b837a5ba1f0f$var$mfa);


const $c8d6c4e01e8b79f2$var$secondary = {
    social_bind_with: "Besitzt du schon ein Konto? Melde dich an, um {{methods, list(type: disjunction;)}} mit deiner Identit\xe4t zu verbinden."
};
var $c8d6c4e01e8b79f2$export$2e2bcd8739ae039 = Object.freeze($c8d6c4e01e8b79f2$var$secondary);


const $0ee99d0dbfb096ac$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $0ee99d0dbfb096ac$export$2e2bcd8739ae039 = Object.freeze($0ee99d0dbfb096ac$var$user_scopes);


const $eec76cf4bbe969eb$var$de = {
    translation: {
        input: $30785be03dd0139f$export$2e2bcd8739ae039,
        secondary: $c8d6c4e01e8b79f2$export$2e2bcd8739ae039,
        action: $da4738e86067beec$export$2e2bcd8739ae039,
        description: $ed1f50f6589010b9$export$2e2bcd8739ae039,
        error: $fb4445e63d175b11$export$2e2bcd8739ae039,
        list: $b70f1f10b435cd0f$export$2e2bcd8739ae039,
        mfa: $1db0b837a5ba1f0f$export$2e2bcd8739ae039,
        development_tenant: $ea163181e5d39425$export$2e2bcd8739ae039,
        user_scopes: $0ee99d0dbfb096ac$export$2e2bcd8739ae039
    }
};
var $eec76cf4bbe969eb$export$2e2bcd8739ae039 = Object.freeze($eec76cf4bbe969eb$var$de);


const $4d2c5ae3c21cc7c8$var$action = {
    sign_in: "Sign in",
    continue: "Continue",
    create_account: "Create account",
    create_account_without_linking: "Create account without linking",
    create: "Create",
    enter_passcode: "Enter verification code",
    confirm: "Confirm",
    cancel: "Cancel",
    save_password: "Save password",
    bind: "Link with {{address}}",
    bind_and_continue: "Link and continue",
    back: "Go back",
    nav_back: "Back",
    nav_skip: "Skip",
    agree: "Agree",
    got_it: "Got it",
    sign_in_with: "Continue with {{name}}",
    forgot_password: "Forgot your password?",
    switch_to: "Switch to {{method}}",
    sign_in_via_passcode: "Sign in with verification code",
    sign_in_via_password: "Sign in with password",
    change: "Change {{method}}",
    link_another_email: "Link another email",
    link_another_phone: "Link another phone",
    link_another_email_or_phone: "Link another email or phone",
    show_password: "Show password",
    copy: "Copy",
    verify_via_passkey: "Verify via passkey",
    download: "Download",
    single_sign_on: "Single Sign-On",
    authorize: "Authorize",
    use_another_account: "Use another account"
};
var $4d2c5ae3c21cc7c8$export$2e2bcd8739ae039 = Object.freeze($4d2c5ae3c21cc7c8$var$action);


const $12f462c58becf58c$var$description = {
    email: "email",
    phone_number: "phone number",
    username: "username",
    reminder: "Reminder",
    not_found: "404 Not Found",
    agree_with_terms: "I have read and agree to the ",
    agree_with_terms_modal: "To proceed, please agree to the <link></link>.",
    terms_of_use: "Terms of Use",
    sign_in: "Sign in",
    privacy_policy: "Privacy Policy",
    create_account: "Create account",
    or: "or",
    and: "and",
    enter_passcode: "The verification code has been sent to your {{address}} {{target}}",
    passcode_sent: "The verification code has been resent",
    resend_after_seconds: "Resend after <span>{{seconds}}</span> seconds",
    resend_passcode: "Resend verification code",
    create_account_id_exists: "The account with {{type}} {{value}} already exists, would you like to sign in?",
    link_account_id_exists: "The account with {{type}} {{value}} already exists. Would you like to link?",
    sign_in_id_does_not_exist: "The account with {{type}} {{value}} does not exist, would you like to create a new account?",
    sign_in_id_does_not_exist_alert: "The account with {{type}} {{value}} does not exist.",
    create_account_id_exists_alert: "The account with {{type}} {{value}} is linked to another account. Please try another {{type}}.",
    social_identity_exist: "The {{type}} {{value}} is linked to another account. Please try another {{type}}.",
    bind_account_title: "Link or create account",
    social_create_account: "You can create a new account.",
    social_link_email: "You can link another email",
    social_link_phone: "You can link another phone",
    social_link_email_or_phone: "You can link another email or phone",
    social_bind_with_existing: "We find a related account, you can link it directly.",
    reset_password: "Reset password",
    reset_password_description: "Enter the {{types, list(type: disjunction;)}} associated with your account, and we’ll send you the verification code to reset your password.",
    new_password: "New password",
    set_password: "Set password",
    password_changed: "Password changed",
    no_account: "No account yet? ",
    have_account: "Already had an account?",
    enter_password: "Enter password",
    enter_password_for: "Sign in with the password to {{method}} {{value}}",
    enter_username: "Set username",
    enter_username_description: "Username is an alternative for sign-in. Username should contain only letters, numbers, and underscores.",
    link_email: "Link email",
    link_phone: "Link phone",
    link_email_or_phone: "Link email or phone",
    link_email_description: "For added security, please link your email with the account.",
    link_phone_description: "For added security, please link your phone with the account.",
    link_email_or_phone_description: "For added security, please link your email or phone with the account.",
    continue_with_more_information: "For added security, please complete below account details.",
    create_your_account: "Create your account",
    sign_in_to_your_account: "Sign in to your account",
    no_region_code_found: "No region code found",
    verify_email: "Verify your email",
    verify_phone: "Verify your phone number",
    password_requirements: "Password {{items, list}}.",
    password_requirement: {
        length_one: "requires a minimum of {{count}} character",
        length_other: "requires a minimum of {{count}} characters",
        character_types_one: "should contain at least {{count}} type of uppercase letters, lowercase letters, digits, and symbols",
        character_types_other: "should contain at least {{count}} types of uppercase letters, lowercase letters, digits, and symbols"
    },
    use: "Use",
    single_sign_on_email_form: "Enter your enterprise email address",
    single_sign_on_connectors_list: "Your enterprise has enabled Single Sign-On for the email account {{email}}. You can continue to sign in with the following SSO providers.",
    single_sign_on_enabled: "Single Sign-On is enabled for this account",
    authorize_title: "Authorize {{name}}",
    request_permission: "{{name}} is requesting access to:",
    grant_organization_access: "Grant the organization access:",
    authorize_personal_data_usage: "Authorize the use of your personal data:",
    authorize_organization_access: "Authorize access to the specific organization:",
    user_scopes: "Personal user data",
    organization_scopes: "Organization access",
    authorize_agreement: `By authorizing the access, you agree to the {{name}}'s <link></link>.`,
    authorize_agreement_with_redirect: `By authorizing the access, you agree to the {{name}}'s <link></link>, and will be redirected to {{uri}}.`,
    not_you: "Not you?",
    user_id: "User ID: {{id}}",
    redirect_to: "You will be redirected to {{name}}."
};
var $12f462c58becf58c$export$2e2bcd8739ae039 = Object.freeze($12f462c58becf58c$var$description);


const $463b588423a46a23$var$development_tenant = {
    notification: "You're in development mode"
};
var $463b588423a46a23$export$2e2bcd8739ae039 = Object.freeze($463b588423a46a23$var$development_tenant);


const $1557560fa4f6bbd4$var$password_rejected = {
    too_short: "Minimum length is {{min}}.",
    too_long: "Maximum length is {{max}}.",
    character_types: "At least {{min}} types of characters are required.",
    unsupported_characters: "Unsupported character found.",
    pwned: "Avoid using simple passwords that are easy to guess.",
    restricted_found: "Avoid overusing {{list, list}}.",
    restricted: {
        repetition: "repeated characters",
        sequence: "sequential characters",
        user_info: "your personal information",
        words: "product context"
    }
};
var $1557560fa4f6bbd4$export$2e2bcd8739ae039 = Object.freeze($1557560fa4f6bbd4$var$password_rejected);


const $7e38ba006f55b49b$var$error = {
    general_required: `{{types, list(type: disjunction;)}} is required`,
    general_invalid: `The {{types, list(type: disjunction;)}} is invalid`,
    username_required: "Username is required",
    password_required: "Password is required",
    username_exists: "Username already exists",
    username_should_not_start_with_number: "Username should not start with a number",
    username_invalid_charset: "Username should only contain letters, numbers, or underscores.",
    invalid_email: "The email is invalid",
    invalid_phone: "The phone number is invalid",
    passwords_do_not_match: "Your passwords don’t match. Please try again.",
    invalid_passcode: "The verification code is invalid",
    invalid_connector_auth: "The authorization is invalid",
    invalid_connector_request: "The connector data is invalid",
    unknown: "Unknown error. Please try again later.",
    invalid_session: "Session not found. Please go back and sign in again.",
    timeout: "Request timeout. Please try again later.",
    password_rejected: $1557560fa4f6bbd4$export$2e2bcd8739ae039,
    sso_not_enabled: "Single Sign-On is not enabled for this email account."
};
var $7e38ba006f55b49b$export$2e2bcd8739ae039 = Object.freeze($7e38ba006f55b49b$var$error);


const $72e0432bb6f48fcd$var$input = {
    username: "Username",
    password: "Password",
    email: "Email",
    phone_number: "Phone number",
    confirm_password: "Confirm password",
    search_region_code: "Search region code",
    backup_code: "Backup code"
};
var $72e0432bb6f48fcd$export$2e2bcd8739ae039 = Object.freeze($72e0432bb6f48fcd$var$input);


const $81bf4d5c6dfe30a2$var$list = {
    or: "or",
    and: "and",
    separator: ","
};
var $81bf4d5c6dfe30a2$export$2e2bcd8739ae039 = Object.freeze($81bf4d5c6dfe30a2$var$list);


const $7718dc044c73f519$var$mfa = {
    totp: "Authenticator app OTP",
    webauthn: "Passkey",
    backup_code: "Backup code",
    link_totp_description: "E.g., Google Authenticator, etc.",
    link_webauthn_description: "Link your device or USB hardware",
    link_backup_code_description: "Generate a backup code",
    verify_totp_description: "Enter the one-time code in app",
    verify_webauthn_description: "Verify your device or USB hardware",
    verify_backup_code_description: "Paste the backup code you saved",
    add_mfa_factors: "Add 2-step verification",
    add_mfa_description: "Two-factor verification is enabled. Select your second verification method for secure sign-in.",
    verify_mfa_factors: "2-step verification",
    verify_mfa_description: "2-step verification has been enabled for this account. Please select the second way to verify your identity.",
    add_authenticator_app: "Add authenticator app",
    step: "Step {{step, number}}: {{content}}",
    scan_qr_code: "Scan this QR code",
    scan_qr_code_description: "Scan the following QR code with your authenticator app, such as Google Authenticator, Duo Mobile, Authy, etc.",
    qr_code_not_available: "Can’t scan the QR code?",
    copy_and_paste_key: "Copy and paste the key",
    copy_and_paste_key_description: "Copy and paste the following key into your authenticator app, such as Google Authenticator, Duo Mobile, Authy, etc.",
    want_to_scan_qr_code: "Want to scan QR code?",
    enter_one_time_code: "Enter the one-time code",
    enter_one_time_code_link_description: "Enter the 6-digit verification code generated by the authenticator app.",
    enter_one_time_code_description: "2-step verification has been enabled for this account. Please enter the one-time code shown on your linked authenticator app.",
    link_another_mfa_factor: "Switch to another method",
    save_backup_code: "Save your backup code",
    save_backup_code_description: "You can use one of these backup code to access your account if you have trouble during 2-step verification in another ways. Each code may be used only once.",
    backup_code_hint: "Make sure copy them and save in a safe place.",
    enter_a_backup_code: "Enter a backup code",
    enter_backup_code_description: "Enter the backup code you saved when the 2-step verification was initially enabled.",
    create_a_passkey: "Create a passkey",
    create_passkey_description: "Register your passkey using device biometrics, security keys (e.g., YubiKey), or other available methods.",
    try_another_verification_method: "Try another method to verify",
    verify_via_passkey: "Verify via passkey",
    verify_via_passkey_description: "Use passkey to verify by your device password or biometrics, scanning QR code, or using USB security key like YubiKey.",
    secret_key_copied: "Secret key copied.",
    backup_code_copied: "Backup code copied.",
    webauthn_not_ready: "WebAuthn is not ready yet. Please try again later.",
    webauthn_not_supported: "WebAuthn is not supported in this browser.",
    webauthn_failed_to_create: "Failed to create. Please try again.",
    webauthn_failed_to_verify: "Failed to verify. Please try again."
};
var $7718dc044c73f519$export$2e2bcd8739ae039 = Object.freeze($7718dc044c73f519$var$mfa);


const $319fa6dc706e976e$var$secondary = {
    social_bind_with: "Already had an account? Sign in to link {{methods, list(type: disjunction;)}} with your social identity."
};
var $319fa6dc706e976e$export$2e2bcd8739ae039 = Object.freeze($319fa6dc706e976e$var$secondary);


const $c2c9f9af1f9d84d3$var$user_scopes = {
    descriptions: {
        custom_data: "Your custom data",
        email: "Your email address",
        phone: "Your phone number",
        profile: "Your name, username, avatar, and other profile info",
        roles: "Your roles",
        identities: "Your linked social identities",
        "urn:logto:scope:organizations": "Your organizations info",
        "urn:logto:scope:organization_roles": "Your organization roles",
        address: "Your address"
    }
};
var $c2c9f9af1f9d84d3$export$2e2bcd8739ae039 = Object.freeze($c2c9f9af1f9d84d3$var$user_scopes);


const $4d64353670dee0c6$var$en = {
    translation: {
        input: $72e0432bb6f48fcd$export$2e2bcd8739ae039,
        secondary: $319fa6dc706e976e$export$2e2bcd8739ae039,
        action: $4d2c5ae3c21cc7c8$export$2e2bcd8739ae039,
        description: $12f462c58becf58c$export$2e2bcd8739ae039,
        error: $7e38ba006f55b49b$export$2e2bcd8739ae039,
        list: $81bf4d5c6dfe30a2$export$2e2bcd8739ae039,
        mfa: $7718dc044c73f519$export$2e2bcd8739ae039,
        development_tenant: $463b588423a46a23$export$2e2bcd8739ae039,
        user_scopes: $c2c9f9af1f9d84d3$export$2e2bcd8739ae039
    }
};
var $4d64353670dee0c6$export$2e2bcd8739ae039 = Object.freeze($4d64353670dee0c6$var$en);


const $118366fb0e7388bc$var$action = {
    sign_in: "Iniciar sesi\xf3n",
    continue: "Continuar",
    create_account: "Crear una cuenta",
    create_account_without_linking: "Crear una cuenta sin vinculaci\xf3n",
    create: "Crear",
    enter_passcode: "Ingresar c\xf3digo de verificaci\xf3n",
    confirm: "Confirmar",
    cancel: "Cancelar",
    save_password: "Guardar contrase\xf1a",
    bind: "Vincular con {{address}}",
    bind_and_continue: "Vincular y continuar",
    back: "Regresar",
    nav_back: "Atr\xe1s",
    nav_skip: "Omitir",
    agree: "Aceptar",
    got_it: "Entendido",
    sign_in_with: "Continuar con {{name}}",
    forgot_password: "\xbfOlvidaste tu contrase\xf1a?",
    switch_to: "Cambiar a {{method}}",
    sign_in_via_passcode: "Iniciar sesi\xf3n con c\xf3digo de verificaci\xf3n",
    sign_in_via_password: "Iniciar sesi\xf3n con contrase\xf1a",
    change: "Cambiar {{method}}",
    link_another_email: "Vincular otro correo electr\xf3nico",
    link_another_phone: "Vincular otro n\xfamero de tel\xe9fono",
    link_another_email_or_phone: "Vincular otro correo electr\xf3nico o n\xfamero de tel\xe9fono",
    show_password: "Mostrar contrase\xf1a",
    copy: "Copiar",
    verify_via_passkey: "Verificar mediante clave de acceso",
    download: "Descargar",
    single_sign_on: "Inicio de sesi\xf3n \xfanico",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $118366fb0e7388bc$export$2e2bcd8739ae039 = Object.freeze($118366fb0e7388bc$var$action);


const $a1db4a3fedebb13d$var$description = {
    email: "correo electr\xf3nico",
    phone_number: "n\xfamero de tel\xe9fono",
    username: "nombre de usuario",
    reminder: "Recordatorio",
    not_found: "404 No encontrado",
    agree_with_terms: "He le\xeddo y acepto los ",
    agree_with_terms_modal: "Para continuar, por favor acepte los <link></link>.",
    terms_of_use: "T\xe9rminos de uso",
    sign_in: "Iniciar sesi\xf3n",
    privacy_policy: "Pol\xedtica de privacidad",
    create_account: "Crear cuenta",
    or: "o",
    and: "y",
    enter_passcode: "El c\xf3digo de verificaci\xf3n ha sido enviado a su {{address}} {{target}}",
    passcode_sent: "El c\xf3digo de verificaci\xf3n ha sido reenviado",
    resend_after_seconds: "Reenviar despu\xe9s de <span>{{seconds}}</span> segundos",
    resend_passcode: "Reenviar c\xf3digo de verificaci\xf3n",
    create_account_id_exists: "La cuenta con {{type}} {{value}} ya existe, \xbfdesea iniciar sesi\xf3n?",
    link_account_id_exists: "La cuenta con {{type}} {{value}} ya existe. \xbfDesea vincular?",
    sign_in_id_does_not_exist: "La cuenta con {{type}} {{value}} no existe, \xbfdesea crear una nueva cuenta?",
    sign_in_id_does_not_exist_alert: "La cuenta con {{type}} {{value}} no existe.",
    create_account_id_exists_alert: "La cuenta con {{type}} {{value}} est\xe1 vinculada a otra cuenta. Por favor intente con otra {{type}}.",
    social_identity_exist: "La {{type}} {{value}} est\xe1 vinculada a otra cuenta. Por favor intente con otra {{type}}.",
    bind_account_title: "Vincular o crear cuenta",
    social_create_account: "Puede crear una nueva cuenta.",
    social_link_email: "Puede vincular otro correo electr\xf3nico",
    social_link_phone: "Puede vincular otro tel\xe9fono",
    social_link_email_or_phone: "Puede vincular otro correo electr\xf3nico o tel\xe9fono",
    social_bind_with_existing: "Hemos encontrado una cuenta relacionada, puede vincularla directamente.",
    reset_password: "Restablecer contrase\xf1a",
    reset_password_description: "Ingrese los {{types, lista(type: disyunci\xf3n;)}} asociados a su cuenta, y le enviaremos el c\xf3digo de verificaci\xf3n para restablecer su contrase\xf1a.",
    new_password: "Nueva contrase\xf1a",
    set_password: "Establecer contrase\xf1a",
    password_changed: "Contrase\xf1a cambiada",
    no_account: "\xbfNo tiene una cuenta todav\xeda? ",
    have_account: "\xbfYa tiene una cuenta?",
    enter_password: "Ingrese la contrase\xf1a",
    enter_password_for: "Inicie sesi\xf3n con la contrase\xf1a de {{method}} {{value}}",
    enter_username: "Establecer nombre de usuario",
    enter_username_description: "El nombre de usuario es una alternativa para iniciar sesi\xf3n. Debe contener solo letras, n\xfameros y guiones bajos.",
    link_email: "Vincular correo electr\xf3nico",
    link_phone: "Vincular tel\xe9fono",
    link_email_or_phone: "Vincular correo electr\xf3nico o tel\xe9fono",
    link_email_description: "Para mayor seguridad, por favor vincule su correo electr\xf3nico con la cuenta.",
    link_phone_description: "Para mayor seguridad, por favor vincule su tel\xe9fono con la cuenta.",
    link_email_or_phone_description: "Para mayor seguridad, por favor vincule su correo electr\xf3nico o tel\xe9fono con la cuenta.",
    continue_with_more_information: "Para mayor seguridad, por favor complete los detalles de su cuenta a continuaci\xf3n.",
    create_your_account: "Cree su cuenta",
    sign_in_to_your_account: "Inicie sesi\xf3n en su cuenta",
    no_region_code_found: "No se encontr\xf3 c\xf3digo de regi\xf3n",
    verify_email: "Verificar su correo electr\xf3nico",
    verify_phone: "Verificar su n\xfamero de tel\xe9fono",
    password_requirements: "Contrase\xf1a {{items, lista}}.",
    password_requirement: {
        length_one: "requiere un m\xednimo de {{count}} car\xe1cter",
        length_other: "requiere un m\xednimo de {{count}} caracteres",
        character_types_one: "debe contener al menos {{count}} tipo de letras may\xfasculas, letras min\xfasculas, d\xedgitos y s\xedmbolos",
        character_types_other: "debe contener al menos {{count}} tipos de letras may\xfasculas, letras min\xfasculas, d\xedgitos y s\xedmbolos"
    },
    use: "Usar",
    single_sign_on_email_form: "Ingrese su direcci\xf3n de correo electr\xf3nico corporativo",
    single_sign_on_connectors_list: "Su empresa ha habilitado el inicio de sesi\xf3n \xfanico (Single Sign-On) para la cuenta de correo electr\xf3nico {{email}}. Puede continuar iniciando sesi\xf3n con los siguientes proveedores de SSO.",
    single_sign_on_enabled: "El inicio de sesi\xf3n \xfanico (Single Sign-On) est\xe1 habilitado para esta cuenta",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ authorize_personal_data_usage: "Authorize the use of your personal data:",
    /** UNTRANSLATED */ authorize_organization_access: "Authorize access to the specific organization:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: `By authorizing the access, you agree to the {{name}}'s <link></link>.`,
    /** UNTRANSLATED */ authorize_agreement_with_redirect: `By authorizing the access, you agree to the {{name}}'s <link></link>, and will be redirected to {{uri}}.`,
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $a1db4a3fedebb13d$export$2e2bcd8739ae039 = Object.freeze($a1db4a3fedebb13d$var$description);


const $6a8e7aa38a447ffb$var$development_tenant = {
    notification: "Est\xe1s en modo de desarrollo"
};
var $6a8e7aa38a447ffb$export$2e2bcd8739ae039 = Object.freeze($6a8e7aa38a447ffb$var$development_tenant);


const $31be9c6ec18bab39$var$password_rejected = {
    too_short: "La longitud m\xednima es {{min}}.",
    too_long: "La longitud m\xe1xima es {{max}}.",
    character_types: "Se necesitan al menos {{min}} tipos de caracteres.",
    unsupported_characters: "Se encontr\xf3 un car\xe1cter no admitido.",
    pwned: "Evite usar contrase\xf1as simples que sean f\xe1ciles de adivinar.",
    restricted_found: "Evite utilizar en exceso {{list, list}}.",
    restricted: {
        repetition: "caracteres repetidos",
        sequence: "caracteres secuenciales",
        user_info: "su informaci\xf3n personal",
        words: "contexto del producto"
    }
};
var $31be9c6ec18bab39$export$2e2bcd8739ae039 = Object.freeze($31be9c6ec18bab39$var$password_rejected);


const $20c8c1a1029bdd5c$var$error = {
    general_required: `{{types, list(type: disjunction;)}} es requerido`,
    general_invalid: `El/La {{types, list(type: disjunction;)}} no es válido`,
    username_required: "Se requiere un nombre de usuario",
    password_required: "Se requiere una contrase\xf1a",
    username_exists: "El nombre de usuario ya existe",
    username_should_not_start_with_number: "El nombre de usuario no debe comenzar con un n\xfamero",
    username_invalid_charset: "El nombre de usuario solo debe contener letras, n\xfameros o guiones bajos.",
    invalid_email: "El correo electr\xf3nico no es v\xe1lido",
    invalid_phone: "El n\xfamero de tel\xe9fono no es v\xe1lido",
    passwords_do_not_match: "Las contrase\xf1as no coinciden. Por favor intente de nuevo",
    invalid_passcode: "El c\xf3digo de verificaci\xf3n no es v\xe1lido",
    invalid_connector_auth: "La autorizaci\xf3n no es v\xe1lida",
    invalid_connector_request: "Los datos del conector no son v\xe1lidos",
    unknown: "Error desconocido. Por favor intente de nuevo m\xe1s tarde.",
    invalid_session: "No se encontr\xf3 la sesi\xf3n. Por favor regrese e inicie sesi\xf3n nuevamente.",
    timeout: "Tiempo de espera de solicitud agotado. Por favor intente de nuevo m\xe1s tarde.",
    password_rejected: $31be9c6ec18bab39$export$2e2bcd8739ae039,
    sso_not_enabled: "El inicio de sesi\xf3n \xfanico no est\xe1 habilitado para esta cuenta de correo electr\xf3nico."
};
var $20c8c1a1029bdd5c$export$2e2bcd8739ae039 = Object.freeze($20c8c1a1029bdd5c$var$error);


const $3c5ea2020d088938$var$input = {
    username: "Nombre de usuario",
    password: "Contrase\xf1a",
    email: "Correo electr\xf3nico",
    phone_number: "N\xfamero de tel\xe9fono",
    confirm_password: "Confirmar contrase\xf1a",
    search_region_code: "C\xf3digo de regi\xf3n de b\xfasqueda",
    backup_code: "C\xf3digo de respaldo"
};
var $3c5ea2020d088938$export$2e2bcd8739ae039 = Object.freeze($3c5ea2020d088938$var$input);


const $cb907316e6f47ebd$var$list = {
    or: "o",
    and: "y",
    separator: ","
};
var $cb907316e6f47ebd$export$2e2bcd8739ae039 = Object.freeze($cb907316e6f47ebd$var$list);


const $5fa4d099d6eb31ee$var$mfa = {
    totp: "OTP de la aplicaci\xf3n autenticadora",
    webauthn: "Contrase\xf1a",
    backup_code: "C\xf3digo de respaldo",
    link_totp_description: "Ej., Google Authenticator, etc.",
    link_webauthn_description: "Vincule su dispositivo o hardware USB",
    link_backup_code_description: "Genere un c\xf3digo de respaldo",
    verify_totp_description: "Ingrese el c\xf3digo de un solo uso en la aplicaci\xf3n",
    verify_webauthn_description: "Verifique su dispositivo o hardware USB",
    verify_backup_code_description: "Pegue el c\xf3digo de respaldo que guard\xf3",
    add_mfa_factors: "Agregar verificaci\xf3n de 2 pasos",
    add_mfa_description: "La verificaci\xf3n de dos factores est\xe1 habilitada. Seleccione su segundo m\xe9todo de verificaci\xf3n para iniciar sesi\xf3n de forma segura.",
    verify_mfa_factors: "Verificaci\xf3n de 2 pasos",
    verify_mfa_description: "La verificaci\xf3n de 2 pasos se ha habilitado para esta cuenta. Seleccione la segunda forma de verificar su identidad.",
    add_authenticator_app: "Agregar aplicaci\xf3n autenticadora",
    step: "Paso {{step, number}}: {{content}}",
    scan_qr_code: "Escanee este c\xf3digo QR",
    scan_qr_code_description: "Escanee el siguiente c\xf3digo QR con su aplicaci\xf3n autenticadora, como Google Authenticator, Duo Mobile, Authy, etc.",
    qr_code_not_available: "\xbfNo puede escanear el c\xf3digo QR?",
    copy_and_paste_key: "Copie y pegue la clave",
    copy_and_paste_key_description: "Copie y pegue la siguiente clave en su aplicaci\xf3n autenticadora, como Google Authenticator, Duo Mobile, Authy, etc.",
    want_to_scan_qr_code: "\xbfQuiere escanear el c\xf3digo QR?",
    enter_one_time_code: "Ingrese el c\xf3digo de un solo uso",
    enter_one_time_code_link_description: "Ingrese el c\xf3digo de verificaci\xf3n de 6 d\xedgitos generado por la aplicaci\xf3n autenticadora.",
    enter_one_time_code_description: "Se ha habilitado la verificaci\xf3n en dos pasos para esta cuenta. Por favor, ingrese el c\xf3digo de un solo uso que se muestra en su aplicaci\xf3n de autenticaci\xf3n vinculada.",
    link_another_mfa_factor: "Cambiar a otro m\xe9todo",
    save_backup_code: "Guarde su c\xf3digo de respaldo",
    save_backup_code_description: "Puede usar uno de estos c\xf3digos de respaldo para acceder a su cuenta si tiene problemas durante la verificaci\xf3n de 2 pasos de otras maneras. Cada c\xf3digo solo se puede usar una vez.",
    backup_code_hint: "Aseg\xfarese de copiarlos y guardarlos en un lugar seguro.",
    enter_a_backup_code: "Ingrese un c\xf3digo de respaldo",
    enter_backup_code_description: "Ingrese el c\xf3digo de respaldo que guard\xf3 cuando se habilit\xf3 la verificaci\xf3n de 2 pasos inicialmente.",
    create_a_passkey: "Crear una contrase\xf1a",
    create_passkey_description: "Registre su contrase\xf1a utilizando la biometr\xeda del dispositivo, claves de seguridad (por ejemplo, YubiKey) u otros m\xe9todos disponibles.",
    try_another_verification_method: "Pruebe otro m\xe9todo de verificaci\xf3n",
    verify_via_passkey: "Verificar mediante contrase\xf1a",
    verify_via_passkey_description: "Use la contrase\xf1a para verificar mediante la contrase\xf1a de su dispositivo o biometr\xeda, escanee el c\xf3digo QR o use una clave de seguridad USB como YubiKey.",
    secret_key_copied: "Clave secreta copiada.",
    backup_code_copied: "C\xf3digo de respaldo copiado.",
    webauthn_not_ready: "WebAuthn a\xfan no est\xe1 listo. Por favor, int\xe9ntelo de nuevo m\xe1s tarde.",
    webauthn_not_supported: "WebAuthn no es compatible con este navegador.",
    webauthn_failed_to_create: "Error al crear. Por favor, int\xe9ntelo de nuevo.",
    webauthn_failed_to_verify: "Error al verificar. Por favor, int\xe9ntelo de nuevo."
};
var $5fa4d099d6eb31ee$export$2e2bcd8739ae039 = Object.freeze($5fa4d099d6eb31ee$var$mfa);


const $1dec08d8a31292c9$var$secondary = {
    social_bind_with: "\xbfYa tienes una cuenta? Inicia sesi\xf3n para vincular {{methods, list(type: disjunction;)}} con tu identidad social."
};
var $1dec08d8a31292c9$export$2e2bcd8739ae039 = Object.freeze($1dec08d8a31292c9$var$secondary);


const $df138f3a19f5cc09$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $df138f3a19f5cc09$export$2e2bcd8739ae039 = Object.freeze($df138f3a19f5cc09$var$user_scopes);


const $f0cc21b4d8d130f6$var$es = {
    translation: {
        input: $3c5ea2020d088938$export$2e2bcd8739ae039,
        secondary: $1dec08d8a31292c9$export$2e2bcd8739ae039,
        action: $118366fb0e7388bc$export$2e2bcd8739ae039,
        description: $a1db4a3fedebb13d$export$2e2bcd8739ae039,
        error: $20c8c1a1029bdd5c$export$2e2bcd8739ae039,
        list: $cb907316e6f47ebd$export$2e2bcd8739ae039,
        mfa: $5fa4d099d6eb31ee$export$2e2bcd8739ae039,
        development_tenant: $6a8e7aa38a447ffb$export$2e2bcd8739ae039,
        user_scopes: $df138f3a19f5cc09$export$2e2bcd8739ae039
    }
};
var $f0cc21b4d8d130f6$export$2e2bcd8739ae039 = Object.freeze($f0cc21b4d8d130f6$var$es);


const $e41f205aea8b2c00$var$action = {
    sign_in: "Connexion",
    continue: "Continuer",
    create_account: "Cr\xe9er un compte",
    create_account_without_linking: "Cr\xe9er un compte sans lier",
    create: "Cr\xe9er",
    enter_passcode: "Entrer le code",
    confirm: "Confirmer",
    cancel: "Annuler",
    save_password: "Enregistrer le mot de passe",
    bind: "Lier avec {{address}}",
    bind_and_continue: "Lier et continuer",
    back: "Aller en arri\xe8re",
    nav_back: "Retour",
    nav_skip: "Passer",
    agree: "Accepter",
    got_it: "Compris",
    sign_in_with: "Continuer avec {{name}}",
    forgot_password: "Mot de passe oubli\xe9?",
    switch_to: "Passer au {{method}}",
    sign_in_via_passcode: "Se connecter avec le code de v\xe9rification",
    sign_in_via_password: "Se connecter avec le mot de passe",
    change: "Changer {{method}}",
    link_another_email: "Lier une autre adresse e-mail",
    link_another_phone: "Lier un autre num\xe9ro de t\xe9l\xe9phone",
    link_another_email_or_phone: "Lier une autre adresse e-mail ou un autre num\xe9ro de t\xe9l\xe9phone",
    show_password: "Afficher le mot de passe",
    copy: "Copier",
    verify_via_passkey: "V\xe9rifier via la cl\xe9 d'acc\xe8s",
    download: "T\xe9l\xe9charger",
    single_sign_on: "Connexion unique",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $e41f205aea8b2c00$export$2e2bcd8739ae039 = Object.freeze($e41f205aea8b2c00$var$action);


const $4c8b8bc823f33e14$var$description = {
    email: "email",
    phone_number: "num\xe9ro de t\xe9l\xe9phone",
    username: "nom d'utilisateur",
    reminder: "Rappel",
    not_found: "404 Non trouv\xe9",
    agree_with_terms: "J'ai lu et accept\xe9 les ",
    agree_with_terms_modal: "Pour continuer, veuillez accepter le <link></link>.",
    terms_of_use: "Conditions d'utilisation",
    sign_in: "Connexion",
    privacy_policy: "Politique de confidentialit\xe9",
    create_account: "Cr\xe9er un compte",
    or: "ou",
    and: "et",
    enter_passcode: "Le code a \xe9t\xe9 envoy\xe9 \xe0 {{address}} {{target}}",
    passcode_sent: "Le code a \xe9t\xe9 renvoy\xe9",
    resend_after_seconds: "Renvoyer apr\xe8s <span>{{seconds}}</span> secondes",
    resend_passcode: "Renvoyer le code",
    create_account_id_exists: "Le compte avec {{type}} {{value}} existe d\xe9j\xe0, voulez-vous vous connecter?",
    link_account_id_exists: "Le compte avec {{type}} {{value}} existe d\xe9j\xe0, voulez-vous le lier?",
    sign_in_id_does_not_exist: "Le compte avec {{type}} {{value}} n'existe pas, voulez-vous cr\xe9er un nouveau compte?",
    sign_in_id_does_not_exist_alert: "Nous ne trouvons aucun compte associ\xe9 \xe0 {{type}} {{value}}.",
    create_account_id_exists_alert: "Le compte avec {{type}} {{value}} est li\xe9 \xe0 un autre compte. Veuillez essayer un autre {{type}}.",
    social_identity_exist: "Le {{type}} {{value}} est li\xe9 \xe0 un autre compte. Veuillez essayer un autre {{type}}.",
    bind_account_title: "Lier ou cr\xe9er un compte",
    social_create_account: "Vous pouvez cr\xe9er un nouveau compte",
    social_link_email: "Vous pouvez lier une autre adresse e-mail",
    social_link_phone: "Vous pouvez lier un autre num\xe9ro de t\xe9l\xe9phone",
    social_link_email_or_phone: "Vous pouvez lier une autre adresse e-mail ou un autre num\xe9ro de t\xe9l\xe9phone",
    social_bind_with_existing: "Nous avons trouv\xe9 un compte associ\xe9, vous pouvez le lier directement.",
    reset_password: "Mot de passe oubli\xe9",
    reset_password_description: "Entrez le {{types, list(type: disjunction;)}} associ\xe9 \xe0 votre compte et nous vous enverrons le code de v\xe9rification pour r\xe9initialiser votre mot de passe.",
    new_password: "Nouveau mot de passe",
    set_password: "D\xe9finir un mot de passe",
    password_changed: "Mot de passe modifi\xe9",
    no_account: "Pas encore de compte? ",
    have_account: "D\xe9j\xe0 un compte?",
    enter_password: "Entrer le mot de passe",
    enter_password_for: "Connectez-vous avec le mot de passe pour {{method}} {{value}}",
    enter_username: "D\xe9finir un nom d'utilisateur",
    enter_username_description: "Le nom d'utilisateur est une alternative pour la connexion. Le nom d'utilisateur doit contenir uniquement des lettres, des chiffres et des underscores.",
    link_email: "Lier l'adresse e-mail",
    link_phone: "Lier le num\xe9ro de t\xe9l\xe9phone",
    link_email_or_phone: "Lier l'adresse e-mail ou le num\xe9ro de t\xe9l\xe9phone",
    link_email_description: "Pour une s\xe9curit\xe9 accrue, veuillez lier votre adresse e-mail au compte.",
    link_phone_description: "Pour une s\xe9curit\xe9 accrue, veuillez lier votre num\xe9ro de t\xe9l\xe9phone au compte.",
    link_email_or_phone_description: "Pour une s\xe9curit\xe9 accrue, veuillez lier votre adresse e-mail ou votre num\xe9ro de t\xe9l\xe9phone au compte.",
    continue_with_more_information: "Pour une s\xe9curit\xe9 accrue, veuillez compl\xe9ter les d\xe9tails du compte ci-dessous.",
    create_your_account: "Cr\xe9er votre compte",
    sign_in_to_your_account: "Connecte-toi \xe0 ton compte",
    no_region_code_found: "Aucun code de r\xe9gion trouv\xe9",
    verify_email: "V\xe9rifiez votre e-mail",
    verify_phone: "V\xe9rifiez votre num\xe9ro de t\xe9l\xe9phone",
    password_requirements: "Mot de passe {{items, list}}.",
    password_requirement: {
        length_one: "doit contenir au minimum {{count}} caract\xe8re",
        length_other: "doit contenir au minimum {{count}} caract\xe8res",
        character_types_one: "doit contenir au moins {{count}} type de lettres majuscules, lettres minuscules, chiffres et symboles",
        character_types_other: "doit contenir au moins {{count}} types de lettres majuscules, lettres minuscules, chiffres et symboles"
    },
    use: "Utiliser",
    single_sign_on_email_form: "Entrez votre adresse e-mail d'entreprise",
    single_sign_on_connectors_list: "Votre entreprise a activ\xe9 la connexion unique (Single Sign-On) pour le compte email {{email}}. Vous pouvez continuer \xe0 vous connecter avec les fournisseurs SSO suivants.",
    single_sign_on_enabled: "La connexion unique (Single Sign-On) est activ\xe9e pour ce compte",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ authorize_personal_data_usage: "Authorize the use of your personal data:",
    /** UNTRANSLATED */ authorize_organization_access: "Authorize access to the specific organization:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: `By authorizing the access, you agree to the {{name}}'s <link></link>.`,
    /** UNTRANSLATED */ authorize_agreement_with_redirect: `By authorizing the access, you agree to the {{name}}'s <link></link>, and will be redirected to {{uri}}.`,
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $4c8b8bc823f33e14$export$2e2bcd8739ae039 = Object.freeze($4c8b8bc823f33e14$var$description);


const $92692e24c493e5b9$var$development_tenant = {
    notification: "Vous \xeates en mode d\xe9veloppement"
};
var $92692e24c493e5b9$export$2e2bcd8739ae039 = Object.freeze($92692e24c493e5b9$var$development_tenant);


const $8a3e89a3daed6030$var$password_rejected = {
    too_short: "La longueur minimale est {{min}}.",
    too_long: "La longueur maximale est {{max}}.",
    character_types: "Au moins {{min}} types de caract\xe8res sont requis.",
    unsupported_characters: "Caract\xe8re non support\xe9 trouv\xe9.",
    pwned: "\xc9vitez d'utiliser des mots de passe simples faciles \xe0 deviner.",
    restricted_found: "\xc9vitez d'utiliser de mani\xe8re excessive {{list, list}}.",
    restricted: {
        repetition: "caract\xe8res r\xe9p\xe9t\xe9s",
        sequence: "caract\xe8res s\xe9quentiels",
        user_info: "vos informations personnelles",
        words: "contexte produit"
    }
};
var $8a3e89a3daed6030$export$2e2bcd8739ae039 = Object.freeze($8a3e89a3daed6030$var$password_rejected);


const $422783ea177cee83$var$error = {
    general_required: "Le {{types, list(type: disjunction;)}} est requis",
    general_invalid: "Le {{types, list(type: disjunction;)}} n'est pas valide",
    username_required: "Le nom d'utilisateur est requis",
    password_required: "Le mot de passe est requis",
    username_exists: "Ce Nom d'utilisateur existe d\xe9j\xe0",
    username_should_not_start_with_number: "Le nom d'utilisateur ne doit pas commencer par un chiffre",
    username_invalid_charset: "Le nom d'utilisateur ne doit contenir que des lettres, des chiffres ou des caract\xe8res de soulignement.",
    invalid_email: "L'email n'est pas valide",
    invalid_phone: "Le num\xe9ro de t\xe9l\xe9phone n'est pas valide",
    passwords_do_not_match: "Les mots de passe ne correspondent pas",
    invalid_passcode: "Le code est invalide",
    invalid_connector_auth: "L'autorisation n'est pas valide",
    invalid_connector_request: "Les donn\xe9es du connecteur ne sont pas valides",
    unknown: "Erreur inconnue. Veuillez r\xe9essayer plus tard.",
    invalid_session: "Session non trouv\xe9e. Veuillez revenir en arri\xe8re et vous connecter \xe0 nouveau.",
    timeout: "D\xe9lai d'attente de la requ\xeate d\xe9pass\xe9. Veuillez r\xe9essayer plus tard.",
    password_rejected: $8a3e89a3daed6030$export$2e2bcd8739ae039,
    sso_not_enabled: "La authentification unique n'est pas activ\xe9e pour ce compte de messagerie."
};
var $422783ea177cee83$export$2e2bcd8739ae039 = Object.freeze($422783ea177cee83$var$error);


const $930e17d62017096f$var$input = {
    username: "Nom d'utilisateur",
    password: "Mot de passe",
    email: "Email",
    phone_number: "Num\xe9ro de t\xe9l\xe9phone",
    confirm_password: "Confirmer le mot de passe",
    search_region_code: "Rechercher le code de r\xe9gion",
    backup_code: "Code de sauvegarde"
};
var $930e17d62017096f$export$2e2bcd8739ae039 = Object.freeze($930e17d62017096f$var$input);


const $132c2449d9ee8888$var$list = {
    or: "ou",
    and: "et",
    separator: ","
};
var $132c2449d9ee8888$export$2e2bcd8739ae039 = Object.freeze($132c2449d9ee8888$var$list);


const $e0e5d27a26c3bc14$var$mfa = {
    totp: "OTP de l'application d'authentification",
    webauthn: "Passkey",
    backup_code: "Code de sauvegarde",
    link_totp_description: "Par exemple, Google Authenticator, etc.",
    link_webauthn_description: "Associez votre appareil ou mat\xe9riel USB",
    link_backup_code_description: "G\xe9n\xe9rez un code de sauvegarde",
    verify_totp_description: "Saisissez le code \xe0 usage unique dans l'application",
    verify_webauthn_description: "V\xe9rifiez votre appareil ou mat\xe9riel USB",
    verify_backup_code_description: "Collez le code de sauvegarde que vous avez enregistr\xe9",
    add_mfa_factors: "Ajouter la v\xe9rification en deux \xe9tapes",
    add_mfa_description: "La v\xe9rification en deux \xe9tapes est activ\xe9e. S\xe9lectionnez votre deuxi\xe8me m\xe9thode de v\xe9rification pour une connexion s\xe9curis\xe9e.",
    verify_mfa_factors: "V\xe9rification en deux \xe9tapes",
    verify_mfa_description: "La v\xe9rification en deux \xe9tapes a \xe9t\xe9 activ\xe9e pour ce compte. Veuillez s\xe9lectionner la deuxi\xe8me fa\xe7on de v\xe9rifier votre identit\xe9.",
    add_authenticator_app: "Ajouter une application d'authentification",
    step: "\xc9tape {{step, number}} : {{content}}",
    scan_qr_code: "Scannez ce code QR",
    scan_qr_code_description: "Scannez le code QR suivant avec votre application d'authentification, telle que Google Authenticator, Duo Mobile, Authy, etc.",
    qr_code_not_available: "Impossible de scanner le code QR ?",
    copy_and_paste_key: "Copiez et collez la cl\xe9",
    copy_and_paste_key_description: "Copiez et collez la cl\xe9 suivante dans votre application d'authentification, telle que Google Authenticator, Duo Mobile, Authy, etc.",
    want_to_scan_qr_code: "Vous voulez scanner le code QR ?",
    enter_one_time_code: "Saisissez le code \xe0 usage unique",
    enter_one_time_code_link_description: "Saisissez le code de v\xe9rification \xe0 6 chiffres g\xe9n\xe9r\xe9 par l'application d'authentification.",
    enter_one_time_code_description: "La v\xe9rification en deux \xe9tapes a \xe9t\xe9 activ\xe9e pour ce compte. Veuillez entrer le code \xe0 usage unique affich\xe9 sur votre application d'authentification li\xe9e.",
    link_another_mfa_factor: "Passez \xe0 une autre m\xe9thode",
    save_backup_code: "Enregistrez votre code de sauvegarde",
    save_backup_code_description: "Vous pouvez utiliser l'un de ces codes de sauvegarde pour acc\xe9der \xe0 votre compte en cas de probl\xe8me lors de la v\xe9rification en deux \xe9tapes par d'autres moyens. Chaque code ne peut \xeatre utilis\xe9 qu'une fois.",
    backup_code_hint: "Assurez-vous de les copier et de les sauvegarder dans un endroit s\xfbr.",
    enter_a_backup_code: "Saisissez un code de sauvegarde",
    enter_backup_code_description: "Saisissez le code de sauvegarde que vous avez enregistr\xe9 lorsque la v\xe9rification en deux \xe9tapes a \xe9t\xe9 activ\xe9e initialement.",
    create_a_passkey: "Cr\xe9ez une cl\xe9 d'acc\xe8s",
    create_passkey_description: "Enregistrez votre cl\xe9 d'acc\xe8s \xe0 l'aide de la biom\xe9trie de l'appareil, de cl\xe9s de s\xe9curit\xe9 (par exemple, YubiKey) ou d'autres m\xe9thodes disponibles.",
    try_another_verification_method: "Essayez une autre m\xe9thode de v\xe9rification",
    verify_via_passkey: "V\xe9rifiez via la cl\xe9 d'acc\xe8s",
    verify_via_passkey_description: "Utilisez la cl\xe9 d'acc\xe8s pour v\xe9rifier avec votre mot de passe ou la biom\xe9trie de votre appareil, en scannant le code QR ou en utilisant une cl\xe9 de s\xe9curit\xe9 USB comme la YubiKey.",
    secret_key_copied: "Cl\xe9 secr\xe8te copi\xe9e.",
    backup_code_copied: "Code de sauvegarde copi\xe9.",
    webauthn_not_ready: "WebAuthn n'est pas pr\xeat pour le moment. Veuillez r\xe9essayer plus tard.",
    webauthn_not_supported: "WebAuthn n'est pas pris en charge dans ce navigateur.",
    webauthn_failed_to_create: "\xc9chec de la cr\xe9ation. Veuillez r\xe9essayer.",
    webauthn_failed_to_verify: "\xc9chec de la v\xe9rification. Veuillez r\xe9essayer."
};
var $e0e5d27a26c3bc14$export$2e2bcd8739ae039 = Object.freeze($e0e5d27a26c3bc14$var$mfa);


const $1d4251c70df072ec$var$secondary = {
    social_bind_with: "Vous avez d\xe9j\xe0 un compte? Connectez-vous pour lier {{methods, list(type: disjunction;)}} avec votre identit\xe9 sociale."
};
var $1d4251c70df072ec$export$2e2bcd8739ae039 = Object.freeze($1d4251c70df072ec$var$secondary);


const $6b0c899f222b401d$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $6b0c899f222b401d$export$2e2bcd8739ae039 = Object.freeze($6b0c899f222b401d$var$user_scopes);


const $fe16315c7ff1471f$var$fr = {
    translation: {
        input: $930e17d62017096f$export$2e2bcd8739ae039,
        secondary: $1d4251c70df072ec$export$2e2bcd8739ae039,
        action: $e41f205aea8b2c00$export$2e2bcd8739ae039,
        description: $4c8b8bc823f33e14$export$2e2bcd8739ae039,
        error: $422783ea177cee83$export$2e2bcd8739ae039,
        list: $132c2449d9ee8888$export$2e2bcd8739ae039,
        mfa: $e0e5d27a26c3bc14$export$2e2bcd8739ae039,
        development_tenant: $92692e24c493e5b9$export$2e2bcd8739ae039,
        user_scopes: $6b0c899f222b401d$export$2e2bcd8739ae039
    }
};
var $fe16315c7ff1471f$export$2e2bcd8739ae039 = Object.freeze($fe16315c7ff1471f$var$fr);


const $d47d3f3bbae3084c$var$action = {
    sign_in: "Accedi",
    continue: "Continua",
    create_account: "Crea account",
    create_account_without_linking: "Crea account senza collegare",
    create: "Crea",
    enter_passcode: "Inserisci il codice di verifica",
    confirm: "Conferma",
    cancel: "Annulla",
    save_password: "Salva password",
    bind: "Collega con {{address}}",
    bind_and_continue: "Collega e continua",
    back: "Torna indietro",
    nav_back: "Indietro",
    nav_skip: "Salta",
    agree: "Accetto",
    got_it: "Capito",
    sign_in_with: "Continua con {{name}}",
    forgot_password: "Hai dimenticato la password?",
    switch_to: "Passa a {{method}}",
    sign_in_via_passcode: "Accedi con il codice di verifica",
    sign_in_via_password: "Accedi con la password",
    change: "Cambia {{method}}",
    link_another_email: "Collega un altro indirizzo email",
    link_another_phone: "Collega un altro numero di telefono",
    link_another_email_or_phone: "Collega un altro indirizzo email o numero di telefono",
    show_password: "Mostra password",
    copy: "Copia",
    verify_via_passkey: "Verifica tramite passkey",
    download: "Scarica",
    single_sign_on: "Single Sign-On",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $d47d3f3bbae3084c$export$2e2bcd8739ae039 = Object.freeze($d47d3f3bbae3084c$var$action);


const $844642d7ab33c2b7$var$description = {
    email: "email",
    phone_number: "numero di telefono",
    username: "username",
    reminder: "Promemoria",
    not_found: "404 Non trovato",
    agree_with_terms: "Ho letto e accetto i ",
    agree_with_terms_modal: "Per procedere, si prega di accettare i <link></link>.",
    terms_of_use: "Termini di utilizzo",
    sign_in: "Accedi",
    privacy_policy: "Informativa sulla privacy",
    create_account: "Crea account",
    or: "o",
    and: "e",
    enter_passcode: "Il codice di verifica \xe8 stato inviato alla tua {{address}} {{target}}",
    passcode_sent: "Il codice di verifica \xe8 stato inviato di nuovo",
    resend_after_seconds: "Inviare di nuovo dopo <span>{{seconds}}</span> secondi",
    resend_passcode: "Inviare nuovamente il codice di verifica",
    create_account_id_exists: "L'account con {{type}} {{value}} gi\xe0 esiste, vuoi accedere?",
    link_account_id_exists: "L'account con {{type}} {{value}} \xe8 gi\xe0 esistente. Vuoi collegarlo?",
    sign_in_id_does_not_exist: "L'account con {{type}} {{value}} non esiste, vuoi creare un nuovo account?",
    sign_in_id_does_not_exist_alert: "L'account con {{type}} {{value}} non esiste.",
    create_account_id_exists_alert: "L'account {{type}} {{value}} \xe8 collegato ad un altro account. Prova con un altro {{type}}.",
    social_identity_exist: "L'{{type}} {{value}} \xe8 collegato ad un altro account. Prova con un altro {{type}}.",
    bind_account_title: "Collega o crea un account",
    social_create_account: "Puoi creare un nuovo account.",
    social_link_email: "Puoi collegare un'altra email",
    social_link_phone: "Puoi collegare un altro telefono",
    social_link_email_or_phone: "Puoi collegare un'altra email o telefono",
    social_bind_with_existing: "Abbiamo trovato un account correlato, puoi collegarlo direttamente.",
    reset_password: "Resetta la password",
    reset_password_description: "Inserisci il {{types, list(type: disjunction;)}} associato al tuo account, e ti invieremo il codice di verifica per resettare la password.",
    new_password: "Nuova password",
    set_password: "Imposta una password",
    password_changed: "Password cambiata",
    no_account: "Ancora nessun account? ",
    have_account: "Hai gi\xe0 un account?",
    enter_password: "Inserisci la password",
    enter_password_for: "Accedi con la password per {{method}} {{value}}",
    enter_username: "Imposta username",
    enter_username_description: "L'username \xe8 un'alternativa per l'accesso. L'username deve contenere solo lettere, numeri e trattini bassi.",
    link_email: "Collega emails",
    link_phone: "Collega telefono",
    link_email_or_phone: "Collega email o telefono",
    link_email_description: "Per maggiore sicurezza, collega la tua email all'account.",
    link_phone_description: "Per maggiore sicurezza, collega il tuo telefono all'account.",
    link_email_or_phone_description: "Per maggiore sicurezza, collega la tua email o il tuo telefono all'account.",
    continue_with_more_information: "Per maggiore sicurezza, completa i dettagli dell'account qui sotto.",
    create_your_account: "Crea il tuo account",
    sign_in_to_your_account: "Accedi al tuo account",
    no_region_code_found: "Nessun codice di regione trovato",
    verify_email: "Verifica la tua email",
    verify_phone: "Verifica il tuo numero di telefono",
    password_requirements: "Password {{items, list}}.",
    password_requirement: {
        length_one: "richiede almeno {{count}} carattere",
        length_other: "richiede almeno {{count}} caratteri",
        character_types_one: "dovrebbe contenere almeno {{count}} tipo di lettere maiuscole, lettere minuscole, numeri e simboli",
        character_types_other: "dovrebbe contenere almeno {{count}} tipi di lettere maiuscole, lettere minuscole, numeri e simboli"
    },
    use: "Utilizzare",
    single_sign_on_email_form: "Inserisci il tuo indirizzo email aziendale",
    single_sign_on_connectors_list: "La tua azienda ha abilitato il Single Sign-On per l'account email {{email}}. Puoi continuare ad accedere con i seguenti fornitori di SSO.",
    single_sign_on_enabled: "Il Single Sign-On \xe8 abilitato per questo account",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ authorize_personal_data_usage: "Authorize the use of your personal data:",
    /** UNTRANSLATED */ authorize_organization_access: "Authorize access to the specific organization:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: `By authorizing the access, you agree to the {{name}}'s <link></link>.`,
    /** UNTRANSLATED */ authorize_agreement_with_redirect: `By authorizing the access, you agree to the {{name}}'s <link></link>, and will be redirected to {{uri}}.`,
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $844642d7ab33c2b7$export$2e2bcd8739ae039 = Object.freeze($844642d7ab33c2b7$var$description);


const $1adffbaebf76eb53$var$development_tenant = {
    notification: "Sei in modalit\xe0 di sviluppo"
};
var $1adffbaebf76eb53$export$2e2bcd8739ae039 = Object.freeze($1adffbaebf76eb53$var$development_tenant);


const $bc8b25ef5d54950f$var$password_rejected = {
    too_short: "La lunghezza minima \xe8 {{min}}.",
    too_long: "La lunghezza massima \xe8 {{max}}.",
    character_types: "Sono richiesti almeno {{min}} tipi di caratteri.",
    unsupported_characters: "Carattere non supportato trovato.",
    pwned: "Evita di utilizzare password semplici facili da indovinare.",
    restricted_found: "Evita di utilizzare in eccesso {{list, list}}.",
    restricted: {
        repetition: "caratteri ripetuti",
        sequence: "caratteri sequenziali",
        user_info: "le tue informazioni personali",
        words: "contesto del prodotto"
    }
};
var $bc8b25ef5d54950f$export$2e2bcd8739ae039 = Object.freeze($bc8b25ef5d54950f$var$password_rejected);


const $8a7d0fe99774803f$var$error = {
    general_required: `{{types, list(type: disjunction;)}} è richiesto`,
    general_invalid: `Il {{types, list(type: disjunction;)}} non è valido`,
    username_required: "Username \xe8 richiesto",
    password_required: "La password \xe8 richiesta",
    username_exists: "Username esiste gi\xe0",
    username_should_not_start_with_number: "L'username non dovrebbe iniziare con un numero",
    username_invalid_charset: "L'username dovrebbe contenere solo lettere, numeri o underscore.",
    invalid_email: "L'email non \xe8 valida",
    invalid_phone: "Il numero di telefono non \xe8 valido",
    passwords_do_not_match: "Le password non corrispondono. Per favore prova di nuovo.",
    invalid_passcode: "Il codice di verifica non \xe8 valido",
    invalid_connector_auth: "L'autorizzazione \xe8 invalida",
    invalid_connector_request: "I dati del connettore non sono validi",
    unknown: "Errore sconosciuto. Si prega di riprovare pi\xf9 tardi.",
    invalid_session: "Sessione non trovata. Si prega di tornare indietro e accedere di nuovo.",
    timeout: "Timeout della richiesta. Si prega di riprovare pi\xf9 tardi.",
    password_rejected: $bc8b25ef5d54950f$export$2e2bcd8739ae039,
    sso_not_enabled: "Single sign-on non abilitato per questo account email."
};
var $8a7d0fe99774803f$export$2e2bcd8739ae039 = Object.freeze($8a7d0fe99774803f$var$error);


const $fab34968a01c542c$var$input = {
    username: "Nome utente",
    password: "Password",
    email: "Email",
    phone_number: "Numero di telefono",
    confirm_password: "Conferma password",
    search_region_code: "Codice regione di ricerca",
    backup_code: "Codice di backup"
};
var $fab34968a01c542c$export$2e2bcd8739ae039 = Object.freeze($fab34968a01c542c$var$input);


const $2981b9ceaa61452f$var$list = {
    or: "o",
    and: "e",
    separator: ","
};
var $2981b9ceaa61452f$export$2e2bcd8739ae039 = Object.freeze($2981b9ceaa61452f$var$list);


const $9922e1a2ca91f413$var$mfa = {
    totp: "OTP dell'app Autenticatore",
    webauthn: "Passkey",
    backup_code: "Codice di backup",
    link_totp_description: "Ad esempio, Google Authenticator, ecc.",
    link_webauthn_description: "Collega il tuo dispositivo o hardware USB",
    link_backup_code_description: "Genera un codice di backup",
    verify_totp_description: "Inserisci il codice monouso nell'app",
    verify_webauthn_description: "Verifica il tuo dispositivo o hardware USB",
    verify_backup_code_description: "Incolla il codice di backup che hai salvato",
    add_mfa_factors: "Aggiungi la verifica in due passaggi",
    add_mfa_description: "La verifica in due passaggi \xe8 abilitata. Seleziona il tuo secondo metodo di verifica per un accesso sicuro.",
    verify_mfa_factors: "Verifica in due passaggi",
    verify_mfa_description: "La verifica in due passaggi \xe8 stata abilitata per questo account. Seleziona il secondo modo per verificare la tua identit\xe0.",
    add_authenticator_app: "Aggiungi app di autenticazione",
    step: "Passo {{step, number}}: {{content}}",
    scan_qr_code: "Scansiona questo codice QR",
    scan_qr_code_description: "Scansiona il seguente codice QR con la tua app di autenticazione, come Google Authenticator, Duo Mobile, Authy, ecc.",
    qr_code_not_available: "Non \xe8 possibile scansionare il codice QR?",
    copy_and_paste_key: "Copia e incolla la chiave",
    copy_and_paste_key_description: "Copia e incolla la seguente chiave nella tua app di autenticazione, come Google Authenticator, Duo Mobile, Authy, ecc.",
    want_to_scan_qr_code: "Vuoi scansionare il codice QR?",
    enter_one_time_code: "Inserisci il codice monouso",
    enter_one_time_code_link_description: "Inserisci il codice di verifica a 6 cifre generato dall'app di autenticazione.",
    enter_one_time_code_description: "La verifica in due passaggi \xe8 stata abilitata per questo account. Inserisci il codice monouso mostrato sulla tua app di autenticazione collegata.",
    link_another_mfa_factor: "Passa a un altro metodo",
    save_backup_code: "Salva il codice di backup",
    save_backup_code_description: "Puoi utilizzare uno di questi codici di backup per accedere al tuo account in caso di problemi durante la verifica in due passaggi in altri modi. Ogni codice pu\xf2 essere utilizzato solo una volta.",
    backup_code_hint: "Assicurati di copiarli e salvarli in un luogo sicuro.",
    enter_a_backup_code: "Inserisci un codice di backup",
    enter_backup_code_description: "Inserisci il codice di backup salvato quando \xe8 stata abilitata la verifica in due passaggi.",
    create_a_passkey: "Crea una chiave di accesso",
    create_passkey_description: "Registra la tua chiave di accesso utilizzando le biometrie del dispositivo, le chiavi di sicurezza (ad esempio, YubiKey) o altri metodi disponibili.",
    try_another_verification_method: "Prova un altro metodo di verifica",
    verify_via_passkey: "Verifica tramite chiave di accesso",
    verify_via_passkey_description: "Usa la chiave di accesso per verificare tramite la password o le biometrie del tuo dispositivo, la scansione del codice QR o l'uso di una chiave di sicurezza USB come YubiKey.",
    secret_key_copied: "Chiave segreta copiata.",
    backup_code_copied: "Codice di backup copiato.",
    webauthn_not_ready: "WebAuthn non \xe8 ancora pronto. Riprova pi\xf9 tardi.",
    webauthn_not_supported: "WebAuthn non \xe8 supportato in questo browser.",
    webauthn_failed_to_create: "Impossibile creare. Riprova.",
    webauthn_failed_to_verify: "Verifica non riuscita. Riprova."
};
var $9922e1a2ca91f413$export$2e2bcd8739ae039 = Object.freeze($9922e1a2ca91f413$var$mfa);


const $45292fc87c716b21$var$secondary = {
    social_bind_with: "Gi\xe0 un account? Accedi per collegare {{methods, list(type: disjunction;)}} con la tua identit\xe0 sociale."
};
var $45292fc87c716b21$export$2e2bcd8739ae039 = Object.freeze($45292fc87c716b21$var$secondary);


const $8586a6fa13525ba9$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $8586a6fa13525ba9$export$2e2bcd8739ae039 = Object.freeze($8586a6fa13525ba9$var$user_scopes);


const $d32334d00d3454d4$var$it = {
    translation: {
        input: $fab34968a01c542c$export$2e2bcd8739ae039,
        secondary: $45292fc87c716b21$export$2e2bcd8739ae039,
        action: $d47d3f3bbae3084c$export$2e2bcd8739ae039,
        description: $844642d7ab33c2b7$export$2e2bcd8739ae039,
        error: $8a7d0fe99774803f$export$2e2bcd8739ae039,
        list: $2981b9ceaa61452f$export$2e2bcd8739ae039,
        mfa: $9922e1a2ca91f413$export$2e2bcd8739ae039,
        development_tenant: $1adffbaebf76eb53$export$2e2bcd8739ae039,
        user_scopes: $8586a6fa13525ba9$export$2e2bcd8739ae039
    }
};
var $d32334d00d3454d4$export$2e2bcd8739ae039 = Object.freeze($d32334d00d3454d4$var$it);


const $a8cf18f8a5fd750c$var$action = {
    sign_in: "サインイン",
    continue: "続ける",
    create_account: "アカウントを作成する",
    create_account_without_linking: "リンクなしでアカウントを作成する",
    create: "作成する",
    enter_passcode: "認証コードを入力してください",
    confirm: "確認する",
    cancel: "キャンセル",
    save_password: "パスワードを保存する",
    bind: "{{address}} とリンクする",
    bind_and_continue: "リンクして続行する",
    back: "戻る",
    nav_back: "戻る",
    nav_skip: "スキップ",
    agree: "同意する",
    got_it: "わかりました",
    sign_in_with: "{{name}} で続ける",
    forgot_password: "パスワードを忘れましたか？",
    switch_to: "{{method}} に切り替える",
    sign_in_via_passcode: "認証コードでサインインする",
    sign_in_via_password: "パスワードでサインインする",
    change: "{{method}} を変更する",
    link_another_email: "別のメールアドレスをリンクする",
    link_another_phone: "別の電話番号をリンクする",
    link_another_email_or_phone: "別のメールアドレスまたは電話番号をリンクする",
    show_password: "パスワードを表示する",
    copy: "コピー",
    verify_via_passkey: "パスキー経由で確認",
    download: "ダウンロード",
    single_sign_on: "シングルサインオン",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $a8cf18f8a5fd750c$export$2e2bcd8739ae039 = Object.freeze($a8cf18f8a5fd750c$var$action);


const $51793d7df4dde012$var$description = {
    email: "メールアドレス",
    phone_number: "電話番号",
    username: "ユーザー名",
    reminder: "リマインダー",
    not_found: "404 Not Found",
    agree_with_terms: "以下に同意することを確認しました：",
    agree_with_terms_modal: "続行するには、<link></link>に同意してください。",
    terms_of_use: "利用規約",
    sign_in: "サインイン",
    privacy_policy: "プライバシーポリシー",
    create_account: "アカウントを作成する",
    or: "または",
    and: "及び",
    enter_passcode: "確認コードが{{address}} {{target}}に送信されました",
    passcode_sent: "確認コードを再送します",
    resend_after_seconds: "<span>{{seconds}}</span>秒後に再送信",
    resend_passcode: "確認コードを再送信します",
    create_account_id_exists: "{{type}} {{value}}でアカウントが既に存在しています。ログインしますか？",
    link_account_id_exists: "{{type}} {{value}}でアカウントが既に存在しています。リンクしますか？",
    sign_in_id_does_not_exist: "{{type}} {{value}}のアカウントは存在しません。新しいアカウントを作成しますか？",
    sign_in_id_does_not_exist_alert: "{{type}} {{value}}のアカウントは存在しません。",
    create_account_id_exists_alert: "{{type}} {{value}}は他のアカウントにリンクされています。他の{{type}}を試してください。",
    social_identity_exist: "{{type}} {{value}}は他のアカウントにリンクされています。他の{{type}}を試してください。",
    bind_account_title: "アカウントのリンクまたは作成",
    social_create_account: "新しいアカウントを作成できます。",
    social_link_email: "別のメールアドレスをリンクできます。",
    social_link_phone: "他の電話番号にリンクできます。",
    social_link_email_or_phone: "他のメールアドレスまたは電話番号にリンクできます。",
    social_bind_with_existing: "関連するアカウントが見つかりました。それを直接リンクできます。",
    reset_password: "パスワードを再設定する",
    reset_password_description: "アカウントに関連する{{types, list(type: disjunction;)}}を入力すると、パスワードの再設定に必要な確認コードが送信されます。",
    new_password: "新しいパスワード",
    set_password: "パスワードを設定する",
    password_changed: "パスワードが変更されました",
    no_account: "アカウントを作成していませんか？",
    have_account: "すでにアカウントをお持ちですか？",
    enter_password: "パスワードを入力する",
    enter_password_for: "{{method}} {{value}}でパスワードでサインインする",
    enter_username: "ユーザー名を入力する",
    enter_username_description: "ユーザー名はサインインの代替手段です。ユーザー名には、文字、数字、アンダースコアのみを含める必要があります。",
    link_email: "メールアドレスをリンクする",
    link_phone: "電話番号をリンクする",
    link_email_or_phone: "メールアドレスまたは電話番号をリンクする",
    link_email_description: "セキュリティを高めるために、アカウントにメールアドレスをリンクしてください。",
    link_phone_description: "セキュリティを高めるために、アカウントに電話番号をリンクしてください。",
    link_email_or_phone_description: "セキュリティを高めるために、アカウントに別のメールアドレスまたは電話番号をリンクしてください。",
    continue_with_more_information: "以下にアカウントの詳細を入力して、セキュリティを高めてください。",
    create_your_account: "アカウントを作成する",
    sign_in_to_your_account: "アカウントにサインインする",
    no_region_code_found: "地域コードが見つかりません",
    verify_email: "Eメールを確認する",
    verify_phone: "電話番号を確認する",
    password_requirements: "パスワード {{items, list}}。",
    password_requirement: {
        length_one: "最低 {{count}} 文字",
        length_other: "最低 {{count}} 文字",
        character_types_one: "大文字、小文字、数字、記号のうち {{count}} 種類を含む必要があります",
        character_types_other: "大文字、小文字、数字、記号のうち {{count}} 種類を含む必要があります"
    },
    use: "使用する",
    single_sign_on_email_form: "企業のメールアドレスを入力してください",
    single_sign_on_connectors_list: "あなたの企業は、メールアカウント{{email}}に対してシングルサインオンを有効にしました。以下のSSOプロバイダーを使用してサインインを続けることができます。",
    single_sign_on_enabled: "このアカウントではシングル サインオンが有効になっています",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ authorize_personal_data_usage: "Authorize the use of your personal data:",
    /** UNTRANSLATED */ authorize_organization_access: "Authorize access to the specific organization:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: `By authorizing the access, you agree to the {{name}}'s <link></link>.`,
    /** UNTRANSLATED */ authorize_agreement_with_redirect: `By authorizing the access, you agree to the {{name}}'s <link></link>, and will be redirected to {{uri}}.`,
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $51793d7df4dde012$export$2e2bcd8739ae039 = Object.freeze($51793d7df4dde012$var$description);


const $4f03e44d910da10c$var$development_tenant = {
    notification: "開発モードです"
};
var $4f03e44d910da10c$export$2e2bcd8739ae039 = Object.freeze($4f03e44d910da10c$var$development_tenant);


const $de84ca662a57f330$var$password_rejected = {
    too_short: "最小の長さは{{min}}です。",
    too_long: "最大の長さは{{max}}です。",
    character_types: "少なくとも{{min}}種類の文字が必要です。",
    unsupported_characters: "サポートされていない文字が見つかりました。",
    pwned: "簡単に推測できる簡単なパスワードの使用を避けてください。",
    restricted_found: "{{list, list}}の過度な使用を避けてください。",
    restricted: {
        repetition: "繰り返された文字",
        sequence: "連続する文字",
        user_info: "個人情報",
        words: "製品のコンテキスト"
    }
};
var $de84ca662a57f330$export$2e2bcd8739ae039 = Object.freeze($de84ca662a57f330$var$password_rejected);


const $a345c2cbdef39d0e$var$error = {
    general_required: `{{types, list(type: disjunction;)}}が必要です`,
    general_invalid: `{{types, list(type: disjunction;)}}が無効です`,
    username_required: "ユーザー名が必要です",
    password_required: "パスワードが必要です",
    username_exists: "ユーザー名が既に存在しています",
    username_should_not_start_with_number: "ユーザー名は数字で始めることはできません",
    username_invalid_charset: "ユーザー名は文字、数字、またはアンダースコアのみを含める必要があります。",
    invalid_email: "メールアドレスが無効です",
    invalid_phone: "電話番号が無効です",
    passwords_do_not_match: "パスワードが一致しません。もう一度お試しください。",
    invalid_passcode: "検証コードが無効です",
    invalid_connector_auth: "認証が無効です",
    invalid_connector_request: "コネクターデータが無効です",
    unknown: "不明なエラーが発生しました。後でもう一度お試しください。",
    invalid_session: "セッションが見つかりません。もう一度サインインしてください。",
    timeout: "リクエストタイムアウト。後でもう一度お試しください。",
    password_rejected: $de84ca662a57f330$export$2e2bcd8739ae039,
    sso_not_enabled: "このメールアカウントではシングルサインオンが有効になっていません。"
};
var $a345c2cbdef39d0e$export$2e2bcd8739ae039 = Object.freeze($a345c2cbdef39d0e$var$error);


const $c1ef34daab3f2a93$var$input = {
    username: "ユーザー名",
    password: "パスワード",
    email: "メールアドレス",
    phone_number: "電話番号",
    confirm_password: "パスワード確認",
    search_region_code: "地域コード検索",
    backup_code: "バックアップコード"
};
var $c1ef34daab3f2a93$export$2e2bcd8739ae039 = Object.freeze($c1ef34daab3f2a93$var$input);


const $a32cd16e365eae55$var$list = {
    or: "または",
    and: "そして",
    separator: ","
};
var $a32cd16e365eae55$export$2e2bcd8739ae039 = Object.freeze($a32cd16e365eae55$var$list);


const $39b79dd6b3458da2$var$mfa = {
    totp: "認証アプリOTP",
    webauthn: "パスキー",
    backup_code: "バックアップコード",
    link_totp_description: "例：Google Authenticator など",
    link_webauthn_description: "デバイスまたはUSBハードウェアをリンク",
    link_backup_code_description: "バックアップコードを生成",
    verify_totp_description: "アプリに表示されるワンタイムコードを入力",
    verify_webauthn_description: "デバイスまたはUSBハードウェアを確認",
    verify_backup_code_description: "保存したバックアップコードを貼り付け",
    add_mfa_factors: "2段階認証を追加",
    add_mfa_description: "2段階認証が有効になっています。安全なサインインのために第二の認証方法を選択してください。",
    verify_mfa_factors: "2段階認証",
    verify_mfa_description: "このアカウントでは2段階認証が有効になっています。アイデンティティを確認するための第二の方法を選択してください。",
    add_authenticator_app: "認証アプリを追加",
    step: "ステップ{{step, number}}：{{content}}",
    scan_qr_code: "このQRコードをスキャン",
    scan_qr_code_description: "次のQRコードを認証アプリ（例：Google Authenticator、Duo Mobile、Authyなど）でスキャンしてください。",
    qr_code_not_available: "QRコードをスキャンできませんか？",
    copy_and_paste_key: "キーをコピーして貼り付ける",
    copy_and_paste_key_description: "次のキーを認証アプリ（例：Google Authenticator、Duo Mobile、Authyなど）にコピーして貼り付けてください。",
    want_to_scan_qr_code: "QRコードをスキャンしますか？",
    enter_one_time_code: "ワンタイムコードを入力",
    enter_one_time_code_link_description: "認証アプリで生成された6桁の確認コードを入力してください。",
    enter_one_time_code_description: "このアカウントでは2段階認証が有効になっています。リンクされた認証アプリに表示されるワンタイムコードを入力してください。",
    link_another_mfa_factor: "別の方法に切り替える",
    save_backup_code: "バックアップコードを保存",
    save_backup_code_description: "2段階認証中に他の方法で問題が発生した場合、これらのバックアップコードのいずれかを使用してアカウントにアクセスできます。各コードは一度だけ使用できます。",
    backup_code_hint: "必ずコピーして安全な場所に保存してください。",
    enter_a_backup_code: "バックアップコードを入力",
    enter_backup_code_description: "初めて2段階認証が有効になったときに保存したバックアップコードを入力してください。",
    create_a_passkey: "パスキーを作成",
    create_passkey_description: "デバイスの生体認証、セキュリティキー（例：YubiKey）などを使用してパスキーを登録します。",
    try_another_verification_method: "別の検証方法を試す",
    verify_via_passkey: "パスキーで確認",
    verify_via_passkey_description: "デバイスのパスワードまたは生体認証、QRコードのスキャン、YubiKeyなどのUSBセキュリティキーを使用してパスキーで確認します。",
    secret_key_copied: "秘密鍵がコピーされました。",
    backup_code_copied: "バックアップコードがコピーされました。",
    webauthn_not_ready: "WebAuthnはまだ準備ができていません。後でもう一度試してください。",
    webauthn_not_supported: "このブラウザではWebAuthnはサポートされていません。",
    webauthn_failed_to_create: "作成に失敗しました。もう一度試してください。",
    webauthn_failed_to_verify: "確認に失敗しました。もう一度試してください。"
};
var $39b79dd6b3458da2$export$2e2bcd8739ae039 = Object.freeze($39b79dd6b3458da2$var$mfa);


const $2fd5896698871069$var$secondary = {
    social_bind_with: "既にアカウントを持っていますか？{{methods, list(type: disjunction;)}}をソーシャルアイデンティティにリンクするためにサインインしてください。"
};
var $2fd5896698871069$export$2e2bcd8739ae039 = Object.freeze($2fd5896698871069$var$secondary);


const $dcbc77aa12f77961$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $dcbc77aa12f77961$export$2e2bcd8739ae039 = Object.freeze($dcbc77aa12f77961$var$user_scopes);


const $03378f07cb499b7e$var$ja = {
    translation: {
        input: $c1ef34daab3f2a93$export$2e2bcd8739ae039,
        secondary: $2fd5896698871069$export$2e2bcd8739ae039,
        action: $a8cf18f8a5fd750c$export$2e2bcd8739ae039,
        description: $51793d7df4dde012$export$2e2bcd8739ae039,
        error: $a345c2cbdef39d0e$export$2e2bcd8739ae039,
        list: $a32cd16e365eae55$export$2e2bcd8739ae039,
        mfa: $39b79dd6b3458da2$export$2e2bcd8739ae039,
        development_tenant: $4f03e44d910da10c$export$2e2bcd8739ae039,
        user_scopes: $dcbc77aa12f77961$export$2e2bcd8739ae039
    }
};
var $03378f07cb499b7e$export$2e2bcd8739ae039 = Object.freeze($03378f07cb499b7e$var$ja);


const $c884039071e414b5$var$action = {
    sign_in: "로그인",
    continue: "계속",
    create_account: "계정 생성",
    create_account_without_linking: "연동 없이 계정 생성하기",
    create: "생성",
    enter_passcode: "비밀번호 입력",
    confirm: "확인",
    cancel: "취소",
    save_password: "저장",
    bind: "{{address}}로 연동",
    bind_and_continue: "연동하고 계속하기",
    back: "뒤로 가기",
    nav_back: "뒤로",
    nav_skip: "건너뛰기",
    agree: "동의",
    got_it: "알겠습니다",
    sign_in_with: "{{name}} 계속",
    forgot_password: "비밀번호를 잊어버리셨나요?",
    switch_to: "{{method}}로 전환",
    sign_in_via_passcode: "인증번호로 로그인",
    sign_in_via_password: "비밀번호로 로그인",
    change: "변경 {{method}}",
    link_another_email: "다른 이메일 연동",
    link_another_phone: "다른 전화번호 연동",
    link_another_email_or_phone: "다른 이메일 또는 전화번호 연동",
    show_password: "비밀번호 보기",
    copy: "복사",
    verify_via_passkey: "패스키로 확인",
    download: "다운로드",
    single_sign_on: "단일 로그인",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $c884039071e414b5$export$2e2bcd8739ae039 = Object.freeze($c884039071e414b5$var$action);


const $0ec939b7df893aca$var$description = {
    email: "이메일",
    phone_number: "휴대전화번호",
    username: "사용자 이름",
    reminder: "리마인더",
    not_found: "404 찾을 수 없음",
    agree_with_terms: "나는 내용을 읽었으며, 이에 동의합니다.",
    agree_with_terms_modal: "진행하기 위해서는, 다음을 동의해주세요 <link></link>.",
    terms_of_use: "이용약관",
    sign_in: "로그인",
    privacy_policy: "개인정보처리방침",
    create_account: "계정 생성",
    or: "또는",
    and: "그리고",
    enter_passcode: "{{address}} {{target}} 으로 비밀번호가 전송되었어요.",
    passcode_sent: "비밀번호가 재전송되었어요.",
    resend_after_seconds: "<span>{{seconds}}</span> 초 후에 재전송",
    resend_passcode: "비밀번호 재전송",
    create_account_id_exists: "{{type}} {{value}} 계정은 다른 계정과 연결되어 있습니다. 다른 {{type}}을(를) 시도해주세요.",
    link_account_id_exists: "{{type}} {{value}}와/과 연동된 계정이 이미 존재해요. 연동할까요?",
    sign_in_id_does_not_exist: "{type}} {{value}} 계정이 존재하지 않아요. 새로 만드시겠어요?",
    sign_in_id_does_not_exist_alert: "{{type}} {{value}} 계정이 존재하지 않아요.",
    create_account_id_exists_alert: "{{type}} {{value}} 이미 존재해요.",
    social_identity_exist: "{{type}} {{value}}이/가 다른 계정과 연동되어 있어요. 다른 {{type}}을/를 시도해 보세요.",
    bind_account_title: "계정 만들거나 연동하기",
    social_create_account: "새로운 계정을 만들 수 있습니다.",
    social_link_email: "다른 이메일을 연동할 수 있어요",
    social_link_phone: "다른 휴대전화를 연동할 수 있어요",
    social_link_email_or_phone: "다른 이메일이나 휴대전화를 연동할 수 있어요",
    social_bind_with_existing: "관련된 계정을 찾았어요. 직접 연동할 수 있어요.",
    reset_password: "비밀번호를 잊으셨나요",
    reset_password_description: "귀하의 계정과 연결된 {{types, list(type: disjunction;)}}를 입력하면 비밀번호 재설정을 위한 인증 코드를 보내드립니다.",
    new_password: "새 비밀번호",
    set_password: "비밀번호 설정",
    password_changed: "비밀번호 변경됨",
    no_account: "계정이 없나요?",
    have_account: "이미 계정이 있나요?",
    enter_password: "비밀번호 입력",
    enter_password_for: "{{method}} {{value}} 비밀번호 로그인",
    enter_username: "사용자 이름 설정하기",
    enter_username_description: "사용자 이름은 로그인을 할 때 사용되요. 사용자 이름에는 문자, 숫자 및 밑줄만 포함되어야 해요.",
    link_email: "이메일 연동",
    link_phone: "휴대전화번호 연동",
    link_email_or_phone: "이메일 또는 휴대전화번호 연동",
    link_email_description: "더 나은 보안을 위해 이메일을 연동해 주세요.",
    link_phone_description: "더 나은 보안을 위해 휴대전화번호를 연동해 주세요.",
    link_email_or_phone_description: "더 나은 보안을 위해 이메일 또는 휴대전화번호를 연동해 주세요.",
    continue_with_more_information: "더 나은 보안을 위해 아래 자세한 내용을 따라 주세요.",
    create_your_account: "계정 생성하기",
    sign_in_to_your_account: "계정에 로그인하세요",
    no_region_code_found: "지역 코드를 찾을 수 없습니다.",
    verify_email: "이메일 인증",
    verify_phone: "휴대전화번호 인증",
    password_requirements: "비밀번호는 {{items, list}} 로 이루어져야 합니다.",
    password_requirement: {
        length_one: "최소 {{count}} 자 이상이어야 함",
        length_other: "최소 {{count}} 문자 이상이어야 함",
        character_types_one: "최소 {{count}} 개의 대문자, 소문자, 숫자, 특수 기호를 포함해야 함",
        character_types_other: "최소 {{count}} 개의 대문자, 소문자, 숫자, 특수 기호를 포함해야 함"
    },
    use: "사용",
    single_sign_on_email_form: "기업 이메일 주소를 입력하세요",
    single_sign_on_connectors_list: "귀하의 기업은 {{email}} 이메일 계정에 대해 Single Sign-On을 활성화했습니다. 다음 SSO 제공업체를 사용하여 로그인을 계속할 수 있습니다.",
    single_sign_on_enabled: "이 계정에는 Single Sign-On이 활성화되어 있습니다.",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ authorize_personal_data_usage: "Authorize the use of your personal data:",
    /** UNTRANSLATED */ authorize_organization_access: "Authorize access to the specific organization:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: `By authorizing the access, you agree to the {{name}}'s <link></link>.`,
    /** UNTRANSLATED */ authorize_agreement_with_redirect: `By authorizing the access, you agree to the {{name}}'s <link></link>, and will be redirected to {{uri}}.`,
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $0ec939b7df893aca$export$2e2bcd8739ae039 = Object.freeze($0ec939b7df893aca$var$description);


const $bbb2a67b8a0260ab$var$development_tenant = {
    notification: "개발 모드입니다"
};
var $bbb2a67b8a0260ab$export$2e2bcd8739ae039 = Object.freeze($bbb2a67b8a0260ab$var$development_tenant);


const $175bc4c4f17be309$var$password_rejected = {
    too_short: "최소 길이는 {{min}}입니다.",
    too_long: "최대 길이는 {{max}}입니다.",
    character_types: "최소 {{min}}개의 문자 유형이 필요합니다.",
    unsupported_characters: "지원되지 않는 문자가 발견되었습니다.",
    pwned: "추측하기 쉬운 간단한 암호 사용을 피하십시오.",
    restricted_found: "{{list, list}}을(를) 과도하게 사용하지 마십시오.",
    restricted: {
        repetition: "반복된 문자",
        sequence: "연속된 문자",
        user_info: "개인 정보",
        words: "품질 가능성"
    }
};
var $175bc4c4f17be309$export$2e2bcd8739ae039 = Object.freeze($175bc4c4f17be309$var$password_rejected);


const $355f4bc171b13be9$var$error = {
    general_required: "{{types, list(type: disjunction;)}}은/는 필수예요.",
    general_invalid: "{{types, list(type: disjunction;)}}은/는 유효하지 않아요.",
    username_required: "사용자 이름은 필수예요.",
    password_required: "비밀번호는 필수예요.",
    username_exists: "사용자 이름이 이미 존재해요.",
    username_should_not_start_with_number: "사용자 이름은 숫자로 시작하면 안 돼요.",
    username_invalid_charset: "사용자 이름은 문자, 숫자, _(밑줄 문자) 로만 이루어져야 해요.",
    invalid_email: "이메일이 유효하지 않아요.",
    invalid_phone: "휴대전화번호가 유효하지 않아요.",
    passwords_do_not_match: "비밀번호가 일치하지 않아요.",
    invalid_passcode: "비밀번호가 유효하지 않아요.",
    invalid_connector_auth: "인증이 유효하지 않아요.",
    invalid_connector_request: "연동 정보가 유효하지 않아요.",
    unknown: "알 수 없는 오류가 발생했어요. 잠시 후에 시도해 주세요.",
    invalid_session: "세션을 찾을 수 없어요. 다시 로그인해 주세요.",
    timeout: "요청 시간이 초과되었어요. 잠시 후에 다시 시도해 주세요.",
    password_rejected: $175bc4c4f17be309$export$2e2bcd8739ae039,
    sso_not_enabled: "이 이메일 계정에 대해 단일 로그인이 활성화되지 않았어요."
};
var $355f4bc171b13be9$export$2e2bcd8739ae039 = Object.freeze($355f4bc171b13be9$var$error);


const $a8af0e54419823cc$var$input = {
    username: "사용자 이름",
    password: "비밀번호",
    email: "이메일",
    phone_number: "휴대전화번호",
    confirm_password: "비밀번호 확인",
    search_region_code: "지역 코드 검색",
    backup_code: "백업 코드"
};
var $a8af0e54419823cc$export$2e2bcd8739ae039 = Object.freeze($a8af0e54419823cc$var$input);


const $859a901f8a17c395$var$list = {
    or: "또는",
    and: "및",
    separator: ","
};
var $859a901f8a17c395$export$2e2bcd8739ae039 = Object.freeze($859a901f8a17c395$var$list);


const $d321d64a38606ccf$var$mfa = {
    totp: "인증 앱 OTP",
    webauthn: "패스키",
    backup_code: "백업 코드",
    link_totp_description: "예: Google Authenticator 등",
    link_webauthn_description: "기기 또는 USB 하드웨어 연결",
    link_backup_code_description: "백업 코드 생성",
    verify_totp_description: "앱에 일회용 코드 입력",
    verify_webauthn_description: "기기 또는 USB 하드웨어 확인",
    verify_backup_code_description: "저장한 백업 코드 붙여넣기",
    add_mfa_factors: "2단계 인증 추가",
    add_mfa_description: "2단계 인증이 활성화되었습니다. 안전한 로그인을 위해 두 번째 인증 방법을 선택하세요.",
    verify_mfa_factors: "2단계 인증 확인",
    verify_mfa_description: "이 계정에 대해 2단계 인증이 활성화되었습니다. 신원을 확인하는 두 번째 방법을 선택하세요.",
    add_authenticator_app: "인증 앱 추가",
    step: "단계 {{step, number}}: {{content}}",
    scan_qr_code: "이 QR 코드 스캔",
    scan_qr_code_description: "Google Authenticator, Duo Mobile, Authy 등의 인증 앱으로 다음 QR 코드를 스캔하세요.",
    qr_code_not_available: "QR 코드를 스캔할 수 없나요?",
    copy_and_paste_key: "키 복사 및 붙여넣기",
    copy_and_paste_key_description: "다음 키를 Google Authenticator, Duo Mobile, Authy 등의 인증 앱에 복사하여 붙여넣으세요.",
    want_to_scan_qr_code: "QR 코드를 스캔하고 싶나요?",
    enter_one_time_code: "일회용 코드 입력",
    enter_one_time_code_link_description: "인증 앱에서 생성된 6자리 확인 코드를 입력하세요.",
    enter_one_time_code_description: "이 계정에서는 2단계 인증이 활성화되었습니다. 연결된 인증 앱에 표시된 일회용 코드를 입력하세요.",
    link_another_mfa_factor: "다른 방법으로 전환",
    save_backup_code: "백업 코드 저장",
    save_backup_code_description: "다른 방법으로 2단계 인증 중 문제가 발생하면 이러한 백업 코드 중 하나를 사용하여 계정에 액세스할 수 있습니다. 각 코드는 한 번만 사용할 수 있습니다.",
    backup_code_hint: "반드시 복사하고 안전한 곳에 저장하세요.",
    enter_a_backup_code: "백업 코드 입력",
    enter_backup_code_description: "2단계 인증이 초기에 활성화될 때 저장한 백업 코드를 입력하세요.",
    create_a_passkey: "패스키 생성",
    create_passkey_description: "기기 바이오메트릭스, 보안 키(예: YubiKey) 또는 기타 사용 가능한 방법을 사용하여 패스키를 등록하세요.",
    try_another_verification_method: "다른 방법으로 확인해보세요",
    verify_via_passkey: "패스키로 확인",
    verify_via_passkey_description: "디바이스 비밀번호 또는 바이오메트릭스, QR 코드 스캔 또는 YubiKey와 같은 USB 보안 키 사용하여 패스키로 확인하세요.",
    secret_key_copied: "비밀 키가 복사되었습니다.",
    backup_code_copied: "백업 코드가 복사되었습니다.",
    webauthn_not_ready: "WebAuthn이 아직 준비되지 않았습니다. 나중에 다시 시도하세요.",
    webauthn_not_supported: "이 브라우저에서는 WebAuthn이 지원되지 않습니다.",
    webauthn_failed_to_create: "생성 실패. 다시 시도하세요.",
    webauthn_failed_to_verify: "확인 실패. 다시 시도하세요."
};
var $d321d64a38606ccf$export$2e2bcd8739ae039 = Object.freeze($d321d64a38606ccf$var$mfa);


const $828286ba28074792$var$secondary = {
    social_bind_with: "이미 계정이 있으신가요? {{methods, list(type: disjunction;)}}로 로그인 해보세요!"
};
var $828286ba28074792$export$2e2bcd8739ae039 = Object.freeze($828286ba28074792$var$secondary);


const $6e56bd3f1e9829d1$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $6e56bd3f1e9829d1$export$2e2bcd8739ae039 = Object.freeze($6e56bd3f1e9829d1$var$user_scopes);


const $4190c12a9fcb9924$var$ko = {
    translation: {
        input: $a8af0e54419823cc$export$2e2bcd8739ae039,
        secondary: $828286ba28074792$export$2e2bcd8739ae039,
        action: $c884039071e414b5$export$2e2bcd8739ae039,
        description: $0ec939b7df893aca$export$2e2bcd8739ae039,
        error: $355f4bc171b13be9$export$2e2bcd8739ae039,
        list: $859a901f8a17c395$export$2e2bcd8739ae039,
        mfa: $d321d64a38606ccf$export$2e2bcd8739ae039,
        development_tenant: $bbb2a67b8a0260ab$export$2e2bcd8739ae039,
        user_scopes: $6e56bd3f1e9829d1$export$2e2bcd8739ae039
    }
};
var $4190c12a9fcb9924$export$2e2bcd8739ae039 = Object.freeze($4190c12a9fcb9924$var$ko);


const $d3f45b9d8ad90d66$var$action = {
    sign_in: "Zaloguj się",
    continue: "Kontynuuj",
    create_account: "Utw\xf3rz konto",
    create_account_without_linking: "Utw\xf3rz konto bez łączenia",
    create: "Utw\xf3rz",
    enter_passcode: "Wprowadź kod weryfikacyjny",
    confirm: "Potwierdź",
    cancel: "Anuluj",
    save_password: "Zapisz hasło",
    bind: "Połącz z {{address}}",
    bind_and_continue: "Połącz i kontynuuj",
    back: "Wr\xf3ć",
    nav_back: "Wstecz",
    nav_skip: "Pomiń",
    agree: "Zgadzam się",
    got_it: "Zrozumiałem",
    sign_in_with: "Kontynuuj z {{name}}",
    forgot_password: "Zapomniałeś hasła?",
    switch_to: "Przełącz na {{method}}",
    sign_in_via_passcode: "Zaloguj się za pomocą kodu weryfikacyjnego",
    sign_in_via_password: "Zaloguj się za pomocą hasła",
    change: "Zmień {{method}}",
    link_another_email: "Połącz inne konto email",
    link_another_phone: "Połącz inne konto telefoniczne",
    link_another_email_or_phone: "Połącz inne konto email lub telefoniczne",
    show_password: "Pokaż hasło",
    copy: "Kopiuj",
    verify_via_passkey: "Weryfikacja za pomocą klucza dostępu",
    download: "Pobierz",
    single_sign_on: "Pojedyncze logowanie",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $d3f45b9d8ad90d66$export$2e2bcd8739ae039 = Object.freeze($d3f45b9d8ad90d66$var$action);


const $ec9c16a0f8004997$var$description = {
    email: "adres email",
    phone_number: "numer telefonu",
    username: "nazwa użytkownika",
    reminder: "Przypomnienie",
    not_found: "404 Nie znaleziono",
    agree_with_terms: "Przeczytałem/am i zgadzam się z ",
    agree_with_terms_modal: "Do kontynuacji należy zaakceptować <link></link>.",
    terms_of_use: "Warunki korzystania",
    sign_in: "Zaloguj się",
    privacy_policy: "Polityka prywatności",
    create_account: "Utw\xf3rz konto",
    or: "lub",
    and: "i",
    enter_passcode: "Kod weryfikacyjny został wysłany na twoje {{address}} {{target}}",
    passcode_sent: "Kod weryfikacyjny został wysłany ponownie",
    resend_after_seconds: "Wyślij ponownie po <span>{{seconds}}</span> sekundach",
    resend_passcode: "Wyślij kod weryfikacyjny ponownie",
    create_account_id_exists: "Konto z {{type}} {{value}} już istnieje. Czy chcesz się zalogować?",
    link_account_id_exists: "Konto z {{type}} {{value}} już istnieje. Czy chcesz je połączyć?",
    sign_in_id_does_not_exist: "Konto z {{type}} {{value}} nie istnieje. Czy chcesz utworzyć nowe konto?",
    sign_in_id_does_not_exist_alert: "Konto z {{type}} {{value}} nie istnieje.",
    create_account_id_exists_alert: "Konto z {{type}} {{value}} jest połączone z innym kontem. Spr\xf3buj inny {{type}}.",
    social_identity_exist: "{{type}} {{value}} jest połączony z innym kontem. Spr\xf3buj inny {{type}}.",
    bind_account_title: "Połącz lub utw\xf3rz konto",
    social_create_account: "Możesz utworzyć nowe konto.",
    social_link_email: "Możesz połączyć kolejny adres email",
    social_link_phone: "Możesz połączyć kolejny numer telefonu",
    social_link_email_or_phone: "Możesz połączyć kolejny adres email lub numer telefonu",
    social_bind_with_existing: "Znaleźliśmy powiązane konto, możesz je połączyć bezpośrednio.",
    reset_password: "Zresetuj hasło",
    reset_password_description: "Wpisz {{types, lista(type: złączonych;)}} związanego z twoim kontem, a wyślemy ci kod weryfikacyjny do zresetowania hasła.",
    new_password: "Nowe hasło",
    set_password: "Ustaw hasło",
    password_changed: "Hasło zmienione",
    no_account: "Nie masz jeszcze konta? ",
    have_account: "Masz już konto?",
    enter_password: "Wpisz hasło",
    enter_password_for: "Zaloguj się przy użyciu hasła do {{method}} {{value}}",
    enter_username: "Ustaw nazwę użytkownika",
    enter_username_description: "Nazwa użytkownika jest alternatywną formą logowania. Nazwa użytkownika powinna zawierać tylko litery, cyfry i podkreślenia.",
    link_email: "Połącz adres email",
    link_phone: "Połącz numer telefonu",
    link_email_or_phone: "Połącz adres email lub numer telefonu",
    link_email_description: "Dla zwiększenia bezpieczeństwa, proszę połączyć konto z adresem e-mail.",
    link_phone_description: "Dla zwiększenia bezpieczeństwa, proszę połączyć konto z numerem telefonu.",
    link_email_or_phone_description: "Dla zwiększenia bezpieczeństwa, proszę połączyć konto z adresem e-mail lub numerem telefonu.",
    continue_with_more_information: "Dla zwiększenia bezpieczeństwa, proszę uzupełnić poniższe informacje o koncie.",
    create_your_account: "Utw\xf3rz konto",
    sign_in_to_your_account: "Zaloguj się do swojego konta",
    no_region_code_found: "Nie znaleziono kodu regionu",
    verify_email: "Potwierdź sw\xf3j email",
    verify_phone: "Potwierdź sw\xf3j numer telefonu",
    password_requirements: "Wymagania dotyczące hasła {{items, list}}.",
    password_requirement: {
        length_one: "wymaga co najmniej {{count}} znaku",
        length_other: "wymaga co najmniej {{count}} znak\xf3w",
        character_types_one: "powinno zawierać co najmniej {{count}} rodzaj liter wielkich, małych liter, cyfr i symboli",
        character_types_other: "powinno zawierać co najmniej {{count}} rodzaje liter wielkich, małych liter, cyfr i symboli"
    },
    use: "Użyj",
    single_sign_on_email_form: "Wpisz sw\xf3j służbowy adres email",
    single_sign_on_connectors_list: "Twoja firma włączyła jednokrotne logowanie dla konta e-mail {{email}}. Możesz kontynuować logowanie za pomocą następujących dostawc\xf3w SSO.",
    single_sign_on_enabled: "To konto ma włączone jednokrotne logowanie.",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ authorize_personal_data_usage: "Authorize the use of your personal data:",
    /** UNTRANSLATED */ authorize_organization_access: "Authorize access to the specific organization:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: `By authorizing the access, you agree to the {{name}}'s <link></link>.`,
    /** UNTRANSLATED */ authorize_agreement_with_redirect: `By authorizing the access, you agree to the {{name}}'s <link></link>, and will be redirected to {{uri}}.`,
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $ec9c16a0f8004997$export$2e2bcd8739ae039 = Object.freeze($ec9c16a0f8004997$var$description);


const $a9038acdea583a43$var$development_tenant = {
    notification: "Jesteś w trybie deweloperskim"
};
var $a9038acdea583a43$export$2e2bcd8739ae039 = Object.freeze($a9038acdea583a43$var$development_tenant);


const $697b87dabab38b2f$var$password_rejected = {
    too_short: "Minimalna długość to {{min}}.",
    too_long: "Maksymalna długość to {{max}}.",
    character_types: "Wymagane są przynajmniej {{min}} rodzaje znak\xf3w.",
    unsupported_characters: "Znaleziono niedozwolony znak.",
    pwned: "Unikaj używania prostych haseł, kt\xf3re są łatwe do odgadnięcia.",
    restricted_found: "Unikaj nadużywania {{list, list}}.",
    restricted: {
        repetition: "powtarzających się znak\xf3w",
        sequence: "sekwencyjnych znak\xf3w",
        user_info: "twoich informacji osobistych",
        words: "kontekstu produktu"
    }
};
var $697b87dabab38b2f$export$2e2bcd8739ae039 = Object.freeze($697b87dabab38b2f$var$password_rejected);


const $6a853c91cbd13dcb$var$error = {
    general_required: `{{types, list(type: disjunction;)}} jest wymagany`,
    general_invalid: `{{types, list(type: disjunction;)}} jest nieprawidłowe`,
    username_required: "Nazwa użytkownika jest wymagana",
    password_required: "Hasło jest wymagane",
    username_exists: "Nazwa użytkownika już istnieje",
    username_should_not_start_with_number: "Nazwa użytkownika nie powinna zaczynać się od liczby",
    username_invalid_charset: "Nazwa użytkownika powinna zawierać tylko litery, liczby lub podkreślenia.",
    invalid_email: "Nieprawidłowy adres e-mail",
    invalid_phone: "Nieprawidłowy numer telefonu",
    passwords_do_not_match: "Hasła nie pasują do siebie. Proszę spr\xf3buj ponownie.",
    invalid_passcode: "Nieprawidłowy kod weryfikacyjny",
    invalid_connector_auth: "Nieprawidłowa autoryzacja",
    invalid_connector_request: "Nieprawidłowe dane konektora",
    unknown: "Nieznany błąd. Proszę spr\xf3buj ponownie p\xf3źniej.",
    invalid_session: "Sesja nie znaleziona. Proszę wr\xf3ć i zaloguj się ponownie.",
    timeout: "Czas żądania upłynął. Proszę spr\xf3buj ponownie p\xf3źniej.",
    password_rejected: $697b87dabab38b2f$export$2e2bcd8739ae039,
    sso_not_enabled: "Pojedyncze logowanie nie jest włączony dla tego konta e-mail."
};
var $6a853c91cbd13dcb$export$2e2bcd8739ae039 = Object.freeze($6a853c91cbd13dcb$var$error);


const $4b4db2f77643a5c7$var$input = {
    username: "Nazwa użytkownika",
    password: "Hasło",
    email: "E-mail",
    phone_number: "Numer telefonu",
    confirm_password: "Potwierdź hasło",
    search_region_code: "Kod regionu wyszukiwania",
    backup_code: "Kod kopii zapasowej"
};
var $4b4db2f77643a5c7$export$2e2bcd8739ae039 = Object.freeze($4b4db2f77643a5c7$var$input);


const $6dd78e0c6c2514f3$var$list = {
    or: "lub",
    and: "i",
    separator: ","
};
var $6dd78e0c6c2514f3$export$2e2bcd8739ae039 = Object.freeze($6dd78e0c6c2514f3$var$list);


const $4e7fdd380b1aa1f9$var$mfa = {
    totp: "OTP aplikacji autentykacyjnej",
    webauthn: "Klucz gł\xf3wny",
    backup_code: "Kod zapasowy",
    link_totp_description: "Np. Google Authenticator itp.",
    link_webauthn_description: "Połącz urządzenie lub sprzęt USB",
    link_backup_code_description: "Generuj kod zapasowy",
    verify_totp_description: "Wprowadź jednorazowy kod w aplikacji",
    verify_webauthn_description: "Zweryfikuj urządzenie lub sprzęt USB",
    verify_backup_code_description: "Wklej kod zapasowy, kt\xf3ry zapisałeś",
    add_mfa_factors: "Dodaj weryfikację dwuetapową",
    add_mfa_description: "Weryfikacja dwuetapowa jest włączona. Wybierz sw\xf3j drugi spos\xf3b weryfikacji dla bezpiecznego logowania.",
    verify_mfa_factors: "Weryfikacja dwuetapowa",
    verify_mfa_description: "Włączono weryfikację dwuetapową dla tego konta. Proszę wybrać drugi spos\xf3b weryfikacji swojej tożsamości.",
    add_authenticator_app: "Dodaj aplikację autentykacyjną",
    step: "Krok {{step, number}}: {{content}}",
    scan_qr_code: "Zeskanuj ten kod QR",
    scan_qr_code_description: "Zeskanuj poniższy kod QR za pomocą aplikacji autentykacyjnej, takiej jak Google Authenticator, Duo Mobile, Authy, itp.",
    qr_code_not_available: "Nie można zeskanować kodu QR?",
    copy_and_paste_key: "Skopiuj i wklej klucz",
    copy_and_paste_key_description: "Skopiuj i wklej poniższy klucz do aplikacji autentykacyjnej, takiej jak Google Authenticator, Duo Mobile, Authy, itp.",
    want_to_scan_qr_code: "Chcesz zeskanować kod QR?",
    enter_one_time_code: "Wprowadź jednorazowy kod",
    enter_one_time_code_link_description: "Wprowadź 6-cyfrowy kod weryfikacyjny wygenerowany przez aplikację autentykacyjną.",
    enter_one_time_code_description: "Dla tego konta włączono weryfikację dwuetapową. Proszę wprowadzić jednorazowy kod widoczny w aplikacji autentykacyjnej powiązanej z kontem.",
    link_another_mfa_factor: "Przełącz na inny spos\xf3b",
    save_backup_code: "Zapisz sw\xf3j kod zapasowy",
    save_backup_code_description: "Możesz użyć jednego z tych kod\xf3w zapasowych, aby uzyskać dostęp do swojego konta w przypadku problem\xf3w z weryfikacją dwuetapową w inny spos\xf3b. Każdy kod można użyć tylko raz.",
    backup_code_hint: "Upewnij się, że je skopiujesz i zapiszesz w bezpiecznym miejscu.",
    enter_a_backup_code: "Wprowadź kod zapasowy",
    enter_backup_code_description: "Wprowadź kod zapasowy, kt\xf3ry zapisałeś, gdy włączono weryfikację dwuetapową.",
    create_a_passkey: "Utw\xf3rz klucz dostępu",
    create_passkey_description: "Zarejestruj sw\xf3j klucz dostępu za pomocą biometrii urządzenia, kluczy bezpieczeństwa (np. YubiKey) lub innych dostępnych metod.",
    try_another_verification_method: "Wypr\xf3buj inny spos\xf3b weryfikacji",
    verify_via_passkey: "Zweryfikuj za pomocą klucza dostępu",
    verify_via_passkey_description: "Użyj klucza dostępu do weryfikacji za pomocą hasła urządzenia lub biometrii, skanowania kodu QR lub użycia klucza bezpieczeństwa USB, takiego jak YubiKey.",
    secret_key_copied: "Skopiowano klucz prywatny.",
    backup_code_copied: "Skopiowano kod zapasowy.",
    webauthn_not_ready: "WebAuthn nie jest jeszcze gotowy. Spr\xf3buj ponownie p\xf3źniej.",
    webauthn_not_supported: "WebAuthn nie jest obsługiwane w tej przeglądarce.",
    webauthn_failed_to_create: "Nie udało się utworzyć. Spr\xf3buj ponownie.",
    webauthn_failed_to_verify: "Nie udało się zweryfikować. Spr\xf3buj ponownie."
};
var $4e7fdd380b1aa1f9$export$2e2bcd8739ae039 = Object.freeze($4e7fdd380b1aa1f9$var$mfa);


const $6d1427f2e8dce896$var$secondary = {
    social_bind_with: "Masz już konto? Zaloguj się, aby połączyć {{methods, list(type: disjunction;)}} z twoją tożsamością społeczną."
};
var $6d1427f2e8dce896$export$2e2bcd8739ae039 = Object.freeze($6d1427f2e8dce896$var$secondary);


const $4a319a08f7e00b62$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $4a319a08f7e00b62$export$2e2bcd8739ae039 = Object.freeze($4a319a08f7e00b62$var$user_scopes);


const $a03ab5a56a0372f5$var$pl_pl = {
    translation: {
        input: $4b4db2f77643a5c7$export$2e2bcd8739ae039,
        secondary: $6d1427f2e8dce896$export$2e2bcd8739ae039,
        action: $d3f45b9d8ad90d66$export$2e2bcd8739ae039,
        description: $ec9c16a0f8004997$export$2e2bcd8739ae039,
        error: $6a853c91cbd13dcb$export$2e2bcd8739ae039,
        list: $6dd78e0c6c2514f3$export$2e2bcd8739ae039,
        mfa: $4e7fdd380b1aa1f9$export$2e2bcd8739ae039,
        development_tenant: $a9038acdea583a43$export$2e2bcd8739ae039,
        user_scopes: $4a319a08f7e00b62$export$2e2bcd8739ae039
    }
};
var $a03ab5a56a0372f5$export$2e2bcd8739ae039 = Object.freeze($a03ab5a56a0372f5$var$pl_pl);


const $2a8a1bdef3c7dca5$var$action = {
    sign_in: "Entrar",
    continue: "Continuar",
    create_account: "Criar conta",
    create_account_without_linking: "Criar conta sem vincular",
    create: "Criar",
    enter_passcode: "Inserir c\xf3digo de verifica\xe7\xe3o",
    confirm: "Confirmar",
    cancel: "Cancelar",
    save_password: "Salvar senha",
    bind: "Link com {{address}}",
    bind_and_continue: "Linkar e continuar",
    back: "Voltar",
    nav_back: "Voltar",
    nav_skip: "Pular",
    agree: "Aceito",
    got_it: "Entendido",
    sign_in_with: "Continuar com {{name}}",
    forgot_password: "Esqueceu sua senha?",
    switch_to: "Trocar para {{method}}",
    sign_in_via_passcode: "Fazer login com c\xf3digo de verifica\xe7\xe3o",
    sign_in_via_password: "Fazer login com senha",
    change: "Alterar {{method}}",
    link_another_email: "Vincular outro e-mail",
    link_another_phone: "Vincular outro telefone",
    link_another_email_or_phone: "Vincular outro e-mail ou telefone",
    show_password: "Mostrar senha",
    copy: "Copiar",
    verify_via_passkey: "Verificar via chave de acesso",
    download: "Baixar",
    single_sign_on: "Single Sign-On",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $2a8a1bdef3c7dca5$export$2e2bcd8739ae039 = Object.freeze($2a8a1bdef3c7dca5$var$action);


const $7a616ff7d44f3079$var$description = {
    email: "e-mail",
    phone_number: "n\xfamero de telefone",
    username: "nome de usu\xe1rio",
    reminder: "Lembrete",
    not_found: "404 N\xe3o Encontrado",
    agree_with_terms: "Eu li e concordo com os ",
    agree_with_terms_modal: "Para continuar, por favor, concorde com os <link></link>.",
    terms_of_use: "Termos de uso",
    sign_in: "Entrar",
    privacy_policy: "Pol\xedtica de privacidade",
    create_account: "Criar conta",
    or: "ou",
    and: "e",
    enter_passcode: "O c\xf3digo de verifica\xe7\xe3o foi enviado para o seu {{address}} {{target}}",
    passcode_sent: "O c\xf3digo de verifica\xe7\xe3o foi reenviado",
    resend_after_seconds: "Reenviar depois <span>{{seconds}}</span> segundos",
    resend_passcode: "Reenviar c\xf3digo de verifica\xe7\xe3o",
    create_account_id_exists: "A conta com {{type}} {{value}} j\xe1 existe, gostaria de entrar?",
    link_account_id_exists: "A conta com {{type}} {{value}} j\xe1 existe, gostaria de vincular?",
    sign_in_id_does_not_exist: "A conta com {{type}} {{value}} n\xe3o existe, gostaria de criar uma nova conta?",
    sign_in_id_does_not_exist_alert: "A conta com {{type}} {{value}} n\xe3o existe.",
    create_account_id_exists_alert: "A conta com {{type}} {{value}} est\xe1 vinculada a outra conta. Por favor, tente outro {{type}}.",
    social_identity_exist: "O {{type}} {{value}} est\xe1 vinculado a outra conta. Por favor, tente outro {{type}}.",
    bind_account_title: "Vincular ou criar conta",
    social_create_account: "Voc\xea pode criar uma nova conta.",
    social_link_email: "\xc9 poss\xedvel vincular outro e-mail",
    social_link_phone: "\xc9 poss\xedvel vincular outro telefone",
    social_link_email_or_phone: "\xc9 poss\xedvel vincular outro e-mail ou telefone",
    social_bind_with_existing: "Encontramos uma conta relacionada registrada e voc\xea pode vincul\xe1-la diretamente.",
    reset_password: "Esqueceu a senha",
    reset_password_description: "Digite o {{types, list(type: disjunction;)}} \xe0 sua conta e enviaremos a voc\xea o c\xf3digo de verifica\xe7\xe3o para redefinir sua senha.",
    new_password: "Nova senha",
    set_password: "Configurar senha",
    password_changed: "Senha alterada",
    no_account: "Ainda n\xe3o tem conta? ",
    have_account: "J\xe1 tinha uma conta?",
    enter_password: "Digite a senha",
    enter_password_for: "Entre com a senha para {{method}} {{value}}",
    enter_username: "Definir nome de usu\xe1rio",
    enter_username_description: "O nome de usu\xe1rio \xe9 uma alternativa para fazer login. O nome de usu\xe1rio deve conter apenas letras, n\xfameros e sublinhados.",
    link_email: "Linkar e-mail",
    link_phone: "Linkar telefone",
    link_email_or_phone: "Linkar e-mail ou telefone",
    link_email_description: "Para maior seguran\xe7a, vincule seu e-mail \xe0 conta.",
    link_phone_description: "Para maior seguran\xe7a, vincule seu telefone \xe0 conta.",
    link_email_or_phone_description: "Para maior seguran\xe7a, vincule seu e-mail ou telefone \xe0 conta.",
    continue_with_more_information: "Para maior seguran\xe7a, preencha os detalhes da conta abaixo.",
    create_your_account: "Crie sua conta",
    sign_in_to_your_account: "Fa\xe7a login na sua conta",
    no_region_code_found: "N\xe3o foi poss\xedvel encontrar o c\xf3digo de regi\xe3o do seu telefone.",
    verify_email: "Verificar e-mail",
    verify_phone: "Verificar n\xfamero de telefone",
    password_requirements: "Senha {{items, list}}.",
    password_requirement: {
        length_one: "requer no m\xednimo 1 caractere.",
        length_other: "requer no m\xednimo {{count}} caracteres.",
        character_types_one: "deve conter pelo menos 1 tipo de letra mai\xfascula, letra min\xfascula, d\xedgito e s\xedmbolo.",
        character_types_other: "deve conter pelo menos {{count}} tipos de letra mai\xfascula, letra min\xfascula, d\xedgito e s\xedmbolo."
    },
    use: "Usar",
    single_sign_on_email_form: "Insira o endere\xe7o de e-mail corporativo",
    single_sign_on_connectors_list: "Sua empresa ativou o Single Sign-On para a conta de email {{email}}. Voc\xea pode continuar a fazer login com os seguintes provedores de SSO.",
    single_sign_on_enabled: "Esta conta tem Single Sign-On ativado.",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ authorize_personal_data_usage: "Authorize the use of your personal data:",
    /** UNTRANSLATED */ authorize_organization_access: "Authorize access to the specific organization:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: `By authorizing the access, you agree to the {{name}}'s <link></link>.`,
    /** UNTRANSLATED */ authorize_agreement_with_redirect: `By authorizing the access, you agree to the {{name}}'s <link></link>, and will be redirected to {{uri}}.`,
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $7a616ff7d44f3079$export$2e2bcd8739ae039 = Object.freeze($7a616ff7d44f3079$var$description);


const $c03e08f4276cef0f$var$development_tenant = {
    notification: "Voc\xea est\xe1 no modo de desenvolvimento"
};
var $c03e08f4276cef0f$export$2e2bcd8739ae039 = Object.freeze($c03e08f4276cef0f$var$development_tenant);


const $e3fb0a65fbcc256c$var$password_rejected = {
    too_short: "O comprimento m\xednimo \xe9 {{min}}.",
    too_long: "O comprimento m\xe1ximo \xe9 {{max}}.",
    character_types: "Pelo menos {{min}} tipos de caracteres s\xe3o necess\xe1rios.",
    unsupported_characters: "Caractere n\xe3o suportado encontrado.",
    pwned: "Evite o uso de senhas simples que s\xe3o f\xe1ceis de adivinhar.",
    restricted_found: "Evite usar em excesso {{list, list}}.",
    restricted: {
        repetition: "caracteres repetidos",
        sequence: "caracteres sequenciais",
        user_info: "suas informa\xe7\xf5es pessoais",
        words: "contexto do produto"
    }
};
var $e3fb0a65fbcc256c$export$2e2bcd8739ae039 = Object.freeze($e3fb0a65fbcc256c$var$password_rejected);


const $0fd65bb2d506589c$var$error = {
    general_required: "{{types, list(type: disjunction;)}} \xe9 obrigat\xf3rio",
    general_invalid: "O {{types, list(type: disjunction;)}} \xe9 inv\xe1lido",
    username_required: "Nome de usu\xe1rio \xe9 obrigat\xf3rio",
    password_required: "Senha \xe9 obrigat\xf3rio",
    username_exists: "O nome de usu\xe1rio j\xe1 existe",
    username_should_not_start_with_number: "O nome de usu\xe1rio n\xe3o deve come\xe7ar com um n\xfamero",
    username_invalid_charset: "O nome de usu\xe1rio deve conter apenas letras, n\xfameros ou sublinhados.",
    invalid_email: "O e-mail \xe9 inv\xe1lido",
    invalid_phone: "O n\xfamero de telefone \xe9 inv\xe1lido",
    passwords_do_not_match: "Suas senhas n\xe3o correspondem. Por favor, tente novamente.",
    invalid_passcode: "O c\xf3digo de verifica\xe7\xe3o \xe9 inv\xe1lido",
    invalid_connector_auth: "A autoriza\xe7\xe3o \xe9 inv\xe1lida",
    invalid_connector_request: "Os dados do conector s\xe3o inv\xe1lidos",
    unknown: "Erro desconhecido. Por favor, tente novamente mais tarde.",
    invalid_session: "Sess\xe3o n\xe3o encontrada. Volte e fa\xe7a login novamente.",
    timeout: "Tempo limite excedido. Por favor, tente novamente mais tarde.",
    password_rejected: $e3fb0a65fbcc256c$export$2e2bcd8739ae039,
    sso_not_enabled: "O Single Sign-On n\xe3o est\xe1 habilitado para esta conta de e-mail."
};
var $0fd65bb2d506589c$export$2e2bcd8739ae039 = Object.freeze($0fd65bb2d506589c$var$error);


const $b23f66317f3ca6c9$var$input = {
    username: "Nome de usu\xe1rio",
    password: "Senha",
    email: "E-mail",
    phone_number: "N\xfamero de telefone",
    confirm_password: "Confirme a senha",
    search_region_code: "Pesquisar c\xf3digo de regi\xe3o",
    backup_code: "C\xf3digo de backup"
};
var $b23f66317f3ca6c9$export$2e2bcd8739ae039 = Object.freeze($b23f66317f3ca6c9$var$input);


const $e5437004c6694cc1$var$list = {
    or: "ou",
    and: "e",
    separator: ","
};
var $e5437004c6694cc1$export$2e2bcd8739ae039 = Object.freeze($e5437004c6694cc1$var$list);


const $e48f5e932d718cfe$var$mfa = {
    totp: "Senha \xfanica do aplicativo autenticador",
    webauthn: "Senha de dispositivo",
    backup_code: "C\xf3digo de backup",
    link_totp_description: "Por exemplo, Google Authenticator, etc.",
    link_webauthn_description: "Vincule seu dispositivo ou hardware USB",
    link_backup_code_description: "Gere um c\xf3digo de backup",
    verify_totp_description: "Digite o c\xf3digo \xfanico no aplicativo",
    verify_webauthn_description: "Verifique seu dispositivo ou hardware USB",
    verify_backup_code_description: "Cole o c\xf3digo de backup que voc\xea salvou",
    add_mfa_factors: "Adicionar verifica\xe7\xe3o em duas etapas",
    add_mfa_description: "A verifica\xe7\xe3o em duas etapas est\xe1 ativada. Selecione seu segundo m\xe9todo de verifica\xe7\xe3o para login seguro.",
    verify_mfa_factors: "Verifica\xe7\xe3o em duas etapas",
    verify_mfa_description: "A verifica\xe7\xe3o em duas etapas foi ativada para esta conta. Por favor, selecione a segunda forma de verificar sua identidade.",
    add_authenticator_app: "Adicionar aplicativo autenticador",
    step: "Passo {{step, number}}: {{content}}",
    scan_qr_code: "Escanear este c\xf3digo QR",
    scan_qr_code_description: "Escanee o seguinte c\xf3digo QR com seu aplicativo autenticador, como Google Authenticator, Duo Mobile, Authy, etc.",
    qr_code_not_available: "N\xe3o consegue escanear o c\xf3digo QR?",
    copy_and_paste_key: "Copiar e colar a chave",
    copy_and_paste_key_description: "Copie e cole a seguinte chave no seu aplicativo autenticador, como Google Authenticator, Duo Mobile, Authy, etc.",
    want_to_scan_qr_code: "Quer escanear o c\xf3digo QR?",
    enter_one_time_code: "Digite o c\xf3digo \xfanico",
    enter_one_time_code_link_description: "Digite o c\xf3digo de verifica\xe7\xe3o de 6 d\xedgitos gerado pelo aplicativo autenticador.",
    enter_one_time_code_description: "A verifica\xe7\xe3o em duas etapas foi habilitada para esta conta. Por favor, insira o c\xf3digo de uso \xfanico mostrado no seu aplicativo autenticador vinculado.",
    link_another_mfa_factor: "Trocar para outro m\xe9todo",
    save_backup_code: "Salve seu c\xf3digo de backup",
    save_backup_code_description: "Voc\xea pode usar um desses c\xf3digos de backup para acessar sua conta se tiver problemas durante a verifica\xe7\xe3o em duas etapas de outras maneiras. Cada c\xf3digo pode ser usado apenas uma vez.",
    backup_code_hint: "Certifique-se de copi\xe1-los e salvar em um local seguro.",
    enter_a_backup_code: "Digite um c\xf3digo de backup",
    enter_backup_code_description: "Digite o c\xf3digo de backup que voc\xea salvou quando a verifica\xe7\xe3o em duas etapas foi ativada inicialmente.",
    create_a_passkey: "Criar uma senha",
    create_passkey_description: "Registre sua senha usando biometria do dispositivo, chaves de seguran\xe7a (por exemplo, YubiKey) ou outros m\xe9todos dispon\xedveis.",
    try_another_verification_method: "Experimente outro m\xe9todo de verifica\xe7\xe3o",
    verify_via_passkey: "Verificar via senha",
    verify_via_passkey_description: "Use a senha para verificar por meio da senha do seu dispositivo ou biometria, escaneando o c\xf3digo QR ou usando uma chave de seguran\xe7a USB como a YubiKey.",
    secret_key_copied: "Chave secreta copiada.",
    backup_code_copied: "C\xf3digo de backup copiado.",
    webauthn_not_ready: "WebAuthn ainda n\xe3o est\xe1 pronto. Por favor, tente novamente mais tarde.",
    webauthn_not_supported: "WebAuthn n\xe3o \xe9 suportado neste navegador.",
    webauthn_failed_to_create: "Falha ao criar. Por favor, tente novamente.",
    webauthn_failed_to_verify: "Falha ao verificar. Por favor, tente novamente."
};
var $e48f5e932d718cfe$export$2e2bcd8739ae039 = Object.freeze($e48f5e932d718cfe$var$mfa);


const $1532ac70d90e6f75$var$secondary = {
    social_bind_with: "J\xe1 tinha uma conta? Fa\xe7a login no link {{methods, list(type: disjunction;)}} com sua identidade social."
};
var $1532ac70d90e6f75$export$2e2bcd8739ae039 = Object.freeze($1532ac70d90e6f75$var$secondary);


const $e9e78b5d22e08669$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $e9e78b5d22e08669$export$2e2bcd8739ae039 = Object.freeze($e9e78b5d22e08669$var$user_scopes);


const $db790d13c8a3e8fe$var$pt_br = {
    translation: {
        input: $b23f66317f3ca6c9$export$2e2bcd8739ae039,
        secondary: $1532ac70d90e6f75$export$2e2bcd8739ae039,
        action: $2a8a1bdef3c7dca5$export$2e2bcd8739ae039,
        description: $7a616ff7d44f3079$export$2e2bcd8739ae039,
        error: $0fd65bb2d506589c$export$2e2bcd8739ae039,
        list: $e5437004c6694cc1$export$2e2bcd8739ae039,
        mfa: $e48f5e932d718cfe$export$2e2bcd8739ae039,
        development_tenant: $c03e08f4276cef0f$export$2e2bcd8739ae039,
        user_scopes: $e9e78b5d22e08669$export$2e2bcd8739ae039
    }
};
var $db790d13c8a3e8fe$export$2e2bcd8739ae039 = Object.freeze($db790d13c8a3e8fe$var$pt_br);


const $b2ee9d0c4bf4ff7f$var$action = {
    sign_in: "Entrar",
    continue: "Continuar",
    create_account: "Criar uma conta",
    create_account_without_linking: "Criar conta sem vincula\xe7\xe3o",
    create: "Criar",
    enter_passcode: "Introduzir c\xf3digo de verifica\xe7\xe3o",
    confirm: "Confirmar",
    cancel: "Cancelar",
    save_password: "Guardar palavra-passe",
    bind: "Agregar a {{address}}",
    bind_and_continue: "Ligar e continuar",
    back: "Voltar",
    nav_back: "Anterior",
    nav_skip: "Saltar",
    agree: "Aceito",
    got_it: "Entendi",
    sign_in_with: "Continuar com {{name}}",
    forgot_password: "Esqueceu-se da palavra-passe?",
    switch_to: "Mudar para {{method}}",
    sign_in_via_passcode: "Iniciar sess\xe3o com c\xf3digo de verifica\xe7\xe3o",
    sign_in_via_password: "Iniciar sess\xe3o com palavra-passe",
    change: "Alterar {{method}}",
    link_another_email: "Vincular outro email",
    link_another_phone: "Vincular outro telefone",
    link_another_email_or_phone: "Vincular outro email ou telefone",
    show_password: "Mostrar palavra-passe",
    copy: "Copiar",
    verify_via_passkey: "Verificar atrav\xe9s de chave de acesso",
    download: "Transferir",
    single_sign_on: "Logon \xdanico",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $b2ee9d0c4bf4ff7f$export$2e2bcd8739ae039 = Object.freeze($b2ee9d0c4bf4ff7f$var$action);


const $437c4249896e7ef3$var$description = {
    email: "email",
    phone_number: "telefone",
    username: "utilizador",
    reminder: "Lembrete",
    not_found: "404 N\xe3o encontrado",
    agree_with_terms: "Eu li e concordo com os ",
    agree_with_terms_modal: "Para prosseguir, por favor, concorde com o <link></link>.",
    terms_of_use: "Termos de uso",
    sign_in: "Entrar",
    privacy_policy: "Pol\xedtica de privacidade",
    create_account: "Criar uma conta",
    or: "ou",
    and: "e",
    enter_passcode: "O c\xf3digo de verifica\xe7\xe3o foi enviado para o seu {{address}} {{target}}",
    passcode_sent: "O c\xf3digo de verifica\xe7\xe3o foi reenviado",
    resend_after_seconds: "Reenviar ap\xf3s <span>{{seconds}}</span> segundos",
    resend_passcode: "Reenviar c\xf3digo de verifica\xe7\xe3o",
    create_account_id_exists: "A conta com {{type}} {{value}} j\xe1 existe, gostaria de fazer login?",
    link_account_id_exists: "A conta com {{type}} {{value}} j\xe1 existe, gostaria de vincul\xe1-la?",
    sign_in_id_does_not_exist: "A conta com {{type}} {{value}} n\xe3o existe, gostaria de criar uma?",
    sign_in_id_does_not_exist_alert: "A conta com {{type}} {{value}} n\xe3o existe.",
    create_account_id_exists_alert: "A conta com {{type}} {{value}} est\xe1 vinculada a outra conta. Por favor, tente outro {{type}}.",
    social_identity_exist: "O {{type}} {{value}} est\xe1 vinculado a outra conta. Por favor, tente outro {{type}}.",
    bind_account_title: "Vincular ou criar conta",
    social_create_account: "Pode criar uma nova conta.",
    social_link_email: "Pode vincular outro email",
    social_link_phone: "Pode vincular outro telefone",
    social_link_email_or_phone: "Pode vincular outro email ou telefone",
    social_bind_with_existing: "Encontramos uma conta relacionada registrada e voc\xea pode vincul\xe1-la diretamente.",
    reset_password: "Esqueceu a senha",
    reset_password_description: "Insira os {{types, list(type: disjunction;)}} associados \xe0 sua conta e enviaremos o c\xf3digo de verifica\xe7\xe3o para redefinir sua senha.",
    new_password: "Nova Senha",
    set_password: "Definir senha",
    password_changed: "Senha alterada",
    no_account: "Ainda n\xe3o tem conta?",
    have_account: "J\xe1 tem conta?",
    enter_password: "Digite a senha",
    enter_password_for: "Fa\xe7a login com a senha do {{method}} {{value}}",
    enter_username: "Definir nome de usu\xe1rio",
    enter_username_description: "O nome de usu\xe1rio \xe9 uma alternativa para o login. O nome de usu\xe1rio deve conter apenas letras, n\xfameros e sublinhados.",
    link_email: "Vincular email",
    link_phone: "Vincular telefone",
    link_email_or_phone: "Vincular email ou telefone",
    link_email_description: "Para maior seguran\xe7a, vincule o seu email \xe0 conta.",
    link_phone_description: "Para maior seguran\xe7a, vincule o seu telefone \xe0 conta.",
    link_email_or_phone_description: "Para maior seguran\xe7a, vincule o seu email ou telefone \xe0 conta.",
    continue_with_more_information: "Para maior seguran\xe7a, por favor complete os detalhes da conta abaixo.",
    create_your_account: "Crie a sua conta",
    sign_in_to_your_account: "Inicie sess\xe3o na sua conta",
    no_region_code_found: "N\xe3o foi poss\xedvel encontrar o c\xf3digo de regi\xe3o do seu telefone.",
    verify_email: "Verifique o seu email",
    verify_phone: "Verifique o seu n\xfamero de telefone",
    password_requirements: "Requisitos de senha {{items, list}}.",
    password_requirement: {
        length_one: "requer um m\xednimo de {{count}} caracter",
        length_other: "requer um m\xednimo de {{count}} caracteres",
        character_types_one: "deve conter pelo menos {{count}} tipo de letras mai\xfasculas, letras min\xfasculas, d\xedgitos e s\xedmbolos",
        character_types_other: "deve conter pelo menos {{count}} tipos de letras mai\xfasculas, letras min\xfasculas, d\xedgitos e s\xedmbolos"
    },
    use: "Usar",
    single_sign_on_email_form: "Insira o endere\xe7o de email corporativo",
    single_sign_on_connectors_list: "A sua empresa ativou o Single Sign-On para a conta de email {{email}}. Pode continuar a iniciar sess\xe3o com os seguintes fornecedores de SSO.",
    single_sign_on_enabled: "Esta conta tem o Single Sign-On ativado.",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ authorize_personal_data_usage: "Authorize the use of your personal data:",
    /** UNTRANSLATED */ authorize_organization_access: "Authorize access to the specific organization:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: `By authorizing the access, you agree to the {{name}}'s <link></link>.`,
    /** UNTRANSLATED */ authorize_agreement_with_redirect: `By authorizing the access, you agree to the {{name}}'s <link></link>, and will be redirected to {{uri}}.`,
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $437c4249896e7ef3$export$2e2bcd8739ae039 = Object.freeze($437c4249896e7ef3$var$description);


const $c5d6200229b82f93$var$development_tenant = {
    notification: "Est\xe1s em modo de desenvolvimento"
};
var $c5d6200229b82f93$export$2e2bcd8739ae039 = Object.freeze($c5d6200229b82f93$var$development_tenant);


const $6a208a923169360f$var$password_rejected = {
    too_short: "M\xednimo de comprimento \xe9 {{min}}.",
    too_long: "M\xe1ximo de comprimento \xe9 {{max}}.",
    character_types: "S\xe3o necess\xe1rios pelo menos {{min}} tipos de caracteres.",
    unsupported_characters: "Caractere n\xe3o suportado encontrado.",
    pwned: "Evite o uso de senhas simples que s\xe3o f\xe1ceis de adivinhar.",
    restricted_found: "Evite o uso excessivo de {{list, list}}.",
    restricted: {
        repetition: "caracteres repetidos",
        sequence: "caracteres sequenciais",
        user_info: "suas informa\xe7\xf5es pessoais",
        words: "contexto do produto"
    }
};
var $6a208a923169360f$export$2e2bcd8739ae039 = Object.freeze($6a208a923169360f$var$password_rejected);


const $9813e2d619c26396$var$error = {
    general_required: "{{types, list(type: disjunction;)}} is necess\xe1rio",
    general_invalid: "O {{types, list(type: disjunction;)}} \xe9 inv\xe1lido",
    username_required: "Utilizador necess\xe1rio",
    password_required: "Password necess\xe1ria",
    username_exists: "O nome de utilizador j\xe1 existe",
    username_should_not_start_with_number: "O nome de utilizador n\xe3o deve come\xe7ar com um n\xfamero",
    username_invalid_charset: "O nome de utilizador deve conter apenas letras, n\xfameros ou underscores.",
    invalid_email: "O email \xe9 inv\xe1lido",
    invalid_phone: "O n\xfamero de telefone \xe9 inv\xe1lido",
    passwords_do_not_match: "As passwords n\xe3o coincidem",
    invalid_passcode: "O c\xf3digo de verifica\xe7\xe3o \xe9 inv\xe1lido.",
    invalid_connector_auth: "A autoriza\xe7\xe3o \xe9 inv\xe1lida",
    invalid_connector_request: "Os dados do conector s\xe3o inv\xe1lidos",
    unknown: "Erro desconhecido. Por favor, tente novamente mais tarde.",
    invalid_session: "Sess\xe3o n\xe3o encontrada. Volte e fa\xe7a login novamente.",
    timeout: "Tempo limite de sess\xe3o. Volte e fa\xe7a login novamente.",
    password_rejected: $6a208a923169360f$export$2e2bcd8739ae039,
    sso_not_enabled: "O Single Sign-On n\xe3o est\xe1 habilitado para esta conta de e-mail."
};
var $9813e2d619c26396$export$2e2bcd8739ae039 = Object.freeze($9813e2d619c26396$var$error);


const $c70f86e538b83f3f$var$input = {
    username: "Utilizador",
    password: "Palavra-passe",
    email: "Email",
    phone_number: "Telefone",
    confirm_password: "Confirmar palavra-passe",
    search_region_code: "Procurar c\xf3digo de regi\xe3o",
    backup_code: "C\xf3digo de backup"
};
var $c70f86e538b83f3f$export$2e2bcd8739ae039 = Object.freeze($c70f86e538b83f3f$var$input);


const $a5373b6cad26992f$var$list = {
    or: "ou",
    and: "e",
    separator: ","
};
var $a5373b6cad26992f$export$2e2bcd8739ae039 = Object.freeze($a5373b6cad26992f$var$list);


const $0d2f2c68502290bd$var$mfa = {
    totp: "Senha \xfanica do aplicativo autenticador",
    webauthn: "Senha de dispositivo",
    backup_code: "C\xf3digo de backup",
    link_totp_description: "Por exemplo, Google Authenticator, etc.",
    link_webauthn_description: "Vincule o seu dispositivo ou hardware USB",
    link_backup_code_description: "Gere um c\xf3digo de backup",
    verify_totp_description: "Introduza o c\xf3digo \xfanico na aplica\xe7\xe3o",
    verify_webauthn_description: "Verifique o seu dispositivo ou hardware USB",
    verify_backup_code_description: "Cole o c\xf3digo de backup que guardou",
    add_mfa_factors: "Adicionar verifica\xe7\xe3o em duas etapas",
    add_mfa_description: "A verifica\xe7\xe3o em duas etapas est\xe1 ativada. Selecione o seu segundo m\xe9todo de verifica\xe7\xe3o para iniciar sess\xe3o de forma segura.",
    verify_mfa_factors: "Verifica\xe7\xe3o em duas etapas",
    verify_mfa_description: "A verifica\xe7\xe3o em duas etapas foi ativada para esta conta. Por favor, selecione a segunda forma de verificar a sua identidade.",
    add_authenticator_app: "Adicionar aplicativo autenticador",
    step: "Passo {{step, number}}: {{content}}",
    scan_qr_code: "Digitalize este c\xf3digo QR",
    scan_qr_code_description: "Digitalize o c\xf3digo QR seguinte com a sua aplica\xe7\xe3o autenticadora, como o Google Authenticator, Duo Mobile, Authy, etc.",
    qr_code_not_available: "N\xe3o consegue digitalizar o c\xf3digo QR?",
    copy_and_paste_key: "Copiar e colar a chave",
    copy_and_paste_key_description: "Copie e cole a seguinte chave na sua aplica\xe7\xe3o autenticadora, como o Google Authenticator, Duo Mobile, Authy, etc.",
    want_to_scan_qr_code: "Quer digitalizar o c\xf3digo QR?",
    enter_one_time_code: "Introduza o c\xf3digo \xfanico",
    enter_one_time_code_link_description: "Introduza o c\xf3digo de verifica\xe7\xe3o de 6 d\xedgitos gerado pela aplica\xe7\xe3o autenticadora.",
    enter_one_time_code_description: "A verifica\xe7\xe3o em duas etapas foi ativada para esta conta. Por favor, insira o c\xf3digo de utiliza\xe7\xe3o \xfanica mostrado na sua aplica\xe7\xe3o autenticadora vinculada.",
    link_another_mfa_factor: "Mudar para outro m\xe9todo",
    save_backup_code: "Guarde o seu c\xf3digo de backup",
    save_backup_code_description: "Pode usar um destes c\xf3digos de backup para aceder \xe0 sua conta se tiver problemas durante a verifica\xe7\xe3o em duas etapas de outras formas. Cada c\xf3digo s\xf3 pode ser utilizado uma vez.",
    backup_code_hint: "Certifique-se de os copiar e guardar num local seguro.",
    enter_a_backup_code: "Introduza um c\xf3digo de backup",
    enter_backup_code_description: "Introduza o c\xf3digo de backup que guardou quando a verifica\xe7\xe3o em duas etapas foi ativada inicialmente.",
    create_a_passkey: "Criar uma palavra-passe",
    create_passkey_description: "Registe a sua palavra-passe utilizando a biometria do dispositivo, chaves de seguran\xe7a (por exemplo, YubiKey) ou outros m\xe9todos dispon\xedveis.",
    try_another_verification_method: "Experimente outro m\xe9todo de verifica\xe7\xe3o",
    verify_via_passkey: "Verificar atrav\xe9s da palavra-passe",
    verify_via_passkey_description: "Utilize a palavra-passe para verificar atrav\xe9s da senha do seu dispositivo ou biometria, digitalizando o c\xf3digo QR ou utilizando uma chave de seguran\xe7a USB como a YubiKey.",
    secret_key_copied: "Chave secreta copiada.",
    backup_code_copied: "C\xf3digo de backup copiado.",
    webauthn_not_ready: "O WebAuthn ainda n\xe3o est\xe1 pronto. Por favor, tente novamente mais tarde.",
    webauthn_not_supported: "O WebAuthn n\xe3o \xe9 suportado neste navegador.",
    webauthn_failed_to_create: "Falha ao criar. Por favor, tente novamente.",
    webauthn_failed_to_verify: "Falha ao verificar. Por favor, tente novamente."
};
var $0d2f2c68502290bd$export$2e2bcd8739ae039 = Object.freeze($0d2f2c68502290bd$var$mfa);


const $1c7ab8e1afa58b88$var$secondary = {
    social_bind_with: "J\xe1 tem uma conta? Fa\xe7a login para agregar {{methods, list(type: disjunction;)}} com a sua identidade social."
};
var $1c7ab8e1afa58b88$export$2e2bcd8739ae039 = Object.freeze($1c7ab8e1afa58b88$var$secondary);


const $b1db73829bcef964$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $b1db73829bcef964$export$2e2bcd8739ae039 = Object.freeze($b1db73829bcef964$var$user_scopes);


const $99db7dcf32d1350b$var$pt_pt = {
    translation: {
        input: $c70f86e538b83f3f$export$2e2bcd8739ae039,
        secondary: $1c7ab8e1afa58b88$export$2e2bcd8739ae039,
        action: $b2ee9d0c4bf4ff7f$export$2e2bcd8739ae039,
        description: $437c4249896e7ef3$export$2e2bcd8739ae039,
        error: $9813e2d619c26396$export$2e2bcd8739ae039,
        list: $a5373b6cad26992f$export$2e2bcd8739ae039,
        mfa: $0d2f2c68502290bd$export$2e2bcd8739ae039,
        development_tenant: $c5d6200229b82f93$export$2e2bcd8739ae039,
        user_scopes: $b1db73829bcef964$export$2e2bcd8739ae039
    }
};
var $99db7dcf32d1350b$export$2e2bcd8739ae039 = Object.freeze($99db7dcf32d1350b$var$pt_pt);


const $fda95863122991ca$var$action = {
    sign_in: "Войти",
    continue: "Продолжить",
    create_account: "Создать аккаунт",
    create_account_without_linking: "Создать аккаунт без связывания",
    create: "Создать",
    enter_passcode: "Введите код подтверждения",
    confirm: "Подтвердить",
    cancel: "Отменить",
    save_password: "Сохраните пароль",
    bind: "Привязать к {{address}}",
    bind_and_continue: "Привязать и продолжить",
    back: "Назад",
    nav_back: "Назад",
    nav_skip: "Пропустить",
    agree: "Согласен",
    got_it: "Понял",
    sign_in_with: "Войти через {{name}}",
    forgot_password: "Забыли пароль?",
    switch_to: "Изменить на {{method}}",
    sign_in_via_passcode: "Войти с кодом подтверждения",
    sign_in_via_password: "Войти с паролем",
    change: "Изменить {{method}}",
    link_another_email: "Привязать другую почту",
    link_another_phone: "Привязать другой номер",
    link_another_email_or_phone: "Привязать другую почту или номер",
    show_password: "Показать пароль",
    copy: "Копировать",
    verify_via_passkey: "Проверить с помощью ключа доступа",
    download: "Скачать",
    single_sign_on: "Единый вход",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $fda95863122991ca$export$2e2bcd8739ae039 = Object.freeze($fda95863122991ca$var$action);


const $33fdd214488c313e$var$description = {
    email: "адрес электронной почты",
    phone_number: "номер телефона",
    username: "имя пользователя",
    reminder: "Напоминание",
    not_found: "404 Не найдено",
    agree_with_terms: "Я прочитал и согласен с ",
    agree_with_terms_modal: "Чтобы продолжить, пожалуйста, согласитесь с <link></link>",
    terms_of_use: "Условиями использования",
    sign_in: "Войти",
    privacy_policy: "Политикой конфиденциальности",
    create_account: "Создать аккаунт",
    or: "или",
    and: "и",
    enter_passcode: "Код подтверждения был отправлен на {{address}}",
    passcode_sent: "Код подтверждения был отправлен повторно",
    resend_after_seconds: "Отправить повторно через <span>{{seconds}}</span> сек.",
    resend_passcode: "Отправить повторно",
    create_account_id_exists: "Учетная запись для {{value}} уже существует, хотите войти?",
    link_account_id_exists: "Учетная запись для {{value}} уже существует, хотите привязать?",
    sign_in_id_does_not_exist: "Учетная запись для {{value}} не существует, хотите зарегистрироваться?",
    sign_in_id_does_not_exist_alert: "Учетная запись для {{value}} не существует.",
    create_account_id_exists_alert: "Аккаунт с {{type}} {{value}} связан с другим аккаунтом. Пожалуйста, попробуйте другой {{type}}.",
    social_identity_exist: "{{type}} {{value}} связан с другим аккаунтом. Пожалуйста, попробуйте другой {{type}}.",
    bind_account_title: "Привязать или создать аккаунт",
    social_create_account: "Вы можете создать новую учетную запись.",
    social_link_email: "Вы можете привязать другой адрес электронной почты",
    social_link_phone: "Вы можете привязать другой номер телефона",
    social_link_email_or_phone: "Вы можете привязать другой адрес электронной почты или телефон",
    social_bind_with_existing: "Мы находим зарегистрированную связанную учетную запись, и вы можете связать ее напрямую.",
    reset_password: "Забыли пароль",
    reset_password_description: "Введите {{types, list(type: disjunction;)}} от вашей учетной записи, и мы вышлем вам код для восстановления пароля.",
    new_password: "Новый пароль",
    set_password: "Задать пароль",
    password_changed: "Пароль изменен",
    no_account: "Еще не зарегистрированы? ",
    have_account: "Уже есть аккаунт?",
    enter_password: "Введите пароль",
    enter_password_for: "Введите пароль для {{value}}",
    enter_username: "Установить имя пользователя",
    enter_username_description: "Имя пользователя является альтернативой для входа в систему. Имя пользователя должно содержать только буквы, цифры и символы подчеркивания.",
    link_email: "Привязать почту",
    link_phone: "Привязать номер телефона",
    link_email_or_phone: "Привязать почту или номер телефона",
    link_email_description: "Для дополнительной безопасности, пожалуйста, привяжите свою электронную почту к учетной записи.",
    link_phone_description: "Для дополнительной безопасности, пожалуйста, привяжите свой номер телефона к учетной записи.",
    link_email_or_phone_description: "Для дополнительной безопасности, пожалуйста, привяжите свою электронную почту или номер телефона к учетной записи.",
    continue_with_more_information: "Для дополнительной безопасности, пожалуйста, заполните приведенные ниже данные учетной записи.",
    create_your_account: "Создайте свой аккаунт",
    sign_in_to_your_account: "Войди в свой аккаунт",
    no_region_code_found: "Не удалось определить код региона",
    verify_email: "Подтвердите Ваш электронный адрес",
    verify_phone: "Подтвердите свой номер телефона",
    password_requirements: "Требования к паролю {{items, list}}.",
    password_requirement: {
        length_one: "требуется минимум {{count}} символ",
        length_other: "требуется минимум {{count}} символов",
        character_types_one: "должен содержать по крайней мере {{count}} тип прописных букв, строчных букв, цифр и символов",
        character_types_other: "должен содержать по крайней мере {{count}} типа прописных букв, строчных букв, цифр и символов"
    },
    use: "Использовать",
    single_sign_on_email_form: "Введите корпоративный адрес электронной почты",
    single_sign_on_connectors_list: "Ваше предприятие включило функцию единого входа для электронной почты {{email}}. Вы можете продолжить вход в систему с помощью следующих провайдеров SSO.",
    single_sign_on_enabled: "Единый вход в систему включен для этой учетной записи",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ authorize_personal_data_usage: "Authorize the use of your personal data:",
    /** UNTRANSLATED */ authorize_organization_access: "Authorize access to the specific organization:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: `By authorizing the access, you agree to the {{name}}'s <link></link>.`,
    /** UNTRANSLATED */ authorize_agreement_with_redirect: `By authorizing the access, you agree to the {{name}}'s <link></link>, and will be redirected to {{uri}}.`,
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $33fdd214488c313e$export$2e2bcd8739ae039 = Object.freeze($33fdd214488c313e$var$description);


const $93f3deb0d0968281$var$development_tenant = {
    notification: "Вы в режиме разработки"
};
var $93f3deb0d0968281$export$2e2bcd8739ae039 = Object.freeze($93f3deb0d0968281$var$development_tenant);


const $a61cd50d4ebd7fe4$var$password_rejected = {
    too_short: "Минимальная длина {{min}} символов.",
    too_long: "Максимальная длина {{max}} символов.",
    character_types: "Требуется как минимум {{min}} типов символов.",
    unsupported_characters: "Найден неподдерживаемый символ.",
    pwned: "Избегайте использования простых паролей, которые легко угадать.",
    restricted_found: "Избегайте чрезмерного использования {{list,list}}.",
    restricted: {
        repetition: "повторяющиеся символы",
        sequence: "последовательные символы",
        user_info: "ваши личные данные",
        words: "контекст продукта"
    }
};
var $a61cd50d4ebd7fe4$export$2e2bcd8739ae039 = Object.freeze($a61cd50d4ebd7fe4$var$password_rejected);


const $3afe01f77379e95c$var$error = {
    general_required: "Введите {{types, list(type: disjunction;)}}",
    general_invalid: "Проверьте {{types, list(type: disjunction;)}}",
    username_required: "Введите имя пользователя",
    password_required: "Введите пароль",
    username_exists: "Имя пользователя занято",
    username_should_not_start_with_number: "Имя пользователя не должно начинаться с цифры",
    username_invalid_charset: "Имя пользователя должно содержать только буквы, цифры или символы подчеркивания",
    invalid_email: "Электронная почта указана неправильно",
    invalid_phone: "Номер телефона указан неправильно",
    passwords_do_not_match: "Пароли не совпадают. Пожалуйста, попробуйте еще раз.",
    invalid_passcode: "Неправильный код подтверждения",
    invalid_connector_auth: "Авторизация недействительна",
    invalid_connector_request: "Данные коннектора недействительны.",
    unknown: "Неизвестная ошибка. Пожалуйста, повторите попытку позднее.",
    invalid_session: "Сессия не найдена. Пожалуйста, войдите снова.",
    timeout: "Время ожидания истекло. Пожалуйста, повторите попытку позднее.",
    password_rejected: $a61cd50d4ebd7fe4$export$2e2bcd8739ae039,
    sso_not_enabled: "Односторонняя авторизация не включена для этого аккаунта электронной почты."
};
var $3afe01f77379e95c$export$2e2bcd8739ae039 = Object.freeze($3afe01f77379e95c$var$error);


const $bd94d0c089f3543d$var$input = {
    username: "Имя пользователя",
    password: "Пароль",
    email: "Электронная почта",
    phone_number: "Номер телефона",
    confirm_password: "Подтверждение пароля",
    search_region_code: "Поиск кода региона",
    backup_code: "Резервный код"
};
var $bd94d0c089f3543d$export$2e2bcd8739ae039 = Object.freeze($bd94d0c089f3543d$var$input);


const $9b395cbcf4a04d81$var$list = {
    or: "или",
    and: "и",
    separator: ","
};
var $9b395cbcf4a04d81$export$2e2bcd8739ae039 = Object.freeze($9b395cbcf4a04d81$var$list);


const $2025f2ee6e3854c0$var$mfa = {
    totp: "Одноразовый пароль приложения для аутентификации",
    webauthn: "Пароль",
    backup_code: "Резервный код",
    link_totp_description: "Например, Google Authenticator и др.",
    link_webauthn_description: "Привяжите ваше устройство или USB-ключ",
    link_backup_code_description: "Создайте резервный код",
    verify_totp_description: "Введите одноразовый код в приложении",
    verify_webauthn_description: "Подтвердите ваше устройство или USB-ключ",
    verify_backup_code_description: "Вставьте резервный код, который вы сохранили",
    add_mfa_factors: "Добавить двухфакторную аутентификацию",
    add_mfa_description: "Включена двухфакторная аутентификация. Выберите второй метод для безопасного входа.",
    verify_mfa_factors: "Двухфакторная аутентификация",
    verify_mfa_description: "Двухфакторная аутентификация включена для этого аккаунта. Выберите второй способ подтверждения вашей личности.",
    add_authenticator_app: "Добавить приложение для аутентификации",
    step: "Шаг {{step, number}}: {{content}}",
    scan_qr_code: "Отсканируйте этот QR-код",
    scan_qr_code_description: "Отсканируйте следующий QR-код с помощью вашего приложения для аутентификации, такого как Google Authenticator, Duo Mobile, Authy и др.",
    qr_code_not_available: "Нельзя отсканировать QR-код?",
    copy_and_paste_key: "Скопируйте и вставьте ключ",
    copy_and_paste_key_description: "Скопируйте и вставьте следующий ключ в ваше приложение для аутентификации, такое как Google Authenticator, Duo Mobile, Authy и др.",
    want_to_scan_qr_code: "Хотите отсканировать QR-код?",
    enter_one_time_code: "Введите одноразовый код",
    enter_one_time_code_link_description: "Введите 6-значный код, сгенерированный приложением для аутентификации.",
    enter_one_time_code_description: "Для этого аккаунта включена двухэтапная аутентификация. Введите одноразовый код, отображаемый в вашем связанном приложении для аутентификации.",
    link_another_mfa_factor: "Переключиться на другой метод",
    save_backup_code: "Сохраните ваш резервный код",
    save_backup_code_description: "Вы можете использовать один из этих резервных кодов для доступа к своему аккаунту, если у вас возникнут проблемы с двухфакторной аутентификацией другим способом. Каждый код может быть использован только один раз.",
    backup_code_hint: "Убедитесь, что вы скопировали и сохранили их в надежном месте.",
    enter_a_backup_code: "Введите резервный код",
    enter_backup_code_description: "Введите резервный код, который вы сохранили при включении двухфакторной аутентификации.",
    create_a_passkey: "Создать код доступа",
    create_passkey_description: "Зарегистрируйте свой код доступа с использованием биометрических данных устройства, ключей безопасности (например, YubiKey) или других доступных методов.",
    try_another_verification_method: "Попробуйте другой метод подтверждения",
    verify_via_passkey: "Подтвердите через код доступа",
    verify_via_passkey_description: "Используйте код доступа для подтверждения с помощью пароля устройства или биометрии, сканирования QR-кода или использования USB-ключа безопасности, такого как YubiKey.",
    secret_key_copied: "Ключ скопирован.",
    backup_code_copied: "Резервный код скопирован.",
    webauthn_not_ready: "WebAuthn еще не готов. Пожалуйста, попробуйте позже.",
    webauthn_not_supported: "WebAuthn не поддерживается в этом браузере.",
    webauthn_failed_to_create: "Не удалось создать. Пожалуйста, попробуйте еще раз.",
    webauthn_failed_to_verify: "Не удалось проверить. Пожалуйста, попробуйте еще раз."
};
var $2025f2ee6e3854c0$export$2e2bcd8739ae039 = Object.freeze($2025f2ee6e3854c0$var$mfa);


const $67e864d803315bd8$var$secondary = {
    social_bind_with: "Уже есть аккаунт? Войдите, чтобы привязать {{methods, list(type: disjunction;)}}."
};
var $67e864d803315bd8$export$2e2bcd8739ae039 = Object.freeze($67e864d803315bd8$var$secondary);


const $133bb1a29c42741d$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $133bb1a29c42741d$export$2e2bcd8739ae039 = Object.freeze($133bb1a29c42741d$var$user_scopes);


const $b31e9cc5d8ae5824$var$ru = {
    translation: {
        input: $bd94d0c089f3543d$export$2e2bcd8739ae039,
        secondary: $67e864d803315bd8$export$2e2bcd8739ae039,
        action: $fda95863122991ca$export$2e2bcd8739ae039,
        description: $33fdd214488c313e$export$2e2bcd8739ae039,
        error: $3afe01f77379e95c$export$2e2bcd8739ae039,
        list: $9b395cbcf4a04d81$export$2e2bcd8739ae039,
        mfa: $2025f2ee6e3854c0$export$2e2bcd8739ae039,
        development_tenant: $93f3deb0d0968281$export$2e2bcd8739ae039,
        user_scopes: $133bb1a29c42741d$export$2e2bcd8739ae039
    }
};
var $b31e9cc5d8ae5824$export$2e2bcd8739ae039 = Object.freeze($b31e9cc5d8ae5824$var$ru);


const $f0184c42bc6bc160$var$action = {
    sign_in: "Giriş Yap",
    continue: "İlerle",
    create_account: "Hesap Oluştur",
    create_account_without_linking: "Bağlamadan hesap oluştur",
    create: "Oluştur",
    enter_passcode: "Doğrulama kodunu girin",
    confirm: "Onayla",
    cancel: "İptal Et",
    save_password: "Şifreyi kaydet",
    bind: "{{address}} ile birleştir",
    bind_and_continue: "Bağla ve devam et",
    back: "Geri D\xf6n",
    nav_back: "Geri",
    nav_skip: "Atla",
    agree: "Kabul Et",
    got_it: "Anladım",
    sign_in_with: "{{name}} ile ilerle",
    forgot_password: "Şifremi Unuttum?",
    switch_to: "{{method}} y\xf6ntemine ge\xe7",
    sign_in_via_passcode: "Doğrulama koduyla oturum a\xe7ın",
    sign_in_via_password: "şifre ile giriş yap",
    change: "{{method}} değiştir",
    link_another_email: "Başka bir e-postayı bağla",
    link_another_phone: "Başka bir telefon bağla",
    link_another_email_or_phone: "Başka bir e-posta veya telefon bağlayın",
    show_password: "Şifreyi g\xf6ster",
    copy: "Kopyala",
    verify_via_passkey: "Parola ile doğrula",
    download: "İndir",
    single_sign_on: "Tek oturum a\xe7ma",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $f0184c42bc6bc160$export$2e2bcd8739ae039 = Object.freeze($f0184c42bc6bc160$var$action);


const $e13b963baac838cf$var$description = {
    email: "e-posta adresi",
    phone_number: "telefon numarası",
    username: "kullanıcı Adı",
    reminder: "Hatırlatıcı",
    not_found: "404 Bulunamadı",
    agree_with_terms: "Okudum ve anladım",
    agree_with_terms_modal: "Devam etmek i\xe7in l\xfctfen <link></link>'i kabul edin.",
    terms_of_use: "Kullanım Koşulları",
    sign_in: "Giriş Yap",
    privacy_policy: "Gizlilik Politikası",
    create_account: "Hesap Oluştur",
    or: "veya",
    and: "ve",
    enter_passcode: "Doğrulama kodu {{address}} {{target}} adresinize g\xf6nderildi",
    passcode_sent: "Doğrulama kodu yeniden g\xf6nderildi",
    resend_after_seconds: "<span>{{seconds}}</span> saniye sonra tekrar g\xf6nder",
    resend_passcode: "Doğrulama kodunu tekrar g\xf6nder",
    create_account_id_exists: "{{type}} {{value}} ile hesap mevcut, giriş yapmak ister misiniz?",
    link_account_id_exists: "{{type}} {{value}} olan hesap zaten var, bağlamak ister misiniz?",
    sign_in_id_does_not_exist: "{{type}} {{value}} ile hesap mevcut değil, yeni bir hesap oluşturmak ister misiniz?",
    sign_in_id_does_not_exist_alert: "{{type}} {{value}} olan hesap mevcut değil.",
    create_account_id_exists_alert: "{{type}} {{value}} olan hesap başka bir hesaba bağlı. L\xfctfen başka bir {{type}} deneyin.",
    social_identity_exist: "{{type}} {{value}} başka bir hesaba bağlı. L\xfctfen başka bir {{type}} deneyin.",
    bind_account_title: "Bağla veya hesap oluştur",
    social_create_account: "Yeni bir hesap oluşturabilirsiniz.",
    social_link_email: "Başka bir e-posta bağlayabilirsiniz",
    social_link_phone: "Başka bir telefon bağlayabilirsiniz",
    social_link_email_or_phone: "Başka bir e-posta veya telefon bağlayabilirsiniz",
    social_bind_with_existing: "Kayıtlı ilgili bir hesap bulduk ve onu doğrudan bağlayabilirsiniz.",
    reset_password: "Parolanızı mı unuttunuz",
    reset_password_description: "Hesabınızla ilişkili {{types, list(type: disjunction;)}} girin, şifrenizi sıfırlamanız i\xe7in size doğrulama kodunu g\xf6ndereceğiz.",
    new_password: "Yeni Şifre",
    set_password: "Şifreyi belirle",
    password_changed: "Şifre değişti",
    no_account: "Hen\xfcz hesap yok mu?",
    have_account: "Zaten bir hesabınız var mıydı?",
    enter_password: "Parolanı Gir",
    enter_password_for: "{{method}} {{value}} şifresiyle oturum a\xe7ın",
    enter_username: "Kullanıcı adını ayarla",
    enter_username_description: "Kullanıcı adı, oturum a\xe7mak i\xe7in bir alternatiftir. Kullanıcı adı yalnızca harf, sayı ve alt \xe7izgi i\xe7ermelidir.",
    link_email: "E-postayı bağla",
    link_phone: "Telefonu bağla",
    link_email_or_phone: "E-posta veya telefon bağlantısı",
    link_email_description: "Daha fazla g\xfcvenlik i\xe7in l\xfctfen e-postanızı hesapla ilişkilendirin.",
    link_phone_description: "Daha fazla g\xfcvenlik i\xe7in l\xfctfen telefonunuzu hesaba bağlayın.",
    link_email_or_phone_description: "Daha fazla g\xfcvenlik i\xe7in l\xfctfen e-postanızı veya telefonunuzu hesaba bağlayın.",
    continue_with_more_information: "Daha fazla g\xfcvenlik i\xe7in l\xfctfen aşağıdaki hesap ayrıntılarını tamamlayın.",
    create_your_account: "Hesabını oluştur",
    sign_in_to_your_account: "Hesabına giriş yap",
    no_region_code_found: "B\xf6lge kodu bulunamadı",
    verify_email: "E-postanızın doğrulanması",
    verify_phone: "Telefon numaranızın doğrulanması",
    password_requirements: "Şifre {{items, list}}.",
    password_requirement: {
        length_one: "en az {{count}} karakter gerektirir",
        length_other: "en az {{count}} karakter gerektirir",
        character_types_one: "en az {{count}} tane b\xfcy\xfck harf, k\xfc\xe7\xfck harf, rakam ve sembol i\xe7ermelidir",
        character_types_other: "en az {{count}} tane b\xfcy\xfck harf, k\xfc\xe7\xfck harf, rakam ve sembol i\xe7ermelidir"
    },
    use: "Kullan",
    single_sign_on_email_form: "Kurumsal e-posta adresinizi girin",
    single_sign_on_connectors_list: "Şirketiniz, {{email}} e-posta hesabı i\xe7in Tekli Oturum A\xe7mayı (Single Sign-On) etkinleştirdi. Aşağıdaki SSO sağlayıcıları ile oturum a\xe7maya devam edebilirsiniz.",
    single_sign_on_enabled: "Bu hesapta Tekli Oturum A\xe7ma etkinleştirildi.",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ authorize_personal_data_usage: "Authorize the use of your personal data:",
    /** UNTRANSLATED */ authorize_organization_access: "Authorize access to the specific organization:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: `By authorizing the access, you agree to the {{name}}'s <link></link>.`,
    /** UNTRANSLATED */ authorize_agreement_with_redirect: `By authorizing the access, you agree to the {{name}}'s <link></link>, and will be redirected to {{uri}}.`,
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $e13b963baac838cf$export$2e2bcd8739ae039 = Object.freeze($e13b963baac838cf$var$description);


const $b859e8127f788be6$var$development_tenant = {
    notification: "Geliştirme modundasın"
};
var $b859e8127f788be6$export$2e2bcd8739ae039 = Object.freeze($b859e8127f788be6$var$development_tenant);


const $2f9461814c517665$var$password_rejected = {
    too_short: "Minimum length is {{min}}.",
    too_long: "Maximum length is {{max}}.",
    character_types: "En az {{min}} t\xfcrde karakter gereklidir.",
    unsupported_characters: "Desteklenmeyen karakter bulundu.",
    pwned: "Kolayca tahmin edilebilen basit şifreleri kullanmaktan ka\xe7ının.",
    restricted_found: "{{list, list}} fazla kullanımdan ka\xe7ının.",
    restricted: {
        repetition: "tekrarlanan karakterler",
        sequence: "dizisel karakterler",
        user_info: "kişisel bilgileriniz",
        words: "\xfcr\xfcnle ilgili terimler"
    }
};
var $2f9461814c517665$export$2e2bcd8739ae039 = Object.freeze($2f9461814c517665$var$password_rejected);


const $b66851b59265025e$var$error = {
    general_required: "{{types, list(type: disjunction;)}} gerekli",
    general_invalid: "{{types, list(type: disjunction;)}} ge\xe7ersiz",
    username_required: "Kullanıcı adı gerekli.",
    password_required: "Şifre gerekli.",
    username_exists: "Kullanıcı adı mevcut.",
    username_should_not_start_with_number: "Kullanıcı adı sayı ile başlayamaz.",
    username_invalid_charset: "Kullanıcı adı yalnızca harf,sayı veya alt \xe7izgi i\xe7ermeli.",
    invalid_email: "E-posta adresi ge\xe7ersiz",
    invalid_phone: "Telefon numarası ge\xe7ersiz",
    passwords_do_not_match: "Şifreler eşleşmiyor",
    invalid_passcode: "Doğrulama kodu ge\xe7ersiz",
    invalid_connector_auth: "Yetki ge\xe7ersiz",
    invalid_connector_request: "Bağlayıcı veri ge\xe7ersiz",
    unknown: "Bilinmeyen hata. L\xfctfen daha sonra tekrar deneyiniz.",
    invalid_session: "Oturum bulunamadı. L\xfctfen geri d\xf6n\xfcp tekrar giriş yapınız.",
    timeout: "Oturum zaman aşımına uğradı. L\xfctfen geri d\xf6n\xfcp tekrar giriş yapınız.",
    password_rejected: $2f9461814c517665$export$2e2bcd8739ae039,
    sso_not_enabled: "Bu e-posta hesabı i\xe7in tek oturum a\xe7ma etkin değil."
};
var $b66851b59265025e$export$2e2bcd8739ae039 = Object.freeze($b66851b59265025e$var$error);


const $e494e805945457f9$var$input = {
    username: "Kullanıcı Adı",
    password: "Şifre",
    email: "E-posta Adresi",
    phone_number: "Telefon Numarası",
    confirm_password: "Şifreyi Doğrula",
    search_region_code: "B\xf6lge kodunu ara",
    backup_code: "Yedek kod"
};
var $e494e805945457f9$export$2e2bcd8739ae039 = Object.freeze($e494e805945457f9$var$input);


const $5aa50f4f744d8983$var$list = {
    or: "veya",
    and: "ve",
    separator: ","
};
var $5aa50f4f744d8983$export$2e2bcd8739ae039 = Object.freeze($5aa50f4f744d8983$var$list);


const $6f813ded854e45ee$var$mfa = {
    totp: "Authenticator uygulaması OTP",
    webauthn: "Anahtar",
    backup_code: "Yedek kod",
    link_totp_description: "\xd6rn., Google Authenticator, vb.",
    link_webauthn_description: "Cihazınızı veya USB donanımınızı bağlayın",
    link_backup_code_description: "Yedek kod oluşturun",
    verify_totp_description: "Uygulamadaki tek kullanımlık kodu girin",
    verify_webauthn_description: "Cihazınızı veya USB donanımınızı doğrulayın",
    verify_backup_code_description: "Kaydettiğiniz yedek kodu yapıştırın",
    add_mfa_factors: "2 aşamalı doğrulamayı ekle",
    add_mfa_description: "İki fakt\xf6rl\xfc doğrulama etkin. G\xfcvenli giriş i\xe7in ikinci doğrulama y\xf6nteminizi se\xe7in.",
    verify_mfa_factors: "2 aşamalı doğrulama",
    verify_mfa_description: "Bu hesap i\xe7in 2 aşamalı doğrulama etkinleştirildi. L\xfctfen kimliğinizi doğrulamak i\xe7in ikinci yolu se\xe7in.",
    add_authenticator_app: "Authenticator uygulaması ekle",
    step: "Adım {{step, number}}: {{content}}",
    scan_qr_code: "Bu QR kodunu tarayın",
    scan_qr_code_description: "Bu QR kodunu authenticator uygulamanızla tarayın, \xf6rneğin Google Authenticator, Duo Mobile, Authy, vb.",
    qr_code_not_available: "QR kodu taranamıyor mu?",
    copy_and_paste_key: "Anahtarı kopyala ve yapıştır",
    copy_and_paste_key_description: "Aşağıdaki anahtarı authenticator uygulamanıza kopyala ve yapıştır, \xf6rneğin Google Authenticator, Duo Mobile, Authy, vb.",
    want_to_scan_qr_code: "QR kodunu tarımak mı istiyorsunuz?",
    enter_one_time_code: "Tek kullanımlık kodu girin",
    enter_one_time_code_link_description: "Authenticator uygulaması tarafından oluşturulan 6 haneli doğrulama kodunu girin.",
    enter_one_time_code_description: "Bu hesap i\xe7in iki aşamalı doğrulama etkinleştirildi. L\xfctfen bağlı kimlik doğrulama uygulamanızda g\xf6sterilen tek kullanımlık kodu girin.",
    link_another_mfa_factor: "Başka bir y\xf6nteme ge\xe7in",
    save_backup_code: "Yedek kodunuzu kaydedin",
    save_backup_code_description: "Başka bir y\xf6ntemle 2 aşamalı doğrulama sırasında sorun yaşarsanız bu yedek kodlardan birini kullanabilirsiniz. Her kod sadece bir kez kullanılabilir.",
    backup_code_hint: "Onları kopyalayın ve g\xfcvenli bir yerde sakladığınızdan emin olun.",
    enter_a_backup_code: "Bir yedek kod girin",
    enter_backup_code_description: "İlk olarak 2 aşamalı doğrulama etkinleştirildiğinde kaydettiğiniz yedek kodu girin.",
    create_a_passkey: "Bir anahtar oluşturun",
    create_passkey_description: "Cihaz biyometrisi, g\xfcvenlik anahtarları (\xf6rneğin YubiKey) veya diğer kullanılabilir y\xf6ntemler kullanarak anahtarınızı kaydedin.",
    try_another_verification_method: "Başka bir doğrulama y\xf6ntemini deneyin",
    verify_via_passkey: "Anahtar ile doğrula",
    verify_via_passkey_description: "Anahtar kullanarak cihaz parolanız veya biyometri ile doğrulama, QR kodunu tarama veya YubiKey gibi USB g\xfcvenlik anahtarı kullanma.",
    secret_key_copied: "Gizli anahtar kopyalandı.",
    backup_code_copied: "Yedek kod kopyalandı.",
    webauthn_not_ready: "WebAuthn hen\xfcz hazır değil. L\xfctfen daha sonra tekrar deneyin.",
    webauthn_not_supported: "Bu tarayıcıda WebAuthn desteklenmiyor.",
    webauthn_failed_to_create: "Oluşturulamadı. L\xfctfen tekrar deneyin.",
    webauthn_failed_to_verify: "Doğrulama başarısız oldu. L\xfctfen tekrar deneyin."
};
var $6f813ded854e45ee$export$2e2bcd8739ae039 = Object.freeze($6f813ded854e45ee$var$mfa);


const $942a18adcb9a672c$var$secondary = {
    social_bind_with: "Hesabınız zaten var mı? {{methods, list(type: disjunction;)}} bağlantısına tıklayarak giriş yapabilirsiniz"
};
var $942a18adcb9a672c$export$2e2bcd8739ae039 = Object.freeze($942a18adcb9a672c$var$secondary);


const $5f0059b269c33efc$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $5f0059b269c33efc$export$2e2bcd8739ae039 = Object.freeze($5f0059b269c33efc$var$user_scopes);


const $d07d15a854fd1aef$var$tr_tr = {
    translation: {
        input: $e494e805945457f9$export$2e2bcd8739ae039,
        secondary: $942a18adcb9a672c$export$2e2bcd8739ae039,
        action: $f0184c42bc6bc160$export$2e2bcd8739ae039,
        description: $e13b963baac838cf$export$2e2bcd8739ae039,
        error: $b66851b59265025e$export$2e2bcd8739ae039,
        list: $5aa50f4f744d8983$export$2e2bcd8739ae039,
        mfa: $6f813ded854e45ee$export$2e2bcd8739ae039,
        development_tenant: $b859e8127f788be6$export$2e2bcd8739ae039,
        user_scopes: $5f0059b269c33efc$export$2e2bcd8739ae039
    }
};
var $d07d15a854fd1aef$export$2e2bcd8739ae039 = Object.freeze($d07d15a854fd1aef$var$tr_tr);


const $673afadc0990a4a7$var$action = {
    sign_in: "登录",
    continue: "继续",
    create_account: "注册",
    create_account_without_linking: "注册新的账号",
    create: "注册",
    enter_passcode: "输入验证码",
    confirm: "确认",
    cancel: "取消",
    save_password: "保存密码",
    bind: "绑定到 {{address}}",
    bind_and_continue: "绑定并继续",
    back: "返回",
    nav_back: "返回",
    nav_skip: "跳过",
    agree: "同意",
    got_it: "知道了",
    sign_in_with: "通过 {{name}} 继续",
    forgot_password: "忘记密码？",
    switch_to: "切换到{{method}}",
    sign_in_via_passcode: "用验证码登录",
    sign_in_via_password: "密码登录",
    change: "更改{{method}}",
    link_another_email: "绑定其它邮箱",
    link_another_phone: "绑定其它手机",
    link_another_email_or_phone: "绑定邮箱或手机号",
    show_password: "显示密码",
    copy: "复制",
    verify_via_passkey: "通过 Passkey 验证",
    download: "下载",
    single_sign_on: "单点登录",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $673afadc0990a4a7$export$2e2bcd8739ae039 = Object.freeze($673afadc0990a4a7$var$action);


const $86127b638d95c7d6$var$description = {
    email: "邮箱",
    phone_number: "手机号",
    username: "用户名",
    reminder: "提示",
    not_found: "404 页面不存在",
    agree_with_terms: "我已阅读并同意 ",
    agree_with_terms_modal: "请先同意 <link></link> 以继续",
    terms_of_use: "使用条款",
    sign_in: "登录",
    privacy_policy: "隐私政策",
    create_account: "创建帐号",
    or: "或",
    and: "和",
    enter_passcode: "验证码已经发送至你的{{ address }} {{target}}",
    passcode_sent: "验证码已经发送",
    resend_after_seconds: "在 <span>{{ seconds }}</span> 秒后重发",
    resend_passcode: "重发验证码",
    create_account_id_exists: "{{type}}为 {{value}} 的帐号已存在，你要登录吗？",
    link_account_id_exists: " {{type}}为 {{value}} 的账号已注册，你要绑定至这个账号吗？",
    sign_in_id_does_not_exist: "{{type}}为 {{value}} 的帐号不存在，你要创建一个新帐号吗？",
    sign_in_id_does_not_exist_alert: "{{type}}为 {{value}} 的帐号不存在。",
    create_account_id_exists_alert: "{{type}} {{value}} 已绑定其他账号。请尝试其他{{type}}。",
    social_identity_exist: " {{type}} {{value}} 已绑定其他账号。请尝试其他{{type}}",
    bind_account_title: "绑定或注册帐号",
    social_create_account: "你可以注册一个新的账号。",
    social_link_email: "你可以绑定其他邮箱",
    social_link_phone: "你可以绑定其他手机号",
    social_link_email_or_phone: "你可以绑定其他邮箱或手机号",
    social_bind_with_existing: "找到了一个已注册的账号，你可以直接绑定。",
    reset_password: "忘记密码",
    reset_password_description: "输入{{types, list(type: disjunction;)}}，获取验证码以重设密码。",
    new_password: "新密码",
    set_password: "设置密码",
    password_changed: "已重置密码！",
    no_account: "还没有账号？",
    have_account: " 已有账号？",
    enter_password: "输入密码",
    enter_password_for: "输入{{method}} {{value}} 对应的密码进行登录",
    enter_username: "设置用户名",
    enter_username_description: "用户名可以用来进行登录。用户名仅可以包含字母、数字和下划线。",
    link_email: "绑定邮箱",
    link_phone: "绑定手机",
    link_email_or_phone: "绑定邮箱或手机号",
    link_email_description: "绑定邮箱以保障你的账号安全",
    link_phone_description: "绑定手机号以保障你的账号安全",
    link_email_or_phone_description: "绑定邮箱或手机号以保障你的账号安全",
    continue_with_more_information: "为保障你的账号安全，需要你补充以下信息。",
    create_your_account: "注册你的账号",
    sign_in_to_your_account: "登录你的账号",
    no_region_code_found: "没有找到区域码",
    verify_email: "验证你的邮箱",
    verify_phone: "验证你的手机号",
    password_requirements: "密码 {{items, list}}。",
    password_requirement: {
        length_one: "应至少有 {{count}} 个字符",
        length_other: "应至少有 {{count}} 个字符",
        character_types_one: "应包含至少 {{count}} 种大写字母、小写字母、数字和符号",
        character_types_other: "应包含至少 {{count}} 种大写字母、小写字母、数字和符号"
    },
    use: "使用",
    single_sign_on_email_form: "输入你的企业电子邮件地址",
    single_sign_on_connectors_list: "你的企业已为电子邮件账户 {{email}} 启用了单点登录。你可以继续使用以下SSO提供商进行登录。",
    single_sign_on_enabled: "该帐户已启用单点登录",
    authorize_title: "授权给 {{name}}",
    request_permission: "{{name}} 需要权限：",
    grant_organization_access: "授予组织访问权限：",
    /** UNTRANSLATED */ authorize_personal_data_usage: "Authorize the use of your personal data:",
    /** UNTRANSLATED */ authorize_organization_access: "Authorize access to the specific organization:",
    user_scopes: "用户个人信息",
    organization_scopes: "组织权限",
    authorize_agreement: `你将同意授权给 {{name}} <link></link>.`,
    /** UNTRANSLATED */ authorize_agreement_with_redirect: `你将同意授权给 {{name}} <link></link>，然后你将被重定向到 {{uri}}。`,
    not_you: "不是你本人吗？",
    user_id: "用户 ID: {{id}}",
    redirect_to: "你将被重定向到 {{name}}。"
};
var $86127b638d95c7d6$export$2e2bcd8739ae039 = Object.freeze($86127b638d95c7d6$var$description);


const $13c408dff9080d8d$var$development_tenant = {
    notification: "你处于开发模式"
};
var $13c408dff9080d8d$export$2e2bcd8739ae039 = Object.freeze($13c408dff9080d8d$var$development_tenant);


const $4a2a271c23be016e$var$password_rejected = {
    too_short: "最短长度为{{min}}。",
    too_long: "最长长度为{{max}}。",
    character_types: "需要至少{{min}}种字符类型。",
    unsupported_characters: "发现不支持的字符。",
    pwned: "避免使用容易被猜到的简单密码。",
    restricted_found: "避免过度使用{{list, list}}。",
    restricted: {
        repetition: "重复字符",
        sequence: "连续字符",
        user_info: "您的个人信息",
        words: "产品上下文"
    }
};
var $4a2a271c23be016e$export$2e2bcd8739ae039 = Object.freeze($4a2a271c23be016e$var$password_rejected);


const $9d47db1f9d075c19$var$error = {
    general_required: "{{types, list(type: disjunction;)}}必填",
    general_invalid: "无效的{{types, list(type: disjunction;)}}",
    username_required: "用户名必填",
    password_required: "密码必填",
    username_exists: "用户名已存在",
    username_should_not_start_with_number: "用户名不能以数字开头",
    username_invalid_charset: "用户名只能包含英文字母、数字或下划线。",
    invalid_email: "无效的邮箱",
    invalid_phone: "无效的手机号",
    passwords_do_not_match: "两次输入的密码不一致，请重试。",
    invalid_passcode: "无效的验证码",
    invalid_connector_auth: "登录失败",
    invalid_connector_request: "无效的登录请求",
    unknown: "未知错误，请稍后重试。",
    invalid_session: "未找到会话，请返回并重新登录。",
    timeout: "请求超时，请稍后重试。",
    password_rejected: $4a2a271c23be016e$export$2e2bcd8739ae039,
    sso_not_enabled: "此邮箱账户未启用单点登录。"
};
var $9d47db1f9d075c19$export$2e2bcd8739ae039 = Object.freeze($9d47db1f9d075c19$var$error);


const $9542907841872402$var$input = {
    username: "用户名",
    password: "密码",
    email: "邮箱",
    phone_number: "手机号",
    confirm_password: "确认密码",
    search_region_code: "搜索区域码",
    backup_code: "备用码"
};
var $9542907841872402$export$2e2bcd8739ae039 = Object.freeze($9542907841872402$var$input);


const $5b8d4ec7d21cf0d2$var$list = {
    or: "或者",
    and: "和",
    separator: "，"
};
var $5b8d4ec7d21cf0d2$export$2e2bcd8739ae039 = Object.freeze($5b8d4ec7d21cf0d2$var$list);


const $170ce9635eec4320$var$mfa = {
    totp: "身份验证应用 OTP",
    webauthn: "通行证",
    backup_code: "备份代码",
    link_totp_description: "例如，Google Authenticator 等。",
    link_webauthn_description: "链接您的设备或 USB 硬件",
    link_backup_code_description: "生成备份代码",
    verify_totp_description: "在应用程序中输入一次性代码",
    verify_webauthn_description: "验证您的设备或 USB 硬件",
    verify_backup_code_description: "粘贴您保存的备份代码",
    add_mfa_factors: "添加两步验证",
    add_mfa_description: "已启用两步验证。选择第二种验证方法以进行安全登录。",
    verify_mfa_factors: "两步验证",
    verify_mfa_description: "此帐户已启用两步验证。请选择第二种验证身份的方式。",
    add_authenticator_app: "添加身份验证应用",
    step: "步骤 {{step, number}}: {{content}}",
    scan_qr_code: "扫描此 QR 码",
    scan_qr_code_description: "使用身份验证应用程序（如 Google Authenticator、Duo Mobile、Authy 等）扫描以下 QR 码。",
    qr_code_not_available: "无法扫描 QR 码？",
    copy_and_paste_key: "复制并粘贴密钥",
    copy_and_paste_key_description: "将以下密钥复制并粘贴到身份验证应用程序中，如 Google Authenticator、Duo Mobile、Authy 等。",
    want_to_scan_qr_code: "想要扫描 QR 码吗？",
    enter_one_time_code: "输入一次性代码",
    enter_one_time_code_link_description: "输入身份验证应用生成的 6 位验证码。",
    enter_one_time_code_description: "此帐户启用了两步验证。请在你关联的认证应用中输入显示的一次性代码。",
    link_another_mfa_factor: "切换到另一种方法",
    save_backup_code: "保存您的备份代码",
    save_backup_code_description: "如果在其他方式的两步验证中遇到问题，您可以使用这些备份代码之一访问您的帐户。每个代码只能使用一次。",
    backup_code_hint: "确保复制它们并保存在安全的地方。",
    enter_a_backup_code: "输入备份代码",
    enter_backup_code_description: "输入初始启用两步验证时保存的备份代码。",
    create_a_passkey: "创建通行证",
    create_passkey_description: "使用设备生物识别、安全密钥（例如 YubiKey）或其他可用方法注册您的通行证。",
    try_another_verification_method: "尝试其他验证方法",
    verify_via_passkey: "通过通行证验证",
    verify_via_passkey_description: "使用通行证通过设备密码或生物识别、扫描 QR 码或使用 USB 安全密钥（如 YubiKey）进行验证。",
    secret_key_copied: "密钥已复制。",
    backup_code_copied: "备份代码已复制。",
    webauthn_not_ready: "WebAuthn 尚未准备就绪。请稍后重试。",
    webauthn_not_supported: "此浏览器不支持 WebAuthn。",
    webauthn_failed_to_create: "创建失败。请重试。",
    webauthn_failed_to_verify: "验证失败。请重试。"
};
var $170ce9635eec4320$export$2e2bcd8739ae039 = Object.freeze($170ce9635eec4320$var$mfa);


const $819a138d21c160fe$var$secondary = {
    social_bind_with: "绑定到已有账户? 使用 {{methods, list(type: disjunction;), zhOrSpaces}} 登录并绑定。"
};
var $819a138d21c160fe$export$2e2bcd8739ae039 = Object.freeze($819a138d21c160fe$var$secondary);


const $8778084cf0781987$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $8778084cf0781987$export$2e2bcd8739ae039 = Object.freeze($8778084cf0781987$var$user_scopes);


const $05c0f581b5030e2a$var$zh_cn = {
    translation: {
        input: $9542907841872402$export$2e2bcd8739ae039,
        secondary: $819a138d21c160fe$export$2e2bcd8739ae039,
        action: $673afadc0990a4a7$export$2e2bcd8739ae039,
        description: $86127b638d95c7d6$export$2e2bcd8739ae039,
        error: $9d47db1f9d075c19$export$2e2bcd8739ae039,
        list: $5b8d4ec7d21cf0d2$export$2e2bcd8739ae039,
        mfa: $170ce9635eec4320$export$2e2bcd8739ae039,
        development_tenant: $13c408dff9080d8d$export$2e2bcd8739ae039,
        user_scopes: $8778084cf0781987$export$2e2bcd8739ae039
    }
};
var $05c0f581b5030e2a$export$2e2bcd8739ae039 = Object.freeze($05c0f581b5030e2a$var$zh_cn);


const $dbdce1d5ab0c609f$var$action = {
    sign_in: "登錄",
    continue: "繼續",
    create_account: "註冊",
    create_account_without_linking: "註冊新的帳號",
    create: "註冊",
    enter_passcode: "輸入驗證碼",
    confirm: "確認",
    cancel: "取消",
    save_password: "保存密碼",
    bind: "綁定到 {{address}}",
    bind_and_continue: "綁定並繼續",
    back: "返回",
    nav_back: "返回",
    nav_skip: "跳過",
    agree: "同意",
    got_it: "知道了",
    sign_in_with: "通過 {{name}} 繼續",
    forgot_password: "忘記密碼？",
    switch_to: "切換到{{method}}",
    sign_in_via_passcode: "用驗證碼登錄",
    sign_in_via_password: "密碼登錄",
    change: "更改{{method}}",
    link_another_email: "綁定其他電子郵件",
    link_another_phone: "綁定其他手機",
    link_another_email_or_phone: "綁定電子郵件或手機號碼",
    show_password: "顯示密碼",
    copy: "複製",
    verify_via_passkey: "透過 Passkey 驗證",
    download: "下載",
    single_sign_on: "單點登錄",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $dbdce1d5ab0c609f$export$2e2bcd8739ae039 = Object.freeze($dbdce1d5ab0c609f$var$action);


const $6c2450218949a0bb$var$description = {
    email: "郵箱",
    phone_number: "手機號",
    username: "用戶名",
    reminder: "提示",
    not_found: "404 頁面不存在",
    agree_with_terms: "我已閱讀並同意 ",
    agree_with_terms_modal: "請先同意 <link></link> 以繼續",
    terms_of_use: "使用條款",
    sign_in: "登錄",
    privacy_policy: "隱私政策",
    create_account: "創建帳號",
    or: "或",
    and: "和",
    enter_passcode: "驗證碼已經發送至你的{{ address }} {{target}}",
    passcode_sent: "驗證碼已經發送",
    resend_after_seconds: "在 <span>{{ seconds }}</span> 秒後重發",
    resend_passcode: "重發驗證碼",
    create_account_id_exists: "{{type}}為 {{value}} 的帳號已存在，你要登錄嗎？",
    link_account_id_exists: " {{type}}為 {{value}} 的帳號已註冊，你要綁定至這個帳號嗎？",
    sign_in_id_does_not_exist: "{{type}}為 {{value}} 的帳號不存在，你要創建一個新帳號嗎？",
    sign_in_id_does_not_exist_alert: "{{type}}為 {{value}} 的帳號不存在。",
    create_account_id_exists_alert: "{{type}} {{value}} 已綁定其他帳號。請嘗試其他{{type}}。",
    social_identity_exist: " {{type}} {{value}} 已綁定其他帳號。請嘗試其他{{type}}",
    bind_account_title: "綁定或註冊帳號",
    social_create_account: "你可以註冊一個新的帳號。",
    social_link_email: "你可以綁定其他郵箱",
    social_link_phone: "你可以綁定其他手機號",
    social_link_email_or_phone: "你可以綁定其他郵箱或手機號",
    social_bind_with_existing: "找到了一個已註冊的帳號，你可以直接綁定。",
    reset_password: "忘記密碼",
    reset_password_description: "輸入{{types, list(type: disjunction;)}}，獲取驗證碼以重設密碼。",
    new_password: "新密碼",
    set_password: "設定密碼",
    password_changed: "已重置密碼！",
    no_account: "還沒有帳號？",
    have_account: " 已有帳號？",
    enter_password: "輸入密碼",
    enter_password_for: "輸入{{method}} {{value}} 對應的密碼進行登錄",
    enter_username: "設定用戶名",
    enter_username_description: "用戶名可以用來進行登錄。用戶名僅可以包含字母、數字和下劃線。",
    link_email: "綁定郵箱",
    link_phone: "綁定手機",
    link_email_or_phone: "綁定郵箱或手機號",
    link_email_description: "綁定郵箱以保障你的帳號安全",
    link_phone_description: "綁定手機號以保障你的帳號安全",
    link_email_or_phone_description: "綁定郵箱或手機號以保障你的帳號安全",
    continue_with_more_information: "為保障你的帳號安全，需要你補充以下信息。",
    create_your_account: "註冊你的帳號",
    sign_in_to_your_account: "登錄你的帳號",
    no_region_code_found: "沒有找到區域碼",
    verify_email: "驗證你的郵箱",
    verify_phone: "驗證你的手機號",
    password_requirements: "要求密碼 {{items, list}}。",
    password_requirement: {
        length_one: "要求至少 {{count}} 個字符",
        length_other: "要求至少 {{count}} 個字符",
        character_types_one: "要求包含至少 {{count}} 類型的大寫字母，小寫字母，數字和符號",
        character_types_other: "要求包含至少 {{count}} 類型的大寫字母，小寫字母，數字和符號"
    },
    use: "使用",
    single_sign_on_email_form: "輸入你的企業電子郵件地址",
    single_sign_on_connectors_list: "您的企業已為電郵賬戶{{email}}啟用單一登入。您可以繼續使用以下的SSO供應商登入。",
    single_sign_on_enabled: "該帳戶已啟用單一登入",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ authorize_personal_data_usage: "Authorize the use of your personal data:",
    /** UNTRANSLATED */ authorize_organization_access: "Authorize access to the specific organization:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: `By authorizing the access, you agree to the {{name}}'s <link></link>.`,
    /** UNTRANSLATED */ authorize_agreement_with_redirect: `By authorizing the access, you agree to the {{name}}'s <link></link>, and will be redirected to {{uri}}.`,
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $6c2450218949a0bb$export$2e2bcd8739ae039 = Object.freeze($6c2450218949a0bb$var$description);


const $211720d4cc6a7556$var$development_tenant = {
    notification: "你處於開發模式"
};
var $211720d4cc6a7556$export$2e2bcd8739ae039 = Object.freeze($211720d4cc6a7556$var$development_tenant);


const $5be58359d3b80aa7$var$password_rejected = {
    too_short: "最少長度為{{min}}。",
    too_long: "最大長度為{{max}}。",
    character_types: "至少需要{{min}}種類的字符。",
    unsupported_characters: "發現不支援的字符。",
    pwned: "避免使用容易猜測的簡單密碼。",
    restricted_found: "避免過度使用{{list, list}}。",
    restricted: {
        repetition: "重複的字符",
        sequence: "連續的字符",
        user_info: "個人資訊",
        words: "產品上下文"
    }
};
var $5be58359d3b80aa7$export$2e2bcd8739ae039 = Object.freeze($5be58359d3b80aa7$var$password_rejected);


const $72c47cd013306377$var$error = {
    general_required: "{{types, list(type: disjunction;)}}必填",
    general_invalid: "無效的{{types, list(type: disjunction;)}}",
    username_required: "用戶名必填",
    password_required: "密碼必填",
    username_exists: "用戶名已存在",
    username_should_not_start_with_number: "用戶名不能以數字開頭",
    username_invalid_charset: "用戶名只能包含英文字母、數字或下劃線。",
    invalid_email: "無效的電子郵件",
    invalid_phone: "無效的手機號碼",
    passwords_do_not_match: "兩次輸入的密碼不一致，請重試。",
    invalid_passcode: "無效的驗證碼",
    invalid_connector_auth: "登錄失敗",
    invalid_connector_request: "無效的登錄請求",
    unknown: "未知錯誤，請稍後重試。",
    invalid_session: "未找到會話，請返回並重新登錄。",
    timeout: "請求超時，請稍後重試。",
    password_rejected: $5be58359d3b80aa7$export$2e2bcd8739ae039,
    sso_not_enabled: "此電子郵件帳戶未啟用單一登錄。"
};
var $72c47cd013306377$export$2e2bcd8739ae039 = Object.freeze($72c47cd013306377$var$error);


const $76aa92be2743efa2$var$input = {
    username: "用戶名",
    password: "密碼",
    email: "電郵",
    phone_number: "手機號碼",
    confirm_password: "確認密碼",
    search_region_code: "搜索區域碼",
    backup_code: "備用碼"
};
var $76aa92be2743efa2$export$2e2bcd8739ae039 = Object.freeze($76aa92be2743efa2$var$input);


const $049b9d4a74910cfa$var$list = {
    or: "或",
    and: "和",
    separator: "，"
};
var $049b9d4a74910cfa$export$2e2bcd8739ae039 = Object.freeze($049b9d4a74910cfa$var$list);


const $87e2f3d790f5b74e$var$mfa = {
    totp: "身份驗證應用 OTP",
    webauthn: "通行證",
    backup_code: "備份代碼",
    link_totp_description: "例如，Google Authenticator 等。",
    link_webauthn_description: "鏈接您的設備或 USB 硬件",
    link_backup_code_description: "生成備份代碼",
    verify_totp_description: "在應用程序中輸入一次性代碼",
    verify_webauthn_description: "驗證您的設備或 USB 硬件",
    verify_backup_code_description: "粘貼您保存的備份代碼",
    add_mfa_factors: "添加兩步驗證",
    add_mfa_description: "已啟用兩步驗證。選擇第二種驗證方法進行安全登錄。",
    verify_mfa_factors: "兩步驗證",
    verify_mfa_description: "此帳戶已啟用兩步驗證。請選擇第二種驗證身份的方式。",
    add_authenticator_app: "添加身份驗證應用",
    step: "步驟 {{step, number}}: {{content}}",
    scan_qr_code: "掃描此 QR 碼",
    scan_qr_code_description: "使用身份驗證應用程序（如 Google Authenticator、Duo Mobile、Authy 等）掃描以下 QR 碼。",
    qr_code_not_available: "無法掃描 QR 碼？",
    copy_and_paste_key: "複製並粘貼密鑰",
    copy_and_paste_key_description: "將以下密鑰複製並粘貼到身份驗證應用程序中，如 Google Authenticator、Duo Mobile、Authy 等。",
    want_to_scan_qr_code: "想要掃描 QR 碼嗎？",
    enter_one_time_code: "輸入一次性代碼",
    enter_one_time_code_link_description: "輸入身份驗證應用生成的 6 位驗證碼。",
    enter_one_time_code_description: "此帳戶啟用了兩步驗證。請輸入在您關聯的認證應用中顯示的一次性代碼。",
    link_another_mfa_factor: "切換到另一種方法",
    save_backup_code: "保存您的備份代碼",
    save_backup_code_description: "如果在其他方式的兩步驗證中遇到問題，您可以使用這些備份代碼之一訪問您的帳戶。每個代碼只能使用一次。",
    backup_code_hint: "確保複製它們並保存在安全的地方。",
    enter_a_backup_code: "輸入備份代碼",
    enter_backup_code_description: "輸入初始啟用兩步驗證時保存的備份代碼。",
    create_a_passkey: "創建通行證",
    create_passkey_description: "使用設備生物識別、安全密鑰（例如 YubiKey）或其他可用方法註冊您的通行證。",
    try_another_verification_method: "嘗試其他驗證方法",
    verify_via_passkey: "通過通行證驗證",
    verify_via_passkey_description: "使用通行證通過設備密碼或生物識別、掃描 QR 碼或使用 USB 安全密鑰（如 YubiKey）進行驗證。",
    secret_key_copied: "密鑰已複製。",
    backup_code_copied: "備份代碼已複製。",
    webauthn_not_ready: "WebAuthn 尚未準備就緒。請稍後重試。",
    webauthn_not_supported: "此瀏覽器不支援 WebAuthn。",
    webauthn_failed_to_create: "創建失敗。請重試。",
    webauthn_failed_to_verify: "驗證失敗。請重試。"
};
var $87e2f3d790f5b74e$export$2e2bcd8739ae039 = Object.freeze($87e2f3d790f5b74e$var$mfa);


const $280afebc1899a46d$var$secondary = {
    social_bind_with: "綁定到已有帳戶? 使用 {{methods, list(type: disjunction;), zhOrSpaces}} 登入並綁定。"
};
var $280afebc1899a46d$export$2e2bcd8739ae039 = Object.freeze($280afebc1899a46d$var$secondary);


const $38aea39724096172$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $38aea39724096172$export$2e2bcd8739ae039 = Object.freeze($38aea39724096172$var$user_scopes);


const $d82c06cfc1d04a1e$var$zh_hk = {
    translation: {
        input: $76aa92be2743efa2$export$2e2bcd8739ae039,
        secondary: $280afebc1899a46d$export$2e2bcd8739ae039,
        action: $dbdce1d5ab0c609f$export$2e2bcd8739ae039,
        description: $6c2450218949a0bb$export$2e2bcd8739ae039,
        error: $72c47cd013306377$export$2e2bcd8739ae039,
        list: $049b9d4a74910cfa$export$2e2bcd8739ae039,
        mfa: $87e2f3d790f5b74e$export$2e2bcd8739ae039,
        development_tenant: $211720d4cc6a7556$export$2e2bcd8739ae039,
        user_scopes: $38aea39724096172$export$2e2bcd8739ae039
    }
};
var $d82c06cfc1d04a1e$export$2e2bcd8739ae039 = Object.freeze($d82c06cfc1d04a1e$var$zh_hk);


const $324ed28a1a3b6e15$var$action = {
    sign_in: "登錄",
    continue: "繼續",
    create_account: "註冊",
    create_account_without_linking: "註冊新的帳號",
    create: "註冊",
    enter_passcode: "輸入驗證碼",
    confirm: "確認",
    cancel: "取消",
    save_password: "保存密碼",
    bind: "綁定到 {{address}}",
    bind_and_continue: "綁定並繼續",
    back: "返回",
    nav_back: "返回",
    nav_skip: "跳過",
    agree: "同意",
    got_it: "知道了",
    sign_in_with: "通過 {{name}} 繼續",
    forgot_password: "忘記密碼？",
    switch_to: "切換到{{method}}",
    sign_in_via_passcode: "用驗證碼登錄",
    sign_in_via_password: "密碼登錄",
    change: "更改{{method}}",
    link_another_email: "綁定其他郵箱",
    link_another_phone: "綁定其他手機",
    link_another_email_or_phone: "綁定郵箱或手機號",
    show_password: "顯示密碼",
    copy: "複製",
    verify_via_passkey: "透過 Passkey 驗證",
    download: "下載",
    single_sign_on: "單點登錄",
    /** UNTRANSLATED */ authorize: "Authorize",
    /** UNTRANSLATED */ use_another_account: "Use another account"
};
var $324ed28a1a3b6e15$export$2e2bcd8739ae039 = Object.freeze($324ed28a1a3b6e15$var$action);


const $4279cf1ea4b01c4d$var$description = {
    email: "郵箱",
    phone_number: "手機號碼",
    username: "用戶名",
    reminder: "提示",
    not_found: "404 頁面不存在",
    agree_with_terms: "我已閱讀並同意 ",
    agree_with_terms_modal: "請先同意<link></link>以繼續",
    terms_of_use: "使用條款",
    sign_in: "登錄",
    privacy_policy: "隱私政策",
    create_account: "創建帳號",
    or: "或",
    and: "和",
    enter_passcode: "驗證碼已經發送至你的{{address}} {{target}}",
    passcode_sent: "驗證碼已經發送",
    resend_after_seconds: "在 <span>{{seconds}}</span> 秒後重新發送",
    resend_passcode: "重新發送驗證碼",
    create_account_id_exists: "{{type}} 為 {{value}} 的帳號已存在，你要登錄嗎？",
    link_account_id_exists: " {{type}} 為 {{value}} 的帳號已註冊，你要綁定至這個帳號嗎？",
    sign_in_id_does_not_exist: "{{type}} 為 {{value}} 的帳號不存在，你要創建一個新帳號嗎？",
    sign_in_id_does_not_exist_alert: "{{type}} 為 {{value}} 的帳號不存在。",
    create_account_id_exists_alert: "{{type}} {{value}} 已綁定其他帳號。請嘗試其他{{type}}。",
    social_identity_exist: " {{type}} {{value}} 已綁定其他帳號。請嘗試其他{{type}}",
    bind_account_title: "綁定或註冊帳號",
    social_create_account: "你可以註冊一個新的帳號。",
    social_link_email: "你可以綁定其他郵箱",
    social_link_phone: "你可以綁定其他手機號碼",
    social_link_email_or_phone: "你可以綁定其他郵箱或手機號碼",
    social_bind_with_existing: "找到了一個已註冊的帳號，你可以直接綁定。",
    reset_password: "忘記密碼",
    reset_password_description: "輸入{{types, list(type: disjunction;)}}，獲取驗證碼以重設密碼。",
    new_password: "新密碼",
    set_password: "設置密碼",
    password_changed: "已重置密碼！",
    no_account: "還沒有帳號？",
    have_account: " 已有帳號？",
    enter_password: "輸入密碼",
    enter_password_for: "輸入{{method}} {{value}}對應的密碼進行登錄",
    enter_username: "設置用戶名",
    enter_username_description: "用戶名可以用來進行登錄。用戶名僅可以包含字母、數字和下劃線。",
    link_email: "綁定郵箱",
    link_phone: "綁定手機",
    link_email_or_phone: "綁定郵箱或手機號碼",
    link_email_description: "綁定郵箱以保障你的帳號安全",
    link_phone_description: "綁定手機號碼以保障你的帳號安全",
    link_email_or_phone_description: "綁定郵箱或手機號碼以保障你的帳號安全",
    continue_with_more_information: "為保障你的帳號安全，需要你補充以下信息。",
    create_your_account: "註冊你的帳號",
    sign_in_to_your_account: "登錄你的帳號",
    no_region_code_found: "沒有找到區域碼",
    verify_email: "驗證你的郵箱",
    verify_phone: "驗證你的手機號碼",
    password_requirements: "密碼{{items, list}}。",
    password_requirement: {
        length_one: "長度至少為 {{count}} 個字符",
        length_other: "長度至少為 {{count}} 個字符",
        character_types_one: "需包含 {{count}} 類型的大寫字母、小寫字母、數字和符號",
        character_types_other: "需包含 {{count}} 類型的大寫字母、小寫字母、數字和符號"
    },
    use: "使用",
    single_sign_on_email_form: "輸入你的企業電子郵件地址",
    single_sign_on_connectors_list: "您的企業已為電子郵件帳戶{{email}}啟用單一登入。您可以繼續使用以下的SSO供應商登入。",
    single_sign_on_enabled: "該帳戶已啟用單一登入",
    /** UNTRANSLATED */ authorize_title: "Authorize {{name}}",
    /** UNTRANSLATED */ request_permission: "{{name}} is requesting access to:",
    /** UNTRANSLATED */ grant_organization_access: "Grant the organization access:",
    /** UNTRANSLATED */ authorize_personal_data_usage: "Authorize the use of your personal data:",
    /** UNTRANSLATED */ authorize_organization_access: "Authorize access to the specific organization:",
    /** UNTRANSLATED */ user_scopes: "Personal user data",
    /** UNTRANSLATED */ organization_scopes: "Organization access",
    /** UNTRANSLATED */ authorize_agreement: `By authorizing the access, you agree to the {{name}}'s <link></link>.`,
    /** UNTRANSLATED */ authorize_agreement_with_redirect: `By authorizing the access, you agree to the {{name}}'s <link></link>, and will be redirected to {{uri}}.`,
    /** UNTRANSLATED */ not_you: "Not you?",
    /** UNTRANSLATED */ user_id: "User ID: {{id}}",
    /** UNTRANSLATED */ redirect_to: "You will be redirected to {{name}}."
};
var $4279cf1ea4b01c4d$export$2e2bcd8739ae039 = Object.freeze($4279cf1ea4b01c4d$var$description);


const $048ee450838edb52$var$development_tenant = {
    notification: "你處於開發模式"
};
var $048ee450838edb52$export$2e2bcd8739ae039 = Object.freeze($048ee450838edb52$var$development_tenant);


const $1e84c3d934861bd6$var$password_rejected = {
    too_short: "最少需要 {{min}} 位字元。",
    too_long: "最多只能有 {{max}} 位字元。",
    character_types: "至少需要 {{min}} 種不同的字元類型。",
    unsupported_characters: "發現不支援的字元。",
    pwned: "請避免使用容易被猜中的簡單密碼。",
    restricted_found: "請避免過度使用 {{list, list}}。",
    restricted: {
        repetition: "連續重複的字元",
        sequence: "連續的字元",
        user_info: "個人資訊",
        words: "使用產品相關的字詞"
    }
};
var $1e84c3d934861bd6$export$2e2bcd8739ae039 = Object.freeze($1e84c3d934861bd6$var$password_rejected);


const $22fcf7fc71e209de$var$error = {
    general_required: "{{types, list(type: disjunction;)}}必填",
    general_invalid: "無效的{{types, list(type: disjunction;)}}",
    username_required: "使用者名稱必填",
    password_required: "密碼必填",
    username_exists: "使用者名稱已存在",
    username_should_not_start_with_number: "使用者名稱不能以數字開頭",
    username_invalid_charset: "使用者名稱只能包含英文字母、數字或下劃線。",
    invalid_email: "無效的郵箱",
    invalid_phone: "無效的手機號",
    passwords_do_not_match: "兩次輸入的密碼不一致，請重試。",
    invalid_passcode: "無效的驗證碼",
    invalid_connector_auth: "登錄失敗",
    invalid_connector_request: "無效的登錄請求",
    unknown: "未知錯誤，請稍後重試。",
    invalid_session: "未找到會話，請返回並重新登錄。",
    timeout: "請求超時，請稍後重試。",
    password_rejected: $1e84c3d934861bd6$export$2e2bcd8739ae039,
    sso_not_enabled: "此郵箱帳戶未啟用單一登錄。"
};
var $22fcf7fc71e209de$export$2e2bcd8739ae039 = Object.freeze($22fcf7fc71e209de$var$error);


const $964649c25150dfae$var$input = {
    username: "用戶名",
    password: "密碼",
    email: "電子郵件",
    phone_number: "手機號碼",
    confirm_password: "確認密碼",
    search_region_code: "搜尋區域碼",
    backup_code: "備用碼"
};
var $964649c25150dfae$export$2e2bcd8739ae039 = Object.freeze($964649c25150dfae$var$input);


const $ba37c56fb9559e6f$var$list = {
    or: "或",
    and: "和",
    separator: "，"
};
var $ba37c56fb9559e6f$export$2e2bcd8739ae039 = Object.freeze($ba37c56fb9559e6f$var$list);


const $ca53d36953ddb368$var$mfa = {
    totp: "身份驗證應用 OTP",
    webauthn: "通行證",
    backup_code: "備份代碼",
    link_totp_description: "例如，Google Authenticator 等。",
    link_webauthn_description: "鏈接您的設備或 USB 硬件",
    link_backup_code_description: "生成備份代碼",
    verify_totp_description: "在應用程序中輸入一次性代碼",
    verify_webauthn_description: "驗證您的設備或 USB 硬件",
    verify_backup_code_description: "粘貼您保存的備份代碼",
    add_mfa_factors: "添加兩步驗證",
    add_mfa_description: "已啟用兩步驗證。選擇第二種驗證方法進行安全登錄。",
    verify_mfa_factors: "兩步驗證",
    verify_mfa_description: "此帳戶已啟用兩步驗證。請選擇第二種驗證身份的方式。",
    add_authenticator_app: "添加身份驗證應用",
    step: "步驟 {{step, number}}: {{content}}",
    scan_qr_code: "掃描此 QR 碼",
    scan_qr_code_description: "使用身份驗證應用程序（如 Google Authenticator、Duo Mobile、Authy 等）掃描以下 QR 碼。",
    qr_code_not_available: "無法掃描 QR 碼？",
    copy_and_paste_key: "複製並粘貼密鑰",
    copy_and_paste_key_description: "將以下密鑰複製並粘貼到身份驗證應用程序中，如 Google Authenticator、Duo Mobile、Authy 等。",
    want_to_scan_qr_code: "想要掃描 QR 碼嗎？",
    enter_one_time_code: "輸入一次性代碼",
    enter_one_time_code_link_description: "輸入身份驗證應用生成的 6 位驗證碼。",
    enter_one_time_code_description: "此帳戶啟用了兩步驗證。請輸入在您關聯的認證應用中顯示的一次性代碼。",
    link_another_mfa_factor: "切換到另一種方法",
    save_backup_code: "保存您的備份代碼",
    save_backup_code_description: "如果在其他方式的兩步驗證中遇到問題，您可以使用這些備份代碼之一訪問您的帳戶。每個代碼只能使用一次。",
    backup_code_hint: "確保複製它們並保存在安全的地方。",
    enter_a_backup_code: "輸入備份代碼",
    enter_backup_code_description: "輸入初始啟用兩步驗證時保存的備份代碼。",
    create_a_passkey: "創建通行證",
    create_passkey_description: "使用設備生物識別、安全密鑰（例如 YubiKey）或其他可用方法註冊您的通行證。",
    try_another_verification_method: "嘗試其他驗證方法",
    verify_via_passkey: "通過通行證驗證",
    verify_via_passkey_description: "使用通行證通過設備密碼或生物識別、掃描 QR 碼或使用 USB 安全密鑰（如 YubiKey）進行驗證。",
    secret_key_copied: "密鑰已複製。",
    backup_code_copied: "備份代碼已複製。",
    webauthn_not_ready: "WebAuthn 尚未準備就緒。請稍後重試。",
    webauthn_not_supported: "此瀏覽器不支援 WebAuthn。",
    webauthn_failed_to_create: "創建失敗。請重試。",
    webauthn_failed_to_verify: "驗證失敗。請重試。"
};
var $ca53d36953ddb368$export$2e2bcd8739ae039 = Object.freeze($ca53d36953ddb368$var$mfa);


const $6b1033b762feb135$var$secondary = {
    social_bind_with: "綁定到已有帳戶？使用 {{methods，list(type：disjunction;)，zhOrSpaces}} 登入並綁定。"
};
var $6b1033b762feb135$export$2e2bcd8739ae039 = Object.freeze($6b1033b762feb135$var$secondary);


const $7da5622d004c0ee1$var$user_scopes = {
    descriptions: {
        /** UNTRANSLATED */ custom_data: "Your custom data",
        /** UNTRANSLATED */ email: "Your email address",
        /** UNTRANSLATED */ phone: "Your phone number",
        /** UNTRANSLATED */ profile: "Your name, username, avatar, and other profile info",
        /** UNTRANSLATED */ roles: "Your roles",
        /** UNTRANSLATED */ identities: "Your linked social identities",
        /** UNTRANSLATED */ "urn:logto:scope:organizations": "Your organizations info",
        /** UNTRANSLATED */ "urn:logto:scope:organization_roles": "Your organization roles",
        /** UNTRANSLATED */ address: "Your address"
    }
};
var $7da5622d004c0ee1$export$2e2bcd8739ae039 = Object.freeze($7da5622d004c0ee1$var$user_scopes);


const $aeac828e5930b2be$var$zh_tw = {
    translation: {
        input: $964649c25150dfae$export$2e2bcd8739ae039,
        secondary: $6b1033b762feb135$export$2e2bcd8739ae039,
        action: $324ed28a1a3b6e15$export$2e2bcd8739ae039,
        description: $4279cf1ea4b01c4d$export$2e2bcd8739ae039,
        error: $22fcf7fc71e209de$export$2e2bcd8739ae039,
        list: $ba37c56fb9559e6f$export$2e2bcd8739ae039,
        mfa: $ca53d36953ddb368$export$2e2bcd8739ae039,
        development_tenant: $048ee450838edb52$export$2e2bcd8739ae039,
        user_scopes: $7da5622d004c0ee1$export$2e2bcd8739ae039
    }
};
var $aeac828e5930b2be$export$2e2bcd8739ae039 = Object.freeze($aeac828e5930b2be$var$zh_tw);


const $38b3e04b52b2e7eb$export$651548ae3cf5e245 = [
    "de",
    "en",
    "es",
    "fr",
    "it",
    "ja",
    "ko",
    "pl-PL",
    "pt-PT",
    "pt-BR",
    "ru",
    "tr-TR",
    "zh-CN",
    "zh-HK",
    "zh-TW"
];
const $38b3e04b52b2e7eb$export$91d555a17bb93dc7 = $38b3e04b52b2e7eb$export$651548ae3cf5e245.map((languageTag)=>({
        value: languageTag,
        title: (0, $cOUYQ.languages)[languageTag]
    }));
const $38b3e04b52b2e7eb$export$5ac61cba82e41a23 = (0, $c3dK3.z).enum($38b3e04b52b2e7eb$export$651548ae3cf5e245);
const $38b3e04b52b2e7eb$var$resource = {
    de: $eec76cf4bbe969eb$export$2e2bcd8739ae039,
    en: $4d64353670dee0c6$export$2e2bcd8739ae039,
    es: $f0cc21b4d8d130f6$export$2e2bcd8739ae039,
    fr: $fe16315c7ff1471f$export$2e2bcd8739ae039,
    it: $d32334d00d3454d4$export$2e2bcd8739ae039,
    ja: $03378f07cb499b7e$export$2e2bcd8739ae039,
    ko: $4190c12a9fcb9924$export$2e2bcd8739ae039,
    "pl-PL": (0, $a03ab5a56a0372f5$export$2e2bcd8739ae039),
    "pt-PT": (0, $99db7dcf32d1350b$export$2e2bcd8739ae039),
    "pt-BR": (0, $db790d13c8a3e8fe$export$2e2bcd8739ae039),
    ru: $b31e9cc5d8ae5824$export$2e2bcd8739ae039,
    "tr-TR": (0, $d07d15a854fd1aef$export$2e2bcd8739ae039),
    "zh-CN": (0, $05c0f581b5030e2a$export$2e2bcd8739ae039),
    "zh-HK": (0, $d82c06cfc1d04a1e$export$2e2bcd8739ae039),
    "zh-TW": (0, $aeac828e5930b2be$export$2e2bcd8739ae039)
};
const $38b3e04b52b2e7eb$export$559ef0bafb7e082f = (language)=>$38b3e04b52b2e7eb$export$5ac61cba82e41a23.or((0, $eRB1v.fallback)("en")).parse(language);
const $38b3e04b52b2e7eb$export$562f9b4f03c85f6c = (language)=>$38b3e04b52b2e7eb$export$5ac61cba82e41a23.safeParse(language).success;
var $38b3e04b52b2e7eb$export$2e2bcd8739ae039 = $38b3e04b52b2e7eb$var$resource;


parcelRequire("12bMu");
var $6cnHd = parcelRequire("6cnHd");

var $jC8Vy = parcelRequire("jC8Vy");

var $voszV = parcelRequire("voszV");

var $7VnwS = parcelRequire("7VnwS");
const $765bafc6430f5f30$var$useUiLanguages = ()=>{
    const { data: customPhraseList, error: error, mutate: mutate } = (0, $voszV.default)("api/custom-phrases");
    const languages = (0, $jC8Vy.useMemo)(()=>(0, $6cnHd.deduplicate)([
            ...(0, $38b3e04b52b2e7eb$export$651548ae3cf5e245),
            ...customPhraseList?.map(({ languageTag: languageTag })=>languageTag) ?? []
        ]).slice().sort(), [
        customPhraseList
    ]);
    const api = (0, $7VnwS.default)();
    const addLanguage = (0, $jC8Vy.useCallback)(async (languageTag)=>{
        await api.put(`api/custom-phrases/${languageTag}`, {
            json: {}
        });
        await mutate();
    }, [
        api,
        mutate
    ]);
    return {
        customPhrases: customPhraseList,
        languages: languages,
        error: error,
        isLoading: !customPhraseList && !error,
        addLanguage: addLanguage,
        mutate: mutate
    };
};
var $765bafc6430f5f30$export$2e2bcd8739ae039 = $765bafc6430f5f30$var$useUiLanguages;


var $991bcf39d90d7c30$exports = {};

$parcel$export($991bcf39d90d7c30$exports, "dark", function () { return $991bcf39d90d7c30$export$55ce6f3a06c59543; }, function (v) { return $991bcf39d90d7c30$export$55ce6f3a06c59543 = v; });
$parcel$export($991bcf39d90d7c30$exports, "device", function () { return $991bcf39d90d7c30$export$91cea577896d70d9; }, function (v) { return $991bcf39d90d7c30$export$91cea577896d70d9 = v; });
$parcel$export($991bcf39d90d7c30$exports, "deviceWrapper", function () { return $991bcf39d90d7c30$export$798a0bc8ea81196c; }, function (v) { return $991bcf39d90d7c30$export$798a0bc8ea81196c = v; });
$parcel$export($991bcf39d90d7c30$exports, "light", function () { return $991bcf39d90d7c30$export$a43af521ac8c3202; }, function (v) { return $991bcf39d90d7c30$export$a43af521ac8c3202 = v; });
$parcel$export($991bcf39d90d7c30$exports, "mobile", function () { return $991bcf39d90d7c30$export$1c4e7a9c31a6c071; }, function (v) { return $991bcf39d90d7c30$export$1c4e7a9c31a6c071 = v; });
$parcel$export($991bcf39d90d7c30$exports, "preview", function () { return $991bcf39d90d7c30$export$48c2d0f2f545ac27; }, function (v) { return $991bcf39d90d7c30$export$48c2d0f2f545ac27 = v; });
$parcel$export($991bcf39d90d7c30$exports, "rotating", function () { return $991bcf39d90d7c30$export$bfd64c937657f93a; }, function (v) { return $991bcf39d90d7c30$export$bfd64c937657f93a = v; });
$parcel$export($991bcf39d90d7c30$exports, "shimmer", function () { return $991bcf39d90d7c30$export$4a6dd88bada4e7d2; }, function (v) { return $991bcf39d90d7c30$export$4a6dd88bada4e7d2 = v; });
$parcel$export($991bcf39d90d7c30$exports, "time", function () { return $991bcf39d90d7c30$export$2da9be4cfdb689b1; }, function (v) { return $991bcf39d90d7c30$export$2da9be4cfdb689b1 = v; });
$parcel$export($991bcf39d90d7c30$exports, "topBar", function () { return $991bcf39d90d7c30$export$ac052f74bbc68e2d; }, function (v) { return $991bcf39d90d7c30$export$ac052f74bbc68e2d = v; });
$parcel$export($991bcf39d90d7c30$exports, "web", function () { return $991bcf39d90d7c30$export$6fe8eed8ccd585ce; }, function (v) { return $991bcf39d90d7c30$export$6fe8eed8ccd585ce = v; });
var $991bcf39d90d7c30$export$55ce6f3a06c59543;
var $991bcf39d90d7c30$export$91cea577896d70d9;
var $991bcf39d90d7c30$export$798a0bc8ea81196c;
var $991bcf39d90d7c30$export$a43af521ac8c3202;
var $991bcf39d90d7c30$export$1c4e7a9c31a6c071;
var $991bcf39d90d7c30$export$48c2d0f2f545ac27;
var $991bcf39d90d7c30$export$bfd64c937657f93a;
var $991bcf39d90d7c30$export$4a6dd88bada4e7d2;
var $991bcf39d90d7c30$export$2da9be4cfdb689b1;
var $991bcf39d90d7c30$export$ac052f74bbc68e2d;
var $991bcf39d90d7c30$export$6fe8eed8ccd585ce;
$991bcf39d90d7c30$export$55ce6f3a06c59543 = `_25xENG_dark`;
$991bcf39d90d7c30$export$91cea577896d70d9 = `_25xENG_device`;
$991bcf39d90d7c30$export$798a0bc8ea81196c = `_25xENG_deviceWrapper`;
$991bcf39d90d7c30$export$a43af521ac8c3202 = `_25xENG_light`;
$991bcf39d90d7c30$export$1c4e7a9c31a6c071 = `_25xENG_mobile`;
$991bcf39d90d7c30$export$48c2d0f2f545ac27 = `_25xENG_preview`;
$991bcf39d90d7c30$export$bfd64c937657f93a = `_25xENG_rotating`;
$991bcf39d90d7c30$export$4a6dd88bada4e7d2 = `_25xENG_shimmer`;
$991bcf39d90d7c30$export$2da9be4cfdb689b1 = `_25xENG_time`;
$991bcf39d90d7c30$export$ac052f74bbc68e2d = `_25xENG_topBar`;
$991bcf39d90d7c30$export$6fe8eed8ccd585ce = `_25xENG_web`;


var $c7bba22dd963ec53$export$70866093e58553f7;
(function(PreviewPlatform) {
    PreviewPlatform["DesktopWeb"] = "desktopWeb";
    PreviewPlatform["Mobile"] = "mobile";
    PreviewPlatform["MobileWeb"] = "mobileWeb";
})($c7bba22dd963ec53$export$70866093e58553f7 || ($c7bba22dd963ec53$export$70866093e58553f7 = {}));



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");

var $5UrGx = parcelRequire("5UrGx");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $ea37fb77f0fcb950$var$SvgMoon = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M14.427 8.667a.667.667 0 0 0-.7-.094 5.367 5.367 0 0 1-2.247.487 5.433 5.433 0 0 1-5.427-5.4c.003-.45.06-.897.167-1.333a.667.667 0 0 0-.887-.754 6.76 6.76 0 1 0 9.334 7.794.667.667 0 0 0-.24-.7Zm-6.334 4.46A5.426 5.426 0 0 1 4.72 3.48v.18a6.767 6.767 0 0 0 8.16 6.613 5.406 5.406 0 0 1-4.787 2.88v-.026Z",
            fill: "currentColor"
        })
    });
var $ea37fb77f0fcb950$export$2e2bcd8739ae039 = $ea37fb77f0fcb950$var$SvgMoon;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $27f10d17d89e21f7$var$SvgSun = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M3.333 8a.667.667 0 0 0-.666-.667H2a.667.667 0 0 0 0 1.334h.667A.667.667 0 0 0 3.333 8Zm.427 3.333-.473.474a.667.667 0 0 0 0 .94.667.667 0 0 0 .94 0l.473-.474a.667.667 0 0 0-.94-.94Zm4.24-8a.667.667 0 0 0 .667-.666V2a.667.667 0 1 0-1.334 0v.667A.667.667 0 0 0 8 3.333Zm3.773 1.56c.175 0 .343-.07.467-.193l.473-.473a.667.667 0 1 0-.94-.94l-.44.473a.667.667 0 0 0 .44 1.133Zm-8-.193a.667.667 0 0 0 1.134-.47.667.667 0 0 0-.194-.47l-.473-.473a.67.67 0 1 0-.953.94l.486.473ZM14 7.333h-.667a.667.667 0 1 0 0 1.334H14a.667.667 0 1 0 0-1.334Zm-1.76 4a.667.667 0 0 0-.907.907l.474.473a.667.667 0 0 0 .94 0 .666.666 0 0 0 0-.94l-.507-.44Zm-4.24-7A3.667 3.667 0 1 0 11.667 8 3.674 3.674 0 0 0 8 4.333Zm0 6a2.333 2.333 0 1 1 0-4.666 2.333 2.333 0 0 1 0 4.666Zm0 2.334a.667.667 0 0 0-.667.666V14a.667.667 0 1 0 1.334 0v-.667A.667.667 0 0 0 8 12.667Z",
            fill: "currentColor"
        })
    });
var $27f10d17d89e21f7$export$2e2bcd8739ae039 = $27f10d17d89e21f7$var$SvgSun;



var $jGWQ4 = parcelRequire("jGWQ4");
var $08fc4ea739e2bd9c$exports = {};

$parcel$export($08fc4ea739e2bd9c$exports, "button", function () { return $08fc4ea739e2bd9c$export$2ba01fb71ed41cb6; }, function (v) { return $08fc4ea739e2bd9c$export$2ba01fb71ed41cb6 = v; });
$parcel$export($08fc4ea739e2bd9c$exports, "container", function () { return $08fc4ea739e2bd9c$export$34e0f9847d4c02dd; }, function (v) { return $08fc4ea739e2bd9c$export$34e0f9847d4c02dd = v; });
$parcel$export($08fc4ea739e2bd9c$exports, "icon", function () { return $08fc4ea739e2bd9c$export$1ca1ec8b29a4ce27; }, function (v) { return $08fc4ea739e2bd9c$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($08fc4ea739e2bd9c$exports, "large", function () { return $08fc4ea739e2bd9c$export$f09585a853dddd32; }, function (v) { return $08fc4ea739e2bd9c$export$f09585a853dddd32 = v; });
$parcel$export($08fc4ea739e2bd9c$exports, "medium", function () { return $08fc4ea739e2bd9c$export$649ecc744817b5c7; }, function (v) { return $08fc4ea739e2bd9c$export$649ecc744817b5c7 = v; });
$parcel$export($08fc4ea739e2bd9c$exports, "rotating", function () { return $08fc4ea739e2bd9c$export$bfd64c937657f93a; }, function (v) { return $08fc4ea739e2bd9c$export$bfd64c937657f93a = v; });
$parcel$export($08fc4ea739e2bd9c$exports, "shimmer", function () { return $08fc4ea739e2bd9c$export$4a6dd88bada4e7d2; }, function (v) { return $08fc4ea739e2bd9c$export$4a6dd88bada4e7d2 = v; });
$parcel$export($08fc4ea739e2bd9c$exports, "small", function () { return $08fc4ea739e2bd9c$export$3c17b0e969a90510; }, function (v) { return $08fc4ea739e2bd9c$export$3c17b0e969a90510 = v; });
var $08fc4ea739e2bd9c$export$2ba01fb71ed41cb6;
var $08fc4ea739e2bd9c$export$34e0f9847d4c02dd;
var $08fc4ea739e2bd9c$export$1ca1ec8b29a4ce27;
var $08fc4ea739e2bd9c$export$f09585a853dddd32;
var $08fc4ea739e2bd9c$export$649ecc744817b5c7;
var $08fc4ea739e2bd9c$export$bfd64c937657f93a;
var $08fc4ea739e2bd9c$export$4a6dd88bada4e7d2;
var $08fc4ea739e2bd9c$export$3c17b0e969a90510;
$08fc4ea739e2bd9c$export$2ba01fb71ed41cb6 = `DiRmtq_button`;
$08fc4ea739e2bd9c$export$34e0f9847d4c02dd = `DiRmtq_container`;
$08fc4ea739e2bd9c$export$1ca1ec8b29a4ce27 = `DiRmtq_icon`;
$08fc4ea739e2bd9c$export$f09585a853dddd32 = `DiRmtq_large`;
$08fc4ea739e2bd9c$export$649ecc744817b5c7 = `DiRmtq_medium`;
$08fc4ea739e2bd9c$export$bfd64c937657f93a = `DiRmtq_rotating`;
$08fc4ea739e2bd9c$export$4a6dd88bada4e7d2 = `DiRmtq_shimmer`;
$08fc4ea739e2bd9c$export$3c17b0e969a90510 = `DiRmtq_small`;


function $976b01dd35b7d62e$var$ToggleUiThemeButton({ value: value, onToggle: onToggle, className: className, iconClassName: iconClassName, size: size = "medium" }) {
    const ThemeIcon = value === (0, $5HVJe.Theme).Light ? (0, $27f10d17d89e21f7$export$2e2bcd8739ae039) : (0, $ea37fb77f0fcb950$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($08fc4ea739e2bd9c$exports.container, $08fc4ea739e2bd9c$exports[size]),
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
            size: size,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($08fc4ea739e2bd9c$exports.button, className),
            icon: /*#__PURE__*/ (0, $C7mD2.jsx)(ThemeIcon, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($08fc4ea739e2bd9c$exports.icon, iconClassName)
            }),
            onClick: ()=>{
                onToggle(value === (0, $5HVJe.Theme).Light ? (0, $5HVJe.Theme).Dark : (0, $5HVJe.Theme).Light);
            }
        })
    });
}
var $976b01dd35b7d62e$export$2e2bcd8739ae039 = $976b01dd35b7d62e$var$ToggleUiThemeButton;


function $c9efa648520f22cb$var$SignInExperiencePreview({ platform: platform, mode: mode, language: language = "en", signInExperience: signInExperience, endpoint: endpointInput }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { customPhrases: customPhrases } = (0, $765bafc6430f5f30$export$2e2bcd8739ae039)();
    const { tenantEndpoint: tenantEndpoint } = (0, $jC8Vy.useContext)((0, $fG7L1.AppDataContext));
    const endpoint = endpointInput ?? tenantEndpoint;
    const previewRef = (0, $jC8Vy.useRef)(null);
    const { data: allConnectors } = (0, $voszV.default)("api/connectors");
    const [iframeLoaded, setIframeLoaded] = (0, $jC8Vy.useState)(false);
    const configForUiPage = (0, $jC8Vy.useMemo)(()=>{
        if (!allConnectors || !signInExperience) return;
        const socialConnectors = signInExperience.socialSignInConnectorTargets.reduce((previous, connectorTarget)=>[
                ...previous,
                ...allConnectors.filter(({ target: target })=>target === connectorTarget)
            ], []);
        const hasEmailConnector = allConnectors.some(({ type: type })=>type === (0, $kowfT.ConnectorType).Email);
        const hasSmsConnector = allConnectors.some(({ type: type })=>type === (0, $kowfT.ConnectorType).Sms);
        return {
            signInExperience: {
                ...signInExperience,
                socialConnectors: socialConnectors,
                forgotPassword: {
                    email: hasEmailConnector,
                    sms: hasSmsConnector
                }
            },
            language: language,
            mode: mode,
            platform: platform === (0, $c7bba22dd963ec53$export$70866093e58553f7).DesktopWeb ? "web" : "mobile",
            isNative: platform === (0, $c7bba22dd963ec53$export$70866093e58553f7).Mobile
        };
    }, [
        allConnectors,
        language,
        mode,
        platform,
        signInExperience
    ]);
    const postPreviewMessage = (0, $jC8Vy.useCallback)(()=>{
        if (!configForUiPage || !customPhrases) return;
        previewRef.current?.contentWindow?.postMessage({
            sender: "ac_preview",
            config: configForUiPage
        }, endpoint?.origin ?? "");
    }, [
        endpoint?.origin,
        configForUiPage,
        customPhrases
    ]);
    const iframeOnLoadEventHandler = (0, $jC8Vy.useCallback)(()=>{
        setIframeLoaded(true);
    }, []);
    (0, $jC8Vy.useEffect)(()=>{
        const iframe = previewRef.current;
        iframe?.addEventListener("load", iframeOnLoadEventHandler);
        return ()=>{
            iframe?.removeEventListener("load", iframeOnLoadEventHandler);
        };
    }, [
        iframeLoaded,
        iframeOnLoadEventHandler
    ]);
    (0, $jC8Vy.useEffect)(()=>{
        if (!iframeLoaded) return;
        postPreviewMessage();
    }, [
        iframeLoaded,
        postPreviewMessage
    ]);
    if (!endpoint) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($991bcf39d90d7c30$exports.preview, platform === (0, $c7bba22dd963ec53$export$70866093e58553f7).DesktopWeb ? $991bcf39d90d7c30$exports.web : $991bcf39d90d7c30$exports.mobile),
        style: (0, $7oDSS.conditional)(platform === (0, $c7bba22dd963ec53$export$70866093e58553f7).DesktopWeb && {
            // Set background color to match iframe's background color on both dark and light mode.
            backgroundColor: mode === (0, $5HVJe.Theme).Dark ? "#000" : "#e5e1ec"
        }),
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
            className: $991bcf39d90d7c30$exports.deviceWrapper,
            children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($991bcf39d90d7c30$exports.device, $991bcf39d90d7c30$exports[String(mode)]),
                children: [
                    platform !== (0, $c7bba22dd963ec53$export$70866093e58553f7).DesktopWeb && /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $991bcf39d90d7c30$exports.topBar,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $991bcf39d90d7c30$exports.time,
                                children: (0, $9aa0641d843cb9a1$export$2e2bcd8739ae039)(Date.now(), "HH:mm")
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $103ec52349a309e9$export$2e2bcd8739ae039), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("iframe", {
                        ref: previewRef,
                        // Allow all sandbox rules
                        sandbox: undefined,
                        src: new URL("/sign-in?preview=true", endpoint).toString(),
                        tabIndex: -1,
                        title: t("sign_in_exp.preview.title")
                    })
                ]
            })
        })
    });
}
var $c9efa648520f22cb$export$2e2bcd8739ae039 = $c9efa648520f22cb$var$SignInExperiencePreview;




var $C7mD2 = parcelRequire("C7mD2");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $b93f65ea78fb0de4$var$SvgConnectorPlatformIconNative = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "m8.473 10.86-.1-.08a.508.508 0 0 0-.12-.06l-.12-.053a.667.667 0 0 0-.606.18.766.766 0 0 0-.14.22.667.667 0 0 0 .867.873.974.974 0 0 0 .22-.147.667.667 0 0 0 0-.933Zm2.194-9.527H5.334a2 2 0 0 0-2 2v9.334a2 2 0 0 0 2 2h5.333a2 2 0 0 0 2-2V3.333a2 2 0 0 0-2-2Zm.667 11.334a.666.666 0 0 1-.667.666H5.334a.667.667 0 0 1-.667-.666V3.333a.667.667 0 0 1 .667-.666h5.333a.667.667 0 0 1 .667.666v9.334Z",
            fill: "currentColor"
        })
    });
var $b93f65ea78fb0de4$export$2e2bcd8739ae039 = $b93f65ea78fb0de4$var$SvgConnectorPlatformIconNative;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $3c153d09ac05a655$var$SvgConnectorPlatformIconWeb = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M12.667 2H3.333a2 2 0 0 0-2 2v5.333a2 2 0 0 0 2 2h4v1.334H4.668a.667.667 0 1 0 0 1.333h6.667a.666.666 0 1 0 0-1.333H8.667v-1.334h4a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Zm.667 7.333a.666.666 0 0 1-.667.667H3.333a.667.667 0 0 1-.666-.667V4a.667.667 0 0 1 .667-.667h9.333a.667.667 0 0 1 .667.667v5.333Z",
            fill: "currentColor"
        })
    });
var $3c153d09ac05a655$export$2e2bcd8739ae039 = $3c153d09ac05a655$var$SvgConnectorPlatformIconWeb;




var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $66ixW = parcelRequire("66ixW");

var $bnkR4 = parcelRequire("bnkR4");
var $1c8a6a68b6dc34ab$export$1ca1ec8b29a4ce27;
var $1c8a6a68b6dc34ab$export$bfd64c937657f93a;
var $1c8a6a68b6dc34ab$export$d90250155de6d7e7;
var $1c8a6a68b6dc34ab$export$4a6dd88bada4e7d2;
var $1c8a6a68b6dc34ab$export$62d58b1c91e8e902;
$1c8a6a68b6dc34ab$export$1ca1ec8b29a4ce27 = `FYb9iq_icon`;
$1c8a6a68b6dc34ab$export$bfd64c937657f93a = `FYb9iq_rotating`;
$1c8a6a68b6dc34ab$export$d90250155de6d7e7 = `FYb9iq_selected`;
$1c8a6a68b6dc34ab$export$4a6dd88bada4e7d2 = `FYb9iq_shimmer`;
$1c8a6a68b6dc34ab$export$62d58b1c91e8e902 = `FYb9iq_tab`;


function $7f6d43967a36a046$var$PlatformTab({ isSelected: isSelected, icon: icon, title: title, tab: tab, onClick: onClick }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        role: "tab",
        tabIndex: 0,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($1c8a6a68b6dc34ab$export$62d58b1c91e8e902, isSelected && $1c8a6a68b6dc34ab$export$d90250155de6d7e7),
        onClick: ()=>{
            onClick(tab);
        },
        onKeyDown: (0, $bnkR4.onKeyDownHandler)(()=>{
            onClick(tab);
        }),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                className: $1c8a6a68b6dc34ab$export$1ca1ec8b29a4ce27,
                children: icon
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                forKey: title
            })
        ]
    });
}
var $7f6d43967a36a046$export$2e2bcd8739ae039 = $7f6d43967a36a046$var$PlatformTab;


var $ee673647b5967d23$export$34e0f9847d4c02dd;
var $ee673647b5967d23$export$bfd64c937657f93a;
var $ee673647b5967d23$export$4a6dd88bada4e7d2;
$ee673647b5967d23$export$34e0f9847d4c02dd = `taJSVa_container`;
$ee673647b5967d23$export$bfd64c937657f93a = `taJSVa_rotating`;
$ee673647b5967d23$export$4a6dd88bada4e7d2 = `taJSVa_shimmer`;


function $1da696e71a415ef4$var$PlatformTabs({ currentTab: currentTab, onSelect: onSelect }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $ee673647b5967d23$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7f6d43967a36a046$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3c153d09ac05a655$export$2e2bcd8739ae039), {}),
                title: "cloud.sie.preview.web_tab",
                tab: (0, $c7bba22dd963ec53$export$70866093e58553f7).DesktopWeb,
                isSelected: currentTab === (0, $c7bba22dd963ec53$export$70866093e58553f7).DesktopWeb,
                onClick: onSelect
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7f6d43967a36a046$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $b93f65ea78fb0de4$export$2e2bcd8739ae039), {}),
                title: "cloud.sie.preview.mobile_tab",
                tab: (0, $c7bba22dd963ec53$export$70866093e58553f7).MobileWeb,
                isSelected: currentTab === (0, $c7bba22dd963ec53$export$70866093e58553f7).MobileWeb,
                onClick: onSelect
            })
        ]
    });
}
var $1da696e71a415ef4$export$2e2bcd8739ae039 = $1da696e71a415ef4$var$PlatformTabs;


var $0103fd672f1c9d51$export$34e0f9847d4c02dd;
var $0103fd672f1c9d51$export$bfd64c937657f93a;
var $0103fd672f1c9d51$export$4a6dd88bada4e7d2;
$0103fd672f1c9d51$export$34e0f9847d4c02dd = `aEpV7G_container`;
$0103fd672f1c9d51$export$bfd64c937657f93a = `aEpV7G_rotating`;
$0103fd672f1c9d51$export$4a6dd88bada4e7d2 = `aEpV7G_shimmer`;


function $2bf96b5d2d743d1e$var$Preview({ signInExperience: signInExperience, className: className, endpoint: endpoint }) {
    const [currentTab, setCurrentTab] = (0, $jC8Vy.useState)((0, $c7bba22dd963ec53$export$70866093e58553f7).DesktopWeb);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($0103fd672f1c9d51$export$34e0f9847d4c02dd, className),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1da696e71a415ef4$export$2e2bcd8739ae039), {
                currentTab: currentTab,
                onSelect: setCurrentTab
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c9efa648520f22cb$export$2e2bcd8739ae039), {
                platform: currentTab,
                mode: (0, $5HVJe.Theme).Light,
                signInExperience: signInExperience,
                endpoint: endpoint
            })
        ]
    });
}
var $2bf96b5d2d743d1e$export$2e2bcd8739ae039 = $2bf96b5d2d743d1e$var$Preview;



var $C7mD2 = parcelRequire("C7mD2");

var $e2ecaff0bc9d0e52$export$3e4dd27034fea0be;
var $e2ecaff0bc9d0e52$export$e506a1d27d1eaa20;
var $e2ecaff0bc9d0e52$export$a7db06668cad9adb;
var $e2ecaff0bc9d0e52$export$e8c278056cb4f639;
var $e2ecaff0bc9d0e52$export$48c2d0f2f545ac27;
var $e2ecaff0bc9d0e52$export$bfd64c937657f93a;
var $e2ecaff0bc9d0e52$export$4a6dd88bada4e7d2;
$e2ecaff0bc9d0e52$export$3e4dd27034fea0be = `N3FFUG_authnSelector`;
$e2ecaff0bc9d0e52$export$e506a1d27d1eaa20 = `N3FFUG_config`;
$e2ecaff0bc9d0e52$export$a7db06668cad9adb = `N3FFUG_content`;
$e2ecaff0bc9d0e52$export$e8c278056cb4f639 = `N3FFUG_continueActions`;
$e2ecaff0bc9d0e52$export$48c2d0f2f545ac27 = `N3FFUG_preview`;
$e2ecaff0bc9d0e52$export$bfd64c937657f93a = `N3FFUG_rotating`;
$e2ecaff0bc9d0e52$export$4a6dd88bada4e7d2 = `N3FFUG_shimmer`;


var $69197fe5992a49ee$export$e324594224ef24da;
var $69197fe5992a49ee$export$2ba01fb71ed41cb6;
var $69197fe5992a49ee$export$e0f35d825088c098;
var $69197fe5992a49ee$export$75c751978d4a1350;
var $69197fe5992a49ee$export$38e42c68cf43b5d4;
var $69197fe5992a49ee$export$db3c28d99448dcff;
var $69197fe5992a49ee$export$1c4e7a9c31a6c071;
var $69197fe5992a49ee$export$48c2d0f2f545ac27;
var $69197fe5992a49ee$export$bfd64c937657f93a;
var $69197fe5992a49ee$export$4a6dd88bada4e7d2;
var $69197fe5992a49ee$export$f30f1338f6f15619;
var $69197fe5992a49ee$export$32bc0991cdcef676;
var $69197fe5992a49ee$export$cba3d3852a039325;
var $69197fe5992a49ee$export$fb184b623420d9be;
$69197fe5992a49ee$export$e324594224ef24da = `OZpvHa_actions`;
$69197fe5992a49ee$export$2ba01fb71ed41cb6 = `OZpvHa_button`;
$69197fe5992a49ee$export$e0f35d825088c098 = `OZpvHa_field`;
$69197fe5992a49ee$export$75c751978d4a1350 = `OZpvHa_fieldWrapper`;
$69197fe5992a49ee$export$38e42c68cf43b5d4 = `OZpvHa_header`;
$69197fe5992a49ee$export$db3c28d99448dcff = `OZpvHa_logo`;
$69197fe5992a49ee$export$1c4e7a9c31a6c071 = `OZpvHa_mobile`;
$69197fe5992a49ee$export$48c2d0f2f545ac27 = `OZpvHa_preview`;
$69197fe5992a49ee$export$bfd64c937657f93a = `OZpvHa_rotating`;
$69197fe5992a49ee$export$4a6dd88bada4e7d2 = `OZpvHa_shimmer`;
$69197fe5992a49ee$export$4a6dd88bada4e7d2;
$69197fe5992a49ee$export$f30f1338f6f15619 = `OZpvHa_slogan`;
$69197fe5992a49ee$export$32bc0991cdcef676 = `OZpvHa_smallButton`;
$69197fe5992a49ee$export$cba3d3852a039325 = `OZpvHa_social`;
$69197fe5992a49ee$export$fb184b623420d9be = `OZpvHa_title`;


function $102a4843e367a27b$var$Skeleton() {
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: $150021613750da2d$export$523fb3936f49e028,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
            className: $150021613750da2d$export$8f981dffec84ba52,
            children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $e2ecaff0bc9d0e52$export$a7db06668cad9adb,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $e2ecaff0bc9d0e52$export$e506a1d27d1eaa20,
                        children: Array.from({
                            length: 3
                        }).map((_, index)=>// eslint-disable-next-line react/no-array-index-key
                            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                className: $69197fe5992a49ee$export$75c751978d4a1350,
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $69197fe5992a49ee$export$fb184b623420d9be
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $69197fe5992a49ee$export$e0f35d825088c098
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $69197fe5992a49ee$export$e0f35d825088c098
                                    })
                                ]
                            }, index))
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $69197fe5992a49ee$export$48c2d0f2f545ac27,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                className: $69197fe5992a49ee$export$38e42c68cf43b5d4,
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $69197fe5992a49ee$export$2ba01fb71ed41cb6
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                        className: $69197fe5992a49ee$export$e324594224ef24da,
                                        children: [
                                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                className: $69197fe5992a49ee$export$32bc0991cdcef676
                                            }),
                                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                className: $69197fe5992a49ee$export$2ba01fb71ed41cb6
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                className: $69197fe5992a49ee$export$1c4e7a9c31a6c071,
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $69197fe5992a49ee$export$db3c28d99448dcff
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $69197fe5992a49ee$export$f30f1338f6f15619
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $69197fe5992a49ee$export$e0f35d825088c098
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $69197fe5992a49ee$export$e0f35d825088c098
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $69197fe5992a49ee$export$2ba01fb71ed41cb6
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $69197fe5992a49ee$export$cba3d3852a039325
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
var $102a4843e367a27b$export$2e2bcd8739ae039 = $102a4843e367a27b$var$Skeleton;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $kowfT = parcelRequire("kowfT");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");

var $5UrGx = parcelRequire("5UrGx");


var $jheqv = parcelRequire("jheqv");
var $54c646ccbdb432ee$exports = {};

$parcel$export($54c646ccbdb432ee$exports, "container", function () { return $54c646ccbdb432ee$export$34e0f9847d4c02dd; }, function (v) { return $54c646ccbdb432ee$export$34e0f9847d4c02dd = v; });
$parcel$export($54c646ccbdb432ee$exports, "large", function () { return $54c646ccbdb432ee$export$f09585a853dddd32; }, function (v) { return $54c646ccbdb432ee$export$f09585a853dddd32 = v; });
$parcel$export($54c646ccbdb432ee$exports, "logo", function () { return $54c646ccbdb432ee$export$db3c28d99448dcff; }, function (v) { return $54c646ccbdb432ee$export$db3c28d99448dcff = v; });
$parcel$export($54c646ccbdb432ee$exports, "small", function () { return $54c646ccbdb432ee$export$3c17b0e969a90510; }, function (v) { return $54c646ccbdb432ee$export$3c17b0e969a90510 = v; });
var $54c646ccbdb432ee$export$34e0f9847d4c02dd;
var $54c646ccbdb432ee$export$f09585a853dddd32;
var $54c646ccbdb432ee$export$db3c28d99448dcff;
var $54c646ccbdb432ee$export$3c17b0e969a90510;
$54c646ccbdb432ee$export$34e0f9847d4c02dd = `Am3ekq_container`;
$54c646ccbdb432ee$export$f09585a853dddd32 = `Am3ekq_large`;
$54c646ccbdb432ee$export$db3c28d99448dcff = `Am3ekq_logo`;
$54c646ccbdb432ee$export$3c17b0e969a90510 = `Am3ekq_small`;


function $34186e61374ae5f6$var$ConnectorLogo({ className: className, data: data, size: size = "medium" }) {
    const theme = (0, $jheqv.default)();
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dbaecc0d7fe55772$export$2e2bcd8739ae039), {
        containerClassName: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($54c646ccbdb432ee$exports.container, $54c646ccbdb432ee$exports[size]),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($54c646ccbdb432ee$exports.logo, $54c646ccbdb432ee$exports[size], className),
        alt: "logo",
        src: theme === (0, $5HVJe.Theme).Dark && data.logoDark ? data.logoDark : data.logo
    });
}
var $34186e61374ae5f6$export$2e2bcd8739ae039 = $34186e61374ae5f6$var$ConnectorLogo;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
function $ee1df03577241ccd$var$UnnamedTrans({ resource: resource, className: className }) {
    const { i18n: { languages: languages } } = (0, $5OuPq.useTranslation)();
    const matchedLanguage = languages.find((language)=>resource[language]);
    if (!matchedLanguage) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
        className: className,
        children: resource[matchedLanguage]
    });
}
var $ee1df03577241ccd$export$2e2bcd8739ae039 = $ee1df03577241ccd$var$UnnamedTrans;



var $8R7rc = parcelRequire("8R7rc");



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $8lyC3 = parcelRequire("8lyC3");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $92dd067ef183ee5b$var$SvgEnvelop = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M14.167 9.167H15a.833.833 0 0 0 .833-.834V7.5A.833.833 0 0 0 15 6.667h-.833a.833.833 0 0 0-.834.833v.833a.834.834 0 0 0 .834.834ZM5 10h4.167a.833.833 0 1 0 0-1.667H5A.833.833 0 0 0 5 10Zm13.333-6.667H1.667a.833.833 0 0 0-.834.834v11.666a.833.833 0 0 0 .834.834h16.666a.833.833 0 0 0 .834-.834V4.167a.833.833 0 0 0-.834-.834ZM17.5 15h-15V5h15v10ZM5 13.333h4.167a.833.833 0 1 0 0-1.666H5a.833.833 0 0 0 0 1.666Z",
            fill: "currentColor"
        })
    });
var $92dd067ef183ee5b$export$2e2bcd8739ae039 = $92dd067ef183ee5b$var$SvgEnvelop;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $be934405c1735adc$var$SvgKeyboard = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M5.592 7.742a.833.833 0 0 0-1.184 0 .833.833 0 0 0-.175.275.833.833 0 0 0 .175.908.958.958 0 0 0 .275.175.7.7 0 0 0 .317.067.833.833 0 0 0 .767-1.15.833.833 0 0 0-.175-.275Zm2.741 1.425a.833.833 0 0 0 .767-1.15.833.833 0 0 0-.925-.517.5.5 0 0 0-.158.05l-.15.075-.125.1a.875.875 0 0 0-.242.608.833.833 0 0 0 .833.834ZM5.317 10.9a.834.834 0 0 0-1.15.767.833.833 0 0 0 1.15.766.959.959 0 0 0 .275-.175.834.834 0 0 0 .241-.591.833.833 0 0 0-.241-.592.776.776 0 0 0-.275-.175Zm6.35-.067H8.333a.834.834 0 0 0 0 1.667h3.334a.833.833 0 1 0 0-1.667Zm.591-3.091a.833.833 0 0 0-1.183 0 .832.832 0 0 0-.175.275.833.833 0 1 0 1.6.316.7.7 0 0 0-.067-.316.832.832 0 0 0-.175-.275Zm3.209 3.233a.636.636 0 0 0-.15-.075.834.834 0 0 0-.634 0 .958.958 0 0 0-.275.175.875.875 0 0 0-.241.592.833.833 0 1 0 1.666 0 .875.875 0 0 0-.241-.592l-.125-.1Zm1.2-6.808H3.333a2.5 2.5 0 0 0-2.5 2.5v6.666a2.5 2.5 0 0 0 2.5 2.5h13.334a2.5 2.5 0 0 0 2.5-2.5V6.667a2.5 2.5 0 0 0-2.5-2.5Zm.833 9.166a.833.833 0 0 1-.833.834H3.333a.833.833 0 0 1-.833-.834V6.667a.833.833 0 0 1 .833-.834h13.334a.833.833 0 0 1 .833.834v6.666Zm-1.908-5.591a.833.833 0 0 0-1.425.591.834.834 0 1 0 1.6-.316.832.832 0 0 0-.175-.275Z",
            fill: "currentColor"
        })
    });
var $be934405c1735adc$export$2e2bcd8739ae039 = $be934405c1735adc$var$SvgKeyboard;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $310d6e9b6c498ea3$var$SvgLabel = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 21,
        height: 20,
        viewBox: "0 0 21 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "m17.933 8.925-7.008-7.017a.834.834 0 0 0-.592-.241h-7.5A.833.833 0 0 0 2 2.5V10a.834.834 0 0 0 .242.592L9.258 17.6a2.5 2.5 0 0 0 3.534 0l5.141-5.1a2.5 2.5 0 0 0 0-3.533v-.042Zm-1.175 2.35-5.15 5.142a.833.833 0 0 1-1.175 0L3.667 9.658V3.333h6.325l6.766 6.767a.832.832 0 0 1 0 1.175Z",
            fill: "currentColor"
        })
    });
var $310d6e9b6c498ea3$export$2e2bcd8739ae039 = $310d6e9b6c498ea3$var$SvgLabel;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $3c62412aa6c074e5$var$SvgLock = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M14.167 7.5V5.833a4.167 4.167 0 0 0-8.334 0V7.5a2.5 2.5 0 0 0-2.5 2.5v5.833a2.5 2.5 0 0 0 2.5 2.5h8.334a2.5 2.5 0 0 0 2.5-2.5V10a2.5 2.5 0 0 0-2.5-2.5ZM7.5 5.833a2.5 2.5 0 1 1 5 0V7.5h-5V5.833Zm7.5 10a.834.834 0 0 1-.833.834H5.833A.833.833 0 0 1 5 15.833V10a.833.833 0 0 1 .833-.833h8.334A.833.833 0 0 1 15 10v5.833Z",
            fill: "currentColor"
        })
    });
var $3c62412aa6c074e5$export$2e2bcd8739ae039 = $3c62412aa6c074e5$var$SvgLock;



var $8R7rc = parcelRequire("8R7rc");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $650d74e4e2a784bb$var$SvgSocialApple = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M15.457 10.625a4.522 4.522 0 0 1 2.161-3.805 4.672 4.672 0 0 0-3.658-1.984c-1.558-.158-3.04.917-3.829.917-.79 0-2.009-.894-3.3-.87a4.896 4.896 0 0 0-4.139 2.508c-1.762 3.06-.45 7.593 1.268 10.076C4.8 18.681 5.802 20.05 7.118 20c1.267-.05 1.746-.82 3.276-.82 1.531 0 1.962.82 3.301.795 1.363-.025 2.228-1.239 3.062-2.457a10.948 10.948 0 0 0 1.384-2.845 4.42 4.42 0 0 1-2.684-4.047ZM12.94 3.193A4.405 4.405 0 0 0 13.98 0a4.483 4.483 0 0 0-2.946 1.516 4.185 4.185 0 0 0-1.061 3.093 3.71 3.71 0 0 0 2.967-1.416Z",
            fill: "#000"
        })
    });
var $650d74e4e2a784bb$export$2e2bcd8739ae039 = $650d74e4e2a784bb$var$SvgSocialApple;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $7ee644fa333d0338$var$SvgSocialFacebook = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                clipPath: "url(#clip0_1812_100173)",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M20 10c0-5.523-4.477-10-10-10S0 4.477 0 10c0 4.992 3.656 9.129 8.438 9.879V12.89h-2.54V10h2.54V7.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.262c-1.242 0-1.629.772-1.629 1.563V10h2.774l-.443 2.89h-2.33v6.989C16.343 19.129 20 14.992 20 10Z",
                        fill: "#1877F2"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "m13.893 12.89.443-2.89h-2.774V8.125c0-.791.387-1.563 1.63-1.563h1.261v-2.46s-1.144-.196-2.238-.196c-2.285 0-3.777 1.385-3.777 3.89V10h-2.54v2.89h2.54v6.989a10.057 10.057 0 0 0 3.124 0V12.89h2.33Z",
                        fill: "#fff"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("defs", {
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("clipPath", {
                    id: "clip0_1812_100173",
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h20v20H0z"
                    })
                })
            })
        ]
    });
var $7ee644fa333d0338$export$2e2bcd8739ae039 = $7ee644fa333d0338$var$SvgSocialFacebook;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $b3f9828f6b67cb27$var$SvgSocialKakao = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                clipPath: "url(#clip0_1812_100162)",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M20 18.438C20 19.3 19.3 20 18.437 20H1.563C.7 20 0 19.3 0 18.437V1.563C0 .7.7 0 1.563 0h16.875C19.3 0 20 .7 20 1.563v16.875Z",
                        fill: "#FFE812"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M10 2.813c-4.487 0-8.125 2.868-8.125 6.406 0 2.287 1.52 4.294 3.808 5.428-.124.429-.8 2.76-.826 2.944 0 0-.016.138.073.19.089.053.194.012.194.012.255-.036 2.964-1.938 3.433-2.269.468.067.95.101 1.443.101 4.487 0 8.125-2.868 8.125-6.406S14.487 2.813 10 2.813Z",
                        fill: "#000"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M5.508 11.455a.46.46 0 0 1-.469-.448V8.223h-.731a.46.46 0 0 1 0-.918h2.4a.46.46 0 0 1 0 .918h-.731v2.784a.46.46 0 0 1-.47.448Zm4.11-.006c-.195 0-.345-.08-.39-.207l-.232-.608h-1.43l-.232.608c-.045.128-.194.207-.39.207a.716.716 0 0 1-.298-.065c-.129-.06-.253-.223-.11-.665l1.12-2.952c.08-.224.32-.455.625-.462.306.007.546.238.625.463l1.12 2.95c.143.443.02.607-.11.666a.717.717 0 0 1-.298.065ZM8.75 9.804l-.468-1.33-.468 1.33h.936Zm2.032 1.583a.44.44 0 0 1-.449-.43V7.773c0-.258.215-.468.478-.468.264 0 .48.21.48.468v2.754h.995a.44.44 0 0 1 .45.43.44.44 0 0 1-.45.43h-1.504Zm2.604.062a.47.47 0 0 1-.468-.469V7.773a.47.47 0 0 1 .937 0v1.008l1.308-1.308a.364.364 0 0 1 .26-.104c.117 0 .235.05.323.138a.462.462 0 0 1 .137.297.365.365 0 0 1-.103.286l-1.068 1.068 1.154 1.529a.465.465 0 0 1-.092.656.464.464 0 0 1-.492.046.467.467 0 0 1-.165-.138l-1.099-1.456-.163.162v1.023a.47.47 0 0 1-.468.469Z",
                        fill: "#FFE812"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("defs", {
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("clipPath", {
                    id: "clip0_1812_100162",
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        width: 20,
                        height: 20,
                        rx: 6,
                        fill: "#fff"
                    })
                })
            })
        ]
    });
var $b3f9828f6b67cb27$export$2e2bcd8739ae039 = $b3f9828f6b67cb27$var$SvgSocialKakao;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $e00a7839e62e96b0$var$SvgSocialMicrosoft = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 20,
        height: 20,
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 23 23",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M0 0h23v23H0z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#f35325",
                d: "M1 1h10v10H1z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#81bc06",
                d: "M12 1h10v10H12z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#05a6f0",
                d: "M1 12h10v10H1z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#ffba08",
                d: "M12 12h10v10H12z"
            })
        ]
    });
var $e00a7839e62e96b0$export$2e2bcd8739ae039 = $e00a7839e62e96b0$var$SvgSocialMicrosoft;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $852af28da5b1dc31$var$SvgSocialOidc = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                clipPath: "url(#clip0_390_81345)",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M20 11.5 19.5 7l-1.45.95C16.7 7.1 15 6.5 13.1 6.2c0 0-.95-.2-2.2-.2-1.25 0-2.4.15-2.4.15C3.65 6.75 0 9.5 0 12.8c0 3.4 3.75 6.2 9.5 6.7v-1.95c-3.95-.55-6.45-2.4-6.45-4.75 0-2.2 2.3-4.05 5.45-4.65 0 0 2.45-.55 4.6.1 1.05.25 2 .6 2.8 1.1L14 10.5l6 1Z",
                        fill: "#9E9E9E"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M9.5 2v17.5l3-1.5V.5L9.5 2Z",
                        fill: "#FF9800"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("defs", {
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("clipPath", {
                    id: "clip0_390_81345",
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h20v20H0z"
                    })
                })
            })
        ]
    });
var $852af28da5b1dc31$export$2e2bcd8739ae039 = $852af28da5b1dc31$var$SvgSocialOidc;



const $d43a9f120c3fe666$export$19ede94f671fb844 = [
    {
        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $92dd067ef183ee5b$export$2e2bcd8739ae039), {}),
        title: "sign_in_exp.sign_up_and_sign_in.identifiers_email",
        value: (0, $8lyC3.SignInIdentifier).Email
    },
    {
        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $310d6e9b6c498ea3$export$2e2bcd8739ae039), {}),
        title: "sign_in_exp.sign_up_and_sign_in.identifiers_username",
        value: (0, $8lyC3.SignInIdentifier).Username
    }
];
const $d43a9f120c3fe666$export$993274cb9b03d078 = [
    {
        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3c62412aa6c074e5$export$2e2bcd8739ae039), {}),
        title: "sign_in_exp.sign_up_and_sign_in.sign_in.password_auth",
        value: (0, $bae4bf33bd28496f$export$d9e3c9dc7eaad0c3).Password
    },
    {
        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $be934405c1735adc$export$2e2bcd8739ae039), {}),
        title: "sign_in_exp.sign_up_and_sign_in.sign_in.verification_code_auth",
        value: (0, $bae4bf33bd28496f$export$d9e3c9dc7eaad0c3).VerificationCode
    }
];
const $d43a9f120c3fe666$export$d5dcbb51002e85de = [
    {
        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $650d74e4e2a784bb$export$2e2bcd8739ae039), {}),
        title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8R7rc.default), {
            children: "Apple"
        }),
        value: "fake-apple",
        tag: "cloud.sie.connectors.unlocked_later",
        isDisabled: true,
        disabledTip: "cloud.sie.connectors.unlocked_later_tip"
    },
    {
        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7ee644fa333d0338$export$2e2bcd8739ae039), {}),
        title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8R7rc.default), {
            children: "Facebook"
        }),
        value: "fake-facebook",
        tag: "cloud.sie.connectors.unlocked_later",
        isDisabled: true,
        disabledTip: "cloud.sie.connectors.unlocked_later_tip"
    },
    {
        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e00a7839e62e96b0$export$2e2bcd8739ae039), {}),
        title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8R7rc.default), {
            children: "Microsoft"
        }),
        value: "fake-microsoft",
        tag: "cloud.sie.connectors.unlocked_later",
        isDisabled: true,
        disabledTip: "cloud.sie.connectors.unlocked_later_tip"
    },
    {
        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $b3f9828f6b67cb27$export$2e2bcd8739ae039), {}),
        title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8R7rc.default), {
            children: "Kakao"
        }),
        value: "fake-kakao",
        tag: "cloud.sie.connectors.unlocked_later",
        isDisabled: true,
        disabledTip: "cloud.sie.connectors.unlocked_later_tip"
    },
    {
        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $852af28da5b1dc31$export$2e2bcd8739ae039), {}),
        title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8R7rc.default), {
            children: "OIDC"
        }),
        value: "fake-oidc",
        tag: "cloud.sie.connectors.unlocked_later",
        isDisabled: true,
        disabledTip: "cloud.sie.connectors.unlocked_later_tip"
    }
];


function $63a49f7a7b8ed8c1$var$SocialSelector({ value: value, onChange: onChange }) {
    const { data: connectorData, error: error } = (0, $9d72639ba10eaeeb$export$2e2bcd8739ae039)();
    if (!connectorData || error) return null;
    const connectorOptions = connectorData.filter(({ type: type })=>type === (0, $kowfT.ConnectorType).Social).map((item)=>{
        return {
            icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $34186e61374ae5f6$export$2e2bcd8739ae039), {
                size: "small",
                data: item
            }),
            title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8R7rc.default), {
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ee1df03577241ccd$export$2e2bcd8739ae039), {
                    resource: item.name
                })
            }),
            value: item.target,
            tag: "general.demo"
        };
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9326dcdf6e771d52$export$2e2bcd8739ae039), {
        options: [
            ...connectorOptions,
            ...(0, $d43a9f120c3fe666$export$d5dcbb51002e85de)
        ],
        value: value,
        onChange: onChange
    });
}
var $63a49f7a7b8ed8c1$export$2e2bcd8739ae039 = $63a49f7a7b8ed8c1$var$SocialSelector;


parcelRequire("cuPVN");
var $8lyC3 = parcelRequire("8lyC3");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

const $d5817f69bef4e179$var$fromSignInExperience = (signInExperience)=>{
    const { color: { primaryColor: primaryColor }, branding: { logoUrl: logo }, signIn: { methods: signInMethods }, signUp: { identifiers: signUpIdentifiers }, socialSignInConnectorTargets: socialSignInConnectorTargets } = signInExperience;
    const identifier = signInMethods.find(({ identifier: identifier })=>signUpIdentifiers.includes(identifier))?.identifier ?? (0, $8lyC3.SignInIdentifier).Username;
    const authentications = signInMethods.reduce((result, method)=>{
        const { password: password, verificationCode: verificationCode } = method;
        return [
            ...result,
            ...password ? [
                (0, $bae4bf33bd28496f$export$d9e3c9dc7eaad0c3).Password
            ] : [],
            ...verificationCode ? [
                (0, $bae4bf33bd28496f$export$d9e3c9dc7eaad0c3).VerificationCode
            ] : []
        ];
    }, []);
    return {
        logo: logo,
        color: primaryColor,
        identifier: identifier,
        authentications: authentications,
        socialTargets: socialSignInConnectorTargets
    };
};
const $d5817f69bef4e179$var$toSignInExperience = (formData, initialSignInExperience)=>{
    const { logo: logo, color: onboardConfigColor, identifier: identifier, authentications: authentications, socialTargets: socialTargets } = formData;
    const { color: initialColor, branding: initialBranding } = initialSignInExperience;
    // Map to sign-up config
    const shouldSetPasswordAtSignUp = identifier === (0, $8lyC3.SignInIdentifier).Username || authentications.includes((0, $bae4bf33bd28496f$export$d9e3c9dc7eaad0c3).Password);
    const shouldVerifyAtSignUp = identifier !== (0, $8lyC3.SignInIdentifier).Username;
    // Map to sign-in methods
    const isSignInByPasswordEnabled = identifier === (0, $8lyC3.SignInIdentifier).Username || authentications.includes((0, $bae4bf33bd28496f$export$d9e3c9dc7eaad0c3).Password);
    const isSignInByVerificationCodeEnabled = identifier !== (0, $8lyC3.SignInIdentifier).Username && authentications.includes((0, $bae4bf33bd28496f$export$d9e3c9dc7eaad0c3).VerificationCode);
    const signInExperience = {
        ...initialSignInExperience,
        branding: {
            ...initialBranding,
            logoUrl: (0, $7oDSS.conditional)(logo?.length && logo),
            darkLogoUrl: (0, $7oDSS.conditional)(logo?.length && logo)
        },
        color: {
            ...initialColor,
            primaryColor: onboardConfigColor
        },
        signUp: {
            identifiers: [
                identifier
            ],
            verify: shouldVerifyAtSignUp,
            password: shouldSetPasswordAtSignUp
        },
        signIn: {
            methods: [
                {
                    identifier: identifier,
                    password: isSignInByPasswordEnabled,
                    verificationCode: isSignInByVerificationCodeEnabled,
                    isPasswordPrimary: isSignInByPasswordEnabled
                }
            ]
        },
        socialSignInConnectorTargets: socialTargets ?? []
    };
    return signInExperience;
};
const $d5817f69bef4e179$var$toUpdateOnboardingSieData = (formData, initialSignInExperience)=>{
    const { color: color, branding: branding, signUp: signUp, signIn: signIn, socialSignInConnectorTargets: socialSignInConnectorTargets } = $d5817f69bef4e179$var$toSignInExperience(formData, initialSignInExperience);
    return {
        color: color,
        branding: branding,
        signUp: signUp,
        signIn: signIn,
        socialSignInConnectorTargets: socialSignInConnectorTargets
    };
};
const $d5817f69bef4e179$export$f05308b466359e4e = {
    fromSignInExperience: $d5817f69bef4e179$var$fromSignInExperience,
    toSignInExperience: $d5817f69bef4e179$var$toSignInExperience,
    toUpdateOnboardingSieData: $d5817f69bef4e179$var$toUpdateOnboardingSieData
};






const $e23243ba69546083$var$useCurrentTenantEndpoint = ()=>{
    const { tenantId: currentTenantId } = (0, $2Phw0.useParams)();
    if (!currentTenantId) throw new Error("No tenant ID param found in the current route. This hook should be used in a route with a tenant ID param.");
    const { data: data } = (0, $fG7L1.useTenantEndpoint)(currentTenantId);
    return data;
};
function $e23243ba69546083$var$SignInExperience() {
    const swrOptions = (0, $43f1764fabec2aae$export$2e2bcd8739ae039)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: signInExperience, error: error, mutate: mutate } = (0, $voszV.default)("api/sign-in-exp", swrOptions);
    const isSignInExperienceDataLoading = !error && !signInExperience;
    const { isLoading: isUserAssetsServiceLoading } = (0, $0075be353fe024d3$export$2e2bcd8739ae039)();
    const isLoading = isSignInExperienceDataLoading || isUserAssetsServiceLoading;
    const api = (0, $c1b7f9ae52d4d5d8$export$2e2bcd8739ae039)();
    const { isReady: isUserAssetsServiceReady } = (0, $04111409d75abad4$export$2e2bcd8739ae039)();
    const { update: update } = (0, $ce45228420657e93$export$2e2bcd8739ae039)();
    const { user: user } = (0, $8dc2d4d6918e57ba$export$2e2bcd8739ae039)();
    const endpoint = $e23243ba69546083$var$useCurrentTenantEndpoint();
    const enterAdminConsole = async ()=>{
        await update({
            isOnboardingDone: true
        });
    };
    const { reset: reset, control: control, watch: watch, register: register, handleSubmit: handleSubmit, getValues: getValues, setValue: setValue, formState: { isSubmitting: isSubmitting, errors: errors } } = (0, $codQP.useForm)({
        defaultValues: (0, $85819ac33b2e3a2e$export$c382f0fc4604f07b)
    });
    const updateAuthenticationConfig = (0, $jC8Vy.useCallback)(()=>{
        const identifier = getValues("identifier");
        if (identifier === (0, $8lyC3.SignInIdentifier).Username) setValue("authentications", [
            (0, $bae4bf33bd28496f$export$d9e3c9dc7eaad0c3).Password
        ]);
    }, [
        getValues,
        setValue
    ]);
    (0, $jC8Vy.useEffect)(()=>{
        if (signInExperience) {
            reset((0, $d5817f69bef4e179$export$f05308b466359e4e).fromSignInExperience(signInExperience));
            updateAuthenticationConfig();
        }
    }, [
        reset,
        signInExperience,
        updateAuthenticationConfig
    ]);
    const onboardingSieFormData = watch();
    const previewSieConfig = (0, $jC8Vy.useMemo)(()=>{
        if (signInExperience) return (0, $d5817f69bef4e179$export$f05308b466359e4e).toSignInExperience(onboardingSieFormData, signInExperience);
    }, [
        onboardingSieFormData,
        signInExperience
    ]);
    const submit = (onSuccess)=>(0, $5OcFi.trySubmitSafe)(async (formData)=>{
            if (!signInExperience) return;
            /**
       * If choose `Email` as `identifier`, we will create email service connector for the tenant (when there is no existing email connector).
       * Should create this connector before updating the sign-in experience, otherwise the sign-in experience can not be updated.
       */ if (formData.identifier === (0, $8lyC3.SignInIdentifier).Email) {
                const connectors = await api.get("api/connectors").json();
                if (!connectors.some(({ type: type })=>type === (0, $kowfT.ConnectorType).Email)) await api.post("api/connectors", {
                    json: {
                        connectorId: (0, $7YxsJ.ServiceConnector).Email
                    }
                });
            }
            const updatedData = await api.patch((0, $7kooT.buildUrl)("api/sign-in-exp", {
                removeUnusedDemoSocialConnector: "1"
            }), {
                json: (0, $d5817f69bef4e179$export$f05308b466359e4e).toUpdateOnboardingSieData(formData, signInExperience)
            }).json();
            (0, $34139a4008fff4d0$export$4d684b225153f74e)({
                gtagId: (0, $34139a4008fff4d0$export$a3b35db81871225).SignUp,
                redditType: "SignUp",
                transactionId: user?.id
            });
            mutate(updatedData);
            onSuccess();
        });
    if (isLoading) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $102a4843e367a27b$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $voszV.SWRConfig), {
        value: swrOptions,
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
            className: $150021613750da2d$export$523fb3936f49e028,
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5TsIB.default), {
                    titleKey: [
                        "cloud.sie.page_title",
                        "cloud.general.onboarding"
                    ]
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aTllQ.default), {
                    className: $150021613750da2d$export$8f981dffec84ba52,
                    children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $e2ecaff0bc9d0e52$export$a7db06668cad9adb,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                className: $e2ecaff0bc9d0e52$export$e506a1d27d1eaa20,
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e1377b7b6e8b94be$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $150021613750da2d$export$fb184b623420d9be,
                                        children: t("cloud.sie.title")
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1c7123eb3990bc17$export$2e2bcd8739ae039), {
                                        onInspired: (template)=>{
                                            for (const [key, value] of Object.entries(template))// eslint-disable-next-line no-restricted-syntax
                                            setValue(key, value, {
                                                shouldDirty: true
                                            });
                                            updateAuthenticationConfig();
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                        title: "cloud.sie.logo_field",
                                        children: isUserAssetsServiceReady ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                                            name: "logo",
                                            control: control,
                                            render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $ab5b5e61d391674b$export$2e2bcd8739ae039), {
                                                    name: name,
                                                    value: value ?? "",
                                                    onChange: onChange
                                                })
                                        }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                            ...register("logo", {
                                                validate: (value)=>!value || (0, $cRLgg.uriValidator)(value) || t("errors.invalid_uri_format")
                                            }),
                                            error: errors.logo?.message
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                        title: "cloud.sie.color_field",
                                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                                            name: "color",
                                            control: control,
                                            render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $41f023d5b4e5db66$export$2e2bcd8739ae039), {
                                                    value: value,
                                                    onChange: onChange
                                                })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                        title: "cloud.sie.identifier_field",
                                        headlineSpacing: "large",
                                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                                            name: "identifier",
                                            control: control,
                                            render: ({ field: { name: name, value: value, onChange: onChange } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b9fbd483153db2c$export$2e2bcd8739ae039), {
                                                    name: name,
                                                    value: value,
                                                    options: (0, $d43a9f120c3fe666$export$19ede94f671fb844),
                                                    onChange: (value)=>{
                                                        onChange(value);
                                                        updateAuthenticationConfig();
                                                    }
                                                })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                        isMultiple: true,
                                        title: "cloud.sie.authn_field",
                                        headlineSpacing: "large",
                                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                                            name: "authentications",
                                            control: control,
                                            defaultValue: (0, $85819ac33b2e3a2e$export$c382f0fc4604f07b).authentications,
                                            render: ({ field: { value: value, onChange: onChange } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $9326dcdf6e771d52$export$2e2bcd8739ae039), {
                                                    isNotAllowEmpty: true,
                                                    className: $e2ecaff0bc9d0e52$export$3e4dd27034fea0be,
                                                    value: value,
                                                    options: (0, $d43a9f120c3fe666$export$993274cb9b03d078).filter(({ value: value })=>onboardingSieFormData.identifier !== (0, $8lyC3.SignInIdentifier).Username || value === (0, $bae4bf33bd28496f$export$d9e3c9dc7eaad0c3).Password),
                                                    onChange: onChange
                                                })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                        isMultiple: true,
                                        title: "cloud.sie.social_field",
                                        headlineSpacing: "large",
                                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                                            name: "socialTargets",
                                            control: control,
                                            defaultValue: (0, $85819ac33b2e3a2e$export$c382f0fc4604f07b).socialTargets,
                                            render: ({ field: { value: value, onChange: onChange } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $63a49f7a7b8ed8c1$export$2e2bcd8739ae039), {
                                                    value: value ?? [],
                                                    onChange: onChange
                                                })
                                        })
                                    })
                                ]
                            }),
                            endpoint && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2bf96b5d2d743d1e$export$2e2bcd8739ae039), {
                                className: $e2ecaff0bc9d0e52$export$48c2d0f2f545ac27,
                                signInExperience: previewSieConfig,
                                endpoint: endpoint
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $d5ec2c6fd251ac7a$export$2e2bcd8739ae039), {
                    step: 3,
                    totalSteps: 3,
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $e2ecaff0bc9d0e52$export$e8c278056cb4f639,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                            type: "primary",
                            title: "cloud.sie.finish_and_done",
                            disabled: isSubmitting,
                            onClick: async ()=>{
                                await handleSubmit(submit(enterAdminConsole))();
                            }
                        })
                    })
                })
            ]
        })
    });
}
var $e23243ba69546083$export$2e2bcd8739ae039 = $e23243ba69546083$var$SignInExperience;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $dNkWp = parcelRequire("dNkWp");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
parcelRequire("6bq3s");
var $2Phw0 = parcelRequire("2Phw0");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $63118833ef0d4de8$var$SvgCase = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M7 17a4 4 0 0 1 4-4h26a4 4 0 0 1 4 4v18a4 4 0 0 1-4 4H11a4 4 0 0 1-4-4V17Z",
                fill: "url(#paint0_linear_331_73558)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M37.6 13H10.4C8.522 13 7 14.79 7 17v6c0 2.21 1.522 4 3.4 4H37.6c1.878 0 3.4-1.79 3.4-4v-6c0-2.21-1.522-4-3.4-4Z",
                fill: "url(#paint1_linear_331_73558)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                opacity: 0.6,
                x: 17,
                y: 22,
                width: 3,
                height: 8,
                rx: 1.5,
                fill: "#7B0093"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                opacity: 0.6,
                x: 28,
                y: 22,
                width: 3,
                height: 8,
                rx: 1.5,
                fill: "#7B0093"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15 12a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v1a1 1 0 1 1-2 0v-1a1 1 0 0 0-1-1H18a1 1 0 0 0-1 1v1a1 1 0 1 1-2 0v-1Z",
                fill: "#34353F"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 7,
                cy: 19,
                r: 1.5,
                stroke: "#FFD5FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 36.879,
                y: 7,
                width: 3,
                height: 3,
                rx: 0.5,
                transform: "rotate(-45 36.879 7)",
                stroke: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 18.707,
                y: 44.828,
                width: 3,
                height: 3,
                rx: 0.5,
                transform: "rotate(-45 18.707 44.828)",
                stroke: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_331_73558",
                        x1: 35.51,
                        y1: 15.979,
                        x2: 20.422,
                        y2: 40.562,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#F07EFF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFF480"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_331_73558",
                        x1: 32.5,
                        y1: 27,
                        x2: 14.388,
                        y2: 10.085,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAABFF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $63118833ef0d4de8$export$2e2bcd8739ae039 = $63118833ef0d4de8$var$SvgCase;




var $5TsIB = parcelRequire("5TsIB");

var $jGWQ4 = parcelRequire("jGWQ4");

var $aqmjm = parcelRequire("aqmjm");

var $aTllQ = parcelRequire("aTllQ");

var $fmHmG = parcelRequire("fmHmG");



var $5OcFi = parcelRequire("5OcFi");


parcelRequire("12bMu");
var $gcHb7 = parcelRequire("gcHb7");

const $b569975076fdf4c6$export$75332796271f8048 = (page)=>(0, $gcHb7.joinPath)((0, $6556ae972ac34d69$export$329ee42b27a3306e).Onboarding, page);


var $ba175b646a6faadc$export$6210fa4921d2a466;
var $ba175b646a6faadc$export$a75d1723e6bda2ec;
var $ba175b646a6faadc$export$bfd64c937657f93a;
var $ba175b646a6faadc$export$4a6dd88bada4e7d2;
var $ba175b646a6faadc$export$5c87d3bbeff1b3ef;
$ba175b646a6faadc$export$6210fa4921d2a466 = `k8ahaW_form`;
$ba175b646a6faadc$export$a75d1723e6bda2ec = `k8ahaW_option`;
$ba175b646a6faadc$export$bfd64c937657f93a = `k8ahaW_rotating`;
$ba175b646a6faadc$export$4a6dd88bada4e7d2 = `k8ahaW_shimmer`;
$ba175b646a6faadc$export$5c87d3bbeff1b3ef = `k8ahaW_titleSelector`;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $dNkWp = parcelRequire("dNkWp");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $ac2bf18d59e6321f$var$SvgBuilding = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 21,
        height: 20,
        viewBox: "0 0 21 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M12.166 6.667H13A.833.833 0 1 0 13 5h-.834a.833.833 0 0 0 0 1.667Zm0 3.333H13a.833.833 0 1 0 0-1.667h-.834a.833.833 0 0 0 0 1.667ZM8 6.667h.833a.833.833 0 0 0 0-1.667H8a.833.833 0 1 0 0 1.667ZM8 10h.833a.833.833 0 0 0 0-1.667H8A.833.833 0 1 0 8 10Zm10 6.667h-.834V2.5a.833.833 0 0 0-.833-.833H4.667a.833.833 0 0 0-.834.833v14.167H3a.833.833 0 1 0 0 1.666h15a.833.833 0 1 0 0-1.666Zm-6.667 0H9.666v-3.334h1.667v3.334Zm4.167 0H13V12.5a.834.834 0 0 0-.834-.833H8.833A.833.833 0 0 0 8 12.5v4.167H5.5V3.333h10v13.334Z",
            fill: "currentColor"
        })
    });
var $ac2bf18d59e6321f$export$2e2bcd8739ae039 = $ac2bf18d59e6321f$var$SvgBuilding;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $cbe61e0df24c77ff$var$SvgPizza = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M7.092 10.4a.833.833 0 1 0 0 1.666.833.833 0 0 0 0-1.666Zm0-3.733a.833.833 0 1 0 0 1.666.833.833 0 0 0 0-1.666ZM10 8.333a.833.833 0 0 0-.833.834V10a.833.833 0 1 0 1.666 0v-.833A.833.833 0 0 0 10 8.333Zm7.083-1.191a2.5 2.5 0 0 0-1.916-.242c-.333.089-.643.248-.909.467L4.592 1.775a.833.833 0 0 0-.834 0 .833.833 0 0 0-.425.725v10.975a2.45 2.45 0 0 0-1.666 2.358 2.5 2.5 0 0 0 2.433 2.5h.483a15.474 15.474 0 0 0 13.425-7.841 2.5 2.5 0 0 0-.916-3.35h-.009ZM5 3.942 13.242 8.7A10.476 10.476 0 0 1 5 13.333V3.942Zm11.558 5.733a13.817 13.817 0 0 1-12.391 6.992.834.834 0 0 1-.77-1.16.834.834 0 0 1 .186-.274.833.833 0 0 1 .584-.233h.425a12.085 12.085 0 0 0 10.516-6.142.75.75 0 0 1 .484-.366.833.833 0 0 1 .625.075.833.833 0 0 1 .35 1.108h-.009Z",
            fill: "currentColor"
        })
    });
var $cbe61e0df24c77ff$export$2e2bcd8739ae039 = $cbe61e0df24c77ff$var$SvgPizza;


const $7d569330e4985ae2$export$4c7a833ad93dd57c = [
    {
        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cbe61e0df24c77ff$export$2e2bcd8739ae039), {}),
        title: "cloud.welcome.project_options.personal",
        value: (0, $dNkWp.Project).Personal
    },
    {
        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ac2bf18d59e6321f$export$2e2bcd8739ae039), {}),
        title: "cloud.welcome.project_options.company",
        value: (0, $dNkWp.Project).Company
    }
];
const $7d569330e4985ae2$export$f45dc0d5f362294f = [
    {
        title: "cloud.welcome.stage_options.new_product",
        value: (0, $dNkWp.Stage).NewProduct
    },
    {
        title: "cloud.welcome.stage_options.existing_product",
        value: (0, $dNkWp.Stage).ExistingProduct
    },
    {
        title: "cloud.welcome.stage_options.target_enterprise_ready",
        value: (0, $dNkWp.Stage).TargetEnterpriseReady
    }
];
const $7d569330e4985ae2$export$87b944183305254b = [
    {
        title: "cloud.welcome.additional_features_options.customize_ui_and_flow",
        value: (0, $dNkWp.AdditionalFeatures).CustomizeUiAndFlow
    },
    {
        title: "cloud.welcome.additional_features_options.compliance",
        value: (0, $dNkWp.AdditionalFeatures).Compliance
    },
    {
        title: "cloud.welcome.additional_features_options.export_user_data",
        value: (0, $dNkWp.AdditionalFeatures).ExportUserDataFromLogto
    },
    {
        title: "cloud.welcome.additional_features_options.budget_control",
        value: (0, $dNkWp.AdditionalFeatures).BudgetControl
    },
    {
        title: "cloud.welcome.additional_features_options.bring_own_auth",
        value: (0, $dNkWp.AdditionalFeatures).BringOwnAuth
    },
    {
        title: "cloud.welcome.additional_features_options.others",
        value: (0, $dNkWp.AdditionalFeatures).Others
    }
];


function $077d94cfccdf33b4$var$Welcome() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const navigate = (0, $2Phw0.useNavigate)();
    const { data: { questionnaire: questionnaire }, update: update } = (0, $ce45228420657e93$export$2e2bcd8739ae039)();
    const { control: control, register: register, handleSubmit: handleSubmit, reset: reset, watch: watch } = (0, $codQP.useForm)({
        mode: "onChange"
    });
    (0, $jC8Vy.useEffect)(()=>{
        reset(questionnaire);
    }, [
        questionnaire,
        reset
    ]);
    const onSubmit = handleSubmit((0, $5OcFi.trySubmitSafe)(async (formData)=>{
        await update({
            questionnaire: formData
        });
    }));
    const onNext = async ()=>{
        await onSubmit();
        navigate((0, $b569975076fdf4c6$export$75332796271f8048)((0, $6556ae972ac34d69$export$1572a1adf9290869).CreateTenant));
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $150021613750da2d$export$523fb3936f49e028,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5TsIB.default), {
                titleKey: [
                    "cloud.welcome.page_title",
                    "cloud.general.onboarding"
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aTllQ.default), {
                className: $150021613750da2d$export$8f981dffec84ba52,
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: $150021613750da2d$export$a7db06668cad9adb,
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $63118833ef0d4de8$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $150021613750da2d$export$fb184b623420d9be,
                            children: t("cloud.welcome.title")
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $150021613750da2d$export$6d59db4903f20f7d,
                            children: t("cloud.welcome.description")
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsxs)("form", {
                            className: $ba175b646a6faadc$export$6210fa4921d2a466,
                            children: [
                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                    title: "cloud.welcome.project_field",
                                    headlineSpacing: "large",
                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                                        control: control,
                                        name: "project",
                                        render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b9fbd483153db2c$export$2e2bcd8739ae039), {
                                                name: name,
                                                value: value ?? "",
                                                options: (0, $7d569330e4985ae2$export$4c7a833ad93dd57c),
                                                onChange: onChange
                                            })
                                    })
                                }),
                                watch("project") === (0, $dNkWp.Project).Company && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                    title: "cloud.welcome.company_name_field",
                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                        placeholder: t("cloud.welcome.company_name_placeholder"),
                                        ...register("companyName")
                                    })
                                }),
                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                    title: "cloud.welcome.stage_field",
                                    headlineSpacing: "large",
                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                                        control: control,
                                        name: "stage",
                                        render: ({ field: { name: name, onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b9fbd483153db2c$export$2e2bcd8739ae039), {
                                                name: name,
                                                value: value ?? "",
                                                options: (0, $7d569330e4985ae2$export$f45dc0d5f362294f),
                                                onChange: (value)=>{
                                                    onChange((0, $7oDSS.conditional)(value && value));
                                                }
                                            })
                                    })
                                }),
                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                    isMultiple: true,
                                    title: "cloud.welcome.additional_features_field",
                                    headlineSpacing: "large",
                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                                        control: control,
                                        name: "additionalFeatures",
                                        render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $9326dcdf6e771d52$export$2e2bcd8739ae039), {
                                                optionClassName: $ba175b646a6faadc$export$a75d1723e6bda2ec,
                                                value: value ?? [],
                                                options: (0, $7d569330e4985ae2$export$87b944183305254b),
                                                onChange: (value)=>{
                                                    onChange(value.length === 0 ? undefined : value);
                                                }
                                            })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $d5ec2c6fd251ac7a$export$2e2bcd8739ae039), {
                step: 1,
                totalSteps: 3,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                    title: "general.next",
                    type: "primary",
                    onClick: onNext
                })
            })
        ]
    });
}
var $077d94cfccdf33b4$export$2e2bcd8739ae039 = $077d94cfccdf33b4$var$Welcome;




const $c47a9066647cd7e1$var$welcomePathname = (0, $b569975076fdf4c6$export$75332796271f8048)((0, $6556ae972ac34d69$export$1572a1adf9290869).Welcome);
const $c47a9066647cd7e1$var$routeObjects = [
    {
        index: true,
        element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Navigate), {
            replace: true,
            to: (0, $6556ae972ac34d69$export$1572a1adf9290869).Welcome
        })
    },
    {
        path: (0, $6556ae972ac34d69$export$1572a1adf9290869).Welcome,
        element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $077d94cfccdf33b4$export$2e2bcd8739ae039), {})
    },
    {
        path: (0, $6556ae972ac34d69$export$1572a1adf9290869).CreateTenant,
        element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $94cf3eea58eb6b99$export$2e2bcd8739ae039), {})
    },
    {
        path: `:tenantId/${(0, $6556ae972ac34d69$export$1572a1adf9290869).SignInExperience}`,
        element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e23243ba69546083$export$2e2bcd8739ae039), {})
    }
];
function $c47a9066647cd7e1$export$1b74a30f1aaea892() {
    const { setThemeOverride: setThemeOverride } = (0, $jC8Vy.useContext)((0, $6gkG2.AppThemeContext));
    const matched = (0, $2Phw0.useMatch)($c47a9066647cd7e1$var$welcomePathname);
    const routes = (0, $2Phw0.useRoutes)($c47a9066647cd7e1$var$routeObjects);
    (0, $77d0d5b50790ecf4$export$751a22e57b65a4b5)($c47a9066647cd7e1$var$routeObjects, "onboarding");
    (0, $jC8Vy.useEffect)(()=>{
        setThemeOverride((0, $5HVJe.Theme).Light);
        return ()=>{
            setThemeOverride(undefined);
        };
    }, [
        setThemeOverride
    ]);
    const { isLoading: isLoading, data: { questionnaire: questionnaire, isOnboardingDone: isOnboardingDone } } = (0, $ce45228420657e93$export$2e2bcd8739ae039)();
    if (isLoading) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4c070a72a1cf87ce$export$2e2bcd8739ae039), {});
    if (isOnboardingDone) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Navigate), {
        replace: true,
        to: "/"
    });
    // Redirect to the welcome page if the user has not started the onboarding process.
    if (!questionnaire && !matched) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Navigate), {
        replace: true,
        to: $c47a9066647cd7e1$var$welcomePathname
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: $85d8df6e048c6090$export$729c8b7179294ba,
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $d7b7c71669250da7$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8f6fee413997db41$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $309a71316332eab7$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $85d8df6e048c6090$export$a7db06668cad9adb,
                    children: routes
                })
            ]
        })
    });
}



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("9zW7e");
var $jSb9j = parcelRequire("jSb9j");
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
var $aZIrr = parcelRequire("aZIrr");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $2Phw0 = parcelRequire("2Phw0");

var $voszV = parcelRequire("voszV");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $9342374032a30fe2$var$SvgKeyboardArrowDown = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "m12.71 15.54 5.65-5.66a1.001 1.001 0 1 0-1.41-1.42l-5 4.95L7 8.46a1 1 0 0 0-1.41 0 1 1 0 0 0-.3.71 1 1 0 0 0 .3.71l5.65 5.66a1 1 0 0 0 1.47 0Z",
            fill: "currentColor"
        })
    });
var $9342374032a30fe2$export$2e2bcd8739ae039 = $9342374032a30fe2$var$SvgKeyboardArrowDown;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $4af961ac2fe37cb1$var$SvgKeyboardArrowUp = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "m11.29 8.46-5.65 5.66a.999.999 0 0 0 0 1.42 1 1 0 0 0 1.41 0l5-4.95L17 15.54a1 1 0 0 0 1.631-.325.998.998 0 0 0 .079-.385 1 1 0 0 0-.3-.71l-5.65-5.66a1 1 0 0 0-1.47 0Z",
            fill: "currentColor"
        })
    });
var $4af961ac2fe37cb1$export$2e2bcd8739ae039 = $4af961ac2fe37cb1$var$SvgKeyboardArrowUp;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $1c8635f1253c6c64$var$SvgErrorDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 58,
                y: 74,
                width: 140,
                height: 108,
                rx: 12.191,
                fill: "#C2BDD5"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "mask0_274_17729",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 58,
                y: 74,
                width: 140,
                height: 108,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                    x: 58,
                    y: 74,
                    width: 140,
                    height: 108,
                    rx: 12.191,
                    fill: "#CABEFF"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                mask: "url(#mask0_274_17729)",
                fill: "#B4AFCC",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M64.8 142.2v-128h.8v128zM73 142V14h.8v128zM81 142V14h.8v128zM89 142V14h.8v128zM97 142V14h.8v128zM105 142V14h.8v128zM113 142V14h.8v128zM121 142V14h.8v128zM129 142V14h.8v128zM137 142V14h.8v128zM145 142V14h.8v128zM153 142V14h.8v128zM161 142V14h.8v128zM169 142V14h.8v128zM177 142V14h.8v128z"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M57 78h128v.8H57zM57 86h128v.8H57zM57 94h128v.8H57zM57 102h128v.8H57zM57 110h128v.8H57zM57 118h128v.8H57zM57 126h128v.8H57zM57 134h128v.8H57z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M125.333 107.619c1.186-2.053 4.148-2.053 5.334 0l26.666 46.188c1.186 2.053-.296 4.619-2.666 4.619h-53.334c-2.37 0-3.852-2.566-2.666-4.619l26.666-46.188Z",
                fill: "#F9EF95"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M128 119a4 4 0 0 0-4 4v12a4 4 0 0 0 8 0v-12a4 4 0 0 0-4-4Zm0 24a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z",
                fill: "#444748"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M58 86c0-6.627 5.373-12 12-12h116c6.627 0 12 5.373 12 12v8H58v-8Z",
                fill: "#78767F"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 77,
                cy: 84,
                r: 3,
                fill: "#E5E1EC"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 87,
                cy: 84,
                r: 3,
                fill: "#47464E"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 97,
                cy: 84,
                r: 3,
                fill: "#47464E"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#4E5065",
                d: "m203.134 214.277 6.511-4.648 4.648 6.51-6.51 4.65z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 206,
                y: 27.648,
                width: 8,
                height: 8,
                rx: 0.16,
                transform: "rotate(-35.523 206 27.648)",
                fill: "#41485E"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 172.452,
                y: 171,
                width: 16,
                height: 16,
                rx: 4,
                transform: "rotate(50.249 172.452 171)",
                fill: "#5C6273"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M221.914 96.209a.21.21 0 0 1 .209-.209h3.755a.21.21 0 0 1 .209.209v6.608l5.723-3.304a.209.209 0 0 1 .285.076l1.877 3.252c.058.1.024.228-.076.285l-5.724 3.305 5.724 3.304a.209.209 0 0 1 .076.285l-1.878 3.252a.207.207 0 0 1-.284.076l-5.723-3.304v6.609a.209.209 0 0 1-.209.208h-3.755a.209.209 0 0 1-.209-.208v-6.609l-5.723 3.304a.208.208 0 0 1-.285-.076l-1.878-3.252a.21.21 0 0 1 .077-.285l5.723-3.304-5.724-3.305a.209.209 0 0 1-.076-.285l1.878-3.252a.208.208 0 0 1 .284-.076l5.724 3.305v-6.61ZM94.331 193.209c0-.116.094-.209.209-.209h2.92c.116 0 .21.093.21.209v5.245l4.542-2.623a.208.208 0 0 1 .284.077l1.461 2.529a.21.21 0 0 1-.077.285l-4.542 2.622 4.542 2.623c.1.058.134.185.076.285l-1.46 2.529a.209.209 0 0 1-.285.077l-4.542-2.623v5.245a.21.21 0 0 1-.208.209H94.54a.21.21 0 0 1-.209-.209v-5.245l-4.542 2.623a.21.21 0 0 1-.285-.077l-1.46-2.529a.209.209 0 0 1 .076-.285l4.542-2.623-4.542-2.622a.209.209 0 0 1-.077-.285l1.46-2.529a.21.21 0 0 1 .285-.077l4.543 2.623v-5.245Z",
                fill: "#4E5075"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M52 62a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
                fill: "#626685"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M39 167a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
                fill: "#4A475C"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M153.212 48.314a.16.16 0 0 1 .177-.213l15.222 2.616a.16.16 0 0 1 .096.26l-9.877 11.875a.16.16 0 0 1-.273-.047l-5.345-14.491Z",
                fill: "#373C4A"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m117.818 59.546 2.108-4.005a4.525 4.525 0 0 0-1.896-6.112v0a4.525 4.525 0 0 1-1.897-6.113v0a4.525 4.525 0 0 0-1.896-6.112v0a4.525 4.525 0 0 1-1.897-6.113l2.108-4.005",
                stroke: "#5E6775",
                strokeWidth: 3.2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 75,
                y: 220,
                width: 80,
                height: 4,
                rx: 2,
                fill: "#4E5075"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 167,
                y: 220,
                width: 19,
                height: 4,
                rx: 2,
                fill: "#4E5075"
            })
        ]
    });
var $1c8635f1253c6c64$export$2e2bcd8739ae039 = $1c8635f1253c6c64$var$SvgErrorDark;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $109203ec5ef38646$var$SvgError = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 58,
                y: 74,
                width: 140,
                height: 108,
                rx: 12.191,
                fill: "#C9C5D0"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "mask0_3312_122828",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 58,
                y: 74,
                width: 140,
                height: 108,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                    x: 58,
                    y: 74,
                    width: 140,
                    height: 108,
                    rx: 12.191,
                    fill: "#CABEFF"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                mask: "url(#mask0_3312_122828)",
                fill: "#000",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M64.8 142.2v-128h.4v128zM73 142V14h.4v128zM81 142V14h.4v128zM89 142V14h.4v128zM97 142V14h.4v128zM105 142V14h.4v128zM113 142V14h.4v128zM121 142V14h.4v128zM129 142V14h.4v128zM137 142V14h.4v128zM145 142V14h.4v128zM153 142V14h.4v128zM161 142V14h.4v128zM169 142V14h.4v128zM177 142V14h.4v128z"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M57 78h128v.4H57zM57 86h128v.4H57zM57 94h128v.4H57zM57 102h128v.4H57zM57 110h128v.4H57zM57 118h128v.4H57zM57 126h128v.4H57zM57 134h128v.4H57z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M125.333 107.619c1.186-2.053 4.148-2.053 5.334 0l26.666 46.188c1.186 2.053-.296 4.619-2.666 4.619h-53.334c-2.37 0-3.852-2.566-2.666-4.619l26.666-46.188Z",
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M128 119a4 4 0 0 0-4 4v12a4 4 0 0 0 8 0v-12a4 4 0 0 0-4-4Zm0 24a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z",
                fill: "#444748"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M58 86c0-6.627 5.373-12 12-12h116c6.627 0 12 5.373 12 12v8H58v-8Z",
                fill: "#78767F"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 77,
                cy: 84,
                r: 3,
                fill: "#E5E1EC"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 87,
                cy: 84,
                r: 3,
                fill: "#47464E"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 97,
                cy: 84,
                r: 3,
                fill: "#47464E"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#C4C4C4",
                d: "m203.133 214.277 6.511-4.648 4.648 6.51-6.51 4.65z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 206,
                y: 27.648,
                width: 8,
                height: 8,
                rx: 0.16,
                transform: "rotate(-35.523 206 27.648)",
                fill: "#E5E1EC"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                transform: "rotate(50.249 172.453 171)",
                fill: "#C4C7C7",
                d: "M172.453 171h16v16h-16z",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M221.914 96.209a.21.21 0 0 1 .209-.209h3.755a.21.21 0 0 1 .209.209v6.608l5.723-3.304a.209.209 0 0 1 .285.076l1.877 3.252c.058.1.024.228-.076.285l-5.724 3.305 5.724 3.304a.209.209 0 0 1 .076.285l-1.878 3.252a.207.207 0 0 1-.284.076l-5.723-3.304v6.609a.209.209 0 0 1-.209.208h-3.755a.209.209 0 0 1-.209-.208v-6.609l-5.723 3.304a.208.208 0 0 1-.285-.076l-1.878-3.252a.21.21 0 0 1 .077-.285l5.723-3.304-5.724-3.305a.209.209 0 0 1-.076-.285l1.878-3.252a.208.208 0 0 1 .284-.076l5.724 3.305v-6.61ZM94.331 193.209c0-.116.094-.209.209-.209h2.92c.116 0 .21.093.21.209v5.245l4.542-2.623a.208.208 0 0 1 .284.077l1.461 2.529a.21.21 0 0 1-.077.285l-4.542 2.622 4.542 2.623c.1.058.134.185.076.285l-1.46 2.529a.209.209 0 0 1-.285.077l-4.542-2.623v5.245a.21.21 0 0 1-.208.209H94.54a.21.21 0 0 1-.209-.209v-5.245l-4.542 2.623a.21.21 0 0 1-.285-.077l-1.46-2.529a.209.209 0 0 1 .076-.285l4.542-2.623-4.542-2.622a.209.209 0 0 1-.077-.285l1.46-2.529a.21.21 0 0 1 .285-.077l4.543 2.623v-5.245Z",
                fill: "#E0E3E3"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M52 62a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
                fill: "#C4C7C7"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M39 167a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
                fill: "#E0E3E3"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M153.212 48.314a.16.16 0 0 1 .177-.213l15.222 2.616a.16.16 0 0 1 .096.26l-9.877 11.875a.16.16 0 0 1-.273-.047l-5.345-14.491Z",
                fill: "#C9C5D0"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m117.818 59.546 2.108-4.005a4.525 4.525 0 0 0-1.896-6.112v0a4.525 4.525 0 0 1-1.897-6.113v0a4.525 4.525 0 0 0-1.896-6.112v0a4.525 4.525 0 0 1-1.897-6.113l2.108-4.005",
                stroke: "#F7F8F8",
                strokeWidth: 3.2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m117.818 59.546 2.108-4.005a4.525 4.525 0 0 0-1.896-6.112v0a4.525 4.525 0 0 1-1.897-6.113v0a4.525 4.525 0 0 0-1.896-6.112v0a4.525 4.525 0 0 1-1.897-6.113l2.108-4.005",
                stroke: "#78767F",
                strokeOpacity: 0.02,
                strokeWidth: 3.2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m117.818 59.546 2.108-4.005a4.525 4.525 0 0 0-1.896-6.112v0a4.525 4.525 0 0 1-1.897-6.113v0a4.525 4.525 0 0 0-1.896-6.112v0a4.525 4.525 0 0 1-1.897-6.113l2.108-4.005",
                stroke: "#5D34F2",
                strokeOpacity: 0.11,
                strokeWidth: 3.2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M29.717 172.618a.16.16 0 0 1 .261-.094l5.675 4.821a.16.16 0 0 1-.05.273l-7.012 2.504a.16.16 0 0 1-.212-.18l1.338-7.324Z",
                fill: "#E5E1EC"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 75,
                y: 220,
                width: 80,
                height: 4,
                rx: 2,
                fill: "#747778"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 167,
                y: 220,
                width: 19,
                height: 4,
                rx: 2,
                fill: "#747778"
            })
        ]
    });
var $109203ec5ef38646$export$2e2bcd8739ae039 = $109203ec5ef38646$var$SvgError;



var $jheqv = parcelRequire("jheqv");

var $bnkR4 = parcelRequire("bnkR4");
var $a6251d9c7cc0cee1$export$34e0f9847d4c02dd;
var $a6251d9c7cc0cee1$export$41ee12f6f6f05843;
var $a6251d9c7cc0cee1$export$f194ed9df726ec47;
var $a6251d9c7cc0cee1$export$bfd64c937657f93a;
var $a6251d9c7cc0cee1$export$4a6dd88bada4e7d2;
var $a6251d9c7cc0cee1$export$9a2dbef7a17e2e58;
$a6251d9c7cc0cee1$export$34e0f9847d4c02dd = `Mn-v3W_container`;
$a6251d9c7cc0cee1$export$41ee12f6f6f05843 = `Mn-v3W_details`;
$a6251d9c7cc0cee1$export$f194ed9df726ec47 = `Mn-v3W_expander`;
$a6251d9c7cc0cee1$export$bfd64c937657f93a = `Mn-v3W_rotating`;
$a6251d9c7cc0cee1$export$4a6dd88bada4e7d2 = `Mn-v3W_shimmer`;
$a6251d9c7cc0cee1$export$9a2dbef7a17e2e58 = `Mn-v3W_summary`;


function $6b7de14b6bd7147f$var$AppError({ title: title, errorCode: errorCode, errorMessage: errorMessage, callStack: callStack, children: children }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [isDetailsOpen, setIsDetailsOpen] = (0, $jC8Vy.useState)(false);
    const theme = (0, $jheqv.default)();
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $a6251d9c7cc0cee1$export$34e0f9847d4c02dd,
        children: [
            theme === (0, $5HVJe.Theme).Light ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $109203ec5ef38646$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1c8635f1253c6c64$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $C7mD2.jsx)("label", {
                children: title ?? t("errors.something_went_wrong")
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $a6251d9c7cc0cee1$export$9a2dbef7a17e2e58,
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("span", {
                    children: [
                        errorCode,
                        errorCode && errorMessage && ": ",
                        errorMessage,
                        callStack && /*#__PURE__*/ (0, $C7mD2.jsxs)("span", {
                            role: "button",
                            tabIndex: 0,
                            className: $a6251d9c7cc0cee1$export$f194ed9df726ec47,
                            onKeyDown: (0, $bnkR4.onKeyDownHandler)(()=>{
                                setIsDetailsOpen(!isDetailsOpen);
                            }),
                            onClick: ()=>{
                                setIsDetailsOpen(!isDetailsOpen);
                            },
                            children: [
                                t("errors.more_details"),
                                isDetailsOpen ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4af961ac2fe37cb1$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9342374032a30fe2$export$2e2bcd8739ae039), {})
                            ]
                        })
                    ]
                })
            }),
            callStack && isDetailsOpen && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $a6251d9c7cc0cee1$export$41ee12f6f6f05843,
                children: callStack
            }),
            children
        ]
    });
}
var $6b7de14b6bd7147f$export$2e2bcd8739ae039 = $6b7de14b6bd7147f$var$AppError;




var $cDKfs = parcelRequire("cDKfs");

var $azCDQ = parcelRequire("azCDQ");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");



var $jGWQ4 = parcelRequire("jGWQ4");

var $28d03821ad2959bb$export$2ba01fb71ed41cb6;
var $28d03821ad2959bb$export$34e0f9847d4c02dd;
var $28d03821ad2959bb$export$6d59db4903f20f7d;
var $28d03821ad2959bb$export$db3c28d99448dcff;
var $28d03821ad2959bb$export$bfd64c937657f93a;
var $28d03821ad2959bb$export$4a6dd88bada4e7d2;
var $28d03821ad2959bb$export$fb184b623420d9be;
var $28d03821ad2959bb$export$cc74dcc53cfce4eb;
$28d03821ad2959bb$export$2ba01fb71ed41cb6 = `eymyMG_button`;
$28d03821ad2959bb$export$34e0f9847d4c02dd = `eymyMG_container`;
$28d03821ad2959bb$export$6d59db4903f20f7d = `eymyMG_description`;
$28d03821ad2959bb$export$db3c28d99448dcff = `eymyMG_logo`;
$28d03821ad2959bb$export$bfd64c937657f93a = `eymyMG_rotating`;
$28d03821ad2959bb$export$4a6dd88bada4e7d2 = `eymyMG_shimmer`;
$28d03821ad2959bb$export$fb184b623420d9be = `eymyMG_title`;
$28d03821ad2959bb$export$cc74dcc53cfce4eb = `eymyMG_wrapper`;


function $3e6694aae057d247$var$SwitchAccount({ onClickSwitch: onClickSwitch }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { user: user, isLoading: isLoading } = (0, $8dc2d4d6918e57ba$export$2e2bcd8739ae039)();
    const { id: id, primaryEmail: primaryEmail, username: username } = user ?? {};
    if (isLoading) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4c070a72a1cf87ce$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: $28d03821ad2959bb$export$34e0f9847d4c02dd,
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
            className: $28d03821ad2959bb$export$cc74dcc53cfce4eb,
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $19cfe35991ba791f$export$2e2bcd8739ae039), {
                    className: $28d03821ad2959bb$export$db3c28d99448dcff
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $28d03821ad2959bb$export$fb184b623420d9be,
                    children: t("invitation.email_not_match_title", {
                        email: primaryEmail ?? username ?? id
                    })
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $28d03821ad2959bb$export$6d59db4903f20f7d,
                    children: t("invitation.email_not_match_description")
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                    type: "primary",
                    size: "large",
                    className: $28d03821ad2959bb$export$2ba01fb71ed41cb6,
                    title: "invitation.switch_account",
                    onClick: onClickSwitch
                })
            ]
        })
    });
}
var $3e6694aae057d247$export$2e2bcd8739ae039 = $3e6694aae057d247$var$SwitchAccount;


function $cd7c7eae25a1591f$var$AcceptInvitation() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { signIn: signIn } = (0, $jSb9j.useLogto)();
    const redirectUri = (0, $azCDQ.default)();
    const { invitationId: invitationId = "" } = (0, $2Phw0.useParams)();
    const cloudApi = (0, $1c34cc51be8c93d3$export$7a5c900790855d66)();
    const { navigateTenant: navigateTenant, resetTenants: resetTenants } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    // The request is only made when the user has signed-in and the invitation ID is available.
    // The response data is returned only when the current user matches the invitee email. Otherwise, it returns 404.
    const { data: invitation, error: error } = (0, $voszV.default)(invitationId && `/api/invitations/${invitationId}`, async ()=>cloudApi.get("/api/invitations/:invitationId", {
            params: {
                invitationId: invitationId
            }
        }));
    (0, $jC8Vy.useEffect)(()=>{
        if (!invitation) return;
        (async ()=>{
            const { id: id, organizationId: organizationId } = invitation;
            // Accept the invitation and redirect to the tenant page.
            await cloudApi.patch(`/api/invitations/:invitationId/status`, {
                params: {
                    invitationId: id
                },
                body: {
                    status: (0, $61Yml.OrganizationInvitationStatus).Accepted
                }
            });
            const data = await cloudApi.get("/api/tenants");
            resetTenants(data);
            navigateTenant((0, $aZIrr.getTenantIdFromOrganizationId)(organizationId));
        })();
    }, [
        cloudApi,
        error,
        invitation,
        navigateTenant,
        resetTenants,
        t
    ]);
    // No invitation returned, indicating the current signed-in user is not the invitee.
    if (error?.status === 403) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3e6694aae057d247$export$2e2bcd8739ae039), {
        onClickSwitch: ()=>{
            (0, $fb6222c61a959560$export$5027ce2731efc4b9)();
            signIn({
                redirectUri: redirectUri.href,
                loginHint: `urn:logto:invitation:${invitationId}`
            });
        }
    });
    if (error?.status === 404) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6b7de14b6bd7147f$export$2e2bcd8739ae039), {
        errorMessage: t("invitation.invitation_not_found")
    });
    if (invitation && invitation.status !== (0, $61Yml.OrganizationInvitationStatus).Pending) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6b7de14b6bd7147f$export$2e2bcd8739ae039), {
        errorMessage: t("invitation.invalid_invitation_status")
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4c070a72a1cf87ce$export$2e2bcd8739ae039), {});
}
var $cd7c7eae25a1591f$export$2e2bcd8739ae039 = $cd7c7eae25a1591f$var$AcceptInvitation;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("9zW7e");
var $jSb9j = parcelRequire("jSb9j");
parcelRequire("6bq3s");
var $2Phw0 = parcelRequire("2Phw0");


/** The global callback page for all sign-in redirects from Logto main flow. */ function $5a59246c75af7fcf$var$Callback() {
    const navigate = (0, $2Phw0.useNavigate)();
    (0, $jSb9j.useHandleSignInCallback)(()=>{
        const saved = (0, $fb6222c61a959560$export$51826bb55f5be139)();
        if (saved) {
            // Saved redirect is full pathname, no need to use `getTo`.
            navigate(saved, {
                replace: true
            });
            return;
        }
        navigate("/", {
            replace: true
        });
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4c070a72a1cf87ce$export$2e2bcd8739ae039), {});
}
var $5a59246c75af7fcf$export$2e2bcd8739ae039 = $5a59246c75af7fcf$var$Callback;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $b67J2 = parcelRequire("b67J2");

var $jC8Vy = parcelRequire("jC8Vy");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $2Phw0 = parcelRequire("2Phw0");parcelRequire("6bq3s");
var $2Phw0 = parcelRequire("2Phw0");
var $7eec5a427a242e1d$exports = {};

!function(e, t) {
    $7eec5a427a242e1d$exports = t((parcelRequire("jC8Vy")));
}("undefined" != typeof self ? self : $7eec5a427a242e1d$exports, function(e) {
    return function(e) {
        var t = {};
        function r(n) {
            if (t[n]) return t[n].exports;
            var o = t[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, n) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var o in e)r.d(n, o, (function(t) {
                return e[t];
            }).bind(null, o));
            return n;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 3);
    }([
        function(t, r) {
            t.exports = e;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.Validate = t.Time = void 0;
            var n = u(r(5)), o = u(r(6));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            t.Time = n.default, t.Validate = o.default;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.useInterval = void 0;
            var n = function(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }(r(7));
            t.useInterval = n.default;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.useTime = t.useStopwatch = t.useTimer = void 0;
            var n = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t];
                    for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
                }
                return e;
            };
            t.default = function(e) {
                if ((0, o.useEffect)(function() {
                    console.warn("react-timer-hook: default export useTimer is deprecated, use named exports { useTimer, useStopwatch, useTime } instead");
                }, []), e.expiryTimestamp) {
                    var t = (0, u.default)(e);
                    return n({}, t, {
                        startTimer: t.start,
                        stopTimer: t.pause,
                        resetTimer: function() {}
                    });
                }
                var r = (0, i.default)(e);
                return n({}, r, {
                    startTimer: r.start,
                    stopTimer: r.pause,
                    resetTimer: r.reset
                });
            };
            var o = r(0), u = c(r(4)), i = c(r(8)), a = c(r(9));
            function c(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            t.useTimer = u.default, t.useStopwatch = i.default, t.useTime = a.default;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t];
                    for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
                }
                return e;
            }, o = function() {
                return function(e, t) {
                    if (Array.isArray(e)) return e;
                    if (Symbol.iterator in Object(e)) return function(e, t) {
                        var r = [], n = !0, o = !1, u = void 0;
                        try {
                            for(var i, a = e[Symbol.iterator](); !(n = (i = a.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0);
                        } catch (e) {
                            o = !0, u = e;
                        } finally{
                            try {
                                !n && a.return && a.return();
                            } finally{
                                if (o) throw u;
                            }
                        }
                        return r;
                    }(e, t);
                    throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            t.default = function(e) {
                var t = e.expiryTimestamp, r = e.onExpire, s = e.autoStart, l = void 0 === s || s, d = (0, u.useState)(t), m = o(d, 2), v = m[0], p = m[1], y = (0, u.useState)(i.Time.getSecondsFromExpiry(v)), T = o(y, 2), g = T[0], b = T[1], h = (0, u.useState)(l), S = o(h, 2), w = S[0], O = S[1], j = (0, u.useState)(l), x = o(j, 2), _ = x[0], M = x[1], P = (0, u.useState)(f(v)), F = o(P, 2), E = F[0], k = F[1];
                function I(e) {
                    var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                    k(f(e)), M(t), O(t), p(e), b(i.Time.getSecondsFromExpiry(e));
                }
                function D() {
                    var e = new Date;
                    e.setMilliseconds(e.getMilliseconds() + 1e3 * g), I(e);
                }
                return (0, a.useInterval)(function() {
                    E !== c && k(c);
                    var e = i.Time.getSecondsFromExpiry(v);
                    b(e), e <= 0 && (i.Validate.onExpire(r) && r(), O(!1), k(null));
                }, w ? E : null), n({}, i.Time.getTimeFromSeconds(g), {
                    start: function() {
                        _ ? (b(i.Time.getSecondsFromExpiry(v)), O(!0)) : D();
                    },
                    pause: function() {
                        O(!1);
                    },
                    resume: D,
                    restart: I,
                    isRunning: w
                });
            };
            var u = r(0), i = r(1), a = r(2), c = 1e3;
            function f(e) {
                if (!i.Validate.expiryTimestamp(e)) return null;
                var t = i.Time.getSecondsFromExpiry(e), r = Math.floor(1e3 * (t - Math.floor(t)));
                return r > 0 ? r : c;
            }
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = function() {
                function e(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                    }
                }
                return function(t, r, n) {
                    return r && e(t.prototype, r), n && e(t, n), t;
                };
            }();
            var o = function() {
                function e() {
                    !function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e);
                }
                return n(e, null, [
                    {
                        key: "getTimeFromSeconds",
                        value: function(e) {
                            var t = Math.ceil(e), r = Math.floor(t / 86400), n = Math.floor(t % 86400 / 3600), o = Math.floor(t % 3600 / 60);
                            return {
                                seconds: Math.floor(t % 60),
                                minutes: o,
                                hours: n,
                                days: r
                            };
                        }
                    },
                    {
                        key: "getSecondsFromExpiry",
                        value: function(e, t) {
                            var r = e - (new Date).getTime();
                            if (r > 0) {
                                var n = r / 1e3;
                                return t ? Math.round(n) : n;
                            }
                            return 0;
                        }
                    },
                    {
                        key: "getSecondsFromPrevTime",
                        value: function(e, t) {
                            var r = (new Date).getTime() - e;
                            if (r > 0) {
                                var n = r / 1e3;
                                return t ? Math.round(n) : n;
                            }
                            return 0;
                        }
                    },
                    {
                        key: "getSecondsFromTimeNow",
                        value: function() {
                            var e = new Date;
                            return e.getTime() / 1e3 - 60 * e.getTimezoneOffset();
                        }
                    },
                    {
                        key: "getFormattedTimeFromSeconds",
                        value: function(t, r) {
                            var n = e.getTimeFromSeconds(t), o = n.seconds, u = n.minutes, i = n.hours, a = "", c = i;
                            return "12-hour" === r && (a = i >= 12 ? "pm" : "am", c = i % 12), {
                                seconds: o,
                                minutes: u,
                                hours: c,
                                ampm: a
                            };
                        }
                    }
                ]), e;
            }();
            t.default = o;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = function() {
                function e(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                    }
                }
                return function(t, r, n) {
                    return r && e(t.prototype, r), n && e(t, n), t;
                };
            }();
            var o = function() {
                function e() {
                    !function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e);
                }
                return n(e, null, [
                    {
                        key: "expiryTimestamp",
                        value: function(e) {
                            var t = new Date(e).getTime() > 0;
                            return t || console.warn("react-timer-hook: { useTimer } Invalid expiryTimestamp settings", e), t;
                        }
                    },
                    {
                        key: "onExpire",
                        value: function(e) {
                            var t = e && "function" == typeof e;
                            return e && !t && console.warn("react-timer-hook: { useTimer } Invalid onExpire settings function", e), t;
                        }
                    }
                ]), e;
            }();
            t.default = o;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.default = function(e, t) {
                var r = (0, n.useRef)();
                (0, n.useEffect)(function() {
                    r.current = e;
                }), (0, n.useEffect)(function() {
                    if (!t) return function() {};
                    var e = setInterval(function() {
                        r.current && r.current();
                    }, t);
                    return function() {
                        return clearInterval(e);
                    };
                }, [
                    t
                ]);
            };
            var n = r(0);
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t];
                    for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
                }
                return e;
            }, o = function() {
                return function(e, t) {
                    if (Array.isArray(e)) return e;
                    if (Symbol.iterator in Object(e)) return function(e, t) {
                        var r = [], n = !0, o = !1, u = void 0;
                        try {
                            for(var i, a = e[Symbol.iterator](); !(n = (i = a.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0);
                        } catch (e) {
                            o = !0, u = e;
                        } finally{
                            try {
                                !n && a.return && a.return();
                            } finally{
                                if (o) throw u;
                            }
                        }
                        return r;
                    }(e, t);
                    throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            t.default = function(e) {
                var t = e.autoStart, r = e.offsetTimestamp, c = (0, u.useState)(i.Time.getSecondsFromExpiry(r, !0) || 0), f = o(c, 2), s = f[0], l = f[1], d = (0, u.useState)(new Date), m = o(d, 2), v = m[0], p = m[1], y = (0, u.useState)(s + i.Time.getSecondsFromPrevTime(v || 0, !0)), T = o(y, 2), g = T[0], b = T[1], h = (0, u.useState)(t), S = o(h, 2), w = S[0], O = S[1];
                return (0, a.useInterval)(function() {
                    b(s + i.Time.getSecondsFromPrevTime(v, !0));
                }, w ? 1e3 : null), n({}, i.Time.getTimeFromSeconds(g), {
                    start: function() {
                        var e = new Date;
                        p(e), O(!0), b(s + i.Time.getSecondsFromPrevTime(e, !0));
                    },
                    pause: function() {
                        l(g), O(!1);
                    },
                    reset: function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], r = i.Time.getSecondsFromExpiry(e, !0) || 0, n = new Date;
                        p(n), l(r), O(t), b(r + i.Time.getSecondsFromPrevTime(n, !0));
                    },
                    isRunning: w
                });
            };
            var u = r(0), i = r(1), a = r(2);
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t];
                    for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
                }
                return e;
            }, o = function() {
                return function(e, t) {
                    if (Array.isArray(e)) return e;
                    if (Symbol.iterator in Object(e)) return function(e, t) {
                        var r = [], n = !0, o = !1, u = void 0;
                        try {
                            for(var i, a = e[Symbol.iterator](); !(n = (i = a.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0);
                        } catch (e) {
                            o = !0, u = e;
                        } finally{
                            try {
                                !n && a.return && a.return();
                            } finally{
                                if (o) throw u;
                            }
                        }
                        return r;
                    }(e, t);
                    throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            t.default = function(e) {
                var t = e.format, r = (0, u.useState)(i.Time.getSecondsFromTimeNow()), c = o(r, 2), f = c[0], s = c[1];
                return (0, a.useInterval)(function() {
                    s(i.Time.getSecondsFromTimeNow());
                }, 1e3), n({}, i.Time.getFormattedTimeFromSeconds(f, t));
            };
            var u = r(0), i = r(1), a = r(2);
        }
    ]);
});



var $voszV = parcelRequire("voszV");




var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $c3dK3 = parcelRequire("c3dK3");
var $0d03b1b348352731$export$e88bde3ace5c7bbf;
(function(ReservedPlanName) {
    ReservedPlanName["Free"] = "Free";
    ReservedPlanName["Hobby"] = "Hobby";
    ReservedPlanName["Pro"] = "Pro";
    ReservedPlanName["Enterprise"] = "Enterprise";
})($0d03b1b348352731$export$e88bde3ace5c7bbf || ($0d03b1b348352731$export$e88bde3ace5c7bbf = {}));
const $0d03b1b348352731$export$474ca7aa7445cdae = (0, $c3dK3.z).object({
    state: (0, $c3dK3.z).string(),
    sessionId: (0, $c3dK3.z).string(),
    callbackPage: (0, $c3dK3.z).string().optional(),
    isDowngrade: (0, $c3dK3.z).boolean().optional()
});


const $161f1bf99d56f621$var$registeredPlanNamePhraseMap = {
    quotaKey: undefined,
    [(0, $0d03b1b348352731$export$e88bde3ace5c7bbf).Free]: "free_plan",
    [(0, $0d03b1b348352731$export$e88bde3ace5c7bbf).Hobby]: "pro_plan",
    [(0, $0d03b1b348352731$export$e88bde3ace5c7bbf).Pro]: "pro_plan",
    [(0, $0d03b1b348352731$export$e88bde3ace5c7bbf).Enterprise]: "enterprise"
};
function $161f1bf99d56f621$var$PlanName({ name: name }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.subscription"
    });
    const planNamePhrase = $161f1bf99d56f621$var$registeredPlanNamePhraseMap[name];
    /**
   * Note: fallback to the plan name if the phrase is not registered.
   */ const planName = planNamePhrase ? String(t(planNamePhrase)) : name;
    return /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
        children: planName
    });
}
var $161f1bf99d56f621$export$2e2bcd8739ae039 = $161f1bf99d56f621$var$PlanName;


parcelRequire("cuPVN");
var $lXQZH = parcelRequire("lXQZH");
const $217fd4972b445457$export$4478f817ef067d45 = 50000;
const $217fd4972b445457$export$273c590433c54f2b = 1;
const $217fd4972b445457$export$a712ffd25223db9f = 1;
const $217fd4972b445457$export$134386eb2e2226bd = 1;
const $217fd4972b445457$export$b061d26c4cbe21f4 = 3;
const $217fd4972b445457$export$20398ca9e4426c2a = 14;
const $217fd4972b445457$export$1d205931921a7a70 = [
    (0, $lXQZH.ReservedPlanId).Free,
    (0, $lXQZH.ReservedPlanId).Hobby
];
const $217fd4972b445457$export$d3db8605a7f752d9 = [
    (0, $lXQZH.ReservedPlanId).Free,
    (0, $lXQZH.ReservedPlanId).Hobby,
    (0, $lXQZH.ReservedPlanId).Pro
];
const $217fd4972b445457$export$bc242540c43bf946 = "checkout-state";



var $cDKfs = parcelRequire("cDKfs");

var $jC8Vy = parcelRequire("jC8Vy");

var $Xh5AE = parcelRequire("Xh5AE");


var $8TpMk = parcelRequire("8TpMk");

const $116db580d0523aa2$export$b035e44d7bb4278f = (order)=>{
    return (previous, next)=>{
        const preIndex = order.indexOf(previous);
        const nextIndex = order.indexOf(next);
        // Note: If both items not present in the order array, sort them in default order
        if (preIndex === -1 && nextIndex === -1) return 0;
        // Note: If only the previous item is not present in the order array, move it to the end
        if (preIndex === -1) return 1;
        // Note: If only the next item is not present in the order array, keep it in the end
        if (nextIndex === -1) return -1;
        // Note: Compare them based on the index in the order array
        return preIndex - nextIndex;
    };
};


parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");
var $3dBAh = parcelRequire("3dBAh");


var $b67J2 = parcelRequire("b67J2");

parcelRequire("cuPVN");
var $lXQZH = parcelRequire("lXQZH");
const $43d5e1b5339ea79b$export$5a61f5d940231afb = {
    [(0, $lXQZH.ReservedPlanId).Free]: 0,
    [(0, $lXQZH.ReservedPlanId).Hobby]: 48,
    [(0, $lXQZH.ReservedPlanId).Pro]: 48
};
const $43d5e1b5339ea79b$export$103450479c8ed1e3 = [
    "mauLimit",
    "tokenLimit",
    "applicationsLimit",
    "machineToMachineLimit",
    "thirdPartyApplicationsLimit",
    "resourcesLimit",
    "scopesPerResourceLimit",
    "customDomainEnabled",
    "omniSignInEnabled",
    "socialConnectorsLimit",
    "mfaEnabled",
    "ssoEnabled",
    "rolesLimit",
    "machineToMachineRolesLimit",
    "scopesPerRoleLimit",
    "organizationsEnabled",
    "auditLogsRetentionDays",
    "hooksLimit",
    "ticketSupportResponseTime"
];
const $43d5e1b5339ea79b$export$69143de3c73b76af = [];



const $b38537f440ba3476$export$e0876f9cbc4219ca = (subscriptionPlanResponse)=>{
    const { id: id, quota: quota } = subscriptionPlanResponse;
    return {
        ...subscriptionPlanResponse,
        quota: {
            ...quota,
            /**
       * Manually add this support quota item to the plan since it will be compared in the downgrade plan notification modal.
       */ ticketSupportResponseTime: (0, $43d5e1b5339ea79b$export$5a61f5d940231afb)[id] ?? 0
        }
    };
};
const $b38537f440ba3476$var$getSubscriptionPlanOrderById = (id)=>{
    const index = (0, $217fd4972b445457$export$d3db8605a7f752d9).indexOf(id);
    // Note: if the plan id is not in the featuredPlanIdOrder, it will be treated as the highest priority
    return index === -1 ? Number.POSITIVE_INFINITY : index;
};
const $b38537f440ba3476$export$64dac4cdd03b50e1 = (fromPlanId, toPlanId)=>$b38537f440ba3476$var$getSubscriptionPlanOrderById(fromPlanId) > $b38537f440ba3476$var$getSubscriptionPlanOrderById(toPlanId);
const $b38537f440ba3476$export$b971ca6f7de66f44 = ({ periodStart: periodStart, periodEnd: periodEnd, displayYear: displayYear })=>{
    const format = displayYear ? "MMM D, YYYY" : "MMM D";
    const formattedStart = (0, (/*@__PURE__*/$parcel$interopDefault($b67J2)))(periodStart).format(format);
    const formattedEnd = (0, (/*@__PURE__*/$parcel$interopDefault($b67J2)))(periodEnd).format(format);
    return `${formattedStart} - ${formattedEnd}`;
};
const $b38537f440ba3476$export$c0ed1fa5d8f3e3a5 = async (error)=>{
    if (!(error instanceof (0, $33b9cc7fd9279a6b$export$286baf652d0b1206))) return [
        false
    ];
    const { message: message } = await (0, $1c34cc51be8c93d3$export$5c32b0b3061e00c4)(error) ?? {};
    const match = message?.match(/Status exception: Exceeded quota limit\. (.+)$/);
    if (!match) return [
        false
    ];
    const data = match[1];
    const exceededQuota = (0, $7oDSS.conditional)(// eslint-disable-next-line no-restricted-syntax -- trust the type from the server if error message matches
    data && (0, $3dBAh.trySafe)(()=>JSON.parse(data)));
    if (!exceededQuota) return [
        false
    ];
    // eslint-disable-next-line no-restricted-syntax
    return [
        true,
        Object.keys(exceededQuota)
    ];
};
const $b38537f440ba3476$export$1673a249ab23858e = (plans)=>plans.filter(({ id: id })=>(0, $217fd4972b445457$export$1d205931921a7a70).includes(id));


/**
 * Fetch subscription plans from the cloud API.
 * Note: If you want to retrieve subscription plans under the {@link TenantAccess} component, use `SubscriptionDataContext` instead.
 */ const $807aaa3ea0f45a20$var$useSubscriptionPlans = ()=>{
    const cloudApi = (0, $1c34cc51be8c93d3$export$7a5c900790855d66)();
    const useSwrResponse = (0, $Xh5AE.default)((0, $8TpMk.isCloud) && "/api/subscription-plans", async ()=>cloudApi.get("/api/subscription-plans"));
    const { data: subscriptionPlansResponse } = useSwrResponse;
    const subscriptionPlans = (0, $jC8Vy.useMemo)(()=>{
        if (!subscriptionPlansResponse) return;
        return subscriptionPlansResponse.map((plan)=>(0, $b38537f440ba3476$export$e0876f9cbc4219ca)(plan)).slice().sort(({ id: previousId }, { id: nextId })=>(0, $116db580d0523aa2$export$b035e44d7bb4278f)((0, $217fd4972b445457$export$d3db8605a7f752d9))(previousId, nextId));
    }, [
        subscriptionPlansResponse
    ]);
    return {
        ...useSwrResponse,
        data: subscriptionPlans
    };
};
var $807aaa3ea0f45a20$export$2e2bcd8739ae039 = $807aaa3ea0f45a20$var$useSubscriptionPlans;



var $4ZcUR = parcelRequire("4ZcUR");
parcelRequire("8Mb3E");
var $fb30i = parcelRequire("fb30i");


var $3RCsa = parcelRequire("3RCsa");
const $4b2a6b644eabe2ec$export$c162b38bc26bbdbf = (session)=>{
    sessionStorage.setItem((0, $fb30i.storageKeys).checkoutSession, JSON.stringify(session));
};
const $4b2a6b644eabe2ec$export$5cb86149c23fcebb = ()=>{
    const sessionValue = sessionStorage.getItem((0, $fb30i.storageKeys).checkoutSession);
    if (!sessionValue) return;
    const sessionJson = (0, $3RCsa.safeParseJson)(sessionValue);
    if (!sessionJson.success) return;
    const parsedSession = (0, $0d03b1b348352731$export$474ca7aa7445cdae).safeParse(sessionJson.data);
    if (!parsedSession.success) return;
    return parsedSession.data;
};
const $4b2a6b644eabe2ec$export$ab08d6a6b54bf937 = ()=>{
    sessionStorage.removeItem((0, $fb30i.storageKeys).checkoutSession);
};


const $99b45a51a5273fbc$var$consoleHomePage = "/";
const $99b45a51a5273fbc$var$subscriptionCheckingInterval = 1000;
const $99b45a51a5273fbc$var$subscriptionCheckingTimeout = 10000;
function $99b45a51a5273fbc$var$CheckoutSuccessCallback() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.subscription"
    });
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const cloudApi = (0, $1c34cc51be8c93d3$export$7a5c900790855d66)({
        hideErrorToast: true
    });
    const { currentTenantId: currentTenantId, navigateTenant: navigateTenant } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { search: search } = (0, $2Phw0.useLocation)();
    const checkoutState = new URLSearchParams(search).get((0, $217fd4972b445457$export$bc242540c43bf946));
    const { state: state, sessionId: sessionId, callbackPage: callbackPage, isDowngrade: isDowngrade } = (0, $4b2a6b644eabe2ec$export$5cb86149c23fcebb)() ?? {};
    const { data: subscriptionPlans, error: fetchPlansError } = (0, $807aaa3ea0f45a20$export$2e2bcd8739ae039)();
    const isLoadingPlans = !subscriptionPlans && !fetchPlansError;
    // Note: if we can't get the subscription results in 10 seconds, we will redirect to the console home page
    (0, $7eec5a427a242e1d$exports.useTimer)({
        autoStart: true,
        expiryTimestamp: (0, (/*@__PURE__*/$parcel$interopDefault($b67J2)))().add($99b45a51a5273fbc$var$subscriptionCheckingTimeout, "millisecond").toDate(),
        onExpire: ()=>{
            (0, $FuhPC.toast).error(t("subscription_check_timeout"));
            (0, $4b2a6b644eabe2ec$export$ab08d6a6b54bf937)();
            navigate($99b45a51a5273fbc$var$consoleHomePage, {
                replace: true
            });
        }
    });
    // Note: only handle the callback comes from the stripe success callback url
    const isValidSession = state && state === checkoutState;
    const { data: stripeCheckoutSession } = (0, $voszV.default)(isValidSession && sessionId && `/api/checkout-session/${sessionId}`, async ()=>cloudApi.get("/api/checkout-session/:id", {
            params: {
                id: (0, $7oDSS.conditionalString)(sessionId)
            }
        }), {
        refreshInterval: $99b45a51a5273fbc$var$subscriptionCheckingInterval
    });
    const checkoutTenantId = stripeCheckoutSession?.tenantId;
    const checkoutPlanId = stripeCheckoutSession?.planId;
    const { data: tenantSubscription } = (0, $voszV.default)(checkoutTenantId && `/api/tenants/${checkoutTenantId}/subscription`, async ()=>cloudApi.get("/api/tenants/:tenantId/subscription", {
            params: {
                tenantId: (0, $7oDSS.conditionalString)(checkoutTenantId)
            }
        }), {
        refreshInterval: $99b45a51a5273fbc$var$subscriptionCheckingInterval
    });
    const isCheckoutSuccessful = !isLoadingPlans && checkoutTenantId && stripeCheckoutSession.status === "complete" && checkoutPlanId === tenantSubscription?.planId;
    (0, $jC8Vy.useEffect)(()=>{
        if (isCheckoutSuccessful) {
            (0, $4b2a6b644eabe2ec$export$ab08d6a6b54bf937)();
            const checkoutPlan = subscriptionPlans?.find((plan)=>plan.id === checkoutPlanId);
            if (checkoutPlan) (0, $FuhPC.toast).success(/*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                components: {
                    name: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $161f1bf99d56f621$export$2e2bcd8739ae039), {
                        name: checkoutPlan.name
                    })
                },
                children: t(isDowngrade ? "downgrade_success" : "upgrade_success")
            }));
            // No need to check `isDowngrade` here, since a downgrade must occur in a tenant with a Pro
            // plan, and the purchase conversion has already been reported using the same tenant ID. We
            // use the tenant ID as the transaction ID, so there's no concern about duplicate conversion
            // reports.
            (0, $34139a4008fff4d0$export$f1adda6fc3c8905c)((0, $34139a4008fff4d0$export$a3b35db81871225).PurchaseProPlan, {
                transactionId: checkoutTenantId
            });
            // If the tenant is the current tenant, navigate to the callback page
            if (checkoutTenantId === currentTenantId) {
                navigate((0, $7oDSS.conditional)(callbackPage) ?? $99b45a51a5273fbc$var$consoleHomePage, {
                    replace: true
                });
                return;
            }
            // New tenant created, navigate to the new tenant page
            (0, $34139a4008fff4d0$export$f1adda6fc3c8905c)((0, $34139a4008fff4d0$export$a3b35db81871225).CreateProductionTenant, {
                transactionId: checkoutTenantId
            });
            navigateTenant(checkoutTenantId);
        }
    }, [
        callbackPage,
        checkoutPlanId,
        checkoutTenantId,
        currentTenantId,
        isCheckoutSuccessful,
        isDowngrade,
        navigate,
        navigateTenant,
        subscriptionPlans,
        t
    ]);
    if (!isValidSession && !isLoadingPlans) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Navigate), {
        replace: true,
        to: $99b45a51a5273fbc$var$consoleHomePage
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4c070a72a1cf87ce$export$2e2bcd8739ae039), {});
}
var $99b45a51a5273fbc$export$2e2bcd8739ae039 = $99b45a51a5273fbc$var$CheckoutSuccessCallback;



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $2Phw0 = parcelRequire("2Phw0");

var $Xh5AE = parcelRequire("Xh5AE");

var $C7mD2 = parcelRequire("C7mD2");

var $66ixW = parcelRequire("66ixW");

var $9Q3SI = parcelRequire("9Q3SI");

var $C7mD2 = parcelRequire("C7mD2");

var $gC7hG = parcelRequire("gC7hG");
var $5a539b0896c4e7a3$export$34e0f9847d4c02dd;
var $5a539b0896c4e7a3$export$6210fa4921d2a466;
var $5a539b0896c4e7a3$export$a279c5c553241f38;
var $5a539b0896c4e7a3$export$5e54b446970e67c0;
var $5a539b0896c4e7a3$export$bfd64c937657f93a;
var $5a539b0896c4e7a3$export$4a6dd88bada4e7d2;
$5a539b0896c4e7a3$export$34e0f9847d4c02dd = `K4QE8a_container`;
$5a539b0896c4e7a3$export$6210fa4921d2a466 = `K4QE8a_form`;
$5a539b0896c4e7a3$export$a279c5c553241f38 = `K4QE8a_introduction`;
$5a539b0896c4e7a3$export$5e54b446970e67c0 = `K4QE8a_responsiveWrapper`;
$5a539b0896c4e7a3$export$bfd64c937657f93a = `K4QE8a_rotating`;
$5a539b0896c4e7a3$export$4a6dd88bada4e7d2 = `K4QE8a_shimmer`;


function $76464ac2c09882a7$var$FormCardLayout({ introduction: introduction, children: children }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: $5a539b0896c4e7a3$export$5e54b446970e67c0,
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
            className: $5a539b0896c4e7a3$export$34e0f9847d4c02dd,
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $5a539b0896c4e7a3$export$a279c5c553241f38,
                    children: introduction
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $5a539b0896c4e7a3$export$6210fa4921d2a466,
                    children: children
                })
            ]
        })
    });
}
var $76464ac2c09882a7$export$2e2bcd8739ae039 = $76464ac2c09882a7$var$FormCardLayout;


var $cbc9e556616ccefe$export$6d59db4903f20f7d;
var $cbc9e556616ccefe$export$bfd64c937657f93a;
var $cbc9e556616ccefe$export$4a6dd88bada4e7d2;
var $cbc9e556616ccefe$export$fb184b623420d9be;
$cbc9e556616ccefe$export$6d59db4903f20f7d = `-TV4Uq_description`;
$cbc9e556616ccefe$export$bfd64c937657f93a = `-TV4Uq_rotating`;
$cbc9e556616ccefe$export$4a6dd88bada4e7d2 = `-TV4Uq_shimmer`;
$cbc9e556616ccefe$export$fb184b623420d9be = `-TV4Uq_title`;



var $C7mD2 = parcelRequire("C7mD2");

var $0d76ce8423b8c5b4$export$e0f35d825088c098;
var $0d76ce8423b8c5b4$export$bfd64c937657f93a;
var $0d76ce8423b8c5b4$export$4a6dd88bada4e7d2;
var $0d76ce8423b8c5b4$export$6f093cfa640b7166;
var $0d76ce8423b8c5b4$export$fb184b623420d9be;
$0d76ce8423b8c5b4$export$e0f35d825088c098 = `iExUWa_field`;
$0d76ce8423b8c5b4$export$bfd64c937657f93a = `iExUWa_rotating`;
$0d76ce8423b8c5b4$export$4a6dd88bada4e7d2 = `iExUWa_shimmer`;
$0d76ce8423b8c5b4$export$4a6dd88bada4e7d2;
$0d76ce8423b8c5b4$export$6f093cfa640b7166 = `iExUWa_text`;
$0d76ce8423b8c5b4$export$fb184b623420d9be = `iExUWa_title`;


function $fe58a6ffca737898$var$Skeleton({ formFieldCount: formFieldCount = 4 }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $76464ac2c09882a7$export$2e2bcd8739ae039), {
        introduction: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $0d76ce8423b8c5b4$export$fb184b623420d9be
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    children: Array.from({
                        length: 2
                    }).map((_, index)=>// eslint-disable-next-line react/no-array-index-key
                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $0d76ce8423b8c5b4$export$6f093cfa640b7166
                        }, index))
                })
            ]
        }),
        children: Array.from({
            length: formFieldCount
        }).map((_, index)=>// eslint-disable-next-line react/no-array-index-key
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $0d76ce8423b8c5b4$export$e0f35d825088c098
            }, index))
    });
}
var $fe58a6ffca737898$export$2e2bcd8739ae039 = $fe58a6ffca737898$var$Skeleton;


function $fb58e96bbd460634$var$FormCard({ title: title, tag: tag, description: description, descriptionInterpolation: descriptionInterpolation, learnMoreLink: learnMoreLink, children: children }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $76464ac2c09882a7$export$2e2bcd8739ae039), {
        introduction: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: $cbc9e556616ccefe$export$fb184b623420d9be,
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: title
                        }),
                        tag
                    ]
                }),
                description && /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: $cbc9e556616ccefe$export$6d59db4903f20f7d,
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: description,
                            interpolation: descriptionInterpolation
                        }),
                        learnMoreLink?.href && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                            children: [
                                " ",
                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                                    href: learnMoreLink.href,
                                    targetBlank: learnMoreLink.targetBlank,
                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                        forKey: learnMoreLink.linkText ?? "general.learn_more"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        }),
        children: children
    });
}
var $fb58e96bbd460634$export$2e2bcd8739ae039 = $fb58e96bbd460634$var$FormCard;



var $5TsIB = parcelRequire("5TsIB");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $3dBAh = parcelRequire("3dBAh");
var $jMfTG = parcelRequire("jMfTG");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $3f84a7e499ce2dd3$var$SvgContactUs = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 18,
        height: 18,
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M8.408 11.742a1.31 1.31 0 0 0-.1.125.632.632 0 0 0-.075.15.533.533 0 0 0-.05.15 1.133 1.133 0 0 0 0 .166.7.7 0 0 0 .067.317.75.75 0 0 0 .45.45.783.783 0 0 0 .633 0 .75.75 0 0 0 .45-.45.834.834 0 0 0 .05-.317.833.833 0 0 0-1.425-.591ZM9 .667a8.333 8.333 0 1 0 0 16.666A8.333 8.333 0 0 0 9 .667Zm0 15A6.666 6.666 0 1 1 9 2.334a6.666 6.666 0 0 1 0 13.333ZM9 4.833a2.5 2.5 0 0 0-2.167 1.25.833.833 0 1 0 1.442.834.833.833 0 0 1 1.314-.173A.833.833 0 0 1 9 8.167.833.833 0 0 0 8.167 9v.833a.833.833 0 0 0 1.666 0v-.15A2.5 2.5 0 0 0 9 4.833Z",
            fill: "#47464E"
        })
    });
var $3f84a7e499ce2dd3$export$2e2bcd8739ae039 = $3f84a7e499ce2dd3$var$SvgContactUs;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $6eca204aeed0dcf3$var$SvgCube = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M20.49 7.52a.19.19 0 0 1 0-.08.169.169 0 0 1 0-.07v-.09l-.06-.15a.48.48 0 0 0-.09-.11l-.09-.08h-.05l-3.94-2.49-3.72-2.3a.85.85 0 0 0-.29-.15h-.08a.82.82 0 0 0-.27 0h-.1c-.116.026-.228.07-.33.13L4 6.78l-.09.07-.09.08-.1.07-.05.06-.06.15v.15a.69.69 0 0 0 0 .2v8.73a1 1 0 0 0 .47.85l7.5 4.64.15.06h.08a.86.86 0 0 0 .52 0h.08l.15-.06L20 17.21a.999.999 0 0 0 .47-.85V7.63s.02-.07.02-.11ZM12 4.17l1.78 1.1-5.59 3.46-1.79-1.1L12 4.17Zm-1 15-5.5-3.36V9.42l5.5 3.4v6.35Zm1-8.11-1.91-1.15 5.59-3.47 1.92 1.19-5.6 3.43Zm6.5 4.72L13 19.2v-6.38l5.5-3.4v6.36Z",
            fill: "currentColor"
        })
    });
var $6eca204aeed0dcf3$export$2e2bcd8739ae039 = $6eca204aeed0dcf3$var$SvgCube;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $d77c39b23d569fd8$var$SvgDocumentNavButton = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 14,
        height: 18,
        viewBox: "0 0 14 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M13.667 6.45a1.097 1.097 0 0 0-.05-.225V6.15a.89.89 0 0 0-.159-.233l-5-5a.892.892 0 0 0-.233-.159H8.15L7.883.667h-5.05a2.5 2.5 0 0 0-2.5 2.5v11.666a2.5 2.5 0 0 0 2.5 2.5h8.334a2.5 2.5 0 0 0 2.5-2.5V6.45Zm-5-2.942 2.158 2.159H8.667V3.508ZM12 14.833a.833.833 0 0 1-.833.834H2.833A.833.833 0 0 1 2 14.833V3.167a.833.833 0 0 1 .833-.834H7V6.5a.833.833 0 0 0 .833.833H12v7.5Z",
            fill: "#47464E"
        })
    });
var $d77c39b23d569fd8$export$2e2bcd8739ae039 = $d77c39b23d569fd8$var$SvgDocumentNavButton;




parcelRequire("8Mb3E");
var $cfL6o = parcelRequire("cfL6o");

var $8TpMk = parcelRequire("8TpMk");

var $66ixW = parcelRequire("66ixW");

var $jbKqE = parcelRequire("jbKqE");

var $9Q3SI = parcelRequire("9Q3SI");
parcelRequire("12bMu");
var $gcHb7 = parcelRequire("gcHb7");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var /**
 * Supported languages on https://docs.logto.io
 */ $b595fc2f0eccd19a$var$DocumentationLanguage;
(function(DocumentationLanguage) {
    DocumentationLanguage["English"] = "en";
})($b595fc2f0eccd19a$var$DocumentationLanguage || ($b595fc2f0eccd19a$var$DocumentationLanguage = {}));
const $b595fc2f0eccd19a$var$documentationSiteRoot = "https://docs.logto.io";
const $b595fc2f0eccd19a$var$useDocumentationUrl = ()=>{
    const { i18n: { language: language } } = (0, $5OuPq.useTranslation)();
    const documentationSiteUrl = Object.values($b595fc2f0eccd19a$var$DocumentationLanguage).filter((language)=>language !== $b595fc2f0eccd19a$var$DocumentationLanguage.English).includes(language) ? `${$b595fc2f0eccd19a$var$documentationSiteRoot}/${language.toLocaleLowerCase()}` : $b595fc2f0eccd19a$var$documentationSiteRoot;
    return {
        documentationSiteUrl: documentationSiteUrl,
        getDocumentationUrl: (pagePath)=>(0, $gcHb7.appendPath)(new URL(documentationSiteUrl), pagePath).toString()
    };
};
var $b595fc2f0eccd19a$export$2e2bcd8739ae039 = $b595fc2f0eccd19a$var$useDocumentationUrl;



var $bnkR4 = parcelRequire("bnkR4");

var $C7mD2 = parcelRequire("C7mD2");

var $kUZ14 = parcelRequire("kUZ14");

var $jGWQ4 = parcelRequire("jGWQ4");

var $66ixW = parcelRequire("66ixW");

var $5vVWy = parcelRequire("5vVWy");

var $dW2kG = parcelRequire("dW2kG");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $2e6df1b21ae8e26a$var$SvgCalendar = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 48,
                height: 48,
                rx: 16,
                fill: "#EFF1F1"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M33.613 11.556h1.775v.888h-1.775v-.888Z",
                fill: "#66757F"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M9.778 16v18.519c0 2.045 1.592 3.703 3.555 3.703h21.334c1.963 0 3.555-1.658 3.555-3.703V16H9.778Z",
                fill: "#C9C5D0"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M34.667 9.778H13.333c-1.963 0-3.555 1.238-3.555 2.765V16h28.444v-3.457c0-1.527-1.592-2.765-3.555-2.765Z",
                fill: "#DD3730"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M17.778 19.556c0-.491.398-.89.889-.89h1.777c.491 0 .89.399.89.89v1.777a.889.889 0 0 1-.89.89h-1.777a.889.889 0 0 1-.89-.89v-1.777Zm4.444 0c0-.491.398-.89.89-.89h1.777c.49 0 .889.399.889.89v1.777a.889.889 0 0 1-.89.89h-1.777a.889.889 0 0 1-.889-.89v-1.777Zm4.445 0c0-.491.398-.89.888-.89h1.778c.491 0 .89.399.89.89v1.777a.889.889 0 0 1-.89.89h-1.777a.889.889 0 0 1-.89-.89v-1.777Zm4.444 0c0-.491.398-.89.889-.89h1.778c.49 0 .889.399.889.89v1.777a.889.889 0 0 1-.89.89H32a.889.889 0 0 1-.889-.89v-1.777ZM13.333 24c0-.49.398-.889.89-.889H16c.49 0 .889.398.889.889v1.778c0 .49-.398.889-.889.889h-1.778a.889.889 0 0 1-.889-.89V24Zm4.445 0c0-.49.398-.889.889-.889h1.777c.491 0 .89.398.89.889v1.778c0 .49-.399.889-.89.889h-1.777a.889.889 0 0 1-.89-.89V24Zm4.444 0c0-.49.398-.889.89-.889h1.777c.49 0 .889.398.889.889v1.778c0 .49-.398.889-.89.889h-1.777a.889.889 0 0 1-.889-.89V24Zm4.445 0c0-.49.398-.889.888-.889h1.778c.491 0 .89.398.89.889v1.778c0 .49-.399.889-.89.889h-1.777a.889.889 0 0 1-.89-.89V24Zm4.444 0c0-.49.398-.889.889-.889h1.778c.49 0 .889.398.889.889v1.778c0 .49-.398.889-.89.889H32a.889.889 0 0 1-.889-.89V24Zm-17.778 4.444c0-.49.398-.888.89-.888H16c.49 0 .889.397.889.888v1.778c0 .491-.398.89-.889.89h-1.778a.889.889 0 0 1-.889-.89v-1.778Zm4.445 0c0-.49.398-.888.889-.888h1.777c.491 0 .89.397.89.888v1.778c0 .491-.399.89-.89.89h-1.777a.889.889 0 0 1-.89-.89v-1.778Zm4.444 0c0-.49.398-.888.89-.888h1.777c.49 0 .889.397.889.888v1.778c0 .491-.398.89-.89.89h-1.777a.889.889 0 0 1-.889-.89v-1.778Zm4.445 0c0-.49.398-.888.888-.888h1.778c.491 0 .89.397.89.888v1.778c0 .491-.399.89-.89.89h-1.777a.889.889 0 0 1-.89-.89v-1.778Zm4.444 0c0-.49.398-.888.889-.888h1.778c.49 0 .889.397.889.888v1.778c0 .491-.398.89-.89.89H32a.889.889 0 0 1-.889-.89v-1.778ZM13.333 32.89c0-.491.398-.889.89-.889H16c.49 0 .889.398.889.889v1.778c0 .49-.398.889-.889.889h-1.778a.889.889 0 0 1-.889-.89V32.89Zm4.445 0c0-.491.398-.889.889-.889h1.777c.491 0 .89.398.89.889v1.778c0 .49-.399.889-.89.889h-1.777a.889.889 0 0 1-.89-.89V32.89Zm4.444 0c0-.491.398-.889.89-.889h1.777c.49 0 .889.398.889.889v1.778c0 .49-.398.889-.89.889h-1.777a.889.889 0 0 1-.889-.89V32.89Z",
                fill: "#fff"
            })
        ]
    });
var $2e6df1b21ae8e26a$export$2e2bcd8739ae039 = $2e6df1b21ae8e26a$var$SvgCalendar;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $f6420c538c76218c$var$SvgDiscordDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 48,
                height: 48,
                rx: 12,
                fill: "#191C1D"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 48,
                height: 48,
                rx: 12,
                fill: "#C4C7C7",
                fillOpacity: 0.02
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 48,
                height: 48,
                rx: 12,
                fill: "#CABEFF",
                fillOpacity: 0.14
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M35.09 14.022a26.388 26.388 0 0 0-6.514-2.02.099.099 0 0 0-.105.05c-.281.5-.593 1.152-.81 1.665a24.363 24.363 0 0 0-7.317 0 16.862 16.862 0 0 0-.823-1.666.103.103 0 0 0-.105-.05 26.312 26.312 0 0 0-6.513 2.02.093.093 0 0 0-.043.038C8.71 20.256 7.575 26.302 8.132 32.272a.11.11 0 0 0 .042.075 26.534 26.534 0 0 0 7.99 4.04.103.103 0 0 0 .113-.037 18.955 18.955 0 0 0 1.634-2.66.101.101 0 0 0-.055-.14c-.87-.33-1.7-.733-2.496-1.19a.103.103 0 0 1-.01-.17c.167-.126.335-.256.495-.389a.099.099 0 0 1 .104-.014c5.237 2.392 10.906 2.392 16.082 0a.099.099 0 0 1 .104.013c.16.132.328.264.497.39a.103.103 0 0 1-.008.17 16.39 16.39 0 0 1-2.498 1.189.102.102 0 0 0-.054.142c.48.93 1.029 1.817 1.633 2.657.025.036.07.051.113.039a26.447 26.447 0 0 0 8.003-4.04.102.102 0 0 0 .041-.073c.667-6.903-1.117-12.899-4.731-18.214a.082.082 0 0 0-.042-.038ZM18.692 28.637c-1.576 0-2.876-1.447-2.876-3.225s1.274-3.225 2.876-3.225c1.615 0 2.901 1.46 2.876 3.225 0 1.778-1.274 3.225-2.876 3.225Zm10.633 0c-1.576 0-2.875-1.447-2.875-3.225s1.273-3.225 2.875-3.225c1.615 0 2.901 1.46 2.876 3.225 0 1.778-1.261 3.225-2.876 3.225Z",
                fill: "#5865F2"
            })
        ]
    });
var $f6420c538c76218c$export$2e2bcd8739ae039 = $f6420c538c76218c$var$SvgDiscordDark;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $68ef4cce1eca21f6$var$SvgDiscord = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M0 12C0 5.373 5.373 0 12 0h24c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H12C5.373 48 0 42.627 0 36V12Z",
                fill: "#EFF1F1"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M35.09 14.022a26.388 26.388 0 0 0-6.514-2.02.099.099 0 0 0-.105.05c-.281.5-.593 1.152-.81 1.665a24.363 24.363 0 0 0-7.317 0 16.862 16.862 0 0 0-.823-1.666.103.103 0 0 0-.105-.05 26.312 26.312 0 0 0-6.513 2.02.093.093 0 0 0-.043.038C8.71 20.256 7.575 26.302 8.132 32.272a.11.11 0 0 0 .042.075 26.534 26.534 0 0 0 7.99 4.04.103.103 0 0 0 .113-.037 18.955 18.955 0 0 0 1.634-2.66.101.101 0 0 0-.055-.14c-.87-.33-1.7-.733-2.496-1.19a.103.103 0 0 1-.01-.17c.167-.126.335-.256.495-.389a.099.099 0 0 1 .104-.014c5.237 2.392 10.906 2.392 16.082 0a.099.099 0 0 1 .104.013c.16.132.328.264.497.39a.103.103 0 0 1-.008.17 16.39 16.39 0 0 1-2.498 1.189.102.102 0 0 0-.054.142c.48.93 1.029 1.817 1.633 2.657.025.036.07.051.113.039a26.447 26.447 0 0 0 8.003-4.04.102.102 0 0 0 .041-.073c.667-6.903-1.117-12.899-4.731-18.214a.082.082 0 0 0-.042-.038ZM18.692 28.637c-1.576 0-2.876-1.447-2.876-3.225s1.274-3.225 2.876-3.225c1.615 0 2.901 1.46 2.876 3.225 0 1.778-1.274 3.225-2.876 3.225Zm10.633 0c-1.576 0-2.875-1.447-2.875-3.225s1.273-3.225 2.875-3.225c1.615 0 2.901 1.46 2.876 3.225 0 1.778-1.261 3.225-2.876 3.225Z",
                fill: "#5865F2"
            })
        ]
    });
var $68ef4cce1eca21f6$export$2e2bcd8739ae039 = $68ef4cce1eca21f6$var$SvgDiscord;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $474b003c22244ad1$var$SvgEmailDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 48,
                height: 48,
                rx: 12,
                fill: "#191C1D"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 48,
                height: 48,
                rx: 12,
                fill: "#C4C7C7",
                fillOpacity: 0.02
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 48,
                height: 48,
                rx: 12,
                fill: "#CABEFF",
                fillOpacity: 0.14
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M24 40c8.837 0 16-7.163 16-16S32.837 8 24 8 8 15.163 8 24s7.163 16 16 16Zm6-24c.475 0 .93.083 1.353.235L24 23.585l-7.352-7.352A3.992 3.992 0 0 1 18 16h12Zm-5.241 9.657a.997.997 0 0 1-.758.291.998.998 0 0 1-.758-.291l-8.27-8.271A3.985 3.985 0 0 0 14 20v8a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4v-8c0-.999-.366-1.912-.971-2.613l-8.27 8.27Z",
                fill: "#8ECF8E"
            })
        ]
    });
var $474b003c22244ad1$export$2e2bcd8739ae039 = $474b003c22244ad1$var$SvgEmailDark;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $cc8f0ed416c99700$var$SvgEmail = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M0 16C0 7.163 7.163 0 16 0h16c8.837 0 16 7.163 16 16v16c0 8.837-7.163 16-16 16H16C7.163 48 0 40.837 0 32V16Z",
                fill: "#EFF1F1"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M24 40c8.837 0 16-7.163 16-16S32.837 8 24 8 8 15.163 8 24s7.163 16 16 16Zm6-24c.475 0 .93.083 1.353.235L24 23.585l-7.352-7.352A3.992 3.992 0 0 1 18 16h12Zm-5.241 9.657a.997.997 0 0 1-.758.291.998.998 0 0 1-.758-.291l-8.27-8.271A3.985 3.985 0 0 0 14 20v8a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4v-8c0-.999-.366-1.912-.971-2.613l-8.27 8.27Z",
                fill: "#4EA254"
            })
        ]
    });
var $cc8f0ed416c99700$export$2e2bcd8739ae039 = $cc8f0ed416c99700$var$SvgEmail;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $4807a3c72bfde125$var$SvgGithubDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 48,
                height: 48,
                rx: 12,
                fill: "#191C1D"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 48,
                height: 48,
                rx: 12,
                fill: "#C4C7C7",
                fillOpacity: 0.02
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 48,
                height: 48,
                rx: 12,
                fill: "#CABEFF",
                fillOpacity: 0.14
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M24 8c-3.8 0-7.474 1.386-10.368 3.91-2.894 2.525-4.817 6.022-5.425 9.867a16.752 16.752 0 0 0 2.103 11.12c1.967 3.333 5.026 5.84 8.63 7.072.8.143 1.1-.349 1.1-.78 0-.39-.02-1.681-.02-3.055-4.02.759-5.06-1.005-5.38-1.928A5.962 5.962 0 0 0 13 31.89c-.56-.307-1.36-1.066-.02-1.087.512.058 1.002.24 1.43.533.429.292.782.687 1.03 1.149.219.403.513.758.866 1.044a3.39 3.39 0 0 0 1.19.624 3.34 3.34 0 0 0 2.604-.315 3.487 3.487 0 0 1 1.02-2.194c-3.56-.41-7.28-1.825-7.28-8.1a6.477 6.477 0 0 1 1.64-4.408 6.033 6.033 0 0 1 .16-4.348s1.34-.43 4.4 1.682a14.724 14.724 0 0 1 8 0c3.06-2.133 4.4-1.682 4.4-1.682.592 1.376.65 2.93.16 4.348a6.439 6.439 0 0 1 1.64 4.409c0 6.295-3.74 7.69-7.3 8.1a3.9 3.9 0 0 1 .862 1.396c.186.524.26 1.083.218 1.638 0 2.194-.02 3.958-.02 4.511 0 .431.3.944 1.1.78 3.598-1.242 6.648-3.755 8.606-7.09a16.762 16.762 0 0 0 2.084-11.115c-.613-3.841-2.537-7.334-5.43-9.856A15.775 15.775 0 0 0 24 8Z",
                fill: "#fff"
            })
        ]
    });
var $4807a3c72bfde125$export$2e2bcd8739ae039 = $4807a3c72bfde125$var$SvgGithubDark;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $1195a88aa0404739$var$SvgGithub = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M0 16C0 7.163 7.163 0 16 0h16c8.837 0 16 7.163 16 16v16c0 8.837-7.163 16-16 16H16C7.163 48 0 40.837 0 32V16Z",
                fill: "#EFF1F1"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M24 8c-3.8 0-7.474 1.386-10.368 3.91-2.894 2.525-4.817 6.022-5.425 9.867a16.752 16.752 0 0 0 2.103 11.12c1.967 3.333 5.026 5.84 8.63 7.072.8.143 1.1-.349 1.1-.78 0-.39-.02-1.681-.02-3.055-4.02.759-5.06-1.005-5.38-1.928A5.962 5.962 0 0 0 13 31.89c-.56-.307-1.36-1.066-.02-1.087.512.058 1.002.24 1.43.533.429.292.782.687 1.03 1.149.219.403.513.758.866 1.044a3.39 3.39 0 0 0 1.19.624 3.34 3.34 0 0 0 2.604-.315 3.487 3.487 0 0 1 1.02-2.194c-3.56-.41-7.28-1.825-7.28-8.1a6.477 6.477 0 0 1 1.64-4.408 6.033 6.033 0 0 1 .16-4.348s1.34-.43 4.4 1.682a14.724 14.724 0 0 1 8 0c3.06-2.133 4.4-1.682 4.4-1.682.592 1.376.65 2.93.16 4.348a6.439 6.439 0 0 1 1.64 4.409c0 6.295-3.74 7.69-7.3 8.1a3.9 3.9 0 0 1 .862 1.396c.186.524.26 1.083.218 1.638 0 2.194-.02 3.958-.02 4.511 0 .431.3.944 1.1.78 3.598-1.242 6.648-3.755 8.606-7.09a16.762 16.762 0 0 0 2.084-11.115c-.613-3.841-2.537-7.334-5.43-9.856A15.775 15.775 0 0 0 24 8Z",
                fill: "#000"
            })
        ]
    });
var $1195a88aa0404739$export$2e2bcd8739ae039 = $1195a88aa0404739$var$SvgGithub;


parcelRequire("8Mb3E");
var $cfL6o = parcelRequire("cfL6o");

var $jheqv = parcelRequire("jheqv");
const $21ed8507f6da45cb$export$287a4b3663fb9f55 = ()=>{
    const theme = (0, $jheqv.default)();
    const isLightMode = theme === (0, $5HVJe.Theme).Light;
    return [
        {
            title: "contact.discord.title",
            icon: isLightMode ? (0, $68ef4cce1eca21f6$export$2e2bcd8739ae039) : (0, $f6420c538c76218c$export$2e2bcd8739ae039),
            description: "contact.discord.description",
            label: "contact.discord.button",
            link: (0, $cfL6o.discordLink)
        },
        {
            title: "contact.github.title",
            icon: isLightMode ? (0, $1195a88aa0404739$export$2e2bcd8739ae039) : (0, $4807a3c72bfde125$export$2e2bcd8739ae039),
            description: "contact.github.description",
            label: "contact.github.button",
            link: (0, $cfL6o.githubIssuesLink)
        },
        {
            title: "contact.email.title",
            icon: isLightMode ? (0, $cc8f0ed416c99700$export$2e2bcd8739ae039) : (0, $474b003c22244ad1$export$2e2bcd8739ae039),
            description: "contact.email.description",
            label: "contact.email.button",
            link: (0, $cfL6o.contactEmailLink)
        },
        {
            title: "contact.reserve.title",
            icon: (0, $2e6df1b21ae8e26a$export$2e2bcd8739ae039),
            description: "contact.reserve.description",
            label: "contact.reserve.button",
            link: (0, $cfL6o.reservationLink)
        }
    ];
};


var $9c80ad59785d8e13$export$2ba01fb71ed41cb6;
var $9c80ad59785d8e13$export$6d59db4903f20f7d;
var $9c80ad59785d8e13$export$1ca1ec8b29a4ce27;
var $9c80ad59785d8e13$export$9c30223ca0a664fb;
var $9c80ad59785d8e13$export$f22da7240b7add18;
var $9c80ad59785d8e13$export$bfd64c937657f93a;
var $9c80ad59785d8e13$export$120ff0929b202a6d;
var $9c80ad59785d8e13$export$4a6dd88bada4e7d2;
var $9c80ad59785d8e13$export$6f093cfa640b7166;
var $9c80ad59785d8e13$export$fb184b623420d9be;
$9c80ad59785d8e13$export$2ba01fb71ed41cb6 = `rdUkXG_button`;
$9c80ad59785d8e13$export$6d59db4903f20f7d = `rdUkXG_description`;
$9c80ad59785d8e13$export$1ca1ec8b29a4ce27 = `rdUkXG_icon`;
$9c80ad59785d8e13$export$9c30223ca0a664fb = `rdUkXG_link`;
$9c80ad59785d8e13$export$f22da7240b7add18 = `rdUkXG_main`;
$9c80ad59785d8e13$export$bfd64c937657f93a = `rdUkXG_rotating`;
$9c80ad59785d8e13$export$120ff0929b202a6d = `rdUkXG_row`;
$9c80ad59785d8e13$export$4a6dd88bada4e7d2 = `rdUkXG_shimmer`;
$9c80ad59785d8e13$export$6f093cfa640b7166 = `rdUkXG_text`;
$9c80ad59785d8e13$export$fb184b623420d9be = `rdUkXG_title`;


function $fb6c208474f70908$var$ContactModal({ isOpen: isOpen, onCancel: onCancel }) {
    const contacts = (0, $21ed8507f6da45cb$export$287a4b3663fb9f55)();
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        shouldCloseOnEsc: true,
        shouldCloseOnOverlayClick: true,
        isOpen: isOpen,
        className: $dW2kG.content,
        overlayClassName: $dW2kG.overlay,
        onRequestClose: onCancel,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5vVWy.default), {
            title: "contact.title",
            subtitle: "contact.description",
            onClose: onCancel,
            children: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $9c80ad59785d8e13$export$f22da7240b7add18,
                children: contacts.map(({ title: title, icon: ContactIcon, description: description, label: label, link: link })=>/*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $9c80ad59785d8e13$export$120ff0929b202a6d,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $9c80ad59785d8e13$export$1ca1ec8b29a4ce27,
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)(ContactIcon, {})
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                className: $9c80ad59785d8e13$export$6f093cfa640b7166,
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $9c80ad59785d8e13$export$fb184b623420d9be,
                                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                            forKey: title
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $9c80ad59785d8e13$export$6d59db4903f20f7d,
                                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                            forKey: description
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("a", {
                                href: link,
                                target: "_blank",
                                className: $9c80ad59785d8e13$export$9c30223ca0a664fb,
                                rel: "noopener",
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                                    type: "outline",
                                    title: label,
                                    className: $9c80ad59785d8e13$export$2ba01fb71ed41cb6
                                })
                            })
                        ]
                    }, title))
            })
        })
    });
}
var $fb6c208474f70908$export$2e2bcd8739ae039 = $fb6c208474f70908$var$ContactModal;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $0b30fe81c923292b$var$SvgPlus = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M15.834 9.167h-5v-5a.833.833 0 1 0-1.667 0v5h-5a.833.833 0 1 0 0 1.666h5v5a.833.833 0 0 0 1.667 0v-5h5a.833.833 0 0 0 0-1.666Z",
            fill: "currentColor"
        })
    });
var $0b30fe81c923292b$export$2e2bcd8739ae039 = $0b30fe81c923292b$var$SvgPlus;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $iq1sR = parcelRequire("iq1sR");
var $5HVJe = parcelRequire("5HVJe");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $kUZ14 = parcelRequire("kUZ14");




var $56db5 = parcelRequire("56db5");

var $8TpMk = parcelRequire("8TpMk");

var $jGWQ4 = parcelRequire("jGWQ4");

var $8R7rc = parcelRequire("8R7rc");

var $aqmjm = parcelRequire("aqmjm");

var $5vVWy = parcelRequire("5vVWy");


var $fmHmG = parcelRequire("fmHmG");

var $jheqv = parcelRequire("jheqv");

var $dW2kG = parcelRequire("dW2kG");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $iq1sR = parcelRequire("iq1sR");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $iq1sR = parcelRequire("iq1sR");

var $5UrGx = parcelRequire("5UrGx");

var $66ixW = parcelRequire("66ixW");
var $d80e154e300f7a77$exports = {};

$parcel$export($d80e154e300f7a77$exports, "development", function () { return $d80e154e300f7a77$export$7f52bbed0c1a13ff; }, function (v) { return $d80e154e300f7a77$export$7f52bbed0c1a13ff = v; });
$parcel$export($d80e154e300f7a77$exports, "large", function () { return $d80e154e300f7a77$export$f09585a853dddd32; }, function (v) { return $d80e154e300f7a77$export$f09585a853dddd32 = v; });
$parcel$export($d80e154e300f7a77$exports, "production", function () { return $d80e154e300f7a77$export$d71d1489bc353e92; }, function (v) { return $d80e154e300f7a77$export$d71d1489bc353e92 = v; });
$parcel$export($d80e154e300f7a77$exports, "rotating", function () { return $d80e154e300f7a77$export$bfd64c937657f93a; }, function (v) { return $d80e154e300f7a77$export$bfd64c937657f93a = v; });
$parcel$export($d80e154e300f7a77$exports, "shimmer", function () { return $d80e154e300f7a77$export$4a6dd88bada4e7d2; }, function (v) { return $d80e154e300f7a77$export$4a6dd88bada4e7d2 = v; });
$parcel$export($d80e154e300f7a77$exports, "staging", function () { return $d80e154e300f7a77$export$e9c7a10224a19f02; }, function (v) { return $d80e154e300f7a77$export$e9c7a10224a19f02 = v; });
$parcel$export($d80e154e300f7a77$exports, "tag", function () { return $d80e154e300f7a77$export$2b067c6666111485; }, function (v) { return $d80e154e300f7a77$export$2b067c6666111485 = v; });
var $d80e154e300f7a77$export$7f52bbed0c1a13ff;
var $d80e154e300f7a77$export$f09585a853dddd32;
var $d80e154e300f7a77$export$d71d1489bc353e92;
var $d80e154e300f7a77$export$bfd64c937657f93a;
var $d80e154e300f7a77$export$4a6dd88bada4e7d2;
var $d80e154e300f7a77$export$e9c7a10224a19f02;
var $d80e154e300f7a77$export$2b067c6666111485;
$d80e154e300f7a77$export$7f52bbed0c1a13ff = `uZxRxa_development`;
$d80e154e300f7a77$export$f09585a853dddd32 = `uZxRxa_large`;
$d80e154e300f7a77$export$d71d1489bc353e92 = `uZxRxa_production`;
$d80e154e300f7a77$export$bfd64c937657f93a = `uZxRxa_rotating`;
$d80e154e300f7a77$export$4a6dd88bada4e7d2 = `uZxRxa_shimmer`;
$d80e154e300f7a77$export$e9c7a10224a19f02 = `uZxRxa_staging`;
$d80e154e300f7a77$export$2b067c6666111485 = `uZxRxa_tag`;


const $7e60916f61ffa7e7$export$ae9becdfc4a807ab = Object.freeze({
    [(0, $iq1sR.TenantTag).Development]: "tenants.settings.environment_tag_development",
    [(0, $iq1sR.TenantTag).Production]: "tenants.settings.environment_tag_production"
});
const $7e60916f61ffa7e7$var$tenantTagNameMap = Object.freeze({
    [(0, $iq1sR.TenantTag).Development]: "tenants.full_env_tag.development",
    [(0, $iq1sR.TenantTag).Production]: "tenants.full_env_tag.production"
});
function $7e60916f61ffa7e7$var$TenantEnvTag({ tag: tag, className: className, isAbbreviated: isAbbreviated = true, size: size = "default" }) {
    const phrasesMap = isAbbreviated ? $7e60916f61ffa7e7$export$ae9becdfc4a807ab : $7e60916f61ffa7e7$var$tenantTagNameMap;
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($d80e154e300f7a77$exports.tag, $d80e154e300f7a77$exports[tag], $d80e154e300f7a77$exports[size], className),
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
            forKey: phrasesMap[tag]
        })
    });
}
var $7e60916f61ffa7e7$export$2e2bcd8739ae039 = $7e60916f61ffa7e7$var$TenantEnvTag;



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");
var $8f4d66f98d1a0009$export$e8c9778bf415dd08;
$8f4d66f98d1a0009$export$e8c9778bf415dd08 = `iMcnjq_divider`;


function $136a7fa3591fc649$var$Divider({ className: className }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($8f4d66f98d1a0009$export$e8c9778bf415dd08, className)
    });
}
var $136a7fa3591fc649$export$2e2bcd8739ae039 = $136a7fa3591fc649$var$Divider;



var $66ixW = parcelRequire("66ixW");


var $b1ade62fb903e6c1$export$34e0f9847d4c02dd;
var $b1ade62fb903e6c1$export$6d59db4903f20f7d;
var $b1ade62fb903e6c1$export$464c821cd4347539;
var $b1ade62fb903e6c1$export$b54cf5587cb9457;
var $b1ade62fb903e6c1$export$bfd64c937657f93a;
var $b1ade62fb903e6c1$export$4a6dd88bada4e7d2;
var $b1ade62fb903e6c1$export$2b067c6666111485;
$b1ade62fb903e6c1$export$34e0f9847d4c02dd = `rO9d9G_container`;
$b1ade62fb903e6c1$export$6d59db4903f20f7d = `rO9d9G_description`;
$b1ade62fb903e6c1$export$464c821cd4347539 = `rO9d9G_hint`;
$b1ade62fb903e6c1$export$b54cf5587cb9457 = `rO9d9G_planNameTag`;
$b1ade62fb903e6c1$export$bfd64c937657f93a = `rO9d9G_rotating`;
$b1ade62fb903e6c1$export$4a6dd88bada4e7d2 = `rO9d9G_shimmer`;
$b1ade62fb903e6c1$export$2b067c6666111485 = `rO9d9G_tag`;


const $1f0e9fef3af80140$var$descriptionMap = {
    [(0, $iq1sR.TenantTag).Development]: "tenants.create_modal.development_description",
    [(0, $iq1sR.TenantTag).Production]: "tenants.create_modal.production_description"
};
const $1f0e9fef3af80140$var$availableProductionPlanNames = [
    (0, $0d03b1b348352731$export$e88bde3ace5c7bbf).Free,
    (0, $0d03b1b348352731$export$e88bde3ace5c7bbf).Pro
];
function $1f0e9fef3af80140$var$EnvTagOptionContent({ tag: tag }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $b1ade62fb903e6c1$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7e60916f61ffa7e7$export$2e2bcd8739ae039), {
                isAbbreviated: false,
                tag: tag,
                size: "large",
                className: $b1ade62fb903e6c1$export$2b067c6666111485
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $b1ade62fb903e6c1$export$6d59db4903f20f7d,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                    forKey: $1f0e9fef3af80140$var$descriptionMap[tag]
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $136a7fa3591fc649$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $b1ade62fb903e6c1$export$464c821cd4347539,
                children: [
                    tag === (0, $iq1sR.TenantTag).Development && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                        forKey: "tenants.create_modal.development_hint"
                    }),
                    tag === (0, $iq1sR.TenantTag).Production && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                forKey: "tenants.create_modal.available_plan"
                            }),
                            $1f0e9fef3af80140$var$availableProductionPlanNames.map((planName)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
                                    variant: "cell",
                                    size: "small",
                                    className: $b1ade62fb903e6c1$export$b54cf5587cb9457,
                                    children: planName
                                }, planName))
                        ]
                    })
                ]
            })
        ]
    });
}
var $1f0e9fef3af80140$export$2e2bcd8739ae039 = $1f0e9fef3af80140$var$EnvTagOptionContent;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $lXQZH = parcelRequire("lXQZH");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $kUZ14 = parcelRequire("kUZ14");


parcelRequire("8Mb3E");
var $cfL6o = parcelRequire("cfL6o");

var $8R7rc = parcelRequire("8R7rc");

var $5vVWy = parcelRequire("5vVWy");

var $9Q3SI = parcelRequire("9Q3SI");
parcelRequire("cuPVN");
var $lXQZH = parcelRequire("lXQZH");

var $b67J2 = parcelRequire("b67J2");

var $4VIdw = parcelRequire("4VIdw");

var $jC8Vy = parcelRequire("jC8Vy");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");



var $cDKfs = parcelRequire("cDKfs");


var $7kooT = parcelRequire("7kooT");

var $4ZcUR = parcelRequire("4ZcUR");
const $699da2d1bc75044e$var$useSubscribe = ()=>{
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const cloudApi = (0, $1c34cc51be8c93d3$export$7a5c900790855d66)({
        hideErrorToast: true
    });
    const { updateTenant: updateTenant } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { getUrl: getUrl } = (0, $4ZcUR.default)();
    const [isSubscribeLoading, setIsSubscribeLoading] = (0, $jC8Vy.useState)(false);
    const subscribe = async ({ planId: planId, callbackPage: callbackPage, tenantId: tenantId, tenantData: tenantData, isDowngrade: isDowngrade = false })=>{
        if (isSubscribeLoading) return;
        setIsSubscribeLoading(true);
        const state = (0, $4VIdw.nanoid)(6);
        const successSearchParam = new URLSearchParams({
            [(0, $217fd4972b445457$export$bc242540c43bf946)]: state
        });
        const successCallbackUrl = getUrl(`${(0, $7kooT.dropLeadingSlash)((0, $cDKfs.GlobalRoute).CheckoutSuccessCallback)}?${successSearchParam.toString()}`).href;
        try {
            const { redirectUri: redirectUri, sessionId: sessionId } = await cloudApi.post("/api/checkout-session", {
                body: {
                    planId: planId,
                    successCallbackUrl: successCallbackUrl,
                    tenantId: tenantId,
                    tenantName: tenantData?.name,
                    tenantTag: tenantData?.tag,
                    tenantRegionName: tenantData?.regionName
                }
            });
            if (!redirectUri) {
                (0, $FuhPC.toast).error(t("general.unknown_error"));
                return;
            }
            (0, $4b2a6b644eabe2ec$export$c162b38bc26bbdbf)({
                state: state,
                sessionId: sessionId,
                callbackPage: callbackPage,
                isDowngrade: isDowngrade
            });
            window.location.assign(redirectUri);
        } finally{
            setIsSubscribeLoading(false);
        }
    };
    const cancelSubscription = async (tenantId)=>{
        await cloudApi.delete("/api/tenants/:tenantId/subscription", {
            params: {
                tenantId: tenantId
            }
        });
        /**
     * Note: need to update the tenant's subscription cache data,
     * since the cancel subscription flow will not redirect to the stripe payment page.
     */ updateTenant(tenantId, {
            planId: (0, $lXQZH.ReservedPlanId).Free,
            subscription: {
                status: "active",
                planId: (0, $lXQZH.ReservedPlanId).Free,
                currentPeriodStart: (0, (/*@__PURE__*/$parcel$interopDefault($b67J2)))().toDate(),
                currentPeriodEnd: (0, (/*@__PURE__*/$parcel$interopDefault($b67J2)))().add(1, "month").toDate()
            }
        });
    };
    const visitManagePaymentPage = async (tenantId)=>{
        try {
            const { redirectUri: redirectUri } = await cloudApi.post("/api/tenants/:tenantId/stripe-customer-portal", {
                params: {
                    tenantId: tenantId
                },
                body: {
                    callbackUrl: window.location.href
                }
            });
            window.location.assign(redirectUri);
        } catch (error) {
            (0, $1c34cc51be8c93d3$export$10abc8714a7caf54)(error);
        }
    };
    return {
        isSubscribeLoading: isSubscribeLoading,
        subscribe: subscribe,
        cancelSubscription: cancelSubscription,
        visitManagePaymentPage: visitManagePaymentPage
    };
};
var $699da2d1bc75044e$export$2e2bcd8739ae039 = $699da2d1bc75044e$var$useSubscribe;




var $dW2kG = parcelRequire("dW2kG");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $lXQZH = parcelRequire("lXQZH");
var $6hxiJ = parcelRequire("6hxiJ");
var $clRgC = parcelRequire("clRgC");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $74869558e0a264ee$var$SvgArrowRight = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M12.95 9.408 8.233 4.7A.834.834 0 1 0 7.05 5.875l4.125 4.166-4.125 4.125a.833.833 0 0 0 .27 1.36.834.834 0 0 0 .913-.184l4.717-4.709a.835.835 0 0 0 0-1.225Z",
            fill: "currentColor"
        })
    });
var $74869558e0a264ee$export$2e2bcd8739ae039 = $74869558e0a264ee$var$SvgArrowRight;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $lXQZH = parcelRequire("lXQZH");

var $66ixW = parcelRequire("66ixW");
const $ee11b869fd4eeed7$var$registeredPlanDescriptionPhrasesMap = {
    [(0, $lXQZH.ReservedPlanId).Free]: "free_plan_description",
    [(0, $lXQZH.ReservedPlanId).Hobby]: "pro_plan_description",
    [(0, $lXQZH.ReservedPlanId).Pro]: "pro_plan_description"
};
function $ee11b869fd4eeed7$var$PlanDescription({ planId: planId }) {
    const description = $ee11b869fd4eeed7$var$registeredPlanDescriptionPhrasesMap[planId];
    if (!description) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
        forKey: `subscription.${description}`
    });
}
var $ee11b869fd4eeed7$export$2e2bcd8739ae039 = $ee11b869fd4eeed7$var$PlanDescription;



parcelRequire("8Mb3E");
var $cfL6o = parcelRequire("cfL6o");

var $cDKfs = parcelRequire("cDKfs");

var $jGWQ4 = parcelRequire("jGWQ4");

var $8R7rc = parcelRequire("8R7rc");

var $66ixW = parcelRequire("66ixW");

var $9Q3SI = parcelRequire("9Q3SI");

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");


var $64a73bfa1d7bd65f$export$7ab64d539530aa6c;
var $64a73bfa1d7bd65f$export$1ca1ec8b29a4ce27;
var $64a73bfa1d7bd65f$export$8837f4fc672e936d;
var $64a73bfa1d7bd65f$export$bfd64c937657f93a;
var $64a73bfa1d7bd65f$export$4a6dd88bada4e7d2;
var $64a73bfa1d7bd65f$export$fe7c49d056ea1d88;
$64a73bfa1d7bd65f$export$7ab64d539530aa6c = `uYfaZq_failed`;
$64a73bfa1d7bd65f$export$1ca1ec8b29a4ce27 = `uYfaZq_icon`;
$64a73bfa1d7bd65f$export$8837f4fc672e936d = `uYfaZq_list`;
$64a73bfa1d7bd65f$export$bfd64c937657f93a = `uYfaZq_rotating`;
$64a73bfa1d7bd65f$export$4a6dd88bada4e7d2 = `uYfaZq_shimmer`;
$64a73bfa1d7bd65f$export$fe7c49d056ea1d88 = `uYfaZq_success`;


parcelRequire("cuPVN");
var $lXQZH = parcelRequire("lXQZH");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

const $43fee24550d43f2d$var$useFeaturedPlanContent = (planId)=>{
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.upsell.featured_plan_content"
    });
    const contentData = (0, $jC8Vy.useMemo)(()=>{
        const isFreePlan = planId === (0, $lXQZH.ReservedPlanId).Free;
        const planPhraseKey = isFreePlan ? "free_plan" : "pro_plan";
        return [
            {
                title: t(`mau.${planPhraseKey}`, {
                    ...(0, $7oDSS.cond)(isFreePlan && {
                        count: (0, $217fd4972b445457$export$4478f817ef067d45)
                    })
                }),
                isAvailable: true
            },
            {
                title: t(`m2m.${planPhraseKey}`, {
                    ...(0, $7oDSS.cond)(isFreePlan && {
                        count: (0, $217fd4972b445457$export$273c590433c54f2b)
                    })
                }),
                isAvailable: true
            },
            {
                title: t("third_party_apps"),
                isAvailable: !isFreePlan
            },
            {
                title: t("mfa"),
                isAvailable: !isFreePlan
            },
            {
                title: t("sso"),
                isAvailable: !isFreePlan
            },
            {
                title: t(`role_and_permissions.${planPhraseKey}`, {
                    ...(0, $7oDSS.cond)(isFreePlan && {
                        roleCount: (0, $217fd4972b445457$export$a712ffd25223db9f),
                        permissionCount: (0, $217fd4972b445457$export$134386eb2e2226bd)
                    })
                }),
                isAvailable: true
            },
            {
                title: t("organizations"),
                isAvailable: !isFreePlan
            },
            {
                title: t("audit_logs", {
                    count: isFreePlan ? (0, $217fd4972b445457$export$b061d26c4cbe21f4) : (0, $217fd4972b445457$export$20398ca9e4426c2a)
                }),
                isAvailable: true
            }
        ];
    }, [
        t,
        planId
    ]);
    return contentData;
};
var $43fee24550d43f2d$export$2e2bcd8739ae039 = $43fee24550d43f2d$var$useFeaturedPlanContent;


function $7dc9a4101defb207$var$FeaturedPlanContent({ planId: planId }) {
    const contentData = (0, $43fee24550d43f2d$export$2e2bcd8739ae039)(planId);
    return /*#__PURE__*/ (0, $C7mD2.jsx)("ul", {
        className: $64a73bfa1d7bd65f$export$8837f4fc672e936d,
        children: contentData.map(({ title: title, isAvailable: isAvailable })=>{
            return /*#__PURE__*/ (0, $C7mD2.jsxs)("li", {
                children: [
                    isAvailable ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $863c8122c7186617$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($64a73bfa1d7bd65f$export$1ca1ec8b29a4ce27, $64a73bfa1d7bd65f$export$fe7c49d056ea1d88)
                    }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $10eea442689aa670$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($64a73bfa1d7bd65f$export$1ca1ec8b29a4ce27, $64a73bfa1d7bd65f$export$7ab64d539530aa6c)
                    }),
                    title
                ]
            }, title);
        })
    });
}
var $7dc9a4101defb207$export$2e2bcd8739ae039 = $7dc9a4101defb207$var$FeaturedPlanContent;


var $79eecf1586cd00bc$export$34e0f9847d4c02dd;
var $79eecf1586cd00bc$export$a7db06668cad9adb;
var $79eecf1586cd00bc$export$6d59db4903f20f7d;
var $79eecf1586cd00bc$export$3e36595b0b3ff9e8;
var $79eecf1586cd00bc$export$9c30223ca0a664fb;
var $79eecf1586cd00bc$export$ebcd2be1028c1c9c;
var $79eecf1586cd00bc$export$8837f4fc672e936d;
var $79eecf1586cd00bc$export$3034042b810d1d6d;
var $79eecf1586cd00bc$export$7507ac6a8989448c;
var $79eecf1586cd00bc$export$321c0b1a406de31f;
var $79eecf1586cd00bc$export$48b652c98657f00b;
var $79eecf1586cd00bc$export$a957e91ae9ff14e3;
var $79eecf1586cd00bc$export$bfd64c937657f93a;
var $79eecf1586cd00bc$export$4a6dd88bada4e7d2;
var $79eecf1586cd00bc$export$5e5b4df997cb5eaa;
var $79eecf1586cd00bc$export$fb184b623420d9be;
$79eecf1586cd00bc$export$34e0f9847d4c02dd = `t4YtMW_container`;
$79eecf1586cd00bc$export$a7db06668cad9adb = `t4YtMW_content`;
$79eecf1586cd00bc$export$6d59db4903f20f7d = `t4YtMW_description`;
$79eecf1586cd00bc$export$3e36595b0b3ff9e8 = `t4YtMW_exceedFreeTenantsTip`;
$79eecf1586cd00bc$export$9c30223ca0a664fb = `t4YtMW_link`;
$79eecf1586cd00bc$export$ebcd2be1028c1c9c = `t4YtMW_linkIcon`;
$79eecf1586cd00bc$export$8837f4fc672e936d = `t4YtMW_list`;
$79eecf1586cd00bc$export$3034042b810d1d6d = `t4YtMW_mostPopularTag`;
$79eecf1586cd00bc$export$7507ac6a8989448c = `t4YtMW_planInfo`;
$79eecf1586cd00bc$export$321c0b1a406de31f = `t4YtMW_price`;
$79eecf1586cd00bc$export$48b652c98657f00b = `t4YtMW_priceInfo`;
$79eecf1586cd00bc$export$a957e91ae9ff14e3 = `t4YtMW_priceLabel`;
$79eecf1586cd00bc$export$bfd64c937657f93a = `t4YtMW_rotating`;
$79eecf1586cd00bc$export$4a6dd88bada4e7d2 = `t4YtMW_shimmer`;
$79eecf1586cd00bc$export$5e5b4df997cb5eaa = `t4YtMW_tip`;
$79eecf1586cd00bc$export$fb184b623420d9be = `t4YtMW_title`;


function $66fbbb135a2bff7b$var$PlanCardItem({ plan: plan, onSelect: onSelect }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.upsell.create_tenant"
    });
    const { tenants: tenants } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { stripeProducts: stripeProducts, id: planId, name: planName } = plan;
    const basePrice = (0, $jC8Vy.useMemo)(()=>stripeProducts.find(({ type: type })=>type === "flat")?.price.unitAmountDecimal ?? 0, [
        stripeProducts
    ]);
    const isFreePlan = planId === (0, $lXQZH.ReservedPlanId).Free;
    const isFreeTenantExceeded = (0, $jC8Vy.useMemo)(()=>/** Should not block admin tenant owners from creating more than three tenants */ !tenants.some(({ id: id })=>id === (0, $6hxiJ.adminTenantId)) && tenants.filter(({ planId: planId })=>planId === (0, $lXQZH.ReservedPlanId).Free).length >= (0, $clRgC.maxFreeTenantLimit), [
        tenants
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $79eecf1586cd00bc$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $79eecf1586cd00bc$export$7507ac6a8989448c,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $79eecf1586cd00bc$export$fb184b623420d9be,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $161f1bf99d56f621$export$2e2bcd8739ae039), {
                            name: planName
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $79eecf1586cd00bc$export$48b652c98657f00b,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $79eecf1586cd00bc$export$a957e91ae9ff14e3,
                                children: t("base_price")
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                className: $79eecf1586cd00bc$export$321c0b1a406de31f,
                                children: [
                                    "$",
                                    t("monthly_price", {
                                        value: Number(basePrice) / 100
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $79eecf1586cd00bc$export$6d59db4903f20f7d,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ee11b869fd4eeed7$export$2e2bcd8739ae039), {
                            planId: planId
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $79eecf1586cd00bc$export$a7db06668cad9adb,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7dc9a4101defb207$export$2e2bcd8739ae039), {
                        planId: planId
                    }),
                    isFreePlan && isFreeTenantExceeded && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($79eecf1586cd00bc$export$5e5b4df997cb5eaa, $79eecf1586cd00bc$export$3e36595b0b3ff9e8),
                        children: t("free_tenants_limit", {
                            count: (0, $clRgC.maxFreeTenantLimit)
                        })
                    }),
                    !isFreePlan && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $79eecf1586cd00bc$export$5e5b4df997cb5eaa,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                            isTrailingIcon: true,
                            href: (0, $cfL6o.pricingLink),
                            targetBlank: "noopener",
                            icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $74869558e0a264ee$export$2e2bcd8739ae039), {
                                className: $79eecf1586cd00bc$export$ebcd2be1028c1c9c
                            }),
                            className: $79eecf1586cd00bc$export$9c30223ca0a664fb,
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                forKey: "upsell.create_tenant.view_all_features"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8R7rc.default), {
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                                components: {
                                    name: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $161f1bf99d56f621$export$2e2bcd8739ae039), {
                                        name: planName
                                    })
                                },
                                children: t("select_plan")
                            })
                        }),
                        disabled: isFreePlan && isFreeTenantExceeded,
                        type: isFreePlan ? "outline" : "primary",
                        size: "large",
                        onClick: onSelect
                    })
                ]
            }),
            planId === (0, $lXQZH.ReservedPlanId).Hobby && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $79eecf1586cd00bc$export$3034042b810d1d6d,
                children: t("most_popular")
            })
        ]
    });
}
var $66fbbb135a2bff7b$export$2e2bcd8739ae039 = $66fbbb135a2bff7b$var$PlanCardItem;


var $db5d69bc2216401f$export$34e0f9847d4c02dd;
var $db5d69bc2216401f$export$bfd64c937657f93a;
var $db5d69bc2216401f$export$4a6dd88bada4e7d2;
$db5d69bc2216401f$export$34e0f9847d4c02dd = `_93AYIq_container`;
$db5d69bc2216401f$export$bfd64c937657f93a = `_93AYIq_rotating`;
$db5d69bc2216401f$export$4a6dd88bada4e7d2 = `_93AYIq_shimmer`;


function $c4cd79499b403d19$var$SelectTenantPlanModal({ tenantData: tenantData, onClose: onClose }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: subscriptionPlans } = (0, $807aaa3ea0f45a20$export$2e2bcd8739ae039)();
    const { subscribe: subscribe } = (0, $699da2d1bc75044e$export$2e2bcd8739ae039)();
    const cloudApi = (0, $1c34cc51be8c93d3$export$7a5c900790855d66)({
        hideErrorToast: true
    });
    const reservedPlans = (0, $7oDSS.conditional)(subscriptionPlans && (0, $b38537f440ba3476$export$1673a249ab23858e)(subscriptionPlans));
    if (!reservedPlans || !tenantData) return null;
    const handleSelectPlan = async (plan)=>{
        const { id: planId } = plan;
        try {
            if (planId === (0, $lXQZH.ReservedPlanId).Free) {
                const { name: name, tag: tag, regionName: regionName } = tenantData;
                const newTenant = await cloudApi.post("/api/tenants", {
                    body: {
                        name: name,
                        tag: tag,
                        regionName: regionName
                    }
                });
                (0, $34139a4008fff4d0$export$f1adda6fc3c8905c)((0, $34139a4008fff4d0$export$a3b35db81871225).CreateProductionTenant, {
                    transactionId: newTenant.id
                });
                onClose(newTenant);
                return;
            }
            await subscribe({
                planId: planId,
                tenantData: tenantData
            });
        } catch (error) {
            (0, $1c34cc51be8c93d3$export$10abc8714a7caf54)(error);
        }
    };
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        shouldCloseOnEsc: true,
        isOpen: Boolean(tenantData),
        className: $dW2kG.content,
        overlayClassName: $dW2kG.overlay,
        onRequestClose: ()=>{
            onClose();
        },
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5vVWy.default), {
            title: "upsell.create_tenant.title",
            subtitle: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8R7rc.default), {
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                    components: {
                        a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                            href: (0, $cfL6o.pricingLink),
                            targetBlank: "noopener"
                        })
                    },
                    children: t("upsell.create_tenant.description")
                })
            }),
            size: "large",
            onClose: onClose,
            children: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $db5d69bc2216401f$export$34e0f9847d4c02dd,
                children: reservedPlans.map((plan)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $66fbbb135a2bff7b$export$2e2bcd8739ae039), {
                        plan: plan,
                        onSelect: ()=>{
                            handleSelectPlan(plan);
                        }
                    }, plan.id))
            })
        })
    });
}
var $c4cd79499b403d19$export$2e2bcd8739ae039 = $c4cd79499b403d19$var$SelectTenantPlanModal;


var $3e5766be5c425e29$export$6d59db4903f20f7d;
var $3e5766be5c425e29$export$f156efb5cf077f10;
var $3e5766be5c425e29$export$bfd64c937657f93a;
var $3e5766be5c425e29$export$4a6dd88bada4e7d2;
$3e5766be5c425e29$export$6d59db4903f20f7d = `_0EJwoa_description`;
$3e5766be5c425e29$export$f156efb5cf077f10 = `_0EJwoa_envTagRadioGroup`;
$3e5766be5c425e29$export$bfd64c937657f93a = `_0EJwoa_rotating`;
$3e5766be5c425e29$export$4a6dd88bada4e7d2 = `_0EJwoa_shimmer`;


const $6b53fcc6297da1c8$var$availableTags = [
    (0, $iq1sR.TenantTag).Development,
    (0, $iq1sR.TenantTag).Production
];
function $6b53fcc6297da1c8$var$CreateTenantModal({ isOpen: isOpen, onClose: onClose }) {
    const [tenantData, setTenantData] = (0, $jC8Vy.useState)();
    const theme = (0, $jheqv.default)();
    const defaultValues = {
        tag: (0, $iq1sR.TenantTag).Development,
        regionName: (0, $56db5.RegionName).EU
    };
    const methods = (0, $codQP.useForm)({
        defaultValues: defaultValues
    });
    const { reset: reset, control: control, handleSubmit: handleSubmit, formState: { errors: errors, isSubmitting: isSubmitting }, register: register } = methods;
    const cloudApi = (0, $1c34cc51be8c93d3$export$7a5c900790855d66)();
    const createTenant = async ({ name: name, tag: tag, regionName: regionName })=>{
        const newTenant = await cloudApi.post("/api/tenants", {
            body: {
                name: name,
                tag: tag,
                regionName: regionName
            }
        });
        onClose(newTenant);
    };
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const onCreateClick = handleSubmit(async (data)=>{
        const { tag: tag } = data;
        if (tag === (0, $iq1sR.TenantTag).Development) {
            await createTenant(data);
            (0, $FuhPC.toast).success(t("tenants.create_modal.tenant_created"));
            return;
        }
        setTenantData(data);
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        shouldCloseOnOverlayClick: true,
        shouldCloseOnEsc: true,
        isOpen: isOpen,
        className: $dW2kG.content,
        overlayClassName: $dW2kG.overlay,
        onAfterClose: ()=>{
            reset(defaultValues);
        },
        onRequestClose: ()=>{
            onClose();
        },
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $5vVWy.default), {
            title: "tenants.create_modal.title",
            subtitle: "tenants.create_modal.subtitle",
            headerIcon: theme === (0, $5HVJe.Theme).Light ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $be12ee274bf4d860$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $41ec666b40f91547$export$2e2bcd8739ae039), {}),
            footer: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                disabled: isSubmitting,
                htmlType: "submit",
                title: "tenants.create_modal.create_button",
                size: "large",
                type: "primary",
                onClick: onCreateClick
            }),
            size: "large",
            onClose: onClose,
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $codQP.FormProvider), {
                    ...methods,
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                            isRequired: true,
                            title: "tenants.settings.tenant_name",
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                // eslint-disable-next-line jsx-a11y/no-autofocus
                                autoFocus: true,
                                ...register("name", {
                                    required: true
                                }),
                                error: Boolean(errors.name)
                            })
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                            title: "tenants.settings.tenant_region",
                            tip: t("tenants.settings.tenant_region_description"),
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                                control: control,
                                name: "regionName",
                                rules: {
                                    required: true
                                },
                                render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $c8e461321115642d$export$2e2bcd8739ae039), {
                                        type: "small",
                                        name: name,
                                        value: value,
                                        onChange: onChange,
                                        children: [
                                            (0, $56db5.RegionName).EU,
                                            (0, $56db5.RegionName).US
                                        ].map((region)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $b4b7cf2a2e4180e8$export$2e2bcd8739ae039), {
                                                title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8R7rc.default), {
                                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $56db5.default), {
                                                        regionName: region,
                                                        isComingSoon: !(0, $8TpMk.isDevFeaturesEnabled) && region !== (0, $56db5.RegionName).EU
                                                    })
                                                }),
                                                value: region,
                                                isDisabled: !(0, $8TpMk.isDevFeaturesEnabled) && region !== (0, $56db5.RegionName).EU
                                            }, region))
                                    })
                            })
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                            title: "tenants.create_modal.tenant_usage_purpose",
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                                control: control,
                                name: "tag",
                                rules: {
                                    required: true
                                },
                                render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $c8e461321115642d$export$2e2bcd8739ae039), {
                                        type: "card",
                                        className: $3e5766be5c425e29$export$f156efb5cf077f10,
                                        value: value,
                                        name: name,
                                        onChange: onChange,
                                        children: $6b53fcc6297da1c8$var$availableTags.map((tag)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $b4b7cf2a2e4180e8$export$2e2bcd8739ae039), {
                                                value: tag,
                                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1f0e9fef3af80140$export$2e2bcd8739ae039), {
                                                    tag: tag
                                                })
                                            }, tag))
                                    })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c4cd79499b403d19$export$2e2bcd8739ae039), {
                    tenantData: tenantData,
                    onClose: (tenant)=>{
                        setTenantData(undefined);
                        if (tenant) {
                            /**
               * Note: only close the create tenant modal when tenant is created successfully
               */ onClose(tenant);
                            (0, $FuhPC.toast).success(t("tenants.create_modal.tenant_created"));
                        }
                    }
                })
            ]
        })
    });
}
var $6b53fcc6297da1c8$export$2e2bcd8739ae039 = $6b53fcc6297da1c8$var$CreateTenantModal;




var $cDKfs = parcelRequire("cDKfs");



var $aTllQ = parcelRequire("aTllQ");
parcelRequire("cuPVN");
var $6hxiJ = parcelRequire("6hxiJ");
parcelRequire("12bMu");
var $3dBAh = parcelRequire("3dBAh");

var $jC8Vy = parcelRequire("jC8Vy");

var $c3dK3 = parcelRequire("c3dK3");

var $8TpMk = parcelRequire("8TpMk");

var $cDKfs = parcelRequire("cDKfs");

const $9d98b4fb971c2442$var$key = "defaultTenantId";
/**
 * A hook that gets the default tenant ID for the current user from user's `customData`.
 *
 * - By default, the default tenant ID is empty, which means the first tenant is the default tenant.
 * - If the default tenant ID is not available to the user anymore, it semantically equals to the first tenant ID.
 */ const $9d98b4fb971c2442$var$useUserDefaultTenantId = ()=>{
    const { customData: customData, updateCustomData: updateCustomData } = (0, $8dc2d4d6918e57ba$export$2e2bcd8739ae039)();
    const { tenants: tenants } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    /** The current stored default tenant ID in the user's `customData`. */ const storedId = (0, $jC8Vy.useMemo)(()=>(0, $3dBAh.trySafe)(()=>(0, $c3dK3.z).object({
                [$9d98b4fb971c2442$var$key]: (0, $c3dK3.z).string()
            }).parse(customData)[$9d98b4fb971c2442$var$key]), [
        customData
    ]);
    const defaultTenantId = (0, $jC8Vy.useMemo)(()=>{
        // Directly return the default tenant ID for OSS because it's single tenant.
        if (!(0, $8TpMk.isCloud)) return 0, $6hxiJ.defaultTenantId;
        // Ensure the stored ID is still available to the user.
        if (storedId && tenants.some(({ id: id })=>id === storedId)) return storedId;
        // Fall back to the first tenant ID.
        return tenants[0]?.id;
    }, [
        storedId,
        tenants
    ]);
    const updateDefaultTenantId = (0, $jC8Vy.useCallback)(async (tenantId)=>{
        // No need for updating for OSS because it's single tenant.
        if (!(0, $8TpMk.isCloud)) return;
        await updateCustomData({
            [$9d98b4fb971c2442$var$key]: tenantId
        });
    }, [
        updateCustomData
    ]);
    return (0, $jC8Vy.useMemo)(()=>({
            defaultTenantId: defaultTenantId,
            updateDefaultTenantId: updateDefaultTenantId
        }), [
        defaultTenantId,
        updateDefaultTenantId
    ]);
};
var $9d98b4fb971c2442$export$2e2bcd8739ae039 = $9d98b4fb971c2442$var$useUserDefaultTenantId;



var $jC8Vy = parcelRequire("jC8Vy");

var $voszV = parcelRequire("voszV");

/**
 *
 * @param status Filter invitations by status
 * @returns The invitations with tenant info, error, and loading status.
 */ const $a0b535ac7bdefda9$var$useUserInvitations = (status)=>{
    const cloudApi = (0, $1c34cc51be8c93d3$export$7a5c900790855d66)({
        hideErrorToast: true
    });
    const { data: data, isLoading: isLoading, error: error } = (0, $voszV.default)(`/api/invitations}`, async ()=>cloudApi.get("/api/invitations"));
    // Filter invitations by given status
    const filteredResult = (0, $jC8Vy.useMemo)(()=>status ? data?.filter((invitation)=>status === invitation.status) : data, [
        data,
        status
    ]);
    return {
        data: filteredResult,
        error: error,
        isLoading: isLoading
    };
};
var $a0b535ac7bdefda9$export$2e2bcd8739ae039 = $a0b535ac7bdefda9$var$useUserInvitations;



var $bnkR4 = parcelRequire("bnkR4");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $iq1sR = parcelRequire("iq1sR");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $3co9T = parcelRequire("3co9T");



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $3dBAh = parcelRequire("3dBAh");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("8Mb3E");
var $ku6YN = parcelRequire("ku6YN");
const $19434c930f80c964$var$defaultSubscription = (0, $ku6YN.defaultTenantResponse).subscription;
const $19434c930f80c964$export$f8addfd4ab69c833 = /*#__PURE__*/ (0, $jC8Vy.createContext)({
    subscriptionPlans: [],
    currentPlan: (0, $ku6YN.defaultSubscriptionPlan),
    currentSubscription: $19434c930f80c964$var$defaultSubscription,
    onCurrentSubscriptionUpdated: (0, $3dBAh.noop)
});
function $19434c930f80c964$var$SubscriptionDataProvider({ children: children, subscriptionData: subscriptionData }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)($19434c930f80c964$export$f8addfd4ab69c833.Provider, {
        value: subscriptionData,
        children: children
    });
}
var $19434c930f80c964$export$2e2bcd8739ae039 = $19434c930f80c964$var$SubscriptionDataProvider;




var $66ixW = parcelRequire("66ixW");

var $C7mD2 = parcelRequire("C7mD2");

var $66ixW = parcelRequire("66ixW");

function $e7c86c286752d4da$var$TenantStatusTag({ tenantData: tenantData, tenantPlan: tenantPlan, className: className }) {
    const { usage: usage, openInvoices: openInvoices, isSuspended: isSuspended } = tenantData;
    /**
   * Tenant status priority:
   * 1. suspend
   * 2. overdue
   * 3. mau exceeded
   */ if (isSuspended) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
        className: className,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
            forKey: "user_details.suspended"
        })
    });
    if (openInvoices.length > 0) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
        className: className,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
            forKey: "tenants.status.overdue"
        })
    });
    const { activeUsers: activeUsers } = usage;
    const { quota: { mauLimit: mauLimit } } = tenantPlan;
    const isMauExceeded = mauLimit !== null && activeUsers >= mauLimit;
    if (isMauExceeded) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
        className: className,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
            forKey: "tenants.status.mau_exceeded"
        })
    });
    return null;
}
var $e7c86c286752d4da$export$2e2bcd8739ae039 = $e7c86c286752d4da$var$TenantStatusTag;


var $844e5d830392e4b9$export$1d8a03084661a191;
var $844e5d830392e4b9$export$a80b3bd66acc52ff;
var $844e5d830392e4b9$export$7061c75fc5af8b7e;
var $844e5d830392e4b9$export$6990040ee07315;
var $844e5d830392e4b9$export$a8ff84c12d48cfa6;
var $844e5d830392e4b9$export$9fc7da2585cefa14;
var $844e5d830392e4b9$export$bfd64c937657f93a;
var $844e5d830392e4b9$export$4a6dd88bada4e7d2;
var $844e5d830392e4b9$export$384817691e7c7e7d;
var $844e5d830392e4b9$export$664c6d24e3175067;
$844e5d830392e4b9$export$1d8a03084661a191 = `_8mkO2q_checkIcon`;
$844e5d830392e4b9$export$a80b3bd66acc52ff = `_8mkO2q_info`;
$844e5d830392e4b9$export$7061c75fc5af8b7e = `_8mkO2q_item`;
$844e5d830392e4b9$export$6990040ee07315 = `_8mkO2q_meta`;
$844e5d830392e4b9$export$a8ff84c12d48cfa6 = `_8mkO2q_name`;
$844e5d830392e4b9$export$9fc7da2585cefa14 = `_8mkO2q_planName`;
$844e5d830392e4b9$export$bfd64c937657f93a = `_8mkO2q_rotating`;
$844e5d830392e4b9$export$4a6dd88bada4e7d2 = `_8mkO2q_shimmer`;
$844e5d830392e4b9$export$384817691e7c7e7d = `_8mkO2q_statusTag`;
$844e5d830392e4b9$export$664c6d24e3175067 = `_8mkO2q_visible`;


function $78c722a20192fd1e$var$TenantDropdownItem({ tenantData: tenantData, isSelected: isSelected, onClick: onClick }) {
    const { name: name, tag: tag, subscription: { planId: planId } } = tenantData;
    const { subscriptionPlans: subscriptionPlans } = (0, $jC8Vy.useContext)((0, $19434c930f80c964$export$f8addfd4ab69c833));
    const tenantPlan = (0, $jC8Vy.useMemo)(()=>subscriptionPlans.find((plan)=>plan.id === planId), [
        subscriptionPlans,
        planId
    ]);
    if (!tenantPlan) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $6c006ec422465f6f$export$2e2bcd8739ae039), {
        className: $844e5d830392e4b9$export$7061c75fc5af8b7e,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $844e5d830392e4b9$export$a80b3bd66acc52ff,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $844e5d830392e4b9$export$6990040ee07315,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $844e5d830392e4b9$export$a8ff84c12d48cfa6,
                                children: name
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7e60916f61ffa7e7$export$2e2bcd8739ae039), {
                                tag: tag
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e7c86c286752d4da$export$2e2bcd8739ae039), {
                                tenantData: tenantData,
                                tenantPlan: tenantPlan,
                                className: $844e5d830392e4b9$export$384817691e7c7e7d
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $844e5d830392e4b9$export$9fc7da2585cefa14,
                        children: tag === (0, $iq1sR.TenantTag).Development ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: "subscription.no_subscription"
                        }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $161f1bf99d56f621$export$2e2bcd8739ae039), {
                            name: tenantPlan.name
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3co9T.default), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($844e5d830392e4b9$export$1d8a03084661a191, isSelected && $844e5d830392e4b9$export$664c6d24e3175067)
            })
        ]
    });
}
var $78c722a20192fd1e$export$2e2bcd8739ae039 = $78c722a20192fd1e$var$TenantDropdownItem;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
var $aZIrr = parcelRequire("aZIrr");

var $jC8Vy = parcelRequire("jC8Vy");



var $cDKfs = parcelRequire("cDKfs");

var $jGWQ4 = parcelRequire("jGWQ4");
var $4398d0d0b689df74$export$7061c75fc5af8b7e;
var $4398d0d0b689df74$export$6990040ee07315;
var $4398d0d0b689df74$export$a8ff84c12d48cfa6;
var $4398d0d0b689df74$export$bfd64c937657f93a;
var $4398d0d0b689df74$export$4a6dd88bada4e7d2;
$4398d0d0b689df74$export$7061c75fc5af8b7e = `K2fIUq_item`;
$4398d0d0b689df74$export$6990040ee07315 = `K2fIUq_meta`;
$4398d0d0b689df74$export$a8ff84c12d48cfa6 = `K2fIUq_name`;
$4398d0d0b689df74$export$bfd64c937657f93a = `K2fIUq_rotating`;
$4398d0d0b689df74$export$4a6dd88bada4e7d2 = `K2fIUq_shimmer`;


function $c3a83382e2b85997$var$TenantInvitationDropdownItem({ data: data }) {
    const cloudApi = (0, $1c34cc51be8c93d3$export$7a5c900790855d66)();
    const { navigateTenant: navigateTenant, resetTenants: resetTenants } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { id: id, organizationId: organizationId, tenantName: tenantName, tenantTag: tenantTag } = data;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $4398d0d0b689df74$export$7061c75fc5af8b7e,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $4398d0d0b689df74$export$6990040ee07315,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $4398d0d0b689df74$export$a8ff84c12d48cfa6,
                        children: tenantName
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7e60916f61ffa7e7$export$2e2bcd8739ae039), {
                        tag: tenantTag
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                size: "small",
                type: "outline",
                title: "general.join",
                onClick: async ()=>{
                    await cloudApi.patch(`/api/invitations/:invitationId/status`, {
                        params: {
                            invitationId: id
                        },
                        body: {
                            status: (0, $61Yml.OrganizationInvitationStatus).Accepted
                        }
                    });
                    const data = await cloudApi.get("/api/tenants");
                    resetTenants(data);
                    navigateTenant((0, $aZIrr.getTenantIdFromOrganizationId)(organizationId));
                }
            })
        ]
    });
}
var $c3a83382e2b85997$export$2e2bcd8739ae039 = $c3a83382e2b85997$var$TenantInvitationDropdownItem;


var $ff906b86d7059d8c$export$fb9188ad99e3f6b;
var $ff906b86d7059d8c$export$718bc6d3654bffd4;
var $ff906b86d7059d8c$export$c6a3c2629453bb7;
var $ff906b86d7059d8c$export$81207e5cc4186890;
var $ff906b86d7059d8c$export$a8ff84c12d48cfa6;
var $ff906b86d7059d8c$export$e8e05f094ca1017a;
var $ff906b86d7059d8c$export$bfd64c937657f93a;
var $ff906b86d7059d8c$export$4c3df62464552999;
var $ff906b86d7059d8c$export$4a6dd88bada4e7d2;
$ff906b86d7059d8c$export$fb9188ad99e3f6b = `_8z7V1W_arrowIcon`;
$ff906b86d7059d8c$export$718bc6d3654bffd4 = `_8z7V1W_createTenantButton`;
$ff906b86d7059d8c$export$c6a3c2629453bb7 = `_8z7V1W_currentTenantCard`;
$ff906b86d7059d8c$export$81207e5cc4186890 = `_8z7V1W_dropdown`;
$ff906b86d7059d8c$export$a8ff84c12d48cfa6 = `_8z7V1W_name`;
$ff906b86d7059d8c$export$e8e05f094ca1017a = `_8z7V1W_redDot`;
$ff906b86d7059d8c$export$bfd64c937657f93a = `_8z7V1W_rotating`;
$ff906b86d7059d8c$export$4c3df62464552999 = `_8z7V1W_scrollableContent`;
$ff906b86d7059d8c$export$4a6dd88bada4e7d2 = `_8z7V1W_shimmer`;


function $59037c420498c1bd$export$2e2bcd8739ae039() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { tenants: tenants, prependTenant: prependTenant, currentTenant: currentTenantInfo, currentTenantId: currentTenantId, navigateTenant: navigateTenant } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { data: pendingInvitations } = (0, $a0b535ac7bdefda9$export$2e2bcd8739ae039)((0, $61Yml.OrganizationInvitationStatus).Pending);
    const anchorRef = (0, $jC8Vy.useRef)(null);
    const [showDropdown, setShowDropdown] = (0, $jC8Vy.useState)(false);
    const [showCreateTenantModal, setShowCreateTenantModal] = (0, $jC8Vy.useState)(false);
    const { updateDefaultTenantId: updateDefaultTenantId } = (0, $9d98b4fb971c2442$export$2e2bcd8739ae039)();
    if (tenants.length === 0 || !currentTenantInfo) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                ref: anchorRef,
                tabIndex: 0,
                className: $ff906b86d7059d8c$export$c6a3c2629453bb7,
                role: "button",
                onKeyDown: (0, $bnkR4.onKeyDownHandler)(()=>{
                    setShowDropdown(true);
                }),
                onClick: ()=>{
                    setShowDropdown(true);
                },
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $ff906b86d7059d8c$export$a8ff84c12d48cfa6,
                        children: currentTenantInfo.name
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7e60916f61ffa7e7$export$2e2bcd8739ae039), {
                        tag: currentTenantInfo.tag
                    }),
                    Boolean(pendingInvitations?.length) && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $ff906b86d7059d8c$export$e8e05f094ca1017a
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9342374032a30fe2$export$2e2bcd8739ae039), {
                        className: $ff906b86d7059d8c$export$fb9188ad99e3f6b
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $f90dea65844a9f7a$export$2e2bcd8739ae039), {
                hasOverflowContent: true,
                className: $ff906b86d7059d8c$export$81207e5cc4186890,
                anchorRef: anchorRef,
                isOpen: showDropdown,
                horizontalAlign: "start",
                onClose: ()=>{
                    setShowDropdown(false);
                },
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aTllQ.default), {
                        className: $ff906b86d7059d8c$export$4c3df62464552999,
                        children: [
                            tenants.map((tenantData)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $78c722a20192fd1e$export$2e2bcd8739ae039), {
                                    tenantData: tenantData,
                                    isSelected: tenantData.id === currentTenantId,
                                    onClick: ()=>{
                                        navigateTenant(tenantData.id);
                                        updateDefaultTenantId(tenantData.id);
                                        setShowDropdown(false);
                                    }
                                }, tenantData.id)),
                            pendingInvitations?.map((invitation)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $c3a83382e2b85997$export$2e2bcd8739ae039), {
                                    data: invitation
                                }, invitation.id))
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $136a7fa3591fc649$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("button", {
                        tabIndex: 0,
                        className: $ff906b86d7059d8c$export$718bc6d3654bffd4,
                        onClick: ()=>{
                            setShowCreateTenantModal(true);
                        },
                        onKeyDown: (0, $bnkR4.onKeyDownHandler)(()=>{
                            setShowCreateTenantModal(true);
                        }),
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                children: t("cloud.tenant.create_tenant")
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0b30fe81c923292b$export$2e2bcd8739ae039), {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6b53fcc6297da1c8$export$2e2bcd8739ae039), {
                isOpen: showCreateTenantModal,
                onClose: async (tenant)=>{
                    setShowCreateTenantModal(false);
                    if (tenant) {
                        prependTenant(tenant);
                        navigateTenant(tenant.id);
                    }
                }
            })
        ]
    });
}



var $C7mD2 = parcelRequire("C7mD2");

parcelRequire("9zW7e");
var $jSb9j = parcelRequire("jSb9j");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $4bc930fbe25d753c$var$SvgExternalLink = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M12 7.213a.667.667 0 0 0-.667.667v4.787a.667.667 0 0 1-.666.666H3.333a.667.667 0 0 1-.666-.666V5.333a.667.667 0 0 1 .666-.666H8.12a.667.667 0 0 0 0-1.334H3.333a2 2 0 0 0-2 2v7.334a2 2 0 0 0 2 2h7.334a2 2 0 0 0 2-2V7.88A.666.666 0 0 0 12 7.213Zm2.613-5.466A.667.667 0 0 0 14 1.333h-4a.667.667 0 0 0 0 1.334h2.393l-6.866 6.86a.667.667 0 0 0 .217 1.092.668.668 0 0 0 .73-.146l6.86-6.866V6a.667.667 0 1 0 1.333 0V2a.667.667 0 0 0-.054-.253Z",
            fill: "currentColor"
        })
    });
var $4bc930fbe25d753c$export$2e2bcd8739ae039 = $4bc930fbe25d753c$var$SvgExternalLink;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $b79c7f173f535601$var$SvgGlobe = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M17.842 7.2V7.16a8.334 8.334 0 0 0-15.65 0V7.2a8.217 8.217 0 0 0 0 5.6v.042a8.333 8.333 0 0 0 15.65 0V12.8a8.217 8.217 0 0 0 0-5.6ZM3.55 11.667a6.517 6.517 0 0 1 0-3.333H5.1a13.941 13.941 0 0 0 0 3.333H3.55Zm.684 1.667H5.4c.196.743.475 1.462.834 2.141a6.667 6.667 0 0 1-2-2.141ZM5.4 6.667H4.234a6.667 6.667 0 0 1 1.975-2.142c-.35.681-.621 1.4-.809 2.142Zm3.767 9.75a5.283 5.283 0 0 1-2.025-3.083h2.025v3.083Zm0-4.75H6.784a11.967 11.967 0 0 1 0-3.333h2.383v3.333Zm0-5H7.142a5.283 5.283 0 0 1 2.025-3.083v3.083Zm6.6 0H14.6a10.128 10.128 0 0 0-.833-2.142 6.667 6.667 0 0 1 2 2.142Zm-4.933-3.083a5.284 5.284 0 0 1 2.025 3.083h-2.025V3.584Zm0 12.833v-3.083h2.025a5.284 5.284 0 0 1-2.025 3.083Zm2.383-4.75h-2.383V8.334h2.383a11.967 11.967 0 0 1 0 3.333Zm.575 3.808c.358-.68.638-1.398.833-2.141h1.167a6.668 6.668 0 0 1-2 2.141Zm2.658-3.808H14.9c.068-.553.101-1.11.1-1.667.001-.557-.032-1.113-.1-1.666h1.55a6.516 6.516 0 0 1 0 3.333Z",
            fill: "currentColor"
        })
    });
var $b79c7f173f535601$export$2e2bcd8739ae039 = $b79c7f173f535601$var$SvgGlobe;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $42a15c8fdac7bdf6$var$SvgPalette = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M6.183 12.95a.834.834 0 1 0 1.183 1.176.834.834 0 0 0-1.183-1.175Zm0-7.074A.833.833 0 1 0 7.365 7.05a.833.833 0 0 0-1.182-1.175Zm4.125 8.333a.834.834 0 1 0 .834.833.833.833 0 0 0-.834-.875v.042Zm-5-5a.833.833 0 1 0 .834.833.833.833 0 0 0-.834-.875v.042Zm5-5a.833.833 0 1 0 .834.833.833.833 0 0 0-.834-.875v.042Zm2.95 1.708a.833.833 0 1 0 1.175 0 .833.833 0 0 0-1.175-.041v.041Zm5.25 0a9.167 9.167 0 1 0-6.541 13.117 3.226 3.226 0 0 0 2.083-1.375 3.502 3.502 0 0 0 .508-2.658 4.699 4.699 0 0 1-.083-.834 4.166 4.166 0 0 1 2.5-3.8 3.201 3.201 0 0 0 1.717-1.875 3.333 3.333 0 0 0-.184-2.591v.016Zm-1.416 2.034a1.584 1.584 0 0 1-.834.908 5.834 5.834 0 0 0-3.45 5.308c.002.392.04.783.117 1.167a1.801 1.801 0 0 1-.258 1.375 1.49 1.49 0 0 1-1.009.667 7.5 7.5 0 0 1-8.85-7.608A7.542 7.542 0 0 1 9.875 2.5h.425a7.5 7.5 0 0 1 6.717 4.166c.19.396.218.851.075 1.267v.017Zm-6.784 1.216a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667Z",
            fill: "currentColor"
        })
    });
var $42a15c8fdac7bdf6$export$2e2bcd8739ae039 = $42a15c8fdac7bdf6$var$SvgPalette;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $408fed7e43ed59a0$var$SvgProfile = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M10 1.666a8.333 8.333 0 0 0-6.125 13.967 8.334 8.334 0 0 0 12.25 0A8.333 8.333 0 0 0 10 1.666Zm0 15a6.667 6.667 0 0 1-4.625-1.875 5 5 0 0 1 9.25 0A6.667 6.667 0 0 1 10 16.666ZM8.333 8.333a1.667 1.667 0 1 1 3.334 0 1.667 1.667 0 0 1-3.334 0Zm7.425 5a6.666 6.666 0 0 0-3.258-2.817 3.333 3.333 0 1 0-5 0 6.666 6.666 0 0 0-3.258 2.817 6.6 6.6 0 0 1-.909-3.334 6.667 6.667 0 1 1 13.334 0 6.6 6.6 0 0 1-.909 3.334Z",
            fill: "currentColor"
        })
    });
var $408fed7e43ed59a0$export$2e2bcd8739ae039 = $408fed7e43ed59a0$var$SvgProfile;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $59584278ba8fe846$var$SvgSignOut = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "m10.492 10.833-1.917 1.909a.833.833 0 0 0 0 1.183.833.833 0 0 0 1.183 0l3.334-3.333a.832.832 0 0 0 .175-.275.833.833 0 0 0 0-.634.832.832 0 0 0-.175-.275L9.758 6.075a.837.837 0 0 0-1.183 1.183l1.917 1.909H2.5a.833.833 0 0 0 0 1.666h7.992ZM10 1.667a8.333 8.333 0 0 0-7.5 4.625.839.839 0 0 0 1.5.75 6.667 6.667 0 1 1 6 9.625 6.608 6.608 0 0 1-5.967-3.709.838.838 0 1 0-1.5.75A8.334 8.334 0 1 0 10 1.667Z",
            fill: "currentColor"
        })
    });
var $59584278ba8fe846$export$2e2bcd8739ae039 = $59584278ba8fe846$var$SvgSignOut;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("ajkVG");
var $51A9u = parcelRequire("51A9u");
var $clvkc = parcelRequire("clvkc");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $5UrGx = parcelRequire("5UrGx");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $292262f340f012d8$var$SvgDefaultAvatar = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#F7F8F8",
                d: "M0 0h48v48H0z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#78767F",
                fillOpacity: 0.02,
                d: "M0 0h48v48H0z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#5D34F2",
                fillOpacity: 0.16,
                d: "M0 0h48v48H0z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M24.174 10a5.478 5.478 0 0 0-5.478 5.478v1.218a5.478 5.478 0 0 0 10.956 0v-1.218A5.478 5.478 0 0 0 24.174 10Zm0 28c12.174 0 12.174-3.957 12.174-3.957 0-5.133-2.548-9.918-9.13-10.043-.029 0-.219.184-.494.452-.723.704-2.036 1.98-2.55 1.98-.514 0-1.827-1.276-2.55-1.98-.276-.268-.466-.453-.494-.452-6.582.125-9.13 4.91-9.13 10.043 0 0 0 3.957 12.174 3.957Z",
                fill: "#947DFF"
            })
        ]
    });
var $292262f340f012d8$export$2e2bcd8739ae039 = $292262f340f012d8$var$SvgDefaultAvatar;



parcelRequire("fIF1D");
var $16GE9 = parcelRequire("16GE9");
var $39721e1625d6f475$exports = {};

$parcel$export($39721e1625d6f475$exports, "avatar", function () { return $39721e1625d6f475$export$345c5736c8054f22; }, function (v) { return $39721e1625d6f475$export$345c5736c8054f22 = v; });
$parcel$export($39721e1625d6f475$exports, "label", function () { return $39721e1625d6f475$export$1237798dc640739a; }, function (v) { return $39721e1625d6f475$export$1237798dc640739a = v; });
$parcel$export($39721e1625d6f475$exports, "large", function () { return $39721e1625d6f475$export$f09585a853dddd32; }, function (v) { return $39721e1625d6f475$export$f09585a853dddd32 = v; });
$parcel$export($39721e1625d6f475$exports, "medium", function () { return $39721e1625d6f475$export$649ecc744817b5c7; }, function (v) { return $39721e1625d6f475$export$649ecc744817b5c7 = v; });
$parcel$export($39721e1625d6f475$exports, "micro", function () { return $39721e1625d6f475$export$77bd0ce503b87b26; }, function (v) { return $39721e1625d6f475$export$77bd0ce503b87b26 = v; });
$parcel$export($39721e1625d6f475$exports, "rotating", function () { return $39721e1625d6f475$export$bfd64c937657f93a; }, function (v) { return $39721e1625d6f475$export$bfd64c937657f93a = v; });
$parcel$export($39721e1625d6f475$exports, "row", function () { return $39721e1625d6f475$export$120ff0929b202a6d; }, function (v) { return $39721e1625d6f475$export$120ff0929b202a6d = v; });
$parcel$export($39721e1625d6f475$exports, "shimmer", function () { return $39721e1625d6f475$export$4a6dd88bada4e7d2; }, function (v) { return $39721e1625d6f475$export$4a6dd88bada4e7d2 = v; });
$parcel$export($39721e1625d6f475$exports, "small", function () { return $39721e1625d6f475$export$3c17b0e969a90510; }, function (v) { return $39721e1625d6f475$export$3c17b0e969a90510 = v; });
$parcel$export($39721e1625d6f475$exports, "tooltip", function () { return $39721e1625d6f475$export$4e6f96734dfe12f4; }, function (v) { return $39721e1625d6f475$export$4e6f96734dfe12f4 = v; });
$parcel$export($39721e1625d6f475$exports, "value", function () { return $39721e1625d6f475$export$2ab9a8f9f1186f14; }, function (v) { return $39721e1625d6f475$export$2ab9a8f9f1186f14 = v; });
$parcel$export($39721e1625d6f475$exports, "wrapper", function () { return $39721e1625d6f475$export$cc74dcc53cfce4eb; }, function (v) { return $39721e1625d6f475$export$cc74dcc53cfce4eb = v; });
$parcel$export($39721e1625d6f475$exports, "xlarge", function () { return $39721e1625d6f475$export$bb57e550b957ab; }, function (v) { return $39721e1625d6f475$export$bb57e550b957ab = v; });
var $39721e1625d6f475$export$345c5736c8054f22;
var $39721e1625d6f475$export$1237798dc640739a;
var $39721e1625d6f475$export$f09585a853dddd32;
var $39721e1625d6f475$export$649ecc744817b5c7;
var $39721e1625d6f475$export$77bd0ce503b87b26;
var $39721e1625d6f475$export$bfd64c937657f93a;
var $39721e1625d6f475$export$120ff0929b202a6d;
var $39721e1625d6f475$export$4a6dd88bada4e7d2;
var $39721e1625d6f475$export$3c17b0e969a90510;
var $39721e1625d6f475$export$4e6f96734dfe12f4;
var $39721e1625d6f475$export$2ab9a8f9f1186f14;
var $39721e1625d6f475$export$cc74dcc53cfce4eb;
var $39721e1625d6f475$export$bb57e550b957ab;
$39721e1625d6f475$export$345c5736c8054f22 = `cX_Dda_avatar`;
$39721e1625d6f475$export$1237798dc640739a = `cX_Dda_label`;
$39721e1625d6f475$export$f09585a853dddd32 = `cX_Dda_large`;
$39721e1625d6f475$export$649ecc744817b5c7 = `cX_Dda_medium`;
$39721e1625d6f475$export$77bd0ce503b87b26 = `cX_Dda_micro`;
$39721e1625d6f475$export$bfd64c937657f93a = `cX_Dda_rotating`;
$39721e1625d6f475$export$120ff0929b202a6d = `cX_Dda_row`;
$39721e1625d6f475$export$4a6dd88bada4e7d2 = `cX_Dda_shimmer`;
$39721e1625d6f475$export$3c17b0e969a90510 = `cX_Dda_small`;
$39721e1625d6f475$export$4e6f96734dfe12f4 = `cX_Dda_tooltip`;
$39721e1625d6f475$export$2ab9a8f9f1186f14 = `cX_Dda_value`;
$39721e1625d6f475$export$cc74dcc53cfce4eb = `cX_Dda_wrapper`;
$39721e1625d6f475$export$bb57e550b957ab = `cX_Dda_xlarge`;


function $e999fd6c93542895$var$UserInfoTipContent({ user: user }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { name: name, primaryEmail: primaryEmail, primaryPhone: primaryPhone, username: username } = user;
    const itemsToDisplay = [
        {
            label: t("user_details.field_name"),
            value: name
        },
        {
            label: t("user_details.field_email"),
            value: primaryEmail
        },
        {
            label: t("user_details.field_phone"),
            value: (0, $7oDSS.conditional)(primaryPhone && (0, $51A9u.formatToInternationalPhoneNumber)(primaryPhone))
        },
        {
            label: t("user_details.field_username"),
            value: username
        }
    ];
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $C7mD2.Fragment), {
        children: itemsToDisplay.filter(({ value: value })=>Boolean(value)).map(({ label: label, value: value })=>/*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $39721e1625d6f475$exports.row,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("span", {
                        className: $39721e1625d6f475$exports.label,
                        children: [
                            label,
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                        className: $39721e1625d6f475$exports.value,
                        children: value
                    })
                ]
            }, label))
    });
}
function $e999fd6c93542895$var$UserAvatar({ className: className, size: size = "medium", user: user, hasTooltip: hasTooltip = false }) {
    const avatarClassName = (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($39721e1625d6f475$exports.avatar, $39721e1625d6f475$exports[size]);
    const wrapperClassName = (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($39721e1625d6f475$exports.wrapper, $39721e1625d6f475$exports[size], className);
    const defaultColorPalette = [
        "#E74C3C",
        "#865300",
        "#FF8B64",
        "#FFC651",
        "#4EA254",
        "#2FA0FD",
        "#02C2E4",
        "#41BEA6",
        "#7958FF",
        "#ED73A3",
        "#DF96FA",
        "#ADAAB4"
    ];
    const { name: name, username: username, avatar: avatar, primaryEmail: primaryEmail } = user ?? {};
    if (avatar) return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: wrapperClassName,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dbaecc0d7fe55772$export$2e2bcd8739ae039), {
            className: avatarClassName,
            src: avatar,
            alt: "avatar",
            /**
           * Some social connectors like Google will block the references to its image resource,
           * without specifying the referrerPolicy attribute. Reference:
           * https://stackoverflow.com/questions/40570117/http403-forbidden-error-when-trying-to-load-img-src-with-google-profile-pic
           */ referrerPolicy: "no-referrer",
            fallbackElement: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $292262f340f012d8$export$2e2bcd8739ae039), {})
        })
    });
    const nameToDisplay = (0, $clvkc.getUserDisplayName)({
        name: name,
        username: username,
        primaryEmail: primaryEmail
    })?.toLocaleUpperCase();
    const color = (0, $7oDSS.conditional)(nameToDisplay && defaultColorPalette[(nameToDisplay.codePointAt(0) ?? 0) % defaultColorPalette.length]);
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: wrapperClassName,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $16GE9.default), {
            className: $39721e1625d6f475$exports.tooltip,
            anchorClassName: $39721e1625d6f475$exports[size],
            content: (0, $7oDSS.conditional)(hasTooltip && user && /*#__PURE__*/ (0, $C7mD2.jsx)($e999fd6c93542895$var$UserInfoTipContent, {
                user: user
            })),
            children: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: avatarClassName,
                style: {
                    backgroundColor: color
                },
                children: nameToDisplay ? nameToDisplay.charAt(0) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $292262f340f012d8$export$2e2bcd8739ae039), {})
            })
        })
    });
}
var $e999fd6c93542895$export$2e2bcd8739ae039 = $e999fd6c93542895$var$UserAvatar;



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $c10afd37dc8c3ee1$export$d290fa47940df19d;
var $c10afd37dc8c3ee1$export$a8ff84c12d48cfa6;
var $c10afd37dc8c3ee1$export$d3ff39bcaba9d9ce;
var $c10afd37dc8c3ee1$export$bfd64c937657f93a;
var $c10afd37dc8c3ee1$export$4a6dd88bada4e7d2;
var $c10afd37dc8c3ee1$export$94e4009ecfbf7408;
$c10afd37dc8c3ee1$export$d290fa47940df19d = `_26bd8a_email`;
$c10afd37dc8c3ee1$export$a8ff84c12d48cfa6 = `_26bd8a_name`;
$c10afd37dc8c3ee1$export$d3ff39bcaba9d9ce = `_26bd8a_nameWrapper`;
$c10afd37dc8c3ee1$export$bfd64c937657f93a = `_26bd8a_rotating`;
$c10afd37dc8c3ee1$export$4a6dd88bada4e7d2 = `_26bd8a_shimmer`;
$c10afd37dc8c3ee1$export$94e4009ecfbf7408 = `_26bd8a_userInfo`;


function $e27711e91d86e1b2$var$UserInfoCard({ className: className, user: user, avatarSize: avatarSize = "medium" }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { name: name, username: username, avatar: avatar, picture: picture, primaryEmail: primaryEmail, email: email } = user ?? {};
    const avatarToDisplay = avatar ?? picture;
    const nameToDisplay = name ?? username;
    const emailToDisplay = primaryEmail ?? email;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($c10afd37dc8c3ee1$export$94e4009ecfbf7408, className),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e999fd6c93542895$export$2e2bcd8739ae039), {
                size: avatarSize,
                user: {
                    name: name,
                    username: username,
                    avatar: avatarToDisplay,
                    primaryEmail: emailToDisplay
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $c10afd37dc8c3ee1$export$d3ff39bcaba9d9ce,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $c10afd37dc8c3ee1$export$a8ff84c12d48cfa6,
                        children: nameToDisplay
                    }),
                    emailToDisplay && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $c10afd37dc8c3ee1$export$d290fa47940df19d,
                        children: emailToDisplay
                    }),
                    !nameToDisplay && !emailToDisplay && /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $c10afd37dc8c3ee1$export$d290fa47940df19d,
                        children: [
                            "(",
                            t("profile.link_account.anonymous"),
                            ")"
                        ]
                    })
                ]
            })
        ]
    });
}
var $e27711e91d86e1b2$export$2e2bcd8739ae039 = $e27711e91d86e1b2$var$UserInfoCard;



var $8TpMk = parcelRequire("8TpMk");



var $jbKqE = parcelRequire("jbKqE");

var $k9Oeh = parcelRequire("k9Oeh");


var $azCDQ = parcelRequire("azCDQ");

var $4ZcUR = parcelRequire("4ZcUR");


var $hrP0q = parcelRequire("hrP0q");

var $bnkR4 = parcelRequire("bnkR4");

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");


var $3co9T = parcelRequire("3co9T");


var $66ixW = parcelRequire("66ixW");

var $aTllQ = parcelRequire("aTllQ");

var $jbKqE = parcelRequire("jbKqE");

var $bnkR4 = parcelRequire("bnkR4");
var $912f7b45ad1884ad$export$34e0f9847d4c02dd;
var $912f7b45ad1884ad$export$1ca1ec8b29a4ce27;
var $912f7b45ad1884ad$export$b1e5508a851be14d;
var $912f7b45ad1884ad$export$f0d22739b64d27b3;
var $912f7b45ad1884ad$export$bfd64c937657f93a;
var $912f7b45ad1884ad$export$d90250155de6d7e7;
var $912f7b45ad1884ad$export$4a6dd88bada4e7d2;
var $912f7b45ad1884ad$export$55d7f61db91b7b70;
var $912f7b45ad1884ad$export$fb184b623420d9be;
var $912f7b45ad1884ad$export$664c6d24e3175067;
$912f7b45ad1884ad$export$34e0f9847d4c02dd = `o057rW_container`;
$912f7b45ad1884ad$export$1ca1ec8b29a4ce27 = `o057rW_icon`;
$912f7b45ad1884ad$export$b1e5508a851be14d = `o057rW_menu`;
$912f7b45ad1884ad$export$f0d22739b64d27b3 = `o057rW_menuOption`;
$912f7b45ad1884ad$export$bfd64c937657f93a = `o057rW_rotating`;
$912f7b45ad1884ad$export$d90250155de6d7e7 = `o057rW_selected`;
$912f7b45ad1884ad$export$4a6dd88bada4e7d2 = `o057rW_shimmer`;
$912f7b45ad1884ad$export$55d7f61db91b7b70 = `o057rW_tick`;
$912f7b45ad1884ad$export$fb184b623420d9be = `o057rW_title`;
$912f7b45ad1884ad$export$664c6d24e3175067 = `o057rW_visible`;


const $a7386a52efdf7d42$var$menuItemHeight = 40;
const $a7386a52efdf7d42$var$menuItemMargin = 4;
const $a7386a52efdf7d42$var$menuBorderSize = 1;
const $a7386a52efdf7d42$var$menuBottomMargin = 16;
function $a7386a52efdf7d42$var$SubMenu({ className: className, menuItemClassName: menuItemClassName, icon: icon, title: title, options: options, selectedOption: selectedOption, onItemClick: onItemClick }) {
    const anchorRef = (0, $jC8Vy.useRef)(null);
    const [showMenu, setShowMenu] = (0, $jC8Vy.useState)(false);
    const mouseEnterTimeoutRef = (0, $jC8Vy.useRef)(0);
    const mouseLeaveTimeoutRef = (0, $jC8Vy.useRef)(0);
    const [menuHeight, setMenuHeight] = (0, $jC8Vy.useState)();
    const calculateDropdownHeight = (0, $jC8Vy.useCallback)(()=>{
        if (anchorRef.current) {
            const anchorRect = anchorRef.current.getBoundingClientRect();
            const originalMenuHeight = options.length * $a7386a52efdf7d42$var$menuItemHeight + (options.length + 1) * $a7386a52efdf7d42$var$menuItemMargin + 2 * $a7386a52efdf7d42$var$menuBorderSize;
            const availableHeight = window.innerHeight - anchorRect.top - $a7386a52efdf7d42$var$menuBottomMargin;
            setMenuHeight(Math.min(originalMenuHeight, availableHeight));
        }
    }, [
        options.length
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        ref: anchorRef,
        role: "button",
        tabIndex: 0,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($912f7b45ad1884ad$export$34e0f9847d4c02dd, className),
        onKeyDown: (0, $bnkR4.onKeyDownHandler)(()=>{
            setShowMenu(true);
        }),
        onMouseEnter: ()=>{
            window.clearTimeout(mouseLeaveTimeoutRef.current);
            calculateDropdownHeight();
            // eslint-disable-next-line @silverhand/fp/no-mutation
            mouseEnterTimeoutRef.current = window.setTimeout(()=>{
                setShowMenu(true);
            }, 300);
        },
        onMouseLeave: ()=>{
            window.clearTimeout(mouseEnterTimeoutRef.current);
            // eslint-disable-next-line @silverhand/fp/no-mutation
            mouseLeaveTimeoutRef.current = window.setTimeout(()=>{
                setShowMenu(false);
            }, 100);
        },
        onClick: (event)=>{
            event.stopPropagation();
            setShowMenu(true);
        },
        children: [
            icon && /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                className: $912f7b45ad1884ad$export$1ca1ec8b29a4ce27,
                children: icon
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                className: $912f7b45ad1884ad$export$fb184b623420d9be,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                    forKey: title
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jbKqE.default), {}),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $74869558e0a264ee$export$2e2bcd8739ae039), {
                className: $912f7b45ad1884ad$export$1ca1ec8b29a4ce27
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aTllQ.default), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($912f7b45ad1884ad$export$b1e5508a851be14d, showMenu && $912f7b45ad1884ad$export$664c6d24e3175067),
                style: {
                    maxHeight: menuHeight
                },
                children: options.map(({ value: value, title: title })=>{
                    const selected = value === selectedOption;
                    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $6c006ec422465f6f$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($912f7b45ad1884ad$export$f0d22739b64d27b3, selected && $912f7b45ad1884ad$export$d90250155de6d7e7, menuItemClassName),
                        onClick: ()=>{
                            onItemClick(value);
                        },
                        children: [
                            selected && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3co9T.default), {
                                className: $912f7b45ad1884ad$export$55d7f61db91b7b70
                            }),
                            title
                        ]
                    }, value);
                })
            })
        ]
    });
}
var $a7386a52efdf7d42$export$2e2bcd8739ae039 = $a7386a52efdf7d42$var$SubMenu;



var $C7mD2 = parcelRequire("C7mD2");
var $45f7845d4f7684a4$export$34e0f9847d4c02dd;
var $45f7845d4f7684a4$export$5c452ff88e35e47d;
var $45f7845d4f7684a4$export$a8ff84c12d48cfa6;
var $45f7845d4f7684a4$export$bfd64c937657f93a;
var $45f7845d4f7684a4$export$4a6dd88bada4e7d2;
$45f7845d4f7684a4$export$34e0f9847d4c02dd = `d1KHsG_container`;
$45f7845d4f7684a4$export$5c452ff88e35e47d = `d1KHsG_image`;
$45f7845d4f7684a4$export$a8ff84c12d48cfa6 = `d1KHsG_name`;
$45f7845d4f7684a4$export$bfd64c937657f93a = `d1KHsG_rotating`;
$45f7845d4f7684a4$export$4a6dd88bada4e7d2 = `d1KHsG_shimmer`;
$45f7845d4f7684a4$export$4a6dd88bada4e7d2;


function $2e2d1228b7fb951d$var$UserInfoSkeleton() {
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: $45f7845d4f7684a4$export$34e0f9847d4c02dd,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
            className: $45f7845d4f7684a4$export$5c452ff88e35e47d
        })
    });
}
var $2e2d1228b7fb951d$export$2e2bcd8739ae039 = $2e2d1228b7fb951d$var$UserInfoSkeleton;


var $c336088c365a4109$export$89da14300d534261;
var $c336088c365a4109$export$34e0f9847d4c02dd;
var $c336088c365a4109$export$81207e5cc4186890;
var $c336088c365a4109$export$a8f2ac991e6b7a5;
var $c336088c365a4109$export$1ca1ec8b29a4ce27;
var $c336088c365a4109$export$46c1c92549715335;
var $c336088c365a4109$export$bfd64c937657f93a;
var $c336088c365a4109$export$4a6dd88bada4e7d2;
var $c336088c365a4109$export$641374ffb95bc399;
var $c336088c365a4109$export$94e4009ecfbf7408;
$c336088c365a4109$export$89da14300d534261 = `p7wx2G_active`;
$c336088c365a4109$export$34e0f9847d4c02dd = `p7wx2G_container`;
$c336088c365a4109$export$81207e5cc4186890 = `p7wx2G_dropdown`;
$c336088c365a4109$export$a8f2ac991e6b7a5 = `p7wx2G_dropdownItem`;
$c336088c365a4109$export$1ca1ec8b29a4ce27 = `p7wx2G_icon`;
$c336088c365a4109$export$46c1c92549715335 = `p7wx2G_loading`;
$c336088c365a4109$export$bfd64c937657f93a = `p7wx2G_rotating`;
$c336088c365a4109$export$4a6dd88bada4e7d2 = `p7wx2G_shimmer`;
$c336088c365a4109$export$641374ffb95bc399 = `p7wx2G_spinner`;
$c336088c365a4109$export$94e4009ecfbf7408 = `p7wx2G_userInfo`;


function $84305e43ec488aa0$var$UserInfo() {
    const { signOut: signOut } = (0, $jSb9j.useLogto)();
    const { getUrl: getUrl } = (0, $4ZcUR.default)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { user: user, isLoading: isLoadingUser } = (0, $8dc2d4d6918e57ba$export$2e2bcd8739ae039)();
    const anchorRef = (0, $jC8Vy.useRef)(null);
    const [showDropdown, setShowDropdown] = (0, $jC8Vy.useState)(false);
    const postSignOutRedirectUri = (0, $azCDQ.default)("signOut");
    const [isLoading, setIsLoading] = (0, $jC8Vy.useState)(false);
    const { data: { language: language, appearanceMode: appearanceMode }, update: update } = (0, $c83ac2f0f8302d6c$export$2e2bcd8739ae039)();
    if (isLoadingUser) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2e2d1228b7fb951d$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                ref: anchorRef,
                role: "button",
                tabIndex: 0,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($c336088c365a4109$export$34e0f9847d4c02dd, showDropdown && $c336088c365a4109$export$89da14300d534261),
                onKeyDown: (0, $bnkR4.onKeyDownHandler)(()=>{
                    setShowDropdown(true);
                }),
                onClick: ()=>{
                    setShowDropdown(true);
                },
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e999fd6c93542895$export$2e2bcd8739ae039), {
                    user: user
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $f90dea65844a9f7a$export$2e2bcd8739ae039), {
                hasOverflowContent: true,
                anchorRef: anchorRef,
                className: $c336088c365a4109$export$81207e5cc4186890,
                isOpen: showDropdown,
                horizontalAlign: "end",
                onClose: ()=>{
                    setShowDropdown(false);
                },
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e27711e91d86e1b2$export$2e2bcd8739ae039), {
                        className: $c336088c365a4109$export$94e4009ecfbf7408,
                        user: user,
                        avatarSize: "large"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $136a7fa3591fc649$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $6c006ec422465f6f$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($c336088c365a4109$export$a8f2ac991e6b7a5, isLoading && $c336088c365a4109$export$46c1c92549715335),
                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $408fed7e43ed59a0$export$2e2bcd8739ae039), {
                            className: $c336088c365a4109$export$1ca1ec8b29a4ce27
                        }),
                        onClick: ()=>{
                            // In OSS version, there will be a `/console` context path in the URL.
                            const profileRouteWithConsoleContext = getUrl("/profile");
                            // Open the profile page in a new tab. In Logto Cloud, the profile page is not nested in the tenant independent,
                            // whereas in OSS version, it is under the `/console` context path.
                            window.open((0, $8TpMk.isCloud) ? "/profile" : profileRouteWithConsoleContext, "_blank");
                        },
                        children: [
                            t("menu.profile"),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jbKqE.default), {}),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $c336088c365a4109$export$1ca1ec8b29a4ce27,
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4bc930fbe25d753c$export$2e2bcd8739ae039), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $136a7fa3591fc649$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a7386a52efdf7d42$export$2e2bcd8739ae039), {
                        className: $c336088c365a4109$export$a8f2ac991e6b7a5,
                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $b79c7f173f535601$export$2e2bcd8739ae039), {
                            className: $c336088c365a4109$export$1ca1ec8b29a4ce27
                        }),
                        title: "menu.language",
                        options: (0, $b350636e94694953$export$91d555a17bb93dc7),
                        selectedOption: language,
                        onItemClick: (language)=>{
                            update({
                                language: language
                            });
                            setShowDropdown(false);
                        }
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a7386a52efdf7d42$export$2e2bcd8739ae039), {
                        className: $c336088c365a4109$export$a8f2ac991e6b7a5,
                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $42a15c8fdac7bdf6$export$2e2bcd8739ae039), {
                            className: $c336088c365a4109$export$1ca1ec8b29a4ce27
                        }),
                        title: "menu.appearance.label",
                        options: [
                            {
                                value: (0, $hrP0q.DynamicAppearanceMode).System,
                                title: t("menu.appearance.system")
                            },
                            {
                                value: (0, $5HVJe.Theme).Light,
                                title: t("menu.appearance.light")
                            },
                            {
                                value: (0, $5HVJe.Theme).Dark,
                                title: t("menu.appearance.dark")
                            }
                        ],
                        selectedOption: appearanceMode,
                        onItemClick: (appearanceMode)=>{
                            update({
                                appearanceMode: appearanceMode
                            });
                            setShowDropdown(false);
                        }
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $136a7fa3591fc649$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $6c006ec422465f6f$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($c336088c365a4109$export$a8f2ac991e6b7a5, isLoading && $c336088c365a4109$export$46c1c92549715335),
                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $59584278ba8fe846$export$2e2bcd8739ae039), {
                            className: $c336088c365a4109$export$1ca1ec8b29a4ce27
                        }),
                        onClick: (event)=>{
                            event.stopPropagation();
                            if (isLoading) return;
                            setIsLoading(true);
                            signOut(postSignOutRedirectUri.href);
                        },
                        children: [
                            t("menu.sign_out"),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jbKqE.default), {}),
                            isLoading && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $k9Oeh.Ring), {
                                className: $c336088c365a4109$export$641374ffb95bc399
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $84305e43ec488aa0$export$2e2bcd8739ae039 = $84305e43ec488aa0$var$UserInfo;


var $ac224c67c94664e1$export$89da14300d534261;
var $ac224c67c94664e1$export$2ba01fb71ed41cb6;
var $ac224c67c94664e1$export$1ca1ec8b29a4ce27;
var $ac224c67c94664e1$export$53f1d5ea8de3d7c;
var $ac224c67c94664e1$export$db3c28d99448dcff;
var $ac224c67c94664e1$export$ee42ab8e1a775707;
var $ac224c67c94664e1$export$bfd64c937657f93a;
var $ac224c67c94664e1$export$4a6dd88bada4e7d2;
var $ac224c67c94664e1$export$6f093cfa640b7166;
var $ac224c67c94664e1$export$42c68d6252221cac;
$ac224c67c94664e1$export$89da14300d534261 = `OfVTMq_active`;
$ac224c67c94664e1$export$2ba01fb71ed41cb6 = `OfVTMq_button`;
$ac224c67c94664e1$export$1ca1ec8b29a4ce27 = `OfVTMq_icon`;
$ac224c67c94664e1$export$53f1d5ea8de3d7c = `OfVTMq_line`;
$ac224c67c94664e1$export$db3c28d99448dcff = `OfVTMq_logo`;
$ac224c67c94664e1$export$ee42ab8e1a775707 = `OfVTMq_newVersionDot`;
$ac224c67c94664e1$export$bfd64c937657f93a = `OfVTMq_rotating`;
$ac224c67c94664e1$export$4a6dd88bada4e7d2 = `OfVTMq_shimmer`;
$ac224c67c94664e1$export$6f093cfa640b7166 = `OfVTMq_text`;
$ac224c67c94664e1$export$42c68d6252221cac = `OfVTMq_topbar`;


var $6ad5e5dc37d12697$exports = {};
$6ad5e5dc37d12697$exports = JSON.parse('{"name":"@logto/core","version":"1.17.0","description":"The open source identity solution.","main":"build/index.js","author":"Silverhand Inc. <contact@silverhand.io>","license":"MPL-2.0","type":"module","private":true,"imports":{"#src/*":"./build/*"},"scripts":{"precommit":"lint-staged","copy:apidocs":"rsync -a -m --include \'*/\' --include \'*.openapi.json\' --exclude \'*\' src/routes/ build/routes/","build":"rm -rf build/ && tsc -p tsconfig.build.json && pnpm run copy:apidocs","build:test":"rm -rf build/ && tsc -p tsconfig.test.json --sourcemap && pnpm run copy:apidocs","lint":"eslint --ext .ts --ext .json src","lint:report":"pnpm lint --format json --output-file report.json","dev":"rm -rf build/ && nodemon","start":"NODE_ENV=production node .","test:only":"NODE_OPTIONS=\\"--experimental-vm-modules --max_old_space_size=4096\\" jest --logHeapUsage","test":"pnpm build:test && pnpm test:only","test:ci":"pnpm test:only --coverage --silent","test:report":"codecov -F core"},"dependencies":{"@authenio/samlify-node-xmllint":"^2.0.0","@aws-sdk/client-s3":"^3.556.0","@azure/storage-blob":"^12.17.0","@google-cloud/storage":"^7.10.0","@koa/cors":"^5.0.0","@logto/affiliate":"^0.1.0","@logto/app-insights":"workspace:^2.0.0","@logto/cli":"workspace:^1.17.0","@logto/connector-kit":"workspace:^3.0.0","@logto/console":"workspace:*","@logto/core-kit":"workspace:^2.5.0","@logto/demo-app":"workspace:*","@logto/experience":"workspace:*","@logto/language-kit":"workspace:^1.1.0","@logto/phrases":"workspace:^1.11.0","@logto/phrases-experience":"workspace:^1.6.1","@logto/schemas":"workspace:^1.17.0","@logto/shared":"workspace:^3.1.1","@silverhand/essentials":"^2.9.1","@silverhand/slonik":"31.0.0-beta.2","@simplewebauthn/server":"^10.0.0","@withtyped/client":"^0.8.7","camelcase":"^8.0.0","camelcase-keys":"^9.0.0","chalk":"^5.0.0","clean-deep":"^3.4.0","date-fns":"^2.29.3","decamelize":"^6.0.0","deepmerge":"^4.2.2","dotenv":"^16.0.0","etag":"^1.8.1","fast-xml-parser":"^4.3.6","find-up":"^7.0.0","got":"^14.0.0","hash-wasm":"^4.9.0","helmet":"^7.0.0","i18next":"^22.4.15","iconv-lite":"0.6.3","jose":"^5.0.0","koa":"^2.13.1","koa-body":"^6.0.1","koa-compose":"^4.1.0","koa-compress":"^5.1.0","koa-logger":"^3.2.1","koa-mount":"^4.0.0","koa-proxies":"^0.12.4","koa-router":"^12.0.0","koa-send":"^5.0.1","ky":"^1.2.3","lru-cache":"^10.0.0","nanoid":"^5.0.1","oidc-provider":"^8.4.6","openapi-types":"^12.1.3","otplib":"^12.0.1","p-map":"^7.0.2","p-retry":"^6.0.0","pg-protocol":"^1.6.0","pluralize":"^8.0.0","qrcode":"^1.5.3","redis":"^4.6.5","roarr":"^7.11.0","samlify":"2.8.11","semver":"^7.3.8","snake-case":"^4.0.0","snakecase-keys":"^8.0.0","zod":"^3.22.4"},"devDependencies":{"@logto/cloud":"0.2.5-38aae44","@silverhand/eslint-config":"6.0.1","@silverhand/ts-config":"6.0.0","@types/debug":"^4.1.7","@types/etag":"^1.8.1","@types/jest":"^29.4.0","@types/koa":"^2.13.3","@types/koa-compose":"^3.2.5","@types/koa-compress":"^4.0.3","@types/koa-logger":"^3.1.1","@types/koa-mount":"^4.0.0","@types/koa-send":"^4.1.3","@types/koa__cors":"^5.0.0","@types/node":"^20.9.5","@types/oidc-provider":"^8.4.4","@types/pluralize":"^0.0.33","@types/qrcode":"^1.5.2","@types/semver":"^7.3.12","@types/sinon":"^17.0.0","@types/supertest":"^6.0.2","eslint":"^8.56.0","jest":"^29.7.0","jest-matcher-specific-error":"^1.0.0","jsonc-eslint-parser":"^2.4.0","lint-staged":"^15.0.0","nock":"^14.0.0-beta.5","node-mocks-http":"^1.12.1","nodemon":"^3.0.0","prettier":"^3.0.0","sinon":"^18.0.0","supertest":"^7.0.0","typescript":"^5.3.3"},"engines":{"node":"^20.9.0"},"eslintConfig":{"extends":"@silverhand","rules":{"no-console":"error","import/no-unused-modules":["error",{"unusedExports":true}]},"overrides":[{"files":["*.d.ts"],"rules":{"import/no-unused-modules":"off"}},{"files":["*.openapi.json"],"rules":{"max-lines":"off"}},{"files":["src/include.d/oidc-provider/**/*"],"rules":{"unicorn/filename-case":"off"}},{"files":["*.json","*.json5","*.jsonc"],"parser":"jsonc-eslint-parser"}]},"prettier":"@silverhand/eslint-config/.prettierrc"}');


const $f07027f542a15566$export$5321c6fdac3e148e = (target)=>{
    const latestComponents = (target.startsWith("v") ? target.slice(1) : target).split(".");
    const currentComponents = (0, $6ad5e5dc37d12697$exports.version).split(".");
    for (const [index, component] of latestComponents.entries()){
        const current = currentComponents[index];
        if (!current || Number(current) < Number(component)) return true;
        if (Number(current) > Number(component)) return false;
    }
    return false;
};


function $8f0e3b0e6954789f$var$Topbar({ className: className, hideTenantSelector: hideTenantSelector, hideTitle: hideTitle }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const LogtoLogo = (0, $8TpMk.isCloud) ? (0, $27da1c1f41f71409$export$2e2bcd8739ae039) : (0, $19cfe35991ba791f$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($ac224c67c94664e1$export$42c68d6252221cac, className),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)(LogtoLogo, {
                className: $ac224c67c94664e1$export$db3c28d99448dcff
            }),
            (0, $8TpMk.isCloud) && !hideTenantSelector && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $59037c420498c1bd$export$2e2bcd8739ae039), {}),
            !(0, $8TpMk.isCloud) && !hideTitle && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $ac224c67c94664e1$export$53f1d5ea8de3d7c
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $ac224c67c94664e1$export$6f093cfa640b7166,
                        children: t("title")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jbKqE.default), {}),
            /*#__PURE__*/ (0, $C7mD2.jsx)($8f0e3b0e6954789f$var$DocumentButton, {}),
            /*#__PURE__*/ (0, $C7mD2.jsx)($8f0e3b0e6954789f$var$HelpButton, {}),
            !(0, $8TpMk.isCloud) && /*#__PURE__*/ (0, $C7mD2.jsx)($8f0e3b0e6954789f$var$VersionButton, {}),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $84305e43ec488aa0$export$2e2bcd8739ae039), {})
        ]
    });
}
var $8f0e3b0e6954789f$export$2e2bcd8739ae039 = $8f0e3b0e6954789f$var$Topbar;
function $8f0e3b0e6954789f$var$DocumentButton() {
    const { documentationSiteUrl: documentationSiteUrl } = (0, $b595fc2f0eccd19a$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
        href: documentationSiteUrl,
        targetBlank: "noopener",
        className: $ac224c67c94664e1$export$2ba01fb71ed41cb6,
        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $d77c39b23d569fd8$export$2e2bcd8739ae039), {
            className: $ac224c67c94664e1$export$1ca1ec8b29a4ce27
        }),
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
            forKey: "topbar.docs"
        })
    });
}
function $8f0e3b0e6954789f$var$HelpButton() {
    const [isContactOpen, setIsContactOpen] = (0, $jC8Vy.useState)(false);
    const anchorRef = (0, $jC8Vy.useRef)(null);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                ref: anchorRef,
                tabIndex: 0,
                className: $ac224c67c94664e1$export$2ba01fb71ed41cb6,
                role: "button",
                onKeyDown: (0, $bnkR4.onKeyDownHandler)(()=>{
                    setIsContactOpen(true);
                }),
                onClick: ()=>{
                    setIsContactOpen(true);
                },
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3f84a7e499ce2dd3$export$2e2bcd8739ae039), {
                        className: $ac224c67c94664e1$export$1ca1ec8b29a4ce27
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: "topbar.help"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fb6c208474f70908$export$2e2bcd8739ae039), {
                isOpen: isContactOpen,
                onCancel: ()=>{
                    setIsContactOpen(false);
                }
            })
        ]
    });
}
function $8f0e3b0e6954789f$var$VersionButton() {
    const [isNewVersionAvailable, setIsNewVersionAvailable] = (0, $jC8Vy.useState)(false);
    (0, $jC8Vy.useEffect)(()=>{
        (0, $3dBAh.trySafe)(async ()=>{
            const response = await fetch("https://numbers.logto.io/pull.json");
            const json = await response.json();
            if (!(0, $jMfTG.isKeyInObject)(json, "latestRelease") || typeof json.latestRelease !== "string" || !json.latestRelease.startsWith("v")) return;
            if ((0, $f07027f542a15566$export$5321c6fdac3e148e)(json.latestRelease)) setIsNewVersionAvailable(true);
        }, (error)=>{
            console.warn("Failed to check for new version", error);
        });
    }, []);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $9Q3SI.default), {
        href: (0, $cfL6o.githubReleasesLink),
        targetBlank: "noopener",
        className: $ac224c67c94664e1$export$2ba01fb71ed41cb6,
        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6eca204aeed0dcf3$export$2e2bcd8739ae039), {
            className: $ac224c67c94664e1$export$1ca1ec8b29a4ce27
        }),
        children: [
            "v",
            (0, $6ad5e5dc37d12697$exports.version),
            isNewVersionAvailable && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $ac224c67c94664e1$export$ee42ab8e1a775707
            })
        ]
    });
}


parcelRequire("8Mb3E");
var $ku6YN = parcelRequire("ku6YN");
var $7YcaX = parcelRequire("7YcaX");

var $8TpMk = parcelRequire("8TpMk");

var $jGWQ4 = parcelRequire("jGWQ4");

var $18SWy = parcelRequire("18SWy");

var $aTllQ = parcelRequire("aTllQ");

var $7VnwS = parcelRequire("7VnwS");

var $C7mD2 = parcelRequire("C7mD2");

var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $e23770ade3edbba9$var$SvgClearInput = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM8.464 9.879A1 1 0 1 1 9.88 8.464L12 10.586l2.121-2.122a1 1 0 1 1 1.415 1.415L13.414 12l2.122 2.121a1 1 0 1 1-1.415 1.415L12 13.414l-2.121 2.122a1 1 0 1 1-1.415-1.415L10.586 12 8.464 9.879Z",
            fill: "currentcolor"
        })
    });
var $e23770ade3edbba9$export$2e2bcd8739ae039 = $e23770ade3edbba9$var$SvgClearInput;


parcelRequire("8Mb3E");
var $ku6YN = parcelRequire("ku6YN");
var $7YcaX = parcelRequire("7YcaX");

var $jGWQ4 = parcelRequire("jGWQ4");

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("fIF1D");
var $16GE9 = parcelRequire("16GE9");

var $bnkR4 = parcelRequire("bnkR4");
var $a770dea13f3a5576$export$8ce1fd94bee2f412;
var $a770dea13f3a5576$export$1edee58a52776cd9;
var $a770dea13f3a5576$export$b07e517d22efa1ca;
var $a770dea13f3a5576$export$b96bb35bc88d6fa;
var $a770dea13f3a5576$export$683472f6198a076e;
var $a770dea13f3a5576$export$1ca1ec8b29a4ce27;
var $a770dea13f3a5576$export$1237798dc640739a;
var $a770dea13f3a5576$export$bfd64c937657f93a;
var $a770dea13f3a5576$export$4a6dd88bada4e7d2;
var $a770dea13f3a5576$export$e94f7fc6c53d997d;
var $a770dea13f3a5576$export$cc74dcc53cfce4eb;
$a770dea13f3a5576$export$8ce1fd94bee2f412 = `nsdVTW_background`;
$a770dea13f3a5576$export$1edee58a52776cd9 = `nsdVTW_border`;
$a770dea13f3a5576$export$b07e517d22efa1ca = `nsdVTW_checkbox`;
$a770dea13f3a5576$export$b96bb35bc88d6fa = `nsdVTW_checked`;
$a770dea13f3a5576$export$683472f6198a076e = `nsdVTW_disabled`;
$a770dea13f3a5576$export$1ca1ec8b29a4ce27 = `nsdVTW_icon`;
$a770dea13f3a5576$export$1237798dc640739a = `nsdVTW_label`;
$a770dea13f3a5576$export$bfd64c937657f93a = `nsdVTW_rotating`;
$a770dea13f3a5576$export$4a6dd88bada4e7d2 = `nsdVTW_shimmer`;
$a770dea13f3a5576$export$e94f7fc6c53d997d = `nsdVTW_tooltipAnchor`;
$a770dea13f3a5576$export$cc74dcc53cfce4eb = `nsdVTW_wrapper`;


function $26dc4ab718ba37b7$var$Checkbox({ checked: checked, disabled: disabled = false, indeterminate: indeterminate, onChange: onChange, label: label, className: className, tooltip: tooltip }) {
    const [isIndeterminate, setIsIndeterminate] = (0, $jC8Vy.useState)(indeterminate);
    (0, $jC8Vy.useLayoutEffect)(()=>{
        setIsIndeterminate(indeterminate);
    }, [
        indeterminate
    ]);
    const handleChange = ()=>{
        if (disabled) return;
        if (isIndeterminate) onChange(false);
        setIsIndeterminate(false);
        onChange(!checked);
    };
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($a770dea13f3a5576$export$b07e517d22efa1ca, disabled && $a770dea13f3a5576$export$683472f6198a076e, className),
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
            "aria-checked": checked,
            className: $a770dea13f3a5576$export$cc74dcc53cfce4eb,
            role: "checkbox",
            tabIndex: 0,
            onClick: handleChange,
            onKeyDown: (0, $bnkR4.onKeyDownHandler)(handleChange),
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $16GE9.default), {
                    horizontalAlign: "start",
                    content: tooltip,
                    anchorClassName: $a770dea13f3a5576$export$e94f7fc6c53d997d,
                    children: /*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($a770dea13f3a5576$export$1ca1ec8b29a4ce27, (checked || isIndeterminate) && $a770dea13f3a5576$export$b96bb35bc88d6fa, disabled && $a770dea13f3a5576$export$683472f6198a076e),
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                                className: $a770dea13f3a5576$export$8ce1fd94bee2f412,
                                x: "1.66663",
                                y: "1.6665",
                                width: "16.6667",
                                height: "16.6667",
                                rx: "4"
                            }),
                            checked && !isIndeterminate && /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M8.31476 13.858L5.13295 10.441C4.95568 10.253 4.95568 9.947 5.13295 9.757L5.77568 9.074C5.95295 8.886 6.24113 8.886 6.4184 9.074L8.63657 11.466L13.5811 6.141C13.7584 5.953 14.0465 5.953 14.2238 6.141L14.8665 6.825C15.0438 7.013 15.0438 7.32 14.8665 7.507L8.95748 13.858C8.78021 14.046 8.49203 14.046 8.31476 13.858Z",
                                fill: "white"
                            }),
                            isIndeterminate && /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                                d: "M5 9.37516C5 9.14504 5.1599 8.9585 5.35714 8.9585H14.6429C14.8401 8.9585 15 9.14504 15 9.37516V10.6252C15 10.8553 14.8401 11.0418 14.6429 11.0418H5.35714C5.1599 11.0418 5 10.8553 5 10.6252V9.37516Z",
                                fill: "white"
                            }),
                            !checked && !isIndeterminate && /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                                className: $a770dea13f3a5576$export$1edee58a52776cd9,
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M15.2469 3.20971H4.75305C3.90076 3.20971 3.20984 3.90063 3.20984 4.75293V15.2467C3.20984 16.099 3.90076 16.79 4.75305 16.79H15.2469C16.0992 16.79 16.7901 16.099 16.7901 15.2467V4.75292C16.7901 3.90063 16.0992 3.20971 15.2469 3.20971ZM4.75305 1.6665C3.04846 1.6665 1.66663 3.04834 1.66663 4.75293V15.2467C1.66663 16.9513 3.04847 18.3332 4.75305 18.3332H15.2469C16.9515 18.3332 18.3333 16.9513 18.3333 15.2467V4.75292C18.3333 3.04834 16.9515 1.6665 15.2469 1.6665H4.75305Z"
                            })
                        ]
                    })
                }),
                label && /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                    className: $a770dea13f3a5576$export$1237798dc640739a,
                    children: label
                })
            ]
        })
    });
}
var $26dc4ab718ba37b7$export$2e2bcd8739ae039 = $26dc4ab718ba37b7$var$Checkbox;



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $66ixW = parcelRequire("66ixW");

var $a438939cc6f9bd53$export$e5e25fbcc1f7affe;
var $a438939cc6f9bd53$export$bfd64c937657f93a;
var $a438939cc6f9bd53$export$4a6dd88bada4e7d2;
$a438939cc6f9bd53$export$e5e25fbcc1f7affe = `BNvetG_group`;
$a438939cc6f9bd53$export$bfd64c937657f93a = `BNvetG_rotating`;
$a438939cc6f9bd53$export$4a6dd88bada4e7d2 = `BNvetG_shimmer`;


function $4a37bd5fa29fd128$var$CheckboxGroup({ options: options, value: checkedValues, onChange: onChange, className: className }) {
    const toggleValue = (value)=>{
        onChange(checkedValues.includes(value) ? checkedValues.filter((selected)=>selected !== value) : [
            ...checkedValues,
            value
        ]);
    };
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($a438939cc6f9bd53$export$e5e25fbcc1f7affe, className),
        children: options.map(({ title: title, value: value, tag: tag })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $26dc4ab718ba37b7$export$2e2bcd8739ae039), {
                label: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                    children: [
                        title ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: title
                        }) : value,
                        tag
                    ]
                }),
                checked: checkedValues.includes(value),
                onChange: ()=>{
                    toggleValue(value);
                }
            }, value))
    });
}
var $4a37bd5fa29fd128$export$2e2bcd8739ae039 = $4a37bd5fa29fd128$var$CheckboxGroup;





var $75SRw = parcelRequire("75SRw");

var $fmHmG = parcelRequire("fmHmG");

var $7VnwS = parcelRequire("7VnwS");

var $kBpQ2 = parcelRequire("kBpQ2");

var $4ZcUR = parcelRequire("4ZcUR");

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $kUZ14 = parcelRequire("kUZ14");
parcelRequire("6bq3s");
var $2Phw0 = parcelRequire("2Phw0");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $582c9405f1750413$var$SvgArrowLeft = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            id: "Vector",
            d: "m8.46 11.29 5.66-5.65a.999.999 0 0 1 1.42 0 1 1 0 0 1 0 1.41l-4.95 5L15.54 17a1 1 0 0 1-.325 1.631.998.998 0 0 1-.385.079 1 1 0 0 1-.71-.3l-5.66-5.65a1 1 0 0 1 0-1.47Z",
            fill: "currentColor"
        })
    });
var $582c9405f1750413$export$2e2bcd8739ae039 = $582c9405f1750413$var$SvgArrowLeft;



var $66ixW = parcelRequire("66ixW");

var $9Q3SI = parcelRequire("9Q3SI");

var $dW2kG = parcelRequire("dW2kG");
var $e92336b9678c2f64$export$8d6d009d1f06226e;
var $e92336b9678c2f64$export$34e0f9847d4c02dd;
var $e92336b9678c2f64$export$bfd64c937657f93a;
var $e92336b9678c2f64$export$4a6dd88bada4e7d2;
var $e92336b9678c2f64$export$59ae2c325a998f89;
var $e92336b9678c2f64$export$c96745152eb2740f;
var $e92336b9678c2f64$export$fb184b623420d9be;
var $e92336b9678c2f64$export$cc74dcc53cfce4eb;
$e92336b9678c2f64$export$8d6d009d1f06226e = `PPT_uG_backButton`;
$e92336b9678c2f64$export$34e0f9847d4c02dd = `PPT_uG_container`;
$e92336b9678c2f64$export$bfd64c937657f93a = `PPT_uG_rotating`;
$e92336b9678c2f64$export$4a6dd88bada4e7d2 = `PPT_uG_shimmer`;
$e92336b9678c2f64$export$59ae2c325a998f89 = `PPT_uG_strong`;
$e92336b9678c2f64$export$c96745152eb2740f = `PPT_uG_subtitle`;
$e92336b9678c2f64$export$fb184b623420d9be = `PPT_uG_title`;
$e92336b9678c2f64$export$cc74dcc53cfce4eb = `PPT_uG_wrapper`;


function $c3cfb1552c8ab2c5$var$ExperienceLikeModal({ title: title, subtitle: subtitle, subtitleProps: subtitleProps, children: children, onClose: onClose, onGoBack: onGoBack }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const navigate = (0, $2Phw0.useNavigate)();
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        shouldCloseOnEsc: true,
        isOpen: true,
        className: $dW2kG.fullScreen,
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($dW2kG.content, $e92336b9678c2f64$export$34e0f9847d4c02dd),
            children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $e92336b9678c2f64$export$cc74dcc53cfce4eb,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                        className: $e92336b9678c2f64$export$8d6d009d1f06226e,
                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $582c9405f1750413$export$2e2bcd8739ae039), {}),
                        onClick: ()=>{
                            if (onGoBack) onGoBack();
                            else navigate(-1);
                        },
                        children: t("general.back")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                        className: $e92336b9678c2f64$export$fb184b623420d9be,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: title
                        })
                    }),
                    subtitle && /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                        className: $e92336b9678c2f64$export$c96745152eb2740f,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                            components: {
                                strong: /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                                    className: $e92336b9678c2f64$export$59ae2c325a998f89
                                })
                            },
                            children: t(subtitle, subtitleProps ?? {})
                        })
                    }),
                    children
                ]
            })
        })
    });
}
var $c3cfb1552c8ab2c5$export$2e2bcd8739ae039 = $c3cfb1552c8ab2c5$var$ExperienceLikeModal;



var $5cXXM = parcelRequire("5cXXM");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("4taJ0");
var $9vrm1 = parcelRequire("9vrm1");

var $c3dK3 = parcelRequire("c3dK3");
const $3bd1c984c0feefb4$export$7d5dc3ccf1648df4 = (0, $c3dK3.z).object({
    email: (0, $c3dK3.z).string().regex((0, $9vrm1.emailRegEx)),
    action: (0, $c3dK3.z).union([
        (0, $c3dK3.z).literal("changeEmail"),
        (0, $c3dK3.z).literal("changePassword")
    ])
});


const $bdd3cc0274f26dd3$export$23da1b6a36f0a363 = (state)=>{
    const parsed = (0, $3bd1c984c0feefb4$export$7d5dc3ccf1648df4).safeParse(state);
    return parsed.success ? parsed.data : {
        email: undefined,
        action: undefined
    };
};
const $bdd3cc0274f26dd3$export$20ff57c8784c652c = (url, windowName, width, height)=>{
    const outerHeight = window.top?.outerHeight ?? 0;
    const outerWidth = window.top?.outerWidth ?? 0;
    const screenX = window.top?.screenX ?? 0;
    const screenY = window.top?.screenY ?? 0;
    const yAxis = outerHeight / 2 + screenY - height / 2;
    const xAxis = outerWidth / 2 + screenX - width / 2;
    return window.open(url, windowName, [
        `toolbar=no`,
        `location=no`,
        `directories=no`,
        `status=no`,
        `menubar=no`,
        `scrollbars=no`,
        `resizable=no`,
        `copyhistory=no`,
        `width=${width}`,
        `height=${height}`,
        `top=${yAxis}`,
        `left=${xAxis}`
    ].join(","));
};
const $bdd3cc0274f26dd3$export$d3da1ecaf1206c58 = async (error, exec)=>{
    if (error instanceof (0, $5cXXM.HTTPError)) {
        const logtoError = await error.response.json();
        const { code: code, message: message } = logtoError;
        const handled = await exec?.(code, message, error.response.status);
        if (handled) return;
        if (error.response.status !== 401) {
            (0, $FuhPC.toast).error(message);
            return;
        }
    }
    throw error;
};


const $19506d07c8204ad1$var$defaultValues = {
    newPassword: "",
    confirmPassword: "",
    showPassword: false
};
function $19506d07c8204ad1$var$ChangePasswordModal() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const { show: showModal } = (0, $kBpQ2.useConfirmModal)();
    const { watch: watch, reset: reset, register: register, clearErrors: clearErrors, handleSubmit: handleSubmit, setValue: setValue, formState: { errors: errors, isSubmitting: isSubmitting } } = (0, $codQP.useForm)({
        reValidateMode: "onBlur",
        defaultValues: $19506d07c8204ad1$var$defaultValues
    });
    const [showPassword, setShowPassword] = (0, $jC8Vy.useState)(false);
    const api = (0, $7VnwS.useStaticApi)({
        prefixUrl: (0, $ku6YN.adminTenantEndpoint),
        resourceIndicator: (0, $7YcaX.meApi).indicator,
        hideErrorToast: true
    });
    const onClose = ()=>{
        reset();
        navigate("/profile");
    };
    const onSubmit = ()=>{
        clearErrors();
        handleSubmit(async ({ newPassword: newPassword })=>{
            try {
                await api.post(`me/password`, {
                    json: {
                        password: newPassword
                    }
                });
                (0, $FuhPC.toast).success(t("profile.password_changed"));
                onClose();
            } catch (error) {
                (0, $bdd3cc0274f26dd3$export$d3da1ecaf1206c58)(error, async (code, message)=>{
                    if (code === "session.verification_failed") {
                        await showModal({
                            ModalContent: message,
                            type: "alert",
                            cancelButtonText: "general.got_it"
                        });
                        onClose();
                        return true;
                    }
                });
            }
        })();
    };
    const onKeyDown = (event)=>{
        if (event.key === "Enter") onSubmit();
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $c3cfb1552c8ab2c5$export$2e2bcd8739ae039), {
        title: "profile.password.set_password",
        onClose: onClose,
        onGoBack: onClose,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                placeholder: t("profile.password.password"),
                ...register("newPassword", {
                    required: t("profile.password.required")
                }),
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus: true,
                type: showPassword ? "text" : "password",
                error: errors.newPassword?.message,
                suffix: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                    onMouseDown: (event)=>{
                        event.preventDefault();
                        setValue("newPassword", "");
                    },
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e23770ade3edbba9$export$2e2bcd8739ae039), {})
                }),
                onKeyDown: onKeyDown
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                placeholder: t("profile.password.confirm_password"),
                ...register("confirmPassword", {
                    validate: (value)=>value === watch("newPassword") || t("profile.password.do_not_match")
                }),
                type: showPassword ? "text" : "password",
                error: errors.confirmPassword?.message,
                suffix: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                    onMouseDown: (event)=>{
                        event.preventDefault();
                        setValue("confirmPassword", "");
                    },
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e23770ade3edbba9$export$2e2bcd8739ae039), {})
                }),
                onKeyDown: onKeyDown
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $26dc4ab718ba37b7$export$2e2bcd8739ae039), {
                checked: showPassword,
                label: t("profile.password.show_password"),
                onChange: ()=>{
                    setShowPassword((value)=>!value);
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                type: "primary",
                title: "general.create",
                size: "large",
                isLoading: isSubmitting,
                onClick: onSubmit
            })
        ]
    });
}
var $19506d07c8204ad1$export$2e2bcd8739ae039 = $19506d07c8204ad1$var$ChangePasswordModal;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("4taJ0");
var $9vrm1 = parcelRequire("9vrm1");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
parcelRequire("6bq3s");
var $2Phw0 = parcelRequire("2Phw0");
parcelRequire("8Mb3E");
var $ku6YN = parcelRequire("ku6YN");
var $7YcaX = parcelRequire("7YcaX");

var $jGWQ4 = parcelRequire("jGWQ4");

var $fmHmG = parcelRequire("fmHmG");

var $7VnwS = parcelRequire("7VnwS");

var $4ZcUR = parcelRequire("4ZcUR");

var $5OcFi = parcelRequire("5OcFi");


function $e83bb6bfe464a39e$var$LinkEmailModal() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const { state: state } = (0, $2Phw0.useLocation)();
    const { register: register, reset: reset, clearErrors: clearErrors, handleSubmit: handleSubmit, formState: { errors: errors, isSubmitting: isSubmitting } } = (0, $codQP.useForm)({
        reValidateMode: "onBlur"
    });
    const api = (0, $7VnwS.useStaticApi)({
        prefixUrl: (0, $ku6YN.adminTenantEndpoint),
        resourceIndicator: (0, $7YcaX.meApi).indicator
    });
    const onClose = ()=>{
        navigate("/profile");
    };
    const onSubmit = ()=>{
        clearErrors();
        handleSubmit((0, $5OcFi.trySubmitSafe)(async ({ email: email })=>{
            await api.post(`me/verification-codes`, {
                json: {
                    email: email
                }
            });
            reset();
            navigate("../verification-code", {
                state: {
                    email: email,
                    action: "changeEmail"
                }
            });
        }))();
    };
    const { email: currentEmail } = (0, $bdd3cc0274f26dd3$export$23da1b6a36f0a363)(state);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $c3cfb1552c8ab2c5$export$2e2bcd8739ae039), {
        title: "profile.link_account.link_email",
        subtitle: "profile.link_account.link_email_subtitle",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                ...register("email", {
                    required: t("profile.link_account.email_required"),
                    pattern: {
                        value: (0, $9vrm1.emailRegEx),
                        message: t("profile.link_account.invalid_email")
                    },
                    validate: (value)=>!currentEmail || currentEmail !== value || t("profile.link_account.identical_email_address")
                }),
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus: true,
                error: errors.email?.message,
                onKeyDown: (event)=>{
                    if (event.key === "Enter") onSubmit();
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                type: "primary",
                size: "large",
                title: "general.continue",
                isLoading: isSubmitting,
                onClick: onSubmit
            })
        ]
    });
}
var $e83bb6bfe464a39e$export$2e2bcd8739ae039 = $e83bb6bfe464a39e$var$LinkEmailModal;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
parcelRequire("6bq3s");
var $2Phw0 = parcelRequire("2Phw0");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $c9e6fc1c8770302e$var$SvgArrowConnection = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 18,
        height: 18,
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "m16.282 6.713-3-3a.752.752 0 1 0-1.065 1.065l1.725 1.718H5.25a.75.75 0 1 0 0 1.5h10.5a.75.75 0 0 0 .69-.465.75.75 0 0 0-.158-.818Zm-3.532 3.783H2.25a.75.75 0 0 0-.69.465.75.75 0 0 0 .157.817l3 3a.75.75 0 0 0 1.23-.244.75.75 0 0 0-.165-.82l-1.725-1.718h8.693a.75.75 0 1 0 0-1.5Z",
            fill: "currentColor"
        })
    });
var $c9e6fc1c8770302e$export$2e2bcd8739ae039 = $c9e6fc1c8770302e$var$SvgArrowConnection;



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");
var $482d29db1b7496ce$export$493b5823483d2c4e;
var $482d29db1b7496ce$export$b7e3ae3d7c15e42e;
var $482d29db1b7496ce$export$bfd64c937657f93a;
var $482d29db1b7496ce$export$4a6dd88bada4e7d2;
var $482d29db1b7496ce$export$cc74dcc53cfce4eb;
$482d29db1b7496ce$export$493b5823483d2c4e = `oZB0cq_errorMessage`;
$482d29db1b7496ce$export$b7e3ae3d7c15e42e = `oZB0cq_input`;
$482d29db1b7496ce$export$bfd64c937657f93a = `oZB0cq_rotating`;
$482d29db1b7496ce$export$4a6dd88bada4e7d2 = `oZB0cq_shimmer`;
$482d29db1b7496ce$export$cc74dcc53cfce4eb = `oZB0cq_wrapper`;


const $ccf521450ed1fc89$export$439d7c9fdf7148d2 = 6;
const $ccf521450ed1fc89$var$isNumeric = (char)=>/^\d+$/.test(char);
const $ccf521450ed1fc89$var$normalize = (value, length)=>{
    if (value.length > length) return value.slice(0, length);
    if (value.length < length) // Undefined will not overwrite the original input displays, need to pass in empty string instead
    return value.concat(Array.from({
        length: length - value.length
    }).fill(""));
    return value;
};
function $ccf521450ed1fc89$var$VerificationCodeInput({ name: name, className: className, value: value, length: length = $ccf521450ed1fc89$export$439d7c9fdf7148d2, error: error, onChange: onChange }) {
    /* eslint-disable @typescript-eslint/ban-types */ const inputReferences = (0, $jC8Vy.useRef)(Array.from({
        length: length
    }).fill(null));
    /* eslint-enable @typescript-eslint/ban-types */ const codes = (0, $jC8Vy.useMemo)(()=>$ccf521450ed1fc89$var$normalize(value, length), [
        length,
        value
    ]);
    const updateValue = (0, $jC8Vy.useCallback)((data, targetId)=>{
        // Filter non-numeric input
        if (!$ccf521450ed1fc89$var$isNumeric(data)) return;
        const chars = data.split("");
        const trimmedChars = chars.slice(0, Math.min(chars.length, codes.length - targetId));
        const value = [
            ...codes.slice(0, targetId),
            ...trimmedChars,
            ...codes.slice(targetId + trimmedChars.length, codes.length)
        ];
        onChange(value);
        // Move to the next target
        const nextTarget = inputReferences.current[Math.min(targetId + trimmedChars.length, codes.length - 1)];
        nextTarget?.focus();
    }, [
        codes,
        onChange
    ]);
    const onInputHandler = (0, $jC8Vy.useCallback)((event)=>{
        const { target: target } = event;
        if (!(target instanceof HTMLInputElement)) return;
        const { value: value, dataset: dataset } = target;
        // Unrecognized target input field
        if (!dataset.id) return;
        event.preventDefault();
        updateValue(value, Number(dataset.id));
    }, [
        updateValue
    ]);
    const onPasteHandler = (0, $jC8Vy.useCallback)((event)=>{
        if (!(event.target instanceof HTMLInputElement)) return;
        const { target: { dataset: dataset }, clipboardData: clipboardData } = event;
        const data = clipboardData.getData("text").match(/\d/g)?.join("") ?? "";
        // Unrecognized target input field
        if (!dataset.id) return;
        event.preventDefault();
        updateValue(data, Number(dataset.id));
    }, [
        updateValue
    ]);
    const onKeyDownHandler = (0, $jC8Vy.useCallback)((event)=>{
        const { key: key, target: target } = event;
        if (!(target instanceof HTMLInputElement)) return;
        const { value: value, dataset: dataset } = target;
        if (!dataset.id) return;
        const targetId = Number(dataset.id);
        const nextTarget = inputReferences.current[targetId + 1];
        const previousTarget = inputReferences.current[targetId - 1];
        switch(key){
            case "Backspace":
                event.preventDefault();
                if (value) {
                    onChange(Object.assign([], codes, {
                        [targetId]: ""
                    }));
                    break;
                }
                if (previousTarget) {
                    previousTarget.focus();
                    onChange(Object.assign([], codes, {
                        [targetId - 1]: ""
                    }));
                }
                break;
            case "ArrowLeft":
                event.preventDefault();
                previousTarget?.focus();
                break;
            case "ArrowRight":
                event.preventDefault();
                nextTarget?.focus();
                break;
            case "+":
            case "-":
            case "e":
            case ".":
            case "ArrowUp":
            case "ArrowDown":
                event.preventDefault();
                break;
            default:
                break;
        }
    }, [
        codes,
        onChange
    ]);
    (0, $jC8Vy.useEffect)(()=>{
        if (value.length === 0) inputReferences.current[0]?.focus();
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $482d29db1b7496ce$export$cc74dcc53cfce4eb,
                children: Array.from({
                    length: length
                }).map((_, index)=>/*#__PURE__*/ (0, $C7mD2.jsx)("input", {
                        ref: (element)=>{
                            // eslint-disable-next-line @silverhand/fp/no-mutation
                            inputReferences.current[index] = element;
                        },
                        className: $482d29db1b7496ce$export$b7e3ae3d7c15e42e,
                        name: `${name}_${index}`,
                        "data-id": index,
                        value: codes[index],
                        type: "number",
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        autoComplete: "off",
                        onPaste: onPasteHandler,
                        onInput: onInputHandler,
                        onKeyDown: onKeyDownHandler
                    }, `${name}_${index}`))
            }),
            error && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $482d29db1b7496ce$export$493b5823483d2c4e,
                children: error
            })
        ]
    });
}
var $ccf521450ed1fc89$export$2e2bcd8739ae039 = $ccf521450ed1fc89$var$VerificationCodeInput;


parcelRequire("8Mb3E");
var $ku6YN = parcelRequire("ku6YN");
var $7YcaX = parcelRequire("7YcaX");

var $9Q3SI = parcelRequire("9Q3SI");

var $7VnwS = parcelRequire("7VnwS");

var $kBpQ2 = parcelRequire("kBpQ2");


var $4ZcUR = parcelRequire("4ZcUR");


var $1a6364a6093cd138$export$9c30223ca0a664fb;
var $1a6364a6093cd138$export$a8ecead220dd38a6;
$1a6364a6093cd138$export$9c30223ca0a664fb = `KTc0zW_link`;
$1a6364a6093cd138$export$a8ecead220dd38a6 = `KTc0zW_message`;


const $69d6de69d3cd6f87$var$resendTimeout = 59;
const $69d6de69d3cd6f87$var$getTimeout = ()=>{
    const now = new Date();
    now.setSeconds(now.getSeconds() + $69d6de69d3cd6f87$var$resendTimeout);
    return now;
};
function $69d6de69d3cd6f87$var$VerificationCodeModal() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const { show: showModal } = (0, $kBpQ2.useConfirmModal)();
    const { state: state } = (0, $2Phw0.useLocation)();
    const { reload: reload } = (0, $8dc2d4d6918e57ba$export$2e2bcd8739ae039)();
    const [code, setCode] = (0, $jC8Vy.useState)([]);
    const [error, setError] = (0, $jC8Vy.useState)();
    const api = (0, $7VnwS.useStaticApi)({
        prefixUrl: (0, $ku6YN.adminTenantEndpoint),
        resourceIndicator: (0, $7YcaX.meApi).indicator,
        hideErrorToast: true
    });
    const { email: email, action: action } = (0, $bdd3cc0274f26dd3$export$23da1b6a36f0a363)(state);
    const { seconds: seconds, isRunning: isRunning, restart: restart } = (0, $7eec5a427a242e1d$exports.useTimer)({
        autoStart: true,
        expiryTimestamp: $69d6de69d3cd6f87$var$getTimeout()
    });
    const onClose = (0, $jC8Vy.useCallback)(()=>{
        navigate("/profile");
        reload();
    }, [
        navigate,
        reload
    ]);
    const onSubmit = (0, $jC8Vy.useCallback)(async ()=>{
        const verificationCode = code.join("");
        if (!email || !verificationCode) return;
        try {
            await api.post(`me/verification-codes/verify`, {
                json: {
                    verificationCode: verificationCode,
                    email: email,
                    action: action
                }
            });
            if (action === "changeEmail") {
                await api.patch("me", {
                    json: {
                        primaryEmail: email
                    }
                });
                (0, $FuhPC.toast).success(t("profile.email_changed"));
                onClose();
            }
            if (action === "changePassword") navigate("../change-password", {
                state: state
            });
        } catch (error) {
            (0, $bdd3cc0274f26dd3$export$d3da1ecaf1206c58)(error, async (code, message)=>{
                // The following errors will be displayed as inline error message.
                if ([
                    "verification_code.code_mismatch",
                    "verification_code.exceed_max_try",
                    "verification_code.not_found"
                ].includes(code)) {
                    setError(message);
                    return true;
                }
                // Other verification code errors will be displayed in a popup modal.
                if (code.startsWith("verification_code.") || code === "user.email_already_in_use") {
                    await showModal({
                        ModalContent: message,
                        type: "alert",
                        cancelButtonText: "general.got_it"
                    });
                    onClose();
                    return true;
                }
            });
        }
    }, [
        code,
        email,
        api,
        action,
        t,
        onClose,
        navigate,
        state,
        showModal
    ]);
    (0, $jC8Vy.useEffect)(()=>{
        if (code.length === (0, $ccf521450ed1fc89$export$439d7c9fdf7148d2) && code.every(Boolean)) onSubmit();
    }, [
        code,
        onSubmit
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $c3cfb1552c8ab2c5$export$2e2bcd8739ae039), {
        title: "profile.code.enter_verification_code",
        subtitle: "profile.code.enter_verification_code_subtitle",
        subtitleProps: (0, $7oDSS.conditional)(email && {
            target: email
        }),
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ccf521450ed1fc89$export$2e2bcd8739ae039), {
                name: "verificationCode",
                value: code,
                error: error,
                onChange: (value)=>{
                    setCode(value);
                    setError(undefined);
                }
            }),
            isRunning ? /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $1a6364a6093cd138$export$a8ecead220dd38a6,
                children: t("profile.code.resend_countdown", {
                    countdown: seconds
                })
            }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                className: $1a6364a6093cd138$export$9c30223ca0a664fb,
                onClick: async ()=>{
                    setCode([]);
                    setError(undefined);
                    await api.post(`me/verification-codes`, {
                        json: {
                            email: email
                        }
                    });
                    restart($69d6de69d3cd6f87$var$getTimeout(), true);
                },
                children: t("profile.code.resend")
            }),
            action === "changePassword" && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                className: $1a6364a6093cd138$export$9c30223ca0a664fb,
                icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c9e6fc1c8770302e$export$2e2bcd8739ae039), {}),
                onClick: ()=>{
                    navigate("../verify-password", {
                        state: state
                    });
                },
                children: t("profile.password.verify_via_password")
            })
        ]
    });
}
var $69d6de69d3cd6f87$export$2e2bcd8739ae039 = $69d6de69d3cd6f87$var$VerificationCodeModal;



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
parcelRequire("6bq3s");
var $2Phw0 = parcelRequire("2Phw0");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $1799fb0a7a4a7c85$var$SvgPasswordHide = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.929 3.929a1 1 0 0 0 0 1.414L6.505 6.92C3.791 8.797 2 11.452 2 12c0 .866 4.477 7 10 7 1.82 0 3.526-.666 4.996-1.59l.66.661a1 1 0 0 0 1.415-1.414L6.343 3.929a1 1 0 0 0-1.414 0Zm9.685 11.099L8.972 9.386a4 4 0 0 0 5.642 5.642Zm-1.057-6.714a4.014 4.014 0 0 1 2.129 2.13l4.39 4.389C21.285 13.533 22 12.346 22 12c0-.866-4.477-7-10-7-.542 0-1.073.059-1.591.166l3.148 3.148Z",
            fill: "currentcolor"
        })
    });
var $1799fb0a7a4a7c85$export$2e2bcd8739ae039 = $1799fb0a7a4a7c85$var$SvgPasswordHide;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $a3da18ce43178c5e$var$SvgPasswordShow = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M22 12c0 .866-4.477 7-10 7S2 12.866 2 12c0-.866 4.477-7 10-7s10 6.134 10 7Zm-6 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-5 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
            fill: "currentcolor"
        })
    });
var $a3da18ce43178c5e$export$2e2bcd8739ae039 = $a3da18ce43178c5e$var$SvgPasswordShow;


parcelRequire("8Mb3E");
var $ku6YN = parcelRequire("ku6YN");
var $7YcaX = parcelRequire("7YcaX");

var $jGWQ4 = parcelRequire("jGWQ4");

var $75SRw = parcelRequire("75SRw");

var $fmHmG = parcelRequire("fmHmG");

var $9Q3SI = parcelRequire("9Q3SI");

var $7VnwS = parcelRequire("7VnwS");

var $4ZcUR = parcelRequire("4ZcUR");


var $4b7ef1480204b5ac$export$9c30223ca0a664fb;
$4b7ef1480204b5ac$export$9c30223ca0a664fb = `bsdY_q_link`;


function $7d1af221703bec48$var$VerifyPasswordModal() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const { state: state } = (0, $2Phw0.useLocation)();
    const { register: register, reset: reset, clearErrors: clearErrors, setError: setError, handleSubmit: handleSubmit, formState: { errors: errors, isSubmitting: isSubmitting } } = (0, $codQP.useForm)({
        reValidateMode: "onBlur"
    });
    const api = (0, $7VnwS.useStaticApi)({
        prefixUrl: (0, $ku6YN.adminTenantEndpoint),
        resourceIndicator: (0, $7YcaX.meApi).indicator,
        hideErrorToast: true
    });
    const [showPassword, setShowPassword] = (0, $jC8Vy.useState)(false);
    const { email: email } = (0, $bdd3cc0274f26dd3$export$23da1b6a36f0a363)(state);
    const onClose = ()=>{
        navigate("/profile");
    };
    const onSubmit = ()=>{
        clearErrors();
        handleSubmit(async ({ password: password })=>{
            try {
                await api.post(`me/password/verify`, {
                    json: {
                        password: password
                    }
                });
                reset();
                navigate("../change-password", {
                    state: state
                });
            } catch (error) {
                (0, $bdd3cc0274f26dd3$export$d3da1ecaf1206c58)(error, async (code, message)=>{
                    if (code === "session.invalid_credentials") {
                        setError("password", {
                            type: "custom",
                            message: message
                        });
                        return true;
                    }
                });
            }
        })();
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $c3cfb1552c8ab2c5$export$2e2bcd8739ae039), {
        title: "profile.password.enter_password",
        subtitle: "profile.password.enter_password_subtitle",
        onClose: onClose,
        onGoBack: onClose,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                ...register("password", {
                    required: t("profile.password.required")
                }),
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus: true,
                error: errors.password?.message,
                type: showPassword ? "text" : "password",
                suffix: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                    onMouseDown: (event)=>{
                        event.preventDefault();
                        setShowPassword((flag)=>!flag);
                    },
                    children: showPassword ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a3da18ce43178c5e$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1799fb0a7a4a7c85$export$2e2bcd8739ae039), {})
                }),
                onKeyDown: (event)=>{
                    if (event.key === "Enter") onSubmit();
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                type: "primary",
                size: "large",
                title: "general.continue",
                isLoading: isSubmitting,
                onClick: onSubmit
            }),
            email && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                className: $4b7ef1480204b5ac$export$9c30223ca0a664fb,
                icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c9e6fc1c8770302e$export$2e2bcd8739ae039), {}),
                onClick: ()=>{
                    api.post("me/verification-codes", {
                        json: {
                            email: email
                        }
                    });
                    navigate("../verification-code", {
                        state: state
                    });
                },
                children: t("profile.code.verify_via_code")
            })
        ]
    });
}
var $7d1af221703bec48$export$2e2bcd8739ae039 = $7d1af221703bec48$var$VerifyPasswordModal;


const $282d6374ee892737$export$4882ae973e0491e = [
    {
        path: "verify-password",
        element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7d1af221703bec48$export$2e2bcd8739ae039), {})
    },
    {
        path: "change-password",
        element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $19506d07c8204ad1$export$2e2bcd8739ae039), {})
    },
    {
        path: "link-email",
        element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e83bb6bfe464a39e$export$2e2bcd8739ae039), {})
    },
    {
        path: "verification-code",
        element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $69d6de69d3cd6f87$export$2e2bcd8739ae039), {})
    }
];






var $4ZcUR = parcelRequire("4ZcUR");

var $7ddbeb184b5d4257$export$34e0f9847d4c02dd;
var $7ddbeb184b5d4257$export$516dd90aeaaabcf0;
var $7ddbeb184b5d4257$export$bfd64c937657f93a;
var $7ddbeb184b5d4257$export$4a6dd88bada4e7d2;
var $7ddbeb184b5d4257$export$9852986a3ec5f6a0;
$7ddbeb184b5d4257$export$34e0f9847d4c02dd = `KDjGaq_container`;
$7ddbeb184b5d4257$export$516dd90aeaaabcf0 = `KDjGaq_headline`;
$7ddbeb184b5d4257$export$bfd64c937657f93a = `KDjGaq_rotating`;
$7ddbeb184b5d4257$export$4a6dd88bada4e7d2 = `KDjGaq_shimmer`;
$7ddbeb184b5d4257$export$9852986a3ec5f6a0 = `KDjGaq_table`;



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");



var $8TpMk = parcelRequire("8TpMk");

var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $kUZ14 = parcelRequire("kUZ14");
parcelRequire("8Mb3E");
var $ku6YN = parcelRequire("ku6YN");
var $7YcaX = parcelRequire("7YcaX");

var $jGWQ4 = parcelRequire("jGWQ4");

var $5vVWy = parcelRequire("5vVWy");

var $fmHmG = parcelRequire("fmHmG");


var $7VnwS = parcelRequire("7VnwS");

var $kBpQ2 = parcelRequire("kBpQ2");


var $dW2kG = parcelRequire("dW2kG");

function $f7d4919f7802fbe7$var$BasicUserInfoUpdateModal({ field: field, value: initialValue, isOpen: isOpen, onClose: onClose }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { show: showModal } = (0, $kBpQ2.useConfirmModal)();
    const api = (0, $7VnwS.useStaticApi)({
        prefixUrl: (0, $ku6YN.adminTenantEndpoint),
        resourceIndicator: (0, $7YcaX.meApi).indicator,
        hideErrorToast: true
    });
    const { register: register, clearErrors: clearErrors, handleSubmit: handleSubmit, setValue: setValue, reset: reset, control: control, formState: { errors: errors, isSubmitting: isSubmitting } } = (0, $codQP.useForm)({
        reValidateMode: "onBlur"
    });
    const { isReady: isUserAssetsServiceReady } = (0, $04111409d75abad4$export$2e2bcd8739ae039)();
    (0, $jC8Vy.useEffect)(()=>{
        clearErrors();
        if (!field) return;
        setValue(field, initialValue);
        return ()=>{
            reset();
        };
    }, [
        clearErrors,
        field,
        initialValue,
        reset,
        setValue
    ]);
    if (!field) return null;
    const getModalTitle = ()=>{
        if (field === "name") return initialValue ? "profile.change_name" : "profile.set_name";
        return `profile.change_${field}`;
    };
    const getInputPlaceholder = ()=>{
        const i18nKey = field === "avatar" ? "user_details.field_avatar_placeholder" : `profile.settings.${field}`;
        return t(i18nKey);
    };
    const onSubmit = async ()=>{
        clearErrors();
        handleSubmit(async (data)=>{
            try {
                await api.patch("me", {
                    json: {
                        [field]: data[field]
                    }
                });
                (0, $FuhPC.toast).success(t("profile.updated", {
                    target: t(`profile.settings.${field}`)
                }));
                onClose();
            } catch (error) {
                (0, $bdd3cc0274f26dd3$export$d3da1ecaf1206c58)(error, async (_, message, status)=>{
                    if (status === 422) {
                        await showModal({
                            ModalContent: message,
                            type: "alert",
                            cancelButtonText: "general.got_it"
                        });
                        return true;
                    }
                });
            }
        })();
    };
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        shouldCloseOnEsc: true,
        isOpen: isOpen,
        className: $dW2kG.content,
        overlayClassName: $dW2kG.overlay,
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5vVWy.default), {
            title: getModalTitle(),
            footer: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                type: "primary",
                size: "large",
                title: "general.save",
                isLoading: isSubmitting,
                onClick: onSubmit
            }),
            onClose: onClose,
            children: field === "avatar" && isUserAssetsServiceReady ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                name: "avatar",
                control: control,
                render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $ab5b5e61d391674b$export$2e2bcd8739ae039), {
                        name: name,
                        value: value,
                        uploadUrl: "me/user-assets",
                        apiInstance: api,
                        onChange: onChange
                    })
            }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                ...register(field, {
                    validate: (value)=>field !== "username" || !!value || t("errors.required_field_missing", {
                            field: t(`profile.settings.${field}`)
                        })
                }),
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus: true,
                placeholder: getInputPlaceholder(),
                error: errors[field]?.message,
                onKeyDown: (event)=>{
                    if (event.key === "Enter") onSubmit();
                }
            })
        })
    });
}
var $f7d4919f7802fbe7$export$2e2bcd8739ae039 = $f7d4919f7802fbe7$var$BasicUserInfoUpdateModal;



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $jGWQ4 = parcelRequire("jGWQ4");

var $66ixW = parcelRequire("66ixW");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $dcf40ddc6f421d6b$export$6f093cfa640b7166;
$dcf40ddc6f421d6b$export$6f093cfa640b7166 = `kSGQ4G_text`;


function $9ca946d2a7721372$var$NotSet() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
        className: $dcf40ddc6f421d6b$export$6f093cfa640b7166,
        children: t("profile.not_set")
    });
}
var $9ca946d2a7721372$export$2e2bcd8739ae039 = $9ca946d2a7721372$var$NotSet;


var $ba7756c5ee3ba19a$export$a75c7ea49564edd7;
var $ba7756c5ee3ba19a$export$34e0f9847d4c02dd;
var $ba7756c5ee3ba19a$export$1ca1ec8b29a4ce27;
var $ba7756c5ee3ba19a$export$bfd64c937657f93a;
var $ba7756c5ee3ba19a$export$4a6dd88bada4e7d2;
var $ba7756c5ee3ba19a$export$fb184b623420d9be;
var $ba7756c5ee3ba19a$export$cc74dcc53cfce4eb;
$ba7756c5ee3ba19a$export$a75c7ea49564edd7 = `Qw8NkG_actionButton`;
$ba7756c5ee3ba19a$export$34e0f9847d4c02dd = `Qw8NkG_container`;
$ba7756c5ee3ba19a$export$1ca1ec8b29a4ce27 = `Qw8NkG_icon`;
$ba7756c5ee3ba19a$export$bfd64c937657f93a = `Qw8NkG_rotating`;
$ba7756c5ee3ba19a$export$4a6dd88bada4e7d2 = `Qw8NkG_shimmer`;
$ba7756c5ee3ba19a$export$fb184b623420d9be = `Qw8NkG_title`;
$ba7756c5ee3ba19a$export$cc74dcc53cfce4eb = `Qw8NkG_wrapper`;


function $78206816466bc9e6$var$CardContent({ title: title, data: data }) {
    const defaultRenderer = (value)=>value ? /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
            children: String(value)
        }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9ca946d2a7721372$export$2e2bcd8739ae039), {});
    if (data.length === 0) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $ba7756c5ee3ba19a$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $ba7756c5ee3ba19a$export$fb184b623420d9be,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                    forKey: title
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("table", {
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("tbody", {
                    children: data.map(({ key: key, icon: icon, label: label, value: value, renderer: renderer = defaultRenderer, action: action })=>{
                        const actions = Array.isArray(action) ? action : [
                            action
                        ];
                        return /*#__PURE__*/ (0, $C7mD2.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $C7mD2.jsx)("td", {
                                    children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                        className: $ba7756c5ee3ba19a$export$cc74dcc53cfce4eb,
                                        children: [
                                            icon && /*#__PURE__*/ (0, $jC8Vy.cloneElement)(icon, {
                                                className: $ba7756c5ee3ba19a$export$1ca1ec8b29a4ce27
                                            }),
                                            typeof label === "string" ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                                forKey: label
                                            }) : label
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $C7mD2.jsx)("td", {
                                    children: renderer(value)
                                }),
                                /*#__PURE__*/ (0, $C7mD2.jsx)("td", {
                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $ba7756c5ee3ba19a$export$cc74dcc53cfce4eb,
                                        children: actions.map(({ name: name, handler: handler })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                                                className: $ba7756c5ee3ba19a$export$a75c7ea49564edd7,
                                                type: "text",
                                                size: "small",
                                                title: name,
                                                onClick: handler
                                            }, name))
                                    })
                                })
                            ]
                        }, key);
                    })
                })
            })
        ]
    });
}
var $78206816466bc9e6$export$2e2bcd8739ae039 = $78206816466bc9e6$var$CardContent;


function $fafd196aa71c2282$var$BasicUserInfoSection({ user: user, onUpdate: onUpdate }) {
    const [editingField, setEditingField] = (0, $jC8Vy.useState)();
    const [isUpdateModalOpen, setIsUpdateModalOpen] = (0, $jC8Vy.useState)(false);
    const { name: name, username: username, avatar: avatar } = user;
    const conditionalUsername = (0, $8TpMk.isCloud) ? [] : [
        {
            key: "username",
            label: "profile.settings.username",
            value: username,
            action: {
                name: "profile.change",
                handler: ()=>{
                    setEditingField("username");
                    setIsUpdateModalOpen(true);
                }
            }
        }
    ];
    // Get the value of the editing simple field (avatar, username or name)
    const getSimpleFieldValue = (field)=>{
        const value = field === "avatar" ? avatar : user[field];
        return value ?? "";
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
        title: "profile.settings.title",
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $78206816466bc9e6$export$2e2bcd8739ae039), {
                title: "profile.settings.profile_information",
                data: [
                    {
                        key: "avatar",
                        label: "profile.settings.avatar",
                        value: avatar,
                        renderer: ()=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $e999fd6c93542895$export$2e2bcd8739ae039), {
                                size: "large",
                                user: user
                            }),
                        action: {
                            name: "profile.change",
                            handler: ()=>{
                                setEditingField("avatar");
                                setIsUpdateModalOpen(true);
                            }
                        }
                    },
                    {
                        key: "name",
                        label: "profile.settings.name",
                        value: name,
                        action: {
                            name: name ? "profile.change" : "profile.set_name",
                            handler: ()=>{
                                setEditingField("name");
                                setIsUpdateModalOpen(true);
                            }
                        }
                    },
                    ...conditionalUsername
                ]
            }),
            editingField && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f7d4919f7802fbe7$export$2e2bcd8739ae039), {
                value: getSimpleFieldValue(editingField),
                field: editingField,
                isOpen: isUpdateModalOpen,
                onClose: ()=>{
                    setIsUpdateModalOpen(false);
                    onUpdate?.();
                }
            })
        ]
    });
}
var $fafd196aa71c2282$export$2e2bcd8739ae039 = $fafd196aa71c2282$var$BasicUserInfoSection;




var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("oK7kD");
var $j080Y = parcelRequire("j080Y");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");
parcelRequire("ajkVG");
var $7WNrO = parcelRequire("7WNrO");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");
var $gcHb7 = parcelRequire("gcHb7");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $4caace99194254f6$var$SvgMail = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M15.834 3.333H4.167a2.5 2.5 0 0 0-2.5 2.5v8.334a2.5 2.5 0 0 0 2.5 2.5h11.667a2.5 2.5 0 0 0 2.5-2.5V5.833a2.5 2.5 0 0 0-2.5-2.5ZM4.167 5h11.667a.833.833 0 0 1 .833.833L10 9.9 3.334 5.833A.833.833 0 0 1 4.167 5Zm12.5 9.167a.833.833 0 0 1-.833.833H4.167a.833.833 0 0 1-.833-.833V7.734l6.233 3.808a.833.833 0 0 0 .833 0l6.267-3.808v6.433Z",
            fill: "currentColor"
        })
    });
var $4caace99194254f6$export$2e2bcd8739ae039 = $4caace99194254f6$var$SvgMail;





parcelRequire("8Mb3E");
var $ku6YN = parcelRequire("ku6YN");
var $7YcaX = parcelRequire("7YcaX");
var $fb30i = parcelRequire("fb30i");


var $7VnwS = parcelRequire("7VnwS");

var $kBpQ2 = parcelRequire("kBpQ2");

var $4ZcUR = parcelRequire("4ZcUR");

var $jheqv = parcelRequire("jheqv");



var $b691b639032b3ac0$export$bfd64c937657f93a;
var $b691b639032b3ac0$export$4a6dd88bada4e7d2;
var $b691b639032b3ac0$export$cc74dcc53cfce4eb;
$b691b639032b3ac0$export$bfd64c937657f93a = `XeRJzW_rotating`;
$b691b639032b3ac0$export$4a6dd88bada4e7d2 = `XeRJzW_shimmer`;
$b691b639032b3ac0$export$cc74dcc53cfce4eb = `XeRJzW_wrapper`;


function $9cc9032506f3349e$var$LinkAccountSection({ user: user, connectors: connectors, onUpdate: onUpdate }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const theme = (0, $jheqv.default)();
    const { show: showConfirm } = (0, $kBpQ2.useConfirmModal)();
    const api = (0, $7VnwS.useStaticApi)({
        prefixUrl: (0, $ku6YN.adminTenantEndpoint),
        resourceIndicator: (0, $7YcaX.meApi).indicator
    });
    const getSocialAuthorizationUri = (0, $jC8Vy.useCallback)(async (connectorId)=>{
        const adminTenantEndpointUrl = new URL((0, $ku6YN.adminTenantEndpoint));
        const state = (0, $7WNrO.generateStandardId)(8);
        const redirectUri = new URL(`/callback/${connectorId}`, adminTenantEndpointUrl).href;
        const { redirectTo: redirectTo } = await api.post("me/social/authorization-uri", {
            json: {
                connectorId: connectorId,
                state: state,
                redirectUri: redirectUri
            }
        }).json();
        sessionStorage.setItem((0, $fb30i.storageKeys).linkingSocialConnector, connectorId);
        return redirectTo;
    }, [
        api
    ]);
    const tableInfo = (0, $jC8Vy.useMemo)(()=>{
        if (!connectors) return [];
        return connectors.map(({ id: id, name: name, logo: logo, logoDark: logoDark, target: target })=>{
            const logoSrc = theme === (0, $5HVJe.Theme).Dark && logoDark ? logoDark : logo;
            const relatedUserDetails = user.identities[target]?.details;
            const socialUserInfo = (0, $j080Y.socialUserInfoGuard).safeParse(relatedUserDetails);
            const hasLinked = socialUserInfo.success;
            return {
                key: target,
                icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dbaecc0d7fe55772$export$2e2bcd8739ae039), {
                    src: logoSrc
                }),
                label: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ee1df03577241ccd$export$2e2bcd8739ae039), {
                    resource: name
                }),
                value: (0, $7oDSS.conditional)(hasLinked && socialUserInfo.data),
                renderer: (user)=>user ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e27711e91d86e1b2$export$2e2bcd8739ae039), {
                        user: user
                    }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9ca946d2a7721372$export$2e2bcd8739ae039), {}),
                action: hasLinked ? {
                    name: "profile.unlink",
                    handler: async ()=>{
                        const [result] = await showConfirm({
                            ModalContent: ()=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                                    components: {
                                        span: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ee1df03577241ccd$export$2e2bcd8739ae039), {
                                            resource: name
                                        })
                                    },
                                    children: t("profile.unlink_reminder")
                                }),
                            confirmButtonText: "profile.unlink_confirm_text"
                        });
                        if (result) {
                            await api.delete(`me/social/identity/${id}`);
                            onUpdate();
                        }
                    }
                } : {
                    name: "profile.link",
                    handler: async ()=>{
                        const authUri = await getSocialAuthorizationUri(id);
                        // Profile page has been moved to the root path instead of being nested inside a tenant context.
                        // Therefore, we don't need to use `getUrl` to prepend the tenant segment in the callback URL.
                        // Also, link social is Cloud only, so no need to conditionally prepend the `ossConsolePath`, either.
                        const callback = new URL("/handle-social", window.location.href).href;
                        const queries = new URLSearchParams({
                            redirectTo: authUri,
                            connectorId: id,
                            callback: callback
                        });
                        const newWindow = (0, $bdd3cc0274f26dd3$export$20ff57c8784c652c)((0, $gcHb7.appendPath)((0, $ku6YN.adminTenantEndpoint), `/springboard?${queries.toString()}`).href, "Link social account with Logto", 600, 640);
                        newWindow?.focus();
                    }
                }
            };
        });
    }, [
        api,
        connectors,
        theme,
        user.identities,
        showConfirm,
        t,
        onUpdate,
        getSocialAuthorizationUri
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
        title: "profile.link_account.title",
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $78206816466bc9e6$export$2e2bcd8739ae039), {
                title: "profile.link_account.email_sign_in",
                data: [
                    {
                        key: "email",
                        label: "profile.link_account.email",
                        value: user.primaryEmail,
                        renderer: (email)=>email ? /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                className: $b691b639032b3ac0$export$cc74dcc53cfce4eb,
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4caace99194254f6$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                                        children: email
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9ca946d2a7721372$export$2e2bcd8739ae039), {}),
                        action: {
                            name: user.primaryEmail ? "profile.change" : "profile.link",
                            handler: ()=>{
                                navigate("link-email", {
                                    state: {
                                        email: user.primaryEmail,
                                        action: "changeEmail"
                                    }
                                });
                            }
                        }
                    }
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $78206816466bc9e6$export$2e2bcd8739ae039), {
                title: "profile.link_account.social_sign_in",
                data: tableInfo
            })
        ]
    });
}
var $9cc9032506f3349e$export$2e2bcd8739ae039 = $9cc9032506f3349e$var$LinkAccountSection;




var $C7mD2 = parcelRequire("C7mD2");
var $992a2983fb5caf01$export$aa3e815946b80764;
var $992a2983fb5caf01$export$34e0f9847d4c02dd;
var $992a2983fb5caf01$export$7061c75fc5af8b7e;
var $992a2983fb5caf01$export$1237798dc640739a;
var $992a2983fb5caf01$export$bfd64c937657f93a;
var $992a2983fb5caf01$export$fe2e36411d703b3d;
var $992a2983fb5caf01$export$4a6dd88bada4e7d2;
var $992a2983fb5caf01$export$9852986a3ec5f6a0;
var $992a2983fb5caf01$export$fb184b623420d9be;
var $992a2983fb5caf01$export$f9922917cc86d0cb;
$992a2983fb5caf01$export$aa3e815946b80764 = `NgX8vq_card`;
$992a2983fb5caf01$export$34e0f9847d4c02dd = `NgX8vq_container`;
$992a2983fb5caf01$export$7061c75fc5af8b7e = `NgX8vq_item`;
$992a2983fb5caf01$export$1237798dc640739a = `NgX8vq_label`;
$992a2983fb5caf01$export$bfd64c937657f93a = `NgX8vq_rotating`;
$992a2983fb5caf01$export$fe2e36411d703b3d = `NgX8vq_section`;
$992a2983fb5caf01$export$4a6dd88bada4e7d2 = `NgX8vq_shimmer`;
$992a2983fb5caf01$export$4a6dd88bada4e7d2;
$992a2983fb5caf01$export$9852986a3ec5f6a0 = `NgX8vq_table`;
$992a2983fb5caf01$export$fb184b623420d9be = `NgX8vq_title`;
$992a2983fb5caf01$export$f9922917cc86d0cb = `NgX8vq_titleWrapper`;


function $23fc1fe7c729ecd6$var$Skeleton() {
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: $992a2983fb5caf01$export$34e0f9847d4c02dd,
        children: Array.from({
            length: 2
        }).map((_, sectionIndex)=>// eslint-disable-next-line react/no-array-index-key
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $992a2983fb5caf01$export$fe2e36411d703b3d,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $992a2983fb5caf01$export$f9922917cc86d0cb,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $992a2983fb5caf01$export$fb184b623420d9be
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $992a2983fb5caf01$export$aa3e815946b80764,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $992a2983fb5caf01$export$1237798dc640739a
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("table", {
                                className: $992a2983fb5caf01$export$9852986a3ec5f6a0,
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)("tbody", {
                                    children: Array.from({
                                        length: 3
                                    }).map((_, rowIndex)=>// eslint-disable-next-line react/no-array-index-key
                                        /*#__PURE__*/ (0, $C7mD2.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $C7mD2.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                        className: $992a2983fb5caf01$export$7061c75fc5af8b7e
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $C7mD2.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                        className: $992a2983fb5caf01$export$7061c75fc5af8b7e
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $C7mD2.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                        className: $992a2983fb5caf01$export$7061c75fc5af8b7e
                                                    })
                                                })
                                            ]
                                        }, rowIndex))
                                })
                            })
                        ]
                    })
                ]
            }, sectionIndex))
    });
}
var $23fc1fe7c729ecd6$export$2e2bcd8739ae039 = $23fc1fe7c729ecd6$var$Skeleton;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $kUZ14 = parcelRequire("kUZ14");
parcelRequire("8Mb3E");
var $cfL6o = parcelRequire("cfL6o");

var $jGWQ4 = parcelRequire("jGWQ4");

var $5vVWy = parcelRequire("5vVWy");

var $9Q3SI = parcelRequire("9Q3SI");

var $dW2kG = parcelRequire("dW2kG");
var $163e73e2f846c4f7$export$34e0f9847d4c02dd;
var $163e73e2f846c4f7$export$b602b78110e4ab1e;
var $163e73e2f846c4f7$export$bfd64c937657f93a;
var $163e73e2f846c4f7$export$4a6dd88bada4e7d2;
$163e73e2f846c4f7$export$34e0f9847d4c02dd = `shIkWq_container`;
$163e73e2f846c4f7$export$b602b78110e4ab1e = `shIkWq_mail`;
$163e73e2f846c4f7$export$bfd64c937657f93a = `shIkWq_rotating`;
$163e73e2f846c4f7$export$4a6dd88bada4e7d2 = `shIkWq_shimmer`;


const $c5327936e962317f$var$mailToLink = `${(0, $cfL6o.contactEmailLink)}?subject=Account%20Deletion%20Request`;
function $c5327936e962317f$var$DeleteAccountModal({ isOpen: isOpen, onClose: onClose }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        shouldCloseOnEsc: true,
        isOpen: isOpen,
        className: $dW2kG.content,
        overlayClassName: $dW2kG.overlay,
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5vVWy.default), {
            title: "profile.delete_account.label",
            footer: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                size: "large",
                title: "general.got_it",
                onClick: onClose
            }),
            onClose: onClose,
            children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $163e73e2f846c4f7$export$34e0f9847d4c02dd,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("p", {
                        children: t("profile.delete_account.dialog_paragraph_1")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("p", {
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                            components: {
                                a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                                    href: $c5327936e962317f$var$mailToLink,
                                    className: $163e73e2f846c4f7$export$b602b78110e4ab1e
                                })
                            },
                            children: t("profile.delete_account.dialog_paragraph_2", {
                                mail: (0, $cfL6o.contactEmail)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("p", {
                        children: t("profile.delete_account.dialog_paragraph_3")
                    })
                ]
            })
        })
    });
}
var $c5327936e962317f$export$2e2bcd8739ae039 = $c5327936e962317f$var$DeleteAccountModal;


var $f48b8411cccb6a08$export$a7db06668cad9adb;
var $f48b8411cccb6a08$export$45abfc3976589d02;
var $f48b8411cccb6a08$export$6d59db4903f20f7d;
var $f48b8411cccb6a08$export$9bfd64464b8f45a7;
var $f48b8411cccb6a08$export$bfd64c937657f93a;
var $f48b8411cccb6a08$export$e19e816763c25ac;
var $f48b8411cccb6a08$export$4a6dd88bada4e7d2;
var $f48b8411cccb6a08$export$cc74dcc53cfce4eb;
$f48b8411cccb6a08$export$a7db06668cad9adb = `HzVHqa_content`;
$f48b8411cccb6a08$export$45abfc3976589d02 = `HzVHqa_deleteAccount`;
$f48b8411cccb6a08$export$6d59db4903f20f7d = `HzVHqa_description`;
$f48b8411cccb6a08$export$9bfd64464b8f45a7 = `HzVHqa_pageContainer`;
$f48b8411cccb6a08$export$bfd64c937657f93a = `HzVHqa_rotating`;
$f48b8411cccb6a08$export$e19e816763c25ac = `HzVHqa_scrollable`;
$f48b8411cccb6a08$export$4a6dd88bada4e7d2 = `HzVHqa_shimmer`;
$f48b8411cccb6a08$export$cc74dcc53cfce4eb = `HzVHqa_wrapper`;


function $22925f126a88c229$var$Profile() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const childrenRoutes = (0, $2Phw0.useRoutes)((0, $282d6374ee892737$export$4882ae973e0491e));
    (0, $77d0d5b50790ecf4$export$751a22e57b65a4b5)((0, $282d6374ee892737$export$4882ae973e0491e), "profile");
    const api = (0, $7VnwS.useStaticApi)({
        prefixUrl: (0, $ku6YN.adminTenantEndpoint),
        resourceIndicator: (0, $7YcaX.meApi).indicator
    });
    const fetcher = (0, $04c74fc7d2f91811$export$2e2bcd8739ae039)(api);
    const { data: connectors, error: fetchConnectorsError } = (0, $Xh5AE.default)("me/social/connectors", fetcher);
    const isLoadingConnectors = !connectors && !fetchConnectorsError;
    const { user: user, reload: reload, isLoading: isLoadingUser } = (0, $8dc2d4d6918e57ba$export$2e2bcd8739ae039)();
    const { isLoading: isUserAssetServiceLoading } = (0, $04111409d75abad4$export$2e2bcd8739ae039)();
    const [showDeleteAccountModal, setShowDeleteAccountModal] = (0, $jC8Vy.useState)(false);
    const showLoadingSkeleton = isLoadingUser || isLoadingConnectors || isUserAssetServiceLoading;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $f48b8411cccb6a08$export$9bfd64464b8f45a7,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8f0e3b0e6954789f$export$2e2bcd8739ae039), {
                hideTenantSelector: true,
                hideTitle: true
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aTllQ.default), {
                className: $f48b8411cccb6a08$export$e19e816763c25ac,
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: $f48b8411cccb6a08$export$cc74dcc53cfce4eb,
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5TsIB.default), {
                            titleKey: "profile.page_title"
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $7ddbeb184b5d4257$export$516dd90aeaaabcf0,
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $18SWy.default), {
                                title: "profile.title",
                                subtitle: "profile.description"
                            })
                        }),
                        showLoadingSkeleton && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $23fc1fe7c729ecd6$export$2e2bcd8739ae039), {}),
                        user && !showLoadingSkeleton && /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                            className: $f48b8411cccb6a08$export$a7db06668cad9adb,
                            children: [
                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fafd196aa71c2282$export$2e2bcd8739ae039), {
                                    user: user,
                                    onUpdate: reload
                                }),
                                (0, $8TpMk.isCloud) && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9cc9032506f3349e$export$2e2bcd8739ae039), {
                                    user: user,
                                    connectors: connectors,
                                    onUpdate: reload
                                }),
                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
                                    title: "profile.password.title",
                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $78206816466bc9e6$export$2e2bcd8739ae039), {
                                        title: "profile.password.password_setting",
                                        data: [
                                            {
                                                key: "password",
                                                label: "profile.password.password",
                                                value: user.hasPassword,
                                                renderer: (value)=>value ? /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                                                        children: "********"
                                                    }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9ca946d2a7721372$export$2e2bcd8739ae039), {}),
                                                action: {
                                                    name: "profile.change",
                                                    handler: ()=>{
                                                        navigate(user.hasPassword ? "verify-password" : "change-password", {
                                                            state: {
                                                                email: user.primaryEmail,
                                                                action: "changePassword"
                                                            }
                                                        });
                                                    }
                                                }
                                            }
                                        ]
                                    })
                                }),
                                (0, $8TpMk.isCloud) && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
                                    title: "profile.delete_account.title",
                                    children: [
                                        /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                            className: $f48b8411cccb6a08$export$45abfc3976589d02,
                                            children: [
                                                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                    className: $f48b8411cccb6a08$export$6d59db4903f20f7d,
                                                    children: t("profile.delete_account.description")
                                                }),
                                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                                                    title: "profile.delete_account.button",
                                                    onClick: ()=>{
                                                        setShowDeleteAccountModal(true);
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c5327936e962317f$export$2e2bcd8739ae039), {
                                            isOpen: showDeleteAccountModal,
                                            onClose: ()=>{
                                                setShowDeleteAccountModal(false);
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            childrenRoutes
        ]
    });
}
var $22925f126a88c229$export$2e2bcd8739ae039 = $22925f126a88c229$var$Profile;



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("6bq3s");
var $2Phw0 = parcelRequire("2Phw0");

parcelRequire("8Mb3E");
var $ku6YN = parcelRequire("ku6YN");
var $7YcaX = parcelRequire("7YcaX");
var $fb30i = parcelRequire("fb30i");

var $7VnwS = parcelRequire("7VnwS");

var $kBpQ2 = parcelRequire("kBpQ2");

function $e6413a98707bc5cf$var$HandleSocialCallback() {
    const { search: search } = (0, $2Phw0.useLocation)();
    const { show: showModal } = (0, $kBpQ2.useConfirmModal)();
    const api = (0, $7VnwS.useStaticApi)({
        prefixUrl: (0, $ku6YN.adminTenantEndpoint),
        resourceIndicator: (0, $7YcaX.meApi).indicator,
        hideErrorToast: true
    });
    (0, $jC8Vy.useEffect)(()=>{
        (async ()=>{
            const connectorId = sessionStorage.getItem((0, $fb30i.storageKeys).linkingSocialConnector);
            sessionStorage.removeItem((0, $fb30i.storageKeys).linkingSocialConnector);
            if (connectorId) {
                const queries = new URLSearchParams(search);
                queries.set("redirectUri", new URL(`/callback/${connectorId}`, new URL((0, $ku6YN.adminTenantEndpoint))).toString());
                const connectorData = Object.fromEntries(queries);
                try {
                    await api.post("me/social/link-identity", {
                        json: {
                            connectorId: connectorId,
                            connectorData: connectorData
                        }
                    });
                    window.close();
                } catch (error) {
                    (0, $bdd3cc0274f26dd3$export$d3da1ecaf1206c58)(error, async (code, message)=>{
                        if (code === "user.identity_already_in_use") {
                            await showModal({
                                ModalContent: message,
                                type: "alert",
                                cancelButtonText: "general.got_it"
                            });
                            window.close();
                            return true;
                        }
                    });
                }
            }
        })();
    }, [
        api,
        search,
        showModal
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4c070a72a1cf87ce$export$2e2bcd8739ae039), {});
}
var $e6413a98707bc5cf$export$2e2bcd8739ae039 = $e6413a98707bc5cf$var$HandleSocialCallback;


var $a65469f7a8fcde27$export$729c8b7179294ba;
$a65469f7a8fcde27$export$729c8b7179294ba = `mKruhW_app`;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");

var $2Phw0 = parcelRequire("2Phw0");


var $8TpMk = parcelRequire("8TpMk");

var $cDKfs = parcelRequire("cDKfs");





var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
var $aZIrr = parcelRequire("aZIrr");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $fa5532faa4d9cc63$var$SvgOrganizationPreview = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 40,
                height: 40,
                rx: 6,
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.4 12.1v4.2h4.2v-4.2h-4.2ZM17.35 10c-.58 0-1.05.47-1.05 1.05v6.3c0 .58.47 1.05 1.05 1.05h6.3c.58 0 1.05-.47 1.05-1.05v-6.3c0-.58-.47-1.05-1.05-1.05h-6.3ZM12.1 24.7v4.2h4.2v-4.2h-4.2Zm-1.05-2.1c-.58 0-1.05.47-1.05 1.05v6.3c0 .58.47 1.05 1.05 1.05h6.3c.58 0 1.05-.47 1.05-1.05v-6.3c0-.58-.47-1.05-1.05-1.05h-2.1v-1.05h10.5v1.05h-2.1c-.58 0-1.05.47-1.05 1.05v6.3c0 .58.47 1.05 1.05 1.05h6.3c.58 0 1.05-.47 1.05-1.05v-6.3c0-.58-.47-1.05-1.05-1.05h-2.1v-1.05a2.1 2.1 0 0 0-2.1-2.1h-4.2V18.4h-2.1v1.05h-4.2a2.1 2.1 0 0 0-2.1 2.1v1.05h-2.1Zm13.65 6.3v-4.2h4.2v4.2h-4.2Z",
                fill: "url(#paint0_linear_550_31630)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("defs", {
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                    id: "paint0_linear_550_31630",
                    x1: 13.609,
                    y1: 28.156,
                    x2: 27.719,
                    y2: 13.063,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            stopColor: "#5D34F2"
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            offset: 1,
                            stopColor: "#FF88FA"
                        })
                    ]
                })
            })
        ]
    });
var $fa5532faa4d9cc63$export$2e2bcd8739ae039 = $fa5532faa4d9cc63$var$SvgOrganizationPreview;





var $C7mD2 = parcelRequire("C7mD2");
var $37e74b928c92b9e7$export$1ca1ec8b29a4ce27;
$37e74b928c92b9e7$export$1ca1ec8b29a4ce27 = `wvr_2q_icon`;


/**
 * Renders an icon with color according to the current theme. It uses `--color-specific-icon-bg`
 * CSS variable to determine the color.
 */ function $c1fc6cc4be9e0c9a$var$ThemedIcon({ for: Icon, size: size }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)(Icon, {
        className: $37e74b928c92b9e7$export$1ca1ec8b29a4ce27,
        style: {
            width: size,
            height: size
        }
    });
}
var $c1fc6cc4be9e0c9a$export$2e2bcd8739ae039 = $c1fc6cc4be9e0c9a$var$ThemedIcon;



var $cDKfs = parcelRequire("cDKfs");

var $jGWQ4 = parcelRequire("jGWQ4");

var $jbKqE = parcelRequire("jbKqE");

var $4ZcUR = parcelRequire("4ZcUR");

var $4ef9f85a9610729a$export$34e0f9847d4c02dd;
var $4ef9f85a9610729a$export$718bc6d3654bffd4;
var $4ef9f85a9610729a$export$6d59db4903f20f7d;
var $4ef9f85a9610729a$export$a8ff84c12d48cfa6;
var $4ef9f85a9610729a$export$bfd64c937657f93a;
var $4ef9f85a9610729a$export$3e523c77c1f23f8c;
var $4ef9f85a9610729a$export$4a6dd88bada4e7d2;
var $4ef9f85a9610729a$export$2b067c6666111485;
var $4ef9f85a9610729a$export$384a6feef7a9a4f6;
var $4ef9f85a9610729a$export$fb184b623420d9be;
var $4ef9f85a9610729a$export$cc74dcc53cfce4eb;
$4ef9f85a9610729a$export$34e0f9847d4c02dd = `kcUJTW_container`;
$4ef9f85a9610729a$export$718bc6d3654bffd4 = `kcUJTW_createTenantButton`;
$4ef9f85a9610729a$export$6d59db4903f20f7d = `kcUJTW_description`;
$4ef9f85a9610729a$export$a8ff84c12d48cfa6 = `kcUJTW_name`;
$4ef9f85a9610729a$export$bfd64c937657f93a = `kcUJTW_rotating`;
$4ef9f85a9610729a$export$3e523c77c1f23f8c = `kcUJTW_separator`;
$4ef9f85a9610729a$export$4a6dd88bada4e7d2 = `kcUJTW_shimmer`;
$4ef9f85a9610729a$export$2b067c6666111485 = `kcUJTW_tag`;
$4ef9f85a9610729a$export$384a6feef7a9a4f6 = `kcUJTW_tenant`;
$4ef9f85a9610729a$export$fb184b623420d9be = `kcUJTW_title`;
$4ef9f85a9610729a$export$cc74dcc53cfce4eb = `kcUJTW_wrapper`;


function $5a46e038250599de$var$InvitationList({ invitations: invitations }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const cloudApi = (0, $1c34cc51be8c93d3$export$7a5c900790855d66)();
    const { navigateTenant: navigateTenant, resetTenants: resetTenants } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const [isJoining, setIsJoining] = (0, $jC8Vy.useState)(false);
    const [isUpdatingOnboardingStatus, setIsUpdatingOnboardingStatus] = (0, $jC8Vy.useState)(false);
    const { update: update } = (0, $ce45228420657e93$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: $4ef9f85a9610729a$export$34e0f9847d4c02dd,
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
            className: $4ef9f85a9610729a$export$cc74dcc53cfce4eb,
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $4ef9f85a9610729a$export$fb184b623420d9be,
                    children: t("invitation.find_your_tenants")
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $4ef9f85a9610729a$export$6d59db4903f20f7d,
                    children: t("invitation.find_tenants_description")
                }),
                invitations.map(({ id: id, organizationId: organizationId, tenantName: tenantName, tenantTag: tenantTag })=>/*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $4ef9f85a9610729a$export$384a6feef7a9a4f6,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c1fc6cc4be9e0c9a$export$2e2bcd8739ae039), {
                                for: (0, $fa5532faa4d9cc63$export$2e2bcd8739ae039),
                                size: 40
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                                className: $4ef9f85a9610729a$export$a8ff84c12d48cfa6,
                                children: tenantName
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7e60916f61ffa7e7$export$2e2bcd8739ae039), {
                                isAbbreviated: true,
                                className: $4ef9f85a9610729a$export$2b067c6666111485,
                                tag: tenantTag
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jbKqE.default), {}),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                                size: "small",
                                type: "primary",
                                title: "general.join",
                                isLoading: isJoining,
                                onClick: async ()=>{
                                    setIsJoining(true);
                                    try {
                                        await cloudApi.patch(`/api/invitations/:invitationId/status`, {
                                            params: {
                                                invitationId: id
                                            },
                                            body: {
                                                status: (0, $61Yml.OrganizationInvitationStatus).Accepted
                                            }
                                        });
                                        const data = await cloudApi.get("/api/tenants");
                                        resetTenants(data);
                                        navigateTenant((0, $aZIrr.getTenantIdFromOrganizationId)(organizationId));
                                    } finally{
                                        setIsJoining(false);
                                    }
                                }
                            })
                        ]
                    }, id)),
                /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: $4ef9f85a9610729a$export$3e523c77c1f23f8c,
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)("hr", {}),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                            children: t("general.or")
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("hr", {})
                    ]
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                    size: "large",
                    type: "outline",
                    className: $4ef9f85a9610729a$export$718bc6d3654bffd4,
                    isLoading: isUpdatingOnboardingStatus,
                    title: "invitation.create_new_tenant",
                    onClick: async ()=>{
                        setIsUpdatingOnboardingStatus(true);
                        try {
                            await update({
                                isOnboardingDone: false
                            });
                            navigate("/");
                        } finally{
                            setIsUpdatingOnboardingStatus(false);
                        }
                    }
                })
            ]
        })
    });
}
var $5a46e038250599de$export$2e2bcd8739ae039 = $5a46e038250599de$var$InvitationList;



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");


var $cDKfs = parcelRequire("cDKfs");
function $11ca84f742810970$var$Redirect({ toTenantId: toTenantId }) {
    const { navigateTenant: navigateTenant } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    (0, $jC8Vy.useEffect)(()=>{
        navigateTenant(toTenantId);
    }, [
        navigateTenant,
        toTenantId
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4c070a72a1cf87ce$export$2e2bcd8739ae039), {});
}
var $11ca84f742810970$export$2e2bcd8739ae039 = $11ca84f742810970$var$Redirect;



var $C7mD2 = parcelRequire("C7mD2");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $0c53ef5ca97bb589$var$SvgTenantLandingPageDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M9.882 224h30.244c2.88 0 4.68-3.398 0-5.663-4.681-2.265-15.842-3.964-24.484-3.114-8.64.849-9 8.777-5.76 8.777Z",
                fill: "#9485C5"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                opacity: 0.85,
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M178.578 85.035c-17.716.74-32.401 13.21-36.49 29.848-15.601.523-28.088 13.335-28.088 29.064 0 15.346 11.886 27.915 26.954 29.004v.174h15.663C141.577 187.307 121.304 196 99 196c-46.392 0-84-37.608-84-84s37.608-84 84-84c36.96 0 68.344 23.87 79.578 57.035Z",
                fill: "url(#paint0_linear_1153_42742)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.67 144.86c-3.23 5.9-3.942 20.305-3.942 37.138 0 2.757.038 5.449.115 8.049-1.841-2.114-3.575-3.272-4.89-3.272-3.582 0-1.806 9.763 1.858 19.326 2.541 6.634 5.503 12.107 8.213 14.403.607.795 1.268 1.286 1.984 1.437l-.025-9.277c-3.448-6.652-10.65-20.117-10.65-20.117l10.642 17.085-.021-7.437v-.008l-.05-17.788-.043.041a3.158 3.158 0 0 0-.035.032v-2.208l.072-.064c-.038-13.916-.072-26.436-.072-27.962 0-2.379.44 6.332.732 27.416 4.155-3.285 12.107-7.058 12.107-7.058-5.705 3.651-10.324 7.617-12.078 9.184.13 10.066.224 22.754.227 38.188 4.89-.693 7.251-17.031 7.423-37.533 1.31-1.024 2.688-2.307 4.1-3.719 2.274-2.274 3.931-4.741 4.846-6.846a84.33 84.33 0 0 1-4.484-4.439c-1.426.623-3.016 1.586-4.599 2.849-.098-3.079-.249-6.018-.456-8.768A83.928 83.928 0 0 1 21.67 144.86Z",
                fill: "url(#paint1_linear_1153_42742)",
                style: {
                    mixBlendMode: "hard-light"
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M140.954 172.951C125.886 171.862 114 159.293 114 143.947c0-15.729 12.487-28.541 28.088-29.064C146.304 97.727 161.789 85 180.246 85c17.889 0 32.986 11.955 37.737 28.311 16.456.525 29.63 13.688 29.63 29.85 0 15.649-12.352 28.487-28.075 29.762v.202h-78.584v-.174Z",
                fill: "url(#paint2_linear_1153_42742)",
                fillOpacity: 0.8
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#947DFF",
                d: "M128 81h18v32h-18z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 24,
                height: 6,
                rx: 3,
                transform: "matrix(1 0 0 -1 125 82)",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m100 78 68 56H32l68-56Z",
                fill: "url(#paint3_linear_1153_42742)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#7958FF",
                d: "M37 134h126v84H37z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "url(#paint4_linear_1153_42742)",
                d: "M37 134h126v84H37z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M73 170c0-14.912 12.088-27 27-27s27 12.088 27 27v48H73v-48Z",
                fill: "url(#paint5_linear_1153_42742)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M100 151c-9.477 0-17.333 6.938-18.766 16.012C80.975 168.648 82.344 170 84 170h32c1.657 0 3.025-1.352 2.766-2.988C117.333 157.938 109.477 151 100 151Z",
                fill: "url(#paint6_linear_1153_42742)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                filter: "url(#filter0_i_1153_42742)",
                fillRule: "evenodd",
                clipRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M98.576 107.87a3 3 0 1 0 .257-4.235 3 3 0 0 0-.257 4.235Zm6.887 3.252a7.003 7.003 0 0 1-8.338.705l-4.45 3.941.645.729a1 1 0 0 1-.085 1.412l-1.498 1.326a1 1 0 0 1-1.411-.086l-.646-.729-2.216 1.963a2 2 0 1 1-2.652-2.994l9.661-8.556a7 7 0 1 1 10.99 2.289Z",
                        fill: "#FEDEAC"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M98.576 107.87a3 3 0 1 0 .257-4.235 3 3 0 0 0-.257 4.235Zm6.887 3.252a7.003 7.003 0 0 1-8.338.705l-4.45 3.941.645.729a1 1 0 0 1-.085 1.412l-1.498 1.326a1 1 0 0 1-1.411-.086l-.646-.729-2.216 1.963a2 2 0 1 1-2.652-2.994l9.661-8.556a7 7 0 1 1 10.99 2.289Z",
                        fill: "url(#paint7_linear_1153_42742)"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M98.576 107.87a3 3 0 1 0 .257-4.235 3 3 0 0 0-.257 4.235Zm6.887 3.252a7.003 7.003 0 0 1-8.338.705l-4.45 3.941.645.729a1 1 0 0 1-.085 1.412l-1.498 1.326a1 1 0 0 1-1.411-.086l-.646-.729-2.216 1.963a2 2 0 1 1-2.652-2.994l9.661-8.556a7 7 0 1 1 10.99 2.289Z",
                        fill: "url(#paint8_linear_1153_42742)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 81,
                y: 176,
                width: 40,
                height: 34,
                rx: 3,
                fill: "url(#paint9_linear_1153_42742)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 113,
                y: 183,
                width: 4,
                height: 9,
                rx: 2,
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M33 224h138v-3a3 3 0 0 0-3-3H36a3 3 0 0 0-3 3v3Z",
                fill: "url(#paint10_linear_1153_42742)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M134 156h1.5a2 2 0 0 1 2 2v58a2 2 0 0 1-2 2H88l46-62Z",
                fill: "url(#paint11_linear_1153_42742)",
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: 0.5
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 137,
                y: 153,
                width: 94,
                height: 68,
                rx: 5,
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 137,
                y: 153,
                width: 94,
                height: 68,
                rx: 5,
                stroke: "#7958FF",
                strokeWidth: 6
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 137,
                y: 153,
                width: 94,
                height: 68,
                rx: 5,
                stroke: "url(#paint12_linear_1153_42742)",
                strokeWidth: 6
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 162,
                y: 203,
                width: 44,
                height: 6,
                rx: 2,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 162,
                y: 193,
                width: 44,
                height: 6,
                rx: 2,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 172,
                y: 165,
                width: 24,
                height: 24,
                rx: 8,
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 184,
                cy: 172,
                r: 4,
                fill: "#FDCF90"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M178 181a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-2Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m95.768 71.846 1.056-.866a3 3 0 0 1 3.804 0l1.057.866L171.5 129a3 3 0 0 1 .374 4.275l-1.302 1.516a3 3 0 0 1-4.178.365l-65.766-53.834a3 3 0 0 0-3.804 0l-65.718 53.834a3 3 0 0 1-4.177-.365l-1.302-1.516A3 3 0 0 1 26 129l69.768-57.154Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M212.345 34.5a.125.125 0 0 1 .171-.044l1.946 1.135c.06.035.08.112.045.171l-1.998 3.425 3.965.018c.07 0 .125.057.125.126l-.01 2.253c0 .069-.057.125-.126.124l-3.965-.017 1.967 3.442a.126.126 0 0 1-.047.171l-1.956 1.118a.126.126 0 0 1-.171-.047l-1.967-3.442-1.998 3.425a.125.125 0 0 1-.171.045l-1.946-1.136a.126.126 0 0 1-.045-.17l1.998-3.426-3.965-.018a.126.126 0 0 1-.125-.126l.011-2.253c0-.069.056-.124.125-.124l3.965.018-1.967-3.443a.125.125 0 0 1 .047-.171l1.956-1.118a.126.126 0 0 1 .171.047l1.967 3.443 1.998-3.425Z",
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m237.791 81-1.194 2.564a2.828 2.828 0 0 1-3.758 1.37v0a2.828 2.828 0 0 0-3.758 1.37v0a2.83 2.83 0 0 1-3.759 1.37v0a2.828 2.828 0 0 0-3.758 1.37l-1.194 2.563",
                stroke: "#CABEFF",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 6.421,
                height: 6.421,
                rx: 2,
                transform: "scale(-1 1) rotate(-40.65 61.962 61.412)",
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_1153_42742",
                        x1: 34.042,
                        y1: 59.039,
                        x2: 197.175,
                        y2: 112,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FFDDB5"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFEEDC",
                                stopOpacity: 0.7
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_1153_42742",
                        x1: 26.861,
                        y1: 223.869,
                        x2: 41.649,
                        y2: 140.844,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#C7BDE6"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E4DBFF",
                                stopOpacity: 0.16
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint2_linear_1153_42742",
                        x1: 180.807,
                        y1: 85,
                        x2: 180.807,
                        y2: 232.5,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#F9F4FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAF7FF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint3_linear_1153_42742",
                        x1: 137,
                        y1: 94.5,
                        x2: 59,
                        y2: 134,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#947DFF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#AF9EFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint4_linear_1153_42742",
                        x1: 58,
                        y1: 232,
                        x2: 152,
                        y2: 134,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#A896FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7958FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint5_linear_1153_42742",
                        x1: 86,
                        y1: 145,
                        x2: 131,
                        y2: 247,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#C1B3FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#8F77FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint6_linear_1153_42742",
                        x1: 128.5,
                        y1: 159.382,
                        x2: 81,
                        y2: 159.382,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FAD5AB"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F9C68B"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint7_linear_1153_42742",
                        x1: 100.535,
                        y1: 114.507,
                        x2: 90.816,
                        y2: 103.533,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FFDDB5"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFCE94"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint8_linear_1153_42742",
                        x1: 103.573,
                        y1: 117.471,
                        x2: 91.971,
                        y2: 104.37,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FAD5AB"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F9C68B"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint9_linear_1153_42742",
                        x1: 131,
                        y1: 191,
                        x2: 81,
                        y2: 191,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FAD5AB"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F9C68B"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint10_linear_1153_42742",
                        x1: 32,
                        y1: 220.5,
                        x2: 139,
                        y2: 218,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#8366FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7A59FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint11_linear_1153_42742",
                        x1: 139.409,
                        y1: 184.414,
                        x2: 94.106,
                        y2: 215.483,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#E1CEE8"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFFBFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint12_linear_1153_42742",
                        x1: 203,
                        y1: 128.5,
                        x2: 141.012,
                        y2: 295.361,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("filter", {
                        id: "filter0_i_1153_42742",
                        x: 84.138,
                        y: 98.881,
                        width: 23.685,
                        height: 24.005,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feOffset", {
                                dy: 2
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feGaussianBlur", {
                                stdDeviation: 1
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: -1,
                                k3: 1
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feBlend", {
                                in2: "shape",
                                result: "effect1_innerShadow_1153_42742"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $0c53ef5ca97bb589$export$2e2bcd8739ae039 = $0c53ef5ca97bb589$var$SvgTenantLandingPageDark;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $eac5c7bacc4e2169$var$SvgTenantLandingPage = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M25.814 221.968c4.89-.693 7.251-17.031 7.423-37.533 1.31-1.024 2.688-2.307 4.1-3.719 4.629-4.629 6.705-10.058 5.155-11.608-1.307-1.307-5.373-.035-9.392 3.172-.557-17.391-2.763-30.274-7.613-30.274-6.534 0-7.76 17.905-7.76 39.992 0 2.757.039 5.449.116 8.049-1.841-2.114-3.575-3.272-4.89-3.272-3.582 0-1.806 9.763 1.858 19.326 2.541 6.634 5.503 12.107 8.213 14.403.607.795 1.268 1.286 1.984 1.437l-.025-9.277c-3.448-6.652-10.65-20.117-10.65-20.117l10.642 17.085-.021-7.437v-.008l-.05-17.788-.078.073v-2.208l.072-.064c-.038-13.916-.072-26.436-.072-27.962 0-2.379.44 6.332.732 27.416 4.155-3.285 12.107-7.058 12.107-7.058-5.705 3.651-10.324 7.617-12.078 9.184.13 10.066.224 22.754.227 38.188Z",
                fill: "url(#paint0_linear_1153_42741)",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M9.882 224h30.244c2.88 0 4.68-3.398 0-5.663-4.681-2.265-15.842-3.964-24.484-3.114-8.64.849-9 8.777-5.76 8.777Z",
                fill: "#C8BEE6"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M178.578 85.035c-17.716.74-32.401 13.21-36.49 29.848-15.601.523-28.088 13.335-28.088 29.064 0 15.346 11.886 27.915 26.954 29.004v.174h15.663C141.577 187.307 121.304 196 99 196c-46.392 0-84-37.608-84-84s37.608-84 84-84c36.96 0 68.344 23.87 79.578 57.035Z",
                fill: "url(#paint1_linear_1153_42741)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M140.954 172.951C125.886 171.862 114 159.293 114 143.947c0-15.729 12.487-28.541 28.088-29.064C146.304 97.727 161.789 85 180.246 85c17.889 0 32.986 11.955 37.737 28.311 16.456.525 29.63 13.688 29.63 29.85 0 15.649-12.352 28.487-28.075 29.762v.202h-78.584v-.174Z",
                fill: "url(#paint2_linear_1153_42741)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#947DFF",
                d: "M128 81h18v32h-18z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 24,
                height: 6,
                rx: 3,
                transform: "matrix(1 0 0 -1 125 82)",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m100 78 68 56H32l68-56Z",
                fill: "url(#paint3_linear_1153_42741)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#7958FF",
                d: "M37 134h126v84H37z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "url(#paint4_linear_1153_42741)",
                d: "M37 134h126v84H37z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M73 170c0-14.912 12.088-27 27-27s27 12.088 27 27v48H73v-48Z",
                fill: "url(#paint5_linear_1153_42741)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M100 151c-9.477 0-17.333 6.938-18.766 16.012C80.975 168.648 82.344 170 84 170h32c1.657 0 3.025-1.352 2.766-2.988C117.333 157.938 109.477 151 100 151Z",
                fill: "url(#paint6_linear_1153_42741)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                filter: "url(#filter0_i_1153_42741)",
                fillRule: "evenodd",
                clipRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M98.576 107.87a3 3 0 1 0 .257-4.235 3 3 0 0 0-.257 4.235Zm6.887 3.252a7.003 7.003 0 0 1-8.338.705l-4.45 3.941.645.729a1 1 0 0 1-.085 1.412l-1.498 1.326a1 1 0 0 1-1.411-.086l-.646-.729-2.216 1.963a2 2 0 1 1-2.652-2.994l9.661-8.556a7 7 0 1 1 10.99 2.289Z",
                        fill: "#FEDEAC"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M98.576 107.87a3 3 0 1 0 .257-4.235 3 3 0 0 0-.257 4.235Zm6.887 3.252a7.003 7.003 0 0 1-8.338.705l-4.45 3.941.645.729a1 1 0 0 1-.085 1.412l-1.498 1.326a1 1 0 0 1-1.411-.086l-.646-.729-2.216 1.963a2 2 0 1 1-2.652-2.994l9.661-8.556a7 7 0 1 1 10.99 2.289Z",
                        fill: "url(#paint7_linear_1153_42741)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 81,
                y: 176,
                width: 40,
                height: 34,
                rx: 3,
                fill: "url(#paint8_linear_1153_42741)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 113,
                y: 183,
                width: 4,
                height: 9,
                rx: 2,
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M33 224h138v-3a3 3 0 0 0-3-3H36a3 3 0 0 0-3 3v3Z",
                fill: "url(#paint9_linear_1153_42741)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M134 156h1.5a2 2 0 0 1 2 2v58a2 2 0 0 1-2 2H88l46-62Z",
                fill: "url(#paint10_linear_1153_42741)",
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: 0.5
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 137,
                y: 153,
                width: 94,
                height: 68,
                rx: 5,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 137,
                y: 153,
                width: 94,
                height: 68,
                rx: 5,
                stroke: "#7958FF",
                strokeWidth: 6
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 137,
                y: 153,
                width: 94,
                height: 68,
                rx: 5,
                stroke: "url(#paint11_linear_1153_42741)",
                strokeWidth: 6
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 162,
                y: 203,
                width: 44,
                height: 6,
                rx: 2,
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 162,
                y: 193,
                width: 44,
                height: 6,
                rx: 2,
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 172,
                y: 165,
                width: 24,
                height: 24,
                rx: 8,
                fill: "#FBF9FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 184,
                cy: 172,
                r: 4,
                fill: "#FDCF90"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M178 181a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-2Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m95.768 71.846 1.056-.866a3 3 0 0 1 3.804 0l1.057.866L171.5 129a3 3 0 0 1 .374 4.275l-1.302 1.516a3 3 0 0 1-4.178.365l-65.766-53.834a3 3 0 0 0-3.804 0l-65.718 53.834a3 3 0 0 1-4.177-.365l-1.302-1.516A3 3 0 0 1 26 129l69.768-57.154Z",
                fill: "url(#paint12_linear_1153_42741)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M212.345 34.5a.125.125 0 0 1 .171-.044l1.946 1.135c.06.035.08.112.045.171l-1.998 3.425 3.965.018c.07 0 .125.057.125.126l-.01 2.253c0 .069-.057.125-.126.124l-3.965-.017 1.967 3.442a.126.126 0 0 1-.047.171l-1.956 1.118a.126.126 0 0 1-.171-.047l-1.967-3.442-1.998 3.425a.125.125 0 0 1-.171.045l-1.946-1.136a.126.126 0 0 1-.045-.17l1.998-3.426-3.965-.018a.126.126 0 0 1-.125-.126l.011-2.253c0-.069.056-.124.125-.124l3.965.018-1.967-3.443a.125.125 0 0 1 .047-.171l1.956-1.118a.126.126 0 0 1 .171.047l1.967 3.443 1.998-3.425Z",
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m237.791 81-1.194 2.564a2.828 2.828 0 0 1-3.758 1.37v0a2.828 2.828 0 0 0-3.758 1.37v0a2.83 2.83 0 0 1-3.759 1.37v0a2.828 2.828 0 0 0-3.758 1.37l-1.194 2.563",
                stroke: "#CABEFF",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 6.421,
                height: 6.421,
                rx: 2,
                transform: "scale(-1 1) rotate(-40.65 61.962 61.412)",
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_1153_42741",
                        x1: 26.861,
                        y1: 223.869,
                        x2: 41.649,
                        y2: 140.844,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#C7BDE6"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E4DBFF",
                                stopOpacity: 0.16
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_1153_42741",
                        x1: 34.042,
                        y1: 59.039,
                        x2: 197.175,
                        y2: 112,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FFDDB5"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFEEDC",
                                stopOpacity: 0.7
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint2_linear_1153_42741",
                        x1: 180.807,
                        y1: 85,
                        x2: 180.807,
                        y2: 232.5,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FEFDFF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAF7FF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint3_linear_1153_42741",
                        x1: 137,
                        y1: 94.5,
                        x2: 59,
                        y2: 134,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#947DFF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#AF9EFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint4_linear_1153_42741",
                        x1: 58,
                        y1: 232,
                        x2: 152,
                        y2: 134,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#A896FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7958FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint5_linear_1153_42741",
                        x1: 86,
                        y1: 145,
                        x2: 127,
                        y2: 221,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#CABEFF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#947DFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint6_linear_1153_42741",
                        x1: 134.5,
                        y1: 159.382,
                        x2: 81,
                        y2: 159.382,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FFDDB5"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFCE94"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint7_linear_1153_42741",
                        x1: 100.535,
                        y1: 114.507,
                        x2: 90.816,
                        y2: 103.533,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FFDDB5"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFCE94"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint8_linear_1153_42741",
                        x1: 131,
                        y1: 191,
                        x2: 81,
                        y2: 191,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FFDDB5"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFCE94"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint9_linear_1153_42741",
                        x1: 32,
                        y1: 220.5,
                        x2: 139,
                        y2: 218,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#8366FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7A59FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint10_linear_1153_42741",
                        x1: 139.409,
                        y1: 184.414,
                        x2: 94.106,
                        y2: 215.483,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#E1CEE8"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFFBFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint11_linear_1153_42741",
                        x1: 203,
                        y1: 128.5,
                        x2: 141.012,
                        y2: 295.361,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint12_linear_1153_42741",
                        x1: 47.404,
                        y1: 102.84,
                        x2: 148.131,
                        y2: 102.84,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#8365FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#6C48FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("filter", {
                        id: "filter0_i_1153_42741",
                        x: 84.138,
                        y: 98.881,
                        width: 23.685,
                        height: 24.005,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feOffset", {
                                dy: 2
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feGaussianBlur", {
                                stdDeviation: 1
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: -1,
                                k3: 1
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feBlend", {
                                in2: "shape",
                                result: "effect1_innerShadow_1153_42741"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $eac5c7bacc4e2169$export$2e2bcd8739ae039 = $eac5c7bacc4e2169$var$SvgTenantLandingPage;




var $cDKfs = parcelRequire("cDKfs");

var $jGWQ4 = parcelRequire("jGWQ4");

var $66ixW = parcelRequire("66ixW");

var $jheqv = parcelRequire("jheqv");
var $ec2c08ee031e9eaa$export$2ba01fb71ed41cb6;
var $ec2c08ee031e9eaa$export$6d59db4903f20f7d;
var $ec2c08ee031e9eaa$export$5c452ff88e35e47d;
var $ec2c08ee031e9eaa$export$c7187bbd1a7a9244;
var $ec2c08ee031e9eaa$export$bfd64c937657f93a;
var $ec2c08ee031e9eaa$export$4a6dd88bada4e7d2;
var $ec2c08ee031e9eaa$export$fb184b623420d9be;
$ec2c08ee031e9eaa$export$2ba01fb71ed41cb6 = `XR1RoW_button`;
$ec2c08ee031e9eaa$export$6d59db4903f20f7d = `XR1RoW_description`;
$ec2c08ee031e9eaa$export$5c452ff88e35e47d = `XR1RoW_image`;
$ec2c08ee031e9eaa$export$c7187bbd1a7a9244 = `XR1RoW_placeholder`;
$ec2c08ee031e9eaa$export$bfd64c937657f93a = `XR1RoW_rotating`;
$ec2c08ee031e9eaa$export$4a6dd88bada4e7d2 = `XR1RoW_shimmer`;
$ec2c08ee031e9eaa$export$fb184b623420d9be = `XR1RoW_title`;


function $37385e5aa1ce316f$var$TenantLandingPageContent({ className: className }) {
    const { tenants: tenants, prependTenant: prependTenant, navigateTenant: navigateTenant } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const theme = (0, $jheqv.default)();
    const [isCreateModalOpen, setIsCreateModalOpen] = (0, $jC8Vy.useState)(false);
    if (tenants.length > 0) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($ec2c08ee031e9eaa$export$c7187bbd1a7a9244, className),
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $ec2c08ee031e9eaa$export$5c452ff88e35e47d,
                        children: theme === (0, $5HVJe.Theme).Light ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $eac5c7bacc4e2169$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0c53ef5ca97bb589$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $ec2c08ee031e9eaa$export$fb184b623420d9be,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: "tenants.tenant_landing_page.title"
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $ec2c08ee031e9eaa$export$6d59db4903f20f7d,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: "tenants.tenant_landing_page.description"
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        title: "tenants.tenant_landing_page.create_tenant_button",
                        type: "primary",
                        size: "large",
                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0b30fe81c923292b$export$2e2bcd8739ae039), {}),
                        className: $ec2c08ee031e9eaa$export$2ba01fb71ed41cb6,
                        onClick: ()=>{
                            setIsCreateModalOpen(true);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6b53fcc6297da1c8$export$2e2bcd8739ae039), {
                isOpen: isCreateModalOpen,
                onClose: async (tenant)=>{
                    setIsCreateModalOpen(false);
                    if (tenant) {
                        prependTenant(tenant);
                        navigateTenant(tenant.id);
                    }
                }
            })
        ]
    });
}
var $37385e5aa1ce316f$export$2e2bcd8739ae039 = $37385e5aa1ce316f$var$TenantLandingPageContent;


var $2cea6f6afaa3e85b$export$2ba01fb71ed41cb6;
var $2cea6f6afaa3e85b$export$6d59db4903f20f7d;
var $2cea6f6afaa3e85b$export$5c452ff88e35e47d;
var $2cea6f6afaa3e85b$export$9bfd64464b8f45a7;
var $2cea6f6afaa3e85b$export$c7187bbd1a7a9244;
var $2cea6f6afaa3e85b$export$bfd64c937657f93a;
var $2cea6f6afaa3e85b$export$4a6dd88bada4e7d2;
var $2cea6f6afaa3e85b$export$fb184b623420d9be;
$2cea6f6afaa3e85b$export$2ba01fb71ed41cb6 = `_81FlKG_button`;
$2cea6f6afaa3e85b$export$6d59db4903f20f7d = `_81FlKG_description`;
$2cea6f6afaa3e85b$export$5c452ff88e35e47d = `_81FlKG_image`;
$2cea6f6afaa3e85b$export$9bfd64464b8f45a7 = `_81FlKG_pageContainer`;
$2cea6f6afaa3e85b$export$c7187bbd1a7a9244 = `_81FlKG_placeholder`;
$2cea6f6afaa3e85b$export$bfd64c937657f93a = `_81FlKG_rotating`;
$2cea6f6afaa3e85b$export$4a6dd88bada4e7d2 = `_81FlKG_shimmer`;
$2cea6f6afaa3e85b$export$fb184b623420d9be = `_81FlKG_title`;


function $975c903dcd6201a3$var$TenantLandingPage() {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $2cea6f6afaa3e85b$export$9bfd64464b8f45a7,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8f0e3b0e6954789f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $37385e5aa1ce316f$export$2e2bcd8739ae039), {
                className: $2cea6f6afaa3e85b$export$c7187bbd1a7a9244
            })
        ]
    });
}
var $975c903dcd6201a3$export$2e2bcd8739ae039 = $975c903dcd6201a3$var$TenantLandingPage;


function $accf9be63f436e6f$export$2e2bcd8739ae039() {
    const { isLoaded: isLoaded } = (0, $8dc2d4d6918e57ba$export$2e2bcd8739ae039)();
    const { isOnboarding: isOnboarding } = (0, $ce45228420657e93$export$2e2bcd8739ae039)();
    const { defaultTenantId: defaultTenantId } = (0, $9d98b4fb971c2442$export$2e2bcd8739ae039)();
    const { data: data } = (0, $a0b535ac7bdefda9$export$2e2bcd8739ae039)((0, $61Yml.OrganizationInvitationStatus).Pending);
    if (!isLoaded) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4c070a72a1cf87ce$export$2e2bcd8739ae039), {});
    // A new user has just signed up, redirect them to the onboarding flow.
    if (isOnboarding) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Navigate), {
        to: (0, $cDKfs.GlobalRoute).Onboarding
    });
    // If current tenant ID is not set, but the defaultTenantId is available.
    if (defaultTenantId) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $11ca84f742810970$export$2e2bcd8739ae039), {
        toTenantId: defaultTenantId
    });
    // If user has pending invitations (onboarding will be skipped), show the invitation list and allow them to quick join.
    if ((0, $8TpMk.isCloud) && data?.length) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5a46e038250599de$export$2e2bcd8739ae039), {
        invitations: data
    });
    // If user has completed onboarding and still has no tenant, redirect to a special landing page.
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $975c903dcd6201a3$export$2e2bcd8739ae039), {});
}



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $6bq3s = parcelRequire("6bq3s");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $238bd383b42e71b0$var$SvgCongratsDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M128 208c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80Zm0-40c22.091 0 40-17.909 40-40s-17.909-40-40-40-40 17.909-40 40 17.909 40 40 40Z",
                fill: "#434966"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m71.32 82.22 3.73-4.254a5.657 5.657 0 0 0-.525-7.983v0A5.657 5.657 0 0 1 74 62v0a5.657 5.657 0 0 0-.525-7.983v0a5.657 5.657 0 0 1-.524-7.983l3.729-4.253",
                stroke: "#81A281",
                strokeWidth: 4,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 89,
                y: 44.156,
                width: 16,
                height: 16,
                rx: 4,
                transform: "rotate(-30.649 89 44.156)",
                fill: "#B68FB9"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#B6A2B8",
                d: "m217.074 72.576 6.506 4.655-4.654 6.506-6.507-4.655z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#B98EBC",
                d: "M142 128h24v24h-24z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M120.586 58a.16.16 0 0 1 .147-.234l17.91.638a.16.16 0 0 1 .13.244l-9.507 15.192a.16.16 0 0 1-.277-.01L120.586 58Z",
                fill: "#68BE6C"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M172.277 123.132a.208.208 0 0 1 .245-.264l22.691 5.205a.208.208 0 0 1 .106.344l-15.853 17.049a.208.208 0 0 1-.351-.081l-6.838-22.253Z",
                fill: "#85C086"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M104.663 86.334c0-.185.149-.334.334-.334h6.008c.184 0 .333.15.333.334v10.573l9.157-5.286a.334.334 0 0 1 .456.122l3.004 5.203a.333.333 0 0 1-.122.456l-9.157 5.287 9.156 5.287c.16.092.215.296.123.456l-3.004 5.203a.335.335 0 0 1-.456.122l-9.157-5.286v10.573a.334.334 0 0 1-.333.334h-6.008a.334.334 0 0 1-.334-.334V108.47l-9.158 5.287a.334.334 0 0 1-.456-.122l-3.004-5.203a.334.334 0 0 1 .123-.456l9.157-5.287-9.158-5.287a.334.334 0 0 1-.122-.456l3.004-5.203a.334.334 0 0 1 .456-.122l9.158 5.287V86.334Z",
                fill: "#7075CB"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M152.2 124.399c10.603 0 19.199-8.596 19.199-19.199 0-10.604-8.596-19.2-19.199-19.2-10.604 0-19.2 8.596-19.2 19.2 0 10.603 8.596 19.199 19.2 19.199Zm0-9.6a9.598 9.598 0 0 0 9.599-9.599 9.6 9.6 0 1 0-19.199 0c0 5.302 4.298 9.599 9.6 9.599Z",
                fill: "#EFD2AA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M40 64a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
                fill: "#948E86"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M218 41a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
                fill: "#AEA090"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M126.596 48a80.03 80.03 0 0 1 22.5 3.208c18.187 5.32 33.691 16.925 44 32.305m-5.279 95.987a80.4 80.4 0 0 1-23.221 18.916 79.431 79.431 0 0 1-15.5 6.376 80.02 80.02 0 0 1-22.5 3.208c-18.689 0-35.882-6.409-49.5-17.149C62.256 179.148 51.661 162.301 48 143m13.136-61a79.9 79.9 0 0 0-7.438 13 79.406 79.406 0 0 0-4.832 14",
                stroke: "#555D86",
                strokeWidth: 2,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M69.233 218.378c-.326 3.412 3.51 5.626 6.302 3.639l93.475-66.552c2.372-1.689 2.202-5.266-.32-6.722l-82.578-47.677c-2.522-1.456-5.705.185-5.981 3.085L69.233 218.378Z",
                fill: "url(#paint0_linear_277_11257)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "mask0_277_11257",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 69,
                y: 100,
                width: 102,
                height: 123,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    d: "M69.233 218.378c-.326 3.412 3.51 5.626 6.302 3.639l93.475-66.552c2.372-1.689 2.202-5.266-.32-6.722l-82.578-47.677c-2.522-1.456-5.705.186-5.981 3.085L69.233 218.378Z",
                    fill: "#AF9EFF"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                mask: "url(#mask0_277_11257)",
                fill: "#E0A1E9",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 57.255,
                        y: 123.748,
                        width: 128,
                        height: 16,
                        rx: 1.28
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 37.255,
                        y: 158.389,
                        width: 128,
                        height: 16,
                        rx: 1.28
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 17.255,
                        y: 193.03,
                        width: 128,
                        height: 16,
                        rx: 1.28
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m165.054 60.642 4.307-3.668A5.657 5.657 0 0 0 170 49v0a5.657 5.657 0 0 1 .64-7.974l4.306-3.668",
                stroke: "#8288A6",
                strokeWidth: 4,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m169 82.42 5.61.727a5.657 5.657 0 0 0 6.336-4.884v0a5.657 5.657 0 0 1 6.336-4.885v0a5.657 5.657 0 0 0 6.336-4.884v0a5.657 5.657 0 0 1 6.336-4.884l5.61.726",
                stroke: "#B0A7D9",
                strokeWidth: 4,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m122.186 33.626-1.365-5.49a5.657 5.657 0 0 1 4.125-6.855v0a5.656 5.656 0 0 0 4.125-6.854l-1.365-5.49",
                stroke: "#68617E",
                strokeWidth: 4,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m190.03 114.09 3.985-4.015a5.657 5.657 0 0 1 8-.03v0a5.657 5.657 0 0 0 8-.03L214 106",
                stroke: "#958CB2",
                strokeWidth: 4,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("defs", {
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                    id: "paint0_linear_277_11257",
                    x1: 67.5,
                    y1: 223.5,
                    x2: 173.05,
                    y2: 155.153,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            stopColor: "#5E49DC"
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            offset: 1,
                            stopColor: "#D279FC"
                        })
                    ]
                })
            })
        ]
    });
var $238bd383b42e71b0$export$2e2bcd8739ae039 = $238bd383b42e71b0$var$SvgCongratsDark;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $3375a03c502d1508$var$SvgCongrats = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M128 208c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80Zm0-40c22.091 0 40-17.909 40-40s-17.909-40-40-40-40 17.909-40 40 17.909 40 40 40Z",
                fill: "#5D34F2",
                fillOpacity: 0.06
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M51.13 109.731a78.572 78.572 0 0 1 11.711-26.39m64.241-34.335c.329-.004.659-.006.989-.006 27.079 0 50.979 13.602 65.229 34.341m-143 58.978C57.042 179.114 89.297 207 128.071 207c23.884 0 45.296-10.582 59.793-27.31",
                stroke: "#5D34F2",
                strokeOpacity: 0.08,
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m71.32 82.22 3.73-4.254a5.657 5.657 0 0 0-.525-7.983v0A5.657 5.657 0 0 1 74 62v0a5.657 5.657 0 0 0-.525-7.982v0a5.657 5.657 0 0 1-.524-7.983l3.729-4.254",
                stroke: "#FFD5FF",
                strokeWidth: 4,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 108,
                y: 62.156,
                width: 16,
                height: 16,
                rx: 4,
                transform: "rotate(-30.649 108 62.156)",
                fill: "#FFD5FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 217.074,
                y: 72.576,
                width: 8,
                height: 8,
                rx: 4,
                transform: "rotate(35.58 217.074 72.576)",
                fill: "#FFD5FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 142,
                y: 128,
                width: 24,
                height: 24,
                rx: 4,
                fill: "#FFD5FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M104.663 86.334c0-.185.149-.334.334-.334h6.008c.184 0 .333.15.333.334v10.573l9.157-5.286a.334.334 0 0 1 .456.122l3.004 5.203a.333.333 0 0 1-.122.456l-9.157 5.287 9.156 5.287c.16.092.215.296.123.456l-3.004 5.203a.335.335 0 0 1-.456.122l-9.157-5.287v10.574a.334.334 0 0 1-.333.334h-6.008a.334.334 0 0 1-.334-.334V108.47l-9.158 5.287a.334.334 0 0 1-.456-.122l-3.004-5.203a.334.334 0 0 1 .123-.456l9.157-5.287-9.158-5.287a.334.334 0 0 1-.122-.456l3.004-5.203a.334.334 0 0 1 .456-.122l9.158 5.287V86.334Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M152.2 124.399c10.603 0 19.199-8.596 19.199-19.199 0-10.604-8.596-19.2-19.199-19.2-10.604 0-19.2 8.596-19.2 19.2 0 10.603 8.596 19.199 19.2 19.199Zm0-9.6a9.598 9.598 0 0 0 9.599-9.599 9.6 9.6 0 1 0-19.199 0c0 5.302 4.298 9.599 9.6 9.599ZM40 64a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
                fill: "#FFB95A"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M218 41a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
                fill: "#FFDDB5"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M69.234 218.379c-.326 3.411 3.51 5.626 6.302 3.638l93.475-66.551c2.372-1.69 2.202-5.267-.32-6.723l-82.578-47.676c-2.522-1.456-5.705.185-5.981 3.084L69.234 218.379Z",
                fill: "url(#paint0_linear_8592_115169)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "mask0_8592_115169",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 69,
                y: 100,
                width: 102,
                height: 123,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    d: "M69.234 218.379c-.325 3.411 3.51 5.626 6.302 3.638l93.475-66.551c2.373-1.69 2.202-5.267-.32-6.723l-82.577-47.676c-2.523-1.456-5.706.185-5.982 3.084L69.234 218.379Z",
                    fill: "#AF9EFF"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                mask: "url(#mask0_8592_115169)",
                fill: "#EA9DF4",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 57.256,
                        y: 123.748,
                        width: 128,
                        height: 16,
                        rx: 1.28
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 37.256,
                        y: 158.39,
                        width: 128,
                        height: 16,
                        rx: 1.28
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 17.256,
                        y: 193.03,
                        width: 128,
                        height: 16,
                        rx: 1.28
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m165.055 60.642 4.307-3.668a5.657 5.657 0 0 0 .639-7.974v0a5.658 5.658 0 0 1 .639-7.975l4.307-3.667",
                stroke: "#C4C7C7",
                strokeWidth: 4,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m169 82.42 5.61.727a5.657 5.657 0 0 0 6.336-4.884v0a5.657 5.657 0 0 1 6.336-4.885v0a5.657 5.657 0 0 0 6.336-4.884v0a5.657 5.657 0 0 1 6.336-4.884l5.61.726",
                stroke: "#CABEFF",
                strokeWidth: 4,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m122.186 33.626-1.365-5.49a5.657 5.657 0 0 1 4.125-6.854v0a5.656 5.656 0 0 0 4.125-6.855l-1.365-5.49M192.031 144.091l3.985-4.015a5.656 5.656 0 0 1 8-.03v0a5.657 5.657 0 0 0 8-.03l3.985-4.015",
                stroke: "#E6DEFF",
                strokeWidth: 4,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("defs", {
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                    id: "paint0_linear_8592_115169",
                    x1: 67.501,
                    y1: 223.5,
                    x2: 173.051,
                    y2: 155.154,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            stopColor: "#492EF3"
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            offset: 1,
                            stopColor: "#CF69FF"
                        })
                    ]
                })
            })
        ]
    });
var $3375a03c502d1508$export$2e2bcd8739ae039 = $3375a03c502d1508$var$SvgCongrats;



var $gC7hG = parcelRequire("gC7hG");

var $jheqv = parcelRequire("jheqv");
var $7cc15368498d74bd$export$aa3e815946b80764;
var $7cc15368498d74bd$export$34e0f9847d4c02dd;
var $7cc15368498d74bd$export$a8ecead220dd38a6;
var $7cc15368498d74bd$export$bfd64c937657f93a;
var $7cc15368498d74bd$export$4a6dd88bada4e7d2;
var $7cc15368498d74bd$export$fb184b623420d9be;
$7cc15368498d74bd$export$aa3e815946b80764 = `k1s4KG_card`;
$7cc15368498d74bd$export$34e0f9847d4c02dd = `k1s4KG_container`;
$7cc15368498d74bd$export$a8ecead220dd38a6 = `k1s4KG_message`;
$7cc15368498d74bd$export$bfd64c937657f93a = `k1s4KG_rotating`;
$7cc15368498d74bd$export$4a6dd88bada4e7d2 = `k1s4KG_shimmer`;
$7cc15368498d74bd$export$fb184b623420d9be = `k1s4KG_title`;


function $0df1998aecbc1063$var$SocialDemoCallback() {
    const theme = (0, $jheqv.default)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [searchParams, setSearchParams] = (0, $6bq3s.useSearchParams)();
    (0, $jC8Vy.useEffect)(()=>{
        // Social callback will have "code" in query params
        if (searchParams.get("code")) setSearchParams({}, {
            replace: true
        });
    }, [
        searchParams,
        setSearchParams
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: $7cc15368498d74bd$export$34e0f9847d4c02dd,
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
            className: $7cc15368498d74bd$export$aa3e815946b80764,
            children: [
                theme === (0, $5HVJe.Theme).Light ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3375a03c502d1508$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $238bd383b42e71b0$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $7cc15368498d74bd$export$fb184b623420d9be,
                    children: t("cloud.socialCallback.title")
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $7cc15368498d74bd$export$a8ecead220dd38a6,
                    children: t("cloud.socialCallback.description")
                })
            ]
        })
    });
}
var $0df1998aecbc1063$export$2e2bcd8739ae039 = $0df1998aecbc1063$var$SocialDemoCallback;


/** Renders necessary routes when the user is not in a tenant context. */ function $253b729e263dcec4$var$AppRoutes() {
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: $a65469f7a8fcde27$export$729c8b7179294ba,
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $2Phw0.Routes), {
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Route), {
                    path: (0, $cDKfs.GlobalAnonymousRoute).Callback,
                    element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5a59246c75af7fcf$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Route), {
                    path: (0, $cDKfs.GlobalAnonymousRoute).SocialDemoCallback,
                    element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0df1998aecbc1063$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $2Phw0.Route), {
                    element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0479ccdfd7d68c85$export$2e2bcd8739ae039), {}),
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Route), {
                            path: `${(0, $cDKfs.GlobalRoute).AcceptInvitation}/:invitationId`,
                            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cd7c7eae25a1591f$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Route), {
                            path: (0, $cDKfs.GlobalRoute).Profile + "/*",
                            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $22925f126a88c229$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Route), {
                            path: (0, $cDKfs.GlobalRoute).HandleSocial,
                            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e6413a98707bc5cf$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Route), {
                            path: (0, $cDKfs.GlobalRoute).CheckoutSuccessCallback,
                            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $99b45a51a5273fbc$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Route), {
                            path: (0, $cDKfs.GlobalRoute).Onboarding + "/*",
                            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c47a9066647cd7e1$export$1b74a30f1aaea892), {})
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Route), {
                            index: true,
                            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $accf9be63f436e6f$export$2e2bcd8739ae039), {})
                        })
                    ]
                })
            ]
        })
    });
}
var $253b729e263dcec4$export$2e2bcd8739ae039 = $253b729e263dcec4$var$AppRoutes;




var $8TpMk = parcelRequire("8TpMk");

var $7YcaX = parcelRequire("7YcaX");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $fjAdn = parcelRequire("fjAdn");

var $2Phw0 = parcelRequire("2Phw0");

var $voszV = parcelRequire("voszV");

var $8TpMk = parcelRequire("8TpMk");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");
var $gcHb7 = parcelRequire("gcHb7");

var $jC8Vy = parcelRequire("jC8Vy");

var $2Phw0 = parcelRequire("2Phw0");



var $8TpMk = parcelRequire("8TpMk");

parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("8Mb3E");
var $ku6YN = parcelRequire("ku6YN");

var $8TpMk = parcelRequire("8TpMk");

var $cDKfs = parcelRequire("cDKfs");

var $voszV = parcelRequire("voszV");


var $8TpMk = parcelRequire("8TpMk");
const $8fae22730cefa722$var$useSubscription = (tenantId)=>{
    const cloudApi = (0, $1c34cc51be8c93d3$export$7a5c900790855d66)();
    return (0, $voszV.default)(// `tenantId` could be an empty string which may cause the request to fail
    (0, $8TpMk.isCloud) && tenantId && `/api/tenants/${tenantId}/subscription`, async ()=>cloudApi.get("/api/tenants/:tenantId/subscription", {
            params: {
                tenantId: tenantId
            }
        }));
};
var $8fae22730cefa722$export$2e2bcd8739ae039 = $8fae22730cefa722$var$useSubscription;



const $480e7e0d8d19d84c$var$useSubscriptionData = ()=>{
    const { currentTenant: currentTenant } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { isLoading: isSubscriptionPlansLoading, data: fetchedPlans } = (0, $807aaa3ea0f45a20$export$2e2bcd8739ae039)();
    const { data: currentSubscription, isLoading: isSubscriptionLoading, mutate: mutateSubscription } = (0, $8fae22730cefa722$export$2e2bcd8739ae039)((0, $7oDSS.condString)(currentTenant?.id));
    const subscriptionPlans = (0, $jC8Vy.useMemo)(()=>(0, $7oDSS.cond)((0, $8TpMk.isCloud) && fetchedPlans) ?? [], [
        fetchedPlans
    ]);
    const currentPlan = (0, $jC8Vy.useMemo)(()=>subscriptionPlans.find((plan)=>plan.id === currentTenant?.planId) ?? (0, $ku6YN.defaultSubscriptionPlan), [
        currentTenant?.planId,
        subscriptionPlans
    ]);
    return {
        isLoading: isSubscriptionLoading || isSubscriptionPlansLoading,
        subscriptionPlans: subscriptionPlans,
        currentPlan: currentPlan,
        currentSubscription: currentSubscription ?? (0, $ku6YN.defaultTenantResponse).subscription,
        onCurrentSubscriptionUpdated: mutateSubscription
    };
};
var $480e7e0d8d19d84c$export$2e2bcd8739ae039 = $480e7e0d8d19d84c$var$useSubscriptionData;



var $cDKfs = parcelRequire("cDKfs");

var $95YIy = parcelRequire("95YIy");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $aTllQ = parcelRequire("aTllQ");

var $4ZcUR = parcelRequire("4ZcUR");

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $6bq3s = parcelRequire("6bq3s");
var $2e0e863c849833bd$export$2e2bcd8739ae039 = $2e0e863c849833bd$var$kebabCase;
/*
  kebabCase('the quick brown fox'); // 'the-quick-brown-fox'
  kebabCase('the-quick-brown-fox'); // 'the-quick-brown-fox'
  kebabCase('the_quick_brown_fox'); // 'the-quick-brown-fox'
  kebabCase('theQuickBrownFox'); // 'the-quick-brown-fox'
  kebabCase('theQuickBrown Fox'); // 'the-quick-brown-fox'
  kebabCase('thequickbrownfox'); // 'thequickbrownfox'
  kebabCase('the - quick * brown# fox'); // 'the-quick-brown-fox'
  kebabCase('theQUICKBrownFox'); // 'the-quick-brown-fox'
*/ // any combination of spaces and punctuation characters
// thanks to http://stackoverflow.com/a/25575009
var $2e0e863c849833bd$var$wordSeparators = /[\s\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,\-.\/:;<=>?@\[\]^_`{|}~]+/;
var $2e0e863c849833bd$var$capital_plus_lower = /[A-ZÀ-Ý\u00C0-\u00D6\u00D9-\u00DD][a-zà-ÿ]/g;
var $2e0e863c849833bd$var$capitals = /[A-ZÀ-Ý\u00C0-\u00D6\u00D9-\u00DD]+/g;
function $2e0e863c849833bd$var$kebabCase(str) {
    // replace word starts with space + lower case equivalent for later parsing
    // 1) treat cap + lower as start of new word
    str = str.replace($2e0e863c849833bd$var$capital_plus_lower, function(match) {
        // match is one caps followed by one non-cap
        return " " + (match[0].toLowerCase() || match[0]) + match[1];
    });
    // 2) treat all remaining capitals as words
    str = str.replace($2e0e863c849833bd$var$capitals, function(match) {
        // match is a series of caps
        return " " + match.toLowerCase();
    });
    return str.trim().split($2e0e863c849833bd$var$wordSeparators).join("-").replace(/^-/, "").replace(/-\s*$/, "");
}


const $698f86671730b31d$export$2aa3fd96c49a84a8 = (title)=>(0, $2e0e863c849833bd$export$2e2bcd8739ae039)(title);


var $0ae42ef975af7f01$export$89da14300d534261;
var $0ae42ef975af7f01$export$1ca1ec8b29a4ce27;
var $0ae42ef975af7f01$export$bfd64c937657f93a;
var $0ae42ef975af7f01$export$120ff0929b202a6d;
var $0ae42ef975af7f01$export$4a6dd88bada4e7d2;
var $0ae42ef975af7f01$export$fb184b623420d9be;
$0ae42ef975af7f01$export$89da14300d534261 = `SoD9uq_active`;
$0ae42ef975af7f01$export$1ca1ec8b29a4ce27 = `SoD9uq_icon`;
$0ae42ef975af7f01$export$bfd64c937657f93a = `SoD9uq_rotating`;
$0ae42ef975af7f01$export$120ff0929b202a6d = `SoD9uq_row`;
$0ae42ef975af7f01$export$4a6dd88bada4e7d2 = `SoD9uq_shimmer`;
$0ae42ef975af7f01$export$fb184b623420d9be = `SoD9uq_title`;


function $14b7c3cf8270d822$var$Item({ icon: icon, titleKey: titleKey, modal: modal, externalLink: externalLink, isActive: isActive = false }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.tabs"
    });
    const [isOpen, setIsOpen] = (0, $jC8Vy.useState)(false);
    const content = (0, $jC8Vy.useMemo)(()=>/*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
            children: [
                icon && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $0ae42ef975af7f01$export$1ca1ec8b29a4ce27,
                    children: icon
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $0ae42ef975af7f01$export$fb184b623420d9be,
                    children: t(titleKey)
                })
            ]
        }), [
        icon,
        t,
        titleKey
    ]);
    if (modal) return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("button", {
                className: $0ae42ef975af7f01$export$120ff0929b202a6d,
                onClick: ()=>{
                    setIsOpen(true);
                },
                children: content
            }),
            modal(isOpen, ()=>{
                setIsOpen(false);
            })
        ]
    });
    if (externalLink) return /*#__PURE__*/ (0, $C7mD2.jsx)("a", {
        href: externalLink,
        target: "_blank",
        className: $0ae42ef975af7f01$export$120ff0929b202a6d,
        rel: "noopener",
        children: content
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6bq3s.Link), {
        to: (0, $698f86671730b31d$export$2aa3fd96c49a84a8)(titleKey),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($0ae42ef975af7f01$export$120ff0929b202a6d, isActive && $0ae42ef975af7f01$export$89da14300d534261),
        children: content
    });
}
var $14b7c3cf8270d822$export$2e2bcd8739ae039 = $14b7c3cf8270d822$var$Item;



var $C7mD2 = parcelRequire("C7mD2");
var $fc6c12319dc7cd7c$export$bfd64c937657f93a;
var $fc6c12319dc7cd7c$export$4a6dd88bada4e7d2;
var $fc6c12319dc7cd7c$export$fb184b623420d9be;
$fc6c12319dc7cd7c$export$bfd64c937657f93a = `s9DuQG_rotating`;
$fc6c12319dc7cd7c$export$4a6dd88bada4e7d2 = `s9DuQG_shimmer`;
$fc6c12319dc7cd7c$export$fb184b623420d9be = `s9DuQG_title`;


function $ebeda71cd4e6b15b$var$Section({ children: children, title: title }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $fc6c12319dc7cd7c$export$fb184b623420d9be,
                children: title
            }),
            children
        ]
    });
}
var $ebeda71cd4e6b15b$export$2e2bcd8739ae039 = $ebeda71cd4e6b15b$var$Section;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $538b8df2809ea470$var$SvgBarGraph = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M12 6a1 1 0 0 0-1 1v10a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1Zm-5 6a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0v-4a1 1 0 0 0-1-1Zm10-2a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0v-6a1 1 0 0 0-1-1Zm2-8H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3Zm1 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v14Z",
            fill: "currentColor"
        })
    });
var $538b8df2809ea470$export$2e2bcd8739ae039 = $538b8df2809ea470$var$SvgBarGraph;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $07bccf54c09b2c98$var$SvgBolt = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M19.89 9.55A1 1 0 0 0 19 9h-5V3a1 1 0 0 0-1.309-1.002 1 1 0 0 0-.501.362l-8 11a1 1 0 0 0-.08 1A1 1 0 0 0 5 15h5v6a1 1 0 0 0 1.81.59l8-11a1 1 0 0 0 .08-1.04ZM12 17.92V14a1 1 0 0 0-1-1H7l5-6.92V10a1 1 0 0 0 1 1h4l-5 6.92Z",
            fill: "currentColor"
        })
    });
var $07bccf54c09b2c98$export$2e2bcd8739ae039 = $07bccf54c09b2c98$var$SvgBolt;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $1ab8d29d73cc7096$var$SvgBox = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M20.47 7.37v-.08l-.06-.15a.712.712 0 0 0-.07-.09.93.93 0 0 0-.09-.12l-.09-.07-.16-.08-7.5-4.63a1 1 0 0 0-1.06 0L4 6.78l-.09.08-.09.07a.94.94 0 0 0-.09.12.71.71 0 0 0-.07.09l-.06.15v.08a1.15 1.15 0 0 0 0 .26v8.74a1 1 0 0 0 .47.85l7.5 4.63a.466.466 0 0 0 .15.06h.08a.86.86 0 0 0 .52 0h.08a.465.465 0 0 0 .15-.06L20 17.22a1 1 0 0 0 .47-.85V7.63c.01-.086.01-.174 0-.26ZM11 19.21l-5.5-3.4V9.43l5.5 3.39v6.39Zm1-8.12L6.4 7.63 12 4.18l5.6 3.45-5.6 3.46Zm6.5 4.72-5.5 3.4v-6.39l5.5-3.39v6.38Z",
            fill: "currentColor"
        })
    });
var $1ab8d29d73cc7096$export$2e2bcd8739ae039 = $1ab8d29d73cc7096$var$SvgBox;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $2a96bd734f8130a2$var$SvgConnection = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M20.52 3.87a5 5 0 0 0-9.08.13H7a3 3 0 0 0-3 3v4a1 1 0 1 0 2 0V7a1 1 0 0 1 1-1h2.78A3 3 0 0 0 9 8a3 3 0 0 0 3 3h7.33a3.66 3.66 0 0 0 1.19-7.13ZM19.33 9H12a1 1 0 1 1 0-2 1 1 0 0 0 1-1 3 3 0 0 1 5.84-1 1 1 0 0 0 .78.67A1.65 1.65 0 0 1 21 7.33 1.67 1.67 0 0 1 19.33 9ZM19 13a1 1 0 0 0-1 1v3a1 1 0 0 1-1 1h-2.26a3.662 3.662 0 0 0-2.22-2.13 5 5 0 0 0-9.45 1.28A3 3 0 0 0 4 23h7.33a3.66 3.66 0 0 0 3.6-3H17a3 3 0 0 0 3-3v-3a1 1 0 0 0-1-1Zm-7.67 8H4a1 1 0 1 1 0-2 1 1 0 0 0 1-1 3 3 0 0 1 5.84-1 1 1 0 0 0 .78.67A1.65 1.65 0 0 1 13 19.33 1.67 1.67 0 0 1 11.33 21Z",
            fill: "currentColor"
        })
    });
var $2a96bd734f8130a2$export$2e2bcd8739ae039 = $2a96bd734f8130a2$var$SvgConnection;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $52d012a4456501b3$var$SvgGear = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "m17.767 7.958-1.575-.525.741-1.483a.834.834 0 0 0-.158-.95L15 3.225a.834.834 0 0 0-.958-.158l-1.484.741-.525-1.575a.833.833 0 0 0-.783-.566h-2.5a.833.833 0 0 0-.792.566l-.525 1.575-1.483-.741a.833.833 0 0 0-.95.158L3.225 5a.833.833 0 0 0-.158.958l.741 1.484-1.575.525a.833.833 0 0 0-.566.783v2.5a.834.834 0 0 0 .566.792l1.575.525-.741 1.483a.833.833 0 0 0 .158.95L5 16.775a.834.834 0 0 0 .958.158l1.484-.741.525 1.575a.834.834 0 0 0 .791.566h2.5a.834.834 0 0 0 .792-.566l.525-1.575 1.483.741a.833.833 0 0 0 .942-.158L16.775 15a.834.834 0 0 0 .158-.958l-.741-1.484 1.575-.525a.834.834 0 0 0 .566-.783v-2.5a.833.833 0 0 0-.566-.792Zm-1.1 2.692-1 .333a1.666 1.666 0 0 0-.967 2.35l.475.95-.917.917-.925-.5a1.667 1.667 0 0 0-2.325.967l-.333 1H9.35l-.333-1a1.667 1.667 0 0 0-2.35-.967l-.95.475-.917-.917.5-.925a1.667 1.667 0 0 0-.967-2.35l-1-.333v-1.3l1-.333a1.667 1.667 0 0 0 .967-2.35l-.475-.925.917-.917.925.475a1.667 1.667 0 0 0 2.35-.967l.333-1h1.3l.333 1a1.666 1.666 0 0 0 2.35.967l.95-.475.917.917-.5.925a1.666 1.666 0 0 0 .967 2.325l1 .333v1.325ZM10 6.667a3.333 3.333 0 1 0 0 6.666 3.333 3.333 0 0 0 0-6.666Zm0 5a1.666 1.666 0 1 1 0-3.333 1.666 1.666 0 0 1 0 3.333Z",
            fill: "currentColor"
        })
    });
var $52d012a4456501b3$export$2e2bcd8739ae039 = $52d012a4456501b3$var$SvgGear;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $3b861fe29e4a5e6f$var$SvgHook = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M12.549 6.149a.839.839 0 0 0 1.676-.064A4.214 4.214 0 1 0 7.222 9.4l-2.146 3.716a.839.839 0 1 0 1.452.839l2.524-4.371a.839.839 0 0 0-.307-1.146 2.537 2.537 0 1 1 3.804-2.29Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M11.81 16.354a.839.839 0 0 1 1.133-.35 2.537 2.537 0 1 0-.082-4.44.839.839 0 0 1-1.145-.307l-2.523-4.37a.839.839 0 0 1 1.452-.84l2.146 3.718a4.215 4.215 0 0 1 3.446 7.645 4.211 4.211 0 0 1-4.076.077.839.839 0 0 1-.35-1.133Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M4.795 10.456a.839.839 0 0 1-.263 1.156 2.537 2.537 0 1 0 3.886 2.149c0-.463.375-.838.838-.838h5.047a.838.838 0 1 1 0 1.677h-4.292a4.215 4.215 0 0 1-8.344-.839c0-1.504.789-2.823 1.971-3.568a.839.839 0 0 1 1.157.263Z",
                fill: "currentColor"
            })
        ]
    });
var $3b861fe29e4a5e6f$export$2e2bcd8739ae039 = $3b861fe29e4a5e6f$var$SvgHook;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $c3e0442675ff21c8$var$SvgJwtClaims = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 17,
        height: 18,
        viewBox: "0 0 17 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M10.128 8.166h-.834v-.833a.833.833 0 0 0-1.666 0v.833h-.834a.833.833 0 0 0 0 1.667h.834v.833a.833.833 0 0 0 1.666 0v-.833h.834a.833.833 0 0 0 0-1.667Zm6.425.242L14.594 6.5V3.7a.833.833 0 0 0-.833-.834h-2.758L9.053.908a.833.833 0 0 0-1.184 0L5.961 2.866h-2.8a.833.833 0 0 0-.833.834v2.8L.369 8.408a.833.833 0 0 0 0 1.183l1.959 1.95V14.3a.833.833 0 0 0 .833.833h2.8l1.95 1.959a.833.833 0 0 0 1.183 0l1.95-1.959h2.759a.833.833 0 0 0 .833-.833V11.54l1.958-1.95a.834.834 0 0 0-.041-1.183Zm-3.375 2.2a.835.835 0 0 0-.25.592v2.267H10.66a.83.83 0 0 0-.592.25l-1.608 1.608-1.608-1.608a.832.832 0 0 0-.592-.25H3.994V11.2a.833.833 0 0 0-.25-.592L2.136 9 3.744 7.39a.833.833 0 0 0 .25-.591V4.533h2.267a.834.834 0 0 0 .592-.25L8.46 2.675l1.608 1.608a.833.833 0 0 0 .592.25h2.267V6.8a.834.834 0 0 0 .25.591L14.786 9l-1.608 1.608Z",
            fill: "currentcolor"
        })
    });
var $c3e0442675ff21c8$export$2e2bcd8739ae039 = $c3e0442675ff21c8$var$SvgJwtClaims;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $309f7e69d6e65bdc$var$SvgKey = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "m17.5 3.667.583-.584a.806.806 0 0 0 0-1.166.806.806 0 0 0-1.166 0l-8.75 8.75A4.48 4.48 0 0 0 5.832 10a4.126 4.126 0 0 0-4.167 4.167 4.126 4.126 0 0 0 4.167 4.166A4.126 4.126 0 0 0 10 14.167a4.48 4.48 0 0 0-.667-2.334L14 7.167l1.75 1.75a.806.806 0 0 0 1.166 0 .806.806 0 0 0 0-1.167L15.166 6l1.167-1.167.584.584a.806.806 0 0 0 1.166 0 .806.806 0 0 0 0-1.167l-.583-.583Zm-11.667 13c-1.417 0-2.5-1.084-2.5-2.5 0-1.417 1.083-2.5 2.5-2.5s2.5 1.083 2.5 2.5c0 1.416-1.083 2.5-2.5 2.5Z",
            fill: "currentColor"
        })
    });
var $309f7e69d6e65bdc$export$2e2bcd8739ae039 = $309f7e69d6e65bdc$var$SvgKey;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $b71760af128d3f01$var$SvgList = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M7.5 8h14c.6 0 1-.4 1-1s-.4-1-1-1h-14c-.6 0-1 .4-1 1s.4 1 1 1Zm14 3h-10c-.6 0-1 .4-1 1s.4 1 1 1h10c.6 0 1-.4 1-1s-.4-1-1-1Zm0 5h-6c-.6 0-1 .4-1 1s.4 1 1 1h6c.6 0 1-.4 1-1s-.4-1-1-1ZM3.5 6c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1Zm4 5c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1Zm4 5c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1Z",
            fill: "currentColor"
        })
    });
var $b71760af128d3f01$export$2e2bcd8739ae039 = $b71760af128d3f01$var$SvgList;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $6ae35afac1070e51$var$SvgOrganizationTemplateFeature = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M11.083 10.183a4.1 4.1 0 0 0 1.417-3.1 4.166 4.166 0 1 0-8.334 0 4.1 4.1 0 0 0 1.417 3.1 6.666 6.666 0 0 0-3.917 6.067.833.833 0 1 0 1.667 0 5 5 0 0 1 10 0 .834.834 0 1 0 1.667 0 6.666 6.666 0 0 0-3.917-6.067Zm-2.75-.6a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Zm9.758-1.975a.833.833 0 0 0-1.183 0l-1.667 1.667-.516-.525a.833.833 0 1 0-1.184 1.175l1.117 1.116a.833.833 0 0 0 1.175 0l2.225-2.225a.834.834 0 0 0 .034-1.208Z",
            fill: "currentColor"
        })
    });
var $6ae35afac1070e51$export$2e2bcd8739ae039 = $6ae35afac1070e51$var$SvgOrganizationTemplateFeature;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $79630b4f411e197e$var$SvgOrganization = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.333 3.333v3.333h3.334V3.333H8.333ZM7.5 1.666a.833.833 0 0 0-.833.834v5c0 .46.373.833.833.833h1.667v.833H5.833c-.92 0-1.666.747-1.666 1.667v.833H2.5a.833.833 0 0 0-.833.834v5c0 .46.373.833.833.833h5c.46 0 .833-.373.833-.833v-5a.833.833 0 0 0-.833-.834H5.833v-.833h8.334v.833H12.5a.833.833 0 0 0-.833.834v5c0 .46.373.833.833.833h5c.46 0 .833-.373.833-.833v-5a.833.833 0 0 0-.833-.834h-1.667v-.833c0-.92-.746-1.667-1.666-1.667h-3.334v-.833H12.5c.46 0 .833-.373.833-.833v-5a.833.833 0 0 0-.833-.833h-5ZM3.333 13.334v3.333h3.334v-3.333H3.333Zm10 3.333v-3.333h3.334v3.333h-3.334Z",
            fill: "currentColor"
        })
    });
var $79630b4f411e197e$export$2e2bcd8739ae039 = $79630b4f411e197e$var$SvgOrganization;




var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $49a1041a43011cc6$var$SvgResource = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M22.5 14.5a2 2 0 0 0-2-2h-6a2 2 0 0 0-2 2h-3v-3h2.33A3.66 3.66 0 0 0 13 4.37a5 5 0 0 0-9.43 1.28 3 3 0 0 0 .93 5.85h3v8a1 1 0 0 0 1 1h4a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-2a2.001 2.001 0 0 0-.28-1c.18-.303.276-.648.28-1v-2Zm-18-5a1 1 0 1 1 0-2 1 1 0 0 0 1-1 3 3 0 0 1 5.84-1 1 1 0 0 0 .78.66 1.65 1.65 0 0 1 1.38 1.67 1.67 1.67 0 0 1-1.67 1.67H4.5Zm8 9h-3v-2h3a2 2 0 0 0 .28 1 2 2 0 0 0-.28 1Zm2 2v-2h6v2h-6Zm0-4v-2h6v2h-6Z",
            fill: "currentColor"
        })
    });
var $49a1041a43011cc6$export$2e2bcd8739ae039 = $49a1041a43011cc6$var$SvgResource;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $af810b9fbc6c48f1$var$SvgRole = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M12.342 10.233c.527-.566.824-1.309.833-2.083a3.15 3.15 0 0 0-6.3 0c.009.774.306 1.517.833 2.083A4.95 4.95 0 0 0 5 14.075a.838.838 0 0 0 1.667.183 3.333 3.333 0 0 1 6.616 0 .833.833 0 0 0 .884.742h.091a.833.833 0 0 0 .734-.917 4.95 4.95 0 0 0-2.65-3.85ZM10 9.633a1.483 1.483 0 1 1 0-2.966 1.483 1.483 0 0 1 0 2.966Zm5.833-7.966H4.167a2.5 2.5 0 0 0-2.5 2.5v11.666a2.5 2.5 0 0 0 2.5 2.5h11.666a2.5 2.5 0 0 0 2.5-2.5V4.167a2.5 2.5 0 0 0-2.5-2.5Zm.834 14.166a.833.833 0 0 1-.834.834H4.167a.833.833 0 0 1-.834-.834V4.167a.833.833 0 0 1 .834-.834h11.666a.833.833 0 0 1 .834.834v11.666Z",
            fill: "currentColor"
        })
    });
var $af810b9fbc6c48f1$export$2e2bcd8739ae039 = $af810b9fbc6c48f1$var$SvgRole;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $0a56311b0fd02a80$var$SvgSecurityLock = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M10 10.833a1.242 1.242 0 0 0-.833 2.175v1.159a.833.833 0 0 0 1.666 0v-1.159A1.241 1.241 0 0 0 10 10.833ZM14.167 7.5V5.833a4.167 4.167 0 1 0-8.334 0V7.5a2.5 2.5 0 0 0-2.5 2.5v5.833a2.5 2.5 0 0 0 2.5 2.5h8.334a2.5 2.5 0 0 0 2.5-2.5V10a2.5 2.5 0 0 0-2.5-2.5ZM7.5 5.833a2.5 2.5 0 1 1 5 0V7.5h-5V5.833Zm7.5 10a.833.833 0 0 1-.833.834H5.833A.833.833 0 0 1 5 15.833V10a.833.833 0 0 1 .833-.833h8.334A.833.833 0 0 1 15 10v5.833Z",
            fill: "currentColor"
        })
    });
var $0a56311b0fd02a80$export$2e2bcd8739ae039 = $0a56311b0fd02a80$var$SvgSecurityLock;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $3858edadf3eb6681$var$SvgSingleSignOn = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.849 3.659a5.833 5.833 0 0 1 2.501 2.764 4.167 4.167 0 0 1 2.984 3.983 4.166 4.166 0 0 1-2.075 3.608.836.836 0 1 1-.834-1.45 2.5 2.5 0 0 0-.833-4.608.833.833 0 0 1-.65-.558 4.167 4.167 0 0 0-8.108 1.341.833.833 0 0 1-.834.834 1.667 1.667 0 0 0-1.666 1.666 1.667 1.667 0 0 0 1.1 1.517.844.844 0 0 1-.267 1.667.942.942 0 0 1-.267-.042 3.333 3.333 0 0 1 .317-6.383 5.833 5.833 0 0 1 8.632-4.339Zm1.49 6.503a.833.833 0 1 0-1.178-1.179l-3.482 3.482a2.5 2.5 0 1 0 1.03 1.327l2-2 .452.453a.833.833 0 1 0 1.178-1.179l-.452-.452.452-.453Zm-5.172 4.41a.833.833 0 1 1-1.667 0 .833.833 0 0 1 1.667 0Z",
            fill: "currentColor"
        })
    });
var $3858edadf3eb6681$export$2e2bcd8739ae039 = $3858edadf3eb6681$var$SvgSingleSignOn;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $f296f9ce5eb05f6c$var$SvgWeb = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M10 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM6 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm8 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm6-4H4a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3Zm1 19a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-9h18v9Zm0-11H3V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v5Z",
            fill: "currentColor"
        })
    });
var $f296f9ce5eb05f6c$export$2e2bcd8739ae039 = $f296f9ce5eb05f6c$var$SvgWeb;



var $8TpMk = parcelRequire("8TpMk");
const $290219f9f98d0883$var$findFirstItem = (sections)=>{
    for (const section of sections){
        const found = section.items.find((item)=>!item.isHidden);
        if (found) return found;
    }
};
const $290219f9f98d0883$export$74c84f4d9513e4e1 = ()=>{
    const allSections = [
        {
            title: "overview",
            items: [
                {
                    Icon: (0, $07bccf54c09b2c98$export$2e2bcd8739ae039),
                    title: "get_started"
                },
                {
                    Icon: (0, $538b8df2809ea470$export$2e2bcd8739ae039),
                    title: "dashboard"
                }
            ]
        },
        {
            title: "authentication",
            items: [
                {
                    Icon: (0, $1ab8d29d73cc7096$export$2e2bcd8739ae039),
                    title: "applications"
                },
                {
                    Icon: (0, $f296f9ce5eb05f6c$export$2e2bcd8739ae039),
                    title: "sign_in_experience"
                },
                {
                    Icon: (0, $0a56311b0fd02a80$export$2e2bcd8739ae039),
                    title: "mfa"
                },
                {
                    Icon: (0, $2a96bd734f8130a2$export$2e2bcd8739ae039),
                    title: "connectors"
                },
                {
                    Icon: (0, $3858edadf3eb6681$export$2e2bcd8739ae039),
                    title: "enterprise_sso"
                }
            ]
        },
        {
            title: "authorization",
            items: [
                {
                    Icon: (0, $49a1041a43011cc6$export$2e2bcd8739ae039),
                    title: "api_resources"
                },
                {
                    Icon: (0, $af810b9fbc6c48f1$export$2e2bcd8739ae039),
                    title: "roles"
                },
                {
                    Icon: (0, $6ae35afac1070e51$export$2e2bcd8739ae039),
                    title: "organization_template"
                }
            ]
        },
        {
            title: "users",
            items: [
                {
                    Icon: (0, $79630b4f411e197e$export$2e2bcd8739ae039),
                    title: "organizations"
                },
                {
                    Icon: (0, $408fed7e43ed59a0$export$2e2bcd8739ae039),
                    title: "users"
                }
            ]
        },
        {
            title: "developer",
            items: [
                {
                    Icon: (0, $309f7e69d6e65bdc$export$2e2bcd8739ae039),
                    title: "signing_keys"
                },
                {
                    Icon: (0, $c3e0442675ff21c8$export$2e2bcd8739ae039),
                    title: "customize_jwt"
                },
                {
                    Icon: (0, $3b861fe29e4a5e6f$export$2e2bcd8739ae039),
                    title: "webhooks"
                },
                {
                    Icon: (0, $b71760af128d3f01$export$2e2bcd8739ae039),
                    title: "audit_logs"
                }
            ]
        },
        {
            title: "tenant",
            isHidden: !(0, $8TpMk.isCloud),
            items: [
                {
                    Icon: (0, $52d012a4456501b3$export$2e2bcd8739ae039),
                    title: "tenant_settings"
                }
            ]
        }
    ];
    const enabledSections = allSections.filter((section)=>!section.isHidden);
    return {
        sections: enabledSections,
        firstItem: $290219f9f98d0883$var$findFirstItem(enabledSections)
    };
};


var $3f51986b6f702777$export$bfd64c937657f93a;
var $3f51986b6f702777$export$4a6dd88bada4e7d2;
var $3f51986b6f702777$export$6fbb9cd2843e91b2;
$3f51986b6f702777$export$bfd64c937657f93a = `_3ZtC7q_rotating`;
$3f51986b6f702777$export$4a6dd88bada4e7d2 = `_3ZtC7q_shimmer`;
$3f51986b6f702777$export$6fbb9cd2843e91b2 = `_3ZtC7q_sidebar`;



function $342fa151f579f1c8$var$Sidebar() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.tab_sections"
    });
    const { sections: sections } = (0, $290219f9f98d0883$export$74c84f4d9513e4e1)();
    const { match: match } = (0, $4ZcUR.default)();
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aTllQ.default), {
        className: $3f51986b6f702777$export$6fbb9cd2843e91b2,
        children: sections.map(({ title: title, items: items })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $ebeda71cd4e6b15b$export$2e2bcd8739ae039), {
                title: t(title),
                children: items.map(({ title: title, Icon: Icon, isHidden: isHidden, modal: modal, externalLink: externalLink })=>!isHidden && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $14b7c3cf8270d822$export$2e2bcd8739ae039), {
                        titleKey: title,
                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)(Icon, {}),
                        isActive: match("/" + (0, $698f86671730b31d$export$2aa3fd96c49a84a8)(title)),
                        modal: modal,
                        externalLink: externalLink
                    }, title))
            }, title))
    });
}
var $342fa151f579f1c8$export$2e2bcd8739ae039 = $342fa151f579f1c8$var$Sidebar;




var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $kUZ14 = parcelRequire("kUZ14");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $5UrGx = parcelRequire("5UrGx");

var $b67J2 = parcelRequire("b67J2");

var $66ixW = parcelRequire("66ixW");

var $69b13c1f799dc369$export$34e0f9847d4c02dd;
var $69b13c1f799dc369$export$e8fe8d4c8a88a102;
var $69b13c1f799dc369$export$e96ebd20767e3616;
var $69b13c1f799dc369$export$bfd64c937657f93a;
var $69b13c1f799dc369$export$4a6dd88bada4e7d2;
var $69b13c1f799dc369$export$bc302bd3f1a12a2c;
var $69b13c1f799dc369$export$ef89c04d7f7888be;
var $69b13c1f799dc369$export$11455a9e44d7c809;
$69b13c1f799dc369$export$34e0f9847d4c02dd = `fkLd0a_container`;
$69b13c1f799dc369$export$e8fe8d4c8a88a102 = `fkLd0a_overuse`;
$69b13c1f799dc369$export$e96ebd20767e3616 = `fkLd0a_planCycle`;
$69b13c1f799dc369$export$bfd64c937657f93a = `fkLd0a_rotating`;
$69b13c1f799dc369$export$4a6dd88bada4e7d2 = `fkLd0a_shimmer`;
$69b13c1f799dc369$export$bc302bd3f1a12a2c = `fkLd0a_usage`;
$69b13c1f799dc369$export$ef89c04d7f7888be = `fkLd0a_usageBar`;
$69b13c1f799dc369$export$11455a9e44d7c809 = `fkLd0a_usageBarInner`;


function $2df8e7170c01f284$var$PlanUsage({ subscriptionUsage: subscriptionUsage, currentSubscription: currentSubscription, currentPlan: currentPlan }) {
    const { currentPeriodStart: currentPeriodStart, currentPeriodEnd: currentPeriodEnd } = currentSubscription;
    const { activeUsers: activeUsers } = subscriptionUsage;
    const { quota: { mauLimit: mauLimit } } = currentPlan;
    const usagePercent = (0, $7oDSS.conditional)(mauLimit && activeUsers / mauLimit);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $69b13c1f799dc369$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $69b13c1f799dc369$export$bc302bd3f1a12a2c,
                children: [
                    `${activeUsers} / `,
                    mauLimit === null ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                        forKey: "subscription.quota_table.unlimited"
                    }) : mauLimit.toLocaleString(),
                    " MAU",
                    usagePercent && ` (${(usagePercent * 100).toFixed(2)}%)`
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $69b13c1f799dc369$export$e96ebd20767e3616,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                    forKey: "subscription.plan_cycle",
                    interpolation: {
                        period: (0, $b38537f440ba3476$export$b971ca6f7de66f44)({
                            periodStart: currentPeriodStart,
                            periodEnd: currentPeriodEnd
                        }),
                        renewDate: (0, (/*@__PURE__*/$parcel$interopDefault($b67J2)))(currentPeriodEnd).add(1, "day").format("MMM D, YYYY")
                    }
                })
            }),
            usagePercent && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $69b13c1f799dc369$export$ef89c04d7f7888be,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($69b13c1f799dc369$export$11455a9e44d7c809, usagePercent >= 1 && $69b13c1f799dc369$export$e8fe8d4c8a88a102),
                    style: {
                        width: `${Math.min(usagePercent, 1) * 100}%`
                    }
                })
            })
        ]
    });
}
var $2df8e7170c01f284$export$2e2bcd8739ae039 = $2df8e7170c01f284$var$PlanUsage;


parcelRequire("8Mb3E");
var $cfL6o = parcelRequire("cfL6o");
parcelRequire("8Mb3E");
var $bt3dS = parcelRequire("bt3dS");
const $b2864970cb73ddbd$export$6d940d0d58a60bc4 = `/tenant-settings/${(0, $bt3dS.TenantSettingsTabs).Subscription}`;




var $cDKfs = parcelRequire("cDKfs");

var $jGWQ4 = parcelRequire("jGWQ4");

var $aqmjm = parcelRequire("aqmjm");

var $1QOtg = parcelRequire("1QOtg");

var $5vVWy = parcelRequire("5vVWy");

var $4ZcUR = parcelRequire("4ZcUR");

var $dW2kG = parcelRequire("dW2kG");

var $64275dd758ddc1e6$export$9126ebe212f3bdac;
$64275dd758ddc1e6$export$9126ebe212f3bdac = `kupZfW_linkButton`;


function $8781336d9fda2936$var$MauExceededModal() {
    const { currentTenant: currentTenant } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { usage: usage } = currentTenant ?? {};
    const { currentPlan: currentPlan, currentSubscription: currentSubscription } = (0, $jC8Vy.useContext)((0, $19434c930f80c964$export$f8addfd4ab69c833));
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const [hasClosed, setHasClosed] = (0, $jC8Vy.useState)(false);
    const handleCloseModal = ()=>{
        setHasClosed(true);
    };
    if (!usage || hasClosed) return null;
    const { quota: { mauLimit: mauLimit }, name: planName } = currentPlan;
    const isMauExceeded = mauLimit !== null && usage.activeUsers >= mauLimit;
    if (!isMauExceeded) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        isOpen: true,
        shouldCloseOnEsc: true,
        className: $dW2kG.content,
        overlayClassName: $dW2kG.overlay,
        onRequestClose: handleCloseModal,
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $5vVWy.default), {
            title: "upsell.mau_exceeded_modal.title",
            footer: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("a", {
                        href: (0, $cfL6o.contactEmailLink),
                        className: $64275dd758ddc1e6$export$9126ebe212f3bdac,
                        rel: "noopener",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                            title: "general.contact_us_action"
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        type: "primary",
                        title: "upsell.upgrade_plan",
                        onClick: ()=>{
                            navigate((0, $b2864970cb73ddbd$export$6d940d0d58a60bc4));
                            handleCloseModal();
                        }
                    })
                ]
            }),
            onClose: handleCloseModal,
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1QOtg.default), {
                    severity: "error",
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                        components: {
                            planName: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $161f1bf99d56f621$export$2e2bcd8739ae039), {
                                name: planName
                            })
                        },
                        children: t("upsell.mau_exceeded_modal.notification")
                    })
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                    title: "subscription.plan_usage",
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2df8e7170c01f284$export$2e2bcd8739ae039), {
                        subscriptionUsage: usage,
                        currentSubscription: currentSubscription,
                        currentPlan: currentPlan
                    })
                })
            ]
        })
    });
}
var $8781336d9fda2936$export$2e2bcd8739ae039 = $8781336d9fda2936$var$MauExceededModal;



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $kUZ14 = parcelRequire("kUZ14");
parcelRequire("8Mb3E");
var $cfL6o = parcelRequire("cfL6o");

var $8TpMk = parcelRequire("8TpMk");

var $cDKfs = parcelRequire("cDKfs");

var $jGWQ4 = parcelRequire("jGWQ4");

var $aqmjm = parcelRequire("aqmjm");

var $1QOtg = parcelRequire("1QOtg");

var $5vVWy = parcelRequire("5vVWy");


var $dW2kG = parcelRequire("dW2kG");

var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $lf8OC = parcelRequire("lf8OC");
parcelRequire("8Mb3E");
var $cfL6o = parcelRequire("cfL6o");

var $cDKfs = parcelRequire("cDKfs");

var $jGWQ4 = parcelRequire("jGWQ4");

var $66ixW = parcelRequire("66ixW");

var $75SRw = parcelRequire("75SRw");

var $9Q3SI = parcelRequire("9Q3SI");
parcelRequire("fIF1D");
var $2LaLj = parcelRequire("2LaLj");

var $9a254ff322357d2f$export$c7f35b042535c54c;
var $9a254ff322357d2f$export$41d105e05873013c;
var $9a254ff322357d2f$export$34e0f9847d4c02dd;
var $9a254ff322357d2f$export$6d59db4903f20f7d;
var $9a254ff322357d2f$export$321c0b1a406de31f;
var $9a254ff322357d2f$export$bfd64c937657f93a;
var $9a254ff322357d2f$export$4a6dd88bada4e7d2;
$9a254ff322357d2f$export$c7f35b042535c54c = `BcZZjq_articleLink`;
$9a254ff322357d2f$export$41d105e05873013c = `BcZZjq_billInfo`;
$9a254ff322357d2f$export$34e0f9847d4c02dd = `BcZZjq_container`;
$9a254ff322357d2f$export$6d59db4903f20f7d = `BcZZjq_description`;
$9a254ff322357d2f$export$321c0b1a406de31f = `BcZZjq_price`;
$9a254ff322357d2f$export$bfd64c937657f93a = `BcZZjq_rotating`;
$9a254ff322357d2f$export$4a6dd88bada4e7d2 = `BcZZjq_shimmer`;


function $210ebe2740442134$var$BillInfo({ cost: cost, isManagePaymentVisible: isManagePaymentVisible }) {
    const { currentTenantId: currentTenantId } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { visitManagePaymentPage: visitManagePaymentPage } = (0, $699da2d1bc75044e$export$2e2bcd8739ae039)();
    const [isLoading, setIsLoading] = (0, $jC8Vy.useState)(false);
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $9a254ff322357d2f$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $9a254ff322357d2f$export$41d105e05873013c,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $9a254ff322357d2f$export$321c0b1a406de31f,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                                children: `$${(cost / 100).toLocaleString()}`
                            }),
                            cost > 0 && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2LaLj.default), {
                                content: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                    forKey: "subscription.next_bill_tip"
                                }),
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                                    size: "small",
                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $lf8OC.default), {})
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $9a254ff322357d2f$export$6d59db4903f20f7d,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                            components: {
                                a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                                    className: $9a254ff322357d2f$export$c7f35b042535c54c,
                                    href: (0, $cfL6o.newPlansBlogLink),
                                    targetBlank: "noopener"
                                })
                            },
                            children: t("subscription.next_bill_hint")
                        })
                    })
                ]
            }),
            isManagePaymentVisible && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                title: "subscription.manage_payment",
                isLoading: isLoading,
                onClick: async ()=>{
                    setIsLoading(true);
                    await visitManagePaymentPage(currentTenantId);
                    setIsLoading(false);
                }
            })
        ]
    });
}
var $210ebe2740442134$export$2e2bcd8739ae039 = $210ebe2740442134$var$BillInfo;


var $88896d6e4ce29d55$export$9126ebe212f3bdac;
var $88896d6e4ce29d55$export$59ae2c325a998f89;
$88896d6e4ce29d55$export$9126ebe212f3bdac = `_23BWOW_linkButton`;
$88896d6e4ce29d55$export$59ae2c325a998f89 = `_23BWOW_strong`;


function $d24da6b4d4bd925f$var$PaymentOverdueModal() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { currentTenant: currentTenant, currentTenantId: currentTenantId } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { openInvoices: openInvoices = [] } = currentTenant ?? {};
    const { visitManagePaymentPage: visitManagePaymentPage } = (0, $699da2d1bc75044e$export$2e2bcd8739ae039)();
    const [isActionLoading, setIsActionLoading] = (0, $jC8Vy.useState)(false);
    const [hasClosed, setHasClosed] = (0, $jC8Vy.useState)(false);
    const handleCloseModal = ()=>{
        setHasClosed(true);
    };
    if (!(0, $8TpMk.isCloud) || openInvoices.length === 0 || hasClosed) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        isOpen: true,
        shouldCloseOnEsc: true,
        className: $dW2kG.content,
        overlayClassName: $dW2kG.overlay,
        onRequestClose: handleCloseModal,
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $5vVWy.default), {
            title: "upsell.payment_overdue_modal.title",
            footer: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("a", {
                        href: (0, $cfL6o.contactEmailLink),
                        className: $88896d6e4ce29d55$export$9126ebe212f3bdac,
                        rel: "noopener",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                            title: "general.contact_us_action"
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        type: "primary",
                        title: "upsell.payment_overdue_modal.update_payment",
                        isLoading: isActionLoading,
                        onClick: async ()=>{
                            setIsActionLoading(true);
                            await visitManagePaymentPage(currentTenantId);
                            setIsActionLoading(false);
                        }
                    })
                ]
            }),
            onClose: handleCloseModal,
            children: [
                currentTenant && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1QOtg.default), {
                    severity: "error",
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                        components: {
                            span: /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                                className: $88896d6e4ce29d55$export$59ae2c325a998f89
                            })
                        },
                        children: t("upsell.payment_overdue_modal.notification", {
                            name: currentTenant.name
                        })
                    })
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                    title: "upsell.payment_overdue_modal.unpaid_bills",
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $210ebe2740442134$export$2e2bcd8739ae039), {
                        cost: openInvoices.reduce((total, currentInvoice)=>total + currentInvoice.amountDue, 0)
                    })
                })
            ]
        })
    });
}
var $d24da6b4d4bd925f$export$2e2bcd8739ae039 = $d24da6b4d4bd925f$var$PaymentOverdueModal;



var $8TpMk = parcelRequire("8TpMk");

var $cDKfs = parcelRequire("cDKfs");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $iq1sR = parcelRequire("iq1sR");

var $jC8Vy = parcelRequire("jC8Vy");

var $jH4WR = parcelRequire("jH4WR");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");


var $cDKfs = parcelRequire("cDKfs");

var $9Q3SI = parcelRequire("9Q3SI");
var $e55f19db3f9fa0de$export$bb5ee47d9ea2348e;
var $e55f19db3f9fa0de$export$bfd64c937657f93a;
var $e55f19db3f9fa0de$export$4a6dd88bada4e7d2;
$e55f19db3f9fa0de$export$bb5ee47d9ea2348e = `f8vb9G_banner`;
$e55f19db3f9fa0de$export$bfd64c937657f93a = `f8vb9G_rotating`;
$e55f19db3f9fa0de$export$4a6dd88bada4e7d2 = `f8vb9G_shimmer`;


function $fd7e5b71da5ec15a$var$CreateProductionTenantBanner() {
    const [isCreateModalOpen, setIsCreateModalOpen] = (0, $jC8Vy.useState)(false);
    const { tenants: tenants, prependTenant: prependTenant, navigateTenant: navigateTenant } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.tenants.production_tenant_notification"
    });
    if (tenants.some((tenant)=>tenant.tag === (0, $iq1sR.TenantTag).Production)) return null;
    return /*#__PURE__*/ (0, $jH4WR.createPortal)(/*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $e55f19db3f9fa0de$export$bb5ee47d9ea2348e,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6b53fcc6297da1c8$export$2e2bcd8739ae039), {
                isOpen: isCreateModalOpen,
                onClose: async (tenant)=>{
                    setIsCreateModalOpen(false);
                    if (tenant) {
                        prependTenant(tenant);
                        navigateTenant(tenant.id);
                    }
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                children: t("text")
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                onClick: ()=>{
                    setIsCreateModalOpen(true);
                },
                children: t("action")
            })
        ]
    }), document.body);
}
var $fd7e5b71da5ec15a$export$2e2bcd8739ae039 = $fd7e5b71da5ec15a$var$CreateProductionTenantBanner;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");

var $jC8Vy = parcelRequire("jC8Vy");
var $685167181ed329d5$exports = {};

!function(t, e) {
    $685167181ed329d5$exports = e((parcelRequire("jC8Vy")));
}("undefined" != typeof self ? self : $685167181ed329d5$exports, function(t) {
    return function(t) {
        var e = {};
        function n(r) {
            if (e[r]) return e[r].exports;
            var i = e[r] = {
                i: r,
                l: !1,
                exports: {}
            };
            return t[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
        }
        return n.m = t, n.c = e, n.d = function(t, e, r) {
            n.o(t, e) || Object.defineProperty(t, e, {
                enumerable: !0,
                get: r
            });
        }, n.r = function(t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        }, n.t = function(t, e) {
            if (1 & e && (t = n(t)), 8 & e) return t;
            if (4 & e && "object" == typeof t && t && t.__esModule) return t;
            var r = Object.create(null);
            if (n.r(r), Object.defineProperty(r, "default", {
                enumerable: !0,
                value: t
            }), 2 & e && "string" != typeof t) for(var i in t)n.d(r, i, (function(e) {
                return t[e];
            }).bind(null, i));
            return r;
        }, n.n = function(t) {
            var e = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return n.d(e, "a", e), e;
        }, n.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }, n.p = "", n(n.s = 2);
    }([
        function(e, n) {
            e.exports = t;
        },
        function(t, e, n) {
            "use strict";
            var r = {
                linear: function(t, e, n, r) {
                    return (n - e) * t / r + e;
                },
                easeInQuad: function(t, e, n, r) {
                    return (n - e) * (t /= r) * t + e;
                },
                easeOutQuad: function(t, e, n, r) {
                    return -(n - e) * (t /= r) * (t - 2) + e;
                },
                easeInOutQuad: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r / 2) < 1 ? i / 2 * t * t + e : -i / 2 * (--t * (t - 2) - 1) + e;
                },
                easeInCubic: function(t, e, n, r) {
                    return (n - e) * (t /= r) * t * t + e;
                },
                easeOutCubic: function(t, e, n, r) {
                    return (n - e) * ((t = t / r - 1) * t * t + 1) + e;
                },
                easeInOutCubic: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r / 2) < 1 ? i / 2 * t * t * t + e : i / 2 * ((t -= 2) * t * t + 2) + e;
                },
                easeInQuart: function(t, e, n, r) {
                    return (n - e) * (t /= r) * t * t * t + e;
                },
                easeOutQuart: function(t, e, n, r) {
                    return -(n - e) * ((t = t / r - 1) * t * t * t - 1) + e;
                },
                easeInOutQuart: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r / 2) < 1 ? i / 2 * t * t * t * t + e : -i / 2 * ((t -= 2) * t * t * t - 2) + e;
                },
                easeInQuint: function(t, e, n, r) {
                    return (n - e) * (t /= r) * t * t * t * t + e;
                },
                easeOutQuint: function(t, e, n, r) {
                    return (n - e) * ((t = t / r - 1) * t * t * t * t + 1) + e;
                },
                easeInOutQuint: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r / 2) < 1 ? i / 2 * t * t * t * t * t + e : i / 2 * ((t -= 2) * t * t * t * t + 2) + e;
                },
                easeInSine: function(t, e, n, r) {
                    var i = n - e;
                    return -i * Math.cos(t / r * (Math.PI / 2)) + i + e;
                },
                easeOutSine: function(t, e, n, r) {
                    return (n - e) * Math.sin(t / r * (Math.PI / 2)) + e;
                },
                easeInOutSine: function(t, e, n, r) {
                    return -(n - e) / 2 * (Math.cos(Math.PI * t / r) - 1) + e;
                },
                easeInExpo: function(t, e, n, r) {
                    return 0 == t ? e : (n - e) * Math.pow(2, 10 * (t / r - 1)) + e;
                },
                easeOutExpo: function(t, e, n, r) {
                    var i = n - e;
                    return t == r ? e + i : i * (1 - Math.pow(2, -10 * t / r)) + e;
                },
                easeInOutExpo: function(t, e, n, r) {
                    var i = n - e;
                    return 0 === t ? e : t === r ? e + i : (t /= r / 2) < 1 ? i / 2 * Math.pow(2, 10 * (t - 1)) + e : i / 2 * (2 - Math.pow(2, -10 * --t)) + e;
                },
                easeInCirc: function(t, e, n, r) {
                    return -(n - e) * (Math.sqrt(1 - (t /= r) * t) - 1) + e;
                },
                easeOutCirc: function(t, e, n, r) {
                    return (n - e) * Math.sqrt(1 - (t = t / r - 1) * t) + e;
                },
                easeInOutCirc: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r / 2) < 1 ? -i / 2 * (Math.sqrt(1 - t * t) - 1) + e : i / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + e;
                },
                easeInElastic: function(t, e, n, r) {
                    var i, o, a, c = n - e;
                    return a = 1.70158, 0 === t ? e : 1 == (t /= r) ? e + c : (o = 0, o = .3 * r, (i = c) < Math.abs(c) ? (i = c, a = o / 4) : a = o / (2 * Math.PI) * Math.asin(c / i), -i * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * r - a) * (2 * Math.PI) / o) + e);
                },
                easeOutElastic: function(t, e, n, r) {
                    var i, o, a, c = n - e;
                    return a = 1.70158, 0 === t ? e : 1 == (t /= r) ? e + c : (o = 0, o = .3 * r, (i = c) < Math.abs(c) ? (i = c, a = o / 4) : a = o / (2 * Math.PI) * Math.asin(c / i), i * Math.pow(2, -10 * t) * Math.sin((t * r - a) * (2 * Math.PI) / o) + c + e);
                },
                easeInOutElastic: function(t, e, n, r) {
                    var i, o, a, c = n - e;
                    return a = 1.70158, 0 === t ? e : 2 == (t /= r / 2) ? e + c : (o = 0, o = r * (.3 * 1.5), (i = c) < Math.abs(c) ? (i = c, a = o / 4) : a = o / (2 * Math.PI) * Math.asin(c / i), t < 1 ? i * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * r - a) * (2 * Math.PI) / o) * -0.5 + e : i * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * r - a) * (2 * Math.PI) / o) * .5 + c + e);
                },
                easeInBack: function(t, e, n, r, i) {
                    return void 0 === i && (i = 1.70158), (n - e) * (t /= r) * t * ((i + 1) * t - i) + e;
                },
                easeOutBack: function(t, e, n, r, i) {
                    return void 0 === i && (i = 1.70158), (n - e) * ((t = t / r - 1) * t * ((i + 1) * t + i) + 1) + e;
                },
                easeInOutBack: function(t, e, n, r, i) {
                    var o = n - e;
                    return void 0 === i && (i = 1.70158), (t /= r / 2) < 1 ? o / 2 * (t * t * ((1 + (i *= 1.525)) * t - i)) + e : o / 2 * ((t -= 2) * t * ((1 + (i *= 1.525)) * t + i) + 2) + e;
                },
                easeInBounce: function(t, e, n, i) {
                    var o = n - e;
                    return o - r.easeOutBounce(i - t, 0, o, i) + e;
                },
                easeOutBounce: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r) < 1 / 2.75 ? i * (7.5625 * t * t) + e : t < 2 / 2.75 ? i * (7.5625 * (t -= 1.5 / 2.75) * t + .75) + e : t < 2.5 / 2.75 ? i * (7.5625 * (t -= 2.25 / 2.75) * t + .9375) + e : i * (7.5625 * (t -= 2.625 / 2.75) * t + .984375) + e;
                },
                easeInOutBounce: function(t, e, n, i) {
                    var o = n - e;
                    return t < i / 2 ? .5 * r.easeInBounce(2 * t, 0, o, i) + e : .5 * r.easeOutBounce(2 * t - i, 0, o, i) + .5 * o + e;
                }
            };
            t.exports = r;
        },
        function(t, e, n) {
            t.exports = n(3);
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "ReactConfetti", function() {
                return Q;
            });
            var r, i, o = n(0), a = n.n(o), c = n(1), s = n.n(c);
            function u(t, e) {
                return t + Math.random() * (e - t);
            }
            function f(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function h(t, e, n) {
                return e in t ? Object.defineProperty(t, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = n, t;
            }
            !function(t) {
                t[t.Circle = 0] = "Circle", t[t.Square = 1] = "Square", t[t.Strip = 2] = "Strip";
            }(r || (r = {})), function(t) {
                t[t.Positive = 1] = "Positive", t[t.Negative = -1] = "Negative";
            }(i || (i = {}));
            var l = function() {
                function t(e, n, r, o) {
                    !function(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, t), h(this, "context", void 0), h(this, "radius", void 0), h(this, "x", void 0), h(this, "y", void 0), h(this, "w", void 0), h(this, "h", void 0), h(this, "vx", void 0), h(this, "vy", void 0), h(this, "shape", void 0), h(this, "angle", void 0), h(this, "angularSpin", void 0), h(this, "color", void 0), h(this, "rotateY", void 0), h(this, "rotationDirection", void 0), h(this, "getOptions", void 0), this.getOptions = n;
                    var a, c, s = this.getOptions(), f = s.colors, l = s.initialVelocityX, p = s.initialVelocityY;
                    this.context = e, this.x = r, this.y = o, this.w = u(5, 20), this.h = u(5, 20), this.radius = u(5, 10), this.vx = "number" == typeof l ? u(-l, l) : u(l.min, l.max), this.vy = "number" == typeof p ? u(-p, 0) : u(p.min, p.max), this.shape = (a = 0, c = 2, Math.floor(a + Math.random() * (c - a + 1))), this.angle = u(0, 360) * Math.PI / 180, this.angularSpin = u(-0.2, .2), this.color = f[Math.floor(Math.random() * f.length)], this.rotateY = u(0, 1), this.rotationDirection = u(0, 1) ? i.Positive : i.Negative;
                }
                var e, n, o;
                return e = t, n = [
                    {
                        key: "update",
                        value: function() {
                            var t = this.getOptions(), e = t.gravity, n = t.wind, o = t.friction, a = t.opacity, c = t.drawShape;
                            this.x += this.vx, this.y += this.vy, this.vy += e, this.vx += n, this.vx *= o, this.vy *= o, this.rotateY >= 1 && this.rotationDirection === i.Positive ? this.rotationDirection = i.Negative : this.rotateY <= -1 && this.rotationDirection === i.Negative && (this.rotationDirection = i.Positive);
                            var s = .1 * this.rotationDirection;
                            if (this.rotateY += s, this.angle += this.angularSpin, this.context.save(), this.context.translate(this.x, this.y), this.context.rotate(this.angle), this.context.scale(1, this.rotateY), this.context.rotate(this.angle), this.context.beginPath(), this.context.fillStyle = this.color, this.context.strokeStyle = this.color, this.context.globalAlpha = a, this.context.lineCap = "round", this.context.lineWidth = 2, c && "function" == typeof c) c.call(this, this.context);
                            else switch(this.shape){
                                case r.Circle:
                                    this.context.beginPath(), this.context.arc(0, 0, this.radius, 0, 2 * Math.PI), this.context.fill();
                                    break;
                                case r.Square:
                                    this.context.fillRect(-this.w / 2, -this.h / 2, this.w, this.h);
                                    break;
                                case r.Strip:
                                    this.context.fillRect(-this.w / 6, -this.h / 2, this.w / 3, this.h);
                            }
                            this.context.closePath(), this.context.restore();
                        }
                    }
                ], f(e.prototype, n), o && f(e, o), t;
            }();
            function p(t, e, n) {
                return e in t ? Object.defineProperty(t, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = n, t;
            }
            var v = function t(e, n) {
                var r = this;
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), p(this, "canvas", void 0), p(this, "context", void 0), p(this, "getOptions", void 0), p(this, "x", 0), p(this, "y", 0), p(this, "w", 0), p(this, "h", 0), p(this, "lastNumberOfPieces", 0), p(this, "tweenInitTime", Date.now()), p(this, "particles", []), p(this, "particlesGenerated", 0), p(this, "removeParticleAt", function(t) {
                    r.particles.splice(t, 1);
                }), p(this, "getParticle", function() {
                    var t = u(r.x, r.w + r.x), e = u(r.y, r.h + r.y);
                    return new l(r.context, r.getOptions, t, e);
                }), p(this, "animate", function() {
                    var t = r.canvas, e = r.context, n = r.particlesGenerated, i = r.lastNumberOfPieces, o = r.getOptions(), a = o.run, c = o.recycle, s = o.numberOfPieces, u = o.debug, f = o.tweenFunction, h = o.tweenDuration;
                    if (!a) return !1;
                    var l = r.particles.length, p = c ? l : n, v = Date.now();
                    if (p < s) {
                        i !== s && (r.tweenInitTime = v, r.lastNumberOfPieces = s);
                        for(var y = r.tweenInitTime, d = f(v - y > h ? h : Math.max(0, v - y), p, s, h), b = Math.round(d - p), g = 0; g < b; g++)r.particles.push(r.getParticle());
                        r.particlesGenerated += b;
                    }
                    return u && (e.font = "12px sans-serif", e.fillStyle = "#333", e.textAlign = "right", e.fillText("Particles: ".concat(l), t.width - 10, t.height - 20)), r.particles.forEach(function(e, n) {
                        e.update(), (e.y > t.height || e.y < -100 || e.x > t.width + 100 || e.x < -100) && (c && p <= s ? r.particles[n] = r.getParticle() : r.removeParticleAt(n));
                    }), l > 0 || p < s;
                }), this.canvas = e;
                var i = this.canvas.getContext("2d");
                if (!i) throw new Error("Could not get canvas context");
                this.context = i, this.getOptions = n;
            };
            function y(t, e) {
                var n = Object.keys(t);
                if (Object.getOwnPropertySymbols) {
                    var r = Object.getOwnPropertySymbols(t);
                    e && (r = r.filter(function(e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                    })), n.push.apply(n, r);
                }
                return n;
            }
            function d(t) {
                for(var e = 1; e < arguments.length; e++){
                    var n = null != arguments[e] ? arguments[e] : {};
                    e % 2 ? y(Object(n), !0).forEach(function(e) {
                        g(t, e, n[e]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : y(Object(n)).forEach(function(e) {
                        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
                    });
                }
                return t;
            }
            function b(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function g(t, e, n) {
                return e in t ? Object.defineProperty(t, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = n, t;
            }
            var O = {
                width: "undefined" != typeof window ? window.innerWidth : 300,
                height: "undefined" != typeof window ? window.innerHeight : 200,
                numberOfPieces: 200,
                friction: .99,
                wind: 0,
                gravity: .1,
                initialVelocityX: 4,
                initialVelocityY: 10,
                colors: [
                    "#f44336",
                    "#e91e63",
                    "#9c27b0",
                    "#673ab7",
                    "#3f51b5",
                    "#2196f3",
                    "#03a9f4",
                    "#00bcd4",
                    "#009688",
                    "#4CAF50",
                    "#8BC34A",
                    "#CDDC39",
                    "#FFEB3B",
                    "#FFC107",
                    "#FF9800",
                    "#FF5722",
                    "#795548"
                ],
                opacity: 1,
                debug: !1,
                tweenFunction: s.a.easeInOutQuad,
                tweenDuration: 5e3,
                recycle: !0,
                run: !0
            }, w = function() {
                function t(e, n) {
                    var r = this;
                    !function(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, t), g(this, "canvas", void 0), g(this, "context", void 0), g(this, "_options", void 0), g(this, "generator", void 0), g(this, "rafId", void 0), g(this, "setOptionsWithDefaults", function(t) {
                        var e = {
                            confettiSource: {
                                x: 0,
                                y: 0,
                                w: r.canvas.width,
                                h: 0
                            }
                        };
                        r._options = d(d(d({}, e), O), t), Object.assign(r, t.confettiSource);
                    }), g(this, "update", function() {
                        var t = r.options, e = t.run, n = t.onConfettiComplete, i = r.canvas, o = r.context;
                        e && (o.fillStyle = "white", o.clearRect(0, 0, i.width, i.height)), r.generator.animate() ? r.rafId = requestAnimationFrame(r.update) : (n && "function" == typeof n && r.generator.particlesGenerated > 0 && n.call(r, r), r._options.run = !1);
                    }), g(this, "reset", function() {
                        r.generator && r.generator.particlesGenerated > 0 && (r.generator.particlesGenerated = 0, r.generator.particles = [], r.generator.lastNumberOfPieces = 0);
                    }), g(this, "stop", function() {
                        r.options = {
                            run: !1
                        }, r.rafId && (cancelAnimationFrame(r.rafId), r.rafId = void 0);
                    }), this.canvas = e;
                    var i = this.canvas.getContext("2d");
                    if (!i) throw new Error("Could not get canvas context");
                    this.context = i, this.generator = new v(this.canvas, function() {
                        return r.options;
                    }), this.options = n, this.update();
                }
                var e, n, r;
                return e = t, n = [
                    {
                        key: "options",
                        get: function() {
                            return this._options;
                        },
                        set: function(t) {
                            var e = this._options && this._options.run, n = this._options && this._options.recycle;
                            this.setOptionsWithDefaults(t), this.generator && (Object.assign(this.generator, this.options.confettiSource), "boolean" == typeof t.recycle && t.recycle && !1 === n && (this.generator.lastNumberOfPieces = this.generator.particles.length)), "boolean" == typeof t.run && t.run && !1 === e && this.update();
                        }
                    }
                ], b(e.prototype, n), r && b(e, r), t;
            }();
            function m(t) {
                return function(t) {
                    if (Array.isArray(t)) return C(t);
                }(t) || function(t) {
                    if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
                }(t) || S(t) || function() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
            }
            function x(t) {
                return (x = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                    return typeof t;
                } : function(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            function P() {
                return (P = Object.assign || function(t) {
                    for(var e = 1; e < arguments.length; e++){
                        var n = arguments[e];
                        for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
                    }
                    return t;
                }).apply(this, arguments);
            }
            function j(t, e) {
                var n = Object.keys(t);
                if (Object.getOwnPropertySymbols) {
                    var r = Object.getOwnPropertySymbols(t);
                    e && (r = r.filter(function(e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                    })), n.push.apply(n, r);
                }
                return n;
            }
            function M(t) {
                for(var e = 1; e < arguments.length; e++){
                    var n = null != arguments[e] ? arguments[e] : {};
                    e % 2 ? j(Object(n), !0).forEach(function(e) {
                        T(t, e, n[e]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : j(Object(n)).forEach(function(e) {
                        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
                    });
                }
                return t;
            }
            function I(t, e) {
                return function(t) {
                    if (Array.isArray(t)) return t;
                }(t) || function(t, e) {
                    if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t))) return;
                    var n = [], r = !0, i = !1, o = void 0;
                    try {
                        for(var a, c = t[Symbol.iterator](); !(r = (a = c.next()).done) && (n.push(a.value), !e || n.length !== e); r = !0);
                    } catch (t) {
                        i = !0, o = t;
                    } finally{
                        try {
                            r || null == c.return || c.return();
                        } finally{
                            if (i) throw o;
                        }
                    }
                    return n;
                }(t, e) || S(t, e) || function() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
            }
            function S(t, e) {
                if (t) {
                    if ("string" == typeof t) return C(t, e);
                    var n = Object.prototype.toString.call(t).slice(8, -1);
                    return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? C(t, e) : void 0;
                }
            }
            function C(t, e) {
                (null == e || e > t.length) && (e = t.length);
                for(var n = 0, r = new Array(e); n < e; n++)r[n] = t[n];
                return r;
            }
            function D(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            function E(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function _(t, e) {
                return (_ = Object.setPrototypeOf || function(t, e) {
                    return t.__proto__ = e, t;
                })(t, e);
            }
            function R(t) {
                var e = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0;
                    } catch (t) {
                        return !1;
                    }
                }();
                return function() {
                    var n, r = F(t);
                    if (e) {
                        var i = F(this).constructor;
                        n = Reflect.construct(r, arguments, i);
                    } else n = r.apply(this, arguments);
                    return k(this, n);
                };
            }
            function k(t, e) {
                return !e || "object" !== x(e) && "function" != typeof e ? A(t) : e;
            }
            function A(t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            }
            function F(t) {
                return (F = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
                    return t.__proto__ || Object.getPrototypeOf(t);
                })(t);
            }
            function T(t, e, n) {
                return e in t ? Object.defineProperty(t, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = n, t;
            }
            var B = a.a.createRef(), N = function(t) {
                !function(t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e && _(t, e);
                }(o, t);
                var e, n, r, i = R(o);
                function o(t) {
                    var e;
                    D(this, o);
                    for(var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), c = 1; c < n; c++)r[c - 1] = arguments[c];
                    return T(A(e = i.call.apply(i, [
                        this,
                        t
                    ].concat(r))), "canvas", a.a.createRef()), T(A(e), "confetti", void 0), e.canvas = t.canvasRef || B, e;
                }
                return e = o, n = [
                    {
                        key: "componentDidMount",
                        value: function() {
                            if (this.canvas.current) {
                                var t = q(this.props)[0];
                                this.confetti = new w(this.canvas.current, t);
                            }
                        }
                    },
                    {
                        key: "componentDidUpdate",
                        value: function() {
                            var t = q(this.props)[0];
                            this.confetti && (this.confetti.options = t);
                        }
                    },
                    {
                        key: "componentWillUnmount",
                        value: function() {
                            this.confetti && this.confetti.stop(), this.confetti = void 0;
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var t = I(q(this.props), 2), e = t[0], n = t[1], r = M({
                                zIndex: 2,
                                position: "absolute",
                                pointerEvents: "none",
                                top: 0,
                                left: 0,
                                bottom: 0,
                                right: 0
                            }, n.style);
                            return a.a.createElement("canvas", P({
                                width: e.width,
                                height: e.height,
                                ref: this.canvas
                            }, n, {
                                style: r
                            }));
                        }
                    }
                ], E(e.prototype, n), r && E(e, r), o;
            }(o.Component);
            function q(t) {
                var e = {}, n = {}, r = [].concat(m(Object.keys(O)), [
                    "confettiSource",
                    "drawShape",
                    "onConfettiComplete"
                ]), i = [
                    "canvasRef"
                ];
                for(var o in t){
                    var a = t[o];
                    r.includes(o) ? e[o] = a : i.includes(o) ? i[o] = a : n[o] = a;
                }
                return [
                    e,
                    n,
                    {}
                ];
            }
            T(N, "defaultProps", M({}, O)), T(N, "displayName", "ReactConfetti");
            var Q = a.a.forwardRef(function(t, e) {
                return a.a.createElement(N, P({
                    canvasRef: e
                }, t));
            });
            e.default = Q;
        }
    ]).default;
});


parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $kUZ14 = parcelRequire("kUZ14");



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $0a430150a2655694$var$SvgTenantModalFireworks = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 824,
        height: 417,
        viewBox: "0 0 824 417",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M783.928 55.334c0-.185.15-.334.334-.334h6.008c.184 0 .334.15.334.334v10.573l9.156-5.286a.334.334 0 0 1 .456.122l3.004 5.203a.333.333 0 0 1-.122.456l-9.157 5.287 9.158 5.287a.334.334 0 0 1 .122.456l-3.004 5.203a.334.334 0 0 1-.456.122l-9.157-5.287v10.574c0 .184-.15.334-.334.334h-6.008a.334.334 0 0 1-.334-.334V77.47l-9.158 5.287a.334.334 0 0 1-.456-.122l-3.004-5.203a.334.334 0 0 1 .123-.456l9.157-5.287-9.157-5.287a.333.333 0 0 1-.122-.456l3.004-5.203a.334.334 0 0 1 .456-.122l9.157 5.287V55.334Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m75.957 199.757 1.513-5.45a5.656 5.656 0 0 0-3.937-6.964v0a5.657 5.657 0 0 1-3.938-6.964v0a5.657 5.657 0 0 0-3.937-6.964v0a5.657 5.657 0 0 1-3.938-6.964L63.234 161",
                stroke: "#FFD5FF",
                strokeWidth: 4,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M652.766 23c6.351 0 11.5-5.149 11.5-11.5S659.117 0 652.766 0c-6.352 0-11.5 5.149-11.5 11.5s5.148 11.5 11.5 11.5Zm0-5.75a5.75 5.75 0 1 0 0-11.501 5.75 5.75 0 0 0 0 11.5ZM815.266 190a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
                fill: "#FFB95A"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m20.012 272.242-1.127-5.544a5.658 5.658 0 0 0-6.67-4.417v0a5.656 5.656 0 0 1-6.67-4.416l-1.127-5.544",
                stroke: "#C4C7C7",
                strokeWidth: 4,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m159.324 49.033-.155-5.655a5.657 5.657 0 0 0-5.81-5.5v0a5.656 5.656 0 0 1-5.809-5.5v0a5.657 5.657 0 0 0-5.81-5.5v0a5.657 5.657 0 0 1-5.81-5.499l-.155-5.655",
                stroke: "#CABEFF",
                strokeWidth: 4,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m492.121 56.688-1.365-5.49a5.658 5.658 0 0 1 4.126-6.854v0a5.658 5.658 0 0 0 4.125-6.854L497.642 32M715.297 414.09l3.985-4.015a5.657 5.657 0 0 1 8-.03v0a5.656 5.656 0 0 0 8-.03l3.985-4.015",
                stroke: "#E6DEFF",
                strokeWidth: 4,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M629.269 83.5V104c0 2.5 1.5 3.5 0 8.5s2 6 1.5 8-3.501 4-2.001 10",
                stroke: "#D1CADE",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M628.466 84.5a1 1 0 0 1 1.732 0l3.634 6.294c.694 1.203-.174 2.706-1.562 2.706l-1.438-.36a1.567 1.567 0 0 0-1.081.12 1.569 1.569 0 0 1-1.009.134l-1.14-.228a5.003 5.003 0 0 0-1.681-.045c-1.065.152-1.863-.986-1.326-1.918l3.871-6.703Z",
                fill: "#DEA0E1"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M649.27 61.77c0 11.47-8.955 26.153-20 26.153-11.046 0-20-14.683-20-26.154 0-11.47 8.954-20.769 20-20.769 11.045 0 20 9.299 20 20.77Z",
                fill: "#F4B4FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M635.85 47.806a19.809 19.809 0 0 1 1.614 1.71m5.219 18.767c1.507-5.654-.256-11.044-2.591-15.038a26.91 26.91 0 0 0-1.215-1.893",
                stroke: "#FEF2FF",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M592.768 143.5c3.504-5.5 4.502-7 2.001-10-1.319-1.584-3-3-1.5-8s-1.499-4 0-8.5c1.001-2.5 0-7.1 0-7.5",
                stroke: "#D1CADE",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M592.698 105.99a.66.66 0 0 1 1.143 0l2.398 4.153a1.19 1.19 0 0 1-1.031 1.785l-.948-.237a1.037 1.037 0 0 0-.714.078c-.206.103-.44.135-.666.09l-.752-.151a3.304 3.304 0 0 0-1.109-.03c-.703.101-1.23-.65-.875-1.265l2.554-4.423Z",
                fill: "#71C171"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M607.27 90.538c0 8.03-6.268 18.308-14 18.308s-14-10.278-14-18.308c0-8.029 6.268-14.538 14-14.538s14 6.51 14 14.538Z",
                fill: "#83DA85"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M598.582 82a9.09 9.09 0 0 1 1 1.217m1.5 10.783c1.085-3.04.747-5.823-.056-8-.136-.37-.286-.722-.444-1.055",
                stroke: "#F7F4FF",
                strokeLinecap: "round"
            })
        ]
    });
var $0a430150a2655694$export$2e2bcd8739ae039 = $0a430150a2655694$var$SvgTenantModalFireworks;


parcelRequire("8Mb3E");
var $cfL6o = parcelRequire("cfL6o");

var $jGWQ4 = parcelRequire("jGWQ4");

var $66ixW = parcelRequire("66ixW");

var $5vVWy = parcelRequire("5vVWy");
parcelRequire("9zW7e");
var $jSb9j = parcelRequire("jSb9j");

var $voszV = parcelRequire("voszV");

var $7VnwS = parcelRequire("7VnwS");
const $dad5317382253f6d$var$useConfigs = ()=>{
    const { isAuthenticated: isAuthenticated, error: authError } = (0, $jSb9j.useLogto)();
    const shouldFetch = isAuthenticated && !authError;
    const { data: configs, error: error, mutate: mutate } = (0, $voszV.default)(shouldFetch && "api/configs/admin-console");
    const api = (0, $7VnwS.default)();
    const updateConfigs = async (json)=>{
        const updatedConfigs = await api.patch("api/configs/admin-console", {
            json: json
        }).json();
        mutate(updatedConfigs);
    };
    return {
        isLoading: !configs && !error,
        configs: configs,
        error: error,
        mutate: mutate,
        updateConfigs: updateConfigs
    };
};
var $dad5317382253f6d$export$2e2bcd8739ae039 = $dad5317382253f6d$var$useConfigs;




var $jheqv = parcelRequire("jheqv");

var $dW2kG = parcelRequire("dW2kG");
var $c44801001261a370$export$a7db06668cad9adb;
var $c44801001261a370$export$e1a536b96d046f66;
var $c44801001261a370$export$2e4cabdda5b7ccbd;
var $c44801001261a370$export$af5dcc21c8ae7acc;
var $c44801001261a370$export$464c821cd4347539;
var $c44801001261a370$export$2469d05e9fc95e3a;
var $c44801001261a370$export$bfd64c937657f93a;
var $c44801001261a370$export$4a6dd88bada4e7d2;
var $c44801001261a370$export$59ae2c325a998f89;
var $c44801001261a370$export$fb184b623420d9be;
$c44801001261a370$export$a7db06668cad9adb = `X6m6Xa_content`;
$c44801001261a370$export$e1a536b96d046f66 = `X6m6Xa_fireworks`;
$c44801001261a370$export$2e4cabdda5b7ccbd = `X6m6Xa_fireworksImage`;
$c44801001261a370$export$af5dcc21c8ae7acc = `X6m6Xa_headerIcon`;
$c44801001261a370$export$464c821cd4347539 = `X6m6Xa_hint`;
$c44801001261a370$export$2469d05e9fc95e3a = `X6m6Xa_modalLayoutWrapper`;
$c44801001261a370$export$bfd64c937657f93a = `X6m6Xa_rotating`;
$c44801001261a370$export$4a6dd88bada4e7d2 = `X6m6Xa_shimmer`;
$c44801001261a370$export$59ae2c325a998f89 = `X6m6Xa_strong`;
$c44801001261a370$export$fb184b623420d9be = `X6m6Xa_title`;


/**
 * This modal is used to notify the user that the tenant env has been migrated.
 *
 * In our new development tenant feature, the old tenant env `staging` is deprecated,
 * we migrated the existing paid tenant's env to 'production', and the existing free 'staging' tenant's env to 'production'.
 *
 * For the original paid and free staging tenants, we will show the migration hint to notify the user that the tenant env has been migrated to 'production'.
 */ function $65b6e77c6168631d$var$TenantEnvMigrationModal() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const theme = (0, $jheqv.default)();
    const HeaderIcon = theme === (0, $5HVJe.Theme).Light ? (0, $3375a03c502d1508$export$2e2bcd8739ae039) : (0, $238bd383b42e71b0$export$2e2bcd8739ae039);
    const { configs: configs, updateConfigs: updateConfigs } = (0, $dad5317382253f6d$export$2e2bcd8739ae039)();
    const { developmentTenantMigrationNotification: migrationData } = configs ?? {};
    const { getDocumentationUrl: getDocumentationUrl } = (0, $b595fc2f0eccd19a$export$2e2bcd8739ae039)();
    const onClose = (0, $jC8Vy.useCallback)(async ()=>{
        if (!migrationData) return;
        await updateConfigs({
            developmentTenantMigrationNotification: {
                ...migrationData,
                readAt: Date.now()
            }
        });
    }, [
        migrationData,
        updateConfigs
    ]);
    if (!migrationData || migrationData.readAt) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        isOpen: true,
        shouldCloseOnEsc: true,
        className: $dW2kG.content,
        overlayClassName: $dW2kG.overlay,
        onRequestClose: onClose,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $c44801001261a370$export$2469d05e9fc95e3a,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5vVWy.default), {
                        isWordWrapEnabled: true,
                        headerIcon: /*#__PURE__*/ (0, $C7mD2.jsx)(HeaderIcon, {
                            className: $c44801001261a370$export$af5dcc21c8ae7acc
                        }),
                        title: "tenants.dev_tenant_migration.title",
                        footer: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.LinkButton), {
                                    title: "tenants.dev_tenant_migration.about_tenant_type",
                                    size: "large",
                                    href: getDocumentationUrl((0, $cfL6o.envTagsFeatureLink)),
                                    targetBlank: "noopener"
                                }),
                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                                    title: "general.got_it",
                                    size: "large",
                                    type: "primary",
                                    onClick: onClose
                                })
                            ]
                        }),
                        onClose: onClose,
                        children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                            className: $c44801001261a370$export$a7db06668cad9adb,
                            children: [
                                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                    className: $c44801001261a370$export$fb184b623420d9be,
                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                        forKey: "tenants.dev_tenant_migration.affect_title"
                                    })
                                }),
                                /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                    className: $c44801001261a370$export$464c821cd4347539,
                                    children: [
                                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                                                components: {
                                                    strong: /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                                                        className: $c44801001261a370$export$59ae2c325a998f89
                                                    })
                                                },
                                                children: t("tenants.dev_tenant_migration.hint_1")
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                                                components: {
                                                    strong: /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                                                        className: $c44801001261a370$export$59ae2c325a998f89
                                                    })
                                                },
                                                children: t("tenants.dev_tenant_migration.hint_2")
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                            children: t("tenants.dev_tenant_migration.hint_3")
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $c44801001261a370$export$e1a536b96d046f66,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0a430150a2655694$export$2e2bcd8739ae039), {
                            className: $c44801001261a370$export$2e4cabdda5b7ccbd
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($685167181ed329d5$exports))), {
                recycle: false
            })
        ]
    });
}
var $65b6e77c6168631d$export$2e2bcd8739ae039 = $65b6e77c6168631d$var$TenantEnvMigrationModal;


function $55b36b0a2b6469ee$var$TenantNotificationContainer() {
    const { currentTenant: currentTenant, isDevTenant: isDevTenant } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const isTenantSuspended = currentTenant?.isSuspended;
    if (!(0, $8TpMk.isCloud) || isTenantSuspended) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            !isDevTenant && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8781336d9fda2936$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $d24da6b4d4bd925f$export$2e2bcd8739ae039), {})
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fd7e5b71da5ec15a$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $65b6e77c6168631d$export$2e2bcd8739ae039), {})
        ]
    });
}
var $55b36b0a2b6469ee$export$2e2bcd8739ae039 = $55b36b0a2b6469ee$var$TenantNotificationContainer;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");


parcelRequire("8Mb3E");
var $cfL6o = parcelRequire("cfL6o");

var $jGWQ4 = parcelRequire("jGWQ4");

var $66ixW = parcelRequire("66ixW");

var $jheqv = parcelRequire("jheqv");
var $43ed38b1d79bc0ac$export$6d59db4903f20f7d;
var $43ed38b1d79bc0ac$export$5c452ff88e35e47d;
var $43ed38b1d79bc0ac$export$9126ebe212f3bdac;
var $43ed38b1d79bc0ac$export$bfd64c937657f93a;
var $43ed38b1d79bc0ac$export$4a6dd88bada4e7d2;
var $43ed38b1d79bc0ac$export$8cbac80413230349;
var $43ed38b1d79bc0ac$export$fb184b623420d9be;
$43ed38b1d79bc0ac$export$6d59db4903f20f7d = `fTcdFG_description`;
$43ed38b1d79bc0ac$export$5c452ff88e35e47d = `fTcdFG_image`;
$43ed38b1d79bc0ac$export$9126ebe212f3bdac = `fTcdFG_linkButton`;
$43ed38b1d79bc0ac$export$bfd64c937657f93a = `fTcdFG_rotating`;
$43ed38b1d79bc0ac$export$4a6dd88bada4e7d2 = `fTcdFG_shimmer`;
$43ed38b1d79bc0ac$export$8cbac80413230349 = `fTcdFG_suspendedPage`;
$43ed38b1d79bc0ac$export$fb184b623420d9be = `fTcdFG_title`;


function $2b88a7637e642e85$var$TenantSuspendedPage() {
    const theme = (0, $jheqv.default)();
    const ErrorImage = theme === (0, $5HVJe.Theme).Light ? (0, $109203ec5ef38646$export$2e2bcd8739ae039) : (0, $1c8635f1253c6c64$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $43ed38b1d79bc0ac$export$8cbac80413230349,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)(ErrorImage, {
                className: $43ed38b1d79bc0ac$export$5c452ff88e35e47d
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $43ed38b1d79bc0ac$export$fb184b623420d9be,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                    forKey: "tenants.tenant_suspended_page.title"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $43ed38b1d79bc0ac$export$6d59db4903f20f7d,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                    forKey: "tenants.tenant_suspended_page.description_1"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $43ed38b1d79bc0ac$export$6d59db4903f20f7d,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                    forKey: "tenants.tenant_suspended_page.description_2"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("a", {
                href: (0, $cfL6o.contactEmailLink),
                className: $43ed38b1d79bc0ac$export$9126ebe212f3bdac,
                rel: "noopener",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                    title: "general.contact_us_action",
                    type: "outline"
                })
            })
        ]
    });
}
var $2b88a7637e642e85$export$2e2bcd8739ae039 = $2b88a7637e642e85$var$TenantSuspendedPage;


var $c8d13818543fa62c$export$729c8b7179294ba;
var $c8d13818543fa62c$export$bfd64c937657f93a;
var $c8d13818543fa62c$export$4a6dd88bada4e7d2;
var $c8d13818543fa62c$export$38c1c9d77d97076;
$c8d13818543fa62c$export$729c8b7179294ba = `wZF7yG_app`;
$c8d13818543fa62c$export$bfd64c937657f93a = `wZF7yG_rotating`;
$c8d13818543fa62c$export$4a6dd88bada4e7d2 = `wZF7yG_shimmer`;
$c8d13818543fa62c$export$38c1c9d77d97076 = `wZF7yG_topbarShadow`;


function $ed805787af27257d$export$2e2bcd8739ae039() {
    const { isLoading: isLoadingPreference } = (0, $c83ac2f0f8302d6c$export$2e2bcd8739ae039)();
    const { currentTenant: currentTenant } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const isTenantSuspended = (0, $8TpMk.isCloud) && currentTenant?.isSuspended;
    const { isLoading: isLoadingSubscriptionData, ...subscriptionDta } = (0, $480e7e0d8d19d84c$export$2e2bcd8739ae039)();
    const scrollableContent = (0, $jC8Vy.useRef)(null);
    const { scrollTop: scrollTop } = (0, $95YIy.default)(scrollableContent.current);
    const isLoading = isLoadingPreference || isLoadingSubscriptionData;
    if (isLoading || !currentTenant) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4c070a72a1cf87ce$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $19434c930f80c964$export$2e2bcd8739ae039), {
        subscriptionData: subscriptionDta,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $c8d13818543fa62c$export$729c8b7179294ba,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8f0e3b0e6954789f$export$2e2bcd8739ae039), {
                        className: (0, $7oDSS.conditional)(scrollTop && $c8d13818543fa62c$export$38c1c9d77d97076)
                    }),
                    isTenantSuspended && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2b88a7637e642e85$export$2e2bcd8739ae039), {}),
                    !isTenantSuspended && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Outlet), {
                        context: {
                            scrollableContent: scrollableContent
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $55b36b0a2b6469ee$export$2e2bcd8739ae039), {})
        ]
    });
}
function $ed805787af27257d$export$468d45f4f0fe384a() {
    const { tenantId: tenantId } = (0, $2Phw0.useParams)();
    const { firstItem: firstItem } = (0, $290219f9f98d0883$export$74c84f4d9513e4e1)();
    if (!firstItem) throw new Error("First sidebar item not found");
    if (!tenantId) throw new Error("Tenant ID not found");
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Navigate), {
        replace: true,
        to: (0, $gcHb7.joinPath)(tenantId, (0, $698f86671730b31d$export$2aa3fd96c49a84a8)(firstItem.title))
    });
}



var $C7mD2 = parcelRequire("C7mD2");

var $2Phw0 = parcelRequire("2Phw0");

var $8TpMk = parcelRequire("8TpMk");

var $aTllQ = parcelRequire("aTllQ");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");

var $8TpMk = parcelRequire("8TpMk");

var $C7mD2 = parcelRequire("C7mD2");


var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $51dd3d952d9b6d71$exports = {};

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $51dd3d952d9b6d71$var$isEqual(value, other) {
    return $1c23a95357bef7bf$exports(value, other);
}
$51dd3d952d9b6d71$exports = $51dd3d952d9b6d71$var$isEqual;


var $044ab485528b5c52$exports = {};
var $0ec33415b6cee0b7$exports = {};


/** `Object#toString` result references. */ var $0ec33415b6cee0b7$var$numberTag = "[object Number]";
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $0ec33415b6cee0b7$var$isNumber(value) {
    return typeof value == "number" || $a35b73cb295f324c$exports(value) && $d607e1880b829c8a$exports(value) == $0ec33415b6cee0b7$var$numberTag;
}
$0ec33415b6cee0b7$exports = $0ec33415b6cee0b7$var$isNumber;


/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */ function $044ab485528b5c52$var$isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return $0ec33415b6cee0b7$exports(value) && value != +value;
}
$044ab485528b5c52$exports = $044ab485528b5c52$var$isNaN;


var $341369312ca6ec3a$exports = {};
var $2852e70d87210654$exports = {};

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $2852e70d87210654$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$bd288f840efc8d52$exports(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
$2852e70d87210654$exports = $2852e70d87210654$var$baseExtremum;


var $25127638e3d65e70$exports = {};
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $25127638e3d65e70$var$baseGt(value, other) {
    return value > other;
}
$25127638e3d65e70$exports = $25127638e3d65e70$var$baseGt;



/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $341369312ca6ec3a$var$max(array) {
    return array && array.length ? $2852e70d87210654$exports(array, $57b7bffe2f9def0f$exports, $25127638e3d65e70$exports) : undefined;
}
$341369312ca6ec3a$exports = $341369312ca6ec3a$var$max;




var $2ff7692bd8c10edb$exports = {};
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $2ff7692bd8c10edb$var$isNil(value) {
    return value == null;
}
$2ff7692bd8c10edb$exports = $2ff7692bd8c10edb$var$isNil;




var $jC8Vy = parcelRequire("jC8Vy");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $bD9Bx = parcelRequire("bD9Bx");
var $f28f24f368f31a49$exports = {};
(function(global, factory) {
    factory($f28f24f368f31a49$exports);
})($f28f24f368f31a49$exports, function(exports1) {
    "use strict";
    var HAS_WEAKSET_SUPPORT = typeof WeakSet === "function";
    var keys = Object.keys;
    /**
   * are the values passed strictly equal or both NaN
   *
   * @param a the value to compare against
   * @param b the value to test
   * @returns are the values equal by the SameValueZero principle
   */ function sameValueZeroEqual(a, b) {
        return a === b || a !== a && b !== b;
    }
    /**
   * is the value a plain object
   *
   * @param value the value to test
   * @returns is the value a plain object
   */ function isPlainObject(value) {
        return value.constructor === Object || value.constructor == null;
    }
    /**
   * is the value promise-like (meaning it is thenable)
   *
   * @param value the value to test
   * @returns is the value promise-like
   */ function isPromiseLike(value) {
        return !!value && typeof value.then === "function";
    }
    /**
   * is the value passed a react element
   *
   * @param value the value to test
   * @returns is the value a react element
   */ function isReactElement(value) {
        return !!(value && value.$$typeof);
    }
    /**
   * in cases where WeakSet is not supported, creates a new custom
   * object that mimics the necessary API aspects for cache purposes
   *
   * @returns the new cache object
   */ function getNewCacheFallback() {
        var values = [];
        return {
            add: function(value) {
                values.push(value);
            },
            has: function(value) {
                return values.indexOf(value) !== -1;
            }
        };
    }
    /**
   * get a new cache object to prevent circular references
   *
   * @returns the new cache object
   */ var getNewCache = function(canUseWeakMap) {
        if (canUseWeakMap) return function _getNewCache() {
            return new WeakSet();
        };
        return getNewCacheFallback;
    }(HAS_WEAKSET_SUPPORT);
    /**
   * create a custom isEqual handler specific to circular objects
   *
   * @param [isEqual] the isEqual comparator to use instead of isDeepEqual
   * @returns the method to create the `isEqual` function
   */ function createCircularEqualCreator(isEqual) {
        return function createCircularEqual(comparator) {
            var _comparator = isEqual || comparator;
            return function circularEqual(a, b, cache) {
                if (cache === void 0) cache = getNewCache();
                var isCacheableA = !!a && typeof a === "object";
                var isCacheableB = !!b && typeof b === "object";
                if (isCacheableA || isCacheableB) {
                    var hasA = isCacheableA && cache.has(a);
                    var hasB = isCacheableB && cache.has(b);
                    if (hasA || hasB) return hasA && hasB;
                    if (isCacheableA) cache.add(a);
                    if (isCacheableB) cache.add(b);
                }
                return _comparator(a, b, cache);
            };
        };
    }
    /**
   * are the arrays equal in value
   *
   * @param a the array to test
   * @param b the array to test against
   * @param isEqual the comparator to determine equality
   * @param meta the meta object to pass through
   * @returns are the arrays equal
   */ function areArraysEqual(a, b, isEqual, meta) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (!isEqual(a[index], b[index], meta)) return false;
        }
        return true;
    }
    /**
   * are the maps equal in value
   *
   * @param a the map to test
   * @param b the map to test against
   * @param isEqual the comparator to determine equality
   * @param meta the meta map to pass through
   * @returns are the maps equal
   */ function areMapsEqual(a, b, isEqual, meta) {
        var isValueEqual = a.size === b.size;
        if (isValueEqual && a.size) {
            var matchedIndices_1 = {};
            a.forEach(function(aValue, aKey) {
                if (isValueEqual) {
                    var hasMatch_1 = false;
                    var matchIndex_1 = 0;
                    b.forEach(function(bValue, bKey) {
                        if (!hasMatch_1 && !matchedIndices_1[matchIndex_1]) {
                            hasMatch_1 = isEqual(aKey, bKey, meta) && isEqual(aValue, bValue, meta);
                            if (hasMatch_1) matchedIndices_1[matchIndex_1] = true;
                        }
                        matchIndex_1++;
                    });
                    isValueEqual = hasMatch_1;
                }
            });
        }
        return isValueEqual;
    }
    var OWNER = "_owner";
    var hasOwnProperty = Function.prototype.bind.call(Function.prototype.call, Object.prototype.hasOwnProperty);
    /**
   * are the objects equal in value
   *
   * @param a the object to test
   * @param b the object to test against
   * @param isEqual the comparator to determine equality
   * @param meta the meta object to pass through
   * @returns are the objects equal
   */ function areObjectsEqual(a, b, isEqual, meta) {
        var keysA = keys(a);
        var index = keysA.length;
        if (keys(b).length !== index) return false;
        if (index) {
            var key = void 0;
            while(index-- > 0){
                key = keysA[index];
                if (key === OWNER) {
                    var reactElementA = isReactElement(a);
                    var reactElementB = isReactElement(b);
                    if ((reactElementA || reactElementB) && reactElementA !== reactElementB) return false;
                }
                if (!hasOwnProperty(b, key) || !isEqual(a[key], b[key], meta)) return false;
            }
        }
        return true;
    }
    /**
   * are the regExps equal in value
   *
   * @param a the regExp to test
   * @param b the regExp to test agains
   * @returns are the regExps equal
   */ function areRegExpsEqual(a, b) {
        return a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.unicode === b.unicode && a.sticky === b.sticky && a.lastIndex === b.lastIndex;
    }
    /**
   * are the sets equal in value
   *
   * @param a the set to test
   * @param b the set to test against
   * @param isEqual the comparator to determine equality
   * @param meta the meta set to pass through
   * @returns are the sets equal
   */ function areSetsEqual(a, b, isEqual, meta) {
        var isValueEqual = a.size === b.size;
        if (isValueEqual && a.size) {
            var matchedIndices_2 = {};
            a.forEach(function(aValue) {
                if (isValueEqual) {
                    var hasMatch_2 = false;
                    var matchIndex_2 = 0;
                    b.forEach(function(bValue) {
                        if (!hasMatch_2 && !matchedIndices_2[matchIndex_2]) {
                            hasMatch_2 = isEqual(aValue, bValue, meta);
                            if (hasMatch_2) matchedIndices_2[matchIndex_2] = true;
                        }
                        matchIndex_2++;
                    });
                    isValueEqual = hasMatch_2;
                }
            });
        }
        return isValueEqual;
    }
    var HAS_MAP_SUPPORT = typeof Map === "function";
    var HAS_SET_SUPPORT = typeof Set === "function";
    function createComparator(createIsEqual) {
        var isEqual = /* eslint-disable no-use-before-define */ typeof createIsEqual === "function" ? createIsEqual(comparator) : comparator;
        /* eslint-enable */ /**
       * compare the value of the two objects and return true if they are equivalent in values
       *
       * @param a the value to test against
       * @param b the value to test
       * @param [meta] an optional meta object that is passed through to all equality test calls
       * @returns are a and b equivalent in value
       */ function comparator(a, b, meta) {
            if (a === b) return true;
            if (a && b && typeof a === "object" && typeof b === "object") {
                if (isPlainObject(a) && isPlainObject(b)) return areObjectsEqual(a, b, isEqual, meta);
                var aShape = Array.isArray(a);
                var bShape = Array.isArray(b);
                if (aShape || bShape) return aShape === bShape && areArraysEqual(a, b, isEqual, meta);
                aShape = a instanceof Date;
                bShape = b instanceof Date;
                if (aShape || bShape) return aShape === bShape && sameValueZeroEqual(a.getTime(), b.getTime());
                aShape = a instanceof RegExp;
                bShape = b instanceof RegExp;
                if (aShape || bShape) return aShape === bShape && areRegExpsEqual(a, b);
                if (isPromiseLike(a) || isPromiseLike(b)) return a === b;
                if (HAS_MAP_SUPPORT) {
                    aShape = a instanceof Map;
                    bShape = b instanceof Map;
                    if (aShape || bShape) return aShape === bShape && areMapsEqual(a, b, isEqual, meta);
                }
                if (HAS_SET_SUPPORT) {
                    aShape = a instanceof Set;
                    bShape = b instanceof Set;
                    if (aShape || bShape) return aShape === bShape && areSetsEqual(a, b, isEqual, meta);
                }
                return areObjectsEqual(a, b, isEqual, meta);
            }
            return a !== a && b !== b;
        }
        return comparator;
    }
    var deepEqual = createComparator();
    var shallowEqual = createComparator(function() {
        return sameValueZeroEqual;
    });
    var circularDeepEqual = createComparator(createCircularEqualCreator());
    var circularShallowEqual = createComparator(createCircularEqualCreator(sameValueZeroEqual));
    exports1.circularDeepEqual = circularDeepEqual;
    exports1.circularShallowEqual = circularShallowEqual;
    exports1.createCustomEqual = createComparator;
    exports1.deepEqual = deepEqual;
    exports1.sameValueZeroEqual = sameValueZeroEqual;
    exports1.shallowEqual = shallowEqual;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});


function $9c3ff5a8a725b5e1$export$2e2bcd8739ae039(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var currTime = -1;
    var shouldUpdate = function shouldUpdate(now) {
        if (currTime < 0) currTime = now;
        if (now - currTime > timeout) {
            callback(now);
            currTime = -1;
        } else requestAnimationFrame(shouldUpdate);
    };
    requestAnimationFrame(shouldUpdate);
}


function $d43c672d1cb92645$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d43c672d1cb92645$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $d43c672d1cb92645$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d43c672d1cb92645$var$_typeof(obj);
}
function $d43c672d1cb92645$var$_toArray(arr) {
    return $d43c672d1cb92645$var$_arrayWithHoles(arr) || $d43c672d1cb92645$var$_iterableToArray(arr) || $d43c672d1cb92645$var$_unsupportedIterableToArray(arr) || $d43c672d1cb92645$var$_nonIterableRest();
}
function $d43c672d1cb92645$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d43c672d1cb92645$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d43c672d1cb92645$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d43c672d1cb92645$var$_arrayLikeToArray(o, minLen);
}
function $d43c672d1cb92645$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d43c672d1cb92645$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $d43c672d1cb92645$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $d43c672d1cb92645$export$2e2bcd8739ae039() {
    var currStyle = {};
    var handleChange = function handleChange() {
        return null;
    };
    var shouldStop = false;
    var setStyle = function setStyle(_style) {
        if (shouldStop) return;
        if (Array.isArray(_style)) {
            if (!_style.length) return;
            var styles = _style;
            var _styles = $d43c672d1cb92645$var$_toArray(styles), curr = _styles[0], restStyles = _styles.slice(1);
            if (typeof curr === "number") {
                (0, $9c3ff5a8a725b5e1$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles), curr);
                return;
            }
            setStyle(curr);
            (0, $9c3ff5a8a725b5e1$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles));
            return;
        }
        if ($d43c672d1cb92645$var$_typeof(_style) === "object") {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === "function") _style();
    };
    return {
        stop: function stop() {
            shouldStop = true;
        },
        start: function start(style) {
            shouldStop = false;
            setStyle(style);
        },
        subscribe: function subscribe(_handleChange) {
            handleChange = _handleChange;
            return function() {
                handleChange = function handleChange() {
                    return null;
                };
            };
        }
    };
}


function $88a16dea13c3b732$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $88a16dea13c3b732$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $88a16dea13c3b732$var$ownKeys(Object(source), true).forEach(function(key) {
            $88a16dea13c3b732$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $88a16dea13c3b732$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $88a16dea13c3b732$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/* eslint no-console: 0 */ var $88a16dea13c3b732$var$PREFIX_LIST = [
    "Webkit",
    "Moz",
    "O",
    "ms"
];
var $88a16dea13c3b732$var$IN_LINE_PREFIX_LIST = [
    "-webkit-",
    "-moz-",
    "-o-",
    "-ms-"
];
var $88a16dea13c3b732$var$IN_COMPATIBLE_PROPERTY = [
    "transform",
    "transformOrigin",
    "transition"
];
var $88a16dea13c3b732$export$59e29973723da0b3 = function getIntersectionKeys(preObj, nextObj) {
    return [
        Object.keys(preObj),
        Object.keys(nextObj)
    ].reduce(function(a, b) {
        return a.filter(function(c) {
            return b.includes(c);
        });
    });
};
var $88a16dea13c3b732$export$f0954fd7d5368655 = function identity(param) {
    return param;
};
var $88a16dea13c3b732$export$51610fddbf64bc9d = function getDashCase(name) {
    return name.replace(/([A-Z])/g, function(v) {
        return "-".concat(v.toLowerCase());
    });
};
var $88a16dea13c3b732$export$4a9169b65825efee = function generatePrefixStyle(name, value) {
    if ($88a16dea13c3b732$var$IN_COMPATIBLE_PROPERTY.indexOf(name) === -1) return $88a16dea13c3b732$var$_defineProperty({}, name, value);
    var isTransition = name === "transition";
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var styleVal = value;
    return $88a16dea13c3b732$var$PREFIX_LIST.reduce(function(result, property, i) {
        if (isTransition) styleVal = value.replace(/(transform|transform-origin)/gim, "".concat($88a16dea13c3b732$var$IN_LINE_PREFIX_LIST[i], "$1"));
        return $88a16dea13c3b732$var$_objectSpread($88a16dea13c3b732$var$_objectSpread({}, result), {}, $88a16dea13c3b732$var$_defineProperty({}, property + camelName, styleVal));
    }, {});
};
var $88a16dea13c3b732$export$bef1f36f5486a6a3 = function log() {
    var _console;
    (_console = console).log.apply(_console, arguments);
};
var $88a16dea13c3b732$export$1c9f709888824e05 = function debug(name) {
    return function(item) {
        $88a16dea13c3b732$export$bef1f36f5486a6a3(name, item);
        return item;
    };
};
var $88a16dea13c3b732$export$1dc45301cd23a8c7 = function debugf(tag, f) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var res = f.apply(void 0, args);
        var name = tag || f.name || "anonymous function";
        var argNames = "(".concat(args.map(JSON.stringify).join(", "), ")");
        $88a16dea13c3b732$export$bef1f36f5486a6a3("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
        return res;
    };
};
var $88a16dea13c3b732$export$d6051a0f7a227332 = function mapObject(fn, obj) {
    return Object.keys(obj).reduce(function(res, key) {
        return $88a16dea13c3b732$var$_objectSpread($88a16dea13c3b732$var$_objectSpread({}, res), {}, $88a16dea13c3b732$var$_defineProperty({}, key, fn(key, obj[key])));
    }, {});
};
var $88a16dea13c3b732$export$ff9926a5d1daa67c = function translateStyle(style) {
    return Object.keys(style).reduce(function(res, key) {
        return $88a16dea13c3b732$var$_objectSpread($88a16dea13c3b732$var$_objectSpread({}, res), $88a16dea13c3b732$export$4a9169b65825efee(key, res[key]));
    }, style);
};
var $88a16dea13c3b732$export$f672e0b6f7222cd7 = function compose() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (!args.length) return $88a16dea13c3b732$export$f0954fd7d5368655;
    var fns = args.reverse(); // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var $88a16dea13c3b732$export$1594c78389ee3429 = function getTransitionVal(props, duration, easing) {
    return props.map(function(prop) {
        return "".concat($88a16dea13c3b732$export$51610fddbf64bc9d(prop), " ").concat(duration, "ms ").concat(easing);
    }).join(",");
};
var $88a16dea13c3b732$var$isDev = false;
var $88a16dea13c3b732$export$c106dd0671a0fc2d = function warn(condition, format, a, b, c, d, e, f) {
    if ($88a16dea13c3b732$var$isDev && typeof console !== "undefined" && console.warn) {
        if (format === undefined) console.warn("LogUtils requires an error message argument");
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var args = [
                    a,
                    b,
                    c,
                    d,
                    e,
                    f
                ];
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};


function $f2c6a684592a87fa$var$_slicedToArray(arr, i) {
    return $f2c6a684592a87fa$var$_arrayWithHoles(arr) || $f2c6a684592a87fa$var$_iterableToArrayLimit(arr, i) || $f2c6a684592a87fa$var$_unsupportedIterableToArray(arr, i) || $f2c6a684592a87fa$var$_nonIterableRest();
}
function $f2c6a684592a87fa$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f2c6a684592a87fa$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $f2c6a684592a87fa$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $f2c6a684592a87fa$var$_toConsumableArray(arr) {
    return $f2c6a684592a87fa$var$_arrayWithoutHoles(arr) || $f2c6a684592a87fa$var$_iterableToArray(arr) || $f2c6a684592a87fa$var$_unsupportedIterableToArray(arr) || $f2c6a684592a87fa$var$_nonIterableSpread();
}
function $f2c6a684592a87fa$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f2c6a684592a87fa$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f2c6a684592a87fa$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f2c6a684592a87fa$var$_arrayLikeToArray(o, minLen);
}
function $f2c6a684592a87fa$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $f2c6a684592a87fa$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $f2c6a684592a87fa$var$_arrayLikeToArray(arr);
}
function $f2c6a684592a87fa$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $f2c6a684592a87fa$var$ACCURACY = 1e-4;
var $f2c6a684592a87fa$var$cubicBezierFactor = function cubicBezierFactor(c1, c2) {
    return [
        0,
        3 * c1,
        3 * c2 - 6 * c1,
        3 * c1 - 3 * c2 + 1
    ];
};
var $f2c6a684592a87fa$var$multyTime = function multyTime(params, t) {
    return params.map(function(param, i) {
        return param * Math.pow(t, i);
    }).reduce(function(pre, curr) {
        return pre + curr;
    });
};
var $f2c6a684592a87fa$var$cubicBezier = function cubicBezier(c1, c2) {
    return function(t) {
        var params = $f2c6a684592a87fa$var$cubicBezierFactor(c1, c2);
        return $f2c6a684592a87fa$var$multyTime(params, t);
    };
};
var $f2c6a684592a87fa$var$derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
    return function(t) {
        var params = $f2c6a684592a87fa$var$cubicBezierFactor(c1, c2);
        var newParams = [].concat($f2c6a684592a87fa$var$_toConsumableArray(params.map(function(param, i) {
            return param * i;
        }).slice(1)), [
            0
        ]);
        return $f2c6a684592a87fa$var$multyTime(newParams, t);
    };
}; // calculate cubic-bezier using Newton's method
var $f2c6a684592a87fa$export$56c51296f72f0592 = function configBezier() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var x1 = args[0], y1 = args[1], x2 = args[2], y2 = args[3];
    if (args.length === 1) switch(args[0]){
        case "linear":
            x1 = 0.0;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case "ease":
            x1 = 0.25;
            y1 = 0.1;
            x2 = 0.25;
            y2 = 1.0;
            break;
        case "ease-in":
            x1 = 0.42;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case "ease-out":
            x1 = 0.42;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        case "ease-in-out":
            x1 = 0.0;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        default:
            var easing = args[0].split("(");
            if (easing[0] === "cubic-bezier" && easing[1].split(")")[0].split(",").length === 4) {
                var _easing$1$split$0$spl = easing[1].split(")")[0].split(",").map(function(x) {
                    return parseFloat(x);
                });
                var _easing$1$split$0$spl2 = $f2c6a684592a87fa$var$_slicedToArray(_easing$1$split$0$spl, 4);
                x1 = _easing$1$split$0$spl2[0];
                y1 = _easing$1$split$0$spl2[1];
                x2 = _easing$1$split$0$spl2[2];
                y2 = _easing$1$split$0$spl2[3];
            } else (0, $88a16dea13c3b732$export$c106dd0671a0fc2d)(false, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", args);
    }
    (0, $88a16dea13c3b732$export$c106dd0671a0fc2d)([
        x1,
        x2,
        y1,
        y2
    ].every(function(num) {
        return typeof num === "number" && num >= 0 && num <= 1;
    }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", args);
    var curveX = $f2c6a684592a87fa$var$cubicBezier(x1, x2);
    var curveY = $f2c6a684592a87fa$var$cubicBezier(y1, y2);
    var derCurveX = $f2c6a684592a87fa$var$derivativeCubicBezier(x1, x2);
    var rangeValue = function rangeValue(value) {
        if (value > 1) return 1;
        else if (value < 0) return 0;
        return value;
    };
    var bezier = function bezier(_t) {
        var t = _t > 1 ? 1 : _t;
        var x = t;
        for(var i = 0; i < 8; ++i){
            var evalT = curveX(x) - t;
            var derVal = derCurveX(x);
            if (Math.abs(evalT - t) < $f2c6a684592a87fa$var$ACCURACY || derVal < $f2c6a684592a87fa$var$ACCURACY) return curveY(x);
            x = rangeValue(x - evalT / derVal);
        }
        return curveY(x);
    };
    bezier.isStepper = false;
    return bezier;
};
var $f2c6a684592a87fa$export$12fc25daf62b865a = function configSpring() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$stiff = config.stiff, stiff = _config$stiff === void 0 ? 100 : _config$stiff, _config$damping = config.damping, damping = _config$damping === void 0 ? 8 : _config$damping, _config$dt = config.dt, dt = _config$dt === void 0 ? 17 : _config$dt;
    var stepper = function stepper(currX, destX, currV) {
        var FSpring = -(currX - destX) * stiff;
        var FDamping = currV * damping;
        var newV = currV + (FSpring - FDamping) * dt / 1000;
        var newX = currV * dt / 1000 + currX;
        if (Math.abs(newX - destX) < $f2c6a684592a87fa$var$ACCURACY && Math.abs(newV) < $f2c6a684592a87fa$var$ACCURACY) return [
            destX,
            0
        ];
        return [
            newX,
            newV
        ];
    };
    stepper.isStepper = true;
    stepper.dt = dt;
    return stepper;
};
var $f2c6a684592a87fa$export$e3e04925801e5434 = function configEasing() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    var easing = args[0];
    if (typeof easing === "string") switch(easing){
        case "ease":
        case "ease-in-out":
        case "ease-out":
        case "ease-in":
        case "linear":
            return $f2c6a684592a87fa$export$56c51296f72f0592(easing);
        case "spring":
            return $f2c6a684592a87fa$export$12fc25daf62b865a();
        default:
            if (easing.split("(")[0] === "cubic-bezier") return $f2c6a684592a87fa$export$56c51296f72f0592(easing);
            (0, $88a16dea13c3b732$export$c106dd0671a0fc2d)(false, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", args);
    }
    if (typeof easing === "function") return easing;
    (0, $88a16dea13c3b732$export$c106dd0671a0fc2d)(false, "[configEasing]: first argument type should be function or string, instead received %s", args);
    return null;
};



function $c03e0de2971db68c$var$_toConsumableArray(arr) {
    return $c03e0de2971db68c$var$_arrayWithoutHoles(arr) || $c03e0de2971db68c$var$_iterableToArray(arr) || $c03e0de2971db68c$var$_unsupportedIterableToArray(arr) || $c03e0de2971db68c$var$_nonIterableSpread();
}
function $c03e0de2971db68c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c03e0de2971db68c$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $c03e0de2971db68c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $c03e0de2971db68c$var$_arrayLikeToArray(arr);
}
function $c03e0de2971db68c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c03e0de2971db68c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $c03e0de2971db68c$var$ownKeys(Object(source), true).forEach(function(key) {
            $c03e0de2971db68c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $c03e0de2971db68c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c03e0de2971db68c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c03e0de2971db68c$var$_slicedToArray(arr, i) {
    return $c03e0de2971db68c$var$_arrayWithHoles(arr) || $c03e0de2971db68c$var$_iterableToArrayLimit(arr, i) || $c03e0de2971db68c$var$_unsupportedIterableToArray(arr, i) || $c03e0de2971db68c$var$_nonIterableRest();
}
function $c03e0de2971db68c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c03e0de2971db68c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c03e0de2971db68c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c03e0de2971db68c$var$_arrayLikeToArray(o, minLen);
}
function $c03e0de2971db68c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c03e0de2971db68c$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $c03e0de2971db68c$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $c03e0de2971db68c$var$alpha = function alpha(begin, end, k) {
    return begin + (end - begin) * k;
};
var $c03e0de2971db68c$var$needContinue = function needContinue(_ref) {
    var from = _ref.from, to = _ref.to;
    return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */ var $c03e0de2971db68c$var$calStepperVals = function calStepperVals(easing, preVals, steps) {
    var nextStepVals = (0, $88a16dea13c3b732$export$d6051a0f7a227332)(function(key, val) {
        if ($c03e0de2971db68c$var$needContinue(val)) {
            var _easing = easing(val.from, val.to, val.velocity), _easing2 = $c03e0de2971db68c$var$_slicedToArray(_easing, 2), newX = _easing2[0], newV = _easing2[1];
            return $c03e0de2971db68c$var$_objectSpread($c03e0de2971db68c$var$_objectSpread({}, val), {}, {
                from: newX,
                velocity: newV
            });
        }
        return val;
    }, preVals);
    if (steps < 1) return (0, $88a16dea13c3b732$export$d6051a0f7a227332)(function(key, val) {
        if ($c03e0de2971db68c$var$needContinue(val)) return $c03e0de2971db68c$var$_objectSpread($c03e0de2971db68c$var$_objectSpread({}, val), {}, {
            velocity: $c03e0de2971db68c$var$alpha(val.velocity, nextStepVals[key].velocity, steps),
            from: $c03e0de2971db68c$var$alpha(val.from, nextStepVals[key].from, steps)
        });
        return val;
    }, preVals);
    return calStepperVals(easing, nextStepVals, steps - 1);
}; // configure update function
var $c03e0de2971db68c$export$2e2bcd8739ae039 = function(from, to, easing, duration, render) {
    var interKeys = (0, $88a16dea13c3b732$export$59e29973723da0b3)(from, to);
    var timingStyle = interKeys.reduce(function(res, key) {
        return $c03e0de2971db68c$var$_objectSpread($c03e0de2971db68c$var$_objectSpread({}, res), {}, $c03e0de2971db68c$var$_defineProperty({}, key, [
            from[key],
            to[key]
        ]));
    }, {});
    var stepperStyle = interKeys.reduce(function(res, key) {
        return $c03e0de2971db68c$var$_objectSpread($c03e0de2971db68c$var$_objectSpread({}, res), {}, $c03e0de2971db68c$var$_defineProperty({}, key, {
            from: from[key],
            velocity: 0,
            to: to[key]
        }));
    }, {});
    var cafId = -1;
    var preTime;
    var beginTime;
    var update = function update() {
        return null;
    };
    var getCurrStyle = function getCurrStyle() {
        return (0, $88a16dea13c3b732$export$d6051a0f7a227332)(function(key, val) {
            return val.from;
        }, stepperStyle);
    };
    var shouldStopAnimation = function shouldStopAnimation() {
        return !Object.values(stepperStyle).filter($c03e0de2971db68c$var$needContinue).length;
    }; // stepper timing function like spring
    var stepperUpdate = function stepperUpdate(now) {
        if (!preTime) preTime = now;
        var deltaTime = now - preTime;
        var steps = deltaTime / easing.dt;
        stepperStyle = $c03e0de2971db68c$var$calStepperVals(easing, stepperStyle, steps); // get union set and add compatible prefix
        render($c03e0de2971db68c$var$_objectSpread($c03e0de2971db68c$var$_objectSpread($c03e0de2971db68c$var$_objectSpread({}, from), to), getCurrStyle(stepperStyle)));
        preTime = now;
        if (!shouldStopAnimation()) cafId = requestAnimationFrame(update);
    }; // t => val timing function like cubic-bezier
    var timingUpdate = function timingUpdate(now) {
        if (!beginTime) beginTime = now;
        var t = (now - beginTime) / duration;
        var currStyle = (0, $88a16dea13c3b732$export$d6051a0f7a227332)(function(key, val) {
            return $c03e0de2971db68c$var$alpha.apply(void 0, $c03e0de2971db68c$var$_toConsumableArray(val).concat([
                easing(t)
            ]));
        }, timingStyle); // get union set and add compatible prefix
        render($c03e0de2971db68c$var$_objectSpread($c03e0de2971db68c$var$_objectSpread($c03e0de2971db68c$var$_objectSpread({}, from), to), currStyle));
        if (t < 1) cafId = requestAnimationFrame(update);
        else {
            var finalStyle = (0, $88a16dea13c3b732$export$d6051a0f7a227332)(function(key, val) {
                return $c03e0de2971db68c$var$alpha.apply(void 0, $c03e0de2971db68c$var$_toConsumableArray(val).concat([
                    easing(1)
                ]));
            }, timingStyle);
            render($c03e0de2971db68c$var$_objectSpread($c03e0de2971db68c$var$_objectSpread($c03e0de2971db68c$var$_objectSpread({}, from), to), finalStyle));
        }
    };
    update = easing.isStepper ? stepperUpdate : timingUpdate; // return start animation method
    return function() {
        requestAnimationFrame(update); // return stop animation method
        return function() {
            cancelAnimationFrame(cafId);
        };
    };
};



function $7bd9593fbd65be39$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $7bd9593fbd65be39$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $7bd9593fbd65be39$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $7bd9593fbd65be39$var$_typeof(obj);
}
function $7bd9593fbd65be39$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $7bd9593fbd65be39$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $7bd9593fbd65be39$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $7bd9593fbd65be39$var$_toConsumableArray(arr) {
    return $7bd9593fbd65be39$var$_arrayWithoutHoles(arr) || $7bd9593fbd65be39$var$_iterableToArray(arr) || $7bd9593fbd65be39$var$_unsupportedIterableToArray(arr) || $7bd9593fbd65be39$var$_nonIterableSpread();
}
function $7bd9593fbd65be39$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7bd9593fbd65be39$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7bd9593fbd65be39$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7bd9593fbd65be39$var$_arrayLikeToArray(o, minLen);
}
function $7bd9593fbd65be39$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $7bd9593fbd65be39$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $7bd9593fbd65be39$var$_arrayLikeToArray(arr);
}
function $7bd9593fbd65be39$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $7bd9593fbd65be39$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7bd9593fbd65be39$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $7bd9593fbd65be39$var$ownKeys(Object(source), true).forEach(function(key) {
            $7bd9593fbd65be39$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $7bd9593fbd65be39$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7bd9593fbd65be39$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7bd9593fbd65be39$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7bd9593fbd65be39$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $7bd9593fbd65be39$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7bd9593fbd65be39$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7bd9593fbd65be39$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $7bd9593fbd65be39$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $7bd9593fbd65be39$var$_setPrototypeOf(subClass, superClass);
}
function $7bd9593fbd65be39$var$_setPrototypeOf(o, p) {
    $7bd9593fbd65be39$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7bd9593fbd65be39$var$_setPrototypeOf(o, p);
}
function $7bd9593fbd65be39$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $7bd9593fbd65be39$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $7bd9593fbd65be39$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $7bd9593fbd65be39$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $7bd9593fbd65be39$var$_possibleConstructorReturn(this, result);
    };
}
function $7bd9593fbd65be39$var$_possibleConstructorReturn(self, call) {
    if (call && ($7bd9593fbd65be39$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $7bd9593fbd65be39$var$_assertThisInitialized(self);
}
function $7bd9593fbd65be39$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7bd9593fbd65be39$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $7bd9593fbd65be39$var$_getPrototypeOf(o) {
    $7bd9593fbd65be39$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7bd9593fbd65be39$var$_getPrototypeOf(o);
}
var $7bd9593fbd65be39$var$Animate = /*#__PURE__*/ function(_PureComponent) {
    $7bd9593fbd65be39$var$_inherits(Animate, _PureComponent);
    var _super = $7bd9593fbd65be39$var$_createSuper(Animate);
    function Animate(props, context) {
        var _this;
        $7bd9593fbd65be39$var$_classCallCheck(this, Animate);
        _this = _super.call(this, props, context);
        var _this$props = _this.props, isActive = _this$props.isActive, attributeName = _this$props.attributeName, from = _this$props.from, to = _this$props.to, steps = _this$props.steps, children = _this$props.children;
        _this.handleStyleChange = _this.handleStyleChange.bind($7bd9593fbd65be39$var$_assertThisInitialized(_this));
        _this.changeStyle = _this.changeStyle.bind($7bd9593fbd65be39$var$_assertThisInitialized(_this));
        if (!isActive) {
            _this.state = {
                style: {}
            }; // if children is a function and animation is not active, set style to 'to'
            if (typeof children === "function") _this.state = {
                style: to
            };
            return $7bd9593fbd65be39$var$_possibleConstructorReturn(_this);
        }
        if (steps && steps.length) _this.state = {
            style: steps[0].style
        };
        else if (from) {
            if (typeof children === "function") {
                _this.state = {
                    style: from
                };
                return $7bd9593fbd65be39$var$_possibleConstructorReturn(_this);
            }
            _this.state = {
                style: attributeName ? $7bd9593fbd65be39$var$_defineProperty({}, attributeName, from) : from
            };
        } else _this.state = {
            style: {}
        };
        return _this;
    }
    $7bd9593fbd65be39$var$_createClass(Animate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props2 = this.props, isActive = _this$props2.isActive, canBegin = _this$props2.canBegin;
                this.mounted = true;
                if (!isActive || !canBegin) return;
                this.runAnimation(this.props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props3 = this.props, isActive = _this$props3.isActive, canBegin = _this$props3.canBegin, attributeName = _this$props3.attributeName, shouldReAnimate = _this$props3.shouldReAnimate;
                if (!canBegin) return;
                if (!isActive) {
                    var newState = {
                        style: attributeName ? $7bd9593fbd65be39$var$_defineProperty({}, attributeName, this.props.to) : this.props.to
                    };
                    if (this.state && this.state.style) {
                        if (attributeName && this.state.style[attributeName] !== this.props.to || !attributeName && this.state.style !== this.props.to) // eslint-disable-next-line react/no-did-update-set-state
                        this.setState(newState);
                    }
                    return;
                }
                if ((0, $f28f24f368f31a49$exports.deepEqual)(prevProps.to, this.props.to) && prevProps.canBegin && prevProps.isActive) return;
                var isTriggered = !prevProps.canBegin || !prevProps.isActive;
                if (this.manager) this.manager.stop();
                if (this.stopJSAnimation) this.stopJSAnimation();
                var from = isTriggered || shouldReAnimate ? this.props.from : prevProps.to;
                if (this.state && this.state.style) {
                    var _newState = {
                        style: attributeName ? $7bd9593fbd65be39$var$_defineProperty({}, attributeName, from) : from
                    };
                    if (attributeName && this.state.style[attributeName] !== from || !attributeName && this.state.style !== from) // eslint-disable-next-line react/no-did-update-set-state
                    this.setState(_newState);
                }
                this.runAnimation($7bd9593fbd65be39$var$_objectSpread($7bd9593fbd65be39$var$_objectSpread({}, this.props), {}, {
                    from: from,
                    begin: 0
                }));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false;
                if (this.unSubscribe) this.unSubscribe();
                if (this.manager) {
                    this.manager.stop();
                    this.manager = null;
                }
                if (this.stopJSAnimation) this.stopJSAnimation();
            }
        },
        {
            key: "runJSAnimation",
            value: function runJSAnimation(props) {
                var _this2 = this;
                var from = props.from, to = props.to, duration = props.duration, easing = props.easing, begin = props.begin, onAnimationEnd = props.onAnimationEnd, onAnimationStart = props.onAnimationStart;
                var startAnimation = (0, $c03e0de2971db68c$export$2e2bcd8739ae039)(from, to, (0, $f2c6a684592a87fa$export$e3e04925801e5434)(easing), duration, this.changeStyle);
                var finalStartAnimation = function finalStartAnimation() {
                    _this2.stopJSAnimation = startAnimation();
                };
                this.manager.start([
                    onAnimationStart,
                    begin,
                    finalStartAnimation,
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "runStepAnimation",
            value: function runStepAnimation(props) {
                var _this3 = this;
                var steps = props.steps, begin = props.begin, onAnimationStart = props.onAnimationStart;
                var _steps$ = steps[0], initialStyle = _steps$.style, _steps$$duration = _steps$.duration, initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
                var addStyle = function addStyle(sequence, nextItem, index) {
                    if (index === 0) return sequence;
                    var duration = nextItem.duration, _nextItem$easing = nextItem.easing, easing = _nextItem$easing === void 0 ? "ease" : _nextItem$easing, style = nextItem.style, nextProperties = nextItem.properties, onAnimationEnd = nextItem.onAnimationEnd;
                    var preItem = index > 0 ? steps[index - 1] : nextItem;
                    var properties = nextProperties || Object.keys(style);
                    if (typeof easing === "function" || easing === "spring") return [].concat($7bd9593fbd65be39$var$_toConsumableArray(sequence), [
                        _this3.runJSAnimation.bind(_this3, {
                            from: preItem.style,
                            to: style,
                            duration: duration,
                            easing: easing
                        }),
                        duration
                    ]);
                    var transition = (0, $88a16dea13c3b732$export$1594c78389ee3429)(properties, duration, easing);
                    var newStyle = $7bd9593fbd65be39$var$_objectSpread($7bd9593fbd65be39$var$_objectSpread($7bd9593fbd65be39$var$_objectSpread({}, preItem.style), style), {}, {
                        transition: transition
                    });
                    return [].concat($7bd9593fbd65be39$var$_toConsumableArray(sequence), [
                        newStyle,
                        duration,
                        onAnimationEnd
                    ]).filter((0, $88a16dea13c3b732$export$f0954fd7d5368655));
                };
                return this.manager.start([
                    onAnimationStart
                ].concat($7bd9593fbd65be39$var$_toConsumableArray(steps.reduce(addStyle, [
                    initialStyle,
                    Math.max(initialTime, begin)
                ])), [
                    props.onAnimationEnd
                ]));
            }
        },
        {
            key: "runAnimation",
            value: function runAnimation(props) {
                if (!this.manager) this.manager = (0, $d43c672d1cb92645$export$2e2bcd8739ae039)();
                var begin = props.begin, duration = props.duration, attributeName = props.attributeName, propsTo = props.to, easing = props.easing, onAnimationStart = props.onAnimationStart, onAnimationEnd = props.onAnimationEnd, steps = props.steps, children = props.children;
                var manager = this.manager;
                this.unSubscribe = manager.subscribe(this.handleStyleChange);
                if (typeof easing === "function" || typeof children === "function" || easing === "spring") {
                    this.runJSAnimation(props);
                    return;
                }
                if (steps.length > 1) {
                    this.runStepAnimation(props);
                    return;
                }
                var to = attributeName ? $7bd9593fbd65be39$var$_defineProperty({}, attributeName, propsTo) : propsTo;
                var transition = (0, $88a16dea13c3b732$export$1594c78389ee3429)(Object.keys(to), duration, easing);
                manager.start([
                    onAnimationStart,
                    begin,
                    $7bd9593fbd65be39$var$_objectSpread($7bd9593fbd65be39$var$_objectSpread({}, to), {}, {
                        transition: transition
                    }),
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "handleStyleChange",
            value: function handleStyleChange(style) {
                this.changeStyle(style);
            }
        },
        {
            key: "changeStyle",
            value: function changeStyle(style) {
                if (this.mounted) this.setState({
                    style: style
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, children = _this$props4.children, begin = _this$props4.begin, duration = _this$props4.duration, attributeName = _this$props4.attributeName, easing = _this$props4.easing, isActive = _this$props4.isActive, steps = _this$props4.steps, from = _this$props4.from, to = _this$props4.to, canBegin = _this$props4.canBegin, onAnimationEnd = _this$props4.onAnimationEnd, shouldReAnimate = _this$props4.shouldReAnimate, onAnimationReStart = _this$props4.onAnimationReStart, others = $7bd9593fbd65be39$var$_objectWithoutProperties(_this$props4, [
                    "children",
                    "begin",
                    "duration",
                    "attributeName",
                    "easing",
                    "isActive",
                    "steps",
                    "from",
                    "to",
                    "canBegin",
                    "onAnimationEnd",
                    "shouldReAnimate",
                    "onAnimationReStart"
                ]);
                var count = (0, $jC8Vy.Children).count(children);
                var stateStyle = (0, $88a16dea13c3b732$export$ff9926a5d1daa67c)(this.state.style);
                if (typeof children === "function") return children(stateStyle);
                if (!isActive || count === 0) return children;
                var cloneContainer = function cloneContainer(container) {
                    var _container$props = container.props, _container$props$styl = _container$props.style, style = _container$props$styl === void 0 ? {} : _container$props$styl, className = _container$props.className;
                    var res = /*#__PURE__*/ (0, $jC8Vy.cloneElement)(container, $7bd9593fbd65be39$var$_objectSpread($7bd9593fbd65be39$var$_objectSpread({}, others), {}, {
                        style: $7bd9593fbd65be39$var$_objectSpread($7bd9593fbd65be39$var$_objectSpread({}, style), stateStyle),
                        className: className
                    }));
                    return res;
                };
                if (count === 1) return cloneContainer((0, $jC8Vy.Children).only(children));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", null, (0, $jC8Vy.Children).map(children, function(child) {
                    return cloneContainer(child);
                }));
            }
        }
    ]);
    return Animate;
}((0, $jC8Vy.PureComponent));
$7bd9593fbd65be39$var$Animate.displayName = "Animate";
$7bd9593fbd65be39$var$Animate.propTypes = {
    from: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).string
    ]),
    to: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).string
    ]),
    attributeName: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).string,
    // animation duration
    duration: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).number,
    begin: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).number,
    easing: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).func
    ]),
    steps: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).shape({
        duration: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).number.isRequired,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).object.isRequired,
        easing: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).oneOf([
                "ease",
                "ease-in",
                "ease-out",
                "ease-in-out",
                "linear"
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).func
        ]),
        // transition css properties(dash case), optional
        properties: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).arrayOf("string"),
        onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).func
    })),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).func
    ]),
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).bool,
    canBegin: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).bool,
    onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).func,
    // decide if it should reanimate with initial from style when props change
    shouldReAnimate: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).bool,
    onAnimationStart: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).func,
    onAnimationReStart: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).func
};
$7bd9593fbd65be39$var$Animate.defaultProps = {
    begin: 0,
    duration: 1000,
    from: "",
    to: "",
    attributeName: "",
    easing: "ease",
    isActive: true,
    canBegin: true,
    steps: [],
    onAnimationEnd: function onAnimationEnd() {},
    onAnimationStart: function onAnimationStart() {}
};
var $7bd9593fbd65be39$export$2e2bcd8739ae039 = $7bd9593fbd65be39$var$Animate;





var $jC8Vy = parcelRequire("jC8Vy");
var $0f65561b5d984373$exports = {};
"use strict";

var $0f65561b5d984373$var$_CSSTransition = $0f65561b5d984373$var$_interopRequireDefault((parcelRequire("76jA5")));

var $0f65561b5d984373$var$_ReplaceTransition = $0f65561b5d984373$var$_interopRequireDefault((parcelRequire("lmllh")));

var $0f65561b5d984373$var$_TransitionGroup = $0f65561b5d984373$var$_interopRequireDefault((parcelRequire("ir7dc")));

var $0f65561b5d984373$var$_Transition = $0f65561b5d984373$var$_interopRequireDefault((parcelRequire("ebNR2")));
function $0f65561b5d984373$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$0f65561b5d984373$exports = {
    Transition: $0f65561b5d984373$var$_Transition.default,
    TransitionGroup: $0f65561b5d984373$var$_TransitionGroup.default,
    ReplaceTransition: $0f65561b5d984373$var$_ReplaceTransition.default,
    CSSTransition: $0f65561b5d984373$var$_CSSTransition.default
};



var $bD9Bx = parcelRequire("bD9Bx");

var $jC8Vy = parcelRequire("jC8Vy");


var $bD9Bx = parcelRequire("bD9Bx");

function $8535cbde1db84651$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $8535cbde1db84651$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $8535cbde1db84651$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $8535cbde1db84651$var$_typeof(obj);
}
function $8535cbde1db84651$var$_extends() {
    $8535cbde1db84651$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8535cbde1db84651$var$_extends.apply(this, arguments);
}
function $8535cbde1db84651$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8535cbde1db84651$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8535cbde1db84651$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $8535cbde1db84651$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8535cbde1db84651$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $8535cbde1db84651$var$ownKeys(Object(source), true).forEach(function(key) {
            $8535cbde1db84651$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $8535cbde1db84651$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8535cbde1db84651$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8535cbde1db84651$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8535cbde1db84651$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $8535cbde1db84651$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8535cbde1db84651$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8535cbde1db84651$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $8535cbde1db84651$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $8535cbde1db84651$var$_setPrototypeOf(subClass, superClass);
}
function $8535cbde1db84651$var$_setPrototypeOf(o, p) {
    $8535cbde1db84651$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8535cbde1db84651$var$_setPrototypeOf(o, p);
}
function $8535cbde1db84651$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $8535cbde1db84651$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $8535cbde1db84651$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $8535cbde1db84651$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $8535cbde1db84651$var$_possibleConstructorReturn(this, result);
    };
}
function $8535cbde1db84651$var$_possibleConstructorReturn(self, call) {
    if (call && ($8535cbde1db84651$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $8535cbde1db84651$var$_assertThisInitialized(self);
}
function $8535cbde1db84651$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $8535cbde1db84651$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $8535cbde1db84651$var$_getPrototypeOf(o) {
    $8535cbde1db84651$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8535cbde1db84651$var$_getPrototypeOf(o);
}
if (Number.isFinite === undefined) Number.isFinite = function(value) {
    return typeof value === "number" && isFinite(value);
};
var $8535cbde1db84651$var$parseDurationOfSingleTransition = function parseDurationOfSingleTransition() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var steps = options.steps, duration = options.duration;
    if (steps && steps.length) return steps.reduce(function(result, entry) {
        return result + (Number.isFinite(entry.duration) && entry.duration > 0 ? entry.duration : 0);
    }, 0);
    if (Number.isFinite(duration)) return duration;
    return 0;
};
var $8535cbde1db84651$var$AnimateGroupChild = /*#__PURE__*/ function(_Component) {
    $8535cbde1db84651$var$_inherits(AnimateGroupChild, _Component);
    var _super = $8535cbde1db84651$var$_createSuper(AnimateGroupChild);
    function AnimateGroupChild() {
        var _this;
        $8535cbde1db84651$var$_classCallCheck(this, AnimateGroupChild);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            isActive: false
        };
        _this.handleEnter = function(node, isAppearing) {
            var _this$props = _this.props, appearOptions = _this$props.appearOptions, enterOptions = _this$props.enterOptions;
            _this.handleStyleActive(isAppearing ? appearOptions : enterOptions);
        };
        _this.handleExit = function() {
            _this.handleStyleActive(_this.props.leaveOptions);
        };
        return _this;
    }
    $8535cbde1db84651$var$_createClass(AnimateGroupChild, [
        {
            key: "handleStyleActive",
            value: function handleStyleActive(style) {
                if (style) {
                    var onAnimationEnd = style.onAnimationEnd ? function() {
                        style.onAnimationEnd();
                    } : null;
                    this.setState($8535cbde1db84651$var$_objectSpread($8535cbde1db84651$var$_objectSpread({}, style), {}, {
                        onAnimationEnd: onAnimationEnd,
                        isActive: true
                    }));
                }
            }
        },
        {
            key: "parseTimeout",
            value: function parseTimeout() {
                var _this$props2 = this.props, appearOptions = _this$props2.appearOptions, enterOptions = _this$props2.enterOptions, leaveOptions = _this$props2.leaveOptions;
                return $8535cbde1db84651$var$parseDurationOfSingleTransition(appearOptions) + $8535cbde1db84651$var$parseDurationOfSingleTransition(enterOptions) + $8535cbde1db84651$var$parseDurationOfSingleTransition(leaveOptions);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props3 = this.props, children = _this$props3.children, appearOptions = _this$props3.appearOptions, enterOptions = _this$props3.enterOptions, leaveOptions = _this$props3.leaveOptions, props = $8535cbde1db84651$var$_objectWithoutProperties(_this$props3, [
                    "children",
                    "appearOptions",
                    "enterOptions",
                    "leaveOptions"
                ]);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $0f65561b5d984373$exports.Transition), $8535cbde1db84651$var$_extends({}, props, {
                    onEnter: this.handleEnter,
                    onExit: this.handleExit,
                    timeout: this.parseTimeout()
                }), function() {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $7bd9593fbd65be39$export$2e2bcd8739ae039), _this2.state, (0, $jC8Vy.Children).only(children));
                });
            }
        }
    ]);
    return AnimateGroupChild;
}((0, $jC8Vy.Component));
$8535cbde1db84651$var$AnimateGroupChild.propTypes = {
    appearOptions: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).object,
    enterOptions: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).object,
    leaveOptions: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).element
};
var $8535cbde1db84651$export$2e2bcd8739ae039 = $8535cbde1db84651$var$AnimateGroupChild;


function $0be43c396d0225c0$var$AnimateGroup(props) {
    var component = props.component, children = props.children, appear = props.appear, enter = props.enter, leave = props.leave;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $0f65561b5d984373$exports.TransitionGroup), {
        component: component
    }, (0, $jC8Vy.Children).map(children, function(child, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $8535cbde1db84651$export$2e2bcd8739ae039), {
            appearOptions: appear,
            enterOptions: enter,
            leaveOptions: leave,
            key: "child-".concat(index) // eslint-disable-line
        }, child);
    }));
}
$0be43c396d0225c0$var$AnimateGroup.propTypes = {
    appear: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).object,
    enter: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).object,
    leave: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).element
    ]),
    component: (0, (/*@__PURE__*/$parcel$interopDefault($bD9Bx))).any
};
$0be43c396d0225c0$var$AnimateGroup.defaultProps = {
    component: "span"
};
var $0be43c396d0225c0$export$2e2bcd8739ae039 = $0be43c396d0225c0$var$AnimateGroup;


var $97a4c34858e514f6$export$2e2bcd8739ae039 = (0, $7bd9593fbd65be39$export$2e2bcd8739ae039);



var $ca2cccb92e57cec1$exports = {};
var $84f5d80d2cd598b3$exports = {};
var $237aa3f91fa7657f$exports = {};
var $3b2dcc25d69fb702$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $3b2dcc25d69fb702$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$3b2dcc25d69fb702$exports = $3b2dcc25d69fb702$var$baseSlice;


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $237aa3f91fa7657f$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $3b2dcc25d69fb702$exports(array, start, end);
}
$237aa3f91fa7657f$exports = $237aa3f91fa7657f$var$castSlice;


var $68e991ca004c0932$exports = {};
/** Used to compose unicode character classes. */ var $68e991ca004c0932$var$rsAstralRange = "\ud800-\udfff", $68e991ca004c0932$var$rsComboMarksRange = "\\u0300-\\u036f", $68e991ca004c0932$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $68e991ca004c0932$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $68e991ca004c0932$var$rsComboRange = $68e991ca004c0932$var$rsComboMarksRange + $68e991ca004c0932$var$reComboHalfMarksRange + $68e991ca004c0932$var$rsComboSymbolsRange, $68e991ca004c0932$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $68e991ca004c0932$var$rsZWJ = "\\u200d";
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $68e991ca004c0932$var$reHasUnicode = RegExp("[" + $68e991ca004c0932$var$rsZWJ + $68e991ca004c0932$var$rsAstralRange + $68e991ca004c0932$var$rsComboRange + $68e991ca004c0932$var$rsVarRange + "]");
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $68e991ca004c0932$var$hasUnicode(string) {
    return $68e991ca004c0932$var$reHasUnicode.test(string);
}
$68e991ca004c0932$exports = $68e991ca004c0932$var$hasUnicode;


var $1fd3c2b79a51d7b2$exports = {};
var $f3302f5f722cd2e2$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $f3302f5f722cd2e2$var$asciiToArray(string) {
    return string.split("");
}
$f3302f5f722cd2e2$exports = $f3302f5f722cd2e2$var$asciiToArray;



var $83971a9a578c939f$exports = {};
/** Used to compose unicode character classes. */ var $83971a9a578c939f$var$rsAstralRange = "\ud800-\udfff", $83971a9a578c939f$var$rsComboMarksRange = "\\u0300-\\u036f", $83971a9a578c939f$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $83971a9a578c939f$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $83971a9a578c939f$var$rsComboRange = $83971a9a578c939f$var$rsComboMarksRange + $83971a9a578c939f$var$reComboHalfMarksRange + $83971a9a578c939f$var$rsComboSymbolsRange, $83971a9a578c939f$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $83971a9a578c939f$var$rsAstral = "[" + $83971a9a578c939f$var$rsAstralRange + "]", $83971a9a578c939f$var$rsCombo = "[" + $83971a9a578c939f$var$rsComboRange + "]", $83971a9a578c939f$var$rsFitz = "\ud83c[\udffb-\udfff]", $83971a9a578c939f$var$rsModifier = "(?:" + $83971a9a578c939f$var$rsCombo + "|" + $83971a9a578c939f$var$rsFitz + ")", $83971a9a578c939f$var$rsNonAstral = "[^" + $83971a9a578c939f$var$rsAstralRange + "]", $83971a9a578c939f$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $83971a9a578c939f$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $83971a9a578c939f$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $83971a9a578c939f$var$reOptMod = $83971a9a578c939f$var$rsModifier + "?", $83971a9a578c939f$var$rsOptVar = "[" + $83971a9a578c939f$var$rsVarRange + "]?", $83971a9a578c939f$var$rsOptJoin = "(?:" + $83971a9a578c939f$var$rsZWJ + "(?:" + [
    $83971a9a578c939f$var$rsNonAstral,
    $83971a9a578c939f$var$rsRegional,
    $83971a9a578c939f$var$rsSurrPair
].join("|") + ")" + $83971a9a578c939f$var$rsOptVar + $83971a9a578c939f$var$reOptMod + ")*", $83971a9a578c939f$var$rsSeq = $83971a9a578c939f$var$rsOptVar + $83971a9a578c939f$var$reOptMod + $83971a9a578c939f$var$rsOptJoin, $83971a9a578c939f$var$rsSymbol = "(?:" + [
    $83971a9a578c939f$var$rsNonAstral + $83971a9a578c939f$var$rsCombo + "?",
    $83971a9a578c939f$var$rsCombo,
    $83971a9a578c939f$var$rsRegional,
    $83971a9a578c939f$var$rsSurrPair,
    $83971a9a578c939f$var$rsAstral
].join("|") + ")";
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $83971a9a578c939f$var$reUnicode = RegExp($83971a9a578c939f$var$rsFitz + "(?=" + $83971a9a578c939f$var$rsFitz + ")|" + $83971a9a578c939f$var$rsSymbol + $83971a9a578c939f$var$rsSeq, "g");
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $83971a9a578c939f$var$unicodeToArray(string) {
    return string.match($83971a9a578c939f$var$reUnicode) || [];
}
$83971a9a578c939f$exports = $83971a9a578c939f$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $1fd3c2b79a51d7b2$var$stringToArray(string) {
    return $68e991ca004c0932$exports(string) ? $83971a9a578c939f$exports(string) : $f3302f5f722cd2e2$exports(string);
}
$1fd3c2b79a51d7b2$exports = $1fd3c2b79a51d7b2$var$stringToArray;



/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $84f5d80d2cd598b3$var$createCaseFirst(methodName) {
    return function(string) {
        string = $72438828c89ad894$exports(string);
        var strSymbols = $68e991ca004c0932$exports(string) ? $1fd3c2b79a51d7b2$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $237aa3f91fa7657f$exports(strSymbols, 1).join("") : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$84f5d80d2cd598b3$exports = $84f5d80d2cd598b3$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $ca2cccb92e57cec1$var$upperFirst = $84f5d80d2cd598b3$exports("toUpperCase");
$ca2cccb92e57cec1$exports = $ca2cccb92e57cec1$var$upperFirst;




var $jC8Vy = parcelRequire("jC8Vy");
const $e37c76946f6488a5$var$pi = Math.PI, $e37c76946f6488a5$var$tau = 2 * $e37c76946f6488a5$var$pi, $e37c76946f6488a5$var$epsilon = 1e-6, $e37c76946f6488a5$var$tauEpsilon = $e37c76946f6488a5$var$tau - $e37c76946f6488a5$var$epsilon;
function $e37c76946f6488a5$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $e37c76946f6488a5$var$path() {
    return new $e37c76946f6488a5$var$Path;
}
$e37c76946f6488a5$var$Path.prototype = $e37c76946f6488a5$var$path.prototype = {
    constructor: $e37c76946f6488a5$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $e37c76946f6488a5$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $e37c76946f6488a5$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($e37c76946f6488a5$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $e37c76946f6488a5$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $e37c76946f6488a5$var$epsilon || Math.abs(this._y1 - y0) > $e37c76946f6488a5$var$epsilon) this._ += "L" + x0 + "," + y0;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $e37c76946f6488a5$var$tau + $e37c76946f6488a5$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $e37c76946f6488a5$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $e37c76946f6488a5$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $e37c76946f6488a5$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $e37c76946f6488a5$export$2e2bcd8739ae039 = $e37c76946f6488a5$var$path;


var $ddd10c0627c7da22$export$58adb3bec8346d0f = Array.prototype.slice;
function $ddd10c0627c7da22$export$2e2bcd8739ae039(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}


function $4b8c5ad53a733149$export$2e2bcd8739ae039(x) {
    return function constant() {
        return x;
    };
}


function $21b31c801b6158b4$var$Linear(context) {
    this._context = context;
}
$21b31c801b6158b4$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $21b31c801b6158b4$export$2e2bcd8739ae039(context) {
    return new $21b31c801b6158b4$var$Linear(context);
}






function $a2ceaa73f4080c87$export$d141bba7fdc215a3(p) {
    return p[0];
}
function $a2ceaa73f4080c87$export$4a5767248b18ef41(p) {
    return p[1];
}


function $8c34c42ff4004274$export$2e2bcd8739ae039(x, y) {
    var defined = (0, $4b8c5ad53a733149$export$2e2bcd8739ae039)(true), context = null, curve = (0, $21b31c801b6158b4$export$2e2bcd8739ae039), output = null;
    x = typeof x === "function" ? x : x === undefined ? (0, $a2ceaa73f4080c87$export$d141bba7fdc215a3) : (0, $4b8c5ad53a733149$export$2e2bcd8739ae039)(x);
    y = typeof y === "function" ? y : y === undefined ? (0, $a2ceaa73f4080c87$export$4a5767248b18ef41) : (0, $4b8c5ad53a733149$export$2e2bcd8739ae039)(y);
    function line(data) {
        var i, n = (data = (0, $ddd10c0627c7da22$export$2e2bcd8739ae039)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $e37c76946f6488a5$export$2e2bcd8739ae039)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $4b8c5ad53a733149$export$2e2bcd8739ae039)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $4b8c5ad53a733149$export$2e2bcd8739ae039)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $4b8c5ad53a733149$export$2e2bcd8739ae039)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}



function $ff9c643c89828b15$export$2e2bcd8739ae039(x0, y0, y1) {
    var x1 = null, defined = (0, $4b8c5ad53a733149$export$2e2bcd8739ae039)(true), context = null, curve = (0, $21b31c801b6158b4$export$2e2bcd8739ae039), output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? (0, $a2ceaa73f4080c87$export$d141bba7fdc215a3) : (0, $4b8c5ad53a733149$export$2e2bcd8739ae039)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $4b8c5ad53a733149$export$2e2bcd8739ae039)(0) : (0, $4b8c5ad53a733149$export$2e2bcd8739ae039)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? (0, $a2ceaa73f4080c87$export$4a5767248b18ef41) : (0, $4b8c5ad53a733149$export$2e2bcd8739ae039)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $ddd10c0627c7da22$export$2e2bcd8739ae039)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $e37c76946f6488a5$export$2e2bcd8739ae039)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $8c34c42ff4004274$export$2e2bcd8739ae039)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $4b8c5ad53a733149$export$2e2bcd8739ae039)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $4b8c5ad53a733149$export$2e2bcd8739ae039)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $4b8c5ad53a733149$export$2e2bcd8739ae039)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $4b8c5ad53a733149$export$2e2bcd8739ae039)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $4b8c5ad53a733149$export$2e2bcd8739ae039)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $4b8c5ad53a733149$export$2e2bcd8739ae039)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $4b8c5ad53a733149$export$2e2bcd8739ae039)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

function $69c6afeeac889904$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $69c6afeeac889904$export$957f7263e89bedd2(context) {
    this._context = context;
}
$69c6afeeac889904$export$957f7263e89bedd2.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $69c6afeeac889904$export$105684a3041cb6f3(this, this._x1, this._y1); // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // falls through
            default:
                $69c6afeeac889904$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $69c6afeeac889904$export$2e2bcd8739ae039(context) {
    return new $69c6afeeac889904$export$957f7263e89bedd2(context);
}

function $ff5a16f16997365c$export$2e2bcd8739ae039() {}



function $f834668643ba3e14$var$BasisClosed(context) {
    this._context = context;
}
$f834668643ba3e14$var$BasisClosed.prototype = {
    areaStart: (0, $ff5a16f16997365c$export$2e2bcd8739ae039),
    areaEnd: (0, $ff5a16f16997365c$export$2e2bcd8739ae039),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $69c6afeeac889904$export$105684a3041cb6f3)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $f834668643ba3e14$export$2e2bcd8739ae039(context) {
    return new $f834668643ba3e14$var$BasisClosed(context);
}


function $1f322ad06d7ca49d$var$BasisOpen(context) {
    this._context = context;
}
$1f322ad06d7ca49d$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, $69c6afeeac889904$export$105684a3041cb6f3)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $1f322ad06d7ca49d$export$2e2bcd8739ae039(context) {
    return new $1f322ad06d7ca49d$var$BasisOpen(context);
}


function $eccdf97df583473e$var$LinearClosed(context) {
    this._context = context;
}
$eccdf97df583473e$var$LinearClosed.prototype = {
    areaStart: (0, $ff5a16f16997365c$export$2e2bcd8739ae039),
    areaEnd: (0, $ff5a16f16997365c$export$2e2bcd8739ae039),
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $eccdf97df583473e$export$2e2bcd8739ae039(context) {
    return new $eccdf97df583473e$var$LinearClosed(context);
}

function $66bc36b6bdff6a71$var$sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $66bc36b6bdff6a71$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($66bc36b6bdff6a71$var$sign(s0) + $66bc36b6bdff6a71$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function $66bc36b6bdff6a71$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $66bc36b6bdff6a71$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $66bc36b6bdff6a71$var$MonotoneX(context) {
    this._context = context;
}
$66bc36b6bdff6a71$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $66bc36b6bdff6a71$var$point(this, this._t0, $66bc36b6bdff6a71$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $66bc36b6bdff6a71$var$point(this, $66bc36b6bdff6a71$var$slope2(this, t1 = $66bc36b6bdff6a71$var$slope3(this, x, y)), t1);
                break;
            default:
                $66bc36b6bdff6a71$var$point(this, this._t0, t1 = $66bc36b6bdff6a71$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $66bc36b6bdff6a71$var$MonotoneY(context) {
    this._context = new $66bc36b6bdff6a71$var$ReflectContext(context);
}
($66bc36b6bdff6a71$var$MonotoneY.prototype = Object.create($66bc36b6bdff6a71$var$MonotoneX.prototype)).point = function(x, y) {
    $66bc36b6bdff6a71$var$MonotoneX.prototype.point.call(this, y, x);
};
function $66bc36b6bdff6a71$var$ReflectContext(context) {
    this._context = context;
}
$66bc36b6bdff6a71$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $66bc36b6bdff6a71$export$99563b5420dbdc55(context) {
    return new $66bc36b6bdff6a71$var$MonotoneX(context);
}
function $66bc36b6bdff6a71$export$8b5360456d6bdb88(context) {
    return new $66bc36b6bdff6a71$var$MonotoneY(context);
}

function $96cb6691ac090603$var$Natural(context) {
    this._context = context;
}
$96cb6691ac090603$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $96cb6691ac090603$var$controlPoints(x), py = $96cb6691ac090603$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $96cb6691ac090603$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $96cb6691ac090603$export$2e2bcd8739ae039(context) {
    return new $96cb6691ac090603$var$Natural(context);
}

function $0fbb17a045950fea$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$0fbb17a045950fea$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $0fbb17a045950fea$export$2e2bcd8739ae039(context) {
    return new $0fbb17a045950fea$var$Step(context, 0.5);
}
function $0fbb17a045950fea$export$10eafa5b7478b343(context) {
    return new $0fbb17a045950fea$var$Step(context, 0);
}
function $0fbb17a045950fea$export$793b3db073781cbb(context) {
    return new $0fbb17a045950fea$var$Step(context, 1);
}



var $5UrGx = parcelRequire("5UrGx");


var $jC8Vy = parcelRequire("jC8Vy");
function $05a192303b32ed93$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $05a192303b32ed93$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $05a192303b32ed93$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $05a192303b32ed93$var$_typeof(obj);
}
var $05a192303b32ed93$var$SVGContainerPropKeys = [
    "viewBox",
    "children"
];
var $05a192303b32ed93$var$SVGElementPropKeys = [
    "aria-activedescendant",
    "aria-atomic",
    "aria-autocomplete",
    "aria-busy",
    "aria-checked",
    "aria-colcount",
    "aria-colindex",
    "aria-colspan",
    "aria-controls",
    "aria-current",
    "aria-describedby",
    "aria-details",
    "aria-disabled",
    "aria-errormessage",
    "aria-expanded",
    "aria-flowto",
    "aria-haspopup",
    "aria-hidden",
    "aria-invalid",
    "aria-keyshortcuts",
    "aria-label",
    "aria-labelledby",
    "aria-level",
    "aria-live",
    "aria-modal",
    "aria-multiline",
    "aria-multiselectable",
    "aria-orientation",
    "aria-owns",
    "aria-placeholder",
    "aria-posinset",
    "aria-pressed",
    "aria-readonly",
    "aria-relevant",
    "aria-required",
    "aria-roledescription",
    "aria-rowcount",
    "aria-rowindex",
    "aria-rowspan",
    "aria-selected",
    "aria-setsize",
    "aria-sort",
    "aria-valuemax",
    "aria-valuemin",
    "aria-valuenow",
    "aria-valuetext",
    "className",
    "color",
    "height",
    "id",
    "lang",
    "max",
    "media",
    "method",
    "min",
    "name",
    "style",
    "target",
    "type",
    "width",
    "role",
    "tabIndex",
    "accentHeight",
    "accumulate",
    "additive",
    "alignmentBaseline",
    "allowReorder",
    "alphabetic",
    "amplitude",
    "arabicForm",
    "ascent",
    "attributeName",
    "attributeType",
    "autoReverse",
    "azimuth",
    "baseFrequency",
    "baselineShift",
    "baseProfile",
    "bbox",
    "begin",
    "bias",
    "by",
    "calcMode",
    "capHeight",
    "clip",
    "clipPath",
    "clipPathUnits",
    "clipRule",
    "colorInterpolation",
    "colorInterpolationFilters",
    "colorProfile",
    "colorRendering",
    "contentScriptType",
    "contentStyleType",
    "cursor",
    "cx",
    "cy",
    "d",
    "decelerate",
    "descent",
    "diffuseConstant",
    "direction",
    "display",
    "divisor",
    "dominantBaseline",
    "dur",
    "dx",
    "dy",
    "edgeMode",
    "elevation",
    "enableBackground",
    "end",
    "exponent",
    "externalResourcesRequired",
    "fill",
    "fillOpacity",
    "fillRule",
    "filter",
    "filterRes",
    "filterUnits",
    "floodColor",
    "floodOpacity",
    "focusable",
    "fontFamily",
    "fontSize",
    "fontSizeAdjust",
    "fontStretch",
    "fontStyle",
    "fontVariant",
    "fontWeight",
    "format",
    "from",
    "fx",
    "fy",
    "g1",
    "g2",
    "glyphName",
    "glyphOrientationHorizontal",
    "glyphOrientationVertical",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "hanging",
    "horizAdvX",
    "horizOriginX",
    "href",
    "ideographic",
    "imageRendering",
    "in2",
    "in",
    "intercept",
    "k1",
    "k2",
    "k3",
    "k4",
    "k",
    "kernelMatrix",
    "kernelUnitLength",
    "kerning",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "letterSpacing",
    "lightingColor",
    "limitingConeAngle",
    "local",
    "markerEnd",
    "markerHeight",
    "markerMid",
    "markerStart",
    "markerUnits",
    "markerWidth",
    "mask",
    "maskContentUnits",
    "maskUnits",
    "mathematical",
    "mode",
    "numOctaves",
    "offset",
    "opacity",
    "operator",
    "order",
    "orient",
    "orientation",
    "origin",
    "overflow",
    "overlinePosition",
    "overlineThickness",
    "paintOrder",
    "panose1",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointerEvents",
    "points",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "r",
    "radius",
    "refX",
    "refY",
    "renderingIntent",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "restart",
    "result",
    "rotate",
    "rx",
    "ry",
    "seed",
    "shapeRendering",
    "slope",
    "spacing",
    "specularConstant",
    "specularExponent",
    "speed",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stemh",
    "stemv",
    "stitchTiles",
    "stopColor",
    "stopOpacity",
    "strikethroughPosition",
    "strikethroughThickness",
    "string",
    "stroke",
    "strokeDasharray",
    "strokeDashoffset",
    "strokeLinecap",
    "strokeLinejoin",
    "strokeMiterlimit",
    "strokeOpacity",
    "strokeWidth",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textAnchor",
    "textDecoration",
    "textLength",
    "textRendering",
    "to",
    "transform",
    "u1",
    "u2",
    "underlinePosition",
    "underlineThickness",
    "unicode",
    "unicodeBidi",
    "unicodeRange",
    "unitsPerEm",
    "vAlphabetic",
    "values",
    "vectorEffect",
    "version",
    "vertAdvY",
    "vertOriginX",
    "vertOriginY",
    "vHanging",
    "vIdeographic",
    "viewTarget",
    "visibility",
    "vMathematical",
    "widths",
    "wordSpacing",
    "writingMode",
    "x1",
    "x2",
    "x",
    "xChannelSelector",
    "xHeight",
    "xlinkActuate",
    "xlinkArcrole",
    "xlinkHref",
    "xlinkRole",
    "xlinkShow",
    "xlinkTitle",
    "xlinkType",
    "xmlBase",
    "xmlLang",
    "xmlns",
    "xmlnsXlink",
    "xmlSpace",
    "y1",
    "y2",
    "y",
    "yChannelSelector",
    "z",
    "zoomAndPan",
    "ref",
    "key",
    "angle"
];
var $05a192303b32ed93$var$EventKeys = [
    "dangerouslySetInnerHTML",
    "onCopy",
    "onCopyCapture",
    "onCut",
    "onCutCapture",
    "onPaste",
    "onPasteCapture",
    "onCompositionEnd",
    "onCompositionEndCapture",
    "onCompositionStart",
    "onCompositionStartCapture",
    "onCompositionUpdate",
    "onCompositionUpdateCapture",
    "onFocus",
    "onFocusCapture",
    "onBlur",
    "onBlurCapture",
    "onChange",
    "onChangeCapture",
    "onBeforeInput",
    "onBeforeInputCapture",
    "onInput",
    "onInputCapture",
    "onReset",
    "onResetCapture",
    "onSubmit",
    "onSubmitCapture",
    "onInvalid",
    "onInvalidCapture",
    "onLoad",
    "onLoadCapture",
    "onError",
    "onErrorCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyPress",
    "onKeyPressCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onAbort",
    "onAbortCapture",
    "onCanPlay",
    "onCanPlayCapture",
    "onCanPlayThrough",
    "onCanPlayThroughCapture",
    "onDurationChange",
    "onDurationChangeCapture",
    "onEmptied",
    "onEmptiedCapture",
    "onEncrypted",
    "onEncryptedCapture",
    "onEnded",
    "onEndedCapture",
    "onLoadedData",
    "onLoadedDataCapture",
    "onLoadedMetadata",
    "onLoadedMetadataCapture",
    "onLoadStart",
    "onLoadStartCapture",
    "onPause",
    "onPauseCapture",
    "onPlay",
    "onPlayCapture",
    "onPlaying",
    "onPlayingCapture",
    "onProgress",
    "onProgressCapture",
    "onRateChange",
    "onRateChangeCapture",
    "onSeeked",
    "onSeekedCapture",
    "onSeeking",
    "onSeekingCapture",
    "onStalled",
    "onStalledCapture",
    "onSuspend",
    "onSuspendCapture",
    "onTimeUpdate",
    "onTimeUpdateCapture",
    "onVolumeChange",
    "onVolumeChangeCapture",
    "onWaiting",
    "onWaitingCapture",
    "onAuxClick",
    "onAuxClickCapture",
    "onClick",
    "onClickCapture",
    "onContextMenu",
    "onContextMenuCapture",
    "onDoubleClick",
    "onDoubleClickCapture",
    "onDrag",
    "onDragCapture",
    "onDragEnd",
    "onDragEndCapture",
    "onDragEnter",
    "onDragEnterCapture",
    "onDragExit",
    "onDragExitCapture",
    "onDragLeave",
    "onDragLeaveCapture",
    "onDragOver",
    "onDragOverCapture",
    "onDragStart",
    "onDragStartCapture",
    "onDrop",
    "onDropCapture",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseMove",
    "onMouseMoveCapture",
    "onMouseOut",
    "onMouseOutCapture",
    "onMouseOver",
    "onMouseOverCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onSelect",
    "onSelectCapture",
    "onTouchCancel",
    "onTouchCancelCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onTouchMove",
    "onTouchMoveCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerMove",
    "onPointerMoveCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onPointerCancel",
    "onPointerCancelCapture",
    "onPointerEnter",
    "onPointerEnterCapture",
    "onPointerLeave",
    "onPointerLeaveCapture",
    "onPointerOver",
    "onPointerOverCapture",
    "onPointerOut",
    "onPointerOutCapture",
    "onGotPointerCapture",
    "onGotPointerCaptureCapture",
    "onLostPointerCapture",
    "onLostPointerCaptureCapture",
    "onScroll",
    "onScrollCapture",
    "onWheel",
    "onWheelCapture",
    "onAnimationStart",
    "onAnimationStartCapture",
    "onAnimationEnd",
    "onAnimationEndCapture",
    "onAnimationIteration",
    "onAnimationIterationCapture",
    "onTransitionEnd",
    "onTransitionEndCapture"
]; // Animation Types => TODO: Should be moved when react-smooth is typescriptified.
var $05a192303b32ed93$export$d697c39a2985a4c = function filterProps(props, includeEvents, isSvg) {
    if (!props || typeof props === "function" || typeof props === "boolean") return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $jC8Vy.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cdeebba9a3c50f33$exports)))(inputProps)) return null;
    var out = {};
    Object.keys(inputProps).forEach(function(key) {
        // viewBox only exist in <svg />
        if ($05a192303b32ed93$var$SVGElementPropKeys.includes(key) || isSvg && $05a192303b32ed93$var$SVGContainerPropKeys.includes(key) || includeEvents && $05a192303b32ed93$var$EventKeys.includes(key)) out[key] = inputProps[key];
    });
    return out;
};
var $05a192303b32ed93$export$7c4c290a4a9c1b1e = function adaptEventHandlers(props, newHandler) {
    if (!props || typeof props === "function" || typeof props === "boolean") return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $jC8Vy.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cdeebba9a3c50f33$exports)))(inputProps)) return null;
    var out = {};
    Object.keys(inputProps).forEach(function(key) {
        if ($05a192303b32ed93$var$EventKeys.includes(key)) out[key] = newHandler || function(e) {
            return inputProps[key](inputProps, e);
        };
    });
    return out;
};
var $05a192303b32ed93$var$getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
    return function(e) {
        originalHandler(data, index, e);
        return null;
    };
};
var $05a192303b32ed93$export$ca62be0d67a3158c = function adaptEventsOfChild(props, data, index) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cdeebba9a3c50f33$exports)))(props) || $05a192303b32ed93$var$_typeof(props) !== "object") return null;
    var out = null;
    Object.keys(props).forEach(function(key) {
        var item = props[key];
        if ($05a192303b32ed93$var$EventKeys.includes(key) && typeof item === "function") {
            if (!out) out = {};
            out[key] = $05a192303b32ed93$var$getEventHandlerOfChild(item, data, index);
        }
    });
    return out;
};







var $804fab7e7cc9eb97$export$9d334328eb75e624 = function mathSign(value) {
    if (value === 0) return 0;
    if (value > 0) return 1;
    return -1;
};
var $804fab7e7cc9eb97$export$e50269385c77c348 = function isPercent(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($3719ffca02e94280$exports)))(value) && value.indexOf("%") === value.length - 1;
};
var $804fab7e7cc9eb97$export$7e4aa119212bc614 = function isNumber(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($0ec33415b6cee0b7$exports)))(value) && !(0, (/*@__PURE__*/$parcel$interopDefault($044ab485528b5c52$exports)))(value);
};
var $804fab7e7cc9eb97$export$402a499e1ea44294 = function isNumOrStr(value) {
    return $804fab7e7cc9eb97$export$7e4aa119212bc614(value) || (0, (/*@__PURE__*/$parcel$interopDefault($3719ffca02e94280$exports)))(value);
};
var $804fab7e7cc9eb97$var$idCounter = 0;
var $804fab7e7cc9eb97$export$8b15d37bc3f197d4 = function uniqueId(prefix) {
    var id = ++$804fab7e7cc9eb97$var$idCounter;
    return "".concat(prefix || "").concat(id);
};
var $804fab7e7cc9eb97$export$476354dbf49bdff6 = function getPercentValue(percent, totalValue) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!$804fab7e7cc9eb97$export$7e4aa119212bc614(percent) && !(0, (/*@__PURE__*/$parcel$interopDefault($3719ffca02e94280$exports)))(percent)) return defaultValue;
    var value;
    if ($804fab7e7cc9eb97$export$e50269385c77c348(percent)) {
        var index = percent.indexOf("%");
        value = totalValue * parseFloat(percent.slice(0, index)) / 100;
    } else value = +percent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($044ab485528b5c52$exports)))(value)) value = defaultValue;
    if (validate && value > totalValue) value = totalValue;
    return value;
};
var $804fab7e7cc9eb97$export$b88993f0aa0bf776 = function getAnyElementOfObject(obj) {
    if (!obj) return null;
    var keys = Object.keys(obj);
    if (keys && keys.length) return obj[keys[0]];
    return null;
};
var $804fab7e7cc9eb97$export$732baf6a98f122 = function hasDuplicate(ary) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($0fe4a5546443a34c$exports)))(ary)) return false;
    var len = ary.length;
    var cache = {};
    for(var i = 0; i < len; i++){
        if (!cache[ary[i]]) cache[ary[i]] = true;
        else return true;
    }
    return false;
};
var $804fab7e7cc9eb97$export$d871d53bd7eeb390 = function interpolateNumber(numberA, numberB) {
    if ($804fab7e7cc9eb97$export$7e4aa119212bc614(numberA) && $804fab7e7cc9eb97$export$7e4aa119212bc614(numberB)) return function(t) {
        return numberA + t * (numberB - numberA);
    };
    return function() {
        return numberB;
    };
};
function $804fab7e7cc9eb97$export$66950d3869f5cc67(ary, specifiedKey, specifiedValue) {
    if (!ary || !ary.length) return null;
    return ary.find(function(entry) {
        return entry && (typeof specifiedKey === "function" ? specifiedKey(entry) : (0, (/*@__PURE__*/$parcel$interopDefault($2cd7f9f9c3b27772$exports)))(entry, specifiedKey)) === specifiedValue;
    });
}
var $804fab7e7cc9eb97$export$484982720961754e = function getLinearRegression(data) {
    if (!data || !data.length) return null;
    var len = data.length;
    var xsum = 0;
    var ysum = 0;
    var xysum = 0;
    var xxsum = 0;
    var xmin = Infinity;
    var xmax = -Infinity;
    var xcurrent = 0;
    var ycurrent = 0;
    for(var i = 0; i < len; i++){
        xcurrent = data[i].cx || 0;
        ycurrent = data[i].cy || 0;
        xsum += xcurrent;
        ysum += ycurrent;
        xysum += xcurrent * ycurrent;
        xxsum += xcurrent * xcurrent;
        xmin = Math.min(xmin, xcurrent);
        xmax = Math.max(xmax, xcurrent);
    }
    var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
    return {
        xmin: xmin,
        xmax: xmax,
        a: a,
        b: (ysum - a * xsum) / len
    };
};


function $aaa3487fdd76f634$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $aaa3487fdd76f634$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $aaa3487fdd76f634$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $aaa3487fdd76f634$var$_typeof(obj);
}
function $aaa3487fdd76f634$var$_extends() {
    $aaa3487fdd76f634$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $aaa3487fdd76f634$var$_extends.apply(this, arguments);
}
function $aaa3487fdd76f634$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $aaa3487fdd76f634$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $aaa3487fdd76f634$var$ownKeys(Object(source), true).forEach(function(key) {
            $aaa3487fdd76f634$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $aaa3487fdd76f634$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $aaa3487fdd76f634$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $aaa3487fdd76f634$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $aaa3487fdd76f634$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $aaa3487fdd76f634$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $aaa3487fdd76f634$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $aaa3487fdd76f634$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $aaa3487fdd76f634$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $aaa3487fdd76f634$var$_setPrototypeOf(subClass, superClass);
}
function $aaa3487fdd76f634$var$_setPrototypeOf(o, p) {
    $aaa3487fdd76f634$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $aaa3487fdd76f634$var$_setPrototypeOf(o, p);
}
function $aaa3487fdd76f634$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $aaa3487fdd76f634$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $aaa3487fdd76f634$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $aaa3487fdd76f634$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $aaa3487fdd76f634$var$_possibleConstructorReturn(this, result);
    };
}
function $aaa3487fdd76f634$var$_possibleConstructorReturn(self, call) {
    if (call && ($aaa3487fdd76f634$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $aaa3487fdd76f634$var$_assertThisInitialized(self);
}
function $aaa3487fdd76f634$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $aaa3487fdd76f634$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $aaa3487fdd76f634$var$_getPrototypeOf(o) {
    $aaa3487fdd76f634$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $aaa3487fdd76f634$var$_getPrototypeOf(o);
}
var $aaa3487fdd76f634$var$CURVE_FACTORIES = {
    curveBasisClosed: (0, $f834668643ba3e14$export$2e2bcd8739ae039),
    curveBasisOpen: (0, $1f322ad06d7ca49d$export$2e2bcd8739ae039),
    curveBasis: (0, $69c6afeeac889904$export$2e2bcd8739ae039),
    curveLinearClosed: (0, $eccdf97df583473e$export$2e2bcd8739ae039),
    curveLinear: (0, $21b31c801b6158b4$export$2e2bcd8739ae039),
    curveMonotoneX: (0, $66bc36b6bdff6a71$export$99563b5420dbdc55),
    curveMonotoneY: (0, $66bc36b6bdff6a71$export$8b5360456d6bdb88),
    curveNatural: (0, $96cb6691ac090603$export$2e2bcd8739ae039),
    curveStep: (0, $0fbb17a045950fea$export$2e2bcd8739ae039),
    curveStepAfter: (0, $0fbb17a045950fea$export$793b3db073781cbb),
    curveStepBefore: (0, $0fbb17a045950fea$export$10eafa5b7478b343)
};
var $aaa3487fdd76f634$var$defined = function defined(p) {
    return p.x === +p.x && p.y === +p.y;
};
var $aaa3487fdd76f634$var$getX = function getX(p) {
    return p.x;
};
var $aaa3487fdd76f634$var$getY = function getY(p) {
    return p.y;
};
var $aaa3487fdd76f634$var$getCurveFactory = function getCurveFactory(type, layout) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(type)) return type;
    var name = "curve".concat((0, (/*@__PURE__*/$parcel$interopDefault($ca2cccb92e57cec1$exports)))(type));
    if (name === "curveMonotone" && layout) return $aaa3487fdd76f634$var$CURVE_FACTORIES["".concat(name).concat(layout === "vertical" ? "Y" : "X")];
    return $aaa3487fdd76f634$var$CURVE_FACTORIES[name] || (0, $21b31c801b6158b4$export$2e2bcd8739ae039);
};
var $aaa3487fdd76f634$export$b0e83c3ef8d2db1 = /*#__PURE__*/ function(_PureComponent) {
    $aaa3487fdd76f634$var$_inherits(Curve, _PureComponent);
    var _super = $aaa3487fdd76f634$var$_createSuper(Curve);
    function Curve() {
        $aaa3487fdd76f634$var$_classCallCheck(this, Curve);
        return _super.apply(this, arguments);
    }
    $aaa3487fdd76f634$var$_createClass(Curve, [
        {
            key: "getPath",
            value: /**
     * Calculate the path of curve
     * @return {String} path
     */ function getPath() {
                var _this$props = this.props, type = _this$props.type, points = _this$props.points, baseLine = _this$props.baseLine, layout = _this$props.layout, connectNulls = _this$props.connectNulls;
                var curveFactory = $aaa3487fdd76f634$var$getCurveFactory(type, layout);
                var formatPoints = connectNulls ? points.filter(function(entry) {
                    return $aaa3487fdd76f634$var$defined(entry);
                }) : points;
                var lineFunction;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($0fe4a5546443a34c$exports)))(baseLine)) {
                    var formatBaseLine = connectNulls ? baseLine.filter(function(base) {
                        return $aaa3487fdd76f634$var$defined(base);
                    }) : baseLine;
                    var areaPoints = formatPoints.map(function(entry, index) {
                        return $aaa3487fdd76f634$var$_objectSpread($aaa3487fdd76f634$var$_objectSpread({}, entry), {}, {
                            base: formatBaseLine[index]
                        });
                    });
                    if (layout === "vertical") lineFunction = (0, $ff9c643c89828b15$export$2e2bcd8739ae039)().y($aaa3487fdd76f634$var$getY).x1($aaa3487fdd76f634$var$getX).x0(function(d) {
                        return d.base.x;
                    });
                    else lineFunction = (0, $ff9c643c89828b15$export$2e2bcd8739ae039)().x($aaa3487fdd76f634$var$getX).y1($aaa3487fdd76f634$var$getY).y0(function(d) {
                        return d.base.y;
                    });
                    lineFunction.defined($aaa3487fdd76f634$var$defined).curve(curveFactory);
                    return lineFunction(areaPoints);
                }
                if (layout === "vertical" && (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $ff9c643c89828b15$export$2e2bcd8739ae039)().y($aaa3487fdd76f634$var$getY).x1($aaa3487fdd76f634$var$getX).x0(baseLine);
                else if ((0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $ff9c643c89828b15$export$2e2bcd8739ae039)().x($aaa3487fdd76f634$var$getX).y1($aaa3487fdd76f634$var$getY).y0(baseLine);
                else lineFunction = (0, $8c34c42ff4004274$export$2e2bcd8739ae039)().x($aaa3487fdd76f634$var$getX).y($aaa3487fdd76f634$var$getY);
                lineFunction.defined($aaa3487fdd76f634$var$defined).curve(curveFactory);
                return lineFunction(formatPoints);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, className = _this$props2.className, points = _this$props2.points, path = _this$props2.path, pathRef = _this$props2.pathRef;
                if ((!points || !points.length) && !path) return null;
                var realPath = points && points.length ? this.getPath() : path;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("path", $aaa3487fdd76f634$var$_extends({}, (0, $05a192303b32ed93$export$d697c39a2985a4c)(this.props), (0, $05a192303b32ed93$export$7c4c290a4a9c1b1e)(this.props), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))("recharts-curve", className),
                    d: realPath,
                    ref: pathRef
                }));
            }
        }
    ]);
    return Curve;
}((0, $jC8Vy.PureComponent));
$aaa3487fdd76f634$export$b0e83c3ef8d2db1.defaultProps = {
    type: "linear",
    points: [],
    connectNulls: false
};



var $jC8Vy = parcelRequire("jC8Vy");

var $5UrGx = parcelRequire("5UrGx");

function $d32ef06d884f12a9$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d32ef06d884f12a9$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $d32ef06d884f12a9$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d32ef06d884f12a9$var$_typeof(obj);
}
function $d32ef06d884f12a9$var$_extends() {
    $d32ef06d884f12a9$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d32ef06d884f12a9$var$_extends.apply(this, arguments);
}
function $d32ef06d884f12a9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d32ef06d884f12a9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d32ef06d884f12a9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d32ef06d884f12a9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d32ef06d884f12a9$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $d32ef06d884f12a9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $d32ef06d884f12a9$var$_setPrototypeOf(subClass, superClass);
}
function $d32ef06d884f12a9$var$_setPrototypeOf(o, p) {
    $d32ef06d884f12a9$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d32ef06d884f12a9$var$_setPrototypeOf(o, p);
}
function $d32ef06d884f12a9$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d32ef06d884f12a9$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $d32ef06d884f12a9$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $d32ef06d884f12a9$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $d32ef06d884f12a9$var$_possibleConstructorReturn(this, result);
    };
}
function $d32ef06d884f12a9$var$_possibleConstructorReturn(self, call) {
    if (call && ($d32ef06d884f12a9$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $d32ef06d884f12a9$var$_assertThisInitialized(self);
}
function $d32ef06d884f12a9$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d32ef06d884f12a9$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $d32ef06d884f12a9$var$_getPrototypeOf(o) {
    $d32ef06d884f12a9$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d32ef06d884f12a9$var$_getPrototypeOf(o);
}
var $d32ef06d884f12a9$export$d046b3c4a416f60d = /*#__PURE__*/ function(_PureComponent) {
    $d32ef06d884f12a9$var$_inherits(Dot, _PureComponent);
    var _super = $d32ef06d884f12a9$var$_createSuper(Dot);
    function Dot() {
        $d32ef06d884f12a9$var$_classCallCheck(this, Dot);
        return _super.apply(this, arguments);
    }
    $d32ef06d884f12a9$var$_createClass(Dot, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, cx = _this$props.cx, cy = _this$props.cy, r = _this$props.r, className = _this$props.className;
                var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))("recharts-dot", className);
                if (cx === +cx && cy === +cy && r === +r) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("circle", $d32ef06d884f12a9$var$_extends({}, (0, $05a192303b32ed93$export$d697c39a2985a4c)(this.props), (0, $05a192303b32ed93$export$7c4c290a4a9c1b1e)(this.props), {
                    className: layerClass,
                    cx: cx,
                    cy: cy,
                    r: r
                }));
                return null;
            }
        }
    ]);
    return Dot;
}((0, $jC8Vy.PureComponent));



var $jC8Vy = parcelRequire("jC8Vy");

var $5UrGx = parcelRequire("5UrGx");

function $a857ed6b15ebb152$var$_extends() {
    $a857ed6b15ebb152$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a857ed6b15ebb152$var$_extends.apply(this, arguments);
}
function $a857ed6b15ebb152$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a857ed6b15ebb152$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a857ed6b15ebb152$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $a857ed6b15ebb152$export$936d0764594b6eb3(props) {
    var children = props.children, className = props.className, others = $a857ed6b15ebb152$var$_objectWithoutProperties(props, [
        "children",
        "className"
    ]);
    var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))("recharts-layer", className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("g", $a857ed6b15ebb152$var$_extends({
        className: layerClass
    }, (0, $05a192303b32ed93$export$d697c39a2985a4c)(others, true)), children);
}





var $a33d480412da9c67$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $a33d480412da9c67$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$a33d480412da9c67$exports = $a33d480412da9c67$var$last;




var $jC8Vy = parcelRequire("jC8Vy");




var $jC8Vy = parcelRequire("jC8Vy");

var $5UrGx = parcelRequire("5UrGx");


var $jC8Vy = parcelRequire("jC8Vy");
var $8a98d7eaad4a965c$exports = {};
"use strict";
Object.defineProperty($8a98d7eaad4a965c$exports, "__esModule", {
    value: true
});
var $31c38e0ed921e84b$exports = {};
var $aa8363815c597048$exports = {};
var $aa8363815c597048$var$openParentheses = "(".charCodeAt(0);
var $aa8363815c597048$var$closeParentheses = ")".charCodeAt(0);
var $aa8363815c597048$var$singleQuote = "'".charCodeAt(0);
var $aa8363815c597048$var$doubleQuote = '"'.charCodeAt(0);
var $aa8363815c597048$var$backslash = "\\".charCodeAt(0);
var $aa8363815c597048$var$slash = "/".charCodeAt(0);
var $aa8363815c597048$var$comma = ",".charCodeAt(0);
var $aa8363815c597048$var$colon = ":".charCodeAt(0);
var $aa8363815c597048$var$star = "*".charCodeAt(0);
$aa8363815c597048$exports = function(input) {
    var tokens = [];
    var value = input;
    var next, quote, prev, token, escape, escapePos, whitespacePos;
    var pos = 0;
    var code = value.charCodeAt(pos);
    var max = value.length;
    var stack = [
        {
            nodes: tokens
        }
    ];
    var balanced = 0;
    var parent;
    var name = "";
    var before = "";
    var after = "";
    while(pos < max){
        // Whitespaces
        if (code <= 32) {
            next = pos;
            do {
                next += 1;
                code = value.charCodeAt(next);
            }while (code <= 32);
            token = value.slice(pos, next);
            prev = tokens[tokens.length - 1];
            if (code === $aa8363815c597048$var$closeParentheses && balanced) after = token;
            else if (prev && prev.type === "div") prev.after = token;
            else if (code === $aa8363815c597048$var$comma || code === $aa8363815c597048$var$colon || code === $aa8363815c597048$var$slash && value.charCodeAt(next + 1) !== $aa8363815c597048$var$star) before = token;
            else tokens.push({
                type: "space",
                sourceIndex: pos,
                value: token
            });
            pos = next;
        // Quotes
        } else if (code === $aa8363815c597048$var$singleQuote || code === $aa8363815c597048$var$doubleQuote) {
            next = pos;
            quote = code === $aa8363815c597048$var$singleQuote ? "'" : '"';
            token = {
                type: "string",
                sourceIndex: pos,
                quote: quote
            };
            do {
                escape = false;
                next = value.indexOf(quote, next + 1);
                if (~next) {
                    escapePos = next;
                    while(value.charCodeAt(escapePos - 1) === $aa8363815c597048$var$backslash){
                        escapePos -= 1;
                        escape = !escape;
                    }
                } else {
                    value += quote;
                    next = value.length - 1;
                    token.unclosed = true;
                }
            }while (escape);
            token.value = value.slice(pos + 1, next);
            tokens.push(token);
            pos = next + 1;
            code = value.charCodeAt(pos);
        // Comments
        } else if (code === $aa8363815c597048$var$slash && value.charCodeAt(pos + 1) === $aa8363815c597048$var$star) {
            token = {
                type: "comment",
                sourceIndex: pos
            };
            next = value.indexOf("*/", pos);
            if (next === -1) {
                token.unclosed = true;
                next = value.length;
            }
            token.value = value.slice(pos + 2, next);
            tokens.push(token);
            pos = next + 2;
            code = value.charCodeAt(pos);
        // Dividers
        } else if (code === $aa8363815c597048$var$slash || code === $aa8363815c597048$var$comma || code === $aa8363815c597048$var$colon) {
            token = value[pos];
            tokens.push({
                type: "div",
                sourceIndex: pos - before.length,
                value: token,
                before: before,
                after: ""
            });
            before = "";
            pos += 1;
            code = value.charCodeAt(pos);
        // Open parentheses
        } else if ($aa8363815c597048$var$openParentheses === code) {
            // Whitespaces after open parentheses
            next = pos;
            do {
                next += 1;
                code = value.charCodeAt(next);
            }while (code <= 32);
            token = {
                type: "function",
                sourceIndex: pos - name.length,
                value: name,
                before: value.slice(pos + 1, next)
            };
            pos = next;
            if (name === "url" && code !== $aa8363815c597048$var$singleQuote && code !== $aa8363815c597048$var$doubleQuote) {
                next -= 1;
                do {
                    escape = false;
                    next = value.indexOf(")", next + 1);
                    if (~next) {
                        escapePos = next;
                        while(value.charCodeAt(escapePos - 1) === $aa8363815c597048$var$backslash){
                            escapePos -= 1;
                            escape = !escape;
                        }
                    } else {
                        value += ")";
                        next = value.length - 1;
                        token.unclosed = true;
                    }
                }while (escape);
                // Whitespaces before closed
                whitespacePos = next;
                do {
                    whitespacePos -= 1;
                    code = value.charCodeAt(whitespacePos);
                }while (code <= 32);
                if (pos !== whitespacePos + 1) token.nodes = [
                    {
                        type: "word",
                        sourceIndex: pos,
                        value: value.slice(pos, whitespacePos + 1)
                    }
                ];
                else token.nodes = [];
                if (token.unclosed && whitespacePos + 1 !== next) {
                    token.after = "";
                    token.nodes.push({
                        type: "space",
                        sourceIndex: whitespacePos + 1,
                        value: value.slice(whitespacePos + 1, next)
                    });
                } else token.after = value.slice(whitespacePos + 1, next);
                pos = next + 1;
                code = value.charCodeAt(pos);
                tokens.push(token);
            } else {
                balanced += 1;
                token.after = "";
                tokens.push(token);
                stack.push(token);
                tokens = token.nodes = [];
                parent = token;
            }
            name = "";
        // Close parentheses
        } else if ($aa8363815c597048$var$closeParentheses === code && balanced) {
            pos += 1;
            code = value.charCodeAt(pos);
            parent.after = after;
            after = "";
            balanced -= 1;
            stack.pop();
            parent = stack[balanced];
            tokens = parent.nodes;
        // Words
        } else {
            next = pos;
            do {
                if (code === $aa8363815c597048$var$backslash) next += 1;
                next += 1;
                code = value.charCodeAt(next);
            }while (next < max && !(code <= 32 || code === $aa8363815c597048$var$singleQuote || code === $aa8363815c597048$var$doubleQuote || code === $aa8363815c597048$var$comma || code === $aa8363815c597048$var$colon || code === $aa8363815c597048$var$slash || code === $aa8363815c597048$var$openParentheses || code === $aa8363815c597048$var$closeParentheses && balanced));
            token = value.slice(pos, next);
            if ($aa8363815c597048$var$openParentheses === code) name = token;
            else tokens.push({
                type: "word",
                sourceIndex: pos,
                value: token
            });
            pos = next;
        }
    }
    for(pos = stack.length - 1; pos; pos -= 1)stack[pos].unclosed = true;
    return stack[0].nodes;
};


var $90e7c0e279800557$exports = {};
$90e7c0e279800557$exports = function walk(nodes, cb, bubble) {
    var i, max, node, result;
    for(i = 0, max = nodes.length; i < max; i += 1){
        node = nodes[i];
        if (!bubble) result = cb(node, i, nodes);
        if (result !== false && node.type === "function" && Array.isArray(node.nodes)) walk(node.nodes, cb, bubble);
        if (bubble) cb(node, i, nodes);
    }
};


var $67e1204eeb797344$exports = {};
function $67e1204eeb797344$var$stringifyNode(node, custom) {
    var type = node.type;
    var value = node.value;
    var buf;
    var customResult;
    if (custom && (customResult = custom(node)) !== undefined) return customResult;
    else if (type === "word" || type === "space") return value;
    else if (type === "string") {
        buf = node.quote || "";
        return buf + value + (node.unclosed ? "" : buf);
    } else if (type === "comment") return "/*" + value + (node.unclosed ? "" : "*/");
    else if (type === "div") return (node.before || "") + value + (node.after || "");
    else if (Array.isArray(node.nodes)) {
        buf = $67e1204eeb797344$var$stringify(node.nodes);
        if (type !== "function") return buf;
        return value + "(" + (node.before || "") + buf + (node.after || "") + (node.unclosed ? "" : ")");
    }
    return value;
}
function $67e1204eeb797344$var$stringify(nodes, custom) {
    var result, i;
    if (Array.isArray(nodes)) {
        result = "";
        for(i = nodes.length - 1; ~i; i -= 1)result = $67e1204eeb797344$var$stringifyNode(nodes[i], custom) + result;
        return result;
    }
    return $67e1204eeb797344$var$stringifyNode(nodes, custom);
}
$67e1204eeb797344$exports = $67e1204eeb797344$var$stringify;


function $31c38e0ed921e84b$var$ValueParser(value) {
    if (this instanceof $31c38e0ed921e84b$var$ValueParser) {
        this.nodes = $aa8363815c597048$exports(value);
        return this;
    }
    return new $31c38e0ed921e84b$var$ValueParser(value);
}
$31c38e0ed921e84b$var$ValueParser.prototype.toString = function() {
    return Array.isArray(this.nodes) ? $67e1204eeb797344$exports(this.nodes) : "";
};
$31c38e0ed921e84b$var$ValueParser.prototype.walk = function(cb, bubble) {
    $90e7c0e279800557$exports(this.nodes, cb, bubble);
    return this;
};

$31c38e0ed921e84b$var$ValueParser.unit = (parcelRequire("5cb9q"));
$31c38e0ed921e84b$var$ValueParser.walk = $90e7c0e279800557$exports;
$31c38e0ed921e84b$var$ValueParser.stringify = $67e1204eeb797344$exports;
$31c38e0ed921e84b$exports = $31c38e0ed921e84b$var$ValueParser;


var $8a98d7eaad4a965c$var$_postcssValueParser2 = $8a98d7eaad4a965c$var$_interopRequireDefault($31c38e0ed921e84b$exports);
/* parser generated by jison 0.6.1-215 */ /*
 * Returns a Parser object of the following structure:
 *
 *  Parser: {
 *    yy: {}     The so-called "shared state" or rather the *source* of it;
 *               the real "shared state" `yy` passed around to
 *               the rule actions, etc. is a derivative/copy of this one,
 *               not a direct reference!
 *  }
 *
 *  Parser.prototype: {
 *    yy: {},
 *    EOF: 1,
 *    TERROR: 2,
 *
 *    trace: function(errorMessage, ...),
 *
 *    JisonParserError: function(msg, hash),
 *
 *    quoteName: function(name),
 *               Helper function which can be overridden by user code later on: put suitable
 *               quotes around literal IDs in a description string.
 *
 *    originalQuoteName: function(name),
 *               The basic quoteName handler provided by JISON.
 *               `cleanupAfterParse()` will clean up and reset `quoteName()` to reference this function
 *               at the end of the `parse()`.
 *
 *    describeSymbol: function(symbol),
 *               Return a more-or-less human-readable description of the given symbol, when
 *               available, or the symbol itself, serving as its own 'description' for lack
 *               of something better to serve up.
 *
 *               Return NULL when the symbol is unknown to the parser.
 *
 *    symbols_: {associative list: name ==> number},
 *    terminals_: {associative list: number ==> name},
 *    nonterminals: {associative list: rule-name ==> {associative list: number ==> rule-alt}},
 *    terminal_descriptions_: (if there are any) {associative list: number ==> description},
 *    productions_: [...],
 *
 *    performAction: function parser__performAction(yytext, yyleng, yylineno, yyloc, yystate, yysp, yyvstack, yylstack, yystack, yysstack),
 *
 *               The function parameters and `this` have the following value/meaning:
 *               - `this`    : reference to the `yyval` internal object, which has members (`$` and `_$`)
 *                             to store/reference the rule value `$$` and location info `@$`.
 *
 *                 One important thing to note about `this` a.k.a. `yyval`: every *reduce* action gets
 *                 to see the same object via the `this` reference, i.e. if you wish to carry custom
 *                 data from one reduce action through to the next within a single parse run, then you
 *                 may get nasty and use `yyval` a.k.a. `this` for storing you own semi-permanent data.
 *
 *                 `this.yy` is a direct reference to the `yy` shared state object.
 *
 *                 `%parse-param`-specified additional `parse()` arguments have been added to this `yy`
 *                 object at `parse()` start and are therefore available to the action code via the
 *                 same named `yy.xxxx` attributes (where `xxxx` represents a identifier name from
 *                 the %parse-param` list.
 *
 *               - `yytext`  : reference to the lexer value which belongs to the last lexer token used
 *                             to match this rule. This is *not* the look-ahead token, but the last token
 *                             that's actually part of this rule.
 *
 *                 Formulated another way, `yytext` is the value of the token immediately preceeding
 *                 the current look-ahead token.
 *                 Caveats apply for rules which don't require look-ahead, such as epsilon rules.
 *
 *               - `yyleng`  : ditto as `yytext`, only now for the lexer.yyleng value.
 *
 *               - `yylineno`: ditto as `yytext`, only now for the lexer.yylineno value.
 *
 *               - `yyloc`   : ditto as `yytext`, only now for the lexer.yylloc lexer token location info.
 *
 *                               WARNING: since jison 0.4.18-186 this entry may be NULL/UNDEFINED instead
 *                               of an empty object when no suitable location info can be provided.
 *
 *               - `yystate` : the current parser state number, used internally for dispatching and
 *                               executing the action code chunk matching the rule currently being reduced.
 *
 *               - `yysp`    : the current state stack position (a.k.a. 'stack pointer')
 *
 *                 This one comes in handy when you are going to do advanced things to the parser
 *                 stacks, all of which are accessible from your action code (see the next entries below).
 *
 *                 Also note that you can access this and other stack index values using the new double-hash
 *                 syntax, i.e. `##$ === ##0 === yysp`, while `##1` is the stack index for all things
 *                 related to the first rule term, just like you have `$1`, `@1` and `#1`.
 *                 This is made available to write very advanced grammar action rules, e.g. when you want
 *                 to investigate the parse state stack in your action code, which would, for example,
 *                 be relevant when you wish to implement error diagnostics and reporting schemes similar
 *                 to the work described here:
 *
 *                 + Pottier, F., 2016. Reachability and error diagnosis in LR(1) automata.
 *                   In Journées Francophones des Languages Applicatifs.
 *
 *                 + Jeffery, C.L., 2003. Generating LR syntax error messages from examples.
 *                   ACM Transactions on Programming Languages and Systems (TOPLAS), 25(5), pp.631–640.
 *
 *               - `yyrulelength`: the current rule's term count, i.e. the number of entries occupied on the stack.
 *
 *                 This one comes in handy when you are going to do advanced things to the parser
 *                 stacks, all of which are accessible from your action code (see the next entries below).
 *
 *               - `yyvstack`: reference to the parser value stack. Also accessed via the `$1` etc.
 *                             constructs.
 *
 *               - `yylstack`: reference to the parser token location stack. Also accessed via
 *                             the `@1` etc. constructs.
 *
 *                             WARNING: since jison 0.4.18-186 this array MAY contain slots which are
 *                             UNDEFINED rather than an empty (location) object, when the lexer/parser
 *                             action code did not provide a suitable location info object when such a
 *                             slot was filled!
 *
 *               - `yystack` : reference to the parser token id stack. Also accessed via the
 *                             `#1` etc. constructs.
 *
 *                 Note: this is a bit of a **white lie** as we can statically decode any `#n` reference to
 *                 its numeric token id value, hence that code wouldn't need the `yystack` but *you* might
 *                 want access this array for your own purposes, such as error analysis as mentioned above!
 *
 *                 Note that this stack stores the current stack of *tokens*, that is the sequence of
 *                 already parsed=reduced *nonterminals* (tokens representing rules) and *terminals*
 *                 (lexer tokens *shifted* onto the stack until the rule they belong to is found and
 *                 *reduced*.
 *
 *               - `yysstack`: reference to the parser state stack. This one carries the internal parser
 *                             *states* such as the one in `yystate`, which are used to represent
 *                             the parser state machine in the *parse table*. *Very* *internal* stuff,
 *                             what can I say? If you access this one, you're clearly doing wicked things
 *
 *               - `...`     : the extra arguments you specified in the `%parse-param` statement in your
 *                             grammar definition file.
 *
 *    table: [...],
 *               State transition table
 *               ----------------------
 *
 *               index levels are:
 *               - `state`  --> hash table
 *               - `symbol` --> action (number or array)
 *
 *                 If the `action` is an array, these are the elements' meaning:
 *                 - index [0]: 1 = shift, 2 = reduce, 3 = accept
 *                 - index [1]: GOTO `state`
 *
 *                 If the `action` is a number, it is the GOTO `state`
 *
 *    defaultActions: {...},
 *
 *    parseError: function(str, hash, ExceptionClass),
 *    yyError: function(str, ...),
 *    yyRecovering: function(),
 *    yyErrOk: function(),
 *    yyClearIn: function(),
 *
 *    constructParseErrorInfo: function(error_message, exception_object, expected_token_set, is_recoverable),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               Produces a new errorInfo 'hash object' which can be passed into `parseError()`.
 *               See it's use in this parser kernel in many places; example usage:
 *
 *                   var infoObj = parser.constructParseErrorInfo('fail!', null,
 *                                     parser.collect_expected_token_set(state), true);
 *                   var retVal = parser.parseError(infoObj.errStr, infoObj, parser.JisonParserError);
 *
 *    originalParseError: function(str, hash, ExceptionClass),
 *               The basic `parseError` handler provided by JISON.
 *               `cleanupAfterParse()` will clean up and reset `parseError()` to reference this function
 *               at the end of the `parse()`.
 *
 *    options: { ... parser %options ... },
 *
 *    parse: function(input[, args...]),
 *               Parse the given `input` and return the parsed value (or `true` when none was provided by
 *               the root action, in which case the parser is acting as a *matcher*).
 *               You MAY use the additional `args...` parameters as per `%parse-param` spec of this grammar:
 *               these extra `args...` are added verbatim to the `yy` object reference as member variables.
 *
 *               WARNING:
 *               Parser's additional `args...` parameters (via `%parse-param`) MAY conflict with
 *               any attributes already added to `yy` by the jison run-time;
 *               when such a collision is detected an exception is thrown to prevent the generated run-time
 *               from silently accepting this confusing and potentially hazardous situation!
 *
 *               The lexer MAY add its own set of additional parameters (via the `%parse-param` line in
 *               the lexer section of the grammar spec): these will be inserted in the `yy` shared state
 *               object and any collision with those will be reported by the lexer via a thrown exception.
 *
 *    cleanupAfterParse: function(resultValue, invoke_post_methods, do_not_nuke_errorinfos),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               This helper API is invoked at the end of the `parse()` call, unless an exception was thrown
 *               and `%options no-try-catch` has been defined for this grammar: in that case this helper MAY
 *               be invoked by calling user code to ensure the `post_parse` callbacks are invoked and
 *               the internal parser gets properly garbage collected under these particular circumstances.
 *
 *    yyMergeLocationInfo: function(first_index, last_index, first_yylloc, last_yylloc, dont_look_back),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               This helper API can be invoked to calculate a spanning `yylloc` location info object.
 *
 *               Note: %epsilon rules MAY specify no `first_index` and `first_yylloc`, in which case
 *               this function will attempt to obtain a suitable location marker by inspecting the location stack
 *               backwards.
 *
 *               For more info see the documentation comment further below, immediately above this function's
 *               implementation.
 *
 *    lexer: {
 *        yy: {...},           A reference to the so-called "shared state" `yy` once
 *                             received via a call to the `.setInput(input, yy)` lexer API.
 *        EOF: 1,
 *        ERROR: 2,
 *        JisonLexerError: function(msg, hash),
 *        parseError: function(str, hash, ExceptionClass),
 *        setInput: function(input, [yy]),
 *        input: function(),
 *        unput: function(str),
 *        more: function(),
 *        reject: function(),
 *        less: function(n),
 *        pastInput: function(n),
 *        upcomingInput: function(n),
 *        showPosition: function(),
 *        test_match: function(regex_match_array, rule_index, ...),
 *        next: function(...),
 *        lex: function(...),
 *        begin: function(condition),
 *        pushState: function(condition),
 *        popState: function(),
 *        topState: function(),
 *        _currentRules: function(),
 *        stateStackSize: function(),
 *        cleanupAfterLex: function()
 *
 *        options: { ... lexer %options ... },
 *
 *        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START, ...),
 *        rules: [...],
 *        conditions: {associative list: name ==> set},
 *    }
 *  }
 *
 *
 *  token location info (@$, _$, etc.): {
 *    first_line: n,
 *    last_line: n,
 *    first_column: n,
 *    last_column: n,
 *    range: [start_number, end_number]
 *               (where the numbers are indexes into the input string, zero-based)
 *  }
 *
 * ---
 *
 * The `parseError` function receives a 'hash' object with these members for lexer and
 * parser errors:
 *
 *  {
 *    text:        (matched text)
 *    token:       (the produced terminal token, if any)
 *    token_id:    (the produced terminal token numeric ID, if any)
 *    line:        (yylineno)
 *    loc:         (yylloc)
 *  }
 *
 * parser (grammar) errors will also provide these additional members:
 *
 *  {
 *    expected:    (array describing the set of expected tokens;
 *                  may be UNDEFINED when we cannot easily produce such a set)
 *    state:       (integer (or array when the table includes grammar collisions);
 *                  represents the current internal state of the parser kernel.
 *                  can, for example, be used to pass to the `collect_expected_token_set()`
 *                  API to obtain the expected token set)
 *    action:      (integer; represents the current internal action which will be executed)
 *    new_state:   (integer; represents the next/planned internal state, once the current
 *                  action has executed)
 *    recoverable: (boolean: TRUE when the parser MAY have an error recovery rule
 *                  available for this particular error)
 *    state_stack: (array: the current parser LALR/LR internal state stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    value_stack: (array: the current parser LALR/LR internal `$$` value stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    location_stack: (array: the current parser LALR/LR internal location stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    yy:          (object: the current parser internal "shared state" `yy`
 *                  as is also available in the rule actions; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    lexer:       (reference to the current lexer instance used by the parser)
 *    parser:      (reference to the current parser instance)
 *  }
 *
 * while `this` will reference the current parser instance.
 *
 * When `parseError` is invoked by the lexer, `this` will still reference the related *parser*
 * instance, while these additional `hash` fields will also be provided:
 *
 *  {
 *    lexer:       (reference to the current lexer instance which reported the error)
 *  }
 *
 * When `parseError` is invoked by the parser due to a **JavaScript exception** being fired
 * from either the parser or lexer, `this` will still reference the related *parser*
 * instance, while these additional `hash` fields will also be provided:
 *
 *  {
 *    exception:   (reference to the exception thrown)
 *  }
 *
 * Please do note that in the latter situation, the `expected` field will be omitted as
 * this type of failure is assumed not to be due to *parse errors* but rather due to user
 * action code in either parser or lexer failing unexpectedly.
 *
 * ---
 *
 * You can specify parser options by setting / modifying the `.yy` object of your Parser instance.
 * These options are available:
 *
 * ### options which are global for all parser instances
 *
 *  Parser.pre_parse: function(yy)
 *                 optional: you can specify a pre_parse() function in the chunk following
 *                 the grammar, i.e. after the last `%%`.
 *  Parser.post_parse: function(yy, retval, parseInfo) { return retval; }
 *                 optional: you can specify a post_parse() function in the chunk following
 *                 the grammar, i.e. after the last `%%`. When it does not return any value,
 *                 the parser will return the original `retval`.
 *
 * ### options which can be set up per parser instance
 *
 *  yy: {
 *      pre_parse:  function(yy)
 *                 optional: is invoked before the parse cycle starts (and before the first
 *                 invocation of `lex()`) but immediately after the invocation of
 *                 `parser.pre_parse()`).
 *      post_parse: function(yy, retval, parseInfo) { return retval; }
 *                 optional: is invoked when the parse terminates due to success ('accept')
 *                 or failure (even when exceptions are thrown).
 *                 `retval` contains the return value to be produced by `Parser.parse()`;
 *                 this function can override the return value by returning another.
 *                 When it does not return any value, the parser will return the original
 *                 `retval`.
 *                 This function is invoked immediately before `parser.post_parse()`.
 *
 *      parseError: function(str, hash, ExceptionClass)
 *                 optional: overrides the default `parseError` function.
 *      quoteName: function(name),
 *                 optional: overrides the default `quoteName` function.
 *  }
 *
 *  parser.lexer.options: {
 *      pre_lex:  function()
 *                 optional: is invoked before the lexer is invoked to produce another token.
 *                 `this` refers to the Lexer object.
 *      post_lex: function(token) { return token; }
 *                 optional: is invoked when the lexer has produced a token `token`;
 *                 this function can override the returned token value by returning another.
 *                 When it does not return any (truthy) value, the lexer will return
 *                 the original `token`.
 *                 `this` refers to the Lexer object.
 *
 *      ranges: boolean
 *                 optional: `true` ==> token location info will include a .range[] member.
 *      flex: boolean
 *                 optional: `true` ==> flex-like lexing behaviour where the rules are tested
 *                 exhaustively to find the longest match.
 *      backtrack_lexer: boolean
 *                 optional: `true` ==> lexer regexes are tested in order and for invoked;
 *                 the lexer terminates the scan when a token is returned by the action code.
 *      xregexp: boolean
 *                 optional: `true` ==> lexer rule regexes are "extended regex format" requiring the
 *                 `XRegExp` library. When this `%option` has not been specified at compile time, all lexer
 *                 rule regexes have been written as standard JavaScript RegExp expressions.
 *  }
 */ var $de2299f7e12635b4$export$8f49e4af10703ce3;
var $de2299f7e12635b4$export$7acfa6ed01010e37;
var $de2299f7e12635b4$export$98e6a39c04603d36;
var $de2299f7e12635b4$var$parser = function() {
    // See also:
    // http://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript/#35881508
    // but we keep the prototype.constructor and prototype.name assignment lines too for compatibility
    // with userland code which might access the derived class in a 'classic' way.
    function JisonParserError(msg, hash) {
        Object.defineProperty(this, "name", {
            enumerable: false,
            writable: false,
            value: "JisonParserError"
        });
        if (msg == null) msg = "???";
        Object.defineProperty(this, "message", {
            enumerable: false,
            writable: true,
            value: msg
        });
        this.hash = hash;
        var stacktrace;
        if (hash && hash.exception instanceof Error) {
            var ex2 = hash.exception;
            this.message = ex2.message || msg;
            stacktrace = ex2.stack;
        }
        if (!stacktrace) {
            if (Error.hasOwnProperty("captureStackTrace")) Error.captureStackTrace(this, this.constructor);
            else stacktrace = new Error(msg).stack;
        }
        if (stacktrace) Object.defineProperty(this, "stack", {
            enumerable: false,
            writable: false,
            value: stacktrace
        });
    }
    if (typeof Object.setPrototypeOf === "function") Object.setPrototypeOf(JisonParserError.prototype, Error.prototype);
    else JisonParserError.prototype = Object.create(Error.prototype);
    JisonParserError.prototype.constructor = JisonParserError;
    JisonParserError.prototype.name = "JisonParserError";
    // helper: reconstruct the productions[] table
    function bp(s) {
        var rv = [];
        var p = s.pop;
        var r = s.rule;
        for(var i = 0, l = p.length; i < l; i++)rv.push([
            p[i],
            r[i]
        ]);
        return rv;
    }
    // helper: reconstruct the defaultActions[] table
    function bda(s) {
        var rv = {};
        var d = s.idx;
        var g = s.goto;
        for(var i = 0, l = d.length; i < l; i++){
            var j = d[i];
            rv[j] = g[i];
        }
        return rv;
    }
    // helper: reconstruct the 'goto' table
    function bt(s) {
        var rv = [];
        var d = s.len;
        var y = s.symbol;
        var t = s.type;
        var a = s.state;
        var m = s.mode;
        var g = s.goto;
        for(var i = 0, l = d.length; i < l; i++){
            var n = d[i];
            var q = {};
            for(var j = 0; j < n; j++){
                var z = y.shift();
                switch(t.shift()){
                    case 2:
                        q[z] = [
                            m.shift(),
                            g.shift()
                        ];
                        break;
                    case 0:
                        q[z] = a.shift();
                        break;
                    default:
                        // type === 1: accept
                        q[z] = [
                            3
                        ];
                }
            }
            rv.push(q);
        }
        return rv;
    }
    // helper: runlength encoding with increment step: code, length: step (default step = 0)
    // `this` references an array
    function s(c, l, a) {
        a = a || 0;
        for(var i = 0; i < l; i++){
            this.push(c);
            c += a;
        }
    }
    // helper: duplicate sequence from *relative* offset and length.
    // `this` references an array
    function c(i, l) {
        i = this.length - i;
        for(l += i; i < l; i++)this.push(this[i]);
    }
    // helper: unpack an array using helpers and data, all passed in an array argument 'a'.
    function u(a) {
        var rv = [];
        for(var i = 0, l = a.length; i < l; i++){
            var e = a[i];
            // Is this entry a helper function?
            if (typeof e === "function") {
                i++;
                e.apply(rv, a[i]);
            } else rv.push(e);
        }
        return rv;
    }
    var parser = {
        // Code Generator Information Report
        // ---------------------------------
        //
        // Options:
        //
        //   default action mode: ............. ["classic","merge"]
        //   test-compile action mode: ........ "parser:*,lexer:*"
        //   try..catch: ...................... true
        //   default resolve on conflict: ..... true
        //   on-demand look-ahead: ............ false
        //   error recovery token skip maximum: 3
        //   yyerror in parse actions is: ..... NOT recoverable,
        //   yyerror in lexer actions and other non-fatal lexer are:
        //   .................................. NOT recoverable,
        //   debug grammar/output: ............ false
        //   has partial LR conflict upgrade:   true
        //   rudimentary token-stack support:   false
        //   parser table compression mode: ... 2
        //   export debug tables: ............. false
        //   export *all* tables: ............. false
        //   module type: ..................... commonjs
        //   parser engine type: .............. lalr
        //   output main() in the module: ..... true
        //   has user-specified main(): ....... false
        //   has user-specified require()/import modules for main():
        //   .................................. false
        //   number of expected conflicts: .... 0
        //
        //
        // Parser Analysis flags:
        //
        //   no significant actions (parser is a language matcher only):
        //   .................................. false
        //   uses yyleng: ..................... false
        //   uses yylineno: ................... false
        //   uses yytext: ..................... false
        //   uses yylloc: ..................... false
        //   uses ParseError API: ............. false
        //   uses YYERROR: .................... false
        //   uses YYRECOVERING: ............... false
        //   uses YYERROK: .................... false
        //   uses YYCLEARIN: .................. false
        //   tracks rule values: .............. true
        //   assigns rule values: ............. true
        //   uses location tracking: .......... false
        //   assigns location: ................ false
        //   uses yystack: .................... false
        //   uses yysstack: ................... false
        //   uses yysp: ....................... true
        //   uses yyrulelength: ............... false
        //   uses yyMergeLocationInfo API: .... false
        //   has error recovery: .............. false
        //   has error reporting: ............. false
        //
        // --------- END OF REPORT -----------
        trace: function no_op_trace() {},
        JisonParserError: JisonParserError,
        yy: {},
        options: {
            type: "lalr",
            hasPartialLrUpgradeOnConflict: true,
            errorRecoveryTokenDiscardCount: 3
        },
        symbols_: {
            "$accept": 0,
            "$end": 1,
            "ADD": 3,
            "ANGLE": 16,
            "CHS": 22,
            "COMMA": 14,
            "CSS_CPROP": 13,
            "CSS_VAR": 12,
            "DIV": 6,
            "EMS": 20,
            "EOF": 1,
            "EXS": 21,
            "FREQ": 18,
            "LENGTH": 15,
            "LPAREN": 7,
            "MUL": 5,
            "NESTED_CALC": 9,
            "NUMBER": 11,
            "PERCENTAGE": 28,
            "PREFIX": 10,
            "REMS": 23,
            "RES": 19,
            "RPAREN": 8,
            "SUB": 4,
            "TIME": 17,
            "VHS": 24,
            "VMAXS": 27,
            "VMINS": 26,
            "VWS": 25,
            "css_value": 33,
            "css_variable": 32,
            "error": 2,
            "expression": 29,
            "math_expression": 30,
            "value": 31
        },
        terminals_: {
            1: "EOF",
            2: "error",
            3: "ADD",
            4: "SUB",
            5: "MUL",
            6: "DIV",
            7: "LPAREN",
            8: "RPAREN",
            9: "NESTED_CALC",
            10: "PREFIX",
            11: "NUMBER",
            12: "CSS_VAR",
            13: "CSS_CPROP",
            14: "COMMA",
            15: "LENGTH",
            16: "ANGLE",
            17: "TIME",
            18: "FREQ",
            19: "RES",
            20: "EMS",
            21: "EXS",
            22: "CHS",
            23: "REMS",
            24: "VHS",
            25: "VWS",
            26: "VMINS",
            27: "VMAXS",
            28: "PERCENTAGE"
        },
        TERROR: 2,
        EOF: 1,
        // internals: defined here so the object *structure* doesn't get modified by parse() et al,
        // thus helping JIT compilers like Chrome V8.
        originalQuoteName: null,
        originalParseError: null,
        cleanupAfterParse: null,
        constructParseErrorInfo: null,
        yyMergeLocationInfo: null,
        __reentrant_call_depth: 0,
        __error_infos: [],
        __error_recovery_infos: [],
        // APIs which will be set up depending on user action code analysis:
        //yyRecovering: 0,
        //yyErrOk: 0,
        //yyClearIn: 0,
        // Helper APIs
        // -----------
        // Helper function which can be overridden by user code later on: put suitable quotes around
        // literal IDs in a description string.
        quoteName: function parser_quoteName(id_str) {
            return '"' + id_str + '"';
        },
        // Return the name of the given symbol (terminal or non-terminal) as a string, when available.
        //
        // Return NULL when the symbol is unknown to the parser.
        getSymbolName: function parser_getSymbolName(symbol) {
            if (this.terminals_[symbol]) return this.terminals_[symbol];
            // Otherwise... this might refer to a RULE token i.e. a non-terminal: see if we can dig that one up.
            //
            // An example of this may be where a rule's action code contains a call like this:
            //
            //      parser.getSymbolName(#$)
            //
            // to obtain a human-readable name of the current grammar rule.
            var s = this.symbols_;
            for(var key in s){
                if (s[key] === symbol) return key;
            }
            return null;
        },
        // Return a more-or-less human-readable description of the given symbol, when available,
        // or the symbol itself, serving as its own 'description' for lack of something better to serve up.
        //
        // Return NULL when the symbol is unknown to the parser.
        describeSymbol: function parser_describeSymbol(symbol) {
            if (symbol !== this.EOF && this.terminal_descriptions_ && this.terminal_descriptions_[symbol]) return this.terminal_descriptions_[symbol];
            else if (symbol === this.EOF) return "end of input";
            var id = this.getSymbolName(symbol);
            if (id) return this.quoteName(id);
            return null;
        },
        // Produce a (more or less) human-readable list of expected tokens at the point of failure.
        //
        // The produced list may contain token or token set descriptions instead of the tokens
        // themselves to help turning this output into something that easier to read by humans
        // unless `do_not_describe` parameter is set, in which case a list of the raw, *numeric*,
        // expected terminals and nonterminals is produced.
        //
        // The returned list (array) will not contain any duplicate entries.
        collect_expected_token_set: function parser_collect_expected_token_set(state, do_not_describe) {
            var TERROR = this.TERROR;
            var tokenset = [];
            var check = {};
            // Has this (error?) state been outfitted with a custom expectations description text for human consumption?
            // If so, use that one instead of the less palatable token set.
            if (!do_not_describe && this.state_descriptions_ && this.state_descriptions_[state]) return [
                this.state_descriptions_[state]
            ];
            for(var p in this.table[state]){
                p = +p;
                if (p !== TERROR) {
                    var d = do_not_describe ? p : this.describeSymbol(p);
                    if (d && !check[d]) {
                        tokenset.push(d);
                        check[d] = true; // Mark this token description as already mentioned to prevent outputting duplicate entries.
                    }
                }
            }
            return tokenset;
        },
        productions_: bp({
            pop: u([
                29,
                s,
                [
                    30,
                    10
                ],
                31,
                31,
                32,
                32,
                s,
                [
                    33,
                    15
                ]
            ]),
            rule: u([
                2,
                s,
                [
                    3,
                    5
                ],
                4,
                7,
                s,
                [
                    1,
                    4
                ],
                2,
                4,
                6,
                s,
                [
                    1,
                    14
                ],
                2
            ])
        }),
        performAction: function parser__PerformAction(yystate /* action[1] */ , yysp, yyvstack) {
            /* this == yyval */ // the JS engine itself can go and remove these statements when `yy` turns out to be unused in any action code!
            var yy = this.yy;
            var yyparser = yy.parser;
            var yylexer = yy.lexer;
            switch(yystate){
                case 0:
                    /*! Production::    $accept : expression $end */ // default action (generated by JISON mode classic/merge :: 1,VT,VA,-,-,-,-,-,-):
                    this.$ = yyvstack[yysp - 1];
                    break;
                case 1:
                    /*! Production::    expression : math_expression EOF */ // default action (generated by JISON mode classic/merge :: 2,VT,VA,-,-,-,-,-,-):
                    this.$ = yyvstack[yysp - 1];
                    // END of default action (generated by JISON mode classic/merge :: 2,VT,VA,-,-,-,-,-,-)
                    return yyvstack[yysp - 1];
                case 2:
                /*! Production::    math_expression : math_expression ADD math_expression */ case 3:
                /*! Production::    math_expression : math_expression SUB math_expression */ case 4:
                /*! Production::    math_expression : math_expression MUL math_expression */ case 5:
                    /*! Production::    math_expression : math_expression DIV math_expression */ this.$ = {
                        type: "MathExpression",
                        operator: yyvstack[yysp - 1],
                        left: yyvstack[yysp - 2],
                        right: yyvstack[yysp]
                    };
                    break;
                case 6:
                    /*! Production::    math_expression : LPAREN math_expression RPAREN */ this.$ = yyvstack[yysp - 1];
                    break;
                case 7:
                    /*! Production::    math_expression : NESTED_CALC LPAREN math_expression RPAREN */ this.$ = {
                        type: "Calc",
                        value: yyvstack[yysp - 1]
                    };
                    break;
                case 8:
                    /*! Production::    math_expression : SUB PREFIX SUB NESTED_CALC LPAREN math_expression RPAREN */ this.$ = {
                        type: "Calc",
                        value: yyvstack[yysp - 1],
                        prefix: yyvstack[yysp - 5]
                    };
                    break;
                case 9:
                /*! Production::    math_expression : css_variable */ case 10:
                /*! Production::    math_expression : css_value */ case 11:
                    /*! Production::    math_expression : value */ this.$ = yyvstack[yysp];
                    break;
                case 12:
                    /*! Production::    value : NUMBER */ this.$ = {
                        type: "Value",
                        value: parseFloat(yyvstack[yysp])
                    };
                    break;
                case 13:
                    /*! Production::    value : SUB NUMBER */ this.$ = {
                        type: "Value",
                        value: parseFloat(yyvstack[yysp]) * -1
                    };
                    break;
                case 14:
                    /*! Production::    css_variable : CSS_VAR LPAREN CSS_CPROP RPAREN */ this.$ = {
                        type: "CssVariable",
                        value: yyvstack[yysp - 1]
                    };
                    break;
                case 15:
                    /*! Production::    css_variable : CSS_VAR LPAREN CSS_CPROP COMMA math_expression RPAREN */ this.$ = {
                        type: "CssVariable",
                        value: yyvstack[yysp - 3],
                        fallback: yyvstack[yysp - 1]
                    };
                    break;
                case 16:
                    /*! Production::    css_value : LENGTH */ this.$ = {
                        type: "LengthValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 17:
                    /*! Production::    css_value : ANGLE */ this.$ = {
                        type: "AngleValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 18:
                    /*! Production::    css_value : TIME */ this.$ = {
                        type: "TimeValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 19:
                    /*! Production::    css_value : FREQ */ this.$ = {
                        type: "FrequencyValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 20:
                    /*! Production::    css_value : RES */ this.$ = {
                        type: "ResolutionValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 21:
                    /*! Production::    css_value : EMS */ this.$ = {
                        type: "EmValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "em"
                    };
                    break;
                case 22:
                    /*! Production::    css_value : EXS */ this.$ = {
                        type: "ExValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "ex"
                    };
                    break;
                case 23:
                    /*! Production::    css_value : CHS */ this.$ = {
                        type: "ChValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "ch"
                    };
                    break;
                case 24:
                    /*! Production::    css_value : REMS */ this.$ = {
                        type: "RemValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "rem"
                    };
                    break;
                case 25:
                    /*! Production::    css_value : VHS */ this.$ = {
                        type: "VhValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "vh"
                    };
                    break;
                case 26:
                    /*! Production::    css_value : VWS */ this.$ = {
                        type: "VwValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "vw"
                    };
                    break;
                case 27:
                    /*! Production::    css_value : VMINS */ this.$ = {
                        type: "VminValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "vmin"
                    };
                    break;
                case 28:
                    /*! Production::    css_value : VMAXS */ this.$ = {
                        type: "VmaxValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "vmax"
                    };
                    break;
                case 29:
                    /*! Production::    css_value : PERCENTAGE */ this.$ = {
                        type: "PercentageValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "%"
                    };
                    break;
                case 30:
                    /*! Production::    css_value : SUB css_value */ var prev = yyvstack[yysp];
                    prev.value *= -1;
                    this.$ = prev;
                    break;
            }
        },
        table: bt({
            len: u([
                24,
                1,
                5,
                23,
                1,
                18,
                s,
                [
                    0,
                    3
                ],
                1,
                s,
                [
                    0,
                    16
                ],
                s,
                [
                    23,
                    4
                ],
                c,
                [
                    28,
                    3
                ],
                0,
                0,
                16,
                1,
                6,
                6,
                s,
                [
                    0,
                    3
                ],
                5,
                1,
                2,
                c,
                [
                    37,
                    3
                ],
                c,
                [
                    20,
                    3
                ],
                5,
                0,
                0
            ]),
            symbol: u([
                4,
                7,
                9,
                11,
                12,
                s,
                [
                    15,
                    19,
                    1
                ],
                1,
                1,
                s,
                [
                    3,
                    4,
                    1
                ],
                c,
                [
                    30,
                    19
                ],
                c,
                [
                    29,
                    4
                ],
                7,
                4,
                10,
                11,
                c,
                [
                    22,
                    14
                ],
                c,
                [
                    19,
                    3
                ],
                c,
                [
                    43,
                    22
                ],
                c,
                [
                    23,
                    69
                ],
                c,
                [
                    139,
                    4
                ],
                8,
                c,
                [
                    51,
                    24
                ],
                4,
                c,
                [
                    138,
                    15
                ],
                13,
                c,
                [
                    186,
                    5
                ],
                8,
                c,
                [
                    6,
                    6
                ],
                c,
                [
                    5,
                    5
                ],
                9,
                8,
                14,
                c,
                [
                    159,
                    47
                ],
                c,
                [
                    60,
                    10
                ]
            ]),
            type: u([
                s,
                [
                    2,
                    19
                ],
                s,
                [
                    0,
                    5
                ],
                1,
                s,
                [
                    2,
                    24
                ],
                s,
                [
                    0,
                    4
                ],
                c,
                [
                    22,
                    19
                ],
                c,
                [
                    43,
                    42
                ],
                c,
                [
                    23,
                    70
                ],
                c,
                [
                    28,
                    25
                ],
                c,
                [
                    45,
                    25
                ],
                c,
                [
                    113,
                    54
                ]
            ]),
            state: u([
                1,
                2,
                8,
                6,
                7,
                30,
                c,
                [
                    4,
                    3
                ],
                33,
                37,
                c,
                [
                    5,
                    3
                ],
                38,
                c,
                [
                    4,
                    3
                ],
                39,
                c,
                [
                    4,
                    3
                ],
                40,
                c,
                [
                    4,
                    3
                ],
                42,
                c,
                [
                    21,
                    4
                ],
                50,
                c,
                [
                    5,
                    3
                ],
                51,
                c,
                [
                    4,
                    3
                ]
            ]),
            mode: u([
                s,
                [
                    1,
                    179
                ],
                s,
                [
                    2,
                    3
                ],
                c,
                [
                    5,
                    5
                ],
                c,
                [
                    6,
                    4
                ],
                s,
                [
                    1,
                    57
                ]
            ]),
            goto: u([
                5,
                3,
                4,
                24,
                s,
                [
                    9,
                    15,
                    1
                ],
                s,
                [
                    25,
                    5,
                    1
                ],
                c,
                [
                    24,
                    19
                ],
                31,
                35,
                32,
                34,
                c,
                [
                    18,
                    14
                ],
                36,
                c,
                [
                    38,
                    19
                ],
                c,
                [
                    19,
                    57
                ],
                c,
                [
                    118,
                    4
                ],
                41,
                c,
                [
                    24,
                    19
                ],
                43,
                35,
                c,
                [
                    16,
                    14
                ],
                44,
                s,
                [
                    2,
                    3
                ],
                28,
                29,
                2,
                s,
                [
                    3,
                    3
                ],
                28,
                29,
                3,
                c,
                [
                    53,
                    4
                ],
                s,
                [
                    45,
                    5,
                    1
                ],
                c,
                [
                    100,
                    42
                ],
                52,
                c,
                [
                    5,
                    4
                ],
                53
            ])
        }),
        defaultActions: bda({
            idx: u([
                6,
                7,
                8,
                s,
                [
                    10,
                    16,
                    1
                ],
                33,
                34,
                39,
                40,
                41,
                45,
                47,
                52,
                53
            ]),
            goto: u([
                9,
                10,
                11,
                s,
                [
                    16,
                    14,
                    1
                ],
                12,
                1,
                30,
                13,
                s,
                [
                    4,
                    4,
                    1
                ],
                14,
                15,
                8
            ])
        }),
        parseError: function parseError(str, hash, ExceptionClass) {
            if (hash.recoverable) {
                if (typeof this.trace === "function") this.trace(str);
                hash.destroy(); // destroy... well, *almost*!
            } else {
                if (typeof this.trace === "function") this.trace(str);
                if (!ExceptionClass) ExceptionClass = this.JisonParserError;
                throw new ExceptionClass(str, hash);
            }
        },
        parse: function parse(input) {
            var self = this;
            var stack = new Array(128); // token stack: stores token which leads to state at the same index (column storage)
            var sstack = new Array(128); // state stack: stores states (column storage)
            var vstack = new Array(128); // semantic value stack
            var table = this.table;
            var sp = 0; // 'stack pointer': index into the stacks
            var symbol = 0;
            var TERROR = this.TERROR;
            var EOF = this.EOF;
            var ERROR_RECOVERY_TOKEN_DISCARD_COUNT = this.options.errorRecoveryTokenDiscardCount | 0 || 3;
            var NO_ACTION = [
                0,
                54 /* === table.length :: ensures that anyone using this new state will fail dramatically! */ 
            ];
            var lexer;
            if (this.__lexer__) lexer = this.__lexer__;
            else lexer = this.__lexer__ = Object.create(this.lexer);
            var sharedState_yy = {
                parseError: undefined,
                quoteName: undefined,
                lexer: undefined,
                parser: undefined,
                pre_parse: undefined,
                post_parse: undefined,
                pre_lex: undefined,
                post_lex: undefined // WARNING: must be written this way for the code expanders to work correctly in both ES5 and ES6 modes!
            };
            var ASSERT;
            if (typeof assert !== "function") ASSERT = function JisonAssert(cond, msg) {
                if (!cond) throw new Error("assertion failed: " + (msg || "***"));
            };
            else ASSERT = assert;
            this.yyGetSharedState = function yyGetSharedState() {
                return sharedState_yy;
            };
            function shallow_copy_noclobber(dst, src) {
                for(var k in src)if (typeof dst[k] === "undefined" && Object.prototype.hasOwnProperty.call(src, k)) dst[k] = src[k];
            }
            // copy state
            shallow_copy_noclobber(sharedState_yy, this.yy);
            sharedState_yy.lexer = lexer;
            sharedState_yy.parser = this;
            // Does the shared state override the default `parseError` that already comes with this instance?
            if (typeof sharedState_yy.parseError === "function") this.parseError = function parseErrorAlt(str, hash, ExceptionClass) {
                if (!ExceptionClass) ExceptionClass = this.JisonParserError;
                return sharedState_yy.parseError.call(this, str, hash, ExceptionClass);
            };
            else this.parseError = this.originalParseError;
            // Does the shared state override the default `quoteName` that already comes with this instance?
            if (typeof sharedState_yy.quoteName === "function") this.quoteName = function quoteNameAlt(id_str) {
                return sharedState_yy.quoteName.call(this, id_str);
            };
            else this.quoteName = this.originalQuoteName;
            // set up the cleanup function; make it an API so that external code can re-use this one in case of
            // calamities or when the `%options no-try-catch` option has been specified for the grammar, in which
            // case this parse() API method doesn't come with a `finally { ... }` block any more!
            //
            // NOTE: as this API uses parse() as a closure, it MUST be set again on every parse() invocation,
            //       or else your `sharedState`, etc. references will be *wrong*!
            this.cleanupAfterParse = function parser_cleanupAfterParse(resultValue, invoke_post_methods, do_not_nuke_errorinfos) {
                var rv;
                if (invoke_post_methods) {
                    var hash;
                    if (sharedState_yy.post_parse || this.post_parse) // create an error hash info instance: we re-use this API in a **non-error situation**
                    // as this one delivers all parser internals ready for access by userland code.
                    hash = this.constructParseErrorInfo(null, null, null, false);
                    if (sharedState_yy.post_parse) {
                        rv = sharedState_yy.post_parse.call(this, sharedState_yy, resultValue, hash);
                        if (typeof rv !== "undefined") resultValue = rv;
                    }
                    if (this.post_parse) {
                        rv = this.post_parse.call(this, sharedState_yy, resultValue, hash);
                        if (typeof rv !== "undefined") resultValue = rv;
                    }
                    // cleanup:
                    if (hash && hash.destroy) hash.destroy();
                }
                if (this.__reentrant_call_depth > 1) return resultValue; // do not (yet) kill the sharedState when this is a reentrant run.
                // clean up the lingering lexer structures as well:
                if (lexer.cleanupAfterLex) lexer.cleanupAfterLex(do_not_nuke_errorinfos);
                // prevent lingering circular references from causing memory leaks:
                if (sharedState_yy) {
                    sharedState_yy.lexer = undefined;
                    sharedState_yy.parser = undefined;
                    if (lexer.yy === sharedState_yy) lexer.yy = undefined;
                }
                sharedState_yy = undefined;
                this.parseError = this.originalParseError;
                this.quoteName = this.originalQuoteName;
                // nuke the vstack[] array at least as that one will still reference obsoleted user values.
                // To be safe, we nuke the other internal stack columns as well...
                stack.length = 0; // fastest way to nuke an array without overly bothering the GC
                sstack.length = 0;
                vstack.length = 0;
                sp = 0;
                // nuke the error hash info instances created during this run.
                // Userland code must COPY any data/references
                // in the error hash instance(s) it is more permanently interested in.
                if (!do_not_nuke_errorinfos) {
                    for(var i = this.__error_infos.length - 1; i >= 0; i--){
                        var el = this.__error_infos[i];
                        if (el && typeof el.destroy === "function") el.destroy();
                    }
                    this.__error_infos.length = 0;
                }
                return resultValue;
            };
            // NOTE: as this API uses parse() as a closure, it MUST be set again on every parse() invocation,
            //       or else your `lexer`, `sharedState`, etc. references will be *wrong*!
            this.constructParseErrorInfo = function parser_constructParseErrorInfo(msg, ex, expected, recoverable) {
                var pei = {
                    errStr: msg,
                    exception: ex,
                    text: lexer.match,
                    value: lexer.yytext,
                    token: this.describeSymbol(symbol) || symbol,
                    token_id: symbol,
                    line: lexer.yylineno,
                    expected: expected,
                    recoverable: recoverable,
                    state: state,
                    action: action,
                    new_state: newState,
                    symbol_stack: stack,
                    state_stack: sstack,
                    value_stack: vstack,
                    stack_pointer: sp,
                    yy: sharedState_yy,
                    lexer: lexer,
                    parser: this,
                    // and make sure the error info doesn't stay due to potential
                    // ref cycle via userland code manipulations.
                    // These would otherwise all be memory leak opportunities!
                    //
                    // Note that only array and object references are nuked as those
                    // constitute the set of elements which can produce a cyclic ref.
                    // The rest of the members is kept intact as they are harmless.
                    destroy: function destructParseErrorInfo() {
                        // remove cyclic references added to error info:
                        // info.yy = null;
                        // info.lexer = null;
                        // info.value = null;
                        // info.value_stack = null;
                        // ...
                        var rec = !!this.recoverable;
                        for(var key in this)if (this.hasOwnProperty(key) && typeof key === "object") this[key] = undefined;
                        this.recoverable = rec;
                    }
                };
                // track this instance so we can `destroy()` it once we deem it superfluous and ready for garbage collection!
                this.__error_infos.push(pei);
                return pei;
            };
            function getNonTerminalFromCode(symbol) {
                var tokenName = self.getSymbolName(symbol);
                if (!tokenName) tokenName = symbol;
                return tokenName;
            }
            function stdLex() {
                var token = lexer.lex();
                // if token isn't its numeric value, convert
                if (typeof token !== "number") token = self.symbols_[token] || token;
                return token || EOF;
            }
            function fastLex() {
                var token = lexer.fastLex();
                // if token isn't its numeric value, convert
                if (typeof token !== "number") token = self.symbols_[token] || token;
                return token || EOF;
            }
            var lex = stdLex;
            var state, action, r, t;
            var yyval = {
                $: true,
                _$: undefined,
                yy: sharedState_yy
            };
            var p;
            var yyrulelen;
            var this_production;
            var newState;
            var retval = false;
            try {
                this.__reentrant_call_depth++;
                lexer.setInput(input, sharedState_yy);
                // NOTE: we *assume* no lexer pre/post handlers are set up *after* 
                // this initial `setInput()` call: hence we can now check and decide
                // whether we'll go with the standard, slower, lex() API or the
                // `fast_lex()` one:
                if (typeof lexer.canIUse === "function") {
                    var lexerInfo = lexer.canIUse();
                    if (lexerInfo.fastLex && typeof fastLex === "function") lex = fastLex;
                }
                vstack[sp] = null;
                sstack[sp] = 0;
                stack[sp] = 0;
                ++sp;
                if (this.pre_parse) this.pre_parse.call(this, sharedState_yy);
                if (sharedState_yy.pre_parse) sharedState_yy.pre_parse.call(this, sharedState_yy);
                newState = sstack[sp - 1];
                for(;;){
                    // retrieve state number from top of stack
                    state = newState; // sstack[sp - 1];
                    // use default actions if available
                    if (this.defaultActions[state]) {
                        action = 2;
                        newState = this.defaultActions[state];
                    } else {
                        // The single `==` condition below covers both these `===` comparisons in a single
                        // operation:
                        //
                        //     if (symbol === null || typeof symbol === 'undefined') ...
                        if (!symbol) symbol = lex();
                        // read action for current state and first input
                        t = table[state] && table[state][symbol] || NO_ACTION;
                        newState = t[1];
                        action = t[0];
                        // handle parse error
                        if (!action) {
                            var errStr;
                            var errSymbolDescr = this.describeSymbol(symbol) || symbol;
                            var expected = this.collect_expected_token_set(state);
                            // Report error
                            if (typeof lexer.yylineno === "number") errStr = "Parse error on line " + (lexer.yylineno + 1) + ": ";
                            else errStr = "Parse error: ";
                            if (typeof lexer.showPosition === "function") errStr += "\n" + lexer.showPosition(69, 10) + "\n";
                            if (expected.length) errStr += "Expecting " + expected.join(", ") + ", got unexpected " + errSymbolDescr;
                            else errStr += "Unexpected " + errSymbolDescr;
                            // we cannot recover from the error!
                            p = this.constructParseErrorInfo(errStr, null, expected, false);
                            r = this.parseError(p.errStr, p, this.JisonParserError);
                            if (typeof r !== "undefined") retval = r;
                            break;
                        }
                    }
                    switch(action){
                        // catch misc. parse failures:
                        default:
                            // this shouldn't happen, unless resolve defaults are off
                            if (action instanceof Array) {
                                p = this.constructParseErrorInfo("Parse Error: multiple actions possible at state: " + state + ", token: " + symbol, null, null, false);
                                r = this.parseError(p.errStr, p, this.JisonParserError);
                                if (typeof r !== "undefined") retval = r;
                                break;
                            }
                            // Another case of better safe than sorry: in case state transitions come out of another error recovery process
                            // or a buggy LUT (LookUp Table):
                            p = this.constructParseErrorInfo("Parsing halted. No viable error recovery approach available due to internal system failure.", null, null, false);
                            r = this.parseError(p.errStr, p, this.JisonParserError);
                            if (typeof r !== "undefined") retval = r;
                            break;
                        // shift:
                        case 1:
                            stack[sp] = symbol;
                            vstack[sp] = lexer.yytext;
                            sstack[sp] = newState; // push state
                            ++sp;
                            symbol = 0;
                            continue;
                        // reduce:
                        case 2:
                            this_production = this.productions_[newState - 1]; // `this.productions_[]` is zero-based indexed while states start from 1 upwards...
                            yyrulelen = this_production[1];
                            r = this.performAction.call(yyval, newState, sp - 1, vstack);
                            if (typeof r !== "undefined") {
                                retval = r;
                                break;
                            }
                            // pop off stack
                            sp -= yyrulelen;
                            // don't overwrite the `symbol` variable: use a local var to speed things up:
                            var ntsymbol = this_production[0]; // push nonterminal (reduce)
                            stack[sp] = ntsymbol;
                            vstack[sp] = yyval.$;
                            // goto new state = table[STATE][NONTERMINAL]
                            newState = table[sstack[sp - 1]][ntsymbol];
                            sstack[sp] = newState;
                            ++sp;
                            continue;
                        // accept:
                        case 3:
                            if (sp !== -2) {
                                retval = true;
                                // Return the `$accept` rule's `$$` result, if available.
                                //
                                // Also note that JISON always adds this top-most `$accept` rule (with implicit,
                                // default, action):
                                //
                                //     $accept: <startSymbol> $end
                                //                  %{ $$ = $1; @$ = @1; %}
                                //
                                // which, combined with the parse kernel's `$accept` state behaviour coded below,
                                // will produce the `$$` value output of the <startSymbol> rule as the parse result,
                                // IFF that result is *not* `undefined`. (See also the parser kernel code.)
                                //
                                // In code:
                                //
                                //                  %{
                                //                      @$ = @1;            // if location tracking support is included
                                //                      if (typeof $1 !== 'undefined')
                                //                          return $1;
                                //                      else
                                //                          return true;           // the default parse result if the rule actions don't produce anything
                                //                  %}
                                sp--;
                                if (typeof vstack[sp] !== "undefined") retval = vstack[sp];
                            }
                            break;
                    }
                    break;
                }
            } catch (ex) {
                // report exceptions through the parseError callback too, but keep the exception intact
                // if it is a known parser or lexer error which has been thrown by parseError() already:
                if (ex instanceof this.JisonParserError) throw ex;
                else if (lexer && typeof lexer.JisonLexerError === "function" && ex instanceof lexer.JisonLexerError) throw ex;
                p = this.constructParseErrorInfo("Parsing aborted due to exception.", ex, null, false);
                retval = false;
                r = this.parseError(p.errStr, p, this.JisonParserError);
                if (typeof r !== "undefined") retval = r;
            } finally{
                retval = this.cleanupAfterParse(retval, true, true);
                this.__reentrant_call_depth--;
            } // /finally
            return retval;
        }
    };
    parser.originalParseError = parser.parseError;
    parser.originalQuoteName = parser.quoteName;
    /* lexer generated by jison-lex 0.6.1-215 */ /*
 * Returns a Lexer object of the following structure:
 *
 *  Lexer: {
 *    yy: {}     The so-called "shared state" or rather the *source* of it;
 *               the real "shared state" `yy` passed around to
 *               the rule actions, etc. is a direct reference!
 *
 *               This "shared context" object was passed to the lexer by way of 
 *               the `lexer.setInput(str, yy)` API before you may use it.
 *
 *               This "shared context" object is passed to the lexer action code in `performAction()`
 *               so userland code in the lexer actions may communicate with the outside world 
 *               and/or other lexer rules' actions in more or less complex ways.
 *
 *  }
 *
 *  Lexer.prototype: {
 *    EOF: 1,
 *    ERROR: 2,
 *
 *    yy:        The overall "shared context" object reference.
 *
 *    JisonLexerError: function(msg, hash),
 *
 *    performAction: function lexer__performAction(yy, yyrulenumber, YY_START),
 *
 *               The function parameters and `this` have the following value/meaning:
 *               - `this`    : reference to the `lexer` instance. 
 *                               `yy_` is an alias for `this` lexer instance reference used internally.
 *
 *               - `yy`      : a reference to the `yy` "shared state" object which was passed to the lexer
 *                             by way of the `lexer.setInput(str, yy)` API before.
 *
 *                             Note:
 *                             The extra arguments you specified in the `%parse-param` statement in your
 *                             **parser** grammar definition file are passed to the lexer via this object
 *                             reference as member variables.
 *
 *               - `yyrulenumber`   : index of the matched lexer rule (regex), used internally.
 *
 *               - `YY_START`: the current lexer "start condition" state.
 *
 *    parseError: function(str, hash, ExceptionClass),
 *
 *    constructLexErrorInfo: function(error_message, is_recoverable),
 *               Helper function.
 *               Produces a new errorInfo 'hash object' which can be passed into `parseError()`.
 *               See it's use in this lexer kernel in many places; example usage:
 *
 *                   var infoObj = lexer.constructParseErrorInfo('fail!', true);
 *                   var retVal = lexer.parseError(infoObj.errStr, infoObj, lexer.JisonLexerError);
 *
 *    options: { ... lexer %options ... },
 *
 *    lex: function(),
 *               Produce one token of lexed input, which was passed in earlier via the `lexer.setInput()` API.
 *               You MAY use the additional `args...` parameters as per `%parse-param` spec of the **lexer** grammar:
 *               these extra `args...` are added verbatim to the `yy` object reference as member variables.
 *
 *               WARNING:
 *               Lexer's additional `args...` parameters (via lexer's `%parse-param`) MAY conflict with
 *               any attributes already added to `yy` by the **parser** or the jison run-time; 
 *               when such a collision is detected an exception is thrown to prevent the generated run-time 
 *               from silently accepting this confusing and potentially hazardous situation! 
 *
 *    cleanupAfterLex: function(do_not_nuke_errorinfos),
 *               Helper function.
 *
 *               This helper API is invoked when the **parse process** has completed: it is the responsibility
 *               of the **parser** (or the calling userland code) to invoke this method once cleanup is desired. 
 *
 *               This helper may be invoked by user code to ensure the internal lexer gets properly garbage collected.
 *
 *    setInput: function(input, [yy]),
 *
 *
 *    input: function(),
 *
 *
 *    unput: function(str),
 *
 *
 *    more: function(),
 *
 *
 *    reject: function(),
 *
 *
 *    less: function(n),
 *
 *
 *    pastInput: function(n),
 *
 *
 *    upcomingInput: function(n),
 *
 *
 *    showPosition: function(),
 *
 *
 *    test_match: function(regex_match_array, rule_index),
 *
 *
 *    next: function(),
 *
 *
 *    begin: function(condition),
 *
 *
 *    pushState: function(condition),
 *
 *
 *    popState: function(),
 *
 *
 *    topState: function(),
 *
 *
 *    _currentRules: function(),
 *
 *
 *    stateStackSize: function(),
 *
 *
 *    performAction: function(yy, yy_, yyrulenumber, YY_START),
 *
 *
 *    rules: [...],
 *
 *
 *    conditions: {associative list: name ==> set},
 *  }
 *
 *
 *  token location info (`yylloc`): {
 *    first_line: n,
 *    last_line: n,
 *    first_column: n,
 *    last_column: n,
 *    range: [start_number, end_number]
 *               (where the numbers are indexes into the input string, zero-based)
 *  }
 *
 * ---
 *
 * The `parseError` function receives a 'hash' object with these members for lexer errors:
 *
 *  {
 *    text:        (matched text)
 *    token:       (the produced terminal token, if any)
 *    token_id:    (the produced terminal token numeric ID, if any)
 *    line:        (yylineno)
 *    loc:         (yylloc)
 *    recoverable: (boolean: TRUE when the parser MAY have an error recovery rule
 *                  available for this particular error)
 *    yy:          (object: the current parser internal "shared state" `yy`
 *                  as is also available in the rule actions; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    lexer:       (reference to the current lexer instance used by the parser)
 *  }
 *
 * while `this` will reference the current lexer instance.
 *
 * When `parseError` is invoked by the lexer, the default implementation will
 * attempt to invoke `yy.parser.parseError()`; when this callback is not provided
 * it will try to invoke `yy.parseError()` instead. When that callback is also not
 * provided, a `JisonLexerError` exception will be thrown containing the error
 * message and `hash`, as constructed by the `constructLexErrorInfo()` API.
 *
 * Note that the lexer's `JisonLexerError` error class is passed via the
 * `ExceptionClass` argument, which is invoked to construct the exception
 * instance to be thrown, so technically `parseError` will throw the object
 * produced by the `new ExceptionClass(str, hash)` JavaScript expression.
 *
 * ---
 *
 * You can specify lexer options by setting / modifying the `.options` object of your Lexer instance.
 * These options are available:
 *
 * (Options are permanent.)
 *  
 *  yy: {
 *      parseError: function(str, hash, ExceptionClass)
 *                 optional: overrides the default `parseError` function.
 *  }
 *
 *  lexer.options: {
 *      pre_lex:  function()
 *                 optional: is invoked before the lexer is invoked to produce another token.
 *                 `this` refers to the Lexer object.
 *      post_lex: function(token) { return token; }
 *                 optional: is invoked when the lexer has produced a token `token`;
 *                 this function can override the returned token value by returning another.
 *                 When it does not return any (truthy) value, the lexer will return
 *                 the original `token`.
 *                 `this` refers to the Lexer object.
 *
 * WARNING: the next set of options are not meant to be changed. They echo the abilities of
 * the lexer as per when it was compiled!
 *
 *      ranges: boolean
 *                 optional: `true` ==> token location info will include a .range[] member.
 *      flex: boolean
 *                 optional: `true` ==> flex-like lexing behaviour where the rules are tested
 *                 exhaustively to find the longest match.
 *      backtrack_lexer: boolean
 *                 optional: `true` ==> lexer regexes are tested in order and for invoked;
 *                 the lexer terminates the scan when a token is returned by the action code.
 *      xregexp: boolean
 *                 optional: `true` ==> lexer rule regexes are "extended regex format" requiring the
 *                 `XRegExp` library. When this %option has not been specified at compile time, all lexer
 *                 rule regexes have been written as standard JavaScript RegExp expressions.
 *  }
 */ var lexer = function() {
        /**
   * See also:
   * http://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript/#35881508
   * but we keep the prototype.constructor and prototype.name assignment lines too for compatibility
   * with userland code which might access the derived class in a 'classic' way.
   *
   * @public
   * @constructor
   * @nocollapse
   */ function JisonLexerError(msg, hash) {
            Object.defineProperty(this, "name", {
                enumerable: false,
                writable: false,
                value: "JisonLexerError"
            });
            if (msg == null) msg = "???";
            Object.defineProperty(this, "message", {
                enumerable: false,
                writable: true,
                value: msg
            });
            this.hash = hash;
            var stacktrace;
            if (hash && hash.exception instanceof Error) {
                var ex2 = hash.exception;
                this.message = ex2.message || msg;
                stacktrace = ex2.stack;
            }
            if (!stacktrace) {
                if (Error.hasOwnProperty("captureStackTrace")) // V8
                Error.captureStackTrace(this, this.constructor);
                else stacktrace = new Error(msg).stack;
            }
            if (stacktrace) Object.defineProperty(this, "stack", {
                enumerable: false,
                writable: false,
                value: stacktrace
            });
        }
        if (typeof Object.setPrototypeOf === "function") Object.setPrototypeOf(JisonLexerError.prototype, Error.prototype);
        else JisonLexerError.prototype = Object.create(Error.prototype);
        JisonLexerError.prototype.constructor = JisonLexerError;
        JisonLexerError.prototype.name = "JisonLexerError";
        var lexer = {
            // Code Generator Information Report
            // ---------------------------------
            //
            // Options:
            //
            //   backtracking: .................... false
            //   location.ranges: ................. false
            //   location line+column tracking: ... true
            //
            //
            // Forwarded Parser Analysis flags:
            //
            //   uses yyleng: ..................... false
            //   uses yylineno: ................... false
            //   uses yytext: ..................... false
            //   uses yylloc: ..................... false
            //   uses lexer values: ............... true / true
            //   location tracking: ............... false
            //   location assignment: ............. false
            //
            //
            // Lexer Analysis flags:
            //
            //   uses yyleng: ..................... ???
            //   uses yylineno: ................... ???
            //   uses yytext: ..................... ???
            //   uses yylloc: ..................... ???
            //   uses ParseError API: ............. ???
            //   uses yyerror: .................... ???
            //   uses location tracking & editing:  ???
            //   uses more() API: ................. ???
            //   uses unput() API: ................ ???
            //   uses reject() API: ............... ???
            //   uses less() API: ................. ???
            //   uses display APIs pastInput(), upcomingInput(), showPosition():
            //        ............................. ???
            //   uses describeYYLLOC() API: ....... ???
            //
            // --------- END OF REPORT -----------
            EOF: 1,
            ERROR: 2,
            // JisonLexerError: JisonLexerError,        /// <-- injected by the code generator
            // options: {},                             /// <-- injected by the code generator
            // yy: ...,                                 /// <-- injected by setInput()
            __currentRuleSet__: null,
            __error_infos: [],
            __decompressed: false,
            done: false,
            _backtrack: false,
            _input: "",
            _more: false,
            _signaled_error_token: false,
            conditionStack: [],
            match: "",
            matched: "",
            matches: false,
            yytext: "",
            offset: 0,
            yyleng: 0,
            yylineno: 0,
            yylloc: null,
            /**
     * INTERNAL USE: construct a suitable error info hash object instance for `parseError`.
     * 
     * @public
     * @this {RegExpLexer}
     */ constructLexErrorInfo: function lexer_constructLexErrorInfo(msg, recoverable, show_input_position) {
                msg = "" + msg;
                // heuristic to determine if the error message already contains a (partial) source code dump
                // as produced by either `showPosition()` or `prettyPrintRange()`:
                if (show_input_position == undefined) show_input_position = !(msg.indexOf("\n") > 0 && msg.indexOf("^") > 0);
                if (this.yylloc && show_input_position) {
                    if (typeof this.prettyPrintRange === "function") {
                        var pretty_src = this.prettyPrintRange(this.yylloc);
                        if (!/\n\s*$/.test(msg)) msg += "\n";
                        msg += "\n  Erroneous area:\n" + this.prettyPrintRange(this.yylloc);
                    } else if (typeof this.showPosition === "function") {
                        var pos_str = this.showPosition();
                        if (pos_str) {
                            if (msg.length && msg[msg.length - 1] !== "\n" && pos_str[0] !== "\n") msg += "\n" + pos_str;
                            else msg += pos_str;
                        }
                    }
                }
                /** @constructor */ var pei = {
                    errStr: msg,
                    recoverable: !!recoverable,
                    text: this.match,
                    token: null,
                    line: this.yylineno,
                    loc: this.yylloc,
                    yy: this.yy,
                    lexer: this,
                    /**
         * and make sure the error info doesn't stay due to potential
         * ref cycle via userland code manipulations.
         * These would otherwise all be memory leak opportunities!
         * 
         * Note that only array and object references are nuked as those
         * constitute the set of elements which can produce a cyclic ref.
         * The rest of the members is kept intact as they are harmless.
         * 
         * @public
         * @this {LexErrorInfo}
         */ destroy: function destructLexErrorInfo() {
                        // remove cyclic references added to error info:
                        // info.yy = null;
                        // info.lexer = null;
                        // ...
                        var rec = !!this.recoverable;
                        for(var key in this)if (this.hasOwnProperty(key) && typeof key === "object") this[key] = undefined;
                        this.recoverable = rec;
                    }
                };
                // track this instance so we can `destroy()` it once we deem it superfluous and ready for garbage collection!
                this.__error_infos.push(pei);
                return pei;
            },
            /**
     * handler which is invoked when a lexer error occurs.
     * 
     * @public
     * @this {RegExpLexer}
     */ parseError: function lexer_parseError(str, hash, ExceptionClass) {
                if (!ExceptionClass) ExceptionClass = this.JisonLexerError;
                if (this.yy) {
                    if (this.yy.parser && typeof this.yy.parser.parseError === "function") return this.yy.parser.parseError.call(this, str, hash, ExceptionClass) || this.ERROR;
                    else if (typeof this.yy.parseError === "function") return this.yy.parseError.call(this, str, hash, ExceptionClass) || this.ERROR;
                }
                throw new ExceptionClass(str, hash);
            },
            /**
     * method which implements `yyerror(str, ...args)` functionality for use inside lexer actions.
     * 
     * @public
     * @this {RegExpLexer}
     */ yyerror: function yyError(str /*, ...args */ ) {
                var lineno_msg = "";
                if (this.yylloc) lineno_msg = " on line " + (this.yylineno + 1);
                var p = this.constructLexErrorInfo("Lexical error" + lineno_msg + ": " + str, this.options.lexerErrorsAreRecoverable);
                // Add any extra args to the hash under the name `extra_error_attributes`:
                var args = Array.prototype.slice.call(arguments, 1);
                if (args.length) p.extra_error_attributes = args;
                return this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
            },
            /**
     * final cleanup function for when we have completed lexing the input;
     * make it an API so that external code can use this one once userland
     * code has decided it's time to destroy any lingering lexer error
     * hash object instances and the like: this function helps to clean
     * up these constructs, which *may* carry cyclic references which would
     * otherwise prevent the instances from being properly and timely
     * garbage-collected, i.e. this function helps prevent memory leaks!
     * 
     * @public
     * @this {RegExpLexer}
     */ cleanupAfterLex: function lexer_cleanupAfterLex(do_not_nuke_errorinfos) {
                // prevent lingering circular references from causing memory leaks:
                this.setInput("", {});
                // nuke the error hash info instances created during this run.
                // Userland code must COPY any data/references
                // in the error hash instance(s) it is more permanently interested in.
                if (!do_not_nuke_errorinfos) {
                    for(var i = this.__error_infos.length - 1; i >= 0; i--){
                        var el = this.__error_infos[i];
                        if (el && typeof el.destroy === "function") el.destroy();
                    }
                    this.__error_infos.length = 0;
                }
                return this;
            },
            /**
     * clear the lexer token context; intended for internal use only
     * 
     * @public
     * @this {RegExpLexer}
     */ clear: function lexer_clear() {
                this.yytext = "";
                this.yyleng = 0;
                this.match = "";
                // - DO NOT reset `this.matched`
                this.matches = false;
                this._more = false;
                this._backtrack = false;
                var col = this.yylloc ? this.yylloc.last_column : 0;
                this.yylloc = {
                    first_line: this.yylineno + 1,
                    first_column: col,
                    last_line: this.yylineno + 1,
                    last_column: col,
                    range: [
                        this.offset,
                        this.offset
                    ]
                };
            },
            /**
     * resets the lexer, sets new input
     * 
     * @public
     * @this {RegExpLexer}
     */ setInput: function lexer_setInput(input, yy) {
                this.yy = yy || this.yy || {};
                // also check if we've fully initialized the lexer instance,
                // including expansion work to be done to go from a loaded
                // lexer to a usable lexer:
                if (!this.__decompressed) {
                    // step 1: decompress the regex list:
                    var rules = this.rules;
                    for(var i = 0, len = rules.length; i < len; i++){
                        var rule_re = rules[i];
                        // compression: is the RE an xref to another RE slot in the rules[] table?
                        if (typeof rule_re === "number") rules[i] = rules[rule_re];
                    }
                    // step 2: unfold the conditions[] set to make these ready for use:
                    var conditions = this.conditions;
                    for(var k in conditions){
                        var spec = conditions[k];
                        var rule_ids = spec.rules;
                        var len = rule_ids.length;
                        var rule_regexes = new Array(len + 1); // slot 0 is unused; we use a 1-based index approach here to keep the hottest code in `lexer_next()` fast and simple! 
                        var rule_new_ids = new Array(len + 1);
                        for(var i = 0; i < len; i++){
                            var idx = rule_ids[i];
                            var rule_re = rules[idx];
                            rule_regexes[i + 1] = rule_re;
                            rule_new_ids[i + 1] = idx;
                        }
                        spec.rules = rule_new_ids;
                        spec.__rule_regexes = rule_regexes;
                        spec.__rule_count = len;
                    }
                    this.__decompressed = true;
                }
                this._input = input || "";
                this.clear();
                this._signaled_error_token = false;
                this.done = false;
                this.yylineno = 0;
                this.matched = "";
                this.conditionStack = [
                    "INITIAL"
                ];
                this.__currentRuleSet__ = null;
                this.yylloc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0,
                    range: [
                        0,
                        0
                    ]
                };
                this.offset = 0;
                return this;
            },
            /**
     * edit the remaining input via user-specified callback.
     * This can be used to forward-adjust the input-to-parse, 
     * e.g. inserting macro expansions and alike in the
     * input which has yet to be lexed.
     * The behaviour of this API contrasts the `unput()` et al
     * APIs as those act on the *consumed* input, while this
     * one allows one to manipulate the future, without impacting
     * the current `yyloc` cursor location or any history. 
     * 
     * Use this API to help implement C-preprocessor-like
     * `#include` statements, etc.
     * 
     * The provided callback must be synchronous and is
     * expected to return the edited input (string).
     *
     * The `cpsArg` argument value is passed to the callback
     * as-is.
     *
     * `callback` interface: 
     * `function callback(input, cpsArg)`
     * 
     * - `input` will carry the remaining-input-to-lex string
     *   from the lexer.
     * - `cpsArg` is `cpsArg` passed into this API.
     * 
     * The `this` reference for the callback will be set to
     * reference this lexer instance so that userland code
     * in the callback can easily and quickly access any lexer
     * API. 
     *
     * When the callback returns a non-string-type falsey value,
     * we assume the callback did not edit the input and we
     * will using the input as-is.
     *
     * When the callback returns a non-string-type value, it
     * is converted to a string for lexing via the `"" + retval`
     * operation. (See also why: http://2ality.com/2012/03/converting-to-string.html 
     * -- that way any returned object's `toValue()` and `toString()`
     * methods will be invoked in a proper/desirable order.)
     * 
     * @public
     * @this {RegExpLexer}
     */ editRemainingInput: function lexer_editRemainingInput(callback, cpsArg) {
                var rv = callback.call(this, this._input, cpsArg);
                if (typeof rv !== "string") {
                    if (rv) this._input = "" + rv;
                } else this._input = rv;
                return this;
            },
            /**
     * consumes and returns one char from the input
     * 
     * @public
     * @this {RegExpLexer}
     */ input: function lexer_input() {
                if (!this._input) //this.done = true;    -- don't set `done` as we want the lex()/next() API to be able to produce one custom EOF token match after this anyhow. (lexer can match special <<EOF>> tokens and perform user action code for a <<EOF>> match, but only does so *once*)
                return null;
                var ch = this._input[0];
                this.yytext += ch;
                this.yyleng++;
                this.offset++;
                this.match += ch;
                this.matched += ch;
                // Count the linenumber up when we hit the LF (or a stand-alone CR).
                // On CRLF, the linenumber is incremented when you fetch the CR or the CRLF combo
                // and we advance immediately past the LF as well, returning both together as if
                // it was all a single 'character' only.
                var slice_len = 1;
                var lines = false;
                if (ch === "\n") lines = true;
                else if (ch === "\r") {
                    lines = true;
                    var ch2 = this._input[1];
                    if (ch2 === "\n") {
                        slice_len++;
                        ch += ch2;
                        this.yytext += ch2;
                        this.yyleng++;
                        this.offset++;
                        this.match += ch2;
                        this.matched += ch2;
                        this.yylloc.range[1]++;
                    }
                }
                if (lines) {
                    this.yylineno++;
                    this.yylloc.last_line++;
                    this.yylloc.last_column = 0;
                } else this.yylloc.last_column++;
                this.yylloc.range[1]++;
                this._input = this._input.slice(slice_len);
                return ch;
            },
            /**
     * unshifts one char (or an entire string) into the input
     * 
     * @public
     * @this {RegExpLexer}
     */ unput: function lexer_unput(ch) {
                var len = ch.length;
                var lines = ch.split(/(?:\r\n?|\n)/g);
                this._input = ch + this._input;
                this.yytext = this.yytext.substr(0, this.yytext.length - len);
                this.yyleng = this.yytext.length;
                this.offset -= len;
                this.match = this.match.substr(0, this.match.length - len);
                this.matched = this.matched.substr(0, this.matched.length - len);
                if (lines.length > 1) {
                    this.yylineno -= lines.length - 1;
                    this.yylloc.last_line = this.yylineno + 1;
                    // Get last entirely matched line into the `pre_lines[]` array's
                    // last index slot; we don't mind when other previously 
                    // matched lines end up in the array too. 
                    var pre = this.match;
                    var pre_lines = pre.split(/(?:\r\n?|\n)/g);
                    if (pre_lines.length === 1) {
                        pre = this.matched;
                        pre_lines = pre.split(/(?:\r\n?|\n)/g);
                    }
                    this.yylloc.last_column = pre_lines[pre_lines.length - 1].length;
                } else this.yylloc.last_column -= len;
                this.yylloc.range[1] = this.yylloc.range[0] + this.yyleng;
                this.done = false;
                return this;
            },
            /**
     * cache matched text and append it on next action
     * 
     * @public
     * @this {RegExpLexer}
     */ more: function lexer_more() {
                this._more = true;
                return this;
            },
            /**
     * signal the lexer that this rule fails to match the input, so the
     * next matching rule (regex) should be tested instead.
     * 
     * @public
     * @this {RegExpLexer}
     */ reject: function lexer_reject() {
                if (this.options.backtrack_lexer) this._backtrack = true;
                else {
                    // when the `parseError()` call returns, we MUST ensure that the error is registered.
                    // We accomplish this by signaling an 'error' token to be produced for the current
                    // `.lex()` run.
                    var lineno_msg = "";
                    if (this.yylloc) lineno_msg = " on line " + (this.yylineno + 1);
                    var p = this.constructLexErrorInfo("Lexical error" + lineno_msg + ": You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).", false);
                    this._signaled_error_token = this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
                }
                return this;
            },
            /**
     * retain first n characters of the match
     * 
     * @public
     * @this {RegExpLexer}
     */ less: function lexer_less(n) {
                return this.unput(this.match.slice(n));
            },
            /**
     * return (part of the) already matched input, i.e. for error
     * messages.
     * 
     * Limit the returned string length to `maxSize` (default: 20).
     * 
     * Limit the returned string to the `maxLines` number of lines of
     * input (default: 1).
     * 
     * Negative limit values equal *unlimited*.
     * 
     * @public
     * @this {RegExpLexer}
     */ pastInput: function lexer_pastInput(maxSize, maxLines) {
                var past = this.matched.substring(0, this.matched.length - this.match.length);
                if (maxSize < 0) maxSize = past.length;
                else if (!maxSize) maxSize = 20;
                if (maxLines < 0) maxLines = past.length; // can't ever have more input lines than this! 
                else if (!maxLines) maxLines = 1;
                // `substr` anticipation: treat \r\n as a single character and take a little
                // more than necessary so that we can still properly check against maxSize
                // after we've transformed and limited the newLines in here:
                past = past.substr(-maxSize * 2 - 2);
                // now that we have a significantly reduced string to process, transform the newlines
                // and chop them, then limit them:
                var a = past.replace(/\r\n|\r/g, "\n").split("\n");
                a = a.slice(-maxLines);
                past = a.join("\n");
                // When, after limiting to maxLines, we still have too much to return,
                // do add an ellipsis prefix...
                if (past.length > maxSize) past = "..." + past.substr(-maxSize);
                return past;
            },
            /**
     * return (part of the) upcoming input, i.e. for error messages.
     * 
     * Limit the returned string length to `maxSize` (default: 20).
     * 
     * Limit the returned string to the `maxLines` number of lines of input (default: 1).
     * 
     * Negative limit values equal *unlimited*.
     *
     * > ### NOTE ###
     * >
     * > *"upcoming input"* is defined as the whole of the both
     * > the *currently lexed* input, together with any remaining input
     * > following that. *"currently lexed"* input is the input 
     * > already recognized by the lexer but not yet returned with
     * > the lexer token. This happens when you are invoking this API
     * > from inside any lexer rule action code block. 
     * >
     * 
     * @public
     * @this {RegExpLexer}
     */ upcomingInput: function lexer_upcomingInput(maxSize, maxLines) {
                var next = this.match;
                if (maxSize < 0) maxSize = next.length + this._input.length;
                else if (!maxSize) maxSize = 20;
                if (maxLines < 0) maxLines = maxSize; // can't ever have more input lines than this! 
                else if (!maxLines) maxLines = 1;
                // `substring` anticipation: treat \r\n as a single character and take a little
                // more than necessary so that we can still properly check against maxSize
                // after we've transformed and limited the newLines in here:
                if (next.length < maxSize * 2 + 2) next += this._input.substring(0, maxSize * 2 + 2); // substring is faster on Chrome/V8 
                // now that we have a significantly reduced string to process, transform the newlines
                // and chop them, then limit them:
                var a = next.replace(/\r\n|\r/g, "\n").split("\n");
                a = a.slice(0, maxLines);
                next = a.join("\n");
                // When, after limiting to maxLines, we still have too much to return,
                // do add an ellipsis postfix...
                if (next.length > maxSize) next = next.substring(0, maxSize) + "...";
                return next;
            },
            /**
     * return a string which displays the character position where the
     * lexing error occurred, i.e. for error messages
     * 
     * @public
     * @this {RegExpLexer}
     */ showPosition: function lexer_showPosition(maxPrefix, maxPostfix) {
                var pre = this.pastInput(maxPrefix).replace(/\s/g, " ");
                var c = new Array(pre.length + 1).join("-");
                return pre + this.upcomingInput(maxPostfix).replace(/\s/g, " ") + "\n" + c + "^";
            },
            /**
     * return an YYLLOC info object derived off the given context (actual, preceding, following, current).
     * Use this method when the given `actual` location is not guaranteed to exist (i.e. when
     * it MAY be NULL) and you MUST have a valid location info object anyway:
     * then we take the given context of the `preceding` and `following` locations, IFF those are available,
     * and reconstruct the `actual` location info from those.
     * If this fails, the heuristic is to take the `current` location, IFF available.
     * If this fails as well, we assume the sought location is at/around the current lexer position
     * and then produce that one as a response. DO NOTE that these heuristic/derived location info
     * values MAY be inaccurate!
     *
     * NOTE: `deriveLocationInfo()` ALWAYS produces a location info object *copy* of `actual`, not just
     * a *reference* hence all input location objects can be assumed to be 'constant' (function has no side-effects).
     * 
     * @public
     * @this {RegExpLexer}
     */ deriveLocationInfo: function lexer_deriveYYLLOC(actual, preceding, following, current) {
                var loc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0,
                    range: [
                        0,
                        0
                    ]
                };
                if (actual) {
                    loc.first_line = actual.first_line | 0;
                    loc.last_line = actual.last_line | 0;
                    loc.first_column = actual.first_column | 0;
                    loc.last_column = actual.last_column | 0;
                    if (actual.range) {
                        loc.range[0] = actual.range[0] | 0;
                        loc.range[1] = actual.range[1] | 0;
                    }
                }
                if (loc.first_line <= 0 || loc.last_line < loc.first_line) {
                    // plan B: heuristic using preceding and following:
                    if (loc.first_line <= 0 && preceding) {
                        loc.first_line = preceding.last_line | 0;
                        loc.first_column = preceding.last_column | 0;
                        if (preceding.range) loc.range[0] = actual.range[1] | 0;
                    }
                    if ((loc.last_line <= 0 || loc.last_line < loc.first_line) && following) {
                        loc.last_line = following.first_line | 0;
                        loc.last_column = following.first_column | 0;
                        if (following.range) loc.range[1] = actual.range[0] | 0;
                    }
                    // plan C?: see if the 'current' location is useful/sane too:
                    if (loc.first_line <= 0 && current && (loc.last_line <= 0 || current.last_line <= loc.last_line)) {
                        loc.first_line = current.first_line | 0;
                        loc.first_column = current.first_column | 0;
                        if (current.range) loc.range[0] = current.range[0] | 0;
                    }
                    if (loc.last_line <= 0 && current && (loc.first_line <= 0 || current.first_line >= loc.first_line)) {
                        loc.last_line = current.last_line | 0;
                        loc.last_column = current.last_column | 0;
                        if (current.range) loc.range[1] = current.range[1] | 0;
                    }
                }
                // sanitize: fix last_line BEFORE we fix first_line as we use the 'raw' value of the latter
                // or plan D heuristics to produce a 'sensible' last_line value:
                if (loc.last_line <= 0) {
                    if (loc.first_line <= 0) {
                        loc.first_line = this.yylloc.first_line;
                        loc.last_line = this.yylloc.last_line;
                        loc.first_column = this.yylloc.first_column;
                        loc.last_column = this.yylloc.last_column;
                        loc.range[0] = this.yylloc.range[0];
                        loc.range[1] = this.yylloc.range[1];
                    } else {
                        loc.last_line = this.yylloc.last_line;
                        loc.last_column = this.yylloc.last_column;
                        loc.range[1] = this.yylloc.range[1];
                    }
                }
                if (loc.first_line <= 0) {
                    loc.first_line = loc.last_line;
                    loc.first_column = 0; // loc.last_column; 
                    loc.range[1] = loc.range[0];
                }
                if (loc.first_column < 0) loc.first_column = 0;
                if (loc.last_column < 0) loc.last_column = loc.first_column > 0 ? loc.first_column : 80;
                return loc;
            },
            /**
     * return a string which displays the lines & columns of input which are referenced 
     * by the given location info range, plus a few lines of context.
     * 
     * This function pretty-prints the indicated section of the input, with line numbers 
     * and everything!
     * 
     * This function is very useful to provide highly readable error reports, while
     * the location range may be specified in various flexible ways:
     * 
     * - `loc` is the location info object which references the area which should be
     *   displayed and 'marked up': these lines & columns of text are marked up by `^`
     *   characters below each character in the entire input range.
     * 
     * - `context_loc` is the *optional* location info object which instructs this
     *   pretty-printer how much *leading* context should be displayed alongside
     *   the area referenced by `loc`. This can help provide context for the displayed
     *   error, etc.
     * 
     *   When this location info is not provided, a default context of 3 lines is
     *   used.
     * 
     * - `context_loc2` is another *optional* location info object, which serves
     *   a similar purpose to `context_loc`: it specifies the amount of *trailing*
     *   context lines to display in the pretty-print output.
     * 
     *   When this location info is not provided, a default context of 1 line only is
     *   used.
     * 
     * Special Notes:
     * 
     * - when the `loc`-indicated range is very large (about 5 lines or more), then
     *   only the first and last few lines of this block are printed while a
     *   `...continued...` message will be printed between them.
     * 
     *   This serves the purpose of not printing a huge amount of text when the `loc`
     *   range happens to be huge: this way a manageable & readable output results
     *   for arbitrary large ranges.
     * 
     * - this function can display lines of input which whave not yet been lexed.
     *   `prettyPrintRange()` can access the entire input!
     * 
     * @public
     * @this {RegExpLexer}
     */ prettyPrintRange: function lexer_prettyPrintRange(loc, context_loc, context_loc2) {
                loc = this.deriveLocationInfo(loc, context_loc, context_loc2);
                const CONTEXT = 3;
                const CONTEXT_TAIL = 1;
                const MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT = 2;
                var input = this.matched + this._input;
                var lines = input.split("\n");
                var l0 = Math.max(1, context_loc ? context_loc.first_line : loc.first_line - CONTEXT);
                var l1 = Math.max(1, context_loc2 ? context_loc2.last_line : loc.last_line + CONTEXT_TAIL);
                var lineno_display_width = 1 + Math.log10(l1 | 1) | 0;
                var ws_prefix = new Array(lineno_display_width).join(" ");
                var nonempty_line_indexes = [];
                var rv = lines.slice(l0 - 1, l1 + 1).map(function injectLineNumber(line, index) {
                    var lno = index + l0;
                    var lno_pfx = (ws_prefix + lno).substr(-lineno_display_width);
                    var rv = lno_pfx + ": " + line;
                    var errpfx = new Array(lineno_display_width + 1).join("^");
                    var offset = 3;
                    var len = 0;
                    if (lno === loc.first_line) {
                        offset += loc.first_column;
                        len = Math.max(2, (lno === loc.last_line ? loc.last_column : line.length) - loc.first_column + 1);
                    } else if (lno === loc.last_line) len = Math.max(2, loc.last_column + 1);
                    else if (lno > loc.first_line && lno < loc.last_line) len = Math.max(2, line.length + 1);
                    if (len) {
                        var lead = new Array(offset).join(".");
                        var mark = new Array(len).join("^");
                        rv += "\n" + errpfx + lead + mark;
                        if (line.trim().length > 0) nonempty_line_indexes.push(index);
                    }
                    rv = rv.replace(/\t/g, " ");
                    return rv;
                });
                // now make sure we don't print an overly large amount of error area: limit it 
                // to the top and bottom line count:
                if (nonempty_line_indexes.length > 2 * MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT) {
                    var clip_start = nonempty_line_indexes[MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT - 1] + 1;
                    var clip_end = nonempty_line_indexes[nonempty_line_indexes.length - MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT] - 1;
                    var intermediate_line = new Array(lineno_display_width + 1).join(" ") + "  (...continued...)";
                    intermediate_line += "\n" + new Array(lineno_display_width + 1).join("-") + "  (---------------)";
                    rv.splice(clip_start, clip_end - clip_start + 1, intermediate_line);
                }
                return rv.join("\n");
            },
            /**
     * helper function, used to produce a human readable description as a string, given
     * the input `yylloc` location object.
     * 
     * Set `display_range_too` to TRUE to include the string character index position(s)
     * in the description if the `yylloc.range` is available.
     * 
     * @public
     * @this {RegExpLexer}
     */ describeYYLLOC: function lexer_describe_yylloc(yylloc, display_range_too) {
                var l1 = yylloc.first_line;
                var l2 = yylloc.last_line;
                var c1 = yylloc.first_column;
                var c2 = yylloc.last_column;
                var dl = l2 - l1;
                var dc = c2 - c1;
                var rv;
                if (dl === 0) {
                    rv = "line " + l1 + ", ";
                    if (dc <= 1) rv += "column " + c1;
                    else rv += "columns " + c1 + " .. " + c2;
                } else rv = "lines " + l1 + "(column " + c1 + ") .. " + l2 + "(column " + c2 + ")";
                if (yylloc.range && display_range_too) {
                    var r1 = yylloc.range[0];
                    var r2 = yylloc.range[1] - 1;
                    if (r2 <= r1) rv += " {String Offset: " + r1 + "}";
                    else rv += " {String Offset range: " + r1 + " .. " + r2 + "}";
                }
                return rv;
            },
            /**
     * test the lexed token: return FALSE when not a match, otherwise return token.
     * 
     * `match` is supposed to be an array coming out of a regex match, i.e. `match[0]`
     * contains the actually matched text string.
     * 
     * Also move the input cursor forward and update the match collectors:
     * 
     * - `yytext`
     * - `yyleng`
     * - `match`
     * - `matches`
     * - `yylloc`
     * - `offset`
     * 
     * @public
     * @this {RegExpLexer}
     */ test_match: function lexer_test_match(match, indexed_rule) {
                var token, lines, backup, match_str, match_str_len;
                if (this.options.backtrack_lexer) // save context
                backup = {
                    yylineno: this.yylineno,
                    yylloc: {
                        first_line: this.yylloc.first_line,
                        last_line: this.yylloc.last_line,
                        first_column: this.yylloc.first_column,
                        last_column: this.yylloc.last_column,
                        range: this.yylloc.range.slice(0)
                    },
                    yytext: this.yytext,
                    match: this.match,
                    matches: this.matches,
                    matched: this.matched,
                    yyleng: this.yyleng,
                    offset: this.offset,
                    _more: this._more,
                    _input: this._input,
                    //_signaled_error_token: this._signaled_error_token,
                    yy: this.yy,
                    conditionStack: this.conditionStack.slice(0),
                    done: this.done
                };
                match_str = match[0];
                match_str_len = match_str.length;
                // if (match_str.indexOf('\n') !== -1 || match_str.indexOf('\r') !== -1) {
                lines = match_str.split(/(?:\r\n?|\n)/g);
                if (lines.length > 1) {
                    this.yylineno += lines.length - 1;
                    this.yylloc.last_line = this.yylineno + 1;
                    this.yylloc.last_column = lines[lines.length - 1].length;
                } else this.yylloc.last_column += match_str_len;
                // }
                this.yytext += match_str;
                this.match += match_str;
                this.matched += match_str;
                this.matches = match;
                this.yyleng = this.yytext.length;
                this.yylloc.range[1] += match_str_len;
                // previous lex rules MAY have invoked the `more()` API rather than producing a token:
                // those rules will already have moved this `offset` forward matching their match lengths,
                // hence we must only add our own match length now:
                this.offset += match_str_len;
                this._more = false;
                this._backtrack = false;
                this._input = this._input.slice(match_str_len);
                // calling this method:
                //
                //   function lexer__performAction(yy, yyrulenumber, YY_START) {...}
                token = this.performAction.call(this, this.yy, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
                // otherwise, when the action codes are all simple return token statements:
                //token = this.simpleCaseActionClusters[indexed_rule];
                if (this.done && this._input) this.done = false;
                if (token) return token;
                else if (this._backtrack) {
                    // recover context
                    for(var k in backup)this[k] = backup[k];
                    this.__currentRuleSet__ = null;
                    return false; // rule action called reject() implying the next rule should be tested instead. 
                } else if (this._signaled_error_token) {
                    // produce one 'error' token as `.parseError()` in `reject()`
                    // did not guarantee a failure signal by throwing an exception!
                    token = this._signaled_error_token;
                    this._signaled_error_token = false;
                    return token;
                }
                return false;
            },
            /**
     * return next match in input
     * 
     * @public
     * @this {RegExpLexer}
     */ next: function lexer_next() {
                if (this.done) {
                    this.clear();
                    return this.EOF;
                }
                if (!this._input) this.done = true;
                var token, match, tempMatch, index;
                if (!this._more) this.clear();
                var spec = this.__currentRuleSet__;
                if (!spec) {
                    // Update the ruleset cache as we apparently encountered a state change or just started lexing.
                    // The cache is set up for fast lookup -- we assume a lexer will switch states much less often than it will
                    // invoke the `lex()` token-producing API and related APIs, hence caching the set for direct access helps
                    // speed up those activities a tiny bit.
                    spec = this.__currentRuleSet__ = this._currentRules();
                    // Check whether a *sane* condition has been pushed before: this makes the lexer robust against
                    // user-programmer bugs such as https://github.com/zaach/jison-lex/issues/19
                    if (!spec || !spec.rules) {
                        var lineno_msg = "";
                        if (this.options.trackPosition) lineno_msg = " on line " + (this.yylineno + 1);
                        var p = this.constructLexErrorInfo("Internal lexer engine error" + lineno_msg + ': The lex grammar programmer pushed a non-existing condition name "' + this.topState() + '"; this is a fatal error and should be reported to the application programmer team!', false);
                        // produce one 'error' token until this situation has been resolved, most probably by parse termination!
                        return this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
                    }
                }
                var rule_ids = spec.rules;
                var regexes = spec.__rule_regexes;
                var len = spec.__rule_count;
                // Note: the arrays are 1-based, while `len` itself is a valid index,
                // hence the non-standard less-or-equal check in the next loop condition!
                for(var i = 1; i <= len; i++){
                    tempMatch = this._input.match(regexes[i]);
                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                        match = tempMatch;
                        index = i;
                        if (this.options.backtrack_lexer) {
                            token = this.test_match(tempMatch, rule_ids[i]);
                            if (token !== false) return token;
                            else if (this._backtrack) {
                                match = undefined;
                                continue; // rule action called reject() implying a rule MISmatch. 
                            } else // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                            return false;
                        } else if (!this.options.flex) break;
                    }
                }
                if (match) {
                    token = this.test_match(match, rule_ids[index]);
                    if (token !== false) return token;
                    // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                    return false;
                }
                if (!this._input) {
                    this.done = true;
                    this.clear();
                    return this.EOF;
                } else {
                    var lineno_msg = "";
                    if (this.options.trackPosition) lineno_msg = " on line " + (this.yylineno + 1);
                    var p = this.constructLexErrorInfo("Lexical error" + lineno_msg + ": Unrecognized text.", this.options.lexerErrorsAreRecoverable);
                    var pendingInput = this._input;
                    var activeCondition = this.topState();
                    var conditionStackDepth = this.conditionStack.length;
                    token = this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
                    if (token === this.ERROR) // we can try to recover from a lexer error that `parseError()` did not 'recover' for us
                    // by moving forward at least one character at a time IFF the (user-specified?) `parseError()`
                    // has not consumed/modified any pending input or changed state in the error handler:
                    {
                        if (!this.matches && // and make sure the input has been modified/consumed ...
                        pendingInput === this._input && // ...or the lexer state has been modified significantly enough
                        // to merit a non-consuming error handling action right now.
                        activeCondition === this.topState() && conditionStackDepth === this.conditionStack.length) this.input();
                    }
                    return token;
                }
            },
            /**
     * return next match that has a token
     * 
     * @public
     * @this {RegExpLexer}
     */ lex: function lexer_lex() {
                var r;
                // allow the PRE/POST handlers set/modify the return token for maximum flexibility of the generated lexer:
                if (typeof this.pre_lex === "function") r = this.pre_lex.call(this, 0);
                if (typeof this.options.pre_lex === "function") // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.options.pre_lex.call(this, r) || r;
                if (this.yy && typeof this.yy.pre_lex === "function") // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.yy.pre_lex.call(this, r) || r;
                while(!r)r = this.next();
                if (this.yy && typeof this.yy.post_lex === "function") // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.yy.post_lex.call(this, r) || r;
                if (typeof this.options.post_lex === "function") // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.options.post_lex.call(this, r) || r;
                if (typeof this.post_lex === "function") // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.post_lex.call(this, r) || r;
                return r;
            },
            /**
     * return next match that has a token. Identical to the `lex()` API but does not invoke any of the 
     * `pre_lex()` nor any of the `post_lex()` callbacks.
     * 
     * @public
     * @this {RegExpLexer}
     */ fastLex: function lexer_fastLex() {
                var r;
                while(!r)r = this.next();
                return r;
            },
            /**
     * return info about the lexer state that can help a parser or other lexer API user to use the
     * most efficient means available. This API is provided to aid run-time performance for larger
     * systems which employ this lexer.
     * 
     * @public
     * @this {RegExpLexer}
     */ canIUse: function lexer_canIUse() {
                var rv = {
                    fastLex: !(typeof this.pre_lex === "function" || typeof this.options.pre_lex === "function" || this.yy && typeof this.yy.pre_lex === "function" || this.yy && typeof this.yy.post_lex === "function" || typeof this.options.post_lex === "function" || typeof this.post_lex === "function") && typeof this.fastLex === "function"
                };
                return rv;
            },
            /**
     * backwards compatible alias for `pushState()`;
     * the latter is symmetrical with `popState()` and we advise to use
     * those APIs in any modern lexer code, rather than `begin()`.
     * 
     * @public
     * @this {RegExpLexer}
     */ begin: function lexer_begin(condition) {
                return this.pushState(condition);
            },
            /**
     * activates a new lexer condition state (pushes the new lexer
     * condition state onto the condition stack)
     * 
     * @public
     * @this {RegExpLexer}
     */ pushState: function lexer_pushState(condition) {
                this.conditionStack.push(condition);
                this.__currentRuleSet__ = null;
                return this;
            },
            /**
     * pop the previously active lexer condition state off the condition
     * stack
     * 
     * @public
     * @this {RegExpLexer}
     */ popState: function lexer_popState() {
                var n = this.conditionStack.length - 1;
                if (n > 0) {
                    this.__currentRuleSet__ = null;
                    return this.conditionStack.pop();
                } else return this.conditionStack[0];
            },
            /**
     * return the currently active lexer condition state; when an index
     * argument is provided it produces the N-th previous condition state,
     * if available
     * 
     * @public
     * @this {RegExpLexer}
     */ topState: function lexer_topState(n) {
                n = this.conditionStack.length - 1 - Math.abs(n || 0);
                if (n >= 0) return this.conditionStack[n];
                else return "INITIAL";
            },
            /**
     * (internal) determine the lexer rule set which is active for the
     * currently active lexer condition state
     * 
     * @public
     * @this {RegExpLexer}
     */ _currentRules: function lexer__currentRules() {
                if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) return this.conditions[this.conditionStack[this.conditionStack.length - 1]];
                else return this.conditions["INITIAL"];
            },
            /**
     * return the number of states currently on the stack
     * 
     * @public
     * @this {RegExpLexer}
     */ stateStackSize: function lexer_stateStackSize() {
                return this.conditionStack.length;
            },
            options: {
                trackPosition: true
            },
            JisonLexerError: JisonLexerError,
            performAction: function lexer__performAction(yy, yyrulenumber, YY_START) {
                var yy_ = this;
                var YYSTATE = YY_START;
                switch(yyrulenumber){
                    case 1:
                        break;
                    default:
                        return this.simpleCaseActionClusters[yyrulenumber];
                }
            },
            simpleCaseActionClusters: {
                /*! Conditions:: INITIAL */ /*! Rule::       (--[0-9a-z-A-Z-]*) */ 0: 13,
                /*! Conditions:: INITIAL */ /*! Rule::       \* */ 2: 5,
                /*! Conditions:: INITIAL */ /*! Rule::       \/ */ 3: 6,
                /*! Conditions:: INITIAL */ /*! Rule::       \+ */ 4: 3,
                /*! Conditions:: INITIAL */ /*! Rule::       - */ 5: 4,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)px\b */ 6: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)cm\b */ 7: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)mm\b */ 8: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)in\b */ 9: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)pt\b */ 10: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)pc\b */ 11: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)deg\b */ 12: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)grad\b */ 13: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)rad\b */ 14: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)turn\b */ 15: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)s\b */ 16: 17,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ms\b */ 17: 17,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)Hz\b */ 18: 18,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)kHz\b */ 19: 18,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dpi\b */ 20: 19,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dpcm\b */ 21: 19,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dppx\b */ 22: 19,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)em\b */ 23: 20,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ex\b */ 24: 21,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ch\b */ 25: 22,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)rem\b */ 26: 23,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vw\b */ 27: 25,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vh\b */ 28: 24,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vmin\b */ 29: 26,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vmax\b */ 30: 27,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)% */ 31: 28,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)\b */ 32: 11,
                /*! Conditions:: INITIAL */ /*! Rule::       (calc) */ 33: 9,
                /*! Conditions:: INITIAL */ /*! Rule::       (var) */ 34: 12,
                /*! Conditions:: INITIAL */ /*! Rule::       ([a-z]+) */ 35: 10,
                /*! Conditions:: INITIAL */ /*! Rule::       \( */ 36: 7,
                /*! Conditions:: INITIAL */ /*! Rule::       \) */ 37: 8,
                /*! Conditions:: INITIAL */ /*! Rule::       , */ 38: 14,
                /*! Conditions:: INITIAL */ /*! Rule::       $ */ 39: 1
            },
            rules: [
                /*  0: */ /^(?:(--[\d\-A-Za-z]*))/,
                /*  1: */ /^(?:\s+)/,
                /*  2: */ /^(?:\*)/,
                /*  3: */ /^(?:\/)/,
                /*  4: */ /^(?:\+)/,
                /*  5: */ /^(?:-)/,
                /*  6: */ /^(?:(\d+(\.\d*)?|\.\d+)px\b)/,
                /*  7: */ /^(?:(\d+(\.\d*)?|\.\d+)cm\b)/,
                /*  8: */ /^(?:(\d+(\.\d*)?|\.\d+)mm\b)/,
                /*  9: */ /^(?:(\d+(\.\d*)?|\.\d+)in\b)/,
                /* 10: */ /^(?:(\d+(\.\d*)?|\.\d+)pt\b)/,
                /* 11: */ /^(?:(\d+(\.\d*)?|\.\d+)pc\b)/,
                /* 12: */ /^(?:(\d+(\.\d*)?|\.\d+)deg\b)/,
                /* 13: */ /^(?:(\d+(\.\d*)?|\.\d+)grad\b)/,
                /* 14: */ /^(?:(\d+(\.\d*)?|\.\d+)rad\b)/,
                /* 15: */ /^(?:(\d+(\.\d*)?|\.\d+)turn\b)/,
                /* 16: */ /^(?:(\d+(\.\d*)?|\.\d+)s\b)/,
                /* 17: */ /^(?:(\d+(\.\d*)?|\.\d+)ms\b)/,
                /* 18: */ /^(?:(\d+(\.\d*)?|\.\d+)Hz\b)/,
                /* 19: */ /^(?:(\d+(\.\d*)?|\.\d+)kHz\b)/,
                /* 20: */ /^(?:(\d+(\.\d*)?|\.\d+)dpi\b)/,
                /* 21: */ /^(?:(\d+(\.\d*)?|\.\d+)dpcm\b)/,
                /* 22: */ /^(?:(\d+(\.\d*)?|\.\d+)dppx\b)/,
                /* 23: */ /^(?:(\d+(\.\d*)?|\.\d+)em\b)/,
                /* 24: */ /^(?:(\d+(\.\d*)?|\.\d+)ex\b)/,
                /* 25: */ /^(?:(\d+(\.\d*)?|\.\d+)ch\b)/,
                /* 26: */ /^(?:(\d+(\.\d*)?|\.\d+)rem\b)/,
                /* 27: */ /^(?:(\d+(\.\d*)?|\.\d+)vw\b)/,
                /* 28: */ /^(?:(\d+(\.\d*)?|\.\d+)vh\b)/,
                /* 29: */ /^(?:(\d+(\.\d*)?|\.\d+)vmin\b)/,
                /* 30: */ /^(?:(\d+(\.\d*)?|\.\d+)vmax\b)/,
                /* 31: */ /^(?:(\d+(\.\d*)?|\.\d+)%)/,
                /* 32: */ /^(?:(\d+(\.\d*)?|\.\d+)\b)/,
                /* 33: */ /^(?:(calc))/,
                /* 34: */ /^(?:(var))/,
                /* 35: */ /^(?:([a-z]+))/,
                /* 36: */ /^(?:\()/,
                /* 37: */ /^(?:\))/,
                /* 38: */ /^(?:,)/,
                /* 39: */ /^(?:$)/
            ],
            conditions: {
                "INITIAL": {
                    rules: [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        17,
                        18,
                        19,
                        20,
                        21,
                        22,
                        23,
                        24,
                        25,
                        26,
                        27,
                        28,
                        29,
                        30,
                        31,
                        32,
                        33,
                        34,
                        35,
                        36,
                        37,
                        38,
                        39
                    ],
                    inclusive: true
                }
            }
        };
        return lexer;
    }();
    parser.lexer = lexer;
    function Parser() {
        this.yy = {};
    }
    Parser.prototype = parser;
    parser.Parser = Parser;
    return new Parser();
}();
$de2299f7e12635b4$export$8f49e4af10703ce3 = $de2299f7e12635b4$var$parser;
$de2299f7e12635b4$export$7acfa6ed01010e37 = $de2299f7e12635b4$var$parser.Parser;
$de2299f7e12635b4$export$98e6a39c04603d36 = function() {
    return $de2299f7e12635b4$var$parser.parse.apply($de2299f7e12635b4$var$parser, arguments);
};


var $934b2fce9c35f7f0$exports = {};
"use strict";
Object.defineProperty($934b2fce9c35f7f0$exports, "__esModule", {
    value: true
});
$934b2fce9c35f7f0$exports.flip = $934b2fce9c35f7f0$var$flip;
var $ecd5aa1f8593ebfe$exports = {};
"use strict";
Object.defineProperty($ecd5aa1f8593ebfe$exports, "__esModule", {
    value: true
});
var $c226efed75f2aa3b$exports = {};
var $c226efed75f2aa3b$var$conversions = {
    // length
    "px": {
        "px": 1,
        "cm": 96.0 / 2.54,
        "mm": 96.0 / 25.4,
        "in": 96,
        "pt": 96.0 / 72.0,
        "pc": 16
    },
    "cm": {
        "px": 2.54 / 96.0,
        "cm": 1,
        "mm": 0.1,
        "in": 2.54,
        "pt": 2.54 / 72.0,
        "pc": 2.54 / 6.0
    },
    "mm": {
        "px": 25.4 / 96.0,
        "cm": 10,
        "mm": 1,
        "in": 25.4,
        "pt": 25.4 / 72.0,
        "pc": 25.4 / 6.0
    },
    "in": {
        "px": 1.0 / 96.0,
        "cm": 1.0 / 2.54,
        "mm": 1.0 / 25.4,
        "in": 1,
        "pt": 1.0 / 72.0,
        "pc": 1.0 / 6.0
    },
    "pt": {
        "px": 0.75,
        "cm": 72.0 / 2.54,
        "mm": 72.0 / 25.4,
        "in": 72,
        "pt": 1,
        "pc": 12
    },
    "pc": {
        "px": 0.0625,
        "cm": 6.0 / 2.54,
        "mm": 6.0 / 25.4,
        "in": 6,
        "pt": 6.0 / 72.0,
        "pc": 1
    },
    // angle
    "deg": {
        "deg": 1,
        "grad": 0.9,
        "rad": 180 / Math.PI,
        "turn": 360
    },
    "grad": {
        "deg": 400 / 360,
        "grad": 1,
        "rad": 200 / Math.PI,
        "turn": 400
    },
    "rad": {
        "deg": Math.PI / 180,
        "grad": Math.PI / 200,
        "rad": 1,
        "turn": Math.PI * 2
    },
    "turn": {
        "deg": 1 / 360,
        "grad": 1 / 400,
        "rad": 0.5 / Math.PI,
        "turn": 1
    },
    // time
    "s": {
        "s": 1,
        "ms": 0.001
    },
    "ms": {
        "s": 1000,
        "ms": 1
    },
    // frequency
    "Hz": {
        "Hz": 1,
        "kHz": 1000
    },
    "kHz": {
        "Hz": 0.001,
        "kHz": 1
    },
    // resolution
    "dpi": {
        "dpi": 1,
        "dpcm": 1.0 / 2.54,
        "dppx": 1 / 96
    },
    "dpcm": {
        "dpi": 2.54,
        "dpcm": 1,
        "dppx": 2.54 / 96.0
    },
    "dppx": {
        "dpi": 96,
        "dpcm": 96.0 / 2.54,
        "dppx": 1
    }
};
$c226efed75f2aa3b$exports = function(value, sourceUnit, targetUnit, precision) {
    if (!$c226efed75f2aa3b$var$conversions.hasOwnProperty(targetUnit)) throw new Error("Cannot convert to " + targetUnit);
    if (!$c226efed75f2aa3b$var$conversions[targetUnit].hasOwnProperty(sourceUnit)) throw new Error("Cannot convert from " + sourceUnit + " to " + targetUnit);
    var converted = $c226efed75f2aa3b$var$conversions[targetUnit][sourceUnit] * value;
    if (precision !== false) {
        precision = Math.pow(10, parseInt(precision) || 5);
        return Math.round(converted * precision) / precision;
    }
    return converted;
};


var $ecd5aa1f8593ebfe$var$_cssUnitConverter2 = $ecd5aa1f8593ebfe$var$_interopRequireDefault($c226efed75f2aa3b$exports);
function $ecd5aa1f8593ebfe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ecd5aa1f8593ebfe$var$convertNodes(left, right, precision) {
    switch(left.type){
        case "LengthValue":
        case "AngleValue":
        case "TimeValue":
        case "FrequencyValue":
        case "ResolutionValue":
            return $ecd5aa1f8593ebfe$var$convertAbsoluteLength(left, right, precision);
        default:
            return {
                left: left,
                right: right
            };
    }
}
function $ecd5aa1f8593ebfe$var$convertAbsoluteLength(left, right, precision) {
    if (right.type === left.type) right = {
        type: left.type,
        value: (0, $ecd5aa1f8593ebfe$var$_cssUnitConverter2.default)(right.value, right.unit, left.unit, precision),
        unit: left.unit
    };
    return {
        left: left,
        right: right
    };
}
$ecd5aa1f8593ebfe$exports.default = $ecd5aa1f8593ebfe$var$convertNodes;
$ecd5aa1f8593ebfe$exports = $ecd5aa1f8593ebfe$exports["default"];


var $934b2fce9c35f7f0$var$_convert2 = $934b2fce9c35f7f0$var$_interopRequireDefault($ecd5aa1f8593ebfe$exports);
function $934b2fce9c35f7f0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $934b2fce9c35f7f0$var$reduce(node, precision) {
    if (node.type === "MathExpression") return $934b2fce9c35f7f0$var$reduceMathExpression(node, precision);
    if (node.type === "Calc") return $934b2fce9c35f7f0$var$reduce(node.value, precision);
    return node;
}
function $934b2fce9c35f7f0$var$isEqual(left, right) {
    return left.type === right.type && left.value === right.value;
}
function $934b2fce9c35f7f0$var$isValueType(type) {
    switch(type){
        case "LengthValue":
        case "AngleValue":
        case "TimeValue":
        case "FrequencyValue":
        case "ResolutionValue":
        case "EmValue":
        case "ExValue":
        case "ChValue":
        case "RemValue":
        case "VhValue":
        case "VwValue":
        case "VminValue":
        case "VmaxValue":
        case "PercentageValue":
        case "Value":
            return true;
    }
    return false;
}
function $934b2fce9c35f7f0$var$convertMathExpression(node, precision) {
    var nodes = (0, $934b2fce9c35f7f0$var$_convert2.default)(node.left, node.right, precision);
    var left = $934b2fce9c35f7f0$var$reduce(nodes.left, precision);
    var right = $934b2fce9c35f7f0$var$reduce(nodes.right, precision);
    if (left.type === "MathExpression" && right.type === "MathExpression") {
        if (left.operator === "/" && right.operator === "*" || left.operator === "-" && right.operator === "+" || left.operator === "*" && right.operator === "/" || left.operator === "+" && right.operator === "-") {
            if ($934b2fce9c35f7f0$var$isEqual(left.right, right.right)) nodes = (0, $934b2fce9c35f7f0$var$_convert2.default)(left.left, right.left, precision);
            else if ($934b2fce9c35f7f0$var$isEqual(left.right, right.left)) nodes = (0, $934b2fce9c35f7f0$var$_convert2.default)(left.left, right.right, precision);
            left = $934b2fce9c35f7f0$var$reduce(nodes.left, precision);
            right = $934b2fce9c35f7f0$var$reduce(nodes.right, precision);
        }
    }
    node.left = left;
    node.right = right;
    return node;
}
function $934b2fce9c35f7f0$var$flip(operator) {
    return operator === "+" ? "-" : "+";
}
function $934b2fce9c35f7f0$var$flipValue(node) {
    if ($934b2fce9c35f7f0$var$isValueType(node.type)) node.value = -node.value;
    else if (node.type == "MathExpression") {
        node.left = $934b2fce9c35f7f0$var$flipValue(node.left);
        node.right = $934b2fce9c35f7f0$var$flipValue(node.right);
    }
    return node;
}
function $934b2fce9c35f7f0$var$reduceAddSubExpression(node, precision) {
    var _node = node, left = _node.left, right = _node.right, op = _node.operator;
    if (left.type === "CssVariable" || right.type === "CssVariable") return node;
    // something + 0 => something
    // something - 0 => something
    if (right.value === 0) return left;
    // 0 + something => something
    if (left.value === 0 && op === "+") return right;
    // 0 - something => -something
    if (left.value === 0 && op === "-") return $934b2fce9c35f7f0$var$flipValue(right);
    // value + value
    // value - value
    if (left.type === right.type && $934b2fce9c35f7f0$var$isValueType(left.type)) {
        node = Object.assign({}, left);
        if (op === "+") node.value = left.value + right.value;
        else node.value = left.value - right.value;
    }
    // value <op> (expr)
    if ($934b2fce9c35f7f0$var$isValueType(left.type) && (right.operator === "+" || right.operator === "-") && right.type === "MathExpression") {
        // value + (value + something) => (value + value) + something
        // value + (value - something) => (value + value) - something
        // value - (value + something) => (value - value) - something
        // value - (value - something) => (value - value) + something
        if (left.type === right.left.type) {
            node = Object.assign({}, node);
            node.left = $934b2fce9c35f7f0$var$reduce({
                type: "MathExpression",
                operator: op,
                left: left,
                right: right.left
            }, precision);
            node.right = right.right;
            node.operator = op === "-" ? $934b2fce9c35f7f0$var$flip(right.operator) : right.operator;
            return $934b2fce9c35f7f0$var$reduce(node, precision);
        } else if (left.type === right.right.type) {
            node = Object.assign({}, node);
            node.left = $934b2fce9c35f7f0$var$reduce({
                type: "MathExpression",
                operator: op === "-" ? $934b2fce9c35f7f0$var$flip(right.operator) : right.operator,
                left: left,
                right: right.right
            }, precision);
            node.right = right.left;
            return $934b2fce9c35f7f0$var$reduce(node, precision);
        }
    }
    // (expr) <op> value
    if (left.type === "MathExpression" && (left.operator === "+" || left.operator === "-") && $934b2fce9c35f7f0$var$isValueType(right.type)) {
        // (value + something) + value => (value + value) + something
        // (value - something) + value => (value + value) - something
        // (value + something) - value => (value - value) + something
        // (value - something) - value => (value - value) - something
        if (right.type === left.left.type) {
            node = Object.assign({}, left);
            node.left = $934b2fce9c35f7f0$var$reduce({
                type: "MathExpression",
                operator: op,
                left: left.left,
                right: right
            }, precision);
            return $934b2fce9c35f7f0$var$reduce(node, precision);
        } else if (right.type === left.right.type) {
            node = Object.assign({}, left);
            if (left.operator === "-") {
                node.right = $934b2fce9c35f7f0$var$reduce({
                    type: "MathExpression",
                    operator: op === "-" ? "+" : "-",
                    left: right,
                    right: left.right
                }, precision);
                node.operator = op === "-" ? "-" : "+";
            } else node.right = $934b2fce9c35f7f0$var$reduce({
                type: "MathExpression",
                operator: op,
                left: left.right,
                right: right
            }, precision);
            if (node.right.value < 0) {
                node.right.value *= -1;
                node.operator = node.operator === "-" ? "+" : "-";
            }
            return $934b2fce9c35f7f0$var$reduce(node, precision);
        }
    }
    return node;
}
function $934b2fce9c35f7f0$var$reduceDivisionExpression(node, precision) {
    if (!$934b2fce9c35f7f0$var$isValueType(node.right.type)) return node;
    if (node.right.type !== "Value") throw new Error('Cannot divide by "' + node.right.unit + '", number expected');
    if (node.right.value === 0) throw new Error("Cannot divide by zero");
    // (expr) / value
    if (node.left.type === "MathExpression") {
        if ($934b2fce9c35f7f0$var$isValueType(node.left.left.type) && $934b2fce9c35f7f0$var$isValueType(node.left.right.type)) {
            node.left.left.value /= node.right.value;
            node.left.right.value /= node.right.value;
            return $934b2fce9c35f7f0$var$reduce(node.left, precision);
        }
        return node;
    } else if ($934b2fce9c35f7f0$var$isValueType(node.left.type)) {
        node.left.value /= node.right.value;
        return node.left;
    }
    return node;
}
function $934b2fce9c35f7f0$var$reduceMultiplicationExpression(node) {
    // (expr) * value
    if (node.left.type === "MathExpression" && node.right.type === "Value") {
        if ($934b2fce9c35f7f0$var$isValueType(node.left.left.type) && $934b2fce9c35f7f0$var$isValueType(node.left.right.type)) {
            node.left.left.value *= node.right.value;
            node.left.right.value *= node.right.value;
            return node.left;
        }
    } else if ($934b2fce9c35f7f0$var$isValueType(node.left.type) && node.right.type === "Value") {
        node.left.value *= node.right.value;
        return node.left;
    } else if (node.left.type === "Value" && node.right.type === "MathExpression") {
        if ($934b2fce9c35f7f0$var$isValueType(node.right.left.type) && $934b2fce9c35f7f0$var$isValueType(node.right.right.type)) {
            node.right.left.value *= node.left.value;
            node.right.right.value *= node.left.value;
            return node.right;
        }
    } else if (node.left.type === "Value" && $934b2fce9c35f7f0$var$isValueType(node.right.type)) {
        node.right.value *= node.left.value;
        return node.right;
    }
    return node;
}
function $934b2fce9c35f7f0$var$reduceMathExpression(node, precision) {
    node = $934b2fce9c35f7f0$var$convertMathExpression(node, precision);
    switch(node.operator){
        case "+":
        case "-":
            return $934b2fce9c35f7f0$var$reduceAddSubExpression(node, precision);
        case "/":
            return $934b2fce9c35f7f0$var$reduceDivisionExpression(node, precision);
        case "*":
            return $934b2fce9c35f7f0$var$reduceMultiplicationExpression(node);
    }
    return node;
}
$934b2fce9c35f7f0$exports.default = $934b2fce9c35f7f0$var$reduce;


var $8a98d7eaad4a965c$var$_reducer2 = $8a98d7eaad4a965c$var$_interopRequireDefault($934b2fce9c35f7f0$exports);
var $9671ff19f2a90d8b$exports = {};
"use strict";
Object.defineProperty($9671ff19f2a90d8b$exports, "__esModule", {
    value: true
});
$9671ff19f2a90d8b$exports.default = function(calc, node, precision) {
    var str = $9671ff19f2a90d8b$var$stringify(node, precision);
    if (node.type === "MathExpression") // if calc expression couldn't be resolved to a single value, re-wrap it as
    // a calc()
    str = calc + "(" + str + ")";
    return str;
};

var $9671ff19f2a90d8b$var$order = {
    "*": 0,
    "/": 0,
    "+": 1,
    "-": 1
};
function $9671ff19f2a90d8b$var$round(value, prec) {
    if (prec !== false) {
        var precision = Math.pow(10, prec);
        return Math.round(value * precision) / precision;
    }
    return value;
}
function $9671ff19f2a90d8b$var$stringify(node, prec) {
    switch(node.type){
        case "MathExpression":
            var left = node.left, right = node.right, op = node.operator;
            var str = "";
            if (left.type === "MathExpression" && $9671ff19f2a90d8b$var$order[op] < $9671ff19f2a90d8b$var$order[left.operator]) str += "(" + $9671ff19f2a90d8b$var$stringify(left, prec) + ")";
            else str += $9671ff19f2a90d8b$var$stringify(left, prec);
            str += " " + node.operator + " ";
            if (right.type === "MathExpression" && $9671ff19f2a90d8b$var$order[op] < $9671ff19f2a90d8b$var$order[right.operator]) str += "(" + $9671ff19f2a90d8b$var$stringify(right, prec) + ")";
            else if (right.type === "MathExpression" && op === "-" && [
                "+",
                "-"
            ].includes(right.operator)) {
                // fix #52 : a-(b+c) = a-b-c
                right.operator = (0, $934b2fce9c35f7f0$exports.flip)(right.operator);
                str += $9671ff19f2a90d8b$var$stringify(right, prec);
            } else str += $9671ff19f2a90d8b$var$stringify(right, prec);
            return str;
        case "Value":
            return $9671ff19f2a90d8b$var$round(node.value, prec);
        case "CssVariable":
            if (node.fallback) return "var(" + node.value + ", " + $9671ff19f2a90d8b$var$stringify(node.fallback, prec, true) + ")";
            return "var(" + node.value + ")";
        case "Calc":
            if (node.prefix) return "-" + node.prefix + "-calc(" + $9671ff19f2a90d8b$var$stringify(node.value, prec) + ")";
            return "calc(" + $9671ff19f2a90d8b$var$stringify(node.value, prec) + ")";
        default:
            return $9671ff19f2a90d8b$var$round(node.value, prec) + node.unit;
    }
}
$9671ff19f2a90d8b$exports = $9671ff19f2a90d8b$exports["default"];


var $8a98d7eaad4a965c$var$_stringifier2 = $8a98d7eaad4a965c$var$_interopRequireDefault($9671ff19f2a90d8b$exports);
function $8a98d7eaad4a965c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// eslint-disable-line
var $8a98d7eaad4a965c$var$MATCH_CALC = /((?:\-[a-z]+\-)?calc)/;
$8a98d7eaad4a965c$exports.default = function(value) {
    var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
    return (0, $8a98d7eaad4a965c$var$_postcssValueParser2.default)(value).walk(function(node) {
        // skip anything which isn't a calc() function
        if (node.type !== "function" || !$8a98d7eaad4a965c$var$MATCH_CALC.test(node.value)) return;
        // stringify calc expression and produce an AST
        var contents = $8a98d7eaad4a965c$var$_postcssValueParser2.default.stringify(node.nodes);
        // skip constant() and env()
        if (contents.indexOf("constant") >= 0 || contents.indexOf("env") >= 0) return;
        var ast = $de2299f7e12635b4$export$8f49e4af10703ce3.parse(contents);
        // reduce AST to its simplest form, that is, either to a single value
        // or a simplified calc expression
        var reducedAst = (0, $8a98d7eaad4a965c$var$_reducer2.default)(ast, precision);
        // stringify AST and write it back
        node.type = "word";
        node.value = (0, $8a98d7eaad4a965c$var$_stringifier2.default)(node.value, reducedAst, precision);
    }, true).toString();
};
$8a98d7eaad4a965c$exports = $8a98d7eaad4a965c$exports["default"];



var $5UrGx = parcelRequire("5UrGx");

var $02caca8e343c9d9a$var$parseIsSsrByDefault = function parseIsSsrByDefault() {
    return !(typeof window !== "undefined" && window.document && window.document.createElement && window.setTimeout);
};
var $02caca8e343c9d9a$export$98f03c5d19621d70 = {
    isSsr: $02caca8e343c9d9a$var$parseIsSsrByDefault(),
    get: function get(key) {
        return $02caca8e343c9d9a$export$98f03c5d19621d70[key];
    },
    set: function set(key, value) {
        if (typeof key === "string") $02caca8e343c9d9a$export$98f03c5d19621d70[key] = value;
        else {
            var keys = Object.keys(key);
            if (keys && keys.length) keys.forEach(function(k) {
                $02caca8e343c9d9a$export$98f03c5d19621d70[k] = key[k];
            });
        }
    }
};




function $f9d7f659152e7a9e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f9d7f659152e7a9e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $f9d7f659152e7a9e$var$ownKeys(Object(source), true).forEach(function(key) {
            $f9d7f659152e7a9e$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $f9d7f659152e7a9e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f9d7f659152e7a9e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f9d7f659152e7a9e$var$_toConsumableArray(arr) {
    return $f9d7f659152e7a9e$var$_arrayWithoutHoles(arr) || $f9d7f659152e7a9e$var$_iterableToArray(arr) || $f9d7f659152e7a9e$var$_unsupportedIterableToArray(arr) || $f9d7f659152e7a9e$var$_nonIterableSpread();
}
function $f9d7f659152e7a9e$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f9d7f659152e7a9e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f9d7f659152e7a9e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f9d7f659152e7a9e$var$_arrayLikeToArray(o, minLen);
}
function $f9d7f659152e7a9e$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $f9d7f659152e7a9e$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $f9d7f659152e7a9e$var$_arrayLikeToArray(arr);
}
function $f9d7f659152e7a9e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $f9d7f659152e7a9e$var$stringCache = {
    widthCache: {},
    cacheCount: 0
};
var $f9d7f659152e7a9e$var$MAX_CACHE_NUM = 2000;
var $f9d7f659152e7a9e$var$SPAN_STYLE = {
    position: "absolute",
    top: "-20000px",
    left: 0,
    padding: 0,
    margin: 0,
    border: "none",
    whiteSpace: "pre"
};
var $f9d7f659152e7a9e$var$STYLE_LIST = [
    "minWidth",
    "maxWidth",
    "width",
    "minHeight",
    "maxHeight",
    "height",
    "top",
    "left",
    "fontSize",
    "lineHeight",
    "padding",
    "margin",
    "paddingLeft",
    "paddingRight",
    "paddingTop",
    "paddingBottom",
    "marginLeft",
    "marginRight",
    "marginTop",
    "marginBottom"
];
var $f9d7f659152e7a9e$var$MEASUREMENT_SPAN_ID = "recharts_measurement_span";
function $f9d7f659152e7a9e$var$autoCompleteStyle(name, value) {
    if ($f9d7f659152e7a9e$var$STYLE_LIST.indexOf(name) >= 0 && value === +value) return "".concat(value, "px");
    return value;
}
function $f9d7f659152e7a9e$var$camelToMiddleLine(text) {
    var strs = text.split("");
    var formatStrs = strs.reduce(function(result, entry) {
        if (entry === entry.toUpperCase()) return [].concat($f9d7f659152e7a9e$var$_toConsumableArray(result), [
            "-",
            entry.toLowerCase()
        ]);
        return [].concat($f9d7f659152e7a9e$var$_toConsumableArray(result), [
            entry
        ]);
    }, []);
    return formatStrs.join("");
}
var $f9d7f659152e7a9e$export$9a2c38fb88d8e30 = function getStyleString(style) {
    return Object.keys(style).reduce(function(result, s) {
        return "".concat(result).concat($f9d7f659152e7a9e$var$camelToMiddleLine(s), ":").concat($f9d7f659152e7a9e$var$autoCompleteStyle(s, style[s]), ";");
    }, "");
};
var $f9d7f659152e7a9e$export$e5560531f057ad5d = function getStringSize(text) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (text === undefined || text === null || (0, $02caca8e343c9d9a$export$98f03c5d19621d70).isSsr) return {
        width: 0,
        height: 0
    };
    var str = "".concat(text);
    var styleString = $f9d7f659152e7a9e$export$9a2c38fb88d8e30(style);
    var cacheKey = "".concat(str, "-").concat(styleString);
    if ($f9d7f659152e7a9e$var$stringCache.widthCache[cacheKey]) return $f9d7f659152e7a9e$var$stringCache.widthCache[cacheKey];
    try {
        var measurementSpan = document.getElementById($f9d7f659152e7a9e$var$MEASUREMENT_SPAN_ID);
        if (!measurementSpan) {
            measurementSpan = document.createElement("span");
            measurementSpan.setAttribute("id", $f9d7f659152e7a9e$var$MEASUREMENT_SPAN_ID);
            measurementSpan.setAttribute("aria-hidden", "true");
            document.body.appendChild(measurementSpan);
        } // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
        // https://en.wikipedia.org/wiki/Content_Security_Policy
        var measurementSpanStyle = $f9d7f659152e7a9e$var$_objectSpread($f9d7f659152e7a9e$var$_objectSpread({}, $f9d7f659152e7a9e$var$SPAN_STYLE), style);
        Object.keys(measurementSpanStyle).map(function(styleKey) {
            measurementSpan.style[styleKey] = measurementSpanStyle[styleKey];
            return styleKey;
        });
        measurementSpan.textContent = str;
        var rect = measurementSpan.getBoundingClientRect();
        var result = {
            width: rect.width,
            height: rect.height
        };
        $f9d7f659152e7a9e$var$stringCache.widthCache[cacheKey] = result;
        if (++$f9d7f659152e7a9e$var$stringCache.cacheCount > $f9d7f659152e7a9e$var$MAX_CACHE_NUM) {
            $f9d7f659152e7a9e$var$stringCache.cacheCount = 0;
            $f9d7f659152e7a9e$var$stringCache.widthCache = {};
        }
        return result;
    } catch (e) {
        return {
            width: 0,
            height: 0
        };
    }
};
var $f9d7f659152e7a9e$export$622cea445a1c5b7d = function getOffset(el) {
    var html = el.ownerDocument.documentElement;
    var box = {
        top: 0,
        left: 0
    }; // If we don't have gBCR, just use 0,0 rather than error
    // BlackBerry 5, iOS 3 (original iPhone)
    if (typeof el.getBoundingClientRect !== "undefined") box = el.getBoundingClientRect();
    return {
        top: box.top + window.pageYOffset - html.clientTop,
        left: box.left + window.pageXOffset - html.clientLeft
    };
};
var $f9d7f659152e7a9e$export$f209e6c32ad3d02e = function calculateChartCoordinate(event, offset) {
    return {
        chartX: Math.round(event.pageX - offset.left),
        chartY: Math.round(event.pageY - offset.top)
    };
};


function $9b127a27894cc2e0$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $9b127a27894cc2e0$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $9b127a27894cc2e0$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $9b127a27894cc2e0$var$_typeof(obj);
}
function $9b127a27894cc2e0$var$_extends() {
    $9b127a27894cc2e0$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9b127a27894cc2e0$var$_extends.apply(this, arguments);
}
function $9b127a27894cc2e0$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9b127a27894cc2e0$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9b127a27894cc2e0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $9b127a27894cc2e0$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9b127a27894cc2e0$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $9b127a27894cc2e0$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9b127a27894cc2e0$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9b127a27894cc2e0$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $9b127a27894cc2e0$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $9b127a27894cc2e0$var$_setPrototypeOf(subClass, superClass);
}
function $9b127a27894cc2e0$var$_setPrototypeOf(o, p) {
    $9b127a27894cc2e0$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $9b127a27894cc2e0$var$_setPrototypeOf(o, p);
}
function $9b127a27894cc2e0$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $9b127a27894cc2e0$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $9b127a27894cc2e0$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $9b127a27894cc2e0$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $9b127a27894cc2e0$var$_possibleConstructorReturn(this, result);
    };
}
function $9b127a27894cc2e0$var$_possibleConstructorReturn(self, call) {
    if (call && ($9b127a27894cc2e0$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $9b127a27894cc2e0$var$_assertThisInitialized(self);
}
function $9b127a27894cc2e0$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $9b127a27894cc2e0$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $9b127a27894cc2e0$var$_getPrototypeOf(o) {
    $9b127a27894cc2e0$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $9b127a27894cc2e0$var$_getPrototypeOf(o);
}
function $9b127a27894cc2e0$var$_slicedToArray(arr, i) {
    return $9b127a27894cc2e0$var$_arrayWithHoles(arr) || $9b127a27894cc2e0$var$_iterableToArrayLimit(arr, i) || $9b127a27894cc2e0$var$_unsupportedIterableToArray(arr, i) || $9b127a27894cc2e0$var$_nonIterableRest();
}
function $9b127a27894cc2e0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9b127a27894cc2e0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9b127a27894cc2e0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9b127a27894cc2e0$var$_arrayLikeToArray(o, minLen);
}
function $9b127a27894cc2e0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9b127a27894cc2e0$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $9b127a27894cc2e0$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $9b127a27894cc2e0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9b127a27894cc2e0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $9b127a27894cc2e0$var$ownKeys(Object(source), true).forEach(function(key) {
            $9b127a27894cc2e0$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $9b127a27894cc2e0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9b127a27894cc2e0$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $9b127a27894cc2e0$var$BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var $9b127a27894cc2e0$var$calculateWordWidths = function calculateWordWidths(props) {
    try {
        var words = [];
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(props.children)) {
            if (props.breakAll) words = props.children.toString().split("");
            else words = props.children.toString().split($9b127a27894cc2e0$var$BREAKING_SPACES);
        }
        var wordsWithComputedWidth = words.map(function(word) {
            return {
                word: word,
                width: (0, $f9d7f659152e7a9e$export$e5560531f057ad5d)(word, props.style).width
            };
        });
        var spaceWidth = props.breakAll ? 0 : (0, $f9d7f659152e7a9e$export$e5560531f057ad5d)("\xa0", props.style).width;
        return {
            wordsWithComputedWidth: wordsWithComputedWidth,
            spaceWidth: spaceWidth
        };
    } catch (e) {
        return null;
    }
};
var $9b127a27894cc2e0$var$calculateWordsByLines = function calculateWordsByLines(props, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit) {
    var shouldLimitLines = (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(props.maxLines);
    var text = props.children;
    var calculate = function calculate() {
        var words = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return words.reduce(function(result, _ref) {
            var word = _ref.word, width = _ref.width;
            var currentLine = result[result.length - 1];
            if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < lineWidth)) {
                // Word can be added to an existing line
                currentLine.words.push(word);
                currentLine.width += width + spaceWidth;
            } else {
                // Add first word to line or word is too long to scaleToFit on existing line
                var newLine = {
                    words: [
                        word
                    ],
                    width: width
                };
                result.push(newLine);
            }
            return result;
        }, []);
    };
    var originalResult = calculate(initialWordsWithComputedWith);
    var findLongestLine = function findLongestLine(words) {
        return words.reduce(function(a, b) {
            return a.width > b.width ? a : b;
        });
    };
    if (!shouldLimitLines) return originalResult;
    var suffix = "…";
    var checkOverflow = function checkOverflow(index) {
        var tempText = text.slice(0, index);
        var words = $9b127a27894cc2e0$var$calculateWordWidths($9b127a27894cc2e0$var$_objectSpread($9b127a27894cc2e0$var$_objectSpread({}, props), {}, {
            children: tempText + suffix
        })).wordsWithComputedWidth;
        var result = calculate(words);
        var doesOverflow = result.length > props.maxLines || findLongestLine(result).width > lineWidth;
        return [
            doesOverflow,
            result
        ];
    };
    var start = 0;
    var end = text.length - 1;
    var iterations = 0;
    var trimmedResult;
    while(start <= end && iterations <= text.length - 1){
        var middle = Math.floor((start + end) / 2);
        var prev = middle - 1;
        var _checkOverflow = checkOverflow(prev), _checkOverflow2 = $9b127a27894cc2e0$var$_slicedToArray(_checkOverflow, 2), doesPrevOverflow = _checkOverflow2[0], result = _checkOverflow2[1];
        var _checkOverflow3 = checkOverflow(middle), _checkOverflow4 = $9b127a27894cc2e0$var$_slicedToArray(_checkOverflow3, 1), doesMiddleOverflow = _checkOverflow4[0];
        if (!doesPrevOverflow && !doesMiddleOverflow) start = middle + 1;
        if (doesPrevOverflow && doesMiddleOverflow) end = middle - 1;
        if (!doesPrevOverflow && doesMiddleOverflow) {
            trimmedResult = result;
            break;
        }
        iterations++;
    } // Fallback to originalResult (result without trimming) if we cannot find the
    // where to trim.  This should not happen :tm:
    return trimmedResult || originalResult;
};
var $9b127a27894cc2e0$var$getWordsWithoutCalculate = function getWordsWithoutCalculate(children) {
    var words = !(0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(children) ? children.toString().split($9b127a27894cc2e0$var$BREAKING_SPACES) : [];
    return [
        {
            words: words
        }
    ];
};
var $9b127a27894cc2e0$var$getWordsByLines = function getWordsByLines(props, needCalculate) {
    // Only perform calculations if using features that require them (multiline, scaleToFit)
    if ((props.width || props.scaleToFit) && !(0, $02caca8e343c9d9a$export$98f03c5d19621d70).isSsr) {
        var wordsWithComputedWidth, spaceWidth;
        if (needCalculate) {
            var wordWidths = $9b127a27894cc2e0$var$calculateWordWidths(props);
            if (wordWidths) {
                var wcw = wordWidths.wordsWithComputedWidth, sw = wordWidths.spaceWidth;
                wordsWithComputedWidth = wcw;
                spaceWidth = sw;
            } else return $9b127a27894cc2e0$var$getWordsWithoutCalculate(props.children);
            return $9b127a27894cc2e0$var$calculateWordsByLines(props, wordsWithComputedWidth, spaceWidth, props.width, props.scaleToFit);
        }
    }
    return $9b127a27894cc2e0$var$getWordsWithoutCalculate(props.children);
};
var $9b127a27894cc2e0$export$5f1af8db9871e1d6 = /*#__PURE__*/ function(_Component) {
    $9b127a27894cc2e0$var$_inherits(Text, _Component);
    var _super = $9b127a27894cc2e0$var$_createSuper(Text);
    function Text() {
        var _this;
        $9b127a27894cc2e0$var$_classCallCheck(this, Text);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {};
        return _this;
    }
    $9b127a27894cc2e0$var$_createClass(Text, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, dx = _this$props.dx, dy = _this$props.dy, textAnchor = _this$props.textAnchor, verticalAnchor = _this$props.verticalAnchor, scaleToFit = _this$props.scaleToFit, angle = _this$props.angle, lineHeight = _this$props.lineHeight, capHeight = _this$props.capHeight, className = _this$props.className, breakAll = _this$props.breakAll, textProps = $9b127a27894cc2e0$var$_objectWithoutProperties(_this$props, [
                    "dx",
                    "dy",
                    "textAnchor",
                    "verticalAnchor",
                    "scaleToFit",
                    "angle",
                    "lineHeight",
                    "capHeight",
                    "className",
                    "breakAll"
                ]);
                var wordsByLines = this.state.wordsByLines;
                if (!(0, $804fab7e7cc9eb97$export$402a499e1ea44294)(textProps.x) || !(0, $804fab7e7cc9eb97$export$402a499e1ea44294)(textProps.y)) return null;
                var x = textProps.x + ((0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(dx) ? dx : 0);
                var y = textProps.y + ((0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(dy) ? dy : 0);
                var startDy;
                switch(verticalAnchor){
                    case "start":
                        startDy = (0, (/*@__PURE__*/$parcel$interopDefault($8a98d7eaad4a965c$exports)))("calc(".concat(capHeight, ")"));
                        break;
                    case "middle":
                        startDy = (0, (/*@__PURE__*/$parcel$interopDefault($8a98d7eaad4a965c$exports)))("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
                        break;
                    default:
                        startDy = (0, (/*@__PURE__*/$parcel$interopDefault($8a98d7eaad4a965c$exports)))("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
                        break;
                }
                var transforms = [];
                if (scaleToFit) {
                    var lineWidth = wordsByLines[0].width;
                    var width = this.props.width;
                    transforms.push("scale(".concat(((0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(width) ? width / lineWidth : 1) / lineWidth, ")"));
                }
                if (angle) transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
                if (transforms.length) textProps.transform = transforms.join(" ");
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("text", $9b127a27894cc2e0$var$_extends({}, (0, $05a192303b32ed93$export$d697c39a2985a4c)(textProps, true), {
                    x: x,
                    y: y,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))("recharts-text", className),
                    textAnchor: textAnchor
                }), wordsByLines.map(function(line, index) {
                    return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                    (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("tspan", {
                        x: x,
                        dy: index === 0 ? startDy : lineHeight,
                        key: index
                    }, line.words.join(breakAll ? "" : " ")));
                }));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.width !== prevState.prevWidth || nextProps.scaleToFit !== prevState.prevScaleToFit || nextProps.children !== prevState.prevChildren || nextProps.style !== prevState.prevStyle || nextProps.breakAll !== prevState.prevBreakAll) {
                    var needCalculate = nextProps.children !== prevState.prevChildren || nextProps.style !== prevState.prevStyle || nextProps.breakAll !== prevState.prevBreakAll;
                    return {
                        prevWidth: nextProps.width,
                        prevScaleToFit: nextProps.scaleToFit,
                        prevChildren: nextProps.children,
                        prevStyle: nextProps.style,
                        wordsByLines: $9b127a27894cc2e0$var$getWordsByLines(nextProps, needCalculate)
                    };
                }
                return null;
            }
        }
    ]);
    return Text;
}((0, $jC8Vy.Component));
$9b127a27894cc2e0$export$5f1af8db9871e1d6.defaultProps = {
    x: 0,
    y: 0,
    lineHeight: "1em",
    capHeight: "0.71em",
    // Magic number from d3
    scaleToFit: false,
    textAnchor: "start",
    verticalAnchor: "end" // Maintain compat with existing charts / default SVG behavior
};







var $jC8Vy = parcelRequire("jC8Vy");
var $619d628f7fec0692$exports = {};
"use strict";

$619d628f7fec0692$exports = (parcelRequire("3EhUN"));



function $69167576c9a4dc19$export$d36bdfa510afb180(a, b) {
    /* eslint-disable no-restricted-syntax */ for(var key in a){
        if (({}).hasOwnProperty.call(a, key) && (!({}).hasOwnProperty.call(b, key) || a[key] !== b[key])) return false;
    }
    for(var _key in b){
        if (({}).hasOwnProperty.call(b, _key) && !({}).hasOwnProperty.call(a, _key)) return false;
    }
    return true;
}


function $217577d291f12aa3$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $217577d291f12aa3$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $217577d291f12aa3$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $217577d291f12aa3$var$REACT_BROWSER_EVENT_MAP = {
    click: "onClick",
    mousedown: "onMouseDown",
    mouseup: "onMouseUp",
    mouseover: "onMouseOver",
    mousemove: "onMouseMove",
    mouseout: "onMouseOut",
    mouseenter: "onMouseEnter",
    mouseleave: "onMouseLeave",
    touchcancel: "onTouchCancel",
    touchend: "onTouchEnd",
    touchmove: "onTouchMove",
    touchstart: "onTouchStart"
};
var $217577d291f12aa3$export$e65e0ff8d3882b46 = [
    "auto",
    "linear",
    "pow",
    "sqrt",
    "log",
    "identity",
    "time",
    "band",
    "point",
    "ordinal",
    "quantile",
    "quantize",
    "utc",
    "sequential",
    "threshold"
];
var $217577d291f12aa3$export$84dbd3b52ff06578 = [
    "plainline",
    "line",
    "square",
    "rect",
    "circle",
    "cross",
    "diamond",
    "star",
    "triangle",
    "wye",
    "none"
];
var $217577d291f12aa3$export$59a4d7d024cf1025 = [
    "none"
];
var $217577d291f12aa3$export$be63e0664592e141 = function getDisplayName(Comp) {
    if (typeof Comp === "string") return Comp;
    if (!Comp) return "";
    return Comp.displayName || Comp.name || "Component";
}; // `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var $217577d291f12aa3$var$lastChildren = null;
var $217577d291f12aa3$var$lastResult = null;
var $217577d291f12aa3$export$45b10814cc054894 = function toArray(children) {
    if (children === $217577d291f12aa3$var$lastChildren && (0, (/*@__PURE__*/$parcel$interopDefault($0fe4a5546443a34c$exports)))($217577d291f12aa3$var$lastResult)) return $217577d291f12aa3$var$lastResult;
    var result = [];
    (0, $jC8Vy.Children).forEach(children, function(child) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(child)) return;
        if ((0, $619d628f7fec0692$exports.isFragment)(child)) result = result.concat(toArray(child.props.children));
        else result.push(child);
    });
    $217577d291f12aa3$var$lastResult = result;
    $217577d291f12aa3$var$lastChildren = children;
    return result;
};
var $217577d291f12aa3$export$fdd5e64c0e8495bb = function findAllByType(children, type) {
    var result = [];
    var types = [];
    if ((0, (/*@__PURE__*/$parcel$interopDefault($0fe4a5546443a34c$exports)))(type)) types = type.map(function(t) {
        return $217577d291f12aa3$export$be63e0664592e141(t);
    });
    else types = [
        $217577d291f12aa3$export$be63e0664592e141(type)
    ];
    $217577d291f12aa3$export$45b10814cc054894(children).forEach(function(child) {
        var childType = (0, (/*@__PURE__*/$parcel$interopDefault($2cd7f9f9c3b27772$exports)))(child, "type.displayName") || (0, (/*@__PURE__*/$parcel$interopDefault($2cd7f9f9c3b27772$exports)))(child, "type.name");
        if (types.indexOf(childType) !== -1) result.push(child);
    });
    return result;
};
var $217577d291f12aa3$export$64c61536a2b72e0f = function findChildByType(children, type) {
    var result = $217577d291f12aa3$export$fdd5e64c0e8495bb(children, type);
    return result && result[0];
};
var $217577d291f12aa3$export$d0b46a9571fa5ebf = function withoutType(children, type) {
    var newChildren = [];
    var types;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($0fe4a5546443a34c$exports)))(type)) types = type.map(function(t) {
        return $217577d291f12aa3$export$be63e0664592e141(t);
    });
    else types = [
        $217577d291f12aa3$export$be63e0664592e141(type)
    ];
    $217577d291f12aa3$export$45b10814cc054894(children).forEach(function(child) {
        var displayName = (0, (/*@__PURE__*/$parcel$interopDefault($2cd7f9f9c3b27772$exports)))(child, "type.displayName");
        if (displayName && types.indexOf(displayName) !== -1) return;
        newChildren.push(child);
    });
    return newChildren;
};
var $217577d291f12aa3$export$5301de6bfd3cfa2a = function validateWidthHeight(el) {
    if (!el || !el.props) return false;
    var _el$props = el.props, width = _el$props.width, height = _el$props.height;
    if (!(0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(height) || height <= 0) return false;
    return true;
};
var $217577d291f12aa3$var$SVG_TAGS = [
    "a",
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animate",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "circle",
    "clipPath",
    "color-profile",
    "cursor",
    "defs",
    "desc",
    "ellipse",
    "feBlend",
    "feColormatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "filter",
    "font",
    "font-face",
    "font-face-format",
    "font-face-name",
    "font-face-url",
    "foreignObject",
    "g",
    "glyph",
    "glyphRef",
    "hkern",
    "image",
    "line",
    "lineGradient",
    "marker",
    "mask",
    "metadata",
    "missing-glyph",
    "mpath",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "script",
    "set",
    "stop",
    "style",
    "svg",
    "switch",
    "symbol",
    "text",
    "textPath",
    "title",
    "tref",
    "tspan",
    "use",
    "view",
    "vkern"
];
var $217577d291f12aa3$var$isSvgElement = function isSvgElement(child) {
    return child && child.type && (0, (/*@__PURE__*/$parcel$interopDefault($3719ffca02e94280$exports)))(child.type) && $217577d291f12aa3$var$SVG_TAGS.indexOf(child.type) >= 0;
};
var $217577d291f12aa3$export$ef6f3b46dcb37b3f = function filterSvgElements(children) {
    var svgElements = [];
    $217577d291f12aa3$export$45b10814cc054894(children).forEach(function(entry) {
        if ($217577d291f12aa3$var$isSvgElement(entry)) svgElements.push(entry);
    });
    return svgElements;
};
var $217577d291f12aa3$export$acdc716e08572f94 = function isChildrenEqual(nextChildren, prevChildren) {
    if (nextChildren === prevChildren) return true;
    var count = (0, $jC8Vy.Children).count(nextChildren);
    if (count !== (0, $jC8Vy.Children).count(prevChildren)) return false;
    if (count === 0) return true;
    if (count === 1) // eslint-disable-next-line no-use-before-define,@typescript-eslint/no-use-before-define
    return $217577d291f12aa3$export$96bceecf65400492((0, (/*@__PURE__*/$parcel$interopDefault($0fe4a5546443a34c$exports)))(nextChildren) ? nextChildren[0] : nextChildren, (0, (/*@__PURE__*/$parcel$interopDefault($0fe4a5546443a34c$exports)))(prevChildren) ? prevChildren[0] : prevChildren);
    for(var i = 0; i < count; i++){
        var nextChild = nextChildren[i];
        var prevChild = prevChildren[i];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($0fe4a5546443a34c$exports)))(nextChild) || (0, (/*@__PURE__*/$parcel$interopDefault($0fe4a5546443a34c$exports)))(prevChild)) {
            if (!isChildrenEqual(nextChild, prevChild)) return false;
             // eslint-disable-next-line no-use-before-define,@typescript-eslint/no-use-before-define
        } else if (!$217577d291f12aa3$export$96bceecf65400492(nextChild, prevChild)) return false;
    }
    return true;
};
var $217577d291f12aa3$export$96bceecf65400492 = function isSingleChildEqual(nextChild, prevChild) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(nextChild) && (0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(prevChild)) return true;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(nextChild) && !(0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(prevChild)) {
        var _ref = nextChild.props || {}, nextChildren = _ref.children, nextProps = $217577d291f12aa3$var$_objectWithoutProperties(_ref, [
            "children"
        ]);
        var _ref2 = prevChild.props || {}, prevChildren = _ref2.children, prevProps = $217577d291f12aa3$var$_objectWithoutProperties(_ref2, [
            "children"
        ]);
        if (nextChildren && prevChildren) // eslint-disable-next-line no-use-before-define
        return (0, $69167576c9a4dc19$export$d36bdfa510afb180)(nextProps, prevProps) && $217577d291f12aa3$export$acdc716e08572f94(nextChildren, prevChildren);
        if (!nextChildren && !prevChildren) return (0, $69167576c9a4dc19$export$d36bdfa510afb180)(nextProps, prevProps);
        return false;
    }
    return false;
};
var $217577d291f12aa3$export$a98d6da55570cb82 = function renderByOrder(children, renderMap) {
    var elements = [];
    var record = {};
    $217577d291f12aa3$export$45b10814cc054894(children).forEach(function(child, index) {
        if ($217577d291f12aa3$var$isSvgElement(child)) elements.push(child);
        else if (child) {
            var displayName = $217577d291f12aa3$export$be63e0664592e141(child.type);
            var _ref3 = renderMap[displayName] || {}, handler = _ref3.handler, once = _ref3.once;
            if (handler && (!once || !record[displayName])) {
                var results = handler(child, displayName, index);
                elements.push(results);
                record[displayName] = true;
            }
        }
    });
    return elements;
};
var $217577d291f12aa3$export$afb3591bc51a0b70 = function getReactEventByType(e) {
    var type = e && e.type;
    if (type && $217577d291f12aa3$var$REACT_BROWSER_EVENT_MAP[type]) return $217577d291f12aa3$var$REACT_BROWSER_EVENT_MAP[type];
    return null;
};
var $217577d291f12aa3$export$857ca101f741953 = function parseChildIndex(child, children) {
    return $217577d291f12aa3$export$45b10814cc054894(children).indexOf(child);
};






var $76273bef9289b8fd$exports = {};
var $f1e5223e1a1aa8c9$exports = {};

var $80d323c31a8e5eed$exports = {};



/** Built-in value references. */ var $80d323c31a8e5eed$var$spreadableSymbol = $a0e007488b23f5fe$exports ? $a0e007488b23f5fe$exports.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $80d323c31a8e5eed$var$isFlattenable(value) {
    return $0fe4a5546443a34c$exports(value) || $740020e1b6465003$exports(value) || !!($80d323c31a8e5eed$var$spreadableSymbol && value && value[$80d323c31a8e5eed$var$spreadableSymbol]);
}
$80d323c31a8e5eed$exports = $80d323c31a8e5eed$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $f1e5223e1a1aa8c9$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $80d323c31a8e5eed$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $f1e5223e1a1aa8c9$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $5ca68c0f8b43df56$exports(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$f1e5223e1a1aa8c9$exports = $f1e5223e1a1aa8c9$var$baseFlatten;


var $36e95a3b1c4751f6$exports = {};




var $06bca9b21ab8fc78$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $06bca9b21ab8fc78$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$06bca9b21ab8fc78$exports = $06bca9b21ab8fc78$var$baseSortBy;



var $e0f2fb191f7f3b65$exports = {};
var $8c932c18267ff376$exports = {};

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $8c932c18267ff376$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $bd288f840efc8d52$exports(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $bd288f840efc8d52$exports(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$8c932c18267ff376$exports = $8c932c18267ff376$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $e0f2fb191f7f3b65$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $8c932c18267ff376$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == "desc" ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$e0f2fb191f7f3b65$exports = $e0f2fb191f7f3b65$var$compareMultiple;




/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $36e95a3b1c4751f6$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $fdb8f9af1091eb2c$exports(iteratees, function(iteratee) {
        if ($0fe4a5546443a34c$exports(iteratee)) return function(value) {
            return $c57b97e716b5dbef$exports(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $57b7bffe2f9def0f$exports
    ];
    var index = -1;
    iteratees = $fdb8f9af1091eb2c$exports(iteratees, $6a1e4a18512710bb$exports($958e35cadb69881a$exports));
    var result = $e4efdf6d5bdd69dc$exports(collection, function(value, key, collection) {
        var criteria = $fdb8f9af1091eb2c$exports(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            "criteria": criteria,
            "index": ++index,
            "value": value
        };
    });
    return $06bca9b21ab8fc78$exports(result, function(object, other) {
        return $e0f2fb191f7f3b65$exports(object, other, orders);
    });
}
$36e95a3b1c4751f6$exports = $36e95a3b1c4751f6$var$baseOrderBy;


var $0864451a38c65def$exports = {};

var $4ab07ae663861c50$exports = {};
var $2f5fe923163c8119$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $2f5fe923163c8119$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$2f5fe923163c8119$exports = $2f5fe923163c8119$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $4ab07ae663861c50$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $4ab07ae663861c50$var$overRest(func, start, transform) {
    start = $4ab07ae663861c50$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $4ab07ae663861c50$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $2f5fe923163c8119$exports(func, this, otherArgs);
    };
}
$4ab07ae663861c50$exports = $4ab07ae663861c50$var$overRest;


var $2c3dc00a6f363215$exports = {};
var $951c25e8ffb397c2$exports = {};
var $3392911d177934fd$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $3392911d177934fd$var$constant(value) {
    return function() {
        return value;
    };
}
$3392911d177934fd$exports = $3392911d177934fd$var$constant;




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $951c25e8ffb397c2$var$baseSetToString = !$5984e4c2489c8c28$exports ? $57b7bffe2f9def0f$exports : function(func, string) {
    return $5984e4c2489c8c28$exports(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $3392911d177934fd$exports(string),
        "writable": true
    });
};
$951c25e8ffb397c2$exports = $951c25e8ffb397c2$var$baseSetToString;


var $4cb0a139300b5e2b$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $4cb0a139300b5e2b$var$HOT_COUNT = 800, $4cb0a139300b5e2b$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $4cb0a139300b5e2b$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $4cb0a139300b5e2b$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $4cb0a139300b5e2b$var$nativeNow(), remaining = $4cb0a139300b5e2b$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $4cb0a139300b5e2b$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$4cb0a139300b5e2b$exports = $4cb0a139300b5e2b$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $2c3dc00a6f363215$var$setToString = $4cb0a139300b5e2b$exports($951c25e8ffb397c2$exports);
$2c3dc00a6f363215$exports = $2c3dc00a6f363215$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $0864451a38c65def$var$baseRest(func, start) {
    return $2c3dc00a6f363215$exports($4ab07ae663861c50$exports(func, start, $57b7bffe2f9def0f$exports), func + "");
}
$0864451a38c65def$exports = $0864451a38c65def$var$baseRest;


var $3c4d4e2d8b3e6d8b$exports = {};




/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $3c4d4e2d8b3e6d8b$var$isIterateeCall(value, index, object) {
    if (!$cdeebba9a3c50f33$exports(object)) return false;
    var type = typeof index;
    if (type == "number" ? $263ae7db1776a88c$exports(object) && $8fea83d6de918b08$exports(index, object.length) : type == "string" && index in object) return $2d67364ed6c1926e$exports(object[index], value);
    return false;
}
$3c4d4e2d8b3e6d8b$exports = $3c4d4e2d8b3e6d8b$var$isIterateeCall;


/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $76273bef9289b8fd$var$sortBy = $0864451a38c65def$exports(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $3c4d4e2d8b3e6d8b$exports(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $3c4d4e2d8b3e6d8b$exports(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $36e95a3b1c4751f6$exports(collection, $f1e5223e1a1aa8c9$exports(iteratees, 1), []);
});
$76273bef9289b8fd$exports = $76273bef9289b8fd$var$sortBy;







var $b554c0681cbe33f9$exports = {};

var $0ad9df483f751b21$exports = {};
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function $0ad9df483f751b21$var$baseLt(value, other) {
    return value < other;
}
$0ad9df483f751b21$exports = $0ad9df483f751b21$var$baseLt;



/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function $b554c0681cbe33f9$var$min(array) {
    return array && array.length ? $2852e70d87210654$exports(array, $57b7bffe2f9def0f$exports, $0ad9df483f751b21$exports) : undefined;
}
$b554c0681cbe33f9$exports = $b554c0681cbe33f9$var$min;


var $3cd41a512b6ad1e6$exports = {};


/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $3cd41a512b6ad1e6$var$flatMap(collection, iteratee) {
    return $f1e5223e1a1aa8c9$exports($8c69ba69485f4ea5$exports(collection, iteratee), 1);
}
$3cd41a512b6ad1e6$exports = $3cd41a512b6ad1e6$var$flatMap;





var $79fd56627fdb23c6$exports = {};
(function(globalScope) {
    "use strict";
    /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    var MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
    Decimal = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed during run-time using `Decimal.config`.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
        // `toFixed`, `toPrecision` and `toSignificantDigits`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The natural logarithm of 10.
        // 115 digits
        LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    external = true, decimalError = "[DecimalError] ", invalidArgument = decimalError + "Invalid argument: ", exponentOutOfRange = decimalError + "Exponent out of range: ", mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), // Decimal.prototype object
    P = {};
    // Decimal prototype methods
    /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this;
        y = new x.constructor(y);
        // Signs differ?
        if (x.s !== y.s) return x.s || -y.s;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
        xdL = x.d.length;
        ydL = y.d.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var x = this, w = x.d.length - 1, dp = (w - x.e) * LOG_BASE;
        // Subtract the number of trailing zeros of the last word.
        w = x.d[w];
        if (w) for(; w % 10 == 0; w /= 10)dp--;
        return dp < 0 ? 0 : dp;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */ P.dividedToIntegerBy = P.idiv = function(y) {
        var x = this, Ctor = x.constructor;
        return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */ P.exponent = function() {
        return getBase10Exponent(this);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        return this.cmp(y) >= 0;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isint = function() {
        return this.e > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isneg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.ispos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */ P.isZero = function() {
        return this.s === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
        // Default base is 10.
        if (base === void 0) base = new Ctor(10);
        else {
            base = new Ctor(base);
            // log[-b](x) = NaN
            // log[0](x)  = NaN
            // log[1](x)  = NaN
            if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + "NaN");
        }
        // log[b](-x) = NaN
        // log[b](0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? "NaN" : "-Infinity"));
        // log[b](1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        external = false;
        r = divide(ln(x, wpr), ln(base, wpr), wpr);
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.minus = P.sub = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
        y = new Ctor(y);
        // x % 0 = NaN
        if (!y.s) throw Error(decimalError + "NaN");
        // Return x if x is 0.
        if (!x.s) return round(new Ctor(x), pr);
        // Prevent rounding of intermediate calculations.
        external = false;
        q = divide(x, y, 0, 1).times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.naturalExponential = P.exp = function() {
        return exp(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return ln(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s || 0;
        return x;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.plus = P.add = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var e, sd, w, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        e = getBase10Exponent(x) + 1;
        w = x.d.length - 1;
        sd = w * LOG_BASE + 1;
        w = x.d[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)sd--;
            // Add the number of digits of the first word.
            for(w = x.d[0]; w >= 10; w /= 10)sd++;
        }
        return z && e > sd ? e : sd;
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.squareRoot = P.sqrt = function() {
        var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
        // Negative or zero?
        if (x.s < 1) {
            if (!x.s) return new Ctor(0);
            // sqrt(-x) = NaN
            throw Error(decimalError + "NaN");
        }
        e = getBase10Exponent(x);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(x.d);
            if ((n.length + e) % 2 == 0) n += "0";
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = "5e" + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf("e") + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        pr = Ctor.precision;
        s = wpr = pr + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, wpr + 2)).times(0.5);
            if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
                n = n.slice(wpr - 3, wpr + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (s == wpr && n == "4999") {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    round(t, pr + 1, 0);
                    if (t.times(t).eq(x)) {
                        r = t;
                        break;
                    }
                } else if (n != "9999") break;
                wpr += 4;
            }
        }
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        // Return 0 if either is 0.
        if (!x.s || !y.s) return new Ctor(0);
        y.s *= x.s;
        e = x.e + y.e;
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = e;
        return external ? round(y, Ctor.precision) : y;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.todp = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return round(x, dp + getBase10Exponent(x) + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = toString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), dp + 1, rm);
            str = toString(x, true, dp + 1);
        }
        return str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) return toString(x);
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
        str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isneg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.toInteger = P.toint = function() {
        var x = this, Ctor = x.constructor;
        return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
        // pow(x, 0) = 1
        if (!y.s) return new Ctor(ONE);
        x = new Ctor(x);
        // pow(0, y > 0) = 0
        // pow(0, y < 0) = Infinity
        if (!x.s) {
            if (y.s < 1) throw Error(decimalError + "Infinity");
            return x;
        }
        // pow(1, y) = 1
        if (x.eq(ONE)) return x;
        pr = Ctor.precision;
        // pow(x, 1) = x
        if (y.eq(ONE)) return round(x, pr);
        e = y.e;
        k = y.d.length - 1;
        yIsInt = e >= k;
        sign = x.s;
        if (!yIsInt) {
            // pow(x < 0, y non-integer) = NaN
            if (sign < 0) throw Error(decimalError + "NaN");
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = new Ctor(ONE);
            // Max k of 9007199254740991 takes 53 loop iterations.
            // Maximum digits array length; leaves [28, 34] guard digits.
            e = Math.ceil(pr / LOG_BASE + 4);
            external = false;
            for(;;){
                if (k % 2) {
                    r = r.times(x);
                    truncate(r.d, e);
                }
                k = mathfloor(k / 2);
                if (k === 0) break;
                x = x.times(x);
                truncate(x.d, e);
            }
            external = true;
            return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
        }
        // Result is negative if x is negative and the last digit of integer y is odd.
        sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
        x.s = 1;
        external = false;
        r = y.times(ln(x, pr + guard));
        external = true;
        r = exp(r);
        r.s = sign;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var e, str, x = this, Ctor = x.constructor;
        if (sd === void 0) {
            e = getBase10Exponent(x);
            str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), sd, rm);
            e = getBase10Exponent(x);
            str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
        }
        return str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toSignificantDigits = P.tosd = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return round(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = P.valueOf = P.val = P.toJSON = function() {
        var x = this, e = getBase10Exponent(x), Ctor = x.constructor;
        return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */ function add(x, y) {
        var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
        // If either is zero...
        if (!x.s || !y.s) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!y.s) y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are finite, non-zero numbers with the same sign.
        k = x.e;
        e = y.e;
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = e;
        return external ? round(y, pr) : y;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = "", w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + "";
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + "";
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return "0";
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % BASE | 0;
                carry = temp / BASE | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * BASE + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, dp) {
            var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either 0?
            if (!x.s) return new Ctor(x);
            if (!y.s) throw Error(decimalError + "Division by zero");
            e = x.e - y.e;
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            for(i = 0; yd[i] == (xd[i] || 0);)++i;
            if (yd[i] > (xd[i] || 0)) --e;
            if (pr == null) sd = pr = Ctor.precision;
            else if (dp) sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
            else sd = pr;
            if (sd < 0) return new Ctor(0);
            // Convert precision in number of base 10 digits to base 1e7 digits.
            sd = sd / LOG_BASE + 2 | 0;
            i = 0;
            // divisor < 1e7
            if (yL == 1) {
                k = 0;
                yd = yd[0];
                sd++;
                // k is the carry.
                for(; (i < xL || k) && sd--; i++){
                    t = k * BASE + (xd[i] || 0);
                    qd[i] = t / yd | 0;
                    k = t % yd | 0;
                }
            // divisor >= 1e7
            } else {
                // Normalise xd and yd so highest order digit of yd is >= BASE/2
                k = BASE / (yd[0] + 1) | 0;
                if (k > 1) {
                    yd = multiplyInteger(yd, k);
                    xd = multiplyInteger(xd, k);
                    yL = yd.length;
                    xL = xd.length;
                }
                xi = yL;
                rem = xd.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL;)rem[remL++] = 0;
                yz = yd.slice();
                yz.unshift(0);
                yd0 = yd[0];
                if (yd[1] >= BASE / 2) ++yd0;
                do {
                    k = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yd, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
                        // k will be how many times the divisor goes into the current remainder.
                        k = rem0 / yd0 | 0;
                        //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                            if (k >= BASE) k = BASE - 1;
                            // product = divisor * trial digit.
                            prod = multiplyInteger(yd, k);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            cmp = compare(prod, rem, prodL, remL);
                            // product > remainder.
                            if (cmp == 1) {
                                k--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yd, prodL);
                            }
                        } else {
                            // cmp is -1.
                            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                            if (k == 0) cmp = k = 1;
                            prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL);
                        // If product was < previous remainder.
                        if (cmp == -1) {
                            remL = rem.length;
                            // Compare divisor and new remainder.
                            cmp = compare(yd, rem, yL, remL);
                            // If divisor < new remainder, subtract divisor from remainder.
                            if (cmp < 1) {
                                k++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yd, remL);
                            }
                        }
                        remL = rem.length;
                    } else if (cmp === 0) {
                        k++;
                        rem = [
                            0
                        ];
                    } // if cmp === 1, k will be 0
                    // Add the next digit, k, to the result array.
                    qd[i++] = k;
                    // Update the remainder.
                    if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                    else {
                        rem = [
                            xd[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] !== void 0) && sd--);
            }
            // Leading zero?
            if (!qd[0]) qd.shift();
            q.e = e;
            return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
        };
    }();
    /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */ function exp(x, sd) {
        var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
        if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
        // exp(0) = 1
        if (!x.s) return new Ctor(ONE);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        while(x.abs().gte(0.1)){
            x = x.times(t); // x = x / 2^5
            k += 5;
        }
        // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(ONE);
        Ctor.precision = wpr;
        for(;;){
            pow = round(pow.times(x), wpr);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                while(k--)sum = round(sum.times(sum), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
        }
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(x) {
        var e = x.e * LOG_BASE, w = x.d[0];
        // Add the number of digits of the first word of the digits array.
        for(; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > Ctor.LN10.sd()) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(decimalError + "LN10 precision limit exceeded");
        }
        return round(new Ctor(Ctor.LN10), sd);
    }
    function getZeroString(k) {
        var zs = "";
        for(; k--;)zs += "0";
        return zs;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */ function ln(y, sd) {
        var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
        // ln(-x) = NaN
        // ln(0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? "NaN" : "-Infinity"));
        // ln(1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        if (x.eq(10)) {
            if (sd == null) external = true;
            return getLn10(Ctor, wpr);
        }
        wpr += guard;
        Ctor.precision = wpr;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        e = getBase10Exponent(x);
        if (Math.abs(e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = getBase10Exponent(x);
            if (c0 > 1) {
                x = new Ctor("0." + c);
                e++;
            } else x = new Ctor(c0 + "." + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + "");
            x = ln(new Ctor(c0 + "." + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? (external = true, round(x, pr)) : x;
        }
        // x is reduced to a value near 1.
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
        x2 = round(x.times(x), wpr);
        denominator = 3;
        for(;;){
            numerator = round(numerator.times(x2), wpr);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ""));
                sum = divide(sum, new Ctor(n), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
            denominator += 2;
        }
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48;)++i;
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
        str = str.slice(i, len);
        if (str) {
            len -= i;
            e = e - i - 1;
            x.e = mathfloor(e / LOG_BASE);
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += "0";
            x.d.push(+str);
            if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
        } else {
            // Zero.
            x.s = 0;
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */ function round(x, sd, rm) {
        var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd which contains the rounding digit, a base 1e7 number.
        // xdi: the index of w within xd.
        // n: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
        // Get the length of the first word of the digits array xd.
        for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
        i = sd - n;
        // Is the rounding digit in the first word of xd?
        if (i < 0) {
            i += LOG_BASE;
            j = sd;
            w = xd[xdi = 0];
        } else {
            xdi = Math.ceil((i + 1) / LOG_BASE);
            k = xd.length;
            if (xdi >= k) return x;
            w = k = xd[xdi];
            // Get the number of digits of w.
            for(n = 1; k >= 10; k /= 10)n++;
            // Get the index of rd within w.
            i %= LOG_BASE;
            // Get the index of rd within w, adjusted for leading zeros.
            // The number of leading zeros of w is given by LOG_BASE - n.
            j = i - LOG_BASE + n;
        }
        if (rm !== void 0) {
            k = mathpow(10, n - j - 1);
            // Get the rounding digit at index j of w.
            rd = w / k % 10 | 0;
            // Are there any non-zero digits after the rounding digit?
            doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
            // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
            // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
            // 714.
            doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        }
        if (sd < 1 || !xd[0]) {
            if (doRound) {
                k = getBase10Exponent(x);
                xd.length = 1;
                // Convert sd to decimal places.
                sd = sd - k - 1;
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                x.e = mathfloor(-sd / LOG_BASE) || 0;
            } else {
                xd.length = 1;
                // Zero.
                xd[0] = x.e = x.s = 0;
            }
            return x;
        }
        // Remove excess digits.
        if (i == 0) {
            xd.length = xdi;
            k = 1;
            xdi--;
        } else {
            xd.length = xdi + 1;
            k = mathpow(10, LOG_BASE - i);
            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of w.
            xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
        }
        if (doRound) {
            for(;;)// Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {
                if ((xd[0] += k) == BASE) {
                    xd[0] = 1;
                    ++x.e;
                }
                break;
            } else {
                xd[xdi] += k;
                if (xd[xdi] != BASE) break;
                xd[xdi--] = 0;
                k = 1;
            }
        }
        // Remove trailing zeros.
        for(i = xd.length; xd[--i] === 0;)xd.pop();
        if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + getBase10Exponent(x));
        return x;
    }
    function subtract(x, y) {
        var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
        // Return y negated if x is zero.
        // Return x if y is zero and x is non-zero.
        if (!x.s || !y.s) {
            if (y.s) y.s = -y.s;
            else y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are non-zero numbers with the same sign.
        e = y.e;
        xe = x.e;
        xd = xd.slice();
        k = xe - e;
        // If exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of zeros
            // needing to be prepended, but this can be avoided while still ensuring correct rounding by
            // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to xd if shorter.
        // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(0);
        y.d = xd;
        y.e = e;
        //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
        return external ? round(y, pr) : y;
    }
    function toString(x, isExp, sd) {
        var k, e = getBase10Exponent(x), str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + "." + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + "." + str.slice(1);
            str = str + (e < 0 ? "e" : "e+") + e;
        } else if (e < 0) {
            str = "0." + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + "." + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + "." + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += ".";
                str += getZeroString(k);
            }
        }
        return x.s < 0 ? "-" + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  clone
   *  config/set
   */ /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */ function Decimal(value) {
            var x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(value);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (value instanceof Decimal) {
                x.s = value.s;
                x.e = value.e;
                x.d = (value = value.d) ? value.slice() : value;
                return;
            }
            if (typeof value === "number") {
                // Reject Infinity/NaN.
                if (value * 0 !== 0) throw Error(invalidArgument + value);
                if (value > 0) x.s = 1;
                else if (value < 0) {
                    value = -value;
                    x.s = -1;
                } else {
                    x.s = 0;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                // Fast path for small integers.
                if (value === ~~value && value < 1e7) {
                    x.e = 0;
                    x.d = [
                        value
                    ];
                    return;
                }
                return parseDecimal(x, value.toString());
            } else if (typeof value !== "string") throw Error(invalidArgument + value);
            // Minus sign?
            if (value.charCodeAt(0) === 45) {
                value = value.slice(1);
                x.s = -1;
            } else x.s = 1;
            if (isDecimal.test(value)) parseDecimal(x, value);
            else throw Error(invalidArgument + value);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.clone = clone;
        Decimal.config = Decimal.set = config;
        if (obj === void 0) obj = {};
        if (obj) {
            ps = [
                "precision",
                "rounding",
                "toExpNeg",
                "toExpPos",
                "LN10"
            ];
            for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== "object") throw Error(decimalError + "Object expected");
        var i, p, v, ps = [
            "precision",
            1,
            MAX_DIGITS,
            "rounding",
            0,
            8,
            "toExpNeg",
            -1 / 0,
            0,
            "toExpPos",
            0,
            1 / 0
        ];
        for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
            if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
            else throw Error(invalidArgument + p + ": " + v);
        }
        if ((v = obj[p = "LN10"]) !== void 0) {
            if (v == Math.LN10) this[p] = new this(v);
            else throw Error(invalidArgument + p + ": " + v);
        }
        return this;
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(Decimal);
    Decimal["default"] = Decimal.Decimal = Decimal;
    // Internal constant.
    ONE = new Decimal(1);
    // Export.
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return Decimal;
    });
    else if (0, $79fd56627fdb23c6$exports) $79fd56627fdb23c6$exports = Decimal;
    else {
        if (!globalScope) globalScope = typeof self != "undefined" && self && self.self == self ? self : Function("return this")();
        globalScope.Decimal = Decimal;
    }
})($79fd56627fdb23c6$exports);


function $2fbe53d0c4c2ac3c$var$_toConsumableArray(arr) {
    return $2fbe53d0c4c2ac3c$var$_arrayWithoutHoles(arr) || $2fbe53d0c4c2ac3c$var$_iterableToArray(arr) || $2fbe53d0c4c2ac3c$var$_unsupportedIterableToArray(arr) || $2fbe53d0c4c2ac3c$var$_nonIterableSpread();
}
function $2fbe53d0c4c2ac3c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2fbe53d0c4c2ac3c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2fbe53d0c4c2ac3c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2fbe53d0c4c2ac3c$var$_arrayLikeToArray(o, minLen);
}
function $2fbe53d0c4c2ac3c$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $2fbe53d0c4c2ac3c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $2fbe53d0c4c2ac3c$var$_arrayLikeToArray(arr);
}
function $2fbe53d0c4c2ac3c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $2fbe53d0c4c2ac3c$var$identity = function identity(i) {
    return i;
};
var $2fbe53d0c4c2ac3c$export$ca73b6d700d0505 = {
    "@@functional/placeholder": true
};
var $2fbe53d0c4c2ac3c$var$isPlaceHolder = function isPlaceHolder(val) {
    return val === $2fbe53d0c4c2ac3c$export$ca73b6d700d0505;
};
var $2fbe53d0c4c2ac3c$var$curry0 = function curry0(fn) {
    return function _curried() {
        if (arguments.length === 0 || arguments.length === 1 && $2fbe53d0c4c2ac3c$var$isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) return _curried;
        return fn.apply(void 0, arguments);
    };
};
var $2fbe53d0c4c2ac3c$var$curryN = function curryN(n, fn) {
    if (n === 1) return fn;
    return $2fbe53d0c4c2ac3c$var$curry0(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var argsLength = args.filter(function(arg) {
            return arg !== $2fbe53d0c4c2ac3c$export$ca73b6d700d0505;
        }).length;
        if (argsLength >= n) return fn.apply(void 0, args);
        return curryN(n - argsLength, $2fbe53d0c4c2ac3c$var$curry0(function() {
            for(var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)restArgs[_key2] = arguments[_key2];
            var newArgs = args.map(function(arg) {
                return $2fbe53d0c4c2ac3c$var$isPlaceHolder(arg) ? restArgs.shift() : arg;
            });
            return fn.apply(void 0, $2fbe53d0c4c2ac3c$var$_toConsumableArray(newArgs).concat(restArgs));
        }));
    });
};
var $2fbe53d0c4c2ac3c$export$c3095a23b368d1f2 = function curry(fn) {
    return $2fbe53d0c4c2ac3c$var$curryN(fn.length, fn);
};
var $2fbe53d0c4c2ac3c$export$d02631cccf789723 = function range(begin, end) {
    var arr = [];
    for(var i = begin; i < end; ++i)arr[i - begin] = i;
    return arr;
};
var $2fbe53d0c4c2ac3c$export$871de8747c9eaa88 = $2fbe53d0c4c2ac3c$export$c3095a23b368d1f2(function(fn, arr) {
    if (Array.isArray(arr)) return arr.map(fn);
    return Object.keys(arr).map(function(key) {
        return arr[key];
    }).map(fn);
});
var $2fbe53d0c4c2ac3c$export$f672e0b6f7222cd7 = function compose() {
    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
    if (!args.length) return $2fbe53d0c4c2ac3c$var$identity;
    var fns = args.reverse(); // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var $2fbe53d0c4c2ac3c$export$66c1ae025e96b4bc = function reverse(arr) {
    if (Array.isArray(arr)) return arr.reverse();
     // can be string
    return arr.split("").reverse.join("");
};
var $2fbe53d0c4c2ac3c$export$fc10aeed3a532e2a = function memoize(fn) {
    var lastArgs = null;
    var lastResult = null;
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        if (lastArgs && args.every(function(val, i) {
            return val === lastArgs[i];
        })) return lastResult;
        lastArgs = args;
        lastResult = fn.apply(void 0, args);
        return lastResult;
    };
};


/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */ 

/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */ function $b78b2edce2cf6226$var$getDigitCount(value) {
    var result;
    if (value === 0) result = 1;
    else result = Math.floor(new (0, (/*@__PURE__*/$parcel$interopDefault($79fd56627fdb23c6$exports)))(value).abs().log(10).toNumber()) + 1;
    return result;
}
/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Decimal} start 起点
 * @param  {Decimal} end   终点，不包含该值
 * @param  {Decimal} step  步长
 * @return {Array}         若干数值
 */ function $b78b2edce2cf6226$var$rangeStep(start, end, step) {
    var num = new (0, (/*@__PURE__*/$parcel$interopDefault($79fd56627fdb23c6$exports)))(start);
    var i = 0;
    var result = []; // magic number to prevent infinite loop
    while(num.lt(end) && i < 100000){
        result.push(num.toNumber());
        num = num.add(step);
        i++;
    }
    return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */ var $b78b2edce2cf6226$var$interpolateNumber = (0, $2fbe53d0c4c2ac3c$export$c3095a23b368d1f2)(function(a, b, t) {
    var newA = +a;
    var newB = +b;
    return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */ var $b78b2edce2cf6226$var$uninterpolateNumber = (0, $2fbe53d0c4c2ac3c$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */ var $b78b2edce2cf6226$var$uninterpolateTruncation = (0, $2fbe53d0c4c2ac3c$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return Math.max(0, Math.min(1, (x - a) / diff));
});
var $b78b2edce2cf6226$export$2e2bcd8739ae039 = {
    rangeStep: $b78b2edce2cf6226$var$rangeStep,
    getDigitCount: $b78b2edce2cf6226$var$getDigitCount,
    interpolateNumber: $b78b2edce2cf6226$var$interpolateNumber,
    uninterpolateNumber: $b78b2edce2cf6226$var$uninterpolateNumber,
    uninterpolateTruncation: $b78b2edce2cf6226$var$uninterpolateTruncation
};


function $1f2680d726e2bea7$var$_toConsumableArray(arr) {
    return $1f2680d726e2bea7$var$_arrayWithoutHoles(arr) || $1f2680d726e2bea7$var$_iterableToArray(arr) || $1f2680d726e2bea7$var$_unsupportedIterableToArray(arr) || $1f2680d726e2bea7$var$_nonIterableSpread();
}
function $1f2680d726e2bea7$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1f2680d726e2bea7$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $1f2680d726e2bea7$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1f2680d726e2bea7$var$_arrayLikeToArray(arr);
}
function $1f2680d726e2bea7$var$_slicedToArray(arr, i) {
    return $1f2680d726e2bea7$var$_arrayWithHoles(arr) || $1f2680d726e2bea7$var$_iterableToArrayLimit(arr, i) || $1f2680d726e2bea7$var$_unsupportedIterableToArray(arr, i) || $1f2680d726e2bea7$var$_nonIterableRest();
}
function $1f2680d726e2bea7$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1f2680d726e2bea7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1f2680d726e2bea7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1f2680d726e2bea7$var$_arrayLikeToArray(o, minLen);
}
function $1f2680d726e2bea7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1f2680d726e2bea7$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $1f2680d726e2bea7$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */ function $1f2680d726e2bea7$var$getValidInterval(_ref) {
    var _ref2 = $1f2680d726e2bea7$var$_slicedToArray(_ref, 2), min = _ref2[0], max = _ref2[1];
    var validMin = min, validMax = max; // exchange
    if (min > max) {
        validMin = max;
        validMax = min;
    }
    return [
        validMin,
        validMax
    ];
}
/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Decimal} roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Decimal} The step which is easy to understand between two ticks
 */ function $1f2680d726e2bea7$var$getFormatStep(roughStep, allowDecimals, correctionFactor) {
    if (roughStep.lte(0)) return new (0, (/*@__PURE__*/$parcel$interopDefault($79fd56627fdb23c6$exports)))(0);
    var digitCount = (0, $b78b2edce2cf6226$export$2e2bcd8739ae039).getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
    // order of magnitudes than the rough step
    var digitCountValue = new (0, (/*@__PURE__*/$parcel$interopDefault($79fd56627fdb23c6$exports)))(10).pow(digitCount);
    var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong
    var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
    var amendStepRatio = new (0, (/*@__PURE__*/$parcel$interopDefault($79fd56627fdb23c6$exports)))(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
    var formatStep = amendStepRatio.mul(digitCountValue);
    return allowDecimals ? formatStep : new (0, (/*@__PURE__*/$parcel$interopDefault($79fd56627fdb23c6$exports)))(Math.ceil(formatStep));
}
/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */ function $1f2680d726e2bea7$var$getTickOfSingleValue(value, tickCount, allowDecimals) {
    var step = 1; // calculate the middle value of ticks
    var middle = new (0, (/*@__PURE__*/$parcel$interopDefault($79fd56627fdb23c6$exports)))(value);
    if (!middle.isint() && allowDecimals) {
        var absVal = Math.abs(value);
        if (absVal < 1) {
            // The step should be a float number when the difference is smaller than 1
            step = new (0, (/*@__PURE__*/$parcel$interopDefault($79fd56627fdb23c6$exports)))(10).pow((0, $b78b2edce2cf6226$export$2e2bcd8739ae039).getDigitCount(value) - 1);
            middle = new (0, (/*@__PURE__*/$parcel$interopDefault($79fd56627fdb23c6$exports)))(Math.floor(middle.div(step).toNumber())).mul(step);
        } else if (absVal > 1) // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($79fd56627fdb23c6$exports)))(Math.floor(value));
    } else if (value === 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($79fd56627fdb23c6$exports)))(Math.floor((tickCount - 1) / 2));
    else if (!allowDecimals) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($79fd56627fdb23c6$exports)))(Math.floor(value));
    var middleIndex = Math.floor((tickCount - 1) / 2);
    var fn = (0, $2fbe53d0c4c2ac3c$export$f672e0b6f7222cd7)((0, $2fbe53d0c4c2ac3c$export$871de8747c9eaa88)(function(n) {
        return middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($79fd56627fdb23c6$exports)))(n - middleIndex).mul(step)).toNumber();
    }), (0, $2fbe53d0c4c2ac3c$export$d02631cccf789723));
    return fn(0, tickCount);
}
/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */ function $1f2680d726e2bea7$var$calculateStep(min, max, tickCount, allowDecimals) {
    var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    // dirty hack (for recharts' test)
    if (!Number.isFinite((max - min) / (tickCount - 1))) return {
        step: new (0, (/*@__PURE__*/$parcel$interopDefault($79fd56627fdb23c6$exports)))(0),
        tickMin: new (0, (/*@__PURE__*/$parcel$interopDefault($79fd56627fdb23c6$exports)))(0),
        tickMax: new (0, (/*@__PURE__*/$parcel$interopDefault($79fd56627fdb23c6$exports)))(0)
    };
     // The step which is easy to understand between two ticks
    var step = $1f2680d726e2bea7$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($79fd56627fdb23c6$exports)))(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks
    var middle; // When 0 is inside the interval, 0 should be a tick
    if (min <= 0 && max >= 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($79fd56627fdb23c6$exports)))(0);
    else {
        // calculate the middle value
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($79fd56627fdb23c6$exports)))(min).add(max).div(2); // minus modulo value
        middle = middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($79fd56627fdb23c6$exports)))(middle).mod(step));
    }
    var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
    var upCount = Math.ceil(new (0, (/*@__PURE__*/$parcel$interopDefault($79fd56627fdb23c6$exports)))(max).sub(middle).div(step).toNumber());
    var scaleCount = belowCount + upCount + 1;
    if (scaleCount > tickCount) // When more ticks need to cover the interval, step should be bigger.
    return $1f2680d726e2bea7$var$calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
    if (scaleCount < tickCount) {
        // When less ticks can cover the interval, we should add some additional ticks
        upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
        belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
    }
    return {
        step: step,
        tickMin: middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($79fd56627fdb23c6$exports)))(belowCount).mul(step)),
        tickMax: middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($79fd56627fdb23c6$exports)))(upCount).mul(step))
    };
}
/**
 * Calculate the ticks of an interval, the count of ticks will be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $1f2680d726e2bea7$var$getNiceTickValuesFn(_ref3) {
    var _ref4 = $1f2680d726e2bea7$var$_slicedToArray(_ref3, 2), min = _ref4[0], max = _ref4[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval = $1f2680d726e2bea7$var$getValidInterval([
        min,
        max
    ]), _getValidInterval2 = $1f2680d726e2bea7$var$_slicedToArray(_getValidInterval, 2), cormin = _getValidInterval2[0], cormax = _getValidInterval2[1];
    if (cormin === -Infinity || cormax === Infinity) {
        var _values = cormax === Infinity ? [
            cormin
        ].concat($1f2680d726e2bea7$var$_toConsumableArray((0, $2fbe53d0c4c2ac3c$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return Infinity;
        }))) : [].concat($1f2680d726e2bea7$var$_toConsumableArray((0, $2fbe53d0c4c2ac3c$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return -Infinity;
        })), [
            cormax
        ]);
        return min > max ? (0, $2fbe53d0c4c2ac3c$export$66c1ae025e96b4bc)(_values) : _values;
    }
    if (cormin === cormax) return $1f2680d726e2bea7$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
     // Get the step between two ticks
    var _calculateStep = $1f2680d726e2bea7$var$calculateStep(cormin, cormax, count, allowDecimals), step = _calculateStep.step, tickMin = _calculateStep.tickMin, tickMax = _calculateStep.tickMax;
    var values = (0, $b78b2edce2cf6226$export$2e2bcd8739ae039).rangeStep(tickMin, tickMax.add(new (0, (/*@__PURE__*/$parcel$interopDefault($79fd56627fdb23c6$exports)))(0.1).mul(step)), step);
    return min > max ? (0, $2fbe53d0c4c2ac3c$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $1f2680d726e2bea7$var$getTickValuesFn(_ref5) {
    var _ref6 = $1f2680d726e2bea7$var$_slicedToArray(_ref5, 2), min = _ref6[0], max = _ref6[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval3 = $1f2680d726e2bea7$var$getValidInterval([
        min,
        max
    ]), _getValidInterval4 = $1f2680d726e2bea7$var$_slicedToArray(_getValidInterval3, 2), cormin = _getValidInterval4[0], cormax = _getValidInterval4[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return $1f2680d726e2bea7$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
    var step = $1f2680d726e2bea7$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($79fd56627fdb23c6$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var fn = (0, $2fbe53d0c4c2ac3c$export$f672e0b6f7222cd7)((0, $2fbe53d0c4c2ac3c$export$871de8747c9eaa88)(function(n) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($79fd56627fdb23c6$exports)))(cormin).add(new (0, (/*@__PURE__*/$parcel$interopDefault($79fd56627fdb23c6$exports)))(n).mul(step)).toNumber();
    }), (0, $2fbe53d0c4c2ac3c$export$d02631cccf789723));
    var values = fn(0, count).filter(function(entry) {
        return entry >= cormin && entry <= cormax;
    });
    return min > max ? (0, $2fbe53d0c4c2ac3c$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
 * but the domain will be guaranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $1f2680d726e2bea7$var$getTickValuesFixedDomainFn(_ref7, tickCount) {
    var _ref8 = $1f2680d726e2bea7$var$_slicedToArray(_ref7, 2), min = _ref8[0], max = _ref8[1];
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var _getValidInterval5 = $1f2680d726e2bea7$var$getValidInterval([
        min,
        max
    ]), _getValidInterval6 = $1f2680d726e2bea7$var$_slicedToArray(_getValidInterval5, 2), cormin = _getValidInterval6[0], cormax = _getValidInterval6[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return [
        cormin
    ];
    var count = Math.max(tickCount, 2);
    var step = $1f2680d726e2bea7$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($79fd56627fdb23c6$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var values = [].concat($1f2680d726e2bea7$var$_toConsumableArray((0, $b78b2edce2cf6226$export$2e2bcd8739ae039).rangeStep(new (0, (/*@__PURE__*/$parcel$interopDefault($79fd56627fdb23c6$exports)))(cormin), new (0, (/*@__PURE__*/$parcel$interopDefault($79fd56627fdb23c6$exports)))(cormax).sub(new (0, (/*@__PURE__*/$parcel$interopDefault($79fd56627fdb23c6$exports)))(0.99).mul(step)), step)), [
        cormax
    ]);
    return min > max ? (0, $2fbe53d0c4c2ac3c$export$66c1ae025e96b4bc)(values) : values;
}
var $1f2680d726e2bea7$export$b84e75ccbfe6a612 = (0, $2fbe53d0c4c2ac3c$export$fc10aeed3a532e2a)($1f2680d726e2bea7$var$getNiceTickValuesFn);
var $1f2680d726e2bea7$export$4cc7a216492b1f53 = (0, $2fbe53d0c4c2ac3c$export$fc10aeed3a532e2a)($1f2680d726e2bea7$var$getTickValuesFn);
var $1f2680d726e2bea7$export$e9d28da780436e98 = (0, $2fbe53d0c4c2ac3c$export$fc10aeed3a532e2a)($1f2680d726e2bea7$var$getTickValuesFixedDomainFn);




var $2a153db2e34e7246$exports = {};

$parcel$export($2a153db2e34e7246$exports, "scaleBand", function () { return $0b895cda4e30f0e1$export$2e2bcd8739ae039; });
$parcel$export($2a153db2e34e7246$exports, "scalePoint", function () { return $0b895cda4e30f0e1$export$105684a3041cb6f3; });
$parcel$export($2a153db2e34e7246$exports, "scaleIdentity", function () { return $e17a42f68f875eb9$export$2e2bcd8739ae039; });
$parcel$export($2a153db2e34e7246$exports, "scaleLinear", function () { return $169d6d8869618bf9$export$2e2bcd8739ae039; });
$parcel$export($2a153db2e34e7246$exports, "scaleLog", function () { return $f9bb92d942e4389b$export$2e2bcd8739ae039; });
$parcel$export($2a153db2e34e7246$exports, "scaleSymlog", function () { return $5193f5f8c08ac341$export$2e2bcd8739ae039; });
$parcel$export($2a153db2e34e7246$exports, "scaleOrdinal", function () { return $d324c18c95d5a424$export$2e2bcd8739ae039; });
$parcel$export($2a153db2e34e7246$exports, "scaleImplicit", function () { return $d324c18c95d5a424$export$e4f898ab14d9d460; });
$parcel$export($2a153db2e34e7246$exports, "scalePow", function () { return $83041545fdc0679f$export$2e2bcd8739ae039; });
$parcel$export($2a153db2e34e7246$exports, "scaleSqrt", function () { return $83041545fdc0679f$export$eba8049fb5020b81; });
$parcel$export($2a153db2e34e7246$exports, "scaleRadial", function () { return $88a0640abab6c81d$export$2e2bcd8739ae039; });
$parcel$export($2a153db2e34e7246$exports, "scaleQuantile", function () { return $81c508ce04cd748a$export$2e2bcd8739ae039; });
$parcel$export($2a153db2e34e7246$exports, "scaleQuantize", function () { return $7bcdfbf1257834a1$export$2e2bcd8739ae039; });
$parcel$export($2a153db2e34e7246$exports, "scaleThreshold", function () { return $c7b0262ed1e45914$export$2e2bcd8739ae039; });
$parcel$export($2a153db2e34e7246$exports, "scaleTime", function () { return $36fc7f9f89f3d633$export$2e2bcd8739ae039; });
$parcel$export($2a153db2e34e7246$exports, "scaleUtc", function () { return $e3b0fcaaa8d3a40a$export$2e2bcd8739ae039; });
$parcel$export($2a153db2e34e7246$exports, "scaleSequential", function () { return $c29a0481091d6b1b$export$2e2bcd8739ae039; });
$parcel$export($2a153db2e34e7246$exports, "scaleSequentialLog", function () { return $c29a0481091d6b1b$export$6843e08bf2ff981f; });
$parcel$export($2a153db2e34e7246$exports, "scaleSequentialPow", function () { return $c29a0481091d6b1b$export$de9f78581b4f2405; });
$parcel$export($2a153db2e34e7246$exports, "scaleSequentialSqrt", function () { return $c29a0481091d6b1b$export$413d935127ed466e; });
$parcel$export($2a153db2e34e7246$exports, "scaleSequentialSymlog", function () { return $c29a0481091d6b1b$export$9d4af4de62c81941; });
$parcel$export($2a153db2e34e7246$exports, "scaleSequentialQuantile", function () { return $14b580239d2d0636$export$2e2bcd8739ae039; });
$parcel$export($2a153db2e34e7246$exports, "scaleDiverging", function () { return $488d3280fe5e7c1c$export$2e2bcd8739ae039; });
$parcel$export($2a153db2e34e7246$exports, "scaleDivergingLog", function () { return $488d3280fe5e7c1c$export$5f0266a9159c47fb; });
$parcel$export($2a153db2e34e7246$exports, "scaleDivergingPow", function () { return $488d3280fe5e7c1c$export$d6cedcc63bf26e7e; });
$parcel$export($2a153db2e34e7246$exports, "scaleDivergingSqrt", function () { return $488d3280fe5e7c1c$export$33ddefb5c4ab9e9c; });
$parcel$export($2a153db2e34e7246$exports, "scaleDivergingSymlog", function () { return $488d3280fe5e7c1c$export$50b3da713cf557c6; });
$parcel$export($2a153db2e34e7246$exports, "tickFormat", function () { return $64bc5e2dcac4f33e$export$2e2bcd8739ae039; });
function $91f47b10949ad070$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}


function $94aa5673c1c16071$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $94aa5673c1c16071$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}


class $7f671ae147456b1d$export$dcc6fb7d82b5bc7b extends Map {
    constructor(entries, key = $7f671ae147456b1d$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($7f671ae147456b1d$var$intern_get(this, key));
    }
    has(key) {
        return super.has($7f671ae147456b1d$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($7f671ae147456b1d$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($7f671ae147456b1d$var$intern_delete(this, key));
    }
}
class $7f671ae147456b1d$export$55278c3294239828 extends Set {
    constructor(values, key = $7f671ae147456b1d$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($7f671ae147456b1d$var$intern_get(this, value));
    }
    add(value) {
        return super.add($7f671ae147456b1d$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($7f671ae147456b1d$var$intern_delete(this, value));
    }
}
function $7f671ae147456b1d$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $7f671ae147456b1d$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $7f671ae147456b1d$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(value);
        _intern.delete(key);
    }
    return value;
}
function $7f671ae147456b1d$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}



const $d324c18c95d5a424$export$e4f898ab14d9d460 = Symbol("implicit");
function $d324c18c95d5a424$export$2e2bcd8739ae039() {
    var index = new (0, $7f671ae147456b1d$export$dcc6fb7d82b5bc7b)(), domain = [], range = [], unknown = $d324c18c95d5a424$export$e4f898ab14d9d460;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $d324c18c95d5a424$export$e4f898ab14d9d460) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new (0, $7f671ae147456b1d$export$dcc6fb7d82b5bc7b)();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $d324c18c95d5a424$export$2e2bcd8739ae039(domain, range).unknown(unknown);
    };
    (0, $94aa5673c1c16071$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}


function $0b895cda4e30f0e1$export$2e2bcd8739ae039() {
    var scale = (0, $d324c18c95d5a424$export$2e2bcd8739ae039)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $91f47b10949ad070$export$2e2bcd8739ae039)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $0b895cda4e30f0e1$export$2e2bcd8739ae039(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, $94aa5673c1c16071$export$23c7bb9e6558da2a).apply(rescale(), arguments);
}
function $0b895cda4e30f0e1$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $0b895cda4e30f0e1$var$pointish(copy());
    };
    return scale;
}
function $0b895cda4e30f0e1$export$105684a3041cb6f3() {
    return $0b895cda4e30f0e1$var$pointish($0b895cda4e30f0e1$export$2e2bcd8739ae039.apply(null, arguments).paddingInner(1));
}


var $2035de1f98672e25$var$e10 = Math.sqrt(50), $2035de1f98672e25$var$e5 = Math.sqrt(10), $2035de1f98672e25$var$e2 = Math.sqrt(2);
function $2035de1f98672e25$export$2e2bcd8739ae039(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $2035de1f98672e25$export$bc64d00cc98e7e95(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $2035de1f98672e25$export$bc64d00cc98e7e95(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $2035de1f98672e25$var$e10 ? 10 : error >= $2035de1f98672e25$var$e5 ? 5 : error >= $2035de1f98672e25$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $2035de1f98672e25$var$e10 ? 10 : error >= $2035de1f98672e25$var$e5 ? 5 : error >= $2035de1f98672e25$var$e2 ? 2 : 1);
}
function $2035de1f98672e25$export$81087d9b915d4ede(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $2035de1f98672e25$var$e10) step1 *= 10;
    else if (error >= $2035de1f98672e25$var$e5) step1 *= 5;
    else if (error >= $2035de1f98672e25$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}


function $3bc99fb33e254efb$export$2e2bcd8739ae039(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}



function $1492a8fafc0d8313$export$2e2bcd8739ae039(f) {
    let delta = f;
    let compare = f;
    if (f.length === 1) {
        delta = (d, x)=>f(d) - x;
        compare = $1492a8fafc0d8313$var$ascendingComparator(f);
    }
    function left(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        while(lo < hi){
            const mid = lo + hi >>> 1;
            if (compare(a[mid], x) < 0) lo = mid + 1;
            else hi = mid;
        }
        return lo;
    }
    function right(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        while(lo < hi){
            const mid = lo + hi >>> 1;
            if (compare(a[mid], x) > 0) hi = mid;
            else lo = mid + 1;
        }
        return lo;
    }
    function center(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $1492a8fafc0d8313$var$ascendingComparator(f) {
    return (d, x)=>(0, $3bc99fb33e254efb$export$2e2bcd8739ae039)(f(d), x);
}


function $4a71a8764f9f56e3$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $4a71a8764f9f56e3$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}


const $7945de4765468759$var$ascendingBisect = (0, $1492a8fafc0d8313$export$2e2bcd8739ae039)((0, $3bc99fb33e254efb$export$2e2bcd8739ae039));
const $7945de4765468759$export$4d945ad3ad5751b0 = $7945de4765468759$var$ascendingBisect.right;
const $7945de4765468759$export$df7d25c84ebd12a5 = $7945de4765468759$var$ascendingBisect.left;
const $7945de4765468759$export$c1cb828b1117c77b = (0, $1492a8fafc0d8313$export$2e2bcd8739ae039)((0, $4a71a8764f9f56e3$export$2e2bcd8739ae039)).center;
var $7945de4765468759$export$2e2bcd8739ae039 = $7945de4765468759$export$4d945ad3ad5751b0;


function $fd5c2c456bec3d89$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $fd5c2c456bec3d89$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}


function $5d84686920f76643$export$892596cec99bc70e() {}
var $5d84686920f76643$export$4adafc6ed0600c10 = 0.7;
var $5d84686920f76643$export$9eace2cc0d12c98d = 1 / $5d84686920f76643$export$4adafc6ed0600c10;
var $5d84686920f76643$var$reI = "\\s*([+-]?\\d+)\\s*", $5d84686920f76643$var$reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", $5d84686920f76643$var$reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", $5d84686920f76643$var$reHex = /^#([0-9a-f]{3,8})$/, $5d84686920f76643$var$reRgbInteger = new RegExp("^rgb\\(" + [
    $5d84686920f76643$var$reI,
    $5d84686920f76643$var$reI,
    $5d84686920f76643$var$reI
] + "\\)$"), $5d84686920f76643$var$reRgbPercent = new RegExp("^rgb\\(" + [
    $5d84686920f76643$var$reP,
    $5d84686920f76643$var$reP,
    $5d84686920f76643$var$reP
] + "\\)$"), $5d84686920f76643$var$reRgbaInteger = new RegExp("^rgba\\(" + [
    $5d84686920f76643$var$reI,
    $5d84686920f76643$var$reI,
    $5d84686920f76643$var$reI,
    $5d84686920f76643$var$reN
] + "\\)$"), $5d84686920f76643$var$reRgbaPercent = new RegExp("^rgba\\(" + [
    $5d84686920f76643$var$reP,
    $5d84686920f76643$var$reP,
    $5d84686920f76643$var$reP,
    $5d84686920f76643$var$reN
] + "\\)$"), $5d84686920f76643$var$reHslPercent = new RegExp("^hsl\\(" + [
    $5d84686920f76643$var$reN,
    $5d84686920f76643$var$reP,
    $5d84686920f76643$var$reP
] + "\\)$"), $5d84686920f76643$var$reHslaPercent = new RegExp("^hsla\\(" + [
    $5d84686920f76643$var$reN,
    $5d84686920f76643$var$reP,
    $5d84686920f76643$var$reP,
    $5d84686920f76643$var$reN
] + "\\)$");
var $5d84686920f76643$var$named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $fd5c2c456bec3d89$export$2e2bcd8739ae039)($5d84686920f76643$export$892596cec99bc70e, $5d84686920f76643$export$2e2bcd8739ae039, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: $5d84686920f76643$var$color_formatHex,
    formatHex: $5d84686920f76643$var$color_formatHex,
    formatHsl: $5d84686920f76643$var$color_formatHsl,
    formatRgb: $5d84686920f76643$var$color_formatRgb,
    toString: $5d84686920f76643$var$color_formatRgb
});
function $5d84686920f76643$var$color_formatHex() {
    return this.rgb().formatHex();
}
function $5d84686920f76643$var$color_formatHsl() {
    return $5d84686920f76643$export$8133dc3fa904d6d1(this).formatHsl();
}
function $5d84686920f76643$var$color_formatRgb() {
    return this.rgb().formatRgb();
}
function $5d84686920f76643$export$2e2bcd8739ae039(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = $5d84686920f76643$var$reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? $5d84686920f76643$var$rgbn(m) // #ff0000
     : l === 3 ? new $5d84686920f76643$export$5e05a94393ac29e3(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? $5d84686920f76643$var$rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? $5d84686920f76643$var$rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = $5d84686920f76643$var$reRgbInteger.exec(format)) ? new $5d84686920f76643$export$5e05a94393ac29e3(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = $5d84686920f76643$var$reRgbPercent.exec(format)) ? new $5d84686920f76643$export$5e05a94393ac29e3(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = $5d84686920f76643$var$reRgbaInteger.exec(format)) ? $5d84686920f76643$var$rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = $5d84686920f76643$var$reRgbaPercent.exec(format)) ? $5d84686920f76643$var$rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = $5d84686920f76643$var$reHslPercent.exec(format)) ? $5d84686920f76643$var$hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = $5d84686920f76643$var$reHslaPercent.exec(format)) ? $5d84686920f76643$var$hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : $5d84686920f76643$var$named.hasOwnProperty(format) ? $5d84686920f76643$var$rgbn($5d84686920f76643$var$named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new $5d84686920f76643$export$5e05a94393ac29e3(NaN, NaN, NaN, 0) : null;
}
function $5d84686920f76643$var$rgbn(n) {
    return new $5d84686920f76643$export$5e05a94393ac29e3(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function $5d84686920f76643$var$rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new $5d84686920f76643$export$5e05a94393ac29e3(r, g, b, a);
}
function $5d84686920f76643$export$42da0a331c2802f5(o) {
    if (!(o instanceof $5d84686920f76643$export$892596cec99bc70e)) o = $5d84686920f76643$export$2e2bcd8739ae039(o);
    if (!o) return new $5d84686920f76643$export$5e05a94393ac29e3;
    o = o.rgb();
    return new $5d84686920f76643$export$5e05a94393ac29e3(o.r, o.g, o.b, o.opacity);
}
function $5d84686920f76643$export$8972dc0e6ad9238f(r, g, b, opacity) {
    return arguments.length === 1 ? $5d84686920f76643$export$42da0a331c2802f5(r) : new $5d84686920f76643$export$5e05a94393ac29e3(r, g, b, opacity == null ? 1 : opacity);
}
function $5d84686920f76643$export$5e05a94393ac29e3(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $fd5c2c456bec3d89$export$2e2bcd8739ae039)($5d84686920f76643$export$5e05a94393ac29e3, $5d84686920f76643$export$8972dc0e6ad9238f, (0, $fd5c2c456bec3d89$export$8b58be045bf06082)($5d84686920f76643$export$892596cec99bc70e, {
    brighter: function(k) {
        k = k == null ? $5d84686920f76643$export$9eace2cc0d12c98d : Math.pow($5d84686920f76643$export$9eace2cc0d12c98d, k);
        return new $5d84686920f76643$export$5e05a94393ac29e3(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? $5d84686920f76643$export$4adafc6ed0600c10 : Math.pow($5d84686920f76643$export$4adafc6ed0600c10, k);
        return new $5d84686920f76643$export$5e05a94393ac29e3(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: $5d84686920f76643$var$rgb_formatHex,
    formatHex: $5d84686920f76643$var$rgb_formatHex,
    formatRgb: $5d84686920f76643$var$rgb_formatRgb,
    toString: $5d84686920f76643$var$rgb_formatRgb
}));
function $5d84686920f76643$var$rgb_formatHex() {
    return "#" + $5d84686920f76643$var$hex(this.r) + $5d84686920f76643$var$hex(this.g) + $5d84686920f76643$var$hex(this.b);
}
function $5d84686920f76643$var$rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function $5d84686920f76643$var$hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function $5d84686920f76643$var$hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new $5d84686920f76643$var$Hsl(h, s, l, a);
}
function $5d84686920f76643$export$8133dc3fa904d6d1(o) {
    if (o instanceof $5d84686920f76643$var$Hsl) return new $5d84686920f76643$var$Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof $5d84686920f76643$export$892596cec99bc70e)) o = $5d84686920f76643$export$2e2bcd8739ae039(o);
    if (!o) return new $5d84686920f76643$var$Hsl;
    if (o instanceof $5d84686920f76643$var$Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new $5d84686920f76643$var$Hsl(h, s, l, o.opacity);
}
function $5d84686920f76643$export$8f4a7c0bb78e6ea8(h, s, l, opacity) {
    return arguments.length === 1 ? $5d84686920f76643$export$8133dc3fa904d6d1(h) : new $5d84686920f76643$var$Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function $5d84686920f76643$var$Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $fd5c2c456bec3d89$export$2e2bcd8739ae039)($5d84686920f76643$var$Hsl, $5d84686920f76643$export$8f4a7c0bb78e6ea8, (0, $fd5c2c456bec3d89$export$8b58be045bf06082)($5d84686920f76643$export$892596cec99bc70e, {
    brighter: function(k) {
        k = k == null ? $5d84686920f76643$export$9eace2cc0d12c98d : Math.pow($5d84686920f76643$export$9eace2cc0d12c98d, k);
        return new $5d84686920f76643$var$Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? $5d84686920f76643$export$4adafc6ed0600c10 : Math.pow($5d84686920f76643$export$4adafc6ed0600c10, k);
        return new $5d84686920f76643$var$Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new $5d84686920f76643$export$5e05a94393ac29e3($5d84686920f76643$var$hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), $5d84686920f76643$var$hsl2rgb(h, m1, m2), $5d84686920f76643$var$hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function $5d84686920f76643$var$hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}



function $b4b28090ad2dcce1$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $b4b28090ad2dcce1$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $b4b28090ad2dcce1$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}



function $a70988656816d4a8$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $b4b28090ad2dcce1$export$4e41033bfeec1a4c)((t - i / n) * n, v0, v1, v2, v3);
    };
}


var $6f6cd89fee58693f$export$2e2bcd8739ae039 = (x)=>()=>x;


function $747b7aa10f22c0ea$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $747b7aa10f22c0ea$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $747b7aa10f22c0ea$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $747b7aa10f22c0ea$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $6f6cd89fee58693f$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $747b7aa10f22c0ea$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $747b7aa10f22c0ea$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $747b7aa10f22c0ea$var$exponential(a, b, y) : (0, $6f6cd89fee58693f$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $747b7aa10f22c0ea$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $747b7aa10f22c0ea$var$linear(a, d) : (0, $6f6cd89fee58693f$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


var $599214888dc9d27e$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $747b7aa10f22c0ea$export$a7ebe8cc6aaf8d37)(y);
    function rgb(start, end) {
        var r = color((start = (0, $5d84686920f76643$export$8972dc0e6ad9238f)(start)).r, (end = (0, $5d84686920f76643$export$8972dc0e6ad9238f)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $747b7aa10f22c0ea$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $599214888dc9d27e$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $5d84686920f76643$export$8972dc0e6ad9238f)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $599214888dc9d27e$export$2c0e28f2e2852d3f = $599214888dc9d27e$var$rgbSpline((0, $b4b28090ad2dcce1$export$2e2bcd8739ae039));
var $599214888dc9d27e$export$53d5214f625ccd4c = $599214888dc9d27e$var$rgbSpline((0, $a70988656816d4a8$export$2e2bcd8739ae039));



function $04946bcc8f3b7f87$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $04946bcc8f3b7f87$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}


function $801b7c5960245d09$export$2e2bcd8739ae039(a, b) {
    return ((0, $04946bcc8f3b7f87$export$5cd576d1827d40c8)(b) ? (0, $04946bcc8f3b7f87$export$2e2bcd8739ae039) : $801b7c5960245d09$export$15d09067c6a5ee49)(a, b);
}
function $801b7c5960245d09$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $b21d994aaa3dc663$export$2e2bcd8739ae039)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}


function $9de18e981298a83c$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}


function $56a714091b0601c5$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}



function $964341890439b869$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $b21d994aaa3dc663$export$2e2bcd8739ae039)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}



var $2ee36419503dbbf3$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $2ee36419503dbbf3$var$reB = new RegExp($2ee36419503dbbf3$var$reA.source, "g");
function $2ee36419503dbbf3$var$zero(b) {
    return function() {
        return b;
    };
}
function $2ee36419503dbbf3$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $2ee36419503dbbf3$export$2e2bcd8739ae039(a, b) {
    var bi = $2ee36419503dbbf3$var$reA.lastIndex = $2ee36419503dbbf3$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $2ee36419503dbbf3$var$reA.exec(a)) && (bm = $2ee36419503dbbf3$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $56a714091b0601c5$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $2ee36419503dbbf3$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $2ee36419503dbbf3$var$one(q[0].x) : $2ee36419503dbbf3$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}




function $b21d994aaa3dc663$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $6f6cd89fee58693f$export$2e2bcd8739ae039)(b) : (t === "number" ? (0, $56a714091b0601c5$export$2e2bcd8739ae039) : t === "string" ? (c = (0, $5d84686920f76643$export$2e2bcd8739ae039)(b)) ? (b = c, $599214888dc9d27e$export$2e2bcd8739ae039) : (0, $2ee36419503dbbf3$export$2e2bcd8739ae039) : b instanceof (0, $5d84686920f76643$export$2e2bcd8739ae039) ? (0, $599214888dc9d27e$export$2e2bcd8739ae039) : b instanceof Date ? (0, $9de18e981298a83c$export$2e2bcd8739ae039) : (0, $04946bcc8f3b7f87$export$5cd576d1827d40c8)(b) ? (0, $04946bcc8f3b7f87$export$2e2bcd8739ae039) : Array.isArray(b) ? (0, $801b7c5960245d09$export$15d09067c6a5ee49) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $964341890439b869$export$2e2bcd8739ae039) : (0, $56a714091b0601c5$export$2e2bcd8739ae039))(a, b);
}

function $74137ec733484977$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}


function $8984e585e0a29229$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $24f072011f99fb95$export$2e2bcd8739ae039(x) {
    return +x;
}


var $70c8ed888851cd4a$var$unit = [
    0,
    1
];
function $70c8ed888851cd4a$export$f0954fd7d5368655(x) {
    return x;
}
function $70c8ed888851cd4a$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $8984e585e0a29229$export$2e2bcd8739ae039)(isNaN(b) ? NaN : 0.5);
}
function $70c8ed888851cd4a$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $70c8ed888851cd4a$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $70c8ed888851cd4a$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $70c8ed888851cd4a$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $70c8ed888851cd4a$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $70c8ed888851cd4a$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $7945de4765468759$export$2e2bcd8739ae039)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $70c8ed888851cd4a$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $70c8ed888851cd4a$export$6b468dcfb64c653c() {
    var domain = $70c8ed888851cd4a$var$unit, range = $70c8ed888851cd4a$var$unit, interpolate = (0, $b21d994aaa3dc663$export$2e2bcd8739ae039), transform, untransform, unknown, clamp = $70c8ed888851cd4a$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $70c8ed888851cd4a$export$f0954fd7d5368655) clamp = $70c8ed888851cd4a$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $70c8ed888851cd4a$var$polymap : $70c8ed888851cd4a$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $56a714091b0601c5$export$2e2bcd8739ae039))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $24f072011f99fb95$export$2e2bcd8739ae039)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, $74137ec733484977$export$2e2bcd8739ae039), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $70c8ed888851cd4a$export$f0954fd7d5368655, rescale()) : clamp !== $70c8ed888851cd4a$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $70c8ed888851cd4a$export$2e2bcd8739ae039() {
    return $70c8ed888851cd4a$export$6b468dcfb64c653c()($70c8ed888851cd4a$export$f0954fd7d5368655, $70c8ed888851cd4a$export$f0954fd7d5368655);
}




function $d902c822138593d7$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $d902c822138593d7$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}


function $3ee10a3fcd8e2314$export$2e2bcd8739ae039(x) {
    return x = (0, $d902c822138593d7$export$8f8e23dd27dc19f5)(Math.abs(x)), x ? x[1] : NaN;
}


function $9c8a1de5b84d46e1$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}


function $f43ce26ebf505810$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}


// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $f5c6bbfee3f0b796$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $f5c6bbfee3f0b796$export$2e2bcd8739ae039(specifier) {
    if (!(match = $f5c6bbfee3f0b796$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $f5c6bbfee3f0b796$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$f5c6bbfee3f0b796$export$2e2bcd8739ae039.prototype = $f5c6bbfee3f0b796$export$963aac351db36ed4.prototype; // instanceof
function $f5c6bbfee3f0b796$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$f5c6bbfee3f0b796$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};


// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $de603ffdf256a408$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}




var $ad55f8a0efc07e83$export$6863724d9a42263;
function $ad55f8a0efc07e83$export$2e2bcd8739ae039(x, p) {
    var d = (0, $d902c822138593d7$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($ad55f8a0efc07e83$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $d902c822138593d7$export$8f8e23dd27dc19f5)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}



function $f08f7949c2363782$export$2e2bcd8739ae039(x, p) {
    var d = (0, $d902c822138593d7$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}


var $9fd173d8e399746c$export$2e2bcd8739ae039 = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, $d902c822138593d7$export$2e2bcd8739ae039),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $f08f7949c2363782$export$2e2bcd8739ae039)(x * 100, p),
    "r": (0, $f08f7949c2363782$export$2e2bcd8739ae039),
    "s": (0, $ad55f8a0efc07e83$export$2e2bcd8739ae039),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};



function $0b30021f61cb5eb2$export$2e2bcd8739ae039(x) {
    return x;
}


var $bae4e694f25aafc9$var$map = Array.prototype.map, $bae4e694f25aafc9$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $bae4e694f25aafc9$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $0b30021f61cb5eb2$export$2e2bcd8739ae039) : (0, $9c8a1de5b84d46e1$export$2e2bcd8739ae039)($bae4e694f25aafc9$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $0b30021f61cb5eb2$export$2e2bcd8739ae039) : (0, $f43ce26ebf505810$export$2e2bcd8739ae039)($bae4e694f25aafc9$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "−" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $f5c6bbfee3f0b796$export$2e2bcd8739ae039)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $9fd173d8e399746c$export$2e2bcd8739ae039)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $9fd173d8e399746c$export$2e2bcd8739ae039)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $de603ffdf256a408$export$2e2bcd8739ae039)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $bae4e694f25aafc9$var$prefixes[8 + (0, $ad55f8a0efc07e83$export$6863724d9a42263) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $f5c6bbfee3f0b796$export$2e2bcd8739ae039)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $3ee10a3fcd8e2314$export$2e2bcd8739ae039)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $bae4e694f25aafc9$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}


var $0de95ec22632d502$var$locale;
var $0de95ec22632d502$export$d9468344d3651243;
var $0de95ec22632d502$export$8d85692a469dde6f;
$0de95ec22632d502$export$2e2bcd8739ae039({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $0de95ec22632d502$export$2e2bcd8739ae039(definition) {
    $0de95ec22632d502$var$locale = (0, $bae4e694f25aafc9$export$2e2bcd8739ae039)(definition);
    $0de95ec22632d502$export$d9468344d3651243 = $0de95ec22632d502$var$locale.format;
    $0de95ec22632d502$export$8d85692a469dde6f = $0de95ec22632d502$var$locale.formatPrefix;
    return $0de95ec22632d502$var$locale;
}


function $df16b9d755436b65$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $3ee10a3fcd8e2314$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $69ec0ff6c0262c64$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $3ee10a3fcd8e2314$export$2e2bcd8739ae039)(value) / 3))) * 3 - (0, $3ee10a3fcd8e2314$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $63bc1fa3529242eb$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $3ee10a3fcd8e2314$export$2e2bcd8739ae039)(max) - (0, $3ee10a3fcd8e2314$export$2e2bcd8739ae039)(step)) + 1;
}


function $64bc5e2dcac4f33e$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $2035de1f98672e25$export$81087d9b915d4ede)(start, stop, count), precision;
    specifier = (0, $f5c6bbfee3f0b796$export$2e2bcd8739ae039)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $69ec0ff6c0262c64$export$2e2bcd8739ae039)(step, value))) specifier.precision = precision;
            return (0, $0de95ec22632d502$export$8d85692a469dde6f)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $63bc1fa3529242eb$export$2e2bcd8739ae039)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $df16b9d755436b65$export$2e2bcd8739ae039)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $0de95ec22632d502$export$d9468344d3651243)(specifier);
}


function $169d6d8869618bf9$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $2035de1f98672e25$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $64bc5e2dcac4f33e$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $2035de1f98672e25$export$bc64d00cc98e7e95)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $169d6d8869618bf9$export$2e2bcd8739ae039() {
    var scale = (0, $70c8ed888851cd4a$export$2e2bcd8739ae039)();
    scale.copy = function() {
        return (0, $70c8ed888851cd4a$export$784d13d8ee351f07)(scale, $169d6d8869618bf9$export$2e2bcd8739ae039());
    };
    (0, $94aa5673c1c16071$export$23c7bb9e6558da2a).apply(scale, arguments);
    return $169d6d8869618bf9$export$16a5d4b4a61a274d(scale);
}



function $e17a42f68f875eb9$export$2e2bcd8739ae039(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $24f072011f99fb95$export$2e2bcd8739ae039)), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $e17a42f68f875eb9$export$2e2bcd8739ae039(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, (0, $24f072011f99fb95$export$2e2bcd8739ae039)) : [
        0,
        1
    ];
    return (0, $169d6d8869618bf9$export$16a5d4b4a61a274d)(scale);
}





function $b383b6cffa77f8f0$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}




function $f9bb92d942e4389b$var$transformLog(x) {
    return Math.log(x);
}
function $f9bb92d942e4389b$var$transformExp(x) {
    return Math.exp(x);
}
function $f9bb92d942e4389b$var$transformLogn(x) {
    return -Math.log(-x);
}
function $f9bb92d942e4389b$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $f9bb92d942e4389b$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $f9bb92d942e4389b$var$powp(base) {
    return base === 10 ? $f9bb92d942e4389b$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $f9bb92d942e4389b$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $f9bb92d942e4389b$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $f9bb92d942e4389b$export$860836db074028f0(transform) {
    const scale = transform($f9bb92d942e4389b$var$transformLog, $f9bb92d942e4389b$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $f9bb92d942e4389b$var$logp(base), pows = $f9bb92d942e4389b$var$powp(base);
        if (domain()[0] < 0) {
            logs = $f9bb92d942e4389b$var$reflect(logs), pows = $f9bb92d942e4389b$var$reflect(pows);
            transform($f9bb92d942e4389b$var$transformLogn, $f9bb92d942e4389b$var$transformExpn);
        } else transform($f9bb92d942e4389b$var$transformLog, $f9bb92d942e4389b$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $2035de1f98672e25$export$2e2bcd8739ae039)(u, v, n);
        } else z = (0, $2035de1f98672e25$export$2e2bcd8739ae039)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $f5c6bbfee3f0b796$export$2e2bcd8739ae039)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $0de95ec22632d502$export$d9468344d3651243)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $b383b6cffa77f8f0$export$2e2bcd8739ae039)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $f9bb92d942e4389b$export$2e2bcd8739ae039() {
    const scale = $f9bb92d942e4389b$export$860836db074028f0((0, $70c8ed888851cd4a$export$6b468dcfb64c653c)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $70c8ed888851cd4a$export$784d13d8ee351f07)(scale, $f9bb92d942e4389b$export$2e2bcd8739ae039()).base(scale.base());
    (0, $94aa5673c1c16071$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}





function $5193f5f8c08ac341$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $5193f5f8c08ac341$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $5193f5f8c08ac341$export$4602684e614eba38(transform) {
    var c = 1, scale = transform($5193f5f8c08ac341$var$transformSymlog(c), $5193f5f8c08ac341$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($5193f5f8c08ac341$var$transformSymlog(c = +_), $5193f5f8c08ac341$var$transformSymexp(c)) : c;
    };
    return (0, $169d6d8869618bf9$export$16a5d4b4a61a274d)(scale);
}
function $5193f5f8c08ac341$export$2e2bcd8739ae039() {
    var scale = $5193f5f8c08ac341$export$4602684e614eba38((0, $70c8ed888851cd4a$export$6b468dcfb64c653c)());
    scale.copy = function() {
        return (0, $70c8ed888851cd4a$export$784d13d8ee351f07)(scale, $5193f5f8c08ac341$export$2e2bcd8739ae039()).constant(scale.constant());
    };
    return (0, $94aa5673c1c16071$export$23c7bb9e6558da2a).apply(scale, arguments);
}






function $83041545fdc0679f$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $83041545fdc0679f$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $83041545fdc0679f$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $83041545fdc0679f$export$34695211ec403a46(transform) {
    var scale = transform((0, $70c8ed888851cd4a$export$f0954fd7d5368655), (0, $70c8ed888851cd4a$export$f0954fd7d5368655)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, $70c8ed888851cd4a$export$f0954fd7d5368655), (0, $70c8ed888851cd4a$export$f0954fd7d5368655)) : exponent === 0.5 ? transform($83041545fdc0679f$var$transformSqrt, $83041545fdc0679f$var$transformSquare) : transform($83041545fdc0679f$var$transformPow(exponent), $83041545fdc0679f$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $169d6d8869618bf9$export$16a5d4b4a61a274d)(scale);
}
function $83041545fdc0679f$export$2e2bcd8739ae039() {
    var scale = $83041545fdc0679f$export$34695211ec403a46((0, $70c8ed888851cd4a$export$6b468dcfb64c653c)());
    scale.copy = function() {
        return (0, $70c8ed888851cd4a$export$784d13d8ee351f07)(scale, $83041545fdc0679f$export$2e2bcd8739ae039()).exponent(scale.exponent());
    };
    (0, $94aa5673c1c16071$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}
function $83041545fdc0679f$export$eba8049fb5020b81() {
    return $83041545fdc0679f$export$2e2bcd8739ae039.apply(null, arguments).exponent(0.5);
}






function $88a0640abab6c81d$var$square(x) {
    return Math.sign(x) * x * x;
}
function $88a0640abab6c81d$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $88a0640abab6c81d$export$2e2bcd8739ae039() {
    var squared = (0, $70c8ed888851cd4a$export$2e2bcd8739ae039)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $88a0640abab6c81d$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($88a0640abab6c81d$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, (0, $24f072011f99fb95$export$2e2bcd8739ae039))).map($88a0640abab6c81d$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $88a0640abab6c81d$export$2e2bcd8739ae039(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    (0, $94aa5673c1c16071$export$23c7bb9e6558da2a).apply(scale, arguments);
    return (0, $169d6d8869618bf9$export$16a5d4b4a61a274d)(scale);
}


function $e0a759d31c93051f$export$2e2bcd8739ae039(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}


function $9c4f6bd25d9bee00$export$2e2bcd8739ae039(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}



function $ac412316855af093$export$2e2bcd8739ae039(array, k, left = 0, right = array.length - 1, compare = (0, $3bc99fb33e254efb$export$2e2bcd8739ae039)) {
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $ac412316855af093$export$2e2bcd8739ae039(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $ac412316855af093$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $ac412316855af093$var$swap(array, left, right);
        while(i < j){
            $ac412316855af093$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $ac412316855af093$var$swap(array, left, j);
        else ++j, $ac412316855af093$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $ac412316855af093$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}



function $fa3f54f7c13c7951$export$2e2bcd8739ae039(values, p, valueof) {
    values = Float64Array.from((0, $4a71a8764f9f56e3$export$1f6c9cc012ebacae)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, $9c4f6bd25d9bee00$export$2e2bcd8739ae039)(values);
    if (p >= 1) return (0, $e0a759d31c93051f$export$2e2bcd8739ae039)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $e0a759d31c93051f$export$2e2bcd8739ae039)((0, $ac412316855af093$export$2e2bcd8739ae039)(values, i0).subarray(0, i0 + 1)), value1 = (0, $9c4f6bd25d9bee00$export$2e2bcd8739ae039)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $fa3f54f7c13c7951$export$f924a6cad778dddb(values, p, valueof = (0, $4a71a8764f9f56e3$export$2e2bcd8739ae039)) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}



function $81c508ce04cd748a$export$2e2bcd8739ae039() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $fa3f54f7c13c7951$export$f924a6cad778dddb)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $7945de4765468759$export$2e2bcd8739ae039)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, $3bc99fb33e254efb$export$2e2bcd8739ae039));
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $81c508ce04cd748a$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return (0, $94aa5673c1c16071$export$23c7bb9e6558da2a).apply(scale, arguments);
}





function $7bcdfbf1257834a1$export$2e2bcd8739ae039() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $7945de4765468759$export$2e2bcd8739ae039)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $7bcdfbf1257834a1$export$2e2bcd8739ae039().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return (0, $94aa5673c1c16071$export$23c7bb9e6558da2a).apply((0, $169d6d8869618bf9$export$16a5d4b4a61a274d)(scale), arguments);
}




function $c7b0262ed1e45914$export$2e2bcd8739ae039() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $7945de4765468759$export$2e2bcd8739ae039)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $c7b0262ed1e45914$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return (0, $94aa5673c1c16071$export$23c7bb9e6558da2a).apply(scale, arguments);
}


var $8bccc6dea1985680$var$t0 = new Date, $8bccc6dea1985680$var$t1 = new Date;
function $8bccc6dea1985680$export$2e2bcd8739ae039(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $8bccc6dea1985680$export$2e2bcd8739ae039(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $8bccc6dea1985680$var$t0.setTime(+start), $8bccc6dea1985680$var$t1.setTime(+end);
            floori($8bccc6dea1985680$var$t0), floori($8bccc6dea1985680$var$t1);
            return Math.floor(count($8bccc6dea1985680$var$t0, $8bccc6dea1985680$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}


const $55b048591b959c61$export$79ef0e34099623dc = 1000;
const $55b048591b959c61$export$683905d551c33fa9 = $55b048591b959c61$export$79ef0e34099623dc * 60;
const $55b048591b959c61$export$4157bf0c8e241659 = $55b048591b959c61$export$683905d551c33fa9 * 60;
const $55b048591b959c61$export$353686095f4fbf45 = $55b048591b959c61$export$4157bf0c8e241659 * 24;
const $55b048591b959c61$export$c241eb88520d5016 = $55b048591b959c61$export$353686095f4fbf45 * 7;
const $55b048591b959c61$export$ab95684df7020b26 = $55b048591b959c61$export$353686095f4fbf45 * 30;
const $55b048591b959c61$export$61f8ee2d834c6959 = $55b048591b959c61$export$353686095f4fbf45 * 365;


var $e0d54857685ccd14$var$day = (0, $8bccc6dea1985680$export$2e2bcd8739ae039)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $55b048591b959c61$export$683905d551c33fa9)) / (0, $55b048591b959c61$export$353686095f4fbf45), (date)=>date.getDate() - 1);
var $e0d54857685ccd14$export$2e2bcd8739ae039 = $e0d54857685ccd14$var$day;
var $e0d54857685ccd14$export$3cf5dda4201cc0f2 = $e0d54857685ccd14$var$day.range;



var $102a119dc1147e89$var$hour = (0, $8bccc6dea1985680$export$2e2bcd8739ae039)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $55b048591b959c61$export$79ef0e34099623dc) - date.getMinutes() * (0, $55b048591b959c61$export$683905d551c33fa9));
}, function(date, step) {
    date.setTime(+date + step * (0, $55b048591b959c61$export$4157bf0c8e241659));
}, function(start, end) {
    return (end - start) / (0, $55b048591b959c61$export$4157bf0c8e241659);
}, function(date) {
    return date.getHours();
});
var $102a119dc1147e89$export$2e2bcd8739ae039 = $102a119dc1147e89$var$hour;
var $102a119dc1147e89$export$8d468796d69cdad1 = $102a119dc1147e89$var$hour.range;



var $b713a37733dec8d3$var$minute = (0, $8bccc6dea1985680$export$2e2bcd8739ae039)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $55b048591b959c61$export$79ef0e34099623dc));
}, function(date, step) {
    date.setTime(+date + step * (0, $55b048591b959c61$export$683905d551c33fa9));
}, function(start, end) {
    return (end - start) / (0, $55b048591b959c61$export$683905d551c33fa9);
}, function(date) {
    return date.getMinutes();
});
var $b713a37733dec8d3$export$2e2bcd8739ae039 = $b713a37733dec8d3$var$minute;
var $b713a37733dec8d3$export$666252b437cce0c7 = $b713a37733dec8d3$var$minute.range;


var $eee382891c0645de$var$month = (0, $8bccc6dea1985680$export$2e2bcd8739ae039)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $eee382891c0645de$export$2e2bcd8739ae039 = $eee382891c0645de$var$month;
var $eee382891c0645de$export$16352d1b10c5eb38 = $eee382891c0645de$var$month.range;



var $86de0affb39b7ade$var$second = (0, $8bccc6dea1985680$export$2e2bcd8739ae039)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * (0, $55b048591b959c61$export$79ef0e34099623dc));
}, function(start, end) {
    return (end - start) / (0, $55b048591b959c61$export$79ef0e34099623dc);
}, function(date) {
    return date.getUTCSeconds();
});
var $86de0affb39b7ade$export$2e2bcd8739ae039 = $86de0affb39b7ade$var$second;
var $86de0affb39b7ade$export$4792e48abc550fa1 = $86de0affb39b7ade$var$second.range;




var $671ad52e45c26ce3$var$millisecond = (0, $8bccc6dea1985680$export$2e2bcd8739ae039)(function() {
// noop
}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
});
// An optimized implementation for this simple case.
$671ad52e45c26ce3$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $671ad52e45c26ce3$var$millisecond;
    return (0, $8bccc6dea1985680$export$2e2bcd8739ae039)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $671ad52e45c26ce3$export$2e2bcd8739ae039 = $671ad52e45c26ce3$var$millisecond;
var $671ad52e45c26ce3$export$9a27fac83d67afd3 = $671ad52e45c26ce3$var$millisecond.range;








function $7cf239c7de9cb019$var$weekday(i) {
    return (0, $8bccc6dea1985680$export$2e2bcd8739ae039)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $55b048591b959c61$export$683905d551c33fa9)) / (0, $55b048591b959c61$export$c241eb88520d5016);
    });
}
var $7cf239c7de9cb019$export$fb3ee18ed410cc21 = $7cf239c7de9cb019$var$weekday(0);
var $7cf239c7de9cb019$export$6416afaab03bc9b8 = $7cf239c7de9cb019$var$weekday(1);
var $7cf239c7de9cb019$export$cb8f040f5d17ac7b = $7cf239c7de9cb019$var$weekday(2);
var $7cf239c7de9cb019$export$347581849975dfc8 = $7cf239c7de9cb019$var$weekday(3);
var $7cf239c7de9cb019$export$2f2b56683a3e5629 = $7cf239c7de9cb019$var$weekday(4);
var $7cf239c7de9cb019$export$59b8c2ccd931d806 = $7cf239c7de9cb019$var$weekday(5);
var $7cf239c7de9cb019$export$478ceadebff4d377 = $7cf239c7de9cb019$var$weekday(6);
var $7cf239c7de9cb019$export$e8daabaa40641211 = $7cf239c7de9cb019$export$fb3ee18ed410cc21.range;
var $7cf239c7de9cb019$export$74e5b559c235c00e = $7cf239c7de9cb019$export$6416afaab03bc9b8.range;
var $7cf239c7de9cb019$export$e7d6aa4fb107bc56 = $7cf239c7de9cb019$export$cb8f040f5d17ac7b.range;
var $7cf239c7de9cb019$export$fcd5880b20bb06a8 = $7cf239c7de9cb019$export$347581849975dfc8.range;
var $7cf239c7de9cb019$export$682716b7bbe33641 = $7cf239c7de9cb019$export$2f2b56683a3e5629.range;
var $7cf239c7de9cb019$export$482924968ca86084 = $7cf239c7de9cb019$export$59b8c2ccd931d806.range;
var $7cf239c7de9cb019$export$7d755172c9cda9d2 = $7cf239c7de9cb019$export$478ceadebff4d377.range;




var $4f8f10aef7de298a$var$year = (0, $8bccc6dea1985680$export$2e2bcd8739ae039)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$4f8f10aef7de298a$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $8bccc6dea1985680$export$2e2bcd8739ae039)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $4f8f10aef7de298a$export$2e2bcd8739ae039 = $4f8f10aef7de298a$var$year;
var $4f8f10aef7de298a$export$6fda41c7fb23acf9 = $4f8f10aef7de298a$var$year.range;




var $846a1b2f672fcd6e$var$utcMinute = (0, $8bccc6dea1985680$export$2e2bcd8739ae039)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $55b048591b959c61$export$683905d551c33fa9));
}, function(start, end) {
    return (end - start) / (0, $55b048591b959c61$export$683905d551c33fa9);
}, function(date) {
    return date.getUTCMinutes();
});
var $846a1b2f672fcd6e$export$2e2bcd8739ae039 = $846a1b2f672fcd6e$var$utcMinute;
var $846a1b2f672fcd6e$export$cedd563624e8ee50 = $846a1b2f672fcd6e$var$utcMinute.range;




var $28e8c25ec48c2022$var$utcHour = (0, $8bccc6dea1985680$export$2e2bcd8739ae039)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $55b048591b959c61$export$4157bf0c8e241659));
}, function(start, end) {
    return (end - start) / (0, $55b048591b959c61$export$4157bf0c8e241659);
}, function(date) {
    return date.getUTCHours();
});
var $28e8c25ec48c2022$export$2e2bcd8739ae039 = $28e8c25ec48c2022$var$utcHour;
var $28e8c25ec48c2022$export$6e7a76cd5f50b719 = $28e8c25ec48c2022$var$utcHour.range;




var $193fefa148bb9373$var$utcDay = (0, $8bccc6dea1985680$export$2e2bcd8739ae039)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / (0, $55b048591b959c61$export$353686095f4fbf45);
}, function(date) {
    return date.getUTCDate() - 1;
});
var $193fefa148bb9373$export$2e2bcd8739ae039 = $193fefa148bb9373$var$utcDay;
var $193fefa148bb9373$export$d277e198508549a1 = $193fefa148bb9373$var$utcDay.range;




function $62046cccbfe47edb$var$utcWeekday(i) {
    return (0, $8bccc6dea1985680$export$2e2bcd8739ae039)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / (0, $55b048591b959c61$export$c241eb88520d5016);
    });
}
var $62046cccbfe47edb$export$4898b06303a92011 = $62046cccbfe47edb$var$utcWeekday(0);
var $62046cccbfe47edb$export$9cfc53b9cfafd080 = $62046cccbfe47edb$var$utcWeekday(1);
var $62046cccbfe47edb$export$2a6d545f77eceb15 = $62046cccbfe47edb$var$utcWeekday(2);
var $62046cccbfe47edb$export$a5c25d8ed64433c4 = $62046cccbfe47edb$var$utcWeekday(3);
var $62046cccbfe47edb$export$1db08111baec2f53 = $62046cccbfe47edb$var$utcWeekday(4);
var $62046cccbfe47edb$export$29265e34dd5921f7 = $62046cccbfe47edb$var$utcWeekday(5);
var $62046cccbfe47edb$export$85b74dad05049604 = $62046cccbfe47edb$var$utcWeekday(6);
var $62046cccbfe47edb$export$6f3e1c2b0f7d7880 = $62046cccbfe47edb$export$4898b06303a92011.range;
var $62046cccbfe47edb$export$1d2d8b858bb366f9 = $62046cccbfe47edb$export$9cfc53b9cfafd080.range;
var $62046cccbfe47edb$export$1d5f6785fc7f30f8 = $62046cccbfe47edb$export$2a6d545f77eceb15.range;
var $62046cccbfe47edb$export$7a75faf0e37ef4af = $62046cccbfe47edb$export$a5c25d8ed64433c4.range;
var $62046cccbfe47edb$export$417eb959611b2f2f = $62046cccbfe47edb$export$1db08111baec2f53.range;
var $62046cccbfe47edb$export$59d308db7af08c64 = $62046cccbfe47edb$export$29265e34dd5921f7.range;
var $62046cccbfe47edb$export$a124108a0a7f34c8 = $62046cccbfe47edb$export$85b74dad05049604.range;



var $f12be621a209ddb3$var$utcMonth = (0, $8bccc6dea1985680$export$2e2bcd8739ae039)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $f12be621a209ddb3$export$2e2bcd8739ae039 = $f12be621a209ddb3$var$utcMonth;
var $f12be621a209ddb3$export$49159f585997498 = $f12be621a209ddb3$var$utcMonth.range;



var $67ecf516f8edf5f5$var$utcYear = (0, $8bccc6dea1985680$export$2e2bcd8739ae039)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$67ecf516f8edf5f5$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $8bccc6dea1985680$export$2e2bcd8739ae039)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $67ecf516f8edf5f5$export$2e2bcd8739ae039 = $67ecf516f8edf5f5$var$utcYear;
var $67ecf516f8edf5f5$export$3e24d311e17f5802 = $67ecf516f8edf5f5$var$utcYear.range;


function $513f71ee2641a4f9$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            (0, $86de0affb39b7ade$export$2e2bcd8739ae039),
            1,
            (0, $55b048591b959c61$export$79ef0e34099623dc)
        ],
        [
            (0, $86de0affb39b7ade$export$2e2bcd8739ae039),
            5,
            5 * (0, $55b048591b959c61$export$79ef0e34099623dc)
        ],
        [
            (0, $86de0affb39b7ade$export$2e2bcd8739ae039),
            15,
            15 * (0, $55b048591b959c61$export$79ef0e34099623dc)
        ],
        [
            (0, $86de0affb39b7ade$export$2e2bcd8739ae039),
            30,
            30 * (0, $55b048591b959c61$export$79ef0e34099623dc)
        ],
        [
            minute,
            1,
            (0, $55b048591b959c61$export$683905d551c33fa9)
        ],
        [
            minute,
            5,
            5 * (0, $55b048591b959c61$export$683905d551c33fa9)
        ],
        [
            minute,
            15,
            15 * (0, $55b048591b959c61$export$683905d551c33fa9)
        ],
        [
            minute,
            30,
            30 * (0, $55b048591b959c61$export$683905d551c33fa9)
        ],
        [
            hour,
            1,
            (0, $55b048591b959c61$export$4157bf0c8e241659)
        ],
        [
            hour,
            3,
            3 * (0, $55b048591b959c61$export$4157bf0c8e241659)
        ],
        [
            hour,
            6,
            6 * (0, $55b048591b959c61$export$4157bf0c8e241659)
        ],
        [
            hour,
            12,
            12 * (0, $55b048591b959c61$export$4157bf0c8e241659)
        ],
        [
            day,
            1,
            (0, $55b048591b959c61$export$353686095f4fbf45)
        ],
        [
            day,
            2,
            2 * (0, $55b048591b959c61$export$353686095f4fbf45)
        ],
        [
            week,
            1,
            (0, $55b048591b959c61$export$c241eb88520d5016)
        ],
        [
            month,
            1,
            (0, $55b048591b959c61$export$ab95684df7020b26)
        ],
        [
            month,
            3,
            3 * (0, $55b048591b959c61$export$ab95684df7020b26)
        ],
        [
            year,
            1,
            (0, $55b048591b959c61$export$61f8ee2d834c6959)
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $1492a8fafc0d8313$export$2e2bcd8739ae039)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $2035de1f98672e25$export$81087d9b915d4ede)(start / (0, $55b048591b959c61$export$61f8ee2d834c6959), stop / (0, $55b048591b959c61$export$61f8ee2d834c6959), count));
        if (i === 0) return (0, $671ad52e45c26ce3$export$2e2bcd8739ae039).every(Math.max((0, $2035de1f98672e25$export$81087d9b915d4ede)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$513f71ee2641a4f9$export$826ba5ae907e9767, $513f71ee2641a4f9$export$6262d8d056ea44c4] = $513f71ee2641a4f9$var$ticker((0, $67ecf516f8edf5f5$export$2e2bcd8739ae039), (0, $f12be621a209ddb3$export$2e2bcd8739ae039), (0, $62046cccbfe47edb$export$4898b06303a92011), (0, $193fefa148bb9373$export$2e2bcd8739ae039), (0, $28e8c25ec48c2022$export$2e2bcd8739ae039), (0, $846a1b2f672fcd6e$export$2e2bcd8739ae039));
const [$513f71ee2641a4f9$export$60c76498552d28a6, $513f71ee2641a4f9$export$69511150134dd174] = $513f71ee2641a4f9$var$ticker((0, $4f8f10aef7de298a$export$2e2bcd8739ae039), (0, $eee382891c0645de$export$2e2bcd8739ae039), (0, $7cf239c7de9cb019$export$fb3ee18ed410cc21), (0, $e0d54857685ccd14$export$2e2bcd8739ae039), (0, $102a119dc1147e89$export$2e2bcd8739ae039), (0, $b713a37733dec8d3$export$2e2bcd8739ae039));



function $1aa73b6a85414cc5$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $1aa73b6a85414cc5$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $1aa73b6a85414cc5$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $1aa73b6a85414cc5$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $1aa73b6a85414cc5$var$formatRe(locale_periods), periodLookup = $1aa73b6a85414cc5$var$formatLookup(locale_periods), weekdayRe = $1aa73b6a85414cc5$var$formatRe(locale_weekdays), weekdayLookup = $1aa73b6a85414cc5$var$formatLookup(locale_weekdays), shortWeekdayRe = $1aa73b6a85414cc5$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $1aa73b6a85414cc5$var$formatLookup(locale_shortWeekdays), monthRe = $1aa73b6a85414cc5$var$formatRe(locale_months), monthLookup = $1aa73b6a85414cc5$var$formatLookup(locale_months), shortMonthRe = $1aa73b6a85414cc5$var$formatRe(locale_shortMonths), shortMonthLookup = $1aa73b6a85414cc5$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $1aa73b6a85414cc5$var$formatDayOfMonth,
        "e": $1aa73b6a85414cc5$var$formatDayOfMonth,
        "f": $1aa73b6a85414cc5$var$formatMicroseconds,
        "g": $1aa73b6a85414cc5$var$formatYearISO,
        "G": $1aa73b6a85414cc5$var$formatFullYearISO,
        "H": $1aa73b6a85414cc5$var$formatHour24,
        "I": $1aa73b6a85414cc5$var$formatHour12,
        "j": $1aa73b6a85414cc5$var$formatDayOfYear,
        "L": $1aa73b6a85414cc5$var$formatMilliseconds,
        "m": $1aa73b6a85414cc5$var$formatMonthNumber,
        "M": $1aa73b6a85414cc5$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $1aa73b6a85414cc5$var$formatUnixTimestamp,
        "s": $1aa73b6a85414cc5$var$formatUnixTimestampSeconds,
        "S": $1aa73b6a85414cc5$var$formatSeconds,
        "u": $1aa73b6a85414cc5$var$formatWeekdayNumberMonday,
        "U": $1aa73b6a85414cc5$var$formatWeekNumberSunday,
        "V": $1aa73b6a85414cc5$var$formatWeekNumberISO,
        "w": $1aa73b6a85414cc5$var$formatWeekdayNumberSunday,
        "W": $1aa73b6a85414cc5$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $1aa73b6a85414cc5$var$formatYear,
        "Y": $1aa73b6a85414cc5$var$formatFullYear,
        "Z": $1aa73b6a85414cc5$var$formatZone,
        "%": $1aa73b6a85414cc5$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $1aa73b6a85414cc5$var$formatUTCDayOfMonth,
        "e": $1aa73b6a85414cc5$var$formatUTCDayOfMonth,
        "f": $1aa73b6a85414cc5$var$formatUTCMicroseconds,
        "g": $1aa73b6a85414cc5$var$formatUTCYearISO,
        "G": $1aa73b6a85414cc5$var$formatUTCFullYearISO,
        "H": $1aa73b6a85414cc5$var$formatUTCHour24,
        "I": $1aa73b6a85414cc5$var$formatUTCHour12,
        "j": $1aa73b6a85414cc5$var$formatUTCDayOfYear,
        "L": $1aa73b6a85414cc5$var$formatUTCMilliseconds,
        "m": $1aa73b6a85414cc5$var$formatUTCMonthNumber,
        "M": $1aa73b6a85414cc5$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $1aa73b6a85414cc5$var$formatUnixTimestamp,
        "s": $1aa73b6a85414cc5$var$formatUnixTimestampSeconds,
        "S": $1aa73b6a85414cc5$var$formatUTCSeconds,
        "u": $1aa73b6a85414cc5$var$formatUTCWeekdayNumberMonday,
        "U": $1aa73b6a85414cc5$var$formatUTCWeekNumberSunday,
        "V": $1aa73b6a85414cc5$var$formatUTCWeekNumberISO,
        "w": $1aa73b6a85414cc5$var$formatUTCWeekdayNumberSunday,
        "W": $1aa73b6a85414cc5$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $1aa73b6a85414cc5$var$formatUTCYear,
        "Y": $1aa73b6a85414cc5$var$formatUTCFullYear,
        "Z": $1aa73b6a85414cc5$var$formatUTCZone,
        "%": $1aa73b6a85414cc5$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $1aa73b6a85414cc5$var$parseDayOfMonth,
        "e": $1aa73b6a85414cc5$var$parseDayOfMonth,
        "f": $1aa73b6a85414cc5$var$parseMicroseconds,
        "g": $1aa73b6a85414cc5$var$parseYear,
        "G": $1aa73b6a85414cc5$var$parseFullYear,
        "H": $1aa73b6a85414cc5$var$parseHour24,
        "I": $1aa73b6a85414cc5$var$parseHour24,
        "j": $1aa73b6a85414cc5$var$parseDayOfYear,
        "L": $1aa73b6a85414cc5$var$parseMilliseconds,
        "m": $1aa73b6a85414cc5$var$parseMonthNumber,
        "M": $1aa73b6a85414cc5$var$parseMinutes,
        "p": parsePeriod,
        "q": $1aa73b6a85414cc5$var$parseQuarter,
        "Q": $1aa73b6a85414cc5$var$parseUnixTimestamp,
        "s": $1aa73b6a85414cc5$var$parseUnixTimestampSeconds,
        "S": $1aa73b6a85414cc5$var$parseSeconds,
        "u": $1aa73b6a85414cc5$var$parseWeekdayNumberMonday,
        "U": $1aa73b6a85414cc5$var$parseWeekNumberSunday,
        "V": $1aa73b6a85414cc5$var$parseWeekNumberISO,
        "w": $1aa73b6a85414cc5$var$parseWeekdayNumberSunday,
        "W": $1aa73b6a85414cc5$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $1aa73b6a85414cc5$var$parseYear,
        "Y": $1aa73b6a85414cc5$var$parseFullYear,
        "Z": $1aa73b6a85414cc5$var$parseZone,
        "%": $1aa73b6a85414cc5$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $1aa73b6a85414cc5$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $1aa73b6a85414cc5$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $1aa73b6a85414cc5$var$utcDate($1aa73b6a85414cc5$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $62046cccbfe47edb$export$9cfc53b9cfafd080).ceil(week) : (0, $62046cccbfe47edb$export$9cfc53b9cfafd080)(week);
                    week = (0, $193fefa148bb9373$export$2e2bcd8739ae039).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $1aa73b6a85414cc5$var$localDate($1aa73b6a85414cc5$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $7cf239c7de9cb019$export$6416afaab03bc9b8).ceil(week) : (0, $7cf239c7de9cb019$export$6416afaab03bc9b8)(week);
                    week = (0, $e0d54857685ccd14$export$2e2bcd8739ae039).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $1aa73b6a85414cc5$var$utcDate($1aa73b6a85414cc5$var$newDate(d.y, 0, 1)).getUTCDay() : $1aa73b6a85414cc5$var$localDate($1aa73b6a85414cc5$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $1aa73b6a85414cc5$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $1aa73b6a85414cc5$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $1aa73b6a85414cc5$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $1aa73b6a85414cc5$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $1aa73b6a85414cc5$var$numberRe = /^\s*\d+/, $1aa73b6a85414cc5$var$percentRe = /^%/, $1aa73b6a85414cc5$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $1aa73b6a85414cc5$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $1aa73b6a85414cc5$var$requote(s) {
    return s.replace($1aa73b6a85414cc5$var$requoteRe, "\\$&");
}
function $1aa73b6a85414cc5$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($1aa73b6a85414cc5$var$requote).join("|") + ")", "i");
}
function $1aa73b6a85414cc5$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $1aa73b6a85414cc5$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $1aa73b6a85414cc5$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $1aa73b6a85414cc5$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $1aa73b6a85414cc5$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $1aa73b6a85414cc5$var$parseWeekNumberSunday(d, string, i) {
    var n = $1aa73b6a85414cc5$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $1aa73b6a85414cc5$var$parseWeekNumberISO(d, string, i) {
    var n = $1aa73b6a85414cc5$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $1aa73b6a85414cc5$var$parseWeekNumberMonday(d, string, i) {
    var n = $1aa73b6a85414cc5$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $1aa73b6a85414cc5$var$parseFullYear(d, string, i) {
    var n = $1aa73b6a85414cc5$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $1aa73b6a85414cc5$var$parseYear(d, string, i) {
    var n = $1aa73b6a85414cc5$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $1aa73b6a85414cc5$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $1aa73b6a85414cc5$var$parseQuarter(d, string, i) {
    var n = $1aa73b6a85414cc5$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $1aa73b6a85414cc5$var$parseMonthNumber(d, string, i) {
    var n = $1aa73b6a85414cc5$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $1aa73b6a85414cc5$var$parseDayOfMonth(d, string, i) {
    var n = $1aa73b6a85414cc5$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $1aa73b6a85414cc5$var$parseDayOfYear(d, string, i) {
    var n = $1aa73b6a85414cc5$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $1aa73b6a85414cc5$var$parseHour24(d, string, i) {
    var n = $1aa73b6a85414cc5$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $1aa73b6a85414cc5$var$parseMinutes(d, string, i) {
    var n = $1aa73b6a85414cc5$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $1aa73b6a85414cc5$var$parseSeconds(d, string, i) {
    var n = $1aa73b6a85414cc5$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $1aa73b6a85414cc5$var$parseMilliseconds(d, string, i) {
    var n = $1aa73b6a85414cc5$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $1aa73b6a85414cc5$var$parseMicroseconds(d, string, i) {
    var n = $1aa73b6a85414cc5$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $1aa73b6a85414cc5$var$parseLiteralPercent(d, string, i) {
    var n = $1aa73b6a85414cc5$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $1aa73b6a85414cc5$var$parseUnixTimestamp(d, string, i) {
    var n = $1aa73b6a85414cc5$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $1aa73b6a85414cc5$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $1aa73b6a85414cc5$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $1aa73b6a85414cc5$var$formatDayOfMonth(d, p) {
    return $1aa73b6a85414cc5$var$pad(d.getDate(), p, 2);
}
function $1aa73b6a85414cc5$var$formatHour24(d, p) {
    return $1aa73b6a85414cc5$var$pad(d.getHours(), p, 2);
}
function $1aa73b6a85414cc5$var$formatHour12(d, p) {
    return $1aa73b6a85414cc5$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $1aa73b6a85414cc5$var$formatDayOfYear(d, p) {
    return $1aa73b6a85414cc5$var$pad(1 + (0, $e0d54857685ccd14$export$2e2bcd8739ae039).count((0, $4f8f10aef7de298a$export$2e2bcd8739ae039)(d), d), p, 3);
}
function $1aa73b6a85414cc5$var$formatMilliseconds(d, p) {
    return $1aa73b6a85414cc5$var$pad(d.getMilliseconds(), p, 3);
}
function $1aa73b6a85414cc5$var$formatMicroseconds(d, p) {
    return $1aa73b6a85414cc5$var$formatMilliseconds(d, p) + "000";
}
function $1aa73b6a85414cc5$var$formatMonthNumber(d, p) {
    return $1aa73b6a85414cc5$var$pad(d.getMonth() + 1, p, 2);
}
function $1aa73b6a85414cc5$var$formatMinutes(d, p) {
    return $1aa73b6a85414cc5$var$pad(d.getMinutes(), p, 2);
}
function $1aa73b6a85414cc5$var$formatSeconds(d, p) {
    return $1aa73b6a85414cc5$var$pad(d.getSeconds(), p, 2);
}
function $1aa73b6a85414cc5$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $1aa73b6a85414cc5$var$formatWeekNumberSunday(d, p) {
    return $1aa73b6a85414cc5$var$pad((0, $7cf239c7de9cb019$export$fb3ee18ed410cc21).count((0, $4f8f10aef7de298a$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $1aa73b6a85414cc5$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $7cf239c7de9cb019$export$2f2b56683a3e5629)(d) : (0, $7cf239c7de9cb019$export$2f2b56683a3e5629).ceil(d);
}
function $1aa73b6a85414cc5$var$formatWeekNumberISO(d, p) {
    d = $1aa73b6a85414cc5$var$dISO(d);
    return $1aa73b6a85414cc5$var$pad((0, $7cf239c7de9cb019$export$2f2b56683a3e5629).count((0, $4f8f10aef7de298a$export$2e2bcd8739ae039)(d), d) + ((0, $4f8f10aef7de298a$export$2e2bcd8739ae039)(d).getDay() === 4), p, 2);
}
function $1aa73b6a85414cc5$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $1aa73b6a85414cc5$var$formatWeekNumberMonday(d, p) {
    return $1aa73b6a85414cc5$var$pad((0, $7cf239c7de9cb019$export$6416afaab03bc9b8).count((0, $4f8f10aef7de298a$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $1aa73b6a85414cc5$var$formatYear(d, p) {
    return $1aa73b6a85414cc5$var$pad(d.getFullYear() % 100, p, 2);
}
function $1aa73b6a85414cc5$var$formatYearISO(d, p) {
    d = $1aa73b6a85414cc5$var$dISO(d);
    return $1aa73b6a85414cc5$var$pad(d.getFullYear() % 100, p, 2);
}
function $1aa73b6a85414cc5$var$formatFullYear(d, p) {
    return $1aa73b6a85414cc5$var$pad(d.getFullYear() % 10000, p, 4);
}
function $1aa73b6a85414cc5$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $7cf239c7de9cb019$export$2f2b56683a3e5629)(d) : (0, $7cf239c7de9cb019$export$2f2b56683a3e5629).ceil(d);
    return $1aa73b6a85414cc5$var$pad(d.getFullYear() % 10000, p, 4);
}
function $1aa73b6a85414cc5$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $1aa73b6a85414cc5$var$pad(z / 60 | 0, "0", 2) + $1aa73b6a85414cc5$var$pad(z % 60, "0", 2);
}
function $1aa73b6a85414cc5$var$formatUTCDayOfMonth(d, p) {
    return $1aa73b6a85414cc5$var$pad(d.getUTCDate(), p, 2);
}
function $1aa73b6a85414cc5$var$formatUTCHour24(d, p) {
    return $1aa73b6a85414cc5$var$pad(d.getUTCHours(), p, 2);
}
function $1aa73b6a85414cc5$var$formatUTCHour12(d, p) {
    return $1aa73b6a85414cc5$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $1aa73b6a85414cc5$var$formatUTCDayOfYear(d, p) {
    return $1aa73b6a85414cc5$var$pad(1 + (0, $193fefa148bb9373$export$2e2bcd8739ae039).count((0, $67ecf516f8edf5f5$export$2e2bcd8739ae039)(d), d), p, 3);
}
function $1aa73b6a85414cc5$var$formatUTCMilliseconds(d, p) {
    return $1aa73b6a85414cc5$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $1aa73b6a85414cc5$var$formatUTCMicroseconds(d, p) {
    return $1aa73b6a85414cc5$var$formatUTCMilliseconds(d, p) + "000";
}
function $1aa73b6a85414cc5$var$formatUTCMonthNumber(d, p) {
    return $1aa73b6a85414cc5$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $1aa73b6a85414cc5$var$formatUTCMinutes(d, p) {
    return $1aa73b6a85414cc5$var$pad(d.getUTCMinutes(), p, 2);
}
function $1aa73b6a85414cc5$var$formatUTCSeconds(d, p) {
    return $1aa73b6a85414cc5$var$pad(d.getUTCSeconds(), p, 2);
}
function $1aa73b6a85414cc5$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $1aa73b6a85414cc5$var$formatUTCWeekNumberSunday(d, p) {
    return $1aa73b6a85414cc5$var$pad((0, $62046cccbfe47edb$export$4898b06303a92011).count((0, $67ecf516f8edf5f5$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $1aa73b6a85414cc5$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $62046cccbfe47edb$export$1db08111baec2f53)(d) : (0, $62046cccbfe47edb$export$1db08111baec2f53).ceil(d);
}
function $1aa73b6a85414cc5$var$formatUTCWeekNumberISO(d, p) {
    d = $1aa73b6a85414cc5$var$UTCdISO(d);
    return $1aa73b6a85414cc5$var$pad((0, $62046cccbfe47edb$export$1db08111baec2f53).count((0, $67ecf516f8edf5f5$export$2e2bcd8739ae039)(d), d) + ((0, $67ecf516f8edf5f5$export$2e2bcd8739ae039)(d).getUTCDay() === 4), p, 2);
}
function $1aa73b6a85414cc5$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $1aa73b6a85414cc5$var$formatUTCWeekNumberMonday(d, p) {
    return $1aa73b6a85414cc5$var$pad((0, $62046cccbfe47edb$export$9cfc53b9cfafd080).count((0, $67ecf516f8edf5f5$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $1aa73b6a85414cc5$var$formatUTCYear(d, p) {
    return $1aa73b6a85414cc5$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $1aa73b6a85414cc5$var$formatUTCYearISO(d, p) {
    d = $1aa73b6a85414cc5$var$UTCdISO(d);
    return $1aa73b6a85414cc5$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $1aa73b6a85414cc5$var$formatUTCFullYear(d, p) {
    return $1aa73b6a85414cc5$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $1aa73b6a85414cc5$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $62046cccbfe47edb$export$1db08111baec2f53)(d) : (0, $62046cccbfe47edb$export$1db08111baec2f53).ceil(d);
    return $1aa73b6a85414cc5$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $1aa73b6a85414cc5$var$formatUTCZone() {
    return "+0000";
}
function $1aa73b6a85414cc5$var$formatLiteralPercent() {
    return "%";
}
function $1aa73b6a85414cc5$var$formatUnixTimestamp(d) {
    return +d;
}
function $1aa73b6a85414cc5$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}


var $c36414af0b36b5e9$var$locale;
var $c36414af0b36b5e9$export$94f4d87fad5dcf9a;
var $c36414af0b36b5e9$export$32b9cd16e1b8c8d2;
var $c36414af0b36b5e9$export$1a08fe38f63ebbbb;
var $c36414af0b36b5e9$export$3edae9cf8e233729;
$c36414af0b36b5e9$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $c36414af0b36b5e9$export$2e2bcd8739ae039(definition) {
    $c36414af0b36b5e9$var$locale = (0, $1aa73b6a85414cc5$export$2e2bcd8739ae039)(definition);
    $c36414af0b36b5e9$export$94f4d87fad5dcf9a = $c36414af0b36b5e9$var$locale.format;
    $c36414af0b36b5e9$export$32b9cd16e1b8c8d2 = $c36414af0b36b5e9$var$locale.parse;
    $c36414af0b36b5e9$export$1a08fe38f63ebbbb = $c36414af0b36b5e9$var$locale.utcFormat;
    $c36414af0b36b5e9$export$3edae9cf8e233729 = $c36414af0b36b5e9$var$locale.utcParse;
    return $c36414af0b36b5e9$var$locale;
}





function $36fc7f9f89f3d633$var$date(t) {
    return new Date(t);
}
function $36fc7f9f89f3d633$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $36fc7f9f89f3d633$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $70c8ed888851cd4a$export$2e2bcd8739ae039)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $36fc7f9f89f3d633$var$number)) : domain().map($36fc7f9f89f3d633$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $b383b6cffa77f8f0$export$2e2bcd8739ae039)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $70c8ed888851cd4a$export$784d13d8ee351f07)(scale, $36fc7f9f89f3d633$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $36fc7f9f89f3d633$export$2e2bcd8739ae039() {
    return (0, $94aa5673c1c16071$export$23c7bb9e6558da2a).apply($36fc7f9f89f3d633$export$56bbcdb8aca31149((0, $513f71ee2641a4f9$export$60c76498552d28a6), (0, $513f71ee2641a4f9$export$69511150134dd174), (0, $4f8f10aef7de298a$export$2e2bcd8739ae039), (0, $eee382891c0645de$export$2e2bcd8739ae039), (0, $7cf239c7de9cb019$export$fb3ee18ed410cc21), (0, $e0d54857685ccd14$export$2e2bcd8739ae039), (0, $102a119dc1147e89$export$2e2bcd8739ae039), (0, $b713a37733dec8d3$export$2e2bcd8739ae039), (0, $86de0affb39b7ade$export$2e2bcd8739ae039), (0, $c36414af0b36b5e9$export$94f4d87fad5dcf9a)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}






function $e3b0fcaaa8d3a40a$export$2e2bcd8739ae039() {
    return (0, $94aa5673c1c16071$export$23c7bb9e6558da2a).apply((0, $36fc7f9f89f3d633$export$56bbcdb8aca31149)((0, $513f71ee2641a4f9$export$826ba5ae907e9767), (0, $513f71ee2641a4f9$export$6262d8d056ea44c4), (0, $67ecf516f8edf5f5$export$2e2bcd8739ae039), (0, $f12be621a209ddb3$export$2e2bcd8739ae039), (0, $62046cccbfe47edb$export$4898b06303a92011), (0, $193fefa148bb9373$export$2e2bcd8739ae039), (0, $28e8c25ec48c2022$export$2e2bcd8739ae039), (0, $846a1b2f672fcd6e$export$2e2bcd8739ae039), (0, $86de0affb39b7ade$export$2e2bcd8739ae039), (0, $c36414af0b36b5e9$export$1a08fe38f63ebbbb)).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}









function $c29a0481091d6b1b$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = (0, $70c8ed888851cd4a$export$f0954fd7d5368655), clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $b21d994aaa3dc663$export$2e2bcd8739ae039));
    scale.rangeRound = range((0, $74137ec733484977$export$2e2bcd8739ae039));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $c29a0481091d6b1b$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $c29a0481091d6b1b$export$2e2bcd8739ae039() {
    var scale = (0, $169d6d8869618bf9$export$16a5d4b4a61a274d)($c29a0481091d6b1b$var$transformer()((0, $70c8ed888851cd4a$export$f0954fd7d5368655)));
    scale.copy = function() {
        return $c29a0481091d6b1b$export$784d13d8ee351f07(scale, $c29a0481091d6b1b$export$2e2bcd8739ae039());
    };
    return (0, $94aa5673c1c16071$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $c29a0481091d6b1b$export$6843e08bf2ff981f() {
    var scale = (0, $f9bb92d942e4389b$export$860836db074028f0)($c29a0481091d6b1b$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $c29a0481091d6b1b$export$784d13d8ee351f07(scale, $c29a0481091d6b1b$export$6843e08bf2ff981f()).base(scale.base());
    };
    return (0, $94aa5673c1c16071$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $c29a0481091d6b1b$export$9d4af4de62c81941() {
    var scale = (0, $5193f5f8c08ac341$export$4602684e614eba38)($c29a0481091d6b1b$var$transformer());
    scale.copy = function() {
        return $c29a0481091d6b1b$export$784d13d8ee351f07(scale, $c29a0481091d6b1b$export$9d4af4de62c81941()).constant(scale.constant());
    };
    return (0, $94aa5673c1c16071$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $c29a0481091d6b1b$export$de9f78581b4f2405() {
    var scale = (0, $83041545fdc0679f$export$34695211ec403a46)($c29a0481091d6b1b$var$transformer());
    scale.copy = function() {
        return $c29a0481091d6b1b$export$784d13d8ee351f07(scale, $c29a0481091d6b1b$export$de9f78581b4f2405()).exponent(scale.exponent());
    };
    return (0, $94aa5673c1c16071$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $c29a0481091d6b1b$export$413d935127ed466e() {
    return $c29a0481091d6b1b$export$de9f78581b4f2405.apply(null, arguments).exponent(0.5);
}





function $14b580239d2d0636$export$2e2bcd8739ae039() {
    var domain = [], interpolator = (0, $70c8ed888851cd4a$export$f0954fd7d5368655);
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, $7945de4765468759$export$2e2bcd8739ae039)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, $3bc99fb33e254efb$export$2e2bcd8739ae039));
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, $fa3f54f7c13c7951$export$2e2bcd8739ae039)(domain, i / n));
    };
    scale.copy = function() {
        return $14b580239d2d0636$export$2e2bcd8739ae039(interpolator).domain(domain);
    };
    return (0, $94aa5673c1c16071$export$7d6b419e59e83f3d).apply(scale, arguments);
}



function $9ed25fdbd188cd73$export$2e2bcd8739ae039(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = (0, $b21d994aaa3dc663$export$2e2bcd8739ae039);
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}









function $488d3280fe5e7c1c$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = (0, $70c8ed888851cd4a$export$f0954fd7d5368655), transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $9ed25fdbd188cd73$export$2e2bcd8739ae039)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $b21d994aaa3dc663$export$2e2bcd8739ae039));
    scale.rangeRound = range((0, $74137ec733484977$export$2e2bcd8739ae039));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $488d3280fe5e7c1c$export$2e2bcd8739ae039() {
    var scale = (0, $169d6d8869618bf9$export$16a5d4b4a61a274d)($488d3280fe5e7c1c$var$transformer()((0, $70c8ed888851cd4a$export$f0954fd7d5368655)));
    scale.copy = function() {
        return (0, $c29a0481091d6b1b$export$784d13d8ee351f07)(scale, $488d3280fe5e7c1c$export$2e2bcd8739ae039());
    };
    return (0, $94aa5673c1c16071$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $488d3280fe5e7c1c$export$5f0266a9159c47fb() {
    var scale = (0, $f9bb92d942e4389b$export$860836db074028f0)($488d3280fe5e7c1c$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $c29a0481091d6b1b$export$784d13d8ee351f07)(scale, $488d3280fe5e7c1c$export$5f0266a9159c47fb()).base(scale.base());
    };
    return (0, $94aa5673c1c16071$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $488d3280fe5e7c1c$export$50b3da713cf557c6() {
    var scale = (0, $5193f5f8c08ac341$export$4602684e614eba38)($488d3280fe5e7c1c$var$transformer());
    scale.copy = function() {
        return (0, $c29a0481091d6b1b$export$784d13d8ee351f07)(scale, $488d3280fe5e7c1c$export$50b3da713cf557c6()).constant(scale.constant());
    };
    return (0, $94aa5673c1c16071$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $488d3280fe5e7c1c$export$d6cedcc63bf26e7e() {
    var scale = (0, $83041545fdc0679f$export$34695211ec403a46)($488d3280fe5e7c1c$var$transformer());
    scale.copy = function() {
        return (0, $c29a0481091d6b1b$export$784d13d8ee351f07)(scale, $488d3280fe5e7c1c$export$d6cedcc63bf26e7e()).exponent(scale.exponent());
    };
    return (0, $94aa5673c1c16071$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $488d3280fe5e7c1c$export$33ddefb5c4ab9e9c() {
    return $488d3280fe5e7c1c$export$d6cedcc63bf26e7e.apply(null, arguments).exponent(0.5);
}







function $486a3fa71ebe57d2$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}


function $765ad40d93feffec$export$2e2bcd8739ae039(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}


function $f6122f905ec4bfff$var$stackValue(d, key) {
    return d[key];
}
function $f6122f905ec4bfff$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $f6122f905ec4bfff$export$2e2bcd8739ae039() {
    var keys = (0, $4b8c5ad53a733149$export$2e2bcd8739ae039)([]), order = (0, $765ad40d93feffec$export$2e2bcd8739ae039), offset = (0, $486a3fa71ebe57d2$export$2e2bcd8739ae039), value = $f6122f905ec4bfff$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $f6122f905ec4bfff$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $ddd10c0627c7da22$export$2e2bcd8739ae039)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $4b8c5ad53a733149$export$2e2bcd8739ae039)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $4b8c5ad53a733149$export$2e2bcd8739ae039)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? (0, $765ad40d93feffec$export$2e2bcd8739ae039) : typeof _ === "function" ? _ : (0, $4b8c5ad53a733149$export$2e2bcd8739ae039)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? (0, $486a3fa71ebe57d2$export$2e2bcd8739ae039) : _, stack) : offset;
    };
    return stack;
}


function $afa3e07987918589$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $486a3fa71ebe57d2$export$2e2bcd8739ae039)(series, order);
}


function $fc2143221f358c55$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $486a3fa71ebe57d2$export$2e2bcd8739ae039)(series, order);
}


function $4e5c02106e9852b6$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $486a3fa71ebe57d2$export$2e2bcd8739ae039)(series, order);
}




var $8cfdf43387bf2d0c$exports = {};

var $5c0e52f50c5bae54$exports = {};

var $472de93488a4485f$exports = {};
var $c4dc7b3f913599c4$exports = {};
var $e190a747c180cedc$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e190a747c180cedc$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$e190a747c180cedc$exports = $e190a747c180cedc$var$baseFindIndex;


var $20778ca05ff71196$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $20778ca05ff71196$var$baseIsNaN(value) {
    return value !== value;
}
$20778ca05ff71196$exports = $20778ca05ff71196$var$baseIsNaN;


var $06343418d2253832$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $06343418d2253832$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$06343418d2253832$exports = $06343418d2253832$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $c4dc7b3f913599c4$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $06343418d2253832$exports(array, value, fromIndex) : $e190a747c180cedc$exports(array, $20778ca05ff71196$exports, fromIndex);
}
$c4dc7b3f913599c4$exports = $c4dc7b3f913599c4$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $472de93488a4485f$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $c4dc7b3f913599c4$exports(array, value, 0) > -1;
}
$472de93488a4485f$exports = $472de93488a4485f$var$arrayIncludes;


var $1301d62ad7d3c84b$exports = {};
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $1301d62ad7d3c84b$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
$1301d62ad7d3c84b$exports = $1301d62ad7d3c84b$var$arrayIncludesWith;



var $4b99a5b32aa62a14$exports = {};

var $147f92b4cf36a27f$exports = {};
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $147f92b4cf36a27f$var$noop() {
// No operation performed.
}
$147f92b4cf36a27f$exports = $147f92b4cf36a27f$var$noop;



/** Used as references for various `Number` constants. */ var $4b99a5b32aa62a14$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $4b99a5b32aa62a14$var$createSet = !($f1e5d3aa10f9181f$exports && 1 / $c5e3ee766fd09634$exports(new $f1e5d3aa10f9181f$exports([
    ,
    -0
]))[1] == $4b99a5b32aa62a14$var$INFINITY) ? $147f92b4cf36a27f$exports : function(values) {
    return new $f1e5d3aa10f9181f$exports(values);
};
$4b99a5b32aa62a14$exports = $4b99a5b32aa62a14$var$createSet;



/** Used as the size to enable large array optimizations. */ var $5c0e52f50c5bae54$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $5c0e52f50c5bae54$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $472de93488a4485f$exports, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $1301d62ad7d3c84b$exports;
    } else if (length >= $5c0e52f50c5bae54$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $4b99a5b32aa62a14$exports(array);
        if (set) return $c5e3ee766fd09634$exports(set);
        isCommon = false;
        includes = $a1dfcc27fe23b4c8$exports;
        seen = new $8eed56c9d2454110$exports;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$5c0e52f50c5bae54$exports = $5c0e52f50c5bae54$var$baseUniq;


/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $8cfdf43387bf2d0c$var$uniqBy(array, iteratee) {
    return array && array.length ? $5c0e52f50c5bae54$exports(array, $958e35cadb69881a$exports(iteratee, 2)) : [];
}
$8cfdf43387bf2d0c$exports = $8cfdf43387bf2d0c$var$uniqBy;



var $jC8Vy = parcelRequire("jC8Vy");

var $jC8Vy = parcelRequire("jC8Vy");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $5UrGx = parcelRequire("5UrGx");

function $38e5da7c3943e1e6$var$_extends() {
    $38e5da7c3943e1e6$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $38e5da7c3943e1e6$var$_extends.apply(this, arguments);
}
function $38e5da7c3943e1e6$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $38e5da7c3943e1e6$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $38e5da7c3943e1e6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $38e5da7c3943e1e6$export$7b92b459e668cb21(props) {
    var children = props.children, width = props.width, height = props.height, viewBox = props.viewBox, className = props.className, style = props.style, others = $38e5da7c3943e1e6$var$_objectWithoutProperties(props, [
        "children",
        "width",
        "height",
        "viewBox",
        "className",
        "style"
    ]);
    var svgView = viewBox || {
        width: width,
        height: height,
        x: 0,
        y: 0
    };
    var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))("recharts-surface", className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("svg", $38e5da7c3943e1e6$var$_extends({}, (0, $05a192303b32ed93$export$d697c39a2985a4c)(others, true, true), {
        className: layerClass,
        width: width,
        height: height,
        style: style,
        viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height),
        version: "1.1"
    }), children);
}




var $jC8Vy = parcelRequire("jC8Vy");


const $e829be839d8b60f4$export$2335f513bbd82c6d = Math.abs;
const $e829be839d8b60f4$export$b8b770ee6a0d9760 = Math.atan2;
const $e829be839d8b60f4$export$50d414a77b60d802 = Math.cos;
const $e829be839d8b60f4$export$8960430cfd85939f = Math.max;
const $e829be839d8b60f4$export$96ec731ed4dcb222 = Math.min;
const $e829be839d8b60f4$export$5de3937cb4b592ed = Math.sin;
const $e829be839d8b60f4$export$eba8049fb5020b81 = Math.sqrt;
const $e829be839d8b60f4$export$6c421550c66a327d = 1e-12;
const $e829be839d8b60f4$export$18c7bea995a110f = Math.PI;
const $e829be839d8b60f4$export$e51408a300e8929a = $e829be839d8b60f4$export$18c7bea995a110f / 2;
const $e829be839d8b60f4$export$a4b4b4d4d776fe92 = 2 * $e829be839d8b60f4$export$18c7bea995a110f;
function $e829be839d8b60f4$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $e829be839d8b60f4$export$18c7bea995a110f : Math.acos(x);
}
function $e829be839d8b60f4$export$41726bdb1fc63f(x) {
    return x >= 1 ? $e829be839d8b60f4$export$e51408a300e8929a : x <= -1 ? -$e829be839d8b60f4$export$e51408a300e8929a : Math.asin(x);
}


const $36d2da92e717719d$var$sqrt3 = (0, $e829be839d8b60f4$export$eba8049fb5020b81)(3);
var $36d2da92e717719d$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $e829be839d8b60f4$export$eba8049fb5020b81)(size + (0, $e829be839d8b60f4$export$96ec731ed4dcb222)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $36d2da92e717719d$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};



var $c299d7fcd314d7ca$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $e829be839d8b60f4$export$eba8049fb5020b81)(size / (0, $e829be839d8b60f4$export$18c7bea995a110f));
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, (0, $e829be839d8b60f4$export$a4b4b4d4d776fe92));
    }
};



var $7aa8bf27582ae2a5$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $e829be839d8b60f4$export$eba8049fb5020b81)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};



const $4e8ce53f219b5192$var$tan30 = (0, $e829be839d8b60f4$export$eba8049fb5020b81)(1 / 3);
const $4e8ce53f219b5192$var$tan30_2 = $4e8ce53f219b5192$var$tan30 * 2;
var $4e8ce53f219b5192$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const y = (0, $e829be839d8b60f4$export$eba8049fb5020b81)(size / $4e8ce53f219b5192$var$tan30_2);
        const x = y * $4e8ce53f219b5192$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};



var $d0a82e6c8879ef98$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $e829be839d8b60f4$export$eba8049fb5020b81)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};



var $970e2404020fab40$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $e829be839d8b60f4$export$eba8049fb5020b81)(size - (0, $e829be839d8b60f4$export$96ec731ed4dcb222)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};



var $b8a3f44392a6eeeb$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const w = (0, $e829be839d8b60f4$export$eba8049fb5020b81)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};



var $06db938206bc5313$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $e829be839d8b60f4$export$eba8049fb5020b81)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};



const $e858e09c36d8680a$var$ka = 0.89081309152928522810;
const $e858e09c36d8680a$var$kr = (0, $e829be839d8b60f4$export$5de3937cb4b592ed)((0, $e829be839d8b60f4$export$18c7bea995a110f) / 10) / (0, $e829be839d8b60f4$export$5de3937cb4b592ed)(7 * (0, $e829be839d8b60f4$export$18c7bea995a110f) / 10);
const $e858e09c36d8680a$var$kx = (0, $e829be839d8b60f4$export$5de3937cb4b592ed)((0, $e829be839d8b60f4$export$a4b4b4d4d776fe92) / 10) * $e858e09c36d8680a$var$kr;
const $e858e09c36d8680a$var$ky = -(0, $e829be839d8b60f4$export$50d414a77b60d802)((0, $e829be839d8b60f4$export$a4b4b4d4d776fe92) / 10) * $e858e09c36d8680a$var$kr;
var $e858e09c36d8680a$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $e829be839d8b60f4$export$eba8049fb5020b81)(size * $e858e09c36d8680a$var$ka);
        const x = $e858e09c36d8680a$var$kx * r;
        const y = $e858e09c36d8680a$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = (0, $e829be839d8b60f4$export$a4b4b4d4d776fe92) * i / 5;
            const c = (0, $e829be839d8b60f4$export$50d414a77b60d802)(a);
            const s = (0, $e829be839d8b60f4$export$5de3937cb4b592ed)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};



const $ecd6a82744bea1ba$var$sqrt3 = (0, $e829be839d8b60f4$export$eba8049fb5020b81)(3);
var $ecd6a82744bea1ba$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const y = -(0, $e829be839d8b60f4$export$eba8049fb5020b81)(size / ($ecd6a82744bea1ba$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$ecd6a82744bea1ba$var$sqrt3 * y, -y);
        context.lineTo($ecd6a82744bea1ba$var$sqrt3 * y, -y);
        context.closePath();
    }
};



const $879885fb0e3b10d8$var$sqrt3 = (0, $e829be839d8b60f4$export$eba8049fb5020b81)(3);
var $879885fb0e3b10d8$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const s = (0, $e829be839d8b60f4$export$eba8049fb5020b81)(size) * 0.6824;
        const t = s / 2;
        const u = s * $879885fb0e3b10d8$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};



const $2ee963594f364064$var$c = -0.5;
const $2ee963594f364064$var$s = (0, $e829be839d8b60f4$export$eba8049fb5020b81)(3) / 2;
const $2ee963594f364064$var$k = 1 / (0, $e829be839d8b60f4$export$eba8049fb5020b81)(12);
const $2ee963594f364064$var$a = ($2ee963594f364064$var$k / 2 + 1) * 3;
var $2ee963594f364064$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $e829be839d8b60f4$export$eba8049fb5020b81)(size / $2ee963594f364064$var$a);
        const x0 = r / 2, y0 = r * $2ee963594f364064$var$k;
        const x1 = x0, y1 = r * $2ee963594f364064$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($2ee963594f364064$var$c * x0 - $2ee963594f364064$var$s * y0, $2ee963594f364064$var$s * x0 + $2ee963594f364064$var$c * y0);
        context.lineTo($2ee963594f364064$var$c * x1 - $2ee963594f364064$var$s * y1, $2ee963594f364064$var$s * x1 + $2ee963594f364064$var$c * y1);
        context.lineTo($2ee963594f364064$var$c * x2 - $2ee963594f364064$var$s * y2, $2ee963594f364064$var$s * x2 + $2ee963594f364064$var$c * y2);
        context.lineTo($2ee963594f364064$var$c * x0 + $2ee963594f364064$var$s * y0, $2ee963594f364064$var$c * y0 - $2ee963594f364064$var$s * x0);
        context.lineTo($2ee963594f364064$var$c * x1 + $2ee963594f364064$var$s * y1, $2ee963594f364064$var$c * y1 - $2ee963594f364064$var$s * x1);
        context.lineTo($2ee963594f364064$var$c * x2 + $2ee963594f364064$var$s * y2, $2ee963594f364064$var$c * y2 - $2ee963594f364064$var$s * x2);
        context.closePath();
    }
};



var $3f0a674f169bea0f$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $e829be839d8b60f4$export$eba8049fb5020b81)(size - (0, $e829be839d8b60f4$export$96ec731ed4dcb222)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};


const $d5dc9a4f2aa2bbbf$export$19158c96a6700c15 = [
    (0, $c299d7fcd314d7ca$export$2e2bcd8739ae039),
    (0, $7aa8bf27582ae2a5$export$2e2bcd8739ae039),
    (0, $4e8ce53f219b5192$export$2e2bcd8739ae039),
    (0, $b8a3f44392a6eeeb$export$2e2bcd8739ae039),
    (0, $e858e09c36d8680a$export$2e2bcd8739ae039),
    (0, $ecd6a82744bea1ba$export$2e2bcd8739ae039),
    (0, $2ee963594f364064$export$2e2bcd8739ae039)
];
const $d5dc9a4f2aa2bbbf$export$915e06de6acf8fe = [
    (0, $c299d7fcd314d7ca$export$2e2bcd8739ae039),
    (0, $970e2404020fab40$export$2e2bcd8739ae039),
    (0, $3f0a674f169bea0f$export$2e2bcd8739ae039),
    (0, $879885fb0e3b10d8$export$2e2bcd8739ae039),
    (0, $36d2da92e717719d$export$2e2bcd8739ae039),
    (0, $06db938206bc5313$export$2e2bcd8739ae039),
    (0, $d0a82e6c8879ef98$export$2e2bcd8739ae039)
];
function $d5dc9a4f2aa2bbbf$export$2e2bcd8739ae039(type, size) {
    let context = null;
    type = typeof type === "function" ? type : (0, $4b8c5ad53a733149$export$2e2bcd8739ae039)(type || (0, $c299d7fcd314d7ca$export$2e2bcd8739ae039));
    size = typeof size === "function" ? size : (0, $4b8c5ad53a733149$export$2e2bcd8739ae039)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = (0, $e37c76946f6488a5$export$2e2bcd8739ae039)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $4b8c5ad53a733149$export$2e2bcd8739ae039)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $4b8c5ad53a733149$export$2e2bcd8739ae039)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}



var $5UrGx = parcelRequire("5UrGx");

function $5d51e9d784c905d7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $5d51e9d784c905d7$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $5d51e9d784c905d7$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $5d51e9d784c905d7$var$_typeof(obj);
}
function $5d51e9d784c905d7$var$_extends() {
    $5d51e9d784c905d7$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5d51e9d784c905d7$var$_extends.apply(this, arguments);
}
function $5d51e9d784c905d7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5d51e9d784c905d7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5d51e9d784c905d7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5d51e9d784c905d7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5d51e9d784c905d7$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $5d51e9d784c905d7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $5d51e9d784c905d7$var$_setPrototypeOf(subClass, superClass);
}
function $5d51e9d784c905d7$var$_setPrototypeOf(o, p) {
    $5d51e9d784c905d7$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5d51e9d784c905d7$var$_setPrototypeOf(o, p);
}
function $5d51e9d784c905d7$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5d51e9d784c905d7$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $5d51e9d784c905d7$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $5d51e9d784c905d7$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $5d51e9d784c905d7$var$_possibleConstructorReturn(this, result);
    };
}
function $5d51e9d784c905d7$var$_possibleConstructorReturn(self, call) {
    if (call && ($5d51e9d784c905d7$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $5d51e9d784c905d7$var$_assertThisInitialized(self);
}
function $5d51e9d784c905d7$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $5d51e9d784c905d7$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $5d51e9d784c905d7$var$_getPrototypeOf(o) {
    $5d51e9d784c905d7$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5d51e9d784c905d7$var$_getPrototypeOf(o);
}
var $5d51e9d784c905d7$var$symbolFactories = {
    symbolCircle: (0, $c299d7fcd314d7ca$export$2e2bcd8739ae039),
    symbolCross: (0, $7aa8bf27582ae2a5$export$2e2bcd8739ae039),
    symbolDiamond: (0, $4e8ce53f219b5192$export$2e2bcd8739ae039),
    symbolSquare: (0, $b8a3f44392a6eeeb$export$2e2bcd8739ae039),
    symbolStar: (0, $e858e09c36d8680a$export$2e2bcd8739ae039),
    symbolTriangle: (0, $ecd6a82744bea1ba$export$2e2bcd8739ae039),
    symbolWye: (0, $2ee963594f364064$export$2e2bcd8739ae039)
};
var $5d51e9d784c905d7$var$RADIAN = Math.PI / 180;
var $5d51e9d784c905d7$var$getSymbolFactory = function getSymbolFactory(type) {
    var name = "symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($ca2cccb92e57cec1$exports)))(type));
    return $5d51e9d784c905d7$var$symbolFactories[name] || (0, $c299d7fcd314d7ca$export$2e2bcd8739ae039);
};
var $5d51e9d784c905d7$var$calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
    if (sizeType === "area") return size;
    switch(type){
        case "cross":
            return 5 * size * size / 9;
        case "diamond":
            return 0.5 * size * size / Math.sqrt(3);
        case "square":
            return size * size;
        case "star":
            var angle = 18 * $5d51e9d784c905d7$var$RADIAN;
            return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
        case "triangle":
            return Math.sqrt(3) * size * size / 4;
        case "wye":
            return (21 - 10 * Math.sqrt(3)) * size * size / 8;
        default:
            return Math.PI * size * size / 4;
    }
};
var $5d51e9d784c905d7$export$fa456266707bf4e4 = /*#__PURE__*/ function(_PureComponent) {
    $5d51e9d784c905d7$var$_inherits(Symbols, _PureComponent);
    var _super = $5d51e9d784c905d7$var$_createSuper(Symbols);
    function Symbols() {
        $5d51e9d784c905d7$var$_classCallCheck(this, Symbols);
        return _super.apply(this, arguments);
    }
    $5d51e9d784c905d7$var$_createClass(Symbols, [
        {
            key: "getPath",
            value: /**
     * Calculate the path of curve
     * @return {String} path
     */ function getPath() {
                var _this$props = this.props, size = _this$props.size, sizeType = _this$props.sizeType, type = _this$props.type;
                var symbolFactory = $5d51e9d784c905d7$var$getSymbolFactory(type);
                var symbol = (0, $d5dc9a4f2aa2bbbf$export$2e2bcd8739ae039)().type(symbolFactory).size($5d51e9d784c905d7$var$calculateAreaSize(size, sizeType, type));
                return symbol();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, className = _this$props2.className, cx = _this$props2.cx, cy = _this$props2.cy, size = _this$props2.size;
                if (cx === +cx && cy === +cy && size === +size) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("path", $5d51e9d784c905d7$var$_extends({}, (0, $05a192303b32ed93$export$d697c39a2985a4c)(this.props, true), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))("recharts-symbols", className),
                    transform: "translate(".concat(cx, ", ").concat(cy, ")"),
                    d: this.getPath()
                }));
                return null;
            }
        }
    ]);
    return Symbols;
}((0, $jC8Vy.PureComponent));
$5d51e9d784c905d7$export$fa456266707bf4e4.defaultProps = {
    type: "circle",
    size: 64,
    sizeType: "area"
};
$5d51e9d784c905d7$export$fa456266707bf4e4.registerSymbol = function(key, factory) {
    $5d51e9d784c905d7$var$symbolFactories["symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($ca2cccb92e57cec1$exports)))(key))] = factory;
};



function $aa69d9f43d96338a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $aa69d9f43d96338a$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $aa69d9f43d96338a$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $aa69d9f43d96338a$var$_typeof(obj);
}
function $aa69d9f43d96338a$var$_extends() {
    $aa69d9f43d96338a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $aa69d9f43d96338a$var$_extends.apply(this, arguments);
}
function $aa69d9f43d96338a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $aa69d9f43d96338a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $aa69d9f43d96338a$var$ownKeys(Object(source), true).forEach(function(key) {
            $aa69d9f43d96338a$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $aa69d9f43d96338a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $aa69d9f43d96338a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $aa69d9f43d96338a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $aa69d9f43d96338a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $aa69d9f43d96338a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $aa69d9f43d96338a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $aa69d9f43d96338a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $aa69d9f43d96338a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $aa69d9f43d96338a$var$_setPrototypeOf(subClass, superClass);
}
function $aa69d9f43d96338a$var$_setPrototypeOf(o, p) {
    $aa69d9f43d96338a$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $aa69d9f43d96338a$var$_setPrototypeOf(o, p);
}
function $aa69d9f43d96338a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $aa69d9f43d96338a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $aa69d9f43d96338a$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $aa69d9f43d96338a$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $aa69d9f43d96338a$var$_possibleConstructorReturn(this, result);
    };
}
function $aa69d9f43d96338a$var$_possibleConstructorReturn(self, call) {
    if (call && ($aa69d9f43d96338a$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $aa69d9f43d96338a$var$_assertThisInitialized(self);
}
function $aa69d9f43d96338a$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $aa69d9f43d96338a$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $aa69d9f43d96338a$var$_getPrototypeOf(o) {
    $aa69d9f43d96338a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $aa69d9f43d96338a$var$_getPrototypeOf(o);
}
var $aa69d9f43d96338a$var$SIZE = 32;
var $aa69d9f43d96338a$export$99f8d96ed0cededa = /*#__PURE__*/ function(_PureComponent) {
    $aa69d9f43d96338a$var$_inherits(DefaultLegendContent, _PureComponent);
    var _super = $aa69d9f43d96338a$var$_createSuper(DefaultLegendContent);
    function DefaultLegendContent() {
        $aa69d9f43d96338a$var$_classCallCheck(this, DefaultLegendContent);
        return _super.apply(this, arguments);
    }
    $aa69d9f43d96338a$var$_createClass(DefaultLegendContent, [
        {
            key: "renderIcon",
            value: /**
     * Render the path of icon
     * @param {Object} data Data of each legend item
     * @return {String} Path element
     */ function renderIcon(data) {
                var inactiveColor = this.props.inactiveColor;
                var halfSize = $aa69d9f43d96338a$var$SIZE / 2;
                var sixthSize = $aa69d9f43d96338a$var$SIZE / 6;
                var thirdSize = $aa69d9f43d96338a$var$SIZE / 3;
                var color = data.inactive ? inactiveColor : data.color;
                if (data.type === "plainline") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("line", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    strokeDasharray: data.payload.strokeDasharray,
                    x1: 0,
                    y1: halfSize,
                    x2: $aa69d9f43d96338a$var$SIZE,
                    y2: halfSize,
                    className: "recharts-legend-icon"
                });
                if (data.type === "line") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("path", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat($aa69d9f43d96338a$var$SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
                    className: "recharts-legend-icon"
                });
                if (data.type === "rect") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("path", {
                    stroke: "none",
                    fill: color,
                    d: "M0,".concat($aa69d9f43d96338a$var$SIZE / 8, "h").concat($aa69d9f43d96338a$var$SIZE, "v").concat($aa69d9f43d96338a$var$SIZE * 3 / 4, "h").concat(-$aa69d9f43d96338a$var$SIZE, "z"),
                    className: "recharts-legend-icon"
                });
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).isValidElement(data.legendIcon)) {
                    var iconProps = $aa69d9f43d96338a$var$_objectSpread({}, data);
                    delete iconProps.legendIcon;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).cloneElement(data.legendIcon, iconProps);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $5d51e9d784c905d7$export$fa456266707bf4e4), {
                    fill: color,
                    cx: halfSize,
                    cy: halfSize,
                    size: $aa69d9f43d96338a$var$SIZE,
                    sizeType: "diameter",
                    type: data.type
                });
            }
        },
        {
            key: "renderItems",
            value: function renderItems() {
                var _this = this;
                var _this$props = this.props, payload = _this$props.payload, iconSize = _this$props.iconSize, layout = _this$props.layout, formatter = _this$props.formatter, inactiveColor = _this$props.inactiveColor;
                var viewBox = {
                    x: 0,
                    y: 0,
                    width: $aa69d9f43d96338a$var$SIZE,
                    height: $aa69d9f43d96338a$var$SIZE
                };
                var itemStyle = {
                    display: layout === "horizontal" ? "inline-block" : "block",
                    marginRight: 10
                };
                var svgStyle = {
                    display: "inline-block",
                    verticalAlign: "middle",
                    marginRight: 4
                };
                return payload.map(function(entry, i) {
                    var _classNames;
                    var finalFormatter = entry.formatter || formatter;
                    var className = (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))((_classNames = {
                        "recharts-legend-item": true
                    }, $aa69d9f43d96338a$var$_defineProperty(_classNames, "legend-item-".concat(i), true), $aa69d9f43d96338a$var$_defineProperty(_classNames, "inactive", entry.inactive), _classNames));
                    if (entry.type === "none") return null;
                    var color = entry.inactive ? inactiveColor : entry.color;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("li", $aa69d9f43d96338a$var$_extends({
                        className: className,
                        style: itemStyle,
                        key: "legend-item-".concat(i) // eslint-disable-line react/no-array-index-key
                    }, (0, $05a192303b32ed93$export$ca62be0d67a3158c)(_this.props, entry, i)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $38e5da7c3943e1e6$export$7b92b459e668cb21), {
                        width: iconSize,
                        height: iconSize,
                        viewBox: viewBox,
                        style: svgStyle
                    }, _this.renderIcon(entry)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("span", {
                        className: "recharts-legend-item-text",
                        style: {
                            color: color
                        }
                    }, finalFormatter ? finalFormatter(entry.value, entry, i) : entry.value));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, payload = _this$props2.payload, layout = _this$props2.layout, align = _this$props2.align;
                if (!payload || !payload.length) return null;
                var finalStyle = {
                    padding: 0,
                    margin: 0,
                    textAlign: layout === "horizontal" ? align : "left"
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("ul", {
                    className: "recharts-default-legend",
                    style: finalStyle
                }, this.renderItems());
            }
        }
    ]);
    return DefaultLegendContent;
}((0, $jC8Vy.PureComponent));
$aa69d9f43d96338a$export$99f8d96ed0cededa.displayName = "Legend";
$aa69d9f43d96338a$export$99f8d96ed0cededa.defaultProps = {
    iconSize: 14,
    layout: "horizontal",
    align: "center",
    verticalAlign: "middle",
    inactiveColor: "#ccc"
};



function $6800f4603cf54f57$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6800f4603cf54f57$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6800f4603cf54f57$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6800f4603cf54f57$var$_typeof(obj);
}
function $6800f4603cf54f57$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6800f4603cf54f57$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $6800f4603cf54f57$var$ownKeys(Object(source), true).forEach(function(key) {
            $6800f4603cf54f57$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $6800f4603cf54f57$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6800f4603cf54f57$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6800f4603cf54f57$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6800f4603cf54f57$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6800f4603cf54f57$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6800f4603cf54f57$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6800f4603cf54f57$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $6800f4603cf54f57$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $6800f4603cf54f57$var$_setPrototypeOf(subClass, superClass);
}
function $6800f4603cf54f57$var$_setPrototypeOf(o, p) {
    $6800f4603cf54f57$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6800f4603cf54f57$var$_setPrototypeOf(o, p);
}
function $6800f4603cf54f57$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6800f4603cf54f57$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $6800f4603cf54f57$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $6800f4603cf54f57$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $6800f4603cf54f57$var$_possibleConstructorReturn(this, result);
    };
}
function $6800f4603cf54f57$var$_possibleConstructorReturn(self, call) {
    if (call && ($6800f4603cf54f57$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $6800f4603cf54f57$var$_assertThisInitialized(self);
}
function $6800f4603cf54f57$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6800f4603cf54f57$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $6800f4603cf54f57$var$_getPrototypeOf(o) {
    $6800f4603cf54f57$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6800f4603cf54f57$var$_getPrototypeOf(o);
}
function $6800f4603cf54f57$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6800f4603cf54f57$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6800f4603cf54f57$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $6800f4603cf54f57$var$defaultUniqBy(entry) {
    return entry.value;
}
function $6800f4603cf54f57$var$getUniqPayload(option, payload) {
    if (option === true) return (0, (/*@__PURE__*/$parcel$interopDefault($8cfdf43387bf2d0c$exports)))(payload, $6800f4603cf54f57$var$defaultUniqBy);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(option)) return (0, (/*@__PURE__*/$parcel$interopDefault($8cfdf43387bf2d0c$exports)))(payload, option);
    return payload;
}
function $6800f4603cf54f57$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).cloneElement(content, props);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement(content, props);
    var ref = props.ref, otherProps = $6800f4603cf54f57$var$_objectWithoutProperties(props, [
        "ref"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aa69d9f43d96338a$export$99f8d96ed0cededa), otherProps);
}
var $6800f4603cf54f57$var$EPS = 1;
var $6800f4603cf54f57$export$ed247974535929c7 = /*#__PURE__*/ function(_PureComponent) {
    $6800f4603cf54f57$var$_inherits(Legend, _PureComponent);
    var _super = $6800f4603cf54f57$var$_createSuper(Legend);
    function Legend() {
        var _this;
        $6800f4603cf54f57$var$_classCallCheck(this, Legend);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.wrapperNode = void 0;
        _this.state = {
            boxWidth: -1,
            boxHeight: -1
        };
        return _this;
    }
    $6800f4603cf54f57$var$_createClass(Legend, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateBBox();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateBBox();
            }
        },
        {
            key: "getBBox",
            value: function getBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) return this.wrapperNode.getBoundingClientRect();
                return null;
            }
        },
        {
            key: "getBBoxSnapshot",
            value: function getBBoxSnapshot() {
                var _this$state = this.state, boxWidth = _this$state.boxWidth, boxHeight = _this$state.boxHeight;
                if (boxWidth >= 0 && boxHeight >= 0) return {
                    width: boxWidth,
                    height: boxHeight
                };
                return null;
            }
        },
        {
            key: "getDefaultPosition",
            value: function getDefaultPosition(style) {
                var _this$props = this.props, layout = _this$props.layout, align = _this$props.align, verticalAlign = _this$props.verticalAlign, margin = _this$props.margin, chartWidth = _this$props.chartWidth, chartHeight = _this$props.chartHeight;
                var hPos, vPos;
                if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
                    if (align === "center" && layout === "vertical") {
                        var _box = this.getBBoxSnapshot() || {
                            width: 0
                        };
                        hPos = {
                            left: ((chartWidth || 0) - _box.width) / 2
                        };
                    } else hPos = align === "right" ? {
                        right: margin && margin.right || 0
                    } : {
                        left: margin && margin.left || 0
                    };
                }
                if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
                    if (verticalAlign === "middle") {
                        var _box2 = this.getBBoxSnapshot() || {
                            height: 0
                        };
                        vPos = {
                            top: ((chartHeight || 0) - _box2.height) / 2
                        };
                    } else vPos = verticalAlign === "bottom" ? {
                        bottom: margin && margin.bottom || 0
                    } : {
                        top: margin && margin.top || 0
                    };
                }
                return $6800f4603cf54f57$var$_objectSpread($6800f4603cf54f57$var$_objectSpread({}, hPos), vPos);
            }
        },
        {
            key: "updateBBox",
            value: function updateBBox() {
                var _this$state2 = this.state, boxWidth = _this$state2.boxWidth, boxHeight = _this$state2.boxHeight;
                var onBBoxUpdate = this.props.onBBoxUpdate;
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var _box3 = this.wrapperNode.getBoundingClientRect();
                    if (Math.abs(_box3.width - boxWidth) > $6800f4603cf54f57$var$EPS || Math.abs(_box3.height - boxHeight) > $6800f4603cf54f57$var$EPS) this.setState({
                        boxWidth: _box3.width,
                        boxHeight: _box3.height
                    }, function() {
                        if (onBBoxUpdate) onBBoxUpdate(_box3);
                    });
                } else if (boxWidth !== -1 || boxHeight !== -1) this.setState({
                    boxWidth: -1,
                    boxHeight: -1
                }, function() {
                    if (onBBoxUpdate) onBBoxUpdate(null);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, content = _this$props2.content, width = _this$props2.width, height = _this$props2.height, wrapperStyle = _this$props2.wrapperStyle, payloadUniqBy = _this$props2.payloadUniqBy, payload = _this$props2.payload;
                var outerStyle = $6800f4603cf54f57$var$_objectSpread($6800f4603cf54f57$var$_objectSpread({
                    position: "absolute",
                    width: width || "auto",
                    height: height || "auto"
                }, this.getDefaultPosition(wrapperStyle)), wrapperStyle);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    className: "recharts-legend-wrapper",
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, $6800f4603cf54f57$var$renderContent(content, $6800f4603cf54f57$var$_objectSpread($6800f4603cf54f57$var$_objectSpread({}, this.props), {}, {
                    payload: $6800f4603cf54f57$var$getUniqPayload(payloadUniqBy, payload)
                })));
            }
        }
    ], [
        {
            key: "getWithHeight",
            value: function getWithHeight(item, chartWidth) {
                var layout = item.props.layout;
                if (layout === "vertical" && (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(item.props.height)) return {
                    height: item.props.height
                };
                if (layout === "horizontal") return {
                    width: item.props.width || chartWidth
                };
                return null;
            }
        }
    ]);
    return Legend;
}((0, $jC8Vy.PureComponent));
$6800f4603cf54f57$export$ed247974535929c7.displayName = "Legend";
$6800f4603cf54f57$export$ed247974535929c7.defaultProps = {
    iconSize: 14,
    layout: "horizontal",
    align: "center",
    verticalAlign: "bottom"
};




function $c86c74861e78fc13$var$_toConsumableArray(arr) {
    return $c86c74861e78fc13$var$_arrayWithoutHoles(arr) || $c86c74861e78fc13$var$_iterableToArray(arr) || $c86c74861e78fc13$var$_unsupportedIterableToArray(arr) || $c86c74861e78fc13$var$_nonIterableSpread();
}
function $c86c74861e78fc13$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c86c74861e78fc13$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c86c74861e78fc13$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c86c74861e78fc13$var$_arrayLikeToArray(o, minLen);
}
function $c86c74861e78fc13$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $c86c74861e78fc13$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $c86c74861e78fc13$var$_arrayLikeToArray(arr);
}
function $c86c74861e78fc13$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c86c74861e78fc13$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c86c74861e78fc13$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $c86c74861e78fc13$var$ownKeys(Object(source), true).forEach(function(key) {
            $c86c74861e78fc13$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $c86c74861e78fc13$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c86c74861e78fc13$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c86c74861e78fc13$export$f97fc4a450f29a(obj, dataKey, defaultValue) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(obj) || (0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(dataKey)) return defaultValue;
    if ((0, $804fab7e7cc9eb97$export$402a499e1ea44294)(dataKey)) return (0, (/*@__PURE__*/$parcel$interopDefault($2cd7f9f9c3b27772$exports)))(obj, dataKey, defaultValue);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(dataKey)) return dataKey(obj);
    return defaultValue;
}
function $c86c74861e78fc13$export$6a1e7873444c95a7(data, key, type, filterNil) {
    var flattenData = (0, (/*@__PURE__*/$parcel$interopDefault($3cd41a512b6ad1e6$exports)))(data, function(entry) {
        return $c86c74861e78fc13$export$f97fc4a450f29a(entry, key);
    });
    if (type === "number") {
        var domain = flattenData.filter(function(entry) {
            return (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(entry) || parseFloat(entry);
        });
        return domain.length ? [
            (0, (/*@__PURE__*/$parcel$interopDefault($b554c0681cbe33f9$exports)))(domain),
            (0, (/*@__PURE__*/$parcel$interopDefault($341369312ca6ec3a$exports)))(domain)
        ] : [
            Infinity,
            -Infinity
        ];
    }
    var validateData = filterNil ? flattenData.filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(entry);
    }) : flattenData; // 支持Date类型的x轴
    return validateData.map(function(entry) {
        return (0, $804fab7e7cc9eb97$export$402a499e1ea44294)(entry) || entry instanceof Date ? entry : "";
    });
}
var $c86c74861e78fc13$export$3071d39cc844078e = function calculateActiveTickIndex(coordinate) {
    var _ticks$length;
    var ticks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var unsortedTicks = arguments.length > 2 ? arguments[2] : undefined;
    var axis = arguments.length > 3 ? arguments[3] : undefined;
    var index = -1;
    var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
    if (len > 1) {
        if (axis && axis.axisType === "angleAxis" && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
            var range = axis.range; // ticks are distributed in a circle
            for(var i = 0; i < len; i++){
                var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
                var cur = unsortedTicks[i].coordinate;
                var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
                var sameDirectionCoord = void 0;
                if ((0, $804fab7e7cc9eb97$export$9d334328eb75e624)(cur - before) !== (0, $804fab7e7cc9eb97$export$9d334328eb75e624)(after - cur)) {
                    var diffInterval = [];
                    if ((0, $804fab7e7cc9eb97$export$9d334328eb75e624)(after - cur) === (0, $804fab7e7cc9eb97$export$9d334328eb75e624)(range[1] - range[0])) {
                        sameDirectionCoord = after;
                        var curInRange = cur + range[1] - range[0];
                        diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
                        diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
                    } else {
                        sameDirectionCoord = before;
                        var afterInRange = after + range[1] - range[0];
                        diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
                        diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
                    }
                    var sameInterval = [
                        Math.min(cur, (sameDirectionCoord + cur) / 2),
                        Math.max(cur, (sameDirectionCoord + cur) / 2)
                    ];
                    if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
                        index = unsortedTicks[i].index;
                        break;
                    }
                } else {
                    var min = Math.min(before, after);
                    var max = Math.max(before, after);
                    if (coordinate > (min + cur) / 2 && coordinate <= (max + cur) / 2) {
                        index = unsortedTicks[i].index;
                        break;
                    }
                }
            }
        } else {
            // ticks are distributed in a single direction
            for(var _i = 0; _i < len; _i++)if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
                index = ticks[_i].index;
                break;
            }
        }
    } else index = 0;
    return index;
};
var $c86c74861e78fc13$export$ec6cab5a7a3b93bf = function getMainColorOfGraphicItem(item) {
    var _ref = item, displayName = _ref.type.displayName; // TODO: check if displayName is valid.
    var _item$props = item.props, stroke = _item$props.stroke, fill = _item$props.fill;
    var result;
    switch(displayName){
        case "Line":
            result = stroke;
            break;
        case "Area":
        case "Radar":
            result = stroke && stroke !== "none" ? stroke : fill;
            break;
        default:
            result = fill;
            break;
    }
    return result;
};
var $c86c74861e78fc13$export$8f9424d123c36aa = function getLegendProps(_ref2) {
    var children = _ref2.children, formattedGraphicalItems = _ref2.formattedGraphicalItems, legendWidth = _ref2.legendWidth, legendContent = _ref2.legendContent;
    var legendItem = (0, $217577d291f12aa3$export$64c61536a2b72e0f)(children, (0, $6800f4603cf54f57$export$ed247974535929c7).displayName);
    if (!legendItem) return null;
    var legendData;
    if (legendItem.props && legendItem.props.payload) legendData = legendItem.props && legendItem.props.payload;
    else if (legendContent === "children") legendData = (formattedGraphicalItems || []).reduce(function(result, _ref3) {
        var item = _ref3.item, props = _ref3.props;
        var data = props.sectors || props.data || [];
        return result.concat(data.map(function(entry) {
            return {
                type: legendItem.props.iconType || item.props.legendType,
                value: entry.name,
                color: entry.fill,
                payload: entry
            };
        }));
    }, []);
    else legendData = (formattedGraphicalItems || []).map(function(_ref4) {
        var item = _ref4.item;
        var _item$props2 = item.props, dataKey = _item$props2.dataKey, name = _item$props2.name, legendType = _item$props2.legendType, hide = _item$props2.hide;
        return {
            inactive: hide,
            dataKey: dataKey,
            type: legendItem.props.iconType || legendType || "square",
            color: $c86c74861e78fc13$export$ec6cab5a7a3b93bf(item),
            value: name || dataKey,
            payload: item.props
        };
    });
    return $c86c74861e78fc13$var$_objectSpread($c86c74861e78fc13$var$_objectSpread($c86c74861e78fc13$var$_objectSpread({}, legendItem.props), (0, $6800f4603cf54f57$export$ed247974535929c7).getWithHeight(legendItem, legendWidth)), {}, {
        payload: legendData,
        item: legendItem
    });
};
var $c86c74861e78fc13$export$570d306bee26c748 = function getBarSizeList(_ref5) {
    var globalSize = _ref5.barSize, _ref5$stackGroups = _ref5.stackGroups, stackGroups = _ref5$stackGroups === void 0 ? {} : _ref5$stackGroups;
    if (!stackGroups) return {};
    var result = {};
    var numericAxisIds = Object.keys(stackGroups);
    for(var i = 0, len = numericAxisIds.length; i < len; i++){
        var sgs = stackGroups[numericAxisIds[i]].stackGroups;
        var stackIds = Object.keys(sgs);
        for(var j = 0, sLen = stackIds.length; j < sLen; j++){
            var _sgs$stackIds$j = sgs[stackIds[j]], items = _sgs$stackIds$j.items, cateAxisId = _sgs$stackIds$j.cateAxisId;
            var barItems = items.filter(function(item) {
                return (0, $217577d291f12aa3$export$be63e0664592e141)(item.type).indexOf("Bar") >= 0;
            });
            if (barItems && barItems.length) {
                var selfSize = barItems[0].props.barSize;
                var cateId = barItems[0].props[cateAxisId];
                if (!result[cateId]) result[cateId] = [];
                result[cateId].push({
                    item: barItems[0],
                    stackList: barItems.slice(1),
                    barSize: (0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(selfSize) ? globalSize : selfSize
                });
            }
        }
    }
    return result;
};
var $c86c74861e78fc13$export$d36834ecd87f906b = function getBarPosition(_ref6) {
    var barGap = _ref6.barGap, barCategoryGap = _ref6.barCategoryGap, bandSize = _ref6.bandSize, _ref6$sizeList = _ref6.sizeList, sizeList = _ref6$sizeList === void 0 ? [] : _ref6$sizeList, maxBarSize = _ref6.maxBarSize;
    var len = sizeList.length;
    if (len < 1) return null;
    var realBarGap = (0, $804fab7e7cc9eb97$export$476354dbf49bdff6)(barGap, bandSize, 0, true);
    var result; // whether or not is barSize setted by user
    if (sizeList[0].barSize === +sizeList[0].barSize) {
        var useFull = false;
        var fullBarSize = bandSize / len;
        var sum = sizeList.reduce(function(res, entry) {
            return res + entry.barSize || 0;
        }, 0);
        sum += (len - 1) * realBarGap;
        if (sum >= bandSize) {
            sum -= (len - 1) * realBarGap;
            realBarGap = 0;
        }
        if (sum >= bandSize && fullBarSize > 0) {
            useFull = true;
            fullBarSize *= 0.9;
            sum = len * fullBarSize;
        }
        var offset = (bandSize - sum) / 2 >> 0;
        var prev = {
            offset: offset - realBarGap,
            size: 0
        };
        result = sizeList.reduce(function(res, entry) {
            var newRes = [].concat($c86c74861e78fc13$var$_toConsumableArray(res), [
                {
                    item: entry.item,
                    position: {
                        offset: prev.offset + prev.size + realBarGap,
                        size: useFull ? fullBarSize : entry.barSize
                    }
                }
            ]);
            prev = newRes[newRes.length - 1].position;
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: prev
                });
            });
            return newRes;
        }, []);
    } else {
        var _offset = (0, $804fab7e7cc9eb97$export$476354dbf49bdff6)(barCategoryGap, bandSize, 0, true);
        if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) realBarGap = 0;
        var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
        if (originalSize > 1) originalSize >>= 0;
        var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
        result = sizeList.reduce(function(res, entry, i) {
            var newRes = [].concat($c86c74861e78fc13$var$_toConsumableArray(res), [
                {
                    item: entry.item,
                    position: {
                        offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
                        size: size
                    }
                }
            ]);
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: newRes[newRes.length - 1].position
                });
            });
            return newRes;
        }, []);
    }
    return result;
};
var $c86c74861e78fc13$export$3a657a8c9f789617 = function appendOffsetOfLegend(offset, items, props, legendBox) {
    var children = props.children, width = props.width, margin = props.margin;
    var legendWidth = width - (margin.left || 0) - (margin.right || 0); // const legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
    var legendProps = $c86c74861e78fc13$export$8f9424d123c36aa({
        children: children,
        legendWidth: legendWidth
    });
    var newOffset = offset;
    if (legendProps) {
        var box = legendBox || {};
        var align = legendProps.align, verticalAlign = legendProps.verticalAlign, layout = legendProps.layout;
        if ((layout === "vertical" || layout === "horizontal" && verticalAlign === "center") && (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(offset[align])) newOffset = $c86c74861e78fc13$var$_objectSpread($c86c74861e78fc13$var$_objectSpread({}, offset), {}, $c86c74861e78fc13$var$_defineProperty({}, align, newOffset[align] + (box.width || 0)));
        if ((layout === "horizontal" || layout === "vertical" && align === "center") && (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(offset[verticalAlign])) newOffset = $c86c74861e78fc13$var$_objectSpread($c86c74861e78fc13$var$_objectSpread({}, offset), {}, $c86c74861e78fc13$var$_defineProperty({}, verticalAlign, newOffset[verticalAlign] + (box.height || 0)));
    }
    return newOffset;
};
var $c86c74861e78fc13$var$isErrorBarRelevantForAxis = function isErrorBarRelevantForAxis(layout, axisType, direction) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(axisType)) return true;
    if (layout === "horizontal") return axisType === "yAxis";
    if (layout === "vertical") return axisType === "xAxis";
    if (direction === "x") return axisType === "xAxis";
    if (direction === "y") return axisType === "yAxis";
    return true;
};
var $c86c74861e78fc13$export$8a46d1a2b0f8e61a = function getDomainOfErrorBars(data, item, dataKey, layout, axisType) {
    var children = item.props.children;
    var errorBars = (0, $217577d291f12aa3$export$fdd5e64c0e8495bb)(children, "ErrorBar").filter(function(errorBarChild) {
        return $c86c74861e78fc13$var$isErrorBarRelevantForAxis(layout, axisType, errorBarChild.props.direction);
    });
    if (errorBars && errorBars.length) {
        var keys = errorBars.map(function(errorBarChild) {
            return errorBarChild.props.dataKey;
        });
        return data.reduce(function(result, entry) {
            var entryValue = $c86c74861e78fc13$export$f97fc4a450f29a(entry, dataKey, 0);
            var mainValue = (0, (/*@__PURE__*/$parcel$interopDefault($0fe4a5546443a34c$exports)))(entryValue) ? [
                (0, (/*@__PURE__*/$parcel$interopDefault($b554c0681cbe33f9$exports)))(entryValue),
                (0, (/*@__PURE__*/$parcel$interopDefault($341369312ca6ec3a$exports)))(entryValue)
            ] : [
                entryValue,
                entryValue
            ];
            var errorDomain = keys.reduce(function(prevErrorArr, k) {
                var errorValue = $c86c74861e78fc13$export$f97fc4a450f29a(entry, k, 0);
                var lowerValue = mainValue[0] - Math.abs((0, (/*@__PURE__*/$parcel$interopDefault($0fe4a5546443a34c$exports)))(errorValue) ? errorValue[0] : errorValue);
                var upperValue = mainValue[1] + Math.abs((0, (/*@__PURE__*/$parcel$interopDefault($0fe4a5546443a34c$exports)))(errorValue) ? errorValue[1] : errorValue);
                return [
                    Math.min(lowerValue, prevErrorArr[0]),
                    Math.max(upperValue, prevErrorArr[1])
                ];
            }, [
                Infinity,
                -Infinity
            ]);
            return [
                Math.min(errorDomain[0], result[0]),
                Math.max(errorDomain[1], result[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
    }
    return null;
};
var $c86c74861e78fc13$export$2266342e22c737e8 = function parseErrorBarsOfAxis(data, items, dataKey, axisType, layout) {
    var domains = items.map(function(item) {
        return $c86c74861e78fc13$export$8a46d1a2b0f8e61a(data, item, dataKey, layout, axisType);
    }).filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(entry);
    });
    if (domains && domains.length) return domains.reduce(function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    return null;
};
var $c86c74861e78fc13$export$c92c4f4286b1390d = function getDomainOfItemsWithSameAxis(data, items, type, layout, filterNil) {
    var domains = items.map(function(item) {
        var dataKey = item.props.dataKey;
        if (type === "number" && dataKey) return $c86c74861e78fc13$export$8a46d1a2b0f8e61a(data, item, dataKey, layout) || $c86c74861e78fc13$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
        return $c86c74861e78fc13$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
    });
    if (type === "number") // Calculate the domain of number axis
    return domains.reduce(function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    var tag = {}; // Get the union set of category axis
    return domains.reduce(function(result, entry) {
        for(var i = 0, len = entry.length; i < len; i++)if (!tag[entry[i]]) {
            tag[entry[i]] = true;
            result.push(entry[i]);
        }
        return result;
    }, []);
};
var $c86c74861e78fc13$export$9fc1baaa6c6368b = function isCategoricalAxis(layout, axisType) {
    return layout === "horizontal" && axisType === "xAxis" || layout === "vertical" && axisType === "yAxis" || layout === "centric" && axisType === "angleAxis" || layout === "radial" && axisType === "radiusAxis";
};
var $c86c74861e78fc13$export$846dc5ac5fecff74 = function getCoordinatesOfGrid(ticks, min, max) {
    var hasMin, hasMax;
    var values = ticks.map(function(entry) {
        if (entry.coordinate === min) hasMin = true;
        if (entry.coordinate === max) hasMax = true;
        return entry.coordinate;
    });
    if (!hasMin) values.push(min);
    if (!hasMax) values.push(max);
    return values;
};
var $c86c74861e78fc13$export$c829ee42daf7f66d = function getTicksOfAxis(axis, isGrid, isAll) {
    if (!axis) return null;
    var scale = axis.scale;
    var duplicateDomain = axis.duplicateDomain, type = axis.type, range = axis.range;
    var offsetForBand = axis.realScaleType === "scaleBand" ? scale.bandwidth() / 2 : 2;
    var offset = (isGrid || isAll) && type === "category" && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axis.axisType === "angleAxis" ? (0, $804fab7e7cc9eb97$export$9d334328eb75e624)(range[0] - range[1]) * 2 * offset : offset; // The ticks setted by user should only affect the ticks adjacent to axis line
    if (isGrid && (axis.ticks || axis.niceTicks)) return (axis.ticks || axis.niceTicks).map(function(entry) {
        var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
        return {
            coordinate: scale(scaleContent) + offset,
            value: entry,
            offset: offset
        };
    });
     // When axis is a categorial axis, but the type of axis is number or the scale of axis is not "auto"
    if (axis.isCategorical && axis.categoricalDomain) return axis.categoricalDomain.map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        };
    });
    if (scale.ticks && !isAll) return scale.ticks(axis.tickCount).map(function(entry) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            offset: offset
        };
    });
     // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    });
};
var $c86c74861e78fc13$export$760ec406ba47bace = function combineEventHandlers(defaultHandler, parentHandler, childHandler) {
    var customizedHandler;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(childHandler)) customizedHandler = childHandler;
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(parentHandler)) customizedHandler = parentHandler;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(defaultHandler) || customizedHandler) return function(arg1, arg2, arg3, arg4) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(defaultHandler)) defaultHandler(arg1, arg2, arg3, arg4);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(customizedHandler)) customizedHandler(arg1, arg2, arg3, arg4);
    };
    return null;
};
var $c86c74861e78fc13$export$534b094a708572c1 = function parseScale(axis, chartType, hasBar) {
    var scale = axis.scale, type = axis.type, layout = axis.layout, axisType = axis.axisType;
    if (scale === "auto") {
        if (layout === "radial" && axisType === "radiusAxis") return {
            scale: $2a153db2e34e7246$exports.scaleBand(),
            realScaleType: "band"
        };
        if (layout === "radial" && axisType === "angleAxis") return {
            scale: $2a153db2e34e7246$exports.scaleLinear(),
            realScaleType: "linear"
        };
        if (type === "category" && chartType && (chartType.indexOf("LineChart") >= 0 || chartType.indexOf("AreaChart") >= 0 || chartType.indexOf("ComposedChart") >= 0 && !hasBar)) return {
            scale: $2a153db2e34e7246$exports.scalePoint(),
            realScaleType: "point"
        };
        if (type === "category") return {
            scale: $2a153db2e34e7246$exports.scaleBand(),
            realScaleType: "band"
        };
        return {
            scale: $2a153db2e34e7246$exports.scaleLinear(),
            realScaleType: "linear"
        };
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3719ffca02e94280$exports)))(scale)) {
        var name = "scale".concat((0, (/*@__PURE__*/$parcel$interopDefault($ca2cccb92e57cec1$exports)))(scale));
        return {
            scale: ($2a153db2e34e7246$exports[name] || $2a153db2e34e7246$exports.scalePoint)(),
            realScaleType: $2a153db2e34e7246$exports[name] ? name : "point"
        };
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(scale) ? {
        scale: scale
    } : {
        scale: $2a153db2e34e7246$exports.scalePoint(),
        realScaleType: "point"
    };
};
var $c86c74861e78fc13$var$EPS = 1e-4;
var $c86c74861e78fc13$export$9d80152e23bae434 = function checkDomainOfScale(scale) {
    var domain = scale.domain();
    if (!domain || domain.length <= 2) return;
    var len = domain.length;
    var range = scale.range();
    var min = Math.min(range[0], range[1]) - $c86c74861e78fc13$var$EPS;
    var max = Math.max(range[0], range[1]) + $c86c74861e78fc13$var$EPS;
    var first = scale(domain[0]);
    var last = scale(domain[len - 1]);
    if (first < min || first > max || last < min || last > max) scale.domain([
        domain[0],
        domain[len - 1]
    ]);
};
var $c86c74861e78fc13$export$778e70011fdf4625 = function findPositionOfBar(barPosition, child) {
    if (!barPosition) return null;
    for(var i = 0, len = barPosition.length; i < len; i++){
        if (barPosition[i].item === child) return barPosition[i].position;
    }
    return null;
};
var $c86c74861e78fc13$export$c7ec0fa96d0c462e = function truncateByDomain(value, domain) {
    if (!domain || domain.length !== 2 || !(0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(domain[0]) || !(0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(domain[1])) return value;
    var min = Math.min(domain[0], domain[1]);
    var max = Math.max(domain[0], domain[1]);
    var result = [
        value[0],
        value[1]
    ];
    if (!(0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(value[0]) || value[0] < min) result[0] = min;
    if (!(0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(value[1]) || value[1] > max) result[1] = max;
    if (result[0] > max) result[0] = max;
    if (result[1] < min) result[1] = min;
    return result;
};
var $c86c74861e78fc13$export$3104c513558164c1 = function offsetSign(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        var negative = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($044ab485528b5c52$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = negative;
                series[i][j][1] = negative + value;
                negative = series[i][j][1];
            }
        /* eslint-enable prefer-destructuring */ }
    }
};
var $c86c74861e78fc13$export$9f2c6ead70935022 = function offsetPositive(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($044ab485528b5c52$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = 0;
                series[i][j][1] = 0;
            }
        /* eslint-enable prefer-destructuring */ }
    }
};
var $c86c74861e78fc13$var$STACK_OFFSET_MAP = {
    sign: $c86c74861e78fc13$export$3104c513558164c1,
    expand: (0, $afa3e07987918589$export$2e2bcd8739ae039),
    none: (0, $486a3fa71ebe57d2$export$2e2bcd8739ae039),
    silhouette: (0, $fc2143221f358c55$export$2e2bcd8739ae039),
    wiggle: (0, $4e5c02106e9852b6$export$2e2bcd8739ae039),
    positive: $c86c74861e78fc13$export$9f2c6ead70935022
};
var $c86c74861e78fc13$export$c2170542cfc0177c = function getStackedData(data, stackItems, offsetType) {
    var dataKeys = stackItems.map(function(item) {
        return item.props.dataKey;
    });
    var stack = (0, $f6122f905ec4bfff$export$2e2bcd8739ae039)().keys(dataKeys).value(function(d, key) {
        return +$c86c74861e78fc13$export$f97fc4a450f29a(d, key, 0);
    }).order((0, $765ad40d93feffec$export$2e2bcd8739ae039)).offset($c86c74861e78fc13$var$STACK_OFFSET_MAP[offsetType]);
    return stack(data);
};
var $c86c74861e78fc13$export$9af3ba56474b9601 = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
    if (!data) return null;
     // reversing items to affect render order (for layering)
    var items = reverseStackOrder ? _items.reverse() : _items;
    var stackGroups = items.reduce(function(result, item) {
        var _item$props3 = item.props, stackId = _item$props3.stackId, hide = _item$props3.hide;
        if (hide) return result;
        var axisId = item.props[numericAxisId];
        var parentGroup = result[axisId] || {
            hasStack: false,
            stackGroups: {}
        };
        if ((0, $804fab7e7cc9eb97$export$402a499e1ea44294)(stackId)) {
            var childGroup = parentGroup.stackGroups[stackId] || {
                numericAxisId: numericAxisId,
                cateAxisId: cateAxisId,
                items: []
            };
            childGroup.items.push(item);
            parentGroup.hasStack = true;
            parentGroup.stackGroups[stackId] = childGroup;
        } else parentGroup.stackGroups[(0, $804fab7e7cc9eb97$export$8b15d37bc3f197d4)("_stackId_")] = {
            numericAxisId: numericAxisId,
            cateAxisId: cateAxisId,
            items: [
                item
            ]
        };
        return $c86c74861e78fc13$var$_objectSpread($c86c74861e78fc13$var$_objectSpread({}, result), {}, $c86c74861e78fc13$var$_defineProperty({}, axisId, parentGroup));
    }, {});
    return Object.keys(stackGroups).reduce(function(result, axisId) {
        var group = stackGroups[axisId];
        if (group.hasStack) group.stackGroups = Object.keys(group.stackGroups).reduce(function(res, stackId) {
            var g = group.stackGroups[stackId];
            return $c86c74861e78fc13$var$_objectSpread($c86c74861e78fc13$var$_objectSpread({}, res), {}, $c86c74861e78fc13$var$_defineProperty({}, stackId, {
                numericAxisId: numericAxisId,
                cateAxisId: cateAxisId,
                items: g.items,
                stackedData: $c86c74861e78fc13$export$c2170542cfc0177c(data, g.items, offsetType)
            }));
        }, {});
        return $c86c74861e78fc13$var$_objectSpread($c86c74861e78fc13$var$_objectSpread({}, result), {}, $c86c74861e78fc13$var$_defineProperty({}, axisId, group));
    }, {});
};
var $c86c74861e78fc13$export$ddbfea630ecc591e = function calculateDomainOfTicks(ticks, type) {
    if (type === "number") return [
        (0, (/*@__PURE__*/$parcel$interopDefault($b554c0681cbe33f9$exports)))(ticks),
        (0, (/*@__PURE__*/$parcel$interopDefault($341369312ca6ec3a$exports)))(ticks)
    ];
    return ticks;
};
var $c86c74861e78fc13$export$ac086aaa4358d590 = function getTicksOfScale(scale, opts) {
    var realScaleType = opts.realScaleType, type = opts.type, tickCount = opts.tickCount, originalDomain = opts.originalDomain, allowDecimals = opts.allowDecimals;
    var scaleType = realScaleType || opts.scale;
    if (scaleType !== "auto" && scaleType !== "linear") return null;
    if (tickCount && type === "number" && originalDomain && (originalDomain[0] === "auto" || originalDomain[1] === "auto")) {
        // Calculate the ticks by the number of grid when the axis is a number axis
        var domain = scale.domain();
        if (!domain.length) return null;
        var tickValues = (0, $1f2680d726e2bea7$export$b84e75ccbfe6a612)(domain, tickCount, allowDecimals);
        scale.domain($c86c74861e78fc13$export$ddbfea630ecc591e(tickValues, type));
        return {
            niceTicks: tickValues
        };
    }
    if (tickCount && type === "number") {
        var _domain = scale.domain();
        var _tickValues = (0, $1f2680d726e2bea7$export$e9d28da780436e98)(_domain, tickCount, allowDecimals);
        return {
            niceTicks: _tickValues
        };
    }
    return null;
};
var $c86c74861e78fc13$export$6e87f3defb83c3f = function getCateCoordinateOfLine(_ref7) {
    var axis = _ref7.axis, ticks = _ref7.ticks, bandSize = _ref7.bandSize, entry = _ref7.entry, index = _ref7.index, dataKey = _ref7.dataKey;
    if (axis.type === "category") {
        // find coordinate of category axis by the value of category
        if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(entry[axis.dataKey])) {
            var matchedTick = (0, $804fab7e7cc9eb97$export$66950d3869f5cc67)(ticks, "value", entry[axis.dataKey]);
            if (matchedTick) return matchedTick.coordinate + bandSize / 2;
        }
        return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
    }
    var value = $c86c74861e78fc13$export$f97fc4a450f29a(entry, !(0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(dataKey) ? dataKey : axis.dataKey);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(value) ? axis.scale(value) : null;
};
var $c86c74861e78fc13$export$8abb9e87422f3a0c = function getCateCoordinateOfBar(_ref8) {
    var axis = _ref8.axis, ticks = _ref8.ticks, offset = _ref8.offset, bandSize = _ref8.bandSize, entry = _ref8.entry, index = _ref8.index;
    if (axis.type === "category") return ticks[index] ? ticks[index].coordinate + offset : null;
    var value = $c86c74861e78fc13$export$f97fc4a450f29a(entry, axis.dataKey, axis.domain[index]);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};
var $c86c74861e78fc13$export$54f3200dd4a8a235 = function getBaseValueOfBar(_ref9) {
    var numericAxis = _ref9.numericAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === "number") {
        var min = Math.min(domain[0], domain[1]);
        var max = Math.max(domain[0], domain[1]);
        if (min <= 0 && max >= 0) return 0;
        if (max < 0) return max;
        return min;
    }
    return domain[0];
};
var $c86c74861e78fc13$export$a17bf3d98457878c = function getStackedDataOfItem(item, stackGroups) {
    var stackId = item.props.stackId;
    if ((0, $804fab7e7cc9eb97$export$402a499e1ea44294)(stackId)) {
        var group = stackGroups[stackId];
        if (group && group.items.length) {
            var itemIndex = -1;
            for(var i = 0, len = group.items.length; i < len; i++)if (group.items[i] === item) {
                itemIndex = i;
                break;
            }
            return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
        }
    }
    return null;
};
var $c86c74861e78fc13$var$getDomainOfSingle = function getDomainOfSingle(data) {
    return data.reduce(function(result, entry) {
        return [
            (0, (/*@__PURE__*/$parcel$interopDefault($b554c0681cbe33f9$exports)))(entry.concat([
                result[0]
            ]).filter((0, $804fab7e7cc9eb97$export$7e4aa119212bc614))),
            (0, (/*@__PURE__*/$parcel$interopDefault($341369312ca6ec3a$exports)))(entry.concat([
                result[1]
            ]).filter((0, $804fab7e7cc9eb97$export$7e4aa119212bc614)))
        ];
    }, [
        Infinity,
        -Infinity
    ]);
};
var $c86c74861e78fc13$export$26522b779eb5497c = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
    return Object.keys(stackGroups).reduce(function(result, stackId) {
        var group = stackGroups[stackId];
        var stackedData = group.stackedData;
        var domain = stackedData.reduce(function(res, entry) {
            var s = $c86c74861e78fc13$var$getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
            return [
                Math.min(res[0], s[0]),
                Math.max(res[1], s[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
        return [
            Math.min(domain[0], result[0]),
            Math.max(domain[1], result[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]).map(function(result) {
        return result === Infinity || result === -Infinity ? 0 : result;
    });
};
var $c86c74861e78fc13$export$75a7b23ff266dfa1 = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $c86c74861e78fc13$export$19c111ec8ad6c644 = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $c86c74861e78fc13$export$a0bc8660980558a0 = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(specifiedDomain)) return specifiedDomain(dataDomain, allowDataOverflow);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($0fe4a5546443a34c$exports)))(specifiedDomain)) return dataDomain;
    var domain = [];
    /* eslint-disable prefer-destructuring */ if ((0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(specifiedDomain[0])) domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
    else if ($c86c74861e78fc13$export$75a7b23ff266dfa1.test(specifiedDomain[0])) {
        var value = +$c86c74861e78fc13$export$75a7b23ff266dfa1.exec(specifiedDomain[0])[1];
        domain[0] = dataDomain[0] - value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(specifiedDomain[0])) domain[0] = specifiedDomain[0](dataDomain[0]);
    else domain[0] = dataDomain[0];
    if ((0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(specifiedDomain[1])) domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
    else if ($c86c74861e78fc13$export$19c111ec8ad6c644.test(specifiedDomain[1])) {
        var _value = +$c86c74861e78fc13$export$19c111ec8ad6c644.exec(specifiedDomain[1])[1];
        domain[1] = dataDomain[1] + _value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(specifiedDomain[1])) domain[1] = specifiedDomain[1](dataDomain[1]);
    else domain[1] = dataDomain[1];
    /* eslint-enable prefer-destructuring */ return domain;
};
var $c86c74861e78fc13$export$212ec45c42fe68a7 = function getBandSizeOfAxis(axis, ticks, isBar) {
    if (axis && axis.scale && axis.scale.bandwidth) {
        var bandWidth = axis.scale.bandwidth();
        if (!isBar || bandWidth > 0) return bandWidth;
    }
    if (axis && ticks && ticks.length >= 2) {
        var orderedTicks = (0, (/*@__PURE__*/$parcel$interopDefault($76273bef9289b8fd$exports)))(ticks, function(o) {
            return o.coordinate;
        });
        var bandSize = Infinity;
        for(var i = 1, len = orderedTicks.length; i < len; i++){
            var cur = orderedTicks[i];
            var prev = orderedTicks[i - 1];
            bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
        }
        return bandSize === Infinity ? 0 : bandSize;
    }
    return isBar ? undefined : 0;
};
var $c86c74861e78fc13$export$c9a5230f0dda41bf = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
    if (!specifiedDomain || !specifiedDomain.length) return calculatedDomain;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($51dd3d952d9b6d71$exports)))(specifiedDomain, (0, (/*@__PURE__*/$parcel$interopDefault($2cd7f9f9c3b27772$exports)))(axisChild, "type.defaultProps.domain"))) return calculatedDomain;
    return specifiedDomain;
};
var $c86c74861e78fc13$export$a4ea3faa19bc2d90 = function getTooltipItem(graphicalItem, payload) {
    var _graphicalItem$props = graphicalItem.props, dataKey = _graphicalItem$props.dataKey, name = _graphicalItem$props.name, unit = _graphicalItem$props.unit, formatter = _graphicalItem$props.formatter, tooltipType = _graphicalItem$props.tooltipType, chartType = _graphicalItem$props.chartType;
    return $c86c74861e78fc13$var$_objectSpread($c86c74861e78fc13$var$_objectSpread({}, (0, $05a192303b32ed93$export$d697c39a2985a4c)(graphicalItem)), {}, {
        dataKey: dataKey,
        unit: unit,
        formatter: formatter,
        name: name || dataKey,
        color: $c86c74861e78fc13$export$ec6cab5a7a3b93bf(graphicalItem),
        value: $c86c74861e78fc13$export$f97fc4a450f29a(payload, dataKey),
        type: tooltipType,
        payload: payload,
        chartType: chartType
    });
};


function $470bf96dd282a944$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $470bf96dd282a944$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $470bf96dd282a944$var$ownKeys(Object(source), true).forEach(function(key) {
            $470bf96dd282a944$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $470bf96dd282a944$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $470bf96dd282a944$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $470bf96dd282a944$var$_slicedToArray(arr, i) {
    return $470bf96dd282a944$var$_arrayWithHoles(arr) || $470bf96dd282a944$var$_iterableToArrayLimit(arr, i) || $470bf96dd282a944$var$_unsupportedIterableToArray(arr, i) || $470bf96dd282a944$var$_nonIterableRest();
}
function $470bf96dd282a944$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $470bf96dd282a944$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $470bf96dd282a944$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $470bf96dd282a944$var$_arrayLikeToArray(o, minLen);
}
function $470bf96dd282a944$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $470bf96dd282a944$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $470bf96dd282a944$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $470bf96dd282a944$export$d74e8f7e9cc3fed3 = Math.PI / 180;
var $470bf96dd282a944$export$4f2c4f194778dcbb = function degreeToRadian(angle) {
    return angle * Math.PI / 180;
};
var $470bf96dd282a944$export$1c20e104e3e29a0a = function radianToDegree(angleInRadian) {
    return angleInRadian * 180 / Math.PI;
};
var $470bf96dd282a944$export$5c9a959bb3fc7749 = function polarToCartesian(cx, cy, radius, angle) {
    return {
        x: cx + Math.cos(-$470bf96dd282a944$export$d74e8f7e9cc3fed3 * angle) * radius,
        y: cy + Math.sin(-$470bf96dd282a944$export$d74e8f7e9cc3fed3 * angle) * radius
    };
};
var $470bf96dd282a944$export$ad5c48602371adfa = function getMaxRadius(width, height) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
var $470bf96dd282a944$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height;
    var startAngle = props.startAngle, endAngle = props.endAngle;
    var cx = (0, $804fab7e7cc9eb97$export$476354dbf49bdff6)(props.cx, width, width / 2);
    var cy = (0, $804fab7e7cc9eb97$export$476354dbf49bdff6)(props.cy, height, height / 2);
    var maxRadius = $470bf96dd282a944$export$ad5c48602371adfa(width, height, offset);
    var innerRadius = (0, $804fab7e7cc9eb97$export$476354dbf49bdff6)(props.innerRadius, maxRadius, 0);
    var outerRadius = (0, $804fab7e7cc9eb97$export$476354dbf49bdff6)(props.outerRadius, maxRadius, maxRadius * 0.8);
    var ids = Object.keys(axisMap);
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var domain = axis.domain, reversed = axis.reversed;
        var range;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(axis.range)) {
            if (axisType === "angleAxis") range = [
                startAngle,
                endAngle
            ];
            else if (axisType === "radiusAxis") range = [
                innerRadius,
                outerRadius
            ];
            if (reversed) range = [
                range[1],
                range[0]
            ];
        } else {
            range = axis.range;
            var _range = range;
            var _range2 = $470bf96dd282a944$var$_slicedToArray(_range, 2);
            startAngle = _range2[0];
            endAngle = _range2[1];
        }
        var _parseScale = (0, $c86c74861e78fc13$export$534b094a708572c1)(axis, chartName), realScaleType = _parseScale.realScaleType, scale = _parseScale.scale;
        scale.domain(domain).range(range);
        (0, $c86c74861e78fc13$export$9d80152e23bae434)(scale);
        var ticks = (0, $c86c74861e78fc13$export$ac086aaa4358d590)(scale, $470bf96dd282a944$var$_objectSpread($470bf96dd282a944$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        var finalAxis = $470bf96dd282a944$var$_objectSpread($470bf96dd282a944$var$_objectSpread($470bf96dd282a944$var$_objectSpread({}, axis), ticks), {}, {
            range: range,
            radius: outerRadius,
            realScaleType: realScaleType,
            scale: scale,
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
        return $470bf96dd282a944$var$_objectSpread($470bf96dd282a944$var$_objectSpread({}, result), {}, $470bf96dd282a944$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $470bf96dd282a944$export$b59117efbc9c7af = function distanceBetweenPoints(point, anotherPoint) {
    var x1 = point.x, y1 = point.y;
    var x2 = anotherPoint.x, y2 = anotherPoint.y;
    return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};
var $470bf96dd282a944$export$bc42f851bd05a2ae = function getAngleOfPoint(_ref, _ref2) {
    var x = _ref.x, y = _ref.y;
    var cx = _ref2.cx, cy = _ref2.cy;
    var radius = $470bf96dd282a944$export$b59117efbc9c7af({
        x: x,
        y: y
    }, {
        x: cx,
        y: cy
    });
    if (radius <= 0) return {
        radius: radius
    };
    var cos = (x - cx) / radius;
    var angleInRadian = Math.acos(cos);
    if (y > cy) angleInRadian = 2 * Math.PI - angleInRadian;
    return {
        radius: radius,
        angle: $470bf96dd282a944$export$1c20e104e3e29a0a(angleInRadian),
        angleInRadian: angleInRadian
    };
};
var $470bf96dd282a944$export$c8ca70209d427b81 = function formatAngleOfSector(_ref3) {
    var startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return {
        startAngle: startAngle - min * 360,
        endAngle: endAngle - min * 360
    };
};
var $470bf96dd282a944$var$reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
    var startAngle = _ref4.startAngle, endAngle = _ref4.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return angle + min * 360;
};
var $470bf96dd282a944$export$e85a2bf8cd31c504 = function inRangeOfSector(_ref5, sector) {
    var x = _ref5.x, y = _ref5.y;
    var _getAngleOfPoint = $470bf96dd282a944$export$bc42f851bd05a2ae({
        x: x,
        y: y
    }, sector), radius = _getAngleOfPoint.radius, angle = _getAngleOfPoint.angle;
    var innerRadius = sector.innerRadius, outerRadius = sector.outerRadius;
    if (radius < innerRadius || radius > outerRadius) return false;
    if (radius === 0) return true;
    var _formatAngleOfSector = $470bf96dd282a944$export$c8ca70209d427b81(sector), startAngle = _formatAngleOfSector.startAngle, endAngle = _formatAngleOfSector.endAngle;
    var formatAngle = angle;
    var inRange;
    if (startAngle <= endAngle) {
        while(formatAngle > endAngle)formatAngle -= 360;
        while(formatAngle < startAngle)formatAngle += 360;
        inRange = formatAngle >= startAngle && formatAngle <= endAngle;
    } else {
        while(formatAngle > startAngle)formatAngle -= 360;
        while(formatAngle < endAngle)formatAngle += 360;
        inRange = formatAngle >= endAngle && formatAngle <= startAngle;
    }
    if (inRange) return $470bf96dd282a944$var$_objectSpread($470bf96dd282a944$var$_objectSpread({}, sector), {}, {
        radius: radius,
        angle: $470bf96dd282a944$var$reverseFormatAngleOfSetor(formatAngle, sector)
    });
    return null;
};



function $3f966edd6f5d584e$var$_toConsumableArray(arr) {
    return $3f966edd6f5d584e$var$_arrayWithoutHoles(arr) || $3f966edd6f5d584e$var$_iterableToArray(arr) || $3f966edd6f5d584e$var$_unsupportedIterableToArray(arr) || $3f966edd6f5d584e$var$_nonIterableSpread();
}
function $3f966edd6f5d584e$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3f966edd6f5d584e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3f966edd6f5d584e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3f966edd6f5d584e$var$_arrayLikeToArray(o, minLen);
}
function $3f966edd6f5d584e$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $3f966edd6f5d584e$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $3f966edd6f5d584e$var$_arrayLikeToArray(arr);
}
function $3f966edd6f5d584e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3f966edd6f5d584e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3f966edd6f5d584e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $3f966edd6f5d584e$var$ownKeys(Object(source), true).forEach(function(key) {
            $3f966edd6f5d584e$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $3f966edd6f5d584e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3f966edd6f5d584e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3f966edd6f5d584e$var$_extends() {
    $3f966edd6f5d584e$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3f966edd6f5d584e$var$_extends.apply(this, arguments);
}
var $3f966edd6f5d584e$var$getLabel = function getLabel(props) {
    var value = props.value, formatter = props.formatter;
    var label = (0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(props.children) ? value : props.children;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(formatter)) return formatter(label);
    return label;
};
var $3f966edd6f5d584e$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $804fab7e7cc9eb97$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var $3f966edd6f5d584e$var$renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
    var position = labelProps.position, viewBox = labelProps.viewBox, offset = labelProps.offset, className = labelProps.className;
    var _ref = viewBox, cx = _ref.cx, cy = _ref.cy, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, startAngle = _ref.startAngle, endAngle = _ref.endAngle, clockWise = _ref.clockWise;
    var radius = (innerRadius + outerRadius) / 2;
    var deltaAngle = $3f966edd6f5d584e$var$getDeltaAngle(startAngle, endAngle);
    var sign = deltaAngle >= 0 ? 1 : -1;
    var labelAngle, direction;
    if (position === "insideStart") {
        labelAngle = startAngle + sign * offset;
        direction = clockWise;
    } else if (position === "insideEnd") {
        labelAngle = endAngle - sign * offset;
        direction = !clockWise;
    } else if (position === "end") {
        labelAngle = endAngle + sign * offset;
        direction = clockWise;
    }
    direction = deltaAngle <= 0 ? direction : !direction;
    var startPoint = (0, $470bf96dd282a944$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle);
    var endPoint = (0, $470bf96dd282a944$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
    var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
    var id = (0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(labelProps.id) ? (0, $804fab7e7cc9eb97$export$8b15d37bc3f197d4)("recharts-radial-line-") : labelProps.id;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("text", $3f966edd6f5d584e$var$_extends({}, attrs, {
        dominantBaseline: "central",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))("recharts-radial-bar-label", className)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("path", {
        id: id,
        d: path
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("textPath", {
        xlinkHref: "#".concat(id)
    }, label));
};
var $3f966edd6f5d584e$var$getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
    var viewBox = props.viewBox, offset = props.offset, position = props.position;
    var _ref2 = viewBox, cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var midAngle = (startAngle + endAngle) / 2;
    if (position === "outside") {
        var _polarToCartesian = (0, $470bf96dd282a944$export$5c9a959bb3fc7749)(cx, cy, outerRadius + offset, midAngle), _x = _polarToCartesian.x, _y = _polarToCartesian.y;
        return {
            x: _x,
            y: _y,
            textAnchor: _x >= cx ? "start" : "end",
            verticalAnchor: "middle"
        };
    }
    if (position === "center") return {
        x: cx,
        y: cy,
        textAnchor: "middle",
        verticalAnchor: "middle"
    };
    if (position === "centerTop") return {
        x: cx,
        y: cy,
        textAnchor: "middle",
        verticalAnchor: "start"
    };
    if (position === "centerBottom") return {
        x: cx,
        y: cy,
        textAnchor: "middle",
        verticalAnchor: "end"
    };
    var r = (innerRadius + outerRadius) / 2;
    var _polarToCartesian2 = (0, $470bf96dd282a944$export$5c9a959bb3fc7749)(cx, cy, r, midAngle), x = _polarToCartesian2.x, y = _polarToCartesian2.y;
    return {
        x: x,
        y: y,
        textAnchor: "middle",
        verticalAnchor: "middle"
    };
};
var $3f966edd6f5d584e$var$getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
    var viewBox = props.viewBox, parentViewBox = props.parentViewBox, offset = props.offset, position = props.position;
    var _ref3 = viewBox, x = _ref3.x, y = _ref3.y, width = _ref3.width, height = _ref3.height; // Define vertical offsets and position inverts based on the value being positive or negative
    var verticalSign = height >= 0 ? 1 : -1;
    var verticalOffset = verticalSign * offset;
    var verticalEnd = verticalSign > 0 ? "end" : "start";
    var verticalStart = verticalSign > 0 ? "start" : "end"; // Define horizontal offsets and position inverts based on the value being positive or negative
    var horizontalSign = width >= 0 ? 1 : -1;
    var horizontalOffset = horizontalSign * offset;
    var horizontalEnd = horizontalSign > 0 ? "end" : "start";
    var horizontalStart = horizontalSign > 0 ? "start" : "end";
    if (position === "top") {
        var attrs = {
            x: x + width / 2,
            y: y - verticalSign * offset,
            textAnchor: "middle",
            verticalAnchor: verticalEnd
        };
        return $3f966edd6f5d584e$var$_objectSpread($3f966edd6f5d584e$var$_objectSpread({}, attrs), parentViewBox ? {
            height: Math.max(y - parentViewBox.y, 0),
            width: width
        } : {});
    }
    if (position === "bottom") {
        var _attrs = {
            x: x + width / 2,
            y: y + height + verticalOffset,
            textAnchor: "middle",
            verticalAnchor: verticalStart
        };
        return $3f966edd6f5d584e$var$_objectSpread($3f966edd6f5d584e$var$_objectSpread({}, _attrs), parentViewBox ? {
            height: Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0),
            width: width
        } : {});
    }
    if (position === "left") {
        var _attrs2 = {
            x: x - horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalEnd,
            verticalAnchor: "middle"
        };
        return $3f966edd6f5d584e$var$_objectSpread($3f966edd6f5d584e$var$_objectSpread({}, _attrs2), parentViewBox ? {
            width: Math.max(_attrs2.x - parentViewBox.x, 0),
            height: height
        } : {});
    }
    if (position === "right") {
        var _attrs3 = {
            x: x + width + horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalStart,
            verticalAnchor: "middle"
        };
        return $3f966edd6f5d584e$var$_objectSpread($3f966edd6f5d584e$var$_objectSpread({}, _attrs3), parentViewBox ? {
            width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
            height: height
        } : {});
    }
    var sizeAttrs = parentViewBox ? {
        width: width,
        height: height
    } : {};
    if (position === "insideLeft") return $3f966edd6f5d584e$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalStart,
        verticalAnchor: "middle"
    }, sizeAttrs);
    if (position === "insideRight") return $3f966edd6f5d584e$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalEnd,
        verticalAnchor: "middle"
    }, sizeAttrs);
    if (position === "insideTop") return $3f966edd6f5d584e$var$_objectSpread({
        x: x + width / 2,
        y: y + verticalOffset,
        textAnchor: "middle",
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === "insideBottom") return $3f966edd6f5d584e$var$_objectSpread({
        x: x + width / 2,
        y: y + height - verticalOffset,
        textAnchor: "middle",
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === "insideTopLeft") return $3f966edd6f5d584e$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === "insideTopRight") return $3f966edd6f5d584e$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === "insideBottomLeft") return $3f966edd6f5d584e$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === "insideBottomRight") return $3f966edd6f5d584e$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cdeebba9a3c50f33$exports)))(position) && ((0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(position.x) || (0, $804fab7e7cc9eb97$export$e50269385c77c348)(position.x)) && ((0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(position.y) || (0, $804fab7e7cc9eb97$export$e50269385c77c348)(position.y))) return $3f966edd6f5d584e$var$_objectSpread({
        x: x + (0, $804fab7e7cc9eb97$export$476354dbf49bdff6)(position.x, width),
        y: y + (0, $804fab7e7cc9eb97$export$476354dbf49bdff6)(position.y, height),
        textAnchor: "end",
        verticalAnchor: "end"
    }, sizeAttrs);
    return $3f966edd6f5d584e$var$_objectSpread({
        x: x + width / 2,
        y: y + height / 2,
        textAnchor: "middle",
        verticalAnchor: "middle"
    }, sizeAttrs);
};
var $3f966edd6f5d584e$var$isPolar = function isPolar(viewBox) {
    return (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(viewBox.cx);
};
function $3f966edd6f5d584e$export$b04be29aa201d4f5(props) {
    var viewBox = props.viewBox, position = props.position, value = props.value, children = props.children, content = props.content, _props$className = props.className, className = _props$className === void 0 ? "" : _props$className, textBreakAll = props.textBreakAll;
    if (!viewBox || (0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(value) && (0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(children) && !/*#__PURE__*/ (0, $jC8Vy.isValidElement)(content) && !(0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(content)) return null;
    if (/*#__PURE__*/ (0, $jC8Vy.isValidElement)(content)) return /*#__PURE__*/ (0, $jC8Vy.cloneElement)(content, props);
    var label;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(content)) {
        label = /*#__PURE__*/ (0, $jC8Vy.createElement)(content, props);
        if (/*#__PURE__*/ (0, $jC8Vy.isValidElement)(label)) return label;
    } else label = $3f966edd6f5d584e$var$getLabel(props);
    var isPolarLabel = $3f966edd6f5d584e$var$isPolar(viewBox);
    var attrs = (0, $05a192303b32ed93$export$d697c39a2985a4c)(props, true);
    if (isPolarLabel && (position === "insideStart" || position === "insideEnd" || position === "end")) return $3f966edd6f5d584e$var$renderRadialLabel(props, label, attrs);
    var positionAttrs = isPolarLabel ? $3f966edd6f5d584e$var$getAttrsOfPolarLabel(props) : $3f966edd6f5d584e$var$getAttrsOfCartesianLabel(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $9b127a27894cc2e0$export$5f1af8db9871e1d6), $3f966edd6f5d584e$var$_extends({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))("recharts-label", className)
    }, attrs, positionAttrs, {
        breakAll: textBreakAll
    }), label);
}
$3f966edd6f5d584e$export$b04be29aa201d4f5.displayName = "Label";
$3f966edd6f5d584e$export$b04be29aa201d4f5.defaultProps = {
    offset: 5
};
var $3f966edd6f5d584e$var$parseViewBox = function parseViewBox(props) {
    var cx = props.cx, cy = props.cy, angle = props.angle, startAngle = props.startAngle, endAngle = props.endAngle, r = props.r, radius = props.radius, innerRadius = props.innerRadius, outerRadius = props.outerRadius, x = props.x, y = props.y, top = props.top, left = props.left, width = props.width, height = props.height, clockWise = props.clockWise, labelViewBox = props.labelViewBox;
    if (labelViewBox) return labelViewBox;
    if ((0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(width) && (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(height)) {
        if ((0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(x) && (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(y)) return {
            x: x,
            y: y,
            width: width,
            height: height
        };
        if ((0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(top) && (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(left)) return {
            x: top,
            y: left,
            width: width,
            height: height
        };
    }
    if ((0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(x) && (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(y)) return {
        x: x,
        y: y,
        width: 0,
        height: 0
    };
    if ((0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(cx) && (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(cy)) return {
        cx: cx,
        cy: cy,
        startAngle: startAngle || angle || 0,
        endAngle: endAngle || angle || 0,
        innerRadius: innerRadius || 0,
        outerRadius: outerRadius || radius || r || 0,
        clockWise: clockWise
    };
    if (props.viewBox) return props.viewBox;
    return {};
};
var $3f966edd6f5d584e$var$parseLabel = function parseLabel(label, viewBox) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement($3f966edd6f5d584e$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox
    });
    if ((0, $804fab7e7cc9eb97$export$402a499e1ea44294)(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement($3f966edd6f5d584e$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox,
        value: label
    });
    if (/*#__PURE__*/ (0, $jC8Vy.isValidElement)(label)) {
        if (label.type === $3f966edd6f5d584e$export$b04be29aa201d4f5) return /*#__PURE__*/ (0, $jC8Vy.cloneElement)(label, {
            key: "label-implicit",
            viewBox: viewBox
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement($3f966edd6f5d584e$export$b04be29aa201d4f5, {
            key: "label-implicit",
            content: label,
            viewBox: viewBox
        });
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement($3f966edd6f5d584e$export$b04be29aa201d4f5, {
        key: "label-implicit",
        content: label,
        viewBox: viewBox
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cdeebba9a3c50f33$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement($3f966edd6f5d584e$export$b04be29aa201d4f5, $3f966edd6f5d584e$var$_extends({
        viewBox: viewBox
    }, label, {
        key: "label-implicit"
    }));
    return null;
};
var $3f966edd6f5d584e$var$renderCallByParent = function renderCallByParent(parentProps, viewBox) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var parentViewBox = $3f966edd6f5d584e$var$parseViewBox(parentProps);
    var explicitChildren = (0, $217577d291f12aa3$export$fdd5e64c0e8495bb)(children, $3f966edd6f5d584e$export$b04be29aa201d4f5.displayName).map(function(child, index) {
        return /*#__PURE__*/ (0, $jC8Vy.cloneElement)(child, {
            viewBox: viewBox || parentViewBox,
            key: "label-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabel = $3f966edd6f5d584e$var$parseLabel(parentProps.label, viewBox || parentViewBox);
    return [
        implicitLabel
    ].concat($3f966edd6f5d584e$var$_toConsumableArray(explicitChildren));
};
$3f966edd6f5d584e$export$b04be29aa201d4f5.parseViewBox = $3f966edd6f5d584e$var$parseViewBox;
$3f966edd6f5d584e$export$b04be29aa201d4f5.renderCallByParent = $3f966edd6f5d584e$var$renderCallByParent;






function $66d0583d62dc2748$var$_toConsumableArray(arr) {
    return $66d0583d62dc2748$var$_arrayWithoutHoles(arr) || $66d0583d62dc2748$var$_iterableToArray(arr) || $66d0583d62dc2748$var$_unsupportedIterableToArray(arr) || $66d0583d62dc2748$var$_nonIterableSpread();
}
function $66d0583d62dc2748$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $66d0583d62dc2748$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $66d0583d62dc2748$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $66d0583d62dc2748$var$_arrayLikeToArray(o, minLen);
}
function $66d0583d62dc2748$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $66d0583d62dc2748$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $66d0583d62dc2748$var$_arrayLikeToArray(arr);
}
function $66d0583d62dc2748$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $66d0583d62dc2748$var$_extends() {
    $66d0583d62dc2748$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $66d0583d62dc2748$var$_extends.apply(this, arguments);
}
function $66d0583d62dc2748$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $66d0583d62dc2748$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $66d0583d62dc2748$var$ownKeys(Object(source), true).forEach(function(key) {
            $66d0583d62dc2748$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $66d0583d62dc2748$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $66d0583d62dc2748$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $66d0583d62dc2748$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $66d0583d62dc2748$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $66d0583d62dc2748$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $66d0583d62dc2748$var$defaultProps = {
    valueAccessor: function valueAccessor(entry) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($0fe4a5546443a34c$exports)))(entry.value) ? (0, (/*@__PURE__*/$parcel$interopDefault($a33d480412da9c67$exports)))(entry.value) : entry.value;
    }
};
function $66d0583d62dc2748$export$835fcf23ab7bf88(props) {
    var data = props.data, valueAccessor = props.valueAccessor, dataKey = props.dataKey, clockWise = props.clockWise, id = props.id, textBreakAll = props.textBreakAll, others = $66d0583d62dc2748$var$_objectWithoutProperties(props, [
        "data",
        "valueAccessor",
        "dataKey",
        "clockWise",
        "id",
        "textBreakAll"
    ]);
    if (!data || !data.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $a857ed6b15ebb152$export$936d0764594b6eb3), {
        className: "recharts-label-list"
    }, data.map(function(entry, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(dataKey) ? valueAccessor(entry, index) : (0, $c86c74861e78fc13$export$f97fc4a450f29a)(entry && entry.payload, dataKey);
        var idProps = (0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(id) ? {} : {
            id: "".concat(id, "-").concat(index)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $3f966edd6f5d584e$export$b04be29aa201d4f5), $66d0583d62dc2748$var$_extends({}, (0, $05a192303b32ed93$export$d697c39a2985a4c)(entry, true), others, idProps, {
            parentViewBox: entry.parentViewBox,
            index: index,
            value: value,
            textBreakAll: textBreakAll,
            viewBox: (0, $3f966edd6f5d584e$export$b04be29aa201d4f5).parseViewBox((0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(clockWise) ? entry : $66d0583d62dc2748$var$_objectSpread($66d0583d62dc2748$var$_objectSpread({}, entry), {}, {
                clockWise: clockWise
            })),
            key: "label-".concat(index) // eslint-disable-line react/no-array-index-key
        }));
    }));
}
$66d0583d62dc2748$export$835fcf23ab7bf88.displayName = "LabelList";
function $66d0583d62dc2748$var$parseLabelList(label, data) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement($66d0583d62dc2748$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data
    });
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).isValidElement(label) || (0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement($66d0583d62dc2748$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data,
        content: label
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cdeebba9a3c50f33$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement($66d0583d62dc2748$export$835fcf23ab7bf88, $66d0583d62dc2748$var$_extends({
        data: data
    }, label, {
        key: "labelList-implicit"
    }));
    return null;
}
function $66d0583d62dc2748$var$renderCallByParent(parentProps, data) {
    var ckeckPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && ckeckPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var explicitChilren = (0, $217577d291f12aa3$export$fdd5e64c0e8495bb)(children, $66d0583d62dc2748$export$835fcf23ab7bf88.displayName).map(function(child, index) {
        return /*#__PURE__*/ (0, $jC8Vy.cloneElement)(child, {
            data: data,
            key: "labelList-".concat(index)
        });
    });
    if (!ckeckPropsLabel) return explicitChilren;
    var implicitLabelList = $66d0583d62dc2748$var$parseLabelList(parentProps.label, data);
    return [
        implicitLabelList
    ].concat($66d0583d62dc2748$var$_toConsumableArray(explicitChilren));
}
$66d0583d62dc2748$export$835fcf23ab7bf88.renderCallByParent = $66d0583d62dc2748$var$renderCallByParent;
$66d0583d62dc2748$export$835fcf23ab7bf88.defaultProps = $66d0583d62dc2748$var$defaultProps;






function $fa5d459f96aa6e1d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $fa5d459f96aa6e1d$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $fa5d459f96aa6e1d$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $fa5d459f96aa6e1d$var$_typeof(obj);
}
function $fa5d459f96aa6e1d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $fa5d459f96aa6e1d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $fa5d459f96aa6e1d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $fa5d459f96aa6e1d$var$_extends() {
    $fa5d459f96aa6e1d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fa5d459f96aa6e1d$var$_extends.apply(this, arguments);
}
function $fa5d459f96aa6e1d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $fa5d459f96aa6e1d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $fa5d459f96aa6e1d$var$ownKeys(Object(source), true).forEach(function(key) {
            $fa5d459f96aa6e1d$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $fa5d459f96aa6e1d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $fa5d459f96aa6e1d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fa5d459f96aa6e1d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fa5d459f96aa6e1d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $fa5d459f96aa6e1d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fa5d459f96aa6e1d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fa5d459f96aa6e1d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $fa5d459f96aa6e1d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $fa5d459f96aa6e1d$var$_setPrototypeOf(subClass, superClass);
}
function $fa5d459f96aa6e1d$var$_setPrototypeOf(o, p) {
    $fa5d459f96aa6e1d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $fa5d459f96aa6e1d$var$_setPrototypeOf(o, p);
}
function $fa5d459f96aa6e1d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $fa5d459f96aa6e1d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $fa5d459f96aa6e1d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $fa5d459f96aa6e1d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $fa5d459f96aa6e1d$var$_possibleConstructorReturn(this, result);
    };
}
function $fa5d459f96aa6e1d$var$_possibleConstructorReturn(self, call) {
    if (call && ($fa5d459f96aa6e1d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $fa5d459f96aa6e1d$var$_assertThisInitialized(self);
}
function $fa5d459f96aa6e1d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $fa5d459f96aa6e1d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $fa5d459f96aa6e1d$var$_getPrototypeOf(o) {
    $fa5d459f96aa6e1d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $fa5d459f96aa6e1d$var$_getPrototypeOf(o);
}
var $fa5d459f96aa6e1d$export$ea1a111407f37557 = /*#__PURE__*/ function(_PureComponent) {
    $fa5d459f96aa6e1d$var$_inherits(Area, _PureComponent);
    var _super = $fa5d459f96aa6e1d$var$_createSuper(Area);
    function Area() {
        var _this;
        $fa5d459f96aa6e1d$var$_classCallCheck(this, Area);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            isAnimationFinished: true
        };
        _this.id = (0, $804fab7e7cc9eb97$export$8b15d37bc3f197d4)("recharts-area-");
        _this.handleAnimationEnd = function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(onAnimationEnd)) onAnimationEnd();
        };
        _this.handleAnimationStart = function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(onAnimationStart)) onAnimationStart();
        };
        return _this;
    }
    $fa5d459f96aa6e1d$var$_createClass(Area, [
        {
            key: "renderDots",
            value: function renderDots(needClip, clipPathId) {
                var isAnimationActive = this.props.isAnimationActive;
                var isAnimationFinished = this.state.isAnimationFinished;
                if (isAnimationActive && !isAnimationFinished) return null;
                var _this$props = this.props, dot = _this$props.dot, points = _this$props.points, dataKey = _this$props.dataKey;
                var areaProps = (0, $05a192303b32ed93$export$d697c39a2985a4c)(this.props);
                var customDotProps = (0, $05a192303b32ed93$export$d697c39a2985a4c)(dot, true);
                var dots = points.map(function(entry, i) {
                    var dotProps = $fa5d459f96aa6e1d$var$_objectSpread($fa5d459f96aa6e1d$var$_objectSpread($fa5d459f96aa6e1d$var$_objectSpread({
                        key: "dot-".concat(i),
                        r: 3
                    }, areaProps), customDotProps), {}, {
                        dataKey: dataKey,
                        cx: entry.x,
                        cy: entry.y,
                        index: i,
                        value: entry.value,
                        payload: entry.payload
                    });
                    return Area.renderDotItem(dot, dotProps);
                });
                var dotsProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $a857ed6b15ebb152$export$936d0764594b6eb3), $fa5d459f96aa6e1d$var$_extends({
                    className: "recharts-area-dots"
                }, dotsProps), dots);
            }
        },
        {
            key: "renderHorizontalRect",
            value: function renderHorizontalRect(alpha) {
                var _this$props2 = this.props, baseLine = _this$props2.baseLine, points = _this$props2.points, strokeWidth = _this$props2.strokeWidth;
                var startX = points[0].x;
                var endX = points[points.length - 1].x;
                var width = alpha * Math.abs(startX - endX);
                var maxY = (0, (/*@__PURE__*/$parcel$interopDefault($341369312ca6ec3a$exports)))(points.map(function(entry) {
                    return entry.y || 0;
                }));
                if ((0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(baseLine) && typeof baseLine === "number") maxY = Math.max(baseLine, maxY);
                else if (baseLine && (0, (/*@__PURE__*/$parcel$interopDefault($0fe4a5546443a34c$exports)))(baseLine) && baseLine.length) maxY = Math.max((0, (/*@__PURE__*/$parcel$interopDefault($341369312ca6ec3a$exports)))(baseLine.map(function(entry) {
                    return entry.y || 0;
                })), maxY);
                if ((0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(maxY)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("rect", {
                    x: startX < endX ? startX : startX - width,
                    y: 0,
                    width: width,
                    height: Math.floor(maxY + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1))
                });
                return null;
            }
        },
        {
            key: "renderVerticalRect",
            value: function renderVerticalRect(alpha) {
                var _this$props3 = this.props, baseLine = _this$props3.baseLine, points = _this$props3.points, strokeWidth = _this$props3.strokeWidth;
                var startY = points[0].y;
                var endY = points[points.length - 1].y;
                var height = alpha * Math.abs(startY - endY);
                var maxX = (0, (/*@__PURE__*/$parcel$interopDefault($341369312ca6ec3a$exports)))(points.map(function(entry) {
                    return entry.x || 0;
                }));
                if ((0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(baseLine) && typeof baseLine === "number") maxX = Math.max(baseLine, maxX);
                else if (baseLine && (0, (/*@__PURE__*/$parcel$interopDefault($0fe4a5546443a34c$exports)))(baseLine) && baseLine.length) maxX = Math.max((0, (/*@__PURE__*/$parcel$interopDefault($341369312ca6ec3a$exports)))(baseLine.map(function(entry) {
                    return entry.x || 0;
                })), maxX);
                if ((0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(maxX)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("rect", {
                    x: 0,
                    y: startY < endY ? startY : startY - height,
                    width: maxX + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1),
                    height: Math.floor(height)
                });
                return null;
            }
        },
        {
            key: "renderClipRect",
            value: function renderClipRect(alpha) {
                var layout = this.props.layout;
                if (layout === "vertical") return this.renderVerticalRect(alpha);
                return this.renderHorizontalRect(alpha);
            }
        },
        {
            key: "renderAreaStatically",
            value: function renderAreaStatically(points, baseLine, needClip, clipPathId) {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                var _this$props4 = this.props, layout = _this$props4.layout, type = _this$props4.type, stroke = _this$props4.stroke, connectNulls = _this$props4.connectNulls, isRange = _this$props4.isRange, ref = _this$props4.ref, others = $fa5d459f96aa6e1d$var$_objectWithoutProperties(_this$props4, [
                    "layout",
                    "type",
                    "stroke",
                    "connectNulls",
                    "isRange",
                    "ref"
                ]);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $a857ed6b15ebb152$export$936d0764594b6eb3), {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aaa3487fdd76f634$export$b0e83c3ef8d2db1), $fa5d459f96aa6e1d$var$_extends({}, (0, $05a192303b32ed93$export$d697c39a2985a4c)(others, true), {
                    points: points,
                    connectNulls: connectNulls,
                    type: type,
                    baseLine: baseLine,
                    layout: layout,
                    stroke: "none",
                    className: "recharts-area-area"
                })), stroke !== "none" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aaa3487fdd76f634$export$b0e83c3ef8d2db1), $fa5d459f96aa6e1d$var$_extends({}, (0, $05a192303b32ed93$export$d697c39a2985a4c)(this.props), {
                    className: "recharts-area-curve",
                    layout: layout,
                    type: type,
                    connectNulls: connectNulls,
                    fill: "none",
                    points: points
                })), stroke !== "none" && isRange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $aaa3487fdd76f634$export$b0e83c3ef8d2db1), $fa5d459f96aa6e1d$var$_extends({}, (0, $05a192303b32ed93$export$d697c39a2985a4c)(this.props), {
                    className: "recharts-area-curve",
                    layout: layout,
                    type: type,
                    connectNulls: connectNulls,
                    fill: "none",
                    points: baseLine
                })));
            }
        },
        {
            key: "renderAreaWithAnimation",
            value: function renderAreaWithAnimation(needClip, clipPathId) {
                var _this2 = this;
                var _this$props5 = this.props, points = _this$props5.points, baseLine = _this$props5.baseLine, isAnimationActive = _this$props5.isAnimationActive, animationBegin = _this$props5.animationBegin, animationDuration = _this$props5.animationDuration, animationEasing = _this$props5.animationEasing, animationId = _this$props5.animationId;
                var _this$state = this.state, prevPoints = _this$state.prevPoints, prevBaseLine = _this$state.prevBaseLine; // const clipPathId = _.isNil(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $97a4c34858e514f6$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "area-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    if (prevPoints) {
                        var prevPointsDiffFactor = prevPoints.length / points.length; // update animtaion
                        var stepPoints = points.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevPoints[prevPointIndex]) {
                                var prev = prevPoints[prevPointIndex];
                                var interpolatorX = (0, $804fab7e7cc9eb97$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $804fab7e7cc9eb97$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $fa5d459f96aa6e1d$var$_objectSpread($fa5d459f96aa6e1d$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            return entry;
                        });
                        var stepBaseLine;
                        if ((0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(baseLine) && typeof baseLine === "number") {
                            var interpolator = (0, $804fab7e7cc9eb97$export$d871d53bd7eeb390)(prevBaseLine, baseLine);
                            stepBaseLine = interpolator(t);
                        } else if ((0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(baseLine) || (0, (/*@__PURE__*/$parcel$interopDefault($044ab485528b5c52$exports)))(baseLine)) {
                            var _interpolator = (0, $804fab7e7cc9eb97$export$d871d53bd7eeb390)(prevBaseLine, 0);
                            stepBaseLine = _interpolator(t);
                        } else stepBaseLine = baseLine.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevBaseLine[prevPointIndex]) {
                                var prev = prevBaseLine[prevPointIndex];
                                var interpolatorX = (0, $804fab7e7cc9eb97$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $804fab7e7cc9eb97$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $fa5d459f96aa6e1d$var$_objectSpread($fa5d459f96aa6e1d$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            return entry;
                        });
                        return _this2.renderAreaStatically(stepPoints, stepBaseLine, needClip, clipPathId);
                    }
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $a857ed6b15ebb152$export$936d0764594b6eb3), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("clipPath", {
                        id: "animationClipPath-".concat(clipPathId)
                    }, _this2.renderClipRect(t))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $a857ed6b15ebb152$export$936d0764594b6eb3), {
                        clipPath: "url(#animationClipPath-".concat(clipPathId, ")")
                    }, _this2.renderAreaStatically(points, baseLine, needClip, clipPathId)));
                });
            }
        },
        {
            key: "renderArea",
            value: function renderArea(needClip, clipPathId) {
                var _this$props6 = this.props, points = _this$props6.points, baseLine = _this$props6.baseLine, isAnimationActive = _this$props6.isAnimationActive;
                var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, prevBaseLine = _this$state2.prevBaseLine, totalLength = _this$state2.totalLength;
                if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, (/*@__PURE__*/$parcel$interopDefault($51dd3d952d9b6d71$exports)))(prevPoints, points) || !(0, (/*@__PURE__*/$parcel$interopDefault($51dd3d952d9b6d71$exports)))(prevBaseLine, baseLine))) return this.renderAreaWithAnimation(needClip, clipPathId);
                return this.renderAreaStatically(points, baseLine, needClip, clipPathId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props7 = this.props, hide = _this$props7.hide, dot = _this$props7.dot, points = _this$props7.points, className = _this$props7.className, top = _this$props7.top, left = _this$props7.left, xAxis = _this$props7.xAxis, yAxis = _this$props7.yAxis, width = _this$props7.width, height = _this$props7.height, isAnimationActive = _this$props7.isAnimationActive, id = _this$props7.id;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var hasSinglePoint = points.length === 1;
                var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))("recharts-area", className);
                var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $a857ed6b15ebb152$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("rect", {
                    x: left,
                    y: top,
                    width: width,
                    height: Math.floor(height)
                }))) : null, !hasSinglePoint ? this.renderArea(needClip, clipPathId) : null, (dot || hasSinglePoint) && this.renderDots(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $66d0583d62dc2748$export$835fcf23ab7bf88).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    curBaseLine: nextProps.baseLine,
                    prevPoints: prevState.curPoints,
                    prevBaseLine: prevState.curBaseLine
                };
                if (nextProps.points !== prevState.curPoints || nextProps.baseLine !== prevState.curBaseLine) return {
                    curPoints: nextProps.points,
                    curBaseLine: nextProps.baseLine
                };
                return null;
            }
        }
    ]);
    return Area;
}((0, $jC8Vy.PureComponent));
$fa5d459f96aa6e1d$export$ea1a111407f37557.displayName = "Area";
$fa5d459f96aa6e1d$export$ea1a111407f37557.defaultProps = {
    stroke: "#3182bd",
    fill: "#3182bd",
    fillOpacity: 0.6,
    xAxisId: 0,
    yAxisId: 0,
    legendType: "line",
    connectNulls: false,
    // points of area
    points: [],
    dot: false,
    activeDot: true,
    hide: false,
    isAnimationActive: !(0, $02caca8e343c9d9a$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease"
};
$fa5d459f96aa6e1d$export$ea1a111407f37557.getBaseValue = function(props, xAxis, yAxis) {
    var layout = props.layout, baseValue = props.baseValue;
    if ((0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(baseValue) && typeof baseValue === "number") return baseValue;
    var numericAxis = layout === "horizontal" ? yAxis : xAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === "number") {
        var max = Math.max(domain[0], domain[1]);
        var min = Math.min(domain[0], domain[1]);
        if (baseValue === "dataMin") return min;
        if (baseValue === "dataMax") return max;
        return max < 0 ? max : Math.max(Math.min(domain[0], domain[1]), 0);
    }
    if (baseValue === "dataMin") return domain[0];
    if (baseValue === "dataMax") return domain[1];
    return domain[0];
};
$fa5d459f96aa6e1d$export$ea1a111407f37557.getComposedData = function(_ref2) {
    var props = _ref2.props, xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, bandSize = _ref2.bandSize, dataKey = _ref2.dataKey, stackedData = _ref2.stackedData, dataStartIndex = _ref2.dataStartIndex, displayedData = _ref2.displayedData, offset = _ref2.offset;
    var layout = props.layout;
    var hasStack = stackedData && stackedData.length;
    var baseValue = $fa5d459f96aa6e1d$export$ea1a111407f37557.getBaseValue(props, xAxis, yAxis);
    var isRange = false;
    var points = displayedData.map(function(entry, index) {
        var originalValue = (0, $c86c74861e78fc13$export$f97fc4a450f29a)(entry, dataKey);
        var value;
        if (hasStack) value = stackedData[dataStartIndex + index];
        else {
            value = originalValue;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($0fe4a5546443a34c$exports)))(value)) value = [
                baseValue,
                value
            ];
            else isRange = true;
        }
        var isBreakPoint = (0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(value[1]) || hasStack && (0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(originalValue);
        if (layout === "horizontal") return {
            x: (0, $c86c74861e78fc13$export$6e87f3defb83c3f)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            y: isBreakPoint ? null : yAxis.scale(value[1]),
            value: value,
            payload: entry
        };
        return {
            x: isBreakPoint ? null : xAxis.scale(value[1]),
            y: (0, $c86c74861e78fc13$export$6e87f3defb83c3f)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            value: value,
            payload: entry
        };
    });
    var baseLine;
    if (hasStack || isRange) baseLine = points.map(function(entry) {
        if (layout === "horizontal") return {
            x: entry.x,
            y: !(0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($2cd7f9f9c3b27772$exports)))(entry, "value[0]")) && !(0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($2cd7f9f9c3b27772$exports)))(entry, "y")) ? yAxis.scale((0, (/*@__PURE__*/$parcel$interopDefault($2cd7f9f9c3b27772$exports)))(entry, "value[0]")) : null
        };
        return {
            x: !(0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($2cd7f9f9c3b27772$exports)))(entry, "value[0]")) ? xAxis.scale((0, (/*@__PURE__*/$parcel$interopDefault($2cd7f9f9c3b27772$exports)))(entry, "value[0]")) : null,
            y: entry.y
        };
    });
    else if (layout === "horizontal") baseLine = yAxis.scale(baseValue);
    else baseLine = xAxis.scale(baseValue);
    return $fa5d459f96aa6e1d$var$_objectSpread({
        points: points,
        baseLine: baseLine,
        layout: layout,
        isRange: isRange
    }, offset);
};
$fa5d459f96aa6e1d$export$ea1a111407f37557.renderDotItem = function(option, props) {
    var dotItem;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).isValidElement(option)) dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(option)) dotItem = option(props);
    else dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $d32ef06d884f12a9$export$d046b3c4a416f60d), $fa5d459f96aa6e1d$var$_extends({}, props, {
        className: "recharts-area-dot"
    }));
    return dotItem;
};

/**
 * @fileOverview Area Chart
 */ var $1867c288c9a52a34$exports = {};
var $d14b86564fbdf611$exports = {};
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */ function $d14b86564fbdf611$var$arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (!predicate(array[index], index, array)) return false;
    }
    return true;
}
$d14b86564fbdf611$exports = $d14b86564fbdf611$var$arrayEvery;


var $26e52cb9d1d31de8$exports = {};

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */ function $26e52cb9d1d31de8$var$baseEvery(collection, predicate) {
    var result = true;
    $f08c47d4f9033453$exports(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
    });
    return result;
}
$26e52cb9d1d31de8$exports = $26e52cb9d1d31de8$var$baseEvery;





/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */ function $1867c288c9a52a34$var$every(collection, predicate, guard) {
    var func = $0fe4a5546443a34c$exports(collection) ? $d14b86564fbdf611$exports : $26e52cb9d1d31de8$exports;
    if (guard && $3c4d4e2d8b3e6d8b$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $958e35cadb69881a$exports(predicate, 3));
}
$1867c288c9a52a34$exports = $1867c288c9a52a34$var$every;


var $cae0b8e98226d6ae$exports = {};
var $b2a47cc97f204256$exports = {};



/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $b2a47cc97f204256$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$263ae7db1776a88c$exports(collection)) {
            var iteratee = $958e35cadb69881a$exports(predicate, 3);
            collection = $322e4354daac4308$exports(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
$b2a47cc97f204256$exports = $b2a47cc97f204256$var$createFind;


var $50848e550d379c84$exports = {};


var $f4f8fdf114e2ded2$exports = {};
var $39b622270881ef21$exports = {};
var $85c95a58bc10ba50$exports = {};
var $975ef1a1534a345f$exports = {};
var $c3fe010c9f81d875$exports = {};
/** Used to match a single whitespace character. */ var $c3fe010c9f81d875$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $c3fe010c9f81d875$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $c3fe010c9f81d875$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$c3fe010c9f81d875$exports = $c3fe010c9f81d875$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $975ef1a1534a345f$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $975ef1a1534a345f$var$baseTrim(string) {
    return string ? string.slice(0, $c3fe010c9f81d875$exports(string) + 1).replace($975ef1a1534a345f$var$reTrimStart, "") : string;
}
$975ef1a1534a345f$exports = $975ef1a1534a345f$var$baseTrim;




/** Used as references for various `Number` constants. */ var $85c95a58bc10ba50$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $85c95a58bc10ba50$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $85c95a58bc10ba50$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $85c95a58bc10ba50$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $85c95a58bc10ba50$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $85c95a58bc10ba50$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($bd288f840efc8d52$exports(value)) return $85c95a58bc10ba50$var$NAN;
    if ($cdeebba9a3c50f33$exports(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $cdeebba9a3c50f33$exports(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $975ef1a1534a345f$exports(value);
    var isBinary = $85c95a58bc10ba50$var$reIsBinary.test(value);
    return isBinary || $85c95a58bc10ba50$var$reIsOctal.test(value) ? $85c95a58bc10ba50$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $85c95a58bc10ba50$var$reIsBadHex.test(value) ? $85c95a58bc10ba50$var$NAN : +value;
}
$85c95a58bc10ba50$exports = $85c95a58bc10ba50$var$toNumber;


/** Used as references for various `Number` constants. */ var $39b622270881ef21$var$INFINITY = 1 / 0, $39b622270881ef21$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $39b622270881ef21$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $85c95a58bc10ba50$exports(value);
    if (value === $39b622270881ef21$var$INFINITY || value === -$39b622270881ef21$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $39b622270881ef21$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
$39b622270881ef21$exports = $39b622270881ef21$var$toFinite;


/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $f4f8fdf114e2ded2$var$toInteger(value) {
    var result = $39b622270881ef21$exports(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
$f4f8fdf114e2ded2$exports = $f4f8fdf114e2ded2$var$toInteger;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $50848e550d379c84$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $50848e550d379c84$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $f4f8fdf114e2ded2$exports(fromIndex);
    if (index < 0) index = $50848e550d379c84$var$nativeMax(length + index, 0);
    return $e190a747c180cedc$exports(array, $958e35cadb69881a$exports(predicate, 3), index);
}
$50848e550d379c84$exports = $50848e550d379c84$var$findIndex;


/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $cae0b8e98226d6ae$var$find = $b2a47cc97f204256$exports($50848e550d379c84$exports);
$cae0b8e98226d6ae$exports = $cae0b8e98226d6ae$var$find;



var $19ce9d71690ae512$exports = {};
var $fb12e5fdec2a8cfe$exports = {};

var $0edd3b79b79abd0b$exports = {};

var $jKHUh = parcelRequire("jKHUh");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $0edd3b79b79abd0b$var$now = function() {
    return $jKHUh.Date.now();
};
$0edd3b79b79abd0b$exports = $0edd3b79b79abd0b$var$now;



/** Error message constants. */ var $fb12e5fdec2a8cfe$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $fb12e5fdec2a8cfe$var$nativeMax = Math.max, $fb12e5fdec2a8cfe$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $fb12e5fdec2a8cfe$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($fb12e5fdec2a8cfe$var$FUNC_ERROR_TEXT);
    wait = $85c95a58bc10ba50$exports(wait) || 0;
    if ($cdeebba9a3c50f33$exports(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $fb12e5fdec2a8cfe$var$nativeMax($85c95a58bc10ba50$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $fb12e5fdec2a8cfe$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $0edd3b79b79abd0b$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($0edd3b79b79abd0b$exports());
    }
    function debounced() {
        var time = $0edd3b79b79abd0b$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$fb12e5fdec2a8cfe$exports = $fb12e5fdec2a8cfe$var$debounce;



/** Error message constants. */ var $19ce9d71690ae512$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $19ce9d71690ae512$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($19ce9d71690ae512$var$FUNC_ERROR_TEXT);
    if ($cdeebba9a3c50f33$exports(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $fb12e5fdec2a8cfe$exports(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
$19ce9d71690ae512$exports = $19ce9d71690ae512$var$throttle;




var $0fb3a4a2cd8e8970$exports = {};
var $8c8b629959bbbe25$exports = {};
var $4fe5168072ae98ab$exports = {};
/* Built-in method references for those with the same name as other `lodash` methods. */ var $4fe5168072ae98ab$var$nativeCeil = Math.ceil, $4fe5168072ae98ab$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $4fe5168072ae98ab$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $4fe5168072ae98ab$var$nativeMax($4fe5168072ae98ab$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
$4fe5168072ae98ab$exports = $4fe5168072ae98ab$var$baseRange;




/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $8c8b629959bbbe25$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != "number" && $3c4d4e2d8b3e6d8b$exports(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $39b622270881ef21$exports(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $39b622270881ef21$exports(end);
        step = step === undefined ? start < end ? 1 : -1 : $39b622270881ef21$exports(step);
        return $4fe5168072ae98ab$exports(start, end, step, fromRight);
    };
}
$8c8b629959bbbe25$exports = $8c8b629959bbbe25$var$createRange;


/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $0fb3a4a2cd8e8970$var$range = $8c8b629959bbbe25$exports();
$0fb3a4a2cd8e8970$exports = $0fb3a4a2cd8e8970$var$range;



var $fbdd9003106207a4$exports = {};


/** `Object#toString` result references. */ var $fbdd9003106207a4$var$boolTag = "[object Boolean]";
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $fbdd9003106207a4$var$isBoolean(value) {
    return value === true || value === false || $a35b73cb295f324c$exports(value) && $d607e1880b829c8a$exports(value) == $fbdd9003106207a4$var$boolTag;
}
$fbdd9003106207a4$exports = $fbdd9003106207a4$var$isBoolean;




var $jC8Vy = parcelRequire("jC8Vy");

var $5UrGx = parcelRequire("5UrGx");






var $jC8Vy = parcelRequire("jC8Vy");


var $5UrGx = parcelRequire("5UrGx");




var $jC8Vy = parcelRequire("jC8Vy");

var $5UrGx = parcelRequire("5UrGx");

function $f0fba628fc692ac8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $f0fba628fc692ac8$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $f0fba628fc692ac8$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $f0fba628fc692ac8$var$_typeof(obj);
}
function $f0fba628fc692ac8$var$_slicedToArray(arr, i) {
    return $f0fba628fc692ac8$var$_arrayWithHoles(arr) || $f0fba628fc692ac8$var$_iterableToArrayLimit(arr, i) || $f0fba628fc692ac8$var$_unsupportedIterableToArray(arr, i) || $f0fba628fc692ac8$var$_nonIterableRest();
}
function $f0fba628fc692ac8$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f0fba628fc692ac8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f0fba628fc692ac8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f0fba628fc692ac8$var$_arrayLikeToArray(o, minLen);
}
function $f0fba628fc692ac8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f0fba628fc692ac8$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $f0fba628fc692ac8$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $f0fba628fc692ac8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f0fba628fc692ac8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $f0fba628fc692ac8$var$ownKeys(Object(source), true).forEach(function(key) {
            $f0fba628fc692ac8$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $f0fba628fc692ac8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f0fba628fc692ac8$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f0fba628fc692ac8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f0fba628fc692ac8$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f0fba628fc692ac8$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f0fba628fc692ac8$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f0fba628fc692ac8$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $f0fba628fc692ac8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $f0fba628fc692ac8$var$_setPrototypeOf(subClass, superClass);
}
function $f0fba628fc692ac8$var$_setPrototypeOf(o, p) {
    $f0fba628fc692ac8$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f0fba628fc692ac8$var$_setPrototypeOf(o, p);
}
function $f0fba628fc692ac8$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f0fba628fc692ac8$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $f0fba628fc692ac8$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $f0fba628fc692ac8$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $f0fba628fc692ac8$var$_possibleConstructorReturn(this, result);
    };
}
function $f0fba628fc692ac8$var$_possibleConstructorReturn(self, call) {
    if (call && ($f0fba628fc692ac8$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $f0fba628fc692ac8$var$_assertThisInitialized(self);
}
function $f0fba628fc692ac8$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f0fba628fc692ac8$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $f0fba628fc692ac8$var$_getPrototypeOf(o) {
    $f0fba628fc692ac8$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f0fba628fc692ac8$var$_getPrototypeOf(o);
}
function $f0fba628fc692ac8$var$defaultFormatter(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($0fe4a5546443a34c$exports)))(value) && (0, $804fab7e7cc9eb97$export$402a499e1ea44294)(value[0]) && (0, $804fab7e7cc9eb97$export$402a499e1ea44294)(value[1]) ? value.join(" ~ ") : value;
}
var $f0fba628fc692ac8$export$6fe33945eebf9ac8 = /*#__PURE__*/ function(_PureComponent) {
    $f0fba628fc692ac8$var$_inherits(DefaultTooltipContent, _PureComponent);
    var _super = $f0fba628fc692ac8$var$_createSuper(DefaultTooltipContent);
    function DefaultTooltipContent() {
        $f0fba628fc692ac8$var$_classCallCheck(this, DefaultTooltipContent);
        return _super.apply(this, arguments);
    }
    $f0fba628fc692ac8$var$_createClass(DefaultTooltipContent, [
        {
            key: "renderContent",
            value: function renderContent() {
                var _this$props = this.props, payload = _this$props.payload, separator = _this$props.separator, formatter = _this$props.formatter, itemStyle = _this$props.itemStyle, itemSorter = _this$props.itemSorter;
                if (payload && payload.length) {
                    var listStyle = {
                        padding: 0,
                        margin: 0
                    };
                    var items = (itemSorter ? (0, (/*@__PURE__*/$parcel$interopDefault($76273bef9289b8fd$exports)))(payload, itemSorter) : payload).map(function(entry, i) {
                        if (entry.type === "none") return null;
                        var finalItemStyle = $f0fba628fc692ac8$var$_objectSpread({
                            display: "block",
                            paddingTop: 4,
                            paddingBottom: 4,
                            color: entry.color || "#000"
                        }, itemStyle);
                        var finalFormatter = entry.formatter || formatter || $f0fba628fc692ac8$var$defaultFormatter;
                        var name = entry.name, value = entry.value;
                        if (finalFormatter) {
                            var formatted = finalFormatter(value, name, entry, i, payload);
                            if (Array.isArray(formatted)) {
                                var _formatted = $f0fba628fc692ac8$var$_slicedToArray(formatted, 2);
                                value = _formatted[0];
                                name = _formatted[1];
                            } else value = formatted;
                        }
                        return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                        (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("li", {
                            className: "recharts-tooltip-item",
                            key: "tooltip-item-".concat(i),
                            style: finalItemStyle
                        }, (0, $804fab7e7cc9eb97$export$402a499e1ea44294)(name) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("span", {
                            className: "recharts-tooltip-item-name"
                        }, name) : null, (0, $804fab7e7cc9eb97$export$402a499e1ea44294)(name) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("span", {
                            className: "recharts-tooltip-item-separator"
                        }, separator) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("span", {
                            className: "recharts-tooltip-item-value"
                        }, value), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("span", {
                            className: "recharts-tooltip-item-unit"
                        }, entry.unit || "")));
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("ul", {
                        className: "recharts-tooltip-item-list",
                        style: listStyle
                    }, items);
                }
                return null;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, wrapperClassName = _this$props2.wrapperClassName, contentStyle = _this$props2.contentStyle, labelClassName = _this$props2.labelClassName, labelStyle = _this$props2.labelStyle, label = _this$props2.label, labelFormatter = _this$props2.labelFormatter, payload = _this$props2.payload;
                var finalStyle = $f0fba628fc692ac8$var$_objectSpread({
                    margin: 0,
                    padding: 10,
                    backgroundColor: "#fff",
                    border: "1px solid #ccc",
                    whiteSpace: "nowrap"
                }, contentStyle);
                var finalLabelStyle = $f0fba628fc692ac8$var$_objectSpread({
                    margin: 0
                }, labelStyle);
                var hasLabel = !(0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(label);
                var finalLabel = hasLabel ? label : "";
                var wrapperCN = (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))("recharts-default-tooltip", wrapperClassName);
                var labelCN = (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))("recharts-tooltip-label", labelClassName);
                if (hasLabel && labelFormatter && payload !== undefined && payload !== null) finalLabel = labelFormatter(label, payload);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    className: wrapperCN,
                    style: finalStyle
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("p", {
                    className: labelCN,
                    style: finalLabelStyle
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), this.renderContent());
            }
        }
    ]);
    return DefaultTooltipContent;
}((0, $jC8Vy.PureComponent));
$f0fba628fc692ac8$export$6fe33945eebf9ac8.displayName = "DefaultTooltipContent";
$f0fba628fc692ac8$export$6fe33945eebf9ac8.defaultProps = {
    separator: " : ",
    contentStyle: {},
    itemStyle: {},
    labelStyle: {}
};




function $def5cb6e7a67bb87$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $def5cb6e7a67bb87$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $def5cb6e7a67bb87$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $def5cb6e7a67bb87$var$_typeof(obj);
}
function $def5cb6e7a67bb87$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $def5cb6e7a67bb87$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $def5cb6e7a67bb87$var$ownKeys(Object(source), true).forEach(function(key) {
            $def5cb6e7a67bb87$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $def5cb6e7a67bb87$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $def5cb6e7a67bb87$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $def5cb6e7a67bb87$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $def5cb6e7a67bb87$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $def5cb6e7a67bb87$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $def5cb6e7a67bb87$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $def5cb6e7a67bb87$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $def5cb6e7a67bb87$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $def5cb6e7a67bb87$var$_setPrototypeOf(subClass, superClass);
}
function $def5cb6e7a67bb87$var$_setPrototypeOf(o, p) {
    $def5cb6e7a67bb87$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $def5cb6e7a67bb87$var$_setPrototypeOf(o, p);
}
function $def5cb6e7a67bb87$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $def5cb6e7a67bb87$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $def5cb6e7a67bb87$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $def5cb6e7a67bb87$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $def5cb6e7a67bb87$var$_possibleConstructorReturn(this, result);
    };
}
function $def5cb6e7a67bb87$var$_possibleConstructorReturn(self, call) {
    if (call && ($def5cb6e7a67bb87$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $def5cb6e7a67bb87$var$_assertThisInitialized(self);
}
function $def5cb6e7a67bb87$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $def5cb6e7a67bb87$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $def5cb6e7a67bb87$var$_getPrototypeOf(o) {
    $def5cb6e7a67bb87$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $def5cb6e7a67bb87$var$_getPrototypeOf(o);
}
var $def5cb6e7a67bb87$var$CLS_PREFIX = "recharts-tooltip-wrapper";
var $def5cb6e7a67bb87$var$EPS = 1;
function $def5cb6e7a67bb87$var$defaultUniqBy(entry) {
    return entry.dataKey;
}
function $def5cb6e7a67bb87$var$getUniqPayload(option, payload) {
    if (option === true) return (0, (/*@__PURE__*/$parcel$interopDefault($8cfdf43387bf2d0c$exports)))(payload, $def5cb6e7a67bb87$var$defaultUniqBy);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(option)) return (0, (/*@__PURE__*/$parcel$interopDefault($8cfdf43387bf2d0c$exports)))(payload, option);
    return payload;
}
function $def5cb6e7a67bb87$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).cloneElement(content, props);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement(content, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $f0fba628fc692ac8$export$6fe33945eebf9ac8), props);
}
var $def5cb6e7a67bb87$export$28c660c63b792dea = /*#__PURE__*/ function(_PureComponent) {
    $def5cb6e7a67bb87$var$_inherits(Tooltip, _PureComponent);
    var _super = $def5cb6e7a67bb87$var$_createSuper(Tooltip);
    function Tooltip() {
        var _this;
        $def5cb6e7a67bb87$var$_classCallCheck(this, Tooltip);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            boxWidth: -1,
            boxHeight: -1,
            dismissed: false,
            dismissedAtCoordinate: {
                x: 0,
                y: 0
            }
        };
        _this.wrapperNode = void 0;
        _this.getTranslate = function(_ref) {
            var key = _ref.key, tooltipDimension = _ref.tooltipDimension, viewBoxDimension = _ref.viewBoxDimension;
            var _this$props = _this.props, allowEscapeViewBox = _this$props.allowEscapeViewBox, coordinate = _this$props.coordinate, offset = _this$props.offset, position = _this$props.position, viewBox = _this$props.viewBox;
            if (position && (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(position[key])) return position[key];
            var restricted = coordinate[key] - tooltipDimension - offset;
            var unrestricted = coordinate[key] + offset;
            if (allowEscapeViewBox[key]) return unrestricted;
            var tooltipBoundary = coordinate[key] + tooltipDimension + offset;
            var viewBoxBoundary = viewBox[key] + viewBoxDimension;
            if (tooltipBoundary > viewBoxBoundary) return Math.max(restricted, viewBox[key]);
            return Math.max(unrestricted, viewBox[key]);
        };
        return _this;
    }
    $def5cb6e7a67bb87$var$_createClass(Tooltip, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateBBox();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateBBox();
            }
        },
        {
            key: "updateBBox",
            value: function updateBBox() {
                var _this$state = this.state, boxWidth = _this$state.boxWidth, boxHeight = _this$state.boxHeight, dismissed = _this$state.dismissed;
                if (dismissed) {
                    this.wrapperNode.blur();
                    if (this.props.coordinate.x !== this.state.dismissedAtCoordinate.x || this.props.coordinate.y !== this.state.dismissedAtCoordinate.y) this.setState({
                        dismissed: false
                    });
                } else this.wrapperNode.focus();
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var box = this.wrapperNode.getBoundingClientRect();
                    if (Math.abs(box.width - boxWidth) > $def5cb6e7a67bb87$var$EPS || Math.abs(box.height - boxHeight) > $def5cb6e7a67bb87$var$EPS) this.setState({
                        boxWidth: box.width,
                        boxHeight: box.height
                    });
                } else if (boxWidth !== -1 || boxHeight !== -1) this.setState({
                    boxWidth: -1,
                    boxHeight: -1
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _classNames, _this2 = this;
                var _this$props2 = this.props, payload = _this$props2.payload, isAnimationActive = _this$props2.isAnimationActive, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, filterNull = _this$props2.filterNull, payloadUniqBy = _this$props2.payloadUniqBy;
                var finalPayload = $def5cb6e7a67bb87$var$getUniqPayload(payloadUniqBy, filterNull && payload && payload.length ? payload.filter(function(entry) {
                    return !(0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(entry.value);
                }) : payload);
                var hasPayload = finalPayload && finalPayload.length;
                var _this$props3 = this.props, content = _this$props3.content, viewBox = _this$props3.viewBox, coordinate = _this$props3.coordinate, position = _this$props3.position, active = _this$props3.active, wrapperStyle = _this$props3.wrapperStyle;
                var outerStyle = $def5cb6e7a67bb87$var$_objectSpread({
                    pointerEvents: "none",
                    visibility: !this.state.dismissed && active && hasPayload ? "visible" : "hidden",
                    position: "absolute",
                    top: 0,
                    left: 0
                }, wrapperStyle);
                var translateX, translateY;
                if (position && (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(position.x) && (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(position.y)) {
                    translateX = position.x;
                    translateY = position.y;
                } else {
                    var _this$state2 = this.state, boxWidth = _this$state2.boxWidth, boxHeight = _this$state2.boxHeight;
                    if (boxWidth > 0 && boxHeight > 0 && coordinate) {
                        translateX = this.getTranslate({
                            key: "x",
                            tooltipDimension: boxWidth,
                            viewBoxDimension: viewBox.width
                        });
                        translateY = this.getTranslate({
                            key: "y",
                            tooltipDimension: boxHeight,
                            viewBoxDimension: viewBox.height
                        });
                    } else outerStyle.visibility = "hidden";
                }
                outerStyle = $def5cb6e7a67bb87$var$_objectSpread($def5cb6e7a67bb87$var$_objectSpread({}, (0, $88a16dea13c3b732$export$ff9926a5d1daa67c)({
                    transform: this.props.useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
                })), outerStyle);
                if (isAnimationActive && active) outerStyle = $def5cb6e7a67bb87$var$_objectSpread($def5cb6e7a67bb87$var$_objectSpread({}, (0, $88a16dea13c3b732$export$ff9926a5d1daa67c)({
                    transition: "transform ".concat(animationDuration, "ms ").concat(animationEasing)
                })), outerStyle);
                var cls = (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($def5cb6e7a67bb87$var$CLS_PREFIX, (_classNames = {}, $def5cb6e7a67bb87$var$_defineProperty(_classNames, "".concat($def5cb6e7a67bb87$var$CLS_PREFIX, "-right"), (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(translateX) && coordinate && (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(coordinate.x) && translateX >= coordinate.x), $def5cb6e7a67bb87$var$_defineProperty(_classNames, "".concat($def5cb6e7a67bb87$var$CLS_PREFIX, "-left"), (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(translateX) && coordinate && (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(coordinate.x) && translateX < coordinate.x), $def5cb6e7a67bb87$var$_defineProperty(_classNames, "".concat($def5cb6e7a67bb87$var$CLS_PREFIX, "-bottom"), (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(translateY) && coordinate && (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(coordinate.y) && translateY >= coordinate.y), $def5cb6e7a67bb87$var$_defineProperty(_classNames, "".concat($def5cb6e7a67bb87$var$CLS_PREFIX, "-top"), (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(translateY) && coordinate && (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(coordinate.y) && translateY < coordinate.y), _classNames));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
                    tabIndex: 0,
                    onKeyDown: function onKeyDown(event) {
                        if (event.key === "Escape") _this2.setState({
                            dismissed: true,
                            dismissedAtCoordinate: $def5cb6e7a67bb87$var$_objectSpread($def5cb6e7a67bb87$var$_objectSpread({}, _this2.state.dismissedAtCoordinate), {}, {
                                x: _this2.props.coordinate.x,
                                y: _this2.props.coordinate.y
                            })
                        });
                    },
                    className: cls,
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, $def5cb6e7a67bb87$var$renderContent(content, $def5cb6e7a67bb87$var$_objectSpread($def5cb6e7a67bb87$var$_objectSpread({}, this.props), {}, {
                    payload: finalPayload
                })));
            }
        }
    ]);
    return Tooltip;
}((0, $jC8Vy.PureComponent));
$def5cb6e7a67bb87$export$28c660c63b792dea.displayName = "Tooltip";
$def5cb6e7a67bb87$export$28c660c63b792dea.defaultProps = {
    active: false,
    allowEscapeViewBox: {
        x: false,
        y: false
    },
    offset: 10,
    viewBox: {
        x1: 0,
        x2: 0,
        y1: 0,
        y2: 0
    },
    coordinate: {
        x: 0,
        y: 0
    },
    cursorStyle: {},
    separator: " : ",
    wrapperStyle: {},
    contentStyle: {},
    itemStyle: {},
    labelStyle: {},
    cursor: true,
    trigger: "hover",
    isAnimationActive: !(0, $02caca8e343c9d9a$export$98f03c5d19621d70).isSsr,
    animationEasing: "ease",
    animationDuration: 400,
    filterNull: true,
    useTranslate3d: false
};





var $jC8Vy = parcelRequire("jC8Vy");

var $5UrGx = parcelRequire("5UrGx");


function $3c938baec9baedc5$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $3c938baec9baedc5$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $3c938baec9baedc5$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $3c938baec9baedc5$var$_typeof(obj);
}
function $3c938baec9baedc5$var$_extends() {
    $3c938baec9baedc5$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3c938baec9baedc5$var$_extends.apply(this, arguments);
}
function $3c938baec9baedc5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3c938baec9baedc5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3c938baec9baedc5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3c938baec9baedc5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3c938baec9baedc5$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $3c938baec9baedc5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $3c938baec9baedc5$var$_setPrototypeOf(subClass, superClass);
}
function $3c938baec9baedc5$var$_setPrototypeOf(o, p) {
    $3c938baec9baedc5$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3c938baec9baedc5$var$_setPrototypeOf(o, p);
}
function $3c938baec9baedc5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $3c938baec9baedc5$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $3c938baec9baedc5$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $3c938baec9baedc5$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $3c938baec9baedc5$var$_possibleConstructorReturn(this, result);
    };
}
function $3c938baec9baedc5$var$_possibleConstructorReturn(self, call) {
    if (call && ($3c938baec9baedc5$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $3c938baec9baedc5$var$_assertThisInitialized(self);
}
function $3c938baec9baedc5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3c938baec9baedc5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $3c938baec9baedc5$var$_getPrototypeOf(o) {
    $3c938baec9baedc5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3c938baec9baedc5$var$_getPrototypeOf(o);
}
var $3c938baec9baedc5$export$3c877bb842c36952 = /*#__PURE__*/ function(_PureComponent) {
    $3c938baec9baedc5$var$_inherits(Cross, _PureComponent);
    var _super = $3c938baec9baedc5$var$_createSuper(Cross);
    function Cross() {
        $3c938baec9baedc5$var$_classCallCheck(this, Cross);
        return _super.apply(this, arguments);
    }
    $3c938baec9baedc5$var$_createClass(Cross, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, x = _this$props.x, y = _this$props.y, width = _this$props.width, height = _this$props.height, top = _this$props.top, left = _this$props.left, className = _this$props.className;
                if (!(0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(x) || !(0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(y) || !(0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(width) || !(0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(height) || !(0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(top) || !(0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(left)) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("path", $3c938baec9baedc5$var$_extends({}, (0, $05a192303b32ed93$export$d697c39a2985a4c)(this.props, true), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))("recharts-cross", className),
                    d: Cross.getPath(x, y, width, height, top, left)
                }));
            }
        }
    ], [
        {
            key: "getPath",
            value: function getPath(x, y, width, height, top, left) {
                return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
            }
        }
    ]);
    return Cross;
}((0, $jC8Vy.PureComponent));
$3c938baec9baedc5$export$3c877bb842c36952.defaultProps = {
    x: 0,
    y: 0,
    top: 0,
    left: 0,
    width: 0,
    height: 0
};



var $jC8Vy = parcelRequire("jC8Vy");

var $5UrGx = parcelRequire("5UrGx");



function $e529a7b3c4259fe3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $e529a7b3c4259fe3$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $e529a7b3c4259fe3$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $e529a7b3c4259fe3$var$_typeof(obj);
}
function $e529a7b3c4259fe3$var$_extends() {
    $e529a7b3c4259fe3$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e529a7b3c4259fe3$var$_extends.apply(this, arguments);
}
function $e529a7b3c4259fe3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e529a7b3c4259fe3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e529a7b3c4259fe3$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e529a7b3c4259fe3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e529a7b3c4259fe3$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $e529a7b3c4259fe3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $e529a7b3c4259fe3$var$_setPrototypeOf(subClass, superClass);
}
function $e529a7b3c4259fe3$var$_setPrototypeOf(o, p) {
    $e529a7b3c4259fe3$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e529a7b3c4259fe3$var$_setPrototypeOf(o, p);
}
function $e529a7b3c4259fe3$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e529a7b3c4259fe3$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $e529a7b3c4259fe3$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $e529a7b3c4259fe3$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $e529a7b3c4259fe3$var$_possibleConstructorReturn(this, result);
    };
}
function $e529a7b3c4259fe3$var$_possibleConstructorReturn(self, call) {
    if (call && ($e529a7b3c4259fe3$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $e529a7b3c4259fe3$var$_assertThisInitialized(self);
}
function $e529a7b3c4259fe3$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e529a7b3c4259fe3$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $e529a7b3c4259fe3$var$_getPrototypeOf(o) {
    $e529a7b3c4259fe3$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e529a7b3c4259fe3$var$_getPrototypeOf(o);
}
var $e529a7b3c4259fe3$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $804fab7e7cc9eb97$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
    return sign * deltaAngle;
};
var $e529a7b3c4259fe3$var$getTangentCircle = function getTangentCircle(_ref) {
    var cx = _ref.cx, cy = _ref.cy, radius = _ref.radius, angle = _ref.angle, sign = _ref.sign, isExternal = _ref.isExternal, cornerRadius = _ref.cornerRadius, cornerIsExternal = _ref.cornerIsExternal;
    var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
    var theta = Math.asin(cornerRadius / centerRadius) / (0, $470bf96dd282a944$export$d74e8f7e9cc3fed3);
    var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
    var center = (0, $470bf96dd282a944$export$5c9a959bb3fc7749)(cx, cy, centerRadius, centerAngle); // The coordinate of point which is tangent to the circle
    var circleTangency = (0, $470bf96dd282a944$export$5c9a959bb3fc7749)(cx, cy, radius, centerAngle); // The coordinate of point which is tangent to the radius line
    var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
    var lineTangency = (0, $470bf96dd282a944$export$5c9a959bb3fc7749)(cx, cy, centerRadius * Math.cos(theta * (0, $470bf96dd282a944$export$d74e8f7e9cc3fed3)), lineTangencyAngle);
    return {
        center: center,
        circleTangency: circleTangency,
        lineTangency: lineTangency,
        theta: theta
    };
};
var $e529a7b3c4259fe3$var$getSectorPath = function getSectorPath(_ref2) {
    var cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var angle = $e529a7b3c4259fe3$var$getDeltaAngle(startAngle, endAngle); // When the angle of sector equals to 360, star point and end point coincide
    var tempEndAngle = startAngle + angle;
    var outerStartPoint = (0, $470bf96dd282a944$export$5c9a959bb3fc7749)(cx, cy, outerRadius, startAngle);
    var outerEndPoint = (0, $470bf96dd282a944$export$5c9a959bb3fc7749)(cx, cy, outerRadius, tempEndAngle);
    var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
    if (innerRadius > 0) {
        var innerStartPoint = (0, $470bf96dd282a944$export$5c9a959bb3fc7749)(cx, cy, innerRadius, startAngle);
        var innerEndPoint = (0, $470bf96dd282a944$export$5c9a959bb3fc7749)(cx, cy, innerRadius, tempEndAngle);
        path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
    } else path += "L ".concat(cx, ",").concat(cy, " Z");
    return path;
};
var $e529a7b3c4259fe3$var$getSectorWithCorner = function getSectorWithCorner(_ref3) {
    var cx = _ref3.cx, cy = _ref3.cy, innerRadius = _ref3.innerRadius, outerRadius = _ref3.outerRadius, cornerRadius = _ref3.cornerRadius, forceCornerRadius = _ref3.forceCornerRadius, cornerIsExternal = _ref3.cornerIsExternal, startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var sign = (0, $804fab7e7cc9eb97$export$9d334328eb75e624)(endAngle - startAngle);
    var _getTangentCircle = $e529a7b3c4259fe3$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: startAngle,
        sign: sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), soct = _getTangentCircle.circleTangency, solt = _getTangentCircle.lineTangency, sot = _getTangentCircle.theta;
    var _getTangentCircle2 = $e529a7b3c4259fe3$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: endAngle,
        sign: -sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), eoct = _getTangentCircle2.circleTangency, eolt = _getTangentCircle2.lineTangency, eot = _getTangentCircle2.theta;
    var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
    if (outerArcAngle < 0) {
        if (forceCornerRadius) return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
        return $e529a7b3c4259fe3$var$getSectorPath({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
    }
    var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
    if (innerRadius > 0) {
        var _getTangentCircle3 = $e529a7b3c4259fe3$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: startAngle,
            sign: sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), sict = _getTangentCircle3.circleTangency, silt = _getTangentCircle3.lineTangency, sit = _getTangentCircle3.theta;
        var _getTangentCircle4 = $e529a7b3c4259fe3$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: endAngle,
            sign: -sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), eict = _getTangentCircle4.circleTangency, eilt = _getTangentCircle4.lineTangency, eit = _getTangentCircle4.theta;
        var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
        if (innerArcAngle < 0 && cornerRadius === 0) return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
        path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
    } else path += "L".concat(cx, ",").concat(cy, "Z");
    return path;
};
var $e529a7b3c4259fe3$export$e98c2c7eb2b14f45 = /*#__PURE__*/ function(_PureComponent) {
    $e529a7b3c4259fe3$var$_inherits(Sector, _PureComponent);
    var _super = $e529a7b3c4259fe3$var$_createSuper(Sector);
    function Sector() {
        $e529a7b3c4259fe3$var$_classCallCheck(this, Sector);
        return _super.apply(this, arguments);
    }
    $e529a7b3c4259fe3$var$_createClass(Sector, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, cx = _this$props.cx, cy = _this$props.cy, innerRadius = _this$props.innerRadius, outerRadius = _this$props.outerRadius, cornerRadius = _this$props.cornerRadius, forceCornerRadius = _this$props.forceCornerRadius, cornerIsExternal = _this$props.cornerIsExternal, startAngle = _this$props.startAngle, endAngle = _this$props.endAngle, className = _this$props.className;
                if (outerRadius < innerRadius || startAngle === endAngle) return null;
                var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))("recharts-sector", className);
                var deltaRadius = outerRadius - innerRadius;
                var cr = (0, $804fab7e7cc9eb97$export$476354dbf49bdff6)(cornerRadius, deltaRadius, 0, true);
                var path;
                if (cr > 0 && Math.abs(startAngle - endAngle) < 360) path = $e529a7b3c4259fe3$var$getSectorWithCorner({
                    cx: cx,
                    cy: cy,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius,
                    cornerRadius: Math.min(cr, deltaRadius / 2),
                    forceCornerRadius: forceCornerRadius,
                    cornerIsExternal: cornerIsExternal,
                    startAngle: startAngle,
                    endAngle: endAngle
                });
                else path = $e529a7b3c4259fe3$var$getSectorPath({
                    cx: cx,
                    cy: cy,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius,
                    startAngle: startAngle,
                    endAngle: endAngle
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("path", $e529a7b3c4259fe3$var$_extends({}, (0, $05a192303b32ed93$export$d697c39a2985a4c)(this.props, true), {
                    className: layerClass,
                    d: path
                }));
            }
        }
    ]);
    return Sector;
}((0, $jC8Vy.PureComponent));
$e529a7b3c4259fe3$export$e98c2c7eb2b14f45.defaultProps = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: false,
    cornerIsExternal: false
};




var $jC8Vy = parcelRequire("jC8Vy");

var $5UrGx = parcelRequire("5UrGx");


function $8ac86f32b9b56c8b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $8ac86f32b9b56c8b$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $8ac86f32b9b56c8b$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $8ac86f32b9b56c8b$var$_typeof(obj);
}
function $8ac86f32b9b56c8b$var$_extends() {
    $8ac86f32b9b56c8b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8ac86f32b9b56c8b$var$_extends.apply(this, arguments);
}
function $8ac86f32b9b56c8b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8ac86f32b9b56c8b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $8ac86f32b9b56c8b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8ac86f32b9b56c8b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8ac86f32b9b56c8b$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $8ac86f32b9b56c8b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $8ac86f32b9b56c8b$var$_setPrototypeOf(subClass, superClass);
}
function $8ac86f32b9b56c8b$var$_setPrototypeOf(o, p) {
    $8ac86f32b9b56c8b$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8ac86f32b9b56c8b$var$_setPrototypeOf(o, p);
}
function $8ac86f32b9b56c8b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $8ac86f32b9b56c8b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $8ac86f32b9b56c8b$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $8ac86f32b9b56c8b$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $8ac86f32b9b56c8b$var$_possibleConstructorReturn(this, result);
    };
}
function $8ac86f32b9b56c8b$var$_possibleConstructorReturn(self, call) {
    if (call && ($8ac86f32b9b56c8b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $8ac86f32b9b56c8b$var$_assertThisInitialized(self);
}
function $8ac86f32b9b56c8b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $8ac86f32b9b56c8b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $8ac86f32b9b56c8b$var$_getPrototypeOf(o) {
    $8ac86f32b9b56c8b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8ac86f32b9b56c8b$var$_getPrototypeOf(o);
}
var $8ac86f32b9b56c8b$var$getRectanglePath = function getRectanglePath(x, y, width, height, radius) {
    var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
    var ySign = height >= 0 ? 1 : -1;
    var xSign = width >= 0 ? 1 : -1;
    var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
    var path;
    if (maxRadius > 0 && radius instanceof Array) {
        var newRadius = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0, len = 4; i < len; i++)newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
        path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);
        if (newRadius[0] > 0) path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
        path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);
        if (newRadius[1] > 0) path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
        path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);
        if (newRadius[2] > 0) path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
        path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);
        if (newRadius[3] > 0) path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
        path += "Z";
    } else if (maxRadius > 0 && radius === +radius && radius > 0) {
        var _newRadius = Math.min(maxRadius, radius);
        path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
    } else path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
    return path;
};
var $8ac86f32b9b56c8b$export$f783d19325be51d5 = function isInRectangle(point, rect) {
    if (!point || !rect) return false;
    var px = point.x, py = point.y;
    var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
    if (Math.abs(width) > 0 && Math.abs(height) > 0) {
        var minX = Math.min(x, x + width);
        var maxX = Math.max(x, x + width);
        var minY = Math.min(y, y + height);
        var maxY = Math.max(y, y + height);
        return px >= minX && px <= maxX && py >= minY && py <= maxY;
    }
    return false;
};
var $8ac86f32b9b56c8b$export$4617fb02663045ef = /*#__PURE__*/ function(_PureComponent) {
    $8ac86f32b9b56c8b$var$_inherits(Rectangle, _PureComponent);
    var _super = $8ac86f32b9b56c8b$var$_createSuper(Rectangle);
    function Rectangle() {
        var _this;
        $8ac86f32b9b56c8b$var$_classCallCheck(this, Rectangle);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            totalLength: -1
        };
        _this.node = void 0;
        return _this;
    }
    $8ac86f32b9b56c8b$var$_createClass(Rectangle, [
        {
            key: "componentDidMount",
            value: /* eslint-disable  react/no-did-mount-set-state */ function componentDidMount() {
                if (this.node && this.node.getTotalLength) try {
                    var totalLength = this.node.getTotalLength();
                    if (totalLength) this.setState({
                        totalLength: totalLength
                    });
                } catch (err) {}
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, x = _this$props.x, y = _this$props.y, width = _this$props.width, height = _this$props.height, radius = _this$props.radius, className = _this$props.className;
                var totalLength = this.state.totalLength;
                var _this$props2 = this.props, animationEasing = _this$props2.animationEasing, animationDuration = _this$props2.animationDuration, animationBegin = _this$props2.animationBegin, isAnimationActive = _this$props2.isAnimationActive, isUpdateAnimationActive = _this$props2.isUpdateAnimationActive;
                if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) return null;
                var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))("recharts-rectangle", className);
                if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("path", $8ac86f32b9b56c8b$var$_extends({}, (0, $05a192303b32ed93$export$d697c39a2985a4c)(this.props, true), {
                    className: layerClass,
                    d: $8ac86f32b9b56c8b$var$getRectanglePath(x, y, width, height, radius)
                }));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $97a4c34858e514f6$export$2e2bcd8739ae039), {
                    canBegin: totalLength > 0,
                    from: {
                        width: width,
                        height: height,
                        x: x,
                        y: y
                    },
                    to: {
                        width: width,
                        height: height,
                        x: x,
                        y: y
                    },
                    duration: animationDuration,
                    animationEasing: animationEasing,
                    isActive: isUpdateAnimationActive
                }, function(_ref) {
                    var currWidth = _ref.width, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $97a4c34858e514f6$export$2e2bcd8739ae039), {
                        canBegin: totalLength > 0,
                        from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
                        to: "".concat(totalLength, "px 0px"),
                        attributeName: "strokeDasharray",
                        begin: animationBegin,
                        duration: animationDuration,
                        isActive: isAnimationActive,
                        easing: animationEasing
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("path", $8ac86f32b9b56c8b$var$_extends({}, (0, $05a192303b32ed93$export$d697c39a2985a4c)(_this2.props, true), {
                        className: layerClass,
                        d: $8ac86f32b9b56c8b$var$getRectanglePath(currX, currY, currWidth, currHeight, radius),
                        ref: function ref(node) {
                            _this2.node = node;
                        }
                    })));
                });
            }
        }
    ]);
    return Rectangle;
}((0, $jC8Vy.PureComponent));
$8ac86f32b9b56c8b$export$4617fb02663045ef.defaultProps = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    // The radius of border
    // The radius of four corners when radius is a number
    // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
    radius: 0,
    isAnimationActive: false,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease"
};






var $jC8Vy = parcelRequire("jC8Vy");

var $5UrGx = parcelRequire("5UrGx");








function $ce731c8553b71ef9$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ce731c8553b71ef9$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $ce731c8553b71ef9$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ce731c8553b71ef9$var$_typeof(obj);
}
function $ce731c8553b71ef9$var$_extends() {
    $ce731c8553b71ef9$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ce731c8553b71ef9$var$_extends.apply(this, arguments);
}
function $ce731c8553b71ef9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ce731c8553b71ef9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ce731c8553b71ef9$var$ownKeys(Object(source), true).forEach(function(key) {
            $ce731c8553b71ef9$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ce731c8553b71ef9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ce731c8553b71ef9$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ce731c8553b71ef9$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ce731c8553b71ef9$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ce731c8553b71ef9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ce731c8553b71ef9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ce731c8553b71ef9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ce731c8553b71ef9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ce731c8553b71ef9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ce731c8553b71ef9$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $ce731c8553b71ef9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $ce731c8553b71ef9$var$_setPrototypeOf(subClass, superClass);
}
function $ce731c8553b71ef9$var$_setPrototypeOf(o, p) {
    $ce731c8553b71ef9$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ce731c8553b71ef9$var$_setPrototypeOf(o, p);
}
function $ce731c8553b71ef9$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ce731c8553b71ef9$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $ce731c8553b71ef9$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $ce731c8553b71ef9$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $ce731c8553b71ef9$var$_possibleConstructorReturn(this, result);
    };
}
function $ce731c8553b71ef9$var$_possibleConstructorReturn(self, call) {
    if (call && ($ce731c8553b71ef9$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $ce731c8553b71ef9$var$_assertThisInitialized(self);
}
function $ce731c8553b71ef9$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ce731c8553b71ef9$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $ce731c8553b71ef9$var$_getPrototypeOf(o) {
    $ce731c8553b71ef9$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ce731c8553b71ef9$var$_getPrototypeOf(o);
}
var $ce731c8553b71ef9$export$bdd99f2cdf352bae = /*#__PURE__*/ function(_Component) {
    $ce731c8553b71ef9$var$_inherits(CartesianAxis, _Component);
    var _super = $ce731c8553b71ef9$var$_createSuper(CartesianAxis);
    function CartesianAxis() {
        $ce731c8553b71ef9$var$_classCallCheck(this, CartesianAxis);
        return _super.apply(this, arguments);
    }
    $ce731c8553b71ef9$var$_createClass(CartesianAxis, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(_ref) {
                var viewBox = _ref.viewBox, restProps = $ce731c8553b71ef9$var$_objectWithoutProperties(_ref, [
                    "viewBox"
                ]);
                // props.viewBox is sometimes generated every time -
                // check that specially as object equality is likely to fail
                var _this$props = this.props, viewBoxOld = _this$props.viewBox, restPropsOld = $ce731c8553b71ef9$var$_objectWithoutProperties(_this$props, [
                    "viewBox"
                ]);
                return !(0, $69167576c9a4dc19$export$d36bdfa510afb180)(viewBox, viewBoxOld) || !(0, $69167576c9a4dc19$export$d36bdfa510afb180)(restProps, restPropsOld);
            }
        },
        {
            key: "getTickLineCoord",
            value: function getTickLineCoord(data) {
                var _this$props2 = this.props, x = _this$props2.x, y = _this$props2.y, width = _this$props2.width, height = _this$props2.height, orientation = _this$props2.orientation, tickSize = _this$props2.tickSize, mirror = _this$props2.mirror, tickMargin = _this$props2.tickMargin;
                var x1, x2, y1, y2, tx, ty;
                var sign = mirror ? -1 : 1;
                var finalTickSize = data.tickSize || tickSize;
                var tickCoord = (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(data.tickCoord) ? data.tickCoord : data.coordinate;
                switch(orientation){
                    case "top":
                        x1 = x2 = data.coordinate;
                        y2 = y + +!mirror * height;
                        y1 = y2 - sign * finalTickSize;
                        ty = y1 - sign * tickMargin;
                        tx = tickCoord;
                        break;
                    case "left":
                        y1 = y2 = data.coordinate;
                        x2 = x + +!mirror * width;
                        x1 = x2 - sign * finalTickSize;
                        tx = x1 - sign * tickMargin;
                        ty = tickCoord;
                        break;
                    case "right":
                        y1 = y2 = data.coordinate;
                        x2 = x + +mirror * width;
                        x1 = x2 + sign * finalTickSize;
                        tx = x1 + sign * tickMargin;
                        ty = tickCoord;
                        break;
                    default:
                        x1 = x2 = data.coordinate;
                        y2 = y + +mirror * height;
                        y1 = y2 + sign * finalTickSize;
                        ty = y1 + sign * tickMargin;
                        tx = tickCoord;
                        break;
                }
                return {
                    line: {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2
                    },
                    tick: {
                        x: tx,
                        y: ty
                    }
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var _this$props3 = this.props, orientation = _this$props3.orientation, mirror = _this$props3.mirror;
                var textAnchor;
                switch(orientation){
                    case "left":
                        textAnchor = mirror ? "start" : "end";
                        break;
                    case "right":
                        textAnchor = mirror ? "end" : "start";
                        break;
                    default:
                        textAnchor = "middle";
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getTickVerticalAnchor",
            value: function getTickVerticalAnchor() {
                var _this$props4 = this.props, orientation = _this$props4.orientation, mirror = _this$props4.mirror;
                var verticalAnchor = "end";
                switch(orientation){
                    case "left":
                    case "right":
                        verticalAnchor = "middle";
                        break;
                    case "top":
                        verticalAnchor = mirror ? "start" : "end";
                        break;
                    default:
                        verticalAnchor = mirror ? "end" : "start";
                        break;
                }
                return verticalAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props5 = this.props, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height, orientation = _this$props5.orientation, mirror = _this$props5.mirror, axisLine = _this$props5.axisLine;
                var props = $ce731c8553b71ef9$var$_objectSpread($ce731c8553b71ef9$var$_objectSpread($ce731c8553b71ef9$var$_objectSpread({}, (0, $05a192303b32ed93$export$d697c39a2985a4c)(this.props)), (0, $05a192303b32ed93$export$d697c39a2985a4c)(axisLine)), {}, {
                    fill: "none"
                });
                if (orientation === "top" || orientation === "bottom") {
                    var needHeight = +(orientation === "top" && !mirror || orientation === "bottom" && mirror);
                    props = $ce731c8553b71ef9$var$_objectSpread($ce731c8553b71ef9$var$_objectSpread({}, props), {}, {
                        x1: x,
                        y1: y + needHeight * height,
                        x2: x + width,
                        y2: y + needHeight * height
                    });
                } else {
                    var needWidth = +(orientation === "left" && !mirror || orientation === "right" && mirror);
                    props = $ce731c8553b71ef9$var$_objectSpread($ce731c8553b71ef9$var$_objectSpread({}, props), {}, {
                        x1: x + needWidth * width,
                        y1: y,
                        x2: x + needWidth * width,
                        y2: y + height
                    });
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("line", $ce731c8553b71ef9$var$_extends({}, props, {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))("recharts-cartesian-axis-line", (0, (/*@__PURE__*/$parcel$interopDefault($2cd7f9f9c3b27772$exports)))(axisLine, "className"))
                }));
            }
        },
        {
            key: "renderTicks",
            value: /**
     * render the ticks
     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
     * @return {ReactComponent} renderedTicks
     */ function renderTicks(ticks) {
                var _this = this;
                var _this$props6 = this.props, tickLine = _this$props6.tickLine, stroke = _this$props6.stroke, tick = _this$props6.tick, tickFormatter = _this$props6.tickFormatter, unit = _this$props6.unit;
                var finalTicks = CartesianAxis.getTicks($ce731c8553b71ef9$var$_objectSpread($ce731c8553b71ef9$var$_objectSpread({}, this.props), {}, {
                    ticks: ticks
                }));
                var textAnchor = this.getTickTextAnchor();
                var verticalAnchor = this.getTickVerticalAnchor();
                var axisProps = (0, $05a192303b32ed93$export$d697c39a2985a4c)(this.props);
                var customTickProps = (0, $05a192303b32ed93$export$d697c39a2985a4c)(tick);
                var tickLineProps = $ce731c8553b71ef9$var$_objectSpread($ce731c8553b71ef9$var$_objectSpread({}, axisProps), {}, {
                    fill: "none"
                }, (0, $05a192303b32ed93$export$d697c39a2985a4c)(tickLine));
                var items = finalTicks.map(function(entry, i) {
                    var _this$getTickLineCoor = _this.getTickLineCoord(entry), lineCoord = _this$getTickLineCoor.line, tickCoord = _this$getTickLineCoor.tick;
                    var tickProps = $ce731c8553b71ef9$var$_objectSpread($ce731c8553b71ef9$var$_objectSpread($ce731c8553b71ef9$var$_objectSpread($ce731c8553b71ef9$var$_objectSpread({
                        textAnchor: textAnchor,
                        verticalAnchor: verticalAnchor
                    }, axisProps), {}, {
                        stroke: "none",
                        fill: stroke
                    }, customTickProps), tickCoord), {}, {
                        index: i,
                        payload: entry,
                        visibleTicksCount: finalTicks.length,
                        tickFormatter: tickFormatter
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $a857ed6b15ebb152$export$936d0764594b6eb3), $ce731c8553b71ef9$var$_extends({
                        className: "recharts-cartesian-axis-tick",
                        key: "tick-".concat(i) // eslint-disable-line react/no-array-index-key
                    }, (0, $05a192303b32ed93$export$ca62be0d67a3158c)(_this.props, entry, i)), tickLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("line", $ce731c8553b71ef9$var$_extends({}, tickLineProps, lineCoord, {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))("recharts-cartesian-axis-tick-line", (0, (/*@__PURE__*/$parcel$interopDefault($2cd7f9f9c3b27772$exports)))(tickLine, "className"))
                    })), tick && CartesianAxis.renderTickItem(tick, tickProps, "".concat((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(tickFormatter) ? tickFormatter(entry.value, i) : entry.value).concat(unit || "")));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("g", {
                    className: "recharts-cartesian-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props7 = this.props, axisLine = _this$props7.axisLine, width = _this$props7.width, height = _this$props7.height, ticksGenerator = _this$props7.ticksGenerator, className = _this$props7.className, hide = _this$props7.hide;
                if (hide) return null;
                var _this$props8 = this.props, ticks = _this$props8.ticks, noTicksProps = $ce731c8553b71ef9$var$_objectWithoutProperties(_this$props8, [
                    "ticks"
                ]);
                var finalTicks = ticks;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(ticksGenerator)) finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
                if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $a857ed6b15ebb152$export$936d0764594b6eb3), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))("recharts-cartesian-axis", className)
                }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks), (0, $3f966edd6f5d584e$export$b04be29aa201d4f5).renderCallByParent(this.props));
            }
        }
    ], [
        {
            key: "getTicks",
            value: function getTicks(props) {
                var tick = props.tick, ticks = props.ticks, viewBox = props.viewBox, minTickGap = props.minTickGap, orientation = props.orientation, interval = props.interval, tickFormatter = props.tickFormatter, unit = props.unit;
                if (!ticks || !ticks.length || !tick) return [];
                if ((0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(interval) || (0, $02caca8e343c9d9a$export$98f03c5d19621d70).isSsr) return CartesianAxis.getNumberIntervalTicks(ticks, typeof interval === "number" && (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(interval) ? interval : 0);
                if (interval === "preserveStartEnd") return CartesianAxis.getTicksStart({
                    ticks: ticks,
                    tickFormatter: tickFormatter,
                    viewBox: viewBox,
                    orientation: orientation,
                    minTickGap: minTickGap,
                    unit: unit
                }, true);
                if (interval === "preserveStart") return CartesianAxis.getTicksStart({
                    ticks: ticks,
                    tickFormatter: tickFormatter,
                    viewBox: viewBox,
                    orientation: orientation,
                    minTickGap: minTickGap,
                    unit: unit
                });
                return CartesianAxis.getTicksEnd({
                    ticks: ticks,
                    tickFormatter: tickFormatter,
                    viewBox: viewBox,
                    orientation: orientation,
                    minTickGap: minTickGap,
                    unit: unit
                });
            }
        },
        {
            key: "getNumberIntervalTicks",
            value: function getNumberIntervalTicks(ticks, interval) {
                return ticks.filter(function(entry, i) {
                    return i % (interval + 1) === 0;
                });
            }
        },
        {
            key: "getTicksStart",
            value: function getTicksStart(_ref2, preserveEnd) {
                var ticks = _ref2.ticks, tickFormatter = _ref2.tickFormatter, viewBox = _ref2.viewBox, orientation = _ref2.orientation, minTickGap = _ref2.minTickGap, unit = _ref2.unit;
                var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
                var sizeKey = orientation === "top" || orientation === "bottom" ? "width" : "height";
                var result = (ticks || []).slice(); // we need add the width of 'unit' only when sizeKey === 'width'
                var unitSize = unit && sizeKey === "width" ? (0, $f9d7f659152e7a9e$export$e5560531f057ad5d)(unit)[sizeKey] : 0;
                var len = result.length;
                var sign = len >= 2 ? (0, $804fab7e7cc9eb97$export$9d334328eb75e624)(result[1].coordinate - result[0].coordinate) : 1;
                var start, end;
                if (sign === 1) {
                    start = sizeKey === "width" ? x : y;
                    end = sizeKey === "width" ? x + width : y + height;
                } else {
                    start = sizeKey === "width" ? x + width : y + height;
                    end = sizeKey === "width" ? x : y;
                }
                if (preserveEnd) {
                    // Try to guarantee the tail to be displayed
                    var tail = ticks[len - 1];
                    var tailContent = (0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(tickFormatter) ? tickFormatter(tail.value, len - 1) : tail.value;
                    var tailSize = (0, $f9d7f659152e7a9e$export$e5560531f057ad5d)(tailContent)[sizeKey] + unitSize;
                    var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
                    result[len - 1] = tail = $ce731c8553b71ef9$var$_objectSpread($ce731c8553b71ef9$var$_objectSpread({}, tail), {}, {
                        tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
                    });
                    var isTailShow = sign * (tail.tickCoord - sign * tailSize / 2 - start) >= 0 && sign * (tail.tickCoord + sign * tailSize / 2 - end) <= 0;
                    if (isTailShow) {
                        end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
                        result[len - 1] = $ce731c8553b71ef9$var$_objectSpread($ce731c8553b71ef9$var$_objectSpread({}, tail), {}, {
                            isShow: true
                        });
                    }
                }
                var count = preserveEnd ? len - 1 : len;
                for(var i = 0; i < count; i++){
                    var entry = result[i];
                    var content = (0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(tickFormatter) ? tickFormatter(entry.value, i) : entry.value;
                    var size = (0, $f9d7f659152e7a9e$export$e5560531f057ad5d)(content)[sizeKey] + unitSize;
                    if (i === 0) {
                        var gap = sign * (entry.coordinate - sign * size / 2 - start);
                        result[i] = entry = $ce731c8553b71ef9$var$_objectSpread($ce731c8553b71ef9$var$_objectSpread({}, entry), {}, {
                            tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
                        });
                    } else result[i] = entry = $ce731c8553b71ef9$var$_objectSpread($ce731c8553b71ef9$var$_objectSpread({}, entry), {}, {
                        tickCoord: entry.coordinate
                    });
                    var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
                    if (isShow) {
                        start = entry.tickCoord + sign * (size / 2 + minTickGap);
                        result[i] = $ce731c8553b71ef9$var$_objectSpread($ce731c8553b71ef9$var$_objectSpread({}, entry), {}, {
                            isShow: true
                        });
                    }
                }
                return result.filter(function(entry) {
                    return entry.isShow;
                });
            }
        },
        {
            key: "getTicksEnd",
            value: function getTicksEnd(_ref3) {
                var ticks = _ref3.ticks, tickFormatter = _ref3.tickFormatter, viewBox = _ref3.viewBox, orientation = _ref3.orientation, minTickGap = _ref3.minTickGap, unit = _ref3.unit;
                var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
                var sizeKey = orientation === "top" || orientation === "bottom" ? "width" : "height"; // we need add the width of 'unit' only when sizeKey === 'width'
                var unitSize = unit && sizeKey === "width" ? (0, $f9d7f659152e7a9e$export$e5560531f057ad5d)(unit)[sizeKey] : 0;
                var result = (ticks || []).slice();
                var len = result.length;
                var sign = len >= 2 ? (0, $804fab7e7cc9eb97$export$9d334328eb75e624)(result[1].coordinate - result[0].coordinate) : 1;
                var start, end;
                if (sign === 1) {
                    start = sizeKey === "width" ? x : y;
                    end = sizeKey === "width" ? x + width : y + height;
                } else {
                    start = sizeKey === "width" ? x + width : y + height;
                    end = sizeKey === "width" ? x : y;
                }
                for(var i = len - 1; i >= 0; i--){
                    var entry = result[i];
                    var content = (0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(tickFormatter) ? tickFormatter(entry.value, len - i - 1) : entry.value;
                    var size = (0, $f9d7f659152e7a9e$export$e5560531f057ad5d)(content)[sizeKey] + unitSize;
                    if (i === len - 1) {
                        var gap = sign * (entry.coordinate + sign * size / 2 - end);
                        result[i] = entry = $ce731c8553b71ef9$var$_objectSpread($ce731c8553b71ef9$var$_objectSpread({}, entry), {}, {
                            tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
                        });
                    } else result[i] = entry = $ce731c8553b71ef9$var$_objectSpread($ce731c8553b71ef9$var$_objectSpread({}, entry), {}, {
                        tickCoord: entry.coordinate
                    });
                    var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
                    if (isShow) {
                        end = entry.tickCoord - sign * (size / 2 + minTickGap);
                        result[i] = $ce731c8553b71ef9$var$_objectSpread($ce731c8553b71ef9$var$_objectSpread({}, entry), {}, {
                            isShow: true
                        });
                    }
                }
                return result.filter(function(entry) {
                    return entry.isShow;
                });
            }
        },
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).isValidElement(option)) tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $9b127a27894cc2e0$export$5f1af8db9871e1d6), $ce731c8553b71ef9$var$_extends({}, props, {
                    className: "recharts-cartesian-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
    return CartesianAxis;
}((0, $jC8Vy.Component));
$ce731c8553b71ef9$export$bdd99f2cdf352bae.displayName = "CartesianAxis";
$ce731c8553b71ef9$export$bdd99f2cdf352bae.defaultProps = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    // The orientation of axis
    orientation: "bottom",
    // The ticks
    ticks: [],
    stroke: "#666",
    tickLine: true,
    axisLine: true,
    tick: true,
    mirror: false,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: "preserveEnd"
};





var $jC8Vy = parcelRequire("jC8Vy");

var $5UrGx = parcelRequire("5UrGx");





function $0624da49f67becb9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0624da49f67becb9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $0624da49f67becb9$var$ownKeys(Object(source), true).forEach(function(key) {
            $0624da49f67becb9$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $0624da49f67becb9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0624da49f67becb9$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $0624da49f67becb9$var$PREFIX_LIST = [
    "Webkit",
    "Moz",
    "O",
    "ms"
];
var $0624da49f67becb9$export$4a9169b65825efee = function generatePrefixStyle(name, value) {
    if (!name) return null;
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var result = $0624da49f67becb9$var$PREFIX_LIST.reduce(function(res, entry) {
        return $0624da49f67becb9$var$_objectSpread($0624da49f67becb9$var$_objectSpread({}, res), {}, $0624da49f67becb9$var$_defineProperty({}, entry + camelName, value));
    }, {});
    result[name] = value;
    return result;
};



function $2ea4d1ce26668dc0$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $2ea4d1ce26668dc0$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $2ea4d1ce26668dc0$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $2ea4d1ce26668dc0$var$_typeof(obj);
}
function $2ea4d1ce26668dc0$var$_extends() {
    $2ea4d1ce26668dc0$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2ea4d1ce26668dc0$var$_extends.apply(this, arguments);
}
function $2ea4d1ce26668dc0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2ea4d1ce26668dc0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2ea4d1ce26668dc0$var$ownKeys(Object(source), true).forEach(function(key) {
            $2ea4d1ce26668dc0$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2ea4d1ce26668dc0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2ea4d1ce26668dc0$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2ea4d1ce26668dc0$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2ea4d1ce26668dc0$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $2ea4d1ce26668dc0$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2ea4d1ce26668dc0$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2ea4d1ce26668dc0$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $2ea4d1ce26668dc0$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $2ea4d1ce26668dc0$var$_setPrototypeOf(subClass, superClass);
}
function $2ea4d1ce26668dc0$var$_setPrototypeOf(o, p) {
    $2ea4d1ce26668dc0$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $2ea4d1ce26668dc0$var$_setPrototypeOf(o, p);
}
function $2ea4d1ce26668dc0$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $2ea4d1ce26668dc0$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $2ea4d1ce26668dc0$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $2ea4d1ce26668dc0$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $2ea4d1ce26668dc0$var$_possibleConstructorReturn(this, result);
    };
}
function $2ea4d1ce26668dc0$var$_possibleConstructorReturn(self, call) {
    if (call && ($2ea4d1ce26668dc0$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $2ea4d1ce26668dc0$var$_assertThisInitialized(self);
}
function $2ea4d1ce26668dc0$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $2ea4d1ce26668dc0$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $2ea4d1ce26668dc0$var$_getPrototypeOf(o) {
    $2ea4d1ce26668dc0$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $2ea4d1ce26668dc0$var$_getPrototypeOf(o);
}
var $2ea4d1ce26668dc0$var$createScale = function createScale(_ref) {
    var data = _ref.data, startIndex = _ref.startIndex, endIndex = _ref.endIndex, x = _ref.x, width = _ref.width, travellerWidth = _ref.travellerWidth;
    if (!data || !data.length) return {};
    var len = data.length;
    var scale = (0, $0b895cda4e30f0e1$export$105684a3041cb6f3)().domain((0, (/*@__PURE__*/$parcel$interopDefault($0fb3a4a2cd8e8970$exports)))(0, len)).range([
        x,
        x + width - travellerWidth
    ]);
    var scaleValues = scale.domain().map(function(entry) {
        return scale(entry);
    });
    return {
        isTextActive: false,
        isSlideMoving: false,
        isTravellerMoving: false,
        startX: scale(startIndex),
        endX: scale(endIndex),
        scale: scale,
        scaleValues: scaleValues
    };
};
var $2ea4d1ce26668dc0$var$isTouch = function isTouch(e) {
    return e.changedTouches && !!e.changedTouches.length;
};
var $2ea4d1ce26668dc0$export$59bc2e3533b384a0 = /*#__PURE__*/ function(_PureComponent) {
    $2ea4d1ce26668dc0$var$_inherits(Brush, _PureComponent);
    var _super = $2ea4d1ce26668dc0$var$_createSuper(Brush);
    function Brush(props) {
        var _this;
        $2ea4d1ce26668dc0$var$_classCallCheck(this, Brush);
        _this = _super.call(this, props);
        _this.leaveTimer = void 0;
        _this.travellerDragStartHandlers = void 0;
        _this.handleDrag = function(e) {
            if (_this.leaveTimer) {
                clearTimeout(_this.leaveTimer);
                _this.leaveTimer = null;
            }
            if (_this.state.isTravellerMoving) _this.handleTravellerMove(e);
            else if (_this.state.isSlideMoving) _this.handleSlideDrag(e);
        };
        _this.handleTouchMove = function(e) {
            if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleDrag(e.changedTouches[0]);
        };
        _this.handleDragEnd = function() {
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: false
            });
            _this.detachDragEndListener();
        };
        _this.handleLeaveWrapper = function() {
            if (_this.state.isTravellerMoving || _this.state.isSlideMoving) _this.leaveTimer = window.setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
        };
        _this.handleEnterSlideOrTraveller = function() {
            _this.setState({
                isTextActive: true
            });
        };
        _this.handleLeaveSlideOrTraveller = function() {
            _this.setState({
                isTextActive: false
            });
        };
        _this.handleSlideDragStart = function(e) {
            var event = $2ea4d1ce26668dc0$var$isTouch(e) ? e.changedTouches[0] : e;
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: true,
                slideMoveStartX: event.pageX
            });
            _this.attachDragEndListener();
        };
        _this.travellerDragStartHandlers = {
            startX: _this.handleTravellerDragStart.bind($2ea4d1ce26668dc0$var$_assertThisInitialized(_this), "startX"),
            endX: _this.handleTravellerDragStart.bind($2ea4d1ce26668dc0$var$_assertThisInitialized(_this), "endX")
        };
        _this.state = {};
        return _this;
    }
    $2ea4d1ce26668dc0$var$_createClass(Brush, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.leaveTimer) {
                    clearTimeout(this.leaveTimer);
                    this.leaveTimer = null;
                }
                this.detachDragEndListener();
            }
        },
        {
            key: "getIndex",
            value: function getIndex(_ref2) {
                var startX = _ref2.startX, endX = _ref2.endX;
                var scaleValues = this.state.scaleValues;
                var _this$props = this.props, gap = _this$props.gap, data = _this$props.data;
                var lastIndex = data.length - 1;
                var min = Math.min(startX, endX);
                var max = Math.max(startX, endX);
                var minIndex = Brush.getIndexInRange(scaleValues, min);
                var maxIndex = Brush.getIndexInRange(scaleValues, max);
                return {
                    startIndex: minIndex - minIndex % gap,
                    endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
                };
            }
        },
        {
            key: "getTextOfTick",
            value: function getTextOfTick(index) {
                var _this$props2 = this.props, data = _this$props2.data, tickFormatter = _this$props2.tickFormatter, dataKey = _this$props2.dataKey;
                var text = (0, $c86c74861e78fc13$export$f97fc4a450f29a)(data[index], dataKey, index);
                return (0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(tickFormatter) ? tickFormatter(text, index) : text;
            }
        },
        {
            key: "attachDragEndListener",
            value: function attachDragEndListener() {
                window.addEventListener("mouseup", this.handleDragEnd, true);
                window.addEventListener("touchend", this.handleDragEnd, true);
            }
        },
        {
            key: "detachDragEndListener",
            value: function detachDragEndListener() {
                window.removeEventListener("mouseup", this.handleDragEnd, true);
                window.removeEventListener("touchend", this.handleDragEnd, true);
            }
        },
        {
            key: "handleSlideDrag",
            value: function handleSlideDrag(e) {
                var _this$state = this.state, slideMoveStartX = _this$state.slideMoveStartX, startX = _this$state.startX, endX = _this$state.endX;
                var _this$props3 = this.props, x = _this$props3.x, width = _this$props3.width, travellerWidth = _this$props3.travellerWidth, startIndex = _this$props3.startIndex, endIndex = _this$props3.endIndex, onChange = _this$props3.onChange;
                var delta = e.pageX - slideMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
                else if (delta < 0) delta = Math.max(delta, x - startX, x - endX);
                var newIndex = this.getIndex({
                    startX: startX + delta,
                    endX: endX + delta
                });
                if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) onChange(newIndex);
                this.setState({
                    startX: startX + delta,
                    endX: endX + delta,
                    slideMoveStartX: e.pageX
                });
            }
        },
        {
            key: "handleTravellerDragStart",
            value: function handleTravellerDragStart(id, e) {
                var event = $2ea4d1ce26668dc0$var$isTouch(e) ? e.changedTouches[0] : e;
                this.setState({
                    isSlideMoving: false,
                    isTravellerMoving: true,
                    movingTravellerId: id,
                    brushMoveStartX: event.pageX
                });
                this.attachDragEndListener();
            }
        },
        {
            key: "handleTravellerMove",
            value: function handleTravellerMove(e) {
                var _this$setState;
                var _this$state2 = this.state, brushMoveStartX = _this$state2.brushMoveStartX, movingTravellerId = _this$state2.movingTravellerId, endX = _this$state2.endX, startX = _this$state2.startX;
                var prevValue = this.state[movingTravellerId];
                var _this$props4 = this.props, x = _this$props4.x, width = _this$props4.width, travellerWidth = _this$props4.travellerWidth, onChange = _this$props4.onChange, gap = _this$props4.gap, data = _this$props4.data;
                var params = {
                    startX: this.state.startX,
                    endX: this.state.endX
                };
                var delta = e.pageX - brushMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - prevValue);
                else if (delta < 0) delta = Math.max(delta, x - prevValue);
                params[movingTravellerId] = prevValue + delta;
                var newIndex = this.getIndex(params);
                var startIndex = newIndex.startIndex, endIndex = newIndex.endIndex;
                var isFullGap = function isFullGap() {
                    var lastIndex = data.length - 1;
                    if (movingTravellerId === "startX" && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === "endX" && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) return true;
                    return false;
                };
                this.setState((_this$setState = {}, $2ea4d1ce26668dc0$var$_defineProperty(_this$setState, movingTravellerId, prevValue + delta), $2ea4d1ce26668dc0$var$_defineProperty(_this$setState, "brushMoveStartX", e.pageX), _this$setState), function() {
                    if (onChange) {
                        if (isFullGap()) onChange(newIndex);
                    }
                });
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this$props5 = this.props, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height, fill = _this$props5.fill, stroke = _this$props5.stroke;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("rect", {
                    stroke: stroke,
                    fill: fill,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderPanorama",
            value: function renderPanorama() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, data = _this$props6.data, children = _this$props6.children, padding = _this$props6.padding;
                var chartElement = (0, $jC8Vy.Children).only(children);
                if (!chartElement) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).cloneElement(chartElement, {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    margin: padding,
                    compact: true,
                    data: data
                });
            }
        },
        {
            key: "renderTravellerLayer",
            value: function renderTravellerLayer(travellerX, id) {
                var _this$props7 = this.props, y = _this$props7.y, travellerWidth = _this$props7.travellerWidth, height = _this$props7.height, traveller = _this$props7.traveller;
                var x = Math.max(travellerX, this.props.x);
                var travellerProps = $2ea4d1ce26668dc0$var$_objectSpread($2ea4d1ce26668dc0$var$_objectSpread({}, (0, $05a192303b32ed93$export$d697c39a2985a4c)(this.props)), {}, {
                    x: x,
                    y: y,
                    width: travellerWidth,
                    height: height
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $a857ed6b15ebb152$export$936d0764594b6eb3), {
                    className: "recharts-brush-traveller",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.travellerDragStartHandlers[id],
                    onTouchStart: this.travellerDragStartHandlers[id],
                    style: {
                        cursor: "col-resize"
                    }
                }, Brush.renderTraveller(traveller, travellerProps));
            }
        },
        {
            key: "renderSlide",
            value: function renderSlide(startX, endX) {
                var _this$props8 = this.props, y = _this$props8.y, height = _this$props8.height, stroke = _this$props8.stroke, travellerWidth = _this$props8.travellerWidth;
                var x = Math.min(startX, endX) + travellerWidth;
                var width = Math.max(Math.abs(endX - startX) - travellerWidth, 0);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("rect", {
                    className: "recharts-brush-slide",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.handleSlideDragStart,
                    onTouchStart: this.handleSlideDragStart,
                    style: {
                        cursor: "move"
                    },
                    stroke: "none",
                    fill: stroke,
                    fillOpacity: 0.2,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderText",
            value: function renderText() {
                var _this$props9 = this.props, startIndex = _this$props9.startIndex, endIndex = _this$props9.endIndex, y = _this$props9.y, height = _this$props9.height, travellerWidth = _this$props9.travellerWidth, stroke = _this$props9.stroke;
                var _this$state3 = this.state, startX = _this$state3.startX, endX = _this$state3.endX;
                var offset = 5;
                var attrs = {
                    pointerEvents: "none",
                    fill: stroke
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $a857ed6b15ebb152$export$936d0764594b6eb3), {
                    className: "recharts-brush-texts"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $9b127a27894cc2e0$export$5f1af8db9871e1d6), $2ea4d1ce26668dc0$var$_extends({
                    textAnchor: "end",
                    verticalAnchor: "middle",
                    x: Math.min(startX, endX) - offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(startIndex)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $9b127a27894cc2e0$export$5f1af8db9871e1d6), $2ea4d1ce26668dc0$var$_extends({
                    textAnchor: "start",
                    verticalAnchor: "middle",
                    x: Math.max(startX, endX) + travellerWidth + offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(endIndex)));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props10 = this.props, data = _this$props10.data, className = _this$props10.className, children = _this$props10.children, x = _this$props10.x, y = _this$props10.y, width = _this$props10.width, height = _this$props10.height, alwaysShowText = _this$props10.alwaysShowText;
                var _this$state4 = this.state, startX = _this$state4.startX, endX = _this$state4.endX, isTextActive = _this$state4.isTextActive, isSlideMoving = _this$state4.isSlideMoving, isTravellerMoving = _this$state4.isTravellerMoving;
                if (!data || !data.length || !(0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(x) || !(0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(y) || !(0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(width) || !(0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(height) || width <= 0 || height <= 0) return null;
                var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))("recharts-brush", className);
                var isPanoramic = (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).Children.count(children) === 1;
                var style = (0, $0624da49f67becb9$export$4a9169b65825efee)("userSelect", "none");
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $a857ed6b15ebb152$export$936d0764594b6eb3), {
                    className: layerClass,
                    onMouseMove: this.handleDrag,
                    onMouseLeave: this.handleLeaveWrapper,
                    onTouchMove: this.handleTouchMove,
                    style: style
                }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTravellerLayer(startX, "startX"), this.renderTravellerLayer(endX, "endX"), (isTextActive || isSlideMoving || isTravellerMoving || alwaysShowText) && this.renderText());
            }
        }
    ], [
        {
            key: "renderDefaultTraveller",
            value: function renderDefaultTraveller(props) {
                var x = props.x, y = props.y, width = props.width, height = props.height, stroke = props.stroke;
                var lineY = Math.floor(y + height / 2) - 1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    fill: stroke,
                    stroke: "none"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("line", {
                    x1: x + 1,
                    y1: lineY,
                    x2: x + width - 1,
                    y2: lineY,
                    fill: "none",
                    stroke: "#fff"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("line", {
                    x1: x + 1,
                    y1: lineY + 2,
                    x2: x + width - 1,
                    y2: lineY + 2,
                    fill: "none",
                    stroke: "#fff"
                }));
            }
        },
        {
            key: "renderTraveller",
            value: function renderTraveller(option, props) {
                var rectangle;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).isValidElement(option)) rectangle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(option)) rectangle = option(props);
                else rectangle = Brush.renderDefaultTraveller(props);
                return rectangle;
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var data = nextProps.data, width = nextProps.width, x = nextProps.x, travellerWidth = nextProps.travellerWidth, updateId = nextProps.updateId, startIndex = nextProps.startIndex, endIndex = nextProps.endIndex;
                if (data !== prevState.prevData || updateId !== prevState.prevUpdateId) return $2ea4d1ce26668dc0$var$_objectSpread({
                    prevData: data,
                    prevTravellerWidth: travellerWidth,
                    prevUpdateId: updateId,
                    prevX: x,
                    prevWidth: width
                }, data && data.length ? $2ea4d1ce26668dc0$var$createScale({
                    data: data,
                    width: width,
                    x: x,
                    travellerWidth: travellerWidth,
                    startIndex: startIndex,
                    endIndex: endIndex
                }) : {
                    scale: null,
                    scaleValues: null
                });
                if (prevState.scale && (width !== prevState.prevWidth || x !== prevState.prevX || travellerWidth !== prevState.prevTravellerWidth)) {
                    prevState.scale.range([
                        x,
                        x + width - travellerWidth
                    ]);
                    var scaleValues = prevState.scale.domain().map(function(entry) {
                        return prevState.scale(entry);
                    });
                    return {
                        prevData: data,
                        prevTravellerWidth: travellerWidth,
                        prevUpdateId: updateId,
                        prevX: x,
                        prevWidth: width,
                        startX: prevState.scale(nextProps.startIndex),
                        endX: prevState.scale(nextProps.endIndex),
                        scaleValues: scaleValues
                    };
                }
                return null;
            }
        },
        {
            key: "getIndexInRange",
            value: function getIndexInRange(range, x) {
                var len = range.length;
                var start = 0;
                var end = len - 1;
                while(end - start > 1){
                    var middle = Math.floor((start + end) / 2);
                    if (range[middle] > x) end = middle;
                    else start = middle;
                }
                return x >= range[end] ? end : start;
            }
        }
    ]);
    return Brush;
}((0, $jC8Vy.PureComponent));
$2ea4d1ce26668dc0$export$59bc2e3533b384a0.displayName = "Brush";
$2ea4d1ce26668dc0$export$59bc2e3533b384a0.defaultProps = {
    height: 40,
    travellerWidth: 5,
    gap: 1,
    fill: "#fff",
    stroke: "#666",
    padding: {
        top: 1,
        right: 1,
        bottom: 1,
        left: 1
    },
    leaveTimeOut: 1000,
    alwaysShowText: false
};







var $jC8Vy = parcelRequire("jC8Vy");

var $5UrGx = parcelRequire("5UrGx");




var $120ce39809b713cf$export$3fb112445eb31879 = function ifOverflowMatches(props, value) {
    var alwaysShow = props.alwaysShow;
    var ifOverflow = props.ifOverflow;
    if (alwaysShow) ifOverflow = "extendDomain";
    return ifOverflow === value;
};



var $2abd82bfca95ed73$exports = {};



/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $2abd82bfca95ed73$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $958e35cadb69881a$exports(iteratee, 3);
    $48b10c759085c7c7$exports(object, function(value, key, object) {
        $03aeaa7f27e7b78e$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$2abd82bfca95ed73$exports = $2abd82bfca95ed73$var$mapValues;





function $6d35a382c17a9759$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6d35a382c17a9759$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6d35a382c17a9759$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6d35a382c17a9759$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6d35a382c17a9759$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $6d35a382c17a9759$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6d35a382c17a9759$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $6d35a382c17a9759$var$ownKeys(Object(source), true).forEach(function(key) {
            $6d35a382c17a9759$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $6d35a382c17a9759$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6d35a382c17a9759$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $6d35a382c17a9759$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height, layout = props.layout, children = props.children;
    var ids = Object.keys(axisMap);
    var steps = {
        left: offset.left,
        leftMirror: offset.left,
        right: width - offset.right,
        rightMirror: width - offset.right,
        top: offset.top,
        topMirror: offset.top,
        bottom: height - offset.bottom,
        bottomMirror: height - offset.bottom
    };
    var hasBar = !!(0, $217577d291f12aa3$export$64c61536a2b72e0f)(children, "Bar");
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var orientation = axis.orientation, domain = axis.domain, _axis$padding = axis.padding, padding = _axis$padding === void 0 ? {} : _axis$padding, mirror = axis.mirror, reversed = axis.reversed;
        var offsetKey = "".concat(orientation).concat(mirror ? "Mirror" : "");
        var calculatedPadding, range, x, y, needSpace;
        if (axis.type === "number" && (axis.padding === "gap" || axis.padding === "no-gap")) {
            var diff = domain[1] - domain[0];
            var smallestDistanceBetweenValues = Infinity;
            var sortedValues = axis.categoricalDomain.sort();
            sortedValues.forEach(function(value, index) {
                if (index > 0) smallestDistanceBetweenValues = Math.min((value || 0) - (sortedValues[index - 1] || 0), smallestDistanceBetweenValues);
            });
            var smallestDistanceInPercent = smallestDistanceBetweenValues / diff;
            var rangeWidth = axis.layout === "vertical" ? offset.height : offset.width;
            if (axis.padding === "gap") calculatedPadding = smallestDistanceInPercent * rangeWidth / 2;
            if (axis.padding === "no-gap") {
                var gap = (0, $804fab7e7cc9eb97$export$476354dbf49bdff6)(props.barCategoryGap, smallestDistanceInPercent * rangeWidth);
                var halfBand = smallestDistanceInPercent * rangeWidth / 2;
                calculatedPadding = halfBand - gap - (halfBand - gap) / rangeWidth * gap;
            }
        }
        if (axisType === "xAxis") range = [
            offset.left + (padding.left || 0) + (calculatedPadding || 0),
            offset.left + offset.width - (padding.right || 0) - (calculatedPadding || 0)
        ];
        else if (axisType === "yAxis") range = layout === "horizontal" ? [
            offset.top + offset.height - (padding.bottom || 0),
            offset.top + (padding.top || 0)
        ] : [
            offset.top + (padding.top || 0) + (calculatedPadding || 0),
            offset.top + offset.height - (padding.bottom || 0) - (calculatedPadding || 0)
        ];
        else range = axis.range;
        if (reversed) range = [
            range[1],
            range[0]
        ];
        var _parseScale = (0, $c86c74861e78fc13$export$534b094a708572c1)(axis, chartName, hasBar), scale = _parseScale.scale, realScaleType = _parseScale.realScaleType;
        scale.domain(domain).range(range);
        (0, $c86c74861e78fc13$export$9d80152e23bae434)(scale);
        var ticks = (0, $c86c74861e78fc13$export$ac086aaa4358d590)(scale, $6d35a382c17a9759$var$_objectSpread($6d35a382c17a9759$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        if (axisType === "xAxis") {
            needSpace = orientation === "top" && !mirror || orientation === "bottom" && mirror;
            x = offset.left;
            y = steps[offsetKey] - needSpace * axis.height;
        } else if (axisType === "yAxis") {
            needSpace = orientation === "left" && !mirror || orientation === "right" && mirror;
            x = steps[offsetKey] - needSpace * axis.width;
            y = offset.top;
        }
        var finalAxis = $6d35a382c17a9759$var$_objectSpread($6d35a382c17a9759$var$_objectSpread($6d35a382c17a9759$var$_objectSpread({}, axis), ticks), {}, {
            realScaleType: realScaleType,
            x: x,
            y: y,
            scale: scale,
            width: axisType === "xAxis" ? offset.width : axis.width,
            height: axisType === "yAxis" ? offset.height : axis.height
        });
        finalAxis.bandSize = (0, $c86c74861e78fc13$export$212ec45c42fe68a7)(finalAxis, ticks);
        if (!axis.hide && axisType === "xAxis") steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
        else if (!axis.hide) steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
        return $6d35a382c17a9759$var$_objectSpread($6d35a382c17a9759$var$_objectSpread({}, result), {}, $6d35a382c17a9759$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $6d35a382c17a9759$export$c7964a5b9439ae62 = function rectWithPoints(_ref, _ref2) {
    var x1 = _ref.x, y1 = _ref.y;
    var x2 = _ref2.x, y2 = _ref2.y;
    return {
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1)
    };
};
var $6d35a382c17a9759$export$6df2062b9e15eec0 = function rectWithCoords(_ref3) {
    var x1 = _ref3.x1, y1 = _ref3.y1, x2 = _ref3.x2, y2 = _ref3.y2;
    return $6d35a382c17a9759$export$c7964a5b9439ae62({
        x: x1,
        y: y1
    }, {
        x: x2,
        y: y2
    });
};
var $6d35a382c17a9759$export$dae1ac4449a69ee8 = /*#__PURE__*/ function() {
    function ScaleHelper(scale) {
        $6d35a382c17a9759$var$_classCallCheck(this, ScaleHelper);
        this.scale = void 0;
        this.scale = scale;
    }
    $6d35a382c17a9759$var$_createClass(ScaleHelper, [
        {
            key: "domain",
            get: function get() {
                return this.scale.domain;
            }
        },
        {
            key: "range",
            get: function get() {
                return this.scale.range;
            }
        },
        {
            key: "rangeMin",
            get: function get() {
                return this.range()[0];
            }
        },
        {
            key: "rangeMax",
            get: function get() {
                return this.range()[1];
            }
        },
        {
            key: "bandwidth",
            get: function get() {
                return this.scale.bandwidth;
            }
        },
        {
            key: "apply",
            value: function apply(value) {
                var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref4.bandAware, position = _ref4.position;
                if (value === undefined) return undefined;
                if (position) switch(position){
                    case "start":
                        return this.scale(value);
                    case "middle":
                        var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
                        return this.scale(value) + offset;
                    case "end":
                        var _offset = this.bandwidth ? this.bandwidth() : 0;
                        return this.scale(value) + _offset;
                    default:
                        return this.scale(value);
                }
                if (bandAware) {
                    var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
                    return this.scale(value) + _offset2;
                }
                return this.scale(value);
            }
        },
        {
            key: "isInRange",
            value: function isInRange(value) {
                var range = this.range();
                var first = range[0];
                var last = range[range.length - 1];
                return first <= last ? value >= first && value <= last : value >= last && value <= first;
            }
        }
    ], [
        {
            key: "create",
            value: function create(obj) {
                return new ScaleHelper(obj);
            }
        }
    ]);
    return ScaleHelper;
}();
$6d35a382c17a9759$export$dae1ac4449a69ee8.EPS = 1e-4;
var $6d35a382c17a9759$export$db77ae668c18269f = function createLabeledScales(options) {
    var scales = Object.keys(options).reduce(function(res, key) {
        return $6d35a382c17a9759$var$_objectSpread($6d35a382c17a9759$var$_objectSpread({}, res), {}, $6d35a382c17a9759$var$_defineProperty({}, key, $6d35a382c17a9759$export$dae1ac4449a69ee8.create(options[key])));
    }, {});
    return $6d35a382c17a9759$var$_objectSpread($6d35a382c17a9759$var$_objectSpread({}, scales), {}, {
        apply: function apply(coord) {
            var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref5.bandAware, position = _ref5.position;
            return (0, (/*@__PURE__*/$parcel$interopDefault($2abd82bfca95ed73$exports)))(coord, function(value, label) {
                return scales[label].apply(value, {
                    bandAware: bandAware,
                    position: position
                });
            });
        },
        isInRange: function isInRange(coord) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($1867c288c9a52a34$exports)))(coord, function(value, label) {
                return scales[label].isInRange(value);
            });
        }
    });
};


/* eslint no-console: 0 */ var $2a9fb8012300d38c$var$isDev = false;
var $2a9fb8012300d38c$export$c106dd0671a0fc2d = function warn(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if ($2a9fb8012300d38c$var$isDev && typeof console !== "undefined" && console.warn) {
        if (format === undefined) console.warn("LogUtils requires an error message argument");
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};



function $d164a262d99df743$var$_extends() {
    $d164a262d99df743$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d164a262d99df743$var$_extends.apply(this, arguments);
}
function $d164a262d99df743$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d164a262d99df743$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d164a262d99df743$var$ownKeys(Object(source), true).forEach(function(key) {
            $d164a262d99df743$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d164a262d99df743$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d164a262d99df743$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $d164a262d99df743$var$getCoordinate = function getCoordinate(props) {
    var x = props.x, y = props.y, xAxis = props.xAxis, yAxis = props.yAxis;
    var scales = (0, $6d35a382c17a9759$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var result = scales.apply({
        x: x,
        y: y
    }, {
        bandAware: true
    });
    if ((0, $120ce39809b713cf$export$3fb112445eb31879)(props, "discard") && !scales.isInRange(result)) return null;
    return result;
};
function $d164a262d99df743$export$aa7f0b0106bff39(props) {
    var x = props.x, y = props.y, r = props.r, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    var isX = (0, $804fab7e7cc9eb97$export$402a499e1ea44294)(x);
    var isY = (0, $804fab7e7cc9eb97$export$402a499e1ea44294)(y);
    (0, $2a9fb8012300d38c$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    if (!isX || !isY) return null;
    var coordinate = $d164a262d99df743$var$getCoordinate(props);
    if (!coordinate) return null;
    var cx = coordinate.x, cy = coordinate.y;
    var shape = props.shape, className = props.className;
    var clipPath = (0, $120ce39809b713cf$export$3fb112445eb31879)(props, "hidden") ? "url(#".concat(clipPathId, ")") : undefined;
    var dotProps = $d164a262d99df743$var$_objectSpread($d164a262d99df743$var$_objectSpread({
        clipPath: clipPath
    }, (0, $05a192303b32ed93$export$d697c39a2985a4c)(props, true)), {}, {
        cx: cx,
        cy: cy
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $a857ed6b15ebb152$export$936d0764594b6eb3), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))("recharts-reference-dot", className)
    }, $d164a262d99df743$export$aa7f0b0106bff39.renderDot(shape, dotProps), (0, $3f966edd6f5d584e$export$b04be29aa201d4f5).renderCallByParent(props, {
        x: cx - r,
        y: cy - r,
        width: 2 * r,
        height: 2 * r
    }));
}
$d164a262d99df743$export$aa7f0b0106bff39.displayName = "ReferenceDot";
$d164a262d99df743$export$aa7f0b0106bff39.defaultProps = {
    isFront: false,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: "#fff",
    stroke: "#ccc",
    fillOpacity: 1,
    strokeWidth: 1
};
$d164a262d99df743$export$aa7f0b0106bff39.renderDot = function(option, props) {
    var dot;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).isValidElement(option)) dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(option)) dot = option(props);
    else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $d32ef06d884f12a9$export$d046b3c4a416f60d), $d164a262d99df743$var$_extends({}, props, {
        cx: props.cx,
        cy: props.cy,
        className: "recharts-reference-dot-dot"
    }));
    return dot;
};


var $d0991161632bba9c$exports = {};


var $663bb20f8ea3870d$exports = {};

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $663bb20f8ea3870d$var$baseSome(collection, predicate) {
    var result;
    $f08c47d4f9033453$exports(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
$663bb20f8ea3870d$exports = $663bb20f8ea3870d$var$baseSome;




/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $d0991161632bba9c$var$some(collection, predicate, guard) {
    var func = $0fe4a5546443a34c$exports(collection) ? $5d099b7c8da75d83$exports : $663bb20f8ea3870d$exports;
    if (guard && $3c4d4e2d8b3e6d8b$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $958e35cadb69881a$exports(predicate, 3));
}
$d0991161632bba9c$exports = $d0991161632bba9c$var$some;




var $jC8Vy = parcelRequire("jC8Vy");

var $5UrGx = parcelRequire("5UrGx");







function $8b548999b8244cd4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8b548999b8244cd4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $8b548999b8244cd4$var$ownKeys(Object(source), true).forEach(function(key) {
            $8b548999b8244cd4$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $8b548999b8244cd4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8b548999b8244cd4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8b548999b8244cd4$var$_slicedToArray(arr, i) {
    return $8b548999b8244cd4$var$_arrayWithHoles(arr) || $8b548999b8244cd4$var$_iterableToArrayLimit(arr, i) || $8b548999b8244cd4$var$_unsupportedIterableToArray(arr, i) || $8b548999b8244cd4$var$_nonIterableRest();
}
function $8b548999b8244cd4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8b548999b8244cd4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8b548999b8244cd4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8b548999b8244cd4$var$_arrayLikeToArray(o, minLen);
}
function $8b548999b8244cd4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8b548999b8244cd4$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $8b548999b8244cd4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $8b548999b8244cd4$var$_extends() {
    $8b548999b8244cd4$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8b548999b8244cd4$var$_extends.apply(this, arguments);
}
var $8b548999b8244cd4$var$renderLine = function renderLine(option, props) {
    var line;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).isValidElement(option)) line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(option)) line = option(props);
    else line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("line", $8b548999b8244cd4$var$_extends({}, props, {
        className: "recharts-reference-line-line"
    }));
    return line;
}; // TODO: ScaleHelper
var $8b548999b8244cd4$var$getEndPoints = function getEndPoints(scales, isFixedX, isFixedY, isSegment, props) {
    var _props$viewBox = props.viewBox, x = _props$viewBox.x, y = _props$viewBox.y, width = _props$viewBox.width, height = _props$viewBox.height, position = props.position;
    if (isFixedY) {
        var yCoord = props.y, orientation = props.yAxis.orientation;
        var coord = scales.y.apply(yCoord, {
            position: position
        });
        if ((0, $120ce39809b713cf$export$3fb112445eb31879)(props, "discard") && !scales.y.isInRange(coord)) return null;
        var points = [
            {
                x: x + width,
                y: coord
            },
            {
                x: x,
                y: coord
            }
        ];
        return orientation === "left" ? points.reverse() : points;
    }
    if (isFixedX) {
        var xCoord = props.x, _orientation = props.xAxis.orientation;
        var _coord = scales.x.apply(xCoord, {
            position: position
        });
        if ((0, $120ce39809b713cf$export$3fb112445eb31879)(props, "discard") && !scales.x.isInRange(_coord)) return null;
        var _points = [
            {
                x: _coord,
                y: y + height
            },
            {
                x: _coord,
                y: y
            }
        ];
        return _orientation === "top" ? _points.reverse() : _points;
    }
    if (isSegment) {
        var segment = props.segment;
        var _points2 = segment.map(function(p) {
            return scales.apply(p, {
                position: position
            });
        });
        if ((0, $120ce39809b713cf$export$3fb112445eb31879)(props, "discard") && (0, (/*@__PURE__*/$parcel$interopDefault($d0991161632bba9c$exports)))(_points2, function(p) {
            return !scales.isInRange(p);
        })) return null;
        return _points2;
    }
    return null;
};
function $8b548999b8244cd4$export$b2f28e248e7838eb(props) {
    var fixedX = props.x, fixedY = props.y, segment = props.segment, xAxis = props.xAxis, yAxis = props.yAxis, shape = props.shape, className = props.className, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    (0, $2a9fb8012300d38c$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var scales = (0, $6d35a382c17a9759$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var isX = (0, $804fab7e7cc9eb97$export$402a499e1ea44294)(fixedX);
    var isY = (0, $804fab7e7cc9eb97$export$402a499e1ea44294)(fixedY);
    var isSegment = segment && segment.length === 2;
    var endPoints = $8b548999b8244cd4$var$getEndPoints(scales, isX, isY, isSegment, props);
    if (!endPoints) return null;
    var _endPoints = $8b548999b8244cd4$var$_slicedToArray(endPoints, 2), _endPoints$ = _endPoints[0], x1 = _endPoints$.x, y1 = _endPoints$.y, _endPoints$2 = _endPoints[1], x2 = _endPoints$2.x, y2 = _endPoints$2.y;
    var clipPath = (0, $120ce39809b713cf$export$3fb112445eb31879)(props, "hidden") ? "url(#".concat(clipPathId, ")") : undefined;
    var lineProps = $8b548999b8244cd4$var$_objectSpread($8b548999b8244cd4$var$_objectSpread({
        clipPath: clipPath
    }, (0, $05a192303b32ed93$export$d697c39a2985a4c)(props, true)), {}, {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $a857ed6b15ebb152$export$936d0764594b6eb3), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))("recharts-reference-line", className)
    }, $8b548999b8244cd4$var$renderLine(shape, lineProps), (0, $3f966edd6f5d584e$export$b04be29aa201d4f5).renderCallByParent(props, (0, $6d35a382c17a9759$export$6df2062b9e15eec0)({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    })));
}
$8b548999b8244cd4$export$b2f28e248e7838eb.displayName = "ReferenceLine";
$8b548999b8244cd4$export$b2f28e248e7838eb.defaultProps = {
    isFront: false,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    fill: "none",
    stroke: "#ccc",
    fillOpacity: 1,
    strokeWidth: 1,
    position: "middle"
};




var $jC8Vy = parcelRequire("jC8Vy");

var $5UrGx = parcelRequire("5UrGx");








function $ad757a409f71132c$var$_extends() {
    $ad757a409f71132c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ad757a409f71132c$var$_extends.apply(this, arguments);
}
function $ad757a409f71132c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ad757a409f71132c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ad757a409f71132c$var$ownKeys(Object(source), true).forEach(function(key) {
            $ad757a409f71132c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ad757a409f71132c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ad757a409f71132c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $ad757a409f71132c$var$getRect = function getRect(hasX1, hasX2, hasY1, hasY2, props) {
    var xValue1 = props.x1, xValue2 = props.x2, yValue1 = props.y1, yValue2 = props.y2, xAxis = props.xAxis, yAxis = props.yAxis;
    if (!xAxis || !yAxis) return null;
    var scales = (0, $6d35a382c17a9759$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var p1 = {
        x: hasX1 ? scales.x.apply(xValue1, {
            position: "start"
        }) : scales.x.rangeMin,
        y: hasY1 ? scales.y.apply(yValue1, {
            position: "start"
        }) : scales.y.rangeMin
    };
    var p2 = {
        x: hasX2 ? scales.x.apply(xValue2, {
            position: "end"
        }) : scales.x.rangeMax,
        y: hasY2 ? scales.y.apply(yValue2, {
            position: "end"
        }) : scales.y.rangeMax
    };
    if ((0, $120ce39809b713cf$export$3fb112445eb31879)(props, "discard") && (!scales.isInRange(p1) || !scales.isInRange(p2))) return null;
    return (0, $6d35a382c17a9759$export$c7964a5b9439ae62)(p1, p2);
};
function $ad757a409f71132c$export$b4ec4f050ce240b9(props) {
    var x1 = props.x1, x2 = props.x2, y1 = props.y1, y2 = props.y2, className = props.className, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    (0, $2a9fb8012300d38c$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var hasX1 = (0, $804fab7e7cc9eb97$export$402a499e1ea44294)(x1);
    var hasX2 = (0, $804fab7e7cc9eb97$export$402a499e1ea44294)(x2);
    var hasY1 = (0, $804fab7e7cc9eb97$export$402a499e1ea44294)(y1);
    var hasY2 = (0, $804fab7e7cc9eb97$export$402a499e1ea44294)(y2);
    var shape = props.shape;
    if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) return null;
    var rect = $ad757a409f71132c$var$getRect(hasX1, hasX2, hasY1, hasY2, props);
    if (!rect && !shape) return null;
    var clipPath = (0, $120ce39809b713cf$export$3fb112445eb31879)(props, "hidden") ? "url(#".concat(clipPathId, ")") : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $a857ed6b15ebb152$export$936d0764594b6eb3), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))("recharts-reference-area", className)
    }, $ad757a409f71132c$export$b4ec4f050ce240b9.renderRect(shape, $ad757a409f71132c$var$_objectSpread($ad757a409f71132c$var$_objectSpread({
        clipPath: clipPath
    }, (0, $05a192303b32ed93$export$d697c39a2985a4c)(props, true)), rect)), (0, $3f966edd6f5d584e$export$b04be29aa201d4f5).renderCallByParent(props, rect));
}
$ad757a409f71132c$export$b4ec4f050ce240b9.displayName = "ReferenceArea";
$ad757a409f71132c$export$b4ec4f050ce240b9.defaultProps = {
    isFront: false,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: "#ccc",
    fillOpacity: 0.5,
    stroke: "none",
    strokeWidth: 1
};
$ad757a409f71132c$export$b4ec4f050ce240b9.renderRect = function(option, props) {
    var rect;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).isValidElement(option)) rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(option)) rect = option(props);
    else rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $8ac86f32b9b56c8b$export$4617fb02663045ef), $ad757a409f71132c$var$_extends({}, props, {
        className: "recharts-reference-area-rect"
    }));
    return rect;
};





var $bcb72bd035dfb736$export$62ecf5c04b491381 = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
    var lines = (0, $217577d291f12aa3$export$fdd5e64c0e8495bb)(children, (0, $8b548999b8244cd4$export$b2f28e248e7838eb).displayName);
    var dots = (0, $217577d291f12aa3$export$fdd5e64c0e8495bb)(children, (0, $d164a262d99df743$export$aa7f0b0106bff39).displayName);
    var elements = lines.concat(dots);
    var areas = (0, $217577d291f12aa3$export$fdd5e64c0e8495bb)(children, (0, $ad757a409f71132c$export$b4ec4f050ce240b9).displayName);
    var idKey = "".concat(axisType, "Id");
    var valueKey = axisType[0];
    var finalDomain = domain;
    if (elements.length) finalDomain = elements.reduce(function(result, el) {
        if (el.props[idKey] === axisId && (0, $120ce39809b713cf$export$3fb112445eb31879)(el.props, "extendDomain") && (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(el.props[valueKey])) {
            var value = el.props[valueKey];
            return [
                Math.min(result[0], value),
                Math.max(result[1], value)
            ];
        }
        return result;
    }, finalDomain);
    if (areas.length) {
        var key1 = "".concat(valueKey, "1");
        var key2 = "".concat(valueKey, "2");
        finalDomain = areas.reduce(function(result, el) {
            if (el.props[idKey] === axisId && (0, $120ce39809b713cf$export$3fb112445eb31879)(el.props, "extendDomain") && (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(el.props[key1]) && (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(el.props[key2])) {
                var value1 = el.props[key1];
                var value2 = el.props[key2];
                return [
                    Math.min(result[0], value1, value2),
                    Math.max(result[1], value1, value2)
                ];
            }
            return result;
        }, finalDomain);
    }
    if (specifiedTicks && specifiedTicks.length) finalDomain = specifiedTicks.reduce(function(result, tick) {
        if ((0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(tick)) return [
            Math.min(result[0], tick),
            Math.max(result[1], tick)
        ];
        return result;
    }, finalDomain);
    return finalDomain;
};




var $a66275c8ac056903$exports = {};
"use strict";
var $a66275c8ac056903$var$has = Object.prototype.hasOwnProperty, $a66275c8ac056903$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $a66275c8ac056903$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $a66275c8ac056903$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $a66275c8ac056903$var$Events().__proto__) $a66275c8ac056903$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $a66275c8ac056903$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $a66275c8ac056903$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $a66275c8ac056903$var$EE(fn, context || emitter, once), evt = $a66275c8ac056903$var$prefix ? $a66275c8ac056903$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $a66275c8ac056903$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $a66275c8ac056903$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $a66275c8ac056903$var$EventEmitter() {
    this._events = new $a66275c8ac056903$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $a66275c8ac056903$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($a66275c8ac056903$var$has.call(events, name)) names.push($a66275c8ac056903$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $a66275c8ac056903$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $a66275c8ac056903$var$prefix ? $a66275c8ac056903$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $a66275c8ac056903$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $a66275c8ac056903$var$prefix ? $a66275c8ac056903$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $a66275c8ac056903$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $a66275c8ac056903$var$prefix ? $a66275c8ac056903$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $a66275c8ac056903$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $a66275c8ac056903$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $a66275c8ac056903$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $a66275c8ac056903$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $a66275c8ac056903$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $a66275c8ac056903$var$prefix ? $a66275c8ac056903$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $a66275c8ac056903$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $a66275c8ac056903$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $a66275c8ac056903$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $a66275c8ac056903$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $a66275c8ac056903$var$prefix ? $a66275c8ac056903$var$prefix + event : event;
        if (this._events[evt]) $a66275c8ac056903$var$clearEvent(this, evt);
    } else {
        this._events = new $a66275c8ac056903$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$a66275c8ac056903$var$EventEmitter.prototype.off = $a66275c8ac056903$var$EventEmitter.prototype.removeListener;
$a66275c8ac056903$var$EventEmitter.prototype.addListener = $a66275c8ac056903$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$a66275c8ac056903$var$EventEmitter.prefixed = $a66275c8ac056903$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$a66275c8ac056903$var$EventEmitter.EventEmitter = $a66275c8ac056903$var$EventEmitter;
$a66275c8ac056903$exports = $a66275c8ac056903$var$EventEmitter;


var $7b280888e35ce977$export$9bcdfe5f29bb33 = new (0, (/*@__PURE__*/$parcel$interopDefault($a66275c8ac056903$exports)))();
if ($7b280888e35ce977$export$9bcdfe5f29bb33.setMaxListeners) $7b280888e35ce977$export$9bcdfe5f29bb33.setMaxListeners(10);
var $7b280888e35ce977$export$ff9a08f6d0c38b8f = "recharts.syncMouseEvents"; // eslint-disable-next-line no-redeclare



function $1665b5dabe1eba12$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $1665b5dabe1eba12$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $1665b5dabe1eba12$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $1665b5dabe1eba12$var$_typeof(obj);
}
function $1665b5dabe1eba12$var$_slicedToArray(arr, i) {
    return $1665b5dabe1eba12$var$_arrayWithHoles(arr) || $1665b5dabe1eba12$var$_iterableToArrayLimit(arr, i) || $1665b5dabe1eba12$var$_unsupportedIterableToArray(arr, i) || $1665b5dabe1eba12$var$_nonIterableRest();
}
function $1665b5dabe1eba12$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1665b5dabe1eba12$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $1665b5dabe1eba12$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $1665b5dabe1eba12$var$_extends() {
    $1665b5dabe1eba12$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1665b5dabe1eba12$var$_extends.apply(this, arguments);
}
function $1665b5dabe1eba12$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1665b5dabe1eba12$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1665b5dabe1eba12$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $1665b5dabe1eba12$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1665b5dabe1eba12$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1665b5dabe1eba12$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1665b5dabe1eba12$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1665b5dabe1eba12$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $1665b5dabe1eba12$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $1665b5dabe1eba12$var$_setPrototypeOf(subClass, superClass);
}
function $1665b5dabe1eba12$var$_setPrototypeOf(o, p) {
    $1665b5dabe1eba12$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1665b5dabe1eba12$var$_setPrototypeOf(o, p);
}
function $1665b5dabe1eba12$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1665b5dabe1eba12$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $1665b5dabe1eba12$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $1665b5dabe1eba12$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $1665b5dabe1eba12$var$_possibleConstructorReturn(this, result);
    };
}
function $1665b5dabe1eba12$var$_possibleConstructorReturn(self, call) {
    if (call && ($1665b5dabe1eba12$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $1665b5dabe1eba12$var$_assertThisInitialized(self);
}
function $1665b5dabe1eba12$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1665b5dabe1eba12$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $1665b5dabe1eba12$var$_getPrototypeOf(o) {
    $1665b5dabe1eba12$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1665b5dabe1eba12$var$_getPrototypeOf(o);
}
function $1665b5dabe1eba12$var$_toConsumableArray(arr) {
    return $1665b5dabe1eba12$var$_arrayWithoutHoles(arr) || $1665b5dabe1eba12$var$_iterableToArray(arr) || $1665b5dabe1eba12$var$_unsupportedIterableToArray(arr) || $1665b5dabe1eba12$var$_nonIterableSpread();
}
function $1665b5dabe1eba12$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1665b5dabe1eba12$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1665b5dabe1eba12$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1665b5dabe1eba12$var$_arrayLikeToArray(o, minLen);
}
function $1665b5dabe1eba12$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $1665b5dabe1eba12$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1665b5dabe1eba12$var$_arrayLikeToArray(arr);
}
function $1665b5dabe1eba12$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1665b5dabe1eba12$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1665b5dabe1eba12$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $1665b5dabe1eba12$var$ownKeys(Object(source), true).forEach(function(key) {
            $1665b5dabe1eba12$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $1665b5dabe1eba12$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1665b5dabe1eba12$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $1665b5dabe1eba12$var$ORIENT_MAP = {
    xAxis: [
        "bottom",
        "top"
    ],
    yAxis: [
        "left",
        "right"
    ]
};
var $1665b5dabe1eba12$var$originCoordinate = {
    x: 0,
    y: 0
}; // use legacy isFinite only if there is a problem (aka IE)
// eslint-disable-next-line no-restricted-globals
var $1665b5dabe1eba12$var$isFinit = Number.isFinite ? Number.isFinite : isFinite;
var $1665b5dabe1eba12$var$defer = typeof requestAnimationFrame === "function" ? requestAnimationFrame : typeof setImmediate === "function" ? setImmediate : setTimeout;
var $1665b5dabe1eba12$var$deferClear = typeof cancelAnimationFrame === "function" ? cancelAnimationFrame : typeof clearImmediate === "function" ? clearImmediate : clearTimeout;
var $1665b5dabe1eba12$var$calculateTooltipPos = function calculateTooltipPos(rangeObj, layout) {
    if (layout === "horizontal") return rangeObj.x;
    if (layout === "vertical") return rangeObj.y;
    if (layout === "centric") return rangeObj.angle;
    return rangeObj.radius;
};
var $1665b5dabe1eba12$var$getActiveCoordinate = function getActiveCoordinate(layout, tooltipTicks, activeIndex, rangeObj) {
    var entry = tooltipTicks.find(function(tick) {
        return tick && tick.index === activeIndex;
    });
    if (entry) {
        if (layout === "horizontal") return {
            x: entry.coordinate,
            y: rangeObj.y
        };
        if (layout === "vertical") return {
            x: rangeObj.x,
            y: entry.coordinate
        };
        if (layout === "centric") {
            var _angle = entry.coordinate;
            var _radius = rangeObj.radius;
            return $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, rangeObj), (0, $470bf96dd282a944$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
                angle: _angle,
                radius: _radius
            });
        }
        var radius = entry.coordinate;
        var angle = rangeObj.angle;
        return $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, rangeObj), (0, $470bf96dd282a944$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
            angle: angle,
            radius: radius
        });
    }
    return $1665b5dabe1eba12$var$originCoordinate;
};
var $1665b5dabe1eba12$var$getDisplayedData = function getDisplayedData(data, _ref, item) {
    var graphicalItems = _ref.graphicalItems, dataStartIndex = _ref.dataStartIndex, dataEndIndex = _ref.dataEndIndex;
    var itemsData = (graphicalItems || []).reduce(function(result, child) {
        var itemData = child.props.data;
        if (itemData && itemData.length) return [].concat($1665b5dabe1eba12$var$_toConsumableArray(result), $1665b5dabe1eba12$var$_toConsumableArray(itemData));
        return result;
    }, []);
    if (itemsData && itemsData.length > 0) return itemsData;
    if (item && item.props && item.props.data && item.props.data.length > 0) return item.props.data;
    if (data && data.length && (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(dataStartIndex) && (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(dataEndIndex)) return data.slice(dataStartIndex, dataEndIndex + 1);
    return [];
};
/**
 * Get the content to be displayed in the tooltip
 * @param  {Object} state          Current state
 * @param  {Array}  chartData      The data defined in chart
 * @param  {Number} activeIndex    Active index of data
 * @param  {String} activeLabel    Active label of data
 * @return {Array}                 The content of tooltip
 */ var $1665b5dabe1eba12$var$getTooltipContent = function getTooltipContent(state, chartData, activeIndex, activeLabel) {
    var graphicalItems = state.graphicalItems, tooltipAxis = state.tooltipAxis;
    var displayedData = $1665b5dabe1eba12$var$getDisplayedData(chartData, state);
    if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) return null;
     // get data by activeIndex when the axis don't allow duplicated category
    return graphicalItems.reduce(function(result, child) {
        var hide = child.props.hide;
        if (hide) return result;
        var data = child.props.data;
        var payload;
        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
            // graphic child has data props
            var entries = data === undefined ? displayedData : data;
            payload = (0, $804fab7e7cc9eb97$export$66950d3869f5cc67)(entries, tooltipAxis.dataKey, activeLabel);
        } else payload = data && data[activeIndex] || displayedData[activeIndex];
        if (!payload) return result;
        return [].concat($1665b5dabe1eba12$var$_toConsumableArray(result), [
            (0, $c86c74861e78fc13$export$a4ea3faa19bc2d90)(child, payload)
        ]);
    }, []);
};
/**
 * Returns tooltip data based on a mouse position (as a parameter or in state)
 * @param  {Object} state     current state
 * @param  {Array}  chartData the data defined in chart
 * @param  {String} layout     The layout type of chart
 * @param  {Object} rangeObj  { x, y } coordinates
 * @return {Object}           Tooltip data data
 */ var $1665b5dabe1eba12$var$getTooltipData = function getTooltipData(state, chartData, layout, rangeObj) {
    var rangeData = rangeObj || {
        x: state.chartX,
        y: state.chartY
    };
    var pos = $1665b5dabe1eba12$var$calculateTooltipPos(rangeData, layout);
    var ticks = state.orderedTooltipTicks, axis = state.tooltipAxis, tooltipTicks = state.tooltipTicks;
    var activeIndex = (0, $c86c74861e78fc13$export$3071d39cc844078e)(pos, ticks, tooltipTicks, axis);
    if (activeIndex >= 0 && tooltipTicks) {
        var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
        var activePayload = $1665b5dabe1eba12$var$getTooltipContent(state, chartData, activeIndex, activeLabel);
        var activeCoordinate = $1665b5dabe1eba12$var$getActiveCoordinate(layout, ticks, activeIndex, rangeData);
        return {
            activeTooltipIndex: activeIndex,
            activeLabel: activeLabel,
            activePayload: activePayload,
            activeCoordinate: activeCoordinate
        };
    }
    return null;
};
/**
 * Get the configuration of axis by the options of axis instance
 * @param  {Object} props         Latest props
 * @param {Array}  axes           The instance of axes
 * @param  {Array} graphicalItems The instances of item
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}      Configuration
 */ var $1665b5dabe1eba12$var$getAxisMapByAxes = function getAxisMapByAxes(props, _ref2) {
    var axes = _ref2.axes, graphicalItems = _ref2.graphicalItems, axisType = _ref2.axisType, axisIdKey = _ref2.axisIdKey, stackGroups = _ref2.stackGroups, dataStartIndex = _ref2.dataStartIndex, dataEndIndex = _ref2.dataEndIndex;
    var layout = props.layout, children = props.children, stackOffset = props.stackOffset;
    var isCategorical = (0, $c86c74861e78fc13$export$9fc1baaa6c6368b)(layout, axisType); // Eliminate duplicated axes
    var axisMap = axes.reduce(function(result, child) {
        var _child$props = child.props, type = _child$props.type, dataKey = _child$props.dataKey, allowDataOverflow = _child$props.allowDataOverflow, allowDuplicatedCategory = _child$props.allowDuplicatedCategory, scale = _child$props.scale, ticks = _child$props.ticks;
        var axisId = child.props[axisIdKey];
        var displayedData = $1665b5dabe1eba12$var$getDisplayedData(props.data, {
            graphicalItems: graphicalItems.filter(function(item) {
                return item.props[axisIdKey] === axisId;
            }),
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
        });
        var len = displayedData.length;
        if (!result[axisId]) {
            var domain, duplicateDomain, categoricalDomain;
            if (dataKey) {
                // has dataKey in <Axis />
                domain = (0, $c86c74861e78fc13$export$6a1e7873444c95a7)(displayedData, dataKey, type);
                if (type === "category" && isCategorical) {
                    // the field type is category data and this axis is catrgorical axis
                    var duplicate = (0, $804fab7e7cc9eb97$export$732baf6a98f122)(domain);
                    if (allowDuplicatedCategory && duplicate) {
                        duplicateDomain = domain; // When category axis has duplicated text, serial numbers are used to generate scale
                        domain = (0, (/*@__PURE__*/$parcel$interopDefault($0fb3a4a2cd8e8970$exports)))(0, len);
                    } else if (!allowDuplicatedCategory) // remove duplicated category
                    domain = (0, $c86c74861e78fc13$export$c9a5230f0dda41bf)(child.props.domain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat($1665b5dabe1eba12$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                } else if (type === "category") {
                    // the field type is category data and this axis is numerical axis
                    if (!allowDuplicatedCategory) domain = (0, $c86c74861e78fc13$export$c9a5230f0dda41bf)(child.props.domain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 || entry === "" || (0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(entry) ? finalDomain : [].concat($1665b5dabe1eba12$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                    else // eliminate undefined or null or empty string
                    domain = domain.filter(function(entry) {
                        return entry !== "" && !(0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(entry);
                    });
                } else if (type === "number") {
                    // the field type is numerical
                    var errorBarsDomain = (0, $c86c74861e78fc13$export$2266342e22c737e8)(displayedData, graphicalItems.filter(function(item) {
                        return item.props[axisIdKey] === axisId && !item.props.hide;
                    }), dataKey, axisType, layout);
                    if (errorBarsDomain) domain = errorBarsDomain;
                }
                if (isCategorical && (type === "number" || scale !== "auto")) categoricalDomain = (0, $c86c74861e78fc13$export$6a1e7873444c95a7)(displayedData, dataKey, "category");
            } else if (isCategorical) // the axis is a categorical axis
            domain = (0, (/*@__PURE__*/$parcel$interopDefault($0fb3a4a2cd8e8970$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === "number") // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
            domain = stackOffset === "expand" ? [
                0,
                1
            ] : (0, $c86c74861e78fc13$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
            else domain = (0, $c86c74861e78fc13$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                return item.props[axisIdKey] === axisId && !item.props.hide;
            }), type, layout, true);
            if (type === "number") {
                // To detect wether there is any reference lines whose props alwaysShow is true
                domain = (0, $bcb72bd035dfb736$export$62ecf5c04b491381)(children, domain, axisId, axisType, ticks);
                if (child.props.domain) domain = (0, $c86c74861e78fc13$export$a0bc8660980558a0)(child.props.domain, domain, allowDataOverflow);
            } else if (type === "category" && child.props.domain) {
                var axisDomain = child.props.domain;
                var isDomainValidate = domain.every(function(entry) {
                    return axisDomain.indexOf(entry) >= 0;
                });
                if (isDomainValidate) domain = axisDomain;
            }
            return $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, result), {}, $1665b5dabe1eba12$var$_defineProperty({}, axisId, $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, child.props), {}, {
                axisType: axisType,
                domain: domain,
                categoricalDomain: categoricalDomain,
                duplicateDomain: duplicateDomain,
                originalDomain: child.props.domain,
                isCategorical: isCategorical,
                layout: layout
            })));
        }
        return result;
    }, {});
    return axisMap;
};
/**
 * Get the configuration of axis by the options of item,
 * this kind of axis does not display in chart
 * @param  {Object} props         Latest props
 * @param  {Array} graphicalItems The instances of item
 * @param  {ReactElement} Axis    Axis Component
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}               Configuration
 */ var $1665b5dabe1eba12$var$getAxisMapByItems = function getAxisMapByItems(props, _ref3) {
    var graphicalItems = _ref3.graphicalItems, Axis = _ref3.Axis, axisType = _ref3.axisType, axisIdKey = _ref3.axisIdKey, stackGroups = _ref3.stackGroups, dataStartIndex = _ref3.dataStartIndex, dataEndIndex = _ref3.dataEndIndex;
    var layout = props.layout, children = props.children;
    var displayedData = $1665b5dabe1eba12$var$getDisplayedData(props.data, {
        graphicalItems: graphicalItems,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    var len = displayedData.length;
    var isCategorical = (0, $c86c74861e78fc13$export$9fc1baaa6c6368b)(layout, axisType);
    var index = -1; // The default type of x-axis is category axis,
    // The default contents of x-axis is the serial numbers of data
    // The default type of y-axis is number axis
    // The default contents of y-axis is the domain of data
    var axisMap = graphicalItems.reduce(function(result, child) {
        var axisId = child.props[axisIdKey];
        if (!result[axisId]) {
            index++;
            var domain;
            if (isCategorical) domain = (0, (/*@__PURE__*/$parcel$interopDefault($0fb3a4a2cd8e8970$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
                domain = (0, $c86c74861e78fc13$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
                domain = (0, $bcb72bd035dfb736$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            } else {
                domain = (0, $c86c74861e78fc13$export$a0bc8660980558a0)(Axis.defaultProps.domain, (0, $c86c74861e78fc13$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                    return item.props[axisIdKey] === axisId && !item.props.hide;
                }), "number", layout), Axis.defaultProps.allowDataOverflow);
                domain = (0, $bcb72bd035dfb736$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            }
            return $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, result), {}, $1665b5dabe1eba12$var$_defineProperty({}, axisId, $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({
                axisType: axisType
            }, Axis.defaultProps), {}, {
                hide: true,
                orientation: (0, (/*@__PURE__*/$parcel$interopDefault($2cd7f9f9c3b27772$exports)))($1665b5dabe1eba12$var$ORIENT_MAP, "".concat(axisType, ".").concat(index % 2), null),
                domain: domain,
                originalDomain: Axis.defaultProps.domain,
                isCategorical: isCategorical,
                layout: layout // specify scale when no Axis
            })));
        }
        return result;
    }, {});
    return axisMap;
};
/**
 * Get the configuration of all x-axis or y-axis
 * @param  {Object} props          Latest props
 * @param  {String} axisType       The type of axis
 * @param  {Array}  graphicalItems The instances of item
 * @param  {Object} stackGroups    The items grouped by axisId and stackId
 * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
 * @return {Object}          Configuration
 */ var $1665b5dabe1eba12$var$getAxisMap = function getAxisMap(props, _ref4) {
    var _ref4$axisType = _ref4.axisType, axisType = _ref4$axisType === void 0 ? "xAxis" : _ref4$axisType, AxisComp = _ref4.AxisComp, graphicalItems = _ref4.graphicalItems, stackGroups = _ref4.stackGroups, dataStartIndex = _ref4.dataStartIndex, dataEndIndex = _ref4.dataEndIndex;
    var children = props.children;
    var axisIdKey = "".concat(axisType, "Id"); // Get all the instance of Axis
    var axes = (0, $217577d291f12aa3$export$fdd5e64c0e8495bb)(children, AxisComp);
    var axisMap = {};
    if (axes && axes.length) axisMap = $1665b5dabe1eba12$var$getAxisMapByAxes(props, {
        axes: axes,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    else if (graphicalItems && graphicalItems.length) axisMap = $1665b5dabe1eba12$var$getAxisMapByItems(props, {
        Axis: AxisComp,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    return axisMap;
};
var $1665b5dabe1eba12$var$tooltipTicksGenerator = function tooltipTicksGenerator(axisMap) {
    var axis = (0, $804fab7e7cc9eb97$export$b88993f0aa0bf776)(axisMap);
    var tooltipTicks = (0, $c86c74861e78fc13$export$c829ee42daf7f66d)(axis, false, true);
    return {
        tooltipTicks: tooltipTicks,
        orderedTooltipTicks: (0, (/*@__PURE__*/$parcel$interopDefault($76273bef9289b8fd$exports)))(tooltipTicks, function(o) {
            return o.coordinate;
        }),
        tooltipAxis: axis,
        tooltipAxisBandSize: (0, $c86c74861e78fc13$export$212ec45c42fe68a7)(axis, tooltipTicks)
    };
};
/**
 * Returns default, reset state for the categorical chart.
 * @param {Object} props Props object to use when creating the default state
 * @return {Object} Whole new state
 */ var $1665b5dabe1eba12$var$createDefaultState = function createDefaultState(props) {
    var children = props.children, defaultShowTooltip = props.defaultShowTooltip;
    var brushItem = (0, $217577d291f12aa3$export$64c61536a2b72e0f)(children, (0, $2ea4d1ce26668dc0$export$59bc2e3533b384a0).displayName);
    var startIndex = brushItem && brushItem.props && brushItem.props.startIndex || 0;
    var endIndex = brushItem && brushItem.props && brushItem.props.endIndex || props.data && props.data.length - 1 || 0;
    return {
        chartX: 0,
        chartY: 0,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex,
        activeTooltipIndex: -1,
        isTooltipActive: !(0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(defaultShowTooltip) ? defaultShowTooltip : false
    };
};
var $1665b5dabe1eba12$var$hasGraphicalBarItem = function hasGraphicalBarItem(graphicalItems) {
    if (!graphicalItems || !graphicalItems.length) return false;
    return graphicalItems.some(function(item) {
        var name = (0, $217577d291f12aa3$export$be63e0664592e141)(item && item.type);
        return name && name.indexOf("Bar") >= 0;
    });
};
var $1665b5dabe1eba12$var$getAxisNameByLayout = function getAxisNameByLayout(layout) {
    if (layout === "horizontal") return {
        numericAxisName: "yAxis",
        cateAxisName: "xAxis"
    };
    if (layout === "vertical") return {
        numericAxisName: "xAxis",
        cateAxisName: "yAxis"
    };
    if (layout === "centric") return {
        numericAxisName: "radiusAxis",
        cateAxisName: "angleAxis"
    };
    return {
        numericAxisName: "angleAxis",
        cateAxisName: "radiusAxis"
    };
};
/**
 * Calculate the offset of main part in the svg element
 * @param  {Object} props          Latest props
 * graphicalItems The instances of item
 * xAxisMap       The configuration of x-axis
 * yAxisMap       The configuration of y-axis
 * @param  {Object} prevLegendBBox          the boundary box of legend
 * @return {Object} The offset of main part in the svg element
 */ var $1665b5dabe1eba12$var$calculateOffset = function calculateOffset(_ref5, prevLegendBBox) {
    var props = _ref5.props, graphicalItems = _ref5.graphicalItems, _ref5$xAxisMap = _ref5.xAxisMap, xAxisMap = _ref5$xAxisMap === void 0 ? {} : _ref5$xAxisMap, _ref5$yAxisMap = _ref5.yAxisMap, yAxisMap = _ref5$yAxisMap === void 0 ? {} : _ref5$yAxisMap;
    var width = props.width, height = props.height, children = props.children;
    var margin = props.margin || {};
    var brushItem = (0, $217577d291f12aa3$export$64c61536a2b72e0f)(children, (0, $2ea4d1ce26668dc0$export$59bc2e3533b384a0).displayName);
    var legendItem = (0, $217577d291f12aa3$export$64c61536a2b72e0f)(children, (0, $6800f4603cf54f57$export$ed247974535929c7).displayName);
    var offsetH = Object.keys(yAxisMap).reduce(function(result, id) {
        var entry = yAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, result), {}, $1665b5dabe1eba12$var$_defineProperty({}, orientation, result[orientation] + entry.width));
        return result;
    }, {
        left: margin.left || 0,
        right: margin.right || 0
    });
    var offsetV = Object.keys(xAxisMap).reduce(function(result, id) {
        var entry = xAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, result), {}, $1665b5dabe1eba12$var$_defineProperty({}, orientation, (0, (/*@__PURE__*/$parcel$interopDefault($2cd7f9f9c3b27772$exports)))(result, "".concat(orientation)) + entry.height));
        return result;
    }, {
        top: margin.top || 0,
        bottom: margin.bottom || 0
    });
    var offset = $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, offsetV), offsetH);
    var brushBottom = offset.bottom;
    if (brushItem) offset.bottom += brushItem.props.height || (0, $2ea4d1ce26668dc0$export$59bc2e3533b384a0).defaultProps.height;
    if (legendItem && prevLegendBBox) offset = (0, $c86c74861e78fc13$export$3a657a8c9f789617)(offset, graphicalItems, props, prevLegendBBox);
    return $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({
        brushBottom: brushBottom
    }, offset), {}, {
        width: width - offset.left - offset.right,
        height: height - offset.top - offset.bottom
    });
};
var $1665b5dabe1eba12$export$77871aede60e6838 = function generateCategoricalChart(_ref6) {
    var _class, _temp;
    var chartName = _ref6.chartName, GraphicalChild = _ref6.GraphicalChild, _ref6$defaultTooltipE = _ref6.defaultTooltipEventType, defaultTooltipEventType = _ref6$defaultTooltipE === void 0 ? "axis" : _ref6$defaultTooltipE, _ref6$validateTooltip = _ref6.validateTooltipEventTypes, validateTooltipEventTypes = _ref6$validateTooltip === void 0 ? [
        "axis"
    ] : _ref6$validateTooltip, axisComponents = _ref6.axisComponents, legendContent = _ref6.legendContent, formatAxisMap = _ref6.formatAxisMap, defaultProps = _ref6.defaultProps;
    var getFormatItems = function getFormatItems(props, currentState) {
        var graphicalItems = currentState.graphicalItems, stackGroups = currentState.stackGroups, offset = currentState.offset, updateId = currentState.updateId, dataStartIndex = currentState.dataStartIndex, dataEndIndex = currentState.dataEndIndex;
        var barSize = props.barSize, layout = props.layout, barGap = props.barGap, barCategoryGap = props.barCategoryGap, globalMaxBarSize = props.maxBarSize;
        var _getAxisNameByLayout = $1665b5dabe1eba12$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout.numericAxisName, cateAxisName = _getAxisNameByLayout.cateAxisName;
        var hasBar = $1665b5dabe1eba12$var$hasGraphicalBarItem(graphicalItems);
        var sizeList = hasBar && (0, $c86c74861e78fc13$export$570d306bee26c748)({
            barSize: barSize,
            stackGroups: stackGroups
        });
        var formattedItems = [];
        graphicalItems.forEach(function(item, index) {
            var displayedData = $1665b5dabe1eba12$var$getDisplayedData(props.data, {
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            }, item);
            var _item$props = item.props, dataKey = _item$props.dataKey, childMaxBarSize = _item$props.maxBarSize;
            var numericAxisId = item.props["".concat(numericAxisName, "Id")];
            var cateAxisId = item.props["".concat(cateAxisName, "Id")];
            var axisObj = axisComponents.reduce(function(result, entry) {
                var _objectSpread6;
                var axisMap = currentState["".concat(entry.axisType, "Map")];
                var id = item.props["".concat(entry.axisType, "Id")];
                var axis = axisMap && axisMap[id];
                return $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, result), {}, (_objectSpread6 = {}, $1665b5dabe1eba12$var$_defineProperty(_objectSpread6, entry.axisType, axis), $1665b5dabe1eba12$var$_defineProperty(_objectSpread6, "".concat(entry.axisType, "Ticks"), (0, $c86c74861e78fc13$export$c829ee42daf7f66d)(axis)), _objectSpread6));
            }, {});
            var cateAxis = axisObj[cateAxisName];
            var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
            var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, $c86c74861e78fc13$export$a17bf3d98457878c)(item, stackGroups[numericAxisId].stackGroups);
            var itemIsBar = (0, $217577d291f12aa3$export$be63e0664592e141)(item.type).indexOf("Bar") >= 0;
            var bandSize = (0, $c86c74861e78fc13$export$212ec45c42fe68a7)(cateAxis, cateTicks);
            var barPosition = [];
            if (itemIsBar) {
                var _ref7, _getBandSizeOfAxis;
                // 如果是bar，计算bar的位置
                var maxBarSize = (0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
                var barBandSize = (_ref7 = (_getBandSizeOfAxis = (0, $c86c74861e78fc13$export$212ec45c42fe68a7)(cateAxis, cateTicks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref7 !== void 0 ? _ref7 : 0;
                barPosition = (0, $c86c74861e78fc13$export$d36834ecd87f906b)({
                    barGap: barGap,
                    barCategoryGap: barCategoryGap,
                    bandSize: barBandSize !== bandSize ? barBandSize : bandSize,
                    sizeList: sizeList[cateAxisId],
                    maxBarSize: maxBarSize
                });
                if (barBandSize !== bandSize) barPosition = barPosition.map(function(pos) {
                    return $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, pos), {}, {
                        position: $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, pos.position), {}, {
                            offset: pos.position.offset - barBandSize / 2
                        })
                    });
                });
            }
            var composedFn = item && item.type && item.type.getComposedData;
            if (composedFn) {
                var _objectSpread7;
                formattedItems.push({
                    props: $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, composedFn($1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, axisObj), {}, {
                        displayedData: displayedData,
                        props: props,
                        dataKey: dataKey,
                        item: item,
                        bandSize: bandSize,
                        barPosition: barPosition,
                        offset: offset,
                        stackedData: stackedData,
                        layout: layout,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex
                    }))), {}, (_objectSpread7 = {
                        key: item.key || "item-".concat(index)
                    }, $1665b5dabe1eba12$var$_defineProperty(_objectSpread7, numericAxisName, axisObj[numericAxisName]), $1665b5dabe1eba12$var$_defineProperty(_objectSpread7, cateAxisName, axisObj[cateAxisName]), $1665b5dabe1eba12$var$_defineProperty(_objectSpread7, "animationId", updateId), _objectSpread7)),
                    childIndex: (0, $217577d291f12aa3$export$857ca101f741953)(item, props.children),
                    item: item
                });
            }
        });
        return formattedItems;
    };
    /**
   * The AxisMaps are expensive to render on large data sets
   * so provide the ability to store them in state and only update them when necessary
   * they are dependent upon the start and end index of
   * the brush so it's important that this method is called _after_
   * the state is updated with any new start/end indices
   *
   * @param {Object} props          The props object to be used for updating the axismaps
   * dataStartIndex: The start index of the data series when a brush is applied
   * dataEndIndex: The end index of the data series when a brush is applied
   * updateId: The update id
   * @param {Object} prevState      Prev state
   * @return {Object} state New state to set
   */ var updateStateOfAxisMapsOffsetAndStackGroups = function updateStateOfAxisMapsOffsetAndStackGroups(_ref8, prevState) {
        var props = _ref8.props, dataStartIndex = _ref8.dataStartIndex, dataEndIndex = _ref8.dataEndIndex, updateId = _ref8.updateId;
        if (!(0, $217577d291f12aa3$export$5301de6bfd3cfa2a)({
            props: props
        })) return null;
        var children = props.children, layout = props.layout, stackOffset = props.stackOffset, data = props.data, reverseStackOrder = props.reverseStackOrder;
        var _getAxisNameByLayout2 = $1665b5dabe1eba12$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout2.numericAxisName, cateAxisName = _getAxisNameByLayout2.cateAxisName;
        var graphicalItems = (0, $217577d291f12aa3$export$fdd5e64c0e8495bb)(children, GraphicalChild);
        var stackGroups = (0, $c86c74861e78fc13$export$9af3ba56474b9601)(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
        var axisObj = axisComponents.reduce(function(result, entry) {
            var name = "".concat(entry.axisType, "Map");
            return $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, result), {}, $1665b5dabe1eba12$var$_defineProperty({}, name, $1665b5dabe1eba12$var$getAxisMap(props, $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, entry), {}, {
                graphicalItems: graphicalItems,
                stackGroups: entry.axisType === numericAxisName && stackGroups,
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            }))));
        }, {});
        var offset = $1665b5dabe1eba12$var$calculateOffset($1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, axisObj), {}, {
            props: props,
            graphicalItems: graphicalItems
        }), prevState === null || prevState === void 0 ? void 0 : prevState.legendBBox);
        Object.keys(axisObj).forEach(function(key) {
            axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace("Map", ""), chartName);
        });
        var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
        var ticksObj = $1665b5dabe1eba12$var$tooltipTicksGenerator(cateAxisMap);
        var formattedGraphicalItems = getFormatItems(props, $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, axisObj), {}, {
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex,
            updateId: updateId,
            graphicalItems: graphicalItems,
            stackGroups: stackGroups,
            offset: offset
        }));
        return $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({
            formattedGraphicalItems: formattedGraphicalItems,
            graphicalItems: graphicalItems,
            offset: offset,
            stackGroups: stackGroups
        }, ticksObj), axisObj);
    };
    return _temp = _class = /*#__PURE__*/ function(_Component) {
        $1665b5dabe1eba12$var$_inherits(CategoricalChartWrapper, _Component);
        var _super = $1665b5dabe1eba12$var$_createSuper(CategoricalChartWrapper);
        // todo join specific chart propTypes
        function CategoricalChartWrapper(_props) {
            var _this;
            $1665b5dabe1eba12$var$_classCallCheck(this, CategoricalChartWrapper);
            _this = _super.call(this, _props);
            _this.uniqueChartId = void 0;
            _this.clipPathId = void 0;
            _this.legendInstance = void 0;
            _this.deferId = void 0;
            _this.container = void 0;
            _this.clearDeferId = function() {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(_this.deferId) && $1665b5dabe1eba12$var$deferClear) $1665b5dabe1eba12$var$deferClear(_this.deferId);
                _this.deferId = null;
            };
            _this.handleLegendBBoxUpdate = function(box) {
                if (box) {
                    var _this$state = _this.state, dataStartIndex = _this$state.dataStartIndex, dataEndIndex = _this$state.dataEndIndex, updateId = _this$state.updateId;
                    _this.setState($1665b5dabe1eba12$var$_objectSpread({
                        legendBBox: box
                    }, updateStateOfAxisMapsOffsetAndStackGroups({
                        props: _this.props,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex,
                        updateId: updateId
                    }, $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, _this.state), {}, {
                        legendBBox: box
                    }))));
                }
            };
            _this.handleReceiveSyncEvent = function(cId, chartId, data) {
                var syncId = _this.props.syncId;
                if (syncId === cId && chartId !== _this.uniqueChartId) {
                    _this.clearDeferId();
                    _this.deferId = $1665b5dabe1eba12$var$defer && $1665b5dabe1eba12$var$defer(_this.applySyncEvent.bind($1665b5dabe1eba12$var$_assertThisInitialized(_this), data));
                }
            };
            _this.handleBrushChange = function(_ref9) {
                var startIndex = _ref9.startIndex, endIndex = _ref9.endIndex;
                // Only trigger changes if the extents of the brush have actually changed
                if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
                    var updateId = _this.state.updateId;
                    _this.setState(function() {
                        return $1665b5dabe1eba12$var$_objectSpread({
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex
                        }, updateStateOfAxisMapsOffsetAndStackGroups({
                            props: _this.props,
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex,
                            updateId: updateId
                        }, _this.state));
                    });
                    _this.triggerSyncEvent({
                        dataStartIndex: startIndex,
                        dataEndIndex: endIndex
                    });
                }
            };
            _this.handleMouseEnter = function(e) {
                var onMouseEnter = _this.props.onMouseEnter;
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState = $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState);
                    _this.triggerSyncEvent(_nextState);
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(onMouseEnter)) onMouseEnter(_nextState, e);
                }
            };
            _this.triggeredAfterMouseMove = function(e) {
                var onMouseMove = _this.props.onMouseMove;
                var mouse = _this.getMouseInfo(e);
                var nextState = mouse ? $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, mouse), {}, {
                    isTooltipActive: true
                }) : {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(onMouseMove)) onMouseMove(nextState, e);
            };
            _this.handleItemMouseEnter = function(el) {
                _this.setState(function() {
                    return {
                        isTooltipActive: true,
                        activeItem: el,
                        activePayload: el.tooltipPayload,
                        activeCoordinate: el.tooltipPosition || {
                            x: el.cx,
                            y: el.cy
                        }
                    };
                });
            };
            _this.handleItemMouseLeave = function() {
                _this.setState(function() {
                    return {
                        isTooltipActive: false
                    };
                });
            };
            _this.handleMouseMove = function(e) {
                if (e && (0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(e.persist)) e.persist();
                _this.triggeredAfterMouseMove(e);
            };
            _this.handleMouseLeave = function(e) {
                var onMouseLeave = _this.props.onMouseLeave;
                var nextState = {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(onMouseLeave)) onMouseLeave(nextState, e);
                _this.cancelThrottledTriggerAfterMouseMove();
            };
            _this.handleOuterEvent = function(e) {
                var eventName = (0, $217577d291f12aa3$export$afb3591bc51a0b70)(e);
                var event = (0, (/*@__PURE__*/$parcel$interopDefault($2cd7f9f9c3b27772$exports)))(_this.props, "".concat(eventName));
                if (eventName && (0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(event)) {
                    var mouse;
                    if (/.*touch.*/i.test(eventName)) mouse = _this.getMouseInfo(e.changedTouches[0]);
                    else mouse = _this.getMouseInfo(e);
                    var handler = event;
                    handler(mouse, e);
                }
            };
            _this.handleClick = function(e) {
                var onClick = _this.props.onClick;
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState2 = $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState2);
                    _this.triggerSyncEvent(_nextState2);
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(onClick)) onClick(_nextState2, e);
                }
            };
            _this.handleMouseDown = function(e) {
                var onMouseDown = _this.props.onMouseDown;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(onMouseDown)) {
                    var _nextState3 = _this.getMouseInfo(e);
                    onMouseDown(_nextState3, e);
                }
            };
            _this.handleMouseUp = function(e) {
                var onMouseUp = _this.props.onMouseUp;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(onMouseUp)) {
                    var _nextState4 = _this.getMouseInfo(e);
                    onMouseUp(_nextState4, e);
                }
            };
            _this.handleTouchMove = function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseMove(e.changedTouches[0]);
            };
            _this.handleTouchStart = function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseDown(e.changedTouches[0]);
            };
            _this.handleTouchEnd = function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseUp(e.changedTouches[0]);
            };
            _this.verticalCoordinatesGenerator = function(_ref10) {
                var xAxis = _ref10.xAxis, width = _ref10.width, height = _ref10.height, offset = _ref10.offset;
                return (0, $c86c74861e78fc13$export$846dc5ac5fecff74)((0, $ce731c8553b71ef9$export$bdd99f2cdf352bae).getTicks($1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, (0, $ce731c8553b71ef9$export$bdd99f2cdf352bae).defaultProps), xAxis), {}, {
                    ticks: (0, $c86c74861e78fc13$export$c829ee42daf7f66d)(xAxis, true),
                    viewBox: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    }
                })), offset.left, offset.left + offset.width);
            };
            _this.horizontalCoordinatesGenerator = function(_ref11) {
                var yAxis = _ref11.yAxis, width = _ref11.width, height = _ref11.height, offset = _ref11.offset;
                return (0, $c86c74861e78fc13$export$846dc5ac5fecff74)((0, $ce731c8553b71ef9$export$bdd99f2cdf352bae).getTicks($1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, (0, $ce731c8553b71ef9$export$bdd99f2cdf352bae).defaultProps), yAxis), {}, {
                    ticks: (0, $c86c74861e78fc13$export$c829ee42daf7f66d)(yAxis, true),
                    viewBox: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    }
                })), offset.top, offset.top + offset.height);
            };
            _this.axesTicksGenerator = function(axis) {
                return (0, $c86c74861e78fc13$export$c829ee42daf7f66d)(axis, true);
            };
            _this.renderCursor = function(element) {
                var _this$state2 = _this.state, isTooltipActive = _this$state2.isTooltipActive, activeCoordinate = _this$state2.activeCoordinate, activePayload = _this$state2.activePayload, offset = _this$state2.offset, activeTooltipIndex = _this$state2.activeTooltipIndex;
                var tooltipEventType = _this.getTooltipEventType();
                if (!element || !element.props.cursor || !isTooltipActive || !activeCoordinate || chartName !== "ScatterChart" && tooltipEventType !== "axis") return null;
                var layout = _this.props.layout;
                var restProps;
                var cursorComp = (0, $aaa3487fdd76f634$export$b0e83c3ef8d2db1);
                if (chartName === "ScatterChart") {
                    restProps = activeCoordinate;
                    cursorComp = (0, $3c938baec9baedc5$export$3c877bb842c36952);
                } else if (chartName === "BarChart") {
                    restProps = _this.getCursorRectangle();
                    cursorComp = (0, $8ac86f32b9b56c8b$export$4617fb02663045ef);
                } else if (layout === "radial") {
                    var _this$getCursorPoints = _this.getCursorPoints(), cx = _this$getCursorPoints.cx, cy = _this$getCursorPoints.cy, radius = _this$getCursorPoints.radius, startAngle = _this$getCursorPoints.startAngle, endAngle = _this$getCursorPoints.endAngle;
                    restProps = {
                        cx: cx,
                        cy: cy,
                        startAngle: startAngle,
                        endAngle: endAngle,
                        innerRadius: radius,
                        outerRadius: radius
                    };
                    cursorComp = (0, $e529a7b3c4259fe3$export$e98c2c7eb2b14f45);
                } else {
                    restProps = {
                        points: _this.getCursorPoints()
                    };
                    cursorComp = (0, $aaa3487fdd76f634$export$b0e83c3ef8d2db1);
                }
                var key = element.key || "_recharts-cursor";
                var cursorProps = $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({
                    stroke: "#ccc",
                    pointerEvents: "none"
                }, offset), restProps), (0, $05a192303b32ed93$export$d697c39a2985a4c)(element.props.cursor)), {}, {
                    payload: activePayload,
                    payloadIndex: activeTooltipIndex,
                    key: key,
                    className: "recharts-tooltip-cursor"
                });
                return /*#__PURE__*/ (0, $jC8Vy.isValidElement)(element.props.cursor) ? /*#__PURE__*/ (0, $jC8Vy.cloneElement)(element.props.cursor, cursorProps) : /*#__PURE__*/ (0, $jC8Vy.createElement)(cursorComp, cursorProps);
            };
            _this.renderPolarAxis = function(element, displayName, index) {
                var axisType = (0, (/*@__PURE__*/$parcel$interopDefault($2cd7f9f9c3b27772$exports)))(element, "type.axisType");
                var axisMap = (0, (/*@__PURE__*/$parcel$interopDefault($2cd7f9f9c3b27772$exports)))(_this.state, "".concat(axisType, "Map"));
                var axisOption = axisMap[element.props["".concat(axisType, "Id")]];
                return /*#__PURE__*/ (0, $jC8Vy.cloneElement)(element, $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, axisOption), {}, {
                    className: axisType,
                    key: element.key || "".concat(displayName, "-").concat(index),
                    ticks: (0, $c86c74861e78fc13$export$c829ee42daf7f66d)(axisOption, true)
                }));
            };
            _this.renderXAxis = function(element, displayName, index) {
                var xAxisMap = _this.state.xAxisMap;
                var axisObj = xAxisMap[element.props.xAxisId];
                return _this.renderAxis(axisObj, element, displayName, index);
            };
            _this.renderYAxis = function(element, displayName, index) {
                var yAxisMap = _this.state.yAxisMap;
                var axisObj = yAxisMap[element.props.yAxisId];
                return _this.renderAxis(axisObj, element, displayName, index);
            };
            _this.renderGrid = function(element) {
                var _this$state3 = _this.state, xAxisMap = _this$state3.xAxisMap, yAxisMap = _this$state3.yAxisMap, offset = _this$state3.offset;
                var _this$props = _this.props, width = _this$props.width, height = _this$props.height;
                var xAxis = (0, $804fab7e7cc9eb97$export$b88993f0aa0bf776)(xAxisMap);
                var yAxisWithFiniteDomain = (0, (/*@__PURE__*/$parcel$interopDefault($cae0b8e98226d6ae$exports)))(yAxisMap, function(axis) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($1867c288c9a52a34$exports)))(axis.domain, $1665b5dabe1eba12$var$isFinit);
                });
                var yAxis = yAxisWithFiniteDomain || (0, $804fab7e7cc9eb97$export$b88993f0aa0bf776)(yAxisMap);
                var props = element.props || {};
                return /*#__PURE__*/ (0, $jC8Vy.cloneElement)(element, {
                    key: element.key || "grid",
                    x: (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(props.x) ? props.x : offset.left,
                    y: (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(props.y) ? props.y : offset.top,
                    width: (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(props.width) ? props.width : offset.width,
                    height: (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(props.height) ? props.height : offset.height,
                    xAxis: xAxis,
                    yAxis: yAxis,
                    offset: offset,
                    chartWidth: width,
                    chartHeight: height,
                    verticalCoordinatesGenerator: props.verticalCoordinatesGenerator || _this.verticalCoordinatesGenerator,
                    horizontalCoordinatesGenerator: props.horizontalCoordinatesGenerator || _this.horizontalCoordinatesGenerator
                });
            };
            _this.renderPolarGrid = function(element) {
                var _element$props = element.props, radialLines = _element$props.radialLines, polarAngles = _element$props.polarAngles, polarRadius = _element$props.polarRadius;
                var _this$state4 = _this.state, radiusAxisMap = _this$state4.radiusAxisMap, angleAxisMap = _this$state4.angleAxisMap;
                var radiusAxis = (0, $804fab7e7cc9eb97$export$b88993f0aa0bf776)(radiusAxisMap);
                var angleAxis = (0, $804fab7e7cc9eb97$export$b88993f0aa0bf776)(angleAxisMap);
                var cx = angleAxis.cx, cy = angleAxis.cy, innerRadius = angleAxis.innerRadius, outerRadius = angleAxis.outerRadius;
                return /*#__PURE__*/ (0, $jC8Vy.cloneElement)(element, {
                    polarAngles: (0, (/*@__PURE__*/$parcel$interopDefault($0fe4a5546443a34c$exports)))(polarAngles) ? polarAngles : (0, $c86c74861e78fc13$export$c829ee42daf7f66d)(angleAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    polarRadius: (0, (/*@__PURE__*/$parcel$interopDefault($0fe4a5546443a34c$exports)))(polarRadius) ? polarRadius : (0, $c86c74861e78fc13$export$c829ee42daf7f66d)(radiusAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    cx: cx,
                    cy: cy,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius,
                    key: element.key || "polar-grid",
                    radialLines: radialLines
                });
            };
            _this.renderLegend = function() {
                var formattedGraphicalItems = _this.state.formattedGraphicalItems;
                var _this$props2 = _this.props, children = _this$props2.children, width = _this$props2.width, height = _this$props2.height;
                var margin = _this.props.margin || {};
                var legendWidth = width - (margin.left || 0) - (margin.right || 0);
                var props = (0, $c86c74861e78fc13$export$8f9424d123c36aa)({
                    children: children,
                    formattedGraphicalItems: formattedGraphicalItems,
                    legendWidth: legendWidth,
                    legendContent: legendContent
                });
                if (!props) return null;
                var item = props.item, otherProps = $1665b5dabe1eba12$var$_objectWithoutProperties(props, [
                    "item"
                ]);
                return /*#__PURE__*/ (0, $jC8Vy.cloneElement)(item, $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, otherProps), {}, {
                    chartWidth: width,
                    chartHeight: height,
                    margin: margin,
                    ref: function ref(legend) {
                        _this.legendInstance = legend;
                    },
                    onBBoxUpdate: _this.handleLegendBBoxUpdate
                }));
            };
            _this.renderTooltip = function() {
                var children = _this.props.children;
                var tooltipItem = (0, $217577d291f12aa3$export$64c61536a2b72e0f)(children, (0, $def5cb6e7a67bb87$export$28c660c63b792dea).displayName);
                if (!tooltipItem) return null;
                var _this$state5 = _this.state, isTooltipActive = _this$state5.isTooltipActive, activeCoordinate = _this$state5.activeCoordinate, activePayload = _this$state5.activePayload, activeLabel = _this$state5.activeLabel, offset = _this$state5.offset;
                return /*#__PURE__*/ (0, $jC8Vy.cloneElement)(tooltipItem, {
                    viewBox: $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    }),
                    active: isTooltipActive,
                    label: activeLabel,
                    payload: isTooltipActive ? activePayload : [],
                    coordinate: activeCoordinate
                });
            };
            _this.renderBrush = function(element) {
                var _this$props3 = _this.props, margin = _this$props3.margin, data = _this$props3.data;
                var _this$state6 = _this.state, offset = _this$state6.offset, dataStartIndex = _this$state6.dataStartIndex, dataEndIndex = _this$state6.dataEndIndex, updateId = _this$state6.updateId; // TODO: update brush when children update
                return /*#__PURE__*/ (0, $jC8Vy.cloneElement)(element, {
                    key: element.key || "_recharts-brush",
                    onChange: (0, $c86c74861e78fc13$export$760ec406ba47bace)(_this.handleBrushChange, null, element.props.onChange),
                    data: data,
                    x: (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(element.props.x) ? element.props.x : offset.left,
                    y: (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
                    width: (0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(element.props.width) ? element.props.width : offset.width,
                    startIndex: dataStartIndex,
                    endIndex: dataEndIndex,
                    updateId: "brush-".concat(updateId)
                });
            };
            _this.renderReferenceElement = function(element, displayName, index) {
                if (!element) return null;
                var _assertThisInitialize = $1665b5dabe1eba12$var$_assertThisInitialized(_this), clipPathId = _assertThisInitialize.clipPathId;
                var _this$state7 = _this.state, xAxisMap = _this$state7.xAxisMap, yAxisMap = _this$state7.yAxisMap, offset = _this$state7.offset;
                var _element$props2 = element.props, xAxisId = _element$props2.xAxisId, yAxisId = _element$props2.yAxisId;
                return /*#__PURE__*/ (0, $jC8Vy.cloneElement)(element, {
                    key: element.key || "".concat(displayName, "-").concat(index),
                    xAxis: xAxisMap[xAxisId],
                    yAxis: yAxisMap[yAxisId],
                    viewBox: {
                        x: offset.left,
                        y: offset.top,
                        width: offset.width,
                        height: offset.height
                    },
                    clipPathId: clipPathId
                });
            };
            _this.renderActivePoints = function(_ref12) {
                var item = _ref12.item, activePoint = _ref12.activePoint, basePoint = _ref12.basePoint, childIndex = _ref12.childIndex, isRange = _ref12.isRange;
                var result = [];
                var key = item.props.key;
                var _item$item$props = item.item.props, activeDot = _item$item$props.activeDot, dataKey = _item$item$props.dataKey;
                var dotProps = $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({
                    index: childIndex,
                    dataKey: dataKey,
                    cx: activePoint.x,
                    cy: activePoint.y,
                    r: 4,
                    fill: (0, $c86c74861e78fc13$export$ec6cab5a7a3b93bf)(item.item),
                    strokeWidth: 2,
                    stroke: "#fff",
                    payload: activePoint.payload,
                    value: activePoint.value,
                    key: "".concat(key, "-activePoint-").concat(childIndex)
                }, (0, $05a192303b32ed93$export$d697c39a2985a4c)(activeDot)), (0, $05a192303b32ed93$export$7c4c290a4a9c1b1e)(activeDot));
                result.push(CategoricalChartWrapper.renderActiveDot(activeDot, dotProps));
                if (basePoint) result.push(CategoricalChartWrapper.renderActiveDot(activeDot, $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, dotProps), {}, {
                    cx: basePoint.x,
                    cy: basePoint.y,
                    key: "".concat(key, "-basePoint-").concat(childIndex)
                })));
                else if (isRange) result.push(null);
                return result;
            };
            _this.renderGraphicChild = function(element, displayName, index) {
                var item = _this.filterFormatItem(element, displayName, index);
                if (!item) return null;
                var tooltipEventType = _this.getTooltipEventType();
                var _this$state8 = _this.state, isTooltipActive = _this$state8.isTooltipActive, tooltipAxis = _this$state8.tooltipAxis, activeTooltipIndex = _this$state8.activeTooltipIndex, activeLabel = _this$state8.activeLabel;
                var children = _this.props.children;
                var tooltipItem = (0, $217577d291f12aa3$export$64c61536a2b72e0f)(children, (0, $def5cb6e7a67bb87$export$28c660c63b792dea).displayName);
                var _item$props2 = item.props, points = _item$props2.points, isRange = _item$props2.isRange, baseLine = _item$props2.baseLine;
                var _item$item$props2 = item.item.props, activeDot = _item$item$props2.activeDot, hide = _item$item$props2.hide;
                var hasActive = !hide && isTooltipActive && tooltipItem && activeDot && activeTooltipIndex >= 0;
                var itemEvents = {};
                if (tooltipEventType !== "axis" && tooltipItem && tooltipItem.props.trigger === "click") itemEvents = {
                    onClick: (0, $c86c74861e78fc13$export$760ec406ba47bace)(_this.handleItemMouseEnter, null, element.props.onCLick)
                };
                else if (tooltipEventType !== "axis") itemEvents = {
                    onMouseLeave: (0, $c86c74861e78fc13$export$760ec406ba47bace)(_this.handleItemMouseLeave, null, element.props.onMouseLeave),
                    onMouseEnter: (0, $c86c74861e78fc13$export$760ec406ba47bace)(_this.handleItemMouseEnter, null, element.props.onMouseEnter)
                };
                var graphicalItem = /*#__PURE__*/ (0, $jC8Vy.cloneElement)(element, $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, item.props), itemEvents));
                function findWithPayload(entry) {
                    // TODO needs to verify dataKey is Function
                    return typeof tooltipAxis.dataKey === "function" ? tooltipAxis.dataKey(entry.payload) : null;
                }
                if (hasActive) {
                    var activePoint, basePoint;
                    if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
                        // number transform to string
                        var specifiedKey = typeof tooltipAxis.dataKey === "function" ? findWithPayload : "payload.".concat(tooltipAxis.dataKey.toString());
                        activePoint = (0, $804fab7e7cc9eb97$export$66950d3869f5cc67)(points, specifiedKey, activeLabel);
                        basePoint = isRange && baseLine && (0, $804fab7e7cc9eb97$export$66950d3869f5cc67)(baseLine, specifiedKey, activeLabel);
                    } else {
                        activePoint = points[activeTooltipIndex];
                        basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
                    }
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(activePoint)) return [
                        graphicalItem
                    ].concat($1665b5dabe1eba12$var$_toConsumableArray(_this.renderActivePoints({
                        item: item,
                        activePoint: activePoint,
                        basePoint: basePoint,
                        childIndex: activeTooltipIndex,
                        isRange: isRange
                    })));
                }
                if (isRange) return [
                    graphicalItem,
                    null,
                    null
                ];
                return [
                    graphicalItem,
                    null
                ];
            };
            _this.renderCustomized = function(element, displayName, index) {
                return /*#__PURE__*/ (0, $jC8Vy.cloneElement)(element, $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({
                    key: "recharts-customized-".concat(index)
                }, _this.props), _this.state));
            };
            _this.uniqueChartId = (0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(_props.id) ? (0, $804fab7e7cc9eb97$export$8b15d37bc3f197d4)("recharts") : _props.id;
            _this.clipPathId = "".concat(_this.uniqueChartId, "-clip");
            if (_props.throttleDelay) _this.triggeredAfterMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($19ce9d71690ae512$exports)))(_this.triggeredAfterMouseMove, _props.throttleDelay);
            _this.state = {};
            return _this;
        }
        /* eslint-disable  react/no-did-mount-set-state */ $1665b5dabe1eba12$var$_createClass(CategoricalChartWrapper, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(this.props.syncId)) this.addListener();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    // add syncId
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(prevProps.syncId) && !(0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(this.props.syncId)) this.addListener();
                     // remove syncId
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(prevProps.syncId) && (0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(this.props.syncId)) this.removeListener();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.clearDeferId();
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(this.props.syncId)) this.removeListener();
                    this.cancelThrottledTriggerAfterMouseMove();
                }
            },
            {
                key: "cancelThrottledTriggerAfterMouseMove",
                value: function cancelThrottledTriggerAfterMouseMove() {
                    if (typeof this.triggeredAfterMouseMove.cancel === "function") this.triggeredAfterMouseMove.cancel();
                }
            },
            {
                key: "getTooltipEventType",
                value: function getTooltipEventType() {
                    var tooltipItem = (0, $217577d291f12aa3$export$64c61536a2b72e0f)(this.props.children, (0, $def5cb6e7a67bb87$export$28c660c63b792dea).displayName);
                    if (tooltipItem && (0, (/*@__PURE__*/$parcel$interopDefault($fbdd9003106207a4$exports)))(tooltipItem.props.shared)) {
                        var eventType = tooltipItem.props.shared ? "axis" : "item";
                        return validateTooltipEventTypes.indexOf(eventType) >= 0 ? eventType : defaultTooltipEventType;
                    }
                    return defaultTooltipEventType;
                }
            },
            {
                key: "getMouseInfo",
                value: function getMouseInfo(event) {
                    if (!this.container) return null;
                    var containerOffset = (0, $f9d7f659152e7a9e$export$622cea445a1c5b7d)(this.container);
                    var e = (0, $f9d7f659152e7a9e$export$f209e6c32ad3d02e)(event, containerOffset);
                    var rangeObj = this.inRange(e.chartX, e.chartY);
                    if (!rangeObj) return null;
                    var _this$state9 = this.state, xAxisMap = _this$state9.xAxisMap, yAxisMap = _this$state9.yAxisMap;
                    var tooltipEventType = this.getTooltipEventType();
                    if (tooltipEventType !== "axis" && xAxisMap && yAxisMap) {
                        var xScale = (0, $804fab7e7cc9eb97$export$b88993f0aa0bf776)(xAxisMap).scale;
                        var yScale = (0, $804fab7e7cc9eb97$export$b88993f0aa0bf776)(yAxisMap).scale;
                        var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
                        var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
                        return $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, e), {}, {
                            xValue: xValue,
                            yValue: yValue
                        });
                    }
                    var toolTipData = $1665b5dabe1eba12$var$getTooltipData(this.state, this.props.data, this.props.layout, rangeObj);
                    if (toolTipData) return $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, e), toolTipData);
                    return null;
                }
            },
            {
                key: "getCursorRectangle",
                value: function getCursorRectangle() {
                    var layout = this.props.layout;
                    var _this$state10 = this.state, activeCoordinate = _this$state10.activeCoordinate, offset = _this$state10.offset, tooltipAxisBandSize = _this$state10.tooltipAxisBandSize;
                    var halfSize = tooltipAxisBandSize / 2;
                    return {
                        stroke: "none",
                        fill: "#ccc",
                        x: layout === "horizontal" ? activeCoordinate.x - halfSize : offset.left + 0.5,
                        y: layout === "horizontal" ? offset.top + 0.5 : activeCoordinate.y - halfSize,
                        width: layout === "horizontal" ? tooltipAxisBandSize : offset.width - 1,
                        height: layout === "horizontal" ? offset.height - 1 : tooltipAxisBandSize
                    };
                }
            },
            {
                key: "getCursorPoints",
                value: function getCursorPoints() {
                    var layout = this.props.layout;
                    var _this$state11 = this.state, activeCoordinate = _this$state11.activeCoordinate, offset = _this$state11.offset;
                    var x1, y1, x2, y2;
                    if (layout === "horizontal") {
                        x1 = activeCoordinate.x;
                        x2 = x1;
                        y1 = offset.top;
                        y2 = offset.top + offset.height;
                    } else if (layout === "vertical") {
                        y1 = activeCoordinate.y;
                        y2 = y1;
                        x1 = offset.left;
                        x2 = offset.left + offset.width;
                    } else if (!(0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(activeCoordinate.cx) || !(0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(activeCoordinate.cy)) {
                        if (layout === "centric") {
                            var cx = activeCoordinate.cx, cy = activeCoordinate.cy, innerRadius = activeCoordinate.innerRadius, outerRadius = activeCoordinate.outerRadius, angle = activeCoordinate.angle;
                            var innerPoint = (0, $470bf96dd282a944$export$5c9a959bb3fc7749)(cx, cy, innerRadius, angle);
                            var outerPoint = (0, $470bf96dd282a944$export$5c9a959bb3fc7749)(cx, cy, outerRadius, angle);
                            x1 = innerPoint.x;
                            y1 = innerPoint.y;
                            x2 = outerPoint.x;
                            y2 = outerPoint.y;
                        } else {
                            var _cx = activeCoordinate.cx, _cy = activeCoordinate.cy, radius = activeCoordinate.radius, startAngle = activeCoordinate.startAngle, endAngle = activeCoordinate.endAngle;
                            var startPoint = (0, $470bf96dd282a944$export$5c9a959bb3fc7749)(_cx, _cy, radius, startAngle);
                            var endPoint = (0, $470bf96dd282a944$export$5c9a959bb3fc7749)(_cx, _cy, radius, endAngle);
                            return {
                                points: [
                                    startPoint,
                                    endPoint
                                ],
                                cx: _cx,
                                cy: _cy,
                                radius: radius,
                                startAngle: startAngle,
                                endAngle: endAngle
                            };
                        }
                    }
                    return [
                        {
                            x: x1,
                            y: y1
                        },
                        {
                            x: x2,
                            y: y2
                        }
                    ];
                }
            },
            {
                key: "inRange",
                value: function inRange(x, y) {
                    var layout = this.props.layout;
                    if (layout === "horizontal" || layout === "vertical") {
                        var offset = this.state.offset;
                        var isInRange = x >= offset.left && x <= offset.left + offset.width && y >= offset.top && y <= offset.top + offset.height;
                        return isInRange ? {
                            x: x,
                            y: y
                        } : null;
                    }
                    var _this$state12 = this.state, angleAxisMap = _this$state12.angleAxisMap, radiusAxisMap = _this$state12.radiusAxisMap;
                    if (angleAxisMap && radiusAxisMap) {
                        var angleAxis = (0, $804fab7e7cc9eb97$export$b88993f0aa0bf776)(angleAxisMap);
                        return (0, $470bf96dd282a944$export$e85a2bf8cd31c504)({
                            x: x,
                            y: y
                        }, angleAxis);
                    }
                    return null;
                }
            },
            {
                key: "parseEventsOfWrapper",
                value: function parseEventsOfWrapper() {
                    var children = this.props.children;
                    var tooltipEventType = this.getTooltipEventType();
                    var tooltipItem = (0, $217577d291f12aa3$export$64c61536a2b72e0f)(children, (0, $def5cb6e7a67bb87$export$28c660c63b792dea).displayName);
                    var tooltipEvents = {};
                    if (tooltipItem && tooltipEventType === "axis") {
                        if (tooltipItem.props.trigger === "click") tooltipEvents = {
                            onClick: this.handleClick
                        };
                        else tooltipEvents = {
                            onMouseEnter: this.handleMouseEnter,
                            onMouseMove: this.handleMouseMove,
                            onMouseLeave: this.handleMouseLeave,
                            onTouchMove: this.handleTouchMove,
                            onTouchStart: this.handleTouchStart,
                            onTouchEnd: this.handleTouchEnd
                        };
                    }
                    var outerEvents = (0, $05a192303b32ed93$export$7c4c290a4a9c1b1e)(this.props, this.handleOuterEvent);
                    return $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, outerEvents), tooltipEvents);
                }
            },
            {
                key: "addListener",
                value: function addListener() {
                    (0, $7b280888e35ce977$export$9bcdfe5f29bb33).on((0, $7b280888e35ce977$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                    if ((0, $7b280888e35ce977$export$9bcdfe5f29bb33).setMaxListeners && (0, $7b280888e35ce977$export$9bcdfe5f29bb33)._maxListeners) (0, $7b280888e35ce977$export$9bcdfe5f29bb33).setMaxListeners((0, $7b280888e35ce977$export$9bcdfe5f29bb33)._maxListeners + 1);
                }
            },
            {
                key: "removeListener",
                value: function removeListener() {
                    (0, $7b280888e35ce977$export$9bcdfe5f29bb33).removeListener((0, $7b280888e35ce977$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                    if ((0, $7b280888e35ce977$export$9bcdfe5f29bb33).setMaxListeners && (0, $7b280888e35ce977$export$9bcdfe5f29bb33)._maxListeners) (0, $7b280888e35ce977$export$9bcdfe5f29bb33).setMaxListeners((0, $7b280888e35ce977$export$9bcdfe5f29bb33)._maxListeners - 1);
                }
            },
            {
                key: "triggerSyncEvent",
                value: function triggerSyncEvent(data) {
                    var syncId = this.props.syncId;
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(syncId)) (0, $7b280888e35ce977$export$9bcdfe5f29bb33).emit((0, $7b280888e35ce977$export$ff9a08f6d0c38b8f), syncId, this.uniqueChartId, data);
                }
            },
            {
                key: "applySyncEvent",
                value: function applySyncEvent(data) {
                    var _this$props4 = this.props, layout = _this$props4.layout, syncMethod = _this$props4.syncMethod;
                    var updateId = this.state.updateId;
                    var dataStartIndex = data.dataStartIndex, dataEndIndex = data.dataEndIndex;
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(data.dataStartIndex) || !(0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(data.dataEndIndex)) this.setState($1665b5dabe1eba12$var$_objectSpread({
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex
                    }, updateStateOfAxisMapsOffsetAndStackGroups({
                        props: this.props,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex,
                        updateId: updateId
                    }, this.state)));
                    else if (!(0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(data.activeTooltipIndex)) {
                        var chartX = data.chartX, chartY = data.chartY;
                        var activeTooltipIndex = data.activeTooltipIndex;
                        var _this$state13 = this.state, offset = _this$state13.offset, tooltipTicks = _this$state13.tooltipTicks;
                        if (!offset) return;
                        if (typeof syncMethod === "function") // Call a callback function. If there is an application specific algorithm
                        activeTooltipIndex = syncMethod(tooltipTicks, data);
                        else if (syncMethod === "value") {
                            // Set activeTooltipIndex to the index with the same value as data.activeLabel
                            // For loop instead of findIndex because the latter is very slow in some browsers
                            activeTooltipIndex = -1; // in case we cannot find the element
                            for(var i = 0; i < tooltipTicks.length; i++)if (tooltipTicks[i].value === data.activeLabel) {
                                activeTooltipIndex = i;
                                break;
                            }
                        }
                        var viewBox = $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, offset), {}, {
                            x: offset.left,
                            y: offset.top
                        }); // When a categotical chart is combined with another chart, the value of chartX
                        // and chartY may beyond the boundaries.
                        var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
                        var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
                        var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
                        var activePayload = $1665b5dabe1eba12$var$getTooltipContent(this.state, this.props.data, activeTooltipIndex);
                        var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
                            x: layout === "horizontal" ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
                            y: layout === "horizontal" ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
                        } : $1665b5dabe1eba12$var$originCoordinate;
                        this.setState($1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, data), {}, {
                            activeLabel: activeLabel,
                            activeCoordinate: activeCoordinate,
                            activePayload: activePayload,
                            activeTooltipIndex: activeTooltipIndex
                        }));
                    } else this.setState(data);
                }
            },
            {
                key: "filterFormatItem",
                value: function filterFormatItem(item, displayName, childIndex) {
                    var formattedGraphicalItems = this.state.formattedGraphicalItems;
                    for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var entry = formattedGraphicalItems[i];
                        if (entry.item === item || entry.props.key === item.key || displayName === (0, $217577d291f12aa3$export$be63e0664592e141)(entry.item.type) && childIndex === entry.childIndex) return entry;
                    }
                    return null;
                }
            },
            {
                key: "renderAxis",
                value: /**
       * Draw axis
       * @param {Object} axisOptions The options of axis
       * @param {Object} element      The axis element
       * @param {String} displayName  The display name of axis
       * @param {Number} index        The index of element
       * @return {ReactElement}       The instance of x-axes
       */ function renderAxis(axisOptions, element, displayName, index) {
                    var _this$props5 = this.props, width = _this$props5.width, height = _this$props5.height;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $ce731c8553b71ef9$export$bdd99f2cdf352bae), $1665b5dabe1eba12$var$_extends({}, axisOptions, {
                        className: "recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType),
                        key: element.key || "".concat(displayName, "-").concat(index),
                        viewBox: {
                            x: 0,
                            y: 0,
                            width: width,
                            height: height
                        },
                        ticksGenerator: this.axesTicksGenerator
                    }));
                }
            },
            {
                key: "renderClipPath",
                value: function renderClipPath() {
                    var clipPathId = this.clipPathId;
                    var _this$state$offset = this.state.offset, left = _this$state$offset.left, top = _this$state$offset.top, height = _this$state$offset.height, width = _this$state$offset.width;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("clipPath", {
                        id: clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("rect", {
                        x: left,
                        y: top,
                        height: height,
                        width: width
                    })));
                }
            },
            {
                key: "getXScales",
                value: function getXScales() {
                    var xAxisMap = this.state.xAxisMap;
                    return xAxisMap ? Object.entries(xAxisMap).reduce(function(res, _ref13) {
                        var _ref14 = $1665b5dabe1eba12$var$_slicedToArray(_ref13, 2), axisId = _ref14[0], axisProps = _ref14[1];
                        return $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, res), {}, $1665b5dabe1eba12$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getYScales",
                value: function getYScales() {
                    var yAxisMap = this.state.yAxisMap;
                    return yAxisMap ? Object.entries(yAxisMap).reduce(function(res, _ref15) {
                        var _ref16 = $1665b5dabe1eba12$var$_slicedToArray(_ref15, 2), axisId = _ref16[0], axisProps = _ref16[1];
                        return $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, res), {}, $1665b5dabe1eba12$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getXScaleByAxisId",
                value: function getXScaleByAxisId(axisId) {
                    var _this$state$xAxisMap, _this$state$xAxisMap$;
                    return (_this$state$xAxisMap = this.state.xAxisMap) === null || _this$state$xAxisMap === void 0 ? void 0 : (_this$state$xAxisMap$ = _this$state$xAxisMap[axisId]) === null || _this$state$xAxisMap$ === void 0 ? void 0 : _this$state$xAxisMap$.scale;
                }
            },
            {
                key: "getYScaleByAxisId",
                value: function getYScaleByAxisId(axisId) {
                    var _this$state$yAxisMap, _this$state$yAxisMap$;
                    return (_this$state$yAxisMap = this.state.yAxisMap) === null || _this$state$yAxisMap === void 0 ? void 0 : (_this$state$yAxisMap$ = _this$state$yAxisMap[axisId]) === null || _this$state$yAxisMap$ === void 0 ? void 0 : _this$state$yAxisMap$.scale;
                }
            },
            {
                key: "getItemByXY",
                value: function getItemByXY(chartXY) {
                    var formattedGraphicalItems = this.state.formattedGraphicalItems;
                    if (formattedGraphicalItems && formattedGraphicalItems.length) for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var graphicalItem = formattedGraphicalItems[i];
                        var props = graphicalItem.props, item = graphicalItem.item;
                        var itemDisplayName = (0, $217577d291f12aa3$export$be63e0664592e141)(item.type);
                        if (itemDisplayName === "Bar") {
                            var activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $8ac86f32b9b56c8b$export$f783d19325be51d5)(chartXY, entry);
                            });
                            if (activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: activeBarItem
                            };
                        } else if (itemDisplayName === "RadialBar") {
                            var _activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $470bf96dd282a944$export$e85a2bf8cd31c504)(chartXY, entry);
                            });
                            if (_activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: _activeBarItem
                            };
                        }
                    }
                    return null;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    if (!(0, $217577d291f12aa3$export$5301de6bfd3cfa2a)(this)) return null;
                    var _this$props6 = this.props, children = _this$props6.children, className = _this$props6.className, width = _this$props6.width, height = _this$props6.height, style = _this$props6.style, compact = _this$props6.compact, others = $1665b5dabe1eba12$var$_objectWithoutProperties(_this$props6, [
                        "children",
                        "className",
                        "width",
                        "height",
                        "style",
                        "compact"
                    ]);
                    var attrs = (0, $05a192303b32ed93$export$d697c39a2985a4c)(others);
                    var map = {
                        CartesianGrid: {
                            handler: this.renderGrid,
                            once: true
                        },
                        ReferenceArea: {
                            handler: this.renderReferenceElement
                        },
                        ReferenceLine: {
                            handler: this.renderReferenceElement
                        },
                        ReferenceDot: {
                            handler: this.renderReferenceElement
                        },
                        XAxis: {
                            handler: this.renderXAxis
                        },
                        YAxis: {
                            handler: this.renderYAxis
                        },
                        Brush: {
                            handler: this.renderBrush,
                            once: true
                        },
                        Bar: {
                            handler: this.renderGraphicChild
                        },
                        Line: {
                            handler: this.renderGraphicChild
                        },
                        Area: {
                            handler: this.renderGraphicChild
                        },
                        Radar: {
                            handler: this.renderGraphicChild
                        },
                        RadialBar: {
                            handler: this.renderGraphicChild
                        },
                        Scatter: {
                            handler: this.renderGraphicChild
                        },
                        Pie: {
                            handler: this.renderGraphicChild
                        },
                        Funnel: {
                            handler: this.renderGraphicChild
                        },
                        Tooltip: {
                            handler: this.renderCursor,
                            once: true
                        },
                        PolarGrid: {
                            handler: this.renderPolarGrid,
                            once: true
                        },
                        PolarAngleAxis: {
                            handler: this.renderPolarAxis
                        },
                        PolarRadiusAxis: {
                            handler: this.renderPolarAxis
                        },
                        Customized: {
                            handler: this.renderCustomized
                        }
                    }; // The "compact" mode is mainly used as the panorama within Brush
                    if (compact) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $38e5da7c3943e1e6$export$7b92b459e668cb21), $1665b5dabe1eba12$var$_extends({}, attrs, {
                        width: width,
                        height: height
                    }), this.renderClipPath(), (0, $217577d291f12aa3$export$a98d6da55570cb82)(children, map));
                    var events = this.parseEventsOfWrapper();
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", $1665b5dabe1eba12$var$_extends({
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))("recharts-wrapper", className),
                        style: $1665b5dabe1eba12$var$_objectSpread({
                            position: "relative",
                            cursor: "default",
                            width: width,
                            height: height
                        }, style)
                    }, events, {
                        ref: function ref(node) {
                            _this2.container = node;
                        }
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $38e5da7c3943e1e6$export$7b92b459e668cb21), $1665b5dabe1eba12$var$_extends({}, attrs, {
                        width: width,
                        height: height
                    }), this.renderClipPath(), (0, $217577d291f12aa3$export$a98d6da55570cb82)(children, map)), this.renderLegend(), this.renderTooltip());
                }
            }
        ]);
        return CategoricalChartWrapper;
    }((0, $jC8Vy.Component)), _class.displayName = chartName, _class.defaultProps = $1665b5dabe1eba12$var$_objectSpread({
        layout: "horizontal",
        stackOffset: "none",
        barCategoryGap: "10%",
        barGap: 4,
        margin: {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5
        },
        reverseStackOrder: false,
        syncMethod: "index"
    }, defaultProps), _class.getDerivedStateFromProps = function(nextProps, prevState) {
        var data = nextProps.data, children = nextProps.children, width = nextProps.width, height = nextProps.height, layout = nextProps.layout, stackOffset = nextProps.stackOffset, margin = nextProps.margin;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(prevState.updateId)) {
            var defaultState = $1665b5dabe1eba12$var$createDefaultState(nextProps);
            return $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, defaultState), {}, {
                updateId: 0
            }, updateStateOfAxisMapsOffsetAndStackGroups($1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({
                props: nextProps
            }, defaultState), {}, {
                updateId: 0
            }), prevState)), {}, {
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (data !== prevState.prevData || width !== prevState.prevWidth || height !== prevState.prevHeight || layout !== prevState.prevLayout || stackOffset !== prevState.prevStackOffset || !(0, $69167576c9a4dc19$export$d36bdfa510afb180)(margin, prevState.prevMargin)) {
            var _defaultState = $1665b5dabe1eba12$var$createDefaultState(nextProps); // Fixes https://github.com/recharts/recharts/issues/2143
            var keepFromPrevState = {
                // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
                // any flickering
                chartX: prevState.chartX,
                chartY: prevState.chartY,
                // The tooltip should stay active when it was active in the previous render. If this is not
                // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
                isTooltipActive: prevState.isTooltipActive
            };
            var updatesToState = $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, $1665b5dabe1eba12$var$getTooltipData(prevState, data, layout)), {}, {
                updateId: prevState.updateId + 1
            });
            var newState = $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, _defaultState), keepFromPrevState), updatesToState);
            return $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({}, newState), updateStateOfAxisMapsOffsetAndStackGroups($1665b5dabe1eba12$var$_objectSpread({
                props: nextProps
            }, newState), prevState)), {}, {
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (!(0, $217577d291f12aa3$export$acdc716e08572f94)(children, prevState.prevChildren)) {
            // update configuration in chilren
            var hasGlobalData = !(0, (/*@__PURE__*/$parcel$interopDefault($2ff7692bd8c10edb$exports)))(data);
            var newUpdateId = hasGlobalData ? prevState.updateId : prevState.updateId + 1;
            return $1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({
                updateId: newUpdateId
            }, updateStateOfAxisMapsOffsetAndStackGroups($1665b5dabe1eba12$var$_objectSpread($1665b5dabe1eba12$var$_objectSpread({
                props: nextProps
            }, prevState), {}, {
                updateId: newUpdateId
            }), prevState)), {}, {
                prevChildren: children
            });
        }
        return null;
    }, _class.renderActiveDot = function(option, props) {
        var dot;
        if (/*#__PURE__*/ (0, $jC8Vy.isValidElement)(option)) dot = /*#__PURE__*/ (0, $jC8Vy.cloneElement)(option, props);
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(option)) dot = option(props);
        else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $d32ef06d884f12a9$export$d046b3c4a416f60d), props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $a857ed6b15ebb152$export$936d0764594b6eb3), {
            className: "recharts-active-dot",
            key: props.key
        }, dot);
    }, _temp;
};



/**
 * @fileOverview X Axis
 */ /** Define of XAxis props */ var $93c866c346f0ff3f$export$ea77231de273b52d = function XAxis() {
    return null;
};
$93c866c346f0ff3f$export$ea77231de273b52d.displayName = "XAxis";
$93c866c346f0ff3f$export$ea77231de273b52d.defaultProps = {
    allowDecimals: true,
    hide: false,
    orientation: "bottom",
    width: 0,
    height: 30,
    mirror: false,
    xAxisId: 0,
    tickCount: 5,
    type: "category",
    domain: [
        0,
        "auto"
    ],
    padding: {
        left: 0,
        right: 0
    },
    allowDataOverflow: false,
    scale: "auto",
    reversed: false,
    allowDuplicatedCategory: true
};


/**
 * @fileOverview Y Axis
 */ var $96778e5623835b0a$export$f96c4024c52de8f4 = function YAxis() {
    return null;
};
$96778e5623835b0a$export$f96c4024c52de8f4.displayName = "YAxis";
$96778e5623835b0a$export$f96c4024c52de8f4.defaultProps = {
    allowDuplicatedCategory: true,
    allowDecimals: true,
    hide: false,
    orientation: "left",
    width: 60,
    height: 0,
    mirror: false,
    yAxisId: 0,
    tickCount: 5,
    type: "number",
    domain: [
        0,
        "auto"
    ],
    padding: {
        top: 0,
        bottom: 0
    },
    allowDataOverflow: false,
    scale: "auto",
    reversed: false
};



var $710db46d899b5603$export$f510429275d6f1a8 = (0, $1665b5dabe1eba12$export$77871aede60e6838)({
    chartName: "AreaChart",
    GraphicalChild: (0, $fa5d459f96aa6e1d$export$ea1a111407f37557),
    axisComponents: [
        {
            axisType: "xAxis",
            AxisComp: (0, $93c866c346f0ff3f$export$ea77231de273b52d)
        },
        {
            axisType: "yAxis",
            AxisComp: (0, $96778e5623835b0a$export$f96c4024c52de8f4)
        }
    ],
    formatAxisMap: (0, $6d35a382c17a9759$export$ece7de1383db5ac)
});



var $jC8Vy = parcelRequire("jC8Vy");


function $0367c217dc0c3235$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $0367c217dc0c3235$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $0367c217dc0c3235$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $0367c217dc0c3235$var$_typeof(obj);
}
function $0367c217dc0c3235$var$_extends() {
    $0367c217dc0c3235$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0367c217dc0c3235$var$_extends.apply(this, arguments);
}
function $0367c217dc0c3235$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0367c217dc0c3235$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0367c217dc0c3235$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $0367c217dc0c3235$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0367c217dc0c3235$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $0367c217dc0c3235$var$ownKeys(Object(source), true).forEach(function(key) {
            $0367c217dc0c3235$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $0367c217dc0c3235$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0367c217dc0c3235$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0367c217dc0c3235$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0367c217dc0c3235$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $0367c217dc0c3235$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0367c217dc0c3235$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0367c217dc0c3235$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $0367c217dc0c3235$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $0367c217dc0c3235$var$_setPrototypeOf(subClass, superClass);
}
function $0367c217dc0c3235$var$_setPrototypeOf(o, p) {
    $0367c217dc0c3235$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0367c217dc0c3235$var$_setPrototypeOf(o, p);
}
function $0367c217dc0c3235$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $0367c217dc0c3235$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $0367c217dc0c3235$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $0367c217dc0c3235$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $0367c217dc0c3235$var$_possibleConstructorReturn(this, result);
    };
}
function $0367c217dc0c3235$var$_possibleConstructorReturn(self, call) {
    if (call && ($0367c217dc0c3235$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $0367c217dc0c3235$var$_assertThisInitialized(self);
}
function $0367c217dc0c3235$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $0367c217dc0c3235$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $0367c217dc0c3235$var$_getPrototypeOf(o) {
    $0367c217dc0c3235$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $0367c217dc0c3235$var$_getPrototypeOf(o);
}
var $0367c217dc0c3235$export$6440e27b9f186856 = /*#__PURE__*/ function(_PureComponent) {
    $0367c217dc0c3235$var$_inherits(CartesianGrid, _PureComponent);
    var _super = $0367c217dc0c3235$var$_createSuper(CartesianGrid);
    function CartesianGrid() {
        $0367c217dc0c3235$var$_classCallCheck(this, CartesianGrid);
        return _super.apply(this, arguments);
    }
    $0367c217dc0c3235$var$_createClass(CartesianGrid, [
        {
            key: "renderHorizontal",
            value: /**
     * Draw the horizontal grid lines
     * @param {Array} horizontalPoints either passed in as props or generated from function
     * @return {Group} Horizontal lines
     */ function renderHorizontal(horizontalPoints) {
                var _this = this;
                var _this$props = this.props, x = _this$props.x, width = _this$props.width, horizontal = _this$props.horizontal;
                if (!horizontalPoints || !horizontalPoints.length) return null;
                var items = horizontalPoints.map(function(entry, i) {
                    var props = $0367c217dc0c3235$var$_objectSpread($0367c217dc0c3235$var$_objectSpread({}, _this.props), {}, {
                        x1: x,
                        y1: entry,
                        x2: x + width,
                        y2: entry,
                        key: "line-".concat(i),
                        index: i
                    });
                    return CartesianGrid.renderLineItem(horizontal, props);
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("g", {
                    className: "recharts-cartesian-grid-horizontal"
                }, items);
            }
        },
        {
            key: "renderVertical",
            value: function renderVertical(verticalPoints) {
                var _this2 = this;
                var _this$props2 = this.props, y = _this$props2.y, height = _this$props2.height, vertical = _this$props2.vertical;
                if (!verticalPoints || !verticalPoints.length) return null;
                var items = verticalPoints.map(function(entry, i) {
                    var props = $0367c217dc0c3235$var$_objectSpread($0367c217dc0c3235$var$_objectSpread({}, _this2.props), {}, {
                        x1: entry,
                        y1: y,
                        x2: entry,
                        y2: y + height,
                        key: "line-".concat(i),
                        index: i
                    });
                    return CartesianGrid.renderLineItem(vertical, props);
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("g", {
                    className: "recharts-cartesian-grid-vertical"
                }, items);
            }
        },
        {
            key: "renderVerticalStripes",
            value: function renderVerticalStripes(verticalPoints) {
                var verticalFill = this.props.verticalFill;
                if (!verticalFill || !verticalFill.length) return null;
                var _this$props3 = this.props, fillOpacity = _this$props3.fillOpacity, x = _this$props3.x, y = _this$props3.y, width = _this$props3.width, height = _this$props3.height;
                var verticalPointsUpdated = verticalPoints.slice().sort(function(a, b) {
                    return a - b;
                });
                if (x !== verticalPointsUpdated[0]) verticalPointsUpdated.unshift(0);
                var items = verticalPointsUpdated.map(function(entry, i) {
                    var lineWidth = verticalPointsUpdated[i + 1] ? verticalPointsUpdated[i + 1] - entry : x + width - entry;
                    if (lineWidth <= 0) return null;
                    var colorIndex = i % verticalFill.length;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("rect", {
                        key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
                        ,
                        x: Math.round(entry + x - x),
                        y: y,
                        width: lineWidth,
                        height: height,
                        stroke: "none",
                        fill: verticalFill[colorIndex],
                        fillOpacity: fillOpacity,
                        className: "recharts-cartesian-grid-bg"
                    });
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("g", {
                    className: "recharts-cartesian-gridstripes-vertical"
                }, items);
            }
        },
        {
            key: "renderHorizontalStripes",
            value: function renderHorizontalStripes(horizontalPoints) {
                var horizontalFill = this.props.horizontalFill;
                if (!horizontalFill || !horizontalFill.length) return null;
                var _this$props4 = this.props, fillOpacity = _this$props4.fillOpacity, x = _this$props4.x, y = _this$props4.y, width = _this$props4.width, height = _this$props4.height;
                var horizontalPointsUpdated = horizontalPoints.slice().sort(function(a, b) {
                    return a - b;
                });
                if (y !== horizontalPointsUpdated[0]) horizontalPointsUpdated.unshift(0);
                var items = horizontalPointsUpdated.map(function(entry, i) {
                    var lineHeight = horizontalPointsUpdated[i + 1] ? horizontalPointsUpdated[i + 1] - entry : y + height - entry;
                    if (lineHeight <= 0) return null;
                    var colorIndex = i % horizontalFill.length;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("rect", {
                        key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
                        ,
                        y: Math.round(entry + y - y),
                        x: x,
                        height: lineHeight,
                        width: width,
                        stroke: "none",
                        fill: horizontalFill[colorIndex],
                        fillOpacity: fillOpacity,
                        className: "recharts-cartesian-grid-bg"
                    });
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("g", {
                    className: "recharts-cartesian-gridstripes-horizontal"
                }, items);
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var fill = this.props.fill;
                if (!fill || fill === "none") return null;
                var _this$props5 = this.props, fillOpacity = _this$props5.fillOpacity, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    stroke: "none",
                    fill: fill,
                    fillOpacity: fillOpacity,
                    className: "recharts-cartesian-grid-bg"
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, horizontal = _this$props6.horizontal, vertical = _this$props6.vertical, horizontalCoordinatesGenerator = _this$props6.horizontalCoordinatesGenerator, verticalCoordinatesGenerator = _this$props6.verticalCoordinatesGenerator, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, offset = _this$props6.offset, chartWidth = _this$props6.chartWidth, chartHeight = _this$props6.chartHeight;
                if (!(0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(height) || height <= 0 || !(0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(x) || x !== +x || !(0, $804fab7e7cc9eb97$export$7e4aa119212bc614)(y) || y !== +y) return null;
                var _this$props7 = this.props, horizontalPoints = _this$props7.horizontalPoints, verticalPoints = _this$props7.verticalPoints; // No horizontal points are specified
                if ((!horizontalPoints || !horizontalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(horizontalCoordinatesGenerator)) horizontalPoints = horizontalCoordinatesGenerator({
                    yAxis: yAxis,
                    width: chartWidth,
                    height: chartHeight,
                    offset: offset
                });
                 // No vertical points are specified
                if ((!verticalPoints || !verticalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(verticalCoordinatesGenerator)) verticalPoints = verticalCoordinatesGenerator({
                    xAxis: xAxis,
                    width: chartWidth,
                    height: chartHeight,
                    offset: offset
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("g", {
                    className: "recharts-cartesian-grid"
                }, this.renderBackground(), horizontal && this.renderHorizontal(horizontalPoints), vertical && this.renderVertical(verticalPoints), horizontal && this.renderHorizontalStripes(horizontalPoints), vertical && this.renderVerticalStripes(verticalPoints));
            }
        }
    ], [
        {
            key: "renderLineItem",
            value: function renderLineItem(option, props) {
                var lineItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).isValidElement(option)) lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($88ef20dc5b761d7c$exports)))(option)) lineItem = option(props);
                else {
                    var x1 = props.x1, y1 = props.y1, x2 = props.x2, y2 = props.y2, key = props.key, others = $0367c217dc0c3235$var$_objectWithoutProperties(props, [
                        "x1",
                        "y1",
                        "x2",
                        "y2",
                        "key"
                    ]);
                    lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("line", $0367c217dc0c3235$var$_extends({}, (0, $05a192303b32ed93$export$d697c39a2985a4c)(others), {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2,
                        fill: "none",
                        key: key
                    }));
                }
                return lineItem;
            }
        }
    ]);
    return CartesianGrid;
}((0, $jC8Vy.PureComponent));
$0367c217dc0c3235$export$6440e27b9f186856.displayName = "CartesianGrid";
$0367c217dc0c3235$export$6440e27b9f186856.defaultProps = {
    horizontal: true,
    vertical: true,
    // The ordinates of horizontal grid lines
    horizontalPoints: [],
    // The abscissas of vertical grid lines
    verticalPoints: [],
    stroke: "#ccc",
    fill: "none",
    // The fill of colors of grid lines
    verticalFill: [],
    horizontalFill: []
};



var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $jC8Vy = parcelRequire("jC8Vy");

var $jH4WR = parcelRequire("jH4WR");
/* global Reflect, Promise */ var $281dc9c55b9413ad$var$extendStatics = function(d, b) {
    $281dc9c55b9413ad$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $281dc9c55b9413ad$var$extendStatics(d, b);
};
function $281dc9c55b9413ad$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $281dc9c55b9413ad$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $281dc9c55b9413ad$var$__assign = function() {
    $281dc9c55b9413ad$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $281dc9c55b9413ad$var$__assign.apply(this, arguments);
};
function $281dc9c55b9413ad$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var $281dc9c55b9413ad$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {}; /**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ 
function $281dc9c55b9413ad$var$isObject$3(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
var $281dc9c55b9413ad$var$isObject_1 = $281dc9c55b9413ad$var$isObject$3; /** Detect free variable `global` from Node.js. */ 
var $281dc9c55b9413ad$var$freeGlobal$1 = typeof $281dc9c55b9413ad$var$commonjsGlobal == "object" && $281dc9c55b9413ad$var$commonjsGlobal && $281dc9c55b9413ad$var$commonjsGlobal.Object === Object && $281dc9c55b9413ad$var$commonjsGlobal;
var $281dc9c55b9413ad$var$_freeGlobal = $281dc9c55b9413ad$var$freeGlobal$1;
var $281dc9c55b9413ad$var$freeGlobal = $281dc9c55b9413ad$var$_freeGlobal;
/** Detect free variable `self`. */ var $281dc9c55b9413ad$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $281dc9c55b9413ad$var$root$2 = $281dc9c55b9413ad$var$freeGlobal || $281dc9c55b9413ad$var$freeSelf || Function("return this")();
var $281dc9c55b9413ad$var$_root = $281dc9c55b9413ad$var$root$2;
var $281dc9c55b9413ad$var$root$1 = $281dc9c55b9413ad$var$_root;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $281dc9c55b9413ad$var$now$1 = function() {
    return $281dc9c55b9413ad$var$root$1.Date.now();
};
var $281dc9c55b9413ad$var$now_1 = $281dc9c55b9413ad$var$now$1; /** Used to match a single whitespace character. */ 
var $281dc9c55b9413ad$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $281dc9c55b9413ad$var$trimmedEndIndex$1(string) {
    var index = string.length;
    while(index-- && $281dc9c55b9413ad$var$reWhitespace.test(string.charAt(index)));
    return index;
}
var $281dc9c55b9413ad$var$_trimmedEndIndex = $281dc9c55b9413ad$var$trimmedEndIndex$1;
var $281dc9c55b9413ad$var$trimmedEndIndex = $281dc9c55b9413ad$var$_trimmedEndIndex;
/** Used to match leading whitespace. */ var $281dc9c55b9413ad$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $281dc9c55b9413ad$var$baseTrim$1(string) {
    return string ? string.slice(0, $281dc9c55b9413ad$var$trimmedEndIndex(string) + 1).replace($281dc9c55b9413ad$var$reTrimStart, "") : string;
}
var $281dc9c55b9413ad$var$_baseTrim = $281dc9c55b9413ad$var$baseTrim$1;
var $281dc9c55b9413ad$var$root = $281dc9c55b9413ad$var$_root;
/** Built-in value references. */ var $281dc9c55b9413ad$var$Symbol$2 = $281dc9c55b9413ad$var$root.Symbol;
var $281dc9c55b9413ad$var$_Symbol = $281dc9c55b9413ad$var$Symbol$2;
var $281dc9c55b9413ad$var$Symbol$1 = $281dc9c55b9413ad$var$_Symbol;
/** Used for built-in method references. */ var $281dc9c55b9413ad$var$objectProto$1 = Object.prototype;
/** Used to check objects for own properties. */ var $281dc9c55b9413ad$var$hasOwnProperty = $281dc9c55b9413ad$var$objectProto$1.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $281dc9c55b9413ad$var$nativeObjectToString$1 = $281dc9c55b9413ad$var$objectProto$1.toString;
/** Built-in value references. */ var $281dc9c55b9413ad$var$symToStringTag$1 = $281dc9c55b9413ad$var$Symbol$1 ? $281dc9c55b9413ad$var$Symbol$1.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $281dc9c55b9413ad$var$getRawTag$1(value) {
    var isOwn = $281dc9c55b9413ad$var$hasOwnProperty.call(value, $281dc9c55b9413ad$var$symToStringTag$1), tag = value[$281dc9c55b9413ad$var$symToStringTag$1];
    try {
        value[$281dc9c55b9413ad$var$symToStringTag$1] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $281dc9c55b9413ad$var$nativeObjectToString$1.call(value);
    if (unmasked) {
        if (isOwn) value[$281dc9c55b9413ad$var$symToStringTag$1] = tag;
        else delete value[$281dc9c55b9413ad$var$symToStringTag$1];
    }
    return result;
}
var $281dc9c55b9413ad$var$_getRawTag = $281dc9c55b9413ad$var$getRawTag$1; /** Used for built-in method references. */ 
var $281dc9c55b9413ad$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $281dc9c55b9413ad$var$nativeObjectToString = $281dc9c55b9413ad$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $281dc9c55b9413ad$var$objectToString$1(value) {
    return $281dc9c55b9413ad$var$nativeObjectToString.call(value);
}
var $281dc9c55b9413ad$var$_objectToString = $281dc9c55b9413ad$var$objectToString$1;
var $281dc9c55b9413ad$var$Symbol = $281dc9c55b9413ad$var$_Symbol, $281dc9c55b9413ad$var$getRawTag = $281dc9c55b9413ad$var$_getRawTag, $281dc9c55b9413ad$var$objectToString = $281dc9c55b9413ad$var$_objectToString;
/** `Object#toString` result references. */ var $281dc9c55b9413ad$var$nullTag = "[object Null]", $281dc9c55b9413ad$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $281dc9c55b9413ad$var$symToStringTag = $281dc9c55b9413ad$var$Symbol ? $281dc9c55b9413ad$var$Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $281dc9c55b9413ad$var$baseGetTag$1(value) {
    if (value == null) return value === undefined ? $281dc9c55b9413ad$var$undefinedTag : $281dc9c55b9413ad$var$nullTag;
    return $281dc9c55b9413ad$var$symToStringTag && $281dc9c55b9413ad$var$symToStringTag in Object(value) ? $281dc9c55b9413ad$var$getRawTag(value) : $281dc9c55b9413ad$var$objectToString(value);
}
var $281dc9c55b9413ad$var$_baseGetTag = $281dc9c55b9413ad$var$baseGetTag$1; /**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ 
function $281dc9c55b9413ad$var$isObjectLike$1(value) {
    return value != null && typeof value == "object";
}
var $281dc9c55b9413ad$var$isObjectLike_1 = $281dc9c55b9413ad$var$isObjectLike$1;
var $281dc9c55b9413ad$var$baseGetTag = $281dc9c55b9413ad$var$_baseGetTag, $281dc9c55b9413ad$var$isObjectLike = $281dc9c55b9413ad$var$isObjectLike_1;
/** `Object#toString` result references. */ var $281dc9c55b9413ad$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $281dc9c55b9413ad$var$isSymbol$1(value) {
    return typeof value == "symbol" || $281dc9c55b9413ad$var$isObjectLike(value) && $281dc9c55b9413ad$var$baseGetTag(value) == $281dc9c55b9413ad$var$symbolTag;
}
var $281dc9c55b9413ad$var$isSymbol_1 = $281dc9c55b9413ad$var$isSymbol$1;
var $281dc9c55b9413ad$var$baseTrim = $281dc9c55b9413ad$var$_baseTrim, $281dc9c55b9413ad$var$isObject$2 = $281dc9c55b9413ad$var$isObject_1, $281dc9c55b9413ad$var$isSymbol = $281dc9c55b9413ad$var$isSymbol_1;
/** Used as references for various `Number` constants. */ var $281dc9c55b9413ad$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $281dc9c55b9413ad$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $281dc9c55b9413ad$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $281dc9c55b9413ad$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $281dc9c55b9413ad$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $281dc9c55b9413ad$var$toNumber$1(value) {
    if (typeof value == "number") return value;
    if ($281dc9c55b9413ad$var$isSymbol(value)) return $281dc9c55b9413ad$var$NAN;
    if ($281dc9c55b9413ad$var$isObject$2(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $281dc9c55b9413ad$var$isObject$2(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $281dc9c55b9413ad$var$baseTrim(value);
    var isBinary = $281dc9c55b9413ad$var$reIsBinary.test(value);
    return isBinary || $281dc9c55b9413ad$var$reIsOctal.test(value) ? $281dc9c55b9413ad$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $281dc9c55b9413ad$var$reIsBadHex.test(value) ? $281dc9c55b9413ad$var$NAN : +value;
}
var $281dc9c55b9413ad$var$toNumber_1 = $281dc9c55b9413ad$var$toNumber$1;
var $281dc9c55b9413ad$var$isObject$1 = $281dc9c55b9413ad$var$isObject_1, $281dc9c55b9413ad$var$now = $281dc9c55b9413ad$var$now_1, $281dc9c55b9413ad$var$toNumber = $281dc9c55b9413ad$var$toNumber_1;
/** Error message constants. */ var $281dc9c55b9413ad$var$FUNC_ERROR_TEXT$1 = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $281dc9c55b9413ad$var$nativeMax = Math.max, $281dc9c55b9413ad$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $281dc9c55b9413ad$var$debounce$1(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($281dc9c55b9413ad$var$FUNC_ERROR_TEXT$1);
    wait = $281dc9c55b9413ad$var$toNumber(wait) || 0;
    if ($281dc9c55b9413ad$var$isObject$1(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $281dc9c55b9413ad$var$nativeMax($281dc9c55b9413ad$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $281dc9c55b9413ad$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $281dc9c55b9413ad$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($281dc9c55b9413ad$var$now());
    }
    function debounced() {
        var time = $281dc9c55b9413ad$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $281dc9c55b9413ad$var$debounce_1 = $281dc9c55b9413ad$var$debounce$1;
var $281dc9c55b9413ad$var$debounce = $281dc9c55b9413ad$var$debounce_1, $281dc9c55b9413ad$var$isObject = $281dc9c55b9413ad$var$isObject_1;
/** Error message constants. */ var $281dc9c55b9413ad$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $281dc9c55b9413ad$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($281dc9c55b9413ad$var$FUNC_ERROR_TEXT);
    if ($281dc9c55b9413ad$var$isObject(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $281dc9c55b9413ad$var$debounce(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
var $281dc9c55b9413ad$var$throttle_1 = $281dc9c55b9413ad$var$throttle;
var $281dc9c55b9413ad$var$patchResizeHandler = function(resizeCallback, refreshMode, refreshRate, refreshOptions) {
    switch(refreshMode){
        case "debounce":
            return $281dc9c55b9413ad$var$debounce_1(resizeCallback, refreshRate, refreshOptions);
        case "throttle":
            return $281dc9c55b9413ad$var$throttle_1(resizeCallback, refreshRate, refreshOptions);
        default:
            return resizeCallback;
    }
};
var $281dc9c55b9413ad$var$isFunction = function(fn) {
    return typeof fn === "function";
};
var $281dc9c55b9413ad$var$isSSR = function() {
    return typeof window === "undefined";
};
var $281dc9c55b9413ad$var$isDOMElement = function(element) {
    return element instanceof Element || element instanceof HTMLDocument;
};
var $281dc9c55b9413ad$var$createNotifier = function(onResize, setSize, handleWidth, handleHeight) {
    return function(_a) {
        var width = _a.width, height = _a.height;
        setSize(function(prev) {
            if (prev.width === width && prev.height === height) // skip if dimensions haven't changed
            return prev;
            if (prev.width === width && !handleHeight || prev.height === height && !handleWidth) // process `handleHeight/handleWidth` props
            return prev;
            if (onResize && $281dc9c55b9413ad$var$isFunction(onResize)) onResize(width, height);
            return {
                width: width,
                height: height
            };
        });
    };
};
var $281dc9c55b9413ad$export$2e2bcd8739ae039 = /** @class */ function(_super) {
    $281dc9c55b9413ad$var$__extends(ResizeDetector, _super);
    function ResizeDetector(props) {
        var _this = _super.call(this, props) || this;
        _this.cancelHandler = function() {
            if (_this.resizeHandler && _this.resizeHandler.cancel) {
                // cancel debounced handler
                _this.resizeHandler.cancel();
                _this.resizeHandler = null;
            }
        };
        _this.attachObserver = function() {
            var _a = _this.props, targetRef = _a.targetRef, observerOptions = _a.observerOptions;
            if ($281dc9c55b9413ad$var$isSSR()) return;
            if (targetRef && targetRef.current) _this.targetRef.current = targetRef.current;
            var element = _this.getElement();
            if (!element) // can't find element to observe
            return;
            if (_this.observableElement && _this.observableElement === element) // element is already observed
            return;
            _this.observableElement = element;
            _this.resizeObserver.observe(element, observerOptions);
        };
        _this.getElement = function() {
            var _a = _this.props, querySelector = _a.querySelector, targetDomEl = _a.targetDomEl;
            if ($281dc9c55b9413ad$var$isSSR()) return null;
            // in case we pass a querySelector
            if (querySelector) return document.querySelector(querySelector);
            // in case we pass a DOM element
            if (targetDomEl && $281dc9c55b9413ad$var$isDOMElement(targetDomEl)) return targetDomEl;
            // in case we pass a React ref using React.createRef()
            if (_this.targetRef && $281dc9c55b9413ad$var$isDOMElement(_this.targetRef.current)) return _this.targetRef.current;
            // the worse case when we don't receive any information from the parent and the library doesn't add any wrappers
            // we have to use a deprecated `findDOMNode` method in order to find a DOM element to attach to
            var currentElement = (0, $jH4WR.findDOMNode)(_this);
            if (!currentElement) return null;
            var renderType = _this.getRenderType();
            switch(renderType){
                case "renderProp":
                    return currentElement;
                case "childFunction":
                    return currentElement;
                case "child":
                    return currentElement;
                case "childArray":
                    return currentElement;
                default:
                    return currentElement.parentElement;
            }
        };
        _this.createResizeHandler = function(entries) {
            var _a = _this.props, _b = _a.handleWidth, handleWidth = _b === void 0 ? true : _b, _c = _a.handleHeight, handleHeight = _c === void 0 ? true : _c, onResize = _a.onResize;
            if (!handleWidth && !handleHeight) return;
            var notifyResize = $281dc9c55b9413ad$var$createNotifier(onResize, _this.setState.bind(_this), handleWidth, handleHeight);
            entries.forEach(function(entry) {
                var _a = entry && entry.contentRect || {}, width = _a.width, height = _a.height;
                var shouldSetSize = !_this.skipOnMount && !$281dc9c55b9413ad$var$isSSR();
                if (shouldSetSize) notifyResize({
                    width: width,
                    height: height
                });
                _this.skipOnMount = false;
            });
        };
        _this.getRenderType = function() {
            var _a = _this.props, render = _a.render, children = _a.children;
            if ($281dc9c55b9413ad$var$isFunction(render)) // DEPRECATED. Use `Child Function Pattern` instead
            return "renderProp";
            if ($281dc9c55b9413ad$var$isFunction(children)) return "childFunction";
            if ((0, $jC8Vy.isValidElement)(children)) return "child";
            if (Array.isArray(children)) // DEPRECATED. Wrap children with a single parent
            return "childArray";
            // DEPRECATED. Use `Child Function Pattern` instead
            return "parent";
        };
        var skipOnMount = props.skipOnMount, refreshMode = props.refreshMode, _a = props.refreshRate, refreshRate = _a === void 0 ? 1000 : _a, refreshOptions = props.refreshOptions;
        _this.state = {
            width: undefined,
            height: undefined
        };
        _this.skipOnMount = skipOnMount;
        _this.targetRef = (0, $jC8Vy.createRef)();
        _this.observableElement = null;
        if ($281dc9c55b9413ad$var$isSSR()) return _this;
        _this.resizeHandler = $281dc9c55b9413ad$var$patchResizeHandler(_this.createResizeHandler, refreshMode, refreshRate, refreshOptions);
        _this.resizeObserver = new window.ResizeObserver(_this.resizeHandler);
        return _this;
    }
    ResizeDetector.prototype.componentDidMount = function() {
        this.attachObserver();
    };
    ResizeDetector.prototype.componentDidUpdate = function() {
        this.attachObserver();
    };
    ResizeDetector.prototype.componentWillUnmount = function() {
        if ($281dc9c55b9413ad$var$isSSR()) return;
        this.observableElement = null;
        this.resizeObserver.disconnect();
        this.cancelHandler();
    };
    ResizeDetector.prototype.render = function() {
        var _a = this.props, render = _a.render, children = _a.children, _b = _a.nodeType, WrapperTag = _b === void 0 ? "div" : _b;
        var _c = this.state, width = _c.width, height = _c.height;
        var childProps = {
            width: width,
            height: height,
            targetRef: this.targetRef
        };
        var renderType = this.getRenderType();
        var typedChildren;
        switch(renderType){
            case "renderProp":
                return render && render(childProps);
            case "childFunction":
                typedChildren = children;
                return typedChildren(childProps);
            case "child":
                // @TODO bug prone logic
                typedChildren = children;
                if (typedChildren.type && typeof typedChildren.type === "string") {
                    // child is a native DOM elements such as div, span etc
                    childProps.targetRef;
                    var nativeProps = $281dc9c55b9413ad$var$__rest(childProps, [
                        "targetRef"
                    ]);
                    return (0, $jC8Vy.cloneElement)(typedChildren, nativeProps);
                }
                // class or functional component otherwise
                return (0, $jC8Vy.cloneElement)(typedChildren, childProps);
            case "childArray":
                typedChildren = children;
                return typedChildren.map(function(el) {
                    return !!el && (0, $jC8Vy.cloneElement)(el, childProps);
                });
            default:
                return $jC8Vy.createElement(WrapperTag, null);
        }
    };
    return ResizeDetector;
}((0, $jC8Vy.PureComponent));
function $281dc9c55b9413ad$export$fa0519968090da40(ComponentInner, options) {
    if (options === void 0) options = {};
    var ResizeDetectorHOC = /** @class */ function(_super) {
        $281dc9c55b9413ad$var$__extends(ResizeDetectorHOC, _super);
        function ResizeDetectorHOC() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.ref = (0, $jC8Vy.createRef)();
            return _this;
        }
        ResizeDetectorHOC.prototype.render = function() {
            var _a = this.props, forwardedRef = _a.forwardedRef, rest = $281dc9c55b9413ad$var$__rest(_a, [
                "forwardedRef"
            ]);
            var targetRef = forwardedRef !== null && forwardedRef !== void 0 ? forwardedRef : this.ref;
            return $jC8Vy.createElement($281dc9c55b9413ad$export$2e2bcd8739ae039, $281dc9c55b9413ad$var$__assign({}, options, {
                targetRef: targetRef
            }), $jC8Vy.createElement(ComponentInner, $281dc9c55b9413ad$var$__assign({
                targetRef: targetRef
            }, rest)));
        };
        return ResizeDetectorHOC;
    }((0, $jC8Vy.Component));
    function forwardRefWrapper(props, ref) {
        return $jC8Vy.createElement(ResizeDetectorHOC, $281dc9c55b9413ad$var$__assign({}, props, {
            forwardedRef: ref
        }));
    }
    var name = ComponentInner.displayName || ComponentInner.name;
    forwardRefWrapper.displayName = "withResizeDetector(".concat(name, ")");
    return (0, $jC8Vy.forwardRef)(forwardRefWrapper);
}
var $281dc9c55b9413ad$var$useEnhancedEffect = $281dc9c55b9413ad$var$isSSR() ? (0, $jC8Vy.useEffect) : (0, $jC8Vy.useLayoutEffect);
function $281dc9c55b9413ad$export$453c3d1cba18d800(props) {
    if (props === void 0) props = {};
    var _a = props.skipOnMount, skipOnMount = _a === void 0 ? false : _a, refreshMode = props.refreshMode, _b = props.refreshRate, refreshRate = _b === void 0 ? 1000 : _b, refreshOptions = props.refreshOptions, _c = props.handleWidth, handleWidth = _c === void 0 ? true : _c, _d = props.handleHeight, handleHeight = _d === void 0 ? true : _d, targetRef = props.targetRef, observerOptions = props.observerOptions, onResize = props.onResize;
    var skipResize = (0, $jC8Vy.useRef)(skipOnMount);
    var localRef = (0, $jC8Vy.useRef)(null);
    var ref = targetRef !== null && targetRef !== void 0 ? targetRef : localRef;
    var resizeHandler = (0, $jC8Vy.useRef)();
    var _e = (0, $jC8Vy.useState)({
        width: undefined,
        height: undefined
    }), size = _e[0], setSize = _e[1];
    $281dc9c55b9413ad$var$useEnhancedEffect(function() {
        if ($281dc9c55b9413ad$var$isSSR()) return;
        var notifyResize = $281dc9c55b9413ad$var$createNotifier(onResize, setSize, handleWidth, handleHeight);
        var resizeCallback = function(entries) {
            if (!handleWidth && !handleHeight) return;
            entries.forEach(function(entry) {
                var _a = entry && entry.contentRect || {}, width = _a.width, height = _a.height;
                var shouldSetSize = !skipResize.current && !$281dc9c55b9413ad$var$isSSR();
                if (shouldSetSize) notifyResize({
                    width: width,
                    height: height
                });
                skipResize.current = false;
            });
        };
        resizeHandler.current = $281dc9c55b9413ad$var$patchResizeHandler(resizeCallback, refreshMode, refreshRate, refreshOptions);
        var resizeObserver = new window.ResizeObserver(resizeHandler.current);
        if (ref.current) // Something wrong with typings here...
        resizeObserver.observe(ref.current, observerOptions);
        return function() {
            resizeObserver.disconnect();
            var patchedResizeHandler = resizeHandler.current;
            if (patchedResizeHandler && patchedResizeHandler.cancel) patchedResizeHandler.cancel();
        };
    }, [
        refreshMode,
        refreshRate,
        refreshOptions,
        handleWidth,
        handleHeight,
        onResize,
        observerOptions,
        ref.current
    ]);
    return $281dc9c55b9413ad$var$__assign({
        ref: ref
    }, size);
}




function $7a37d1810b6110b6$var$_extends() {
    $7a37d1810b6110b6$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7a37d1810b6110b6$var$_extends.apply(this, arguments);
}
function $7a37d1810b6110b6$var$_slicedToArray(arr, i) {
    return $7a37d1810b6110b6$var$_arrayWithHoles(arr) || $7a37d1810b6110b6$var$_iterableToArrayLimit(arr, i) || $7a37d1810b6110b6$var$_unsupportedIterableToArray(arr, i) || $7a37d1810b6110b6$var$_nonIterableRest();
}
function $7a37d1810b6110b6$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7a37d1810b6110b6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7a37d1810b6110b6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7a37d1810b6110b6$var$_arrayLikeToArray(o, minLen);
}
function $7a37d1810b6110b6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $7a37d1810b6110b6$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $7a37d1810b6110b6$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $7a37d1810b6110b6$export$e60a4704009a0009 = /*#__PURE__*/ (0, $jC8Vy.forwardRef)(function(_ref, ref) {
    var aspect = _ref.aspect, _ref$width = _ref.width, width = _ref$width === void 0 ? "100%" : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? "100%" : _ref$height, minWidth = _ref.minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, children = _ref.children, _ref$debounce = _ref.debounce, debounce = _ref$debounce === void 0 ? 0 : _ref$debounce, id = _ref.id, className = _ref.className;
    var _useState = (0, $jC8Vy.useState)({
        containerWidth: -1,
        containerHeight: -1
    }), _useState2 = $7a37d1810b6110b6$var$_slicedToArray(_useState, 2), sizes = _useState2[0], setSizes = _useState2[1];
    var containerRef = (0, $jC8Vy.useRef)(null);
    (0, $jC8Vy.useImperativeHandle)(ref, function() {
        return containerRef;
    }, [
        containerRef
    ]);
    var _useState3 = (0, $jC8Vy.useState)(false), _useState4 = $7a37d1810b6110b6$var$_slicedToArray(_useState3, 2), mounted = _useState4[0], setMounted = _useState4[1];
    var getContainerSize = function getContainerSize() {
        if (!containerRef.current) return null;
        return {
            containerWidth: containerRef.current.clientWidth,
            containerHeight: containerRef.current.clientHeight
        };
    };
    var updateDimensionsImmediate = function updateDimensionsImmediate() {
        if (!mounted) return;
        var newSize = getContainerSize();
        if (newSize) {
            var oldWidth = sizes.containerWidth, oldHeight = sizes.containerHeight;
            var containerWidth = newSize.containerWidth, containerHeight = newSize.containerHeight;
            if (containerWidth !== oldWidth || containerHeight !== oldHeight) setSizes({
                containerWidth: containerWidth,
                containerHeight: containerHeight
            });
        }
    };
    var handleResize = debounce > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($fb12e5fdec2a8cfe$exports)))(updateDimensionsImmediate, debounce) : updateDimensionsImmediate;
    var renderChart = function renderChart() {
        var containerWidth = sizes.containerWidth, containerHeight = sizes.containerHeight;
        if (containerWidth < 0 || containerHeight < 0) return null;
        (0, $2a9fb8012300d38c$export$c106dd0671a0fc2d)((0, $804fab7e7cc9eb97$export$e50269385c77c348)(width) || (0, $804fab7e7cc9eb97$export$e50269385c77c348)(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
        (0, $2a9fb8012300d38c$export$c106dd0671a0fc2d)(!aspect || aspect > 0, "The aspect(%s) must be greater than zero.", aspect);
        var calculatedWidth = (0, $804fab7e7cc9eb97$export$e50269385c77c348)(width) ? containerWidth : width;
        var calculatedHeight = (0, $804fab7e7cc9eb97$export$e50269385c77c348)(height) ? containerHeight : height;
        if (aspect && aspect > 0) {
            // Preserve the desired aspect ratio
            if (calculatedWidth) // Will default to using width for aspect ratio
            calculatedHeight = calculatedWidth / aspect;
            else if (calculatedHeight) // But we should also take height into consideration
            calculatedWidth = calculatedHeight * aspect;
             // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
            if (maxHeight && calculatedHeight > maxHeight) calculatedHeight = maxHeight;
        }
        (0, $2a9fb8012300d38c$export$c106dd0671a0fc2d)(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
        return /*#__PURE__*/ (0, $jC8Vy.cloneElement)(children, {
            width: calculatedWidth,
            height: calculatedHeight
        });
    };
    (0, $jC8Vy.useEffect)(function() {
        if (mounted) {
            var size = getContainerSize();
            if (size) setSizes(size);
        }
    }, [
        mounted
    ]);
    (0, $jC8Vy.useEffect)(function() {
        setMounted(true);
    }, []);
    var style = {
        width: width,
        height: height,
        minWidth: minWidth,
        minHeight: minHeight,
        maxHeight: maxHeight
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement((0, $281dc9c55b9413ad$export$2e2bcd8739ae039), {
        handleWidth: true,
        handleHeight: true,
        onResize: handleResize,
        targetRef: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", $7a37d1810b6110b6$var$_extends({}, id != null ? {
        id: "".concat(id)
    } : {}, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))("recharts-responsive-container", className),
        style: style,
        ref: containerRef
    }), renderChart()));
});



var $voszV = parcelRequire("voszV");


var $5TsIB = parcelRequire("5TsIB");

var $gC7hG = parcelRequire("gC7hG");

var $fmHmG = parcelRequire("fmHmG");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $5UrGx = parcelRequire("5UrGx");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $7b32a692a910236d$var$SvgArrowDown = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "m14.758 10.588-4.167 4.167a.835.835 0 0 1-.275.175.834.834 0 0 1-.633 0 .835.835 0 0 1-.275-.175L5.24 10.588a.837.837 0 1 1 1.184-1.183l2.741 2.75V5.83a.833.833 0 1 1 1.667 0v6.325l2.742-2.75a.833.833 0 0 1 1.183 0 .833.833 0 0 1 0 1.183Z",
            fill: "currentColor"
        })
    });
var $7b32a692a910236d$export$2e2bcd8739ae039 = $7b32a692a910236d$var$SvgArrowDown;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $ddf03bd4c039315a$var$SvgArrowUp = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M14.758 9.412 10.59 5.245a.834.834 0 0 0-.275-.175.833.833 0 0 0-.633 0 .833.833 0 0 0-.275.175L5.24 9.412a.837.837 0 1 0 1.184 1.183l2.741-2.75v6.325a.833.833 0 0 0 1.667 0V7.845l2.742 2.75a.833.833 0 0 0 1.183 0 .832.832 0 0 0 0-1.183Z",
            fill: "currentColor"
        })
    });
var $ddf03bd4c039315a$export$2e2bcd8739ae039 = $ddf03bd4c039315a$var$SvgArrowUp;



var $lf8OC = parcelRequire("lf8OC");

var $gC7hG = parcelRequire("gC7hG");

var $66ixW = parcelRequire("66ixW");

var $75SRw = parcelRequire("75SRw");
parcelRequire("fIF1D");
var $2LaLj = parcelRequire("2LaLj");
const $bbf813c7af1c3c88$export$6a7c5d109b9a49cf = (value)=>value.toString().replaceAll(/\B(?=(\d{3})+(?!\d))/g, ",");


var $528dced16de1d8b1$exports = {};

$parcel$export($528dced16de1d8b1$exports, "block", function () { return $528dced16de1d8b1$export$837bd02682cd3db9; }, function (v) { return $528dced16de1d8b1$export$837bd02682cd3db9 = v; });
$parcel$export($528dced16de1d8b1$exports, "bordered", function () { return $528dced16de1d8b1$export$ecb9dc282039f854; }, function (v) { return $528dced16de1d8b1$export$ecb9dc282039f854 = v; });
$parcel$export($528dced16de1d8b1$exports, "content", function () { return $528dced16de1d8b1$export$a7db06668cad9adb; }, function (v) { return $528dced16de1d8b1$export$a7db06668cad9adb = v; });
$parcel$export($528dced16de1d8b1$exports, "delta", function () { return $528dced16de1d8b1$export$eabbe41f409ce55b; }, function (v) { return $528dced16de1d8b1$export$eabbe41f409ce55b = v; });
$parcel$export($528dced16de1d8b1$exports, "down", function () { return $528dced16de1d8b1$export$5df884bdba3ad6a1; }, function (v) { return $528dced16de1d8b1$export$5df884bdba3ad6a1 = v; });
$parcel$export($528dced16de1d8b1$exports, "number", function () { return $528dced16de1d8b1$export$98e628dec113755e; }, function (v) { return $528dced16de1d8b1$export$98e628dec113755e = v; });
$parcel$export($528dced16de1d8b1$exports, "plain", function () { return $528dced16de1d8b1$export$58d971314ad6cab; }, function (v) { return $528dced16de1d8b1$export$58d971314ad6cab = v; });
$parcel$export($528dced16de1d8b1$exports, "rotating", function () { return $528dced16de1d8b1$export$bfd64c937657f93a; }, function (v) { return $528dced16de1d8b1$export$bfd64c937657f93a = v; });
$parcel$export($528dced16de1d8b1$exports, "shimmer", function () { return $528dced16de1d8b1$export$4a6dd88bada4e7d2; }, function (v) { return $528dced16de1d8b1$export$4a6dd88bada4e7d2 = v; });
$parcel$export($528dced16de1d8b1$exports, "title", function () { return $528dced16de1d8b1$export$fb184b623420d9be; }, function (v) { return $528dced16de1d8b1$export$fb184b623420d9be = v; });
$parcel$export($528dced16de1d8b1$exports, "toggleTipButton", function () { return $528dced16de1d8b1$export$d7648c09dd2d912c; }, function (v) { return $528dced16de1d8b1$export$d7648c09dd2d912c = v; });
var $528dced16de1d8b1$export$837bd02682cd3db9;
var $528dced16de1d8b1$export$ecb9dc282039f854;
var $528dced16de1d8b1$export$a7db06668cad9adb;
var $528dced16de1d8b1$export$eabbe41f409ce55b;
var $528dced16de1d8b1$export$5df884bdba3ad6a1;
var $528dced16de1d8b1$export$98e628dec113755e;
var $528dced16de1d8b1$export$58d971314ad6cab;
var $528dced16de1d8b1$export$bfd64c937657f93a;
var $528dced16de1d8b1$export$4a6dd88bada4e7d2;
var $528dced16de1d8b1$export$fb184b623420d9be;
var $528dced16de1d8b1$export$d7648c09dd2d912c;
$528dced16de1d8b1$export$837bd02682cd3db9 = `bk57eW_block`;
$528dced16de1d8b1$export$ecb9dc282039f854 = `bk57eW_bordered`;
$528dced16de1d8b1$export$a7db06668cad9adb = `bk57eW_content`;
$528dced16de1d8b1$export$eabbe41f409ce55b = `bk57eW_delta`;
$528dced16de1d8b1$export$5df884bdba3ad6a1 = `bk57eW_down`;
$528dced16de1d8b1$export$98e628dec113755e = `bk57eW_number`;
$528dced16de1d8b1$export$58d971314ad6cab = `bk57eW_plain`;
$528dced16de1d8b1$export$bfd64c937657f93a = `bk57eW_rotating`;
$528dced16de1d8b1$export$4a6dd88bada4e7d2 = `bk57eW_shimmer`;
$528dced16de1d8b1$export$fb184b623420d9be = `bk57eW_title`;
$528dced16de1d8b1$export$d7648c09dd2d912c = `bk57eW_toggleTipButton`;


function $dbca1ce8c90a759a$var$Block({ variant: variant = "default", count: count, delta: delta, title: title, tip: tip }) {
    const deltaLabel = delta !== undefined && `${(0, $7oDSS.conditionalString)(delta >= 0 && "+")}${delta}`;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($528dced16de1d8b1$exports.block, $528dced16de1d8b1$exports[variant]),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $528dced16de1d8b1$exports.title,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                        forKey: title
                    }),
                    tip && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2LaLj.default), {
                        anchorClassName: $528dced16de1d8b1$exports.toggleTipButton,
                        content: tip,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                            size: "small",
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $lf8OC.default), {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $528dced16de1d8b1$exports.content,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $528dced16de1d8b1$exports.number,
                        children: (0, $bbf813c7af1c3c88$export$6a7c5d109b9a49cf)(count)
                    }),
                    delta !== undefined && /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($528dced16de1d8b1$exports.delta, delta < 0 && $528dced16de1d8b1$exports.down),
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsxs)("span", {
                                children: [
                                    "(",
                                    deltaLabel,
                                    ")"
                                ]
                            }),
                            delta > 0 && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ddf03bd4c039315a$export$2e2bcd8739ae039), {}),
                            delta < 0 && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7b32a692a910236d$export$2e2bcd8739ae039), {})
                        ]
                    })
                ]
            })
        ]
    });
}
var $dbca1ce8c90a759a$export$2e2bcd8739ae039 = $dbca1ce8c90a759a$var$Block;



var $C7mD2 = parcelRequire("C7mD2");

var $6e1c2d2aa38bb9c7$export$206ef41b79261bbb;
var $6e1c2d2aa38bb9c7$export$1237798dc640739a;
var $6e1c2d2aa38bb9c7$export$bfd64c937657f93a;
var $6e1c2d2aa38bb9c7$export$4a6dd88bada4e7d2;
var $6e1c2d2aa38bb9c7$export$2ab9a8f9f1186f14;
$6e1c2d2aa38bb9c7$export$206ef41b79261bbb = `hGh_LW_chartTooltip`;
$6e1c2d2aa38bb9c7$export$1237798dc640739a = `hGh_LW_label`;
$6e1c2d2aa38bb9c7$export$bfd64c937657f93a = `hGh_LW_rotating`;
$6e1c2d2aa38bb9c7$export$4a6dd88bada4e7d2 = `hGh_LW_shimmer`;
$6e1c2d2aa38bb9c7$export$2ab9a8f9f1186f14 = `hGh_LW_value`;


function $dd010b00d9464c3b$var$ChartTooltip({ label: label, payload: payload }) {
    if (!label || !payload?.[0]) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $6e1c2d2aa38bb9c7$export$206ef41b79261bbb,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $6e1c2d2aa38bb9c7$export$2ab9a8f9f1186f14,
                children: (0, $bbf813c7af1c3c88$export$6a7c5d109b9a49cf)(payload[0].payload.count)
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $6e1c2d2aa38bb9c7$export$1237798dc640739a,
                children: label
            })
        ]
    });
}
var $dd010b00d9464c3b$export$2e2bcd8739ae039 = $dd010b00d9464c3b$var$ChartTooltip;



var $C7mD2 = parcelRequire("C7mD2");

var $gC7hG = parcelRequire("gC7hG");
var $825ae7fcc89e9b17$export$ff43767a4f1fa449;
var $825ae7fcc89e9b17$export$837bd02682cd3db9;
var $825ae7fcc89e9b17$export$12a40731da9c9684;
var $825ae7fcc89e9b17$export$c05cc7140eecf824;
var $825ae7fcc89e9b17$export$d224e3b3d2a2842c;
var $825ae7fcc89e9b17$export$98e628dec113755e;
var $825ae7fcc89e9b17$export$bfd64c937657f93a;
var $825ae7fcc89e9b17$export$4a6dd88bada4e7d2;
var $825ae7fcc89e9b17$export$fb184b623420d9be;
$825ae7fcc89e9b17$export$ff43767a4f1fa449 = `grVxOq_activeBlocks`;
$825ae7fcc89e9b17$export$837bd02682cd3db9 = `grVxOq_block`;
$825ae7fcc89e9b17$export$12a40731da9c9684 = `grVxOq_blocks`;
$825ae7fcc89e9b17$export$c05cc7140eecf824 = `grVxOq_curve`;
$825ae7fcc89e9b17$export$d224e3b3d2a2842c = `grVxOq_dau`;
$825ae7fcc89e9b17$export$98e628dec113755e = `grVxOq_number`;
$825ae7fcc89e9b17$export$bfd64c937657f93a = `grVxOq_rotating`;
$825ae7fcc89e9b17$export$4a6dd88bada4e7d2 = `grVxOq_shimmer`;
$825ae7fcc89e9b17$export$4a6dd88bada4e7d2;
$825ae7fcc89e9b17$export$fb184b623420d9be = `grVxOq_title`;


function $c445851d4fb09f65$var$Skeleton() {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $825ae7fcc89e9b17$export$12a40731da9c9684,
                children: [
                    ...Array.from({
                        length: 3
                    }).keys()
                ].map((index)=>/*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
                        className: $825ae7fcc89e9b17$export$837bd02682cd3db9,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $825ae7fcc89e9b17$export$fb184b623420d9be
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $825ae7fcc89e9b17$export$98e628dec113755e
                            })
                        ]
                    }, index))
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $825ae7fcc89e9b17$export$d224e3b3d2a2842c,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $825ae7fcc89e9b17$export$fb184b623420d9be
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $825ae7fcc89e9b17$export$98e628dec113755e
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $825ae7fcc89e9b17$export$c05cc7140eecf824
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $825ae7fcc89e9b17$export$ff43767a4f1fa449,
                        children: [
                            ...Array.from({
                                length: 2
                            }).keys()
                        ].map((index)=>/*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
                                className: $825ae7fcc89e9b17$export$837bd02682cd3db9,
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $825ae7fcc89e9b17$export$fb184b623420d9be
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $825ae7fcc89e9b17$export$98e628dec113755e
                                    })
                                ]
                            }, index))
                    })
                ]
            })
        ]
    });
}
var $c445851d4fb09f65$export$2e2bcd8739ae039 = $c445851d4fb09f65$var$Skeleton;


var $82d6141a1c36e754$export$ffb9aadaab235117;
var $82d6141a1c36e754$export$12a40731da9c9684;
var $82d6141a1c36e754$export$34e0f9847d4c02dd;
var $82d6141a1c36e754$export$c05cc7140eecf824;
var $82d6141a1c36e754$export$a727d6cd3f21b50b;
var $82d6141a1c36e754$export$38e42c68cf43b5d4;
var $82d6141a1c36e754$export$bfd64c937657f93a;
var $82d6141a1c36e754$export$4a6dd88bada4e7d2;
var $82d6141a1c36e754$export$c96745152eb2740f;
var $82d6141a1c36e754$export$fb184b623420d9be;
$82d6141a1c36e754$export$ffb9aadaab235117 = `aADheW_activeCard`;
$82d6141a1c36e754$export$12a40731da9c9684 = `aADheW_blocks`;
$82d6141a1c36e754$export$34e0f9847d4c02dd = `aADheW_container`;
$82d6141a1c36e754$export$c05cc7140eecf824 = `aADheW_curve`;
$82d6141a1c36e754$export$a727d6cd3f21b50b = `aADheW_datePicker`;
$82d6141a1c36e754$export$38e42c68cf43b5d4 = `aADheW_header`;
$82d6141a1c36e754$export$bfd64c937657f93a = `aADheW_rotating`;
$82d6141a1c36e754$export$4a6dd88bada4e7d2 = `aADheW_shimmer`;
$82d6141a1c36e754$export$c96745152eb2740f = `aADheW_subtitle`;
$82d6141a1c36e754$export$fb184b623420d9be = `aADheW_title`;


const $6f42ee3417378e11$var$tickStyle = {
    fill: "var(--color-text-secondary)",
    fontSize: 11,
    fontFamily: "var(--font-family)"
};
const $6f42ee3417378e11$var$tickFormatter = new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 1,
    notation: "compact"
});
function $6f42ee3417378e11$var$Dashboard() {
    const [date, setDate] = (0, $jC8Vy.useState)((0, $9aa0641d843cb9a1$export$2e2bcd8739ae039)(Date.now(), "yyyy-MM-dd"));
    const { data: totalData, error: totalError } = (0, $voszV.default)("api/dashboard/users/total");
    const { data: newData, error: newError } = (0, $voszV.default)("api/dashboard/users/new");
    const { data: activeData, error: activeError } = (0, $voszV.default)(`api/dashboard/users/active?date=${date}`);
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    // Pick an error as the page's error
    const error = totalError ?? newError ?? activeError;
    const isLoading = (!totalData || !newData || !activeData) && !error;
    const handleDateChange = (event)=>{
        setDate(event.target.value);
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $82d6141a1c36e754$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5TsIB.default), {
                titleKey: "dashboard.title"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $82d6141a1c36e754$export$38e42c68cf43b5d4,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $82d6141a1c36e754$export$fb184b623420d9be,
                        children: t("dashboard.title")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $82d6141a1c36e754$export$c96745152eb2740f,
                        children: t("dashboard.description")
                    })
                ]
            }),
            isLoading && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c445851d4fb09f65$export$2e2bcd8739ae039), {}),
            error && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6b7de14b6bd7147f$export$2e2bcd8739ae039), {
                errorMessage: error.body?.message
            }),
            !isLoading && totalData && newData && activeData && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $82d6141a1c36e754$export$12a40731da9c9684,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dbca1ce8c90a759a$export$2e2bcd8739ae039), {
                                title: "dashboard.total_users",
                                tip: t("dashboard.total_users_tip"),
                                count: totalData.totalUserCount
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dbca1ce8c90a759a$export$2e2bcd8739ae039), {
                                title: "dashboard.new_users_today",
                                tip: t("dashboard.new_users_today_tip"),
                                count: newData.today.count,
                                delta: newData.today.delta
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dbca1ce8c90a759a$export$2e2bcd8739ae039), {
                                title: "dashboard.new_users_7_days",
                                tip: t("dashboard.new_users_7_days_tip"),
                                count: newData.last7Days.count,
                                delta: newData.last7Days.delta
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
                        className: $82d6141a1c36e754$export$ffb9aadaab235117,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dbca1ce8c90a759a$export$2e2bcd8739ae039), {
                                title: "dashboard.daily_active_users",
                                tip: t("dashboard.daily_active_users_tip"),
                                count: activeData.dau.count,
                                delta: activeData.dau.delta,
                                variant: "plain"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $82d6141a1c36e754$export$a727d6cd3f21b50b,
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                    type: "date",
                                    value: date,
                                    onChange: handleDateChange
                                })
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $82d6141a1c36e754$export$c05cc7140eecf824,
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7a37d1810b6110b6$export$e60a4704009a0009), {
                                    children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $710db46d899b5603$export$f510429275d6f1a8), {
                                        data: activeData.dauCurve.map((item)=>({
                                                ...item,
                                                // Remove "year" for a compact label.
                                                date: item.date.replace(/\d{4}-/, "")
                                            })),
                                        width: 1100,
                                        height: 168,
                                        children: [
                                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0367c217dc0c3235$export$6440e27b9f186856), {
                                                vertical: false,
                                                stroke: "var(--color-divider)"
                                            }),
                                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fa5d459f96aa6e1d$export$ea1a111407f37557), {
                                                type: "monotone",
                                                dataKey: "count",
                                                stroke: "var(--color-primary)",
                                                strokeWidth: 2,
                                                fill: "var(--color-hover-variant)"
                                            }),
                                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $93c866c346f0ff3f$export$ea77231de273b52d), {
                                                dataKey: "date",
                                                tickLine: false,
                                                tick: $6f42ee3417378e11$var$tickStyle
                                            }),
                                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $96778e5623835b0a$export$f96c4024c52de8f4), {
                                                width: 35,
                                                axisLine: false,
                                                tickLine: false,
                                                tick: $6f42ee3417378e11$var$tickStyle,
                                                tickFormatter: (tick)=>$6f42ee3417378e11$var$tickFormatter.format(Number(tick)).toLowerCase()
                                            }),
                                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $def5cb6e7a67bb87$export$28c660c63b792dea), {
                                                content: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dd010b00d9464c3b$export$2e2bcd8739ae039), {}),
                                                cursor: {
                                                    stroke: "var(--color-primary"
                                                }
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                className: $82d6141a1c36e754$export$12a40731da9c9684,
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dbca1ce8c90a759a$export$2e2bcd8739ae039), {
                                        title: "dashboard.weekly_active_users",
                                        tip: t("dashboard.weekly_active_users_tip"),
                                        count: activeData.wau.count,
                                        delta: activeData.wau.delta,
                                        variant: "bordered"
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dbca1ce8c90a759a$export$2e2bcd8739ae039), {
                                        title: "dashboard.monthly_active_users",
                                        tip: t("dashboard.monthly_active_users_tip"),
                                        count: activeData.mau.count,
                                        delta: activeData.mau.delta,
                                        variant: "bordered"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $6f42ee3417378e11$export$2e2bcd8739ae039 = $6f42ee3417378e11$var$Dashboard;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $0e9c330ef0ca550a$var$SvgCheckDemoDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 48,
                height: 48,
                rx: 8,
                fill: "#3A3B59"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 12,
                y: 6,
                width: 20,
                height: 36,
                rx: 4,
                fill: "url(#paint0_linear_4272_17340)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 22,
                cy: 38,
                r: 1.5,
                stroke: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M19 9a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Z",
                fill: "#5938A3"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                opacity: 0.64,
                d: "M42 24c0 1.533-5.373 7-12 7s-12-5.467-12-7c0-1.533 5.373-7 12-7 1.324 0 2.598.218 3.79.58A15.75 15.75 0 0 1 37 18.973c3.028 1.726 5 4.099 5 5.027Z",
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 30,
                cy: 24,
                r: 4,
                fill: "#302F38"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 33,
                cy: 24,
                r: 2,
                fill: "#F07EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 30,
                y: 11,
                width: 1,
                height: 4,
                rx: 0.5,
                fill: "#FFFBF7"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 36.56,
                y: 12.232,
                width: 1,
                height: 4,
                rx: 0.5,
                transform: "rotate(45 36.56 12.232)",
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 1,
                height: 4,
                rx: 0.5,
                transform: "scale(1 -1) rotate(45 32.314 24.177)",
                fill: "#FFFBF7"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("defs", {
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                    id: "paint0_linear_4272_17340",
                    x1: 15.438,
                    y1: 37.125,
                    x2: 36.732,
                    y2: 24.47,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            stopColor: "#5D34F2"
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            offset: 1,
                            stopColor: "#FAABFF"
                        })
                    ]
                })
            })
        ]
    });
var $0e9c330ef0ca550a$export$2e2bcd8739ae039 = $0e9c330ef0ca550a$var$SvgCheckDemoDark;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $b876cba539dbc053$var$SvgCheckDemo = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 48,
                height: 48,
                rx: 8,
                fill: "#F3EFFA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 12,
                y: 6,
                width: 20,
                height: 36,
                rx: 4,
                fill: "url(#paint0_linear_1555_9124)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 22,
                cy: 38,
                r: 1.5,
                stroke: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M19 9a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Z",
                fill: "#302F38"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                opacity: 0.64,
                d: "M42 24c0 1.533-5.373 7-12 7s-12-5.467-12-7c0-1.533 5.373-7 12-7 1.324 0 2.598.218 3.79.58A15.75 15.75 0 0 1 37 18.973c3.028 1.726 5 4.099 5 5.027Z",
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 30,
                cy: 24,
                r: 4,
                fill: "#302F38"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 33,
                cy: 24,
                r: 2,
                fill: "#F07EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 30,
                y: 11,
                width: 1,
                height: 4,
                rx: 0.5,
                fill: "#FFFBF7"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 36.56,
                y: 12.232,
                width: 1,
                height: 4,
                rx: 0.5,
                transform: "rotate(45 36.56 12.232)",
                fill: "#F07EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 1,
                height: 4,
                rx: 0.5,
                transform: "scale(1 -1) rotate(45 32.314 24.177)",
                fill: "#FFFBF7"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("defs", {
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                    id: "paint0_linear_1555_9124",
                    x1: 15.438,
                    y1: 37.125,
                    x2: 36.732,
                    y2: 24.47,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            stopColor: "#5D34F2"
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            offset: 1,
                            stopColor: "#FAABFF"
                        })
                    ]
                })
            })
        ]
    });
var $b876cba539dbc053$export$2e2bcd8739ae039 = $b876cba539dbc053$var$SvgCheckDemo;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $c50dbe7fa70b800f$var$SvgCreateRoleDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                clipPath: "url(#clip0_1820_100266)",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        width: 48,
                        height: 48,
                        rx: 8,
                        fill: "#3A3B59"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 5,
                        y: 5,
                        width: 30.8,
                        height: 30.8,
                        rx: 8,
                        fill: "url(#paint0_linear_1820_100266)",
                        fillOpacity: 0.8
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                        cx: 20.4,
                        cy: 15.781,
                        r: 4.62,
                        fill: "#F5EEFF"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 15.01,
                        y: 14.241,
                        width: 6.16,
                        height: 0.77,
                        rx: 0.385,
                        fill: "#2D2C61"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 22.709,
                        y: 14.241,
                        width: 3.08,
                        height: 0.77,
                        rx: 0.385,
                        fill: "#2D2C61"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M13.47 26.56a4.62 4.62 0 0 1 4.62-4.62h4.62a4.62 4.62 0 0 1 4.62 4.62v1.54c0 .851-.69 1.54-1.54 1.54H15.01c-.85 0-1.54-.689-1.54-1.54v-1.54Z",
                        fill: "#FAABFF"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        opacity: 0.7,
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M34.72 26.634a.77.77 0 0 1 .77-.77h1.54a.77.77 0 0 1 .77.77v1.54h-3.08v-1.54Zm0 17.71c0 .426.345.77.77.77h1.54a.77.77 0 0 0 .77-.77v-1.54h-3.08v1.54Zm-7.315-7.314a.77.77 0 0 1-.77-.77v-1.54a.77.77 0 0 1 .77-.77h1.54v3.08h-1.54Zm17.71 0a.77.77 0 0 0 .77-.77v-1.54a.77.77 0 0 0-.77-.77h-1.54v3.08h1.54ZM28.91 30.317a.77.77 0 0 1 0-1.09l1.088-1.088c.301-.301.789-.301 1.09 0l1.088 1.089-2.178 2.177-1.088-1.088ZM41.432 42.84c.301.3.789.3 1.09 0l1.088-1.09c.3-.3.3-.788 0-1.088l-1.089-1.09-2.178 2.179 1.09 1.089Zm-10.344 0c-.301.3-.789.3-1.09 0l-1.088-1.089a.77.77 0 0 1 0-1.089l1.089-1.089 2.178 2.178-1.09 1.09ZM43.61 30.317c.301-.3.301-.788 0-1.089l-1.089-1.089a.77.77 0 0 0-1.089 0l-1.088 1.09 2.178 2.177 1.088-1.089Z",
                        fill: "#CABEFF"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M36.26 43.191a7.7 7.7 0 1 0 0-15.4 7.7 7.7 0 0 0 0 15.4Zm0-4.62a3.08 3.08 0 1 0 0-6.16 3.08 3.08 0 0 0 0 6.16Z",
                        fill: "url(#paint1_linear_1820_100266)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_1820_100266",
                        x1: 32.5,
                        y1: 7,
                        x2: 4,
                        y2: 40.5,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#5E35F3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F5A7FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_1820_100266",
                        x1: 27.811,
                        y1: 42.091,
                        x2: 42.755,
                        y2: 30.013,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FFF06A"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E54AFE"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("clipPath", {
                        id: "clip0_1820_100266",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                            width: 48,
                            height: 48,
                            rx: 8,
                            fill: "#fff"
                        })
                    })
                ]
            })
        ]
    });
var $c50dbe7fa70b800f$export$2e2bcd8739ae039 = $c50dbe7fa70b800f$var$SvgCreateRoleDark;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $eebf51cb571e115c$var$SvgCreateRole = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                clipPath: "url(#clip0_1724_99135)",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        width: 48,
                        height: 48,
                        rx: 8,
                        fill: "#F3EFFA"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 5,
                        y: 5,
                        width: 30.8,
                        height: 30.8,
                        rx: 8,
                        fill: "url(#paint0_linear_1724_99135)",
                        fillOpacity: 0.8
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                        cx: 20.4,
                        cy: 15.781,
                        r: 4.62,
                        fill: "#F5EEFF"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 15.01,
                        y: 14.241,
                        width: 6.16,
                        height: 0.77,
                        rx: 0.385,
                        fill: "#2D2C61"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 22.709,
                        y: 14.241,
                        width: 3.08,
                        height: 0.77,
                        rx: 0.385,
                        fill: "#2D2C61"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M13.47 26.56a4.62 4.62 0 0 1 4.62-4.62h4.62a4.62 4.62 0 0 1 4.62 4.62v1.54c0 .851-.69 1.54-1.54 1.54H15.01c-.85 0-1.54-.689-1.54-1.54v-1.54Z",
                        fill: "#FAABFF"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        opacity: 0.7,
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M34.72 26.634a.77.77 0 0 1 .77-.77h1.54a.77.77 0 0 1 .77.77v1.54h-3.08v-1.54Zm0 17.71c0 .426.345.77.77.77h1.54a.77.77 0 0 0 .77-.77v-1.54h-3.08v1.54Zm-7.315-7.314a.77.77 0 0 1-.77-.77v-1.54a.77.77 0 0 1 .77-.77h1.54v3.08h-1.54Zm17.71 0a.77.77 0 0 0 .77-.77v-1.54a.77.77 0 0 0-.77-.77h-1.54v3.08h1.54ZM28.91 30.317a.77.77 0 0 1 0-1.09l1.088-1.088c.301-.301.789-.301 1.09 0l1.088 1.089-2.178 2.177-1.088-1.088ZM41.432 42.84c.301.3.789.3 1.09 0l1.088-1.09c.3-.3.3-.788 0-1.088l-1.089-1.09-2.178 2.179 1.09 1.089Zm-10.344 0c-.301.3-.789.3-1.09 0l-1.088-1.089a.77.77 0 0 1 0-1.089l1.089-1.089 2.178 2.178-1.09 1.09ZM43.61 30.317c.301-.3.301-.788 0-1.089l-1.089-1.089a.77.77 0 0 0-1.089 0l-1.088 1.09 2.178 2.177 1.088-1.089Z",
                        fill: "#7958FF"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M36.26 43.191a7.7 7.7 0 1 0 0-15.4 7.7 7.7 0 0 0 0 15.4Zm0-4.62a3.08 3.08 0 1 0 0-6.16 3.08 3.08 0 0 0 0 6.16Z",
                        fill: "url(#paint1_linear_1724_99135)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_1724_99135",
                        x1: 32.5,
                        y1: 7,
                        x2: 4,
                        y2: 40.5,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#5E35F3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F5A7FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_1724_99135",
                        x1: 27.811,
                        y1: 42.091,
                        x2: 42.755,
                        y2: 30.013,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FFF06A"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E54AFE"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("clipPath", {
                        id: "clip0_1724_99135",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                            width: 48,
                            height: 48,
                            rx: 8,
                            fill: "#fff"
                        })
                    })
                ]
            })
        ]
    });
var $eebf51cb571e115c$export$2e2bcd8739ae039 = $eebf51cb571e115c$var$SvgCreateRole;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $968f10368190a6e1$var$SvgSocialDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 48,
                height: 48,
                rx: 8,
                fill: "#3A3B59"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m26 24 3-6m-3 6h2.942a4 4 0 0 0 3.255-1.675l2.606-3.65A4 4 0 0 1 38.06 17H41m-15 7v3m0 0h4.735a4 4 0 0 1 3.43 1.942l.67 1.116A4 4 0 0 0 38.265 32H41m-15-5v5M24 24V9m0 15h-3.718a4 4 0 0 1-2.325-.745l-4.914-3.51A4 4 0 0 0 10.718 19H10m14 5v14m-8-11-4.05 2.43a4 4 0 0 1-2.058.57H7",
                stroke: "#CABEFF",
                strokeWidth: 2,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 24,
                cy: 24,
                r: 12,
                fill: "url(#paint0_linear_4272_17343)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "mask0_4272_17343",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 12,
                y: 12,
                width: 24,
                height: 24,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                    cx: 24,
                    cy: 24,
                    r: 12,
                    fill: "url(#paint1_linear_4272_17343)"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("g", {
                mask: "url(#mask0_4272_17343)",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    d: "M23.508 16a.8.8 0 0 0-.782.63l-.268 1.231a.87.87 0 0 1-.553.617c-.112.042-.221.088-.33.136a.871.871 0 0 1-.828-.045l-1.056-.679a.8.8 0 0 0-.998.108l-.695.695a.8.8 0 0 0-.108.998l.68 1.056c.158.248.165.56.044.829a5.883 5.883 0 0 0-.136.329.87.87 0 0 1-.617.553l-1.23.268a.8.8 0 0 0-.631.782v.984a.8.8 0 0 0 .63.782l1.231.268a.87.87 0 0 1 .617.553c.042.112.088.221.136.33a.871.871 0 0 1-.045.828l-.679 1.056a.8.8 0 0 0 .108.998l.695.695a.8.8 0 0 0 .998.108l1.056-.68a.871.871 0 0 1 .829-.044c.108.048.217.094.329.136a.87.87 0 0 1 .553.617l.268 1.23a.8.8 0 0 0 .782.631h.984a.8.8 0 0 0 .782-.63l.268-1.231a.87.87 0 0 1 .553-.617c.112-.042.221-.088.33-.136a.871.871 0 0 1 .828.045l1.056.679a.8.8 0 0 0 .998-.108l.695-.695a.8.8 0 0 0 .108-.998l-.68-1.056a.871.871 0 0 1-.044-.829c.048-.108.094-.217.136-.329a.87.87 0 0 1 .617-.553l1.23-.268a.8.8 0 0 0 .631-.782v-.984a.8.8 0 0 0-.63-.782l-1.231-.268a.87.87 0 0 1-.617-.553 5.883 5.883 0 0 0-.136-.33.871.871 0 0 1 .045-.828l.679-1.056a.8.8 0 0 0-.108-.998l-.695-.695a.8.8 0 0 0-.998-.108l-1.056.68a.871.871 0 0 1-.829.044 5.883 5.883 0 0 0-.329-.136.87.87 0 0 1-.553-.617l-.268-1.23a.8.8 0 0 0-.782-.631h-.984ZM24 20.571a3.429 3.429 0 1 1 0 6.858 3.429 3.429 0 0 1 0-6.858Z",
                    fill: "#F5EEFF"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 42,
                cy: 17,
                r: 2,
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 7,
                cy: 19,
                r: 3,
                fill: "#83DA85"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 24,
                cy: 7,
                r: 3,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 41,
                cy: 32,
                r: 3,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 7,
                cy: 30,
                r: 3,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 24,
                cy: 41,
                r: 3,
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_4272_17343",
                        x1: 16.125,
                        y1: 32.75,
                        x2: 32.25,
                        y2: 15.5,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAABFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_4272_17343",
                        x1: 16.125,
                        y1: 32.75,
                        x2: 32.25,
                        y2: 15.5,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAABFF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $968f10368190a6e1$export$2e2bcd8739ae039 = $968f10368190a6e1$var$SvgSocialDark;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $486da8ad3ff29fcc$var$SvgSocial = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 48,
                height: 48,
                rx: 8,
                fill: "#F3EFFA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m26 24 3-6m-3 6h2.942a4 4 0 0 0 3.255-1.675l2.606-3.65A4 4 0 0 1 38.06 17H41m-15 7v3m0 0h4.735a4 4 0 0 1 3.43 1.942l.67 1.116A4 4 0 0 0 38.265 32H41m-15-5v5M24 24V9m0 15h-3.718a4 4 0 0 1-2.325-.745l-4.914-3.51A4 4 0 0 0 10.718 19H10m14 5v14m-8-11-4.05 2.43a4 4 0 0 1-2.058.57H7",
                stroke: "#CABEFF",
                strokeWidth: 2,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 24,
                cy: 24,
                r: 12,
                fill: "url(#paint0_linear_1555_9204)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "mask0_1555_9204",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 12,
                y: 12,
                width: 24,
                height: 24,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                    cx: 24,
                    cy: 24,
                    r: 12,
                    fill: "url(#paint1_linear_1555_9204)"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("g", {
                mask: "url(#mask0_1555_9204)",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    d: "M23.508 16a.8.8 0 0 0-.782.63l-.268 1.231a.87.87 0 0 1-.553.617c-.112.042-.221.088-.33.136a.871.871 0 0 1-.828-.045l-1.056-.679a.8.8 0 0 0-.998.108l-.695.695a.8.8 0 0 0-.108.998l.68 1.056c.158.248.165.56.044.829a5.883 5.883 0 0 0-.136.329.87.87 0 0 1-.617.553l-1.23.268a.8.8 0 0 0-.631.782v.984a.8.8 0 0 0 .63.782l1.231.268a.87.87 0 0 1 .617.553c.042.112.088.221.136.33a.871.871 0 0 1-.045.828l-.679 1.056a.8.8 0 0 0 .108.998l.695.695a.8.8 0 0 0 .998.108l1.056-.68a.871.871 0 0 1 .829-.044c.108.048.217.094.329.136a.87.87 0 0 1 .553.617l.268 1.23a.8.8 0 0 0 .782.631h.984a.8.8 0 0 0 .782-.63l.268-1.231a.87.87 0 0 1 .553-.617c.112-.042.221-.088.33-.136a.871.871 0 0 1 .828.045l1.056.679a.8.8 0 0 0 .998-.108l.695-.695a.8.8 0 0 0 .108-.998l-.68-1.056a.871.871 0 0 1-.044-.829c.048-.108.094-.217.136-.329a.87.87 0 0 1 .617-.553l1.23-.268a.8.8 0 0 0 .631-.782v-.984a.8.8 0 0 0-.63-.782l-1.231-.268a.87.87 0 0 1-.617-.553 5.883 5.883 0 0 0-.136-.33.871.871 0 0 1 .045-.828l.679-1.056a.8.8 0 0 0-.108-.998l-.695-.695a.8.8 0 0 0-.998-.108l-1.056.68a.871.871 0 0 1-.829.044 5.883 5.883 0 0 0-.329-.136.87.87 0 0 1-.553-.617l-.268-1.23a.8.8 0 0 0-.782-.631h-.984ZM24 20.571a3.429 3.429 0 1 1 0 6.858 3.429 3.429 0 0 1 0-6.858Z",
                    fill: "#F5EEFF"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 42,
                cy: 17,
                r: 2,
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 7,
                cy: 19,
                r: 3,
                fill: "#83DA85"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 24,
                cy: 7,
                r: 3,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 41,
                cy: 32,
                r: 3,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 7,
                cy: 30,
                r: 3,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 24,
                cy: 41,
                r: 3,
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_1555_9204",
                        x1: 16.125,
                        y1: 32.75,
                        x2: 32.25,
                        y2: 15.5,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAABFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_1555_9204",
                        x1: 16.125,
                        y1: 32.75,
                        x2: 32.25,
                        y2: 15.5,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAABFF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $486da8ad3ff29fcc$export$2e2bcd8739ae039 = $486da8ad3ff29fcc$var$SvgSocial;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");

var $jC8Vy = parcelRequire("jC8Vy");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $kUZ14 = parcelRequire("kUZ14");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");

var $5UrGx = parcelRequire("5UrGx");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $37b2fef0020c87fb$var$SvgManagementApiAccess = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1.333 2.498c0-.46 0-.69.09-.874a.951.951 0 0 1 .363-.398c.18-.11.42-.143.9-.208l6.846-.93c.621-.085.932-.128 1.173-.038a.972.972 0 0 1 .5.411c.128.214.128.512.128 1.107v12.864c0 .595 0 .893-.127 1.107a.972.972 0 0 1-.5.411c-.242.09-.553.047-1.174-.037l-6.845-.93c-.48-.066-.72-.099-.9-.209a.95.95 0 0 1-.365-.398c-.089-.185-.089-.415-.089-.874V2.498Zm7.334 4.338c0-.14 0-.21.023-.265a.263.263 0 0 1 .095-.117c.048-.032.11-.038.234-.05l.558-.057c.147-.015.22-.023.277.005.05.024.09.066.116.12.03.06.03.142.03.307v2.442c0 .165 0 .247-.03.308a.255.255 0 0 1-.116.12c-.057.027-.13.02-.277.004l-.558-.056c-.124-.013-.186-.02-.234-.05a.263.263 0 0 1-.095-.118c-.023-.055-.023-.125-.023-.265V6.836Zm4.548-5.17h-.882v13h.882c.508 0 .762 0 .956-.098a.909.909 0 0 0 .397-.398c.099-.195.099-.45.099-.96V3.124c0-.51 0-.765-.1-.96a.909.909 0 0 0-.396-.397c-.194-.1-.448-.1-.956-.1Z",
            fill: "currentColor"
        })
    });
var $37b2fef0020c87fb$export$2e2bcd8739ae039 = $37b2fef0020c87fb$var$SvgManagementApiAccess;



var $8TpMk = parcelRequire("8TpMk");

var $aqmjm = parcelRequire("aqmjm");

var $1QOtg = parcelRequire("1QOtg");

var $1c26dd25fa3ad36d$export$827f4ee28efc37;
var $1c26dd25fa3ad36d$export$a03f626b8106969c;
var $1c26dd25fa3ad36d$export$eda11a42e6b44edc;
var $1c26dd25fa3ad36d$export$9f6c77b8cdee9051;
var $1c26dd25fa3ad36d$export$34e0f9847d4c02dd;
var $1c26dd25fa3ad36d$export$2d49e08edfff676e;
var $1c26dd25fa3ad36d$export$bfd64c937657f93a;
var $1c26dd25fa3ad36d$export$4a6dd88bada4e7d2;
var $1c26dd25fa3ad36d$export$d999e528e771887b;
$1c26dd25fa3ad36d$export$827f4ee28efc37 = `G_cUGW_box`;
$1c26dd25fa3ad36d$export$a03f626b8106969c = `G_cUGW_boxContent`;
$1c26dd25fa3ad36d$export$eda11a42e6b44edc = `G_cUGW_boxPagination`;
$1c26dd25fa3ad36d$export$9f6c77b8cdee9051 = `G_cUGW_boxTopBar`;
$1c26dd25fa3ad36d$export$34e0f9847d4c02dd = `G_cUGW_container`;
$1c26dd25fa3ad36d$export$2d49e08edfff676e = `G_cUGW_emptyBoxContent`;
$1c26dd25fa3ad36d$export$bfd64c937657f93a = `G_cUGW_rotating`;
$1c26dd25fa3ad36d$export$4a6dd88bada4e7d2 = `G_cUGW_shimmer`;
$1c26dd25fa3ad36d$export$d999e528e771887b = `G_cUGW_verticalBar`;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $voszV = parcelRequire("voszV");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $45ba7f7cad465e3f$var$SvgSearch = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M8 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm9.707 4.293-4.82-4.82A5.968 5.968 0 0 0 14 8 6 6 0 0 0 2 8a6 6 0 0 0 6 6 5.968 5.968 0 0 0 3.473-1.113l4.82 4.82a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414Z",
            fill: "currentColor"
        })
    });
var $45ba7f7cad465e3f$export$2e2bcd8739ae039 = $45ba7f7cad465e3f$var$SvgSearch;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");

var $5UrGx = parcelRequire("5UrGx");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $c431292b825765bf$var$SvgTableEmptyDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M22.5 198h81m13 0h-6",
                stroke: "#4E5075",
                strokeWidth: 4,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M40.815 132.884c0-1.384.957-2.583 2.306-2.89l62.223-14.141a2.969 2.969 0 0 1 1.313 0l62.222 14.141a2.964 2.964 0 0 1 2.307 2.89v63.418a2.964 2.964 0 0 1-2.307 2.889l-62.222 14.141a2.969 2.969 0 0 1-1.313 0l-62.223-14.141a2.963 2.963 0 0 1-2.306-2.889v-63.418Z",
                fill: "#47464E"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M40.815 134.23a2.963 2.963 0 0 1 3.62-2.889l60.909 13.843c.432.098.881.098 1.313 0l60.909-13.843a2.964 2.964 0 0 1 3.62 2.889v62.072a2.964 2.964 0 0 1-2.307 2.889l-62.222 14.141a2.94 2.94 0 0 1-1.313 0l-62.223-14.141a2.963 2.963 0 0 1-2.306-2.889V134.23Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M40.815 134.23v62.072c0 1.383.958 2.582 2.307 2.889L106 213.482v-68.149l-61.566-13.992a2.963 2.963 0 0 0-3.62 2.889Z",
                fill: "url(#paint0_linear_490_14139)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M40.327 132.697a2.221 2.221 0 0 1 2.377-.989l62.115 14.117-13.146 21.034a2.221 2.221 0 0 1-2.377.989L30.23 154.424a2.222 2.222 0 0 1-1.392-3.345l11.489-18.382Z",
                fill: "#CABEFF",
                fillOpacity: 0.16,
                stroke: "url(#paint1_linear_490_14139)",
                strokeWidth: 1.481
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M39.699 128.733a2.964 2.964 0 0 0 3.17 1.319L106 115.704 92.301 93.786a2.963 2.963 0 0 0-3.17-1.32l-59.065 13.425a2.962 2.962 0 0 0-1.856 4.459l11.489 18.383Z",
                fill: "#625881"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M171.673 132.697a2.221 2.221 0 0 0-2.377-.989l-62.115 14.117 13.146 21.034a2.221 2.221 0 0 0 2.377.989l59.066-13.424a2.222 2.222 0 0 0 1.392-3.345l-11.489-18.382Z",
                fill: "#CABEFF",
                fillOpacity: 0.16,
                stroke: "url(#paint2_linear_490_14139)",
                strokeWidth: 1.481
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M172.301 128.733a2.964 2.964 0 0 1-3.169 1.319L106 115.704l13.699-21.918a2.963 2.963 0 0 1 3.169-1.32l59.066 13.425a2.962 2.962 0 0 1 1.856 4.459l-11.489 18.383Z",
                fill: "#625881"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m14.426 132.746 1.114 1.281a1.697 1.697 0 0 0 2.394.167v0a1.697 1.697 0 0 1 2.394.167v0a1.697 1.697 0 0 0 2.395.167l1.28-1.114",
                stroke: "#947DFF",
                strokeWidth: 1.2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M179.289 103.654a3 3 0 0 1 3.899-4.56l10.641 9.098a3 3 0 0 1-3.899 4.561l-10.641-9.099Z",
                fill: "#C4B4E0"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M182.759 102.674c10.049-11.753 8.668-29.428-3.085-39.478s-29.428-8.668-39.478 3.085c-10.049 11.753-8.668 29.428 3.085 39.478 11.753 10.049 29.428 8.668 39.478-3.085Zm-4.56-3.9c7.896-9.234 6.811-23.121-2.424-31.017-9.234-7.897-23.122-6.811-31.018 2.423-7.896 9.235-6.811 23.122 2.424 31.018 9.235 7.897 23.122 6.812 31.018-2.423Z",
                fill: "#DDA8E0"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                opacity: 0.6,
                cx: 161.478,
                cy: 84.478,
                r: 22,
                transform: "rotate(-49.468 161.478 84.478)",
                fill: "#302F38"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                opacity: 0.6,
                d: "M161.458 67.901a15.927 15.927 0 0 0-7.958 2.116M150.436 95.5a16.05 16.05 0 0 1-3.062-4 15.93 15.93 0 0 1-1.916-7.599c0-2.276.475-4.44 1.332-6.401",
                stroke: "#FEE8FF",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 184.94,
                y: 112.433,
                width: 12,
                height: 28,
                rx: 6,
                transform: "rotate(-49.468 184.94 112.433)",
                fill: "#C584D0"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 90.916,
                y: 74.016,
                width: 2,
                height: 4,
                rx: 1,
                transform: "rotate(-21.657 90.916 74.016)",
                fill: "#D7C947"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                cx: 90,
                cy: 69,
                rx: 4,
                ry: 6,
                transform: "rotate(-21.657 90 69)",
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 87.417,
                cy: 62.494,
                r: 2,
                transform: "rotate(-21.657 87.417 62.494)",
                fill: "#6D698D"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                opacity: 0.6,
                cx: 82.004,
                cy: 73.251,
                rx: 6,
                ry: 3,
                transform: "rotate(-37.657 82.004 73.25)",
                fill: "#83DA85"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                opacity: 0.6,
                rx: 6,
                ry: 3,
                transform: "scale(1 -1) rotate(5.657 753.563 783.485)",
                fill: "#83DA85"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                opacity: 0.6,
                rx: 6,
                ry: 3,
                transform: "scale(-1 1) rotate(5.657 -723.473 -965.922)",
                fill: "#83DA85"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                opacity: 0.6,
                cx: 97.626,
                cy: 63.82,
                rx: 6,
                ry: 3,
                transform: "rotate(142.343 97.626 63.82)",
                fill: "#83DA85"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M95 82.5c3.833 2.167 10 9 4 19s.167 16.5 4 18.5",
                stroke: "#CABEFF",
                strokeLinecap: "round",
                strokeDasharray: "4 4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M141.5 209h81m13 0h-6",
                stroke: "#4E5075",
                strokeWidth: 4,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 219.562,
                y: 155.275,
                width: 8,
                height: 2,
                rx: 1,
                transform: "rotate(-47.512 219.562 155.275)",
                fill: "#807694"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 215.622,
                y: 151.748,
                width: 8,
                height: 2,
                rx: 1,
                transform: "rotate(-71.512 215.622 151.748)",
                fill: "#807694"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 8,
                height: 2,
                rx: 1,
                transform: "scale(1 -1) rotate(23.512 497.432 460.195)",
                fill: "#807694"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M145 165a8 8 0 0 1 8-8h27.823a1 1 0 0 1 .987 1.161L180.528 166l4.916 7-3.747 7.196L187.5 189l-1.833-8 4.583-6-3.25-9 5.703-8.555c.186-.278.498-.445.832-.445H209a8 8 0 0 1 8 8v36a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8v-36Z",
                fill: "#C4B4E0"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M141 167h69",
                stroke: "#C9C5D0",
                strokeLinecap: "round",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 154,
                y: 171,
                width: 12,
                height: 12,
                rx: 4,
                fill: "#AC95D3"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 154,
                y: 189,
                width: 24,
                height: 2,
                rx: 1,
                fill: "#AC95D3"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 154,
                y: 195,
                width: 51,
                height: 2,
                rx: 1,
                fill: "#AC95D3"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 151.5,
                cy: 162.5,
                r: 1.5,
                fill: "#FF897A"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 156.5,
                cy: 162.5,
                r: 1.5,
                fill: "#FFF06A"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 161.5,
                cy: 162.5,
                r: 1.5,
                fill: "#83DA85"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 194.758,
                y: 19.621,
                width: 6,
                height: 6,
                rx: 0.12,
                transform: "rotate(-44.634 194.758 19.621)",
                fill: "#47464E"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M234.009 76.33a.125.125 0 0 1 .171-.045l1.947 1.135a.127.127 0 0 1 .045.172l-1.998 3.424 3.965.018c.069 0 .124.057.124.126l-.01 2.253c0 .07-.057.125-.126.125l-3.965-.018 1.967 3.443a.125.125 0 0 1-.047.17l-1.956 1.118a.126.126 0 0 1-.171-.047l-1.966-3.442-1.998 3.425a.126.126 0 0 1-.172.045l-1.946-1.135a.126.126 0 0 1-.045-.172l1.998-3.425-3.965-.018a.126.126 0 0 1-.125-.125l.011-2.253c0-.07.056-.125.125-.125l3.965.018-1.967-3.443a.126.126 0 0 1 .047-.17l1.956-1.118a.125.125 0 0 1 .171.046l1.967 3.443 1.998-3.425Z",
                fill: "#5F5D67"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m45.259 25.757.029 2.263a2.263 2.263 0 0 0 2.292 2.233v0a2.263 2.263 0 0 1 2.291 2.234v0a2.263 2.263 0 0 0 2.292 2.233v0a2.263 2.263 0 0 1 2.291 2.234l.03 2.263",
                stroke: "#8983A2",
                strokeWidth: 1.6,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_490_14139",
                        x1: 73.408,
                        y1: 130.519,
                        x2: 73.408,
                        y2: 213.482,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#423379"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#473296",
                                stopOpacity: 0.49
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_490_14139",
                        x1: 66,
                        y1: 130.519,
                        x2: 53.407,
                        y2: 165.333,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#2E2AF5",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CACCFE",
                                stopOpacity: 0.32
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint2_linear_490_14139",
                        x1: 146,
                        y1: 130.519,
                        x2: 158.593,
                        y2: 165.333,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#2E2AF5",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CBCDFF",
                                stopOpacity: 0.32
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $c431292b825765bf$export$2e2bcd8739ae039 = $c431292b825765bf$var$SvgTableEmptyDark;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $cf57d7e1ccb80e65$var$SvgTableEmpty = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 257,
        height: 256,
        viewBox: "0 0 257 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M23 198h81m13 0h-6",
                stroke: "#ADAAB4",
                strokeWidth: 4,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M41.315 132.884c0-1.384.958-2.583 2.307-2.89l62.222-14.141a2.969 2.969 0 0 1 1.313 0l62.223 14.141a2.963 2.963 0 0 1 2.306 2.89v63.417a2.963 2.963 0 0 1-2.306 2.89l-62.223 14.141a2.969 2.969 0 0 1-1.313 0l-62.222-14.141a2.964 2.964 0 0 1-2.307-2.89v-63.417Z",
                fill: "#47464E"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M41.315 134.23a2.963 2.963 0 0 1 3.62-2.889l60.909 13.843c.432.098.881.098 1.313 0l60.909-13.843a2.964 2.964 0 0 1 3.62 2.889v62.072a2.963 2.963 0 0 1-2.306 2.889l-62.223 14.141a2.94 2.94 0 0 1-1.313 0l-62.222-14.141a2.963 2.963 0 0 1-2.307-2.889V134.23Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M41.315 134.23v62.072c0 1.383.958 2.582 2.307 2.889l59.259 13.468a2.964 2.964 0 0 0 3.62-2.889v-63.638c0-.467-.323-.872-.779-.976l-60.787-13.815a2.963 2.963 0 0 0-3.62 2.889Z",
                fill: "url(#paint0_linear_5794_197247)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M40.827 132.697a2.221 2.221 0 0 1 2.377-.989l62.115 14.117-13.146 21.034a2.221 2.221 0 0 1-2.377.989L30.73 154.424a2.222 2.222 0 0 1-1.392-3.345l11.489-18.382Z",
                fill: "#CABEFF",
                fillOpacity: 0.16,
                stroke: "url(#paint1_linear_5794_197247)",
                strokeWidth: 1.481
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M40.199 128.733a2.964 2.964 0 0 0 3.17 1.319l63.131-14.348-13.699-21.918a2.963 2.963 0 0 0-3.17-1.32l-59.065 13.425a2.962 2.962 0 0 0-1.856 4.459l11.489 18.383Z",
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M172.173 132.697a2.221 2.221 0 0 0-2.377-.989l-62.115 14.117 13.146 21.034a2.221 2.221 0 0 0 2.377.989l59.066-13.424a2.222 2.222 0 0 0 1.392-3.345l-11.489-18.382Z",
                fill: "#CABEFF",
                fillOpacity: 0.16,
                stroke: "url(#paint2_linear_5794_197247)",
                strokeWidth: 1.481
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M172.801 128.733a2.964 2.964 0 0 1-3.169 1.319L106.5 115.704l13.699-21.918a2.963 2.963 0 0 1 3.169-1.32l59.066 13.425a2.962 2.962 0 0 1 1.856 4.459l-11.489 18.383Z",
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m14.927 132.746 1.113 1.281a1.697 1.697 0 0 0 2.395.167v0a1.697 1.697 0 0 1 2.394.167v0a1.697 1.697 0 0 0 2.394.167l1.28-1.114",
                stroke: "#947DFF",
                strokeWidth: 1.2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M179.789 103.655a3 3 0 1 1 3.899-4.56l10.641 9.098a3 3 0 1 1-3.9 4.56l-10.64-9.098Z",
                fill: "#47464E"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M183.259 102.674c10.049-11.753 8.668-29.428-3.085-39.477-11.753-10.05-29.428-8.669-39.478 3.084-10.049 11.754-8.668 29.428 3.085 39.478s29.428 8.669 39.478-3.085Zm-4.56-3.899c7.896-9.235 6.811-23.122-2.424-31.018-9.234-7.896-23.122-6.811-31.018 2.424-7.896 9.234-6.811 23.122 2.424 31.018 9.235 7.896 23.122 6.811 31.018-2.424Z",
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                opacity: 0.6,
                cx: 161.978,
                cy: 84.478,
                r: 22,
                transform: "rotate(-49.468 161.978 84.478)",
                fill: "#302F38"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                opacity: 0.6,
                d: "M161.958 67.902A15.92 15.92 0 0 0 154 70.018M150.936 95.5a16.052 16.052 0 0 1-3.062-4 15.93 15.93 0 0 1-1.916-7.598c0-2.276.475-4.441 1.332-6.402",
                stroke: "#FEE8FF",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 185.439,
                y: 112.434,
                width: 12,
                height: 28,
                rx: 6,
                transform: "rotate(-49.468 185.439 112.434)",
                fill: "#D361E7"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 91.416,
                y: 74.016,
                width: 2,
                height: 4,
                rx: 1,
                transform: "rotate(-21.657 91.416 74.016)",
                fill: "#D7C947"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                cx: 90.5,
                cy: 69,
                rx: 4,
                ry: 6,
                transform: "rotate(-21.657 90.5 69)",
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 87.916,
                cy: 62.494,
                r: 2,
                transform: "rotate(-21.657 87.916 62.494)",
                fill: "#47464E"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                cx: 82.505,
                cy: 73.251,
                rx: 6,
                ry: 3,
                transform: "rotate(-37.657 82.505 73.25)",
                fill: "#83DA85",
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                rx: 6,
                ry: 3,
                transform: "scale(1 -1) rotate(5.657 753.812 788.553)",
                fill: "#83DA85",
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                rx: 6,
                ry: 3,
                transform: "scale(-1 1) rotate(5.657 -723.723 -970.983)",
                fill: "#83DA85",
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                cx: 98.126,
                cy: 63.82,
                rx: 6,
                ry: 3,
                transform: "rotate(142.343 98.126 63.82)",
                fill: "#83DA85",
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M95.5 82.5c3.833 2.167 10 9 4 19s.167 16.5 4 18.5",
                stroke: "#947DFF",
                strokeLinecap: "round",
                strokeDasharray: "4 4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M142 209h81m13 0h-6",
                stroke: "#ADAAB4",
                strokeWidth: 4,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 220.062,
                y: 155.274,
                width: 8,
                height: 2,
                rx: 1,
                transform: "rotate(-47.512 220.062 155.274)",
                fill: "#C4C7C7"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 216.122,
                y: 151.749,
                width: 8,
                height: 2,
                rx: 1,
                transform: "rotate(-71.512 216.122 151.749)",
                fill: "#C4C7C7"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 8,
                height: 2,
                rx: 1,
                transform: "scale(1 -1) rotate(23.512 497.682 461.397)",
                fill: "#C4C7C7"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M145.5 165a8 8 0 0 1 8-8h27.823a1 1 0 0 1 .987 1.161L181.028 166l4.916 7-3.747 7.196L188 189l-1.833-8 4.583-6-3.25-9 5.703-8.555c.186-.278.498-.445.832-.445H209.5a8 8 0 0 1 8 8v36a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8v-36Z",
                fill: "#E5E1EC"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M141 167a.5.5 0 0 1 .5-.5h69a.5.5 0 0 1 0 1h-69a.5.5 0 0 1-.5-.5Z",
                fill: "#C9C5D0",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M154.5 175a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v4a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4v-4Z",
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M154.5 190a1 1 0 0 1 1-1h22a1 1 0 0 1 0 2h-22a1 1 0 0 1-1-1ZM154.5 196a1 1 0 0 1 1-1h49a1 1 0 0 1 0 2h-49a1 1 0 0 1-1-1Z",
                fill: "#C9C5D0"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 152,
                cy: 162.5,
                r: 1.5,
                fill: "#FF897A"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 157,
                cy: 162.5,
                r: 1.5,
                fill: "#FFF06A"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 162,
                cy: 162.5,
                r: 1.5,
                fill: "#83DA85"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 215.258,
                y: 22.621,
                width: 6,
                height: 6,
                rx: 0.12,
                transform: "rotate(-44.634 215.258 22.621)",
                fill: "#E5E1EC"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M234.509 76.33a.125.125 0 0 1 .171-.045l1.947 1.135a.126.126 0 0 1 .045.171l-1.998 3.425 3.965.018c.069 0 .124.057.124.126l-.01 2.253c0 .069-.057.125-.126.124l-3.965-.017 1.967 3.442a.126.126 0 0 1-.047.171l-1.956 1.118a.126.126 0 0 1-.171-.047l-1.966-3.442-1.998 3.425a.126.126 0 0 1-.172.045l-1.946-1.136a.126.126 0 0 1-.045-.17l1.998-3.426-3.965-.018a.126.126 0 0 1-.125-.126l.011-2.252c0-.07.056-.125.125-.125l3.965.018-1.967-3.443a.126.126 0 0 1 .047-.17l1.956-1.119a.125.125 0 0 1 .171.047l1.967 3.443 1.998-3.425Z",
                fill: "#E5E1EC"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m45.758 25.757.029 2.263a2.263 2.263 0 0 0 2.291 2.233v0a2.263 2.263 0 0 1 2.292 2.234v0a2.263 2.263 0 0 0 2.292 2.233v0a2.263 2.263 0 0 1 2.291 2.234l.03 2.262",
                stroke: "#F7F8F8",
                strokeWidth: 1.6,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m45.758 25.757.029 2.263a2.263 2.263 0 0 0 2.291 2.233v0a2.263 2.263 0 0 1 2.292 2.234v0a2.263 2.263 0 0 0 2.292 2.233v0a2.263 2.263 0 0 1 2.291 2.234l.03 2.262",
                stroke: "#78767F",
                strokeOpacity: 0.02,
                strokeWidth: 1.6,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m45.758 25.757.029 2.263a2.263 2.263 0 0 0 2.291 2.233v0a2.263 2.263 0 0 1 2.292 2.234v0a2.263 2.263 0 0 0 2.292 2.233v0a2.263 2.263 0 0 1 2.291 2.234l.03 2.262",
                stroke: "#5D34F2",
                strokeOpacity: 0.11,
                strokeWidth: 1.6,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_5794_197247",
                        x1: 73.908,
                        y1: 130.519,
                        x2: 73.908,
                        y2: 213.482,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#4F33B7"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#5337B8",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_5794_197247",
                        x1: 66.5,
                        y1: 130.519,
                        x2: 53.907,
                        y2: 165.333,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#2E2AF5",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#A1A5FF",
                                stopOpacity: 0.32
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint2_linear_5794_197247",
                        x1: 146.5,
                        y1: 130.519,
                        x2: 159.093,
                        y2: 165.333,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#2E2AF5",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#A1A5FF",
                                stopOpacity: 0.32
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $cf57d7e1ccb80e65$export$2e2bcd8739ae039 = $cf57d7e1ccb80e65$var$SvgTableEmpty;



var $jheqv = parcelRequire("jheqv");
var $a67a161478a2cf90$exports = {};

$parcel$export($a67a161478a2cf90$exports, "bottomSpace", function () { return $a67a161478a2cf90$export$dd62fe10de5d9423; }, function (v) { return $a67a161478a2cf90$export$dd62fe10de5d9423 = v; });
$parcel$export($a67a161478a2cf90$exports, "description", function () { return $a67a161478a2cf90$export$6d59db4903f20f7d; }, function (v) { return $a67a161478a2cf90$export$6d59db4903f20f7d = v; });
$parcel$export($a67a161478a2cf90$exports, "empty", function () { return $a67a161478a2cf90$export$6e22c362a0406a2c; }, function (v) { return $a67a161478a2cf90$export$6e22c362a0406a2c = v; });
$parcel$export($a67a161478a2cf90$exports, "image", function () { return $a67a161478a2cf90$export$5c452ff88e35e47d; }, function (v) { return $a67a161478a2cf90$export$5c452ff88e35e47d = v; });
$parcel$export($a67a161478a2cf90$exports, "large", function () { return $a67a161478a2cf90$export$f09585a853dddd32; }, function (v) { return $a67a161478a2cf90$export$f09585a853dddd32 = v; });
$parcel$export($a67a161478a2cf90$exports, "medium", function () { return $a67a161478a2cf90$export$649ecc744817b5c7; }, function (v) { return $a67a161478a2cf90$export$649ecc744817b5c7 = v; });
$parcel$export($a67a161478a2cf90$exports, "rotating", function () { return $a67a161478a2cf90$export$bfd64c937657f93a; }, function (v) { return $a67a161478a2cf90$export$bfd64c937657f93a = v; });
$parcel$export($a67a161478a2cf90$exports, "shimmer", function () { return $a67a161478a2cf90$export$4a6dd88bada4e7d2; }, function (v) { return $a67a161478a2cf90$export$4a6dd88bada4e7d2 = v; });
$parcel$export($a67a161478a2cf90$exports, "small", function () { return $a67a161478a2cf90$export$3c17b0e969a90510; }, function (v) { return $a67a161478a2cf90$export$3c17b0e969a90510 = v; });
$parcel$export($a67a161478a2cf90$exports, "title", function () { return $a67a161478a2cf90$export$fb184b623420d9be; }, function (v) { return $a67a161478a2cf90$export$fb184b623420d9be = v; });
$parcel$export($a67a161478a2cf90$exports, "topSpace", function () { return $a67a161478a2cf90$export$f6ec5d68907ebc61; }, function (v) { return $a67a161478a2cf90$export$f6ec5d68907ebc61 = v; });
var $a67a161478a2cf90$export$dd62fe10de5d9423;
var $a67a161478a2cf90$export$6d59db4903f20f7d;
var $a67a161478a2cf90$export$6e22c362a0406a2c;
var $a67a161478a2cf90$export$5c452ff88e35e47d;
var $a67a161478a2cf90$export$f09585a853dddd32;
var $a67a161478a2cf90$export$649ecc744817b5c7;
var $a67a161478a2cf90$export$bfd64c937657f93a;
var $a67a161478a2cf90$export$4a6dd88bada4e7d2;
var $a67a161478a2cf90$export$3c17b0e969a90510;
var $a67a161478a2cf90$export$fb184b623420d9be;
var $a67a161478a2cf90$export$f6ec5d68907ebc61;
$a67a161478a2cf90$export$dd62fe10de5d9423 = `ljXalG_bottomSpace`;
$a67a161478a2cf90$export$6d59db4903f20f7d = `ljXalG_description`;
$a67a161478a2cf90$export$6e22c362a0406a2c = `ljXalG_empty`;
$a67a161478a2cf90$export$5c452ff88e35e47d = `ljXalG_image`;
$a67a161478a2cf90$export$f09585a853dddd32 = `ljXalG_large`;
$a67a161478a2cf90$export$649ecc744817b5c7 = `ljXalG_medium`;
$a67a161478a2cf90$export$bfd64c937657f93a = `ljXalG_rotating`;
$a67a161478a2cf90$export$4a6dd88bada4e7d2 = `ljXalG_shimmer`;
$a67a161478a2cf90$export$3c17b0e969a90510 = `ljXalG_small`;
$a67a161478a2cf90$export$fb184b623420d9be = `ljXalG_title`;
$a67a161478a2cf90$export$f6ec5d68907ebc61 = `ljXalG_topSpace`;


function $a0f84bc7cc69e410$var$EmptyDataPlaceholder({ title: title, size: size = "medium", className: className }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const theme = (0, $jheqv.default)();
    const EmptyImage = theme === (0, $5HVJe.Theme).Light ? (0, $cf57d7e1ccb80e65$export$2e2bcd8739ae039) : (0, $c431292b825765bf$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($a67a161478a2cf90$exports.empty, $a67a161478a2cf90$exports[size], className),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $a67a161478a2cf90$exports.topSpace
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)(EmptyImage, {
                className: $a67a161478a2cf90$exports.image
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $a67a161478a2cf90$exports.title,
                children: title ?? t("errors.empty")
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $a67a161478a2cf90$exports.bottomSpace
            })
        ]
    });
}
var $a0f84bc7cc69e410$export$2e2bcd8739ae039 = $a0f84bc7cc69e410$var$EmptyDataPlaceholder;



var $8Mb3E = parcelRequire("8Mb3E");

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $g6wRR = parcelRequire("g6wRR");

var $jC8Vy = parcelRequire("jC8Vy");
const $ae0079a11bfb304f$var$useCacheValue = (value)=>{
    const [cachedValue, setCachedValue] = (0, $jC8Vy.useState)();
    (0, $jC8Vy.useEffect)(()=>{
        if (value !== undefined) setCachedValue(value);
    }, [
        value
    ]);
    return cachedValue;
};
var $ae0079a11bfb304f$export$2e2bcd8739ae039 = $ae0079a11bfb304f$var$useCacheValue;



var $jGWQ4 = parcelRequire("jGWQ4");

var $8R7rc = parcelRequire("8R7rc");

var $C7mD2 = parcelRequire("C7mD2");
function $36fe9c31d164e580$var$Next() {
    return /*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M12.9509 9.40832L8.23425 4.69999C8.15679 4.62188 8.06462 4.55989 7.96307 4.51758C7.86152 4.47527 7.7526 4.45349 7.64259 4.45349C7.53258 4.45349 7.42366 4.47527 7.32211 4.51758C7.22056 4.55989 7.12839 4.62188 7.05092 4.69999C6.89571 4.85613 6.80859 5.06734 6.80859 5.28749C6.80859 5.50764 6.89571 5.71885 7.05092 5.87499L11.1759 10.0417L7.05092 14.1667C6.89571 14.3228 6.80859 14.534 6.80859 14.7542C6.80859 14.9743 6.89571 15.1855 7.05092 15.3417C7.1281 15.4204 7.22014 15.483 7.3217 15.526C7.42326 15.5689 7.53233 15.5912 7.64259 15.5917C7.75284 15.5912 7.86191 15.5689 7.96348 15.526C8.06504 15.483 8.15708 15.4204 8.23425 15.3417L12.9509 10.6333C13.0355 10.5553 13.103 10.4606 13.1492 10.3552C13.1954 10.2497 13.2192 10.1359 13.2192 10.0208C13.2192 9.90574 13.1954 9.7919 13.1492 9.68648C13.103 9.58107 13.0355 9.48636 12.9509 9.40832Z",
            fill: "#747778"
        })
    });
}
var $36fe9c31d164e580$export$2e2bcd8739ae039 = $36fe9c31d164e580$var$Next;



var $C7mD2 = parcelRequire("C7mD2");
function $777cd678a42a2055$var$Previous() {
    return /*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M7.04908 9.40832L11.7657 4.69999C11.8432 4.62188 11.9354 4.55989 12.0369 4.51758C12.1385 4.47527 12.2474 4.45349 12.3574 4.45349C12.4674 4.45349 12.5763 4.47527 12.6779 4.51758C12.7794 4.55989 12.8716 4.62188 12.9491 4.69999C13.1043 4.85613 13.1914 5.06734 13.1914 5.28749C13.1914 5.50764 13.1043 5.71885 12.9491 5.87499L8.82408 10.0417L12.9491 14.1667C13.1043 14.3228 13.1914 14.534 13.1914 14.7542C13.1914 14.9743 13.1043 15.1855 12.9491 15.3417C12.8719 15.4204 12.7799 15.483 12.6783 15.526C12.5767 15.5689 12.4677 15.5912 12.3574 15.5917C12.2472 15.5912 12.1381 15.5689 12.0365 15.526C11.935 15.483 11.8429 15.4204 11.7657 15.3417L7.04908 10.6333C6.96449 10.5553 6.89698 10.4606 6.85081 10.3552C6.80464 10.2497 6.7808 10.1359 6.7808 10.0208C6.7808 9.90574 6.80464 9.7919 6.85081 9.68648C6.89698 9.58107 6.96449 9.48636 7.04908 9.40832Z",
            fill: "#747778"
        })
    });
}
var $777cd678a42a2055$export$2e2bcd8739ae039 = $777cd678a42a2055$var$Previous;


var $d54d8f4336a0bac0$export$89da14300d534261;
var $d54d8f4336a0bac0$export$2ba01fb71ed41cb6;
var $d54d8f4336a0bac0$export$34e0f9847d4c02dd;
var $d54d8f4336a0bac0$export$683472f6198a076e;
var $d54d8f4336a0bac0$export$22fa394f3ba39578;
var $d54d8f4336a0bac0$export$e10c52a2ab594201;
var $d54d8f4336a0bac0$export$a04a6574f0d14896;
var $d54d8f4336a0bac0$export$bfd64c937657f93a;
var $d54d8f4336a0bac0$export$4a6dd88bada4e7d2;
$d54d8f4336a0bac0$export$89da14300d534261 = `i6FXZq_active`;
$d54d8f4336a0bac0$export$2ba01fb71ed41cb6 = `i6FXZq_button`;
$d54d8f4336a0bac0$export$34e0f9847d4c02dd = `i6FXZq_container`;
$d54d8f4336a0bac0$export$683472f6198a076e = `i6FXZq_disabled`;
$d54d8f4336a0bac0$export$22fa394f3ba39578 = `i6FXZq_pagination`;
$d54d8f4336a0bac0$export$e10c52a2ab594201 = `i6FXZq_pico`;
$d54d8f4336a0bac0$export$a04a6574f0d14896 = `i6FXZq_positionInfo`;
$d54d8f4336a0bac0$export$bfd64c937657f93a = `i6FXZq_rotating`;
$d54d8f4336a0bac0$export$4a6dd88bada4e7d2 = `i6FXZq_shimmer`;


function $54e9f57962fc2e08$var$Pagination({ page: page, totalCount: totalCount, pageSize: pageSize, className: className, mode: mode = "normal", onChange: onChange }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    /**
   * Note:
   * The `totalCount` will become `undefined` temporarily when fetching data on page changes, and this causes the pagination to disappear.
   * Cache `totalCount` to solve this problem.
   */ const cachedTotalCount = (0, $ae0079a11bfb304f$export$2e2bcd8739ae039)(totalCount) ?? 0;
    const pageCount = Math.ceil(cachedTotalCount / pageSize);
    if (pageCount <= 1) return null;
    const min = (page - 1) * pageSize + 1;
    const max = Math.min(page * pageSize, cachedTotalCount);
    const isPicoMode = mode === "pico";
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($d54d8f4336a0bac0$export$34e0f9847d4c02dd, isPicoMode && $d54d8f4336a0bac0$export$e10c52a2ab594201, className),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $d54d8f4336a0bac0$export$a04a6574f0d14896,
                children: t("general.page_info", {
                    min: min,
                    max: max,
                    total: cachedTotalCount
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6wRR))), {
                className: $d54d8f4336a0bac0$export$22fa394f3ba39578,
                pageCount: pageCount,
                forcePage: page - 1,
                pageLabelBuilder: (pageNumber)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        type: pageNumber === page ? "outline" : "default",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($d54d8f4336a0bac0$export$2ba01fb71ed41cb6, pageNumber === page && $d54d8f4336a0bac0$export$89da14300d534261),
                        size: "small",
                        title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8R7rc.default), {
                            children: pageNumber
                        })
                    }),
                previousLabel: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                    className: $d54d8f4336a0bac0$export$2ba01fb71ed41cb6,
                    size: "small",
                    icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $777cd678a42a2055$export$2e2bcd8739ae039), {}),
                    disabled: page === 1
                }),
                nextLabel: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                    className: $d54d8f4336a0bac0$export$2ba01fb71ed41cb6,
                    size: "small",
                    icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $36fe9c31d164e580$export$2e2bcd8739ae039), {}),
                    disabled: page === pageCount
                }),
                breakLabel: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                    className: $d54d8f4336a0bac0$export$2ba01fb71ed41cb6,
                    size: "small",
                    title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8R7rc.default), {
                        children: "..."
                    })
                }),
                disabledClassName: $d54d8f4336a0bac0$export$683472f6198a076e,
                pageRangeDisplayed: isPicoMode ? -1 : undefined,
                marginPagesDisplayed: isPicoMode ? 0 : undefined,
                onPageChange: ({ selected: selected })=>{
                    onChange?.(selected + 1);
                }
            })
        ]
    });
}
var $54e9f57962fc2e08$export$2e2bcd8739ae039 = $54e9f57962fc2e08$var$Pagination;



var $fmHmG = parcelRequire("fmHmG");

var $jC8Vy = parcelRequire("jC8Vy");
const $fe972dea93e1e243$var$defaultDelay = 500;
const $fe972dea93e1e243$var$useDebounce = (delay = $fe972dea93e1e243$var$defaultDelay)=>{
    const timerRef = (0, $jC8Vy.useRef)();
    const clearTimer = ()=>{
        if (timerRef.current) clearTimeout(timerRef.current);
    };
    (0, $jC8Vy.useEffect)(()=>{
        return ()=>{
            clearTimer();
        };
    }, []);
    return (callback)=>{
        clearTimer();
        // eslint-disable-next-line @silverhand/fp/no-mutation
        timerRef.current = window.setTimeout(()=>{
            callback();
            clearTimer();
        }, delay);
    };
};
var $fe972dea93e1e243$export$2e2bcd8739ae039 = $fe972dea93e1e243$var$useDebounce;




var $7kooT = parcelRequire("7kooT");

var $C7mD2 = parcelRequire("C7mD2");


var $bnkR4 = parcelRequire("bnkR4");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
var $9XFlr = parcelRequire("9XFlr");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $voszV = parcelRequire("voszV");


var $8TpMk = parcelRequire("8TpMk");

var $66ixW = parcelRequire("66ixW");
parcelRequire("fIF1D");
var $16GE9 = parcelRequire("16GE9");
var $12650a80e48ea14a$export$34e0f9847d4c02dd;
var $12650a80e48ea14a$export$85b9a36db797e02b;
var $12650a80e48ea14a$export$42405f212471e8a2;
var $12650a80e48ea14a$export$a8ff84c12d48cfa6;
var $12650a80e48ea14a$export$bfd64c937657f93a;
var $12650a80e48ea14a$export$4a6dd88bada4e7d2;
$12650a80e48ea14a$export$34e0f9847d4c02dd = `EGojMG_container`;
$12650a80e48ea14a$export$85b9a36db797e02b = `EGojMG_count`;
$12650a80e48ea14a$export$42405f212471e8a2 = `EGojMG_flag`;
$12650a80e48ea14a$export$a8ff84c12d48cfa6 = `EGojMG_name`;
$12650a80e48ea14a$export$bfd64c937657f93a = `EGojMG_rotating`;
$12650a80e48ea14a$export$4a6dd88bada4e7d2 = `EGojMG_shimmer`;


function $23045991aae5d54d$var$RoleInformation({ role: role }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { id: id, name: name, type: type, usersCount: usersCount, applicationsCount: applicationsCount } = role;
    const { data: data } = (0, $voszV.default)(// Todo @xiaoyijun remove dev feature flag
    (0, $8TpMk.isDevFeaturesEnabled) && type === (0, $61Yml.RoleType).MachineToMachine && `api/roles/${id}/scopes`);
    const withManagementApiFlag = data?.some(({ resource: { indicator: indicator } })=>(0, $9XFlr.isManagementApi)(indicator));
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $12650a80e48ea14a$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $12650a80e48ea14a$export$a8ff84c12d48cfa6,
                children: name
            }),
            !(0, $8TpMk.isDevFeaturesEnabled) && /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $12650a80e48ea14a$export$85b9a36db797e02b,
                children: [
                    "(",
                    type === (0, $61Yml.RoleType).User ? t("user_details.roles.assigned_user_count", {
                        value: usersCount
                    }) : t("application_details.roles.assigned_app_count", {
                        value: applicationsCount
                    }),
                    ")"
                ]
            }),
            withManagementApiFlag && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $16GE9.default), {
                anchorClassName: $12650a80e48ea14a$export$42405f212471e8a2,
                content: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                    forKey: "roles.with_management_api_access_tip"
                }),
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $37b2fef0020c87fb$export$2e2bcd8739ae039), {})
            })
        ]
    });
}
var $23045991aae5d54d$export$2e2bcd8739ae039 = $23045991aae5d54d$var$RoleInformation;


var $5cf16a157d3764a1$export$7061c75fc5af8b7e;
var $5cf16a157d3764a1$export$bfd64c937657f93a;
var $5cf16a157d3764a1$export$4a6dd88bada4e7d2;
$5cf16a157d3764a1$export$7061c75fc5af8b7e = `WO-lOa_item`;
$5cf16a157d3764a1$export$bfd64c937657f93a = `WO-lOa_rotating`;
$5cf16a157d3764a1$export$4a6dd88bada4e7d2 = `WO-lOa_shimmer`;


function $e8705d1145714627$var$SourceRoleItem({ role: role, isSelected: isSelected, onSelect: onSelect }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $5cf16a157d3764a1$export$7061c75fc5af8b7e,
        role: "button",
        tabIndex: 0,
        onKeyDown: (0, $bnkR4.onKeyDownHandler)(()=>{
            onSelect();
        }),
        onClick: ()=>{
            onSelect();
        },
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $26dc4ab718ba37b7$export$2e2bcd8739ae039), {
                checked: isSelected,
                onChange: ()=>{
                    onSelect();
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $23045991aae5d54d$export$2e2bcd8739ae039), {
                role: role
            })
        ]
    });
}
var $e8705d1145714627$export$2e2bcd8739ae039 = $e8705d1145714627$var$SourceRoleItem;


var $278fcd50bba0b47d$export$f05c1fab6a17ec98;
var $278fcd50bba0b47d$export$1ca1ec8b29a4ce27;
var $278fcd50bba0b47d$export$d76128d007d19019;
$278fcd50bba0b47d$export$f05c1fab6a17ec98 = `-CIDxa_emptyImage`;
$278fcd50bba0b47d$export$1ca1ec8b29a4ce27 = `-CIDxa_icon`;
$278fcd50bba0b47d$export$d76128d007d19019 = `-CIDxa_search`;


const $a69369cc180771bc$var$pageSize = (0, $8Mb3E.defaultPageSize);
function $a69369cc180771bc$var$SourceRolesBox({ entityId: entityId, type: type, selectedRoles: selectedRoles, onChange: onChange }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [page, setPage] = (0, $jC8Vy.useState)(1);
    const [keyword, setKeyword] = (0, $jC8Vy.useState)("");
    const debounce = (0, $fe972dea93e1e243$export$2e2bcd8739ae039)();
    const url = (0, $7kooT.buildUrl)("api/roles", {
        page: String(page),
        page_size: String($a69369cc180771bc$var$pageSize),
        type: type,
        [type === (0, $61Yml.RoleType).User ? "excludeUserId" : "excludeApplicationId"]: entityId,
        ...(0, $7oDSS.conditional)(keyword && {
            search: `%${keyword}%`
        })
    });
    const { data: data, error: error } = (0, $voszV.default)(url, {
        /**
     * Always use the latest data to reflect the latest available roles.
     * Using cached data before new data is loaded can result in roles that have been assigned or deleted being rendered in the list.
     * If a deleted role is rendered in the list, it will cause the query requests for role scopes in the list items to return a 404 error.
     */ keepPreviousData: false
    });
    const isLoading = !data && !error;
    const [dataSource = [], totalCount] = data ?? [];
    const isRoleSelected = (role)=>selectedRoles.findIndex(({ id: id })=>role.id === id) >= 0;
    const handleSearchInput = (event)=>{
        debounce(()=>{
            setPage(1);
            setKeyword(event.target.value);
        });
    };
    const isEmpty = !isLoading && !error && dataSource.length === 0;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $1c26dd25fa3ad36d$export$827f4ee28efc37,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $1c26dd25fa3ad36d$export$9f6c77b8cdee9051,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                    className: $278fcd50bba0b47d$export$d76128d007d19019,
                    icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $45ba7f7cad465e3f$export$2e2bcd8739ae039), {
                        className: $278fcd50bba0b47d$export$1ca1ec8b29a4ce27
                    }),
                    placeholder: t("general.search_placeholder"),
                    onChange: handleSearchInput
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($1c26dd25fa3ad36d$export$a03f626b8106969c, isEmpty && $1c26dd25fa3ad36d$export$2d49e08edfff676e),
                children: isEmpty ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a0f84bc7cc69e410$export$2e2bcd8739ae039), {
                    size: "small",
                    title: t(type === (0, $61Yml.RoleType).User ? "user_details.roles.empty" : "application_details.roles.empty")
                }) : dataSource.map((role)=>{
                    const isSelected = isRoleSelected(role);
                    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e8705d1145714627$export$2e2bcd8739ae039), {
                        role: role,
                        isSelected: isSelected,
                        onSelect: ()=>{
                            onChange(isSelected ? selectedRoles.filter(({ id: id })=>id !== role.id) : [
                                role,
                                ...selectedRoles
                            ]);
                        }
                    }, role.id);
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $54e9f57962fc2e08$export$2e2bcd8739ae039), {
                mode: "pico",
                page: page,
                totalCount: totalCount,
                pageSize: $a69369cc180771bc$var$pageSize,
                className: $1c26dd25fa3ad36d$export$eda11a42e6b44edc,
                onChange: (page)=>{
                    setPage(page);
                }
            })
        ]
    });
}
var $a69369cc180771bc$export$2e2bcd8739ae039 = $a69369cc180771bc$var$SourceRolesBox;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");


var $C7mD2 = parcelRequire("C7mD2");

var $HHYyb = parcelRequire("HHYyb");

var $75SRw = parcelRequire("75SRw");

var $66d991bf6dcc0480$export$64a53ecd158b85c4;
var $66d991bf6dcc0480$export$7061c75fc5af8b7e;
var $66d991bf6dcc0480$export$bfd64c937657f93a;
var $66d991bf6dcc0480$export$4a6dd88bada4e7d2;
$66d991bf6dcc0480$export$64a53ecd158b85c4 = `HYx5aG_closeIcon`;
$66d991bf6dcc0480$export$7061c75fc5af8b7e = `HYx5aG_item`;
$66d991bf6dcc0480$export$bfd64c937657f93a = `HYx5aG_rotating`;
$66d991bf6dcc0480$export$4a6dd88bada4e7d2 = `HYx5aG_shimmer`;


function $ad4632eecf241fc9$var$TargetRoleItem({ role: role, onDelete: onDelete }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $66d991bf6dcc0480$export$7061c75fc5af8b7e,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $23045991aae5d54d$export$2e2bcd8739ae039), {
                role: role
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                size: "small",
                className: $66d991bf6dcc0480$export$64a53ecd158b85c4,
                onClick: onDelete,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $HHYyb.default), {})
            })
        ]
    });
}
var $ad4632eecf241fc9$export$2e2bcd8739ae039 = $ad4632eecf241fc9$var$TargetRoleItem;


var $025d2fd86badcc2f$export$80f73db1a407fae0;
var $025d2fd86badcc2f$export$1ca1ec8b29a4ce27;
$025d2fd86badcc2f$export$80f73db1a407fae0 = `Qd6Kxq_added`;
$025d2fd86badcc2f$export$1ca1ec8b29a4ce27 = `Qd6Kxq_icon`;


function $b164237a1c6c834b$var$TargetRolesBox({ selectedRoles: selectedRoles, onChange: onChange }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $1c26dd25fa3ad36d$export$827f4ee28efc37,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $1c26dd25fa3ad36d$export$9f6c77b8cdee9051,
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("span", {
                    className: $025d2fd86badcc2f$export$80f73db1a407fae0,
                    children: [
                        `${selectedRoles.length} `,
                        t("general.added")
                    ]
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $1c26dd25fa3ad36d$export$a03f626b8106969c,
                children: selectedRoles.map((role)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $ad4632eecf241fc9$export$2e2bcd8739ae039), {
                        role: role,
                        onDelete: ()=>{
                            onChange(selectedRoles.filter(({ id: id })=>id !== role.id));
                        }
                    }, role.id))
            })
        ]
    });
}
var $b164237a1c6c834b$export$2e2bcd8739ae039 = $b164237a1c6c834b$var$TargetRolesBox;


var $a2396d8dbc851cbe$export$7857b083e4f8c039;
var $a2396d8dbc851cbe$export$a9c4b5b7bc92a147;
$a2396d8dbc851cbe$export$7857b083e4f8c039 = `_1g5OiG_flagIcon`;
$a2396d8dbc851cbe$export$a9c4b5b7bc92a147 = `_1g5OiG_rolesTransfer`;


function $8ec6df9390a6fefb$var$RolesTransfer({ entityId: entityId, type: type, value: value, onChange: onChange }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const isM2mRole = type === (0, $61Yml.RoleType).MachineToMachine;
    const { data: { roleWithManagementApiAccessNotificationAcknowledged: roleWithManagementApiAccessNotificationAcknowledged }, update: update, isLoaded: isLoaded } = (0, $c83ac2f0f8302d6c$export$2e2bcd8739ae039)();
    // Default to true if configs is not loaded to avoid page flickering
    const notificationAcknowledged = isLoaded ? Boolean(roleWithManagementApiAccessNotificationAcknowledged) : true;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        children: [
            (0, $8TpMk.isDevFeaturesEnabled) && isM2mRole && !notificationAcknowledged && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1QOtg.default), {
                action: "general.got_it",
                onClick: ()=>{
                    update({
                        roleWithManagementApiAccessNotificationAcknowledged: true
                    });
                },
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                    components: {
                        flag: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $37b2fef0020c87fb$export$2e2bcd8739ae039), {
                            className: $a2396d8dbc851cbe$export$7857b083e4f8c039
                        })
                    },
                    children: t("roles.management_api_access_notification")
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: isM2mRole ? "roles.assign_m2m_roles" : "roles.assign_user_roles",
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($1c26dd25fa3ad36d$export$34e0f9847d4c02dd, $a2396d8dbc851cbe$export$a9c4b5b7bc92a147),
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a69369cc180771bc$export$2e2bcd8739ae039), {
                            entityId: entityId,
                            type: type,
                            selectedRoles: value,
                            onChange: onChange
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $1c26dd25fa3ad36d$export$d999e528e771887b
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $b164237a1c6c834b$export$2e2bcd8739ae039), {
                            selectedRoles: value,
                            onChange: onChange
                        })
                    ]
                })
            })
        ]
    });
}
var $8ec6df9390a6fefb$export$2e2bcd8739ae039 = $8ec6df9390a6fefb$var$RolesTransfer;



var $jGWQ4 = parcelRequire("jGWQ4");

var $8R7rc = parcelRequire("8R7rc");

var $5vVWy = parcelRequire("5vVWy");

var $9Q3SI = parcelRequire("9Q3SI");

var $7VnwS = parcelRequire("7VnwS");

var $dW2kG = parcelRequire("dW2kG");
parcelRequire("ajkVG");
var $clvkc = parcelRequire("clvkc");

var $4TsiV = parcelRequire("4TsiV");
const $46451cbb59c7a857$export$5f7a1baecd59f846 = (user)=>(user ? (0, $clvkc.getUserDisplayName)(user) : undefined) ?? (0, $4TsiV.t)("admin_console.users.unnamed");
const $46451cbb59c7a857$export$336d714c72178bf2 = (user)=>{
    if (!user?.name) return;
    const { username: username, primaryEmail: primaryEmail, primaryPhone: primaryPhone } = user;
    return (0, $clvkc.getUserDisplayName)({
        username: username,
        primaryEmail: primaryEmail,
        primaryPhone: primaryPhone
    });
};


var $cf08386af6c3e245$export$464c821cd4347539;
var $cf08386af6c3e245$export$bfd64c937657f93a;
var $cf08386af6c3e245$export$4a6dd88bada4e7d2;
$cf08386af6c3e245$export$464c821cd4347539 = `-CfDsG_hint`;
$cf08386af6c3e245$export$bfd64c937657f93a = `-CfDsG_rotating`;
$cf08386af6c3e245$export$4a6dd88bada4e7d2 = `-CfDsG_shimmer`;


function $5980bec6c22435f4$var$RoleAssignmentModal({ entity: entity, onClose: onClose, type: type, modalTextOverrides: modalTextOverrides, isSkippable: isSkippable, isMachineToMachineRoleCreationHintVisible: isMachineToMachineRoleCreationHintVisible }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [isSubmitting, setIsSubmitting] = (0, $jC8Vy.useState)(false);
    const [roles, setRoles] = (0, $jC8Vy.useState)([]);
    const isForUser = type === (0, $61Yml.RoleType).User;
    const api = (0, $7VnwS.default)();
    const handleAssign = async ()=>{
        if (isSubmitting || roles.length === 0) return;
        setIsSubmitting(true);
        try {
            await api.post(`api/${isForUser ? "users" : "applications"}/${entity.id}/roles`, {
                json: {
                    roleIds: roles.map(({ id: id })=>id)
                }
            });
            (0, $FuhPC.toast).success(t("user_details.roles.role_assigned"));
            onClose(true);
        } finally{
            setIsSubmitting(false);
        }
    };
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        isOpen: true,
        shouldCloseOnEsc: true,
        className: $dW2kG.content,
        overlayClassName: $dW2kG.overlay,
        onRequestClose: ()=>{
            onClose();
        },
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $5vVWy.default), {
            title: (0, $7oDSS.cond)(modalTextOverrides?.title) ?? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8R7rc.default), {
                children: t(isForUser ? "user_details.roles.assign_title" : "application_details.roles.assign_title", {
                    name: isForUser ? (0, $46451cbb59c7a857$export$5f7a1baecd59f846)(entity) : entity.name
                })
            }),
            subtitle: (0, $7oDSS.cond)(modalTextOverrides?.subtitle) ?? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8R7rc.default), {
                children: t(isForUser ? "user_details.roles.assign_subtitle" : "application_details.roles.assign_subtitle", {
                    name: isForUser ? (0, $46451cbb59c7a857$export$5f7a1baecd59f846)(entity) : entity.name
                })
            }),
            size: "large",
            footer: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    isSkippable && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        isLoading: isSubmitting,
                        title: "general.skip",
                        size: "large",
                        onClick: ()=>{
                            onClose();
                        }
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        isLoading: isSubmitting,
                        disabled: roles.length === 0,
                        htmlType: "submit",
                        title: isForUser ? "user_details.roles.confirm_assign" : "application_details.roles.confirm_assign",
                        size: "large",
                        type: "primary",
                        onClick: handleAssign
                    })
                ]
            }),
            onClose: onClose,
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8ec6df9390a6fefb$export$2e2bcd8739ae039), {
                    entityId: entity.id,
                    type: type,
                    value: roles,
                    onChange: (value)=>{
                        setRoles(value);
                    }
                }),
                !isForUser && isMachineToMachineRoleCreationHintVisible && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $cf08386af6c3e245$export$464c821cd4347539,
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                        components: {
                            a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                                to: "/roles"
                            })
                        },
                        children: t("applications.m2m_role_assignment.role_creation_hint")
                    })
                })
            ]
        })
    });
}
var $5980bec6c22435f4$export$2e2bcd8739ae039 = $5980bec6c22435f4$var$RoleAssignmentModal;



var $8TpMk = parcelRequire("8TpMk");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $kUZ14 = parcelRequire("kUZ14");


var $66ixW = parcelRequire("66ixW");

var $aqmjm = parcelRequire("aqmjm");

var $5vVWy = parcelRequire("5vVWy");


var $fmHmG = parcelRequire("fmHmG");

var $7VnwS = parcelRequire("7VnwS");


var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");
parcelRequire("8Mb3E");
var $e8luV = parcelRequire("e8luV");
var $dxSXj = parcelRequire("dxSXj");
var $gyL1Y = parcelRequire("gyL1Y");

var $jheqv = parcelRequire("jheqv");
const $e07e369caa387826$var$getIcon = (type, isLightMode, isThirdParty)=>{
    if (isThirdParty) return isLightMode ? (0, $e8luV.default) : (0, $dxSXj.default);
    return isLightMode ? (0, $gyL1Y.lightModeApplicationIconMap)[type] : (0, $gyL1Y.darkModeApplicationIconMap)[type];
};
function $e07e369caa387826$var$ApplicationIcon({ type: type, className: className, isThirdParty: isThirdParty = false }) {
    const theme = (0, $jheqv.default)();
    const isLightMode = theme === (0, $5HVJe.Theme).Light;
    const Icon = $e07e369caa387826$var$getIcon(type, isLightMode, isThirdParty);
    return /*#__PURE__*/ (0, $C7mD2.jsx)(Icon, {
        className: className
    });
}
var $e07e369caa387826$export$2e2bcd8739ae039 = $e07e369caa387826$var$ApplicationIcon;


var $406226487fe4dc1f$exports = {};

$parcel$export($406226487fe4dc1f$exports, "container", function () { return $406226487fe4dc1f$export$34e0f9847d4c02dd; }, function (v) { return $406226487fe4dc1f$export$34e0f9847d4c02dd = v; });
$parcel$export($406226487fe4dc1f$exports, "description", function () { return $406226487fe4dc1f$export$6d59db4903f20f7d; }, function (v) { return $406226487fe4dc1f$export$6d59db4903f20f7d = v; });
$parcel$export($406226487fe4dc1f$exports, "rotating", function () { return $406226487fe4dc1f$export$bfd64c937657f93a; }, function (v) { return $406226487fe4dc1f$export$bfd64c937657f93a = v; });
$parcel$export($406226487fe4dc1f$exports, "shimmer", function () { return $406226487fe4dc1f$export$4a6dd88bada4e7d2; }, function (v) { return $406226487fe4dc1f$export$4a6dd88bada4e7d2 = v; });
$parcel$export($406226487fe4dc1f$exports, "small", function () { return $406226487fe4dc1f$export$3c17b0e969a90510; }, function (v) { return $406226487fe4dc1f$export$3c17b0e969a90510 = v; });
$parcel$export($406226487fe4dc1f$exports, "subtitle", function () { return $406226487fe4dc1f$export$c96745152eb2740f; }, function (v) { return $406226487fe4dc1f$export$c96745152eb2740f = v; });
$parcel$export($406226487fe4dc1f$exports, "title", function () { return $406226487fe4dc1f$export$fb184b623420d9be; }, function (v) { return $406226487fe4dc1f$export$fb184b623420d9be = v; });
var $406226487fe4dc1f$export$34e0f9847d4c02dd;
var $406226487fe4dc1f$export$6d59db4903f20f7d;
var $406226487fe4dc1f$export$bfd64c937657f93a;
var $406226487fe4dc1f$export$4a6dd88bada4e7d2;
var $406226487fe4dc1f$export$3c17b0e969a90510;
var $406226487fe4dc1f$export$c96745152eb2740f;
var $406226487fe4dc1f$export$fb184b623420d9be;
$406226487fe4dc1f$export$34e0f9847d4c02dd = `q8OBxa_container`;
$406226487fe4dc1f$export$6d59db4903f20f7d = `q8OBxa_description`;
$406226487fe4dc1f$export$bfd64c937657f93a = `q8OBxa_rotating`;
$406226487fe4dc1f$export$4a6dd88bada4e7d2 = `q8OBxa_shimmer`;
$406226487fe4dc1f$export$3c17b0e969a90510 = `q8OBxa_small`;
$406226487fe4dc1f$export$c96745152eb2740f = `q8OBxa_subtitle`;
$406226487fe4dc1f$export$fb184b623420d9be = `q8OBxa_title`;


function $746647aa0de20b4b$var$TypeDescription({ title: title, subtitle: subtitle, description: description, type: type, size: size = "large" }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($406226487fe4dc1f$exports.container, $406226487fe4dc1f$exports[size]),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e07e369caa387826$export$2e2bcd8739ae039), {
                type: type
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $406226487fe4dc1f$exports.title,
                children: title
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $406226487fe4dc1f$exports.subtitle,
                children: subtitle
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $406226487fe4dc1f$exports.description,
                children: description
            })
        ]
    });
}
var $746647aa0de20b4b$export$2e2bcd8739ae039 = $746647aa0de20b4b$var$TypeDescription;



var $dW2kG = parcelRequire("dW2kG");
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
const $59106c8950c5d39f$export$914bc6e40242037e = "ThirdParty";
const $59106c8950c5d39f$export$d8e4c8dab9129f15 = Object.freeze({
    [(0, $61Yml.ApplicationType).Native]: "applications.type.native",
    [(0, $61Yml.ApplicationType).SPA]: "applications.type.spa",
    [(0, $61Yml.ApplicationType).Traditional]: "applications.type.traditional",
    [(0, $61Yml.ApplicationType).MachineToMachine]: "applications.type.machine_to_machine",
    [(0, $61Yml.ApplicationType).Protected]: "applications.type.protected",
    thirdParty: "applications.type.third_party"
});
const $59106c8950c5d39f$export$a5fbc60a6db6cc4b = Object.freeze([
    "Protected",
    "featured",
    "Traditional",
    "SPA",
    "Native",
    "MachineToMachine",
    $59106c8950c5d39f$export$914bc6e40242037e
]);



var $5OcFi = parcelRequire("5OcFi");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
var $lXQZH = parcelRequire("lXQZH");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("8Mb3E");
var $cfL6o = parcelRequire("cfL6o");

var $9Q3SI = parcelRequire("9Q3SI");
function $a3bc63325dc3c1a8$var$ContactUsPhraseLink({ children: children }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
        href: (0, $cfL6o.contactEmailLink),
        children: children
    });
}
var $a3bc63325dc3c1a8$export$2e2bcd8739ae039 = $a3bc63325dc3c1a8$var$ContactUsPhraseLink;




var $C7mD2 = parcelRequire("C7mD2");

var $jGWQ4 = parcelRequire("jGWQ4");

var $4ZcUR = parcelRequire("4ZcUR");
var $18106901b7e079ed$export$34e0f9847d4c02dd;
var $18106901b7e079ed$export$6d59db4903f20f7d;
var $18106901b7e079ed$export$bfd64c937657f93a;
var $18106901b7e079ed$export$4a6dd88bada4e7d2;
$18106901b7e079ed$export$34e0f9847d4c02dd = `lK2u-q_container`;
$18106901b7e079ed$export$6d59db4903f20f7d = `lK2u-q_description`;
$18106901b7e079ed$export$bfd64c937657f93a = `lK2u-q_rotating`;
$18106901b7e079ed$export$4a6dd88bada4e7d2 = `lK2u-q_shimmer`;


function $dafa1bad5a99c1ae$var$QuotaGuardFooter({ children: children, isLoading: isLoading, onClickUpgrade: onClickUpgrade }) {
    const { navigate: navigate } = (0, $4ZcUR.default)();
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $18106901b7e079ed$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $18106901b7e079ed$export$6d59db4903f20f7d,
                children: children
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                size: "large",
                type: "primary",
                title: "upsell.upgrade_plan",
                isLoading: isLoading,
                onClick: ()=>{
                    if (onClickUpgrade) {
                        onClickUpgrade();
                        return;
                    }
                    // Navigate to subscription page by default
                    navigate("/tenant-settings/subscription");
                }
            })
        ]
    });
}
var $dafa1bad5a99c1ae$export$2e2bcd8739ae039 = $dafa1bad5a99c1ae$var$QuotaGuardFooter;




var $jGWQ4 = parcelRequire("jGWQ4");
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");

var $jC8Vy = parcelRequire("jC8Vy");

var $voszV = parcelRequire("voszV");

var $8TpMk = parcelRequire("8TpMk");


var $8TpMk = parcelRequire("8TpMk");
const $605aee781e0fe83f$var$isUsageWithInLimit = ({ quotaKey: quotaKey, usage: usage, plan: plan }, inclusive = true)=>{
    // No limitations for OSS version
    if (!(0, $8TpMk.isCloud)) return true;
    const quotaValue = plan.quota[quotaKey];
    // Unlimited
    if (quotaValue === null) return true;
    if (typeof quotaValue === "boolean") return quotaValue;
    return inclusive ? usage <= quotaValue : usage < quotaValue;
};
const $605aee781e0fe83f$export$6486e974a84ab8b6 = (options)=>!$605aee781e0fe83f$var$isUsageWithInLimit(options);
const $605aee781e0fe83f$export$1cc4b5152472cd4f = (options)=>!$605aee781e0fe83f$var$isUsageWithInLimit(options, false);


const $d2d1111984d2f594$var$useApplicationsUsage = ()=>{
    const { currentPlan: currentPlan } = (0, $jC8Vy.useContext)((0, $19434c930f80c964$export$f8addfd4ab69c833));
    /**
   * Note: we only need to fetch all applications when the user is in cloud environment.
   * The oss version doesn't have the quota limit.
   */ const { data: allApplications } = (0, $voszV.default)((0, $8TpMk.isCloud) && "api/applications");
    const m2mAppCount = (0, $jC8Vy.useMemo)(()=>allApplications?.filter(({ type: type })=>type === (0, $61Yml.ApplicationType).MachineToMachine).length ?? 0, [
        allApplications
    ]);
    const thirdPartyAppCount = (0, $jC8Vy.useMemo)(()=>allApplications?.filter(({ isThirdParty: isThirdParty })=>isThirdParty).length ?? 0, [
        allApplications
    ]);
    const hasMachineToMachineAppsReachedLimit = (0, $jC8Vy.useMemo)(()=>(0, $605aee781e0fe83f$export$1cc4b5152472cd4f)({
            quotaKey: "machineToMachineLimit",
            plan: currentPlan,
            usage: m2mAppCount
        }), [
        currentPlan,
        m2mAppCount
    ]);
    const hasMachineToMachineAppsSurpassedLimit = (0, $jC8Vy.useMemo)(()=>(0, $605aee781e0fe83f$export$6486e974a84ab8b6)({
            quotaKey: "machineToMachineLimit",
            plan: currentPlan,
            usage: m2mAppCount
        }), [
        currentPlan,
        m2mAppCount
    ]);
    const hasThirdPartyAppsReachedLimit = (0, $jC8Vy.useMemo)(()=>(0, $605aee781e0fe83f$export$1cc4b5152472cd4f)({
            quotaKey: "thirdPartyApplicationsLimit",
            plan: currentPlan,
            usage: thirdPartyAppCount
        }), [
        currentPlan,
        thirdPartyAppCount
    ]);
    const hasAppsReachedLimit = (0, $jC8Vy.useMemo)(()=>(0, $605aee781e0fe83f$export$1cc4b5152472cd4f)({
            quotaKey: "applicationsLimit",
            plan: currentPlan,
            usage: allApplications?.length ?? 0
        }), [
        allApplications?.length,
        currentPlan
    ]);
    return {
        hasMachineToMachineAppsReachedLimit: hasMachineToMachineAppsReachedLimit,
        hasMachineToMachineAppsSurpassedLimit: hasMachineToMachineAppsSurpassedLimit,
        hasAppsReachedLimit: hasAppsReachedLimit,
        hasThirdPartyAppsReachedLimit: hasThirdPartyAppsReachedLimit
    };
};
var $d2d1111984d2f594$export$2e2bcd8739ae039 = $d2d1111984d2f594$var$useApplicationsUsage;


function $d1250b451625733f$var$Footer({ selectedType: selectedType, isLoading: isLoading, onClickCreate: onClickCreate, isThirdParty: isThirdParty }) {
    const { currentPlan: currentPlan } = (0, $jC8Vy.useContext)((0, $19434c930f80c964$export$f8addfd4ab69c833));
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.upsell.paywall"
    });
    const { hasAppsReachedLimit: hasAppsReachedLimit, hasMachineToMachineAppsReachedLimit: hasMachineToMachineAppsReachedLimit, hasThirdPartyAppsReachedLimit: hasThirdPartyAppsReachedLimit } = (0, $d2d1111984d2f594$export$2e2bcd8739ae039)();
    if (selectedType) {
        const { id: planId, name: planName, quota: quota } = currentPlan;
        if (selectedType === (0, $61Yml.ApplicationType).MachineToMachine && hasMachineToMachineAppsReachedLimit && // For paid plan (pro plan), we don't guard the m2m app creation since it's an add-on feature.
        planId === (0, $lXQZH.ReservedPlanId).Free) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dafa1bad5a99c1ae$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                components: {
                    a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a3bc63325dc3c1a8$export$2e2bcd8739ae039), {})
                },
                children: t("machine_to_machine_feature")
            })
        });
        // Third party app is only available for paid plan (pro plan).
        if (isThirdParty && hasThirdPartyAppsReachedLimit) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dafa1bad5a99c1ae$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                components: {
                    a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a3bc63325dc3c1a8$export$2e2bcd8739ae039), {})
                },
                children: t("third_party_apps")
            })
        });
        if (hasAppsReachedLimit) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dafa1bad5a99c1ae$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                components: {
                    a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a3bc63325dc3c1a8$export$2e2bcd8739ae039), {}),
                    planName: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $161f1bf99d56f621$export$2e2bcd8739ae039), {
                        name: planName
                    })
                },
                children: t("applications", {
                    count: quota.applicationsLimit ?? 0
                })
            })
        });
    }
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
        isLoading: isLoading,
        htmlType: "submit",
        title: "applications.create",
        size: "large",
        type: "primary",
        onClick: onClickCreate
    });
}
var $d1250b451625733f$export$2e2bcd8739ae039 = $d1250b451625733f$var$Footer;


var $011a9b02f521f8bf$export$a3bc9b8ed74fc;
var $011a9b02f521f8bf$export$7246d22ab0922ede;
var $011a9b02f521f8bf$export$bfd64c937657f93a;
var $011a9b02f521f8bf$export$4a6dd88bada4e7d2;
$011a9b02f521f8bf$export$a3bc9b8ed74fc = `iCnB3a_error`;
$011a9b02f521f8bf$export$7246d22ab0922ede = `iCnB3a_radioGroup`;
$011a9b02f521f8bf$export$bfd64c937657f93a = `iCnB3a_rotating`;
$011a9b02f521f8bf$export$4a6dd88bada4e7d2 = `iCnB3a_shimmer`;


function $4ff4f64e0646b632$var$CreateForm({ defaultCreateType: defaultCreateType, defaultCreateFrameworkName: defaultCreateFrameworkName, isDefaultCreateThirdParty: isDefaultCreateThirdParty, onClose: onClose }) {
    const { handleSubmit: handleSubmit, control: control, register: register, formState: { errors: errors, isSubmitting: isSubmitting } } = (0, $codQP.useForm)({
        defaultValues: {
            type: defaultCreateType,
            isThirdParty: isDefaultCreateThirdParty
        }
    });
    const { user: user } = (0, $8dc2d4d6918e57ba$export$2e2bcd8739ae039)();
    const { field: { onChange: onChange, value: value, name: name, ref: ref } } = (0, $codQP.useController)({
        name: "type",
        control: control,
        rules: {
            required: true
        }
    });
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const api = (0, $7VnwS.default)();
    const onSubmit = handleSubmit((0, $5OcFi.trySubmitSafe)(async (data)=>{
        if (isSubmitting) return;
        const createdApp = await api.post("api/applications", {
            json: data
        }).json();
        // Report the conversion event after the application is created. Note that the conversion
        // should be set as count once since this will be reported multiple times.
        (0, $34139a4008fff4d0$export$4d684b225153f74e)({
            gtagId: (0, $34139a4008fff4d0$export$a3b35db81871225).CreateFirstApp,
            transactionId: user?.id
        });
        (0, $FuhPC.toast).success(t("applications.application_created"));
        onClose?.(createdApp);
    }));
    const subtitleElement = (0, $jC8Vy.useMemo)(()=>{
        if (!defaultCreateFrameworkName) return "applications.subtitle";
        if (isDefaultCreateThirdParty) return "applications.create_subtitle_third_party";
        return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
            forKey: "applications.subtitle_with_app_type",
            interpolation: {
                name: defaultCreateFrameworkName
            }
        });
    }, [
        defaultCreateFrameworkName,
        isDefaultCreateThirdParty
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        shouldCloseOnEsc: true,
        isOpen: true,
        className: $dW2kG.content,
        overlayClassName: $dW2kG.overlay,
        onRequestClose: ()=>{
            onClose?.();
        },
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5vVWy.default), {
            title: "applications.create",
            subtitle: subtitleElement,
            size: defaultCreateType ? "medium" : "large",
            footer: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $d1250b451625733f$export$2e2bcd8739ae039), {
                selectedType: value,
                isLoading: isSubmitting,
                isThirdParty: isDefaultCreateThirdParty,
                onClickCreate: onSubmit
            }),
            onClose: onClose,
            children: /*#__PURE__*/ (0, $C7mD2.jsxs)("form", {
                children: [
                    !defaultCreateType && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aqmjm.default), {
                        title: "applications.select_application_type",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c8e461321115642d$export$2e2bcd8739ae039), {
                                ref: ref,
                                className: $011a9b02f521f8bf$export$7246d22ab0922ede,
                                name: name,
                                value: value,
                                type: "card",
                                onChange: onChange,
                                children: Object.values((0, $61Yml.ApplicationType))// Other application types (e.g. "Protected") should not show up in the creation modal
                                .filter((value)=>[
                                        (0, $61Yml.ApplicationType).Native,
                                        (0, $61Yml.ApplicationType).SPA,
                                        (0, $61Yml.ApplicationType).Traditional,
                                        (0, $61Yml.ApplicationType).MachineToMachine
                                    ].includes(value)).map((type)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $b4b7cf2a2e4180e8$export$2e2bcd8739ae039), {
                                        value: type,
                                        hasCheckIconForCard: type !== (0, $61Yml.ApplicationType).MachineToMachine,
                                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $746647aa0de20b4b$export$2e2bcd8739ae039), {
                                            type: type,
                                            title: t(`${(0, $59106c8950c5d39f$export$d8e4c8dab9129f15)[type]}.title`),
                                            subtitle: t(`${(0, $59106c8950c5d39f$export$d8e4c8dab9129f15)[type]}.subtitle`),
                                            description: t(`${(0, $59106c8950c5d39f$export$d8e4c8dab9129f15)[type]}.description`)
                                        })
                                    }, type))
                            }),
                            errors.type?.type === "required" && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $011a9b02f521f8bf$export$a3bc9b8ed74fc,
                                children: t("applications.no_application_type_selected")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        isRequired: true,
                        title: "applications.application_name",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                            ...register("name", {
                                required: true
                            }),
                            // eslint-disable-next-line jsx-a11y/no-autofocus
                            autoFocus: !!defaultCreateType,
                            placeholder: t("applications.application_name_placeholder"),
                            error: Boolean(errors.name)
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        title: "applications.application_description",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                            ...register("description"),
                            placeholder: t("applications.application_description_placeholder")
                        })
                    }),
                    defaultCreateType && /*#__PURE__*/ (0, $C7mD2.jsx)("input", {
                        hidden: true,
                        ...register("type"),
                        value: defaultCreateType
                    })
                ]
            })
        })
    });
}
var $4ff4f64e0646b632$export$2e2bcd8739ae039 = $4ff4f64e0646b632$var$CreateForm;


/**
 * The component for handling application creation (including create an application and setup its permissions if needed).
 */ function $87d78ab4d5324714$var$ApplicationCreation({ onCompleted: onCompleted, ...reset }) {
    const [createdMachineToMachineApplication, setCreatedMachineToMachineApplication] = (0, $jC8Vy.useState)();
    const createFormModalCloseHandler = (0, $jC8Vy.useCallback)((createdApp)=>{
        // Todo @xiaoyijun remove dev feature flag
        if ((0, $8TpMk.isDevFeaturesEnabled) && createdApp?.type === (0, $61Yml.ApplicationType).MachineToMachine) {
            setCreatedMachineToMachineApplication(createdApp);
            return;
        }
        onCompleted?.(createdApp);
    }, [
        onCompleted
    ]);
    if (createdMachineToMachineApplication) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5980bec6c22435f4$export$2e2bcd8739ae039), {
        isSkippable: true,
        isMachineToMachineRoleCreationHintVisible: true,
        entity: createdMachineToMachineApplication,
        type: (0, $61Yml.RoleType).MachineToMachine,
        modalTextOverrides: {
            title: "applications.m2m_role_assignment.title",
            subtitle: "applications.m2m_role_assignment.subtitle"
        },
        onClose: ()=>{
            onCompleted?.(createdMachineToMachineApplication);
        }
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4ff4f64e0646b632$export$2e2bcd8739ae039), {
        ...reset,
        onClose: createFormModalCloseHandler
    });
}
var $87d78ab4d5324714$export$2e2bcd8739ae039 = $87d78ab4d5324714$var$ApplicationCreation;



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $lXQZH = parcelRequire("lXQZH");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $fXNOZ = parcelRequire("fXNOZ");
var $c8znl = parcelRequire("c8znl");

var $8TpMk = parcelRequire("8TpMk");


var $jGWQ4 = parcelRequire("jGWQ4");

var $bnkR4 = parcelRequire("bnkR4");
var $31c7189f2dd71bb6$export$aa3e815946b80764;
var $31c7189f2dd71bb6$export$6d59db4903f20f7d;
var $31c7189f2dd71bb6$export$3b0508b4994f1c2d;
var $31c7189f2dd71bb6$export$e77b9811020023f0;
var $31c7189f2dd71bb6$export$70b14f10e1c53761;
var $31c7189f2dd71bb6$export$38e42c68cf43b5d4;
var $31c7189f2dd71bb6$export$7fffd76db8c31048;
var $31c7189f2dd71bb6$export$db3c28d99448dcff;
var $31c7189f2dd71bb6$export$58edefb809f879ec;
var $31c7189f2dd71bb6$export$a8ff84c12d48cfa6;
var $31c7189f2dd71bb6$export$bfd64c937657f93a;
var $31c7189f2dd71bb6$export$4a6dd88bada4e7d2;
var $31c7189f2dd71bb6$export$7abf455a094ad3ca;
$31c7189f2dd71bb6$export$aa3e815946b80764 = `_7CsCrG_card`;
$31c7189f2dd71bb6$export$6d59db4903f20f7d = `_7CsCrG_description`;
$31c7189f2dd71bb6$export$3b0508b4994f1c2d = `_7CsCrG_flexRow`;
$31c7189f2dd71bb6$export$e77b9811020023f0 = `_7CsCrG_hasBorder`;
$31c7189f2dd71bb6$export$70b14f10e1c53761 = `_7CsCrG_hasButton`;
$31c7189f2dd71bb6$export$38e42c68cf43b5d4 = `_7CsCrG_header`;
$31c7189f2dd71bb6$export$7fffd76db8c31048 = `_7CsCrG_infoWrapper`;
$31c7189f2dd71bb6$export$db3c28d99448dcff = `_7CsCrG_logo`;
$31c7189f2dd71bb6$export$58edefb809f879ec = `_7CsCrG_logoSkeleton`;
$31c7189f2dd71bb6$export$a8ff84c12d48cfa6 = `_7CsCrG_name`;
$31c7189f2dd71bb6$export$bfd64c937657f93a = `_7CsCrG_rotating`;
$31c7189f2dd71bb6$export$4a6dd88bada4e7d2 = `_7CsCrG_shimmer`;
$31c7189f2dd71bb6$export$4a6dd88bada4e7d2;
$31c7189f2dd71bb6$export$7abf455a094ad3ca = `_7CsCrG_tagWrapper`;


function $9c9bd1c7e420d345$var$GuideCard({ data: data, onClick: onClick, hasBorder: hasBorder, hasButton: hasButton }) {
    const { id: id, Logo: Logo, metadata: { target: target, name: name, description: description, isThirdParty: isThirdParty } } = data;
    const buttonText = target === "API" ? "guide.get_started" : "guide.start_building";
    const { currentPlan: currentPlan } = (0, $jC8Vy.useContext)((0, $19434c930f80c964$export$f8addfd4ab69c833));
    const showPaywallTag = (0, $8TpMk.isCloud) && isThirdParty;
    const showBetaTag = (0, $8TpMk.isCloud) && isThirdParty;
    const handleClick = (0, $jC8Vy.useCallback)(()=>{
        onClick({
            id: id,
            target: target,
            name: name,
            isThirdParty: isThirdParty
        });
    }, [
        onClick,
        id,
        target,
        name,
        isThirdParty
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($31c7189f2dd71bb6$export$aa3e815946b80764, hasBorder && $31c7189f2dd71bb6$export$e77b9811020023f0, hasButton && $31c7189f2dd71bb6$export$70b14f10e1c53761),
        ...!hasButton && {
            tabIndex: 0,
            role: "button",
            onKeyDown: (0, $bnkR4.onKeyDownHandler)(handleClick),
            onClick: handleClick
        },
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $31c7189f2dd71bb6$export$38e42c68cf43b5d4,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jC8Vy.Suspense), {
                        fallback: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $31c7189f2dd71bb6$export$58edefb809f879ec
                        }),
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)(Logo, {
                            className: $31c7189f2dd71bb6$export$db3c28d99448dcff
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $31c7189f2dd71bb6$export$7fffd76db8c31048,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                className: $31c7189f2dd71bb6$export$3b0508b4994f1c2d,
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $31c7189f2dd71bb6$export$a8ff84c12d48cfa6,
                                        children: name
                                    }),
                                    showPaywallTag || showBetaTag ? /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                        className: $31c7189f2dd71bb6$export$7abf455a094ad3ca,
                                        children: [
                                            showPaywallTag && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fXNOZ.default), {
                                                isVisible: currentPlan.quota.thirdPartyApplicationsLimit === 0,
                                                plan: (0, $lXQZH.ReservedPlanId).Pro
                                            }),
                                            showBetaTag && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c8znl.default), {})
                                        ]
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $31c7189f2dd71bb6$export$6d59db4903f20f7d,
                                title: description,
                                children: description
                            })
                        ]
                    })
                ]
            }),
            hasButton && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                title: buttonText,
                size: "small",
                onClick: handleClick
            })
        ]
    });
}
var $9c9bd1c7e420d345$export$2e2bcd8739ae039 = $9c9bd1c7e420d345$var$GuideCard;


var $35f1144554ae9286$export$85fc379452d91af0;
var $35f1144554ae9286$export$1f1f054184239bf5;
var $35f1144554ae9286$export$bfd64c937657f93a;
var $35f1144554ae9286$export$4a6dd88bada4e7d2;
$35f1144554ae9286$export$85fc379452d91af0 = `_5Dl9qW_grid`;
$35f1144554ae9286$export$1f1f054184239bf5 = `_5Dl9qW_guideGroup`;
$35f1144554ae9286$export$bfd64c937657f93a = `_5Dl9qW_rotating`;
$35f1144554ae9286$export$4a6dd88bada4e7d2 = `_5Dl9qW_shimmer`;


function $742494c24a2c2466$var$GuideCardGroup({ className: className, categoryName: categoryName, guides: guides, hasCardBorder: hasCardBorder, hasCardButton: hasCardButton, onClickGuide: onClickGuide }, ref) {
    if (!guides?.length) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($35f1144554ae9286$export$1f1f054184239bf5, className),
        children: [
            categoryName && /*#__PURE__*/ (0, $C7mD2.jsx)("label", {
                children: categoryName
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $35f1144554ae9286$export$85fc379452d91af0,
                children: guides.map((guide)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $9c9bd1c7e420d345$export$2e2bcd8739ae039), {
                        hasBorder: hasCardBorder,
                        hasButton: hasCardButton,
                        data: guide,
                        onClick: onClickGuide
                    }, guide.id))
            })
        ]
    });
}
var $742494c24a2c2466$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $jC8Vy.forwardRef)($742494c24a2c2466$var$GuideCardGroup);



var $jC8Vy = parcelRequire("jC8Vy");

var $fiyfZ = parcelRequire("fiyfZ");

const $c14feef50a46e3d8$var$defaultStructuredMetadata = {
    featured: [],
    Traditional: [],
    SPA: [],
    Native: [],
    MachineToMachine: [],
    Protected: [],
    ThirdParty: []
};
const $c14feef50a46e3d8$export$6bb65ec2faabc0af = ()=>(0, $fiyfZ.default).filter(({ metadata: { target: target } })=>target === "API");
const $c14feef50a46e3d8$export$6b80cd72646f4cab = ()=>{
    const appGuides = (0, $jC8Vy.useMemo)(()=>(0, $fiyfZ.default).filter(({ metadata: { target: target } })=>target !== "API"), []);
    const getFilteredAppGuideMetadata = (0, $jC8Vy.useCallback)((filters)=>{
        const { categories: filterCategories, keyword: keyword } = filters ?? {};
        // If no filter is applied, return all metadata
        if (!filterCategories?.length && !keyword) return appGuides;
        // Keyword only, return partial name matched result
        if (keyword && !filterCategories?.length) return appGuides.filter(({ metadata: { name: name } })=>name.toLowerCase().includes(keyword.toLowerCase()));
        // Categories only, return selected categories
        if (!keyword && filterCategories?.length) return appGuides.filter(({ metadata: { target: target, isFeatured: isFeatured, isThirdParty: isThirdParty } })=>filterCategories.some((filterCategory)=>{
                return filterCategory === target || // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                isFeatured && filterCategory === "featured" || isThirdParty && filterCategory === "ThirdParty";
            }));
        // Keyword and categories, return partial name matched result in selected categories
        if (keyword && filterCategories?.length) return appGuides.filter(({ metadata: { name: name, target: target, isFeatured: isFeatured } })=>name.toLowerCase().includes(keyword.toLowerCase()) && filterCategories.some((filterCategory)=>filterCategory === target || isFeatured && filterCategory === "featured"));
        return [];
    }, [
        appGuides
    ]);
    const getStructuredAppGuideMetadata = (0, $jC8Vy.useCallback)((filters)=>{
        const filteredMetadata = getFilteredAppGuideMetadata(filters);
        return filteredMetadata.reduce((accumulated, guide)=>{
            const { target: target, isFeatured: isFeatured, isThirdParty: isThirdParty } = guide.metadata;
            // Rule out API target guides to make TypeScript happy
            if (target === "API") return accumulated;
            if (isThirdParty) return {
                ...accumulated,
                [(0, $59106c8950c5d39f$export$914bc6e40242037e)]: [
                    ...accumulated[0, $59106c8950c5d39f$export$914bc6e40242037e],
                    guide
                ]
            };
            return {
                ...accumulated,
                [target]: [
                    ...accumulated[target],
                    guide
                ],
                ...isFeatured && {
                    featured: [
                        ...accumulated.featured,
                        guide
                    ]
                }
            };
        }, $c14feef50a46e3d8$var$defaultStructuredMetadata);
    }, [
        getFilteredAppGuideMetadata
    ]);
    return {
        getFilteredAppGuideMetadata: getFilteredAppGuideMetadata,
        getStructuredAppGuideMetadata: getStructuredAppGuideMetadata
    };
};



var $5TsIB = parcelRequire("5TsIB");
parcelRequire("8Mb3E");
var $bt3dS = parcelRequire("bt3dS");

var $8TpMk = parcelRequire("8TpMk");

var $fG7L1 = parcelRequire("fG7L1");

var $jGWQ4 = parcelRequire("jGWQ4");

var $gC7hG = parcelRequire("gC7hG");

var $jbKqE = parcelRequire("jbKqE");

var $9Q3SI = parcelRequire("9Q3SI");

var $4ZcUR = parcelRequire("4ZcUR");

var $jheqv = parcelRequire("jheqv");

var $jC8Vy = parcelRequire("jC8Vy");
const $db44c573c0c8fb99$var$useWindowResize = (callback)=>{
    const callbackRef = (0, $jC8Vy.useRef)(callback);
    (0, $jC8Vy.useEffect)(()=>{
        // eslint-disable-next-line @silverhand/fp/no-mutation
        callbackRef.current = callback;
    }, [
        callback
    ]);
    (0, $jC8Vy.useLayoutEffect)(()=>{
        const handler = (event)=>{
            callbackRef.current(event);
        };
        handler();
        window.addEventListener("resize", handler);
        return ()=>{
            window.removeEventListener("resize", handler);
        };
    }, []);
};
var $db44c573c0c8fb99$export$2e2bcd8739ae039 = $db44c573c0c8fb99$var$useWindowResize;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("4taJ0");
var $5rMXH = parcelRequire("5rMXH");

var $codQP = parcelRequire("codQP");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $kUZ14 = parcelRequire("kUZ14");

var $aqmjm = parcelRequire("aqmjm");

var $5vVWy = parcelRequire("5vVWy");

var $fmHmG = parcelRequire("fmHmG");

var $9Q3SI = parcelRequire("9Q3SI");

var $7VnwS = parcelRequire("7VnwS");

var $dW2kG = parcelRequire("dW2kG");

var $5OcFi = parcelRequire("5OcFi");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $lXQZH = parcelRequire("lXQZH");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");





var $jGWQ4 = parcelRequire("jGWQ4");
parcelRequire("cuPVN");
var $9XFlr = parcelRequire("9XFlr");

var $jC8Vy = parcelRequire("jC8Vy");

var $voszV = parcelRequire("voszV");

var $8TpMk = parcelRequire("8TpMk");


const $061553e9dfc672b8$var$useApiResourcesUsage = ()=>{
    const { currentPlan: currentPlan } = (0, $jC8Vy.useContext)((0, $19434c930f80c964$export$f8addfd4ab69c833));
    /**
   * Note: we only need to fetch all resources when the user is in cloud environment.
   * The oss version doesn't have the quota limit.
   */ const { data: allResources } = (0, $voszV.default)((0, $8TpMk.isCloud) && "api/resources");
    const resourceCount = (0, $jC8Vy.useMemo)(()=>allResources?.filter(({ indicator: indicator })=>!(0, $9XFlr.isManagementApi)(indicator)).length ?? 0, [
        allResources
    ]);
    const hasReachedLimit = (0, $jC8Vy.useMemo)(()=>(0, $605aee781e0fe83f$export$1cc4b5152472cd4f)({
            quotaKey: "resourcesLimit",
            plan: currentPlan,
            usage: resourceCount
        }), [
        currentPlan,
        resourceCount
    ]);
    const hasSurpassedLimit = (0, $jC8Vy.useMemo)(()=>(0, $605aee781e0fe83f$export$6486e974a84ab8b6)({
            quotaKey: "resourcesLimit",
            plan: currentPlan,
            usage: resourceCount
        }), [
        currentPlan,
        resourceCount
    ]);
    return {
        hasReachedLimit: hasReachedLimit,
        hasSurpassedLimit: hasSurpassedLimit
    };
};
var $061553e9dfc672b8$export$2e2bcd8739ae039 = $061553e9dfc672b8$var$useApiResourcesUsage;


function $0d56097a1f52df29$var$Footer({ isCreationLoading: isCreationLoading, onClickCreate: onClickCreate }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { currentPlan: currentPlan } = (0, $jC8Vy.useContext)((0, $19434c930f80c964$export$f8addfd4ab69c833));
    const { hasReachedLimit: hasReachedLimit } = (0, $061553e9dfc672b8$export$2e2bcd8739ae039)();
    if (hasReachedLimit && /**
     * We don't guard API resources quota limit for paid plan, since it's an add-on feature
     */ currentPlan.id === (0, $lXQZH.ReservedPlanId).Free) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dafa1bad5a99c1ae$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
            components: {
                a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a3bc63325dc3c1a8$export$2e2bcd8739ae039), {}),
                planName: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $161f1bf99d56f621$export$2e2bcd8739ae039), {
                    name: currentPlan.name
                })
            },
            children: t("upsell.paywall.resources", {
                count: currentPlan.quota.resourcesLimit ?? 0
            })
        })
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
        isLoading: isCreationLoading,
        htmlType: "submit",
        title: "api_resources.create",
        size: "large",
        type: "primary",
        onClick: onClickCreate
    });
}
var $0d56097a1f52df29$export$2e2bcd8739ae039 = $0d56097a1f52df29$var$Footer;


function $297779ffbed99380$var$CreateForm({ onClose: onClose }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { handleSubmit: handleSubmit, register: register, formState: { isSubmitting: isSubmitting, errors: errors } } = (0, $codQP.useForm)();
    const api = (0, $7VnwS.default)();
    const onSubmit = handleSubmit((0, $5OcFi.trySubmitSafe)(async (data)=>{
        if (isSubmitting) return;
        const createdApiResource = await api.post("api/resources", {
            json: data
        }).json();
        (0, $FuhPC.toast).success(t("api_resources.api_resource_created", {
            name: createdApiResource.name
        }));
        onClose?.(createdApiResource);
    }));
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        shouldCloseOnEsc: true,
        isOpen: true,
        className: $dW2kG.content,
        overlayClassName: $dW2kG.overlay,
        onRequestClose: ()=>{
            onClose?.();
        },
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5vVWy.default), {
            title: "api_resources.create",
            subtitle: "api_resources.subtitle",
            footer: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0d56097a1f52df29$export$2e2bcd8739ae039), {
                isCreationLoading: isSubmitting,
                onClickCreate: onSubmit
            }),
            onClose: onClose,
            children: /*#__PURE__*/ (0, $C7mD2.jsxs)("form", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        isRequired: true,
                        title: "api_resources.api_name",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                            // eslint-disable-next-line jsx-a11y/no-autofocus
                            autoFocus: true,
                            ...register("name", {
                                required: true
                            }),
                            placeholder: t("api_resources.api_name_placeholder")
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        isRequired: true,
                        title: "api_resources.api_identifier",
                        tip: (closeTipHandler)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                                components: {
                                    a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                                        targetBlank: true,
                                        href: "https://datatracker.ietf.org/doc/html/rfc8707#section-2",
                                        onClick: closeTipHandler
                                    })
                                },
                                children: t("api_resources.api_identifier_tip")
                            }),
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                            ...register("indicator", {
                                required: true,
                                validate: (value)=>(0, $5rMXH.isValidUrl)(value) || t("api_resources.invalid_resource_indicator_format")
                            }),
                            placeholder: t("api_resources.api_identifier_placeholder"),
                            error: errors.indicator?.message
                        })
                    })
                ]
            })
        })
    });
}
var $297779ffbed99380$export$2e2bcd8739ae039 = $297779ffbed99380$var$CreateForm;



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $6bq3s = parcelRequire("6bq3s");

var $voszV = parcelRequire("voszV");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");


var $75SRw = parcelRequire("75SRw");
parcelRequire("fIF1D");
var $16GE9 = parcelRequire("16GE9");
function $db1495a4b735df6f$var$OpenExternalLink({ link: link }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $16GE9.default), {
        content: t("general.open"),
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
            size: "small",
            onClick: ()=>{
                window.open(link, "_blank");
            },
            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4bc930fbe25d753c$export$2e2bcd8739ae039), {})
        })
    });
}
var $db1495a4b735df6f$export$2e2bcd8739ae039 = $db1495a4b735df6f$var$OpenExternalLink;



var $cw2No = parcelRequire("cw2No");


var $4ZcUR = parcelRequire("4ZcUR");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $m3h86 = parcelRequire("m3h86");

var $lwdI3 = parcelRequire("lwdI3");
parcelRequire("fXNOZ");
var $c8znl = parcelRequire("c8znl");

var $jGWQ4 = parcelRequire("jGWQ4");

var $9Q3SI = parcelRequire("9Q3SI");


var $jheqv = parcelRequire("jheqv");

var $C7mD2 = parcelRequire("C7mD2");

var $kUZ14 = parcelRequire("kUZ14");

var $5vVWy = parcelRequire("5vVWy");

var $dW2kG = parcelRequire("dW2kG");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("4taJ0");
var $5rMXH = parcelRequire("5rMXH");
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
parcelRequire("ajkVG");
var $1Iqyx = parcelRequire("1Iqyx");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $5UrGx = parcelRequire("5UrGx");

var $5cXXM = parcelRequire("5cXXM");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $Xh5AE = parcelRequire("Xh5AE");




var $8TpMk = parcelRequire("8TpMk");


var $jGWQ4 = parcelRequire("jGWQ4");

var $aqmjm = parcelRequire("aqmjm");

var $fmHmG = parcelRequire("fmHmG");

var $9Q3SI = parcelRequire("9Q3SI");

var $7VnwS = parcelRequire("7VnwS");


var $4ZcUR = parcelRequire("4ZcUR");
var $c661d5dae66c2ada$export$7b03b12ff8298fc8;
var $c661d5dae66c2ada$export$21779e503be4cd98;
var $c661d5dae66c2ada$export$79ceb6365251b71a;
var $c661d5dae66c2ada$export$e0f35d825088c098;
var $c661d5dae66c2ada$export$dccc8485bc7d2332;
var $c661d5dae66c2ada$export$b610b8812bbcded9;
var $c661d5dae66c2ada$export$b7e3ae3d7c15e42e;
var $c661d5dae66c2ada$export$f83f8be4d5ed7815;
var $c661d5dae66c2ada$export$bfd64c937657f93a;
var $c661d5dae66c2ada$export$4a6dd88bada4e7d2;
var $c661d5dae66c2ada$export$390c86fe1c232dc3;
var $c661d5dae66c2ada$export$d675b3969e4857cb;
var $c661d5dae66c2ada$export$39d1f22b6d431806;
$c661d5dae66c2ada$export$7b03b12ff8298fc8 = `LxmOYW_dashedLine`;
$c661d5dae66c2ada$export$21779e503be4cd98 = `LxmOYW_domain`;
$c661d5dae66c2ada$export$79ceb6365251b71a = `LxmOYW_domainFieldWrapper`;
$c661d5dae66c2ada$export$e0f35d825088c098 = `LxmOYW_field`;
$c661d5dae66c2ada$export$dccc8485bc7d2332 = `LxmOYW_formFieldWrapper`;
$c661d5dae66c2ada$export$b610b8812bbcded9 = `LxmOYW_index`;
$c661d5dae66c2ada$export$b7e3ae3d7c15e42e = `LxmOYW_input`;
$c661d5dae66c2ada$export$f83f8be4d5ed7815 = `LxmOYW_leftAligned`;
$c661d5dae66c2ada$export$bfd64c937657f93a = `LxmOYW_rotating`;
$c661d5dae66c2ada$export$4a6dd88bada4e7d2 = `LxmOYW_shimmer`;
$c661d5dae66c2ada$export$390c86fe1c232dc3 = `LxmOYW_subdomain`;
$c661d5dae66c2ada$export$d675b3969e4857cb = `LxmOYW_submitButton`;
$c661d5dae66c2ada$export$39d1f22b6d431806 = `LxmOYW_withDashedLine`;


function $e4a38463a6eb99d6$var$ProtectedAppForm({ className: className, buttonAlignment: buttonAlignment = "right", buttonSize: buttonSize = "large", buttonText: buttonText = "protected_app.form.create_application", hasDetailedInstructions: hasDetailedInstructions, hasRequiredLabel: hasRequiredLabel, onCreateSuccess: onCreateSuccess }) {
    const { data: data } = (0, $Xh5AE.default)((0, $8TpMk.isCloud) && "api/systems/application");
    const { currentPlan: currentPlan } = (0, $jC8Vy.useContext)((0, $19434c930f80c964$export$f8addfd4ab69c833));
    const { hasAppsReachedLimit: hasAppsReachedLimit } = (0, $d2d1111984d2f594$export$2e2bcd8739ae039)();
    const { name: planName, quota: quota } = currentPlan;
    const defaultDomain = data?.protectedApps.defaultDomain ?? "";
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { register: register, handleSubmit: handleSubmit, setError: setError, formState: { errors: errors, isSubmitting: isSubmitting } } = (0, $codQP.useForm)({
        mode: "onBlur"
    });
    const api = (0, $7VnwS.default)({
        hideErrorToast: true
    });
    const onSubmit = handleSubmit(async (data)=>{
        if (isSubmitting) return;
        try {
            const createdApp = await api.post("api/applications", {
                json: {
                    // App name is subdomain on create, but user can change it later in app details.
                    name: data.subDomain,
                    type: (0, $61Yml.ApplicationType).Protected,
                    protectedAppMetadata: data
                }
            }).json();
            (0, $FuhPC.toast).success(t("applications.application_created"));
            onCreateSuccess?.(createdApp);
            navigate(`/applications/${createdApp.id}`);
        } catch (error) {
            if (error instanceof (0, $5cXXM.HTTPError)) {
                const { code: code, message: message } = await error.response.json();
                if (code === "application.protected_application_subdomain_exists") {
                    setError("subDomain", {
                        type: "custom",
                        message: message
                    });
                    return;
                }
                if (error.response.status !== 401) {
                    (0, $FuhPC.toast).error(message);
                    return;
                }
                throw error;
            }
            throw error;
        }
    });
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("form", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $c661d5dae66c2ada$export$dccc8485bc7d2332,
                children: [
                    hasDetailedInstructions && /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $c661d5dae66c2ada$export$39d1f22b6d431806,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $c661d5dae66c2ada$export$b610b8812bbcded9,
                                children: "1"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $c661d5dae66c2ada$export$7b03b12ff8298fc8
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        isRequired: hasRequiredLabel,
                        className: $c661d5dae66c2ada$export$e0f35d825088c098,
                        title: "protected_app.form.url_field_label",
                        description: (0, $7oDSS.conditional)(hasDetailedInstructions && "protected_app.form.url_field_description"),
                        descriptionPosition: (0, $7oDSS.conditional)(hasDetailedInstructions && "top"),
                        tip: (0, $7oDSS.conditional)(!hasDetailedInstructions && t("protected_app.form.url_field_tooltip")),
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                            inputContainerClassName: $c661d5dae66c2ada$export$b7e3ae3d7c15e42e,
                            ...register("origin", {
                                required: true,
                                validate: (value)=>{
                                    if (!(0, $5rMXH.validateUriOrigin)(value)) return t("protected_app.form.errors.invalid_url");
                                    if ((0, $5rMXH.isLocalhost)(value)) return t("protected_app.form.errors.localhost");
                                    return true;
                                }
                            }),
                            placeholder: t("protected_app.form.url_field_placeholder"),
                            error: // Error message can only be string, manually add link to the message
                            errors.origin?.message === t("protected_app.form.errors.localhost") ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                                components: {
                                    a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                                        to: "https://docs.logto.io/docs/recipes/protected-app/#local-development"
                                    })
                                },
                                children: t("protected_app.form.errors.localhost")
                            }) : // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                            errors.origin?.message || errors.origin?.type === "required" && t("protected_app.form.errors.url_required")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $c661d5dae66c2ada$export$dccc8485bc7d2332,
                children: [
                    hasDetailedInstructions && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $c661d5dae66c2ada$export$b610b8812bbcded9,
                        children: "2"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        isRequired: hasRequiredLabel,
                        className: $c661d5dae66c2ada$export$e0f35d825088c098,
                        title: "protected_app.form.domain_field_label",
                        description: `protected_app.form.domain_field_description${hasDetailedInstructions ? "" : "_short"}`,
                        descriptionPosition: (0, $7oDSS.conditional)(hasDetailedInstructions && "top"),
                        tip: (0, $7oDSS.conditional)(!hasDetailedInstructions && t("protected_app.form.domain_field_tooltip", {
                            domain: defaultDomain
                        })),
                        children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                            className: $c661d5dae66c2ada$export$79ceb6365251b71a,
                            children: [
                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                    className: $c661d5dae66c2ada$export$390c86fe1c232dc3,
                                    inputContainerClassName: $c661d5dae66c2ada$export$b7e3ae3d7c15e42e,
                                    ...register("subDomain", {
                                        required: true,
                                        validate: (value)=>(0, $1Iqyx.isValidSubdomain)(value) || t("protected_app.form.errors.invalid_domain_format")
                                    }),
                                    placeholder: t("protected_app.form.domain_field_placeholder"),
                                    error: // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                                    errors.subDomain?.message || errors.subDomain?.type === "required" && t("protected_app.form.errors.domain_required")
                                }),
                                defaultDomain && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                    className: $c661d5dae66c2ada$export$21779e503be4cd98,
                                    children: (0, $7oDSS.condString)(defaultDomain && `.${defaultDomain}`)
                                })
                            ]
                        })
                    })
                ]
            }),
            hasAppsReachedLimit ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dafa1bad5a99c1ae$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                    components: {
                        a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a3bc63325dc3c1a8$export$2e2bcd8739ae039), {}),
                        planName: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $161f1bf99d56f621$export$2e2bcd8739ae039), {
                            name: planName
                        })
                    },
                    children: t("upsell.paywall.applications", {
                        count: quota.applicationsLimit ?? 0
                    })
                })
            }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($c661d5dae66c2ada$export$d675b3969e4857cb, buttonAlignment === "left" && $c661d5dae66c2ada$export$f83f8be4d5ed7815),
                size: buttonSize,
                type: "primary",
                title: buttonText,
                isLoading: isSubmitting,
                onClick: onSubmit
            })
        ]
    });
}
var $e4a38463a6eb99d6$export$2e2bcd8739ae039 = $e4a38463a6eb99d6$var$ProtectedAppForm;


function $3474f316e95df9b9$var$ProtectedAppModal({ onClose: onClose }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        shouldCloseOnEsc: true,
        isOpen: true,
        className: $dW2kG.content,
        overlayClassName: $dW2kG.overlay,
        onRequestClose: ()=>{
            onClose?.();
        },
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5vVWy.default), {
            title: "protected_app.modal_title",
            subtitle: "protected_app.modal_subtitle",
            size: "large",
            onClose: onClose,
            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e4a38463a6eb99d6$export$2e2bcd8739ae039), {
                hasRequiredLabel: true,
                onCreateSuccess: onClose
            })
        })
    });
}
var $3474f316e95df9b9$export$2e2bcd8739ae039 = $3474f316e95df9b9$var$ProtectedAppModal;


var $0020f631ab877249$export$aa3e815946b80764;
var $0020f631ab877249$export$2839a4a39e4d1879;
var $0020f631ab877249$export$34e0f9847d4c02dd;
var $0020f631ab877249$export$6d59db4903f20f7d;
var $0020f631ab877249$export$e77b9811020023f0;
var $0020f631ab877249$export$1237798dc640739a;
var $0020f631ab877249$export$db3c28d99448dcff;
var $0020f631ab877249$export$bfd64c937657f93a;
var $0020f631ab877249$export$4a6dd88bada4e7d2;
var $0020f631ab877249$export$fb184b623420d9be;
var $0020f631ab877249$export$b4f7f414760e829;
$0020f631ab877249$export$aa3e815946b80764 = `E3m9jq_card`;
$0020f631ab877249$export$2839a4a39e4d1879 = `E3m9jq_columnWrapper`;
$0020f631ab877249$export$34e0f9847d4c02dd = `E3m9jq_container`;
$0020f631ab877249$export$6d59db4903f20f7d = `E3m9jq_description`;
$0020f631ab877249$export$e77b9811020023f0 = `E3m9jq_hasBorder`;
$0020f631ab877249$export$1237798dc640739a = `E3m9jq_label`;
$0020f631ab877249$export$db3c28d99448dcff = `E3m9jq_logo`;
$0020f631ab877249$export$bfd64c937657f93a = `E3m9jq_rotating`;
$0020f631ab877249$export$4a6dd88bada4e7d2 = `E3m9jq_shimmer`;
$0020f631ab877249$export$fb184b623420d9be = `E3m9jq_title`;
$0020f631ab877249$export$b4f7f414760e829 = `E3m9jq_titleRowWrapper`;


function $a0d482ac4311ce46$var$ProtectedAppCard({ className: className, isInAppCreationPage: isInAppCreationPage, hasBorder: hasBorder, hasCreateButton: hasCreateButton, onCreateSuccess: onCreateSuccess }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.protected_app"
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $b595fc2f0eccd19a$export$2e2bcd8739ae039)();
    const [showCreateModal, setShowCreateModal] = (0, $jC8Vy.useState)(false);
    const theme = (0, $jheqv.default)();
    const Icon = theme === (0, $5HVJe.Theme).Light ? (0, $lwdI3.default) : (0, $m3h86.default);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($0020f631ab877249$export$34e0f9847d4c02dd, className),
                children: [
                    isInAppCreationPage && /*#__PURE__*/ (0, $C7mD2.jsx)("label", {
                        children: t("name")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($0020f631ab877249$export$aa3e815946b80764, hasBorder && $0020f631ab877249$export$e77b9811020023f0),
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)(Icon, {
                                className: $0020f631ab877249$export$db3c28d99448dcff
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                className: $0020f631ab877249$export$2839a4a39e4d1879,
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                        className: $0020f631ab877249$export$b4f7f414760e829,
                                        children: [
                                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                className: isInAppCreationPage ? $0020f631ab877249$export$1237798dc640739a : $0020f631ab877249$export$fb184b623420d9be,
                                                children: t(isInAppCreationPage ? "name" : "title")
                                            }),
                                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c8znl.default), {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $0020f631ab877249$export$6d59db4903f20f7d,
                                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                                            components: {
                                                a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                                                    href: getDocumentationUrl("/docs/recipes/protected-app/"),
                                                    targetBlank: "noopener"
                                                })
                                            },
                                            children: t("description")
                                        })
                                    })
                                ]
                            }),
                            hasCreateButton && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                                title: "protected_app.fast_create",
                                onClick: ()=>{
                                    setShowCreateModal(true);
                                }
                            })
                        ]
                    })
                ]
            }),
            showCreateModal && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3474f316e95df9b9$export$2e2bcd8739ae039), {
                onClose: (app)=>{
                    setShowCreateModal(false);
                    if (app) onCreateSuccess?.(app);
                }
            })
        ]
    });
}
var $a0d482ac4311ce46$export$2e2bcd8739ae039 = $a0d482ac4311ce46$var$ProtectedAppCard;



var $6cc740a519c3064a$export$729c8b7179294ba;
var $6cc740a519c3064a$export$dbd89fd7a9dba0cb;
var $6cc740a519c3064a$export$2839a4a39e4d1879;
var $6cc740a519c3064a$export$34e0f9847d4c02dd;
var $6cc740a519c3064a$export$6d59db4903f20f7d;
var $6cc740a519c3064a$export$6210fa4921d2a466;
var $6cc740a519c3064a$export$7cf03eaf8fbb2827;
var $6cc740a519c3064a$export$1ca1ec8b29a4ce27;
var $6cc740a519c3064a$export$1237798dc640739a;
var $6cc740a519c3064a$export$8837f4fc672e936d;
var $6cc740a519c3064a$export$3e7bcdf53d3c4af3;
var $6cc740a519c3064a$export$e29295a1512d5ff3;
var $6cc740a519c3064a$export$bfd64c937657f93a;
var $6cc740a519c3064a$export$3e523c77c1f23f8c;
var $6cc740a519c3064a$export$4a6dd88bada4e7d2;
var $6cc740a519c3064a$export$471f7ae5c4103ae1;
var $6cc740a519c3064a$export$fb184b623420d9be;
$6cc740a519c3064a$export$729c8b7179294ba = `TxnFKG_app`;
$6cc740a519c3064a$export$dbd89fd7a9dba0cb = `TxnFKG_bone`;
$6cc740a519c3064a$export$2839a4a39e4d1879 = `TxnFKG_columnWrapper`;
$6cc740a519c3064a$export$34e0f9847d4c02dd = `TxnFKG_container`;
$6cc740a519c3064a$export$6d59db4903f20f7d = `TxnFKG_description`;
$6cc740a519c3064a$export$6210fa4921d2a466 = `TxnFKG_form`;
$6cc740a519c3064a$export$7cf03eaf8fbb2827 = `TxnFKG_hostName`;
$6cc740a519c3064a$export$1ca1ec8b29a4ce27 = `TxnFKG_icon`;
$6cc740a519c3064a$export$1237798dc640739a = `TxnFKG_label`;
$6cc740a519c3064a$export$8837f4fc672e936d = `TxnFKG_list`;
$6cc740a519c3064a$export$3e7bcdf53d3c4af3 = `TxnFKG_loadingSkeleton`;
$6cc740a519c3064a$export$e29295a1512d5ff3 = `TxnFKG_protectedApps`;
$6cc740a519c3064a$export$bfd64c937657f93a = `TxnFKG_rotating`;
$6cc740a519c3064a$export$3e523c77c1f23f8c = `TxnFKG_separator`;
$6cc740a519c3064a$export$4a6dd88bada4e7d2 = `TxnFKG_shimmer`;
$6cc740a519c3064a$export$4a6dd88bada4e7d2;
$6cc740a519c3064a$export$471f7ae5c4103ae1 = `TxnFKG_status`;
$6cc740a519c3064a$export$fb184b623420d9be = `TxnFKG_title`;


function $312648e8b3e3db05$var$ProtectedAppCreationForm() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getTo: getTo } = (0, $4ZcUR.default)();
    const { data: data, isLoading: isLoading, mutate: mutate } = (0, $voszV.default)("api/applications?types=Protected");
    const { hasAppsReachedLimit: hasAppsReachedLimit } = (0, $d2d1111984d2f594$export$2e2bcd8739ae039)();
    const hasProtectedApps = !isLoading && !!data?.length;
    const showCreationForm = !hasProtectedApps && !hasAppsReachedLimit;
    const mutateApps = (0, $jC8Vy.useCallback)((app)=>{
        mutate([
            ...data ?? [],
            app
        ]);
    }, [
        data,
        mutate
    ]);
    if (isLoading) return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $6cc740a519c3064a$export$3e7bcdf53d3c4af3,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($6cc740a519c3064a$export$dbd89fd7a9dba0cb, $6cc740a519c3064a$export$1ca1ec8b29a4ce27)
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $6cc740a519c3064a$export$2839a4a39e4d1879,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($6cc740a519c3064a$export$dbd89fd7a9dba0cb, $6cc740a519c3064a$export$fb184b623420d9be)
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($6cc740a519c3064a$export$dbd89fd7a9dba0cb, $6cc740a519c3064a$export$6d59db4903f20f7d)
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $6cc740a519c3064a$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a0d482ac4311ce46$export$2e2bcd8739ae039), {
                hasCreateButton: !showCreationForm,
                onCreateSuccess: mutateApps
            }),
            showCreationForm && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $6cc740a519c3064a$export$3e523c77c1f23f8c
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $6cc740a519c3064a$export$6210fa4921d2a466,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e4a38463a6eb99d6$export$2e2bcd8739ae039), {
                            hasDetailedInstructions: true,
                            buttonAlignment: "left",
                            buttonText: "protected_app.form.create_protected_app",
                            buttonSize: "medium",
                            onCreateSuccess: mutateApps
                        })
                    })
                ]
            }),
            hasProtectedApps && /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $6cc740a519c3064a$export$e29295a1512d5ff3,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $6cc740a519c3064a$export$1237798dc640739a,
                        children: t("protected_app.success_message")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $6cc740a519c3064a$export$8837f4fc672e936d,
                        children: data.map((app)=>{
                            const { host: host, customDomains: customDomains } = app.protectedAppMetadata ?? {};
                            const domain = customDomains?.[0]?.domain ?? host;
                            return !!domain && /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                className: $6cc740a519c3064a$export$729c8b7179294ba,
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $6cc740a519c3064a$export$471f7ae5c4103ae1
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6bq3s.Link), {
                                        className: $6cc740a519c3064a$export$7cf03eaf8fbb2827,
                                        to: getTo(`/applications/${app.id}`),
                                        children: domain
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
                                        value: domain,
                                        variant: "icon"
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $db1495a4b735df6f$export$2e2bcd8739ae039), {
                                        link: `https://${domain}`
                                    })
                                ]
                            }, app.id);
                        })
                    })
                ]
            })
        ]
    });
}
var $312648e8b3e3db05$export$2e2bcd8739ae039 = $312648e8b3e3db05$var$ProtectedAppCreationForm;


var $d060f94231e13b1e$export$ed32643c9618a26;
var $d060f94231e13b1e$export$bbea856fdb3e3c5f;
var $d060f94231e13b1e$export$aa3e815946b80764;
var $d060f94231e13b1e$export$2839a4a39e4d1879;
var $d060f94231e13b1e$export$34e0f9847d4c02dd;
var $d060f94231e13b1e$export$85fc379452d91af0;
var $d060f94231e13b1e$export$38e42c68cf43b5d4;
var $d060f94231e13b1e$export$1ca1ec8b29a4ce27;
var $d060f94231e13b1e$export$bfd64c937657f93a;
var $d060f94231e13b1e$export$d3257a3edf3cda05;
var $d060f94231e13b1e$export$4a6dd88bada4e7d2;
var $d060f94231e13b1e$export$c96745152eb2740f;
var $d060f94231e13b1e$export$fb184b623420d9be;
$d060f94231e13b1e$export$ed32643c9618a26 = `vUugRG_borderBox`;
$d060f94231e13b1e$export$bbea856fdb3e3c5f = `vUugRG_buttons`;
$d060f94231e13b1e$export$aa3e815946b80764 = `vUugRG_card`;
$d060f94231e13b1e$export$2839a4a39e4d1879 = `vUugRG_columnWrapper`;
$d060f94231e13b1e$export$34e0f9847d4c02dd = `vUugRG_container`;
$d060f94231e13b1e$export$85fc379452d91af0 = `vUugRG_grid`;
$d060f94231e13b1e$export$38e42c68cf43b5d4 = `vUugRG_header`;
$d060f94231e13b1e$export$1ca1ec8b29a4ce27 = `vUugRG_icon`;
$d060f94231e13b1e$export$bfd64c937657f93a = `vUugRG_rotating`;
$d060f94231e13b1e$export$d3257a3edf3cda05 = `vUugRG_rowWrapper`;
$d060f94231e13b1e$export$4a6dd88bada4e7d2 = `vUugRG_shimmer`;
$d060f94231e13b1e$export$c96745152eb2740f = `vUugRG_subtitle`;
$d060f94231e13b1e$export$fb184b623420d9be = `vUugRG_title`;


const $1ab7b740c116daef$var$icons = {
    [(0, $5HVJe.Theme).Light]: {
        PreviewIcon: (0, $b876cba539dbc053$export$2e2bcd8739ae039),
        SocialIcon: (0, $486da8ad3ff29fcc$export$2e2bcd8739ae039),
        RbacIcon: (0, $eebf51cb571e115c$export$2e2bcd8739ae039)
    },
    [(0, $5HVJe.Theme).Dark]: {
        PreviewIcon: (0, $0e9c330ef0ca550a$export$2e2bcd8739ae039),
        SocialIcon: (0, $968f10368190a6e1$export$2e2bcd8739ae039),
        RbacIcon: (0, $c50dbe7fa70b800f$export$2e2bcd8739ae039)
    }
};
function $1ab7b740c116daef$var$GetStarted() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const { tenantEndpoint: tenantEndpoint } = (0, $jC8Vy.useContext)((0, $fG7L1.AppDataContext));
    const [selectedGuide, setSelectedGuide] = (0, $jC8Vy.useState)();
    const { getStructuredAppGuideMetadata: getStructuredAppGuideMetadata } = (0, $c14feef50a46e3d8$export$6b80cd72646f4cab)();
    const apiGuideMetadata = (0, $c14feef50a46e3d8$export$6bb65ec2faabc0af)();
    const [showCreateAppForm, setShowCreateAppForm] = (0, $jC8Vy.useState)(false);
    const [showCreateApiForm, setShowCreateApiForm] = (0, $jC8Vy.useState)(false);
    // The number of visible guide cards to show in one row per the current screen width
    const [visibleCardCount, setVisibleCardCount] = (0, $jC8Vy.useState)(4);
    const containerRef = (0, $jC8Vy.useRef)(null);
    const theme = (0, $jheqv.default)();
    const { PreviewIcon: PreviewIcon, SocialIcon: SocialIcon, RbacIcon: RbacIcon } = $1ab7b740c116daef$var$icons[theme];
    (0, $db44c573c0c8fb99$export$2e2bcd8739ae039)(()=>{
        const containerWidth = containerRef.current?.clientWidth ?? 0;
        // Responsive breakpoints (1080, 680px) are defined in `GuideCardGroup` component SCSS,
        // and we need to keep them consistent.
        setVisibleCardCount(containerWidth > 1080 ? 4 : containerWidth > 680 ? 3 : 2);
    });
    /**
   * Slice the guide metadata as we only need to show 1 row of guide cards in get-started page
   */ const featuredAppGuides = (0, $jC8Vy.useMemo)(()=>getStructuredAppGuideMetadata().featured.slice(0, visibleCardCount), [
        visibleCardCount,
        getStructuredAppGuideMetadata
    ]);
    const onClickAppGuide = (0, $jC8Vy.useCallback)((data)=>{
        setShowCreateAppForm(true);
        setSelectedGuide(data);
    }, []);
    const onAppCreationCompleted = (0, $jC8Vy.useCallback)((newApp)=>{
        if (newApp && selectedGuide) {
            navigate(`/applications/${newApp.id}/guide/${selectedGuide.id}`, {
                replace: true
            });
            return;
        }
        setShowCreateAppForm(false);
        setSelectedGuide(undefined);
    }, [
        navigate,
        selectedGuide
    ]);
    const onClickApiGuide = (0, $jC8Vy.useCallback)((data)=>{
        setShowCreateApiForm(true);
        setSelectedGuide(data);
    }, []);
    const onCloseCreateApiForm = (0, $jC8Vy.useCallback)((newResource)=>{
        if (newResource && selectedGuide) {
            navigate(`/api-resources/${newResource.id}/guide/${selectedGuide.id}`, {
                replace: true
            });
            return;
        }
        setShowCreateApiForm(false);
        setSelectedGuide(undefined);
    }, [
        navigate,
        selectedGuide
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $d060f94231e13b1e$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5TsIB.default), {
                titleKey: "get_started.page_title"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $d060f94231e13b1e$export$38e42c68cf43b5d4,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $d060f94231e13b1e$export$fb184b623420d9be,
                        children: t("get_started.title")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $d060f94231e13b1e$export$c96745152eb2740f,
                        children: t("get_started.subtitle")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
                className: $d060f94231e13b1e$export$aa3e815946b80764,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $d060f94231e13b1e$export$fb184b623420d9be,
                        children: t(`get_started.develop.title${(0, $8TpMk.isCloud) ? "_cloud" : ""}`)
                    }),
                    (0, $8TpMk.isCloud) && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $312648e8b3e3db05$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $d060f94231e13b1e$export$c96745152eb2740f,
                                children: t("get_started.develop.subtitle_cloud")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $742494c24a2c2466$export$2e2bcd8739ae039), {
                        ref: containerRef,
                        hasCardBorder: true,
                        hasCardButton: true,
                        guides: featuredAppGuides,
                        onClickGuide: onClickAppGuide
                    }),
                    selectedGuide?.target !== "API" && showCreateAppForm && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $87d78ab4d5324714$export$2e2bcd8739ae039), {
                        defaultCreateType: selectedGuide?.target,
                        defaultCreateFrameworkName: selectedGuide?.name,
                        onCompleted: onAppCreationCompleted
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                        to: "/applications/create",
                        children: t("get_started.view_all")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
                className: $d060f94231e13b1e$export$aa3e815946b80764,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $d060f94231e13b1e$export$fb184b623420d9be,
                        children: t("get_started.customize.title")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $d060f94231e13b1e$export$ed32643c9618a26,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                className: $d060f94231e13b1e$export$d3257a3edf3cda05,
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $d060f94231e13b1e$export$1ca1ec8b29a4ce27,
                                        children: /*#__PURE__*/ (0, $C7mD2.jsx)(PreviewIcon, {})
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                        className: $d060f94231e13b1e$export$2839a4a39e4d1879,
                                        children: [
                                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                className: $d060f94231e13b1e$export$fb184b623420d9be,
                                                children: t("get_started.customize.preview.title")
                                            }),
                                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                className: $d060f94231e13b1e$export$c96745152eb2740f,
                                                children: t("get_started.customize.preview.subtitle")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jbKqE.default), {}),
                            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($d060f94231e13b1e$export$d3257a3edf3cda05, $d060f94231e13b1e$export$bbea856fdb3e3c5f),
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.LinkButton), {
                                        title: "get_started.customize.continue_customizing",
                                        href: "/sign-in-experience"
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.LinkButton), {
                                        title: "get_started.customize.try_now",
                                        href: new URL("/demo-app", tenantEndpoint).href,
                                        targetBlank: "noopener"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $d060f94231e13b1e$export$ed32643c9618a26,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                className: $d060f94231e13b1e$export$d3257a3edf3cda05,
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $d060f94231e13b1e$export$1ca1ec8b29a4ce27,
                                        children: /*#__PURE__*/ (0, $C7mD2.jsx)(SocialIcon, {})
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                        className: $d060f94231e13b1e$export$2839a4a39e4d1879,
                                        children: [
                                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                className: $d060f94231e13b1e$export$fb184b623420d9be,
                                                children: t("get_started.customize.connector.title")
                                            }),
                                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                className: $d060f94231e13b1e$export$c96745152eb2740f,
                                                children: t("get_started.customize.connector.subtitle")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jbKqE.default), {}),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.LinkButton), {
                                title: "get_started.customize.add_more",
                                href: `/connectors/${(0, $bt3dS.ConnectorsTabs).Social}`
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
                className: $d060f94231e13b1e$export$aa3e815946b80764,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $d060f94231e13b1e$export$fb184b623420d9be,
                        children: t("get_started.secure.title")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $742494c24a2c2466$export$2e2bcd8739ae039), {
                        ref: containerRef,
                        hasCardBorder: true,
                        hasCardButton: true,
                        guides: apiGuideMetadata,
                        onClickGuide: onClickApiGuide
                    }),
                    showCreateApiForm && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $297779ffbed99380$export$2e2bcd8739ae039), {
                        onClose: onCloseCreateApiForm
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                        to: "/api-resources/create",
                        children: t("get_started.view_all")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
                className: $d060f94231e13b1e$export$aa3e815946b80764,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $d060f94231e13b1e$export$fb184b623420d9be,
                        children: t("get_started.manage.title")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $d060f94231e13b1e$export$ed32643c9618a26,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                className: $d060f94231e13b1e$export$d3257a3edf3cda05,
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $d060f94231e13b1e$export$1ca1ec8b29a4ce27,
                                        children: /*#__PURE__*/ (0, $C7mD2.jsx)(RbacIcon, {})
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                        className: $d060f94231e13b1e$export$2839a4a39e4d1879,
                                        children: [
                                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                className: $d060f94231e13b1e$export$fb184b623420d9be,
                                                children: t("get_started.manage.rbac.title")
                                            }),
                                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                className: $d060f94231e13b1e$export$c96745152eb2740f,
                                                children: t("get_started.manage.rbac.subtitle")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jbKqE.default), {}),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.LinkButton), {
                                title: "get_started.manage.create_roles",
                                href: "/roles"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $1ab7b740c116daef$export$2e2bcd8739ae039 = $1ab7b740c116daef$var$GetStarted;



var $C7mD2 = parcelRequire("C7mD2");

var $voszV = parcelRequire("voszV");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");

var $5UrGx = parcelRequire("5UrGx");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $b0dc04176e412b04$var$SvgRequestErrorDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 58,
                y: 74,
                width: 140,
                height: 108,
                rx: 12,
                fill: "#928F9A"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "mask0_5321_35616",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 58,
                y: 74,
                width: 140,
                height: 108,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                    x: 58,
                    y: 74,
                    width: 140,
                    height: 108,
                    rx: 12.191,
                    fill: "#928F9A"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M58 86c0-6.627 5.373-12 12-12h116c6.627 0 12 5.373 12 12v4H58v-4Z",
                fill: "#78767F"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M101.686 124.686a4 4 0 0 0 0 5.657l5.657 5.657-5.656 5.657a4 4 0 1 0 5.657 5.656l5.656-5.656 5.656 5.656a4 4 0 0 0 5.657-5.656L118.657 136l5.658-5.657a4 4 0 0 0-5.657-5.657L113 130.344l-5.657-5.658a4 4 0 0 0-5.657 0ZM149.686 124.686a4 4 0 0 0 0 5.657l5.657 5.657-5.656 5.657a4 4 0 1 0 5.657 5.656l5.656-5.656 5.656 5.656a4 4 0 0 0 5.657-5.656L166.657 136l5.658-5.657a4 4 0 0 0-5.657-5.657L161 130.344l-5.657-5.658a4 4 0 0 0-5.657 0Z",
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 72,
                cy: 82,
                r: 2,
                fill: "#5F5D67"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 82,
                cy: 82,
                r: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 92,
                cy: 82,
                r: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 74,
                y: 102,
                width: 64,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 74,
                y: 109,
                width: 14,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 172,
                y: 109,
                width: 10,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 92,
                y: 109,
                width: 74,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 146,
                y: 102,
                width: 10,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 159,
                y: 102,
                width: 23,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "mask1_5321_35616",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 25,
                y: 93,
                width: 92,
                height: 99,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    d: "M116 98.5V94H25.5v97.5H63c13.255 0 24-10.745 24-24v-40c0-8.008 6.492-14.5 14.5-14.5s14.5-6.492 14.5-14.5Z",
                    fill: "#fff",
                    stroke: "#F7F8F8",
                    strokeOpacity: 0.16,
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("g", {
                mask: "url(#mask1_5321_35616)",
                stroke: "#F7F8F8",
                strokeOpacity: 0.16,
                strokeWidth: 0.8,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    d: "m-4 90 4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.693 8.693 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.027 9.027 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.92 8.92 0 0 1 7.991-.002 8.917 8.917 0 0 0 7.985 0L124 90M-4 94l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.693 8.693 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.027 9.027 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.92 8.92 0 0 1 7.991-.002 8.917 8.917 0 0 0 7.985 0L124 94M-4 98l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.027 9.027 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.917 8.917 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0l3.996-2M-4 102l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 102M-4 106l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 106M-4 110l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 110M-4 114l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 114M-4 118l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 118M-4 122l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 122M-4 126l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 126M-4 130l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 130M-4 134l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 134M-4 138l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 138M-4 142l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 142M-4 146l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 146M-4 150l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 150M-4 154l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 154M-4 158l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 158M-4 162l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 162M-4 166l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 166M-4 170l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 170M-4 174l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 174M-4 178l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 178M-4 182l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 182M-4 186l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 186M-4 190l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 190"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 167.453,
                y: 52,
                width: 24,
                height: 24,
                rx: 4,
                transform: "rotate(50.249 167.453 52)",
                fill: "#F7F8F8",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M205.914 28.209a.21.21 0 0 1 .209-.209h3.755a.21.21 0 0 1 .209.209v6.608l5.723-3.304a.209.209 0 0 1 .285.076l1.877 3.252c.058.1.024.228-.076.285l-5.724 3.305 5.724 3.304a.209.209 0 0 1 .076.285l-1.878 3.252a.208.208 0 0 1-.284.076l-5.723-3.304v6.609a.21.21 0 0 1-.209.208h-3.755a.21.21 0 0 1-.209-.208v-6.61l-5.723 3.305a.208.208 0 0 1-.285-.076l-1.878-3.252a.21.21 0 0 1 .077-.285l5.723-3.304-5.724-3.305a.209.209 0 0 1-.076-.285l1.878-3.252a.208.208 0 0 1 .284-.076l5.724 3.305v-6.61Z",
                fill: "#CABEFF",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M32 53a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
                fill: "#F7F8F8",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M194 190c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12Zm0-6a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z",
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M76.305 53.602c-1.066-2.889 1.395-5.848 4.43-5.327l4.552.783c3.035.521 4.367 4.132 2.398 6.5l-2.953 3.55c-1.97 2.368-5.763 1.716-6.829-1.173l-1.598-4.333Z",
                fill: "#F7F8F8",
                fillOpacity: 0.12
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 75,
                y: 220,
                width: 80,
                height: 4,
                rx: 2,
                fill: "#CABEFF",
                fillOpacity: 0.12
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 167,
                y: 220,
                width: 19,
                height: 4,
                rx: 2,
                fill: "#CABEFF",
                fillOpacity: 0.12
            })
        ]
    });
var $b0dc04176e412b04$export$2e2bcd8739ae039 = $b0dc04176e412b04$var$SvgRequestErrorDark;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $52264e41c0705e4e$var$SvgRequestError = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 57,
                y: 74,
                width: 140,
                height: 108,
                rx: 12,
                fill: "#C9C5D0"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "mask0_5318_34653",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 57,
                y: 74,
                width: 140,
                height: 108,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                    x: 57,
                    y: 74,
                    width: 140,
                    height: 108,
                    rx: 12,
                    fill: "#D5CFF1"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M57 86c0-6.627 5.373-12 12-12h116c6.627 0 12 5.373 12 12v4H57v-4Z",
                fill: "#78767F"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M100.686 124.687a3.999 3.999 0 0 0 0 5.656l5.657 5.658-5.656 5.656a4 4 0 0 0 5.657 5.657l5.656-5.656 5.656 5.656a4 4 0 0 0 5.657-5.657l-5.656-5.656 5.658-5.658a4 4 0 0 0-5.657-5.657L112 130.344l-5.657-5.657a3.999 3.999 0 0 0-5.657 0ZM148.686 124.687a4 4 0 0 0 0 5.656l5.657 5.658-5.656 5.656a4 4 0 0 0 5.657 5.657l5.656-5.656 5.656 5.656a4 4 0 0 0 5.657-5.657l-5.656-5.656 5.658-5.658a4 4 0 0 0-5.657-5.657L160 130.344l-5.657-5.657a3.999 3.999 0 0 0-5.657 0Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 71,
                cy: 82,
                r: 2,
                fill: "#78767F"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 81,
                cy: 82,
                r: 2,
                fill: "#C9C5D0"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 91,
                cy: 82,
                r: 2,
                fill: "#C9C5D0"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 73,
                y: 102,
                width: 64,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 73,
                y: 109,
                width: 14,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 171,
                y: 109,
                width: 10,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 91,
                y: 109,
                width: 74,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 145,
                y: 102,
                width: 10,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 158,
                y: 102,
                width: 23,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "mask1_5318_34653",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 24,
                y: 94,
                width: 91,
                height: 98,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    d: "M115 98.5V94H24.5v97.5H62c13.255 0 24-10.745 24-24v-40c0-8.008 6.492-14.5 14.5-14.5s14.5-6.492 14.5-14.5Z",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("g", {
                mask: "url(#mask1_5318_34653)",
                stroke: "#C9C5D0",
                strokeWidth: 0.8,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    d: "m-5 94 4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.693 8.693 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.027 9.027 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.92 8.92 0 0 1 7.991-.002 8.917 8.917 0 0 0 7.985 0L123 94M-5 98l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.027 9.027 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.917 8.917 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0l3.996-2M-5 102l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 102M-5 106l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 106M-5 110l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 110M-5 114l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 114M-5 118l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 118M-5 122l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 122M-5 126l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 126M-5 130l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 130M-5 134l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 134M-5 138l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 138M-5 142l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 142M-5 146l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 146M-5 150l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 150M-5 154l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 154M-5 158l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 158M-5 162l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 162M-5 166l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 166M-5 170l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 170M-5 174l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 174M-5 178l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 178M-5 182l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 182M-5 186l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 186M-5 190l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 190"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 166.453,
                y: 52,
                width: 24,
                height: 24,
                rx: 6,
                transform: "rotate(50.249 166.453 52)",
                fill: "#C9C5D0",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M204.914 28.209a.21.21 0 0 1 .209-.209h3.755a.21.21 0 0 1 .209.209v6.608l5.723-3.304a.209.209 0 0 1 .285.076l1.877 3.252c.058.1.024.228-.076.285l-5.724 3.305 5.724 3.304a.209.209 0 0 1 .076.285l-1.878 3.252a.208.208 0 0 1-.284.076l-5.723-3.304v6.609a.21.21 0 0 1-.209.208h-3.755a.21.21 0 0 1-.209-.208v-6.61l-5.723 3.305a.208.208 0 0 1-.285-.076l-1.878-3.252a.21.21 0 0 1 .077-.285l5.723-3.304-5.724-3.305a.209.209 0 0 1-.076-.285l1.878-3.252a.208.208 0 0 1 .284-.076l5.724 3.305v-6.61Z",
                fill: "#E5E1EC"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M31 53a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
                fill: "#F3EFFA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M193 190c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12Zm0-6a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z",
                fill: "#E5E1EC",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M75.305 53.602c-1.066-2.889 1.395-5.848 4.43-5.327l4.552.783c3.035.521 4.367 4.132 2.398 6.5l-2.953 3.55c-1.97 2.368-5.763 1.716-6.829-1.173l-1.598-4.333Z",
                fill: "#F3EFFA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 74,
                y: 220,
                width: 80,
                height: 4,
                rx: 2,
                fill: "#C9C5D0"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 166,
                y: 220,
                width: 19,
                height: 4,
                rx: 2,
                fill: "#C9C5D0"
            })
        ]
    });
var $52264e41c0705e4e$export$2e2bcd8739ae039 = $52264e41c0705e4e$var$SvgRequestError;



var $jGWQ4 = parcelRequire("jGWQ4");

var $gC7hG = parcelRequire("gC7hG");

var $jheqv = parcelRequire("jheqv");
var $8d12f6777c44fc77$export$a7db06668cad9adb;
var $8d12f6777c44fc77$export$a3bc9b8ed74fc;
var $8d12f6777c44fc77$export$5c452ff88e35e47d;
var $8d12f6777c44fc77$export$bfd64c937657f93a;
var $8d12f6777c44fc77$export$4a6dd88bada4e7d2;
var $8d12f6777c44fc77$export$fb184b623420d9be;
$8d12f6777c44fc77$export$a7db06668cad9adb = `_60TtZq_content`;
$8d12f6777c44fc77$export$a3bc9b8ed74fc = `_60TtZq_error`;
$8d12f6777c44fc77$export$5c452ff88e35e47d = `_60TtZq_image`;
$8d12f6777c44fc77$export$bfd64c937657f93a = `_60TtZq_rotating`;
$8d12f6777c44fc77$export$4a6dd88bada4e7d2 = `_60TtZq_shimmer`;
$8d12f6777c44fc77$export$fb184b623420d9be = `_60TtZq_title`;


function $a20a092c49eaf711$var$RequestDataError({ error: error, onRetry: onRetry, className: className }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const theme = (0, $jheqv.default)();
    const errorMessage = error.body?.message ?? error.message;
    const isNotFoundError = error.status === 404;
    const ErrorImage = theme === (0, $5HVJe.Theme).Light ? (0, $52264e41c0705e4e$export$2e2bcd8739ae039) : (0, $b0dc04176e412b04$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($8d12f6777c44fc77$export$a3bc9b8ed74fc, className),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)(ErrorImage, {
                className: $8d12f6777c44fc77$export$5c452ff88e35e47d
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $8d12f6777c44fc77$export$fb184b623420d9be,
                children: t(isNotFoundError ? "errors.not_found" : "errors.something_went_wrong")
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $8d12f6777c44fc77$export$a7db06668cad9adb,
                children: errorMessage
            }),
            onRetry && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                title: "general.retry",
                onClick: onRetry
            })
        ]
    });
}
var $a20a092c49eaf711$export$2e2bcd8739ae039 = $a20a092c49eaf711$var$RequestDataError;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $8lyC3 = parcelRequire("8lyC3");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jGWQ4 = parcelRequire("jGWQ4");
var $69f005e1e275fbdd$export$795623e8105ba10a;
var $69f005e1e275fbdd$export$89da14300d534261;
var $69f005e1e275fbdd$export$34e0f9847d4c02dd;
var $69f005e1e275fbdd$export$bfd64c937657f93a;
var $69f005e1e275fbdd$export$4a6dd88bada4e7d2;
$69f005e1e275fbdd$export$795623e8105ba10a = `_7BqVIW_actionBar`;
$69f005e1e275fbdd$export$89da14300d534261 = `_7BqVIW_active`;
$69f005e1e275fbdd$export$34e0f9847d4c02dd = `_7BqVIW_container`;
$69f005e1e275fbdd$export$bfd64c937657f93a = `_7BqVIW_rotating`;
$69f005e1e275fbdd$export$4a6dd88bada4e7d2 = `_7BqVIW_shimmer`;


function $41b73519a7034b3a$var$SubmitFormChangesActionBar({ isOpen: isOpen, isSubmitting: isSubmitting, confirmText: confirmText = "general.save_changes", onSubmit: onSubmit, onDiscard: onDiscard, className: className }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($69f005e1e275fbdd$export$34e0f9847d4c02dd, isOpen && $69f005e1e275fbdd$export$89da14300d534261, className),
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
            className: $69f005e1e275fbdd$export$795623e8105ba10a,
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                    size: "medium",
                    title: "general.discard",
                    disabled: isSubmitting,
                    onClick: ()=>{
                        onDiscard();
                    }
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                    isLoading: isSubmitting,
                    type: "primary",
                    size: "medium",
                    title: confirmText,
                    onClick: async ()=>onSubmit()
                })
            ]
        })
    });
}
var $41b73519a7034b3a$export$2e2bcd8739ae039 = $41b73519a7034b3a$var$SubmitFormChangesActionBar;


var $fc98f3f2f9f20b62$export$34e0f9847d4c02dd;
var $fc98f3f2f9f20b62$export$4dbdc8f16fed8a34;
var $fc98f3f2f9f20b62$export$bfd64c937657f93a;
var $fc98f3f2f9f20b62$export$4a6dd88bada4e7d2;
var $fc98f3f2f9f20b62$export$1258c5dd981c51cf;
$fc98f3f2f9f20b62$export$34e0f9847d4c02dd = `l9fJqW_container`;
$fc98f3f2f9f20b62$export$4dbdc8f16fed8a34 = `l9fJqW_fields`;
$fc98f3f2f9f20b62$export$bfd64c937657f93a = `l9fJqW_rotating`;
$fc98f3f2f9f20b62$export$4a6dd88bada4e7d2 = `l9fJqW_shimmer`;
$fc98f3f2f9f20b62$export$1258c5dd981c51cf = `l9fJqW_withSubmitActionBar`;


function $f0e7fd6d3bded790$var$DetailsForm({ autoComplete: autoComplete, isDirty: isDirty, isSubmitting: isSubmitting, onSubmit: onSubmit, onDiscard: onDiscard, children: children }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("form", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($fc98f3f2f9f20b62$export$34e0f9847d4c02dd, isDirty && $fc98f3f2f9f20b62$export$1258c5dd981c51cf),
        autoComplete: autoComplete,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $fc98f3f2f9f20b62$export$4dbdc8f16fed8a34,
                children: children
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $41b73519a7034b3a$export$2e2bcd8739ae039), {
                isOpen: isDirty,
                isSubmitting: isSubmitting,
                onSubmit: onSubmit,
                onDiscard: onDiscard
            })
        ]
    });
}
var $f0e7fd6d3bded790$export$2e2bcd8739ae039 = $f0e7fd6d3bded790$var$DetailsForm;




var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $1QOtg = parcelRequire("1QOtg");

var $4ZcUR = parcelRequire("4ZcUR");

var $7a6472b80a388108$export$2adf6238a2d0dafa;
var $7a6472b80a388108$export$bfd64c937657f93a;
var $7a6472b80a388108$export$4a6dd88bada4e7d2;
$7a6472b80a388108$export$2adf6238a2d0dafa = `d6tymq_notification`;
$7a6472b80a388108$export$bfd64c937657f93a = `d6tymq_rotating`;
$7a6472b80a388108$export$4a6dd88bada4e7d2 = `d6tymq_shimmer`;


/** Displays an inline notification that explains the paywall and provides a clickable action button which links to the subscription page. */ function $ae2e86db85042098$var$InlineUpsell({ className: className, for: forFeature, actionButtonText: actionButtonText }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.upsell.paywall"
    });
    const { navigate: navigate } = (0, $4ZcUR.default)();
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1QOtg.default), {
        hasIcon: false,
        severity: "info",
        action: actionButtonText ?? "upsell.compare_plans",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($7a6472b80a388108$export$2adf6238a2d0dafa, className),
        onClick: ()=>{
            navigate("/tenant-settings/subscription");
        },
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
            components: {
                a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a3bc63325dc3c1a8$export$2e2bcd8739ae039), {})
            },
            children: t(forFeature)
        })
    });
}
var $ae2e86db85042098$export$2e2bcd8739ae039 = $ae2e86db85042098$var$InlineUpsell;



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
parcelRequire("6bq3s");
var $2Phw0 = parcelRequire("2Phw0");

var $dL4NZ = parcelRequire("dL4NZ");
function $fea55fa5d5726e29$var$UnsavedChangesAlertModal({ hasUnsavedChanges: hasUnsavedChanges, parentPath: parentPath, onConfirm: onConfirm }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { pathname: pathname } = (0, $2Phw0.useLocation)();
    const blocker = (0, $2Phw0.unstable_useBlocker)(hasUnsavedChanges);
    // Reset the blocker if the conditions are met.
    (0, $jC8Vy.useEffect)(()=>{
        if (blocker.state !== "blocked") return;
        const targetPathname = blocker.location.pathname;
        if (!hasUnsavedChanges || targetPathname === pathname) {
            blocker.reset();
            return;
        }
        if (parentPath && targetPathname.startsWith(parentPath)) blocker.proceed();
    }, [
        blocker,
        pathname,
        hasUnsavedChanges,
        parentPath
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dL4NZ.default), {
        isOpen: blocker.state === "blocked",
        confirmButtonText: "general.leave_page",
        cancelButtonText: "general.stay_on_page",
        onCancel: blocker.reset,
        onConfirm: ()=>{
            onConfirm?.();
            blocker.proceed?.();
        },
        children: t("general.unsaved_changes_warning")
    });
}
var $fea55fa5d5726e29$export$2e2bcd8739ae039 = $fea55fa5d5726e29$var$UnsavedChangesAlertModal;



var $8TpMk = parcelRequire("8TpMk");


var $66ixW = parcelRequire("66ixW");

var $aqmjm = parcelRequire("aqmjm");

var $1QOtg = parcelRequire("1QOtg");


var $8RfrQ = parcelRequire("8RfrQ");

var $7VnwS = parcelRequire("7VnwS");


var $5OcFi = parcelRequire("5OcFi");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $8lyC3 = parcelRequire("8lyC3");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $8lyC3 = parcelRequire("8lyC3");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $a6144c2b452d6dc2$var$SvgFactorBackupCode = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M10 16.667H4.167a.833.833 0 0 1-.834-.834V4.167a.833.833 0 0 1 .834-.834h4.166v2.5a2.5 2.5 0 0 0 2.5 2.5h2.5v.834a.833.833 0 1 0 1.667 0V7.45a1.09 1.09 0 0 0-.05-.225V7.15a.893.893 0 0 0-.158-.233l-5-5a.892.892 0 0 0-.234-.159.267.267 0 0 0-.075 0 .733.733 0 0 0-.275-.091H4.167a2.5 2.5 0 0 0-2.5 2.5v11.666a2.5 2.5 0 0 0 2.5 2.5H10a.833.833 0 0 0 0-1.666Zm0-12.159 2.158 2.159h-1.325A.833.833 0 0 1 10 5.833V4.508ZM5.833 6.667a.833.833 0 1 0 0 1.666h.834a.833.833 0 1 0 0-1.666h-.834Zm12.259 10.241-.975-.966a2.867 2.867 0 0 0-.45-3.442 2.908 2.908 0 0 0-5 2.075 2.883 2.883 0 0 0 4.275 2.542l.966.975a.834.834 0 0 0 1.366-.272.833.833 0 0 0-.182-.912ZM15.45 15.45a1.283 1.283 0 0 1-1.758 0 1.25 1.25 0 0 1 .008-1.758c.222-.221.52-.35.833-.359a1.223 1.223 0 0 1 1.3 1.242 1.25 1.25 0 0 1-.383.875ZM10.833 10h-5a.834.834 0 0 0 0 1.667h5a.833.833 0 0 0 0-1.667Zm-1.666 5a.833.833 0 1 0 0-1.667H5.833a.833.833 0 1 0 0 1.667h3.334Z",
            fill: "currentColor"
        })
    });
var $a6144c2b452d6dc2$export$2e2bcd8739ae039 = $a6144c2b452d6dc2$var$SvgFactorBackupCode;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $bb56169fac0559b7$var$SvgFactorTotp = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M17.5 1.667h-5a.833.833 0 0 0 0 1.666h4.167V7.5a.833.833 0 0 0 1.666 0v-5a.833.833 0 0 0-.833-.833Zm0 10a.833.833 0 0 0-.833.833v4.167H12.5a.833.833 0 0 0 0 1.666h5a.833.833 0 0 0 .833-.833v-5a.833.833 0 0 0-.833-.833ZM10 5a2.5 2.5 0 0 0-2.5 2.5v.833A1.667 1.667 0 0 0 5.833 10v3.333A1.667 1.667 0 0 0 7.5 15h5a1.667 1.667 0 0 0 1.667-1.667V10A1.666 1.666 0 0 0 12.5 8.333V7.5A2.5 2.5 0 0 0 10 5Zm-.833 2.5a.833.833 0 0 1 1.666 0v.833H9.167V7.5Zm3.333 5.833h-5V10h5v3.333Zm-10-5a.833.833 0 0 0 .833-.833V3.333H7.5a.833.833 0 1 0 0-1.666h-5a.833.833 0 0 0-.833.833v5a.833.833 0 0 0 .833.833Zm5 8.334H3.333V12.5a.833.833 0 1 0-1.666 0v5a.833.833 0 0 0 .833.833h5a.833.833 0 1 0 0-1.666Z",
            fill: "currentColor"
        })
    });
var $bb56169fac0559b7$export$2e2bcd8739ae039 = $bb56169fac0559b7$var$SvgFactorTotp;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $2457c18eb2acf996$var$SvgFactorWebauthn = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                clipPath: "url(#clip0_1158_5594)",
                fillRule: "evenodd",
                clipRule: "evenodd",
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M10 2.917a.417.417 0 0 0-.417-.417h-5a.417.417 0 0 0-.416.417v2.916H10V2.917ZM4.167.833C3.247.833 2.5 1.58 2.5 2.5v3.333c0 .92.746.834 1.667.834H10c.92 0 1.667.087 1.667-.834V2.5c0-.92-.746-1.667-1.667-1.667H4.167Z"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M.833 7.5c0-.92.747-1.667 1.667-1.667h9.167c.92 0 1.666.746 1.666 1.667H2.917a.417.417 0 0 0-.417.417v9.166c0 .23.187.417.417.417H5a.833.833 0 0 1 0 1.667H2.5c-.92 0-1.667-.747-1.667-1.667v-10ZM5.833 5a.833.833 0 1 1 0-1.667.833.833 0 0 1 0 1.667ZM8.333 5a.833.833 0 1 1 0-1.667.833.833 0 0 1 0 1.667Z"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M13.75 10C11.602 10 10 11.565 10 13.333v5a.833.833 0 0 1-1.667 0v-5c0-2.834 2.502-5 5.417-5s5.417 2.166 5.417 5V15a.833.833 0 1 1-1.667 0v-1.667c0-1.768-1.602-3.333-3.75-3.333Z"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M13.75 12.5c.767 0 1.25.548 1.25 1.06v4.773a.833.833 0 0 0 1.667 0v-4.772c0-1.58-1.383-2.728-2.917-2.728-1.534 0-2.917 1.148-2.917 2.727v.758a.833.833 0 0 0 1.667 0v-.758c0-.512.483-1.06 1.25-1.06ZM18.333 16.666c.46 0 .834.374.834.834v.833a.833.833 0 0 1-1.667 0V17.5c0-.46.373-.834.833-.834Z"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M13.75 16.666c.46 0 .833.374.833.834v.833a.833.833 0 0 1-1.666 0V17.5c0-.46.373-.834.833-.834ZM11.667 15.833c.46 0 .833.373.833.834v1.666a.833.833 0 0 1-1.667 0v-1.666c0-.46.373-.834.834-.834ZM13.75 13.333c.46 0 .833.373.833.834V15a.833.833 0 1 1-1.666 0v-.833c0-.46.373-.834.833-.834Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("defs", {
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("clipPath", {
                    id: "clip0_1158_5594",
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h20v20H0z"
                    })
                })
            })
        ]
    });
var $2457c18eb2acf996$export$2e2bcd8739ae039 = $2457c18eb2acf996$var$SvgFactorWebauthn;



var $lf8OC = parcelRequire("lf8OC");

var $75SRw = parcelRequire("75SRw");
parcelRequire("fIF1D");
var $2LaLj = parcelRequire("2LaLj");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $8lyC3 = parcelRequire("8lyC3");

var $66ixW = parcelRequire("66ixW");
const $7c7d50aa193e10ff$var$factorNameLabel = {
    [(0, $8lyC3.MfaFactor).TOTP]: "mfa.totp",
    [(0, $8lyC3.MfaFactor).WebAuthn]: "mfa.webauthn",
    [(0, $8lyC3.MfaFactor).BackupCode]: "mfa.backup_code"
};
function $7c7d50aa193e10ff$var$MfaFactorName({ type: type }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
        forKey: $7c7d50aa193e10ff$var$factorNameLabel[type]
    });
}
var $7c7d50aa193e10ff$export$2e2bcd8739ae039 = $7c7d50aa193e10ff$var$MfaFactorName;


var $1f1e7973a35e4f2c$export$873364fe1dae561a;
var $1f1e7973a35e4f2c$export$f679e3eca39988e1;
var $1f1e7973a35e4f2c$export$bb188c6f3a9eb2a0;
var $1f1e7973a35e4f2c$export$bfd64c937657f93a;
var $1f1e7973a35e4f2c$export$4a6dd88bada4e7d2;
$1f1e7973a35e4f2c$export$873364fe1dae561a = `Dwh-rW_factorIcon`;
$1f1e7973a35e4f2c$export$f679e3eca39988e1 = `Dwh-rW_factorTip`;
$1f1e7973a35e4f2c$export$bb188c6f3a9eb2a0 = `Dwh-rW_factorTitle`;
$1f1e7973a35e4f2c$export$bfd64c937657f93a = `Dwh-rW_rotating`;
$1f1e7973a35e4f2c$export$4a6dd88bada4e7d2 = `Dwh-rW_shimmer`;


const $f5eba2852d88b12e$var$factorIcon = {
    [(0, $8lyC3.MfaFactor).TOTP]: (0, $bb56169fac0559b7$export$2e2bcd8739ae039),
    [(0, $8lyC3.MfaFactor).WebAuthn]: (0, $2457c18eb2acf996$export$2e2bcd8739ae039),
    [(0, $8lyC3.MfaFactor).BackupCode]: (0, $a6144c2b452d6dc2$export$2e2bcd8739ae039)
};
function $f5eba2852d88b12e$var$MfaFactorTitle({ type: type, tooltip: tooltip }) {
    const Icon = $f5eba2852d88b12e$var$factorIcon[type];
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $1f1e7973a35e4f2c$export$bb188c6f3a9eb2a0,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)(Icon, {
                className: $1f1e7973a35e4f2c$export$873364fe1dae561a
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7c7d50aa193e10ff$export$2e2bcd8739ae039), {
                type: type
            }),
            tooltip && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2LaLj.default), {
                anchorClassName: $1f1e7973a35e4f2c$export$f679e3eca39988e1,
                content: tooltip,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                    size: "small",
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $lf8OC.default), {})
                })
            })
        ]
    });
}
var $f5eba2852d88b12e$export$2e2bcd8739ae039 = $f5eba2852d88b12e$var$MfaFactorTitle;



var $66ixW = parcelRequire("66ixW");

var $C7mD2 = parcelRequire("C7mD2");

var $66ixW = parcelRequire("66ixW");
var $36ca8a317bd374fd$export$bfd64c937657f93a;
var $36ca8a317bd374fd$export$4a6dd88bada4e7d2;
var $36ca8a317bd374fd$export$63233d98cbda935;
$36ca8a317bd374fd$export$bfd64c937657f93a = `zXM0ta_rotating`;
$36ca8a317bd374fd$export$4a6dd88bada4e7d2 = `zXM0ta_shimmer`;
$36ca8a317bd374fd$export$63233d98cbda935 = `zXM0ta_webauthnTipContent`;


function $85a44c2262072b32$var$WebAuthnTipContent() {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("ul", {
        className: $36ca8a317bd374fd$export$63233d98cbda935,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("li", {
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                    forKey: "mfa.webauthn_native_tip"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("li", {
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                    forKey: "mfa.webauthn_domain_tip"
                })
            })
        ]
    });
}
var $85a44c2262072b32$export$2e2bcd8739ae039 = $85a44c2262072b32$var$WebAuthnTipContent;


var $aa84d247fafb5ded$export$72c773c1d6af3870;
var $aa84d247fafb5ded$export$9ded734754bb4e14;
var $aa84d247fafb5ded$export$bfd64c937657f93a;
var $aa84d247fafb5ded$export$4a6dd88bada4e7d2;
$aa84d247fafb5ded$export$72c773c1d6af3870 = `dqcVIG_factorDescription`;
$aa84d247fafb5ded$export$9ded734754bb4e14 = `dqcVIG_factorLabel`;
$aa84d247fafb5ded$export$bfd64c937657f93a = `dqcVIG_rotating`;
$aa84d247fafb5ded$export$4a6dd88bada4e7d2 = `dqcVIG_shimmer`;


const $a86e3d54b79bb54e$var$factorDescriptionLabel = {
    [(0, $8lyC3.MfaFactor).TOTP]: "mfa.otp_description",
    [(0, $8lyC3.MfaFactor).WebAuthn]: "mfa.webauthn_description",
    [(0, $8lyC3.MfaFactor).BackupCode]: "mfa.backup_code_description"
};
function $a86e3d54b79bb54e$var$FactorLabel({ type: type }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $aa84d247fafb5ded$export$9ded734754bb4e14,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f5eba2852d88b12e$export$2e2bcd8739ae039), {
                type: type,
                tooltip: type === (0, $8lyC3.MfaFactor).WebAuthn && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $85a44c2262072b32$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $aa84d247fafb5ded$export$72c773c1d6af3870,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                    forKey: $a86e3d54b79bb54e$var$factorDescriptionLabel[type]
                })
            })
        ]
    });
}
var $a86e3d54b79bb54e$export$2e2bcd8739ae039 = $a86e3d54b79bb54e$var$FactorLabel;


parcelRequire("cuPVN");
var $8lyC3 = parcelRequire("8lyC3");
const $5721d40213977385$export$6f1d9681af8abc37 = {
    [(0, $8lyC3.MfaPolicy).UserControlled]: "mfa.user_controlled",
    [(0, $8lyC3.MfaPolicy).Mandatory]: "mfa.mandatory"
};


var $594b435357bd64b6$export$743a1e05baa63b3;
var $594b435357bd64b6$export$2fc99d9950743efd;
var $594b435357bd64b6$export$fc93d7d2231c45c3;
var $594b435357bd64b6$export$bfd64c937657f93a;
var $594b435357bd64b6$export$4a6dd88bada4e7d2;
var $594b435357bd64b6$export$f6622776f1de379c;
$594b435357bd64b6$export$743a1e05baa63b3 = `Pc7KcW_backupCodeDescription`;
$594b435357bd64b6$export$2fc99d9950743efd = `Pc7KcW_backupCodeField`;
$594b435357bd64b6$export$fc93d7d2231c45c3 = `Pc7KcW_factorField`;
$594b435357bd64b6$export$bfd64c937657f93a = `Pc7KcW_rotating`;
$594b435357bd64b6$export$4a6dd88bada4e7d2 = `Pc7KcW_shimmer`;
$594b435357bd64b6$export$f6622776f1de379c = `Pc7KcW_unlockMfaNotice`;


parcelRequire("cuPVN");
var $8lyC3 = parcelRequire("8lyC3");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");
const $884fcb99db45c9c3$export$f12469c4ef30ac22 = ({ policy: policy, factors: factors })=>({
        policy: policy,
        totpEnabled: factors.includes((0, $8lyC3.MfaFactor).TOTP),
        webAuthnEnabled: factors.includes((0, $8lyC3.MfaFactor).WebAuthn),
        backupCodeEnabled: factors.includes((0, $8lyC3.MfaFactor).BackupCode)
    });
const $884fcb99db45c9c3$export$e3a56780a63c79fa = (mfaConfigForm)=>{
    const { policy: policy, totpEnabled: totpEnabled, webAuthnEnabled: webAuthnEnabled, backupCodeEnabled: backupCodeEnabled } = mfaConfigForm;
    const factors = [
        (0, $7oDSS.conditional)(totpEnabled && (0, $8lyC3.MfaFactor).TOTP),
        (0, $7oDSS.conditional)(webAuthnEnabled && (0, $8lyC3.MfaFactor).WebAuthn),
        (0, $7oDSS.conditional)(backupCodeEnabled && (0, $8lyC3.MfaFactor).BackupCode)
    ].filter((factor)=>Boolean(factor));
    return {
        policy: policy,
        factors: factors
    };
};
const $884fcb99db45c9c3$export$ce1e34af78d84da0 = (factors)=>{
    return !(factors.length === 1 && factors.includes((0, $8lyC3.MfaFactor).BackupCode));
};


function $89f74ea93d0f0ef6$var$MfaForm({ data: data, onMfaUpdated: onMfaUpdated }) {
    const { currentPlan: currentPlan } = (0, $jC8Vy.useContext)((0, $19434c930f80c964$export$f8addfd4ab69c833));
    const isMfaDisabled = (0, $8TpMk.isCloud) && !currentPlan.quota.mfaEnabled;
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $b595fc2f0eccd19a$export$2e2bcd8739ae039)();
    const { register: register, reset: reset, formState: { isDirty: isDirty, isSubmitting: isSubmitting }, handleSubmit: handleSubmit, control: control, watch: watch } = (0, $codQP.useForm)({
        defaultValues: (0, $884fcb99db45c9c3$export$f12469c4ef30ac22)(data),
        mode: "onChange"
    });
    const api = (0, $7VnwS.default)();
    const formValues = watch();
    const isBackupCodeAllowed = (0, $jC8Vy.useMemo)(()=>{
        const { factors: factors } = (0, $884fcb99db45c9c3$export$e3a56780a63c79fa)(formValues);
        return (0, $884fcb99db45c9c3$export$ce1e34af78d84da0)(factors);
    }, [
        formValues
    ]);
    const isPolicySettingsDisabled = (0, $jC8Vy.useMemo)(()=>{
        if (isMfaDisabled) return true;
        const { factors: factors } = (0, $884fcb99db45c9c3$export$e3a56780a63c79fa)(formValues);
        return factors.length === 0;
    }, [
        formValues,
        isMfaDisabled
    ]);
    const onSubmit = handleSubmit((0, $5OcFi.trySubmitSafe)(async (formData)=>{
        const mfaConfig = (0, $884fcb99db45c9c3$export$e3a56780a63c79fa)(formData);
        if (!(0, $884fcb99db45c9c3$export$ce1e34af78d84da0)(mfaConfig.factors)) return;
        const { mfa: updatedMfaConfig } = await api.patch("api/sign-in-exp", {
            json: {
                mfa: mfaConfig
            }
        }).json();
        reset((0, $884fcb99db45c9c3$export$f12469c4ef30ac22)(updatedMfaConfig));
        (0, $FuhPC.toast).success(t("general.saved"));
        onMfaUpdated(updatedMfaConfig);
    }));
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $f0e7fd6d3bded790$export$2e2bcd8739ae039), {
                isDirty: isDirty,
                isSubmitting: isSubmitting,
                onSubmit: onSubmit,
                onDiscard: reset,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
                        title: "mfa.factors",
                        description: "mfa.multi_factors_description",
                        learnMoreLink: {
                            href: getDocumentationUrl("/docs/recipes/multi-factor-auth/configure-mfa"),
                            targetBlank: "noopener"
                        },
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                title: "mfa.multi_factors",
                                headlineSpacing: "large",
                                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                    className: $594b435357bd64b6$export$fc93d7d2231c45c3,
                                    children: [
                                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8RfrQ.default), {
                                            disabled: isMfaDisabled,
                                            label: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a86e3d54b79bb54e$export$2e2bcd8739ae039), {
                                                type: (0, $8lyC3.MfaFactor).TOTP
                                            }),
                                            ...register("totpEnabled")
                                        }),
                                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8RfrQ.default), {
                                            disabled: isMfaDisabled,
                                            label: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a86e3d54b79bb54e$export$2e2bcd8739ae039), {
                                                type: (0, $8lyC3.MfaFactor).WebAuthn
                                            }),
                                            ...register("webAuthnEnabled")
                                        }),
                                        /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                            className: $594b435357bd64b6$export$2fc99d9950743efd,
                                            children: [
                                                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                    className: $594b435357bd64b6$export$743a1e05baa63b3,
                                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                                        forKey: "mfa.backup_code_setup_hint"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8RfrQ.default), {
                                                    disabled: isMfaDisabled,
                                                    label: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a86e3d54b79bb54e$export$2e2bcd8739ae039), {
                                                        type: (0, $8lyC3.MfaFactor).BackupCode
                                                    }),
                                                    hasError: !isBackupCodeAllowed,
                                                    ...register("backupCodeEnabled")
                                                }),
                                                !isBackupCodeAllowed && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1QOtg.default), {
                                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                                        forKey: "mfa.backup_code_error_hint"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            isMfaDisabled && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ae2e86db85042098$export$2e2bcd8739ae039), {
                                for: "mfa",
                                className: $594b435357bd64b6$export$f6622776f1de379c,
                                actionButtonText: "upsell.view_plans"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
                        title: "mfa.policy",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                            title: "mfa.two_step_sign_in_policy",
                            headlineSpacing: "large",
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                                control: control,
                                name: "policy",
                                render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $c8e461321115642d$export$2e2bcd8739ae039), {
                                        name: name,
                                        value: value,
                                        onChange: onChange,
                                        children: Object.values((0, $8lyC3.MfaPolicy)).map((policy)=>{
                                            const title = (0, $5721d40213977385$export$6f1d9681af8abc37)[policy];
                                            return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $b4b7cf2a2e4180e8$export$2e2bcd8739ae039), {
                                                isDisabled: isPolicySettingsDisabled,
                                                title: title,
                                                value: policy
                                            }, policy);
                                        })
                                    })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fea55fa5d5726e29$export$2e2bcd8739ae039), {
                hasUnsavedChanges: isDirty
            })
        ]
    });
}
var $89f74ea93d0f0ef6$export$2e2bcd8739ae039 = $89f74ea93d0f0ef6$var$MfaForm;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $lXQZH = parcelRequire("lXQZH");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");

var $5TsIB = parcelRequire("5TsIB");

var $8TpMk = parcelRequire("8TpMk");


var $cDKfs = parcelRequire("cDKfs");

var $18SWy = parcelRequire("18SWy");
var $cf8dff265614b550$export$3aac624c619dfa7f;
var $cf8dff265614b550$export$34e0f9847d4c02dd;
var $cf8dff265614b550$export$bfd64c937657f93a;
var $cf8dff265614b550$export$4a6dd88bada4e7d2;
$cf8dff265614b550$export$3aac624c619dfa7f = `_6tXdya_cardTitle`;
$cf8dff265614b550$export$34e0f9847d4c02dd = `_6tXdya_container`;
$cf8dff265614b550$export$bfd64c937657f93a = `_6tXdya_rotating`;
$cf8dff265614b550$export$4a6dd88bada4e7d2 = `_6tXdya_shimmer`;


function $37e6b7b3894c7450$var$PageWrapper({ children: children }) {
    const { isDevTenant: isDevTenant } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { currentPlan: currentPlan } = (0, $jC8Vy.useContext)((0, $19434c930f80c964$export$f8addfd4ab69c833));
    const isMfaEnabled = !(0, $8TpMk.isCloud) || currentPlan.quota.mfaEnabled;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $cf8dff265614b550$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5TsIB.default), {
                titleKey: "mfa.title"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $18SWy.default), {
                paywall: (0, $7oDSS.cond)((!isMfaEnabled || isDevTenant) && (0, $lXQZH.ReservedPlanId).Pro),
                title: "mfa.title",
                subtitle: "mfa.description",
                className: $cf8dff265614b550$export$3aac624c619dfa7f
            }),
            children
        ]
    });
}
var $37e6b7b3894c7450$export$2e2bcd8739ae039 = $37e6b7b3894c7450$var$PageWrapper;



var $C7mD2 = parcelRequire("C7mD2");

var $e5873bf5cfa40094$export$34e0f9847d4c02dd;
var $e5873bf5cfa40094$export$bfd64c937657f93a;
var $e5873bf5cfa40094$export$4a6dd88bada4e7d2;
$e5873bf5cfa40094$export$34e0f9847d4c02dd = `JK0d5G_container`;
$e5873bf5cfa40094$export$bfd64c937657f93a = `JK0d5G_rotating`;
$e5873bf5cfa40094$export$4a6dd88bada4e7d2 = `JK0d5G_shimmer`;


function $b250c3af3f6b991b$var$Skeleton() {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $e5873bf5cfa40094$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fe58a6ffca737898$export$2e2bcd8739ae039), {
                formFieldCount: 1
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fe58a6ffca737898$export$2e2bcd8739ae039), {
                formFieldCount: 1
            })
        ]
    });
}
var $b250c3af3f6b991b$export$2e2bcd8739ae039 = $b250c3af3f6b991b$var$Skeleton;


function $f75a1f06c05de4cc$var$Mfa() {
    const { data: data, error: error, mutate: mutate, isLoading: isLoading } = (0, $voszV.default)("api/sign-in-exp");
    if (isLoading) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $37e6b7b3894c7450$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $b250c3af3f6b991b$export$2e2bcd8739ae039), {})
    });
    if (error) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $37e6b7b3894c7450$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a20a092c49eaf711$export$2e2bcd8739ae039), {
            error: error,
            onRetry: mutate
        })
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $37e6b7b3894c7450$export$2e2bcd8739ae039), {
        children: data && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $89f74ea93d0f0ef6$export$2e2bcd8739ae039), {
            data: data.mfa,
            onMfaUpdated: (mfa)=>{
                mutate({
                    ...data,
                    mfa: mfa
                });
            }
        })
    });
}
var $f75a1f06c05de4cc$export$2e2bcd8739ae039 = $f75a1f06c05de4cc$var$Mfa;



var $g0vtZ = parcelRequire("g0vtZ");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $jnq2J = parcelRequire("jnq2J");

var $5TsIB = parcelRequire("5TsIB");
parcelRequire("8Mb3E");
var $cfL6o = parcelRequire("cfL6o");

var $18SWy = parcelRequire("18SWy");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $jnq2J = parcelRequire("jnq2J");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $voszV = parcelRequire("voszV");



var $jGWQ4 = parcelRequire("jGWQ4");

var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $dL4NZ = parcelRequire("dL4NZ");

var $fmHmG = parcelRequire("fmHmG");
function $7065f4e52ae4e862$var$DeleteConfirmModal({ isOpen: isOpen, isLoading: isLoading = false, expectedInput: expectedInput, inputPlaceholder: inputPlaceholder, children: children, className: className, onCancel: onCancel, onConfirm: onConfirm, title: title, confirmButtonText: confirmButtonText }) {
    const [input, setInput] = (0, $jC8Vy.useState)("");
    const isConfirmBlocked = Boolean(expectedInput) && input !== expectedInput;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $dL4NZ.default), {
        isOpen: isOpen,
        isLoading: isLoading,
        isConfirmButtonDisabled: isConfirmBlocked,
        confirmButtonText: confirmButtonText ?? "general.delete",
        className: className,
        title: title,
        onCancel: onCancel,
        onConfirm: onConfirm,
        children: [
            children,
            expectedInput && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus: true,
                value: input,
                placeholder: inputPlaceholder,
                onChange: (event)=>{
                    setInput(event.currentTarget.value);
                }
            })
        ]
    });
}
var $7065f4e52ae4e862$export$2e2bcd8739ae039 = $7065f4e52ae4e862$var$DeleteConfirmModal;



var $aqmjm = parcelRequire("aqmjm");

var $75SRw = parcelRequire("75SRw");

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $HHYyb = parcelRequire("HHYyb");





var $bnkR4 = parcelRequire("bnkR4");


var $75SRw = parcelRequire("75SRw");
var $8ef17a492a7c5cd2$exports = {};

$parcel$export($8ef17a492a7c5cd2$exports, "arrow", function () { return $8ef17a492a7c5cd2$export$f2120bbfa5450bd2; }, function (v) { return $8ef17a492a7c5cd2$export$f2120bbfa5450bd2 = v; });
$parcel$export($8ef17a492a7c5cd2$exports, "clear", function () { return $8ef17a492a7c5cd2$export$42ffd38884aecdac; }, function (v) { return $8ef17a492a7c5cd2$export$42ffd38884aecdac = v; });
$parcel$export($8ef17a492a7c5cd2$exports, "clearable", function () { return $8ef17a492a7c5cd2$export$9a75bea1029d84f2; }, function (v) { return $8ef17a492a7c5cd2$export$9a75bea1029d84f2 = v; });
$parcel$export($8ef17a492a7c5cd2$exports, "close", function () { return $8ef17a492a7c5cd2$export$8360e631d277ea4d; }, function (v) { return $8ef17a492a7c5cd2$export$8360e631d277ea4d = v; });
$parcel$export($8ef17a492a7c5cd2$exports, "delete", function () { return $8ef17a492a7c5cd2$export$1822828d790e23ee; }, function (v) { return $8ef17a492a7c5cd2$export$1822828d790e23ee = v; });
$parcel$export($8ef17a492a7c5cd2$exports, "dropdown", function () { return $8ef17a492a7c5cd2$export$81207e5cc4186890; }, function (v) { return $8ef17a492a7c5cd2$export$81207e5cc4186890 = v; });
$parcel$export($8ef17a492a7c5cd2$exports, "error", function () { return $8ef17a492a7c5cd2$export$a3bc9b8ed74fc; }, function (v) { return $8ef17a492a7c5cd2$export$a3bc9b8ed74fc = v; });
$parcel$export($8ef17a492a7c5cd2$exports, "focused", function () { return $8ef17a492a7c5cd2$export$4c2b230493b2b322; }, function (v) { return $8ef17a492a7c5cd2$export$4c2b230493b2b322 = v; });
$parcel$export($8ef17a492a7c5cd2$exports, "icon", function () { return $8ef17a492a7c5cd2$export$1ca1ec8b29a4ce27; }, function (v) { return $8ef17a492a7c5cd2$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($8ef17a492a7c5cd2$exports, "large", function () { return $8ef17a492a7c5cd2$export$f09585a853dddd32; }, function (v) { return $8ef17a492a7c5cd2$export$f09585a853dddd32 = v; });
$parcel$export($8ef17a492a7c5cd2$exports, "medium", function () { return $8ef17a492a7c5cd2$export$649ecc744817b5c7; }, function (v) { return $8ef17a492a7c5cd2$export$649ecc744817b5c7 = v; });
$parcel$export($8ef17a492a7c5cd2$exports, "multiple", function () { return $8ef17a492a7c5cd2$export$939ddaa3205df08e; }, function (v) { return $8ef17a492a7c5cd2$export$939ddaa3205df08e = v; });
$parcel$export($8ef17a492a7c5cd2$exports, "noResult", function () { return $8ef17a492a7c5cd2$export$17aca76bf89ef49e; }, function (v) { return $8ef17a492a7c5cd2$export$17aca76bf89ef49e = v; });
$parcel$export($8ef17a492a7c5cd2$exports, "open", function () { return $8ef17a492a7c5cd2$export$3ce6949f20cea765; }, function (v) { return $8ef17a492a7c5cd2$export$3ce6949f20cea765 = v; });
$parcel$export($8ef17a492a7c5cd2$exports, "readOnly", function () { return $8ef17a492a7c5cd2$export$b2cbc93d4da94977; }, function (v) { return $8ef17a492a7c5cd2$export$b2cbc93d4da94977 = v; });
$parcel$export($8ef17a492a7c5cd2$exports, "rotating", function () { return $8ef17a492a7c5cd2$export$bfd64c937657f93a; }, function (v) { return $8ef17a492a7c5cd2$export$bfd64c937657f93a = v; });
$parcel$export($8ef17a492a7c5cd2$exports, "search", function () { return $8ef17a492a7c5cd2$export$d76128d007d19019; }, function (v) { return $8ef17a492a7c5cd2$export$d76128d007d19019 = v; });
$parcel$export($8ef17a492a7c5cd2$exports, "searchInput", function () { return $8ef17a492a7c5cd2$export$952af3258ed45903; }, function (v) { return $8ef17a492a7c5cd2$export$952af3258ed45903 = v; });
$parcel$export($8ef17a492a7c5cd2$exports, "searchInputContainer", function () { return $8ef17a492a7c5cd2$export$de44969449e66315; }, function (v) { return $8ef17a492a7c5cd2$export$de44969449e66315 = v; });
$parcel$export($8ef17a492a7c5cd2$exports, "select", function () { return $8ef17a492a7c5cd2$export$2e6c959c16ff56b8; }, function (v) { return $8ef17a492a7c5cd2$export$2e6c959c16ff56b8 = v; });
$parcel$export($8ef17a492a7c5cd2$exports, "shimmer", function () { return $8ef17a492a7c5cd2$export$4a6dd88bada4e7d2; }, function (v) { return $8ef17a492a7c5cd2$export$4a6dd88bada4e7d2 = v; });
$parcel$export($8ef17a492a7c5cd2$exports, "small", function () { return $8ef17a492a7c5cd2$export$3c17b0e969a90510; }, function (v) { return $8ef17a492a7c5cd2$export$3c17b0e969a90510 = v; });
$parcel$export($8ef17a492a7c5cd2$exports, "spinner", function () { return $8ef17a492a7c5cd2$export$641374ffb95bc399; }, function (v) { return $8ef17a492a7c5cd2$export$641374ffb95bc399 = v; });
$parcel$export($8ef17a492a7c5cd2$exports, "tag", function () { return $8ef17a492a7c5cd2$export$2b067c6666111485; }, function (v) { return $8ef17a492a7c5cd2$export$2b067c6666111485 = v; });
$parcel$export($8ef17a492a7c5cd2$exports, "title", function () { return $8ef17a492a7c5cd2$export$fb184b623420d9be; }, function (v) { return $8ef17a492a7c5cd2$export$fb184b623420d9be = v; });
var $8ef17a492a7c5cd2$export$f2120bbfa5450bd2;
var $8ef17a492a7c5cd2$export$42ffd38884aecdac;
var $8ef17a492a7c5cd2$export$9a75bea1029d84f2;
var $8ef17a492a7c5cd2$export$8360e631d277ea4d;
var $8ef17a492a7c5cd2$export$1822828d790e23ee;
var $8ef17a492a7c5cd2$export$81207e5cc4186890;
var $8ef17a492a7c5cd2$export$a3bc9b8ed74fc;
var $8ef17a492a7c5cd2$export$4c2b230493b2b322;
var $8ef17a492a7c5cd2$export$1ca1ec8b29a4ce27;
var $8ef17a492a7c5cd2$export$f09585a853dddd32;
var $8ef17a492a7c5cd2$export$649ecc744817b5c7;
var $8ef17a492a7c5cd2$export$939ddaa3205df08e;
var $8ef17a492a7c5cd2$export$17aca76bf89ef49e;
var $8ef17a492a7c5cd2$export$3ce6949f20cea765;
var $8ef17a492a7c5cd2$export$b2cbc93d4da94977;
var $8ef17a492a7c5cd2$export$bfd64c937657f93a;
var $8ef17a492a7c5cd2$export$d76128d007d19019;
var $8ef17a492a7c5cd2$export$952af3258ed45903;
var $8ef17a492a7c5cd2$export$de44969449e66315;
var $8ef17a492a7c5cd2$export$2e6c959c16ff56b8;
var $8ef17a492a7c5cd2$export$4a6dd88bada4e7d2;
var $8ef17a492a7c5cd2$export$3c17b0e969a90510;
var $8ef17a492a7c5cd2$export$641374ffb95bc399;
var $8ef17a492a7c5cd2$export$2b067c6666111485;
var $8ef17a492a7c5cd2$export$fb184b623420d9be;
$8ef17a492a7c5cd2$export$f2120bbfa5450bd2 = `el1x2W_arrow`;
$8ef17a492a7c5cd2$export$42ffd38884aecdac = `el1x2W_clear`;
$8ef17a492a7c5cd2$export$9a75bea1029d84f2 = `el1x2W_clearable`;
$8ef17a492a7c5cd2$export$8360e631d277ea4d = `el1x2W_close`;
$8ef17a492a7c5cd2$export$1822828d790e23ee = `el1x2W_delete`;
$8ef17a492a7c5cd2$export$81207e5cc4186890 = `el1x2W_dropdown`;
$8ef17a492a7c5cd2$export$a3bc9b8ed74fc = `el1x2W_error`;
$8ef17a492a7c5cd2$export$4c2b230493b2b322 = `el1x2W_focused`;
$8ef17a492a7c5cd2$export$1ca1ec8b29a4ce27 = `el1x2W_icon`;
$8ef17a492a7c5cd2$export$f09585a853dddd32 = `el1x2W_large`;
$8ef17a492a7c5cd2$export$649ecc744817b5c7 = `el1x2W_medium`;
$8ef17a492a7c5cd2$export$939ddaa3205df08e = `el1x2W_multiple`;
$8ef17a492a7c5cd2$export$17aca76bf89ef49e = `el1x2W_noResult`;
$8ef17a492a7c5cd2$export$3ce6949f20cea765 = `el1x2W_open`;
$8ef17a492a7c5cd2$export$b2cbc93d4da94977 = `el1x2W_readOnly`;
$8ef17a492a7c5cd2$export$bfd64c937657f93a = `el1x2W_rotating`;
$8ef17a492a7c5cd2$export$d76128d007d19019 = `el1x2W_search`;
$8ef17a492a7c5cd2$export$952af3258ed45903 = `el1x2W_searchInput`;
$8ef17a492a7c5cd2$export$de44969449e66315 = `el1x2W_searchInputContainer`;
$8ef17a492a7c5cd2$export$2e6c959c16ff56b8 = `el1x2W_select`;
$8ef17a492a7c5cd2$export$4a6dd88bada4e7d2 = `el1x2W_shimmer`;
$8ef17a492a7c5cd2$export$3c17b0e969a90510 = `el1x2W_small`;
$8ef17a492a7c5cd2$export$641374ffb95bc399 = `el1x2W_spinner`;
$8ef17a492a7c5cd2$export$2b067c6666111485 = `el1x2W_tag`;
$8ef17a492a7c5cd2$export$fb184b623420d9be = `el1x2W_title`;


function $286a7bc94edef870$var$Select({ className: className, value: value, options: options, onChange: onChange, isReadOnly: isReadOnly, error: error, placeholder: placeholder, isClearable: isClearable, size: size = "large", isSearchEnabled: isSearchEnabled }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [isOpen, setIsOpen] = (0, $jC8Vy.useState)(false);
    const [searchInputValue, setSearchInputValue] = (0, $jC8Vy.useState)("");
    const [searchInputContainerStyles, setSearchInputContainerStyles] = (0, $jC8Vy.useState)({});
    const anchorRef = (0, $jC8Vy.useRef)(null);
    const current = options.find((option)=>value && option.value === value);
    const filteredOptions = (0, $jC8Vy.useMemo)(()=>{
        return searchInputValue ? options.filter(({ value: value })=>value.toLocaleLowerCase().includes(searchInputValue.toLocaleLowerCase())) : options;
    }, [
        searchInputValue,
        options
    ]);
    const handleSelect = (value)=>{
        onChange?.(value);
        setIsOpen(false);
    };
    const handleClear = (event)=>{
        onChange?.(undefined);
        setIsOpen(false);
        event.stopPropagation();
    };
    const getSearchInputContainerStyles = ()=>{
        if (!anchorRef.current) return {};
        const element = anchorRef.current;
        const cs = getComputedStyle(element);
        const paddingX = Number.parseFloat(cs.paddingLeft) + Number.parseFloat(cs.paddingRight);
        const paddingY = Number.parseFloat(cs.paddingTop) + Number.parseFloat(cs.paddingBottom);
        const borderX = Number.parseFloat(cs.borderLeftWidth) + Number.parseFloat(cs.borderRightWidth);
        const borderY = Number.parseFloat(cs.borderTopWidth) + Number.parseFloat(cs.borderBottomWidth);
        return {
            position: "fixed",
            width: `${element.offsetWidth - paddingX - borderX}px`,
            height: `${element.offsetHeight - paddingY - borderY}px`,
            top: `${element.getBoundingClientRect().top + Number.parseFloat(cs.borderTopWidth) + Number.parseFloat(cs.paddingTop)}px`,
            left: `${element.getBoundingClientRect().left + Number.parseFloat(cs.borderLeftWidth) + Number.parseFloat(cs.paddingLeft)}px`,
            backgroundColor: cs.backgroundColor
        };
    };
    (0, $db44c573c0c8fb99$export$2e2bcd8739ae039)(()=>{
        setSearchInputContainerStyles(getSearchInputContainerStyles());
    });
    (0, $jC8Vy.useEffect)(()=>{
        if (isOpen) {
            anchorRef.current?.scrollIntoView({
                block: "nearest"
            });
            setSearchInputContainerStyles(getSearchInputContainerStyles());
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                ref: anchorRef,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($8ef17a492a7c5cd2$exports.select, $8ef17a492a7c5cd2$exports[size], isOpen && $8ef17a492a7c5cd2$exports.open, isReadOnly && $8ef17a492a7c5cd2$exports.readOnly, Boolean(error) && $8ef17a492a7c5cd2$exports.error, isClearable && value && $8ef17a492a7c5cd2$exports.clearable, className),
                role: "button",
                tabIndex: 0,
                onKeyDown: (0, $bnkR4.onKeyDownHandler)(()=>{
                    if (!isReadOnly) setIsOpen(true);
                }),
                onClick: ()=>{
                    if (!isReadOnly) setIsOpen(true);
                },
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $8ef17a492a7c5cd2$exports.title,
                        children: current?.title ?? placeholder
                    }),
                    isClearable && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($8ef17a492a7c5cd2$exports.icon, $8ef17a492a7c5cd2$exports.clear),
                        size: "small",
                        onClick: handleClear,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $HHYyb.default), {})
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($8ef17a492a7c5cd2$exports.icon, $8ef17a492a7c5cd2$exports.arrow),
                        children: isOpen ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4af961ac2fe37cb1$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9342374032a30fe2$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $f90dea65844a9f7a$export$2e2bcd8739ae039), {
                isFullWidth: true,
                anchorRef: anchorRef,
                className: $8ef17a492a7c5cd2$exports.dropdown,
                isOpen: isOpen,
                onClose: ()=>{
                    setIsOpen(false);
                    setSearchInputValue("");
                },
                children: [
                    isSearchEnabled && isOpen && /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        style: searchInputContainerStyles,
                        className: $8ef17a492a7c5cd2$exports.searchInputContainer,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $45ba7f7cad465e3f$export$2e2bcd8739ae039), {
                                className: $8ef17a492a7c5cd2$exports.search
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("input", {
                                ref: (input)=>input?.focus(),
                                className: $8ef17a492a7c5cd2$exports.searchInput,
                                value: searchInputValue,
                                role: "searchbox",
                                autoComplete: "off",
                                placeholder: t("general.type_to_search"),
                                onChange: (event)=>{
                                    setSearchInputValue(event.target.value);
                                },
                                onClick: (event)=>{
                                    event.stopPropagation();
                                }
                            })
                        ]
                    }),
                    filteredOptions.map(({ value: value, title: title })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $6c006ec422465f6f$export$2e2bcd8739ae039), {
                            onClick: ()=>{
                                handleSelect(value);
                            },
                            children: title
                        }, value))
                ]
            })
        ]
    });
}
var $286a7bc94edef870$export$2e2bcd8739ae039 = $286a7bc94edef870$var$Select;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");


var $aTllQ = parcelRequire("aTllQ");

var $C7mD2 = parcelRequire("C7mD2");
var $2749f7f442042b3a$export$345c5736c8054f22;
var $2749f7f442042b3a$export$a7db06668cad9adb;
var $2749f7f442042b3a$export$d532169bc1db23fb;
var $2749f7f442042b3a$export$4b409e53cf4df6e6;
var $2749f7f442042b3a$export$bfd64c937657f93a;
var $2749f7f442042b3a$export$120ff0929b202a6d;
var $2749f7f442042b3a$export$4a6dd88bada4e7d2;
var $2749f7f442042b3a$export$896d2bb7e421ffa1;
var $2749f7f442042b3a$export$fb184b623420d9be;
$2749f7f442042b3a$export$345c5736c8054f22 = `YeJh6G_avatar`;
$2749f7f442042b3a$export$a7db06668cad9adb = `YeJh6G_content`;
$2749f7f442042b3a$export$d532169bc1db23fb = `YeJh6G_itemPreview`;
$2749f7f442042b3a$export$4b409e53cf4df6e6 = `YeJh6G_rect`;
$2749f7f442042b3a$export$bfd64c937657f93a = `YeJh6G_rotating`;
$2749f7f442042b3a$export$120ff0929b202a6d = `YeJh6G_row`;
$2749f7f442042b3a$export$4a6dd88bada4e7d2 = `YeJh6G_shimmer`;
$2749f7f442042b3a$export$4a6dd88bada4e7d2;
$2749f7f442042b3a$export$896d2bb7e421ffa1 = `YeJh6G_subTitle`;
$2749f7f442042b3a$export$fb184b623420d9be = `YeJh6G_title`;


function $ca017285acad5f0a$var$Skeleton({ columnSpans: columnSpans, isCompact: isCompact }) {
    if (isCompact) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $C7mD2.Fragment), {
        children: Array.from({
            length: 2
        }).map((_, rowIndex)=>// eslint-disable-next-line react/no-array-index-key
            /*#__PURE__*/ (0, $C7mD2.jsx)("tr", {
                children: columnSpans.map((colSpan, columnIndex)=>// eslint-disable-next-line react/no-array-index-key
                    /*#__PURE__*/ (0, $C7mD2.jsx)("td", {
                        colSpan: colSpan,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $2749f7f442042b3a$export$4b409e53cf4df6e6
                        })
                    }, columnIndex))
            }, `row-${rowIndex}`))
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $C7mD2.Fragment), {
        children: Array.from({
            length: 8
        }).map((_, rowIndex)=>// eslint-disable-next-line react/no-array-index-key
            /*#__PURE__*/ (0, $C7mD2.jsxs)("tr", {
                className: $2749f7f442042b3a$export$120ff0929b202a6d,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("td", {
                        colSpan: columnSpans[0],
                        children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                            className: $2749f7f442042b3a$export$d532169bc1db23fb,
                            children: [
                                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                    className: $2749f7f442042b3a$export$345c5736c8054f22
                                }),
                                /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                    className: $2749f7f442042b3a$export$a7db06668cad9adb,
                                    children: [
                                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                            className: $2749f7f442042b3a$export$fb184b623420d9be
                                        }),
                                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                            className: $2749f7f442042b3a$export$896d2bb7e421ffa1
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    columnSpans.slice(1).map((colSpan, index)=>// eslint-disable-next-line react/no-array-index-key
                        /*#__PURE__*/ (0, $C7mD2.jsx)("td", {
                            colSpan: colSpan,
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $2749f7f442042b3a$export$4b409e53cf4df6e6
                            })
                        }, index))
                ]
            }, `row-${rowIndex}`))
    });
}
var $ca017285acad5f0a$export$2e2bcd8739ae039 = $ca017285acad5f0a$var$Skeleton;



var $C7mD2 = parcelRequire("C7mD2");
var $9bd85b47c46f82a7$export$dd62fe10de5d9423;
var $9bd85b47c46f82a7$export$a7db06668cad9adb;
var $9bd85b47c46f82a7$export$bfd64c937657f93a;
var $9bd85b47c46f82a7$export$4a6dd88bada4e7d2;
var $9bd85b47c46f82a7$export$19fc884436501bea;
var $9bd85b47c46f82a7$export$f6ec5d68907ebc61;
$9bd85b47c46f82a7$export$dd62fe10de5d9423 = `yl7C0q_bottomSpace`;
$9bd85b47c46f82a7$export$a7db06668cad9adb = `yl7C0q_content`;
$9bd85b47c46f82a7$export$bfd64c937657f93a = `yl7C0q_rotating`;
$9bd85b47c46f82a7$export$4a6dd88bada4e7d2 = `yl7C0q_shimmer`;
$9bd85b47c46f82a7$export$19fc884436501bea = `yl7C0q_tableEmptyWrapper`;
$9bd85b47c46f82a7$export$f6ec5d68907ebc61 = `yl7C0q_topSpace`;


function $9f24b3a39999da53$var$TableEmptyWrapper({ columns: columns, children: children }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)("tr", {
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("td", {
            colSpan: columns,
            className: $9bd85b47c46f82a7$export$19fc884436501bea,
            children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $9bd85b47c46f82a7$export$a7db06668cad9adb,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $9bd85b47c46f82a7$export$f6ec5d68907ebc61
                    }),
                    children,
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $9bd85b47c46f82a7$export$dd62fe10de5d9423
                    })
                ]
            })
        })
    });
}
var $9f24b3a39999da53$export$2e2bcd8739ae039 = $9f24b3a39999da53$var$TableEmptyWrapper;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");



var $jheqv = parcelRequire("jheqv");

var $jGWQ4 = parcelRequire("jGWQ4");
var $fc44510d6ccd5eb6$export$a7db06668cad9adb;
var $fc44510d6ccd5eb6$export$bfd64c937657f93a;
var $fc44510d6ccd5eb6$export$4a6dd88bada4e7d2;
var $fc44510d6ccd5eb6$export$2229a34b9ab2b766;
var $fc44510d6ccd5eb6$export$fb184b623420d9be;
$fc44510d6ccd5eb6$export$a7db06668cad9adb = `KxIFNq_content`;
$fc44510d6ccd5eb6$export$bfd64c937657f93a = `KxIFNq_rotating`;
$fc44510d6ccd5eb6$export$4a6dd88bada4e7d2 = `KxIFNq_shimmer`;
$fc44510d6ccd5eb6$export$2229a34b9ab2b766 = `KxIFNq_tableError`;
$fc44510d6ccd5eb6$export$fb184b623420d9be = `KxIFNq_title`;


function $c673111b46691ba2$var$TableError({ title: title, content: content, onRetry: onRetry, columns: columns }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const theme = (0, $jheqv.default)();
    return /*#__PURE__*/ (0, $C7mD2.jsx)("tr", {
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("td", {
            colSpan: columns,
            children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $fc44510d6ccd5eb6$export$2229a34b9ab2b766,
                children: [
                    theme === (0, $5HVJe.Theme).Light ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $52264e41c0705e4e$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $b0dc04176e412b04$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $fc44510d6ccd5eb6$export$fb184b623420d9be,
                        children: title ?? t("errors.something_went_wrong")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $fc44510d6ccd5eb6$export$a7db06668cad9adb,
                        children: content ?? t("errors.unknown_server_error")
                    }),
                    onRetry && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        title: "general.retry",
                        onClick: onRetry
                    })
                ]
            })
        })
    });
}
var $c673111b46691ba2$export$2e2bcd8739ae039 = $c673111b46691ba2$var$TableError;


var $70a5afbb1a1f212a$export$46a4a5faf57246fb;
var $70a5afbb1a1f212a$export$60d5655c6babb2a0;
var $70a5afbb1a1f212a$export$34e0f9847d4c02dd;
var $70a5afbb1a1f212a$export$6e22c362a0406a2c;
var $70a5afbb1a1f212a$export$3dea766d36a8935f;
var $70a5afbb1a1f212a$export$d9ce03847cc286f2;
var $70a5afbb1a1f212a$export$adb608be33961c98;
var $70a5afbb1a1f212a$export$e77b9811020023f0;
var $70a5afbb1a1f212a$export$ac4de22553a86e47;
var $70a5afbb1a1f212a$export$6418f2f28151f498;
var $70a5afbb1a1f212a$export$2712072f82bc811d;
var $70a5afbb1a1f212a$export$22fa394f3ba39578;
var $70a5afbb1a1f212a$export$bfd64c937657f93a;
var $70a5afbb1a1f212a$export$4a6dd88bada4e7d2;
var $70a5afbb1a1f212a$export$f2d5245d66b09437;
$70a5afbb1a1f212a$export$46a4a5faf57246fb = `Orfd3G_bodyTable`;
$70a5afbb1a1f212a$export$60d5655c6babb2a0 = `Orfd3G_clickable`;
$70a5afbb1a1f212a$export$34e0f9847d4c02dd = `Orfd3G_container`;
$70a5afbb1a1f212a$export$6e22c362a0406a2c = `Orfd3G_empty`;
$70a5afbb1a1f212a$export$3dea766d36a8935f = `Orfd3G_filter`;
$70a5afbb1a1f212a$export$d9ce03847cc286f2 = `Orfd3G_filterContainer`;
$70a5afbb1a1f212a$export$adb608be33961c98 = `Orfd3G_footer`;
$70a5afbb1a1f212a$export$e77b9811020023f0 = `Orfd3G_hasBorder`;
$70a5afbb1a1f212a$export$ac4de22553a86e47 = `Orfd3G_headerTable`;
$70a5afbb1a1f212a$export$6418f2f28151f498 = `Orfd3G_hideTopBorderRadius`;
$70a5afbb1a1f212a$export$2712072f82bc811d = `Orfd3G_hoverEffect`;
$70a5afbb1a1f212a$export$22fa394f3ba39578 = `Orfd3G_pagination`;
$70a5afbb1a1f212a$export$bfd64c937657f93a = `Orfd3G_rotating`;
$70a5afbb1a1f212a$export$4a6dd88bada4e7d2 = `Orfd3G_shimmer`;
$70a5afbb1a1f212a$export$f2d5245d66b09437 = `Orfd3G_tableContainer`;


function $3166f28a681c41bb$var$Table({ rowGroups: rowGroups, columns: columns, rowIndexKey: rowIndexKey, filter: filter, isRowHoverEffectDisabled: isRowHoverEffectDisabled = false, rowClickHandler: rowClickHandler, isRowClickable: isRowClickable = ()=>Boolean(rowClickHandler), rowClassName: rowClassName, className: className, headerTableClassName: headerTableClassName, bodyTableWrapperClassName: bodyTableWrapperClassName, isLoading: isLoading, pagination: pagination, placeholder: placeholder, loadingSkeleton: loadingSkeleton, errorMessage: errorMessage, hasBorder: hasBorder, onRetry: onRetry, footer: footer }) {
    const totalColspan = columns.reduce((result, { colSpan: colSpan })=>{
        return result + (colSpan ?? 1);
    }, 0);
    const hasData = rowGroups.some(({ data: data })=>data?.length);
    const hasError = !isLoading && !hasData && errorMessage;
    const isEmpty = !isLoading && !hasData && !errorMessage;
    const isLoaded = !isLoading && hasData;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($70a5afbb1a1f212a$export$34e0f9847d4c02dd, className),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($70a5afbb1a1f212a$export$f2d5245d66b09437, hasBorder && $70a5afbb1a1f212a$export$e77b9811020023f0),
                children: [
                    filter && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $70a5afbb1a1f212a$export$d9ce03847cc286f2,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $70a5afbb1a1f212a$export$3dea766d36a8935f,
                            children: filter
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("table", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($70a5afbb1a1f212a$export$ac4de22553a86e47, filter && $70a5afbb1a1f212a$export$6418f2f28151f498, headerTableClassName),
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)("tr", {
                                children: columns.map(({ title: title, colSpan: colSpan, dataIndex: dataIndex })=>/*#__PURE__*/ (0, $C7mD2.jsx)("th", {
                                        colSpan: colSpan,
                                        children: title
                                    }, dataIndex))
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aTllQ.default), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($70a5afbb1a1f212a$export$46a4a5faf57246fb, isEmpty && $70a5afbb1a1f212a$export$6e22c362a0406a2c, bodyTableWrapperClassName),
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)("table", {
                            children: /*#__PURE__*/ (0, $C7mD2.jsxs)("tbody", {
                                children: [
                                    isLoading && (loadingSkeleton ?? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ca017285acad5f0a$export$2e2bcd8739ae039), {
                                        isCompact: hasBorder,
                                        columnSpans: columns.map(({ colSpan: colSpan })=>colSpan ?? 1)
                                    })),
                                    hasError && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c673111b46691ba2$export$2e2bcd8739ae039), {
                                        columns: columns.length,
                                        content: errorMessage,
                                        onRetry: onRetry
                                    }),
                                    isEmpty && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9f24b3a39999da53$export$2e2bcd8739ae039), {
                                        columns: columns.length,
                                        children: placeholder
                                    }),
                                    isLoaded && rowGroups.map(({ key: key, label: label, labelRowClassName: labelRowClassName, labelClassName: labelClassName, data: data })=>/*#__PURE__*/ (0, $C7mD2.jsxs)((0, $jC8Vy.Fragment), {
                                            children: [
                                                label && /*#__PURE__*/ (0, $C7mD2.jsx)("tr", {
                                                    className: labelRowClassName,
                                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)("td", {
                                                        colSpan: totalColspan,
                                                        className: labelClassName,
                                                        children: label
                                                    })
                                                }),
                                                data?.map((row, rowIndex)=>{
                                                    const rowClickable = isRowClickable(row);
                                                    const onClick = (0, $7oDSS.conditional)(rowClickable && rowClickHandler && (()=>{
                                                        rowClickHandler(row);
                                                    }));
                                                    return /*#__PURE__*/ (0, $C7mD2.jsx)("tr", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))(rowClickable && $70a5afbb1a1f212a$export$60d5655c6babb2a0, !isRowHoverEffectDisabled && $70a5afbb1a1f212a$export$2712072f82bc811d, rowClassName?.(row, rowIndex)),
                                                        onClick: onClick,
                                                        children: columns.map(({ dataIndex: dataIndex, colSpan: colSpan, className: className, render: render })=>/*#__PURE__*/ (0, $C7mD2.jsx)("td", {
                                                                colSpan: colSpan,
                                                                className: className,
                                                                children: render(row, rowIndex)
                                                            }, dataIndex))
                                                    }, row[rowIndexKey]);
                                                })
                                            ]
                                        }, key))
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $70a5afbb1a1f212a$export$adb608be33961c98,
                children: [
                    footer ?? /*#__PURE__*/ (0, $C7mD2.jsx)("div", {}),
                    pagination && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $54e9f57962fc2e08$export$2e2bcd8739ae039), {
                        className: $70a5afbb1a1f212a$export$22fa394f3ba39578,
                        ...pagination
                    })
                ]
            })
        ]
    });
}
var $3166f28a681c41bb$export$2e2bcd8739ae039 = $3166f28a681c41bb$var$Table;




var $7VnwS = parcelRequire("7VnwS");
var $a1c439e28a9b3ccc$export$dbd89fd7a9dba0cb;
var $a1c439e28a9b3ccc$export$12d45ee5c2161b75;
var $a1c439e28a9b3ccc$export$6d59db4903f20f7d;
var $a1c439e28a9b3ccc$export$d3f18b13a180f10f;
var $a1c439e28a9b3ccc$export$f3b647f123acc394;
var $a1c439e28a9b3ccc$export$bfd64c937657f93a;
var $a1c439e28a9b3ccc$export$4a6dd88bada4e7d2;
$a1c439e28a9b3ccc$export$dbd89fd7a9dba0cb = `IADUPq_bone`;
$a1c439e28a9b3ccc$export$12d45ee5c2161b75 = `IADUPq_deleteIcon`;
$a1c439e28a9b3ccc$export$6d59db4903f20f7d = `IADUPq_description`;
$a1c439e28a9b3ccc$export$d3f18b13a180f10f = `IADUPq_idWrapper`;
$a1c439e28a9b3ccc$export$f3b647f123acc394 = `IADUPq_rotateKey`;
$a1c439e28a9b3ccc$export$bfd64c937657f93a = `IADUPq_rotating`;
$a1c439e28a9b3ccc$export$4a6dd88bada4e7d2 = `IADUPq_shimmer`;
$a1c439e28a9b3ccc$export$4a6dd88bada4e7d2;


function $70d3148cc02b96f2$var$SigningKeyFormCard({ keyType: keyType }) {
    const api = (0, $7VnwS.default)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.signing_keys"
    });
    const isPrivateKey = keyType === (0, $jnq2J.LogtoOidcConfigKeyType).PrivateKeys;
    const keyTypePhrase = isPrivateKey ? "private" : "cookie";
    const { data: data, error: error, mutate: mutate } = (0, $voszV.default)(`api/configs/oidc/${keyType}`);
    const [deletingKeyId, setDeletingKeyId] = (0, $jC8Vy.useState)();
    const [showRotateConfirmModal, setShowRotateConfirmModal] = (0, $jC8Vy.useState)(false);
    const [isRotating, setIsRotating] = (0, $jC8Vy.useState)(false);
    const [rotateKeyAlgorithm, setRotateKeyAlgorithm] = (0, $jC8Vy.useState)((0, $jnq2J.SupportedSigningKeyAlgorithm).EC);
    const isLoadingKeys = !data && !error;
    const tableColumns = (0, $jC8Vy.useMemo)(()=>[
            {
                title: t("table_column.id"),
                dataIndex: "id",
                colSpan: 8,
                render: ({ id: id })=>/*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                        className: $a1c439e28a9b3ccc$export$d3f18b13a180f10f,
                        children: id
                    })
            },
            {
                title: t("table_column.status"),
                dataIndex: "status",
                colSpan: 4,
                render: (_, rowIndex)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
                        type: "state",
                        variant: "plain",
                        status: rowIndex === 0 ? "success" : "alert",
                        children: t(rowIndex === 0 ? "status.current" : "status.previous")
                    })
            },
            ...(0, $7oDSS.condArray)(isPrivateKey && [
                {
                    title: t("table_column.algorithm"),
                    dataIndex: "signingKeyAlgorithm",
                    colSpan: 7,
                    render: ({ signingKeyAlgorithm: signingKeyAlgorithm })=>/*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                            children: signingKeyAlgorithm
                        })
                }
            ]),
            {
                title: "",
                dataIndex: "action",
                colSpan: 2,
                render: ({ id: id }, rowIndex)=>rowIndex !== 0 && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $a1c439e28a9b3ccc$export$12d45ee5c2161b75,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                            onClick: ()=>{
                                setDeletingKeyId(id);
                            },
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3aa588de5c8665f2$export$2e2bcd8739ae039), {})
                        })
                    })
            }
        ], [
        isPrivateKey,
        t
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
        title: `signing_keys.${keyTypePhrase}_key`,
        description: `signing_keys.${keyTypePhrase}_keys_description`,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: `signing_keys.${keyTypePhrase}_keys_in_use`,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3166f28a681c41bb$export$2e2bcd8739ae039), {
                    hasBorder: true,
                    isRowHoverEffectDisabled: true,
                    isLoading: isLoadingKeys || isRotating,
                    errorMessage: error?.body?.message ?? error?.message,
                    rowIndexKey: "id",
                    rowGroups: [
                        {
                            key: "signing_keys",
                            data: data
                        }
                    ],
                    columns: tableColumns
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: `signing_keys.rotate_${keyTypePhrase}_keys`,
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: $a1c439e28a9b3ccc$export$f3b647f123acc394,
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $a1c439e28a9b3ccc$export$6d59db4903f20f7d,
                            children: t(`rotate_${keyTypePhrase}_keys_description`)
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                            title: `signing_keys.rotate_${keyTypePhrase}_keys`,
                            type: "default",
                            onClick: ()=>{
                                setShowRotateConfirmModal(true);
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $7065f4e52ae4e862$export$2e2bcd8739ae039), {
                confirmButtonText: "signing_keys.rotate_button",
                isOpen: showRotateConfirmModal,
                onCancel: ()=>{
                    setShowRotateConfirmModal(false);
                },
                onConfirm: async ()=>{
                    setIsRotating(true);
                    setShowRotateConfirmModal(false);
                    try {
                        const keys = await api.post(`api/configs/oidc/${keyType}/rotate`, {
                            json: {
                                signingKeyAlgorithm: rotateKeyAlgorithm
                            }
                        }).json();
                        mutate(keys);
                        (0, $FuhPC.toast).success(t("messages.rotate_key_success"));
                    } finally{
                        setIsRotating(false);
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                            components: {
                                strong: /*#__PURE__*/ (0, $C7mD2.jsx)("strong", {})
                            },
                            children: t(`reminder.rotate_${keyTypePhrase}_key`)
                        })
                    }),
                    isPrivateKey && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        title: "signing_keys.select_private_key_algorithm",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $286a7bc94edef870$export$2e2bcd8739ae039), {
                            options: Object.values((0, $jnq2J.SupportedSigningKeyAlgorithm)).map((value)=>({
                                    title: value,
                                    value: value
                                })),
                            value: rotateKeyAlgorithm,
                            onChange: (value)=>{
                                if (!value) return;
                                setRotateKeyAlgorithm(value);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7065f4e52ae4e862$export$2e2bcd8739ae039), {
                isOpen: Boolean(deletingKeyId),
                onCancel: ()=>{
                    setDeletingKeyId(undefined);
                },
                onConfirm: async ()=>{
                    if (!deletingKeyId) return;
                    try {
                        await api.delete(`api/configs/oidc/${keyType}/${deletingKeyId}`);
                        mutate(data?.filter((key)=>key.id !== deletingKeyId));
                        (0, $FuhPC.toast).success(t("messages.delete_key_success"));
                    } finally{
                        setDeletingKeyId(undefined);
                    }
                },
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                        components: {
                            strong: /*#__PURE__*/ (0, $C7mD2.jsx)("strong", {})
                        },
                        children: t(`reminder.delete_${keyTypePhrase}_key`)
                    })
                })
            })
        ]
    });
}
var $70d3148cc02b96f2$export$2e2bcd8739ae039 = $70d3148cc02b96f2$var$SigningKeyFormCard;


var $558c0d94b6717287$export$34e0f9847d4c02dd;
var $558c0d94b6717287$export$38e42c68cf43b5d4;
var $558c0d94b6717287$export$bfd64c937657f93a;
var $558c0d94b6717287$export$4a6dd88bada4e7d2;
$558c0d94b6717287$export$34e0f9847d4c02dd = `Jo1tJW_container`;
$558c0d94b6717287$export$38e42c68cf43b5d4 = `Jo1tJW_header`;
$558c0d94b6717287$export$bfd64c937657f93a = `Jo1tJW_rotating`;
$558c0d94b6717287$export$4a6dd88bada4e7d2 = `Jo1tJW_shimmer`;


function $72b1045649d1b774$var$SigningKeys() {
    const { getDocumentationUrl: getDocumentationUrl } = (0, $b595fc2f0eccd19a$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $558c0d94b6717287$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5TsIB.default), {
                titleKey: "signing_keys.title"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $18SWy.default), {
                title: "signing_keys.title",
                subtitle: "signing_keys.description",
                learnMoreLink: {
                    href: getDocumentationUrl((0, $cfL6o.signingKeysLink)),
                    targetBlank: "noopener"
                },
                className: $558c0d94b6717287$export$38e42c68cf43b5d4
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $70d3148cc02b96f2$export$2e2bcd8739ae039), {
                keyType: (0, $jnq2J.LogtoOidcConfigKeyType).PrivateKeys
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $70d3148cc02b96f2$export$2e2bcd8739ae039), {
                keyType: (0, $jnq2J.LogtoOidcConfigKeyType).CookieKeys
            })
        ]
    });
}
var $72b1045649d1b774$export$2e2bcd8739ae039 = $72b1045649d1b774$var$SigningKeys;



var $C7mD2 = parcelRequire("C7mD2");

var $2Phw0 = parcelRequire("2Phw0");
parcelRequire("8Mb3E");
var $bt3dS = parcelRequire("bt3dS");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");
var $9XFlr = parcelRequire("9XFlr");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $2Phw0 = parcelRequire("2Phw0");parcelRequire("6bq3s");
var $2Phw0 = parcelRequire("2Phw0");

var $voszV = parcelRequire("voszV");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $3da24e4cf07ae5e9$var$SvgApiResourceDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 40,
        height: 41,
        viewBox: "0 0 40 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                y: 0.5,
                width: 40,
                height: 40,
                rx: 8,
                fill: "#F7F8F8",
                fillOpacity: 0.12
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "path-2-inside-1_4272_16285",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M18.78 6.5a1 1 0 0 0-.97.757L17 10.5l3 1 3-1-.81-3.243a1 1 0 0 0-.97-.757h-2.44Zm0 28a1 1 0 0 1-.97-.758L17 30.5l3-1 3 1-.81 3.242a1 1 0 0 1-.97.758h-2.44Z"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m17.81 7.257-.97-.242.97.242ZM17 10.5l-.97-.242-.225.898.879.293L17 10.5Zm3 1-.316.949.316.105.316-.105L20 11.5Zm3-1 .316.949.879-.293-.225-.899-.97.243Zm-.81-3.243-.97.243.97-.243Zm-4.38 26.485-.97.243.97-.242ZM17 30.5l-.316-.949-.879.293.225.898.97-.242Zm3-1 .316-.949-.316-.105-.316.105.316.949Zm3 1 .97.242.225-.898-.879-.293L23 30.5Zm-4.22-23v-2a2 2 0 0 0-1.94 1.515l1.94.485Zm-.81 3.242.81-3.242-1.94-.485-.81 3.243 1.94.485Zm2.346-.19-3-1-.632 1.897 3 1 .632-1.898Zm2.368-1-3 1 .632 1.897 3-1-.632-1.898ZM21.219 7.5l.81 3.242 1.941-.485-.81-3.242-1.94.485Zm0 0 1.94-.485A2 2 0 0 0 21.22 5.5v2Zm-2.438 0h2.438v-2h-2.438v2Zm-1.94 26.485a2 2 0 0 0 1.94 1.515v-2l-1.94.485Zm-.811-3.242.81 3.242 1.94-.485-.81-3.242-1.94.485Zm3.654-2.192-3 1 .632 1.898 3-1-.632-1.898Zm3.632 1-3-1-.632 1.898 3 1 .632-1.898Zm-.156 4.434.81-3.242-1.94-.485-.81 3.242 1.94.485ZM21.22 35.5a2 2 0 0 0 1.94-1.515l-1.94-.485v2Zm-2.44 0h2.44v-2h-2.44v2Z",
                fill: "#F4A6FE",
                mask: "url(#path-2-inside-1_4272_16285)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "path-4-inside-2_4272_16285",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9.238 11.463a1 1 0 0 0-.15 1.221l1.719 2.866 3.192-1.05 1.05-3.193-2.865-1.72a1 1 0 0 0-1.222.151l-1.724 1.725Zm19.799 19.799a1 1 0 0 1-1.222.15l-2.866-1.72L26 26.5l3.193-1.05 1.72 2.866a1 1 0 0 1-.151 1.221l-1.724 1.725Z"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m9.087 12.684-.857.515.857-.515Zm1.72 2.866-.858.515.412.685.758-.25-.312-.95Zm3.192-1.05.313.95.48-.158.157-.48L14 14.5Zm1.05-3.193.95.313.25-.759-.685-.411-.514.857Zm-2.865-1.72-.515.858.515-.857Zm15.631 21.825-.514.857.514-.857Zm-2.866-1.72L24 29.38l-.25.759.686.41.514-.857ZM26 26.5l-.312-.95-.48.158-.158.48.95.312Zm3.193-1.05.857-.515-.41-.685-.76.25.313.95ZM9.945 12.17 8.53 10.755A2 2 0 0 0 8.23 13.2l1.715-1.03Zm1.72 2.866-1.72-2.866-1.715 1.029 1.72 2.866 1.714-1.03Zm2.022-1.486-3.193 1.05.625 1.9 3.193-1.05-.625-1.9Zm.413-2.555-1.05 3.192 1.9.625L16 11.62l-1.9-.625Zm-2.43-.55 2.865 1.72 1.03-1.715-2.867-1.72-1.029 1.715Zm0 0 1.028-1.715a2 2 0 0 0-2.443.301l1.414 1.414ZM9.944 12.17l1.724-1.725-1.414-1.414-1.724 1.724 1.414 1.415ZM27.3 32.27a2 2 0 0 0 2.443-.301l-1.414-1.415-1.03 1.715Zm-2.866-1.72 2.866 1.72 1.029-1.716-2.866-1.72-1.03 1.716Zm.614-4.363L24 29.38l1.9.625 1.05-3.192-1.9-.626Zm3.83-1.687-3.192 1.05.625 1.9 3.192-1.05-.625-1.9Zm2.89 3.301-1.72-2.866-1.715 1.03 1.72 2.865 1.715-1.029Zm-.3 2.443a2 2 0 0 0 .3-2.443l-1.715 1.03 1.414 1.413Zm-1.725 1.725 1.724-1.725-1.414-1.414-1.724 1.724 1.414 1.415Z",
                fill: "#F4A6FE",
                mask: "url(#path-4-inside-2_4272_16285)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "path-6-inside-3_4272_16285",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M30.762 11.463a1 1 0 0 1 .15 1.221l-1.719 2.866-3.192-1.05-1.05-3.193 2.865-1.72a1 1 0 0 1 1.222.151l1.724 1.725ZM10.963 31.261a1 1 0 0 0 1.222.15l2.866-1.72L14 26.5l-3.193-1.05-1.72 2.866a1 1 0 0 0 .151 1.221l1.724 1.725Z"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m30.913 12.684.857.515-.857-.515Zm-.15-1.221.706-.708-.707.707Zm-1.57 4.087.858.515-.411.685-.76-.25.313-.95Zm-3.192-1.05-.313.95-.48-.158-.157-.48.95-.312Zm-1.05-3.193-.95.313-.25-.759.685-.411.514.857Zm2.865-1.72.515.858-.515-.857Zm1.222.151-.707.707.707-.707ZM12.185 31.412l.514.857-.514-.857Zm-1.222-.15.707-.708-.707.708Zm4.088-1.57.95-.312.25.759-.686.41-.514-.857ZM14 26.5l.312-.95.48.158.158.48-.95.312Zm-3.193-1.05-.857-.515.41-.685.76.25-.313.95Zm-1.72 2.866.858.514-.857-.514Zm.151 1.221-.707.707.707-.707ZM30.055 12.17l1.414-1.415a2 2 0 0 1 .301 2.444l-1.715-1.03Zm-1.72 2.866 1.72-2.866 1.715 1.029-1.72 2.866-1.714-1.03Zm-2.022-1.486 3.193 1.05-.625 1.9-3.193-1.05.625-1.9Zm-.413-2.555 1.05 3.192-1.9.625L24 11.62l1.9-.625Zm2.43-.55-2.865 1.72-1.03-1.715 2.867-1.72 1.029 1.715Zm0 0L27.303 8.73a2 2 0 0 1 2.443.301l-1.414 1.414Zm1.725 1.725-1.724-1.725 1.414-1.414 1.724 1.724-1.414 1.415ZM12.7 32.27a2 2 0 0 1-2.443-.301l1.414-1.415 1.03 1.715Zm2.866-1.72L12.7 32.27l-1.029-1.716 2.866-1.72 1.03 1.716Zm-.614-4.363L16 29.38l-1.9.625-1.05-3.193 1.9-.625ZM11.12 24.5l3.192 1.05-.625 1.9-3.192-1.05.625-1.9ZM8.23 27.8l1.72-2.866 1.715 1.03-1.72 2.865-1.715-1.029Zm.301 2.443a2 2 0 0 1-.3-2.443l1.714 1.03-1.414 1.413Zm1.724 1.725-1.724-1.725 1.414-1.414 1.724 1.724-1.414 1.415Z",
                fill: "#F4A6FE",
                mask: "url(#path-6-inside-3_4272_16285)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "path-8-inside-4_4272_16285",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M6 21.72a1 1 0 0 0 .757.97L10 23.5l1-3-1-3-3.243.81a1 1 0 0 0-.757.97v2.44Zm28 0a1 1 0 0 1-.758.97L30 23.5l-1-3 1-3 3.242.81a1 1 0 0 1 .758.97v2.44Z"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m6.757 22.69-.242.97.242-.97ZM10 23.5l-.243.97.899.225.293-.879L10 23.5Zm1-3 .949.316.105-.316-.105-.316L11 20.5Zm-1-3 .949-.316-.293-.879-.899.225.243.97Zm-3.243.81.243.97-.243-.97Zm26.485 4.38.243.97-.242-.97ZM30 23.5l-.949.316.293.879.898-.225L30 23.5Zm-1-3-.949-.316-.105.316.105.316L29 20.5Zm1-3 .242-.97-.898-.225-.293.879.949.316ZM7 21.72H5a2 2 0 0 0 1.515 1.94L7 21.72Zm3.242.81L7 21.72l-.485 1.94 3.242.81.486-1.94Zm-.19-2.346-1 3 1.897.632 1-3-1.898-.632Zm-1-2.368 1 3 1.897-.632-1-3-1.898.632ZM7 19.281l3.242-.81-.485-1.941-3.242.81L7 19.28Zm0 0-.485-1.94A2 2 0 0 0 5 19.28h2Zm0 2.438v-2.438H5v2.438h2Zm26.485 1.94A2 2 0 0 0 35 21.72h-2l.485 1.94Zm-3.242.811 3.242-.81L33 21.72l-3.242.81.485 1.94Zm-2.192-3.654 1 3 1.898-.632-1-3-1.898.632Zm1-3.632-1 3 1.898.632 1-3-1.898-.632Zm4.434.156-3.242-.81-.485 1.94 3.242.81.485-1.94ZM35 19.28a2 2 0 0 0-1.515-1.94L33 19.28h2Zm0 2.44v-2.44h-2v2.44h2Z",
                fill: "#F4A6FE",
                mask: "url(#path-8-inside-4_4272_16285)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20 31.5c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11Zm0-4a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z",
                fill: "url(#paint0_linear_4272_16285)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#F0DAFF",
                d: "M15 18.5h1v1h-1zM14 18.5h1v1h-1zM14 19.5h1v1h-1zM14 20.5h1v1h-1zM15 20.5h1v1h-1zM16 20.5h1v1h-1zM14 21.5h1v1h-1zM16 18.5h1v1h-1zM17 18.5h1v1h-1zM19 18.5h1v1h-1zM20 18.5h1v1h-1zM21 18.5h1v1h-1zM22 18.5h1v1h-1zM22 19.5h1v1h-1zM24 19.5h1v1h-1zM24 20.5h1v1h-1zM24 21.5h1v1h-1zM24 18.5h1v1h-1zM22 20.5h1v1h-1zM21 20.5h1v1h-1zM20 20.5h1v1h-1zM19 21.5h1v1h-1zM19 20.5h1v1h-1zM19 19.5h1v1h-1zM17 19.5h1v1h-1zM17 20.5h1v1h-1zM17 21.5h1v1h-1z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("defs", {
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                    id: "paint0_linear_4272_16285",
                    x1: 7.193,
                    y1: 22.104,
                    x2: 30.707,
                    y2: 13.422,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            stopColor: "#614DDD"
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            offset: 1,
                            stopColor: "#D47AFE"
                        })
                    ]
                })
            })
        ]
    });
var $3da24e4cf07ae5e9$export$2e2bcd8739ae039 = $3da24e4cf07ae5e9$var$SvgApiResourceDark;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $c9b59df86be12d23$var$SvgApiResource = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 40,
        height: 41,
        viewBox: "0 0 40 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                y: 0.5,
                width: 40,
                height: 40,
                rx: 8,
                fill: "#F3EFFA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "path-2-inside-1_1555_8784",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M18.78 6.5a1 1 0 0 0-.97.757L17 10.5l3 1 3-1-.81-3.243a1 1 0 0 0-.97-.757h-2.44Zm0 28a1 1 0 0 1-.97-.758L17 30.5l3-1 3 1-.81 3.242a1 1 0 0 1-.97.758h-2.44Z"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m17.81 7.257-.97-.242.97.242ZM17 10.5l-.97-.242-.225.898.879.293L17 10.5Zm3 1-.316.949.316.105.316-.105L20 11.5Zm3-1 .316.949.879-.293-.225-.899-.97.243Zm-.81-3.243-.97.243.97-.243Zm-4.38 26.485-.97.243.97-.242ZM17 30.5l-.316-.949-.879.293.225.898.97-.242Zm3-1 .316-.949-.316-.105-.316.105.316.949Zm3 1 .97.242.225-.898-.879-.293L23 30.5Zm-4.22-23v-2a2 2 0 0 0-1.94 1.515l1.94.485Zm-.81 3.242.81-3.242-1.94-.485-.81 3.243 1.94.485Zm2.346-.19-3-1-.632 1.897 3 1 .632-1.898Zm2.368-1-3 1 .632 1.897 3-1-.632-1.898ZM21.219 7.5l.81 3.242 1.941-.485-.81-3.242-1.94.485Zm0 0 1.94-.485A2 2 0 0 0 21.22 5.5v2Zm-2.438 0h2.438v-2h-2.438v2Zm-1.94 26.485a2 2 0 0 0 1.94 1.515v-2l-1.94.485Zm-.811-3.242.81 3.242 1.94-.485-.81-3.242-1.94.485Zm3.654-2.192-3 1 .632 1.898 3-1-.632-1.898Zm3.632 1-3-1-.632 1.898 3 1 .632-1.898Zm-.156 4.434.81-3.242-1.94-.485-.81 3.242 1.94.485ZM21.22 35.5a2 2 0 0 0 1.94-1.515l-1.94-.485v2Zm-2.44 0h2.44v-2h-2.44v2Z",
                fill: "#F07EFF",
                mask: "url(#path-2-inside-1_1555_8784)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "path-4-inside-2_1555_8784",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9.238 11.463a1 1 0 0 0-.15 1.221l1.719 2.866 3.192-1.05 1.05-3.193-2.865-1.72a1 1 0 0 0-1.222.151l-1.724 1.725Zm19.799 19.799a1 1 0 0 1-1.222.15l-2.866-1.72L26 26.5l3.193-1.05 1.72 2.866a1 1 0 0 1-.151 1.221l-1.724 1.725Z"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m9.087 12.684-.857.515.857-.515Zm.15-1.221-.706-.708.707.707Zm1.57 4.087-.858.515.412.685.758-.25-.312-.95Zm3.192-1.05.313.95.48-.158.157-.48L14 14.5Zm1.05-3.193.95.313.25-.759-.685-.411-.514.857Zm-2.865-1.72-.515.858.515-.857Zm-1.222.151.707.707-.707-.707Zm16.853 21.674-.514.857.514-.857Zm1.222-.15-.707-.708.707.708Zm-4.088-1.57L24 29.38l-.25.759.686.41.514-.857ZM26 26.5l-.312-.95-.48.158-.158.48.95.312Zm3.193-1.05.857-.515-.41-.685-.76.25.313.95Zm1.569 4.087.707.707-.707-.707ZM9.945 12.17 8.53 10.755A2 2 0 0 0 8.23 13.2l1.715-1.03Zm1.72 2.866-1.72-2.866-1.715 1.029 1.72 2.866 1.714-1.03Zm2.022-1.486-3.193 1.05.625 1.9 3.193-1.05-.625-1.9Zm.413-2.555-1.05 3.192 1.9.625L16 11.62l-1.9-.625Zm-2.43-.55 2.865 1.72 1.03-1.715-2.867-1.72-1.029 1.715Zm0 0 1.028-1.715a2 2 0 0 0-2.443.301l1.414 1.414ZM9.944 12.17l1.724-1.725-1.414-1.414-1.724 1.724 1.414 1.415ZM27.3 32.27a2 2 0 0 0 2.443-.301l-1.414-1.415-1.03 1.715Zm-2.866-1.72 2.866 1.72 1.029-1.716-2.866-1.72-1.03 1.716Zm.614-4.363L24 29.38l1.9.625 1.05-3.192-1.9-.626Zm3.83-1.687-3.192 1.05.625 1.9 3.192-1.05-.625-1.9Zm2.89 3.301-1.72-2.866-1.715 1.03 1.72 2.865 1.715-1.029Zm-.3 2.443a2 2 0 0 0 .3-2.443l-1.715 1.03 1.414 1.413Zm-1.725 1.725 1.724-1.725-1.414-1.414-1.724 1.724 1.414 1.415Z",
                fill: "#F07EFF",
                mask: "url(#path-4-inside-2_1555_8784)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "path-6-inside-3_1555_8784",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M30.762 11.463a1 1 0 0 1 .15 1.221l-1.719 2.866-3.192-1.05-1.05-3.193 2.865-1.72a1 1 0 0 1 1.222.151l1.724 1.725ZM10.963 31.261a1 1 0 0 0 1.222.15l2.866-1.72L14 26.5l-3.193-1.05-1.72 2.866a1 1 0 0 0 .151 1.221l1.724 1.725Z"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m30.913 12.684.857.515-.857-.515Zm-.15-1.221.706-.708-.707.707Zm-1.57 4.087.858.515-.411.685-.76-.25.313-.95Zm-3.192-1.05-.313.95-.48-.158-.157-.48.95-.312Zm-1.05-3.193-.95.313-.25-.759.685-.411.514.857Zm2.865-1.72.515.858-.515-.857Zm1.222.151-.707.707.707-.707ZM12.185 31.412l.514.857-.514-.857Zm-1.222-.15.707-.708-.707.708Zm4.088-1.57.95-.312.25.759-.686.41-.514-.857ZM14 26.5l.312-.95.48.158.158.48-.95.312Zm-3.193-1.05-.857-.515.41-.685.76.25-.313.95ZM9.24 29.537l-.707.707.707-.707ZM30.055 12.17l1.414-1.415a2 2 0 0 1 .301 2.444l-1.715-1.03Zm-1.72 2.866 1.72-2.866 1.715 1.029-1.72 2.866-1.714-1.03Zm-2.022-1.486 3.193 1.05-.625 1.9-3.193-1.05.625-1.9Zm-.413-2.555 1.05 3.192-1.9.625L24 11.62l1.9-.625Zm2.43-.55-2.865 1.72-1.03-1.715 2.867-1.72 1.029 1.715Zm0 0L27.303 8.73a2 2 0 0 1 2.443.301l-1.414 1.414Zm1.725 1.725-1.724-1.725 1.414-1.414 1.724 1.724-1.414 1.415ZM12.7 32.27a2 2 0 0 1-2.443-.301l1.414-1.415 1.03 1.715Zm2.866-1.72L12.7 32.27l-1.029-1.716 2.866-1.72 1.03 1.716Zm-.614-4.363L16 29.38l-1.9.625-1.05-3.193 1.9-.625ZM11.12 24.5l3.192 1.05-.625 1.9-3.192-1.05.625-1.9ZM8.23 27.8l1.72-2.866 1.715 1.03-1.72 2.865-1.715-1.029Zm.301 2.443a2 2 0 0 1-.3-2.443l1.714 1.03-1.414 1.413Zm1.724 1.725-1.724-1.725 1.414-1.414 1.724 1.724-1.414 1.415Z",
                fill: "#F07EFF",
                mask: "url(#path-6-inside-3_1555_8784)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "path-8-inside-4_1555_8784",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M6 21.72a1 1 0 0 0 .757.97L10 23.5l1-3-1-3-3.243.81a1 1 0 0 0-.757.97v2.44Zm28 0a1 1 0 0 1-.758.97L30 23.5l-1-3 1-3 3.242.81a1 1 0 0 1 .758.97v2.44Z"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m6.757 22.69-.242.97.242-.97ZM10 23.5l-.243.97.899.225.293-.879L10 23.5Zm1-3 .949.316.105-.316-.105-.316L11 20.5Zm-1-3 .949-.316-.293-.879-.899.225.243.97Zm-3.243.81.243.97-.243-.97Zm26.485 4.38.243.97-.242-.97ZM30 23.5l-.949.316.293.879.898-.225L30 23.5Zm-1-3-.949-.316-.105.316.105.316L29 20.5Zm1-3 .242-.97-.898-.225-.293.879.949.316ZM7 21.72H5a2 2 0 0 0 1.515 1.94L7 21.72Zm3.242.81L7 21.72l-.485 1.94 3.242.81.486-1.94Zm-.19-2.346-1 3 1.897.632 1-3-1.898-.632Zm-1-2.368 1 3 1.897-.632-1-3-1.898.632ZM7 19.281l3.242-.81-.485-1.941-3.242.81L7 19.28Zm0 0-.485-1.94A2 2 0 0 0 5 19.28h2Zm0 2.438v-2.438H5v2.438h2Zm26.485 1.94A2 2 0 0 0 35 21.72h-2l.485 1.94Zm-3.242.811 3.242-.81L33 21.72l-3.242.81.485 1.94Zm-2.192-3.654 1 3 1.898-.632-1-3-1.898.632Zm1-3.632-1 3 1.898.632 1-3-1.898-.632Zm4.434.156-3.242-.81-.485 1.94 3.242.81.485-1.94ZM35 19.28a2 2 0 0 0-1.515-1.94L33 19.28h2Zm0 2.44v-2.44h-2v2.44h2Z",
                fill: "#F07EFF",
                mask: "url(#path-8-inside-4_1555_8784)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20 31.5c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11Zm0-4a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z",
                fill: "url(#paint0_linear_1555_8784)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#1B1B22",
                d: "M15 18.5h1v1h-1zM14 18.5h1v1h-1zM14 19.5h1v1h-1zM14 20.5h1v1h-1zM15 20.5h1v1h-1zM16 20.5h1v1h-1zM14 21.5h1v1h-1zM16 18.5h1v1h-1zM17 18.5h1v1h-1zM19 18.5h1v1h-1zM20 18.5h1v1h-1zM21 18.5h1v1h-1zM22 18.5h1v1h-1zM22 19.5h1v1h-1zM24 19.5h1v1h-1zM24 20.5h1v1h-1zM24 21.5h1v1h-1zM24 18.5h1v1h-1zM22 20.5h1v1h-1zM21 20.5h1v1h-1zM20 20.5h1v1h-1zM19 21.5h1v1h-1zM19 20.5h1v1h-1zM19 19.5h1v1h-1zM17 19.5h1v1h-1zM17 20.5h1v1h-1zM17 21.5h1v1h-1z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("defs", {
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                    id: "paint0_linear_1555_8784",
                    x1: 7.193,
                    y1: 22.104,
                    x2: 32.587,
                    y2: 9.589,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            stopColor: "#492EF3"
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            offset: 1,
                            stopColor: "#CF69FF"
                        })
                    ]
                })
            })
        ]
    });
var $c9b59df86be12d23$export$2e2bcd8739ae039 = $c9b59df86be12d23$var$SvgApiResource;




var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $f71d98d4090dad5c$var$SvgFile = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M7.5 8.333h.833a.833.833 0 1 0 0-1.666H7.5a.833.833 0 1 0 0 1.666ZM7.5 10a.833.833 0 1 0 0 1.667h5a.833.833 0 1 0 0-1.667h-5Zm9.167-2.55a1.097 1.097 0 0 0-.05-.225V7.15a.893.893 0 0 0-.159-.233l-5-5a.892.892 0 0 0-.233-.159.267.267 0 0 0-.075 0 .733.733 0 0 0-.275-.091H5.833a2.5 2.5 0 0 0-2.5 2.5v11.666a2.5 2.5 0 0 0 2.5 2.5h8.334a2.5 2.5 0 0 0 2.5-2.5V7.45Zm-5-2.942 2.158 2.159H12.5a.833.833 0 0 1-.833-.834V4.508ZM15 15.833a.833.833 0 0 1-.833.834H5.833A.833.833 0 0 1 5 15.833V4.167a.833.833 0 0 1 .833-.834H10v2.5a2.5 2.5 0 0 0 2.5 2.5H15v7.5Zm-2.5-2.5h-5A.833.833 0 1 0 7.5 15h5a.833.833 0 0 0 0-1.667Z",
            fill: "currentColor"
        })
    });
var $f71d98d4090dad5c$export$2e2bcd8739ae039 = $f71d98d4090dad5c$var$SvgFile;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $9260430af4663ded$var$SvgManagementApiResourceDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 40,
        height: 41,
        viewBox: "0 0 40 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                y: 0.5,
                width: 40,
                height: 40,
                rx: 8,
                fill: "#F7F8F8",
                fillOpacity: 0.12
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.25 10.654c0-.603 0-.905.117-1.148.103-.214.269-.395.478-.522.237-.145.552-.187 1.182-.273l8.984-1.222c.815-.11 1.223-.166 1.54-.049.278.103.51.294.657.54.167.28.167.671.167 1.453v16.884c0 .782 0 1.172-.167 1.453a1.276 1.276 0 0 1-.657.54c-.317.117-.725.061-1.54-.05L9.027 27.04c-.63-.086-.945-.128-1.182-.273a1.248 1.248 0 0 1-.478-.522c-.117-.243-.117-.545-.117-1.148V10.654Zm9.625 5.693c0-.184 0-.275.03-.348a.344.344 0 0 1 .126-.154c.062-.04.144-.049.307-.065l.732-.075c.192-.02.289-.03.363.007.065.031.12.086.153.156.039.08.039.188.039.405v3.204c0 .217 0 .325-.039.405a.335.335 0 0 1-.153.156c-.074.036-.17.026-.363.007l-.732-.075c-.163-.016-.245-.024-.307-.066a.344.344 0 0 1-.125-.153c-.031-.073-.031-.164-.031-.348v-3.056Zm5.97-6.785h-1.157v17.063h1.156c.668 0 1.001 0 1.256-.13.224-.115.406-.297.52-.522.13-.256.13-.59.13-1.259v-13.24c0-.67 0-1.004-.13-1.26a1.193 1.193 0 0 0-.52-.521c-.255-.13-.588-.13-1.256-.13Z",
                fill: "url(#paint0_linear_8738_119575)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "path-3-inside-1_8738_119575",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M25.319 19.5a.5.5 0 0 0-.485.379l-.441 1.764 1.607.536 1.607-.536-.44-1.764a.5.5 0 0 0-.486-.379h-1.362Zm0 15a.5.5 0 0 1-.485-.379l-.441-1.764L26 31.821l1.607.536-.44 1.764a.5.5 0 0 1-.486.379h-1.362Z"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m24.834 19.879 77.611 19.403-77.611-19.403Zm-.441 1.764L-53.22 2.24l-17.967 71.87 70.28 23.427 25.299-75.894Zm1.607.536L.702 98.073 26 106.506l25.298-8.433L26 22.18Zm1.607-.536 25.298 75.894 70.281-23.426L105.219 2.24 27.607 21.643Zm-.44-1.764L104.776.476l-77.61 19.403ZM24.833 34.12l-77.612 19.403 77.612-19.403Zm-.441-1.764L-.905-43.537-71.186-20.11l17.968 71.87 77.61-19.403ZM26 31.821l25.298-75.894L26-52.506.702-44.073 26 31.82Zm1.607.536L105.22 51.76l17.967-71.87-70.28-23.428-25.299 75.895Zm-.44 1.764 77.61 19.403h.001L27.166 34.121Zm75.278 5.16C93.598 74.673 61.799 99.5 25.319 99.5v-160C-11.62-60.5-43.82-35.36-52.778.476l155.223 38.806Zm-.441 1.765.441-1.764L-52.777.476l-.442 1.764 155.223 38.806ZM51.298-53.716l-1.607-.536L-.905 97.538l1.607.535 50.596-151.79Zm-48.99-.536-1.606.536 50.596 151.79 1.607-.537L2.31-54.251Zm-52.753 93.534.44 1.764L105.22 2.24l-.442-1.764-155.222 38.806ZM26.68 99.5c-36.48 0-68.279-24.828-77.126-60.218L104.777.476C95.818-35.36 63.62-60.5 26.681-60.5v160Zm-1.362 0h1.362v-160h-1.362v160Zm-78.097-45.976C-43.818 89.36-11.62 114.5 25.32 114.5v-160c36.48 0 68.279 24.828 77.126 60.218L-52.777 53.524Zm-.44-1.764.44 1.764 155.223-38.806-.441-1.764L-53.218 51.76ZM.702-44.073l-1.607.535 50.596 151.79 1.607-.536L.702-44.074Zm52.203.535-1.607-.535L.702 107.716l1.607.536 50.596-151.79Zm51.873 97.062.441-1.764-155.223-38.806-.441 1.764 155.223 38.806ZM26.681 114.5c36.939 0 69.138-25.14 78.096-60.976L-50.445 14.718C-41.598-20.672-9.8-45.5 26.68-45.5v160Zm-1.362 0h1.362v-160h-1.362v160Z",
                fill: "#FAABFF",
                mask: "url(#path-3-inside-1_8738_119575)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "path-5-inside-2_8738_119575",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M20.215 22.178a.5.5 0 0 0-.075.611l.935 1.56 1.71-.563.563-1.71-1.56-.936a.5.5 0 0 0-.61.075l-.963.963Zm10.607 10.607a.5.5 0 0 1-.611.075l-1.56-.936.563-1.71 1.71-.563.936 1.56a.5.5 0 0 1-.075.61l-.963.964Z"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m20.14 22.789 68.6-41.16-68.6 41.16Zm.935 1.56-68.6 41.159 32.885 54.807 60.715-19.973-25-75.994Zm1.71-.563 25 75.993 38.371-12.623L98.78 48.785l-75.993-25Zm.563-1.71 75.994 24.999 19.973-60.715-54.807-32.884-41.16 68.6Zm-1.56-.936 41.16-68.6-41.16 68.6Zm8.423 11.72-41.16 68.599 41.16-68.6Zm-1.56-.936L-47.34 6.921l-19.977 60.717 54.81 32.886 41.16-68.6Zm.563-1.71L4.211-45.778l-38.366 12.623L-46.778 5.21l75.992 25.003Zm1.71-.563 68.6-41.16-32.886-54.809L5.922-46.34 30.924 29.65Zm.936 1.56 68.599-41.16-68.6 41.16Zm56.88-49.582c18.768 31.282 13.839 71.323-11.956 97.118L-36.355-34.39c-26.12 26.12-31.11 66.664-12.106 98.339l137.2-82.32Zm.935 1.56-.936-1.56L-48.46 63.95l.936 1.559 137.199-82.32Zm-91.89-35.397-1.71.563 50 151.987 1.71-.563-50-151.987Zm-50.43 49.284-.563 1.71L98.779 48.785l.563-1.71L-52.646-2.924Zm33.274 92.663 1.56.936L64.508-46.524l-1.56-.936-82.319 137.2Zm97.118-11.955C51.95 103.579 11.91 108.508-19.371 89.739L62.95-47.46c-31.675-19.005-72.22-14.013-98.34 12.107L77.748 77.784Zm-.963.963.963-.963L-35.391-35.354l-.963.964L76.784 78.747Zm-87.733 22.712c31.675 19.005 72.22 14.014 98.34-12.106L-25.748-23.784C.048-49.579 40.09-54.508 71.37-35.74L-10.949 101.46Zm-1.56-.935 1.56.935L71.371-35.74l-1.56-.935-82.32 137.199Zm-34.27-95.313-.562 1.71 151.985 50.007.563-1.71L-46.778 5.21Zm52.7-51.552-1.71.563 50.006 151.985 1.71-.563L5.922-46.341ZM100.46-9.95l-.935-1.56-137.2 82.32.937 1.56L100.459-9.95ZM88.353 88.39c26.12-26.12 31.111-66.664 12.106-98.339l-137.198 82.32C-55.51 41.088-50.58 1.047-24.784-24.748L88.353 88.39Zm-.963.963.963-.963L-24.784-24.747l-.963.963L87.39 89.353Z",
                fill: "#FAABFF",
                mask: "url(#path-5-inside-2_8738_119575)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "path-7-inside-3_8738_119575",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M31.785 22.178a.5.5 0 0 1 .075.611l-.935 1.56-1.71-.563-.563-1.71 1.56-.936a.5.5 0 0 1 .61.075l.963.963ZM21.178 32.785a.5.5 0 0 0 .611.075l1.56-.936-.563-1.71-1.71-.563-.936 1.56a.5.5 0 0 0 .075.61l.963.964Z"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m31.86 22.789-68.6-41.16 68.6 41.16Zm-.935 1.56 68.6 41.159-32.886 54.808-60.715-19.975 25-75.993Zm-1.71-.563L4.213 99.779l-38.369-12.623-12.623-38.369 75.993-25.001Zm-.563-1.71-75.993 25.001-19.976-60.716 54.81-32.885 41.159 68.6Zm1.56-.936-41.16-68.6 41.16 68.6Zm-8.423 11.72 41.16 68.599-41.16-68.6Zm1.56-.936 75.993-25 19.974 60.715-54.808 32.885-41.16-68.6Zm-.563-1.71 25.002-75.993 38.368 12.624L98.78 5.213 22.786 30.214Zm-1.71-.563-68.6-41.16 32.886-54.808 60.716 19.976L21.076 29.65Zm-.936 1.56-68.6-41.16 68.6 41.16Zm-56.88-49.582c-18.768 31.282-13.839 71.323 11.957 97.118L88.353-34.39c26.119 26.12 31.111 66.664 12.106 98.339l-137.2-82.32Zm-.935 1.56.936-1.56L100.46 63.95l-.936 1.559-137.199-82.32Zm91.89-35.397 1.71.563-50 151.986-1.711-.562L54.215-52.208Zm50.43 49.281.562 1.71-151.985 50.005-.563-1.71L104.645-2.928ZM71.371 89.74l-1.56.936-82.319-137.199 1.56-.936L71.37 89.74Zm-97.118-11.955C.05 103.579 40.09 108.508 71.371 89.739L-10.95-47.46c31.675-19.005 72.22-14.013 98.34 12.107L-25.748 77.784Zm.963.963-.963-.963L87.391-35.354l.963.964L-24.784 78.747Zm87.733 22.712c-31.675 19.005-72.22 14.014-98.34-12.106L77.748-23.784C51.952-49.579 11.91-54.508-19.37-35.74L62.949 101.46Zm1.56-.935-1.56.935-82.32-137.199 1.56-.935 82.32 137.199Zm34.27-95.31.563 1.71-151.987 50-.562-1.71 151.986-50ZM46.078-46.342l1.71.562-50.004 151.986-1.71-.563L46.078-46.341ZM-48.46-9.95l.935-1.56 137.2 82.32-.936 1.56-137.2-82.32Zm12.106 98.339C-62.473 62.27-67.464 21.726-48.46-9.949L88.74 72.371c18.768-31.282 13.839-71.323-11.956-97.118L-36.353 88.39Zm.963.963-.963-.963L76.784-24.747l.963.963L-35.39 89.353Z",
                fill: "#FAABFF",
                mask: "url(#path-7-inside-3_8738_119575)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "path-9-inside-4_8738_119575",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M18.5 27.68a.5.5 0 0 0 .379.485l1.764.441.536-1.607-.536-1.607-1.764.441a.5.5 0 0 0-.379.485v1.362Zm15 0a.5.5 0 0 1-.379.485l-1.764.441L30.821 27l.536-1.607 1.764.441a.5.5 0 0 1 .379.485v1.362Z"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m18.879 28.165 19.403-77.611-19.403 77.611Zm1.764.441L1.24 106.218l71.87 17.967 23.427-70.28-75.894-25.299ZM21.179 27l75.894 25.299 8.433-25.299-8.433-25.298L21.18 27Zm-.536-1.607L96.537.094l-23.426-70.28L1.24-52.22l19.403 77.611Zm-1.764.441L-.524-51.778l19.403 77.611Zm14.242 2.332 19.403 77.612-19.403-77.612Zm-1.764.441-75.894 25.299 23.427 70.28 71.87-17.967-19.403-77.612ZM30.821 27-45.073 1.701l-8.433 25.298 8.433 25.299L30.82 26.999Zm.536-1.607L50.76-52.219l-71.87-17.968L-44.538.093l75.895 25.3Zm1.764.441 19.403-77.611-19.403 77.611Zm5.16-75.279C73.673-40.598 98.5-8.8 98.5 27.68h-160c0 36.94 25.14 69.138 60.976 78.097L38.282-49.446Zm1.765.441-1.764-.441L-.524 105.777l1.764.441L40.046-49.005ZM-54.716 1.701l-.536 1.607 151.79 50.597.535-1.608-151.79-50.596Zm-.536 48.99.536 1.606L97.074 1.702 96.536.094-55.251 50.69Zm93.534 52.754 1.764-.441L1.24-52.219l-1.764.44 38.806 155.224ZM98.5 26.318c0 36.48-24.828 68.279-60.218 77.127L-.524-51.778C-36.36-42.82-61.5-10.621-61.5 26.318h160Zm0 1.362v-1.362h-160v1.362h160Zm-45.976 78.097C88.36 96.817 113.5 64.619 113.5 27.68h-160c0-36.48 24.828-68.278 60.218-77.126l38.806 155.223Zm-1.764.441 1.764-.441L13.718-49.446l-1.764.441L50.76 106.218Zm-95.833-53.92.535 1.607 151.79-50.597-.536-1.607-151.79 50.597Zm.535-52.204-.535 1.607 151.789 50.597.536-1.608L-44.538.094Zm97.062-51.872-1.764-.441-38.806 155.223 1.764.441L52.524-51.778ZM113.5 26.318c0-36.939-25.14-69.137-60.976-78.096L13.718 103.445C-21.672 94.597-46.5 62.798-46.5 26.318h160Zm0 1.362v-1.362h-160v1.362h160Z",
                fill: "#FAABFF",
                mask: "url(#path-9-inside-4_8738_119575)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M31.893 27a5.893 5.893 0 1 1-11.786 0 5.893 5.893 0 0 1 11.786 0Z",
                fill: "url(#paint1_linear_8738_119575)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 26,
                cy: 26.999,
                r: 3.75,
                fill: "#3A3B59"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#F7F8F8",
                d: "M23.589 25.929h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#F7F8F8",
                d: "M23.053 25.929h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#F7F8F8",
                d: "M23.053 26.464h.536V27h-.536zM23.053 27h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#F7F8F8",
                d: "M23.589 27h.536v.536h-.536zM24.125 27h.536v.536h-.536zM23.053 27.536h.536v.536h-.536zM24.125 25.929h.536v.536h-.536zM24.661 25.929h.536v.536h-.536zM25.732 25.929h.536v.536h-.536zM26.268 25.929h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#F7F8F8",
                d: "M26.803 25.929h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#F7F8F8",
                d: "M27.339 25.929h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#F7F8F8",
                d: "M27.339 26.464h.536V27h-.536zM28.411 26.464h.536V27h-.536zM28.411 27h.536v.536h-.536zM28.411 27.536h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#F7F8F8",
                d: "M28.411 25.929h.536v.536h-.536zM27.339 27h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#F7F8F8",
                d: "M26.803 27h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#F7F8F8",
                d: "M26.268 27h.536v.536h-.536zM25.732 27.536h.536v.536h-.536zM25.732 27h.536v.536h-.536zM25.732 26.464h.536V27h-.536zM24.661 26.464h.536V27h-.536zM24.661 27h.536v.536h-.536zM24.661 27.536h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_8738_119575",
                        x1: 1.833,
                        y1: 21.898,
                        x2: 23.389,
                        y2: 13.086,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#4B2EFB"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E65FFC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_8738_119575",
                        x1: 19.139,
                        y1: 27.859,
                        x2: 32.743,
                        y2: 21.154,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $9260430af4663ded$export$2e2bcd8739ae039 = $9260430af4663ded$var$SvgManagementApiResourceDark;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $ff631a8563f36219$var$SvgManagementApiResource = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 40,
        height: 41,
        viewBox: "0 0 40 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                y: 0.5,
                width: 40,
                height: 40,
                rx: 8,
                fill: "#F3EFFA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.25 10.654c0-.603 0-.905.117-1.148.103-.214.269-.395.478-.522.237-.145.552-.187 1.182-.273l8.984-1.222c.815-.11 1.223-.166 1.54-.049.278.103.51.294.657.54.167.28.167.671.167 1.453v16.884c0 .782 0 1.172-.167 1.453a1.276 1.276 0 0 1-.657.54c-.317.117-.725.061-1.54-.05L9.027 27.04c-.63-.086-.945-.128-1.182-.273a1.248 1.248 0 0 1-.478-.522c-.117-.243-.117-.545-.117-1.148V10.654Zm9.625 5.693c0-.184 0-.275.03-.348a.344.344 0 0 1 .126-.154c.062-.04.144-.049.307-.065l.732-.075c.192-.02.289-.03.363.007.065.031.12.086.153.156.039.08.039.188.039.405v3.204c0 .217 0 .325-.039.405a.335.335 0 0 1-.153.156c-.074.036-.17.026-.363.007l-.732-.075c-.163-.016-.245-.024-.307-.066a.344.344 0 0 1-.125-.153c-.031-.073-.031-.164-.031-.348v-3.056Zm5.97-6.785h-1.157v17.063h1.156c.668 0 1.001 0 1.256-.13.224-.115.406-.297.52-.522.13-.256.13-.59.13-1.259v-13.24c0-.67 0-1.004-.13-1.26a1.193 1.193 0 0 0-.52-.521c-.255-.13-.588-.13-1.256-.13Z",
                fill: "url(#paint0_linear_8738_113352)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "path-3-inside-1_8738_113352",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M25.319 19.5a.5.5 0 0 0-.485.379l-.441 1.764 1.607.536 1.607-.536-.44-1.764a.5.5 0 0 0-.486-.379h-1.362Zm0 15a.5.5 0 0 1-.485-.379l-.441-1.764L26 31.821l1.607.536-.44 1.764a.5.5 0 0 1-.486.379h-1.362Z"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m24.834 19.879 77.611 19.403-77.611-19.403Zm-.441 1.764L-53.22 2.24l-17.967 71.87 70.28 23.427 25.299-75.894Zm1.607.536L.702 98.073 26 106.506l25.298-8.433L26 22.18Zm1.607-.536 25.298 75.894 70.281-23.426L105.219 2.24 27.607 21.643Zm-.44-1.764L104.776.476l-77.61 19.403ZM24.833 34.12l-77.612 19.403 77.612-19.403Zm-.441-1.764L-.905-43.537-71.186-20.11l17.968 71.87 77.61-19.403ZM26 31.821l25.298-75.894L26-52.506.702-44.073 26 31.82Zm1.607.536L105.22 51.76l17.967-71.87-70.28-23.428-25.299 75.895Zm-.44 1.764 77.61 19.403h.001L27.166 34.121Zm75.278 5.16C93.598 74.673 61.799 99.5 25.319 99.5v-160C-11.62-60.5-43.82-35.36-52.778.476l155.223 38.806Zm-.441 1.765.441-1.764L-52.777.476l-.442 1.764 155.223 38.806ZM51.298-53.716l-1.607-.536L-.905 97.538l1.607.535 50.596-151.79Zm-48.99-.536-1.606.536 50.596 151.79 1.607-.537L2.31-54.251Zm-52.753 93.534.44 1.764L105.22 2.24l-.442-1.764-155.222 38.806ZM26.68 99.5c-36.48 0-68.279-24.828-77.126-60.218L104.777.476C95.818-35.36 63.62-60.5 26.681-60.5v160Zm-1.362 0h1.362v-160h-1.362v160Zm-78.097-45.976C-43.818 89.36-11.62 114.5 25.32 114.5v-160c36.48 0 68.279 24.828 77.126 60.218L-52.777 53.524Zm-.44-1.764.44 1.764 155.223-38.806-.441-1.764L-53.218 51.76ZM.702-44.073l-1.607.535 50.596 151.79 1.607-.536L.702-44.074Zm52.203.535-1.607-.535L.702 107.716l1.607.536 50.596-151.79Zm51.873 97.062.441-1.764-155.223-38.806-.441 1.764 155.223 38.806ZM26.681 114.5c36.939 0 69.138-25.14 78.096-60.976L-50.445 14.718C-41.598-20.672-9.8-45.5 26.68-45.5v160Zm-1.362 0h1.362v-160h-1.362v160Z",
                fill: "#F07EFF",
                mask: "url(#path-3-inside-1_8738_113352)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "path-5-inside-2_8738_113352",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M20.215 22.178a.5.5 0 0 0-.075.611l.935 1.56 1.71-.563.563-1.71-1.56-.936a.5.5 0 0 0-.61.075l-.963.963Zm10.607 10.607a.5.5 0 0 1-.611.075l-1.56-.936.563-1.71 1.71-.563.936 1.56a.5.5 0 0 1-.075.61l-.963.964Z"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m20.14 22.789 68.6-41.16-68.6 41.16Zm.075-.61-56.569-56.57 56.569 56.57Zm.86 2.17-68.6 41.159 32.885 54.807 60.715-19.973-25-75.994Zm1.71-.563 25 75.993 38.371-12.623L98.78 48.785l-75.993-25Zm.563-1.71 75.994 24.999 19.973-60.715-54.807-32.884-41.16 68.6Zm-1.56-.936 41.16-68.6-41.16 68.6Zm-.61.075 56.569 56.569-56.569-56.569Zm9.033 11.645-41.16 68.599 41.16-68.6Zm-1.56-.936L-47.34 6.921l-19.977 60.717 54.81 32.886 41.16-68.6Zm.563-1.71L4.211-45.778l-38.366 12.623L-46.778 5.21l75.992 25.003Zm1.71-.563 68.6-41.16-32.886-54.809L5.922-46.34 30.924 29.65Zm.936 1.56 68.599-41.16-68.6 41.16Zm56.88-49.582c18.768 31.282 13.839 71.323-11.956 97.118L-36.355-34.39c-26.12 26.12-31.11 66.664-12.106 98.339l137.2-82.32Zm.935 1.56-.936-1.56L-48.46 63.95l.936 1.559 137.199-82.32Zm-91.89-35.397-1.71.563 50 151.987 1.71-.563-50-151.987Zm-50.43 49.284-.563 1.71L98.779 48.785l.563-1.71L-52.646-2.924Zm33.274 92.663 1.56.936L64.508-46.524l-1.56-.936-82.319 137.2Zm97.118-11.955C51.95 103.579 11.91 108.508-19.371 89.739L62.95-47.46c-31.675-19.005-72.22-14.013-98.34 12.107L77.748 77.784Zm-.963.963.963-.963L-35.391-35.354l-.963.964L76.784 78.747Zm-87.733 22.712c31.675 19.005 72.22 14.014 98.34-12.106L-25.748-23.784C.048-49.579 40.09-54.508 71.37-35.74L-10.949 101.46Zm-1.56-.935 1.56.935L71.371-35.74l-1.56-.935-82.32 137.199Zm-34.27-95.313-.562 1.71 151.985 50.007.563-1.71L-46.778 5.21Zm52.7-51.552-1.71.563 50.006 151.985 1.71-.563L5.922-46.341ZM100.46-9.95l-.935-1.56-137.2 82.32.937 1.56L100.459-9.95ZM88.353 88.39c26.12-26.12 31.111-66.664 12.106-98.339l-137.198 82.32C-55.51 41.088-50.58 1.047-24.784-24.748L88.353 88.39Zm-.963.963.963-.963L-24.784-24.747l-.963.963L87.39 89.353Z",
                fill: "#F07EFF",
                mask: "url(#path-5-inside-2_8738_113352)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "path-7-inside-3_8738_113352",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M31.785 22.178a.5.5 0 0 1 .075.611l-.935 1.56-1.71-.563-.563-1.71 1.56-.936a.5.5 0 0 1 .61.075l.963.963ZM21.178 32.785a.5.5 0 0 0 .611.075l1.56-.936-.563-1.71-1.71-.563-.936 1.56a.5.5 0 0 0 .075.61l.963.964Z"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m31.86 22.789-68.6-41.16 68.6 41.16Zm-.075-.61 56.569-56.57-56.569 56.57Zm-.86 2.17 68.6 41.159-32.886 54.808-60.715-19.975 25-75.993Zm-1.71-.563L4.213 99.779l-38.369-12.623-12.623-38.369 75.993-25.001Zm-.563-1.71-75.993 25.001-19.976-60.716 54.81-32.885 41.159 68.6Zm1.56-.936-41.16-68.6 41.16 68.6Zm.61.075-56.569 56.569 56.569-56.569ZM21.789 32.86l41.16 68.599-41.16-68.6Zm1.56-.936 75.993-25 19.974 60.715-54.808 32.885-41.16-68.6Zm-.563-1.71 25.002-75.993 38.368 12.624L98.78 5.213 22.786 30.214Zm-1.71-.563-68.6-41.16 32.886-54.808 60.716 19.976L21.076 29.65Zm-.936 1.56-68.6-41.16 68.6 41.16Zm-56.88-49.582c-18.768 31.282-13.839 71.323 11.957 97.118L88.353-34.39c26.119 26.12 31.111 66.664 12.106 98.339l-137.2-82.32Zm-.935 1.56.936-1.56L100.46 63.95l-.936 1.559-137.199-82.32Zm91.89-35.397 1.71.563-50 151.986-1.711-.562L54.215-52.208Zm50.43 49.281.562 1.71-151.985 50.005-.563-1.71L104.645-2.928ZM71.371 89.74l-1.56.936-82.319-137.199 1.56-.936L71.37 89.74Zm-97.118-11.955C.05 103.579 40.09 108.508 71.371 89.739L-10.95-47.46c31.675-19.005 72.22-14.013 98.34 12.107L-25.748 77.784Zm.963.963-.963-.963L87.391-35.354l.963.964L-24.784 78.747Zm87.733 22.712c-31.675 19.005-72.22 14.014-98.34-12.106L77.748-23.784C51.952-49.579 11.91-54.508-19.37-35.74L62.949 101.46Zm1.56-.935-1.56.935-82.32-137.199 1.56-.935 82.32 137.199Zm34.27-95.31.563 1.71-151.987 50-.562-1.71 151.986-50ZM46.078-46.342l1.71.562-50.004 151.986-1.71-.563L46.078-46.341ZM-48.46-9.95l.935-1.56 137.2 82.32-.936 1.56-137.2-82.32Zm12.106 98.339C-62.473 62.27-67.464 21.726-48.46-9.949L88.74 72.371c18.768-31.282 13.839-71.323-11.956-97.118L-36.353 88.39Zm.963.963-.963-.963L76.784-24.747l.963.963L-35.39 89.353Z",
                fill: "#F07EFF",
                mask: "url(#path-7-inside-3_8738_113352)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "path-9-inside-4_8738_113352",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M18.5 27.68a.5.5 0 0 0 .379.485l1.764.441.536-1.607-.536-1.607-1.764.441a.5.5 0 0 0-.379.485v1.362Zm15 0a.5.5 0 0 1-.379.485l-1.764.441L30.821 27l.536-1.607 1.764.441a.5.5 0 0 1 .379.485v1.362Z"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m18.879 28.165 19.403-77.611-19.403 77.611Zm1.764.441L1.24 106.218l71.87 17.967 23.427-70.28-75.894-25.299ZM21.179 27l75.894 25.299 8.433-25.299-8.433-25.298L21.18 27Zm-.536-1.607L96.537.094l-23.426-70.28L1.24-52.22l19.403 77.611Zm-1.764.441L-.524-51.778l19.403 77.611Zm14.242 2.332 19.403 77.612-19.403-77.612Zm-1.764.441-75.894 25.299 23.427 70.28 71.87-17.967-19.403-77.612ZM30.821 27-45.073 1.701l-8.433 25.298 8.433 25.299L30.82 26.999Zm.536-1.607L50.76-52.219l-71.87-17.968L-44.538.093l75.895 25.3Zm1.764.441 19.403-77.611-19.403 77.611Zm5.16-75.279C73.673-40.598 98.5-8.8 98.5 27.68h-160c0 36.94 25.14 69.138 60.976 78.097L38.282-49.446Zm1.765.441-1.764-.441L-.524 105.777l1.764.441L40.046-49.005ZM-54.716 1.701l-.536 1.607 151.79 50.597.535-1.608-151.79-50.596Zm-.536 48.99.536 1.606L97.074 1.702 96.536.094-55.251 50.69Zm93.534 52.754 1.764-.441L1.24-52.219l-1.764.44 38.806 155.224ZM98.5 26.318c0 36.48-24.828 68.279-60.218 77.127L-.524-51.778C-36.36-42.82-61.5-10.621-61.5 26.318h160Zm0 1.362v-1.362h-160v1.362h160Zm-45.976 78.097C88.36 96.817 113.5 64.619 113.5 27.68h-160c0-36.48 24.828-68.278 60.218-77.126l38.806 155.223Zm-1.764.441 1.764-.441L13.718-49.446l-1.764.441L50.76 106.218Zm-95.833-53.92.535 1.607 151.79-50.597-.536-1.607-151.79 50.597Zm.535-52.204-.535 1.607 151.789 50.597.536-1.608L-44.538.094Zm97.062-51.872-1.764-.441-38.806 155.223 1.764.441L52.524-51.778ZM113.5 26.318c0-36.939-25.14-69.137-60.976-78.096L13.718 103.445C-21.672 94.597-46.5 62.798-46.5 26.318h160Zm0 1.362v-1.362h-160v1.362h160Z",
                fill: "#F07EFF",
                mask: "url(#path-9-inside-4_8738_113352)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M31.893 27a5.893 5.893 0 1 1-11.786 0 5.893 5.893 0 0 1 11.786 0Z",
                fill: "url(#paint1_linear_8738_113352)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 26,
                cy: 26.999,
                r: 3.75,
                fill: "#F3EFFA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#1B1B22",
                d: "M23.589 25.929h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#1B1B22",
                d: "M23.053 25.929h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#1B1B22",
                d: "M23.053 26.464h.536V27h-.536zM23.053 27h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#1B1B22",
                d: "M23.589 27h.536v.536h-.536zM24.125 27h.536v.536h-.536zM23.053 27.536h.536v.536h-.536zM24.125 25.929h.536v.536h-.536zM24.661 25.929h.536v.536h-.536zM25.732 25.929h.536v.536h-.536zM26.268 25.929h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#1B1B22",
                d: "M26.803 25.929h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#1B1B22",
                d: "M27.339 25.929h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#1B1B22",
                d: "M27.339 26.464h.536V27h-.536zM28.411 26.464h.536V27h-.536zM28.411 27h.536v.536h-.536zM28.411 27.536h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#1B1B22",
                d: "M28.411 25.929h.536v.536h-.536zM27.339 27h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#1B1B22",
                d: "M26.803 27h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#1B1B22",
                d: "M26.268 27h.536v.536h-.536zM25.732 27.536h.536v.536h-.536zM25.732 27h.536v.536h-.536zM25.732 26.464h.536V27h-.536zM24.661 26.464h.536V27h-.536zM24.661 27h.536v.536h-.536zM24.661 27.536h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_8738_113352",
                        x1: 1.833,
                        y1: 21.898,
                        x2: 23.389,
                        y2: 13.086,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#4B2EFB"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E65FFC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_8738_113352",
                        x1: 19.139,
                        y1: 27.859,
                        x2: 32.743,
                        y2: 21.154,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $ff631a8563f36219$export$2e2bcd8739ae039 = $ff631a8563f36219$var$SvgManagementApiResource;



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $a964dbd437bfde7b$var$SvgBack = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 -2 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M10.357 13.656 4.7 8l5.657-5.657.943.943L6.585 8l4.715 4.714-.943.942Z",
            fill: "currentColor"
        })
    });
var $a964dbd437bfde7b$export$2e2bcd8739ae039 = $a964dbd437bfde7b$var$SvgBack;



var $66ixW = parcelRequire("66ixW");

var $9Q3SI = parcelRequire("9Q3SI");


var $C7mD2 = parcelRequire("C7mD2");


var $jbKqE = parcelRequire("jbKqE");
var $69269db3183d321c$export$2ba01fb71ed41cb6;
var $69269db3183d321c$export$34e0f9847d4c02dd;
var $69269db3183d321c$export$38e42c68cf43b5d4;
var $69269db3183d321c$export$1ca1ec8b29a4ce27;
var $69269db3183d321c$export$bfd64c937657f93a;
var $69269db3183d321c$export$4a6dd88bada4e7d2;
var $69269db3183d321c$export$1261a644c63cbc91;
var $69269db3183d321c$export$8b7a896ae75accbf;
var $69269db3183d321c$export$fb184b623420d9be;
var $69269db3183d321c$export$cc74dcc53cfce4eb;
$69269db3183d321c$export$2ba01fb71ed41cb6 = `_V32qG_button`;
$69269db3183d321c$export$34e0f9847d4c02dd = `_V32qG_container`;
$69269db3183d321c$export$38e42c68cf43b5d4 = `_V32qG_header`;
$69269db3183d321c$export$1ca1ec8b29a4ce27 = `_V32qG_icon`;
$69269db3183d321c$export$bfd64c937657f93a = `_V32qG_rotating`;
$69269db3183d321c$export$4a6dd88bada4e7d2 = `_V32qG_shimmer`;
$69269db3183d321c$export$4a6dd88bada4e7d2;
$69269db3183d321c$export$1261a644c63cbc91 = `_V32qG_tabBar`;
$69269db3183d321c$export$8b7a896ae75accbf = `_V32qG_tags`;
$69269db3183d321c$export$fb184b623420d9be = `_V32qG_title`;
$69269db3183d321c$export$cc74dcc53cfce4eb = `_V32qG_wrapper`;


function $dd9fddb6bc5d38a8$var$Skeleton() {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $69269db3183d321c$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $69269db3183d321c$export$38e42c68cf43b5d4,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $69269db3183d321c$export$1ca1ec8b29a4ce27
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $69269db3183d321c$export$cc74dcc53cfce4eb,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $69269db3183d321c$export$fb184b623420d9be
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $69269db3183d321c$export$8b7a896ae75accbf
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jbKqE.default), {}),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $69269db3183d321c$export$2ba01fb71ed41cb6
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $69269db3183d321c$export$1261a644c63cbc91
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fe58a6ffca737898$export$2e2bcd8739ae039), {})
        ]
    });
}
var $dd9fddb6bc5d38a8$export$2e2bcd8739ae039 = $dd9fddb6bc5d38a8$var$Skeleton;


var $c4c606635610599b$export$3e2b3ca194606303;
var $c4c606635610599b$export$34e0f9847d4c02dd;
var $c4c606635610599b$export$bfd64c937657f93a;
var $c4c606635610599b$export$4a6dd88bada4e7d2;
$c4c606635610599b$export$3e2b3ca194606303 = `_1JPFKW_backLink`;
$c4c606635610599b$export$34e0f9847d4c02dd = `_1JPFKW_container`;
$c4c606635610599b$export$bfd64c937657f93a = `_1JPFKW_rotating`;
$c4c606635610599b$export$4a6dd88bada4e7d2 = `_1JPFKW_shimmer`;


function $aa35f43ec98b7478$var$DetailsPage({ backLink: backLink, backLinkTitle: backLinkTitle, isLoading: isLoading, error: error, onRetry: onRetry, children: children, className: className }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($c4c606635610599b$export$34e0f9847d4c02dd, className),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                to: backLink,
                icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a964dbd437bfde7b$export$2e2bcd8739ae039), {}),
                className: $c4c606635610599b$export$3e2b3ca194606303,
                children: typeof backLinkTitle === "string" ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                    forKey: backLinkTitle
                }) : backLinkTitle
            }),
            isLoading ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dd9fddb6bc5d38a8$export$2e2bcd8739ae039), {}) : error ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a20a092c49eaf711$export$2e2bcd8739ae039), {
                error: error,
                onRetry: onRetry
            }) : children
        ]
    });
}
var $aa35f43ec98b7478$export$2e2bcd8739ae039 = $aa35f43ec98b7478$var$DetailsPage;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $51f9e5400e6421f4$var$SvgMore = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M10 5.833A1.667 1.667 0 1 0 10 2.5a1.667 1.667 0 0 0 0 3.333Zm0 8.334a1.666 1.666 0 1 0 0 3.332 1.666 1.666 0 0 0 0-3.332Zm0-5.834a1.667 1.667 0 1 0 0 3.334 1.667 1.667 0 0 0 0-3.334Z",
            fill: "currentColor"
        })
    });
var $51f9e5400e6421f4$export$2e2bcd8739ae039 = $51f9e5400e6421f4$var$SvgMore;



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $jGWQ4 = parcelRequire("jGWQ4");


var $75SRw = parcelRequire("75SRw");
var $0370b1dc41c4d951$export$562c94e8096742fc;
var $0370b1dc41c4d951$export$a7db06668cad9adb;
var $0370b1dc41c4d951$export$22711916b0c9a0b1;
var $0370b1dc41c4d951$export$bfd64c937657f93a;
var $0370b1dc41c4d951$export$4a6dd88bada4e7d2;
$0370b1dc41c4d951$export$562c94e8096742fc = `sE9p8W_actionMenuButton`;
$0370b1dc41c4d951$export$a7db06668cad9adb = `sE9p8W_content`;
$0370b1dc41c4d951$export$22711916b0c9a0b1 = `sE9p8W_dropdownTitle`;
$0370b1dc41c4d951$export$bfd64c937657f93a = `sE9p8W_rotating`;
$0370b1dc41c4d951$export$4a6dd88bada4e7d2 = `sE9p8W_shimmer`;



/**
 * A button that can be used to open and close a dropdown menu.
 *
 * @param props If `buttonProps` is provided, the button will be rendered using the `ActionMenuButton`
 * component. Otherwise, `icon` will be required to render the button using the `IconButton`
 * component.
 * @see {@link ActionMenuButton} for the list of props that can be passed to the button.
 * @see {@link IconButton} for how the button will be rendered if `icon` is provided.
 */ function $f25eeaa133584984$var$ActionMenu(props) {
    const { children: children, title: title, dropdownHorizontalAlign: dropdownHorizontalAlign, dropdownClassName: dropdownClassName, isDropdownFullWidth: isDropdownFullWidth = false } = props;
    const [isOpen, setIsOpen] = (0, $jC8Vy.useState)(false);
    const anchorReference = (0, $jC8Vy.useRef)(null);
    const hasButtonProps = "buttonProps" in props;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        children: [
            hasButtonProps && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                ...props.buttonProps,
                ref: anchorReference,
                className: $0370b1dc41c4d951$export$562c94e8096742fc,
                onClick: ()=>{
                    setIsOpen(true);
                }
            }),
            !hasButtonProps && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                ref: anchorReference,
                size: props.iconSize,
                onClick: ()=>{
                    setIsOpen(true);
                },
                children: props.icon
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f90dea65844a9f7a$export$2e2bcd8739ae039), {
                title: title,
                titleClassName: $0370b1dc41c4d951$export$22711916b0c9a0b1,
                anchorRef: anchorReference,
                isOpen: isOpen,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($0370b1dc41c4d951$export$a7db06668cad9adb, dropdownClassName),
                horizontalAlign: dropdownHorizontalAlign,
                isFullWidth: isDropdownFullWidth,
                onClose: ()=>{
                    setIsOpen(false);
                },
                children: children
            })
        ]
    });
}
var $f25eeaa133584984$export$2e2bcd8739ae039 = $f25eeaa133584984$var$ActionMenu;



var $jGWQ4 = parcelRequire("jGWQ4");

var $gC7hG = parcelRequire("gC7hG");

var $cw2No = parcelRequire("cw2No");

var $66ixW = parcelRequire("66ixW");


var $a2e5fd98a465cf26$export$201c1586e0f2a1e0;
var $a2e5fd98a465cf26$export$38e42c68cf43b5d4;
var $a2e5fd98a465cf26$export$1ca1ec8b29a4ce27;
var $a2e5fd98a465cf26$export$dbb5e893e736e4ee;
var $a2e5fd98a465cf26$export$a8ff84c12d48cfa6;
var $a2e5fd98a465cf26$export$59894c102379d64a;
var $a2e5fd98a465cf26$export$bfd64c937657f93a;
var $a2e5fd98a465cf26$export$120ff0929b202a6d;
var $a2e5fd98a465cf26$export$4a6dd88bada4e7d2;
var $a2e5fd98a465cf26$export$6f093cfa640b7166;
var $a2e5fd98a465cf26$export$d999e528e771887b;
$a2e5fd98a465cf26$export$201c1586e0f2a1e0 = `ReARlW_copyId`;
$a2e5fd98a465cf26$export$38e42c68cf43b5d4 = `ReARlW_header`;
$a2e5fd98a465cf26$export$1ca1ec8b29a4ce27 = `ReARlW_icon`;
$a2e5fd98a465cf26$export$dbb5e893e736e4ee = `ReARlW_metadata`;
$a2e5fd98a465cf26$export$a8ff84c12d48cfa6 = `ReARlW_name`;
$a2e5fd98a465cf26$export$59894c102379d64a = `ReARlW_operations`;
$a2e5fd98a465cf26$export$bfd64c937657f93a = `ReARlW_rotating`;
$a2e5fd98a465cf26$export$120ff0929b202a6d = `ReARlW_row`;
$a2e5fd98a465cf26$export$4a6dd88bada4e7d2 = `ReARlW_shimmer`;
$a2e5fd98a465cf26$export$6f093cfa640b7166 = `ReARlW_text`;
$a2e5fd98a465cf26$export$d999e528e771887b = `ReARlW_verticalBar`;


function $eefae5244405013e$var$DetailsPageHeader({ icon: icon, title: title, subtitle: subtitle, primaryTag: primaryTag, statusTag: statusTag, identifier: identifier, additionalActionButton: additionalActionButton, additionalCustomElement: additionalCustomElement, actionMenuItems: actionMenuItems }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [showIcon, setShowIcon] = (0, $jC8Vy.useState)(true);
    const [isCompact, setIsCompact] = (0, $jC8Vy.useState)(false);
    const [showAdditionalCustomElement, setShowAdditionalCustomElement] = (0, $jC8Vy.useState)(true);
    const identifierRef = (0, $jC8Vy.useRef)(null);
    const operationRef = (0, $jC8Vy.useRef)(null);
    (0, $db44c573c0c8fb99$export$2e2bcd8739ae039)(()=>{
        if (!identifierRef.current || !operationRef.current) return;
        // Dynamically handle the visibility of the icon and action button styles. Sources:
        // https://www.figma.com/file/hqAWH3Di8gkiV5TXAt6juO/%F0%9F%8C%B9-%5BAC%5D-Layout-UI-Optimization?type=design&node-id=896-75673
        const { right: identifierRightEdge, width: identifierWidth } = identifierRef.current.getBoundingClientRect();
        const operationLeftEdge = operationRef.current.getBoundingClientRect().left;
        // When the operation buttons are in regular form, and the gap between the operation area and the identifier copy box is
        // only 24px. This means the window is shrinking and reaching the 1st breakpoint. Set operation buttons to compact form.
        if (!isCompact && operationLeftEdge - identifierRightEdge <= 24) setIsCompact(true);
        // When the operation buttons are compact, and the gap between the operation area and the identifier copy box is only 24px.
        // This means the window keeps shrinking and reaching the 2nd breakpoint. Hide the main icon on the very left.
        if (isCompact && showIcon && operationLeftEdge - identifierRightEdge <= 24) setShowIcon(false);
        // When the identifier copy box is 50px, and the gap between the operation area and the identifier copy box is only 24px.
        // This is when the page header is extremely narrow and barely has space to hold the identifier. Hide the additional custom element.
        if (identifierWidth <= 50 && operationLeftEdge - identifierRightEdge <= 24) setShowAdditionalCustomElement(false);
        // When the gap between the operation buttons and the identifier copy box is greater than 80px, show the additional custom element.
        if (!showAdditionalCustomElement && operationLeftEdge - identifierRightEdge > 80) setShowAdditionalCustomElement(true);
        // When the operation buttons are compact, icon is hidden, and the operation area is 120px away from the identifier copy box.
        // This means the window is enlarging and there is enough room to hold the icon. Show the icon.
        // 120px is a bit greater than the space required to hold the icon (60px + 24px padding), in order to avoid jittering.
        if (isCompact && !showIcon && operationLeftEdge - identifierRightEdge > 120) setShowIcon(true);
        // When the operation buttons are compact, icon is visible, and the operation area is 240px away from the identifier copy box.
        // This means the window width keeps increasing, and there is enough room to hold the regular size operation buttons.
        // Set compact operation buttons to regular form. Also, 240px is a bit greater than the actual space required to hold the regular
        // form operation buttons (around 180 ~ 240px in various cases), and this is also to avoid jittering.
        if (isCompact && showIcon && operationLeftEdge - identifierRightEdge > (additionalCustomElement ? 240 : 180)) setIsCompact(false);
    });
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
        className: $a2e5fd98a465cf26$export$38e42c68cf43b5d4,
        children: [
            showIcon && /*#__PURE__*/ (0, $jC8Vy.isValidElement)(icon) && /*#__PURE__*/ (0, $jC8Vy.cloneElement)(icon, {
                className: $a2e5fd98a465cf26$export$1ca1ec8b29a4ce27
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $a2e5fd98a465cf26$export$dbb5e893e736e4ee,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $a2e5fd98a465cf26$export$a8ff84c12d48cfa6,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $a2e5fd98a465cf26$export$120ff0929b202a6d,
                        children: [
                            primaryTag && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                                children: [
                                    typeof primaryTag === "string" ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
                                        children: primaryTag
                                    }) : primaryTag,
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $a2e5fd98a465cf26$export$d999e528e771887b
                                    })
                                ]
                            }),
                            subtitle && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $a2e5fd98a465cf26$export$6f093cfa640b7166,
                                        children: subtitle
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $a2e5fd98a465cf26$export$d999e528e771887b
                                    })
                                ]
                            }),
                            statusTag && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
                                        type: "state",
                                        status: statusTag.status,
                                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                            forKey: statusTag.text
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $a2e5fd98a465cf26$export$d999e528e771887b
                                    })
                                ]
                            }),
                            identifier && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $a2e5fd98a465cf26$export$6f093cfa640b7166,
                                        children: identifier.name
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
                                        ref: identifierRef,
                                        className: $a2e5fd98a465cf26$export$201c1586e0f2a1e0,
                                        // It's OK to use `ch` here because the font is monospace. 40px is the copy icon + padding.
                                        style: {
                                            maxWidth: `calc(${identifier.value.length}ch + 40px)`
                                        },
                                        valueStyle: {
                                            width: 0
                                        },
                                        size: "small",
                                        value: identifier.value
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                ref: operationRef,
                className: $a2e5fd98a465cf26$export$59894c102379d64a,
                children: [
                    showAdditionalCustomElement && /*#__PURE__*/ (0, $jC8Vy.isValidElement)(additionalCustomElement) && /*#__PURE__*/ (0, $jC8Vy.cloneElement)(additionalCustomElement, {
                        isCompact: isCompact
                    }),
                    additionalActionButton && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        icon: (0, $7oDSS.conditional)(isCompact && additionalActionButton.icon),
                        title: (0, $7oDSS.conditional)(!isCompact && additionalActionButton.title),
                        size: "large",
                        onClick: additionalActionButton.onClick
                    }),
                    actionMenuItems && actionMenuItems.length > 0 && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f25eeaa133584984$export$2e2bcd8739ae039), {
                        buttonProps: {
                            icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $51f9e5400e6421f4$export$2e2bcd8739ae039), {}),
                            size: "large"
                        },
                        title: t("general.more_options"),
                        children: actionMenuItems.map(({ title: title, icon: icon, type: type, onClick: onClick })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $6c006ec422465f6f$export$2e2bcd8739ae039), {
                                icon: icon,
                                type: type,
                                onClick: onClick,
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                    forKey: title
                                })
                            }, title))
                    })
                ]
            })
        ]
    });
}
var $eefae5244405013e$export$2e2bcd8739ae039 = $eefae5244405013e$var$DetailsPageHeader;



var $C7mD2 = parcelRequire("C7mD2");

var $kUZ14 = parcelRequire("kUZ14");

var $HHYyb = parcelRequire("HHYyb");

var $18SWy = parcelRequire("18SWy");

var $75SRw = parcelRequire("75SRw");

var $jbKqE = parcelRequire("jbKqE");
var $fd35cb19775af501$export$a7db06668cad9adb;
var $fd35cb19775af501$export$cc74dcc53cfce4eb;
var $fd35cb19775af501$export$38e42c68cf43b5d4;
var $fd35cb19775af501$export$32180ef41b15b513;
var $fd35cb19775af501$export$29dd17c7f3c81c36;
var $fd35cb19775af501$export$bfd64c937657f93a;
var $fd35cb19775af501$export$4a6dd88bada4e7d2;
$fd35cb19775af501$export$a7db06668cad9adb = "content_a964f6";
$fd35cb19775af501$export$cc74dcc53cfce4eb = "wrapper_a964f6";
$fd35cb19775af501$export$38e42c68cf43b5d4 = "header_a964f6";
$fd35cb19775af501$export$32180ef41b15b513 = "body_a964f6";
$fd35cb19775af501$export$29dd17c7f3c81c36 = "overlay_a964f6";
$fd35cb19775af501$export$bfd64c937657f93a = "rotating_a964f6";
$fd35cb19775af501$export$4a6dd88bada4e7d2 = "shimmer_a964f6";


function $353ae25d75ceb68c$var$Drawer({ title: title, subtitle: subtitle, isOpen: isOpen, children: children, onClose: onClose }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        shouldCloseOnOverlayClick: true,
        // Styling purpose
        // eslint-disable-next-line jsx-a11y/aria-role
        role: "drawer",
        isOpen: isOpen,
        className: $fd35cb19775af501$export$a7db06668cad9adb,
        overlayClassName: $fd35cb19775af501$export$29dd17c7f3c81c36,
        closeTimeoutMS: 300,
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
            className: $fd35cb19775af501$export$cc74dcc53cfce4eb,
            children: [
                title && /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: $fd35cb19775af501$export$38e42c68cf43b5d4,
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $18SWy.default), {
                            size: "small",
                            title: title,
                            subtitle: subtitle
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jbKqE.default), {}),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                            size: "large",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $HHYyb.default), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $fd35cb19775af501$export$32180ef41b15b513,
                    children: children
                })
            ]
        })
    });
}
var $353ae25d75ceb68c$export$2e2bcd8739ae039 = $353ae25d75ceb68c$var$Drawer;



var $5TsIB = parcelRequire("5TsIB");

var $bt3dS = parcelRequire("bt3dS");


var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");
var $a8aa1b2713e5255f$export$80e4b313e5e6b30d;
var $a8aa1b2713e5255f$export$bfd64c937657f93a;
var $a8aa1b2713e5255f$export$4a6dd88bada4e7d2;
$a8aa1b2713e5255f$export$80e4b313e5e6b30d = `AFg1_W_nav`;
$a8aa1b2713e5255f$export$bfd64c937657f93a = `AFg1_W_rotating`;
$a8aa1b2713e5255f$export$4a6dd88bada4e7d2 = `AFg1_W_shimmer`;



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $6bq3s = parcelRequire("6bq3s");

var $4ZcUR = parcelRequire("4ZcUR");

var $bnkR4 = parcelRequire("bnkR4");
var $7fdb4c7407dc21ac$export$30f3b02011db23c0;
var $7fdb4c7407dc21ac$export$7061c75fc5af8b7e;
var $7fdb4c7407dc21ac$export$9c30223ca0a664fb;
var $7fdb4c7407dc21ac$export$bfd64c937657f93a;
var $7fdb4c7407dc21ac$export$d90250155de6d7e7;
var $7fdb4c7407dc21ac$export$4a6dd88bada4e7d2;
$7fdb4c7407dc21ac$export$30f3b02011db23c0 = `Vu2b8a_errors`;
$7fdb4c7407dc21ac$export$7061c75fc5af8b7e = `Vu2b8a_item`;
$7fdb4c7407dc21ac$export$9c30223ca0a664fb = `Vu2b8a_link`;
$7fdb4c7407dc21ac$export$bfd64c937657f93a = `Vu2b8a_rotating`;
$7fdb4c7407dc21ac$export$d90250155de6d7e7 = `Vu2b8a_selected`;
$7fdb4c7407dc21ac$export$4a6dd88bada4e7d2 = `Vu2b8a_shimmer`;


function $8b5950685d0fe3f8$var$TabNavItem({ children: children, href: href, isActive: isActive, errorCount: errorCount = 0, onClick: onClick }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { match: match, getTo: getTo } = (0, $4ZcUR.default)();
    // `isActive` is used to override the default behavior of `match` when the
    // tab is not a link or the link is a relative path.
    const selected = isActive ?? (href ? match(href) : false);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $7fdb4c7407dc21ac$export$7061c75fc5af8b7e,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($7fdb4c7407dc21ac$export$9c30223ca0a664fb, selected && $7fdb4c7407dc21ac$export$d90250155de6d7e7),
                children: href ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6bq3s.Link), {
                    to: getTo(href),
                    children: children
                }) : // eslint-disable-next-line jsx-a11y/anchor-is-valid
                /*#__PURE__*/ (0, $C7mD2.jsx)("a", {
                    role: "tab",
                    tabIndex: 0,
                    onKeyDown: (0, $bnkR4.onKeyDownHandler)(onClick),
                    onClick: onClick,
                    children: children
                })
            }),
            errorCount > 0 && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $7fdb4c7407dc21ac$export$30f3b02011db23c0,
                children: t("general.tab_errors", {
                    count: errorCount
                })
            })
        ]
    });
}
var $8b5950685d0fe3f8$export$2e2bcd8739ae039 = $8b5950685d0fe3f8$var$TabNavItem;


function $26090e0c44b20d28$var$TabNav({ className: className, children: children }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)("nav", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($a8aa1b2713e5255f$export$80e4b313e5e6b30d, className),
        children: children
    });
}
var $26090e0c44b20d28$export$2e2bcd8739ae039 = $26090e0c44b20d28$var$TabNav;



var $7VnwS = parcelRequire("7VnwS");


var $4ZcUR = parcelRequire("4ZcUR");

var $jheqv = parcelRequire("jheqv");

var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");


var $HHYyb = parcelRequire("HHYyb");



var $75SRw = parcelRequire("75SRw");

var $jbKqE = parcelRequire("jbKqE");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");

var $fiyfZ = parcelRequire("fiyfZ");

var $2ZX8W = parcelRequire("2ZX8W");

var $fG7L1 = parcelRequire("fG7L1");

var $lWGA3 = parcelRequire("lWGA3");
function $8c1e8933c6ac3159$var$ApiGuide({ className: className, guideId: guideId, apiResource: apiResource, isCompact: isCompact, onClose: onClose }) {
    const { tenantEndpoint: tenantEndpoint } = (0, $jC8Vy.useContext)((0, $fG7L1.AppDataContext));
    const { applyDomain: applyCustomDomain } = (0, $lWGA3.default)();
    const guide = (0, $fiyfZ.default).find(({ id: id })=>id === guideId);
    const memorizedContext = (0, $jC8Vy.useMemo)(()=>(0, $7oDSS.conditional)(!!guide && !!apiResource && {
            metadata: guide.metadata,
            Logo: guide.Logo,
            isCompact: Boolean(isCompact),
            endpoint: applyCustomDomain(tenantEndpoint?.href ?? ""),
            audience: apiResource.indicator
        }), [
        apiResource,
        applyCustomDomain,
        guide,
        isCompact,
        tenantEndpoint?.href
    ]);
    return memorizedContext ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2ZX8W.GuideContext).Provider, {
        value: memorizedContext,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2ZX8W.default), {
            className: className,
            guideId: guideId,
            isLoading: !guide,
            onClose: onClose
        })
    }) : null;
}
var $8c1e8933c6ac3159$export$2e2bcd8739ae039 = $8c1e8933c6ac3159$var$ApiGuide;


var $ea210d7dcd4f89a5$export$a22f64ad99009e4f;
var $ea210d7dcd4f89a5$export$e2ebc74040679039;
var $ea210d7dcd4f89a5$export$675bc0f5721dbbd7;
var $ea210d7dcd4f89a5$export$38e42c68cf43b5d4;
var $ea210d7dcd4f89a5$export$bfd64c937657f93a;
var $ea210d7dcd4f89a5$export$3e523c77c1f23f8c;
var $ea210d7dcd4f89a5$export$4a6dd88bada4e7d2;
$ea210d7dcd4f89a5$export$a22f64ad99009e4f = `UaW6SG_cardGroup`;
$ea210d7dcd4f89a5$export$e2ebc74040679039 = `UaW6SG_drawerContainer`;
$ea210d7dcd4f89a5$export$675bc0f5721dbbd7 = `UaW6SG_guide`;
$ea210d7dcd4f89a5$export$38e42c68cf43b5d4 = `UaW6SG_header`;
$ea210d7dcd4f89a5$export$bfd64c937657f93a = `UaW6SG_rotating`;
$ea210d7dcd4f89a5$export$3e523c77c1f23f8c = `UaW6SG_separator`;
$ea210d7dcd4f89a5$export$4a6dd88bada4e7d2 = `UaW6SG_shimmer`;


function $29e4b79621fc17a8$var$GuideDrawer({ apiResource: apiResource, onClose: onClose }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.guide"
    });
    const guides = (0, $c14feef50a46e3d8$export$6bb65ec2faabc0af)();
    const [selectedGuide, setSelectedGuide] = (0, $jC8Vy.useState)();
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $ea210d7dcd4f89a5$export$e2ebc74040679039,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $ea210d7dcd4f89a5$export$38e42c68cf43b5d4,
                children: [
                    selectedGuide && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                                size: "large",
                                onClick: ()=>{
                                    setSelectedGuide(undefined);
                                },
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $582c9405f1750413$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $ea210d7dcd4f89a5$export$3e523c77c1f23f8c
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                                children: t("checkout_tutorial", {
                                    name: selectedGuide.name
                                })
                            })
                        ]
                    }),
                    !selectedGuide && t("api.select_a_tutorial"),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jbKqE.default), {}),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                        size: "large",
                        onClick: onClose,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $HHYyb.default), {})
                    })
                ]
            }),
            !selectedGuide && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $742494c24a2c2466$export$2e2bcd8739ae039), {
                className: $ea210d7dcd4f89a5$export$a22f64ad99009e4f,
                guides: guides,
                onClickGuide: (guide)=>{
                    setSelectedGuide(guide);
                }
            }),
            selectedGuide && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8c1e8933c6ac3159$export$2e2bcd8739ae039), {
                isCompact: true,
                className: $ea210d7dcd4f89a5$export$675bc0f5721dbbd7,
                guideId: selectedGuide.id,
                apiResource: apiResource,
                onClose: ()=>{
                    setSelectedGuide(undefined);
                }
            })
        ]
    });
}
var $29e4b79621fc17a8$export$2e2bcd8739ae039 = $29e4b79621fc17a8$var$GuideDrawer;



var $C7mD2 = parcelRequire("C7mD2");

var $kUZ14 = parcelRequire("kUZ14");

var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

parcelRequire("8Mb3E");
var $cfL6o = parcelRequire("cfL6o");

var $8TpMk = parcelRequire("8TpMk");

var $jGWQ4 = parcelRequire("jGWQ4");

var $C7mD2 = parcelRequire("C7mD2");

var $HHYyb = parcelRequire("HHYyb");

var $18SWy = parcelRequire("18SWy");

var $75SRw = parcelRequire("75SRw");

var $jbKqE = parcelRequire("jbKqE");
var $326ca72bad5a7879$export$64a53ecd158b85c4;
var $326ca72bad5a7879$export$38e42c68cf43b5d4;
var $326ca72bad5a7879$export$bfd64c937657f93a;
var $326ca72bad5a7879$export$3e523c77c1f23f8c;
var $326ca72bad5a7879$export$4a6dd88bada4e7d2;
$326ca72bad5a7879$export$64a53ecd158b85c4 = `UAORjW_closeIcon`;
$326ca72bad5a7879$export$38e42c68cf43b5d4 = `UAORjW_header`;
$326ca72bad5a7879$export$bfd64c937657f93a = `UAORjW_rotating`;
$326ca72bad5a7879$export$3e523c77c1f23f8c = `UAORjW_separator`;
$326ca72bad5a7879$export$4a6dd88bada4e7d2 = `UAORjW_shimmer`;


function $30d966bbac99cf1b$var$ModalHeader({ title: title, subtitle: subtitle, actionButton: actionButton, onClose: onClose }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $326ca72bad5a7879$export$38e42c68cf43b5d4,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                size: "large",
                onClick: onClose,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $HHYyb.default), {
                    className: $326ca72bad5a7879$export$64a53ecd158b85c4
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $326ca72bad5a7879$export$3e523c77c1f23f8c
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $18SWy.default), {
                size: "small",
                title: title,
                subtitle: subtitle
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jbKqE.default), {}),
            actionButton
        ]
    });
}
var $30d966bbac99cf1b$export$2e2bcd8739ae039 = $30d966bbac99cf1b$var$ModalHeader;



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $kUZ14 = parcelRequire("kUZ14");

var $jGWQ4 = parcelRequire("jGWQ4");

var $66ixW = parcelRequire("66ixW");

var $aqmjm = parcelRequire("aqmjm");

var $5vVWy = parcelRequire("5vVWy");

var $fmHmG = parcelRequire("fmHmG");


var $dW2kG = parcelRequire("dW2kG");
function $3a2d6d1a8a0a764f$export$2e2bcd8739ae039({ title: title, fieldLabel: fieldLabel, fieldPlaceholder: fieldPlaceholder, successMessage: successMessage, isOpen: isOpen, onClose: onClose }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [inputValue, setInputValue] = (0, $jC8Vy.useState)("");
    const [isLoading, setIsLoading] = (0, $jC8Vy.useState)(false);
    const { customData: customData, updateCustomData: updateCustomData } = (0, $8dc2d4d6918e57ba$export$2e2bcd8739ae039)();
    const guideRequests = customData?.guideRequests;
    const submit = async ()=>{
        setIsLoading(true);
        try {
            await updateCustomData({
                guideRequests: Array.isArray(guideRequests) ? guideRequests.concat(inputValue) : [
                    inputValue
                ]
            });
        } catch  {
            setIsLoading(false);
            return;
        }
        setIsLoading(false);
        setInputValue("");
        onClose();
        (0, $FuhPC.toast).success(String(t(successMessage)));
    };
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        shouldCloseOnEsc: true,
        isOpen: isOpen,
        className: $dW2kG.content,
        overlayClassName: $dW2kG.overlay,
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5vVWy.default), {
            title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                forKey: title
            }),
            footer: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                size: "large",
                type: "primary",
                title: "general.submit",
                isLoading: isLoading,
                disabled: !inputValue,
                onClick: submit
            }),
            onClose: onClose,
            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                    forKey: fieldLabel
                }),
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                    /** The i18n value is already string here. */ placeholder: String(t(fieldPlaceholder)),
                    value: inputValue,
                    onChange: ({ currentTarget: { value: value } })=>{
                        setInputValue(value);
                    }
                })
            })
        })
    });
}


var $b431a63bf35dce46$export$bded1fa0dae15b2b;
var $b431a63bf35dce46$export$bfd64c937657f93a;
var $b431a63bf35dce46$export$4a6dd88bada4e7d2;
$b431a63bf35dce46$export$bded1fa0dae15b2b = `GSUL-G_requestSdkButton`;
$b431a63bf35dce46$export$bfd64c937657f93a = `GSUL-G_rotating`;
$b431a63bf35dce46$export$4a6dd88bada4e7d2 = `GSUL-G_shimmer`;


function $81c55e09caea137c$var$ModalHeader({ title: title, subtitle: subtitle, buttonText: buttonText, requestFormTitle: requestFormTitle = buttonText, requestFormFieldLabel: requestFormFieldLabel, requestFormFieldPlaceholder: requestFormFieldPlaceholder, requestSuccessMessage: requestSuccessMessage, onClose: onClose }) {
    const [isRequestGuideOpen, setIsRequestGuideOpen] = (0, $jC8Vy.useState)(false);
    const onRequestGuideClose = (0, $jC8Vy.useCallback)(()=>{
        setIsRequestGuideOpen(false);
    }, []);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $30d966bbac99cf1b$export$2e2bcd8739ae039), {
                title: title,
                subtitle: subtitle,
                actionButton: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                    className: $b431a63bf35dce46$export$bded1fa0dae15b2b,
                    type: "outline",
                    icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1ab8d29d73cc7096$export$2e2bcd8739ae039), {}),
                    title: buttonText,
                    onClick: ()=>{
                        if (0, $8TpMk.isCloud) setIsRequestGuideOpen(true);
                        else window.open((0, $cfL6o.githubIssuesLink), "_blank");
                    }
                }),
                onClose: onClose
            }),
            (0, $8TpMk.isCloud) && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3a2d6d1a8a0a764f$export$2e2bcd8739ae039), {
                title: requestFormTitle,
                successMessage: requestSuccessMessage,
                fieldLabel: requestFormFieldLabel,
                fieldPlaceholder: requestFormFieldPlaceholder,
                isOpen: isRequestGuideOpen,
                onClose: onRequestGuideClose
            })
        ]
    });
}
var $81c55e09caea137c$export$2e2bcd8739ae039 = $81c55e09caea137c$var$ModalHeader;



var $dW2kG = parcelRequire("dW2kG");

var $13f9fbf2a35ec283$export$675bc0f5721dbbd7;
var $13f9fbf2a35ec283$export$56c24f306bd986cf;
var $13f9fbf2a35ec283$export$bfd64c937657f93a;
var $13f9fbf2a35ec283$export$4a6dd88bada4e7d2;
$13f9fbf2a35ec283$export$675bc0f5721dbbd7 = `K2_WUa_guide`;
$13f9fbf2a35ec283$export$56c24f306bd986cf = `K2_WUa_modalContainer`;
$13f9fbf2a35ec283$export$bfd64c937657f93a = `K2_WUa_rotating`;
$13f9fbf2a35ec283$export$4a6dd88bada4e7d2 = `K2_WUa_shimmer`;


function $d0f47021c127b071$var$GuideModal({ guideId: guideId, apiResource: apiResource, onClose: onClose }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        shouldCloseOnEsc: true,
        isOpen: true,
        className: $dW2kG.fullScreen,
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
            className: $13f9fbf2a35ec283$export$56c24f306bd986cf,
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $81c55e09caea137c$export$2e2bcd8739ae039), {
                    title: "guide.api.modal_title",
                    subtitle: "guide.api.modal_subtitle",
                    buttonText: "guide.cannot_find_guide",
                    requestFormFieldLabel: "guide.describe_guide_looking_for",
                    requestFormFieldPlaceholder: "guide.api.describe_guide_looking_for_placeholder",
                    requestSuccessMessage: "guide.request_guide_successfully",
                    onClose: onClose
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8c1e8933c6ac3159$export$2e2bcd8739ae039), {
                    className: $13f9fbf2a35ec283$export$675bc0f5721dbbd7,
                    guideId: guideId,
                    apiResource: apiResource,
                    onClose: onClose
                })
            ]
        })
    });
}
var $d0f47021c127b071$export$2e2bcd8739ae039 = $d0f47021c127b071$var$GuideModal;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $1QOtg = parcelRequire("1QOtg");

var $9Q3SI = parcelRequire("9Q3SI");


function $d2e504905769e522$var$ManagementApiNotice() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $b595fc2f0eccd19a$export$2e2bcd8739ae039)();
    const { data: data, isLoading: isLoading, update: update } = (0, $c83ac2f0f8302d6c$export$2e2bcd8739ae039)();
    const { managementApiAcknowledged: managementApiAcknowledged } = data;
    if (isLoading || managementApiAcknowledged) return null;
    const learnMoreLink = getDocumentationUrl("/docs/recipes/interact-with-management-api");
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1QOtg.default), {
        action: "general.got_it",
        onClick: ()=>{
            update({
                managementApiAcknowledged: true
            });
        },
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
            components: {
                a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                    href: learnMoreLink,
                    targetBlank: "noopener"
                })
            },
            children: t("api_resource_details.management_api_notice")
        })
    });
}
var $d2e504905769e522$export$2e2bcd8739ae039 = $d2e504905769e522$var$ManagementApiNotice;


var $e9141c7fcb9b1ab3$export$64fda0c1cfacc296;
var $e9141c7fcb9b1ab3$export$6d59db4903f20f7d;
var $e9141c7fcb9b1ab3$export$e4043f67d36cbb26;
var $e9141c7fcb9b1ab3$export$cc11a623cb30934;
var $e9141c7fcb9b1ab3$export$bfd64c937657f93a;
var $e9141c7fcb9b1ab3$export$4a6dd88bada4e7d2;
$e9141c7fcb9b1ab3$export$64fda0c1cfacc296 = `nfnr9a_deleteConfirm`;
$e9141c7fcb9b1ab3$export$6d59db4903f20f7d = `nfnr9a_description`;
$e9141c7fcb9b1ab3$export$e4043f67d36cbb26 = `nfnr9a_highlight`;
$e9141c7fcb9b1ab3$export$cc11a623cb30934 = `nfnr9a_permissionPage`;
$e9141c7fcb9b1ab3$export$bfd64c937657f93a = `nfnr9a_rotating`;
$e9141c7fcb9b1ab3$export$4a6dd88bada4e7d2 = `nfnr9a_shimmer`;


const $2cd82a99935118fa$var$icons = {
    [(0, $5HVJe.Theme).Light]: {
        ApiIcon: (0, $c9b59df86be12d23$export$2e2bcd8739ae039),
        ManagementApiIcon: (0, $ff631a8563f36219$export$2e2bcd8739ae039)
    },
    [(0, $5HVJe.Theme).Dark]: {
        ApiIcon: (0, $3da24e4cf07ae5e9$export$2e2bcd8739ae039),
        ManagementApiIcon: (0, $9260430af4663ded$export$2e2bcd8739ae039)
    }
};
function $2cd82a99935118fa$var$ApiResourceDetails() {
    const { pathname: pathname } = (0, $2Phw0.useLocation)();
    const { id: id, guideId: guideId } = (0, $2Phw0.useParams)();
    const { navigate: navigate, match: match } = (0, $4ZcUR.default)();
    const { getDocumentationUrl: getDocumentationUrl } = (0, $b595fc2f0eccd19a$export$2e2bcd8739ae039)();
    const isGuideView = !!id && !!guideId && match(`/api-resources/${id}/guide/${guideId}`);
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: data, error: error, mutate: mutate } = (0, $voszV.default)(id && `api/resources/${id}`);
    const isLoading = !data && !error;
    const theme = (0, $jheqv.default)();
    const { ApiIcon: ApiIcon, ManagementApiIcon: ManagementApiIcon } = $2cd82a99935118fa$var$icons[theme];
    const isOnPermissionPage = pathname.endsWith((0, $bt3dS.ApiResourceDetailsTabs).Permissions);
    const isLogtoManagementApiResource = (0, $9XFlr.isManagementApi)(data?.indicator ?? "");
    const Icon = isLogtoManagementApiResource ? ManagementApiIcon : ApiIcon;
    const [isGuideDrawerOpen, setIsGuideDrawerOpen] = (0, $jC8Vy.useState)(false);
    const [isDeleteFormOpen, setIsDeleteFormOpen] = (0, $jC8Vy.useState)(false);
    (0, $jC8Vy.useEffect)(()=>{
        setIsDeleteFormOpen(false);
    }, [
        pathname
    ]);
    const [isDeleting, setIsDeleting] = (0, $jC8Vy.useState)(false);
    const api = (0, $7VnwS.default)();
    const onDelete = async ()=>{
        if (!data || isDeleting) return;
        setIsDeleting(true);
        try {
            await api.delete(`api/resources/${data.id}`);
            (0, $FuhPC.toast).success(t("api_resource_details.api_resource_deleted", {
                name: data.name
            }));
            navigate(`/api-resources`);
        } finally{
            setIsDeleting(false);
        }
    };
    const onCloseDrawer = ()=>{
        setIsGuideDrawerOpen(false);
    };
    if (isGuideView) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $d0f47021c127b071$export$2e2bcd8739ae039), {
        guideId: guideId,
        apiResource: data,
        onClose: ()=>{
            navigate(`/api-resources/${id}`);
        }
    });
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aa35f43ec98b7478$export$2e2bcd8739ae039), {
        backLink: "/api-resources",
        backLinkTitle: "api_resource_details.back_to_api_resources",
        isLoading: isLoading,
        error: error,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))(isOnPermissionPage && $e9141c7fcb9b1ab3$export$cc11a623cb30934),
        onRetry: mutate,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5TsIB.default), {
                titleKey: "api_resource_details.page_title"
            }),
            isLogtoManagementApiResource && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $d2e504905769e522$export$2e2bcd8739ae039), {}),
            data && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $eefae5244405013e$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)(Icon, {}),
                        title: data.name,
                        primaryTag: data.isDefault && t("api_resources.default_api"),
                        identifier: {
                            name: "API Identifier",
                            value: data.indicator
                        },
                        additionalActionButton: {
                            icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f71d98d4090dad5c$export$2e2bcd8739ae039), {}),
                            title: "application_details.check_guide",
                            onClick: ()=>{
                                if (isLogtoManagementApiResource) window.open(getDocumentationUrl("/docs/recipes/interact-with-management-api/"), "_blank");
                                else setIsGuideDrawerOpen(true);
                            }
                        },
                        actionMenuItems: (0, $7oDSS.conditionalArray)(// Should not show delete button for management api resource.
                        !isLogtoManagementApiResource && {
                            icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3aa588de5c8665f2$export$2e2bcd8739ae039), {}),
                            title: "general.delete",
                            type: "danger",
                            onClick: ()=>{
                                setIsDeleteFormOpen(true);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $353ae25d75ceb68c$export$2e2bcd8739ae039), {
                        isOpen: isGuideDrawerOpen,
                        onClose: onCloseDrawer,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $29e4b79621fc17a8$export$2e2bcd8739ae039), {
                            apiResource: data,
                            onClose: onCloseDrawer
                        })
                    }),
                    !isLogtoManagementApiResource && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7065f4e52ae4e862$export$2e2bcd8739ae039), {
                        isOpen: isDeleteFormOpen,
                        isLoading: isDeleting,
                        expectedInput: data.name,
                        className: $e9141c7fcb9b1ab3$export$64fda0c1cfacc296,
                        inputPlaceholder: t("api_resource_details.enter_your_api_resource_name"),
                        onCancel: ()=>{
                            setIsDeleteFormOpen(false);
                        },
                        onConfirm: onDelete,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $e9141c7fcb9b1ab3$export$6d59db4903f20f7d,
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                                components: {
                                    span: /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                                        className: $e9141c7fcb9b1ab3$export$e4043f67d36cbb26
                                    })
                                },
                                children: t("api_resource_details.delete_description", {
                                    name: data.name
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $26090e0c44b20d28$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                                href: `/api-resources/${data.id}/${(0, $bt3dS.ApiResourceDetailsTabs).Permissions}`,
                                children: t("api_resource_details.permissions_tab")
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                                href: `/api-resources/${data.id}/${(0, $bt3dS.ApiResourceDetailsTabs).General}`,
                                children: t("api_resource_details.general_tab")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Outlet), {
                        context: {
                            resource: data,
                            isDeleting: isDeleting,
                            isLogtoManagementApiResource: isLogtoManagementApiResource,
                            onResourceUpdated: mutate
                        }
                    })
                ]
            })
        ]
    });
}
var $2cd82a99935118fa$export$2e2bcd8739ae039 = $2cd82a99935118fa$var$ApiResourceDetails;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $2Phw0 = parcelRequire("2Phw0");

var $voszV = parcelRequire("voszV");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $fbc1a38a5dc459d3$var$SvgPermissionsEmptyDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#191C1D",
                d: "M0 0h256v256H0z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#C4C7C7",
                fillOpacity: 0.02,
                d: "M0 0h256v256H0z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#CABEFF",
                fillOpacity: 0.08,
                d: "M0 0h256v256H0z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M250 219H15l19.087-29.902a18.05 18.05 0 0 1 15.214-8.337h.65c3.114 0 6.16.915 8.757 2.632 7.128 4.71 16.704 2.939 21.675-4.008l22.791-31.844a20.433 20.433 0 0 1 30.081-3.477l6.509 5.702a23.895 23.895 0 0 0 28.7 2.106 23.894 23.894 0 0 1 12.954-3.815h.946a27.106 27.106 0 0 1 25.812 18.83l5.335 16.636a13.406 13.406 0 0 0 12.766 9.313c4.633 0 8.938 2.392 11.385 6.327L250 219Z",
                fill: "#59566E"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M37.181 210.929c1.207-1.064 2.384-2.449 2.572-4.111.09-.788.016-1.741-.639-2.289-.614-.518-1.474-.554-2.23-.388-1.676.369-3.035 1.582-4.774 1.734a5.25 5.25 0 0 1-1.613-.11c-2.697-3.57-4.281-7.764-4.933-12.255-.007-.04-.007-.08-.013-.118.443.142.889.27 1.34.368 1.168.255 2.37.338 3.564.28 1.19-.057 2.454-.252 3.571-.678.476-.18.937-.498 1.133-.986.233-.588-.057-1.14-.445-1.578-1.414-1.59-3.527-2.12-5.53-2.54-1.385-.293-2.925-.606-4.068-1.463-.012-3.339.212-6.687.38-10.019.014-.272.024-.545.038-.82.46.268.91.549 1.349.846l1.576 1.225a.86.86 0 0 0 .233.128c.098.082.199.155.297.237.32.27.795.213 1.084-.063.02-.018.036-.041.05-.061.437-.117.77-.541.548-1.065-.605-1.43-1.65-2.557-2.715-3.66-.851-.88-1.737-1.779-2.313-2.865-.059-4.473-.603-8.93-2.407-13.07-.312-.713.45-1.278 1.095-1.068 5.209 1.716 10.23 3.906 15.08 6.441.798 1.109.916 2.671.996 3.984a22.07 22.07 0 0 1 0 2.695c-.05.819-.078 1.642.497 2.303.48.552 1.178.802 1.867.977.38.095.76.154 1.12-.041.388-.214.503-.628.619-1.023.418-1.417 1.093-3.626.983-5.491a147.93 147.93 0 0 1 9.324 6.067c.503 2.108-.556 4.519-1.337 6.471-.913 2.277-1.883 5.15-.673 7.507.54 1.052 1.533 1.865 2.748 1.937.563.035 1.379-.05 1.654-.625.243-.505.32-1.069.595-1.574 1.268-2.318 3.74-3.664 5.588-5.458.355-.347.633-.697.796-1.058 1.456 1.383 2.777 2.885 3.848 4.567 1.4 2.204 2.225 4.648 2.538 7.158a4.278 4.278 0 0 1-.396.433 5.473 5.473 0 0 1-.995.753c-.34.197-.699.362-1.01.6-.81.624-1.106 1.647-.535 2.542.534.838 1.62 1.117 2.56 1.139.1.001.185-.011.273-.025a20.875 20.875 0 0 1-.858 3.477c-.921 2.699-2.395 5.15-4.216 7.325-2.675 1.578-6.068 1.632-8.912-.035a.585.585 0 0 0-.264-.075 76.952 76.952 0 0 0-2.75-6.423c-1.913-3.989-4.077-7.831-6.316-11.616l-6.776-11.311c-2.272-3.76-4.64-7.494-7.482-10.85 2.737 3.444 4.974 7.233 7.124 11.058l6.415 11.51c2.114 3.844 4.145 7.733 5.909 11.724a74.632 74.632 0 0 1 2.857 7.462 8.545 8.545 0 0 1-3.35 5.158 8.127 8.127 0 0 1-1.154.686c-2.12.64-4.383.765-6.625.542-2.761-.811-5.33-2.19-7.65-3.909.266-.195.52-.399.758-.613Z",
                fill: "url(#paint0_linear_6532_88970)",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M52 132a8 8 0 0 1 8-8h128a8 8 0 0 1 8 8v85H52v-85Z",
                fill: "url(#paint1_linear_6532_88970)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M56 131a4 4 0 0 1 4-4h128a4 4 0 0 1 4 4v82H56v-82Z",
                fill: "url(#paint2_linear_6532_88970)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M27 213h193v2a4 4 0 0 1-4 4H32a5 5 0 0 1-5-5v-1Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M114 127h20v2a4 4 0 0 1-4 4h-12a4 4 0 0 1-4-4v-2Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 69,
                y: 143,
                width: 110,
                height: 56,
                rx: 5,
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M100.548 143h28.451v47a9 9 0 0 1-9 9h-33l13.549-56Z",
                fill: "url(#paint3_linear_6532_88970)",
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 207.098,
                y: 115,
                width: 8,
                height: 8,
                rx: 2,
                transform: "rotate(30.813 207.098 115)",
                fill: "#6E6083"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M108 86.632c-4.145 0-6.109-3.537-6.109-6.632 0 3.095-1.746 6.632-5.891 6.632 4.145 0 5.891 2.18 5.891 7.368 0-5.187 1.964-7.368 6.109-7.368ZM30 108.632c-4.145 0-6.11-3.537-6.11-6.632 0 3.095-1.745 6.632-5.89 6.632 4.145 0 5.89 2.181 5.89 7.368 0-5.187 1.965-7.368 6.11-7.368Z",
                fill: "#928F9A"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M218.956 53.104c0-.057.047-.104.104-.104h1.878c.057 0 .104.047.104.104v3.305l2.861-1.652a.105.105 0 0 1 .143.038l.939 1.626a.105.105 0 0 1-.038.142l-2.862 1.653 2.861 1.652c.05.029.067.092.039.142l-.939 1.626a.105.105 0 0 1-.143.038l-2.861-1.652v3.304a.104.104 0 0 1-.104.105h-1.878a.104.104 0 0 1-.104-.105v-3.304l-2.862 1.652a.105.105 0 0 1-.143-.038l-.938-1.626a.104.104 0 0 1 .038-.142l2.862-1.652-2.862-1.653a.104.104 0 0 1-.038-.142l.938-1.626a.105.105 0 0 1 .143-.038l2.862 1.652v-3.305Z",
                fill: "#5F5D67"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                opacity: 0.7,
                x: 100,
                y: 154,
                width: 68,
                height: 6,
                rx: 2,
                fill: "#F07EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 100,
                y: 166,
                width: 68,
                height: 6,
                rx: 2,
                fill: "#9C7ECC"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 100,
                y: 178,
                width: 68,
                height: 6,
                rx: 2,
                fill: "#9C7ECC"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m173.162 115.98.003.003 11.335 10.239V195a9.5 9.5 0 0 1-9.5 9.5h-51a9.5 9.5 0 0 1-9.5-9.5v-79a9.5 9.5 0 0 1 9.5-9.5h38.806l10.356 9.48Z",
                fill: "#E6DEFF",
                stroke: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M169.774 124H184v72a9 9 0 0 1-9 9h-18.5l13.274-81Z",
                fill: "url(#paint4_linear_6532_88970)",
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 124,
                y: 150,
                width: 49,
                height: 6,
                rx: 2,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                opacity: 0.7,
                x: 124,
                y: 139,
                width: 7,
                height: 6,
                rx: 2,
                fill: "#F07EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 138,
                y: 139,
                width: 18,
                height: 6,
                rx: 2,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 124,
                y: 172,
                width: 32,
                height: 6,
                rx: 2,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 159,
                y: 172,
                width: 14,
                height: 6,
                rx: 2,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 124,
                y: 161,
                width: 49,
                height: 6,
                rx: 2,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 124,
                y: 184,
                width: 32,
                height: 6,
                rx: 2,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M153 79a4 4 0 0 1 4-4h25v17h-25a4 4 0 0 1-4-4v-9Z",
                fill: "#FFDAD4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M245.5 88a4 4 0 0 1-4 4H182V75h59.5a4 4 0 0 1 4 4v9Z",
                fill: "#FFD5FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M221 92.5h20a5 5 0 0 0 5-5V82",
                stroke: "#B1869F"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                opacity: 0.7,
                d: "M101 95H34a4 4 0 0 0-4 4v7",
                stroke: "#58577B"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M163.5 116v-8.863l20.027 18.363H173a9.5 9.5 0 0 1-9.5-9.5Z",
                fill: "#DBD3FF",
                stroke: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M160.5 74.5H193",
                stroke: "#B1869F"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#2A2C32",
                d: "M131 101h14v6h-14z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 157,
                y: 82,
                width: 18,
                height: 3,
                rx: 1.5,
                fill: "#635452",
                fillOpacity: 0.5
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 192,
                y: 82,
                width: 49,
                height: 3,
                rx: 1.5,
                fill: "#635452",
                fillOpacity: 0.5
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M182 76v16",
                stroke: "#B18BA1",
                strokeDasharray: "4 4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 83.5,
                cy: 159.5,
                r: 7.5,
                fill: "#9C7ECC"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "mask0_6532_88970",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 76,
                y: 152,
                width: 15,
                height: 15,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                    cx: 83.5,
                    cy: 159.5,
                    r: 7.5,
                    fill: "#FF91DF"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("g", {
                mask: "url(#mask0_6532_88970)",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    d: "M83.434 154.5a.8.8 0 0 0-.782.63l-.092.425a.773.773 0 0 1-.475.535.769.769 0 0 1-.712-.044l-.363-.234a.8.8 0 0 0-.998.107l-.093.093a.8.8 0 0 0-.107.998l.234.363a.77.77 0 0 1 .044.712.774.774 0 0 1-.535.475l-.425.092a.8.8 0 0 0-.63.782v.132a.8.8 0 0 0 .63.782l.425.092c.246.053.439.242.535.475a.77.77 0 0 1-.044.712l-.234.363a.8.8 0 0 0 .107.998l.093.093a.8.8 0 0 0 .998.107l.364-.234a.769.769 0 0 1 .711-.044.773.773 0 0 1 .475.535l.092.425a.8.8 0 0 0 .782.63h.132a.8.8 0 0 0 .782-.63l.092-.425a.773.773 0 0 1 .475-.535.769.769 0 0 1 .712.044l.363.234a.8.8 0 0 0 .998-.107l.093-.093a.8.8 0 0 0 .107-.998l-.234-.363a.77.77 0 0 1-.044-.712.774.774 0 0 1 .535-.475l.425-.092a.8.8 0 0 0 .63-.782v-.132a.8.8 0 0 0-.63-.782l-.425-.092a.774.774 0 0 1-.535-.475.77.77 0 0 1 .044-.712l.234-.363a.8.8 0 0 0-.107-.998l-.093-.093a.8.8 0 0 0-.998-.107l-.364.234a.769.769 0 0 1-.711.044.773.773 0 0 1-.475-.535l-.092-.425a.8.8 0 0 0-.782-.63h-.132Zm.066 2.857a2.143 2.143 0 1 1 0 4.287 2.143 2.143 0 0 1 0-4.287Z",
                    fill: "#F5EEFF"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M34 146a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
                fill: "#5F5D67"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M130.8 130.015c4.003 0 7.25-3.237 7.25-7.233 0-3.995-3.247-7.232-7.25-7.232s-7.25 3.237-7.25 7.232c0 3.996 3.247 7.233 7.25 7.233Z",
                stroke: "url(#paint5_linear_6532_88970)",
                strokeWidth: 0.9
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                cx: 130.8,
                cy: 122.783,
                rx: 6.152,
                ry: 6.136,
                fill: "#86BF8F"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 1.756,
                height: 5.268,
                rx: 0.878,
                transform: "rotate(-44.926 211.263 -91.91)",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 7.024,
                height: 1.756,
                rx: 0.878,
                transform: "rotate(-44.926 215.506 -93.677)",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_6532_88970",
                        x1: 57.329,
                        y1: 213.747,
                        x2: 24.255,
                        y2: 153.83,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#B6ADD3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#5124DB",
                                stopOpacity: 0.16
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_6532_88970",
                        x1: 120.556,
                        y1: 126.099,
                        x2: 151.327,
                        y2: 228.121,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#735DF9"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#D781FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint2_linear_6532_88970",
                        x1: 192,
                        y1: 213.001,
                        x2: -17,
                        y2: 80.001,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#BC97FD"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#BC97FD",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint3_linear_6532_88970",
                        x1: 130.59,
                        y1: 168.664,
                        x2: 90.951,
                        y2: 193.746,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#ECB6FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#BE9BFF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint4_linear_6532_88970",
                        x1: 184.795,
                        y1: 161.121,
                        x2: 158.308,
                        y2: 166.914,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#E1CEE8"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFFBFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint5_linear_6532_88970",
                        x1: 125.619,
                        y1: 117.938,
                        x2: 137.57,
                        y2: 129.596,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#74B382"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#83DA85",
                                stopOpacity: 0
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $fbc1a38a5dc459d3$export$2e2bcd8739ae039 = $fbc1a38a5dc459d3$var$SvgPermissionsEmptyDark;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $e03e8b98a9e094ed$var$SvgPermissionsEmpty = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M250 220H15l19.087-29.902a18.05 18.05 0 0 1 15.214-8.337h.65c3.114 0 6.16.915 8.757 2.632 7.128 4.71 16.704 2.939 21.675-4.008l22.791-31.844a20.433 20.433 0 0 1 30.081-3.477l6.509 5.702a23.895 23.895 0 0 0 28.7 2.106 23.894 23.894 0 0 1 12.954-3.815h.946a27.106 27.106 0 0 1 25.812 18.83l5.335 16.636a13.406 13.406 0 0 0 12.766 9.313c4.633 0 8.938 2.392 11.385 6.327L250 220Z",
                fill: "#D2CCDD"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M37.181 210.929c1.207-1.064 2.384-2.449 2.572-4.111.09-.788.016-1.741-.639-2.289-.614-.518-1.474-.554-2.23-.388-1.676.369-3.035 1.582-4.774 1.734a5.25 5.25 0 0 1-1.613-.11c-2.697-3.57-4.281-7.764-4.933-12.255-.007-.04-.007-.08-.013-.118.443.142.889.27 1.34.368 1.168.255 2.37.338 3.564.28 1.19-.057 2.454-.252 3.571-.678.476-.18.937-.498 1.133-.986.233-.588-.057-1.14-.445-1.578-1.414-1.59-3.527-2.12-5.53-2.54-1.385-.293-2.925-.606-4.068-1.463-.012-3.339.212-6.687.38-10.019.014-.272.024-.545.038-.82.46.268.91.549 1.349.846l1.576 1.225a.86.86 0 0 0 .233.128c.098.082.199.155.297.237.32.27.795.213 1.084-.063.02-.018.036-.041.05-.061.437-.117.77-.541.548-1.065-.605-1.43-1.65-2.557-2.715-3.66-.851-.88-1.737-1.779-2.313-2.865-.059-4.473-.603-8.93-2.407-13.07-.312-.713.45-1.278 1.095-1.068 5.209 1.716 10.23 3.906 15.08 6.441.798 1.109.916 2.671.996 3.984a22.07 22.07 0 0 1 0 2.695c-.05.819-.078 1.642.497 2.303.48.552 1.178.802 1.867.977.38.095.76.154 1.12-.041.388-.214.503-.628.619-1.023.418-1.417 1.093-3.626.983-5.491a147.93 147.93 0 0 1 9.324 6.067c.503 2.108-.556 4.519-1.337 6.471-.913 2.277-1.883 5.15-.673 7.507.54 1.052 1.533 1.865 2.748 1.937.563.035 1.379-.05 1.654-.625.243-.505.32-1.069.595-1.574 1.268-2.318 3.74-3.664 5.588-5.458.355-.347.633-.697.796-1.058 1.456 1.382 2.777 2.885 3.848 4.567 1.4 2.204 2.225 4.648 2.538 7.158a4.278 4.278 0 0 1-.396.433 5.473 5.473 0 0 1-.995.753c-.34.197-.699.362-1.01.6-.81.624-1.106 1.647-.535 2.542.534.838 1.62 1.117 2.56 1.139.1.001.185-.011.273-.025a20.875 20.875 0 0 1-.858 3.477c-.921 2.699-2.395 5.15-4.216 7.325-2.675 1.578-6.068 1.632-8.912-.035a.585.585 0 0 0-.264-.075 76.952 76.952 0 0 0-2.75-6.423c-1.913-3.989-4.077-7.831-6.316-11.616l-6.776-11.311c-2.272-3.76-4.64-7.494-7.482-10.85 2.737 3.444 4.974 7.233 7.124 11.058l6.415 11.51c2.114 3.844 4.145 7.733 5.909 11.724a74.632 74.632 0 0 1 2.857 7.462 8.545 8.545 0 0 1-3.35 5.158 8.127 8.127 0 0 1-1.154.686c-2.12.64-4.383.765-6.625.542-2.761-.811-5.33-2.19-7.65-3.909.266-.195.52-.399.758-.613Z",
                fill: "url(#paint0_linear_6485_85356)",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M52 132a8 8 0 0 1 8-8h128a8 8 0 0 1 8 8v85H52v-85Z",
                fill: "url(#paint1_linear_6485_85356)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M56 131a4 4 0 0 1 4-4h128a4 4 0 0 1 4 4v82H56v-82Z",
                fill: "url(#paint2_linear_6485_85356)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M27 213h193v2a4 4 0 0 1-4 4H32a5 5 0 0 1-5-5v-1Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M114 127h20v2a4 4 0 0 1-4 4h-12a4 4 0 0 1-4-4v-2Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 69,
                y: 143,
                width: 110,
                height: 56,
                rx: 5,
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M100.548 143h28.451v47a9 9 0 0 1-9 9h-33l13.549-56Z",
                fill: "url(#paint3_linear_6485_85356)",
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 207.098,
                y: 115,
                width: 8,
                height: 8,
                rx: 2,
                transform: "rotate(30.813 207.098 115)",
                fill: "#FFD5FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M108 86.632c-4.145 0-6.109-3.537-6.109-6.632 0 3.095-1.746 6.632-5.891 6.632 4.145 0 5.891 2.18 5.891 7.368 0-5.187 1.964-7.368 6.109-7.368ZM30 108.632c-4.145 0-6.11-3.537-6.11-6.632 0 3.095-1.745 6.632-5.89 6.632 4.145 0 5.89 2.181 5.89 7.368 0-5.187 1.965-7.368 6.11-7.368Z",
                fill: "#FFF06A"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M218.956 53.104c0-.057.047-.104.104-.104h1.878c.057 0 .104.047.104.104v3.305l2.861-1.652a.105.105 0 0 1 .143.038l.939 1.626a.105.105 0 0 1-.038.142l-2.862 1.653 2.861 1.652c.05.029.067.092.039.142l-.939 1.626a.105.105 0 0 1-.143.038l-2.861-1.652v3.304a.104.104 0 0 1-.104.105h-1.878a.104.104 0 0 1-.104-.105v-3.304l-2.862 1.652a.105.105 0 0 1-.143-.038l-.938-1.626a.104.104 0 0 1 .038-.142l2.862-1.652-2.862-1.653a.104.104 0 0 1-.038-.142l.938-1.626a.105.105 0 0 1 .143-.038l2.862 1.652v-3.305Z",
                fill: "#FFFBFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 100,
                y: 154,
                width: 68,
                height: 6,
                rx: 2,
                fill: "#FF91DF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 100,
                y: 166,
                width: 68,
                height: 6,
                rx: 2,
                fill: "#C29DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 100,
                y: 178,
                width: 68,
                height: 6,
                rx: 2,
                fill: "#C29DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m173.162 115.98.003.003 11.335 10.239V195a9.5 9.5 0 0 1-9.5 9.5h-51a9.5 9.5 0 0 1-9.5-9.5v-79a9.5 9.5 0 0 1 9.5-9.5h38.806l10.356 9.48Z",
                fill: "#FFFBFF",
                stroke: "#D0BED6"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M169.774 124H184v72a9 9 0 0 1-9 9h-18.5l13.274-81Z",
                fill: "url(#paint4_linear_6485_85356)",
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 124,
                y: 149,
                width: 49,
                height: 6,
                rx: 2,
                fill: "#E1CEE8"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 124,
                y: 139,
                width: 7,
                height: 6,
                rx: 2,
                fill: "#FFC3F1"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 138,
                y: 139,
                width: 18,
                height: 6,
                rx: 2,
                fill: "#E1CEE8"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 124,
                y: 172,
                width: 32,
                height: 6,
                rx: 2,
                fill: "#E1CEE8"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 159,
                y: 172,
                width: 14,
                height: 6,
                rx: 2,
                fill: "#E1CEE8"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 124,
                y: 161,
                width: 49,
                height: 6,
                rx: 2,
                fill: "#E1CEE8"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 124,
                y: 184,
                width: 32,
                height: 6,
                rx: 2,
                fill: "#E1CEE8"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M130.8 130.015c4.003 0 7.25-3.237 7.25-7.233 0-3.995-3.247-7.232-7.25-7.232s-7.25 3.237-7.25 7.232c0 3.996 3.247 7.233 7.25 7.233Z",
                stroke: "url(#paint5_linear_6485_85356)",
                strokeWidth: 0.9
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                cx: 130.8,
                cy: 122.783,
                rx: 6.152,
                ry: 6.136,
                fill: "#83DA85"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 1.756,
                height: 5.268,
                rx: 0.878,
                transform: "rotate(-44.926 211.263 -91.91)",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 7.024,
                height: 1.756,
                rx: 0.878,
                transform: "rotate(-44.926 215.506 -93.677)",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M153 79a4 4 0 0 1 4-4h25v17h-25a4 4 0 0 1-4-4v-9Z",
                fill: "#FFDAD4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                opacity: 0.7,
                d: "M245.5 88a4 4 0 0 1-4 4H182V75h59.5a4 4 0 0 1 4 4v9Z",
                fill: "#FFA9EA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M221 92.5h20a5 5 0 0 0 5-5V82",
                stroke: "#C9AAC1"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                opacity: 0.7,
                d: "M101 95H34a4 4 0 0 0-4 4v7",
                stroke: "#C9AAC1"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M163.5 116v-8.863l20.027 18.363H173a9.5 9.5 0 0 1-9.5-9.5Z",
                fill: "#fff",
                stroke: "#D0BED6"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M160.5 74.5H193",
                stroke: "#C9AAC1"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#fff",
                d: "M131 101h14v6h-14z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 157,
                y: 82,
                width: 18,
                height: 3,
                rx: 1.5,
                fill: "#635452",
                fillOpacity: 0.5
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 192,
                y: 82,
                width: 49,
                height: 3,
                rx: 1.5,
                fill: "#635452",
                fillOpacity: 0.5
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M182 76v16",
                stroke: "#B18BA1",
                strokeDasharray: "4 4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 83.5,
                cy: 159.5,
                r: 7.5,
                fill: "#C39EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "mask0_6485_85356",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 76,
                y: 152,
                width: 15,
                height: 15,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                    cx: 83.5,
                    cy: 159.5,
                    r: 7.5,
                    fill: "#FF91DF"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("g", {
                mask: "url(#mask0_6485_85356)",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    d: "M83.434 154.5a.8.8 0 0 0-.782.63l-.092.425a.773.773 0 0 1-.475.535.769.769 0 0 1-.712-.044l-.363-.234a.8.8 0 0 0-.998.107l-.093.093a.8.8 0 0 0-.107.998l.234.363a.77.77 0 0 1 .044.712.774.774 0 0 1-.535.475l-.425.092a.8.8 0 0 0-.63.782v.132a.8.8 0 0 0 .63.782l.425.092c.246.053.439.242.535.475a.77.77 0 0 1-.044.712l-.234.363a.8.8 0 0 0 .107.998l.093.093a.8.8 0 0 0 .998.107l.364-.234a.769.769 0 0 1 .711-.044.773.773 0 0 1 .475.535l.092.425a.8.8 0 0 0 .782.63h.132a.8.8 0 0 0 .782-.63l.092-.425a.773.773 0 0 1 .475-.535.769.769 0 0 1 .712.044l.363.234a.8.8 0 0 0 .998-.107l.093-.093a.8.8 0 0 0 .107-.998l-.234-.363a.77.77 0 0 1-.044-.712.774.774 0 0 1 .535-.475l.425-.092a.8.8 0 0 0 .63-.782v-.132a.8.8 0 0 0-.63-.782l-.425-.092a.774.774 0 0 1-.535-.475.77.77 0 0 1 .044-.712l.234-.363a.8.8 0 0 0-.107-.998l-.093-.093a.8.8 0 0 0-.998-.107l-.364.234a.769.769 0 0 1-.711.044.773.773 0 0 1-.475-.535l-.092-.425a.8.8 0 0 0-.782-.63h-.132Zm.066 2.857a2.143 2.143 0 1 1 0 4.287 2.143 2.143 0 0 1 0-4.287Z",
                    fill: "#F5EEFF"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M34 146a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
                fill: "#FFDDB5"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_6485_85356",
                        x1: 57.329,
                        y1: 213.747,
                        x2: 24.255,
                        y2: 153.83,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#C7BDE6"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E4DBFF",
                                stopOpacity: 0.16
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_6485_85356",
                        x1: 120.556,
                        y1: 126.099,
                        x2: 151.327,
                        y2: 228.121,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint2_linear_6485_85356",
                        x1: 192,
                        y1: 213.001,
                        x2: -17,
                        y2: 80.001,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#BC97FD"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#BC97FD",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint3_linear_6485_85356",
                        x1: 130.59,
                        y1: 168.664,
                        x2: 90.951,
                        y2: 193.746,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#ECB6FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#BE9BFF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint4_linear_6485_85356",
                        x1: 184.795,
                        y1: 161.121,
                        x2: 158.308,
                        y2: 166.914,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#E1CEE8"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFFBFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint5_linear_6485_85356",
                        x1: 125.619,
                        y1: 117.938,
                        x2: 137.57,
                        y2: 129.596,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#83DA85"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#83DA85",
                                stopOpacity: 0
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $e03e8b98a9e094ed$export$2e2bcd8739ae039 = $e03e8b98a9e094ed$var$SvgPermissionsEmpty;



var $bt3dS = parcelRequire("bt3dS");

var $jGWQ4 = parcelRequire("jGWQ4");

var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");


var $jGWQ4 = parcelRequire("jGWQ4");

var $fmHmG = parcelRequire("fmHmG");
var $1a424a227751a2de$export$bfd64c937657f93a;
var $1a424a227751a2de$export$d76128d007d19019;
var $1a424a227751a2de$export$8687ffcdea58e000;
var $1a424a227751a2de$export$4a6dd88bada4e7d2;
$1a424a227751a2de$export$bfd64c937657f93a = `XhA89q_rotating`;
$1a424a227751a2de$export$d76128d007d19019 = `XhA89q_search`;
$1a424a227751a2de$export$8687ffcdea58e000 = `XhA89q_searchIcon`;
$1a424a227751a2de$export$4a6dd88bada4e7d2 = `XhA89q_shimmer`;


/**
 * The body-2 font declared in @logto/core-kit/scss/fonts. It is referenced here to calculate the
 * width of the placeholder text, which determines the minimum width of the search input field.
 */ const $46c375e0973aedf1$var$fontBody2 = "400 14px / 20px -apple-system, system-ui, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji";
function $46c375e0973aedf1$var$Search({ defaultValue: defaultValue = "", isClearable: isClearable = false, placeholder: placeholder = "", inputClassName: inputClassName, onSearch: onSearch, onClearSearch: onClearSearch }) {
    const [inputValue, setInputValue] = (0, $jC8Vy.useState)(defaultValue);
    const [minInputWidth, setMinInputWidth] = (0, $jC8Vy.useState)(0);
    const canvasRef = (0, $jC8Vy.useRef)(null);
    const handleSearchKeyPress = (event)=>{
        if (event.key === "Enter" && inputValue) onSearch?.(inputValue);
    };
    const handleSearchChange = (event)=>{
        setInputValue(event.currentTarget.value);
    };
    const handleClick = ()=>{
        onSearch?.(inputValue);
    };
    (0, $jC8Vy.useEffect)(()=>{
        // Render placeholder text in canvas to calculate its width in CSS pixels.
        const ctx = canvasRef.current?.getContext("2d");
        if (!ctx) return;
        ctx.font = $46c375e0973aedf1$var$fontBody2;
        setMinInputWidth(ctx.measureText(placeholder).width);
    }, [
        placeholder
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $1a424a227751a2de$export$d76128d007d19019,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("canvas", {
                ref: canvasRef
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                className: inputClassName,
                value: inputValue,
                icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $45ba7f7cad465e3f$export$2e2bcd8739ae039), {
                    className: $1a424a227751a2de$export$8687ffcdea58e000
                }),
                placeholder: placeholder,
                style: {
                    minWidth: `${minInputWidth}px`
                },
                onChange: handleSearchChange,
                onKeyPress: handleSearchKeyPress
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                title: "general.search",
                onClick: handleClick
            }),
            isClearable && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                size: "small",
                type: "text",
                title: "general.clear_result",
                onClick: ()=>{
                    setInputValue("");
                    onClearSearch?.();
                }
            })
        ]
    });
}
var $46c375e0973aedf1$export$2e2bcd8739ae039 = $46c375e0973aedf1$var$Search;




var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $jheqv = parcelRequire("jheqv");

var $66ixW = parcelRequire("66ixW");

var $9Q3SI = parcelRequire("9Q3SI");
var $b234707317096fd1$export$31eb53bd5b582a97;
var $b234707317096fd1$export$6d59db4903f20f7d;
var $b234707317096fd1$export$5c452ff88e35e47d;
var $b234707317096fd1$export$c7187bbd1a7a9244;
var $b234707317096fd1$export$bfd64c937657f93a;
var $b234707317096fd1$export$4a6dd88bada4e7d2;
var $b234707317096fd1$export$fb184b623420d9be;
$b234707317096fd1$export$31eb53bd5b582a97 = `uyn--W_action`;
$b234707317096fd1$export$6d59db4903f20f7d = `uyn--W_description`;
$b234707317096fd1$export$5c452ff88e35e47d = `uyn--W_image`;
$b234707317096fd1$export$c7187bbd1a7a9244 = `uyn--W_placeholder`;
$b234707317096fd1$export$bfd64c937657f93a = `uyn--W_rotating`;
$b234707317096fd1$export$4a6dd88bada4e7d2 = `uyn--W_shimmer`;
$b234707317096fd1$export$fb184b623420d9be = `uyn--W_title`;


function $2b56c00d3802884b$var$TablePlaceholder({ image: image, imageDark: imageDark, title: title, description: description, learnMoreLink: learnMoreLink, action: action }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const theme = (0, $jheqv.default)();
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $b234707317096fd1$export$c7187bbd1a7a9244,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $b234707317096fd1$export$5c452ff88e35e47d,
                children: theme === (0, $5HVJe.Theme).Light ? image : imageDark
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $b234707317096fd1$export$fb184b623420d9be,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                    forKey: title
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $b234707317096fd1$export$6d59db4903f20f7d,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                        forKey: description
                    }),
                    learnMoreLink?.href && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                                href: learnMoreLink.href,
                                targetBlank: learnMoreLink.targetBlank,
                                children: t("general.learn_more")
                            })
                        ]
                    })
                ]
            }),
            action && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $b234707317096fd1$export$31eb53bd5b582a97,
                children: action
            })
        ]
    });
}
var $2b56c00d3802884b$export$2e2bcd8739ae039 = $2b56c00d3802884b$var$TablePlaceholder;




var $9Q3SI = parcelRequire("9Q3SI");

var $7VnwS = parcelRequire("7VnwS");


var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $f8294d6f9d89665d$var$SvgEdit = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M4.167 15H7.7a.833.833 0 0 0 .592-.242l5.766-5.775 2.367-2.317a.833.833 0 0 0 0-1.183l-3.533-3.575a.833.833 0 0 0-1.184 0l-2.35 2.358-5.783 5.775a.833.833 0 0 0-.242.592v3.534a.833.833 0 0 0 .834.833ZM12.3 3.675l2.358 2.358-1.183 1.183-2.358-2.358L12.3 3.675Zm-7.3 7.3 4.942-4.942L12.3 8.391l-4.942 4.942H5v-2.358Zm12.5 5.691h-15a.834.834 0 0 0 0 1.667h15a.833.833 0 1 0 0-1.666Z",
            fill: "currentColor"
        })
    });
var $f8294d6f9d89665d$export$2e2bcd8739ae039 = $f8294d6f9d89665d$var$SvgEdit;





var $dL4NZ = parcelRequire("dL4NZ");

var $66ixW = parcelRequire("66ixW");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
const $ed226b81b3190522$export$da1930f05c3ce270 = (value)=>value.charAt(0).toLowerCase() + value.slice(1);


/**
 * Returns a function that translates a given action and target into a short phrase.
 */ const $9fca41f2a64ee9e4$var$useActionTranslation = ()=>{
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return (0, $jC8Vy.useCallback)((action, target)=>t(`general.${action}_field`, {
            field: (0, $ed226b81b3190522$export$da1930f05c3ce270)(String(t(target)))
        }), [
        t
    ]);
};
var $9fca41f2a64ee9e4$export$2e2bcd8739ae039 = $9fca41f2a64ee9e4$var$useActionTranslation;


var $d35908b1b8b82e83$export$1ca1ec8b29a4ce27;
$d35908b1b8b82e83$export$1ca1ec8b29a4ce27 = `v6CNCW_icon`;


/**
 * A button that displays a three-dot icon and opens a menu the following options:
 *
 * - Edit (optional)
 * - Delete
 */ function $d6ac1a830c94487b$var$ActionsButton({ onDelete: onDelete, onEdit: onEdit, deleteConfirmation: deleteConfirmation, fieldName: fieldName, textOverrides: textOverrides }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const tAction = (0, $9fca41f2a64ee9e4$export$2e2bcd8739ae039)();
    const [isModalOpen, setIsModalOpen] = (0, $jC8Vy.useState)(false);
    const [isDeleting, setIsDeleting] = (0, $jC8Vy.useState)(false);
    const handleDelete = (0, $jC8Vy.useCallback)(async ()=>{
        if (!onDelete) return;
        setIsDeleting(true);
        try {
            await onDelete();
        } finally{
            setIsDeleting(false);
            setIsModalOpen(false);
        }
    }, [
        onDelete
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $f25eeaa133584984$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $51f9e5400e6421f4$export$2e2bcd8739ae039), {
                    className: $d35908b1b8b82e83$export$1ca1ec8b29a4ce27
                }),
                title: t("general.more_options"),
                children: [
                    onEdit && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6c006ec422465f6f$export$2e2bcd8739ae039), {
                        iconClassName: $d35908b1b8b82e83$export$1ca1ec8b29a4ce27,
                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f8294d6f9d89665d$export$2e2bcd8739ae039), {}),
                        onClick: onEdit,
                        children: textOverrides?.edit ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: textOverrides.edit
                        }) : tAction("edit", fieldName)
                    }),
                    onDelete && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6c006ec422465f6f$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3aa588de5c8665f2$export$2e2bcd8739ae039), {}),
                        type: "danger",
                        onClick: ()=>{
                            setIsModalOpen(true);
                        },
                        children: textOverrides?.delete ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: textOverrides.delete
                        }) : tAction("delete", fieldName)
                    })
                ]
            }),
            onDelete && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dL4NZ.default), {
                isOpen: isModalOpen,
                confirmButtonText: textOverrides?.deleteConfirmation ?? "general.delete",
                isLoading: isDeleting,
                onCancel: ()=>{
                    setIsModalOpen(false);
                },
                onConfirm: handleDelete,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                    forKey: deleteConfirmation
                })
            })
        ]
    });
}
var $d6ac1a830c94487b$export$2e2bcd8739ae039 = $d6ac1a830c94487b$var$ActionsButton;



var $C7mD2 = parcelRequire("C7mD2");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $kUZ14 = parcelRequire("kUZ14");

var $jGWQ4 = parcelRequire("jGWQ4");

var $aqmjm = parcelRequire("aqmjm");

var $5vVWy = parcelRequire("5vVWy");

var $fmHmG = parcelRequire("fmHmG");

var $dW2kG = parcelRequire("dW2kG");

var $5OcFi = parcelRequire("5OcFi");
function $5335921b9cd1fc58$var$EditScopeModal({ scopeName: scopeName, data: data, text: text, onClose: onClose, onSubmit: onSubmit }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { handleSubmit: handleSubmit, register: register, formState: { isSubmitting: isSubmitting } } = (0, $codQP.useForm)({
        defaultValues: data
    });
    const onSubmitHandler = handleSubmit((0, $5OcFi.trySubmitSafe)(async (formData)=>{
        await onSubmit(formData);
        onClose();
    }));
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        shouldCloseOnEsc: true,
        isOpen: Boolean(data),
        className: $dW2kG.content,
        overlayClassName: $dW2kG.overlay,
        onRequestClose: ()=>{
            onClose();
        },
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5vVWy.default), {
            title: text.title,
            footer: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        isLoading: isSubmitting,
                        title: "general.cancel",
                        onClick: onClose
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        isLoading: isSubmitting,
                        title: "general.save",
                        type: "primary",
                        htmlType: "submit",
                        onClick: onSubmitHandler
                    })
                ]
            }),
            onClose: onClose,
            children: /*#__PURE__*/ (0, $C7mD2.jsxs)("form", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        title: text.nameField,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                            readOnly: true,
                            value: scopeName
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        title: text.descriptionField,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                            // eslint-disable-next-line jsx-a11y/no-autofocus
                            autoFocus: true,
                            placeholder: String(t(text.descriptionPlaceholder)),
                            ...register("description")
                        })
                    })
                ]
            })
        })
    });
}
var $5335921b9cd1fc58$export$2e2bcd8739ae039 = $5335921b9cd1fc58$var$EditScopeModal;



var $639bfc5c1e0b80c2$export$bec2adab93981092;
var $639bfc5c1e0b80c2$export$9b6d6ca62970729f;
var $639bfc5c1e0b80c2$export$6d59db4903f20f7d;
var $639bfc5c1e0b80c2$export$3dea766d36a8935f;
var $639bfc5c1e0b80c2$export$9c30223ca0a664fb;
var $639bfc5c1e0b80c2$export$9abc8bff93154df;
var $639bfc5c1e0b80c2$export$bfd64c937657f93a;
var $639bfc5c1e0b80c2$export$4a6dd88bada4e7d2;
$639bfc5c1e0b80c2$export$bec2adab93981092 = `vPj7DW_actionColumn`;
$639bfc5c1e0b80c2$export$9b6d6ca62970729f = `vPj7DW_createButton`;
$639bfc5c1e0b80c2$export$6d59db4903f20f7d = `vPj7DW_description`;
$639bfc5c1e0b80c2$export$3dea766d36a8935f = `vPj7DW_filter`;
$639bfc5c1e0b80c2$export$9c30223ca0a664fb = `vPj7DW_link`;
$639bfc5c1e0b80c2$export$9abc8bff93154df = `vPj7DW_permissionTable`;
$639bfc5c1e0b80c2$export$bfd64c937657f93a = `vPj7DW_rotating`;
$639bfc5c1e0b80c2$export$4a6dd88bada4e7d2 = `vPj7DW_shimmer`;


function $32ff64ac17e10119$var$PermissionsTable({ scopes: scopes, isLoading: isLoading, errorMessage: errorMessage, createButtonTitle: createButtonTitle, isReadOnly: isReadOnly = false, isApiColumnVisible: isApiColumnVisible = false, isCreateGuideVisible: isCreateGuideVisible = false, pagination: pagination, search: { keyword: keyword, searchHandler: searchHandler, clearSearchHandler: clearSearchHandler }, createHandler: createHandler, deleteHandler: deleteHandler, retryHandler: retryHandler, onPermissionUpdated: onPermissionUpdated, deletionText: deletionText }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $b595fc2f0eccd19a$export$2e2bcd8739ae039)();
    const [editingScope, setEditingScope] = (0, $jC8Vy.useState)();
    const api = (0, $7VnwS.default)();
    const handleEdit = async (scope, editedData)=>{
        const patchApiEndpoint = `api/resources/${scope.resourceId}/scopes/${scope.id}`;
        await api.patch(patchApiEndpoint, {
            json: editedData
        });
        (0, $FuhPC.toast).success(t("general.saved"));
        onPermissionUpdated();
    };
    const nameColumn = {
        title: t("permissions.name_column"),
        dataIndex: "name",
        colSpan: isApiColumnVisible ? 5 : 6,
        render: ({ name: name })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
                variant: "cell",
                children: name
            })
    };
    const descriptionColumn = {
        title: t("permissions.description_column"),
        dataIndex: "description",
        colSpan: isApiColumnVisible ? 5 : 9,
        render: ({ description: description })=>/*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $639bfc5c1e0b80c2$export$6d59db4903f20f7d,
                children: description
            })
    };
    const apiColumn = {
        title: t("permissions.api_column"),
        dataIndex: "resource",
        colSpan: 5,
        render: ({ resource: resource })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                className: $639bfc5c1e0b80c2$export$9c30223ca0a664fb,
                to: `/api-resources/${resource.id}/${(0, $bt3dS.ApiResourceDetailsTabs).General}`,
                children: resource.name
            })
    };
    const actionColumn = {
        title: null,
        dataIndex: "action",
        colSpan: 1,
        className: $639bfc5c1e0b80c2$export$bec2adab93981092,
        render: (scope)=>/**
       * When the table is read-only, hide the delete button rather than the whole column to keep the table column spaces.
       */ isReadOnly ? null : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $d6ac1a830c94487b$export$2e2bcd8739ae039), {
                fieldName: "permissions.name_column",
                deleteConfirmation: deletionText.confirmation,
                textOverrides: {
                    edit: "permissions.edit",
                    delete: deletionText.actionButton,
                    deleteConfirmation: deletionText.confirmButton
                },
                onDelete: ()=>{
                    deleteHandler(scope);
                },
                onEdit: ()=>{
                    setEditingScope(scope);
                }
            })
    };
    const columns = [
        nameColumn,
        descriptionColumn,
        (0, $7oDSS.conditional)(isApiColumnVisible && apiColumn),
        actionColumn
    ].filter((column)=>Boolean(column));
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3166f28a681c41bb$export$2e2bcd8739ae039), {
                className: $639bfc5c1e0b80c2$export$9abc8bff93154df,
                rowIndexKey: "id",
                rowGroups: [
                    {
                        key: "scopes",
                        data: scopes
                    }
                ],
                columns: columns,
                filter: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: $639bfc5c1e0b80c2$export$3dea766d36a8935f,
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $46c375e0973aedf1$export$2e2bcd8739ae039), {
                            defaultValue: keyword,
                            isClearable: Boolean(keyword),
                            placeholder: t(isApiColumnVisible ? "permissions.search_placeholder" : "permissions.search_placeholder_without_api"),
                            onSearch: searchHandler,
                            onClearSearch: clearSearchHandler
                        }),
                        !isReadOnly && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                            title: createButtonTitle,
                            className: $639bfc5c1e0b80c2$export$9b6d6ca62970729f,
                            type: "primary",
                            size: "large",
                            icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0b30fe81c923292b$export$2e2bcd8739ae039), {}),
                            onClick: ()=>{
                                createHandler();
                            }
                        })
                    ]
                }),
                isLoading: isLoading,
                pagination: pagination,
                placeholder: !isReadOnly && isCreateGuideVisible ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2b56c00d3802884b$export$2e2bcd8739ae039), {
                    image: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e03e8b98a9e094ed$export$2e2bcd8739ae039), {}),
                    imageDark: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fbc1a38a5dc459d3$export$2e2bcd8739ae039), {}),
                    title: "permissions.placeholder_title",
                    description: "permissions.placeholder_description",
                    learnMoreLink: {
                        href: getDocumentationUrl("/docs/recipes/rbac/manage-permissions-and-roles"),
                        targetBlank: "noopener"
                    },
                    action: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        title: createButtonTitle,
                        type: "primary",
                        size: "large",
                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0b30fe81c923292b$export$2e2bcd8739ae039), {}),
                        onClick: ()=>{
                            createHandler();
                        }
                    })
                }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a0f84bc7cc69e410$export$2e2bcd8739ae039), {}),
                errorMessage: errorMessage,
                onRetry: retryHandler
            }),
            editingScope && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5335921b9cd1fc58$export$2e2bcd8739ae039), {
                scopeName: editingScope.name,
                data: editingScope,
                text: {
                    title: "permissions.edit_title",
                    nameField: "api_resource_details.permission.name",
                    descriptionField: "api_resource_details.permission.description",
                    descriptionPlaceholder: "api_resource_details.permission.description_placeholder"
                },
                onSubmit: async (editedData)=>{
                    await handleEdit(editingScope, editedData);
                },
                onClose: ()=>{
                    setEditingScope(undefined);
                }
            })
        ]
    });
}
var $32ff64ac17e10119$export$2e2bcd8739ae039 = $32ff64ac17e10119$var$PermissionsTable;



var $8Mb3E = parcelRequire("8Mb3E");

var $7VnwS = parcelRequire("7VnwS");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");

var $6bq3s = parcelRequire("6bq3s");
/**
 * Watch search parameters
 *
 * @param config Define search parameter keys and their default value. E.g., `{ page: 1, keyword: '' }`
 * @returns [searchParams, updateSearchParams]
 */ const $66a3eb3654f9d141$var$useSearchParametersWatcher = (config)=>{
    const [searchParameters, setSearchParameters] = (0, $6bq3s.useSearchParams)();
    const updateSearchParameters = (0, $jC8Vy.useCallback)((parameters)=>{
        const baseParameters = new URLSearchParams(searchParameters);
        for (const key of Object.keys(parameters)){
            // eslint-disable-next-line no-restricted-syntax
            const value = parameters[key];
            if (value === undefined) baseParameters.delete(key);
            else baseParameters.set(key, String(value));
        }
        setSearchParameters(baseParameters);
    }, [
        searchParameters,
        setSearchParameters
    ]);
    return [
        // eslint-disable-next-line no-restricted-syntax
        Object.fromEntries(Object.entries(config).map(([parameterKey, defaultValue])=>{
            const locationParameterValue = searchParameters.get(parameterKey);
            const parameterValue = typeof defaultValue === "string" ? locationParameterValue ?? defaultValue : (0, $7oDSS.conditional)(locationParameterValue && Number(locationParameterValue)) ?? defaultValue;
            return [
                parameterKey,
                parameterValue
            ];
        })),
        updateSearchParameters
    ];
};
var $66a3eb3654f9d141$export$2e2bcd8739ae039 = $66a3eb3654f9d141$var$useSearchParametersWatcher;



var $7kooT = parcelRequire("7kooT");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("4taJ0");
var $9vrm1 = parcelRequire("9vrm1");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $kUZ14 = parcelRequire("kUZ14");





var $jGWQ4 = parcelRequire("jGWQ4");

var $aqmjm = parcelRequire("aqmjm");

var $5vVWy = parcelRequire("5vVWy");

var $fmHmG = parcelRequire("fmHmG");

var $7VnwS = parcelRequire("7VnwS");

var $dW2kG = parcelRequire("dW2kG");

var $5OcFi = parcelRequire("5OcFi");

function $863f5d776e1589ca$var$CreatePermissionModal({ resourceId: resourceId, totalResourceCount: totalResourceCount, onClose: onClose }) {
    const { currentPlan: currentPlan } = (0, $jC8Vy.useContext)((0, $19434c930f80c964$export$f8addfd4ab69c833));
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { handleSubmit: handleSubmit, register: register, formState: { isSubmitting: isSubmitting, errors: errors } } = (0, $codQP.useForm)();
    const api = (0, $7VnwS.default)();
    const onSubmit = handleSubmit((0, $5OcFi.trySubmitSafe)(async (formData)=>{
        if (isSubmitting) return;
        const createdScope = await api.post(`api/resources/${resourceId}/scopes`, {
            json: formData
        }).json();
        onClose(createdScope);
    }));
    const isScopesPerResourceReachLimit = (0, $605aee781e0fe83f$export$1cc4b5152472cd4f)({
        quotaKey: "scopesPerResourceLimit",
        plan: currentPlan,
        usage: totalResourceCount
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        isOpen: true,
        shouldCloseOnEsc: true,
        className: $dW2kG.content,
        overlayClassName: $dW2kG.overlay,
        onRequestClose: ()=>{
            onClose();
        },
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5vVWy.default), {
            title: "api_resource_details.permission.create_title",
            subtitle: "api_resource_details.permission.create_subtitle",
            learnMoreLink: {
                href: "https://docs.logto.io/docs/recipes/rbac/manage-permissions-and-roles#manage-role-permissions",
                targetBlank: "noopener"
            },
            footer: isScopesPerResourceReachLimit ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dafa1bad5a99c1ae$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                    components: {
                        a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a3bc63325dc3c1a8$export$2e2bcd8739ae039), {}),
                        planName: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $161f1bf99d56f621$export$2e2bcd8739ae039), {
                            name: currentPlan.name
                        })
                    },
                    children: t("upsell.paywall.scopes_per_resource", {
                        count: currentPlan.quota.scopesPerResourceLimit ?? 0
                    })
                })
            }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                isLoading: isSubmitting,
                htmlType: "submit",
                title: "api_resource_details.permission.confirm_create",
                size: "large",
                type: "primary",
                onClick: onSubmit
            }),
            onClose: onClose,
            children: /*#__PURE__*/ (0, $C7mD2.jsxs)("form", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        isRequired: true,
                        title: "api_resource_details.permission.name",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                            // eslint-disable-next-line jsx-a11y/no-autofocus
                            autoFocus: true,
                            placeholder: t("api_resource_details.permission.name_placeholder"),
                            ...register("name", {
                                required: true,
                                pattern: {
                                    value: (0, $9vrm1.noSpaceRegEx),
                                    message: t("api_resource_details.permission.forbidden_space_in_name")
                                }
                            }),
                            error: errors.name?.message
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        title: "api_resource_details.permission.description",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                            placeholder: t("api_resource_details.permission.description_placeholder"),
                            ...register("description"),
                            error: Boolean(errors.description)
                        })
                    })
                ]
            })
        })
    });
}
var $863f5d776e1589ca$export$2e2bcd8739ae039 = $863f5d776e1589ca$var$CreatePermissionModal;


const $14247092f318ef59$var$pageSize = (0, $8Mb3E.defaultPageSize);
function $14247092f318ef59$var$ApiResourcePermissions() {
    const { resource: { id: resourceId }, isLogtoManagementApiResource: isLogtoManagementApiResource } = (0, $2Phw0.useOutletContext)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [{ page: page, keyword: keyword }, updateSearchParameters] = (0, $66a3eb3654f9d141$export$2e2bcd8739ae039)({
        page: 1,
        keyword: ""
    });
    const { data: data, error: error, mutate: mutate } = (0, $voszV.default)(resourceId && (0, $7kooT.buildUrl)(`api/resources/${resourceId}/scopes`, {
        page: String(page),
        page_size: String($14247092f318ef59$var$pageSize),
        ...(0, $7oDSS.conditional)(keyword && {
            search: (0, $7kooT.formatSearchKeyword)(keyword)
        })
    }));
    const isLoading = !data && !error;
    const [scopes, totalCount] = data ?? [];
    const api = (0, $7VnwS.default)();
    const [isCreateFormOpen, setIsCreateFormOpen] = (0, $jC8Vy.useState)(false);
    const handleDelete = async (scopeToBeDeleted)=>{
        await api.delete(`api/resources/${resourceId}/scopes/${scopeToBeDeleted.id}`);
        (0, $FuhPC.toast).success(t("api_resource_details.permission.deleted", {
            name: scopeToBeDeleted.name
        }));
        await mutate();
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $32ff64ac17e10119$export$2e2bcd8739ae039), {
                isCreateGuideVisible: true,
                scopes: scopes,
                isLoading: isLoading,
                isReadOnly: isLogtoManagementApiResource,
                createButtonTitle: "api_resource_details.permission.create_button",
                createHandler: ()=>{
                    setIsCreateFormOpen(true);
                },
                deletionText: {
                    actionButton: "permissions.delete",
                    confirmation: "api_resource_details.permission.delete_description",
                    confirmButton: "general.delete"
                },
                deleteHandler: handleDelete,
                errorMessage: error?.body?.message ?? error?.message,
                retryHandler: async ()=>mutate(undefined, true),
                pagination: {
                    page: page,
                    pageSize: $14247092f318ef59$var$pageSize,
                    totalCount: totalCount,
                    onChange: (page)=>{
                        updateSearchParameters({
                            page: page
                        });
                    }
                },
                search: {
                    keyword: keyword,
                    searchHandler: (keyword)=>{
                        updateSearchParameters({
                            keyword: keyword,
                            page: 1
                        });
                    },
                    clearSearchHandler: ()=>{
                        updateSearchParameters({
                            keyword: "",
                            page: 1
                        });
                    }
                },
                onPermissionUpdated: mutate
            }),
            isCreateFormOpen && totalCount !== undefined && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $863f5d776e1589ca$export$2e2bcd8739ae039), {
                resourceId: resourceId,
                totalResourceCount: totalCount,
                onClose: (scope)=>{
                    if (scope) {
                        (0, $FuhPC.toast).success(t("api_resource_details.permission.permission_created", {
                            name: scope.name
                        }));
                        mutate();
                    }
                    setIsCreateFormOpen(false);
                }
            })
        ]
    });
}
var $14247092f318ef59$export$2e2bcd8739ae039 = $14247092f318ef59$var$ApiResourcePermissions;



var $C7mD2 = parcelRequire("C7mD2");

var $codQP = parcelRequire("codQP");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $2Phw0 = parcelRequire("2Phw0");




var $aqmjm = parcelRequire("aqmjm");

var $8RfrQ = parcelRequire("8RfrQ");

var $fmHmG = parcelRequire("fmHmG");

var $9Q3SI = parcelRequire("9Q3SI");

var $7VnwS = parcelRequire("7VnwS");


var $5OcFi = parcelRequire("5OcFi");
function $463bc073e4cf4ebc$var$ApiResourceSettings() {
    const { resource: resource, isDeleting: isDeleting, isLogtoManagementApiResource: isLogtoManagementApiResource, onResourceUpdated: onResourceUpdated } = (0, $2Phw0.useOutletContext)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $b595fc2f0eccd19a$export$2e2bcd8739ae039)();
    const { handleSubmit: handleSubmit, register: register, reset: reset, formState: { isDirty: isDirty, isSubmitting: isSubmitting, errors: errors } } = (0, $codQP.useForm)({
        defaultValues: resource
    });
    const api = (0, $7VnwS.default)();
    const onSubmit = handleSubmit((0, $5OcFi.trySubmitSafe)(async ({ isDefault: isDefault, ...rest })=>{
        if (isSubmitting) return;
        const [data] = await Promise.all([
            api.patch(`api/resources/${resource.id}`, {
                json: rest
            }).json(),
            api.patch(`api/resources/${resource.id}/is-default`, {
                json: {
                    isDefault: isDefault
                }
            }).json()
        ]);
        // We cannot ensure the order of API requests, manually combine the results
        const updatedApiResource = {
            ...data,
            isDefault: isDefault
        };
        reset(updatedApiResource);
        onResourceUpdated(updatedApiResource);
        (0, $FuhPC.toast).success(t("general.saved"));
    }));
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f0e7fd6d3bded790$export$2e2bcd8739ae039), {
                isDirty: isDirty,
                isSubmitting: isSubmitting,
                onDiscard: reset,
                onSubmit: onSubmit,
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
                    title: "api_resource_details.settings",
                    description: isLogtoManagementApiResource ? "api_resource_details.management_api_settings_description" : "api_resource_details.settings_description",
                    learnMoreLink: {
                        href: getDocumentationUrl(isLogtoManagementApiResource ? "/docs/recipes/interact-with-management-api/" : "/docs/recipes/protect-your-api/"),
                        targetBlank: "noopener"
                    },
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                            isRequired: true,
                            title: "api_resources.api_name",
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                ...register("name", {
                                    required: true
                                }),
                                error: Boolean(errors.name),
                                readOnly: isLogtoManagementApiResource,
                                placeholder: t("api_resources.api_name_placeholder")
                            })
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                            isRequired: true,
                            title: "api_resource_details.token_expiration_time_in_seconds",
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                ...register("accessTokenTtl", {
                                    required: true,
                                    valueAsNumber: true
                                }),
                                type: "number",
                                error: Boolean(errors.accessTokenTtl),
                                placeholder: t("api_resource_details.token_expiration_time_in_seconds_placeholder")
                            })
                        }),
                        !isLogtoManagementApiResource && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                            title: "api_resources.default_api",
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8RfrQ.default), {
                                ...register("isDefault"),
                                label: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                                    components: {
                                        a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                                            href: "https://docs.logto.io/docs/references/resources/#default-api",
                                            targetBlank: "noopener"
                                        })
                                    },
                                    children: t("api_resources.default_api_label")
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fea55fa5d5726e29$export$2e2bcd8739ae039), {
                hasUnsavedChanges: !isDeleting && isDirty
            })
        ]
    });
}
var $463bc073e4cf4ebc$export$2e2bcd8739ae039 = $463bc073e4cf4ebc$var$ApiResourceSettings;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");
var $9XFlr = parcelRequire("9XFlr");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
parcelRequire("6bq3s");
var $2Phw0 = parcelRequire("2Phw0");

var $voszV = parcelRequire("voszV");





var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $lXQZH = parcelRequire("lXQZH");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");
parcelRequire("8Mb3E");
var $cfL6o = parcelRequire("cfL6o");


var $1QOtg = parcelRequire("1QOtg");

var $9Q3SI = parcelRequire("9Q3SI");

/**
 * Charge notification for add-on quota limit features
 *
 * CAUTION:
 * - This notification will be rendered only when the tenant's subscription plan is a paid plan. We won't render it for free plan since we will not charge for free plan.
 * - If the notification has been marked as checked, it will not be rendered.
 */ function $69ac10e11f23c995$var$ChargeNotification({ hasSurpassedLimit: hasSurpassedLimit, quotaItemPhraseKey: quotaItemPhraseKey, quotaLimit: quotaLimit, className: className, checkedFlagKey: checkedFlagKey }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.upsell"
    });
    const { currentPlan: currentPlan } = (0, $jC8Vy.useContext)((0, $19434c930f80c964$export$f8addfd4ab69c833));
    const { configs: configs, updateConfigs: updateConfigs } = (0, $dad5317382253f6d$export$2e2bcd8739ae039)();
    // Display null when loading
    if (!configs) return null;
    const { checkedChargeNotification: checkedChargeNotification } = configs;
    if (Boolean(checkedChargeNotification?.[checkedFlagKey]) || !hasSurpassedLimit || // No charge notification for free plan
    currentPlan.id === (0, $lXQZH.ReservedPlanId).Free) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1QOtg.default), {
        className: className,
        action: "general.got_it",
        onClick: ()=>{
            updateConfigs({
                checkedChargeNotification: {
                    ...checkedChargeNotification,
                    [checkedFlagKey]: true
                }
            });
        },
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
            components: {
                a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                    href: (0, $cfL6o.newPlansBlogLink),
                    targetBlank: "noopener"
                })
            },
            children: t("charge_notification_for_quota_limit", {
                item: t(`add_on_quota_item.${quotaItemPhraseKey}`, {
                    ...(0, $7oDSS.cond)(// Note: tokens use 'M' as unit
                    quotaLimit && {
                        limit: quotaItemPhraseKey === "tokens" ? quotaLimit / 1000000 : quotaLimit
                    })
                })
            })
        })
    });
}
var $69ac10e11f23c995$export$2e2bcd8739ae039 = $69ac10e11f23c995$var$ChargeNotification;




var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $6bq3s = parcelRequire("6bq3s");

var $4ZcUR = parcelRequire("4ZcUR");
var $d7400bdcfc5cf05d$exports = {};

$parcel$export($d7400bdcfc5cf05d$exports, "compact", function () { return $d7400bdcfc5cf05d$export$8e16b83750b44988; }, function (v) { return $d7400bdcfc5cf05d$export$8e16b83750b44988 = v; });
$parcel$export($d7400bdcfc5cf05d$exports, "content", function () { return $d7400bdcfc5cf05d$export$a7db06668cad9adb; }, function (v) { return $d7400bdcfc5cf05d$export$a7db06668cad9adb = v; });
$parcel$export($d7400bdcfc5cf05d$exports, "item", function () { return $d7400bdcfc5cf05d$export$7061c75fc5af8b7e; }, function (v) { return $d7400bdcfc5cf05d$export$7061c75fc5af8b7e = v; });
$parcel$export($d7400bdcfc5cf05d$exports, "meta", function () { return $d7400bdcfc5cf05d$export$6990040ee07315; }, function (v) { return $d7400bdcfc5cf05d$export$6990040ee07315 = v; });
$parcel$export($d7400bdcfc5cf05d$exports, "rotating", function () { return $d7400bdcfc5cf05d$export$bfd64c937657f93a; }, function (v) { return $d7400bdcfc5cf05d$export$bfd64c937657f93a = v; });
$parcel$export($d7400bdcfc5cf05d$exports, "shimmer", function () { return $d7400bdcfc5cf05d$export$4a6dd88bada4e7d2; }, function (v) { return $d7400bdcfc5cf05d$export$4a6dd88bada4e7d2 = v; });
$parcel$export($d7400bdcfc5cf05d$exports, "subtitle", function () { return $d7400bdcfc5cf05d$export$c96745152eb2740f; }, function (v) { return $d7400bdcfc5cf05d$export$c96745152eb2740f = v; });
$parcel$export($d7400bdcfc5cf05d$exports, "title", function () { return $d7400bdcfc5cf05d$export$fb184b623420d9be; }, function (v) { return $d7400bdcfc5cf05d$export$fb184b623420d9be = v; });
$parcel$export($d7400bdcfc5cf05d$exports, "withLink", function () { return $d7400bdcfc5cf05d$export$dba12c34892a5782; }, function (v) { return $d7400bdcfc5cf05d$export$dba12c34892a5782 = v; });
var $d7400bdcfc5cf05d$export$8e16b83750b44988;
var $d7400bdcfc5cf05d$export$a7db06668cad9adb;
var $d7400bdcfc5cf05d$export$7061c75fc5af8b7e;
var $d7400bdcfc5cf05d$export$6990040ee07315;
var $d7400bdcfc5cf05d$export$bfd64c937657f93a;
var $d7400bdcfc5cf05d$export$4a6dd88bada4e7d2;
var $d7400bdcfc5cf05d$export$c96745152eb2740f;
var $d7400bdcfc5cf05d$export$fb184b623420d9be;
var $d7400bdcfc5cf05d$export$dba12c34892a5782;
$d7400bdcfc5cf05d$export$8e16b83750b44988 = `mTaj3G_compact`;
$d7400bdcfc5cf05d$export$a7db06668cad9adb = `mTaj3G_content`;
$d7400bdcfc5cf05d$export$7061c75fc5af8b7e = `mTaj3G_item`;
$d7400bdcfc5cf05d$export$6990040ee07315 = `mTaj3G_meta`;
$d7400bdcfc5cf05d$export$bfd64c937657f93a = `mTaj3G_rotating`;
$d7400bdcfc5cf05d$export$4a6dd88bada4e7d2 = `mTaj3G_shimmer`;
$d7400bdcfc5cf05d$export$c96745152eb2740f = `mTaj3G_subtitle`;
$d7400bdcfc5cf05d$export$fb184b623420d9be = `mTaj3G_title`;
$d7400bdcfc5cf05d$export$dba12c34892a5782 = `mTaj3G_withLink`;


function $4d952cae22cb03fc$var$ItemPreview({ title: title, subtitle: subtitle, icon: icon, to: to, size: size = "default", suffix: suffix, toTarget: toTarget }) {
    const { getTo: getTo } = (0, $4ZcUR.default)();
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($d7400bdcfc5cf05d$exports.item, $d7400bdcfc5cf05d$exports[size]),
        children: [
            icon,
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $d7400bdcfc5cf05d$exports.content,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $d7400bdcfc5cf05d$exports.meta,
                        children: [
                            to && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6bq3s.Link), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($d7400bdcfc5cf05d$exports.title, $d7400bdcfc5cf05d$exports.withLink),
                                to: getTo(to),
                                target: toTarget,
                                onClick: (event)=>{
                                    event.stopPropagation();
                                },
                                children: title
                            }),
                            !to && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $d7400bdcfc5cf05d$exports.title,
                                children: title
                            }),
                            subtitle && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $d7400bdcfc5cf05d$exports.subtitle,
                                children: subtitle
                            })
                        ]
                    }),
                    suffix
                ]
            })
        ]
    });
}
var $4d952cae22cb03fc$export$2e2bcd8739ae039 = $4d952cae22cb03fc$var$ItemPreview;



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");


var $5TsIB = parcelRequire("5TsIB");

var $jGWQ4 = parcelRequire("jGWQ4");

var $18SWy = parcelRequire("18SWy");


function $998b64ca82ed2460$var$ListPage({ title: title, pageMeta: pageMeta, createButton: createButton, subHeader: subHeader, table: table, widgets: widgets, className: className }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($7ddbeb184b5d4257$export$34e0f9847d4c02dd, className),
        children: [
            pageMeta && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5TsIB.default), {
                ...pageMeta
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $7ddbeb184b5d4257$export$516dd90aeaaabcf0,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $18SWy.default), {
                        ...title
                    }),
                    createButton && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0b30fe81c923292b$export$2e2bcd8739ae039), {}),
                        type: "primary",
                        size: "large",
                        ...createButton
                    })
                ]
            }),
            subHeader,
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3166f28a681c41bb$export$2e2bcd8739ae039), {
                className: $7ddbeb184b5d4257$export$9852986a3ec5f6a0,
                ...table
            }),
            widgets
        ]
    });
}
var $998b64ca82ed2460$export$2e2bcd8739ae039 = $998b64ca82ed2460$var$ListPage;



var $8Mb3E = parcelRequire("8Mb3E");

var $8TpMk = parcelRequire("8TpMk");

var $bt3dS = parcelRequire("bt3dS");

var $cw2No = parcelRequire("cw2No");




var $4ZcUR = parcelRequire("4ZcUR");

var $jheqv = parcelRequire("jheqv");

var $7kooT = parcelRequire("7kooT");

var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $kUZ14 = parcelRequire("kUZ14");

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jGWQ4 = parcelRequire("jGWQ4");

var $66ixW = parcelRequire("66ixW");
var $e7e3ea4240dcab8c$export$795623e8105ba10a;
var $e7e3ea4240dcab8c$export$bfd64c937657f93a;
var $e7e3ea4240dcab8c$export$4a6dd88bada4e7d2;
var $e7e3ea4240dcab8c$export$6f093cfa640b7166;
var $e7e3ea4240dcab8c$export$cc74dcc53cfce4eb;
$e7e3ea4240dcab8c$export$795623e8105ba10a = `iJckjG_actionBar`;
$e7e3ea4240dcab8c$export$bfd64c937657f93a = `iJckjG_rotating`;
$e7e3ea4240dcab8c$export$4a6dd88bada4e7d2 = `iJckjG_shimmer`;
$e7e3ea4240dcab8c$export$6f093cfa640b7166 = `iJckjG_text`;
$e7e3ea4240dcab8c$export$cc74dcc53cfce4eb = `iJckjG_wrapper`;


function $e8d0f46f7ce96736$export$2e2bcd8739ae039({ wrapperClassName: wrapperClassName, content: content, buttonText: buttonText, onClick: onClick }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)("nav", {
        className: $e7e3ea4240dcab8c$export$795623e8105ba10a,
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($e7e3ea4240dcab8c$export$cc74dcc53cfce4eb, wrapperClassName),
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                    className: $e7e3ea4240dcab8c$export$6f093cfa640b7166,
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                        forKey: content
                    })
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                    size: "large",
                    title: buttonText,
                    type: "outline",
                    onClick: onClick
                })
            ]
        })
    });
}




var $4ZcUR = parcelRequire("4ZcUR");

var $dW2kG = parcelRequire("dW2kG");


var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");




var $aTllQ = parcelRequire("aTllQ");

var $4ZcUR = parcelRequire("4ZcUR");

var $87c50f602a979df2$export$34e0f9847d4c02dd;
var $87c50f602a979df2$export$a76584009ca8faeb;
var $87c50f602a979df2$export$d4abd167df80d226;
var $87c50f602a979df2$export$1f1f054184239bf5;
var $87c50f602a979df2$export$bfd64c937657f93a;
var $87c50f602a979df2$export$4a6dd88bada4e7d2;
var $87c50f602a979df2$export$cc74dcc53cfce4eb;
$87c50f602a979df2$export$34e0f9847d4c02dd = `nzzT_q_container`;
$87c50f602a979df2$export$a76584009ca8faeb = `nzzT_q_emptyPlaceholder`;
$87c50f602a979df2$export$d4abd167df80d226 = `nzzT_q_groups`;
$87c50f602a979df2$export$1f1f054184239bf5 = `nzzT_q_guideGroup`;
$87c50f602a979df2$export$bfd64c937657f93a = `nzzT_q_rotating`;
$87c50f602a979df2$export$4a6dd88bada4e7d2 = `nzzT_q_shimmer`;
$87c50f602a979df2$export$cc74dcc53cfce4eb = `nzzT_q_wrapper`;


function $93170623ceaee50e$var$GuideLibrary({ className: className, hasCardBorder: hasCardBorder, hasCardButton: hasCardButton }) {
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const [selectedGuide, setSelectedGuide] = (0, $jC8Vy.useState)();
    const guides = (0, $c14feef50a46e3d8$export$6bb65ec2faabc0af)();
    const [showCreateForm, setShowCreateForm] = (0, $jC8Vy.useState)(false);
    const onClickGuide = (0, $jC8Vy.useCallback)((data)=>{
        setShowCreateForm(true);
        setSelectedGuide(data);
    }, []);
    const onCloseCreateForm = (0, $jC8Vy.useCallback)((newResource)=>{
        if (newResource && selectedGuide) {
            navigate(`/api-resources/${newResource.id}/guide/${selectedGuide.id}`, {
                replace: true
            });
            return;
        }
        setShowCreateForm(false);
        setSelectedGuide(undefined);
    }, [
        navigate,
        selectedGuide
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aTllQ.default), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($87c50f602a979df2$export$34e0f9847d4c02dd, className),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $87c50f602a979df2$export$cc74dcc53cfce4eb,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $87c50f602a979df2$export$d4abd167df80d226,
                    children: guides.length > 0 ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $742494c24a2c2466$export$2e2bcd8739ae039), {
                        className: $87c50f602a979df2$export$1f1f054184239bf5,
                        hasCardBorder: hasCardBorder,
                        hasCardButton: hasCardButton,
                        guides: guides,
                        onClickGuide: onClickGuide
                    }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a0f84bc7cc69e410$export$2e2bcd8739ae039), {
                        className: $87c50f602a979df2$export$a76584009ca8faeb,
                        size: "large"
                    })
                })
            }),
            selectedGuide?.target === "API" && showCreateForm && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $297779ffbed99380$export$2e2bcd8739ae039), {
                onClose: onCloseCreateForm
            })
        ]
    });
}
var $93170623ceaee50e$export$2e2bcd8739ae039 = $93170623ceaee50e$var$GuideLibrary;


var $32f71b220c954cfa$export$34e0f9847d4c02dd;
var $32f71b220c954cfa$export$a7db06668cad9adb;
var $32f71b220c954cfa$export$bfd64c937657f93a;
var $32f71b220c954cfa$export$4a6dd88bada4e7d2;
$32f71b220c954cfa$export$34e0f9847d4c02dd = `BBV9gW_container`;
$32f71b220c954cfa$export$a7db06668cad9adb = `BBV9gW_content`;
$32f71b220c954cfa$export$bfd64c937657f93a = `BBV9gW_rotating`;
$32f71b220c954cfa$export$4a6dd88bada4e7d2 = `BBV9gW_shimmer`;


function $6f96482911dd19d7$var$GuideLibraryModal({ isOpen: isOpen, onClose: onClose }) {
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const [showCreateForm, setShowCreateForm] = (0, $jC8Vy.useState)(false);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        shouldCloseOnEsc: true,
        isOpen: isOpen,
        className: $dW2kG.fullScreen,
        onRequestClose: onClose,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $32f71b220c954cfa$export$34e0f9847d4c02dd,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $81c55e09caea137c$export$2e2bcd8739ae039), {
                        title: "guide.api.modal_title",
                        subtitle: "guide.api.modal_subtitle",
                        buttonText: "guide.cannot_find_guide",
                        requestFormFieldLabel: "guide.describe_guide_looking_for",
                        requestFormFieldPlaceholder: "guide.api.describe_guide_looking_for_placeholder",
                        requestSuccessMessage: "guide.request_guide_successfully",
                        onClose: onClose
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $93170623ceaee50e$export$2e2bcd8739ae039), {
                        hasCardButton: true,
                        className: $32f71b220c954cfa$export$a7db06668cad9adb
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e8d0f46f7ce96736$export$2e2bcd8739ae039), {
                        content: "guide.do_not_need_tutorial",
                        buttonText: "guide.api.continue_without_tutorial",
                        onClick: ()=>{
                            setShowCreateForm(true);
                        }
                    })
                ]
            }),
            showCreateForm && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $297779ffbed99380$export$2e2bcd8739ae039), {
                onClose: (newApiResource)=>{
                    if (newApiResource) navigate(`/api-resources/${newApiResource.id}`);
                    setShowCreateForm(false);
                }
            })
        ]
    });
}
var $6f96482911dd19d7$export$2e2bcd8739ae039 = $6f96482911dd19d7$var$GuideLibraryModal;


var $ace8521b2d1de415$export$25b61ec9da546d46;
var $ace8521b2d1de415$export$1ca1ec8b29a4ce27;
var $ace8521b2d1de415$export$bfd64c937657f93a;
var $ace8521b2d1de415$export$4a6dd88bada4e7d2;
$ace8521b2d1de415$export$25b61ec9da546d46 = `_2WfC1G_chargeNotification`;
$ace8521b2d1de415$export$1ca1ec8b29a4ce27 = `_2WfC1G_icon`;
$ace8521b2d1de415$export$bfd64c937657f93a = `_2WfC1G_rotating`;
$ace8521b2d1de415$export$4a6dd88bada4e7d2 = `_2WfC1G_shimmer`;


const $cd1e0e92b2704d0f$var$pageSize = (0, $8Mb3E.defaultPageSize);
const $cd1e0e92b2704d0f$var$apiResourcesPathname = "/api-resources";
const $cd1e0e92b2704d0f$var$createApiResourcePathname = `${$cd1e0e92b2704d0f$var$apiResourcesPathname}/create`;
const $cd1e0e92b2704d0f$var$buildDetailsPathname = (id)=>`${$cd1e0e92b2704d0f$var$apiResourcesPathname}/${id}/${(0, $bt3dS.ApiResourceDetailsTabs).Permissions}`;
const $cd1e0e92b2704d0f$var$icons = {
    [(0, $5HVJe.Theme).Light]: {
        ApiIcon: (0, $c9b59df86be12d23$export$2e2bcd8739ae039),
        ManagementApiIcon: (0, $ff631a8563f36219$export$2e2bcd8739ae039)
    },
    [(0, $5HVJe.Theme).Dark]: {
        ApiIcon: (0, $3da24e4cf07ae5e9$export$2e2bcd8739ae039),
        ManagementApiIcon: (0, $9260430af4663ded$export$2e2bcd8739ae039)
    }
};
function $cd1e0e92b2704d0f$var$ApiResources() {
    const { search: search } = (0, $2Phw0.useLocation)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { hasSurpassedLimit: hasSurpassedLimit } = (0, $061553e9dfc672b8$export$2e2bcd8739ae039)();
    const [{ page: page }, updateSearchParameters] = (0, $66a3eb3654f9d141$export$2e2bcd8739ae039)({
        page: 1
    });
    const url = (0, $7kooT.buildUrl)("api/resources", {
        page: String(page),
        page_size: String($cd1e0e92b2704d0f$var$pageSize)
    });
    const { data: data, error: error, mutate: mutate } = (0, $voszV.default)(url);
    const isLoading = !data && !error;
    const { navigate: navigate, match: match } = (0, $4ZcUR.default)();
    const theme = (0, $jheqv.default)();
    const [apiResources, totalCount] = data ?? [];
    const { ApiIcon: ApiIcon, ManagementApiIcon: ManagementApiIcon } = $cd1e0e92b2704d0f$var$icons[theme];
    const isCreating = match($cd1e0e92b2704d0f$var$createApiResourcePathname);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $998b64ca82ed2460$export$2e2bcd8739ae039), {
                title: {
                    title: "api_resources.title",
                    subtitle: "api_resources.subtitle"
                },
                pageMeta: {
                    titleKey: "api_resources.page_title"
                },
                createButton: {
                    title: "api_resources.create",
                    onClick: ()=>{
                        navigate({
                            pathname: $cd1e0e92b2704d0f$var$createApiResourcePathname,
                            search: search
                        });
                    }
                },
                subHeader: (0, $8TpMk.isCloud) && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $69ac10e11f23c995$export$2e2bcd8739ae039), {
                    hasSurpassedLimit: hasSurpassedLimit,
                    quotaItemPhraseKey: "api_resource",
                    checkedFlagKey: "apiResource",
                    className: $ace8521b2d1de415$export$25b61ec9da546d46
                }),
                table: {
                    rowGroups: [
                        {
                            key: "apiResources",
                            data: apiResources
                        }
                    ],
                    rowIndexKey: "id",
                    isLoading: isLoading,
                    errorMessage: error?.body?.message ?? error?.message,
                    columns: [
                        {
                            title: t("api_resources.api_name"),
                            dataIndex: "name",
                            colSpan: 6,
                            render: ({ id: id, name: name, isDefault: isDefault, indicator: indicator })=>{
                                const Icon = (0, $9XFlr.isManagementApi)(indicator) ? ManagementApiIcon : ApiIcon;
                                return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4d952cae22cb03fc$export$2e2bcd8739ae039), {
                                    title: name,
                                    icon: /*#__PURE__*/ (0, $C7mD2.jsx)(Icon, {
                                        className: $ace8521b2d1de415$export$1ca1ec8b29a4ce27
                                    }),
                                    to: $cd1e0e92b2704d0f$var$buildDetailsPathname(id),
                                    suffix: isDefault && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
                                        children: t("api_resources.default_api")
                                    })
                                });
                            }
                        },
                        {
                            title: t("api_resources.api_identifier"),
                            dataIndex: "indicator",
                            colSpan: 10,
                            render: ({ indicator: indicator })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
                                    value: indicator,
                                    variant: "text"
                                })
                        }
                    ],
                    placeholder: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a0f84bc7cc69e410$export$2e2bcd8739ae039), {}),
                    rowClickHandler: ({ id: id })=>{
                        navigate($cd1e0e92b2704d0f$var$buildDetailsPathname(id));
                    },
                    onRetry: async ()=>mutate(undefined, true),
                    pagination: {
                        page: page,
                        totalCount: totalCount,
                        pageSize: $cd1e0e92b2704d0f$var$pageSize,
                        onChange: (page)=>{
                            updateSearchParameters({
                                page: page
                            });
                        }
                    }
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6f96482911dd19d7$export$2e2bcd8739ae039), {
                isOpen: isCreating,
                onClose: ()=>{
                    navigate({
                        pathname: $cd1e0e92b2704d0f$var$apiResourcesPathname,
                        search: search
                    });
                }
            })
        ]
    });
}
var $cd1e0e92b2704d0f$export$2e2bcd8739ae039 = $cd1e0e92b2704d0f$var$ApiResources;


const $362cfc57314b0c6f$export$23ad47434f71b6b1 = {
    path: "api-resources",
    children: [
        {
            index: true,
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cd1e0e92b2704d0f$export$2e2bcd8739ae039), {})
        },
        {
            path: "create",
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cd1e0e92b2704d0f$export$2e2bcd8739ae039), {})
        },
        {
            path: ":id/guide/:guideId",
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2cd82a99935118fa$export$2e2bcd8739ae039), {})
        },
        {
            path: ":id/*",
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2cd82a99935118fa$export$2e2bcd8739ae039), {}),
            children: [
                {
                    index: true,
                    element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Navigate), {
                        replace: true,
                        to: (0, $bt3dS.ApiResourceDetailsTabs).Permissions
                    })
                },
                {
                    path: (0, $bt3dS.ApiResourceDetailsTabs).Permissions,
                    element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $14247092f318ef59$export$2e2bcd8739ae039), {})
                },
                {
                    path: (0, $bt3dS.ApiResourceDetailsTabs).General,
                    element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $463bc073e4cf4ebc$export$2e2bcd8739ae039), {})
                }
            ]
        }
    ]
};



var $C7mD2 = parcelRequire("C7mD2");

var $2Phw0 = parcelRequire("2Phw0");
parcelRequire("8Mb3E");
var $bt3dS = parcelRequire("bt3dS");

var $C7mD2 = parcelRequire("C7mD2");

var $2Phw0 = parcelRequire("2Phw0");

var $voszV = parcelRequire("voszV");


var $5TsIB = parcelRequire("5TsIB");

var $byEIK = parcelRequire("byEIK");

var $4ZcUR = parcelRequire("4ZcUR");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $2Phw0 = parcelRequire("2Phw0");







parcelRequire("8Mb3E");
var $cfL6o = parcelRequire("cfL6o");
var $bt3dS = parcelRequire("bt3dS");



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");
var $d58a036403a89adc$export$fe8985bb6374093c;
$d58a036403a89adc$export$fe8985bb6374093c = `Sol9Da_hide`;


function $03bc4af79519e411$var$TabWrapper({ isActive: isActive, className: className, children: children }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))(!isActive && $d58a036403a89adc$export$fe8985bb6374093c, className),
        "data-active": isActive,
        children: children
    });
}
var $03bc4af79519e411$export$2e2bcd8739ae039 = $03bc4af79519e411$var$TabWrapper;



var $7VnwS = parcelRequire("7VnwS");


var $4ZcUR = parcelRequire("4ZcUR");


var $5OcFi = parcelRequire("5OcFi");

var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");




parcelRequire("8Mb3E");
var $cfL6o = parcelRequire("cfL6o");

var $aqmjm = parcelRequire("aqmjm");

var $fmHmG = parcelRequire("fmHmG");

var $7VnwS = parcelRequire("7VnwS");



var $5OcFi = parcelRequire("5OcFi");

var $cRLgg = parcelRequire("cRLgg");

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");


var $64bc78b19ebe8e2e$export$34e0f9847d4c02dd;
var $64bc78b19ebe8e2e$export$808aaf1b460dc9af;
var $64bc78b19ebe8e2e$export$6d59db4903f20f7d;
var $64bc78b19ebe8e2e$export$a3bc9b8ed74fc;
var $64bc78b19ebe8e2e$export$48ba76420b337f5e;
var $64bc78b19ebe8e2e$export$bfd64c937657f93a;
var $64bc78b19ebe8e2e$export$4a6dd88bada4e7d2;
$64bc78b19ebe8e2e$export$34e0f9847d4c02dd = `m0Dypq_container`;
$64bc78b19ebe8e2e$export$808aaf1b460dc9af = `m0Dypq_darkMode`;
$64bc78b19ebe8e2e$export$6d59db4903f20f7d = `m0Dypq_description`;
$64bc78b19ebe8e2e$export$a3bc9b8ed74fc = `m0Dypq_error`;
$64bc78b19ebe8e2e$export$48ba76420b337f5e = `m0Dypq_multiColumn`;
$64bc78b19ebe8e2e$export$bfd64c937657f93a = `m0Dypq_rotating`;
$64bc78b19ebe8e2e$export$4a6dd88bada4e7d2 = `m0Dypq_shimmer`;


function $af2e865a72157fa4$var$LogoUploader({ isDarkModeEnabled: isDarkModeEnabled }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [uploadLogoError, setUploadLogoError] = (0, $jC8Vy.useState)();
    const [uploadDarkLogoError, setUploadDarkLogoError] = (0, $jC8Vy.useState)();
    const { description: description } = (0, $75ebfd707e0e1bc0$export$2e2bcd8739ae039)();
    const { control: control } = (0, $codQP.useFormContext)();
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $64bc78b19ebe8e2e$export$34e0f9847d4c02dd,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                        name: "branding.logoUrl",
                        control: control,
                        render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $d986fdd56af49b28$export$2e2bcd8739ae039), {
                                className: isDarkModeEnabled ? $64bc78b19ebe8e2e$export$48ba76420b337f5e : undefined,
                                name: name,
                                value: value ?? "",
                                actionDescription: t("sign_in_exp.branding.logo_image_url"),
                                onCompleted: onChange,
                                onUploadErrorChange: setUploadLogoError,
                                onDelete: ()=>{
                                    onChange("");
                                }
                            })
                    }),
                    isDarkModeEnabled && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                        name: "branding.darkLogoUrl",
                        control: control,
                        render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $d986fdd56af49b28$export$2e2bcd8739ae039), {
                                name: name,
                                value: value ?? "",
                                className: value ? $64bc78b19ebe8e2e$export$808aaf1b460dc9af : undefined,
                                actionDescription: t("sign_in_exp.branding.dark_logo_image_url"),
                                onCompleted: onChange,
                                onUploadErrorChange: setUploadDarkLogoError,
                                onDelete: ()=>{
                                    onChange("");
                                }
                            })
                    })
                ]
            }),
            uploadLogoError && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($64bc78b19ebe8e2e$export$6d59db4903f20f7d, $64bc78b19ebe8e2e$export$a3bc9b8ed74fc),
                children: t("sign_in_exp.branding.logo_image_error", {
                    error: uploadLogoError
                })
            }),
            uploadDarkLogoError && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($64bc78b19ebe8e2e$export$6d59db4903f20f7d, $64bc78b19ebe8e2e$export$a3bc9b8ed74fc),
                children: t("sign_in_exp.branding.logo_image_error", {
                    error: uploadDarkLogoError
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $64bc78b19ebe8e2e$export$6d59db4903f20f7d,
                children: description
            })
        ]
    });
}
var $af2e865a72157fa4$export$2e2bcd8739ae039 = $af2e865a72157fa4$var$LogoUploader;



var $voszV = parcelRequire("voszV");

var $7VnwS = parcelRequire("7VnwS");


/**
 * SWR fetcher for application sign-in experience
 *
 * hide error toast, because we will handle the error in the component
 * allow 404 error, if the sign-in experience is not set
 */ const $1177d0d63f00768d$var$useApplicationSignInExperienceSWR = (applicationId)=>{
    const fetchApi = (0, $7VnwS.default)({
        hideErrorToast: true
    });
    const fetcher = (0, $04c74fc7d2f91811$export$2e2bcd8739ae039)(fetchApi);
    return (0, $voszV.default)(`api/applications/${applicationId}/sign-in-experience`, {
        fetcher: fetcher,
        shouldRetryOnError: (0, $d3d6bc7d2607318c$export$9ea285d0c158d4f1)({
            ignore: [
                404
            ]
        })
    });
};
var $1177d0d63f00768d$export$2e2bcd8739ae039 = $1177d0d63f00768d$var$useApplicationSignInExperienceSWR;



var $voszV = parcelRequire("voszV");
/**
 * We need SIE isDarkModeEnabled to determine if we should show the dark mode logo forms
 */ const $166b97027050a184$var$useSignInExperienceSWR = ()=>{
    return (0, $voszV.default)("api/sign-in-exp");
};
var $166b97027050a184$export$2e2bcd8739ae039 = $166b97027050a184$var$useSignInExperienceSWR;


parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");
const $04dcb1b687b2de61$export$e42d859aa9b9d1c4 = (data)=>{
    const { branding: branding, applicationId: applicationId, tenantId: tenantId, ...rest } = data;
    return {
        ...rest,
        branding: {
            ...(0, $7oDSS.conditional)(branding.logoUrl && {
                logoUrl: branding.logoUrl
            }),
            ...(0, $7oDSS.conditional)(branding.darkLogoUrl && {
                darkLogoUrl: branding.darkLogoUrl
            })
        }
    };
};
const $04dcb1b687b2de61$export$5f954257ec69fc83 = (data)=>{
    const { branding: branding, ...rest } = data;
    return {
        ...rest,
        branding: {
            logoUrl: branding.logoUrl ?? "",
            darkLogoUrl: branding.darkLogoUrl ?? ""
        }
    };
};


function $07559b443b856fd2$var$Branding({ application: application, isActive: isActive }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $b595fc2f0eccd19a$export$2e2bcd8739ae039)();
    const formMethods = (0, $codQP.useForm)({
        defaultValues: {
            tenantId: application.tenantId,
            applicationId: application.id,
            branding: {}
        }
    });
    const { handleSubmit: handleSubmit, register: register, reset: reset, formState: { isDirty: isDirty, isSubmitting: isSubmitting, errors: errors } } = formMethods;
    const api = (0, $7VnwS.default)();
    const { data: data, error: error, mutate: mutate } = (0, $1177d0d63f00768d$export$2e2bcd8739ae039)(application.id);
    const { data: sieData, error: sieError, mutate: sieMutate } = (0, $166b97027050a184$export$2e2bcd8739ae039)();
    const { isReady: isUserAssetsServiceReady, isLoading: isUserAssetsServiceLoading } = (0, $04111409d75abad4$export$2e2bcd8739ae039)();
    const isApplicationSieLoading = !data && !error;
    const isSieLoading = !sieData && !sieError;
    const isLoading = isApplicationSieLoading || isSieLoading || isUserAssetsServiceLoading;
    const onSubmit = handleSubmit((0, $5OcFi.trySubmitSafe)(async (data)=>{
        if (isSubmitting) return;
        const response = await api.put(`api/applications/${application.id}/sign-in-experience`, {
            json: (0, $04dcb1b687b2de61$export$e42d859aa9b9d1c4)(data)
        }).json();
        mutate(response);
        (0, $FuhPC.toast).success(t("general.saved"));
    }));
    const onRetryFetch = (0, $jC8Vy.useCallback)(()=>{
        mutate();
        sieMutate();
    }, [
        mutate,
        sieMutate
    ]);
    (0, $jC8Vy.useEffect)(()=>{
        if (!data) return;
        reset((0, $04dcb1b687b2de61$export$5f954257ec69fc83)(data));
    }, [
        data,
        reset
    ]);
    if (isLoading) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fe58a6ffca737898$export$2e2bcd8739ae039), {});
    // Show error details if the error is not 404
    if (error && error.status !== 404) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a20a092c49eaf711$export$2e2bcd8739ae039), {
        error: error,
        onRetry: onRetryFetch
    });
    const isDarkModeEnabled = sieData?.color.isDarkModeEnabled;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.FormProvider), {
                ...formMethods,
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $f0e7fd6d3bded790$export$2e2bcd8739ae039), {
                    isDirty: isDirty,
                    isSubmitting: isSubmitting,
                    onDiscard: reset,
                    onSubmit: onSubmit,
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
                            title: "application_details.branding.name",
                            description: "application_details.branding.description",
                            learnMoreLink: {
                                href: getDocumentationUrl((0, $cfL6o.logtoThirdPartyAppBrandingLink)),
                                targetBlank: "noopener"
                            },
                            children: [
                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                    title: "application_details.branding.display_name",
                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                        ...register("displayName"),
                                        placeholder: application.name
                                    })
                                }),
                                isUserAssetsServiceReady && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                    title: "application_details.branding.display_logo",
                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $af2e865a72157fa4$export$2e2bcd8739ae039), {
                                        isDarkModeEnabled: isDarkModeEnabled
                                    })
                                }),
                                !isUserAssetsServiceReady && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                    title: "application_details.branding.display_logo",
                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                        ...register("branding.logoUrl", {
                                            validate: (value)=>!value || (0, $cRLgg.uriValidator)(value) || t("errors.invalid_uri_format")
                                        }),
                                        placeholder: t("sign_in_exp.branding.logo_image_url_placeholder"),
                                        error: errors.branding?.logoUrl?.message
                                    })
                                }),
                                !isUserAssetsServiceReady && isDarkModeEnabled && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                    title: "application_details.branding.display_logo_dark",
                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                        ...register("branding.darkLogoUrl", {
                                            validate: (value)=>!value || (0, $cRLgg.uriValidator)(value) || t("errors.invalid_uri_format")
                                        }),
                                        placeholder: t("sign_in_exp.branding.dark_logo_image_url_placeholder"),
                                        error: errors.branding?.darkLogoUrl?.message
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
                            title: "application_details.branding.more_info",
                            description: "application_details.branding.more_info_description",
                            children: [
                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                    title: "application_details.branding.terms_of_use_url",
                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                        ...register("termsOfUseUrl", {
                                            validate: (value)=>!value || (0, $cRLgg.uriValidator)(value) || t("errors.invalid_uri_format")
                                        }),
                                        error: errors.termsOfUseUrl?.message,
                                        placeholder: "https://"
                                    })
                                }),
                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                    title: "application_details.branding.privacy_policy_url",
                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                        ...register("privacyPolicyUrl", {
                                            validate: (value)=>!value || (0, $cRLgg.uriValidator)(value) || t("errors.invalid_uri_format")
                                        }),
                                        error: errors.privacyPolicyUrl?.message,
                                        placeholder: "https://"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            isActive && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fea55fa5d5726e29$export$2e2bcd8739ae039), {
                hasUnsavedChanges: isDirty,
                onConfirm: reset
            })
        ]
    });
}
var $07559b443b856fd2$export$2e2bcd8739ae039 = $07559b443b856fd2$var$Branding;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $3zL0M = parcelRequire("3zL0M");
var $61Yml = parcelRequire("61Yml");
parcelRequire("12bMu");
var $gcHb7 = parcelRequire("gcHb7");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $98a4f18236948225$var$SvgCaretDown = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M8.473 9.887 11.3 7.06a.666.666 0 0 0-.47-1.14.667.667 0 0 0-.47.193L8 8.473l-2.36-2.36a.667.667 0 0 0-1.084.218.667.667 0 0 0-.05.256.667.667 0 0 0 .194.473l2.827 2.827a.668.668 0 0 0 .946 0Z",
            fill: "currentColor"
        })
    });
var $98a4f18236948225$export$2e2bcd8739ae039 = $98a4f18236948225$var$SvgCaretDown;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $16d7b0de1c0442c9$var$SvgCaretUp = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M7.527 6.113 4.7 8.94a.667.667 0 1 0 .94.947L8 7.527l2.36 2.36a.667.667 0 0 0 1.084-.218.666.666 0 0 0 .05-.256.666.666 0 0 0-.194-.473L8.473 6.113a.667.667 0 0 0-.946 0Z",
            fill: "currentColor"
        })
    });
var $16d7b0de1c0442c9$export$2e2bcd8739ae039 = $16d7b0de1c0442c9$var$SvgCaretUp;




var $byEIK = parcelRequire("byEIK");

var $fG7L1 = parcelRequire("fG7L1");

var $jGWQ4 = parcelRequire("jGWQ4");

var $cw2No = parcelRequire("cw2No");

var $66ixW = parcelRequire("66ixW");

var $aqmjm = parcelRequire("aqmjm");

var $9Q3SI = parcelRequire("9Q3SI");

var $lWGA3 = parcelRequire("lWGA3");
var $1605e323fe6a84db$export$73afd3c3e9f6aecf;
var $1605e323fe6a84db$export$64fda0c1cfacc296;
var $1605e323fe6a84db$export$6d59db4903f20f7d;
var $1605e323fe6a84db$export$a2f81f0e973500f1;
var $1605e323fe6a84db$export$e4043f67d36cbb26;
var $1605e323fe6a84db$export$bfd64c937657f93a;
var $1605e323fe6a84db$export$4a6dd88bada4e7d2;
var $1605e323fe6a84db$export$5d1c634ec2526b93;
var $1605e323fe6a84db$export$74dc5dd4e622afa8;
$1605e323fe6a84db$export$73afd3c3e9f6aecf = `eOA9Fa_customEndpointNotes`;
$1605e323fe6a84db$export$64fda0c1cfacc296 = `eOA9Fa_deleteConfirm`;
$1605e323fe6a84db$export$6d59db4903f20f7d = `eOA9Fa_description`;
$1605e323fe6a84db$export$a2f81f0e973500f1 = `eOA9Fa_fieldButton`;
$1605e323fe6a84db$export$e4043f67d36cbb26 = `eOA9Fa_highlight`;
$1605e323fe6a84db$export$bfd64c937657f93a = `eOA9Fa_rotating`;
$1605e323fe6a84db$export$4a6dd88bada4e7d2 = `eOA9Fa_shimmer`;
$1605e323fe6a84db$export$5d1c634ec2526b93 = `eOA9Fa_tabContainer`;
$1605e323fe6a84db$export$74dc5dd4e622afa8 = `eOA9Fa_trailingIcon`;


function $ca6dfdcf0c0487d2$var$EndpointsAndCredentials({ app: { type: type, secret: secret, id: id, isThirdParty: isThirdParty }, oidcConfig: oidcConfig }) {
    const { tenantEndpoint: tenantEndpoint } = (0, $jC8Vy.useContext)((0, $fG7L1.AppDataContext));
    const [showMoreEndpoints, setShowMoreEndpoints] = (0, $jC8Vy.useState)(false);
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: customDomain, applyDomain: applyCustomDomain } = (0, $lWGA3.default)();
    const toggleShowMoreEndpoints = (0, $jC8Vy.useCallback)(()=>{
        setShowMoreEndpoints((previous)=>!previous);
    }, []);
    const ToggleVisibleCaretIcon = showMoreEndpoints ? (0, $16d7b0de1c0442c9$export$2e2bcd8739ae039) : (0, $98a4f18236948225$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
        title: "application_details.endpoints_and_credentials",
        description: "application_details.endpoints_and_credentials_description",
        learnMoreLink: {
            href: "https://openid.net/specs/openid-connect-core-1_0.html#TokenEndpoint",
            targetBlank: true
        },
        children: [
            tenantEndpoint && !isThirdParty && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: "application_details.logto_endpoint",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
                    displayType: "block",
                    value: applyCustomDomain(tenantEndpoint.href),
                    variant: "border"
                })
            }),
            tenantEndpoint && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: "application_details.config_endpoint",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
                    displayType: "block",
                    value: applyCustomDomain((0, $gcHb7.appendPath)(tenantEndpoint, (0, $byEIK.openIdProviderConfigPath)).href),
                    variant: "border"
                })
            }),
            showMoreEndpoints && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        title: "application_details.authorization_endpoint",
                        tip: (closeTipHandler)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                                components: {
                                    a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                                        targetBlank: true,
                                        href: "https://openid.net/specs/openid-connect-core-1_0.html#Authentication",
                                        onClick: closeTipHandler
                                    })
                                },
                                children: t("application_details.authorization_endpoint_tip")
                            }),
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
                            displayType: "block",
                            value: applyCustomDomain(oidcConfig.authorization_endpoint),
                            variant: "border"
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        title: "application_details.token_endpoint",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
                            displayType: "block",
                            value: applyCustomDomain(oidcConfig.token_endpoint),
                            variant: "border"
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        title: "application_details.user_info_endpoint",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
                            displayType: "block",
                            value: applyCustomDomain(oidcConfig.userinfo_endpoint),
                            variant: "border"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $1605e323fe6a84db$export$a2f81f0e973500f1,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                    size: "small",
                    type: "text",
                    title: showMoreEndpoints ? "application_details.hide_endpoint_details" : "application_details.show_endpoint_details",
                    trailingIcon: /*#__PURE__*/ (0, $C7mD2.jsx)(ToggleVisibleCaretIcon, {
                        className: $1605e323fe6a84db$export$74dc5dd4e622afa8
                    }),
                    onClick: toggleShowMoreEndpoints
                })
            }),
            customDomain?.status === (0, $3zL0M.DomainStatus).Active && tenantEndpoint && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $1605e323fe6a84db$export$73afd3c3e9f6aecf,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                    forKey: "domain.custom_endpoint_note",
                    interpolation: {
                        custom: customDomain.domain,
                        default: new URL(tenantEndpoint).host
                    }
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: "application_details.application_id",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
                    displayType: "block",
                    value: id,
                    variant: "border"
                })
            }),
            [
                (0, $61Yml.ApplicationType).Traditional,
                (0, $61Yml.ApplicationType).MachineToMachine,
                (0, $61Yml.ApplicationType).Protected
            ].includes(type) && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: "application_details.application_secret",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
                    hasVisibilityToggle: true,
                    displayType: "block",
                    value: secret,
                    variant: "border"
                })
            })
        ]
    });
}
var $ca6dfdcf0c0487d2$export$2e2bcd8739ae039 = $ca6dfdcf0c0487d2$var$EndpointsAndCredentials;



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");


var $HHYyb = parcelRequire("HHYyb");



var $75SRw = parcelRequire("75SRw");

var $jbKqE = parcelRequire("jbKqE");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");

var $fiyfZ = parcelRequire("fiyfZ");

var $2ZX8W = parcelRequire("2ZX8W");

var $fG7L1 = parcelRequire("fG7L1");

var $lWGA3 = parcelRequire("lWGA3");
function $11292fe225cd666f$var$AppGuide({ className: className, guideId: guideId, app: app, isCompact: isCompact, onClose: onClose }) {
    const { tenantEndpoint: tenantEndpoint } = (0, $jC8Vy.useContext)((0, $fG7L1.AppDataContext));
    const { applyDomain: applyCustomDomain } = (0, $lWGA3.default)();
    const guide = (0, $fiyfZ.default).find(({ id: id })=>id === guideId);
    const memorizedContext = (0, $jC8Vy.useMemo)(()=>(0, $7oDSS.conditional)(!!guide && !!app && {
            metadata: guide.metadata,
            Logo: guide.Logo,
            app: app,
            endpoint: applyCustomDomain(tenantEndpoint?.href ?? ""),
            redirectUris: app.oidcClientMetadata.redirectUris,
            postLogoutRedirectUris: app.oidcClientMetadata.postLogoutRedirectUris,
            isCompact: Boolean(isCompact),
            sampleUrls: {
                origin: "http://localhost:3001/",
                callback: "http://localhost:3001/callback"
            }
        }), [
        guide,
        app,
        tenantEndpoint?.href,
        applyCustomDomain,
        isCompact
    ]);
    return memorizedContext ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2ZX8W.GuideContext).Provider, {
        value: memorizedContext,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2ZX8W.default), {
            className: className,
            guideId: guideId,
            isEmpty: !app && !guide,
            isLoading: !app,
            onClose: onClose
        })
    }) : null;
}
var $11292fe225cd666f$export$2e2bcd8739ae039 = $11292fe225cd666f$var$AppGuide;


var $f7530c2232cd89d3$export$a22f64ad99009e4f;
var $f7530c2232cd89d3$export$e2ebc74040679039;
var $f7530c2232cd89d3$export$675bc0f5721dbbd7;
var $f7530c2232cd89d3$export$38e42c68cf43b5d4;
var $f7530c2232cd89d3$export$bfd64c937657f93a;
var $f7530c2232cd89d3$export$3e523c77c1f23f8c;
var $f7530c2232cd89d3$export$4a6dd88bada4e7d2;
$f7530c2232cd89d3$export$a22f64ad99009e4f = `awo3XW_cardGroup`;
$f7530c2232cd89d3$export$e2ebc74040679039 = `awo3XW_drawerContainer`;
$f7530c2232cd89d3$export$675bc0f5721dbbd7 = `awo3XW_guide`;
$f7530c2232cd89d3$export$38e42c68cf43b5d4 = `awo3XW_header`;
$f7530c2232cd89d3$export$bfd64c937657f93a = `awo3XW_rotating`;
$f7530c2232cd89d3$export$3e523c77c1f23f8c = `awo3XW_separator`;
$f7530c2232cd89d3$export$4a6dd88bada4e7d2 = `awo3XW_shimmer`;


function $4894cc0fc6e33e79$var$GuideDrawer({ app: app, onClose: onClose }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.guide"
    });
    const { getStructuredAppGuideMetadata: getStructuredAppGuideMetadata } = (0, $c14feef50a46e3d8$export$6b80cd72646f4cab)();
    const [selectedGuide, setSelectedGuide] = (0, $jC8Vy.useState)();
    const structuredMetadata = (0, $jC8Vy.useMemo)(()=>getStructuredAppGuideMetadata({
            categories: [
                app.type
            ]
        }), [
        getStructuredAppGuideMetadata,
        app.type
    ]);
    const hasSingleGuide = (0, $jC8Vy.useMemo)(()=>{
        return structuredMetadata[app.type].length === 1;
    }, [
        app.type,
        structuredMetadata
    ]);
    (0, $jC8Vy.useEffect)(()=>{
        if (hasSingleGuide) {
            const guide = structuredMetadata[app.type][0];
            if (guide) {
                const { id: id, metadata: { target: target, name: name, isThirdParty: isThirdParty } } = guide;
                setSelectedGuide({
                    id: id,
                    target: target,
                    name: name,
                    isThirdParty: isThirdParty
                });
            }
        }
    }, [
        hasSingleGuide,
        app.type,
        structuredMetadata
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $f7530c2232cd89d3$export$e2ebc74040679039,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $f7530c2232cd89d3$export$38e42c68cf43b5d4,
                children: [
                    selectedGuide && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                        children: [
                            !hasSingleGuide && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                                        size: "large",
                                        onClick: ()=>{
                                            setSelectedGuide(undefined);
                                        },
                                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $582c9405f1750413$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $f7530c2232cd89d3$export$3e523c77c1f23f8c
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                                children: t("checkout_tutorial", {
                                    name: selectedGuide.name
                                })
                            })
                        ]
                    }),
                    !selectedGuide && t("app.select_a_framework"),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jbKqE.default), {}),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                        size: "large",
                        onClick: onClose,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $HHYyb.default), {})
                    })
                ]
            }),
            !selectedGuide && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $742494c24a2c2466$export$2e2bcd8739ae039), {
                className: $f7530c2232cd89d3$export$a22f64ad99009e4f,
                categoryName: t(`categories.${app.type}`),
                guides: structuredMetadata[app.type],
                onClickGuide: (guide)=>{
                    setSelectedGuide(guide);
                }
            }),
            selectedGuide && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $11292fe225cd666f$export$2e2bcd8739ae039), {
                isCompact: true,
                className: $f7530c2232cd89d3$export$675bc0f5721dbbd7,
                guideId: selectedGuide.id,
                app: app,
                onClose: ()=>{
                    setSelectedGuide(undefined);
                }
            })
        ]
    });
}
var $4894cc0fc6e33e79$export$2e2bcd8739ae039 = $4894cc0fc6e33e79$var$GuideDrawer;



var $C7mD2 = parcelRequire("C7mD2");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
var $7GyLL = parcelRequire("7GyLL");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $voszV = parcelRequire("voszV");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5TTZn = parcelRequire("5TTZn");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $6bq3s = parcelRequire("6bq3s");

var $voszV = parcelRequire("voszV");

var $7VnwS = parcelRequire("7VnwS");


var $4ZcUR = parcelRequire("4ZcUR");

var $408d8d3093352bd7$export$9c30223ca0a664fb;
$408d8d3093352bd7$export$9c30223ca0a664fb = `QCDwsq_link`;


function $0004ff537e7bb7fe$var$ApplicationName({ applicationId: applicationId, isLink: isLink = false }) {
    const isAdminConsole = applicationId === (0, $5TTZn.adminConsoleApplicationId);
    const fetchApi = (0, $7VnwS.default)({
        hideErrorToast: true
    });
    const fetcher = (0, $04c74fc7d2f91811$export$2e2bcd8739ae039)(fetchApi);
    const { data: data, error: error } = (0, $voszV.default)(!isAdminConsole && `api/applications/${applicationId}`, {
        fetcher: fetcher,
        shouldRetryOnError: (0, $d3d6bc7d2607318c$export$9ea285d0c158d4f1)({
            ignore: [
                404
            ]
        })
    });
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getTo: getTo } = (0, $4ZcUR.default)();
    const name = (0, $jC8Vy.useMemo)(()=>{
        if (isAdminConsole) return `Admin Console (${t("system_app")})`;
        if (data?.name) return data.name;
        if (error?.status === 404) return `${applicationId} (${t("general.deleted")})`;
        return "-";
    }, [
        applicationId,
        data?.name,
        error?.status,
        isAdminConsole,
        t
    ]);
    if (isLink && !isAdminConsole && data?.name) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6bq3s.Link), {
        className: $408d8d3093352bd7$export$9c30223ca0a664fb,
        to: getTo(`/applications/${applicationId}`),
        children: name
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
        children: name
    });
}
var $0004ff537e7bb7fe$export$2e2bcd8739ae039 = $0004ff537e7bb7fe$var$ApplicationName;



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $6bq3s = parcelRequire("6bq3s");

var $voszV = parcelRequire("voszV");

var $7VnwS = parcelRequire("7VnwS");


var $4ZcUR = parcelRequire("4ZcUR");



var $ba26980b9747b5d5$export$9c30223ca0a664fb;
var $ba26980b9747b5d5$export$bfd64c937657f93a;
var $ba26980b9747b5d5$export$4a6dd88bada4e7d2;
var $ba26980b9747b5d5$export$fb184b623420d9be;
var $ba26980b9747b5d5$export$c86d3ca66f38ed60;
$ba26980b9747b5d5$export$9c30223ca0a664fb = `_3-KeZq_link`;
$ba26980b9747b5d5$export$bfd64c937657f93a = `_3-KeZq_rotating`;
$ba26980b9747b5d5$export$4a6dd88bada4e7d2 = `_3-KeZq_shimmer`;
$ba26980b9747b5d5$export$fb184b623420d9be = `_3-KeZq_title`;
$ba26980b9747b5d5$export$c86d3ca66f38ed60 = `_3-KeZq_userName`;


function $e1be354dd609d651$var$UserName({ userId: userId, isLink: isLink = false }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const fetchApi = (0, $7VnwS.default)({
        hideErrorToast: true
    });
    const fetcher = (0, $04c74fc7d2f91811$export$2e2bcd8739ae039)(fetchApi);
    const { data: data, error: error } = (0, $voszV.default)(`api/users/${userId}`, {
        fetcher: fetcher,
        shouldRetryOnError: (0, $d3d6bc7d2607318c$export$9ea285d0c158d4f1)({
            ignore: [
                404
            ]
        })
    });
    const { getTo: getTo } = (0, $4ZcUR.default)();
    const name = (0, $jC8Vy.useMemo)(()=>{
        if (data) return (0, $46451cbb59c7a857$export$5f7a1baecd59f846)(data);
        if (error?.status === 404) return `${userId} (${t("general.deleted")})`;
        return "-";
    }, [
        userId,
        data,
        error?.status,
        t
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: $ba26980b9747b5d5$export$c86d3ca66f38ed60,
        children: isLink && data ? /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $6bq3s.Link), {
            to: getTo(`/users/${userId}`),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($ba26980b9747b5d5$export$fb184b623420d9be, $ba26980b9747b5d5$export$9c30223ca0a664fb),
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e999fd6c93542895$export$2e2bcd8739ae039), {
                    hasTooltip: true,
                    size: "micro",
                    user: data
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                    children: name
                })
            ]
        }) : /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
            className: $ba26980b9747b5d5$export$fb184b623420d9be,
            children: name
        })
    });
}
var $e1be354dd609d651$export$2e2bcd8739ae039 = $e1be354dd609d651$var$UserName;


parcelRequire("8Mb3E");
var $h8YkU = parcelRequire("h8YkU");
var $8Mb3E = parcelRequire("8Mb3E");



var $4ZcUR = parcelRequire("4ZcUR");

var $7kooT = parcelRequire("7kooT");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $6hxiJ = parcelRequire("6hxiJ");
var $5TTZn = parcelRequire("5TTZn");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $voszV = parcelRequire("voszV");

var $8TpMk = parcelRequire("8TpMk");

var $cDKfs = parcelRequire("cDKfs");

function $ee6c4f15995bb59c$var$ApplicationSelector({ value: value, onChange: onChange }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { currentTenantId: currentTenantId } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { data: data } = (0, $voszV.default)("api/applications");
    const options = data?.map(({ id: id, name: name })=>({
            value: id,
            title: name
        })) ?? [];
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $286a7bc94edef870$export$2e2bcd8739ae039), {
        isClearable: true,
        value: value,
        options: [
            ...(0, $7oDSS.conditional)((0, $8TpMk.isCloud) && currentTenantId === (0, $6hxiJ.adminTenantId) && [
                {
                    value: (0, $5TTZn.adminConsoleApplicationId),
                    title: "Admin Console"
                }
            ]) ?? [],
            ...options
        ],
        placeholder: t("logs.application"),
        onChange: onChange
    });
}
var $ee6c4f15995bb59c$export$2e2bcd8739ae039 = $ee6c4f15995bb59c$var$ApplicationSelector;



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $6bq3s = parcelRequire("6bq3s");



var $h8YkU = parcelRequire("h8YkU");

var $4ZcUR = parcelRequire("4ZcUR");
var $23baafcac2ee460d$export$a0305a8c6cff19c8;
var $23baafcac2ee460d$export$2b62a06a9fee979c;
var $23baafcac2ee460d$export$1ca1ec8b29a4ce27;
var $23baafcac2ee460d$export$bfd64c937657f93a;
var $23baafcac2ee460d$export$4a6dd88bada4e7d2;
var $23baafcac2ee460d$export$fe7c49d056ea1d88;
var $23baafcac2ee460d$export$fb184b623420d9be;
$23baafcac2ee460d$export$a0305a8c6cff19c8 = `ji4gBq_eventName`;
$23baafcac2ee460d$export$2b62a06a9fee979c = `ji4gBq_fail`;
$23baafcac2ee460d$export$1ca1ec8b29a4ce27 = `ji4gBq_icon`;
$23baafcac2ee460d$export$bfd64c937657f93a = `ji4gBq_rotating`;
$23baafcac2ee460d$export$4a6dd88bada4e7d2 = `ji4gBq_shimmer`;
$23baafcac2ee460d$export$fe7c49d056ea1d88 = `ji4gBq_success`;
$23baafcac2ee460d$export$fb184b623420d9be = `ji4gBq_title`;


function $0b682f2dbec245d1$var$EventName({ eventKey: eventKey, isSuccess: isSuccess, to: to }) {
    const title = (0, $h8YkU.logEventTitle)[eventKey] ?? eventKey;
    const { getTo: getTo } = (0, $4ZcUR.default)();
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $23baafcac2ee460d$export$a0305a8c6cff19c8,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($23baafcac2ee460d$export$1ca1ec8b29a4ce27, isSuccess ? $23baafcac2ee460d$export$fe7c49d056ea1d88 : $23baafcac2ee460d$export$2b62a06a9fee979c),
                children: isSuccess ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $863c8122c7186617$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $10eea442689aa670$export$2e2bcd8739ae039), {})
            }),
            to && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6bq3s.Link), {
                className: $23baafcac2ee460d$export$fb184b623420d9be,
                to: getTo(to),
                onClick: (event)=>{
                    event.stopPropagation();
                },
                children: title
            }),
            !to && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $23baafcac2ee460d$export$fb184b623420d9be,
                children: title
            })
        ]
    });
}
var $0b682f2dbec245d1$export$2e2bcd8739ae039 = $0b682f2dbec245d1$var$EventName;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $h8YkU = parcelRequire("h8YkU");

const $8482f894a8934304$var$defaultEventOptions = Object.entries((0, $h8YkU.logEventTitle)).map(([value, title])=>({
        value: value,
        title: title ?? value
    }));
function $8482f894a8934304$var$EventSelector({ value: value, onChange: onChange, options: options }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $286a7bc94edef870$export$2e2bcd8739ae039), {
        isClearable: true,
        value: value,
        options: options ?? $8482f894a8934304$var$defaultEventOptions,
        placeholder: t("logs.event"),
        onChange: onChange
    });
}
var $8482f894a8934304$export$2e2bcd8739ae039 = $8482f894a8934304$var$EventSelector;


var $8ce007aaa55c4b20$export$5b2ad1bf581a1d7b;
var $8ce007aaa55c4b20$export$baf82c066573e902;
var $8ce007aaa55c4b20$export$3dea766d36a8935f;
var $8ce007aaa55c4b20$export$bfd64c937657f93a;
var $8ce007aaa55c4b20$export$4a6dd88bada4e7d2;
var $8ce007aaa55c4b20$export$fb184b623420d9be;
$8ce007aaa55c4b20$export$5b2ad1bf581a1d7b = `_l4QRW_applicationSelector`;
$8ce007aaa55c4b20$export$baf82c066573e902 = `_l4QRW_eventSelector`;
$8ce007aaa55c4b20$export$3dea766d36a8935f = `_l4QRW_filter`;
$8ce007aaa55c4b20$export$bfd64c937657f93a = `_l4QRW_rotating`;
$8ce007aaa55c4b20$export$4a6dd88bada4e7d2 = `_l4QRW_shimmer`;
$8ce007aaa55c4b20$export$fb184b623420d9be = `_l4QRW_title`;


const $85bd40f9f49866bd$var$auditLogEventOptions = Object.entries((0, $h8YkU.auditLogEventTitle)).map(([value, title])=>({
        value: value,
        title: title ?? value
    }));
function $85bd40f9f49866bd$var$AuditLogTable({ applicationId: applicationId, userId: userId, className: className }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const pageSize = (0, $8Mb3E.defaultPageSize);
    const [{ page: page, event: event, applicationId: applicationIdFromSearch }, updateSearchParameters] = (0, $66a3eb3654f9d141$export$2e2bcd8739ae039)({
        page: 1,
        event: "",
        // If `applicationId` not specified when init this component, then search parameter of `applicationId` can be accepted.
        ...(0, $7oDSS.conditional)(!applicationId && {
            applicationId: ""
        })
    });
    // TODO: LOG-7135, revisit this fallback logic and see whether this should be done outside of this component.
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    const searchApplicationId = applicationId || applicationIdFromSearch;
    const { data: specifiedApplication } = (0, $voszV.default)(applicationId && `api/applications/${applicationId}`);
    const url = (0, $7kooT.buildUrl)("api/logs", {
        page: String(page),
        page_size: String(pageSize),
        ...(0, $7oDSS.conditional)(event && {
            logKey: event
        }),
        ...(0, $7oDSS.conditional)(searchApplicationId && {
            applicationId: searchApplicationId
        }),
        ...(0, $7oDSS.conditional)(userId && {
            userId: userId
        })
    });
    const { data: data, error: error, mutate: mutate } = (0, $voszV.default)(url);
    const isLoading = !data && !error;
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const [logs, totalCount] = data ?? [];
    const isUserColumnVisible = !userId && specifiedApplication?.type !== (0, $61Yml.ApplicationType).MachineToMachine;
    const eventColumn = {
        title: t("logs.event"),
        dataIndex: "event",
        colSpan: isUserColumnVisible ? 5 : 6,
        render: ({ key: key, payload: { result: result } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $0b682f2dbec245d1$export$2e2bcd8739ae039), {
                eventKey: key,
                isSuccess: result === (0, $7GyLL.LogResult).Success
            })
    };
    const userColumn = {
        title: t("logs.user"),
        dataIndex: "user",
        colSpan: 5,
        render: ({ payload: { userId: userId } })=>userId ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e1be354dd609d651$export$2e2bcd8739ae039), {
                userId: userId
            }) : /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                children: "-"
            })
    };
    const applicationColumn = {
        title: t("logs.application"),
        dataIndex: "application",
        colSpan: isUserColumnVisible ? 3 : 5,
        render: ({ payload: { applicationId: applicationId } })=>applicationId ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0004ff537e7bb7fe$export$2e2bcd8739ae039), {
                applicationId: applicationId
            }) : /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                children: "-"
            })
    };
    const timeColumn = {
        title: t("logs.time"),
        dataIndex: "time",
        colSpan: isUserColumnVisible ? 3 : 5,
        render: ({ createdAt: createdAt })=>new Date(createdAt).toLocaleString()
    };
    const columns = [
        eventColumn,
        (0, $7oDSS.conditional)(isUserColumnVisible && userColumn),
        applicationColumn,
        timeColumn
    ].filter((column)=>Boolean(column));
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3166f28a681c41bb$export$2e2bcd8739ae039), {
        className: className,
        rowGroups: [
            {
                key: "logs",
                data: logs
            }
        ],
        rowIndexKey: "id",
        columns: columns,
        rowClickHandler: ({ id: id })=>{
            navigate(id);
        },
        filter: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
            className: $8ce007aaa55c4b20$export$3dea766d36a8935f,
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $8ce007aaa55c4b20$export$fb184b623420d9be,
                    children: t("logs.filter_by")
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $8ce007aaa55c4b20$export$baf82c066573e902,
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8482f894a8934304$export$2e2bcd8739ae039), {
                        value: event,
                        options: $85bd40f9f49866bd$var$auditLogEventOptions,
                        onChange: (event)=>{
                            updateSearchParameters({
                                event: event,
                                page: undefined
                            });
                        }
                    })
                }),
                !applicationId && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $8ce007aaa55c4b20$export$5b2ad1bf581a1d7b,
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ee6c4f15995bb59c$export$2e2bcd8739ae039), {
                        value: applicationIdFromSearch,
                        onChange: (applicationIdFromSearch)=>{
                            updateSearchParameters({
                                applicationId: applicationIdFromSearch,
                                page: undefined
                            });
                        }
                    })
                })
            ]
        }),
        placeholder: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a0f84bc7cc69e410$export$2e2bcd8739ae039), {}),
        pagination: {
            page: page,
            totalCount: totalCount,
            pageSize: pageSize,
            onChange: (page)=>{
                updateSearchParameters({
                    page: page
                });
            }
        },
        isLoading: isLoading,
        errorMessage: error?.body?.message ?? error?.message,
        onRetry: async ()=>mutate(undefined, true)
    });
}
var $85bd40f9f49866bd$export$2e2bcd8739ae039 = $85bd40f9f49866bd$var$AuditLogTable;


var $885928e6e4d4152b$export$fa0831f497706bad;
var $885928e6e4d4152b$export$bfd64c937657f93a;
var $885928e6e4d4152b$export$4a6dd88bada4e7d2;
$885928e6e4d4152b$export$fa0831f497706bad = `Zm2fMa_logs`;
$885928e6e4d4152b$export$bfd64c937657f93a = `Zm2fMa_rotating`;
$885928e6e4d4152b$export$4a6dd88bada4e7d2 = `Zm2fMa_shimmer`;


function $ca1829f02fb6ab2d$var$MachineLogs({ applicationId: applicationId }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $85bd40f9f49866bd$export$2e2bcd8739ae039), {
        applicationId: applicationId,
        className: $885928e6e4d4152b$export$fa0831f497706bad
    });
}
var $ca1829f02fb6ab2d$export$2e2bcd8739ae039 = $ca1829f02fb6ab2d$var$MachineLogs;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");
var $61Yml = parcelRequire("61Yml");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $voszV = parcelRequire("voszV");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $8ab60efc5360b57c$var$SvgM2MRoleDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 40,
                height: 40,
                rx: 8,
                fill: "#F7F8F8",
                fillOpacity: 0.12
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 19.792,
                cy: 13.5,
                r: 6.5,
                fill: "url(#paint0_linear_8921_102395)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 12.194,
                y: 11.889,
                width: 8.778,
                height: 1.097,
                rx: 0.549,
                fill: "#2D2C61"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 23.167,
                y: 11.889,
                width: 4.389,
                height: 1.097,
                rx: 0.549,
                fill: "#2D2C61"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M10 28.584A6.583 6.583 0 0 1 16.584 22h6.832A6.583 6.583 0 0 1 30 28.584v2.221A2.194 2.194 0 0 1 27.805 33h-15.61A2.194 2.194 0 0 1 10 30.805v-2.221Z",
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M21 26.556c0-.86.696-1.556 1.556-1.556h10.888c.86 0 1.556.696 1.556 1.556v7.777c0 .86-.696 1.556-1.556 1.556H22.556c-.86 0-1.556-.697-1.556-1.556v-7.777Z",
                fill: "url(#paint1_linear_8921_102395)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#947DFF",
                d: "M21 28.111h14v.778H21z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M28.778 26.945c0-.215.174-.39.389-.39h3.889a.389.389 0 1 1 0 .778h-3.89a.389.389 0 0 1-.388-.388Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 22.556,
                y: 26.556,
                width: 0.778,
                height: 0.778,
                rx: 0.389,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M28.778 30.833c0-.215.174-.389.389-.389h3.889a.389.389 0 1 1 0 .778h-3.89a.389.389 0 0 1-.388-.389Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 22.556,
                y: 30.444,
                width: 0.778,
                height: 0.778,
                rx: 0.389,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 24.111,
                y: 30.444,
                width: 0.778,
                height: 0.778,
                rx: 0.389,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M28.778 34.723c0-.215.174-.389.389-.389h3.888a.389.389 0 0 1 0 .778h-3.889a.389.389 0 0 1-.388-.39Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 22.555,
                y: 34.334,
                width: 0.778,
                height: 0.778,
                rx: 0.389,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 24.111,
                y: 34.334,
                width: 0.778,
                height: 0.778,
                rx: 0.389,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#947DFF",
                d: "M21 32h14v.778H21z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_8921_102395",
                        x1: 15.526,
                        y1: 18.24,
                        x2: 24.261,
                        y2: 8.896,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF88FA"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_8921_102395",
                        x1: 19.85,
                        y1: 31.238,
                        x2: 33.727,
                        y2: 24.651,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $8ab60efc5360b57c$export$2e2bcd8739ae039 = $8ab60efc5360b57c$var$SvgM2MRoleDark;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $6d851c22506b0fe9$var$SvgM2MRole = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 40,
                height: 40,
                rx: 8,
                fill: "#F3EFFA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 19.792,
                cy: 13.5,
                r: 6.5,
                fill: "url(#paint0_linear_8921_102314)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 12.194,
                y: 11.889,
                width: 8.778,
                height: 1.097,
                rx: 0.549,
                fill: "#2D2C61"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 23.167,
                y: 11.889,
                width: 4.389,
                height: 1.097,
                rx: 0.549,
                fill: "#2D2C61"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M10 28.584A6.583 6.583 0 0 1 16.584 22h6.832A6.583 6.583 0 0 1 30 28.584v2.221A2.194 2.194 0 0 1 27.805 33h-15.61A2.194 2.194 0 0 1 10 30.805v-2.221Z",
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M21 26.556c0-.86.696-1.556 1.556-1.556h10.888c.86 0 1.556.696 1.556 1.556v7.777c0 .86-.696 1.556-1.556 1.556H22.556c-.86 0-1.556-.697-1.556-1.556v-7.777Z",
                fill: "url(#paint1_linear_8921_102314)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#947DFF",
                d: "M21 28.111h14v.778H21z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M28.778 26.945c0-.215.174-.39.389-.39h3.889a.389.389 0 1 1 0 .778h-3.89a.389.389 0 0 1-.388-.388Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 22.556,
                y: 26.556,
                width: 0.778,
                height: 0.778,
                rx: 0.389,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M28.778 30.833c0-.215.174-.389.389-.389h3.889a.389.389 0 1 1 0 .778h-3.89a.389.389 0 0 1-.388-.389Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 22.556,
                y: 30.444,
                width: 0.778,
                height: 0.778,
                rx: 0.389,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 24.111,
                y: 30.444,
                width: 0.778,
                height: 0.778,
                rx: 0.389,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M28.778 34.723c0-.215.174-.389.389-.389h3.889a.389.389 0 0 1 0 .778h-3.889a.389.389 0 0 1-.389-.39Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 22.556,
                y: 34.334,
                width: 0.778,
                height: 0.778,
                rx: 0.389,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 24.112,
                y: 34.334,
                width: 0.778,
                height: 0.778,
                rx: 0.389,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#947DFF",
                d: "M21 32h14v.778H21z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_8921_102314",
                        x1: 15.526,
                        y1: 18.24,
                        x2: 24.261,
                        y2: 8.896,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF88FA"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_8921_102314",
                        x1: 19.85,
                        y1: 31.238,
                        x2: 33.727,
                        y2: 24.651,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $6d851c22506b0fe9$export$2e2bcd8739ae039 = $6d851c22506b0fe9$var$SvgM2MRole;







var $8Mb3E = parcelRequire("8Mb3E");

var $jGWQ4 = parcelRequire("jGWQ4");

var $dL4NZ = parcelRequire("dL4NZ");

var $75SRw = parcelRequire("75SRw");


parcelRequire("fIF1D");
var $16GE9 = parcelRequire("16GE9");

var $7VnwS = parcelRequire("7VnwS");


var $jheqv = parcelRequire("jheqv");

var $7kooT = parcelRequire("7kooT");
var $4d0f121b63eddd84$export$6d59db4903f20f7d;
var $4d0f121b63eddd84$export$3dea766d36a8935f;
var $4d0f121b63eddd84$export$1ca1ec8b29a4ce27;
var $4d0f121b63eddd84$export$2e4d17fb8dfe5f16;
var $4d0f121b63eddd84$export$bfd64c937657f93a;
var $4d0f121b63eddd84$export$4a6dd88bada4e7d2;
$4d0f121b63eddd84$export$6d59db4903f20f7d = `MrHGWq_description`;
$4d0f121b63eddd84$export$3dea766d36a8935f = `MrHGWq_filter`;
$4d0f121b63eddd84$export$1ca1ec8b29a4ce27 = `MrHGWq_icon`;
$4d0f121b63eddd84$export$2e4d17fb8dfe5f16 = `MrHGWq_rolesTable`;
$4d0f121b63eddd84$export$bfd64c937657f93a = `MrHGWq_rotating`;
$4d0f121b63eddd84$export$4a6dd88bada4e7d2 = `MrHGWq_shimmer`;


const $550b7407811eb1a6$var$pageSize = (0, $8Mb3E.defaultPageSize);
function $550b7407811eb1a6$var$MachineToMachineApplicationRoles({ application: application }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const theme = (0, $jheqv.default)();
    const [{ page: page, keyword: keyword }, updateSearchParameters] = (0, $66a3eb3654f9d141$export$2e2bcd8739ae039)({
        page: 1,
        keyword: ""
    });
    const { data: data, error: error, mutate: mutate } = (0, $voszV.default)((0, $7kooT.buildUrl)(`api/applications/${application.id}/roles`, {
        page: String(page),
        page_size: String($550b7407811eb1a6$var$pageSize),
        ...(0, $7oDSS.conditional)(keyword && {
            search: (0, $7kooT.formatSearchKeyword)(keyword)
        })
    }));
    const isLoading = !data && !error;
    const [roles, totalCount] = data ?? [];
    const [isAssignRolesModalOpen, setIsAssignRolesModalOpen] = (0, $jC8Vy.useState)(false);
    const [roleToBeDeleted, setRoleToBeDeleted] = (0, $jC8Vy.useState)();
    const [isDeleting, setIsDeleting] = (0, $jC8Vy.useState)(false);
    const api = (0, $7VnwS.default)();
    const handleDelete = async ()=>{
        if (!roleToBeDeleted || isDeleting) return;
        setIsDeleting(true);
        try {
            await api.delete(`api/applications/${application.id}/roles/${roleToBeDeleted.id}`);
            (0, $FuhPC.toast).success(t("application_details.roles.deleted", {
                name: roleToBeDeleted.name
            }));
            await mutate();
            setRoleToBeDeleted(undefined);
        } finally{
            setIsDeleting(false);
        }
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3166f28a681c41bb$export$2e2bcd8739ae039), {
                className: $4d0f121b63eddd84$export$2e4d17fb8dfe5f16,
                isLoading: isLoading,
                rowGroups: [
                    {
                        key: "roles",
                        data: roles
                    }
                ],
                rowIndexKey: "id",
                columns: [
                    {
                        title: t("application_details.roles.name_column"),
                        dataIndex: "name",
                        colSpan: 6,
                        render: ({ id: id, name: name })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $4d952cae22cb03fc$export$2e2bcd8739ae039), {
                                title: name,
                                to: `/roles/${id}`,
                                icon: theme === (0, $5HVJe.Theme).Dark ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8ab60efc5360b57c$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6d851c22506b0fe9$export$2e2bcd8739ae039), {})
                            })
                    },
                    {
                        title: t("application_details.roles.description_column"),
                        dataIndex: "description",
                        colSpan: 9,
                        render: ({ description: description })=>/*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $4d0f121b63eddd84$export$6d59db4903f20f7d,
                                children: description
                            })
                    },
                    {
                        title: null,
                        dataIndex: "delete",
                        colSpan: 1,
                        render: (role)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $16GE9.default), {
                                content: t("general.remove"),
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                                    onClick: ()=>{
                                        setRoleToBeDeleted(role);
                                    },
                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3aa588de5c8665f2$export$2e2bcd8739ae039), {})
                                })
                            })
                    }
                ],
                filter: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: $4d0f121b63eddd84$export$3dea766d36a8935f,
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $46c375e0973aedf1$export$2e2bcd8739ae039), {
                            defaultValue: keyword,
                            isClearable: Boolean(keyword),
                            placeholder: t("application_details.roles.search"),
                            onSearch: (keyword)=>{
                                updateSearchParameters({
                                    keyword: keyword,
                                    page: 1
                                });
                            },
                            onClearSearch: ()=>{
                                updateSearchParameters({
                                    keyword: "",
                                    page: 1
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                            title: "application_details.roles.assign_button",
                            type: "primary",
                            size: "large",
                            icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0b30fe81c923292b$export$2e2bcd8739ae039), {}),
                            onClick: ()=>{
                                setIsAssignRolesModalOpen(true);
                            }
                        })
                    ]
                }),
                pagination: {
                    page: page,
                    pageSize: $550b7407811eb1a6$var$pageSize,
                    totalCount: totalCount,
                    onChange: (page)=>{
                        updateSearchParameters({
                            page: page
                        });
                    }
                },
                placeholder: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a0f84bc7cc69e410$export$2e2bcd8739ae039), {}),
                errorMessage: error?.body?.message ?? error?.message,
                onRetry: async ()=>mutate(undefined, true)
            }),
            roleToBeDeleted && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dL4NZ.default), {
                isOpen: true,
                isLoading: isDeleting,
                confirmButtonText: "general.remove",
                onCancel: ()=>{
                    setRoleToBeDeleted(undefined);
                },
                onConfirm: handleDelete,
                children: t("application_details.roles.delete_description")
            }),
            isAssignRolesModalOpen && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5980bec6c22435f4$export$2e2bcd8739ae039), {
                entity: application,
                type: (0, $61Yml.RoleType).MachineToMachine,
                onClose: (success)=>{
                    if (success) mutate();
                    setIsAssignRolesModalOpen(false);
                }
            })
        ]
    });
}
var $550b7407811eb1a6$export$2e2bcd8739ae039 = $550b7407811eb1a6$var$MachineToMachineApplicationRoles;



var $C7mD2 = parcelRequire("C7mD2");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $fGvTA = parcelRequire("fGvTA");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $voszV = parcelRequire("voszV");


var $C7mD2 = parcelRequire("C7mD2");
var $ca5227d3f64e4a49$export$743d887d09c13b13;
$ca5227d3f64e4a49$export$743d887d09c13b13 = `wAHLyq_breakable`;


/**
 * A component that can be used to render text that can be broken into multiple lines. It
 * wraps the children with a div and applies `word-break: break-word` and
 * `overflow-wrap: break-word` to it.
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/CSS/word-break | word-break in MDN}
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/CSS/overflow-wrap | overflow-wrap in MDN}
 */ function $e52124c5a4489a19$var$Breakable({ children: children }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: $ca5227d3f64e4a49$export$743d887d09c13b13,
        children: children
    });
}
var $e52124c5a4489a19$export$2e2bcd8739ae039 = $e52124c5a4489a19$var$Breakable;




var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $kezPv = parcelRequire("kezPv");


var $jGWQ4 = parcelRequire("jGWQ4");

var $66ixW = parcelRequire("66ixW");

var $d37cb07bcd3e7458$export$ae5f3242c350d062;
var $d37cb07bcd3e7458$export$6e22c362a0406a2c;
var $d37cb07bcd3e7458$export$bfd64c937657f93a;
var $d37cb07bcd3e7458$export$fe2e36411d703b3d;
var $d37cb07bcd3e7458$export$4a6dd88bada4e7d2;
var $d37cb07bcd3e7458$export$641374ffb95bc399;
var $d37cb07bcd3e7458$export$fb184b623420d9be;
$d37cb07bcd3e7458$export$ae5f3242c350d062 = `yG5A-W_addAnother`;
$d37cb07bcd3e7458$export$6e22c362a0406a2c = `yG5A-W_empty`;
$d37cb07bcd3e7458$export$bfd64c937657f93a = `yG5A-W_rotating`;
$d37cb07bcd3e7458$export$fe2e36411d703b3d = `yG5A-W_section`;
$d37cb07bcd3e7458$export$4a6dd88bada4e7d2 = `yG5A-W_shimmer`;
$d37cb07bcd3e7458$export$641374ffb95bc399 = `yG5A-W_spinner`;
$d37cb07bcd3e7458$export$fb184b623420d9be = `yG5A-W_title`;


const $361879821187d718$var$pageSize = 10;
/**
 * The table component for organization template editing, such as permissions and roles.
 * If `onAdd` is provided, an add button will be rendered in the bottom.
 */ function $361879821187d718$var$TemplateTable({ name: name, className: className, rowIndexKey: rowIndexKey, rowGroups: rowGroups, columns: columns, pagination: pagination, isLoading: isLoading, onAdd: onAdd, errorMessage: errorMessage }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    // If there is no data for all row groups, we will render an empty state with an add button.
    const noData = !isLoading && !rowGroups.some(({ data: data })=>data && data.length > 0);
    const tablePagination = (0, $jC8Vy.useMemo)(()=>pagination && {
            ...pagination,
            pageSize: $361879821187d718$var$pageSize
        }, [
        pagination
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("section", {
        className: $d37cb07bcd3e7458$export$fe2e36411d703b3d,
        children: [
            name && /*#__PURE__*/ (0, $C7mD2.jsx)("header", {
                className: $d37cb07bcd3e7458$export$fb184b623420d9be,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                    forKey: name,
                    interpolation: {
                        count: 2
                    }
                })
            }),
            onAdd && noData && !errorMessage && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    name && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $d37cb07bcd3e7458$export$6e22c362a0406a2c,
                        children: t("organizations.empty_placeholder", {
                            entity: String(t(name)).toLowerCase()
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0b30fe81c923292b$export$2e2bcd8739ae039), {}),
                        title: "general.add",
                        onClick: onAdd
                    })
                ]
            }),
            noData && errorMessage && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $d37cb07bcd3e7458$export$6e22c362a0406a2c,
                children: errorMessage
            }),
            !noData && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3166f28a681c41bb$export$2e2bcd8739ae039), {
                hasBorder: true,
                isRowHoverEffectDisabled: true,
                className: className,
                isLoading: isLoading,
                rowGroups: rowGroups,
                columns: columns,
                rowIndexKey: rowIndexKey,
                pagination: tablePagination,
                footer: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                    size: "small",
                    type: "text",
                    className: $d37cb07bcd3e7458$export$ae5f3242c350d062,
                    icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $kezPv.default), {}),
                    title: "general.add_another",
                    onClick: onAdd
                })
            })
        ]
    });
}
var $361879821187d718$export$2e2bcd8739ae039 = $361879821187d718$var$TemplateTable;


parcelRequire("8Mb3E");
var $cfL6o = parcelRequire("cfL6o");



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $fGvTA = parcelRequire("fGvTA");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $dL4NZ = parcelRequire("dL4NZ");

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $aqmjm = parcelRequire("aqmjm");


var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");



var $fmHmG = parcelRequire("fmHmG");


var $C7mD2 = parcelRequire("C7mD2");


var $bnkR4 = parcelRequire("bnkR4");
var $ac44abca4c783e83$export$d45376104c4ecf1a;
var $ac44abca4c783e83$export$1ca1ec8b29a4ce27;
var $ac44abca4c783e83$export$a8ff84c12d48cfa6;
var $ac44abca4c783e83$export$bfd64c937657f93a;
var $ac44abca4c783e83$export$4a6dd88bada4e7d2;
$ac44abca4c783e83$export$d45376104c4ecf1a = `tgjteG_dataItem`;
$ac44abca4c783e83$export$1ca1ec8b29a4ce27 = `tgjteG_icon`;
$ac44abca4c783e83$export$a8ff84c12d48cfa6 = `tgjteG_name`;
$ac44abca4c783e83$export$bfd64c937657f93a = `tgjteG_rotating`;
$ac44abca4c783e83$export$4a6dd88bada4e7d2 = `tgjteG_shimmer`;


function $498939343abdc94a$var$SourceDataItem({ data: data, isSelected: isSelected, onSelect: onSelect }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $ac44abca4c783e83$export$d45376104c4ecf1a,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $26dc4ab718ba37b7$export$2e2bcd8739ae039), {
                checked: isSelected,
                onChange: ()=>{
                    onSelect(data);
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $ac44abca4c783e83$export$a8ff84c12d48cfa6,
                role: "button",
                tabIndex: 0,
                onKeyDown: (0, $bnkR4.onKeyDownHandler)(()=>{
                    onSelect(data);
                }),
                onClick: ()=>{
                    onSelect(data);
                },
                children: data.name
            })
        ]
    });
}
var $498939343abdc94a$export$2e2bcd8739ae039 = $498939343abdc94a$var$SourceDataItem;



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $442b31b4cd054ae7$var$SvgCaretExpanded = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "m10.592 12.358 3.533-3.533a.833.833 0 1 0-1.175-1.183L10 10.592l-2.95-2.95a.833.833 0 0 0-1.355.271.833.833 0 0 0-.062.32.833.833 0 0 0 .242.592l3.533 3.533a.833.833 0 0 0 1.184 0Z",
            fill: "currentColor"
        })
    });
var $442b31b4cd054ae7$export$2e2bcd8739ae039 = $442b31b4cd054ae7$var$SvgCaretExpanded;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $8190cd3bb8bc1e74$var$SvgCaretFolded = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M12.358 9.408 8.825 5.875A.833.833 0 1 0 7.642 7.05l2.95 2.95-2.95 2.95a.833.833 0 0 0 .271 1.355c.102.041.21.062.32.062a.833.833 0 0 0 .592-.242l3.533-3.533a.834.834 0 0 0 0-1.184Z",
            fill: "currentColor"
        })
    });
var $8190cd3bb8bc1e74$export$2e2bcd8739ae039 = $8190cd3bb8bc1e74$var$SvgCaretFolded;




var $75SRw = parcelRequire("75SRw");

var $bnkR4 = parcelRequire("bnkR4");

var $14dcc572b1ae02c8$export$e88cb2efb12ae807;
var $14dcc572b1ae02c8$export$b80af9aaedbd9198;
var $14dcc572b1ae02c8$export$7989a97017158b33;
var $14dcc572b1ae02c8$export$e5e25fbcc1f7affe;
var $14dcc572b1ae02c8$export$327035af44b99d88;
var $14dcc572b1ae02c8$export$c99df9cf5e6bee9b;
var $14dcc572b1ae02c8$export$a8ff84c12d48cfa6;
var $14dcc572b1ae02c8$export$bfd64c937657f93a;
var $14dcc572b1ae02c8$export$4a6dd88bada4e7d2;
var $14dcc572b1ae02c8$export$fb184b623420d9be;
$14dcc572b1ae02c8$export$e88cb2efb12ae807 = `lfCsgq_caret`;
$14dcc572b1ae02c8$export$b80af9aaedbd9198 = `lfCsgq_dataInfo`;
$14dcc572b1ae02c8$export$7989a97017158b33 = `lfCsgq_dataList`;
$14dcc572b1ae02c8$export$e5e25fbcc1f7affe = `lfCsgq_group`;
$14dcc572b1ae02c8$export$327035af44b99d88 = `lfCsgq_groupItem`;
$14dcc572b1ae02c8$export$c99df9cf5e6bee9b = `lfCsgq_invisible`;
$14dcc572b1ae02c8$export$a8ff84c12d48cfa6 = `lfCsgq_name`;
$14dcc572b1ae02c8$export$bfd64c937657f93a = `lfCsgq_rotating`;
$14dcc572b1ae02c8$export$4a6dd88bada4e7d2 = `lfCsgq_shimmer`;
$14dcc572b1ae02c8$export$fb184b623420d9be = `lfCsgq_title`;


/**
 * SourceGroupItem is a component that renders a group of data in the source panel.
 *
 * e.g. API resource scopes grouped under the same API resource.
 *
 * @param dataGroup - The data group to be rendered. e.g. resource with scopes
 * @param selectedGroupDataList - The list of selected data in the group.
 * @param onSelectDataGroup - The callback function to select the whole group.
 * @param onSelectData - The callback function to select a single data within the group.
 */ function $bc1b92a472527bf2$var$SourceGroupItem({ dataGroup: dataGroup, selectedGroupDataList: selectedGroupDataList, onSelectDataGroup: onSelectDataGroup, onSelectData: onSelectData }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { groupName: groupName, groupId: groupId, dataList: dataList } = dataGroup;
    const selectedDataIdSet = new Set(selectedGroupDataList.map(({ id: id })=>id));
    const selectedCount = selectedDataIdSet.size;
    const totalCount = dataList.length;
    const [isDataListHidden, setIsDataListHidden] = (0, $jC8Vy.useState)(true);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $14dcc572b1ae02c8$export$327035af44b99d88,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $14dcc572b1ae02c8$export$fb184b623420d9be,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $26dc4ab718ba37b7$export$2e2bcd8739ae039), {
                        checked: selectedCount === totalCount,
                        indeterminate: selectedCount > 0 && selectedCount < totalCount,
                        onChange: ()=>{
                            onSelectDataGroup(dataGroup);
                        }
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        role: "button",
                        tabIndex: 0,
                        className: $14dcc572b1ae02c8$export$e5e25fbcc1f7affe,
                        onKeyDown: (0, $bnkR4.onKeyDownHandler)(()=>{
                            setIsDataListHidden(!isDataListHidden);
                        }),
                        onClick: ()=>{
                            setIsDataListHidden(!isDataListHidden);
                        },
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                                size: "medium",
                                className: $14dcc572b1ae02c8$export$e88cb2efb12ae807,
                                children: isDataListHidden ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8190cd3bb8bc1e74$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $442b31b4cd054ae7$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $14dcc572b1ae02c8$export$a8ff84c12d48cfa6,
                                children: groupName
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                className: $14dcc572b1ae02c8$export$b80af9aaedbd9198,
                                children: [
                                    "(",
                                    t("role_details.permission.api_permission_count", {
                                        count: dataList.length
                                    }),
                                    ")"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))(isDataListHidden && $14dcc572b1ae02c8$export$c99df9cf5e6bee9b, $14dcc572b1ae02c8$export$7989a97017158b33),
                children: dataList.map((data)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $498939343abdc94a$export$2e2bcd8739ae039), {
                        data: data,
                        isSelected: selectedDataIdSet.has(data.id),
                        onSelect: ()=>{
                            onSelectData({
                                ...data,
                                groupName: groupName,
                                groupId: groupId
                            });
                        }
                    }, data.id))
            })
        ]
    });
}
var $bc1b92a472527bf2$export$2e2bcd8739ae039 = $bc1b92a472527bf2$var$SourceGroupItem;


var $c0db89f6a2b6b16f$export$1ca1ec8b29a4ce27;
var $c0db89f6a2b6b16f$export$bfd64c937657f93a;
var $c0db89f6a2b6b16f$export$d76128d007d19019;
var $c0db89f6a2b6b16f$export$4a6dd88bada4e7d2;
$c0db89f6a2b6b16f$export$1ca1ec8b29a4ce27 = `bmBJea_icon`;
$c0db89f6a2b6b16f$export$bfd64c937657f93a = `bmBJea_rotating`;
$c0db89f6a2b6b16f$export$d76128d007d19019 = `bmBJea_search`;
$c0db89f6a2b6b16f$export$4a6dd88bada4e7d2 = `bmBJea_shimmer`;


const $de4ea1e18a03d446$var$appendUnique = (list, items)=>{
    const newEntries = Array.isArray(items) ? items : [
        items
    ];
    return [
        ...list,
        ...newEntries.filter((item)=>list.every(({ id: id })=>id !== item.id))
    ];
};
function $de4ea1e18a03d446$var$SourcePanel({ selectedData: selectedData, setSelectedData: setSelectedData, availableDataList: availableDataList, availableDataGroups: availableDataGroups }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    // Keyword search
    const [keyword, setKeyword] = (0, $jC8Vy.useState)("");
    const handleSearchInput = (0, $jC8Vy.useCallback)((event)=>{
        setKeyword(event.target.value);
    }, []);
    const isDataEntrySelected = (0, $jC8Vy.useCallback)((data)=>selectedData.findIndex(({ id: id })=>id === data.id) >= 0, [
        selectedData
    ]);
    // Get all the selected data by group
    const getSelectedDataInGroup = (0, $jC8Vy.useCallback)(({ dataList: dataList })=>selectedData.filter(({ id: id })=>dataList.some((data)=>data.id === id)), [
        selectedData
    ]);
    // Toggle the data Entry selection status
    const onSelectData = (0, $jC8Vy.useCallback)((data)=>{
        if (isDataEntrySelected(data)) {
            setSelectedData(selectedData.filter(({ id: id })=>id !== data.id));
            return;
        }
        setSelectedData($de4ea1e18a03d446$var$appendUnique(selectedData, data));
    }, [
        isDataEntrySelected,
        selectedData,
        setSelectedData
    ]);
    // Toggle the data group selection status
    const onSelectDataGroup = (0, $jC8Vy.useCallback)(({ groupName: groupName, groupId: groupId, dataList: dataList })=>{
        const isAllSelected = dataList.every((data)=>isDataEntrySelected(data));
        // If all the data entities in the group are selected, remove them from the selected data list
        if (isAllSelected) {
            setSelectedData(selectedData.filter(({ id: selectedDataId })=>!dataList.some(({ id: groupDataId })=>groupDataId === selectedDataId)));
            return;
        }
        // Add all the data entities in the group to the selected data list
        setSelectedData($de4ea1e18a03d446$var$appendUnique(selectedData, dataList.map((data)=>({
                ...data,
                groupName: groupName,
                groupId: groupId
            }))));
    }, [
        isDataEntrySelected,
        selectedData,
        setSelectedData
    ]);
    // Get the keyword filtered available dataList
    const filteredAvailableDataList = (0, $jC8Vy.useMemo)(()=>{
        if (!availableDataList) return;
        const lowerCasedKeyword = keyword.toLowerCase();
        if (!lowerCasedKeyword) return availableDataList;
        return availableDataList.filter(({ name: name })=>name.toLowerCase().includes(lowerCasedKeyword));
    }, [
        availableDataList,
        keyword
    ]);
    // Get the keyword filtered available dataGroups
    const filteredAvailableDataGroups = (0, $jC8Vy.useMemo)(()=>{
        if (!availableDataGroups) return;
        const lowerCasedKeyword = keyword.toLowerCase();
        if (!lowerCasedKeyword) return availableDataGroups;
        return availableDataGroups.map((dataGroup)=>{
            // If the group name matches the keyword, return all the data in the group
            if (dataGroup.groupName.toLowerCase().includes(lowerCasedKeyword)) return dataGroup;
            // If the group name doesn't match the keyword, return the dataEntry name filtered dataList
            return {
                ...dataGroup,
                dataList: dataGroup.dataList.filter(({ name: name })=>lowerCasedKeyword ? name.toLowerCase().includes(lowerCasedKeyword) : true)
            };
        })// Filter out the dataGroups if the group name doesn't match the keyword and none of the dataEntry name matches the keyword
        .filter((dataGroup)=>dataGroup.groupName.toLowerCase().includes(lowerCasedKeyword) || dataGroup.dataList.length > 0);
    }, [
        availableDataGroups,
        keyword
    ]);
    const isEmpty = !filteredAvailableDataList?.length && !filteredAvailableDataGroups?.length;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $1c26dd25fa3ad36d$export$827f4ee28efc37,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $1c26dd25fa3ad36d$export$9f6c77b8cdee9051,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                    className: $c0db89f6a2b6b16f$export$d76128d007d19019,
                    icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $45ba7f7cad465e3f$export$2e2bcd8739ae039), {
                        className: $c0db89f6a2b6b16f$export$1ca1ec8b29a4ce27
                    }),
                    placeholder: t("general.search_placeholder"),
                    onChange: handleSearchInput
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($1c26dd25fa3ad36d$export$a03f626b8106969c, isEmpty && $1c26dd25fa3ad36d$export$2d49e08edfff676e),
                children: isEmpty ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a0f84bc7cc69e410$export$2e2bcd8739ae039), {
                    size: "small",
                    title: t("role_details.permission.empty")
                }) : /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                    children: [
                        filteredAvailableDataGroups?.map((dataGroup)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $bc1b92a472527bf2$export$2e2bcd8739ae039), {
                                dataGroup: dataGroup,
                                selectedGroupDataList: getSelectedDataInGroup(dataGroup),
                                onSelectData: onSelectData,
                                onSelectDataGroup: onSelectDataGroup
                            }, dataGroup.groupId)),
                        filteredAvailableDataList?.map((data)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $498939343abdc94a$export$2e2bcd8739ae039), {
                                data: data,
                                isSelected: isDataEntrySelected(data),
                                onSelect: onSelectData
                            }, data.id))
                    ]
                })
            })
        ]
    });
}
var $de4ea1e18a03d446$export$2e2bcd8739ae039 = $de4ea1e18a03d446$var$SourcePanel;



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");


var $C7mD2 = parcelRequire("C7mD2");

var $HHYyb = parcelRequire("HHYyb");

var $75SRw = parcelRequire("75SRw");
var $b088aa3df35a17e6$export$f1f4ce1df2235f79;
var $b088aa3df35a17e6$export$a8ff84c12d48cfa6;
var $b088aa3df35a17e6$export$bfd64c937657f93a;
var $b088aa3df35a17e6$export$4a6dd88bada4e7d2;
var $b088aa3df35a17e6$export$f8ccffd2b537ed55;
var $b088aa3df35a17e6$export$fb184b623420d9be;
$b088aa3df35a17e6$export$f1f4ce1df2235f79 = `qz7dNW_groupName`;
$b088aa3df35a17e6$export$a8ff84c12d48cfa6 = `qz7dNW_name`;
$b088aa3df35a17e6$export$bfd64c937657f93a = `qz7dNW_rotating`;
$b088aa3df35a17e6$export$4a6dd88bada4e7d2 = `qz7dNW_shimmer`;
$b088aa3df35a17e6$export$f8ccffd2b537ed55 = `qz7dNW_targetDataItem`;
$b088aa3df35a17e6$export$fb184b623420d9be = `qz7dNW_title`;


function $4a012657c29effeb$var$TargetDataItem({ data: data, onDelete: onDelete }) {
    const { name: name } = data;
    const groupName = "groupName" in data ? data.groupName : undefined;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $b088aa3df35a17e6$export$f8ccffd2b537ed55,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $b088aa3df35a17e6$export$fb184b623420d9be,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $b088aa3df35a17e6$export$a8ff84c12d48cfa6,
                        children: name
                    }),
                    groupName && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $b088aa3df35a17e6$export$f1f4ce1df2235f79,
                        children: groupName
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                size: "small",
                onClick: ()=>{
                    onDelete(data);
                },
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $HHYyb.default), {})
            })
        ]
    });
}
var $4a012657c29effeb$export$2e2bcd8739ae039 = $4a012657c29effeb$var$TargetDataItem;


var $82ec74c8cd481411$export$80f73db1a407fae0;
$82ec74c8cd481411$export$80f73db1a407fae0 = `nPWvea_added`;


function $f326e1c1002f6f0d$var$TargetPanel({ selectedData: selectedData, setSelectedData: setSelectedData }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const onDelete = (0, $jC8Vy.useCallback)(({ id: id })=>{
        setSelectedData(selectedData.filter(({ id: selectedDataId })=>selectedDataId !== id));
    }, [
        selectedData,
        setSelectedData
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $1c26dd25fa3ad36d$export$827f4ee28efc37,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $1c26dd25fa3ad36d$export$9f6c77b8cdee9051,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                    className: $82ec74c8cd481411$export$80f73db1a407fae0,
                    children: t("role_details.permission.added_text", {
                        count: selectedData.length
                    })
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $1c26dd25fa3ad36d$export$a03f626b8106969c,
                children: selectedData.map((data)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $4a012657c29effeb$export$2e2bcd8739ae039), {
                        data: data,
                        onDelete: onDelete
                    }, data.id))
            })
        ]
    });
}
var $f326e1c1002f6f0d$export$2e2bcd8739ae039 = $f326e1c1002f6f0d$var$TargetPanel;


var $f7ad03bb7f18a93b$export$b52a7ba8678e6932;
$f7ad03bb7f18a93b$export$b52a7ba8678e6932 = `EUu5oq_dataTransferBox`;


function $e2d629f863c762e5$var$DataTransferBox({ title: title, selectedData: selectedData, setSelectedData: setSelectedData, availableDataList: availableDataList, availableDataGroups: availableDataGroups, className: className, containerClassName: containerClassName }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
        title: title,
        className: className,
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($1c26dd25fa3ad36d$export$34e0f9847d4c02dd, $f7ad03bb7f18a93b$export$b52a7ba8678e6932, containerClassName),
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $de4ea1e18a03d446$export$2e2bcd8739ae039), {
                    selectedData: selectedData,
                    setSelectedData: setSelectedData,
                    availableDataList: availableDataList,
                    availableDataGroups: availableDataGroups
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $1c26dd25fa3ad36d$export$d999e528e771887b
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f326e1c1002f6f0d$export$2e2bcd8739ae039), {
                    selectedData: selectedData,
                    setSelectedData: setSelectedData
                })
            ]
        })
    });
}
var $e2d629f863c762e5$export$2e2bcd8739ae039 = $e2d629f863c762e5$var$DataTransferBox;




parcelRequire("cuPVN");
var $fGvTA = parcelRequire("fGvTA");
const $50cd528a8d31231f$export$823e51caa075f844 = Object.freeze({
    [(0, $fGvTA.ApplicationUserConsentScopeType).UserScopes]: {
        title: "application_details.permissions.user_profile",
        key: (0, $fGvTA.ApplicationUserConsentScopeType).UserScopes
    },
    [(0, $fGvTA.ApplicationUserConsentScopeType).ResourceScopes]: {
        title: "application_details.permissions.api_permissions",
        key: (0, $fGvTA.ApplicationUserConsentScopeType).ResourceScopes
    }
});
const $50cd528a8d31231f$export$c82be7b8c88fba4f = Object.freeze({
    [(0, $fGvTA.ApplicationUserConsentScopeType).OrganizationScopes]: {
        title: "application_details.permissions.organization",
        key: (0, $fGvTA.ApplicationUserConsentScopeType).OrganizationScopes
    },
    [(0, $fGvTA.ApplicationUserConsentScopeType).OrganizationResourceScopes]: {
        title: "application_details.permissions.api_permissions",
        key: (0, $fGvTA.ApplicationUserConsentScopeType).OrganizationResourceScopes
    }
});


var $7a0395d9de438311$export$bf9d7c4801670108;
(function(ScopeLevel) {
    ScopeLevel["User"] = "user";
    ScopeLevel["Organization"] = "organization";
})($7a0395d9de438311$export$bf9d7c4801670108 || ($7a0395d9de438311$export$bf9d7c4801670108 = {}));


parcelRequire("cuPVN");
var $fGvTA = parcelRequire("fGvTA");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");

var $voszV = parcelRequire("voszV");

var $7VnwS = parcelRequire("7VnwS");

parcelRequire("cuPVN");
var $fGvTA = parcelRequire("fGvTA");

var $jC8Vy = parcelRequire("jC8Vy");

var $voszV = parcelRequire("voszV");
const $154a45af16369a41$var$useOrganizationScopesAssignment = (assignedOrganizationScopes = [])=>{
    const [selectedData, setSelectedData] = (0, $jC8Vy.useState)([]);
    const { data: organizationScopes } = (0, $voszV.default)("api/organization-scopes");
    const availableDataList = (0, $jC8Vy.useMemo)(()=>(organizationScopes ?? []).filter(({ id: id })=>!assignedOrganizationScopes.some((scope)=>scope.id === id)), [
        organizationScopes,
        assignedOrganizationScopes
    ]);
    return {
        scopeType: (0, $fGvTA.ApplicationUserConsentScopeType).OrganizationScopes,
        selectedData: selectedData,
        setSelectedData: setSelectedData,
        availableDataList: availableDataList,
        title: "application_details.permissions.organization_permissions_assignment_form_title"
    };
};
var $154a45af16369a41$export$2e2bcd8739ae039 = $154a45af16369a41$var$useOrganizationScopesAssignment;


parcelRequire("cuPVN");
var $9XFlr = parcelRequire("9XFlr");
var $fGvTA = parcelRequire("fGvTA");

var $jC8Vy = parcelRequire("jC8Vy");

var $voszV = parcelRequire("voszV");

var $7kooT = parcelRequire("7kooT");
const $55f5c59d5553746e$var$useResourceScopesAssignment = (assignedResourceScopes, options)=>{
    const [selectedData, setSelectedData] = (0, $jC8Vy.useState)([]);
    const { isForOrganization: isForOrganization } = options ?? {};
    const { data: allResources } = (0, $voszV.default)((0, $7kooT.buildUrl)("api/resources", {
        includeScopes: String(true)
    }));
    const availableDataGroups = (0, $jC8Vy.useMemo)(()=>{
        if (!allResources) return [];
        const resourcesWithScopes = allResources// Filter out the management APIs
        .filter((resource)=>!(0, $9XFlr.isManagementApi)(resource.indicator)).map(({ name: name, scopes: scopes, id: id })=>{
            const assignedResource = assignedResourceScopes?.find(({ resource: resource })=>resource.id === id);
            return {
                groupId: id,
                groupName: name,
                dataList: scopes// Filter out the scopes that have been assigned
                .filter(({ id: scopeId })=>{
                    if (!assignedResourceScopes) return true;
                    return assignedResource ? !assignedResource.scopes.some((scope)=>scope.id === scopeId) : true;
                })
            };
        });
        // Filter out the resources that have no scopes
        return resourcesWithScopes.filter(({ dataList: dataList })=>dataList.length > 0);
    }, [
        allResources,
        assignedResourceScopes
    ]);
    return {
        scopeType: isForOrganization ? (0, $fGvTA.ApplicationUserConsentScopeType).OrganizationResourceScopes : (0, $fGvTA.ApplicationUserConsentScopeType).ResourceScopes,
        selectedData: selectedData,
        setSelectedData: setSelectedData,
        availableDataGroups: availableDataGroups,
        title: `application_details.permissions.api_resource_permissions_assignment_form_title`
    };
};
var $55f5c59d5553746e$export$2e2bcd8739ae039 = $55f5c59d5553746e$var$useResourceScopesAssignment;


parcelRequire("4taJ0");
var $hyigV = parcelRequire("hyigV");
parcelRequire("cuPVN");
var $fGvTA = parcelRequire("fGvTA");

var $jC8Vy = parcelRequire("jC8Vy");
const $9e22e2648eb2a4ad$var$useUserScopesAssignment = (assignedUserScopes = [])=>{
    const [selectedData, setSelectedData] = (0, $jC8Vy.useState)([]);
    const availableDataList = (0, $jC8Vy.useMemo)(()=>Object.values((0, $hyigV.UserScope)).map((name)=>({
                name: name,
                id: name
            }))// Filter out the scopes that have been assigned
        .filter(({ id: id })=>!assignedUserScopes.includes(id)), [
        assignedUserScopes
    ]);
    return {
        scopeType: (0, $fGvTA.ApplicationUserConsentScopeType).UserScopes,
        selectedData: selectedData,
        setSelectedData: setSelectedData,
        availableDataList: availableDataList,
        title: "application_details.permissions.user_permissions_assignment_form_title"
    };
};
var $9e22e2648eb2a4ad$export$2e2bcd8739ae039 = $9e22e2648eb2a4ad$var$useUserScopesAssignment;


const $897366714d413360$var$useApplicationScopesAssignment = (applicationId, scopeLevel)=>{
    const [activeTab, setActiveTab] = (0, $jC8Vy.useState)(scopeLevel === (0, $7a0395d9de438311$export$bf9d7c4801670108).Organization ? (0, $fGvTA.ApplicationUserConsentScopeType).OrganizationScopes : (0, $fGvTA.ApplicationUserConsentScopeType).UserScopes);
    const [isLoading, setIsLoading] = (0, $jC8Vy.useState)(false);
    const api = (0, $7VnwS.default)();
    const { data: data, mutate: mutate } = (0, $voszV.default)(`api/applications/${applicationId}/user-consent-scopes`);
    const userScopesAssignment = (0, $9e22e2648eb2a4ad$export$2e2bcd8739ae039)(data?.userScopes);
    const organizationScopesAssignment = (0, $154a45af16369a41$export$2e2bcd8739ae039)(data?.organizationScopes);
    const resourceScopesAssignment = (0, $55f5c59d5553746e$export$2e2bcd8739ae039)(data?.resourceScopes);
    const organizationResourceScopesAssignment = (0, $55f5c59d5553746e$export$2e2bcd8739ae039)(data?.organizationResourceScopes, {
        isForOrganization: true
    });
    const clearSelectedData = (0, $jC8Vy.useCallback)(()=>{
        userScopesAssignment.setSelectedData([]);
        resourceScopesAssignment.setSelectedData([]);
        organizationScopesAssignment.setSelectedData([]);
        organizationResourceScopesAssignment.setSelectedData([]);
    }, [
        organizationResourceScopesAssignment,
        organizationScopesAssignment,
        resourceScopesAssignment,
        userScopesAssignment
    ]);
    const onSubmit = (0, $jC8Vy.useCallback)(async ()=>{
        setIsLoading(true);
        const newUserScopes = userScopesAssignment.selectedData.map(({ id: id })=>id);
        const newOrganizationScopes = organizationScopesAssignment.selectedData.map(({ id: id })=>id);
        const newResourceScopes = resourceScopesAssignment.selectedData.map(({ id: id })=>id);
        const newOrganizationResourceScopes = organizationResourceScopesAssignment.selectedData.map(({ id: id })=>id);
        await api.post(`api/applications/${applicationId}/user-consent-scopes`, {
            json: {
                ...(0, $7oDSS.conditional)(newUserScopes.length > 0 && {
                    userScopes: newUserScopes
                }),
                ...(0, $7oDSS.conditional)(newOrganizationScopes.length > 0 && {
                    organizationScopes: newOrganizationScopes
                }),
                ...(0, $7oDSS.conditional)(newResourceScopes.length > 0 && {
                    resourceScopes: newResourceScopes
                }),
                ...(0, $7oDSS.conditional)(newOrganizationResourceScopes.length > 0 && {
                    organizationResourceScopes: newOrganizationResourceScopes
                })
            }
        }).finally(()=>{
            setIsLoading(false);
        });
        mutate();
    }, [
        api,
        applicationId,
        mutate,
        organizationResourceScopesAssignment.selectedData,
        organizationScopesAssignment.selectedData,
        resourceScopesAssignment.selectedData,
        userScopesAssignment.selectedData
    ]);
    // Return selectedScopes and setSelectedScopes based on the active tab
    const scopesAssignment = (0, $jC8Vy.useMemo)(()=>({
            [(0, $fGvTA.ApplicationUserConsentScopeType).UserScopes]: userScopesAssignment,
            [(0, $fGvTA.ApplicationUserConsentScopeType).ResourceScopes]: resourceScopesAssignment,
            [(0, $fGvTA.ApplicationUserConsentScopeType).OrganizationScopes]: organizationScopesAssignment,
            [(0, $fGvTA.ApplicationUserConsentScopeType).OrganizationResourceScopes]: organizationResourceScopesAssignment
        }), [
        userScopesAssignment,
        resourceScopesAssignment,
        organizationScopesAssignment,
        organizationResourceScopesAssignment
    ]);
    return {
        isLoading: isLoading,
        activeTab: activeTab,
        setActiveTab: setActiveTab,
        scopesAssignment: scopesAssignment,
        clearSelectedData: clearSelectedData,
        onSubmit: onSubmit
    };
};
var $897366714d413360$export$2e2bcd8739ae039 = $897366714d413360$var$useApplicationScopesAssignment;


function $0684e943bc924ed3$var$ApplicationScopesAssignmentModal({ isOpen: isOpen, onClose: onClose, applicationId: applicationId, scopeLevel: scopeLevel }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { activeTab: activeTab, setActiveTab: setActiveTab, scopesAssignment: scopesAssignment, clearSelectedData: clearSelectedData, onSubmit: onSubmit, isLoading: isLoading } = (0, $897366714d413360$export$2e2bcd8739ae039)(applicationId, scopeLevel);
    const onCloseHandler = (0, $jC8Vy.useCallback)(()=>{
        onClose();
        clearSelectedData();
        setActiveTab(scopeLevel === (0, $7a0395d9de438311$export$bf9d7c4801670108).Organization ? (0, $fGvTA.ApplicationUserConsentScopeType).OrganizationScopes : (0, $fGvTA.ApplicationUserConsentScopeType).UserScopes);
    }, [
        clearSelectedData,
        onClose,
        scopeLevel,
        setActiveTab
    ]);
    const onSubmitHandler = (0, $jC8Vy.useCallback)(async ()=>{
        await onSubmit();
        onCloseHandler();
    }, [
        onCloseHandler,
        onSubmit
    ]);
    // If any of the tabs has selected scopes, the modal is dirty
    const isDirty = (0, $jC8Vy.useMemo)(()=>Object.values(scopesAssignment).some(({ selectedData: selectedData })=>selectedData.length > 0), [
        scopesAssignment
    ]);
    const tabs = (0, $jC8Vy.useMemo)(()=>Object.values(scopeLevel === (0, $7a0395d9de438311$export$bf9d7c4801670108).User ? (0, $50cd528a8d31231f$export$823e51caa075f844) : (0, $50cd528a8d31231f$export$c82be7b8c88fba4f)).map(({ title: title, key: key })=>{
            const selectedDataCount = scopesAssignment[key].selectedData.length;
            return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                isActive: key === activeTab,
                onClick: ()=>{
                    setActiveTab(key);
                },
                children: `${String(t(title))}${selectedDataCount ? ` (${selectedDataCount})` : ""}`
            }, key);
        }), [
        activeTab,
        scopeLevel,
        scopesAssignment,
        setActiveTab,
        t
    ]);
    const modalText = (0, $jC8Vy.useMemo)(()=>{
        const scopeLevelPhrase = scopeLevel === (0, $7a0395d9de438311$export$bf9d7c4801670108).User ? "user" : "organization";
        return {
            title: `application_details.permissions.grant_${scopeLevelPhrase}_level_permissions`,
            subtitle: `application_details.permissions.${scopeLevelPhrase}_description`,
            saveButton: "general.save"
        };
    }, [
        scopeLevel
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $dL4NZ.default), {
        isOpen: isOpen,
        isLoading: isLoading,
        title: modalText.title,
        subtitle: modalText.subtitle,
        isConfirmButtonDisabled: !isDirty,
        confirmButtonType: "primary",
        confirmButtonText: modalText.saveButton,
        isCancelButtonVisible: false,
        size: "large",
        onCancel: onCloseHandler,
        onConfirm: onSubmitHandler,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $26090e0c44b20d28$export$2e2bcd8739ae039), {
                children: tabs
            }),
            scopeLevel === (0, $7a0395d9de438311$export$bf9d7c4801670108).User && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $03bc4af79519e411$export$2e2bcd8739ae039), {
                        isActive: (0, $fGvTA.ApplicationUserConsentScopeType).UserScopes === activeTab,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e2d629f863c762e5$export$2e2bcd8739ae039), {
                            ...scopesAssignment[(0, $fGvTA.ApplicationUserConsentScopeType).UserScopes]
                        })
                    }, (0, $fGvTA.ApplicationUserConsentScopeType).UserScopes),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $03bc4af79519e411$export$2e2bcd8739ae039), {
                        isActive: (0, $fGvTA.ApplicationUserConsentScopeType).ResourceScopes === activeTab,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e2d629f863c762e5$export$2e2bcd8739ae039), {
                            ...scopesAssignment[(0, $fGvTA.ApplicationUserConsentScopeType).ResourceScopes]
                        })
                    }, (0, $fGvTA.ApplicationUserConsentScopeType).ResourceScopes)
                ]
            }),
            scopeLevel === (0, $7a0395d9de438311$export$bf9d7c4801670108).Organization && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $03bc4af79519e411$export$2e2bcd8739ae039), {
                        isActive: (0, $fGvTA.ApplicationUserConsentScopeType).OrganizationScopes === activeTab,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e2d629f863c762e5$export$2e2bcd8739ae039), {
                            ...scopesAssignment[(0, $fGvTA.ApplicationUserConsentScopeType).OrganizationScopes]
                        })
                    }, (0, $fGvTA.ApplicationUserConsentScopeType).OrganizationScopes),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $03bc4af79519e411$export$2e2bcd8739ae039), {
                        isActive: (0, $fGvTA.ApplicationUserConsentScopeType).OrganizationResourceScopes === activeTab,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e2d629f863c762e5$export$2e2bcd8739ae039), {
                            ...scopesAssignment[(0, $fGvTA.ApplicationUserConsentScopeType).OrganizationResourceScopes]
                        })
                    }, (0, $fGvTA.ApplicationUserConsentScopeType).OrganizationResourceScopes)
                ]
            })
        ]
    });
}
var $0684e943bc924ed3$export$2e2bcd8739ae039 = $0684e943bc924ed3$var$ApplicationScopesAssignmentModal;




var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $fGvTA = parcelRequire("fGvTA");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $kUZ14 = parcelRequire("kUZ14");

var $jGWQ4 = parcelRequire("jGWQ4");

var $8R7rc = parcelRequire("8R7rc");

var $aqmjm = parcelRequire("aqmjm");

var $5vVWy = parcelRequire("5vVWy");

var $fmHmG = parcelRequire("fmHmG");


var $7VnwS = parcelRequire("7VnwS");

var $dW2kG = parcelRequire("dW2kG");

var $5OcFi = parcelRequire("5OcFi");
function $1f5d4792c0eae3dc$var$ApplicationScopesManagementModal({ scope: scope, onClose: onClose, onSubmit: onSubmit }) {
    const api = (0, $7VnwS.default)();
    const { reset: reset, register: register, handleSubmit: handleSubmit, formState: { errors: errors, isSubmitting: isSubmitting } } = (0, $codQP.useForm)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const tAction = (0, $9fca41f2a64ee9e4$export$2e2bcd8739ae039)();
    const onSubmitHandler = handleSubmit((0, $5OcFi.trySubmitSafe)(onSubmit));
    // Reset form on open
    (0, $jC8Vy.useEffect)(()=>{
        if (scope) reset(scope);
    }, [
        reset,
        scope
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        isOpen: Boolean(scope),
        className: $dW2kG.content,
        overlayClassName: $dW2kG.overlay,
        onRequestClose: onClose,
        children: scope && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5vVWy.default), {
            title: scope.type === (0, $fGvTA.ApplicationUserConsentScopeType).ResourceScopes ? "api_resource_details.permission.edit_title" : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8R7rc.default), {
                children: tAction("edit", "organizations.organization_permission")
            }),
            subtitle: scope.type === (0, $fGvTA.ApplicationUserConsentScopeType).ResourceScopes ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8R7rc.default), {
                children: t("api_resource_details.permission.edit_subtitle", {
                    resourceName: scope.resourceName
                })
            }) : undefined,
            learnMoreLink: scope.type === (0, $fGvTA.ApplicationUserConsentScopeType).ResourceScopes ? {
                href: "https://docs.logto.io/docs/recipes/rbac/manage-permissions-and-roles#manage-role-permissions",
                targetBlank: "noopener"
            } : undefined,
            footer: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                isLoading: isSubmitting,
                htmlType: "submit",
                type: "primary",
                size: "large",
                title: "general.save",
                onClick: onSubmitHandler
            }),
            onClose: onClose,
            children: /*#__PURE__*/ (0, $C7mD2.jsxs)("form", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        isRequired: true,
                        title: "general.name",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                            disabled: true,
                            error: Boolean(errors.name),
                            ...register("name", {
                                required: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        title: "general.description",
                        isRequired: scope.type === (0, $fGvTA.ApplicationUserConsentScopeType).ResourceScopes,
                        tip: t("application_details.permissions.permission_description_tips"),
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                            // eslint-disable-next-line jsx-a11y/no-autofocus
                            autoFocus: true,
                            placeholder: scope.type === (0, $fGvTA.ApplicationUserConsentScopeType).ResourceScopes ? t("api_resource_details.permission.description_placeholder") : t("organizations.create_permission_placeholder"),
                            error: Boolean(errors.description),
                            ...register("description", {
                                required: scope.type === (0, $fGvTA.ApplicationUserConsentScopeType).ResourceScopes
                            })
                        })
                    })
                ]
            })
        })
    });
}
var $1f5d4792c0eae3dc$export$2e2bcd8739ae039 = $1f5d4792c0eae3dc$var$ApplicationScopesManagementModal;


var $6e0bf4e94c7e537b$export$1237798dc640739a;
var $6e0bf4e94c7e537b$export$9237cbee53ef3050;
var $6e0bf4e94c7e537b$export$bfd64c937657f93a;
var $6e0bf4e94c7e537b$export$508df5ccc2f6751a;
var $6e0bf4e94c7e537b$export$4a6dd88bada4e7d2;
$6e0bf4e94c7e537b$export$1237798dc640739a = `gqrIFa_label`;
$6e0bf4e94c7e537b$export$9237cbee53ef3050 = `gqrIFa_permissionsModal`;
$6e0bf4e94c7e537b$export$bfd64c937657f93a = `gqrIFa_rotating`;
$6e0bf4e94c7e537b$export$508df5ccc2f6751a = `gqrIFa_sectionTitleRow`;
$6e0bf4e94c7e537b$export$4a6dd88bada4e7d2 = `gqrIFa_shimmer`;


/* eslint-disable consistent-default-export-name/default-export-match-filename */ // We need to return a ReactNode property in the parseRowGroup function

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $fGvTA = parcelRequire("fGvTA");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $lf8OC = parcelRequire("lf8OC");

var $75SRw = parcelRequire("75SRw");
parcelRequire("fIF1D");
var $2LaLj = parcelRequire("2LaLj");

var $7VnwS = parcelRequire("7VnwS");

/**
 * - parseRowGroup: parse the application user consent scopes response data to table field group data
 */ const $fa9a095bb0e2b9af$var$useScopesTable = ()=>{
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { t: experienceT } = (0, $5OuPq.useTranslation)("experience", {
        keyPrefix: "user_scopes"
    });
    const api = (0, $7VnwS.default)();
    const parseRowGroup = (0, $jC8Vy.useCallback)((data)=>{
        if (!data) return {
            userLevelRowGroups: [],
            organizationLevelGroups: []
        };
        const { userScopes: userScopes, resourceScopes: resourceScopes, organizationScopes: organizationScopes, organizationResourceScopes: organizationResourceScopes } = data;
        const userScopesGroup = {
            key: (0, $fGvTA.ApplicationUserConsentScopeType).UserScopes,
            label: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $6e0bf4e94c7e537b$export$1237798dc640739a,
                children: [
                    t("application_details.permissions.user_permissions"),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2LaLj.default), {
                        content: t("application_details.permissions.user_data_permission_description_tips"),
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                            size: "small",
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $lf8OC.default), {})
                        })
                    })
                ]
            }),
            labelRowClassName: $6e0bf4e94c7e537b$export$508df5ccc2f6751a,
            data: userScopes.map((scope)=>({
                    type: (0, $fGvTA.ApplicationUserConsentScopeType).UserScopes,
                    id: scope,
                    name: scope,
                    // We have ':' in the user scope, need to change the nsSeparator to '|' to avoid i18n ns matching
                    description: experienceT(`descriptions.${scope}`, {
                        nsSeparator: "|"
                    })
                }))
        };
        const resourceScopesGroups = resourceScopes.map(({ resource: resource, scopes: scopes })=>({
                key: resource.indicator,
                label: resource.name,
                labelRowClassName: $6e0bf4e94c7e537b$export$508df5ccc2f6751a,
                data: scopes.map((scope)=>({
                        type: (0, $fGvTA.ApplicationUserConsentScopeType).ResourceScopes,
                        ...scope,
                        resourceId: resource.id,
                        resourceName: resource.name
                    }))
            }));
        const organizationScopesGroup = {
            key: (0, $fGvTA.ApplicationUserConsentScopeType).OrganizationScopes,
            label: t("application_details.permissions.organization_permissions"),
            labelRowClassName: $6e0bf4e94c7e537b$export$508df5ccc2f6751a,
            data: organizationScopes.map((scope)=>({
                    type: (0, $fGvTA.ApplicationUserConsentScopeType).OrganizationScopes,
                    ...scope
                }))
        };
        const organizationResourceScopesGroup = organizationResourceScopes.map(({ resource: resource, scopes: scopes })=>({
                key: resource.indicator,
                label: resource.name,
                labelRowClassName: $6e0bf4e94c7e537b$export$508df5ccc2f6751a,
                data: scopes.map((scope)=>({
                        type: (0, $fGvTA.ApplicationUserConsentScopeType).OrganizationResourceScopes,
                        ...scope,
                        resourceId: resource.id,
                        resourceName: resource.name
                    }))
            }));
        return {
            userLevelRowGroups: [
                // Hide the user scopes group if there is no user scopes
                ...userScopesGroup.data.length > 0 ? [
                    userScopesGroup
                ] : [],
                ...resourceScopesGroups
            ],
            organizationLevelGroups: [
                // Hide the organization scopes group if there is no organization scopes
                ...organizationScopesGroup.data.length > 0 ? [
                    organizationScopesGroup
                ] : [],
                ...organizationResourceScopesGroup.length > 0 ? organizationResourceScopesGroup : []
            ]
        };
    }, [
        experienceT,
        t
    ]);
    const deleteScope = (0, $jC8Vy.useCallback)(async (scope, applicationId)=>api.delete(`api/applications/${applicationId}/user-consent-scopes/${scope.type}/${scope.id}`), [
        api
    ]);
    // Only description is editable
    const editScope = (0, $jC8Vy.useCallback)(async (scope)=>{
        const { type: type, id: id, description: description } = scope;
        if (type === (0, $fGvTA.ApplicationUserConsentScopeType).ResourceScopes) {
            const { resourceId: resourceId } = scope;
            await api.patch(`api/resources/${resourceId}/scopes/${id}`, {
                json: {
                    description: description
                }
            });
            return;
        }
        if (type === (0, $fGvTA.ApplicationUserConsentScopeType).OrganizationScopes) await api.patch(`api/organization-scopes/${id}`, {
            json: {
                description: description
            }
        });
    }, [
        api
    ]);
    return {
        parseRowGroup: parseRowGroup,
        deleteScope: deleteScope,
        editScope: editScope
    };
};
var $fa9a095bb0e2b9af$export$2e2bcd8739ae039 /* eslint-enable consistent-default-export-name/default-export-match-filename */  = $fa9a095bb0e2b9af$var$useScopesTable;


function $3561dd5f402ff0a1$var$PermissionsCard({ applicationId: applicationId, scopeLevel: scopeLevel }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $b595fc2f0eccd19a$export$2e2bcd8739ae039)();
    const { data: data, error: error, mutate: mutate, isLoading: isLoading } = (0, $voszV.default)(`api/applications/${applicationId}/user-consent-scopes`);
    const { parseRowGroup: parseRowGroup, deleteScope: deleteScope, editScope: editScope } = (0, $fa9a095bb0e2b9af$export$2e2bcd8739ae039)();
    const [editScopeModalData, setEditScopeModalData] = (0, $jC8Vy.useState)();
    const [isAssignScopesModalOpen, setIsAssignScopesModalOpen] = (0, $jC8Vy.useState)(false);
    const rowGroups = (0, $jC8Vy.useMemo)(()=>{
        const { userLevelRowGroups: userLevelRowGroups, organizationLevelGroups: organizationLevelGroups } = parseRowGroup(data);
        return scopeLevel === (0, $7a0395d9de438311$export$bf9d7c4801670108).User ? userLevelRowGroups : organizationLevelGroups;
    }, [
        data,
        parseRowGroup,
        scopeLevel
    ]);
    const displayTextProps = (0, $jC8Vy.useMemo)(()=>{
        const scopeLevelPhrase = scopeLevel === (0, $7a0395d9de438311$export$bf9d7c4801670108).User ? "user" : "organization";
        return {
            formCard: {
                title: `application_details.permissions.${scopeLevelPhrase}_title`,
                description: `application_details.permissions.${scopeLevelPhrase}_description`,
                learnMoreLink: (0, $7oDSS.conditional)(scopeLevel === (0, $7a0395d9de438311$export$bf9d7c4801670108).User && {
                    href: getDocumentationUrl((0, $cfL6o.logtoThirdPartyAppPermissionsLink)),
                    targetBlank: "noopener"
                })
            },
            tableName: `application_details.permissions.grant_${scopeLevelPhrase}_level_permissions`
        };
    }, [
        getDocumentationUrl,
        scopeLevel
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
        ...displayTextProps.formCard,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $361879821187d718$export$2e2bcd8739ae039), {
                className: $6e0bf4e94c7e537b$export$9237cbee53ef3050,
                name: displayTextProps.tableName,
                rowIndexKey: "id",
                errorMessage: error?.body?.message ?? error?.message,
                isLoading: isLoading,
                rowGroups: rowGroups,
                columns: [
                    {
                        title: t("application_details.permissions.field_name"),
                        dataIndex: "name",
                        colSpan: 5,
                        render: ({ name: name })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
                                variant: "cell",
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e52124c5a4489a19$export$2e2bcd8739ae039), {
                                    children: name
                                })
                            })
                    },
                    {
                        title: `${t("general.description")} (${t("application_details.permissions.field_description")})`,
                        dataIndex: "description",
                        colSpan: 5,
                        render: ({ description: description })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $e52124c5a4489a19$export$2e2bcd8739ae039), {
                                children: description ?? "-"
                            })
                    },
                    {
                        title: null,
                        dataIndex: "delete",
                        render: (data)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $d6ac1a830c94487b$export$2e2bcd8739ae039), {
                                fieldName: "application_details.permissions.name",
                                deleteConfirmation: "application_details.permissions.permission_delete_confirm",
                                textOverrides: {
                                    delete: "application_details.permissions.delete_text",
                                    deleteConfirmation: "general.remove"
                                },
                                onEdit: // UserScopes is not editable
                                data.type === (0, $fGvTA.ApplicationUserConsentScopeType).UserScopes ? undefined : ()=>{
                                    setEditScopeModalData(data);
                                },
                                onDelete: async ()=>{
                                    await deleteScope(data, applicationId);
                                    mutate();
                                }
                            })
                    }
                ],
                onAdd: ()=>{
                    setIsAssignScopesModalOpen(true);
                }
            }),
            data && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0684e943bc924ed3$export$2e2bcd8739ae039), {
                isOpen: isAssignScopesModalOpen,
                applicationId: applicationId,
                scopeLevel: scopeLevel,
                onClose: ()=>{
                    setIsAssignScopesModalOpen(false);
                }
            }),
            data && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1f5d4792c0eae3dc$export$2e2bcd8739ae039), {
                scope: editScopeModalData,
                onClose: ()=>{
                    setEditScopeModalData(undefined);
                },
                onSubmit: async (scope)=>{
                    await editScope(scope);
                    mutate();
                    setEditScopeModalData(undefined);
                }
            })
        ]
    });
}
var $3561dd5f402ff0a1$export$2e2bcd8739ae039 = $3561dd5f402ff0a1$var$PermissionsCard;



var $4d7ec8e941c58d2b$export$34e0f9847d4c02dd;
var $4d7ec8e941c58d2b$export$bfd64c937657f93a;
var $4d7ec8e941c58d2b$export$4a6dd88bada4e7d2;
$4d7ec8e941c58d2b$export$34e0f9847d4c02dd = `yN8Ufq_container`;
$4d7ec8e941c58d2b$export$bfd64c937657f93a = `yN8Ufq_rotating`;
$4d7ec8e941c58d2b$export$4a6dd88bada4e7d2 = `yN8Ufq_shimmer`;


function $2e044fd8d01aff04$var$Permissions({ application: application }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: $4d7ec8e941c58d2b$export$34e0f9847d4c02dd,
        children: [
            (0, $7a0395d9de438311$export$bf9d7c4801670108).User,
            (0, $7a0395d9de438311$export$bf9d7c4801670108).Organization
        ].map((scopeLevel)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $3561dd5f402ff0a1$export$2e2bcd8739ae039), {
                applicationId: application.id,
                scopeLevel: scopeLevel
            }, scopeLevel))
    });
}
var $2e044fd8d01aff04$export$2e2bcd8739ae039 = $2e044fd8d01aff04$var$Permissions;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $ZBK3w = parcelRequire("ZBK3w");
var $61Yml = parcelRequire("61Yml");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");


var $aqmjm = parcelRequire("aqmjm");

var $8RfrQ = parcelRequire("8RfrQ");

var $fmHmG = parcelRequire("fmHmG");

var $9Q3SI = parcelRequire("9Q3SI");
function $df9126c460c606fb$var$RefreshTokenSettings({ data: { type: type } }) {
    const { register: register, formState: { errors: errors } } = (0, $codQP.useFormContext)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { minValue: minValue, maxValue: maxValue } = (0, $ZBK3w.customClientMetadataGuard).shape.refreshTokenTtlInDays._def.innerType;
    const minTtl = minValue ?? Number.NEGATIVE_INFINITY;
    const maxTtl = maxValue ?? Number.POSITIVE_INFINITY;
    const ttlErrorMessage = t("errors.number_should_be_between_inclusive", {
        min: minTtl,
        max: maxTtl
    });
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
        title: "application_details.refresh_token_settings",
        description: "application_details.refresh_token_settings_description",
        children: [
            [
                (0, $61Yml.ApplicationType).Traditional,
                (0, $61Yml.ApplicationType).SPA
            ].includes(type) && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: "application_details.always_issue_refresh_token",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8RfrQ.default), {
                    label: t("application_details.always_issue_refresh_token_label"),
                    ...register("customClientMetadata.alwaysIssueRefreshToken")
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: "application_details.rotate_refresh_token",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8RfrQ.default), {
                    label: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                        components: {
                            a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                                href: "https://docs.logto.io/docs/references/applications/#rotate-refresh-token",
                                targetBlank: "noopener"
                            })
                        },
                        children: t("application_details.rotate_refresh_token_label")
                    }),
                    ...register("customClientMetadata.rotateRefreshToken")
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: "application_details.refresh_token_ttl",
                tip: t("application_details.refresh_token_ttl_tip"),
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                    ...register("customClientMetadata.refreshTokenTtlInDays", {
                        min: {
                            value: minTtl,
                            message: ttlErrorMessage
                        },
                        max: {
                            value: maxTtl,
                            message: ttlErrorMessage
                        },
                        valueAsNumber: true,
                        validate: (value)=>value === undefined || Number.isInteger(value) || t("errors.should_be_an_integer")
                    }),
                    placeholder: "14",
                    // Confirm if we need a customized message here
                    error: errors.customClientMetadata?.refreshTokenTtlInDays?.message
                })
            })
        ]
    });
}
var $df9126c460c606fb$export$2e2bcd8739ae039 = $df9126c460c606fb$var$RefreshTokenSettings;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("4taJ0");
var $5rMXH = parcelRequire("5rMXH");
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");


var $kMkzL = parcelRequire("kMkzL");

var $aqmjm = parcelRequire("aqmjm");

var $5n0rM = parcelRequire("5n0rM");

var $fmHmG = parcelRequire("fmHmG");

var $9Q3SI = parcelRequire("9Q3SI");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("4taJ0");
var $5rMXH = parcelRequire("5rMXH");
var $b4hyY = parcelRequire("b4hyY");
parcelRequire("cuPVN");
var $3zL0M = parcelRequire("3zL0M");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $voszV = parcelRequire("voszV");

var $Xh5AE = parcelRequire("Xh5AE");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $3zL0M = parcelRequire("3zL0M");

var $66ixW = parcelRequire("66ixW");

const $27f02c712e8097d0$var$domainStatusToTag = {
    [(0, $3zL0M.DomainStatus).PendingVerification]: {
        title: "domain.status.connecting",
        status: "alert"
    },
    [(0, $3zL0M.DomainStatus).PendingSsl]: {
        title: "domain.status.connecting",
        status: "alert"
    },
    [(0, $3zL0M.DomainStatus).Active]: {
        title: "domain.status.in_use",
        status: "success"
    },
    [(0, $3zL0M.DomainStatus).Error]: {
        title: "domain.status.failed_to_connect",
        status: "error"
    }
};
function $27f02c712e8097d0$var$DomainStatusTag({ status: status }) {
    const tag = $27f02c712e8097d0$var$domainStatusToTag[status];
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
        status: tag.status,
        type: "state",
        variant: "plain",
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
            forKey: tag.title
        })
    });
}
var $27f02c712e8097d0$export$2e2bcd8739ae039 = $27f02c712e8097d0$var$DomainStatusTag;





var $8TpMk = parcelRequire("8TpMk");

var $byEIK = parcelRequire("byEIK");

var $jGWQ4 = parcelRequire("jGWQ4");

var $cw2No = parcelRequire("cw2No");

var $aqmjm = parcelRequire("aqmjm");

var $1QOtg = parcelRequire("1QOtg");

var $jbKqE = parcelRequire("jbKqE");

var $fmHmG = parcelRequire("fmHmG");

var $9Q3SI = parcelRequire("9Q3SI");

var $7VnwS = parcelRequire("7VnwS");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("4taJ0");
var $9vrm1 = parcelRequire("9vrm1");

var $5UrGx = parcelRequire("5UrGx");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $jGWQ4 = parcelRequire("jGWQ4");

var $fmHmG = parcelRequire("fmHmG");

var $bnkR4 = parcelRequire("bnkR4");

var $5OcFi = parcelRequire("5OcFi");
var $6cf865a1f6cf6239$export$76174c80c75f9baa;
var $6cf865a1f6cf6239$export$55b49835081025b8;
var $6cf865a1f6cf6239$export$bfd64c937657f93a;
var $6cf865a1f6cf6239$export$4a6dd88bada4e7d2;
var $6cf865a1f6cf6239$export$181ff85155496734;
$6cf865a1f6cf6239$export$76174c80c75f9baa = `NxrG3q_addButton`;
$6cf865a1f6cf6239$export$55b49835081025b8 = `NxrG3q_addDomain`;
$6cf865a1f6cf6239$export$bfd64c937657f93a = `NxrG3q_rotating`;
$6cf865a1f6cf6239$export$4a6dd88bada4e7d2 = `NxrG3q_shimmer`;
$6cf865a1f6cf6239$export$181ff85155496734 = `NxrG3q_textInput`;


function $5c429530f327e55f$var$AddDomainForm({ className: className, isReadonly: isReadonly, onSubmitCustomDomain: onSubmitCustomDomain }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { register: register, watch: watch, formState: { errors: errors, isSubmitting: isSubmitting }, handleSubmit: handleSubmit } = (0, $codQP.useForm)({
        defaultValues: {
            domain: ""
        }
    });
    const domainInput = watch("domain");
    const onSubmit = handleSubmit((0, $5OcFi.trySubmitSafe)(async (formData)=>{
        await onSubmitCustomDomain(formData);
    }));
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($6cf865a1f6cf6239$export$55b49835081025b8, className),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                className: $6cf865a1f6cf6239$export$181ff85155496734,
                placeholder: t("domain.custom.custom_domain_placeholder"),
                error: errors.domain?.message,
                readOnly: isReadonly,
                onKeyDown: (0, $bnkR4.onKeyDownHandler)({
                    Enter: onSubmit
                }),
                ...register("domain", {
                    required: true,
                    pattern: {
                        value: (0, $9vrm1.domainRegEx),
                        message: t("domain.custom.invalid_domain_format")
                    }
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                className: $6cf865a1f6cf6239$export$76174c80c75f9baa,
                type: "primary",
                title: "domain.custom.add_domain",
                isLoading: isSubmitting,
                disabled: domainInput.length === 0 || isReadonly,
                onClick: onSubmit
            })
        ]
    });
}
var $5c429530f327e55f$export$2e2bcd8739ae039 = $5c429530f327e55f$var$AddDomainForm;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $3zL0M = parcelRequire("3zL0M");

var $5UrGx = parcelRequire("5UrGx");

var $C7mD2 = parcelRequire("C7mD2");

var $3rVvj = parcelRequire("3rVvj");

var $66ixW = parcelRequire("66ixW");

var $1QOtg = parcelRequire("1QOtg");

var $C7mD2 = parcelRequire("C7mD2");

var $cw2No = parcelRequire("cw2No");

var $66ixW = parcelRequire("66ixW");

var $k9Oeh = parcelRequire("k9Oeh");

var $260f6627190f2eac$export$aa79b10cb7913a21;
var $260f6627190f2eac$export$4e0c71f277ca26b3;
var $260f6627190f2eac$export$34e0f9847d4c02dd;
var $260f6627190f2eac$export$38e42c68cf43b5d4;
var $260f6627190f2eac$export$46c1c92549715335;
var $260f6627190f2eac$export$5dd8d3d3c0fde971;
var $260f6627190f2eac$export$bfd64c937657f93a;
var $260f6627190f2eac$export$4a6dd88bada4e7d2;
var $260f6627190f2eac$export$9852986a3ec5f6a0;
var $260f6627190f2eac$export$5e5b4df997cb5eaa;
$260f6627190f2eac$export$aa79b10cb7913a21 = `zsr46a_bodyTableWrapper`;
$260f6627190f2eac$export$4e0c71f277ca26b3 = `zsr46a_column`;
$260f6627190f2eac$export$34e0f9847d4c02dd = `zsr46a_container`;
$260f6627190f2eac$export$38e42c68cf43b5d4 = `zsr46a_header`;
$260f6627190f2eac$export$46c1c92549715335 = `zsr46a_loading`;
$260f6627190f2eac$export$5dd8d3d3c0fde971 = `zsr46a_loadingIcon`;
$260f6627190f2eac$export$bfd64c937657f93a = `zsr46a_rotating`;
$260f6627190f2eac$export$4a6dd88bada4e7d2 = `zsr46a_shimmer`;
$260f6627190f2eac$export$9852986a3ec5f6a0 = `zsr46a_table`;
$260f6627190f2eac$export$5e5b4df997cb5eaa = `zsr46a_tip`;


function $1efee0a0c8ec2add$var$DnsRecordsTable({ records: records }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $260f6627190f2eac$export$5e5b4df997cb5eaa,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                    forKey: "domain.custom.add_dns_records"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $260f6627190f2eac$export$34e0f9847d4c02dd,
                children: records.length === 0 ? /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: $260f6627190f2eac$export$46c1c92549715335,
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $k9Oeh.Ring), {
                            className: $260f6627190f2eac$export$5dd8d3d3c0fde971
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: "domain.custom.generating_dns_records"
                        })
                    ]
                }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3166f28a681c41bb$export$2e2bcd8739ae039), {
                    isRowHoverEffectDisabled: true,
                    className: $260f6627190f2eac$export$9852986a3ec5f6a0,
                    headerTableClassName: $260f6627190f2eac$export$38e42c68cf43b5d4,
                    bodyTableWrapperClassName: $260f6627190f2eac$export$aa79b10cb7913a21,
                    rowGroups: [
                        {
                            key: "dnsRecords",
                            data: records
                        }
                    ],
                    rowIndexKey: "name",
                    isRowClickable: ()=>false,
                    columns: [
                        {
                            title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                forKey: "domain.custom.dns_table.type_field"
                            }),
                            dataIndex: "type",
                            colSpan: 2,
                            render: ({ type: type })=>/*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                    className: $260f6627190f2eac$export$4e0c71f277ca26b3,
                                    children: type
                                })
                        },
                        {
                            title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                forKey: "domain.custom.dns_table.name_field"
                            }),
                            dataIndex: "name",
                            colSpan: 7,
                            render: ({ name: name })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
                                    isWordWrapAllowed: true,
                                    className: $260f6627190f2eac$export$4e0c71f277ca26b3,
                                    value: name,
                                    variant: "text"
                                })
                        },
                        {
                            title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                forKey: "domain.custom.dns_table.value_field"
                            }),
                            dataIndex: "value",
                            colSpan: 7,
                            render: ({ value: value })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
                                    isWordWrapAllowed: true,
                                    className: $260f6627190f2eac$export$4e0c71f277ca26b3,
                                    value: value,
                                    variant: "text"
                                })
                        }
                    ]
                })
            })
        ]
    });
}
var $1efee0a0c8ec2add$export$2e2bcd8739ae039 = $1efee0a0c8ec2add$var$DnsRecordsTable;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $3zL0M = parcelRequire("3zL0M");

var $5UrGx = parcelRequire("5UrGx");


var $lf8OC = parcelRequire("lf8OC");

var $66ixW = parcelRequire("66ixW");

var $75SRw = parcelRequire("75SRw");

var $k9Oeh = parcelRequire("k9Oeh");

var $2LaLj = parcelRequire("2LaLj");
var $94ff489d2dc2ec92$export$8f981dffec84ba52;
var $94ff489d2dc2ec92$export$90407f30cb0073b9;
var $94ff489d2dc2ec92$export$38e42c68cf43b5d4;
var $94ff489d2dc2ec92$export$1ca1ec8b29a4ce27;
var $94ff489d2dc2ec92$export$46c1c92549715335;
var $94ff489d2dc2ec92$export$bfd64c937657f93a;
var $94ff489d2dc2ec92$export$4a6dd88bada4e7d2;
var $94ff489d2dc2ec92$export$471f7ae5c4103ae1;
var $94ff489d2dc2ec92$export$35d34bc0ed591a92;
var $94ff489d2dc2ec92$export$d26e66e6a9da146e;
var $94ff489d2dc2ec92$export$5e5b4df997cb5eaa;
var $94ff489d2dc2ec92$export$fb184b623420d9be;
$94ff489d2dc2ec92$export$8f981dffec84ba52 = `v0c2IW_contentContainer`;
$94ff489d2dc2ec92$export$90407f30cb0073b9 = `v0c2IW_finished`;
$94ff489d2dc2ec92$export$38e42c68cf43b5d4 = `v0c2IW_header`;
$94ff489d2dc2ec92$export$1ca1ec8b29a4ce27 = `v0c2IW_icon`;
$94ff489d2dc2ec92$export$46c1c92549715335 = `v0c2IW_loading`;
$94ff489d2dc2ec92$export$bfd64c937657f93a = `v0c2IW_rotating`;
$94ff489d2dc2ec92$export$4a6dd88bada4e7d2 = `v0c2IW_shimmer`;
$94ff489d2dc2ec92$export$471f7ae5c4103ae1 = `v0c2IW_status`;
$94ff489d2dc2ec92$export$35d34bc0ed591a92 = `v0c2IW_step`;
$94ff489d2dc2ec92$export$d26e66e6a9da146e = `v0c2IW_stepIcon`;
$94ff489d2dc2ec92$export$5e5b4df997cb5eaa = `v0c2IW_tip`;
$94ff489d2dc2ec92$export$fb184b623420d9be = `v0c2IW_title`;


const $df42a5b8eb89924d$var$domainStatusToStep = {
    [(0, $3zL0M.DomainStatus).Error]: 0,
    [(0, $3zL0M.DomainStatus).PendingVerification]: 1,
    [(0, $3zL0M.DomainStatus).PendingSsl]: 2,
    [(0, $3zL0M.DomainStatus).Active]: 3
};
function $df42a5b8eb89924d$var$Step({ step: step, title: title, tip: tip, domainStatus: domainStatus, children: children }) {
    const domainStatusStep = $df42a5b8eb89924d$var$domainStatusToStep[domainStatus];
    const isPending = step > domainStatusStep;
    const isLoading = step === domainStatusStep;
    const isFinished = step < domainStatusStep;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $94ff489d2dc2ec92$export$35d34bc0ed591a92,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $94ff489d2dc2ec92$export$38e42c68cf43b5d4,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($94ff489d2dc2ec92$export$d26e66e6a9da146e, isLoading && $94ff489d2dc2ec92$export$46c1c92549715335, isFinished && $94ff489d2dc2ec92$export$90407f30cb0073b9),
                        children: [
                            isPending && step,
                            isLoading && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $k9Oeh.Ring), {}),
                            isFinished && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $863c8122c7186617$export$2e2bcd8739ae039), {
                                className: $94ff489d2dc2ec92$export$1ca1ec8b29a4ce27
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $94ff489d2dc2ec92$export$fb184b623420d9be,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: title
                        })
                    }),
                    tip && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2LaLj.default), {
                        anchorClassName: $94ff489d2dc2ec92$export$5e5b4df997cb5eaa,
                        content: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: tip
                        }),
                        horizontalAlign: "start",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                            size: "small",
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $lf8OC.default), {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $94ff489d2dc2ec92$export$8f981dffec84ba52,
                children: children
            })
        ]
    });
}
var $df42a5b8eb89924d$export$2e2bcd8739ae039 = $df42a5b8eb89924d$var$Step;


var $179373fc87a9d0a7$export$34e0f9847d4c02dd;
var $179373fc87a9d0a7$export$dd472c3d8fe5a85a;
var $179373fc87a9d0a7$export$464c821cd4347539;
var $179373fc87a9d0a7$export$bfd64c937657f93a;
var $179373fc87a9d0a7$export$4a6dd88bada4e7d2;
$179373fc87a9d0a7$export$34e0f9847d4c02dd = `o9ke_a_container`;
$179373fc87a9d0a7$export$dd472c3d8fe5a85a = `o9ke_a_errorNotification`;
$179373fc87a9d0a7$export$464c821cd4347539 = `o9ke_a_hint`;
$179373fc87a9d0a7$export$bfd64c937657f93a = `o9ke_a_rotating`;
$179373fc87a9d0a7$export$4a6dd88bada4e7d2 = `o9ke_a_shimmer`;


function $b1ef22377cc541b3$var$ActivationProcess({ customDomain: customDomain }) {
    const { dnsRecords: dnsRecords, status: domainStatus, errorMessage: errorMessage } = customDomain;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $179373fc87a9d0a7$export$34e0f9847d4c02dd,
        children: [
            errorMessage && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $1QOtg.default), {
                className: $179373fc87a9d0a7$export$dd472c3d8fe5a85a,
                severity: "error",
                children: [
                    errorMessage,
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $179373fc87a9d0a7$export$464c821cd4347539,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: "domain.error_hint",
                            interpolation: {
                                value: (0, $3rVvj.customDomainSyncInterval)
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $df42a5b8eb89924d$export$2e2bcd8739ae039), {
                step: 1,
                title: "domain.custom.verify_domain",
                tip: "domain.custom.checking_dns_tip",
                domainStatus: domainStatus,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1efee0a0c8ec2add$export$2e2bcd8739ae039), {
                    records: dnsRecords
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $df42a5b8eb89924d$export$2e2bcd8739ae039), {
                step: 2,
                title: "domain.custom.enable_ssl",
                tip: "domain.custom.enable_ssl_tip",
                domainStatus: domainStatus
            })
        ]
    });
}
var $b1ef22377cc541b3$export$2e2bcd8739ae039 = $b1ef22377cc541b3$var$ActivationProcess;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $3zL0M = parcelRequire("3zL0M");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");






var $cw2No = parcelRequire("cw2No");

var $66ixW = parcelRequire("66ixW");

var $jbKqE = parcelRequire("jbKqE");

var $kBpQ2 = parcelRequire("kBpQ2");
var $9a3a68dd8aa03633$export$21779e503be4cd98;
var $9a3a68dd8aa03633$export$38e42c68cf43b5d4;
var $9a3a68dd8aa03633$export$1ca1ec8b29a4ce27;
var $9a3a68dd8aa03633$export$4cc594d73a54e241;
var $9a3a68dd8aa03633$export$bfd64c937657f93a;
var $9a3a68dd8aa03633$export$4a6dd88bada4e7d2;
var $9a3a68dd8aa03633$export$59ae2c325a998f89;
$9a3a68dd8aa03633$export$21779e503be4cd98 = `_7tMuma_domain`;
$9a3a68dd8aa03633$export$38e42c68cf43b5d4 = `_7tMuma_header`;
$9a3a68dd8aa03633$export$1ca1ec8b29a4ce27 = `_7tMuma_icon`;
$9a3a68dd8aa03633$export$4cc594d73a54e241 = `_7tMuma_inUsedDeletionTip`;
$9a3a68dd8aa03633$export$bfd64c937657f93a = `_7tMuma_rotating`;
$9a3a68dd8aa03633$export$4a6dd88bada4e7d2 = `_7tMuma_shimmer`;
$9a3a68dd8aa03633$export$59ae2c325a998f89 = `_7tMuma_strong`;


function $cb8396c890aac62c$var$CustomDomainHeader({ customDomain: { domain: domain, status: status }, hasExtraTipsOnDelete: hasExtraTipsOnDelete, hasOpenExternalLink: hasOpenExternalLink, isReadonly: isReadonly, onDeleteCustomDomain: onDeleteCustomDomain }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { show: show } = (0, $kBpQ2.useConfirmModal)();
    const handleDelete = async ()=>{
        const [result] = await show({
            ModalContent: ()=>{
                if (status !== (0, $3zL0M.DomainStatus).Active) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                    forKey: "domain.custom.deletion.description"
                });
                return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                            components: {
                                span: /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                                    className: $9a3a68dd8aa03633$export$59ae2c325a998f89
                                })
                            },
                            children: t("domain.custom.deletion.in_used_description", {
                                domain: domain
                            })
                        }),
                        hasExtraTipsOnDelete && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $9a3a68dd8aa03633$export$4cc594d73a54e241,
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                                components: {
                                    span: /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                                        className: $9a3a68dd8aa03633$export$59ae2c325a998f89
                                    })
                                },
                                children: t("domain.custom.deletion.in_used_tip", {
                                    domain: domain
                                })
                            })
                        })
                    ]
                });
            },
            confirmButtonText: "general.delete",
            title: "domain.custom.deletion.delete_domain"
        });
        if (!result) return;
        await onDeleteCustomDomain();
        (0, $FuhPC.toast).success(t("domain.custom.deletion.deleted"));
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $9a3a68dd8aa03633$export$38e42c68cf43b5d4,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $9a3a68dd8aa03633$export$21779e503be4cd98,
                children: domain
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $27f02c712e8097d0$export$2e2bcd8739ae039), {
                status: status
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jbKqE.default), {}),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
                value: domain,
                variant: "icon"
            }),
            hasOpenExternalLink && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $db1495a4b735df6f$export$2e2bcd8739ae039), {
                link: `https://${domain}`
            }),
            !isReadonly && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f25eeaa133584984$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $51f9e5400e6421f4$export$2e2bcd8739ae039), {
                    className: $9a3a68dd8aa03633$export$1ca1ec8b29a4ce27
                }),
                iconSize: "small",
                title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                    forKey: "general.more_options"
                }),
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6c006ec422465f6f$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3aa588de5c8665f2$export$2e2bcd8739ae039), {}),
                    type: "danger",
                    onClick: handleDelete,
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                        forKey: "general.delete"
                    })
                })
            })
        ]
    });
}
var $cb8396c890aac62c$export$2e2bcd8739ae039 = $cb8396c890aac62c$var$CustomDomainHeader;


var $5c0c80e00d46c136$export$34e0f9847d4c02dd;
var $5c0c80e00d46c136$export$bfd64c937657f93a;
var $5c0c80e00d46c136$export$4a6dd88bada4e7d2;
$5c0c80e00d46c136$export$34e0f9847d4c02dd = `wMuGfW_container`;
$5c0c80e00d46c136$export$bfd64c937657f93a = `wMuGfW_rotating`;
$5c0c80e00d46c136$export$4a6dd88bada4e7d2 = `wMuGfW_shimmer`;


function $96b2faa7a8fc7f6f$var$CustomDomain({ className: className, customDomain: customDomain, hasExtraTipsOnDelete: hasExtraTipsOnDelete, hasOpenExternalLink: hasOpenExternalLink, isReadonly: isReadonly, onDeleteCustomDomain: onDeleteCustomDomain }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($5c0c80e00d46c136$export$34e0f9847d4c02dd, className),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cb8396c890aac62c$export$2e2bcd8739ae039), {
                customDomain: customDomain,
                hasExtraTipsOnDelete: hasExtraTipsOnDelete,
                hasOpenExternalLink: hasOpenExternalLink,
                isReadonly: isReadonly,
                onDeleteCustomDomain: onDeleteCustomDomain
            }),
            customDomain.status !== (0, $3zL0M.DomainStatus).Active && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $b1ef22377cc541b3$export$2e2bcd8739ae039), {
                customDomain: customDomain
            })
        ]
    });
}
var $96b2faa7a8fc7f6f$export$2e2bcd8739ae039 = $96b2faa7a8fc7f6f$var$CustomDomain;




var $C7mD2 = parcelRequire("C7mD2");

var $codQP = parcelRequire("codQP");

var $Xh5AE = parcelRequire("Xh5AE");


var $byEIK = parcelRequire("byEIK");

var $aqmjm = parcelRequire("aqmjm");

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");



var $bnkR4 = parcelRequire("bnkR4");
var $74edcf773cfbf795$export$2ba01fb71ed41cb6;
var $74edcf773cfbf795$export$34e0f9847d4c02dd;
var $74edcf773cfbf795$export$683472f6198a076e;
var $74edcf773cfbf795$export$5df884bdba3ad6a1;
var $74edcf773cfbf795$export$bfd64c937657f93a;
var $74edcf773cfbf795$export$4a6dd88bada4e7d2;
var $74edcf773cfbf795$export$e1f445cd6eeea85e;
$74edcf773cfbf795$export$2ba01fb71ed41cb6 = `U6WLiq_button`;
$74edcf773cfbf795$export$34e0f9847d4c02dd = `U6WLiq_container`;
$74edcf773cfbf795$export$683472f6198a076e = `U6WLiq_disabled`;
$74edcf773cfbf795$export$5df884bdba3ad6a1 = `U6WLiq_down`;
$74edcf773cfbf795$export$bfd64c937657f93a = `U6WLiq_rotating`;
$74edcf773cfbf795$export$4a6dd88bada4e7d2 = `U6WLiq_shimmer`;
$74edcf773cfbf795$export$e1f445cd6eeea85e = `U6WLiq_up`;



var $fmHmG = parcelRequire("fmHmG");
function $1ed54dbe2d43891b$var$Button({ className: className, onTrigger: onTrigger, children: children, isDisabled: isDisabled }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        role: "button",
        tabIndex: 0,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($74edcf773cfbf795$export$2ba01fb71ed41cb6, isDisabled && $74edcf773cfbf795$export$683472f6198a076e, className),
        "aria-disabled": isDisabled,
        onKeyDown: (0, $bnkR4.onKeyDownHandler)(onTrigger),
        onClick: (event)=>{
            event.preventDefault();
            if (isDisabled) return;
            onTrigger?.(event);
        },
        children: children
    });
}
/** A numeric text input with up and down buttons for incrementing and decrementing the value. */ function $1ed54dbe2d43891b$var$NumericInput({ onValueUp: onValueUp, onValueDown: onValueDown, ...props }) {
    const isDisabled = Boolean(props.disabled) || Boolean(props.readOnly);
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
        ...props,
        alwaysShowSuffix: true,
        type: "number",
        suffix: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
            className: $74edcf773cfbf795$export$34e0f9847d4c02dd,
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsx)($1ed54dbe2d43891b$var$Button, {
                    className: $74edcf773cfbf795$export$e1f445cd6eeea85e,
                    isDisabled: isDisabled || props.value !== undefined && props.max !== undefined && Number(props.value) >= Number(props.max),
                    onTrigger: onValueUp,
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $16d7b0de1c0442c9$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)($1ed54dbe2d43891b$var$Button, {
                    className: $74edcf773cfbf795$export$5df884bdba3ad6a1,
                    isDisabled: isDisabled || props.value !== undefined && props.min !== undefined && Number(props.value) <= Number(props.min),
                    onTrigger: onValueDown,
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $98a4f18236948225$export$2e2bcd8739ae039), {})
                })
            ]
        })
    });
}
var $1ed54dbe2d43891b$export$2e2bcd8739ae039 = $1ed54dbe2d43891b$var$NumericInput;


var $ecaa77a086d705fb$export$ec35a3d3e818fad2;
$ecaa77a086d705fb$export$ec35a3d3e818fad2 = `_9-F7yW_sessionDuration`;


const $2a06ff805c2c3b0b$var$maxSessionDuration = 365; // 1 year
function $2a06ff805c2c3b0b$var$SessionForm({ data: data }) {
    const { data: oidcConfig } = (0, $Xh5AE.default)((0, $byEIK.openIdProviderConfigPath));
    const { control: control, formState: { errors: errors } } = (0, $codQP.useFormContext)();
    if (!data.protectedAppMetadata || !oidcConfig) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
        title: "application_details.session",
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
            title: "application_details.session_duration",
            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                name: "protectedAppMetadata.sessionDuration",
                control: control,
                rules: {
                    min: 1
                },
                render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $1ed54dbe2d43891b$export$2e2bcd8739ae039), {
                        className: $ecaa77a086d705fb$export$ec35a3d3e818fad2,
                        name: name,
                        placeholder: "14",
                        value: String(value),
                        min: 1,
                        max: $2a06ff805c2c3b0b$var$maxSessionDuration,
                        error: Boolean(errors.protectedAppMetadata?.sessionDuration),
                        onChange: ({ target: { value: value } })=>{
                            onChange(value && Number(value));
                        },
                        onValueUp: ()=>{
                            onChange(value + 1);
                        },
                        onValueDown: ()=>{
                            onChange(value - 1);
                        },
                        onBlur: ()=>{
                            if (value < 1) onChange(1);
                            else if (value > $2a06ff805c2c3b0b$var$maxSessionDuration) onChange($2a06ff805c2c3b0b$var$maxSessionDuration);
                        }
                    })
            })
        })
    });
}
var $2a06ff805c2c3b0b$export$2e2bcd8739ae039 = $2a06ff805c2c3b0b$var$SessionForm;


var $cc07e2d9400133f5$export$dbd89fd7a9dba0cb;
var $cc07e2d9400133f5$export$2ba01fb71ed41cb6;
var $cc07e2d9400133f5$export$71150836a6bda1e7;
var $cc07e2d9400133f5$export$41bf061237fe167f;
var $cc07e2d9400133f5$export$6d59db4903f20f7d;
var $cc07e2d9400133f5$export$94132a0e348806d4;
var $cc07e2d9400133f5$export$5e032988b71f6158;
var $cc07e2d9400133f5$export$1a06d502dce4885c;
var $cc07e2d9400133f5$export$91b9bee19a0d8569;
var $cc07e2d9400133f5$export$1237798dc640739a;
var $cc07e2d9400133f5$export$173b038a5a34bfb3;
var $cc07e2d9400133f5$export$3e7bcdf53d3c4af3;
var $cc07e2d9400133f5$export$bfd64c937657f93a;
var $cc07e2d9400133f5$export$66b32f6f30eb4b4;
var $cc07e2d9400133f5$export$4a6dd88bada4e7d2;
var $cc07e2d9400133f5$export$471f7ae5c4103ae1;
var $cc07e2d9400133f5$export$fe7c49d056ea1d88;
var $cc07e2d9400133f5$export$5e5b4df997cb5eaa;
var $cc07e2d9400133f5$export$fb184b623420d9be;
$cc07e2d9400133f5$export$dbd89fd7a9dba0cb = `_9JJ_Hq_bone`;
$cc07e2d9400133f5$export$2ba01fb71ed41cb6 = `_9JJ_Hq_button`;
$cc07e2d9400133f5$export$71150836a6bda1e7 = `_9JJ_Hq_connecting`;
$cc07e2d9400133f5$export$41bf061237fe167f = `_9JJ_Hq_customDomain`;
$cc07e2d9400133f5$export$6d59db4903f20f7d = `_9JJ_Hq_description`;
$cc07e2d9400133f5$export$94132a0e348806d4 = `_9JJ_Hq_dot`;
$cc07e2d9400133f5$export$5e032988b71f6158 = `_9JJ_Hq_host`;
$cc07e2d9400133f5$export$1a06d502dce4885c = `_9JJ_Hq_hostInUse`;
$cc07e2d9400133f5$export$91b9bee19a0d8569 = `_9JJ_Hq_inlineCode`;
$cc07e2d9400133f5$export$1237798dc640739a = `_9JJ_Hq_label`;
$cc07e2d9400133f5$export$173b038a5a34bfb3 = `_9JJ_Hq_launcher`;
$cc07e2d9400133f5$export$3e7bcdf53d3c4af3 = `_9JJ_Hq_loadingSkeleton`;
$cc07e2d9400133f5$export$bfd64c937657f93a = `_9JJ_Hq_rotating`;
$cc07e2d9400133f5$export$66b32f6f30eb4b4 = `_9JJ_Hq_routes`;
$cc07e2d9400133f5$export$4a6dd88bada4e7d2 = `_9JJ_Hq_shimmer`;
$cc07e2d9400133f5$export$4a6dd88bada4e7d2;
$cc07e2d9400133f5$export$471f7ae5c4103ae1 = `_9JJ_Hq_status`;
$cc07e2d9400133f5$export$fe7c49d056ea1d88 = `_9JJ_Hq_success`;
$cc07e2d9400133f5$export$5e5b4df997cb5eaa = `_9JJ_Hq_tip`;
$cc07e2d9400133f5$export$fb184b623420d9be = `_9JJ_Hq_title`;


const $bdcad9d09d3c8034$var$routes = Object.freeze([
    "/register",
    "/sign-in",
    "/sign-in-callback",
    "/sign-out"
]);
function $bdcad9d09d3c8034$var$ProtectedAppSettings({ data: data }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $b595fc2f0eccd19a$export$2e2bcd8739ae039)();
    const { data: oidcConfig } = (0, $Xh5AE.default)((0, $byEIK.openIdProviderConfigPath));
    const { data: customDomains = [], isLoading: isLoadingCustomDomain, mutate: mutate } = (0, $voszV.default)(`api/applications/${data.id}/protected-app-metadata/custom-domains`);
    const { data: systemDomainData } = (0, $Xh5AE.default)((0, $8TpMk.isCloud) && "api/systems/application");
    const api = (0, $7VnwS.default)();
    const [isDeletingCustomDomain, setIsDeletingCustomDomain] = (0, $jC8Vy.useState)(false);
    const { control: control, register: register, getFieldState: getFieldState, setValue: setValue, formState: { errors: errors } } = (0, $codQP.useFormContext)();
    const { fields: fields } = (0, $codQP.useFieldArray)({
        control: control,
        name: "protectedAppMetadata.pageRules"
    });
    (0, $jC8Vy.useEffect)(()=>{
        if (fields.length === 0) setValue("protectedAppMetadata.pageRules", [
            {
                path: ""
            }
        ]);
    }, [
        fields.length,
        setValue
    ]);
    if (!data.protectedAppMetadata || !oidcConfig) return null;
    const { host: host } = data.protectedAppMetadata;
    // We only support one custom domain for protected apps at the moment.
    const customDomain = customDomains[0];
    const externalLink = `https://${customDomain?.status === (0, $3zL0M.DomainStatus).Active ? customDomain.domain : host}`;
    const showCustomDomainLoadingMask = isLoadingCustomDomain || isDeletingCustomDomain;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
                title: "application_details.integration",
                description: "application_details.integration_description",
                learnMoreLink: {
                    href: getDocumentationUrl("/docs/references/applications"),
                    targetBlank: "noopener"
                },
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $cc07e2d9400133f5$export$173b038a5a34bfb3,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                                children: t("protected_app.success_message")
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                                className: $cc07e2d9400133f5$export$2ba01fb71ed41cb6,
                                size: "small",
                                title: "application_details.try_it",
                                trailingIcon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4bc930fbe25d753c$export$2e2bcd8739ae039), {}),
                                onClick: ()=>{
                                    window.open(externalLink, "_blank");
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        isRequired: true,
                        title: "application_details.application_name",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                            ...register("name", {
                                required: true
                            }),
                            error: Boolean(errors.name),
                            placeholder: t("application_details.application_name_placeholder")
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        isRequired: true,
                        title: "protected_app.form.url_field_label",
                        description: (0, $7oDSS.cond)(getFieldState("protectedAppMetadata.origin").isDirty && "protected_app.form.url_field_modification_notice"),
                        tip: t("protected_app.form.url_field_tooltip"),
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                            ...register("protectedAppMetadata.origin", {
                                required: true,
                                validate: (value)=>{
                                    if (!(0, $5rMXH.validateUriOrigin)(value)) return t("protected_app.form.errors.invalid_url");
                                    if ((0, $5rMXH.isLocalhost)(value)) return t("protected_app.form.errors.localhost");
                                    return true;
                                }
                            }),
                            error: errors.protectedAppMetadata?.origin?.message === t("protected_app.form.errors.localhost") ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                                components: {
                                    a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                                        to: "https://docs.logto.io/docs/recipes/protected-app/#local-development"
                                    })
                                },
                                children: t("protected_app.form.errors.localhost")
                            }) : // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                            errors.protectedAppMetadata?.origin?.message || errors.protectedAppMetadata?.origin?.type === "required" && t("protected_app.form.errors.url_required"),
                            placeholder: t("protected_app.form.url_field_placeholder")
                        })
                    }),
                    !!host && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aqmjm.default), {
                        title: "protected_app.form.domain_field_label",
                        children: [
                            showCustomDomainLoadingMask && /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                className: $cc07e2d9400133f5$export$3e7bcdf53d3c4af3,
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($cc07e2d9400133f5$export$dbd89fd7a9dba0cb, $cc07e2d9400133f5$export$fb184b623420d9be)
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($cc07e2d9400133f5$export$dbd89fd7a9dba0cb, $cc07e2d9400133f5$export$6d59db4903f20f7d)
                                    })
                                ]
                            }),
                            !customDomain && !showCustomDomainLoadingMask && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5c429530f327e55f$export$2e2bcd8739ae039), {
                                className: $cc07e2d9400133f5$export$41bf061237fe167f,
                                onSubmitCustomDomain: async (json)=>{
                                    await api.post(`api/applications/${data.id}/protected-app-metadata/custom-domains`, {
                                        json: json
                                    });
                                    mutate();
                                }
                            }),
                            customDomain && !showCustomDomainLoadingMask && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $96b2faa7a8fc7f6f$export$2e2bcd8739ae039), {
                                hasOpenExternalLink: true,
                                className: $cc07e2d9400133f5$export$41bf061237fe167f,
                                customDomain: customDomain,
                                onDeleteCustomDomain: async ()=>{
                                    setIsDeletingCustomDomain(true);
                                    await api.delete(`api/applications/${data.id}/protected-app-metadata/custom-domains/${customDomain.domain}`);
                                    setIsDeletingCustomDomain(false);
                                    mutate();
                                }
                            }),
                            customDomain?.status !== (0, $3zL0M.DomainStatus).Active && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $cc07e2d9400133f5$export$1237798dc640739a,
                                        children: t("application_details.app_domain_description_1", {
                                            domain: systemDomainData?.protectedApps.defaultDomain
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                        className: $cc07e2d9400133f5$export$1a06d502dce4885c,
                                        children: [
                                            /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                                                className: $cc07e2d9400133f5$export$5e032988b71f6158,
                                                children: host
                                            }),
                                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $27f02c712e8097d0$export$2e2bcd8739ae039), {
                                                status: (0, $3zL0M.DomainStatus).Active
                                            }),
                                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jbKqE.default), {}),
                                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
                                                value: host,
                                                variant: "icon"
                                            }),
                                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $db1495a4b735df6f$export$2e2bcd8739ae039), {
                                                link: externalLink
                                            })
                                        ]
                                    })
                                ]
                            }),
                            customDomain?.status === (0, $3zL0M.DomainStatus).Active && /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                                className: $cc07e2d9400133f5$export$1237798dc640739a,
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                                    components: {
                                        domain: /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                                            className: $cc07e2d9400133f5$export$91b9bee19a0d8569
                                        })
                                    },
                                    children: t("application_details.app_domain_description_2", {
                                        domain: host
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        title: "application_details.custom_rules",
                        description: "application_details.custom_rules_description",
                        descriptionPosition: "top",
                        tip: /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                            className: $cc07e2d9400133f5$export$5e5b4df997cb5eaa,
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                                components: {
                                    ol: /*#__PURE__*/ (0, $C7mD2.jsx)("ol", {}),
                                    li: /*#__PURE__*/ (0, $C7mD2.jsx)("li", {})
                                },
                                children: t("application_details.custom_rules_tip")
                            })
                        }),
                        children: fields.map((field, index)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                ...register(`protectedAppMetadata.pageRules.${index}.path`, {
                                    validate: (value)=>!value || (0, $b4hyY.isValidRegEx)(value) || t("errors.invalid_regex")
                                }),
                                error: Boolean(errors.protectedAppMetadata?.pageRules?.[index]?.path),
                                placeholder: t("application_details.custom_rules_placeholder")
                            }, field.id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
                title: "application_details.service_configuration",
                description: "application_details.service_configuration_description",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        title: "application_details.authentication_routes",
                        description: "application_details.authentication_routes_description",
                        descriptionPosition: "top",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $cc07e2d9400133f5$export$66b32f6f30eb4b4,
                            children: $bdcad9d09d3c8034$var$routes.map((route)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
                                    variant: "border",
                                    value: route
                                }, route))
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        title: "application_details.protect_origin_server",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1QOtg.default), {
                            severity: "alert",
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                                components: {
                                    a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                                        href: getDocumentationUrl("/docs/recipes/protected-app/#protect-your-origin-server"),
                                        targetBlank: "noopener"
                                    })
                                },
                                children: t("application_details.protect_origin_server_description")
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ca6dfdcf0c0487d2$export$2e2bcd8739ae039), {
                app: data,
                oidcConfig: oidcConfig
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2a06ff805c2c3b0b$export$2e2bcd8739ae039), {
                data: data
            })
        ]
    });
}
var $bdcad9d09d3c8034$export$2e2bcd8739ae039 = $bdcad9d09d3c8034$var$ProtectedAppSettings;


function $6fa5fffd4764f336$var$Settings({ data: data }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $b595fc2f0eccd19a$export$2e2bcd8739ae039)();
    const { control: control, register: register, formState: { errors: errors } } = (0, $codQP.useFormContext)();
    const { type: applicationType } = data;
    const isNativeApp = applicationType === (0, $61Yml.ApplicationType).Native;
    const isProtectedApp = applicationType === (0, $61Yml.ApplicationType).Protected;
    const uriPatternRules = {
        pattern: {
            verify: (value)=>!value || (0, $5rMXH.validateRedirectUrl)(value, isNativeApp ? "mobile" : "web"),
            message: t("errors.invalid_uri_format")
        }
    };
    if (isProtectedApp) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $bdcad9d09d3c8034$export$2e2bcd8739ae039), {
        data: data
    });
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
        title: "application_details.settings",
        description: "application_details.settings_description",
        learnMoreLink: {
            href: getDocumentationUrl("/docs/references/applications"),
            targetBlank: "noopener"
        },
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                isRequired: true,
                title: "application_details.application_name",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                    ...register("name", {
                        required: true
                    }),
                    error: Boolean(errors.name),
                    placeholder: t("application_details.application_name_placeholder")
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: "application_details.description",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                    ...register("description"),
                    placeholder: t("application_details.description_placeholder")
                })
            }),
            applicationType !== (0, $61Yml.ApplicationType).MachineToMachine && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                name: "oidcClientMetadata.redirectUris",
                control: control,
                defaultValue: [],
                rules: {
                    validate: (0, $5n0rM.createValidatorForRhf)({
                        ...uriPatternRules,
                        required: t("application_details.redirect_uri_required")
                    })
                },
                render: ({ field: { onChange: onChange, value: value }, fieldState: { error: error } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $kMkzL.default), {
                        isRequired: true,
                        title: "application_details.redirect_uris",
                        tip: (closeTipHandler)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                                components: {
                                    a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                                        targetBlank: true,
                                        href: "https://openid.net/specs/openid-connect-core-1_0.html#AuthRequest",
                                        onClick: closeTipHandler
                                    })
                                },
                                children: t("application_details.redirect_uri_tip")
                            }),
                        value: value,
                        error: (0, $5n0rM.convertRhfErrorMessage)(error?.message),
                        placeholder: applicationType === (0, $61Yml.ApplicationType).Native ? t("application_details.redirect_uri_placeholder_native") : t("application_details.redirect_uri_placeholder"),
                        onChange: onChange
                    })
            }),
            applicationType !== (0, $61Yml.ApplicationType).MachineToMachine && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                name: "oidcClientMetadata.postLogoutRedirectUris",
                control: control,
                defaultValue: [],
                rules: {
                    validate: (0, $5n0rM.createValidatorForRhf)(uriPatternRules)
                },
                render: ({ field: { onChange: onChange, value: value }, fieldState: { error: error } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $kMkzL.default), {
                        title: "application_details.post_sign_out_redirect_uris",
                        tip: t("application_details.post_sign_out_redirect_uri_tip"),
                        value: value,
                        error: (0, $5n0rM.convertRhfErrorMessage)(error?.message),
                        placeholder: t("application_details.post_sign_out_redirect_uri_placeholder"),
                        onChange: onChange
                    })
            }),
            applicationType !== (0, $61Yml.ApplicationType).MachineToMachine && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                name: "customClientMetadata.corsAllowedOrigins",
                control: control,
                defaultValue: [],
                render: ({ field: { onChange: onChange, value: value }, fieldState: { error: error } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $kMkzL.default), {
                        title: "application_details.cors_allowed_origins",
                        tip: (closeTipHandler)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                                components: {
                                    a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                                        targetBlank: true,
                                        href: "https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS",
                                        onClick: closeTipHandler
                                    })
                                },
                                children: t("application_details.cors_allowed_origins_tip")
                            }),
                        value: value,
                        error: (0, $5n0rM.convertRhfErrorMessage)(error?.message),
                        placeholder: t("application_details.cors_allowed_origins_placeholder"),
                        onChange: onChange
                    })
            })
        ]
    });
}
var $6fa5fffd4764f336$export$2e2bcd8739ae039 = $6fa5fffd4764f336$var$Settings;



parcelRequire("cuPVN");
var $7cCjo = parcelRequire("7cCjo");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");
const $0885fd89f2314d62$var$mapToUriFormatArrays = (value)=>value?.filter(Boolean).map((uri)=>decodeURIComponent(uri));
const $0885fd89f2314d62$var$mapToUriOriginFormatArrays = (value)=>value?.filter(Boolean).map((uri)=>decodeURIComponent(uri.replace(/\/*$/, "")));
const $0885fd89f2314d62$export$40577cf8423edfcc = {
    fromResponse: (data)=>{
        const { name: name, description: description, oidcClientMetadata: oidcClientMetadata, customClientMetadata: customClientMetadata, isAdmin: isAdmin, protectedAppMetadata: /** Specific metadata for protected apps */ protectedAppMetadata } = data;
        return {
            name: name,
            ...(0, $7oDSS.cond)(!protectedAppMetadata && {
                description: description,
                oidcClientMetadata: oidcClientMetadata,
                customClientMetadata: {
                    ...(0, $7cCjo.customClientMetadataDefault),
                    ...customClientMetadata
                },
                isAdmin: isAdmin
            }),
            ...(0, $7oDSS.cond)(protectedAppMetadata && {
                protectedAppMetadata: {
                    ...protectedAppMetadata,
                    sessionDuration: protectedAppMetadata.sessionDuration / 3600 / 24
                }
            })
        };
    },
    toRequestPayload: (data)=>{
        const { name: name, description: description, oidcClientMetadata: oidcClientMetadata, customClientMetadata: customClientMetadata, isAdmin: isAdmin, protectedAppMetadata: protectedAppMetadata } = data;
        return {
            name: name,
            ...(0, $7oDSS.cond)(!protectedAppMetadata && {
                description: description,
                oidcClientMetadata: {
                    ...oidcClientMetadata,
                    redirectUris: $0885fd89f2314d62$var$mapToUriFormatArrays(oidcClientMetadata?.redirectUris),
                    postLogoutRedirectUris: $0885fd89f2314d62$var$mapToUriFormatArrays(oidcClientMetadata?.postLogoutRedirectUris)
                },
                customClientMetadata: {
                    ...customClientMetadata,
                    corsAllowedOrigins: $0885fd89f2314d62$var$mapToUriOriginFormatArrays(customClientMetadata?.corsAllowedOrigins)
                },
                isAdmin: isAdmin
            }),
            ...(0, $7oDSS.cond)(protectedAppMetadata && {
                protectedAppMetadata: {
                    ...protectedAppMetadata,
                    sessionDuration: protectedAppMetadata.sessionDuration * 86400
                }
            })
        };
    }
};


function $999a84d5583b340a$var$ApplicationDetailsContent({ data: data, oidcConfig: oidcConfig, onApplicationUpdated: onApplicationUpdated }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { tab: tab } = (0, $2Phw0.useParams)();
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const { getDocumentationUrl: getDocumentationUrl } = (0, $b595fc2f0eccd19a$export$2e2bcd8739ae039)();
    const formMethods = (0, $codQP.useForm)({
        defaultValues: (0, $0885fd89f2314d62$export$40577cf8423edfcc).fromResponse(data),
        mode: "onBlur"
    });
    const { handleSubmit: handleSubmit, reset: reset, formState: { isSubmitting: isSubmitting, isDirty: isDirty } } = formMethods;
    const [isReadmeOpen, setIsReadmeOpen] = (0, $jC8Vy.useState)(false);
    const [isDeleteFormOpen, setIsDeleteFormOpen] = (0, $jC8Vy.useState)(false);
    const [isDeleting, setIsDeleting] = (0, $jC8Vy.useState)(false);
    const [isDeleted, setIsDeleted] = (0, $jC8Vy.useState)(false);
    const api = (0, $7VnwS.default)();
    const onSubmit = handleSubmit((0, $5OcFi.trySubmitSafe)(async (formData)=>{
        if (isSubmitting) return;
        const updatedData = await api.patch(`api/applications/${data.id}`, {
            json: (0, $0885fd89f2314d62$export$40577cf8423edfcc).toRequestPayload(formData)
        }).json();
        reset((0, $0885fd89f2314d62$export$40577cf8423edfcc).fromResponse(updatedData));
        onApplicationUpdated();
        (0, $FuhPC.toast).success(t("general.saved"));
    }));
    const onDelete = async ()=>{
        setIsDeleting(true);
        try {
            await api.delete(`api/applications/${data.id}`);
            setIsDeleted(true);
            setIsDeleteFormOpen(false);
            (0, $FuhPC.toast).success(t("application_details.application_deleted", {
                name: data.name
            }));
            navigate(`/applications`);
        } finally{
            setIsDeleting(false);
        }
    };
    const onCloseDrawer = ()=>{
        setIsReadmeOpen(false);
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $eefae5244405013e$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e07e369caa387826$export$2e2bcd8739ae039), {
                    type: data.type,
                    isThirdParty: data.isThirdParty
                }),
                title: data.name,
                primaryTag: data.isThirdParty ? t(`${(0, $59106c8950c5d39f$export$d8e4c8dab9129f15).thirdParty}.title`) : t(`${(0, $59106c8950c5d39f$export$d8e4c8dab9129f15)[data.type]}.title`),
                identifier: {
                    name: "App ID",
                    value: data.id
                },
                additionalActionButton: {
                    title: "application_details.check_guide",
                    icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f71d98d4090dad5c$export$2e2bcd8739ae039), {}),
                    onClick: ()=>{
                        // Open IdP docs link in new tab if it's a third party app
                        if (data.isThirdParty) {
                            window.open(getDocumentationUrl((0, $cfL6o.logtoThirdPartyGuideLink)), "_blank");
                            return;
                        }
                        // Open protected app docs link in new tab
                        if (data.type === (0, $61Yml.ApplicationType).Protected) {
                            window.open(getDocumentationUrl((0, $cfL6o.protectedAppLink)), "_blank");
                            return;
                        }
                        setIsReadmeOpen(true);
                    }
                },
                actionMenuItems: [
                    {
                        type: "danger",
                        title: "general.delete",
                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3aa588de5c8665f2$export$2e2bcd8739ae039), {}),
                        onClick: ()=>{
                            setIsDeleteFormOpen(true);
                        }
                    }
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $353ae25d75ceb68c$export$2e2bcd8739ae039), {
                isOpen: isReadmeOpen,
                onClose: onCloseDrawer,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4894cc0fc6e33e79$export$2e2bcd8739ae039), {
                    app: data,
                    onClose: onCloseDrawer
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7065f4e52ae4e862$export$2e2bcd8739ae039), {
                isOpen: isDeleteFormOpen,
                isLoading: isDeleting,
                expectedInput: data.name,
                inputPlaceholder: t("application_details.enter_your_application_name"),
                className: $1605e323fe6a84db$export$64fda0c1cfacc296,
                onCancel: ()=>{
                    setIsDeleteFormOpen(false);
                },
                onConfirm: onDelete,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $1605e323fe6a84db$export$6d59db4903f20f7d,
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                        components: {
                            span: /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                                className: $1605e323fe6a84db$export$e4043f67d36cbb26
                            })
                        },
                        children: t("application_details.delete_description", {
                            name: data.name
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $26090e0c44b20d28$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                        href: `/applications/${data.id}/${(0, $bt3dS.ApplicationDetailsTabs).Settings}`,
                        children: t("application_details.settings")
                    }),
                    data.type === (0, $61Yml.ApplicationType).MachineToMachine && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                                href: `/applications/${data.id}/${(0, $bt3dS.ApplicationDetailsTabs).Roles}`,
                                children: t("application_details.application_roles")
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                                href: `/applications/${data.id}/${(0, $bt3dS.ApplicationDetailsTabs).Logs}`,
                                children: t("application_details.machine_logs")
                            })
                        ]
                    }),
                    data.isThirdParty && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                                href: `/applications/${data.id}/${(0, $bt3dS.ApplicationDetailsTabs).Permissions}`,
                                children: t("application_details.permissions.name")
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                                href: `/applications/${data.id}/${(0, $bt3dS.ApplicationDetailsTabs).Branding}`,
                                children: t("application_details.branding.name")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $03bc4af79519e411$export$2e2bcd8739ae039), {
                isActive: tab === (0, $bt3dS.ApplicationDetailsTabs).Settings,
                className: $1605e323fe6a84db$export$5d1c634ec2526b93,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.FormProvider), {
                        ...formMethods,
                        children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $f0e7fd6d3bded790$export$2e2bcd8739ae039), {
                            isDirty: isDirty,
                            isSubmitting: isSubmitting,
                            onDiscard: reset,
                            onSubmit: onSubmit,
                            children: [
                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6fa5fffd4764f336$export$2e2bcd8739ae039), {
                                    data: data
                                }),
                                data.type !== (0, $61Yml.ApplicationType).Protected && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ca6dfdcf0c0487d2$export$2e2bcd8739ae039), {
                                    app: data,
                                    oidcConfig: oidcConfig
                                }),
                                ![
                                    (0, $61Yml.ApplicationType).MachineToMachine,
                                    (0, $61Yml.ApplicationType).Protected
                                ].includes(data.type) && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $df9126c460c606fb$export$2e2bcd8739ae039), {
                                    data: data
                                })
                            ]
                        })
                    }),
                    tab === (0, $bt3dS.ApplicationDetailsTabs).Settings && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fea55fa5d5726e29$export$2e2bcd8739ae039), {
                        hasUnsavedChanges: !isDeleted && isDirty,
                        onConfirm: reset
                    })
                ]
            }),
            data.type === (0, $61Yml.ApplicationType).MachineToMachine && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $03bc4af79519e411$export$2e2bcd8739ae039), {
                        isActive: tab === (0, $bt3dS.ApplicationDetailsTabs).Roles,
                        className: $1605e323fe6a84db$export$5d1c634ec2526b93,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $550b7407811eb1a6$export$2e2bcd8739ae039), {
                            application: data
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $03bc4af79519e411$export$2e2bcd8739ae039), {
                        isActive: tab === (0, $bt3dS.ApplicationDetailsTabs).Logs,
                        className: $1605e323fe6a84db$export$5d1c634ec2526b93,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ca1829f02fb6ab2d$export$2e2bcd8739ae039), {
                            applicationId: data.id
                        })
                    })
                ]
            }),
            data.isThirdParty && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $03bc4af79519e411$export$2e2bcd8739ae039), {
                        isActive: tab === (0, $bt3dS.ApplicationDetailsTabs).Permissions,
                        className: $1605e323fe6a84db$export$5d1c634ec2526b93,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2e044fd8d01aff04$export$2e2bcd8739ae039), {
                            application: data
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $03bc4af79519e411$export$2e2bcd8739ae039), {
                        isActive: tab === (0, $bt3dS.ApplicationDetailsTabs).Branding,
                        className: $1605e323fe6a84db$export$5d1c634ec2526b93,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $07559b443b856fd2$export$2e2bcd8739ae039), {
                            application: data,
                            isActive: tab === (0, $bt3dS.ApplicationDetailsTabs).Branding
                        })
                    })
                ]
            })
        ]
    });
}
var $999a84d5583b340a$export$2e2bcd8739ae039 = $999a84d5583b340a$var$ApplicationDetailsContent;



var $C7mD2 = parcelRequire("C7mD2");

var $kUZ14 = parcelRequire("kUZ14");


var $dW2kG = parcelRequire("dW2kG");

var $d39f7d3a1a09e987$export$675bc0f5721dbbd7;
var $d39f7d3a1a09e987$export$56c24f306bd986cf;
var $d39f7d3a1a09e987$export$bfd64c937657f93a;
var $d39f7d3a1a09e987$export$4a6dd88bada4e7d2;
$d39f7d3a1a09e987$export$675bc0f5721dbbd7 = `_3uqoIW_guide`;
$d39f7d3a1a09e987$export$56c24f306bd986cf = `_3uqoIW_modalContainer`;
$d39f7d3a1a09e987$export$bfd64c937657f93a = `_3uqoIW_rotating`;
$d39f7d3a1a09e987$export$4a6dd88bada4e7d2 = `_3uqoIW_shimmer`;


function $d6e560608b9985da$var$GuideModal({ guideId: guideId, app: app, onClose: onClose }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        shouldCloseOnEsc: true,
        isOpen: true,
        className: $dW2kG.fullScreen,
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
            className: $d39f7d3a1a09e987$export$56c24f306bd986cf,
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $81c55e09caea137c$export$2e2bcd8739ae039), {
                    title: "guide.app.guide_modal_title",
                    subtitle: "guide.app.modal_subtitle",
                    buttonText: "guide.cannot_find_guide",
                    requestFormFieldLabel: "guide.describe_guide_looking_for",
                    requestFormFieldPlaceholder: "guide.app.describe_guide_looking_for_placeholder",
                    requestSuccessMessage: "guide.request_guide_successfully",
                    onClose: onClose
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $11292fe225cd666f$export$2e2bcd8739ae039), {
                    className: $d39f7d3a1a09e987$export$675bc0f5721dbbd7,
                    guideId: guideId,
                    app: app,
                    onClose: onClose
                })
            ]
        })
    });
}
var $d6e560608b9985da$export$2e2bcd8739ae039 = $d6e560608b9985da$var$GuideModal;


function $05740b2d8eb0c6c7$var$ApplicationDetails() {
    const { id: id, guideId: guideId } = (0, $2Phw0.useParams)();
    const { navigate: navigate, match: match } = (0, $4ZcUR.default)();
    const isGuideView = !!id && !!guideId && match(`/applications/${id}/guide/${guideId}`);
    const { data: data, error: error, mutate: mutate } = (0, $voszV.default)(id && `api/applications/${id}`);
    const { data: oidcConfig, error: fetchOidcConfigError, mutate: mutateOidcConfig } = (0, $voszV.default)((0, $byEIK.openIdProviderConfigPath));
    const isLoading = !data && !error || !oidcConfig && !fetchOidcConfigError;
    const requestError = error ?? fetchOidcConfigError;
    if (isGuideView) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $d6e560608b9985da$export$2e2bcd8739ae039), {
        guideId: guideId,
        app: data,
        onClose: ()=>{
            navigate(`/applications/${id}`);
        }
    });
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aa35f43ec98b7478$export$2e2bcd8739ae039), {
        backLink: data?.isThirdParty ? "/applications/third-party-applications" : "/applications",
        backLinkTitle: "application_details.back_to_applications",
        isLoading: isLoading,
        error: requestError,
        onRetry: ()=>{
            mutate();
            mutateOidcConfig();
        },
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5TsIB.default), {
                titleKey: "application_details.page_title"
            }),
            data && oidcConfig && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $999a84d5583b340a$export$2e2bcd8739ae039), {
                data: data,
                oidcConfig: oidcConfig,
                onApplicationUpdated: mutate
            })
        ]
    });
}
var $05740b2d8eb0c6c7$export$2e2bcd8739ae039 = $05740b2d8eb0c6c7$var$ApplicationDetails;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $gcHb7 = parcelRequire("gcHb7");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
parcelRequire("6bq3s");
var $2Phw0 = parcelRequire("2Phw0");





var $5TsIB = parcelRequire("5TsIB");

var $8TpMk = parcelRequire("8TpMk");

var $jGWQ4 = parcelRequire("jGWQ4");

var $18SWy = parcelRequire("18SWy");

var $cw2No = parcelRequire("cw2No");




var $4ZcUR = parcelRequire("4ZcUR");



var $7kooT = parcelRequire("7kooT");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $lXQZH = parcelRequire("lXQZH");
var $61Yml = parcelRequire("61Yml");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
parcelRequire("6bq3s");
var $2Phw0 = parcelRequire("2Phw0");




var $fXNOZ = parcelRequire("fXNOZ");



var $8TpMk = parcelRequire("8TpMk");



var $aTllQ = parcelRequire("aTllQ");

var $fmHmG = parcelRequire("fmHmG");

var $9Q3SI = parcelRequire("9Q3SI");

var $4ZcUR = parcelRequire("4ZcUR");


var $68a68425fe84331e$export$b507296dd3c7a2ce;
var $68a68425fe84331e$export$b33cb64c1b36574c;
var $68a68425fe84331e$export$34e0f9847d4c02dd;
var $68a68425fe84331e$export$a76584009ca8faeb;
var $68a68425fe84331e$export$774b667cba0f8f5f;
var $68a68425fe84331e$export$82462a21aead86ed;
var $68a68425fe84331e$export$d4abd167df80d226;
var $68a68425fe84331e$export$1f1f054184239bf5;
var $68a68425fe84331e$export$93a3f47f7318e7e2;
var $68a68425fe84331e$export$5389c3225d6cd45c;
var $68a68425fe84331e$export$22a8aed2c43b66fd;
var $68a68425fe84331e$export$bfd64c937657f93a;
var $68a68425fe84331e$export$952af3258ed45903;
var $68a68425fe84331e$export$4a6dd88bada4e7d2;
var $68a68425fe84331e$export$662d5fbfe238eb0a;
var $68a68425fe84331e$export$cc74dcc53cfce4eb;
$68a68425fe84331e$export$b507296dd3c7a2ce = `aBenmW_checkboxGroup`;
$68a68425fe84331e$export$b33cb64c1b36574c = `aBenmW_checkboxGroupContainer`;
$68a68425fe84331e$export$34e0f9847d4c02dd = `aBenmW_container`;
$68a68425fe84331e$export$a76584009ca8faeb = `aBenmW_emptyPlaceholder`;
$68a68425fe84331e$export$774b667cba0f8f5f = `aBenmW_filterAnchor`;
$68a68425fe84331e$export$82462a21aead86ed = `aBenmW_filters`;
$68a68425fe84331e$export$d4abd167df80d226 = `aBenmW_groups`;
$68a68425fe84331e$export$1f1f054184239bf5 = `aBenmW_guideGroup`;
$68a68425fe84331e$export$93a3f47f7318e7e2 = `aBenmW_hasFilters`;
$68a68425fe84331e$export$5389c3225d6cd45c = `aBenmW_proTag`;
$68a68425fe84331e$export$22a8aed2c43b66fd = `aBenmW_protectedAppCard`;
$68a68425fe84331e$export$bfd64c937657f93a = `aBenmW_rotating`;
$68a68425fe84331e$export$952af3258ed45903 = `aBenmW_searchInput`;
$68a68425fe84331e$export$4a6dd88bada4e7d2 = `aBenmW_shimmer`;
$68a68425fe84331e$export$662d5fbfe238eb0a = `aBenmW_viewAll`;
$68a68425fe84331e$export$cc74dcc53cfce4eb = `aBenmW_wrapper`;


function $2fe9c8307ccb5a1b$var$GuideLibrary({ className: className, hasCardBorder: hasCardBorder, hasCardButton: hasCardButton }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const { pathname: pathname } = (0, $2Phw0.useLocation)();
    const [keyword, setKeyword] = (0, $jC8Vy.useState)("");
    const [filterCategories, setFilterCategories] = (0, $jC8Vy.useState)([]);
    const [selectedGuide, setSelectedGuide] = (0, $jC8Vy.useState)();
    const { getFilteredAppGuideMetadata: getFilteredAppGuideMetadata, getStructuredAppGuideMetadata: getStructuredAppGuideMetadata } = (0, $c14feef50a46e3d8$export$6b80cd72646f4cab)();
    const [showCreateForm, setShowCreateForm] = (0, $jC8Vy.useState)(false);
    const isApplicationCreateModal = pathname.includes("/applications/create");
    const { currentPlan: currentPlan } = (0, $jC8Vy.useContext)((0, $19434c930f80c964$export$f8addfd4ab69c833));
    const structuredMetadata = (0, $jC8Vy.useMemo)(()=>getStructuredAppGuideMetadata({
            categories: filterCategories
        }), [
        getStructuredAppGuideMetadata,
        filterCategories
    ]);
    const filteredMetadata = (0, $jC8Vy.useMemo)(()=>getFilteredAppGuideMetadata({
            keyword: keyword,
            categories: filterCategories
        }), [
        getFilteredAppGuideMetadata,
        keyword,
        filterCategories
    ]);
    // Only show third party app and machine to machine app in create modal. Hide them by default in the empty app guide page.
    const fullApplicationCategories = (0, $jC8Vy.useMemo)(()=>{
        if (isApplicationCreateModal) return 0, $59106c8950c5d39f$export$a5fbc60a6db6cc4b;
        return (0, $59106c8950c5d39f$export$a5fbc60a6db6cc4b).filter((category)=>category !== (0, $59106c8950c5d39f$export$914bc6e40242037e) && category !== "MachineToMachine");
    }, [
        isApplicationCreateModal
    ]);
    const onClickGuide = (0, $jC8Vy.useCallback)((data)=>{
        setShowCreateForm(true);
        setSelectedGuide(data);
    }, []);
    const onAppCreationCompleted = (0, $jC8Vy.useCallback)((newApp)=>{
        if (newApp && selectedGuide) {
            navigate(// Third party app directly goes to the app detail page
            selectedGuide.isThirdParty ? `/applications/${newApp.id}` : `/applications/${newApp.id}/guide/${selectedGuide.id}`, {
                replace: true
            });
            return;
        }
        setShowCreateForm(false);
        setSelectedGuide(undefined);
    }, [
        navigate,
        selectedGuide
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aTllQ.default), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($68a68425fe84331e$export$34e0f9847d4c02dd, className),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($68a68425fe84331e$export$cc74dcc53cfce4eb, isApplicationCreateModal && $68a68425fe84331e$export$93a3f47f7318e7e2),
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: $68a68425fe84331e$export$d4abd167df80d226,
                    children: [
                        isApplicationCreateModal && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $68a68425fe84331e$export$774b667cba0f8f5f,
                            children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                className: $68a68425fe84331e$export$82462a21aead86ed,
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("label", {
                                        children: t("guide.filter.title")
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                        className: $68a68425fe84331e$export$952af3258ed45903,
                                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $45ba7f7cad465e3f$export$2e2bcd8739ae039), {}),
                                        placeholder: t("guide.filter.placeholder"),
                                        value: keyword,
                                        onChange: (event)=>{
                                            setKeyword(event.currentTarget.value);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $68a68425fe84331e$export$b33cb64c1b36574c,
                                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4a37bd5fa29fd128$export$2e2bcd8739ae039), {
                                            className: $68a68425fe84331e$export$b507296dd3c7a2ce,
                                            options: (0, $59106c8950c5d39f$export$a5fbc60a6db6cc4b).filter((category)=>(0, $8TpMk.isCloud) || category !== "Protected").map((category)=>({
                                                    title: `guide.categories.${category}`,
                                                    value: category,
                                                    ...(0, $7oDSS.cond)((0, $8TpMk.isCloud) && category === "ThirdParty" && {
                                                        tag: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fXNOZ.default), {
                                                            isVisible: currentPlan.quota.thirdPartyApplicationsLimit === 0,
                                                            plan: (0, $lXQZH.ReservedPlanId).Pro
                                                        })
                                                    })
                                                })),
                                            value: filterCategories,
                                            onChange: (value)=>{
                                                const sortedValue = (0, $59106c8950c5d39f$export$a5fbc60a6db6cc4b).filter((category)=>value.includes(category));
                                                setFilterCategories(sortedValue);
                                            }
                                        })
                                    })
                                ]
                            })
                        }),
                        keyword && (filteredMetadata.length > 0 ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $742494c24a2c2466$export$2e2bcd8739ae039), {
                            className: $68a68425fe84331e$export$1f1f054184239bf5,
                            hasCardBorder: hasCardBorder,
                            hasCardButton: hasCardButton,
                            guides: filteredMetadata,
                            onClickGuide: onClickGuide
                        }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a0f84bc7cc69e410$export$2e2bcd8739ae039), {
                            className: $68a68425fe84331e$export$a76584009ca8faeb,
                            size: "large"
                        })),
                        !keyword && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                            children: [
                                (0, $8TpMk.isCloud) && (filterCategories.length === 0 || filterCategories.includes((0, $61Yml.ApplicationType).Protected)) && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a0d482ac4311ce46$export$2e2bcd8739ae039), {
                                    isInAppCreationPage: true,
                                    hasCreateButton: true,
                                    hasBorder: hasCardBorder,
                                    className: $68a68425fe84331e$export$22a8aed2c43b66fd
                                }),
                                (filterCategories.length > 0 ? filterCategories : fullApplicationCategories).map((category)=>structuredMetadata[category].length > 0 && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $742494c24a2c2466$export$2e2bcd8739ae039), {
                                        className: $68a68425fe84331e$export$1f1f054184239bf5,
                                        hasCardBorder: hasCardBorder,
                                        hasCardButton: hasCardButton,
                                        categoryName: t(`guide.categories.${category}`),
                                        guides: structuredMetadata[category],
                                        onClickGuide: onClickGuide
                                    }, category))
                            ]
                        }),
                        !isApplicationCreateModal && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                            className: $68a68425fe84331e$export$662d5fbfe238eb0a,
                            to: "/applications/create",
                            children: t("get_started.view_all")
                        })
                    ]
                })
            }),
            selectedGuide?.target !== "API" && showCreateForm && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $87d78ab4d5324714$export$2e2bcd8739ae039), {
                defaultCreateType: selectedGuide?.target,
                defaultCreateFrameworkName: selectedGuide?.name,
                isDefaultCreateThirdParty: selectedGuide?.isThirdParty,
                onCompleted: onAppCreationCompleted
            })
        ]
    });
}
var $2fe9c8307ccb5a1b$export$2e2bcd8739ae039 = $2fe9c8307ccb5a1b$var$GuideLibrary;



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $kUZ14 = parcelRequire("kUZ14");




var $4ZcUR = parcelRequire("4ZcUR");

var $dW2kG = parcelRequire("dW2kG");

var $c3bb59fbd4038e5c$export$34e0f9847d4c02dd;
var $c3bb59fbd4038e5c$export$a7db06668cad9adb;
var $c3bb59fbd4038e5c$export$f0c9323dff8f5149;
var $c3bb59fbd4038e5c$export$bfd64c937657f93a;
var $c3bb59fbd4038e5c$export$4a6dd88bada4e7d2;
$c3bb59fbd4038e5c$export$34e0f9847d4c02dd = `oksFFW_container`;
$c3bb59fbd4038e5c$export$a7db06668cad9adb = `oksFFW_content`;
$c3bb59fbd4038e5c$export$f0c9323dff8f5149 = `oksFFW_footerInnerWrapper`;
$c3bb59fbd4038e5c$export$bfd64c937657f93a = `oksFFW_rotating`;
$c3bb59fbd4038e5c$export$4a6dd88bada4e7d2 = `oksFFW_shimmer`;


function $2e794ea84a430700$var$GuideLibraryModal({ isOpen: isOpen, onClose: onClose }) {
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const [showCreateForm, setShowCreateForm] = (0, $jC8Vy.useState)(false);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        shouldCloseOnEsc: true,
        isOpen: isOpen,
        className: $dW2kG.fullScreen,
        onRequestClose: onClose,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $c3bb59fbd4038e5c$export$34e0f9847d4c02dd,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $81c55e09caea137c$export$2e2bcd8739ae039), {
                        title: "guide.app.guide_modal_title",
                        subtitle: "guide.app.modal_subtitle",
                        buttonText: "guide.cannot_find_guide",
                        requestFormFieldLabel: "guide.describe_guide_looking_for",
                        requestFormFieldPlaceholder: "guide.app.describe_guide_looking_for_placeholder",
                        requestSuccessMessage: "guide.request_guide_successfully",
                        onClose: onClose
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2fe9c8307ccb5a1b$export$2e2bcd8739ae039), {
                        hasCardButton: true,
                        className: $c3bb59fbd4038e5c$export$a7db06668cad9adb
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e8d0f46f7ce96736$export$2e2bcd8739ae039), {
                        wrapperClassName: $c3bb59fbd4038e5c$export$f0c9323dff8f5149,
                        content: "guide.do_not_need_tutorial",
                        buttonText: "guide.app.continue_without_framework",
                        onClick: ()=>{
                            setShowCreateForm(true);
                        }
                    })
                ]
            }),
            showCreateForm && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $87d78ab4d5324714$export$2e2bcd8739ae039), {
                onCompleted: (newApp)=>{
                    if (newApp) navigate(`/applications/${newApp.id}`);
                    setShowCreateForm(false);
                }
            })
        ]
    });
}
var $2e794ea84a430700$export$2e2bcd8739ae039 = $2e794ea84a430700$var$GuideLibraryModal;



var $jC8Vy = parcelRequire("jC8Vy");

var $voszV = parcelRequire("voszV");

var $8Mb3E = parcelRequire("8Mb3E");


var $7kooT = parcelRequire("7kooT");
const $c3d925a435188423$var$pageSize = (0, $8Mb3E.defaultPageSize);
const $c3d925a435188423$var$applicationsEndpoint = "api/applications";
/**
 * @typeof {Object} ApplicationData
 *
 * @property data - The application data of the current active tab, returned from useSWR.
 * @property error - The request error of the current active tab returned from useSWR.
 * @property mutate - The mutate function of the current active tab returned from useSWR.
 * @property pagination - The pagination data of the current active tab. It contains the current page and page size.
 * @property paginationRecords - Returns the global pagination records of the first party and third party applications.
 *    This is used to keep track of the pagination when switching between tabs by passing the page records to the tab navigation.
 * @property updatePagination - The function to update the pagination of the current active tab.
 * @property showThirdPartyApplicationTab - The flag to show the third party application tab. Hide the tab if there is no third party applications.
 */ /**
 * This hook is used to keep track of the first party and third party applications data with pagination.
 *
 * @param isThirdParty
 * @returns {ApplicationData}
 */ const $c3d925a435188423$var$useApplicationsData = (isThirdParty = false)=>{
    const [{ page: page }, updateSearchParameters] = (0, $66a3eb3654f9d141$export$2e2bcd8739ae039)({
        page: 1
    });
    const [firstPartyApplicationPage, setFirstPartyApplicationPage] = (0, $jC8Vy.useState)(isThirdParty ? 1 : page);
    const [thirdPartyApplicationPage, setThirdPartyApplicationPage] = (0, $jC8Vy.useState)(isThirdParty ? page : 1);
    const updatePagination = (0, $jC8Vy.useCallback)((page)=>{
        updateSearchParameters({
            page: page
        });
    }, [
        updateSearchParameters
    ]);
    (0, $jC8Vy.useEffect)(()=>{
        // Update the pagination records based on the current active tab.
        if (isThirdParty) setThirdPartyApplicationPage(page);
        else setFirstPartyApplicationPage(page);
    }, [
        page,
        isThirdParty
    ]);
    const firstPartyApplicationsFetchUrl = (0, $jC8Vy.useMemo)(()=>(0, $7kooT.buildUrl)($c3d925a435188423$var$applicationsEndpoint, {
            page: String(firstPartyApplicationPage),
            page_size: String($c3d925a435188423$var$pageSize),
            isThirdParty: "false"
        }), [
        firstPartyApplicationPage
    ]);
    const thirdPartyApplicationsFetchUrl = (0, $jC8Vy.useMemo)(()=>(0, $7kooT.buildUrl)($c3d925a435188423$var$applicationsEndpoint, {
            page: String(thirdPartyApplicationPage),
            page_size: String($c3d925a435188423$var$pageSize),
            isThirdParty: "true"
        }), [
        thirdPartyApplicationPage
    ]);
    const firstPartyApplicationsData = (0, $voszV.default)(firstPartyApplicationsFetchUrl);
    const thirdPartyApplicationsData = (0, $voszV.default)(thirdPartyApplicationsFetchUrl);
    const { data: data } = thirdPartyApplicationsData;
    const [_, totalCount] = data ?? [];
    const hasThirdPartyApplications = Boolean(totalCount && totalCount > 0);
    return {
        ...isThirdParty ? thirdPartyApplicationsData : firstPartyApplicationsData,
        pagination: {
            page: isThirdParty ? thirdPartyApplicationPage : firstPartyApplicationPage,
            pageSize: $c3d925a435188423$var$pageSize
        },
        paginationRecords: {
            firstPartyApplicationPage: firstPartyApplicationPage,
            thirdPartyApplicationPage: thirdPartyApplicationPage
        },
        showThirdPartyApplicationTab: hasThirdPartyApplications,
        updatePagination: updatePagination
    };
};
var $c3d925a435188423$export$2e2bcd8739ae039 = $c3d925a435188423$var$useApplicationsData;


var $a15e1fb9d5fbd762$export$25ada6361acbb81c;
var $a15e1fb9d5fbd762$export$25b61ec9da546d46;
var $a15e1fb9d5fbd762$export$deecac453d2344ce;
var $a15e1fb9d5fbd762$export$1ca1ec8b29a4ce27;
var $a15e1fb9d5fbd762$export$b839f963c7dc0e34;
var $a15e1fb9d5fbd762$export$bfd64c937657f93a;
var $a15e1fb9d5fbd762$export$4a6dd88bada4e7d2;
var $a15e1fb9d5fbd762$export$39f5674517ec0000;
var $a15e1fb9d5fbd762$export$fb184b623420d9be;
$a15e1fb9d5fbd762$export$25ada6361acbb81c = `_7_IiMW_applicationName`;
$a15e1fb9d5fbd762$export$25b61ec9da546d46 = `_7_IiMW_chargeNotification`;
$a15e1fb9d5fbd762$export$deecac453d2344ce = `_7_IiMW_guideLibraryContainer`;
$a15e1fb9d5fbd762$export$1ca1ec8b29a4ce27 = `_7_IiMW_icon`;
$a15e1fb9d5fbd762$export$b839f963c7dc0e34 = `_7_IiMW_library`;
$a15e1fb9d5fbd762$export$bfd64c937657f93a = `_7_IiMW_rotating`;
$a15e1fb9d5fbd762$export$4a6dd88bada4e7d2 = `_7_IiMW_shimmer`;
$a15e1fb9d5fbd762$export$39f5674517ec0000 = `_7_IiMW_tabs`;
$a15e1fb9d5fbd762$export$fb184b623420d9be = `_7_IiMW_title`;


const $0c947782c24bacd4$var$tabs = Object.freeze({
    thirdPartyApplications: "third-party-applications"
});
const $0c947782c24bacd4$var$applicationsPathname = "/applications";
const $0c947782c24bacd4$var$createApplicationPathname = `${$0c947782c24bacd4$var$applicationsPathname}/create`;
const $0c947782c24bacd4$var$buildDetailsPathname = (id)=>`${$0c947782c24bacd4$var$applicationsPathname}/${id}`;
// Build the path with pagination query param for the tabs
const $0c947782c24bacd4$var$buildTabPathWithPagePagination = (page, tab)=>{
    const pathname = tab ? (0, $gcHb7.joinPath)($0c947782c24bacd4$var$applicationsPathname, $0c947782c24bacd4$var$tabs.thirdPartyApplications) : $0c947782c24bacd4$var$applicationsPathname;
    return page > 1 ? (0, $7kooT.buildUrl)(pathname, {
        page: String(page)
    }) : pathname;
};
function $0c947782c24bacd4$var$Applications({ tab: tab }) {
    const { search: search } = (0, $2Phw0.useLocation)();
    const { match: match, navigate: navigate } = (0, $4ZcUR.default)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const isCreating = match($0c947782c24bacd4$var$createApplicationPathname);
    const { hasMachineToMachineAppsSurpassedLimit: hasMachineToMachineAppsSurpassedLimit } = (0, $d2d1111984d2f594$export$2e2bcd8739ae039)();
    const { data: data, error: error, mutate: mutate, pagination: pagination, updatePagination: updatePagination, paginationRecords: paginationRecords, showThirdPartyApplicationTab: showThirdPartyApplicationTab } = (0, $c3d925a435188423$export$2e2bcd8739ae039)(tab === "thirdPartyApplications");
    const isLoading = !data && !error;
    const [applications, totalCount] = data ?? [];
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $7ddbeb184b5d4257$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5TsIB.default), {
                titleKey: "applications.title"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $7ddbeb184b5d4257$export$516dd90aeaaabcf0,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $18SWy.default), {
                        title: "applications.title",
                        subtitle: "applications.subtitle"
                    }),
                    !!totalCount && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0b30fe81c923292b$export$2e2bcd8739ae039), {}),
                        type: "primary",
                        size: "large",
                        title: "applications.create",
                        onClick: ()=>{
                            navigate({
                                pathname: $0c947782c24bacd4$var$createApplicationPathname,
                                search: search
                            });
                        }
                    })
                ]
            }),
            (0, $8TpMk.isCloud) && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $69ac10e11f23c995$export$2e2bcd8739ae039), {
                hasSurpassedLimit: hasMachineToMachineAppsSurpassedLimit,
                quotaItemPhraseKey: "machine_to_machine",
                className: $a15e1fb9d5fbd762$export$25b61ec9da546d46,
                checkedFlagKey: "machineToMachineApp"
            }),
            showThirdPartyApplicationTab && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $26090e0c44b20d28$export$2e2bcd8739ae039), {
                className: $a15e1fb9d5fbd762$export$39f5674517ec0000,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                        href: $0c947782c24bacd4$var$buildTabPathWithPagePagination(paginationRecords.firstPartyApplicationPage),
                        isActive: !tab,
                        children: t("applications.tab.my_applications")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                        href: $0c947782c24bacd4$var$buildTabPathWithPagePagination(paginationRecords.thirdPartyApplicationPage, "thirdPartyApplications"),
                        isActive: tab === "thirdPartyApplications",
                        children: t("applications.tab.third_party_applications")
                    })
                ]
            }),
            !isLoading && !applications?.length && /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $a15e1fb9d5fbd762$export$deecac453d2344ce,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $18SWy.default), {
                        className: $a15e1fb9d5fbd762$export$fb184b623420d9be,
                        title: "guide.app.select_framework_or_tutorial",
                        subtitle: "guide.app.modal_subtitle"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2fe9c8307ccb5a1b$export$2e2bcd8739ae039), {
                        hasCardBorder: true,
                        hasCardButton: true,
                        className: $a15e1fb9d5fbd762$export$b839f963c7dc0e34
                    })
                ]
            }),
            (isLoading || !!applications?.length) && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3166f28a681c41bb$export$2e2bcd8739ae039), {
                isLoading: isLoading,
                className: $7ddbeb184b5d4257$export$9852986a3ec5f6a0,
                rowGroups: [
                    {
                        key: "applications",
                        data: applications
                    }
                ],
                rowIndexKey: "id",
                errorMessage: error?.body?.message ?? error?.message,
                columns: [
                    {
                        title: t("applications.application_name"),
                        dataIndex: "name",
                        colSpan: 6,
                        render: ({ id: id, name: name, type: type, isThirdParty: isThirdParty })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $4d952cae22cb03fc$export$2e2bcd8739ae039), {
                                title: name,
                                subtitle: isThirdParty ? t(`${(0, $59106c8950c5d39f$export$d8e4c8dab9129f15).thirdParty}.title`) : t(`${(0, $59106c8950c5d39f$export$d8e4c8dab9129f15)[type]}.title`),
                                icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e07e369caa387826$export$2e2bcd8739ae039), {
                                    className: $a15e1fb9d5fbd762$export$1ca1ec8b29a4ce27,
                                    type: type,
                                    isThirdParty: isThirdParty
                                }),
                                to: $0c947782c24bacd4$var$buildDetailsPathname(id)
                            })
                    },
                    {
                        title: t("applications.app_id"),
                        dataIndex: "id",
                        colSpan: 10,
                        render: ({ id: id })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
                                value: id,
                                variant: "text"
                            })
                    }
                ],
                rowClickHandler: ({ id: id })=>{
                    navigate($0c947782c24bacd4$var$buildDetailsPathname(id));
                },
                pagination: {
                    ...pagination,
                    totalCount: totalCount,
                    onChange: updatePagination
                },
                onRetry: async ()=>mutate(undefined, true)
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2e794ea84a430700$export$2e2bcd8739ae039), {
                isOpen: isCreating,
                onClose: ()=>{
                    navigate(-1);
                }
            })
        ]
    });
}
var $0c947782c24bacd4$export$2e2bcd8739ae039 = $0c947782c24bacd4$var$Applications;


/* eslint-disable complexity */ 
var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5TTZn = parcelRequire("5TTZn");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
parcelRequire("6bq3s");
var $2Phw0 = parcelRequire("2Phw0");
var $2Phw0 = parcelRequire("2Phw0");

var $voszV = parcelRequire("voszV");



var $5TsIB = parcelRequire("5TsIB");


var $h8YkU = parcelRequire("h8YkU");

var $gC7hG = parcelRequire("gC7hG");

var $kUskP = parcelRequire("kUskP");

var $8R7rc = parcelRequire("8R7rc");

var $aqmjm = parcelRequire("aqmjm");

parcelRequire("cuPVN");
var $7CUeL = parcelRequire("7CUeL");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");
const $0329986f2f441fa6$export$267897f64bb59b59 = {
    toLocalForm: (data)=>{
        const { event: event, events: events, name: name, config: { url: url, headers: headers } } = data;
        const headerFields = (0, $7oDSS.conditional)(headers && Object.entries(headers).map(([key, value])=>({
                key: key,
                value: value
            })));
        return {
            events: (0, $7oDSS.conditional)(events.length > 0 && events) ?? (event ? [
                event
            ] : []),
            name: name,
            url: url,
            headers: headerFields?.length ? headerFields : [
                {
                    key: "",
                    value: ""
                }
            ]
        };
    },
    toRemoteModel: (formData)=>{
        const { name: name, events: events, url: url, headers: headers } = formData;
        const headersObject = (0, $7oDSS.conditional)(headers && Object.fromEntries(headers.filter(({ key: key, value: value })=>key && value).map(({ key: key, value: value })=>[
                key,
                value
            ])));
        return {
            name: name,
            events: events,
            config: {
                url: url,
                headers: headersObject,
                /**
         * This is for backward compatibility.
         */ retries: 3
            }
        };
    }
};
const $0329986f2f441fa6$export$4ddfaf1ad2964c7a = (event)=>`TriggerHook.${event}`;
const $0329986f2f441fa6$export$3ab72c193bc99e07 = (logKey)=>{
    const [prefix, ...events] = logKey.split(".");
    // eslint-disable-next-line no-restricted-syntax
    return prefix === "TriggerHook" && (0, $7CUeL.hookEvents).includes(events.join("."));
};
const $0329986f2f441fa6$export$3a881692556fa951 = (logKey)=>{
    if (!$0329986f2f441fa6$export$3ab72c193bc99e07(logKey)) return " - ";
    return logKey.replace("TriggerHook.", "");
};




var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");


var $d2413374337ae33f$export$2b62a06a9fee979c;
var $d2413374337ae33f$export$1ca1ec8b29a4ce27;
var $d2413374337ae33f$export$1237798dc640739a;
var $d2413374337ae33f$export$fe7c49d056ea1d88;
$d2413374337ae33f$export$2b62a06a9fee979c = `_1f0U4G_fail`;
$d2413374337ae33f$export$1ca1ec8b29a4ce27 = `_1f0U4G_icon`;
$d2413374337ae33f$export$1237798dc640739a = `_1f0U4G_label`;
$d2413374337ae33f$export$fe7c49d056ea1d88 = `_1f0U4G_success`;


function $9294e564633e1bd3$var$EventIcon({ isSuccess: isSuccess }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: isSuccess ? $d2413374337ae33f$export$fe7c49d056ea1d88 : $d2413374337ae33f$export$2b62a06a9fee979c,
                children: isSuccess ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $863c8122c7186617$export$2e2bcd8739ae039), {
                    className: $d2413374337ae33f$export$1ca1ec8b29a4ce27
                }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $10eea442689aa670$export$2e2bcd8739ae039), {
                    className: $d2413374337ae33f$export$1ca1ec8b29a4ce27
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $d2413374337ae33f$export$1237798dc640739a,
                children: t(isSuccess ? "log_details.success" : "log_details.failed")
            })
        ]
    });
}
var $9294e564633e1bd3$export$2e2bcd8739ae039 = $9294e564633e1bd3$var$EventIcon;


var $dfd731bc8d4317ad$export$ff9539f96fd6527c;
var $dfd731bc8d4317ad$export$32180ef41b15b513;
var $dfd731bc8d4317ad$export$a7db06668cad9adb;
var $dfd731bc8d4317ad$export$a0305a8c6cff19c8;
var $dfd731bc8d4317ad$export$38e42c68cf43b5d4;
var $dfd731bc8d4317ad$export$e9205afa0ff1255b;
var $dfd731bc8d4317ad$export$1237798dc640739a;
var $dfd731bc8d4317ad$export$f22da7240b7add18;
var $dfd731bc8d4317ad$export$bfd64c937657f93a;
var $dfd731bc8d4317ad$export$4a6dd88bada4e7d2;
$dfd731bc8d4317ad$export$ff9539f96fd6527c = `tI75Cq_basicInfo`;
$dfd731bc8d4317ad$export$32180ef41b15b513 = `tI75Cq_body`;
$dfd731bc8d4317ad$export$a7db06668cad9adb = `tI75Cq_content`;
$dfd731bc8d4317ad$export$a0305a8c6cff19c8 = `tI75Cq_eventName`;
$dfd731bc8d4317ad$export$38e42c68cf43b5d4 = `tI75Cq_header`;
$dfd731bc8d4317ad$export$e9205afa0ff1255b = `tI75Cq_infoItem`;
$dfd731bc8d4317ad$export$1237798dc640739a = `tI75Cq_label`;
$dfd731bc8d4317ad$export$f22da7240b7add18 = `tI75Cq_main`;
$dfd731bc8d4317ad$export$bfd64c937657f93a = `tI75Cq_rotating`;
$dfd731bc8d4317ad$export$4a6dd88bada4e7d2 = `tI75Cq_shimmer`;


const $01bafbd02b1a9b1b$var$getAuditLogDetailsRelatedResourceLink = (pathname)=>`${pathname.slice(0, pathname.lastIndexOf("/"))}`;
const $01bafbd02b1a9b1b$var$getDetailsTabNavLink = (logId, userId)=>userId ? `/users/${userId}/logs/${logId}` : `/audit-logs/${logId}`;
function $01bafbd02b1a9b1b$var$AuditLogDetails() {
    const { appId: appId, userId: userId, hookId: hookId, logId: logId } = (0, $2Phw0.useParams)();
    const { pathname: pathname } = (0, $2Phw0.useLocation)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: data, error: error, mutate: mutate } = (0, $voszV.default)(logId && `api/logs/${logId}`);
    const { data: appData } = (0, $voszV.default)(appId && `api/applications/${appId}`);
    const { data: userData } = (0, $voszV.default)(userId && `api/users/${userId}`);
    const { data: hookData } = (0, $voszV.default)(hookId && `api/hooks/${hookId}`);
    const isLoading = !data && !error;
    const backLink = $01bafbd02b1a9b1b$var$getAuditLogDetailsRelatedResourceLink(pathname);
    const backLinkTitle = (0, $7oDSS.conditional)(userId && t("log_details.back_to", {
        name: (0, $46451cbb59c7a857$export$5f7a1baecd59f846)(userData)
    })) ?? (0, $7oDSS.conditional)(hookId && t("log_details.back_to", {
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        name: hookData?.name || t("general.unnamed")
    })) ?? (0, $7oDSS.conditional)(appId && t("log_details.back_to", {
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        name: appData?.name || t("general.unnamed")
    })) ?? t("log_details.back_to_logs");
    if (!logId) return null;
    const isWebHookEvent = (0, $0329986f2f441fa6$export$3ab72c193bc99e07)(data?.key ?? "");
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aa35f43ec98b7478$export$2e2bcd8739ae039), {
        backLink: backLink,
        backLinkTitle: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8R7rc.default), {
            children: backLinkTitle
        }),
        isLoading: isLoading,
        error: error,
        onRetry: mutate,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5TsIB.default), {
                titleKey: "log_details.page_title"
            }),
            data && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
                        className: $dfd731bc8d4317ad$export$38e42c68cf43b5d4,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9294e564633e1bd3$export$2e2bcd8739ae039), {
                                isSuccess: data.payload.result === "Success"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                className: $dfd731bc8d4317ad$export$a7db06668cad9adb,
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $dfd731bc8d4317ad$export$a0305a8c6cff19c8,
                                        children: (0, $h8YkU.logEventTitle)[data.key]
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                        className: $dfd731bc8d4317ad$export$ff9539f96fd6527c,
                                        children: [
                                            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                                className: $dfd731bc8d4317ad$export$e9205afa0ff1255b,
                                                children: [
                                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                        className: $dfd731bc8d4317ad$export$1237798dc640739a,
                                                        children: t("log_details.event_key")
                                                    }),
                                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                        children: data.key
                                                    })
                                                ]
                                            }),
                                            !isWebHookEvent && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                                        className: $dfd731bc8d4317ad$export$e9205afa0ff1255b,
                                                        children: [
                                                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                                className: $dfd731bc8d4317ad$export$1237798dc640739a,
                                                                children: t("log_details.application")
                                                            }),
                                                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                                children: data.payload.applicationId ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0004ff537e7bb7fe$export$2e2bcd8739ae039), {
                                                                    isLink: data.payload.applicationId !== (0, $5TTZn.demoAppApplicationId),
                                                                    applicationId: data.payload.applicationId
                                                                }) : "-"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                                        className: $dfd731bc8d4317ad$export$e9205afa0ff1255b,
                                                        children: [
                                                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                                className: $dfd731bc8d4317ad$export$1237798dc640739a,
                                                                children: t("log_details.ip_address")
                                                            }),
                                                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                                children: data.payload.ip ?? "-"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                                        className: $dfd731bc8d4317ad$export$e9205afa0ff1255b,
                                                        children: [
                                                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                                className: $dfd731bc8d4317ad$export$1237798dc640739a,
                                                                children: t("log_details.user")
                                                            }),
                                                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                                children: data.payload.userId ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e1be354dd609d651$export$2e2bcd8739ae039), {
                                                                    isLink: true,
                                                                    userId: data.payload.userId
                                                                }) : "-"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                                className: $dfd731bc8d4317ad$export$e9205afa0ff1255b,
                                                children: [
                                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                        className: $dfd731bc8d4317ad$export$1237798dc640739a,
                                                        children: t("log_details.log_id")
                                                    }),
                                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                        children: data.id
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                                className: $dfd731bc8d4317ad$export$e9205afa0ff1255b,
                                                children: [
                                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                        className: $dfd731bc8d4317ad$export$1237798dc640739a,
                                                        children: t("log_details.time")
                                                    }),
                                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                        children: new Date(data.createdAt).toLocaleString()
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    !isWebHookEvent && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                            className: $dfd731bc8d4317ad$export$e9205afa0ff1255b,
                                            children: [
                                                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                    className: $dfd731bc8d4317ad$export$1237798dc640739a,
                                                    children: t("log_details.user_agent")
                                                }),
                                                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                    children: data.payload.userAgent
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $26090e0c44b20d28$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                            href: $01bafbd02b1a9b1b$var$getDetailsTabNavLink(logId, userId),
                            children: t("log_details.tab_details")
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $gC7hG.default), {
                        className: $dfd731bc8d4317ad$export$32180ef41b15b513,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $dfd731bc8d4317ad$export$f22da7240b7add18,
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                title: "log_details.raw_data",
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $kUskP.default), {
                                    language: "json",
                                    value: JSON.stringify(data.payload, null, 2)
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
}
var $01bafbd02b1a9b1b$export$2e2bcd8739ae039 /* eslint-enable complexity */  = $01bafbd02b1a9b1b$var$AuditLogDetails;


const $ca1fff02ab32f880$export$e7ad650a602a37dc = {
    path: "applications",
    children: [
        {
            index: true,
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0c947782c24bacd4$export$2e2bcd8739ae039), {})
        },
        {
            path: "third-party-applications",
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0c947782c24bacd4$export$2e2bcd8739ae039), {
                tab: "thirdPartyApplications"
            })
        },
        {
            path: "create",
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0c947782c24bacd4$export$2e2bcd8739ae039), {})
        },
        {
            path: ":id/guide/:guideId",
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $05740b2d8eb0c6c7$export$2e2bcd8739ae039), {})
        },
        {
            path: ":id",
            children: [
                {
                    index: true,
                    element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Navigate), {
                        replace: true,
                        to: (0, $bt3dS.ApplicationDetailsTabs).Settings
                    })
                },
                {
                    path: ":tab",
                    element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $05740b2d8eb0c6c7$export$2e2bcd8739ae039), {})
                }
            ]
        },
        {
            path: `:appId/${(0, $bt3dS.ApplicationDetailsTabs).Logs}/:logId`,
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $01bafbd02b1a9b1b$export$2e2bcd8739ae039), {})
        }
    ]
};



var $C7mD2 = parcelRequire("C7mD2");


var $C7mD2 = parcelRequire("C7mD2");


var $5TsIB = parcelRequire("5TsIB");

var $18SWy = parcelRequire("18SWy");

function $44be36c50961a077$var$AuditLogs() {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $7ddbeb184b5d4257$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5TsIB.default), {
                titleKey: "logs.page_title"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $7ddbeb184b5d4257$export$516dd90aeaaabcf0,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $18SWy.default), {
                    title: "logs.title",
                    subtitle: "logs.subtitle"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $85bd40f9f49866bd$export$2e2bcd8739ae039), {
                className: $7ddbeb184b5d4257$export$9852986a3ec5f6a0
            })
        ]
    });
}
var $44be36c50961a077$export$2e2bcd8739ae039 = $44be36c50961a077$var$AuditLogs;


const $a728fa81fe4486eb$export$5200962c4a74900e = {
    path: "audit-logs",
    children: [
        {
            index: true,
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $44be36c50961a077$export$2e2bcd8739ae039), {})
        },
        {
            path: ":logId",
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $01bafbd02b1a9b1b$export$2e2bcd8739ae039), {})
        }
    ]
};



var $C7mD2 = parcelRequire("C7mD2");

var $2Phw0 = parcelRequire("2Phw0");
parcelRequire("8Mb3E");
var $bt3dS = parcelRequire("bt3dS");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("oK7kD");
var $7YxsJ = parcelRequire("7YxsJ");
parcelRequire("cuPVN");
var $kowfT = parcelRequire("kowfT");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
parcelRequire("6bq3s");
var $2Phw0 = parcelRequire("2Phw0");
var $2Phw0 = parcelRequire("2Phw0");
parcelRequire("voszV");
var $hgWIN = parcelRequire("hgWIN");
var $voszV = parcelRequire("voszV");



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $bf46177f0fb84c60$var$SvgReset = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M10 1.667a8.333 8.333 0 0 0-5.733 2.308V2.5a.833.833 0 1 0-1.667 0v3.75a.833.833 0 0 0 .834.833h3.75a.833.833 0 0 0 0-1.666h-2A6.667 6.667 0 1 1 3.334 10a.833.833 0 1 0-1.667 0A8.333 8.333 0 1 0 10 1.667Zm0 5a.833.833 0 0 0-.833.833V10a.833.833 0 0 0 .833.833h1.667a.833.833 0 1 0 0-1.666h-.833V7.5A.833.833 0 0 0 10 6.667Z",
            fill: "currentColor"
        })
    });
var $bf46177f0fb84c60$export$2e2bcd8739ae039 = $bf46177f0fb84c60$var$SvgReset;




var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $kowfT = parcelRequire("kowfT");

var $jC8Vy = parcelRequire("jC8Vy");

var $kUZ14 = parcelRequire("kUZ14");

var $voszV = parcelRequire("voszV");

var $66ixW = parcelRequire("66ixW");

var $5vVWy = parcelRequire("5vVWy");

var $dW2kG = parcelRequire("dW2kG");


var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");


var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");


var $ee88d6a981085d70$export$f79a732982c93a3b;
var $ee88d6a981085d70$export$1ed84f4bcea4be27;
var $ee88d6a981085d70$export$a7db06668cad9adb;
var $ee88d6a981085d70$export$6d59db4903f20f7d;
var $ee88d6a981085d70$export$a8ff84c12d48cfa6;
var $ee88d6a981085d70$export$bfd64c937657f93a;
var $ee88d6a981085d70$export$4a6dd88bada4e7d2;
$ee88d6a981085d70$export$f79a732982c93a3b = `BnCFfW_connector`;
$ee88d6a981085d70$export$1ed84f4bcea4be27 = `BnCFfW_connectorId`;
$ee88d6a981085d70$export$a7db06668cad9adb = `BnCFfW_content`;
$ee88d6a981085d70$export$6d59db4903f20f7d = `BnCFfW_description`;
$ee88d6a981085d70$export$a8ff84c12d48cfa6 = `BnCFfW_name`;
$ee88d6a981085d70$export$bfd64c937657f93a = `BnCFfW_rotating`;
$ee88d6a981085d70$export$4a6dd88bada4e7d2 = `BnCFfW_shimmer`;


function $be1841dc6e4f55bd$var$ConnectorRadio({ data: { name: name, logo: logo, logoDark: logoDark, description: description } }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $ee88d6a981085d70$export$f79a732982c93a3b,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $34186e61374ae5f6$export$2e2bcd8739ae039), {
                data: {
                    logo: logo,
                    logoDark: logoDark
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $ee88d6a981085d70$export$a7db06668cad9adb,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($ee88d6a981085d70$export$a8ff84c12d48cfa6),
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ee1df03577241ccd$export$2e2bcd8739ae039), {
                            resource: name
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $ee88d6a981085d70$export$6d59db4903f20f7d,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ee1df03577241ccd$export$2e2bcd8739ae039), {
                            resource: description
                        })
                    })
                ]
            })
        ]
    });
}
var $be1841dc6e4f55bd$export$2e2bcd8739ae039 = $be1841dc6e4f55bd$var$ConnectorRadio;


var $ee0f80e1eeac5e9f$exports = {};

$parcel$export($ee0f80e1eeac5e9f$exports, "connectorGroup", function () { return $ee0f80e1eeac5e9f$export$8a5ac33d5834e89d; }, function (v) { return $ee0f80e1eeac5e9f$export$8a5ac33d5834e89d = v; });
$parcel$export($ee0f80e1eeac5e9f$exports, "large", function () { return $ee0f80e1eeac5e9f$export$f09585a853dddd32; }, function (v) { return $ee0f80e1eeac5e9f$export$f09585a853dddd32 = v; });
$parcel$export($ee0f80e1eeac5e9f$exports, "medium", function () { return $ee0f80e1eeac5e9f$export$649ecc744817b5c7; }, function (v) { return $ee0f80e1eeac5e9f$export$649ecc744817b5c7 = v; });
$parcel$export($ee0f80e1eeac5e9f$exports, "rotating", function () { return $ee0f80e1eeac5e9f$export$bfd64c937657f93a; }, function (v) { return $ee0f80e1eeac5e9f$export$bfd64c937657f93a = v; });
$parcel$export($ee0f80e1eeac5e9f$exports, "shimmer", function () { return $ee0f80e1eeac5e9f$export$4a6dd88bada4e7d2; }, function (v) { return $ee0f80e1eeac5e9f$export$4a6dd88bada4e7d2 = v; });
var $ee0f80e1eeac5e9f$export$8a5ac33d5834e89d;
var $ee0f80e1eeac5e9f$export$f09585a853dddd32;
var $ee0f80e1eeac5e9f$export$649ecc744817b5c7;
var $ee0f80e1eeac5e9f$export$bfd64c937657f93a;
var $ee0f80e1eeac5e9f$export$4a6dd88bada4e7d2;
$ee0f80e1eeac5e9f$export$8a5ac33d5834e89d = `ZBQxdG_connectorGroup`;
$ee0f80e1eeac5e9f$export$f09585a853dddd32 = `ZBQxdG_large`;
$ee0f80e1eeac5e9f$export$649ecc744817b5c7 = `ZBQxdG_medium`;
$ee0f80e1eeac5e9f$export$bfd64c937657f93a = `ZBQxdG_rotating`;
$ee0f80e1eeac5e9f$export$4a6dd88bada4e7d2 = `ZBQxdG_shimmer`;


function $6cea2629c5e6614b$var$ConnectorRadioGroup({ name: name, groups: groups, value: value, size: size, onChange: onChange }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c8e461321115642d$export$2e2bcd8739ae039), {
        name: name,
        value: value,
        type: "card",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($ee0f80e1eeac5e9f$exports.connectorGroup, $ee0f80e1eeac5e9f$exports[size]),
        onChange: onChange,
        children: groups.map((data)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $b4b7cf2a2e4180e8$export$2e2bcd8739ae039), {
                value: data.id,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $be1841dc6e4f55bd$export$2e2bcd8739ae039), {
                    data: data
                })
            }, data.id))
    });
}
var $6cea2629c5e6614b$export$2e2bcd8739ae039 = $6cea2629c5e6614b$var$ConnectorRadioGroup;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $kowfT = parcelRequire("kowfT");
var $lXQZH = parcelRequire("lXQZH");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");





var $jGWQ4 = parcelRequire("jGWQ4");

function $6e29d6c764baa3c4$var$Footer({ isCreatingSocialConnector: isCreatingSocialConnector, existingConnectors: existingConnectors, selectedConnectorGroup: selectedConnectorGroup, isCreateButtonDisabled: isCreateButtonDisabled, onClickCreateButton: onClickCreateButton }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.upsell.paywall"
    });
    const { currentPlan: currentPlan } = (0, $jC8Vy.useContext)((0, $19434c930f80c964$export$f8addfd4ab69c833));
    const standardConnectorCount = (0, $jC8Vy.useMemo)(()=>existingConnectors.filter(({ isStandard: isStandard, isDemo: isDemo, type: type })=>isStandard && !isDemo && type === (0, $kowfT.ConnectorType).Social).length, [
        existingConnectors
    ]);
    const socialConnectorCount = (0, $jC8Vy.useMemo)(()=>existingConnectors.filter(({ isStandard: isStandard, isDemo: isDemo, type: type })=>!isStandard && !isDemo && type === (0, $kowfT.ConnectorType).Social).length, [
        existingConnectors
    ]);
    const isStandardConnectorsReachLimit = (0, $605aee781e0fe83f$export$1cc4b5152472cd4f)({
        quotaKey: "standardConnectorsLimit",
        plan: currentPlan,
        usage: standardConnectorCount
    });
    const isSocialConnectorsReachLimit = (0, $605aee781e0fe83f$export$1cc4b5152472cd4f)({
        quotaKey: "socialConnectorsLimit",
        plan: currentPlan,
        usage: socialConnectorCount
    });
    if (isCreatingSocialConnector && selectedConnectorGroup) {
        const { id: planId, name: planName, quota: quota } = currentPlan;
        if (isStandardConnectorsReachLimit && selectedConnectorGroup.isStandard) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dafa1bad5a99c1ae$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                components: {
                    a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a3bc63325dc3c1a8$export$2e2bcd8739ae039), {}),
                    planName: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $161f1bf99d56f621$export$2e2bcd8739ae039), {
                        name: planName
                    })
                },
                children: quota.standardConnectorsLimit === 0 ? t("standard_connectors_feature") : t(planId === (0, $lXQZH.ReservedPlanId).Pro ? "standard_connectors_pro" : "standard_connectors", {
                    count: quota.standardConnectorsLimit ?? 0
                })
            })
        });
        if (isSocialConnectorsReachLimit && !selectedConnectorGroup.isStandard) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dafa1bad5a99c1ae$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                components: {
                    a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a3bc63325dc3c1a8$export$2e2bcd8739ae039), {}),
                    planName: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $161f1bf99d56f621$export$2e2bcd8739ae039), {
                        name: planName
                    })
                },
                children: t("social_connectors", {
                    count: quota.socialConnectorsLimit ?? 0
                })
            })
        });
    }
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
        title: "general.next",
        type: "primary",
        disabled: isCreateButtonDisabled,
        onClick: onClickCreateButton
    });
}
var $6e29d6c764baa3c4$export$2e2bcd8739ae039 = $6e29d6c764baa3c4$var$Footer;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");


var $lmQmj = parcelRequire("lmQmj");

var $2e7b601fbae4a563$export$caa92bdde36f2a2d;
var $2e7b601fbae4a563$export$bfd64c937657f93a;
var $2e7b601fbae4a563$export$4a6dd88bada4e7d2;
var $2e7b601fbae4a563$export$fb184b623420d9be;
$2e7b601fbae4a563$export$caa92bdde36f2a2d = `NQKgPa_platforms`;
$2e7b601fbae4a563$export$bfd64c937657f93a = `NQKgPa_rotating`;
$2e7b601fbae4a563$export$4a6dd88bada4e7d2 = `NQKgPa_shimmer`;
$2e7b601fbae4a563$export$fb184b623420d9be = `NQKgPa_title`;


function $0fd30a8c81b918d1$var$PlatformSelector({ connectorGroup: connectorGroup, connectorId: connectorId, onConnectorIdChange: onConnectorIdChange }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    if (connectorGroup.connectors.length <= 1) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $2e7b601fbae4a563$export$caa92bdde36f2a2d,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $2e7b601fbae4a563$export$fb184b623420d9be,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ee1df03577241ccd$export$2e2bcd8739ae039), {
                        resource: connectorGroup.name
                    }),
                    t("connectors.add_multi_platform")
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c8e461321115642d$export$2e2bcd8739ae039), {
                type: "plain",
                name: "connector",
                value: connectorId,
                onChange: onConnectorIdChange,
                children: connectorGroup.connectors.map(({ platform: platform, id: id, added: added })=>platform && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $b4b7cf2a2e4180e8$export$2e2bcd8739ae039), {
                        value: id,
                        title: (0, $lmQmj.connectorPlatformLabel)[platform],
                        isDisabled: added
                    }, id))
            })
        ]
    });
}
var $0fd30a8c81b918d1$export$2e2bcd8739ae039 = $0fd30a8c81b918d1$var$PlatformSelector;



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");


var $0b347033f29f64eb$export$f79a732982c93a3b;
var $0b347033f29f64eb$export$6d59db4903f20f7d;
var $0b347033f29f64eb$export$db3c28d99448dcff;
var $0b347033f29f64eb$export$a8ff84c12d48cfa6;
var $0b347033f29f64eb$export$bfd64c937657f93a;
var $0b347033f29f64eb$export$4a6dd88bada4e7d2;
var $0b347033f29f64eb$export$ced924466afdd597;
$0b347033f29f64eb$export$f79a732982c93a3b = `ZBI9IG_connector`;
$0b347033f29f64eb$export$6d59db4903f20f7d = `ZBI9IG_description`;
$0b347033f29f64eb$export$db3c28d99448dcff = `ZBI9IG_logo`;
$0b347033f29f64eb$export$a8ff84c12d48cfa6 = `ZBI9IG_name`;
$0b347033f29f64eb$export$bfd64c937657f93a = `ZBI9IG_rotating`;
$0b347033f29f64eb$export$4a6dd88bada4e7d2 = `ZBI9IG_shimmer`;
$0b347033f29f64eb$export$4a6dd88bada4e7d2;
$0b347033f29f64eb$export$ced924466afdd597 = `ZBI9IG_shortDescription`;


function $f360002a3daba4ea$var$Skeleton({ numberOfLoadingConnectors: numberOfLoadingConnectors = 8 }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: $ee0f80e1eeac5e9f$export$8a5ac33d5834e89d,
        children: Array.from({
            length: numberOfLoadingConnectors
        }).map((_, index)=>// eslint-disable-next-line react/no-array-index-key
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($ee88d6a981085d70$export$f79a732982c93a3b, $0b347033f29f64eb$export$f79a732982c93a3b),
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $0b347033f29f64eb$export$db3c28d99448dcff
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $ee88d6a981085d70$export$a7db06668cad9adb,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $0b347033f29f64eb$export$a8ff84c12d48cfa6
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $0b347033f29f64eb$export$6d59db4903f20f7d
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($0b347033f29f64eb$export$6d59db4903f20f7d, $0b347033f29f64eb$export$ced924466afdd597)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, index))
    });
}
var $f360002a3daba4ea$export$2e2bcd8739ae039 = $f360002a3daba4ea$var$Skeleton;


var $d696551bb0912a78$export$bfd64c937657f93a;
var $d696551bb0912a78$export$4a6dd88bada4e7d2;
var $d696551bb0912a78$export$51242721bb71b0ff;
$d696551bb0912a78$export$bfd64c937657f93a = `_21Rf0a_rotating`;
$d696551bb0912a78$export$4a6dd88bada4e7d2 = `_21Rf0a_shimmer`;
$d696551bb0912a78$export$51242721bb71b0ff = `_21Rf0a_standardLabel`;


parcelRequire("cuPVN");
var $kowfT = parcelRequire("kowfT");
const $8754d3a3b2dfe157$export$624a8265433e880 = [
    // Social
    "google",
    "apple",
    "facebook",
    "github",
    "discord",
    "wechat",
    "alipay",
    "kakao",
    "naver",
    "azuread",
    // Email
    "logto-email",
    "aws-ses",
    "sendgrid-mail",
    "aliyun-dm",
    // SMS
    "twilio-sms",
    "aliyun-sms",
    "tencent-sms"
];


const $cfa9e34c07697b6d$var$getConnectorOrder = (target, isStandard)=>{
    const order = (0, $8754d3a3b2dfe157$export$624a8265433e880).indexOf(target);
    if (order === -1) // Standard connectors come last.
    return isStandard ? (0, $8754d3a3b2dfe157$export$624a8265433e880).length + 1 : (0, $8754d3a3b2dfe157$export$624a8265433e880).length;
    return order;
};
const $cfa9e34c07697b6d$export$1f031023d9a4beb9 = (connectorA, connectorB)=>{
    const orderA = $cfa9e34c07697b6d$var$getConnectorOrder(connectorA.target, connectorA.isStandard);
    const orderB = $cfa9e34c07697b6d$var$getConnectorOrder(connectorB.target, connectorB.isStandard);
    return orderA - orderB;
};
const $cfa9e34c07697b6d$export$2ace16fb29e63d87 = (connectorCount, connectorType)=>{
    /**
   * Note:
   * Fix the size to large, since now we have little passwordless connectors.
   */ if (connectorType !== (0, $kowfT.ConnectorType).Social) return "large";
    if (connectorCount <= 2) return "medium";
    if (connectorCount === 3) return "large";
    return "xlarge";
};
const $cfa9e34c07697b6d$export$56d81f3a0a66aebd = (connectorType)=>{
    if (connectorType === (0, $kowfT.ConnectorType).Email) return "connectors.setup_title.email";
    if (connectorType === (0, $kowfT.ConnectorType).Sms) return "connectors.setup_title.sms";
    return "connectors.setup_title.social";
};


function $80bae7df489c133c$var$CreateConnectorForm({ onClose: onClose, isOpen: isFormOpen, type: type }) {
    const { data: existingConnectors, error: connectorsError } = (0, $voszV.default)("api/connectors");
    const { data: factories, error: factoriesError } = (0, $voszV.default)("api/connector-factories");
    const isLoading = !factories && !existingConnectors && !connectorsError && !factoriesError;
    const [activeGroupId, setActiveGroupId] = (0, $jC8Vy.useState)();
    const [activeFactoryId, setActiveFactoryId] = (0, $jC8Vy.useState)();
    const isCreatingSocialConnector = type === (0, $kowfT.ConnectorType).Social;
    const groups = (0, $jC8Vy.useMemo)(()=>{
        if (!factories || !existingConnectors) return [];
        const allGroups = (0, $be65b460d85f5eb9$export$48daf4eb8bb4366e)(factories.filter(({ type: factoryType, isDemo: isDemo })=>factoryType === type && !isDemo)// Hide the entrance of adding SAML social connectors, users should go to Enterprise SSO if they want to use SAML.
        // Should not remove the SAML factory from GET /connector-factories API, since that could break the existing SAML connectors.
        .filter(({ id: id })=>id !== "saml"));
        return allGroups.map((group)=>({
                ...group,
                connectors: group.connectors.map((connector)=>({
                        ...connector,
                        added: !group.isStandard && existingConnectors.some(({ connectorId: connectorId })=>connector.id === connectorId)
                    }))
            })).filter(({ connectors: connectors })=>!connectors.every(({ added: added })=>added)).slice().sort((0, $cfa9e34c07697b6d$export$1f031023d9a4beb9));
    }, [
        factories,
        type,
        existingConnectors
    ]);
    const activeGroup = (0, $jC8Vy.useMemo)(()=>groups.find(({ id: id })=>id === activeGroupId), [
        activeGroupId,
        groups
    ]);
    const cardTitle = (0, $jC8Vy.useMemo)(()=>(0, $cfa9e34c07697b6d$export$56d81f3a0a66aebd)(type), [
        type
    ]);
    const radioGroupSize = (0, $jC8Vy.useMemo)(()=>(0, $cfa9e34c07697b6d$export$2ace16fb29e63d87)(groups.length, type), [
        groups.length,
        type
    ]);
    const handleGroupChange = (groupId)=>{
        setActiveGroupId(groupId);
        const group = groups.find(({ id: id })=>id === groupId);
        if (!group) return;
        const firstAvailableConnector = group.connectors.find(({ added: added })=>!added);
        setActiveFactoryId(firstAvailableConnector?.id);
    };
    const defaultGroups = (0, $jC8Vy.useMemo)(()=>isCreatingSocialConnector ? groups.filter((group)=>!group.isStandard) : groups, [
        groups,
        isCreatingSocialConnector
    ]);
    const standardGroups = (0, $jC8Vy.useMemo)(()=>groups.filter((group)=>group.isStandard), [
        groups
    ]);
    if (!isFormOpen) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        shouldCloseOnEsc: true,
        isOpen: isFormOpen,
        className: $dW2kG.content,
        overlayClassName: $dW2kG.overlay,
        onRequestClose: ()=>{
            onClose?.();
        },
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $5vVWy.default), {
            title: cardTitle,
            footer: existingConnectors && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6e29d6c764baa3c4$export$2e2bcd8739ae039), {
                isCreatingSocialConnector: isCreatingSocialConnector,
                existingConnectors: existingConnectors,
                selectedConnectorGroup: activeGroup,
                isCreateButtonDisabled: !activeFactoryId,
                onClickCreateButton: ()=>{
                    onClose?.(activeFactoryId);
                }
            }),
            size: radioGroupSize,
            onClose: onClose,
            children: [
                isLoading && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f360002a3daba4ea$export$2e2bcd8739ae039), {}),
                factoriesError?.message ?? connectorsError?.message,
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6cea2629c5e6614b$export$2e2bcd8739ae039), {
                    name: "group",
                    groups: defaultGroups,
                    value: activeGroupId,
                    size: radioGroupSize,
                    onChange: handleGroupChange
                }),
                activeGroup && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0fd30a8c81b918d1$export$2e2bcd8739ae039), {
                    connectorGroup: activeGroup,
                    connectorId: activeFactoryId,
                    onConnectorIdChange: setActiveFactoryId
                }),
                standardGroups.length > 0 && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $d696551bb0912a78$export$51242721bb71b0ff,
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                forKey: "connectors.standard_connectors"
                            })
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6cea2629c5e6614b$export$2e2bcd8739ae039), {
                            name: "group",
                            groups: standardGroups,
                            value: activeGroupId,
                            size: radioGroupSize,
                            onChange: handleGroupChange
                        })
                    ]
                })
            ]
        })
    });
}
var $80bae7df489c133c$export$2e2bcd8739ae039 = $80bae7df489c133c$var$CreateConnectorForm;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $kowfT = parcelRequire("kowfT");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");


var $dL4NZ = parcelRequire("dL4NZ");
function $1473e789d55b40f6$var$DeleteConnectorConfirmModal({ data: data, isOpen: isOpen, isInUse: isInUse, isLoading: isLoading, onCancel: onCancel, onConfirm: onConfirm }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const isSocial = data.type === (0, $kowfT.ConnectorType).Social;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $dL4NZ.default), {
        isOpen: isOpen,
        confirmButtonText: "general.delete",
        isLoading: isLoading,
        onCancel: onCancel,
        onConfirm: onConfirm,
        children: [
            !isInUse && t("connector_details.deletion_description"),
            isInUse && isSocial && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                t: t,
                i18nKey: "connector_details.in_used_social_deletion_description",
                components: {
                    name: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ee1df03577241ccd$export$2e2bcd8739ae039), {
                        resource: data.name
                    })
                }
            }),
            isInUse && !isSocial && t("connector_details.in_used_passwordless_deletion_description", {
                name: t(data.type === (0, $kowfT.ConnectorType).Email ? "connector_details.type_email" : "connector_details.type_sms")
            })
        ]
    });
}
var $1473e789d55b40f6$export$2e2bcd8739ae039 = $1473e789d55b40f6$var$DeleteConnectorConfirmModal;






var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");
// Register `Raw` in tree:
/// <reference types="mdast-util-to-hast" />
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Nodes} Nodes
 * @typedef {import('hast').Parents} Parents
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast-util-to-jsx-runtime').Components} JsxRuntimeComponents
 * @typedef {import('remark-rehype').Options} RemarkRehypeOptions
 * @typedef {import('unist-util-visit').BuildVisitor<Root>} Visitor
 * @typedef {import('unified').PluggableList} PluggableList
 */ /**
 * @callback AllowElement
 *   Filter elements.
 * @param {Readonly<Element>} element
 *   Element to check.
 * @param {number} index
 *   Index of `element` in `parent`.
 * @param {Readonly<Parents> | undefined} parent
 *   Parent of `element`.
 * @returns {boolean | null | undefined}
 *   Whether to allow `element` (default: `false`).
 *
 * @typedef {Partial<JsxRuntimeComponents>} Components
 *   Map tag names to components.
 *
 * @typedef Deprecation
 *   Deprecation.
 * @property {string} from
 *   Old field.
 * @property {string} id
 *   ID in readme.
 * @property {keyof Options} [to]
 *   New field.
 *
 * @typedef Options
 *   Configuration.
 * @property {AllowElement | null | undefined} [allowElement]
 *   Filter elements (optional);
 *   `allowedElements` / `disallowedElements` is used first.
 * @property {ReadonlyArray<string> | null | undefined} [allowedElements]
 *   Tag names to allow (default: all tag names);
 *   cannot combine w/ `disallowedElements`.
 * @property {string | null | undefined} [children]
 *   Markdown.
 * @property {string | null | undefined} [className]
 *   Wrap in a `div` with this class name.
 * @property {Components | null | undefined} [components]
 *   Map tag names to components.
 * @property {ReadonlyArray<string> | null | undefined} [disallowedElements]
 *   Tag names to disallow (default: `[]`);
 *   cannot combine w/ `allowedElements`.
 * @property {PluggableList | null | undefined} [rehypePlugins]
 *   List of rehype plugins to use.
 * @property {PluggableList | null | undefined} [remarkPlugins]
 *   List of remark plugins to use.
 * @property {Readonly<RemarkRehypeOptions> | null | undefined} [remarkRehypeOptions]
 *   Options to pass through to `remark-rehype`.
 * @property {boolean | null | undefined} [skipHtml=false]
 *   Ignore HTML in markdown completely (default: `false`).
 * @property {boolean | null | undefined} [unwrapDisallowed=false]
 *   Extract (unwrap) what’s in disallowed elements (default: `false`);
 *   normally when say `strong` is not allowed, it and it’s children are dropped,
 *   with `unwrapDisallowed` the element itself is replaced by its children.
 * @property {UrlTransform | null | undefined} [urlTransform]
 *   Change URLs (default: `defaultUrlTransform`)
 *
 * @callback UrlTransform
 *   Transform all URLs.
 * @param {string} url
 *   URL.
 * @param {string} key
 *   Property name (example: `'href'`).
 * @param {Readonly<Element>} node
 *   Node.
 * @returns {string | null | undefined}
 *   Transformed URL (optional).
 */ function $331630515164a454$export$b680e6b2c82f8c2f(fn) {
    return fn;
}
function $331630515164a454$export$411ce8e5a71e3069() {}
function $331630515164a454$export$dcb8b3f0e2de7e49() {}
function $331630515164a454$export$565e9d9bd6b6e0d4() {}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Nodes} Nodes
 * @typedef {import('hast').Parents} Parents
 *
 * @typedef {import('property-information').Schema} Schema
 *
 * @typedef {import('./components.js').Components} Components
 */ /**
 * @typedef {JSX.Element | string | null | undefined} Child
 *   Child.
 *
 * @callback Create
 *   Create something in development or production.
 * @param {Nodes} node
 *   hast node.
 * @param {unknown} type
 *   Fragment symbol or tag name.
 * @param {Props} props
 *   Properties and children.
 * @param {string | undefined} key
 *   Key.
 * @returns {JSX.Element}
 *   Result.
 *
 * @typedef {'html' | 'react'} ElementAttributeNameCase
 *   Casing to use for attribute names.
 *
 *   HTML casing is for example `class`, `stroke-linecap`, `xml:lang`.
 *   React casing is for example `className`, `strokeLinecap`, `xmlLang`.
 *
 * @typedef {[string, Value]} Field
 *   Property field.
 *
 * @typedef {unknown} Fragment
 *   Represent the children, typically a symbol.
 *
 * @callback Jsx
 *   Create a production element.
 * @param {unknown} type
 *   Element type: `Fragment` symbol, tag name (`string`), component.
 * @param {Props} props
 *   Element props, `children`, and maybe `node`.
 * @param {string | undefined} [key]
 *   Dynamicly generated key to use.
 * @returns {JSX.Element}
 *   An element from your framework.
 *
 * @callback JsxDev
 *   Create a development element.
 * @param {unknown} type
 *   Element type: `Fragment` symbol, tag name (`string`), component.
 * @param {Props} props
 *   Element props, `children`, and maybe `node`.
 * @param {string | undefined} key
 *   Dynamicly generated key to use.
 * @param {boolean} isStaticChildren
 *   Whether two or more children are passed (in an array), which is whether
 *   `jsxs` or `jsx` would be used.
 * @param {Source} source
 *   Info about source.
 * @param {undefined} self
 *   Nothing (this is used by frameworks that have components, we don’t).
 * @returns {JSX.Element}
 *   An element from your framework.
 *
 * @typedef {{children?: Array<Child> | Child, node?: Element | undefined, [prop: string]: Array<Child> | Child | Element | Value | undefined}} Props
 *   Properties and children.
 *
 * @typedef RegularFields
 *   Configuration.
 * @property {Partial<Components> | null | undefined} [components]
 *   Components to use (optional).
 * @property {ElementAttributeNameCase | null | undefined} [elementAttributeNameCase='react']
 *   Specify casing to use for attribute names (default: `'react'`).
 * @property {string | null | undefined} [filePath]
 *   File path to the original source file (optional).
 *
 *   Passed in source info to `jsxDEV` when using the automatic runtime with
 *   `development: true`.
 * @property {boolean | null | undefined} [ignoreInvalidStyle=false]
 *   Ignore invalid CSS in `style` props (default: `false`);
 *   the default behavior is to throw an error.
 * @property {boolean | null | undefined} [passKeys=true]
 *   Generate keys to optimize frameworks that support them (default: `true`).
 *
 *   > 👉 **Note**: Solid currently fails if keys are passed.
 * @property {boolean | null | undefined} [passNode=false]
 *   Pass the hast element node to components (default: `false`).
 * @property {Space | null | undefined} [space='html']
 *   Whether `tree` is in the `'html'` or `'svg'` space (default: `'html'`).
 *
 *   When an `<svg>` element is found in the HTML space, this package already
 *   automatically switches to and from the SVG space when entering and exiting
 *   it.
 * @property {StylePropertyNameCase | null | undefined} [stylePropertyNameCase='dom']
 *   Specify casing to use for property names in `style` objects (default:
 *   `'dom'`).
 * @property {boolean | null | undefined} [tableCellAlignToStyle=true]
 *   Turn obsolete `align` props on `td` and `th` into CSS `style` props
 *   (default: `true`).
 *
 * @typedef RuntimeDevelopment
 *   Runtime fields when development is on.
 * @property {Fragment} Fragment
 *   Fragment.
 * @property {true} development
 *   Whether to use `jsxDEV` (when on) or `jsx` and `jsxs` (when off).
 * @property {Jsx | null | undefined} [jsx]
 *   Dynamic JSX (optional).
 * @property {JsxDev} jsxDEV
 *   Development JSX.
 * @property {Jsx | null | undefined} [jsxs]
 *   Static JSX (optional).
 *
 * @typedef RuntimeProduction
 *   Runtime fields when development is off.
 * @property {Fragment} Fragment
 *   Fragment.
 * @property {false | null | undefined} [development]
 *   Whether to use `jsxDEV` (when on) or `jsx` and `jsxs` (when off) (optional).
 * @property {Jsx} jsx
 *   Dynamic JSX.
 * @property {JsxDev | null | undefined} [jsxDEV]
 *   Development JSX (optional).
 * @property {Jsx} jsxs
 *   Static JSX.
 *
 * @typedef RuntimeUnknown
 *   Runtime fields when development might be on or off.
 * @property {Fragment} Fragment
 *   Fragment.
 * @property {boolean} development
 *   Whether to use `jsxDEV` (when on) or `jsx` and `jsxs` (when off).
 * @property {Jsx | null | undefined} [jsx]
 *   Dynamic JSX (optional).
 * @property {JsxDev | null | undefined} [jsxDEV]
 *   Development JSX (optional).
 * @property {Jsx | null | undefined} [jsxs]
 *   Static JSX (optional).
 *
 * @typedef Source
 *   Info about source.
 * @property {number | undefined} columnNumber
 *   Column where thing starts (0-indexed).
 * @property {string | undefined} fileName
 *   Name of source file.
 * @property {number | undefined} lineNumber
 *   Line where thing starts (1-indexed).
 *
 * @typedef {'html' | 'svg'} Space
 *   Namespace.
 *
 *   > 👉 **Note**: hast is not XML.
 *   > It supports SVG as embedded in HTML.
 *   > It does not support the features available in XML.
 *   > Passing SVG might break but fragments of modern SVG should be fine.
 *   > Use `xast` if you need to support SVG as XML.
 *
 * @typedef State
 *   Info passed around.
 * @property {unknown} Fragment
 *   Fragment symbol.
 * @property {Array<Parents>} ancestors
 *   Stack of parents.
 * @property {Partial<Components>} components
 *   Components to swap.
 * @property {Create} create
 *   Create something in development or production.
 * @property {ElementAttributeNameCase} elementAttributeNameCase
 *   Casing to use for attribute names.
 * @property {string | undefined} filePath
 *   File path.
 * @property {boolean} ignoreInvalidStyle
 *   Ignore invalid CSS in `style` props.
 * @property {boolean} passKeys
 *   Generate keys to optimize frameworks that support them.
 * @property {boolean} passNode
 *   Pass `node` to components.
 * @property {Schema} schema
 *   Current schema.
 * @property {StylePropertyNameCase} stylePropertyNameCase
 *   Casing to use for property names in `style` objects.
 * @property {boolean} tableCellAlignToStyle
 *   Turn obsolete `align` props on `td` and `th` into CSS `style` props.
 *
 * @typedef {Record<string, string>} Style
 *   Style map.
 *
 * @typedef {'css' | 'dom'} StylePropertyNameCase
 *   Casing to use for property names in `style` objects.
 *
 *   CSS casing is for example `background-color` and `-webkit-line-clamp`.
 *   DOM casing is for example `backgroundColor` and `WebkitLineClamp`.
 *
 * @typedef {Style | boolean | number | string} Value
 *   Primitive property value and `Style` map.
 */ /**
 * @typedef {RuntimeDevelopment & RegularFields} Development
 *   Configuration (development).
 * @typedef {Development | Production | Unknown} Options
 *   Configuration.
 * @typedef {RegularFields & RuntimeProduction} Production
 *   Configuration (production).
 * @typedef {RegularFields & RuntimeUnknown} Unknown
 *   Configuration (production or development).
 */ /**
 * @typedef {Object} StringifyOptions
 * @property {boolean} [padLeft=true] Whether to pad a space before a token (`boolean`, default: `true`).
 * @property {boolean} [padRight=false] Whether to pad a space after a token (`boolean`, default: `false`).
 */ /**
 * Parse comma separated tokens to an array.
 *
 * @param {string} value
 * @returns {Array.<string>}
 */ function $04bff1d485c19e9f$export$98e6a39c04603d36(value) {
    /** @type {Array.<string>} */ var tokens = [];
    var input = String(value || "");
    var index = input.indexOf(",");
    var start = 0;
    /** @type {boolean} */ var end;
    /** @type {string} */ var token;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        token = input.slice(start, index).trim();
        if (token || !end) tokens.push(token);
        start = index + 1;
        index = input.indexOf(",", start);
    }
    return tokens;
}
function $04bff1d485c19e9f$export$fac44ee5b035f737(values, options) {
    var settings = options || {};
    // Ensure the last empty entry is seen.
    if (values[values.length - 1] === "") values = values.concat("");
    return values.join((settings.padRight ? " " : "") + "," + (settings.padLeft === false ? "" : " ")).trim();
}


/**
 * @typedef {import('hast').Nodes} Nodes
 */ // HTML whitespace expression.
// See <https://infra.spec.whatwg.org/#ascii-whitespace>.
const $b1f5fe7f2b8089b4$var$re = /[ \t\n\f\r]/g;
function $b1f5fe7f2b8089b4$export$7af1228ff777d175(thing) {
    return typeof thing === "object" ? thing.type === "text" ? $b1f5fe7f2b8089b4$var$empty(thing.value) : false : $b1f5fe7f2b8089b4$var$empty(thing);
}
/**
 * @param {string} value
 * @returns {boolean}
 */ function $b1f5fe7f2b8089b4$var$empty(value) {
    return value.replace($b1f5fe7f2b8089b4$var$re, "") === "";
}


/**
 * @typedef {import('./util/schema.js').Schema} Schema
 */ /**
 * @param {string} value
 * @returns {string}
 */ function $856389b85b5f547a$export$a3295358bff77e(value) {
    return value.toLowerCase();
}


class $1884799a452536ca$export$c4868e4a24d48fad {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */ constructor(property, attribute){
        /** @type {string} */ this.property = property;
        /** @type {string} */ this.attribute = attribute;
    }
}
/** @type {string|null} */ $1884799a452536ca$export$c4868e4a24d48fad.prototype.space = null;
$1884799a452536ca$export$c4868e4a24d48fad.prototype.boolean = false;
$1884799a452536ca$export$c4868e4a24d48fad.prototype.booleanish = false;
$1884799a452536ca$export$c4868e4a24d48fad.prototype.overloadedBoolean = false;
$1884799a452536ca$export$c4868e4a24d48fad.prototype.number = false;
$1884799a452536ca$export$c4868e4a24d48fad.prototype.commaSeparated = false;
$1884799a452536ca$export$c4868e4a24d48fad.prototype.spaceSeparated = false;
$1884799a452536ca$export$c4868e4a24d48fad.prototype.commaOrSpaceSeparated = false;
$1884799a452536ca$export$c4868e4a24d48fad.prototype.mustUseProperty = false;
$1884799a452536ca$export$c4868e4a24d48fad.prototype.defined = false;


var $77906414ca06b2c8$exports = {};

$parcel$export($77906414ca06b2c8$exports, "boolean", function () { return $77906414ca06b2c8$export$4a21f16c33752377; });
$parcel$export($77906414ca06b2c8$exports, "booleanish", function () { return $77906414ca06b2c8$export$55e9e1fbc638dc8f; });
$parcel$export($77906414ca06b2c8$exports, "overloadedBoolean", function () { return $77906414ca06b2c8$export$242ac3d3042558aa; });
$parcel$export($77906414ca06b2c8$exports, "number", function () { return $77906414ca06b2c8$export$98e628dec113755e; });
$parcel$export($77906414ca06b2c8$exports, "spaceSeparated", function () { return $77906414ca06b2c8$export$ab8645c862eb5a3e; });
$parcel$export($77906414ca06b2c8$exports, "commaSeparated", function () { return $77906414ca06b2c8$export$9c8d678629b3d3; });
$parcel$export($77906414ca06b2c8$exports, "commaOrSpaceSeparated", function () { return $77906414ca06b2c8$export$2ad25cfebf36cacd; });
let $77906414ca06b2c8$var$powers = 0;
const $77906414ca06b2c8$export$4a21f16c33752377 = $77906414ca06b2c8$var$increment();
const $77906414ca06b2c8$export$55e9e1fbc638dc8f = $77906414ca06b2c8$var$increment();
const $77906414ca06b2c8$export$242ac3d3042558aa = $77906414ca06b2c8$var$increment();
const $77906414ca06b2c8$export$98e628dec113755e = $77906414ca06b2c8$var$increment();
const $77906414ca06b2c8$export$ab8645c862eb5a3e = $77906414ca06b2c8$var$increment();
const $77906414ca06b2c8$export$9c8d678629b3d3 = $77906414ca06b2c8$var$increment();
const $77906414ca06b2c8$export$2ad25cfebf36cacd = $77906414ca06b2c8$var$increment();
function $77906414ca06b2c8$var$increment() {
    return 2 ** ++$77906414ca06b2c8$var$powers;
}


/** @type {Array<keyof types>} */ // @ts-expect-error: hush.
const $50e0e01af3a91921$var$checks = Object.keys($77906414ca06b2c8$exports);
class $50e0e01af3a91921$export$ea6b9f0064e88c9b extends (0, $1884799a452536ca$export$c4868e4a24d48fad) {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */ constructor(property, attribute, mask, space){
        let index = -1;
        super(property, attribute);
        $50e0e01af3a91921$var$mark(this, "space", space);
        if (typeof mask === "number") while(++index < $50e0e01af3a91921$var$checks.length){
            const check = $50e0e01af3a91921$var$checks[index];
            $50e0e01af3a91921$var$mark(this, $50e0e01af3a91921$var$checks[index], (mask & $77906414ca06b2c8$exports[check]) === $77906414ca06b2c8$exports[check]);
        }
    }
}
$50e0e01af3a91921$export$ea6b9f0064e88c9b.prototype.defined = true;
/**
 * @param {DefinedInfo} values
 * @param {string} key
 * @param {unknown} value
 */ function $50e0e01af3a91921$var$mark(values, key, value) {
    if (value) // @ts-expect-error: assume `value` matches the expected value of `key`.
    values[key] = value;
}



const $50285aefa5e98f02$var$valid = /^data[-\w.:]+$/i;
const $50285aefa5e98f02$var$dash = /-[a-z]/g;
const $50285aefa5e98f02$var$cap = /[A-Z]/g;
function $50285aefa5e98f02$export$71aa6c912b956294(schema, value) {
    const normal = (0, $856389b85b5f547a$export$a3295358bff77e)(value);
    let prop = value;
    let Type = (0, $1884799a452536ca$export$c4868e4a24d48fad);
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === "data" && $50285aefa5e98f02$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === "-") {
            // Turn it into a property.
            const rest = value.slice(5).replace($50285aefa5e98f02$var$dash, $50285aefa5e98f02$var$camelcase);
            prop = "data" + rest.charAt(0).toUpperCase() + rest.slice(1);
        } else {
            // Turn it into an attribute.
            const rest = value.slice(4);
            if (!$50285aefa5e98f02$var$dash.test(rest)) {
                let dashes = rest.replace($50285aefa5e98f02$var$cap, $50285aefa5e98f02$var$kebab);
                if (dashes.charAt(0) !== "-") dashes = "-" + dashes;
                value = "data" + dashes;
            }
        }
        Type = (0, $50e0e01af3a91921$export$ea6b9f0064e88c9b);
    }
    return new Type(prop, value);
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $50285aefa5e98f02$var$kebab($0) {
    return "-" + $0.toLowerCase();
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $50285aefa5e98f02$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}

/**
 * `hast` is close to `React`, but differs in a couple of cases.
 *
 * To get a React property from a hast property, check if it is in
 * `hastToReact`, if it is, then use the corresponding value,
 * otherwise, use the hast property.
 *
 * @type {Record<string, string>}
 */ const $675de08bc33c4a01$export$d8abd7e5fb6871f9 = {
    classId: "classID",
    dataType: "datatype",
    itemId: "itemID",
    strokeDashArray: "strokeDasharray",
    strokeDashOffset: "strokeDashoffset",
    strokeLineCap: "strokeLinecap",
    strokeLineJoin: "strokeLinejoin",
    strokeMiterLimit: "strokeMiterlimit",
    typeOf: "typeof",
    xLinkActuate: "xlinkActuate",
    xLinkArcRole: "xlinkArcrole",
    xLinkHref: "xlinkHref",
    xLinkRole: "xlinkRole",
    xLinkShow: "xlinkShow",
    xLinkTitle: "xlinkTitle",
    xLinkType: "xlinkType",
    xmlnsXLink: "xmlnsXlink"
};

/**
 * @typedef {import('./lib/util/info.js').Info} Info
 * @typedef {import('./lib/util/schema.js').Schema} Schema
 */ /**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 */ /**
 * @typedef {import('./info.js').Info} Info
 * @typedef {Record<string, Info>} Properties
 * @typedef {Record<string, string>} Normal
 */ class $808deaa9d67a89a1$export$19342e026b58ebb7 {
    /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */ constructor(property, normal, space){
        this.property = property;
        this.normal = normal;
        if (space) this.space = space;
    }
}
/** @type {Properties} */ $808deaa9d67a89a1$export$19342e026b58ebb7.prototype.property = {};
/** @type {Normal} */ $808deaa9d67a89a1$export$19342e026b58ebb7.prototype.normal = {};
/** @type {string|null} */ $808deaa9d67a89a1$export$19342e026b58ebb7.prototype.space = null;


function $e11d5cc5e2d498a7$export$4950aa0f605343fb(definitions, space) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    let index = -1;
    while(++index < definitions.length){
        Object.assign(property, definitions[index].property);
        Object.assign(normal, definitions[index].normal);
    }
    return new (0, $808deaa9d67a89a1$export$19342e026b58ebb7)(property, normal, space);
}


/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 *
 * @typedef {Record<string, string>} Attributes
 *
 * @typedef {Object} Definition
 * @property {Record<string, number|null>} properties
 * @property {(attributes: Attributes, property: string) => string} transform
 * @property {string} [space]
 * @property {Attributes} [attributes]
 * @property {Array<string>} [mustUseProperty]
 */ 


const $152608770f9afeeb$var$own = {}.hasOwnProperty;
function $152608770f9afeeb$export$185802fd694ee1f5(definition) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    /** @type {string} */ let prop;
    for(prop in definition.properties)if ($152608770f9afeeb$var$own.call(definition.properties, prop)) {
        const value = definition.properties[prop];
        const info = new (0, $50e0e01af3a91921$export$ea6b9f0064e88c9b)(prop, definition.transform(definition.attributes || {}, prop), value, definition.space);
        if (definition.mustUseProperty && definition.mustUseProperty.includes(prop)) info.mustUseProperty = true;
        property[prop] = info;
        normal[(0, $856389b85b5f547a$export$a3295358bff77e)(prop)] = prop;
        normal[(0, $856389b85b5f547a$export$a3295358bff77e)(info.attribute)] = prop;
    }
    return new (0, $808deaa9d67a89a1$export$19342e026b58ebb7)(property, normal, definition.space);
}


const $a1283f670d8ae8f8$export$2bd1230ec7600845 = (0, $152608770f9afeeb$export$185802fd694ee1f5)({
    space: "xlink",
    transform (_, prop) {
        return "xlink:" + prop.slice(5).toLowerCase();
    },
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    }
});



const $440cd80b72261c32$export$f2913fe8983302e = (0, $152608770f9afeeb$export$185802fd694ee1f5)({
    space: "xml",
    transform (_, prop) {
        return "xml:" + prop.slice(3).toLowerCase();
    },
    properties: {
        xmlLang: null,
        xmlBase: null,
        xmlSpace: null
    }
});



/**
 * @param {Record<string, string>} attributes
 * @param {string} attribute
 * @returns {string}
 */ function $0c49ba436e5c3fe2$export$5b10b3bc32d7efbc(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}


function $069ae486d0864d35$export$32b9e4cec9c208e1(attributes, property) {
    return (0, $0c49ba436e5c3fe2$export$5b10b3bc32d7efbc)(attributes, property.toLowerCase());
}


const $825e0ecacb0f9d30$export$e20c24a128671213 = (0, $152608770f9afeeb$export$185802fd694ee1f5)({
    space: "xmlns",
    attributes: {
        xmlnsxlink: "xmlns:xlink"
    },
    transform: (0, $069ae486d0864d35$export$32b9e4cec9c208e1),
    properties: {
        xmlns: null,
        xmlnsXLink: null
    }
});




const $a4265a6678314874$export$4d2d26490572750a = (0, $152608770f9afeeb$export$185802fd694ee1f5)({
    transform (_, prop) {
        return prop === "role" ? prop : "aria-" + prop.slice(4).toLowerCase();
    },
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: (0, $77906414ca06b2c8$export$55e9e1fbc638dc8f),
        ariaAutoComplete: null,
        ariaBusy: (0, $77906414ca06b2c8$export$55e9e1fbc638dc8f),
        ariaChecked: (0, $77906414ca06b2c8$export$55e9e1fbc638dc8f),
        ariaColCount: (0, $77906414ca06b2c8$export$98e628dec113755e),
        ariaColIndex: (0, $77906414ca06b2c8$export$98e628dec113755e),
        ariaColSpan: (0, $77906414ca06b2c8$export$98e628dec113755e),
        ariaControls: (0, $77906414ca06b2c8$export$ab8645c862eb5a3e),
        ariaCurrent: null,
        ariaDescribedBy: (0, $77906414ca06b2c8$export$ab8645c862eb5a3e),
        ariaDetails: null,
        ariaDisabled: (0, $77906414ca06b2c8$export$55e9e1fbc638dc8f),
        ariaDropEffect: (0, $77906414ca06b2c8$export$ab8645c862eb5a3e),
        ariaErrorMessage: null,
        ariaExpanded: (0, $77906414ca06b2c8$export$55e9e1fbc638dc8f),
        ariaFlowTo: (0, $77906414ca06b2c8$export$ab8645c862eb5a3e),
        ariaGrabbed: (0, $77906414ca06b2c8$export$55e9e1fbc638dc8f),
        ariaHasPopup: null,
        ariaHidden: (0, $77906414ca06b2c8$export$55e9e1fbc638dc8f),
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: (0, $77906414ca06b2c8$export$ab8645c862eb5a3e),
        ariaLevel: (0, $77906414ca06b2c8$export$98e628dec113755e),
        ariaLive: null,
        ariaModal: (0, $77906414ca06b2c8$export$55e9e1fbc638dc8f),
        ariaMultiLine: (0, $77906414ca06b2c8$export$55e9e1fbc638dc8f),
        ariaMultiSelectable: (0, $77906414ca06b2c8$export$55e9e1fbc638dc8f),
        ariaOrientation: null,
        ariaOwns: (0, $77906414ca06b2c8$export$ab8645c862eb5a3e),
        ariaPlaceholder: null,
        ariaPosInSet: (0, $77906414ca06b2c8$export$98e628dec113755e),
        ariaPressed: (0, $77906414ca06b2c8$export$55e9e1fbc638dc8f),
        ariaReadOnly: (0, $77906414ca06b2c8$export$55e9e1fbc638dc8f),
        ariaRelevant: null,
        ariaRequired: (0, $77906414ca06b2c8$export$55e9e1fbc638dc8f),
        ariaRoleDescription: (0, $77906414ca06b2c8$export$ab8645c862eb5a3e),
        ariaRowCount: (0, $77906414ca06b2c8$export$98e628dec113755e),
        ariaRowIndex: (0, $77906414ca06b2c8$export$98e628dec113755e),
        ariaRowSpan: (0, $77906414ca06b2c8$export$98e628dec113755e),
        ariaSelected: (0, $77906414ca06b2c8$export$55e9e1fbc638dc8f),
        ariaSetSize: (0, $77906414ca06b2c8$export$98e628dec113755e),
        ariaSort: null,
        ariaValueMax: (0, $77906414ca06b2c8$export$98e628dec113755e),
        ariaValueMin: (0, $77906414ca06b2c8$export$98e628dec113755e),
        ariaValueNow: (0, $77906414ca06b2c8$export$98e628dec113755e),
        ariaValueText: null,
        role: null
    }
});





const $c216ad746de7e547$export$c0bb0b647f701bb5 = (0, $152608770f9afeeb$export$185802fd694ee1f5)({
    space: "html",
    attributes: {
        acceptcharset: "accept-charset",
        classname: "class",
        htmlfor: "for",
        httpequiv: "http-equiv"
    },
    transform: (0, $069ae486d0864d35$export$32b9e4cec9c208e1),
    mustUseProperty: [
        "checked",
        "multiple",
        "muted",
        "selected"
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: (0, $77906414ca06b2c8$export$9c8d678629b3d3),
        acceptCharset: (0, $77906414ca06b2c8$export$ab8645c862eb5a3e),
        accessKey: (0, $77906414ca06b2c8$export$ab8645c862eb5a3e),
        action: null,
        allow: null,
        allowFullScreen: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        allowPaymentRequest: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        allowUserMedia: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        alt: null,
        as: null,
        async: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        autoCapitalize: null,
        autoComplete: (0, $77906414ca06b2c8$export$ab8645c862eb5a3e),
        autoFocus: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        autoPlay: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        capture: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        charSet: null,
        checked: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        cite: null,
        className: (0, $77906414ca06b2c8$export$ab8645c862eb5a3e),
        cols: (0, $77906414ca06b2c8$export$98e628dec113755e),
        colSpan: null,
        content: null,
        contentEditable: (0, $77906414ca06b2c8$export$55e9e1fbc638dc8f),
        controls: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        controlsList: (0, $77906414ca06b2c8$export$ab8645c862eb5a3e),
        coords: (0, $77906414ca06b2c8$export$98e628dec113755e) | (0, $77906414ca06b2c8$export$9c8d678629b3d3),
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        defer: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        dir: null,
        dirName: null,
        disabled: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        download: (0, $77906414ca06b2c8$export$242ac3d3042558aa),
        draggable: (0, $77906414ca06b2c8$export$55e9e1fbc638dc8f),
        encType: null,
        enterKeyHint: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        formTarget: null,
        headers: (0, $77906414ca06b2c8$export$ab8645c862eb5a3e),
        height: (0, $77906414ca06b2c8$export$98e628dec113755e),
        hidden: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        high: (0, $77906414ca06b2c8$export$98e628dec113755e),
        href: null,
        hrefLang: null,
        htmlFor: (0, $77906414ca06b2c8$export$ab8645c862eb5a3e),
        httpEquiv: (0, $77906414ca06b2c8$export$ab8645c862eb5a3e),
        id: null,
        imageSizes: null,
        imageSrcSet: null,
        inputMode: null,
        integrity: null,
        is: null,
        isMap: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        itemId: null,
        itemProp: (0, $77906414ca06b2c8$export$ab8645c862eb5a3e),
        itemRef: (0, $77906414ca06b2c8$export$ab8645c862eb5a3e),
        itemScope: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        itemType: (0, $77906414ca06b2c8$export$ab8645c862eb5a3e),
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        low: (0, $77906414ca06b2c8$export$98e628dec113755e),
        manifest: null,
        max: null,
        maxLength: (0, $77906414ca06b2c8$export$98e628dec113755e),
        media: null,
        method: null,
        min: null,
        minLength: (0, $77906414ca06b2c8$export$98e628dec113755e),
        multiple: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        muted: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        name: null,
        nonce: null,
        noModule: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        noValidate: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforeMatch: null,
        onBeforePrint: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextLost: null,
        onContextMenu: null,
        onContextRestored: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onScrollEnd: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        optimum: (0, $77906414ca06b2c8$export$98e628dec113755e),
        pattern: null,
        ping: (0, $77906414ca06b2c8$export$ab8645c862eb5a3e),
        placeholder: null,
        playsInline: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        poster: null,
        preload: null,
        readOnly: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        referrerPolicy: null,
        rel: (0, $77906414ca06b2c8$export$ab8645c862eb5a3e),
        required: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        reversed: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        rows: (0, $77906414ca06b2c8$export$98e628dec113755e),
        rowSpan: (0, $77906414ca06b2c8$export$98e628dec113755e),
        sandbox: (0, $77906414ca06b2c8$export$ab8645c862eb5a3e),
        scope: null,
        scoped: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        seamless: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        selected: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        shape: null,
        size: (0, $77906414ca06b2c8$export$98e628dec113755e),
        sizes: null,
        slot: null,
        span: (0, $77906414ca06b2c8$export$98e628dec113755e),
        spellCheck: (0, $77906414ca06b2c8$export$55e9e1fbc638dc8f),
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: null,
        start: (0, $77906414ca06b2c8$export$98e628dec113755e),
        step: null,
        style: null,
        tabIndex: (0, $77906414ca06b2c8$export$98e628dec113755e),
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        useMap: null,
        value: (0, $77906414ca06b2c8$export$55e9e1fbc638dc8f),
        width: (0, $77906414ca06b2c8$export$98e628dec113755e),
        wrap: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: (0, $77906414ca06b2c8$export$ab8645c862eb5a3e),
        axis: null,
        background: null,
        bgColor: null,
        border: (0, $77906414ca06b2c8$export$98e628dec113755e),
        borderColor: null,
        bottomMargin: (0, $77906414ca06b2c8$export$98e628dec113755e),
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        declare: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: (0, $77906414ca06b2c8$export$98e628dec113755e),
        leftMargin: (0, $77906414ca06b2c8$export$98e628dec113755e),
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: (0, $77906414ca06b2c8$export$98e628dec113755e),
        marginWidth: (0, $77906414ca06b2c8$export$98e628dec113755e),
        noResize: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        noHref: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        noShade: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        noWrap: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: (0, $77906414ca06b2c8$export$98e628dec113755e),
        rules: null,
        scheme: null,
        scrolling: (0, $77906414ca06b2c8$export$55e9e1fbc638dc8f),
        standby: null,
        summary: null,
        text: null,
        topMargin: (0, $77906414ca06b2c8$export$98e628dec113755e),
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: (0, $77906414ca06b2c8$export$98e628dec113755e),
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        disableRemotePlayback: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        prefix: null,
        property: null,
        results: (0, $77906414ca06b2c8$export$98e628dec113755e),
        security: null,
        unselectable: null
    }
});





const $7949cd4c5d76eb6c$export$7ed1367e7fa1ad68 = (0, $152608770f9afeeb$export$185802fd694ee1f5)({
    space: "svg",
    attributes: {
        accentHeight: "accent-height",
        alignmentBaseline: "alignment-baseline",
        arabicForm: "arabic-form",
        baselineShift: "baseline-shift",
        capHeight: "cap-height",
        className: "class",
        clipPath: "clip-path",
        clipRule: "clip-rule",
        colorInterpolation: "color-interpolation",
        colorInterpolationFilters: "color-interpolation-filters",
        colorProfile: "color-profile",
        colorRendering: "color-rendering",
        crossOrigin: "crossorigin",
        dataType: "datatype",
        dominantBaseline: "dominant-baseline",
        enableBackground: "enable-background",
        fillOpacity: "fill-opacity",
        fillRule: "fill-rule",
        floodColor: "flood-color",
        floodOpacity: "flood-opacity",
        fontFamily: "font-family",
        fontSize: "font-size",
        fontSizeAdjust: "font-size-adjust",
        fontStretch: "font-stretch",
        fontStyle: "font-style",
        fontVariant: "font-variant",
        fontWeight: "font-weight",
        glyphName: "glyph-name",
        glyphOrientationHorizontal: "glyph-orientation-horizontal",
        glyphOrientationVertical: "glyph-orientation-vertical",
        hrefLang: "hreflang",
        horizAdvX: "horiz-adv-x",
        horizOriginX: "horiz-origin-x",
        horizOriginY: "horiz-origin-y",
        imageRendering: "image-rendering",
        letterSpacing: "letter-spacing",
        lightingColor: "lighting-color",
        markerEnd: "marker-end",
        markerMid: "marker-mid",
        markerStart: "marker-start",
        navDown: "nav-down",
        navDownLeft: "nav-down-left",
        navDownRight: "nav-down-right",
        navLeft: "nav-left",
        navNext: "nav-next",
        navPrev: "nav-prev",
        navRight: "nav-right",
        navUp: "nav-up",
        navUpLeft: "nav-up-left",
        navUpRight: "nav-up-right",
        onAbort: "onabort",
        onActivate: "onactivate",
        onAfterPrint: "onafterprint",
        onBeforePrint: "onbeforeprint",
        onBegin: "onbegin",
        onCancel: "oncancel",
        onCanPlay: "oncanplay",
        onCanPlayThrough: "oncanplaythrough",
        onChange: "onchange",
        onClick: "onclick",
        onClose: "onclose",
        onCopy: "oncopy",
        onCueChange: "oncuechange",
        onCut: "oncut",
        onDblClick: "ondblclick",
        onDrag: "ondrag",
        onDragEnd: "ondragend",
        onDragEnter: "ondragenter",
        onDragExit: "ondragexit",
        onDragLeave: "ondragleave",
        onDragOver: "ondragover",
        onDragStart: "ondragstart",
        onDrop: "ondrop",
        onDurationChange: "ondurationchange",
        onEmptied: "onemptied",
        onEnd: "onend",
        onEnded: "onended",
        onError: "onerror",
        onFocus: "onfocus",
        onFocusIn: "onfocusin",
        onFocusOut: "onfocusout",
        onHashChange: "onhashchange",
        onInput: "oninput",
        onInvalid: "oninvalid",
        onKeyDown: "onkeydown",
        onKeyPress: "onkeypress",
        onKeyUp: "onkeyup",
        onLoad: "onload",
        onLoadedData: "onloadeddata",
        onLoadedMetadata: "onloadedmetadata",
        onLoadStart: "onloadstart",
        onMessage: "onmessage",
        onMouseDown: "onmousedown",
        onMouseEnter: "onmouseenter",
        onMouseLeave: "onmouseleave",
        onMouseMove: "onmousemove",
        onMouseOut: "onmouseout",
        onMouseOver: "onmouseover",
        onMouseUp: "onmouseup",
        onMouseWheel: "onmousewheel",
        onOffline: "onoffline",
        onOnline: "ononline",
        onPageHide: "onpagehide",
        onPageShow: "onpageshow",
        onPaste: "onpaste",
        onPause: "onpause",
        onPlay: "onplay",
        onPlaying: "onplaying",
        onPopState: "onpopstate",
        onProgress: "onprogress",
        onRateChange: "onratechange",
        onRepeat: "onrepeat",
        onReset: "onreset",
        onResize: "onresize",
        onScroll: "onscroll",
        onSeeked: "onseeked",
        onSeeking: "onseeking",
        onSelect: "onselect",
        onShow: "onshow",
        onStalled: "onstalled",
        onStorage: "onstorage",
        onSubmit: "onsubmit",
        onSuspend: "onsuspend",
        onTimeUpdate: "ontimeupdate",
        onToggle: "ontoggle",
        onUnload: "onunload",
        onVolumeChange: "onvolumechange",
        onWaiting: "onwaiting",
        onZoom: "onzoom",
        overlinePosition: "overline-position",
        overlineThickness: "overline-thickness",
        paintOrder: "paint-order",
        panose1: "panose-1",
        pointerEvents: "pointer-events",
        referrerPolicy: "referrerpolicy",
        renderingIntent: "rendering-intent",
        shapeRendering: "shape-rendering",
        stopColor: "stop-color",
        stopOpacity: "stop-opacity",
        strikethroughPosition: "strikethrough-position",
        strikethroughThickness: "strikethrough-thickness",
        strokeDashArray: "stroke-dasharray",
        strokeDashOffset: "stroke-dashoffset",
        strokeLineCap: "stroke-linecap",
        strokeLineJoin: "stroke-linejoin",
        strokeMiterLimit: "stroke-miterlimit",
        strokeOpacity: "stroke-opacity",
        strokeWidth: "stroke-width",
        tabIndex: "tabindex",
        textAnchor: "text-anchor",
        textDecoration: "text-decoration",
        textRendering: "text-rendering",
        typeOf: "typeof",
        underlinePosition: "underline-position",
        underlineThickness: "underline-thickness",
        unicodeBidi: "unicode-bidi",
        unicodeRange: "unicode-range",
        unitsPerEm: "units-per-em",
        vAlphabetic: "v-alphabetic",
        vHanging: "v-hanging",
        vIdeographic: "v-ideographic",
        vMathematical: "v-mathematical",
        vectorEffect: "vector-effect",
        vertAdvY: "vert-adv-y",
        vertOriginX: "vert-origin-x",
        vertOriginY: "vert-origin-y",
        wordSpacing: "word-spacing",
        writingMode: "writing-mode",
        xHeight: "x-height",
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: "playbackorder",
        timelineBegin: "timelinebegin"
    },
    transform: (0, $0c49ba436e5c3fe2$export$5b10b3bc32d7efbc),
    properties: {
        about: (0, $77906414ca06b2c8$export$2ad25cfebf36cacd),
        accentHeight: (0, $77906414ca06b2c8$export$98e628dec113755e),
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: (0, $77906414ca06b2c8$export$98e628dec113755e),
        amplitude: (0, $77906414ca06b2c8$export$98e628dec113755e),
        arabicForm: null,
        ascent: (0, $77906414ca06b2c8$export$98e628dec113755e),
        attributeName: null,
        attributeType: null,
        azimuth: (0, $77906414ca06b2c8$export$98e628dec113755e),
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: (0, $77906414ca06b2c8$export$98e628dec113755e),
        by: null,
        calcMode: null,
        capHeight: (0, $77906414ca06b2c8$export$98e628dec113755e),
        className: (0, $77906414ca06b2c8$export$ab8645c862eb5a3e),
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: (0, $77906414ca06b2c8$export$98e628dec113755e),
        diffuseConstant: (0, $77906414ca06b2c8$export$98e628dec113755e),
        direction: null,
        display: null,
        dur: null,
        divisor: (0, $77906414ca06b2c8$export$98e628dec113755e),
        dominantBaseline: null,
        download: (0, $77906414ca06b2c8$export$4a21f16c33752377),
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: (0, $77906414ca06b2c8$export$98e628dec113755e),
        enableBackground: null,
        end: null,
        event: null,
        exponent: (0, $77906414ca06b2c8$export$98e628dec113755e),
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: (0, $77906414ca06b2c8$export$98e628dec113755e),
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: (0, $77906414ca06b2c8$export$9c8d678629b3d3),
        g2: (0, $77906414ca06b2c8$export$9c8d678629b3d3),
        glyphName: (0, $77906414ca06b2c8$export$9c8d678629b3d3),
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: (0, $77906414ca06b2c8$export$98e628dec113755e),
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: (0, $77906414ca06b2c8$export$98e628dec113755e),
        horizOriginX: (0, $77906414ca06b2c8$export$98e628dec113755e),
        horizOriginY: (0, $77906414ca06b2c8$export$98e628dec113755e),
        id: null,
        ideographic: (0, $77906414ca06b2c8$export$98e628dec113755e),
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: (0, $77906414ca06b2c8$export$98e628dec113755e),
        k: (0, $77906414ca06b2c8$export$98e628dec113755e),
        k1: (0, $77906414ca06b2c8$export$98e628dec113755e),
        k2: (0, $77906414ca06b2c8$export$98e628dec113755e),
        k3: (0, $77906414ca06b2c8$export$98e628dec113755e),
        k4: (0, $77906414ca06b2c8$export$98e628dec113755e),
        kernelMatrix: (0, $77906414ca06b2c8$export$2ad25cfebf36cacd),
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: (0, $77906414ca06b2c8$export$98e628dec113755e),
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: (0, $77906414ca06b2c8$export$98e628dec113755e),
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: (0, $77906414ca06b2c8$export$98e628dec113755e),
        overlineThickness: (0, $77906414ca06b2c8$export$98e628dec113755e),
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: (0, $77906414ca06b2c8$export$98e628dec113755e),
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: (0, $77906414ca06b2c8$export$ab8645c862eb5a3e),
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: (0, $77906414ca06b2c8$export$98e628dec113755e),
        pointsAtY: (0, $77906414ca06b2c8$export$98e628dec113755e),
        pointsAtZ: (0, $77906414ca06b2c8$export$98e628dec113755e),
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: (0, $77906414ca06b2c8$export$2ad25cfebf36cacd),
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: (0, $77906414ca06b2c8$export$2ad25cfebf36cacd),
        rev: (0, $77906414ca06b2c8$export$2ad25cfebf36cacd),
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: (0, $77906414ca06b2c8$export$2ad25cfebf36cacd),
        requiredFeatures: (0, $77906414ca06b2c8$export$2ad25cfebf36cacd),
        requiredFonts: (0, $77906414ca06b2c8$export$2ad25cfebf36cacd),
        requiredFormats: (0, $77906414ca06b2c8$export$2ad25cfebf36cacd),
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: (0, $77906414ca06b2c8$export$98e628dec113755e),
        specularExponent: (0, $77906414ca06b2c8$export$98e628dec113755e),
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: (0, $77906414ca06b2c8$export$98e628dec113755e),
        strikethroughThickness: (0, $77906414ca06b2c8$export$98e628dec113755e),
        string: null,
        stroke: null,
        strokeDashArray: (0, $77906414ca06b2c8$export$2ad25cfebf36cacd),
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: (0, $77906414ca06b2c8$export$98e628dec113755e),
        strokeOpacity: (0, $77906414ca06b2c8$export$98e628dec113755e),
        strokeWidth: null,
        style: null,
        surfaceScale: (0, $77906414ca06b2c8$export$98e628dec113755e),
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: (0, $77906414ca06b2c8$export$2ad25cfebf36cacd),
        tabIndex: (0, $77906414ca06b2c8$export$98e628dec113755e),
        tableValues: null,
        target: null,
        targetX: (0, $77906414ca06b2c8$export$98e628dec113755e),
        targetY: (0, $77906414ca06b2c8$export$98e628dec113755e),
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: (0, $77906414ca06b2c8$export$2ad25cfebf36cacd),
        to: null,
        transform: null,
        u1: null,
        u2: null,
        underlinePosition: (0, $77906414ca06b2c8$export$98e628dec113755e),
        underlineThickness: (0, $77906414ca06b2c8$export$98e628dec113755e),
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: (0, $77906414ca06b2c8$export$98e628dec113755e),
        values: null,
        vAlphabetic: (0, $77906414ca06b2c8$export$98e628dec113755e),
        vMathematical: (0, $77906414ca06b2c8$export$98e628dec113755e),
        vectorEffect: null,
        vHanging: (0, $77906414ca06b2c8$export$98e628dec113755e),
        vIdeographic: (0, $77906414ca06b2c8$export$98e628dec113755e),
        version: null,
        vertAdvY: (0, $77906414ca06b2c8$export$98e628dec113755e),
        vertOriginX: (0, $77906414ca06b2c8$export$98e628dec113755e),
        vertOriginY: (0, $77906414ca06b2c8$export$98e628dec113755e),
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: (0, $77906414ca06b2c8$export$98e628dec113755e),
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    }
});





const $744c79ac00c55d9d$export$c0bb0b647f701bb5 = (0, $e11d5cc5e2d498a7$export$4950aa0f605343fb)([
    (0, $440cd80b72261c32$export$f2913fe8983302e),
    (0, $a1283f670d8ae8f8$export$2bd1230ec7600845),
    (0, $825e0ecacb0f9d30$export$e20c24a128671213),
    (0, $a4265a6678314874$export$4d2d26490572750a),
    (0, $c216ad746de7e547$export$c0bb0b647f701bb5)
], "html");
const $744c79ac00c55d9d$export$7ed1367e7fa1ad68 = (0, $e11d5cc5e2d498a7$export$4950aa0f605343fb)([
    (0, $440cd80b72261c32$export$f2913fe8983302e),
    (0, $a1283f670d8ae8f8$export$2bd1230ec7600845),
    (0, $825e0ecacb0f9d30$export$e20c24a128671213),
    (0, $a4265a6678314874$export$4d2d26490572750a),
    (0, $7949cd4c5d76eb6c$export$7ed1367e7fa1ad68)
], "svg");


/**
 * Parse space separated tokens to an array of strings.
 *
 * @param {string} value Space separated tokens
 * @returns {Array.<string>} Tokens
 */ function $52ac0fd1715e7e9e$export$98e6a39c04603d36(value) {
    const input = String(value || "").trim();
    return input ? input.split(/[ \t\n\r\f]+/g) : [];
}
function $52ac0fd1715e7e9e$export$fac44ee5b035f737(values) {
    return values.join(" ").trim();
}


var $8cc7527fb17b6502$exports = {};
var $235d4ce2a0483b3b$exports = {};
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $235d4ce2a0483b3b$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $235d4ce2a0483b3b$var$NEWLINE_REGEX = /\n/g;
var $235d4ce2a0483b3b$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $235d4ce2a0483b3b$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $235d4ce2a0483b3b$var$COLON_REGEX = /^:\s*/;
var $235d4ce2a0483b3b$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $235d4ce2a0483b3b$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $235d4ce2a0483b3b$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $235d4ce2a0483b3b$var$NEWLINE = "\n";
var $235d4ce2a0483b3b$var$FORWARD_SLASH = "/";
var $235d4ce2a0483b3b$var$ASTERISK = "*";
var $235d4ce2a0483b3b$var$EMPTY_STRING = "";
// types
var $235d4ce2a0483b3b$var$TYPE_COMMENT = "comment";
var $235d4ce2a0483b3b$var$TYPE_DECLARATION = "declaration";
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ $235d4ce2a0483b3b$exports = function(style, options) {
    if (typeof style !== "string") throw new TypeError("First argument must be a string");
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($235d4ce2a0483b3b$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($235d4ce2a0483b3b$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    var errorsList = [];
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ":" + lineno + ":" + column + ": " + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($235d4ce2a0483b3b$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($235d4ce2a0483b3b$var$FORWARD_SLASH != style.charAt(0) || $235d4ce2a0483b3b$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($235d4ce2a0483b3b$var$EMPTY_STRING != style.charAt(i) && ($235d4ce2a0483b3b$var$ASTERISK != style.charAt(i) || $235d4ce2a0483b3b$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($235d4ce2a0483b3b$var$EMPTY_STRING === style.charAt(i - 1)) return error("End of comment missing");
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $235d4ce2a0483b3b$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($235d4ce2a0483b3b$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($235d4ce2a0483b3b$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($235d4ce2a0483b3b$var$VALUE_REGEX);
        var ret = pos({
            type: $235d4ce2a0483b3b$var$TYPE_DECLARATION,
            property: $235d4ce2a0483b3b$var$trim(prop[0].replace($235d4ce2a0483b3b$var$COMMENT_REGEX, $235d4ce2a0483b3b$var$EMPTY_STRING)),
            value: val ? $235d4ce2a0483b3b$var$trim(val[0].replace($235d4ce2a0483b3b$var$COMMENT_REGEX, $235d4ce2a0483b3b$var$EMPTY_STRING)) : $235d4ce2a0483b3b$var$EMPTY_STRING
        });
        // ;
        match($235d4ce2a0483b3b$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $235d4ce2a0483b3b$var$trim(str) {
    return str ? str.replace($235d4ce2a0483b3b$var$TRIM_REGEX, $235d4ce2a0483b3b$var$EMPTY_STRING) : $235d4ce2a0483b3b$var$EMPTY_STRING;
}


/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */ function $8cc7527fb17b6502$var$StyleToObject(style, iterator) {
    var output = null;
    if (!style || typeof style !== "string") return output;
    var declaration;
    var declarations = $235d4ce2a0483b3b$exports(style);
    var hasIterator = typeof iterator === "function";
    var property;
    var value;
    for(var i = 0, len = declarations.length; i < len; i++){
        declaration = declarations[i];
        property = declaration.property;
        value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            output || (output = {});
            output[property] = value;
        }
    }
    return output;
}
$8cc7527fb17b6502$exports = $8cc7527fb17b6502$var$StyleToObject;
$8cc7527fb17b6502$exports.default = $8cc7527fb17b6502$var$StyleToObject; // ESM support


var $201af925e8f77214$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($8cc7527fb17b6502$exports)));


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Get the ending point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */ const $a349554b0943c73d$export$da309cdce9dc2a25 = $a349554b0943c73d$var$point("end");
const $a349554b0943c73d$export$771bf3e4949bfbee = $a349554b0943c73d$var$point("start");
/**
 * Get the positional info of `node`.
 *
 * @param {'end' | 'start'} type
 *   Side.
 * @returns
 *   Getter.
 */ function $a349554b0943c73d$var$point(type) {
    return point;
    /**
   * Get the point info of `node` at a bound side.
   *
   * @param {Node | NodeLike | null | undefined} [node]
   * @returns {Point | undefined}
   */ function point(node) {
        const point = node && node.position && node.position[type] || {};
        if (typeof point.line === "number" && point.line > 0 && typeof point.column === "number" && point.column > 0) return {
            line: point.line,
            column: point.column,
            offset: typeof point.offset === "number" && point.offset > -1 ? point.offset : undefined
        };
    }
}
function $a349554b0943c73d$export$5880b8b5730aff45(node) {
    const start = $a349554b0943c73d$export$771bf3e4949bfbee(node);
    const end = $a349554b0943c73d$export$da309cdce9dc2a25(node);
    if (start && end) return {
        start: start,
        end: end
    };
}


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef Options
 *   Configuration.
 * @property {Array<Node> | null | undefined} [ancestors]
 *   Stack of (inclusive) ancestor nodes surrounding the message (optional).
 * @property {Error | null | undefined} [cause]
 *   Original error cause of the message (optional).
 * @property {Point | Position | null | undefined} [place]
 *   Place of message (optional).
 * @property {string | null | undefined} [ruleId]
 *   Category of message (optional, example: `'my-rule'`).
 * @property {string | null | undefined} [source]
 *   Namespace of who sent the message (optional, example: `'my-package'`).
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 */ /**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Point | PointLike | Position | PositionLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */ function $21e5b9692333dcba$export$c304dd45fe166145(value) {
    // Nothing.
    if (!value || typeof value !== "object") return "";
    // Node.
    if ("position" in value || "type" in value) return $21e5b9692333dcba$var$position(value.position);
    // Position.
    if ("start" in value || "end" in value) return $21e5b9692333dcba$var$position(value);
    // Point.
    if ("line" in value || "column" in value) return $21e5b9692333dcba$var$point(value);
    // ?
    return "";
}
/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */ function $21e5b9692333dcba$var$point(point) {
    return $21e5b9692333dcba$var$index(point && point.line) + ":" + $21e5b9692333dcba$var$index(point && point.column);
}
/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */ function $21e5b9692333dcba$var$position(pos) {
    return $21e5b9692333dcba$var$point(pos && pos.start) + "-" + $21e5b9692333dcba$var$point(pos && pos.end);
}
/**
 * @param {number | null | undefined} value
 * @returns {number}
 */ function $21e5b9692333dcba$var$index(value) {
    return value && typeof value === "number" ? value : 1;
}


class $1af72c1830aac8bc$export$752e5c445fe834ef extends Error {
    /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */ // eslint-disable-next-line complexity
    constructor(causeOrReason, optionsOrParentOrPlace, origin){
        super();
        if (typeof optionsOrParentOrPlace === "string") {
            origin = optionsOrParentOrPlace;
            optionsOrParentOrPlace = undefined;
        }
        /** @type {string} */ let reason = "";
        /** @type {Options} */ let options = {};
        let legacyCause = false;
        if (optionsOrParentOrPlace) {
            // Point.
            if ("line" in optionsOrParentOrPlace && "column" in optionsOrParentOrPlace) options = {
                place: optionsOrParentOrPlace
            };
            else if ("start" in optionsOrParentOrPlace && "end" in optionsOrParentOrPlace) options = {
                place: optionsOrParentOrPlace
            };
            else if ("type" in optionsOrParentOrPlace) options = {
                ancestors: [
                    optionsOrParentOrPlace
                ],
                place: optionsOrParentOrPlace.position
            };
            else options = {
                ...optionsOrParentOrPlace
            };
        }
        if (typeof causeOrReason === "string") reason = causeOrReason;
        else if (!options.cause && causeOrReason) {
            legacyCause = true;
            reason = causeOrReason.message;
            options.cause = causeOrReason;
        }
        if (!options.ruleId && !options.source && typeof origin === "string") {
            const index = origin.indexOf(":");
            if (index === -1) options.ruleId = origin;
            else {
                options.source = origin.slice(0, index);
                options.ruleId = origin.slice(index + 1);
            }
        }
        if (!options.place && options.ancestors && options.ancestors) {
            const parent = options.ancestors[options.ancestors.length - 1];
            if (parent) options.place = parent.position;
        }
        const start = options.place && "start" in options.place ? options.place.start : options.place;
        /* eslint-disable no-unused-expressions */ /**
     * Stack of ancestor nodes surrounding the message.
     *
     * @type {Array<Node> | undefined}
     */ this.ancestors = options.ancestors || undefined;
        /**
     * Original error cause of the message.
     *
     * @type {Error | undefined}
     */ this.cause = options.cause || undefined;
        /**
     * Starting column of message.
     *
     * @type {number | undefined}
     */ this.column = start ? start.column : undefined;
        /**
     * State of problem.
     *
     * * `true` — error, file not usable
     * * `false` — warning, change may be needed
     * * `undefined` — change likely not needed
     *
     * @type {boolean | null | undefined}
     */ this.fatal = undefined;
        /**
     * Path of a file (used throughout the `VFile` ecosystem).
     *
     * @type {string | undefined}
     */ this.file;
        // Field from `Error`.
        /**
     * Reason for message.
     *
     * @type {string}
     */ this.message = reason;
        /**
     * Starting line of error.
     *
     * @type {number | undefined}
     */ this.line = start ? start.line : undefined;
        // Field from `Error`.
        /**
     * Serialized positional info of message.
     *
     * On normal errors, this would be something like `ParseError`, buit in
     * `VFile` messages we use this space to show where an error happened.
     */ this.name = (0, $21e5b9692333dcba$export$c304dd45fe166145)(options.place) || "1:1";
        /**
     * Place of message.
     *
     * @type {Point | Position | undefined}
     */ this.place = options.place || undefined;
        /**
     * Reason for message, should use markdown.
     *
     * @type {string}
     */ this.reason = this.message;
        /**
     * Category of message (example: `'my-rule'`).
     *
     * @type {string | undefined}
     */ this.ruleId = options.ruleId || undefined;
        /**
     * Namespace of message (example: `'my-package'`).
     *
     * @type {string | undefined}
     */ this.source = options.source || undefined;
        // Field from `Error`.
        /**
     * Stack of message.
     *
     * This is used by normal errors to show where something happened in
     * programming code, irrelevant for `VFile` messages,
     *
     * @type {string}
     */ this.stack = legacyCause && options.cause && typeof options.cause.stack === "string" ? options.cause.stack : "";
        // The following fields are “well known”.
        // Not standard.
        // Feel free to add other non-standard fields to your messages.
        /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string | undefined}
     */ this.actual;
        /**
     * Suggest acceptable values that can be used instead of `actual`.
     *
     * @type {Array<string> | undefined}
     */ this.expected;
        /**
     * Long form description of the message (you should use markdown).
     *
     * @type {string | undefined}
     */ this.note;
        /**
     * Link to docs for the message.
     *
     * > 👉 **Note**: this must be an absolute URL that can be passed as `x`
     * > to `new URL(x)`.
     *
     * @type {string | undefined}
     */ this.url;
    /* eslint-enable no-unused-expressions */ }
}
$1af72c1830aac8bc$export$752e5c445fe834ef.prototype.file = "";
$1af72c1830aac8bc$export$752e5c445fe834ef.prototype.name = "";
$1af72c1830aac8bc$export$752e5c445fe834ef.prototype.reason = "";
$1af72c1830aac8bc$export$752e5c445fe834ef.prototype.message = "";
$1af72c1830aac8bc$export$752e5c445fe834ef.prototype.stack = "";
$1af72c1830aac8bc$export$752e5c445fe834ef.prototype.column = undefined;
$1af72c1830aac8bc$export$752e5c445fe834ef.prototype.line = undefined;
$1af72c1830aac8bc$export$752e5c445fe834ef.prototype.ancestors = undefined;
$1af72c1830aac8bc$export$752e5c445fe834ef.prototype.cause = undefined;
$1af72c1830aac8bc$export$752e5c445fe834ef.prototype.fatal = undefined;
$1af72c1830aac8bc$export$752e5c445fe834ef.prototype.place = undefined;
$1af72c1830aac8bc$export$752e5c445fe834ef.prototype.ruleId = undefined;
$1af72c1830aac8bc$export$752e5c445fe834ef.prototype.source = undefined;


const $9143a58b0eb89e6c$var$own = {}.hasOwnProperty;
/** @type {Map<string, number>} */ const $9143a58b0eb89e6c$var$emptyMap = new Map();
const $9143a58b0eb89e6c$var$cap = /[A-Z]/g;
const $9143a58b0eb89e6c$var$dashSomething = /-([a-z])/g;
// `react-dom` triggers a warning for *any* white space in tables.
// To follow GFM, `mdast-util-to-hast` injects line endings between elements.
// Other tools might do so too, but they don’t do here, so we remove all of
// that.
// See: <https://github.com/facebook/react/pull/7081>.
// See: <https://github.com/facebook/react/pull/7515>.
// See: <https://github.com/remarkjs/remark-react/issues/64>.
// See: <https://github.com/rehypejs/rehype-react/pull/29>.
// See: <https://github.com/rehypejs/rehype-react/pull/32>.
// See: <https://github.com/rehypejs/rehype-react/pull/45>.
const $9143a58b0eb89e6c$var$tableElements = new Set([
    "table",
    "tbody",
    "thead",
    "tfoot",
    "tr"
]);
const $9143a58b0eb89e6c$var$tableCellElement = new Set([
    "td",
    "th"
]);
function $9143a58b0eb89e6c$export$59c10052b2dee561(tree, options) {
    if (!options || options.Fragment === undefined) throw new TypeError("Expected `Fragment` in options");
    const filePath = options.filePath || undefined;
    /** @type {Create} */ let create;
    if (options.development) {
        if (typeof options.jsxDEV !== "function") throw new TypeError("Expected `jsxDEV` in options when `development: true`");
        create = $9143a58b0eb89e6c$var$developmentCreate(filePath, options.jsxDEV);
    } else {
        if (typeof options.jsx !== "function") throw new TypeError("Expected `jsx` in production options");
        if (typeof options.jsxs !== "function") throw new TypeError("Expected `jsxs` in production options");
        create = $9143a58b0eb89e6c$var$productionCreate(filePath, options.jsx, options.jsxs);
    }
    /** @type {State} */ const state = {
        Fragment: options.Fragment,
        ancestors: [],
        components: options.components || {},
        create: create,
        elementAttributeNameCase: options.elementAttributeNameCase || "react",
        filePath: filePath,
        ignoreInvalidStyle: options.ignoreInvalidStyle || false,
        passKeys: options.passKeys !== false,
        passNode: options.passNode || false,
        schema: options.space === "svg" ? (0, $744c79ac00c55d9d$export$7ed1367e7fa1ad68) : (0, $744c79ac00c55d9d$export$c0bb0b647f701bb5),
        stylePropertyNameCase: options.stylePropertyNameCase || "dom",
        tableCellAlignToStyle: options.tableCellAlignToStyle !== false
    };
    const result = $9143a58b0eb89e6c$var$one(state, tree, undefined);
    // JSX element.
    if (result && typeof result !== "string") return result;
    // Text node or something that turned into nothing.
    return state.create(tree, state.Fragment, {
        children: result || undefined
    }, undefined);
}
/**
 * Transform a node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Nodes} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $9143a58b0eb89e6c$var$one(state, node, key) {
    if (node.type === "element" || node.type === "root") {
        const parentSchema = state.schema;
        let schema = parentSchema;
        if (node.type === "element" && node.tagName.toLowerCase() === "svg" && parentSchema.space === "html") {
            schema = (0, $744c79ac00c55d9d$export$7ed1367e7fa1ad68);
            state.schema = schema;
        }
        state.ancestors.push(node);
        let children = $9143a58b0eb89e6c$var$createChildren(state, node);
        const props = $9143a58b0eb89e6c$var$createProperties(state, state.ancestors);
        let type = state.Fragment;
        state.ancestors.pop();
        if (node.type === "element") {
            if (children && $9143a58b0eb89e6c$var$tableElements.has(node.tagName)) children = children.filter(function(child) {
                return typeof child === "string" ? !(0, $b1f5fe7f2b8089b4$export$7af1228ff777d175)(child) : true;
            });
            if ($9143a58b0eb89e6c$var$own.call(state.components, node.tagName)) {
                const key = /** @type {keyof JSX.IntrinsicElements} */ node.tagName;
                type = state.components[key];
                // If this is swapped out for a component:
                if (typeof type !== "string" && type !== state.Fragment && state.passNode) props.node = node;
            } else type = node.tagName;
        }
        if (children.length > 0) {
            const value = children.length > 1 ? children : children[0];
            if (value) props.children = value;
        }
        // Restore parent schema.
        state.schema = parentSchema;
        return state.create(node, type, props, key);
    }
    if (node.type === "text") return node.value;
}
/**
 * @param {string | undefined} _
 *   Path to file.
 * @param {Jsx} jsx
 *   Dynamic.
 * @param {Jsx} jsxs
 *   Static.
 * @returns {Create}
 *   Create a production element.
 */ function $9143a58b0eb89e6c$var$productionCreate(_, jsx, jsxs) {
    return create;
    /** @type {Create} */ function create(_, type, props, key) {
        // Only an array when there are 2 or more children.
        const isStaticChildren = Array.isArray(props.children);
        const fn = isStaticChildren ? jsxs : jsx;
        return key ? fn(type, props, key) : fn(type, props);
    }
}
/**
 * @param {string | undefined} filePath
 *   Path to file.
 * @param {JsxDev} jsxDEV
 *   Development.
 * @returns {Create}
 *   Create a development element.
 */ function $9143a58b0eb89e6c$var$developmentCreate(filePath, jsxDEV) {
    return create;
    /** @type {Create} */ function create(node, type, props, key) {
        // Only an array when there are 2 or more children.
        const isStaticChildren = Array.isArray(props.children);
        const point = (0, $a349554b0943c73d$export$771bf3e4949bfbee)(node);
        return jsxDEV(type, props, key, isStaticChildren, {
            columnNumber: point ? point.column - 1 : undefined,
            fileName: filePath,
            lineNumber: point ? point.line : undefined
        }, undefined);
    }
}
/**
 * Create children.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Parents} node
 *   Current element.
 * @returns {Array<Child>}
 *   Children.
 */ function $9143a58b0eb89e6c$var$createChildren(state, node) {
    /** @type {Array<Child>} */ const children = [];
    let index = -1;
    /** @type {Map<string, number>} */ // Note: test this when Solid doesn’t want to merge my upcoming PR.
    /* c8 ignore next */ const countsByTagName = state.passKeys ? new Map() : $9143a58b0eb89e6c$var$emptyMap;
    while(++index < node.children.length){
        const child = node.children[index];
        /** @type {string | undefined} */ let key;
        if (state.passKeys && child.type === "element") {
            const count = countsByTagName.get(child.tagName) || 0;
            key = child.tagName + "-" + count;
            countsByTagName.set(child.tagName, count + 1);
        }
        const result = $9143a58b0eb89e6c$var$one(state, child, key);
        if (result !== undefined) children.push(result);
    }
    return children;
}
/**
 * Handle properties.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Array<Parents>} ancestors
 *   Stack of parents.
 * @returns {Props}
 *   Props for runtime.
 */ function $9143a58b0eb89e6c$var$createProperties(state, ancestors) {
    const node = ancestors[ancestors.length - 1];
    /** @type {Props} */ const props = {};
    /** @type {string} */ let prop;
    if ("properties" in node && node.properties) {
        /** @type {string | undefined} */ let alignValue;
        for(prop in node.properties)if (prop !== "children" && $9143a58b0eb89e6c$var$own.call(node.properties, prop)) {
            const result = $9143a58b0eb89e6c$var$createProperty(state, ancestors, prop, node.properties[prop]);
            if (result) {
                const [key, value] = result;
                if (state.tableCellAlignToStyle && key === "align" && typeof value === "string" && $9143a58b0eb89e6c$var$tableCellElement.has(node.tagName)) alignValue = value;
                else props[key] = value;
            }
        }
        if (alignValue) {
            // Assume style is an object.
            const style = /** @type {Style} */ props.style || (props.style = {});
            style[state.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = alignValue;
        }
    }
    return props;
}
/**
 * Handle a property.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Array<Parents>} ancestors
 *   Stack of parents.
 * @param {string} prop
 *   Key.
 * @param {Array<number | string> | boolean | number | string | null | undefined} value
 *   hast property value.
 * @returns {Field | undefined}
 *   Field for runtime, optional.
 */ function $9143a58b0eb89e6c$var$createProperty(state, ancestors, prop, value) {
    const info = (0, $50285aefa5e98f02$export$71aa6c912b956294)(state.schema, prop);
    // Ignore nullish and `NaN` values.
    if (value === null || value === undefined || typeof value === "number" && Number.isNaN(value)) return;
    if (Array.isArray(value)) // Accept `array`.
    // Most props are space-separated.
    value = info.commaSeparated ? (0, $04bff1d485c19e9f$export$fac44ee5b035f737)(value) : (0, $52ac0fd1715e7e9e$export$fac44ee5b035f737)(value);
    // React only accepts `style` as object.
    if (info.property === "style") {
        let styleObject = typeof value === "object" ? value : $9143a58b0eb89e6c$var$parseStyle(state, ancestors, String(value));
        if (state.stylePropertyNameCase === "css") styleObject = $9143a58b0eb89e6c$var$transformStylesToCssCasing(styleObject);
        return [
            "style",
            styleObject
        ];
    }
    return [
        state.elementAttributeNameCase === "react" && info.space ? (0, $675de08bc33c4a01$export$d8abd7e5fb6871f9)[info.property] || info.property : info.attribute,
        value
    ];
}
/**
 * Parse a CSS declaration to an object.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Array<Nodes>} ancestors
 *   Stack of nodes.
 * @param {string} value
 *   CSS declarations.
 * @returns {Style}
 *   Properties.
 * @throws
 *   Throws `VFileMessage` when CSS cannot be parsed.
 */ function $9143a58b0eb89e6c$var$parseStyle(state, ancestors, value) {
    /** @type {Style} */ const result = {};
    try {
        (0, $201af925e8f77214$export$2e2bcd8739ae039)(value, replacer);
    } catch (error) {
        if (!state.ignoreInvalidStyle) {
            const cause = /** @type {Error} */ error;
            const message = new (0, $1af72c1830aac8bc$export$752e5c445fe834ef)("Cannot parse `style` attribute", {
                ancestors: ancestors,
                cause: cause,
                source: "hast-util-to-jsx-runtime",
                ruleId: "style"
            });
            message.file = state.filePath || undefined;
            message.url = "https://github.com/syntax-tree/hast-util-to-jsx-runtime#cannot-parse-style-attribute";
            throw message;
        }
    }
    return result;
    /**
   * Add a CSS property (normal, so with dashes) to `result` as a DOM CSS
   * property.
   *
   * @param {string} name
   *   Key.
   * @param {string} value
   *   Value
   * @returns {undefined}
   *   Nothing.
   */ function replacer(name, value) {
        let key = name;
        if (key.slice(0, 2) !== "--") {
            if (key.slice(0, 4) === "-ms-") key = "ms-" + key.slice(4);
            key = key.replace($9143a58b0eb89e6c$var$dashSomething, $9143a58b0eb89e6c$var$toCamel);
        }
        result[key] = value;
    }
}
/**
 * Transform a DOM casing style object to a CSS casing style object.
 *
 * @param {Style} domCasing
 * @returns {Style}
 */ function $9143a58b0eb89e6c$var$transformStylesToCssCasing(domCasing) {
    /** @type {Style} */ const cssCasing = {};
    /** @type {string} */ let from;
    for(from in domCasing)if ($9143a58b0eb89e6c$var$own.call(domCasing, from)) cssCasing[$9143a58b0eb89e6c$var$transformStyleToCssCasing(from)] = domCasing[from];
    return cssCasing;
}
/**
 * Transform a DOM casing style field to a CSS casing style field.
 *
 * @param {string} from
 * @returns {string}
 */ function $9143a58b0eb89e6c$var$transformStyleToCssCasing(from) {
    let to = from.replace($9143a58b0eb89e6c$var$cap, $9143a58b0eb89e6c$var$toDash);
    // Handle `ms-xxx` -> `-ms-xxx`.
    if (to.slice(0, 3) === "ms-") to = "-" + to;
    return to;
}
/**
 * Make `$1` capitalized.
 *
 * @param {string} _
 *   Whatever.
 * @param {string} $1
 *   Single ASCII alphabetical.
 * @returns {string}
 *   Capitalized `$1`.
 */ function $9143a58b0eb89e6c$var$toCamel(_, $1) {
    return $1.toUpperCase();
}
/**
 * Make `$0` dash cased.
 *
 * @param {string} $0
 *   Capitalized ASCII leter.
 * @returns {string}
 *   Dash and lower letter.
 */ function $9143a58b0eb89e6c$var$toDash($0) {
    return "-" + $0.toLowerCase();
}


/**
 * HTML URL properties.
 *
 * Each key is a property name and each value is a list of tag names it applies
 * to or `null` if it applies to all elements.
 *
 * @type {Record<string, Array<string> | null>}
 */ const $fa8d6da92b4f6774$export$de3e062aedff083a = {
    action: [
        "form"
    ],
    cite: [
        "blockquote",
        "del",
        "ins",
        "q"
    ],
    data: [
        "object"
    ],
    formAction: [
        "button",
        "input"
    ],
    href: [
        "a",
        "area",
        "base",
        "link"
    ],
    icon: [
        "menuitem"
    ],
    itemId: null,
    manifest: [
        "html"
    ],
    ping: [
        "a",
        "area"
    ],
    poster: [
        "video"
    ],
    src: [
        "audio",
        "embed",
        "iframe",
        "img",
        "input",
        "script",
        "source",
        "track",
        "video"
    ]
};


/**
 * @typedef {import('micromark-util-types').Code} Code
 */ const $74ae855ebddfe8fb$var$unicodePunctuationInternal = $74ae855ebddfe8fb$var$regexCheck(/\p{P}/u);
const $74ae855ebddfe8fb$export$d65d6b62c24d5436 = $74ae855ebddfe8fb$var$regexCheck(/[A-Za-z]/);
const $74ae855ebddfe8fb$export$75c76db11865a9f4 = $74ae855ebddfe8fb$var$regexCheck(/[\dA-Za-z]/);
const $74ae855ebddfe8fb$export$4397998b34fe597d = $74ae855ebddfe8fb$var$regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function $74ae855ebddfe8fb$export$67dbf494fc8394df(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127));
}
const $74ae855ebddfe8fb$export$ca8b5b1a6c320e6e = $74ae855ebddfe8fb$var$regexCheck(/\d/);
const $74ae855ebddfe8fb$export$eca2752363989806 = $74ae855ebddfe8fb$var$regexCheck(/[\dA-Fa-f]/);
const $74ae855ebddfe8fb$export$35794a7d1db99380 = $74ae855ebddfe8fb$var$regexCheck(/[!-/:-@[-`{-~]/);
function $74ae855ebddfe8fb$export$34a1dff1c0936953(code) {
    return code !== null && code < -2;
}
function $74ae855ebddfe8fb$export$a30284361b3814b7(code) {
    return code !== null && (code < 0 || code === 32);
}
function $74ae855ebddfe8fb$export$2c6cf65c1127992a(code) {
    return code === -2 || code === -1 || code === 32;
}
function $74ae855ebddfe8fb$export$aa04114dd888a7a0(code) {
    return $74ae855ebddfe8fb$export$35794a7d1db99380(code) || $74ae855ebddfe8fb$var$unicodePunctuationInternal(code);
}
const $74ae855ebddfe8fb$export$a0ff789c034ffdf4 = $74ae855ebddfe8fb$var$regexCheck(/\s/);
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 * @returns {(code: Code) => boolean}
 */ function $74ae855ebddfe8fb$var$regexCheck(regex) {
    return check;
    /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */ function check(code) {
        return code !== null && code > -1 && regex.test(String.fromCharCode(code));
    }
}


const $2a8eabc31e2cf4c6$var$characterReferences = {
    '"': "quot",
    "&": "amp",
    "<": "lt",
    ">": "gt"
};
function $2a8eabc31e2cf4c6$export$c564cdbbe6da493(value) {
    return value.replace(/["&<>]/g, replace);
    /**
   * @param {string} value
   * @returns {string}
   */ function replace(value) {
        // @ts-expect-error Hush, it’s fine.
        return "&" + $2a8eabc31e2cf4c6$var$characterReferences[value] + ";";
    }
}


function $161d5a87d2da344f$export$d130a2d684099e5a(url, protocol) {
    const value = (0, $2a8eabc31e2cf4c6$export$c564cdbbe6da493)($161d5a87d2da344f$export$e42a3e39590d28b5(url || ""));
    if (!protocol) return value;
    const colon = value.indexOf(":");
    const questionMark = value.indexOf("?");
    const numberSign = value.indexOf("#");
    const slash = value.indexOf("/");
    if (// If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))) return value;
    return "";
}
function $161d5a87d2da344f$export$e42a3e39590d28b5(value) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    let start = 0;
    let skip = 0;
    while(++index < value.length){
        const code = value.charCodeAt(index);
        /** @type {string} */ let replace = "";
        // A correct percent encoded value.
        if (code === 37 && (0, $74ae855ebddfe8fb$export$75c76db11865a9f4)(value.charCodeAt(index + 1)) && (0, $74ae855ebddfe8fb$export$75c76db11865a9f4)(value.charCodeAt(index + 2))) skip = 2;
        else if (code < 128) {
            if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) replace = String.fromCharCode(code);
        } else if (code > 55295 && code < 57344) {
            const next = value.charCodeAt(index + 1);
            // A correct surrogate pair.
            if (code < 56320 && next > 56319 && next < 57344) {
                replace = String.fromCharCode(code, next);
                skip = 1;
            } else replace = "�";
        } else replace = String.fromCharCode(code);
        if (replace) {
            result.push(value.slice(start, index), encodeURIComponent(replace));
            start = index + skip + 1;
            replace = "";
        }
        if (skip) {
            index += skip;
            skip = 0;
        }
    }
    return result.join("") + value.slice(start);
}



var $C7mD2 = parcelRequire("C7mD2");
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} FromMarkdownOptions
 * @typedef {import('unified').Parser<Root>} Parser
 * @typedef {import('unified').Processor<Root>} Processor
 */ /**
 * @typedef {Omit<FromMarkdownOptions, 'extensions' | 'mdastExtensions'>} Options
 */ /**
 * @typedef {import('mdast').Break} Break
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('mdast').Code} Code
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('mdast').Html} Html
 * @typedef {import('mdast').Image} Image
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').List} List
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Nodes} Nodes
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').ReferenceType} ReferenceType
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('mdast').Text} Text
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 *
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Value} Value
 *
 * @typedef {import('unist').Point} Point
 *
 * @typedef {import('../index.js').CompileData} CompileData
 */ /**
 * @typedef {Omit<Parent, 'children' | 'type'> & {type: 'fragment', children: Array<PhrasingContent>}} Fragment
 */ /**
 * @callback Transform
 *   Extra transform, to change the AST afterwards.
 * @param {Root} tree
 *   Tree to transform.
 * @returns {Root | null | undefined | void}
 *   New tree or nothing (in which case the current tree is used).
 *
 * @callback Handle
 *   Handle a token.
 * @param {CompileContext} this
 *   Context.
 * @param {Token} token
 *   Current token.
 * @returns {undefined | void}
 *   Nothing.
 *
 * @typedef {Record<string, Handle>} Handles
 *   Token types mapping to handles
 *
 * @callback OnEnterError
 *   Handle the case where the `right` token is open, but it is closed (by the
 *   `left` token) or because we reached the end of the document.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token | undefined} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {undefined}
 *   Nothing.
 *
 * @callback OnExitError
 *   Handle the case where the `right` token is open but it is closed by
 *   exiting the `left` token.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {undefined}
 *   Nothing.
 *
 * @typedef {[Token, OnEnterError | undefined]} TokenTuple
 *   Open token on the stack, with an optional error handler for when
 *   that token isn’t closed properly.
 */ /**
 * @typedef Config
 *   Configuration.
 *
 *   We have our defaults, but extensions will add more.
 * @property {Array<string>} canContainEols
 *   Token types where line endings are used.
 * @property {Handles} enter
 *   Opening handles.
 * @property {Handles} exit
 *   Closing handles.
 * @property {Array<Transform>} transforms
 *   Tree transforms.
 *
 * @typedef {Partial<Config>} Extension
 *   Change how markdown tokens from micromark are turned into mdast.
 *
 * @typedef CompileContext
 *   mdast compiler context.
 * @property {Array<Fragment | Nodes>} stack
 *   Stack of nodes.
 * @property {Array<TokenTuple>} tokenStack
 *   Stack of tokens.
 * @property {(this: CompileContext) => undefined} buffer
 *   Capture some of the output data.
 * @property {(this: CompileContext) => string} resume
 *   Stop capturing and access the output data.
 * @property {(this: CompileContext, node: Nodes, token: Token, onError?: OnEnterError) => undefined} enter
 *   Enter a node.
 * @property {(this: CompileContext, token: Token, onError?: OnExitError) => undefined} exit
 *   Exit a node.
 * @property {TokenizeContext['sliceSerialize']} sliceSerialize
 *   Get the string value of a token.
 * @property {Config} config
 *   Configuration.
 * @property {CompileData} data
 *   Info passed around; key/value store.
 *
 * @typedef FromMarkdownOptions
 *   Configuration for how to build mdast.
 * @property {Array<Extension | Array<Extension>> | null | undefined} [mdastExtensions]
 *   Extensions for this utility to change how tokens are turned into a tree.
 *
 * @typedef {ParseOptions & FromMarkdownOptions} Options
 *   Configuration.
 */ /**
 * @typedef {import('mdast').Nodes} Nodes
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s (default: `true`).
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML (default: `true`).
 */ /** @type {Options} */ const $3ca019da562f1c43$var$emptyOptions = {};
function $3ca019da562f1c43$export$f84e8e69fd4488a5(value, options) {
    const settings = options || $3ca019da562f1c43$var$emptyOptions;
    const includeImageAlt = typeof settings.includeImageAlt === "boolean" ? settings.includeImageAlt : true;
    const includeHtml = typeof settings.includeHtml === "boolean" ? settings.includeHtml : true;
    return $3ca019da562f1c43$var$one(value, includeImageAlt, includeHtml);
}
/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */ function $3ca019da562f1c43$var$one(value, includeImageAlt, includeHtml) {
    if ($3ca019da562f1c43$var$node(value)) {
        if ("value" in value) return value.type === "html" && !includeHtml ? "" : value.value;
        if (includeImageAlt && "alt" in value && value.alt) return value.alt;
        if ("children" in value) return $3ca019da562f1c43$var$all(value.children, includeImageAlt, includeHtml);
    }
    if (Array.isArray(value)) return $3ca019da562f1c43$var$all(value, includeImageAlt, includeHtml);
    return "";
}
/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */ function $3ca019da562f1c43$var$all(values, includeImageAlt, includeHtml) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    while(++index < values.length)result[index] = $3ca019da562f1c43$var$one(values[index], includeImageAlt, includeHtml);
    return result.join("");
}
/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Nodes}
 *   Whether `value` is a node.
 */ function $3ca019da562f1c43$var$node(value) {
    return Boolean(value && typeof value === "object");
}


/**
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Options} Options
 * @typedef {import('micromark-util-types').Value} Value
 */ /**
 * While micromark is a lexer/tokenizer, the common case of going from markdown
 * to html is currently built in as this module, even though the parts can be
 * used separately to build ASTs, CSTs, or many other output formats.
 *
 * Having an HTML compiler built in is useful because it allows us to check for
 * compliancy to CommonMark, the de facto norm of markdown, specified in roughly
 * 600 input/output cases.
 *
 * This module has an interface that accepts lists of events instead of the
 * whole at once, however, because markdown can’t be truly streaming, we buffer
 * events before processing and outputting the final result.
 */ /**
 * @typedef {import('micromark-util-types').Compile} Compile
 * @typedef {import('micromark-util-types').CompileContext} CompileContext
 * @typedef {import('micromark-util-types').CompileData} CompileData
 * @typedef {import('micromark-util-types').CompileOptions} CompileOptions
 * @typedef {import('micromark-util-types').Definition} Definition
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Handle} Handle
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').NormalizedHtmlExtension} NormalizedHtmlExtension
 * @typedef {import('micromark-util-types').Token} Token
 */ /**
 * @typedef Media
 * @property {boolean | undefined} [image]
 * @property {string | undefined} [labelId]
 * @property {string | undefined} [label]
 * @property {string | undefined} [referenceId]
 * @property {string | undefined} [destination]
 * @property {string | undefined} [title]
 */ /// <reference lib="dom" />
/* eslint-env browser */ const $5e5977bcdef97531$var$element = document.createElement("i");
function $5e5977bcdef97531$export$289b6a6320f709b4(value) {
    const characterReference = "&" + value + ";";
    $5e5977bcdef97531$var$element.innerHTML = characterReference;
    const char = $5e5977bcdef97531$var$element.textContent;
    // Some named character references do not require the closing semicolon
    // (`&not`, for instance), which leads to situations where parsing the assumed
    // named reference of `&notit;` will result in the string `¬it;`.
    // When we encounter a trailing semicolon after parsing, and the character
    // reference to decode was not a semicolon (`&semi;`), we can assume that the
    // matching was not complete.
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    if (char.charCodeAt(char.length - 1) === 59 /* `;` */  && value !== "semi") return false;
    // If the decoded string is equal to the input, the character reference was
    // not valid.
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    return char === characterReference ? false : char;
}


/**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {undefined}
 *   Nothing.
 */ function $ab4e16a48121f0b9$export$869882364835d202(list, start, remove, items) {
    const end = list.length;
    let chunkStart = 0;
    /** @type {Array<unknown>} */ let parameters;
    // Make start between zero and `end` (included).
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0;
    // No need to chunk the items if there’s only a couple (10k) items.
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        // @ts-expect-error Hush, it’s fine.
        list.splice(...parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) list.splice(start, remove);
        // Insert the items in chunks to not cause stack overflows.
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            // @ts-expect-error Hush, it’s fine.
            list.splice(...parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
function $ab4e16a48121f0b9$export$4cbf152802aa238(list, items) {
    if (list.length > 0) {
        $ab4e16a48121f0b9$export$869882364835d202(list, list.length, 0, items);
        return list;
    }
    return items;
}


/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Handles} Handles
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').NormalizedExtension} NormalizedExtension
 */ 
const $29c77022840ec938$var$hasOwnProperty = {}.hasOwnProperty;
function $29c77022840ec938$export$86a865d89ef3c690(extensions) {
    /** @type {NormalizedExtension} */ const all = {};
    let index = -1;
    while(++index < extensions.length)$29c77022840ec938$var$syntaxExtension(all, extensions[index]);
    return all;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {undefined}
 */ function $29c77022840ec938$var$syntaxExtension(all, extension) {
    /** @type {keyof Extension} */ let hook;
    for(hook in extension){
        const maybe = $29c77022840ec938$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        /** @type {Record<string, unknown>} */ const left = maybe || (all[hook] = {});
        /** @type {Record<string, unknown> | undefined} */ const right = extension[hook];
        /** @type {string} */ let code;
        if (right) for(code in right){
            if (!$29c77022840ec938$var$hasOwnProperty.call(left, code)) left[code] = [];
            const value = right[code];
            $29c77022840ec938$var$constructs(// @ts-expect-error Looks like a list.
            left[code], Array.isArray(value) ? value : value ? [
                value
            ] : []);
        }
    }
}
/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 * @param {Array<unknown>} list
 * @returns {undefined}
 */ function $29c77022840ec938$var$constructs(existing, list) {
    let index = -1;
    /** @type {Array<unknown>} */ const before = [];
    while(++index < list.length)(list[index].add === "after" ? existing : before).push(list[index]);
    (0, $ab4e16a48121f0b9$export$869882364835d202)(existing, 0, 0, before);
}
function $29c77022840ec938$export$eaf8c406dfb0a620(htmlExtensions) {
    /** @type {HtmlExtension} */ const handlers = {};
    let index = -1;
    while(++index < htmlExtensions.length)$29c77022840ec938$var$htmlExtension(handlers, htmlExtensions[index]);
    return handlers;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all
 *   Extension to merge into.
 * @param {HtmlExtension} extension
 *   Extension to merge.
 * @returns {undefined}
 */ function $29c77022840ec938$var$htmlExtension(all, extension) {
    /** @type {keyof HtmlExtension} */ let hook;
    for(hook in extension){
        const maybe = $29c77022840ec938$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        const left = maybe || (all[hook] = {});
        const right = extension[hook];
        /** @type {keyof Handles} */ let type;
        if (right) for(type in right)// @ts-expect-error assume document vs regular handler are managed correctly.
        left[type] = right[type];
    }
}


/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCharCode(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */ function $6e75d5d6c969a16a$export$15a69557afac2c20(value, base) {
    const code = Number.parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space.
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of C0, and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || (code & 65535) === 65535 || (code & 65535) === 65534 /* eslint-enable no-bitwise */  || // Out of range
    code > 1114111) return "�";
    return String.fromCharCode(code);
}



/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */ function $46d36bfd48dea0be$export$806d55e226cfcd08(value) {
    return value// Collapse markdown whitespace.
    .replace(/[\t\n\r ]+/g, " ")// Trim.
    .replace(/^ | $/g, "")// Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no method is uppercase.
    .toLowerCase().toUpperCase();
}



const $caf4caa13396207e$var$hasOwnProperty = {}.hasOwnProperty;
/**
 * These two are allowlists of safe protocols for full URLs in respectively the
 * `href` (on `<a>`) and `src` (on `<img>`) attributes.
 * They are based on what is allowed on GitHub,
 * <https://github.com/syntax-tree/hast-util-sanitize/blob/9275b21/lib/github.json#L31>
 */ const $caf4caa13396207e$var$protocolHref = /^(https?|ircs?|mailto|xmpp)$/i;
const $caf4caa13396207e$var$protocolSrc = /^https?$/i;
function $caf4caa13396207e$export$ef7acd7185315e22(options) {
    const settings = options || {};
    /**
   * Tags is needed because according to markdown, links and emphasis and
   * whatnot can exist in images, however, as HTML doesn’t allow content in
   * images, the tags are ignored in the `alt` attribute, but the content
   * remains.
   *
   * @type {boolean | undefined}
   */ let tags = true;
    /**
   * An object to track identifiers to media (URLs and titles) defined with
   * definitions.
   *
   * @type {Record<string, Definition>}
   */ const definitions = {};
    /**
   * A lot of the handlers need to capture some of the output data, modify it
   * somehow, and then deal with it.
   * We do that by tracking a stack of buffers, that can be opened (with
   * `buffer`) and closed (with `resume`) to access them.
   *
   * @type {Array<Array<string>>}
   */ const buffers = [
        []
    ];
    /**
   * As we can have links in images and the other way around, where the deepest
   * ones are closed first, we need to track which one we’re in.
   *
   * @type {Array<Media>}
   */ const mediaStack = [];
    /**
   * Same as `mediaStack` for tightness, which is specific to lists.
   * We need to track if we’re currently in a tight or loose container.
   *
   * @type {Array<boolean>}
   */ const tightStack = [];
    /** @type {HtmlExtension} */ const defaultHandlers = {
        enter: {
            blockQuote: onenterblockquote,
            codeFenced: onentercodefenced,
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: onentercodeindented,
            codeText: onentercodetext,
            content: onentercontent,
            definition: onenterdefinition,
            definitionDestinationString: onenterdefinitiondestinationstring,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: onenteremphasis,
            htmlFlow: onenterhtmlflow,
            htmlText: onenterhtml,
            image: onenterimage,
            label: buffer,
            link: onenterlink,
            listItemMarker: onenterlistitemmarker,
            listItemValue: onenterlistitemvalue,
            listOrdered: onenterlistordered,
            listUnordered: onenterlistunordered,
            paragraph: onenterparagraph,
            reference: buffer,
            resource: onenterresource,
            resourceDestinationString: onenterresourcedestinationstring,
            resourceTitleString: buffer,
            setextHeading: onentersetextheading,
            strong: onenterstrong
        },
        exit: {
            atxHeading: onexitatxheading,
            atxHeadingSequence: onexitatxheadingsequence,
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: onexitblockquote,
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: onexitflowcode,
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onresumedrop,
            codeFlowValue: onexitcodeflowvalue,
            codeIndented: onexitflowcode,
            codeText: onexitcodetext,
            codeTextData: onexitdata,
            data: onexitdata,
            definition: onexitdefinition,
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: onexitemphasis,
            hardBreakEscape: onexithardbreak,
            hardBreakTrailing: onexithardbreak,
            htmlFlow: onexithtml,
            htmlFlowData: onexitdata,
            htmlText: onexithtml,
            htmlTextData: onexitdata,
            image: onexitmedia,
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: onexitmedia,
            listOrdered: onexitlistordered,
            listUnordered: onexitlistunordered,
            paragraph: onexitparagraph,
            reference: onresumedrop,
            referenceString: onexitreferencestring,
            resource: onresumedrop,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            setextHeading: onexitsetextheading,
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: onexitstrong,
            thematicBreak: onexitthematicbreak
        }
    };
    /**
   * Combine the HTML extensions with the default handlers.
   * An HTML extension is an object whose fields are either `enter` or `exit`
   * (reflecting whether a token is entered or exited).
   * The values at such objects are names of tokens mapping to handlers.
   * Handlers are called, respectively when a token is opener or closed, with
   * that token, and a context as `this`.
   */ const handlers = /** @type {NormalizedHtmlExtension} */ (0, $29c77022840ec938$export$eaf8c406dfb0a620)([
        defaultHandlers
    ].concat(settings.htmlExtensions || []));
    /**
   * Handlers do often need to keep track of some state.
   * That state is provided here as a key-value store (an object).
   *
   * @type {CompileData}
   */ const data = {
        tightStack: tightStack,
        definitions: definitions
    };
    /**
   * The context for handlers references a couple of useful functions.
   * In handlers from extensions, those can be accessed at `this`.
   * For the handlers here, they can be accessed directly.
   *
   * @type {Omit<CompileContext, 'sliceSerialize'>}
   */ const context = {
        lineEndingIfNeeded: lineEndingIfNeeded,
        options: settings,
        encode: encode,
        raw: raw,
        tag: tag,
        buffer: buffer,
        resume: resume,
        setData: setData,
        getData: getData
    };
    /**
   * Generally, micromark copies line endings (`'\r'`, `'\n'`, `'\r\n'`) in the
   * markdown document over to the compiled HTML.
   * In some cases, such as `> a`, CommonMark requires that extra line endings
   * are added: `<blockquote>\n<p>a</p>\n</blockquote>`.
   * This variable hold the default line ending when given (or `undefined`),
   * and in the latter case will be updated to the first found line ending if
   * there is one.
   */ let lineEndingStyle = settings.defaultLineEnding;
    // Return the function that handles a slice of events.
    return compile;
    /**
   * Deal w/ a slice of events.
   * Return either the empty string if there’s nothing of note to return, or the
   * result when done.
   *
   * @param {Array<Event>} events
   * @returns {string}
   */ function compile(events) {
        let index = -1;
        let start = 0;
        /** @type {Array<number>} */ const listStack = [];
        // As definitions can come after references, we need to figure out the media
        // (urls and titles) defined by them before handling the references.
        // So, we do sort of what HTML does: put metadata at the start (in head), and
        // then put content after (`body`).
        /** @type {Array<Event>} */ let head = [];
        /** @type {Array<Event>} */ let body = [];
        while(++index < events.length){
            // Figure out the line ending style used in the document.
            if (!lineEndingStyle && (events[index][1].type === "lineEnding" || events[index][1].type === "lineEndingBlank")) // @ts-expect-error Hush, it’s a line ending.
            lineEndingStyle = events[index][2].sliceSerialize(events[index][1]);
            // Preprocess lists to infer whether the list is loose or not.
            if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
                if (events[index][0] === "enter") listStack.push(index);
                else prepareList(events.slice(listStack.pop(), index));
            }
            // Move definitions to the front.
            if (events[index][1].type === "definition") {
                if (events[index][0] === "enter") {
                    body = (0, $ab4e16a48121f0b9$export$4cbf152802aa238)(body, events.slice(start, index));
                    start = index;
                } else {
                    head = (0, $ab4e16a48121f0b9$export$4cbf152802aa238)(head, events.slice(start, index + 1));
                    start = index + 1;
                }
            }
        }
        head = (0, $ab4e16a48121f0b9$export$4cbf152802aa238)(head, body);
        head = (0, $ab4e16a48121f0b9$export$4cbf152802aa238)(head, events.slice(start));
        index = -1;
        const result = head;
        // Handle the start of the document, if defined.
        if (handlers.enter.null) handlers.enter.null.call(context);
        // Handle all events.
        while(++index < events.length){
            const handles = handlers[result[index][0]];
            const kind = result[index][1].type;
            const handle = handles[kind];
            if ($caf4caa13396207e$var$hasOwnProperty.call(handles, kind) && handle) handle.call(Object.assign({
                sliceSerialize: result[index][2].sliceSerialize
            }, context), result[index][1]);
        }
        // Handle the end of the document, if defined.
        if (handlers.exit.null) handlers.exit.null.call(context);
        return buffers[0].join("");
    }
    /**
   * Figure out whether lists are loose or not.
   *
   * @param {Array<Event>} slice
   * @returns {undefined}
   */ function prepareList(slice) {
        const length = slice.length;
        let index = 0 // Skip open.
        ;
        let containerBalance = 0;
        let loose = false;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index < length){
            const event = slice[index];
            if (event[1]._container) {
                atMarker = undefined;
                if (event[0] === "enter") containerBalance++;
                else containerBalance--;
            } else switch(event[1].type){
                case "listItemPrefix":
                    if (event[0] === "exit") atMarker = true;
                    break;
                case "linePrefix":
                    break;
                case "lineEndingBlank":
                    if (event[0] === "enter" && !containerBalance) {
                        if (atMarker) atMarker = undefined;
                        else loose = true;
                    }
                    break;
                default:
                    atMarker = undefined;
            }
        }
        slice[0][1]._loose = loose;
    }
    /**
   * @type {CompileContext['setData']}
   */ function setData(key, value) {
        // @ts-expect-error: assume `value` is omitted (`undefined` is passed) only
        // if allowed.
        data[key] = value;
    }
    /**
   * @type {CompileContext['getData']}
   */ function getData(key) {
        return data[key];
    }
    /** @type {CompileContext['buffer']} */ function buffer() {
        buffers.push([]);
    }
    /** @type {CompileContext['resume']} */ function resume() {
        const buf = buffers.pop();
        return buf.join("");
    }
    /** @type {CompileContext['tag']} */ function tag(value) {
        if (!tags) return;
        setData("lastWasTag", true);
        buffers[buffers.length - 1].push(value);
    }
    /** @type {CompileContext['raw']} */ function raw(value) {
        setData("lastWasTag");
        buffers[buffers.length - 1].push(value);
    }
    /**
   * Output an extra line ending.
   *
   * @returns {undefined}
   */ function lineEnding() {
        raw(lineEndingStyle || "\n");
    }
    /** @type {CompileContext['lineEndingIfNeeded']} */ function lineEndingIfNeeded() {
        const buffer = buffers[buffers.length - 1];
        const slice = buffer[buffer.length - 1];
        const previous = slice ? slice.charCodeAt(slice.length - 1) : null;
        if (previous === 10 || previous === 13 || previous === null) return;
        lineEnding();
    }
    /** @type {CompileContext['encode']} */ function encode(value) {
        return getData("ignoreEncode") ? value : (0, $2a8eabc31e2cf4c6$export$c564cdbbe6da493)(value);
    }
    //
    // Handlers.
    //
    /**
   * @returns {undefined}
   */ function onresumedrop() {
        resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag("<ol");
        setData("expectFirstItem", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistunordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag("<ul");
        setData("expectFirstItem", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (getData("expectFirstItem")) {
            const value = Number.parseInt(this.sliceSerialize(token), 10);
            if (value !== 1) tag(' start="' + encode(String(value)) + '"');
        }
    }
    /**
   * @returns {undefined}
   */ function onenterlistitemmarker() {
        if (getData("expectFirstItem")) tag(">");
        else onexitlistitem();
        lineEndingIfNeeded();
        tag("<li>");
        setData("expectFirstItem");
        // “Hack” to prevent a line ending from showing up if the item is empty.
        setData("lastWasTag");
    }
    /**
   * @returns {undefined}
   */ function onexitlistordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag("</ol>");
    }
    /**
   * @returns {undefined}
   */ function onexitlistunordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag("</ul>");
    }
    /**
   * @returns {undefined}
   */ function onexitlistitem() {
        if (getData("lastWasTag") && !getData("slurpAllLineEndings")) lineEndingIfNeeded();
        tag("</li>");
        setData("slurpAllLineEndings");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterblockquote() {
        tightStack.push(false);
        lineEndingIfNeeded();
        tag("<blockquote>");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitblockquote() {
        tightStack.pop();
        lineEndingIfNeeded();
        tag("</blockquote>");
        setData("slurpAllLineEndings");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterparagraph() {
        if (!tightStack[tightStack.length - 1]) {
            lineEndingIfNeeded();
            tag("<p>");
        }
        setData("slurpAllLineEndings");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitparagraph() {
        if (tightStack[tightStack.length - 1]) setData("slurpAllLineEndings", true);
        else tag("</p>");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodefenced() {
        lineEndingIfNeeded();
        tag("<pre><code");
        setData("fencesCount", 0);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const value = resume();
        tag(' class="language-' + value + '"');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        const count = getData("fencesCount") || 0;
        if (!count) {
            tag(">");
            setData("slurpOneLineEnding", true);
        }
        setData("fencesCount", count + 1);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodeindented() {
        lineEndingIfNeeded();
        tag("<pre><code>");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitflowcode() {
        const count = getData("fencesCount");
        // One special case is if we are inside a container, and the fenced code was
        // not closed (meaning it runs to the end).
        // In that case, the following line ending, is considered *outside* the
        // fenced code and block quote by micromark, but CM wants to treat that
        // ending as part of the code.
        if (count !== undefined && count < 2 && data.tightStack.length > 0 && !getData("lastWasTag")) lineEnding();
        // But in most cases, it’s simpler: when we’ve seen some data, emit an extra
        // line ending when needed.
        if (getData("flowCodeSeenData")) lineEndingIfNeeded();
        tag("</code></pre>");
        if (count !== undefined && count < 2) lineEndingIfNeeded();
        setData("flowCodeSeenData");
        setData("fencesCount");
        setData("slurpOneLineEnding");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterimage() {
        mediaStack.push({
            image: true
        });
        tags = undefined // Disallow tags.
        ;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlink() {
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        mediaStack[mediaStack.length - 1].label = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        mediaStack[mediaStack.length - 1].referenceId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresource() {
        buffer() // We can have line endings in the resource, ignore them.
        ;
        mediaStack[mediaStack.length - 1].destination = "";
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresourcedestinationstring() {
        buffer();
        // Ignore encoding the result, as we’ll first percent encode the url and
        // encode manually after.
        setData("ignoreEncode", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData("ignoreEncode");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitmedia() {
        let index = mediaStack.length - 1 // Skip current.
        ;
        const media = mediaStack[index];
        const id = media.referenceId || media.labelId;
        const context = media.destination === undefined ? definitions[(0, $46d36bfd48dea0be$export$806d55e226cfcd08)(id)] : media;
        tags = true;
        while(index--)if (mediaStack[index].image) {
            tags = undefined;
            break;
        }
        if (media.image) {
            tag('<img src="' + (0, $161d5a87d2da344f$export$d130a2d684099e5a)(context.destination, settings.allowDangerousProtocol ? undefined : $caf4caa13396207e$var$protocolSrc) + '" alt="');
            raw(media.label);
            tag('"');
        } else tag('<a href="' + (0, $161d5a87d2da344f$export$d130a2d684099e5a)(context.destination, settings.allowDangerousProtocol ? undefined : $caf4caa13396207e$var$protocolHref) + '"');
        tag(context.title ? ' title="' + context.title + '"' : "");
        if (media.image) tag(" />");
        else {
            tag(">");
            raw(media.label);
            tag("</a>");
        }
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinition() {
        buffer();
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        // Discard label, use the source content instead.
        resume();
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinitiondestinationstring() {
        buffer();
        setData("ignoreEncode", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData("ignoreEncode");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinition() {
        const media = mediaStack[mediaStack.length - 1];
        const id = (0, $46d36bfd48dea0be$export$806d55e226cfcd08)(media.labelId);
        resume();
        if (!$caf4caa13396207e$var$hasOwnProperty.call(definitions, id)) definitions[id] = mediaStack[mediaStack.length - 1];
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercontent() {
        setData("slurpAllLineEndings", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        // Exit for further sequences.
        if (getData("headingRank")) return;
        setData("headingRank", this.sliceSerialize(token).length);
        lineEndingIfNeeded();
        tag("<h" + getData("headingRank") + ">");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentersetextheading() {
        buffer();
        setData("slurpAllLineEndings");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        setData("slurpAllLineEndings", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheading() {
        tag("</h" + getData("headingRank") + ">");
        setData("headingRank");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        setData("headingRank", this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        const value = resume();
        lineEndingIfNeeded();
        tag("<h" + getData("headingRank") + ">");
        raw(value);
        tag("</h" + getData("headingRank") + ">");
        setData("slurpAllLineEndings");
        setData("headingRank");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        if (getData("slurpAllLineEndings")) return;
        if (getData("slurpOneLineEnding")) {
            setData("slurpOneLineEnding");
            return;
        }
        if (getData("inCodeText")) {
            raw(" ");
            return;
        }
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeflowvalue(token) {
        raw(encode(this.sliceSerialize(token)));
        setData("flowCodeSeenData", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        tag("<br />");
    }
    /**
   * @returns {undefined}
   */ function onenterhtmlflow() {
        lineEndingIfNeeded();
        onenterhtml();
    }
    /**
   * @returns {undefined}
   */ function onexithtml() {
        setData("ignoreEncode");
    }
    /**
   * @returns {undefined}
   */ function onenterhtml() {
        if (settings.allowDangerousHtml) setData("ignoreEncode", true);
    }
    /**
   * @returns {undefined}
   */ function onenteremphasis() {
        tag("<em>");
    }
    /**
   * @returns {undefined}
   */ function onenterstrong() {
        tag("<strong>");
    }
    /**
   * @returns {undefined}
   */ function onentercodetext() {
        setData("inCodeText", true);
        tag("<code>");
    }
    /**
   * @returns {undefined}
   */ function onexitcodetext() {
        setData("inCodeText");
        tag("</code>");
    }
    /**
   * @returns {undefined}
   */ function onexitemphasis() {
        tag("</em>");
    }
    /**
   * @returns {undefined}
   */ function onexitstrong() {
        tag("</strong>");
    }
    /**
   * @returns {undefined}
   */ function onexitthematicbreak() {
        lineEndingIfNeeded();
        tag("<hr />");
    }
    /**
   * @this {CompileContext}
   * @param {Token} token
   * @returns {undefined}
   */ function onexitcharacterreferencemarker(token) {
        setData("characterReferenceType", token.type);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        let value = this.sliceSerialize(token);
        // @ts-expect-error `decodeNamedCharacterReference` can return false for
        // invalid named character references, but everything we’ve tokenized is
        // valid.
        value = getData("characterReferenceType") ? (0, $6e75d5d6c969a16a$export$15a69557afac2c20)(value, getData("characterReferenceType") === "characterReferenceMarkerNumeric" ? 10 : 16) : (0, $5e5977bcdef97531$export$289b6a6320f709b4)(value);
        raw(encode(value));
        setData("characterReferenceType");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        const uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $161d5a87d2da344f$export$d130a2d684099e5a)(uri, settings.allowDangerousProtocol ? undefined : $caf4caa13396207e$var$protocolHref) + '">');
        raw(encode(uri));
        tag("</a>");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        const uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $161d5a87d2da344f$export$d130a2d684099e5a)("mailto:" + uri) + '">');
        raw(encode(uri));
        tag("</a>");
    }
}


/**
 * @typedef {import('micromark-util-types').Create} Create
 * @typedef {import('micromark-util-types').FullNormalizedExtension} FullNormalizedExtension
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 */ 
/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
function $07c9a93298d989be$export$ae105c1eb063a0a2(effects, ok, type, max) {
    const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    /** @type {State} */ function prefix(code) {
        if ((0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}



const $39f0647f55776bd1$export$a7db06668cad9adb = {
    tokenize: $39f0647f55776bd1$var$initializeContent
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $39f0647f55776bd1$var$initializeContent(effects) {
    const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    /** @type {Token} */ let previous;
    return contentStart;
    /** @type {State} */ function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, contentStart, "linePrefix");
    }
    /** @type {State} */ function paragraphInitial(code) {
        effects.enter("paragraph");
        return lineStart(code);
    }
    /** @type {State} */ function lineStart(code) {
        const token = effects.enter("chunkText", {
            contentType: "text",
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    /** @type {State} */ function data(code) {
        if (code === null) {
            effects.exit("chunkText");
            effects.exit("paragraph");
            effects.consume(code);
            return;
        }
        if ((0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            effects.exit("chunkText");
            return lineStart;
        }
        // Data.
        effects.consume(code);
        return data;
    }
}


/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {[Construct, ContainerState]} StackItem
 */ 


const $9a319b10969f951c$export$5a7bfc01df82fcd1 = {
    tokenize: $9a319b10969f951c$var$initializeDocument
};
/** @type {Construct} */ const $9a319b10969f951c$var$containerConstruct = {
    tokenize: $9a319b10969f951c$var$tokenizeContainer
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $9a319b10969f951c$var$initializeDocument(effects) {
    const self = this;
    /** @type {Array<StackItem>} */ const stack = [];
    let continued = 0;
    /** @type {TokenizeContext | undefined} */ let childFlow;
    /** @type {Token | undefined} */ let childToken;
    /** @type {number} */ let lineStartOffset;
    return start;
    /** @type {State} */ function start(code) {
        // First we iterate through the open blocks, starting with the root
        // document, and descending through last children down to the last open
        // block.
        // Each block imposes a condition that the line must satisfy if the block is
        // to remain open.
        // For example, a block quote requires a `>` character.
        // A paragraph requires a non-blank line.
        // In this phase we may match all or just some of the open blocks.
        // But we cannot close unmatched blocks yet, because we may have a lazy
        // continuation line.
        if (continued < stack.length) {
            const item = stack[continued];
            self.containerState = item[1];
            return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code);
        }
        // Done.
        return checkNewContainers(code);
    }
    /** @type {State} */ function documentContinue(code) {
        continued++;
        // Note: this field is called `_closeFlow` but it also closes containers.
        // Perhaps a good idea to rename it but it’s already used in the wild by
        // extensions.
        if (self.containerState._closeFlow) {
            self.containerState._closeFlow = undefined;
            if (childFlow) closeFlow();
            // Note: this algorithm for moving events around is similar to the
            // algorithm when dealing with lazy lines in `writeToChild`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {Point | undefined} */ let point;
            // Find the flow chunk.
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === "exit" && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                point = self.events[indexBeforeFlow][1].end;
                break;
            }
            exitContainers(continued);
            // Fix positions.
            let index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $ab4e16a48121f0b9$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
            return checkNewContainers(code);
        }
        return start(code);
    }
    /** @type {State} */ function checkNewContainers(code) {
        // Next, after consuming the continuation markers for existing blocks, we
        // look for new block starts (e.g. `>` for a block quote).
        // If we encounter a new block start, we close any blocks unmatched in
        // step 1 before creating the new block as a child of the last matched
        // block.
        if (continued === stack.length) {
            // No need to `check` whether there’s a container, of `exitContainers`
            // would be moot.
            // We can instead immediately `attempt` to parse one.
            if (!childFlow) return documentContinued(code);
            // If we have concrete content, such as block HTML or fenced code,
            // we can’t have containers “pierce” into them, so we can immediately
            // start.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) return flowStart(code);
            // If we do have flow, it could still be a blank line,
            // but we’d be interrupting it w/ a new container if there’s a current
            // construct.
            // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
            // needed in micromark-extension-gfm-table@1.0.6).
            self.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
        }
        // Check if there is a new container.
        self.containerState = {};
        return effects.check($9a319b10969f951c$var$containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code);
    }
    /** @type {State} */ function thereIsANewContainer(code) {
        if (childFlow) closeFlow();
        exitContainers(continued);
        return documentContinued(code);
    }
    /** @type {State} */ function thereIsNoNewContainer(code) {
        self.parser.lazy[self.now().line] = continued !== stack.length;
        lineStartOffset = self.now().offset;
        return flowStart(code);
    }
    /** @type {State} */ function documentContinued(code) {
        // Try new containers.
        self.containerState = {};
        return effects.attempt($9a319b10969f951c$var$containerConstruct, containerContinue, flowStart)(code);
    }
    /** @type {State} */ function containerContinue(code) {
        continued++;
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        // Try another.
        return documentContinued(code);
    }
    /** @type {State} */ function flowStart(code) {
        if (code === null) {
            if (childFlow) closeFlow();
            exitContainers(0);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter("chunkFlow", {
            contentType: "flow",
            previous: childToken,
            _tokenizer: childFlow
        });
        return flowContinue(code);
    }
    /** @type {State} */ function flowContinue(code) {
        if (code === null) {
            writeToChild(effects.exit("chunkFlow"), true);
            exitContainers(0);
            effects.consume(code);
            return;
        }
        if ((0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            writeToChild(effects.exit("chunkFlow"));
            // Get ready for the next line.
            continued = 0;
            self.interrupt = undefined;
            return start;
        }
        effects.consume(code);
        return flowContinue;
    }
    /**
   * @param {Token} token
   * @param {boolean | undefined} [eof]
   * @returns {undefined}
   */ function writeToChild(token, eof) {
        const stream = self.sliceStream(token);
        if (eof) stream.push(null);
        token.previous = childToken;
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.defineSkip(token.start);
        childFlow.write(stream);
        // Alright, so we just added a lazy line:
        //
        // ```markdown
        // > a
        // b.
        //
        // Or:
        //
        // > ~~~c
        // d
        //
        // Or:
        //
        // > | e |
        // f
        // ```
        //
        // The construct in the second example (fenced code) does not accept lazy
        // lines, so it marked itself as done at the end of its first line, and
        // then the content construct parses `d`.
        // Most constructs in markdown match on the first line: if the first line
        // forms a construct, a non-lazy line can’t “unmake” it.
        //
        // The construct in the third example is potentially a GFM table, and
        // those are *weird*.
        // It *could* be a table, from the first line, if the following line
        // matches a condition.
        // In this case, that second line is lazy, which “unmakes” the first line
        // and turns the whole into one content block.
        //
        // We’ve now parsed the non-lazy and the lazy line, and can figure out
        // whether the lazy line started a new flow block.
        // If it did, we exit the current containers between the two flow blocks.
        if (self.parser.lazy[token.start.line]) {
            let index = childFlow.events.length;
            while(index--){
                if (// The token starts before the line ending…
                childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
                (!childFlow.events[index][1].end || // …or ends after it.
                childFlow.events[index][1].end.offset > lineStartOffset)) // Exit: there’s still something open, which means it’s a lazy line
                // part of something.
                return;
            }
            // Note: this algorithm for moving events around is similar to the
            // algorithm when closing flow in `documentContinue`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {boolean | undefined} */ let seen;
            /** @type {Point | undefined} */ let point;
            // Find the previous chunk (the one before the lazy line).
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === "exit" && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                if (seen) {
                    point = self.events[indexBeforeFlow][1].end;
                    break;
                }
                seen = true;
            }
            exitContainers(continued);
            // Fix positions.
            index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $ab4e16a48121f0b9$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
        }
    }
    /**
   * @param {number} size
   * @returns {undefined}
   */ function exitContainers(size) {
        let index = stack.length;
        // Exit open containers.
        while(index-- > size){
            const entry = stack[index];
            self.containerState = entry[1];
            entry[0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function closeFlow() {
        childFlow.write([
            null
        ]);
        childToken = undefined;
        childFlow = undefined;
        self.containerState._closeFlow = undefined;
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $9a319b10969f951c$var$tokenizeContainer(effects, ok, nok) {
    // Always populated by defaults.
    return (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.document, ok, nok), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4);
}


/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $464bca88fae6642a$export$d50d28ce3ab2a612 = {
    tokenize: $464bca88fae6642a$var$tokenizeBlankLine,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $464bca88fae6642a$var$tokenizeBlankLine(effects, ok, nok) {
    return start;
    /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        return (0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code) ? (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, after, "linePrefix")(code) : after(code);
    }
    /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return code === null || (0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Token} Token
 */ 
function $849b4234cfb5fa8d$export$12949d1dd00fddf4(events) {
    /** @type {Record<string, number>} */ const jumps = {};
    let index = -1;
    /** @type {Event} */ let event;
    /** @type {number | undefined} */ let lineIndex;
    /** @type {number} */ let otherIndex;
    /** @type {Event} */ let otherEvent;
    /** @type {Array<Event>} */ let parameters;
    /** @type {Array<Event>} */ let subevents;
    /** @type {boolean | undefined} */ let more;
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events[index];
        // Add a hook for the GFM tasklist extension, which needs to know if text
        // is in the first content of a list item.
        if (index && event[1].type === "chunkFlow" && events[index - 1][1].type === "listItemPrefix") {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === "content") break;
                if (subevents[otherIndex][1].type === "chunkText") {
                    subevents[otherIndex][1]._isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        }
        // Enter.
        if (event[0] === "enter") {
            if (event[1].contentType) {
                Object.assign(jumps, $849b4234cfb5fa8d$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events[otherIndex];
                if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
                    if (otherEvent[0] === "enter") {
                        if (lineIndex) events[lineIndex][1].type = "lineEndingBlank";
                        otherEvent[1].type = "lineEnding";
                        lineIndex = otherIndex;
                    }
                } else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = Object.assign({}, events[lineIndex][1].start);
                // Switch container exit w/ line endings.
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                (0, $ab4e16a48121f0b9$export$869882364835d202)(events, lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    return !more;
}
/**
 * Tokenize embedded tokens.
 *
 * @param {Array<Event>} events
 * @param {number} eventIndex
 * @returns {Record<string, number>}
 */ function $849b4234cfb5fa8d$var$subcontent(events, eventIndex) {
    const token = events[eventIndex][1];
    const context = events[eventIndex][2];
    let startPosition = eventIndex - 1;
    /** @type {Array<number>} */ const startPositions = [];
    const tokenizer = token._tokenizer || context.parser[token.contentType](token.start);
    const childEvents = tokenizer.events;
    /** @type {Array<[number, number]>} */ const jumps = [];
    /** @type {Record<string, number>} */ const gaps = {};
    /** @type {Array<Chunk>} */ let stream;
    /** @type {Token | undefined} */ let previous;
    let index = -1;
    /** @type {Token | undefined} */ let current = token;
    let adjust = 0;
    let start = 0;
    const breaks = [
        start
    ];
    // Loop forward through the linked tokens to pass them in order to the
    // subtokenizer.
    while(current){
        // Find the position of the event for this token.
        while(events[++startPosition][1] !== current);
        startPositions.push(startPosition);
        if (!current._tokenizer) {
            stream = context.sliceStream(current);
            if (!current.next) stream.push(null);
            if (previous) tokenizer.defineSkip(current.start);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        }
        // Unravel the next token.
        previous = current;
        current = current.next;
    }
    // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    current = token;
    while(++index < childEvents.length)if (// Find a void token that includes a break.
    childEvents[index][0] === "exit" && childEvents[index - 1][0] === "enter" && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
        start = index + 1;
        breaks.push(start);
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
        current = current.next;
    }
    // Help GC.
    tokenizer.events = [];
    // If there’s one more token (which is the cases for lines that end in an
    // EOF), that’s perfect: the last point we found starts it.
    // If there isn’t then make sure any remaining content is added to it.
    if (current) {
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
    } else breaks.pop();
    // Now splice the events from the subtokenizer into the current events,
    // moving back to front so that splice indices aren’t affected.
    index = breaks.length;
    while(index--){
        const slice = childEvents.slice(breaks[index], breaks[index + 1]);
        const start = startPositions.pop();
        jumps.unshift([
            start,
            start + slice.length - 1
        ]);
        (0, $ab4e16a48121f0b9$export$869882364835d202)(events, start, 2, slice);
    }
    index = -1;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
}


const $584b18ce6f33e1da$export$a7db06668cad9adb = {
    tokenize: $584b18ce6f33e1da$var$tokenizeContent,
    resolve: $584b18ce6f33e1da$var$resolveContent
};
/** @type {Construct} */ const $584b18ce6f33e1da$var$continuationConstruct = {
    tokenize: $584b18ce6f33e1da$var$tokenizeContinuation,
    partial: true
};
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */ function $584b18ce6f33e1da$var$resolveContent(events) {
    (0, $849b4234cfb5fa8d$export$12949d1dd00fddf4)(events);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $584b18ce6f33e1da$var$tokenizeContent(effects, ok) {
    /** @type {Token | undefined} */ let previous;
    return chunkStart;
    /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */ function chunkStart(code) {
        effects.enter("content");
        previous = effects.enter("chunkContent", {
            contentType: "content"
        });
        return chunkInside(code);
    }
    /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */ function chunkInside(code) {
        if (code === null) return contentEnd(code);
        // To do: in `markdown-rs`, each line is parsed on its own, and everything
        // is stitched together resolving.
        if ((0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) return effects.check($584b18ce6f33e1da$var$continuationConstruct, contentContinue, contentEnd)(code);
        // Data.
        effects.consume(code);
        return chunkInside;
    }
    /**
   *
   *
   * @type {State}
   */ function contentEnd(code) {
        effects.exit("chunkContent");
        effects.exit("content");
        return ok(code);
    }
    /**
   *
   *
   * @type {State}
   */ function contentContinue(code) {
        effects.consume(code);
        effects.exit("chunkContent");
        previous.next = effects.enter("chunkContent", {
            contentType: "content",
            previous: previous
        });
        previous = previous.next;
        return chunkInside;
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $584b18ce6f33e1da$var$tokenizeContinuation(effects, ok, nok) {
    const self = this;
    return startLookahead;
    /**
   *
   *
   * @type {State}
   */ function startLookahead(code) {
        effects.exit("chunkContent");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, prefixed, "linePrefix");
    }
    /**
   *
   *
   * @type {State}
   */ function prefixed(code) {
        if (code === null || (0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) return nok(code);
        // Always populated by defaults.
        const tail = self.events[self.events.length - 1];
        if (!self.parser.constructs.disable.null.includes("codeIndented") && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) return ok(code);
        return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
    }
}




const $b7d003f6a78a4fb7$export$ccc7b0636abaffc3 = {
    tokenize: $b7d003f6a78a4fb7$var$initializeFlow
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $b7d003f6a78a4fb7$var$initializeFlow(effects) {
    const self = this;
    const initial = effects.attempt(// Try to parse a blank line.
    (0, $464bca88fae6642a$export$d50d28ce3ab2a612), atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt((0, $584b18ce6f33e1da$export$a7db06668cad9adb), afterConstruct)), "linePrefix")));
    return initial;
    /** @type {State} */ function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        self.currentConstruct = undefined;
        return initial;
    }
    /** @type {State} */ function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        self.currentConstruct = undefined;
        return initial;
    }
}


/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ const $c9755994ad418fe0$export$50397835cbfdbc24 = {
    resolveAll: $c9755994ad418fe0$var$createResolver()
};
const $c9755994ad418fe0$export$22b082955e083ec3 = $c9755994ad418fe0$var$initializeFactory("string");
const $c9755994ad418fe0$export$6f093cfa640b7166 = $c9755994ad418fe0$var$initializeFactory("text");
/**
 * @param {'string' | 'text'} field
 * @returns {InitialConstruct}
 */ function $c9755994ad418fe0$var$initializeFactory(field) {
    return {
        tokenize: initializeText,
        resolveAll: $c9755994ad418fe0$var$createResolver(field === "text" ? $c9755994ad418fe0$var$resolveAllLineSuffixes : undefined)
    };
    /**
   * @this {TokenizeContext}
   * @type {Initializer}
   */ function initializeText(effects) {
        const self = this;
        const constructs = this.parser.constructs[field];
        const text = effects.attempt(constructs, start, notText);
        return start;
        /** @type {State} */ function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        /** @type {State} */ function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter("data");
            effects.consume(code);
            return data;
        }
        /** @type {State} */ function data(code) {
            if (atBreak(code)) {
                effects.exit("data");
                return text(code);
            }
            // Data.
            effects.consume(code);
            return data;
        }
        /**
     * @param {Code} code
     * @returns {boolean}
     */ function atBreak(code) {
            if (code === null) return true;
            const list = constructs[code];
            let index = -1;
            if (list) // Always populated by defaults.
            while(++index < list.length){
                const item = list[index];
                if (!item.previous || item.previous.call(self, self.previous)) return true;
            }
            return false;
        }
    }
}
/**
 * @param {Resolver | undefined} [extraResolver]
 * @returns {Resolver}
 */ function $c9755994ad418fe0$var$createResolver(extraResolver) {
    return resolveAllText;
    /** @type {Resolver} */ function resolveAllText(events, context) {
        let index = -1;
        /** @type {number | undefined} */ let enter;
        // A rather boring computation (to merge adjacent `data` events) which
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === "data") {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== "data") {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */ function $c9755994ad418fe0$var$resolveAllLineSuffixes(events, context) {
    let eventIndex = 0 // Skip first.
    ;
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
        const data = events[eventIndex - 1][1];
        const chunks = context.sliceStream(data);
        let index = chunks.length;
        let bufferIndex = -1;
        let size = 0;
        /** @type {boolean | undefined} */ let tabs;
        while(index--){
            const chunk = chunks[index];
            if (typeof chunk === "string") {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        if (size) {
            const token = {
                type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
                start: {
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size,
                    _index: data.start._index + index,
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex
                },
                end: Object.assign({}, data.end)
            };
            data.end = Object.assign({}, token.start);
            if (data.start.offset === data.end.offset) Object.assign(data, token);
            else {
                events.splice(eventIndex, 0, [
                    "enter",
                    token,
                    context
                ], [
                    "exit",
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}


/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenType} TokenType
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @callback Restore
 * @returns {undefined}
 *
 * @typedef Info
 * @property {Restore} restore
 * @property {number} from
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 * @param {Info} info
 * @returns {undefined}
 */ 

/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * Call all `resolveAll`s.
 *
 * @param {Array<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */ function $af7938992e81384c$export$3ff61ec196ff408b(constructs, events, context) {
    /** @type {Array<Resolver>} */ const called = [];
    let index = -1;
    while(++index < constructs.length){
        const resolve = constructs[index].resolveAll;
        if (resolve && !called.includes(resolve)) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}


function $668a97eece5f50dd$export$ae34f10ee4b29837(parser, initialize, from) {
    /** @type {Point} */ let point = Object.assign(from ? Object.assign({}, from) : {
        line: 1,
        column: 1,
        offset: 0
    }, {
        _index: 0,
        _bufferIndex: -1
    });
    /** @type {Record<string, number>} */ const columnStart = {};
    /** @type {Array<Construct>} */ const resolveAllConstructs = [];
    /** @type {Array<Chunk>} */ let chunks = [];
    /** @type {Array<Token>} */ let stack = [];
    /** @type {boolean | undefined} */ let consumed = true;
    /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */ const effects = {
        consume: consume,
        enter: enter,
        exit: exit,
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        })
    };
    /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */ const context = {
        previous: null,
        code: null,
        containerState: {},
        events: [],
        parser: parser,
        sliceStream: sliceStream,
        sliceSerialize: sliceSerialize,
        now: now,
        defineSkip: defineSkip,
        write: write
    };
    /**
   * The state function.
   *
   * @type {State | undefined}
   */ let state = initialize.tokenize.call(context, effects);
    /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */ let expectedCode;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
    return context;
    /** @type {TokenizeContext['write']} */ function write(slice) {
        chunks = (0, $ab4e16a48121f0b9$export$4cbf152802aa238)(chunks, slice);
        main();
        // Exit if we’re not done, resolve might change stuff.
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0);
        // Otherwise, resolve, and exit.
        context.events = (0, $af7938992e81384c$export$3ff61ec196ff408b)(resolveAllConstructs, context.events, context);
        return context.events;
    }
    //
    // Tools.
    //
    /** @type {TokenizeContext['sliceSerialize']} */ function sliceSerialize(token, expandTabs) {
        return $668a97eece5f50dd$var$serializeChunks(sliceStream(token), expandTabs);
    }
    /** @type {TokenizeContext['sliceStream']} */ function sliceStream(token) {
        return $668a97eece5f50dd$var$sliceChunks(chunks, token);
    }
    /** @type {TokenizeContext['now']} */ function now() {
        // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
        const { line: line, column: column, offset: offset, _index: _index, _bufferIndex: _bufferIndex } = point;
        return {
            line: line,
            column: column,
            offset: offset,
            _index: _index,
            _bufferIndex: _bufferIndex
        };
    }
    /** @type {TokenizeContext['defineSkip']} */ function defineSkip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    }
    //
    // State management.
    //
    /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {undefined}
   */ function main() {
        /** @type {number} */ let chunkIndex;
        while(point._index < chunks.length){
            const chunk = chunks[point._index];
            // If we’re in a buffer chunk, loop through it.
            if (typeof chunk === "string") {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    }
    /**
   * Deal with one code.
   *
   * @param {Code} code
   * @returns {undefined}
   */ function go(code) {
        consumed = undefined;
        expectedCode = code;
        state = state(code);
    }
    /** @type {Effects['consume']} */ function consume(code) {
        if ((0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        }
        // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++;
            // At end of string chunk.
            // @ts-expect-error Points w/ non-negative `_bufferIndex` reference
            // strings.
            if (point._bufferIndex === chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        }
        // Expose the previous character.
        context.previous = code;
        // Mark as consumed.
        consumed = true;
    }
    /** @type {Effects['enter']} */ function enter(type, fields) {
        /** @type {Token} */ // @ts-expect-error Patch instead of assign required fields to help GC.
        const token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            "enter",
            token,
            context
        ]);
        stack.push(token);
        return token;
    }
    /** @type {Effects['exit']} */ function exit(type) {
        const token = stack.pop();
        token.end = now();
        context.events.push([
            "exit",
            token,
            context
        ]);
        return token;
    }
    /**
   * Use results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    }
    /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulcheck(_, info) {
        info.restore();
    }
    /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   */ function constructFactory(onreturn, fields) {
        return hook;
        /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | Construct | ConstructRecord} constructs
     * @param {State} returnState
     * @param {State | undefined} [bogusState]
     * @returns {State}
     */ function hook(constructs, returnState, bogusState) {
            /** @type {Array<Construct>} */ let listOfConstructs;
            /** @type {number} */ let constructIndex;
            /** @type {Construct} */ let currentConstruct;
            /** @type {Info} */ let info;
            return Array.isArray(constructs) ? handleListOfConstructs(constructs) : "tokenize" in constructs ? handleListOfConstructs([
                constructs
            ]) : handleMapOfConstructs(constructs);
            /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       * @returns {State}
       */ function handleMapOfConstructs(map) {
                return start;
                /** @type {State} */ function start(code) {
                    const def = code !== null && map[code];
                    const all = code !== null && map.null;
                    const list = [
                        // To do: add more extension tests.
                        /* c8 ignore next 2 */ ...Array.isArray(def) ? def : def ? [
                            def
                        ] : [],
                        ...Array.isArray(all) ? all : all ? [
                            all
                        ] : []
                    ];
                    return handleListOfConstructs(list)(code);
                }
            }
            /**
       * Handle a list of construct.
       *
       * @param {Array<Construct>} list
       * @returns {State}
       */ function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                if (list.length === 0) return bogusState;
                return handleConstruct(list[constructIndex]);
            }
            /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       * @returns {State}
       */ function handleConstruct(construct) {
                return start;
                /** @type {State} */ function start(code) {
                    // To do: not needed to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    // Always populated by defaults.
                    if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) return nok(code);
                    return construct.tokenize.call(// If we do have fields, create an object w/ `context` as its
                    // prototype.
                    // This allows a “live binding”, which is needed for `interrupt`.
                    fields ? Object.assign(Object.create(context), fields) : context, effects, ok, nok)(code);
                }
            }
            /** @type {State} */ function ok(code) {
                consumed = true;
                onreturn(currentConstruct, info);
                return returnState;
            }
            /** @type {State} */ function nok(code) {
                consumed = true;
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    /**
   * @param {Construct} construct
   * @param {number} from
   * @returns {undefined}
   */ function addResult(construct, from) {
        if (construct.resolveAll && !resolveAllConstructs.includes(construct)) resolveAllConstructs.push(construct);
        if (construct.resolve) (0, $ab4e16a48121f0b9$export$869882364835d202)(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    /**
   * Store state.
   *
   * @returns {Info}
   */ function store() {
        const startPoint = now();
        const startPrevious = context.previous;
        const startCurrentConstruct = context.currentConstruct;
        const startEventsIndex = context.events.length;
        const startStack = Array.from(stack);
        return {
            restore: restore,
            from: startEventsIndex
        };
        /**
     * Restore state.
     *
     * @returns {undefined}
     */ function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {undefined}
   */ function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {Array<Chunk>} chunks
 * @param {Pick<Token, 'end' | 'start'>} token
 * @returns {Array<Chunk>}
 */ function $668a97eece5f50dd$var$sliceChunks(chunks, token) {
    const startIndex = token.start._index;
    const startBufferIndex = token.start._bufferIndex;
    const endIndex = token.end._index;
    const endBufferIndex = token.end._bufferIndex;
    /** @type {Array<Chunk>} */ let view;
    if (startIndex === endIndex) // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) {
            const head = view[0];
            if (typeof head === "string") view[0] = head.slice(startBufferIndex);
            else view.shift();
        }
        if (endBufferIndex > 0) // @ts-expect-error `_bufferIndex` is used on string chunks.
        view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {Array<Chunk>} chunks
 * @param {boolean | undefined} [expandTabs=false]
 * @returns {string}
 */ function $668a97eece5f50dd$var$serializeChunks(chunks, expandTabs) {
    let index = -1;
    /** @type {Array<string>} */ const result = [];
    /** @type {boolean | undefined} */ let atTab;
    while(++index < chunks.length){
        const chunk = chunks[index];
        /** @type {string} */ let value;
        if (typeof chunk === "string") value = chunk;
        else switch(chunk){
            case -5:
                value = "\r";
                break;
            case -4:
                value = "\n";
                break;
            case -3:
                value = "\r\n";
                break;
            case -2:
                value = expandTabs ? " " : "	";
                break;
            case -1:
                if (!expandTabs && atTab) continue;
                value = " ";
                break;
            default:
                // Currently only replacement character.
                value = String.fromCharCode(chunk);
        }
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join("");
}


var $2708d814dd07d14e$exports = {};

$parcel$export($2708d814dd07d14e$exports, "document", function () { return $2708d814dd07d14e$export$5a7bfc01df82fcd1; });
$parcel$export($2708d814dd07d14e$exports, "contentInitial", function () { return $2708d814dd07d14e$export$5a2181fb44b58173; });
$parcel$export($2708d814dd07d14e$exports, "flowInitial", function () { return $2708d814dd07d14e$export$cf8bead395eff824; });
$parcel$export($2708d814dd07d14e$exports, "flow", function () { return $2708d814dd07d14e$export$ccc7b0636abaffc3; });
$parcel$export($2708d814dd07d14e$exports, "string", function () { return $2708d814dd07d14e$export$22b082955e083ec3; });
$parcel$export($2708d814dd07d14e$exports, "text", function () { return $2708d814dd07d14e$export$6f093cfa640b7166; });
$parcel$export($2708d814dd07d14e$exports, "insideSpan", function () { return $2708d814dd07d14e$export$d44f260a3f9b69f5; });
$parcel$export($2708d814dd07d14e$exports, "attentionMarkers", function () { return $2708d814dd07d14e$export$b9c0b60d74426aea; });
$parcel$export($2708d814dd07d14e$exports, "disable", function () { return $2708d814dd07d14e$export$e20fbacbb41798b; });
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 */ /**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
/**
 * @typedef {import('micromark-util-types').Code} Code
 */ 
function $5b5c5b3f542c778e$export$e3902bc0d835cad0(code) {
    if (code === null || (0, $74ae855ebddfe8fb$export$a30284361b3814b7)(code) || (0, $74ae855ebddfe8fb$export$a0ff789c034ffdf4)(code)) return 1;
    if ((0, $74ae855ebddfe8fb$export$aa04114dd888a7a0)(code)) return 2;
}



const $7230a0c6174a6750$export$45b92471da762af7 = {
    name: "attention",
    tokenize: $7230a0c6174a6750$var$tokenizeAttention,
    resolveAll: $7230a0c6174a6750$var$resolveAllAttention
};
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */ // eslint-disable-next-line complexity
function $7230a0c6174a6750$var$resolveAllAttention(events, context) {
    let index = -1;
    /** @type {number} */ let open;
    /** @type {Token} */ let group;
    /** @type {Token} */ let text;
    /** @type {Token} */ let openingSequence;
    /** @type {Token} */ let closingSequence;
    /** @type {number} */ let use;
    /** @type {Array<Event>} */ let nextEvents;
    /** @type {number} */ let offset;
    // Walk through all events.
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === "enter" && events[index][1].type === "attentionSequence" && events[index][1]._close) {
        open = index;
        // Now walk back to find an opener.
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === "exit" && events[open][1].type === "attentionSequence" && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
            // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            const start = Object.assign({}, events[open][1].end);
            const end = Object.assign({}, events[index][1].start);
            $7230a0c6174a6750$var$movePoint(start, -use);
            $7230a0c6174a6750$var$movePoint(end, use);
            openingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: start,
                end: Object.assign({}, events[open][1].end)
            };
            closingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: Object.assign({}, events[index][1].start),
                end: end
            };
            text = {
                type: use > 1 ? "strongText" : "emphasisText",
                start: Object.assign({}, events[open][1].end),
                end: Object.assign({}, events[index][1].start)
            };
            group = {
                type: use > 1 ? "strong" : "emphasis",
                start: Object.assign({}, openingSequence.start),
                end: Object.assign({}, closingSequence.end)
            };
            events[open][1].end = Object.assign({}, openingSequence.start);
            events[index][1].start = Object.assign({}, closingSequence.end);
            nextEvents = [];
            // If there are more markers in the opening, add them before.
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = (0, $ab4e16a48121f0b9$export$4cbf152802aa238)(nextEvents, [
                [
                    "enter",
                    events[open][1],
                    context
                ],
                [
                    "exit",
                    events[open][1],
                    context
                ]
            ]);
            // Opening.
            nextEvents = (0, $ab4e16a48121f0b9$export$4cbf152802aa238)(nextEvents, [
                [
                    "enter",
                    group,
                    context
                ],
                [
                    "enter",
                    openingSequence,
                    context
                ],
                [
                    "exit",
                    openingSequence,
                    context
                ],
                [
                    "enter",
                    text,
                    context
                ]
            ]);
            // Always populated by defaults.
            // Between.
            nextEvents = (0, $ab4e16a48121f0b9$export$4cbf152802aa238)(nextEvents, (0, $af7938992e81384c$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
            // Closing.
            nextEvents = (0, $ab4e16a48121f0b9$export$4cbf152802aa238)(nextEvents, [
                [
                    "exit",
                    text,
                    context
                ],
                [
                    "enter",
                    closingSequence,
                    context
                ],
                [
                    "exit",
                    closingSequence,
                    context
                ],
                [
                    "exit",
                    group,
                    context
                ]
            ]);
            // If there are more markers in the closing, add them after.
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = (0, $ab4e16a48121f0b9$export$4cbf152802aa238)(nextEvents, [
                    [
                        "enter",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            (0, $ab4e16a48121f0b9$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
    // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === "attentionSequence") events[index][1].type = "data";
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $7230a0c6174a6750$var$tokenizeAttention(effects, ok) {
    const attentionMarkers = this.parser.constructs.attentionMarkers.null;
    const previous = this.previous;
    const before = (0, $5b5c5b3f542c778e$export$e3902bc0d835cad0)(previous);
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        marker = code;
        effects.enter("attentionSequence");
        return inside(code);
    }
    /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        const token = effects.exit("attentionSequence");
        // To do: next major: move this to resolver, just like `markdown-rs`.
        const after = (0, $5b5c5b3f542c778e$export$e3902bc0d835cad0)(code);
        // Always populated by defaults.
        const open = !after || after === 2 && before || attentionMarkers.includes(code);
        const close = !before || before === 2 && after || attentionMarkers.includes(previous);
        token._open = Boolean(marker === 42 ? open : open && (before || !close));
        token._close = Boolean(marker === 42 ? close : close && (after || !open));
        return ok(code);
    }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 * @param {number} offset
 * @returns {undefined}
 */ function $7230a0c6174a6750$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $fec8b78d8ce85447$export$17ddf85e4c916ad6 = {
    name: "autolink",
    tokenize: $fec8b78d8ce85447$var$tokenizeAutolink
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $fec8b78d8ce85447$var$tokenizeAutolink(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("autolink");
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.enter("autolinkProtocol");
        return open;
    }
    /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if ((0, $74ae855ebddfe8fb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        return emailAtext(code);
    }
    /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeOrEmailAtext(code) {
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if (code === 43 || code === 45 || code === 46 || (0, $74ae855ebddfe8fb$export$75c76db11865a9f4)(code)) {
            // Count the previous alphabetical from `open` too.
            size = 1;
            return schemeInsideOrEmailAtext(code);
        }
        return emailAtext(code);
    }
    /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            size = 0;
            return urlInside;
        }
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if ((code === 43 || code === 45 || code === 46 || (0, $74ae855ebddfe8fb$export$75c76db11865a9f4)(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        size = 0;
        return emailAtext(code);
    }
    /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */ function urlInside(code) {
        if (code === 62) {
            effects.exit("autolinkProtocol");
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        // ASCII control, space, or `<`.
        if (code === null || code === 32 || code === 60 || (0, $74ae855ebddfe8fb$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */ function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            return emailAtSignOrDot;
        }
        if ((0, $74ae855ebddfe8fb$export$4397998b34fe597d)(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */ function emailAtSignOrDot(code) {
        return (0, $74ae855ebddfe8fb$export$75c76db11865a9f4)(code) ? emailLabel(code) : nok(code);
    }
    /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */ function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the token type.
            effects.exit("autolinkProtocol").type = "autolinkEmail";
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        return emailValue(code);
    }
    /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */ function emailValue(code) {
        // ASCII alphanumeric or `-`.
        if ((code === 45 || (0, $74ae855ebddfe8fb$export$75c76db11865a9f4)(code)) && size++ < 63) {
            const next = code === 45 ? emailValue : emailLabel;
            effects.consume(code);
            return next;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $ef9a2630bab0c827$export$200dcd0a5903c968 = {
    name: "blockQuote",
    tokenize: $ef9a2630bab0c827$var$tokenizeBlockQuoteStart,
    continuation: {
        tokenize: $ef9a2630bab0c827$var$tokenizeBlockQuoteContinuation
    },
    exit: $ef9a2630bab0c827$var$exit
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ef9a2630bab0c827$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 62) {
            const state = self.containerState;
            if (!state.open) {
                effects.enter("blockQuote", {
                    _container: true
                });
                state.open = true;
            }
            effects.enter("blockQuotePrefix");
            effects.enter("blockQuoteMarker");
            effects.consume(code);
            effects.exit("blockQuoteMarker");
            return after;
        }
        return nok(code);
    }
    /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if ((0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code)) {
            effects.enter("blockQuotePrefixWhitespace");
            effects.consume(code);
            effects.exit("blockQuotePrefixWhitespace");
            effects.exit("blockQuotePrefix");
            return ok;
        }
        effects.exit("blockQuotePrefix");
        return ok(code);
    }
}
/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ef9a2630bab0c827$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    const self = this;
    return contStart;
    /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contStart(code) {
        if ((0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code)) // Always populated by defaults.
        return (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, contBefore, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
        return contBefore(code);
    }
    /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contBefore(code) {
        return effects.attempt($ef9a2630bab0c827$export$200dcd0a5903c968, ok, nok)(code);
    }
}
/** @type {Exiter} */ function $ef9a2630bab0c827$var$exit(effects) {
    effects.exit("blockQuote");
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $455b1f810d975361$export$2005478564e78d96 = {
    name: "characterEscape",
    tokenize: $455b1f810d975361$var$tokenizeCharacterEscape
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $455b1f810d975361$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        effects.exit("escapeMarker");
        return inside;
    }
    /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // ASCII punctuation.
        if ((0, $74ae855ebddfe8fb$export$35794a7d1db99380)(code)) {
            effects.enter("characterEscapeValue");
            effects.consume(code);
            effects.exit("characterEscapeValue");
            effects.exit("characterEscape");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $034308c613320ed2$export$e31905600aaf3d8e = {
    name: "characterReference",
    tokenize: $034308c613320ed2$var$tokenizeCharacterReference
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $034308c613320ed2$var$tokenizeCharacterReference(effects, ok, nok) {
    const self = this;
    let size = 0;
    /** @type {number} */ let max;
    /** @type {(code: Code) => boolean} */ let test;
    return start;
    /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterReference");
        effects.enter("characterReferenceMarker");
        effects.consume(code);
        effects.exit("characterReferenceMarker");
        return open;
    }
    /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 35) {
            effects.enter("characterReferenceMarkerNumeric");
            effects.consume(code);
            effects.exit("characterReferenceMarkerNumeric");
            return numeric;
        }
        effects.enter("characterReferenceValue");
        max = 31;
        test = (0, $74ae855ebddfe8fb$export$75c76db11865a9f4);
        return value(code);
    }
    /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */ function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter("characterReferenceMarkerHexadecimal");
            effects.consume(code);
            effects.exit("characterReferenceMarkerHexadecimal");
            effects.enter("characterReferenceValue");
            max = 6;
            test = (0, $74ae855ebddfe8fb$export$eca2752363989806);
            return value;
        }
        effects.enter("characterReferenceValue");
        max = 7;
        test = (0, $74ae855ebddfe8fb$export$ca8b5b1a6c320e6e);
        return value(code);
    }
    /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */ function value(code) {
        if (code === 59 && size) {
            const token = effects.exit("characterReferenceValue");
            if (test === (0, $74ae855ebddfe8fb$export$75c76db11865a9f4) && !(0, $5e5977bcdef97531$export$289b6a6320f709b4)(self.sliceSerialize(token))) return nok(code);
            // To do: `markdown-rs` uses a different name:
            // `CharacterReferenceMarkerSemi`.
            effects.enter("characterReferenceMarker");
            effects.consume(code);
            effects.exit("characterReferenceMarker");
            effects.exit("characterReference");
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

/** @type {Construct} */ const $23e8b02c6186c8d5$var$nonLazyContinuation = {
    tokenize: $23e8b02c6186c8d5$var$tokenizeNonLazyContinuation,
    partial: true
};
const $23e8b02c6186c8d5$export$c23e4921f8d87e7c = {
    name: "codeFenced",
    tokenize: $23e8b02c6186c8d5$var$tokenizeCodeFenced,
    concrete: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $23e8b02c6186c8d5$var$tokenizeCodeFenced(effects, ok, nok) {
    const self = this;
    /** @type {Construct} */ const closeStart = {
        tokenize: tokenizeCloseStart,
        partial: true
    };
    let initialPrefix = 0;
    let sizeOpen = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse whitespace like `markdown-rs`.
        return beforeSequenceOpen(code);
    }
    /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeSequenceOpen(code) {
        const tail = self.events[self.events.length - 1];
        initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
        marker = code;
        effects.enter("codeFenced");
        effects.enter("codeFencedFence");
        effects.enter("codeFencedFenceSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === marker) {
            sizeOpen++;
            effects.consume(code);
            return sequenceOpen;
        }
        if (sizeOpen < 3) return nok(code);
        effects.exit("codeFencedFenceSequence");
        return (0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code) ? (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, infoBefore, "whitespace")(code) : infoBefore(code);
    }
    /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function infoBefore(code) {
        if (code === null || (0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFencedFence");
            return self.interrupt ? ok(code) : effects.check($23e8b02c6186c8d5$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        }
        effects.enter("codeFencedFenceInfo");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return info(code);
    }
    /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function info(code) {
        if (code === null || (0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return infoBefore(code);
        }
        if ((0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, metaBefore, "whitespace")(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function metaBefore(code) {
        if (code === null || (0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) return infoBefore(code);
        effects.enter("codeFencedFenceMeta");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return meta(code);
    }
    /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function meta(code) {
        if (code === null || (0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceMeta");
            return infoBefore(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function atNonLazyBreak(code) {
        return effects.attempt(closeStart, after, contentBefore)(code);
    }
    /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentBefore(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return contentStart;
    }
    /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentStart(code) {
        return initialPrefix > 0 && (0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code) ? (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code) : beforeContentChunk(code);
    }
    /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeContentChunk(code) {
        if (code === null || (0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) return effects.check($23e8b02c6186c8d5$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        effects.enter("codeFlowValue");
        return contentChunk(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentChunk(code) {
        if (code === null || (0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return beforeContentChunk(code);
        }
        effects.consume(code);
        return contentChunk;
    }
    /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        effects.exit("codeFenced");
        return ok(code);
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeCloseStart(effects, ok, nok) {
        let size = 0;
        return startBefore;
        /**
     *
     *
     * @type {State}
     */ function startBefore(code) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return start;
        }
        /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function start(code) {
            // Always populated by defaults.
            // To do: `enter` here or in next state?
            effects.enter("codeFencedFence");
            return (0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code) ? (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, beforeSequenceClose, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code) : beforeSequenceClose(code);
        }
        /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function beforeSequenceClose(code) {
            if (code === marker) {
                effects.enter("codeFencedFenceSequence");
                return sequenceClose(code);
            }
            return nok(code);
        }
        /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function sequenceClose(code) {
            if (code === marker) {
                size++;
                effects.consume(code);
                return sequenceClose;
            }
            if (size >= sizeOpen) {
                effects.exit("codeFencedFenceSequence");
                return (0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code) ? (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, sequenceCloseAfter, "whitespace")(code) : sequenceCloseAfter(code);
            }
            return nok(code);
        }
        /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */ function sequenceCloseAfter(code) {
            if (code === null || (0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
                effects.exit("codeFencedFence");
                return ok(code);
            }
            return nok(code);
        }
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $23e8b02c6186c8d5$var$tokenizeNonLazyContinuation(effects, ok, nok) {
    const self = this;
    return start;
    /**
   *
   *
   * @type {State}
   */ function start(code) {
        if (code === null) return nok(code);
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineStart;
    }
    /**
   *
   *
   * @type {State}
   */ function lineStart(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $de6ae6e6a5e259d8$export$47910b7ab28d1853 = {
    name: "codeIndented",
    tokenize: $de6ae6e6a5e259d8$var$tokenizeCodeIndented
};
/** @type {Construct} */ const $de6ae6e6a5e259d8$var$furtherStart = {
    tokenize: $de6ae6e6a5e259d8$var$tokenizeFurtherStart,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $de6ae6e6a5e259d8$var$tokenizeCodeIndented(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: manually check if interrupting like `markdown-rs`.
        effects.enter("codeIndented");
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code) : nok(code);
    }
    /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === null) return after(code);
        if ((0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) return effects.attempt($de6ae6e6a5e259d8$var$furtherStart, atBreak, after)(code);
        effects.enter("codeFlowValue");
        return inside(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === null || (0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return atBreak(code);
        }
        effects.consume(code);
        return inside;
    }
    /** @type {State} */ function after(code) {
        effects.exit("codeIndented");
        // To do: allow interrupting like `markdown-rs`.
        // Feel free to interrupt.
        // tokenizer.interrupt = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $de6ae6e6a5e259d8$var$tokenizeFurtherStart(effects, ok, nok) {
    const self = this;
    return furtherStart;
    /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */ function furtherStart(code) {
        // To do: improve `lazy` / `pierce` handling.
        // If this is a lazy line, it can’t be code.
        if (self.parser.lazy[self.now().line]) return nok(code);
        if ((0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return furtherStart;
        }
        // To do: the code here in `micromark-js` is a bit different from
        // `markdown-rs` because there it can attempt spaces.
        // We can’t yet.
        //
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code) : (0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code) ? furtherStart(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $da4255073b0f8c9c$export$d24f93e715f9df88 = {
    name: "codeText",
    tokenize: $da4255073b0f8c9c$var$tokenizeCodeText,
    resolve: $da4255073b0f8c9c$var$resolveCodeText,
    previous: $da4255073b0f8c9c$var$previous
};
// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */ function $da4255073b0f8c9c$var$resolveCodeText(events) {
    let tailExitIndex = events.length - 4;
    let headEnterIndex = 3;
    /** @type {number} */ let index;
    /** @type {number | undefined} */ let enter;
    // If we start and end with an EOL or a space.
    if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === "space") && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === "space")) {
        index = headEnterIndex;
        // And we have data.
        while(++index < tailExitIndex)if (events[index][1].type === "codeTextData") {
            // Then we have padding.
            events[headEnterIndex][1].type = "codeTextPadding";
            events[tailExitIndex][1].type = "codeTextPadding";
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    }
    // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== "lineEnding") enter = index;
        } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
            events[enter][1].type = "codeTextData";
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Previous}
 */ function $da4255073b0f8c9c$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $da4255073b0f8c9c$var$tokenizeCodeText(effects, ok, nok) {
    const self = this;
    let sizeOpen = 0;
    /** @type {number} */ let size;
    /** @type {Token} */ let token;
    return start;
    /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("codeText");
        effects.enter("codeTextSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit("codeTextSequence");
        return between(code);
    }
    /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */ function between(code) {
        // EOF.
        if (code === null) return nok(code);
        // To do: next major: don’t do spaces in resolve, but when compiling,
        // like `markdown-rs`.
        // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter("space");
            effects.consume(code);
            effects.exit("space");
            return between;
        }
        // Closing fence? Could also be data.
        if (code === 96) {
            token = effects.enter("codeTextSequence");
            size = 0;
            return sequenceClose(code);
        }
        if ((0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return between;
        }
        // Data.
        effects.enter("codeTextData");
        return data(code);
    }
    /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 32 || code === 96 || (0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            effects.exit("codeTextData");
            return between(code);
        }
        effects.consume(code);
        return data;
    }
    /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */ function sequenceClose(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return sequenceClose;
        }
        // Done!
        if (size === sizeOpen) {
            effects.exit("codeTextSequence");
            effects.exit("codeText");
            return ok(code);
        }
        // More or less accents: mark as data.
        token.type = "codeTextData";
        return data(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
function $e741db756e392bf6$export$2e6c8deaa96af245(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    const limit = max || Number.POSITIVE_INFINITY;
    let balance = 0;
    return start;
    /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return enclosedBefore;
        }
        // ASCII control, space, closing paren.
        if (code === null || code === 32 || code === 41 || (0, $74ae855ebddfe8fb$export$67dbf494fc8394df)(code)) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return raw(code);
    }
    /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return enclosed(code);
    }
    /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosed(code) {
        if (code === 62) {
            effects.exit("chunkString");
            effects.exit(stringType);
            return enclosedBefore(code);
        }
        if (code === null || code === 60 || (0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? enclosedEscape : enclosed;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */ function enclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return enclosed;
        }
        return enclosed(code);
    }
    /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function raw(code) {
        if (!balance && (code === null || code === 41 || (0, $74ae855ebddfe8fb$export$a30284361b3814b7)(code))) {
            effects.exit("chunkString");
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if (balance < limit && code === 40) {
            effects.consume(code);
            balance++;
            return raw;
        }
        if (code === 41) {
            effects.consume(code);
            balance--;
            return raw;
        }
        // ASCII control (but *not* `\0`) and space and `(`.
        // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
        // doesn’t.
        if (code === null || code === 32 || code === 40 || (0, $74ae855ebddfe8fb$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? rawEscape : raw;
    }
    /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */ function rawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return raw;
        }
        return raw(code);
    }
}


/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
function $ffc1da37451866a9$export$7b768614d8ba97a7(effects, ok, nok, type, markerType, stringType) {
    const self = this;
    let size = 0;
    /** @type {boolean} */ let seen;
    return start;
    /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (size > 999 || code === null || code === 91 || code === 93 && !seen || // To do: remove in the future once we’ve switched from
        // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
        // which doesn’t need this.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ code === 94 && !size && "_hiddenFootnoteSupport" in self.parser.constructs) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        // To do: indent? Link chunks and EOLs together?
        if ((0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return atBreak;
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return labelInside(code);
    }
    /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (code === null || code === 91 || code === 93 || (0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code) || size++ > 999) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        if (!seen) seen = !(0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
}



/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 

function $10607c0e95af177a$export$f970569cc855e483(effects, ok, nok, type, markerType, stringType) {
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 34 || code === 39 || code === 40) {
            effects.enter(type);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            marker = code === 40 ? 41 : code;
            return begin;
        }
        return nok(code);
    }
    /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function begin(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atBreak(code);
    }
    /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return begin(marker);
        }
        if (code === null) return nok(code);
        // Note: blank lines can’t exist in content.
        if ((0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            // To do: use `space_or_tab_eol_with_options`, connect.
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, atBreak, "linePrefix");
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return inside(code);
    }
    /**
   *
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker || code === null || (0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        return code === 92 ? escape : inside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */ function escape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return inside;
        }
        return inside(code);
    }
}


/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */ 

function $143ad627545abc7e$export$1f27bd1aa33ce173(effects, ok) {
    /** @type {boolean} */ let seen;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            seen = true;
            return start;
        }
        if ((0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code)) return (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, start, seen ? "linePrefix" : "lineSuffix")(code);
        return ok(code);
    }
}




const $7d7a6561e3000c7c$export$69f215ed977cdb73 = {
    name: "definition",
    tokenize: $7d7a6561e3000c7c$var$tokenizeDefinition
};
/** @type {Construct} */ const $7d7a6561e3000c7c$var$titleBefore = {
    tokenize: $7d7a6561e3000c7c$var$tokenizeTitleBefore,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $7d7a6561e3000c7c$var$tokenizeDefinition(effects, ok, nok) {
    const self = this;
    /** @type {string} */ let identifier;
    return start;
    /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Do not interrupt paragraphs (but do follow definitions).
        // To do: do `interrupt` the way `markdown-rs` does.
        // To do: parse whitespace the way `markdown-rs` does.
        effects.enter("definition");
        return before(code);
    }
    /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        // To do: parse whitespace the way `markdown-rs` does.
        return (0, $ffc1da37451866a9$export$7b768614d8ba97a7).call(self, effects, labelAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code);
    }
    /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        identifier = (0, $46d36bfd48dea0be$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            return markerAfter;
        }
        return nok(code);
    }
    /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */ function markerAfter(code) {
        // Note: whitespace is optional.
        return (0, $74ae855ebddfe8fb$export$a30284361b3814b7)(code) ? (0, $143ad627545abc7e$export$1f27bd1aa33ce173)(effects, destinationBefore)(code) : destinationBefore(code);
    }
    /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */ function destinationBefore(code) {
        return (0, $e741db756e392bf6$export$2e6c8deaa96af245)(effects, destinationAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(code);
    }
    /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function destinationAfter(code) {
        return effects.attempt($7d7a6561e3000c7c$var$titleBefore, after, after)(code);
    }
    /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return (0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code) ? (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, afterWhitespace, "whitespace")(code) : afterWhitespace(code);
    }
    /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function afterWhitespace(code) {
        if (code === null || (0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            effects.exit("definition");
            // Note: we don’t care about uniqueness.
            // It’s likely that that doesn’t happen very frequently.
            // It is more likely that it wastes precious time.
            self.parser.defined.push(identifier);
            // To do: `markdown-rs` interrupt.
            // // You’d be interrupting.
            // tokenizer.interrupt = true
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $7d7a6561e3000c7c$var$tokenizeTitleBefore(effects, ok, nok) {
    return titleBefore;
    /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function titleBefore(code) {
        return (0, $74ae855ebddfe8fb$export$a30284361b3814b7)(code) ? (0, $143ad627545abc7e$export$1f27bd1aa33ce173)(effects, beforeMarker)(code) : nok(code);
    }
    /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function beforeMarker(code) {
        return (0, $10607c0e95af177a$export$f970569cc855e483)(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
    }
    /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfter(code) {
        return (0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code) ? (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, titleAfterOptionalWhitespace, "whitespace")(code) : titleAfterOptionalWhitespace(code);
    }
    /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfterOptionalWhitespace(code) {
        return code === null || (0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $df67ef7cc1bf6824$export$86c573ab9e06f418 = {
    name: "hardBreakEscape",
    tokenize: $df67ef7cc1bf6824$var$tokenizeHardBreakEscape
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $df67ef7cc1bf6824$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("hardBreakEscape");
        effects.consume(code);
        return after;
    }
    /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */ function after(code) {
        if ((0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            effects.exit("hardBreakEscape");
            return ok(code);
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 


const $2547c9aa83982ee7$export$3871e9deb360695c = {
    name: "headingAtx",
    tokenize: $2547c9aa83982ee7$var$tokenizeHeadingAtx,
    resolve: $2547c9aa83982ee7$var$resolveHeadingAtx
};
/** @type {Resolver} */ function $2547c9aa83982ee7$var$resolveHeadingAtx(events, context) {
    let contentEnd = events.length - 2;
    let contentStart = 3;
    /** @type {Token} */ let content;
    /** @type {Token} */ let text;
    // Prefix whitespace, part of the opening.
    if (events[contentStart][1].type === "whitespace") contentStart += 2;
    // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") contentEnd -= 2;
    if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: "atxHeadingText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: "chunkText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: "text"
        };
        (0, $ab4e16a48121f0b9$export$869882364835d202)(events, contentStart, contentEnd - contentStart + 1, [
            [
                "enter",
                content,
                context
            ],
            [
                "enter",
                text,
                context
            ],
            [
                "exit",
                text,
                context
            ],
            [
                "exit",
                content,
                context
            ]
        ]);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2547c9aa83982ee7$var$tokenizeHeadingAtx(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        effects.enter("atxHeading");
        return before(code);
    }
    /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("atxHeadingSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return sequenceOpen;
        }
        // Always at least one `#`.
        if (code === null || (0, $74ae855ebddfe8fb$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingSequence");
            return atBreak(code);
        }
        return nok(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === 35) {
            effects.enter("atxHeadingSequence");
            return sequenceFurther(code);
        }
        if (code === null || (0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            effects.exit("atxHeading");
            // To do: interrupt like `markdown-rs`.
            // // Feel free to interrupt.
            // tokenizer.interrupt = false
            return ok(code);
        }
        if ((0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code)) return (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code);
        // To do: generate `data` tokens, add the `text` token later.
        // Needs edit map, see: `markdown.rs`.
        effects.enter("atxHeadingText");
        return data(code);
    }
    /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */ function sequenceFurther(code) {
        if (code === 35) {
            effects.consume(code);
            return sequenceFurther;
        }
        effects.exit("atxHeadingSequence");
        return atBreak(code);
    }
    /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 35 || (0, $74ae855ebddfe8fb$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingText");
            return atBreak(code);
        }
        effects.consume(code);
        return data;
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */ const $0961e3a517525667$export$7364aee1c59d1879 = [
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "search",
    "section",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
];
const $0961e3a517525667$export$948e66da505d080 = [
    "pre",
    "script",
    "style",
    "textarea"
];



const $0d446361532d6fbe$export$476ac411cb7d0d8f = {
    name: "htmlFlow",
    tokenize: $0d446361532d6fbe$var$tokenizeHtmlFlow,
    resolveTo: $0d446361532d6fbe$var$resolveToHtmlFlow,
    concrete: true
};
/** @type {Construct} */ const $0d446361532d6fbe$var$blankLineBefore = {
    tokenize: $0d446361532d6fbe$var$tokenizeBlankLineBefore,
    partial: true
};
const $0d446361532d6fbe$var$nonLazyContinuationStart = {
    tokenize: $0d446361532d6fbe$var$tokenizeNonLazyContinuationStart,
    partial: true
};
/** @type {Resolver} */ function $0d446361532d6fbe$var$resolveToHtmlFlow(events) {
    let index = events.length;
    while(index--){
        if (events[index][0] === "enter" && events[index][1].type === "htmlFlow") break;
    }
    if (index > 1 && events[index - 2][1].type === "linePrefix") {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start;
        // Add the prefix start to the HTML line token.
        events[index + 1][1].start = events[index - 2][1].start;
        // Remove the line prefix.
        events.splice(index - 2, 2);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $0d446361532d6fbe$var$tokenizeHtmlFlow(effects, ok, nok) {
    const self = this;
    /** @type {number} */ let marker;
    /** @type {boolean} */ let closingTag;
    /** @type {string} */ let buffer;
    /** @type {number} */ let index;
    /** @type {Code} */ let markerB;
    return start;
    /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("htmlFlow");
        effects.enter("htmlFlowData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            closingTag = true;
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            marker = 3;
            // To do:
            // tokenizer.concrete = true
            // To do: use `markdown-rs` style interrupt.
            // While we’re in an instruction instead of a declaration, we’re on a `?`
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        // ASCII alphabetical.
        if ((0, $74ae855ebddfe8fb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            marker = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            marker = 5;
            index = 0;
            return cdataOpenInside;
        }
        // ASCII alphabetical.
        if ((0, $74ae855ebddfe8fb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            marker = 4;
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            if (index === value.length) // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
            return cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        if ((0, $74ae855ebddfe8fb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */ function tagName(code) {
        if (code === null || code === 47 || code === 62 || (0, $74ae855ebddfe8fb$export$a30284361b3814b7)(code)) {
            const slash = code === 47;
            const name = buffer.toLowerCase();
            if (!slash && !closingTag && (0, $0961e3a517525667$export$948e66da505d080).includes(name)) {
                marker = 1;
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ((0, $0961e3a517525667$export$7364aee1c59d1879).includes(buffer.toLowerCase())) {
                marker = 6;
                if (slash) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            marker = 7;
            // Do not support complete HTML when interrupting.
            return self.interrupt && !self.parser.lazy[self.now().line] ? nok(code) : closingTag ? completeClosingTagAfter(code) : completeAttributeNameBefore(code);
        }
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $74ae855ebddfe8fb$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */ function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeClosingTagAfter(code) {
        if ((0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        // ASCII alphanumerical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $74ae855ebddfe8fb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ((0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeName(code) {
        // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $74ae855ebddfe8fb$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ((0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            markerB = code;
            return completeAttributeValueQuoted;
        }
        if ((0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        return completeAttributeValueUnquoted(code);
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuoted(code) {
        if (code === markerB) {
            effects.consume(code);
            markerB = null;
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || (0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 47 || code === 60 || code === 61 || code === 62 || code === 96 || (0, $74ae855ebddfe8fb$export$a30284361b3814b7)(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */ function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAfter(code) {
        if (code === null || (0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) // // Do not form containers.
        // tokenizer.concrete = true
        return continuation(code);
        if ((0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */ function continuation(code) {
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && marker === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && marker === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && marker === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && marker === 5) {
            effects.consume(code);
            return continuationCdataInside;
        }
        if ((0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code) && (marker === 6 || marker === 7)) {
            effects.exit("htmlFlowData");
            return effects.check($0d446361532d6fbe$var$blankLineBefore, continuationAfter, continuationStart)(code);
        }
        if (code === null || (0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationStart(code);
        }
        effects.consume(code);
        return continuation;
    }
    /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStart(code) {
        return effects.check($0d446361532d6fbe$var$nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code);
    }
    /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStartNonLazy(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return continuationBefore;
    }
    /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */ function continuationBefore(code) {
        if (code === null || (0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) return continuationStart(code);
        effects.enter("htmlFlowData");
        return continuation(code);
    }
    /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */ function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */ function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = "";
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */ function continuationRawEndTag(code) {
        if (code === 62) {
            const name = buffer.toLowerCase();
            if ((0, $0961e3a517525667$export$948e66da505d080).includes(name)) {
                effects.consume(code);
                return continuationClose;
            }
            return continuation(code);
        }
        if ((0, $74ae855ebddfe8fb$export$d65d6b62c24d5436)(code) && buffer.length < 8) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer += String.fromCharCode(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */ function continuationCdataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */ function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        // More dashes.
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationClose(code) {
        if (code === null || (0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationAfter(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationAfter(code) {
        effects.exit("htmlFlow");
        // // Feel free to interrupt.
        // tokenizer.interrupt = false
        // // No longer concrete.
        // tokenizer.concrete = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $0d446361532d6fbe$var$tokenizeNonLazyContinuationStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        if ((0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return after;
        }
        return nok(code);
    }
    /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $0d446361532d6fbe$var$tokenizeBlankLineBefore(effects, ok, nok) {
    return start;
    /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return effects.attempt((0, $464bca88fae6642a$export$d50d28ce3ab2a612), ok, nok);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $37c6f077e7577d52$export$398af27f284914fe = {
    name: "htmlText",
    tokenize: $37c6f077e7577d52$var$tokenizeHtmlText
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $37c6f077e7577d52$var$tokenizeHtmlText(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code> | undefined} */ let marker;
    /** @type {number} */ let index;
    /** @type {State} */ let returnState;
    return start;
    /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("htmlText");
        effects.enter("htmlTextData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        // ASCII alphabetical.
        if ((0, $74ae855ebddfe8fb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            index = 0;
            return cdataOpenInside;
        }
        if ((0, $74ae855ebddfe8fb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return nok(code);
    }
    /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */ function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ((0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            returnState = comment;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return comment;
    }
    /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */ function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return comment(code);
    }
    /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */ function commentEnd(code) {
        return code === 62 ? end(code) : code === 45 ? commentClose(code) : comment(code);
    }
    /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            return index === value.length ? cdata : cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */ function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ((0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            returnState = cdata;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return cdata;
    }
    /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */ function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */ function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ((0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            returnState = declaration;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return declaration;
    }
    /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */ function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ((0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            returnState = instruction;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return instruction;
    }
    /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */ function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        // ASCII alphabetical.
        if ((0, $74ae855ebddfe8fb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagClose(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $74ae855ebddfe8fb$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagCloseBetween(code) {
        if ((0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            returnState = tagCloseBetween;
            return lineEndingBefore(code);
        }
        if ((0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpen(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $74ae855ebddfe8fb$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || (0, $74ae855ebddfe8fb$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        // ASCII alphabetical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $74ae855ebddfe8fb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ((0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenBetween;
            return lineEndingBefore(code);
        }
        if ((0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeName(code) {
        // ASCII alphabetical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $74ae855ebddfe8fb$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ((0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeNameAfter;
            return lineEndingBefore(code);
        }
        if ((0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ((0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueBefore;
            return lineEndingBefore(code);
        }
        if ((0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            marker = undefined;
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ((0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 47 || code === 62 || (0, $74ae855ebddfe8fb$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $74ae855ebddfe8fb$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit("htmlTextData");
            effects.exit("htmlText");
            return ok;
        }
        return nok(code);
    }
    /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */ function lineEndingBefore(code) {
        effects.exit("htmlTextData");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineEndingAfter;
    }
    /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfter(code) {
        // Always populated by defaults.
        return (0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code) ? (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, lineEndingAfterPrefix, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code) : lineEndingAfterPrefix(code);
    }
    /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfterPrefix(code) {
        effects.enter("htmlTextData");
        return returnState(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 







const $9927ca4c0ce63c44$export$470a5dafbbf62654 = {
    name: "labelEnd",
    tokenize: $9927ca4c0ce63c44$var$tokenizeLabelEnd,
    resolveTo: $9927ca4c0ce63c44$var$resolveToLabelEnd,
    resolveAll: $9927ca4c0ce63c44$var$resolveAllLabelEnd
};
/** @type {Construct} */ const $9927ca4c0ce63c44$var$resourceConstruct = {
    tokenize: $9927ca4c0ce63c44$var$tokenizeResource
};
/** @type {Construct} */ const $9927ca4c0ce63c44$var$referenceFullConstruct = {
    tokenize: $9927ca4c0ce63c44$var$tokenizeReferenceFull
};
/** @type {Construct} */ const $9927ca4c0ce63c44$var$referenceCollapsedConstruct = {
    tokenize: $9927ca4c0ce63c44$var$tokenizeReferenceCollapsed
};
/** @type {Resolver} */ function $9927ca4c0ce63c44$var$resolveAllLabelEnd(events) {
    let index = -1;
    while(++index < events.length){
        const token = events[index][1];
        if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
            // Remove the marker.
            events.splice(index + 1, token.type === "labelImage" ? 4 : 2);
            token.type = "data";
            index++;
        }
    }
    return events;
}
/** @type {Resolver} */ function $9927ca4c0ce63c44$var$resolveToLabelEnd(events, context) {
    let index = events.length;
    let offset = 0;
    /** @type {Token} */ let token;
    /** @type {number | undefined} */ let open;
    /** @type {number | undefined} */ let close;
    /** @type {Array<Event>} */ let media;
    // Find an opening.
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === "link" || token.type === "labelLink" && token._inactive) break;
            // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === "enter" && token.type === "labelLink") token._inactive = true;
        } else if (close) {
            if (events[index][0] === "enter" && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
                open = index;
                if (token.type !== "labelLink") {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === "labelEnd") close = index;
    }
    const group = {
        type: events[open][1].type === "labelLink" ? "link" : "image",
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    const label = {
        type: "label",
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[close][1].end)
    };
    const text = {
        type: "labelText",
        start: Object.assign({}, events[open + offset + 2][1].end),
        end: Object.assign({}, events[close - 2][1].start)
    };
    media = [
        [
            "enter",
            group,
            context
        ],
        [
            "enter",
            label,
            context
        ]
    ];
    // Opening marker.
    media = (0, $ab4e16a48121f0b9$export$4cbf152802aa238)(media, events.slice(open + 1, open + offset + 3));
    // Text open.
    media = (0, $ab4e16a48121f0b9$export$4cbf152802aa238)(media, [
        [
            "enter",
            text,
            context
        ]
    ]);
    // Always populated by defaults.
    // Between.
    media = (0, $ab4e16a48121f0b9$export$4cbf152802aa238)(media, (0, $af7938992e81384c$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context));
    // Text close, marker close, label close.
    media = (0, $ab4e16a48121f0b9$export$4cbf152802aa238)(media, [
        [
            "exit",
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            "exit",
            label,
            context
        ]
    ]);
    // Reference, resource, or so.
    media = (0, $ab4e16a48121f0b9$export$4cbf152802aa238)(media, events.slice(close + 1));
    // Media close.
    media = (0, $ab4e16a48121f0b9$export$4cbf152802aa238)(media, [
        [
            "exit",
            group,
            context
        ]
    ]);
    (0, $ab4e16a48121f0b9$export$869882364835d202)(events, open, events.length, media);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $9927ca4c0ce63c44$var$tokenizeLabelEnd(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Token} */ let labelStart;
    /** @type {boolean} */ let defined;
    // Find an opening.
    while(index--)if ((self.events[index][1].type === "labelImage" || self.events[index][1].type === "labelLink") && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */ function start(code) {
        // If there is not an okay opening.
        if (!labelStart) return nok(code);
        // If the corresponding label (link) start is marked as inactive,
        // it means we’d be wrapping a link, like this:
        //
        // ```markdown
        // > | a [b [c](d) e](f) g.
        //                  ^
        // ```
        //
        // We can’t have that, so it’s just balanced brackets.
        if (labelStart._inactive) return labelEndNok(code);
        defined = self.parser.defined.includes((0, $46d36bfd48dea0be$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        })));
        effects.enter("labelEnd");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelEnd");
        return after;
    }
    /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
        // an extension.
        // Resource (`[asd](fgh)`)?
        if (code === 40) return effects.attempt($9927ca4c0ce63c44$var$resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code);
        // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
        if (code === 91) return effects.attempt($9927ca4c0ce63c44$var$referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code);
        // Shortcut (`[asd]`) reference?
        return defined ? labelEndOk(code) : labelEndNok(code);
    }
    /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceNotFull(code) {
        return effects.attempt($9927ca4c0ce63c44$var$referenceCollapsedConstruct, labelEndOk, labelEndNok)(code);
    }
    /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndOk(code) {
        // Note: `markdown-rs` does a bunch of stuff here.
        return ok(code);
    }
    /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndNok(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $9927ca4c0ce63c44$var$tokenizeResource(effects, ok, nok) {
    return resourceStart;
    /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */ function resourceStart(code) {
        effects.enter("resource");
        effects.enter("resourceMarker");
        effects.consume(code);
        effects.exit("resourceMarker");
        return resourceBefore;
    }
    /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceBefore(code) {
        return (0, $74ae855ebddfe8fb$export$a30284361b3814b7)(code) ? (0, $143ad627545abc7e$export$1f27bd1aa33ce173)(effects, resourceOpen)(code) : resourceOpen(code);
    }
    /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceOpen(code) {
        if (code === 41) return resourceEnd(code);
        return (0, $e741db756e392bf6$export$2e6c8deaa96af245)(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code);
    }
    /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationAfter(code) {
        return (0, $74ae855ebddfe8fb$export$a30284361b3814b7)(code) ? (0, $143ad627545abc7e$export$1f27bd1aa33ce173)(effects, resourceBetween)(code) : resourceEnd(code);
    }
    /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationMissing(code) {
        return nok(code);
    }
    /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */ function resourceBetween(code) {
        if (code === 34 || code === 39 || code === 40) return (0, $10607c0e95af177a$export$f970569cc855e483)(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
        return resourceEnd(code);
    }
    /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */ function resourceTitleAfter(code) {
        return (0, $74ae855ebddfe8fb$export$a30284361b3814b7)(code) ? (0, $143ad627545abc7e$export$1f27bd1aa33ce173)(effects, resourceEnd)(code) : resourceEnd(code);
    }
    /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceEnd(code) {
        if (code === 41) {
            effects.enter("resourceMarker");
            effects.consume(code);
            effects.exit("resourceMarker");
            effects.exit("resource");
            return ok;
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $9927ca4c0ce63c44$var$tokenizeReferenceFull(effects, ok, nok) {
    const self = this;
    return referenceFull;
    /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFull(code) {
        return (0, $ffc1da37451866a9$export$7b768614d8ba97a7).call(self, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code);
    }
    /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */ function referenceFullAfter(code) {
        return self.parser.defined.includes((0, $46d36bfd48dea0be$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) ? ok(code) : nok(code);
    }
    /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFullMissing(code) {
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $9927ca4c0ce63c44$var$tokenizeReferenceCollapsed(effects, ok, nok) {
    return referenceCollapsedStart;
    /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceCollapsedStart(code) {
        // We only attempt a collapsed label if there’s a `[`.
        effects.enter("reference");
        effects.enter("referenceMarker");
        effects.consume(code);
        effects.exit("referenceMarker");
        return referenceCollapsedOpen;
    }
    /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */ function referenceCollapsedOpen(code) {
        if (code === 93) {
            effects.enter("referenceMarker");
            effects.consume(code);
            effects.exit("referenceMarker");
            effects.exit("reference");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $fc05bd3663d4d8d5$export$3d754936e25aa5f5 = {
    name: "labelStartImage",
    tokenize: $fc05bd3663d4d8d5$var$tokenizeLabelStartImage,
    resolveAll: (0, $9927ca4c0ce63c44$export$470a5dafbbf62654).resolveAll
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $fc05bd3663d4d8d5$var$tokenizeLabelStartImage(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelImage");
        effects.enter("labelImageMarker");
        effects.consume(code);
        effects.exit("labelImageMarker");
        return open;
    }
    /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 91) {
            effects.enter("labelMarker");
            effects.consume(code);
            effects.exit("labelMarker");
            effects.exit("labelImage");
            return after;
        }
        return nok(code);
    }
    /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */ function after(code) {
        // To do: use a new field to do this, this is still needed for
        // `micromark-extension-gfm-footnote`, but the `label-start-link`
        // behavior isn’t.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && "_hiddenFootnoteSupport" in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $f2991591be5ba01b$export$5c0cee0701a3b584 = {
    name: "labelStartLink",
    tokenize: $f2991591be5ba01b$var$tokenizeLabelStartLink,
    resolveAll: (0, $9927ca4c0ce63c44$export$470a5dafbbf62654).resolveAll
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $f2991591be5ba01b$var$tokenizeLabelStartLink(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelLink");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelLink");
        return after;
    }
    /** @type {State} */ function after(code) {
        // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
        // remove.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && "_hiddenFootnoteSupport" in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $2535971b9b780153$export$8e62e0ad51c97b2 = {
    name: "lineEnding",
    tokenize: $2535971b9b780153$var$tokenizeLineEnding
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2535971b9b780153$var$tokenizeLineEnding(effects, ok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, ok, "linePrefix");
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 


/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $1f3bfc8d699cedf6$export$ba7b13e047416c03 = {
    name: "thematicBreak",
    tokenize: $1f3bfc8d699cedf6$var$tokenizeThematicBreak
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $1f3bfc8d699cedf6$var$tokenizeThematicBreak(effects, ok, nok) {
    let size = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("thematicBreak");
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        marker = code;
        return atBreak(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.enter("thematicBreakSequence");
            return sequence(code);
        }
        if (size >= 3 && (code === null || (0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code))) {
            effects.exit("thematicBreak");
            return ok(code);
        }
        return nok(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit("thematicBreakSequence");
        return (0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code) ? (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code) : atBreak(code);
    }
}


const $8f248106b94b4dad$export$8837f4fc672e936d = {
    name: "list",
    tokenize: $8f248106b94b4dad$var$tokenizeListStart,
    continuation: {
        tokenize: $8f248106b94b4dad$var$tokenizeListContinuation
    },
    exit: $8f248106b94b4dad$var$tokenizeListEnd
};
/** @type {Construct} */ const $8f248106b94b4dad$var$listItemPrefixWhitespaceConstruct = {
    tokenize: $8f248106b94b4dad$var$tokenizeListItemPrefixWhitespace,
    partial: true
};
/** @type {Construct} */ const $8f248106b94b4dad$var$indentConstruct = {
    tokenize: $8f248106b94b4dad$var$tokenizeIndent,
    partial: true
};
// To do: `markdown-rs` parses list items on their own and later stitches them
// together.
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $8f248106b94b4dad$var$tokenizeListStart(effects, ok, nok) {
    const self = this;
    const tail = self.events[self.events.length - 1];
    let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        const kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
        if (kind === "listUnordered" ? !self.containerState.marker || code === self.containerState.marker : (0, $74ae855ebddfe8fb$export$ca8b5b1a6c320e6e)(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === "listUnordered") {
                effects.enter("listItemPrefix");
                return code === 42 || code === 45 ? effects.check((0, $1f3bfc8d699cedf6$export$ba7b13e047416c03), nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter("listItemPrefix");
                effects.enter("listItemValue");
                return inside(code);
            }
        }
        return nok(code);
    }
    /** @type {State} */ function inside(code) {
        if ((0, $74ae855ebddfe8fb$export$ca8b5b1a6c320e6e)(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit("listItemValue");
            return atMarker(code);
        }
        return nok(code);
    }
    /**
   * @type {State}
   **/ function atMarker(code) {
        effects.enter("listItemMarker");
        effects.consume(code);
        effects.exit("listItemMarker");
        self.containerState.marker = self.containerState.marker || code;
        return effects.check((0, $464bca88fae6642a$export$d50d28ce3ab2a612), // Can’t be empty when interrupting.
        self.interrupt ? nok : onBlank, effects.attempt($8f248106b94b4dad$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    /** @type {State} */ function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    /** @type {State} */ function otherPrefix(code) {
        if ((0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code)) {
            effects.enter("listItemPrefixWhitespace");
            effects.consume(code);
            effects.exit("listItemPrefixWhitespace");
            return endOfPrefix;
        }
        return nok(code);
    }
    /** @type {State} */ function endOfPrefix(code) {
        self.containerState.size = initialSize + self.sliceSerialize(effects.exit("listItemPrefix"), true).length;
        return ok(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $8f248106b94b4dad$var$tokenizeListContinuation(effects, ok, nok) {
    const self = this;
    self.containerState._closeFlow = undefined;
    return effects.check((0, $464bca88fae6642a$export$d50d28ce3ab2a612), onBlank, notBlank);
    /** @type {State} */ function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine;
        // We have a blank line.
        // Still, try to consume at most the items size.
        return (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, ok, "listItemIndent", self.containerState.size + 1)(code);
    }
    /** @type {State} */ function notBlank(code) {
        if (self.containerState.furtherBlankLines || !(0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code)) {
            self.containerState.furtherBlankLines = undefined;
            self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = undefined;
        self.containerState.initialBlankLine = undefined;
        return effects.attempt($8f248106b94b4dad$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    /** @type {State} */ function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true;
        // As we’re closing flow, we’re no longer interrupting.
        self.interrupt = undefined;
        // Always populated by defaults.
        return (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, effects.attempt($8f248106b94b4dad$export$8837f4fc672e936d, ok, nok), "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $8f248106b94b4dad$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemIndent", self.containerState.size + 1);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self.containerState.size ? ok(code) : nok(code);
    }
}
/**
 * @type {Exiter}
 * @this {TokenizeContext}
 */ function $8f248106b94b4dad$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $8f248106b94b4dad$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    const self = this;
    // Always populated by defaults.
    return (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemPrefixWhitespace", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 5);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return !(0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $4faf9792c1bae140$export$e104e2de391dfde9 = {
    name: "setextUnderline",
    tokenize: $4faf9792c1bae140$var$tokenizeSetextUnderline,
    resolveTo: $4faf9792c1bae140$var$resolveToSetextUnderline
};
/** @type {Resolver} */ function $4faf9792c1bae140$var$resolveToSetextUnderline(events, context) {
    // To do: resolve like `markdown-rs`.
    let index = events.length;
    /** @type {number | undefined} */ let content;
    /** @type {number | undefined} */ let text;
    /** @type {number | undefined} */ let definition;
    // Find the opening of the content.
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === "enter") {
        if (events[index][1].type === "content") {
            content = index;
            break;
        }
        if (events[index][1].type === "paragraph") text = index;
    } else {
        if (events[index][1].type === "content") // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === "definition") definition = index;
    }
    const heading = {
        type: "setextHeading",
        start: Object.assign({}, events[text][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    // Change the paragraph to setext heading text.
    events[text][1].type = "setextHeadingText";
    // If we have definitions in the content, we’ll keep on having content,
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            "enter",
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            "exit",
            events[content][1],
            context
        ]);
        events[content][1].end = Object.assign({}, events[definition][1].end);
    } else events[content][1] = heading;
    // Add the heading exit at the end.
    events.push([
        "exit",
        heading,
        context
    ]);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $4faf9792c1bae140$var$tokenizeSetextUnderline(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        let index = self.events.length;
        /** @type {boolean | undefined} */ let paragraph;
        // Find an opening.
        while(index--)// Skip enter/exit of line ending, line prefix, and content.
        // We can now either have a definition or a paragraph.
        if (self.events[index][1].type !== "lineEnding" && self.events[index][1].type !== "linePrefix" && self.events[index][1].type !== "content") {
            paragraph = self.events[index][1].type === "paragraph";
            break;
        }
        // To do: handle lazy/pierce like `markdown-rs`.
        // To do: parse indent like `markdown-rs`.
        if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
            effects.enter("setextHeadingLine");
            marker = code;
            return before(code);
        }
        return nok(code);
    }
    /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("setextHeadingLineSequence");
        return inside(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        effects.exit("setextHeadingLineSequence");
        return (0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code) ? (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, after, "lineSuffix")(code) : after(code);
    }
    /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if (code === null || (0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            effects.exit("setextHeadingLine");
            return ok(code);
        }
        return nok(code);
    }
}



const $2708d814dd07d14e$export$5a7bfc01df82fcd1 = {
    [42]: (0, $8f248106b94b4dad$export$8837f4fc672e936d),
    [43]: (0, $8f248106b94b4dad$export$8837f4fc672e936d),
    [45]: (0, $8f248106b94b4dad$export$8837f4fc672e936d),
    [48]: (0, $8f248106b94b4dad$export$8837f4fc672e936d),
    [49]: (0, $8f248106b94b4dad$export$8837f4fc672e936d),
    [50]: (0, $8f248106b94b4dad$export$8837f4fc672e936d),
    [51]: (0, $8f248106b94b4dad$export$8837f4fc672e936d),
    [52]: (0, $8f248106b94b4dad$export$8837f4fc672e936d),
    [53]: (0, $8f248106b94b4dad$export$8837f4fc672e936d),
    [54]: (0, $8f248106b94b4dad$export$8837f4fc672e936d),
    [55]: (0, $8f248106b94b4dad$export$8837f4fc672e936d),
    [56]: (0, $8f248106b94b4dad$export$8837f4fc672e936d),
    [57]: (0, $8f248106b94b4dad$export$8837f4fc672e936d),
    [62]: (0, $ef9a2630bab0c827$export$200dcd0a5903c968)
};
const $2708d814dd07d14e$export$5a2181fb44b58173 = {
    [91]: (0, $7d7a6561e3000c7c$export$69f215ed977cdb73)
};
const $2708d814dd07d14e$export$cf8bead395eff824 = {
    [-2]: (0, $de6ae6e6a5e259d8$export$47910b7ab28d1853),
    [-1]: (0, $de6ae6e6a5e259d8$export$47910b7ab28d1853),
    [32]: (0, $de6ae6e6a5e259d8$export$47910b7ab28d1853)
};
const $2708d814dd07d14e$export$ccc7b0636abaffc3 = {
    [35]: (0, $2547c9aa83982ee7$export$3871e9deb360695c),
    [42]: (0, $1f3bfc8d699cedf6$export$ba7b13e047416c03),
    [45]: [
        (0, $4faf9792c1bae140$export$e104e2de391dfde9),
        (0, $1f3bfc8d699cedf6$export$ba7b13e047416c03)
    ],
    [60]: (0, $0d446361532d6fbe$export$476ac411cb7d0d8f),
    [61]: (0, $4faf9792c1bae140$export$e104e2de391dfde9),
    [95]: (0, $1f3bfc8d699cedf6$export$ba7b13e047416c03),
    [96]: (0, $23e8b02c6186c8d5$export$c23e4921f8d87e7c),
    [126]: (0, $23e8b02c6186c8d5$export$c23e4921f8d87e7c)
};
const $2708d814dd07d14e$export$22b082955e083ec3 = {
    [38]: (0, $034308c613320ed2$export$e31905600aaf3d8e),
    [92]: (0, $455b1f810d975361$export$2005478564e78d96)
};
const $2708d814dd07d14e$export$6f093cfa640b7166 = {
    [-5]: (0, $2535971b9b780153$export$8e62e0ad51c97b2),
    [-4]: (0, $2535971b9b780153$export$8e62e0ad51c97b2),
    [-3]: (0, $2535971b9b780153$export$8e62e0ad51c97b2),
    [33]: (0, $fc05bd3663d4d8d5$export$3d754936e25aa5f5),
    [38]: (0, $034308c613320ed2$export$e31905600aaf3d8e),
    [42]: (0, $7230a0c6174a6750$export$45b92471da762af7),
    [60]: [
        (0, $fec8b78d8ce85447$export$17ddf85e4c916ad6),
        (0, $37c6f077e7577d52$export$398af27f284914fe)
    ],
    [91]: (0, $f2991591be5ba01b$export$5c0cee0701a3b584),
    [92]: [
        (0, $df67ef7cc1bf6824$export$86c573ab9e06f418),
        (0, $455b1f810d975361$export$2005478564e78d96)
    ],
    [93]: (0, $9927ca4c0ce63c44$export$470a5dafbbf62654),
    [95]: (0, $7230a0c6174a6750$export$45b92471da762af7),
    [96]: (0, $da4255073b0f8c9c$export$d24f93e715f9df88)
};
const $2708d814dd07d14e$export$d44f260a3f9b69f5 = {
    null: [
        (0, $7230a0c6174a6750$export$45b92471da762af7),
        (0, $c9755994ad418fe0$export$50397835cbfdbc24)
    ]
};
const $2708d814dd07d14e$export$b9c0b60d74426aea = {
    null: [
        42,
        95
    ]
};
const $2708d814dd07d14e$export$e20fbacbb41798b = {
    null: []
};


function $e4d59b7116fe1ae9$export$98e6a39c04603d36(options) {
    const settings = options || {};
    const constructs = /** @type {FullNormalizedExtension} */ (0, $29c77022840ec938$export$86a865d89ef3c690)([
        $2708d814dd07d14e$exports,
        ...settings.extensions || []
    ]);
    /** @type {ParseContext} */ const parser = {
        defined: [],
        lazy: {},
        constructs: constructs,
        content: create((0, $39f0647f55776bd1$export$a7db06668cad9adb)),
        document: create((0, $9a319b10969f951c$export$5a7bfc01df82fcd1)),
        flow: create((0, $b7d003f6a78a4fb7$export$ccc7b0636abaffc3)),
        string: create((0, $c9755994ad418fe0$export$22b082955e083ec3)),
        text: create((0, $c9755994ad418fe0$export$6f093cfa640b7166))
    };
    return parser;
    /**
   * @param {InitialConstruct} initial
   */ function create(initial) {
        return creator;
        /** @type {Create} */ function creator(from) {
            return (0, $668a97eece5f50dd$export$ae34f10ee4b29837)(parser, initial, from);
        }
    }
}


/**
 * @typedef {import('micromark-util-types').Event} Event
 */ 
function $c18410cb499762d5$export$bd0e6e1378a871d7(events) {
    while(!(0, $849b4234cfb5fa8d$export$12949d1dd00fddf4)(events));
    return events;
}


/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Value} Value
 */ /**
 * @callback Preprocessor
 * @param {Value} value
 * @param {Encoding | null | undefined} [encoding]
 * @param {boolean | null | undefined} [end=false]
 * @returns {Array<Chunk>}
 */ const $c41a5643d6dc85da$var$search = /[\0\t\n\r]/g;
function $c41a5643d6dc85da$export$fc37fe19dfda43ee() {
    let column = 1;
    let buffer = "";
    /** @type {boolean | undefined} */ let start = true;
    /** @type {boolean | undefined} */ let atCarriageReturn;
    return preprocessor;
    /** @type {Preprocessor} */ // eslint-disable-next-line complexity
    function preprocessor(value, encoding, end) {
        /** @type {Array<Chunk>} */ const chunks = [];
        /** @type {RegExpMatchArray | null} */ let match;
        /** @type {number} */ let next;
        /** @type {number} */ let startPosition;
        /** @type {number} */ let endPosition;
        /** @type {Code} */ let code;
        value = buffer + (typeof value === "string" ? value.toString() : new TextDecoder(encoding || undefined).decode(value));
        startPosition = 0;
        buffer = "";
        if (start) {
            // To do: `markdown-rs` actually parses BOMs (byte order mark).
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $c41a5643d6dc85da$var$search.lastIndex = startPosition;
            match = $c41a5643d6dc85da$var$search.exec(value);
            endPosition = match && match.index !== undefined ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                switch(code){
                    case 0:
                        chunks.push(65533);
                        column++;
                        break;
                    case 9:
                        next = Math.ceil(column / 4) * 4;
                        chunks.push(-2);
                        while(column++ < next)chunks.push(-1);
                        break;
                    case 10:
                        chunks.push(-4);
                        column = 1;
                        break;
                    default:
                        atCarriageReturn = true;
                        column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}


function $2d90a42763806d27$export$eb6d260b88819962(value, encoding, options) {
    if (typeof encoding !== "string") {
        options = encoding;
        encoding = undefined;
    }
    return (0, $caf4caa13396207e$export$ef7acd7185315e22)(options)((0, $c18410cb499762d5$export$bd0e6e1378a871d7)((0, $e4d59b7116fe1ae9$export$98e6a39c04603d36)(options).document().write((0, $c41a5643d6dc85da$export$fc37fe19dfda43ee)()(value, encoding, true))));
}





const $85bea2252ff036be$var$characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $85bea2252ff036be$export$a0fb664af7d0cc44(value) {
    return value.replace($85bea2252ff036be$var$characterEscapeOrReference, $85bea2252ff036be$var$decode);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @param {string} $2
 * @returns {string}
 */ function $85bea2252ff036be$var$decode($0, $1, $2) {
    if ($1) // Escape.
    return $1;
    // Reference.
    const head = $2.charCodeAt(0);
    if (head === 35) {
        const head = $2.charCodeAt(1);
        const hex = head === 120 || head === 88;
        return (0, $6e75d5d6c969a16a$export$15a69557afac2c20)($2.slice(hex ? 2 : 1), hex ? 16 : 10);
    }
    return (0, $5e5977bcdef97531$export$289b6a6320f709b4)($2) || $0;
}





const $1542ab29d44f85a8$var$own = {}.hasOwnProperty;
function $1542ab29d44f85a8$export$d744d789c09bfde6(value, encoding, options) {
    if (typeof encoding !== "string") {
        options = encoding;
        encoding = undefined;
    }
    return $1542ab29d44f85a8$var$compiler(options)((0, $c18410cb499762d5$export$bd0e6e1378a871d7)((0, $e4d59b7116fe1ae9$export$98e6a39c04603d36)(options).document().write((0, $c41a5643d6dc85da$export$fc37fe19dfda43ee)()(value, encoding, true))));
}
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */ function $1542ab29d44f85a8$var$compiler(options) {
    /** @type {Config} */ const config = {
        transforms: [],
        canContainEols: [
            "emphasis",
            "fragment",
            "heading",
            "paragraph",
            "strong"
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    };
    $1542ab29d44f85a8$var$configure(config, (options || {}).mdastExtensions || []);
    /** @type {CompileData} */ const data = {};
    return compile;
    /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */ function compile(events) {
        /** @type {Root} */ let tree = {
            type: "root",
            children: []
        };
        /** @type {Omit<CompileContext, 'sliceSerialize'>} */ const context = {
            stack: [
                tree
            ],
            tokenStack: [],
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            data: data
        };
        /** @type {Array<number>} */ const listStack = [];
        let index = -1;
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
            if (events[index][0] === "enter") listStack.push(index);
            else {
                const tail = listStack.pop();
                index = prepareList(events, tail, index);
            }
        }
        index = -1;
        while(++index < events.length){
            const handler = config[events[index][0]];
            if ($1542ab29d44f85a8$var$own.call(handler, events[index][1].type)) handler[events[index][1].type].call(Object.assign({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        // Handle tokens still being open.
        if (context.tokenStack.length > 0) {
            const tail = context.tokenStack[context.tokenStack.length - 1];
            const handler = tail[1] || $1542ab29d44f85a8$var$defaultOnError;
            handler.call(context, undefined, tail[0]);
        }
        // Figure out `root` position.
        tree.position = {
            start: $1542ab29d44f85a8$var$point(events.length > 0 ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: $1542ab29d44f85a8$var$point(events.length > 0 ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        // Call transforms.
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */ function prepareList(events, start, length) {
        let index = start - 1;
        let containerBalance = -1;
        let listSpread = false;
        /** @type {Token | undefined} */ let listItem;
        /** @type {number | undefined} */ let lineIndex;
        /** @type {number | undefined} */ let firstBlankLineIndex;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index <= length){
            const event = events[index];
            switch(event[1].type){
                case "listUnordered":
                case "listOrdered":
                case "blockQuote":
                    if (event[0] === "enter") containerBalance++;
                    else containerBalance--;
                    atMarker = undefined;
                    break;
                case "lineEndingBlank":
                    if (event[0] === "enter") {
                        if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                        atMarker = undefined;
                    }
                    break;
                case "linePrefix":
                case "listItemValue":
                case "listItemMarker":
                case "listItemPrefix":
                case "listItemPrefixWhitespace":
                    break;
                default:
                    atMarker = undefined;
            }
            if (!containerBalance && event[0] === "enter" && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === "exit" && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
                if (listItem) {
                    let tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        const tailEvent = events[tailIndex];
                        if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
                            if (tailEvent[0] === "exit") continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = "lineEndingBlank";
                                listSpread = true;
                            }
                            tailEvent[1].type = "lineEnding";
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        "exit",
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === "listItemPrefix") {
                    /** @type {Token} */ const item = {
                        type: "listItem",
                        _spread: false,
                        start: Object.assign({}, event[1].start),
                        // @ts-expect-error: we’ll add `end` in a second.
                        end: undefined
                    };
                    listItem = item;
                    events.splice(index, 0, [
                        "enter",
                        item,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Nodes} create
   *   Create a node.
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function opener(create, and) {
        return open;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @returns {undefined}
   */ function buffer() {
        this.stack.push({
            type: "fragment",
            children: []
        });
    }
    /**
   * @this {CompileContext}
   *   Context.
   * @param {Nodes} node
   *   Node to enter.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnEnterError | undefined} [errorHandler]
   *   Handle the case where this token is open, but it is closed by something else.
   * @returns {undefined}
   *   Nothing.
   */ function enter(node, token, errorHandler) {
        const parent = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ const siblings = parent.children;
        siblings.push(node);
        this.stack.push(node);
        this.tokenStack.push([
            token,
            errorHandler
        ]);
        node.position = {
            start: $1542ab29d44f85a8$var$point(token.start),
            // @ts-expect-error: `end` will be patched later.
            end: undefined
        };
    }
    /**
   * Create a closer handle.
   *
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function closer(and) {
        return close;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   *   Context.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnExitError | undefined} [onExitError]
   *   Handle the case where another token is open.
   * @returns {undefined}
   *   Nothing.
   */ function exit(token, onExitError) {
        const node = this.stack.pop();
        const open = this.tokenStack.pop();
        if (!open) throw new Error("Cannot close `" + token.type + "` (" + (0, $21e5b9692333dcba$export$c304dd45fe166145)({
            start: token.start,
            end: token.end
        }) + "): it’s not open");
        else if (open[0].type !== token.type) {
            if (onExitError) onExitError.call(this, token, open[0]);
            else {
                const handler = open[1] || $1542ab29d44f85a8$var$defaultOnError;
                handler.call(this, token, open[0]);
            }
        }
        node.position.end = $1542ab29d44f85a8$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @returns {string}
   */ function resume() {
        return (0, $3ca019da562f1c43$export$f84e8e69fd4488a5)(this.stack.pop());
    }
    //
    // Handlers.
    //
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered() {
        this.data.expectingFirstListItemValue = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (this.data.expectingFirstListItemValue) {
            const ancestor = this.stack[this.stack.length - 2];
            ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
            this.data.expectingFirstListItemValue = undefined;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.lang = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfencemeta() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.meta = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (this.data.flowCodeInside) return;
        this.buffer();
        this.data.flowCodeInside = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefenced() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, "");
        this.data.flowCodeInside = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeindented() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/(\r?\n|\r)$/g, "");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.label = label;
        node.identifier = (0, $46d36bfd48dea0be$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        const node = this.stack[this.stack.length - 1];
        if (!node.depth) {
            const depth = this.sliceSerialize(token).length;
            node.depth = depth;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        this.data.setextHeadingSlurpLineEnding = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        const node = this.stack[this.stack.length - 1];
        node.depth = this.sliceSerialize(token).codePointAt(0) === 61 ? 1 : 2;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        this.data.setextHeadingSlurpLineEnding = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdata(token) {
        const node = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ const siblings = node.children;
        let tail = siblings[siblings.length - 1];
        if (!tail || tail.type !== "text") {
            // Add a new text node.
            tail = text();
            tail.position = {
                start: $1542ab29d44f85a8$var$point(token.start),
                // @ts-expect-error: we’ll add `end` later.
                end: undefined
            };
            siblings.push(tail);
        }
        this.stack.push(tail);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        const tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = $1542ab29d44f85a8$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        const context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (this.data.atHardBreak) {
            const tail = context.children[context.children.length - 1];
            tail.position.end = $1542ab29d44f85a8$var$point(token.end);
            this.data.atHardBreak = undefined;
            return;
        }
        if (!this.data.setextHeadingSlurpLineEnding && config.canContainEols.includes(context.type)) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        this.data.atHardBreak = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmlflow() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmltext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodetext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlink() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ const referenceType = this.data.referenceType || "shortcut";
            node.type += "Reference";
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitimage() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ const referenceType = this.data.referenceType || "shortcut";
            node.type += "Reference";
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        const string = this.sliceSerialize(token);
        const ancestor = this.stack[this.stack.length - 2];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        ancestor.label = (0, $85bea2252ff036be$export$a0fb664af7d0cc44)(string);
        // @ts-expect-error: same as above.
        ancestor.identifier = (0, $46d36bfd48dea0be$export$806d55e226cfcd08)(string).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        const fragment = this.stack[this.stack.length - 1];
        const value = this.resume();
        const node = this.stack[this.stack.length - 1];
        // Assume a reference.
        this.data.inReference = true;
        if (node.type === "link") {
            /** @type {Array<PhrasingContent>} */ const children = fragment.children;
            node.children = children;
        } else node.alt = value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresource() {
        this.data.inReference = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterreference() {
        this.data.referenceType = "collapsed";
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        node.label = label;
        // @ts-expect-error: same as above.
        node.identifier = (0, $46d36bfd48dea0be$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
        this.data.referenceType = "full";
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencemarker(token) {
        this.data.characterReferenceType = token.type;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const data = this.sliceSerialize(token);
        const type = this.data.characterReferenceType;
        /** @type {string} */ let value;
        if (type) {
            value = (0, $6e75d5d6c969a16a$export$15a69557afac2c20)(data, type === "characterReferenceMarkerNumeric" ? 10 : 16);
            this.data.characterReferenceType = undefined;
        } else {
            const result = (0, $5e5977bcdef97531$export$289b6a6320f709b4)(data);
            value = result;
        }
        const tail = this.stack.pop();
        tail.value += value;
        tail.position.end = $1542ab29d44f85a8$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = "mailto:" + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    /** @returns {Blockquote} */ function blockQuote() {
        return {
            type: "blockquote",
            children: []
        };
    }
    /** @returns {Code} */ function codeFlow() {
        return {
            type: "code",
            lang: null,
            meta: null,
            value: ""
        };
    }
    /** @returns {InlineCode} */ function codeText() {
        return {
            type: "inlineCode",
            value: ""
        };
    }
    /** @returns {Definition} */ function definition() {
        return {
            type: "definition",
            identifier: "",
            label: null,
            title: null,
            url: ""
        };
    }
    /** @returns {Emphasis} */ function emphasis() {
        return {
            type: "emphasis",
            children: []
        };
    }
    /** @returns {Heading} */ function heading() {
        return {
            type: "heading",
            // @ts-expect-error `depth` will be set later.
            depth: 0,
            children: []
        };
    }
    /** @returns {Break} */ function hardBreak() {
        return {
            type: "break"
        };
    }
    /** @returns {Html} */ function html() {
        return {
            type: "html",
            value: ""
        };
    }
    /** @returns {Image} */ function image() {
        return {
            type: "image",
            title: null,
            url: "",
            alt: null
        };
    }
    /** @returns {Link} */ function link() {
        return {
            type: "link",
            title: null,
            url: "",
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {List}
   */ function list(token) {
        return {
            type: "list",
            ordered: token.type === "listOrdered",
            start: null,
            spread: token._spread,
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {ListItem}
   */ function listItem(token) {
        return {
            type: "listItem",
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    /** @returns {Paragraph} */ function paragraph() {
        return {
            type: "paragraph",
            children: []
        };
    }
    /** @returns {Strong} */ function strong() {
        return {
            type: "strong",
            children: []
        };
    }
    /** @returns {Text} */ function text() {
        return {
            type: "text",
            value: ""
        };
    }
    /** @returns {ThematicBreak} */ function thematicBreak() {
        return {
            type: "thematicBreak"
        };
    }
}
/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */ function $1542ab29d44f85a8$var$point(d) {
    return {
        line: d.line,
        column: d.column,
        offset: d.offset
    };
}
/**
 * @param {Config} combined
 * @param {Array<Array<Extension> | Extension>} extensions
 * @returns {undefined}
 */ function $1542ab29d44f85a8$var$configure(combined, extensions) {
    let index = -1;
    while(++index < extensions.length){
        const value = extensions[index];
        if (Array.isArray(value)) $1542ab29d44f85a8$var$configure(combined, value);
        else $1542ab29d44f85a8$var$extension(combined, value);
    }
}
/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {undefined}
 */ function $1542ab29d44f85a8$var$extension(combined, extension) {
    /** @type {keyof Extension} */ let key;
    for(key in extension)if ($1542ab29d44f85a8$var$own.call(extension, key)) switch(key){
        case "canContainEols":
            {
                const right = extension[key];
                if (right) combined[key].push(...right);
                break;
            }
        case "transforms":
            {
                const right = extension[key];
                if (right) combined[key].push(...right);
                break;
            }
        case "enter":
        case "exit":
            {
                const right = extension[key];
                if (right) Object.assign(combined[key], right);
                break;
            }
    }
}
/** @type {OnEnterError} */ function $1542ab29d44f85a8$var$defaultOnError(left, right) {
    if (left) throw new Error("Cannot close `" + left.type + "` (" + (0, $21e5b9692333dcba$export$c304dd45fe166145)({
        start: left.start,
        end: left.end
    }) + "): a different token (`" + right.type + "`, " + (0, $21e5b9692333dcba$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ") is open");
    else throw new Error("Cannot close document, a token (`" + right.type + "`, " + (0, $21e5b9692333dcba$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ") is still open");
}


function $50644eab85d80578$export$2e2bcd8739ae039(options) {
    /** @type {Processor} */ // @ts-expect-error: TS in JSDoc generates wrong types if `this` is typed regularly.
    const self = this;
    self.parser = parser;
    /**
   * @type {Parser}
   */ function parser(doc) {
        return (0, $1542ab29d44f85a8$export$d744d789c09bfde6)(doc, {
            ...self.data("settings"),
            ...options,
            // Note: these options are not in the readme.
            // The goal is for them to be set by plugins on `data` instead of being
            // passed by users.
            extensions: self.data("micromarkExtensions") || [],
            mdastExtensions: self.data("fromMarkdownExtensions") || []
        });
    }
}


// Include `data` fields in mdast and `raw` nodes in hast.
/// <reference types="mdast-util-to-hast" />
/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('mdast-util-to-hast').Options} Options
 * @typedef {import('unified').Processor} Processor
 * @typedef {import('vfile').VFile} VFile
 */ /**
 * @callback TransformBridge
 *   Bridge-mode.
 *
 *   Runs the destination with the new hast tree.
 *   Discards result.
 * @param {MdastRoot} tree
 *   Tree.
 * @param {VFile} file
 *   File.
 * @returns {Promise<undefined>}
 *   Nothing.
 *
 * @callback TransformMutate
 *  Mutate-mode.
 *
 *  Further transformers run on the hast tree.
 * @param {MdastRoot} tree
 *   Tree.
 * @param {VFile} file
 *   File.
 * @returns {HastRoot}
 *   Tree (hast).
 */ /**
 * @typedef {import('hast').Nodes} HastNodes
 * @typedef {import('mdast').Nodes} MdastNodes
 * @typedef {import('./state.js').Options} Options
 */ 
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('./state.js').State} State
 */ /**
 * @callback FootnoteBackContentTemplate
 *   Generate content for the backreference dynamically.
 *
 *   For the following markdown:
 *
 *   ```markdown
 *   Alpha[^micromark], bravo[^micromark], and charlie[^remark].
 *
 *   [^remark]: things about remark
 *   [^micromark]: things about micromark
 *   ```
 *
 *   This function will be called with:
 *
 *   *  `0` and `0` for the backreference from `things about micromark` to
 *      `alpha`, as it is the first used definition, and the first call to it
 *   *  `0` and `1` for the backreference from `things about micromark` to
 *      `bravo`, as it is the first used definition, and the second call to it
 *   *  `1` and `0` for the backreference from `things about remark` to
 *      `charlie`, as it is the second used definition
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {Array<ElementContent> | ElementContent | string}
 *   Content for the backreference when linking back from definitions to their
 *   reference.
 *
 * @callback FootnoteBackLabelTemplate
 *   Generate a back label dynamically.
 *
 *   For the following markdown:
 *
 *   ```markdown
 *   Alpha[^micromark], bravo[^micromark], and charlie[^remark].
 *
 *   [^remark]: things about remark
 *   [^micromark]: things about micromark
 *   ```
 *
 *   This function will be called with:
 *
 *   *  `0` and `0` for the backreference from `things about micromark` to
 *      `alpha`, as it is the first used definition, and the first call to it
 *   *  `0` and `1` for the backreference from `things about micromark` to
 *      `bravo`, as it is the first used definition, and the second call to it
 *   *  `1` and `0` for the backreference from `things about remark` to
 *      `charlie`, as it is the second used definition
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {string}
 *   Back label to use when linking back from definitions to their reference.
 */ const $8bffa792e6f2cecd$export$1cd1943b3a73bbe8 = -1;
const $8bffa792e6f2cecd$export$a44b4f3d5b73db95 = 0;
const $8bffa792e6f2cecd$export$b119f07080a207ba = 1;
const $8bffa792e6f2cecd$export$8b8a958a7f6f130c = 2;
const $8bffa792e6f2cecd$export$501a7fac1df67a49 = 3;
const $8bffa792e6f2cecd$export$cd2b220b1ea851b2 = 4;
const $8bffa792e6f2cecd$export$ce970371e0e850bc = 5;
const $8bffa792e6f2cecd$export$5e8f180ef0142226 = 6;
const $8bffa792e6f2cecd$export$103bedf43ba882db = 7;
const $8bffa792e6f2cecd$export$9f2207c8fceeefa8 = 8; // export const SYMBOL = 9;


const $c10ee4c95fdbbdb8$var$env = typeof self === "object" ? self : globalThis;
const $c10ee4c95fdbbdb8$var$deserializer = ($, _)=>{
    const as = (out, index)=>{
        $.set(index, out);
        return out;
    };
    const unpair = (index)=>{
        if ($.has(index)) return $.get(index);
        const [type, value] = _[index];
        switch(type){
            case 0, $8bffa792e6f2cecd$export$a44b4f3d5b73db95:
            case 0, $8bffa792e6f2cecd$export$1cd1943b3a73bbe8:
                return as(value, index);
            case 0, $8bffa792e6f2cecd$export$b119f07080a207ba:
                {
                    const arr = as([], index);
                    for (const index of value)arr.push(unpair(index));
                    return arr;
                }
            case 0, $8bffa792e6f2cecd$export$8b8a958a7f6f130c:
                {
                    const object = as({}, index);
                    for (const [key, index] of value)object[unpair(key)] = unpair(index);
                    return object;
                }
            case 0, $8bffa792e6f2cecd$export$501a7fac1df67a49:
                return as(new Date(value), index);
            case 0, $8bffa792e6f2cecd$export$cd2b220b1ea851b2:
                {
                    const { source: source, flags: flags } = value;
                    return as(new RegExp(source, flags), index);
                }
            case 0, $8bffa792e6f2cecd$export$ce970371e0e850bc:
                {
                    const map = as(new Map, index);
                    for (const [key, index] of value)map.set(unpair(key), unpair(index));
                    return map;
                }
            case 0, $8bffa792e6f2cecd$export$5e8f180ef0142226:
                {
                    const set = as(new Set, index);
                    for (const index of value)set.add(unpair(index));
                    return set;
                }
            case 0, $8bffa792e6f2cecd$export$103bedf43ba882db:
                {
                    const { name: name, message: message } = value;
                    return as(new $c10ee4c95fdbbdb8$var$env[name](message), index);
                }
            case 0, $8bffa792e6f2cecd$export$9f2207c8fceeefa8:
                return as(BigInt(value), index);
            case "BigInt":
                return as(Object(BigInt(value)), index);
        }
        return as(new $c10ee4c95fdbbdb8$var$env[type](value), index);
    };
    return unpair;
};
const $c10ee4c95fdbbdb8$export$efcd34ab6248d3cd = (serialized)=>$c10ee4c95fdbbdb8$var$deserializer(new Map, serialized)(0);



const $0050b71aefc735a3$var$EMPTY = "";
const { toString: $0050b71aefc735a3$var$toString } = {};
const { keys: $0050b71aefc735a3$var$keys } = Object;
const $0050b71aefc735a3$var$typeOf = (value)=>{
    const type = typeof value;
    if (type !== "object" || !value) return [
        (0, $8bffa792e6f2cecd$export$a44b4f3d5b73db95),
        type
    ];
    const asString = $0050b71aefc735a3$var$toString.call(value).slice(8, -1);
    switch(asString){
        case "Array":
            return [
                (0, $8bffa792e6f2cecd$export$b119f07080a207ba),
                $0050b71aefc735a3$var$EMPTY
            ];
        case "Object":
            return [
                (0, $8bffa792e6f2cecd$export$8b8a958a7f6f130c),
                $0050b71aefc735a3$var$EMPTY
            ];
        case "Date":
            return [
                (0, $8bffa792e6f2cecd$export$501a7fac1df67a49),
                $0050b71aefc735a3$var$EMPTY
            ];
        case "RegExp":
            return [
                (0, $8bffa792e6f2cecd$export$cd2b220b1ea851b2),
                $0050b71aefc735a3$var$EMPTY
            ];
        case "Map":
            return [
                (0, $8bffa792e6f2cecd$export$ce970371e0e850bc),
                $0050b71aefc735a3$var$EMPTY
            ];
        case "Set":
            return [
                (0, $8bffa792e6f2cecd$export$5e8f180ef0142226),
                $0050b71aefc735a3$var$EMPTY
            ];
    }
    if (asString.includes("Array")) return [
        (0, $8bffa792e6f2cecd$export$b119f07080a207ba),
        asString
    ];
    if (asString.includes("Error")) return [
        (0, $8bffa792e6f2cecd$export$103bedf43ba882db),
        asString
    ];
    return [
        (0, $8bffa792e6f2cecd$export$8b8a958a7f6f130c),
        asString
    ];
};
const $0050b71aefc735a3$var$shouldSkip = ([TYPE, type])=>TYPE === (0, $8bffa792e6f2cecd$export$a44b4f3d5b73db95) && (type === "function" || type === "symbol");
const $0050b71aefc735a3$var$serializer = (strict, json, $, _)=>{
    const as = (out, value)=>{
        const index = _.push(out) - 1;
        $.set(value, index);
        return index;
    };
    const pair = (value)=>{
        if ($.has(value)) return $.get(value);
        let [TYPE, type] = $0050b71aefc735a3$var$typeOf(value);
        switch(TYPE){
            case 0, $8bffa792e6f2cecd$export$a44b4f3d5b73db95:
                {
                    let entry = value;
                    switch(type){
                        case "bigint":
                            TYPE = (0, $8bffa792e6f2cecd$export$9f2207c8fceeefa8);
                            entry = value.toString();
                            break;
                        case "function":
                        case "symbol":
                            if (strict) throw new TypeError("unable to serialize " + type);
                            entry = null;
                            break;
                        case "undefined":
                            return as([
                                (0, $8bffa792e6f2cecd$export$1cd1943b3a73bbe8)
                            ], value);
                    }
                    return as([
                        TYPE,
                        entry
                    ], value);
                }
            case 0, $8bffa792e6f2cecd$export$b119f07080a207ba:
                {
                    if (type) return as([
                        type,
                        [
                            ...value
                        ]
                    ], value);
                    const arr = [];
                    const index = as([
                        TYPE,
                        arr
                    ], value);
                    for (const entry of value)arr.push(pair(entry));
                    return index;
                }
            case 0, $8bffa792e6f2cecd$export$8b8a958a7f6f130c:
                {
                    if (type) switch(type){
                        case "BigInt":
                            return as([
                                type,
                                value.toString()
                            ], value);
                        case "Boolean":
                        case "Number":
                        case "String":
                            return as([
                                type,
                                value.valueOf()
                            ], value);
                    }
                    if (json && "toJSON" in value) return pair(value.toJSON());
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const key of $0050b71aefc735a3$var$keys(value))if (strict || !$0050b71aefc735a3$var$shouldSkip($0050b71aefc735a3$var$typeOf(value[key]))) entries.push([
                        pair(key),
                        pair(value[key])
                    ]);
                    return index;
                }
            case 0, $8bffa792e6f2cecd$export$501a7fac1df67a49:
                return as([
                    TYPE,
                    value.toISOString()
                ], value);
            case 0, $8bffa792e6f2cecd$export$cd2b220b1ea851b2:
                {
                    const { source: source, flags: flags } = value;
                    return as([
                        TYPE,
                        {
                            source: source,
                            flags: flags
                        }
                    ], value);
                }
            case 0, $8bffa792e6f2cecd$export$ce970371e0e850bc:
                {
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const [key, entry] of value)if (strict || !($0050b71aefc735a3$var$shouldSkip($0050b71aefc735a3$var$typeOf(key)) || $0050b71aefc735a3$var$shouldSkip($0050b71aefc735a3$var$typeOf(entry)))) entries.push([
                        pair(key),
                        pair(entry)
                    ]);
                    return index;
                }
            case 0, $8bffa792e6f2cecd$export$5e8f180ef0142226:
                {
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const entry of value)if (strict || !$0050b71aefc735a3$var$shouldSkip($0050b71aefc735a3$var$typeOf(entry))) entries.push(pair(entry));
                    return index;
                }
        }
        const { message: message } = value;
        return as([
            TYPE,
            {
                name: type,
                message: message
            }
        ], value);
    };
    return pair;
};
const $0050b71aefc735a3$export$dfdc1655ccc5b9cb = (value, { json: json, lossy: lossy } = {})=>{
    const _ = [];
    return $0050b71aefc735a3$var$serializer(!(json || lossy), !!json, new Map, _)(value), _;
};


var /**
 * @typedef {Array<string,any>} Record a type representation
 */ /**
 * Returns an array of serialized Records.
 * @param {any} any a serializable value.
 * @param {{transfer?: any[], json?: boolean, lossy?: boolean}?} options an object with
 * a transfer option (ignored when polyfilled) and/or non standard fields that
 * fallback to the polyfill if present.
 * @returns {Record[]}
 */ $bc3cd85dbe1274fe$export$2e2bcd8739ae039 = typeof structuredClone === "function" ? /* c8 ignore start */ (any, options)=>options && ("json" in options || "lossy" in options) ? (0, $c10ee4c95fdbbdb8$export$efcd34ab6248d3cd)((0, $0050b71aefc735a3$export$dfdc1655ccc5b9cb)(any, options)) : structuredClone(any) : (any, options)=>(0, $c10ee4c95fdbbdb8$export$efcd34ab6248d3cd)((0, $0050b71aefc735a3$export$dfdc1655ccc5b9cb)(any, options));



function $c344dd3971a437f6$export$4a6e1c4b9e5bc5d1(_, rereferenceIndex) {
    /** @type {Array<ElementContent>} */ const result = [
        {
            type: "text",
            value: "↩"
        }
    ];
    if (rereferenceIndex > 1) result.push({
        type: "element",
        tagName: "sup",
        properties: {},
        children: [
            {
                type: "text",
                value: String(rereferenceIndex)
            }
        ]
    });
    return result;
}
function $c344dd3971a437f6$export$d83e66a407212d3b(referenceIndex, rereferenceIndex) {
    return "Back to reference " + (referenceIndex + 1) + (rereferenceIndex > 1 ? "-" + rereferenceIndex : "");
}
function $c344dd3971a437f6$export$adb608be33961c98(state) {
    const clobberPrefix = typeof state.options.clobberPrefix === "string" ? state.options.clobberPrefix : "user-content-";
    const footnoteBackContent = state.options.footnoteBackContent || $c344dd3971a437f6$export$4a6e1c4b9e5bc5d1;
    const footnoteBackLabel = state.options.footnoteBackLabel || $c344dd3971a437f6$export$d83e66a407212d3b;
    const footnoteLabel = state.options.footnoteLabel || "Footnotes";
    const footnoteLabelTagName = state.options.footnoteLabelTagName || "h2";
    const footnoteLabelProperties = state.options.footnoteLabelProperties || {
        className: [
            "sr-only"
        ]
    };
    /** @type {Array<ElementContent>} */ const listItems = [];
    let referenceIndex = -1;
    while(++referenceIndex < state.footnoteOrder.length){
        const def = state.footnoteById.get(state.footnoteOrder[referenceIndex]);
        if (!def) continue;
        const content = state.all(def);
        const id = String(def.identifier).toUpperCase();
        const safeId = (0, $161d5a87d2da344f$export$e42a3e39590d28b5)(id.toLowerCase());
        let rereferenceIndex = 0;
        /** @type {Array<ElementContent>} */ const backReferences = [];
        const counts = state.footnoteCounts.get(id);
        // eslint-disable-next-line no-unmodified-loop-condition
        while(counts !== undefined && ++rereferenceIndex <= counts){
            if (backReferences.length > 0) backReferences.push({
                type: "text",
                value: " "
            });
            let children = typeof footnoteBackContent === "string" ? footnoteBackContent : footnoteBackContent(referenceIndex, rereferenceIndex);
            if (typeof children === "string") children = {
                type: "text",
                value: children
            };
            backReferences.push({
                type: "element",
                tagName: "a",
                properties: {
                    href: "#" + clobberPrefix + "fnref-" + safeId + (rereferenceIndex > 1 ? "-" + rereferenceIndex : ""),
                    dataFootnoteBackref: "",
                    ariaLabel: typeof footnoteBackLabel === "string" ? footnoteBackLabel : footnoteBackLabel(referenceIndex, rereferenceIndex),
                    className: [
                        "data-footnote-backref"
                    ]
                },
                children: Array.isArray(children) ? children : [
                    children
                ]
            });
        }
        const tail = content[content.length - 1];
        if (tail && tail.type === "element" && tail.tagName === "p") {
            const tailTail = tail.children[tail.children.length - 1];
            if (tailTail && tailTail.type === "text") tailTail.value += " ";
            else tail.children.push({
                type: "text",
                value: " "
            });
            tail.children.push(...backReferences);
        } else content.push(...backReferences);
        /** @type {Element} */ const listItem = {
            type: "element",
            tagName: "li",
            properties: {
                id: clobberPrefix + "fn-" + safeId
            },
            children: state.wrap(content, true)
        };
        state.patch(def, listItem);
        listItems.push(listItem);
    }
    if (listItems.length === 0) return;
    return {
        type: "element",
        tagName: "section",
        properties: {
            dataFootnotes: true,
            className: [
                "footnotes"
            ]
        },
        children: [
            {
                type: "element",
                tagName: footnoteLabelTagName,
                properties: {
                    ...(0, $bc3cd85dbe1274fe$export$2e2bcd8739ae039)(footnoteLabelProperties),
                    id: "footnote-label"
                },
                children: [
                    {
                        type: "text",
                        value: footnoteLabel
                    }
                ]
            },
            {
                type: "text",
                value: "\n"
            },
            {
                type: "element",
                tagName: "ol",
                properties: {},
                children: state.wrap(listItems, true)
            },
            {
                type: "text",
                value: "\n"
            }
        ]
    };
}


/**
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').ElementContent} HastElementContent
 * @typedef {import('hast').Nodes} HastNodes
 * @typedef {import('hast').Properties} HastProperties
 * @typedef {import('hast').RootContent} HastRootContent
 * @typedef {import('hast').Text} HastText
 *
 * @typedef {import('mdast').Definition} MdastDefinition
 * @typedef {import('mdast').FootnoteDefinition} MdastFootnoteDefinition
 * @typedef {import('mdast').Nodes} MdastNodes
 * @typedef {import('mdast').Parents} MdastParents
 *
 * @typedef {import('./footer.js').FootnoteBackContentTemplate} FootnoteBackContentTemplate
 * @typedef {import('./footer.js').FootnoteBackLabelTemplate} FootnoteBackLabelTemplate
 */ /**
 * @callback Handler
 *   Handle a node.
 * @param {State} state
 *   Info passed around.
 * @param {any} node
 *   mdast node to handle.
 * @param {MdastParents | undefined} parent
 *   Parent of `node`.
 * @returns {Array<HastElementContent> | HastElementContent | undefined}
 *   hast node.
 *
 * @typedef {Partial<Record<MdastNodes['type'], Handler>>} Handlers
 *   Handle nodes.
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [allowDangerousHtml=false]
 *   Whether to persist raw HTML in markdown in the hast tree (default:
 *   `false`).
 * @property {string | null | undefined} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` property on footnotes to prevent them from
 *   *clobbering* (default: `'user-content-'`).
 *
 *   Pass `''` for trusted markdown and when you are careful with
 *   polyfilling.
 *   You could pass a different prefix.
 *
 *   DOM clobbering is this:
 *
 *   ```html
 *   <p id="x"></p>
 *   <script>alert(x) // `x` now refers to the `p#x` DOM element</script>
 *   ```
 *
 *   The above example shows that elements are made available by browsers, by
 *   their ID, on the `window` object.
 *   This is a security risk because you might be expecting some other variable
 *   at that place.
 *   It can also break polyfills.
 *   Using a prefix solves these problems.
 * @property {FootnoteBackContentTemplate | string | null | undefined} [footnoteBackContent]
 *   Content of the backreference back to references (default: `defaultFootnoteBackContent`).
 *
 *   The default value is:
 *
 *   ```js
 *   function defaultFootnoteBackContent(_, rereferenceIndex) {
 *     const result = [{type: 'text', value: '↩'}]
 *
 *     if (rereferenceIndex > 1) {
 *       result.push({
 *         type: 'element',
 *         tagName: 'sup',
 *         properties: {},
 *         children: [{type: 'text', value: String(rereferenceIndex)}]
 *       })
 *     }
 *
 *     return result
 *   }
 *   ```
 *
 *   This content is used in the `a` element of each backreference (the `↩`
 *   links).
 * @property {FootnoteBackLabelTemplate | string | null | undefined} [footnoteBackLabel]
 *   Label to describe the backreference back to references (default:
 *   `defaultFootnoteBackLabel`).
 *
 *   The default value is:
 *
 *   ```js
 *   function defaultFootnoteBackLabel(referenceIndex, rereferenceIndex) {
 *    return (
 *      'Back to reference ' +
 *      (referenceIndex + 1) +
 *      (rereferenceIndex > 1 ? '-' + rereferenceIndex : '')
 *    )
 *   }
 *   ```
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is used in the `ariaLabel` property on each backreference
 *   (the `↩` links).
 *   It affects users of assistive technology.
 * @property {string | null | undefined} [footnoteLabel='Footnotes']
 *   Textual label to use for the footnotes section (default: `'Footnotes'`).
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different properties with the `footnoteLabelProperties` option.
 * @property {HastProperties | null | undefined} [footnoteLabelProperties={className: ['sr-only']}]
 *   Properties to use on the footnote label (default: `{className:
 *   ['sr-only']}`).
 *
 *   Change it to show the label and add other properties.
 *
 *   This label is typically hidden visually (assuming an `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass an empty string.
 *   You can also add different properties.
 *
 *   > 👉 **Note**: `id: 'footnote-label'` is always added, because footnote
 *   > calls use it with `aria-describedby` to provide an accessible label.
 * @property {string | null | undefined} [footnoteLabelTagName='h2']
 *   HTML tag name to use for the footnote label element (default: `'h2'`).
 *
 *   Change it to match your document structure.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different properties with the `footnoteLabelProperties` option.
 * @property {Handlers | null | undefined} [handlers]
 *   Extra handlers for nodes (optional).
 * @property {Array<MdastNodes['type']> | null | undefined} [passThrough]
 *   List of custom mdast node types to pass through (keep) in hast (note that
 *   the node itself is passed, but eventual children are transformed)
 *   (optional).
 * @property {Handler | null | undefined} [unknownHandler]
 *   Handler for all unknown nodes (optional).
 *
 * @typedef State
 *   Info passed around.
 * @property {(node: MdastNodes) => Array<HastElementContent>} all
 *   Transform the children of an mdast parent to hast.
 * @property {<Type extends HastNodes>(from: MdastNodes, to: Type) => HastElement | Type} applyData
 *   Honor the `data` of `from`, and generate an element instead of `node`.
 * @property {Map<string, MdastDefinition>} definitionById
 *   Definitions by their identifier.
 * @property {Map<string, MdastFootnoteDefinition>} footnoteById
 *   Footnote definitions by their identifier.
 * @property {Map<string, number>} footnoteCounts
 *   Counts for how often the same footnote was called.
 * @property {Array<string>} footnoteOrder
 *   Identifiers of order when footnote calls first appear in tree order.
 * @property {Handlers} handlers
 *   Applied handlers.
 * @property {(node: MdastNodes, parent: MdastParents | undefined) => Array<HastElementContent> | HastElementContent | undefined} one
 *   Transform an mdast node to hast.
 * @property {Options} options
 *   Configuration.
 * @property {(from: MdastNodes, node: HastNodes) => undefined} patch
 *   Copy a node’s positional info.
 * @property {<Type extends HastRootContent>(nodes: Array<Type>, loose?: boolean | undefined) => Array<HastText | Type>} wrap
 *   Wrap `nodes` with line endings between each node, adds initial/final line endings when `loose`.
 */ 
/**
 * @typedef {import('unist').Node} UnistNode
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ // To do: use types from `unist-util-visit-parents` when it’s released.
/**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends Array<any>
 *   ? MatchesOne<Value, Check[keyof Check]>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends UnistNode ? number | undefined : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends UnistParent ? Ancestor | undefined : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [Ancestor=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Visited, Parent<Ancestor, Visited>>} BuildVisitorFromMatch
 *   Build a typed `Visitor` function from a node and all possible parents.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Visited
 *   Node type.
 * @template {UnistParent} Ancestor
 *   Parent type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     Matches<Descendant, Check>,
 *     Extract<Descendant, UnistParent>
 *   >
 * )} BuildVisitorFromDescendants
 *   Build a typed `Visitor` function from a list of descendants and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Node type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ /**
 * @typedef {import('unist').Node} UnistNode
 * @typedef {import('unist').Parent} UnistParent
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ /**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends Array<any>
 *   ? MatchesOne<Value, Check[keyof Check]>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {InternalAncestor<InclusiveDescendant<Tree>, Child>} Ancestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {'skip' | boolean} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<VisitedParents>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [VisitedParents=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Matches<InclusiveDescendant<Tree>, Check>, Ancestor<Tree, Matches<InclusiveDescendant<Tree>, Check>>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Tree type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 */ /**
 * @template Fn
 * @template Fallback
 * @typedef {Fn extends (value: any) => value is infer Thing ? Thing : Fallback} Predicate
 */ /**
 * @callback Check
 *   Check that an arbitrary value is a node.
 * @param {unknown} this
 *   The given context.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 *
 * @typedef {Record<string, unknown> | Node} Props
 *   Object to check for equivalence.
 *
 *   Note: `Node` is included as it is common but is not indexable.
 *
 * @typedef {Array<Props | TestFunction | string> | Props | TestFunction | string | null | undefined} Test
 *   Check for an arbitrary node.
 *
 * @callback TestFunction
 *   Check if a node passes a test.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | undefined | void}
 *   Whether this node passes the test.
 *
 *   Note: `void` is included until TS sees no return as `undefined`.
 */ /**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param {unknown} node
 *   Thing to check, typically `Node`.
 * @param {Test} test
 *   A check for a specific node.
 * @param {number | null | undefined} index
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} parent
 *   The node’s parent.
 * @param {unknown} context
 *   Context object (`this`) to pass to `test` functions.
 * @returns {boolean}
 *   Whether `node` is a node and passes a test.
 */ const $a74142eedbb1409b$export$226b3eccf92c9ed9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends string>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((node?: null | undefined) => false) &
   *   ((node: unknown, test?: null | undefined, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((node: unknown, test?: Test, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function(node, test, index, parent, context) {
    const check = $a74142eedbb1409b$export$9c68d69a4c5bbcf9(test);
    if (index !== undefined && index !== null && (typeof index !== "number" || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error("Expected positive finite index");
    if (parent !== undefined && parent !== null && (!$a74142eedbb1409b$export$226b3eccf92c9ed9(parent) || !parent.children)) throw new Error("Expected parent node");
    if ((parent === undefined || parent === null) !== (index === undefined || index === null)) throw new Error("Expected both parent and index");
    return $a74142eedbb1409b$var$looksLikeANode(node) ? check.call(context, node, index, parent) : false;
};
const $a74142eedbb1409b$export$9c68d69a4c5bbcf9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */ /**
     * @param {Test} [test]
     * @returns {Check}
     */ function(test) {
    if (test === null || test === undefined) return $a74142eedbb1409b$var$ok;
    if (typeof test === "function") return $a74142eedbb1409b$var$castFactory(test);
    if (typeof test === "object") return Array.isArray(test) ? $a74142eedbb1409b$var$anyFactory(test) : $a74142eedbb1409b$var$propsFactory(test);
    if (typeof test === "string") return $a74142eedbb1409b$var$typeFactory(test);
    throw new Error("Expected function, string, or object as test");
};
/**
 * @param {Array<Props | TestFunction | string>} tests
 * @returns {Check}
 */ function $a74142eedbb1409b$var$anyFactory(tests) {
    /** @type {Array<Check>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $a74142eedbb1409b$export$9c68d69a4c5bbcf9(tests[index]);
    return $a74142eedbb1409b$var$castFactory(any);
    /**
   * @this {unknown}
   * @type {TestFunction}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].apply(this, parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {Check}
 */ function $a74142eedbb1409b$var$propsFactory(check) {
    const checkAsRecord = /** @type {Record<string, unknown>} */ check;
    return $a74142eedbb1409b$var$castFactory(all);
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function all(node) {
        const nodeAsRecord = /** @type {Record<string, unknown>} */ /** @type {unknown} */ node;
        /** @type {string} */ let key;
        for(key in check){
            if (nodeAsRecord[key] !== checkAsRecord[key]) return false;
        }
        return true;
    }
}
/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {Check}
 */ function $a74142eedbb1409b$var$typeFactory(check) {
    return $a74142eedbb1409b$var$castFactory(type);
    /**
   * @param {Node} node
   */ function type(node) {
        return node && node.type === check;
    }
}
/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunction} testFunction
 * @returns {Check}
 */ function $a74142eedbb1409b$var$castFactory(testFunction) {
    return check;
    /**
   * @this {unknown}
   * @type {Check}
   */ function check(value, index, parent) {
        return Boolean($a74142eedbb1409b$var$looksLikeANode(value) && testFunction.call(this, value, typeof index === "number" ? index : undefined, parent || undefined));
    }
}
function $a74142eedbb1409b$var$ok() {
    return true;
}
/**
 * @param {unknown} value
 * @returns {value is Node}
 */ function $a74142eedbb1409b$var$looksLikeANode(value) {
    return value !== null && typeof value === "object" && "type" in value;
}


/**
 * @param {string} d
 * @returns {string}
 */ function $953db9da902056bf$export$35e9368ef982300f(d) {
    return d;
}


/** @type {Readonly<ActionTuple>} */ const $12fffbe49747f304$var$empty = [];
const $12fffbe49747f304$export$f4d8133c446fe484 = true;
const $12fffbe49747f304$export$7f100f842f565dc9 = false;
const $12fffbe49747f304$export$8773f85c2fb2c116 = "skip";
function $12fffbe49747f304$export$70008a21eb6de899(tree, test, visitor, reverse) {
    /** @type {Test} */ let check;
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
    } else // @ts-expect-error visitor given, so `test` isn’t a visitor.
    check = test;
    const is = (0, $a74142eedbb1409b$export$9c68d69a4c5bbcf9)(check);
    const step = reverse ? -1 : 1;
    factory(tree, undefined, [])();
    /**
   * @param {UnistNode} node
   * @param {number | undefined} index
   * @param {Array<UnistParent>} parents
   */ function factory(node, index, parents) {
        const value = /** @type {Record<string, unknown>} */ node && typeof node === "object" ? node : {};
        if (typeof value.type === "string") {
            const name = // `hast`
            typeof value.tagName === "string" ? value.tagName : typeof value.name === "string" ? value.name : undefined;
            Object.defineProperty(visit, "name", {
                value: "node (" + (0, $953db9da902056bf$export$35e9368ef982300f)(node.type + (name ? "<" + name + ">" : "")) + ")"
            });
        }
        return visit;
        function visit() {
            /** @type {Readonly<ActionTuple>} */ let result = $12fffbe49747f304$var$empty;
            /** @type {Readonly<ActionTuple>} */ let subresult;
            /** @type {number} */ let offset;
            /** @type {Array<UnistParent>} */ let grandparents;
            if (!test || is(node, index, parents[parents.length - 1] || undefined)) {
                // @ts-expect-error: `visitor` is now a visitor.
                result = $12fffbe49747f304$var$toResult(visitor(node, parents));
                if (result[0] === $12fffbe49747f304$export$7f100f842f565dc9) return result;
            }
            if ("children" in node && node.children) {
                const nodeAsParent = /** @type {UnistParent} */ node;
                if (nodeAsParent.children && result[0] !== $12fffbe49747f304$export$8773f85c2fb2c116) {
                    offset = (reverse ? nodeAsParent.children.length : -1) + step;
                    grandparents = parents.concat(nodeAsParent);
                    while(offset > -1 && offset < nodeAsParent.children.length){
                        const child = nodeAsParent.children[offset];
                        subresult = factory(child, offset, grandparents)();
                        if (subresult[0] === $12fffbe49747f304$export$7f100f842f565dc9) return subresult;
                        offset = typeof subresult[1] === "number" ? subresult[1] : offset + step;
                    }
                }
            }
            return result;
        }
    }
}
/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {Readonly<ActionTuple>}
 *   Clean result.
 */ function $12fffbe49747f304$var$toResult(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === "number") return [
        $12fffbe49747f304$export$f4d8133c446fe484,
        value
    ];
    return value === null || value === undefined ? $12fffbe49747f304$var$empty : [
        value
    ];
}


function $54f08257f9dfe0bf$export$bf638b60ea8b89b7(tree, testOrVisitor, visitorOrReverse, maybeReverse) {
    /** @type {boolean | null | undefined} */ let reverse;
    /** @type {Test} */ let test;
    /** @type {Visitor} */ let visitor;
    if (typeof testOrVisitor === "function" && typeof visitorOrReverse !== "function") {
        test = undefined;
        visitor = testOrVisitor;
        reverse = visitorOrReverse;
    } else {
        // @ts-expect-error: assume the overload with test was given.
        test = testOrVisitor;
        // @ts-expect-error: assume the overload with test was given.
        visitor = visitorOrReverse;
        reverse = maybeReverse;
    }
    (0, $12fffbe49747f304$export$70008a21eb6de899)(tree, test, overload, reverse);
    /**
   * @param {UnistNode} node
   * @param {Array<UnistParent>} parents
   */ function overload(node, parents) {
        const parent = parents[parents.length - 1];
        const index = parent ? parent.children.indexOf(node) : undefined;
        return visitor(node, index, parent);
    }
}



/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $955a47ac5d47075f$export$67dc04e652a298ca(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "blockquote",
        properties: {},
        children: state.wrap(state.all(node), true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').Break} Break
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $587086a72aee5766$export$371da9dd35aba193(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "br",
        properties: {},
        children: []
    };
    state.patch(node, result);
    return [
        state.applyData(node, result),
        {
            type: "text",
            value: "\n"
        }
    ];
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Code} Code
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $1364b9893259ecfc$export$6565f9f03506010b(state, node) {
    const value = node.value ? node.value + "\n" : "";
    /** @type {Properties} */ const properties = {};
    if (node.lang) properties.className = [
        "language-" + node.lang
    ];
    // Create `<code>`.
    /** @type {Element} */ let result = {
        type: "element",
        tagName: "code",
        properties: properties,
        children: [
            {
                type: "text",
                value: value
            }
        ]
    };
    if (node.meta) result.data = {
        meta: node.meta
    };
    state.patch(node, result);
    result = state.applyData(node, result);
    // Create `<pre>`.
    result = {
        type: "element",
        tagName: "pre",
        properties: {},
        children: [
            result
        ]
    };
    state.patch(node, result);
    return result;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Delete} Delete
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $cc1c6c8222e6a677$export$19426ff118fe8be(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "del",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $7a74bf776bd11ea0$export$bef81ba411953b51(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "em",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('../state.js').State} State
 */ 
function $06c3f4293e8f167d$export$7f87ee744075c1ba(state, node) {
    const clobberPrefix = typeof state.options.clobberPrefix === "string" ? state.options.clobberPrefix : "user-content-";
    const id = String(node.identifier).toUpperCase();
    const safeId = (0, $161d5a87d2da344f$export$e42a3e39590d28b5)(id.toLowerCase());
    const index = state.footnoteOrder.indexOf(id);
    /** @type {number} */ let counter;
    let reuseCounter = state.footnoteCounts.get(id);
    if (reuseCounter === undefined) {
        reuseCounter = 0;
        state.footnoteOrder.push(id);
        counter = state.footnoteOrder.length;
    } else counter = index + 1;
    reuseCounter += 1;
    state.footnoteCounts.set(id, reuseCounter);
    /** @type {Element} */ const link = {
        type: "element",
        tagName: "a",
        properties: {
            href: "#" + clobberPrefix + "fn-" + safeId,
            id: clobberPrefix + "fnref-" + safeId + (reuseCounter > 1 ? "-" + reuseCounter : ""),
            dataFootnoteRef: true,
            ariaDescribedBy: [
                "footnote-label"
            ]
        },
        children: [
            {
                type: "text",
                value: String(counter)
            }
        ]
    };
    state.patch(node, link);
    /** @type {Element} */ const sup = {
        type: "element",
        tagName: "sup",
        properties: {},
        children: [
            link
        ]
    };
    state.patch(node, sup);
    return state.applyData(node, sup);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $ca875ea98ccc9de9$export$46e4a324ac90507f(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "h" + node.depth,
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Html} Html
 * @typedef {import('../state.js').State} State
 * @typedef {import('../../index.js').Raw} Raw
 */ // Make VS Code show references to the above types.
"";
function $e5a69249dd3a730e$export$c0bb0b647f701bb5(state, node) {
    if (state.options.allowDangerousHtml) {
        /** @type {Raw} */ const result = {
            type: "raw",
            value: node.value
        };
        state.patch(node, result);
        return state.applyData(node, result);
    }
    return undefined;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('../state.js').State} State
 */ 
/**
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('mdast').Nodes} Nodes
 * @typedef {import('mdast').Reference} Reference
 *
 * @typedef {import('./state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $c78a924c7f0df703$export$3fdd26f3d9e7dc78(state, node) {
    const subtype = node.referenceType;
    let suffix = "]";
    if (subtype === "collapsed") suffix += "[]";
    else if (subtype === "full") suffix += "[" + (node.label || node.identifier) + "]";
    if (node.type === "imageReference") return [
        {
            type: "text",
            value: "![" + node.alt + suffix
        }
    ];
    const contents = state.all(node);
    const head = contents[0];
    if (head && head.type === "text") head.value = "[" + head.value;
    else contents.unshift({
        type: "text",
        value: "["
    });
    const tail = contents[contents.length - 1];
    if (tail && tail.type === "text") tail.value += suffix;
    else contents.push({
        type: "text",
        value: suffix
    });
    return contents;
}


function $d3cdbb7b702a330a$export$f281796f6bc3b8db(state, node) {
    const id = String(node.identifier).toUpperCase();
    const def = state.definitionById.get(id);
    if (!def) return (0, $c78a924c7f0df703$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        src: (0, $161d5a87d2da344f$export$e42a3e39590d28b5)(def.url || ""),
        alt: node.alt
    };
    if (def.title !== null && def.title !== undefined) properties.title = def.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "img",
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Image} Image
 * @typedef {import('../state.js').State} State
 */ 
function $baa57df20c585b81$export$5c452ff88e35e47d(state, node) {
    /** @type {Properties} */ const properties = {
        src: (0, $161d5a87d2da344f$export$e42a3e39590d28b5)(node.url)
    };
    if (node.alt !== null && node.alt !== undefined) properties.alt = node.alt;
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "img",
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $64acbf4cd1f309e2$export$91b9bee19a0d8569(state, node) {
    /** @type {Text} */ const text = {
        type: "text",
        value: node.value.replace(/\r?\n|\r/g, " ")
    };
    state.patch(node, text);
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "code",
        properties: {},
        children: [
            text
        ]
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('../state.js').State} State
 */ 

function $b5cb1998deb8661e$export$e6c469b1b7b2bc6a(state, node) {
    const id = String(node.identifier).toUpperCase();
    const def = state.definitionById.get(id);
    if (!def) return (0, $c78a924c7f0df703$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        href: (0, $161d5a87d2da344f$export$e42a3e39590d28b5)(def.url || "")
    };
    if (def.title !== null && def.title !== undefined) properties.title = def.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "a",
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Link} Link
 * @typedef {import('../state.js').State} State
 */ 
function $e36121a4112384ee$export$9c30223ca0a664fb(state, node) {
    /** @type {Properties} */ const properties = {
        href: (0, $161d5a87d2da344f$export$e42a3e39590d28b5)(node.url)
    };
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "a",
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $973a676b399e8414$export$76c7e83ecc9cdf05(state, node, parent) {
    const results = state.all(node);
    const loose = parent ? $973a676b399e8414$var$listLoose(parent) : $973a676b399e8414$var$listItemLoose(node);
    /** @type {Properties} */ const properties = {};
    /** @type {Array<ElementContent>} */ const children = [];
    if (typeof node.checked === "boolean") {
        const head = results[0];
        /** @type {Element} */ let paragraph;
        if (head && head.type === "element" && head.tagName === "p") paragraph = head;
        else {
            paragraph = {
                type: "element",
                tagName: "p",
                properties: {},
                children: []
            };
            results.unshift(paragraph);
        }
        if (paragraph.children.length > 0) paragraph.children.unshift({
            type: "text",
            value: " "
        });
        paragraph.children.unshift({
            type: "element",
            tagName: "input",
            properties: {
                type: "checkbox",
                checked: node.checked,
                disabled: true
            },
            children: []
        });
        // According to github-markdown-css, this class hides bullet.
        // See: <https://github.com/sindresorhus/github-markdown-css>.
        properties.className = [
            "task-list-item"
        ];
    }
    let index = -1;
    while(++index < results.length){
        const child = results[index];
        // Add eols before nodes, except if this is a loose, first paragraph.
        if (loose || index !== 0 || child.type !== "element" || child.tagName !== "p") children.push({
            type: "text",
            value: "\n"
        });
        if (child.type === "element" && child.tagName === "p" && !loose) children.push(...child.children);
        else children.push(child);
    }
    const tail = results[results.length - 1];
    // Add a final eol.
    if (tail && (loose || tail.type !== "element" || tail.tagName !== "p")) children.push({
        type: "text",
        value: "\n"
    });
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "li",
        properties: properties,
        children: children
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
/**
 * @param {Parents} node
 * @return {Boolean}
 */ function $973a676b399e8414$var$listLoose(node) {
    let loose = false;
    if (node.type === "list") {
        loose = node.spread || false;
        const children = node.children;
        let index = -1;
        while(!loose && ++index < children.length)loose = $973a676b399e8414$var$listItemLoose(children[index]);
    }
    return loose;
}
/**
 * @param {ListItem} node
 * @return {Boolean}
 */ function $973a676b399e8414$var$listItemLoose(node) {
    const spread = node.spread;
    return spread === null || spread === undefined ? node.children.length > 1 : spread;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').List} List
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $4b18885aa5092364$export$8837f4fc672e936d(state, node) {
    /** @type {Properties} */ const properties = {};
    const results = state.all(node);
    let index = -1;
    if (typeof node.start === "number" && node.start !== 1) properties.start = node.start;
    // Like GitHub, add a class for custom styling.
    while(++index < results.length){
        const child = results[index];
        if (child.type === "element" && child.tagName === "li" && child.properties && Array.isArray(child.properties.className) && child.properties.className.includes("task-list-item")) {
            properties.className = [
                "contains-task-list"
            ];
            break;
        }
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: node.ordered ? "ol" : "ul",
        properties: properties,
        children: state.wrap(results, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $4f2858c23833dade$export$9c206ddddb32a9b(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "p",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Parents} HastParents
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $80cb2e892a9dc435$export$e8e78c978b129247(state, node) {
    /** @type {HastRoot} */ const result = {
        type: "root",
        children: state.wrap(state.all(node))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $64c123d6c0e3bb7f$export$59ae2c325a998f89(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "strong",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Table} Table
 * @typedef {import('../state.js').State} State
 */ 
function $c2e9ff9d07cbac9e$export$9852986a3ec5f6a0(state, node) {
    const rows = state.all(node);
    const firstRow = rows.shift();
    /** @type {Array<Element>} */ const tableContent = [];
    if (firstRow) {
        /** @type {Element} */ const head = {
            type: "element",
            tagName: "thead",
            properties: {},
            children: state.wrap([
                firstRow
            ], true)
        };
        state.patch(node.children[0], head);
        tableContent.push(head);
    }
    if (rows.length > 0) {
        /** @type {Element} */ const body = {
            type: "element",
            tagName: "tbody",
            properties: {},
            children: state.wrap(rows, true)
        };
        const start = (0, $a349554b0943c73d$export$771bf3e4949bfbee)(node.children[1]);
        const end = (0, $a349554b0943c73d$export$da309cdce9dc2a25)(node.children[node.children.length - 1]);
        if (start && end) body.position = {
            start: start,
            end: end
        };
        tableContent.push(body);
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "table",
        properties: {},
        children: state.wrap(tableContent, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $491a41d1734ce70f$export$ce666bf02318c957(state, node, parent) {
    const siblings = parent ? parent.children : undefined;
    // Generate a body row when without parent.
    const rowIndex = siblings ? siblings.indexOf(node) : 1;
    const tagName = rowIndex === 0 ? "th" : "td";
    // To do: option to use `style`?
    const align = parent && parent.type === "table" ? parent.align : undefined;
    const length = align ? align.length : node.children.length;
    let cellIndex = -1;
    /** @type {Array<ElementContent>} */ const cells = [];
    while(++cellIndex < length){
        // Note: can also be undefined.
        const cell = node.children[cellIndex];
        /** @type {Properties} */ const properties = {};
        const alignValue = align ? align[cellIndex] : undefined;
        if (alignValue) properties.align = alignValue;
        /** @type {Element} */ let result = {
            type: "element",
            tagName: tagName,
            properties: properties,
            children: []
        };
        if (cell) {
            result.children = state.all(cell);
            state.patch(cell, result);
            result = state.applyData(cell, result);
        }
        cells.push(result);
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "tr",
        properties: {},
        children: state.wrap(cells, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $96db1c145d833283$export$e1e720e5f4603e6a(state, node) {
    // Note: this function is normally not called: see `table-row` for how rows
    // and their cells are compiled.
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "td",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').Text} HastText
 * @typedef {import('mdast').Text} MdastText
 * @typedef {import('../state.js').State} State
 */ const $74fc049505089c7d$var$tab = 9 /* `\t` */ ;
const $74fc049505089c7d$var$space = 32 /* ` ` */ ;
function $74fc049505089c7d$export$a771f20bdd13def9(value) {
    const source = String(value);
    const search = /\r?\n|\r/g;
    let match = search.exec(source);
    let last = 0;
    /** @type {Array<string>} */ const lines = [];
    while(match){
        lines.push($74fc049505089c7d$var$trimLine(source.slice(last, match.index), last > 0, true), match[0]);
        last = match.index + match[0].length;
        match = search.exec(source);
    }
    lines.push($74fc049505089c7d$var$trimLine(source.slice(last), last > 0, false));
    return lines.join("");
}
/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */ function $74fc049505089c7d$var$trimLine(value, start, end) {
    let startIndex = 0;
    let endIndex = value.length;
    if (start) {
        let code = value.codePointAt(startIndex);
        while(code === $74fc049505089c7d$var$tab || code === $74fc049505089c7d$var$space){
            startIndex++;
            code = value.codePointAt(startIndex);
        }
    }
    if (end) {
        let code = value.codePointAt(endIndex - 1);
        while(code === $74fc049505089c7d$var$tab || code === $74fc049505089c7d$var$space){
            endIndex--;
            code = value.codePointAt(endIndex - 1);
        }
    }
    return endIndex > startIndex ? value.slice(startIndex, endIndex) : "";
}


function $d7fe11c1b92bbeb8$export$6f093cfa640b7166(state, node) {
    /** @type {HastText} */ const result = {
        type: "text",
        value: (0, $74fc049505089c7d$export$a771f20bdd13def9)(String(node.value))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $00e35e0402999d04$export$ba7b13e047416c03(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "hr",
        properties: {},
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


const $6bc5a573245133ae$export$455ce229eb3d2472 = {
    blockquote: $955a47ac5d47075f$export$67dc04e652a298ca,
    break: (0, $587086a72aee5766$export$371da9dd35aba193),
    code: $1364b9893259ecfc$export$6565f9f03506010b,
    delete: (0, $cc1c6c8222e6a677$export$19426ff118fe8be),
    emphasis: $7a74bf776bd11ea0$export$bef81ba411953b51,
    footnoteReference: $06c3f4293e8f167d$export$7f87ee744075c1ba,
    heading: $ca875ea98ccc9de9$export$46e4a324ac90507f,
    html: $e5a69249dd3a730e$export$c0bb0b647f701bb5,
    imageReference: $d3cdbb7b702a330a$export$f281796f6bc3b8db,
    image: $baa57df20c585b81$export$5c452ff88e35e47d,
    inlineCode: $64acbf4cd1f309e2$export$91b9bee19a0d8569,
    linkReference: $b5cb1998deb8661e$export$e6c469b1b7b2bc6a,
    link: $e36121a4112384ee$export$9c30223ca0a664fb,
    listItem: $973a676b399e8414$export$76c7e83ecc9cdf05,
    list: $4b18885aa5092364$export$8837f4fc672e936d,
    paragraph: $4f2858c23833dade$export$9c206ddddb32a9b,
    root: // @ts-expect-error: root is different, but hard to type.
    $80cb2e892a9dc435$export$e8e78c978b129247,
    strong: $64c123d6c0e3bb7f$export$59ae2c325a998f89,
    table: $c2e9ff9d07cbac9e$export$9852986a3ec5f6a0,
    tableCell: $96db1c145d833283$export$e1e720e5f4603e6a,
    tableRow: $491a41d1734ce70f$export$ce666bf02318c957,
    text: $d7fe11c1b92bbeb8$export$6f093cfa640b7166,
    thematicBreak: $00e35e0402999d04$export$ba7b13e047416c03,
    toml: $6bc5a573245133ae$var$ignore,
    yaml: $6bc5a573245133ae$var$ignore,
    definition: $6bc5a573245133ae$var$ignore,
    footnoteDefinition: $6bc5a573245133ae$var$ignore
};
// Return nothing for nodes that are ignored.
function $6bc5a573245133ae$var$ignore() {
    return undefined;
}


const $9eb77b098c561bcd$var$own = {}.hasOwnProperty;
/** @type {Options} */ const $9eb77b098c561bcd$var$emptyOptions = {};
function $9eb77b098c561bcd$export$e6a0daad8304de(tree, options) {
    const settings = options || $9eb77b098c561bcd$var$emptyOptions;
    /** @type {Map<string, MdastDefinition>} */ const definitionById = new Map();
    /** @type {Map<string, MdastFootnoteDefinition>} */ const footnoteById = new Map();
    /** @type {Map<string, number>} */ const footnoteCounts = new Map();
    /** @type {Handlers} */ // @ts-expect-error: the root handler returns a root.
    // Hard to type.
    const handlers = {
        ...(0, $6bc5a573245133ae$export$455ce229eb3d2472),
        ...settings.handlers
    };
    /** @type {State} */ const state = {
        all: all,
        applyData: $9eb77b098c561bcd$var$applyData,
        definitionById: definitionById,
        footnoteById: footnoteById,
        footnoteCounts: footnoteCounts,
        footnoteOrder: [],
        handlers: handlers,
        one: one,
        options: settings,
        patch: $9eb77b098c561bcd$var$patch,
        wrap: $9eb77b098c561bcd$export$4997ffc0176396a6
    };
    (0, $54f08257f9dfe0bf$export$bf638b60ea8b89b7)(tree, function(node) {
        if (node.type === "definition" || node.type === "footnoteDefinition") {
            const map = node.type === "definition" ? definitionById : footnoteById;
            const id = String(node.identifier).toUpperCase();
            // Mimick CM behavior of link definitions.
            // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/9032189/lib/index.js#L20-L21>.
            if (!map.has(id)) // @ts-expect-error: node type matches map.
            map.set(id, node);
        }
    });
    return state;
    /**
   * Transform an mdast node into a hast node.
   *
   * @param {MdastNodes} node
   *   mdast node.
   * @param {MdastParents | undefined} [parent]
   *   Parent of `node`.
   * @returns {Array<HastElementContent> | HastElementContent | undefined}
   *   Resulting hast node.
   */ function one(node, parent) {
        const type = node.type;
        const handle = state.handlers[type];
        if ($9eb77b098c561bcd$var$own.call(state.handlers, type) && handle) return handle(state, node, parent);
        if (state.options.passThrough && state.options.passThrough.includes(type)) {
            if ("children" in node) {
                const { children: children, ...shallow } = node;
                const result = (0, $bc3cd85dbe1274fe$export$2e2bcd8739ae039)(shallow);
                // @ts-expect-error: TS doesn’t understand…
                result.children = state.all(node);
                // @ts-expect-error: TS doesn’t understand…
                return result;
            }
            // @ts-expect-error: it’s custom.
            return (0, $bc3cd85dbe1274fe$export$2e2bcd8739ae039)(node);
        }
        const unknown = state.options.unknownHandler || $9eb77b098c561bcd$var$defaultUnknownHandler;
        return unknown(state, node, parent);
    }
    /**
   * Transform the children of an mdast node into hast nodes.
   *
   * @param {MdastNodes} parent
   *   mdast node to compile
   * @returns {Array<HastElementContent>}
   *   Resulting hast nodes.
   */ function all(parent) {
        /** @type {Array<HastElementContent>} */ const values = [];
        if ("children" in parent) {
            const nodes = parent.children;
            let index = -1;
            while(++index < nodes.length){
                const result = state.one(nodes[index], parent);
                // To do: see if we van clean this? Can we merge texts?
                if (result) {
                    if (index && nodes[index - 1].type === "break") {
                        if (!Array.isArray(result) && result.type === "text") result.value = $9eb77b098c561bcd$var$trimMarkdownSpaceStart(result.value);
                        if (!Array.isArray(result) && result.type === "element") {
                            const head = result.children[0];
                            if (head && head.type === "text") head.value = $9eb77b098c561bcd$var$trimMarkdownSpaceStart(head.value);
                        }
                    }
                    if (Array.isArray(result)) values.push(...result);
                    else values.push(result);
                }
            }
        }
        return values;
    }
}
/**
 * Copy a node’s positional info.
 *
 * @param {MdastNodes} from
 *   mdast node to copy from.
 * @param {HastNodes} to
 *   hast node to copy into.
 * @returns {undefined}
 *   Nothing.
 */ function $9eb77b098c561bcd$var$patch(from, to) {
    if (from.position) to.position = (0, $a349554b0943c73d$export$5880b8b5730aff45)(from);
}
/**
 * Honor the `data` of `from` and maybe generate an element instead of `to`.
 *
 * @template {HastNodes} Type
 *   Node type.
 * @param {MdastNodes} from
 *   mdast node to use data from.
 * @param {Type} to
 *   hast node to change.
 * @returns {HastElement | Type}
 *   Nothing.
 */ function $9eb77b098c561bcd$var$applyData(from, to) {
    /** @type {HastElement | Type} */ let result = to;
    // Handle `data.hName`, `data.hProperties, `data.hChildren`.
    if (from && from.data) {
        const hName = from.data.hName;
        const hChildren = from.data.hChildren;
        const hProperties = from.data.hProperties;
        if (typeof hName === "string") {
            // Transforming the node resulted in an element with a different name
            // than wanted:
            if (result.type === "element") result.tagName = hName;
            else {
                /** @type {Array<HastElementContent>} */ // @ts-expect-error: assume no doctypes in `root`.
                const children = "children" in result ? result.children : [
                    result
                ];
                result = {
                    type: "element",
                    tagName: hName,
                    properties: {},
                    children: children
                };
            }
        }
        if (result.type === "element" && hProperties) Object.assign(result.properties, (0, $bc3cd85dbe1274fe$export$2e2bcd8739ae039)(hProperties));
        if ("children" in result && result.children && hChildren !== null && hChildren !== undefined) result.children = hChildren;
    }
    return result;
}
/**
 * Transform an unknown node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastNodes} node
 *   Unknown mdast node.
 * @returns {HastElement | HastText}
 *   Resulting hast node.
 */ function $9eb77b098c561bcd$var$defaultUnknownHandler(state, node) {
    const data = node.data || {};
    /** @type {HastElement | HastText} */ const result = "value" in node && !($9eb77b098c561bcd$var$own.call(data, "hProperties") || $9eb77b098c561bcd$var$own.call(data, "hChildren")) ? {
        type: "text",
        value: node.value
    } : {
        type: "element",
        tagName: "div",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
function $9eb77b098c561bcd$export$4997ffc0176396a6(nodes, loose) {
    /** @type {Array<HastText | Type>} */ const result = [];
    let index = -1;
    if (loose) result.push({
        type: "text",
        value: "\n"
    });
    while(++index < nodes.length){
        if (index) result.push({
            type: "text",
            value: "\n"
        });
        result.push(nodes[index]);
    }
    if (loose && nodes.length > 0) result.push({
        type: "text",
        value: "\n"
    });
    return result;
}
/**
 * Trim spaces and tabs at the start of `value`.
 *
 * @param {string} value
 *   Value to trim.
 * @returns {string}
 *   Result.
 */ function $9eb77b098c561bcd$var$trimMarkdownSpaceStart(value) {
    let index = 0;
    let code = value.charCodeAt(index);
    while(code === 9 || code === 32){
        index++;
        code = value.charCodeAt(index);
    }
    return value.slice(index);
}


function $3b60910002d9af3a$export$c0e4c5cf07538633(tree, options) {
    const state = (0, $9eb77b098c561bcd$export$e6a0daad8304de)(tree, options);
    const node = state.one(tree, undefined);
    const foot = (0, $c344dd3971a437f6$export$adb608be33961c98)(state);
    /** @type {HastNodes} */ const result = Array.isArray(node) ? {
        type: "root",
        children: node
    } : node || {
        type: "root",
        children: []
    };
    if (foot) {
        // If there’s a footer, there were definitions, meaning block
        // content.
        // So `result` is a parent node.
        (0, $331630515164a454$export$dcb8b3f0e2de7e49)("children" in result);
        result.children.push({
            type: "text",
            value: "\n"
        }, foot);
    }
    return result;
}


function $3fc37f6f9c7aa14c$export$2e2bcd8739ae039(destination, options) {
    if (destination && "run" in destination) /**
     * @type {TransformBridge}
     */ return async function(tree, file) {
        // Cast because root in -> root out.
        const hastTree = /** @type {HastRoot} */ (0, $3b60910002d9af3a$export$c0e4c5cf07538633)(tree, options);
        await destination.run(hastTree, file);
    };
    /**
   * @type {TransformMutate}
   */ return function(tree) {
        // Cast because root in -> root out.
        return /** @type {HastRoot} */ (0, $3b60910002d9af3a$export$c0e4c5cf07538633)(tree, options || destination);
    };
}


/**
 * @typedef {import('trough').Pipeline} Pipeline
 *
 * @typedef {import('unist').Node} Node
 *
 * @typedef {import('vfile').Compatible} Compatible
 * @typedef {import('vfile').Value} Value
 *
 * @typedef {import('../index.js').CompileResultMap} CompileResultMap
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Settings} Settings
 */ /**
 * @typedef {CompileResultMap[keyof CompileResultMap]} CompileResults
 *   Acceptable results from compilers.
 *
 *   To register custom results, add them to
 *   {@link CompileResultMap `CompileResultMap`}.
 */ /**
 * @template {Node} [Tree=Node]
 *   The node that the compiler receives (default: `Node`).
 * @template {CompileResults} [Result=CompileResults]
 *   The thing that the compiler yields (default: `CompileResults`).
 * @callback Compiler
 *   A **compiler** handles the compiling of a syntax tree to something else
 *   (in most cases, text) (TypeScript type).
 *
 *   It is used in the stringify phase and called with a {@link Node `Node`}
 *   and {@link VFile `VFile`} representation of the document to compile.
 *   It should return the textual representation of the given tree (typically
 *   `string`).
 *
 *   > 👉 **Note**: unified typically compiles by serializing: most compilers
 *   > return `string` (or `Uint8Array`).
 *   > Some compilers, such as the one configured with
 *   > [`rehype-react`][rehype-react], return other values (in this case, a
 *   > React tree).
 *   > If you’re using a compiler that doesn’t serialize, expect different
 *   > result values.
 *   >
 *   > To register custom results in TypeScript, add them to
 *   > {@link CompileResultMap `CompileResultMap`}.
 *
 *   [rehype-react]: https://github.com/rehypejs/rehype-react
 * @param {Tree} tree
 *   Tree to compile.
 * @param {VFile} file
 *   File associated with `tree`.
 * @returns {Result}
 *   New content: compiled text (`string` or `Uint8Array`, for `file.value`) or
 *   something else (for `file.result`).
 */ /**
 * @template {Node} [Tree=Node]
 *   The node that the parser yields (default: `Node`)
 * @callback Parser
 *   A **parser** handles the parsing of text to a syntax tree.
 *
 *   It is used in the parse phase and is called with a `string` and
 *   {@link VFile `VFile`} of the document to parse.
 *   It must return the syntax tree representation of the given file
 *   ({@link Node `Node`}).
 * @param {string} document
 *   Document to parse.
 * @param {VFile} file
 *   File associated with `document`.
 * @returns {Tree}
 *   Node representing the given file.
 */ /**
 * @typedef {(
 *   Plugin<Array<any>, any, any> |
 *   PluginTuple<Array<any>, any, any> |
 *   Preset
 * )} Pluggable
 *   Union of the different ways to add plugins and settings.
 */ /**
 * @typedef {Array<Pluggable>} PluggableList
 *   List of plugins and presets.
 */ // Note: we can’t use `callback` yet as it messes up `this`:
//  <https://github.com/microsoft/TypeScript/issues/55197>.
/**
 * @template {Array<unknown>} [PluginParameters=[]]
 *   Arguments passed to the plugin (default: `[]`, the empty tuple).
 * @template {Node | string | undefined} [Input=Node]
 *   Value that is expected as input (default: `Node`).
 *
 *   *   If the plugin returns a {@link Transformer `Transformer`}, this
 *       should be the node it expects.
 *   *   If the plugin sets a {@link Parser `Parser`}, this should be
 *       `string`.
 *   *   If the plugin sets a {@link Compiler `Compiler`}, this should be the
 *       node it expects.
 * @template [Output=Input]
 *   Value that is yielded as output (default: `Input`).
 *
 *   *   If the plugin returns a {@link Transformer `Transformer`}, this
 *       should be the node that that yields.
 *   *   If the plugin sets a {@link Parser `Parser`}, this should be the
 *       node that it yields.
 *   *   If the plugin sets a {@link Compiler `Compiler`}, this should be
 *       result it yields.
 * @typedef {(
 *   (this: Processor, ...parameters: PluginParameters) =>
 *     Input extends string ? // Parser.
 *        Output extends Node | undefined ? undefined | void : never :
 *     Output extends CompileResults ? // Compiler.
 *        Input extends Node | undefined ? undefined | void : never :
 *     Transformer<
 *       Input extends Node ? Input : Node,
 *       Output extends Node ? Output : Node
 *     > | undefined | void
 * )} Plugin
 *   Single plugin.
 *
 *   Plugins configure the processors they are applied on in the following
 *   ways:
 *
 *   *   they change the processor, such as the parser, the compiler, or by
 *       configuring data
 *   *   they specify how to handle trees and files
 *
 *   In practice, they are functions that can receive options and configure the
 *   processor (`this`).
 *
 *   > 👉 **Note**: plugins are called when the processor is *frozen*, not when
 *   > they are applied.
 */ /**
 * Tuple of a plugin and its configuration.
 *
 * The first item is a plugin, the rest are its parameters.
 *
 * @template {Array<unknown>} [TupleParameters=[]]
 *   Arguments passed to the plugin (default: `[]`, the empty tuple).
 * @template {Node | string | undefined} [Input=undefined]
 *   Value that is expected as input (optional).
 *
 *   *   If the plugin returns a {@link Transformer `Transformer`}, this
 *       should be the node it expects.
 *   *   If the plugin sets a {@link Parser `Parser`}, this should be
 *       `string`.
 *   *   If the plugin sets a {@link Compiler `Compiler`}, this should be the
 *       node it expects.
 * @template [Output=undefined] (optional).
 *   Value that is yielded as output.
 *
 *   *   If the plugin returns a {@link Transformer `Transformer`}, this
 *       should be the node that that yields.
 *   *   If the plugin sets a {@link Parser `Parser`}, this should be the
 *       node that it yields.
 *   *   If the plugin sets a {@link Compiler `Compiler`}, this should be
 *       result it yields.
 * @typedef {(
 *   [
 *     plugin: Plugin<TupleParameters, Input, Output>,
 *     ...parameters: TupleParameters
 *   ]
 * )} PluginTuple
 */ /**
 * @typedef Preset
 *   Sharable configuration.
 *
 *   They can contain plugins and settings.
 * @property {PluggableList | undefined} [plugins]
 *   List of plugins and presets (optional).
 * @property {Settings | undefined} [settings]
 *   Shared settings for parsers and compilers (optional).
 */ /**
 * @template {VFile} [File=VFile]
 *   The file that the callback receives (default: `VFile`).
 * @callback ProcessCallback
 *   Callback called when the process is done.
 *
 *   Called with either an error or a result.
 * @param {Error | undefined} [error]
 *   Fatal error (optional).
 * @param {File | undefined} [file]
 *   Processed file (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Tree=Node]
 *   The tree that the callback receives (default: `Node`).
 * @callback RunCallback
 *   Callback called when transformers are done.
 *
 *   Called with either an error or results.
 * @param {Error | undefined} [error]
 *   Fatal error (optional).
 * @param {Tree | undefined} [tree]
 *   Transformed tree (optional).
 * @param {VFile | undefined} [file]
 *   File (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Output=Node]
 *   Node type that the transformer yields (default: `Node`).
 * @callback TransformCallback
 *   Callback passed to transforms.
 *
 *   If the signature of a `transformer` accepts a third argument, the
 *   transformer may perform asynchronous operations, and must call it.
 * @param {Error | undefined} [error]
 *   Fatal error to stop the process (optional).
 * @param {Output | undefined} [tree]
 *   New, changed, tree (optional).
 * @param {VFile | undefined} [file]
 *   New, changed, file (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Input=Node]
 *   Node type that the transformer expects (default: `Node`).
 * @template {Node} [Output=Input]
 *   Node type that the transformer yields (default: `Input`).
 * @callback Transformer
 *   Transformers handle syntax trees and files.
 *
 *   They are functions that are called each time a syntax tree and file are
 *   passed through the run phase.
 *   When an error occurs in them (either because it’s thrown, returned,
 *   rejected, or passed to `next`), the process stops.
 *
 *   The run phase is handled by [`trough`][trough], see its documentation for
 *   the exact semantics of these functions.
 *
 *   > 👉 **Note**: you should likely ignore `next`: don’t accept it.
 *   > it supports callback-style async work.
 *   > But promises are likely easier to reason about.
 *
 *   [trough]: https://github.com/wooorm/trough#function-fninput-next
 * @param {Input} tree
 *   Tree to handle.
 * @param {VFile} file
 *   File to handle.
 * @param {TransformCallback<Output>} next
 *   Callback.
 * @returns {(
 *   Promise<Output | undefined | void> |
 *   Promise<never> | // For some reason this is needed separately.
 *   Output |
 *   Error |
 *   undefined |
 *   void
 * )}
 *   If you accept `next`, nothing.
 *   Otherwise:
 *
 *   *   `Error` — fatal error to stop the process
 *   *   `Promise<undefined>` or `undefined` — the next transformer keeps using
 *       same tree
 *   *   `Promise<Node>` or `Node` — new, changed, tree
 */ /**
 * @template {Node | undefined} ParseTree
 *   Output of `parse`.
 * @template {Node | undefined} HeadTree
 *   Input for `run`.
 * @template {Node | undefined} TailTree
 *   Output for `run`.
 * @template {Node | undefined} CompileTree
 *   Input of `stringify`.
 * @template {CompileResults | undefined} CompileResult
 *   Output of `stringify`.
 * @template {Node | string | undefined} Input
 *   Input of plugin.
 * @template Output
 *   Output of plugin (optional).
 * @typedef {(
 *   Input extends string
 *     ? Output extends Node | undefined
 *       ? // Parser.
 *         Processor<
 *           Output extends undefined ? ParseTree : Output,
 *           HeadTree,
 *           TailTree,
 *           CompileTree,
 *           CompileResult
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : Output extends CompileResults
 *     ? Input extends Node | undefined
 *       ? // Compiler.
 *         Processor<
 *           ParseTree,
 *           HeadTree,
 *           TailTree,
 *           Input extends undefined ? CompileTree : Input,
 *           Output extends undefined ? CompileResult : Output
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : Input extends Node | undefined
 *     ? Output extends Node | undefined
 *       ? // Transform.
 *         Processor<
 *           ParseTree,
 *           HeadTree extends undefined ? Input : HeadTree,
 *           Output extends undefined ? TailTree : Output,
 *           CompileTree,
 *           CompileResult
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : // Unknown.
 *       Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 * )} UsePlugin
 *   Create a processor based on the input/output of a {@link Plugin plugin}.
 */ /**
 * @template {CompileResults | undefined} Result
 *   Node type that the transformer yields.
 * @typedef {(
 *   Result extends Value | undefined ?
 *     VFile :
 *     VFile & {result: Result}
 *   )} VFileWithOutput
 *   Type to generate a {@link VFile `VFile`} corresponding to a compiler result.
 *
 *   If a result that is not acceptable on a `VFile` is used, that will
 *   be stored on the `result` field of {@link VFile `VFile`}.
 */ /**
 * Throw a given error.
 *
 * @param {Error|null|undefined} [error]
 *   Maybe error.
 * @returns {asserts error is null|undefined}
 */ function $df5ffbd626869999$export$dd911e13ecb11e05(error) {
    if (error) throw error;
}


var $58468e7de1e61277$exports = {};
"use strict";
var $58468e7de1e61277$var$hasOwn = Object.prototype.hasOwnProperty;
var $58468e7de1e61277$var$toStr = Object.prototype.toString;
var $58468e7de1e61277$var$defineProperty = Object.defineProperty;
var $58468e7de1e61277$var$gOPD = Object.getOwnPropertyDescriptor;
var $58468e7de1e61277$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === "function") return Array.isArray(arr);
    return $58468e7de1e61277$var$toStr.call(arr) === "[object Array]";
};
var $58468e7de1e61277$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $58468e7de1e61277$var$toStr.call(obj) !== "[object Object]") return false;
    var hasOwnConstructor = $58468e7de1e61277$var$hasOwn.call(obj, "constructor");
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $58468e7de1e61277$var$hasOwn.call(obj.constructor.prototype, "isPrototypeOf");
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === "undefined" || $58468e7de1e61277$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $58468e7de1e61277$var$setProperty = function setProperty(target, options) {
    if ($58468e7de1e61277$var$defineProperty && options.name === "__proto__") $58468e7de1e61277$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $58468e7de1e61277$var$getProperty = function getProperty(obj, name) {
    if (name === "__proto__") {
        if (!$58468e7de1e61277$var$hasOwn.call(obj, name)) return void 0;
        else if ($58468e7de1e61277$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $58468e7de1e61277$var$gOPD(obj, name).value;
    }
    return obj[name];
};
$58468e7de1e61277$exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === "boolean") {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== "object" && typeof target !== "function") target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $58468e7de1e61277$var$getProperty(target, name);
            copy = $58468e7de1e61277$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($58468e7de1e61277$var$isPlainObject(copy) || (copyIsArray = $58468e7de1e61277$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $58468e7de1e61277$var$isArray(src) ? src : [];
                    } else clone = src && $58468e7de1e61277$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $58468e7de1e61277$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== "undefined") $58468e7de1e61277$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};



function $fe5a2b0ba2786d83$export$2e2bcd8739ae039(value) {
    if (typeof value !== "object" || value === null) return false;
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}


/**
 * @typedef {(error?: Error|null|undefined, ...output: Array<any>) => void} Callback
 * @typedef {(...input: Array<any>) => any} Middleware
 *
 * @typedef {(...input: Array<any>) => void} Run
 *   Call all middleware.
 * @typedef {(fn: Middleware) => Pipeline} Use
 *   Add `fn` (middleware) to the list.
 * @typedef {{run: Run, use: Use}} Pipeline
 *   Middleware.
 */ /**
 * Create new middleware.
 *
 * @returns {Pipeline}
 */ function $1b39a04cebdc8c7f$export$91b56f5ca106aa43() {
    /** @type {Array<Middleware>} */ const fns = [];
    /** @type {Pipeline} */ const pipeline = {
        run: run,
        use: use
    };
    return pipeline;
    /** @type {Run} */ function run(...values) {
        let middlewareIndex = -1;
        /** @type {Callback} */ const callback = values.pop();
        if (typeof callback !== "function") throw new TypeError("Expected function as last argument, not " + callback);
        next(null, ...values);
        /**
     * Run the next `fn`, or we’re done.
     *
     * @param {Error|null|undefined} error
     * @param {Array<any>} output
     */ function next(error, ...output) {
            const fn = fns[++middlewareIndex];
            let index = -1;
            if (error) {
                callback(error);
                return;
            }
            // Copy non-nullish input into values.
            while(++index < values.length)if (output[index] === null || output[index] === undefined) output[index] = values[index];
            // Save the newly created `output` for the next call.
            values = output;
            // Next or done.
            if (fn) $1b39a04cebdc8c7f$export$4997ffc0176396a6(fn, next)(...output);
            else callback(null, ...output);
        }
    }
    /** @type {Use} */ function use(middelware) {
        if (typeof middelware !== "function") throw new TypeError("Expected `middelware` to be a function, not " + middelware);
        fns.push(middelware);
        return pipeline;
    }
}
function $1b39a04cebdc8c7f$export$4997ffc0176396a6(middleware, callback) {
    /** @type {boolean} */ let called;
    return wrapped;
    /**
   * Call `middleware`.
   * @this {any}
   * @param {Array<any>} parameters
   * @returns {void}
   */ function wrapped(...parameters) {
        const fnExpectsCallback = middleware.length > parameters.length;
        /** @type {any} */ let result;
        if (fnExpectsCallback) parameters.push(done);
        try {
            result = middleware.apply(this, parameters);
        } catch (error) {
            const exception = /** @type {Error} */ error;
            // Well, this is quite the pickle.
            // `middleware` received a callback and called it synchronously, but that
            // threw an error.
            // The only thing left to do is to throw the thing instead.
            if (fnExpectsCallback && called) throw exception;
            return done(exception);
        }
        if (!fnExpectsCallback) {
            if (result instanceof Promise) result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    /**
   * Call `callback`, only once.
   * @type {Callback}
   */ function done(error, ...output) {
        if (!called) {
            called = true;
            callback(error, ...output);
        }
    }
    /**
   * Call `done` with one value.
   *
   * @param {any} [value]
   */ function then(value) {
        done(null, value);
    }
}


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 * @typedef {import('vfile-message').Options} MessageOptions
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Value} Value
 */ /**
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef {Options | URL | VFile | Value} Compatible
 *   Things that can be passed to the constructor.
 *
 * @typedef VFileCoreOptions
 *   Set multiple values.
 * @property {string | null | undefined} [basename]
 *   Set `basename` (name).
 * @property {string | null | undefined} [cwd]
 *   Set `cwd` (working directory).
 * @property {Data | null | undefined} [data]
 *   Set `data` (associated info).
 * @property {string | null | undefined} [dirname]
 *   Set `dirname` (path w/o basename).
 * @property {string | null | undefined} [extname]
 *   Set `extname` (extension with dot).
 * @property {Array<string> | null | undefined} [history]
 *   Set `history` (paths the file moved between).
 * @property {URL | string | null | undefined} [path]
 *   Set `path` (current path).
 * @property {string | null | undefined} [stem]
 *   Set `stem` (name without extension).
 * @property {Value | null | undefined} [value]
 *   Set `value` (the contents of the file).
 *
 * @typedef Map
 *   Raw source map.
 *
 *   See:
 *   <https://github.com/mozilla/source-map/blob/60adcb0/source-map.d.ts#L15-L23>.
 * @property {number} version
 *   Which version of the source map spec this map is following.
 * @property {Array<string>} sources
 *   An array of URLs to the original source files.
 * @property {Array<string>} names
 *   An array of identifiers which can be referenced by individual mappings.
 * @property {string | undefined} [sourceRoot]
 *   The URL root from which all sources are relative.
 * @property {Array<string> | undefined} [sourcesContent]
 *   An array of contents of the original source files.
 * @property {string} mappings
 *   A string of base64 VLQs which contain the actual mappings.
 * @property {string} file
 *   The generated file this source map is associated with.
 *
 * @typedef {Record<string, unknown> & VFileCoreOptions} Options
 *   Configuration.
 *
 *   A bunch of keys that will be shallow copied over to the new file.
 *
 * @typedef {Record<string, unknown>} ReporterSettings
 *   Configuration for reporters.
 */ /**
 * @template [Settings=ReporterSettings]
 *   Options type.
 * @callback Reporter
 *   Type for a reporter.
 * @param {Array<VFile>} files
 *   Files to report.
 * @param {Settings} options
 *   Configuration.
 * @returns {string}
 *   Report.
 */ 
// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
const $80c5f31d40cf772c$export$bb654e07daaf8c3a = {
    basename: $80c5f31d40cf772c$var$basename,
    dirname: $80c5f31d40cf772c$var$dirname,
    extname: $80c5f31d40cf772c$var$extname,
    join: $80c5f31d40cf772c$var$join,
    sep: "/"
};
/* eslint-disable max-depth, complexity */ /**
 * Get the basename from a path.
 *
 * @param {string} path
 *   File path.
 * @param {string | null | undefined} [ext]
 *   Extension to strip.
 * @returns {string}
 *   Stem or basename.
 */ function $80c5f31d40cf772c$var$basename(path, ext) {
    if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
    $80c5f31d40cf772c$var$assertPath(path);
    let start = 0;
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let seenNonSlash;
    if (ext === undefined || ext.length === 0 || ext.length > path.length) {
        while(index--){
            if (path.codePointAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            {
                if (seenNonSlash) {
                    start = index + 1;
                    break;
                }
            } else if (end < 0) {
                // We saw the first non-path separator, mark this as the end of our
                // path component.
                seenNonSlash = true;
                end = index + 1;
            }
        }
        return end < 0 ? "" : path.slice(start, end);
    }
    if (ext === path) return "";
    let firstNonSlashEnd = -1;
    let extIndex = ext.length - 1;
    while(index--){
        if (path.codePointAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        {
            if (seenNonSlash) {
                start = index + 1;
                break;
            }
        } else {
            if (firstNonSlashEnd < 0) {
                // We saw the first non-path separator, remember this index in case
                // we need it if the extension ends up not matching.
                seenNonSlash = true;
                firstNonSlashEnd = index + 1;
            }
            if (extIndex > -1) {
                // Try to match the explicit extension.
                if (path.codePointAt(index) === ext.codePointAt(extIndex--)) {
                    if (extIndex < 0) // We matched the extension, so mark this as the end of our path
                    // component
                    end = index;
                } else {
                    // Extension does not match, so our result is the entire path
                    // component
                    extIndex = -1;
                    end = firstNonSlashEnd;
                }
            }
        }
    }
    if (start === end) end = firstNonSlashEnd;
    else if (end < 0) end = path.length;
    return path.slice(start, end);
}
/**
 * Get the dirname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ function $80c5f31d40cf772c$var$dirname(path) {
    $80c5f31d40cf772c$var$assertPath(path);
    if (path.length === 0) return ".";
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    // Prefix `--` is important to not run on `0`.
    while(--index){
        if (path.codePointAt(index) === 47 /* `/` */ ) {
            if (unmatchedSlash) {
                end = index;
                break;
            }
        } else if (!unmatchedSlash) // We saw the first non-path separator
        unmatchedSlash = true;
    }
    return end < 0 ? path.codePointAt(0) === 47 /* `/` */  ? "/" : "." : end === 1 && path.codePointAt(0) === 47 /* `/` */  ? "//" : path.slice(0, end);
}
/**
 * Get an extname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   Extname.
 */ function $80c5f31d40cf772c$var$extname(path) {
    $80c5f31d40cf772c$var$assertPath(path);
    let index = path.length;
    let end = -1;
    let startPart = 0;
    let startDot = -1;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find.
    let preDotState = 0;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    while(index--){
        const code = path.codePointAt(index);
        if (code === 47 /* `/` */ ) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            if (unmatchedSlash) {
                startPart = index + 1;
                break;
            }
            continue;
        }
        if (end < 0) {
            // We saw the first non-path separator, mark this as the end of our
            // extension.
            unmatchedSlash = true;
            end = index + 1;
        }
        if (code === 46 /* `.` */ ) {
            // If this is our first dot, mark it as the start of our extension.
            if (startDot < 0) startDot = index;
            else if (preDotState !== 1) preDotState = 1;
        } else if (startDot > -1) // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension.
        preDotState = -1;
    }
    if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
    preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
    return path.slice(startDot, end);
}
/**
 * Join segments from a path.
 *
 * @param {Array<string>} segments
 *   Path segments.
 * @returns {string}
 *   File path.
 */ function $80c5f31d40cf772c$var$join(...segments) {
    let index = -1;
    /** @type {string | undefined} */ let joined;
    while(++index < segments.length){
        $80c5f31d40cf772c$var$assertPath(segments[index]);
        if (segments[index]) joined = joined === undefined ? segments[index] : joined + "/" + segments[index];
    }
    return joined === undefined ? "." : $80c5f31d40cf772c$var$normalize(joined);
}
/**
 * Normalize a basic file path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ // Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function $80c5f31d40cf772c$var$normalize(path) {
    $80c5f31d40cf772c$var$assertPath(path);
    const absolute = path.codePointAt(0) === 47 /* `/` */ ;
    // Normalize the path according to POSIX rules.
    let value = $80c5f31d40cf772c$var$normalizeString(path, !absolute);
    if (value.length === 0 && !absolute) value = ".";
    if (value.length > 0 && path.codePointAt(path.length - 1) === 47 /* / */ ) value += "/";
    return absolute ? "/" + value : value;
}
/**
 * Resolve `.` and `..` elements in a path with directory names.
 *
 * @param {string} path
 *   File path.
 * @param {boolean} allowAboveRoot
 *   Whether `..` can move above root.
 * @returns {string}
 *   File path.
 */ function $80c5f31d40cf772c$var$normalizeString(path, allowAboveRoot) {
    let result = "";
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let index = -1;
    /** @type {number | undefined} */ let code;
    /** @type {number} */ let lastSlashIndex;
    while(++index <= path.length){
        if (index < path.length) code = path.codePointAt(index);
        else if (code === 47 /* `/` */ ) break;
        else code = 47 /* `/` */ ;
        if (code === 47 /* `/` */ ) {
            if (lastSlash === index - 1 || dots === 1) ;
            else if (lastSlash !== index - 1 && dots === 2) {
                if (result.length < 2 || lastSegmentLength !== 2 || result.codePointAt(result.length - 1) !== 46 /* `.` */  || result.codePointAt(result.length - 2) !== 46 /* `.` */ ) {
                    if (result.length > 2) {
                        lastSlashIndex = result.lastIndexOf("/");
                        if (lastSlashIndex !== result.length - 1) {
                            if (lastSlashIndex < 0) {
                                result = "";
                                lastSegmentLength = 0;
                            } else {
                                result = result.slice(0, lastSlashIndex);
                                lastSegmentLength = result.length - 1 - result.lastIndexOf("/");
                            }
                            lastSlash = index;
                            dots = 0;
                            continue;
                        }
                    } else if (result.length > 0) {
                        result = "";
                        lastSegmentLength = 0;
                        lastSlash = index;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    result = result.length > 0 ? result + "/.." : "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (result.length > 0) result += "/" + path.slice(lastSlash + 1, index);
                else result = path.slice(lastSlash + 1, index);
                lastSegmentLength = index - lastSlash - 1;
            }
            lastSlash = index;
            dots = 0;
        } else if (code === 46 /* `.` */  && dots > -1) dots++;
        else dots = -1;
    }
    return result;
}
/**
 * Make sure `path` is a string.
 *
 * @param {string} path
 *   File path.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $80c5f31d40cf772c$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
} /* eslint-enable max-depth, complexity */ 


// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
const $a396e9bef4dda946$export$97a5aaf482767187 = {
    cwd: $a396e9bef4dda946$var$cwd
};
function $a396e9bef4dda946$var$cwd() {
    return "/";
}


/**
 * Checks if a value has the shape of a WHATWG URL object.
 *
 * Using a symbol or instanceof would not be able to recognize URL objects
 * coming from other implementations (e.g. in Electron), so instead we are
 * checking some well known properties for a lack of a better test.
 *
 * We use `href` and `protocol` as they are the only properties that are
 * easy to retrieve and calculate due to the lazy nature of the getters.
 *
 * We check for auth attribute to distinguish legacy url instance with
 * WHATWG URL instance.
 *
 * @param {unknown} fileUrlOrPath
 *   File path or URL.
 * @returns {fileUrlOrPath is URL}
 *   Whether it’s a URL.
 */ // From: <https://github.com/nodejs/node/blob/6a3403c/lib/internal/url.js#L720>
function $94e6d1c59de5b7d4$export$8304a22d431f958(fileUrlOrPath) {
    return Boolean(fileUrlOrPath !== null && typeof fileUrlOrPath === "object" && "href" in fileUrlOrPath && fileUrlOrPath.href && "protocol" in fileUrlOrPath && fileUrlOrPath.protocol && // @ts-expect-error: indexing is fine.
    fileUrlOrPath.auth === undefined);
}


function $0e15394d668c620e$export$9b2b676c902de799(path) {
    if (typeof path === "string") path = new URL(path);
    else if (!(0, $94e6d1c59de5b7d4$export$8304a22d431f958)(path)) {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The "path" argument must be of type string or an instance of URL. Received `' + path + "`");
        error.code = "ERR_INVALID_ARG_TYPE";
        throw error;
    }
    if (path.protocol !== "file:") {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError("The URL must be of scheme file");
        error.code = "ERR_INVALID_URL_SCHEME";
        throw error;
    }
    return $0e15394d668c620e$var$getPathFromURLPosix(path);
}
/**
 * Get a path from a POSIX URL.
 *
 * @param {URL} url
 *   URL.
 * @returns {string}
 *   File path.
 */ function $0e15394d668c620e$var$getPathFromURLPosix(url) {
    if (url.hostname !== "") {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL host must be "localhost" or empty on darwin');
        error.code = "ERR_INVALID_FILE_URL_HOST";
        throw error;
    }
    const pathname = url.pathname;
    let index = -1;
    while(++index < pathname.length)if (pathname.codePointAt(index) === 37 /* `%` */  && pathname.codePointAt(index + 1) === 50 /* `2` */ ) {
        const third = pathname.codePointAt(index + 2);
        if (third === 70 /* `F` */  || third === 102 /* `f` */ ) {
            /** @type {NodeJS.ErrnoException} */ const error = new TypeError("File URL path must not include encoded / characters");
            error.code = "ERR_INVALID_FILE_URL_PATH";
            throw error;
        }
    }
    return decodeURIComponent(pathname);
}


/**
 * Order of setting (least specific to most), we need this because otherwise
 * `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
 * stem can be set.
 */ const $d2830ef88effe228$var$order = /** @type {const} */ [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
];
class $d2830ef88effe228$export$93dff69eb10dc7ce {
    /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */ constructor(value){
        /** @type {Options | VFile} */ let options;
        if (!value) options = {};
        else if ((0, $94e6d1c59de5b7d4$export$8304a22d431f958)(value)) options = {
            path: value
        };
        else if (typeof value === "string" || $d2830ef88effe228$var$isUint8Array(value)) options = {
            value: value
        };
        else options = value;
        /* eslint-disable no-unused-expressions */ /**
     * Base of `path` (default: `process.cwd()` or `'/'` in browsers).
     *
     * @type {string}
     */ this.cwd = (0, $a396e9bef4dda946$export$97a5aaf482767187).cwd();
        /**
     * Place to store custom info (default: `{}`).
     *
     * It’s OK to store custom data directly on the file but moving it to
     * `data` is recommended.
     *
     * @type {Data}
     */ this.data = {};
        /**
     * List of file paths the file moved between.
     *
     * The first is the original path and the last is the current path.
     *
     * @type {Array<string>}
     */ this.history = [];
        /**
     * List of messages associated with the file.
     *
     * @type {Array<VFileMessage>}
     */ this.messages = [];
        /**
     * Raw value.
     *
     * @type {Value}
     */ this.value;
        // The below are non-standard, they are “well-known”.
        // As in, used in several tools.
        /**
     * Source map.
     *
     * This type is equivalent to the `RawSourceMap` type from the `source-map`
     * module.
     *
     * @type {Map | null | undefined}
     */ this.map;
        /**
     * Custom, non-string, compiled, representation.
     *
     * This is used by unified to store non-string results.
     * One example is when turning markdown into React nodes.
     *
     * @type {unknown}
     */ this.result;
        /**
     * Whether a file was saved to disk.
     *
     * This is used by vfile reporters.
     *
     * @type {boolean}
     */ this.stored;
        /* eslint-enable no-unused-expressions */ // Set path related properties in the correct order.
        let index = -1;
        while(++index < $d2830ef88effe228$var$order.length){
            const prop = $d2830ef88effe228$var$order[index];
            // Note: we specifically use `in` instead of `hasOwnProperty` to accept
            // `vfile`s too.
            if (prop in options && options[prop] !== undefined && options[prop] !== null) // @ts-expect-error: TS doesn’t understand basic reality.
            this[prop] = prop === "history" ? [
                ...options[prop]
            ] : options[prop];
        }
        /** @type {string} */ let prop;
        // Set non-path related properties.
        for(prop in options)// @ts-expect-error: fine to set other things.
        if (!$d2830ef88effe228$var$order.includes(prop)) // @ts-expect-error: fine to set other things.
        this[prop] = options[prop];
    }
    /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */ get basename() {
        return typeof this.path === "string" ? (0, $80c5f31d40cf772c$export$bb654e07daaf8c3a).basename(this.path) : undefined;
    }
    /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */ set basename(basename) {
        $d2830ef88effe228$var$assertNonEmpty(basename, "basename");
        $d2830ef88effe228$var$assertPart(basename, "basename");
        this.path = (0, $80c5f31d40cf772c$export$bb654e07daaf8c3a).join(this.dirname || "", basename);
    }
    /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */ get dirname() {
        return typeof this.path === "string" ? (0, $80c5f31d40cf772c$export$bb654e07daaf8c3a).dirname(this.path) : undefined;
    }
    /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */ set dirname(dirname) {
        $d2830ef88effe228$var$assertPath(this.basename, "dirname");
        this.path = (0, $80c5f31d40cf772c$export$bb654e07daaf8c3a).join(dirname || "", this.basename);
    }
    /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */ get extname() {
        return typeof this.path === "string" ? (0, $80c5f31d40cf772c$export$bb654e07daaf8c3a).extname(this.path) : undefined;
    }
    /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */ set extname(extname) {
        $d2830ef88effe228$var$assertPart(extname, "extname");
        $d2830ef88effe228$var$assertPath(this.dirname, "extname");
        if (extname) {
            if (extname.codePointAt(0) !== 46 /* `.` */ ) throw new Error("`extname` must start with `.`");
            if (extname.includes(".", 1)) throw new Error("`extname` cannot contain multiple dots");
        }
        this.path = (0, $80c5f31d40cf772c$export$bb654e07daaf8c3a).join(this.dirname, this.stem + (extname || ""));
    }
    /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */ get path() {
        return this.history[this.history.length - 1];
    }
    /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */ set path(path) {
        if ((0, $94e6d1c59de5b7d4$export$8304a22d431f958)(path)) path = (0, $0e15394d668c620e$export$9b2b676c902de799)(path);
        $d2830ef88effe228$var$assertNonEmpty(path, "path");
        if (this.path !== path) this.history.push(path);
    }
    /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */ get stem() {
        return typeof this.path === "string" ? (0, $80c5f31d40cf772c$export$bb654e07daaf8c3a).basename(this.path, this.extname) : undefined;
    }
    /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */ set stem(stem) {
        $d2830ef88effe228$var$assertNonEmpty(stem, "stem");
        $d2830ef88effe228$var$assertPart(stem, "stem");
        this.path = (0, $80c5f31d40cf772c$export$bb654e07daaf8c3a).join(this.dirname || "", stem + (this.extname || ""));
    }
    // Normal prototypal methods.
    /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */ fail(causeOrReason, optionsOrParentOrPlace, origin) {
        // @ts-expect-error: the overloads are fine.
        const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
        message.fatal = true;
        throw message;
    }
    /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ info(causeOrReason, optionsOrParentOrPlace, origin) {
        // @ts-expect-error: the overloads are fine.
        const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
        message.fatal = undefined;
        return message;
    }
    /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ message(causeOrReason, optionsOrParentOrPlace, origin) {
        const message = new (0, $1af72c1830aac8bc$export$752e5c445fe834ef)(// @ts-expect-error: the overloads are fine.
        causeOrReason, optionsOrParentOrPlace, origin);
        if (this.path) {
            message.name = this.path + ":" + message.name;
            message.file = this.path;
        }
        message.fatal = false;
        this.messages.push(message);
        return message;
    }
    /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */ toString(encoding) {
        if (this.value === undefined) return "";
        if (typeof this.value === "string") return this.value;
        const decoder = new TextDecoder(encoding || undefined);
        return decoder.decode(this.value);
    }
}
/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string | null | undefined} part
 *   File path part.
 * @param {string} name
 *   Part name.
 * @returns {undefined}
 *   Nothing.
 */ function $d2830ef88effe228$var$assertPart(part, name) {
    if (part && part.includes((0, $80c5f31d40cf772c$export$bb654e07daaf8c3a).sep)) throw new Error("`" + name + "` cannot be a path: did not expect `" + (0, $80c5f31d40cf772c$export$bb654e07daaf8c3a).sep + "`");
}
/**
 * Assert that `part` is not empty.
 *
 * @param {string | undefined} part
 *   Thing.
 * @param {string} name
 *   Part name.
 * @returns {asserts part is string}
 *   Nothing.
 */ function $d2830ef88effe228$var$assertNonEmpty(part, name) {
    if (!part) throw new Error("`" + name + "` cannot be empty");
}
/**
 * Assert `path` exists.
 *
 * @param {string | undefined} path
 *   Path.
 * @param {string} name
 *   Dependency name.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $d2830ef88effe228$var$assertPath(path, name) {
    if (!path) throw new Error("Setting `" + name + "` requires `path` to be set too");
}
/**
 * Assert `value` is an `Uint8Array`.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Uint8Array}
 *   Whether `value` is an `Uint8Array`.
 */ function $d2830ef88effe228$var$isUint8Array(value) {
    return Boolean(value && typeof value === "object" && "byteLength" in value && "byteOffset" in value);
}


const $abeeff203cd45fd0$export$b7de1db558410812 = /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */ /** @type {unknown} */ /**
       * @this {Function}
       * @param {string | symbol} property
       * @returns {(...parameters: Array<unknown>) => unknown}
       */ function(property) {
    const self = this;
    const constr = self.constructor;
    const proto = /** @type {Record<string | symbol, Function>} */ // Prototypes do exist.
    // type-coverage:ignore-next-line
    constr.prototype;
    const func = proto[property];
    /** @type {(...parameters: Array<unknown>) => unknown} */ const apply = function() {
        return func.apply(apply, arguments);
    };
    Object.setPrototypeOf(apply, proto);
    const names = Object.getOwnPropertyNames(func);
    for (const p of names){
        const descriptor = Object.getOwnPropertyDescriptor(func, p);
        if (descriptor) Object.defineProperty(apply, p, descriptor);
    }
    return apply;
};


// To do: next major: drop `Compiler`, `Parser`: prefer lowercase.
// To do: we could start yielding `never` in TS when a parser is missing and
// `parse` is called.
// Currently, we allow directly setting `processor.parser`, which is untyped.
const $d7ff5355c2de279c$var$own = {}.hasOwnProperty;
class $d7ff5355c2de279c$export$c30cd198d731db19 extends (0, $abeeff203cd45fd0$export$b7de1db558410812) {
    /**
   * Create a processor.
   */ constructor(){
        // If `Processor()` is called (w/o new), `copy` is called instead.
        super("copy");
        /**
     * Compiler to use (deprecated).
     *
     * @deprecated
     *   Use `compiler` instead.
     * @type {(
     *   Compiler<
     *     CompileTree extends undefined ? Node : CompileTree,
     *     CompileResult extends undefined ? CompileResults : CompileResult
     *   > |
     *   undefined
     * )}
     */ this.Compiler = undefined;
        /**
     * Parser to use (deprecated).
     *
     * @deprecated
     *   Use `parser` instead.
     * @type {(
     *   Parser<ParseTree extends undefined ? Node : ParseTree> |
     *   undefined
     * )}
     */ this.Parser = undefined;
        // Note: the following fields are considered private.
        // However, they are needed for tests, and TSC generates an untyped
        // `private freezeIndex` field for, which trips `type-coverage` up.
        // Instead, we use `@deprecated` to visualize that they shouldn’t be used.
        /**
     * Internal list of configured plugins.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Array<PluginTuple<Array<unknown>>>}
     */ this.attachers = [];
        /**
     * Compiler to use.
     *
     * @type {(
     *   Compiler<
     *     CompileTree extends undefined ? Node : CompileTree,
     *     CompileResult extends undefined ? CompileResults : CompileResult
     *   > |
     *   undefined
     * )}
     */ this.compiler = undefined;
        /**
     * Internal state to track where we are while freezing.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {number}
     */ this.freezeIndex = -1;
        /**
     * Internal state to track whether we’re frozen.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {boolean | undefined}
     */ this.frozen = undefined;
        /**
     * Internal state.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Data}
     */ this.namespace = {};
        /**
     * Parser to use.
     *
     * @type {(
     *   Parser<ParseTree extends undefined ? Node : ParseTree> |
     *   undefined
     * )}
     */ this.parser = undefined;
        /**
     * Internal list of configured transformers.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Pipeline}
     */ this.transformers = (0, $1b39a04cebdc8c7f$export$91b56f5ca106aa43)();
    }
    /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@link Processor `Processor`}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */ copy() {
        // Cast as the type parameters will be the same after attaching.
        const destination = /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */ new $d7ff5355c2de279c$export$c30cd198d731db19();
        let index = -1;
        while(++index < this.attachers.length){
            const attacher = this.attachers[index];
            destination.use(...attacher);
        }
        destination.data((0, (/*@__PURE__*/$parcel$interopDefault($58468e7de1e61277$exports)))(true, {}, this.namespace));
        return destination;
    }
    /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > 👉 **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > 👉 **Note**: to register custom data in TypeScript, augment the
   * > {@link Data `Data`} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */ data(key, value) {
        if (typeof key === "string") {
            // Set `key`.
            if (arguments.length === 2) {
                $d7ff5355c2de279c$var$assertUnfrozen("data", this.frozen);
                this.namespace[key] = value;
                return this;
            }
            // Get `key`.
            return $d7ff5355c2de279c$var$own.call(this.namespace, key) && this.namespace[key] || undefined;
        }
        // Set space.
        if (key) {
            $d7ff5355c2de279c$var$assertUnfrozen("data", this.frozen);
            this.namespace = key;
            return this;
        }
        // Get space.
        return this.namespace;
    }
    /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */ freeze() {
        if (this.frozen) return this;
        // Cast so that we can type plugins easier.
        // Plugins are supposed to be usable on different processors, not just on
        // this exact processor.
        const self = /** @type {Processor} */ /** @type {unknown} */ this;
        while(++this.freezeIndex < this.attachers.length){
            const [attacher, ...options] = this.attachers[this.freezeIndex];
            if (options[0] === false) continue;
            if (options[0] === true) options[0] = undefined;
            const transformer = attacher.call(self, ...options);
            if (typeof transformer === "function") this.transformers.use(transformer);
        }
        this.frozen = true;
        this.freezeIndex = Number.POSITIVE_INFINITY;
        return this;
    }
    /**
   * Parse text to a syntax tree.
   *
   * > 👉 **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */ parse(file) {
        this.freeze();
        const realFile = $d7ff5355c2de279c$var$vfile(file);
        const parser = this.parser || this.Parser;
        $d7ff5355c2de279c$var$assertParser("parse", parser);
        return parser(String(realFile), realFile);
    }
    /**
   * Process the given file as configured on the processor.
   *
   * > 👉 **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ process(file, done) {
        const self = this;
        this.freeze();
        $d7ff5355c2de279c$var$assertParser("process", this.parser || this.Parser);
        $d7ff5355c2de279c$var$assertCompiler("process", this.compiler || this.Compiler);
        return done ? executor(undefined, done) : new Promise(executor);
        // Note: `void`s needed for TS.
        /**
     * @param {((file: VFileWithOutput<CompileResult>) => undefined | void) | undefined} resolve
     * @param {(error: Error | undefined) => undefined | void} reject
     * @returns {undefined}
     */ function executor(resolve, reject) {
            const realFile = $d7ff5355c2de279c$var$vfile(file);
            // Assume `ParseTree` (the result of the parser) matches `HeadTree` (the
            // input of the first transform).
            const parseTree = /** @type {HeadTree extends undefined ? Node : HeadTree} */ /** @type {unknown} */ self.parse(realFile);
            self.run(parseTree, realFile, function(error, tree, file) {
                if (error || !tree || !file) return realDone(error);
                // Assume `TailTree` (the output of the last transform) matches
                // `CompileTree` (the input of the compiler).
                const compileTree = /** @type {CompileTree extends undefined ? Node : CompileTree} */ /** @type {unknown} */ tree;
                const compileResult = self.stringify(compileTree, file);
                if ($d7ff5355c2de279c$var$looksLikeAValue(compileResult)) file.value = compileResult;
                else file.result = compileResult;
                realDone(error, /** @type {VFileWithOutput<CompileResult>} */ file);
            });
            /**
       * @param {Error | undefined} error
       * @param {VFileWithOutput<CompileResult> | undefined} [file]
       * @returns {undefined}
       */ function realDone(error, file) {
                if (error || !file) reject(error);
                else if (resolve) resolve(file);
                else {
                    (0, $331630515164a454$export$dcb8b3f0e2de7e49)(done, "`done` is defined if `resolve` is not");
                    done(undefined, file);
                }
            }
        }
    }
    /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > 👉 **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ processSync(file) {
        /** @type {boolean} */ let complete = false;
        /** @type {VFileWithOutput<CompileResult> | undefined} */ let result;
        this.freeze();
        $d7ff5355c2de279c$var$assertParser("processSync", this.parser || this.Parser);
        $d7ff5355c2de279c$var$assertCompiler("processSync", this.compiler || this.Compiler);
        this.process(file, realDone);
        $d7ff5355c2de279c$var$assertDone("processSync", "process", complete);
        (0, $331630515164a454$export$dcb8b3f0e2de7e49)(result, "we either bailed on an error or have a tree");
        return result;
        /**
     * @type {ProcessCallback<VFileWithOutput<CompileResult>>}
     */ function realDone(error, file) {
            complete = true;
            (0, $df5ffbd626869999$export$dd911e13ecb11e05)(error);
            result = file;
        }
    }
    /**
   * Run *transformers* on a syntax tree.
   *
   * > 👉 **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */ run(tree, file, done) {
        $d7ff5355c2de279c$var$assertNode(tree);
        this.freeze();
        const transformers = this.transformers;
        if (!done && typeof file === "function") {
            done = file;
            file = undefined;
        }
        return done ? executor(undefined, done) : new Promise(executor);
        // Note: `void`s needed for TS.
        /**
     * @param {(
     *   ((tree: TailTree extends undefined ? Node : TailTree) => undefined | void) |
     *   undefined
     * )} resolve
     * @param {(error: Error) => undefined | void} reject
     * @returns {undefined}
     */ function executor(resolve, reject) {
            (0, $331630515164a454$export$dcb8b3f0e2de7e49)(typeof file !== "function", "`file` can’t be a `done` anymore, we checked");
            const realFile = $d7ff5355c2de279c$var$vfile(file);
            transformers.run(tree, realFile, realDone);
            /**
       * @param {Error | undefined} error
       * @param {Node} outputTree
       * @param {VFile} file
       * @returns {undefined}
       */ function realDone(error, outputTree, file) {
                const resultingTree = /** @type {TailTree extends undefined ? Node : TailTree} */ outputTree || tree;
                if (error) reject(error);
                else if (resolve) resolve(resultingTree);
                else {
                    (0, $331630515164a454$export$dcb8b3f0e2de7e49)(done, "`done` is defined if `resolve` is not");
                    done(undefined, resultingTree, file);
                }
            }
        }
    }
    /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > 👉 **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */ runSync(tree, file) {
        /** @type {boolean} */ let complete = false;
        /** @type {(TailTree extends undefined ? Node : TailTree) | undefined} */ let result;
        this.run(tree, file, realDone);
        $d7ff5355c2de279c$var$assertDone("runSync", "run", complete);
        (0, $331630515164a454$export$dcb8b3f0e2de7e49)(result, "we either bailed on an error or have a tree");
        return result;
        /**
     * @type {RunCallback<TailTree extends undefined ? Node : TailTree>}
     */ function realDone(error, tree) {
            (0, $df5ffbd626869999$export$dd911e13ecb11e05)(error);
            result = tree;
            complete = true;
        }
    }
    /**
   * Compile a syntax tree.
   *
   * > 👉 **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ stringify(tree, file) {
        this.freeze();
        const realFile = $d7ff5355c2de279c$var$vfile(file);
        const compiler = this.compiler || this.Compiler;
        $d7ff5355c2de279c$var$assertCompiler("stringify", compiler);
        $d7ff5355c2de279c$var$assertNode(tree);
        return compiler(tree, realFile);
    }
    /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > 👉 **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */ use(value, ...parameters) {
        const attachers = this.attachers;
        const namespace = this.namespace;
        $d7ff5355c2de279c$var$assertUnfrozen("use", this.frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === "function") addPlugin(value, parameters);
        else if (typeof value === "object") {
            if (Array.isArray(value)) addList(value);
            else addPreset(value);
        } else throw new TypeError("Expected usable value, not `" + value + "`");
        return this;
        /**
     * @param {Pluggable} value
     * @returns {undefined}
     */ function add(value) {
            if (typeof value === "function") addPlugin(value, []);
            else if (typeof value === "object") {
                if (Array.isArray(value)) {
                    const [plugin, ...parameters] = /** @type {PluginTuple<Array<unknown>>} */ value;
                    addPlugin(plugin, parameters);
                } else addPreset(value);
            } else throw new TypeError("Expected usable value, not `" + value + "`");
        }
        /**
     * @param {Preset} result
     * @returns {undefined}
     */ function addPreset(result) {
            if (!("plugins" in result) && !("settings" in result)) throw new Error("Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither");
            addList(result.plugins);
            if (result.settings) namespace.settings = (0, (/*@__PURE__*/$parcel$interopDefault($58468e7de1e61277$exports)))(true, namespace.settings, result.settings);
        }
        /**
     * @param {PluggableList | null | undefined} plugins
     * @returns {undefined}
     */ function addList(plugins) {
            let index = -1;
            if (plugins === null || plugins === undefined) ;
            else if (Array.isArray(plugins)) while(++index < plugins.length){
                const thing = plugins[index];
                add(thing);
            }
            else throw new TypeError("Expected a list of plugins, not `" + plugins + "`");
        }
        /**
     * @param {Plugin} plugin
     * @param {Array<unknown>} parameters
     * @returns {undefined}
     */ function addPlugin(plugin, parameters) {
            let index = -1;
            let entryIndex = -1;
            while(++index < attachers.length)if (attachers[index][0] === plugin) {
                entryIndex = index;
                break;
            }
            if (entryIndex === -1) attachers.push([
                plugin,
                ...parameters
            ]);
            else if (parameters.length > 0) {
                let [primary, ...rest] = parameters;
                const currentPrimary = attachers[entryIndex][1];
                if ((0, $fe5a2b0ba2786d83$export$2e2bcd8739ae039)(currentPrimary) && (0, $fe5a2b0ba2786d83$export$2e2bcd8739ae039)(primary)) primary = (0, (/*@__PURE__*/$parcel$interopDefault($58468e7de1e61277$exports)))(true, currentPrimary, primary);
                attachers[entryIndex] = [
                    plugin,
                    primary,
                    ...rest
                ];
            }
        }
    }
}
const $d7ff5355c2de279c$export$7cc1b2fe10c52bb = new $d7ff5355c2de279c$export$c30cd198d731db19().freeze();
/**
 * Assert a parser is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Parser}
 */ function $d7ff5355c2de279c$var$assertParser(name, value) {
    if (typeof value !== "function") throw new TypeError("Cannot `" + name + "` without `parser`");
}
/**
 * Assert a compiler is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Compiler}
 */ function $d7ff5355c2de279c$var$assertCompiler(name, value) {
    if (typeof value !== "function") throw new TypeError("Cannot `" + name + "` without `compiler`");
}
/**
 * Assert the processor is not frozen.
 *
 * @param {string} name
 * @param {unknown} frozen
 * @returns {asserts frozen is false}
 */ function $d7ff5355c2de279c$var$assertUnfrozen(name, frozen) {
    if (frozen) throw new Error("Cannot call `" + name + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.");
}
/**
 * Assert `node` is a unist node.
 *
 * @param {unknown} node
 * @returns {asserts node is Node}
 */ function $d7ff5355c2de279c$var$assertNode(node) {
    // `isPlainObj` unfortunately uses `any` instead of `unknown`.
    // type-coverage:ignore-next-line
    if (!(0, $fe5a2b0ba2786d83$export$2e2bcd8739ae039)(node) || typeof node.type !== "string") throw new TypeError("Expected node, got `" + node + "`");
}
/**
 * Assert that `complete` is `true`.
 *
 * @param {string} name
 * @param {string} asyncName
 * @param {unknown} complete
 * @returns {asserts complete is true}
 */ function $d7ff5355c2de279c$var$assertDone(name, asyncName, complete) {
    if (!complete) throw new Error("`" + name + "` finished async. Use `" + asyncName + "` instead");
}
/**
 * @param {Compatible | undefined} [value]
 * @returns {VFile}
 */ function $d7ff5355c2de279c$var$vfile(value) {
    return $d7ff5355c2de279c$var$looksLikeAVFile(value) ? value : new (0, $d2830ef88effe228$export$93dff69eb10dc7ce)(value);
}
/**
 * @param {Compatible | undefined} [value]
 * @returns {value is VFile}
 */ function $d7ff5355c2de279c$var$looksLikeAVFile(value) {
    return Boolean(value && typeof value === "object" && "message" in value && "messages" in value);
}
/**
 * @param {unknown} [value]
 * @returns {value is Value}
 */ function $d7ff5355c2de279c$var$looksLikeAValue(value) {
    return typeof value === "string" || $d7ff5355c2de279c$var$isUint8Array(value);
}
/**
 * Assert `value` is an `Uint8Array`.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Uint8Array}
 *   Whether `value` is an `Uint8Array`.
 */ function $d7ff5355c2de279c$var$isUint8Array(value) {
    return Boolean(value && typeof value === "object" && "byteLength" in value && "byteOffset" in value);
}




const $c7a38d2a5c855e00$var$own = {}.hasOwnProperty;
const $c7a38d2a5c855e00$var$changelog = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md";
/** @type {PluggableList} */ const $c7a38d2a5c855e00$var$emptyPlugins = [];
/** @type {Readonly<RemarkRehypeOptions>} */ const $c7a38d2a5c855e00$var$emptyRemarkRehypeOptions = {
    allowDangerousHtml: true
};
const $c7a38d2a5c855e00$var$safeProtocol = /^(https?|ircs?|mailto|xmpp)$/i;
// Mutable because we `delete` any time it’s used and a message is sent.
/** @type {ReadonlyArray<Readonly<Deprecation>>} */ const $c7a38d2a5c855e00$var$deprecations = [
    {
        from: "astPlugins",
        id: "remove-buggy-html-in-markdown-parser"
    },
    {
        from: "allowDangerousHtml",
        id: "remove-buggy-html-in-markdown-parser"
    },
    {
        from: "allowNode",
        id: "replace-allownode-allowedtypes-and-disallowedtypes",
        to: "allowElement"
    },
    {
        from: "allowedTypes",
        id: "replace-allownode-allowedtypes-and-disallowedtypes",
        to: "allowedElements"
    },
    {
        from: "disallowedTypes",
        id: "replace-allownode-allowedtypes-and-disallowedtypes",
        to: "disallowedElements"
    },
    {
        from: "escapeHtml",
        id: "remove-buggy-html-in-markdown-parser"
    },
    {
        from: "includeElementIndex",
        id: "#remove-includeelementindex"
    },
    {
        from: "includeNodeIndex",
        id: "change-includenodeindex-to-includeelementindex"
    },
    {
        from: "linkTarget",
        id: "remove-linktarget"
    },
    {
        from: "plugins",
        id: "change-plugins-to-remarkplugins",
        to: "remarkPlugins"
    },
    {
        from: "rawSourcePos",
        id: "#remove-rawsourcepos"
    },
    {
        from: "renderers",
        id: "change-renderers-to-components",
        to: "components"
    },
    {
        from: "source",
        id: "change-source-to-children",
        to: "children"
    },
    {
        from: "sourcePos",
        id: "#remove-sourcepos"
    },
    {
        from: "transformImageUri",
        id: "#add-urltransform",
        to: "urlTransform"
    },
    {
        from: "transformLinkUri",
        id: "#add-urltransform",
        to: "urlTransform"
    }
];
function $c7a38d2a5c855e00$export$7460c8b7e4ce9582(options) {
    const allowedElements = options.allowedElements;
    const allowElement = options.allowElement;
    const children = options.children || "";
    const className = options.className;
    const components = options.components;
    const disallowedElements = options.disallowedElements;
    const rehypePlugins = options.rehypePlugins || $c7a38d2a5c855e00$var$emptyPlugins;
    const remarkPlugins = options.remarkPlugins || $c7a38d2a5c855e00$var$emptyPlugins;
    const remarkRehypeOptions = options.remarkRehypeOptions ? {
        ...options.remarkRehypeOptions,
        ...$c7a38d2a5c855e00$var$emptyRemarkRehypeOptions
    } : $c7a38d2a5c855e00$var$emptyRemarkRehypeOptions;
    const skipHtml = options.skipHtml;
    const unwrapDisallowed = options.unwrapDisallowed;
    const urlTransform = options.urlTransform || $c7a38d2a5c855e00$export$ca5e94754123e2f3;
    const processor = (0, $d7ff5355c2de279c$export$7cc1b2fe10c52bb)().use((0, $50644eab85d80578$export$2e2bcd8739ae039)).use(remarkPlugins).use((0, $3fc37f6f9c7aa14c$export$2e2bcd8739ae039), remarkRehypeOptions).use(rehypePlugins);
    const file = new (0, $d2830ef88effe228$export$93dff69eb10dc7ce)();
    if (typeof children === "string") file.value = children;
    else (0, $331630515164a454$export$565e9d9bd6b6e0d4)("Unexpected value `" + children + "` for `children` prop, expected `string`");
    if (allowedElements && disallowedElements) (0, $331630515164a454$export$565e9d9bd6b6e0d4)("Unexpected combined `allowedElements` and `disallowedElements`, expected one or the other");
    for (const deprecation of $c7a38d2a5c855e00$var$deprecations)if (Object.hasOwn(options, deprecation.from)) (0, $331630515164a454$export$565e9d9bd6b6e0d4)("Unexpected `" + deprecation.from + "` prop, " + (deprecation.to ? "use `" + deprecation.to + "` instead" : "remove it") + " (see <" + $c7a38d2a5c855e00$var$changelog + "#" + deprecation.id + "> for more info)");
    const mdastTree = processor.parse(file);
    /** @type {Nodes} */ let hastTree = processor.runSync(mdastTree, file);
    // Wrap in `div` if there’s a class name.
    if (className) hastTree = {
        type: "element",
        tagName: "div",
        properties: {
            className: className
        },
        // Assume no doctypes.
        children: /** @type {Array<ElementContent>} */ hastTree.type === "root" ? hastTree.children : [
            hastTree
        ]
    };
    (0, $54f08257f9dfe0bf$export$bf638b60ea8b89b7)(hastTree, transform);
    return (0, $9143a58b0eb89e6c$export$59c10052b2dee561)(hastTree, {
        Fragment: $C7mD2.Fragment,
        components: components,
        ignoreInvalidStyle: true,
        jsx: $C7mD2.jsx,
        jsxs: $C7mD2.jsxs,
        passKeys: true,
        passNode: true
    });
    /** @type {Visitor} */ function transform(node, index, parent) {
        if (node.type === "raw" && parent && typeof index === "number") {
            if (skipHtml) parent.children.splice(index, 1);
            else parent.children[index] = {
                type: "text",
                value: node.value
            };
            return index;
        }
        if (node.type === "element") {
            /** @type {string} */ let key;
            for(key in 0, $fa8d6da92b4f6774$export$de3e062aedff083a)if ($c7a38d2a5c855e00$var$own.call((0, $fa8d6da92b4f6774$export$de3e062aedff083a), key) && $c7a38d2a5c855e00$var$own.call(node.properties, key)) {
                const value = node.properties[key];
                const test = (0, $fa8d6da92b4f6774$export$de3e062aedff083a)[key];
                if (test === null || test.includes(node.tagName)) node.properties[key] = urlTransform(String(value || ""), key, node);
            }
        }
        if (node.type === "element") {
            let remove = allowedElements ? !allowedElements.includes(node.tagName) : disallowedElements ? disallowedElements.includes(node.tagName) : false;
            if (!remove && allowElement && typeof index === "number") remove = !allowElement(node, index, parent);
            if (remove && parent && typeof index === "number") {
                if (unwrapDisallowed && node.children) parent.children.splice(index, 1, ...node.children);
                else parent.children.splice(index, 1);
                return index;
            }
        }
    }
}
function $c7a38d2a5c855e00$export$ca5e94754123e2f3(value) {
    return (0, $161d5a87d2da344f$export$d130a2d684099e5a)(value, $c7a38d2a5c855e00$var$safeProtocol);
}


/// <reference types="remark-parse" />
/// <reference types="remark-stringify" />
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-gfm').Options} MdastOptions
 * @typedef {import('micromark-extension-gfm').Options} MicromarkOptions
 * @typedef {import('unified').Processor<Root>} Processor
 */ /**
 * @typedef {MicromarkOptions & MdastOptions} Options
 *   Configuration.
 */ /**
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 */ /**
 * @typedef {import('mdast-util-gfm-table').Options} Options
 *   Configuration.
 */ /**
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-from-markdown').Transform} FromMarkdownTransform
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 *
 * @typedef {import('mdast-util-find-and-replace').RegExpMatchObject} RegExpMatchObject
 * @typedef {import('mdast-util-find-and-replace').ReplaceFunction} ReplaceFunction
 */ /**
 * Count how often a character (or substring) is used in a string.
 *
 * @param {string} value
 *   Value to search in.
 * @param {string} character
 *   Character (or substring) to look for.
 * @return {number}
 *   Number of times `character` occurred in `value`.
 */ function $06b1b520d0d45702$export$fa42eaa97a352e23(value, character) {
    const source = String(value);
    if (typeof character !== "string") throw new TypeError("Expected character");
    let count = 0;
    let index = source.indexOf(character);
    while(index !== -1){
        count++;
        index = source.indexOf(character, index + character.length);
    }
    return count;
}




/**
 * @typedef {import('mdast').Nodes} Nodes
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Text} Text
 * @typedef {import('unist-util-visit-parents').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */ /**
 * @typedef RegExpMatchObject
 *   Info on the match.
 * @property {number} index
 *   The index of the search at which the result was found.
 * @property {string} input
 *   A copy of the search string in the text node.
 * @property {[...Array<Parents>, Text]} stack
 *   All ancestors of the text node, where the last node is the text itself.
 *
 * @typedef {RegExp | string} Find
 *   Pattern to find.
 *
 *   Strings are escaped and then turned into global expressions.
 *
 * @typedef {Array<FindAndReplaceTuple>} FindAndReplaceList
 *   Several find and replaces, in array form.
 *
 * @typedef {[Find, Replace?]} FindAndReplaceTuple
 *   Find and replace in tuple form.
 *
 * @typedef {ReplaceFunction | string | null | undefined} Replace
 *   Thing to replace with.
 *
 * @callback ReplaceFunction
 *   Callback called when a search matches.
 * @param {...any} parameters
 *   The parameters are the result of corresponding search expression:
 *
 *   * `value` (`string`) — whole match
 *   * `...capture` (`Array<string>`) — matches from regex capture groups
 *   * `match` (`RegExpMatchObject`) — info on the match
 * @returns {Array<PhrasingContent> | PhrasingContent | string | false | null | undefined}
 *   Thing to replace with.
 *
 *   * when `null`, `undefined`, `''`, remove the match
 *   * …or when `false`, do not replace at all
 *   * …or when `string`, replace with a text node of that value
 *   * …or when `Node` or `Array<Node>`, replace with those nodes
 *
 * @typedef {[RegExp, ReplaceFunction]} Pair
 *   Normalized find and replace.
 *
 * @typedef {Array<Pair>} Pairs
 *   All find and replaced.
 *
 * @typedef Options
 *   Configuration.
 * @property {Test | null | undefined} [ignore]
 *   Test for which nodes to ignore (optional).
 */ function $a9ff5fa6fe4066e9$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new TypeError("Expected a string");
    // Escape characters with special meaning either inside or outside character sets.
    // Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
    return string.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}




function $eb479c0e8db80b5a$export$fb306ebf003fc574(tree, list, options) {
    const settings = options || {};
    const ignored = (0, $a74142eedbb1409b$export$9c68d69a4c5bbcf9)(settings.ignore || []);
    const pairs = $eb479c0e8db80b5a$var$toPairs(list);
    let pairIndex = -1;
    while(++pairIndex < pairs.length)(0, $12fffbe49747f304$export$70008a21eb6de899)(tree, "text", visitor);
    /** @type {import('unist-util-visit-parents').BuildVisitor<Root, 'text'>} */ function visitor(node, parents) {
        let index = -1;
        /** @type {Parents | undefined} */ let grandparent;
        while(++index < parents.length){
            const parent = parents[index];
            /** @type {Array<Nodes> | undefined} */ const siblings = grandparent ? grandparent.children : undefined;
            if (ignored(parent, siblings ? siblings.indexOf(parent) : undefined, grandparent)) return;
            grandparent = parent;
        }
        if (grandparent) return handler(node, parents);
    }
    /**
   * Handle a text node which is not in an ignored parent.
   *
   * @param {Text} node
   *   Text node.
   * @param {Array<Parents>} parents
   *   Parents.
   * @returns {VisitorResult}
   *   Result.
   */ function handler(node, parents) {
        const parent = parents[parents.length - 1];
        const find = pairs[pairIndex][0];
        const replace = pairs[pairIndex][1];
        let start = 0;
        /** @type {Array<Nodes>} */ const siblings = parent.children;
        const index = siblings.indexOf(node);
        let change = false;
        /** @type {Array<PhrasingContent>} */ let nodes = [];
        find.lastIndex = 0;
        let match = find.exec(node.value);
        while(match){
            const position = match.index;
            /** @type {RegExpMatchObject} */ const matchObject = {
                index: match.index,
                input: match.input,
                stack: [
                    ...parents,
                    node
                ]
            };
            let value = replace(...match, matchObject);
            if (typeof value === "string") value = value.length > 0 ? {
                type: "text",
                value: value
            } : undefined;
            // It wasn’t a match after all.
            if (value === false) // False acts as if there was no match.
            // So we need to reset `lastIndex`, which currently being at the end of
            // the current match, to the beginning.
            find.lastIndex = position + 1;
            else {
                if (start !== position) nodes.push({
                    type: "text",
                    value: node.value.slice(start, position)
                });
                if (Array.isArray(value)) nodes.push(...value);
                else if (value) nodes.push(value);
                start = position + match[0].length;
                change = true;
            }
            if (!find.global) break;
            match = find.exec(node.value);
        }
        if (change) {
            if (start < node.value.length) nodes.push({
                type: "text",
                value: node.value.slice(start)
            });
            parent.children.splice(index, 1, ...nodes);
        } else nodes = [
            node
        ];
        return index + nodes.length;
    }
}
/**
 * Turn a tuple or a list of tuples into pairs.
 *
 * @param {FindAndReplaceList | FindAndReplaceTuple} tupleOrList
 *   Schema.
 * @returns {Pairs}
 *   Clean pairs.
 */ function $eb479c0e8db80b5a$var$toPairs(tupleOrList) {
    /** @type {Pairs} */ const result = [];
    if (!Array.isArray(tupleOrList)) throw new TypeError("Expected find and replace tuple or list of tuples");
    /** @type {FindAndReplaceList} */ // @ts-expect-error: correct.
    const list = !tupleOrList[0] || Array.isArray(tupleOrList[0]) ? tupleOrList : [
        tupleOrList
    ];
    let index = -1;
    while(++index < list.length){
        const tuple = list[index];
        result.push([
            $eb479c0e8db80b5a$var$toExpression(tuple[0]),
            $eb479c0e8db80b5a$var$toFunction(tuple[1])
        ]);
    }
    return result;
}
/**
 * Turn a find into an expression.
 *
 * @param {Find} find
 *   Find.
 * @returns {RegExp}
 *   Expression.
 */ function $eb479c0e8db80b5a$var$toExpression(find) {
    return typeof find === "string" ? new RegExp((0, $a9ff5fa6fe4066e9$export$2e2bcd8739ae039)(find), "g") : find;
}
/**
 * Turn a replace into a function.
 *
 * @param {Replace} replace
 *   Replace.
 * @returns {ReplaceFunction}
 *   Function.
 */ function $eb479c0e8db80b5a$var$toFunction(replace) {
    return typeof replace === "function" ? replace : function() {
        return replace;
    };
}


/** @type {ConstructName} */ const $04fc5af4d0498e38$var$inConstruct = "phrasing";
/** @type {Array<ConstructName>} */ const $04fc5af4d0498e38$var$notInConstruct = [
    "autolink",
    "link",
    "image",
    "label"
];
function $04fc5af4d0498e38$export$b6afdfff2163546f() {
    return {
        transforms: [
            $04fc5af4d0498e38$var$transformGfmAutolinkLiterals
        ],
        enter: {
            literalAutolink: $04fc5af4d0498e38$var$enterLiteralAutolink,
            literalAutolinkEmail: $04fc5af4d0498e38$var$enterLiteralAutolinkValue,
            literalAutolinkHttp: $04fc5af4d0498e38$var$enterLiteralAutolinkValue,
            literalAutolinkWww: $04fc5af4d0498e38$var$enterLiteralAutolinkValue
        },
        exit: {
            literalAutolink: $04fc5af4d0498e38$var$exitLiteralAutolink,
            literalAutolinkEmail: $04fc5af4d0498e38$var$exitLiteralAutolinkEmail,
            literalAutolinkHttp: $04fc5af4d0498e38$var$exitLiteralAutolinkHttp,
            literalAutolinkWww: $04fc5af4d0498e38$var$exitLiteralAutolinkWww
        }
    };
}
function $04fc5af4d0498e38$export$d3ace9096b01c39d() {
    return {
        unsafe: [
            {
                character: "@",
                before: "[+\\-.\\w]",
                after: "[\\-.\\w]",
                inConstruct: $04fc5af4d0498e38$var$inConstruct,
                notInConstruct: $04fc5af4d0498e38$var$notInConstruct
            },
            {
                character: ".",
                before: "[Ww]",
                after: "[\\-.\\w]",
                inConstruct: $04fc5af4d0498e38$var$inConstruct,
                notInConstruct: $04fc5af4d0498e38$var$notInConstruct
            },
            {
                character: ":",
                before: "[ps]",
                after: "\\/",
                inConstruct: $04fc5af4d0498e38$var$inConstruct,
                notInConstruct: $04fc5af4d0498e38$var$notInConstruct
            }
        ]
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $04fc5af4d0498e38$var$enterLiteralAutolink(token) {
    this.enter({
        type: "link",
        title: null,
        url: "",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $04fc5af4d0498e38$var$enterLiteralAutolinkValue(token) {
    this.config.enter.autolinkProtocol.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $04fc5af4d0498e38$var$exitLiteralAutolinkHttp(token) {
    this.config.exit.autolinkProtocol.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $04fc5af4d0498e38$var$exitLiteralAutolinkWww(token) {
    this.config.exit.data.call(this, token);
    const node = this.stack[this.stack.length - 1];
    (0, $331630515164a454$export$dcb8b3f0e2de7e49)(node.type === "link");
    node.url = "http://" + this.sliceSerialize(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $04fc5af4d0498e38$var$exitLiteralAutolinkEmail(token) {
    this.config.exit.autolinkEmail.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $04fc5af4d0498e38$var$exitLiteralAutolink(token) {
    this.exit(token);
}
/** @type {FromMarkdownTransform} */ function $04fc5af4d0498e38$var$transformGfmAutolinkLiterals(tree) {
    (0, $eb479c0e8db80b5a$export$fb306ebf003fc574)(tree, [
        [
            /(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi,
            $04fc5af4d0498e38$var$findUrl
        ],
        [
            /([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/g,
            $04fc5af4d0498e38$var$findEmail
        ]
    ], {
        ignore: [
            "link",
            "linkReference"
        ]
    });
}
/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} protocol
 * @param {string} domain
 * @param {string} path
 * @param {RegExpMatchObject} match
 * @returns {Array<PhrasingContent> | Link | false}
 */ // eslint-disable-next-line max-params
function $04fc5af4d0498e38$var$findUrl(_, protocol, domain, path, match) {
    let prefix = "";
    // Not an expected previous character.
    if (!$04fc5af4d0498e38$var$previous(match)) return false;
    // Treat `www` as part of the domain.
    if (/^w/i.test(protocol)) {
        domain = protocol + domain;
        protocol = "";
        prefix = "http://";
    }
    if (!$04fc5af4d0498e38$var$isCorrectDomain(domain)) return false;
    const parts = $04fc5af4d0498e38$var$splitUrl(domain + path);
    if (!parts[0]) return false;
    /** @type {Link} */ const result = {
        type: "link",
        title: null,
        url: prefix + protocol + parts[0],
        children: [
            {
                type: "text",
                value: protocol + parts[0]
            }
        ]
    };
    if (parts[1]) return [
        result,
        {
            type: "text",
            value: parts[1]
        }
    ];
    return result;
}
/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} atext
 * @param {string} label
 * @param {RegExpMatchObject} match
 * @returns {Link | false}
 */ function $04fc5af4d0498e38$var$findEmail(_, atext, label, match) {
    if (// Not an expected previous character.
    !$04fc5af4d0498e38$var$previous(match, true) || // Label ends in not allowed character.
    /[-\d_]$/.test(label)) return false;
    return {
        type: "link",
        title: null,
        url: "mailto:" + atext + "@" + label,
        children: [
            {
                type: "text",
                value: atext + "@" + label
            }
        ]
    };
}
/**
 * @param {string} domain
 * @returns {boolean}
 */ function $04fc5af4d0498e38$var$isCorrectDomain(domain) {
    const parts = domain.split(".");
    if (parts.length < 2 || parts[parts.length - 1] && (/_/.test(parts[parts.length - 1]) || !/[a-zA-Z\d]/.test(parts[parts.length - 1])) || parts[parts.length - 2] && (/_/.test(parts[parts.length - 2]) || !/[a-zA-Z\d]/.test(parts[parts.length - 2]))) return false;
    return true;
}
/**
 * @param {string} url
 * @returns {[string, string | undefined]}
 */ function $04fc5af4d0498e38$var$splitUrl(url) {
    const trailExec = /[!"&'),.:;<>?\]}]+$/.exec(url);
    if (!trailExec) return [
        url,
        undefined
    ];
    url = url.slice(0, trailExec.index);
    let trail = trailExec[0];
    let closingParenIndex = trail.indexOf(")");
    const openingParens = (0, $06b1b520d0d45702$export$fa42eaa97a352e23)(url, "(");
    let closingParens = (0, $06b1b520d0d45702$export$fa42eaa97a352e23)(url, ")");
    while(closingParenIndex !== -1 && openingParens > closingParens){
        url += trail.slice(0, closingParenIndex + 1);
        trail = trail.slice(closingParenIndex + 1);
        closingParenIndex = trail.indexOf(")");
        closingParens++;
    }
    return [
        url,
        trail
    ];
}
/**
 * @param {RegExpMatchObject} match
 * @param {boolean | null | undefined} [email=false]
 * @returns {boolean}
 */ function $04fc5af4d0498e38$var$previous(match, email) {
    const code = match.input.charCodeAt(match.index - 1);
    return (match.index === 0 || (0, $74ae855ebddfe8fb$export$a0ff789c034ffdf4)(code) || (0, $74ae855ebddfe8fb$export$aa04114dd888a7a0)(code)) && (!email || code !== 47);
}


/**
 * @typedef {import('mdast').FootnoteDefinition} FootnoteDefinition
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Map} Map
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 */ 

$4cef1d95953b5f14$var$footnoteReference.peek = $4cef1d95953b5f14$var$footnoteReferencePeek;
function $4cef1d95953b5f14$export$c9d5ad4bdf6ff801() {
    return {
        enter: {
            gfmFootnoteDefinition: $4cef1d95953b5f14$var$enterFootnoteDefinition,
            gfmFootnoteDefinitionLabelString: $4cef1d95953b5f14$var$enterFootnoteDefinitionLabelString,
            gfmFootnoteCall: $4cef1d95953b5f14$var$enterFootnoteCall,
            gfmFootnoteCallString: $4cef1d95953b5f14$var$enterFootnoteCallString
        },
        exit: {
            gfmFootnoteDefinition: $4cef1d95953b5f14$var$exitFootnoteDefinition,
            gfmFootnoteDefinitionLabelString: $4cef1d95953b5f14$var$exitFootnoteDefinitionLabelString,
            gfmFootnoteCall: $4cef1d95953b5f14$var$exitFootnoteCall,
            gfmFootnoteCallString: $4cef1d95953b5f14$var$exitFootnoteCallString
        }
    };
}
function $4cef1d95953b5f14$export$3727766a73a6c09f() {
    return {
        // This is on by default already.
        unsafe: [
            {
                character: "[",
                inConstruct: [
                    "phrasing",
                    "label",
                    "reference"
                ]
            }
        ],
        handlers: {
            footnoteDefinition: $4cef1d95953b5f14$var$footnoteDefinition,
            footnoteReference: $4cef1d95953b5f14$var$footnoteReference
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $4cef1d95953b5f14$var$enterFootnoteDefinition(token) {
    this.enter({
        type: "footnoteDefinition",
        identifier: "",
        label: "",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $4cef1d95953b5f14$var$enterFootnoteDefinitionLabelString() {
    this.buffer();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $4cef1d95953b5f14$var$exitFootnoteDefinitionLabelString(token) {
    const label = this.resume();
    const node = this.stack[this.stack.length - 1];
    (0, $331630515164a454$export$dcb8b3f0e2de7e49)(node.type === "footnoteDefinition");
    node.label = label;
    node.identifier = (0, $46d36bfd48dea0be$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $4cef1d95953b5f14$var$exitFootnoteDefinition(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $4cef1d95953b5f14$var$enterFootnoteCall(token) {
    this.enter({
        type: "footnoteReference",
        identifier: "",
        label: ""
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $4cef1d95953b5f14$var$enterFootnoteCallString() {
    this.buffer();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $4cef1d95953b5f14$var$exitFootnoteCallString(token) {
    const label = this.resume();
    const node = this.stack[this.stack.length - 1];
    (0, $331630515164a454$export$dcb8b3f0e2de7e49)(node.type === "footnoteReference");
    node.label = label;
    node.identifier = (0, $46d36bfd48dea0be$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $4cef1d95953b5f14$var$exitFootnoteCall(token) {
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {FootnoteReference} node
 */ function $4cef1d95953b5f14$var$footnoteReference(node, _, state, info) {
    const tracker = state.createTracker(info);
    let value = tracker.move("[^");
    const exit = state.enter("footnoteReference");
    const subexit = state.enter("reference");
    value += tracker.move(state.safe(state.associationId(node), {
        ...tracker.current(),
        before: value,
        after: "]"
    }));
    subexit();
    exit();
    value += tracker.move("]");
    return value;
}
/** @type {ToMarkdownHandle} */ function $4cef1d95953b5f14$var$footnoteReferencePeek() {
    return "[";
}
/**
 * @type {ToMarkdownHandle}
 * @param {FootnoteDefinition} node
 */ function $4cef1d95953b5f14$var$footnoteDefinition(node, _, state, info) {
    const tracker = state.createTracker(info);
    let value = tracker.move("[^");
    const exit = state.enter("footnoteDefinition");
    const subexit = state.enter("label");
    value += tracker.move(state.safe(state.associationId(node), {
        ...tracker.current(),
        before: value,
        after: "]"
    }));
    subexit();
    value += tracker.move("]:" + (node.children && node.children.length > 0 ? " " : ""));
    tracker.shift(4);
    value += tracker.move(state.indentLines(state.containerFlow(node, tracker.current()), $4cef1d95953b5f14$var$map));
    exit();
    return value;
}
/** @type {Map} */ function $4cef1d95953b5f14$var$map(line, index, blank) {
    if (index === 0) return line;
    return (blank ? "" : "    ") + line;
}


/**
 * @typedef {import('mdast').Delete} Delete
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 */ /**
 * List of constructs that occur in phrasing (paragraphs, headings), but cannot
 * contain strikethrough.
 * So they sort of cancel each other out.
 * Note: could use a better name.
 *
 * Note: keep in sync with: <https://github.com/syntax-tree/mdast-util-to-markdown/blob/8ce8dbf/lib/unsafe.js#L14>
 *
 * @type {Array<ConstructName>}
 */ const $840e3e37503239ce$var$constructsWithoutStrikethrough = [
    "autolink",
    "destinationLiteral",
    "destinationRaw",
    "reference",
    "titleQuote",
    "titleApostrophe"
];
$840e3e37503239ce$var$handleDelete.peek = $840e3e37503239ce$var$peekDelete;
function $840e3e37503239ce$export$34d64e709dd0b9bb() {
    return {
        canContainEols: [
            "delete"
        ],
        enter: {
            strikethrough: $840e3e37503239ce$var$enterStrikethrough
        },
        exit: {
            strikethrough: $840e3e37503239ce$var$exitStrikethrough
        }
    };
}
function $840e3e37503239ce$export$1632835bd2c84956() {
    return {
        unsafe: [
            {
                character: "~",
                inConstruct: "phrasing",
                notInConstruct: $840e3e37503239ce$var$constructsWithoutStrikethrough
            }
        ],
        handlers: {
            delete: $840e3e37503239ce$var$handleDelete
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $840e3e37503239ce$var$enterStrikethrough(token) {
    this.enter({
        type: "delete",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $840e3e37503239ce$var$exitStrikethrough(token) {
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {Delete} node
 */ function $840e3e37503239ce$var$handleDelete(node, _, state, info) {
    const tracker = state.createTracker(info);
    const exit = state.enter("strikethrough");
    let value = tracker.move("~~");
    value += state.containerPhrasing(node, {
        ...tracker.current(),
        before: value,
        after: "~"
    });
    value += tracker.move("~~");
    exit();
    return value;
}
/** @type {ToMarkdownHandle} */ function $840e3e37503239ce$var$peekDelete() {
    return "~";
}


/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Table} Table
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('mdast').TableRow} TableRow
 *
 * @typedef {import('markdown-table').Options} MarkdownTableOptions
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').State} State
 * @typedef {import('mdast-util-to-markdown').Info} Info
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [tableCellPadding=true]
 *   Whether to add a space of padding between delimiters and cells (default:
 *   `true`).
 * @property {boolean | null | undefined} [tablePipeAlign=true]
 *   Whether to align the delimiters (default: `true`).
 * @property {MarkdownTableOptions['stringLength'] | null | undefined} [stringLength]
 *   Function to detect the length of table cell content, used when aligning
 *   the delimiters between cells (optional).
 */ 
/**
 * @typedef Options
 *   Configuration (optional).
 * @property {string|null|Array<string|null|undefined>} [align]
 *   One style for all columns, or styles for their respective columns.
 *   Each style is either `'l'` (left), `'r'` (right), or `'c'` (center).
 *   Other values are treated as `''`, which doesn’t place the colon in the
 *   alignment row but does align left.
 *   *Only the lowercased first character is used, so `Right` is fine.*
 * @property {boolean} [padding=true]
 *   Whether to add a space of padding between delimiters and cells.
 *
 *   When `true`, there is padding:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there is no padding:
 *
 *   ```markdown
 *   |Alpha|B    |
 *   |-----|-----|
 *   |C    |Delta|
 *   ```
 * @property {boolean} [delimiterStart=true]
 *   Whether to begin each row with the delimiter.
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are starting delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no starting delimiters:
 *
 *   ```markdown
 *   Alpha | B     |
 *   ----- | ----- |
 *   C     | Delta |
 *   ```
 * @property {boolean} [delimiterEnd=true]
 *   Whether to end each row with the delimiter.
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B
 *   | ----- | -----
 *   | C     | Delta
 *   ```
 * @property {boolean} [alignDelimiters=true]
 *   Whether to align the delimiters.
 *   By default, they are aligned:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   Pass `false` to make them staggered:
 *
 *   ```markdown
 *   | Alpha | B |
 *   | - | - |
 *   | C | Delta |
 *   ```
 * @property {(value: string) => number} [stringLength]
 *   Function to detect the length of table cell content.
 *   This is used when aligning the delimiters (`|`) between table cells.
 *   Full-width characters and emoji mess up delimiter alignment when viewing
 *   the markdown source.
 *   To fix this, you can pass this function, which receives the cell content
 *   and returns its “visible” size.
 *   Note that what is and isn’t visible depends on where the text is displayed.
 *
 *   Without such a function, the following:
 *
 *   ```js
 *   markdownTable([
 *     ['Alpha', 'Bravo'],
 *     ['中文', 'Charlie'],
 *     ['👩‍❤️‍👩', 'Delta']
 *   ])
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo |
 *   | - | - |
 *   | 中文 | Charlie |
 *   | 👩‍❤️‍👩 | Delta |
 *   ```
 *
 *   With [`string-width`](https://github.com/sindresorhus/string-width):
 *
 *   ```js
 *   import stringWidth from 'string-width'
 *
 *   markdownTable(
 *     [
 *       ['Alpha', 'Bravo'],
 *       ['中文', 'Charlie'],
 *       ['👩‍❤️‍👩', 'Delta']
 *     ],
 *     {stringLength: stringWidth}
 *   )
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo   |
 *   | ----- | ------- |
 *   | 中文  | Charlie |
 *   | 👩‍❤️‍👩    | Delta   |
 *   ```
 */ /**
 * @typedef {Options} MarkdownTableOptions
 * @todo
 *   Remove next major.
 */ /**
 * Generate a markdown ([GFM](https://docs.github.com/en/github/writing-on-github/working-with-advanced-formatting/organizing-information-with-tables)) table..
 *
 * @param {Array<Array<string|null|undefined>>} table
 *   Table data (matrix of strings).
 * @param {Options} [options]
 *   Configuration (optional).
 * @returns {string}
 */ function $b30d3756ce242a78$export$cdb7288612c4f3d6(table, options = {}) {
    const align = (options.align || []).concat();
    const stringLength = options.stringLength || $b30d3756ce242a78$var$defaultStringLength;
    /** @type {Array<number>} Character codes as symbols for alignment per column. */ const alignments = [];
    /** @type {Array<Array<string>>} Cells per row. */ const cellMatrix = [];
    /** @type {Array<Array<number>>} Sizes of each cell per row. */ const sizeMatrix = [];
    /** @type {Array<number>} */ const longestCellByColumn = [];
    let mostCellsPerRow = 0;
    let rowIndex = -1;
    // This is a superfluous loop if we don’t align delimiters, but otherwise we’d
    // do superfluous work when aligning, so optimize for aligning.
    while(++rowIndex < table.length){
        /** @type {Array<string>} */ const row = [];
        /** @type {Array<number>} */ const sizes = [];
        let columnIndex = -1;
        if (table[rowIndex].length > mostCellsPerRow) mostCellsPerRow = table[rowIndex].length;
        while(++columnIndex < table[rowIndex].length){
            const cell = $b30d3756ce242a78$var$serialize(table[rowIndex][columnIndex]);
            if (options.alignDelimiters !== false) {
                const size = stringLength(cell);
                sizes[columnIndex] = size;
                if (longestCellByColumn[columnIndex] === undefined || size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            }
            row.push(cell);
        }
        cellMatrix[rowIndex] = row;
        sizeMatrix[rowIndex] = sizes;
    }
    // Figure out which alignments to use.
    let columnIndex = -1;
    if (typeof align === "object" && "length" in align) while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = $b30d3756ce242a78$var$toAlignment(align[columnIndex]);
    else {
        const code = $b30d3756ce242a78$var$toAlignment(align);
        while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = code;
    }
    // Inject the alignment row.
    columnIndex = -1;
    /** @type {Array<string>} */ const row = [];
    /** @type {Array<number>} */ const sizes = [];
    while(++columnIndex < mostCellsPerRow){
        const code = alignments[columnIndex];
        let before = "";
        let after = "";
        if (code === 99 /* `c` */ ) {
            before = ":";
            after = ":";
        } else if (code === 108 /* `l` */ ) before = ":";
        else if (code === 114 /* `r` */ ) after = ":";
        // There *must* be at least one hyphen-minus in each alignment cell.
        let size = options.alignDelimiters === false ? 1 : Math.max(1, longestCellByColumn[columnIndex] - before.length - after.length);
        const cell = before + "-".repeat(size) + after;
        if (options.alignDelimiters !== false) {
            size = before.length + size + after.length;
            if (size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            sizes[columnIndex] = size;
        }
        row[columnIndex] = cell;
    }
    // Inject the alignment row.
    cellMatrix.splice(1, 0, row);
    sizeMatrix.splice(1, 0, sizes);
    rowIndex = -1;
    /** @type {Array<string>} */ const lines = [];
    while(++rowIndex < cellMatrix.length){
        const row = cellMatrix[rowIndex];
        const sizes = sizeMatrix[rowIndex];
        columnIndex = -1;
        /** @type {Array<string>} */ const line = [];
        while(++columnIndex < mostCellsPerRow){
            const cell = row[columnIndex] || "";
            let before = "";
            let after = "";
            if (options.alignDelimiters !== false) {
                const size = longestCellByColumn[columnIndex] - (sizes[columnIndex] || 0);
                const code = alignments[columnIndex];
                if (code === 114 /* `r` */ ) before = " ".repeat(size);
                else if (code === 99 /* `c` */ ) {
                    if (size % 2) {
                        before = " ".repeat(size / 2 + 0.5);
                        after = " ".repeat(size / 2 - 0.5);
                    } else {
                        before = " ".repeat(size / 2);
                        after = before;
                    }
                } else after = " ".repeat(size);
            }
            if (options.delimiterStart !== false && !columnIndex) line.push("|");
            if (options.padding !== false && // Don’t add the opening space if we’re not aligning and the cell is
            // empty: there will be a closing space.
            !(options.alignDelimiters === false && cell === "") && (options.delimiterStart !== false || columnIndex)) line.push(" ");
            if (options.alignDelimiters !== false) line.push(before);
            line.push(cell);
            if (options.alignDelimiters !== false) line.push(after);
            if (options.padding !== false) line.push(" ");
            if (options.delimiterEnd !== false || columnIndex !== mostCellsPerRow - 1) line.push("|");
        }
        lines.push(options.delimiterEnd === false ? line.join("").replace(/ +$/, "") : line.join(""));
    }
    return lines.join("\n");
}
/**
 * @param {string|null|undefined} [value]
 * @returns {string}
 */ function $b30d3756ce242a78$var$serialize(value) {
    return value === null || value === undefined ? "" : String(value);
}
/**
 * @param {string} value
 * @returns {number}
 */ function $b30d3756ce242a78$var$defaultStringLength(value) {
    return value.length;
}
/**
 * @param {string|null|undefined} value
 * @returns {number}
 */ function $b30d3756ce242a78$var$toAlignment(value) {
    const code = typeof value === "string" ? value.codePointAt(0) : 0;
    return code === 67 /* `C` */  || code === 99 /* `c` */  ? 99 /* `c` */  : code === 76 /* `L` */  || code === 108 /* `l` */  ? 108 /* `l` */  : code === 82 /* `R` */  || code === 114 /* `r` */  ? 114 /* `r` */  : 0;
}


/**
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').Map} Map
 * @typedef {import('../types.js').State} State
 */ /**
 * @param {Blockquote} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $6fa9fb19119f37a1$export$67dc04e652a298ca(node, _, state, info) {
    const exit = state.enter("blockquote");
    const tracker = state.createTracker(info);
    tracker.move("> ");
    tracker.shift(2);
    const value = state.indentLines(state.containerFlow(node, tracker.current()), $6fa9fb19119f37a1$var$map);
    exit();
    return value;
}
/** @type {Map} */ function $6fa9fb19119f37a1$var$map(line, _, blank) {
    return ">" + (blank ? "" : " ") + line;
}


/**
 * @typedef {import('mdast').Break} Break
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */ /**
 * @typedef {import('../types.js').ConstructName} ConstructName
 * @typedef {import('../types.js').Unsafe} Unsafe
 */ /**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe} pattern
 * @returns {boolean}
 */ function $a2c155739bdd1e5a$export$78221a09424368d(stack, pattern) {
    return $a2c155739bdd1e5a$var$listInScope(stack, pattern.inConstruct, true) && !$a2c155739bdd1e5a$var$listInScope(stack, pattern.notInConstruct, false);
}
/**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe['inConstruct']} list
 * @param {boolean} none
 * @returns {boolean}
 */ function $a2c155739bdd1e5a$var$listInScope(stack, list, none) {
    if (typeof list === "string") list = [
        list
    ];
    if (!list || list.length === 0) return none;
    let index = -1;
    while(++index < list.length){
        if (stack.includes(list[index])) return true;
    }
    return false;
}


function $1cda02ec7fd5c692$export$371da9dd35aba193(_, _1, state, info) {
    let index = -1;
    while(++index < state.unsafe.length){
        // If we can’t put eols in this construct (setext headings, tables), use a
        // space instead.
        if (state.unsafe[index].character === "\n" && (0, $a2c155739bdd1e5a$export$78221a09424368d)(state.stack, state.unsafe[index])) return /[ \t]/.test(info.before) ? "" : " ";
    }
    return "\\\n";
}


/**
 * @typedef {import('mdast').Code} Code
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').Map} Map
 * @typedef {import('../types.js').State} State
 */ /**
 * Get the count of the longest repeating streak of `character` in `value`.
 *
 * @param {string} value
 *   Content to search in.
 * @param {string} character
 *   Single character to look for.
 * @returns {number}
 *   Count of most frequent adjacent `character`s in `value`.
 */ function $0a610213cae3d437$export$711675ff42d864f2(value, character) {
    const source = String(value);
    let index = source.indexOf(character);
    let expected = index;
    let count = 0;
    let max = 0;
    if (typeof character !== "string" || character.length !== 1) throw new Error("Expected character");
    while(index !== -1){
        if (index === expected) {
            if (++count > max) max = count;
        } else count = 1;
        expected = index + 1;
        index = source.indexOf(character, expected);
    }
    return max;
}


/**
 * @typedef {import('mdast').Code} Code
 * @typedef {import('../types.js').State} State
 */ /**
 * @param {Code} node
 * @param {State} state
 * @returns {boolean}
 */ function $acb0ca8ad7e903c5$export$8c0df78a8cad9f4b(node, state) {
    return Boolean(state.options.fences === false && node.value && // If there’s no info…
    !node.lang && // And there’s a non-whitespace character…
    /[^ \r\n]/.test(node.value) && // And the value doesn’t start or end in a blank…
    !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(node.value));
}


/**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['fence'], null | undefined>}
 */ function $151c2fe666798d9d$export$7487ee7cbb2e2919(state) {
    const marker = state.options.fence || "`";
    if (marker !== "`" && marker !== "~") throw new Error("Cannot serialize code with `" + marker + "` for `options.fence`, expected `` ` `` or `~`");
    return marker;
}


function $8886317b5b45fec1$export$6565f9f03506010b(node, _, state, info) {
    const marker = (0, $151c2fe666798d9d$export$7487ee7cbb2e2919)(state);
    const raw = node.value || "";
    const suffix = marker === "`" ? "GraveAccent" : "Tilde";
    if ((0, $acb0ca8ad7e903c5$export$8c0df78a8cad9f4b)(node, state)) {
        const exit = state.enter("codeIndented");
        const value = state.indentLines(raw, $8886317b5b45fec1$var$map);
        exit();
        return value;
    }
    const tracker = state.createTracker(info);
    const sequence = marker.repeat(Math.max((0, $0a610213cae3d437$export$711675ff42d864f2)(raw, marker) + 1, 3));
    const exit = state.enter("codeFenced");
    let value = tracker.move(sequence);
    if (node.lang) {
        const subexit = state.enter(`codeFencedLang${suffix}`);
        value += tracker.move(state.safe(node.lang, {
            before: value,
            after: " ",
            encode: [
                "`"
            ],
            ...tracker.current()
        }));
        subexit();
    }
    if (node.lang && node.meta) {
        const subexit = state.enter(`codeFencedMeta${suffix}`);
        value += tracker.move(" ");
        value += tracker.move(state.safe(node.meta, {
            before: value,
            after: "\n",
            encode: [
                "`"
            ],
            ...tracker.current()
        }));
        subexit();
    }
    value += tracker.move("\n");
    if (raw) value += tracker.move(raw + "\n");
    value += tracker.move(sequence);
    exit();
    return value;
}
/** @type {Map} */ function $8886317b5b45fec1$var$map(line, _, blank) {
    return (blank ? "" : "    ") + line;
}


/**
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */ /**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['quote'], null | undefined>}
 */ function $2156625bd69278c8$export$7aeba63896b2719(state) {
    const marker = state.options.quote || '"';
    if (marker !== '"' && marker !== "'") throw new Error("Cannot serialize title with `" + marker + "` for `options.quote`, expected `\"`, or `'`");
    return marker;
}


function $d9663dc3decd9249$export$69f215ed977cdb73(node, _, state, info) {
    const quote = (0, $2156625bd69278c8$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? "Quote" : "Apostrophe";
    const exit = state.enter("definition");
    let subexit = state.enter("label");
    const tracker = state.createTracker(info);
    let value = tracker.move("[");
    value += tracker.move(state.safe(state.associationId(node), {
        before: value,
        after: "]",
        ...tracker.current()
    }));
    value += tracker.move("]: ");
    subexit();
    if (// If there’s no url, or…
    !node.url || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter("destinationLiteral");
        value += tracker.move("<");
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: ">",
            ...tracker.current()
        }));
        value += tracker.move(">");
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter("destinationRaw");
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: node.title ? " " : "\n",
            ...tracker.current()
        }));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(" " + quote);
        value += tracker.move(state.safe(node.title, {
            before: value,
            after: quote,
            ...tracker.current()
        }));
        value += tracker.move(quote);
        subexit();
    }
    exit();
    return value;
}


/**
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */ /**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['emphasis'], null | undefined>}
 */ function $4f2a56021a085417$export$f967eb786dea04e7(state) {
    const marker = state.options.emphasis || "*";
    if (marker !== "*" && marker !== "_") throw new Error("Cannot serialize emphasis with `" + marker + "` for `options.emphasis`, expected `*`, or `_`");
    return marker;
}


$d9dffead9011c778$export$bef81ba411953b51.peek = $d9dffead9011c778$var$emphasisPeek;
function $d9dffead9011c778$export$bef81ba411953b51(node, _, state, info) {
    const marker = (0, $4f2a56021a085417$export$f967eb786dea04e7)(state);
    const exit = state.enter("emphasis");
    const tracker = state.createTracker(info);
    let value = tracker.move(marker);
    value += tracker.move(state.containerPhrasing(node, {
        before: value,
        after: marker,
        ...tracker.current()
    }));
    value += tracker.move(marker);
    exit();
    return value;
}
/**
 * @param {Emphasis} _
 * @param {Parents | undefined} _1
 * @param {State} state
 * @returns {string}
 */ function $d9dffead9011c778$var$emphasisPeek(_, _1, state) {
    return state.options.emphasis || "*";
}


/**
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */ /**
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../types.js').State} State
 */ 

function $592a6fa5a1000b26$export$78863676235adfbc(node, state) {
    let literalWithBreak = false;
    // Look for literals with a line break.
    // Note that this also
    (0, $54f08257f9dfe0bf$export$bf638b60ea8b89b7)(node, function(node) {
        if ("value" in node && /\r?\n|\r/.test(node.value) || node.type === "break") {
            literalWithBreak = true;
            return 0, $12fffbe49747f304$export$7f100f842f565dc9;
        }
    });
    return Boolean((!node.depth || node.depth < 3) && (0, $3ca019da562f1c43$export$f84e8e69fd4488a5)(node) && (state.options.setext || literalWithBreak));
}


function $bc2ad1615f94306d$export$46e4a324ac90507f(node, _, state, info) {
    const rank = Math.max(Math.min(6, node.depth || 1), 1);
    const tracker = state.createTracker(info);
    if ((0, $592a6fa5a1000b26$export$78863676235adfbc)(node, state)) {
        const exit = state.enter("headingSetext");
        const subexit = state.enter("phrasing");
        const value = state.containerPhrasing(node, {
            ...tracker.current(),
            before: "\n",
            after: "\n"
        });
        subexit();
        exit();
        return value + "\n" + (rank === 1 ? "=" : "-").repeat(// The whole size…
        value.length - // Minus the position of the character after the last EOL (or
        // 0 if there is none)…
        (Math.max(value.lastIndexOf("\r"), value.lastIndexOf("\n")) + 1));
    }
    const sequence = "#".repeat(rank);
    const exit = state.enter("headingAtx");
    const subexit = state.enter("phrasing");
    // Note: for proper tracking, we should reset the output positions when there
    // is no content returned, because then the space is not output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    tracker.move(sequence + " ");
    let value = state.containerPhrasing(node, {
        before: "# ",
        after: "\n",
        ...tracker.current()
    });
    if (/^[\t ]/.test(value)) // To do: what effect has the character reference on tracking?
    value = "&#x" + value.charCodeAt(0).toString(16).toUpperCase() + ";" + value.slice(1);
    value = value ? sequence + " " + value : sequence;
    if (state.options.closeAtx) value += " " + sequence;
    subexit();
    exit();
    return value;
}


/**
 * @typedef {import('mdast').Html} Html
 */ $8d97bb9400189bf5$export$c0bb0b647f701bb5.peek = $8d97bb9400189bf5$var$htmlPeek;
function $8d97bb9400189bf5$export$c0bb0b647f701bb5(node) {
    return node.value || "";
}
/**
 * @returns {string}
 */ function $8d97bb9400189bf5$var$htmlPeek() {
    return "<";
}


/**
 * @typedef {import('mdast').Image} Image
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */ 
$b1218ae5cfc005f5$export$5c452ff88e35e47d.peek = $b1218ae5cfc005f5$var$imagePeek;
function $b1218ae5cfc005f5$export$5c452ff88e35e47d(node, _, state, info) {
    const quote = (0, $2156625bd69278c8$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? "Quote" : "Apostrophe";
    const exit = state.enter("image");
    let subexit = state.enter("label");
    const tracker = state.createTracker(info);
    let value = tracker.move("![");
    value += tracker.move(state.safe(node.alt, {
        before: value,
        after: "]",
        ...tracker.current()
    }));
    value += tracker.move("](");
    subexit();
    if (// If there’s no url but there is a title…
    !node.url && node.title || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter("destinationLiteral");
        value += tracker.move("<");
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: ">",
            ...tracker.current()
        }));
        value += tracker.move(">");
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter("destinationRaw");
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: node.title ? " " : ")",
            ...tracker.current()
        }));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(" " + quote);
        value += tracker.move(state.safe(node.title, {
            before: value,
            after: quote,
            ...tracker.current()
        }));
        value += tracker.move(quote);
        subexit();
    }
    value += tracker.move(")");
    exit();
    return value;
}
/**
 * @returns {string}
 */ function $b1218ae5cfc005f5$var$imagePeek() {
    return "!";
}


/**
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */ $2516a97d80143ef1$export$f281796f6bc3b8db.peek = $2516a97d80143ef1$var$imageReferencePeek;
function $2516a97d80143ef1$export$f281796f6bc3b8db(node, _, state, info) {
    const type = node.referenceType;
    const exit = state.enter("imageReference");
    let subexit = state.enter("label");
    const tracker = state.createTracker(info);
    let value = tracker.move("![");
    const alt = state.safe(node.alt, {
        before: value,
        after: "]",
        ...tracker.current()
    });
    value += tracker.move(alt + "][");
    subexit();
    // Hide the fact that we’re in phrasing, because escapes don’t work.
    const stack = state.stack;
    state.stack = [];
    subexit = state.enter("reference");
    // Note: for proper tracking, we should reset the output positions when we end
    // up making a `shortcut` reference, because then there is no brace output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    const reference = state.safe(state.associationId(node), {
        before: value,
        after: "]",
        ...tracker.current()
    });
    subexit();
    state.stack = stack;
    exit();
    if (type === "full" || !alt || alt !== reference) value += tracker.move(reference + "]");
    else if (type === "shortcut") // Remove the unwanted `[`.
    value = value.slice(0, -1);
    else value += tracker.move("]");
    return value;
}
/**
 * @returns {string}
 */ function $2516a97d80143ef1$var$imageReferencePeek() {
    return "!";
}


/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').State} State
 */ $b31c4558128a67d8$export$91b9bee19a0d8569.peek = $b31c4558128a67d8$var$inlineCodePeek;
function $b31c4558128a67d8$export$91b9bee19a0d8569(node, _, state) {
    let value = node.value || "";
    let sequence = "`";
    let index = -1;
    // If there is a single grave accent on its own in the code, use a fence of
    // two.
    // If there are two in a row, use one.
    while(new RegExp("(^|[^`])" + sequence + "([^`]|$)").test(value))sequence += "`";
    // If this is not just spaces or eols (tabs don’t count), and either the
    // first or last character are a space, eol, or tick, then pad with spaces.
    if (/[^ \r\n]/.test(value) && (/^[ \r\n]/.test(value) && /[ \r\n]$/.test(value) || /^`|`$/.test(value))) value = " " + value + " ";
    // We have a potential problem: certain characters after eols could result in
    // blocks being seen.
    // For example, if someone injected the string `'\n# b'`, then that would
    // result in an ATX heading.
    // We can’t escape characters in `inlineCode`, but because eols are
    // transformed to spaces when going from markdown to HTML anyway, we can swap
    // them out.
    while(++index < state.unsafe.length){
        const pattern = state.unsafe[index];
        const expression = state.compilePattern(pattern);
        /** @type {RegExpExecArray | null} */ let match;
        // Only look for `atBreak`s.
        // Btw: note that `atBreak` patterns will always start the regex at LF or
        // CR.
        if (!pattern.atBreak) continue;
        while(match = expression.exec(value)){
            let position = match.index;
            // Support CRLF (patterns only look for one of the characters).
            if (value.charCodeAt(position) === 10 /* `\n` */  && value.charCodeAt(position - 1) === 13 /* `\r` */ ) position--;
            value = value.slice(0, position) + " " + value.slice(match.index + 1);
        }
    }
    return sequence + value + sequence;
}
/**
 * @returns {string}
 */ function $b31c4558128a67d8$var$inlineCodePeek() {
    return "`";
}


/**
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Exit} Exit
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */ 
/**
 * @typedef {import('mdast').Link} Link
 * @typedef {import('../types.js').State} State
 */ 
function $66a8cb5c9b5d731c$export$74cae3045e3179ed(node, state) {
    const raw = (0, $3ca019da562f1c43$export$f84e8e69fd4488a5)(node);
    return Boolean(!state.options.resourceLink && // If there’s a url…
    node.url && // And there’s a no title…
    !node.title && // And the content of `node` is a single text node…
    node.children && node.children.length === 1 && node.children[0].type === "text" && // And if the url is the same as the content…
    (raw === node.url || "mailto:" + raw === node.url) && // And that starts w/ a protocol…
    /^[a-z][a-z+.-]+:/i.test(node.url) && // And that doesn’t contain ASCII control codes (character escapes and
    // references don’t work), space, or angle brackets…
    !/[\0- <>\u007F]/.test(node.url));
}


$ca850846bdf62720$export$9c30223ca0a664fb.peek = $ca850846bdf62720$var$linkPeek;
function $ca850846bdf62720$export$9c30223ca0a664fb(node, _, state, info) {
    const quote = (0, $2156625bd69278c8$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? "Quote" : "Apostrophe";
    const tracker = state.createTracker(info);
    /** @type {Exit} */ let exit;
    /** @type {Exit} */ let subexit;
    if ((0, $66a8cb5c9b5d731c$export$74cae3045e3179ed)(node, state)) {
        // Hide the fact that we’re in phrasing, because escapes don’t work.
        const stack = state.stack;
        state.stack = [];
        exit = state.enter("autolink");
        let value = tracker.move("<");
        value += tracker.move(state.containerPhrasing(node, {
            before: value,
            after: ">",
            ...tracker.current()
        }));
        value += tracker.move(">");
        exit();
        state.stack = stack;
        return value;
    }
    exit = state.enter("link");
    subexit = state.enter("label");
    let value = tracker.move("[");
    value += tracker.move(state.containerPhrasing(node, {
        before: value,
        after: "](",
        ...tracker.current()
    }));
    value += tracker.move("](");
    subexit();
    if (// If there’s no url but there is a title…
    !node.url && node.title || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter("destinationLiteral");
        value += tracker.move("<");
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: ">",
            ...tracker.current()
        }));
        value += tracker.move(">");
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter("destinationRaw");
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: node.title ? " " : ")",
            ...tracker.current()
        }));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(" " + quote);
        value += tracker.move(state.safe(node.title, {
            before: value,
            after: quote,
            ...tracker.current()
        }));
        value += tracker.move(quote);
        subexit();
    }
    value += tracker.move(")");
    exit();
    return value;
}
/**
 * @param {Link} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @returns {string}
 */ function $ca850846bdf62720$var$linkPeek(node, _, state) {
    return (0, $66a8cb5c9b5d731c$export$74cae3045e3179ed)(node, state) ? "<" : "[";
}


/**
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */ $75df2731ae5edfd6$export$e6c469b1b7b2bc6a.peek = $75df2731ae5edfd6$var$linkReferencePeek;
function $75df2731ae5edfd6$export$e6c469b1b7b2bc6a(node, _, state, info) {
    const type = node.referenceType;
    const exit = state.enter("linkReference");
    let subexit = state.enter("label");
    const tracker = state.createTracker(info);
    let value = tracker.move("[");
    const text = state.containerPhrasing(node, {
        before: value,
        after: "]",
        ...tracker.current()
    });
    value += tracker.move(text + "][");
    subexit();
    // Hide the fact that we’re in phrasing, because escapes don’t work.
    const stack = state.stack;
    state.stack = [];
    subexit = state.enter("reference");
    // Note: for proper tracking, we should reset the output positions when we end
    // up making a `shortcut` reference, because then there is no brace output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    const reference = state.safe(state.associationId(node), {
        before: value,
        after: "]",
        ...tracker.current()
    });
    subexit();
    state.stack = stack;
    exit();
    if (type === "full" || !text || text !== reference) value += tracker.move(reference + "]");
    else if (type === "shortcut") // Remove the unwanted `[`.
    value = value.slice(0, -1);
    else value += tracker.move("]");
    return value;
}
/**
 * @returns {string}
 */ function $75df2731ae5edfd6$var$linkReferencePeek() {
    return "[";
}


/**
 * @typedef {import('mdast').List} List
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */ /**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['bullet'], null | undefined>}
 */ function $e56c43303d6164aa$export$7425517207a4d0ae(state) {
    const marker = state.options.bullet || "*";
    if (marker !== "*" && marker !== "+" && marker !== "-") throw new Error("Cannot serialize items with `" + marker + "` for `options.bullet`, expected `*`, `+`, or `-`");
    return marker;
}


/**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */ 
function $39954fa65dd62aac$export$e6803bf0889262a1(state) {
    const bullet = (0, $e56c43303d6164aa$export$7425517207a4d0ae)(state);
    const bulletOther = state.options.bulletOther;
    if (!bulletOther) return bullet === "*" ? "-" : "*";
    if (bulletOther !== "*" && bulletOther !== "+" && bulletOther !== "-") throw new Error("Cannot serialize items with `" + bulletOther + "` for `options.bulletOther`, expected `*`, `+`, or `-`");
    if (bulletOther === bullet) throw new Error("Expected `bullet` (`" + bullet + "`) and `bulletOther` (`" + bulletOther + "`) to be different");
    return bulletOther;
}


/**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['bulletOrdered'], null | undefined>}
 */ function $70c9a35c5f09b887$export$98d522b78eddc19b(state) {
    const marker = state.options.bulletOrdered || ".";
    if (marker !== "." && marker !== ")") throw new Error("Cannot serialize items with `" + marker + "` for `options.bulletOrdered`, expected `.` or `)`");
    return marker;
}


/**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['rule'], null | undefined>}
 */ function $d4e2917f289f7a5c$export$d8d533ef24dba866(state) {
    const marker = state.options.rule || "*";
    if (marker !== "*" && marker !== "-" && marker !== "_") throw new Error("Cannot serialize rules with `" + marker + "` for `options.rule`, expected `*`, `-`, or `_`");
    return marker;
}


function $295170a9683e17f9$export$8837f4fc672e936d(node, parent, state, info) {
    const exit = state.enter("list");
    const bulletCurrent = state.bulletCurrent;
    /** @type {string} */ let bullet = node.ordered ? (0, $70c9a35c5f09b887$export$98d522b78eddc19b)(state) : (0, $e56c43303d6164aa$export$7425517207a4d0ae)(state);
    /** @type {string} */ const bulletOther = node.ordered ? bullet === "." ? ")" : "." : (0, $39954fa65dd62aac$export$e6803bf0889262a1)(state);
    let useDifferentMarker = parent && state.bulletLastUsed ? bullet === state.bulletLastUsed : false;
    if (!node.ordered) {
        const firstListItem = node.children ? node.children[0] : undefined;
        // If there’s an empty first list item directly in two list items,
        // we have to use a different bullet:
        //
        // ```markdown
        // * - *
        // ```
        //
        // …because otherwise it would become one big thematic break.
        if (// Bullet could be used as a thematic break marker:
        (bullet === "*" || bullet === "-") && // Empty first list item:
        firstListItem && (!firstListItem.children || !firstListItem.children[0]) && // Directly in two other list items:
        state.stack[state.stack.length - 1] === "list" && state.stack[state.stack.length - 2] === "listItem" && state.stack[state.stack.length - 3] === "list" && state.stack[state.stack.length - 4] === "listItem" && // That are each the first child.
        state.indexStack[state.indexStack.length - 1] === 0 && state.indexStack[state.indexStack.length - 2] === 0 && state.indexStack[state.indexStack.length - 3] === 0) useDifferentMarker = true;
        // If there’s a thematic break at the start of the first list item,
        // we have to use a different bullet:
        //
        // ```markdown
        // * ---
        // ```
        //
        // …because otherwise it would become one big thematic break.
        if ((0, $d4e2917f289f7a5c$export$d8d533ef24dba866)(state) === bullet && firstListItem) {
            let index = -1;
            while(++index < node.children.length){
                const item = node.children[index];
                if (item && item.type === "listItem" && item.children && item.children[0] && item.children[0].type === "thematicBreak") {
                    useDifferentMarker = true;
                    break;
                }
            }
        }
    }
    if (useDifferentMarker) bullet = bulletOther;
    state.bulletCurrent = bullet;
    const value = state.containerFlow(node, info);
    state.bulletLastUsed = bullet;
    state.bulletCurrent = bulletCurrent;
    exit();
    return value;
}


/**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').Map} Map
 * @typedef {import('../types.js').State} State
 */ 
/**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['listItemIndent'], null | undefined>}
 */ function $0f86210f9325abc8$export$2d5358b63da92261(state) {
    const style = state.options.listItemIndent || "one";
    if (style !== "tab" && style !== "one" && style !== "mixed") throw new Error("Cannot serialize items with `" + style + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`");
    return style;
}


function $91ba458764191115$export$76c7e83ecc9cdf05(node, parent, state, info) {
    const listItemIndent = (0, $0f86210f9325abc8$export$2d5358b63da92261)(state);
    let bullet = state.bulletCurrent || (0, $e56c43303d6164aa$export$7425517207a4d0ae)(state);
    // Add the marker value for ordered lists.
    if (parent && parent.type === "list" && parent.ordered) bullet = (typeof parent.start === "number" && parent.start > -1 ? parent.start : 1) + (state.options.incrementListMarker === false ? 0 : parent.children.indexOf(node)) + bullet;
    let size = bullet.length + 1;
    if (listItemIndent === "tab" || listItemIndent === "mixed" && (parent && parent.type === "list" && parent.spread || node.spread)) size = Math.ceil(size / 4) * 4;
    const tracker = state.createTracker(info);
    tracker.move(bullet + " ".repeat(size - bullet.length));
    tracker.shift(size);
    const exit = state.enter("listItem");
    const value = state.indentLines(state.containerFlow(node, tracker.current()), map);
    exit();
    return value;
    /** @type {Map} */ function map(line, index, blank) {
        if (index) return (blank ? "" : " ".repeat(size)) + line;
        return (blank ? bullet : bullet + " ".repeat(size - bullet.length)) + line;
    }
}


/**
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */ /**
 * @param {Paragraph} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $8a7d76054064d35e$export$9c206ddddb32a9b(node, _, state, info) {
    const exit = state.enter("paragraph");
    const subexit = state.enter("phrasing");
    const value = state.containerPhrasing(node, info);
    subexit();
    exit();
    return value;
}


/**
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('mdast').Root} Root
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */ /**
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 */ 
const $f57ba4dfd42001da$export$444c9dec66a6f08c = /** @type {(node?: unknown) => node is PhrasingContent} */ (0, $a74142eedbb1409b$export$9c68d69a4c5bbcf9)([
    "break",
    "delete",
    "emphasis",
    "footnote",
    "footnoteReference",
    "image",
    "imageReference",
    "inlineCode",
    "link",
    "linkReference",
    "strong",
    "text"
]);


function $8a32896720a3ec29$export$e8e78c978b129247(node, _, state, info) {
    // Note: `html` nodes are ambiguous.
    const hasPhrasing = node.children.some(function(d) {
        return (0, $f57ba4dfd42001da$export$444c9dec66a6f08c)(d);
    });
    const fn = hasPhrasing ? state.containerPhrasing : state.containerFlow;
    return fn.call(state, node, info);
}


/**
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */ /**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['strong'], null | undefined>}
 */ function $7187ae0912797134$export$b7ce17905d66a6c3(state) {
    const marker = state.options.strong || "*";
    if (marker !== "*" && marker !== "_") throw new Error("Cannot serialize strong with `" + marker + "` for `options.strong`, expected `*`, or `_`");
    return marker;
}


$fd64b95af118399b$export$59ae2c325a998f89.peek = $fd64b95af118399b$var$strongPeek;
function $fd64b95af118399b$export$59ae2c325a998f89(node, _, state, info) {
    const marker = (0, $7187ae0912797134$export$b7ce17905d66a6c3)(state);
    const exit = state.enter("strong");
    const tracker = state.createTracker(info);
    let value = tracker.move(marker + marker);
    value += tracker.move(state.containerPhrasing(node, {
        before: value,
        after: marker,
        ...tracker.current()
    }));
    value += tracker.move(marker + marker);
    exit();
    return value;
}
/**
 * @param {Strong} _
 * @param {Parents | undefined} _1
 * @param {State} state
 * @returns {string}
 */ function $fd64b95af118399b$var$strongPeek(_, _1, state) {
    return state.options.strong || "*";
}


/**
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('mdast').Text} Text
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */ /**
 * @param {Text} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $11c4d0a8378aa917$export$6f093cfa640b7166(node, _, state, info) {
    return state.safe(node.value, info);
}


/**
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('../types.js').State} State
 */ /**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['ruleRepetition'], null | undefined>}
 */ function $7bfcfa914d8bb027$export$72f02155834d89c4(state) {
    const repetition = state.options.ruleRepetition || 3;
    if (repetition < 3) throw new Error("Cannot serialize rules with repetition `" + repetition + "` for `options.ruleRepetition`, expected `3` or more");
    return repetition;
}



function $9a48f50bc7c64e93$export$ba7b13e047416c03(_, _1, state) {
    const value = ((0, $d4e2917f289f7a5c$export$d8d533ef24dba866)(state) + (state.options.ruleSpaces ? " " : "")).repeat((0, $7bfcfa914d8bb027$export$72f02155834d89c4)(state));
    return state.options.ruleSpaces ? value.slice(0, -1) : value;
}


const $37af987eface8662$export$8f34ce051745d39e = {
    blockquote: $6fa9fb19119f37a1$export$67dc04e652a298ca,
    break: (0, $1cda02ec7fd5c692$export$371da9dd35aba193),
    code: $8886317b5b45fec1$export$6565f9f03506010b,
    definition: $d9663dc3decd9249$export$69f215ed977cdb73,
    emphasis: $d9dffead9011c778$export$bef81ba411953b51,
    hardBreak: $1cda02ec7fd5c692$export$371da9dd35aba193,
    heading: $bc2ad1615f94306d$export$46e4a324ac90507f,
    html: $8d97bb9400189bf5$export$c0bb0b647f701bb5,
    image: $b1218ae5cfc005f5$export$5c452ff88e35e47d,
    imageReference: $2516a97d80143ef1$export$f281796f6bc3b8db,
    inlineCode: $b31c4558128a67d8$export$91b9bee19a0d8569,
    link: $ca850846bdf62720$export$9c30223ca0a664fb,
    linkReference: $75df2731ae5edfd6$export$e6c469b1b7b2bc6a,
    list: $295170a9683e17f9$export$8837f4fc672e936d,
    listItem: $91ba458764191115$export$76c7e83ecc9cdf05,
    paragraph: $8a7d76054064d35e$export$9c206ddddb32a9b,
    root: $8a32896720a3ec29$export$e8e78c978b129247,
    strong: $fd64b95af118399b$export$59ae2c325a998f89,
    text: $11c4d0a8378aa917$export$6f093cfa640b7166,
    thematicBreak: $9a48f50bc7c64e93$export$ba7b13e047416c03
};


function $347dea0938ade38a$export$8bd0ec8ecf6adb7d() {
    return {
        enter: {
            table: $347dea0938ade38a$var$enterTable,
            tableData: $347dea0938ade38a$var$enterCell,
            tableHeader: $347dea0938ade38a$var$enterCell,
            tableRow: $347dea0938ade38a$var$enterRow
        },
        exit: {
            codeText: $347dea0938ade38a$var$exitCodeText,
            table: $347dea0938ade38a$var$exitTable,
            tableData: $347dea0938ade38a$var$exit,
            tableHeader: $347dea0938ade38a$var$exit,
            tableRow: $347dea0938ade38a$var$exit
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $347dea0938ade38a$var$enterTable(token) {
    const align = token._align;
    (0, $331630515164a454$export$dcb8b3f0e2de7e49)(align, "expected `_align` on table");
    this.enter({
        type: "table",
        align: align.map(function(d) {
            return d === "none" ? null : d;
        }),
        children: []
    }, token);
    this.data.inTable = true;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $347dea0938ade38a$var$exitTable(token) {
    this.exit(token);
    this.data.inTable = undefined;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $347dea0938ade38a$var$enterRow(token) {
    this.enter({
        type: "tableRow",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $347dea0938ade38a$var$exit(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $347dea0938ade38a$var$enterCell(token) {
    this.enter({
        type: "tableCell",
        children: []
    }, token);
}
// Overwrite the default code text data handler to unescape escaped pipes when
// they are in tables.
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $347dea0938ade38a$var$exitCodeText(token) {
    let value = this.resume();
    if (this.data.inTable) value = value.replace(/\\([\\|])/g, $347dea0938ade38a$var$replace);
    const node = this.stack[this.stack.length - 1];
    (0, $331630515164a454$export$dcb8b3f0e2de7e49)(node.type === "inlineCode");
    node.value = value;
    this.exit(token);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $347dea0938ade38a$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === "|" ? $1 : $0;
}
function $347dea0938ade38a$export$dafcad76ea6e0045(options) {
    const settings = options || {};
    const padding = settings.tableCellPadding;
    const alignDelimiters = settings.tablePipeAlign;
    const stringLength = settings.stringLength;
    const around = padding ? " " : "|";
    return {
        unsafe: [
            {
                character: "\r",
                inConstruct: "tableCell"
            },
            {
                character: "\n",
                inConstruct: "tableCell"
            },
            // A pipe, when followed by a tab or space (padding), or a dash or colon
            // (unpadded delimiter row), could result in a table.
            {
                atBreak: true,
                character: "|",
                after: "[	 :-]"
            },
            // A pipe in a cell must be encoded.
            {
                character: "|",
                inConstruct: "tableCell"
            },
            // A colon must be followed by a dash, in which case it could start a
            // delimiter row.
            {
                atBreak: true,
                character: ":",
                after: "-"
            },
            // A delimiter row can also start with a dash, when followed by more
            // dashes, a colon, or a pipe.
            // This is a stricter version than the built in check for lists, thematic
            // breaks, and setex heading underlines though:
            // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
            {
                atBreak: true,
                character: "-",
                after: "[:|-]"
            }
        ],
        handlers: {
            inlineCode: inlineCodeWithTable,
            table: handleTable,
            tableCell: handleTableCell,
            tableRow: handleTableRow
        }
    };
    /**
   * @type {ToMarkdownHandle}
   * @param {Table} node
   */ function handleTable(node, _, state, info) {
        return serializeData(handleTableAsData(node, state, info), node.align);
    }
    /**
   * This function isn’t really used normally, because we handle rows at the
   * table level.
   * But, if someone passes in a table row, this ensures we make somewhat sense.
   *
   * @type {ToMarkdownHandle}
   * @param {TableRow} node
   */ function handleTableRow(node, _, state, info) {
        const row = handleTableRowAsData(node, state, info);
        const value = serializeData([
            row
        ]);
        // `markdown-table` will always add an align row
        return value.slice(0, value.indexOf("\n"));
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {TableCell} node
   */ function handleTableCell(node, _, state, info) {
        const exit = state.enter("tableCell");
        const subexit = state.enter("phrasing");
        const value = state.containerPhrasing(node, {
            ...info,
            before: around,
            after: around
        });
        subexit();
        exit();
        return value;
    }
    /**
   * @param {Array<Array<string>>} matrix
   * @param {Array<string | null | undefined> | null | undefined} [align]
   */ function serializeData(matrix, align) {
        return (0, $b30d3756ce242a78$export$cdb7288612c4f3d6)(matrix, {
            align: align,
            alignDelimiters: // @ts-expect-error: `markdown-table` types should support `null`.
            alignDelimiters,
            padding: // @ts-expect-error: `markdown-table` types should support `null`.
            padding,
            stringLength: // @ts-expect-error: `markdown-table` types should support `null`.
            stringLength
        });
    }
    /**
   * @param {Table} node
   * @param {State} state
   * @param {Info} info
   */ function handleTableAsData(node, state, info) {
        const children = node.children;
        let index = -1;
        /** @type {Array<Array<string>>} */ const result = [];
        const subexit = state.enter("table");
        while(++index < children.length)result[index] = handleTableRowAsData(children[index], state, info);
        subexit();
        return result;
    }
    /**
   * @param {TableRow} node
   * @param {State} state
   * @param {Info} info
   */ function handleTableRowAsData(node, state, info) {
        const children = node.children;
        let index = -1;
        /** @type {Array<string>} */ const result = [];
        const subexit = state.enter("tableRow");
        while(++index < children.length)// Note: the positional info as used here is incorrect.
        // Making it correct would be impossible due to aligning cells?
        // And it would need copy/pasting `markdown-table` into this project.
        result[index] = handleTableCell(children[index], node, state, info);
        subexit();
        return result;
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {InlineCode} node
   */ function inlineCodeWithTable(node, parent, state) {
        let value = (0, $37af987eface8662$export$8f34ce051745d39e).inlineCode(node, parent, state);
        if (state.stack.includes("tableCell")) value = value.replace(/\|/g, "\\$&");
        return value;
    }
}


/**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */ 

function $4957e097a71e941d$export$a427a608608b215f() {
    return {
        exit: {
            taskListCheckValueChecked: $4957e097a71e941d$var$exitCheck,
            taskListCheckValueUnchecked: $4957e097a71e941d$var$exitCheck,
            paragraph: $4957e097a71e941d$var$exitParagraphWithTaskListItem
        }
    };
}
function $4957e097a71e941d$export$9975722e7e834b78() {
    return {
        unsafe: [
            {
                atBreak: true,
                character: "-",
                after: "[:|-]"
            }
        ],
        handlers: {
            listItem: $4957e097a71e941d$var$listItemWithTaskListItem
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $4957e097a71e941d$var$exitCheck(token) {
    // We’re always in a paragraph, in a list item.
    const node = this.stack[this.stack.length - 2];
    (0, $331630515164a454$export$dcb8b3f0e2de7e49)(node.type === "listItem");
    node.checked = token.type === "taskListCheckValueChecked";
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $4957e097a71e941d$var$exitParagraphWithTaskListItem(token) {
    const parent = this.stack[this.stack.length - 2];
    if (parent && parent.type === "listItem" && typeof parent.checked === "boolean") {
        const node = this.stack[this.stack.length - 1];
        (0, $331630515164a454$export$dcb8b3f0e2de7e49)(node.type === "paragraph");
        const head = node.children[0];
        if (head && head.type === "text") {
            const siblings = parent.children;
            let index = -1;
            /** @type {Paragraph | undefined} */ let firstParaghraph;
            while(++index < siblings.length){
                const sibling = siblings[index];
                if (sibling.type === "paragraph") {
                    firstParaghraph = sibling;
                    break;
                }
            }
            if (firstParaghraph === node) {
                // Must start with a space or a tab.
                head.value = head.value.slice(1);
                if (head.value.length === 0) node.children.shift();
                else if (node.position && head.position && typeof head.position.start.offset === "number") {
                    head.position.start.column++;
                    head.position.start.offset++;
                    node.position.start = Object.assign({}, head.position.start);
                }
            }
        }
    }
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {ListItem} node
 */ function $4957e097a71e941d$var$listItemWithTaskListItem(node, parent, state, info) {
    const head = node.children[0];
    const checkable = typeof node.checked === "boolean" && head && head.type === "paragraph";
    const checkbox = "[" + (node.checked ? "x" : " ") + "] ";
    const tracker = state.createTracker(info);
    if (checkable) tracker.move(checkbox);
    let value = (0, $37af987eface8662$export$8f34ce051745d39e).listItem(node, parent, state, {
        ...info,
        ...tracker.current()
    });
    if (checkable) value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check);
    return value;
    /**
   * @param {string} $0
   * @returns {string}
   */ function check($0) {
        return $0 + checkbox;
    }
}


function $66ffb1b9555b95a5$export$95adae814eb7433e() {
    return [
        (0, $04fc5af4d0498e38$export$b6afdfff2163546f)(),
        (0, $4cef1d95953b5f14$export$c9d5ad4bdf6ff801)(),
        (0, $840e3e37503239ce$export$34d64e709dd0b9bb)(),
        (0, $347dea0938ade38a$export$8bd0ec8ecf6adb7d)(),
        (0, $4957e097a71e941d$export$a427a608608b215f)()
    ];
}
function $66ffb1b9555b95a5$export$ea77de6901e7c72b(options) {
    return {
        extensions: [
            (0, $04fc5af4d0498e38$export$d3ace9096b01c39d)(),
            (0, $4cef1d95953b5f14$export$3727766a73a6c09f)(),
            (0, $840e3e37503239ce$export$1632835bd2c84956)(),
            (0, $347dea0938ade38a$export$dafcad76ea6e0045)(options),
            (0, $4957e097a71e941d$export$9975722e7e834b78)()
        ]
    };
}


/**
 * @typedef {import('micromark-extension-gfm-footnote').HtmlOptions} HtmlOptions
 * @typedef {import('micromark-extension-gfm-strikethrough').Options} Options
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ 
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $ca6e61d5eaaf81bd$var$wwwPrefix = {
    tokenize: $ca6e61d5eaaf81bd$var$tokenizeWwwPrefix,
    partial: true
};
const $ca6e61d5eaaf81bd$var$domain = {
    tokenize: $ca6e61d5eaaf81bd$var$tokenizeDomain,
    partial: true
};
const $ca6e61d5eaaf81bd$var$path = {
    tokenize: $ca6e61d5eaaf81bd$var$tokenizePath,
    partial: true
};
const $ca6e61d5eaaf81bd$var$trail = {
    tokenize: $ca6e61d5eaaf81bd$var$tokenizeTrail,
    partial: true
};
const $ca6e61d5eaaf81bd$var$emailDomainDotTrail = {
    tokenize: $ca6e61d5eaaf81bd$var$tokenizeEmailDomainDotTrail,
    partial: true
};
const $ca6e61d5eaaf81bd$var$wwwAutolink = {
    tokenize: $ca6e61d5eaaf81bd$var$tokenizeWwwAutolink,
    previous: $ca6e61d5eaaf81bd$var$previousWww
};
const $ca6e61d5eaaf81bd$var$protocolAutolink = {
    tokenize: $ca6e61d5eaaf81bd$var$tokenizeProtocolAutolink,
    previous: $ca6e61d5eaaf81bd$var$previousProtocol
};
const $ca6e61d5eaaf81bd$var$emailAutolink = {
    tokenize: $ca6e61d5eaaf81bd$var$tokenizeEmailAutolink,
    previous: $ca6e61d5eaaf81bd$var$previousEmail
};
/** @type {ConstructRecord} */ const $ca6e61d5eaaf81bd$var$text = {};
function $ca6e61d5eaaf81bd$export$608123d9b549151() {
    return {
        text: $ca6e61d5eaaf81bd$var$text
    };
}
/** @type {Code} */ let $ca6e61d5eaaf81bd$var$code = 48;
// Add alphanumerics.
while($ca6e61d5eaaf81bd$var$code < 123){
    $ca6e61d5eaaf81bd$var$text[$ca6e61d5eaaf81bd$var$code] = $ca6e61d5eaaf81bd$var$emailAutolink;
    $ca6e61d5eaaf81bd$var$code++;
    if ($ca6e61d5eaaf81bd$var$code === 58) $ca6e61d5eaaf81bd$var$code = 65;
    else if ($ca6e61d5eaaf81bd$var$code === 91) $ca6e61d5eaaf81bd$var$code = 97;
}
$ca6e61d5eaaf81bd$var$text[43] = $ca6e61d5eaaf81bd$var$emailAutolink;
$ca6e61d5eaaf81bd$var$text[45] = $ca6e61d5eaaf81bd$var$emailAutolink;
$ca6e61d5eaaf81bd$var$text[46] = $ca6e61d5eaaf81bd$var$emailAutolink;
$ca6e61d5eaaf81bd$var$text[95] = $ca6e61d5eaaf81bd$var$emailAutolink;
$ca6e61d5eaaf81bd$var$text[72] = [
    $ca6e61d5eaaf81bd$var$emailAutolink,
    $ca6e61d5eaaf81bd$var$protocolAutolink
];
$ca6e61d5eaaf81bd$var$text[104] = [
    $ca6e61d5eaaf81bd$var$emailAutolink,
    $ca6e61d5eaaf81bd$var$protocolAutolink
];
$ca6e61d5eaaf81bd$var$text[87] = [
    $ca6e61d5eaaf81bd$var$emailAutolink,
    $ca6e61d5eaaf81bd$var$wwwAutolink
];
$ca6e61d5eaaf81bd$var$text[119] = [
    $ca6e61d5eaaf81bd$var$emailAutolink,
    $ca6e61d5eaaf81bd$var$wwwAutolink
];
// To do: perform email autolink literals on events, afterwards.
// That’s where `markdown-rs` and `cmark-gfm` perform it.
// It should look for `@`, then for atext backwards, and then for a label
// forwards.
// To do: `mailto:`, `xmpp:` protocol as prefix.
/**
 * Email autolink literal.
 *
 * ```markdown
 * > | a contact@example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ca6e61d5eaaf81bd$var$tokenizeEmailAutolink(effects, ok, nok) {
    const self = this;
    /** @type {boolean | undefined} */ let dot;
    /** @type {boolean} */ let data;
    return start;
    /**
   * Start of email autolink literal.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (!$ca6e61d5eaaf81bd$var$gfmAtext(code) || !$ca6e61d5eaaf81bd$var$previousEmail.call(self, self.previous) || $ca6e61d5eaaf81bd$var$previousUnbalanced(self.events)) return nok(code);
        effects.enter("literalAutolink");
        effects.enter("literalAutolinkEmail");
        return atext(code);
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */ function atext(code) {
        if ($ca6e61d5eaaf81bd$var$gfmAtext(code)) {
            effects.consume(code);
            return atext;
        }
        if (code === 64) {
            effects.consume(code);
            return emailDomain;
        }
        return nok(code);
    }
    /**
   * In email domain.
   *
   * The reference code is a bit overly complex as it handles the `@`, of which
   * there may be just one.
   * Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L318>
   *
   * ```markdown
   * > | a contact@example.org b
   *               ^
   * ```
   *
   * @type {State}
   */ function emailDomain(code) {
        // Dot followed by alphanumerical (not `-` or `_`).
        if (code === 46) return effects.check($ca6e61d5eaaf81bd$var$emailDomainDotTrail, emailDomainAfter, emailDomainDot)(code);
        // Alphanumerical, `-`, and `_`.
        if (code === 45 || code === 95 || (0, $74ae855ebddfe8fb$export$75c76db11865a9f4)(code)) {
            data = true;
            effects.consume(code);
            return emailDomain;
        }
        // To do: `/` if xmpp.
        // Note: normally we’d truncate trailing punctuation from the link.
        // However, email autolink literals cannot contain any of those markers,
        // except for `.`, but that can only occur if it isn’t trailing.
        // So we can ignore truncating!
        return emailDomainAfter(code);
    }
    /**
   * In email domain, on dot that is not a trail.
   *
   * ```markdown
   * > | a contact@example.org b
   *                      ^
   * ```
   *
   * @type {State}
   */ function emailDomainDot(code) {
        effects.consume(code);
        dot = true;
        return emailDomain;
    }
    /**
   * After email domain.
   *
   * ```markdown
   * > | a contact@example.org b
   *                          ^
   * ```
   *
   * @type {State}
   */ function emailDomainAfter(code) {
        // Domain must not be empty, must include a dot, and must end in alphabetical.
        // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L332>.
        if (data && dot && (0, $74ae855ebddfe8fb$export$d65d6b62c24d5436)(self.previous)) {
            effects.exit("literalAutolinkEmail");
            effects.exit("literalAutolink");
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * `www` autolink literal.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ca6e61d5eaaf81bd$var$tokenizeWwwAutolink(effects, ok, nok) {
    const self = this;
    return wwwStart;
    /**
   * Start of www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */ function wwwStart(code) {
        if (code !== 87 && code !== 119 || !$ca6e61d5eaaf81bd$var$previousWww.call(self, self.previous) || $ca6e61d5eaaf81bd$var$previousUnbalanced(self.events)) return nok(code);
        effects.enter("literalAutolink");
        effects.enter("literalAutolinkWww");
        // Note: we *check*, so we can discard the `www.` we parsed.
        // If it worked, we consider it as a part of the domain.
        return effects.check($ca6e61d5eaaf81bd$var$wwwPrefix, effects.attempt($ca6e61d5eaaf81bd$var$domain, effects.attempt($ca6e61d5eaaf81bd$var$path, wwwAfter), nok), nok)(code);
    }
    /**
   * After a www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *                          ^
   * ```
   *
   * @type {State}
   */ function wwwAfter(code) {
        effects.exit("literalAutolinkWww");
        effects.exit("literalAutolink");
        return ok(code);
    }
}
/**
 * Protocol autolink literal.
 *
 * ```markdown
 * > | a https://example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ca6e61d5eaaf81bd$var$tokenizeProtocolAutolink(effects, ok, nok) {
    const self = this;
    let buffer = "";
    let seen = false;
    return protocolStart;
    /**
   * Start of protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */ function protocolStart(code) {
        if ((code === 72 || code === 104) && $ca6e61d5eaaf81bd$var$previousProtocol.call(self, self.previous) && !$ca6e61d5eaaf81bd$var$previousUnbalanced(self.events)) {
            effects.enter("literalAutolink");
            effects.enter("literalAutolinkHttp");
            buffer += String.fromCodePoint(code);
            effects.consume(code);
            return protocolPrefixInside;
        }
        return nok(code);
    }
    /**
   * In protocol.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^^^^^
   * ```
   *
   * @type {State}
   */ function protocolPrefixInside(code) {
        // `5` is size of `https`
        if ((0, $74ae855ebddfe8fb$export$d65d6b62c24d5436)(code) && buffer.length < 5) {
            // @ts-expect-error: definitely number.
            buffer += String.fromCodePoint(code);
            effects.consume(code);
            return protocolPrefixInside;
        }
        if (code === 58) {
            const protocol = buffer.toLowerCase();
            if (protocol === "http" || protocol === "https") {
                effects.consume(code);
                return protocolSlashesInside;
            }
        }
        return nok(code);
    }
    /**
   * In slashes.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *           ^^
   * ```
   *
   * @type {State}
   */ function protocolSlashesInside(code) {
        if (code === 47) {
            effects.consume(code);
            if (seen) return afterProtocol;
            seen = true;
            return protocolSlashesInside;
        }
        return nok(code);
    }
    /**
   * After protocol, before domain.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *             ^
   * ```
   *
   * @type {State}
   */ function afterProtocol(code) {
        // To do: this is different from `markdown-rs`:
        // https://github.com/wooorm/markdown-rs/blob/b3a921c761309ae00a51fe348d8a43adbc54b518/src/construct/gfm_autolink_literal.rs#L172-L182
        return code === null || (0, $74ae855ebddfe8fb$export$67dbf494fc8394df)(code) || (0, $74ae855ebddfe8fb$export$a30284361b3814b7)(code) || (0, $74ae855ebddfe8fb$export$a0ff789c034ffdf4)(code) || (0, $74ae855ebddfe8fb$export$aa04114dd888a7a0)(code) ? nok(code) : effects.attempt($ca6e61d5eaaf81bd$var$domain, effects.attempt($ca6e61d5eaaf81bd$var$path, protocolAfter), nok)(code);
    }
    /**
   * After a protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *                              ^
   * ```
   *
   * @type {State}
   */ function protocolAfter(code) {
        effects.exit("literalAutolinkHttp");
        effects.exit("literalAutolink");
        return ok(code);
    }
}
/**
 * `www` prefix.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ca6e61d5eaaf81bd$var$tokenizeWwwPrefix(effects, ok, nok) {
    let size = 0;
    return wwwPrefixInside;
    /**
   * In www prefix.
   *
   * ```markdown
   * > | www.example.com
   *     ^^^^
   * ```
   *
   * @type {State}
   */ function wwwPrefixInside(code) {
        if ((code === 87 || code === 119) && size < 3) {
            size++;
            effects.consume(code);
            return wwwPrefixInside;
        }
        if (code === 46 && size === 3) {
            effects.consume(code);
            return wwwPrefixAfter;
        }
        return nok(code);
    }
    /**
   * After www prefix.
   *
   * ```markdown
   * > | www.example.com
   *         ^
   * ```
   *
   * @type {State}
   */ function wwwPrefixAfter(code) {
        // If there is *anything*, we can link.
        return code === null ? nok(code) : ok(code);
    }
}
/**
 * Domain.
 *
 * ```markdown
 * > | a https://example.org b
 *               ^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ca6e61d5eaaf81bd$var$tokenizeDomain(effects, ok, nok) {
    /** @type {boolean | undefined} */ let underscoreInLastSegment;
    /** @type {boolean | undefined} */ let underscoreInLastLastSegment;
    /** @type {boolean | undefined} */ let seen;
    return domainInside;
    /**
   * In domain.
   *
   * ```markdown
   * > | https://example.com/a
   *             ^^^^^^^^^^^
   * ```
   *
   * @type {State}
   */ function domainInside(code) {
        // Check whether this marker, which is a trailing punctuation
        // marker, optionally followed by more trailing markers, and then
        // followed by an end.
        if (code === 46 || code === 95) return effects.check($ca6e61d5eaaf81bd$var$trail, domainAfter, domainAtPunctuation)(code);
        // GH documents that only alphanumerics (other than `-`, `.`, and `_`) can
        // occur, which sounds like ASCII only, but they also support `www.點看.com`,
        // so that’s Unicode.
        // Instead of some new production for Unicode alphanumerics, markdown
        // already has that for Unicode punctuation and whitespace, so use those.
        // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L12>.
        if (code === null || (0, $74ae855ebddfe8fb$export$a30284361b3814b7)(code) || (0, $74ae855ebddfe8fb$export$a0ff789c034ffdf4)(code) || code !== 45 && (0, $74ae855ebddfe8fb$export$aa04114dd888a7a0)(code)) return domainAfter(code);
        seen = true;
        effects.consume(code);
        return domainInside;
    }
    /**
   * In domain, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com
   *                    ^
   * ```
   *
   * @type {State}
   */ function domainAtPunctuation(code) {
        // There is an underscore in the last segment of the domain
        if (code === 95) underscoreInLastSegment = true;
        else {
            underscoreInLastLastSegment = underscoreInLastSegment;
            underscoreInLastSegment = undefined;
        }
        effects.consume(code);
        return domainInside;
    }
    /**
   * After domain.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^
   * ```
   *
   * @type {State} */ function domainAfter(code) {
        // Note: that’s GH says a dot is needed, but it’s not true:
        // <https://github.com/github/cmark-gfm/issues/279>
        if (underscoreInLastLastSegment || underscoreInLastSegment || !seen) return nok(code);
        return ok(code);
    }
}
/**
 * Path.
 *
 * ```markdown
 * > | a https://example.org/stuff b
 *                          ^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ca6e61d5eaaf81bd$var$tokenizePath(effects, ok) {
    let sizeOpen = 0;
    let sizeClose = 0;
    return pathInside;
    /**
   * In path.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^^
   * ```
   *
   * @type {State}
   */ function pathInside(code) {
        if (code === 40) {
            sizeOpen++;
            effects.consume(code);
            return pathInside;
        }
        // To do: `markdown-rs` also needs this.
        // If this is a paren, and there are less closings than openings,
        // we don’t check for a trail.
        if (code === 41 && sizeClose < sizeOpen) return pathAtPunctuation(code);
        // Check whether this trailing punctuation marker is optionally
        // followed by more trailing markers, and then followed
        // by an end.
        if (code === 33 || code === 34 || code === 38 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 60 || code === 63 || code === 93 || code === 95 || code === 126) return effects.check($ca6e61d5eaaf81bd$var$trail, ok, pathAtPunctuation)(code);
        if (code === null || (0, $74ae855ebddfe8fb$export$a30284361b3814b7)(code) || (0, $74ae855ebddfe8fb$export$a0ff789c034ffdf4)(code)) return ok(code);
        effects.consume(code);
        return pathInside;
    }
    /**
   * In path, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com/a"b
   *                          ^
   * ```
   *
   * @type {State}
   */ function pathAtPunctuation(code) {
        // Count closing parens.
        if (code === 41) sizeClose++;
        effects.consume(code);
        return pathInside;
    }
}
/**
 * Trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the entire trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | https://example.com").
 *                        ^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ca6e61d5eaaf81bd$var$tokenizeTrail(effects, ok, nok) {
    return trail;
    /**
   * In trail of domain or path.
   *
   * ```markdown
   * > | https://example.com").
   *                        ^
   * ```
   *
   * @type {State}
   */ function trail(code) {
        // Regular trailing punctuation.
        if (code === 33 || code === 34 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 63 || code === 95 || code === 126) {
            effects.consume(code);
            return trail;
        }
        // `&` followed by one or more alphabeticals and then a `;`, is
        // as a whole considered as trailing punctuation.
        // In all other cases, it is considered as continuation of the URL.
        if (code === 38) {
            effects.consume(code);
            return trailCharRefStart;
        }
        // Needed because we allow literals after `[`, as we fix:
        // <https://github.com/github/cmark-gfm/issues/278>.
        // Check that it is not followed by `(` or `[`.
        if (code === 93) {
            effects.consume(code);
            return trailBracketAfter;
        }
        if (// `<` is an end.
        code === 60 || // So is whitespace.
        code === null || (0, $74ae855ebddfe8fb$export$a30284361b3814b7)(code) || (0, $74ae855ebddfe8fb$export$a0ff789c034ffdf4)(code)) return ok(code);
        return nok(code);
    }
    /**
   * In trail, after `]`.
   *
   * > 👉 **Note**: this deviates from `cmark-gfm` to fix a bug.
   * > See end of <https://github.com/github/cmark-gfm/issues/278> for more.
   *
   * ```markdown
   * > | https://example.com](
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailBracketAfter(code) {
        // Whitespace or something that could start a resource or reference is the end.
        // Switch back to trail otherwise.
        if (code === null || code === 40 || code === 91 || (0, $74ae855ebddfe8fb$export$a30284361b3814b7)(code) || (0, $74ae855ebddfe8fb$export$a0ff789c034ffdf4)(code)) return ok(code);
        return trail(code);
    }
    /**
   * In character-reference like trail, after `&`.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailCharRefStart(code) {
        // When non-alpha, it’s not a trail.
        return (0, $74ae855ebddfe8fb$export$d65d6b62c24d5436)(code) ? trailCharRefInside(code) : nok(code);
    }
    /**
   * In character-reference like trail.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailCharRefInside(code) {
        // Switch back to trail if this is well-formed.
        if (code === 59) {
            effects.consume(code);
            return trail;
        }
        if ((0, $74ae855ebddfe8fb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return trailCharRefInside;
        }
        // It’s not a trail.
        return nok(code);
    }
}
/**
 * Dot in email domain trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | contact@example.org.
 *                        ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ca6e61d5eaaf81bd$var$tokenizeEmailDomainDotTrail(effects, ok, nok) {
    return start;
    /**
   * Dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                    ^   ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Must be dot.
        effects.consume(code);
        return after;
    }
    /**
   * After dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                     ^   ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Not a trail if alphanumeric.
        return (0, $74ae855ebddfe8fb$export$75c76db11865a9f4)(code) ? nok(code) : ok(code);
    }
}
/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L156>.
 *
 * @type {Previous}
 */ function $ca6e61d5eaaf81bd$var$previousWww(code) {
    return code === null || code === 40 || code === 42 || code === 95 || code === 91 || code === 93 || code === 126 || (0, $74ae855ebddfe8fb$export$a30284361b3814b7)(code);
}
/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L214>.
 *
 * @type {Previous}
 */ function $ca6e61d5eaaf81bd$var$previousProtocol(code) {
    return !(0, $74ae855ebddfe8fb$export$d65d6b62c24d5436)(code);
}
/**
 * @this {TokenizeContext}
 * @type {Previous}
 */ function $ca6e61d5eaaf81bd$var$previousEmail(code) {
    // Do not allow a slash “inside” atext.
    // The reference code is a bit weird, but that’s what it results in.
    // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L307>.
    // Other than slash, every preceding character is allowed.
    return !(code === 47 || $ca6e61d5eaaf81bd$var$gfmAtext(code));
}
/**
 * @param {Code} code
 * @returns {boolean}
 */ function $ca6e61d5eaaf81bd$var$gfmAtext(code) {
    return code === 43 || code === 45 || code === 46 || code === 95 || (0, $74ae855ebddfe8fb$export$75c76db11865a9f4)(code);
}
/**
 * @param {Array<Event>} events
 * @returns {boolean}
 */ function $ca6e61d5eaaf81bd$var$previousUnbalanced(events) {
    let index = events.length;
    let result = false;
    while(index--){
        const token = events[index][1];
        if ((token.type === "labelLink" || token.type === "labelImage") && !token._balanced) {
            result = true;
            break;
        }
        // If we’ve seen this token, and it was marked as not having any unbalanced
        // bracket before it, we can exit.
        if (token._gfmAutolinkLiteralWalkedInto) {
            result = false;
            break;
        }
    }
    if (events.length > 0 && !result) // Mark the last token as “walked into” w/o finding
    // anything.
    events[events.length - 1][1]._gfmAutolinkLiteralWalkedInto = true;
    return result;
}

/**
 * @typedef {import('micromark-util-types').CompileContext} CompileContext
 * @typedef {import('micromark-util-types').Handle} Handle
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').Token} Token
 */ 
function $b578555f801c859e$export$999603f1f1c3d2f9() {
    return {
        exit: {
            literalAutolinkEmail: $b578555f801c859e$var$literalAutolinkEmail,
            literalAutolinkHttp: $b578555f801c859e$var$literalAutolinkHttp,
            literalAutolinkWww: $b578555f801c859e$var$literalAutolinkWww
        }
    };
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $b578555f801c859e$var$literalAutolinkWww(token) {
    $b578555f801c859e$var$anchorFromToken.call(this, token, "http://");
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $b578555f801c859e$var$literalAutolinkEmail(token) {
    $b578555f801c859e$var$anchorFromToken.call(this, token, "mailto:");
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $b578555f801c859e$var$literalAutolinkHttp(token) {
    $b578555f801c859e$var$anchorFromToken.call(this, token);
}
/**
 * @this CompileContext
 * @param {Token} token
 * @param {string | null | undefined} [protocol]
 * @returns {undefined}
 */ function $b578555f801c859e$var$anchorFromToken(token, protocol) {
    const url = this.sliceSerialize(token);
    this.tag('<a href="' + (0, $161d5a87d2da344f$export$d130a2d684099e5a)((protocol || "") + url) + '">');
    this.raw(this.encode(url));
    this.tag("</a>");
}


/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 



const $fcd35fc19af1126d$var$indent = {
    tokenize: $fcd35fc19af1126d$var$tokenizeIndent,
    partial: true
};
function $fcd35fc19af1126d$export$c82499b6656305df() {
    /** @type {Extension} */ return {
        document: {
            [91]: {
                tokenize: $fcd35fc19af1126d$var$tokenizeDefinitionStart,
                continuation: {
                    tokenize: $fcd35fc19af1126d$var$tokenizeDefinitionContinuation
                },
                exit: $fcd35fc19af1126d$var$gfmFootnoteDefinitionEnd
            }
        },
        text: {
            [91]: {
                tokenize: $fcd35fc19af1126d$var$tokenizeGfmFootnoteCall
            },
            [93]: {
                add: "after",
                tokenize: $fcd35fc19af1126d$var$tokenizePotentialGfmFootnoteCall,
                resolveTo: $fcd35fc19af1126d$var$resolveToPotentialGfmFootnoteCall
            }
        }
    };
}
// To do: remove after micromark update.
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $fcd35fc19af1126d$var$tokenizePotentialGfmFootnoteCall(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    /** @type {Token} */ let labelStart;
    // Find an opening.
    while(index--){
        const token = self.events[index][1];
        if (token.type === "labelImage") {
            labelStart = token;
            break;
        }
        // Exit if we’ve walked far enough.
        if (token.type === "gfmFootnoteCall" || token.type === "labelLink" || token.type === "label" || token.type === "image" || token.type === "link") break;
    }
    return start;
    /**
   * @type {State}
   */ function start(code) {
        if (!labelStart || !labelStart._balanced) return nok(code);
        const id = (0, $46d36bfd48dea0be$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        }));
        if (id.codePointAt(0) !== 94 || !defined.includes(id.slice(1))) return nok(code);
        effects.enter("gfmFootnoteCallLabelMarker");
        effects.consume(code);
        effects.exit("gfmFootnoteCallLabelMarker");
        return ok(code);
    }
}
// To do: remove after micromark update.
/** @type {Resolver} */ function $fcd35fc19af1126d$var$resolveToPotentialGfmFootnoteCall(events, context) {
    let index = events.length;
    /** @type {Token | undefined} */ let labelStart;
    // Find an opening.
    while(index--)if (events[index][1].type === "labelImage" && events[index][0] === "enter") {
        labelStart = events[index][1];
        break;
    }
    // Change the `labelImageMarker` to a `data`.
    events[index + 1][1].type = "data";
    events[index + 3][1].type = "gfmFootnoteCallLabelMarker";
    // The whole (without `!`):
    /** @type {Token} */ const call = {
        type: "gfmFootnoteCall",
        start: Object.assign({}, events[index + 3][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    // The `^` marker
    /** @type {Token} */ const marker = {
        type: "gfmFootnoteCallMarker",
        start: Object.assign({}, events[index + 3][1].end),
        end: Object.assign({}, events[index + 3][1].end)
    };
    // Increment the end 1 character.
    marker.end.column++;
    marker.end.offset++;
    marker.end._bufferIndex++;
    /** @type {Token} */ const string = {
        type: "gfmFootnoteCallString",
        start: Object.assign({}, marker.end),
        end: Object.assign({}, events[events.length - 1][1].start)
    };
    /** @type {Token} */ const chunk = {
        type: "chunkString",
        contentType: "string",
        start: Object.assign({}, string.start),
        end: Object.assign({}, string.end)
    };
    /** @type {Array<Event>} */ const replacement = [
        // Take the `labelImageMarker` (now `data`, the `!`)
        events[index + 1],
        events[index + 2],
        [
            "enter",
            call,
            context
        ],
        // The `[`
        events[index + 3],
        events[index + 4],
        // The `^`.
        [
            "enter",
            marker,
            context
        ],
        [
            "exit",
            marker,
            context
        ],
        // Everything in between.
        [
            "enter",
            string,
            context
        ],
        [
            "enter",
            chunk,
            context
        ],
        [
            "exit",
            chunk,
            context
        ],
        [
            "exit",
            string,
            context
        ],
        // The ending (`]`, properly parsed and labelled).
        events[events.length - 2],
        events[events.length - 1],
        [
            "exit",
            call,
            context
        ]
    ];
    events.splice(index, events.length - index + 1, ...replacement);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $fcd35fc19af1126d$var$tokenizeGfmFootnoteCall(effects, ok, nok) {
    const self = this;
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    let size = 0;
    /** @type {boolean} */ let data;
    // Note: the implementation of `markdown-rs` is different, because it houses
    // core *and* extensions in one project.
    // Therefore, it can include footnote logic inside `label-end`.
    // We can’t do that, but luckily, we can parse footnotes in a simpler way than
    // needed for labels.
    return start;
    /**
   * Start of footnote label.
   *
   * ```markdown
   * > | a [^b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("gfmFootnoteCall");
        effects.enter("gfmFootnoteCallLabelMarker");
        effects.consume(code);
        effects.exit("gfmFootnoteCallLabelMarker");
        return callStart;
    }
    /**
   * After `[`, at `^`.
   *
   * ```markdown
   * > | a [^b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function callStart(code) {
        if (code !== 94) return nok(code);
        effects.enter("gfmFootnoteCallMarker");
        effects.consume(code);
        effects.exit("gfmFootnoteCallMarker");
        effects.enter("gfmFootnoteCallString");
        effects.enter("chunkString").contentType = "string";
        return callData;
    }
    /**
   * In label.
   *
   * ```markdown
   * > | a [^b] c
   *         ^
   * ```
   *
   * @type {State}
   */ function callData(code) {
        if (// Too long.
        size > 999 || // Closing brace with nothing.
        code === 93 && !data || // Space or tab is not supported by GFM for some reason.
        // `\n` and `[` not being supported makes sense.
        code === null || code === 91 || (0, $74ae855ebddfe8fb$export$a30284361b3814b7)(code)) return nok(code);
        if (code === 93) {
            effects.exit("chunkString");
            const token = effects.exit("gfmFootnoteCallString");
            if (!defined.includes((0, $46d36bfd48dea0be$export$806d55e226cfcd08)(self.sliceSerialize(token)))) return nok(code);
            effects.enter("gfmFootnoteCallLabelMarker");
            effects.consume(code);
            effects.exit("gfmFootnoteCallLabelMarker");
            effects.exit("gfmFootnoteCall");
            return ok;
        }
        if (!(0, $74ae855ebddfe8fb$export$a30284361b3814b7)(code)) data = true;
        size++;
        effects.consume(code);
        return code === 92 ? callEscape : callData;
    }
    /**
   * On character after escape.
   *
   * ```markdown
   * > | a [^b\c] d
   *           ^
   * ```
   *
   * @type {State}
   */ function callEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return callData;
        }
        return callData(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $fcd35fc19af1126d$var$tokenizeDefinitionStart(effects, ok, nok) {
    const self = this;
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    /** @type {string} */ let identifier;
    let size = 0;
    /** @type {boolean | undefined} */ let data;
    return start;
    /**
   * Start of GFM footnote definition.
   *
   * ```markdown
   * > | [^a]: b
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("gfmFootnoteDefinition")._container = true;
        effects.enter("gfmFootnoteDefinitionLabel");
        effects.enter("gfmFootnoteDefinitionLabelMarker");
        effects.consume(code);
        effects.exit("gfmFootnoteDefinitionLabelMarker");
        return labelAtMarker;
    }
    /**
   * In label, at caret.
   *
   * ```markdown
   * > | [^a]: b
   *      ^
   * ```
   *
   * @type {State}
   */ function labelAtMarker(code) {
        if (code === 94) {
            effects.enter("gfmFootnoteDefinitionMarker");
            effects.consume(code);
            effects.exit("gfmFootnoteDefinitionMarker");
            effects.enter("gfmFootnoteDefinitionLabelString");
            effects.enter("chunkString").contentType = "string";
            return labelInside;
        }
        return nok(code);
    }
    /**
   * In label.
   *
   * > 👉 **Note**: `cmark-gfm` prevents whitespace from occurring in footnote
   * > definition labels.
   *
   * ```markdown
   * > | [^a]: b
   *       ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (// Too long.
        size > 999 || // Closing brace with nothing.
        code === 93 && !data || // Space or tab is not supported by GFM for some reason.
        // `\n` and `[` not being supported makes sense.
        code === null || code === 91 || (0, $74ae855ebddfe8fb$export$a30284361b3814b7)(code)) return nok(code);
        if (code === 93) {
            effects.exit("chunkString");
            const token = effects.exit("gfmFootnoteDefinitionLabelString");
            identifier = (0, $46d36bfd48dea0be$export$806d55e226cfcd08)(self.sliceSerialize(token));
            effects.enter("gfmFootnoteDefinitionLabelMarker");
            effects.consume(code);
            effects.exit("gfmFootnoteDefinitionLabelMarker");
            effects.exit("gfmFootnoteDefinitionLabel");
            return labelAfter;
        }
        if (!(0, $74ae855ebddfe8fb$export$a30284361b3814b7)(code)) data = true;
        size++;
        effects.consume(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * > 👉 **Note**: `cmark-gfm` currently does not support escaped brackets:
   * > <https://github.com/github/cmark-gfm/issues/240>
   *
   * ```markdown
   * > | [^a\*b]: c
   *         ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
    /**
   * After definition label.
   *
   * ```markdown
   * > | [^a]: b
   *         ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            if (!defined.includes(identifier)) defined.push(identifier);
            // Any whitespace after the marker is eaten, forming indented code
            // is not possible.
            // No space is also fine, just like a block quote marker.
            return (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, whitespaceAfter, "gfmFootnoteDefinitionWhitespace");
        }
        return nok(code);
    }
    /**
   * After definition prefix.
   *
   * ```markdown
   * > | [^a]: b
   *           ^
   * ```
   *
   * @type {State}
   */ function whitespaceAfter(code) {
        // `markdown-rs` has a wrapping token for the prefix that is closed here.
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $fcd35fc19af1126d$var$tokenizeDefinitionContinuation(effects, ok, nok) {
    /// Start of footnote definition continuation.
    ///
    /// ```markdown
    ///   | [^a]: b
    /// > |     c
    ///     ^
    /// ```
    //
    // Either a blank line, which is okay, or an indented thing.
    return effects.check((0, $464bca88fae6642a$export$d50d28ce3ab2a612), ok, effects.attempt($fcd35fc19af1126d$var$indent, ok, nok));
}
/** @type {Exiter} */ function $fcd35fc19af1126d$var$gfmFootnoteDefinitionEnd(effects) {
    effects.exit("gfmFootnoteDefinition");
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $fcd35fc19af1126d$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, afterPrefix, "gfmFootnoteDefinitionIndent", 5);
    /**
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "gfmFootnoteDefinitionIndent" && tail[2].sliceSerialize(tail[1], true).length === 4 ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ /**
 * @callback BackLabelTemplate
 *   Generate a back label dynamically.
 *
 *   For the following markdown:
 *
 *   ```markdown
 *   Alpha[^micromark], bravo[^micromark], and charlie[^remark].
 *
 *   [^remark]: things about remark
 *   [^micromark]: things about micromark
 *   ```
 *
 *   This function will be called with:
 *
 *   * `0` and `0` for the backreference from `things about micromark` to
 *      `alpha`, as it is the first used definition, and the first call to it
 *   * `0` and `1` for the backreference from `things about micromark` to
 *      `bravo`, as it is the first used definition, and the second call to it
 *   * `1` and `0` for the backreference from `things about remark` to
 *      `charlie`, as it is the second used definition
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {string}
 *   Back label to use when linking back from definitions to their reference.
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {string | null | undefined} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` attribute on footnotes to prevent them from
 *   *clobbering* (default: `'user-content-'`).
 *
 *   Pass `''` for trusted markdown and when you are careful with
 *   polyfilling.
 *   You could pass a different prefix.
 *
 *   DOM clobbering is this:
 *
 *   ```html
 *   <p id="x"></p>
 *   <script>alert(x) // `x` now refers to the `p#x` DOM element</script>
 *   ```
 *
 *   The above example shows that elements are made available by browsers, by
 *   their ID, on the `window` object.
 *   This is a security risk because you might be expecting some other variable
 *   at that place.
 *   It can also break polyfills.
 *   Using a prefix solves these problems.
 * @property {string | null | undefined} [label='Footnotes']
 *   Textual label to use for the footnotes section (default: `'Footnotes'`).
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different attributes with the `labelAttributes` option.
 * @property {string | null | undefined} [labelAttributes='class="sr-only"']
 *   Attributes to use on the footnote label (default: `'class="sr-only"'`).
 *
 *   Change it to show the label and add other attributes.
 *
 *   This label is typically hidden visually (assuming an `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass an empty string.
 *   You can also add different attributes.
 *
 *   > 👉 **Note**: `id="footnote-label"` is always added, because footnote
 *   > calls use it with `aria-describedby` to provide an accessible label.
 * @property {string | null | undefined} [labelTagName='h2']
 *   HTML tag name to use for the footnote label element (default: `'h2'`).
 *
 *   Change it to match your document structure.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different attributes with the `labelAttributes` option.
 * @property {BackLabelTemplate | string | null | undefined} [backLabel]
 *   Textual label to describe the backreference back to references (default:
 *   `defaultBackLabel`).
 *
 *   The default value is:
 *
 *   ```js
 *   function defaultBackLabel(referenceIndex, rereferenceIndex) {
 *    return (
 *      'Back to reference ' +
 *      (referenceIndex + 1) +
 *      (rereferenceIndex > 1 ? '-' + rereferenceIndex : '')
 *    )
 *  }
 *   ```
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is used in the `aria-label` attribute on each backreference
 *   (the `↩` links).
 *   It affects users of assistive technology.
 */ 

const $1cfbdefadab51ed0$var$own = {}.hasOwnProperty;
/** @type {Options} */ const $1cfbdefadab51ed0$var$emptyOptions = {};
function $1cfbdefadab51ed0$export$a18c77a47f4154b6(referenceIndex, rereferenceIndex) {
    return "Back to reference " + (referenceIndex + 1) + (rereferenceIndex > 1 ? "-" + rereferenceIndex : "");
}
function $1cfbdefadab51ed0$export$a731a1f6cf81900c(options) {
    const config = options || $1cfbdefadab51ed0$var$emptyOptions;
    const label = config.label || "Footnotes";
    const labelTagName = config.labelTagName || "h2";
    const labelAttributes = config.labelAttributes === null || config.labelAttributes === undefined ? 'class="sr-only"' : config.labelAttributes;
    const backLabel = config.backLabel || $1cfbdefadab51ed0$export$a18c77a47f4154b6;
    const clobberPrefix = config.clobberPrefix === null || config.clobberPrefix === undefined ? "user-content-" : config.clobberPrefix;
    return {
        enter: {
            gfmFootnoteDefinition () {
                const stack = this.getData("tightStack");
                stack.push(false);
            },
            gfmFootnoteDefinitionLabelString () {
                this.buffer();
            },
            gfmFootnoteCallString () {
                this.buffer();
            }
        },
        exit: {
            gfmFootnoteDefinition () {
                let definitions = this.getData("gfmFootnoteDefinitions");
                const footnoteStack = this.getData("gfmFootnoteDefinitionStack");
                const tightStack = this.getData("tightStack");
                const current = footnoteStack.pop();
                const value = this.resume();
                if (!definitions) this.setData("gfmFootnoteDefinitions", definitions = {});
                if (!$1cfbdefadab51ed0$var$own.call(definitions, current)) definitions[current] = value;
                tightStack.pop();
                this.setData("slurpOneLineEnding", true);
                // “Hack” to prevent a line ending from showing up if we’re in a definition in
                // an empty list item.
                this.setData("lastWasTag");
            },
            gfmFootnoteDefinitionLabelString (token) {
                let footnoteStack = this.getData("gfmFootnoteDefinitionStack");
                if (!footnoteStack) this.setData("gfmFootnoteDefinitionStack", footnoteStack = []);
                footnoteStack.push((0, $46d36bfd48dea0be$export$806d55e226cfcd08)(this.sliceSerialize(token)));
                this.resume() // Drop the label.
                ;
                this.buffer() // Get ready for a value.
                ;
            },
            gfmFootnoteCallString (token) {
                let calls = this.getData("gfmFootnoteCallOrder");
                let counts = this.getData("gfmFootnoteCallCounts");
                const id = (0, $46d36bfd48dea0be$export$806d55e226cfcd08)(this.sliceSerialize(token));
                /** @type {number} */ let counter;
                this.resume();
                if (!calls) this.setData("gfmFootnoteCallOrder", calls = []);
                if (!counts) this.setData("gfmFootnoteCallCounts", counts = {});
                const index = calls.indexOf(id);
                const safeId = (0, $161d5a87d2da344f$export$d130a2d684099e5a)(id.toLowerCase());
                if (index === -1) {
                    calls.push(id);
                    counts[id] = 1;
                    counter = calls.length;
                } else {
                    counts[id]++;
                    counter = index + 1;
                }
                const reuseCounter = counts[id];
                this.tag('<sup><a href="#' + clobberPrefix + "fn-" + safeId + '" id="' + clobberPrefix + "fnref-" + safeId + (reuseCounter > 1 ? "-" + reuseCounter : "") + '" data-footnote-ref="" aria-describedby="footnote-label">' + String(counter) + "</a></sup>");
            },
            null () {
                const calls = this.getData("gfmFootnoteCallOrder") || [];
                const counts = this.getData("gfmFootnoteCallCounts") || {};
                const definitions = this.getData("gfmFootnoteDefinitions") || {};
                let index = -1;
                if (calls.length > 0) {
                    this.lineEndingIfNeeded();
                    this.tag('<section data-footnotes="" class="footnotes"><' + labelTagName + ' id="footnote-label"' + (labelAttributes ? " " + labelAttributes : "") + ">");
                    this.raw(this.encode(label));
                    this.tag("</" + labelTagName + ">");
                    this.lineEndingIfNeeded();
                    this.tag("<ol>");
                }
                while(++index < calls.length){
                    // Called definitions are always defined.
                    const id = calls[index];
                    const safeId = (0, $161d5a87d2da344f$export$d130a2d684099e5a)(id.toLowerCase());
                    let referenceIndex = 0;
                    /** @type {Array<string>} */ const references = [];
                    while(++referenceIndex <= counts[id])references.push('<a href="#' + clobberPrefix + "fnref-" + safeId + (referenceIndex > 1 ? "-" + referenceIndex : "") + '" data-footnote-backref="" aria-label="' + this.encode(typeof backLabel === "string" ? backLabel : backLabel(index, referenceIndex)) + '" class="data-footnote-backref">↩' + (referenceIndex > 1 ? "<sup>" + referenceIndex + "</sup>" : "") + "</a>");
                    const reference = references.join(" ");
                    let injected = false;
                    this.lineEndingIfNeeded();
                    this.tag('<li id="' + clobberPrefix + "fn-" + safeId + '">');
                    this.lineEndingIfNeeded();
                    this.tag(definitions[id].replace(/<\/p>(?:\r?\n|\r)?$/, function($0) {
                        injected = true;
                        return " " + reference + $0;
                    }));
                    if (!injected) {
                        this.lineEndingIfNeeded();
                        this.tag(reference);
                    }
                    this.lineEndingIfNeeded();
                    this.tag("</li>");
                }
                if (calls.length > 0) {
                    this.lineEndingIfNeeded();
                    this.tag("</ol>");
                    this.lineEndingIfNeeded();
                    this.tag("</section>");
                }
            }
        }
    };
}


/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [singleTilde=true]
 *   Whether to support strikethrough with a single tilde (default: `true`).
 *
 *   Single tildes work on github.com, but are technically prohibited by the
 *   GFM spec.
 */ 


function $5c425dd5360b3475$export$8bbec8ea1400a00e(options) {
    const options_ = options || {};
    let single = options_.singleTilde;
    const tokenizer = {
        tokenize: tokenizeStrikethrough,
        resolveAll: resolveAllStrikethrough
    };
    if (single === null || single === undefined) single = true;
    return {
        text: {
            [126]: tokenizer
        },
        insideSpan: {
            null: [
                tokenizer
            ]
        },
        attentionMarkers: {
            null: [
                126
            ]
        }
    };
    /**
   * Take events and resolve strikethrough.
   *
   * @type {Resolver}
   */ function resolveAllStrikethrough(events, context) {
        let index = -1;
        // Walk through all events.
        while(++index < events.length)// Find a token that can close.
        if (events[index][0] === "enter" && events[index][1].type === "strikethroughSequenceTemporary" && events[index][1]._close) {
            let open = index;
            // Now walk back to find an opener.
            while(open--)// Find a token that can open the closer.
            if (events[open][0] === "exit" && events[open][1].type === "strikethroughSequenceTemporary" && events[open][1]._open && // If the sizes are the same:
            events[index][1].end.offset - events[index][1].start.offset === events[open][1].end.offset - events[open][1].start.offset) {
                events[index][1].type = "strikethroughSequence";
                events[open][1].type = "strikethroughSequence";
                /** @type {Token} */ const strikethrough = {
                    type: "strikethrough",
                    start: Object.assign({}, events[open][1].start),
                    end: Object.assign({}, events[index][1].end)
                };
                /** @type {Token} */ const text = {
                    type: "strikethroughText",
                    start: Object.assign({}, events[open][1].end),
                    end: Object.assign({}, events[index][1].start)
                };
                // Opening.
                /** @type {Array<Event>} */ const nextEvents = [
                    [
                        "enter",
                        strikethrough,
                        context
                    ],
                    [
                        "enter",
                        events[open][1],
                        context
                    ],
                    [
                        "exit",
                        events[open][1],
                        context
                    ],
                    [
                        "enter",
                        text,
                        context
                    ]
                ];
                const insideSpan = context.parser.constructs.insideSpan.null;
                if (insideSpan) // Between.
                (0, $ab4e16a48121f0b9$export$869882364835d202)(nextEvents, nextEvents.length, 0, (0, $af7938992e81384c$export$3ff61ec196ff408b)(insideSpan, events.slice(open + 1, index), context));
                // Closing.
                (0, $ab4e16a48121f0b9$export$869882364835d202)(nextEvents, nextEvents.length, 0, [
                    [
                        "exit",
                        text,
                        context
                    ],
                    [
                        "enter",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        strikethrough,
                        context
                    ]
                ]);
                (0, $ab4e16a48121f0b9$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
                index = open + nextEvents.length - 2;
                break;
            }
        }
        index = -1;
        while(++index < events.length)if (events[index][1].type === "strikethroughSequenceTemporary") events[index][1].type = "data";
        return events;
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeStrikethrough(effects, ok, nok) {
        const previous = this.previous;
        const events = this.events;
        let size = 0;
        return start;
        /** @type {State} */ function start(code) {
            if (previous === 126 && events[events.length - 1][1].type !== "characterEscape") return nok(code);
            effects.enter("strikethroughSequenceTemporary");
            return more(code);
        }
        /** @type {State} */ function more(code) {
            const before = (0, $5b5c5b3f542c778e$export$e3902bc0d835cad0)(previous);
            if (code === 126) {
                // If this is the third marker, exit.
                if (size > 1) return nok(code);
                effects.consume(code);
                size++;
                return more;
            }
            if (size < 2 && !single) return nok(code);
            const token = effects.exit("strikethroughSequenceTemporary");
            const after = (0, $5b5c5b3f542c778e$export$e3902bc0d835cad0)(code);
            token._open = !after || after === 2 && Boolean(before);
            token._close = !before || before === 2 && Boolean(after);
            return ok(code);
        }
    }
}

/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ /**
 * Create an HTML extension for `micromark` to support GFM strikethrough when
 * serializing to HTML.
 *
 * @returns {HtmlExtension}
 *   Extension for `micromark` that can be passed in `htmlExtensions`, to
 *   support GFM strikethrough when serializing to HTML.
 */ function $269c0b3230ca8c52$export$58acedca46108820() {
    return {
        enter: {
            strikethrough () {
                this.tag("<del>");
            }
        },
        exit: {
            strikethrough () {
                this.tag("</del>");
            }
        }
    };
}


/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {[number, number, number, number]} Range
 *   Cell info.
 *
 * @typedef {0 | 1 | 2 | 3} RowKind
 *   Where we are: `1` for head row, `2` for delimiter row, `3` for body row.
 */ 

/**
 * @typedef {import('micromark-util-types').Event} Event
 */ // Port of `edit_map.rs` from `markdown-rs`.
// This should move to `markdown-js` later.
// Deal with several changes in events, batching them together.
//
// Preferably, changes should be kept to a minimum.
// Sometimes, it’s needed to change the list of events, because parsing can be
// messy, and it helps to expose a cleaner interface of events to the compiler
// and other users.
// It can also help to merge many adjacent similar events.
// And, in other cases, it’s needed to parse subcontent: pass some events
// through another tokenizer and inject the result.
/**
 * @typedef {[number, number, Array<Event>]} Change
 * @typedef {[number, number, number]} Jump
 */ /**
 * Tracks a bunch of edits.
 */ class $707f0a4e7a349f12$export$9348908dd4518b4a {
    /**
   * Create a new edit map.
   */ constructor(){
        /**
     * Record of changes.
     *
     * @type {Array<Change>}
     */ this.map = [];
    }
    /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */ add(index, remove, add) {
        $707f0a4e7a349f12$var$addImpl(this, index, remove, add);
    }
    // To do: add this when moving to `micromark`.
    // /**
    //  * Create an edit: but insert `add` before existing additions.
    //  *
    //  * @param {number} index
    //  * @param {number} remove
    //  * @param {Array<Event>} add
    //  * @returns {undefined}
    //  */
    // addBefore(index, remove, add) {
    //   addImpl(this, index, remove, add, true)
    // }
    /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */ consume(events) {
        this.map.sort(function(a, b) {
            return a[0] - b[0];
        });
        /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (this.map.length === 0) return;
        // To do: if links are added in events, like they are in `markdown-rs`,
        // this is needed.
        // // Calculate jumps: where items in the current list move to.
        // /** @type {Array<Jump>} */
        // const jumps = []
        // let index = 0
        // let addAcc = 0
        // let removeAcc = 0
        // while (index < this.map.length) {
        //   const [at, remove, add] = this.map[index]
        //   removeAcc += remove
        //   addAcc += add.length
        //   jumps.push([at, removeAcc, addAcc])
        //   index += 1
        // }
        //
        // . shiftLinks(events, jumps)
        let index = this.map.length;
        /** @type {Array<Array<Event>>} */ const vecs = [];
        while(index > 0){
            index -= 1;
            vecs.push(events.slice(this.map[index][0] + this.map[index][1]), this.map[index][2]);
            // Truncate rest.
            events.length = this.map[index][0];
        }
        vecs.push([
            ...events
        ]);
        events.length = 0;
        let slice = vecs.pop();
        while(slice){
            events.push(...slice);
            slice = vecs.pop();
        }
        // Truncate everything.
        this.map.length = 0;
    }
}
/**
 * Create an edit.
 *
 * @param {EditMap} editMap
 * @param {number} at
 * @param {number} remove
 * @param {Array<Event>} add
 * @returns {undefined}
 */ function $707f0a4e7a349f12$var$addImpl(editMap, at, remove, add) {
    let index = 0;
    /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (remove === 0 && add.length === 0) return;
    while(index < editMap.map.length){
        if (editMap.map[index][0] === at) {
            editMap.map[index][1] += remove;
            // To do: before not used by tables, use when moving to micromark.
            // if (before) {
            //   add.push(...editMap.map[index][2])
            //   editMap.map[index][2] = add
            // } else {
            editMap.map[index][2].push(...add);
            // }
            return;
        }
        index += 1;
    }
    editMap.map.push([
        at,
        remove,
        add
    ]);
} // /**
 //  * Shift `previous` and `next` links according to `jumps`.
 //  *
 //  * This fixes links in case there are events removed or added between them.
 //  *
 //  * @param {Array<Event>} events
 //  * @param {Array<Jump>} jumps
 //  */
 // function shiftLinks(events, jumps) {
 //   let jumpIndex = 0
 //   let index = 0
 //   let add = 0
 //   let rm = 0
 //   while (index < events.length) {
 //     const rmCurr = rm
 //     while (jumpIndex < jumps.length && jumps[jumpIndex][0] <= index) {
 //       add = jumps[jumpIndex][2]
 //       rm = jumps[jumpIndex][1]
 //       jumpIndex += 1
 //     }
 //     // Ignore items that will be removed.
 //     if (rm > rmCurr) {
 //       index += rm - rmCurr
 //     } else {
 //       // ?
 //       // if let Some(link) = &events[index].link {
 //       //     if let Some(next) = link.next {
 //       //         events[next].link.as_mut().unwrap().previous = Some(index + add - rm);
 //       //         while jumpIndex < jumps.len() && jumps[jumpIndex].0 <= next {
 //       //             add = jumps[jumpIndex].2;
 //       //             rm = jumps[jumpIndex].1;
 //       //             jumpIndex += 1;
 //       //         }
 //       //         events[index].link.as_mut().unwrap().next = Some(next + add - rm);
 //       //         index = next;
 //       //         continue;
 //       //     }
 //       // }
 //       index += 1
 //     }
 //   }
 // }


/**
 * @typedef {import('micromark-util-types').Event} Event
 */ /**
 * @typedef {'center' | 'left' | 'none' | 'right'} Align
 */ /**
 * Figure out the alignment of a GFM table.
 *
 * @param {Readonly<Array<Event>>} events
 *   List of events.
 * @param {number} index
 *   Table enter event.
 * @returns {Array<Align>}
 *   List of aligns.
 */ function $ee2a0e15f8454e98$export$bbf4fe2c547a4878(events, index) {
    let inDelimiterRow = false;
    /** @type {Array<Align>} */ const align = [];
    while(index < events.length){
        const event = events[index];
        if (inDelimiterRow) {
            if (event[0] === "enter") // Start of alignment value: set a new column.
            // To do: `markdown-rs` uses `tableDelimiterCellValue`.
            {
                if (event[1].type === "tableContent") align.push(events[index + 1][1].type === "tableDelimiterMarker" ? "left" : "none");
            } else if (event[1].type === "tableContent") {
                if (events[index - 1][1].type === "tableDelimiterMarker") {
                    const alignIndex = align.length - 1;
                    align[alignIndex] = align[alignIndex] === "left" ? "center" : "right";
                }
            } else if (event[1].type === "tableDelimiterRow") break;
        } else if (event[0] === "enter" && event[1].type === "tableDelimiterRow") inDelimiterRow = true;
        index += 1;
    }
    return align;
}


function $a2f65f39627b0423$export$e36cebda627bf2dd() {
    return {
        flow: {
            null: {
                tokenize: $a2f65f39627b0423$var$tokenizeTable,
                resolveAll: $a2f65f39627b0423$var$resolveTable
            }
        }
    };
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $a2f65f39627b0423$var$tokenizeTable(effects, ok, nok) {
    const self = this;
    let size = 0;
    let sizeB = 0;
    /** @type {boolean | undefined} */ let seen;
    return start;
    /**
   * Start of a GFM table.
   *
   * If there is a valid table row or table head before, then we try to parse
   * another row.
   * Otherwise, we try to parse a head.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   * > | | b |
   *     ^
   * ```
   * @type {State}
   */ function start(code) {
        let index = self.events.length - 1;
        while(index > -1){
            const type = self.events[index][1].type;
            if (type === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
            type === "linePrefix") index--;
            else break;
        }
        const tail = index > -1 ? self.events[index][1].type : null;
        const next = tail === "tableHead" || tail === "tableRow" ? bodyRowStart : headRowBefore;
        // Don’t allow lazy body rows.
        if (next === bodyRowStart && self.parser.lazy[self.now().line]) return nok(code);
        return next(code);
    }
    /**
   * Before table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBefore(code) {
        effects.enter("tableHead");
        effects.enter("tableRow");
        return headRowStart(code);
    }
    /**
   * Before table head row, after whitespace.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowStart(code) {
        if (code === 124) return headRowBreak(code);
        // To do: micromark-js should let us parse our own whitespace in extensions,
        // like `markdown-rs`:
        //
        // ```js
        // // 4+ spaces.
        // if (markdownSpace(code)) {
        //   return nok(code)
        // }
        // ```
        seen = true;
        // Count the first character, that isn’t a pipe, double.
        sizeB += 1;
        return headRowBreak(code);
    }
    /**
   * At break in table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *       ^
   *         ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBreak(code) {
        if (code === null) // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
        if ((0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            // If anything other than one pipe (ignoring whitespace) was used, it’s fine.
            if (sizeB > 1) {
                sizeB = 0;
                // To do: check if this works.
                // Feel free to interrupt:
                self.interrupt = true;
                effects.exit("tableRow");
                effects.enter("lineEnding");
                effects.consume(code);
                effects.exit("lineEnding");
                return headDelimiterStart;
            }
            // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
            return nok(code);
        }
        if ((0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code)) // To do: check if this is fine.
        // effects.attempt(State::Next(StateName::GfmTableHeadRowBreak), State::Nok)
        // State::Retry(space_or_tab(tokenizer))
        return (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, headRowBreak, "whitespace")(code);
        sizeB += 1;
        if (seen) {
            seen = false;
            // Header cell count.
            size += 1;
        }
        if (code === 124) {
            effects.enter("tableCellDivider");
            effects.consume(code);
            effects.exit("tableCellDivider");
            // Whether a delimiter was seen.
            seen = true;
            return headRowBreak;
        }
        // Anything else is cell data.
        effects.enter("data");
        return headRowData(code);
    }
    /**
   * In table head row data.
   *
   * ```markdown
   * > | | a |
   *       ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowData(code) {
        if (code === null || code === 124 || (0, $74ae855ebddfe8fb$export$a30284361b3814b7)(code)) {
            effects.exit("data");
            return headRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? headRowEscape : headRowData;
    }
    /**
   * In table head row escape.
   *
   * ```markdown
   * > | | a\-b |
   *         ^
   *   | | ---- |
   *   | | c    |
   * ```
   *
   * @type {State}
   */ function headRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return headRowData;
        }
        return headRowData(code);
    }
    /**
   * Before delimiter row.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterStart(code) {
        // Reset `interrupt`.
        self.interrupt = false;
        // Note: in `markdown-rs`, we need to handle piercing here too.
        if (self.parser.lazy[self.now().line]) return nok(code);
        effects.enter("tableDelimiterRow");
        // Track if we’ve seen a `:` or `|`.
        seen = false;
        if ((0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code)) return (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, headDelimiterBefore, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
        return headDelimiterBefore(code);
    }
    /**
   * Before delimiter row, after optional whitespace.
   *
   * Reused when a `|` is found later, to parse another cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterBefore(code) {
        if (code === 45 || code === 58) return headDelimiterValueBefore(code);
        if (code === 124) {
            seen = true;
            // If we start with a pipe, we open a cell marker.
            effects.enter("tableCellDivider");
            effects.consume(code);
            effects.exit("tableCellDivider");
            return headDelimiterCellBefore;
        }
        // More whitespace / empty row not allowed at start.
        return headDelimiterNok(code);
    }
    /**
   * After `|`, before delimiter cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *      ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellBefore(code) {
        if ((0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code)) return (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, headDelimiterValueBefore, "whitespace")(code);
        return headDelimiterValueBefore(code);
    }
    /**
   * Before delimiter cell value.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterValueBefore(code) {
        // Align: left.
        if (code === 58) {
            sizeB += 1;
            seen = true;
            effects.enter("tableDelimiterMarker");
            effects.consume(code);
            effects.exit("tableDelimiterMarker");
            return headDelimiterLeftAlignmentAfter;
        }
        // Align: none.
        if (code === 45) {
            sizeB += 1;
            // To do: seems weird that this *isn’t* left aligned, but that state is used?
            return headDelimiterLeftAlignmentAfter(code);
        }
        if (code === null || (0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) return headDelimiterCellAfter(code);
        return headDelimiterNok(code);
    }
    /**
   * After delimiter cell left alignment marker.
   *
   * ```markdown
   *   | | a  |
   * > | | :- |
   *        ^
   * ```
   *
   * @type {State}
   */ function headDelimiterLeftAlignmentAfter(code) {
        if (code === 45) {
            effects.enter("tableDelimiterFiller");
            return headDelimiterFiller(code);
        }
        // Anything else is not ok after the left-align colon.
        return headDelimiterNok(code);
    }
    /**
   * In delimiter cell filler.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterFiller(code) {
        if (code === 45) {
            effects.consume(code);
            return headDelimiterFiller;
        }
        // Align is `center` if it was `left`, `right` otherwise.
        if (code === 58) {
            seen = true;
            effects.exit("tableDelimiterFiller");
            effects.enter("tableDelimiterMarker");
            effects.consume(code);
            effects.exit("tableDelimiterMarker");
            return headDelimiterRightAlignmentAfter;
        }
        effects.exit("tableDelimiterFiller");
        return headDelimiterRightAlignmentAfter(code);
    }
    /**
   * After delimiter cell right alignment marker.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *         ^
   * ```
   *
   * @type {State}
   */ function headDelimiterRightAlignmentAfter(code) {
        if ((0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code)) return (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, headDelimiterCellAfter, "whitespace")(code);
        return headDelimiterCellAfter(code);
    }
    /**
   * After delimiter cell.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *          ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellAfter(code) {
        if (code === 124) return headDelimiterBefore(code);
        if (code === null || (0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            // Exit when:
            // * there was no `:` or `|` at all (it’s a thematic break or setext
            //   underline instead)
            // * the header cell count is not the delimiter cell count
            if (!seen || size !== sizeB) return headDelimiterNok(code);
            // Note: in markdown-rs`, a reset is needed here.
            effects.exit("tableDelimiterRow");
            effects.exit("tableHead");
            // To do: in `markdown-rs`, resolvers need to be registered manually.
            // effects.register_resolver(ResolveName::GfmTable)
            return ok(code);
        }
        return headDelimiterNok(code);
    }
    /**
   * In delimiter row, at a disallowed byte.
   *
   * ```markdown
   *   | | a |
   * > | | x |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterNok(code) {
        // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
    }
    /**
   * Before table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   * ```
   *
   * @type {State}
   */ function bodyRowStart(code) {
        // Note: in `markdown-rs` we need to manually take care of a prefix,
        // but in `micromark-js` that is done for us, so if we’re here, we’re
        // never at whitespace.
        effects.enter("tableRow");
        return bodyRowBreak(code);
    }
    /**
   * At break in table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   *       ^
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowBreak(code) {
        if (code === 124) {
            effects.enter("tableCellDivider");
            effects.consume(code);
            effects.exit("tableCellDivider");
            return bodyRowBreak;
        }
        if (code === null || (0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) {
            effects.exit("tableRow");
            return ok(code);
        }
        if ((0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code)) return (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, bodyRowBreak, "whitespace")(code);
        // Anything else is cell content.
        effects.enter("data");
        return bodyRowData(code);
    }
    /**
   * In table body row data.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *       ^
   * ```
   *
   * @type {State}
   */ function bodyRowData(code) {
        if (code === null || code === 124 || (0, $74ae855ebddfe8fb$export$a30284361b3814b7)(code)) {
            effects.exit("data");
            return bodyRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? bodyRowEscape : bodyRowData;
    }
    /**
   * In table body row escape.
   *
   * ```markdown
   *   | | a    |
   *   | | ---- |
   * > | | b\-c |
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return bodyRowData;
        }
        return bodyRowData(code);
    }
}
/** @type {Resolver} */ function $a2f65f39627b0423$var$resolveTable(events, context) {
    let index = -1;
    let inFirstCellAwaitingPipe = true;
    /** @type {RowKind} */ let rowKind = 0;
    /** @type {Range} */ let lastCell = [
        0,
        0,
        0,
        0
    ];
    /** @type {Range} */ let cell = [
        0,
        0,
        0,
        0
    ];
    let afterHeadAwaitingFirstBodyRow = false;
    let lastTableEnd = 0;
    /** @type {Token | undefined} */ let currentTable;
    /** @type {Token | undefined} */ let currentBody;
    /** @type {Token | undefined} */ let currentCell;
    const map = new (0, $707f0a4e7a349f12$export$9348908dd4518b4a)();
    while(++index < events.length){
        const event = events[index];
        const token = event[1];
        if (event[0] === "enter") {
            // Start of head.
            if (token.type === "tableHead") {
                afterHeadAwaitingFirstBodyRow = false;
                // Inject previous (body end and) table end.
                if (lastTableEnd !== 0) {
                    $a2f65f39627b0423$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
                    currentBody = undefined;
                    lastTableEnd = 0;
                }
                // Inject table start.
                currentTable = {
                    type: "table",
                    start: Object.assign({}, token.start),
                    // Note: correct end is set later.
                    end: Object.assign({}, token.end)
                };
                map.add(index, 0, [
                    [
                        "enter",
                        currentTable,
                        context
                    ]
                ]);
            } else if (token.type === "tableRow" || token.type === "tableDelimiterRow") {
                inFirstCellAwaitingPipe = true;
                currentCell = undefined;
                lastCell = [
                    0,
                    0,
                    0,
                    0
                ];
                cell = [
                    0,
                    index + 1,
                    0,
                    0
                ];
                // Inject table body start.
                if (afterHeadAwaitingFirstBodyRow) {
                    afterHeadAwaitingFirstBodyRow = false;
                    currentBody = {
                        type: "tableBody",
                        start: Object.assign({}, token.start),
                        // Note: correct end is set later.
                        end: Object.assign({}, token.end)
                    };
                    map.add(index, 0, [
                        [
                            "enter",
                            currentBody,
                            context
                        ]
                    ]);
                }
                rowKind = token.type === "tableDelimiterRow" ? 2 : currentBody ? 3 : 1;
            } else if (rowKind && (token.type === "data" || token.type === "tableDelimiterMarker" || token.type === "tableDelimiterFiller")) {
                inFirstCellAwaitingPipe = false;
                // First value in cell.
                if (cell[2] === 0) {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $a2f65f39627b0423$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                        lastCell = [
                            0,
                            0,
                            0,
                            0
                        ];
                    }
                    cell[2] = index;
                }
            } else if (token.type === "tableCellDivider") {
                if (inFirstCellAwaitingPipe) inFirstCellAwaitingPipe = false;
                else {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $a2f65f39627b0423$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                    }
                    lastCell = cell;
                    cell = [
                        lastCell[1],
                        index,
                        0,
                        0
                    ];
                }
            }
        } else if (token.type === "tableHead") {
            afterHeadAwaitingFirstBodyRow = true;
            lastTableEnd = index;
        } else if (token.type === "tableRow" || token.type === "tableDelimiterRow") {
            lastTableEnd = index;
            if (lastCell[1] !== 0) {
                cell[0] = cell[1];
                currentCell = $a2f65f39627b0423$var$flushCell(map, context, lastCell, rowKind, index, currentCell);
            } else if (cell[1] !== 0) currentCell = $a2f65f39627b0423$var$flushCell(map, context, cell, rowKind, index, currentCell);
            rowKind = 0;
        } else if (rowKind && (token.type === "data" || token.type === "tableDelimiterMarker" || token.type === "tableDelimiterFiller")) cell[3] = index;
    }
    if (lastTableEnd !== 0) $a2f65f39627b0423$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
    map.consume(context.events);
    // To do: move this into `html`, when events are exposed there.
    // That’s what `markdown-rs` does.
    // That needs updates to `mdast-util-gfm-table`.
    index = -1;
    while(++index < context.events.length){
        const event = context.events[index];
        if (event[0] === "enter" && event[1].type === "table") event[1]._align = (0, $ee2a0e15f8454e98$export$bbf4fe2c547a4878)(context.events, index);
    }
    return events;
}
/**
 * Generate a cell.
 *
 * @param {EditMap} map
 * @param {Readonly<TokenizeContext>} context
 * @param {Readonly<Range>} range
 * @param {RowKind} rowKind
 * @param {number | undefined} rowEnd
 * @param {Token | undefined} previousCell
 * @returns {Token | undefined}
 */ // eslint-disable-next-line max-params
function $a2f65f39627b0423$var$flushCell(map, context, range, rowKind, rowEnd, previousCell) {
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCell' : 'tableCell'
    const groupName = rowKind === 1 ? "tableHeader" : rowKind === 2 ? "tableDelimiter" : "tableData";
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCellValue' : 'tableCellText'
    const valueName = "tableContent";
    // Insert an exit for the previous cell, if there is one.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //          ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[0] !== 0) {
        previousCell.end = Object.assign({}, $a2f65f39627b0423$var$getPoint(context.events, range[0]));
        map.add(range[0], 0, [
            [
                "exit",
                previousCell,
                context
            ]
        ]);
    }
    // Insert enter of this cell.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //           ^-- enter
    //           ^^^^-- this cell
    // ```
    const now = $a2f65f39627b0423$var$getPoint(context.events, range[1]);
    previousCell = {
        type: groupName,
        start: Object.assign({}, now),
        // Note: correct end is set later.
        end: Object.assign({}, now)
    };
    map.add(range[1], 0, [
        [
            "enter",
            previousCell,
            context
        ]
    ]);
    // Insert text start at first data start and end at last data end, and
    // remove events between.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //            ^-- enter
    //             ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[2] !== 0) {
        const relatedStart = $a2f65f39627b0423$var$getPoint(context.events, range[2]);
        const relatedEnd = $a2f65f39627b0423$var$getPoint(context.events, range[3]);
        /** @type {Token} */ const valueToken = {
            type: valueName,
            start: Object.assign({}, relatedStart),
            end: Object.assign({}, relatedEnd)
        };
        map.add(range[2], 0, [
            [
                "enter",
                valueToken,
                context
            ]
        ]);
        if (rowKind !== 2) {
            // Fix positional info on remaining events
            const start = context.events[range[2]];
            const end = context.events[range[3]];
            start[1].end = Object.assign({}, end[1].end);
            start[1].type = "chunkText";
            start[1].contentType = "text";
            // Remove if needed.
            if (range[3] > range[2] + 1) {
                const a = range[2] + 1;
                const b = range[3] - range[2] - 1;
                map.add(a, b, []);
            }
        }
        map.add(range[3] + 1, 0, [
            [
                "exit",
                valueToken,
                context
            ]
        ]);
    }
    // Insert an exit for the last cell, if at the row end.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //                    ^-- exit
    //               ^^^^^^-- this cell (the last one contains two “between” parts)
    // ```
    if (rowEnd !== undefined) {
        previousCell.end = Object.assign({}, $a2f65f39627b0423$var$getPoint(context.events, rowEnd));
        map.add(rowEnd, 0, [
            [
                "exit",
                previousCell,
                context
            ]
        ]);
        previousCell = undefined;
    }
    return previousCell;
}
/**
 * Generate table end (and table body end).
 *
 * @param {Readonly<EditMap>} map
 * @param {Readonly<TokenizeContext>} context
 * @param {number} index
 * @param {Token} table
 * @param {Token | undefined} tableBody
 */ // eslint-disable-next-line max-params
function $a2f65f39627b0423$var$flushTableEnd(map, context, index, table, tableBody) {
    /** @type {Array<Event>} */ const exits = [];
    const related = $a2f65f39627b0423$var$getPoint(context.events, index);
    if (tableBody) {
        tableBody.end = Object.assign({}, related);
        exits.push([
            "exit",
            tableBody,
            context
        ]);
    }
    table.end = Object.assign({}, related);
    exits.push([
        "exit",
        table,
        context
    ]);
    map.add(index + 1, 0, exits);
}
/**
 * @param {Readonly<Array<Event>>} events
 * @param {number} index
 * @returns {Readonly<Point>}
 */ function $a2f65f39627b0423$var$getPoint(events, index) {
    const event = events[index];
    const side = event[0] === "enter" ? "start" : "end";
    return event[1][side];
}

/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ /**
 * @typedef {import('./infer.js').Align} Align
 */ const $ec7caacf921549e0$var$alignment = {
    none: "",
    left: ' align="left"',
    right: ' align="right"',
    center: ' align="center"'
};
function $ec7caacf921549e0$export$c64626c032567c7f() {
    return {
        enter: {
            table (token) {
                const tableAlign = token._align;
                this.lineEndingIfNeeded();
                this.tag("<table>");
                this.setData("tableAlign", tableAlign);
            },
            tableBody () {
                this.tag("<tbody>");
            },
            tableData () {
                const tableAlign = this.getData("tableAlign");
                const tableColumn = this.getData("tableColumn");
                const align = $ec7caacf921549e0$var$alignment[tableAlign[tableColumn]];
                if (align === undefined) // Capture results to ignore them.
                this.buffer();
                else {
                    this.lineEndingIfNeeded();
                    this.tag("<td" + align + ">");
                }
            },
            tableHead () {
                this.lineEndingIfNeeded();
                this.tag("<thead>");
            },
            tableHeader () {
                const tableAlign = this.getData("tableAlign");
                const tableColumn = this.getData("tableColumn");
                const align = $ec7caacf921549e0$var$alignment[tableAlign[tableColumn]];
                this.lineEndingIfNeeded();
                this.tag("<th" + align + ">");
            },
            tableRow () {
                this.setData("tableColumn", 0);
                this.lineEndingIfNeeded();
                this.tag("<tr>");
            }
        },
        exit: {
            // Overwrite the default code text data handler to unescape escaped pipes when
            // they are in tables.
            codeTextData (token) {
                let value = this.sliceSerialize(token);
                if (this.getData("tableAlign")) value = value.replace(/\\([\\|])/g, $ec7caacf921549e0$var$replace);
                this.raw(this.encode(value));
            },
            table () {
                this.setData("tableAlign");
                // Note: we don’t set `slurpAllLineEndings` anymore, in delimiter rows,
                // but we do need to reset it to match a funky newline GH generates for
                // list items combined with tables.
                this.setData("slurpAllLineEndings");
                this.lineEndingIfNeeded();
                this.tag("</table>");
            },
            tableBody () {
                this.lineEndingIfNeeded();
                this.tag("</tbody>");
            },
            tableData () {
                const tableAlign = this.getData("tableAlign");
                const tableColumn = this.getData("tableColumn");
                if (tableColumn in tableAlign) {
                    this.tag("</td>");
                    this.setData("tableColumn", tableColumn + 1);
                } else // Stop capturing.
                this.resume();
            },
            tableHead () {
                this.lineEndingIfNeeded();
                this.tag("</thead>");
            },
            tableHeader () {
                const tableColumn = this.getData("tableColumn");
                this.tag("</th>");
                this.setData("tableColumn", tableColumn + 1);
            },
            tableRow () {
                const tableAlign = this.getData("tableAlign");
                let tableColumn = this.getData("tableColumn");
                while(tableColumn < tableAlign.length){
                    this.lineEndingIfNeeded();
                    this.tag("<td" + $ec7caacf921549e0$var$alignment[tableAlign[tableColumn]] + "></td>");
                    tableColumn++;
                }
                this.setData("tableColumn", tableColumn);
                this.lineEndingIfNeeded();
                this.tag("</tr>");
            }
        }
    };
}
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $ec7caacf921549e0$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === "|" ? $1 : $0;
}


/**
 * @typedef {import('micromark-util-types').CompileContext} CompileContext
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').Token} Token
 */ // An opening or closing tag start, followed by a case-insensitive specific tag name,
// followed by HTML whitespace, a greater than, or a slash.
const $dca4f68541bc853d$var$reFlow = /<(\/?)(iframe|noembed|noframes|plaintext|script|style|title|textarea|xmp)(?=[\t\n\f\r />])/gi;
// As HTML (text) parses tags separately (and very strictly), we don’t need to be
// global.
const $dca4f68541bc853d$var$reText = new RegExp("^" + $dca4f68541bc853d$var$reFlow.source, "i");
function $dca4f68541bc853d$export$c9bf87ea36d00682() {
    return {
        exit: {
            htmlFlowData (token) {
                $dca4f68541bc853d$var$exitHtmlData.call(this, token, $dca4f68541bc853d$var$reFlow);
            },
            htmlTextData (token) {
                $dca4f68541bc853d$var$exitHtmlData.call(this, token, $dca4f68541bc853d$var$reText);
            }
        }
    };
}
/**
 * @this {CompileContext}
 * @param {Token} token
 * @param {RegExp} filter
 * @returns {undefined}
 */ function $dca4f68541bc853d$var$exitHtmlData(token, filter) {
    let value = this.sliceSerialize(token);
    if (this.options.allowDangerousHtml) value = value.replace(filter, "&lt;$1$2");
    this.raw(this.encode(value));
}


/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $4e0abc49bb549e90$var$tasklistCheck = {
    tokenize: $4e0abc49bb549e90$var$tokenizeTasklistCheck
};
function $4e0abc49bb549e90$export$2912e8b2802475ff() {
    return {
        text: {
            [91]: $4e0abc49bb549e90$var$tasklistCheck
        }
    };
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $4e0abc49bb549e90$var$tokenizeTasklistCheck(effects, ok, nok) {
    const self = this;
    return open;
    /**
   * At start of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (// Exit if there’s stuff before.
        self.previous !== null || // Exit if not in the first content that is the first child of a list
        // item.
        !self._gfmTasklistFirstContentOfListItem) return nok(code);
        effects.enter("taskListCheck");
        effects.enter("taskListCheckMarker");
        effects.consume(code);
        effects.exit("taskListCheckMarker");
        return inside;
    }
    /**
   * In task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *        ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // Currently we match how GH works in files.
        // To match how GH works in comments, use `markdownSpace` (`[\t ]`) instead
        // of `markdownLineEndingOrSpace` (`[\t\n\r ]`).
        if ((0, $74ae855ebddfe8fb$export$a30284361b3814b7)(code)) {
            effects.enter("taskListCheckValueUnchecked");
            effects.consume(code);
            effects.exit("taskListCheckValueUnchecked");
            return close;
        }
        if (code === 88 || code === 120) {
            effects.enter("taskListCheckValueChecked");
            effects.consume(code);
            effects.exit("taskListCheckValueChecked");
            return close;
        }
        return nok(code);
    }
    /**
   * At close of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *         ^
   * ```
   *
   * @type {State}
   */ function close(code) {
        if (code === 93) {
            effects.enter("taskListCheckMarker");
            effects.consume(code);
            effects.exit("taskListCheckMarker");
            effects.exit("taskListCheck");
            return after;
        }
        return nok(code);
    }
    /**
   * @type {State}
   */ function after(code) {
        // EOL in paragraph means there must be something else after it.
        if ((0, $74ae855ebddfe8fb$export$34a1dff1c0936953)(code)) return ok(code);
        // Space or tab?
        // Check what comes after.
        if ((0, $74ae855ebddfe8fb$export$2c6cf65c1127992a)(code)) return effects.check({
            tokenize: $4e0abc49bb549e90$var$spaceThenNonSpace
        }, ok, nok)(code);
        // EOF, or non-whitespace, both wrong.
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $4e0abc49bb549e90$var$spaceThenNonSpace(effects, ok, nok) {
    return (0, $07c9a93298d989be$export$ae105c1eb063a0a2)(effects, after, "whitespace");
    /**
   * After whitespace, after task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *           ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // EOF means there was nothing, so bad.
        // EOL means there’s content after it, so good.
        // Impossible to have more spaces.
        // Anything else is good.
        return code === null ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ /**
 * Create an HTML extension for `micromark` to support GFM task list items when
 * serializing to HTML.
 *
 * @returns {HtmlExtension}
 *   Extension for `micromark` that can be passed in `htmlExtensions` to
 *   support GFM task list items when serializing to HTML.
 */ function $cd9b7502612532e3$export$4b6a13e2af1b08ed() {
    return {
        enter: {
            taskListCheck () {
                this.tag('<input type="checkbox" disabled="" ');
            }
        },
        exit: {
            taskListCheck () {
                this.tag("/>");
            },
            taskListCheckValueChecked () {
                this.tag('checked="" ');
            }
        }
    };
}


function $6533d9db15ff2996$export$59ffe8c4d7a4aab2(options) {
    return (0, $29c77022840ec938$export$86a865d89ef3c690)([
        (0, $ca6e61d5eaaf81bd$export$608123d9b549151)(),
        (0, $fcd35fc19af1126d$export$c82499b6656305df)(),
        (0, $5c425dd5360b3475$export$8bbec8ea1400a00e)(options),
        (0, $a2f65f39627b0423$export$e36cebda627bf2dd)(),
        (0, $4e0abc49bb549e90$export$2912e8b2802475ff)()
    ]);
}
function $6533d9db15ff2996$export$6983b82e6105d62a(options) {
    return (0, $29c77022840ec938$export$eaf8c406dfb0a620)([
        (0, $b578555f801c859e$export$999603f1f1c3d2f9)(),
        (0, $1cfbdefadab51ed0$export$a731a1f6cf81900c)(options),
        (0, $269c0b3230ca8c52$export$58acedca46108820)(),
        (0, $ec7caacf921549e0$export$c64626c032567c7f)(),
        (0, $dca4f68541bc853d$export$c9bf87ea36d00682)(),
        (0, $cd9b7502612532e3$export$4b6a13e2af1b08ed)()
    ]);
}


/** @type {Options} */ const $dc8976dcf9ab9c2a$var$emptyOptions = {};
function $dc8976dcf9ab9c2a$export$2e2bcd8739ae039(options) {
    // @ts-expect-error: TS is wrong about `this`.
    // eslint-disable-next-line unicorn/no-this-assignment
    const self = /** @type {Processor} */ this;
    const settings = options || $dc8976dcf9ab9c2a$var$emptyOptions;
    const data = self.data();
    const micromarkExtensions = data.micromarkExtensions || (data.micromarkExtensions = []);
    const fromMarkdownExtensions = data.fromMarkdownExtensions || (data.fromMarkdownExtensions = []);
    const toMarkdownExtensions = data.toMarkdownExtensions || (data.toMarkdownExtensions = []);
    micromarkExtensions.push((0, $6533d9db15ff2996$export$59ffe8c4d7a4aab2)(settings));
    fromMarkdownExtensions.push((0, $66ffb1b9555b95a5$export$95adae814eb7433e)());
    toMarkdownExtensions.push((0, $66ffb1b9555b95a5$export$ea77de6901e7c72b)(settings));
}




var $kUskP = parcelRequire("kUskP");

var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");
const $86116cb31a521dc7$var$githubRawUrlPrefix = "https://raw.githubusercontent.com/logto-io/logto/master";
function $86116cb31a521dc7$var$GithubRawImage({ src: src, alt: alt }) {
    const imgRef = (0, $jC8Vy.useRef)(null);
    const [width, setWidth] = (0, $jC8Vy.useState)(0);
    const onLoad = ()=>{
        if (imgRef.current) {
            const { naturalWidth: naturalWidth, parentElement: parentElement } = imgRef.current;
            const parentClientWidth = parentElement?.clientWidth ?? 0;
            const preferredWidth = Math.min(parentClientWidth, naturalWidth / 2);
            setWidth(preferredWidth);
        }
    };
    if (!src) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsx)("img", {
        ref: imgRef,
        src: `${$86116cb31a521dc7$var$githubRawUrlPrefix}${src}`,
        alt: alt,
        width: `${width}px`,
        crossOrigin: "anonymous",
        onLoad: onLoad
    });
}
var $86116cb31a521dc7$export$2e2bcd8739ae039 = $86116cb31a521dc7$var$GithubRawImage;


var $af308d5a35a07662$export$91b9bee19a0d8569;
var $af308d5a35a07662$export$199d64cd116a5491;
var $af308d5a35a07662$export$bfd64c937657f93a;
var $af308d5a35a07662$export$4a6dd88bada4e7d2;
$af308d5a35a07662$export$91b9bee19a0d8569 = `dvBGRa_inlineCode`;
$af308d5a35a07662$export$199d64cd116a5491 = `dvBGRa_markdown`;
$af308d5a35a07662$export$bfd64c937657f93a = `dvBGRa_rotating`;
$af308d5a35a07662$export$4a6dd88bada4e7d2 = `dvBGRa_shimmer`;


function $061baaa56e1104e9$var$Markdown({ className: className, children: children }) {
    const tocIdSet = (0, $jC8Vy.useRef)(new Set());
    const generateTocId = (text)=>{
        const resolveIdCollision = (kebabCaseString, index = 0)=>{
            const result = `${kebabCaseString}${(0, $7oDSS.conditionalString)(index && `-${index}`)}`;
            if (!tocIdSet.current.has(result)) {
                tocIdSet.current.add(result);
                return result;
            }
            return resolveIdCollision(kebabCaseString, index + 1);
        };
        const initialKebabCaseString = text// Remove all symbols and punctuations except for dash and underscore. https://javascript.info/regexp-unicode
        .replaceAll(/\p{S}|\p{Pi}|\p{Pf}|\p{Ps}|\p{Pe}|\p{Po}/gu, "").replaceAll(/\s+/g, "-").toLowerCase();
        return resolveIdCollision(initialKebabCaseString);
    };
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c7a38d2a5c855e00$export$7460c8b7e4ce9582), {
        remarkPlugins: [
            (0, $dc8976dcf9ab9c2a$export$2e2bcd8739ae039)
        ],
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($af308d5a35a07662$export$199d64cd116a5491, className),
        components: {
            code: ({ className: className, children: children, ...props })=>{
                const [, codeBlockType] = /language-(\w+)/.exec(className ?? "") ?? [];
                return codeBlockType ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $kUskP.default), {
                    isReadonly: true,
                    language: codeBlockType,
                    value: String(children)
                }) : /*#__PURE__*/ (0, $C7mD2.jsx)("code", {
                    className: $af308d5a35a07662$export$91b9bee19a0d8569,
                    ...props,
                    children: children
                });
            },
            img: ({ src: src, alt: alt })=>{
                return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $86116cb31a521dc7$export$2e2bcd8739ae039), {
                    src: src,
                    alt: alt
                });
            },
            a: ({ href: href, children: children })=>{
                const isExternalLink = href?.startsWith("http");
                return /*#__PURE__*/ (0, $C7mD2.jsx)("a", {
                    href: href,
                    target: isExternalLink ? "_blank" : "_self",
                    rel: "noopener",
                    children: children
                });
            },
            h1: ({ children: children })=>/*#__PURE__*/ (0, $C7mD2.jsx)("h1", {
                    id: generateTocId(String(children)),
                    children: children
                }),
            h2: ({ children: children })=>/*#__PURE__*/ (0, $C7mD2.jsx)("h2", {
                    id: generateTocId(String(children)),
                    children: children
                }),
            h3: ({ children: children })=>/*#__PURE__*/ (0, $C7mD2.jsx)("h3", {
                    id: generateTocId(String(children)),
                    children: children
                }),
            h4: ({ children: children })=>/*#__PURE__*/ (0, $C7mD2.jsx)("h4", {
                    id: generateTocId(String(children)),
                    children: children
                }),
            h5: ({ children: children })=>/*#__PURE__*/ (0, $C7mD2.jsx)("h5", {
                    id: generateTocId(String(children)),
                    children: children
                }),
            h6: ({ children: children })=>/*#__PURE__*/ (0, $C7mD2.jsx)("h6", {
                    id: generateTocId(String(children)),
                    children: children
                })
        },
        children: children
    });
}
var $061baaa56e1104e9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $jC8Vy.memo)($061baaa56e1104e9$var$Markdown);



var $5TsIB = parcelRequire("5TsIB");


var $bt3dS = parcelRequire("bt3dS");


var $7VnwS = parcelRequire("7VnwS");

var $7VnwS = parcelRequire("7VnwS");
const $ef5cb09f22cdc7ad$var$useConnectorApi = (props = {})=>{
    const api = (0, $7VnwS.default)(props);
    const createConnector = async (payload)=>api.post("api/connectors", {
            json: payload
        }).json();
    return {
        createConnector: createConnector
    };
};
var $ef5cb09f22cdc7ad$export$2e2bcd8739ae039 = $ef5cb09f22cdc7ad$var$useConnectorApi;


parcelRequire("cuPVN");
var $kowfT = parcelRequire("kowfT");
var $8lyC3 = parcelRequire("8lyC3");

var $jC8Vy = parcelRequire("jC8Vy");

var $voszV = parcelRequire("voszV");
const $ebd9bedb78e39567$var$useConnectorInUse = ()=>{
    const { data: data } = (0, $voszV.default)("api/sign-in-exp");
    const isConnectorInUse = (0, $jC8Vy.useCallback)((connector)=>{
        if (!connector || !data) return false;
        const { type: type, target: target } = connector;
        if (type === (0, $kowfT.ConnectorType).Social) return data.socialSignInConnectorTargets.includes(target);
        const relatedIdentifier = type === (0, $kowfT.ConnectorType).Email ? (0, $8lyC3.SignInIdentifier).Email : (0, $8lyC3.SignInIdentifier).Phone;
        const usedInSignUp = data.signUp.identifiers.includes(relatedIdentifier) && data.signUp.verify;
        const usedInSignIn = data.signIn.methods.some(({ identifier: identifier, verificationCode: verificationCode })=>verificationCode && identifier === relatedIdentifier);
        return usedInSignUp || usedInSignIn;
    }, [
        data
    ]);
    return {
        isConnectorInUse: isConnectorInUse
    };
};
var $ebd9bedb78e39567$export$2e2bcd8739ae039 = $ebd9bedb78e39567$var$useConnectorInUse;



var $4ZcUR = parcelRequire("4ZcUR");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("oK7kD");
var $7YxsJ = parcelRequire("7YxsJ");
parcelRequire("cuPVN");
var $kowfT = parcelRequire("kowfT");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");



var $4vbce = parcelRequire("4vbce");


var $jGWQ4 = parcelRequire("jGWQ4");

var $aqmjm = parcelRequire("aqmjm");


var $fmHmG = parcelRequire("fmHmG");

var $9Q3SI = parcelRequire("9Q3SI");

var $6c796a80483fa826$export$ed9ee40b3ba009ed;
(function(SyncProfileMode) {
    SyncProfileMode["OnlyAtRegister"] = "OnlyAtRegister";
    SyncProfileMode["EachSignIn"] = "EachSignIn";
})($6c796a80483fa826$export$ed9ee40b3ba009ed || ($6c796a80483fa826$export$ed9ee40b3ba009ed = {}));



var $cRLgg = parcelRequire("cRLgg");
var $ffae330fba90e427$export$a7db06668cad9adb;
var $ffae330fba90e427$export$a3bc9b8ed74fc;
var $ffae330fba90e427$export$a2f81f0e973500f1;
var $ffae330fba90e427$export$1ca1ec8b29a4ce27;
var $ffae330fba90e427$export$bfd64c937657f93a;
var $ffae330fba90e427$export$4a6dd88bada4e7d2;
var $ffae330fba90e427$export$5e5b4df997cb5eaa;
var $ffae330fba90e427$export$74dc5dd4e622afa8;
$ffae330fba90e427$export$a7db06668cad9adb = `MeDZeq_content`;
$ffae330fba90e427$export$a3bc9b8ed74fc = `MeDZeq_error`;
$ffae330fba90e427$export$a2f81f0e973500f1 = `MeDZeq_fieldButton`;
$ffae330fba90e427$export$1ca1ec8b29a4ce27 = `MeDZeq_icon`;
$ffae330fba90e427$export$bfd64c937657f93a = `MeDZeq_rotating`;
$ffae330fba90e427$export$4a6dd88bada4e7d2 = `MeDZeq_shimmer`;
$ffae330fba90e427$export$5e5b4df997cb5eaa = `MeDZeq_tip`;
$ffae330fba90e427$export$74dc5dd4e622afa8 = `MeDZeq_trailingIcon`;


function $d07ae49cfb76ace8$var$BasicForm({ isAllowEditTarget: isAllowEditTarget, isDarkDefaultVisible: isDarkDefaultVisible, isStandard: isStandard, conflictConnectorName: conflictConnectorName }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $b595fc2f0eccd19a$export$2e2bcd8739ae039)();
    const { control: control, register: register, formState: { errors: errors } } = (0, $codQP.useFormContext)();
    const [darkVisible, setDarkVisible] = (0, $jC8Vy.useState)(Boolean(isDarkDefaultVisible));
    const toggleDarkVisible = ()=>{
        setDarkVisible((previous)=>!previous);
    };
    const toggleVisibleButtonTitle = darkVisible ? "connectors.guide.logo_dark_collapse" : "connectors.guide.logo_dark_show";
    const ToggleVisibleCaretIcon = darkVisible ? (0, $16d7b0de1c0442c9$export$2e2bcd8739ae039) : (0, $98a4f18236948225$export$2e2bcd8739ae039);
    const syncProfileOptions = [
        {
            value: (0, $6c796a80483fa826$export$ed9ee40b3ba009ed).OnlyAtRegister,
            title: t("connectors.guide.sync_profile_only_at_sign_up")
        },
        {
            value: (0, $6c796a80483fa826$export$ed9ee40b3ba009ed).EachSignIn,
            title: t("connectors.guide.sync_profile_each_sign_in")
        }
    ];
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        children: [
            isStandard && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        isRequired: true,
                        title: "connectors.guide.name",
                        tip: t("connectors.guide.name_tip"),
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                            placeholder: t("connectors.guide.name_placeholder"),
                            error: Boolean(errors.name),
                            ...register("name", {
                                required: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        title: "connectors.guide.logo",
                        tip: t("connectors.guide.logo_tip"),
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                            placeholder: t("connectors.guide.logo_placeholder"),
                            error: errors.logo?.message,
                            ...register("logo", {
                                validate: (value)=>!value || (0, $cRLgg.uriValidator)(value) || t("errors.invalid_uri_format")
                            })
                        })
                    }),
                    darkVisible && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        title: "connectors.guide.logo_dark",
                        tip: t("connectors.guide.logo_dark_tip"),
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                            placeholder: t("connectors.guide.logo_dark_placeholder"),
                            error: errors.logoDark?.message,
                            ...register("logoDark", {
                                validate: (value)=>!value || (0, $cRLgg.uriValidator)(value) || t("errors.invalid_uri_format")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $ffae330fba90e427$export$a2f81f0e973500f1,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                            size: "small",
                            type: "text",
                            title: toggleVisibleButtonTitle,
                            trailingIcon: /*#__PURE__*/ (0, $C7mD2.jsx)(ToggleVisibleCaretIcon, {
                                className: $ffae330fba90e427$export$74dc5dd4e622afa8
                            }),
                            onClick: toggleDarkVisible
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aqmjm.default), {
                isRequired: isStandard,
                title: "connectors.guide.target",
                tip: (closeTipHandler)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                        components: {
                            a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                                href: getDocumentationUrl("/docs/references/connectors/#target"),
                                targetBlank: "noopener",
                                onClick: closeTipHandler
                            })
                        },
                        children: t("connectors.guide.target_tooltip")
                    }),
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                        placeholder: t("connectors.guide.target_placeholder"),
                        error: Boolean(errors.target),
                        disabled: !isAllowEditTarget,
                        ...register("target", {
                            required: true
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $ffae330fba90e427$export$5e5b4df997cb5eaa,
                        children: isStandard ? t("connectors.guide.target_tip_standard") : t("connectors.guide.target_tip")
                    }),
                    conflictConnectorName && /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $ffae330fba90e427$export$a3bc9b8ed74fc,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $ffae330fba90e427$export$1ca1ec8b29a4ce27,
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4vbce.default), {})
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                className: $ffae330fba90e427$export$a7db06668cad9adb,
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                                        components: {
                                            span: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ee1df03577241ccd$export$2e2bcd8739ae039), {
                                                resource: conflictConnectorName
                                            })
                                        },
                                        children: t("connectors.guide.target_conflict")
                                    }),
                                    isStandard ? /*#__PURE__*/ (0, $C7mD2.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0, $C7mD2.jsx)("li", {
                                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                                                    components: {
                                                        span: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ee1df03577241ccd$export$2e2bcd8739ae039), {
                                                            resource: conflictConnectorName
                                                        })
                                                    },
                                                    children: t("connectors.guide.target_conflict_line2")
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $C7mD2.jsx)("li", {
                                                children: t("connectors.guide.target_conflict_line3")
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $7i2be.Trans), {
                                        components: {
                                            span: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ee1df03577241ccd$export$2e2bcd8739ae039), {
                                                resource: conflictConnectorName
                                            })
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $C7mD2.jsx)("br", {}),
                                            t("connectors.guide.target_conflict_line2")
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aqmjm.default), {
                title: "connectors.guide.sync_profile",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                        name: "syncProfile",
                        control: control,
                        rules: {
                            required: true
                        },
                        render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $286a7bc94edef870$export$2e2bcd8739ae039), {
                                options: syncProfileOptions,
                                value: value,
                                onChange: onChange
                            })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $ffae330fba90e427$export$5e5b4df997cb5eaa,
                        children: t("connectors.guide.sync_profile_tip")
                    })
                ]
            })
        ]
    });
}
var $d07ae49cfb76ace8$export$2e2bcd8739ae039 = $d07ae49cfb76ace8$var$BasicForm;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("oK7kD");
var $kowfT = parcelRequire("kowfT");
parcelRequire("cuPVN");
var $3zL0M = parcelRequire("3zL0M");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");
var $gcHb7 = parcelRequire("gcHb7");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $fG7L1 = parcelRequire("fG7L1");

var $kUskP = parcelRequire("kUskP");

var $cw2No = parcelRequire("cw2No");

var $66ixW = parcelRequire("66ixW");

var $aqmjm = parcelRequire("aqmjm");

var $lWGA3 = parcelRequire("lWGA3");

var $cRLgg = parcelRequire("cRLgg");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("oK7kD");
var $bpo6r = parcelRequire("bpo6r");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $kUskP = parcelRequire("kUskP");

var $8R7rc = parcelRequire("8R7rc");

var $aqmjm = parcelRequire("aqmjm");


var $8RfrQ = parcelRequire("8RfrQ");

var $fmHmG = parcelRequire("fmHmG");

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");
var $4745d0a7a5197d69$export$34e0f9847d4c02dd;
var $4745d0a7a5197d69$export$a3bc9b8ed74fc;
var $4745d0a7a5197d69$export$bfd64c937657f93a;
var $4745d0a7a5197d69$export$4a6dd88bada4e7d2;
$4745d0a7a5197d69$export$34e0f9847d4c02dd = `pHWkkq_container`;
$4745d0a7a5197d69$export$a3bc9b8ed74fc = `pHWkkq_error`;
$4745d0a7a5197d69$export$bfd64c937657f93a = `pHWkkq_rotating`;
$4745d0a7a5197d69$export$4a6dd88bada4e7d2 = `pHWkkq_shimmer`;


function $813ca3f2d2f09d2e$var$Textarea({ className: className, error: error, ...rest }, reference) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($4745d0a7a5197d69$export$34e0f9847d4c02dd, Boolean(error) && $4745d0a7a5197d69$export$a3bc9b8ed74fc, className),
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("textarea", {
            ...rest,
            ref: reference
        })
    });
}
var $813ca3f2d2f09d2e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $jC8Vy.forwardRef)($813ca3f2d2f09d2e$var$Textarea);



var $cRLgg = parcelRequire("cRLgg");
var $1f3c859af3fac24e$export$6d59db4903f20f7d;
var $1f3c859af3fac24e$export$bfd64c937657f93a;
var $1f3c859af3fac24e$export$4a6dd88bada4e7d2;
$1f3c859af3fac24e$export$6d59db4903f20f7d = `FmIcgq_description`;
$1f3c859af3fac24e$export$bfd64c937657f93a = `FmIcgq_rotating`;
$1f3c859af3fac24e$export$4a6dd88bada4e7d2 = `FmIcgq_shimmer`;


function $42f02afa2d2311ad$var$ConfigFormFields({ formItems: formItems }) {
    const { watch: watch, register: register, control: control, formState: { errors: { formConfig: formConfigErrors } } } = (0, $codQP.useFormContext)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const values = watch("formConfig");
    const showFormItems = (0, $jC8Vy.useCallback)((formItem)=>{
        if (!formItem.showConditions) return true;
        return formItem.showConditions.every(({ expectValue: expectValue, targetKey: targetKey })=>{
            const targetValue = values[targetKey];
            return targetValue === expectValue;
        });
    }, [
        values
    ]);
    const renderFormItem = (item)=>{
        const errorMessage = formConfigErrors?.[item.key]?.message;
        const error = typeof errorMessage === "string" && errorMessage.length > 0 ? errorMessage : Boolean(formConfigErrors?.[item.key]);
        const buildCommonProperties = ()=>({
                ...register(`formConfig.${item.key}`, {
                    required: item.required,
                    valueAsNumber: item.type === (0, $bpo6r.ConnectorConfigFormItemType).Number
                }),
                placeholder: item.placeholder,
                error: error
            });
        if (item.type === (0, $bpo6r.ConnectorConfigFormItemType).Text) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
            ...buildCommonProperties(),
            // TODO: update connectors form config and remove RegExp check
            isConfidential: item.isConfidential ?? /(Key|Secret)$/.test(item.key)
        });
        if (item.type === (0, $bpo6r.ConnectorConfigFormItemType).MultilineText) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $813ca3f2d2f09d2e$export$2e2bcd8739ae039), {
            rows: 5,
            ...buildCommonProperties()
        });
        if (item.type === (0, $bpo6r.ConnectorConfigFormItemType).Number) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
            type: "number",
            ...buildCommonProperties()
        });
        return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
            name: `formConfig.${item.key}`,
            control: control,
            rules: {
                // For switch, "false" will be treated as an empty value, so we need to set required to false.
                required: item.type === (0, $bpo6r.ConnectorConfigFormItemType).Switch ? false : item.required,
                validate: item.type === (0, $bpo6r.ConnectorConfigFormItemType).Json ? (value)=>typeof value === "string" && (0, $cRLgg.jsonValidator)(value) || t("errors.invalid_json_format") : undefined
            },
            render: ({ field: { onChange: onChange, value: value } })=>{
                if (item.type === (0, $bpo6r.ConnectorConfigFormItemType).Switch) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8RfrQ.default), {
                    label: item.label,
                    checked: typeof value === "boolean" ? value : false,
                    onChange: ({ currentTarget: { checked: checked } })=>{
                        onChange(checked);
                    }
                });
                if (item.type === (0, $bpo6r.ConnectorConfigFormItemType).Select) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $286a7bc94edef870$export$2e2bcd8739ae039), {
                    options: item.selectItems,
                    value: typeof value === "string" ? value : undefined,
                    error: error,
                    onChange: onChange
                });
                if (item.type === (0, $bpo6r.ConnectorConfigFormItemType).Json) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $kUskP.default), {
                    language: "json",
                    error: error,
                    value: typeof value === "string" ? value : "{}",
                    onChange: onChange
                });
                // Default (unknown) type is "Text"
                // This will happen when connector's version is ahead of AC
                return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                    error: error,
                    value: typeof value === "string" ? value : "",
                    onChange: onChange
                });
            }
        });
    };
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $C7mD2.Fragment), {
        children: formItems.map((item)=>showFormItems(item) ? /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aqmjm.default), {
                isRequired: item.required,
                // Tooltip is currently string and does not support i18n.
                tip: item.tooltip,
                title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8R7rc.default), {
                    children: item.type !== (0, $bpo6r.ConnectorConfigFormItemType).Switch && item.label
                }),
                children: [
                    renderFormItem(item),
                    Boolean(item.description) && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $1f3c859af3fac24e$export$6d59db4903f20f7d,
                        children: item.description
                    })
                ]
            }, item.key) : null)
    });
}
var $42f02afa2d2311ad$export$2e2bcd8739ae039 = $42f02afa2d2311ad$var$ConfigFormFields;


var $88f4ff02d953054a$export$6d59db4903f20f7d;
var $88f4ff02d953054a$export$bfd64c937657f93a;
var $88f4ff02d953054a$export$4a6dd88bada4e7d2;
$88f4ff02d953054a$export$6d59db4903f20f7d = `ne1fZq_description`;
$88f4ff02d953054a$export$bfd64c937657f93a = `ne1fZq_rotating`;
$88f4ff02d953054a$export$4a6dd88bada4e7d2 = `ne1fZq_shimmer`;


function $ddd4f852125f683c$var$ConfigForm({ formItems: formItems, className: className, connectorId: connectorId, connectorFactoryId: connectorFactoryId, connectorType: connectorType }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { control: control, formState: { errors: errors } } = (0, $codQP.useFormContext)();
    const { tenantEndpoint: tenantEndpoint } = (0, $jC8Vy.useContext)((0, $fG7L1.AppDataContext));
    const { data: customDomain, applyDomain: applyCustomDomain } = (0, $lWGA3.default)();
    const callbackUri = new URL(`/callback/${connectorId}`, tenantEndpoint).toString();
    const acsUrl = (0, $7oDSS.conditional)(tenantEndpoint && (0, $gcHb7.appendPath)(tenantEndpoint, `/api/authn/saml/${connectorId}`).href);
    const isSamlConnector = connectorFactoryId === "saml";
    // This is an auto-generated URL serve as the connector's internal property and should be configured on the identity provider side.
    const displayUrl = isSamlConnector ? acsUrl : callbackUri;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: className,
        children: [
            connectorType === (0, $kowfT.ConnectorType).Social && displayUrl && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aqmjm.default), {
                title: isSamlConnector ? "connectors.guide.acs_url" : "connectors.guide.callback_uri",
                tip: (0, $7oDSS.conditional)(!isSamlConnector && t("connectors.guide.callback_uri_description")),
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
                        displayType: "block",
                        variant: "border",
                        value: applyCustomDomain(displayUrl)
                    }),
                    customDomain?.status === (0, $3zL0M.DomainStatus).Active && tenantEndpoint && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $88f4ff02d953054a$export$6d59db4903f20f7d,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: isSamlConnector ? "domain.custom_acs_url_note" : "domain.custom_social_callback_url_note",
                            interpolation: {
                                custom: customDomain.domain,
                                default: new URL(tenantEndpoint).host
                            }
                        })
                    })
                ]
            }),
            formItems ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $42f02afa2d2311ad$export$2e2bcd8739ae039), {
                formItems: formItems
            }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: "connectors.guide.config",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                    name: "jsonConfig",
                    control: control,
                    rules: {
                        validate: (value)=>(0, $cRLgg.jsonValidator)(value) || t("errors.invalid_json_format")
                    },
                    render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $kUskP.default), {
                            error: errors.jsonConfig?.message ?? Boolean(errors.jsonConfig),
                            language: "json",
                            value: value,
                            onChange: onChange
                        })
                })
            })
        ]
    });
}
var $ddd4f852125f683c$export$2e2bcd8739ae039 = $ddd4f852125f683c$var$ConfigForm;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("oK7kD");
var $7YxsJ = parcelRequire("7YxsJ");
parcelRequire("4taJ0");
var $9vrm1 = parcelRequire("9vrm1");
parcelRequire("cuPVN");
var $kowfT = parcelRequire("kowfT");
parcelRequire("ajkVG");
var $51A9u = parcelRequire("51A9u");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $jGWQ4 = parcelRequire("jGWQ4");

var $aqmjm = parcelRequire("aqmjm");

var $fmHmG = parcelRequire("fmHmG");
parcelRequire("fIF1D");
var $16GE9 = parcelRequire("16GE9");

var $7VnwS = parcelRequire("7VnwS");

var $bnkR4 = parcelRequire("bnkR4");

var $5OcFi = parcelRequire("5OcFi");
var $0c28aaecbf1cfd84$export$6d59db4903f20f7d;
var $0c28aaecbf1cfd84$export$a3bc9b8ed74fc;
var $0c28aaecbf1cfd84$export$4dbdc8f16fed8a34;
var $0c28aaecbf1cfd84$export$bfd64c937657f93a;
var $0c28aaecbf1cfd84$export$89db4734f6c919c4;
var $0c28aaecbf1cfd84$export$4a6dd88bada4e7d2;
var $0c28aaecbf1cfd84$export$c54b92c0bb02ba64;
$0c28aaecbf1cfd84$export$6d59db4903f20f7d = `MRFoga_description`;
$0c28aaecbf1cfd84$export$a3bc9b8ed74fc = `MRFoga_error`;
$0c28aaecbf1cfd84$export$4dbdc8f16fed8a34 = `MRFoga_fields`;
$0c28aaecbf1cfd84$export$bfd64c937657f93a = `MRFoga_rotating`;
$0c28aaecbf1cfd84$export$89db4734f6c919c4 = `MRFoga_send`;
$0c28aaecbf1cfd84$export$4a6dd88bada4e7d2 = `MRFoga_shimmer`;
$0c28aaecbf1cfd84$export$c54b92c0bb02ba64 = `MRFoga_textField`;


function $1eb486476ab9f4d3$var$ConnectorTester({ connectorFactoryId: connectorFactoryId, connectorType: connectorType, className: className, parse: parse, updateUsage: updateUsage }) {
    const [showTooltip, setShowTooltip] = (0, $jC8Vy.useState)(false);
    const { handleSubmit: handleSubmit, register: register, formState: { errors: { sendTo: inputError }, isSubmitting: isSubmitting } } = (0, $codQP.useForm)();
    const { trigger: trigger } = (0, $codQP.useFormContext)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const api = (0, $7VnwS.default)();
    const isSms = connectorType === (0, $kowfT.ConnectorType).Sms;
    const isEmailServiceConnector = connectorFactoryId === (0, $7YxsJ.ServiceConnector).Email;
    (0, $jC8Vy.useEffect)(()=>{
        if (!showTooltip) return;
        const tooltipTimeout = setTimeout(()=>{
            setShowTooltip(false);
        }, 2000);
        return ()=>{
            clearTimeout(tooltipTimeout);
        };
    }, [
        showTooltip
    ]);
    const onSubmit = handleSubmit((0, $5OcFi.trySubmitSafe)(async (formData)=>{
        const isConfigFormValid = await trigger(undefined, {
            shouldFocus: true
        });
        if (!isConfigFormValid) return;
        const { sendTo: sendTo } = formData;
        const data = {
            config: parse(),
            ...isSms ? {
                phone: (0, $51A9u.parsePhoneNumber)(sendTo)
            } : {
                email: sendTo
            }
        };
        await api.post(`api/connectors/${connectorFactoryId}/test`, {
            json: data
        }).json();
        updateUsage?.();
        setShowTooltip(true);
    }));
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $0c28aaecbf1cfd84$export$4dbdc8f16fed8a34,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        title: isSms ? "connector_details.test_sms_sender" : "connector_details.test_email_sender",
                        className: $0c28aaecbf1cfd84$export$c54b92c0bb02ba64,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                            error: Boolean(inputError),
                            type: isSms ? "tel" : "email",
                            placeholder: isSms ? t("connector_details.test_sms_placeholder") : t("connector_details.test_email_placeholder"),
                            onKeyDown: (0, $bnkR4.onKeyDownHandler)({
                                Enter: onSubmit
                            }),
                            ...register("sendTo", {
                                required: true,
                                pattern: {
                                    value: isSms ? (0, $9vrm1.phoneInputRegEx) : (0, $9vrm1.emailRegEx),
                                    message: t("connector_details.send_error_invalid_format")
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $16GE9.default), {
                        isKeepOpen: true,
                        isSuccessful: true,
                        anchorClassName: $0c28aaecbf1cfd84$export$89db4734f6c919c4,
                        content: (0, $7oDSS.conditional)(showTooltip && t("connector_details.test_message_sent")),
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                            isLoading: isSubmitting,
                            title: "connector_details.send",
                            type: "outline",
                            onClick: onSubmit
                        })
                    })
                ]
            }),
            !isEmailServiceConnector && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $0c28aaecbf1cfd84$export$6d59db4903f20f7d,
                children: t("connector_details.test_sender_description")
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $0c28aaecbf1cfd84$export$a3bc9b8ed74fc,
                children: inputError?.message
            })
        ]
    });
}
var $1eb486476ab9f4d3$export$2e2bcd8739ae039 = $1eb486476ab9f4d3$var$ConnectorTester;






var $7VnwS = parcelRequire("7VnwS");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
parcelRequire("oK7kD");
var $bpo6r = parcelRequire("bpo6r");
var $kowfT = parcelRequire("kowfT");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");


var $3RCsa = parcelRequire("3RCsa");
const $3125bc5569a0afef$var$initFormData = (formItems, config)=>{
    const data = formItems.map((item)=>{
        const value = config?.[item.key] ?? item.defaultValue;
        if (item.type === (0, $bpo6r.ConnectorConfigFormItemType).Json) return [
            item.key,
            JSON.stringify(value, null, 2)
        ];
        return [
            item.key,
            value
        ];
    });
    return Object.fromEntries(data);
};
const $3125bc5569a0afef$export$938064bb4218f4f0 = (config, formItems)=>{
    return Object.fromEntries(Object.entries(config).map(([key, value])=>{
        // Filter out empty input
        if (value === "") return null;
        const formItem = formItems.find((item)=>item.key === key);
        if (!formItem) return null;
        if (formItem.type === (0, $bpo6r.ConnectorConfigFormItemType).Number) /**
           * When set ReactHookForm valueAsNumber to true, the number input field
           * will return number value. If the input can not be properly converted
           * to number value, it will return NaN instead.
           */ // The number input my return string value.
        return Number.isNaN(value) ? null : [
            key,
            Number(value)
        ];
        if (formItem.type === (0, $bpo6r.ConnectorConfigFormItemType).Json) {
            // The JSON validation is done in the form
            const result = (0, $3RCsa.safeParseJson)(typeof value === "string" ? value : "");
            return [
                key,
                result.success ? result.data : {}
            ];
        }
        return [
            key,
            value
        ];
    }).filter((item)=>Array.isArray(item)));
};
const $3125bc5569a0afef$export$6dae40d70e178ce1 = (connector)=>{
    const { metadata: metadata, type: type, config: config, syncProfile: syncProfile, isStandard: isStandard, formItems: formItems, target: target } = connector;
    const { name: name, logo: logo, logoDark: logoDark } = metadata;
    const formConfig = (0, $7oDSS.conditional)(formItems && $3125bc5569a0afef$var$initFormData(formItems, config)) ?? {};
    return {
        name: name?.en,
        logo: logo,
        logoDark: logoDark,
        target: (0, $7oDSS.conditional)(type === (0, $kowfT.ConnectorType).Social && (isStandard ? target : metadata.target ?? target)),
        syncProfile: syncProfile ? (0, $6c796a80483fa826$export$ed9ee40b3ba009ed).EachSignIn : (0, $6c796a80483fa826$export$ed9ee40b3ba009ed).OnlyAtRegister,
        jsonConfig: JSON.stringify(config, null, 2),
        formConfig: formConfig
    };
};
const $3125bc5569a0afef$export$7bb2f28ad6c44e46 = (connectorFactory)=>{
    const { formItems: formItems, configTemplate: configTemplate, type: type, isStandard: isStandard, target: target } = connectorFactory;
    const jsonConfig = configTemplate ?? "{}";
    const formConfig = (0, $7oDSS.conditional)(formItems && $3125bc5569a0afef$var$initFormData(formItems)) ?? {};
    return {
        target: (0, $7oDSS.conditional)(type === (0, $kowfT.ConnectorType).Social && !isStandard && target),
        syncProfile: (0, $6c796a80483fa826$export$ed9ee40b3ba009ed).OnlyAtRegister,
        jsonConfig: jsonConfig,
        formConfig: formConfig
    };
};



var $3RCsa = parcelRequire("3RCsa");
const $ad959390f5003ec2$var$useJsonStringConfigParser = ()=>{
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return (config)=>{
        if (!config) {
            (0, $FuhPC.toast).error(t("connector_details.save_error_empty_config"));
            return;
        }
        const result = (0, $3RCsa.safeParseJson)(config);
        if (!result.success) {
            (0, $FuhPC.toast).error(result.error);
            return;
        }
        return result.data;
    };
};
const $ad959390f5003ec2$export$4c86d49e765c99cd = ()=>{
    const parseJsonConfig = $ad959390f5003ec2$var$useJsonStringConfigParser();
    return (data, formItems)=>{
        return formItems ? (0, $3125bc5569a0afef$export$938064bb4218f4f0)(data.formConfig, formItems) : parseJsonConfig(data.jsonConfig);
    };
};






var $5OcFi = parcelRequire("5OcFi");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("oK7kD");
var $9BaLv = parcelRequire("9BaLv");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $c3dK3 = parcelRequire("c3dK3");


var $66ixW = parcelRequire("66ixW");

var $aqmjm = parcelRequire("aqmjm");

var $fmHmG = parcelRequire("fmHmG");




var $cRLgg = parcelRequire("cRLgg");
var $a397e9e2678766fd$export$6d59db4903f20f7d;
var $a397e9e2678766fd$export$bfd64c937657f93a;
var $a397e9e2678766fd$export$4a6dd88bada4e7d2;
$a397e9e2678766fd$export$6d59db4903f20f7d = `FnKWBW_description`;
$a397e9e2678766fd$export$bfd64c937657f93a = `FnKWBW_rotating`;
$a397e9e2678766fd$export$4a6dd88bada4e7d2 = `FnKWBW_shimmer`;


const $c8830ea370f3dcd4$var$extraInfoGuard = (0, $c3dK3.z).object({
    fromEmail: (0, $c3dK3.z).string()
});
/**
 * Note:
 * This `EmailServiceConnectorForm` is hard-coded since the custom connector config form does not support i18n and we need i18n for our built-in connectors.
 *
 * TODO: @xiaoyijun @darcyYe remove this hard-coded form once the custom connector config form supports i18n.
 */ function $c8830ea370f3dcd4$var$EmailServiceConnectorForm({ extraInfo: extraInfo }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { isReady: isUserAssetsServiceReady } = (0, $04111409d75abad4$export$2e2bcd8739ae039)();
    const parsedExtraInfo = $c8830ea370f3dcd4$var$extraInfoGuard.safeParse(extraInfo ?? {});
    const { getDocumentationUrl: getDocumentationUrl } = (0, $b595fc2f0eccd19a$export$2e2bcd8739ae039)();
    const { control: control, register: register, formState: { errors: { formConfig: fromConfigErrors } } } = (0, $codQP.useFormContext)();
    const validateInput = (value)=>{
        const containUrl = (0, $9BaLv.urlRegEx).test(value);
        return containUrl ? t("connector_details.logto_email.urls_not_allowed") : true;
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
        title: "connector_details.logto_email.email_template_title",
        description: "connector_details.logto_email.template_description",
        learnMoreLink: {
            href: getDocumentationUrl("/docs/recipes/configure-connectors/email-connector/configure-logto-email-service/#unified-email-templates"),
            targetBlank: "noopener",
            linkText: "connector_details.logto_email.template_description_link_text"
        },
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: "connector_details.logto_email.from_email_field",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                    readOnly: true,
                    value: (0, $7oDSS.conditionalString)(parsedExtraInfo.success && parsedExtraInfo.data.fromEmail)
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: "connector_details.logto_email.sender_name_field",
                tip: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                    forKey: "connector_details.logto_email.sender_name_tip"
                }),
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                    ...register("formConfig.senderName", {
                        validate: (value)=>validateInput((0, $7oDSS.conditionalString)(value))
                    }),
                    error: fromConfigErrors?.senderName?.message,
                    placeholder: t("connector_details.logto_email.sender_name_placeholder")
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aqmjm.default), {
                title: "connector_details.logto_email.company_information_field",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                        ...register("formConfig.companyInformation", {
                            validate: (value)=>validateInput((0, $7oDSS.conditionalString)(value))
                        }),
                        error: fromConfigErrors?.companyInformation?.message,
                        placeholder: t("connector_details.logto_email.company_information_placeholder")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $a397e9e2678766fd$export$6d59db4903f20f7d,
                        children: t("connector_details.logto_email.company_information_description")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: "connector_details.logto_email.app_logo_field",
                tip: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                    forKey: "connector_details.logto_email.app_logo_tip"
                }),
                headlineSpacing: isUserAssetsServiceReady ? "large" : "default",
                children: isUserAssetsServiceReady ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                    name: "formConfig.appLogo",
                    control: control,
                    render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $ab5b5e61d391674b$export$2e2bcd8739ae039), {
                            name: name,
                            allowedMimeTypes: [
                                "image/png",
                                "image/jpeg"
                            ],
                            value: (0, $7oDSS.conditionalString)(value),
                            onChange: onChange
                        })
                }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                    ...register("formConfig.appLogo", {
                        validate: (value)=>!value || (0, $cRLgg.uriValidator)((0, $7oDSS.conditionalString)(value)) || t("errors.invalid_uri_format")
                    }),
                    error: fromConfigErrors?.appLogo?.message
                })
            })
        ]
    });
}
var $c8830ea370f3dcd4$export$2e2bcd8739ae039 = $c8830ea370f3dcd4$var$EmailServiceConnectorForm;


function $98cb9dc7c74fa8db$var$ConnectorContent({ isDeleted: isDeleted, connectorData: connectorData, onConnectorUpdated: onConnectorUpdated }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $b595fc2f0eccd19a$export$2e2bcd8739ae039)();
    const api = (0, $7VnwS.default)();
    const formData = (0, $jC8Vy.useMemo)(()=>(0, $3125bc5569a0afef$export$6dae40d70e178ce1)(connectorData), [
        connectorData
    ]);
    const methods = (0, $codQP.useForm)({
        reValidateMode: "onBlur",
        defaultValues: {
            ...formData,
            /**
       * Note:
       * The `formConfig` will be setup in the `useEffect` hook since react-hook-form's `useForm` hook infers `Record<string, unknown>` to `{ [x: string]: {} | undefined }` incorrectly,
       * this causes we cannot apply the default value of `formConfig` to the form.
       */ formConfig: {}
        }
    });
    const { formState: { isSubmitting: isSubmitting, isDirty: isDirty }, handleSubmit: handleSubmit, watch: watch, reset: reset } = methods;
    const { id: id, connectorId: connectorId, type: connectorType, formItems: formItems, isStandard: isStandardConnector, metadata: { logoDark: logoDark } } = connectorData;
    const isSocialConnector = connectorType === (0, $kowfT.ConnectorType).Social;
    const isEmailServiceConnector = connectorId === (0, $7YxsJ.ServiceConnector).Email;
    (0, $jC8Vy.useEffect)(()=>{
        /**
     * Note: should not refresh form data when the form is dirty.
     */ if (isDirty) return;
        reset(formData);
    }, [
        formData,
        isDirty,
        reset
    ]);
    const configParser = (0, $ad959390f5003ec2$export$4c86d49e765c99cd)();
    const onSubmit = handleSubmit((0, $5OcFi.trySubmitSafe)(async (data)=>{
        const { formItems: formItems, isStandard: isStandard, id: id } = connectorData;
        const config = configParser(data, formItems);
        const { syncProfile: syncProfile, name: name, logo: logo, logoDark: logoDark, target: target } = data;
        const payload = isSocialConnector ? {
            config: config,
            syncProfile: syncProfile === (0, $6c796a80483fa826$export$ed9ee40b3ba009ed).EachSignIn
        } : {
            config: config
        };
        const standardConnectorPayload = {
            ...payload,
            metadata: {
                name: {
                    en: name
                },
                logo: logo,
                logoDark: logoDark,
                target: target
            }
        };
        // Should not update `target` for neither passwordless connectors nor non-standard social connectors.
        const body = isStandard ? standardConnectorPayload : {
            ...payload,
            target: undefined
        };
        const updatedConnector = await api.patch(`api/connectors/${id}`, {
            json: body
        }).json();
        /**
       * Note: reset form dirty state before updating the form data.
       */ reset((0, $3125bc5569a0afef$export$6dae40d70e178ce1)(updatedConnector));
        onConnectorUpdated(updatedConnector);
        (0, $FuhPC.toast).success(t("general.saved"));
    }));
    const updateUsage = (0, $jC8Vy.useCallback)(()=>{
        if (connectorData.usage === undefined) return;
        onConnectorUpdated();
    }, [
        connectorData,
        onConnectorUpdated
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $codQP.FormProvider), {
        ...methods,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $f0e7fd6d3bded790$export$2e2bcd8739ae039), {
                autoComplete: "off",
                isDirty: isDirty,
                isSubmitting: isSubmitting,
                onDiscard: ()=>{
                    reset();
                },
                onSubmit: onSubmit,
                children: [
                    isSocialConnector && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
                        title: "connector_details.settings",
                        description: "connector_details.settings_description",
                        learnMoreLink: {
                            href: getDocumentationUrl("/docs/references/connectors"),
                            targetBlank: "noopener"
                        },
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $d07ae49cfb76ace8$export$2e2bcd8739ae039), {
                            isStandard: isStandardConnector,
                            isDarkDefaultVisible: Boolean(logoDark)
                        })
                    }),
                    isEmailServiceConnector ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c8830ea370f3dcd4$export$2e2bcd8739ae039), {
                        extraInfo: connectorData.extraInfo
                    }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
                        title: "connector_details.parameter_configuration",
                        description: (0, $7oDSS.conditional)(!isSocialConnector && "connector_details.settings_description"),
                        learnMoreLink: (0, $7oDSS.conditional)(!isSocialConnector && {
                            href: getDocumentationUrl("/docs/references/connectors"),
                            targetBlank: "noopener"
                        }),
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ddd4f852125f683c$export$2e2bcd8739ae039), {
                            formItems: formItems,
                            connectorFactoryId: connectorId,
                            connectorId: id,
                            connectorType: connectorType
                        })
                    }),
                    !isSocialConnector && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
                        title: "connector_details.test_connection",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1eb486476ab9f4d3$export$2e2bcd8739ae039), {
                            connectorFactoryId: connectorId,
                            connectorType: connectorType,
                            parse: ()=>configParser(watch(), formItems),
                            updateUsage: updateUsage
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fea55fa5d5726e29$export$2e2bcd8739ae039), {
                hasUnsavedChanges: !isDeleted && isDirty
            })
        ]
    });
}
var $98cb9dc7c74fa8db$export$2e2bcd8739ae039 = $98cb9dc7c74fa8db$var$ConnectorContent;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $cIy8v = parcelRequire("cIy8v");
var $kowfT = parcelRequire("kowfT");

var $5UrGx = parcelRequire("5UrGx");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $6bq3s = parcelRequire("6bq3s");

var $voszV = parcelRequire("voszV");
parcelRequire("8Mb3E");
var $lmQmj = parcelRequire("lmQmj");

var $bt3dS = parcelRequire("bt3dS");

var $4ZcUR = parcelRequire("4ZcUR");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $cIy8v = parcelRequire("cIy8v");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $a01fa3089d11e147$var$SvgConnectorPlatformIconUniversal = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M6.667 3.333a.667.667 0 1 0 0 1.334.667.667 0 0 0 0-1.334ZM4 3.333a.667.667 0 1 0 0 1.334.667.667 0 0 0 0-1.334Zm5.333 0a.667.667 0 1 0 0 1.334.667.667 0 0 0 0-1.334Zm4-2.666H2.667a2 2 0 0 0-2 2v10.666a2 2 0 0 0 2 2h10.666a2 2 0 0 0 2-2V2.667a2 2 0 0 0-2-2ZM14 13.333a.667.667 0 0 1-.667.667H2.667A.667.667 0 0 1 2 13.333v-6h12v6ZM14 6H2V2.667A.667.667 0 0 1 2.667 2h10.666a.667.667 0 0 1 .667.667V6Z",
            fill: "currentColor"
        })
    });
var $a01fa3089d11e147$export$2e2bcd8739ae039 = $a01fa3089d11e147$var$SvgConnectorPlatformIconUniversal;



function $f79fa5ee09aaae72$var$ConnectorPlatformIcon({ platform: platform }) {
    if (platform === (0, $cIy8v.ConnectorPlatform).Native) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $b93f65ea78fb0de4$export$2e2bcd8739ae039), {});
    if (platform === (0, $cIy8v.ConnectorPlatform).Web) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3c153d09ac05a655$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a01fa3089d11e147$export$2e2bcd8739ae039), {});
}
var $f79fa5ee09aaae72$export$2e2bcd8739ae039 = $f79fa5ee09aaae72$var$ConnectorPlatformIcon;


var $17029af85128534f$export$89da14300d534261;
var $17029af85128534f$export$1ca1ec8b29a4ce27;
var $17029af85128534f$export$bfd64c937657f93a;
var $17029af85128534f$export$4a6dd88bada4e7d2;
var $17029af85128534f$export$62d58b1c91e8e902;
var $17029af85128534f$export$39f5674517ec0000;
$17029af85128534f$export$89da14300d534261 = `O1NQ5W_active`;
$17029af85128534f$export$1ca1ec8b29a4ce27 = `O1NQ5W_icon`;
$17029af85128534f$export$bfd64c937657f93a = `O1NQ5W_rotating`;
$17029af85128534f$export$4a6dd88bada4e7d2 = `O1NQ5W_shimmer`;
$17029af85128534f$export$62d58b1c91e8e902 = `O1NQ5W_tab`;
$17029af85128534f$export$39f5674517ec0000 = `O1NQ5W_tabs`;


function $23ea47e0ebe99977$var$ConnectorTabs({ target: target, connectorId: connectorId }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: connectors } = (0, $voszV.default)(`api/connectors?target=${target}`);
    const { getTo: getTo } = (0, $4ZcUR.default)();
    if (!connectors) return null;
    if (connectors.length === 0) return null;
    if (connectors.length === 1 && connectors[0]?.platform === (0, $cIy8v.ConnectorPlatform).Universal) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: $17029af85128534f$export$39f5674517ec0000,
        children: connectors.map((connector)=>/*#__PURE__*/ (0, $C7mD2.jsxs)((0, $6bq3s.Link), {
                to: getTo(`/connectors/${connector.type === (0, $kowfT.ConnectorType).Social ? (0, $bt3dS.ConnectorsTabs).Social : (0, $bt3dS.ConnectorsTabs).Passwordless}/${connector.id}`),
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($17029af85128534f$export$62d58b1c91e8e902, connector.id === connectorId && $17029af85128534f$export$89da14300d534261),
                children: [
                    connector.platform && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $17029af85128534f$export$1ca1ec8b29a4ce27,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f79fa5ee09aaae72$export$2e2bcd8739ae039), {
                            platform: connector.platform
                        })
                    }),
                    connector.platform && t((0, $lmQmj.connectorPlatformLabel)[connector.platform])
                ]
            }, connector.id))
    });
}
var $23ea47e0ebe99977$export$2e2bcd8739ae039 = $23ea47e0ebe99977$var$ConnectorTabs;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $kowfT = parcelRequire("kowfT");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

function $94a5acb2a2382d2b$var$ConnectorTypeName({ type: type }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
        children: [
            type === (0, $kowfT.ConnectorType).Email && t("connector_details.type_email"),
            type === (0, $kowfT.ConnectorType).Sms && t("connector_details.type_sms"),
            type === (0, $kowfT.ConnectorType).Social && t("connector_details.type_social")
        ]
    });
}
var $94a5acb2a2382d2b$export$2e2bcd8739ae039 = $94a5acb2a2382d2b$var$ConnectorTypeName;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $f566651bcfbb23d6$var$SvgEmailSentDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.44 3.23 9.6 10.07l-6.838-6.84c.143-.019.29-.029.438-.029H16c.15 0 .296.01.44.03ZM9.6 11.96a.798.798 0 0 1-.605-.234l-7.81-7.81A3.194 3.194 0 0 0 0 6.4V16a3.2 3.2 0 0 0 3.2 3.2H16a3.2 3.2 0 0 0 3.2-3.2V6.4a3.194 3.194 0 0 0-1.183-2.484l-7.81 7.81a.798.798 0 0 1-.606.233Z",
                fill: "url(#paint0_linear_8601_113491)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 18.4,
                cy: 14.4,
                r: 5.6,
                fill: "#68BE6C"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 1.603,
                height: 4.808,
                rx: 0.801,
                transform: "rotate(-44.926 24.231 -10.617)",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 6.41,
                height: 1.603,
                rx: 0.801,
                transform: "rotate(-44.926 28.102 -12.23)",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("defs", {
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                    id: "paint0_linear_8601_113491",
                    x1: 13.6,
                    y1: 3.2,
                    x2: -1.2,
                    y2: 19.2,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            stopColor: "#D361E7"
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            offset: 1,
                            stopColor: "#7D5FF4"
                        })
                    ]
                })
            })
        ]
    });
var $f566651bcfbb23d6$export$2e2bcd8739ae039 = $f566651bcfbb23d6$var$SvgEmailSentDark;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $20c74b78b4de93fe$var$SvgEmailSent = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.44 3.23 9.6 10.069l-6.838-6.84c.143-.019.29-.029.438-.029H16c.15 0 .296.01.44.03ZM9.6 11.958a.798.798 0 0 1-.605-.233l-7.81-7.81A3.194 3.194 0 0 0 0 6.4V16a3.2 3.2 0 0 0 3.2 3.2H16a3.2 3.2 0 0 0 3.2-3.2V6.4a3.194 3.194 0 0 0-1.183-2.485l-7.81 7.81a.798.798 0 0 1-.606.233Z",
                fill: "url(#paint0_linear_271_9123)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 18.4,
                cy: 14.4,
                r: 5.6,
                fill: "#83DA85"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 1.603,
                height: 4.808,
                rx: 0.801,
                transform: "rotate(-44.926 24.231 -10.617)",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 6.41,
                height: 1.603,
                rx: 0.801,
                transform: "rotate(-44.926 28.103 -12.23)",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("defs", {
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                    id: "paint0_linear_271_9123",
                    x1: 13.6,
                    y1: 3.2,
                    x2: -1.2,
                    y2: 19.2,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            stopColor: "#D361E7"
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            offset: 1,
                            stopColor: "#7D5FF4"
                        })
                    ]
                })
            })
        ]
    });
var $20c74b78b4de93fe$export$2e2bcd8739ae039 = $20c74b78b4de93fe$var$SvgEmailSent;



var $lf8OC = parcelRequire("lf8OC");

var $66ixW = parcelRequire("66ixW");

var $75SRw = parcelRequire("75SRw");

var $9Q3SI = parcelRequire("9Q3SI");
parcelRequire("fIF1D");
var $2LaLj = parcelRequire("2LaLj");


var $jheqv = parcelRequire("jheqv");
var $f3c492afc8e0d7e0$export$34e0f9847d4c02dd;
var $f3c492afc8e0d7e0$export$bfd64c937657f93a;
var $f3c492afc8e0d7e0$export$4a6dd88bada4e7d2;
$f3c492afc8e0d7e0$export$34e0f9847d4c02dd = `_84lriq_container`;
$f3c492afc8e0d7e0$export$bfd64c937657f93a = `_84lriq_rotating`;
$f3c492afc8e0d7e0$export$4a6dd88bada4e7d2 = `_84lriq_shimmer`;


function $1d420ca91dfedf93$var$EmailUsage({ usage: usage, isCompact: isCompact }) {
    const theme = (0, $jheqv.default)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $b595fc2f0eccd19a$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $f3c492afc8e0d7e0$export$34e0f9847d4c02dd,
        children: [
            theme === (0, $5HVJe.Theme).Light ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $20c74b78b4de93fe$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f566651bcfbb23d6$export$2e2bcd8739ae039), {}),
            isCompact ? usage : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                forKey: "connector_details.logto_email.total_email_sent",
                interpolation: {
                    value: usage
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2LaLj.default), {
                content: (closeTipHandler)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                        components: {
                            a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                                href: getDocumentationUrl("docs/recipes/configure-connectors/email-connector/configure-logto-email-service"),
                                targetBlank: "noopener",
                                onClick: closeTipHandler
                            })
                        },
                        children: t("connector_details.logto_email.total_email_sent_tip")
                    }),
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                    size: "small",
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $lf8OC.default), {})
                })
            })
        ]
    });
}
var $1d420ca91dfedf93$export$2e2bcd8739ae039 = $1d420ca91dfedf93$var$EmailUsage;


var $c7ce70b1c03f74a8$export$20b6fe5c276910c1;
var $c7ce70b1c03f74a8$export$bfd64c937657f93a;
var $c7ce70b1c03f74a8$export$4a6dd88bada4e7d2;
$c7ce70b1c03f74a8$export$20b6fe5c276910c1 = `ke03AG_readme`;
$c7ce70b1c03f74a8$export$bfd64c937657f93a = `ke03AG_rotating`;
$c7ce70b1c03f74a8$export$4a6dd88bada4e7d2 = `ke03AG_shimmer`;


// TODO: refactor path-related operation utils in both Connectors and ConnectorDetails page
const $7d1e296fdb980a58$var$getConnectorsPathname = (isSocial)=>`/connectors/${isSocial ? (0, $bt3dS.ConnectorsTabs).Social : (0, $bt3dS.ConnectorsTabs).Passwordless}`;
function $7d1e296fdb980a58$var$ConnectorDetails() {
    const { pathname: pathname } = (0, $2Phw0.useLocation)();
    const { connectorId: connectorId } = (0, $2Phw0.useParams)();
    const { createConnector: createConnector } = (0, $ef5cb09f22cdc7ad$export$2e2bcd8739ae039)();
    const { mutate: mutateGlobal } = (0, $hgWIN.useSWRConfig)();
    const [isDeleted, setIsDeleted] = (0, $jC8Vy.useState)(false);
    const [isReadMeOpen, setIsReadMeOpen] = (0, $jC8Vy.useState)(false);
    const [isSetupOpen, setIsSetupOpen] = (0, $jC8Vy.useState)(false);
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: data, error: error, mutate: mutate } = (0, $voszV.default)(connectorId && `api/connectors/${connectorId}`, {
        keepPreviousData: true
    });
    const { data: connectorFactory, error: fetchConnectorFactoryError, mutate: mutateConnectorFactory } = (0, $voszV.default)(data?.isStandard && `api/connector-factories/${data.connectorId}`);
    const requestError = error ?? fetchConnectorFactoryError;
    const { isConnectorInUse: isConnectorInUse } = (0, $ebd9bedb78e39567$export$2e2bcd8739ae039)();
    const inUse = isConnectorInUse(data);
    const isLoading = !data && !error || data?.isStandard && !connectorFactory && !fetchConnectorFactoryError;
    const api = (0, $7VnwS.default)();
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const isSocial = data?.type === (0, $kowfT.ConnectorType).Social;
    const [isDeleteAlertOpen, setIsDeleteAlertOpen] = (0, $jC8Vy.useState)(false);
    const [isDeleting, setIsDeleting] = (0, $jC8Vy.useState)(false);
    (0, $jC8Vy.useEffect)(()=>{
        setIsDeleteAlertOpen(false);
    }, [
        pathname
    ]);
    const handleDelete = async ()=>{
        if (!connectorId || isDeleting) return;
        setIsDeleting(true);
        try {
            await api.delete(`api/connectors/${connectorId}`).json();
            setIsDeleted(true);
            (0, $FuhPC.toast).success(t("connector_details.connector_deleted"));
            await mutateGlobal("api/connectors");
            navigate($7d1e296fdb980a58$var$getConnectorsPathname(isSocial), {
                replace: true
            });
        } finally{
            setIsDeleting(false);
        }
    };
    if (!connectorId) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aa35f43ec98b7478$export$2e2bcd8739ae039), {
        backLink: $7d1e296fdb980a58$var$getConnectorsPathname(isSocial),
        backLinkTitle: "connector_details.back_to_connectors",
        isLoading: isLoading,
        error: requestError,
        onRetry: ()=>{
            mutate();
            mutateConnectorFactory();
        },
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5TsIB.default), {
                titleKey: "connector_details.page_title"
            }),
            isSocial && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $23ea47e0ebe99977$export$2e2bcd8739ae039), {
                target: data.target,
                connectorId: data.id
            }),
            data && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $eefae5244405013e$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $34186e61374ae5f6$export$2e2bcd8739ae039), {
                            data: data,
                            size: "large"
                        }),
                        title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ee1df03577241ccd$export$2e2bcd8739ae039), {
                            resource: data.name
                        }),
                        primaryTag: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $94a5acb2a2382d2b$export$2e2bcd8739ae039), {
                            type: data.type
                        }),
                        statusTag: {
                            status: inUse ? "success" : "info",
                            text: inUse ? "connectors.connector_status_in_use" : "connectors.connector_status_not_in_use"
                        },
                        identifier: {
                            name: "ID",
                            value: data.id
                        },
                        additionalActionButton: (0, $7oDSS.conditional)(data.connectorId !== (0, $7YxsJ.ServiceConnector).Email && {
                            title: "connector_details.check_readme",
                            icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f71d98d4090dad5c$export$2e2bcd8739ae039), {}),
                            onClick: ()=>{
                                setIsReadMeOpen(true);
                            }
                        }),
                        additionalCustomElement: (0, $7oDSS.conditional)(data.type === (0, $kowfT.ConnectorType).Email && data.usage !== undefined && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1d420ca91dfedf93$export$2e2bcd8739ae039), {
                            usage: data.usage
                        })),
                        actionMenuItems: [
                            ...(0, $7oDSS.condArray)(!isSocial && [
                                {
                                    title: data.type === (0, $kowfT.ConnectorType).Sms ? "connector_details.options_change_sms" : "connector_details.options_change_email",
                                    icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $bf46177f0fb84c60$export$2e2bcd8739ae039), {}),
                                    onClick: ()=>{
                                        setIsSetupOpen(true);
                                    }
                                }
                            ]),
                            {
                                type: "danger",
                                title: "general.delete",
                                icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3aa588de5c8665f2$export$2e2bcd8739ae039), {}),
                                onClick: ()=>{
                                    setIsDeleteAlertOpen(true);
                                }
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $353ae25d75ceb68c$export$2e2bcd8739ae039), {
                        title: "connectors.title",
                        subtitle: "connectors.subtitle",
                        isOpen: isReadMeOpen,
                        onClose: ()=>{
                            setIsReadMeOpen(false);
                        },
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $061baaa56e1104e9$export$2e2bcd8739ae039), {
                            className: $c7ce70b1c03f74a8$export$20b6fe5c276910c1,
                            children: data.readme
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $80bae7df489c133c$export$2e2bcd8739ae039), {
                        isOpen: isSetupOpen,
                        type: data.type,
                        onClose: async (connectorId)=>{
                            setIsSetupOpen(false);
                            if (connectorId) {
                                /**
                 * Note:
                 * The "Email Service Connector" is a built-in connector that can be directly created without the need for setup in the guide.
                 */ if (connectorId === (0, $7YxsJ.ServiceConnector).Email) {
                                    const created = await createConnector({
                                        connectorId: connectorId
                                    });
                                    navigate(`/connectors/${(0, $bt3dS.ConnectorsTabs).Passwordless}/${created.id}`, {
                                        replace: true
                                    });
                                    return;
                                }
                                navigate(`${$7d1e296fdb980a58$var$getConnectorsPathname(isSocial)}/guide/${connectorId}`);
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $26090e0c44b20d28$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                            href: `${$7d1e296fdb980a58$var$getConnectorsPathname(isSocial)}/${connectorId}`,
                            children: t("general.settings_nav")
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $98cb9dc7c74fa8db$export$2e2bcd8739ae039), {
                        isDeleted: isDeleted,
                        connectorData: data,
                        onConnectorUpdated: (connector)=>{
                            mutate(connector);
                        }
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1473e789d55b40f6$export$2e2bcd8739ae039), {
                        data: data,
                        isInUse: inUse,
                        isOpen: isDeleteAlertOpen,
                        isLoading: isDeleting,
                        onCancel: ()=>{
                            setIsDeleteAlertOpen(false);
                        },
                        onConfirm: handleDelete
                    })
                ]
            })
        ]
    });
}
var $7d1e296fdb980a58$export$2e2bcd8739ae039 = $7d1e296fdb980a58$var$ConnectorDetails;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("oK7kD");
var $7YxsJ = parcelRequire("7YxsJ");
parcelRequire("cuPVN");
var $kowfT = parcelRequire("kowfT");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $2Phw0 = parcelRequire("2Phw0");

var $voszV = parcelRequire("voszV");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $d564cfd7e053f4f6$var$SvgSocialConnectorEmptyDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M103.585 156H69.048c-19.844 0-36.687 14.548-39.575 34.18L24.5 224H234l-.31-1.013A24 24 0 0 0 210.738 206h-29.086a16.002 16.002 0 0 1-14.154-8.537l-1.662-3.153a29.628 29.628 0 0 0-26.209-15.81h-1.42a12.628 12.628 0 0 1-11.54-7.5 25.258 25.258 0 0 0-23.082-15Z",
                fill: "#41425F"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M61 75H30a4 4 0 0 0 0 8h31",
                stroke: "#6669A8",
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m26.5 69.5 37-23M114.5 71.5l-40-25M164.5 71.5l-90-25",
                stroke: "#A39BD8",
                strokeWidth: 2,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M87 72h82.597a3 3 0 0 1 1.874.657l10 8c2.214 1.772.962 5.343-1.874 5.343H87a3 3 0 0 1-3-3v-8a3 3 0 0 1 3-3Z",
                stroke: "#6669A8",
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M45.818 101.813A6 6 0 0 1 51.815 96h36.37a6 6 0 0 1 5.997 5.813l3.625 116A6 6 0 0 1 91.81 224H48.19a6 6 0 0 1-5.997-6.187l3.625-116Z",
                fill: "#7B7EBB"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "mask0_503_14464",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 42,
                y: 96,
                width: 56,
                height: 128,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    d: "M45.818 101.813A6 6 0 0 1 51.815 96h36.37a6 6 0 0 1 5.997 5.813l3.625 116A6 6 0 0 1 91.81 224H48.19a6 6 0 0 1-5.997-6.187l3.625-116Z",
                    fill: "#3F375A"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                mask: "url(#mask0_503_14464)",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        fill: "#6669A8",
                        d: "m39.822 130.268 62.354-36 1 1.732-62.354 36zM34 133h72v2H34zM34 172.732h72v2H34z"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        fill: "#6669A8",
                        d: "m39.822 170.268 62.354-36 1 1.732-62.354 36zM39.822 210.268l62.354-36 1 1.732-62.354 36zM39.822 97.732l62.354 36 1-1.732-62.354-36z"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        fill: "#6669A8",
                        d: "m39.822 137.732 62.354 36 1-1.732-62.354-36zM39.822 177.732l62.354 36 1-1.732-62.354-36z"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M47.5 93.5h21l-1 130.5H-1L47.5 93.5Z",
                        fill: "url(#paint0_linear_503_14464)",
                        style: {
                            mixBlendMode: "multiply"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M62.694 46.668A4 4 0 0 1 66.68 43h4.64a4 4 0 0 1 3.986 3.668l3.333 40A4 4 0 0 1 74.653 91H63.347a4 4 0 0 1-3.986-4.332l3.333-40Z",
                fill: "#7B7EBB"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 70,
                y: 67,
                width: 24,
                height: 24,
                rx: 6,
                fill: "url(#paint1_linear_503_14464)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 18,
                y: 67,
                width: 16,
                height: 24,
                rx: 4,
                fill: "#5F5D67"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M170 200.667a3.333 3.333 0 1 1 0 6.666h-43.333v-6.666H170Z",
                fill: "#746A9A"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M184 197.333a6 6 0 0 1 6 6v1.334a6 6 0 0 1-6 6h-14.667a6 6 0 0 1-6-6v-1.334a6 6 0 0 1 6-6H184Z",
                fill: "#B780FE"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M113.333 184c9.205 0 16.667 7.462 16.667 16.667v6.666c0 9.205-7.462 16.667-16.667 16.667H66.667C57.462 224 50 216.538 50 207.333v-6.666C50 191.462 57.462 184 66.667 184h46.666Z",
                fill: "url(#paint2_linear_503_14464)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 116.666,
                y: 195,
                width: 4,
                height: 53.333,
                rx: 2,
                transform: "rotate(90 116.666 195)",
                fill: "#DA9FFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 116.666,
                y: 207.333,
                width: 4,
                height: 53.333,
                rx: 2,
                transform: "rotate(90 116.666 207.333)",
                fill: "#DA9FFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 214,
                cy: 56,
                r: 20,
                fill: "#696B97"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m208 46 16 10-16 10",
                stroke: "#40456D",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 224,
                cy: 56,
                r: 4,
                fill: "#B19EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 208,
                cy: 66,
                r: 4,
                fill: "#B19EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 208,
                cy: 46,
                r: 4,
                fill: "#B19EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 154,
                cy: 124,
                r: 20,
                fill: "#696B97"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M154 110.996a13.33 13.33 0 0 0-13.161 11.198 13.332 13.332 0 0 0 8.944 14.785c.667.117.917-.283.917-.633 0-.317-.017-1.367-.017-2.484-3.35.617-4.216-.816-4.483-1.566a4.848 4.848 0 0 0-1.367-1.884c-.466-.25-1.133-.866-.016-.883a2.672 2.672 0 0 1 2.05 1.367 2.84 2.84 0 0 0 1.713 1.355 2.832 2.832 0 0 0 2.17-.255 2.81 2.81 0 0 1 .85-1.784c-2.967-.333-6.067-1.483-6.067-6.583a5.185 5.185 0 0 1 1.367-3.583 4.793 4.793 0 0 1 .133-3.534s1.117-.35 3.667 1.367c2.182-.6 4.485-.6 6.667 0 2.55-1.733 3.666-1.367 3.666-1.367a4.793 4.793 0 0 1 .134 3.534 5.156 5.156 0 0 1 1.366 3.583c0 5.117-3.116 6.25-6.083 6.583a3.158 3.158 0 0 1 .9 2.467c0 1.783-.017 3.217-.017 3.667 0 .35.25.766.917.633a13.336 13.336 0 0 0 8.908-14.796A13.336 13.336 0 0 0 154 110.996Z",
                fill: "#BFBEF0"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 126,
                cy: 24,
                r: 16,
                fill: "#615984"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M136.666 24c0-5.892-4.775-10.667-10.667-10.667-5.891 0-10.666 4.775-10.666 10.667 0 5.325 3.9 9.737 9 10.538v-7.455h-2.709V24h2.709v-2.35c0-2.673 1.591-4.15 4.029-4.15 1.166 0 2.387.208 2.387.208v2.625h-1.346c-1.325 0-1.737.823-1.737 1.667v2h2.958l-.473 3.083h-2.485v7.455c5.1-.8 9-5.213 9-10.538Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m130.151 27.083.473-3.083h-2.958v-2c0-.844.412-1.667 1.737-1.667h1.346v-2.625s-1.221-.208-2.387-.208c-2.438 0-4.03 1.477-4.03 4.15V24h-2.708v3.083h2.708v7.455a10.736 10.736 0 0 0 3.334 0v-7.455h2.485Z",
                fill: "#F0EDFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M246 172c0-5.072-1.888-9.703-5-13.229a20.065 20.065 0 0 0-7-5.107M212.771 157a20.079 20.079 0 0 0-4.095 5A19.87 19.87 0 0 0 206 172a19.89 19.89 0 0 0 2.676 10 20.088 20.088 0 0 0 7.634 7.5A19.909 19.909 0 0 0 226 192c3.516 0 6.819-.907 9.69-2.5a20.098 20.098 0 0 0 6.675-6M219 153.259c-.863.323-1.698.703-2.5 1.137",
                stroke: "#AF9EFF",
                strokeWidth: 2,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M237.52 172.273c0-.851-.076-1.669-.218-2.455H226v4.642h6.458a5.52 5.52 0 0 1-2.394 3.622v3.011h3.878c2.269-2.089 3.578-5.166 3.578-8.82Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M226 184c3.24 0 5.956-1.075 7.941-2.907l-3.878-3.011c-1.074.72-2.449 1.145-4.063 1.145-3.126 0-5.771-2.111-6.715-4.947h-4.009v3.109A11.995 11.995 0 0 0 226 184Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M219.285 174.28a7.213 7.213 0 0 1-.376-2.28c0-.791.136-1.56.376-2.28v-3.109h-4.009A12.005 12.005 0 0 0 214 172c0 1.936.464 3.769 1.276 5.389l4.009-3.109Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M226 164.773c1.761 0 3.343.605 4.587 1.794l3.442-3.442C231.95 161.189 229.234 160 226 160c-4.691 0-8.75 2.689-10.724 6.611l4.009 3.109c.944-2.836 3.589-4.947 6.715-4.947Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 153,
                cy: 180,
                r: 8,
                fill: "#E5E1EC",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 34,
                cy: 34,
                r: 7,
                stroke: "#E0E3E3",
                strokeWidth: 2,
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 238,
                cy: 104,
                r: 4,
                fill: "#9FE79F",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#C093C0",
                d: "m198.311 125 7.283 3.311-3.312 7.283-7.282-3.311z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#79709C",
                d: "M168 46.212 174.07 41l5.211 6.07-6.07 5.212z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m15.629 125 1.011 2.641a2.828 2.828 0 0 0 3.653 1.63v0a2.829 2.829 0 0 1 3.653 1.63v0a2.828 2.828 0 0 0 3.653 1.63v0a2.828 2.828 0 0 1 3.653 1.63l1.011 2.641",
                stroke: "#9F96CD",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_503_14464",
                        x1: 37.5,
                        y1: 224,
                        x2: 69,
                        y2: 91.5,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#ADAAB4"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ADAAB4",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_503_14464",
                        x1: 67.5,
                        y1: 82.5,
                        x2: 90.125,
                        y2: 68.123,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#DA8CFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint2_linear_503_14464",
                        x1: 24,
                        y1: 214.5,
                        x2: 132.815,
                        y2: 216.789,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#D376FF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $d564cfd7e053f4f6$export$2e2bcd8739ae039 = $d564cfd7e053f4f6$var$SvgSocialConnectorEmptyDark;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $a2d27914efa8292d$var$SvgSocialConnectorEmpty = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M103.585 156H69.048c-19.844 0-36.687 14.548-39.575 34.18L24.5 224H234l-.31-1.013A24 24 0 0 0 210.738 206h-29.086a16.002 16.002 0 0 1-14.154-8.537l-1.662-3.153a29.628 29.628 0 0 0-26.209-15.81h-1.42a12.628 12.628 0 0 1-11.54-7.5 25.258 25.258 0 0 0-23.082-15Z",
                fill: "#5D34F2",
                fillOpacity: 0.12
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m26.5 69.5 37-23M114.5 71.5l-40-25",
                stroke: "#E5E1EC",
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M61 75H30a4 4 0 0 0 0 8h31",
                stroke: "#C9C5D0",
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m164.5 71.5-90-25",
                stroke: "#E5E1EC",
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M84 75a3 3 0 0 1 3-3h82.597a3 3 0 0 1 1.874.657l10 8c2.214 1.772.962 5.343-1.874 5.343H87a3 3 0 0 1-3-3v-8Z",
                stroke: "#C9C5D0",
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M45.818 101.813A6 6 0 0 1 51.815 96h36.37a6 6 0 0 1 5.997 5.813l3.625 116A6 6 0 0 1 91.81 224H48.19a6 6 0 0 1-5.997-6.187l3.625-116Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "mask0_8614_113852",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 42,
                y: 96,
                width: 56,
                height: 128,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    d: "M45.818 101.813A6 6 0 0 1 51.815 96h36.37a6 6 0 0 1 5.997 5.813l3.625 116A6 6 0 0 1 91.81 224H48.19a6 6 0 0 1-5.997-6.187l3.625-116Z",
                    fill: "#3F375A"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                mask: "url(#mask0_8614_113852)",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        fill: "#AF9EFF",
                        d: "m39.822 130.268 62.354-36 1 1.732-62.354 36zM34 133h72v2H34zM34 172.732h72v2H34z"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        fill: "#AF9EFF",
                        d: "m39.822 170.268 62.354-36 1 1.732-62.354 36zM39.822 210.268l62.354-36 1 1.732-62.354 36zM39.822 97.732l62.354 36 1-1.732-62.354-36z"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        fill: "#AF9EFF",
                        d: "m39.822 137.732 62.354 36 1-1.732-62.354-36zM39.822 177.732l62.354 36 1-1.732-62.354-36z"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M47.5 93.5h21l-1 130.5H-1L47.5 93.5Z",
                        fill: "#E6DEFF",
                        style: {
                            mixBlendMode: "multiply"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M62.694 46.668A4 4 0 0 1 66.68 43h4.64a4 4 0 0 1 3.986 3.668l3.333 40A4 4 0 0 1 74.653 91H63.347a4 4 0 0 1-3.986-4.332l3.333-40Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 70,
                y: 67,
                width: 24,
                height: 24,
                rx: 6,
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 18,
                y: 67,
                width: 16,
                height: 24,
                rx: 4,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M170.001 200.667a3.333 3.333 0 1 1 0 6.667h-43.334v-6.667h43.334Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M184 197.333a6 6 0 0 1 6 6v1.333a6 6 0 0 1-6 6h-14.667a6 6 0 0 1-6-6v-1.333a6 6 0 0 1 6-6H184Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M114 224c8.837 0 16-7.163 16-16v-8c0-8.837-7.163-16-16-16H66c-8.837 0-16 7.163-16 16v8c0 8.837 7.163 16 16 16h48Z",
                fill: "url(#paint0_linear_8614_113852)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 116.666,
                y: 195,
                width: 4,
                height: 53.333,
                rx: 2,
                transform: "rotate(90 116.666 195)",
                fill: "#DFAEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 116.666,
                y: 207.333,
                width: 4,
                height: 53.333,
                rx: 2,
                transform: "rotate(90 116.666 207.333)",
                fill: "#DFAEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 214,
                cy: 56,
                r: 20,
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m208 46 16 10-16 10",
                stroke: "#947DFF",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 224,
                cy: 56,
                r: 4,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 208,
                cy: 66,
                r: 4,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 208,
                cy: 46,
                r: 4,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 154,
                cy: 124,
                r: 20,
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M154 110.996a13.331 13.331 0 0 0-13.161 11.198 13.335 13.335 0 0 0 8.944 14.785c.667.117.917-.283.917-.633 0-.317-.017-1.367-.017-2.483-3.35.616-4.216-.817-4.483-1.567a4.845 4.845 0 0 0-1.367-1.883c-.466-.25-1.133-.867-.016-.884a2.678 2.678 0 0 1 2.05 1.367 2.843 2.843 0 0 0 2.823 1.444 2.855 2.855 0 0 0 1.06-.344c.058-.678.36-1.312.85-1.783-2.967-.334-6.067-1.484-6.067-6.584a5.185 5.185 0 0 1 1.367-3.583 4.79 4.79 0 0 1 .133-3.533s1.117-.35 3.667 1.366c2.182-.6 4.485-.6 6.667 0 2.55-1.733 3.666-1.366 3.666-1.366a4.79 4.79 0 0 1 .134 3.533 5.16 5.16 0 0 1 1.366 3.583c0 5.117-3.116 6.25-6.083 6.584a3.154 3.154 0 0 1 .9 2.466c0 1.784-.017 3.217-.017 3.667 0 .35.25.767.917.633a13.337 13.337 0 0 0 8.908-14.796A13.337 13.337 0 0 0 154 110.996Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 126,
                cy: 24,
                r: 16,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M136.666 24c0-5.891-4.775-10.666-10.666-10.666-5.892 0-10.667 4.775-10.667 10.667 0 5.325 3.9 9.737 9 10.537v-7.454h-2.708v-3.083h2.708v-2.35c0-2.673 1.592-4.15 4.029-4.15 1.167 0 2.388.208 2.388.208v2.625h-1.346c-1.325 0-1.738.823-1.738 1.667v2h2.959l-.473 3.083h-2.486v7.454c5.1-.8 9-5.212 9-10.537Z",
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m130.152 27.084.473-3.083h-2.959v-2c0-.844.413-1.667 1.738-1.667h1.346V17.71s-1.221-.208-2.388-.208c-2.437 0-4.029 1.477-4.029 4.15v2.35h-2.708v3.083h2.708v7.454a10.736 10.736 0 0 0 3.333 0v-7.454h2.486Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M246 172c0-5.073-1.888-9.704-5-13.23a20.05 20.05 0 0 0-7-5.106M212.771 157a20.06 20.06 0 0 0-4.095 5 19.855 19.855 0 0 0-2.046 5 20.048 20.048 0 0 0-.63 5c0 2.275.38 4.462 1.08 6.5a19.957 19.957 0 0 0 1.596 3.5 20.095 20.095 0 0 0 7.634 7.5A19.92 19.92 0 0 0 226 192a19.92 19.92 0 0 0 9.69-2.5 20.108 20.108 0 0 0 6.675-6M219 153.259c-.863.322-1.698.703-2.5 1.136",
                stroke: "#E5E1EC",
                strokeWidth: 2,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M237.52 172.273c0-.851-.076-1.669-.218-2.455H226v4.642h6.458a5.52 5.52 0 0 1-2.394 3.622v3.011h3.878c2.269-2.089 3.578-5.166 3.578-8.82Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M226 184c3.24 0 5.956-1.074 7.941-2.907l-3.878-3.011c-1.074.72-2.449 1.146-4.063 1.146-3.126 0-5.771-2.111-6.715-4.948h-4.009v3.109A11.995 11.995 0 0 0 226 184Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M219.285 174.279a7.213 7.213 0 0 1-.376-2.28c0-.79.136-1.56.376-2.28v-3.109h-4.009a12.005 12.005 0 0 0-1.276 5.389c0 1.937.464 3.77 1.276 5.39l4.009-3.11Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M226 164.773c1.761 0 3.343.605 4.587 1.794l3.442-3.442C231.95 161.189 229.234 160 226 160c-4.691 0-8.75 2.689-10.724 6.611l4.009 3.109c.944-2.836 3.589-4.947 6.715-4.947Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 153,
                cy: 180,
                r: 8,
                fill: "#E5E1EC",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m15.629 125 1.011 2.641a2.828 2.828 0 0 0 3.653 1.63v0a2.829 2.829 0 0 1 3.653 1.63v0a2.828 2.828 0 0 0 3.653 1.63v0a2.828 2.828 0 0 1 3.653 1.63l1.011 2.641",
                stroke: "#AF9EFF",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("defs", {
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                    id: "paint0_linear_8614_113852",
                    x1: 60.833,
                    y1: 217.125,
                    x2: 84.802,
                    y2: 172.314,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            stopColor: "#5D34F2"
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            offset: 1,
                            stopColor: "#FAABFF"
                        })
                    ]
                })
            })
        ]
    });
var $a2d27914efa8292d$export$2e2bcd8739ae039 = $a2d27914efa8292d$var$SvgSocialConnectorEmpty;




parcelRequire("8Mb3E");
var $lmQmj = parcelRequire("lmQmj");

var $bt3dS = parcelRequire("bt3dS");

var $jGWQ4 = parcelRequire("jGWQ4");






var $4ZcUR = parcelRequire("4ZcUR");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $1QOtg = parcelRequire("1QOtg");
var $cab9adfc3ad05cc2$export$b31f6ae88848cf15;
var $cab9adfc3ad05cc2$export$bfd64c937657f93a;
var $cab9adfc3ad05cc2$export$4a6dd88bada4e7d2;
$cab9adfc3ad05cc2$export$b31f6ae88848cf15 = `LfdwjW_notice`;
$cab9adfc3ad05cc2$export$bfd64c937657f93a = `LfdwjW_rotating`;
$cab9adfc3ad05cc2$export$4a6dd88bada4e7d2 = `LfdwjW_shimmer`;


function $66994a2f46f4858a$var$DemoConnectorNotice() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1QOtg.default), {
        className: $cab9adfc3ad05cc2$export$b31f6ae88848cf15,
        children: t("cloud.sie.connectors.notice")
    });
}
var $66994a2f46f4858a$export$2e2bcd8739ae039 = $66994a2f46f4858a$var$DemoConnectorNotice;



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
parcelRequire("voszV");
var $hgWIN = parcelRequire("hgWIN");



var $75SRw = parcelRequire("75SRw");
parcelRequire("fIF1D");
var $16GE9 = parcelRequire("16GE9");

var $7VnwS = parcelRequire("7VnwS");

function $e95793fba5558ff3$var$ConnectorDeleteButton({ connectorGroup: connectorGroup }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { mutate: mutateGlobal } = (0, $hgWIN.useSWRConfig)();
    const { connectors: connectors } = connectorGroup;
    const { isConnectorInUse: isConnectorInUse } = (0, $ebd9bedb78e39567$export$2e2bcd8739ae039)();
    const firstConnector = connectors[0];
    const inUse = isConnectorInUse(firstConnector);
    const [isDeleteAlertOpen, setIsDeleteAlertOpen] = (0, $jC8Vy.useState)(false);
    const [isDeleting, setIsDeleting] = (0, $jC8Vy.useState)(false);
    const api = (0, $7VnwS.default)();
    const handleDelete = async ()=>{
        if (!firstConnector || isDeleting) return;
        setIsDeleting(true);
        const { connectors: connectors } = connectorGroup;
        try {
            await Promise.all(connectors.map(async (connector)=>{
                await api.delete(`api/connectors/${connector.id}`);
            }));
            (0, $FuhPC.toast).success(t("connector_details.connector_deleted"));
            await mutateGlobal("api/connectors");
        } finally{
            setIsDeleting(false);
        }
    };
    if (!firstConnector) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $16GE9.default), {
                content: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    children: t("general.delete")
                }),
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                    onClick: ()=>{
                        setIsDeleteAlertOpen(true);
                    },
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3aa588de5c8665f2$export$2e2bcd8739ae039), {})
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1473e789d55b40f6$export$2e2bcd8739ae039), {
                data: firstConnector,
                isInUse: inUse,
                isOpen: isDeleteAlertOpen,
                isLoading: isDeleting,
                onCancel: ()=>{
                    setIsDeleteAlertOpen(false);
                },
                onConfirm: handleDelete
            })
        ]
    });
}
var $e95793fba5558ff3$export$2e2bcd8739ae039 = $e95793fba5558ff3$var$ConnectorDeleteButton;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $cIy8v = parcelRequire("cIy8v");
var $kowfT = parcelRequire("kowfT");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");




var $lmQmj = parcelRequire("lmQmj");

var $bt3dS = parcelRequire("bt3dS");

var $jGWQ4 = parcelRequire("jGWQ4");

var $4ZcUR = parcelRequire("4ZcUR");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("oK7kD");
var $kowfT = parcelRequire("kowfT");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

parcelRequire("fIF1D");
var $16GE9 = parcelRequire("16GE9");
function $3fdcd3c1ab218cca$var$DemoTag({ connectorType: connectorType }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const isSocial = connectorType === (0, $kowfT.ConnectorType).Social;
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $16GE9.default), {
        content: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
            children: t(isSocial ? "connectors.social_demo_tip" : "connectors.demo_tip")
        }),
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
            status: "alert",
            children: t("general.demo")
        })
    });
}
var $3fdcd3c1ab218cca$export$2e2bcd8739ae039 = $3fdcd3c1ab218cca$var$DemoTag;


var $5ead1067eb1677d1$export$34e0f9847d4c02dd;
var $5ead1067eb1677d1$export$db3c28d99448dcff;
var $5ead1067eb1677d1$export$a1fe6a2d7788354f;
var $5ead1067eb1677d1$export$722a64dea1b767dc;
var $5ead1067eb1677d1$export$caa92bdde36f2a2d;
var $5ead1067eb1677d1$export$435aa072d3c70d67;
var $5ead1067eb1677d1$export$bfd64c937657f93a;
var $5ead1067eb1677d1$export$4a6dd88bada4e7d2;
$5ead1067eb1677d1$export$34e0f9847d4c02dd = `_3V_yJa_container`;
$5ead1067eb1677d1$export$db3c28d99448dcff = `_3V_yJa_logo`;
$5ead1067eb1677d1$export$a1fe6a2d7788354f = `_3V_yJa_logoContainer`;
$5ead1067eb1677d1$export$722a64dea1b767dc = `_3V_yJa_platform`;
$5ead1067eb1677d1$export$caa92bdde36f2a2d = `_3V_yJa_platforms`;
$5ead1067eb1677d1$export$435aa072d3c70d67 = `_3V_yJa_previewTitle`;
$5ead1067eb1677d1$export$bfd64c937657f93a = `_3V_yJa_rotating`;
$5ead1067eb1677d1$export$4a6dd88bada4e7d2 = `_3V_yJa_shimmer`;


function $cec9b740cd481a2c$var$ConnectorName({ connectorGroup: connectorGroup, isDemo: isDemo = false }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { type: type, connectors: connectors } = connectorGroup;
    const connector = connectors[0];
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const hasNonUniversalConnector = connectors.some(({ platform: platform })=>platform !== (0, $cIy8v.ConnectorPlatform).Universal);
    if (!connector) {
        const PlaceholderIcon = (0, $lmQmj.connectorPlaceholderIcon)[type];
        return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4d952cae22cb03fc$export$2e2bcd8739ae039), {
            title: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $5ead1067eb1677d1$export$435aa072d3c70d67,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        children: t((0, $lmQmj.connectorTitlePlaceHolder)[type])
                    }),
                    type !== (0, $kowfT.ConnectorType).Social && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        title: "general.set_up",
                        onClick: ()=>{
                            navigate(`/connectors/${(0, $bt3dS.ConnectorsTabs).Passwordless}/create/${type}`);
                        }
                    })
                ]
            }),
            icon: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $5ead1067eb1677d1$export$a1fe6a2d7788354f,
                children: PlaceholderIcon && /*#__PURE__*/ (0, $C7mD2.jsx)(PlaceholderIcon, {
                    className: $5ead1067eb1677d1$export$db3c28d99448dcff
                })
            })
        });
    }
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $5ead1067eb1677d1$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4d952cae22cb03fc$export$2e2bcd8739ae039), {
                title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ee1df03577241ccd$export$2e2bcd8739ae039), {
                    resource: connector.name
                }),
                subtitle: type === (0, $kowfT.ConnectorType).Social && hasNonUniversalConnector && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $5ead1067eb1677d1$export$caa92bdde36f2a2d,
                    children: connectors.map(({ id: id, platform: platform })=>platform && /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                            className: $5ead1067eb1677d1$export$722a64dea1b767dc,
                            children: [
                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f79fa5ee09aaae72$export$2e2bcd8739ae039), {
                                    platform: platform
                                }),
                                t((0, $lmQmj.connectorPlatformLabel)[platform])
                            ]
                        }, id))
                }),
                icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $34186e61374ae5f6$export$2e2bcd8739ae039), {
                    data: connector
                }),
                to: (0, $7oDSS.conditional)(!isDemo && `/connectors/${connector.type === (0, $kowfT.ConnectorType).Social ? (0, $bt3dS.ConnectorsTabs).Social : (0, $bt3dS.ConnectorsTabs).Passwordless}/${connector.id}`)
            }),
            isDemo && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3fdcd3c1ab218cca$export$2e2bcd8739ae039), {
                connectorType: connector.type
            })
        ]
    });
}
var $cec9b740cd481a2c$export$2e2bcd8739ae039 = $cec9b740cd481a2c$var$ConnectorName;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");


function $88ce4af6518b830d$var$ConnectorStatus({ connectorGroup: connectorGroup }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { connectors: connectors } = connectorGroup;
    const { isConnectorInUse: isConnectorInUse } = (0, $ebd9bedb78e39567$export$2e2bcd8739ae039)();
    const firstConnector = connectors[0];
    const inUse = isConnectorInUse(firstConnector);
    return firstConnector ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
        type: "state",
        status: inUse ? "success" : "info",
        variant: "plain",
        children: t(inUse ? "connectors.connector_status_in_use" : "connectors.connector_status_not_in_use")
    }) : /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
        children: "-"
    });
}
var $88ce4af6518b830d$export$2e2bcd8739ae039 = $88ce4af6518b830d$var$ConnectorStatus;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $lf8OC = parcelRequire("lf8OC");

var $75SRw = parcelRequire("75SRw");

var $9Q3SI = parcelRequire("9Q3SI");
parcelRequire("fIF1D");
var $2LaLj = parcelRequire("2LaLj");
var $a9a24dabad22fd14$export$a7db06668cad9adb;
var $a9a24dabad22fd14$export$e0f35d825088c098;
var $a9a24dabad22fd14$export$bfd64c937657f93a;
var $a9a24dabad22fd14$export$4a6dd88bada4e7d2;
var $a9a24dabad22fd14$export$ce3e55343e166f1c;
var $a9a24dabad22fd14$export$fb184b623420d9be;
$a9a24dabad22fd14$export$a7db06668cad9adb = `_6N10NW_content`;
$a9a24dabad22fd14$export$e0f35d825088c098 = `_6N10NW_field`;
$a9a24dabad22fd14$export$bfd64c937657f93a = `_6N10NW_rotating`;
$a9a24dabad22fd14$export$4a6dd88bada4e7d2 = `_6N10NW_shimmer`;
$a9a24dabad22fd14$export$ce3e55343e166f1c = `_6N10NW_tipButton`;
$a9a24dabad22fd14$export$fb184b623420d9be = `_6N10NW_title`;


function $fc11849530e00506$var$ConnectorStatusField() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $a9a24dabad22fd14$export$e0f35d825088c098,
        children: [
            t("connectors.connector_status"),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2LaLj.default), {
                anchorClassName: $a9a24dabad22fd14$export$ce3e55343e166f1c,
                content: (closeTipHandler)=>/*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $a9a24dabad22fd14$export$fb184b623420d9be,
                                children: t("connectors.connector_status")
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $a9a24dabad22fd14$export$a7db06668cad9adb,
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                                    components: {
                                        a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                                            to: "/sign-in-experience/sign-up-and-sign-in",
                                            onClick: closeTipHandler
                                        })
                                    },
                                    children: t("connectors.not_in_use_tip.content", {
                                        link: t("connectors.not_in_use_tip.go_to_sie")
                                    })
                                })
                            })
                        ]
                    }),
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                    size: "small",
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $lf8OC.default), {})
                })
            })
        ]
    });
}
var $fc11849530e00506$export$2e2bcd8739ae039 = $fc11849530e00506$var$ConnectorStatusField;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $voszV = parcelRequire("voszV");


var $lmQmj = parcelRequire("lmQmj");
function $7dac66eecf504254$var$ConnectorTypeColumn({ connectorGroup: { type: type, connectors: connectors } }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const standardConnectors = connectors.filter(({ isStandard: isStandard })=>isStandard);
    if (standardConnectors.length > 1) throw new Error("More than one standard connectors with the same target is not supported.");
    const firstStandardConnector = standardConnectors[0];
    const { data: connectorFactory } = (0, $voszV.default)(firstStandardConnector && `api/connector-factories/${firstStandardConnector.connectorId}`);
    if (!firstStandardConnector) return /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
        children: t((0, $lmQmj.connectorTitlePlaceHolder)[type])
    });
    if (!connectorFactory) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ee1df03577241ccd$export$2e2bcd8739ae039), {
        resource: connectorFactory.name
    });
}
var $7dac66eecf504254$export$2e2bcd8739ae039 = $7dac66eecf504254$var$ConnectorTypeColumn;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("hNGhh");
var $eRB1v = parcelRequire("eRB1v");
parcelRequire("cuPVN");
var $kowfT = parcelRequire("kowfT");
parcelRequire("ajkVG");
var $7WNrO = parcelRequire("7WNrO");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $4TsiV = parcelRequire("4TsiV");

var $5cXXM = parcelRequire("5cXXM");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $kUZ14 = parcelRequire("kUZ14");

var $HHYyb = parcelRequire("HHYyb");





var $bt3dS = parcelRequire("bt3dS");

var $jGWQ4 = parcelRequire("jGWQ4");

var $18SWy = parcelRequire("18SWy");

var $8R7rc = parcelRequire("8R7rc");

var $75SRw = parcelRequire("75SRw");

var $aTllQ = parcelRequire("aTllQ");



var $4ZcUR = parcelRequire("4ZcUR");

var $dW2kG = parcelRequire("dW2kG");



var $5OcFi = parcelRequire("5OcFi");

var $d774c88e7577c1e5$export$837bd02682cd3db9;
var $d774c88e7577c1e5$export$2f3470a7f0d1a379;
var $d774c88e7577c1e5$export$64a53ecd158b85c4;
var $d774c88e7577c1e5$export$34e0f9847d4c02dd;
var $d774c88e7577c1e5$export$a7db06668cad9adb;
var $d774c88e7577c1e5$export$adb608be33961c98;
var $d774c88e7577c1e5$export$38e42c68cf43b5d4;
var $d774c88e7577c1e5$export$98e628dec113755e;
var $d774c88e7577c1e5$export$20b6fe5c276910c1;
var $d774c88e7577c1e5$export$ca1a0b14edb13127;
var $d774c88e7577c1e5$export$62b98b62cb75971a;
var $d774c88e7577c1e5$export$bfd64c937657f93a;
var $d774c88e7577c1e5$export$3e523c77c1f23f8c;
var $d774c88e7577c1e5$export$de27182ff8187d6c;
var $d774c88e7577c1e5$export$4a6dd88bada4e7d2;
$d774c88e7577c1e5$export$837bd02682cd3db9 = `_2-O1KW_block`;
$d774c88e7577c1e5$export$2f3470a7f0d1a379 = `_2-O1KW_blockTitle`;
$d774c88e7577c1e5$export$64a53ecd158b85c4 = `_2-O1KW_closeIcon`;
$d774c88e7577c1e5$export$34e0f9847d4c02dd = `_2-O1KW_container`;
$d774c88e7577c1e5$export$a7db06668cad9adb = `_2-O1KW_content`;
$d774c88e7577c1e5$export$adb608be33961c98 = `_2-O1KW_footer`;
$d774c88e7577c1e5$export$38e42c68cf43b5d4 = `_2-O1KW_header`;
$d774c88e7577c1e5$export$98e628dec113755e = `_2-O1KW_number`;
$d774c88e7577c1e5$export$20b6fe5c276910c1 = `_2-O1KW_readme`;
$d774c88e7577c1e5$export$ca1a0b14edb13127 = `_2-O1KW_readmeContent`;
$d774c88e7577c1e5$export$62b98b62cb75971a = `_2-O1KW_readmeTitle`;
$d774c88e7577c1e5$export$bfd64c937657f93a = `_2-O1KW_rotating`;
$d774c88e7577c1e5$export$3e523c77c1f23f8c = `_2-O1KW_separator`;
$d774c88e7577c1e5$export$de27182ff8187d6c = `_2-O1KW_setup`;
$d774c88e7577c1e5$export$4a6dd88bada4e7d2 = `_2-O1KW_shimmer`;


const $8f1b807d77061756$var$targetErrorCode = "connector.multiple_target_with_same_platform";
function $8f1b807d77061756$var$Guide({ connector: connector, onClose: onClose }) {
    const { createConnector: createConnector } = (0, $ef5cb09f22cdc7ad$export$2e2bcd8739ae039)();
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const callbackConnectorId = (0, $jC8Vy.useRef)((0, $7WNrO.generateStandardId)());
    const [conflictConnectorName, setConflictConnectorName] = (0, $jC8Vy.useState)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { type: connectorType, formItems: formItems, isStandard: isStandard, id: connectorFactoryId } = connector ?? {};
    const { language: language } = (0, $4TsiV.default);
    const isSocialConnector = connectorType !== (0, $kowfT.ConnectorType).Sms && connectorType !== (0, $kowfT.ConnectorType).Email;
    const methods = (0, $codQP.useForm)({
        reValidateMode: "onBlur",
        defaultValues: {
            jsonConfig: "{}",
            formConfig: {},
            syncProfile: (0, $6c796a80483fa826$export$ed9ee40b3ba009ed).OnlyAtRegister
        }
    });
    const { formState: { isSubmitting: isSubmitting }, handleSubmit: handleSubmit, watch: watch, setError: setError, reset: reset } = methods;
    (0, $jC8Vy.useEffect)(()=>{
        if (!connector) return;
        reset((0, $3125bc5569a0afef$export$7bb2f28ad6c44e46)(connector));
    }, [
        reset,
        connector
    ]);
    const configParser = (0, $ad959390f5003ec2$export$4c86d49e765c99cd)();
    (0, $jC8Vy.useEffect)(()=>{
        setConflictConnectorName(undefined);
    }, [
        connector
    ]);
    if (!connector) return null;
    const { id: connectorId, name: name, readme: readme } = connector;
    const { title: title, content: content } = (0, $be65b460d85f5eb9$export$3e690d7c9decfaaa)(readme);
    const connectorName = (0, $7oDSS.conditional)((0, $eRB1v.isLanguageTag)(language) && name[language]) ?? name.en;
    const onSubmit = handleSubmit((0, $5OcFi.trySubmitSafe)(async (data)=>{
        if (isSubmitting) return;
        // Recover error state
        setConflictConnectorName(undefined);
        const config = configParser(data, formItems);
        const { syncProfile: syncProfile, name: name, logo: logo, logoDark: logoDark, target: target } = data;
        const basePayload = {
            config: config,
            connectorId: connectorId,
            id: (0, $7oDSS.conditional)(connectorType === (0, $kowfT.ConnectorType).Social && callbackConnectorId.current),
            metadata: (0, $7oDSS.conditional)(isStandard && {
                logo: logo,
                logoDark: logoDark,
                target: target,
                name: {
                    en: name
                }
            })
        };
        const payload = isSocialConnector ? {
            ...basePayload,
            syncProfile: syncProfile === (0, $6c796a80483fa826$export$ed9ee40b3ba009ed).EachSignIn
        } : basePayload;
        try {
            const createdConnector = await createConnector(payload);
            onClose();
            (0, $FuhPC.toast).success(t("general.saved"));
            navigate(`/connectors/${isSocialConnector ? (0, $bt3dS.ConnectorsTabs).Social : (0, $bt3dS.ConnectorsTabs).Passwordless}/${createdConnector.id}`);
        } catch (error) {
            if (error instanceof (0, $5cXXM.HTTPError)) {
                const { response: response } = error;
                const metadata = await response.json();
                if (metadata.code === $8f1b807d77061756$var$targetErrorCode) {
                    setConflictConnectorName(metadata.data.connectorName);
                    setError("target", {}, {
                        shouldFocus: true
                    });
                    return;
                }
            }
            throw error;
        }
    }));
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        shouldCloseOnEsc: true,
        isOpen: Boolean(connector),
        className: $dW2kG.fullScreen,
        onRequestClose: ()=>{
            onClose();
        },
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
            className: $d774c88e7577c1e5$export$34e0f9847d4c02dd,
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: $d774c88e7577c1e5$export$38e42c68cf43b5d4,
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                            size: "large",
                            onClick: ()=>{
                                onClose(callbackConnectorId.current);
                            },
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $HHYyb.default), {
                                className: $d774c88e7577c1e5$export$64a53ecd158b85c4
                            })
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $d774c88e7577c1e5$export$3e523c77c1f23f8c
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $18SWy.default), {
                            size: "small",
                            title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8R7rc.default), {
                                children: connectorName
                            }),
                            subtitle: "connectors.guide.subtitle"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: $d774c88e7577c1e5$export$a7db06668cad9adb,
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aTllQ.default), {
                            className: $d774c88e7577c1e5$export$20b6fe5c276910c1,
                            children: [
                                /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                    className: $d774c88e7577c1e5$export$62b98b62cb75971a,
                                    children: [
                                        "README: ",
                                        title
                                    ]
                                }),
                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $061baaa56e1104e9$export$2e2bcd8739ae039), {
                                    className: $d774c88e7577c1e5$export$ca1a0b14edb13127,
                                    children: content
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $d774c88e7577c1e5$export$de27182ff8187d6c,
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.FormProvider), {
                                ...methods,
                                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("form", {
                                    autoComplete: "off",
                                    onSubmit: onSubmit,
                                    children: [
                                        isSocialConnector && /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                            className: $d774c88e7577c1e5$export$837bd02682cd3db9,
                                            children: [
                                                /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                                    className: $d774c88e7577c1e5$export$2f3470a7f0d1a379,
                                                    children: [
                                                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                            className: $d774c88e7577c1e5$export$98e628dec113755e,
                                                            children: "1"
                                                        }),
                                                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                            children: t("connectors.guide.general_setting")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $d07ae49cfb76ace8$export$2e2bcd8739ae039), {
                                                    isAllowEditTarget: isStandard,
                                                    isStandard: isStandard,
                                                    conflictConnectorName: conflictConnectorName
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                            className: $d774c88e7577c1e5$export$837bd02682cd3db9,
                                            children: [
                                                /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                                    className: $d774c88e7577c1e5$export$2f3470a7f0d1a379,
                                                    children: [
                                                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                            className: $d774c88e7577c1e5$export$98e628dec113755e,
                                                            children: isSocialConnector ? 2 : 1
                                                        }),
                                                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                            children: t("connectors.guide.parameter_configuration")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ddd4f852125f683c$export$2e2bcd8739ae039), {
                                                    connectorId: callbackConnectorId.current,
                                                    connectorFactoryId: connectorFactoryId,
                                                    connectorType: connectorType,
                                                    formItems: formItems
                                                })
                                            ]
                                        }),
                                        !isSocialConnector && /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                            className: $d774c88e7577c1e5$export$837bd02682cd3db9,
                                            children: [
                                                /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                                    className: $d774c88e7577c1e5$export$2f3470a7f0d1a379,
                                                    children: [
                                                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                            className: $d774c88e7577c1e5$export$98e628dec113755e,
                                                            children: "2"
                                                        }),
                                                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                            children: t("connectors.guide.test_connection")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1eb486476ab9f4d3$export$2e2bcd8739ae039), {
                                                    connectorFactoryId: connectorId,
                                                    connectorType: connectorType,
                                                    parse: ()=>configParser(watch(), formItems)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                            className: $d774c88e7577c1e5$export$adb608be33961c98,
                                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                                                title: "connectors.save_and_done",
                                                type: "primary",
                                                htmlType: "submit",
                                                isLoading: isSubmitting
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
}
var $8f1b807d77061756$export$2e2bcd8739ae039 = $8f1b807d77061756$var$Guide;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $voszV = parcelRequire("voszV");

var $1QOtg = parcelRequire("1QOtg");

var $9Q3SI = parcelRequire("9Q3SI");

var $bf35df009204f062$export$b31f6ae88848cf15;
var $bf35df009204f062$export$bfd64c937657f93a;
var $bf35df009204f062$export$4a6dd88bada4e7d2;
$bf35df009204f062$export$b31f6ae88848cf15 = `_78fBFG_notice`;
$bf35df009204f062$export$bfd64c937657f93a = `_78fBFG_rotating`;
$bf35df009204f062$export$4a6dd88bada4e7d2 = `_78fBFG_shimmer`;


function $ce57ad93df1fdde2$var$SignInExperienceSetupNotice() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: connectors } = (0, $voszV.default)("api/connectors");
    const { data: { connectorSieNoticeConfirmed: connectorSieNoticeConfirmed }, update: update } = (0, $c83ac2f0f8302d6c$export$2e2bcd8739ae039)();
    if (!connectors || connectors.length === 0 || connectorSieNoticeConfirmed) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1QOtg.default), {
        action: "general.got_it",
        className: $bf35df009204f062$export$b31f6ae88848cf15,
        onClick: ()=>{
            update({
                connectorSieNoticeConfirmed: true
            });
        },
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
            components: {
                a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                    to: "/sign-in-experience/sign-up-and-sign-in"
                })
            },
            children: t("connectors.config_sie_notice", {
                link: t("connectors.config_sie_link_text")
            })
        })
    });
}
var $ce57ad93df1fdde2$export$2e2bcd8739ae039 = $ce57ad93df1fdde2$var$SignInExperienceSetupNotice;


var $4b4c6f8aadc3072d$export$ded9b5979746c93f;
var $4b4c6f8aadc3072d$export$34e0f9847d4c02dd;
var $4b4c6f8aadc3072d$export$6e22c362a0406a2c;
var $4b4c6f8aadc3072d$export$c34e3c28fad7070e;
var $4b4c6f8aadc3072d$export$bfd64c937657f93a;
var $4b4c6f8aadc3072d$export$4a6dd88bada4e7d2;
var $4b4c6f8aadc3072d$export$39f5674517ec0000;
$4b4c6f8aadc3072d$export$ded9b5979746c93f = `G05ORa_connectorName`;
$4b4c6f8aadc3072d$export$34e0f9847d4c02dd = `G05ORa_container`;
$4b4c6f8aadc3072d$export$6e22c362a0406a2c = `G05ORa_empty`;
$4b4c6f8aadc3072d$export$c34e3c28fad7070e = `G05ORa_emptyLine`;
$4b4c6f8aadc3072d$export$bfd64c937657f93a = `G05ORa_rotating`;
$4b4c6f8aadc3072d$export$4a6dd88bada4e7d2 = `G05ORa_shimmer`;
$4b4c6f8aadc3072d$export$39f5674517ec0000 = `G05ORa_tabs`;


const $a93af05407b74123$var$basePathname = "/connectors";
const $a93af05407b74123$var$passwordlessPathname = `${$a93af05407b74123$var$basePathname}/${(0, $bt3dS.ConnectorsTabs).Passwordless}`;
const $a93af05407b74123$var$socialPathname = `${$a93af05407b74123$var$basePathname}/${(0, $bt3dS.ConnectorsTabs).Social}`;
const $a93af05407b74123$var$buildTabPathname = (connectorType)=>connectorType === (0, $kowfT.ConnectorType).Social ? $a93af05407b74123$var$socialPathname : $a93af05407b74123$var$passwordlessPathname;
const $a93af05407b74123$var$buildCreatePathname = (connectorType)=>{
    const tabPath = $a93af05407b74123$var$buildTabPathname(connectorType);
    return `${tabPath}/create/${connectorType}`;
};
const $a93af05407b74123$var$buildGuidePathname = (connectorType, factoryId)=>{
    const tabPath = $a93af05407b74123$var$buildTabPathname(connectorType);
    return `${tabPath}/guide/${factoryId}`;
};
const $a93af05407b74123$var$isConnectorType = (value)=>Object.values((0, $kowfT.ConnectorType)).includes(value);
const $a93af05407b74123$var$parseToConnectorType = (value)=>(0, $7oDSS.conditional)(value && $a93af05407b74123$var$isConnectorType(value) && value);
function $a93af05407b74123$var$Connectors() {
    const { tab: tab = (0, $bt3dS.ConnectorsTabs).Passwordless, createType: createType, factoryId: factoryId } = (0, $2Phw0.useParams)();
    const createConnectorType = $a93af05407b74123$var$parseToConnectorType(createType);
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const isSocial = tab === (0, $bt3dS.ConnectorsTabs).Social;
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $b595fc2f0eccd19a$export$2e2bcd8739ae039)();
    const { createConnector: createConnector } = (0, $ef5cb09f22cdc7ad$export$2e2bcd8739ae039)();
    const { data: data, error: error, mutate: mutate } = (0, $9d72639ba10eaeeb$export$2e2bcd8739ae039)();
    const { data: factories, error: factoriesError } = (0, $voszV.default)("api/connector-factories");
    const isLoading = !data && !factories && !error && !factoriesError;
    const passwordlessConnectors = (0, $jC8Vy.useMemo)(()=>{
        const emailConnector = data?.find(({ type: type })=>type === (0, $kowfT.ConnectorType).Email) ?? (0, $lmQmj.defaultEmailConnectorGroup);
        const smsConnector = data?.find(({ type: type })=>type === (0, $kowfT.ConnectorType).Sms) ?? (0, $lmQmj.defaultSmsConnectorGroup);
        return [
            emailConnector,
            smsConnector
        ];
    }, [
        data
    ]);
    const socialConnectors = (0, $jC8Vy.useMemo)(()=>data?.filter(({ type: type })=>type === (0, $kowfT.ConnectorType).Social), [
        data
    ]);
    const connectors = isSocial ? socialConnectors : passwordlessConnectors;
    const hasDemoConnector = connectors?.some(({ isDemo: isDemo })=>isDemo);
    const connectorToShowInGuide = (0, $jC8Vy.useMemo)(()=>{
        if (factories && factoryId) return factories.find(({ id: id })=>id === factoryId);
    }, [
        factoryId,
        factories
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $998b64ca82ed2460$export$2e2bcd8739ae039), {
        className: $4b4c6f8aadc3072d$export$34e0f9847d4c02dd,
        title: {
            title: "connectors.title",
            subtitle: "connectors.subtitle"
        },
        pageMeta: {
            titleKey: "connectors.page_title"
        },
        createButton: (0, $7oDSS.conditional)(isSocial && {
            title: "connectors.create",
            onClick: ()=>{
                navigate($a93af05407b74123$var$buildCreatePathname((0, $kowfT.ConnectorType).Social));
            }
        }),
        subHeader: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ce57ad93df1fdde2$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $26090e0c44b20d28$export$2e2bcd8739ae039), {
                    className: $4b4c6f8aadc3072d$export$39f5674517ec0000,
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                            href: $a93af05407b74123$var$passwordlessPathname,
                            children: t("connectors.tab_email_sms")
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                            href: $a93af05407b74123$var$socialPathname,
                            children: t("connectors.tab_social")
                        })
                    ]
                }),
                hasDemoConnector && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66994a2f46f4858a$export$2e2bcd8739ae039), {})
            ]
        }),
        table: {
            rowIndexKey: "id",
            rowGroups: [
                {
                    key: "connectors",
                    data: connectors
                }
            ],
            columns: [
                {
                    title: t("connectors.connector_name"),
                    dataIndex: "name",
                    colSpan: 6,
                    render: (connectorGroup)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $cec9b740cd481a2c$export$2e2bcd8739ae039), {
                            connectorGroup: connectorGroup,
                            isDemo: connectorGroup.isDemo
                        })
                },
                {
                    title: t("connectors.connector_type"),
                    dataIndex: "type",
                    colSpan: 5,
                    render: (connectorGroup)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $7dac66eecf504254$export$2e2bcd8739ae039), {
                            connectorGroup: connectorGroup
                        })
                },
                {
                    title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fc11849530e00506$export$2e2bcd8739ae039), {}),
                    dataIndex: "status",
                    colSpan: 4,
                    render: (connectorGroup)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $88ce4af6518b830d$export$2e2bcd8739ae039), {
                            connectorGroup: connectorGroup
                        })
                },
                {
                    title: null,
                    dataIndex: "delete",
                    colSpan: 1,
                    render: (connectorGroup)=>connectorGroup.isDemo ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e95793fba5558ff3$export$2e2bcd8739ae039), {
                            connectorGroup: connectorGroup
                        }) : null
                }
            ],
            isRowClickable: ({ connectors: connectors })=>Boolean(connectors[0]) && !connectors[0]?.isDemo,
            rowClickHandler: ({ connectors: connectors })=>{
                const firstConnector = connectors[0];
                if (!firstConnector) return;
                const { type: type, id: id } = firstConnector;
                navigate(`${type === (0, $kowfT.ConnectorType).Social ? $a93af05407b74123$var$socialPathname : $a93af05407b74123$var$passwordlessPathname}/${id}`);
            },
            isLoading: isLoading,
            errorMessage: error?.body?.message ?? error?.message,
            placeholder: (0, $7oDSS.conditional)(isSocial && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2b56c00d3802884b$export$2e2bcd8739ae039), {
                image: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a2d27914efa8292d$export$2e2bcd8739ae039), {}),
                imageDark: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $d564cfd7e053f4f6$export$2e2bcd8739ae039), {}),
                title: "connectors.placeholder_title",
                description: "connectors.placeholder_description",
                learnMoreLink: {
                    href: getDocumentationUrl("/docs/recipes/configure-connectors/configure-social-connector"),
                    targetBlank: "noopener"
                },
                action: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                    title: "connectors.create",
                    type: "primary",
                    size: "large",
                    icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0b30fe81c923292b$export$2e2bcd8739ae039), {}),
                    onClick: ()=>{
                        navigate($a93af05407b74123$var$buildCreatePathname((0, $kowfT.ConnectorType).Social));
                    }
                })
            })),
            onRetry: async ()=>mutate(undefined, true)
        },
        widgets: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $80bae7df489c133c$export$2e2bcd8739ae039), {
                    isOpen: Boolean(createConnectorType),
                    type: createConnectorType,
                    onClose: async (id)=>{
                        if (createConnectorType && id) {
                            /**
                 * Note:
                 * The "Email Service Connector" is a built-in connector that can be directly created without the need for setup in the guide.
                 */ if (id === (0, $7YxsJ.ServiceConnector).Email) {
                                const created = await createConnector({
                                    connectorId: id
                                });
                                navigate(`/connectors/${(0, $bt3dS.ConnectorsTabs).Passwordless}/${created.id}`, {
                                    replace: true
                                });
                                return;
                            }
                            navigate($a93af05407b74123$var$buildGuidePathname(createConnectorType, id), {
                                replace: true
                            });
                            return;
                        }
                        navigate(`${$a93af05407b74123$var$basePathname}/${tab}`);
                    }
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8f1b807d77061756$export$2e2bcd8739ae039), {
                    connector: connectorToShowInGuide,
                    onClose: ()=>{
                        navigate(`${$a93af05407b74123$var$basePathname}/${tab}`);
                    }
                })
            ]
        })
    });
}
var $a93af05407b74123$export$2e2bcd8739ae039 = $a93af05407b74123$var$Connectors;


const $01ab90c2db008176$export$8f569aada139fb21 = {
    path: "connectors",
    children: [
        {
            index: true,
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Navigate), {
                replace: true,
                to: (0, $bt3dS.ConnectorsTabs).Passwordless
            })
        },
        {
            path: ":tab",
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a93af05407b74123$export$2e2bcd8739ae039), {})
        },
        {
            path: ":tab/create/:createType",
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a93af05407b74123$export$2e2bcd8739ae039), {})
        },
        {
            path: ":tab/guide/:factoryId",
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a93af05407b74123$export$2e2bcd8739ae039), {})
        },
        {
            path: ":tab/:connectorId",
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7d1e296fdb980a58$export$2e2bcd8739ae039), {})
        }
    ]
};



var $C7mD2 = parcelRequire("C7mD2");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $lXQZH = parcelRequire("lXQZH");
var $6NioG = parcelRequire("6NioG");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");


var $8TpMk = parcelRequire("8TpMk");


var $cDKfs = parcelRequire("cDKfs");

var $18SWy = parcelRequire("18SWy");

var $aqmjm = parcelRequire("aqmjm");

var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");



var $jGWQ4 = parcelRequire("jGWQ4");

var $kBpQ2 = parcelRequire("kBpQ2");

var $4ZcUR = parcelRequire("4ZcUR");
const $be22d3afc68f1d38$export$413d97236b66d9c0 = (tokenType)=>{
    if (!tokenType) return "api/configs/jwt-customizer";
    return `api/configs/jwt-customizer/${tokenType}`;
};
const $be22d3afc68f1d38$export$d72b1b7bb75ba57c = (tokenType, action)=>{
    if (!tokenType) return "/customize-jwt";
    if (action) return `/customize-jwt/${tokenType}/${action}`;
    // Fallback to the main page
    return `/customize-jwt`;
};


function $a33aa2a01aa25101$var$CreateButton({ tokenType: tokenType }) {
    const link = (0, $be22d3afc68f1d38$export$d72b1b7bb75ba57c)(tokenType, "create");
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const { show: show } = (0, $kBpQ2.useConfirmModal)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { currentPlan: currentPlan } = (0, $jC8Vy.useContext)((0, $19434c930f80c964$export$f8addfd4ab69c833));
    const { quota: { customJwtEnabled: customJwtEnabled } } = currentPlan;
    const onCreateButtonClick = (0, $jC8Vy.useCallback)(async ()=>{
        if (customJwtEnabled) {
            navigate(link);
            return;
        }
        const [confirm] = await show({
            title: "upsell.paywall.custom_jwt.title",
            ModalContent: ()=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                    components: {
                        a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a3bc63325dc3c1a8$export$2e2bcd8739ae039), {})
                    },
                    children: t("upsell.paywall.custom_jwt.description")
                }),
            confirmButtonText: "upsell.upgrade_plan",
            confirmButtonType: "primary",
            isCancelButtonVisible: false
        });
        if (confirm) // Navigate to subscription page by default
        navigate("/tenant-settings/subscription");
    }, [
        customJwtEnabled,
        link,
        navigate,
        show,
        t
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
        type: "primary",
        title: "jwt_claims.custom_jwt_create_button",
        onClick: onCreateButtonClick
    });
}
var $a33aa2a01aa25101$export$2e2bcd8739ae039 = $a33aa2a01aa25101$var$CreateButton;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $6NioG = parcelRequire("6NioG");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");



var $jGWQ4 = parcelRequire("jGWQ4");

var $4ZcUR = parcelRequire("4ZcUR");

var $48efe6f530fcfdf4$export$e324594224ef24da;
var $48efe6f530fcfdf4$export$34e0f9847d4c02dd;
var $48efe6f530fcfdf4$export$7c4df8d735fa2705;
var $48efe6f530fcfdf4$export$1ca1ec8b29a4ce27;
var $48efe6f530fcfdf4$export$bfd64c937657f93a;
var $48efe6f530fcfdf4$export$4a6dd88bada4e7d2;
var $48efe6f530fcfdf4$export$fb184b623420d9be;
$48efe6f530fcfdf4$export$e324594224ef24da = `V1O4mG_actions`;
$48efe6f530fcfdf4$export$34e0f9847d4c02dd = `V1O4mG_container`;
$48efe6f530fcfdf4$export$7c4df8d735fa2705 = `V1O4mG_danger`;
$48efe6f530fcfdf4$export$1ca1ec8b29a4ce27 = `V1O4mG_icon`;
$48efe6f530fcfdf4$export$bfd64c937657f93a = `V1O4mG_rotating`;
$48efe6f530fcfdf4$export$4a6dd88bada4e7d2 = `V1O4mG_shimmer`;
$48efe6f530fcfdf4$export$fb184b623420d9be = `V1O4mG_title`;


function $65fcf80534f7a59c$var$CustomizerItem({ tokenType: tokenType, onDelete: onDelete }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const editLink = (0, $be22d3afc68f1d38$export$d72b1b7bb75ba57c)(tokenType, "edit");
    const { navigate: navigate } = (0, $4ZcUR.default)();
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $48efe6f530fcfdf4$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $48efe6f530fcfdf4$export$fb184b623420d9be,
                children: t("jwt_claims.custom_jwt_item", {
                    for: tokenType === (0, $6NioG.LogtoJwtTokenKeyType).AccessToken ? t("jwt_claims.user_jwt.for") : t("jwt_claims.machine_to_machine_jwt.for")
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $48efe6f530fcfdf4$export$e324594224ef24da,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f8294d6f9d89665d$export$2e2bcd8739ae039), {
                            className: $48efe6f530fcfdf4$export$1ca1ec8b29a4ce27
                        }),
                        type: "text",
                        size: "small",
                        title: "general.edit",
                        onClick: ()=>{
                            navigate(editLink);
                        }
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        className: $48efe6f530fcfdf4$export$7c4df8d735fa2705,
                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3aa588de5c8665f2$export$2e2bcd8739ae039), {
                            className: $48efe6f530fcfdf4$export$1ca1ec8b29a4ce27
                        }),
                        type: "text",
                        size: "small",
                        title: "general.delete",
                        onClick: ()=>{
                            onDelete(tokenType);
                        }
                    })
                ]
            })
        ]
    });
}
var $65fcf80534f7a59c$export$2e2bcd8739ae039 = $65fcf80534f7a59c$var$CustomizerItem;



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
parcelRequire("voszV");
var $hgWIN = parcelRequire("hgWIN");

var $dL4NZ = parcelRequire("dL4NZ");

var $7VnwS = parcelRequire("7VnwS");

function $9703f2a5d5a6db7e$var$DeleteConfirmModal({ isOpen: isOpen, tokenType: tokenType, onCancel: onCancel }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [loading, setLoading] = (0, $jC8Vy.useState)(false);
    const { mutate: mutate } = (0, $hgWIN.useSWRConfig)();
    const api = (0, $7VnwS.default)();
    const apiLink = tokenType && (0, $be22d3afc68f1d38$export$413d97236b66d9c0)(tokenType);
    const onDelete = (0, $jC8Vy.useCallback)(async ()=>{
        // If no token type is provided, dismiss the modal
        if (!apiLink) {
            onCancel();
            return;
        }
        setLoading(true);
        try {
            // Delete the JWT customizer
            await api.delete(apiLink);
            // Mutate the SWR cache
            await mutate((0, $be22d3afc68f1d38$export$413d97236b66d9c0)());
        } finally{
            setLoading(false);
            onCancel();
        }
    }, [
        api,
        apiLink,
        mutate,
        onCancel
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dL4NZ.default), {
        title: "jwt_claims.delete_modal_title",
        confirmButtonText: "general.delete",
        isOpen: isOpen,
        isLoading: loading,
        onConfirm: onDelete,
        onCancel: onCancel,
        children: t("jwt_claims.delete_modal_content")
    });
}
var $9703f2a5d5a6db7e$export$2e2bcd8739ae039 = $9703f2a5d5a6db7e$var$DeleteConfirmModal;


var $c60b88d35936613f$export$34e0f9847d4c02dd;
var $c60b88d35936613f$export$6d59db4903f20f7d;
var $c60b88d35936613f$export$38e42c68cf43b5d4;
var $c60b88d35936613f$export$ad430d422a89f9f0;
var $c60b88d35936613f$export$bfd64c937657f93a;
var $c60b88d35936613f$export$4a6dd88bada4e7d2;
$c60b88d35936613f$export$34e0f9847d4c02dd = `L-f7HW_container`;
$c60b88d35936613f$export$6d59db4903f20f7d = `L-f7HW_description`;
$c60b88d35936613f$export$38e42c68cf43b5d4 = `L-f7HW_header`;
$c60b88d35936613f$export$ad430d422a89f9f0 = `L-f7HW_mainContent`;
$c60b88d35936613f$export$bfd64c937657f93a = `L-f7HW_rotating`;
$c60b88d35936613f$export$4a6dd88bada4e7d2 = `L-f7HW_shimmer`;


parcelRequire("cuPVN");
var $jnq2J = parcelRequire("jnq2J");

var $jC8Vy = parcelRequire("jC8Vy");

var $voszV = parcelRequire("voszV");

var $7VnwS = parcelRequire("7VnwS");


function $ef4ed2b0737fcf9b$var$useJwtCustomizer() {
    const fetchApi = (0, $7VnwS.default)({
        hideErrorToast: true
    });
    const fetcher = (0, $04c74fc7d2f91811$export$2e2bcd8739ae039)(fetchApi);
    const { data: data, isLoading: isDataLoading, error: error, mutate: mutate } = (0, $voszV.default)((0, $be22d3afc68f1d38$export$413d97236b66d9c0)(), {
        fetcher: fetcher
    });
    const isLoading = isDataLoading && !error;
    return (0, $jC8Vy.useMemo)(()=>{
        const { value: accessTokenJwtCustomizer } = data?.find(({ key: key })=>key === (0, $jnq2J.LogtoJwtTokenKey).AccessToken) ?? {};
        const { value: clientCredentialsJwtCustomizer } = data?.find(({ key: key })=>key === (0, $jnq2J.LogtoJwtTokenKey).ClientCredentials) ?? {};
        return {
            accessTokenJwtCustomizer: accessTokenJwtCustomizer,
            clientCredentialsJwtCustomizer: clientCredentialsJwtCustomizer,
            isLoading: isLoading,
            mutate: mutate
        };
    }, [
        data,
        isLoading,
        mutate
    ]);
}
var $ef4ed2b0737fcf9b$export$2e2bcd8739ae039 = $ef4ed2b0737fcf9b$var$useJwtCustomizer;


function $929e8d9f5970bcab$var$CustomizeJwt() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { isDevTenant: isDevTenant } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { currentPlan: currentPlan } = (0, $jC8Vy.useContext)((0, $19434c930f80c964$export$f8addfd4ab69c833));
    const isCustomJwtEnabled = !(0, $8TpMk.isCloud) || currentPlan.quota.customJwtEnabled;
    const [deleteModalTokenType, setDeleteModalTokenType] = (0, $jC8Vy.useState)();
    const onDeleteHandler = (0, $jC8Vy.useCallback)((tokenType)=>{
        setDeleteModalTokenType(tokenType);
    }, []);
    const { isLoading: isLoading, accessTokenJwtCustomizer: accessTokenJwtCustomizer, clientCredentialsJwtCustomizer: clientCredentialsJwtCustomizer } = (0, $ef4ed2b0737fcf9b$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("main", {
        className: $c60b88d35936613f$export$ad430d422a89f9f0,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $18SWy.default), {
                paywall: (0, $7oDSS.cond)((!isCustomJwtEnabled || isDevTenant) && (0, $lXQZH.ReservedPlanId).Pro),
                title: "jwt_claims.title",
                subtitle: "jwt_claims.description",
                className: $c60b88d35936613f$export$38e42c68cf43b5d4
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $c60b88d35936613f$export$34e0f9847d4c02dd,
                children: [
                    isLoading && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fe58a6ffca737898$export$2e2bcd8739ae039), {
                                formFieldCount: 1
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fe58a6ffca737898$export$2e2bcd8739ae039), {
                                formFieldCount: 1
                            })
                        ]
                    }),
                    !isLoading && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
                                title: "jwt_claims.user_jwt.card_title",
                                children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aqmjm.default), {
                                    title: "jwt_claims.user_jwt.card_field",
                                    children: [
                                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                            className: $c60b88d35936613f$export$6d59db4903f20f7d,
                                            children: t("jwt_claims.user_jwt.card_description")
                                        }),
                                        accessTokenJwtCustomizer ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $65fcf80534f7a59c$export$2e2bcd8739ae039), {
                                            tokenType: (0, $6NioG.LogtoJwtTokenKeyType).AccessToken,
                                            onDelete: onDeleteHandler
                                        }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a33aa2a01aa25101$export$2e2bcd8739ae039), {
                                            tokenType: (0, $6NioG.LogtoJwtTokenKeyType).AccessToken
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
                                title: "jwt_claims.machine_to_machine_jwt.card_title",
                                children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aqmjm.default), {
                                    title: "jwt_claims.machine_to_machine_jwt.card_field",
                                    children: [
                                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                            className: $c60b88d35936613f$export$6d59db4903f20f7d,
                                            children: t("jwt_claims.machine_to_machine_jwt.card_description")
                                        }),
                                        clientCredentialsJwtCustomizer ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $65fcf80534f7a59c$export$2e2bcd8739ae039), {
                                            tokenType: (0, $6NioG.LogtoJwtTokenKeyType).ClientCredentials,
                                            onDelete: onDeleteHandler
                                        }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a33aa2a01aa25101$export$2e2bcd8739ae039), {
                                            tokenType: (0, $6NioG.LogtoJwtTokenKeyType).ClientCredentials
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9703f2a5d5a6db7e$export$2e2bcd8739ae039), {
                isOpen: !!deleteModalTokenType,
                tokenType: deleteModalTokenType,
                onCancel: ()=>{
                    setDeleteModalTokenType(undefined);
                }
            })
        ]
    });
}
var $929e8d9f5970bcab$export$2e2bcd8739ae039 = $929e8d9f5970bcab$var$CustomizeJwt;



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $2Phw0 = parcelRequire("2Phw0");


/**
 * This context is used to share the loading state of the code editor with the root page.
 *
 * 1. First code editor won't be rendered until the fetch API is returned.
 * 2. After the code editor is mounted, multiple async operations will be triggered to load the monaco editor.
 * 3. We need to mount the code editor component will keep the loading state until the monaco editor is ready.
 */ parcelRequire("12bMu");
var $3dBAh = parcelRequire("3dBAh");

var $jC8Vy = parcelRequire("jC8Vy");
const $ab3b3c4ca6da4bbe$export$e174976f1470e250 = (0, $jC8Vy.createContext)({
    isMonacoLoaded: false,
    setIsMonacoLoaded: (0, $3dBAh.noop)
});



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $codQP = parcelRequire("codQP");
parcelRequire("6bq3s");
var $2Phw0 = parcelRequire("2Phw0");
parcelRequire("voszV");
var $hgWIN = parcelRequire("hgWIN");



var $7VnwS = parcelRequire("7VnwS");


var $5OcFi = parcelRequire("5OcFi");
parcelRequire("cuPVN");
var $6NioG = parcelRequire("6NioG");

var $C7mD2 = parcelRequire("C7mD2");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $078889940a177961$var$SvgTokenFileIcon = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 16,
        height: 17,
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M12.667 1.937H3.333a2 2 0 0 0-2 2v9.333a2 2 0 0 0 2 2h9.334a2 2 0 0 0 2-2V3.937a2 2 0 0 0-2-2Zm.666 11.333a.667.667 0 0 1-.666.667H3.333a.667.667 0 0 1-.666-.667V3.937a.667.667 0 0 1 .666-.667h9.334a.667.667 0 0 1 .666.667v9.333Z",
                fill: "currentcolor"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M7.917 12.656a.783.783 0 0 1-.784-.783V6.66H5.362a.695.695 0 1 1 0-1.39h5.128a.695.695 0 0 1 0 1.39H8.7v5.213c0 .432-.35.783-.783.783Z",
                fill: "currentcolor"
            })
        ]
    });
var $078889940a177961$export$2e2bcd8739ae039 = $078889940a177961$var$SvgTokenFileIcon;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $360d6b446e95f9f2$var$SvgUserFileIcon = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 16,
        height: 17,
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M8 1.937A6.667 6.667 0 0 0 3.1 13.11a6.665 6.665 0 0 0 9.8 0A6.667 6.667 0 0 0 8 1.937Zm0 12a5.333 5.333 0 0 1-3.7-1.5 4 4 0 0 1 7.4 0 5.334 5.334 0 0 1-3.7 1.5ZM6.667 7.27a1.333 1.333 0 1 1 2.666 0 1.333 1.333 0 0 1-2.666 0Zm5.94 4A5.333 5.333 0 0 0 10 9.017a2.666 2.666 0 1 0-4 0 5.333 5.333 0 0 0-2.607 2.253 5.28 5.28 0 0 1-.726-2.667 5.333 5.333 0 1 1 10.666 0 5.28 5.28 0 0 1-.726 2.667Z",
            fill: "currentcolor"
        })
    });
var $360d6b446e95f9f2$export$2e2bcd8739ae039 = $360d6b446e95f9f2$var$SvgUserFileIcon;


/* This file is auto-generated. Do not modify it manually. */ var $7f1c81b5383b5d33$export$f5fdbf0ecbd5c6d6;
(function(JwtCustomizerTypeDefinitionKey) {
    JwtCustomizerTypeDefinitionKey["JwtCustomizerUserContext"] = "JwtCustomizerUserContext";
    JwtCustomizerTypeDefinitionKey["AccessTokenPayload"] = "AccessTokenPayload";
    JwtCustomizerTypeDefinitionKey["ClientCredentialsPayload"] = "ClientCredentialsPayload";
    JwtCustomizerTypeDefinitionKey["EnvironmentVariables"] = "EnvironmentVariables";
})($7f1c81b5383b5d33$export$f5fdbf0ecbd5c6d6 || ($7f1c81b5383b5d33$export$f5fdbf0ecbd5c6d6 = {}));
const $7f1c81b5383b5d33$export$dfc7d5a7a860045c = `type JwtCustomizerUserContext = {
    id: string;
    username: string | null;
    primaryEmail: string | null;
    primaryPhone: string | null;
    name: string | null;
    avatar: string | null;
    customData: {
        [x: string]: Record<string, unknown>;
    };
    identities: {
        [x: string]: {
            userId: string;
            details?: {
                [x: string]: Record<string, unknown>;
            } | undefined;
        };
    };
    lastSignInAt: number | null;
    createdAt: number;
    updatedAt: number;
    profile: {
        familyName?: string | undefined;
        givenName?: string | undefined;
        middleName?: string | undefined;
        nickname?: string | undefined;
        preferredUsername?: string | undefined;
        profile?: string | undefined;
        website?: string | undefined;
        gender?: string | undefined;
        birthdate?: string | undefined;
        zoneinfo?: string | undefined;
        locale?: string | undefined;
        address?: {
            formatted?: string | undefined;
            streetAddress?: string | undefined;
            locality?: string | undefined;
            region?: string | undefined;
            postalCode?: string | undefined;
            country?: string | undefined;
        } | undefined;
    };
    applicationId: string | null;
    isSuspended: boolean;
    ssoIdentities: {
        issuer: string;
        identityId: string;
        detail: {
            [x: string]: Record<string, unknown>;
        };
    }[];
    mfaVerificationFactors: ("Totp" | "WebAuthn" | "BackupCode")[];
    roles: {
        id: string;
        name: string;
        description: string;
        scopes: {
            id: string;
            name: string;
            description: string | null;
            resourceId: string;
            resource: {
                tenantId: string;
                id: string;
                name: string;
                indicator: string;
                isDefault: boolean;
                accessTokenTtl: number;
            };
        }[];
    }[];
    organizations: {
        id: string;
        name: string;
        description: string | null;
    }[];
    organizationRoles: {
        organizationId: string;
        roleId: string;
        roleName: string;
    }[];
};`;
const $7f1c81b5383b5d33$export$ba331f2e33839a49 = `type AccessTokenPayload = {
    jti: string;
    aud: string | string[];
    scope?: string | undefined;
    clientId?: string | undefined;
    accountId: string;
    expiresWithSession?: boolean | undefined;
    grantId: string;
    gty: string;
    sessionUid?: string | undefined;
    sid?: string | undefined;
    kind: "AccessToken";
};`;
const $7f1c81b5383b5d33$export$52758b5206de435e = `type ClientCredentialsPayload = {
    jti: string;
    aud: string | string[];
    scope?: string | undefined;
    clientId?: string | undefined;
    kind: "ClientCredentials";
};`;


const $cd1b3f507bbd071b$export$28d3d92bc8ad5be6 = ()=>{
    return `declare ${0, $7f1c81b5383b5d33$export$dfc7d5a7a860045c}

  declare ${0, $7f1c81b5383b5d33$export$ba331f2e33839a49}`;
};
const $cd1b3f507bbd071b$export$ef7d5ec00a37371f = ()=>`declare ${0, $7f1c81b5383b5d33$export$52758b5206de435e}`;
const $cd1b3f507bbd071b$export$a712d55055a8329b = (envVariables)=>{
    const typeDefinition = envVariables ? `{
  ${envVariables.filter(({ key: key })=>Boolean(key)).map(({ key: key })=>`${key}: string`).join(";\n")}
    }` : "undefined";
    return `declare type ${(0, $7f1c81b5383b5d33$export$f5fdbf0ecbd5c6d6).EnvironmentVariables} = ${typeDefinition}`;
};


/**
 * JWT token code editor configuration
 */ const $6010cf9dfb34da69$var$accessTokenJwtCustomizerDefinition = `
declare interface CustomJwtClaims extends Record<string, any> {}

/** Logto internal data that can be used to pass additional information
 * @param {${(0, $7f1c81b5383b5d33$export$f5fdbf0ecbd5c6d6).JwtCustomizerUserContext}} user - The user info associated with the token.
 */
declare type Context = {
  user: ${(0, $7f1c81b5383b5d33$export$f5fdbf0ecbd5c6d6).JwtCustomizerUserContext};
}

declare type Payload = {
  token: ${(0, $7f1c81b5383b5d33$export$f5fdbf0ecbd5c6d6).AccessTokenPayload};
  context: Context;
  environmentVariables: ${(0, $7f1c81b5383b5d33$export$f5fdbf0ecbd5c6d6).EnvironmentVariables};
};`;
const $6010cf9dfb34da69$var$clientCredentialsJwtCustomizerDefinition = `
declare interface CustomJwtClaims extends Record<string, any> {}

declare type Payload = {
  token: ${(0, $7f1c81b5383b5d33$export$f5fdbf0ecbd5c6d6).AccessTokenPayload};
  environmentVariables: ${(0, $7f1c81b5383b5d33$export$f5fdbf0ecbd5c6d6).EnvironmentVariables};
};`;
const $6010cf9dfb34da69$export$e7e9b9870a3c2a78 = `/**
* This function is called during the access token generation process to get custom claims for the JWT token.
* Limit custom claims to under 50KB.
*
* @param {Object} payload - The input payload of the function.
* @param {${(0, $7f1c81b5383b5d33$export$f5fdbf0ecbd5c6d6).AccessTokenPayload}} payload.token -The JWT token.
* @param {Context} payload.context - Logto internal data that can be used to pass additional information
* @param {${(0, $7f1c81b5383b5d33$export$f5fdbf0ecbd5c6d6).EnvironmentVariables}} [payload.environmentVariables] - The environment variables.
*
* @returns The custom claims.
*/
const getCustomJwtClaims = async ({ token, context, environmentVariables }) => {
  return {};
}`;
const $6010cf9dfb34da69$export$6939cd0ad96cec1b = `/**
* This function is called during the access token generation process to get custom claims for the JWT token.
* Limit custom claims to under 50KB.
*
* @param {Object} payload - The input payload of the function.
* @param {${(0, $7f1c81b5383b5d33$export$f5fdbf0ecbd5c6d6).ClientCredentialsPayload}} payload.token -The JWT token.
* @param {${(0, $7f1c81b5383b5d33$export$f5fdbf0ecbd5c6d6).EnvironmentVariables}} [payload.environmentVariables] - The environment variables.
*
* @returns The custom claims.
*/
const getCustomJwtClaims = async ({ token, environmentVariables }) => {
  return {};
}`;
const $6010cf9dfb34da69$export$b7c0c8726c797329 = {
    name: "user-jwt.js",
    title: "User access token",
    language: "typescript",
    defaultValue: $6010cf9dfb34da69$export$e7e9b9870a3c2a78,
    extraLibs: [
        {
            content: $6010cf9dfb34da69$var$accessTokenJwtCustomizerDefinition,
            filePath: `file:///logto-jwt-customizer.d.ts`
        },
        {
            content: (0, $cd1b3f507bbd071b$export$28d3d92bc8ad5be6)(),
            filePath: `file:///logto-jwt-customizer-context.d.ts`
        }
    ]
};
const $6010cf9dfb34da69$export$f332c44a3c6fb9f9 = {
    name: "machine-to-machine-jwt.js",
    title: "Machine-to-machine token",
    language: "typescript",
    defaultValue: $6010cf9dfb34da69$export$6939cd0ad96cec1b,
    extraLibs: [
        {
            content: $6010cf9dfb34da69$var$clientCredentialsJwtCustomizerDefinition,
            filePath: `file:///logto-jwt-customizer.d.ts`
        },
        {
            content: (0, $cd1b3f507bbd071b$export$ef7d5ec00a37371f)(),
            filePath: `file:///logto-jwt-customizer-context.d.ts`
        }
    ]
};
const $6010cf9dfb34da69$export$d5cfafb9872058ea = {
    readOnly: true,
    wordWrap: "on",
    minimap: {
        enabled: false
    },
    renderLineHighlight: "none",
    fontSize: 14,
    padding: {
        top: 16,
        bottom: 16
    },
    overviewRulerBorder: false,
    overviewRulerLanes: 0,
    lineNumbers: "off",
    folding: false,
    tabSize: 2,
    scrollBeyondLastLine: false
};
const $6010cf9dfb34da69$export$68b7ccdd266b35b8 = {
    ...$6010cf9dfb34da69$export$d5cfafb9872058ea,
    folding: true
};
const $6010cf9dfb34da69$export$53ee4998c34664bf = `const response = await fetch('https://api.example.com/data', {
  headers: {
    Authorization: \`{{API KEY}}\`,
  }
});

const data = await response.json();

return {
  externalData: data,
};`;
const $6010cf9dfb34da69$export$9c26fbd24436cc79 = `const getCustomJwtClaimsSample = async ({ environmentVariables }) => {
  const { apiKey } = environmentVariables;

  const response = await fetch('https://api.example.com/data', {
    headers: {
      Authorization: apiKey,
    }
  });

  const data = await response.json();

  return {
    externalData: data,
  };
};`;
/**
 * Tester Code Editor configs
 */ const $6010cf9dfb34da69$var$standardTokenPayloadData = {
    jti: "f1d3d2d1-1f2d-3d4e-5d6f-7d8a9d0e1d2",
    aud: "http://localhost:3000/api/test",
    scope: "read write",
    clientId: "my_app"
};
const $6010cf9dfb34da69$export$d67a66aa0b47d5e5 = {
    ...$6010cf9dfb34da69$var$standardTokenPayloadData,
    accountId: "uid_123",
    grantId: "grant_123",
    gty: "authorization_code",
    kind: "AccessToken"
};
const $6010cf9dfb34da69$export$cea22edde46eb66b = {
    ...$6010cf9dfb34da69$var$standardTokenPayloadData,
    kind: "ClientCredentials"
};
const $6010cf9dfb34da69$var$defaultUserContext = {
    id: "123",
    username: "foo",
    primaryEmail: "foo@logto.io",
    primaryPhone: "+1234567890",
    name: "Foo Bar",
    avatar: "https://example.com/avatar.png",
    customData: {},
    identities: {},
    profile: {},
    applicationId: "my-app",
    ssoIdentities: [],
    mfaVerificationFactors: [],
    roles: [],
    organizations: [],
    organizationRoles: []
};
const $6010cf9dfb34da69$export$1230b96ef2e3b303 = {
    user: $6010cf9dfb34da69$var$defaultUserContext
};
const $6010cf9dfb34da69$export$615416178429da08 = {
    language: "json",
    icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $078889940a177961$export$2e2bcd8739ae039), {}),
    name: "user-token-payload.json",
    title: "Token data",
    defaultValue: JSON.stringify($6010cf9dfb34da69$export$d67a66aa0b47d5e5, null, 2)
};
const $6010cf9dfb34da69$export$91df5829726a58b6 = {
    language: "json",
    icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $078889940a177961$export$2e2bcd8739ae039), {}),
    name: "machine-to-machine-token-payload.json",
    title: "Token data",
    defaultValue: JSON.stringify($6010cf9dfb34da69$export$cea22edde46eb66b, null, 2)
};
const $6010cf9dfb34da69$export$dae80692bff07000 = {
    language: "json",
    icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $360d6b446e95f9f2$export$2e2bcd8739ae039), {}),
    name: "user-token-context.json",
    title: "User data",
    defaultValue: JSON.stringify($6010cf9dfb34da69$export$1230b96ef2e3b303, null, 2)
};


const $42f2b6b98e4ee585$var$formatEnvVariablesResponseToFormData = (enVariables)=>{
    if (!enVariables) return;
    return Object.entries(enVariables).map(([key, value])=>({
            key: key,
            value: value
        }));
};
const $42f2b6b98e4ee585$var$formatEnvVariablesFormDataToRequest = (envVariables)=>{
    if (!envVariables) return;
    const entries = envVariables.filter(({ key: key, value: value })=>key && value);
    if (entries.length === 0) return;
    return Object.fromEntries(entries.map(({ key: key, value: value })=>[
            key,
            value
        ]));
};
const $42f2b6b98e4ee585$var$formatSampleCodeJsonToString = (sampleJson)=>{
    if (!sampleJson) return;
    return JSON.stringify(sampleJson, null, 2);
};
const $42f2b6b98e4ee585$var$formatSampleCodeStringToJson = (sampleCode)=>{
    if (!sampleCode) return;
    try {
        // eslint-disable-next-line no-restricted-syntax -- guarded by back-end validation
        return JSON.parse(sampleCode);
    } catch  {}
};
const $42f2b6b98e4ee585$var$defaultValues = Object.freeze({
    [(0, $6NioG.LogtoJwtTokenKeyType).AccessToken]: {
        script: (0, $6010cf9dfb34da69$export$e7e9b9870a3c2a78),
        tokenSample: (0, $6010cf9dfb34da69$export$d67a66aa0b47d5e5),
        contextSample: (0, $6010cf9dfb34da69$export$1230b96ef2e3b303)
    },
    [(0, $6NioG.LogtoJwtTokenKeyType).ClientCredentials]: {
        script: (0, $6010cf9dfb34da69$export$6939cd0ad96cec1b),
        tokenSample: (0, $6010cf9dfb34da69$export$cea22edde46eb66b),
        contextSample: undefined
    }
});
const $42f2b6b98e4ee585$export$e46869577cb50342 = (tokenType, data)=>{
    return {
        tokenType: tokenType,
        script: data?.script ?? $42f2b6b98e4ee585$var$defaultValues[tokenType].script,
        environmentVariables: $42f2b6b98e4ee585$var$formatEnvVariablesResponseToFormData(data?.environmentVariables) ?? [
            {
                key: "",
                value: ""
            }
        ],
        testSample: {
            tokenSample: $42f2b6b98e4ee585$var$formatSampleCodeJsonToString(data?.tokenSample ?? $42f2b6b98e4ee585$var$defaultValues[tokenType].tokenSample),
            contextSample: $42f2b6b98e4ee585$var$formatSampleCodeJsonToString(data?.contextSample ?? $42f2b6b98e4ee585$var$defaultValues[tokenType].contextSample)
        }
    };
};
const $42f2b6b98e4ee585$export$14e991553b564f72 = (data)=>{
    return {
        script: data.script,
        environmentVariables: $42f2b6b98e4ee585$var$formatEnvVariablesFormDataToRequest(data.environmentVariables),
        tokenSample: $42f2b6b98e4ee585$var$formatSampleCodeStringToJson(data.testSample.tokenSample),
        contextSample: $42f2b6b98e4ee585$var$formatSampleCodeStringToJson(data.testSample.contextSample)
    };
};
const $42f2b6b98e4ee585$export$64150fac4e9f6fb3 = ({ tokenType: tokenType, script: script, environmentVariables: environmentVariables, testSample: testSample })=>{
    return {
        tokenType: tokenType,
        script: script,
        environmentVariables: $42f2b6b98e4ee585$var$formatEnvVariablesFormDataToRequest(environmentVariables),
        token: $42f2b6b98e4ee585$var$formatSampleCodeStringToJson(testSample.tokenSample) ?? $42f2b6b98e4ee585$var$defaultValues[tokenType].tokenSample,
        context: $42f2b6b98e4ee585$var$formatSampleCodeStringToJson(testSample.contextSample) ?? $42f2b6b98e4ee585$var$defaultValues[tokenType].contextSample
    };
};


/* Code Editor for the custom JWT claims script. */ 
var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $6NioG = parcelRequire("6NioG");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $d728f06a1d8109a7$var$SvgStart = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 16,
        height: 17,
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M12.36 6.728 5.92 3.035a2.28 2.28 0 0 0-3.42 2v7.413a2.28 2.28 0 0 0 3.42 1.973l6.44-3.693a2.281 2.281 0 0 0 0-3.947v-.053Zm-.667 2.793-6.44 3.747a.96.96 0 0 1-.946 0 .946.946 0 0 1-.474-.82v-7.44a.947.947 0 0 1 .947-.947c.166.004.328.047.473.127l6.44 3.72a.946.946 0 0 1 0 1.64V9.52Z",
            fill: "currentcolor"
        })
    });
var $d728f06a1d8109a7$export$2e2bcd8739ae039 = $d728f06a1d8109a7$var$SvgStart;



var $jGWQ4 = parcelRequire("jGWQ4");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");
function $a46716400691f84a$export$fdab3c20aae16ddf(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a46716400691f84a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a46716400691f84a$export$df72099fd95ee399(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a46716400691f84a$var$ownKeys(Object(source), true).forEach(function(key) {
            $a46716400691f84a$export$fdab3c20aae16ddf(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a46716400691f84a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a46716400691f84a$export$81942a8f34b531c4(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $a46716400691f84a$export$d8a2083381e8fcb(source, excluded) {
    if (source == null) return {};
    var target = $a46716400691f84a$export$81942a8f34b531c4(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a46716400691f84a$export$12b6a547ec390b98(arr, i) {
    return $a46716400691f84a$export$993bf82df8051d40(arr) || $a46716400691f84a$export$861af887bcb88094(arr, i) || $a46716400691f84a$export$b471fbbbe6d7806(arr, i) || $a46716400691f84a$export$37ce4bd7a39fe25f();
}
function $a46716400691f84a$export$993bf82df8051d40(arr) {
    if (Array.isArray(arr)) return arr;
}
function $a46716400691f84a$export$861af887bcb88094(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a46716400691f84a$export$b471fbbbe6d7806(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a46716400691f84a$export$93cc12bcce4c2e3c(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a46716400691f84a$export$93cc12bcce4c2e3c(o, minLen);
}
function $a46716400691f84a$export$93cc12bcce4c2e3c(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a46716400691f84a$export$37ce4bd7a39fe25f() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $19161d474b9e3037$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $19161d474b9e3037$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $19161d474b9e3037$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $19161d474b9e3037$var$ownKeys(Object(source), true).forEach(function(key) {
            $19161d474b9e3037$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $19161d474b9e3037$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $19161d474b9e3037$var$compose() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(x) {
        return fns.reduceRight(function(y, f) {
            return f(y);
        }, x);
    };
}
function $19161d474b9e3037$var$curry(fn) {
    return function curried() {
        var _this = this;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return args.length >= fn.length ? fn.apply(this, args) : function() {
            for(var _len3 = arguments.length, nextArgs = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)nextArgs[_key3] = arguments[_key3];
            return curried.apply(_this, [].concat(args, nextArgs));
        };
    };
}
function $19161d474b9e3037$var$isObject(value) {
    return ({}).toString.call(value).includes("Object");
}
function $19161d474b9e3037$var$isEmpty(obj) {
    return !Object.keys(obj).length;
}
function $19161d474b9e3037$var$isFunction(value) {
    return typeof value === "function";
}
function $19161d474b9e3037$var$hasOwnProperty(object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
}
function $19161d474b9e3037$var$validateChanges(initial, changes) {
    if (!$19161d474b9e3037$var$isObject(changes)) $19161d474b9e3037$var$errorHandler("changeType");
    if (Object.keys(changes).some(function(field) {
        return !$19161d474b9e3037$var$hasOwnProperty(initial, field);
    })) $19161d474b9e3037$var$errorHandler("changeField");
    return changes;
}
function $19161d474b9e3037$var$validateSelector(selector) {
    if (!$19161d474b9e3037$var$isFunction(selector)) $19161d474b9e3037$var$errorHandler("selectorType");
}
function $19161d474b9e3037$var$validateHandler(handler) {
    if (!($19161d474b9e3037$var$isFunction(handler) || $19161d474b9e3037$var$isObject(handler))) $19161d474b9e3037$var$errorHandler("handlerType");
    if ($19161d474b9e3037$var$isObject(handler) && Object.values(handler).some(function(_handler) {
        return !$19161d474b9e3037$var$isFunction(_handler);
    })) $19161d474b9e3037$var$errorHandler("handlersType");
}
function $19161d474b9e3037$var$validateInitial(initial) {
    if (!initial) $19161d474b9e3037$var$errorHandler("initialIsRequired");
    if (!$19161d474b9e3037$var$isObject(initial)) $19161d474b9e3037$var$errorHandler("initialType");
    if ($19161d474b9e3037$var$isEmpty(initial)) $19161d474b9e3037$var$errorHandler("initialContent");
}
function $19161d474b9e3037$var$throwError(errorMessages, type) {
    throw new Error(errorMessages[type] || errorMessages["default"]);
}
var $19161d474b9e3037$var$errorMessages = {
    initialIsRequired: "initial state is required",
    initialType: "initial state should be an object",
    initialContent: "initial state shouldn't be an empty object",
    handlerType: "handler should be an object or a function",
    handlersType: "all handlers should be a functions",
    selectorType: "selector should be a function",
    changeType: "provided value of changes should be an object",
    changeField: 'it seams you want to change a field in the state which is not specified in the "initial" state',
    "default": "an unknown error accured in `state-local` package"
};
var $19161d474b9e3037$var$errorHandler = $19161d474b9e3037$var$curry($19161d474b9e3037$var$throwError)($19161d474b9e3037$var$errorMessages);
var $19161d474b9e3037$var$validators = {
    changes: $19161d474b9e3037$var$validateChanges,
    selector: $19161d474b9e3037$var$validateSelector,
    handler: $19161d474b9e3037$var$validateHandler,
    initial: $19161d474b9e3037$var$validateInitial
};
function $19161d474b9e3037$var$create(initial) {
    var handler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    $19161d474b9e3037$var$validators.initial(initial);
    $19161d474b9e3037$var$validators.handler(handler);
    var state = {
        current: initial
    };
    var didUpdate = $19161d474b9e3037$var$curry($19161d474b9e3037$var$didStateUpdate)(state, handler);
    var update = $19161d474b9e3037$var$curry($19161d474b9e3037$var$updateState)(state);
    var validate = $19161d474b9e3037$var$curry($19161d474b9e3037$var$validators.changes)(initial);
    var getChanges = $19161d474b9e3037$var$curry($19161d474b9e3037$var$extractChanges)(state);
    function getState() {
        var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function(state) {
            return state;
        };
        $19161d474b9e3037$var$validators.selector(selector);
        return selector(state.current);
    }
    function setState(causedChanges) {
        $19161d474b9e3037$var$compose(didUpdate, update, validate, getChanges)(causedChanges);
    }
    return [
        getState,
        setState
    ];
}
function $19161d474b9e3037$var$extractChanges(state, causedChanges) {
    return $19161d474b9e3037$var$isFunction(causedChanges) ? causedChanges(state.current) : causedChanges;
}
function $19161d474b9e3037$var$updateState(state, changes) {
    state.current = $19161d474b9e3037$var$_objectSpread2($19161d474b9e3037$var$_objectSpread2({}, state.current), changes);
    return changes;
}
function $19161d474b9e3037$var$didStateUpdate(state, handler, changes) {
    $19161d474b9e3037$var$isFunction(handler) ? handler(state.current) : Object.keys(changes).forEach(function(field) {
        var _handler$field;
        return (_handler$field = handler[field]) === null || _handler$field === void 0 ? void 0 : _handler$field.call(handler, state.current[field]);
    });
    return changes;
}
var $19161d474b9e3037$var$index = {
    create: $19161d474b9e3037$var$create
};
var $19161d474b9e3037$export$2e2bcd8739ae039 = $19161d474b9e3037$var$index;


var $3b1f97522f93db4d$var$config = {
    paths: {
        vs: "https://cdn.jsdelivr.net/npm/monaco-editor@0.43.0/min/vs"
    }
};
var $3b1f97522f93db4d$export$2e2bcd8739ae039 = $3b1f97522f93db4d$var$config;


function $b6f429fa0654bcc8$var$curry(fn) {
    return function curried() {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return args.length >= fn.length ? fn.apply(this, args) : function() {
            for(var _len2 = arguments.length, nextArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)nextArgs[_key2] = arguments[_key2];
            return curried.apply(_this, [].concat(args, nextArgs));
        };
    };
}
var $b6f429fa0654bcc8$export$2e2bcd8739ae039 = $b6f429fa0654bcc8$var$curry;


function $00e61fd901eed1c9$var$isObject(value) {
    return ({}).toString.call(value).includes("Object");
}
var $00e61fd901eed1c9$export$2e2bcd8739ae039 = $00e61fd901eed1c9$var$isObject;


/**
 * validates the configuration object and informs about deprecation
 * @param {Object} config - the configuration object 
 * @return {Object} config - the validated configuration object
 */ function $a495fc24fbe10d55$var$validateConfig(config) {
    if (!config) $a495fc24fbe10d55$export$cc3fdd528b56c4a9("configIsRequired");
    if (!(0, $00e61fd901eed1c9$export$2e2bcd8739ae039)(config)) $a495fc24fbe10d55$export$cc3fdd528b56c4a9("configType");
    if (config.urls) {
        $a495fc24fbe10d55$var$informAboutDeprecation();
        return {
            paths: {
                vs: config.urls.monacoBase
            }
        };
    }
    return config;
}
/**
 * logs deprecation message
 */ function $a495fc24fbe10d55$var$informAboutDeprecation() {
    console.warn($a495fc24fbe10d55$export$d8bd0967cb58683.deprecation);
}
function $a495fc24fbe10d55$var$throwError(errorMessages, type) {
    throw new Error(errorMessages[type] || errorMessages["default"]);
}
var $a495fc24fbe10d55$export$d8bd0967cb58683 = {
    configIsRequired: "the configuration object is required",
    configType: "the configuration object should be an object",
    "default": "an unknown error accured in `@monaco-editor/loader` package",
    deprecation: "Deprecation warning!\n    You are using deprecated way of configuration.\n\n    Instead of using\n      monaco.config({ urls: { monacoBase: '...' } })\n    use\n      monaco.config({ paths: { vs: '...' } })\n\n    For more please check the link https://github.com/suren-atoyan/monaco-loader#config\n  "
};
var $a495fc24fbe10d55$export$cc3fdd528b56c4a9 = (0, $b6f429fa0654bcc8$export$2e2bcd8739ae039)($a495fc24fbe10d55$var$throwError)($a495fc24fbe10d55$export$d8bd0967cb58683);
var $a495fc24fbe10d55$var$validators = {
    config: $a495fc24fbe10d55$var$validateConfig
};
var $a495fc24fbe10d55$export$2e2bcd8739ae039 = $a495fc24fbe10d55$var$validators;


var $e4ecb298bad95481$var$compose = function compose() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(x) {
        return fns.reduceRight(function(y, f) {
            return f(y);
        }, x);
    };
};
var $e4ecb298bad95481$export$2e2bcd8739ae039 = $e4ecb298bad95481$var$compose;



function $09127e48e3a021ef$var$merge(target, source) {
    Object.keys(source).forEach(function(key) {
        if (source[key] instanceof Object) {
            if (target[key]) Object.assign(source[key], $09127e48e3a021ef$var$merge(target[key], source[key]));
        }
    });
    return (0, $a46716400691f84a$export$df72099fd95ee399)((0, $a46716400691f84a$export$df72099fd95ee399)({}, target), source);
}
var $09127e48e3a021ef$export$2e2bcd8739ae039 = $09127e48e3a021ef$var$merge;


// The source (has been changed) is https://github.com/facebook/react/issues/5465#issuecomment-157888325
var $ee7f5941df1ec4d8$export$ef4ebf120f9f6749 = {
    type: "cancelation",
    msg: "operation is manually canceled"
};
function $ee7f5941df1ec4d8$var$makeCancelable(promise) {
    var hasCanceled_ = false;
    var wrappedPromise = new Promise(function(resolve, reject) {
        promise.then(function(val) {
            return hasCanceled_ ? reject($ee7f5941df1ec4d8$export$ef4ebf120f9f6749) : resolve(val);
        });
        promise["catch"](reject);
    });
    return wrappedPromise.cancel = function() {
        return hasCanceled_ = true;
    }, wrappedPromise;
}
var $ee7f5941df1ec4d8$export$2e2bcd8739ae039 = $ee7f5941df1ec4d8$var$makeCancelable;


/** the local state of the module */ var $6c14b8e0d6e956f8$var$_state$create = (0, $19161d474b9e3037$export$2e2bcd8739ae039).create({
    config: (0, $3b1f97522f93db4d$export$2e2bcd8739ae039),
    isInitialized: false,
    resolve: null,
    reject: null,
    monaco: null
}), $6c14b8e0d6e956f8$var$_state$create2 = (0, $a46716400691f84a$export$12b6a547ec390b98)($6c14b8e0d6e956f8$var$_state$create, 2), $6c14b8e0d6e956f8$var$getState = $6c14b8e0d6e956f8$var$_state$create2[0], $6c14b8e0d6e956f8$var$setState = $6c14b8e0d6e956f8$var$_state$create2[1];
/**
 * set the loader configuration
 * @param {Object} config - the configuration object
 */ function $6c14b8e0d6e956f8$var$config(globalConfig) {
    var _validators$config = (0, $a495fc24fbe10d55$export$2e2bcd8739ae039).config(globalConfig), monaco = _validators$config.monaco, config = (0, $a46716400691f84a$export$d8a2083381e8fcb)(_validators$config, [
        "monaco"
    ]);
    $6c14b8e0d6e956f8$var$setState(function(state) {
        return {
            config: (0, $09127e48e3a021ef$export$2e2bcd8739ae039)(state.config, config),
            monaco: monaco
        };
    });
}
/**
 * handles the initialization of the monaco-editor
 * @return {Promise} - returns an instance of monaco (with a cancelable promise)
 */ function $6c14b8e0d6e956f8$var$init() {
    var state = $6c14b8e0d6e956f8$var$getState(function(_ref) {
        var monaco = _ref.monaco, isInitialized = _ref.isInitialized, resolve = _ref.resolve;
        return {
            monaco: monaco,
            isInitialized: isInitialized,
            resolve: resolve
        };
    });
    if (!state.isInitialized) {
        $6c14b8e0d6e956f8$var$setState({
            isInitialized: true
        });
        if (state.monaco) {
            state.resolve(state.monaco);
            return (0, $ee7f5941df1ec4d8$export$2e2bcd8739ae039)($6c14b8e0d6e956f8$var$wrapperPromise);
        }
        if (window.monaco && window.monaco.editor) {
            $6c14b8e0d6e956f8$var$storeMonacoInstance(window.monaco);
            state.resolve(window.monaco);
            return (0, $ee7f5941df1ec4d8$export$2e2bcd8739ae039)($6c14b8e0d6e956f8$var$wrapperPromise);
        }
        (0, $e4ecb298bad95481$export$2e2bcd8739ae039)($6c14b8e0d6e956f8$var$injectScripts, $6c14b8e0d6e956f8$var$getMonacoLoaderScript)($6c14b8e0d6e956f8$var$configureLoader);
    }
    return (0, $ee7f5941df1ec4d8$export$2e2bcd8739ae039)($6c14b8e0d6e956f8$var$wrapperPromise);
}
/**
 * injects provided scripts into the document.body
 * @param {Object} script - an HTML script element
 * @return {Object} - the injected HTML script element
 */ function $6c14b8e0d6e956f8$var$injectScripts(script) {
    return document.body.appendChild(script);
}
/**
 * creates an HTML script element with/without provided src
 * @param {string} [src] - the source path of the script
 * @return {Object} - the created HTML script element
 */ function $6c14b8e0d6e956f8$var$createScript(src) {
    var script = document.createElement("script");
    return src && (script.src = src), script;
}
/**
 * creates an HTML script element with the monaco loader src
 * @return {Object} - the created HTML script element
 */ function $6c14b8e0d6e956f8$var$getMonacoLoaderScript(configureLoader) {
    var state = $6c14b8e0d6e956f8$var$getState(function(_ref2) {
        var config = _ref2.config, reject = _ref2.reject;
        return {
            config: config,
            reject: reject
        };
    });
    var loaderScript = $6c14b8e0d6e956f8$var$createScript("".concat(state.config.paths.vs, "/loader.js"));
    loaderScript.onload = function() {
        return configureLoader();
    };
    loaderScript.onerror = state.reject;
    return loaderScript;
}
/**
 * configures the monaco loader
 */ function $6c14b8e0d6e956f8$var$configureLoader() {
    var state = $6c14b8e0d6e956f8$var$getState(function(_ref3) {
        var config = _ref3.config, resolve = _ref3.resolve, reject = _ref3.reject;
        return {
            config: config,
            resolve: resolve,
            reject: reject
        };
    });
    var require = window.require;
    require.config(state.config);
    require([
        "vs/editor/editor.main"
    ], function(monaco) {
        $6c14b8e0d6e956f8$var$storeMonacoInstance(monaco);
        state.resolve(monaco);
    }, function(error) {
        state.reject(error);
    });
}
/**
 * store monaco instance in local state
 */ function $6c14b8e0d6e956f8$var$storeMonacoInstance(monaco) {
    if (!$6c14b8e0d6e956f8$var$getState().monaco) $6c14b8e0d6e956f8$var$setState({
        monaco: monaco
    });
}
/**
 * internal helper function
 * extracts stored monaco instance
 * @return {Object|null} - the monaco instance
 */ function $6c14b8e0d6e956f8$var$__getMonacoInstance() {
    return $6c14b8e0d6e956f8$var$getState(function(_ref4) {
        var monaco = _ref4.monaco;
        return monaco;
    });
}
var $6c14b8e0d6e956f8$var$wrapperPromise = new Promise(function(resolve, reject) {
    return $6c14b8e0d6e956f8$var$setState({
        resolve: resolve,
        reject: reject
    });
});
var $6c14b8e0d6e956f8$var$loader = {
    config: $6c14b8e0d6e956f8$var$config,
    init: $6c14b8e0d6e956f8$var$init,
    __getMonacoInstance: $6c14b8e0d6e956f8$var$__getMonacoInstance
};
var $6c14b8e0d6e956f8$export$2e2bcd8739ae039 = $6c14b8e0d6e956f8$var$loader;





var $jC8Vy = parcelRequire("jC8Vy");
var $f6fc09178920afde$var$le = {
    wrapper: {
        display: "flex",
        position: "relative",
        textAlign: "initial"
    },
    fullWidth: {
        width: "100%"
    },
    hide: {
        display: "none"
    }
}, $f6fc09178920afde$var$v = $f6fc09178920afde$var$le;
var $f6fc09178920afde$var$ae = {
    container: {
        display: "flex",
        height: "100%",
        width: "100%",
        justifyContent: "center",
        alignItems: "center"
    }
}, $f6fc09178920afde$var$Y = $f6fc09178920afde$var$ae;
function $f6fc09178920afde$var$Me({ children: e }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        style: $f6fc09178920afde$var$Y.container
    }, e);
}
var $f6fc09178920afde$var$Z = $f6fc09178920afde$var$Me;
var $f6fc09178920afde$var$$ = $f6fc09178920afde$var$Z;
function $f6fc09178920afde$var$Ee({ width: e, height: r, isEditorReady: n, loading: t, _ref: a, className: m, wrapperProps: E }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("section", {
        style: {
            ...$f6fc09178920afde$var$v.wrapper,
            width: e,
            height: r
        },
        ...E
    }, !n && (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement($f6fc09178920afde$var$$, null, t), (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement("div", {
        ref: a,
        style: {
            ...$f6fc09178920afde$var$v.fullWidth,
            ...!n && $f6fc09178920afde$var$v.hide
        },
        className: m
    }));
}
var $f6fc09178920afde$var$ee = $f6fc09178920afde$var$Ee;
var $f6fc09178920afde$var$H = (0, $jC8Vy.memo)($f6fc09178920afde$var$ee);
function $f6fc09178920afde$var$Ce(e) {
    (0, $jC8Vy.useEffect)(e, []);
}
var $f6fc09178920afde$var$k = $f6fc09178920afde$var$Ce;
function $f6fc09178920afde$var$he(e, r, n = !0) {
    let t = (0, $jC8Vy.useRef)(!0);
    (0, $jC8Vy.useEffect)(t.current || !n ? ()=>{
        t.current = !1;
    } : e, r);
}
var $f6fc09178920afde$var$l = $f6fc09178920afde$var$he;
function $f6fc09178920afde$var$D() {}
function $f6fc09178920afde$var$h(e, r, n, t) {
    return $f6fc09178920afde$var$De(e, t) || $f6fc09178920afde$var$be(e, r, n, t);
}
function $f6fc09178920afde$var$De(e, r) {
    return e.editor.getModel($f6fc09178920afde$var$te(e, r));
}
function $f6fc09178920afde$var$be(e, r, n, t) {
    return e.editor.createModel(r, n, t ? $f6fc09178920afde$var$te(e, t) : void 0);
}
function $f6fc09178920afde$var$te(e, r) {
    return e.Uri.parse(r);
}
function $f6fc09178920afde$var$Oe({ original: e, modified: r, language: n, originalLanguage: t, modifiedLanguage: a, originalModelPath: m, modifiedModelPath: E, keepCurrentOriginalModel: g = !1, keepCurrentModifiedModel: N = !1, theme: x = "light", loading: P = "Loading...", options: y = {}, height: V = "100%", width: z = "100%", className: F, wrapperProps: j = {}, beforeMount: A = $f6fc09178920afde$var$D, onMount: q = $f6fc09178920afde$var$D }) {
    let [M, O] = (0, $jC8Vy.useState)(!1), [T, s] = (0, $jC8Vy.useState)(!0), u = (0, $jC8Vy.useRef)(null), c = (0, $jC8Vy.useRef)(null), w = (0, $jC8Vy.useRef)(null), d = (0, $jC8Vy.useRef)(q), o = (0, $jC8Vy.useRef)(A), b = (0, $jC8Vy.useRef)(!1);
    $f6fc09178920afde$var$k(()=>{
        let i = (0, $6c14b8e0d6e956f8$export$2e2bcd8739ae039).init();
        return i.then((f)=>(c.current = f) && s(!1)).catch((f)=>f?.type !== "cancelation" && console.error("Monaco initialization: error:", f)), ()=>u.current ? I() : i.cancel();
    }), $f6fc09178920afde$var$l(()=>{
        if (u.current && c.current) {
            let i = u.current.getOriginalEditor(), f = $f6fc09178920afde$var$h(c.current, e || "", t || n || "text", m || "");
            f !== i.getModel() && i.setModel(f);
        }
    }, [
        m
    ], M), $f6fc09178920afde$var$l(()=>{
        if (u.current && c.current) {
            let i = u.current.getModifiedEditor(), f = $f6fc09178920afde$var$h(c.current, r || "", a || n || "text", E || "");
            f !== i.getModel() && i.setModel(f);
        }
    }, [
        E
    ], M), $f6fc09178920afde$var$l(()=>{
        let i = u.current.getModifiedEditor();
        i.getOption(c.current.editor.EditorOption.readOnly) ? i.setValue(r || "") : r !== i.getValue() && (i.executeEdits("", [
            {
                range: i.getModel().getFullModelRange(),
                text: r || "",
                forceMoveMarkers: !0
            }
        ]), i.pushUndoStop());
    }, [
        r
    ], M), $f6fc09178920afde$var$l(()=>{
        u.current?.getModel()?.original.setValue(e || "");
    }, [
        e
    ], M), $f6fc09178920afde$var$l(()=>{
        let { original: i, modified: f } = u.current.getModel();
        c.current.editor.setModelLanguage(i, t || n || "text"), c.current.editor.setModelLanguage(f, a || n || "text");
    }, [
        n,
        t,
        a
    ], M), $f6fc09178920afde$var$l(()=>{
        c.current?.editor.setTheme(x);
    }, [
        x
    ], M), $f6fc09178920afde$var$l(()=>{
        u.current?.updateOptions(y);
    }, [
        y
    ], M);
    let L = (0, $jC8Vy.useCallback)(()=>{
        if (!c.current) return;
        o.current(c.current);
        let i = $f6fc09178920afde$var$h(c.current, e || "", t || n || "text", m || ""), f = $f6fc09178920afde$var$h(c.current, r || "", a || n || "text", E || "");
        u.current?.setModel({
            original: i,
            modified: f
        });
    }, [
        n,
        r,
        a,
        e,
        t,
        m,
        E
    ]), U = (0, $jC8Vy.useCallback)(()=>{
        !b.current && w.current && (u.current = c.current.editor.createDiffEditor(w.current, {
            automaticLayout: !0,
            ...y
        }), L(), c.current?.editor.setTheme(x), O(!0), b.current = !0);
    }, [
        y,
        x,
        L
    ]);
    (0, $jC8Vy.useEffect)(()=>{
        M && d.current(u.current, c.current);
    }, [
        M
    ]), (0, $jC8Vy.useEffect)(()=>{
        !T && !M && U();
    }, [
        T,
        M,
        U
    ]);
    function I() {
        let i = u.current?.getModel();
        g || i?.original?.dispose(), N || i?.modified?.dispose(), u.current?.dispose();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement($f6fc09178920afde$var$H, {
        width: z,
        height: V,
        isEditorReady: M,
        loading: P,
        _ref: w,
        className: F,
        wrapperProps: j
    });
}
var $f6fc09178920afde$var$ie = $f6fc09178920afde$var$Oe;
var $f6fc09178920afde$export$f95cfa31b5a0bc91 = (0, $jC8Vy.memo)($f6fc09178920afde$var$ie);
function $f6fc09178920afde$var$Pe() {
    let [e, r] = (0, $jC8Vy.useState)((0, $6c14b8e0d6e956f8$export$2e2bcd8739ae039).__getMonacoInstance());
    return $f6fc09178920afde$var$k(()=>{
        let n;
        return e || (n = (0, $6c14b8e0d6e956f8$export$2e2bcd8739ae039).init(), n.then((t)=>{
            r(t);
        })), ()=>n?.cancel();
    }), e;
}
var $f6fc09178920afde$export$7c29dcfb1e21cfdd = $f6fc09178920afde$var$Pe;
function $f6fc09178920afde$var$He(e) {
    let r = (0, $jC8Vy.useRef)();
    return (0, $jC8Vy.useEffect)(()=>{
        r.current = e;
    }, [
        e
    ]), r.current;
}
var $f6fc09178920afde$var$se = $f6fc09178920afde$var$He;
var $f6fc09178920afde$var$_ = new Map;
function $f6fc09178920afde$var$Ve({ defaultValue: e, defaultLanguage: r, defaultPath: n, value: t, language: a, path: m, theme: E = "light", line: g, loading: N = "Loading...", options: x = {}, overrideServices: P = {}, saveViewState: y = !0, keepCurrentModel: V = !1, width: z = "100%", height: F = "100%", className: j, wrapperProps: A = {}, beforeMount: q = $f6fc09178920afde$var$D, onMount: M = $f6fc09178920afde$var$D, onChange: O, onValidate: T = $f6fc09178920afde$var$D }) {
    let [s, u] = (0, $jC8Vy.useState)(!1), [c, w] = (0, $jC8Vy.useState)(!0), d = (0, $jC8Vy.useRef)(null), o = (0, $jC8Vy.useRef)(null), b = (0, $jC8Vy.useRef)(null), L = (0, $jC8Vy.useRef)(M), U = (0, $jC8Vy.useRef)(q), I = (0, $jC8Vy.useRef)(), i = (0, $jC8Vy.useRef)(t), f = $f6fc09178920afde$var$se(m), Q = (0, $jC8Vy.useRef)(!1), B = (0, $jC8Vy.useRef)(!1);
    $f6fc09178920afde$var$k(()=>{
        let p = (0, $6c14b8e0d6e956f8$export$2e2bcd8739ae039).init();
        return p.then((R)=>(d.current = R) && w(!1)).catch((R)=>R?.type !== "cancelation" && console.error("Monaco initialization: error:", R)), ()=>o.current ? pe() : p.cancel();
    }), $f6fc09178920afde$var$l(()=>{
        let p = $f6fc09178920afde$var$h(d.current, e || t || "", r || a || "", m || n || "");
        p !== o.current?.getModel() && (y && $f6fc09178920afde$var$_.set(f, o.current?.saveViewState()), o.current?.setModel(p), y && o.current?.restoreViewState($f6fc09178920afde$var$_.get(m)));
    }, [
        m
    ], s), $f6fc09178920afde$var$l(()=>{
        o.current?.updateOptions(x);
    }, [
        x
    ], s), $f6fc09178920afde$var$l(()=>{
        !o.current || t === void 0 || (o.current.getOption(d.current.editor.EditorOption.readOnly) ? o.current.setValue(t) : t !== o.current.getValue() && (B.current = !0, o.current.executeEdits("", [
            {
                range: o.current.getModel().getFullModelRange(),
                text: t,
                forceMoveMarkers: !0
            }
        ]), o.current.pushUndoStop(), B.current = !1));
    }, [
        t
    ], s), $f6fc09178920afde$var$l(()=>{
        let p = o.current?.getModel();
        p && a && d.current?.editor.setModelLanguage(p, a);
    }, [
        a
    ], s), $f6fc09178920afde$var$l(()=>{
        g !== void 0 && o.current?.revealLine(g);
    }, [
        g
    ], s), $f6fc09178920afde$var$l(()=>{
        d.current?.editor.setTheme(E);
    }, [
        E
    ], s);
    let X = (0, $jC8Vy.useCallback)(()=>{
        if (!(!b.current || !d.current) && !Q.current) {
            U.current(d.current);
            let p = m || n, R = $f6fc09178920afde$var$h(d.current, t || e || "", r || a || "", p || "");
            o.current = d.current?.editor.create(b.current, {
                model: R,
                automaticLayout: !0,
                ...x
            }, P), y && o.current.restoreViewState($f6fc09178920afde$var$_.get(p)), d.current.editor.setTheme(E), g !== void 0 && o.current.revealLine(g), u(!0), Q.current = !0;
        }
    }, [
        e,
        r,
        n,
        t,
        a,
        m,
        x,
        P,
        y,
        E,
        g
    ]);
    (0, $jC8Vy.useEffect)(()=>{
        s && L.current(o.current, d.current);
    }, [
        s
    ]), (0, $jC8Vy.useEffect)(()=>{
        !c && !s && X();
    }, [
        c,
        s,
        X
    ]), i.current = t, (0, $jC8Vy.useEffect)(()=>{
        s && O && (I.current?.dispose(), I.current = o.current?.onDidChangeModelContent((p)=>{
            B.current || O(o.current.getValue(), p);
        }));
    }, [
        s,
        O
    ]), (0, $jC8Vy.useEffect)(()=>{
        if (s) {
            let p = d.current.editor.onDidChangeMarkers((R)=>{
                let G = o.current.getModel()?.uri;
                if (G && R.find((J)=>J.path === G.path)) {
                    let J = d.current.editor.getModelMarkers({
                        resource: G
                    });
                    T?.(J);
                }
            });
            return ()=>{
                p?.dispose();
            };
        }
        return ()=>{};
    }, [
        s,
        T
    ]);
    function pe() {
        I.current?.dispose(), V ? y && $f6fc09178920afde$var$_.set(m, o.current.saveViewState()) : o.current.getModel()?.dispose(), o.current.dispose();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($jC8Vy))).createElement($f6fc09178920afde$var$H, {
        width: z,
        height: F,
        isEditorReady: s,
        loading: N,
        _ref: b,
        className: j,
        wrapperProps: A
    });
}
var $f6fc09178920afde$var$fe = $f6fc09178920afde$var$Ve;
var $f6fc09178920afde$export$7cda8d932e2f33c0 = (0, $jC8Vy.memo)($f6fc09178920afde$var$fe);
var $f6fc09178920afde$export$2e2bcd8739ae039 = $f6fc09178920afde$export$7cda8d932e2f33c0;



var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $cw2No = parcelRequire("cw2No");

var $jheqv = parcelRequire("jheqv");

var $bnkR4 = parcelRequire("bnkR4");

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $fdd1e61b965b5329$var$SvgRedo = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 17,
        height: 17,
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M14.5 7.833c-.4 0-.667.267-.667.667 0 1.934-1 3.667-2.666 4.6-2.534 1.467-5.8.6-7.267-1.933-1.467-2.534-.6-5.8 1.933-7.267a5.338 5.338 0 0 1 6.534.933h-1.6c-.4 0-.667.267-.667.667s.267.667.667.667h3c.4 0 .666-.267.666-.667v-3c0-.4-.266-.667-.666-.667S13.1 2.1 13.1 2.5v1.2c-1.267-1.2-2.867-1.867-4.6-1.867-3.667 0-6.667 3-6.667 6.667s3 6.667 6.667 6.667 6.667-3 6.667-6.667c0-.4-.267-.667-.667-.667Z",
            fill: "currentColor"
        })
    });
var $fdd1e61b965b5329$export$2e2bcd8739ae039 = $fdd1e61b965b5329$var$SvgRedo;



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $75SRw = parcelRequire("75SRw");
parcelRequire("fIF1D");
var $16GE9 = parcelRequire("16GE9");
function $be0246e06ea73fdf$var$ActionButton({ actionTip: actionTip, actionSuccessTip: actionSuccessTip, actionLoadingTip: actionLoadingTip, className: className, icon: icon, onClick: onClick }) {
    const [tipContent, setTipContent] = (0, $jC8Vy.useState)(actionTip);
    const iconButtonRef = (0, $jC8Vy.useRef)(null);
    (0, $jC8Vy.useEffect)(()=>{
        const mouseLeaveHandler = ()=>{
            setTipContent(actionTip);
        };
        iconButtonRef.current?.addEventListener("mouseleave", mouseLeaveHandler);
        return ()=>{
            // eslint-disable-next-line react-hooks/exhaustive-deps -- iconButtonRef.current is not a dependency
            iconButtonRef.current?.removeEventListener("mouseleave", mouseLeaveHandler);
        };
    });
    const handleClick = (0, $jC8Vy.useCallback)(async ()=>{
        iconButtonRef.current?.blur();
        if (actionLoadingTip) setTipContent(actionLoadingTip);
        await onClick();
        setTipContent(actionSuccessTip);
    }, [
        actionLoadingTip,
        actionSuccessTip,
        onClick
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $16GE9.default), {
            content: tipContent,
            isSuccessful: tipContent === actionSuccessTip,
            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                ref: iconButtonRef,
                size: "small",
                onClick: handleClick,
                children: icon
            })
        })
    });
}
var $be0246e06ea73fdf$export$2e2bcd8739ae039 = $be0246e06ea73fdf$var$ActionButton;


var $d2464ee94c510826$export$a75c7ea49564edd7;
var $d2464ee94c510826$export$bfd64c937657f93a;
var $d2464ee94c510826$export$4a6dd88bada4e7d2;
$d2464ee94c510826$export$a75c7ea49564edd7 = `eljKkG_actionButton`;
$d2464ee94c510826$export$bfd64c937657f93a = `eljKkG_rotating`;
$d2464ee94c510826$export$4a6dd88bada4e7d2 = `eljKkG_shimmer`;


function $d3f478072b52bed7$var$CodeRestoreButton({ className: className, onClick: onClick }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $be0246e06ea73fdf$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))(className, $d2464ee94c510826$export$a75c7ea49564edd7),
        actionTip: t("jwt_claims.restore"),
        actionSuccessTip: t("jwt_claims.restored"),
        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fdd1e61b965b5329$export$2e2bcd8739ae039), {}),
        onClick: onClick
    });
}
var $d3f478072b52bed7$export$2e2bcd8739ae039 = $d3f478072b52bed7$var$CodeRestoreButton;



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $HHYyb = parcelRequire("HHYyb");

var $75SRw = parcelRequire("75SRw");
var $0cf76cbff4886834$export$a5f98448b9315739;
var $0cf76cbff4886834$export$c247fd01dee748f7;
var $0cf76cbff4886834$export$c76a7e5fde7d33b0;
var $0cf76cbff4886834$export$a3bc9b8ed74fc;
var $0cf76cbff4886834$export$bfd64c937657f93a;
var $0cf76cbff4886834$export$4a6dd88bada4e7d2;
$0cf76cbff4886834$export$a5f98448b9315739 = `Yd0mUG_dashboard`;
$0cf76cbff4886834$export$c247fd01dee748f7 = `Yd0mUG_dashboardContent`;
$0cf76cbff4886834$export$c76a7e5fde7d33b0 = `Yd0mUG_dashboardHeader`;
$0cf76cbff4886834$export$a3bc9b8ed74fc = `Yd0mUG_error`;
$0cf76cbff4886834$export$bfd64c937657f93a = `Yd0mUG_rotating`;
$0cf76cbff4886834$export$4a6dd88bada4e7d2 = `Yd0mUG_shimmer`;


function $3aabcd867e4c31c6$var$Dashboard({ title: title, content: content, className: className, onClose: onClose }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($0cf76cbff4886834$export$a5f98448b9315739, className),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $0cf76cbff4886834$export$c76a7e5fde7d33b0,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                        onClick: onClose,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $HHYyb.default), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $0cf76cbff4886834$export$c247fd01dee748f7,
                children: content
            })
        ]
    });
}
var $3aabcd867e4c31c6$export$2e2bcd8739ae039 = $3aabcd867e4c31c6$var$Dashboard;


const $e8e0523204c09c74$export$94547feca3fe1daf = {
    base: "vs-dark",
    inherit: true,
    rules: [],
    colors: {
        "editor.background": "#090613"
    }
};
const $e8e0523204c09c74$export$fc5764685f505cf1 = {
    ...$e8e0523204c09c74$export$94547feca3fe1daf,
    colors: {
        "editor.background": "#181133"
    }
};
const $e8e0523204c09c74$export$ba43bf67f3d48107 = {
    minimap: {
        enabled: false
    },
    renderLineHighlight: "none",
    fontFamily: "Roboto Mono, monospace",
    fontSize: 14,
    automaticLayout: true,
    tabSize: 2,
    scrollBeyondLastLine: false
};


var $1c8bf422f117cae0$export$b6fb1741c7f64881;
var $1c8bf422f117cae0$export$89da14300d534261;
var $1c8bf422f117cae0$export$d89b6f4d34274146;
var $1c8bf422f117cae0$export$dc15ead813a0bf7e;
var $1c8bf422f117cae0$export$3117ecc0d04bc057;
var $1c8bf422f117cae0$export$60bb6c1f29b8a8cc;
var $1c8bf422f117cae0$export$69321d0675a735cd;
var $1c8bf422f117cae0$export$bfd64c937657f93a;
var $1c8bf422f117cae0$export$4a6dd88bada4e7d2;
var $1c8bf422f117cae0$export$62d58b1c91e8e902;
var $1c8bf422f117cae0$export$ef65521c1db5cbae;
var $1c8bf422f117cae0$export$78257405ed7446e8;
$1c8bf422f117cae0$export$b6fb1741c7f64881 = `_9T2S7q_actionButtons`;
$1c8bf422f117cae0$export$89da14300d534261 = `_9T2S7q_active`;
$1c8bf422f117cae0$export$d89b6f4d34274146 = `_9T2S7q_codeEditor`;
$1c8bf422f117cae0$export$dc15ead813a0bf7e = `_9T2S7q_dashboardOpen`;
$1c8bf422f117cae0$export$3117ecc0d04bc057 = `_9T2S7q_editorContainer`;
$1c8bf422f117cae0$export$60bb6c1f29b8a8cc = `_9T2S7q_iconButton`;
$1c8bf422f117cae0$export$69321d0675a735cd = `_9T2S7q_resultPanel`;
$1c8bf422f117cae0$export$bfd64c937657f93a = `_9T2S7q_rotating`;
$1c8bf422f117cae0$export$4a6dd88bada4e7d2 = `_9T2S7q_shimmer`;
$1c8bf422f117cae0$export$62d58b1c91e8e902 = `_9T2S7q_tab`;
$1c8bf422f117cae0$export$ef65521c1db5cbae = `_9T2S7q_tabButton`;
$1c8bf422f117cae0$export$78257405ed7446e8 = `_9T2S7q_tabList`;



var $jC8Vy = parcelRequire("jC8Vy");
// Recalculate the height of the editor when the container size changes
// This is to avoid the code editor's height shaking when the content is updated.
// @see {@link https://github.com/react-monaco-editor/react-monaco-editor/issues/391}
const $4e0e9bcbf916ad80$var$useEditorHeight = ()=>{
    const containerRef = (0, $jC8Vy.useRef)(null);
    const [editorHeight, setEditorHeight] = (0, $jC8Vy.useState)("100%");
    const safeArea = 16;
    (0, $jC8Vy.useLayoutEffect)(()=>{
        const handleResize = ()=>{
            if (containerRef.current) setEditorHeight(containerRef.current.clientHeight - safeArea);
        };
        handleResize();
        const resizeObserver = new ResizeObserver(handleResize);
        if (containerRef.current) resizeObserver.observe(containerRef.current);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, []);
    return {
        containerRef: containerRef,
        editorHeight: editorHeight
    };
};
var $4e0e9bcbf916ad80$export$2e2bcd8739ae039 = $4e0e9bcbf916ad80$var$useEditorHeight;


/**
 * Monaco code editor component.
 * @param {Props} prop
 * @param {string} [prop.className] - The class name of the component.
 * @param {ActionButtonType[]} prop.enabledActions - The enabled action buttons, available values are 'clear', 'restore', 'copy'.
 * @param {ModelSettings[]} prop.models - The static model settings (all tabs) for the code editor.
 * @param {string} prop.activeModelName - The active model name.
 * @param {(name: string) => void} prop.setActiveModel - The callback function to set the active model. Used to switch between tabs.
 * @param {string} prop.value - The value of the code editor for the current active model.
 * @param {(value: string | undefined) => void} prop.onChange - The callback function to handle the value change of the code editor.
 * @param {string} [prop.environmentVariablesDefinition] - The environment variables type definition for the script section.
 * @param {ReactNode} [actionButtons] - Additional action buttons shown on the header
 * @param {DashboardProps} [dashboard] - The dashboard component shown at the bottom of the editor.
 *
 * @returns
 */ function $8ddbadc498f4c1c5$var$MonacoCodeEditor({ className: className, enabledActions: enabledActions = [
    "copy"
], models: models, activeModelName: activeModelName, value: value, environmentVariablesDefinition: environmentVariablesDefinition, setActiveModel: setActiveModel, onChange: onChange, onMountHandler: onMountHandler, actionButtons: actionButtons, dashboard: dashboard }) {
    const monaco = (0, $f6fc09178920afde$export$7c29dcfb1e21cfdd)();
    const editorRef = (0, $jC8Vy.useRef)(null);
    const theme = (0, $jheqv.default)();
    const activeModel = (0, $jC8Vy.useMemo)(()=>activeModelName && models.find((model)=>model.name === activeModelName), [
        activeModelName,
        models
    ]);
    const isMultiModals = (0, $jC8Vy.useMemo)(()=>models.length > 1, [
        models
    ]);
    // Get the container ref and the editor height
    const { containerRef: containerRef, editorHeight: editorHeight } = (0, $4e0e9bcbf916ad80$export$2e2bcd8739ae039)();
    // Handle editor extraLibs and language compile settings
    (0, $jC8Vy.useEffect)(()=>{
        // Monaco will be ready after the editor is mounted, useEffect will be called after the monaco is ready
        if (!monaco || !activeModel) return;
        // Set the global declarations for the active model
        // @see {@link https://microsoft.github.io/monaco-editor/typedoc/interfaces/languages.typescript.LanguageServiceDefaults.html#setExtraLibs}
        if (activeModel.extraLibs) monaco.languages.typescript.typescriptDefaults.setExtraLibs(activeModel.extraLibs);
        // Set the environment variables type definition for the active model
        if (environmentVariablesDefinition) monaco.languages.typescript.typescriptDefaults.addExtraLib(environmentVariablesDefinition, "environmentVariables.d.ts");
        if (activeModel.language === "typescript") {
            monaco.languages.typescript.javascriptDefaults.setDiagnosticsOptions({
                noSemanticValidation: false,
                noSyntaxValidation: false
            });
            // Set the typescript compiler options
            monaco.languages.typescript.typescriptDefaults.setCompilerOptions({
                allowNonTsExtensions: true,
                strictNullChecks: true,
                allowJs: true,
                checkJs: true
            });
        }
    }, [
        activeModel,
        monaco,
        environmentVariablesDefinition
    ]);
    // Handle the editor theme settings
    (0, $jC8Vy.useEffect)(()=>{
        // Monaco will be ready after the editor is mounted, useEffect will be called after the monaco is ready
        if (!monaco) return;
        const editorTheme = theme === (0, $5HVJe.Theme).Light ? (0, $e8e0523204c09c74$export$fc5764685f505cf1) : (0, $e8e0523204c09c74$export$94547feca3fe1daf);
        monaco.editor.defineTheme("logto-dark", editorTheme);
    }, [
        monaco,
        theme
    ]);
    const handleEditorDidMount = (0, $jC8Vy.useCallback)((editor)=>{
        // eslint-disable-next-line @silverhand/fp/no-mutation
        editorRef.current = editor;
        onMountHandler?.(editor);
    }, [
        onMountHandler
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))(className, $1c8bf422f117cae0$export$d89b6f4d34274146),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("header", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $1c8bf422f117cae0$export$78257405ed7446e8,
                        children: models.map(({ name: name, title: title, icon: icon })=>/*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($1c8bf422f117cae0$export$62d58b1c91e8e902, isMultiModals && $1c8bf422f117cae0$export$ef65521c1db5cbae, name === activeModelName && $1c8bf422f117cae0$export$89da14300d534261),
                                ...isMultiModals && {
                                    role: "button",
                                    tabIndex: 0,
                                    onClick: ()=>{
                                        setActiveModel?.(name);
                                    },
                                    onKeyDown: (0, $bnkR4.onKeyDownHandler)(()=>{
                                        setActiveModel?.(name);
                                    })
                                },
                                children: [
                                    icon,
                                    title
                                ]
                            }, name))
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $1c8bf422f117cae0$export$b6fb1741c7f64881,
                        children: [
                            enabledActions.includes("restore") && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $d3f478072b52bed7$export$2e2bcd8739ae039), {
                                className: $1c8bf422f117cae0$export$60bb6c1f29b8a8cc,
                                onClick: ()=>{
                                    if (activeModel && value !== activeModel.defaultValue) onChange?.(activeModel.defaultValue);
                                }
                            }),
                            enabledActions.includes("copy") && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
                                variant: "icon",
                                value: editorRef.current?.getValue() ?? "",
                                className: $1c8bf422f117cae0$export$60bb6c1f29b8a8cc
                            }),
                            actionButtons
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                ref: containerRef,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($1c8bf422f117cae0$export$3117ecc0d04bc057, dashboard && $1c8bf422f117cae0$export$dc15ead813a0bf7e),
                children: activeModel && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f6fc09178920afde$export$7cda8d932e2f33c0), {
                    height: editorHeight,
                    language: activeModel.language,
                    path: activeModel.name,
                    theme: "logto-dark",
                    options: {
                        ...(0, $e8e0523204c09c74$export$ba43bf67f3d48107),
                        ...activeModel.options
                    },
                    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- empty string is falsy
                    value: value || activeModel.defaultValue,
                    onMount: handleEditorDidMount,
                    onChange: onChange
                })
            }),
            dashboard && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3aabcd867e4c31c6$export$2e2bcd8739ae039), {
                ...dashboard,
                className: $1c8bf422f117cae0$export$69321d0675a735cd
            })
        ]
    });
}
var $8ddbadc498f4c1c5$export$2e2bcd8739ae039 = $8ddbadc498f4c1c5$var$MonacoCodeEditor;





var $C7mD2 = parcelRequire("C7mD2");
var $5b66434c503dab96$export$a3bc9b8ed74fc;
var $5b66434c503dab96$export$bfd64c937657f93a;
var $5b66434c503dab96$export$4a6dd88bada4e7d2;
$5b66434c503dab96$export$a3bc9b8ed74fc = `wylMlq_error`;
$5b66434c503dab96$export$bfd64c937657f93a = `wylMlq_rotating`;
$5b66434c503dab96$export$4a6dd88bada4e7d2 = `wylMlq_shimmer`;


function $e56697db22f5a13f$var$ErrorContent({ testResult: testResult }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        children: [
            testResult.error && /*#__PURE__*/ (0, $C7mD2.jsxs)("pre", {
                className: $5b66434c503dab96$export$a3bc9b8ed74fc,
                children: [
                    "Error: \n",
                    testResult.error
                ]
            }),
            testResult.payload && /*#__PURE__*/ (0, $C7mD2.jsxs)("pre", {
                children: [
                    "Extra JWT claims: \n",
                    testResult.payload
                ]
            })
        ]
    });
}
var $e56697db22f5a13f$export$2e2bcd8739ae039 = $e56697db22f5a13f$var$ErrorContent;


var $81124103472bee15$export$d89b6f4d34274146;
var $81124103472bee15$export$53fcb65b2bec690f;
var $81124103472bee15$export$bfd64c937657f93a;
var $81124103472bee15$export$8cebe4c64c6c7c0f;
var $81124103472bee15$export$4a6dd88bada4e7d2;
$81124103472bee15$export$d89b6f4d34274146 = `_7vSKpW_codeEditor`;
$81124103472bee15$export$53fcb65b2bec690f = `_7vSKpW_fixHeightWrapper`;
$81124103472bee15$export$bfd64c937657f93a = `_7vSKpW_rotating`;
$81124103472bee15$export$8cebe4c64c6c7c0f = `_7vSKpW_scriptSection`;
$81124103472bee15$export$4a6dd88bada4e7d2 = `_7vSKpW_shimmer`;



var $5cXXM = parcelRequire("5cXXM");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");

var $c3dK3 = parcelRequire("c3dK3");

var $7VnwS = parcelRequire("7VnwS");

const $abcb44e6205731e6$var$testEndpointPath = "api/configs/jwt-customizer/test";
const $abcb44e6205731e6$var$jwtCustomizerGeneralErrorCode = "jwt_customizer.general";
const $abcb44e6205731e6$var$apiInvalidInputErrorCode = "guard.invalid_input";
const $abcb44e6205731e6$var$useTestHandler = ()=>{
    const [testResult, setTestResult] = (0, $jC8Vy.useState)();
    const [isLoading, setIsLoading] = (0, $jC8Vy.useState)(false);
    const { getValues: getValues } = (0, $codQP.useFormContext)();
    const api = (0, $7VnwS.default)({
        hideErrorToast: true
    });
    const onTestHandler = (0, $jC8Vy.useCallback)(async ()=>{
        const payload = getValues();
        setIsLoading(true);
        const result = await api.post($abcb44e6205731e6$var$testEndpointPath, {
            json: (0, $42f2b6b98e4ee585$export$64150fac4e9f6fb3)(payload)
        }).json().catch(async (error)=>{
            if (error instanceof (0, $5cXXM.HTTPError)) {
                const { response: response } = error;
                const metadata = await response.clone().json();
                // Get error message from cloud connection client.
                if (metadata.code === $abcb44e6205731e6$var$jwtCustomizerGeneralErrorCode) {
                    const result = (0, $c3dK3.z).object({
                        message: (0, $c3dK3.z).string()
                    }).safeParse(metadata.data);
                    if (result.success) {
                        setTestResult({
                            error: result.data.message
                        });
                        return;
                    }
                }
                /**
           * Get error message when the API request violates the request guard.
           * Find details on the implementation of:
           * 1. `RequestError`
           * 2. `koaGuard`
           */ if (metadata.code === $abcb44e6205731e6$var$apiInvalidInputErrorCode) {
                    const result = (0, $c3dK3.z).string().safeParse(metadata.details);
                    if (result.success) {
                        setTestResult({
                            error: result.data
                        });
                        return;
                    }
                }
            }
            setTestResult({
                error: error instanceof Error ? error.message : String(error)
            });
        }).finally(()=>{
            setIsLoading(false);
        });
        if (result) setTestResult({
            payload: JSON.stringify(result, null, 2)
        });
    }, [
        api,
        getValues
    ]);
    return {
        testResult: testResult,
        isLoading: isLoading,
        onTestHandler: onTestHandler,
        setTestResult: setTestResult
    };
};
var $abcb44e6205731e6$export$2e2bcd8739ae039 = $abcb44e6205731e6$var$useTestHandler;


function $ad07e9af9fa9eba2$var$ScriptSection() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { watch: watch, control: control } = (0, $codQP.useFormContext)();
    const tokenType = watch("tokenType");
    // Need to use useWatch hook to subscribe the mutation of the environmentVariables field
    // Otherwise, the default watch function's return value won't mutate when the environmentVariables field changes
    const envVariables = (0, $codQP.useWatch)({
        control: control,
        name: "environmentVariables"
    });
    const environmentVariablesTypeDefinition = (0, $jC8Vy.useMemo)(()=>(0, $cd1b3f507bbd071b$export$a712d55055a8329b)(envVariables), [
        envVariables
    ]);
    // Get the active model based on the token type
    const activeModel = (0, $jC8Vy.useMemo)(()=>tokenType === (0, $6NioG.LogtoJwtTokenKeyType).AccessToken ? (0, $6010cf9dfb34da69$export$b7c0c8726c797329) : (0, $6010cf9dfb34da69$export$f332c44a3c6fb9f9), [
        tokenType
    ]);
    // Set the Monaco editor loaded state to true when the editor is mounted
    const { setIsMonacoLoaded: setIsMonacoLoaded } = (0, $jC8Vy.useContext)((0, $ab3b3c4ca6da4bbe$export$e174976f1470e250));
    const onMountHandler = (0, $jC8Vy.useCallback)(()=>{
        setIsMonacoLoaded(true);
    }, [
        setIsMonacoLoaded
    ]);
    // Test handler
    const { onTestHandler: onTestHandler, setTestResult: setTestResult, isLoading: isLoading, testResult: testResult } = (0, $abcb44e6205731e6$export$2e2bcd8739ae039)();
    const dashBoardProps = (0, $jC8Vy.useMemo)(()=>{
        if (!testResult) return;
        return {
            title: t("jwt_claims.tester.result_title"),
            content: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e56697db22f5a13f$export$2e2bcd8739ae039), {
                testResult: testResult
            }),
            onClose: ()=>{
                setTestResult(undefined);
            }
        };
    }, [
        setTestResult,
        t,
        testResult
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: $81124103472bee15$export$8cebe4c64c6c7c0f,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
            className: $81124103472bee15$export$53fcb65b2bec690f,
            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                control: control,
                name: "script",
                render: ({ field: { onChange: onChange, value: value }, formState: { defaultValues: defaultValues } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $8ddbadc498f4c1c5$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($81124103472bee15$export$d89b6f4d34274146),
                        enabledActions: [
                            "restore",
                            "copy"
                        ],
                        models: [
                            activeModel
                        ],
                        activeModelName: activeModel.name,
                        value: value,
                        environmentVariablesDefinition: environmentVariablesTypeDefinition,
                        actionButtons: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                            icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $d728f06a1d8109a7$export$2e2bcd8739ae039), {}),
                            size: "small",
                            title: "jwt_claims.tester.run_button",
                            type: "primary",
                            isLoading: isLoading,
                            onClick: onTestHandler
                        }),
                        dashboard: dashBoardProps,
                        onChange: (newValue)=>{
                            // If the value is the same as the default code and the original form script value is undefined, reset the value to undefined as well
                            if (newValue === activeModel.defaultValue && !defaultValues?.script) {
                                onChange("");
                                return;
                            }
                            // Input value should not be undefined for react-hook-form @see https://react-hook-form.com/docs/usecontroller/controller
                            onChange(newValue ?? "");
                        },
                        onMountHandler: onMountHandler
                    })
            })
        })
    });
}
var $ad07e9af9fa9eba2$export$2e2bcd8739ae039 = $ad07e9af9fa9eba2$var$ScriptSection;



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $739926a26699572e$var$SvgBook = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 17,
        height: 17,
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M11.794 1.744h-8a.667.667 0 0 0-.666.666v12a.667.667 0 0 0 .666.667h8a2 2 0 0 0 2-2V3.744a2 2 0 0 0-2-2Zm-6 12H4.461V3.077h1.333v10.667Zm6.667-.667a.667.667 0 0 1-.667.667H7.128V3.077h4.666a.667.667 0 0 1 .667.667v9.333Z",
            fill: "currentcolor"
        })
    });
var $739926a26699572e$export$2e2bcd8739ae039 = $739926a26699572e$var$SvgBook;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $5b757463ef38c83e$var$SvgConicalFlask = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 17,
        height: 16,
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M13.568 11.66 10.16 5.82V2.667h.667a.667.667 0 1 0 0-1.334H5.494a.667.667 0 0 0 0 1.334h.667V5.82l-3.407 5.84a2 2 0 0 0 1.727 3.007h7.333a2 2 0 0 0 1.727-3.007h.027ZM7.4 6.327A.667.667 0 0 0 7.494 6V2.667h1.334V6a.667.667 0 0 0 .093.333l.573 1H6.828L7.4 6.327Zm5.013 6.666a.667.667 0 0 1-.573.334H4.508a.667.667 0 0 1-.574-1l2.114-3.66h4.233l2.133 3.666a.667.667 0 0 1 0 .667v-.007ZM6.828 10a.666.666 0 1 0 0 1.333.666.666 0 0 0 0-1.333Zm2.666.667a.667.667 0 1 0 0 1.334.667.667 0 0 0 0-1.334Z",
            fill: "currentcolor"
        })
    });
var $5b757463ef38c83e$export$2e2bcd8739ae039 = $5b757463ef38c83e$var$SvgConicalFlask;



var $jGWQ4 = parcelRequire("jGWQ4");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $6NioG = parcelRequire("6NioG");


var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");


var $eecada452eb0d0a3$export$89da14300d534261;
var $eecada452eb0d0a3$export$6d59db4903f20f7d;
var $eecada452eb0d0a3$export$ba9a56610c2a1379;
var $eecada452eb0d0a3$export$36c65c169152373d;
var $eecada452eb0d0a3$export$bfd64c937657f93a;
var $eecada452eb0d0a3$export$4a6dd88bada4e7d2;
var $eecada452eb0d0a3$export$62d58b1c91e8e902;
var $eecada452eb0d0a3$export$bda7fe321f6bbcf1;
var $eecada452eb0d0a3$export$39f5674517ec0000;
$eecada452eb0d0a3$export$89da14300d534261 = `_42MIqG_active`;
$eecada452eb0d0a3$export$6d59db4903f20f7d = `_42MIqG_description`;
$eecada452eb0d0a3$export$ba9a56610c2a1379 = `_42MIqG_flexColumn`;
$eecada452eb0d0a3$export$36c65c169152373d = `_42MIqG_flexGrow`;
$eecada452eb0d0a3$export$bfd64c937657f93a = `_42MIqG_rotating`;
$eecada452eb0d0a3$export$4a6dd88bada4e7d2 = `_42MIqG_shimmer`;
$eecada452eb0d0a3$export$62d58b1c91e8e902 = `_42MIqG_tab`;
$eecada452eb0d0a3$export$bda7fe321f6bbcf1 = `_42MIqG_tabContent`;
$eecada452eb0d0a3$export$39f5674517ec0000 = `_42MIqG_tabs`;



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $aqmjm = parcelRequire("aqmjm");

var $C7mD2 = parcelRequire("C7mD2");

var $kezPv = parcelRequire("kezPv");

var $jyqwk = parcelRequire("jyqwk");

var $jGWQ4 = parcelRequire("jGWQ4");

var $75SRw = parcelRequire("75SRw");

var $fmHmG = parcelRequire("fmHmG");
var $f597d4dc08871763$export$a3bc9b8ed74fc;
var $f597d4dc08871763$export$e0f35d825088c098;
var $f597d4dc08871763$export$b7e3ae3d7c15e42e;
var $f597d4dc08871763$export$a188eecf6751e19c;
var $f597d4dc08871763$export$bfd64c937657f93a;
var $f597d4dc08871763$export$4a6dd88bada4e7d2;
var $f597d4dc08871763$export$ec672cc1b25fb83f;
$f597d4dc08871763$export$a3bc9b8ed74fc = `Wy0kla_error`;
$f597d4dc08871763$export$e0f35d825088c098 = `Wy0kla_field`;
$f597d4dc08871763$export$b7e3ae3d7c15e42e = `Wy0kla_input`;
$f597d4dc08871763$export$a188eecf6751e19c = `Wy0kla_keyInput`;
$f597d4dc08871763$export$bfd64c937657f93a = `Wy0kla_rotating`;
$f597d4dc08871763$export$4a6dd88bada4e7d2 = `Wy0kla_shimmer`;
$f597d4dc08871763$export$ec672cc1b25fb83f = `Wy0kla_valueInput`;


function $88142b94340a6b0b$var$Error({ error: error }) {
    if (!error) return null;
    if (typeof error === "string") return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: $f597d4dc08871763$export$a3bc9b8ed74fc,
        children: error
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: $f597d4dc08871763$export$a3bc9b8ed74fc,
        children: error.message
    });
}
/**
 * UI component for key-value input field.
 *
 * This component is used to add multiple key-value pairs.
 * For most of the cases, it is designed to be used along with react-hook-form.
 * All the input properties are registered with react-hook-form.
 * @param {Props} props - The props for the component.
 * @param {string} [props.className] - The class name for the container.
 * @param {FieldType} props.fields - The array of key-value pairs. @see {@link https://react-hook-form.com/docs/usefieldarray}
 * @param {ErrorType[]} [props.errors] - The array of errors for each field. Accepts both string and FieldError from RHF.
 * @param {Function} props.onRemove - The function to remove a field. @see {@link https://react-hook-form.com/docs/usefieldarray}
 * @param {Function} props.onAppend - The function to append a new field. @see {@link https://react-hook-form.com/docs/usefieldarray}
 * @param {InputFieldPropsGetter} getInputFieldProps - The function bundle to get the input field props for each field. e.g. Use React Hook Form's register method to register the input field.
 */ function $88142b94340a6b0b$var$KeyValueInputField({ className: className, fields: fields, errors: errors, getInputFieldProps: getInputFieldProps, onRemove: onRemove, onAppend: onAppend }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: className,
        children: [
            fields.map((field, index)=>{
                return(// Use id as the element key if it exists (generated by react-hook-form useFieldArray method), otherwise use the key
                /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: $f597d4dc08871763$export$e0f35d825088c098,
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                            className: $f597d4dc08871763$export$b7e3ae3d7c15e42e,
                            children: [
                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                    className: $f597d4dc08871763$export$a188eecf6751e19c,
                                    placeholder: "Key",
                                    error: Boolean(errors?.[index]?.key),
                                    ...getInputFieldProps.key(index)
                                }),
                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                    className: $f597d4dc08871763$export$ec672cc1b25fb83f,
                                    placeholder: "Value",
                                    error: Boolean(errors?.[index]?.value),
                                    ...getInputFieldProps.value(index)
                                }),
                                fields.length > 1 && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                                    onClick: ()=>{
                                        onRemove(index);
                                    },
                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jyqwk.default), {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)($88142b94340a6b0b$var$Error, {
                            error: errors?.[index]?.key
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)($88142b94340a6b0b$var$Error, {
                            error: errors?.[index]?.value
                        })
                    ]
                }, field.id));
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                size: "small",
                type: "text",
                title: "general.add_another",
                icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $kezPv.default), {}),
                onClick: ()=>{
                    onAppend({
                        key: "",
                        value: ""
                    });
                }
            })
        ]
    });
}
var $88142b94340a6b0b$export$2e2bcd8739ae039 = $88142b94340a6b0b$var$KeyValueInputField;


const $d20e8015173db78b$var$isValidKey = (key)=>{
    return /^\w+$/.test(key);
};
function $d20e8015173db78b$var$EnvironmentVariablesField({ className: className }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { register: register, getValues: getValues, trigger: trigger, formState: { errors: { environmentVariables: envVariableErrors }, submitCount: submitCount } } = (0, $codQP.useFormContext)();
    // Read the form controller from the context @see {@link https://react-hook-form.com/docs/usefieldarray}
    const { fields: fields, remove: remove, append: append } = (0, $codQP.useFieldArray)({
        name: "environmentVariables"
    });
    const keyValidator = (0, $jC8Vy.useCallback)((key, index)=>{
        const envVariables = getValues("environmentVariables");
        if (!envVariables) return true;
        // Unique key validation
        if (envVariables.filter(({ key: _key })=>_key.length > 0 && _key === key).length > 1) // Reuse the same error phrase key from webhook settings
        return t("webhook_details.settings.key_duplicated_error");
        // Empty key validation (if value is present)
        const correspondValue = getValues(`environmentVariables.${index}.value`);
        if (correspondValue) // Reuse the same error phrase key from webhook settings
        return Boolean(key) || t("webhook_details.settings.key_missing_error");
        // Key format validation
        if (Boolean(key) && !$d20e8015173db78b$var$isValidKey(key)) // Reuse the same error phrase key from webhook settings
        return t("webhook_details.settings.invalid_key_error");
        return true;
    }, [
        getValues,
        t
    ]);
    const valueValidator = (0, $jC8Vy.useCallback)((value, index)=>{
        return getValues(`environmentVariables.${index}.key`) ? Boolean(value) || t("webhook_details.settings.value_missing_error") : true;
    }, [
        getValues,
        t
    ]);
    const revalidate = (0, $jC8Vy.useCallback)(()=>{
        for (const [index] of fields.entries()){
            trigger(`environmentVariables.${index}.key`);
            // Only trigger value validation if the form has been submitted
            if (submitCount > 0) trigger(`environmentVariables.${index}.value`);
        }
    }, [
        fields,
        submitCount,
        trigger
    ]);
    const getInputFieldProps = (0, $jC8Vy.useMemo)(()=>({
            key: (index)=>register(`environmentVariables.${index}.key`, {
                    validate: (key)=>keyValidator(key, index),
                    onChange: revalidate
                }),
            value: (index)=>register(`environmentVariables.${index}.value`, {
                    validate: (value)=>valueValidator(value, index),
                    onChange: revalidate
                })
        }), [
        register,
        revalidate,
        keyValidator,
        valueValidator
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
        title: "jwt_claims.environment_variables.input_field_title",
        className: className,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $88142b94340a6b0b$export$2e2bcd8739ae039), {
            fields: fields,
            // Force envVariableErrors to be an array, otherwise return undefined
            errors: envVariableErrors?.map?.((error)=>error),
            getInputFieldProps: getInputFieldProps,
            onAppend: append,
            onRemove: remove
        })
    });
}
var $d20e8015173db78b$export$2e2bcd8739ae039 = $d20e8015173db78b$var$EnvironmentVariablesField;



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");


var $gC7hG = parcelRequire("gC7hG");

var $bnkR4 = parcelRequire("bnkR4");
var $f3f7d13a39cb9669$export$aa3e815946b80764;
var $f3f7d13a39cb9669$export$54df52f2b9f10b68;
var $f3f7d13a39cb9669$export$b8bf98e4d70f4134;
var $f3f7d13a39cb9669$export$f524fc929eb1947b;
var $f3f7d13a39cb9669$export$3aac624c619dfa7f;
var $f3f7d13a39cb9669$export$b94e31e2de63b9f5;
var $f3f7d13a39cb9669$export$52105d146316f63c;
var $f3f7d13a39cb9669$export$faed4863136ce212;
var $f3f7d13a39cb9669$export$bfd64c937657f93a;
var $f3f7d13a39cb9669$export$4a6dd88bada4e7d2;
$f3f7d13a39cb9669$export$aa3e815946b80764 = `-mgBka_card`;
$f3f7d13a39cb9669$export$54df52f2b9f10b68 = `-mgBka_cardContent`;
$f3f7d13a39cb9669$export$b8bf98e4d70f4134 = `-mgBka_cardHeader`;
$f3f7d13a39cb9669$export$f524fc929eb1947b = `-mgBka_cardSubtitle`;
$f3f7d13a39cb9669$export$3aac624c619dfa7f = `-mgBka_cardTitle`;
$f3f7d13a39cb9669$export$b94e31e2de63b9f5 = `-mgBka_expandButton`;
$f3f7d13a39cb9669$export$52105d146316f63c = `-mgBka_expanded`;
$f3f7d13a39cb9669$export$faed4863136ce212 = `-mgBka_headerRow`;
$f3f7d13a39cb9669$export$bfd64c937657f93a = `-mgBka_rotating`;
$f3f7d13a39cb9669$export$4a6dd88bada4e7d2 = `-mgBka_shimmer`;


var $af9afcbdab3755a3$export$f1a79bffad3377cd;
(function(CardType) {
    CardType["UserData"] = "user_data";
    CardType["TokenData"] = "token_data";
    CardType["FetchExternalData"] = "fetch_external_data";
    CardType["EnvironmentVariables"] = "environment_variables";
})($af9afcbdab3755a3$export$f1a79bffad3377cd || ($af9afcbdab3755a3$export$f1a79bffad3377cd = {}));
function $af9afcbdab3755a3$var$GuideCard({ name: name, children: children, isExpanded: isExpanded, setExpanded: setExpanded }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.jwt_claims"
    });
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($f3f7d13a39cb9669$export$aa3e815946b80764, isExpanded && $f3f7d13a39cb9669$export$52105d146316f63c),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $f3f7d13a39cb9669$export$faed4863136ce212,
                role: "button",
                tabIndex: 0,
                onClick: ()=>{
                    setExpanded(!isExpanded);
                },
                onKeyDown: (0, $bnkR4.onKeyDownHandler)(()=>{
                    setExpanded(!isExpanded);
                }),
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $f3f7d13a39cb9669$export$b8bf98e4d70f4134,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $f3f7d13a39cb9669$export$3aac624c619dfa7f,
                                children: t(`${name}.title`)
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $f3f7d13a39cb9669$export$f524fc929eb1947b,
                                children: t(`${name}.subtitle`)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $442b31b4cd054ae7$export$2e2bcd8739ae039), {
                        className: $f3f7d13a39cb9669$export$b94e31e2de63b9f5
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $f3f7d13a39cb9669$export$54df52f2b9f10b68,
                children: children
            })
        ]
    });
}
var $af9afcbdab3755a3$export$2e2bcd8739ae039 = $af9afcbdab3755a3$var$GuideCard;


var $e3413bd5eca0ab33$export$a3b4d748ba139cfa;
var $e3413bd5eca0ab33$export$7ee6f3c088891df4;
var $e3413bd5eca0ab33$export$bfd64c937657f93a;
var $e3413bd5eca0ab33$export$4a6dd88bada4e7d2;
$e3413bd5eca0ab33$export$a3b4d748ba139cfa = "sampleCode_909893";
$e3413bd5eca0ab33$export$7ee6f3c088891df4 = "envVariablesField_909893";
$e3413bd5eca0ab33$export$bfd64c937657f93a = "rotating_909893";
$e3413bd5eca0ab33$export$4a6dd88bada4e7d2 = "shimmer_909893";


/* Instructions and environment variable settings for the custom JWT claims script. */ function $5d54a55c1507cb31$var$InstructionTab({ isActive: isActive }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [expendCard, setExpendCard] = (0, $jC8Vy.useState)();
    const { watch: watch } = (0, $codQP.useFormContext)();
    const tokenType = watch("tokenType");
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($eecada452eb0d0a3$export$bda7fe321f6bbcf1, isActive && $eecada452eb0d0a3$export$89da14300d534261),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $af9afcbdab3755a3$export$2e2bcd8739ae039), {
                name: (0, $af9afcbdab3755a3$export$f1a79bffad3377cd).TokenData,
                isExpanded: expendCard === (0, $af9afcbdab3755a3$export$f1a79bffad3377cd).TokenData,
                setExpanded: (expand)=>{
                    setExpendCard(expand ? (0, $af9afcbdab3755a3$export$f1a79bffad3377cd).TokenData : undefined);
                },
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f6fc09178920afde$export$7cda8d932e2f33c0), {
                    language: "typescript",
                    className: $e3413bd5eca0ab33$export$a3b4d748ba139cfa,
                    value: tokenType === (0, $6NioG.LogtoJwtTokenKeyType).AccessToken ? (0, $7f1c81b5383b5d33$export$ba331f2e33839a49) : (0, $7f1c81b5383b5d33$export$52758b5206de435e),
                    // ClientCredentials token payload has only a few fields, so it doesn't need to be as tall as the AccessToken payload.
                    height: tokenType === (0, $6NioG.LogtoJwtTokenKeyType).AccessToken ? "320px" : "200px",
                    theme: "logto-dark",
                    options: (0, $6010cf9dfb34da69$export$68b7ccdd266b35b8)
                })
            }),
            tokenType === (0, $6NioG.LogtoJwtTokenKeyType).AccessToken && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $af9afcbdab3755a3$export$2e2bcd8739ae039), {
                name: (0, $af9afcbdab3755a3$export$f1a79bffad3377cd).UserData,
                isExpanded: expendCard === (0, $af9afcbdab3755a3$export$f1a79bffad3377cd).UserData,
                setExpanded: (expand)=>{
                    setExpendCard(expand ? (0, $af9afcbdab3755a3$export$f1a79bffad3377cd).UserData : undefined);
                },
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f6fc09178920afde$export$7cda8d932e2f33c0), {
                    language: "typescript",
                    className: $e3413bd5eca0ab33$export$a3b4d748ba139cfa,
                    value: (0, $7f1c81b5383b5d33$export$dfc7d5a7a860045c),
                    height: "400px",
                    theme: "logto-dark",
                    options: (0, $6010cf9dfb34da69$export$68b7ccdd266b35b8)
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $af9afcbdab3755a3$export$2e2bcd8739ae039), {
                name: (0, $af9afcbdab3755a3$export$f1a79bffad3377cd).FetchExternalData,
                isExpanded: expendCard === (0, $af9afcbdab3755a3$export$f1a79bffad3377cd).FetchExternalData,
                setExpanded: (expand)=>{
                    setExpendCard(expand ? (0, $af9afcbdab3755a3$export$f1a79bffad3377cd).FetchExternalData : undefined);
                },
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $eecada452eb0d0a3$export$6d59db4903f20f7d,
                        children: t("jwt_claims.fetch_external_data.description")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f6fc09178920afde$export$7cda8d932e2f33c0), {
                        language: "typescript",
                        className: $e3413bd5eca0ab33$export$a3b4d748ba139cfa,
                        value: (0, $6010cf9dfb34da69$export$53ee4998c34664bf),
                        height: "300px",
                        theme: "logto-dark",
                        options: (0, $6010cf9dfb34da69$export$d5cfafb9872058ea)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $af9afcbdab3755a3$export$2e2bcd8739ae039), {
                name: (0, $af9afcbdab3755a3$export$f1a79bffad3377cd).EnvironmentVariables,
                isExpanded: expendCard === (0, $af9afcbdab3755a3$export$f1a79bffad3377cd).EnvironmentVariables,
                setExpanded: (expand)=>{
                    setExpendCard(expand ? (0, $af9afcbdab3755a3$export$f1a79bffad3377cd).EnvironmentVariables : undefined);
                },
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $d20e8015173db78b$export$2e2bcd8739ae039), {
                        className: $e3413bd5eca0ab33$export$7ee6f3c088891df4
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $eecada452eb0d0a3$export$6d59db4903f20f7d,
                        children: t("jwt_claims.environment_variables.sample_code")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f6fc09178920afde$export$7cda8d932e2f33c0), {
                        language: "typescript",
                        className: $e3413bd5eca0ab33$export$a3b4d748ba139cfa,
                        value: (0, $6010cf9dfb34da69$export$9c26fbd24436cc79),
                        path: "file:///env-variables-sample.js",
                        height: "400px",
                        theme: "logto-dark",
                        options: (0, $6010cf9dfb34da69$export$d5cfafb9872058ea)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $eecada452eb0d0a3$export$6d59db4903f20f7d,
                children: t("jwt_claims.jwt_claims_description")
            })
        ]
    });
}
var $5d54a55c1507cb31$export$2e2bcd8739ae039 = $5d54a55c1507cb31$var$InstructionTab;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $6NioG = parcelRequire("6NioG");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");



var $f11972914219f6c1$export$d89b6f4d34274146;
var $f11972914219f6c1$export$a3bc9b8ed74fc;
var $f11972914219f6c1$export$bfd64c937657f93a;
var $f11972914219f6c1$export$4a6dd88bada4e7d2;
$f11972914219f6c1$export$d89b6f4d34274146 = `EIUXsq_codeEditor`;
$f11972914219f6c1$export$a3bc9b8ed74fc = `EIUXsq_error`;
$f11972914219f6c1$export$bfd64c937657f93a = `EIUXsq_rotating`;
$f11972914219f6c1$export$4a6dd88bada4e7d2 = `EIUXsq_shimmer`;


const $82edcf420c19a801$var$accessTokenModelSettings = [
    (0, $6010cf9dfb34da69$export$615416178429da08),
    (0, $6010cf9dfb34da69$export$dae80692bff07000)
];
const $82edcf420c19a801$var$clientCredentialsModelSettings = [
    (0, $6010cf9dfb34da69$export$91df5829726a58b6)
];
function $82edcf420c19a801$var$TestTab({ isActive: isActive }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.jwt_claims"
    });
    const [activeModelName, setActiveModelName] = (0, $jC8Vy.useState)();
    const { watch: watch, control: control, formState: formState } = (0, $codQP.useFormContext)();
    const tokenType = watch("tokenType");
    const editorModels = (0, $jC8Vy.useMemo)(()=>tokenType === (0, $6NioG.LogtoJwtTokenKeyType).AccessToken ? $82edcf420c19a801$var$accessTokenModelSettings : $82edcf420c19a801$var$clientCredentialsModelSettings, [
        tokenType
    ]);
    (0, $jC8Vy.useEffect)(()=>{
        setActiveModelName(editorModels[0]?.name);
    }, [
        editorModels,
        tokenType
    ]);
    const getModelControllerProps = (0, $jC8Vy.useCallback)(({ value: value, onChange: onChange })=>{
        return {
            value: activeModelName === (0, $6010cf9dfb34da69$export$dae80692bff07000).name ? value.contextSample : value.tokenSample,
            onChange: (newValue)=>{
                // Form value is a object we need to update the specific field
                const updatedValue = {
                    ...value,
                    ...(0, $7oDSS.conditional)(activeModelName === (0, $6010cf9dfb34da69$export$dae80692bff07000).name && {
                        contextSample: newValue
                    }),
                    ...(0, $7oDSS.conditional)(activeModelName === (0, $6010cf9dfb34da69$export$615416178429da08).name && {
                        tokenSample: newValue
                    }),
                    ...(0, $7oDSS.conditional)(activeModelName === (0, $6010cf9dfb34da69$export$91df5829726a58b6).name && {
                        // Reset the field to undefined if the value is the same as the default value
                        tokenSample: newValue
                    })
                };
                onChange(updatedValue);
            }
        };
    }, [
        activeModelName
    ]);
    const validateSampleCode = (0, $jC8Vy.useCallback)((value)=>{
        for (const [_, sampleCode] of Object.entries(value)){
            if (sampleCode) try {
                JSON.parse(sampleCode);
            } catch  {
                return t("form_error.invalid_json");
            }
        }
        return true;
    }, [
        t
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($eecada452eb0d0a3$export$bda7fe321f6bbcf1, isActive && $eecada452eb0d0a3$export$89da14300d534261),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $eecada452eb0d0a3$export$6d59db4903f20f7d,
                children: t("tester.subtitle")
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($eecada452eb0d0a3$export$ba9a56610c2a1379, $eecada452eb0d0a3$export$36c65c169152373d),
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                        control: control,
                        name: "testSample",
                        rules: {
                            validate: validateSampleCode
                        },
                        render: ({ field: field })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $8ddbadc498f4c1c5$export$2e2bcd8739ae039), {
                                className: $f11972914219f6c1$export$d89b6f4d34274146,
                                enabledActions: [
                                    "restore",
                                    "copy"
                                ],
                                models: editorModels,
                                activeModelName: activeModelName,
                                setActiveModel: setActiveModelName,
                                ...getModelControllerProps(field)
                            })
                    }),
                    formState.errors.testSample && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $f11972914219f6c1$export$a3bc9b8ed74fc,
                        children: formState.errors.testSample.message
                    })
                ]
            })
        ]
    });
}
var $82edcf420c19a801$export$2e2bcd8739ae039 = $82edcf420c19a801$var$TestTab;



var $43e5b74ed7ce0951$var$Tab;
(function(Tab) {
    Tab["DataSource"] = "data_source_tab";
    Tab["Test"] = "test_tab";
})($43e5b74ed7ce0951$var$Tab || ($43e5b74ed7ce0951$var$Tab = {}));
function $43e5b74ed7ce0951$var$SettingsSection() {
    const [activeTab, setActiveTab] = (0, $jC8Vy.useState)($43e5b74ed7ce0951$var$Tab.DataSource);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $eecada452eb0d0a3$export$ba9a56610c2a1379,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $eecada452eb0d0a3$export$39f5674517ec0000,
                children: Object.values($43e5b74ed7ce0951$var$Tab).map((tab)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        type: "primary",
                        icon: tab === $43e5b74ed7ce0951$var$Tab.DataSource ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $739926a26699572e$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5b757463ef38c83e$export$2e2bcd8739ae039), {}),
                        title: `jwt_claims.${tab}`,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($eecada452eb0d0a3$export$62d58b1c91e8e902, activeTab === tab && $eecada452eb0d0a3$export$89da14300d534261),
                        onClick: ()=>{
                            setActiveTab(tab);
                        }
                    }, tab))
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5d54a55c1507cb31$export$2e2bcd8739ae039), {
                isActive: activeTab === $43e5b74ed7ce0951$var$Tab.DataSource
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $82edcf420c19a801$export$2e2bcd8739ae039), {
                isActive: activeTab === $43e5b74ed7ce0951$var$Tab.Test
            })
        ]
    });
}
var $43e5b74ed7ce0951$export$2e2bcd8739ae039 = $43e5b74ed7ce0951$var$SettingsSection;


var $db529a491869fd6e$export$a7db06668cad9adb;
var $db529a491869fd6e$export$d3305692eb3e9a81;
var $db529a491869fd6e$export$bfd64c937657f93a;
var $db529a491869fd6e$export$4a6dd88bada4e7d2;
var $db529a491869fd6e$export$5938e5d47c8ceb04;
$db529a491869fd6e$export$a7db06668cad9adb = `_50Ug_W_content`;
$db529a491869fd6e$export$d3305692eb3e9a81 = `_50Ug_W_overwrite`;
$db529a491869fd6e$export$bfd64c937657f93a = `_50Ug_W_rotating`;
$db529a491869fd6e$export$4a6dd88bada4e7d2 = `_50Ug_W_shimmer`;
$db529a491869fd6e$export$5938e5d47c8ceb04 = `_50Ug_W_submitActionBar`;


function $41a45b4ce12c0c88$var$MainContent({ className: className, token: token, data: data, mutate: mutate, action: action }) {
    const api = (0, $7VnwS.default)();
    const navigate = (0, $2Phw0.useNavigate)();
    const { mutate: globalMutate } = (0, $hgWIN.useSWRConfig)();
    const methods = (0, $codQP.useForm)({
        defaultValues: (0, $42f2b6b98e4ee585$export$e46869577cb50342)(token, data)
    });
    const { formState: { isDirty: isDirty, isSubmitting: isSubmitting }, reset: reset, handleSubmit: handleSubmit } = methods;
    const onSubmitHandler = handleSubmit((0, $5OcFi.trySubmitSafe)(async (data)=>{
        if (isSubmitting) return;
        const { tokenType: tokenType } = data;
        const payload = (0, $42f2b6b98e4ee585$export$14e991553b564f72)(data);
        const updatedJwtCustomizer = await api.put((0, $be22d3afc68f1d38$export$413d97236b66d9c0)(tokenType), {
            json: payload
        }).json();
        await mutate(updatedJwtCustomizer);
        // Need to reset the form data ahead to avoid the unsaved changes alert
        reset((0, $42f2b6b98e4ee585$export$e46869577cb50342)(tokenType, updatedJwtCustomizer));
        // If the form is in create mode, navigate back to the previous page
        if (action === "create") {
            globalMutate((0, $be22d3afc68f1d38$export$413d97236b66d9c0)());
            navigate(-1);
        }
    }));
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.FormProvider), {
                ...methods,
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("form", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($db529a491869fd6e$export$a7db06668cad9adb, className),
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ad07e9af9fa9eba2$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $43e5b74ed7ce0951$export$2e2bcd8739ae039), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $41b73519a7034b3a$export$2e2bcd8739ae039), {
                // Always show the action bar if is the create mode
                isOpen: isDirty || action === "create",
                isSubmitting: isSubmitting,
                confirmText: action === "create" ? "general.create" : "general.save_changes",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($db529a491869fd6e$export$5938e5d47c8ceb04, $db529a491869fd6e$export$d3305692eb3e9a81),
                onDiscard: // If the form is in create mode, navigate back to the previous page
                action === "create" ? ()=>{
                    navigate(-1);
                } : reset,
                onSubmit: onSubmitHandler
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fea55fa5d5726e29$export$2e2bcd8739ae039), {
                hasUnsavedChanges: isDirty && !isSubmitting,
                onConfirm: reset
            })
        ]
    });
}
var $41a45b4ce12c0c88$export$2e2bcd8739ae039 = $41a45b4ce12c0c88$var$MainContent;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $6NioG = parcelRequire("6NioG");

var $5UrGx = parcelRequire("5UrGx");

var $gC7hG = parcelRequire("gC7hG");
var $328010fbf2c3ecf7$export$b916b1b8ce003690;
var $328010fbf2c3ecf7$export$aa3e815946b80764;
var $328010fbf2c3ecf7$export$a7db06668cad9adb;
var $328010fbf2c3ecf7$export$f09585a853dddd32;
var $328010fbf2c3ecf7$export$bfd64c937657f93a;
var $328010fbf2c3ecf7$export$4a6dd88bada4e7d2;
var $328010fbf2c3ecf7$export$43c8416ff6d266ab;
var $328010fbf2c3ecf7$export$fb184b623420d9be;
$328010fbf2c3ecf7$export$b916b1b8ce003690 = `-wzdyW_blockShimmer`;
$328010fbf2c3ecf7$export$aa3e815946b80764 = `-wzdyW_card`;
$328010fbf2c3ecf7$export$a7db06668cad9adb = `-wzdyW_content`;
$328010fbf2c3ecf7$export$f09585a853dddd32 = `-wzdyW_large`;
$328010fbf2c3ecf7$export$bfd64c937657f93a = `-wzdyW_rotating`;
$328010fbf2c3ecf7$export$4a6dd88bada4e7d2 = `-wzdyW_shimmer`;
$328010fbf2c3ecf7$export$4a6dd88bada4e7d2;
$328010fbf2c3ecf7$export$43c8416ff6d266ab = `-wzdyW_textShimmer`;
$328010fbf2c3ecf7$export$fb184b623420d9be = `-wzdyW_title`;


function $eb820b903008b978$var$PageLoadingSkeleton({ tokenType: tokenType }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $328010fbf2c3ecf7$export$a7db06668cad9adb,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $328010fbf2c3ecf7$export$b916b1b8ce003690
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($328010fbf2c3ecf7$export$43c8416ff6d266ab, $328010fbf2c3ecf7$export$f09585a853dddd32)
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
                        className: $328010fbf2c3ecf7$export$aa3e815946b80764,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($328010fbf2c3ecf7$export$43c8416ff6d266ab, $328010fbf2c3ecf7$export$fb184b623420d9be)
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $328010fbf2c3ecf7$export$43c8416ff6d266ab
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
                        className: $328010fbf2c3ecf7$export$aa3e815946b80764,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($328010fbf2c3ecf7$export$43c8416ff6d266ab, $328010fbf2c3ecf7$export$fb184b623420d9be)
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $328010fbf2c3ecf7$export$43c8416ff6d266ab
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
                        className: $328010fbf2c3ecf7$export$aa3e815946b80764,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($328010fbf2c3ecf7$export$43c8416ff6d266ab, $328010fbf2c3ecf7$export$fb184b623420d9be)
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $328010fbf2c3ecf7$export$43c8416ff6d266ab
                            })
                        ]
                    }),
                    tokenType === (0, $6NioG.LogtoJwtTokenKeyType).AccessToken && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
                        className: $328010fbf2c3ecf7$export$aa3e815946b80764,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $328010fbf2c3ecf7$export$43c8416ff6d266ab
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $328010fbf2c3ecf7$export$43c8416ff6d266ab
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $eb820b903008b978$export$2e2bcd8739ae039 = $eb820b903008b978$var$PageLoadingSkeleton;


var $c99508dc3a603779$export$34e0f9847d4c02dd;
var $c99508dc3a603779$export$38e42c68cf43b5d4;
var $c99508dc3a603779$export$73920f18ca706874;
var $c99508dc3a603779$export$bfd64c937657f93a;
var $c99508dc3a603779$export$4a6dd88bada4e7d2;
$c99508dc3a603779$export$34e0f9847d4c02dd = `_3YYh6q_container`;
$c99508dc3a603779$export$38e42c68cf43b5d4 = `_3YYh6q_header`;
$c99508dc3a603779$export$73920f18ca706874 = `_3YYh6q_hidden`;
$c99508dc3a603779$export$bfd64c937657f93a = `_3YYh6q_rotating`;
$c99508dc3a603779$export$4a6dd88bada4e7d2 = `_3YYh6q_shimmer`;


parcelRequire("cuPVN");
var $6NioG = parcelRequire("6NioG");

var $c3dK3 = parcelRequire("c3dK3");
const $5e74ead7d62d4a6c$export$9b8b5ad70be0154a = (0, $c3dK3.z).object({
    tokenType: (0, $c3dK3.z).nativeEnum((0, $6NioG.LogtoJwtTokenKeyType)),
    action: (0, $c3dK3.z).union([
        (0, $c3dK3.z).literal("create"),
        (0, $c3dK3.z).literal("edit")
    ])
});



var $voszV = parcelRequire("voszV");

var $7VnwS = parcelRequire("7VnwS");



const $12f6c5e270277a4c$var$useDataFetch = (tokenType, action)=>{
    const apiPath = (0, $be22d3afc68f1d38$export$413d97236b66d9c0)(tokenType);
    const fetchApi = (0, $7VnwS.default)({
        hideErrorToast: true
    });
    const fetcher = (0, $04c74fc7d2f91811$export$2e2bcd8739ae039)(fetchApi);
    // Return undefined if action is create
    const { isLoading: isLoading, data: data, mutate: mutate, error: error } = (0, $voszV.default)(action === "create" ? undefined : apiPath, {
        fetcher: fetcher,
        shouldRetryOnError: (0, $d3d6bc7d2607318c$export$9ea285d0c158d4f1)({
            ignore: [
                404
            ]
        })
    });
    return {
        // Show global loading status only if any of the fetchers are loading and no errors are present
        isLoading: isLoading && !error,
        data: data,
        mutate: mutate,
        error: error
    };
};
var $12f6c5e270277a4c$export$2e2bcd8739ae039 = $12f6c5e270277a4c$var$useDataFetch;


function $76711429e65224a0$var$Content({ tokenType: tokenType, action: action }) {
    const { isLoading: isLoading, error: error, ...rest } = (0, $12f6c5e270277a4c$export$2e2bcd8739ae039)(tokenType, action);
    const [isMonacoLoaded, setIsMonacoLoaded] = (0, $jC8Vy.useState)(false);
    const codeEditorContextValue = (0, $jC8Vy.useMemo)(()=>({
            isMonacoLoaded: isMonacoLoaded,
            setIsMonacoLoaded: setIsMonacoLoaded
        }), [
        isMonacoLoaded
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aa35f43ec98b7478$export$2e2bcd8739ae039), {
        backLink: "/customize-jwt",
        backLinkTitle: "jwt_claims.title",
        className: $c99508dc3a603779$export$34e0f9847d4c02dd,
        children: [
            (isLoading || !isMonacoLoaded) && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $eb820b903008b978$export$2e2bcd8739ae039), {
                tokenType: tokenType
            }),
            !isLoading && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ab3b3c4ca6da4bbe$export$e174976f1470e250).Provider, {
                value: codeEditorContextValue,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $41a45b4ce12c0c88$export$2e2bcd8739ae039), {
                    action: action,
                    token: tokenType,
                    ...rest,
                    className: isMonacoLoaded ? undefined : $c99508dc3a603779$export$73920f18ca706874
                })
            })
        ]
    });
}
// Guard the parameters to ensure they are valid
function $76711429e65224a0$var$CustomizeJwtDetails() {
    const { tokenType: tokenType, action: action } = (0, $2Phw0.useParams)();
    const params = (0, $5e74ead7d62d4a6c$export$9b8b5ad70be0154a).safeParse({
        tokenType: tokenType,
        action: action
    });
    if (!params.success) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a0f84bc7cc69e410$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $C7mD2.jsx)($76711429e65224a0$var$Content, {
        tokenType: params.data.tokenType,
        action: params.data.action
    });
}
var $76711429e65224a0$export$2e2bcd8739ae039 = $76711429e65224a0$var$CustomizeJwtDetails;


const $cb2118ff38a4baa7$export$1c195da67e015885 = {
    path: "customize-jwt",
    children: [
        {
            index: true,
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $929e8d9f5970bcab$export$2e2bcd8739ae039), {})
        },
        {
            path: ":tokenType/:action",
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $76711429e65224a0$export$2e2bcd8739ae039), {})
        }
    ]
};



var $C7mD2 = parcelRequire("C7mD2");

var $2Phw0 = parcelRequire("2Phw0");

var $bt3dS = parcelRequire("bt3dS");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $lXQZH = parcelRequire("lXQZH");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
parcelRequire("6bq3s");
var $2Phw0 = parcelRequire("2Phw0");

var $voszV = parcelRequire("voszV");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $1914b4197efeea0c$var$SvgSsoConnectorEmptyDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M168.233 70c0-7.05 5.716-12.767 12.767-12.767h2v1.534h-2c-6.204 0-11.233 5.03-11.233 11.233v117c0 6.204 5.029 11.233 11.233 11.233h2v1.534h-2c-7.051 0-12.767-5.716-12.767-12.767V70Z",
                fill: "#A782E8"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M42.712 204.2a6.134 6.134 0 1 0 6.285-10.537 6.134 6.134 0 0 0-6.285 10.537Zm1.572-2.634a3.068 3.068 0 1 0 3.14-5.269 3.068 3.068 0 0 0-3.14 5.269Z",
                fill: "#CABEFF",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M27.926 70.828a2.045 2.045 0 0 0-.22-2.884l-1.878-1.612a2.045 2.045 0 0 0-2.883.22l-1.613 1.877a2.045 2.045 0 0 0 .22 2.884l1.878 1.612a2.045 2.045 0 0 0 2.883-.22l1.613-1.877Z",
                fill: "#CABEFF",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M153.999 127.233h29v1.534h-29v-1.534ZM72 127.233h14v1.534H72v-1.534Z",
                fill: "#A782E8"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M14 111.269C14 104.493 19.493 99 26.269 99h33.462C66.507 99 72 104.493 72 111.269v33.462C72 151.507 66.507 157 59.73 157H26.27C19.493 157 14 151.507 14 144.731v-33.462Z",
                fill: "url(#paint0_linear_2731_87774)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M47.695 129.398v3.293c0 .634-9.39.421-9.39-.493 0-.861.017-4.761 0-8.772-2.103-2.719-2.103-4.418-.44-6.175 1.662-1.756 13.498-2.634 13.498-2.634s.888 8.519 1.027 10.83c.056.929.66 3.951-1.687 3.951h-3.008Z",
                fill: "url(#paint1_linear_2731_87774)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M47.692 129.113a13.916 13.916 0 0 1-5.425-1.767s1.174 2.78 5.425 3.535v-1.768Z",
                fill: "#FFD7B8",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M58.406 139.246c.869 1.761 1.566 4.596 2.09 8.503a.763.763 0 0 1-.758.863H26.263a.763.763 0 0 1-.759-.863c.525-3.908 1.222-6.742 2.09-8.503.928-1.882 9.537-5.504 9.537-5.504s.172-1.656.587-1.893c.416-.238 10.07-.237 10.564 0 .495.237.587 1.892.587 1.892s8.611 3.627 9.537 5.505Z",
                fill: "#6F45E5"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M40.216 119.036c-.466-.4-1.033-.669-1.835-.254-1.9.984-.639 4.78 1.488 4.706.733-.026.397 1.433-1.563 2.396 0-1.537-2.348-5.342-2.553-8.806-2.362-.878-1.775-4.388-.154-4.388-.258-3.218 4.908-4.881 6.908-3.034 2.035-2.432 7.17-1.188 7.48.922 3.532-1.88 5.853 3.524 2.546 5.622-1.36.864-4.543 1.192-9.138 1.192-2.204 0-.936 5.147-.247 6.809.88 2.122 5.796 2.414 7.336 2.195 1.203-.171 1.834-.659 1.908-.951 1.1 2.927-.294 4.683-2.495 4.683-3.741 0-7.483-1.098-8.07-3.805-.467-2.155-.441-5.632-1.61-7.287Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M98.902 149.905c-8.12-.593-14.525-7.439-14.525-15.798 0-8.567 6.729-15.545 15.136-15.83 2.272-9.345 10.616-16.277 20.562-16.277 9.64 0 17.775 6.511 20.335 15.42 8.868.286 15.967 7.456 15.967 16.259 0 8.524-6.656 15.516-15.129 16.211v.11H98.902v-.095Z",
                fill: "url(#paint2_linear_2731_87774)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M120.401 125.349a3.22 3.22 0 0 1-4.628 0 3.404 3.404 0 0 1 0-4.736 3.22 3.22 0 0 1 4.628 0 3.404 3.404 0 0 1 0 4.736Zm-7.714 3.158a7.51 7.51 0 0 0 9.033 1.349l4.586 4.693-.751.768a1.135 1.135 0 0 0 0 1.579l1.543 1.578a1.072 1.072 0 0 0 1.542 0l.751-.768 2.284 2.337a2.147 2.147 0 0 0 3.086 0 2.27 2.27 0 0 0 0-3.158l-9.955-10.186c1.566-2.961 1.127-6.74-1.319-9.243a7.514 7.514 0 0 0-10.8 0c-2.982 3.052-2.982 7.999 0 11.051Z",
                fill: "#FDCF90"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M120.401 125.349a3.22 3.22 0 0 1-4.628 0 3.404 3.404 0 0 1 0-4.736 3.22 3.22 0 0 1 4.628 0 3.404 3.404 0 0 1 0 4.736Zm-7.714 3.158a7.51 7.51 0 0 0 9.033 1.349l4.586 4.693-.751.768a1.135 1.135 0 0 0 0 1.579l1.543 1.578a1.072 1.072 0 0 0 1.542 0l.751-.768 2.284 2.337a2.147 2.147 0 0 0 3.086 0 2.27 2.27 0 0 0 0-3.158l-9.955-10.186c1.566-2.961 1.127-6.74-1.319-9.243a7.514 7.514 0 0 0-10.8 0c-2.982 3.052-2.982 7.999 0 11.051Z",
                fill: "url(#paint3_linear_2731_87774)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M184 41.269C184 34.493 189.493 29 196.269 29h33.462C236.507 29 242 34.493 242 41.269v33.462C242 81.507 236.507 87 229.731 87h-33.462C189.493 87 184 81.507 184 74.731V41.269Z",
                fill: "#CABEFF",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M196.269 29.75c-6.362 0-11.519 5.157-11.519 11.519v33.462c0 6.362 5.157 11.519 11.519 11.519H230.5c5.937 0 10.75-4.813 10.75-10.75V41.269c0-6.362-5.157-11.519-11.519-11.519H229v-1.5h.731c7.19 0 13.019 5.829 13.019 13.019V75.5c0 6.766-5.485 12.25-12.25 12.25h-34.231c-7.19 0-13.019-5.829-13.019-13.019V41.269c0-7.19 5.829-13.019 13.019-13.019H222v1.5h-25.731Z",
                fill: "#454262"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                opacity: 0.8,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M197.001 48.116a2.56 2.56 0 0 1 2.56-2.56h26.88a2.56 2.56 0 0 1 2.56 2.56v19.2a2.56 2.56 0 0 1-2.56 2.56h-26.88a2.56 2.56 0 0 1-2.56-2.56v-19.2Z",
                        fill: "url(#paint4_linear_2731_87774)"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M197.001 48.116a2.56 2.56 0 0 1 2.56-2.56h26.88a2.56 2.56 0 0 1 2.56 2.56v19.2a2.56 2.56 0 0 1-2.56 2.56h-26.88a2.56 2.56 0 0 1-2.56-2.56v-19.2Z",
                        fill: "url(#paint5_linear_2731_87774)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M197.001 50.768h32v-2.733a2.479 2.479 0 0 0-2.479-2.479H199.48a2.479 2.479 0 0 0-2.479 2.479v2.733Z",
                fill: "#5D34F2"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M200.557 55.109c0-.48.389-.869.868-.869h8.93a.869.869 0 0 1 0 1.737h-8.93a.869.869 0 0 1-.868-.868ZM200.557 60.322c0-.48.389-.869.868-.869h19.596a.869.869 0 1 1 0 1.737h-19.596a.869.869 0 0 1-.868-.868Z",
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M184 181.269c0-6.776 5.493-12.269 12.269-12.269h33.462c6.776 0 12.269 5.493 12.269 12.269v33.462c0 6.776-5.493 12.269-12.269 12.269h-33.462c-6.776 0-12.269-5.493-12.269-12.269v-33.462Z",
                fill: "#CABEFF",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M196.269 169.75c-6.362 0-11.519 5.157-11.519 11.519v33.462c0 6.362 5.157 11.519 11.519 11.519H230.5c5.937 0 10.75-4.813 10.75-10.75v-34.231c0-6.362-5.157-11.519-11.519-11.519H229v-1.5h.731c7.19 0 13.019 5.829 13.019 13.019V215.5c0 6.765-5.485 12.25-12.25 12.25h-34.231c-7.19 0-13.019-5.829-13.019-13.019v-33.462c0-7.19 5.829-13.019 13.019-13.019H222v1.5h-25.731Z",
                fill: "#454262"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                opacity: 0.8,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M197.001 188.116a2.56 2.56 0 0 1 2.56-2.56h26.88a2.56 2.56 0 0 1 2.56 2.56v19.2a2.56 2.56 0 0 1-2.56 2.56h-26.88a2.56 2.56 0 0 1-2.56-2.56v-19.2Z",
                        fill: "url(#paint6_linear_2731_87774)"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M197.001 188.116a2.56 2.56 0 0 1 2.56-2.56h26.88a2.56 2.56 0 0 1 2.56 2.56v19.2a2.56 2.56 0 0 1-2.56 2.56h-26.88a2.56 2.56 0 0 1-2.56-2.56v-19.2Z",
                        fill: "url(#paint7_linear_2731_87774)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M197.001 190.768h32v-2.733a2.48 2.48 0 0 0-2.479-2.479H199.48a2.48 2.48 0 0 0-2.479 2.479v2.733Z",
                fill: "#5D34F2"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M200.557 195.109c0-.48.389-.869.868-.869h8.93a.869.869 0 0 1 0 1.737h-8.93a.868.868 0 0 1-.868-.868ZM200.557 200.322c0-.48.389-.869.868-.869h19.596a.869.869 0 1 1 0 1.737h-19.596a.868.868 0 0 1-.868-.868Z",
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M184 111.269C184 104.493 189.493 99 196.269 99h33.462c6.776 0 12.269 5.493 12.269 12.269v33.462c0 6.776-5.493 12.269-12.269 12.269h-33.462c-6.776 0-12.269-5.493-12.269-12.269v-33.462Z",
                fill: "#CABEFF",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M196.269 99.75c-6.362 0-11.519 5.157-11.519 11.519v33.462c0 6.362 5.157 11.519 11.519 11.519h33.462c6.362 0 11.519-5.157 11.519-11.519v-.231h1.5v.231c0 7.19-5.829 13.019-13.019 13.019h-33.462c-7.19 0-13.019-5.829-13.019-13.019v-33.462c0-7.19 5.829-13.019 13.019-13.019h1.231v1.5h-1.231Zm33.462 0H205v-1.5h24.731c7.19 0 13.019 5.829 13.019 13.019V144.5h-1.5v-33.231c0-6.362-5.157-11.519-11.519-11.519Z",
                fill: "#454262"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M203 113.908c0-2.711 2.289-4.908 5.112-4.908h10.224c2.824 0 5.112 2.197 5.112 4.908V140.9c0 2.71-2.288 4.907-5.112 4.907h-10.224c-2.823 0-5.112-2.197-5.112-4.907v-26.992Z",
                fill: "url(#paint8_linear_2731_87774)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M203 113.908c0-2.711 2.289-4.908 5.112-4.908h10.224c2.824 0 5.112 2.197 5.112 4.908V140.9c0 2.71-2.288 4.907-5.112 4.907h-10.224c-2.823 0-5.112-2.197-5.112-4.907v-26.992Z",
                fill: "url(#paint9_linear_2731_87774)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M215.142 140.899c0 .978-.833 1.815-1.917 1.815s-1.917-.837-1.917-1.815.833-1.815 1.917-1.815 1.917.837 1.917 1.815Z",
                stroke: "#F5EEFF",
                strokeWidth: 1.278
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M208.112 110.278c0-.706.572-1.278 1.278-1.278h7.668c.706 0 1.279.572 1.279 1.278v1.176c0 .677-.573 1.227-1.279 1.227h-7.668c-.706 0-1.278-.55-1.278-1.227v-1.176Z",
                fill: "#4300DA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M64.36 40.718a1.107 1.107 0 0 1-.643 1.421c-.898.339-1.767.738-2.6 1.193a1.09 1.09 0 0 1-1.485-.446 1.11 1.11 0 0 1 .442-1.497 22.792 22.792 0 0 1 2.876-1.319 1.092 1.092 0 0 1 1.41.648Zm14.398.392a1.092 1.092 0 0 1 1.442-.57 23.07 23.07 0 0 1 8.05 5.922A23.224 23.224 0 0 1 94 61.805a1.1 1.1 0 0 1-1.095 1.104 1.1 1.1 0 0 1-1.096-1.104c0-5.323-1.963-10.181-5.202-13.881a20.88 20.88 0 0 0-7.284-5.36 1.108 1.108 0 0 1-.565-1.454Zm-21.426 3.396c.4.457.357 1.155-.096 1.559a21.053 21.053 0 0 0-4.262 5.247 20.951 20.951 0 0 0-2.128 5.245 21.196 21.196 0 0 0-.655 5.248c0 2.39.395 4.683 1.123 6.82a21 21 0 0 0 9.605 11.543A20.574 20.574 0 0 0 71 82.791c3.66 0 7.096-.952 10.082-2.623a20.98 20.98 0 0 0 6.946-6.297 1.09 1.09 0 0 1 1.526-.267 1.11 1.11 0 0 1 .265 1.539 23.176 23.176 0 0 1-7.675 6.957A22.75 22.75 0 0 1 71 85a22.75 22.75 0 0 1-11.144-2.9 23.2 23.2 0 0 1-10.614-12.757A23.345 23.345 0 0 1 48 61.805c0-2 .251-3.944.725-5.798a23.166 23.166 0 0 1 2.353-5.8 23.256 23.256 0 0 1 4.708-5.798 1.089 1.089 0 0 1 1.546.097Z",
                fill: "#CABEFF",
                fillOpacity: 0.2
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                clipPath: "url(#clip0_2731_87774)",
                fill: "#AF9EFF",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "m83.999 62.95-.65-5.85-1.886 1.236C79.71 57.23 77.5 56.45 75.03 56.06c0 0-1.236-.26-2.86-.26-1.626 0-3.12.195-3.12.195-6.306.78-11.05 4.355-11.05 8.645 0 4.42 4.874 8.06 12.35 8.71v-2.535c-5.136-.715-8.386-3.12-8.386-6.175 0-2.86 2.99-5.265 7.086-6.045 0 0 3.184-.715 5.98.13 1.365.325 2.6.78 3.64 1.43l-2.47 1.495 7.8 1.3Z",
                        fillOpacity: 0.6
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M70.348 50.6v22.75l3.9-1.95V48.65l-3.9 1.95Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M154 77c0 11.046-8.954 20-20 20s-20-8.954-20-20 8.954-20 20-20 20 8.954 20 20Z",
                fill: "#CABEFF",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("g", {
                clipPath: "url(#clip1_2731_87774)",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "m135.498 65.174-.503 6.215a6.004 6.004 0 0 0-1.627.024l-.287-3.014a.16.16 0 0 1 .161-.175h.515l-.249-3.05a.16.16 0 0 1 .16-.174h1.668c.094 0 .167.08.16.174h.002Zm-4.211.308a.16.16 0 0 0-.21-.108l-1.568.572a.16.16 0 0 0-.091.218l1.275 2.78-.484.176a.161.161 0 0 0-.091.22l1.299 2.735c.471-.26.982-.455 1.521-.578l-1.651-6.014Zm-3.85 1.732 3.609 5.084a5.951 5.951 0 0 0-1.23 1.066l-2.158-2.126a.161.161 0 0 1 .009-.238l.395-.33-2.149-2.177a.16.16 0 0 1 .012-.236l1.277-1.073a.161.161 0 0 1 .235.03Zm-3.027 2.943a.163.163 0 0 0-.231.052l-.834 1.445a.161.161 0 0 0 .07.226l2.764 1.31-.258.446a.16.16 0 0 0 .072.227l2.754 1.259c.2-.513.466-.99.792-1.42l-5.129-3.545Zm-2.036 3.929a.16.16 0 0 1 .199-.128l6.031 1.575a5.953 5.953 0 0 0-.255 1.607l-3.02-.243a.161.161 0 0 1-.146-.188l.091-.507-3.045-.285a.162.162 0 0 1-.143-.189l.289-1.643h-.001Zm-.228 4.073a.16.16 0 0 0-.143.19l.289 1.643a.161.161 0 0 0 .199.127l2.959-.773.089.506a.16.16 0 0 0 .201.127l2.919-.806a5.875 5.875 0 0 1-.306-1.598l-6.207.584Zm.965 4.32a.16.16 0 0 1 .07-.226l5.632-2.67c.214.505.498.974.837 1.394l-2.468 1.756a.16.16 0 0 1-.232-.05l-.257-.447-2.516 1.74a.161.161 0 0 1-.231-.052l-.835-1.445Zm6.824-1.172-4.381 4.438a.16.16 0 0 0 .011.236l1.278 1.072c.073.061.181.047.236-.03l1.769-2.495.394.332c.072.061.182.047.236-.032l1.718-2.492a6.028 6.028 0 0 1-1.261-1.029Zm-.865 7.125a.16.16 0 0 1-.091-.219l2.598-5.668c.478.244.994.426 1.536.534l-.762 2.93a.16.16 0 0 1-.21.11l-.484-.177-.81 2.95a.16.16 0 0 1-.21.108l-1.569-.57.002.002Zm4.474-5.284-.503 6.216a.161.161 0 0 0 .16.174h1.668a.16.16 0 0 0 .16-.174l-.248-3.049h.514a.16.16 0 0 0 .161-.175l-.287-3.014a6.032 6.032 0 0 1-1.626.023l.001-.001Zm6.017-16.824a.162.162 0 0 0-.091-.219l-1.568-.57a.162.162 0 0 0-.211.108l-.81 2.95-.484-.177a.16.16 0 0 0-.21.11l-.762 2.93c.542.108 1.058.29 1.536.535l2.6-5.668Zm3.424 2.47-4.381 4.438a5.95 5.95 0 0 0-1.261-1.03l1.718-2.492a.16.16 0 0 1 .236-.031l.394.332 1.769-2.495a.161.161 0 0 1 .235-.03l1.278 1.072a.16.16 0 0 1 .012.236Zm2.372 3.493a.16.16 0 0 0 .07-.226l-.835-1.446a.16.16 0 0 0-.231-.051l-2.515 1.739-.257-.447a.16.16 0 0 0-.232-.05l-2.469 1.756c.34.422.623.89.838 1.395l5.631-2.67Zm.889 2.262.29 1.643a.161.161 0 0 1-.143.189l-6.207.582a5.875 5.875 0 0 0-.307-1.598l2.919-.805a.16.16 0 0 1 .201.127l.088.506 2.959-.773a.16.16 0 0 1 .199.128h.001Zm-.28 6.032a.161.161 0 0 0 .199-.127l.288-1.644a.161.161 0 0 0-.143-.189l-3.045-.285.091-.507a.16.16 0 0 0-.145-.188l-3.02-.243a5.96 5.96 0 0 1-.256 1.608l6.032 1.574-.001.001Zm-1.607 3.75a.162.162 0 0 1-.231.052l-5.13-3.544c.326-.43.593-.908.792-1.42l2.754 1.26a.16.16 0 0 1 .072.226l-.259.445 2.764 1.311a.16.16 0 0 1 .07.226l-.834 1.445h.002Zm-6.867-2.09 3.609 5.085c.055.077.162.091.235.03l1.278-1.073a.16.16 0 0 0 .011-.236l-2.149-2.176.395-.33a.16.16 0 0 0 .009-.238l-2.158-2.126a5.957 5.957 0 0 1-1.23 1.065Zm-.031 6.924a.161.161 0 0 1-.21-.108l-1.652-6.014c.54-.123 1.05-.32 1.521-.578l1.299 2.734a.16.16 0 0 1-.09.221l-.485.175 1.275 2.781a.161.161 0 0 1-.09.219l-1.569.571.001-.001Z",
                    fill: "#AF9EFF"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M98.336 164.738a1.108 1.108 0 0 1-.994 1.202c-.955.089-1.898.245-2.823.464a1.09 1.09 0 0 1-1.314-.821 1.11 1.11 0 0 1 .821-1.328 22.93 22.93 0 0 1 3.122-.514 1.093 1.093 0 0 1 1.188.997Zm13.787 4.174a1.092 1.092 0 0 1 1.541-.17 23.077 23.077 0 0 1 6.203 7.835 23.22 23.22 0 0 1 1.502 16.316 1.1 1.1 0 0 1-1.347.777 1.1 1.1 0 0 1-.766-1.355 21.001 21.001 0 0 0-1.358-14.761 20.886 20.886 0 0 0-5.614-7.09 1.109 1.109 0 0 1-.161-1.552Zm-21.564-2.373c.266.547.04 1.209-.504 1.479a21.051 21.051 0 0 0-5.494 3.938 20.965 20.965 0 0 0-3.436 4.498 21.204 21.204 0 0 0-2.015 4.889 21.118 21.118 0 0 0-.715 6.876 20.995 20.995 0 0 0 6.222 13.666 20.574 20.574 0 0 0 9.033 5.188c3.53.965 7.096.953 10.416.128a20.978 20.978 0 0 0 8.362-4.243 1.09 1.09 0 0 1 1.542.144c.385.47.317 1.166-.15 1.555a23.18 23.18 0 0 1-9.238 4.688 22.754 22.754 0 0 1-11.514-.141 22.75 22.75 0 0 1-9.986-5.735 23.203 23.203 0 0 1-6.874-15.104 23.34 23.34 0 0 1 .789-7.599 23.423 23.423 0 0 1 2.227-5.402 23.166 23.166 0 0 1 3.8-4.975 23.264 23.264 0 0 1 6.07-4.351c.544-.27 1.2-.046 1.465.501Z",
                fill: "#CABEFF",
                fillOpacity: 0.2
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M86 194.449c0-3.075 2.933-14.547 8.998-22.234-4.28 8.081-6.771 13.553-4.955 17.819 1.427 3.351 8.76 2.286 12.725.946-7.056 3.193-14.297 3.627-16.768 3.469Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M99.137 171.875c2.678 1.537 11.201 9.8 14.863 18.867-4.897-7.728-8.417-12.609-13.039-13.177-3.632-.446-6.372 6.402-7.187 10.486.748-7.674 3.99-14.127 5.363-16.176Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M112.287 194.422c-2.677 1.537-14.134 4.747-23.86 3.367 9.177-.354 15.188-.945 17.994-4.642 2.204-2.904-2.389-8.688-5.539-11.432 6.309 4.48 10.307 10.5 11.405 12.707Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_2731_87774",
                        x1: 43,
                        y1: 99,
                        x2: 19.686,
                        y2: 157,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#A089E1"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#816DB9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_2731_87774",
                        x1: 44.584,
                        y1: 114.617,
                        x2: 44.584,
                        y2: 133.055,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FFD4B3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFDCC2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint2_linear_2731_87774",
                        x1: 120.377,
                        y1: 102,
                        x2: 106.437,
                        y2: 154.02,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#A089E1"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#816DB9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint3_linear_2731_87774",
                        x1: 117.831,
                        y1: 132.612,
                        x2: 129.398,
                        y2: 121.307,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FFD099"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFC37D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint4_linear_2731_87774",
                        x1: 194.372,
                        y1: 59.489,
                        x2: 225.817,
                        y2: 44.213,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint5_linear_2731_87774",
                        x1: 202.501,
                        y1: 66.582,
                        x2: 217.966,
                        y2: 44.815,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAABFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint6_linear_2731_87774",
                        x1: 194.372,
                        y1: 199.489,
                        x2: 225.817,
                        y2: 184.213,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint7_linear_2731_87774",
                        x1: 202.501,
                        y1: 206.582,
                        x2: 217.966,
                        y2: 184.815,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAABFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint8_linear_2731_87774",
                        x1: 201.32,
                        y1: 130.087,
                        x2: 225.153,
                        y2: 125.199,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint9_linear_2731_87774",
                        x1: 206.515,
                        y1: 140.823,
                        x2: 228.286,
                        y2: 127.884,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAABFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("clipPath", {
                        id: "clip0_2731_87774",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(58 48)",
                            d: "M0 0h26v26H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("clipPath", {
                        id: "clip1_2731_87774",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(122 65)",
                            d: "M0 0h24.538v24.538H0z"
                        })
                    })
                ]
            })
        ]
    });
var $1914b4197efeea0c$export$2e2bcd8739ae039 = $1914b4197efeea0c$var$SvgSsoConnectorEmptyDark;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $db56e945ce261f42$var$SvgSsoConnectorEmpty = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M42.712 204.2a6.134 6.134 0 1 0 6.285-10.537 6.134 6.134 0 0 0-6.285 10.537Zm1.572-2.634a3.068 3.068 0 1 0 3.14-5.269 3.068 3.068 0 0 0-3.14 5.269Z",
                fill: "#DBC1FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M27.926 70.828a2.045 2.045 0 0 0-.22-2.884l-1.878-1.612a2.045 2.045 0 0 0-2.883.22l-1.613 1.877a2.045 2.045 0 0 0 .22 2.884l1.878 1.612a2.045 2.045 0 0 0 2.883-.22l1.613-1.877Z",
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M168.233 70c0-7.05 5.716-12.767 12.767-12.767h2v1.534h-2c-6.204 0-11.233 5.03-11.233 11.233v117c0 6.204 5.029 11.233 11.233 11.233h2v1.534h-2c-7.051 0-12.767-5.716-12.767-12.767V70Z",
                fill: "#A782E8"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M153.999 127.233h29v1.534h-29v-1.534ZM72 127.233h14v1.534H72v-1.534Z",
                fill: "#A782E8"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M14 111.269C14 104.493 19.493 99 26.269 99h33.462C66.507 99 72 104.493 72 111.269v33.462C72 151.507 66.507 157 59.73 157H26.27C19.493 157 14 151.507 14 144.731v-33.462Z",
                fill: "url(#paint0_linear_2731_87834)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M47.695 129.398v3.293c0 .634-9.39.421-9.39-.493 0-.861.017-4.761 0-8.772-2.103-2.719-2.103-4.418-.44-6.175 1.662-1.756 13.498-2.634 13.498-2.634s.888 8.519 1.027 10.83c.056.929.66 3.951-1.687 3.951h-3.008Z",
                fill: "url(#paint1_linear_2731_87834)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M47.692 129.113a13.916 13.916 0 0 1-5.425-1.767s1.174 2.78 5.425 3.535v-1.768Z",
                fill: "#FFD7B8",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M58.406 139.246c.869 1.761 1.566 4.596 2.09 8.503a.763.763 0 0 1-.758.863H26.263a.763.763 0 0 1-.759-.863c.525-3.908 1.222-6.742 2.09-8.503.928-1.882 9.537-5.504 9.537-5.504s.172-1.656.587-1.893c.416-.238 10.07-.237 10.564 0 .495.237.587 1.892.587 1.892s8.611 3.627 9.537 5.505Z",
                fill: "#6F45E5"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M40.216 119.036c-.466-.4-1.033-.669-1.835-.254-1.9.984-.639 4.78 1.488 4.706.733-.026.397 1.433-1.563 2.396 0-1.537-2.348-5.342-2.553-8.806-2.362-.878-1.775-4.388-.154-4.388-.258-3.218 4.908-4.881 6.908-3.034 2.035-2.432 7.17-1.188 7.48.922 3.532-1.88 5.853 3.524 2.546 5.622-1.36.864-4.543 1.192-9.138 1.192-2.204 0-.936 5.147-.247 6.809.88 2.122 5.796 2.414 7.336 2.195 1.203-.171 1.834-.659 1.908-.951 1.1 2.927-.294 4.683-2.495 4.683-3.741 0-7.483-1.098-8.07-3.805-.467-2.155-.441-5.632-1.61-7.287Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M98.902 149.905c-8.12-.593-14.525-7.439-14.525-15.798 0-8.567 6.729-15.545 15.136-15.83 2.272-9.345 10.616-16.277 20.562-16.277 9.64 0 17.775 6.511 20.335 15.42 8.868.286 15.967 7.456 15.967 16.259 0 8.524-6.656 15.516-15.129 16.211v.11H98.902v-.095Z",
                fill: "url(#paint2_linear_2731_87834)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M120.401 125.349a3.22 3.22 0 0 1-4.628 0 3.404 3.404 0 0 1 0-4.736 3.22 3.22 0 0 1 4.628 0 3.404 3.404 0 0 1 0 4.736Zm-7.714 3.158a7.51 7.51 0 0 0 9.033 1.349l4.586 4.693-.751.768a1.135 1.135 0 0 0 0 1.579l1.543 1.578a1.072 1.072 0 0 0 1.542 0l.751-.768 2.284 2.337a2.147 2.147 0 0 0 3.086 0 2.27 2.27 0 0 0 0-3.158l-9.955-10.186c1.566-2.961 1.127-6.74-1.319-9.243a7.514 7.514 0 0 0-10.8 0c-2.982 3.052-2.982 7.999 0 11.051Z",
                fill: "#FDCF90"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M120.401 125.349a3.22 3.22 0 0 1-4.628 0 3.404 3.404 0 0 1 0-4.736 3.22 3.22 0 0 1 4.628 0 3.404 3.404 0 0 1 0 4.736Zm-7.714 3.158a7.51 7.51 0 0 0 9.033 1.349l4.586 4.693-.751.768a1.135 1.135 0 0 0 0 1.579l1.543 1.578a1.072 1.072 0 0 0 1.542 0l.751-.768 2.284 2.337a2.147 2.147 0 0 0 3.086 0 2.27 2.27 0 0 0 0-3.158l-9.955-10.186c1.566-2.961 1.127-6.74-1.319-9.243a7.514 7.514 0 0 0-10.8 0c-2.982 3.052-2.982 7.999 0 11.051Z",
                fill: "url(#paint3_linear_2731_87834)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M184 41.269C184 34.493 189.493 29 196.269 29h33.462C236.507 29 242 34.493 242 41.269v33.462C242 81.507 236.507 87 229.731 87h-33.462C189.493 87 184 81.507 184 74.731V41.269Z",
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                opacity: 0.5,
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M196.269 29.75c-6.362 0-11.519 5.157-11.519 11.519v33.462c0 6.362 5.157 11.519 11.519 11.519H230.5c5.937 0 10.75-4.813 10.75-10.75V41.269c0-6.362-5.157-11.519-11.519-11.519H229v-1.5h.731c7.19 0 13.019 5.829 13.019 13.019V75.5c0 6.766-5.485 12.25-12.25 12.25h-34.231c-7.19 0-13.019-5.829-13.019-13.019V41.269c0-7.19 5.829-13.019 13.019-13.019H222v1.5h-25.731Z",
                fill: "#A782E8"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                opacity: 0.8,
                d: "M197.001 48.116a2.56 2.56 0 0 1 2.56-2.56h26.88a2.56 2.56 0 0 1 2.56 2.56v19.2a2.56 2.56 0 0 1-2.56 2.56h-26.88a2.56 2.56 0 0 1-2.56-2.56v-19.2Z",
                fill: "url(#paint4_linear_2731_87834)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M197.001 50.768h32v-2.733a2.479 2.479 0 0 0-2.479-2.479H199.48a2.479 2.479 0 0 0-2.479 2.479v2.733Z",
                fill: "#5D34F2"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M200.557 55.109c0-.48.389-.869.868-.869h8.93a.869.869 0 0 1 0 1.737h-8.93a.869.869 0 0 1-.868-.868ZM200.557 60.322c0-.48.389-.869.868-.869h19.596a.869.869 0 1 1 0 1.737h-19.596a.869.869 0 0 1-.868-.868ZM184 181.269c0-6.776 5.493-12.269 12.269-12.269h33.462c6.776 0 12.269 5.493 12.269 12.269v33.462c0 6.776-5.493 12.269-12.269 12.269h-33.462c-6.776 0-12.269-5.493-12.269-12.269v-33.462Z",
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                opacity: 0.8,
                d: "M197.001 188.116a2.56 2.56 0 0 1 2.56-2.56h26.88a2.56 2.56 0 0 1 2.56 2.56v19.2a2.56 2.56 0 0 1-2.56 2.56h-26.88a2.56 2.56 0 0 1-2.56-2.56v-19.2Z",
                fill: "url(#paint5_linear_2731_87834)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M197.001 190.768h32v-2.733a2.48 2.48 0 0 0-2.479-2.479H199.48a2.48 2.48 0 0 0-2.479 2.479v2.733Z",
                fill: "#5D34F2"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M200.557 195.109c0-.48.389-.869.868-.869h8.93a.869.869 0 0 1 0 1.737h-8.93a.868.868 0 0 1-.868-.868ZM200.557 200.322c0-.48.389-.869.868-.869h19.596a.869.869 0 1 1 0 1.737h-19.596a.868.868 0 0 1-.868-.868Z",
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                opacity: 0.5,
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M196.269 169.75c-6.362 0-11.519 5.157-11.519 11.519v33.462c0 6.362 5.157 11.519 11.519 11.519H230.5c5.937 0 10.75-4.813 10.75-10.75v-34.231c0-6.362-5.157-11.519-11.519-11.519H229v-1.5h.731c7.19 0 13.019 5.829 13.019 13.019V215.5c0 6.765-5.485 12.25-12.25 12.25h-34.231c-7.19 0-13.019-5.829-13.019-13.019v-33.462c0-7.19 5.829-13.019 13.019-13.019H222v1.5h-25.731Z",
                fill: "#A782E8"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M184 111.269C184 104.493 189.493 99 196.269 99h33.462c6.776 0 12.269 5.493 12.269 12.269v33.462c0 6.776-5.493 12.269-12.269 12.269h-33.462c-6.776 0-12.269-5.493-12.269-12.269v-33.462Z",
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                opacity: 0.5,
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M196.269 99.75c-6.362 0-11.519 5.157-11.519 11.519v33.462c0 6.362 5.157 11.519 11.519 11.519h33.462c6.362 0 11.519-5.157 11.519-11.519v-33.462c0-6.362-5.157-11.519-11.519-11.519H205v-1.5h24.731c7.19 0 13.019 5.829 13.019 13.019v33.462c0 7.19-5.829 13.019-13.019 13.019h-33.462c-7.19 0-13.019-5.829-13.019-13.019v-33.462c0-7.19 5.829-13.019 13.019-13.019h1.231v1.5h-1.231Z",
                fill: "#A782E8"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M203 113.908c0-2.711 2.289-4.908 5.112-4.908h10.224c2.824 0 5.112 2.197 5.112 4.908V140.9c0 2.71-2.288 4.907-5.112 4.907h-10.224c-2.823 0-5.112-2.197-5.112-4.907v-26.992Z",
                fill: "url(#paint6_linear_2731_87834)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M215.142 140.899c0 .978-.833 1.815-1.917 1.815s-1.917-.837-1.917-1.815.833-1.815 1.917-1.815 1.917.837 1.917 1.815Z",
                stroke: "#F5EEFF",
                strokeWidth: 1.278
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M208.112 110.278c0-.706.572-1.278 1.278-1.278h7.668c.706 0 1.279.572 1.279 1.278v1.176c0 .677-.573 1.227-1.279 1.227h-7.668c-.706 0-1.278-.55-1.278-1.227v-1.176Z",
                fill: "#4300DA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M64.36 40.718a1.107 1.107 0 0 1-.643 1.421c-.898.339-1.767.738-2.6 1.193a1.09 1.09 0 0 1-1.485-.446 1.11 1.11 0 0 1 .442-1.497 22.792 22.792 0 0 1 2.876-1.319 1.092 1.092 0 0 1 1.41.648Zm14.398.392a1.092 1.092 0 0 1 1.442-.57 23.07 23.07 0 0 1 8.05 5.922A23.224 23.224 0 0 1 94 61.805a1.1 1.1 0 0 1-1.095 1.104 1.1 1.1 0 0 1-1.096-1.104c0-5.323-1.963-10.181-5.202-13.881a20.88 20.88 0 0 0-7.284-5.36 1.108 1.108 0 0 1-.565-1.454Zm-21.426 3.396c.4.457.357 1.155-.096 1.559a21.053 21.053 0 0 0-4.262 5.247 20.951 20.951 0 0 0-2.128 5.245 21.196 21.196 0 0 0-.655 5.248c0 2.39.395 4.683 1.123 6.82a21 21 0 0 0 9.605 11.543A20.574 20.574 0 0 0 71 82.791c3.66 0 7.096-.952 10.082-2.623a20.98 20.98 0 0 0 6.946-6.297 1.09 1.09 0 0 1 1.526-.267 1.11 1.11 0 0 1 .265 1.539 23.176 23.176 0 0 1-7.675 6.957A22.75 22.75 0 0 1 71 85a22.75 22.75 0 0 1-11.144-2.9 23.2 23.2 0 0 1-10.614-12.757A23.345 23.345 0 0 1 48 61.805c0-2 .251-3.944.725-5.798a23.166 23.166 0 0 1 2.353-5.8 23.256 23.256 0 0 1 4.708-5.798 1.089 1.089 0 0 1 1.546.097Z",
                fill: "#E5E1EC"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                clipPath: "url(#clip0_2731_87834)",
                fill: "#AF9EFF",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "m83.999 62.95-.65-5.85-1.886 1.236C79.71 57.23 77.5 56.45 75.03 56.06c0 0-1.236-.26-2.86-.26-1.626 0-3.12.195-3.12.195-6.306.78-11.05 4.355-11.05 8.645 0 4.42 4.874 8.06 12.35 8.71v-2.535c-5.136-.715-8.386-3.12-8.386-6.175 0-2.86 2.99-5.265 7.086-6.045 0 0 3.184-.715 5.98.13 1.365.325 2.6.78 3.64 1.43l-2.47 1.495 7.8 1.3Z",
                        fillOpacity: 0.6
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M70.348 50.6v22.75l3.9-1.95V48.65l-3.9 1.95Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M154 77c0 11.046-8.954 20-20 20s-20-8.954-20-20 8.954-20 20-20 20 8.954 20 20Z",
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("g", {
                clipPath: "url(#clip1_2731_87834)",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "m135.498 65.174-.503 6.215a6.004 6.004 0 0 0-1.627.024l-.287-3.014a.16.16 0 0 1 .161-.175h.515l-.249-3.05a.16.16 0 0 1 .16-.174h1.668c.094 0 .167.08.16.174h.002Zm-4.211.308a.16.16 0 0 0-.21-.108l-1.568.572a.16.16 0 0 0-.091.218l1.275 2.78-.484.176a.161.161 0 0 0-.091.22l1.299 2.735c.471-.26.982-.455 1.521-.578l-1.651-6.014Zm-3.85 1.732 3.609 5.084a5.951 5.951 0 0 0-1.23 1.066l-2.158-2.126a.161.161 0 0 1 .009-.238l.395-.33-2.149-2.177a.16.16 0 0 1 .012-.236l1.277-1.073a.161.161 0 0 1 .235.03Zm-3.027 2.943a.163.163 0 0 0-.231.052l-.834 1.445a.161.161 0 0 0 .07.226l2.764 1.31-.258.446a.16.16 0 0 0 .072.227l2.754 1.259c.2-.513.466-.99.792-1.42l-5.129-3.545Zm-2.036 3.929a.16.16 0 0 1 .199-.128l6.031 1.575a5.953 5.953 0 0 0-.255 1.607l-3.02-.243a.161.161 0 0 1-.146-.188l.091-.507-3.045-.285a.162.162 0 0 1-.143-.189l.289-1.643h-.001Zm-.228 4.073a.16.16 0 0 0-.143.19l.289 1.643a.161.161 0 0 0 .199.127l2.959-.773.089.506a.16.16 0 0 0 .201.127l2.919-.806a5.875 5.875 0 0 1-.306-1.598l-6.207.584Zm.965 4.32a.16.16 0 0 1 .07-.226l5.632-2.67c.214.505.498.974.837 1.394l-2.468 1.756a.16.16 0 0 1-.232-.05l-.257-.447-2.516 1.74a.161.161 0 0 1-.231-.052l-.835-1.445Zm6.824-1.172-4.381 4.438a.16.16 0 0 0 .011.236l1.278 1.072c.073.061.181.047.236-.03l1.769-2.495.394.332c.072.061.182.047.236-.032l1.718-2.492a6.028 6.028 0 0 1-1.261-1.029Zm-.865 7.125a.16.16 0 0 1-.091-.219l2.598-5.668c.478.244.994.426 1.536.534l-.762 2.93a.16.16 0 0 1-.21.11l-.484-.177-.81 2.95a.16.16 0 0 1-.21.108l-1.569-.57.002.002Zm4.474-5.284-.503 6.216a.161.161 0 0 0 .16.174h1.668a.16.16 0 0 0 .16-.174l-.248-3.049h.514a.16.16 0 0 0 .161-.175l-.287-3.014a6.032 6.032 0 0 1-1.626.023l.001-.001Zm6.017-16.824a.162.162 0 0 0-.091-.219l-1.568-.57a.162.162 0 0 0-.211.108l-.81 2.95-.484-.177a.16.16 0 0 0-.21.11l-.762 2.93c.542.108 1.058.29 1.536.535l2.6-5.668Zm3.424 2.47-4.381 4.438a5.95 5.95 0 0 0-1.261-1.03l1.718-2.492a.16.16 0 0 1 .236-.031l.394.332 1.769-2.495a.161.161 0 0 1 .235-.03l1.278 1.072a.16.16 0 0 1 .012.236Zm2.372 3.493a.16.16 0 0 0 .07-.226l-.835-1.446a.16.16 0 0 0-.231-.051l-2.515 1.739-.257-.447a.16.16 0 0 0-.232-.05l-2.469 1.756c.34.422.623.89.838 1.395l5.631-2.67Zm.889 2.262.29 1.643a.161.161 0 0 1-.143.189l-6.207.582a5.875 5.875 0 0 0-.307-1.598l2.919-.805a.16.16 0 0 1 .201.127l.088.506 2.959-.773a.16.16 0 0 1 .199.128h.001Zm-.28 6.032a.161.161 0 0 0 .199-.127l.288-1.644a.161.161 0 0 0-.143-.189l-3.045-.285.091-.507a.16.16 0 0 0-.145-.188l-3.02-.243a5.96 5.96 0 0 1-.256 1.608l6.032 1.574-.001.001Zm-1.607 3.75a.162.162 0 0 1-.231.052l-5.13-3.544c.326-.43.593-.908.792-1.42l2.754 1.26a.16.16 0 0 1 .072.226l-.259.445 2.764 1.311a.16.16 0 0 1 .07.226l-.834 1.445h.002Zm-6.867-2.09 3.609 5.085c.055.077.162.091.235.03l1.278-1.073a.16.16 0 0 0 .011-.236l-2.149-2.176.395-.33a.16.16 0 0 0 .009-.238l-2.158-2.126a5.957 5.957 0 0 1-1.23 1.065Zm-.031 6.924a.161.161 0 0 1-.21-.108l-1.652-6.014c.54-.123 1.05-.32 1.521-.578l1.299 2.734a.16.16 0 0 1-.09.221l-.485.175 1.275 2.781a.161.161 0 0 1-.09.219l-1.569.571.001-.001Z",
                    fill: "#AF9EFF"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M86 194.449c0-3.075 2.934-14.547 8.999-22.234-4.281 8.081-6.772 13.553-4.955 17.819 1.427 3.351 8.76 2.286 12.724.946-7.056 3.193-14.297 3.627-16.767 3.469Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M99.138 171.875c2.678 1.537 11.201 9.8 14.863 18.867-4.897-7.728-8.417-12.609-13.04-13.177-3.631-.446-6.371 6.402-7.186 10.486.747-7.674 3.99-14.127 5.363-16.176Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M112.288 194.422c-2.678 1.537-14.135 4.747-23.861 3.367 9.178-.354 15.188-.945 17.994-4.642 2.205-2.904-2.389-8.688-5.538-11.432 6.309 4.48 10.307 10.5 11.405 12.707Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M98.337 164.738a1.108 1.108 0 0 1-.995 1.202c-.955.089-1.898.245-2.823.464a1.09 1.09 0 0 1-1.314-.821 1.11 1.11 0 0 1 .822-1.328 22.927 22.927 0 0 1 3.121-.514 1.093 1.093 0 0 1 1.189.997Zm13.786 4.174a1.092 1.092 0 0 1 1.541-.17 23.068 23.068 0 0 1 6.204 7.835 23.23 23.23 0 0 1 1.502 16.316 1.101 1.101 0 0 1-1.348.777 1.1 1.1 0 0 1-.765-1.355 21.001 21.001 0 0 0-6.972-21.851 1.109 1.109 0 0 1-.162-1.552Zm-21.563-2.373c.265.547.04 1.209-.504 1.479a21.054 21.054 0 0 0-5.495 3.938 20.968 20.968 0 0 0-3.435 4.498 21.2 21.2 0 0 0-2.016 4.889 21.118 21.118 0 0 0-.714 6.876 20.995 20.995 0 0 0 6.222 13.666 20.574 20.574 0 0 0 9.033 5.188c3.53.965 7.095.953 10.416.128a20.98 20.98 0 0 0 8.361-4.243 1.09 1.09 0 0 1 1.543.144c.384.47.317 1.166-.15 1.555a23.186 23.186 0 0 1-9.238 4.688 22.756 22.756 0 0 1-11.515-.141 22.749 22.749 0 0 1-9.985-5.735 23.203 23.203 0 0 1-6.875-15.104 23.34 23.34 0 0 1 .79-7.599 23.419 23.419 0 0 1 2.227-5.402 23.169 23.169 0 0 1 3.799-4.975 23.265 23.265 0 0 1 6.07-4.351c.544-.27 1.2-.046 1.466.501Z",
                fill: "#E5E1EC"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_2731_87834",
                        x1: 43,
                        y1: 122.304,
                        x2: 19.686,
                        y2: 157,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#C39EFF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#906FEF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_2731_87834",
                        x1: 44.584,
                        y1: 114.617,
                        x2: 44.584,
                        y2: 133.055,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FFD4B3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFDCC2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint2_linear_2731_87834",
                        x1: 120.377,
                        y1: 102,
                        x2: 106.437,
                        y2: 154.02,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#C39EFF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#906FEF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint3_linear_2731_87834",
                        x1: 117.831,
                        y1: 132.612,
                        x2: 129.398,
                        y2: 121.307,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FFD099"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFC37D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint4_linear_2731_87834",
                        x1: 194.372,
                        y1: 59.489,
                        x2: 225.817,
                        y2: 44.213,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint5_linear_2731_87834",
                        x1: 194.372,
                        y1: 199.489,
                        x2: 225.817,
                        y2: 184.213,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint6_linear_2731_87834",
                        x1: 201.32,
                        y1: 130.087,
                        x2: 225.153,
                        y2: 125.199,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("clipPath", {
                        id: "clip0_2731_87834",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(58 48)",
                            d: "M0 0h26v26H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("clipPath", {
                        id: "clip1_2731_87834",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(122 65)",
                            d: "M0 0h24.538v24.538H0z"
                        })
                    })
                ]
            })
        ]
    });
var $db56e945ce261f42$export$2e2bcd8739ae039 = $db56e945ce261f42$var$SvgSsoConnectorEmpty;





var $8Mb3E = parcelRequire("8Mb3E");

var $8TpMk = parcelRequire("8TpMk");


var $cDKfs = parcelRequire("cDKfs");

var $jGWQ4 = parcelRequire("jGWQ4");




var $4ZcUR = parcelRequire("4ZcUR");

var $7kooT = parcelRequire("7kooT");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");

var $5UrGx = parcelRequire("5UrGx");


var $jheqv = parcelRequire("jheqv");
var $9beadbdb6d1ff38e$export$34e0f9847d4c02dd;
var $9beadbdb6d1ff38e$export$db3c28d99448dcff;
$9beadbdb6d1ff38e$export$34e0f9847d4c02dd = `KNePoW_container`;
$9beadbdb6d1ff38e$export$db3c28d99448dcff = `KNePoW_logo`;


const $d136fd1291c68114$export$9c5801498225ab9c = (isDarkMode, logo, logoDark)=>{
    return (isDarkMode ? logoDark : logo) || logoDark || logo;
};


/**
 * Prioritize `branding` configuration:
 *   - Even if it's in light mode and have `branding.darkLogo` configured, use `branding.darkLogo`.
 */ const $608656f1bddbd059$var$pickLogoForCurrentTheme = (isDarkMode, { logo: logo, logoDark: logoDark }, branding)=>{
    // Need to use `||` here since `??` operator can not avoid empty strings.
    // Since `logo` and `darkLogo` are both optional, when it is dark mode and `darkLogo` is not configured, should fallback to `logo`.
    const configuredLogo = (0, $d136fd1291c68114$export$9c5801498225ab9c)(isDarkMode, branding.logo, branding.darkLogo);
    const builtInLogo = (0, $d136fd1291c68114$export$9c5801498225ab9c)(isDarkMode, logo, logoDark);
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    return configuredLogo || builtInLogo;
};
function $608656f1bddbd059$var$SsoConnectorLogo({ className: className, containerClassName: containerClassName, data: data }) {
    const theme = (0, $jheqv.default)();
    const isDarkMode = theme === (0, $5HVJe.Theme).Dark;
    const { providerLogo: logo, providerLogoDark: logoDark, branding: branding } = data;
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dbaecc0d7fe55772$export$2e2bcd8739ae039), {
        containerClassName: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($9beadbdb6d1ff38e$export$34e0f9847d4c02dd, containerClassName),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($9beadbdb6d1ff38e$export$db3c28d99448dcff, className),
        alt: "logo",
        src: $608656f1bddbd059$var$pickLogoForCurrentTheme(isDarkMode, {
            logo: logo,
            logoDark: logoDark
        }, branding)
    });
}
var $608656f1bddbd059$export$2e2bcd8739ae039 = $608656f1bddbd059$var$SsoConnectorLogo;



var $C7mD2 = parcelRequire("C7mD2");

var $5cXXM = parcelRequire("5cXXM");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $kUZ14 = parcelRequire("kUZ14");

var $voszV = parcelRequire("voszV");





var $8TpMk = parcelRequire("8TpMk");


var $jGWQ4 = parcelRequire("jGWQ4");

var $66ixW = parcelRequire("66ixW");

var $aqmjm = parcelRequire("aqmjm");

var $5vVWy = parcelRequire("5vVWy");

var $fmHmG = parcelRequire("fmHmG");

var $7VnwS = parcelRequire("7VnwS");

var $dW2kG = parcelRequire("dW2kG");

var $5OcFi = parcelRequire("5OcFi");

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");

var $5UrGx = parcelRequire("5UrGx");


var $jheqv = parcelRequire("jheqv");
var $4fe27205021fcba7$export$34e0f9847d4c02dd;
var $4fe27205021fcba7$export$a7db06668cad9adb;
var $4fe27205021fcba7$export$6d59db4903f20f7d;
var $4fe27205021fcba7$export$db3c28d99448dcff;
var $4fe27205021fcba7$export$a8ff84c12d48cfa6;
var $4fe27205021fcba7$export$bfd64c937657f93a;
var $4fe27205021fcba7$export$4a6dd88bada4e7d2;
var $4fe27205021fcba7$export$8d4349e65e8dc335;
$4fe27205021fcba7$export$34e0f9847d4c02dd = `EhFvKG_container`;
$4fe27205021fcba7$export$a7db06668cad9adb = `EhFvKG_content`;
$4fe27205021fcba7$export$6d59db4903f20f7d = `EhFvKG_description`;
$4fe27205021fcba7$export$db3c28d99448dcff = `EhFvKG_logo`;
$4fe27205021fcba7$export$a8ff84c12d48cfa6 = `EhFvKG_name`;
$4fe27205021fcba7$export$bfd64c937657f93a = `EhFvKG_rotating`;
$4fe27205021fcba7$export$4a6dd88bada4e7d2 = `EhFvKG_shimmer`;
$4fe27205021fcba7$export$8d4349e65e8dc335 = `EhFvKG_ssoConnector`;


function $49e6678f0ea81000$var$SsoConnectorRadio({ data: { logo: logo, logoDark: logoDark, description: description, name: name } }) {
    const theme = (0, $jheqv.default)();
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $4fe27205021fcba7$export$8d4349e65e8dc335,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dbaecc0d7fe55772$export$2e2bcd8739ae039), {
                containerClassName: $4fe27205021fcba7$export$34e0f9847d4c02dd,
                className: $4fe27205021fcba7$export$db3c28d99448dcff,
                alt: "logo",
                src: theme === (0, $5HVJe.Theme).Light ? logo : logoDark
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $4fe27205021fcba7$export$a7db06668cad9adb,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($4fe27205021fcba7$export$a8ff84c12d48cfa6),
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                            children: name
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $4fe27205021fcba7$export$6d59db4903f20f7d,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                            children: description
                        })
                    })
                ]
            })
        ]
    });
}
var $49e6678f0ea81000$export$2e2bcd8739ae039 = $49e6678f0ea81000$var$SsoConnectorRadio;


var $3377f11fd0d03b1b$exports = {};

$parcel$export($3377f11fd0d03b1b$exports, "large", function () { return $3377f11fd0d03b1b$export$f09585a853dddd32; }, function (v) { return $3377f11fd0d03b1b$export$f09585a853dddd32 = v; });
$parcel$export($3377f11fd0d03b1b$exports, "medium", function () { return $3377f11fd0d03b1b$export$649ecc744817b5c7; }, function (v) { return $3377f11fd0d03b1b$export$649ecc744817b5c7 = v; });
$parcel$export($3377f11fd0d03b1b$exports, "rotating", function () { return $3377f11fd0d03b1b$export$bfd64c937657f93a; }, function (v) { return $3377f11fd0d03b1b$export$bfd64c937657f93a = v; });
$parcel$export($3377f11fd0d03b1b$exports, "shimmer", function () { return $3377f11fd0d03b1b$export$4a6dd88bada4e7d2; }, function (v) { return $3377f11fd0d03b1b$export$4a6dd88bada4e7d2 = v; });
$parcel$export($3377f11fd0d03b1b$exports, "ssoConnectorGroup", function () { return $3377f11fd0d03b1b$export$956c7f28362e1bcc; }, function (v) { return $3377f11fd0d03b1b$export$956c7f28362e1bcc = v; });
var $3377f11fd0d03b1b$export$f09585a853dddd32;
var $3377f11fd0d03b1b$export$649ecc744817b5c7;
var $3377f11fd0d03b1b$export$bfd64c937657f93a;
var $3377f11fd0d03b1b$export$4a6dd88bada4e7d2;
var $3377f11fd0d03b1b$export$956c7f28362e1bcc;
$3377f11fd0d03b1b$export$f09585a853dddd32 = `zOIz_a_large`;
$3377f11fd0d03b1b$export$649ecc744817b5c7 = `zOIz_a_medium`;
$3377f11fd0d03b1b$export$bfd64c937657f93a = `zOIz_a_rotating`;
$3377f11fd0d03b1b$export$4a6dd88bada4e7d2 = `zOIz_a_shimmer`;
$3377f11fd0d03b1b$export$956c7f28362e1bcc = `zOIz_a_ssoConnectorGroup`;


function $ff12107e772eab7a$var$SsoConnectorRadioGroup({ name: name, value: value, className: className, size: size, connectors: connectors, onChange: onChange }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c8e461321115642d$export$2e2bcd8739ae039), {
        name: name,
        value: value,
        type: "card",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))(className, $3377f11fd0d03b1b$exports.ssoConnectorGroup, $3377f11fd0d03b1b$exports[size]),
        onChange: onChange,
        children: connectors.map((data)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $b4b7cf2a2e4180e8$export$2e2bcd8739ae039), {
                value: data.providerName,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $49e6678f0ea81000$export$2e2bcd8739ae039), {
                    data: data
                })
            }, data.providerName))
    });
}
var $ff12107e772eab7a$export$2e2bcd8739ae039 = $ff12107e772eab7a$var$SsoConnectorRadioGroup;


var $b0e715d967a0a558$export$bfd64c937657f93a;
var $b0e715d967a0a558$export$4a6dd88bada4e7d2;
var $b0e715d967a0a558$export$e086976dd0272b53;
$b0e715d967a0a558$export$bfd64c937657f93a = `TBsm3a_rotating`;
$b0e715d967a0a558$export$4a6dd88bada4e7d2 = `TBsm3a_shimmer`;
$b0e715d967a0a558$export$e086976dd0272b53 = `TBsm3a_textDivider`;


parcelRequire("cuPVN");
var $8q742 = parcelRequire("8q742");
const $79addf8c09ab5e22$var$standardSsoConnectorProviders = Object.freeze([
    (0, $8q742.SsoProviderName).OIDC,
    (0, $8q742.SsoProviderName).SAML
]);
function $79addf8c09ab5e22$export$cd5022949ec0f454(providers = []) {
    const standardProviders = new Set();
    const enterpriseProviders = new Set();
    for (const provider of providers)if ($79addf8c09ab5e22$var$standardSsoConnectorProviders.includes(provider.providerName)) standardProviders.add(provider);
    else enterpriseProviders.add(provider);
    return {
        standardProviders: [
            ...standardProviders
        ],
        enterpriseProviders: [
            ...enterpriseProviders
        ]
    };
}


const $5637d59679d8154b$var$duplicateConnectorNameErrorCode = "single_sign_on.duplicate_connector_name";
function $5637d59679d8154b$var$SsoCreationModal({ isOpen: isOpen, onClose: rawOnClose }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { currentPlan: currentPlan } = (0, $jC8Vy.useContext)((0, $19434c930f80c964$export$f8addfd4ab69c833));
    const [selectedProviderName, setSelectedProviderName] = (0, $jC8Vy.useState)();
    const isSsoEnabled = !(0, $8TpMk.isCloud) || currentPlan.quota.ssoEnabled;
    const { data: data, error: error } = (0, $voszV.default)("api/sso-connector-providers");
    const { reset: reset, register: register, handleSubmit: handleSubmit, formState: { isSubmitting: isSubmitting, errors: errors }, setError: setError, watch: watch } = (0, $codQP.useForm)({
        resetOptions: {
            keepErrors: true
        }
    });
    const api = (0, $7VnwS.default)({
        hideErrorToast: true
    });
    const isLoading = !data && !error;
    const { standardProviders: standardProviders, enterpriseProviders: enterpriseProviders } = (0, $79addf8c09ab5e22$export$cd5022949ec0f454)(data);
    const radioGroupSize = (0, $cfa9e34c07697b6d$export$2ace16fb29e63d87)(standardProviders.length + enterpriseProviders.length);
    const isAnyConnectorSelected = (0, $jC8Vy.useMemo)(()=>[
            ...standardProviders,
            ...enterpriseProviders
        ].some(({ providerName: providerName })=>selectedProviderName === providerName), [
        enterpriseProviders,
        selectedProviderName,
        standardProviders
    ]);
    // `rawOnClose` does not clean the state of the modal.
    const onClose = (ssoConnector)=>{
        setSelectedProviderName(undefined);
        reset();
        rawOnClose(ssoConnector);
    };
    const handleSsoSelection = (providerName)=>{
        setSelectedProviderName(providerName);
    };
    const onSubmit = handleSubmit((0, $5OcFi.trySubmitSafe)(async (formData)=>{
        if (isSubmitting) return;
        try {
            const createdSsoConnector = await api.post(`api/sso-connectors`, {
                json: {
                    ...formData,
                    providerName: selectedProviderName
                }
            }).json();
            onClose(createdSsoConnector);
        } catch (error) {
            if (error instanceof (0, $5cXXM.HTTPError)) {
                const { response: response } = error;
                const metadata = await response.clone().json();
                if (metadata.code === $5637d59679d8154b$var$duplicateConnectorNameErrorCode) setError("connectorName", {
                    type: "custom",
                    message: metadata.message
                });
            }
        }
    }));
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        shouldCloseOnEsc: true,
        isOpen: isOpen,
        className: $dW2kG.content,
        overlayClassName: $dW2kG.overlay,
        onRequestClose: ()=>{
            onClose();
        },
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $5vVWy.default), {
            title: "enterprise_sso.create_modal.title",
            footer: isSsoEnabled ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                title: "enterprise_sso.create_modal.create_button_text",
                type: "primary",
                disabled: // The button is available only when:
                // 1. `connectorName` field is not empty.
                // 2. At least one connector is selected.
                // 3. Error is resolved. Since `connectorName` is the only field of this form, it means `connectorName` field error is resolved.
                !(watch("connectorName") && isAnyConnectorSelected) || Boolean(errors.connectorName),
                onClick: onSubmit
            }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dafa1bad5a99c1ae$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                    components: {
                        a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a3bc63325dc3c1a8$export$2e2bcd8739ae039), {})
                    },
                    children: t("upsell.paywall.sso_connectors")
                })
            }),
            size: "xlarge",
            onClose: onClose,
            children: [
                isLoading && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f360002a3daba4ea$export$2e2bcd8739ae039), {
                    numberOfLoadingConnectors: 2
                }),
                error?.message,
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ff12107e772eab7a$export$2e2bcd8739ae039), {
                    name: "enterpriseProviders",
                    value: selectedProviderName,
                    connectors: enterpriseProviders,
                    size: radioGroupSize,
                    onChange: handleSsoSelection
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $b0e715d967a0a558$export$e086976dd0272b53,
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                        forKey: "enterprise_sso.create_modal.text_divider"
                    })
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ff12107e772eab7a$export$2e2bcd8739ae039), {
                    name: "standardProviders",
                    value: selectedProviderName,
                    connectors: standardProviders,
                    size: radioGroupSize,
                    onChange: handleSsoSelection
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                    isRequired: true,
                    title: "enterprise_sso.create_modal.connector_name_field_title",
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                        ...register("connectorName", {
                            required: true
                        }),
                        placeholder: t("enterprise_sso.create_modal.connector_name_field_placeholder"),
                        error: errors.connectorName?.message
                    })
                })
            ]
        })
    });
}
var $5637d59679d8154b$export$2e2bcd8739ae039 = $5637d59679d8154b$var$SsoCreationModal;


var $c9950ce70990fe9f$export$34e0f9847d4c02dd;
var $c9950ce70990fe9f$export$5d15c6f5dc2166f9;
var $c9950ce70990fe9f$export$db3c28d99448dcff;
var $c9950ce70990fe9f$export$bfd64c937657f93a;
var $c9950ce70990fe9f$export$4a6dd88bada4e7d2;
var $c9950ce70990fe9f$export$bf9fb029d174d554;
$c9950ce70990fe9f$export$34e0f9847d4c02dd = `EpHMJG_container`;
$c9950ce70990fe9f$export$5d15c6f5dc2166f9 = `EpHMJG_domains`;
$c9950ce70990fe9f$export$db3c28d99448dcff = `EpHMJG_logo`;
$c9950ce70990fe9f$export$bfd64c937657f93a = `EpHMJG_rotating`;
$c9950ce70990fe9f$export$4a6dd88bada4e7d2 = `EpHMJG_shimmer`;
$c9950ce70990fe9f$export$bf9fb029d174d554 = `EpHMJG_type`;


const $7f506c68bad4b969$var$pageSize = (0, $8Mb3E.defaultPageSize);
const $7f506c68bad4b969$var$enterpriseSsoPathname = "/enterprise-sso";
const $7f506c68bad4b969$var$createEnterpriseSsoPathname = `${$7f506c68bad4b969$var$enterpriseSsoPathname}/create`;
const $7f506c68bad4b969$var$buildDetailsPathname = (id)=>`${$7f506c68bad4b969$var$enterpriseSsoPathname}/${id}`;
function $7f506c68bad4b969$var$EnterpriseSso() {
    const { pathname: pathname } = (0, $2Phw0.useLocation)();
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { isDevTenant: isDevTenant } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { currentPlan: currentPlan } = (0, $jC8Vy.useContext)((0, $19434c930f80c964$export$f8addfd4ab69c833));
    const [{ page: page }, updateSearchParameters] = (0, $66a3eb3654f9d141$export$2e2bcd8739ae039)({
        page: 1
    });
    const isSsoEnabled = !(0, $8TpMk.isCloud) || currentPlan.quota.ssoEnabled;
    const url = (0, $7kooT.buildUrl)("api/sso-connectors", {
        page: String(page),
        page_size: String($7f506c68bad4b969$var$pageSize)
    });
    const { data: data, error: error, mutate: mutate } = (0, $voszV.default)(url);
    const isLoading = !data && !error;
    const [ssoConnectors, totalCount] = data ?? [];
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $998b64ca82ed2460$export$2e2bcd8739ae039), {
        title: {
            paywall: (0, $7oDSS.conditional)((!isSsoEnabled || isDevTenant) && (0, $lXQZH.ReservedPlanId).Pro),
            title: "enterprise_sso.title",
            subtitle: "enterprise_sso.subtitle"
        },
        pageMeta: {
            titleKey: "enterprise_sso.page_title"
        },
        createButton: (0, $7oDSS.conditional)(ssoConnectors?.length && {
            title: "enterprise_sso.create",
            onClick: ()=>{
                navigate($7f506c68bad4b969$var$createEnterpriseSsoPathname);
            }
        }),
        table: {
            rowGroups: [
                {
                    key: "enterprise_sso",
                    data: ssoConnectors
                }
            ],
            rowIndexKey: "id",
            isLoading: isLoading,
            errorMessage: error?.body?.message ?? error?.message,
            columns: [
                {
                    title: t("enterprise_sso.col_connector_name"),
                    dataIndex: "name",
                    colSpan: 5,
                    render: ({ id: id, connectorName: connectorName, ...rest })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $4d952cae22cb03fc$export$2e2bcd8739ae039), {
                            title: connectorName,
                            icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $608656f1bddbd059$export$2e2bcd8739ae039), {
                                className: $c9950ce70990fe9f$export$db3c28d99448dcff,
                                containerClassName: $c9950ce70990fe9f$export$34e0f9847d4c02dd,
                                data: rest
                            }),
                            to: $7f506c68bad4b969$var$buildDetailsPathname(id)
                        })
                },
                {
                    title: t("enterprise_sso.col_type"),
                    dataIndex: "type",
                    colSpan: 4,
                    render: ({ name: name })=>/*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $c9950ce70990fe9f$export$bf9fb029d174d554,
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                                children: name
                            })
                        })
                },
                {
                    title: t("enterprise_sso.col_email_domain"),
                    dataIndex: "emailDomain",
                    colSpan: 7,
                    render: ({ domains: domains })=>domains.length === 0 ? "-" : /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $c9950ce70990fe9f$export$5d15c6f5dc2166f9,
                            children: domains.map((domain, index)=>// eslint-disable-next-line react/no-array-index-key
                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
                                    variant: "cell",
                                    children: domain
                                }, index))
                        })
                }
            ],
            rowClickHandler: ({ id: id })=>{
                navigate($7f506c68bad4b969$var$buildDetailsPathname(id));
            },
            pagination: {
                page: page,
                totalCount: totalCount,
                pageSize: $7f506c68bad4b969$var$pageSize,
                onChange: (page)=>{
                    updateSearchParameters({
                        page: page
                    });
                }
            },
            placeholder: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2b56c00d3802884b$export$2e2bcd8739ae039), {
                image: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $db56e945ce261f42$export$2e2bcd8739ae039), {}),
                imageDark: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1914b4197efeea0c$export$2e2bcd8739ae039), {}),
                title: "enterprise_sso.placeholder_title",
                description: "enterprise_sso.placeholder_description",
                action: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                    title: "enterprise_sso.create",
                    type: "primary",
                    size: "large",
                    icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0b30fe81c923292b$export$2e2bcd8739ae039), {}),
                    onClick: ()=>{
                        navigate($7f506c68bad4b969$var$createEnterpriseSsoPathname);
                    }
                })
            }),
            onRetry: async ()=>mutate(undefined, true)
        },
        widgets: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5637d59679d8154b$export$2e2bcd8739ae039), {
            isOpen: pathname.endsWith($7f506c68bad4b969$var$createEnterpriseSsoPathname),
            onClose: (ssoConnector)=>{
                if (ssoConnector) {
                    mutate();
                    navigate($7f506c68bad4b969$var$buildDetailsPathname(ssoConnector.id));
                    return;
                }
                navigate($7f506c68bad4b969$var$enterpriseSsoPathname);
            }
        })
    });
}
var $7f506c68bad4b969$export$2e2bcd8739ae039 = $7f506c68bad4b969$var$EnterpriseSso;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $iS4bq = parcelRequire("iS4bq");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("6bq3s");
var $2Phw0 = parcelRequire("2Phw0");
var $2Phw0 = parcelRequire("2Phw0");

var $voszV = parcelRequire("voszV");







var $5TsIB = parcelRequire("5TsIB");
parcelRequire("8Mb3E");
var $bt3dS = parcelRequire("bt3dS");

var $dL4NZ = parcelRequire("dL4NZ");

var $66ixW = parcelRequire("66ixW");




var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $8q742 = parcelRequire("8q742");

var $C7mD2 = parcelRequire("C7mD2");
var $9c80b3e301b9e290$exports = {};
/**
 * Module dependencies.
 */ 
var $fmrD5 = parcelRequire("fmrD5");
var $1898d919456b5ce4$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** `Object#toString` result references. */ var $1898d919456b5ce4$var$objectTag = "[object Object]";
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $1898d919456b5ce4$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $1898d919456b5ce4$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var $1898d919456b5ce4$var$funcProto = Function.prototype, $1898d919456b5ce4$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $1898d919456b5ce4$var$funcToString = $1898d919456b5ce4$var$funcProto.toString;
/** Used to check objects for own properties. */ var $1898d919456b5ce4$var$hasOwnProperty = $1898d919456b5ce4$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $1898d919456b5ce4$var$objectCtorString = $1898d919456b5ce4$var$funcToString.call(Object);
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $1898d919456b5ce4$var$objectToString = $1898d919456b5ce4$var$objectProto.toString;
/** Built-in value references. */ var $1898d919456b5ce4$var$getPrototype = $1898d919456b5ce4$var$overArg(Object.getPrototypeOf, Object);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $1898d919456b5ce4$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $1898d919456b5ce4$var$isPlainObject(value) {
    if (!$1898d919456b5ce4$var$isObjectLike(value) || $1898d919456b5ce4$var$objectToString.call(value) != $1898d919456b5ce4$var$objectTag || $1898d919456b5ce4$var$isHostObject(value)) return false;
    var proto = $1898d919456b5ce4$var$getPrototype(value);
    if (proto === null) return true;
    var Ctor = $1898d919456b5ce4$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $1898d919456b5ce4$var$funcToString.call(Ctor) == $1898d919456b5ce4$var$objectCtorString;
}
$1898d919456b5ce4$exports = $1898d919456b5ce4$var$isPlainObject;



var $7bx9V = parcelRequire("7bx9V");
/**
 * Export `cleanDeep` function.
 */ $9c80b3e301b9e290$exports = function cleanDeep(object, { cleanKeys: cleanKeys = [], cleanValues: cleanValues = [], emptyArrays: emptyArrays = true, emptyObjects: emptyObjects = true, emptyStrings: emptyStrings = true, NaNValues: NaNValues = false, nullValues: nullValues = true, undefinedValues: undefinedValues = true } = {}) {
    return $7bx9V(object, (result, value, key)=>{
        // Exclude specific keys.
        if (cleanKeys.includes(key)) return;
        // Recurse into arrays and objects.
        if (Array.isArray(value) || $1898d919456b5ce4$exports(value)) value = cleanDeep(value, {
            NaNValues: NaNValues,
            cleanKeys: cleanKeys,
            cleanValues: cleanValues,
            emptyArrays: emptyArrays,
            emptyObjects: emptyObjects,
            emptyStrings: emptyStrings,
            nullValues: nullValues,
            undefinedValues: undefinedValues
        });
        // Exclude specific values.
        if (cleanValues.includes(value)) return;
        // Exclude empty objects.
        if (emptyObjects && $1898d919456b5ce4$exports(value) && $fmrD5(value)) return;
        // Exclude empty arrays.
        if (emptyArrays && Array.isArray(value) && !value.length) return;
        // Exclude empty strings.
        if (emptyStrings && value === "") return;
        // Exclude NaN values.
        if (NaNValues && Number.isNaN(value)) return;
        // Exclude null values.
        if (nullValues && value === null) return;
        // Exclude undefined values.
        if (undefinedValues && value === undefined) return;
        // Append when recursing arrays.
        if (Array.isArray(result)) return result.push(value);
        result[key] = value;
    });
};



var $5cXXM = parcelRequire("5cXXM");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");




var $7VnwS = parcelRequire("7VnwS");
const $66bbea88429aa70a$export$c203fee5942bffc3 = "/enterprise-sso";
const $66bbea88429aa70a$export$cc569019d304003 = "connector.invalid_config";
const $66bbea88429aa70a$export$8eb7d458c411e001 = "connector.invalid_metadata";



var $c3dK3 = parcelRequire("c3dK3");
const $b2bf67c42cd38703$export$d8ffe2943e1082d = (0, $c3dK3.z).object({
    clientId: (0, $c3dK3.z).string(),
    clientSecret: (0, $c3dK3.z).string(),
    issuer: (0, $c3dK3.z).string(),
    scope: (0, $c3dK3.z).string().optional()
}).partial();
const $b2bf67c42cd38703$export$999e45b2b5d6e23a = (0, $c3dK3.z).object({
    authorizationEndpoint: (0, $c3dK3.z).string(),
    tokenEndpoint: (0, $c3dK3.z).string(),
    userinfoEndpoint: (0, $c3dK3.z).string(),
    jwksUri: (0, $c3dK3.z).string(),
    issuer: (0, $c3dK3.z).string()
});



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $8q742 = parcelRequire("8q742");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $cw2No = parcelRequire("cw2No");

var $aqmjm = parcelRequire("aqmjm");

var $1QOtg = parcelRequire("1QOtg");

var $fmHmG = parcelRequire("fmHmG");

var $cRLgg = parcelRequire("cRLgg");

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $1cb06f0b2066e7de$export$34e0f9847d4c02dd;
var $1cb06f0b2066e7de$export$a7db06668cad9adb;
var $1cb06f0b2066e7de$export$bfd64c937657f93a;
var $1cb06f0b2066e7de$export$4a6dd88bada4e7d2;
var $1cb06f0b2066e7de$export$fb184b623420d9be;
$1cb06f0b2066e7de$export$34e0f9847d4c02dd = `Qn5Lwq_container`;
$1cb06f0b2066e7de$export$a7db06668cad9adb = `Qn5Lwq_content`;
$1cb06f0b2066e7de$export$bfd64c937657f93a = `Qn5Lwq_rotating`;
$1cb06f0b2066e7de$export$4a6dd88bada4e7d2 = `Qn5Lwq_shimmer`;
$1cb06f0b2066e7de$export$fb184b623420d9be = `Qn5Lwq_title`;


function $7dc0264d24c77cd6$var$ParsedConfigPreview({ providerConfig: providerConfig, className: className }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.enterprise_sso_details.oidc_preview"
    });
    const { authorizationEndpoint: authorizationEndpoint, tokenEndpoint: tokenEndpoint, userinfoEndpoint: userinfoEndpoint, jwksUri: jwksUri, issuer: issuer } = providerConfig;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($1cb06f0b2066e7de$export$34e0f9847d4c02dd, className),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $1cb06f0b2066e7de$export$fb184b623420d9be,
                        children: t("authorization_endpoint")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $1cb06f0b2066e7de$export$a7db06668cad9adb,
                        children: authorizationEndpoint
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $1cb06f0b2066e7de$export$fb184b623420d9be,
                        children: t("token_endpoint")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $1cb06f0b2066e7de$export$a7db06668cad9adb,
                        children: tokenEndpoint
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $1cb06f0b2066e7de$export$fb184b623420d9be,
                        children: t("userinfo_endpoint")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $1cb06f0b2066e7de$export$a7db06668cad9adb,
                        children: userinfoEndpoint
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $1cb06f0b2066e7de$export$fb184b623420d9be,
                        children: t("jwks_uri")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $1cb06f0b2066e7de$export$a7db06668cad9adb,
                        children: jwksUri
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $1cb06f0b2066e7de$export$fb184b623420d9be,
                        children: t("issuer")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $1cb06f0b2066e7de$export$a7db06668cad9adb,
                        children: issuer
                    })
                ]
            })
        ]
    });
}
var $7dc0264d24c77cd6$export$2e2bcd8739ae039 = $7dc0264d24c77cd6$var$ParsedConfigPreview;


var $ab27366109a6da67$export$a18c376ddfc9b6e5;
var $ab27366109a6da67$export$bfd64c937657f93a;
var $ab27366109a6da67$export$4a6dd88bada4e7d2;
$ab27366109a6da67$export$a18c376ddfc9b6e5 = `tsEUTq_oidcConfigPreview`;
$ab27366109a6da67$export$bfd64c937657f93a = `tsEUTq_rotating`;
$ab27366109a6da67$export$4a6dd88bada4e7d2 = `tsEUTq_shimmer`;


// Do not show inline notification and parsed config preview if it is on guide page.
function $5582527abf705033$var$OidcMetadataForm({ providerConfig: providerConfig, config: config, providerName: providerName }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { register: register, formState: { errors: errors } } = (0, $codQP.useFormContext)();
    const isConfigEmpty = !config || Object.keys(config).length === 0;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            !providerConfig && isConfigEmpty && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1QOtg.default), {
                severity: "alert",
                children: t("enterprise_sso_details.upload_oidc_idp_info_text")
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                isRequired: true,
                title: "enterprise_sso.metadata.oidc.client_id_field_name",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                    ...register("clientId", {
                        required: true
                    }),
                    error: Boolean(errors.clientId),
                    placeholder: "Client ID"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                isRequired: true,
                title: "enterprise_sso.metadata.oidc.client_secret_field_name",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                    isConfidential: true,
                    ...register("clientSecret", {
                        required: true
                    }),
                    error: Boolean(errors.clientSecret),
                    placeholder: "Client secret"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aqmjm.default), {
                isRequired: providerName !== (0, $8q742.SsoProviderName).GOOGLE_WORKSPACE,
                title: "enterprise_sso.metadata.oidc.issuer_field_name",
                children: [
                    providerName === (0, $8q742.SsoProviderName).GOOGLE_WORKSPACE ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
                        displayType: "block",
                        variant: "border",
                        // TODO: this hard-coded value should align with the `googleIssuer` value defined in `packages/core/src/sso/GoogleWorkspaceSsoConnector/index.ts`.
                        value: providerConfig?.issuer ?? "https://accounts.google.com"
                    }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                        ...register("issuer", {
                            required: true,
                            validate: (value)=>!value || (0, $cRLgg.uriValidator)(value) || t("errors.invalid_uri_format")
                        }),
                        error: errors.issuer?.message,
                        placeholder: "http(s)://"
                    }),
                    providerConfig && (config?.issuer ?? providerName === (0, $8q742.SsoProviderName).GOOGLE_WORKSPACE) && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7dc0264d24c77cd6$export$2e2bcd8739ae039), {
                        className: $ab27366109a6da67$export$a18c376ddfc9b6e5,
                        providerConfig: providerConfig
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: "enterprise_sso.metadata.oidc.scope_field_name",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                    ...register("scope"),
                    error: Boolean(errors.scope)
                })
            })
        ]
    });
}
var $5582527abf705033$export$2e2bcd8739ae039 = $5582527abf705033$var$OidcMetadataForm;



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $fG7L1 = parcelRequire("fG7L1");

var $cw2No = parcelRequire("cw2No");

var $aqmjm = parcelRequire("aqmjm");

var $lWGA3 = parcelRequire("lWGA3");
function $4b418392bf76cd47$var$OidcConnectorSpInfo({ ssoConnectorId: ssoConnectorId }) {
    const { tenantEndpoint: tenantEndpoint } = (0, $jC8Vy.useContext)((0, $fG7L1.AppDataContext));
    const { applyDomain: applyCustomDomain } = (0, $lWGA3.default)();
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
        title: "enterprise_sso.basic_info.oidc.redirect_uri_field_name",
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
            displayType: "block",
            variant: "border",
            value: applyCustomDomain(new URL(`/callback/${ssoConnectorId}`, tenantEndpoint).toString())
        })
    });
}
var $4b418392bf76cd47$export$2e2bcd8739ae039 = $4b418392bf76cd47$var$OidcConnectorSpInfo;


function $e5a79493610a775d$var$OidcConnectorForm({ isDeleted: isDeleted, data: data, onUpdated: onUpdated }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const api = (0, $7VnwS.default)({
        hideErrorToast: [
            (0, $66bbea88429aa70a$export$cc569019d304003)
        ]
    });
    const methods = (0, $codQP.useForm)();
    const { formState: { isSubmitting: isSubmitting, isDirty: isDirty }, handleSubmit: handleSubmit, reset: reset, setError: setError } = methods;
    const { config: config, providerConfig: providerConfig, providerName: providerName, id: connectorId } = data;
    // Guard the config data
    const oidcConnectorConfig = (0, $jC8Vy.useMemo)(()=>{
        const result = (0, $b2bf67c42cd38703$export$d8ffe2943e1082d).safeParse(config);
        const { success: success } = result;
        const guardedConfig = success ? result.data : undefined;
        return guardedConfig;
    }, [
        config
    ]);
    const oidcProviderConfig = (0, $jC8Vy.useMemo)(()=>{
        const result = (0, $b2bf67c42cd38703$export$999e45b2b5d6e23a).safeParse(providerConfig);
        const { success: success } = result;
        const guardedConfig = success ? result.data : undefined;
        return guardedConfig;
    }, [
        providerConfig
    ]);
    (0, $jC8Vy.useEffect)(()=>{
        reset(oidcConnectorConfig);
    }, [
        oidcConnectorConfig,
        reset
    ]);
    const onSubmit = handleSubmit(async (formData)=>{
        if (isSubmitting) return;
        try {
            const result = await api.patch(`api/sso-connectors/${connectorId}`, {
                json: {
                    config: (0, (/*@__PURE__*/$parcel$interopDefault($9c80b3e301b9e290$exports)))(formData)
                }
            }).json();
            (0, $FuhPC.toast).success(t("general.saved"));
            onUpdated(result);
            reset(result.config);
        } catch (error) {
            if (error instanceof (0, $5cXXM.HTTPError)) {
                const errorBody = await error.response.clone().json();
                // Manually handle the error to show the error message in the form.
                if (errorBody.code === (0, $66bbea88429aa70a$export$cc569019d304003)) {
                    setError("issuer", {
                        type: "custom",
                        message: errorBody.message
                    });
                    return;
                }
            }
            throw error;
        }
    });
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $codQP.FormProvider), {
        ...methods,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $f0e7fd6d3bded790$export$2e2bcd8739ae039), {
                isDirty: isDirty,
                isSubmitting: isSubmitting,
                onDiscard: reset,
                onSubmit: onSubmit,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
                        title: "enterprise_sso_details.upload_idp_metadata_title_oidc",
                        description: "enterprise_sso_details.upload_idp_metadata_description_oidc",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5582527abf705033$export$2e2bcd8739ae039), {
                            providerName: providerName,
                            config: oidcConnectorConfig,
                            providerConfig: oidcProviderConfig
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
                        title: "enterprise_sso_details.service_provider_property_title",
                        description: "enterprise_sso_details.service_provider_property_description",
                        descriptionInterpolation: {
                            protocol: "OIDC"
                        },
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4b418392bf76cd47$export$2e2bcd8739ae039), {
                            ssoConnectorId: connectorId
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fea55fa5d5726e29$export$2e2bcd8739ae039), {
                hasUnsavedChanges: !isDeleted && isDirty
            })
        ]
    });
}
var $e5a79493610a775d$export$2e2bcd8739ae039 = $e5a79493610a775d$var$OidcConnectorForm;



var $C7mD2 = parcelRequire("C7mD2");


var $5cXXM = parcelRequire("5cXXM");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");




var $7VnwS = parcelRequire("7VnwS");

var $c3dK3 = parcelRequire("c3dK3");
/**
 * All the following guards are copied from {@link @logto/core/packages/core/src/sso/types/saml }
 * @TODO: consider to move them to a shared package e.g. @logto/schemas
 */ const $ecec7dd81bded225$var$samlAttributeMappingGuard = (0, $c3dK3.z).object({
    id: (0, $c3dK3.z).string(),
    email: (0, $c3dK3.z).string(),
    name: (0, $c3dK3.z).string()
}).partial();
const $ecec7dd81bded225$export$fc0bd3c7b04915a0 = Object.freeze([
    "id",
    "email",
    "name"
]);
const $ecec7dd81bded225$export$70b1b935b7ff7713 = (0, $c3dK3.z).object({
    metadataUrl: (0, $c3dK3.z).string(),
    metadata: (0, $c3dK3.z).string(),
    signInEndpoint: (0, $c3dK3.z).string(),
    entityId: (0, $c3dK3.z).string(),
    x509Certificate: (0, $c3dK3.z).string(),
    attributeMapping: $ecec7dd81bded225$var$samlAttributeMappingGuard
}).partial();
// Guard the saml provider config from the response of the API.
const $ecec7dd81bded225$var$samlServiceProviderMetadataGuard = (0, $c3dK3.z).object({
    entityId: (0, $c3dK3.z).string().min(1),
    assertionConsumerServiceUrl: (0, $c3dK3.z).string().min(1)
});
const $ecec7dd81bded225$var$samlIdentityProviderMetadataGuard = (0, $c3dK3.z).object({
    entityId: (0, $c3dK3.z).string(),
    signInEndpoint: (0, $c3dK3.z).string(),
    x509Certificate: (0, $c3dK3.z).string(),
    certificateExpiresAt: (0, $c3dK3.z).number(),
    isCertificateValid: (0, $c3dK3.z).boolean()
});
const $ecec7dd81bded225$export$fb0b03910ad8ad02 = (0, $c3dK3.z).object({
    defaultAttributeMapping: $ecec7dd81bded225$var$samlAttributeMappingGuard,
    serviceProvider: $ecec7dd81bded225$var$samlServiceProviderMetadataGuard,
    identityProvider: $ecec7dd81bded225$var$samlIdentityProviderMetadataGuard.optional()
});



var $5OcFi = parcelRequire("5OcFi");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $codQP = parcelRequire("codQP");

var $cw2No = parcelRequire("cw2No");

var $66ixW = parcelRequire("66ixW");

var $fmHmG = parcelRequire("fmHmG");

var $93b399186fc7509e$export$32180ef41b15b513;
var $93b399186fc7509e$export$38e42c68cf43b5d4;
var $93b399186fc7509e$export$bfd64c937657f93a;
var $93b399186fc7509e$export$120ff0929b202a6d;
var $93b399186fc7509e$export$4a6dd88bada4e7d2;
var $93b399186fc7509e$export$9852986a3ec5f6a0;
$93b399186fc7509e$export$32180ef41b15b513 = `v3-9YW_body`;
$93b399186fc7509e$export$38e42c68cf43b5d4 = `v3-9YW_header`;
$93b399186fc7509e$export$bfd64c937657f93a = `v3-9YW_rotating`;
$93b399186fc7509e$export$120ff0929b202a6d = `v3-9YW_row`;
$93b399186fc7509e$export$4a6dd88bada4e7d2 = `v3-9YW_shimmer`;
$93b399186fc7509e$export$9852986a3ec5f6a0 = `v3-9YW_table`;


const $b2e3d9a170028e87$var$primaryKey = "attributeMapping";
function $b2e3d9a170028e87$var$SamlAttributeMapping({ samlProviderConfig: samlProviderConfig }) {
    const { register: register } = (0, $codQP.useFormContext)();
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("table", {
        className: $93b399186fc7509e$export$9852986a3ec5f6a0,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("thead", {
                className: $93b399186fc7509e$export$38e42c68cf43b5d4,
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("tr", {
                    className: $93b399186fc7509e$export$120ff0929b202a6d,
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)("th", {
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                forKey: "enterprise_sso.attribute_mapping.col_sp_claims"
                            })
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("th", {
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                forKey: "enterprise_sso.attribute_mapping.col_idp_claims"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("tbody", {
                className: $93b399186fc7509e$export$32180ef41b15b513,
                children: (0, $ecec7dd81bded225$export$fc0bd3c7b04915a0).map((key)=>{
                    return /*#__PURE__*/ (0, $C7mD2.jsxs)("tr", {
                        className: $93b399186fc7509e$export$120ff0929b202a6d,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("td", {
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
                                    displayType: "block",
                                    variant: "border",
                                    value: key
                                })
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("td", {
                                children: key === "id" ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
                                    displayType: "block",
                                    variant: "border",
                                    value: (0, $7oDSS.conditionalString)(samlProviderConfig?.defaultAttributeMapping[key])
                                }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                    ...register(`${$b2e3d9a170028e87$var$primaryKey}.${key}`),
                                    placeholder: (0, $7oDSS.conditional)(samlProviderConfig?.defaultAttributeMapping[key])
                                })
                            })
                        ]
                    }, key);
                })
            })
        ]
    });
}
var $b2e3d9a170028e87$export$2e2bcd8739ae039 = $b2e3d9a170028e87$var$SamlAttributeMapping;



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $aqmjm = parcelRequire("aqmjm");

var $1QOtg = parcelRequire("1QOtg");

var $fmHmG = parcelRequire("fmHmG");

var $cRLgg = parcelRequire("cRLgg");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");

var $jC8Vy = parcelRequire("jC8Vy");



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $ed9a684e452c6201$var$SvgFileIconDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                opacity: 0.6,
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9 0a4 4 0 0 0-4 4v32a4 4 0 0 0 4 4h22a4 4 0 0 0 4-4V10L25 0H9Z",
                fill: "#5D34F2"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m25 0 10 10h-8a2 2 0 0 1-2-2V0Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.317 16.552a1 1 0 0 1 .632 1.265l-3.5 10.5a1 1 0 0 1-1.897-.633l3.5-10.5a1 1 0 0 1 1.265-.632ZM15.633 16.726a1 1 0 0 1 .141 1.407l-3.957 4.836 3.926 4.362a1 1 0 1 1-1.486 1.338l-4.5-5a1 1 0 0 1-.031-1.302l4.5-5.5a1 1 0 0 1 1.407-.14ZM24.367 16.726a1 1 0 0 0-.141 1.407l3.957 4.836-3.926 4.362a1 1 0 1 0 1.486 1.338l4.5-5a1 1 0 0 0 .031-1.302l-4.5-5.5a1 1 0 0 0-1.407-.14Z",
                fill: "#AF9EFF"
            })
        ]
    });
var $ed9a684e452c6201$export$2e2bcd8739ae039 = $ed9a684e452c6201$var$SvgFileIconDark;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $dd89738a3421c514$var$SvgFileIcon = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                opacity: 0.5,
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9 0a4 4 0 0 0-4 4v32a4 4 0 0 0 4 4h22a4 4 0 0 0 4-4V10L25 0H9Z",
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m25 0 10 10h-8a2 2 0 0 1-2-2V0Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.317 16.552a1 1 0 0 1 .632 1.265l-3.5 10.5a1 1 0 0 1-1.897-.633l3.5-10.5a1 1 0 0 1 1.265-.632ZM15.633 16.726a1 1 0 0 1 .141 1.407l-3.957 4.836 3.926 4.362a1 1 0 1 1-1.486 1.338l-4.5-5a1 1 0 0 1-.031-1.302l4.5-5.5a1 1 0 0 1 1.407-.14ZM24.367 16.726a1 1 0 0 0-.141 1.407l3.957 4.836-3.926 4.362a1 1 0 1 0 1.486 1.338l4.5-5a1 1 0 0 0 .031-1.302l-4.5-5.5a1 1 0 0 0-1.407-.14Z",
                fill: "#947DFF"
            })
        ]
    });
var $dd89738a3421c514$export$2e2bcd8739ae039 = $dd89738a3421c514$var$SvgFileIcon;




var $jGWQ4 = parcelRequire("jGWQ4");

var $75SRw = parcelRequire("75SRw");

var $jheqv = parcelRequire("jheqv");
// In Bytes.
const $6ba5c176fa7028ed$export$daea4c00f4def5a0 = (xmlContent, fileName, mimeType)=>{
    const blob = new Blob([
        xmlContent
    ], {
        type: mimeType
    });
    const file = new File([
        blob
    ], fileName);
    return file.size;
};


var $791b90f7ea83896d$export$1822828d790e23ee;
var $791b90f7ea83896d$export$a3bc9b8ed74fc;
var $791b90f7ea83896d$export$c03ea6337221a120;
var $791b90f7ea83896d$export$5d5b61cfc3d870a9;
var $791b90f7ea83896d$export$45547f6c19231c9;
var $791b90f7ea83896d$export$cd8a31fb65ca89f4;
var $791b90f7ea83896d$export$1ca1ec8b29a4ce27;
var $791b90f7ea83896d$export$48c2d0f2f545ac27;
var $791b90f7ea83896d$export$bfd64c937657f93a;
var $791b90f7ea83896d$export$4a6dd88bada4e7d2;
$791b90f7ea83896d$export$1822828d790e23ee = `_6EOEtq_delete`;
$791b90f7ea83896d$export$a3bc9b8ed74fc = `_6EOEtq_error`;
$791b90f7ea83896d$export$c03ea6337221a120 = `_6EOEtq_fileInfo`;
$791b90f7ea83896d$export$5d5b61cfc3d870a9 = `_6EOEtq_fileInput`;
$791b90f7ea83896d$export$45547f6c19231c9 = `_6EOEtq_fileName`;
$791b90f7ea83896d$export$cd8a31fb65ca89f4 = `_6EOEtq_fileSize`;
$791b90f7ea83896d$export$1ca1ec8b29a4ce27 = `_6EOEtq_icon`;
$791b90f7ea83896d$export$48c2d0f2f545ac27 = `_6EOEtq_preview`;
$791b90f7ea83896d$export$bfd64c937657f93a = `_6EOEtq_rotating`;
$791b90f7ea83896d$export$4a6dd88bada4e7d2 = `_6EOEtq_shimmer`;


const $4dbd848f814183a7$var$fileSizeLimit = 512000; // 500 KB
function $4dbd848f814183a7$var$FileReader({ onChange: onChange, value: value, attributes: attributes, fieldError: fieldError, setError: setError }) {
    const theme = (0, $jheqv.default)();
    const { accept: accept, buttonTitle: buttonTitle, defaultFilename: defaultFilename, defaultFileMimeType: defaultFileMimeType } = attributes;
    /**
   * As you can see, per `useDropzone` hook's config, there are at most one file, if file is rejected, then we can return as long as we get the error message.
   */ const onDrop = (0, $jC8Vy.useCallback)(async (acceptedFiles = [], fileRejection = [])=>{
        if (fileRejection.length > 0) {
            const fileErrors = fileRejection[0]?.errors;
            if (fileErrors?.[0]?.message) setError({
                type: "custom",
                message: fileErrors[0]?.message
            });
            return;
        }
        const acceptedFile = acceptedFiles[0];
        if (!acceptedFile) return;
        const fileContent = await acceptedFile.text();
        onChange(fileContent);
    }, [
        onChange,
        setError
    ]);
    const handleRemove = ()=>{
        onChange(undefined);
    };
    const { getRootProps: getRootProps, getInputProps: getInputProps } = (0, $9d9dd5baa20d706c$export$cd49c0ecc5be9f36)({
        onDrop: onDrop,
        noDrag: true,
        maxFiles: 1,
        maxSize: $4dbd848f814183a7$var$fileSizeLimit,
        multiple: false,
        accept: accept
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        children: value ? /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
            className: $791b90f7ea83896d$export$48c2d0f2f545ac27,
            children: [
                theme === (0, $5HVJe.Theme).Dark ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ed9a684e452c6201$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dd89738a3421c514$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: $791b90f7ea83896d$export$c03ea6337221a120,
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                            className: $791b90f7ea83896d$export$45547f6c19231c9,
                            children: defaultFilename
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                            className: $791b90f7ea83896d$export$cd8a31fb65ca89f4,
                            children: `${((0, $6ba5c176fa7028ed$export$daea4c00f4def5a0)(value, defaultFilename, defaultFileMimeType) / 1024).toFixed(2)} KB`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                    className: $791b90f7ea83896d$export$1822828d790e23ee,
                    onClick: ()=>{
                        handleRemove();
                    },
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3aa588de5c8665f2$export$2e2bcd8739ae039), {
                        className: $791b90f7ea83896d$export$1ca1ec8b29a4ce27
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    ...getRootProps(),
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                            icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fbedeff6d2a860db$export$2e2bcd8739ae039), {}),
                            title: buttonTitle,
                            size: "large"
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("input", {
                            ...getInputProps({
                                className: $791b90f7ea83896d$export$5d5b61cfc3d870a9
                            })
                        })
                    ]
                }),
                Boolean(fieldError) && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $791b90f7ea83896d$export$a3bc9b8ed74fc,
                    children: fieldError?.message
                })
            ]
        })
    });
}
var $4dbd848f814183a7$export$2e2bcd8739ae039 = $4dbd848f814183a7$var$FileReader;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("hNGhh");
var $eRB1v = parcelRequire("eRB1v");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $5UrGx = parcelRequire("5UrGx");

var $4TsiV = parcelRequire("4TsiV");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $cw2No = parcelRequire("cw2No");

var $66ixW = parcelRequire("66ixW");
var $db7e4271c7a0922d$export$af8f8af11f83a76a;
var $db7e4271c7a0922d$export$34e0f9847d4c02dd;
var $db7e4271c7a0922d$export$a7db06668cad9adb;
var $db7e4271c7a0922d$export$916114a2e15d3c1c;
var $db7e4271c7a0922d$export$e897cab68364f2de;
var $db7e4271c7a0922d$export$bfd64c937657f93a;
var $db7e4271c7a0922d$export$4a6dd88bada4e7d2;
var $db7e4271c7a0922d$export$fb184b623420d9be;
$db7e4271c7a0922d$export$af8f8af11f83a76a = `JgiM0G_certificatePreview`;
$db7e4271c7a0922d$export$34e0f9847d4c02dd = `JgiM0G_container`;
$db7e4271c7a0922d$export$a7db06668cad9adb = `JgiM0G_content`;
$db7e4271c7a0922d$export$916114a2e15d3c1c = `JgiM0G_errorStatus`;
$db7e4271c7a0922d$export$e897cab68364f2de = `JgiM0G_indicator`;
$db7e4271c7a0922d$export$bfd64c937657f93a = `JgiM0G_rotating`;
$db7e4271c7a0922d$export$4a6dd88bada4e7d2 = `JgiM0G_shimmer`;
$db7e4271c7a0922d$export$fb184b623420d9be = `JgiM0G_title`;


function $a1162a0c2a542624$export$f1c9def0bdce5f3d({ identityProviderConfig: { x509Certificate: x509Certificate, certificateExpiresAt: certificateExpiresAt, isCertificateValid: isCertificateValid }, className: className }) {
    const { language: language } = (0, $4TsiV.default);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($db7e4271c7a0922d$export$af8f8af11f83a76a, className),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($db7e4271c7a0922d$export$e897cab68364f2de, !isCertificateValid && $db7e4271c7a0922d$export$916114a2e15d3c1c)
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                forKey: "enterprise_sso_details.saml_preview.certificate_content",
                interpolation: {
                    date: new Date(certificateExpiresAt).toLocaleDateString(// TODO: @darcyYe check whether can use date-fns later, may need a Logto locale to date-fns locale mapping.
                    (0, $7oDSS.conditional)((0, $eRB1v.isLanguageTag)(language) && language) ?? "en", {
                        weekday: "long",
                        year: "numeric",
                        month: "long",
                        day: "numeric"
                    })
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
                displayType: "block",
                variant: "icon",
                value: x509Certificate
            })
        ]
    });
}
function $a1162a0c2a542624$var$ParsedConfigPreview({ identityProviderConfig: identityProviderConfig }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.enterprise_sso_details.saml_preview"
    });
    if (!identityProviderConfig) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $db7e4271c7a0922d$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $db7e4271c7a0922d$export$fb184b623420d9be,
                        children: t("sign_on_url")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $db7e4271c7a0922d$export$a7db06668cad9adb,
                        children: identityProviderConfig.signInEndpoint
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $db7e4271c7a0922d$export$fb184b623420d9be,
                        children: t("entity_id")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $db7e4271c7a0922d$export$a7db06668cad9adb,
                        children: identityProviderConfig.entityId
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $db7e4271c7a0922d$export$fb184b623420d9be,
                        children: t("x509_certificate")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $db7e4271c7a0922d$export$a7db06668cad9adb,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)($a1162a0c2a542624$export$f1c9def0bdce5f3d, {
                            identityProviderConfig: identityProviderConfig
                        })
                    })
                ]
            })
        ]
    });
}
var $a1162a0c2a542624$export$2e2bcd8739ae039 = $a1162a0c2a542624$var$ParsedConfigPreview;



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $8fbd391934dd0d24$var$SvgSwitchArrow = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 21,
        height: 20,
        viewBox: "0 0 21 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "m18.591 7.742-3.333-3.334a.837.837 0 1 0-1.183 1.183L15.992 7.5H6.332a.833.833 0 0 0 0 1.666H18a.833.833 0 0 0 .767-.516.834.834 0 0 0-.175-.909Zm-3.925 3.091H3a.833.833 0 0 0-.767.517.833.833 0 0 0 .175.908l3.333 3.334a.833.833 0 0 0 1.184 0 .833.833 0 0 0 0-1.184L5.008 12.5h9.659a.834.834 0 0 0 0-1.667Z",
            fill: "currentColor"
        })
    });
var $8fbd391934dd0d24$export$2e2bcd8739ae039 = $8fbd391934dd0d24$var$SvgSwitchArrow;



var $3co9T = parcelRequire("3co9T");



var $66ixW = parcelRequire("66ixW");
var $f183b3f908526bbd$export$81207e5cc4186890;
var $f183b3f908526bbd$export$b7f029de53087ca2;
var $f183b3f908526bbd$export$1ca1ec8b29a4ce27;
var $f183b3f908526bbd$export$d366b825f37a435b;
var $f183b3f908526bbd$export$bfd64c937657f93a;
var $f183b3f908526bbd$export$d90250155de6d7e7;
var $f183b3f908526bbd$export$4a6dd88bada4e7d2;
var $f183b3f908526bbd$export$fb184b623420d9be;
$f183b3f908526bbd$export$81207e5cc4186890 = `eYEHqq_dropdown`;
$f183b3f908526bbd$export$b7f029de53087ca2 = `eYEHqq_dropdownIcon`;
$f183b3f908526bbd$export$1ca1ec8b29a4ce27 = `eYEHqq_icon`;
$f183b3f908526bbd$export$d366b825f37a435b = `eYEHqq_optionText`;
$f183b3f908526bbd$export$bfd64c937657f93a = `eYEHqq_rotating`;
$f183b3f908526bbd$export$d90250155de6d7e7 = `eYEHqq_selected`;
$f183b3f908526bbd$export$4a6dd88bada4e7d2 = `eYEHqq_shimmer`;
$f183b3f908526bbd$export$fb184b623420d9be = `eYEHqq_title`;


var $510d26eb4987b881$export$20c44e4bf7f271bb;
(function(FormFormat) {
    FormFormat["Url"] = "url";
    FormFormat["Xml"] = "xml";
    FormFormat["Manual"] = "manual";
})($510d26eb4987b881$export$20c44e4bf7f271bb || ($510d26eb4987b881$export$20c44e4bf7f271bb = {}));
const $510d26eb4987b881$var$options = [
    {
        value: $510d26eb4987b881$export$20c44e4bf7f271bb.Url,
        title: "enterprise_sso.metadata.metadata_format_url"
    },
    {
        value: $510d26eb4987b881$export$20c44e4bf7f271bb.Xml,
        title: "enterprise_sso.metadata.metadata_format_xml"
    },
    {
        value: $510d26eb4987b881$export$20c44e4bf7f271bb.Manual,
        title: "enterprise_sso.metadata.metadata_format_manual"
    }
];
function $510d26eb4987b881$var$SwitchFormatButton({ value: value, onChange: onChange }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f25eeaa133584984$export$2e2bcd8739ae039), {
        buttonProps: {
            type: "text",
            size: "small",
            title: "enterprise_sso.metadata.dropdown_trigger_text",
            icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8fbd391934dd0d24$export$2e2bcd8739ae039), {
                className: $f183b3f908526bbd$export$b7f029de53087ca2
            })
        },
        dropdownHorizontalAlign: "start",
        dropdownClassName: $f183b3f908526bbd$export$81207e5cc4186890,
        title: t("enterprise_sso.metadata.dropdown_title"),
        children: $510d26eb4987b881$var$options.map(({ value: optionValue, title: title })=>/*#__PURE__*/ (0, $C7mD2.jsxs)((0, $6c006ec422465f6f$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    onChange(optionValue);
                },
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3co9T.default), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($f183b3f908526bbd$export$1ca1ec8b29a4ce27, value === optionValue && $f183b3f908526bbd$export$d90250155de6d7e7)
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($f183b3f908526bbd$export$fb184b623420d9be, $f183b3f908526bbd$export$d366b825f37a435b, value === optionValue && $f183b3f908526bbd$export$d90250155de6d7e7),
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: title
                        })
                    })
                ]
            }, optionValue))
    });
}
var $510d26eb4987b881$export$2e2bcd8739ae039 = $510d26eb4987b881$var$SwitchFormatButton;


var $c630b154ba50d510$export$af8f8af11f83a76a;
var $c630b154ba50d510$export$6d59db4903f20f7d;
var $c630b154ba50d510$export$bfd64c937657f93a;
var $c630b154ba50d510$export$4a6dd88bada4e7d2;
$c630b154ba50d510$export$af8f8af11f83a76a = `VZM6aG_certificatePreview`;
$c630b154ba50d510$export$6d59db4903f20f7d = `VZM6aG_description`;
$c630b154ba50d510$export$bfd64c937657f93a = `VZM6aG_rotating`;
$c630b154ba50d510$export$4a6dd88bada4e7d2 = `VZM6aG_shimmer`;


const $c606610e55ec539a$var$fileReaderAttributesMap = {
    // Accept xml file.
    metadata: {
        buttonTitle: "enterprise_sso.metadata.saml.metadata_xml_uploader_text",
        accept: {
            "application/xml": [],
            "text/xml": []
        },
        defaultFilename: "identity provider metadata.xml",
        defaultFileMimeType: "application/xml"
    },
    x509Certificate: {
        buttonTitle: "enterprise_sso_details.upload_signing_certificate_button_text",
        accept: {
            "application/x-x509-user-cert": [
                ".crt",
                ".cer"
            ],
            "application/x-x509-ca-cert": [
                ".crt",
                ".cer"
            ],
            "application/x-pem-file": [
                ".pem"
            ]
        },
        defaultFilename: "signing certificate.cer",
        defaultFileMimeType: "application/x-x509-user-cert"
    }
};
function $c606610e55ec539a$var$SamlMetadataFormFields({ formFormat: formFormat, identityProviderConfig: identityProviderConfig, config: config }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { setError: setError, control: control, register: register, formState: { errors: errors } } = (0, $codQP.useFormContext)();
    switch(formFormat){
        case (0, $510d26eb4987b881$export$20c44e4bf7f271bb).Manual:
            return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        isRequired: true,
                        title: "enterprise_sso.metadata.saml.sign_in_endpoint_field_name",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                            ...register("signInEndpoint", {
                                required: true,
                                validate: (value)=>!value || (0, $cRLgg.uriValidator)(value) || t("errors.invalid_uri_format")
                            }),
                            error: Boolean(errors.signInEndpoint),
                            placeholder: "https://"
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        isRequired: true,
                        title: "enterprise_sso.metadata.saml.idp_entity_id_field_name",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                            ...register("entityId", {
                                required: true,
                                validate: (value)=>!value || (0, $cRLgg.uriValidator)(value) || t("errors.invalid_uri_format")
                            }),
                            error: Boolean(errors.entityId),
                            placeholder: "https://"
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        isRequired: true,
                        title: "enterprise_sso.metadata.saml.certificate_field_name",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                            control: control,
                            name: "x509Certificate",
                            rules: {
                                validate: (value)=>{
                                    if (!value) return t("enterprise_sso.metadata.saml.certificate_required");
                                    return true;
                                }
                            },
                            render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4dbd848f814183a7$export$2e2bcd8739ae039), {
                                            attributes: $c606610e55ec539a$var$fileReaderAttributesMap.x509Certificate,
                                            value: value,
                                            fieldError: errors.x509Certificate,
                                            setError: (error)=>{
                                                setError("x509Certificate", error);
                                            },
                                            onChange: onChange
                                        }),
                                        value && identityProviderConfig && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a1162a0c2a542624$export$f1c9def0bdce5f3d), {
                                            className: $c630b154ba50d510$export$af8f8af11f83a76a,
                                            identityProviderConfig: identityProviderConfig
                                        })
                                    ]
                                })
                        })
                    })
                ]
            });
        case (0, $510d26eb4987b881$export$20c44e4bf7f271bb).Xml:
            return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        title: "enterprise_sso.metadata.saml.metadata_xml_field_name",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                            control: control,
                            name: "metadata",
                            render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $4dbd848f814183a7$export$2e2bcd8739ae039), {
                                    attributes: $c606610e55ec539a$var$fileReaderAttributesMap.metadata,
                                    value: value,
                                    fieldError: errors.metadata,
                                    setError: (error)=>{
                                        setError("metadata", error);
                                    },
                                    onChange: onChange
                                })
                        })
                    }),
                    config?.metadata && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a1162a0c2a542624$export$2e2bcd8739ae039), {
                        identityProviderConfig: identityProviderConfig
                    })
                ]
            });
        case (0, $510d26eb4987b881$export$20c44e4bf7f271bb).Url:
            return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aqmjm.default), {
                        isRequired: true,
                        title: "enterprise_sso.metadata.saml.metadata_url_field_name",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                ...register("metadataUrl", {
                                    required: true,
                                    validate: (value)=>!value || (0, $cRLgg.uriValidator)(value) || t("errors.invalid_uri_format")
                                }),
                                error: errors.metadataUrl?.message,
                                placeholder: "https://"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $c630b154ba50d510$export$6d59db4903f20f7d,
                                children: t("enterprise_sso.metadata.saml.metadata_url_description")
                            })
                        ]
                    }),
                    config?.metadataUrl && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a1162a0c2a542624$export$2e2bcd8739ae039), {
                        identityProviderConfig: identityProviderConfig
                    })
                ]
            });
    }
}
// Do not show inline notification and parsed config preview if it is on guide page.
function $c606610e55ec539a$var$SamlMetadataForm({ config: config, providerConfig: providerConfig }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { setValue: setValue } = (0, $codQP.useFormContext)();
    const identityProviderConfig = providerConfig?.identityProvider;
    const isConfigEmpty = !config || Object.keys(config).length === 0;
    // Default form format could change based on the value of ORIGINAL `config`.
    // We emphasis ORIGINAL here to avoid using `watch()` which got the real-time value and could lead to conflict.
    const [formFormat, setFormFormat] = (0, $jC8Vy.useState)(()=>{
        if (!config) return (0, $510d26eb4987b881$export$20c44e4bf7f271bb).Url;
        const { metadataUrl: metadataUrl, metadata: metadata, entityId: entityId, signInEndpoint: signInEndpoint, x509Certificate: x509Certificate } = config;
        if (metadataUrl) return (0, $510d26eb4987b881$export$20c44e4bf7f271bb).Url;
        if (metadata) return (0, $510d26eb4987b881$export$20c44e4bf7f271bb).Xml;
        if (entityId && signInEndpoint && x509Certificate) return (0, $510d26eb4987b881$export$20c44e4bf7f271bb).Manual;
        return (0, $510d26eb4987b881$export$20c44e4bf7f271bb).Url;
    });
    // If some form format is selected, then fields from other fields should be cleared.
    const onSelect = (newFormFormat)=>{
        if (newFormFormat === formFormat) return;
        // Reset old format form values.
        switch(formFormat){
            case (0, $510d26eb4987b881$export$20c44e4bf7f271bb).Url:
                setValue("metadataUrl", undefined);
                break;
            case (0, $510d26eb4987b881$export$20c44e4bf7f271bb).Xml:
                setValue("metadata", undefined);
                break;
            case (0, $510d26eb4987b881$export$20c44e4bf7f271bb).Manual:
                setValue("entityId", undefined);
                setValue("signInEndpoint", undefined);
                setValue("x509Certificate", undefined);
                break;
        }
        // Resume field if exists in `config`; should show original value if switch to another form format and switch back.
        switch(newFormFormat){
            case (0, $510d26eb4987b881$export$20c44e4bf7f271bb).Url:
                setValue("metadataUrl", config?.metadataUrl);
                break;
            case (0, $510d26eb4987b881$export$20c44e4bf7f271bb).Xml:
                setValue("metadata", config?.metadata);
                break;
            case (0, $510d26eb4987b881$export$20c44e4bf7f271bb).Manual:
                setValue("entityId", config?.entityId);
                setValue("signInEndpoint", config?.signInEndpoint);
                setValue("x509Certificate", config?.x509Certificate);
                break;
        }
        setFormFormat(newFormFormat);
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            !identityProviderConfig && isConfigEmpty && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1QOtg.default), {
                severity: "alert",
                children: t(formFormat === (0, $510d26eb4987b881$export$20c44e4bf7f271bb).Url ? "enterprise_sso_details.upload_saml_idp_metadata_info_text_url" : formFormat === (0, $510d26eb4987b881$export$20c44e4bf7f271bb).Xml ? "enterprise_sso_details.upload_saml_idp_metadata_info_text_xml" : "enterprise_sso_details.upload_saml_idp_metadata_info_text_manual")
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)($c606610e55ec539a$var$SamlMetadataFormFields, {
                formFormat: formFormat,
                identityProviderConfig: identityProviderConfig,
                config: config
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $510d26eb4987b881$export$2e2bcd8739ae039), {
                value: formFormat,
                onChange: onSelect
            })
        ]
    });
}
var $c606610e55ec539a$export$2e2bcd8739ae039 = $c606610e55ec539a$var$SamlMetadataForm;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $cw2No = parcelRequire("cw2No");

var $aqmjm = parcelRequire("aqmjm");

var $lWGA3 = parcelRequire("lWGA3");
function $f7db2874f110380e$var$SamlConnectorSpInfo({ samlProviderConfig: samlProviderConfig }) {
    const { applyDomain: applyCustomDomain } = (0, $lWGA3.default)();
    /**
   * Should not fallback to some other manually concatenated URL, show empty string instead.
   * Empty string should never show up unless the API does not work properly.
   */ return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: "enterprise_sso.basic_info.saml.acs_url_field_name",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
                    displayType: "block",
                    variant: "border",
                    value: (0, $7oDSS.conditionalString)(samlProviderConfig?.serviceProvider && applyCustomDomain(samlProviderConfig.serviceProvider.assertionConsumerServiceUrl))
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: "enterprise_sso.basic_info.saml.audience_uri_field_name",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
                    displayType: "block",
                    variant: "border",
                    value: (0, $7oDSS.conditionalString)(samlProviderConfig?.serviceProvider && applyCustomDomain(samlProviderConfig.serviceProvider.entityId))
                })
            })
        ]
    });
}
var $f7db2874f110380e$export$2e2bcd8739ae039 = $f7db2874f110380e$var$SamlConnectorSpInfo;


var $d43394d1ecad5555$export$bfd64c937657f93a;
var $d43394d1ecad5555$export$f8e7b82cc7a7899b;
var $d43394d1ecad5555$export$4a6dd88bada4e7d2;
$d43394d1ecad5555$export$bfd64c937657f93a = `PniY7q_rotating`;
$d43394d1ecad5555$export$f8e7b82cc7a7899b = `PniY7q_samlMetadataForm`;
$d43394d1ecad5555$export$4a6dd88bada4e7d2 = `PniY7q_shimmer`;


const $26317544ddc65781$var$manualHandleErrorCodes = [
    (0, $66bbea88429aa70a$export$cc569019d304003),
    (0, $66bbea88429aa70a$export$8eb7d458c411e001)
];
function $26317544ddc65781$var$SamlConnectorForm({ isDeleted: isDeleted, data: data, onUpdated: onUpdated }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const api = (0, $7VnwS.default)({
        hideErrorToast: $26317544ddc65781$var$manualHandleErrorCodes
    });
    const methods = (0, $codQP.useForm)();
    const { formState: { isSubmitting: isSubmitting, isDirty: isDirty }, handleSubmit: handleSubmit, reset: reset, setError: setError } = methods;
    const { config: config, providerConfig: providerConfig, id: connectorId } = data;
    // Guard the config data
    const samlConnectorConfig = (0, $jC8Vy.useMemo)(()=>{
        const result = (0, $ecec7dd81bded225$export$70b1b935b7ff7713).safeParse(config);
        const { success: success } = result;
        const guardedConfig = success ? result.data : undefined;
        return guardedConfig;
    }, [
        config
    ]);
    // Guard the provider config data
    const samlProviderConfig = (0, $jC8Vy.useMemo)(()=>{
        const result = (0, $ecec7dd81bded225$export$fb0b03910ad8ad02).safeParse(providerConfig);
        const { success: success } = result;
        const guardedConfig = success ? result.data : undefined;
        return guardedConfig;
    }, [
        providerConfig
    ]);
    (0, $jC8Vy.useEffect)(()=>{
        reset(samlConnectorConfig);
    }, [
        samlConnectorConfig,
        reset
    ]);
    const onSubmit = handleSubmit((0, $5OcFi.trySubmitSafe)(async (formData)=>{
        if (isSubmitting) return;
        try {
            const result = await api.patch(`api/sso-connectors/${connectorId}`, {
                json: {
                    config: (0, (/*@__PURE__*/$parcel$interopDefault($9c80b3e301b9e290$exports)))(formData)
                }
            }).json();
            (0, $FuhPC.toast).success(t("general.saved"));
            onUpdated(result);
            reset(result.config);
        } catch (error) {
            if (error instanceof (0, $5cXXM.HTTPError)) {
                const errorBody = await error.response.clone().json();
                // Manually handle the error to show the error message in the form.
                if ($26317544ddc65781$var$manualHandleErrorCodes.includes(errorBody.code)) {
                    const errorFormKey = formData.metadataUrl ? "metadataUrl" : "metadata";
                    setError(errorFormKey, {
                        type: "custom",
                        message: errorBody.message
                    });
                    return;
                }
            }
            throw error;
        }
    }));
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $codQP.FormProvider), {
        ...methods,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $f0e7fd6d3bded790$export$2e2bcd8739ae039), {
                isDirty: isDirty,
                isSubmitting: isSubmitting,
                onDiscard: reset,
                onSubmit: onSubmit,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
                        title: "enterprise_sso_details.upload_idp_metadata_title_saml",
                        description: "enterprise_sso_details.upload_idp_metadata_description_saml",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $d43394d1ecad5555$export$f8e7b82cc7a7899b,
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c606610e55ec539a$export$2e2bcd8739ae039), {
                                config: samlConnectorConfig,
                                providerConfig: samlProviderConfig
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
                        title: "enterprise_sso_details.service_provider_property_title",
                        description: "enterprise_sso_details.service_provider_property_description",
                        descriptionInterpolation: {
                            protocol: "SAML 2.0"
                        },
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f7db2874f110380e$export$2e2bcd8739ae039), {
                            samlProviderConfig: samlProviderConfig
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
                        title: "enterprise_sso_details.attribute_mapping_title",
                        description: "enterprise_sso_details.attribute_mapping_description",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $b2e3d9a170028e87$export$2e2bcd8739ae039), {
                            samlProviderConfig: samlProviderConfig
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fea55fa5d5726e29$export$2e2bcd8739ae039), {
                hasUnsavedChanges: !isDeleted && isDirty
            })
        ]
    });
}
var $26317544ddc65781$export$2e2bcd8739ae039 = $26317544ddc65781$var$SamlConnectorForm;


function $53dcb3f7c21a6789$var$isSamlProviderData(data) {
    return data.providerType === (0, $8q742.SsoProviderType).SAML;
}
function $53dcb3f7c21a6789$var$isOidcProviderData(data) {
    return data.providerType === (0, $8q742.SsoProviderType).OIDC;
}
function $53dcb3f7c21a6789$var$Connection({ isDeleted: isDeleted, data: data, onUpdated: onUpdated }) {
    if ($53dcb3f7c21a6789$var$isSamlProviderData(data)) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $26317544ddc65781$export$2e2bcd8739ae039), {
        isDeleted: isDeleted,
        data: data,
        onUpdated: onUpdated
    });
    if ($53dcb3f7c21a6789$var$isOidcProviderData(data)) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e5a79493610a775d$export$2e2bcd8739ae039), {
        isDeleted: isDeleted,
        data: data,
        onUpdated: onUpdated
    });
    return null;
}
var $53dcb3f7c21a6789$export$2e2bcd8739ae039 = $53dcb3f7c21a6789$var$Connection;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("ajkVG");
var $7WNrO = parcelRequire("7WNrO");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");


var $5cXXM = parcelRequire("5cXXM");

var $codQP = parcelRequire("codQP");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");




var $aqmjm = parcelRequire("aqmjm");

var $1QOtg = parcelRequire("1QOtg");


var $fmHmG = parcelRequire("fmHmG");

var $7VnwS = parcelRequire("7VnwS");



var $5OcFi = parcelRequire("5OcFi");

var $cRLgg = parcelRequire("cRLgg");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("ajkVG");
var $7WNrO = parcelRequire("7WNrO");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $HHYyb = parcelRequire("HHYyb");

var $75SRw = parcelRequire("75SRw");


var $bnkR4 = parcelRequire("bnkR4");
const $e077665038dea8b0$export$a5d922e87633d379 = "single_sign_on.duplicated_domains";
const $e077665038dea8b0$export$87bccd4692227778 = "single_sign_on.forbidden_domains";
const $e077665038dea8b0$export$e4db90811da8f94 = "single_sign_on.invalid_domain_format";
const $e077665038dea8b0$export$693a7739508f6d01 = new RegExp("\\S+[\\.]{1}\\S+");


var $9404c66770613269$exports = {};

$parcel$export($9404c66770613269$exports, "close", function () { return $9404c66770613269$export$8360e631d277ea4d; }, function (v) { return $9404c66770613269$export$8360e631d277ea4d = v; });
$parcel$export($9404c66770613269$exports, "delete", function () { return $9404c66770613269$export$1822828d790e23ee; }, function (v) { return $9404c66770613269$export$1822828d790e23ee = v; });
$parcel$export($9404c66770613269$exports, "error", function () { return $9404c66770613269$export$a3bc9b8ed74fc; }, function (v) { return $9404c66770613269$export$a3bc9b8ed74fc = v; });
$parcel$export($9404c66770613269$exports, "errorMessage", function () { return $9404c66770613269$export$493b5823483d2c4e; }, function (v) { return $9404c66770613269$export$493b5823483d2c4e = v; });
$parcel$export($9404c66770613269$exports, "focused", function () { return $9404c66770613269$export$4c2b230493b2b322; }, function (v) { return $9404c66770613269$export$4c2b230493b2b322 = v; });
$parcel$export($9404c66770613269$exports, "info", function () { return $9404c66770613269$export$a80b3bd66acc52ff; }, function (v) { return $9404c66770613269$export$a80b3bd66acc52ff = v; });
$parcel$export($9404c66770613269$exports, "input", function () { return $9404c66770613269$export$b7e3ae3d7c15e42e; }, function (v) { return $9404c66770613269$export$b7e3ae3d7c15e42e = v; });
$parcel$export($9404c66770613269$exports, "multiple", function () { return $9404c66770613269$export$939ddaa3205df08e; }, function (v) { return $9404c66770613269$export$939ddaa3205df08e = v; });
$parcel$export($9404c66770613269$exports, "rotating", function () { return $9404c66770613269$export$bfd64c937657f93a; }, function (v) { return $9404c66770613269$export$bfd64c937657f93a = v; });
$parcel$export($9404c66770613269$exports, "shimmer", function () { return $9404c66770613269$export$4a6dd88bada4e7d2; }, function (v) { return $9404c66770613269$export$4a6dd88bada4e7d2 = v; });
$parcel$export($9404c66770613269$exports, "tag", function () { return $9404c66770613269$export$2b067c6666111485; }, function (v) { return $9404c66770613269$export$2b067c6666111485 = v; });
var $9404c66770613269$export$8360e631d277ea4d;
var $9404c66770613269$export$1822828d790e23ee;
var $9404c66770613269$export$a3bc9b8ed74fc;
var $9404c66770613269$export$493b5823483d2c4e;
var $9404c66770613269$export$4c2b230493b2b322;
var $9404c66770613269$export$a80b3bd66acc52ff;
var $9404c66770613269$export$b7e3ae3d7c15e42e;
var $9404c66770613269$export$939ddaa3205df08e;
var $9404c66770613269$export$bfd64c937657f93a;
var $9404c66770613269$export$4a6dd88bada4e7d2;
var $9404c66770613269$export$2b067c6666111485;
$9404c66770613269$export$8360e631d277ea4d = `_8qpGpW_close`;
$9404c66770613269$export$1822828d790e23ee = `_8qpGpW_delete`;
$9404c66770613269$export$a3bc9b8ed74fc = `_8qpGpW_error`;
$9404c66770613269$export$493b5823483d2c4e = `_8qpGpW_errorMessage`;
$9404c66770613269$export$4c2b230493b2b322 = `_8qpGpW_focused`;
$9404c66770613269$export$a80b3bd66acc52ff = `_8qpGpW_info`;
$9404c66770613269$export$b7e3ae3d7c15e42e = `_8qpGpW_input`;
$9404c66770613269$export$939ddaa3205df08e = `_8qpGpW_multiple`;
$9404c66770613269$export$bfd64c937657f93a = `_8qpGpW_rotating`;
$9404c66770613269$export$4a6dd88bada4e7d2 = `_8qpGpW_shimmer`;
$9404c66770613269$export$2b067c6666111485 = `_8qpGpW_tag`;


parcelRequire("cuPVN");
var $8ynli = parcelRequire("8ynli");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $4TsiV = parcelRequire("4TsiV");

const $e5b6a84d156ea62f$export$929a2b2dcadf379e = (inputValues)=>{
    const { duplicatedDomains: duplicatedDomains, forbiddenDomains: forbiddenDomains } = (0, $8ynli.findDuplicatedOrBlockedEmailDomains)(inputValues.map((domain)=>domain.value));
    const isAnyDomainInvalid = inputValues.some(({ value: value })=>!(0, $e077665038dea8b0$export$693a7739508f6d01).test(value));
    // Show error message and update the inputs' status for error display.
    if (duplicatedDomains.size > 0 || forbiddenDomains.size > 0 || isAnyDomainInvalid) return {
        values: inputValues.map(({ status: status, ...rest })=>({
                ...rest,
                ...(0, $7oDSS.conditional)((duplicatedDomains.has(rest.value) || forbiddenDomains.has(rest.value) || !(0, $e077665038dea8b0$export$693a7739508f6d01).test(rest.value)) && {
                    status: "info"
                })
            })),
        errorMessage: (0, $7oDSS.conditionalArray)((0, $7oDSS.conditionalString)(duplicatedDomains.size > 0 && (0, $4TsiV.t)(`errors:${(0, $e077665038dea8b0$export$a5d922e87633d379)}`)), (0, $7oDSS.conditionalString)(forbiddenDomains.size > 0 && (0, $4TsiV.t)(`errors:${(0, $e077665038dea8b0$export$87bccd4692227778)}`)), (0, $7oDSS.conditionalString)(isAnyDomainInvalid && (0, $4TsiV.t)(`errors:${(0, $e077665038dea8b0$export$e4db90811da8f94)}`))).join(" ")
    };
    return {
        values: inputValues
    };
};


function $3836ac8c937465a0$var$DomainsInput({ className: className, values: values, onChange: rawOnChange, error: error, placeholder: placeholder }) {
    const inputRef = (0, $jC8Vy.useRef)(null);
    const [focusedValueId, setFocusedValueId] = (0, $jC8Vy.useState)(null);
    const [currentValue, setCurrentValue] = (0, $jC8Vy.useState)("");
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { setError: setError, clearErrors: clearErrors } = (0, $codQP.useFormContext)();
    const onChange = (values)=>{
        const { values: parsedValues, errorMessage: errorMessage } = (0, $e5b6a84d156ea62f$export$929a2b2dcadf379e)(values);
        if (errorMessage) setError("domains", {
            type: "custom",
            message: errorMessage
        });
        else clearErrors("domains");
        rawOnChange(parsedValues);
    };
    const handleAdd = (value)=>{
        const newValues = [
            ...values,
            {
                value: value,
                id: (0, $7WNrO.generateStandardShortId)(),
                ...(0, $7oDSS.conditional)(!(0, $e077665038dea8b0$export$693a7739508f6d01).test(value) && {
                    status: "info"
                })
            }
        ];
        onChange(newValues);
        setCurrentValue("");
        inputRef.current?.focus();
    };
    const handleDelete = (option)=>{
        onChange(values.filter(({ id: id })=>id !== option.id));
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($9404c66770613269$exports.input, $9404c66770613269$exports.multiple, Boolean(error) && $9404c66770613269$exports.error, className),
                role: "button",
                tabIndex: 0,
                onKeyDown: (0, $bnkR4.onKeyDownHandler)(()=>{
                    inputRef.current?.focus();
                }),
                onClick: ()=>{
                    inputRef.current?.focus();
                },
                children: [
                    values.map((option)=>{
                        return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
                            variant: "cell",
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($9404c66770613269$exports.tag, option.status && $9404c66770613269$exports[option.status], option.id === focusedValueId && $9404c66770613269$exports.focused),
                            onClick: ()=>{
                                inputRef.current?.focus();
                            },
                            children: [
                                option.value,
                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                                    className: $9404c66770613269$exports.delete,
                                    size: "small",
                                    onClick: ()=>{
                                        handleDelete(option);
                                    },
                                    onKeyDown: (0, $bnkR4.onKeyDownHandler)(()=>{
                                        handleDelete(option);
                                    }),
                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $HHYyb.default), {
                                        className: $9404c66770613269$exports.close
                                    })
                                })
                            ]
                        }, option.id);
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("input", {
                        ref: inputRef,
                        // Need to use t() to complete the translation with prefix, use String() to convert the result to string.
                        // Should not show placeholder when there are values.
                        placeholder: (0, $7oDSS.conditional)(values.length === 0 && placeholder && String(t(placeholder))),
                        value: currentValue,
                        onKeyDown: (event)=>{
                            if (event.key === "Backspace" && currentValue === "") {
                                if (focusedValueId) {
                                    onChange(values.filter(({ id: id })=>id !== focusedValueId));
                                    setFocusedValueId(null);
                                } else setFocusedValueId(values.at(-1)?.id ?? null);
                                inputRef.current?.focus();
                            }
                            if (event.key === " " || event.code === "Space" || event.key === "Enter") {
                                // Focusing on input
                                if (currentValue !== "" && document.activeElement === inputRef.current) handleAdd(currentValue);
                                // Do not react to "Enter"
                                event.preventDefault();
                            }
                        },
                        onChange: ({ currentTarget: { value: value } })=>{
                            setCurrentValue(value);
                            setFocusedValueId(null);
                        },
                        onFocus: ()=>{
                            inputRef.current?.focus();
                        },
                        onBlur: ()=>{
                            if (currentValue !== "") handleAdd(currentValue);
                            setFocusedValueId(null);
                        }
                    })
                ]
            }),
            Boolean(error) && typeof error === "string" && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $9404c66770613269$exports.errorMessage,
                children: error
            })
        ]
    });
}
var $3836ac8c937465a0$export$2e2bcd8739ae039 = $3836ac8c937465a0$var$DomainsInput;





var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $2f4090d5272f101f$export$34e0f9847d4c02dd;
var $2f4090d5272f101f$export$6d59db4903f20f7d;
var $2f4090d5272f101f$export$a3bc9b8ed74fc;
var $2f4090d5272f101f$export$2cef06c20297c17d;
var $2f4090d5272f101f$export$8d14eecd258bcdb7;
var $2f4090d5272f101f$export$96cc76c17ae5d4f1;
var $2f4090d5272f101f$export$f1185274f83a7a7d;
var $2f4090d5272f101f$export$a7b0d73c5acc4a43;
var $2f4090d5272f101f$export$8a0fd8301fa867af;
var $2f4090d5272f101f$export$bfd64c937657f93a;
var $2f4090d5272f101f$export$4a6dd88bada4e7d2;
var $2f4090d5272f101f$export$7472b0d4ff79ef04;
$2f4090d5272f101f$export$34e0f9847d4c02dd = `wBBHtG_container`;
$2f4090d5272f101f$export$6d59db4903f20f7d = `wBBHtG_description`;
$2f4090d5272f101f$export$a3bc9b8ed74fc = `wBBHtG_error`;
$2f4090d5272f101f$export$2cef06c20297c17d = `wBBHtG_frame`;
$2f4090d5272f101f$export$8d14eecd258bcdb7 = `wBBHtG_frameBackground`;
$2f4090d5272f101f$export$96cc76c17ae5d4f1 = `wBBHtG_frameDark`;
$2f4090d5272f101f$export$f1185274f83a7a7d = `wBBHtG_frameDarkBackground`;
$2f4090d5272f101f$export$a7b0d73c5acc4a43 = `wBBHtG_logoDarkUploader`;
$2f4090d5272f101f$export$8a0fd8301fa867af = `wBBHtG_logoUploader`;
$2f4090d5272f101f$export$bfd64c937657f93a = `wBBHtG_rotating`;
$2f4090d5272f101f$export$4a6dd88bada4e7d2 = `wBBHtG_shimmer`;
$2f4090d5272f101f$export$7472b0d4ff79ef04 = `wBBHtG_uploader`;


const $9cbbd86b5eb23fa2$var$allowedMimeTypes = [
    "image/png",
    "image/jpeg",
    "image/svg+xml"
]; // Only allow `svg`, `png`, `jpg` and `jpeg` files.
function $9cbbd86b5eb23fa2$var$LogosUploader({ isDarkModeEnabled: isDarkModeEnabled }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [uploadLogoError, setUploadLogoError] = (0, $jC8Vy.useState)();
    const [uploadDarkLogoError, setUploadDarkLogoError] = (0, $jC8Vy.useState)();
    const { control: control } = (0, $codQP.useFormContext)();
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $2f4090d5272f101f$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $2f4090d5272f101f$export$7472b0d4ff79ef04,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $2f4090d5272f101f$export$8a0fd8301fa867af,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                            control: control,
                            name: "branding.logo",
                            render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $d986fdd56af49b28$export$2e2bcd8739ae039), {
                                    name: name,
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))(isDarkModeEnabled && $2f4090d5272f101f$export$2cef06c20297c17d, isDarkModeEnabled && value && $2f4090d5272f101f$export$8d14eecd258bcdb7),
                                    value: value ?? "",
                                    actionDescription: t(isDarkModeEnabled ? "enterprise_sso_details.branding_light_logo_context" : "enterprise_sso_details.branding_logo_context"),
                                    allowedMimeTypes: $9cbbd86b5eb23fa2$var$allowedMimeTypes,
                                    onCompleted: onChange,
                                    onUploadErrorChange: setUploadLogoError,
                                    onDelete: ()=>{
                                        onChange("");
                                    }
                                })
                        })
                    }),
                    isDarkModeEnabled && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $2f4090d5272f101f$export$a7b0d73c5acc4a43,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                            control: control,
                            name: "branding.darkLogo",
                            render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $d986fdd56af49b28$export$2e2bcd8739ae039), {
                                    name: name,
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($2f4090d5272f101f$export$96cc76c17ae5d4f1, value && $2f4090d5272f101f$export$f1185274f83a7a7d),
                                    value: value ?? "",
                                    actionDescription: t("enterprise_sso_details.branding_dark_logo_context"),
                                    allowedMimeTypes: $9cbbd86b5eb23fa2$var$allowedMimeTypes,
                                    onCompleted: onChange,
                                    onUploadErrorChange: setUploadDarkLogoError,
                                    onDelete: ()=>{
                                        onChange("");
                                    }
                                })
                        })
                    })
                ]
            }),
            uploadLogoError && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($2f4090d5272f101f$export$6d59db4903f20f7d, $2f4090d5272f101f$export$a3bc9b8ed74fc),
                children: t(isDarkModeEnabled ? "enterprise_sso_details.branding_light_logo_error" : "enterprise_sso_details.branding_logo_error", {
                    error: uploadLogoError
                })
            }),
            uploadDarkLogoError && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($2f4090d5272f101f$export$6d59db4903f20f7d, $2f4090d5272f101f$export$a3bc9b8ed74fc),
                children: t("enterprise_sso_details.branding_dark_logo_error", {
                    error: uploadDarkLogoError
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $2f4090d5272f101f$export$6d59db4903f20f7d,
                children: t("enterprise_sso_details.connector_logo_field_description")
            })
        ]
    });
}
var $9cbbd86b5eb23fa2$export$2e2bcd8739ae039 = $9cbbd86b5eb23fa2$var$LogosUploader;


var $c9eb767feb648776$export$6d59db4903f20f7d;
var $c9eb767feb648776$export$9e9024ab31cc2703;
var $c9eb767feb648776$export$bfd64c937657f93a;
var $c9eb767feb648776$export$4a6dd88bada4e7d2;
$c9eb767feb648776$export$6d59db4903f20f7d = `_32dlKq_description`;
$c9eb767feb648776$export$9e9024ab31cc2703 = `_32dlKq_inlineNotification`;
$c9eb767feb648776$export$bfd64c937657f93a = `_32dlKq_rotating`;
$c9eb767feb648776$export$4a6dd88bada4e7d2 = `_32dlKq_shimmer`;


const $56a5f74f8a2760d7$var$duplicateConnectorNameErrorCode = "single_sign_on.duplicate_connector_name";
const $56a5f74f8a2760d7$var$dataToFormParser = (data)=>{
    const { branding: branding, connectorName: connectorName, domains: domains, syncProfile: syncProfile } = data;
    return {
        branding: branding,
        connectorName: connectorName,
        domains: domains.map((domain)=>({
                value: domain,
                id: (0, $7WNrO.generateStandardShortId)()
            })),
        syncProfile: syncProfile ? (0, $6c796a80483fa826$export$ed9ee40b3ba009ed).EachSignIn : (0, $6c796a80483fa826$export$ed9ee40b3ba009ed).OnlyAtRegister
    };
};
const $56a5f74f8a2760d7$var$formDataToSsoConnectorParser = (formData)=>{
    const { branding: branding, connectorName: connectorName, domains: domains, syncProfile: syncProfile } = formData;
    return {
        branding: branding,
        connectorName: connectorName,
        domains: domains.map(({ value: value })=>value),
        syncProfile: syncProfile === (0, $6c796a80483fa826$export$ed9ee40b3ba009ed).EachSignIn
    };
};
function $56a5f74f8a2760d7$var$Experience({ data: data, isDeleted: isDeleted, onUpdated: onUpdated, isDarkModeEnabled: isDarkModeEnabled }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { isReady: isUserAssetsServiceReady } = (0, $04111409d75abad4$export$2e2bcd8739ae039)();
    const api = (0, $7VnwS.default)({
        hideErrorToast: true
    });
    const syncProfileOptions = [
        {
            value: (0, $6c796a80483fa826$export$ed9ee40b3ba009ed).OnlyAtRegister,
            title: t("enterprise_sso_details.sync_profile_option.register_only")
        },
        {
            value: (0, $6c796a80483fa826$export$ed9ee40b3ba009ed).EachSignIn,
            title: t("enterprise_sso_details.sync_profile_option.each_sign_in")
        }
    ];
    const formMethods = (0, $codQP.useForm)({
        defaultValues: $56a5f74f8a2760d7$var$dataToFormParser(data)
    });
    const { control: control, watch: watch, setValue: setValue, setError: setError, handleSubmit: handleSubmit, register: register, formState: { defaultValues: defaultValues, isDirty: isDirty, isSubmitting: isSubmitting, errors: errors }, reset: reset } = formMethods;
    const onSubmit = handleSubmit((0, $5OcFi.trySubmitSafe)(async (formData)=>{
        if (isSubmitting) return;
        try {
            const updatedSsoConnector = await api// TODO: @darcyYe add console test case of clean up `branding` config.
            // Only keep non-empty values since PATCH operation performs a merge scheme.
            .patch(`api/sso-connectors/${data.id}`, {
                json: (0, (/*@__PURE__*/$parcel$interopDefault($9c80b3e301b9e290$exports)))($56a5f74f8a2760d7$var$formDataToSsoConnectorParser(formData), {
                    // To overwrite the `branding` field, which is a JSONB typed column in DB.
                    emptyObjects: false
                })
            }).json();
            reset($56a5f74f8a2760d7$var$dataToFormParser(updatedSsoConnector));
            (0, $FuhPC.toast).success(t("general.saved"));
            onUpdated(updatedSsoConnector);
        } catch (error) {
            if (error instanceof (0, $5cXXM.HTTPError)) {
                const { response: response } = error;
                const metadata = await response.clone().json();
                /**
           * Should render invalid domains:
           * - show `error` tag for forbidden domains
           * - show `info` tag for duplicated domains
           *
           * Also manually passed the returned error message to `setError` to show the error message in-place.
           */ if ([
                    (0, $e077665038dea8b0$export$a5d922e87633d379),
                    (0, $e077665038dea8b0$export$87bccd4692227778),
                    (0, $e077665038dea8b0$export$e4db90811da8f94)
                ].includes(metadata.code)) {
                    setValue("domains", watch("domains").map((domain)=>({
                            ...domain,
                            ...(0, $7oDSS.conditional)(metadata.data.data.includes(domain.value) && {
                                status: "info"
                            })
                        })), {
                        shouldDirty: true
                    });
                    setError("domains", {
                        type: "custom",
                        message: metadata.message
                    });
                }
                if ($56a5f74f8a2760d7$var$duplicateConnectorNameErrorCode === metadata.code) setError("connectorName", {
                    type: "custom",
                    message: metadata.message
                });
            }
        }
    }));
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $codQP.FormProvider), {
        ...formMethods,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $f0e7fd6d3bded790$export$2e2bcd8739ae039), {
                isDirty: isDirty,
                isSubmitting: isSubmitting,
                onDiscard: reset,
                onSubmit: onSubmit,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
                        title: "enterprise_sso_details.general_settings_title",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                isRequired: true,
                                title: "enterprise_sso_details.connector_name_field_name",
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                    ...register("connectorName", {
                                        required: true
                                    }),
                                    error: errors.connectorName?.message
                                })
                            }),
                            !defaultValues?.domains?.length && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1QOtg.default), {
                                className: $c9eb767feb648776$export$9e9024ab31cc2703,
                                severity: "alert",
                                children: t("enterprise_sso_details.configure_domain_field_info_text")
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aqmjm.default), {
                                isRequired: true,
                                title: "enterprise_sso_details.email_domain_field_name",
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                                        name: "domains",
                                        control: control,
                                        rules: {
                                            validate: (value)=>{
                                                if (value.length === 0) return t("enterprise_sso_details.email_domain_field_required");
                                                const { errorMessage: errorMessage } = (0, $e5b6a84d156ea62f$export$929a2b2dcadf379e)(value);
                                                if (errorMessage) return errorMessage;
                                                return true;
                                            }
                                        },
                                        render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $3836ac8c937465a0$export$2e2bcd8739ae039), {
                                                values: value,
                                                // Per previous error handling on submitting, error message will be truthy.
                                                error: errors.domains?.message,
                                                placeholder: "enterprise_sso_details.email_domain_field_placeholder",
                                                onChange: onChange
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $c9eb767feb648776$export$6d59db4903f20f7d,
                                        children: t("enterprise_sso_details.email_domain_field_description")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                title: "enterprise_sso_details.sync_profile_field_name",
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                                    name: "syncProfile",
                                    control: control,
                                    rules: {
                                        required: true
                                    },
                                    render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $286a7bc94edef870$export$2e2bcd8739ae039), {
                                            options: syncProfileOptions,
                                            value: value,
                                            onChange: onChange
                                        })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
                        title: "enterprise_sso_details.custom_branding_title",
                        description: "enterprise_sso_details.custom_branding_description",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                title: "enterprise_sso_details.display_name_field_name",
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                    ...register("branding.displayName"),
                                    placeholder: data.name,
                                    error: errors.branding?.displayName?.message
                                })
                            }),
                            isUserAssetsServiceReady ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                title: "enterprise_sso_details.connector_logo_field_name",
                                headlineSpacing: "large",
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9cbbd86b5eb23fa2$export$2e2bcd8739ae039), {
                                    isDarkModeEnabled: isDarkModeEnabled
                                })
                            }) : /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                        title: "enterprise_sso_details.branding_logo_field_name",
                                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                            ...register("branding.logo", {
                                                validate: (value)=>!value || (0, $cRLgg.uriValidator)(value) || t("errors.invalid_uri_format")
                                            }),
                                            error: errors.branding?.logo?.message,
                                            placeholder: t("enterprise_sso_details.branding_logo_field_placeholder")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                        title: "enterprise_sso_details.branding_dark_logo_field_name",
                                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                            ...register("branding.darkLogo", {
                                                validate: (value)=>!value || (0, $cRLgg.uriValidator)(value) || t("errors.invalid_uri_format")
                                            }),
                                            error: errors.branding?.darkLogo?.message,
                                            placeholder: t("enterprise_sso_details.branding_dark_logo_field_placeholder")
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fea55fa5d5726e29$export$2e2bcd8739ae039), {
                hasUnsavedChanges: !isDeleted && isDirty
            })
        ]
    });
}
var $56a5f74f8a2760d7$export$2e2bcd8739ae039 = $56a5f74f8a2760d7$var$Experience;



var $C7mD2 = parcelRequire("C7mD2");

var $6YrGU = parcelRequire("6YrGU");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("cuPVN");
var $8q742 = parcelRequire("8q742");

var $jC8Vy = parcelRequire("jC8Vy");






const $3b41bd9158677564$var$ssoConnectorGuides = {
    [(0, $8q742.SsoProviderName).SAML]: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("cdnQF"))),
    [(0, $8q742.SsoProviderName).OIDC]: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("gKITH"))),
    [(0, $8q742.SsoProviderName).AZURE_AD]: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("7kkSz"))),
    [(0, $8q742.SsoProviderName).GOOGLE_WORKSPACE]: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("HJdjf"))),
    [(0, $8q742.SsoProviderName).OKTA]: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("5L9hQ"))),
    [(0, $8q742.SsoProviderName).AZURE_AD_OIDC]: (0, $jC8Vy.lazy)(async ()=>(parcelRequire("euAl0")))
};
var $3b41bd9158677564$export$2e2bcd8739ae039 = $3b41bd9158677564$var$ssoConnectorGuides;



var $2lgsR = parcelRequire("2lgsR");

var $aTllQ = parcelRequire("aTllQ");

var $9Q3SI = parcelRequire("9Q3SI");

var $g0vtZ = parcelRequire("g0vtZ");
var $5fee2affab27753e$export$a7db06668cad9adb;
var $5fee2affab27753e$export$bfd64c937657f93a;
var $5fee2affab27753e$export$4a6dd88bada4e7d2;
$5fee2affab27753e$export$a7db06668cad9adb = `-ViIsG_content`;
$5fee2affab27753e$export$bfd64c937657f93a = `-ViIsG_rotating`;
$5fee2affab27753e$export$4a6dd88bada4e7d2 = `-ViIsG_shimmer`;


function $f824bb0ac5da0416$var$SsoGuide({ ssoConnector: ssoConnector, className: className }) {
    if (!ssoConnector) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $g0vtZ.default), {});
    const { providerName: providerName } = ssoConnector;
    const Guide = (0, $3b41bd9158677564$export$2e2bcd8739ae039)[providerName];
    if (!Guide) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $g0vtZ.default), {});
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2lgsR.default), {
        ssoConnector: ssoConnector,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aTllQ.default), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($5fee2affab27753e$export$a7db06668cad9adb, className),
            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6YrGU.MDXProvider), {
                components: {
                    a: ({ children: children, ...props })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                            ...props,
                            targetBlank: true,
                            children: children
                        })
                },
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jC8Vy.Suspense), {
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)(Guide, {})
                })
            })
        })
    });
}
var $f824bb0ac5da0416$export$2e2bcd8739ae039 = $f824bb0ac5da0416$var$SsoGuide;



var $45238a38302a5c14$export$34e0f9847d4c02dd;
var $45238a38302a5c14$export$db3c28d99448dcff;
var $45238a38302a5c14$export$20b6fe5c276910c1;
var $45238a38302a5c14$export$bfd64c937657f93a;
var $45238a38302a5c14$export$4a6dd88bada4e7d2;
$45238a38302a5c14$export$34e0f9847d4c02dd = `_6rYuna_container`;
$45238a38302a5c14$export$db3c28d99448dcff = `_6rYuna_logo`;
$45238a38302a5c14$export$20b6fe5c276910c1 = `_6rYuna_readme`;
$45238a38302a5c14$export$bfd64c937657f93a = `_6rYuna_rotating`;
$45238a38302a5c14$export$4a6dd88bada4e7d2 = `_6rYuna_shimmer`;



var $jC8Vy = parcelRequire("jC8Vy");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
parcelRequire("voszV");
var $hgWIN = parcelRequire("hgWIN");

var $7VnwS = parcelRequire("7VnwS");

var $4ZcUR = parcelRequire("4ZcUR");

function $ca444500202b5a92$var$useDeleteConnector(ssoConnectorId) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [isDeleted, setIsDeleted] = (0, $jC8Vy.useState)(false);
    const [isDeleting, setIsDeleting] = (0, $jC8Vy.useState)(false);
    const api = (0, $7VnwS.default)();
    const { mutate: mutateGlobal } = (0, $hgWIN.useSWRConfig)();
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const onDeleteHandler = (0, $jC8Vy.useCallback)(async ()=>{
        if (!ssoConnectorId || isDeleting) return;
        setIsDeleting(true);
        try {
            await api.delete(`api/sso-connectors/${ssoConnectorId}`);
            setIsDeleted(true);
            (0, $FuhPC.toast).success(t("enterprise_sso_details.enterprise_sso_deleted"));
            // Reset the sso-connectors data to refresh the list.
            await mutateGlobal("api/sso-connectors");
            navigate((0, $66bbea88429aa70a$export$c203fee5942bffc3), {
                replace: true
            });
        } finally{
            setIsDeleting(false);
        }
    }, [
        api,
        isDeleting,
        mutateGlobal,
        navigate,
        ssoConnectorId,
        t
    ]);
    return {
        isDeleted: isDeleted,
        isDeleting: isDeleting,
        onDeleteHandler: onDeleteHandler
    };
}
var $ca444500202b5a92$export$2e2bcd8739ae039 = $ca444500202b5a92$var$useDeleteConnector;


const $6dc79d2a503ccace$var$getSsoConnectorDetailsPathname = (ssoConnectorId, tab)=>`${0, $66bbea88429aa70a$export$c203fee5942bffc3}/${ssoConnectorId}/${tab}`;
function $6dc79d2a503ccace$var$EnterpriseSsoDetails() {
    const { pathname: pathname } = (0, $2Phw0.useLocation)();
    const { ssoConnectorId: ssoConnectorId, tab: tab } = (0, $2Phw0.useParams)();
    const { isDeleted: isDeleted, isDeleting: isDeleting, onDeleteHandler: onDeleteHandler } = (0, $ca444500202b5a92$export$2e2bcd8739ae039)(ssoConnectorId);
    const [isReadmeOpen, setIsReadmeOpen] = (0, $jC8Vy.useState)(false);
    const { isLoading: isUserAssetServiceLoading } = (0, $04111409d75abad4$export$2e2bcd8739ae039)();
    const { data: signInExperience, isLoading: isSignInExperienceLoading } = (0, $voszV.default)("api/sign-in-exp");
    const { data: ssoConnector, error: requestError, mutate: mutate, isLoading: isSsoConnectorLoading } = (0, $voszV.default)(ssoConnectorId && `api/sso-connectors/${ssoConnectorId}`, {
        keepPreviousData: true
    });
    const isLoading = isSsoConnectorLoading || isUserAssetServiceLoading || isSignInExperienceLoading;
    const [isDeleteAlertOpen, setIsDeleteAlertOpen] = (0, $jC8Vy.useState)(false);
    const isDarkModeEnabled = signInExperience?.color.isDarkModeEnabled ?? false;
    (0, $jC8Vy.useEffect)(()=>{
        setIsDeleteAlertOpen(false);
    }, [
        pathname
    ]);
    if (!ssoConnectorId) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aa35f43ec98b7478$export$2e2bcd8739ae039), {
        backLink: (0, $66bbea88429aa70a$export$c203fee5942bffc3),
        backLinkTitle: "enterprise_sso_details.back_to_sso_connectors",
        error: requestError,
        onRetry: ()=>{
            mutate();
        },
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5TsIB.default), {
                titleKey: "enterprise_sso_details.page_title"
            }),
            isLoading && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dd9fddb6bc5d38a8$export$2e2bcd8739ae039), {}),
            !isLoading && ssoConnector && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $eefae5244405013e$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $608656f1bddbd059$export$2e2bcd8739ae039), {
                            className: $45238a38302a5c14$export$db3c28d99448dcff,
                            containerClassName: $45238a38302a5c14$export$34e0f9847d4c02dd,
                            data: (0, $iS4bq.pick)(ssoConnector, "providerLogo", "providerLogoDark", "branding")
                        }),
                        title: ssoConnector.connectorName,
                        primaryTag: ssoConnector.name,
                        identifier: {
                            name: "ID",
                            value: ssoConnector.id
                        },
                        additionalActionButton: {
                            title: "enterprise_sso_details.check_connection_guide",
                            icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f71d98d4090dad5c$export$2e2bcd8739ae039), {}),
                            onClick: ()=>{
                                setIsReadmeOpen(true);
                            }
                        },
                        actionMenuItems: [
                            {
                                type: "danger",
                                title: "general.delete",
                                icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3aa588de5c8665f2$export$2e2bcd8739ae039), {}),
                                onClick: ()=>{
                                    setIsDeleteAlertOpen(true);
                                }
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $353ae25d75ceb68c$export$2e2bcd8739ae039), {
                        title: "enterprise_sso_details.readme_drawer_title",
                        subtitle: "enterprise_sso_details.readme_drawer_subtitle",
                        isOpen: isReadmeOpen,
                        onClose: ()=>{
                            setIsReadmeOpen(false);
                        },
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f824bb0ac5da0416$export$2e2bcd8739ae039), {
                            ssoConnector: ssoConnector,
                            className: $45238a38302a5c14$export$20b6fe5c276910c1
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $26090e0c44b20d28$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                                href: $6dc79d2a503ccace$var$getSsoConnectorDetailsPathname(ssoConnectorId, (0, $bt3dS.EnterpriseSsoDetailsTabs).Connection),
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                    forKey: "enterprise_sso_details.tab_connection"
                                })
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                                href: $6dc79d2a503ccace$var$getSsoConnectorDetailsPathname(ssoConnectorId, (0, $bt3dS.EnterpriseSsoDetailsTabs).Experience),
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                    forKey: "enterprise_sso_details.tab_experience"
                                })
                            })
                        ]
                    }),
                    tab === (0, $bt3dS.EnterpriseSsoDetailsTabs).Experience && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $56a5f74f8a2760d7$export$2e2bcd8739ae039), {
                        data: ssoConnector,
                        isDeleted: isDeleted,
                        isDarkModeEnabled: isDarkModeEnabled,
                        onUpdated: ()=>{
                            mutate();
                        }
                    }),
                    tab === (0, $bt3dS.EnterpriseSsoDetailsTabs).Connection && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $53dcb3f7c21a6789$export$2e2bcd8739ae039), {
                        data: ssoConnector,
                        isDeleted: isDeleted,
                        onUpdated: (ssoConnector)=>{
                            mutate(ssoConnector);
                        }
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dL4NZ.default), {
                        isOpen: isDeleteAlertOpen,
                        isLoading: isDeleting,
                        confirmButtonText: "general.delete",
                        title: "enterprise_sso_details.delete_confirm_modal_title",
                        onCancel: async ()=>{
                            setIsDeleteAlertOpen(false);
                        },
                        onConfirm: onDeleteHandler,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: "enterprise_sso_details.delete_confirm_modal_content"
                        })
                    })
                ]
            })
        ]
    });
}
var $6dc79d2a503ccace$export$2e2bcd8739ae039 = $6dc79d2a503ccace$var$EnterpriseSsoDetails;


const $472148578556eea4$export$91c27cce9e6d3628 = {
    path: "enterprise-sso",
    children: [
        {
            index: true,
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7f506c68bad4b969$export$2e2bcd8739ae039), {})
        },
        {
            path: "create",
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7f506c68bad4b969$export$2e2bcd8739ae039), {})
        },
        {
            path: ":ssoConnectorId",
            children: [
                {
                    index: true,
                    element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Navigate), {
                        replace: true,
                        to: (0, $bt3dS.EnterpriseSsoDetailsTabs).Connection
                    })
                },
                {
                    path: ":tab",
                    element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6dc79d2a503ccace$export$2e2bcd8739ae039), {})
                }
            ]
        }
    ]
};



var $C7mD2 = parcelRequire("C7mD2");

var $2Phw0 = parcelRequire("2Phw0");
parcelRequire("8Mb3E");
var $bt3dS = parcelRequire("bt3dS");

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $2Phw0 = parcelRequire("2Phw0");parcelRequire("6bq3s");
var $2Phw0 = parcelRequire("2Phw0");

var $voszV = parcelRequire("voszV");
var $hgWIN = parcelRequire("hgWIN");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $e513438a8bc87044$var$SvgRoleFeature = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 40,
                height: 40,
                rx: 6,
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 19.792,
                cy: 13.5,
                r: 6.5,
                fill: "url(#paint0_linear_897_8053)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 12.194,
                y: 11.889,
                width: 8.778,
                height: 1.097,
                rx: 0.549,
                fill: "#2D2C61"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 23.167,
                y: 11.889,
                width: 4.389,
                height: 1.097,
                rx: 0.549,
                fill: "#2D2C61"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M10 28.584A6.583 6.583 0 0 1 16.584 22h6.832A6.583 6.583 0 0 1 30 28.584v2.221A2.194 2.194 0 0 1 27.805 33h-15.61A2.194 2.194 0 0 1 10 30.805v-2.221Z",
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M27.2 22a.6.6 0 0 0-.6.6v3.6a.6.6 0 0 0 .6.6h3.6a.6.6 0 0 0 .6-.6v-3.6a.6.6 0 0 0-.6-.6h-3.6Zm-3.6 7.2a.6.6 0 0 0-.6.6v3.6a.6.6 0 0 0 .6.6h3.6a.6.6 0 0 0 .6-.6v-3.6a.6.6 0 0 0-.6-.6h-3.6Zm6.6.6a.6.6 0 0 1 .6-.6h3.6a.6.6 0 0 1 .6.6v3.6a.6.6 0 0 1-.6.6h-3.6a.6.6 0 0 1-.6-.6v-3.6Zm-5.4-1.2a1.2 1.2 0 0 1 1.2-1.2h2.4v-.6h1.2v.6H32a1.2 1.2 0 0 1 1.2 1.2v.6H32v-.6h-6v.6h-1.2v-.6Z",
                fill: "url(#paint1_linear_897_8053)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M27.8 23.2v2.4h2.4v-2.4h-2.4Z",
                fill: "url(#paint2_linear_897_8053)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M24.2 30.4v2.4h2.4v-2.4h-2.4Z",
                fill: "url(#paint3_linear_897_8053)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M31.4 30.4v2.4h2.4v-2.4h-2.4Z",
                fill: "url(#paint4_linear_897_8053)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_897_8053",
                        x1: 15.526,
                        y1: 18.24,
                        x2: 24.261,
                        y2: 8.896,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF88FA"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_897_8053",
                        x1: 25.063,
                        y1: 32.375,
                        x2: 33.125,
                        y2: 23.75,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF88FA"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint2_linear_897_8053",
                        x1: 27.833,
                        y1: 24.31,
                        x2: 30.2,
                        y2: 24.31,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#D2C4FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ECD5FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint3_linear_897_8053",
                        x1: 24.233,
                        y1: 31.509,
                        x2: 26.6,
                        y2: 31.509,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#D2C4FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ECD5FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint4_linear_897_8053",
                        x1: 31.433,
                        y1: 31.51,
                        x2: 33.8,
                        y2: 31.51,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#D2C4FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ECD5FF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $e513438a8bc87044$export$2e2bcd8739ae039 = $e513438a8bc87044$var$SvgRoleFeature;





var $5TsIB = parcelRequire("5TsIB");

parcelRequire("8Mb3E");
var $bt3dS = parcelRequire("bt3dS");

var $dL4NZ = parcelRequire("dL4NZ");

var $66ixW = parcelRequire("66ixW");


var $7VnwS = parcelRequire("7VnwS");

var $4ZcUR = parcelRequire("4ZcUR");
var $95ee1858d8194dfe$export$bfd64c937657f93a;
var $95ee1858d8194dfe$export$4a6dd88bada4e7d2;
var $95ee1858d8194dfe$export$e16a509e03e8e9f6;
$95ee1858d8194dfe$export$bfd64c937657f93a = `RMR0ra_rotating`;
$95ee1858d8194dfe$export$4a6dd88bada4e7d2 = `RMR0ra_shimmer`;
$95ee1858d8194dfe$export$e16a509e03e8e9f6 = `RMR0ra_withTable`;


// Console path for organization roles
const $a54e9815eaed0b27$var$organizationRolesPath = `/organization-template/${(0, $bt3dS.OrganizationTemplateTabs).OrganizationRoles}`;
// API endpoint for organization roles
const $a54e9815eaed0b27$var$organizationRolesEndpoint = "api/organization-roles";
function $a54e9815eaed0b27$var$OrganizationRoleDetails() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { id: id } = (0, $2Phw0.useParams)();
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const { pathname: pathname } = (0, $2Phw0.useLocation)();
    const isPageHasTable = pathname.endsWith((0, $bt3dS.OrganizationRoleDetailsTabs).Permissions);
    const { data: data, error: error, mutate: mutate, isLoading: isLoading } = (0, $voszV.default)(id && `${$a54e9815eaed0b27$var$organizationRolesEndpoint}/${id}`);
    const api = (0, $7VnwS.default)();
    const { mutate: mutateGlobal } = (0, $hgWIN.useSWRConfig)();
    const [isDeletionAlertOpen, setIsDeletionAlertOpen] = (0, $jC8Vy.useState)(false);
    const [isDeleting, setIsDeleting] = (0, $jC8Vy.useState)(false);
    // Close deletion alert when navigating to another page
    (0, $jC8Vy.useEffect)(()=>{
        setIsDeletionAlertOpen(false);
    }, [
        pathname
    ]);
    const handleDelete = async ()=>{
        if (!data) return;
        setIsDeleting(true);
        try {
            await api.delete(`${$a54e9815eaed0b27$var$organizationRolesEndpoint}/${data.id}`);
            (0, $FuhPC.toast).success(t("organization_role_details.deleted", {
                name: data.name
            }));
            await mutateGlobal($a54e9815eaed0b27$var$organizationRolesEndpoint);
            navigate($a54e9815eaed0b27$var$organizationRolesPath, {
                replace: true
            });
        } finally{
            setIsDeleting(false);
        }
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aa35f43ec98b7478$export$2e2bcd8739ae039), {
        backLink: $a54e9815eaed0b27$var$organizationRolesPath,
        backLinkTitle: "organization_role_details.back_to_org_roles",
        isLoading: isLoading,
        error: error,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))(isPageHasTable && $95ee1858d8194dfe$export$e16a509e03e8e9f6),
        onRetry: mutate,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5TsIB.default), {
                titleKey: "organization_role_details.page_title"
            }),
            data && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $eefae5244405013e$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c1fc6cc4be9e0c9a$export$2e2bcd8739ae039), {
                            for: (0, $e513438a8bc87044$export$2e2bcd8739ae039),
                            size: 60
                        }),
                        title: data.name,
                        primaryTag: t("organization_role_details.org_role"),
                        identifier: {
                            name: "ID",
                            value: data.id
                        },
                        actionMenuItems: [
                            {
                                title: "general.delete",
                                icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3aa588de5c8665f2$export$2e2bcd8739ae039), {}),
                                type: "danger",
                                onClick: ()=>{
                                    setIsDeletionAlertOpen(true);
                                }
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dL4NZ.default), {
                        isOpen: isDeletionAlertOpen,
                        isLoading: isDeleting,
                        confirmButtonText: "general.delete",
                        onCancel: ()=>{
                            setIsDeletionAlertOpen(false);
                        },
                        onConfirm: handleDelete,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: "organization_role_details.delete_confirm"
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $26090e0c44b20d28$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                                href: `${$a54e9815eaed0b27$var$organizationRolesPath}/${data.id}/${(0, $bt3dS.OrganizationRoleDetailsTabs).Permissions}`,
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                    forKey: "organization_role_details.permissions.tab"
                                })
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                                href: `${$a54e9815eaed0b27$var$organizationRolesPath}/${data.id}/${(0, $bt3dS.OrganizationRoleDetailsTabs).General}`,
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                    forKey: "organization_role_details.general.tab"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Outlet), {
                        context: {
                            organizationRole: data,
                            isDeleting: isDeleting,
                            onOrganizationRoleUpdated: mutate
                        }
                    })
                ]
            })
        ]
    });
}
var $a54e9815eaed0b27$export$2e2bcd8739ae039 = $a54e9815eaed0b27$var$OrganizationRoleDetails;



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $2Phw0 = parcelRequire("2Phw0");






var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $dL4NZ = parcelRequire("dL4NZ");



var $a795877093e24fb9$export$af2022a36dc13b47;
(function(PermissionType) {
    PermissionType["Organization"] = "Organization";
    PermissionType["Api"] = "Api";
})($a795877093e24fb9$export$af2022a36dc13b47 || ($a795877093e24fb9$export$af2022a36dc13b47 = {}));


parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");

var $7VnwS = parcelRequire("7VnwS");

var $voszV = parcelRequire("voszV");
/**
 * Fetches the organization and resource scopes of an organization role.
 */ function $7dda433048cca98b$var$useOrganizationRoleScopes(organizationRoleId) {
    const organizationRolePath = `api/organization-roles/${organizationRoleId}`;
    const { data: organizationScopes = [], error: fetchOrganizationScopesError, isLoading: isOrganizationScopesLoading, mutate: mutateOrganizationScopes } = (0, $voszV.default)(`${organizationRolePath}/scopes`);
    const { data: resourceScopes = [], error: fetchResourceScopesError, isLoading: isResourceScopesLoading, mutate: mutateResourceScopes } = (0, $voszV.default)(`${organizationRolePath}/resource-scopes`);
    return {
        organizationScopes: organizationScopes,
        resourceScopes: resourceScopes,
        error: fetchOrganizationScopesError ?? fetchResourceScopesError,
        isLoading: isOrganizationScopesLoading || isResourceScopesLoading,
        mutate: ()=>{
            mutateOrganizationScopes();
            mutateResourceScopes();
        }
    };
}
var $7dda433048cca98b$export$2e2bcd8739ae039 = $7dda433048cca98b$var$useOrganizationRoleScopes;




var $jC8Vy = parcelRequire("jC8Vy");

var $voszV = parcelRequire("voszV");
function $00fcd0e7b0f0a984$var$useOrganizationScopesAssignment(assignedScopes = []) {
    const [selectedData, setSelectedData] = (0, $jC8Vy.useState)([]);
    const { data: organizationScopes } = (0, $voszV.default)("api/organization-scopes");
    const availableDataList = (0, $jC8Vy.useMemo)(()=>(organizationScopes ?? []).filter(({ id: id })=>!assignedScopes.some((scope)=>scope.id === id)), [
        organizationScopes,
        assignedScopes
    ]);
    return (0, $jC8Vy.useMemo)(()=>({
            selectedData: selectedData,
            setSelectedData: setSelectedData,
            availableDataList: availableDataList
        }), [
        selectedData,
        setSelectedData,
        availableDataList
    ]);
}
var $00fcd0e7b0f0a984$export$2e2bcd8739ae039 = $00fcd0e7b0f0a984$var$useOrganizationScopesAssignment;


parcelRequire("cuPVN");
var $9XFlr = parcelRequire("9XFlr");

var $jC8Vy = parcelRequire("jC8Vy");

var $voszV = parcelRequire("voszV");
function $0861aa77603b0f46$var$useResourceScopesAssignment(assignedScopes) {
    const [selectedData, setSelectedData] = (0, $jC8Vy.useState)([]);
    const { data: allResources } = (0, $voszV.default)("api/resources?includeScopes=true");
    const availableDataGroups = (0, $jC8Vy.useMemo)(()=>{
        if (!allResources) return [];
        const resourcesWithScopes = allResources// Filter out the management APIs
        .filter((resource)=>!(0, $9XFlr.isManagementApi)(resource.indicator)).map(({ name: name, scopes: scopes, id: resourceId })=>({
                groupId: resourceId,
                groupName: name,
                dataList: scopes// Filter out the scopes that have been assigned
                .filter(({ id: scopeId })=>!assignedScopes?.some((scope)=>scope.id === scopeId))
            }));
        // Filter out the resources that have no scopes
        return resourcesWithScopes.filter(({ dataList: dataList })=>dataList.length > 0);
    }, [
        allResources,
        assignedScopes
    ]);
    return (0, $jC8Vy.useMemo)(()=>({
            selectedData: selectedData,
            setSelectedData: setSelectedData,
            availableDataGroups: availableDataGroups
        }), [
        availableDataGroups,
        selectedData
    ]);
}
var $0861aa77603b0f46$export$2e2bcd8739ae039 = $0861aa77603b0f46$var$useResourceScopesAssignment;


function $01687897503c6760$var$useOrganizationRolePermissionsAssignment(organizationRoleId) {
    const organizationRolePath = `api/organization-roles/${organizationRoleId}`;
    const [activeTab, setActiveTab] = (0, $jC8Vy.useState)((0, $a795877093e24fb9$export$af2022a36dc13b47).Organization);
    const [isLoading, setIsLoading] = (0, $jC8Vy.useState)(false);
    const api = (0, $7VnwS.default)();
    const { organizationScopes: organizationScopes, resourceScopes: resourceScopes, mutate: mutate } = (0, $7dda433048cca98b$export$2e2bcd8739ae039)(organizationRoleId);
    const organizationScopesAssignment = (0, $00fcd0e7b0f0a984$export$2e2bcd8739ae039)(organizationScopes);
    const resourceScopesAssignment = (0, $0861aa77603b0f46$export$2e2bcd8739ae039)(resourceScopes);
    const clearSelectedData = (0, $jC8Vy.useCallback)(()=>{
        organizationScopesAssignment.setSelectedData([]);
        resourceScopesAssignment.setSelectedData([]);
    }, [
        organizationScopesAssignment,
        resourceScopesAssignment
    ]);
    const onSubmit = (0, $jC8Vy.useCallback)(async ()=>{
        setIsLoading(true);
        const newOrganizationScopes = organizationScopesAssignment.selectedData.map(({ id: id })=>id);
        const newResourceScopes = resourceScopesAssignment.selectedData.map(({ id: id })=>id);
        await Promise.all([
            (0, $7oDSS.cond)(newOrganizationScopes.length > 0 && api.post(`${organizationRolePath}/scopes`, {
                json: {
                    organizationScopeIds: newOrganizationScopes
                }
            })),
            (0, $7oDSS.cond)(newResourceScopes.length > 0 && api.post(`${organizationRolePath}/resource-scopes`, {
                json: {
                    scopeIds: newResourceScopes
                }
            }))
        ].filter(Boolean)).finally(()=>{
            setIsLoading(false);
        });
        mutate();
    }, [
        api,
        mutate,
        organizationRolePath,
        organizationScopesAssignment.selectedData,
        resourceScopesAssignment.selectedData
    ]);
    return (0, $jC8Vy.useMemo)(()=>({
            activeTab: activeTab,
            setActiveTab: setActiveTab,
            isLoading: isLoading,
            organizationScopesAssignment: organizationScopesAssignment,
            resourceScopesAssignment: resourceScopesAssignment,
            clearSelectedData: clearSelectedData,
            onSubmit: onSubmit
        }), [
        activeTab,
        clearSelectedData,
        isLoading,
        onSubmit,
        organizationScopesAssignment,
        resourceScopesAssignment
    ]);
}
var $01687897503c6760$export$2e2bcd8739ae039 = $01687897503c6760$var$useOrganizationRolePermissionsAssignment;


const $fc8b6b5544eb5e1e$var$permissionTabs = {
    [(0, $a795877093e24fb9$export$af2022a36dc13b47).Organization]: {
        title: "organization_role_details.permissions.organization_permissions",
        key: (0, $a795877093e24fb9$export$af2022a36dc13b47).Organization
    },
    [(0, $a795877093e24fb9$export$af2022a36dc13b47).Api]: {
        title: "organization_role_details.permissions.api_permissions",
        key: (0, $a795877093e24fb9$export$af2022a36dc13b47).Api
    }
};
function $fc8b6b5544eb5e1e$var$OrganizationRolePermissionsAssignmentModal({ organizationRoleId: organizationRoleId, isOpen: isOpen, onClose: onClose }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { activeTab: activeTab, setActiveTab: setActiveTab, onSubmit: onSubmit, organizationScopesAssignment: organizationScopesAssignment, resourceScopesAssignment: resourceScopesAssignment, clearSelectedData: clearSelectedData, isLoading: isLoading } = (0, $01687897503c6760$export$2e2bcd8739ae039)(organizationRoleId);
    const onCloseHandler = (0, $jC8Vy.useCallback)(()=>{
        onClose();
        clearSelectedData();
        setActiveTab((0, $a795877093e24fb9$export$af2022a36dc13b47).Organization);
    }, [
        clearSelectedData,
        onClose,
        setActiveTab
    ]);
    const onSubmitHandler = (0, $jC8Vy.useCallback)(async ()=>{
        await onSubmit();
        onCloseHandler();
    }, [
        onCloseHandler,
        onSubmit
    ]);
    const tabs = (0, $jC8Vy.useMemo)(()=>Object.values($fc8b6b5544eb5e1e$var$permissionTabs).map(({ title: title, key: key })=>{
            const selectedDataCount = key === (0, $a795877093e24fb9$export$af2022a36dc13b47).Organization ? organizationScopesAssignment.selectedData.length : resourceScopesAssignment.selectedData.length;
            return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                isActive: key === activeTab,
                onClick: ()=>{
                    setActiveTab(key);
                },
                children: `${t(title)}${selectedDataCount ? ` (${selectedDataCount})` : ""}`
            }, key);
        }), [
        activeTab,
        organizationScopesAssignment.selectedData.length,
        resourceScopesAssignment.selectedData.length,
        setActiveTab,
        t
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $dL4NZ.default), {
        isOpen: isOpen,
        isLoading: isLoading,
        title: "organization_role_details.permissions.assign_permissions",
        subtitle: "organization_role_details.permissions.assign_description",
        confirmButtonType: "primary",
        confirmButtonText: "general.save",
        cancelButtonText: "general.discard",
        size: "large",
        onCancel: onCloseHandler,
        onConfirm: onSubmitHandler,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $26090e0c44b20d28$export$2e2bcd8739ae039), {
                children: tabs
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $03bc4af79519e411$export$2e2bcd8739ae039), {
                isActive: (0, $a795877093e24fb9$export$af2022a36dc13b47).Organization === activeTab,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e2d629f863c762e5$export$2e2bcd8739ae039), {
                    title: "organization_role_details.permissions.assign_organization_permissions",
                    ...organizationScopesAssignment
                })
            }, (0, $a795877093e24fb9$export$af2022a36dc13b47).Organization),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $03bc4af79519e411$export$2e2bcd8739ae039), {
                isActive: (0, $a795877093e24fb9$export$af2022a36dc13b47).Api === activeTab,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e2d629f863c762e5$export$2e2bcd8739ae039), {
                    title: "organization_role_details.permissions.assign_api_permissions",
                    ...resourceScopesAssignment
                })
            }, (0, $a795877093e24fb9$export$af2022a36dc13b47).Api)
        ]
    });
}
var $fc8b6b5544eb5e1e$export$2e2bcd8739ae039 = $fc8b6b5544eb5e1e$var$OrganizationRolePermissionsAssignmentModal;



var $jGWQ4 = parcelRequire("jGWQ4");

var $66ixW = parcelRequire("66ixW");




var $7VnwS = parcelRequire("7VnwS");


var $C7mD2 = parcelRequire("C7mD2");

var $voszV = parcelRequire("voszV");

var $587a2979afbfb30a$export$34e0f9847d4c02dd;
var $587a2979afbfb30a$export$1ca1ec8b29a4ce27;
var $587a2979afbfb30a$export$bfd64c937657f93a;
var $587a2979afbfb30a$export$4a6dd88bada4e7d2;
$587a2979afbfb30a$export$34e0f9847d4c02dd = `xGfwhW_container`;
$587a2979afbfb30a$export$1ca1ec8b29a4ce27 = `xGfwhW_icon`;
$587a2979afbfb30a$export$bfd64c937657f93a = `xGfwhW_rotating`;
$587a2979afbfb30a$export$4a6dd88bada4e7d2 = `xGfwhW_shimmer`;


function $248d7f22d25ab833$var$ResourceName({ resourceId: resourceId }) {
    const { data: data, isLoading: isLoading } = (0, $voszV.default)(`api/resources/${resourceId}`);
    if (isLoading || !data) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("span", {
        className: $587a2979afbfb30a$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $49a1041a43011cc6$export$2e2bcd8739ae039), {
                className: $587a2979afbfb30a$export$1ca1ec8b29a4ce27
            }),
            data.name
        ]
    });
}
var $248d7f22d25ab833$export$2e2bcd8739ae039 = $248d7f22d25ab833$var$ResourceName;


var $f6780e4b323c7082$export$db2694f41e635e56;
var $f6780e4b323c7082$export$3dea766d36a8935f;
var $f6780e4b323c7082$export$bfd64c937657f93a;
var $f6780e4b323c7082$export$4a6dd88bada4e7d2;
$f6780e4b323c7082$export$db2694f41e635e56 = `RKvxGa_assignButton`;
$f6780e4b323c7082$export$3dea766d36a8935f = `RKvxGa_filter`;
$f6780e4b323c7082$export$bfd64c937657f93a = `RKvxGa_rotating`;
$f6780e4b323c7082$export$4a6dd88bada4e7d2 = `RKvxGa_shimmer`;



const $deb773656760afac$var$isResourceScope = (scope)=>"resourceId" in scope;
function $deb773656760afac$var$Permissions() {
    const { organizationRole: { id: organizationRoleId } } = (0, $2Phw0.useOutletContext)();
    const organizationRolePath = `api/organization-roles/${organizationRoleId}`;
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const api = (0, $7VnwS.default)();
    const { organizationScopes: organizationScopes, resourceScopes: resourceScopes, error: error, isLoading: isLoading, mutate: mutate } = (0, $7dda433048cca98b$export$2e2bcd8739ae039)(organizationRoleId);
    const [{ keyword: keyword }, updateSearchParameters] = (0, $66a3eb3654f9d141$export$2e2bcd8739ae039)({
        keyword: ""
    });
    const filterScopesByKeyword = (0, $jC8Vy.useCallback)((scopes)=>scopes.filter(({ name: name })=>name.includes(keyword)), [
        keyword
    ]);
    const scopesData = (0, $jC8Vy.useMemo)(()=>keyword ? [
            ...filterScopesByKeyword(resourceScopes),
            ...filterScopesByKeyword(organizationScopes)
        ] : [
            ...resourceScopes,
            ...organizationScopes
        ], [
        filterScopesByKeyword,
        keyword,
        organizationScopes,
        resourceScopes
    ]);
    const [editingScope, setEditingScope] = (0, $jC8Vy.useState)();
    const removeScopeHandler = (0, $jC8Vy.useCallback)((scopeToRemove)=>async ()=>{
            const deleteSubpath = $deb773656760afac$var$isResourceScope(scopeToRemove) ? "resource-scopes" : "scopes";
            await api.delete(`${organizationRolePath}/${deleteSubpath}/${scopeToRemove.id}`);
            (0, $FuhPC.toast).success(t("organization_role_details.permissions.removed", {
                name: scopeToRemove.name
            }));
            mutate();
        }, [
        api,
        mutate,
        organizationRolePath,
        t
    ]);
    const handleEdit = async (scope, editedData)=>{
        const patchApiEndpoint = $deb773656760afac$var$isResourceScope(scope) ? `api/resources/${scope.resourceId}/scopes/${scope.id}` : `api/organization-scopes/${scope.id}`;
        await api.patch(patchApiEndpoint, {
            json: editedData
        });
        (0, $FuhPC.toast).success(t("general.saved"));
        mutate();
    };
    const [isAssignScopesModalOpen, setIsAssignScopesModalOpen] = (0, $jC8Vy.useState)(false);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3166f28a681c41bb$export$2e2bcd8739ae039), {
                rowGroups: [
                    {
                        key: "organizationRolePermissions",
                        data: scopesData
                    }
                ],
                rowIndexKey: "id",
                columns: [
                    {
                        title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: "organization_role_details.permissions.name_column"
                        }),
                        dataIndex: "name",
                        colSpan: 5,
                        render: ({ name: name })=>{
                            return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
                                variant: "cell",
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e52124c5a4489a19$export$2e2bcd8739ae039), {
                                    children: name
                                })
                            });
                        }
                    },
                    {
                        title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: "organization_role_details.permissions.description_column"
                        }),
                        dataIndex: "description",
                        colSpan: 5,
                        render: ({ description: description })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $e52124c5a4489a19$export$2e2bcd8739ae039), {
                                children: description ?? "-"
                            })
                    },
                    {
                        title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: "organization_role_details.permissions.type_column"
                        }),
                        dataIndex: "type",
                        colSpan: 5,
                        render: (scope)=>{
                            return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e52124c5a4489a19$export$2e2bcd8739ae039), {
                                children: $deb773656760afac$var$isResourceScope(scope) ? /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                            forKey: "organization_role_details.permissions.type.api"
                                        }),
                                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $248d7f22d25ab833$export$2e2bcd8739ae039), {
                                            resourceId: scope.resourceId
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                    forKey: "organization_role_details.permissions.type.org"
                                })
                            });
                        }
                    },
                    {
                        title: null,
                        dataIndex: "action",
                        colSpan: 1,
                        render: (scope)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $d6ac1a830c94487b$export$2e2bcd8739ae039), {
                                fieldName: "organization_role_details.permissions.name_column",
                                deleteConfirmation: "organization_role_details.permissions.remove_confirmation",
                                textOverrides: {
                                    delete: "organization_role_details.permissions.remove_permission",
                                    deleteConfirmation: "general.remove"
                                },
                                onEdit: ()=>{
                                    setEditingScope(scope);
                                },
                                onDelete: removeScopeHandler(scope)
                            })
                    }
                ],
                filter: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: $f6780e4b323c7082$export$3dea766d36a8935f,
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $46c375e0973aedf1$export$2e2bcd8739ae039), {
                            isClearable: Boolean(keyword),
                            placeholder: t("organization_template.permissions.search_placeholder"),
                            defaultValue: keyword,
                            onSearch: (keyword)=>{
                                if (keyword) updateSearchParameters({
                                    keyword: keyword
                                });
                            },
                            onClearSearch: ()=>{
                                updateSearchParameters({
                                    keyword: ""
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                            title: "organization_role_details.permissions.assign_permissions",
                            className: $f6780e4b323c7082$export$db2694f41e635e56,
                            type: "primary",
                            icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0b30fe81c923292b$export$2e2bcd8739ae039), {}),
                            onClick: ()=>{
                                setIsAssignScopesModalOpen(true);
                            }
                        })
                    ]
                }),
                placeholder: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a0f84bc7cc69e410$export$2e2bcd8739ae039), {}),
                isLoading: isLoading,
                errorMessage: error?.body?.message ?? error?.message,
                onRetry: mutate
            }),
            editingScope && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5335921b9cd1fc58$export$2e2bcd8739ae039), {
                scopeName: editingScope.name,
                data: editingScope,
                text: $deb773656760afac$var$isResourceScope(editingScope) ? {
                    title: "permissions.edit_title",
                    nameField: "api_resource_details.permission.name",
                    descriptionField: "api_resource_details.permission.description",
                    descriptionPlaceholder: "api_resource_details.permission.description_placeholder"
                } : {
                    title: "organization_template.permissions.edit_title",
                    nameField: "organization_template.permissions.permission_field_name",
                    descriptionField: "organization_template.permissions.description_field_name",
                    descriptionPlaceholder: "organization_template.permissions.description_field_placeholder"
                },
                onSubmit: async (editedData)=>{
                    await handleEdit(editingScope, editedData);
                },
                onClose: ()=>{
                    setEditingScope(undefined);
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fc8b6b5544eb5e1e$export$2e2bcd8739ae039), {
                organizationRoleId: organizationRoleId,
                isOpen: isAssignScopesModalOpen,
                onClose: ()=>{
                    setIsAssignScopesModalOpen(false);
                }
            })
        ]
    });
}
var $deb773656760afac$export$2e2bcd8739ae039 = $deb773656760afac$var$Permissions;



var $C7mD2 = parcelRequire("C7mD2");

var $codQP = parcelRequire("codQP");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $2Phw0 = parcelRequire("2Phw0");



parcelRequire("8Mb3E");
var $cfL6o = parcelRequire("cfL6o");

var $aqmjm = parcelRequire("aqmjm");

var $fmHmG = parcelRequire("fmHmG");

var $7VnwS = parcelRequire("7VnwS");


var $5OcFi = parcelRequire("5OcFi");
function $267ad39c2bc3d37a$var$Settings() {
    const { organizationRole: organizationRole, isDeleting: isDeleting, onOrganizationRoleUpdated: onOrganizationRoleUpdated } = (0, $2Phw0.useOutletContext)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $b595fc2f0eccd19a$export$2e2bcd8739ae039)();
    const { register: register, handleSubmit: handleSubmit, reset: reset, formState: { errors: errors, isDirty: isDirty, isSubmitting: isSubmitting } } = (0, $codQP.useForm)({
        defaultValues: organizationRole
    });
    const api = (0, $7VnwS.default)();
    const onSubmit = handleSubmit((0, $5OcFi.trySubmitSafe)(async (formData)=>{
        const updatedData = await api.patch(`api/organization-roles/${organizationRole.id}`, {
            json: formData
        }).json();
        reset(updatedData);
        onOrganizationRoleUpdated(updatedData);
        (0, $FuhPC.toast).success(t("general.saved"));
    }));
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $f0e7fd6d3bded790$export$2e2bcd8739ae039), {
        isDirty: isDirty,
        isSubmitting: isSubmitting,
        onSubmit: onSubmit,
        onDiscard: reset,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
                title: "organization_role_details.general.settings",
                description: "organization_role_details.general.description",
                learnMoreLink: {
                    href: getDocumentationUrl((0, $cfL6o.organizationRoleLink)),
                    targetBlank: "noopener"
                },
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        isRequired: true,
                        title: "organization_role_details.general.name_field",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                            placeholder: "viewer",
                            error: Boolean(errors.name),
                            ...register("name", {
                                required: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        title: "organization_role_details.general.description_field",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                            placeholder: t("organization_role_details.general.description_field_placeholder"),
                            ...register("description")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fea55fa5d5726e29$export$2e2bcd8739ae039), {
                hasUnsavedChanges: !isDeleting && isDirty
            })
        ]
    });
}
var $267ad39c2bc3d37a$export$2e2bcd8739ae039 = $267ad39c2bc3d37a$var$Settings;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $lXQZH = parcelRequire("lXQZH");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $2Phw0 = parcelRequire("2Phw0");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $0807787c5f5c1b37$var$SvgOrganizationEmptyDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                opacity: 0.4,
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M183.392 208.572H74.295c-2.523.361-5.1.548-7.717.548a54.46 54.46 0 0 1-7.717-.548h-4.39v-.814C29.042 201.941 10 178.181 10 149.755c0-29.527 20.545-54.02 47.453-58.597C66.408 59.273 94.515 36 127.804 36c31.611 0 58.551 20.988 68.853 50.408 29.827 2.865 53.187 29.183 53.187 61.227 0 30.421-21.055 55.682-48.709 60.613v.324H199.1a56.417 56.417 0 0 1-7.854.548c-2.663 0-5.285-.187-7.854-.548Z",
                fill: "url(#paint0_linear_9679_23642)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M219.527 125.238c.007-.314.011-.63.011-.946 0-21.7-17.591-39.292-39.292-39.292-18.457 0-33.942 12.727-38.158 29.883-15.601.523-28.088 13.335-28.088 29.064 0 15.346 11.886 27.915 26.954 29.004v.174h78.584v-47.887h-.011Z",
                fill: "url(#paint1_linear_9679_23642)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M41.814 226.968c4.89-.693 7.251-17.031 7.423-37.533 1.31-1.024 2.688-2.307 4.1-3.719 4.629-4.629 6.705-10.058 5.155-11.608-1.307-1.307-5.373-.035-9.392 3.172-.557-17.391-2.763-30.274-7.613-30.274-6.534 0-7.76 17.905-7.76 39.992 0 2.757.039 5.449.116 8.049-1.841-2.114-3.575-3.272-4.89-3.272-3.582 0-1.806 9.763 1.858 19.326 2.541 6.634 5.503 12.107 8.213 14.403.607.795 1.268 1.286 1.984 1.437l-.025-9.277c-3.448-6.652-10.65-20.117-10.65-20.117l10.642 17.085-.021-7.437v-.008l-.05-17.788-.078.073v-2.208l.072-.064c-.038-13.916-.072-26.436-.072-27.962 0-2.379.44 6.332.733 27.416 4.154-3.285 12.106-7.058 12.106-7.058-5.705 3.651-10.324 7.617-12.078 9.184.13 10.066.224 22.754.227 38.188Z",
                fill: "url(#paint2_linear_9679_23642)",
                style: {
                    mixBlendMode: "hard-light"
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M15.882 229h30.244c2.88 0 4.68-3.398 0-5.663-4.681-2.265-15.842-3.964-24.484-3.114-8.64.849-9 8.777-5.76 8.777Z",
                fill: "#C8BEE6",
                style: {
                    mixBlendMode: "hard-light"
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M219.527 125.238c.007-.314.011-.63.011-.946 0-21.7-17.591-39.292-39.292-39.292-18.457 0-33.942 12.727-38.158 29.883-15.601.523-28.088 13.335-28.088 29.064 0 15.346 11.886 27.915 26.954 29.004v.174h78.584v-47.887h-.011Z",
                fill: "#D2CCDD"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M219.527 125.238c.007-.314.011-.63.011-.946 0-21.7-17.591-39.292-39.292-39.292-18.457 0-33.942 12.727-38.158 29.883-15.601.523-28.088 13.335-28.088 29.064 0 15.346 11.886 27.915 26.954 29.004v.174h78.584v-47.887h-.011Z",
                fill: "url(#paint3_linear_9679_23642)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M222.346 34.5a.125.125 0 0 1 .171-.044l1.946 1.135c.06.035.08.112.045.171l-1.998 3.425 3.965.018c.069 0 .125.056.125.126l-.011 2.252c0 .07-.056.125-.125.125l-3.966-.018 1.967 3.443a.124.124 0 0 1-.046.171l-1.956 1.118a.125.125 0 0 1-.171-.047l-1.967-3.442-1.998 3.424a.125.125 0 0 1-.171.046l-1.946-1.136a.125.125 0 0 1-.045-.171l1.998-3.425-3.966-.018a.125.125 0 0 1-.124-.126l.01-2.253c0-.07.057-.125.126-.124l3.965.017-1.967-3.442a.124.124 0 0 1 .046-.17l1.956-1.119a.125.125 0 0 1 .171.047l1.967 3.443 1.999-3.425Z",
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 6.421,
                height: 6.421,
                rx: 2,
                transform: "scale(-1 1) rotate(-40.65 56.962 74.91)",
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M44 142a8 8 0 0 1 8-8h128a8 8 0 0 1 8 8v85H44v-85Z",
                fill: "url(#paint4_linear_9679_23642)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M48 141a4 4 0 0 1 4-4h128a4 4 0 0 1 4 4v82H48v-82Z",
                fill: "url(#paint5_linear_9679_23642)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M19 223h193v2a4 4 0 0 1-4 4H24a5 5 0 0 1-5-5v-1Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M106 137h20v2a4 4 0 0 1-4 4h-12a4 4 0 0 1-4-4v-2Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 59,
                y: 153,
                width: 110,
                height: 56,
                rx: 5,
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M90.548 153h28.451v47a9 9 0 0 1-9 9h-33l13.549-56Z",
                fill: "url(#paint6_linear_9679_23642)",
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 90,
                y: 164,
                width: 68,
                height: 6,
                rx: 2,
                fill: "#FF91DF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 90,
                y: 176,
                width: 68,
                height: 6,
                rx: 2,
                fill: "#C29DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 90,
                y: 188,
                width: 68,
                height: 6,
                rx: 2,
                fill: "#C29DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 73.5,
                cy: 169.5,
                r: 7.5,
                fill: "#C39EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "mask0_9679_23642",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 66,
                y: 162,
                width: 15,
                height: 15,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                    cx: 73.5,
                    cy: 169.5,
                    r: 7.5,
                    fill: "#FF91DF"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("g", {
                mask: "url(#mask0_9679_23642)",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    d: "M73.434 164.5a.8.8 0 0 0-.782.63l-.092.425a.773.773 0 0 1-.475.535.769.769 0 0 1-.712-.044l-.363-.234a.8.8 0 0 0-.998.107l-.093.093a.8.8 0 0 0-.107.998l.234.363a.77.77 0 0 1 .044.712.774.774 0 0 1-.535.475l-.425.092a.8.8 0 0 0-.63.782v.132a.8.8 0 0 0 .63.782l.425.092c.246.053.439.242.535.475a.77.77 0 0 1-.044.712l-.234.363a.8.8 0 0 0 .107.998l.093.093a.8.8 0 0 0 .998.107l.364-.234a.769.769 0 0 1 .711-.044.773.773 0 0 1 .475.535l.092.425a.8.8 0 0 0 .782.63h.132a.8.8 0 0 0 .782-.63l.092-.425a.773.773 0 0 1 .475-.535.769.769 0 0 1 .712.044l.363.234a.8.8 0 0 0 .998-.107l.093-.093a.8.8 0 0 0 .107-.998l-.234-.363a.77.77 0 0 1-.044-.712.774.774 0 0 1 .535-.475l.425-.092a.8.8 0 0 0 .63-.782v-.132a.8.8 0 0 0-.63-.782l-.425-.092a.774.774 0 0 1-.535-.475.77.77 0 0 1 .044-.712l.234-.363a.8.8 0 0 0-.107-.998l-.093-.093a.8.8 0 0 0-.998-.107l-.364.234a.769.769 0 0 1-.711.044.773.773 0 0 1-.475-.535l-.092-.425a.8.8 0 0 0-.782-.63h-.132Zm.066 2.857a2.143 2.143 0 1 1 0 4.287 2.143 2.143 0 0 1 0-4.287Z",
                    fill: "#F5EEFF"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                clipPath: "url(#clip0_9679_23642)",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 99,
                        y: 62,
                        width: 139.8,
                        height: 153,
                        rx: 10,
                        fill: "#E6DEFF"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                        cx: 110.519,
                        cy: 77.949,
                        r: 2.658,
                        fill: "#FF5449"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                        cx: 121.152,
                        cy: 77.949,
                        r: 2.658,
                        fill: "#FFB95A"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                        cx: 131.785,
                        cy: 77.949,
                        r: 2.658,
                        fill: "#68BE6C"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 107.861,
                        y: 91.24,
                        width: 21.266,
                        height: 21.266,
                        rx: 4.43,
                        fill: "url(#paint7_linear_9679_23642)"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M117.361 97.469v2h2v-2h-2Zm-.5-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3Zm-2.5 7v2h2v-2h-2Zm-.5-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-1v-.5h5v.5h-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-1v-.5a1 1 0 0 0-1-1h-2v-.5h-1v.5h-2a1 1 0 0 0-1 1v.5h-1Zm6.5 3v-2h2v2h-2Z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 133.557,
                        y: 94.873,
                        width: 54,
                        height: 14,
                        rx: 3,
                        fill: "url(#paint8_linear_9679_23642)",
                        opacity: 0.4
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 107.861,
                        y: 118.506,
                        width: 21.266,
                        height: 21.266,
                        rx: 4.43,
                        fill: "url(#paint9_linear_9679_23642)"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M117.361 124.734v2h2v-2h-2Zm-.5-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3Zm-2.5 7v2h2v-2h-2Zm-.5-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-1v-.5h5v.5h-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-1v-.5a1 1 0 0 0-1-1h-2v-.499h-1v.499h-2a1 1 0 0 0-1 1v.5h-1Zm6.5 3v-2h2v2h-2Z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 133.557,
                        y: 122.139,
                        width: 54,
                        height: 14,
                        rx: 3,
                        fill: "url(#paint10_linear_9679_23642)",
                        opacity: 0.4
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 107.861,
                        y: 145.771,
                        width: 21.266,
                        height: 21.266,
                        rx: 4.43,
                        fill: "url(#paint11_linear_9679_23642)"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M117.361 152v2h2v-2h-2Zm-.5-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3Zm-2.5 7v2h2v-2h-2Zm-.5-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-1v-.5h5v.5h-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-1v-.5a1 1 0 0 0-1-1h-2v-.5h-1v.5h-2a1 1 0 0 0-1 1v.5h-1Zm6.5 3v-2h2v2h-2Z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 133.557,
                        y: 149.404,
                        width: 54,
                        height: 14,
                        rx: 3,
                        fill: "url(#paint12_linear_9679_23642)",
                        opacity: 0.4
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 107.861,
                        y: 173.038,
                        width: 21.266,
                        height: 21.266,
                        rx: 4.43,
                        fill: "#9C7ECC"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M122.629 183.081h-3.545v-3.544a.59.59 0 1 0-1.181 0v3.544h-3.544a.595.595 0 0 0-.591.591.59.59 0 0 0 .591.591h3.544v3.544a.59.59 0 1 0 1.181 0v-3.544h3.545a.588.588 0 0 0 .59-.591.59.59 0 0 0-.59-.591Z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 133.557,
                        y: 176.671,
                        width: 54,
                        height: 14,
                        rx: 3,
                        fill: "url(#paint13_linear_9679_23642)",
                        opacity: 0.4
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("g", {
                        clipPath: "url(#clip1_9679_23642)",
                        children: /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                            clipPath: "url(#clip2_9679_23642)",
                            children: [
                                /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                                    opacity: 0.2,
                                    x: 201,
                                    y: 86,
                                    width: 50.506,
                                    height: 13.291,
                                    rx: 2.658,
                                    fill: "url(#paint14_linear_9679_23642)"
                                }),
                                /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                                    opacity: 0.2,
                                    x: 201,
                                    y: 106.38,
                                    width: 50.506,
                                    height: 13.291,
                                    rx: 2.658,
                                    fill: "url(#paint15_linear_9679_23642)"
                                }),
                                /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                                    opacity: 0.2,
                                    x: 201,
                                    y: 126.76,
                                    width: 51,
                                    height: 92,
                                    rx: 2.658,
                                    fill: "url(#paint16_linear_9679_23642)"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 99.3,
                y: 62.3,
                width: 139.2,
                height: 152.4,
                rx: 9.7,
                stroke: "#C9C5D0",
                strokeWidth: 0.6
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 7.195,
                height: 7.186,
                rx: 1.8,
                transform: "rotate(30.748 -162.595 155.586) skewX(-.13)",
                fill: "#6E6083"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m252.791 71-1.195 2.564a2.828 2.828 0 0 1-3.758 1.37v0a2.828 2.828 0 0 0-3.758 1.37v0a2.828 2.828 0 0 1-3.758 1.37v0a2.828 2.828 0 0 0-3.758 1.37l-1.194 2.563",
                stroke: "#928F9A",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m72.521 65.49-.36-2.514a2.544 2.544 0 0 0-2.88-2.154v0a2.544 2.544 0 0 1-2.88-2.154v0a2.544 2.544 0 0 0-2.881-2.154l-2.52.36",
                stroke: "#928F9A",
                strokeWidth: 1.8,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_9679_23642",
                        x1: 44,
                        y1: -19,
                        x2: 130,
                        y2: 232,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#6E6A88"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F3EFFA",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_9679_23642",
                        x1: 166.769,
                        y1: 85,
                        x2: 166.769,
                        y2: 232.5,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FEFDFF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAF7FF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint2_linear_9679_23642",
                        x1: 42.861,
                        y1: 228.869,
                        x2: 56.406,
                        y2: 112.054,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#C7BDE6"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E4DBFF",
                                stopOpacity: 0.16
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint3_linear_9679_23642",
                        x1: 166.769,
                        y1: 85,
                        x2: 166.769,
                        y2: 232.5,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FEFDFF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAF7FF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint4_linear_9679_23642",
                        x1: 112.556,
                        y1: 136.099,
                        x2: 143.327,
                        y2: 238.121,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint5_linear_9679_23642",
                        x1: 184,
                        y1: 223.001,
                        x2: -25,
                        y2: 90.001,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#BC97FD"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#BC97FD",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint6_linear_9679_23642",
                        x1: 120.59,
                        y1: 178.664,
                        x2: 80.951,
                        y2: 203.746,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#ECB6FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#BE9BFF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint7_linear_9679_23642",
                        x1: 109.423,
                        y1: 101.855,
                        x2: 131.77,
                        y2: 101.855,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#6B47F7"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7F46FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint8_linear_9679_23642",
                        x1: 137.524,
                        y1: 101.861,
                        x2: 194.27,
                        y2: 101.861,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#6B47F7"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7F46FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint9_linear_9679_23642",
                        x1: 109.423,
                        y1: 129.121,
                        x2: 131.77,
                        y2: 129.121,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#6B47F7"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7F46FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint10_linear_9679_23642",
                        x1: 137.524,
                        y1: 129.127,
                        x2: 194.27,
                        y2: 129.127,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#6B47F7"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7F46FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint11_linear_9679_23642",
                        x1: 109.423,
                        y1: 156.387,
                        x2: 131.77,
                        y2: 156.387,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#6B47F7"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7F46FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint12_linear_9679_23642",
                        x1: 137.524,
                        y1: 156.393,
                        x2: 194.27,
                        y2: 156.393,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#6B47F7"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7F46FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint13_linear_9679_23642",
                        x1: 137.524,
                        y1: 183.659,
                        x2: 194.27,
                        y2: 183.659,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#6B47F7"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7F46FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint14_linear_9679_23642",
                        x1: 204.71,
                        y1: 92.634,
                        x2: 257.785,
                        y2: 92.634,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#6B47F7"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7F46FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint15_linear_9679_23642",
                        x1: 204.71,
                        y1: 113.014,
                        x2: 257.785,
                        y2: 113.014,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#6B47F7"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7F46FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint16_linear_9679_23642",
                        x1: 204.747,
                        y1: 172.683,
                        x2: 258.34,
                        y2: 172.683,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#6B47F7"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7F46FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("clipPath", {
                        id: "clip0_9679_23642",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                            x: 99,
                            y: 62,
                            width: 139.8,
                            height: 153,
                            rx: 10,
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("clipPath", {
                        id: "clip1_9679_23642",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(192 75)",
                            d: "M0 0h47v140H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("clipPath", {
                        id: "clip2_9679_23642",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(201 86)",
                            d: "M0 0h51v149H0z"
                        })
                    })
                ]
            })
        ]
    });
var $0807787c5f5c1b37$export$2e2bcd8739ae039 = $0807787c5f5c1b37$var$SvgOrganizationEmptyDark;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $ef008b0357de52f9$var$SvgOrganizationEmpty = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M183.392 208.572H74.295c-2.523.361-5.1.548-7.717.548a54.46 54.46 0 0 1-7.717-.548h-4.39v-.814C29.042 201.941 10 178.181 10 149.755c0-29.527 20.545-54.02 47.453-58.597C66.408 59.273 94.515 36 127.804 36c31.611 0 58.551 20.988 68.853 50.408 29.827 2.865 53.187 29.183 53.187 61.227 0 30.421-21.055 55.682-48.709 60.613v.324H199.1a56.417 56.417 0 0 1-7.854.548c-2.663 0-5.285-.187-7.854-.548Z",
                fill: "url(#paint0_linear_9679_23375)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M140.954 172.951C125.886 171.862 114 159.293 114 143.947c0-15.729 12.487-28.541 28.088-29.064C146.304 97.727 161.789 85 180.246 85c17.889 0 32.986 11.955 37.737 28.311 16.456.525 29.63 13.688 29.63 29.85 0 15.649-12.352 28.487-28.075 29.762v.202h-78.584v-.174Z",
                fill: "url(#paint1_linear_9679_23375)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M41.814 226.968c4.89-.693 7.251-17.031 7.423-37.533 1.31-1.024 2.688-2.307 4.1-3.719 4.629-4.629 6.705-10.058 5.155-11.608-1.307-1.307-5.373-.035-9.392 3.172-.557-17.391-2.763-30.274-7.613-30.274-6.534 0-7.76 17.905-7.76 39.992 0 2.757.039 5.449.116 8.049-1.841-2.114-3.575-3.272-4.89-3.272-3.582 0-1.806 9.763 1.858 19.326 2.541 6.634 5.503 12.107 8.213 14.403.607.795 1.268 1.286 1.984 1.437l-.025-9.277c-3.448-6.652-10.65-20.117-10.65-20.117l10.642 17.085-.021-7.437v-.008l-.05-17.788-.078.073v-2.208l.072-.064c-.038-13.916-.072-26.436-.072-27.962 0-2.379.44 6.332.733 27.416 4.154-3.285 12.106-7.058 12.106-7.058-5.705 3.651-10.324 7.617-12.078 9.184.13 10.066.224 22.754.227 38.188Z",
                fill: "url(#paint2_linear_9679_23375)",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M15.882 229h30.244c2.88 0 4.68-3.398 0-5.663-4.681-2.265-15.842-3.964-24.484-3.114-8.64.849-9 8.777-5.76 8.777Z",
                fill: "#C8BEE6"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M219.527 125.238c.007-.314.011-.63.011-.946 0-21.7-17.591-39.292-39.292-39.292-18.457 0-33.942 12.727-38.158 29.883-15.601.523-28.088 13.335-28.088 29.064 0 15.346 11.886 27.915 26.954 29.004v.174h78.584v-47.887h-.011Z",
                fill: "#D2CCDD"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M219.527 125.238c.007-.314.011-.63.011-.946 0-21.7-17.591-39.292-39.292-39.292-18.457 0-33.942 12.727-38.158 29.883-15.601.523-28.088 13.335-28.088 29.064 0 15.346 11.886 27.915 26.954 29.004v.174h78.584v-47.887h-.011Z",
                fill: "url(#paint3_linear_9679_23375)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M222.346 34.5a.125.125 0 0 1 .171-.044l1.946 1.135c.06.035.08.112.045.171l-1.998 3.425 3.965.018c.069 0 .125.056.125.126l-.011 2.252c0 .07-.056.125-.125.125l-3.966-.018 1.967 3.443a.124.124 0 0 1-.046.171l-1.956 1.118a.125.125 0 0 1-.171-.047l-1.967-3.442-1.998 3.424a.125.125 0 0 1-.171.046l-1.946-1.136a.125.125 0 0 1-.045-.171l1.998-3.425-3.966-.018a.125.125 0 0 1-.124-.126l.01-2.253c0-.07.057-.125.126-.124l3.965.017-1.967-3.442a.124.124 0 0 1 .046-.17l1.956-1.119a.125.125 0 0 1 .171.047l1.967 3.443 1.999-3.425Z",
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 6.421,
                height: 6.421,
                rx: 2,
                transform: "scale(-1 1) rotate(-40.65 56.962 74.91)",
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M44 142a8 8 0 0 1 8-8h128a8 8 0 0 1 8 8v85H44v-85Z",
                fill: "url(#paint4_linear_9679_23375)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M48 141a4 4 0 0 1 4-4h128a4 4 0 0 1 4 4v82H48v-82Z",
                fill: "url(#paint5_linear_9679_23375)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M19 223h193v2a4 4 0 0 1-4 4H24a5 5 0 0 1-5-5v-1Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M106 137h20v2a4 4 0 0 1-4 4h-12a4 4 0 0 1-4-4v-2Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 59,
                y: 153,
                width: 110,
                height: 56,
                rx: 5,
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M90.548 153h28.451v47a9 9 0 0 1-9 9h-33l13.549-56Z",
                fill: "url(#paint6_linear_9679_23375)",
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 90,
                y: 164,
                width: 68,
                height: 6,
                rx: 2,
                fill: "#FF91DF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 90,
                y: 176,
                width: 68,
                height: 6,
                rx: 2,
                fill: "#C29DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 90,
                y: 188,
                width: 68,
                height: 6,
                rx: 2,
                fill: "#C29DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 73.5,
                cy: 169.5,
                r: 7.5,
                fill: "#C39EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("mask", {
                id: "mask0_9679_23375",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 66,
                y: 162,
                width: 15,
                height: 15,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                    cx: 73.5,
                    cy: 169.5,
                    r: 7.5,
                    fill: "#FF91DF"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("g", {
                mask: "url(#mask0_9679_23375)",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                    d: "M73.434 164.5a.8.8 0 0 0-.782.63l-.092.425a.773.773 0 0 1-.475.535.769.769 0 0 1-.712-.044l-.363-.234a.8.8 0 0 0-.998.107l-.093.093a.8.8 0 0 0-.107.998l.234.363a.77.77 0 0 1 .044.712.774.774 0 0 1-.535.475l-.425.092a.8.8 0 0 0-.63.782v.132a.8.8 0 0 0 .63.782l.425.092c.246.053.439.242.535.475a.77.77 0 0 1-.044.712l-.234.363a.8.8 0 0 0 .107.998l.093.093a.8.8 0 0 0 .998.107l.364-.234a.769.769 0 0 1 .711-.044.773.773 0 0 1 .475.535l.092.425a.8.8 0 0 0 .782.63h.132a.8.8 0 0 0 .782-.63l.092-.425a.773.773 0 0 1 .475-.535.769.769 0 0 1 .712.044l.363.234a.8.8 0 0 0 .998-.107l.093-.093a.8.8 0 0 0 .107-.998l-.234-.363a.77.77 0 0 1-.044-.712.774.774 0 0 1 .535-.475l.425-.092a.8.8 0 0 0 .63-.782v-.132a.8.8 0 0 0-.63-.782l-.425-.092a.774.774 0 0 1-.535-.475.77.77 0 0 1 .044-.712l.234-.363a.8.8 0 0 0-.107-.998l-.093-.093a.8.8 0 0 0-.998-.107l-.364.234a.769.769 0 0 1-.711.044.773.773 0 0 1-.475-.535l-.092-.425a.8.8 0 0 0-.782-.63h-.132Zm.066 2.857a2.143 2.143 0 1 1 0 4.287 2.143 2.143 0 0 1 0-4.287Z",
                    fill: "#F5EEFF"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                clipPath: "url(#clip0_9679_23375)",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 99,
                        y: 62,
                        width: 139.8,
                        height: 153,
                        rx: 10,
                        fill: "#FFFBFF"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                        cx: 110.519,
                        cy: 77.949,
                        r: 2.658,
                        fill: "#FF5449"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                        cx: 121.152,
                        cy: 77.949,
                        r: 2.658,
                        fill: "#FFB95A"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                        cx: 131.785,
                        cy: 77.949,
                        r: 2.658,
                        fill: "#68BE6C"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 107.861,
                        y: 91.24,
                        width: 21.266,
                        height: 21.266,
                        rx: 4.43,
                        fill: "url(#paint7_linear_9679_23375)"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M117.361 97.469v2h2v-2h-2Zm-.5-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3Zm-2.5 7v2h2v-2h-2Zm-.5-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-1v-.5h5v.5h-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-1v-.5a1 1 0 0 0-1-1h-2v-.5h-1v.5h-2a1 1 0 0 0-1 1v.5h-1Zm6.5 3v-2h2v2h-2Z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 133.557,
                        y: 94.873,
                        width: 54,
                        height: 14,
                        rx: 3,
                        fill: "url(#paint8_linear_9679_23375)"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 107.861,
                        y: 118.506,
                        width: 21.266,
                        height: 21.266,
                        rx: 4.43,
                        fill: "url(#paint9_linear_9679_23375)"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M117.361 124.734v2h2v-2h-2Zm-.5-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3Zm-2.5 7v2h2v-2h-2Zm-.5-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-1v-.5h5v.5h-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-1v-.5a1 1 0 0 0-1-1h-2v-.499h-1v.499h-2a1 1 0 0 0-1 1v.5h-1Zm6.5 3v-2h2v2h-2Z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 133.557,
                        y: 122.139,
                        width: 54,
                        height: 14,
                        rx: 3,
                        fill: "url(#paint10_linear_9679_23375)"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 107.861,
                        y: 145.771,
                        width: 21.266,
                        height: 21.266,
                        rx: 4.43,
                        fill: "url(#paint11_linear_9679_23375)"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M117.361 152v2h2v-2h-2Zm-.5-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3Zm-2.5 7v2h2v-2h-2Zm-.5-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-1v-.5h5v.5h-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-1v-.5a1 1 0 0 0-1-1h-2v-.5h-1v.5h-2a1 1 0 0 0-1 1v.5h-1Zm6.5 3v-2h2v2h-2Z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 133.557,
                        y: 149.404,
                        width: 54,
                        height: 14,
                        rx: 3,
                        fill: "url(#paint12_linear_9679_23375)"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 107.861,
                        y: 173.038,
                        width: 21.266,
                        height: 21.266,
                        rx: 4.43,
                        fill: "#BDBDBD"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M122.629 183.081h-3.545v-3.544a.59.59 0 1 0-1.181 0v3.544h-3.544a.595.595 0 0 0-.591.591.59.59 0 0 0 .591.591h3.544v3.544a.59.59 0 1 0 1.181 0v-3.544h3.545a.588.588 0 0 0 .59-.591.59.59 0 0 0-.59-.591Z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 133.557,
                        y: 176.671,
                        width: 54,
                        height: 14,
                        rx: 3,
                        fill: "url(#paint13_linear_9679_23375)"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("g", {
                        clipPath: "url(#clip1_9679_23375)",
                        children: /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                            clipPath: "url(#clip2_9679_23375)",
                            children: [
                                /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                                    opacity: 0.2,
                                    x: 201,
                                    y: 86,
                                    width: 50.506,
                                    height: 13.291,
                                    rx: 2.658,
                                    fill: "url(#paint14_linear_9679_23375)"
                                }),
                                /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                                    opacity: 0.2,
                                    x: 201,
                                    y: 106.38,
                                    width: 50.506,
                                    height: 13.291,
                                    rx: 2.658,
                                    fill: "url(#paint15_linear_9679_23375)"
                                }),
                                /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                                    opacity: 0.2,
                                    x: 201,
                                    y: 126.76,
                                    width: 51,
                                    height: 92,
                                    rx: 2.658,
                                    fill: "url(#paint16_linear_9679_23375)"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 99.3,
                y: 62.3,
                width: 139.2,
                height: 152.4,
                rx: 9.7,
                stroke: "#C9C5D0",
                strokeWidth: 0.6
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 7.195,
                height: 7.186,
                rx: 1.8,
                transform: "rotate(30.748 -162.595 155.586) skewX(-.13)",
                fill: "#FFD5FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m252.791 71-1.195 2.564a2.828 2.828 0 0 1-3.758 1.37v0a2.828 2.828 0 0 0-3.758 1.37v0a2.828 2.828 0 0 1-3.758 1.37v0a2.828 2.828 0 0 0-3.758 1.37l-1.194 2.563",
                stroke: "#CABEFF",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m72.521 65.49-.36-2.514a2.544 2.544 0 0 0-2.88-2.154v0a2.544 2.544 0 0 1-2.88-2.154v0a2.544 2.544 0 0 0-2.881-2.154l-2.52.36",
                stroke: "#FFF06A",
                strokeWidth: 1.8,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_9679_23375",
                        x1: 129.922,
                        y1: 36,
                        x2: 129.922,
                        y2: 209.12,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#F3EFFA"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F3EFFA",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_9679_23375",
                        x1: 180.807,
                        y1: 85,
                        x2: 180.807,
                        y2: 232.5,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FEFDFF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAF7FF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint2_linear_9679_23375",
                        x1: 42.861,
                        y1: 228.869,
                        x2: 57.649,
                        y2: 145.844,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#C7BDE6"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E4DBFF",
                                stopOpacity: 0.16
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint3_linear_9679_23375",
                        x1: 166.769,
                        y1: 85,
                        x2: 166.769,
                        y2: 232.5,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FEFDFF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAF7FF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint4_linear_9679_23375",
                        x1: 112.556,
                        y1: 136.099,
                        x2: 143.327,
                        y2: 238.121,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint5_linear_9679_23375",
                        x1: 184,
                        y1: 223.001,
                        x2: -25,
                        y2: 90.001,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#BC97FD"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#BC97FD",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint6_linear_9679_23375",
                        x1: 120.59,
                        y1: 178.664,
                        x2: 80.951,
                        y2: 203.746,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#ECB6FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#BE9BFF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint7_linear_9679_23375",
                        x1: 109.423,
                        y1: 101.855,
                        x2: 131.77,
                        y2: 101.855,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#6B47F7"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7F46FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint8_linear_9679_23375",
                        x1: 134.307,
                        y1: 101.348,
                        x2: 187.557,
                        y2: 101.348,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#D2C4FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ECD5FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint9_linear_9679_23375",
                        x1: 109.423,
                        y1: 129.121,
                        x2: 131.77,
                        y2: 129.121,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#6B47F7"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7F46FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint10_linear_9679_23375",
                        x1: 134.307,
                        y1: 128.614,
                        x2: 187.557,
                        y2: 128.614,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#D2C4FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ECD5FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint11_linear_9679_23375",
                        x1: 109.423,
                        y1: 156.387,
                        x2: 131.77,
                        y2: 156.387,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#6B47F7"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7F46FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint12_linear_9679_23375",
                        x1: 134.307,
                        y1: 155.879,
                        x2: 187.557,
                        y2: 155.879,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#D2C4FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ECD5FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint13_linear_9679_23375",
                        x1: 134.307,
                        y1: 183.146,
                        x2: 187.557,
                        y2: 183.146,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#D2C4FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ECD5FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint14_linear_9679_23375",
                        x1: 194.797,
                        y1: 92.646,
                        x2: 209.282,
                        y2: 67.446,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#A278FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F3A8FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint15_linear_9679_23375",
                        x1: 194.797,
                        y1: 113.025,
                        x2: 209.282,
                        y2: 87.826,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#A278FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F3A8FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint16_linear_9679_23375",
                        x1: 194.737,
                        y1: 172.76,
                        x2: 250.069,
                        y2: 158.716,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#A278FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F3A8FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("clipPath", {
                        id: "clip0_9679_23375",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                            x: 99,
                            y: 62,
                            width: 139.8,
                            height: 153,
                            rx: 10,
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("clipPath", {
                        id: "clip1_9679_23375",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(192 75)",
                            d: "M0 0h47v140H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("clipPath", {
                        id: "clip2_9679_23375",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(201 86)",
                            d: "M0 0h51v149H0z"
                        })
                    })
                ]
            })
        ]
    });
var $ef008b0357de52f9$export$2e2bcd8739ae039 = $ef008b0357de52f9$var$SvgOrganizationEmpty;




var $5TsIB = parcelRequire("5TsIB");
parcelRequire("8Mb3E");
var $cfL6o = parcelRequire("cfL6o");
var $bt3dS = parcelRequire("bt3dS");

var $8TpMk = parcelRequire("8TpMk");



var $cDKfs = parcelRequire("cDKfs");

var $jGWQ4 = parcelRequire("jGWQ4");

var $gC7hG = parcelRequire("gC7hG");

var $18SWy = parcelRequire("18SWy");

var $66ixW = parcelRequire("66ixW");




var $4ZcUR = parcelRequire("4ZcUR");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");

var $5UrGx = parcelRequire("5UrGx");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $f85156023f85d837$var$SvgOrganizationFeatureDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.8 11.2v6.4h6.4v-6.4h-6.4ZM19.2 8a1.6 1.6 0 0 0-1.6 1.6v9.6a1.6 1.6 0 0 0 1.6 1.6h9.6a1.6 1.6 0 0 0 1.6-1.6V9.6A1.6 1.6 0 0 0 28.8 8h-9.6Zm-8 22.4v6.4h6.4v-6.4h-6.4Zm-1.6-3.2A1.6 1.6 0 0 0 8 28.8v9.6A1.6 1.6 0 0 0 9.6 40h9.6a1.6 1.6 0 0 0 1.6-1.6v-9.6a1.6 1.6 0 0 0-1.6-1.6H16v-1.6h16v1.6h-3.2a1.6 1.6 0 0 0-1.6 1.6v9.6a1.6 1.6 0 0 0 1.6 1.6h9.6a1.6 1.6 0 0 0 1.6-1.6v-9.6a1.6 1.6 0 0 0-1.6-1.6h-3.2v-1.6a3.2 3.2 0 0 0-3.2-3.2h-6.4v-1.6h-3.2v1.6H16a3.2 3.2 0 0 0-3.2 3.2v1.6H9.6Zm20.8 9.6v-6.4h6.4v6.4h-6.4Z",
                fill: "url(#paint0_linear_9450_17742)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 7,
                cy: 19,
                r: 1.5,
                stroke: "#78767F"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 36.879,
                y: 7,
                width: 3,
                height: 3,
                rx: 0.5,
                transform: "rotate(-45 36.879 7)",
                stroke: "#78767F"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 18.707,
                y: 44.828,
                width: 3,
                height: 3,
                rx: 0.5,
                transform: "rotate(-45 18.707 44.828)",
                stroke: "#78767F"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M20.8 11.2v6.4h6.4v-6.4h-6.4Z",
                fill: "#FAABFF",
                fillOpacity: 0.3
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                opacity: 0.6,
                d: "M11.2 30.4v6.4h6.4v-6.4h-6.4Z",
                fill: "#FAABFF",
                fillOpacity: 0.3
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M30.4 30.4v6.4h6.4v-6.4h-6.4Z",
                fill: "#FAABFF",
                fillOpacity: 0.3
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("defs", {
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                    id: "paint0_linear_9450_17742",
                    x1: 13.5,
                    y1: 35.666,
                    x2: 35,
                    y2: 12.666,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            stopColor: "#5D34F2"
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            offset: 1,
                            stopColor: "#FF88FA"
                        })
                    ]
                })
            })
        ]
    });
var $f85156023f85d837$export$2e2bcd8739ae039 = $f85156023f85d837$var$SvgOrganizationFeatureDark;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $72deab380bd1401f$var$SvgOrganizationFeature = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.8 11.2v6.4h6.4v-6.4h-6.4ZM19.2 8a1.6 1.6 0 0 0-1.6 1.6v9.6a1.6 1.6 0 0 0 1.6 1.6h9.6a1.6 1.6 0 0 0 1.6-1.6V9.6A1.6 1.6 0 0 0 28.8 8h-9.6Zm-8 22.4v6.4h6.4v-6.4h-6.4Zm-1.6-3.2A1.6 1.6 0 0 0 8 28.8v9.6A1.6 1.6 0 0 0 9.6 40h9.6a1.6 1.6 0 0 0 1.6-1.6v-9.6a1.6 1.6 0 0 0-1.6-1.6H16v-1.6h16v1.6h-3.2a1.6 1.6 0 0 0-1.6 1.6v9.6a1.6 1.6 0 0 0 1.6 1.6h9.6a1.6 1.6 0 0 0 1.6-1.6v-9.6a1.6 1.6 0 0 0-1.6-1.6h-3.2v-1.6a3.2 3.2 0 0 0-3.2-3.2h-6.4v-1.6h-3.2v1.6H16a3.2 3.2 0 0 0-3.2 3.2v1.6H9.6Zm20.8 9.6v-6.4h6.4v6.4h-6.4Z",
                fill: "url(#paint0_linear_9448_17722)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 7,
                cy: 19,
                r: 1.5,
                stroke: "#FFD5FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 36.879,
                y: 7,
                width: 3,
                height: 3,
                rx: 0.5,
                transform: "rotate(-45 36.879 7)",
                stroke: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 18.707,
                y: 44.828,
                width: 3,
                height: 3,
                rx: 0.5,
                transform: "rotate(-45 18.707 44.828)",
                stroke: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                opacity: 0.6,
                d: "M20.8 11.2v6.4h6.4v-6.4h-6.4ZM11.2 30.4v6.4h6.4v-6.4h-6.4ZM30.4 30.4v6.4h6.4v-6.4h-6.4Z",
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("defs", {
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                    id: "paint0_linear_9448_17722",
                    x1: 13.5,
                    y1: 35.666,
                    x2: 35,
                    y2: 12.666,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            stopColor: "#5D34F2"
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            offset: 1,
                            stopColor: "#FF88FA"
                        })
                    ]
                })
            })
        ]
    });
var $72deab380bd1401f$export$2e2bcd8739ae039 = $72deab380bd1401f$var$SvgOrganizationFeature;



var $gC7hG = parcelRequire("gC7hG");

var $aTllQ = parcelRequire("aTllQ");

var $jheqv = parcelRequire("jheqv");

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");
var $17572efa0c48fd08$exports = {};

$parcel$export($17572efa0c48fd08$exports, "column", function () { return $17572efa0c48fd08$export$4e0c71f277ca26b3; }, function (v) { return $17572efa0c48fd08$export$4e0c71f277ca26b3 = v; });
$parcel$export($17572efa0c48fd08$exports, "equallyDivided", function () { return $17572efa0c48fd08$export$53eab53cdc9a3971; }, function (v) { return $17572efa0c48fd08$export$53eab53cdc9a3971 = v; });
$parcel$export($17572efa0c48fd08$exports, "flexBox", function () { return $17572efa0c48fd08$export$6b39a1ef00710959; }, function (v) { return $17572efa0c48fd08$export$6b39a1ef00710959 = v; });
$parcel$export($17572efa0c48fd08$exports, "rotating", function () { return $17572efa0c48fd08$export$bfd64c937657f93a; }, function (v) { return $17572efa0c48fd08$export$bfd64c937657f93a = v; });
$parcel$export($17572efa0c48fd08$exports, "shimmer", function () { return $17572efa0c48fd08$export$4a6dd88bada4e7d2; }, function (v) { return $17572efa0c48fd08$export$4a6dd88bada4e7d2 = v; });
var $17572efa0c48fd08$export$4e0c71f277ca26b3;
var $17572efa0c48fd08$export$53eab53cdc9a3971;
var $17572efa0c48fd08$export$6b39a1ef00710959;
var $17572efa0c48fd08$export$bfd64c937657f93a;
var $17572efa0c48fd08$export$4a6dd88bada4e7d2;
$17572efa0c48fd08$export$4e0c71f277ca26b3 = `a8Z5Ca_column`;
$17572efa0c48fd08$export$53eab53cdc9a3971 = `a8Z5Ca_equallyDivided`;
$17572efa0c48fd08$export$6b39a1ef00710959 = `a8Z5Ca_flexBox`;
$17572efa0c48fd08$export$bfd64c937657f93a = `a8Z5Ca_rotating`;
$17572efa0c48fd08$export$4a6dd88bada4e7d2 = `a8Z5Ca_shimmer`;


function $f7bb46695f6c1445$var$FlexBox({ className: className, children: children, type: type = "row", gap: gap = 12, style: style, isEquallyDivided: isEquallyDivided, onMouseOver: onMouseOver, onMouseOut: onMouseOut }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($17572efa0c48fd08$exports.flexBox, $17572efa0c48fd08$exports[type], isEquallyDivided && $17572efa0c48fd08$exports.equallyDivided, className),
        style: {
            gap: `${gap}px`,
            ...style
        },
        onFocus: onMouseOver,
        onBlur: onMouseOut,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        children: children
    });
}
var $f7bb46695f6c1445$export$2e2bcd8739ae039 = $f7bb46695f6c1445$var$FlexBox;


/* eslint-disable complexity */ 
var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");


var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");
var $f3bcaa8ed5e8a663$exports = {};

$parcel$export($f3bcaa8ed5e8a663$exports, "blue", function () { return $f3bcaa8ed5e8a663$export$2aa0182783e7e9de; }, function (v) { return $f3bcaa8ed5e8a663$export$2aa0182783e7e9de = v; });
$parcel$export($f3bcaa8ed5e8a663$exports, "body", function () { return $f3bcaa8ed5e8a663$export$32180ef41b15b513; }, function (v) { return $f3bcaa8ed5e8a663$export$32180ef41b15b513 = v; });
$parcel$export($f3bcaa8ed5e8a663$exports, "header", function () { return $f3bcaa8ed5e8a663$export$38e42c68cf43b5d4; }, function (v) { return $f3bcaa8ed5e8a663$export$38e42c68cf43b5d4 = v; });
$parcel$export($f3bcaa8ed5e8a663$exports, "panel", function () { return $f3bcaa8ed5e8a663$export$21f42ab9b6679f44; }, function (v) { return $f3bcaa8ed5e8a663$export$21f42ab9b6679f44 = v; });
$parcel$export($f3bcaa8ed5e8a663$exports, "purple", function () { return $f3bcaa8ed5e8a663$export$e13cce2a2d16a9d4; }, function (v) { return $f3bcaa8ed5e8a663$export$e13cce2a2d16a9d4 = v; });
$parcel$export($f3bcaa8ed5e8a663$exports, "rotating", function () { return $f3bcaa8ed5e8a663$export$bfd64c937657f93a; }, function (v) { return $f3bcaa8ed5e8a663$export$bfd64c937657f93a = v; });
$parcel$export($f3bcaa8ed5e8a663$exports, "shimmer", function () { return $f3bcaa8ed5e8a663$export$4a6dd88bada4e7d2; }, function (v) { return $f3bcaa8ed5e8a663$export$4a6dd88bada4e7d2 = v; });
$parcel$export($f3bcaa8ed5e8a663$exports, "small", function () { return $f3bcaa8ed5e8a663$export$3c17b0e969a90510; }, function (v) { return $f3bcaa8ed5e8a663$export$3c17b0e969a90510 = v; });
var $f3bcaa8ed5e8a663$export$2aa0182783e7e9de;
var $f3bcaa8ed5e8a663$export$32180ef41b15b513;
var $f3bcaa8ed5e8a663$export$38e42c68cf43b5d4;
var $f3bcaa8ed5e8a663$export$21f42ab9b6679f44;
var $f3bcaa8ed5e8a663$export$e13cce2a2d16a9d4;
var $f3bcaa8ed5e8a663$export$bfd64c937657f93a;
var $f3bcaa8ed5e8a663$export$4a6dd88bada4e7d2;
var $f3bcaa8ed5e8a663$export$3c17b0e969a90510;
$f3bcaa8ed5e8a663$export$2aa0182783e7e9de = `-wf_va_blue`;
$f3bcaa8ed5e8a663$export$32180ef41b15b513 = `-wf_va_body`;
$f3bcaa8ed5e8a663$export$38e42c68cf43b5d4 = `-wf_va_header`;
$f3bcaa8ed5e8a663$export$21f42ab9b6679f44 = `-wf_va_panel`;
$f3bcaa8ed5e8a663$export$e13cce2a2d16a9d4 = `-wf_va_purple`;
$f3bcaa8ed5e8a663$export$bfd64c937657f93a = `-wf_va_rotating`;
$f3bcaa8ed5e8a663$export$4a6dd88bada4e7d2 = `-wf_va_shimmer`;
$f3bcaa8ed5e8a663$export$3c17b0e969a90510 = `-wf_va_small`;


function $5c4298baea104fc8$var$Panel({ className: className, label: label, variant: variant, size: size = "medium", children: children }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($f3bcaa8ed5e8a663$exports.panel, variant && $f3bcaa8ed5e8a663$exports[variant], $f3bcaa8ed5e8a663$exports[size], className),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $f3bcaa8ed5e8a663$exports.header,
                children: label
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $f3bcaa8ed5e8a663$exports.body,
                children: children
            })
        ]
    });
}
var $5c4298baea104fc8$export$2e2bcd8739ae039 = $5c4298baea104fc8$var$Panel;



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $16GE9 = parcelRequire("16GE9");


var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");
var $dab108451b7dcae9$export$d8cfd17610b730e0;
var $dab108451b7dcae9$export$ff398d236afe1183;
var $dab108451b7dcae9$export$bfd64c937657f93a;
var $dab108451b7dcae9$export$4a6dd88bada4e7d2;
$dab108451b7dcae9$export$d8cfd17610b730e0 = `_8B3_QW_monoSpace`;
$dab108451b7dcae9$export$ff398d236afe1183 = `_8B3_QW_permission`;
$dab108451b7dcae9$export$bfd64c937657f93a = `_8B3_QW_rotating`;
$dab108451b7dcae9$export$4a6dd88bada4e7d2 = `_8B3_QW_shimmer`;


function $e0901aab2859ca5e$var$Permission({ className: className, name: name, isMonospace: isMonospace = true }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($dab108451b7dcae9$export$ff398d236afe1183, isMonospace && $dab108451b7dcae9$export$d8cfd17610b730e0, className),
        children: name
    });
}
var $e0901aab2859ca5e$export$2e2bcd8739ae039 = $e0901aab2859ca5e$var$Permission;


var $e02d49f92faf31b0$exports = {};

$parcel$export($e02d49f92faf31b0$exports, "active", function () { return $e02d49f92faf31b0$export$89da14300d534261; }, function (v) { return $e02d49f92faf31b0$export$89da14300d534261 = v; });
$parcel$export($e02d49f92faf31b0$exports, "interactive", function () { return $e02d49f92faf31b0$export$dbd07fce1f97166e; }, function (v) { return $e02d49f92faf31b0$export$dbd07fce1f97166e = v; });
$parcel$export($e02d49f92faf31b0$exports, "label", function () { return $e02d49f92faf31b0$export$1237798dc640739a; }, function (v) { return $e02d49f92faf31b0$export$1237798dc640739a = v; });
$parcel$export($e02d49f92faf31b0$exports, "permissions", function () { return $e02d49f92faf31b0$export$430c45605c9594b5; }, function (v) { return $e02d49f92faf31b0$export$430c45605c9594b5 = v; });
$parcel$export($e02d49f92faf31b0$exports, "role", function () { return $e02d49f92faf31b0$export$3100efae45e879; }, function (v) { return $e02d49f92faf31b0$export$3100efae45e879 = v; });
$parcel$export($e02d49f92faf31b0$exports, "rotating", function () { return $e02d49f92faf31b0$export$bfd64c937657f93a; }, function (v) { return $e02d49f92faf31b0$export$bfd64c937657f93a = v; });
$parcel$export($e02d49f92faf31b0$exports, "shimmer", function () { return $e02d49f92faf31b0$export$4a6dd88bada4e7d2; }, function (v) { return $e02d49f92faf31b0$export$4a6dd88bada4e7d2 = v; });
$parcel$export($e02d49f92faf31b0$exports, "small", function () { return $e02d49f92faf31b0$export$3c17b0e969a90510; }, function (v) { return $e02d49f92faf31b0$export$3c17b0e969a90510 = v; });
var $e02d49f92faf31b0$export$89da14300d534261;
var $e02d49f92faf31b0$export$dbd07fce1f97166e;
var $e02d49f92faf31b0$export$1237798dc640739a;
var $e02d49f92faf31b0$export$430c45605c9594b5;
var $e02d49f92faf31b0$export$3100efae45e879;
var $e02d49f92faf31b0$export$bfd64c937657f93a;
var $e02d49f92faf31b0$export$4a6dd88bada4e7d2;
var $e02d49f92faf31b0$export$3c17b0e969a90510;
$e02d49f92faf31b0$export$89da14300d534261 = `_yZ3DG_active`;
$e02d49f92faf31b0$export$dbd07fce1f97166e = `_yZ3DG_interactive`;
$e02d49f92faf31b0$export$1237798dc640739a = `_yZ3DG_label`;
$e02d49f92faf31b0$export$430c45605c9594b5 = `_yZ3DG_permissions`;
$e02d49f92faf31b0$export$3100efae45e879 = `_yZ3DG_role`;
$e02d49f92faf31b0$export$bfd64c937657f93a = `_yZ3DG_rotating`;
$e02d49f92faf31b0$export$4a6dd88bada4e7d2 = `_yZ3DG_shimmer`;
$e02d49f92faf31b0$export$3c17b0e969a90510 = `_yZ3DG_small`;


function $e101e5d5cd6b9ae1$var$Role({ className: className, label: label, permissions: permissions, tooltip: tooltip, size: size = "default", isActive: isActive = true, onMouseOver: onMouseOver, onMouseOut: onMouseOut }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $16GE9.default), {
        content: tooltip,
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $f7bb46695f6c1445$export$2e2bcd8739ae039), {
            type: "column",
            gap: 10,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($e02d49f92faf31b0$exports.role, $e02d49f92faf31b0$exports[size], isActive && $e02d49f92faf31b0$exports.active, tooltip && $e02d49f92faf31b0$exports.interactive, className),
            onMouseOver: onMouseOver,
            onMouseOut: onMouseOut,
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $e02d49f92faf31b0$exports.label,
                    children: label
                }),
                !!permissions?.length && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f7bb46695f6c1445$export$2e2bcd8739ae039), {
                    type: "column",
                    gap: 10,
                    className: $e02d49f92faf31b0$exports.permissions,
                    children: permissions.map((permission)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $e0901aab2859ca5e$export$2e2bcd8739ae039), {
                            name: permission
                        }, permission))
                })
            ]
        })
    });
}
var $e101e5d5cd6b9ae1$export$2e2bcd8739ae039 = $e101e5d5cd6b9ae1$var$Role;



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $cc270c6b8f968e53$var$SvgUser = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 26,
        height: 28,
        viewBox: "0 0 26 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            id: "Union",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13 0a5.478 5.478 0 0 0-5.478 5.478v1.218a5.478 5.478 0 0 0 10.956 0V5.478A5.478 5.478 0 0 0 13 0Zm0 28c12.174 0 12.174-3.957 12.174-3.957 0-5.133-2.548-9.918-9.13-10.043-.029 0-.219.184-.494.452-.723.704-2.036 1.98-2.55 1.98-.514 0-1.827-1.276-2.55-1.98-.275-.268-.466-.453-.494-.452-6.582.125-9.13 4.91-9.13 10.043 0 0 0 3.957 12.174 3.957Z",
            fill: "currentColor"
        })
    });
var $cc270c6b8f968e53$export$2e2bcd8739ae039 = $cc270c6b8f968e53$var$SvgUser;



var $16GE9 = parcelRequire("16GE9");
var $ce45392cbfe729a6$exports = {};

$parcel$export($ce45392cbfe729a6$exports, "active", function () { return $ce45392cbfe729a6$export$89da14300d534261; }, function (v) { return $ce45392cbfe729a6$export$89da14300d534261 = v; });
$parcel$export($ce45392cbfe729a6$exports, "avatar", function () { return $ce45392cbfe729a6$export$345c5736c8054f22; }, function (v) { return $ce45392cbfe729a6$export$345c5736c8054f22 = v; });
$parcel$export($ce45392cbfe729a6$exports, "blue", function () { return $ce45392cbfe729a6$export$2aa0182783e7e9de; }, function (v) { return $ce45392cbfe729a6$export$2aa0182783e7e9de = v; });
$parcel$export($ce45392cbfe729a6$exports, "interactive", function () { return $ce45392cbfe729a6$export$dbd07fce1f97166e; }, function (v) { return $ce45392cbfe729a6$export$dbd07fce1f97166e = v; });
$parcel$export($ce45392cbfe729a6$exports, "name", function () { return $ce45392cbfe729a6$export$a8ff84c12d48cfa6; }, function (v) { return $ce45392cbfe729a6$export$a8ff84c12d48cfa6 = v; });
$parcel$export($ce45392cbfe729a6$exports, "pink", function () { return $ce45392cbfe729a6$export$47853bc718611763; }, function (v) { return $ce45392cbfe729a6$export$47853bc718611763 = v; });
$parcel$export($ce45392cbfe729a6$exports, "rotating", function () { return $ce45392cbfe729a6$export$bfd64c937657f93a; }, function (v) { return $ce45392cbfe729a6$export$bfd64c937657f93a = v; });
$parcel$export($ce45392cbfe729a6$exports, "shimmer", function () { return $ce45392cbfe729a6$export$4a6dd88bada4e7d2; }, function (v) { return $ce45392cbfe729a6$export$4a6dd88bada4e7d2 = v; });
$parcel$export($ce45392cbfe729a6$exports, "small", function () { return $ce45392cbfe729a6$export$3c17b0e969a90510; }, function (v) { return $ce45392cbfe729a6$export$3c17b0e969a90510 = v; });
$parcel$export($ce45392cbfe729a6$exports, "user", function () { return $ce45392cbfe729a6$export$ddb906a32562356c; }, function (v) { return $ce45392cbfe729a6$export$ddb906a32562356c = v; });
var $ce45392cbfe729a6$export$89da14300d534261;
var $ce45392cbfe729a6$export$345c5736c8054f22;
var $ce45392cbfe729a6$export$2aa0182783e7e9de;
var $ce45392cbfe729a6$export$dbd07fce1f97166e;
var $ce45392cbfe729a6$export$a8ff84c12d48cfa6;
var $ce45392cbfe729a6$export$47853bc718611763;
var $ce45392cbfe729a6$export$bfd64c937657f93a;
var $ce45392cbfe729a6$export$4a6dd88bada4e7d2;
var $ce45392cbfe729a6$export$3c17b0e969a90510;
var $ce45392cbfe729a6$export$ddb906a32562356c;
$ce45392cbfe729a6$export$89da14300d534261 = `csnI6G_active`;
$ce45392cbfe729a6$export$345c5736c8054f22 = `csnI6G_avatar`;
$ce45392cbfe729a6$export$2aa0182783e7e9de = `csnI6G_blue`;
$ce45392cbfe729a6$export$dbd07fce1f97166e = `csnI6G_interactive`;
$ce45392cbfe729a6$export$a8ff84c12d48cfa6 = `csnI6G_name`;
$ce45392cbfe729a6$export$47853bc718611763 = `csnI6G_pink`;
$ce45392cbfe729a6$export$bfd64c937657f93a = `csnI6G_rotating`;
$ce45392cbfe729a6$export$4a6dd88bada4e7d2 = `csnI6G_shimmer`;
$ce45392cbfe729a6$export$3c17b0e969a90510 = `csnI6G_small`;
$ce45392cbfe729a6$export$ddb906a32562356c = `csnI6G_user`;


function $98e48af11ee1665c$var$User({ className: className, name: name, hasIcon: hasIcon = true, variant: variant, size: size, tooltip: tooltip, isActive: isActive = true, onMouseOver: onMouseOver, onMouseOut: onMouseOut }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $16GE9.default), {
        content: tooltip,
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($ce45392cbfe729a6$exports.user, variant && $ce45392cbfe729a6$exports[variant], size && $ce45392cbfe729a6$exports[size], isActive && $ce45392cbfe729a6$exports.active, tooltip && $ce45392cbfe729a6$exports.interactive, className),
            onFocus: onMouseOver,
            onBlur: onMouseOut,
            onMouseOver: onMouseOver,
            onMouseOut: onMouseOut,
            children: [
                hasIcon && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cc270c6b8f968e53$export$2e2bcd8739ae039), {
                    className: $ce45392cbfe729a6$exports.avatar
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $ce45392cbfe729a6$exports.name,
                    children: name
                })
            ]
        })
    });
}
var $98e48af11ee1665c$export$2e2bcd8739ae039 = $98e48af11ee1665c$var$User;



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");
var $8946b074e8f523d7$export$89da14300d534261;
var $8946b074e8f523d7$export$6f093cfa640b7166;
var $8946b074e8f523d7$export$aa6223da92b253dd;
var $8946b074e8f523d7$export$6074e20ba5c64bef;
$8946b074e8f523d7$export$89da14300d534261 = `ktj7pG_active`;
$8946b074e8f523d7$export$6f093cfa640b7166 = `ktj7pG_text`;
$8946b074e8f523d7$export$aa6223da92b253dd = `ktj7pG_textWrapper`;
$8946b074e8f523d7$export$6074e20ba5c64bef = `ktj7pG_vector`;


function $5dca62c1c296bda6$var$John({ isActive: isActive = true }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($8946b074e8f523d7$export$6074e20ba5c64bef, isActive && $8946b074e8f523d7$export$89da14300d534261),
        width: "190",
        height: "200",
        viewBox: "0 0 190 200",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            transform: "translateY(90px)"
        },
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M186.704 11.589L183.121 9.50968L183.114 13.6504L186.704 11.589ZM0.233412 11.4807L183.476 11.9395L183.477 11.2223L0.234605 10.7635L0.233412 11.4807Z",
                fill: "#8E9192"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                className: $8946b074e8f523d7$export$aa6223da92b253dd,
                width: "107",
                height: "24",
                transform: "translate(41.8317 0.121582)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("text", {
                className: $8946b074e8f523d7$export$6f093cfa640b7166,
                x: "48",
                y: "15",
                children: "john@email.com"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M185.27 186.451L181.684 188.521V184.381L185.27 186.451ZM21.3918 11.4565V177.845H20.6746V11.4565H21.3918ZM29.6395 186.092H182.042V186.809H29.6395V186.092ZM21.3918 177.845C21.3918 182.4 25.0844 186.092 29.6395 186.092V186.809C24.6883 186.809 20.6746 182.796 20.6746 177.845H21.3918Z",
                fill: "#8E9192"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                className: $8946b074e8f523d7$export$aa6223da92b253dd,
                width: "107",
                height: "24",
                transform: "translate(41.8317 175.693)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("text", {
                className: $8946b074e8f523d7$export$6f093cfa640b7166,
                x: "48",
                y: "190",
                children: "john@email.com"
            })
        ]
    });
}
var $5dca62c1c296bda6$export$2e2bcd8739ae039 = $5dca62c1c296bda6$var$John;



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

function $f443651e44fa70e7$var$Sarah({ isActive: isActive }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($8946b074e8f523d7$export$6074e20ba5c64bef, isActive && $8946b074e8f523d7$export$89da14300d534261),
        width: "187",
        height: "25",
        viewBox: "0 0 187 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M186.704 10.8857L183.118 8.81539V12.9561L186.704 10.8857ZM0.234619 11.2443L183.477 11.2443V10.5271L0.234619 10.5271L0.234619 11.2443Z",
                fill: "#8E9192"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                className: $8946b074e8f523d7$export$aa6223da92b253dd,
                width: "108",
                height: "24",
                transform: "translate(41.8317 0.326172)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("text", {
                className: $8946b074e8f523d7$export$6f093cfa640b7166,
                x: "47",
                y: "14",
                children: "sarah@email.com"
            })
        ]
    });
}
var $f443651e44fa70e7$export$2e2bcd8739ae039 = $f443651e44fa70e7$var$Sarah;


var $1b32e8102b91ee55$export$6d59db4903f20f7d;
var $1b32e8102b91ee55$export$21f42ab9b6679f44;
var $1b32e8102b91ee55$export$bfd64c937657f93a;
var $1b32e8102b91ee55$export$1a952fe22cdce89e;
var $1b32e8102b91ee55$export$4a6dd88bada4e7d2;
$1b32e8102b91ee55$export$6d59db4903f20f7d = `zdxmxq_description`;
$1b32e8102b91ee55$export$21f42ab9b6679f44 = `zdxmxq_panel`;
$1b32e8102b91ee55$export$bfd64c937657f93a = `zdxmxq_rotating`;
$1b32e8102b91ee55$export$1a952fe22cdce89e = `zdxmxq_sectionTitle`;
$1b32e8102b91ee55$export$4a6dd88bada4e7d2 = `zdxmxq_shimmer`;


function $4c13b94c3c6590a0$var$InteractiveDiagram() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.organizations"
    });
    const [activePerson, setActivePerson] = (0, $jC8Vy.useState)();
    const [activeRole, setActiveRole] = (0, $jC8Vy.useState)();
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $f7bb46695f6c1445$export$2e2bcd8739ae039), {
        type: "column",
        gap: 32,
        style: {
            padding: "12px 0"
        },
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $f7bb46695f6c1445$export$2e2bcd8739ae039), {
                style: {
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $98e48af11ee1665c$export$2e2bcd8739ae039), {
                        variant: "blue",
                        name: "John",
                        tooltip: t("guide.john_tip"),
                        isActive: activePerson !== "Sarah" && !activeRole,
                        onMouseOver: ()=>{
                            setActivePerson("John");
                        },
                        onMouseOut: ()=>{
                            setActivePerson(undefined);
                        }
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5dca62c1c296bda6$export$2e2bcd8739ae039), {
                        isActive: activePerson !== "Sarah" && !activeRole
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $5c4298baea104fc8$export$2e2bcd8739ae039), {
                        className: $1b32e8102b91ee55$export$21f42ab9b6679f44,
                        label: `${t("organization")} A`,
                        size: "small",
                        variant: "blue",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $f7bb46695f6c1445$export$2e2bcd8739ae039), {
                                isEquallyDivided: true,
                                gap: 10,
                                style: {
                                    marginBottom: "8px"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e101e5d5cd6b9ae1$export$2e2bcd8739ae039), {
                                        size: "small",
                                        label: `${t("role")}: Admin`,
                                        tooltip: t("guide.role_description", {
                                            role: "Admin"
                                        }),
                                        isActive: (activeRole === "Admin" || !activeRole) && activePerson !== "Sarah",
                                        onMouseOver: ()=>{
                                            setActiveRole("Admin");
                                        },
                                        onMouseOut: ()=>{
                                            setActiveRole(undefined);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e101e5d5cd6b9ae1$export$2e2bcd8739ae039), {
                                        size: "small",
                                        label: `${t("role")}: Member`,
                                        tooltip: t("guide.role_description", {
                                            role: "Member"
                                        }),
                                        isActive: (activeRole === "Member" || !activeRole) && !activePerson,
                                        onMouseOver: ()=>{
                                            setActiveRole("Member");
                                        },
                                        onMouseOut: ()=>{
                                            setActiveRole(undefined);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e101e5d5cd6b9ae1$export$2e2bcd8739ae039), {
                                        size: "small",
                                        label: `${t("role")}: Guest`,
                                        tooltip: t("guide.role_description", {
                                            role: "Guest"
                                        }),
                                        isActive: (activeRole === "Guest" || !activeRole) && !activePerson,
                                        onMouseOver: ()=>{
                                            setActiveRole("Guest");
                                        },
                                        onMouseOut: ()=>{
                                            setActiveRole(undefined);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e101e5d5cd6b9ae1$export$2e2bcd8739ae039), {
                                        size: "small",
                                        label: "...",
                                        isActive: !activeRole && !activePerson
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $98e48af11ee1665c$export$2e2bcd8739ae039), {
                                size: "small",
                                variant: "blue",
                                name: "John",
                                tooltip: t("guide.john_tip"),
                                isActive: activePerson !== "Sarah" && !activeRole,
                                onMouseOver: ()=>{
                                    setActivePerson("John");
                                },
                                onMouseOut: ()=>{
                                    setActivePerson(undefined);
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $f7bb46695f6c1445$export$2e2bcd8739ae039), {
                style: {
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $98e48af11ee1665c$export$2e2bcd8739ae039), {
                        variant: "pink",
                        name: "Sarah",
                        tooltip: t("guide.sarah_tip"),
                        isActive: activePerson !== "John" && !activeRole,
                        onMouseOver: ()=>{
                            setActivePerson("Sarah");
                        },
                        onMouseOut: ()=>{
                            setActivePerson(undefined);
                        }
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f443651e44fa70e7$export$2e2bcd8739ae039), {
                        isActive: activePerson !== "John" && !activeRole
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $5c4298baea104fc8$export$2e2bcd8739ae039), {
                        className: $1b32e8102b91ee55$export$21f42ab9b6679f44,
                        label: `${t("organization")} B`,
                        size: "small",
                        variant: "purple",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $f7bb46695f6c1445$export$2e2bcd8739ae039), {
                                isEquallyDivided: true,
                                gap: 10,
                                style: {
                                    marginBottom: "8px"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e101e5d5cd6b9ae1$export$2e2bcd8739ae039), {
                                        size: "small",
                                        label: `${t("role")}: Admin`,
                                        tooltip: t("guide.role_description", {
                                            role: "Admin"
                                        }),
                                        isActive: (activeRole === "Admin" || !activeRole) && activePerson !== "John",
                                        onMouseOver: ()=>{
                                            setActiveRole("Admin");
                                        },
                                        onMouseOut: ()=>{
                                            setActiveRole(undefined);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e101e5d5cd6b9ae1$export$2e2bcd8739ae039), {
                                        size: "small",
                                        label: `${t("role")}: Member`,
                                        tooltip: t("guide.role_description", {
                                            role: "Member"
                                        }),
                                        isActive: (activeRole === "Member" || !activeRole) && !activePerson,
                                        onMouseOver: ()=>{
                                            setActiveRole("Member");
                                        },
                                        onMouseOut: ()=>{
                                            setActiveRole(undefined);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e101e5d5cd6b9ae1$export$2e2bcd8739ae039), {
                                        size: "small",
                                        label: `${t("role")}: Guest`,
                                        tooltip: t("guide.role_description", {
                                            role: "Guest"
                                        }),
                                        isActive: (activeRole === "Guest" || !activeRole) && activePerson !== "Sarah",
                                        onMouseOver: ()=>{
                                            setActiveRole("Guest");
                                        },
                                        onMouseOut: ()=>{
                                            setActiveRole(undefined);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e101e5d5cd6b9ae1$export$2e2bcd8739ae039), {
                                        size: "small",
                                        label: "...",
                                        isActive: !activeRole && !activePerson
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $f7bb46695f6c1445$export$2e2bcd8739ae039), {
                                isEquallyDivided: true,
                                gap: 10,
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $98e48af11ee1665c$export$2e2bcd8739ae039), {
                                            variant: "pink",
                                            name: "Sarah",
                                            size: "small",
                                            tooltip: t("guide.sarah_tip"),
                                            isActive: activePerson !== "John" && !activeRole,
                                            onMouseOver: ()=>{
                                                setActivePerson("Sarah");
                                            },
                                            onMouseOut: ()=>{
                                                setActivePerson(undefined);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $98e48af11ee1665c$export$2e2bcd8739ae039), {
                                            variant: "blue",
                                            name: "John",
                                            size: "small",
                                            tooltip: t("guide.john_tip"),
                                            isActive: activePerson !== "Sarah" && !activeRole,
                                            onMouseOver: ()=>{
                                                setActivePerson("John");
                                            },
                                            onMouseOut: ()=>{
                                                setActivePerson(undefined);
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $4c13b94c3c6590a0$export$2e2bcd8739ae039 /* eslint-enable complexity */  = $4c13b94c3c6590a0$var$InteractiveDiagram;






var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $87331361ac03abe8$export$6d59db4903f20f7d;
var $87331361ac03abe8$export$bfd64c937657f93a;
var $87331361ac03abe8$export$fe2e36411d703b3d;
var $87331361ac03abe8$export$4a6dd88bada4e7d2;
var $87331361ac03abe8$export$fb184b623420d9be;
$87331361ac03abe8$export$6d59db4903f20f7d = `QAqorW_description`;
$87331361ac03abe8$export$bfd64c937657f93a = `QAqorW_rotating`;
$87331361ac03abe8$export$fe2e36411d703b3d = `QAqorW_section`;
$87331361ac03abe8$export$4a6dd88bada4e7d2 = `QAqorW_shimmer`;
$87331361ac03abe8$export$fb184b623420d9be = `QAqorW_title`;


function $6e4590464060e450$var$Section({ className: className, title: title, description: description, children: children }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $f7bb46695f6c1445$export$2e2bcd8739ae039), {
        type: "column",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($87331361ac03abe8$export$fe2e36411d703b3d, className),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $87331361ac03abe8$export$fb184b623420d9be,
                children: title
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $87331361ac03abe8$export$6d59db4903f20f7d,
                children: description
            }),
            children
        ]
    });
}
var $6e4590464060e450$export$2e2bcd8739ae039 = $6e4590464060e450$var$Section;



var $ab3eb09f0caddb3a$export$aa3e815946b80764;
var $ab3eb09f0caddb3a$export$8e16b83750b44988;
var $ab3eb09f0caddb3a$export$a7db06668cad9adb;
var $ab3eb09f0caddb3a$export$6d59db4903f20f7d;
var $ab3eb09f0caddb3a$export$42f9fc1286aa9efd;
var $ab3eb09f0caddb3a$export$1ca1ec8b29a4ce27;
var $ab3eb09f0caddb3a$export$5c452ff88e35e47d;
var $ab3eb09f0caddb3a$export$21f42ab9b6679f44;
var $ab3eb09f0caddb3a$export$bfd64c937657f93a;
var $ab3eb09f0caddb3a$export$fe2e36411d703b3d;
var $ab3eb09f0caddb3a$export$1a952fe22cdce89e;
var $ab3eb09f0caddb3a$export$4a6dd88bada4e7d2;
var $ab3eb09f0caddb3a$export$543dc55cf524ac77;
var $ab3eb09f0caddb3a$export$c96745152eb2740f;
var $ab3eb09f0caddb3a$export$fb184b623420d9be;
$ab3eb09f0caddb3a$export$aa3e815946b80764 = `CvHr5q_card`;
$ab3eb09f0caddb3a$export$8e16b83750b44988 = `CvHr5q_compact`;
$ab3eb09f0caddb3a$export$a7db06668cad9adb = `CvHr5q_content`;
$ab3eb09f0caddb3a$export$6d59db4903f20f7d = `CvHr5q_description`;
$ab3eb09f0caddb3a$export$42f9fc1286aa9efd = `CvHr5q_fieldGroup`;
$ab3eb09f0caddb3a$export$1ca1ec8b29a4ce27 = `CvHr5q_icon`;
$ab3eb09f0caddb3a$export$5c452ff88e35e47d = `CvHr5q_image`;
$ab3eb09f0caddb3a$export$21f42ab9b6679f44 = `CvHr5q_panel`;
$ab3eb09f0caddb3a$export$bfd64c937657f93a = `CvHr5q_rotating`;
$ab3eb09f0caddb3a$export$fe2e36411d703b3d = `CvHr5q_section`;
$ab3eb09f0caddb3a$export$1a952fe22cdce89e = `CvHr5q_sectionTitle`;
$ab3eb09f0caddb3a$export$4a6dd88bada4e7d2 = `CvHr5q_shimmer`;
$ab3eb09f0caddb3a$export$543dc55cf524ac77 = `CvHr5q_stepContainer`;
$ab3eb09f0caddb3a$export$c96745152eb2740f = `CvHr5q_subtitle`;
$ab3eb09f0caddb3a$export$fb184b623420d9be = `CvHr5q_title`;


const $78901c2ca8895a3d$var$icons = {
    [(0, $5HVJe.Theme).Light]: {
        OrganizationIcon: (0, $72deab380bd1401f$export$2e2bcd8739ae039)
    },
    [(0, $5HVJe.Theme).Dark]: {
        OrganizationIcon: (0, $f85156023f85d837$export$2e2bcd8739ae039)
    }
};
function $78901c2ca8895a3d$var$Introduction() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.organizations"
    });
    const theme = (0, $jheqv.default)();
    const { OrganizationIcon: OrganizationIcon } = $78901c2ca8895a3d$var$icons[theme];
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aTllQ.default), {
        className: $ab3eb09f0caddb3a$export$543dc55cf524ac77,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($ab3eb09f0caddb3a$export$a7db06668cad9adb),
            children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($ab3eb09f0caddb3a$export$aa3e815946b80764),
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)(OrganizationIcon, {
                        className: $ab3eb09f0caddb3a$export$1ca1ec8b29a4ce27
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $f7bb46695f6c1445$export$2e2bcd8739ae039), {
                        type: "column",
                        gap: 24,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $ab3eb09f0caddb3a$export$fb184b623420d9be,
                                children: t("guide.introduction.title")
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $f7bb46695f6c1445$export$2e2bcd8739ae039), {
                                type: "column",
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $ab3eb09f0caddb3a$export$1a952fe22cdce89e,
                                        children: t("guide.introduction.section_1.title")
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6e4590464060e450$export$2e2bcd8739ae039), {
                                        title: t("organization_and_member"),
                                        description: t("organization_and_member_description"),
                                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5c4298baea104fc8$export$2e2bcd8739ae039), {
                                            label: t("organization"),
                                            children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $f7bb46695f6c1445$export$2e2bcd8739ae039), {
                                                gap: 20,
                                                style: {
                                                    justifyContent: "center"
                                                },
                                                children: [
                                                    Array.from({
                                                        length: 5
                                                    }).map((_, index)=>// eslint-disable-next-line react/no-array-index-key
                                                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $98e48af11ee1665c$export$2e2bcd8739ae039), {
                                                            name: t("guide.member")
                                                        }, index)),
                                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $98e48af11ee1665c$export$2e2bcd8739ae039), {
                                                        hasIcon: false,
                                                        name: "......"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $f7bb46695f6c1445$export$2e2bcd8739ae039), {
                                type: "column",
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $ab3eb09f0caddb3a$export$1a952fe22cdce89e,
                                        children: t("guide.introduction.section_2.title")
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $ab3eb09f0caddb3a$export$6d59db4903f20f7d,
                                        children: t("guide.introduction.section_2.description")
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6e4590464060e450$export$2e2bcd8739ae039), {
                                        title: t("guide.organization_permissions"),
                                        description: t("guide.introduction.section_2.permission_description"),
                                        children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $f7bb46695f6c1445$export$2e2bcd8739ae039), {
                                            isEquallyDivided: true,
                                            gap: 20,
                                            style: {
                                                padding: "12px 0",
                                                justifyContent: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e0901aab2859ca5e$export$2e2bcd8739ae039), {
                                                    name: "read:resource"
                                                }),
                                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e0901aab2859ca5e$export$2e2bcd8739ae039), {
                                                    name: "edit:resource"
                                                }),
                                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e0901aab2859ca5e$export$2e2bcd8739ae039), {
                                                    name: "delete:resource"
                                                }),
                                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e0901aab2859ca5e$export$2e2bcd8739ae039), {
                                                    name: "......",
                                                    isMonospace: false
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6e4590464060e450$export$2e2bcd8739ae039), {
                                        title: t("guide.organization_roles"),
                                        description: t("guide.introduction.section_2.role_description"),
                                        children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $f7bb46695f6c1445$export$2e2bcd8739ae039), {
                                            isEquallyDivided: true,
                                            gap: 20,
                                            children: [
                                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e101e5d5cd6b9ae1$export$2e2bcd8739ae039), {
                                                    label: t("guide.admin"),
                                                    permissions: [
                                                        "read:resource",
                                                        "edit:resource",
                                                        "delete:resource"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e101e5d5cd6b9ae1$export$2e2bcd8739ae039), {
                                                    label: t("guide.member"),
                                                    permissions: [
                                                        "read:resource",
                                                        "edit:resource"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e101e5d5cd6b9ae1$export$2e2bcd8739ae039), {
                                                    label: t("guide.guest"),
                                                    permissions: [
                                                        "read:resource"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e101e5d5cd6b9ae1$export$2e2bcd8739ae039), {
                                                    label: "......"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $f7bb46695f6c1445$export$2e2bcd8739ae039), {
                                type: "column",
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $ab3eb09f0caddb3a$export$1a952fe22cdce89e,
                                        children: t("guide.introduction.section_3.title")
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $ab3eb09f0caddb3a$export$6d59db4903f20f7d,
                                        children: t("guide.introduction.section_3.description")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $f7bb46695f6c1445$export$2e2bcd8739ae039), {
                                type: "column",
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $ab3eb09f0caddb3a$export$1a952fe22cdce89e,
                                        children: t("guide.introduction.section_4.title")
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $ab3eb09f0caddb3a$export$6d59db4903f20f7d,
                                        children: t("guide.introduction.section_4.description")
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4c13b94c3c6590a0$export$2e2bcd8739ae039), {})
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
var $78901c2ca8895a3d$export$2e2bcd8739ae039 = $78901c2ca8895a3d$var$Introduction;


var $ed69d723bebfd0aa$export$34e0f9847d4c02dd;
var $ed69d723bebfd0aa$export$c8611a1d12375c02;
var $ed69d723bebfd0aa$export$bfd64c937657f93a;
var $ed69d723bebfd0aa$export$4a6dd88bada4e7d2;
$ed69d723bebfd0aa$export$34e0f9847d4c02dd = `mSfVLW_container`;
$ed69d723bebfd0aa$export$c8611a1d12375c02 = `mSfVLW_paywallCard`;
$ed69d723bebfd0aa$export$bfd64c937657f93a = `mSfVLW_rotating`;
$ed69d723bebfd0aa$export$4a6dd88bada4e7d2 = `mSfVLW_shimmer`;


const $d16dccf1455a42b5$var$basePathname = "/organization-template";
function $d16dccf1455a42b5$var$OrganizationTemplate() {
    const { getDocumentationUrl: getDocumentationUrl } = (0, $b595fc2f0eccd19a$export$2e2bcd8739ae039)();
    const [isGuideDrawerOpen, setIsGuideDrawerOpen] = (0, $jC8Vy.useState)(false);
    const { currentPlan: currentPlan } = (0, $jC8Vy.useContext)((0, $19434c930f80c964$export$f8addfd4ab69c833));
    const { isDevTenant: isDevTenant } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const isOrganizationsDisabled = (0, $8TpMk.isCloud) && !currentPlan.quota.organizationsEnabled;
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const handleUpgradePlan = (0, $jC8Vy.useCallback)(()=>{
        navigate((0, $b2864970cb73ddbd$export$6d940d0d58a60bc4));
    }, [
        navigate
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($7ddbeb184b5d4257$export$34e0f9847d4c02dd, $ed69d723bebfd0aa$export$34e0f9847d4c02dd),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5TsIB.default), {
                titleKey: "organization_template.title"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $7ddbeb184b5d4257$export$516dd90aeaaabcf0,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $18SWy.default), {
                        title: "organization_template.title",
                        subtitle: "organization_template.subtitle",
                        learnMoreLink: {
                            href: getDocumentationUrl((0, $cfL6o.organizationTemplateLink)),
                            targetBlank: "noopener"
                        },
                        paywall: (0, $7oDSS.cond)((isOrganizationsDisabled || isDevTenant) && (0, $lXQZH.ReservedPlanId).Pro)
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        title: "application_details.check_guide",
                        type: "outline",
                        size: "large",
                        onClick: ()=>{
                            setIsGuideDrawerOpen(true);
                        }
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $353ae25d75ceb68c$export$2e2bcd8739ae039), {
                        title: "organizations.guide.title",
                        subtitle: "organizations.guide.subtitle",
                        isOpen: isGuideDrawerOpen,
                        onClose: ()=>{
                            setIsGuideDrawerOpen(false);
                        },
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $78901c2ca8895a3d$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            isOrganizationsDisabled && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $gC7hG.default), {
                className: $ed69d723bebfd0aa$export$c8611a1d12375c02,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2b56c00d3802884b$export$2e2bcd8739ae039), {
                    title: "organization_template.title",
                    description: "organization_template.subtitle",
                    image: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ef008b0357de52f9$export$2e2bcd8739ae039), {}),
                    imageDark: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0807787c5f5c1b37$export$2e2bcd8739ae039), {}),
                    action: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        title: "upsell.upgrade_plan",
                        type: "primary",
                        size: "large",
                        onClick: handleUpgradePlan
                    })
                })
            }),
            !isOrganizationsDisabled && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $26090e0c44b20d28$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                                href: `${$d16dccf1455a42b5$var$basePathname}/${(0, $bt3dS.OrganizationTemplateTabs).OrganizationRoles}`,
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                    forKey: "organization_template.roles.tab_name"
                                })
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                                href: `${$d16dccf1455a42b5$var$basePathname}/${(0, $bt3dS.OrganizationTemplateTabs).OrganizationPermissions}`,
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                    forKey: "organization_template.permissions.tab_name"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Outlet), {})
                ]
            })
        ]
    });
}
var $d16dccf1455a42b5$export$2e2bcd8739ae039 = $d16dccf1455a42b5$var$OrganizationTemplate;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $voszV = parcelRequire("voszV");







var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $codQP = parcelRequire("codQP");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $kUZ14 = parcelRequire("kUZ14");

var $jGWQ4 = parcelRequire("jGWQ4");

var $aqmjm = parcelRequire("aqmjm");

var $5vVWy = parcelRequire("5vVWy");

var $fmHmG = parcelRequire("fmHmG");

var $7VnwS = parcelRequire("7VnwS");

var $dW2kG = parcelRequire("dW2kG");

var $5OcFi = parcelRequire("5OcFi");
const $6d27d07ce633c7e4$var$organizationScopesPath = "api/organization-scopes";
/** A modal that allows users to create or edit an organization permission. */ function $6d27d07ce633c7e4$var$ManageOrganizationPermissionModal({ data: data, onClose: onClose }) {
    const isCreateMode = data === null;
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const api = (0, $7VnwS.default)();
    const { register: register, formState: { errors: errors, isSubmitting: isSubmitting }, handleSubmit: handleSubmit } = (0, $codQP.useForm)((0, $7oDSS.cond)(data && {
        defaultValues: data
    }));
    const submit = handleSubmit((0, $5OcFi.trySubmitSafe)(async (json)=>{
        await (isCreateMode ? api.post($6d27d07ce633c7e4$var$organizationScopesPath, {
            json: json
        }) : api.patch(`${$6d27d07ce633c7e4$var$organizationScopesPath}/${data.id}`, {
            json: json
        }));
        (0, $FuhPC.toast).success(t(isCreateMode ? "organization_template.permissions.created" : "general.saved", {
            name: json.name
        }));
        onClose();
    }));
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        isOpen: true,
        className: $dW2kG.content,
        overlayClassName: $dW2kG.overlay,
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $5vVWy.default), {
            title: `organization_template.permissions.${isCreateMode ? "create" : "edit"}_title`,
            footer: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    !isCreateMode && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        title: "general.cancel",
                        isLoading: isSubmitting,
                        onClick: onClose
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        type: "primary",
                        title: isCreateMode ? "organization_template.permissions.create_permission" : "general.save",
                        isLoading: isSubmitting,
                        onClick: submit
                    })
                ]
            }),
            onClose: onClose,
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                    isRequired: true,
                    title: "organization_template.permissions.permission_field_name",
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                        // eslint-disable-next-line jsx-a11y/no-autofocus
                        autoFocus: isCreateMode,
                        readOnly: !isCreateMode,
                        placeholder: "read:appointment",
                        error: Boolean(errors.name),
                        ...register("name", {
                            required: true
                        })
                    })
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                    title: "organization_template.permissions.description_field_name",
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                        // eslint-disable-next-line jsx-a11y/no-autofocus
                        autoFocus: !isCreateMode,
                        placeholder: t("organization_template.permissions.description_field_placeholder"),
                        error: Boolean(errors.description),
                        ...register("description")
                    })
                })
            ]
        })
    });
}
var $6d27d07ce633c7e4$export$2e2bcd8739ae039 = $6d27d07ce633c7e4$var$ManageOrganizationPermissionModal;


parcelRequire("8Mb3E");
var $cfL6o = parcelRequire("cfL6o");

var $jGWQ4 = parcelRequire("jGWQ4");

var $66ixW = parcelRequire("66ixW");





var $7VnwS = parcelRequire("7VnwS");



var $7kooT = parcelRequire("7kooT");
var $2c2e842f982e0732$export$9b6d6ca62970729f;
var $2c2e842f982e0732$export$3dea766d36a8935f;
var $2c2e842f982e0732$export$bfd64c937657f93a;
var $2c2e842f982e0732$export$4a6dd88bada4e7d2;
$2c2e842f982e0732$export$9b6d6ca62970729f = `aGGNAG_createButton`;
$2c2e842f982e0732$export$3dea766d36a8935f = `aGGNAG_filter`;
$2c2e842f982e0732$export$bfd64c937657f93a = `aGGNAG_rotating`;
$2c2e842f982e0732$export$4a6dd88bada4e7d2 = `aGGNAG_shimmer`;


function $504a72a9e6d19a1f$var$OrganizationPermissions() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $b595fc2f0eccd19a$export$2e2bcd8739ae039)();
    const [{ keyword: keyword }, updateSearchParameters] = (0, $66a3eb3654f9d141$export$2e2bcd8739ae039)({
        keyword: ""
    });
    const { data: data, error: error, mutate: mutate, isLoading: isLoading } = (0, $voszV.default)((0, $7kooT.buildUrl)("api/organization-scopes", {
        ...(0, $7oDSS.cond)(keyword && {
            q: (0, $7kooT.formatSearchKeyword)(keyword)
        })
    }));
    const api = (0, $7VnwS.default)();
    const [permissionModalData, setPermissionModalData] = (0, $jC8Vy.useState)();
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3166f28a681c41bb$export$2e2bcd8739ae039), {
                rowGroups: [
                    {
                        key: "organizationPermissions",
                        data: data
                    }
                ],
                rowIndexKey: "id",
                columns: [
                    {
                        title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: "organization_template.permissions.permission_column"
                        }),
                        dataIndex: "name",
                        colSpan: 7,
                        render: ({ name: name })=>{
                            return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
                                variant: "cell",
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e52124c5a4489a19$export$2e2bcd8739ae039), {
                                    children: name
                                })
                            });
                        }
                    },
                    {
                        title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: "organization_template.permissions.description_column"
                        }),
                        dataIndex: "scopes",
                        colSpan: 8,
                        render: ({ description: description })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $e52124c5a4489a19$export$2e2bcd8739ae039), {
                                children: description ?? "-"
                            })
                    },
                    {
                        title: null,
                        dataIndex: "action",
                        colSpan: 1,
                        render: (scope)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $d6ac1a830c94487b$export$2e2bcd8739ae039), {
                                fieldName: "organization_template.permissions.permission_column",
                                deleteConfirmation: "organization_template.permissions.delete_confirm",
                                onEdit: ()=>{
                                    setPermissionModalData(scope);
                                },
                                onDelete: async ()=>{
                                    await api.delete(`api/organization-scopes/${scope.id}`);
                                    mutate();
                                }
                            })
                    }
                ],
                filter: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: $2c2e842f982e0732$export$3dea766d36a8935f,
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $46c375e0973aedf1$export$2e2bcd8739ae039), {
                            placeholder: t("organization_template.permissions.search_placeholder"),
                            defaultValue: keyword,
                            isClearable: Boolean(keyword),
                            onSearch: (keyword)=>{
                                updateSearchParameters({
                                    keyword: keyword
                                });
                            },
                            onClearSearch: ()=>{
                                updateSearchParameters({
                                    keyword: ""
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                            title: "organization_template.permissions.create_org_permission",
                            className: $2c2e842f982e0732$export$9b6d6ca62970729f,
                            type: "primary",
                            icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0b30fe81c923292b$export$2e2bcd8739ae039), {}),
                            onClick: ()=>{
                                setPermissionModalData(null);
                            }
                        })
                    ]
                }),
                placeholder: keyword ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a0f84bc7cc69e410$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2b56c00d3802884b$export$2e2bcd8739ae039), {
                    image: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e03e8b98a9e094ed$export$2e2bcd8739ae039), {}),
                    imageDark: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fbc1a38a5dc459d3$export$2e2bcd8739ae039), {}),
                    title: "organization_template.permissions.placeholder_title",
                    description: "organization_template.permissions.placeholder_description",
                    learnMoreLink: {
                        href: getDocumentationUrl((0, $cfL6o.organizationPermissionLink)),
                        targetBlank: "noopener"
                    },
                    action: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        title: "organization_template.permissions.create_org_permission",
                        type: "primary",
                        size: "large",
                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0b30fe81c923292b$export$2e2bcd8739ae039), {}),
                        onClick: ()=>{
                            setPermissionModalData(null);
                        }
                    })
                }),
                isLoading: isLoading,
                errorMessage: error?.body?.message ?? error?.message,
                onRetry: async ()=>mutate(undefined, true)
            }),
            permissionModalData !== undefined && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6d27d07ce633c7e4$export$2e2bcd8739ae039), {
                data: permissionModalData,
                onClose: ()=>{
                    setPermissionModalData(undefined);
                    mutate();
                }
            })
        ]
    });
}
var $504a72a9e6d19a1f$export$2e2bcd8739ae039 = $504a72a9e6d19a1f$var$OrganizationPermissions;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $voszV = parcelRequire("voszV");



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $a9b194b780a6cb64$var$SvgRolesEmptyDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#191C1D",
                d: "M0 0h256v256H0z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#C4C7C7",
                fillOpacity: 0.02,
                d: "M0 0h256v256H0z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#CABEFF",
                fillOpacity: 0.08,
                d: "M0 0h256v256H0z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M22 219h212.4V47.6c0-11.93-9.671-21.6-21.6-21.6H43.6C31.67 26 22 35.67 22 47.6V219Z",
                fill: "url(#paint0_linear_6532_88910)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M104.109 159.753H62.501c-17.539 0-32.526 12.64-35.484 29.928L22 218.999h212.4l-.469-1.319a21.6 21.6 0 0 0-20.352-14.363h-33.978a14.402 14.402 0 0 1-12.274-6.87l-2.057-3.352a28.799 28.799 0 0 0-24.547-13.738h-4.406c-4.519 0-8.66-2.521-10.736-6.535a24.174 24.174 0 0 0-21.472-13.069Z",
                fill: "#CABEFF",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M82.3 193.865H34.6c-11.93 0-21.6-9.67-21.6-21.6v-67.27M188.05 66.395h33.75c11.929 0 21.6 9.646 21.6 21.544v20.647",
                stroke: "#58577B",
                strokeWidth: 0.9,
                strokeDasharray: "3.6 3.6"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M148.861 64.694c0-.052.042-.094.094-.094h1.69c.052 0 .094.042.094.094v2.965l2.575-1.483a.095.095 0 0 1 .129.035l.844 1.46a.093.093 0 0 1-.034.127l-2.576 1.483 2.576 1.483c.045.026.06.084.034.129l-.845 1.459a.094.094 0 0 1-.128.034l-2.575-1.483v2.966a.094.094 0 0 1-.094.094h-1.69a.094.094 0 0 1-.094-.094v-2.966l-2.575 1.483a.095.095 0 0 1-.129-.034l-.844-1.46a.093.093 0 0 1 .034-.128l2.575-1.483-2.575-1.483a.094.094 0 0 1-.035-.128l.845-1.46a.095.095 0 0 1 .129-.034l2.575 1.484v-2.966Z",
                fill: "#5F5D67"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m129.822 59.93-.361-2.513a2.544 2.544 0 0 0-2.88-2.154v0a2.544 2.544 0 0 1-2.88-2.154v0a2.545 2.545 0 0 0-2.881-2.154l-2.52.36",
                stroke: "#52514B",
                strokeWidth: 1.8,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 87.7,
                y: 96.019,
                width: 135,
                height: 97.847,
                rx: 10.8,
                fill: "url(#paint1_linear_6532_88910)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 107.5,
                y: 146.287,
                width: 102.6,
                height: 8.977,
                rx: 3.6,
                fill: "#AF9FDB"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 107.5,
                y: 160.651,
                width: 102.6,
                height: 8.977,
                rx: 3.6,
                fill: "#F0EBFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 107.5,
                y: 175.014,
                width: 38.7,
                height: 8.977,
                rx: 3.6,
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 33.3,
                y: 160.253,
                width: 116,
                height: 58.246,
                rx: 10.3,
                fill: "#CABEFF",
                stroke: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 44.5,
                y: 192.07,
                width: 44.1,
                height: 7.181,
                rx: 1.8,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                opacity: 0.7,
                x: 44.5,
                y: 178.605,
                width: 8.1,
                height: 7.181,
                rx: 1.8,
                fill: "#F07EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 60.7,
                y: 178.605,
                width: 20.7,
                height: 7.181,
                rx: 1.8,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                clipPath: "url(#clip0_6532_88910)",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 104.8,
                        y: 172.321,
                        width: 32.4,
                        height: 32.316,
                        rx: 10.8,
                        fill: "#776E9E"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M131.613 200.939c.872 1.662 1.309 7.717 1.309 7.717h-24.521s.437-6.055 1.31-7.717c1.309-2.493 10.951-5.699 10.951-5.699s9.641 3.206 10.951 5.699Z",
                        fill: "#F07EFF"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "m130.836 193.864-19.338-2.331c-.953-5.048.178-8.229 3.393-9.542 1.486-4.857 7.271-4.462 8.91-4.066 5.58 1.348 7.925 6.661 7.035 15.939Z",
                        fill: "#47464E"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M117.806 196.666v-7.124c-2.979-.044-2.398-5.192.595-3.621.535.237 1.904-.416 1.428-2.018 3.214 2.374 7.692-1.793 7.975.771.557 5.047-.52 9.196-3.375 9.196a4.622 4.622 0 0 1-.91-.054v2.85c-.932.554-1.864.831-2.796.831-.932 0-1.904-.277-2.917-.831Z",
                        fill: "#FFB95A"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M123.518 193.816v.949c-1.309 0-3.174-.85-4.166-2.552 1.19.791 2.579 1.326 4.166 1.603Z",
                        fill: "#FA8B54"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M120.657 197.374c.814-.039 2.861-.459 2.861-1.367v-.767c.218 0 .843.515 1.164.95 1.271 1.722-.138 3.265-1.288 3.265-1.45 0-2.412-1.209-2.733-1.79-.321.581-1.283 1.79-2.733 1.79-1.15 0-2.56-1.543-1.289-3.265.322-.435.947-.95 1.165-.95v.767c0 .908 1.993 1.328 2.853 1.367Z",
                        fill: "url(#paint2_linear_6532_88910)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 105.25,
                y: 172.771,
                width: 31.5,
                height: 31.416,
                rx: 10.35,
                stroke: "#947DFF",
                strokeWidth: 0.9
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M59.8 106.819c0-5.965 4.835-10.8 10.8-10.8h141.3c5.965 0 10.8 4.835 10.8 10.8v3.562H59.8v-3.562Z",
                fill: "#635C8F"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M219.1 115.32c8.697 0 15.75-7.033 15.75-15.71 0-8.679-7.053-15.711-15.75-15.711s-15.75 7.032-15.75 15.71 7.053 15.711 15.75 15.711Z",
                stroke: "url(#paint3_linear_6532_88910)",
                strokeWidth: 0.9
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                cx: 219.101,
                cy: 99.61,
                rx: 13.843,
                ry: 13.807,
                fill: "#86BF8F"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 3.951,
                height: 11.854,
                rx: 1.976,
                transform: "rotate(-44.926 224.116 -204.183)",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 15.805,
                height: 3.951,
                rx: 1.976,
                transform: "rotate(-44.926 233.662 -208.158)",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m109.3 138.659 10.887-10.859a10.8 10.8 0 0 1 12.877-1.791l9.457 5.26a10.8 10.8 0 0 0 12.573-1.5l6.282-5.796a10.8 10.8 0 0 1 12.924-1.297l26.35 15.983",
                stroke: "#fff",
                strokeOpacity: 0.7,
                strokeWidth: 0.9,
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 45.4,
                y: 62.805,
                width: 62.1,
                height: 91.563,
                rx: 14.4,
                fill: "#C39EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 7.195,
                height: 7.186,
                rx: 1.8,
                transform: "rotate(30.748 -30.22 407.104) skewX(-.13)",
                fill: "#6E6083"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M40.9 66.064c-3.73 0-5.498-3.175-5.498-5.953 0 2.778-1.571 5.953-5.302 5.953 3.731 0 5.302 1.958 5.302 6.615 0-4.657 1.767-6.615 5.498-6.615Z",
                fill: "#928F9A"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M56.2 90.302c-3.731 0-5.498-3.175-5.498-5.953 0 2.778-1.571 5.953-5.302 5.953 3.73 0 5.302 1.957 5.302 6.614 0-4.656 1.767-6.614 5.498-6.614Z",
                fill: "#fff",
                fillOpacity: 0.8
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                cx: 166.94,
                cy: 121.192,
                rx: 1.839,
                ry: 1.835,
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                cx: 126.44,
                cy: 124.784,
                rx: 1.839,
                ry: 1.835,
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 52.6,
                y: 115.77,
                width: 48.6,
                height: 8.977,
                rx: 3.6,
                fill: "#D8C7FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 52.6,
                y: 129.234,
                width: 48.6,
                height: 8.977,
                rx: 3.6,
                fill: "#EFE9FF",
                stroke: "#815AE3",
                strokeWidth: 0.9
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M58 120.257c0-.496.402-.898.897-.898h19.805a.898.898 0 0 1 0 1.796H58.897a.898.898 0 0 1-.897-.898Zm25.2 0c0-.496.402-.898.897-.898h5.405a.898.898 0 0 1 0 1.796h-5.405a.898.898 0 0 1-.897-.898Zm9.897-.898a.898.898 0 0 0 0 1.796h1.805a.898.898 0 0 0 0-1.796h-1.805Z",
                fill: "#9877EA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                cx: 62.5,
                cy: 133.722,
                rx: 1.8,
                ry: 1.795,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                cx: 69.7,
                cy: 133.722,
                rx: 1.8,
                ry: 1.795,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                cx: 76.9,
                cy: 133.722,
                rx: 1.8,
                ry: 1.795,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                cx: 84.1,
                cy: 133.722,
                rx: 1.8,
                ry: 1.795,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                cx: 91.3,
                cy: 133.722,
                rx: 1.8,
                ry: 1.795,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                clipPath: "url(#clip1_6532_88910)",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 60.7,
                        y: 74.476,
                        width: 32.4,
                        height: 32.316,
                        rx: 10.8,
                        fill: "#D8C7FF"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M79.93 97.279v2.44c0 .47-6.96.312-6.96-.366 0-.637.013-3.528 0-6.501-1.56-2.015-1.56-3.275-.327-4.576 1.233-1.302 10.005-1.953 10.005-1.953s.658 6.314.761 8.027c.042.689.49 2.929-1.25 2.929h-2.23Z",
                        fill: "url(#paint4_linear_6532_88910)"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M79.928 97.069a10.308 10.308 0 0 1-4.021-1.31s.87 2.06 4.02 2.62v-1.31Z",
                        fill: "#FFD7B8",
                        style: {
                            mixBlendMode: "multiply"
                        }
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M87.868 104.578c.629 1.275 1.136 3.308 1.522 6.099a.744.744 0 0 1-.74.843h-24.4a.744.744 0 0 1-.74-.843c.386-2.792.893-4.824 1.52-6.099.689-1.395 7.07-4.079 7.07-4.079s.127-1.227.435-1.403c.308-.176 7.463-.176 7.83 0s.435 1.402.435 1.402 6.382 2.688 7.068 4.08Z",
                        fill: "#5F5D67"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M74.386 89.598c-.346-.296-.766-.495-1.36-.188-1.408.73-.474 3.543 1.102 3.488.544-.019.295 1.062-1.158 1.776 0-1.139-1.74-3.959-1.892-6.527-1.751-.65-1.316-3.252-.114-3.252-.192-2.385 3.637-3.617 5.12-2.248 1.508-1.803 5.314-.881 5.544.683 2.617-1.394 4.338 2.612 1.887 4.167-1.008.64-3.367.883-6.773.883-1.634 0-.694 3.815-.183 5.047.652 1.572 4.296 1.79 5.437 1.627.892-.127 1.36-.488 1.414-.705.816 2.17-.217 3.47-1.849 3.47-2.773 0-5.546-.813-5.98-2.82-.347-1.596-.328-4.174-1.195-5.4Z",
                        fill: "#7958FF"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 61.15,
                y: 74.926,
                width: 31.5,
                height: 31.416,
                rx: 10.35,
                stroke: "#9877EA",
                strokeWidth: 0.9
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#191C1D",
                d: "M89 218h20v5H89z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#C4C7C7",
                fillOpacity: 0.02,
                d: "M89 218h20v5H89z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#CABEFF",
                fillOpacity: 0.08,
                d: "M89 218h20v5H89z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_6532_88910",
                        x1: 128.2,
                        y1: 219,
                        x2: 128.2,
                        y2: 26,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#444353"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#444353",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_6532_88910",
                        x1: 155.2,
                        y1: 96.019,
                        x2: 136.658,
                        y2: 198.202,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#9B84DA"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#8470BD"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint2_linear_6532_88910",
                        x1: 120.661,
                        y1: 199.455,
                        x2: 120.661,
                        y2: 195.24,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FCF2EB"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFF9F5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint3_linear_6532_88910",
                        x1: 219.1,
                        y1: 84.349,
                        x2: 219.1,
                        y2: 114.87,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#86BF8F"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#86BF8F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint4_linear_6532_88910",
                        x1: 77.624,
                        y1: 86.323,
                        x2: 77.624,
                        y2: 99.989,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FFD4B3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFDCC2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("clipPath", {
                        id: "clip0_6532_88910",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                            x: 104.8,
                            y: 172.321,
                            width: 32.4,
                            height: 32.316,
                            rx: 10.8,
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("clipPath", {
                        id: "clip1_6532_88910",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                            x: 60.7,
                            y: 74.476,
                            width: 32.4,
                            height: 32.316,
                            rx: 10.8,
                            fill: "#fff"
                        })
                    })
                ]
            })
        ]
    });
var $a9b194b780a6cb64$export$2e2bcd8739ae039 = $a9b194b780a6cb64$var$SvgRolesEmptyDark;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $ed5f4a9b0d5d1626$var$SvgRolesEmpty = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M22 219h212.4V47.6c0-11.93-9.671-21.6-21.6-21.6H43.6C31.67 26 22 35.67 22 47.6V219Z",
                fill: "url(#paint0_linear_6485_85287)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M104.109 159.753H62.501c-17.539 0-32.526 12.64-35.484 29.928L22 218.999h212.4l-.469-1.319a21.6 21.6 0 0 0-20.352-14.363h-33.978a14.402 14.402 0 0 1-12.274-6.87l-2.057-3.352a28.799 28.799 0 0 0-24.547-13.738h-4.406c-4.519 0-8.66-2.521-10.736-6.535a24.174 24.174 0 0 0-21.472-13.069Z",
                fill: "#D2CCDD"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M82.3 193.865H34.6c-11.93 0-21.6-9.67-21.6-21.6v-67.27M188.05 66.395h33.75c11.929 0 21.6 9.646 21.6 21.544v20.647",
                stroke: "#A782E8",
                strokeWidth: 0.9,
                strokeDasharray: "3.6 3.6"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M148.861 64.694c0-.052.042-.094.094-.094h1.69c.052 0 .094.042.094.094v2.965l2.575-1.483a.094.094 0 0 1 .128.035l.845 1.46a.093.093 0 0 1-.034.127l-2.576 1.483 2.576 1.483c.045.026.06.084.034.129l-.845 1.459a.094.094 0 0 1-.128.034l-2.575-1.483v2.966a.094.094 0 0 1-.094.094h-1.69a.094.094 0 0 1-.094-.094v-2.966l-2.575 1.483a.095.095 0 0 1-.129-.034l-.844-1.46a.093.093 0 0 1 .034-.128l2.575-1.483-2.575-1.483a.094.094 0 0 1-.035-.128l.845-1.46a.095.095 0 0 1 .129-.034l2.575 1.484v-2.966Z",
                fill: "#E5E1EC"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m129.822 59.93-.361-2.513a2.544 2.544 0 0 0-2.88-2.154v0a2.544 2.544 0 0 1-2.88-2.154v0a2.545 2.545 0 0 0-2.881-2.154l-2.52.36",
                stroke: "#FFF06A",
                strokeWidth: 1.8,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 87.7,
                y: 96.019,
                width: 135,
                height: 97.847,
                rx: 10.8,
                fill: "url(#paint1_linear_6485_85287)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 107.5,
                y: 146.287,
                width: 102.6,
                height: 8.977,
                rx: 3.6,
                fill: "#D8C7FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 107.5,
                y: 160.651,
                width: 102.6,
                height: 8.977,
                rx: 3.6,
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 107.5,
                y: 175.014,
                width: 38.7,
                height: 8.977,
                rx: 3.6,
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 33.3,
                y: 160.253,
                width: 116,
                height: 58.246,
                rx: 10.3,
                fill: "#F5EEFF",
                stroke: "#D0BED6"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 44.5,
                y: 192.07,
                width: 44.1,
                height: 7.181,
                rx: 1.8,
                fill: "#E1CEE8"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 44.5,
                y: 178.605,
                width: 8.1,
                height: 7.181,
                rx: 1.8,
                fill: "#FFC3F1"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 60.7,
                y: 178.605,
                width: 20.7,
                height: 7.181,
                rx: 1.8,
                fill: "#E1CEE8"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                clipPath: "url(#clip0_6485_85287)",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 104.8,
                        y: 172.321,
                        width: 32.4,
                        height: 32.316,
                        rx: 10.8,
                        fill: "#F5EEFF"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M131.613 200.939c.872 1.662 1.309 7.717 1.309 7.717h-24.521s.437-6.055 1.31-7.717c1.309-2.493 10.951-5.699 10.951-5.699s9.641 3.206 10.951 5.699Z",
                        fill: "#F07EFF"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "m130.836 193.864-19.338-2.331c-.953-5.048.178-8.229 3.393-9.542 1.486-4.857 7.271-4.462 8.91-4.066 5.58 1.348 7.925 6.661 7.035 15.939Z",
                        fill: "#47464E"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M117.806 196.666v-7.124c-2.979-.044-2.398-5.192.595-3.621.535.237 1.904-.416 1.428-2.018 3.214 2.374 7.692-1.793 7.975.771.557 5.047-.52 9.196-3.375 9.196a4.622 4.622 0 0 1-.91-.054v2.85c-.932.554-1.864.831-2.796.831-.932 0-1.904-.277-2.917-.831Z",
                        fill: "#FFB95A"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M123.518 193.816v.949c-1.309 0-3.174-.85-4.166-2.552 1.19.791 2.579 1.326 4.166 1.603Z",
                        fill: "#FA8B54"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M120.657 197.374c.814-.039 2.861-.459 2.861-1.367v-.767c.218 0 .843.515 1.164.95 1.271 1.722-.138 3.265-1.288 3.265-1.45 0-2.412-1.209-2.733-1.79-.321.581-1.283 1.79-2.733 1.79-1.15 0-2.56-1.543-1.289-3.265.322-.435.947-.95 1.165-.95v.767c0 .908 1.993 1.328 2.853 1.367Z",
                        fill: "url(#paint2_linear_6485_85287)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 105.25,
                y: 172.771,
                width: 31.5,
                height: 31.416,
                rx: 10.35,
                stroke: "#D0BED6",
                strokeWidth: 0.9
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M59.8 106.819c0-5.965 4.835-10.8 10.8-10.8h141.3c5.965 0 10.8 4.835 10.8 10.8v3.562H59.8v-3.562Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M219.1 115.32c8.697 0 15.75-7.033 15.75-15.71 0-8.679-7.053-15.711-15.75-15.711s-15.75 7.032-15.75 15.71 7.053 15.711 15.75 15.711Z",
                stroke: "url(#paint3_linear_6485_85287)",
                strokeWidth: 0.9
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                cx: 219.101,
                cy: 99.61,
                rx: 13.843,
                ry: 13.807,
                fill: "#83DA85"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 3.951,
                height: 11.854,
                rx: 1.976,
                transform: "rotate(-44.926 224.116 -204.183)",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 15.805,
                height: 3.951,
                rx: 1.976,
                transform: "rotate(-44.926 233.662 -208.158)",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m109.3 138.659 10.887-10.859a10.8 10.8 0 0 1 12.877-1.791l9.457 5.26a10.8 10.8 0 0 0 12.573-1.5l6.282-5.796a10.8 10.8 0 0 1 12.924-1.297l26.35 15.983",
                stroke: "#fff",
                strokeOpacity: 0.7,
                strokeWidth: 0.9,
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 45.4,
                y: 62.805,
                width: 62.1,
                height: 91.563,
                rx: 14.4,
                fill: "#C39EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 7.195,
                height: 7.186,
                rx: 1.8,
                transform: "rotate(30.748 -30.22 407.104) skewX(-.13)",
                fill: "#FFD5FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M40.9 66.064c-3.73 0-5.498-3.175-5.498-5.953 0 2.778-1.571 5.953-5.302 5.953 3.731 0 5.302 1.958 5.302 6.615 0-4.657 1.767-6.615 5.498-6.615ZM56.2 90.302c-3.731 0-5.498-3.175-5.498-5.953 0 2.778-1.571 5.953-5.302 5.953 3.73 0 5.302 1.957 5.302 6.614 0-4.656 1.767-6.614 5.498-6.614Z",
                fill: "#FFF06A"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                cx: 166.94,
                cy: 121.192,
                rx: 1.839,
                ry: 1.835,
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                cx: 126.44,
                cy: 124.784,
                rx: 1.839,
                ry: 1.835,
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 52.6,
                y: 115.77,
                width: 48.6,
                height: 8.977,
                rx: 3.6,
                fill: "#D8C7FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 52.6,
                y: 129.234,
                width: 48.6,
                height: 8.977,
                rx: 3.6,
                fill: "#EFE9FF",
                stroke: "#815AE3",
                strokeWidth: 0.9
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M58 120.257c0-.496.402-.898.897-.898h19.805a.898.898 0 0 1 0 1.796H58.897a.898.898 0 0 1-.897-.898Zm25.2 0c0-.496.402-.898.897-.898h5.405a.898.898 0 0 1 0 1.796h-5.405a.898.898 0 0 1-.897-.898Zm9.897-.898a.898.898 0 0 0 0 1.796h1.805a.898.898 0 0 0 0-1.796h-1.805Z",
                fill: "#9877EA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                cx: 62.5,
                cy: 133.722,
                rx: 1.8,
                ry: 1.795,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                cx: 69.7,
                cy: 133.722,
                rx: 1.8,
                ry: 1.795,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                cx: 76.9,
                cy: 133.722,
                rx: 1.8,
                ry: 1.795,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                cx: 84.1,
                cy: 133.722,
                rx: 1.8,
                ry: 1.795,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                cx: 91.3,
                cy: 133.722,
                rx: 1.8,
                ry: 1.795,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                clipPath: "url(#clip1_6485_85287)",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                        x: 60.7,
                        y: 74.476,
                        width: 32.4,
                        height: 32.316,
                        rx: 10.8,
                        fill: "#D8C7FF"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M79.93 97.279v2.44c0 .47-6.96.312-6.96-.366 0-.637.013-3.528 0-6.501-1.56-2.015-1.56-3.275-.327-4.576 1.233-1.302 10.005-1.953 10.005-1.953s.658 6.314.761 8.027c.042.689.49 2.929-1.25 2.929h-2.23Z",
                        fill: "url(#paint4_linear_6485_85287)"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M79.928 97.069a10.308 10.308 0 0 1-4.021-1.31s.87 2.06 4.02 2.62v-1.31Z",
                        fill: "#FFD7B8",
                        style: {
                            mixBlendMode: "multiply"
                        }
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M87.868 104.578c.629 1.275 1.136 3.308 1.522 6.099a.744.744 0 0 1-.74.843h-24.4a.744.744 0 0 1-.74-.843c.386-2.792.893-4.824 1.52-6.099.689-1.395 7.07-4.079 7.07-4.079s.127-1.227.435-1.403c.308-.176 7.463-.176 7.83 0s.435 1.402.435 1.402 6.382 2.688 7.068 4.08Z",
                        fill: "#5F5D67"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M74.386 89.598c-.346-.296-.766-.495-1.36-.188-1.408.73-.474 3.543 1.102 3.488.544-.019.295 1.062-1.158 1.776 0-1.139-1.74-3.959-1.892-6.527-1.751-.65-1.316-3.252-.114-3.252-.192-2.385 3.637-3.617 5.12-2.248 1.508-1.803 5.314-.881 5.544.683 2.617-1.394 4.338 2.612 1.887 4.167-1.008.64-3.367.883-6.773.883-1.634 0-.694 3.815-.183 5.047.652 1.572 4.296 1.79 5.437 1.627.892-.127 1.36-.488 1.414-.705.816 2.17-.217 3.47-1.849 3.47-2.773 0-5.546-.813-5.98-2.82-.347-1.596-.328-4.174-1.195-5.4Z",
                        fill: "#7958FF"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 61.15,
                y: 74.926,
                width: 31.5,
                height: 31.416,
                rx: 10.35,
                stroke: "#9877EA",
                strokeWidth: 0.9
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#fff",
                d: "M89 218h20v5H89z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_6485_85287",
                        x1: 128.2,
                        y1: 219,
                        x2: 128.2,
                        y2: 26,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#F5EEFF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F5EEFF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_6485_85287",
                        x1: 155.2,
                        y1: 96.019,
                        x2: 124.678,
                        y2: 200.782,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#C39EFF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#906FEF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint2_linear_6485_85287",
                        x1: 120.661,
                        y1: 199.455,
                        x2: 120.661,
                        y2: 195.24,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FCF2EB"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFF9F5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint3_linear_6485_85287",
                        x1: 207.443,
                        y1: 88.709,
                        x2: 234.332,
                        y2: 114.939,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#83DA85"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#83DA85",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint4_linear_6485_85287",
                        x1: 77.624,
                        y1: 86.323,
                        x2: 77.624,
                        y2: 99.989,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FFD4B3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFDCC2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("clipPath", {
                        id: "clip0_6485_85287",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                            x: 104.8,
                            y: 172.321,
                            width: 32.4,
                            height: 32.316,
                            rx: 10.8,
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("clipPath", {
                        id: "clip1_6485_85287",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                            x: 60.7,
                            y: 74.476,
                            width: 32.4,
                            height: 32.316,
                            rx: 10.8,
                            fill: "#fff"
                        })
                    })
                ]
            })
        ]
    });
var $ed5f4a9b0d5d1626$export$2e2bcd8739ae039 = $ed5f4a9b0d5d1626$var$SvgRolesEmpty;








var $8Mb3E = parcelRequire("8Mb3E");
var $cfL6o = parcelRequire("cfL6o");

var $jGWQ4 = parcelRequire("jGWQ4");

var $66ixW = parcelRequire("66ixW");







var $4ZcUR = parcelRequire("4ZcUR");

var $7kooT = parcelRequire("7kooT");

var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $kUZ14 = parcelRequire("kUZ14");

var $jGWQ4 = parcelRequire("jGWQ4");

var $aqmjm = parcelRequire("aqmjm");

var $5vVWy = parcelRequire("5vVWy");

var $fmHmG = parcelRequire("fmHmG");

var $7VnwS = parcelRequire("7VnwS");

var $dW2kG = parcelRequire("dW2kG");

var $5OcFi = parcelRequire("5OcFi");
function $d972a56f133672b7$var$CreateOrganizationRoleModal({ isOpen: isOpen, onClose: onClose }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { register: register, formState: { errors: errors, isSubmitting: isSubmitting }, handleSubmit: handleSubmit, reset: reset } = (0, $codQP.useForm)();
    const onCloseHandler = (0, $jC8Vy.useCallback)((createdData)=>{
        // Reset form when modal is closed
        reset();
        onClose(createdData);
    }, [
        onClose,
        reset
    ]);
    const api = (0, $7VnwS.default)();
    const submit = handleSubmit((0, $5OcFi.trySubmitSafe)(async (formData)=>{
        const createdData = await api.post("api/organization-roles", {
            json: formData
        }).json();
        (0, $FuhPC.toast).success(t("organization_template.roles.create_modal.created", {
            name: createdData.name
        }));
        onCloseHandler(createdData);
    }));
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        isOpen: isOpen,
        className: $dW2kG.content,
        overlayClassName: $dW2kG.overlay,
        onRequestClose: ()=>{
            onCloseHandler();
        },
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $5vVWy.default), {
            title: "organization_template.roles.create_modal.title",
            footer: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                type: "primary",
                title: "organization_template.roles.create_modal.create",
                isLoading: isSubmitting,
                onClick: submit
            }),
            onClose: onCloseHandler,
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                    isRequired: true,
                    title: "organization_template.roles.create_modal.name_field",
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                        // eslint-disable-next-line jsx-a11y/no-autofocus
                        autoFocus: true,
                        placeholder: "viewer",
                        error: Boolean(errors.name),
                        ...register("name", {
                            required: true
                        })
                    })
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                    title: "organization_template.permissions.description_field_name",
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                        placeholder: t("organization_role_details.general.description_field_placeholder"),
                        error: Boolean(errors.description),
                        ...register("description")
                    })
                })
            ]
        })
    });
}
var $d972a56f133672b7$export$2e2bcd8739ae039 = $d972a56f133672b7$var$CreateOrganizationRoleModal;


var $456b866da988cb46$export$3dea766d36a8935f;
var $456b866da988cb46$export$430c45605c9594b5;
var $456b866da988cb46$export$bfd64c937657f93a;
var $456b866da988cb46$export$4a6dd88bada4e7d2;
$456b866da988cb46$export$3dea766d36a8935f = `e6owva_filter`;
$456b866da988cb46$export$430c45605c9594b5 = `e6owva_permissions`;
$456b866da988cb46$export$bfd64c937657f93a = `e6owva_rotating`;
$456b866da988cb46$export$4a6dd88bada4e7d2 = `e6owva_shimmer`;


function $ff1a4ef1abf35d0b$var$OrganizationRoles() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $b595fc2f0eccd19a$export$2e2bcd8739ae039)();
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const [{ page: page, keyword: keyword }, updateSearchParameters] = (0, $66a3eb3654f9d141$export$2e2bcd8739ae039)({
        page: 1,
        keyword: ""
    });
    const { data: data, error: error, mutate: mutate, isLoading: isLoading } = (0, $voszV.default)((0, $7kooT.buildUrl)("api/organization-roles", {
        page: String(page),
        page_size: String((0, $8Mb3E.defaultPageSize)),
        ...(0, $7oDSS.cond)(keyword && {
            q: (0, $7kooT.formatSearchKeyword)(keyword)
        })
    }));
    const [orgRoles, totalCount] = data ?? [];
    const [isCreateModalOpen, setIsCreateModalOpen] = (0, $jC8Vy.useState)(false);
    const [createdRole, setCreatedRole] = (0, $jC8Vy.useState)();
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3166f28a681c41bb$export$2e2bcd8739ae039), {
                rowGroups: [
                    {
                        key: "organizationRoles",
                        data: orgRoles
                    }
                ],
                rowIndexKey: "id",
                columns: [
                    {
                        title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: "organization_template.roles.role_column"
                        }),
                        dataIndex: "name",
                        colSpan: 4,
                        render: ({ id: id, name: name })=>{
                            return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4d952cae22cb03fc$export$2e2bcd8739ae039), {
                                title: name,
                                icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c1fc6cc4be9e0c9a$export$2e2bcd8739ae039), {
                                    for: (0, $e513438a8bc87044$export$2e2bcd8739ae039)
                                }),
                                to: id
                            });
                        }
                    },
                    {
                        title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: "organization_template.roles.permissions_column"
                        }),
                        dataIndex: "scopes",
                        colSpan: 12,
                        render: ({ scopes: scopes, resourceScopes: resourceScopes })=>{
                            const roleScopes = [
                                ...scopes,
                                ...resourceScopes
                            ];
                            return roleScopes.length === 0 ? "-" : /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $456b866da988cb46$export$430c45605c9594b5,
                                children: roleScopes.map(({ id: id, name: name })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
                                        variant: "cell",
                                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e52124c5a4489a19$export$2e2bcd8739ae039), {
                                            children: name
                                        })
                                    }, id))
                            });
                        }
                    }
                ],
                rowClickHandler: ({ id: id })=>{
                    navigate(id);
                },
                filter: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: $456b866da988cb46$export$3dea766d36a8935f,
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $46c375e0973aedf1$export$2e2bcd8739ae039), {
                            placeholder: t("organization_template.roles.search_placeholder"),
                            defaultValue: keyword,
                            isClearable: Boolean(keyword),
                            onSearch: (keyword)=>{
                                updateSearchParameters({
                                    keyword: keyword
                                });
                            },
                            onClearSearch: ()=>{
                                updateSearchParameters({
                                    keyword: ""
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                            title: "organization_template.roles.create_title",
                            type: "primary",
                            icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0b30fe81c923292b$export$2e2bcd8739ae039), {}),
                            onClick: ()=>{
                                setIsCreateModalOpen(true);
                            }
                        })
                    ]
                }),
                placeholder: keyword ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a0f84bc7cc69e410$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2b56c00d3802884b$export$2e2bcd8739ae039), {
                    image: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ed5f4a9b0d5d1626$export$2e2bcd8739ae039), {}),
                    imageDark: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a9b194b780a6cb64$export$2e2bcd8739ae039), {}),
                    title: "organization_template.roles.placeholder_title",
                    description: "organization_template.roles.placeholder_description",
                    learnMoreLink: {
                        href: getDocumentationUrl((0, $cfL6o.organizationRoleLink)),
                        targetBlank: "noopener"
                    },
                    action: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        title: "organization_template.roles.create_title",
                        type: "primary",
                        size: "large",
                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0b30fe81c923292b$export$2e2bcd8739ae039), {}),
                        onClick: ()=>{
                            setIsCreateModalOpen(true);
                        }
                    })
                }),
                pagination: {
                    page: page,
                    totalCount: totalCount,
                    pageSize: (0, $8Mb3E.defaultPageSize),
                    onChange: (page)=>{
                        updateSearchParameters({
                            page: page
                        });
                    }
                },
                isLoading: isLoading,
                errorMessage: error?.body?.message ?? error?.message,
                onRetry: async ()=>mutate(undefined, true)
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $d972a56f133672b7$export$2e2bcd8739ae039), {
                isOpen: isCreateModalOpen,
                onClose: (createdRole)=>{
                    setIsCreateModalOpen(false);
                    if (createdRole) {
                        mutate();
                        setCreatedRole({
                            ...createdRole,
                            scopes: [],
                            resourceScopes: []
                        });
                    }
                }
            }),
            createdRole && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fc8b6b5544eb5e1e$export$2e2bcd8739ae039), {
                isOpen: true,
                organizationRoleId: createdRole.id,
                onClose: ()=>{
                    setCreatedRole(undefined);
                    navigate(createdRole.id);
                    mutate();
                }
            })
        ]
    });
}
var $ff1a4ef1abf35d0b$export$2e2bcd8739ae039 = $ff1a4ef1abf35d0b$var$OrganizationRoles;


const $4d9c808c996a5276$export$9d2f05f7e7fe6f0c = [
    {
        path: "organization-template",
        element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $d16dccf1455a42b5$export$2e2bcd8739ae039), {}),
        children: [
            {
                index: true,
                element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Navigate), {
                    replace: true,
                    to: (0, $bt3dS.OrganizationTemplateTabs).OrganizationRoles
                })
            },
            {
                path: (0, $bt3dS.OrganizationTemplateTabs).OrganizationRoles,
                element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ff1a4ef1abf35d0b$export$2e2bcd8739ae039), {})
            },
            {
                path: (0, $bt3dS.OrganizationTemplateTabs).OrganizationPermissions,
                element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $504a72a9e6d19a1f$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        path: `organization-template/${(0, $bt3dS.OrganizationTemplateTabs).OrganizationRoles}/:id/*`,
        element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a54e9815eaed0b27$export$2e2bcd8739ae039), {}),
        children: [
            {
                index: true,
                element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Navigate), {
                    replace: true,
                    to: (0, $bt3dS.OrganizationRoleDetailsTabs).Permissions
                })
            },
            {
                path: (0, $bt3dS.OrganizationRoleDetailsTabs).Permissions,
                element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $deb773656760afac$export$2e2bcd8739ae039), {})
            },
            {
                path: (0, $bt3dS.OrganizationRoleDetailsTabs).General,
                element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $267ad39c2bc3d37a$export$2e2bcd8739ae039), {})
            }
        ]
    }
];



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $2Phw0 = parcelRequire("2Phw0");

var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $2Phw0 = parcelRequire("2Phw0");

var $voszV = parcelRequire("voszV");









var $5TsIB = parcelRequire("5TsIB");




var $7VnwS = parcelRequire("7VnwS");

var $4ZcUR = parcelRequire("4ZcUR");

var $e8250641bf982bab$export$38e42c68cf43b5d4;
var $e8250641bf982bab$export$1237798dc640739a;
var $e8250641bf982bab$export$dbb5e893e736e4ee;
var $e8250641bf982bab$export$a8ff84c12d48cfa6;
var $e8250641bf982bab$export$523fb3936f49e028;
var $e8250641bf982bab$export$bfd64c937657f93a;
var $e8250641bf982bab$export$120ff0929b202a6d;
var $e8250641bf982bab$export$4a6dd88bada4e7d2;
$e8250641bf982bab$export$38e42c68cf43b5d4 = `sCS0zG_header`;
$e8250641bf982bab$export$1237798dc640739a = `sCS0zG_label`;
$e8250641bf982bab$export$dbb5e893e736e4ee = `sCS0zG_metadata`;
$e8250641bf982bab$export$a8ff84c12d48cfa6 = `sCS0zG_name`;
$e8250641bf982bab$export$523fb3936f49e028 = `sCS0zG_page`;
$e8250641bf982bab$export$bfd64c937657f93a = `sCS0zG_rotating`;
$e8250641bf982bab$export$120ff0929b202a6d = `sCS0zG_row`;
$e8250641bf982bab$export$4a6dd88bada4e7d2 = `sCS0zG_shimmer`;


var $7969f1e3d9973888$export$b34acede8cc7b639;
(function(OrganizationDetailsTabs) {
    OrganizationDetailsTabs["Settings"] = "settings";
    OrganizationDetailsTabs["Members"] = "members";
})($7969f1e3d9973888$export$b34acede8cc7b639 || ($7969f1e3d9973888$export$b34acede8cc7b639 = {}));


const $a10636997a9c033b$var$pathname = "/organizations";
function $a10636997a9c033b$var$OrganizationDetails() {
    const { id: id } = (0, $2Phw0.useParams)();
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: data, error: error, mutate: mutate } = (0, $voszV.default)(id && `api/organizations/${id}`);
    const [isDeleting, setIsDeleting] = (0, $jC8Vy.useState)(false);
    const [isGuideDrawerOpen, setIsGuideDrawerOpen] = (0, $jC8Vy.useState)(false);
    const [isDeleteFormOpen, setIsDeleteFormOpen] = (0, $jC8Vy.useState)(false);
    const api = (0, $7VnwS.default)();
    const deleteOrganization = (0, $jC8Vy.useCallback)(async ()=>{
        if (!id || isDeleting) return;
        setIsDeleting(true);
        try {
            await api.delete(`api/organizations/${id}`);
            navigate($a10636997a9c033b$var$pathname);
        } finally{
            setIsDeleting(false);
        }
    }, [
        api,
        id,
        isDeleting,
        navigate
    ]);
    const isLoading = !data && !error;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aa35f43ec98b7478$export$2e2bcd8739ae039), {
        backLink: $a10636997a9c033b$var$pathname,
        backLinkTitle: "organizations.title",
        className: $e8250641bf982bab$export$523fb3936f49e028,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5TsIB.default), {
                titleKey: "organization_details.page_title"
            }),
            isLoading && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dd9fddb6bc5d38a8$export$2e2bcd8739ae039), {}),
            error && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6b7de14b6bd7147f$export$2e2bcd8739ae039), {
                errorCode: error.body?.code,
                errorMessage: error.body?.message
            }),
            data && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $eefae5244405013e$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c1fc6cc4be9e0c9a$export$2e2bcd8739ae039), {
                            for: (0, $fa5532faa4d9cc63$export$2e2bcd8739ae039),
                            size: 60
                        }),
                        title: data.name,
                        identifier: {
                            name: t("organization_details.organization_id"),
                            value: data.id
                        },
                        additionalActionButton: {
                            icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f71d98d4090dad5c$export$2e2bcd8739ae039), {}),
                            title: "application_details.check_guide",
                            onClick: ()=>{
                                setIsGuideDrawerOpen(true);
                            }
                        },
                        actionMenuItems: [
                            {
                                icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3aa588de5c8665f2$export$2e2bcd8739ae039), {}),
                                title: "general.delete",
                                type: "danger",
                                onClick: ()=>{
                                    setIsDeleteFormOpen(true);
                                }
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $353ae25d75ceb68c$export$2e2bcd8739ae039), {
                        title: "organizations.guide.title",
                        subtitle: "organizations.guide.subtitle",
                        isOpen: isGuideDrawerOpen,
                        onClose: ()=>{
                            setIsGuideDrawerOpen(false);
                        },
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $78901c2ca8895a3d$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7065f4e52ae4e862$export$2e2bcd8739ae039), {
                        isOpen: isDeleteFormOpen,
                        isLoading: isDeleting,
                        onCancel: ()=>{
                            setIsDeleteFormOpen(false);
                        },
                        onConfirm: deleteOrganization,
                        children: t("organization_details.delete_confirmation")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $26090e0c44b20d28$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                                href: `${$a10636997a9c033b$var$pathname}/${data.id}/${(0, $7969f1e3d9973888$export$b34acede8cc7b639).Settings}`,
                                children: t("general.settings_nav")
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                                href: `${$a10636997a9c033b$var$pathname}/${data.id}/${(0, $7969f1e3d9973888$export$b34acede8cc7b639).Members}`,
                                children: t("organizations.members")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Outlet), {
                        context: {
                            data: data,
                            isDeleting: isDeleting,
                            onUpdated: async (data)=>mutate(data)
                        }
                    })
                ]
            })
        ]
    });
}
var $a10636997a9c033b$export$2e2bcd8739ae039 = $a10636997a9c033b$var$OrganizationDetails;



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $2Phw0 = parcelRequire("2Phw0");

var $voszV = parcelRequire("voszV");



var $C7mD2 = parcelRequire("C7mD2");

function $5bc18cf18674bbc6$var$DateTime({ children: children }) {
    const date = children && new Date(children);
    if (!date || !(0, $60c6adb4b27d9137$export$2e2bcd8739ae039)(date)) return /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
        children: "-"
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
        children: date.toLocaleDateString()
    });
}
var $5bc18cf18674bbc6$export$2e2bcd8739ae039 = $5bc18cf18674bbc6$var$DateTime;




var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

function $6f644f560eac971b$var$SuspendedTag({ className: className }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
        status: "error",
        className: className,
        children: t("user_details.suspended")
    });
}
var $6f644f560eac971b$export$2e2bcd8739ae039 = $6f644f560eac971b$var$SuspendedTag;





/** A component that renders a preview of a user. It's useful for displaying a user in a list. */ function $55e437438f7e6e4f$var$UserPreview({ user: user, hasUserDetailsLink: hasUserDetailsLink }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4d952cae22cb03fc$export$2e2bcd8739ae039), {
        title: (0, $46451cbb59c7a857$export$5f7a1baecd59f846)(user),
        subtitle: (0, $46451cbb59c7a857$export$336d714c72178bf2)(user),
        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e999fd6c93542895$export$2e2bcd8739ae039), {
            size: "large",
            user: user
        }),
        to: (0, $7oDSS.conditional)(hasUserDetailsLink !== false && `/users/${user.id}`),
        suffix: (0, $7oDSS.conditional)(user.isSuspended && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6f644f560eac971b$export$2e2bcd8739ae039), {}))
    });
}
var $55e437438f7e6e4f$export$2e2bcd8739ae039 = $55e437438f7e6e4f$var$UserPreview;



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $HHYyb = parcelRequire("HHYyb");

var $k9Oeh = parcelRequire("k9Oeh");

var $bnkR4 = parcelRequire("bnkR4");


var $75SRw = parcelRequire("75SRw");


function $897151762b31466b$var$MultiSelect({ className: className, value: value, options: options, onSearch: onSearch, onChange: onChange, isReadOnly: isReadOnly, error: error, placeholder: placeholder, isOptionsLoading: isOptionsLoading, renderOption: renderOption = ({ title: title, value: value })=>title ?? value }) {
    const inputRef = (0, $jC8Vy.useRef)(null);
    const selectRef = (0, $jC8Vy.useRef)(null);
    const [keyword, setKeyword] = (0, $jC8Vy.useState)("");
    const [isInputFocused, setIsInputFocused] = (0, $jC8Vy.useState)(false);
    // Used to focus on the last tag to perform deletion
    const [focusedValue, setFocusedValue] = (0, $jC8Vy.useState)(null);
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    // Search on keyword changes
    (0, $jC8Vy.useEffect)(()=>{
        if (isInputFocused) onSearch(keyword);
    }, [
        keyword,
        isInputFocused,
        onSearch
    ]);
    const handleSelect = (option)=>{
        if (value.some(({ value: value })=>value === option.value)) return;
        onChange([
            ...value,
            option
        ]);
        setKeyword("");
        inputRef.current?.focus();
    };
    const handleDelete = (option)=>{
        onChange(value.filter(({ value: value })=>value !== option.value));
    };
    // https://exogen.github.io/blog/focus-state/
    (0, $jC8Vy.useEffect)(()=>{
        if (document.hasFocus() && inputRef.current?.contains(document.activeElement)) setIsInputFocused(true);
    }, []);
    const isOpen = !isReadOnly && isInputFocused && !focusedValue;
    const filteredOptions = options.filter(({ value: current })=>{
        return !value.some(({ value: value })=>value === current);
    });
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        ref: selectRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($8ef17a492a7c5cd2$export$2e6c959c16ff56b8, $8ef17a492a7c5cd2$export$939ddaa3205df08e, isOpen && $8ef17a492a7c5cd2$export$3ce6949f20cea765, isReadOnly && $8ef17a492a7c5cd2$export$b2cbc93d4da94977, Boolean(error) && $8ef17a492a7c5cd2$export$a3bc9b8ed74fc, className),
        role: "button",
        tabIndex: 0,
        onKeyDown: (0, $bnkR4.onKeyDownHandler)(()=>{
            if (!isReadOnly) inputRef.current?.focus();
        }),
        onClick: ()=>{
            if (!isReadOnly) inputRef.current?.focus();
        },
        children: [
            value.map((option)=>{
                return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
                    variant: "cell",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($8ef17a492a7c5cd2$export$2b067c6666111485, option.value === focusedValue && $8ef17a492a7c5cd2$export$4c2b230493b2b322),
                    onClick: (event)=>{
                        event.stopPropagation();
                    },
                    children: [
                        renderOption(option),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                            className: $8ef17a492a7c5cd2$export$1822828d790e23ee,
                            size: "small",
                            onClick: ()=>{
                                handleDelete(option);
                            },
                            onKeyDown: (0, $bnkR4.onKeyDownHandler)(()=>{
                                handleDelete(option);
                            }),
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $HHYyb.default), {
                                className: $8ef17a492a7c5cd2$export$8360e631d277ea4d
                            })
                        })
                    ]
                }, option.value);
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("input", {
                ref: inputRef,
                type: "text",
                placeholder: (0, $7oDSS.cond)(value.length === 0 && placeholder && String(t(placeholder))),
                value: keyword,
                onKeyDown: (event)=>{
                    if (event.key === "Backspace" && keyword === "") {
                        if (focusedValue) {
                            onChange(value.filter(({ value: value })=>value !== focusedValue));
                            setFocusedValue(null);
                        } else setFocusedValue(value.at(-1)?.value ?? null);
                        event.stopPropagation();
                    }
                },
                onChange: ({ currentTarget: { value: value } })=>{
                    setKeyword(value);
                    setFocusedValue(null);
                },
                onFocus: ()=>{
                    setIsInputFocused(true);
                },
                onBlur: ()=>{
                    setIsInputFocused(false);
                    setFocusedValue(null);
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $f90dea65844a9f7a$export$2e2bcd8739ae039), {
                isFullWidth: true,
                noOverlay: true,
                isOpen: isOpen,
                className: $8ef17a492a7c5cd2$export$81207e5cc4186890,
                anchorRef: selectRef,
                children: [
                    isOptionsLoading && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $k9Oeh.Ring), {
                        className: $8ef17a492a7c5cd2$export$641374ffb95bc399
                    }),
                    !isOptionsLoading && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                        children: [
                            filteredOptions.length === 0 && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $8ef17a492a7c5cd2$export$17aca76bf89ef49e,
                                children: t("errors.empty")
                            }),
                            filteredOptions.map((option)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $6c006ec422465f6f$export$2e2bcd8739ae039), {
                                    onClick: (event)=>{
                                        event.preventDefault();
                                        handleSelect(option);
                                    },
                                    children: renderOption(option)
                                }, option.value))
                        ]
                    })
                ]
            })
        ]
    });
}
var $897151762b31466b$export$2e2bcd8739ae039 = $897151762b31466b$var$MultiSelect;



var $jC8Vy = parcelRequire("jC8Vy");

var $voszV = parcelRequire("voszV");

var $8Mb3E = parcelRequire("8Mb3E");

var $7kooT = parcelRequire("7kooT");
const $f2f245ca847f9959$var$useSearchValues = (pathname, keyword)=>{
    const { data: response, error: error, mutate: mutate } = (0, $voszV.default)((0, $7kooT.buildUrl)(pathname, {
        page: String(1),
        page_size: String((0, $8Mb3E.defaultPageSize)),
        q: keyword
    }), {
        revalidateOnFocus: false
    });
    const [data] = response ?? [
        [],
        0
    ];
    return (0, $jC8Vy.useMemo)(()=>({
            isLoading: !response && !error,
            data: data,
            mutate: mutate,
            error: error
        }), [
        data,
        error,
        mutate,
        response
    ]);
};
var $f2f245ca847f9959$export$2e2bcd8739ae039 = $f2f245ca847f9959$var$useSearchValues;




var $cef1e62e08162a4b$export$f09585a853dddd32;
var $cef1e62e08162a4b$export$f8907ddf2999bb8a;
var $cef1e62e08162a4b$export$bfd64c937657f93a;
var $cef1e62e08162a4b$export$4a6dd88bada4e7d2;
$cef1e62e08162a4b$export$f09585a853dddd32 = `FQBl7a_large`;
$cef1e62e08162a4b$export$f8907ddf2999bb8a = `FQBl7a_roleOption`;
$cef1e62e08162a4b$export$bfd64c937657f93a = `FQBl7a_rotating`;
$cef1e62e08162a4b$export$4a6dd88bada4e7d2 = `FQBl7a_shimmer`;


function $be4f434fcf26f56b$export$9b2040b3fe7f4e3f({ title: title, value: value, size: size = "small" }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($cef1e62e08162a4b$export$f8907ddf2999bb8a, size === "large" && $cef1e62e08162a4b$export$f09585a853dddd32),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c1fc6cc4be9e0c9a$export$2e2bcd8739ae039), {
                for: (0, $e513438a8bc87044$export$2e2bcd8739ae039),
                size: size === "small" ? 16 : 40
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e52124c5a4489a19$export$2e2bcd8739ae039), {
                children: title ?? value
            })
        ]
    });
}
function $be4f434fcf26f56b$var$OrganizationRolesSelect({ value: value, onChange: onChange, keyword: keyword, setKeyword: setKeyword }) {
    const { data: scopes, isLoading: isLoading } = (0, $f2f245ca847f9959$export$2e2bcd8739ae039)("api/organization-roles", keyword);
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $897151762b31466b$export$2e2bcd8739ae039), {
        value: value,
        options: scopes.map(({ id: id, name: name })=>({
                value: id,
                title: name
            })),
        placeholder: "organizations.search_role_placeholder",
        isOptionsLoading: isLoading,
        renderOption: $be4f434fcf26f56b$export$9b2040b3fe7f4e3f,
        onChange: onChange,
        onSearch: setKeyword
    });
}
var $be4f434fcf26f56b$export$2e2bcd8739ae039 = $be4f434fcf26f56b$var$OrganizationRolesSelect;



var $8Mb3E = parcelRequire("8Mb3E");

var $jGWQ4 = parcelRequire("jGWQ4");

var $8R7rc = parcelRequire("8R7rc");





var $7VnwS = parcelRequire("7VnwS");

var $7kooT = parcelRequire("7kooT");

var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $kUZ14 = parcelRequire("kUZ14");

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $voszV = parcelRequire("voszV");



var $8Mb3E = parcelRequire("8Mb3E");

var $66ixW = parcelRequire("66ixW");


var $fmHmG = parcelRequire("fmHmG");



var $7kooT = parcelRequire("7kooT");

var $C7mD2 = parcelRequire("C7mD2");


var $bnkR4 = parcelRequire("bnkR4");
var $b8f182ac68cd069a$export$1ca1ec8b29a4ce27;
var $b8f182ac68cd069a$export$7061c75fc5af8b7e;
var $b8f182ac68cd069a$export$bfd64c937657f93a;
var $b8f182ac68cd069a$export$4a6dd88bada4e7d2;
var $b8f182ac68cd069a$export$9c4e203df590c544;
var $b8f182ac68cd069a$export$fb184b623420d9be;
$b8f182ac68cd069a$export$1ca1ec8b29a4ce27 = `Y0u9ea_icon`;
$b8f182ac68cd069a$export$7061c75fc5af8b7e = `Y0u9ea_item`;
$b8f182ac68cd069a$export$bfd64c937657f93a = `Y0u9ea_rotating`;
$b8f182ac68cd069a$export$4a6dd88bada4e7d2 = `Y0u9ea_shimmer`;
$b8f182ac68cd069a$export$9c4e203df590c544 = `Y0u9ea_suspended`;
$b8f182ac68cd069a$export$fb184b623420d9be = `Y0u9ea_title`;


function $efbe229a2b32c333$var$SourceEntityItem({ entity: entity, isSelected: isSelected, onSelect: onSelect, render: render }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        role: "button",
        tabIndex: 0,
        className: $b8f182ac68cd069a$export$7061c75fc5af8b7e,
        onKeyDown: (0, $bnkR4.onKeyDownHandler)(()=>{
            onSelect();
        }),
        onClick: ()=>{
            onSelect();
        },
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $26dc4ab718ba37b7$export$2e2bcd8739ae039), {
                checked: isSelected,
                onChange: ()=>{
                    onSelect();
                }
            }),
            render(entity)
        ]
    });
}
var $efbe229a2b32c333$export$2e2bcd8739ae039 = $efbe229a2b32c333$var$SourceEntityItem;


var $f63ccb147771317e$export$1ca1ec8b29a4ce27;
var $f63ccb147771317e$export$d76128d007d19019;
$f63ccb147771317e$export$1ca1ec8b29a4ce27 = `Nr_Nla_icon`;
$f63ccb147771317e$export$d76128d007d19019 = `Nr_Nla_search`;


const $ae637b08a969b696$var$pageSize = (0, $8Mb3E.defaultPageSize);
function $ae637b08a969b696$var$SourceEntitiesBox({ searchProps: { pathname: pathname, parameters: parameters }, selectedEntities: selectedEntities, onChange: onChange, emptyPlaceholder: emptyPlaceholder, renderEntity: renderEntity }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [page, setPage] = (0, $jC8Vy.useState)(1);
    const [keyword, setKeyword] = (0, $jC8Vy.useState)("");
    const debounce = (0, $fe972dea93e1e243$export$2e2bcd8739ae039)();
    const commonSearchParams = {
        page: String(page),
        page_size: String($ae637b08a969b696$var$pageSize),
        ...(0, $7oDSS.conditional)(keyword && {
            search: (0, $7kooT.formatSearchKeyword)(keyword)
        })
    };
    const { data: data, error: error } = (0, $voszV.default)((0, $7kooT.buildUrl)(pathname, {
        ...parameters,
        ...commonSearchParams
    }));
    const isLoading = !data && !error;
    const [dataSource = [], totalCount] = data ?? [];
    const handleSearchInput = (event)=>{
        debounce(()=>{
            setPage(1);
            setKeyword(event.target.value);
        });
    };
    const isEntityAdded = (entity)=>selectedEntities.findIndex(({ id: id })=>id === entity.id) >= 0;
    const isEmpty = !isLoading && !error && dataSource.length === 0;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $1c26dd25fa3ad36d$export$827f4ee28efc37,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $1c26dd25fa3ad36d$export$9f6c77b8cdee9051,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                    className: $f63ccb147771317e$export$d76128d007d19019,
                    icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $45ba7f7cad465e3f$export$2e2bcd8739ae039), {
                        className: $f63ccb147771317e$export$1ca1ec8b29a4ce27
                    }),
                    placeholder: t("general.search_placeholder"),
                    onChange: handleSearchInput
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($1c26dd25fa3ad36d$export$a03f626b8106969c, isEmpty && $1c26dd25fa3ad36d$export$2d49e08edfff676e),
                children: isEmpty ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a0f84bc7cc69e410$export$2e2bcd8739ae039), {
                    size: "small",
                    title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                        forKey: emptyPlaceholder
                    })
                }) : dataSource.map((entity)=>{
                    const isSelected = isEntityAdded(entity);
                    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $efbe229a2b32c333$export$2e2bcd8739ae039), {
                        entity: entity,
                        isSelected: isSelected,
                        render: renderEntity,
                        onSelect: ()=>{
                            onChange(isSelected ? selectedEntities.filter(({ id: id })=>entity.id !== id) : [
                                entity,
                                ...selectedEntities
                            ]);
                        }
                    }, entity.id);
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $54e9f57962fc2e08$export$2e2bcd8739ae039), {
                mode: "pico",
                page: page,
                totalCount: totalCount,
                pageSize: $ae637b08a969b696$var$pageSize,
                className: $1c26dd25fa3ad36d$export$eda11a42e6b44edc,
                onChange: (page)=>{
                    setPage(page);
                }
            })
        ]
    });
}
var $ae637b08a969b696$export$2e2bcd8739ae039 = $ae637b08a969b696$var$SourceEntitiesBox;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");


var $C7mD2 = parcelRequire("C7mD2");

var $HHYyb = parcelRequire("HHYyb");

var $75SRw = parcelRequire("75SRw");
var $423d18de11b0245c$export$1ca1ec8b29a4ce27;
var $423d18de11b0245c$export$7061c75fc5af8b7e;
var $423d18de11b0245c$export$6990040ee07315;
var $423d18de11b0245c$export$bfd64c937657f93a;
var $423d18de11b0245c$export$4a6dd88bada4e7d2;
var $423d18de11b0245c$export$9c4e203df590c544;
var $423d18de11b0245c$export$fb184b623420d9be;
$423d18de11b0245c$export$1ca1ec8b29a4ce27 = `-f8eNq_icon`;
$423d18de11b0245c$export$7061c75fc5af8b7e = `-f8eNq_item`;
$423d18de11b0245c$export$6990040ee07315 = `-f8eNq_meta`;
$423d18de11b0245c$export$bfd64c937657f93a = `-f8eNq_rotating`;
$423d18de11b0245c$export$4a6dd88bada4e7d2 = `-f8eNq_shimmer`;
$423d18de11b0245c$export$9c4e203df590c544 = `-f8eNq_suspended`;
$423d18de11b0245c$export$fb184b623420d9be = `-f8eNq_title`;


function $46db2ec9322f4b07$var$TargetEntityItem({ entity: entity, render: render, onDelete: onDelete }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $423d18de11b0245c$export$7061c75fc5af8b7e,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $423d18de11b0245c$export$6990040ee07315,
                children: render(entity)
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                size: "small",
                onClick: ()=>{
                    onDelete();
                },
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $HHYyb.default), {})
            })
        ]
    });
}
var $46db2ec9322f4b07$export$2e2bcd8739ae039 = $46db2ec9322f4b07$var$TargetEntityItem;


var $9082c710d66f2767$export$80f73db1a407fae0;
$9082c710d66f2767$export$80f73db1a407fae0 = `OoY2hq_added`;


function $d938ae06f1fcb418$var$TargetEntitiesBox({ renderEntity: renderEntity, selectedEntities: selectedEntities, onChange: onChange }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $1c26dd25fa3ad36d$export$827f4ee28efc37,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $1c26dd25fa3ad36d$export$9f6c77b8cdee9051,
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("span", {
                    className: $9082c710d66f2767$export$80f73db1a407fae0,
                    children: [
                        `${selectedEntities.length} `,
                        t("general.added")
                    ]
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $1c26dd25fa3ad36d$export$a03f626b8106969c,
                children: selectedEntities.map((entity)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $46db2ec9322f4b07$export$2e2bcd8739ae039), {
                        entity: entity,
                        render: renderEntity,
                        onDelete: ()=>{
                            onChange(selectedEntities.filter(({ id: id })=>id !== entity.id));
                        }
                    }, entity.id))
            })
        ]
    });
}
var $d938ae06f1fcb418$export$2e2bcd8739ae039 = $d938ae06f1fcb418$var$TargetEntitiesBox;


var $16cbd0070759f903$export$493b5823483d2c4e;
var $16cbd0070759f903$export$a9c4b5b7bc92a147;
var $16cbd0070759f903$export$bfd64c937657f93a;
var $16cbd0070759f903$export$4a6dd88bada4e7d2;
$16cbd0070759f903$export$493b5823483d2c4e = `zPwfGa_errorMessage`;
$16cbd0070759f903$export$a9c4b5b7bc92a147 = `zPwfGa_rolesTransfer`;
$16cbd0070759f903$export$bfd64c937657f93a = `zPwfGa_rotating`;
$16cbd0070759f903$export$4a6dd88bada4e7d2 = `zPwfGa_shimmer`;


function $133dd77f608c23b1$var$EntitiesTransfer({ errorMessage: errorMessage, ...props }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($1c26dd25fa3ad36d$export$34e0f9847d4c02dd, $16cbd0070759f903$export$a9c4b5b7bc92a147),
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ae637b08a969b696$export$2e2bcd8739ae039), {
                        ...props
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $1c26dd25fa3ad36d$export$d999e528e771887b
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $d938ae06f1fcb418$export$2e2bcd8739ae039), {
                        ...props
                    })
                ]
            }),
            errorMessage && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $16cbd0070759f903$export$493b5823483d2c4e,
                children: errorMessage
            })
        ]
    });
}
var $133dd77f608c23b1$export$2e2bcd8739ae039 = $133dd77f608c23b1$var$EntitiesTransfer;



var $C7mD2 = parcelRequire("C7mD2");




var $ea6594964de2efcf$export$1ca1ec8b29a4ce27;
var $ea6594964de2efcf$export$bfd64c937657f93a;
var $ea6594964de2efcf$export$4a6dd88bada4e7d2;
var $ea6594964de2efcf$export$9c4e203df590c544;
var $ea6594964de2efcf$export$fb184b623420d9be;
$ea6594964de2efcf$export$1ca1ec8b29a4ce27 = `da450q_icon`;
$ea6594964de2efcf$export$bfd64c937657f93a = `da450q_rotating`;
$ea6594964de2efcf$export$4a6dd88bada4e7d2 = `da450q_shimmer`;
$ea6594964de2efcf$export$9c4e203df590c544 = `da450q_suspended`;
$ea6594964de2efcf$export$fb184b623420d9be = `da450q_title`;


function $e542aa41315bcd92$export$7d5b61b2bb96bf4d({ entity: entity }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e999fd6c93542895$export$2e2bcd8739ae039), {
                hasTooltip: true,
                user: entity,
                size: "micro"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $ea6594964de2efcf$export$fb184b623420d9be,
                children: (0, $46451cbb59c7a857$export$5f7a1baecd59f846)(entity)
            }),
            entity.isSuspended && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6f644f560eac971b$export$2e2bcd8739ae039), {
                className: $ea6594964de2efcf$export$9c4e203df590c544
            })
        ]
    });
}
function $e542aa41315bcd92$export$a42ffac851fa6a76({ entity: entity }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e07e369caa387826$export$2e2bcd8739ae039), {
                type: entity.type,
                className: $ea6594964de2efcf$export$1ca1ec8b29a4ce27
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $ea6594964de2efcf$export$fb184b623420d9be,
                children: entity.name
            })
        ]
    });
}




var $jGWQ4 = parcelRequire("jGWQ4");

var $8R7rc = parcelRequire("8R7rc");

var $aqmjm = parcelRequire("aqmjm");

var $5vVWy = parcelRequire("5vVWy");


var $7VnwS = parcelRequire("7VnwS");

var $dW2kG = parcelRequire("dW2kG");

var $5OcFi = parcelRequire("5OcFi");
function $8a62fa84d38f8e93$var$AddMembersToOrganization({ organization: organization, isOpen: isOpen, onClose: onClose }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const tAction = (0, $9fca41f2a64ee9e4$export$2e2bcd8739ae039)();
    const api = (0, $7VnwS.default)();
    const { reset: reset, control: control, handleSubmit: handleSubmit, formState: { isSubmitting: isSubmitting } } = (0, $codQP.useForm)({
        defaultValues: {
            users: [],
            scopes: []
        }
    });
    const [keyword, setKeyword] = (0, $jC8Vy.useState)("");
    const onSubmit = handleSubmit((0, $5OcFi.trySubmitSafe)(async (data)=>{
        await api.post(`api/organizations/${organization.id}/users`, {
            json: {
                userIds: data.users.map(({ id: id })=>id)
            }
        });
        if (data.scopes.length > 0) await api.post(`api/organizations/${organization.id}/users/roles`, {
            json: {
                userIds: data.users.map(({ id: id })=>id),
                organizationRoleIds: data.scopes.map(({ value: value })=>value)
            }
        });
        onClose();
    }));
    (0, $jC8Vy.useEffect)(()=>{
        if (isOpen) {
            reset();
            setKeyword("");
        }
    }, [
        isOpen,
        reset
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        isOpen: isOpen,
        className: $dW2kG.content,
        overlayClassName: $dW2kG.overlay,
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $5vVWy.default), {
            size: "large",
            title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8R7rc.default), {
                children: t("organization_details.add_members_to_organization", {
                    name: organization.name
                })
            }),
            subtitle: "organization_details.add_members_to_organization_description",
            footer: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                isLoading: isSubmitting,
                size: "large",
                type: "primary",
                title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $C7mD2.Fragment), {
                    children: tAction("add", "organization_details.member_other")
                }),
                onClick: onSubmit
            }),
            onClose: onClose,
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                    title: "organization_details.member_other",
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                        name: "users",
                        control: control,
                        rules: {
                            validate: (value)=>{
                                if (value.length === 0) return t("organization_details.at_least_one_user");
                                return true;
                            }
                        },
                        render: ({ field: { onChange: onChange, value: value }, fieldState: { error: error } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $133dd77f608c23b1$export$2e2bcd8739ae039), {
                                errorMessage: error?.message,
                                searchProps: {
                                    pathname: "api/users",
                                    parameters: {
                                        excludeOrganizationId: organization.id
                                    }
                                },
                                selectedEntities: value,
                                emptyPlaceholder: "errors.empty",
                                renderEntity: (entity)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $e542aa41315bcd92$export$7d5b61b2bb96bf4d), {
                                        entity: entity
                                    }),
                                onChange: onChange
                            })
                    })
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                    title: "organization_details.add_with_organization_role",
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                        name: "scopes",
                        control: control,
                        render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $be4f434fcf26f56b$export$2e2bcd8739ae039), {
                                keyword: keyword,
                                setKeyword: setKeyword,
                                value: value,
                                onChange: onChange
                            })
                    })
                })
            ]
        })
    });
}
var $8a62fa84d38f8e93$export$2e2bcd8739ae039 = $8a62fa84d38f8e93$var$AddMembersToOrganization;



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $kUZ14 = parcelRequire("kUZ14");


var $jGWQ4 = parcelRequire("jGWQ4");

var $aqmjm = parcelRequire("aqmjm");

var $5vVWy = parcelRequire("5vVWy");

var $7VnwS = parcelRequire("7VnwS");

var $dW2kG = parcelRequire("dW2kG");

function $ea444d01cb9c41c3$var$EditOrganizationRolesModal({ organizationId: organizationId, user: user, isOpen: isOpen, onClose: onClose }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [keyword, setKeyword] = (0, $jC8Vy.useState)("");
    const [roles, setRoles] = (0, $jC8Vy.useState)(user.organizationRoles.map(({ id: id, name: name })=>({
            value: id,
            title: name
        })));
    const name = user.name ?? (0, $ed226b81b3190522$export$da1930f05c3ce270)(t("organization_details.user"));
    const [isLoading, setIsLoading] = (0, $jC8Vy.useState)(false);
    const api = (0, $7VnwS.default)();
    const onSubmit = async ()=>{
        setIsLoading(true);
        try {
            await api.put(`api/organizations/${organizationId}/users/${user.id}/roles`, {
                json: {
                    organizationRoleIds: roles.map(({ value: value })=>value)
                }
            });
            onClose();
        } finally{
            setIsLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        isOpen: isOpen,
        className: $dW2kG.content,
        overlayClassName: $dW2kG.overlay,
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5vVWy.default), {
            title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $C7mD2.Fragment), {
                children: t("organization_details.edit_organization_roles_of_user", {
                    name: name
                })
            }),
            subtitle: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $C7mD2.Fragment), {
                children: t("organization_details.authorize_to_roles", {
                    name: name
                })
            }),
            footer: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                size: "large",
                type: "primary",
                title: "general.save",
                isLoading: isLoading,
                onClick: onSubmit
            }),
            onClose: onClose,
            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: "organizations.organization_role_other",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $be4f434fcf26f56b$export$2e2bcd8739ae039), {
                    value: roles,
                    keyword: keyword,
                    setKeyword: setKeyword,
                    onChange: setRoles
                })
            })
        })
    });
}
var $ea444d01cb9c41c3$export$2e2bcd8739ae039 = $ea444d01cb9c41c3$var$EditOrganizationRolesModal;


var $64887b6429dbc7d4$export$3dea766d36a8935f;
var $64887b6429dbc7d4$export$8e77a375f9a5908e;
var $64887b6429dbc7d4$export$bfd64c937657f93a;
var $64887b6429dbc7d4$export$4a6dd88bada4e7d2;
$64887b6429dbc7d4$export$3dea766d36a8935f = `HFfI9G_filter`;
$64887b6429dbc7d4$export$8e77a375f9a5908e = `HFfI9G_roles`;
$64887b6429dbc7d4$export$bfd64c937657f93a = `HFfI9G_rotating`;
$64887b6429dbc7d4$export$4a6dd88bada4e7d2 = `HFfI9G_shimmer`;


const $ff3ea3c50665afca$var$pageSize = (0, $8Mb3E.defaultPageSize);
function $ff3ea3c50665afca$var$Members() {
    const { data: organization } = (0, $2Phw0.useOutletContext)();
    const api = (0, $7VnwS.default)();
    const [keyword, setKeyword] = (0, $jC8Vy.useState)("");
    const [page, setPage] = (0, $jC8Vy.useState)(1);
    const { data: response, error: error, mutate: mutate } = (0, $voszV.default)((0, $7kooT.buildUrl)(`api/organizations/${organization.id}/users`, {
        q: keyword,
        page: String(page),
        page_size: String($ff3ea3c50665afca$var$pageSize)
    }));
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const tAction = (0, $9fca41f2a64ee9e4$export$2e2bcd8739ae039)();
    const [isModalOpen, setIsModalOpen] = (0, $jC8Vy.useState)(false);
    const [userToBeEdited, setUserToBeEdited] = (0, $jC8Vy.useState)();
    const isLoading = !response && !error;
    const [data, totalCount] = response ?? [];
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3166f28a681c41bb$export$2e2bcd8739ae039), {
                isRowHoverEffectDisabled: true,
                placeholder: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a0f84bc7cc69e410$export$2e2bcd8739ae039), {}),
                pagination: {
                    page: page,
                    totalCount: totalCount,
                    pageSize: $ff3ea3c50665afca$var$pageSize,
                    onChange: setPage
                },
                isLoading: isLoading,
                errorMessage: error?.toString(),
                rowGroups: [
                    {
                        key: "data",
                        data: data
                    }
                ],
                columns: [
                    {
                        dataIndex: "user",
                        title: "User",
                        colSpan: 4,
                        render: (user)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $55e437438f7e6e4f$export$2e2bcd8739ae039), {
                                user: user
                            })
                    },
                    {
                        dataIndex: "roles",
                        title: "Organization roles",
                        colSpan: 6,
                        render: ({ organizationRoles: organizationRoles })=>{
                            if (organizationRoles.length === 0) return "-";
                            return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $64887b6429dbc7d4$export$8e77a375f9a5908e,
                                children: organizationRoles.map(({ id: id, name: name })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
                                        variant: "cell",
                                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $be4f434fcf26f56b$export$9b2040b3fe7f4e3f), {
                                            value: id,
                                            title: name
                                        })
                                    }, id))
                            });
                        }
                    },
                    {
                        dataIndex: "lastSignInAt",
                        title: "Last sign-in",
                        colSpan: 5,
                        render: ({ lastSignInAt: lastSignInAt })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $5bc18cf18674bbc6$export$2e2bcd8739ae039), {
                                children: lastSignInAt
                            })
                    },
                    {
                        dataIndex: "actions",
                        title: null,
                        colSpan: 1,
                        render: (user)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $d6ac1a830c94487b$export$2e2bcd8739ae039), {
                                deleteConfirmation: "organization_details.remove_user_from_organization_description",
                                fieldName: "organization_details.user",
                                textOverrides: {
                                    edit: "organization_details.edit_organization_roles",
                                    delete: "organization_details.remove_user_from_organization",
                                    deleteConfirmation: "general.remove"
                                },
                                onEdit: ()=>{
                                    setUserToBeEdited(user);
                                },
                                onDelete: async ()=>{
                                    await api.delete(`api/organizations/${organization.id}/users/${user.id}`);
                                    mutate();
                                }
                            })
                    }
                ],
                rowIndexKey: "id",
                filter: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: $64887b6429dbc7d4$export$3dea766d36a8935f,
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $46c375e0973aedf1$export$2e2bcd8739ae039), {
                            defaultValue: keyword,
                            isClearable: Boolean(keyword),
                            placeholder: t("organization_details.search_user_placeholder"),
                            onSearch: (value)=>{
                                setKeyword(value);
                                setPage(1);
                            },
                            onClearSearch: ()=>{
                                setKeyword("");
                                setPage(1);
                            }
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                            size: "large",
                            title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8R7rc.default), {
                                children: tAction("add", "organization_details.member")
                            }),
                            type: "primary",
                            icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0b30fe81c923292b$export$2e2bcd8739ae039), {}),
                            onClick: ()=>{
                                setIsModalOpen(true);
                            }
                        })
                    ]
                })
            }),
            userToBeEdited && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ea444d01cb9c41c3$export$2e2bcd8739ae039), {
                isOpen: true,
                organizationId: organization.id,
                user: userToBeEdited,
                onClose: ()=>{
                    setUserToBeEdited(undefined);
                    mutate();
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8a62fa84d38f8e93$export$2e2bcd8739ae039), {
                organization: organization,
                isOpen: isModalOpen,
                onClose: ()=>{
                    setIsModalOpen(false);
                    mutate();
                }
            })
        ]
    });
}
var $ff3ea3c50665afca$export$2e2bcd8739ae039 = $ff3ea3c50665afca$var$Members;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $3dBAh = parcelRequire("3dBAh");

var $codQP = parcelRequire("codQP");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $2Phw0 = parcelRequire("2Phw0");




var $kUskP = parcelRequire("kUskP");

var $aqmjm = parcelRequire("aqmjm");

var $fmHmG = parcelRequire("fmHmG");

var $7VnwS = parcelRequire("7VnwS");

var $5OcFi = parcelRequire("5OcFi");
const $6454b4be12ac8b17$var$isJsonObject = (value)=>{
    const parsed = (0, $3dBAh.trySafe)(()=>JSON.parse(value));
    return Boolean(parsed && typeof parsed === "object");
};
const $6454b4be12ac8b17$var$normalizeData = (data)=>({
        ...data,
        customData: JSON.stringify(data.customData, undefined, 2)
    });
const $6454b4be12ac8b17$var$assembleData = (data)=>({
        ...data,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        customData: JSON.parse(data.customData ?? "{}")
    });
function $6454b4be12ac8b17$var$Settings() {
    const { isDeleting: isDeleting, data: data, onUpdated: onUpdated } = (0, $2Phw0.useOutletContext)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { register: register, reset: reset, control: control, handleSubmit: handleSubmit, formState: { isDirty: isDirty, isSubmitting: isSubmitting, errors: errors } } = (0, $codQP.useForm)({
        defaultValues: $6454b4be12ac8b17$var$normalizeData(data)
    });
    const api = (0, $7VnwS.default)();
    const onSubmit = handleSubmit((0, $5OcFi.trySubmitSafe)(async (data)=>{
        if (isSubmitting) return;
        const updatedData = await api.patch(`api/organizations/${data.id}`, {
            json: $6454b4be12ac8b17$var$assembleData(data)
        }).json();
        reset($6454b4be12ac8b17$var$normalizeData(updatedData));
        (0, $FuhPC.toast).success(t("general.saved"));
        onUpdated(updatedData);
    }));
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $f0e7fd6d3bded790$export$2e2bcd8739ae039), {
        isDirty: isDirty,
        isSubmitting: isSubmitting,
        onDiscard: reset,
        onSubmit: onSubmit,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
                title: "general.settings_nav",
                description: "organization_details.settings_description",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        isRequired: true,
                        title: "general.name",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                            placeholder: t("organization_details.name_placeholder"),
                            error: Boolean(errors.name),
                            ...register("name", {
                                required: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        title: "general.description",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                            placeholder: t("organization_details.description_placeholder"),
                            ...register("description")
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        title: "organization_details.custom_data",
                        tip: t("organization_details.custom_data_tip"),
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                            name: "customData",
                            control: control,
                            rules: {
                                validate: (value)=>$6454b4be12ac8b17$var$isJsonObject(value ?? "") ? true : t("organization_details.invalid_json_object")
                            },
                            render: ({ field: field })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $kUskP.default), {
                                    language: "json",
                                    ...field,
                                    error: errors.customData?.message
                                })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fea55fa5d5726e29$export$2e2bcd8739ae039), {
                hasUnsavedChanges: !isDeleting && isDirty
            })
        ]
    });
}
var $6454b4be12ac8b17$export$2e2bcd8739ae039 = $6454b4be12ac8b17$var$Settings;




var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $lXQZH = parcelRequire("lXQZH");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");


var $5TsIB = parcelRequire("5TsIB");
parcelRequire("8Mb3E");
var $cfL6o = parcelRequire("cfL6o");

var $8TpMk = parcelRequire("8TpMk");



var $cDKfs = parcelRequire("cDKfs");

var $jGWQ4 = parcelRequire("jGWQ4");

var $gC7hG = parcelRequire("gC7hG");

var $18SWy = parcelRequire("18SWy");


var $4ZcUR = parcelRequire("4ZcUR");


var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $kUZ14 = parcelRequire("kUZ14");



var $8TpMk = parcelRequire("8TpMk");


var $jGWQ4 = parcelRequire("jGWQ4");

var $aqmjm = parcelRequire("aqmjm");

var $5vVWy = parcelRequire("5vVWy");

var $fmHmG = parcelRequire("fmHmG");

var $7VnwS = parcelRequire("7VnwS");

var $dW2kG = parcelRequire("dW2kG");

var $5OcFi = parcelRequire("5OcFi");
function $2e75010407b3c865$var$CreateOrganizationModal({ isOpen: isOpen, onClose: onClose }) {
    const api = (0, $7VnwS.default)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { currentPlan: currentPlan } = (0, $jC8Vy.useContext)((0, $19434c930f80c964$export$f8addfd4ab69c833));
    const isOrganizationsDisabled = (0, $8TpMk.isCloud) && !currentPlan.quota.organizationsEnabled;
    const { reset: reset, register: register, handleSubmit: handleSubmit, formState: { errors: errors, isSubmitting: isSubmitting } } = (0, $codQP.useForm)();
    const submit = handleSubmit((0, $5OcFi.trySubmitSafe)(async (json)=>{
        const { id: id } = await api.post("api/organizations", {
            json: json
        }).json();
        onClose(id);
    }));
    // Reset form on open
    (0, $jC8Vy.useEffect)(()=>{
        if (isOpen) reset({});
    }, [
        isOpen,
        reset
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        isOpen: isOpen,
        className: $dW2kG.content,
        overlayClassName: $dW2kG.overlay,
        onRequestClose: ()=>{
            onClose();
        },
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5vVWy.default), {
            title: "organizations.create_organization",
            footer: isOrganizationsDisabled ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dafa1bad5a99c1ae$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                    components: {
                        a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a3bc63325dc3c1a8$export$2e2bcd8739ae039), {})
                    },
                    children: t("upsell.paywall.organizations")
                })
            }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                type: "primary",
                title: "general.create",
                isLoading: isSubmitting,
                onClick: submit
            }),
            onClose: onClose,
            children: /*#__PURE__*/ (0, $C7mD2.jsxs)("form", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        isRequired: true,
                        title: "general.name",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                            // eslint-disable-next-line jsx-a11y/no-autofocus
                            autoFocus: true,
                            placeholder: t("organizations.organization_name_placeholder"),
                            error: Boolean(errors.name),
                            ...register("name", {
                                required: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        title: "general.description",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                            error: Boolean(errors.description),
                            placeholder: t("organizations.organization_description_placeholder"),
                            ...register("description")
                        })
                    })
                ]
            })
        })
    });
}
var $2e75010407b3c865$export$2e2bcd8739ae039 = $2e75010407b3c865$var$CreateOrganizationModal;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
parcelRequire("12bMu");
var $gcHb7 = parcelRequire("gcHb7");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $voszV = parcelRequire("voszV");





var $8Mb3E = parcelRequire("8Mb3E");

var $cw2No = parcelRequire("cw2No");



var $4ZcUR = parcelRequire("4ZcUR");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");

var $5UrGx = parcelRequire("5UrGx");



var $66ixW = parcelRequire("66ixW");
var $23df7c1b0b264d32$export$fae01a4f5c829e19;
var $23df7c1b0b264d32$export$345c5736c8054f22;
var $23df7c1b0b264d32$export$31d6f2c3562ba09e;
var $23df7c1b0b264d32$export$85b9a36db797e02b;
var $23df7c1b0b264d32$export$6e22c362a0406a2c;
var $23df7c1b0b264d32$export$5345fd892b40e1f6;
var $23df7c1b0b264d32$export$bfd64c937657f93a;
var $23df7c1b0b264d32$export$4a6dd88bada4e7d2;
$23df7c1b0b264d32$export$fae01a4f5c829e19 = `UErFpq_applicationIcon`;
$23df7c1b0b264d32$export$345c5736c8054f22 = `UErFpq_avatar`;
$23df7c1b0b264d32$export$31d6f2c3562ba09e = `UErFpq_avatars`;
$23df7c1b0b264d32$export$85b9a36db797e02b = `UErFpq_count`;
$23df7c1b0b264d32$export$6e22c362a0406a2c = `UErFpq_empty`;
$23df7c1b0b264d32$export$5345fd892b40e1f6 = `UErFpq_entities`;
$23df7c1b0b264d32$export$bfd64c937657f93a = `UErFpq_rotating`;
$23df7c1b0b264d32$export$4a6dd88bada4e7d2 = `UErFpq_shimmer`;


function $c0759582e0649a0d$var$AssignedEntities({ entities: entities, count: count, type: type }) {
    return count ? /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $23df7c1b0b264d32$export$5345fd892b40e1f6,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $23df7c1b0b264d32$export$31d6f2c3562ba09e,
                children: entities.map((entity)=>type === (0, $61Yml.RoleType).User ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e999fd6c93542895$export$2e2bcd8739ae039), {
                        className: $23df7c1b0b264d32$export$345c5736c8054f22,
                        user: entity,
                        size: "small"
                    }, entity.id) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e07e369caa387826$export$2e2bcd8739ae039), {
                        type: (0, $61Yml.ApplicationType).MachineToMachine,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($23df7c1b0b264d32$export$fae01a4f5c829e19, $23df7c1b0b264d32$export$345c5736c8054f22)
                    }, entity.id))
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                className: $23df7c1b0b264d32$export$85b9a36db797e02b,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                    forKey: count >= 2 ? type === (0, $61Yml.RoleType).User ? "roles.user_counts" : "roles.application_counts" : type === (0, $61Yml.RoleType).User ? "roles.user_count" : "roles.application_count",
                    interpolation: {
                        count: count
                    }
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: $23df7c1b0b264d32$export$6e22c362a0406a2c,
        children: "-"
    });
}
var $c0759582e0649a0d$export$2e2bcd8739ae039 = $c0759582e0649a0d$var$AssignedEntities;




var $7kooT = parcelRequire("7kooT");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");




var $jGWQ4 = parcelRequire("jGWQ4");


var $jheqv = parcelRequire("jheqv");
var $d6beb9b5edf86813$export$2ba01fb71ed41cb6;
var $d6beb9b5edf86813$export$5c452ff88e35e47d;
var $d6beb9b5edf86813$export$c7187bbd1a7a9244;
var $d6beb9b5edf86813$export$bfd64c937657f93a;
var $d6beb9b5edf86813$export$4a6dd88bada4e7d2;
var $d6beb9b5edf86813$export$6f093cfa640b7166;
var $d6beb9b5edf86813$export$fb184b623420d9be;
$d6beb9b5edf86813$export$2ba01fb71ed41cb6 = `MBDhfG_button`;
$d6beb9b5edf86813$export$5c452ff88e35e47d = `MBDhfG_image`;
$d6beb9b5edf86813$export$c7187bbd1a7a9244 = `MBDhfG_placeholder`;
$d6beb9b5edf86813$export$bfd64c937657f93a = `MBDhfG_rotating`;
$d6beb9b5edf86813$export$4a6dd88bada4e7d2 = `MBDhfG_shimmer`;
$d6beb9b5edf86813$export$6f093cfa640b7166 = `MBDhfG_text`;
$d6beb9b5edf86813$export$fb184b623420d9be = `MBDhfG_title`;


function $e8770b6667fd025a$var$EmptyDataPlaceholder({ buttonProps: buttonProps }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.organizations"
    });
    const { configs: configs } = (0, $dad5317382253f6d$export$2e2bcd8739ae039)();
    const theme = (0, $jheqv.default)();
    const PlaceholderImage = theme === (0, $5HVJe.Theme).Light ? (0, $ef008b0357de52f9$export$2e2bcd8739ae039) : (0, $0807787c5f5c1b37$export$2e2bcd8739ae039);
    const isInitialSetup = !configs?.organizationCreated;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $d6beb9b5edf86813$export$c7187bbd1a7a9244,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)(PlaceholderImage, {
                className: $d6beb9b5edf86813$export$5c452ff88e35e47d
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $d6beb9b5edf86813$export$fb184b623420d9be,
                children: t("organization_list_placeholder_title")
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $d6beb9b5edf86813$export$6f093cfa640b7166,
                children: t("organization_list_placeholder_text")
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                className: $d6beb9b5edf86813$export$2ba01fb71ed41cb6,
                type: "primary",
                size: "large",
                icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0b30fe81c923292b$export$2e2bcd8739ae039), {}),
                title: isInitialSetup ? "organizations.setup_organization" : "organizations.create_organization",
                ...buttonProps
            })
        ]
    });
}
var $e8770b6667fd025a$export$2e2bcd8739ae039 = $e8770b6667fd025a$var$EmptyDataPlaceholder;


/** The page size of the organizations table. */ const $b4389372c011be78$var$pageSize = (0, $8Mb3E.defaultPageSize);
/** The organizations page root pathname. */ const $b4389372c011be78$var$pathname = "/organizations";
/** The organizations API pathname in the management API. */ const $b4389372c011be78$var$apiPathname = "api/organizations";
function $b4389372c011be78$var$OrganizationsTable({ onCreate: onCreate }) {
    const [keyword, setKeyword] = (0, $jC8Vy.useState)("");
    const [page, setPage] = (0, $jC8Vy.useState)(1);
    const { data: response, error: error } = (0, $voszV.default)((0, $7kooT.buildUrl)($b4389372c011be78$var$apiPathname, {
        q: keyword,
        showFeatured: "1",
        page: String(page),
        page_size: String($b4389372c011be78$var$pageSize)
    }));
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const isTableLoading = !response && !error;
    const [data, totalCount] = response ?? [
        [],
        0
    ];
    const { navigate: navigate } = (0, $4ZcUR.default)();
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3166f28a681c41bb$export$2e2bcd8739ae039), {
        className: $7ddbeb184b5d4257$export$9852986a3ec5f6a0,
        isLoading: isTableLoading,
        placeholder: keyword ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a0f84bc7cc69e410$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e8770b6667fd025a$export$2e2bcd8739ae039), {
            buttonProps: {
                title: "organizations.create_organization",
                onClick: onCreate
            }
        }),
        rowGroups: [
            {
                key: "data",
                data: data
            }
        ],
        rowClickHandler: ({ id: id })=>{
            navigate((0, $gcHb7.joinPath)($b4389372c011be78$var$pathname, id));
        },
        columns: [
            {
                title: t("general.name"),
                dataIndex: "name",
                render: ({ name: name, id: id })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $4d952cae22cb03fc$export$2e2bcd8739ae039), {
                        title: name,
                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c1fc6cc4be9e0c9a$export$2e2bcd8739ae039), {
                            for: (0, $fa5532faa4d9cc63$export$2e2bcd8739ae039)
                        }),
                        to: (0, $gcHb7.joinPath)($b4389372c011be78$var$pathname, id)
                    })
            },
            {
                title: t("organizations.organization_id"),
                dataIndex: "id",
                render: ({ id: id })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
                        value: id,
                        variant: "text"
                    })
            },
            {
                title: t("organizations.members"),
                dataIndex: "members",
                render: ({ usersCount: usersCount, featuredUsers: featuredUsers })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $c0759582e0649a0d$export$2e2bcd8739ae039), {
                        type: (0, $61Yml.RoleType).User,
                        entities: featuredUsers ?? [],
                        count: usersCount ?? 0
                    })
            }
        ],
        rowIndexKey: "id",
        pagination: {
            page: page,
            totalCount: totalCount,
            pageSize: $b4389372c011be78$var$pageSize,
            onChange: setPage
        },
        filter: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $46c375e0973aedf1$export$2e2bcd8739ae039), {
            defaultValue: keyword,
            isClearable: Boolean(keyword),
            placeholder: t("organizations.search_placeholder"),
            onSearch: (value)=>{
                setKeyword(value);
                setPage(1);
            },
            onClearSearch: ()=>{
                setKeyword("");
                setPage(1);
            }
        })
    });
}
var $b4389372c011be78$export$2e2bcd8739ae039 = $b4389372c011be78$var$OrganizationsTable;



var $d69ab80ab0bcd596$export$d2728412f6b340a9;
var $d69ab80ab0bcd596$export$bfd64c937657f93a;
var $d69ab80ab0bcd596$export$4a6dd88bada4e7d2;
var $d69ab80ab0bcd596$export$39f5674517ec0000;
$d69ab80ab0bcd596$export$d2728412f6b340a9 = `ynTgOa_emptyCardContainer`;
$d69ab80ab0bcd596$export$bfd64c937657f93a = `ynTgOa_rotating`;
$d69ab80ab0bcd596$export$4a6dd88bada4e7d2 = `ynTgOa_shimmer`;
$d69ab80ab0bcd596$export$39f5674517ec0000 = `ynTgOa_tabs`;


const $57cb847faf2f9051$var$organizationsPathname = "/organizations";
function $57cb847faf2f9051$var$Organizations() {
    const { getDocumentationUrl: getDocumentationUrl } = (0, $b595fc2f0eccd19a$export$2e2bcd8739ae039)();
    const { currentPlan: currentPlan } = (0, $jC8Vy.useContext)((0, $19434c930f80c964$export$f8addfd4ab69c833));
    const { isDevTenant: isDevTenant } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const [isCreating, setIsCreating] = (0, $jC8Vy.useState)(false);
    const isOrganizationsDisabled = (0, $8TpMk.isCloud) && !currentPlan.quota.organizationsEnabled;
    const upgradePlan = (0, $jC8Vy.useCallback)(()=>{
        navigate((0, $b2864970cb73ddbd$export$6d940d0d58a60bc4));
    }, [
        navigate
    ]);
    const handleCreate = ()=>{
        setIsCreating(true);
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $7ddbeb184b5d4257$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2e75010407b3c865$export$2e2bcd8739ae039), {
                isOpen: isCreating,
                onClose: (createdId)=>{
                    if (createdId) {
                        navigate($57cb847faf2f9051$var$organizationsPathname + `/${createdId}`);
                        return;
                    }
                    setIsCreating(false);
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5TsIB.default), {
                titleKey: "organizations.page_title"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $7ddbeb184b5d4257$export$516dd90aeaaabcf0,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $18SWy.default), {
                        paywall: (0, $7oDSS.cond)((isOrganizationsDisabled || isDevTenant) && (0, $lXQZH.ReservedPlanId).Pro),
                        title: "organizations.title",
                        subtitle: "organizations.subtitle",
                        learnMoreLink: {
                            href: getDocumentationUrl((0, $cfL6o.organizationsFeatureLink)),
                            targetBlank: "noopener"
                        }
                    }),
                    !isOrganizationsDisabled && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0b30fe81c923292b$export$2e2bcd8739ae039), {}),
                        type: "primary",
                        size: "large",
                        title: "organizations.create_organization",
                        onClick: handleCreate
                    })
                ]
            }),
            isOrganizationsDisabled && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $gC7hG.default), {
                className: $d69ab80ab0bcd596$export$d2728412f6b340a9,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e8770b6667fd025a$export$2e2bcd8739ae039), {
                    buttonProps: {
                        title: "upsell.upgrade_plan",
                        onClick: upgradePlan,
                        // Set to `undefined` to override the default icon
                        icon: undefined
                    }
                })
            }),
            !isOrganizationsDisabled && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $b4389372c011be78$export$2e2bcd8739ae039), {
                onCreate: handleCreate
            })
        ]
    });
}
var $57cb847faf2f9051$export$2e2bcd8739ae039 = $57cb847faf2f9051$var$Organizations;


const $23b66b8a4660b99c$export$fe0f87d711783637 = {
    path: "organizations",
    children: (0, $7oDSS.condArray)({
        index: true,
        element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $57cb847faf2f9051$export$2e2bcd8739ae039), {})
    }, {
        path: "create",
        element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $57cb847faf2f9051$export$2e2bcd8739ae039), {})
    }, {
        path: ":id/*",
        element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a10636997a9c033b$export$2e2bcd8739ae039), {}),
        children: [
            {
                index: true,
                element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Navigate), {
                    replace: true,
                    to: (0, $7969f1e3d9973888$export$b34acede8cc7b639).Settings
                })
            },
            {
                path: (0, $7969f1e3d9973888$export$b34acede8cc7b639).Settings,
                element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6454b4be12ac8b17$export$2e2bcd8739ae039), {})
            },
            {
                path: (0, $7969f1e3d9973888$export$b34acede8cc7b639).Members,
                element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ff3ea3c50665afca$export$2e2bcd8739ae039), {})
            }
        ]
    })
};



var $C7mD2 = parcelRequire("C7mD2");

var $2Phw0 = parcelRequire("2Phw0");

var $bt3dS = parcelRequire("bt3dS");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");
var $61Yml = parcelRequire("61Yml");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $2Phw0 = parcelRequire("2Phw0");parcelRequire("6bq3s");
var $2Phw0 = parcelRequire("2Phw0");

var $voszV = parcelRequire("voszV");
var $hgWIN = parcelRequire("hgWIN");




var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $0663a2b9fa963923$var$SvgUserRoleDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 40,
        height: 41,
        viewBox: "0 0 40 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                y: 0.5,
                width: 40,
                height: 40,
                rx: 8,
                fill: "#F7F8F8",
                fillOpacity: 0.12
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 19.792,
                cy: 14,
                r: 6.5,
                fill: "url(#paint0_linear_8738_113276)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 12.194,
                y: 12.389,
                width: 8.778,
                height: 1.097,
                rx: 0.549,
                fill: "#2D2C61"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 23.167,
                y: 12.389,
                width: 4.389,
                height: 1.097,
                rx: 0.549,
                fill: "#2D2C61"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M10 29.084a6.583 6.583 0 0 1 6.584-6.584h6.832A6.583 6.583 0 0 1 30 29.084v2.221a2.194 2.194 0 0 1-2.195 2.195h-15.61A2.194 2.194 0 0 1 10 31.305v-2.221Z",
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("defs", {
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                    id: "paint0_linear_8738_113276",
                    x1: 15.526,
                    y1: 18.74,
                    x2: 24.261,
                    y2: 9.396,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            stopColor: "#5D34F2"
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            offset: 1,
                            stopColor: "#FF88FA"
                        })
                    ]
                })
            })
        ]
    });
var $0663a2b9fa963923$export$2e2bcd8739ae039 = $0663a2b9fa963923$var$SvgUserRoleDark;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $4c2e4598d85b0069$var$SvgUserRole = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 40,
        height: 41,
        viewBox: "0 0 40 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                y: 0.5,
                width: 40,
                height: 40,
                rx: 8,
                fill: "#F3EFFA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 19.792,
                cy: 14,
                r: 6.5,
                fill: "url(#paint0_linear_8738_113217)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 12.194,
                y: 12.389,
                width: 8.778,
                height: 1.097,
                rx: 0.549,
                fill: "#2D2C61"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 23.167,
                y: 12.389,
                width: 4.389,
                height: 1.097,
                rx: 0.549,
                fill: "#2D2C61"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M10 29.084a6.583 6.583 0 0 1 6.584-6.584h6.832A6.583 6.583 0 0 1 30 29.084v2.221a2.194 2.194 0 0 1-2.195 2.195h-15.61A2.194 2.194 0 0 1 10 31.305v-2.221Z",
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("defs", {
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                    id: "paint0_linear_8738_113217",
                    x1: 15.526,
                    y1: 18.74,
                    x2: 24.261,
                    y2: 9.396,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            stopColor: "#5D34F2"
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                            offset: 1,
                            stopColor: "#FF88FA"
                        })
                    ]
                })
            })
        ]
    });
var $4c2e4598d85b0069$export$2e2bcd8739ae039 = $4c2e4598d85b0069$var$SvgUserRole;





var $8TpMk = parcelRequire("8TpMk");

var $bt3dS = parcelRequire("bt3dS");

var $dL4NZ = parcelRequire("dL4NZ");

var $1QOtg = parcelRequire("1QOtg");


var $9Q3SI = parcelRequire("9Q3SI");

var $7VnwS = parcelRequire("7VnwS");

var $4ZcUR = parcelRequire("4ZcUR");

var $jheqv = parcelRequire("jheqv");

var $011b3197a4a4a6d0$export$bfd64c937657f93a;
var $011b3197a4a4a6d0$export$4a6dd88bada4e7d2;
var $011b3197a4a4a6d0$export$e16a509e03e8e9f6;
$011b3197a4a4a6d0$export$bfd64c937657f93a = `Tm4JdG_rotating`;
$011b3197a4a4a6d0$export$4a6dd88bada4e7d2 = `Tm4JdG_shimmer`;
$011b3197a4a4a6d0$export$e16a509e03e8e9f6 = `Tm4JdG_withTable`;


const $f040fda8f31ec618$var$icons = {
    [(0, $5HVJe.Theme).Light]: {
        UserIcon: (0, $4c2e4598d85b0069$export$2e2bcd8739ae039),
        MachineToMachineIcon: (0, $6d851c22506b0fe9$export$2e2bcd8739ae039)
    },
    [(0, $5HVJe.Theme).Dark]: {
        UserIcon: (0, $0663a2b9fa963923$export$2e2bcd8739ae039),
        MachineToMachineIcon: (0, $8ab60efc5360b57c$export$2e2bcd8739ae039)
    }
};
function $f040fda8f31ec618$var$RoleDetails() {
    const { pathname: pathname } = (0, $2Phw0.useLocation)();
    const { id: id } = (0, $2Phw0.useParams)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const theme = (0, $jheqv.default)();
    const { UserIcon: UserIcon, MachineToMachineIcon: MachineToMachineIcon } = $f040fda8f31ec618$var$icons[theme];
    const isPageHasTable = pathname.endsWith((0, $bt3dS.RoleDetailsTabs).Permissions) || pathname.endsWith((0, $bt3dS.RoleDetailsTabs).Users) || pathname.endsWith((0, $bt3dS.RoleDetailsTabs).M2mApps);
    const { data: data, error: error, mutate: mutate } = (0, $voszV.default)(id && `api/roles/${id}`);
    const { mutate: mutateGlobal } = (0, $hgWIN.useSWRConfig)();
    const isLoading = !data && !error;
    const { data: { m2mRoleNotificationAcknowledged: m2mRoleNotificationAcknowledged }, update: updateUserPreferences, isLoaded: isUserPreferencesLoaded } = (0, $c83ac2f0f8302d6c$export$2e2bcd8739ae039)();
    // Default to true to avoid page flickering
    const isM2mRoleNotificationAcknowledged = isUserPreferencesLoaded ? Boolean(m2mRoleNotificationAcknowledged) : true;
    const [isDeletionAlertOpen, setIsDeletionAlertOpen] = (0, $jC8Vy.useState)(false);
    (0, $jC8Vy.useEffect)(()=>{
        setIsDeletionAlertOpen(false);
    }, [
        pathname
    ]);
    const [isDeleting, setIsDeleting] = (0, $jC8Vy.useState)(false);
    const api = (0, $7VnwS.default)();
    const handleDelete = async ()=>{
        if (!data) return;
        setIsDeleting(true);
        try {
            await api.delete(`api/roles/${data.id}`);
            (0, $FuhPC.toast).success(t("role_details.role_deleted", {
                name: data.name
            }));
            await mutateGlobal("api/roles");
            navigate("/roles", {
                replace: true
            });
        } finally{
            setIsDeleting(false);
        }
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aa35f43ec98b7478$export$2e2bcd8739ae039), {
        backLink: "/roles",
        backLinkTitle: "role_details.back_to_roles",
        isLoading: isLoading,
        error: error,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))(isPageHasTable && $011b3197a4a4a6d0$export$e16a509e03e8e9f6),
        onRetry: mutate,
        children: [
            (0, $8TpMk.isDevFeaturesEnabled) && !isM2mRoleNotificationAcknowledged && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1QOtg.default), {
                action: "general.got_it",
                onClick: ()=>{
                    updateUserPreferences({
                        m2mRoleNotificationAcknowledged: true
                    });
                },
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                    components: {
                        a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                            to: "/applications"
                        })
                    },
                    children: t("role_details.m2m_role_notification")
                })
            }),
            data && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $eefae5244405013e$export$2e2bcd8739ae039), {
                        icon: data.type === (0, $61Yml.RoleType).User ? /*#__PURE__*/ (0, $C7mD2.jsx)(UserIcon, {}) : /*#__PURE__*/ (0, $C7mD2.jsx)(MachineToMachineIcon, {}),
                        title: data.name,
                        primaryTag: t(data.type === (0, $61Yml.RoleType).User ? "role_details.type_user_role_tag" : "role_details.type_m2m_role_tag"),
                        identifier: {
                            name: "ID",
                            value: data.id
                        },
                        actionMenuItems: [
                            {
                                title: "general.delete",
                                icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3aa588de5c8665f2$export$2e2bcd8739ae039), {}),
                                type: "danger",
                                onClick: ()=>{
                                    setIsDeletionAlertOpen(true);
                                }
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dL4NZ.default), {
                        isOpen: isDeletionAlertOpen,
                        isLoading: isDeleting,
                        confirmButtonText: "general.delete",
                        onCancel: ()=>{
                            setIsDeletionAlertOpen(false);
                        },
                        onConfirm: handleDelete,
                        children: t("role_details.delete_description")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $26090e0c44b20d28$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                                href: `/roles/${data.id}/${(0, $bt3dS.RoleDetailsTabs).Permissions}`,
                                children: t("role_details.permissions_tab")
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                                href: `/roles/${data.id}/${data.type === (0, $61Yml.RoleType).User ? (0, $bt3dS.RoleDetailsTabs).Users : (0, $bt3dS.RoleDetailsTabs).M2mApps}`,
                                children: t(data.type === (0, $61Yml.RoleType).User ? "role_details.users_tab" : "role_details.m2m_apps_tab")
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                                href: `/roles/${data.id}/${(0, $bt3dS.RoleDetailsTabs).General}`,
                                children: t("role_details.general_tab")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Outlet), {
                        context: {
                            role: data,
                            isDeleting: isDeleting,
                            onRoleUpdated: (role)=>{
                                mutate(role);
                            }
                        }
                    })
                ]
            })
        ]
    });
}
var $f040fda8f31ec618$export$2e2bcd8739ae039 = $f040fda8f31ec618$var$RoleDetails;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $2Phw0 = parcelRequire("2Phw0");

var $voszV = parcelRequire("voszV");






var $8Mb3E = parcelRequire("8Mb3E");

var $jGWQ4 = parcelRequire("jGWQ4");

var $dL4NZ = parcelRequire("dL4NZ");

var $75SRw = parcelRequire("75SRw");


parcelRequire("fIF1D");
var $16GE9 = parcelRequire("16GE9");

var $7VnwS = parcelRequire("7VnwS");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");

var $jC8Vy = parcelRequire("jC8Vy");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $kUZ14 = parcelRequire("kUZ14");



var $jGWQ4 = parcelRequire("jGWQ4");

var $aqmjm = parcelRequire("aqmjm");

var $5vVWy = parcelRequire("5vVWy");

var $7VnwS = parcelRequire("7VnwS");

var $dW2kG = parcelRequire("dW2kG");
const $54f8201b3e2ea2cf$var$isUserEntity = (entity)=>"customData" in entity || "identities" in entity;
function $54f8201b3e2ea2cf$var$AssignRoleModal({ roleId: roleId, roleType: roleType, isRemindSkip: isRemindSkip = false, onClose: onClose }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [isLoading, setIsLoading] = (0, $jC8Vy.useState)(false);
    const [entities, setEntities] = (0, $jC8Vy.useState)([]);
    const phraseKey = roleType === (0, $61Yml.RoleType).User ? "users" : "applications";
    const api = (0, $7VnwS.default)();
    const handleAssign = async ()=>{
        if (isLoading || entities.length === 0) return;
        setIsLoading(true);
        try {
            await api.post(`api/roles/${roleId}/${phraseKey}`, {
                json: {
                    [phraseKey.slice(0, -1) + "Ids"]: entities.map(({ id: id })=>id)
                }
            });
            (0, $FuhPC.toast).success(t(`role_details.${phraseKey}.assigned_toast_text`));
            onClose(true);
        } finally{
            setIsLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        isOpen: true,
        shouldCloseOnEsc: true,
        className: $dW2kG.content,
        overlayClassName: $dW2kG.overlay,
        onRequestClose: ()=>{
            onClose();
        },
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5vVWy.default), {
            title: `role_details.${phraseKey}.assign_title`,
            subtitle: `role_details.${phraseKey}.assign_subtitle`,
            size: "large",
            footer: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        isLoading: isLoading,
                        htmlType: "submit",
                        title: isRemindSkip ? "general.skip_for_now" : "general.cancel",
                        size: "large",
                        type: "default",
                        onClick: ()=>{
                            onClose();
                        }
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        isLoading: isLoading,
                        disabled: entities.length === 0,
                        htmlType: "submit",
                        title: `role_details.${phraseKey}.confirm_assign`,
                        size: "large",
                        type: "primary",
                        onClick: handleAssign
                    })
                ]
            }),
            onClose: onClose,
            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: `role_details.${phraseKey}.assign_field`,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $133dd77f608c23b1$export$2e2bcd8739ae039), {
                    searchProps: {
                        pathname: `api/${phraseKey}`,
                        parameters: {
                            excludeRoleId: roleId,
                            ...roleType === (0, $61Yml.RoleType).User ? {} : {
                                types: (0, $61Yml.ApplicationType).MachineToMachine
                            }
                        }
                    },
                    selectedEntities: entities,
                    emptyPlaceholder: `role_details.${phraseKey}.empty`,
                    renderEntity: (entity)=>$54f8201b3e2ea2cf$var$isUserEntity(entity) ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e542aa41315bcd92$export$7d5b61b2bb96bf4d), {
                            entity: entity
                        }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e542aa41315bcd92$export$a42ffac851fa6a76), {
                            entity: entity
                        }),
                    onChange: setEntities
                })
            })
        })
    });
}
var $54f8201b3e2ea2cf$export$2e2bcd8739ae039 = $54f8201b3e2ea2cf$var$AssignRoleModal;



var $7kooT = parcelRequire("7kooT");
var $a14ddb094ceeab99$export$58fcafe19102a562;
var $a14ddb094ceeab99$export$3dea766d36a8935f;
var $a14ddb094ceeab99$export$1ca1ec8b29a4ce27;
var $a14ddb094ceeab99$export$bfd64c937657f93a;
var $a14ddb094ceeab99$export$4a6dd88bada4e7d2;
$a14ddb094ceeab99$export$58fcafe19102a562 = `l-2Klq_applicationsTable`;
$a14ddb094ceeab99$export$3dea766d36a8935f = `l-2Klq_filter`;
$a14ddb094ceeab99$export$1ca1ec8b29a4ce27 = `l-2Klq_icon`;
$a14ddb094ceeab99$export$bfd64c937657f93a = `l-2Klq_rotating`;
$a14ddb094ceeab99$export$4a6dd88bada4e7d2 = `l-2Klq_shimmer`;


const $61868757709ed06e$var$pageSize = (0, $8Mb3E.defaultPageSize);
function $61868757709ed06e$var$RoleApplications() {
    const { role: { id: roleId } } = (0, $2Phw0.useOutletContext)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [{ page: page, keyword: keyword }, updateSearchParameters] = (0, $66a3eb3654f9d141$export$2e2bcd8739ae039)({
        page: 1,
        keyword: ""
    });
    const { data: data, error: error, mutate: mutate } = (0, $voszV.default)(roleId && (0, $7kooT.buildUrl)(`api/roles/${roleId}/applications`, {
        page: String(page),
        page_size: String($61868757709ed06e$var$pageSize),
        ...(0, $7oDSS.conditional)(keyword && {
            search: (0, $7kooT.formatSearchKeyword)(keyword)
        })
    }));
    const isLoading = !data && !error;
    const [applications, totalCount] = data ?? [];
    const [isAssignModalOpen, setIsAssignModalOpen] = (0, $jC8Vy.useState)(false);
    const [applicationToBeDeleted, setApplicationToBeDeleted] = (0, $jC8Vy.useState)();
    const [isDeleting, setIsDeleting] = (0, $jC8Vy.useState)(false);
    const api = (0, $7VnwS.default)();
    const handleDelete = async ()=>{
        if (!applicationToBeDeleted || isDeleting) return;
        setIsDeleting(true);
        try {
            await api.delete(`api/roles/${roleId}/applications/${applicationToBeDeleted.id}`);
            (0, $FuhPC.toast).success(t("role_details.applications.deleted", {
                name: applicationToBeDeleted.name
            }));
            await mutate();
            setApplicationToBeDeleted(undefined);
        } finally{
            setIsDeleting(false);
        }
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3166f28a681c41bb$export$2e2bcd8739ae039), {
                className: $a14ddb094ceeab99$export$58fcafe19102a562,
                isLoading: isLoading,
                rowGroups: [
                    {
                        key: "applications",
                        data: applications
                    }
                ],
                rowIndexKey: "id",
                columns: [
                    {
                        title: t("role_details.applications.app_column"),
                        dataIndex: "name",
                        colSpan: 5,
                        render: (application)=>{
                            return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4d952cae22cb03fc$export$2e2bcd8739ae039), {
                                title: application.name,
                                icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e07e369caa387826$export$2e2bcd8739ae039), {
                                    type: (0, $61Yml.ApplicationType).MachineToMachine,
                                    className: $a14ddb094ceeab99$export$1ca1ec8b29a4ce27
                                }),
                                to: `/applications/${application.id}`
                            });
                        }
                    },
                    {
                        title: t("role_details.applications.description_column"),
                        dataIndex: "description",
                        colSpan: 5,
                        render: ({ description: description })=>/*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                                children: (0, $7oDSS.conditional)(description) ?? "-"
                            })
                    },
                    {
                        title: null,
                        dataIndex: "delete",
                        colSpan: 1,
                        render: (application)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $16GE9.default), {
                                content: t("general.remove"),
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                                    onClick: ()=>{
                                        setApplicationToBeDeleted(application);
                                    },
                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3aa588de5c8665f2$export$2e2bcd8739ae039), {})
                                })
                            })
                    }
                ],
                filter: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: $a14ddb094ceeab99$export$3dea766d36a8935f,
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $46c375e0973aedf1$export$2e2bcd8739ae039), {
                            defaultValue: keyword,
                            isClearable: Boolean(keyword),
                            placeholder: t("general.search_placeholder"),
                            onSearch: (keyword)=>{
                                updateSearchParameters({
                                    keyword: keyword,
                                    page: 1
                                });
                            },
                            onClearSearch: ()=>{
                                updateSearchParameters({
                                    keyword: "",
                                    page: 1
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                            title: "role_details.applications.assign_button",
                            type: "primary",
                            size: "large",
                            icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0b30fe81c923292b$export$2e2bcd8739ae039), {}),
                            onClick: ()=>{
                                setIsAssignModalOpen(true);
                            }
                        })
                    ]
                }),
                pagination: {
                    page: page,
                    pageSize: $61868757709ed06e$var$pageSize,
                    totalCount: totalCount,
                    onChange: (page)=>{
                        updateSearchParameters({
                            page: page
                        });
                    }
                },
                placeholder: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a0f84bc7cc69e410$export$2e2bcd8739ae039), {})
            }),
            applicationToBeDeleted && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dL4NZ.default), {
                isOpen: true,
                isLoading: isDeleting,
                confirmButtonText: "general.remove",
                onCancel: ()=>{
                    setApplicationToBeDeleted(undefined);
                },
                onConfirm: handleDelete,
                children: t("role_details.applications.delete_description")
            }),
            isAssignModalOpen && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $54f8201b3e2ea2cf$export$2e2bcd8739ae039), {
                roleId: roleId,
                roleType: (0, $61Yml.RoleType).MachineToMachine,
                onClose: (success)=>{
                    if (success) mutate();
                    setIsAssignModalOpen(false);
                }
            })
        ]
    });
}
var $61868757709ed06e$export$2e2bcd8739ae039 = $61868757709ed06e$var$RoleApplications;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $2Phw0 = parcelRequire("2Phw0");

var $voszV = parcelRequire("voszV");


var $8Mb3E = parcelRequire("8Mb3E");

var $7VnwS = parcelRequire("7VnwS");


var $7kooT = parcelRequire("7kooT");

var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $kUZ14 = parcelRequire("kUZ14");




var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $68782 = parcelRequire("68782");
var $61Yml = parcelRequire("61Yml");
var $9XFlr = parcelRequire("9XFlr");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $voszV = parcelRequire("voszV");



var $fmHmG = parcelRequire("fmHmG");


var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");




var $75SRw = parcelRequire("75SRw");

var $bnkR4 = parcelRequire("bnkR4");

var $C7mD2 = parcelRequire("C7mD2");


var $bnkR4 = parcelRequire("bnkR4");
var $2affff0ecb3c910c$export$1ca1ec8b29a4ce27;
var $2affff0ecb3c910c$export$a8ff84c12d48cfa6;
var $2affff0ecb3c910c$export$bfd64c937657f93a;
var $2affff0ecb3c910c$export$4a6dd88bada4e7d2;
var $2affff0ecb3c910c$export$4b74bb440bb801f7;
$2affff0ecb3c910c$export$1ca1ec8b29a4ce27 = `HOGL5a_icon`;
$2affff0ecb3c910c$export$a8ff84c12d48cfa6 = `HOGL5a_name`;
$2affff0ecb3c910c$export$bfd64c937657f93a = `HOGL5a_rotating`;
$2affff0ecb3c910c$export$4a6dd88bada4e7d2 = `HOGL5a_shimmer`;
$2affff0ecb3c910c$export$4b74bb440bb801f7 = `HOGL5a_sourceScopeItem`;


function $d177f125ba9d52eb$var$SourceScopeItem({ scope: scope, scope: { name: name }, isSelected: isSelected, onSelect: onSelect }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $2affff0ecb3c910c$export$4b74bb440bb801f7,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $26dc4ab718ba37b7$export$2e2bcd8739ae039), {
                checked: isSelected,
                onChange: ()=>{
                    onSelect(scope);
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $2affff0ecb3c910c$export$a8ff84c12d48cfa6,
                role: "button",
                tabIndex: 0,
                onKeyDown: (0, $bnkR4.onKeyDownHandler)(()=>{
                    onSelect(scope);
                }),
                onClick: ()=>{
                    onSelect(scope);
                },
                children: name
            })
        ]
    });
}
var $d177f125ba9d52eb$export$2e2bcd8739ae039 = $d177f125ba9d52eb$var$SourceScopeItem;


var $6450538752dd3d91$export$e88cb2efb12ae807;
var $6450538752dd3d91$export$c99df9cf5e6bee9b;
var $6450538752dd3d91$export$a8ff84c12d48cfa6;
var $6450538752dd3d91$export$23e0665cffcf8918;
var $6450538752dd3d91$export$d3dfeb0bd4220bf7;
var $6450538752dd3d91$export$bfd64c937657f93a;
var $6450538752dd3d91$export$c2e49e3f3da9e921;
var $6450538752dd3d91$export$4a6dd88bada4e7d2;
var $6450538752dd3d91$export$fb184b623420d9be;
$6450538752dd3d91$export$e88cb2efb12ae807 = `kfGtNa_caret`;
$6450538752dd3d91$export$c99df9cf5e6bee9b = `kfGtNa_invisible`;
$6450538752dd3d91$export$a8ff84c12d48cfa6 = `kfGtNa_name`;
$6450538752dd3d91$export$23e0665cffcf8918 = `kfGtNa_resource`;
$6450538752dd3d91$export$d3dfeb0bd4220bf7 = `kfGtNa_resourceItem`;
$6450538752dd3d91$export$bfd64c937657f93a = `kfGtNa_rotating`;
$6450538752dd3d91$export$c2e49e3f3da9e921 = `kfGtNa_scopeInfo`;
$6450538752dd3d91$export$4a6dd88bada4e7d2 = `kfGtNa_shimmer`;
$6450538752dd3d91$export$fb184b623420d9be = `kfGtNa_title`;


function $ad4eeb8fc2a445fd$var$ResourceItem({ resource: resource, selectedScopes: selectedScopes, onSelectResource: onSelectResource, onSelectScope: onSelectScope }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { name: name, scopes: scopes } = resource;
    const selectedScopesCount = selectedScopes.length;
    const totalScopesCount = scopes.length;
    const [isScopesInvisible, setIsScopesInvisible] = (0, $jC8Vy.useState)(true);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $6450538752dd3d91$export$d3dfeb0bd4220bf7,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $6450538752dd3d91$export$fb184b623420d9be,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $26dc4ab718ba37b7$export$2e2bcd8739ae039), {
                        checked: selectedScopesCount === totalScopesCount,
                        indeterminate: selectedScopesCount > 0 && selectedScopesCount < totalScopesCount,
                        onChange: ()=>{
                            onSelectResource(resource);
                        }
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        role: "button",
                        tabIndex: 0,
                        className: $6450538752dd3d91$export$23e0665cffcf8918,
                        onKeyDown: (0, $bnkR4.onKeyDownHandler)(()=>{
                            setIsScopesInvisible(!isScopesInvisible);
                        }),
                        onClick: ()=>{
                            setIsScopesInvisible(!isScopesInvisible);
                        },
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                                size: "medium",
                                className: $6450538752dd3d91$export$e88cb2efb12ae807,
                                children: isScopesInvisible ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8190cd3bb8bc1e74$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $442b31b4cd054ae7$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $6450538752dd3d91$export$a8ff84c12d48cfa6,
                                children: name
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                className: $6450538752dd3d91$export$c2e49e3f3da9e921,
                                children: [
                                    "(",
                                    t("role_details.permission.api_permission_count", {
                                        count: scopes.length
                                    }),
                                    ")"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))(isScopesInvisible && $6450538752dd3d91$export$c99df9cf5e6bee9b),
                children: scopes.map((scope)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $d177f125ba9d52eb$export$2e2bcd8739ae039), {
                        scope: scope,
                        isSelected: selectedScopes.findIndex(({ id: id })=>scope.id === id) >= 0,
                        onSelect: onSelectScope
                    }, scope.id))
            })
        ]
    });
}
var $ad4eeb8fc2a445fd$export$2e2bcd8739ae039 = $ad4eeb8fc2a445fd$var$ResourceItem;


var $e22f44e7e4161ba6$export$1ca1ec8b29a4ce27;
var $e22f44e7e4161ba6$export$d76128d007d19019;
$e22f44e7e4161ba6$export$1ca1ec8b29a4ce27 = `lgwVMa_icon`;
$e22f44e7e4161ba6$export$d76128d007d19019 = `lgwVMa_search`;


function $caef076fed732ebc$var$SourceScopesBox({ roleId: roleId, roleType: roleType, selectedScopes: selectedScopes, onChange: onChange }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: allResources, error: fetchAllResourcesError } = (0, $voszV.default)("api/resources?includeScopes=true");
    const { data: roleScopes, error: fetchRoleScopesError } = (0, $voszV.default)(roleId && `api/roles/${roleId}/scopes`);
    const isLoading = !allResources && !fetchAllResourcesError || roleId && !roleScopes && !fetchRoleScopesError;
    const hasError = Boolean(fetchAllResourcesError) || Boolean(roleId && fetchRoleScopesError);
    const [keyword, setKeyword] = (0, $jC8Vy.useState)("");
    const handleSearchInput = (event)=>{
        setKeyword(event.target.value);
    };
    const isScopeAdded = (scope)=>selectedScopes.findIndex(({ id: id })=>id === scope.id) >= 0;
    const onSelectScope = (scope)=>{
        onChange(isScopeAdded(scope) ? selectedScopes.filter(({ id: id })=>id !== scope.id) : [
            scope,
            ...selectedScopes
        ]);
    };
    const onSelectResource = ({ scopes: resourceScopes })=>{
        const isAllSelected = resourceScopes.every((scope)=>isScopeAdded(scope));
        const resourceScopesIds = new Set(resourceScopes.map(({ id: id })=>id));
        const selectedScopesExcludeResourceScopes = selectedScopes.filter(({ id: id })=>!resourceScopesIds.has(id));
        onChange(isAllSelected ? selectedScopesExcludeResourceScopes : [
            ...resourceScopes,
            ...selectedScopesExcludeResourceScopes
        ]);
    };
    const getResourceSelectedScopes = ({ scopes: scopes })=>scopes.filter((scope)=>selectedScopes.findIndex(({ id: id })=>id === scope.id) >= 0);
    const resources = (0, $jC8Vy.useMemo)(()=>{
        if (!allResources || roleId && !roleScopes) return [];
        const existingScopeIds = roleScopes?.map(({ id: id })=>id) ?? [];
        const excludeScopeIds = new Set([
            ...existingScopeIds,
            (0, $68782.PredefinedScope).All
        ]);
        return allResources.filter(({ indicator: indicator, scopes: scopes })=>/** Should show management API scopes for machine-to-machine roles */ (roleType === (0, $61Yml.RoleType).MachineToMachine || !(0, $9XFlr.isManagementApi)(indicator)) && scopes.some(({ id: id })=>!excludeScopeIds.has(id))).map(({ scopes: scopes, ...resource })=>({
                ...resource,
                scopes: scopes.filter(({ id: id })=>!excludeScopeIds.has(id)).map((scope)=>({
                        ...scope,
                        resource: resource
                    }))
            }));
    }, [
        allResources,
        roleType,
        roleId,
        roleScopes
    ]);
    const dataSource = (0, $jC8Vy.useMemo)(()=>{
        const lowerCasedKeyword = keyword.toLowerCase();
        return (0, $7oDSS.conditional)(lowerCasedKeyword && resources.filter(({ name: name, scopes: scopes })=>{
            return name.toLowerCase().includes(lowerCasedKeyword) || scopes.some(({ name: name })=>name.toLowerCase().includes(lowerCasedKeyword));
        }).map(({ scopes: scopes, ...resource })=>({
                ...resource,
                scopes: scopes.filter(({ name: name, resource: resource })=>name.toLocaleLowerCase().includes(lowerCasedKeyword) || resource.name.toLocaleLowerCase().includes(lowerCasedKeyword))
            })).filter(({ scopes: scopes })=>scopes.length > 0)) ?? resources;
    }, [
        keyword,
        resources
    ]);
    const isEmpty = !isLoading && !hasError && dataSource.length === 0;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $1c26dd25fa3ad36d$export$827f4ee28efc37,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $1c26dd25fa3ad36d$export$9f6c77b8cdee9051,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                    className: $e22f44e7e4161ba6$export$d76128d007d19019,
                    icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $45ba7f7cad465e3f$export$2e2bcd8739ae039), {
                        className: $e22f44e7e4161ba6$export$1ca1ec8b29a4ce27
                    }),
                    placeholder: t("general.search_placeholder"),
                    onChange: handleSearchInput
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($1c26dd25fa3ad36d$export$a03f626b8106969c, isEmpty && $1c26dd25fa3ad36d$export$2d49e08edfff676e),
                children: isEmpty ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a0f84bc7cc69e410$export$2e2bcd8739ae039), {
                    size: "small",
                    title: t("role_details.permission.empty")
                }) : dataSource.map((resource)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $ad4eeb8fc2a445fd$export$2e2bcd8739ae039), {
                        resource: resource,
                        selectedScopes: getResourceSelectedScopes(resource),
                        onSelectResource: onSelectResource,
                        onSelectScope: onSelectScope
                    }, resource.id))
            })
        ]
    });
}
var $caef076fed732ebc$export$2e2bcd8739ae039 = $caef076fed732ebc$var$SourceScopesBox;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");


var $C7mD2 = parcelRequire("C7mD2");

var $HHYyb = parcelRequire("HHYyb");

var $75SRw = parcelRequire("75SRw");
var $f8578bb398ff08b6$export$a8ff84c12d48cfa6;
var $f8578bb398ff08b6$export$42a13522e3b9f353;
var $f8578bb398ff08b6$export$bfd64c937657f93a;
var $f8578bb398ff08b6$export$4a6dd88bada4e7d2;
var $f8578bb398ff08b6$export$fc4e68ccefdfac4c;
var $f8578bb398ff08b6$export$fb184b623420d9be;
$f8578bb398ff08b6$export$a8ff84c12d48cfa6 = `WBz-qW_name`;
$f8578bb398ff08b6$export$42a13522e3b9f353 = `WBz-qW_resourceName`;
$f8578bb398ff08b6$export$bfd64c937657f93a = `WBz-qW_rotating`;
$f8578bb398ff08b6$export$4a6dd88bada4e7d2 = `WBz-qW_shimmer`;
$f8578bb398ff08b6$export$fc4e68ccefdfac4c = `WBz-qW_targetScopeItem`;
$f8578bb398ff08b6$export$fb184b623420d9be = `WBz-qW_title`;


function $5fdc56d33f93319d$var$TargetScopeItem({ scope: scope, onDelete: onDelete }) {
    const { name: name, resource: { name: resourceName } } = scope;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $f8578bb398ff08b6$export$fc4e68ccefdfac4c,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $f8578bb398ff08b6$export$fb184b623420d9be,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $f8578bb398ff08b6$export$a8ff84c12d48cfa6,
                        children: name
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $f8578bb398ff08b6$export$42a13522e3b9f353,
                        children: `(${resourceName})`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                size: "small",
                onClick: ()=>{
                    onDelete(scope);
                },
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $HHYyb.default), {})
            })
        ]
    });
}
var $5fdc56d33f93319d$export$2e2bcd8739ae039 = $5fdc56d33f93319d$var$TargetScopeItem;


var $0bf1623b697c1844$export$80f73db1a407fae0;
$0bf1623b697c1844$export$80f73db1a407fae0 = `_5nfMBq_added`;


function $e33e3275b2842e54$var$TargetScopesBox({ selectedScopes: selectedScopes, onChange: onChange }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $1c26dd25fa3ad36d$export$827f4ee28efc37,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $1c26dd25fa3ad36d$export$9f6c77b8cdee9051,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                    className: $0bf1623b697c1844$export$80f73db1a407fae0,
                    children: t("role_details.permission.added_text", {
                        count: selectedScopes.length
                    })
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $1c26dd25fa3ad36d$export$a03f626b8106969c,
                children: selectedScopes.map((scope)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $5fdc56d33f93319d$export$2e2bcd8739ae039), {
                        scope: scope,
                        onDelete: (scope)=>{
                            onChange(selectedScopes.filter(({ id: id })=>id !== scope.id));
                        }
                    }, scope.id))
            })
        ]
    });
}
var $e33e3275b2842e54$export$2e2bcd8739ae039 = $e33e3275b2842e54$var$TargetScopesBox;


var $ac376b2b790350b2$export$fd3a44c6c35bba04;
var $ac376b2b790350b2$export$bfd64c937657f93a;
var $ac376b2b790350b2$export$4a6dd88bada4e7d2;
$ac376b2b790350b2$export$fd3a44c6c35bba04 = `_4f4-IW_roleScopesTransfer`;
$ac376b2b790350b2$export$bfd64c937657f93a = `_4f4-IW_rotating`;
$ac376b2b790350b2$export$4a6dd88bada4e7d2 = `_4f4-IW_shimmer`;


function $2e97551deecdcf02$var$RoleScopesTransfer({ roleId: roleId, roleType: roleType, value: value, onChange: onChange }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($1c26dd25fa3ad36d$export$34e0f9847d4c02dd, $ac376b2b790350b2$export$fd3a44c6c35bba04),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $caef076fed732ebc$export$2e2bcd8739ae039), {
                roleId: roleId,
                roleType: roleType,
                selectedScopes: value,
                onChange: onChange
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $1c26dd25fa3ad36d$export$d999e528e771887b
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e33e3275b2842e54$export$2e2bcd8739ae039), {
                selectedScopes: value,
                onChange: onChange
            })
        ]
    });
}
var $2e97551deecdcf02$export$2e2bcd8739ae039 = $2e97551deecdcf02$var$RoleScopesTransfer;




var $jGWQ4 = parcelRequire("jGWQ4");

var $aqmjm = parcelRequire("aqmjm");

var $5vVWy = parcelRequire("5vVWy");

var $7VnwS = parcelRequire("7VnwS");

var $dW2kG = parcelRequire("dW2kG");

function $bf74af3322cb942a$var$AssignPermissionsModal({ roleId: roleId, roleType: roleType, totalRoleScopeCount: totalRoleScopeCount, onClose: onClose }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { currentPlan: currentPlan } = (0, $jC8Vy.useContext)((0, $19434c930f80c964$export$f8addfd4ab69c833));
    const [isSubmitting, setIsSubmitting] = (0, $jC8Vy.useState)(false);
    const [scopes, setScopes] = (0, $jC8Vy.useState)([]);
    const api = (0, $7VnwS.default)();
    const handleAssign = async ()=>{
        if (isSubmitting || scopes.length === 0) return;
        setIsSubmitting(true);
        try {
            await api.post(`api/roles/${roleId}/scopes`, {
                json: {
                    scopeIds: scopes.map(({ id: id })=>id)
                }
            });
            (0, $FuhPC.toast).success(t("role_details.permission.permission_assigned"));
            onClose(true);
        } finally{
            setIsSubmitting(false);
        }
    };
    const shouldBlockScopeAssignment = (0, $605aee781e0fe83f$export$6486e974a84ab8b6)({
        quotaKey: "scopesPerRoleLimit",
        plan: currentPlan,
        usage: totalRoleScopeCount + scopes.length
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        isOpen: true,
        shouldCloseOnEsc: true,
        className: $dW2kG.content,
        overlayClassName: $dW2kG.overlay,
        onRequestClose: ()=>{
            onClose();
        },
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5vVWy.default), {
            title: "role_details.permission.assign_title",
            subtitle: "role_details.permission.assign_subtitle",
            learnMoreLink: {
                href: "https://docs.logto.io/docs/recipes/rbac/manage-permissions-and-roles#manage-role-permissions",
                targetBlank: "noopener"
            },
            size: "large",
            footer: shouldBlockScopeAssignment ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dafa1bad5a99c1ae$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                    components: {
                        a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a3bc63325dc3c1a8$export$2e2bcd8739ae039), {}),
                        planName: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $161f1bf99d56f621$export$2e2bcd8739ae039), {
                            name: currentPlan.name
                        })
                    },
                    children: t("upsell.paywall.scopes_per_role", {
                        count: currentPlan.quota.scopesPerRoleLimit ?? 0
                    })
                })
            }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                isLoading: isSubmitting,
                disabled: scopes.length === 0,
                htmlType: "submit",
                title: "role_details.permission.confirm_assign",
                size: "large",
                type: "primary",
                onClick: handleAssign
            }),
            onClose: onClose,
            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: "role_details.permission.assign_form_field",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2e97551deecdcf02$export$2e2bcd8739ae039), {
                    roleId: roleId,
                    roleType: roleType,
                    value: scopes,
                    onChange: (scopes)=>{
                        setScopes(scopes);
                    }
                })
            })
        })
    });
}
var $bf74af3322cb942a$export$2e2bcd8739ae039 = $bf74af3322cb942a$var$AssignPermissionsModal;


const $46973e31d15845a6$var$pageSize = (0, $8Mb3E.defaultPageSize);
function $46973e31d15845a6$var$RolePermissions() {
    const { role: { id: roleId, type: roleType } } = (0, $2Phw0.useOutletContext)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [{ page: page, keyword: keyword }, updateSearchParameters] = (0, $66a3eb3654f9d141$export$2e2bcd8739ae039)({
        page: 1,
        keyword: ""
    });
    const { data: data, error: error, mutate: mutate } = (0, $voszV.default)(roleId && (0, $7kooT.buildUrl)(`api/roles/${roleId}/scopes`, {
        page: String(page),
        page_size: String($46973e31d15845a6$var$pageSize),
        ...(0, $7oDSS.conditional)(keyword && {
            search: (0, $7kooT.formatSearchKeyword)(keyword)
        })
    }));
    const isLoading = !data && !error;
    const [scopes, totalCount] = data ?? [];
    const [isAssignPermissionsModalOpen, setIsAssignPermissionsModalOpen] = (0, $jC8Vy.useState)(false);
    const api = (0, $7VnwS.default)();
    const handleDelete = async (scope)=>{
        await api.delete(`api/roles/${roleId}/scopes/${scope.id}`);
        (0, $FuhPC.toast).success(t("role_details.permission.permission_deleted", {
            name: scope.name
        }));
        await mutate();
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $32ff64ac17e10119$export$2e2bcd8739ae039), {
                isApiColumnVisible: true,
                scopes: scopes,
                isLoading: isLoading,
                createButtonTitle: "role_details.permission.assign_button",
                deletionText: {
                    actionButton: "permissions.remove",
                    confirmation: "role_details.permission.deletion_description",
                    confirmButton: "general.remove"
                },
                createHandler: ()=>{
                    setIsAssignPermissionsModalOpen(true);
                },
                deleteHandler: handleDelete,
                errorMessage: error?.body?.message ?? error?.message,
                retryHandler: async ()=>mutate(undefined, true),
                pagination: {
                    page: page,
                    pageSize: $46973e31d15845a6$var$pageSize,
                    totalCount: totalCount,
                    onChange: (page)=>{
                        updateSearchParameters({
                            page: page
                        });
                    }
                },
                search: {
                    keyword: keyword,
                    searchHandler: (keyword)=>{
                        updateSearchParameters({
                            keyword: keyword,
                            page: 1
                        });
                    },
                    clearSearchHandler: ()=>{
                        updateSearchParameters({
                            keyword: "",
                            page: 1
                        });
                    }
                },
                onPermissionUpdated: mutate
            }),
            isAssignPermissionsModalOpen && totalCount !== undefined && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $bf74af3322cb942a$export$2e2bcd8739ae039), {
                roleId: roleId,
                roleType: roleType,
                totalRoleScopeCount: totalCount,
                onClose: (success)=>{
                    if (success) mutate();
                    setIsAssignPermissionsModalOpen(false);
                }
            })
        ]
    });
}
var $46973e31d15845a6$export$2e2bcd8739ae039 = $46973e31d15845a6$var$RolePermissions;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");

var $codQP = parcelRequire("codQP");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $2Phw0 = parcelRequire("2Phw0");




var $aqmjm = parcelRequire("aqmjm");

var $8RfrQ = parcelRequire("8RfrQ");

var $fmHmG = parcelRequire("fmHmG");

var $7VnwS = parcelRequire("7VnwS");

var $5OcFi = parcelRequire("5OcFi");
function $22e4d8629755ee77$var$RoleSettings() {
    const { role: role, isDeleting: isDeleting, onRoleUpdated: onRoleUpdated } = (0, $2Phw0.useOutletContext)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { handleSubmit: handleSubmit, register: register, reset: reset, formState: { isDirty: isDirty, isSubmitting: isSubmitting, errors: errors } } = (0, $codQP.useForm)({
        defaultValues: role
    });
    const api = (0, $7VnwS.default)();
    const onSubmit = handleSubmit((0, $5OcFi.trySubmitSafe)(async (formData)=>{
        if (isSubmitting) return;
        const updatedRole = await api.patch(`api/roles/${role.id}`, {
            json: formData
        }).json();
        reset(updatedRole);
        onRoleUpdated(updatedRole);
        (0, $FuhPC.toast).success(t("general.saved"));
    }));
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f0e7fd6d3bded790$export$2e2bcd8739ae039), {
                isDirty: isDirty,
                isSubmitting: isSubmitting,
                onDiscard: reset,
                onSubmit: onSubmit,
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
                    title: "role_details.settings",
                    description: "role_details.settings_description",
                    learnMoreLink: {
                        href: "https://docs.logto.io/docs/recipes/rbac/manage-permissions-and-roles#manage-roles",
                        targetBlank: "noopener"
                    },
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                            isRequired: true,
                            title: "role_details.field_name",
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                ...register("name", {
                                    required: true
                                }),
                                error: Boolean(errors.name)
                            })
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                            isRequired: true,
                            title: "role_details.field_description",
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                ...register("description", {
                                    required: true
                                }),
                                error: Boolean(errors.description)
                            })
                        }),
                        role.type === (0, $61Yml.RoleType).User && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                            title: "role_details.field_is_default",
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8RfrQ.default), {
                                label: t("role_details.field_is_default_description"),
                                ...register("isDefault")
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fea55fa5d5726e29$export$2e2bcd8739ae039), {
                hasUnsavedChanges: !isDeleting && isDirty
            })
        ]
    });
}
var $22e4d8629755ee77$export$2e2bcd8739ae039 = $22e4d8629755ee77$var$RoleSettings;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $2Phw0 = parcelRequire("2Phw0");

var $voszV = parcelRequire("voszV");







var $8Mb3E = parcelRequire("8Mb3E");

var $jGWQ4 = parcelRequire("jGWQ4");

var $dL4NZ = parcelRequire("dL4NZ");

var $75SRw = parcelRequire("75SRw");


parcelRequire("fIF1D");
var $16GE9 = parcelRequire("16GE9");

var $7VnwS = parcelRequire("7VnwS");



var $7kooT = parcelRequire("7kooT");
var $190a9c16cf03b5b0$export$3dea766d36a8935f;
var $190a9c16cf03b5b0$export$bfd64c937657f93a;
var $190a9c16cf03b5b0$export$4a6dd88bada4e7d2;
var $190a9c16cf03b5b0$export$5f0eed9cd9df5b6a;
$190a9c16cf03b5b0$export$3dea766d36a8935f = `FlVJdW_filter`;
$190a9c16cf03b5b0$export$bfd64c937657f93a = `FlVJdW_rotating`;
$190a9c16cf03b5b0$export$4a6dd88bada4e7d2 = `FlVJdW_shimmer`;
$190a9c16cf03b5b0$export$5f0eed9cd9df5b6a = `FlVJdW_usersTable`;


const $d20a0e74f4c6c43b$var$pageSize = (0, $8Mb3E.defaultPageSize);
function $d20a0e74f4c6c43b$var$RoleUsers() {
    const { role: { id: roleId } } = (0, $2Phw0.useOutletContext)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [{ page: page, keyword: keyword }, updateSearchParameters] = (0, $66a3eb3654f9d141$export$2e2bcd8739ae039)({
        page: 1,
        keyword: ""
    });
    const { data: data, error: error, mutate: mutate } = (0, $voszV.default)(roleId && (0, $7kooT.buildUrl)(`api/roles/${roleId}/users`, {
        page: String(page),
        page_size: String($d20a0e74f4c6c43b$var$pageSize),
        ...(0, $7oDSS.conditional)(keyword && {
            search: (0, $7kooT.formatSearchKeyword)(keyword)
        })
    }));
    const isLoading = !data && !error;
    const [users, totalCount] = data ?? [];
    const [isAssignModalOpen, setIsAssignModalOpen] = (0, $jC8Vy.useState)(false);
    const [userToBeDeleted, setUserToBeDeleted] = (0, $jC8Vy.useState)();
    const [isDeleting, setIsDeleting] = (0, $jC8Vy.useState)(false);
    const api = (0, $7VnwS.default)();
    const handleDelete = async ()=>{
        if (!userToBeDeleted || isDeleting) return;
        setIsDeleting(true);
        try {
            await api.delete(`api/roles/${roleId}/users/${userToBeDeleted.id}`);
            (0, $FuhPC.toast).success(t("role_details.users.deleted", {
                name: userToBeDeleted.name
            }));
            await mutate();
            setUserToBeDeleted(undefined);
        } finally{
            setIsDeleting(false);
        }
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3166f28a681c41bb$export$2e2bcd8739ae039), {
                className: $190a9c16cf03b5b0$export$5f0eed9cd9df5b6a,
                isLoading: isLoading,
                rowGroups: [
                    {
                        key: "users",
                        data: users
                    }
                ],
                rowIndexKey: "id",
                columns: [
                    {
                        title: t("role_details.users.name_column"),
                        dataIndex: "name",
                        colSpan: 5,
                        render: (user)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $55e437438f7e6e4f$export$2e2bcd8739ae039), {
                                user: user
                            })
                    },
                    {
                        title: t("role_details.users.app_column"),
                        dataIndex: "app",
                        colSpan: 5,
                        render: ({ applicationId: applicationId })=>applicationId ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0004ff537e7bb7fe$export$2e2bcd8739ae039), {
                                applicationId: applicationId
                            }) : "-"
                    },
                    {
                        title: t("role_details.users.latest_sign_in_column"),
                        dataIndex: "latestSignIn",
                        colSpan: 5,
                        render: ({ lastSignInAt: lastSignInAt })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $5bc18cf18674bbc6$export$2e2bcd8739ae039), {
                                children: lastSignInAt
                            })
                    },
                    {
                        title: null,
                        dataIndex: "delete",
                        colSpan: 1,
                        render: (user)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $16GE9.default), {
                                content: t("general.remove"),
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                                    onClick: ()=>{
                                        setUserToBeDeleted(user);
                                    },
                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3aa588de5c8665f2$export$2e2bcd8739ae039), {})
                                })
                            })
                    }
                ],
                filter: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: $190a9c16cf03b5b0$export$3dea766d36a8935f,
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $46c375e0973aedf1$export$2e2bcd8739ae039), {
                            defaultValue: keyword,
                            isClearable: Boolean(keyword),
                            placeholder: t("general.search_placeholder"),
                            onSearch: (keyword)=>{
                                updateSearchParameters({
                                    keyword: keyword,
                                    page: 1
                                });
                            },
                            onClearSearch: ()=>{
                                updateSearchParameters({
                                    keyword: "",
                                    page: 1
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                            title: "role_details.users.assign_button",
                            type: "primary",
                            size: "large",
                            icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0b30fe81c923292b$export$2e2bcd8739ae039), {}),
                            onClick: ()=>{
                                setIsAssignModalOpen(true);
                            }
                        })
                    ]
                }),
                pagination: {
                    page: page,
                    pageSize: $d20a0e74f4c6c43b$var$pageSize,
                    totalCount: totalCount,
                    onChange: (page)=>{
                        updateSearchParameters({
                            page: page
                        });
                    }
                },
                placeholder: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a0f84bc7cc69e410$export$2e2bcd8739ae039), {})
            }),
            userToBeDeleted && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dL4NZ.default), {
                isOpen: true,
                isLoading: isDeleting,
                confirmButtonText: "general.remove",
                onCancel: ()=>{
                    setUserToBeDeleted(undefined);
                },
                onConfirm: handleDelete,
                children: t("role_details.users.delete_description")
            }),
            isAssignModalOpen && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $54f8201b3e2ea2cf$export$2e2bcd8739ae039), {
                roleId: roleId,
                roleType: (0, $61Yml.RoleType).User,
                onClose: (success)=>{
                    if (success) mutate();
                    setIsAssignModalOpen(false);
                }
            })
        ]
    });
}
var $d20a0e74f4c6c43b$export$2e2bcd8739ae039 = $d20a0e74f4c6c43b$var$RoleUsers;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
var $5HVJe = parcelRequire("5HVJe");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
parcelRequire("6bq3s");
var $2Phw0 = parcelRequire("2Phw0");

var $voszV = parcelRequire("voszV");











var $8Mb3E = parcelRequire("8Mb3E");

var $jGWQ4 = parcelRequire("jGWQ4");





var $4ZcUR = parcelRequire("4ZcUR");

var $jheqv = parcelRequire("jheqv");

var $7kooT = parcelRequire("7kooT");


var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $kUZ14 = parcelRequire("kUZ14");

var $4ZcUR = parcelRequire("4ZcUR");

var $dW2kG = parcelRequire("dW2kG");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
var $2nQqt = parcelRequire("2nQqt");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");




var $jGWQ4 = parcelRequire("jGWQ4");

var $66ixW = parcelRequire("66ixW");

var $aqmjm = parcelRequire("aqmjm");

var $5vVWy = parcelRequire("5vVWy");


var $fmHmG = parcelRequire("fmHmG");

var $7VnwS = parcelRequire("7VnwS");

var $5OcFi = parcelRequire("5OcFi");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $voszV = parcelRequire("voszV");




var $8TpMk = parcelRequire("8TpMk");


var $jGWQ4 = parcelRequire("jGWQ4");


var $7kooT = parcelRequire("7kooT");
function $c77b64b0449c7b8b$var$Footer({ roleType: roleType, selectedScopesCount: selectedScopesCount, isCreating: isCreating, onClickCreate: onClickCreate }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { currentPlan: currentPlan } = (0, $jC8Vy.useContext)((0, $19434c930f80c964$export$f8addfd4ab69c833));
    const { data: [, roleCount] = [] } = (0, $voszV.default)((0, $8TpMk.isCloud) && (0, $7kooT.buildUrl)("api/roles", {
        page: String(1),
        page_size: String(1),
        type: roleType
    }));
    const hasRoleReachedLimit = (0, $605aee781e0fe83f$export$1cc4b5152472cd4f)({
        quotaKey: roleType === (0, $61Yml.RoleType).User ? "rolesLimit" : "machineToMachineRolesLimit",
        plan: currentPlan,
        usage: roleCount ?? 0
    });
    const hasScopesPerRoleSurpassedLimit = (0, $605aee781e0fe83f$export$6486e974a84ab8b6)({
        quotaKey: "scopesPerRoleLimit",
        plan: currentPlan,
        usage: selectedScopesCount
    });
    if (hasRoleReachedLimit || hasScopesPerRoleSurpassedLimit) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dafa1bad5a99c1ae$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $7i2be.Trans), {
            components: {
                a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a3bc63325dc3c1a8$export$2e2bcd8739ae039), {}),
                planName: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $161f1bf99d56f621$export$2e2bcd8739ae039), {
                    name: currentPlan.name
                })
            },
            children: [
                hasRoleReachedLimit && roleType === (0, $61Yml.RoleType).User && t("upsell.paywall.roles", {
                    count: currentPlan.quota.rolesLimit ?? 0
                }),
                hasRoleReachedLimit && roleType === (0, $61Yml.RoleType).MachineToMachine && t("upsell.paywall.machine_to_machine_roles", {
                    count: currentPlan.quota.machineToMachineRolesLimit ?? 0
                }),
                !hasRoleReachedLimit && hasScopesPerRoleSurpassedLimit && t("upsell.paywall.scopes_per_role", {
                    count: currentPlan.quota.scopesPerRoleLimit ?? 0
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
        isLoading: isCreating,
        htmlType: "submit",
        title: "roles.create_role_button",
        size: "large",
        type: "primary",
        onClick: onClickCreate
    });
}
var $c77b64b0449c7b8b$export$2e2bcd8739ae039 = $c77b64b0449c7b8b$var$Footer;


var $4a66532f94bcff4d$export$5389c3225d6cd45c;
var $4a66532f94bcff4d$export$7834d747dd9f1115;
var $4a66532f94bcff4d$export$32325fe76ee7094c;
var $4a66532f94bcff4d$export$bfd64c937657f93a;
var $4a66532f94bcff4d$export$4a6dd88bada4e7d2;
var $4a66532f94bcff4d$export$74dc5dd4e622afa8;
$4a66532f94bcff4d$export$5389c3225d6cd45c = `IGa9CW_proTag`;
$4a66532f94bcff4d$export$7834d747dd9f1115 = `IGa9CW_roleTypeSelectionSwitch`;
$4a66532f94bcff4d$export$32325fe76ee7094c = `IGa9CW_roleTypes`;
$4a66532f94bcff4d$export$bfd64c937657f93a = `IGa9CW_rotating`;
$4a66532f94bcff4d$export$4a6dd88bada4e7d2 = `IGa9CW_shimmer`;
$4a66532f94bcff4d$export$74dc5dd4e622afa8 = `IGa9CW_trailingIcon`;


const $7a9b000d8647a055$var$radioOptions = [
    {
        key: "roles.type_user",
        value: (0, $61Yml.RoleType).User
    },
    {
        key: "roles.type_machine_to_machine",
        value: (0, $61Yml.RoleType).MachineToMachine
    }
];
function $7a9b000d8647a055$var$CreateRoleForm({ onClose: onClose }) {
    const [isTypeSelectorVisible, setIsTypeSelectorVisible] = (0, $jC8Vy.useState)(false);
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { control: control, handleSubmit: handleSubmit, register: register, watch: watch, formState: { isSubmitting: isSubmitting, errors: errors } } = (0, $codQP.useForm)({
        defaultValues: {
            type: (0, $61Yml.RoleType).User
        }
    });
    const api = (0, $7VnwS.default)();
    const onSubmit = handleSubmit((0, $5OcFi.trySubmitSafe)(async ({ name: name, description: description, type: type, scopes: scopes })=>{
        if (isSubmitting) return;
        const payload = {
            name: name,
            description: description,
            type: type,
            scopeIds: (0, $7oDSS.conditional)(scopes.length > 0 && scopes.map(({ id: id })=>id))
        };
        const createdRole = await api.post("api/roles", {
            json: payload
        }).json();
        onClose(createdRole);
    }));
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5vVWy.default), {
        title: "roles.create_role_title",
        subtitle: "roles.create_role_description",
        learnMoreLink: {
            href: "https://docs.logto.io/docs/recipes/rbac/manage-permissions-and-roles#manage-roles",
            targetBlank: "noopener"
        },
        size: "large",
        footer: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c77b64b0449c7b8b$export$2e2bcd8739ae039), {
            roleType: watch("type"),
            selectedScopesCount: watch("scopes", []).length,
            isCreating: isSubmitting,
            onClickCreate: onSubmit
        }),
        onClose: onClose,
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)("form", {
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aqmjm.default), {
                    isRequired: true,
                    title: "roles.role_name",
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                            // eslint-disable-next-line jsx-a11y/no-autofocus
                            autoFocus: true,
                            ...register("name", {
                                required: true,
                                validate: (name)=>name.startsWith((0, $2nQqt.internalRolePrefix)) ? t("errors.create_internal_role_violation") : true
                            }),
                            placeholder: t("roles.role_name_placeholder"),
                            error: errors.name?.message
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                            type: "text",
                            size: "small",
                            title: isTypeSelectorVisible ? "roles.hide_role_type_button_text" : "roles.show_role_type_button_text",
                            trailingIcon: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $4a66532f94bcff4d$export$74dc5dd4e622afa8,
                                children: isTypeSelectorVisible ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4af961ac2fe37cb1$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9342374032a30fe2$export$2e2bcd8739ae039), {})
                            }),
                            className: $4a66532f94bcff4d$export$7834d747dd9f1115,
                            onClick: ()=>{
                                setIsTypeSelectorVisible(!isTypeSelectorVisible);
                            }
                        })
                    ]
                }),
                isTypeSelectorVisible && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                    title: "roles.role_type",
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                        name: "type",
                        control: control,
                        render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $c8e461321115642d$export$2e2bcd8739ae039), {
                                name: name,
                                className: $4a66532f94bcff4d$export$32325fe76ee7094c,
                                value: value,
                                onChange: (value)=>{
                                    onChange(value);
                                },
                                children: $7a9b000d8647a055$var$radioOptions.map(({ key: key, value: value })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $b4b7cf2a2e4180e8$export$2e2bcd8739ae039), {
                                        title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                            forKey: key
                                        }),
                                        value: value
                                    }, value))
                            })
                    })
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                    isRequired: true,
                    title: "roles.role_description",
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                        ...register("description", {
                            required: true
                        }),
                        placeholder: t("roles.role_description_placeholder"),
                        error: Boolean(errors.description)
                    })
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                    title: "roles.assign_permissions",
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                        control: control,
                        name: "scopes",
                        defaultValue: [],
                        render: ({ field: { value: value, onChange: onChange } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $2e97551deecdcf02$export$2e2bcd8739ae039), {
                                roleType: watch("type"),
                                value: value,
                                onChange: onChange
                            })
                    })
                })
            ]
        })
    });
}
var $7a9b000d8647a055$export$2e2bcd8739ae039 = $7a9b000d8647a055$var$CreateRoleForm;


function $8a5e8b6e8109d4e8$var$CreateRoleModal({ onClose: onClose }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const [createdRole, setCreatedRole] = (0, $jC8Vy.useState)();
    const onCreateFormClose = (createdRole)=>{
        if (createdRole) {
            setCreatedRole(createdRole);
            (0, $FuhPC.toast).success(t("roles.role_created", {
                name: createdRole.name
            }));
            return;
        }
        onClose();
    };
    // Show assign role modal after role is created
    if (createdRole) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $54f8201b3e2ea2cf$export$2e2bcd8739ae039), {
        isRemindSkip: true,
        roleId: createdRole.id,
        roleType: createdRole.type,
        onClose: ()=>{
            navigate(`/roles/${createdRole.id}`, {
                replace: true
            });
        }
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        isOpen: true,
        shouldCloseOnEsc: true,
        className: $dW2kG.content,
        overlayClassName: $dW2kG.overlay,
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7a9b000d8647a055$export$2e2bcd8739ae039), {
            onClose: onCreateFormClose
        })
    });
}
var $8a5e8b6e8109d4e8$export$2e2bcd8739ae039 = $8a5e8b6e8109d4e8$var$CreateRoleModal;


var $b156072776b22823$export$6d59db4903f20f7d;
var $b156072776b22823$export$bfd64c937657f93a;
var $b156072776b22823$export$4a6dd88bada4e7d2;
var $b156072776b22823$export$bf9fb029d174d554;
$b156072776b22823$export$6d59db4903f20f7d = `EXktkG_description`;
$b156072776b22823$export$bfd64c937657f93a = `EXktkG_rotating`;
$b156072776b22823$export$4a6dd88bada4e7d2 = `EXktkG_shimmer`;
$b156072776b22823$export$bf9fb029d174d554 = `EXktkG_type`;


const $55baa8353fb3f53b$var$rolesPathname = "/roles";
const $55baa8353fb3f53b$var$createRolePathname = `${$55baa8353fb3f53b$var$rolesPathname}/create`;
const $55baa8353fb3f53b$var$buildDetailsPathname = (id)=>`${$55baa8353fb3f53b$var$rolesPathname}/${id}`;
const $55baa8353fb3f53b$var$pageSize = (0, $8Mb3E.defaultPageSize);
const $55baa8353fb3f53b$var$getRoleIcon = (type, isDarkMode)=>{
    if (type === (0, $61Yml.RoleType).User) return isDarkMode ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0663a2b9fa963923$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4c2e4598d85b0069$export$2e2bcd8739ae039), {});
    return isDarkMode ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8ab60efc5360b57c$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6d851c22506b0fe9$export$2e2bcd8739ae039), {});
};
function $55baa8353fb3f53b$var$Roles() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { search: search } = (0, $2Phw0.useLocation)();
    const { navigate: navigate, match: match } = (0, $4ZcUR.default)();
    const isCreating = match($55baa8353fb3f53b$var$createRolePathname);
    const { getDocumentationUrl: getDocumentationUrl } = (0, $b595fc2f0eccd19a$export$2e2bcd8739ae039)();
    const theme = (0, $jheqv.default)();
    const [{ page: page, keyword: keyword }, updateSearchParameters] = (0, $66a3eb3654f9d141$export$2e2bcd8739ae039)({
        page: 1,
        keyword: ""
    });
    const url = (0, $7kooT.buildUrl)("api/roles", {
        page: String(page),
        page_size: String($55baa8353fb3f53b$var$pageSize),
        ...(0, $7oDSS.conditional)(keyword && {
            search: (0, $7kooT.formatSearchKeyword)(keyword)
        })
    });
    const { data: data, error: error, mutate: mutate } = (0, $voszV.default)(url);
    const isLoading = !data && !error;
    const [roles, totalCount] = data ?? [];
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $998b64ca82ed2460$export$2e2bcd8739ae039), {
        title: {
            title: "roles.title",
            subtitle: "roles.subtitle",
            learnMoreLink: {
                href: "https://docs.logto.io/docs/recipes/rbac/manage-permissions-and-roles#manage-roles",
                targetBlank: "noopener"
            }
        },
        pageMeta: {
            titleKey: "roles.page_title"
        },
        createButton: {
            title: "roles.create",
            onClick: ()=>{
                navigate({
                    pathname: $55baa8353fb3f53b$var$createRolePathname,
                    search: search
                });
            }
        },
        table: {
            rowGroups: [
                {
                    key: "roles",
                    data: roles
                }
            ],
            rowIndexKey: "id",
            isLoading: isLoading,
            errorMessage: error?.body?.message ?? error?.message,
            columns: [
                {
                    title: t("roles.col_roles"),
                    dataIndex: "roles",
                    colSpan: 5,
                    render: ({ id: id, name: name, type: type })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $4d952cae22cb03fc$export$2e2bcd8739ae039), {
                            title: name,
                            to: $55baa8353fb3f53b$var$buildDetailsPathname(id),
                            icon: $55baa8353fb3f53b$var$getRoleIcon(type, theme === (0, $5HVJe.Theme).Dark)
                        })
                },
                {
                    title: t("roles.col_type"),
                    dataIndex: "type",
                    colSpan: 5,
                    render: ({ type: type })=>/*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $b156072776b22823$export$bf9fb029d174d554,
                            children: type === (0, $61Yml.RoleType).User ? t("roles.type_user") : t("roles.type_machine_to_machine")
                        })
                },
                {
                    title: t("roles.col_description"),
                    dataIndex: "description",
                    colSpan: 5,
                    render: ({ description: description })=>/*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $b156072776b22823$export$6d59db4903f20f7d,
                            children: description
                        })
                },
                {
                    title: /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                        children: t("roles.col_assigned_entities")
                    }),
                    dataIndex: "entities",
                    colSpan: 5,
                    render: ({ type: type, featuredUsers: featuredUsers, usersCount: usersCount, featuredApplications: featuredApplications, applicationsCount: applicationsCount })=>{
                        if (type === (0, $61Yml.RoleType).User) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c0759582e0649a0d$export$2e2bcd8739ae039), {
                            entities: featuredUsers,
                            count: usersCount,
                            type: type
                        });
                        return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c0759582e0649a0d$export$2e2bcd8739ae039), {
                            entities: featuredApplications,
                            count: applicationsCount,
                            type: type
                        });
                    }
                }
            ],
            rowClickHandler: ({ id: id })=>{
                navigate($55baa8353fb3f53b$var$buildDetailsPathname(id));
            },
            filter: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $46c375e0973aedf1$export$2e2bcd8739ae039), {
                placeholder: t("roles.search"),
                defaultValue: keyword,
                isClearable: Boolean(keyword),
                onSearch: (keyword)=>{
                    updateSearchParameters({
                        keyword: keyword,
                        page: 1
                    });
                },
                onClearSearch: ()=>{
                    updateSearchParameters({
                        keyword: "",
                        page: 1
                    });
                }
            }),
            pagination: {
                page: page,
                totalCount: totalCount,
                pageSize: $55baa8353fb3f53b$var$pageSize,
                onChange: (page)=>{
                    updateSearchParameters({
                        page: page
                    });
                }
            },
            placeholder: keyword ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a0f84bc7cc69e410$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2b56c00d3802884b$export$2e2bcd8739ae039), {
                image: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ed5f4a9b0d5d1626$export$2e2bcd8739ae039), {}),
                imageDark: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a9b194b780a6cb64$export$2e2bcd8739ae039), {}),
                title: "roles.placeholder_title",
                description: "roles.placeholder_description",
                learnMoreLink: {
                    href: getDocumentationUrl("/docs/recipes/rbac/manage-permissions-and-roles#manage-roles"),
                    targetBlank: "noopener"
                },
                action: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                    title: "roles.create",
                    type: "primary",
                    size: "large",
                    icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0b30fe81c923292b$export$2e2bcd8739ae039), {}),
                    onClick: ()=>{
                        navigate({
                            pathname: $55baa8353fb3f53b$var$createRolePathname,
                            search: search
                        });
                    }
                })
            }),
            onRetry: async ()=>mutate(undefined, true)
        },
        widgets: isCreating && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8a5e8b6e8109d4e8$export$2e2bcd8739ae039), {
            onClose: ()=>{
                navigate({
                    pathname: $55baa8353fb3f53b$var$rolesPathname,
                    search: search
                });
            }
        })
    });
}
var $55baa8353fb3f53b$export$2e2bcd8739ae039 = $55baa8353fb3f53b$var$Roles;


const $8b22258bc8f800c0$export$8e77a375f9a5908e = {
    path: "roles",
    children: [
        {
            index: true,
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $55baa8353fb3f53b$export$2e2bcd8739ae039), {})
        },
        {
            path: "create",
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $55baa8353fb3f53b$export$2e2bcd8739ae039), {})
        },
        {
            path: ":id",
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f040fda8f31ec618$export$2e2bcd8739ae039), {}),
            children: [
                {
                    index: true,
                    element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Navigate), {
                        replace: true,
                        to: (0, $bt3dS.RoleDetailsTabs).Permissions
                    })
                },
                {
                    path: (0, $bt3dS.RoleDetailsTabs).Permissions,
                    element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $46973e31d15845a6$export$2e2bcd8739ae039), {})
                },
                {
                    path: (0, $bt3dS.RoleDetailsTabs).Users,
                    element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $d20a0e74f4c6c43b$export$2e2bcd8739ae039), {})
                },
                {
                    path: (0, $bt3dS.RoleDetailsTabs).M2mApps,
                    element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $61868757709ed06e$export$2e2bcd8739ae039), {})
                },
                {
                    path: (0, $bt3dS.RoleDetailsTabs).General,
                    element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $22e4d8629755ee77$export$2e2bcd8739ae039), {})
                }
            ]
        }
    ]
};



var $C7mD2 = parcelRequire("C7mD2");

var $2Phw0 = parcelRequire("2Phw0");

var $C7mD2 = parcelRequire("C7mD2");

var $voszV = parcelRequire("voszV");


var $8TpMk = parcelRequire("8TpMk");

var $18SWy = parcelRequire("18SWy");




var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $2Phw0 = parcelRequire("2Phw0");



var $dL4NZ = parcelRequire("dL4NZ");


var $7VnwS = parcelRequire("7VnwS");


var $4ZcUR = parcelRequire("4ZcUR");

var $5OcFi = parcelRequire("5OcFi");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("hNGhh");
var $cOUYQ = parcelRequire("cOUYQ");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");


var $fG7L1 = parcelRequire("fG7L1");

var $jGWQ4 = parcelRequire("jGWQ4");
parcelRequire("fIF1D");
var $16GE9 = parcelRequire("16GE9");
var $248b2c95ce5158dc$export$ca2f546e21dcce87;
var $248b2c95ce5158dc$export$eb8ac6f826d2b00;
$248b2c95ce5158dc$export$ca2f546e21dcce87 = `od0qPW_defaultIcon`;
$248b2c95ce5158dc$export$eb8ac6f826d2b00 = `od0qPW_disabledDefaultIcon`;


function $235d7bd503efd00b$var$LivePreviewButton({ size: size, type: type, isDisabled: isDisabled }) {
    const { tenantEndpoint: tenantEndpoint } = (0, $jC8Vy.useContext)((0, $fG7L1.AppDataContext));
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $16GE9.default), {
        content: (0, $7oDSS.conditional)(isDisabled && t("sign_in_exp.preview.live_preview_tip")),
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
            size: size,
            type: type,
            disabled: isDisabled,
            title: "sign_in_exp.preview.live_preview",
            trailingIcon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4bc930fbe25d753c$export$2e2bcd8739ae039), {
                className: (0, $7oDSS.conditional)(type !== "violet" && (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($248b2c95ce5158dc$export$ca2f546e21dcce87, isDisabled && $248b2c95ce5158dc$export$eb8ac6f826d2b00))
            }),
            onClick: ()=>{
                window.open(new URL("/demo-app", tenantEndpoint), "_blank");
            }
        })
    });
}
var $235d7bd503efd00b$export$2e2bcd8739ae039 = $235d7bd503efd00b$var$LivePreviewButton;








var $396b0dda5eff2d4c$export$38e42c68cf43b5d4;
var $396b0dda5eff2d4c$export$789c912f57fe164c;
var $396b0dda5eff2d4c$export$80e4b313e5e6b30d;
var $396b0dda5eff2d4c$export$48c2d0f2f545ac27;
var $396b0dda5eff2d4c$export$bfd64c937657f93a;
var $396b0dda5eff2d4c$export$2e44bf0978869fd4;
var $396b0dda5eff2d4c$export$4a6dd88bada4e7d2;
var $396b0dda5eff2d4c$export$fb184b623420d9be;
$396b0dda5eff2d4c$export$38e42c68cf43b5d4 = `R5BQyG_header`;
$396b0dda5eff2d4c$export$789c912f57fe164c = `R5BQyG_language`;
$396b0dda5eff2d4c$export$80e4b313e5e6b30d = `R5BQyG_nav`;
$396b0dda5eff2d4c$export$48c2d0f2f545ac27 = `R5BQyG_preview`;
$396b0dda5eff2d4c$export$bfd64c937657f93a = `R5BQyG_rotating`;
$396b0dda5eff2d4c$export$2e44bf0978869fd4 = `R5BQyG_selects`;
$396b0dda5eff2d4c$export$4a6dd88bada4e7d2 = `R5BQyG_shimmer`;
$396b0dda5eff2d4c$export$fb184b623420d9be = `R5BQyG_title`;


function $6b09b9283b35ff1b$var$Preview({ isLivePreviewDisabled: isLivePreviewDisabled = false, isLivePreviewEntryInvisible: isLivePreviewEntryInvisible = false, signInExperience: signInExperience, className: className }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { hasSupportNativePlatformTarget: isNativeTabEnabled } = (0, $9d72639ba10eaeeb$export$2e2bcd8739ae039)();
    const [language, setLanguage] = (0, $jC8Vy.useState)("en");
    const [mode, setMode] = (0, $jC8Vy.useState)((0, $5HVJe.Theme).Light);
    const [platform, setPlatform] = (0, $jC8Vy.useState)((0, $c7bba22dd963ec53$export$70866093e58553f7).DesktopWeb);
    const { languages: languages } = (0, $765bafc6430f5f30$export$2e2bcd8739ae039)();
    (0, $jC8Vy.useEffect)(()=>{
        if (!signInExperience?.color.isDarkModeEnabled) setMode((0, $5HVJe.Theme).Light);
    }, [
        mode,
        signInExperience
    ]);
    const availableLanguageOptions = (0, $jC8Vy.useMemo)(()=>{
        const availableLanguageTags = signInExperience && !signInExperience.languageInfo.autoDetect ? languages.filter((languageTag)=>languageTag === signInExperience.languageInfo.fallbackLanguage) : languages;
        return availableLanguageTags.map((languageTag)=>({
                value: languageTag,
                title: (0, $cOUYQ.languages)[languageTag]
            }));
    }, [
        languages,
        signInExperience
    ]);
    (0, $jC8Vy.useEffect)(()=>{
        if (!availableLanguageOptions[0]) return;
        if (!availableLanguageOptions.some(({ value: value })=>value === language)) setLanguage(availableLanguageOptions[0].value);
    }, [
        language,
        availableLanguageOptions
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($396b0dda5eff2d4c$export$48c2d0f2f545ac27, className),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $396b0dda5eff2d4c$export$38e42c68cf43b5d4,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $396b0dda5eff2d4c$export$fb184b623420d9be,
                        children: t("sign_in_exp.preview.title")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $396b0dda5eff2d4c$export$2e44bf0978869fd4,
                        children: [
                            signInExperience?.color.isDarkModeEnabled && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $976b01dd35b7d62e$export$2e2bcd8739ae039), {
                                value: mode,
                                size: "small",
                                onToggle: setMode
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $286a7bc94edef870$export$2e2bcd8739ae039), {
                                className: $396b0dda5eff2d4c$export$789c912f57fe164c,
                                size: "small",
                                value: language,
                                options: availableLanguageOptions,
                                onChange: (value)=>{
                                    if (value) setLanguage(value);
                                }
                            }),
                            !isLivePreviewEntryInvisible && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $235d7bd503efd00b$export$2e2bcd8739ae039), {
                                isDisabled: isLivePreviewDisabled,
                                size: "small"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $26090e0c44b20d28$export$2e2bcd8739ae039), {
                className: $396b0dda5eff2d4c$export$80e4b313e5e6b30d,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                        isActive: platform === (0, $c7bba22dd963ec53$export$70866093e58553f7).DesktopWeb,
                        onClick: ()=>{
                            setPlatform((0, $c7bba22dd963ec53$export$70866093e58553f7).DesktopWeb);
                        },
                        children: t(isNativeTabEnabled ? "sign_in_exp.preview.desktop_web" : "sign_in_exp.preview.desktop")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                        isActive: platform === (0, $c7bba22dd963ec53$export$70866093e58553f7).MobileWeb,
                        onClick: ()=>{
                            setPlatform((0, $c7bba22dd963ec53$export$70866093e58553f7).MobileWeb);
                        },
                        children: t(isNativeTabEnabled ? "sign_in_exp.preview.mobile_web" : "sign_in_exp.preview.mobile")
                    }),
                    isNativeTabEnabled && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                        isActive: platform === (0, $c7bba22dd963ec53$export$70866093e58553f7).Mobile,
                        onClick: ()=>{
                            setPlatform((0, $c7bba22dd963ec53$export$70866093e58553f7).Mobile);
                        },
                        children: t("sign_in_exp.preview.native")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c9efa648520f22cb$export$2e2bcd8739ae039), {
                platform: platform,
                mode: mode,
                language: language,
                signInExperience: signInExperience
            })
        ]
    });
}
var $6b09b9283b35ff1b$export$2e2bcd8739ae039 = $6b09b9283b35ff1b$var$Preview;



var $jC8Vy = parcelRequire("jC8Vy");

parcelRequire("4taJ0");
var $d1NuF = parcelRequire("d1NuF");
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
parcelRequire("12bMu");
var $hRw8F = parcelRequire("hRw8F");
var $7oDSS = parcelRequire("7oDSS");
parcelRequire("cuPVN");
var $8lyC3 = parcelRequire("8lyC3");
var $8643043f1fa1a33d$export$8ce28b52dd68c0b7;
(function(SignInExperienceTab) {
    SignInExperienceTab["Branding"] = "branding";
    SignInExperienceTab["SignUpAndSignIn"] = "sign-up-and-sign-in";
    SignInExperienceTab["Content"] = "content";
    SignInExperienceTab["PasswordPolicy"] = "password-policy";
})($8643043f1fa1a33d$export$8ce28b52dd68c0b7 || ($8643043f1fa1a33d$export$8ce28b52dd68c0b7 = {}));
var $8643043f1fa1a33d$export$69ec1500fb2141d2;
(function(SignUpIdentifier) {
    SignUpIdentifier["Email"] = "email";
    SignUpIdentifier["Phone"] = "phone";
    SignUpIdentifier["Username"] = "username";
    SignUpIdentifier["EmailOrSms"] = "emailOrSms";
    SignUpIdentifier["None"] = "none";
})($8643043f1fa1a33d$export$69ec1500fb2141d2 || ($8643043f1fa1a33d$export$69ec1500fb2141d2 = {}));


const $cf27937a07aeee10$export$370e1bd33b1689cd = Object.values((0, $8643043f1fa1a33d$export$69ec1500fb2141d2));
const $cf27937a07aeee10$export$b0ad61f2357dff83 = Object.values((0, $8lyC3.SignInIdentifier));
const $cf27937a07aeee10$export$6ce44f6619762c02 = {
    [(0, $8643043f1fa1a33d$export$69ec1500fb2141d2).Username]: [
        (0, $8lyC3.SignInIdentifier).Username
    ],
    [(0, $8643043f1fa1a33d$export$69ec1500fb2141d2).Email]: [
        (0, $8lyC3.SignInIdentifier).Email
    ],
    [(0, $8643043f1fa1a33d$export$69ec1500fb2141d2).Phone]: [
        (0, $8lyC3.SignInIdentifier).Phone
    ],
    [(0, $8643043f1fa1a33d$export$69ec1500fb2141d2).EmailOrSms]: [
        (0, $8lyC3.SignInIdentifier).Email,
        (0, $8lyC3.SignInIdentifier).Phone
    ],
    [(0, $8643043f1fa1a33d$export$69ec1500fb2141d2).None]: []
};
const $cf27937a07aeee10$export$c54a2f6297ba7cbe = Object.freeze({
    [(0, $8lyC3.SignInIdentifier).Email]: "sign_in_exp.sign_up_and_sign_in.identifiers_email",
    [(0, $8lyC3.SignInIdentifier).Phone]: "sign_in_exp.sign_up_and_sign_in.identifiers_phone",
    [(0, $8lyC3.SignInIdentifier).Username]: "sign_in_exp.sign_up_and_sign_in.identifiers_username"
});
const $cf27937a07aeee10$export$2d3509a8eccb8b17 = Object.freeze({
    [(0, $8643043f1fa1a33d$export$69ec1500fb2141d2).Email]: "sign_in_exp.sign_up_and_sign_in.identifiers_email",
    [(0, $8643043f1fa1a33d$export$69ec1500fb2141d2).Phone]: "sign_in_exp.sign_up_and_sign_in.identifiers_phone",
    [(0, $8643043f1fa1a33d$export$69ec1500fb2141d2).Username]: "sign_in_exp.sign_up_and_sign_in.identifiers_username",
    [(0, $8643043f1fa1a33d$export$69ec1500fb2141d2).EmailOrSms]: "sign_in_exp.sign_up_and_sign_in.identifiers_email_or_sms",
    [(0, $8643043f1fa1a33d$export$69ec1500fb2141d2).None]: "sign_in_exp.sign_up_and_sign_in.identifiers_none"
});


const $6696e751cd950b0a$var$mapIdentifiersToSignUpIdentifier = (identifiers)=>{
    for (const [signUpIdentifier, mappedIdentifiers] of Object.entries((0, $cf27937a07aeee10$export$6ce44f6619762c02))){
        if ((0, $hRw8F.isSameArray)(identifiers, mappedIdentifiers)) // eslint-disable-next-line no-restricted-syntax
        return signUpIdentifier;
    }
    throw new Error("Invalid identifiers in the sign up settings.");
};
const $6696e751cd950b0a$export$ce2003b7968fffcc = {
    fromSignUp: (data)=>{
        const { identifiers: identifiers, ...signUpData } = data;
        return {
            identifier: $6696e751cd950b0a$var$mapIdentifiersToSignUpIdentifier(identifiers),
            ...signUpData
        };
    },
    toSignUp: (formData)=>{
        const { identifier: identifier, ...signUpFormData } = formData;
        return {
            identifiers: (0, $cf27937a07aeee10$export$6ce44f6619762c02)[identifier],
            ...signUpFormData
        };
    }
};
const $6696e751cd950b0a$export$64f7b79bdbb2c1d4 = {
    fromSignInExperience: (data)=>{
        const { signUp: signUp, signInMode: signInMode, customCss: customCss, branding: branding, passwordPolicy: passwordPolicy } = data;
        return {
            ...data,
            signUp: $6696e751cd950b0a$export$ce2003b7968fffcc.fromSignUp(signUp),
            createAccountEnabled: signInMode !== (0, $61Yml.SignInMode).SignIn,
            customCss: customCss ?? undefined,
            branding: {
                ...branding,
                logoUrl: branding.logoUrl ?? "",
                darkLogoUrl: branding.darkLogoUrl ?? "",
                favicon: branding.favicon ?? ""
            },
            /** Parse password policy with default values. */ passwordPolicy: {
                ...(0, $d1NuF.passwordPolicyGuard).parse(passwordPolicy),
                customWords: passwordPolicy.rejects?.words?.join("\n") ?? "",
                isCustomWordsEnabled: Boolean(passwordPolicy.rejects?.words?.length)
            }
        };
    },
    toSignInExperience: (formData)=>{
        const { branding: branding, createAccountEnabled: createAccountEnabled, signUp: signUp, customCss: customCss, /** Remove the custom words related properties since they are not used in the remote model. */ passwordPolicy: { isCustomWordsEnabled: isCustomWordsEnabled, customWords: customWords, ...passwordPolicy } } = formData;
        return {
            ...formData,
            branding: {
                ...branding,
                // Transform empty string to undefined
                favicon: (0, $7oDSS.conditional)(branding.favicon?.length && branding.favicon),
                logoUrl: (0, $7oDSS.conditional)(branding.logoUrl?.length && branding.logoUrl),
                darkLogoUrl: (0, $7oDSS.conditional)(branding.darkLogoUrl?.length && branding.darkLogoUrl)
            },
            signUp: $6696e751cd950b0a$export$ce2003b7968fffcc.toSignUp(signUp),
            signInMode: createAccountEnabled ? (0, $61Yml.SignInMode).SignInAndRegister : (0, $61Yml.SignInMode).SignIn,
            customCss: customCss?.length ? customCss : null,
            passwordPolicy: {
                ...passwordPolicy,
                rejects: {
                    ...passwordPolicy.rejects,
                    words: isCustomWordsEnabled ? customWords.split("\n").filter(Boolean) : []
                }
            }
        };
    },
    toUpdateSignInExperienceData: (formData)=>({
            ...$6696e751cd950b0a$export$64f7b79bdbb2c1d4.toSignInExperience(formData),
            mfa: undefined
        })
};


const $85223ff59ae29aa3$var$usePreviewConfigs = (formData, isDirty, data, timeDelay = 400 // Render the preview after the user stops typing in the custom CSS editing box for two seconds.
)=>{
    const debounce = (0, $fe972dea93e1e243$export$2e2bcd8739ae039)(timeDelay);
    const { customCss: customCss, ...restFormData } = formData;
    const [debouncedCustomCss, setDebouncedCustomCss] = (0, $jC8Vy.useState)(customCss);
    (0, $jC8Vy.useEffect)(()=>{
        debounce(()=>{
            setDebouncedCustomCss(customCss);
        });
    }, [
        debounce,
        customCss
    ]);
    return (0, $jC8Vy.useMemo)(()=>{
        if (!isDirty) return data;
        return (0, $6696e751cd950b0a$export$64f7b79bdbb2c1d4).toSignInExperience({
            ...restFormData,
            customCss: debouncedCustomCss
        });
    }, [
        restFormData,
        debouncedCustomCss,
        isDirty,
        data
    ]);
};
var $85223ff59ae29aa3$export$2e2bcd8739ae039 = $85223ff59ae29aa3$var$usePreviewConfigs;




var $C7mD2 = parcelRequire("C7mD2");

var $5TsIB = parcelRequire("5TsIB");

var $C7mD2 = parcelRequire("C7mD2");

var $eb74774cb151a3dd$export$bfd64c937657f93a;
var $eb74774cb151a3dd$export$4a6dd88bada4e7d2;
var $eb74774cb151a3dd$export$bda7fe321f6bbcf1;
$eb74774cb151a3dd$export$bfd64c937657f93a = `yNlmJq_rotating`;
$eb74774cb151a3dd$export$4a6dd88bada4e7d2 = `yNlmJq_shimmer`;
$eb74774cb151a3dd$export$bda7fe321f6bbcf1 = `yNlmJq_tabContent`;


function $85f28dcf05dc2c5d$var$SignInExperienceTabWrapper({ children: children, ...reset }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $03bc4af79519e411$export$2e2bcd8739ae039), {
        ...reset,
        className: $eb74774cb151a3dd$export$bda7fe321f6bbcf1,
        children: children
    });
}
var $85f28dcf05dc2c5d$export$2e2bcd8739ae039 = $85f28dcf05dc2c5d$var$SignInExperienceTabWrapper;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("4taJ0");
var $gS6ii = parcelRequire("gS6ii");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $jGWQ4 = parcelRequire("jGWQ4");

var $gC7hG = parcelRequire("gC7hG");


var $8R7rc = parcelRequire("8R7rc");

var $aqmjm = parcelRequire("aqmjm");

var $8RfrQ = parcelRequire("8RfrQ");

var $fmHmG = parcelRequire("fmHmG");



var $cRLgg = parcelRequire("cRLgg");

var $C7mD2 = parcelRequire("C7mD2");

var $66ixW = parcelRequire("66ixW");
var $a173139a243e27fa$export$bfd64c937657f93a;
var $a173139a243e27fa$export$4a6dd88bada4e7d2;
var $a173139a243e27fa$export$fb184b623420d9be;
$a173139a243e27fa$export$bfd64c937657f93a = `MAlhiG_rotating`;
$a173139a243e27fa$export$4a6dd88bada4e7d2 = `MAlhiG_shimmer`;
$a173139a243e27fa$export$fb184b623420d9be = `MAlhiG_title`;


function $188993d9a1b43b27$var$FormSectionTitle({ title: title }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: $a173139a243e27fa$export$fb184b623420d9be,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
            forKey: `sign_in_exp.${title}`
        })
    });
}
var $188993d9a1b43b27$export$2e2bcd8739ae039 = $188993d9a1b43b27$var$FormSectionTitle;



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");


var $8b0d7e1e0ecb0a39$export$34e0f9847d4c02dd;
var $8b0d7e1e0ecb0a39$export$6d59db4903f20f7d;
var $8b0d7e1e0ecb0a39$export$a3bc9b8ed74fc;
var $8b0d7e1e0ecb0a39$export$2db776e97d65a417;
var $8b0d7e1e0ecb0a39$export$8a0fd8301fa867af;
var $8b0d7e1e0ecb0a39$export$bfd64c937657f93a;
var $8b0d7e1e0ecb0a39$export$4a6dd88bada4e7d2;
var $8b0d7e1e0ecb0a39$export$7472b0d4ff79ef04;
$8b0d7e1e0ecb0a39$export$34e0f9847d4c02dd = `_66Qfba_container`;
$8b0d7e1e0ecb0a39$export$6d59db4903f20f7d = `_66Qfba_description`;
$8b0d7e1e0ecb0a39$export$a3bc9b8ed74fc = `_66Qfba_error`;
$8b0d7e1e0ecb0a39$export$2db776e97d65a417 = `_66Qfba_faviconUploader`;
$8b0d7e1e0ecb0a39$export$8a0fd8301fa867af = `_66Qfba_logoUploader`;
$8b0d7e1e0ecb0a39$export$bfd64c937657f93a = `_66Qfba_rotating`;
$8b0d7e1e0ecb0a39$export$4a6dd88bada4e7d2 = `_66Qfba_shimmer`;
$8b0d7e1e0ecb0a39$export$7472b0d4ff79ef04 = `_66Qfba_uploader`;


function $c1329782b91d8ac6$var$LogoAndFaviconUploader() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [uploadLogoError, setUploadLogoError] = (0, $jC8Vy.useState)();
    const [uploadFaviconError, setUploadFaviconError] = (0, $jC8Vy.useState)();
    const { control: control } = (0, $codQP.useFormContext)();
    const { description: description } = (0, $75ebfd707e0e1bc0$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $8b0d7e1e0ecb0a39$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $8b0d7e1e0ecb0a39$export$7472b0d4ff79ef04,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $8b0d7e1e0ecb0a39$export$8a0fd8301fa867af,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                            control: control,
                            name: "branding.logoUrl",
                            render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $d986fdd56af49b28$export$2e2bcd8739ae039), {
                                    name: name,
                                    value: value ?? "",
                                    actionDescription: t("sign_in_exp.branding.logo_image"),
                                    onCompleted: onChange,
                                    onUploadErrorChange: setUploadLogoError,
                                    onDelete: ()=>{
                                        onChange("");
                                    }
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $8b0d7e1e0ecb0a39$export$2db776e97d65a417,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                            control: control,
                            name: "branding.favicon",
                            render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $d986fdd56af49b28$export$2e2bcd8739ae039), {
                                    name: name,
                                    value: value ?? "",
                                    actionDescription: t("sign_in_exp.branding.favicon"),
                                    onCompleted: onChange,
                                    onUploadErrorChange: setUploadFaviconError,
                                    onDelete: ()=>{
                                        onChange("");
                                    }
                                })
                        })
                    })
                ]
            }),
            uploadLogoError && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($8b0d7e1e0ecb0a39$export$6d59db4903f20f7d, $8b0d7e1e0ecb0a39$export$a3bc9b8ed74fc),
                children: t("sign_in_exp.branding.logo_image_error", {
                    error: uploadLogoError
                })
            }),
            uploadFaviconError && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($8b0d7e1e0ecb0a39$export$6d59db4903f20f7d, $8b0d7e1e0ecb0a39$export$a3bc9b8ed74fc),
                children: t("sign_in_exp.branding.favicon_error", {
                    error: uploadFaviconError
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $8b0d7e1e0ecb0a39$export$6d59db4903f20f7d,
                children: description
            })
        ]
    });
}
var $c1329782b91d8ac6$export$2e2bcd8739ae039 = $c1329782b91d8ac6$var$LogoAndFaviconUploader;


var $efd352980ea39695$export$63edcefea1e7341;
var $efd352980ea39695$export$bfd64c937657f93a;
var $efd352980ea39695$export$4a6dd88bada4e7d2;
$efd352980ea39695$export$63edcefea1e7341 = `IXqKQG_darkModeTip`;
$efd352980ea39695$export$bfd64c937657f93a = `IXqKQG_rotating`;
$efd352980ea39695$export$4a6dd88bada4e7d2 = `IXqKQG_shimmer`;


function $69cd3aca4d6e6ef7$var$BrandingForm() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { isReady: isUserAssetsServiceReady } = (0, $04111409d75abad4$export$2e2bcd8739ae039)();
    const { watch: watch, register: register, setValue: setValue, control: control, formState: { errors: errors, isDirty: isDirty } } = (0, $codQP.useFormContext)();
    const isDarkModeEnabled = watch("color.isDarkModeEnabled");
    const primaryColor = watch("color.primaryColor");
    const darkPrimaryColor = watch("color.darkPrimaryColor");
    const calculatedDarkPrimaryColor = (0, $jC8Vy.useMemo)(()=>{
        return (0, $gS6ii.generateDarkColor)(primaryColor);
    }, [
        primaryColor
    ]);
    const handleResetColor = (0, $jC8Vy.useCallback)(()=>{
        setValue("color.darkPrimaryColor", calculatedDarkPrimaryColor);
    }, [
        calculatedDarkPrimaryColor,
        setValue
    ]);
    (0, $jC8Vy.useEffect)(()=>{
        if (!isDirty) return;
        // If it's enabled, the original dark mode color won't change, users need to click "reset".
        if (!isDarkModeEnabled) handleResetColor();
    }, [
        handleResetColor,
        isDarkModeEnabled,
        isDirty
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $188993d9a1b43b27$export$2e2bcd8739ae039), {
                title: "branding.title"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: "sign_in_exp.color.primary_color",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                    name: "color.primaryColor",
                    control: control,
                    render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $41f023d5b4e5db66$export$2e2bcd8739ae039), {
                            value: value,
                            onChange: onChange
                        })
                })
            }),
            isUserAssetsServiceReady ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $8R7rc.default), {
                    children: [
                        t("sign_in_exp.branding.logo_image"),
                        " & ",
                        t("sign_in_exp.branding.favicon")
                    ]
                }),
                headlineSpacing: "large",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c1329782b91d8ac6$export$2e2bcd8739ae039), {})
            }) : /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        title: "sign_in_exp.branding.logo_image_url",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                            ...register("branding.logoUrl", {
                                validate: (value)=>!value || (0, $cRLgg.uriValidator)(value) || t("errors.invalid_uri_format")
                            }),
                            error: errors.branding?.logoUrl?.message,
                            placeholder: t("sign_in_exp.branding.logo_image_url_placeholder")
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        title: "sign_in_exp.branding.favicon",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                            ...register("branding.favicon", {
                                validate: (value)=>!value || (0, $cRLgg.uriValidator)(value) || t("errors.invalid_uri_format")
                            }),
                            error: errors.branding?.favicon?.message,
                            placeholder: t("sign_in_exp.branding.favicon")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: "sign_in_exp.color.dark_mode",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8RfrQ.default), {
                    label: t("sign_in_exp.color.dark_mode_description"),
                    ...register("color.isDarkModeEnabled")
                })
            }),
            isDarkModeEnabled && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aqmjm.default), {
                        title: "sign_in_exp.color.dark_primary_color",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                                name: "color.darkPrimaryColor",
                                control: control,
                                render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $41f023d5b4e5db66$export$2e2bcd8739ae039), {
                                        value: value,
                                        onChange: onChange
                                    })
                            }),
                            calculatedDarkPrimaryColor !== darkPrimaryColor && /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                className: $efd352980ea39695$export$63edcefea1e7341,
                                children: [
                                    t("sign_in_exp.color.dark_mode_reset_tip"),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                                        type: "text",
                                        size: "small",
                                        title: "sign_in_exp.color.reset",
                                        onClick: handleResetColor
                                    })
                                ]
                            })
                        ]
                    }),
                    isUserAssetsServiceReady ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        title: "sign_in_exp.branding.dark_logo_image",
                        headlineSpacing: "large",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                            name: "branding.darkLogoUrl",
                            control: control,
                            render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $ab5b5e61d391674b$export$2e2bcd8739ae039), {
                                    name: name,
                                    value: value ?? "",
                                    actionDescription: t("sign_in_exp.branding.dark_logo_image"),
                                    onChange: onChange
                                })
                        })
                    }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        title: "sign_in_exp.branding.dark_logo_image_url",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                            ...register("branding.darkLogoUrl", {
                                validate: (value)=>!value || (0, $cRLgg.uriValidator)(value) || t("errors.invalid_uri_format")
                            }),
                            error: errors.branding?.darkLogoUrl?.message,
                            placeholder: t("sign_in_exp.branding.dark_logo_image_url_placeholder")
                        })
                    })
                ]
            })
        ]
    });
}
var $69cd3aca4d6e6ef7$export$2e2bcd8739ae039 = $69cd3aca4d6e6ef7$var$BrandingForm;



var $C7mD2 = parcelRequire("C7mD2");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $gC7hG = parcelRequire("gC7hG");

var $kUskP = parcelRequire("kUskP");

var $aqmjm = parcelRequire("aqmjm");

var $9Q3SI = parcelRequire("9Q3SI");


var $225373a6f4ccfea9$export$9652dd019aefa3a6;
$225373a6f4ccfea9$export$9652dd019aefa3a6 = `_84-wRa_customCssCodeEditor`;


function $ecda4674ea1c66e6$var$CustomCssForm() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $b595fc2f0eccd19a$export$2e2bcd8739ae039)();
    const { control: control } = (0, $codQP.useFormContext)();
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $188993d9a1b43b27$export$2e2bcd8739ae039), {
                title: "custom_css.title"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: "sign_in_exp.custom_css.css_code_editor_title",
                tip: (closeTipHandler)=>/*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                children: t("sign_in_exp.custom_css.css_code_editor_description1")
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                                    components: {
                                        a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                                            targetBlank: "noopener",
                                            href: getDocumentationUrl("/docs/recipes/customize-sie/custom-css"),
                                            onClick: closeTipHandler
                                        })
                                    },
                                    children: t("sign_in_exp.custom_css.css_code_editor_description2", {
                                        link: t("sign_in_exp.custom_css.css_code_editor_description_link_content")
                                    })
                                })
                            })
                        ]
                    }),
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                    name: "customCss",
                    control: control,
                    render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $kUskP.default), {
                            className: $225373a6f4ccfea9$export$9652dd019aefa3a6,
                            language: "scss",
                            value: value ?? undefined,
                            placeholder: t("sign_in_exp.custom_css.css_code_editor_content_placeholder"),
                            onChange: onChange
                        })
                })
            })
        ]
    });
}
var $ecda4674ea1c66e6$export$2e2bcd8739ae039 = $ecda4674ea1c66e6$var$CustomCssForm;


function $6b5e540e24475bee$var$Branding({ isActive: isActive }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $85f28dcf05dc2c5d$export$2e2bcd8739ae039), {
        isActive: isActive,
        children: [
            isActive && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5TsIB.default), {
                titleKey: [
                    "sign_in_exp.tabs.branding",
                    "sign_in_exp.page_title"
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $69cd3aca4d6e6ef7$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ecda4674ea1c66e6$export$2e2bcd8739ae039), {})
        ]
    });
}
var $6b5e540e24475bee$export$2e2bcd8739ae039 = $6b5e540e24475bee$var$Branding;



var $C7mD2 = parcelRequire("C7mD2");

var $5TsIB = parcelRequire("5TsIB");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("hNGhh");
var $cOUYQ = parcelRequire("cOUYQ");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $voszV = parcelRequire("voszV");

var $gC7hG = parcelRequire("gC7hG");

var $aqmjm = parcelRequire("aqmjm");


var $8RfrQ = parcelRequire("8RfrQ");



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $jGWQ4 = parcelRequire("jGWQ4");

var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $kUZ14 = parcelRequire("kUZ14");

var $HHYyb = parcelRequire("HHYyb");

var $gC7hG = parcelRequire("gC7hG");

var $18SWy = parcelRequire("18SWy");

var $dL4NZ = parcelRequire("dL4NZ");

var $75SRw = parcelRequire("75SRw");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("hNGhh");
var $cOUYQ = parcelRequire("cOUYQ");



var $299ff32b8000178f$exports = {};
"use strict";
var $299ff32b8000178f$var$isMergeableObject = function isMergeableObject(value) {
    return $299ff32b8000178f$var$isNonNullObject(value) && !$299ff32b8000178f$var$isSpecial(value);
};
function $299ff32b8000178f$var$isNonNullObject(value) {
    return !!value && typeof value === "object";
}
function $299ff32b8000178f$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || $299ff32b8000178f$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $299ff32b8000178f$var$canUseSymbol = typeof Symbol === "function" && Symbol.for;
var $299ff32b8000178f$var$REACT_ELEMENT_TYPE = $299ff32b8000178f$var$canUseSymbol ? Symbol.for("react.element") : 0xeac7;
function $299ff32b8000178f$var$isReactElement(value) {
    return value.$$typeof === $299ff32b8000178f$var$REACT_ELEMENT_TYPE;
}
function $299ff32b8000178f$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $299ff32b8000178f$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $299ff32b8000178f$var$deepmerge($299ff32b8000178f$var$emptyTarget(value), value, options) : value;
}
function $299ff32b8000178f$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $299ff32b8000178f$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $299ff32b8000178f$var$getMergeFunction(key, options) {
    if (!options.customMerge) return $299ff32b8000178f$var$deepmerge;
    var customMerge = options.customMerge(key);
    return typeof customMerge === "function" ? customMerge : $299ff32b8000178f$var$deepmerge;
}
function $299ff32b8000178f$var$getEnumerableOwnPropertySymbols(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return target.propertyIsEnumerable(symbol);
    }) : [];
}
function $299ff32b8000178f$var$getKeys(target) {
    return Object.keys(target).concat($299ff32b8000178f$var$getEnumerableOwnPropertySymbols(target));
}
function $299ff32b8000178f$var$propertyIsOnObject(object, property) {
    try {
        return property in object;
    } catch (_) {
        return false;
    }
}
// Protects from prototype poisoning and unexpected merging up the prototype chain.
function $299ff32b8000178f$var$propertyIsUnsafe(target, key) {
    return $299ff32b8000178f$var$propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
     && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
     && Object.propertyIsEnumerable.call(target, key) // and also unsafe if they're nonenumerable.
    );
}
function $299ff32b8000178f$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) $299ff32b8000178f$var$getKeys(target).forEach(function(key) {
        destination[key] = $299ff32b8000178f$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    $299ff32b8000178f$var$getKeys(source).forEach(function(key) {
        if ($299ff32b8000178f$var$propertyIsUnsafe(target, key)) return;
        if ($299ff32b8000178f$var$propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = $299ff32b8000178f$var$getMergeFunction(key, options)(target[key], source[key], options);
        else destination[key] = $299ff32b8000178f$var$cloneUnlessOtherwiseSpecified(source[key], options);
    });
    return destination;
}
function $299ff32b8000178f$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $299ff32b8000178f$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $299ff32b8000178f$var$isMergeableObject;
    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
    // implementations can use it. The caller may not replace it.
    options.cloneUnlessOtherwiseSpecified = $299ff32b8000178f$var$cloneUnlessOtherwiseSpecified;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $299ff32b8000178f$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $299ff32b8000178f$var$mergeObject(target, source, options);
}
$299ff32b8000178f$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error("first argument should be an array");
    return array.reduce(function(prev, next) {
        return $299ff32b8000178f$var$deepmerge(prev, next, options);
    }, {});
};
var $299ff32b8000178f$var$deepmerge_1 = $299ff32b8000178f$var$deepmerge;
$299ff32b8000178f$exports = $299ff32b8000178f$var$deepmerge_1;



var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $voszV = parcelRequire("voszV");
var $hgWIN = parcelRequire("hgWIN");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $b002b5cd44c2dd97$var$SvgClear = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.49 7.005a2 2 0 0 1 1.973-1.672h7.074a2 2 0 0 1 1.973 1.672l.889 5.333a2 2 0 0 1-1.973 2.329H3.574a2 2 0 0 1-1.973-2.33l.889-5.332Zm1.973-.338a.667.667 0 0 0-.658.557l-.889 5.333a.667.667 0 0 0 .658.776h8.852c.412 0 .725-.37.657-.776l-.889-5.333a.667.667 0 0 0-.657-.557H4.463Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6 3.333a2 2 0 1 1 4 0v2H8.667v-2a.667.667 0 0 0-1.334 0v2H6v-2Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M4 12a.667.667 0 0 1 1.333 0v1.334a.667.667 0 0 1-1.333 0V12ZM6.667 12A.667.667 0 1 1 8 12v1.333a.667.667 0 1 1-1.333 0V12Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 2.667,
                y: 8,
                width: 10.667,
                height: 1.333,
                rx: 0.667,
                fill: "currentColor"
            })
        ]
    });
var $b002b5cd44c2dd97$export$2e2bcd8739ae039 = $b002b5cd44c2dd97$var$SvgClear;




var $jGWQ4 = parcelRequire("jGWQ4");

var $dL4NZ = parcelRequire("dL4NZ");

var $75SRw = parcelRequire("75SRw");



parcelRequire("fIF1D");
var $16GE9 = parcelRequire("16GE9");

var $7VnwS = parcelRequire("7VnwS");



var $5OcFi = parcelRequire("5OcFi");

var $fe7c68c46bee90ce$export$52aab205873de00;
var $fe7c68c46bee90ce$export$de39a1795fbdd05e;
var $fe7c68c46bee90ce$export$34e0f9847d4c02dd;
var $fe7c68c46bee90ce$export$a7db06668cad9adb;
var $fe7c68c46bee90ce$export$c774a32f4013ebd1;
var $fe7c68c46bee90ce$export$adb608be33961c98;
var $fe7c68c46bee90ce$export$7c37e2db16dd3b00;
var $fe7c68c46bee90ce$export$c0aced386536f657;
var $fe7c68c46bee90ce$export$b975f624cdc70b60;
var $fe7c68c46bee90ce$export$bfd64c937657f93a;
var $fe7c68c46bee90ce$export$ab4de3b61da72174;
var $fe7c68c46bee90ce$export$db08678d9f357d0c;
var $fe7c68c46bee90ce$export$9ec472074ce7d308;
var $fe7c68c46bee90ce$export$1a952fe22cdce89e;
var $fe7c68c46bee90ce$export$4a6dd88bada4e7d2;
var $fe7c68c46bee90ce$export$e7d47881ec916f76;
var $fe7c68c46bee90ce$export$fb184b623420d9be;
$fe7c68c46bee90ce$export$52aab205873de00 = `mFK_Wq_clearButton`;
$fe7c68c46bee90ce$export$de39a1795fbdd05e = `mFK_Wq_clearIcon`;
$fe7c68c46bee90ce$export$34e0f9847d4c02dd = `mFK_Wq_container`;
$fe7c68c46bee90ce$export$a7db06668cad9adb = `mFK_Wq_content`;
$fe7c68c46bee90ce$export$c774a32f4013ebd1 = `mFK_Wq_customValuesColumn`;
$fe7c68c46bee90ce$export$adb608be33961c98 = `mFK_Wq_footer`;
$fe7c68c46bee90ce$export$7c37e2db16dd3b00 = `mFK_Wq_inputCell`;
$fe7c68c46bee90ce$export$c0aced386536f657 = `mFK_Wq_languageDetails`;
$fe7c68c46bee90ce$export$b975f624cdc70b60 = `mFK_Wq_languageInfo`;
$fe7c68c46bee90ce$export$bfd64c937657f93a = `mFK_Wq_rotating`;
$fe7c68c46bee90ce$export$ab4de3b61da72174 = `mFK_Wq_sectionBuiltInText`;
$fe7c68c46bee90ce$export$db08678d9f357d0c = `mFK_Wq_sectionDataKey`;
$fe7c68c46bee90ce$export$9ec472074ce7d308 = `mFK_Wq_sectionInputArea`;
$fe7c68c46bee90ce$export$1a952fe22cdce89e = `mFK_Wq_sectionTitle`;
$fe7c68c46bee90ce$export$4a6dd88bada4e7d2 = `mFK_Wq_shimmer`;
$fe7c68c46bee90ce$export$e7d47881ec916f76 = `mFK_Wq_tableWrapper`;
$fe7c68c46bee90ce$export$fb184b623420d9be = `mFK_Wq_title`;


const $80ec5caeb882ab62$export$3ce3630e4723edc4 = [
    "development_tenant"
];
const $80ec5caeb882ab62$export$c187cc910ee1951e = [];


parcelRequire("12bMu");
var $3dBAh = parcelRequire("3dBAh");

var $jC8Vy = parcelRequire("jC8Vy");
const $f698e367ce920b6d$export$af8e7b825b344e4f = (0, $jC8Vy.createContext)({
    selectedLanguage: "en",
    preSelectedLanguage: undefined,
    preAddedLanguage: undefined,
    isDirty: false,
    confirmationState: "none",
    setSelectedLanguage: (0, $3dBAh.noop),
    setPreSelectedLanguage: (0, $3dBAh.noop),
    setPreAddedLanguage: (0, $3dBAh.noop),
    setIsDirty: (0, $3dBAh.noop),
    setConfirmationState: (0, $3dBAh.noop)
});
const $f698e367ce920b6d$var$useLanguageEditorContext = ()=>{
    const [selectedLanguage, setSelectedLanguage] = (0, $jC8Vy.useState)("en");
    const [preSelectedLanguage, setPreSelectedLanguage] = (0, $jC8Vy.useState)();
    const [preAddedLanguage, setPreAddedLanguage] = (0, $jC8Vy.useState)();
    const [isDirty, setIsDirty] = (0, $jC8Vy.useState)(false);
    const [confirmationState, setConfirmationState] = (0, $jC8Vy.useState)("none");
    const context = (0, $jC8Vy.useMemo)(()=>({
            selectedLanguage: selectedLanguage,
            preSelectedLanguage: preSelectedLanguage,
            preAddedLanguage: preAddedLanguage,
            isDirty: isDirty,
            confirmationState: confirmationState,
            setSelectedLanguage: setSelectedLanguage,
            setPreSelectedLanguage: setPreSelectedLanguage,
            setPreAddedLanguage: setPreAddedLanguage,
            setIsDirty: setIsDirty,
            setConfirmationState: setConfirmationState
        }), [
        confirmationState,
        isDirty,
        preAddedLanguage,
        preSelectedLanguage,
        selectedLanguage
    ]);
    return {
        context: context,
        Provider: $f698e367ce920b6d$export$af8e7b825b344e4f.Provider
    };
};
var $f698e367ce920b6d$export$2e2bcd8739ae039 = $f698e367ce920b6d$var$useLanguageEditorContext;



const $10e57c00d9cc1c39$export$6284419e04300199 = (translation, keyPrefix = "")=>Object.keys(translation).reduce((result, key)=>{
        const prefix = keyPrefix ? `${keyPrefix}.` : keyPrefix;
        const unwrappedKey = `${prefix}${key}`;
        const unwrapped = translation[key];
        return unwrapped === undefined ? result : {
            ...result,
            ...typeof unwrapped === "string" ? {
                [unwrappedKey]: unwrapped
            } : $10e57c00d9cc1c39$export$6284419e04300199(unwrapped, unwrappedKey)
        };
    }, {});
const $10e57c00d9cc1c39$var$emptyTranslation = (translation)=>Object.entries(translation).reduce((result, [key, value])=>{
        return typeof value === "string" ? {
            ...result,
            [key]: ""
        } : {
            ...result,
            [key]: $10e57c00d9cc1c39$var$emptyTranslation(value)
        };
    }, {});
const $10e57c00d9cc1c39$export$9bb7f6e016453b9a = ()=>$10e57c00d9cc1c39$var$emptyTranslation((0, $4d64353670dee0c6$export$2e2bcd8739ae039).translation);


const $5496cf431b01915d$var$emptyUiTranslation = (0, $10e57c00d9cc1c39$export$9bb7f6e016453b9a)();
function $5496cf431b01915d$var$LanguageDetails() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: signInExperience } = (0, $voszV.default)("api/sign-in-exp");
    const { languages: languages } = (0, $765bafc6430f5f30$export$2e2bcd8739ae039)();
    const { selectedLanguage: selectedLanguage, isDirty: isDirty, setIsDirty: setIsDirty, setSelectedLanguage: setSelectedLanguage } = (0, $jC8Vy.useContext)((0, $f698e367ce920b6d$export$af8e7b825b344e4f));
    const [isDeletionAlertOpen, setIsDeletionAlertOpen] = (0, $jC8Vy.useState)(false);
    const isBuiltIn = (0, $38b3e04b52b2e7eb$export$562f9b4f03c85f6c)(selectedLanguage);
    const isDefaultLanguage = signInExperience?.languageInfo.fallbackLanguage === selectedLanguage;
    const fetchApi = (0, $7VnwS.default)({
        hideErrorToast: true
    });
    const fetcher = (0, $04c74fc7d2f91811$export$2e2bcd8739ae039)(fetchApi);
    const translationData = (0, $jC8Vy.useMemo)(()=>Object.entries((isBuiltIn ? (0, $38b3e04b52b2e7eb$export$2e2bcd8739ae039)[selectedLanguage] : (0, $4d64353670dee0c6$export$2e2bcd8739ae039)).translation).filter(// eslint-disable-next-line no-restricted-syntax
        ([groupKey])=>!(0, $80ec5caeb882ab62$export$3ce3630e4723edc4).includes(groupKey)).map(([groupKey, value])=>({
                key: groupKey,
                label: groupKey,
                labelClassName: $fe7c68c46bee90ce$export$1a952fe22cdce89e,
                data: Object.entries((0, $10e57c00d9cc1c39$export$6284419e04300199)(value)).filter(([phraseKey])=>// eslint-disable-next-line no-restricted-syntax
                    !(0, $80ec5caeb882ab62$export$c187cc910ee1951e).includes(`${groupKey}.${phraseKey}`)).map(([phraseKey, value])=>({
                        phraseKey: phraseKey,
                        sourceValue: value,
                        fieldKey: `${groupKey}.${phraseKey}`
                    }))
            })), [
        isBuiltIn,
        selectedLanguage
    ]);
    const { data: customPhrase, mutate: mutate } = (0, $voszV.default)(`api/custom-phrases/${selectedLanguage}`, {
        fetcher: fetcher,
        shouldRetryOnError: (0, $d3d6bc7d2607318c$export$9ea285d0c158d4f1)({
            ignore: [
                404
            ]
        })
    });
    const defaultFormValues = (0, $jC8Vy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($299ff32b8000178f$exports)))($5496cf431b01915d$var$emptyUiTranslation, customPhrase?.translation ?? {}), [
        customPhrase
    ]);
    const { handleSubmit: handleSubmit, reset: reset, setValue: setValue, register: register, formState: { isSubmitting: isSubmitting, isDirty: isFormStateDirty, dirtyFields: dirtyFields } } = (0, $codQP.useForm)({
        defaultValues: defaultFormValues
    });
    (0, $jC8Vy.useEffect)(()=>{
        /**
     * Note: This is a workaround for dirty state checking,
     * for the `isDirty` state does not work correctly when comparing form data with empty / undefined values.
     * Reference: https://github.com/react-hook-form/react-hook-form/issues/4740
     */ setIsDirty(isFormStateDirty && Object.keys(dirtyFields).length > 0);
    }, [
        /**
     * Note: `isDirty` is used to trigger this `useEffect`; for `dirtyFields` object only marks filed dirty at field level.
     * When `dirtyFields` is changed from `{keyA: false}` to `{keyA: true}`, this `useEffect` won't be triggered.
     */ isFormStateDirty,
        dirtyFields,
        setIsDirty
    ]);
    const { mutate: globalMutate } = (0, $hgWIN.useSWRConfig)();
    const api = (0, $7VnwS.default)();
    const upsertCustomPhrase = (0, $jC8Vy.useCallback)(async (languageTag, translation)=>{
        const updatedCustomPhrase = await api.put(`api/custom-phrases/${languageTag}`, {
            json: {
                ...(0, (/*@__PURE__*/$parcel$interopDefault($9c80b3e301b9e290$exports)))(translation)
            }
        }).json();
        globalMutate("api/custom-phrases");
        return updatedCustomPhrase;
    }, [
        api,
        globalMutate
    ]);
    const onConfirmDeletion = (0, $jC8Vy.useCallback)(async ()=>{
        setIsDeletionAlertOpen(false);
        if (isDefaultLanguage) return;
        await api.delete(`api/custom-phrases/${selectedLanguage}`);
        await globalMutate("api/custom-phrases");
        setIsDirty(false);
        setSelectedLanguage(languages.find((languageTag)=>languageTag !== selectedLanguage) ?? "en");
    }, [
        api,
        globalMutate,
        isDefaultLanguage,
        languages,
        selectedLanguage,
        setIsDirty,
        setSelectedLanguage
    ]);
    const onSubmit = handleSubmit((0, $5OcFi.trySubmitSafe)(async (formData)=>{
        const updatedCustomPhrase = await upsertCustomPhrase(selectedLanguage, formData);
        reset(updatedCustomPhrase.translation);
        mutate(updatedCustomPhrase);
        (0, $FuhPC.toast).success(t("general.saved"));
    }));
    (0, $jC8Vy.useEffect)(()=>{
        if (isDirty) return;
        reset(defaultFormValues);
    }, [
        /**
     * Note: trigger form reset when selectedLanguage changed,
     * for the `defaultValues` will not change when switching between languages with unavailable custom phrases.
     */ selectedLanguage,
        defaultFormValues,
        reset,
        isDirty
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $fe7c68c46bee90ce$export$c0aced386536f657,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $fe7c68c46bee90ce$export$fb184b623420d9be,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $fe7c68c46bee90ce$export$b975f624cdc70b60,
                        children: [
                            (0, $cOUYQ.languages)[selectedLanguage],
                            /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                                children: selectedLanguage
                            }),
                            isBuiltIn && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
                                children: t("sign_in_exp.content.manage_language.logto_provided")
                            })
                        ]
                    }),
                    !isBuiltIn && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $16GE9.default), {
                        content: t("sign_in_exp.content.manage_language.deletion_tip"),
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                            onClick: ()=>{
                                setIsDeletionAlertOpen(true);
                            },
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3aa588de5c8665f2$export$2e2bcd8739ae039), {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $fe7c68c46bee90ce$export$34e0f9847d4c02dd,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3166f28a681c41bb$export$2e2bcd8739ae039), {
                        isRowHoverEffectDisabled: true,
                        className: $fe7c68c46bee90ce$export$a7db06668cad9adb,
                        headerTableClassName: $fe7c68c46bee90ce$export$e7d47881ec916f76,
                        bodyTableWrapperClassName: $fe7c68c46bee90ce$export$e7d47881ec916f76,
                        rowIndexKey: "phraseKey",
                        rowGroups: translationData,
                        columns: [
                            {
                                title: t("sign_in_exp.content.manage_language.key"),
                                dataIndex: "phraseKey",
                                render: ({ phraseKey: phraseKey })=>phraseKey,
                                className: $fe7c68c46bee90ce$export$db08678d9f357d0c
                            },
                            {
                                title: t("sign_in_exp.content.manage_language.logto_source_values"),
                                dataIndex: "sourceValue",
                                render: ({ sourceValue: sourceValue })=>/*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $fe7c68c46bee90ce$export$ab4de3b61da72174,
                                        children: sourceValue
                                    })
                            },
                            {
                                title: /*#__PURE__*/ (0, $C7mD2.jsxs)("span", {
                                    className: $fe7c68c46bee90ce$export$c774a32f4013ebd1,
                                    children: [
                                        t("sign_in_exp.content.manage_language.custom_values"),
                                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $16GE9.default), {
                                            anchorClassName: $fe7c68c46bee90ce$export$52aab205873de00,
                                            content: t("sign_in_exp.content.manage_language.clear_all_tip"),
                                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                                                size: "small",
                                                onClick: ()=>{
                                                    for (const [key, value] of Object.entries((0, $10e57c00d9cc1c39$export$6284419e04300199)($5496cf431b01915d$var$emptyUiTranslation)))setValue(key, value, {
                                                        shouldDirty: true
                                                    });
                                                },
                                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $b002b5cd44c2dd97$export$2e2bcd8739ae039), {
                                                    className: $fe7c68c46bee90ce$export$de39a1795fbdd05e
                                                })
                                            })
                                        })
                                    ]
                                }),
                                dataIndex: "fieldKey",
                                render: ({ fieldKey: fieldKey })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $813ca3f2d2f09d2e$export$2e2bcd8739ae039), {
                                        className: $fe7c68c46bee90ce$export$9ec472074ce7d308,
                                        ...register(fieldKey)
                                    }),
                                className: $fe7c68c46bee90ce$export$7c37e2db16dd3b00
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $fe7c68c46bee90ce$export$adb608be33961c98,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                            isLoading: isSubmitting,
                            type: "primary",
                            title: "general.save",
                            onClick: async ()=>onSubmit()
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dL4NZ.default), {
                isOpen: isDeletionAlertOpen,
                title: isDefaultLanguage ? "sign_in_exp.content.manage_language.default_language_deletion_title" : "sign_in_exp.content.manage_language.deletion_title",
                confirmButtonText: isDefaultLanguage ? "general.got_it" : "general.delete",
                confirmButtonType: isDefaultLanguage ? "primary" : "danger",
                onCancel: ()=>{
                    setIsDeletionAlertOpen(false);
                },
                onConfirm: onConfirmDeletion,
                children: isDefaultLanguage ? t("sign_in_exp.content.manage_language.default_language_deletion_description", {
                    language: (0, $cOUYQ.languages)[selectedLanguage]
                }) : t("sign_in_exp.content.manage_language.deletion_description")
            })
        ]
    });
}
var $5496cf431b01915d$export$2e2bcd8739ae039 = $5496cf431b01915d$var$LanguageDetails;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("hNGhh");
var $cOUYQ = parcelRequire("cOUYQ");
var $eRB1v = parcelRequire("eRB1v");

var $jC8Vy = parcelRequire("jC8Vy");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("hNGhh");
var $cOUYQ = parcelRequire("cOUYQ");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");



var $jGWQ4 = parcelRequire("jGWQ4");

var $66ixW = parcelRequire("66ixW");

var $aTllQ = parcelRequire("aTllQ");

var $fmHmG = parcelRequire("fmHmG");

var $bnkR4 = parcelRequire("bnkR4");
var $ecaf3dafd3eea16a$export$bb37e2b647b67cbf;
var $ecaf3dafd3eea16a$export$ac9988d300f6ef8a;
var $ecaf3dafd3eea16a$export$bd4558eab3154e95;
var $ecaf3dafd3eea16a$export$7541d60b826a3a96;
var $ecaf3dafd3eea16a$export$b7e3ae3d7c15e42e;
var $ecaf3dafd3eea16a$export$77849bfc92d943c2;
var $ecaf3dafd3eea16a$export$79c0f9d0f5163be1;
var $ecaf3dafd3eea16a$export$ac0adb53061a7575;
var $ecaf3dafd3eea16a$export$d650c0dc24ac0d6b;
var $ecaf3dafd3eea16a$export$bfd64c937657f93a;
var $ecaf3dafd3eea16a$export$4a6dd88bada4e7d2;
$ecaf3dafd3eea16a$export$bb37e2b647b67cbf = `hqOtrW_addLanguageButton`;
$ecaf3dafd3eea16a$export$ac9988d300f6ef8a = `hqOtrW_buttonIcon`;
$ecaf3dafd3eea16a$export$bd4558eab3154e95 = `hqOtrW_dropDown`;
$ecaf3dafd3eea16a$export$7541d60b826a3a96 = `hqOtrW_dropDownItem`;
$ecaf3dafd3eea16a$export$b7e3ae3d7c15e42e = `hqOtrW_input`;
$ecaf3dafd3eea16a$export$77849bfc92d943c2 = `hqOtrW_languageName`;
$ecaf3dafd3eea16a$export$79c0f9d0f5163be1 = `hqOtrW_languageSelector`;
$ecaf3dafd3eea16a$export$ac0adb53061a7575 = `hqOtrW_languageTag`;
$ecaf3dafd3eea16a$export$d650c0dc24ac0d6b = `hqOtrW_noDataPlaceholder`;
$ecaf3dafd3eea16a$export$bfd64c937657f93a = `hqOtrW_rotating`;
$ecaf3dafd3eea16a$export$4a6dd88bada4e7d2 = `hqOtrW_shimmer`;


function $d2447b2c9827a0ee$var$AddLanguageSelector({ options: options, onSelect: onSelect }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const selectorRef = (0, $jC8Vy.useRef)(null);
    const searchInputRef = (0, $jC8Vy.useRef)(null);
    const [isDropDownOpen, setIsDropDownOpen] = (0, $jC8Vy.useState)(false);
    const [searchInputValue, setSearchInputValue] = (0, $jC8Vy.useState)("");
    const filteredOptions = searchInputValue ? options.filter((languageTag)=>languageTag.toLocaleLowerCase().includes(searchInputValue.toLocaleLowerCase()) || (0, $cOUYQ.languages)[languageTag].toLocaleLowerCase().includes(searchInputValue.toLocaleLowerCase())) : options;
    const clickOutsideHandler = ({ target: target })=>{
        if (target instanceof HTMLElement && !selectorRef.current?.contains(target)) {
            setIsDropDownOpen(false);
            setSearchInputValue("");
        }
    };
    (0, $jC8Vy.useEffect)(()=>{
        if (isDropDownOpen) {
            searchInputRef.current?.focus();
            document.addEventListener("mousedown", clickOutsideHandler);
        } else document.removeEventListener("mousedown", clickOutsideHandler);
        return ()=>{
            if (isDropDownOpen) document.removeEventListener("mousedown", clickOutsideHandler);
        };
    }, [
        isDropDownOpen,
        searchInputRef
    ]);
    const handleSelect = (languageTag)=>{
        onSelect(languageTag);
        setIsDropDownOpen(false);
        setSearchInputValue("");
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        ref: selectorRef,
        className: $ecaf3dafd3eea16a$export$79c0f9d0f5163be1,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $ecaf3dafd3eea16a$export$b7e3ae3d7c15e42e,
                children: isDropDownOpen ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                    ref: searchInputRef,
                    icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $45ba7f7cad465e3f$export$2e2bcd8739ae039), {
                        className: $ecaf3dafd3eea16a$export$ac9988d300f6ef8a
                    }),
                    placeholder: t("general.type_to_search"),
                    value: searchInputValue,
                    onChange: (event)=>{
                        setSearchInputValue(event.target.value);
                    }
                }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                    className: $ecaf3dafd3eea16a$export$bb37e2b647b67cbf,
                    icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0b30fe81c923292b$export$2e2bcd8739ae039), {
                        className: $ecaf3dafd3eea16a$export$ac9988d300f6ef8a
                    }),
                    title: "sign_in_exp.content.manage_language.add_language",
                    type: "default",
                    size: "medium",
                    onClick: ()=>{
                        setIsDropDownOpen(true);
                    }
                })
            }),
            isDropDownOpen && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aTllQ.default), {
                className: $ecaf3dafd3eea16a$export$bd4558eab3154e95,
                children: filteredOptions.length === 0 ? /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $ecaf3dafd3eea16a$export$d650c0dc24ac0d6b,
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                        forKey: "errors.empty"
                    })
                }) : filteredOptions.map((languageTag)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        role: "tab",
                        tabIndex: 0,
                        className: $ecaf3dafd3eea16a$export$7541d60b826a3a96,
                        onKeyDown: (0, $bnkR4.onKeyDownHandler)(()=>{
                            handleSelect(languageTag);
                        }),
                        onClick: ()=>{
                            handleSelect(languageTag);
                        },
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $ecaf3dafd3eea16a$export$77849bfc92d943c2,
                                children: (0, $cOUYQ.languages)[languageTag]
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $ecaf3dafd3eea16a$export$ac0adb53061a7575,
                                children: languageTag
                            })
                        ]
                    }, languageTag))
            })
        ]
    });
}
var $d2447b2c9827a0ee$export$2e2bcd8739ae039 = $d2447b2c9827a0ee$var$AddLanguageSelector;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("hNGhh");
var $cOUYQ = parcelRequire("cOUYQ");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $bnkR4 = parcelRequire("bnkR4");
var $44c00ef86e46001b$export$23a6eccff7614b43;
var $44c00ef86e46001b$export$77849bfc92d943c2;
var $44c00ef86e46001b$export$ac0adb53061a7575;
var $44c00ef86e46001b$export$bfd64c937657f93a;
var $44c00ef86e46001b$export$d90250155de6d7e7;
var $44c00ef86e46001b$export$4a6dd88bada4e7d2;
$44c00ef86e46001b$export$23a6eccff7614b43 = `taG0zG_languageItem`;
$44c00ef86e46001b$export$77849bfc92d943c2 = `taG0zG_languageName`;
$44c00ef86e46001b$export$ac0adb53061a7575 = `taG0zG_languageTag`;
$44c00ef86e46001b$export$bfd64c937657f93a = `taG0zG_rotating`;
$44c00ef86e46001b$export$d90250155de6d7e7 = `taG0zG_selected`;
$44c00ef86e46001b$export$4a6dd88bada4e7d2 = `taG0zG_shimmer`;


function $b620a7a66e281ee1$var$LanguageItem({ languageTag: languageTag, isSelected: isSelected, onClick: onClick }) {
    const itemRef = (0, $jC8Vy.useRef)(null);
    (0, $jC8Vy.useEffect)(()=>{
        if (isSelected) itemRef.current?.scrollIntoView({
            block: "nearest",
            behavior: "smooth"
        });
    }, [
        isSelected
    ]);
    const handleSelect = ()=>{
        if (isSelected) return;
        onClick();
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        ref: itemRef,
        role: "tab",
        tabIndex: 0,
        "aria-selected": isSelected,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($44c00ef86e46001b$export$23a6eccff7614b43, isSelected && $44c00ef86e46001b$export$d90250155de6d7e7),
        onClick: handleSelect,
        onKeyDown: (0, $bnkR4.onKeyDownHandler)(handleSelect),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $44c00ef86e46001b$export$77849bfc92d943c2,
                children: (0, $cOUYQ.languages)[languageTag]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $44c00ef86e46001b$export$ac0adb53061a7575,
                children: languageTag
            })
        ]
    });
}
var $b620a7a66e281ee1$export$2e2bcd8739ae039 = $b620a7a66e281ee1$var$LanguageItem;


var $d8274cf528093283$export$97e05aa5bd0f5a81;
var $d8274cf528093283$export$ad0bd5ce9a315472;
var $d8274cf528093283$export$bfd64c937657f93a;
var $d8274cf528093283$export$4a6dd88bada4e7d2;
$d8274cf528093283$export$97e05aa5bd0f5a81 = `G0xB0W_languageItemList`;
$d8274cf528093283$export$ad0bd5ce9a315472 = `G0xB0W_languageNav`;
$d8274cf528093283$export$bfd64c937657f93a = `G0xB0W_rotating`;
$d8274cf528093283$export$4a6dd88bada4e7d2 = `G0xB0W_shimmer`;



function $557f4858cd480cbd$var$LanguageNav() {
    const { languages: languages, addLanguage: addLanguage } = (0, $765bafc6430f5f30$export$2e2bcd8739ae039)();
    const { selectedLanguage: selectedLanguage, isDirty: isDirty, setConfirmationState: setConfirmationState, setSelectedLanguage: setSelectedLanguage, setPreSelectedLanguage: setPreSelectedLanguage, setPreAddedLanguage: setPreAddedLanguage } = (0, $jC8Vy.useContext)((0, $f698e367ce920b6d$export$af8e7b825b344e4f));
    const languageOptions = Object.keys((0, $cOUYQ.languages)).filter((languageTag)=>(0, $eRB1v.isLanguageTag)(languageTag) && !languages.includes(languageTag));
    const onAddLanguage = async (languageTag)=>{
        if (isDirty) {
            setPreAddedLanguage(languageTag);
            setConfirmationState("try-add-language");
            return;
        }
        await addLanguage(languageTag);
        setSelectedLanguage(languageTag);
    };
    const onSwitchLanguage = (languageTag)=>{
        if (isDirty) {
            setPreSelectedLanguage(languageTag);
            setConfirmationState("try-switch-language");
            return;
        }
        setSelectedLanguage(languageTag);
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $d8274cf528093283$export$ad0bd5ce9a315472,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $d2447b2c9827a0ee$export$2e2bcd8739ae039), {
                options: languageOptions,
                onSelect: onAddLanguage
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $d8274cf528093283$export$97e05aa5bd0f5a81,
                children: languages.map((languageTag)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $b620a7a66e281ee1$export$2e2bcd8739ae039), {
                        languageTag: languageTag,
                        isSelected: selectedLanguage === languageTag,
                        onClick: ()=>{
                            onSwitchLanguage(languageTag);
                        }
                    }, languageTag))
            })
        ]
    });
}
var $557f4858cd480cbd$export$2e2bcd8739ae039 = $557f4858cd480cbd$var$LanguageNav;


var $fa8ba965d2f4e5eb$export$a7db06668cad9adb;
var $fa8ba965d2f4e5eb$export$b5d042d2b680aed6;
var $fa8ba965d2f4e5eb$export$38e42c68cf43b5d4;
var $fa8ba965d2f4e5eb$export$add244bda2f9423c;
var $fa8ba965d2f4e5eb$export$70c017da01953e13;
var $fa8ba965d2f4e5eb$export$bfd64c937657f93a;
var $fa8ba965d2f4e5eb$export$4a6dd88bada4e7d2;
$fa8ba965d2f4e5eb$export$a7db06668cad9adb = `_0c66Ga_content`;
$fa8ba965d2f4e5eb$export$b5d042d2b680aed6 = `_0c66Ga_editor`;
$fa8ba965d2f4e5eb$export$38e42c68cf43b5d4 = `_0c66Ga_header`;
$fa8ba965d2f4e5eb$export$add244bda2f9423c = `_0c66Ga_modalContent`;
$fa8ba965d2f4e5eb$export$70c017da01953e13 = `_0c66Ga_modalOverlay`;
$fa8ba965d2f4e5eb$export$bfd64c937657f93a = `_0c66Ga_rotating`;
$fa8ba965d2f4e5eb$export$4a6dd88bada4e7d2 = `_0c66Ga_shimmer`;



function $4a84ef162ae3a920$var$LanguageEditorModal({ isOpen: isOpen, onClose: onClose }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { languages: languages, addLanguage: addLanguage } = (0, $765bafc6430f5f30$export$2e2bcd8739ae039)();
    const defaultSelectedLanguage = languages[0] ?? "en";
    const { preSelectedLanguage: preSelectedLanguage, preAddedLanguage: preAddedLanguage, isDirty: isDirty, confirmationState: confirmationState, setSelectedLanguage: setSelectedLanguage, setPreSelectedLanguage: setPreSelectedLanguage, setPreAddedLanguage: setPreAddedLanguage, setConfirmationState: setConfirmationState, setIsDirty: setIsDirty } = (0, $jC8Vy.useContext)((0, $f698e367ce920b6d$export$af8e7b825b344e4f));
    (0, $jC8Vy.useEffect)(()=>{
        setSelectedLanguage(defaultSelectedLanguage);
    }, [
        defaultSelectedLanguage,
        setSelectedLanguage
    ]);
    const onCloseModal = ()=>{
        if (isDirty) {
            setConfirmationState("try-close");
            return;
        }
        onClose();
        setSelectedLanguage(languages[0] ?? "en");
    };
    const onConfirmUnsavedChanges = async ()=>{
        if (confirmationState === "try-close") onClose();
        if (confirmationState === "try-switch-language" && preSelectedLanguage) {
            setSelectedLanguage(preSelectedLanguage);
            setPreSelectedLanguage(undefined);
        }
        if (confirmationState === "try-add-language" && preAddedLanguage) {
            await addLanguage(preAddedLanguage);
            setSelectedLanguage(preAddedLanguage);
            setPreAddedLanguage(undefined);
        }
        setConfirmationState("none");
        setIsDirty(false);
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        shouldCloseOnEsc: true,
        isOpen: isOpen,
        className: $fa8ba965d2f4e5eb$export$add244bda2f9423c,
        overlayClassName: $fa8ba965d2f4e5eb$export$70c017da01953e13,
        onRequestClose: onCloseModal,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
                className: $fa8ba965d2f4e5eb$export$b5d042d2b680aed6,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $fa8ba965d2f4e5eb$export$38e42c68cf43b5d4,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $18SWy.default), {
                                title: "sign_in_exp.content.manage_language.title",
                                subtitle: "sign_in_exp.content.manage_language.subtitle"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                                onClick: onCloseModal,
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $HHYyb.default), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $fa8ba965d2f4e5eb$export$a7db06668cad9adb,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $557f4858cd480cbd$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5496cf431b01915d$export$2e2bcd8739ae039), {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dL4NZ.default), {
                isOpen: confirmationState !== "none",
                cancelButtonText: "general.stay_on_page",
                confirmButtonText: "general.leave_page",
                onCancel: ()=>{
                    setConfirmationState("none");
                },
                onConfirm: onConfirmUnsavedChanges,
                children: t("sign_in_exp.content.manage_language.unsaved_description")
            })
        ]
    });
}
function $4a84ef162ae3a920$var$LanguageEditor(props) {
    const { context: languageEditorContext, Provider: LanguageEditorContextProvider } = (0, $f698e367ce920b6d$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $C7mD2.jsx)(LanguageEditorContextProvider, {
        value: languageEditorContext,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)($4a84ef162ae3a920$var$LanguageEditorModal, {
            ...props
        })
    });
}
var $4a84ef162ae3a920$export$2e2bcd8739ae039 = $4a84ef162ae3a920$var$LanguageEditor;


function $75d5a4f2fddb7b8f$var$ManageLanguageButton({ className: className }) {
    const [isLanguageEditorOpen, setIsLanguageEditorOpen] = (0, $jC8Vy.useState)(false);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                type: "text",
                size: "small",
                title: "sign_in_exp.content.languages.manage_language",
                className: className,
                onClick: ()=>{
                    setIsLanguageEditorOpen(true);
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4a84ef162ae3a920$export$2e2bcd8739ae039), {
                isOpen: isLanguageEditorOpen,
                onClose: ()=>{
                    setIsLanguageEditorOpen(false);
                }
            })
        ]
    });
}
var $75d5a4f2fddb7b8f$export$2e2bcd8739ae039 = $75d5a4f2fddb7b8f$var$ManageLanguageButton;


var $76e2d1c8c2847d96$export$3742d6e2000a7562;
var $76e2d1c8c2847d96$export$25d6b38b5bfe0b7;
var $76e2d1c8c2847d96$export$bfd64c937657f93a;
var $76e2d1c8c2847d96$export$4a6dd88bada4e7d2;
var $76e2d1c8c2847d96$export$fb184b623420d9be;
$76e2d1c8c2847d96$export$3742d6e2000a7562 = `_9_FG3q_defaultLanguageDescription`;
$76e2d1c8c2847d96$export$25d6b38b5bfe0b7 = `_9_FG3q_manageLanguageButton`;
$76e2d1c8c2847d96$export$bfd64c937657f93a = `_9_FG3q_rotating`;
$76e2d1c8c2847d96$export$4a6dd88bada4e7d2 = `_9_FG3q_shimmer`;
$76e2d1c8c2847d96$export$fb184b623420d9be = `_9_FG3q_title`;


function $81f1d3b1a9622e27$var$LanguagesForm({ isManageLanguageVisible: isManageLanguageVisible = false }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: signInExperience } = (0, $voszV.default)("api/sign-in-exp");
    const { watch: watch, control: control, register: register, setValue: setValue } = (0, $codQP.useFormContext)();
    const isAutoDetect = watch("languageInfo.autoDetect");
    const selectedDefaultLanguage = watch("languageInfo.fallbackLanguage");
    const { languages: languages } = (0, $765bafc6430f5f30$export$2e2bcd8739ae039)();
    const languageOptions = (0, $jC8Vy.useMemo)(()=>{
        return languages.map((languageTag)=>({
                value: languageTag,
                title: (0, $cOUYQ.languages)[languageTag]
            }));
    }, [
        languages
    ]);
    (0, $jC8Vy.useEffect)(()=>{
        if (!languages.includes(selectedDefaultLanguage)) setValue("languageInfo.fallbackLanguage", signInExperience?.languageInfo.fallbackLanguage ?? "en");
    }, [
        languages,
        selectedDefaultLanguage,
        setValue,
        signInExperience
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $188993d9a1b43b27$export$2e2bcd8739ae039), {
                title: "content.languages.title"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aqmjm.default), {
                title: "sign_in_exp.content.languages.enable_auto_detect",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8RfrQ.default), {
                        ...register("languageInfo.autoDetect"),
                        label: t("sign_in_exp.content.languages.description")
                    }),
                    isManageLanguageVisible && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75d5a4f2fddb7b8f$export$2e2bcd8739ae039), {
                        className: $76e2d1c8c2847d96$export$25d6b38b5bfe0b7
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aqmjm.default), {
                title: "sign_in_exp.content.languages.default_language",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                        name: "languageInfo.fallbackLanguage",
                        control: control,
                        render: ({ field: { value: value, onChange: onChange } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $286a7bc94edef870$export$2e2bcd8739ae039), {
                                value: value,
                                options: languageOptions,
                                onChange: onChange
                            })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $76e2d1c8c2847d96$export$3742d6e2000a7562,
                        children: isAutoDetect ? t("sign_in_exp.content.languages.default_language_description_auto") : t("sign_in_exp.content.languages.default_language_description_fixed")
                    })
                ]
            })
        ]
    });
}
var $81f1d3b1a9622e27$export$2e2bcd8739ae039 = $81f1d3b1a9622e27$var$LanguagesForm;



var $C7mD2 = parcelRequire("C7mD2");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $gC7hG = parcelRequire("gC7hG");

var $aqmjm = parcelRequire("aqmjm");

var $fmHmG = parcelRequire("fmHmG");

var $cRLgg = parcelRequire("cRLgg");

function $4a21f1e1a7ce463f$var$TermsForm() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { register: register, formState: { errors: errors } } = (0, $codQP.useFormContext)();
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $188993d9a1b43b27$export$2e2bcd8739ae039), {
                title: "content.terms_of_use.title"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: "sign_in_exp.content.terms_of_use.terms_of_use",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                    ...register("termsOfUseUrl", {
                        validate: (value)=>!value || (0, $cRLgg.uriValidator)(value) || t("errors.invalid_uri_format")
                    }),
                    error: errors.termsOfUseUrl?.message,
                    placeholder: t("sign_in_exp.content.terms_of_use.terms_of_use_placeholder")
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: "sign_in_exp.content.terms_of_use.privacy_policy",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                    ...register("privacyPolicyUrl", {
                        validate: (value)=>!value || (0, $cRLgg.uriValidator)(value) || t("errors.invalid_uri_format")
                    }),
                    error: errors.termsOfUseUrl?.message,
                    placeholder: t("sign_in_exp.content.terms_of_use.privacy_policy_placeholder")
                })
            })
        ]
    });
}
var $4a21f1e1a7ce463f$export$2e2bcd8739ae039 = $4a21f1e1a7ce463f$var$TermsForm;


function $82c6c9a00dabb956$var$Content({ isActive: isActive }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $85f28dcf05dc2c5d$export$2e2bcd8739ae039), {
        isActive: isActive,
        children: [
            isActive && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5TsIB.default), {
                titleKey: [
                    "sign_in_exp.tabs.content",
                    "sign_in_exp.page_title"
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4a21f1e1a7ce463f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $81f1d3b1a9622e27$export$2e2bcd8739ae039), {
                isManageLanguageVisible: true
            })
        ]
    });
}
var $82c6c9a00dabb956$export$2e2bcd8739ae039 = $82c6c9a00dabb956$var$Content;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("4taJ0");
var $d1NuF = parcelRequire("d1NuF");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $5TsIB = parcelRequire("5TsIB");

var $gC7hG = parcelRequire("gC7hG");


var $aqmjm = parcelRequire("aqmjm");



var $9Q3SI = parcelRequire("9Q3SI");


var $C7mD2 = parcelRequire("C7mD2");
var $27a2a03e1850a13f$export$f71f035a831fd7a7;
var $27a2a03e1850a13f$export$bfd64c937657f93a;
var $27a2a03e1850a13f$export$4a6dd88bada4e7d2;
$27a2a03e1850a13f$export$f71f035a831fd7a7 = `_2v160W_formFieldDescription`;
$27a2a03e1850a13f$export$bfd64c937657f93a = `_2v160W_rotating`;
$27a2a03e1850a13f$export$4a6dd88bada4e7d2 = `_2v160W_shimmer`;


function $69a75ca169b2ed64$var$FormFieldDescription({ children: children }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: $27a2a03e1850a13f$export$f71f035a831fd7a7,
        children: children
    });
}
var $69a75ca169b2ed64$export$2e2bcd8739ae039 = $69a75ca169b2ed64$var$FormFieldDescription;




var $7eb7bed88bcedf0b$export$3dc8b34440fdaec5;
var $7eb7bed88bcedf0b$export$6d59db4903f20f7d;
var $7eb7bed88bcedf0b$export$1237798dc640739a;
var $7eb7bed88bcedf0b$export$8fe860a115a1e636;
var $7eb7bed88bcedf0b$export$a84c34a1d06a6ca3;
var $7eb7bed88bcedf0b$export$bfd64c937657f93a;
var $7eb7bed88bcedf0b$export$4a6dd88bada4e7d2;
var $7eb7bed88bcedf0b$export$a3574df893ffa88d;
var $7eb7bed88bcedf0b$export$fb184b623420d9be;
$7eb7bed88bcedf0b$export$3dc8b34440fdaec5 = `_4qS6hG_characterTypes`;
$7eb7bed88bcedf0b$export$6d59db4903f20f7d = `_4qS6hG_description`;
$7eb7bed88bcedf0b$export$1237798dc640739a = `_4qS6hG_label`;
$7eb7bed88bcedf0b$export$8fe860a115a1e636 = `_4qS6hG_minLength`;
$7eb7bed88bcedf0b$export$a84c34a1d06a6ca3 = `_4qS6hG_passwordOption`;
$7eb7bed88bcedf0b$export$bfd64c937657f93a = `_4qS6hG_rotating`;
$7eb7bed88bcedf0b$export$4a6dd88bada4e7d2 = `_4qS6hG_shimmer`;
$7eb7bed88bcedf0b$export$a3574df893ffa88d = `_4qS6hG_textarea`;
$7eb7bed88bcedf0b$export$fb184b623420d9be = `_4qS6hG_title`;


/** A display component for password policy options with a title and description. */ function $d161730b5fc84495$var$PasswordOption({ name: name, title: title, description: description, children: children }) {
    const { control: control } = (0, $codQP.useFormContext)();
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
        name: name,
        control: control,
        render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $26dc4ab718ba37b7$export$2e2bcd8739ae039), {
                className: $7eb7bed88bcedf0b$export$a84c34a1d06a6ca3,
                label: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: $7eb7bed88bcedf0b$export$1237798dc640739a,
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $7eb7bed88bcedf0b$export$fb184b623420d9be,
                            children: title
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $7eb7bed88bcedf0b$export$6d59db4903f20f7d,
                            children: description
                        }),
                        children
                    ]
                }),
                checked: Boolean(value),
                onChange: onChange
            })
    });
}
function $d161730b5fc84495$var$PasswordPolicy({ isActive: isActive }) {
    const { control: control, register: register, getValues: getValues, formState: { errors: errors } } = (0, $codQP.useFormContext)();
    const max = getValues("passwordPolicy.length.max");
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.sign_in_exp.password_policy"
    });
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $85f28dcf05dc2c5d$export$2e2bcd8739ae039), {
        isActive: isActive,
        children: [
            isActive && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5TsIB.default), {
                titleKey: [
                    "sign_in_exp.tabs.password_policy",
                    "sign_in_exp.page_title"
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $188993d9a1b43b27$export$2e2bcd8739ae039), {
                        title: "password_policy.password_requirements"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aqmjm.default), {
                        title: "sign_in_exp.password_policy.minimum_length",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $69a75ca169b2ed64$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                                    components: {
                                        a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                                            targetBlank: true,
                                            href: "https://pages.nist.gov/800-63-3/sp800-63b.html#sec5"
                                        })
                                    },
                                    children: t("minimum_length_description")
                                })
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                                name: "passwordPolicy.length.min",
                                control: control,
                                rules: {
                                    min: 1,
                                    max: max
                                },
                                render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $1ed54dbe2d43891b$export$2e2bcd8739ae039), {
                                        className: $7eb7bed88bcedf0b$export$8fe860a115a1e636,
                                        name: name,
                                        value: String(value),
                                        min: 1,
                                        max: max,
                                        error: errors.passwordPolicy?.length?.min && t("minimum_length_error", {
                                            min: 1,
                                            max: max
                                        }),
                                        onChange: ({ target: { value: value } })=>{
                                            onChange(value && Number(value));
                                        },
                                        onValueUp: ()=>{
                                            onChange(value + 1);
                                        },
                                        onValueDown: ()=>{
                                            onChange(value - 1);
                                        },
                                        onBlur: ()=>{
                                            if (value < 1) onChange(1);
                                            else if (value > max) onChange(max);
                                        }
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aqmjm.default), {
                        title: "sign_in_exp.password_policy.minimum_required_char_types",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $69a75ca169b2ed64$export$2e2bcd8739ae039), {
                                children: t("minimum_required_char_types_description", {
                                    symbols: (0, $d1NuF.PasswordPolicyChecker).symbols
                                })
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                                name: "passwordPolicy.characterTypes.min",
                                control: control,
                                render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $c8e461321115642d$export$2e2bcd8739ae039), {
                                        name: name,
                                        className: $7eb7bed88bcedf0b$export$3dc8b34440fdaec5,
                                        value: (0, $7oDSS.cond)(value && String(value)),
                                        onChange: (value)=>{
                                            onChange(Number(value));
                                        },
                                        children: [
                                            1,
                                            2,
                                            3,
                                            4
                                        ].map((i)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $b4b7cf2a2e4180e8$export$2e2bcd8739ae039), {
                                                title: /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                                                    children: i
                                                }),
                                                value: String(i)
                                            }, i))
                                    })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $188993d9a1b43b27$export$2e2bcd8739ae039), {
                        title: "password_policy.password_rejection"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        title: "sign_in_exp.password_policy.compromised_passwords",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)($d161730b5fc84495$var$PasswordOption, {
                            name: "passwordPolicy.rejects.pwned",
                            title: t("breached_passwords"),
                            description: t("breached_passwords_description")
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aqmjm.default), {
                        title: "sign_in_exp.password_policy.restricted_phrases",
                        tip: t("restricted_phrases_tooltip"),
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)($d161730b5fc84495$var$PasswordOption, {
                                name: "passwordPolicy.rejects.repetitionAndSequence",
                                title: t("repetitive_or_sequential_characters"),
                                description: t("repetitive_or_sequential_characters_description")
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)($d161730b5fc84495$var$PasswordOption, {
                                name: "passwordPolicy.rejects.userInfo",
                                title: t("user_information"),
                                description: t("user_information_description")
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)($d161730b5fc84495$var$PasswordOption, {
                                name: "passwordPolicy.isCustomWordsEnabled",
                                title: t("custom_words"),
                                description: t("custom_words_description")
                            }),
                            getValues("passwordPolicy.isCustomWordsEnabled") && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $813ca3f2d2f09d2e$export$2e2bcd8739ae039), {
                                className: $7eb7bed88bcedf0b$export$a3574df893ffa88d,
                                rows: 5,
                                placeholder: t("custom_words_placeholder"),
                                ...register("passwordPolicy.customWords")
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $d161730b5fc84495$export$2e2bcd8739ae039 = $d161730b5fc84495$var$PasswordPolicy;



var $C7mD2 = parcelRequire("C7mD2");

var $5TsIB = parcelRequire("5TsIB");


var $C7mD2 = parcelRequire("C7mD2");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $gC7hG = parcelRequire("gC7hG");

var $aqmjm = parcelRequire("aqmjm");

var $8RfrQ = parcelRequire("8RfrQ");

var $9Q3SI = parcelRequire("9Q3SI");

var $84f55bbf0b0516e6$export$bfd64c937657f93a;
var $84f55bbf0b0516e6$export$95dd8163eacc2ed3;
var $84f55bbf0b0516e6$export$de27182ff8187d6c;
var $84f55bbf0b0516e6$export$4a6dd88bada4e7d2;
$84f55bbf0b0516e6$export$bfd64c937657f93a = `K8RUKW_rotating`;
$84f55bbf0b0516e6$export$95dd8163eacc2ed3 = `K8RUKW_setUpHint`;
$84f55bbf0b0516e6$export$de27182ff8187d6c = `K8RUKW_setup`;
$84f55bbf0b0516e6$export$4a6dd88bada4e7d2 = `K8RUKW_shimmer`;


function $f96a067a166ef856$var$AdvancedOptions() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.sign_in_exp.sign_up_and_sign_in.advanced_options"
    });
    const { register: register } = (0, $codQP.useFormContext)();
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $188993d9a1b43b27$export$2e2bcd8739ae039), {
                title: "sign_up_and_sign_in.advanced_options.title"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: "sign_in_exp.sign_up_and_sign_in.advanced_options.enable_single_sign_on",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8RfrQ.default), {
                    ...register("singleSignOnEnabled"),
                    label: t("enable_single_sign_on_description")
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $84f55bbf0b0516e6$export$95dd8163eacc2ed3,
                children: [
                    t("single_sign_on_hint.prefix"),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                        to: "/enterprise-sso",
                        className: $84f55bbf0b0516e6$export$de27182ff8187d6c,
                        children: t("single_sign_on_hint.link")
                    }),
                    t("single_sign_on_hint.suffix")
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: "sign_in_exp.sign_up_and_sign_in.advanced_options.enable_user_registration",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8RfrQ.default), {
                    ...register("createAccountEnabled"),
                    label: t("enable_user_registration_description")
                })
            })
        ]
    });
}
var $f96a067a166ef856$export$2e2bcd8739ae039 = $f96a067a166ef856$var$AdvancedOptions;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $gC7hG = parcelRequire("gC7hG");

var $aqmjm = parcelRequire("aqmjm");



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $8lyC3 = parcelRequire("8lyC3");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");

var $C7mD2 = parcelRequire("C7mD2");

var $azUPN = parcelRequire("azUPN");
function $941ec4f6aa03d6dd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $941ec4f6aa03d6dd$export$2e2bcd8739ae039(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $941ec4f6aa03d6dd$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $azUPN.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $941ec4f6aa03d6dd$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $bbbf76cea1c5a0a3$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $bbbf76cea1c5a0a3$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $bbbf76cea1c5a0a3$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $bbbf76cea1c5a0a3$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $bbbf76cea1c5a0a3$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $bbbf76cea1c5a0a3$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $bbbf76cea1c5a0a3$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $bbbf76cea1c5a0a3$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $bbbf76cea1c5a0a3$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($bbbf76cea1c5a0a3$var$isDate(val)) return "date";
    if ($bbbf76cea1c5a0a3$var$isError(val)) return "error";
    var constructorName = $bbbf76cea1c5a0a3$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $bbbf76cea1c5a0a3$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $bbbf76cea1c5a0a3$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $bbbf76cea1c5a0a3$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $bbbf76cea1c5a0a3$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ function $bbbf76cea1c5a0a3$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($bbbf76cea1c5a0a3$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($bbbf76cea1c5a0a3$var$formatProdErrorMessage(1));
        return enhancer($bbbf76cea1c5a0a3$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($bbbf76cea1c5a0a3$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($bbbf76cea1c5a0a3$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($bbbf76cea1c5a0a3$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($bbbf76cea1c5a0a3$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($bbbf76cea1c5a0a3$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$bbbf76cea1c5a0a3$var$isPlainObject(action)) throw new Error($bbbf76cea1c5a0a3$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($bbbf76cea1c5a0a3$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($bbbf76cea1c5a0a3$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($bbbf76cea1c5a0a3$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $bbbf76cea1c5a0a3$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($bbbf76cea1c5a0a3$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$bbbf76cea1c5a0a3$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $bbbf76cea1c5a0a3$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$bbbf76cea1c5a0a3$var$$$observable] = observable, _ref2;
}
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $bbbf76cea1c5a0a3$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $bbbf76cea1c5a0a3$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $bbbf76cea1c5a0a3$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$bbbf76cea1c5a0a3$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $bbbf76cea1c5a0a3$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $bbbf76cea1c5a0a3$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $bbbf76cea1c5a0a3$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $bbbf76cea1c5a0a3$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($bbbf76cea1c5a0a3$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $bbbf76cea1c5a0a3$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($bbbf76cea1c5a0a3$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $bbbf76cea1c5a0a3$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $bbbf76cea1c5a0a3$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($bbbf76cea1c5a0a3$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $bbbf76cea1c5a0a3$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $bbbf76cea1c5a0a3$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $bbbf76cea1c5a0a3$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($bbbf76cea1c5a0a3$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $bbbf76cea1c5a0a3$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $bbbf76cea1c5a0a3$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $bbbf76cea1c5a0a3$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($bbbf76cea1c5a0a3$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $bbbf76cea1c5a0a3$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $941ec4f6aa03d6dd$export$2e2bcd8739ae039)((0, $941ec4f6aa03d6dd$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}
/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */ function $bbbf76cea1c5a0a3$var$isCrushed() {}


/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ 
var $9fi9T = parcelRequire("9fi9T");
function $79773a7d776aedca$export$f5708dca728d7177(condition, format, ...args) {
    if ($79773a7d776aedca$var$isProduction()) {
        if (format === undefined) throw new Error("invariant requires an error message argument");
    }
    if (!condition) {
        let error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            let argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1 // we don't care about invariant's own frame
        ;
        throw error;
    }
}
function $79773a7d776aedca$var$isProduction() {
    return typeof $9fi9T !== "undefined" && true;
}


// cheap lodash replacements
/**
 * drop-in replacement for _.get
 * @param obj
 * @param path
 * @param defaultValue
 */ function $47cf51fbd9270494$export$3988ae62b71be9a3(obj, path, defaultValue) {
    return path.split(".").reduce((a, c)=>a && a[c] ? a[c] : defaultValue || null, obj);
}
function $47cf51fbd9270494$export$5d14bf425b37f49e(items, item) {
    return items.filter((i)=>i !== item);
}
function $47cf51fbd9270494$export$844ec244b1367d54(input) {
    return typeof input === "string";
}
function $47cf51fbd9270494$export$a6cdc56e425d0d0a(input) {
    return typeof input === "object";
}
function $47cf51fbd9270494$export$6444ef5cd411280c(itemsA, itemsB) {
    const map = new Map();
    const insertItem = (item)=>{
        map.set(item, map.has(item) ? map.get(item) + 1 : 1);
    };
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    const result = [];
    map.forEach((count, key)=>{
        if (count === 1) result.push(key);
    });
    return result;
}
function $47cf51fbd9270494$export$bc86dfbf7795668c(itemsA, itemsB) {
    return itemsA.filter((t)=>itemsB.indexOf(t) > -1);
}


const $dce07c8c698f8b6c$export$3fc3a33e48b33945 = "dnd-core/INIT_COORDS";
const $dce07c8c698f8b6c$export$98f9b4193e6b55e6 = "dnd-core/BEGIN_DRAG";
const $dce07c8c698f8b6c$export$22d1d88e2de0d0e0 = "dnd-core/PUBLISH_DRAG_SOURCE";
const $dce07c8c698f8b6c$export$9d358706ccac3727 = "dnd-core/HOVER";
const $dce07c8c698f8b6c$export$b4af72c40fd57063 = "dnd-core/DROP";
const $dce07c8c698f8b6c$export$d300627d16aeb9cc = "dnd-core/END_DRAG";


function $398c413c9879f38d$export$844048139dfc906d(clientOffset, sourceClientOffset) {
    return {
        type: (0, $dce07c8c698f8b6c$export$3fc3a33e48b33945),
        payload: {
            sourceClientOffset: sourceClientOffset || null,
            clientOffset: clientOffset || null
        }
    };
}



const $dde5c64da28bcac7$var$ResetCoordinatesAction = {
    type: (0, $dce07c8c698f8b6c$export$3fc3a33e48b33945),
    payload: {
        clientOffset: null,
        sourceClientOffset: null
    }
};
function $dde5c64da28bcac7$export$d6542eb0d76867d6(manager) {
    return function beginDrag(sourceIds = [], options = {
        publishSource: true
    }) {
        const { publishSource: publishSource = true, clientOffset: clientOffset, getSourceClientOffset: getSourceClientOffset } = options;
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        // Initialize the coordinates using the client offset
        manager.dispatch((0, $398c413c9879f38d$export$844048139dfc906d)(clientOffset));
        $dde5c64da28bcac7$var$verifyInvariants(sourceIds, monitor, registry);
        // Get the draggable source
        const sourceId = $dde5c64da28bcac7$var$getDraggableSource(sourceIds, monitor);
        if (sourceId == null) {
            manager.dispatch($dde5c64da28bcac7$var$ResetCoordinatesAction);
            return;
        }
        // Get the source client offset
        let sourceClientOffset = null;
        if (clientOffset) {
            if (!getSourceClientOffset) throw new Error("getSourceClientOffset must be defined");
            $dde5c64da28bcac7$var$verifyGetSourceClientOffsetIsFunction(getSourceClientOffset);
            sourceClientOffset = getSourceClientOffset(sourceId);
        }
        // Initialize the full coordinates
        manager.dispatch((0, $398c413c9879f38d$export$844048139dfc906d)(clientOffset, sourceClientOffset));
        const source = registry.getSource(sourceId);
        const item = source.beginDrag(monitor, sourceId);
        // If source.beginDrag returns null, this is an indicator to cancel the drag
        if (item == null) return undefined;
        $dde5c64da28bcac7$var$verifyItemIsObject(item);
        registry.pinSource(sourceId);
        const itemType = registry.getSourceType(sourceId);
        return {
            type: (0, $dce07c8c698f8b6c$export$98f9b4193e6b55e6),
            payload: {
                itemType: itemType,
                item: item,
                sourceId: sourceId,
                clientOffset: clientOffset || null,
                sourceClientOffset: sourceClientOffset || null,
                isSourcePublic: !!publishSource
            }
        };
    };
}
function $dde5c64da28bcac7$var$verifyInvariants(sourceIds, monitor, registry) {
    (0, $79773a7d776aedca$export$f5708dca728d7177)(!monitor.isDragging(), "Cannot call beginDrag while dragging.");
    sourceIds.forEach(function(sourceId) {
        (0, $79773a7d776aedca$export$f5708dca728d7177)(registry.getSource(sourceId), "Expected sourceIds to be registered.");
    });
}
function $dde5c64da28bcac7$var$verifyGetSourceClientOffsetIsFunction(getSourceClientOffset) {
    (0, $79773a7d776aedca$export$f5708dca728d7177)(typeof getSourceClientOffset === "function", "When clientOffset is provided, getSourceClientOffset must be a function.");
}
function $dde5c64da28bcac7$var$verifyItemIsObject(item) {
    (0, $79773a7d776aedca$export$f5708dca728d7177)((0, $47cf51fbd9270494$export$a6cdc56e425d0d0a)(item), "Item must be an object.");
}
function $dde5c64da28bcac7$var$getDraggableSource(sourceIds, monitor) {
    let sourceId = null;
    for(let i = sourceIds.length - 1; i >= 0; i--)if (monitor.canDragSource(sourceIds[i])) {
        sourceId = sourceIds[i];
        break;
    }
    return sourceId;
}





function $1b66493cb4c751c1$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1b66493cb4c751c1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $1b66493cb4c751c1$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $1b66493cb4c751c1$export$9f5cbae8d079dda0(manager) {
    return function drop(options = {}) {
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        $1b66493cb4c751c1$var$verifyInvariants(monitor);
        const targetIds = $1b66493cb4c751c1$var$getDroppableTargets(monitor);
        // Multiple actions are dispatched here, which is why this doesn't return an action
        targetIds.forEach((targetId, index)=>{
            const dropResult = $1b66493cb4c751c1$var$determineDropResult(targetId, index, registry, monitor);
            const action = {
                type: (0, $dce07c8c698f8b6c$export$b4af72c40fd57063),
                payload: {
                    dropResult: $1b66493cb4c751c1$var$_objectSpread({}, options, dropResult)
                }
            };
            manager.dispatch(action);
        });
    };
}
function $1b66493cb4c751c1$var$verifyInvariants(monitor) {
    (0, $79773a7d776aedca$export$f5708dca728d7177)(monitor.isDragging(), "Cannot call drop while not dragging.");
    (0, $79773a7d776aedca$export$f5708dca728d7177)(!monitor.didDrop(), "Cannot call drop twice during one drag operation.");
}
function $1b66493cb4c751c1$var$determineDropResult(targetId, index, registry, monitor) {
    const target = registry.getTarget(targetId);
    let dropResult = target ? target.drop(monitor, targetId) : undefined;
    $1b66493cb4c751c1$var$verifyDropResultType(dropResult);
    if (typeof dropResult === "undefined") dropResult = index === 0 ? {} : monitor.getDropResult();
    return dropResult;
}
function $1b66493cb4c751c1$var$verifyDropResultType(dropResult) {
    (0, $79773a7d776aedca$export$f5708dca728d7177)(typeof dropResult === "undefined" || (0, $47cf51fbd9270494$export$a6cdc56e425d0d0a)(dropResult), "Drop result must either be an object or undefined.");
}
function $1b66493cb4c751c1$var$getDroppableTargets(monitor) {
    const targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
    targetIds.reverse();
    return targetIds;
}




function $89aed5fd66957114$export$2f5c7d4805260fdf(manager) {
    return function endDrag() {
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        $89aed5fd66957114$var$verifyIsDragging(monitor);
        const sourceId = monitor.getSourceId();
        if (sourceId != null) {
            const source = registry.getSource(sourceId, true);
            source.endDrag(monitor, sourceId);
            registry.unpinSource();
        }
        return {
            type: (0, $dce07c8c698f8b6c$export$d300627d16aeb9cc)
        };
    };
}
function $89aed5fd66957114$var$verifyIsDragging(monitor) {
    (0, $79773a7d776aedca$export$f5708dca728d7177)(monitor.isDragging(), "Cannot call endDrag while not dragging.");
}



function $f135a2fefd5900ff$export$2d6239ff106f142f(targetType, draggedItemType) {
    if (draggedItemType === null) return targetType === null;
    return Array.isArray(targetType) ? targetType.some((t)=>t === draggedItemType) : targetType === draggedItemType;
}



function $5c311bea4d2fe434$export$2f85b44a1d72ad03(manager) {
    return function hover(targetIdsArg, { clientOffset: clientOffset } = {}) {
        $5c311bea4d2fe434$var$verifyTargetIdsIsArray(targetIdsArg);
        const targetIds = targetIdsArg.slice(0);
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        $5c311bea4d2fe434$var$checkInvariants(targetIds, monitor, registry);
        const draggedItemType = monitor.getItemType();
        $5c311bea4d2fe434$var$removeNonMatchingTargetIds(targetIds, registry, draggedItemType);
        $5c311bea4d2fe434$var$hoverAllTargets(targetIds, monitor, registry);
        return {
            type: (0, $dce07c8c698f8b6c$export$9d358706ccac3727),
            payload: {
                targetIds: targetIds,
                clientOffset: clientOffset || null
            }
        };
    };
}
function $5c311bea4d2fe434$var$verifyTargetIdsIsArray(targetIdsArg) {
    (0, $79773a7d776aedca$export$f5708dca728d7177)(Array.isArray(targetIdsArg), "Expected targetIds to be an array.");
}
function $5c311bea4d2fe434$var$checkInvariants(targetIds, monitor, registry) {
    (0, $79773a7d776aedca$export$f5708dca728d7177)(monitor.isDragging(), "Cannot call hover while not dragging.");
    (0, $79773a7d776aedca$export$f5708dca728d7177)(!monitor.didDrop(), "Cannot call hover after drop.");
    for(let i = 0; i < targetIds.length; i++){
        const targetId = targetIds[i];
        (0, $79773a7d776aedca$export$f5708dca728d7177)(targetIds.lastIndexOf(targetId) === i, "Expected targetIds to be unique in the passed array.");
        const target = registry.getTarget(targetId);
        (0, $79773a7d776aedca$export$f5708dca728d7177)(target, "Expected targetIds to be registered.");
    }
}
function $5c311bea4d2fe434$var$removeNonMatchingTargetIds(targetIds, registry, draggedItemType) {
    // Remove those targetIds that don't match the targetType.  This
    // fixes shallow isOver which would only be non-shallow because of
    // non-matching targets.
    for(let i = targetIds.length - 1; i >= 0; i--){
        const targetId = targetIds[i];
        const targetType = registry.getTargetType(targetId);
        if (!(0, $f135a2fefd5900ff$export$2d6239ff106f142f)(targetType, draggedItemType)) targetIds.splice(i, 1);
    }
}
function $5c311bea4d2fe434$var$hoverAllTargets(targetIds, monitor, registry) {
    // Finally call hover on all matching targets.
    targetIds.forEach(function(targetId) {
        const target = registry.getTarget(targetId);
        target.hover(monitor, targetId);
    });
}



function $e7e47233fa6fe6c0$export$1675a481db21e714(manager) {
    return function publishDragSource() {
        const monitor = manager.getMonitor();
        if (monitor.isDragging()) return {
            type: (0, $dce07c8c698f8b6c$export$22d1d88e2de0d0e0)
        };
        return;
    };
}



function $5128f7507fab7b64$export$ac1b80e79f04247f(manager) {
    return {
        beginDrag: (0, $dde5c64da28bcac7$export$d6542eb0d76867d6)(manager),
        publishDragSource: (0, $e7e47233fa6fe6c0$export$1675a481db21e714)(manager),
        hover: (0, $5c311bea4d2fe434$export$2f85b44a1d72ad03)(manager),
        drop: (0, $1b66493cb4c751c1$export$9f5cbae8d079dda0)(manager),
        endDrag: (0, $89aed5fd66957114$export$2f5c7d4805260fdf)(manager)
    };
}


class $46b5e205c4a90746$export$1141bbf61324c55f {
    receiveBackend(backend) {
        this.backend = backend;
    }
    getMonitor() {
        return this.monitor;
    }
    getBackend() {
        return this.backend;
    }
    getRegistry() {
        return this.monitor.registry;
    }
    getActions() {
        /* eslint-disable-next-line @typescript-eslint/no-this-alias */ const manager = this;
        const { dispatch: dispatch } = this.store;
        function bindActionCreator(actionCreator) {
            return (...args)=>{
                const action = actionCreator.apply(manager, args);
                if (typeof action !== "undefined") dispatch(action);
            };
        }
        const actions = (0, $5128f7507fab7b64$export$ac1b80e79f04247f)(this);
        return Object.keys(actions).reduce((boundActions, key)=>{
            const action = actions[key];
            boundActions[key] = bindActionCreator(action);
            return boundActions;
        }, {});
    }
    dispatch(action) {
        this.store.dispatch(action);
    }
    constructor(store, monitor){
        this.isSetUp = false;
        this.handleRefCountChange = ()=>{
            const shouldSetUp = this.store.getState().refCount > 0;
            if (this.backend) {
                if (shouldSetUp && !this.isSetUp) {
                    this.backend.setup();
                    this.isSetUp = true;
                } else if (!shouldSetUp && this.isSetUp) {
                    this.backend.teardown();
                    this.isSetUp = false;
                }
            }
        };
        this.store = store;
        this.monitor = monitor;
        store.subscribe(this.handleRefCountChange);
    }
}



/**
 * Coordinate addition
 * @param a The first coordinate
 * @param b The second coordinate
 */ function $6e8f5d01e1cbc355$export$e16d8520af44a096(a, b) {
    return {
        x: a.x + b.x,
        y: a.y + b.y
    };
}
function $6e8f5d01e1cbc355$export$4e2d2ead65e5f7e3(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $6e8f5d01e1cbc355$export$b6a5970fca17c71e(state) {
    const { clientOffset: clientOffset, initialClientOffset: initialClientOffset, initialSourceClientOffset: initialSourceClientOffset } = state;
    if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) return null;
    return $6e8f5d01e1cbc355$export$4e2d2ead65e5f7e3($6e8f5d01e1cbc355$export$e16d8520af44a096(clientOffset, initialSourceClientOffset), initialClientOffset);
}
function $6e8f5d01e1cbc355$export$b57ee1a41eb1620b(state) {
    const { clientOffset: clientOffset, initialClientOffset: initialClientOffset } = state;
    if (!clientOffset || !initialClientOffset) return null;
    return $6e8f5d01e1cbc355$export$4e2d2ead65e5f7e3(clientOffset, initialClientOffset);
}



const $8353734a5669f96b$export$c53d0f541b41b88e = [];
const $8353734a5669f96b$export$61b49a5ae59d663 = [];
$8353734a5669f96b$export$c53d0f541b41b88e.__IS_NONE__ = true;
$8353734a5669f96b$export$61b49a5ae59d663.__IS_ALL__ = true;
function $8353734a5669f96b$export$3347776eeed47180(dirtyIds, handlerIds) {
    if (dirtyIds === $8353734a5669f96b$export$c53d0f541b41b88e) return false;
    if (dirtyIds === $8353734a5669f96b$export$61b49a5ae59d663 || typeof handlerIds === "undefined") return true;
    const commonIds = (0, $47cf51fbd9270494$export$bc86dfbf7795668c)(handlerIds, dirtyIds);
    return commonIds.length > 0;
}



class $1ab90f14baeaa60c$export$e220263e518daaed {
    subscribeToStateChange(listener, options = {}) {
        const { handlerIds: handlerIds } = options;
        (0, $79773a7d776aedca$export$f5708dca728d7177)(typeof listener === "function", "listener must be a function.");
        (0, $79773a7d776aedca$export$f5708dca728d7177)(typeof handlerIds === "undefined" || Array.isArray(handlerIds), "handlerIds, when specified, must be an array of strings.");
        let prevStateId = this.store.getState().stateId;
        const handleChange = ()=>{
            const state = this.store.getState();
            const currentStateId = state.stateId;
            try {
                const canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !(0, $8353734a5669f96b$export$3347776eeed47180)(state.dirtyHandlerIds, handlerIds);
                if (!canSkipListener) listener();
            } finally{
                prevStateId = currentStateId;
            }
        };
        return this.store.subscribe(handleChange);
    }
    subscribeToOffsetChange(listener) {
        (0, $79773a7d776aedca$export$f5708dca728d7177)(typeof listener === "function", "listener must be a function.");
        let previousState = this.store.getState().dragOffset;
        const handleChange = ()=>{
            const nextState = this.store.getState().dragOffset;
            if (nextState === previousState) return;
            previousState = nextState;
            listener();
        };
        return this.store.subscribe(handleChange);
    }
    canDragSource(sourceId) {
        if (!sourceId) return false;
        const source = this.registry.getSource(sourceId);
        (0, $79773a7d776aedca$export$f5708dca728d7177)(source, `Expected to find a valid source. sourceId=${sourceId}`);
        if (this.isDragging()) return false;
        return source.canDrag(this, sourceId);
    }
    canDropOnTarget(targetId) {
        // undefined on initial render
        if (!targetId) return false;
        const target = this.registry.getTarget(targetId);
        (0, $79773a7d776aedca$export$f5708dca728d7177)(target, `Expected to find a valid target. targetId=${targetId}`);
        if (!this.isDragging() || this.didDrop()) return false;
        const targetType = this.registry.getTargetType(targetId);
        const draggedItemType = this.getItemType();
        return (0, $f135a2fefd5900ff$export$2d6239ff106f142f)(targetType, draggedItemType) && target.canDrop(this, targetId);
    }
    isDragging() {
        return Boolean(this.getItemType());
    }
    isDraggingSource(sourceId) {
        // undefined on initial render
        if (!sourceId) return false;
        const source = this.registry.getSource(sourceId, true);
        (0, $79773a7d776aedca$export$f5708dca728d7177)(source, `Expected to find a valid source. sourceId=${sourceId}`);
        if (!this.isDragging() || !this.isSourcePublic()) return false;
        const sourceType = this.registry.getSourceType(sourceId);
        const draggedItemType = this.getItemType();
        if (sourceType !== draggedItemType) return false;
        return source.isDragging(this, sourceId);
    }
    isOverTarget(targetId, options = {
        shallow: false
    }) {
        // undefined on initial render
        if (!targetId) return false;
        const { shallow: shallow } = options;
        if (!this.isDragging()) return false;
        const targetType = this.registry.getTargetType(targetId);
        const draggedItemType = this.getItemType();
        if (draggedItemType && !(0, $f135a2fefd5900ff$export$2d6239ff106f142f)(targetType, draggedItemType)) return false;
        const targetIds = this.getTargetIds();
        if (!targetIds.length) return false;
        const index = targetIds.indexOf(targetId);
        if (shallow) return index === targetIds.length - 1;
        else return index > -1;
    }
    getItemType() {
        return this.store.getState().dragOperation.itemType;
    }
    getItem() {
        return this.store.getState().dragOperation.item;
    }
    getSourceId() {
        return this.store.getState().dragOperation.sourceId;
    }
    getTargetIds() {
        return this.store.getState().dragOperation.targetIds;
    }
    getDropResult() {
        return this.store.getState().dragOperation.dropResult;
    }
    didDrop() {
        return this.store.getState().dragOperation.didDrop;
    }
    isSourcePublic() {
        return Boolean(this.store.getState().dragOperation.isSourcePublic);
    }
    getInitialClientOffset() {
        return this.store.getState().dragOffset.initialClientOffset;
    }
    getInitialSourceClientOffset() {
        return this.store.getState().dragOffset.initialSourceClientOffset;
    }
    getClientOffset() {
        return this.store.getState().dragOffset.clientOffset;
    }
    getSourceClientOffset() {
        return (0, $6e8f5d01e1cbc355$export$b6a5970fca17c71e)(this.store.getState().dragOffset);
    }
    getDifferenceFromInitialOffset() {
        return (0, $6e8f5d01e1cbc355$export$b57ee1a41eb1620b)(this.store.getState().dragOffset);
    }
    constructor(store, registry){
        this.store = store;
        this.registry = registry;
    }
}


/* eslint-disable no-restricted-globals, @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unused-vars, @typescript-eslint/no-non-null-assertion */ // Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
/* globals self */ const $1d46eeac53a92368$var$scope = typeof $parcel$global !== "undefined" ? $parcel$global : self;
const $1d46eeac53a92368$var$BrowserMutationObserver = $1d46eeac53a92368$var$scope.MutationObserver || $1d46eeac53a92368$var$scope.WebKitMutationObserver;
function $1d46eeac53a92368$export$27a7cafb047f3c77(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        const timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        const intervalHandle = setInterval(handleTimer, 50);
        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}
function $1d46eeac53a92368$export$2785f4493cc9ca62(callback) {
    let toggle = 1;
    const observer = new $1d46eeac53a92368$var$BrowserMutationObserver(callback);
    const node = document.createTextNode("");
    observer.observe(node, {
        characterData: true
    });
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}
const $1d46eeac53a92368$export$29545a1340296ce3 = typeof $1d46eeac53a92368$var$BrowserMutationObserver === "function" ? // They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
$1d46eeac53a92368$export$2785f4493cc9ca62 : // 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.
// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396
// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
$1d46eeac53a92368$export$27a7cafb047f3c77;


class $50f1fb12b6e985a0$export$d3f0708de0e313ed {
    // Use the fastest means possible to execute a task in its own turn, with
    // priority over other events including IO, animation, reflow, and redraw
    // events in browsers.
    //
    // An exception thrown by a task will permanently interrupt the processing of
    // subsequent tasks. The higher level `asap` function ensures that if an
    // exception is thrown by a task, that the task queue will continue flushing as
    // soon as possible, but if you use `rawAsap` directly, you are responsible to
    // either ensure that no exceptions are thrown from your task, or to manually
    // call `rawAsap.requestFlush` if an exception is thrown.
    enqueueTask(task) {
        const { queue: q, requestFlush: requestFlush } = this;
        if (!q.length) {
            requestFlush();
            this.flushing = true;
        }
        // Equivalent to push, but avoids a function call.
        q[q.length] = task;
    }
    constructor(){
        this.queue = [];
        // We queue errors to ensure they are thrown in right order (FIFO).
        // Array-as-queue is good enough here, since we are just dealing with exceptions.
        this.pendingErrors = [];
        // Once a flush has been requested, no further calls to `requestFlush` are
        // necessary until the next `flush` completes.
        // @ts-ignore
        this.flushing = false;
        // The position of the next task to execute in the task queue. This is
        // preserved between calls to `flush` so that it can be resumed if
        // a task throws an exception.
        this.index = 0;
        // If a task schedules additional tasks recursively, the task queue can grow
        // unbounded. To prevent memory exhaustion, the task queue will periodically
        // truncate already-completed tasks.
        this.capacity = 1024;
        // The flush function processes all tasks that have been scheduled with
        // `rawAsap` unless and until one of those tasks throws an exception.
        // If a task throws an exception, `flush` ensures that its state will remain
        // consistent and will resume where it left off when called again.
        // However, `flush` does not make any arrangements to be called again if an
        // exception is thrown.
        this.flush = ()=>{
            const { queue: q } = this;
            while(this.index < q.length){
                const currentIndex = this.index;
                // Advance the index before calling the task. This ensures that we will
                // begin flushing on the next task the task throws an error.
                this.index++;
                q[currentIndex].call();
                // Prevent leaking memory for long chains of recursive calls to `asap`.
                // If we call `asap` within tasks scheduled by `asap`, the queue will
                // grow, but to avoid an O(n) walk for every task we execute, we don't
                // shift tasks off the queue after they have been executed.
                // Instead, we periodically shift 1024 tasks off the queue.
                if (this.index > this.capacity) {
                    // Manually shift all values starting at the index back to the
                    // beginning of the queue.
                    for(let scan = 0, newLength = q.length - this.index; scan < newLength; scan++)q[scan] = q[scan + this.index];
                    q.length -= this.index;
                    this.index = 0;
                }
            }
            q.length = 0;
            this.index = 0;
            this.flushing = false;
        };
        // In a web browser, exceptions are not fatal. However, to avoid
        // slowing down the queue of pending tasks, we rethrow the error in a
        // lower priority turn.
        this.registerPendingError = (err)=>{
            this.pendingErrors.push(err);
            this.requestErrorThrow();
        };
        // `requestFlush` requests that the high priority event queue be flushed as
        // soon as possible.
        // This is useful to prevent an error thrown in a task from stalling the event
        // queue if the exception handled by Node.js’s
        // `process.on("uncaughtException")` or by a domain.
        // `requestFlush` is implemented using a strategy based on data collected from
        // every available SauceLabs Selenium web driver worker at time of writing.
        // https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
        this.requestFlush = (0, $1d46eeac53a92368$export$29545a1340296ce3)(this.flush);
        this.requestErrorThrow = (0, $1d46eeac53a92368$export$27a7cafb047f3c77)(()=>{
            // Throw first error
            if (this.pendingErrors.length) throw this.pendingErrors.shift();
        });
    }
} // The message channel technique was discovered by Malte Ubl and was the
 // original foundation for this library.
 // http://www.nonblocking.io/2011/06/windownexttick.html
 // Safari 6.0.5 (at least) intermittently fails to create message ports on a
 // page's first load. Thankfully, this version of Safari supports
 // MutationObservers, so we don't need to fall back in that case.
 // function makeRequestCallFromMessageChannel(callback) {
 //     var channel = new MessageChannel();
 //     channel.port1.onmessage = callback;
 //     return function requestCall() {
 //         channel.port2.postMessage(0);
 //     };
 // }
 // For reasons explained above, we are also unable to use `setImmediate`
 // under any circumstances.
 // Even if we were, there is another bug in Internet Explorer 10.
 // It is not sufficient to assign `setImmediate` to `requestFlush` because
 // `setImmediate` must be called *by name* and therefore must be wrapped in a
 // closure.
 // Never forget.
 // function makeRequestCallFromSetImmediate(callback) {
 //     return function requestCall() {
 //         setImmediate(callback);
 //     };
 // }
 // Safari 6.0 has a problem where timers will get lost while the user is
 // scrolling. This problem does not impact ASAP because Safari 6.0 supports
 // mutation observers, so that implementation is used instead.
 // However, if we ever elect to use timers in Safari, the prevalent work-around
 // is to add a scroll event listener that calls for a flush.
 // `setTimeout` does not call the passed callback if the delay is less than
 // approximately 7 in web workers in Firefox 8 through 18, and sometimes not
 // even then.
 // This is for `asap.js` only.
 // Its name will be periodically randomized to break any code that depends on
 // // its existence.
 // rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer
 // ASAP was originally a nextTick shim included in Q. This was factored out
 // into this ASAP package. It was later adapted to RSVP which made further
 // amendments. These decisions, particularly to marginalize MessageChannel and
 // to capture the MutationObserver implementation in a closure, were integrated
 // back into ASAP proper.
 // https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js


// `call`, just like a function.
class $15c263de38c40f26$export$c84b69da61b33d93 {
    call() {
        try {
            this.task && this.task();
        } catch (error) {
            this.onError(error);
        } finally{
            this.task = null;
            this.release(this);
        }
    }
    constructor(onError, release){
        this.onError = onError;
        this.release = release;
        this.task = null;
    }
}


class $e5e47698e4e9f93e$export$4577931b6c22c63b {
    create(task) {
        const tasks = this.freeTasks;
        const t1 = tasks.length ? tasks.pop() : new (0, $15c263de38c40f26$export$c84b69da61b33d93)(this.onError, (t)=>tasks[tasks.length] = t);
        t1.task = task;
        return t1;
    }
    constructor(onError){
        this.onError = onError;
        this.freeTasks = [];
    }
}


const $b015a6019713ab85$var$asapQueue = new (0, $50f1fb12b6e985a0$export$d3f0708de0e313ed)();
const $b015a6019713ab85$var$taskFactory = new (0, $e5e47698e4e9f93e$export$4577931b6c22c63b)($b015a6019713ab85$var$asapQueue.registerPendingError);
function $b015a6019713ab85$export$dc4d482300a341e1(task) {
    $b015a6019713ab85$var$asapQueue.enqueueTask($b015a6019713ab85$var$taskFactory.create(task));
}









const $9c250d9f82190291$export$b36933c81fb1c092 = "dnd-core/ADD_SOURCE";
const $9c250d9f82190291$export$2c313542981556ae = "dnd-core/ADD_TARGET";
const $9c250d9f82190291$export$13332566b98b8783 = "dnd-core/REMOVE_SOURCE";
const $9c250d9f82190291$export$82ace346d17d8869 = "dnd-core/REMOVE_TARGET";
function $9c250d9f82190291$export$bc333c64f07a75c4(sourceId) {
    return {
        type: $9c250d9f82190291$export$b36933c81fb1c092,
        payload: {
            sourceId: sourceId
        }
    };
}
function $9c250d9f82190291$export$9dd68fe78f37278b(targetId) {
    return {
        type: $9c250d9f82190291$export$2c313542981556ae,
        payload: {
            targetId: targetId
        }
    };
}
function $9c250d9f82190291$export$c724aacd61334138(sourceId) {
    return {
        type: $9c250d9f82190291$export$13332566b98b8783,
        payload: {
            sourceId: sourceId
        }
    };
}
function $9c250d9f82190291$export$20ae7ec87f7f8696(targetId) {
    return {
        type: $9c250d9f82190291$export$82ace346d17d8869,
        payload: {
            targetId: targetId
        }
    };
}



function $92949d2f0091cf75$export$a7a13c013ce18993(source) {
    (0, $79773a7d776aedca$export$f5708dca728d7177)(typeof source.canDrag === "function", "Expected canDrag to be a function.");
    (0, $79773a7d776aedca$export$f5708dca728d7177)(typeof source.beginDrag === "function", "Expected beginDrag to be a function.");
    (0, $79773a7d776aedca$export$f5708dca728d7177)(typeof source.endDrag === "function", "Expected endDrag to be a function.");
}
function $92949d2f0091cf75$export$77d3cd1340fdeb5a(target) {
    (0, $79773a7d776aedca$export$f5708dca728d7177)(typeof target.canDrop === "function", "Expected canDrop to be a function.");
    (0, $79773a7d776aedca$export$f5708dca728d7177)(typeof target.hover === "function", "Expected hover to be a function.");
    (0, $79773a7d776aedca$export$f5708dca728d7177)(typeof target.drop === "function", "Expected beginDrag to be a function.");
}
function $92949d2f0091cf75$export$831a593efd22380d(type, allowArray) {
    if (allowArray && Array.isArray(type)) {
        type.forEach((t)=>$92949d2f0091cf75$export$831a593efd22380d(t, false));
        return;
    }
    (0, $79773a7d776aedca$export$f5708dca728d7177)(typeof type === "string" || typeof type === "symbol", allowArray ? "Type can only be a string, a symbol, or an array of either." : "Type can only be a string or a symbol.");
}


var $53cf8455cc30270b$export$bb8f0843d7d66cb0;
(function(HandlerRole) {
    HandlerRole["SOURCE"] = "SOURCE";
    HandlerRole["TARGET"] = "TARGET";
})($53cf8455cc30270b$export$bb8f0843d7d66cb0 || ($53cf8455cc30270b$export$bb8f0843d7d66cb0 = {}));


let $8b5a31d11ed56c27$var$nextUniqueId = 0;
function $8b5a31d11ed56c27$export$dbfb29c8f2c7bb44() {
    return $8b5a31d11ed56c27$var$nextUniqueId++;
}


function $c690e0be32e1c9ec$var$getNextHandlerId(role) {
    const id = (0, $8b5a31d11ed56c27$export$dbfb29c8f2c7bb44)().toString();
    switch(role){
        case (0, $53cf8455cc30270b$export$bb8f0843d7d66cb0).SOURCE:
            return `S${id}`;
        case (0, $53cf8455cc30270b$export$bb8f0843d7d66cb0).TARGET:
            return `T${id}`;
        default:
            throw new Error(`Unknown Handler Role: ${role}`);
    }
}
function $c690e0be32e1c9ec$var$parseRoleFromHandlerId(handlerId) {
    switch(handlerId[0]){
        case "S":
            return (0, $53cf8455cc30270b$export$bb8f0843d7d66cb0).SOURCE;
        case "T":
            return (0, $53cf8455cc30270b$export$bb8f0843d7d66cb0).TARGET;
        default:
            throw new Error(`Cannot parse handler ID: ${handlerId}`);
    }
}
function $c690e0be32e1c9ec$var$mapContainsValue(map, searchValue) {
    const entries = map.entries();
    let isDone = false;
    do {
        const { done: done, value: [, value] } = entries.next();
        if (value === searchValue) return true;
        isDone = !!done;
    }while (!isDone);
    return false;
}
class $c690e0be32e1c9ec$export$60ceab237232d5db {
    addSource(type, source) {
        (0, $92949d2f0091cf75$export$831a593efd22380d)(type);
        (0, $92949d2f0091cf75$export$a7a13c013ce18993)(source);
        const sourceId = this.addHandler((0, $53cf8455cc30270b$export$bb8f0843d7d66cb0).SOURCE, type, source);
        this.store.dispatch((0, $9c250d9f82190291$export$bc333c64f07a75c4)(sourceId));
        return sourceId;
    }
    addTarget(type, target) {
        (0, $92949d2f0091cf75$export$831a593efd22380d)(type, true);
        (0, $92949d2f0091cf75$export$77d3cd1340fdeb5a)(target);
        const targetId = this.addHandler((0, $53cf8455cc30270b$export$bb8f0843d7d66cb0).TARGET, type, target);
        this.store.dispatch((0, $9c250d9f82190291$export$9dd68fe78f37278b)(targetId));
        return targetId;
    }
    containsHandler(handler) {
        return $c690e0be32e1c9ec$var$mapContainsValue(this.dragSources, handler) || $c690e0be32e1c9ec$var$mapContainsValue(this.dropTargets, handler);
    }
    getSource(sourceId, includePinned = false) {
        (0, $79773a7d776aedca$export$f5708dca728d7177)(this.isSourceId(sourceId), "Expected a valid source ID.");
        const isPinned = includePinned && sourceId === this.pinnedSourceId;
        const source = isPinned ? this.pinnedSource : this.dragSources.get(sourceId);
        return source;
    }
    getTarget(targetId) {
        (0, $79773a7d776aedca$export$f5708dca728d7177)(this.isTargetId(targetId), "Expected a valid target ID.");
        return this.dropTargets.get(targetId);
    }
    getSourceType(sourceId) {
        (0, $79773a7d776aedca$export$f5708dca728d7177)(this.isSourceId(sourceId), "Expected a valid source ID.");
        return this.types.get(sourceId);
    }
    getTargetType(targetId) {
        (0, $79773a7d776aedca$export$f5708dca728d7177)(this.isTargetId(targetId), "Expected a valid target ID.");
        return this.types.get(targetId);
    }
    isSourceId(handlerId) {
        const role = $c690e0be32e1c9ec$var$parseRoleFromHandlerId(handlerId);
        return role === (0, $53cf8455cc30270b$export$bb8f0843d7d66cb0).SOURCE;
    }
    isTargetId(handlerId) {
        const role = $c690e0be32e1c9ec$var$parseRoleFromHandlerId(handlerId);
        return role === (0, $53cf8455cc30270b$export$bb8f0843d7d66cb0).TARGET;
    }
    removeSource(sourceId) {
        (0, $79773a7d776aedca$export$f5708dca728d7177)(this.getSource(sourceId), "Expected an existing source.");
        this.store.dispatch((0, $9c250d9f82190291$export$c724aacd61334138)(sourceId));
        (0, $b015a6019713ab85$export$dc4d482300a341e1)(()=>{
            this.dragSources.delete(sourceId);
            this.types.delete(sourceId);
        });
    }
    removeTarget(targetId) {
        (0, $79773a7d776aedca$export$f5708dca728d7177)(this.getTarget(targetId), "Expected an existing target.");
        this.store.dispatch((0, $9c250d9f82190291$export$20ae7ec87f7f8696)(targetId));
        this.dropTargets.delete(targetId);
        this.types.delete(targetId);
    }
    pinSource(sourceId) {
        const source = this.getSource(sourceId);
        (0, $79773a7d776aedca$export$f5708dca728d7177)(source, "Expected an existing source.");
        this.pinnedSourceId = sourceId;
        this.pinnedSource = source;
    }
    unpinSource() {
        (0, $79773a7d776aedca$export$f5708dca728d7177)(this.pinnedSource, "No source is pinned at the time.");
        this.pinnedSourceId = null;
        this.pinnedSource = null;
    }
    addHandler(role, type, handler) {
        const id = $c690e0be32e1c9ec$var$getNextHandlerId(role);
        this.types.set(id, type);
        if (role === (0, $53cf8455cc30270b$export$bb8f0843d7d66cb0).SOURCE) this.dragSources.set(id, handler);
        else if (role === (0, $53cf8455cc30270b$export$bb8f0843d7d66cb0).TARGET) this.dropTargets.set(id, handler);
        return id;
    }
    constructor(store){
        this.types = new Map();
        this.dragSources = new Map();
        this.dropTargets = new Map();
        this.pinnedSourceId = null;
        this.pinnedSource = null;
        this.store = store;
    }
}






const $081af5331c77c76a$export$2116cbe61f6a442a = (a, b)=>a === b;
function $081af5331c77c76a$export$102b20725d4d2263(offsetA, offsetB) {
    if (!offsetA && !offsetB) return true;
    else if (!offsetA || !offsetB) return false;
    else return offsetA.x === offsetB.x && offsetA.y === offsetB.y;
}
function $081af5331c77c76a$export$94fd53d40f0652a(a, b, isEqual = $081af5331c77c76a$export$2116cbe61f6a442a) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; ++i){
        if (!isEqual(a[i], b[i])) return false;
    }
    return true;
}



function $636cbce29451bb11$export$533b26079ad0b4b(_state = (0, $8353734a5669f96b$export$c53d0f541b41b88e), action) {
    switch(action.type){
        case 0, $dce07c8c698f8b6c$export$9d358706ccac3727:
            break;
        case 0, $9c250d9f82190291$export$b36933c81fb1c092:
        case 0, $9c250d9f82190291$export$2c313542981556ae:
        case 0, $9c250d9f82190291$export$82ace346d17d8869:
        case 0, $9c250d9f82190291$export$13332566b98b8783:
            return 0, $8353734a5669f96b$export$c53d0f541b41b88e;
        case 0, $dce07c8c698f8b6c$export$98f9b4193e6b55e6:
        case 0, $dce07c8c698f8b6c$export$22d1d88e2de0d0e0:
        case 0, $dce07c8c698f8b6c$export$d300627d16aeb9cc:
        case 0, $dce07c8c698f8b6c$export$b4af72c40fd57063:
        default:
            return 0, $8353734a5669f96b$export$61b49a5ae59d663;
    }
    const { targetIds: targetIds = [], prevTargetIds: prevTargetIds = [] } = action.payload;
    const result = (0, $47cf51fbd9270494$export$6444ef5cd411280c)(targetIds, prevTargetIds);
    const didChange = result.length > 0 || !(0, $081af5331c77c76a$export$94fd53d40f0652a)(targetIds, prevTargetIds);
    if (!didChange) return 0, $8353734a5669f96b$export$c53d0f541b41b88e;
    // Check the target ids at the innermost position. If they are valid, add them
    // to the result
    const prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
    const innermostTargetId = targetIds[targetIds.length - 1];
    if (prevInnermostTargetId !== innermostTargetId) {
        if (prevInnermostTargetId) result.push(prevInnermostTargetId);
        if (innermostTargetId) result.push(innermostTargetId);
    }
    return result;
}




function $8d16a2d7a9d3ad37$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8d16a2d7a9d3ad37$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $8d16a2d7a9d3ad37$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
const $8d16a2d7a9d3ad37$var$initialState = {
    initialSourceClientOffset: null,
    initialClientOffset: null,
    clientOffset: null
};
function $8d16a2d7a9d3ad37$export$533b26079ad0b4b(state = $8d16a2d7a9d3ad37$var$initialState, action) {
    const { payload: payload } = action;
    switch(action.type){
        case 0, $dce07c8c698f8b6c$export$3fc3a33e48b33945:
        case 0, $dce07c8c698f8b6c$export$98f9b4193e6b55e6:
            return {
                initialSourceClientOffset: payload.sourceClientOffset,
                initialClientOffset: payload.clientOffset,
                clientOffset: payload.clientOffset
            };
        case 0, $dce07c8c698f8b6c$export$9d358706ccac3727:
            if ((0, $081af5331c77c76a$export$102b20725d4d2263)(state.clientOffset, payload.clientOffset)) return state;
            return $8d16a2d7a9d3ad37$var$_objectSpread({}, state, {
                clientOffset: payload.clientOffset
            });
        case 0, $dce07c8c698f8b6c$export$d300627d16aeb9cc:
        case 0, $dce07c8c698f8b6c$export$b4af72c40fd57063:
            return $8d16a2d7a9d3ad37$var$initialState;
        default:
            return state;
    }
}





function $9906d9a36d980644$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9906d9a36d980644$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $9906d9a36d980644$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
const $9906d9a36d980644$var$initialState = {
    itemType: null,
    item: null,
    sourceId: null,
    targetIds: [],
    dropResult: null,
    didDrop: false,
    isSourcePublic: null
};
function $9906d9a36d980644$export$533b26079ad0b4b(state = $9906d9a36d980644$var$initialState, action) {
    const { payload: payload } = action;
    switch(action.type){
        case 0, $dce07c8c698f8b6c$export$98f9b4193e6b55e6:
            return $9906d9a36d980644$var$_objectSpread({}, state, {
                itemType: payload.itemType,
                item: payload.item,
                sourceId: payload.sourceId,
                isSourcePublic: payload.isSourcePublic,
                dropResult: null,
                didDrop: false
            });
        case 0, $dce07c8c698f8b6c$export$22d1d88e2de0d0e0:
            return $9906d9a36d980644$var$_objectSpread({}, state, {
                isSourcePublic: true
            });
        case 0, $dce07c8c698f8b6c$export$9d358706ccac3727:
            return $9906d9a36d980644$var$_objectSpread({}, state, {
                targetIds: payload.targetIds
            });
        case 0, $9c250d9f82190291$export$82ace346d17d8869:
            if (state.targetIds.indexOf(payload.targetId) === -1) return state;
            return $9906d9a36d980644$var$_objectSpread({}, state, {
                targetIds: (0, $47cf51fbd9270494$export$5d14bf425b37f49e)(state.targetIds, payload.targetId)
            });
        case 0, $dce07c8c698f8b6c$export$b4af72c40fd57063:
            return $9906d9a36d980644$var$_objectSpread({}, state, {
                dropResult: payload.dropResult,
                didDrop: true,
                targetIds: []
            });
        case 0, $dce07c8c698f8b6c$export$d300627d16aeb9cc:
            return $9906d9a36d980644$var$_objectSpread({}, state, {
                itemType: null,
                item: null,
                sourceId: null,
                dropResult: null,
                didDrop: false,
                isSourcePublic: null,
                targetIds: []
            });
        default:
            return state;
    }
}



function $7a045dca126f29ae$export$533b26079ad0b4b(state = 0, action) {
    switch(action.type){
        case 0, $9c250d9f82190291$export$b36933c81fb1c092:
        case 0, $9c250d9f82190291$export$2c313542981556ae:
            return state + 1;
        case 0, $9c250d9f82190291$export$13332566b98b8783:
        case 0, $9c250d9f82190291$export$82ace346d17d8869:
            return state - 1;
        default:
            return state;
    }
}


function $126f80941feeb9da$export$533b26079ad0b4b(state = 0) {
    return state + 1;
}


function $323e0e48d7be0e6d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $323e0e48d7be0e6d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $323e0e48d7be0e6d$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $323e0e48d7be0e6d$export$533b26079ad0b4b(state = {}, action) {
    return {
        dirtyHandlerIds: (0, $636cbce29451bb11$export$533b26079ad0b4b)(state.dirtyHandlerIds, {
            type: action.type,
            payload: $323e0e48d7be0e6d$var$_objectSpread({}, action.payload, {
                prevTargetIds: (0, $47cf51fbd9270494$export$3988ae62b71be9a3)(state, "dragOperation.targetIds", [])
            })
        }),
        dragOffset: (0, $8d16a2d7a9d3ad37$export$533b26079ad0b4b)(state.dragOffset, action),
        refCount: (0, $7a045dca126f29ae$export$533b26079ad0b4b)(state.refCount, action),
        dragOperation: (0, $9906d9a36d980644$export$533b26079ad0b4b)(state.dragOperation, action),
        stateId: (0, $126f80941feeb9da$export$533b26079ad0b4b)(state.stateId)
    };
}


function $3cf55d59f6d5f2ef$export$ff47aa43d5fd3e5d(backendFactory, globalContext, backendOptions = {}, debugMode = false) {
    const store = $3cf55d59f6d5f2ef$var$makeStoreInstance(debugMode);
    const monitor = new (0, $1ab90f14baeaa60c$export$e220263e518daaed)(store, new (0, $c690e0be32e1c9ec$export$60ceab237232d5db)(store));
    const manager = new (0, $46b5e205c4a90746$export$1141bbf61324c55f)(store, monitor);
    const backend = backendFactory(manager, globalContext, backendOptions);
    manager.receiveBackend(backend);
    return manager;
}
function $3cf55d59f6d5f2ef$var$makeStoreInstance(debugMode) {
    // TODO: if we ever make a react-native version of this,
    // we'll need to consider how to pull off dev-tooling
    const reduxDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__;
    return (0, $bbbf76cea1c5a0a3$export$f51a9068ac82ea43)((0, $323e0e48d7be0e6d$export$533b26079ad0b4b), debugMode && reduxDevTools && reduxDevTools({
        name: "dnd-core",
        instanceId: "dnd-core"
    }));
}



var $jC8Vy = parcelRequire("jC8Vy");

var $jC8Vy = parcelRequire("jC8Vy");
const $78d2743c927350a9$export$2d5c5ceac203fc1e = (0, $jC8Vy.createContext)({
    dragDropManager: undefined
});


function $1565dd1af151930c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1565dd1af151930c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1565dd1af151930c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
let $1565dd1af151930c$var$refCount = 0;
const $1565dd1af151930c$var$INSTANCE_SYM = Symbol.for("__REACT_DND_CONTEXT_INSTANCE__");
var $1565dd1af151930c$export$9861489d68213f9c = /*#__PURE__*/ (0, $jC8Vy.memo)(function DndProvider(_param) {
    var { children: children } = _param, props = $1565dd1af151930c$var$_objectWithoutProperties(_param, [
        "children"
    ]);
    const [manager, isGlobalInstance] = $1565dd1af151930c$var$getDndContextValue(props) // memoized from props
    ;
    /**
		 * If the global context was used to store the DND context
		 * then where theres no more references to it we should
		 * clean it up to avoid memory leaks
		 */ (0, $jC8Vy.useEffect)(()=>{
        if (isGlobalInstance) {
            const context = $1565dd1af151930c$var$getGlobalContext();
            ++$1565dd1af151930c$var$refCount;
            return ()=>{
                if (--$1565dd1af151930c$var$refCount === 0) context[$1565dd1af151930c$var$INSTANCE_SYM] = null;
            };
        }
        return;
    }, []);
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $78d2743c927350a9$export$2d5c5ceac203fc1e).Provider, {
        value: manager,
        children: children
    });
});
function $1565dd1af151930c$var$getDndContextValue(props) {
    if ("manager" in props) {
        const manager = {
            dragDropManager: props.manager
        };
        return [
            manager,
            false
        ];
    }
    const manager = $1565dd1af151930c$var$createSingletonDndContext(props.backend, props.context, props.options, props.debugMode);
    const isGlobalInstance = !props.context;
    return [
        manager,
        isGlobalInstance
    ];
}
function $1565dd1af151930c$var$createSingletonDndContext(backend, context = $1565dd1af151930c$var$getGlobalContext(), options, debugMode) {
    const ctx = context;
    if (!ctx[$1565dd1af151930c$var$INSTANCE_SYM]) ctx[$1565dd1af151930c$var$INSTANCE_SYM] = {
        dragDropManager: (0, $3cf55d59f6d5f2ef$export$ff47aa43d5fd3e5d)(backend, context, options, debugMode)
    };
    return ctx[$1565dd1af151930c$var$INSTANCE_SYM];
}
function $1565dd1af151930c$var$getGlobalContext() {
    return typeof $parcel$global !== "undefined" ? $parcel$global : window;
}


// cheap lodash replacements
function $b59af345f8cef601$export$fc10aeed3a532e2a(fn) {
    let result = null;
    const memoized = ()=>{
        if (result == null) result = fn();
        return result;
    };
    return memoized;
}
function $b59af345f8cef601$export$5d14bf425b37f49e(items, item) {
    return items.filter((i)=>i !== item);
}
function $b59af345f8cef601$export$971dd5b0dfd021b6(itemsA, itemsB) {
    const set = new Set();
    const insertItem = (item)=>set.add(item);
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    const result = [];
    set.forEach((key)=>result.push(key));
    return result;
}


class $7f9af8ed5a0cbff4$export$9ff3e6eb5c734d0d {
    enter(enteringNode) {
        const previousLength = this.entered.length;
        const isNodeEntered = (node)=>this.isNodeInDocument(node) && (!node.contains || node.contains(enteringNode));
        this.entered = (0, $b59af345f8cef601$export$971dd5b0dfd021b6)(this.entered.filter(isNodeEntered), [
            enteringNode
        ]);
        return previousLength === 0 && this.entered.length > 0;
    }
    leave(leavingNode) {
        const previousLength = this.entered.length;
        this.entered = (0, $b59af345f8cef601$export$5d14bf425b37f49e)(this.entered.filter(this.isNodeInDocument), leavingNode);
        return previousLength > 0 && this.entered.length === 0;
    }
    reset() {
        this.entered = [];
    }
    constructor(isNodeInDocument){
        this.entered = [];
        this.isNodeInDocument = isNodeInDocument;
    }
}


class $a7200034fdbdd83c$export$f22384f077cf51c4 {
    initializeExposedProperties() {
        Object.keys(this.config.exposeProperties).forEach((property)=>{
            Object.defineProperty(this.item, property, {
                configurable: true,
                enumerable: true,
                get () {
                    // eslint-disable-next-line no-console
                    console.warn(`Browser doesn't allow reading "${property}" until the drop event.`);
                    return null;
                }
            });
        });
    }
    loadDataTransfer(dataTransfer) {
        if (dataTransfer) {
            const newProperties = {};
            Object.keys(this.config.exposeProperties).forEach((property)=>{
                const propertyFn = this.config.exposeProperties[property];
                if (propertyFn != null) newProperties[property] = {
                    value: propertyFn(dataTransfer, this.config.matchesTypes),
                    configurable: true,
                    enumerable: true
                };
            });
            Object.defineProperties(this.item, newProperties);
        }
    }
    canDrag() {
        return true;
    }
    beginDrag() {
        return this.item;
    }
    isDragging(monitor, handle) {
        return handle === monitor.getSourceId();
    }
    endDrag() {
    // empty
    }
    constructor(config){
        this.config = config;
        this.item = {};
        this.initializeExposedProperties();
    }
}


var $756d467d767a1fe0$exports = {};

$parcel$export($756d467d767a1fe0$exports, "FILE", function () { return $756d467d767a1fe0$export$1802dbfd31b58482; });
$parcel$export($756d467d767a1fe0$exports, "URL", function () { return $756d467d767a1fe0$export$61abde59b50deb8e; });
$parcel$export($756d467d767a1fe0$exports, "TEXT", function () { return $756d467d767a1fe0$export$d597759d33be802e; });
$parcel$export($756d467d767a1fe0$exports, "HTML", function () { return $756d467d767a1fe0$export$9dcd2b1ca4768128; });
const $756d467d767a1fe0$export$1802dbfd31b58482 = "__NATIVE_FILE__";
const $756d467d767a1fe0$export$61abde59b50deb8e = "__NATIVE_URL__";
const $756d467d767a1fe0$export$d597759d33be802e = "__NATIVE_TEXT__";
const $756d467d767a1fe0$export$9dcd2b1ca4768128 = "__NATIVE_HTML__";


function $8dab8380746bddd2$export$dc02f6a7b68f305f(dataTransfer, typesToTry, defaultValue) {
    const result = typesToTry.reduce((resultSoFar, typeToTry)=>resultSoFar || dataTransfer.getData(typeToTry), "");
    return result != null ? result : defaultValue;
}


const $d7515986e9124064$export$8cc89d9b8cb1bd88 = {
    [$756d467d767a1fe0$export$1802dbfd31b58482]: {
        exposeProperties: {
            files: (dataTransfer)=>Array.prototype.slice.call(dataTransfer.files),
            items: (dataTransfer)=>dataTransfer.items,
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            "Files"
        ]
    },
    [$756d467d767a1fe0$export$9dcd2b1ca4768128]: {
        exposeProperties: {
            html: (dataTransfer, matchesTypes)=>(0, $8dab8380746bddd2$export$dc02f6a7b68f305f)(dataTransfer, matchesTypes, ""),
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            "Html",
            "text/html"
        ]
    },
    [$756d467d767a1fe0$export$61abde59b50deb8e]: {
        exposeProperties: {
            urls: (dataTransfer, matchesTypes)=>(0, $8dab8380746bddd2$export$dc02f6a7b68f305f)(dataTransfer, matchesTypes, "").split("\n"),
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            "Url",
            "text/uri-list"
        ]
    },
    [$756d467d767a1fe0$export$d597759d33be802e]: {
        exposeProperties: {
            text: (dataTransfer, matchesTypes)=>(0, $8dab8380746bddd2$export$dc02f6a7b68f305f)(dataTransfer, matchesTypes, ""),
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            "Text",
            "text/plain"
        ]
    }
};


function $13d2017e52d6b2d0$export$ada362c01636774d(type, dataTransfer) {
    const config = (0, $d7515986e9124064$export$8cc89d9b8cb1bd88)[type];
    if (!config) throw new Error(`native type ${type} has no configuration`);
    const result = new (0, $a7200034fdbdd83c$export$f22384f077cf51c4)(config);
    result.loadDataTransfer(dataTransfer);
    return result;
}
function $13d2017e52d6b2d0$export$11b547ed8c182c11(dataTransfer) {
    if (!dataTransfer) return null;
    const dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
    return Object.keys((0, $d7515986e9124064$export$8cc89d9b8cb1bd88)).filter((nativeItemType)=>{
        const typeConfig = (0, $d7515986e9124064$export$8cc89d9b8cb1bd88)[nativeItemType];
        if (!(typeConfig === null || typeConfig === void 0 ? void 0 : typeConfig.matchesTypes)) return false;
        return typeConfig.matchesTypes.some((t)=>dataTransferTypes.indexOf(t) > -1);
    })[0] || null;
}




const $7fe739f3b16a1a72$export$b7d78993b74f766d = (0, $b59af345f8cef601$export$fc10aeed3a532e2a)(()=>/firefox/i.test(navigator.userAgent));
const $7fe739f3b16a1a72$export$95df08bae54cb4df = (0, $b59af345f8cef601$export$fc10aeed3a532e2a)(()=>Boolean(window.safari));


class $64c3fe6fd2a9a228$export$6d87c156c5199b02 {
    interpolate(x) {
        const { xs: xs, ys: ys, c1s: c1s, c2s: c2s, c3s: c3s } = this;
        // The rightmost point in the dataset should give an exact result
        let i = xs.length - 1;
        if (x === xs[i]) return ys[i];
        // Search for the interval x is in, returning the corresponding y if x is one of the original xs
        let low = 0;
        let high = c3s.length - 1;
        let mid;
        while(low <= high){
            mid = Math.floor(0.5 * (low + high));
            const xHere = xs[mid];
            if (xHere < x) low = mid + 1;
            else if (xHere > x) high = mid - 1;
            else return ys[mid];
        }
        i = Math.max(0, high);
        // Interpolate
        const diff = x - xs[i];
        const diffSq = diff * diff;
        return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
    }
    constructor(xs, ys){
        const { length: length } = xs;
        // Rearrange xs and ys so that xs is sorted
        const indexes = [];
        for(let i = 0; i < length; i++)indexes.push(i);
        indexes.sort((a, b)=>xs[a] < xs[b] ? -1 : 1);
        // Get consecutive differences and slopes
        const dys = [];
        const dxs = [];
        const ms = [];
        let dx;
        let dy;
        for(let i1 = 0; i1 < length - 1; i1++){
            dx = xs[i1 + 1] - xs[i1];
            dy = ys[i1 + 1] - ys[i1];
            dxs.push(dx);
            dys.push(dy);
            ms.push(dy / dx);
        }
        // Get degree-1 coefficients
        const c1s = [
            ms[0]
        ];
        for(let i2 = 0; i2 < dxs.length - 1; i2++){
            const m2 = ms[i2];
            const mNext = ms[i2 + 1];
            if (m2 * mNext <= 0) c1s.push(0);
            else {
                dx = dxs[i2];
                const dxNext = dxs[i2 + 1];
                const common = dx + dxNext;
                c1s.push(3 * common / ((common + dxNext) / m2 + (common + dx) / mNext));
            }
        }
        c1s.push(ms[ms.length - 1]);
        // Get degree-2 and degree-3 coefficients
        const c2s = [];
        const c3s = [];
        let m;
        for(let i3 = 0; i3 < c1s.length - 1; i3++){
            m = ms[i3];
            const c1 = c1s[i3];
            const invDx = 1 / dxs[i3];
            const common = c1 + c1s[i3 + 1] - m - m;
            c2s.push((m - c1 - common) * invDx);
            c3s.push(common * invDx * invDx);
        }
        this.xs = xs;
        this.ys = ys;
        this.c1s = c1s;
        this.c2s = c2s;
        this.c3s = c3s;
    }
}


const $5602532c3a47f0c2$var$ELEMENT_NODE = 1;
function $5602532c3a47f0c2$export$8419e8612027b1d8(node) {
    const el = node.nodeType === $5602532c3a47f0c2$var$ELEMENT_NODE ? node : node.parentElement;
    if (!el) return null;
    const { top: top, left: left } = el.getBoundingClientRect();
    return {
        x: left,
        y: top
    };
}
function $5602532c3a47f0c2$export$710c829989c68339(e) {
    return {
        x: e.clientX,
        y: e.clientY
    };
}
function $5602532c3a47f0c2$var$isImageNode(node) {
    var ref;
    return node.nodeName === "IMG" && ((0, $7fe739f3b16a1a72$export$b7d78993b74f766d)() || !((ref = document.documentElement) === null || ref === void 0 ? void 0 : ref.contains(node)));
}
function $5602532c3a47f0c2$var$getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
    let dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
    let dragPreviewHeight = isImage ? dragPreview.height : sourceHeight;
    // Work around @2x coordinate discrepancies in browsers
    if ((0, $7fe739f3b16a1a72$export$95df08bae54cb4df)() && isImage) {
        dragPreviewHeight /= window.devicePixelRatio;
        dragPreviewWidth /= window.devicePixelRatio;
    }
    return {
        dragPreviewWidth: dragPreviewWidth,
        dragPreviewHeight: dragPreviewHeight
    };
}
function $5602532c3a47f0c2$export$e99fdbb90efc75c5(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
    // The browsers will use the image intrinsic size under different conditions.
    // Firefox only cares if it's an image, but WebKit also wants it to be detached.
    const isImage = $5602532c3a47f0c2$var$isImageNode(dragPreview);
    const dragPreviewNode = isImage ? sourceNode : dragPreview;
    const dragPreviewNodeOffsetFromClient = $5602532c3a47f0c2$export$8419e8612027b1d8(dragPreviewNode);
    const offsetFromDragPreview = {
        x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
        y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
    };
    const { offsetWidth: sourceWidth, offsetHeight: sourceHeight } = sourceNode;
    const { anchorX: anchorX, anchorY: anchorY } = anchorPoint;
    const { dragPreviewWidth: dragPreviewWidth, dragPreviewHeight: dragPreviewHeight } = $5602532c3a47f0c2$var$getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight);
    const calculateYOffset = ()=>{
        const interpolantY = new (0, $64c3fe6fd2a9a228$export$6d87c156c5199b02)([
            0,
            0.5,
            1
        ], [
            // Dock to the top
            offsetFromDragPreview.y,
            // Align at the center
            offsetFromDragPreview.y / sourceHeight * dragPreviewHeight,
            // Dock to the bottom
            offsetFromDragPreview.y + dragPreviewHeight - sourceHeight
        ]);
        let y = interpolantY.interpolate(anchorY);
        // Work around Safari 8 positioning bug
        if ((0, $7fe739f3b16a1a72$export$95df08bae54cb4df)() && isImage) // We'll have to wait for @3x to see if this is entirely correct
        y += (window.devicePixelRatio - 1) * dragPreviewHeight;
        return y;
    };
    const calculateXOffset = ()=>{
        // Interpolate coordinates depending on anchor point
        // If you know a simpler way to do this, let me know
        const interpolantX = new (0, $64c3fe6fd2a9a228$export$6d87c156c5199b02)([
            0,
            0.5,
            1
        ], [
            // Dock to the left
            offsetFromDragPreview.x,
            // Align at the center
            offsetFromDragPreview.x / sourceWidth * dragPreviewWidth,
            // Dock to the right
            offsetFromDragPreview.x + dragPreviewWidth - sourceWidth
        ]);
        return interpolantX.interpolate(anchorX);
    };
    // Force offsets if specified in the options.
    const { offsetX: offsetX, offsetY: offsetY } = offsetPoint;
    const isManualOffsetX = offsetX === 0 || offsetX;
    const isManualOffsetY = offsetY === 0 || offsetY;
    return {
        x: isManualOffsetX ? offsetX : calculateXOffset(),
        y: isManualOffsetY ? offsetY : calculateYOffset()
    };
}


class $714a6cd8030e3199$export$2b3a268803e49e64 {
    get window() {
        if (this.globalContext) return this.globalContext;
        else if (typeof window !== "undefined") return window;
        return undefined;
    }
    get document() {
        var ref;
        if ((ref = this.globalContext) === null || ref === void 0 ? void 0 : ref.document) return this.globalContext.document;
        else if (this.window) return this.window.document;
        else return undefined;
    }
    get rootElement() {
        var ref;
        return ((ref = this.optionsArgs) === null || ref === void 0 ? void 0 : ref.rootElement) || this.window;
    }
    constructor(globalContext, options){
        this.ownerDocument = null;
        this.globalContext = globalContext;
        this.optionsArgs = options;
    }
}


function $2080c741ee4be55f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2080c741ee4be55f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $2080c741ee4be55f$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
class $2080c741ee4be55f$export$3a01990c235a9281 {
    /**
	 * Generate profiling statistics for the HTML5Backend.
	 */ profile() {
        var ref, ref1;
        return {
            sourcePreviewNodes: this.sourcePreviewNodes.size,
            sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
            sourceNodeOptions: this.sourceNodeOptions.size,
            sourceNodes: this.sourceNodes.size,
            dragStartSourceIds: ((ref = this.dragStartSourceIds) === null || ref === void 0 ? void 0 : ref.length) || 0,
            dropTargetIds: this.dropTargetIds.length,
            dragEnterTargetIds: this.dragEnterTargetIds.length,
            dragOverTargetIds: ((ref1 = this.dragOverTargetIds) === null || ref1 === void 0 ? void 0 : ref1.length) || 0
        };
    }
    // public for test
    get window() {
        return this.options.window;
    }
    get document() {
        return this.options.document;
    }
    /**
	 * Get the root element to use for event subscriptions
	 */ get rootElement() {
        return this.options.rootElement;
    }
    setup() {
        const root = this.rootElement;
        if (root === undefined) return;
        if (root.__isReactDndBackendSetUp) throw new Error("Cannot have two HTML5 backends at the same time.");
        root.__isReactDndBackendSetUp = true;
        this.addEventListeners(root);
    }
    teardown() {
        const root = this.rootElement;
        if (root === undefined) return;
        root.__isReactDndBackendSetUp = false;
        this.removeEventListeners(this.rootElement);
        this.clearCurrentDragSourceNode();
        if (this.asyncEndDragFrameId) {
            var ref;
            (ref = this.window) === null || ref === void 0 || ref.cancelAnimationFrame(this.asyncEndDragFrameId);
        }
    }
    connectDragPreview(sourceId, node, options) {
        this.sourcePreviewNodeOptions.set(sourceId, options);
        this.sourcePreviewNodes.set(sourceId, node);
        return ()=>{
            this.sourcePreviewNodes.delete(sourceId);
            this.sourcePreviewNodeOptions.delete(sourceId);
        };
    }
    connectDragSource(sourceId, node, options) {
        this.sourceNodes.set(sourceId, node);
        this.sourceNodeOptions.set(sourceId, options);
        const handleDragStart = (e)=>this.handleDragStart(e, sourceId);
        const handleSelectStart = (e)=>this.handleSelectStart(e);
        node.setAttribute("draggable", "true");
        node.addEventListener("dragstart", handleDragStart);
        node.addEventListener("selectstart", handleSelectStart);
        return ()=>{
            this.sourceNodes.delete(sourceId);
            this.sourceNodeOptions.delete(sourceId);
            node.removeEventListener("dragstart", handleDragStart);
            node.removeEventListener("selectstart", handleSelectStart);
            node.setAttribute("draggable", "false");
        };
    }
    connectDropTarget(targetId, node) {
        const handleDragEnter = (e)=>this.handleDragEnter(e, targetId);
        const handleDragOver = (e)=>this.handleDragOver(e, targetId);
        const handleDrop = (e)=>this.handleDrop(e, targetId);
        node.addEventListener("dragenter", handleDragEnter);
        node.addEventListener("dragover", handleDragOver);
        node.addEventListener("drop", handleDrop);
        return ()=>{
            node.removeEventListener("dragenter", handleDragEnter);
            node.removeEventListener("dragover", handleDragOver);
            node.removeEventListener("drop", handleDrop);
        };
    }
    addEventListeners(target) {
        // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
        if (!target.addEventListener) return;
        target.addEventListener("dragstart", this.handleTopDragStart);
        target.addEventListener("dragstart", this.handleTopDragStartCapture, true);
        target.addEventListener("dragend", this.handleTopDragEndCapture, true);
        target.addEventListener("dragenter", this.handleTopDragEnter);
        target.addEventListener("dragenter", this.handleTopDragEnterCapture, true);
        target.addEventListener("dragleave", this.handleTopDragLeaveCapture, true);
        target.addEventListener("dragover", this.handleTopDragOver);
        target.addEventListener("dragover", this.handleTopDragOverCapture, true);
        target.addEventListener("drop", this.handleTopDrop);
        target.addEventListener("drop", this.handleTopDropCapture, true);
    }
    removeEventListeners(target) {
        // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
        if (!target.removeEventListener) return;
        target.removeEventListener("dragstart", this.handleTopDragStart);
        target.removeEventListener("dragstart", this.handleTopDragStartCapture, true);
        target.removeEventListener("dragend", this.handleTopDragEndCapture, true);
        target.removeEventListener("dragenter", this.handleTopDragEnter);
        target.removeEventListener("dragenter", this.handleTopDragEnterCapture, true);
        target.removeEventListener("dragleave", this.handleTopDragLeaveCapture, true);
        target.removeEventListener("dragover", this.handleTopDragOver);
        target.removeEventListener("dragover", this.handleTopDragOverCapture, true);
        target.removeEventListener("drop", this.handleTopDrop);
        target.removeEventListener("drop", this.handleTopDropCapture, true);
    }
    getCurrentSourceNodeOptions() {
        const sourceId = this.monitor.getSourceId();
        const sourceNodeOptions = this.sourceNodeOptions.get(sourceId);
        return $2080c741ee4be55f$var$_objectSpread({
            dropEffect: this.altKeyPressed ? "copy" : "move"
        }, sourceNodeOptions || {});
    }
    getCurrentDropEffect() {
        if (this.isDraggingNativeItem()) // It makes more sense to default to 'copy' for native resources
        return "copy";
        return this.getCurrentSourceNodeOptions().dropEffect;
    }
    getCurrentSourcePreviewNodeOptions() {
        const sourceId = this.monitor.getSourceId();
        const sourcePreviewNodeOptions = this.sourcePreviewNodeOptions.get(sourceId);
        return $2080c741ee4be55f$var$_objectSpread({
            anchorX: 0.5,
            anchorY: 0.5,
            captureDraggingState: false
        }, sourcePreviewNodeOptions || {});
    }
    isDraggingNativeItem() {
        const itemType = this.monitor.getItemType();
        return Object.keys($756d467d767a1fe0$exports).some((key)=>$756d467d767a1fe0$exports[key] === itemType);
    }
    beginDragNativeItem(type, dataTransfer) {
        this.clearCurrentDragSourceNode();
        this.currentNativeSource = (0, $13d2017e52d6b2d0$export$ada362c01636774d)(type, dataTransfer);
        this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
        this.actions.beginDrag([
            this.currentNativeHandle
        ]);
    }
    setCurrentDragSourceNode(node) {
        this.clearCurrentDragSourceNode();
        this.currentDragSourceNode = node;
        // A timeout of > 0 is necessary to resolve Firefox issue referenced
        // See:
        //   * https://github.com/react-dnd/react-dnd/pull/928
        //   * https://github.com/react-dnd/react-dnd/issues/869
        const MOUSE_MOVE_TIMEOUT = 1000;
        // Receiving a mouse event in the middle of a dragging operation
        // means it has ended and the drag source node disappeared from DOM,
        // so the browser didn't dispatch the dragend event.
        //
        // We need to wait before we start listening for mousemove events.
        // This is needed because the drag preview needs to be drawn or else it fires an 'mousemove' event
        // immediately in some browsers.
        //
        // See:
        //   * https://github.com/react-dnd/react-dnd/pull/928
        //   * https://github.com/react-dnd/react-dnd/issues/869
        //
        this.mouseMoveTimeoutTimer = setTimeout(()=>{
            var ref;
            return (ref = this.rootElement) === null || ref === void 0 ? void 0 : ref.addEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, true);
        }, MOUSE_MOVE_TIMEOUT);
    }
    clearCurrentDragSourceNode() {
        if (this.currentDragSourceNode) {
            this.currentDragSourceNode = null;
            if (this.rootElement) {
                var ref;
                (ref = this.window) === null || ref === void 0 || ref.clearTimeout(this.mouseMoveTimeoutTimer || undefined);
                this.rootElement.removeEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, true);
            }
            this.mouseMoveTimeoutTimer = null;
            return true;
        }
        return false;
    }
    handleDragStart(e, sourceId) {
        if (e.defaultPrevented) return;
        if (!this.dragStartSourceIds) this.dragStartSourceIds = [];
        this.dragStartSourceIds.unshift(sourceId);
    }
    handleDragEnter(_e, targetId) {
        this.dragEnterTargetIds.unshift(targetId);
    }
    handleDragOver(_e, targetId) {
        if (this.dragOverTargetIds === null) this.dragOverTargetIds = [];
        this.dragOverTargetIds.unshift(targetId);
    }
    handleDrop(_e, targetId) {
        this.dropTargetIds.unshift(targetId);
    }
    constructor(manager, globalContext, options){
        this.sourcePreviewNodes = new Map();
        this.sourcePreviewNodeOptions = new Map();
        this.sourceNodes = new Map();
        this.sourceNodeOptions = new Map();
        this.dragStartSourceIds = null;
        this.dropTargetIds = [];
        this.dragEnterTargetIds = [];
        this.currentNativeSource = null;
        this.currentNativeHandle = null;
        this.currentDragSourceNode = null;
        this.altKeyPressed = false;
        this.mouseMoveTimeoutTimer = null;
        this.asyncEndDragFrameId = null;
        this.dragOverTargetIds = null;
        this.lastClientOffset = null;
        this.hoverRafId = null;
        this.getSourceClientOffset = (sourceId)=>{
            const source = this.sourceNodes.get(sourceId);
            return source && (0, $5602532c3a47f0c2$export$8419e8612027b1d8)(source) || null;
        };
        this.endDragNativeItem = ()=>{
            if (!this.isDraggingNativeItem()) return;
            this.actions.endDrag();
            if (this.currentNativeHandle) this.registry.removeSource(this.currentNativeHandle);
            this.currentNativeHandle = null;
            this.currentNativeSource = null;
        };
        this.isNodeInDocument = (node)=>{
            // Check the node either in the main document or in the current context
            return Boolean(node && this.document && this.document.body && this.document.body.contains(node));
        };
        this.endDragIfSourceWasRemovedFromDOM = ()=>{
            const node = this.currentDragSourceNode;
            if (node == null || this.isNodeInDocument(node)) return;
            if (this.clearCurrentDragSourceNode() && this.monitor.isDragging()) this.actions.endDrag();
            this.cancelHover();
        };
        this.scheduleHover = (dragOverTargetIds)=>{
            if (this.hoverRafId === null && typeof requestAnimationFrame !== "undefined") this.hoverRafId = requestAnimationFrame(()=>{
                if (this.monitor.isDragging()) this.actions.hover(dragOverTargetIds || [], {
                    clientOffset: this.lastClientOffset
                });
                this.hoverRafId = null;
            });
        };
        this.cancelHover = ()=>{
            if (this.hoverRafId !== null && typeof cancelAnimationFrame !== "undefined") {
                cancelAnimationFrame(this.hoverRafId);
                this.hoverRafId = null;
            }
        };
        this.handleTopDragStartCapture = ()=>{
            this.clearCurrentDragSourceNode();
            this.dragStartSourceIds = [];
        };
        this.handleTopDragStart = (e)=>{
            if (e.defaultPrevented) return;
            const { dragStartSourceIds: dragStartSourceIds } = this;
            this.dragStartSourceIds = null;
            const clientOffset = (0, $5602532c3a47f0c2$export$710c829989c68339)(e);
            // Avoid crashing if we missed a drop event or our previous drag died
            if (this.monitor.isDragging()) {
                this.actions.endDrag();
                this.cancelHover();
            }
            // Don't publish the source just yet (see why below)
            this.actions.beginDrag(dragStartSourceIds || [], {
                publishSource: false,
                getSourceClientOffset: this.getSourceClientOffset,
                clientOffset: clientOffset
            });
            const { dataTransfer: dataTransfer } = e;
            const nativeType = (0, $13d2017e52d6b2d0$export$11b547ed8c182c11)(dataTransfer);
            if (this.monitor.isDragging()) {
                if (dataTransfer && typeof dataTransfer.setDragImage === "function") {
                    // Use custom drag image if user specifies it.
                    // If child drag source refuses drag but parent agrees,
                    // use parent's node as drag image. Neither works in IE though.
                    const sourceId = this.monitor.getSourceId();
                    const sourceNode = this.sourceNodes.get(sourceId);
                    const dragPreview = this.sourcePreviewNodes.get(sourceId) || sourceNode;
                    if (dragPreview) {
                        const { anchorX: anchorX, anchorY: anchorY, offsetX: offsetX, offsetY: offsetY } = this.getCurrentSourcePreviewNodeOptions();
                        const anchorPoint = {
                            anchorX: anchorX,
                            anchorY: anchorY
                        };
                        const offsetPoint = {
                            offsetX: offsetX,
                            offsetY: offsetY
                        };
                        const dragPreviewOffset = (0, $5602532c3a47f0c2$export$e99fdbb90efc75c5)(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);
                        dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
                    }
                }
                try {
                    // Firefox won't drag without setting data
                    dataTransfer === null || dataTransfer === void 0 || dataTransfer.setData("application/json", {});
                } catch (err) {
                // IE doesn't support MIME types in setData
                }
                // Store drag source node so we can check whether
                // it is removed from DOM and trigger endDrag manually.
                this.setCurrentDragSourceNode(e.target);
                // Now we are ready to publish the drag source.. or are we not?
                const { captureDraggingState: captureDraggingState } = this.getCurrentSourcePreviewNodeOptions();
                if (!captureDraggingState) // Usually we want to publish it in the next tick so that browser
                // is able to screenshot the current (not yet dragging) state.
                //
                // It also neatly avoids a situation where render() returns null
                // in the same tick for the source element, and browser freaks out.
                setTimeout(()=>this.actions.publishDragSource(), 0);
                else // In some cases the user may want to override this behavior, e.g.
                // to work around IE not supporting custom drag previews.
                //
                // When using a custom drag layer, the only way to prevent
                // the default drag preview from drawing in IE is to screenshot
                // the dragging state in which the node itself has zero opacity
                // and height. In this case, though, returning null from render()
                // will abruptly end the dragging, which is not obvious.
                //
                // This is the reason such behavior is strictly opt-in.
                this.actions.publishDragSource();
            } else if (nativeType) // A native item (such as URL) dragged from inside the document
            this.beginDragNativeItem(nativeType);
            else if (dataTransfer && !dataTransfer.types && (e.target && !e.target.hasAttribute || !e.target.hasAttribute("draggable"))) // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
            // Just let it drag. It's a native type (URL or text) and will be picked up in
            // dragenter handler.
            return;
            else // If by this time no drag source reacted, tell browser not to drag.
            e.preventDefault();
        };
        this.handleTopDragEndCapture = ()=>{
            if (this.clearCurrentDragSourceNode() && this.monitor.isDragging()) // Firefox can dispatch this event in an infinite loop
            // if dragend handler does something like showing an alert.
            // Only proceed if we have not handled it already.
            this.actions.endDrag();
            this.cancelHover();
        };
        this.handleTopDragEnterCapture = (e)=>{
            this.dragEnterTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                (ref = this.currentNativeSource) === null || ref === void 0 || ref.loadDataTransfer(e.dataTransfer);
            }
            const isFirstEnter = this.enterLeaveCounter.enter(e.target);
            if (!isFirstEnter || this.monitor.isDragging()) return;
            const { dataTransfer: dataTransfer } = e;
            const nativeType = (0, $13d2017e52d6b2d0$export$11b547ed8c182c11)(dataTransfer);
            if (nativeType) // A native item (such as file or URL) dragged from outside the document
            this.beginDragNativeItem(nativeType, dataTransfer);
        };
        this.handleTopDragEnter = (e)=>{
            const { dragEnterTargetIds: dragEnterTargetIds } = this;
            this.dragEnterTargetIds = [];
            if (!this.monitor.isDragging()) // This is probably a native item type we don't understand.
            return;
            this.altKeyPressed = e.altKey;
            // If the target changes position as the result of `dragenter`, `dragover` might still
            // get dispatched despite target being no longer there. The easy solution is to check
            // whether there actually is a target before firing `hover`.
            if (dragEnterTargetIds.length > 0) this.actions.hover(dragEnterTargetIds, {
                clientOffset: (0, $5602532c3a47f0c2$export$710c829989c68339)(e)
            });
            const canDrop = dragEnterTargetIds.some((targetId)=>this.monitor.canDropOnTarget(targetId));
            if (canDrop) {
                // IE requires this to fire dragover events
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = this.getCurrentDropEffect();
            }
        };
        this.handleTopDragOverCapture = (e)=>{
            this.dragOverTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                (ref = this.currentNativeSource) === null || ref === void 0 || ref.loadDataTransfer(e.dataTransfer);
            }
        };
        this.handleTopDragOver = (e)=>{
            const { dragOverTargetIds: dragOverTargetIds } = this;
            this.dragOverTargetIds = [];
            if (!this.monitor.isDragging()) {
                // This is probably a native item type we don't understand.
                // Prevent default "drop and blow away the whole document" action.
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = "none";
                return;
            }
            this.altKeyPressed = e.altKey;
            this.lastClientOffset = (0, $5602532c3a47f0c2$export$710c829989c68339)(e);
            this.scheduleHover(dragOverTargetIds);
            const canDrop = (dragOverTargetIds || []).some((targetId)=>this.monitor.canDropOnTarget(targetId));
            if (canDrop) {
                // Show user-specified drop effect.
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = this.getCurrentDropEffect();
            } else if (this.isDraggingNativeItem()) // Don't show a nice cursor but still prevent default
            // "drop and blow away the whole document" action.
            e.preventDefault();
            else {
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = "none";
            }
        };
        this.handleTopDragLeaveCapture = (e)=>{
            if (this.isDraggingNativeItem()) e.preventDefault();
            const isLastLeave = this.enterLeaveCounter.leave(e.target);
            if (!isLastLeave) return;
            if (this.isDraggingNativeItem()) setTimeout(()=>this.endDragNativeItem(), 0);
            this.cancelHover();
        };
        this.handleTopDropCapture = (e)=>{
            this.dropTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                e.preventDefault();
                (ref = this.currentNativeSource) === null || ref === void 0 || ref.loadDataTransfer(e.dataTransfer);
            } else if ((0, $13d2017e52d6b2d0$export$11b547ed8c182c11)(e.dataTransfer)) // Dragging some elements, like <a> and <img> may still behave like a native drag event,
            // even if the current drag event matches a user-defined type.
            // Stop the default behavior when we're not expecting a native item to be dropped.
            e.preventDefault();
            this.enterLeaveCounter.reset();
        };
        this.handleTopDrop = (e)=>{
            const { dropTargetIds: dropTargetIds } = this;
            this.dropTargetIds = [];
            this.actions.hover(dropTargetIds, {
                clientOffset: (0, $5602532c3a47f0c2$export$710c829989c68339)(e)
            });
            this.actions.drop({
                dropEffect: this.getCurrentDropEffect()
            });
            if (this.isDraggingNativeItem()) this.endDragNativeItem();
            else if (this.monitor.isDragging()) this.actions.endDrag();
            this.cancelHover();
        };
        this.handleSelectStart = (e)=>{
            const target = e.target;
            // Only IE requires us to explicitly say
            // we want drag drop operation to start
            if (typeof target.dragDrop !== "function") return;
            // Inputs and textareas should be selectable
            if (target.tagName === "INPUT" || target.tagName === "SELECT" || target.tagName === "TEXTAREA" || target.isContentEditable) return;
            // For other targets, ask IE
            // to enable drag and drop
            e.preventDefault();
            target.dragDrop();
        };
        this.options = new (0, $714a6cd8030e3199$export$2b3a268803e49e64)(globalContext, options);
        this.actions = manager.getActions();
        this.monitor = manager.getMonitor();
        this.registry = manager.getRegistry();
        this.enterLeaveCounter = new (0, $7f9af8ed5a0cbff4$export$9ff3e6eb5c734d0d)(this.isNodeInDocument);
    }
}




const $4590d982bbd0a7b3$export$f4f61d779bb20744 = function createBackend(manager, context, options) {
    return new (0, $2080c741ee4be55f$export$3a01990c235a9281)(manager, context, options);
};


var $40da8f7944db251c$export$8e6c816465ea7419;
var $40da8f7944db251c$export$7061c75fc5af8b7e;
$40da8f7944db251c$export$8e6c816465ea7419 = `_2SKKNa_dragging`;
$40da8f7944db251c$export$7061c75fc5af8b7e = `_2SKKNa_item`;


const $9bf2c1ca188f94ef$export$237bd83162c14364 = /*#__PURE__*/ (0, $jC8Vy.createContext)({
    isDragging: false
});
function $9bf2c1ca188f94ef$var$DragDropProvider({ children: children }) {
    const [isDragging, setIsDragging] = (0, $jC8Vy.useState)(false);
    const memorizedContext = (0, $jC8Vy.useMemo)(()=>({
            isDragging: isDragging,
            setIsDragging: setIsDragging
        }), [
        isDragging
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsx)($9bf2c1ca188f94ef$export$237bd83162c14364.Provider, {
        value: memorizedContext,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1565dd1af151930c$export$9861489d68213f9c), {
            backend: (0, $4590d982bbd0a7b3$export$f4f61d779bb20744),
            children: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: (0, $7oDSS.conditionalString)(isDragging && $40da8f7944db251c$export$8e6c816465ea7419),
                children: children
            })
        })
    });
}
var $9bf2c1ca188f94ef$export$2e2bcd8739ae039 = $9bf2c1ca188f94ef$var$DragDropProvider;



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $b490237a884ea319$exports = {};
"use strict";
// do not edit .js files directly - edit src/index.jst
$b490237a884ea319$exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};



var $jC8Vy = parcelRequire("jC8Vy");

var $jC8Vy = parcelRequire("jC8Vy");
const $aade701aee1be517$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $jC8Vy.useLayoutEffect) : (0, $jC8Vy.useEffect);


function $b5791306938b375d$export$e32e64a4387f290a(monitor, collect, onUpdate) {
    const [collected, setCollected] = (0, $jC8Vy.useState)(()=>collect(monitor));
    const updateCollected = (0, $jC8Vy.useCallback)(()=>{
        const nextValue = collect(monitor);
        // This needs to be a deep-equality check because some monitor-collected values
        // include XYCoord objects that may be equivalent, but do not have instance equality.
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($b490237a884ea319$exports)))(collected, nextValue)) {
            setCollected(nextValue);
            if (onUpdate) onUpdate();
        }
    }, [
        collected,
        monitor,
        onUpdate
    ]);
    // update the collected properties after react renders.
    // Note that the "Dustbin Stress Test" fails if this is not
    // done when the component updates
    (0, $aade701aee1be517$export$700979bc83e7db82)(updateCollected);
    return [
        collected,
        updateCollected
    ];
}



function $b685a1943bb00e6f$export$f34439a5e43bd79c(monitor, collect, onCollect) {
    const [collected, updateCollected] = (0, $b5791306938b375d$export$e32e64a4387f290a)(monitor, collect, onCollect);
    (0, $aade701aee1be517$export$700979bc83e7db82)(function subscribeToMonitorStateChange() {
        const handlerId = monitor.getHandlerId();
        if (handlerId == null) return;
        return monitor.subscribeToStateChange(updateCollected, {
            handlerIds: [
                handlerId
            ]
        });
    }, [
        monitor,
        updateCollected
    ]);
    return collected;
}


function $cbc66105089d313e$export$a55a4e3c0acb6f15(collector, monitor, connector) {
    return (0, $b685a1943bb00e6f$export$f34439a5e43bd79c)(monitor, collector || (()=>({})), ()=>connector.reconnect());
}



var $jC8Vy = parcelRequire("jC8Vy");
function $1bbca2b6cd979a61$export$f16a07909151e918(arg, deps) {
    const memoDeps = [
        ...deps || []
    ];
    if (deps == null && typeof arg !== "function") memoDeps.push(arg);
    return (0, $jC8Vy.useMemo)(()=>{
        return typeof arg === "function" ? arg() : arg;
    }, memoDeps);
}



var $jC8Vy = parcelRequire("jC8Vy");
function $41107dd53fe74710$export$90c397533e0cc6(connector) {
    return (0, $jC8Vy.useMemo)(()=>connector.hooks.dragSource(), [
        connector
    ]);
}
function $41107dd53fe74710$export$a66b3011bc8970d6(connector) {
    return (0, $jC8Vy.useMemo)(()=>connector.hooks.dragPreview(), [
        connector
    ]);
}



var $jC8Vy = parcelRequire("jC8Vy");
function $28e2d1a3999b92b2$export$d36bdfa510afb180(objA, objB, compare, compareContext) {
    let compareResult = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (compareResult !== void 0) return !!compareResult;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    const bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(let idx = 0; idx < keysA.length; idx++){
        const key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        const valueA = objA[key];
        const valueB = objB[key];
        compareResult = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (compareResult === false || compareResult === void 0 && valueA !== valueB) return false;
    }
    return true;
}


function $d458985606f7f3a4$export$4f9f5282de18fc69(obj) {
    return obj !== null && typeof obj === "object" && Object.prototype.hasOwnProperty.call(obj, "current");
}




var $jC8Vy = parcelRequire("jC8Vy");
function $9936638d22b1770d$var$throwIfCompositeComponentElement(element) {
    // Custom components can no longer be wrapped directly in React DnD 2.0
    // so that we don't need to depend on findDOMNode() from react-dom.
    if (typeof element.type === "string") return;
    const displayName = element.type.displayName || element.type.name || "the component";
    throw new Error("Only native element nodes can now be passed to React DnD connectors." + `You can either wrap ${displayName} into a <div>, or turn it into a ` + "drag source or a drop target itself.");
}
function $9936638d22b1770d$var$wrapHookToRecognizeElement(hook) {
    return (elementOrNode = null, options = null)=>{
        // When passed a node, call the hook straight away.
        if (!(0, $jC8Vy.isValidElement)(elementOrNode)) {
            const node = elementOrNode;
            hook(node, options);
            // return the node so it can be chained (e.g. when within callback refs
            // <div ref={node => connectDragSource(connectDropTarget(node))}/>
            return node;
        }
        // If passed a ReactElement, clone it and attach this function as a ref.
        // This helps us achieve a neat API where user doesn't even know that refs
        // are being used under the hood.
        const element = elementOrNode;
        $9936638d22b1770d$var$throwIfCompositeComponentElement(element);
        // When no options are passed, use the hook directly
        const ref = options ? (node)=>hook(node, options) : hook;
        return $9936638d22b1770d$var$cloneWithRef(element, ref);
    };
}
function $9936638d22b1770d$export$d8dcaf80ab4f6cb7(hooks) {
    const wrappedHooks = {};
    Object.keys(hooks).forEach((key)=>{
        const hook = hooks[key];
        // ref objects should be passed straight through without wrapping
        if (key.endsWith("Ref")) wrappedHooks[key] = hooks[key];
        else {
            const wrappedHook = $9936638d22b1770d$var$wrapHookToRecognizeElement(hook);
            wrappedHooks[key] = ()=>wrappedHook;
        }
    });
    return wrappedHooks;
}
function $9936638d22b1770d$var$setRef(ref, node) {
    if (typeof ref === "function") ref(node);
    else ref.current = node;
}
function $9936638d22b1770d$var$cloneWithRef(element, newRef) {
    const previousRef = element.ref;
    (0, $79773a7d776aedca$export$f5708dca728d7177)(typeof previousRef !== "string", "Cannot connect React DnD to an element with an existing string ref. Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. Read more: https://reactjs.org/docs/refs-and-the-dom.html#callback-refs");
    if (!previousRef) // When there is no ref on the element, use the new ref directly
    return (0, $jC8Vy.cloneElement)(element, {
        ref: newRef
    });
    else return (0, $jC8Vy.cloneElement)(element, {
        ref: (node)=>{
            $9936638d22b1770d$var$setRef(previousRef, node);
            $9936638d22b1770d$var$setRef(newRef, node);
        }
    });
}


class $db39b1c25db500b6$export$9a7176fb37ab5028 {
    receiveHandlerId(newHandlerId) {
        if (this.handlerId === newHandlerId) return;
        this.handlerId = newHandlerId;
        this.reconnect();
    }
    get connectTarget() {
        return this.dragSource;
    }
    get dragSourceOptions() {
        return this.dragSourceOptionsInternal;
    }
    set dragSourceOptions(options) {
        this.dragSourceOptionsInternal = options;
    }
    get dragPreviewOptions() {
        return this.dragPreviewOptionsInternal;
    }
    set dragPreviewOptions(options) {
        this.dragPreviewOptionsInternal = options;
    }
    reconnect() {
        const didChange = this.reconnectDragSource();
        this.reconnectDragPreview(didChange);
    }
    reconnectDragSource() {
        const dragSource = this.dragSource;
        // if nothing has changed then don't resubscribe
        const didChange = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();
        if (didChange) this.disconnectDragSource();
        if (!this.handlerId) return didChange;
        if (!dragSource) {
            this.lastConnectedDragSource = dragSource;
            return didChange;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDragSource = dragSource;
            this.lastConnectedDragSourceOptions = this.dragSourceOptions;
            this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, dragSource, this.dragSourceOptions);
        }
        return didChange;
    }
    reconnectDragPreview(forceDidChange = false) {
        const dragPreview = this.dragPreview;
        // if nothing has changed then don't resubscribe
        const didChange = forceDidChange || this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();
        if (didChange) this.disconnectDragPreview();
        if (!this.handlerId) return;
        if (!dragPreview) {
            this.lastConnectedDragPreview = dragPreview;
            return;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDragPreview = dragPreview;
            this.lastConnectedDragPreviewOptions = this.dragPreviewOptions;
            this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, dragPreview, this.dragPreviewOptions);
        }
    }
    didHandlerIdChange() {
        return this.lastConnectedHandlerId !== this.handlerId;
    }
    didConnectedDragSourceChange() {
        return this.lastConnectedDragSource !== this.dragSource;
    }
    didConnectedDragPreviewChange() {
        return this.lastConnectedDragPreview !== this.dragPreview;
    }
    didDragSourceOptionsChange() {
        return !(0, $28e2d1a3999b92b2$export$d36bdfa510afb180)(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
    }
    didDragPreviewOptionsChange() {
        return !(0, $28e2d1a3999b92b2$export$d36bdfa510afb180)(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
    }
    disconnectDragSource() {
        if (this.dragSourceUnsubscribe) {
            this.dragSourceUnsubscribe();
            this.dragSourceUnsubscribe = undefined;
        }
    }
    disconnectDragPreview() {
        if (this.dragPreviewUnsubscribe) {
            this.dragPreviewUnsubscribe();
            this.dragPreviewUnsubscribe = undefined;
            this.dragPreviewNode = null;
            this.dragPreviewRef = null;
        }
    }
    get dragSource() {
        return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
    }
    get dragPreview() {
        return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
    }
    clearDragSource() {
        this.dragSourceNode = null;
        this.dragSourceRef = null;
    }
    clearDragPreview() {
        this.dragPreviewNode = null;
        this.dragPreviewRef = null;
    }
    constructor(backend){
        this.hooks = (0, $9936638d22b1770d$export$d8dcaf80ab4f6cb7)({
            dragSource: (node, options)=>{
                this.clearDragSource();
                this.dragSourceOptions = options || null;
                if ((0, $d458985606f7f3a4$export$4f9f5282de18fc69)(node)) this.dragSourceRef = node;
                else this.dragSourceNode = node;
                this.reconnectDragSource();
            },
            dragPreview: (node, options)=>{
                this.clearDragPreview();
                this.dragPreviewOptions = options || null;
                if ((0, $d458985606f7f3a4$export$4f9f5282de18fc69)(node)) this.dragPreviewRef = node;
                else this.dragPreviewNode = node;
                this.reconnectDragPreview();
            }
        });
        this.handlerId = null;
        // The drop target may either be attached via ref or connect function
        this.dragSourceRef = null;
        this.dragSourceOptionsInternal = null;
        // The drag preview may either be attached via ref or connect function
        this.dragPreviewRef = null;
        this.dragPreviewOptionsInternal = null;
        this.lastConnectedHandlerId = null;
        this.lastConnectedDragSource = null;
        this.lastConnectedDragSourceOptions = null;
        this.lastConnectedDragPreview = null;
        this.lastConnectedDragPreviewOptions = null;
        this.backend = backend;
    }
}




var $jC8Vy = parcelRequire("jC8Vy");

function $56e18a6a74c0ba66$export$49db7e1a057ab0fa() {
    const { dragDropManager: dragDropManager } = (0, $jC8Vy.useContext)((0, $78d2743c927350a9$export$2d5c5ceac203fc1e));
    (0, $79773a7d776aedca$export$f5708dca728d7177)(dragDropManager != null, "Expected drag drop context");
    return dragDropManager;
}



function $8fa4a091fbd549a7$export$a5dfa024c6f78e86(dragSourceOptions, dragPreviewOptions) {
    const manager = (0, $56e18a6a74c0ba66$export$49db7e1a057ab0fa)();
    const connector = (0, $jC8Vy.useMemo)(()=>new (0, $db39b1c25db500b6$export$9a7176fb37ab5028)(manager.getBackend()), [
        manager
    ]);
    (0, $aade701aee1be517$export$700979bc83e7db82)(()=>{
        connector.dragSourceOptions = dragSourceOptions || null;
        connector.reconnect();
        return ()=>connector.disconnectDragSource();
    }, [
        connector,
        dragSourceOptions
    ]);
    (0, $aade701aee1be517$export$700979bc83e7db82)(()=>{
        connector.dragPreviewOptions = dragPreviewOptions || null;
        connector.reconnect();
        return ()=>connector.disconnectDragPreview();
    }, [
        connector,
        dragPreviewOptions
    ]);
    return connector;
}



var $jC8Vy = parcelRequire("jC8Vy");

let $8779e8123c7ce9c6$var$isCallingCanDrag = false;
let $8779e8123c7ce9c6$var$isCallingIsDragging = false;
class $8779e8123c7ce9c6$export$af934094fb48ddf {
    receiveHandlerId(sourceId) {
        this.sourceId = sourceId;
    }
    getHandlerId() {
        return this.sourceId;
    }
    canDrag() {
        (0, $79773a7d776aedca$export$f5708dca728d7177)(!$8779e8123c7ce9c6$var$isCallingCanDrag, "You may not call monitor.canDrag() inside your canDrag() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
        try {
            $8779e8123c7ce9c6$var$isCallingCanDrag = true;
            return this.internalMonitor.canDragSource(this.sourceId);
        } finally{
            $8779e8123c7ce9c6$var$isCallingCanDrag = false;
        }
    }
    isDragging() {
        if (!this.sourceId) return false;
        (0, $79773a7d776aedca$export$f5708dca728d7177)(!$8779e8123c7ce9c6$var$isCallingIsDragging, "You may not call monitor.isDragging() inside your isDragging() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
        try {
            $8779e8123c7ce9c6$var$isCallingIsDragging = true;
            return this.internalMonitor.isDraggingSource(this.sourceId);
        } finally{
            $8779e8123c7ce9c6$var$isCallingIsDragging = false;
        }
    }
    subscribeToStateChange(listener, options) {
        return this.internalMonitor.subscribeToStateChange(listener, options);
    }
    isDraggingSource(sourceId) {
        return this.internalMonitor.isDraggingSource(sourceId);
    }
    isOverTarget(targetId, options) {
        return this.internalMonitor.isOverTarget(targetId, options);
    }
    getTargetIds() {
        return this.internalMonitor.getTargetIds();
    }
    isSourcePublic() {
        return this.internalMonitor.isSourcePublic();
    }
    getSourceId() {
        return this.internalMonitor.getSourceId();
    }
    subscribeToOffsetChange(listener) {
        return this.internalMonitor.subscribeToOffsetChange(listener);
    }
    canDragSource(sourceId) {
        return this.internalMonitor.canDragSource(sourceId);
    }
    canDropOnTarget(targetId) {
        return this.internalMonitor.canDropOnTarget(targetId);
    }
    getItemType() {
        return this.internalMonitor.getItemType();
    }
    getItem() {
        return this.internalMonitor.getItem();
    }
    getDropResult() {
        return this.internalMonitor.getDropResult();
    }
    didDrop() {
        return this.internalMonitor.didDrop();
    }
    getInitialClientOffset() {
        return this.internalMonitor.getInitialClientOffset();
    }
    getInitialSourceClientOffset() {
        return this.internalMonitor.getInitialSourceClientOffset();
    }
    getSourceClientOffset() {
        return this.internalMonitor.getSourceClientOffset();
    }
    getClientOffset() {
        return this.internalMonitor.getClientOffset();
    }
    getDifferenceFromInitialOffset() {
        return this.internalMonitor.getDifferenceFromInitialOffset();
    }
    constructor(manager){
        this.sourceId = null;
        this.internalMonitor = manager.getMonitor();
    }
}



function $69eb0db53528a17b$export$82f95eab323fcd7a() {
    const manager = (0, $56e18a6a74c0ba66$export$49db7e1a057ab0fa)();
    return (0, $jC8Vy.useMemo)(()=>new (0, $8779e8123c7ce9c6$export$af934094fb48ddf)(manager), [
        manager
    ]);
}


function $1188b02034bedd0e$export$38b18180ae58b09b(type, target, manager) {
    const registry = manager.getRegistry();
    const targetId = registry.addTarget(type, target);
    return [
        targetId,
        ()=>registry.removeTarget(targetId)
    ];
}
function $1188b02034bedd0e$export$51c814b9e17958c(type, source, manager) {
    const registry = manager.getRegistry();
    const sourceId = registry.addSource(type, source);
    return [
        sourceId,
        ()=>registry.removeSource(sourceId)
    ];
}





var $jC8Vy = parcelRequire("jC8Vy");
class $23cfd888e97b75c7$export$680f0a3c92f9d645 {
    beginDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        let result = null;
        if (typeof spec.item === "object") result = spec.item;
        else if (typeof spec.item === "function") result = spec.item(monitor);
        else result = {};
        return result !== null && result !== void 0 ? result : null;
    }
    canDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (typeof spec.canDrag === "boolean") return spec.canDrag;
        else if (typeof spec.canDrag === "function") return spec.canDrag(monitor);
        else return true;
    }
    isDragging(globalMonitor, target) {
        const spec = this.spec;
        const monitor = this.monitor;
        const { isDragging: isDragging } = spec;
        return isDragging ? isDragging(monitor) : target === globalMonitor.getSourceId();
    }
    endDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        const connector = this.connector;
        const { end: end } = spec;
        if (end) end(monitor.getItem(), monitor);
        connector.reconnect();
    }
    constructor(spec, monitor, connector){
        this.spec = spec;
        this.monitor = monitor;
        this.connector = connector;
    }
}


function $2c13aa023744507f$export$cdddb20adb7aad5c(spec, monitor, connector) {
    const handler = (0, $jC8Vy.useMemo)(()=>new (0, $23cfd888e97b75c7$export$680f0a3c92f9d645)(spec, monitor, connector), [
        monitor,
        connector
    ]);
    (0, $jC8Vy.useEffect)(()=>{
        handler.spec = spec;
    }, [
        spec
    ]);
    return handler;
}




var $jC8Vy = parcelRequire("jC8Vy");
function $f787ae17ff8d90f3$export$dec3a5d742510a3f(spec) {
    return (0, $jC8Vy.useMemo)(()=>{
        const result = spec.type;
        (0, $79773a7d776aedca$export$f5708dca728d7177)(result != null, "spec.type must be defined");
        return result;
    }, [
        spec
    ]);
}


function $199fac639f11caf8$export$1bdd19ff5ac2e03c(spec, monitor, connector) {
    const manager = (0, $56e18a6a74c0ba66$export$49db7e1a057ab0fa)();
    const handler = (0, $2c13aa023744507f$export$cdddb20adb7aad5c)(spec, monitor, connector);
    const itemType = (0, $f787ae17ff8d90f3$export$dec3a5d742510a3f)(spec);
    (0, $aade701aee1be517$export$700979bc83e7db82)(function registerDragSource() {
        if (itemType != null) {
            const [handlerId, unregister] = (0, $1188b02034bedd0e$export$51c814b9e17958c)(itemType, handler, manager);
            monitor.receiveHandlerId(handlerId);
            connector.receiveHandlerId(handlerId);
            return unregister;
        }
        return;
    }, [
        manager,
        monitor,
        connector,
        handler,
        itemType
    ]);
}


function $312885ee3c5429a3$export$7941f8aafa4b6021(specArg, deps) {
    const spec = (0, $1bbca2b6cd979a61$export$f16a07909151e918)(specArg, deps);
    (0, $79773a7d776aedca$export$f5708dca728d7177)(!spec.begin, `useDrag::spec.begin was deprecated in v14. Replace spec.begin() with spec.item(). (see more here - https://react-dnd.github.io/react-dnd/docs/api/use-drag)`);
    const monitor = (0, $69eb0db53528a17b$export$82f95eab323fcd7a)();
    const connector = (0, $8fa4a091fbd549a7$export$a5dfa024c6f78e86)(spec.options, spec.previewOptions);
    (0, $199fac639f11caf8$export$1bdd19ff5ac2e03c)(spec, monitor, connector);
    return [
        (0, $cbc66105089d313e$export$a55a4e3c0acb6f15)(spec.collect, monitor, connector),
        (0, $41107dd53fe74710$export$90c397533e0cc6)(connector),
        (0, $41107dd53fe74710$export$a66b3011bc8970d6)(connector)
    ];
}




var $jC8Vy = parcelRequire("jC8Vy");
function $801f97790779d02b$export$c914595a34b9504a(connector) {
    return (0, $jC8Vy.useMemo)(()=>connector.hooks.dropTarget(), [
        connector
    ]);
}



var $jC8Vy = parcelRequire("jC8Vy");



class $7aa11660050600fc$export$ed6d7b7bc55193cf {
    get connectTarget() {
        return this.dropTarget;
    }
    reconnect() {
        // if nothing has changed then don't resubscribe
        const didChange = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();
        if (didChange) this.disconnectDropTarget();
        const dropTarget = this.dropTarget;
        if (!this.handlerId) return;
        if (!dropTarget) {
            this.lastConnectedDropTarget = dropTarget;
            return;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDropTarget = dropTarget;
            this.lastConnectedDropTargetOptions = this.dropTargetOptions;
            this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, dropTarget, this.dropTargetOptions);
        }
    }
    receiveHandlerId(newHandlerId) {
        if (newHandlerId === this.handlerId) return;
        this.handlerId = newHandlerId;
        this.reconnect();
    }
    get dropTargetOptions() {
        return this.dropTargetOptionsInternal;
    }
    set dropTargetOptions(options) {
        this.dropTargetOptionsInternal = options;
    }
    didHandlerIdChange() {
        return this.lastConnectedHandlerId !== this.handlerId;
    }
    didDropTargetChange() {
        return this.lastConnectedDropTarget !== this.dropTarget;
    }
    didOptionsChange() {
        return !(0, $28e2d1a3999b92b2$export$d36bdfa510afb180)(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
    }
    disconnectDropTarget() {
        if (this.unsubscribeDropTarget) {
            this.unsubscribeDropTarget();
            this.unsubscribeDropTarget = undefined;
        }
    }
    get dropTarget() {
        return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
    }
    clearDropTarget() {
        this.dropTargetRef = null;
        this.dropTargetNode = null;
    }
    constructor(backend){
        this.hooks = (0, $9936638d22b1770d$export$d8dcaf80ab4f6cb7)({
            dropTarget: (node, options)=>{
                this.clearDropTarget();
                this.dropTargetOptions = options;
                if ((0, $d458985606f7f3a4$export$4f9f5282de18fc69)(node)) this.dropTargetRef = node;
                else this.dropTargetNode = node;
                this.reconnect();
            }
        });
        this.handlerId = null;
        // The drop target may either be attached via ref or connect function
        this.dropTargetRef = null;
        this.dropTargetOptionsInternal = null;
        this.lastConnectedHandlerId = null;
        this.lastConnectedDropTarget = null;
        this.lastConnectedDropTargetOptions = null;
        this.backend = backend;
    }
}




function $cf3006ee3ff93638$export$29242ded1aad6df7(options) {
    const manager = (0, $56e18a6a74c0ba66$export$49db7e1a057ab0fa)();
    const connector = (0, $jC8Vy.useMemo)(()=>new (0, $7aa11660050600fc$export$ed6d7b7bc55193cf)(manager.getBackend()), [
        manager
    ]);
    (0, $aade701aee1be517$export$700979bc83e7db82)(()=>{
        connector.dropTargetOptions = options || null;
        connector.reconnect();
        return ()=>connector.disconnectDropTarget();
    }, [
        options
    ]);
    return connector;
}



var $jC8Vy = parcelRequire("jC8Vy");

let $b1b261afee9e92b6$var$isCallingCanDrop = false;
class $b1b261afee9e92b6$export$9fe8834769ae8ddf {
    receiveHandlerId(targetId) {
        this.targetId = targetId;
    }
    getHandlerId() {
        return this.targetId;
    }
    subscribeToStateChange(listener, options) {
        return this.internalMonitor.subscribeToStateChange(listener, options);
    }
    canDrop() {
        // Cut out early if the target id has not been set. This should prevent errors
        // where the user has an older version of dnd-core like in
        // https://github.com/react-dnd/react-dnd/issues/1310
        if (!this.targetId) return false;
        (0, $79773a7d776aedca$export$f5708dca728d7177)(!$b1b261afee9e92b6$var$isCallingCanDrop, "You may not call monitor.canDrop() inside your canDrop() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor");
        try {
            $b1b261afee9e92b6$var$isCallingCanDrop = true;
            return this.internalMonitor.canDropOnTarget(this.targetId);
        } finally{
            $b1b261afee9e92b6$var$isCallingCanDrop = false;
        }
    }
    isOver(options) {
        if (!this.targetId) return false;
        return this.internalMonitor.isOverTarget(this.targetId, options);
    }
    getItemType() {
        return this.internalMonitor.getItemType();
    }
    getItem() {
        return this.internalMonitor.getItem();
    }
    getDropResult() {
        return this.internalMonitor.getDropResult();
    }
    didDrop() {
        return this.internalMonitor.didDrop();
    }
    getInitialClientOffset() {
        return this.internalMonitor.getInitialClientOffset();
    }
    getInitialSourceClientOffset() {
        return this.internalMonitor.getInitialSourceClientOffset();
    }
    getSourceClientOffset() {
        return this.internalMonitor.getSourceClientOffset();
    }
    getClientOffset() {
        return this.internalMonitor.getClientOffset();
    }
    getDifferenceFromInitialOffset() {
        return this.internalMonitor.getDifferenceFromInitialOffset();
    }
    constructor(manager){
        this.targetId = null;
        this.internalMonitor = manager.getMonitor();
    }
}



function $52edf354802a2420$export$f0c0ad05844dec3b() {
    const manager = (0, $56e18a6a74c0ba66$export$49db7e1a057ab0fa)();
    return (0, $jC8Vy.useMemo)(()=>new (0, $b1b261afee9e92b6$export$9fe8834769ae8ddf)(manager), [
        manager
    ]);
}







var $jC8Vy = parcelRequire("jC8Vy");
function $037cce48776034c3$export$2a5cc7f0ac8651d0(spec) {
    const { accept: accept } = spec;
    return (0, $jC8Vy.useMemo)(()=>{
        (0, $79773a7d776aedca$export$f5708dca728d7177)(spec.accept != null, "accept must be defined");
        return Array.isArray(accept) ? accept : [
            accept
        ];
    }, [
        accept
    ]);
}



var $jC8Vy = parcelRequire("jC8Vy");
class $2f2c1701d0b5c538$export$f26a17703f5cb233 {
    canDrop() {
        const spec = this.spec;
        const monitor = this.monitor;
        return spec.canDrop ? spec.canDrop(monitor.getItem(), monitor) : true;
    }
    hover() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (spec.hover) spec.hover(monitor.getItem(), monitor);
    }
    drop() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (spec.drop) return spec.drop(monitor.getItem(), monitor);
        return;
    }
    constructor(spec, monitor){
        this.spec = spec;
        this.monitor = monitor;
    }
}


function $69de9ea59a319bc5$export$5967d4bb72ce3c0(spec, monitor) {
    const dropTarget = (0, $jC8Vy.useMemo)(()=>new (0, $2f2c1701d0b5c538$export$f26a17703f5cb233)(spec, monitor), [
        monitor
    ]);
    (0, $jC8Vy.useEffect)(()=>{
        dropTarget.spec = spec;
    }, [
        spec
    ]);
    return dropTarget;
}


function $d4edb4ca22e4c661$export$b31a008bfacf9de1(spec, monitor, connector) {
    const manager = (0, $56e18a6a74c0ba66$export$49db7e1a057ab0fa)();
    const dropTarget = (0, $69de9ea59a319bc5$export$5967d4bb72ce3c0)(spec, monitor);
    const accept = (0, $037cce48776034c3$export$2a5cc7f0ac8651d0)(spec);
    (0, $aade701aee1be517$export$700979bc83e7db82)(function registerDropTarget() {
        const [handlerId, unregister] = (0, $1188b02034bedd0e$export$38b18180ae58b09b)(accept, dropTarget, manager);
        monitor.receiveHandlerId(handlerId);
        connector.receiveHandlerId(handlerId);
        return unregister;
    }, [
        manager,
        monitor,
        dropTarget,
        connector,
        accept.map((a)=>a.toString()).join("|")
    ]);
}


function $72db1f7656cedc94$export$ccdee5eaf73cf661(specArg, deps) {
    const spec = (0, $1bbca2b6cd979a61$export$f16a07909151e918)(specArg, deps);
    const monitor = (0, $52edf354802a2420$export$f0c0ad05844dec3b)();
    const connector = (0, $cf3006ee3ff93638$export$29242ded1aad6df7)(spec.options);
    (0, $d4edb4ca22e4c661$export$b31a008bfacf9de1)(spec, monitor, connector);
    return [
        (0, $cbc66105089d313e$export$a55a4e3c0acb6f15)(spec.collect, monitor, connector),
        (0, $801f97790779d02b$export$c914595a34b9504a)(connector)
    ];
}



function $f864351d8674fd42$var$DraggableItem({ id: id, children: children, sortIndex: sortIndex, moveItem: moveItem, dragType: dragType = "DraggableItem", className: className }) {
    const ref = (0, $jC8Vy.useRef)(null);
    const { setIsDragging: setIsDragging } = (0, $jC8Vy.useContext)((0, $9bf2c1ca188f94ef$export$237bd83162c14364));
    const [{ handlerId: handlerId }, drop] = (0, $72db1f7656cedc94$export$ccdee5eaf73cf661)({
        accept: dragType,
        collect (monitor) {
            return {
                handlerId: monitor.getHandlerId()
            };
        },
        hover (item, monitor) {
            if (!ref.current) return;
            const dragIndex = item.sortIndex;
            const hoverIndex = sortIndex;
            // Don't replace items with themselves
            if (dragIndex === hoverIndex) return;
            // Determine rectangle on screen
            const hoverBoundingRect = ref.current.getBoundingClientRect();
            // Get vertical middle
            const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
            // Determine mouse position
            const clientOffset = monitor.getClientOffset();
            // Get pixels to the top
            const hoverClientY = (clientOffset?.y ?? 0) - hoverBoundingRect.top;
            // Only perform the move when the mouse has crossed half of the items height
            // When dragging downwards, only move when the cursor is below 50%
            // When dragging upwards, only move when the cursor is above 50%
            // Dragging downwards
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) return;
            // Dragging upwards
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) return;
            // Time to actually perform the action
            moveItem(dragIndex, hoverIndex);
            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            // eslint-disable-next-line @silverhand/fp/no-mutation
            item.sortIndex = hoverIndex;
        }
    });
    const [{ isDragging: isDragging }, drag] = (0, $312885ee3c5429a3$export$7941f8aafa4b6021)({
        type: dragType,
        item: ()=>{
            return {
                id: id,
                sortIndex: sortIndex
            };
        },
        collect: (monitor)=>({
                isDragging: monitor.isDragging()
            })
    });
    const opacity = isDragging ? 0 : 1;
    drag(drop(ref));
    (0, $jC8Vy.useEffect)(()=>{
        setIsDragging?.(isDragging);
    }, [
        setIsDragging,
        isDragging
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        ref: ref,
        style: {
            opacity: opacity
        },
        "data-handler-id": handlerId,
        className: className,
        children: children
    });
}
var $f864351d8674fd42$export$2e2bcd8739ae039 = $f864351d8674fd42$var$DraggableItem;





var $jC8Vy = parcelRequire("jC8Vy");

var $voszV = parcelRequire("voszV");
const $dce70f7a16ad80bd$var$useEnabledConnectorTypes = ()=>{
    const { data: connectors } = (0, $voszV.default)("api/connectors");
    const enabledConnectorTypes = (0, $jC8Vy.useMemo)(()=>connectors?.map(({ type: type })=>type) ?? [], [
        connectors
    ]);
    const isConnectorTypeEnabled = (0, $jC8Vy.useCallback)((connectorType)=>enabledConnectorTypes.includes(connectorType), [
        enabledConnectorTypes
    ]);
    return {
        isConnectorTypeEnabled: isConnectorTypeEnabled
    };
};
var $dce70f7a16ad80bd$export$2e2bcd8739ae039 = $dce70f7a16ad80bd$var$useEnabledConnectorTypes;



parcelRequire("oK7kD");
var $kowfT = parcelRequire("kowfT");
parcelRequire("cuPVN");
var $8lyC3 = parcelRequire("8lyC3");
const $aa049a1b9e4654bf$export$b918f3278c9100b2 = {
    [(0, $8lyC3.SignInIdentifier).Email]: (0, $kowfT.ConnectorType).Email,
    [(0, $8lyC3.SignInIdentifier).Phone]: (0, $kowfT.ConnectorType).Sms
};


parcelRequire("cuPVN");
var $8lyC3 = parcelRequire("8lyC3");



const $54e664df476ccbe5$export$2696fec11b4dc54c = (signInIdentifier, signUpConfig, currentCheckState)=>{
    if (signInIdentifier === (0, $8lyC3.SignInIdentifier).Username) return currentCheckState;
    const { password: isSignUpPasswordRequired } = signUpConfig;
    return isSignUpPasswordRequired || currentCheckState;
};
const $54e664df476ccbe5$export$6f13fc330d708d53 = (signInIdentifier, signUpConfig, currentCheckState)=>{
    if (signInIdentifier === (0, $8lyC3.SignInIdentifier).Username) return currentCheckState;
    const { identifier: signUpIdentifier, password: isSignUpPasswordRequired } = signUpConfig;
    if ((0, $8643043f1fa1a33d$export$69ec1500fb2141d2).None !== signUpIdentifier && !isSignUpPasswordRequired) return true;
    return currentCheckState;
};
const $54e664df476ccbe5$export$79c0a739e7155c5f = (identifier)=>({
        identifier: identifier,
        password: true,
        verificationCode: identifier !== (0, $8lyC3.SignInIdentifier).Username,
        isPasswordPrimary: true
    });
const $54e664df476ccbe5$export$df47f60a13d5578b = (signUpIdentifier)=>{
    const identifiers = (0, $cf27937a07aeee10$export$6ce44f6619762c02)[signUpIdentifier];
    return identifiers.includes((0, $8lyC3.SignInIdentifier).Email) || identifiers.includes((0, $8lyC3.SignInIdentifier).Phone);
};
const $54e664df476ccbe5$export$765847ef858119f6 = (signUpIdentifier)=>(0, $cf27937a07aeee10$export$6ce44f6619762c02)[signUpIdentifier].map((identifier)=>(0, $aa049a1b9e4654bf$export$b918f3278c9100b2)[identifier])// eslint-disable-next-line unicorn/prefer-native-coercion-functions
    .filter((connectorType)=>Boolean(connectorType));



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $kezPv = parcelRequire("kezPv");




var $87f7cf92e54567d1$export$c52a2c2535ad2bcb;
var $87f7cf92e54567d1$export$20de9a48f0a5642d;
var $87f7cf92e54567d1$export$8bf4ce924aca1720;
var $87f7cf92e54567d1$export$1455c8f2746d9c06;
var $87f7cf92e54567d1$export$50021cec2d6efdb6;
var $87f7cf92e54567d1$export$a3bc9b8ed74fc;
var $87f7cf92e54567d1$export$493b5823483d2c4e;
var $87f7cf92e54567d1$export$c2ab62c7bf24634;
var $87f7cf92e54567d1$export$3304639b795b6ae;
var $87f7cf92e54567d1$export$bfd64c937657f93a;
var $87f7cf92e54567d1$export$4a6dd88bada4e7d2;
var $87f7cf92e54567d1$export$3b952bca719b842;
var $87f7cf92e54567d1$export$200aa4c63e47ca8c;
var $87f7cf92e54567d1$export$ad45c99c3690e609;
var $87f7cf92e54567d1$export$cb0615a09427c07b;
$87f7cf92e54567d1$export$c52a2c2535ad2bcb = `myI5la_addAnotherSignInMethodDropdown`;
$87f7cf92e54567d1$export$20de9a48f0a5642d = `myI5la_addSignInMethodDropDown`;
$87f7cf92e54567d1$export$8bf4ce924aca1720 = `myI5la_authentication`;
$87f7cf92e54567d1$export$1455c8f2746d9c06 = `myI5la_draggableIcon`;
$87f7cf92e54567d1$export$50021cec2d6efdb6 = `myI5la_draggleItemContainer`;
$87f7cf92e54567d1$export$a3bc9b8ed74fc = `myI5la_error`;
$87f7cf92e54567d1$export$493b5823483d2c4e = `myI5la_errorMessage`;
$87f7cf92e54567d1$export$c2ab62c7bf24634 = `myI5la_identifier`;
$87f7cf92e54567d1$export$3304639b795b6ae = `myI5la_plusIcon`;
$87f7cf92e54567d1$export$bfd64c937657f93a = `myI5la_rotating`;
$87f7cf92e54567d1$export$4a6dd88bada4e7d2 = `myI5la_shimmer`;
$87f7cf92e54567d1$export$3b952bca719b842 = `myI5la_signInMethod`;
$87f7cf92e54567d1$export$200aa4c63e47ca8c = `myI5la_signInMethodItem`;
$87f7cf92e54567d1$export$ad45c99c3690e609 = `myI5la_swapButton`;
$87f7cf92e54567d1$export$cb0615a09427c07b = `myI5la_verifyCodePrimary`;


function $a3deb9b9ac13dc28$var$AddButton({ options: options, onSelected: onSelected, hasSelectedIdentifiers: hasSelectedIdentifiers }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    if (options.length === 0) return null;
    const addSignInMethodButtonProps = {
        type: "default",
        size: "medium",
        title: "sign_in_exp.sign_up_and_sign_in.sign_in.add_sign_in_method",
        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0b30fe81c923292b$export$2e2bcd8739ae039), {
            className: $87f7cf92e54567d1$export$3304639b795b6ae
        })
    };
    const addAnotherButtonProps = {
        type: "text",
        size: "small",
        title: "general.add_another",
        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $kezPv.default), {})
    };
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f25eeaa133584984$export$2e2bcd8739ae039), {
        buttonProps: hasSelectedIdentifiers ? addAnotherButtonProps : addSignInMethodButtonProps,
        dropdownHorizontalAlign: "start",
        dropdownClassName: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))(hasSelectedIdentifiers ? $87f7cf92e54567d1$export$c52a2c2535ad2bcb : $87f7cf92e54567d1$export$20de9a48f0a5642d),
        isDropdownFullWidth: !hasSelectedIdentifiers,
        children: options.map((identifier)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $6c006ec422465f6f$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    onSelected(identifier);
                },
                children: t((0, $cf27937a07aeee10$export$c54a2f6297ba7cbe)[identifier])
            }, identifier))
    });
}
var $a3deb9b9ac13dc28$export$2e2bcd8739ae039 = $a3deb9b9ac13dc28$var$AddButton;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $8lyC3 = parcelRequire("8lyC3");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $5UrGx = parcelRequire("5UrGx");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $6339c3a7edd74477$var$SvgDraggable = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M6 10a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0ZM6 5.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0ZM6 14.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0ZM11 10a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0ZM11 5.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0ZM11 14.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Z",
            fill: "currentColor"
        })
    });
var $6339c3a7edd74477$export$2e2bcd8739ae039 = $6339c3a7edd74477$var$SvgDraggable;



var $jyqwk = parcelRequire("jyqwk");



var $75SRw = parcelRequire("75SRw");
parcelRequire("fIF1D");
var $16GE9 = parcelRequire("16GE9");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $kowfT = parcelRequire("kowfT");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $1QOtg = parcelRequire("1QOtg");

var $9Q3SI = parcelRequire("9Q3SI");

var $9538743bb8e928cd$export$b31f6ae88848cf15;
var $9538743bb8e928cd$export$bfd64c937657f93a;
var $9538743bb8e928cd$export$4a6dd88bada4e7d2;
$9538743bb8e928cd$export$b31f6ae88848cf15 = `ImK0rq_notice`;
$9538743bb8e928cd$export$bfd64c937657f93a = `ImK0rq_rotating`;
$9538743bb8e928cd$export$4a6dd88bada4e7d2 = `ImK0rq_shimmer`;


const $2f0d21b9e2359e99$var$noConnectorWarningPhrase = Object.freeze({
    [(0, $kowfT.ConnectorType).Email]: "sign_in_exp.setup_warning.no_connector_email",
    [(0, $kowfT.ConnectorType).Sms]: "sign_in_exp.setup_warning.no_connector_sms",
    [(0, $kowfT.ConnectorType).Social]: "sign_in_exp.setup_warning.no_connector_social"
});
function $2f0d21b9e2359e99$var$ConnectorSetupWarning({ requiredConnectors: requiredConnectors }) {
    const { isConnectorTypeEnabled: isConnectorTypeEnabled } = (0, $dce70f7a16ad80bd$export$2e2bcd8739ae039)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const missingConnectors = requiredConnectors.filter((connectorType)=>!isConnectorTypeEnabled(connectorType));
    if (missingConnectors.length === 0) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $C7mD2.Fragment), {
        children: missingConnectors.map((connectorType)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $1QOtg.default), {
                className: $9538743bb8e928cd$export$b31f6ae88848cf15,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                    components: {
                        a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                            to: connectorType === (0, $kowfT.ConnectorType).Social ? "/connectors/social" : "/connectors"
                        })
                    },
                    children: t($2f0d21b9e2359e99$var$noConnectorWarningPhrase[connectorType], {
                        link: t("sign_in_exp.setup_warning.setup_link")
                    })
                })
            }, connectorType))
    });
}
var $2f0d21b9e2359e99$export$2e2bcd8739ae039 = $2f0d21b9e2359e99$var$ConnectorSetupWarning;



function $6b201aef34a2638e$var$SignInMethodItem({ signInMethod: { identifier: identifier, password: password, verificationCode: verificationCode, isPasswordPrimary: isPasswordPrimary }, isPasswordCheckable: isPasswordCheckable, isVerificationCodeCheckable: isVerificationCodeCheckable, isDeletable: isDeletable, requiredConnectors: requiredConnectors, hasError: hasError, errorMessage: errorMessage, onVerificationStateChange: onVerificationStateChange, onToggleVerificationPrimary: onToggleVerificationPrimary, onDelete: onDelete }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $87f7cf92e54567d1$export$200aa4c63e47ca8c,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($87f7cf92e54567d1$export$3b952bca719b842, hasError && $87f7cf92e54567d1$export$a3bc9b8ed74fc),
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                className: $87f7cf92e54567d1$export$c2ab62c7bf24634,
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6339c3a7edd74477$export$2e2bcd8739ae039), {
                                        className: $87f7cf92e54567d1$export$1455c8f2746d9c06
                                    }),
                                    t((0, $cf27937a07aeee10$export$c54a2f6297ba7cbe)[identifier])
                                ]
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($87f7cf92e54567d1$export$8bf4ce924aca1720, !isPasswordPrimary && $87f7cf92e54567d1$export$cb0615a09427c07b),
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $26dc4ab718ba37b7$export$2e2bcd8739ae039), {
                                        label: t("sign_in_exp.sign_up_and_sign_in.sign_in.password_auth"),
                                        checked: password,
                                        disabled: !isPasswordCheckable,
                                        tooltip: (0, $7oDSS.conditional)(!isPasswordCheckable && t("sign_in_exp.sign_up_and_sign_in.tip.password_auth")),
                                        onChange: (checked)=>{
                                            onVerificationStateChange("password", checked);
                                        }
                                    }),
                                    identifier !== (0, $8lyC3.SignInIdentifier).Username && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $16GE9.default), {
                                                anchorClassName: $87f7cf92e54567d1$export$ad45c99c3690e609,
                                                content: t("sign_in_exp.sign_up_and_sign_in.sign_in.auth_swap_tip"),
                                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                                                    onClick: onToggleVerificationPrimary,
                                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8fbd391934dd0d24$export$2e2bcd8739ae039), {})
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $26dc4ab718ba37b7$export$2e2bcd8739ae039), {
                                                label: t("sign_in_exp.sign_up_and_sign_in.sign_in.verification_code_auth"),
                                                checked: verificationCode,
                                                disabled: !isVerificationCodeCheckable,
                                                tooltip: (0, $7oDSS.conditional)(!isVerificationCodeCheckable && t("sign_in_exp.sign_up_and_sign_in.tip.verification_code_auth")),
                                                onChange: (checked)=>{
                                                    onVerificationStateChange("verificationCode", checked);
                                                }
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $16GE9.default), {
                        content: (0, $7oDSS.conditional)(!isDeletable && t("sign_in_exp.sign_up_and_sign_in.tip.delete_sign_in_method", {
                            identifier: String(t((0, $cf27937a07aeee10$export$c54a2f6297ba7cbe)[identifier])).toLocaleLowerCase()
                        })),
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                            disabled: !isDeletable,
                            onClick: onDelete,
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jyqwk.default), {})
                        })
                    })
                ]
            }, identifier),
            errorMessage && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $87f7cf92e54567d1$export$493b5823483d2c4e,
                children: errorMessage
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2f0d21b9e2359e99$export$2e2bcd8739ae039), {
                requiredConnectors: requiredConnectors
            })
        ]
    });
}
var $6b201aef34a2638e$export$2e2bcd8739ae039 = $6b201aef34a2638e$var$SignInMethodItem;



function $164454bdcc0839af$var$SignInMethodEditBox() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { control: control, watch: watch, trigger: trigger, formState: { submitCount: submitCount } } = (0, $codQP.useFormContext)();
    const signUp = watch("signUp");
    const { fields: fields, swap: swap, update: update, remove: remove, append: append } = (0, $codQP.useFieldArray)({
        control: control,
        name: "signIn.methods"
    });
    const revalidate = ()=>{
        if (submitCount) // Note: wait for the form to be updated before validating the new data.
        setTimeout(()=>{
            trigger("signIn.methods");
        }, 0);
    };
    const { isConnectorTypeEnabled: isConnectorTypeEnabled } = (0, $dce70f7a16ad80bd$export$2e2bcd8739ae039)();
    const { identifier: signUpIdentifier, password: isSignUpPasswordRequired, verify: isSignUpVerificationRequired } = signUp;
    const requiredSignInIdentifiers = (0, $cf27937a07aeee10$export$6ce44f6619762c02)[signUpIdentifier];
    const ignoredWarningConnectors = (0, $54e664df476ccbe5$export$765847ef858119f6)(signUpIdentifier);
    const signInIdentifierOptions = (0, $cf27937a07aeee10$export$b0ad61f2357dff83).filter((candidateIdentifier)=>fields.every(({ identifier: identifier })=>identifier !== candidateIdentifier));
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9bf2c1ca188f94ef$export$2e2bcd8739ae039), {
                children: fields.map((signInMethod, index)=>{
                    const { id: id, identifier: identifier, verificationCode: verificationCode, isPasswordPrimary: isPasswordPrimary } = signInMethod;
                    const signInRelatedConnector = (0, $aa049a1b9e4654bf$export$b918f3278c9100b2)[identifier];
                    const requiredConnectors = (0, $7oDSS.conditional)(verificationCode && signInRelatedConnector && !ignoredWarningConnectors.includes(signInRelatedConnector) && [
                        signInRelatedConnector
                    ]) ?? [];
                    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f864351d8674fd42$export$2e2bcd8739ae039), {
                        id: id,
                        sortIndex: index,
                        moveItem: swap,
                        className: $87f7cf92e54567d1$export$50021cec2d6efdb6,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                            control: control,
                            name: `signIn.methods.${index}`,
                            rules: {
                                validate: ({ password: password, verificationCode: verificationCode })=>{
                                    if (!password && !verificationCode) return t("sign_in_exp.sign_up_and_sign_in.sign_in.require_auth_factor");
                                    if (verificationCode && requiredConnectors.some((connectorType)=>!isConnectorTypeEnabled(connectorType))) // Note: when required connectors are not all enabled, we show error state without error message for we have the connector setup warning
                                    return false;
                                    return true;
                                }
                            },
                            render: ({ field: { value: value }, fieldState: { error: error } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $6b201aef34a2638e$export$2e2bcd8739ae039), {
                                    signInMethod: value,
                                    isPasswordCheckable: identifier !== (0, $8lyC3.SignInIdentifier).Username && !isSignUpPasswordRequired,
                                    isVerificationCodeCheckable: !(isSignUpVerificationRequired && !isSignUpPasswordRequired),
                                    isDeletable: !requiredSignInIdentifiers.includes(identifier),
                                    requiredConnectors: requiredConnectors,
                                    hasError: Boolean(error),
                                    errorMessage: error?.message,
                                    onVerificationStateChange: (verification, checked)=>{
                                        update(index, {
                                            ...value,
                                            [verification]: checked
                                        });
                                        revalidate();
                                    },
                                    onToggleVerificationPrimary: ()=>{
                                        update(index, {
                                            ...value,
                                            isPasswordPrimary: !isPasswordPrimary
                                        });
                                        revalidate();
                                    },
                                    onDelete: ()=>{
                                        remove(index);
                                        revalidate();
                                    }
                                })
                        })
                    }, id);
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a3deb9b9ac13dc28$export$2e2bcd8739ae039), {
                options: signInIdentifierOptions,
                hasSelectedIdentifiers: fields.length > 0,
                onSelected: (identifier)=>{
                    append((0, $54e664df476ccbe5$export$79c0a739e7155c5f)(identifier));
                    revalidate();
                }
            })
        ]
    });
}
var $164454bdcc0839af$export$2e2bcd8739ae039 = $164454bdcc0839af$var$SignInMethodEditBox;


function $fffebb589150a3ee$var$SignInForm() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $188993d9a1b43b27$export$2e2bcd8739ae039), {
                title: "sign_up_and_sign_in.sign_in.title"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aqmjm.default), {
                title: "sign_in_exp.sign_up_and_sign_in.sign_in.sign_in_identifier_and_auth",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $69a75ca169b2ed64$export$2e2bcd8739ae039), {
                        children: t("sign_in_exp.sign_up_and_sign_in.sign_in.description")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $164454bdcc0839af$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
}
var $fffebb589150a3ee$export$2e2bcd8739ae039 = $fffebb589150a3ee$var$SignInForm;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $gC7hG = parcelRequire("gC7hG");


var $aqmjm = parcelRequire("aqmjm");








var $32566e4992b2ea44$export$bfd64c937657f93a;
var $32566e4992b2ea44$export$4ea6092c933ebdb5;
var $32566e4992b2ea44$export$4a6dd88bada4e7d2;
var $32566e4992b2ea44$export$56cec662996de3c;
var $32566e4992b2ea44$export$fb184b623420d9be;
$32566e4992b2ea44$export$bfd64c937657f93a = `aN8gOa_rotating`;
$32566e4992b2ea44$export$4ea6092c933ebdb5 = `aN8gOa_selections`;
$32566e4992b2ea44$export$4a6dd88bada4e7d2 = `aN8gOa_shimmer`;
$32566e4992b2ea44$export$56cec662996de3c = `aN8gOa_socialOnlyDescription`;
$32566e4992b2ea44$export$fb184b623420d9be = `aN8gOa_title`;


function $26a8106d5a03162b$var$SignUpForm() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { control: control, setValue: setValue, getValues: getValues, watch: watch, trigger: trigger, formState: { errors: errors, submitCount: submitCount } } = (0, $codQP.useFormContext)();
    const { isConnectorTypeEnabled: isConnectorTypeEnabled } = (0, $dce70f7a16ad80bd$export$2e2bcd8739ae039)();
    const signUp = watch("signUp");
    const { identifier: signUpIdentifier } = signUp;
    const isUsernamePasswordSignUp = signUpIdentifier === (0, $8643043f1fa1a33d$export$69ec1500fb2141d2).Username;
    const postSignUpIdentifierChange = (signUpIdentifier)=>{
        if (signUpIdentifier === (0, $8643043f1fa1a33d$export$69ec1500fb2141d2).Username) {
            setValue("signUp.password", true);
            setValue("signUp.verify", false);
            return;
        }
        if (signUpIdentifier === (0, $8643043f1fa1a33d$export$69ec1500fb2141d2).None) {
            setValue("signUp.password", false);
            setValue("signUp.verify", false);
            return;
        }
        if ((0, $54e664df476ccbe5$export$df47f60a13d5578b)(signUpIdentifier)) setValue("signUp.verify", true);
    };
    const refreshSignInMethods = ()=>{
        const signInMethods = getValues("signIn.methods");
        const { identifier: signUpIdentifier } = signUp;
        // Note: append required sign-in methods according to the sign-up identifier config
        const requiredSignInIdentifiers = (0, $cf27937a07aeee10$export$6ce44f6619762c02)[signUpIdentifier];
        const allSignInMethods = requiredSignInIdentifiers.reduce((methods, requiredIdentifier)=>{
            if (signInMethods.some(({ identifier: identifier })=>identifier === requiredIdentifier)) return methods;
            return [
                ...methods,
                (0, $54e664df476ccbe5$export$79c0a739e7155c5f)(requiredIdentifier)
            ];
        }, signInMethods);
        setValue("signIn.methods", // Note: refresh sign-in authentications according to the sign-up authentications config
        allSignInMethods.map((method)=>{
            const { identifier: identifier, password: password, verificationCode: verificationCode } = method;
            return {
                ...method,
                password: (0, $54e664df476ccbe5$export$2696fec11b4dc54c)(identifier, signUp, password),
                verificationCode: (0, $54e664df476ccbe5$export$6f13fc330d708d53)(identifier, signUp, verificationCode)
            };
        }));
        // Note: we need to revalidate the sign-in methods after we have submitted
        if (submitCount) // Note: wait for the form to be updated before validating the new data.
        setTimeout(()=>{
            trigger("signIn.methods");
        }, 0);
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $188993d9a1b43b27$export$2e2bcd8739ae039), {
                title: "sign_up_and_sign_in.sign_up.title"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aqmjm.default), {
                title: "sign_in_exp.sign_up_and_sign_in.sign_up.sign_up_identifier",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $69a75ca169b2ed64$export$2e2bcd8739ae039), {
                        children: t("sign_in_exp.sign_up_and_sign_in.sign_up.identifier_description")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                        name: "signUp.identifier",
                        control: control,
                        rules: {
                            validate: (value)=>{
                                return (0, $54e664df476ccbe5$export$765847ef858119f6)(value).every((connectorType)=>isConnectorTypeEnabled(connectorType));
                            }
                        },
                        render: ({ field: { value: value, onChange: onChange } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $286a7bc94edef870$export$2e2bcd8739ae039), {
                                value: value,
                                error: Boolean(errors.signUp?.identifier),
                                options: (0, $cf27937a07aeee10$export$370e1bd33b1689cd).map((identifier)=>({
                                        value: identifier,
                                        title: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                            children: [
                                                t((0, $cf27937a07aeee10$export$2d3509a8eccb8b17)[identifier]),
                                                identifier === (0, $8643043f1fa1a33d$export$69ec1500fb2141d2).None && /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                                                    className: $32566e4992b2ea44$export$56cec662996de3c,
                                                    children: t("sign_in_exp.sign_up_and_sign_in.sign_up.social_only_creation_description")
                                                })
                                            ]
                                        })
                                    })),
                                onChange: (value)=>{
                                    if (!value) return;
                                    onChange(value);
                                    postSignUpIdentifierChange(value);
                                    refreshSignInMethods();
                                }
                            })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2f0d21b9e2359e99$export$2e2bcd8739ae039), {
                        requiredConnectors: (0, $54e664df476ccbe5$export$765847ef858119f6)(signUpIdentifier)
                    })
                ]
            }),
            signUpIdentifier !== (0, $8643043f1fa1a33d$export$69ec1500fb2141d2).None && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aqmjm.default), {
                title: "sign_in_exp.sign_up_and_sign_in.sign_up.sign_up_authentication",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $69a75ca169b2ed64$export$2e2bcd8739ae039), {
                        children: t("sign_in_exp.sign_up_and_sign_in.sign_up.authentication_description")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $32566e4992b2ea44$export$4ea6092c933ebdb5,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                                name: "signUp.password",
                                control: control,
                                render: ({ field: { value: value, onChange: onChange } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $26dc4ab718ba37b7$export$2e2bcd8739ae039), {
                                        label: t("sign_in_exp.sign_up_and_sign_in.sign_up.set_a_password_option"),
                                        disabled: isUsernamePasswordSignUp,
                                        checked: value,
                                        tooltip: (0, $7oDSS.conditional)(isUsernamePasswordSignUp && t("sign_in_exp.sign_up_and_sign_in.tip.set_a_password")),
                                        onChange: (value)=>{
                                            onChange(value);
                                            refreshSignInMethods();
                                        }
                                    })
                            }),
                            (0, $54e664df476ccbe5$export$df47f60a13d5578b)(signUpIdentifier) && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                                name: "signUp.verify",
                                control: control,
                                render: ({ field: { value: value, onChange: onChange } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $26dc4ab718ba37b7$export$2e2bcd8739ae039), {
                                        disabled: true,
                                        label: t("sign_in_exp.sign_up_and_sign_in.sign_up.verify_at_sign_up_option"),
                                        checked: value,
                                        tooltip: t("sign_in_exp.sign_up_and_sign_in.tip.verify_at_sign_up"),
                                        onChange: (value)=>{
                                            onChange(value);
                                            refreshSignInMethods();
                                        }
                                    })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $26a8106d5a03162b$export$2e2bcd8739ae039 = $26a8106d5a03162b$var$SignUpForm;



var $C7mD2 = parcelRequire("C7mD2");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $gC7hG = parcelRequire("gC7hG");

var $aqmjm = parcelRequire("aqmjm");



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $kowfT = parcelRequire("kowfT");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");


var $9Q3SI = parcelRequire("9Q3SI");



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $kezPv = parcelRequire("kezPv");






var $e9d3caeca07dae53$export$fdddc8db4e8f3828;
var $e9d3caeca07dae53$export$81207e5cc4186890;
var $e9d3caeca07dae53$export$1ca1ec8b29a4ce27;
var $e9d3caeca07dae53$export$a8ff84c12d48cfa6;
var $e9d3caeca07dae53$export$3304639b795b6ae;
var $e9d3caeca07dae53$export$bfd64c937657f93a;
var $e9d3caeca07dae53$export$4a6dd88bada4e7d2;
var $e9d3caeca07dae53$export$fb184b623420d9be;
$e9d3caeca07dae53$export$fdddc8db4e8f3828 = `NCe_Nq_addAnotherDropdown`;
$e9d3caeca07dae53$export$81207e5cc4186890 = `NCe_Nq_dropdown`;
$e9d3caeca07dae53$export$1ca1ec8b29a4ce27 = `NCe_Nq_icon`;
$e9d3caeca07dae53$export$a8ff84c12d48cfa6 = `NCe_Nq_name`;
$e9d3caeca07dae53$export$3304639b795b6ae = `NCe_Nq_plusIcon`;
$e9d3caeca07dae53$export$bfd64c937657f93a = `NCe_Nq_rotating`;
$e9d3caeca07dae53$export$4a6dd88bada4e7d2 = `NCe_Nq_shimmer`;
$e9d3caeca07dae53$export$fb184b623420d9be = `NCe_Nq_title`;


function $b73d21bee9ff6276$var$AddButton({ options: options, onSelected: onSelected, hasSelectedConnectors: hasSelectedConnectors }) {
    if (options.length === 0) return null;
    const addSocialConnectorButtonProps = {
        type: "default",
        size: "medium",
        title: "sign_in_exp.sign_up_and_sign_in.social_sign_in.add_social_connector",
        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0b30fe81c923292b$export$2e2bcd8739ae039), {
            className: $e9d3caeca07dae53$export$3304639b795b6ae
        })
    };
    const addAnotherButtonProps = {
        type: "text",
        size: "small",
        title: "general.add_another",
        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $kezPv.default), {})
    };
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f25eeaa133584984$export$2e2bcd8739ae039), {
        buttonProps: hasSelectedConnectors ? addAnotherButtonProps : addSocialConnectorButtonProps,
        dropdownHorizontalAlign: "start",
        dropdownClassName: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))(hasSelectedConnectors ? $e9d3caeca07dae53$export$fdddc8db4e8f3828 : $e9d3caeca07dae53$export$81207e5cc4186890),
        children: options.map(({ target: target, logo: logo, logoDark: logoDark, name: name, connectors: connectors })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $6c006ec422465f6f$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    onSelected(target);
                },
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: $e9d3caeca07dae53$export$fb184b623420d9be,
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $34186e61374ae5f6$export$2e2bcd8739ae039), {
                            data: {
                                logo: logo,
                                logoDark: logoDark
                            },
                            size: "small"
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ee1df03577241ccd$export$2e2bcd8739ae039), {
                            resource: name,
                            className: $e9d3caeca07dae53$export$a8ff84c12d48cfa6
                        }),
                        connectors.length > 1 && connectors.map(({ platform: platform })=>/*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $e9d3caeca07dae53$export$1ca1ec8b29a4ce27,
                                children: platform && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f79fa5ee09aaae72$export$2e2bcd8739ae039), {
                                    platform: platform
                                })
                            }, platform))
                    ]
                })
            }, target))
    });
}
var $b73d21bee9ff6276$export$2e2bcd8739ae039 = $b73d21bee9ff6276$var$AddButton;



var $C7mD2 = parcelRequire("C7mD2");


var $jyqwk = parcelRequire("jyqwk");



var $75SRw = parcelRequire("75SRw");

var $2cdb13a9a48dcfa9$export$1455c8f2746d9c06;
var $2cdb13a9a48dcfa9$export$1ca1ec8b29a4ce27;
var $2cdb13a9a48dcfa9$export$a80b3bd66acc52ff;
var $2cdb13a9a48dcfa9$export$7061c75fc5af8b7e;
var $2cdb13a9a48dcfa9$export$a8ff84c12d48cfa6;
var $2cdb13a9a48dcfa9$export$bfd64c937657f93a;
var $2cdb13a9a48dcfa9$export$4a6dd88bada4e7d2;
$2cdb13a9a48dcfa9$export$1455c8f2746d9c06 = `cL_q8W_draggableIcon`;
$2cdb13a9a48dcfa9$export$1ca1ec8b29a4ce27 = `cL_q8W_icon`;
$2cdb13a9a48dcfa9$export$a80b3bd66acc52ff = `cL_q8W_info`;
$2cdb13a9a48dcfa9$export$7061c75fc5af8b7e = `cL_q8W_item`;
$2cdb13a9a48dcfa9$export$a8ff84c12d48cfa6 = `cL_q8W_name`;
$2cdb13a9a48dcfa9$export$bfd64c937657f93a = `cL_q8W_rotating`;
$2cdb13a9a48dcfa9$export$4a6dd88bada4e7d2 = `cL_q8W_shimmer`;


function $5b8dd83f800efd7c$var$SelectedConnectorItem({ data: { logo: logo, logoDark: logoDark, target: target, name: name, connectors: connectors }, onDelete: onDelete }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $2cdb13a9a48dcfa9$export$7061c75fc5af8b7e,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $2cdb13a9a48dcfa9$export$a80b3bd66acc52ff,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6339c3a7edd74477$export$2e2bcd8739ae039), {
                        className: $2cdb13a9a48dcfa9$export$1455c8f2746d9c06
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $34186e61374ae5f6$export$2e2bcd8739ae039), {
                        data: {
                            logo: logo,
                            logoDark: logoDark
                        },
                        size: "small"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ee1df03577241ccd$export$2e2bcd8739ae039), {
                        resource: name,
                        className: $2cdb13a9a48dcfa9$export$a8ff84c12d48cfa6
                    }),
                    connectors.length > 1 && connectors.map(({ platform: platform })=>/*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $2cdb13a9a48dcfa9$export$1ca1ec8b29a4ce27,
                            children: platform && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f79fa5ee09aaae72$export$2e2bcd8739ae039), {
                                platform: platform
                            })
                        }, platform))
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                onClick: ()=>{
                    onDelete(target);
                },
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jyqwk.default), {})
            })
        ]
    });
}
var $5b8dd83f800efd7c$export$2e2bcd8739ae039 = $5b8dd83f800efd7c$var$SelectedConnectorItem;


var $9ad24e0549924ef6$export$50021cec2d6efdb6;
var $9ad24e0549924ef6$export$bfd64c937657f93a;
var $9ad24e0549924ef6$export$95dd8163eacc2ed3;
var $9ad24e0549924ef6$export$de27182ff8187d6c;
var $9ad24e0549924ef6$export$4a6dd88bada4e7d2;
$9ad24e0549924ef6$export$50021cec2d6efdb6 = `Ob65FG_draggleItemContainer`;
$9ad24e0549924ef6$export$bfd64c937657f93a = `Ob65FG_rotating`;
$9ad24e0549924ef6$export$95dd8163eacc2ed3 = `Ob65FG_setUpHint`;
$9ad24e0549924ef6$export$de27182ff8187d6c = `Ob65FG_setup`;
$9ad24e0549924ef6$export$4a6dd88bada4e7d2 = `Ob65FG_shimmer`;


function $d0d564ee0f93306f$var$SocialConnectorEditBox({ value: value, onChange: onChange }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: connectorData, error: error } = (0, $9d72639ba10eaeeb$export$2e2bcd8739ae039)();
    if (!connectorData || error) return null;
    const onMoveItem = (dragIndex, hoverIndex)=>{
        const dragItem = value[dragIndex];
        const hoverItem = value[hoverIndex];
        if (!dragItem || !hoverItem) return;
        onChange(value.map((value_, index)=>{
            if (index === dragIndex) return hoverItem;
            if (index === hoverIndex) return dragItem;
            return value_;
        }));
    };
    const socialConnectors = connectorData.filter(({ type: type })=>type === (0, $kowfT.ConnectorType).Social);
    const selectedConnectorItems = value.map((connectorTarget)=>socialConnectors.find(({ target: target })=>target === connectorTarget))// eslint-disable-next-line unicorn/prefer-native-coercion-functions
    .filter((item)=>Boolean(item));
    const connectorOptions = socialConnectors.filter(({ target: target })=>!value.includes(target));
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9bf2c1ca188f94ef$export$2e2bcd8739ae039), {
                children: selectedConnectorItems.map((item, index)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $f864351d8674fd42$export$2e2bcd8739ae039), {
                        id: item.id,
                        sortIndex: index,
                        moveItem: onMoveItem,
                        className: $9ad24e0549924ef6$export$50021cec2d6efdb6,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5b8dd83f800efd7c$export$2e2bcd8739ae039), {
                            data: item,
                            onDelete: (target)=>{
                                onChange(value.filter((connectorTarget)=>connectorTarget !== target));
                            }
                        })
                    }, item.id))
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $b73d21bee9ff6276$export$2e2bcd8739ae039), {
                options: connectorOptions,
                hasSelectedConnectors: selectedConnectorItems.length > 0,
                onSelected: (target)=>{
                    onChange([
                        ...value,
                        target
                    ]);
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2f0d21b9e2359e99$export$2e2bcd8739ae039), {
                requiredConnectors: [
                    (0, $kowfT.ConnectorType).Social
                ]
            }),
            socialConnectors.length > 0 && /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $9ad24e0549924ef6$export$95dd8163eacc2ed3,
                children: [
                    t("sign_in_exp.sign_up_and_sign_in.social_sign_in.set_up_hint.not_in_list"),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                        to: "/connectors/social",
                        className: $9ad24e0549924ef6$export$de27182ff8187d6c,
                        children: t("sign_in_exp.sign_up_and_sign_in.social_sign_in.set_up_hint.set_up_more")
                    }),
                    t("sign_in_exp.sign_up_and_sign_in.social_sign_in.set_up_hint.go_to")
                ]
            })
        ]
    });
}
var $d0d564ee0f93306f$export$2e2bcd8739ae039 = $d0d564ee0f93306f$var$SocialConnectorEditBox;


function $49ac8768f9e2b5be$var$SocialSignInForm() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { control: control } = (0, $codQP.useFormContext)();
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $gC7hG.default), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $188993d9a1b43b27$export$2e2bcd8739ae039), {
                title: "sign_up_and_sign_in.social_sign_in.title"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aqmjm.default), {
                title: "sign_in_exp.sign_up_and_sign_in.social_sign_in.social_sign_in",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $69a75ca169b2ed64$export$2e2bcd8739ae039), {
                        children: t("sign_in_exp.sign_up_and_sign_in.social_sign_in.description")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                        control: control,
                        defaultValue: [],
                        name: "socialSignInConnectorTargets",
                        render: ({ field: { value: value, onChange: onChange } })=>{
                            return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $d0d564ee0f93306f$export$2e2bcd8739ae039), {
                                value: value,
                                onChange: onChange
                            });
                        }
                    })
                ]
            })
        ]
    });
}
var $49ac8768f9e2b5be$export$2e2bcd8739ae039 = $49ac8768f9e2b5be$var$SocialSignInForm;


function $f9ded55df7f0d37a$var$SignUpAndSignIn({ isActive: isActive }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $85f28dcf05dc2c5d$export$2e2bcd8739ae039), {
        isActive: isActive,
        children: [
            isActive && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5TsIB.default), {
                titleKey: [
                    "sign_in_exp.tabs.sign_up_and_sign_in",
                    "sign_in_exp.page_title"
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $26a8106d5a03162b$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fffebb589150a3ee$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $49ac8768f9e2b5be$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f96a067a166ef856$export$2e2bcd8739ae039), {})
        ]
    });
}
var $f9ded55df7f0d37a$export$2e2bcd8739ae039 = $f9ded55df7f0d37a$var$SignUpAndSignIn;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $C7mD2 = parcelRequire("C7mD2");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7Pi8O = parcelRequire("7Pi8O");
const $8e2a3e2ef107aa47$export$871608497c498473 = (d)=>d instanceof Date;
const $8e2a3e2ef107aa47$export$dd1bc94b04021eeb = (o)=>Object.keys(o).length === 0;
const $8e2a3e2ef107aa47$export$a6cdc56e425d0d0a = (o)=>o != null && typeof o === "object";
const $8e2a3e2ef107aa47$export$5a15a386532a5ea4 = (o, ...args)=>Object.prototype.hasOwnProperty.call(o, ...args);
const $8e2a3e2ef107aa47$export$83b788b1a3698c03 = (o)=>$8e2a3e2ef107aa47$export$a6cdc56e425d0d0a(o) && $8e2a3e2ef107aa47$export$dd1bc94b04021eeb(o);
const $8e2a3e2ef107aa47$export$d6d64087a1bd2d = ()=>Object.create(null);


const $4532790fde323af4$var$diff = (lhs, rhs)=>{
    if (lhs === rhs) return {}; // equal return no diff
    if (!(0, $8e2a3e2ef107aa47$export$a6cdc56e425d0d0a)(lhs) || !(0, $8e2a3e2ef107aa47$export$a6cdc56e425d0d0a)(rhs)) return rhs; // return updated rhs
    const deletedValues = Object.keys(lhs).reduce((acc, key)=>{
        if (!(0, $8e2a3e2ef107aa47$export$5a15a386532a5ea4)(rhs, key)) acc[key] = undefined;
        return acc;
    }, (0, $8e2a3e2ef107aa47$export$d6d64087a1bd2d)());
    if ((0, $8e2a3e2ef107aa47$export$871608497c498473)(lhs) || (0, $8e2a3e2ef107aa47$export$871608497c498473)(rhs)) {
        if (lhs.valueOf() == rhs.valueOf()) return {};
        return rhs;
    }
    return Object.keys(rhs).reduce((acc, key)=>{
        if (!(0, $8e2a3e2ef107aa47$export$5a15a386532a5ea4)(lhs, key)) {
            acc[key] = rhs[key]; // return added r key
            return acc;
        }
        const difference = $4532790fde323af4$var$diff(lhs[key], rhs[key]);
        // If the difference is empty, and the lhs is an empty object or the rhs is not an empty object
        if ((0, $8e2a3e2ef107aa47$export$83b788b1a3698c03)(difference) && !(0, $8e2a3e2ef107aa47$export$871608497c498473)(difference) && ((0, $8e2a3e2ef107aa47$export$83b788b1a3698c03)(lhs[key]) || !(0, $8e2a3e2ef107aa47$export$83b788b1a3698c03)(rhs[key]))) return acc; // return no diff
        acc[key] = difference // return updated key
        ;
        return acc; // return updated key
    }, deletedValues);
};
var $4532790fde323af4$export$2e2bcd8739ae039 = $4532790fde323af4$var$diff;



const $6862948a962745b0$var$addedDiff = (lhs, rhs)=>{
    if (lhs === rhs || !(0, $8e2a3e2ef107aa47$export$a6cdc56e425d0d0a)(lhs) || !(0, $8e2a3e2ef107aa47$export$a6cdc56e425d0d0a)(rhs)) return {};
    return Object.keys(rhs).reduce((acc, key)=>{
        if ((0, $8e2a3e2ef107aa47$export$5a15a386532a5ea4)(lhs, key)) {
            const difference = $6862948a962745b0$var$addedDiff(lhs[key], rhs[key]);
            if ((0, $8e2a3e2ef107aa47$export$a6cdc56e425d0d0a)(difference) && (0, $8e2a3e2ef107aa47$export$dd1bc94b04021eeb)(difference)) return acc;
            acc[key] = difference;
            return acc;
        }
        acc[key] = rhs[key];
        return acc;
    }, (0, $8e2a3e2ef107aa47$export$d6d64087a1bd2d)());
};
var $6862948a962745b0$export$2e2bcd8739ae039 = $6862948a962745b0$var$addedDiff;



const $93aa160976cd39d9$var$deletedDiff = (lhs, rhs)=>{
    if (lhs === rhs || !(0, $8e2a3e2ef107aa47$export$a6cdc56e425d0d0a)(lhs) || !(0, $8e2a3e2ef107aa47$export$a6cdc56e425d0d0a)(rhs)) return {};
    return Object.keys(lhs).reduce((acc, key)=>{
        if ((0, $8e2a3e2ef107aa47$export$5a15a386532a5ea4)(rhs, key)) {
            const difference = $93aa160976cd39d9$var$deletedDiff(lhs[key], rhs[key]);
            if ((0, $8e2a3e2ef107aa47$export$a6cdc56e425d0d0a)(difference) && (0, $8e2a3e2ef107aa47$export$dd1bc94b04021eeb)(difference)) return acc;
            acc[key] = difference;
            return acc;
        }
        acc[key] = undefined;
        return acc;
    }, (0, $8e2a3e2ef107aa47$export$d6d64087a1bd2d)());
};
var $93aa160976cd39d9$export$2e2bcd8739ae039 = $93aa160976cd39d9$var$deletedDiff;



const $d4d484f98f1265cd$var$updatedDiff = (lhs, rhs)=>{
    if (lhs === rhs) return {};
    if (!(0, $8e2a3e2ef107aa47$export$a6cdc56e425d0d0a)(lhs) || !(0, $8e2a3e2ef107aa47$export$a6cdc56e425d0d0a)(rhs)) return rhs;
    if ((0, $8e2a3e2ef107aa47$export$871608497c498473)(lhs) || (0, $8e2a3e2ef107aa47$export$871608497c498473)(rhs)) {
        if (lhs.valueOf() == rhs.valueOf()) return {};
        return rhs;
    }
    return Object.keys(rhs).reduce((acc, key)=>{
        if ((0, $8e2a3e2ef107aa47$export$5a15a386532a5ea4)(lhs, key)) {
            const difference = $d4d484f98f1265cd$var$updatedDiff(lhs[key], rhs[key]);
            // If the difference is empty, and the lhs is an empty object or the rhs is not an empty object
            if ((0, $8e2a3e2ef107aa47$export$83b788b1a3698c03)(difference) && !(0, $8e2a3e2ef107aa47$export$871608497c498473)(difference) && ((0, $8e2a3e2ef107aa47$export$83b788b1a3698c03)(lhs[key]) || !(0, $8e2a3e2ef107aa47$export$83b788b1a3698c03)(rhs[key]))) return acc; // return no diff
            acc[key] = difference;
            return acc;
        }
        return acc;
    }, (0, $8e2a3e2ef107aa47$export$d6d64087a1bd2d)());
};
var $d4d484f98f1265cd$export$2e2bcd8739ae039 = $d4d484f98f1265cd$var$updatedDiff;





const $493c7b23c99fb7fa$var$detailedDiff = (lhs, rhs)=>({
        added: (0, $6862948a962745b0$export$2e2bcd8739ae039)(lhs, rhs),
        deleted: (0, $93aa160976cd39d9$export$2e2bcd8739ae039)(lhs, rhs),
        updated: (0, $d4d484f98f1265cd$export$2e2bcd8739ae039)(lhs, rhs)
    });
var $493c7b23c99fb7fa$export$2e2bcd8739ae039 = $493c7b23c99fb7fa$var$detailedDiff;




parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $66ixW = parcelRequire("66ixW");



const $2ea4b7305ae49fb9$export$b103357118c3dddf = (signInMethods)=>signInMethods.reduce((methodsObject, { identifier: identifier, password: password, verificationCode: verificationCode })=>({
            ...methodsObject,
            [identifier]: {
                password: password,
                verificationCode: verificationCode
            }
        }), // eslint-disable-next-line @typescript-eslint/prefer-reduce-type-parameter, no-restricted-syntax
    {});
const $2ea4b7305ae49fb9$var$hasSignUpSettingsChanged = (before, after)=>Object.keys((0, $4532790fde323af4$export$2e2bcd8739ae039)(before, after)).length > 0;
const $2ea4b7305ae49fb9$var$hasSignInMethodsChanged = (before, after)=>Object.keys((0, $4532790fde323af4$export$2e2bcd8739ae039)($2ea4b7305ae49fb9$export$b103357118c3dddf(before), $2ea4b7305ae49fb9$export$b103357118c3dddf(after))).length > 0;
const $2ea4b7305ae49fb9$var$hasSocialTargetsChanged = (before, after)=>Object.keys((0, $4532790fde323af4$export$2e2bcd8739ae039)(before.slice().sort(), after.slice().sort())).length > 0;
const $2ea4b7305ae49fb9$export$a8696f76b721e0ff = (before, after)=>{
    return !$2ea4b7305ae49fb9$var$hasSignUpSettingsChanged(before.signUp, after.signUp) && !$2ea4b7305ae49fb9$var$hasSignInMethodsChanged(before.signIn.methods, after.signIn.methods) && !$2ea4b7305ae49fb9$var$hasSocialTargetsChanged(before.socialSignInConnectorTargets, after.socialSignInConnectorTargets);
};
const $2ea4b7305ae49fb9$export$baf53b848b6e91d = (errors)=>{
    const { color: color, branding: branding, customCss: customCss } = errors;
    const colorFormErrorCount = color ? Object.keys(color).length : 0;
    const brandingFormErrorCount = branding ? Object.keys(branding).length : 0;
    const customCssFormErrorCount = customCss ? 1 : 0;
    return colorFormErrorCount + brandingFormErrorCount + customCssFormErrorCount;
};
const $2ea4b7305ae49fb9$export$466b1d0c39a15838 = (errors, formData)=>{
    const signUpIdentifier = formData.signUp.identifier;
    /**
   * Note: we treat the `emailOrSms` sign-up identifier as 2 errors when it's invalid.
   */ const signUpIdentifierRelatedErrorCount = signUpIdentifier === (0, $8643043f1fa1a33d$export$69ec1500fb2141d2).EmailOrSms ? 2 : 1;
    const { signUp: signUp, signIn: signIn } = errors;
    const signUpErrorCount = signUp?.identifier ? signUpIdentifierRelatedErrorCount : 0;
    const signInMethodErrors = signIn?.methods;
    const signInMethodErrorCount = Array.isArray(signInMethodErrors) ? signInMethodErrors.filter(Boolean).length : 0;
    return signUpErrorCount + signInMethodErrorCount;
};
const $2ea4b7305ae49fb9$export$df85389c5efb9b1b = (errors)=>{
    const termsOfUseUrlErrorCount = errors.termsOfUseUrl ? 1 : 0;
    const privacyPolicyUrlErrorCount = errors.privacyPolicyUrl ? 1 : 0;
    return termsOfUseUrlErrorCount + privacyPolicyUrlErrorCount;
};



var $C7mD2 = parcelRequire("C7mD2");
var $7c8715e6fe5025a5$export$955a2ebd2fb142ae;
var $7c8715e6fe5025a5$export$8837f4fc672e936d;
var $7c8715e6fe5025a5$export$a90204d1394caf30;
var $7c8715e6fe5025a5$export$bfd64c937657f93a;
var $7c8715e6fe5025a5$export$4a6dd88bada4e7d2;
var $7c8715e6fe5025a5$export$fb184b623420d9be;
$7c8715e6fe5025a5$export$955a2ebd2fb142ae = `_6ugWbW_green`;
$7c8715e6fe5025a5$export$8837f4fc672e936d = `_6ugWbW_list`;
$7c8715e6fe5025a5$export$a90204d1394caf30 = `_6ugWbW_red`;
$7c8715e6fe5025a5$export$bfd64c937657f93a = `_6ugWbW_rotating`;
$7c8715e6fe5025a5$export$4a6dd88bada4e7d2 = `_6ugWbW_shimmer`;
$7c8715e6fe5025a5$export$fb184b623420d9be = `_6ugWbW_title`;


function $008b55b65504989e$var$DiffSegment({ children: children, hasChanged: hasChanged, isAfter: isAfter = false }) {
    if (!hasChanged) // eslint-disable-next-line react/jsx-no-useless-fragment
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $C7mD2.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
        className: isAfter ? $7c8715e6fe5025a5$export$955a2ebd2fb142ae : $7c8715e6fe5025a5$export$a90204d1394caf30,
        children: children
    });
}
var $008b55b65504989e$export$2e2bcd8739ae039 = $008b55b65504989e$var$DiffSegment;



function $7f6cfc62926c6036$var$SignInDiffSection({ before: before, after: after, isAfter: isAfter = false }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const beforeSignInMethodsObject = (0, $2ea4b7305ae49fb9$export$b103357118c3dddf)(before);
    const afterSignInMethodsObject = (0, $2ea4b7305ae49fb9$export$b103357118c3dddf)(after);
    const signInDiff = isAfter ? (0, $493c7b23c99fb7fa$export$2e2bcd8739ae039)(beforeSignInMethodsObject, afterSignInMethodsObject) : (0, $493c7b23c99fb7fa$export$2e2bcd8739ae039)(afterSignInMethodsObject, beforeSignInMethodsObject);
    const displaySignInMethodsObject = isAfter ? afterSignInMethodsObject : beforeSignInMethodsObject;
    const hasIdentifierChanged = (identifierKey)=>(0, $7Pi8O.getSafe)(signInDiff, `added.${identifierKey.toLocaleLowerCase()}`) !== undefined;
    const hasAuthenticationChanged = (identifierKey, authenticationKey)=>(0, $7Pi8O.getSafe)(signInDiff, `updated.${identifierKey.toLocaleLowerCase()}.${authenticationKey}`) !== undefined;
    // eslint-disable-next-line no-restricted-syntax
    const displayedIdentifiers = Object.keys(displaySignInMethodsObject).slice().sort();
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $7c8715e6fe5025a5$export$fb184b623420d9be,
                children: t("sign_in_exp.save_alert.sign_in")
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ul", {
                className: $7c8715e6fe5025a5$export$8837f4fc672e936d,
                children: displayedIdentifiers.map((identifierKey)=>{
                    const { password: password, verificationCode: verificationCode } = displaySignInMethodsObject[identifierKey];
                    const hasAuthentication = password || verificationCode;
                    const needDisjunction = password && verificationCode;
                    return /*#__PURE__*/ (0, $C7mD2.jsx)("li", {
                        children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $008b55b65504989e$export$2e2bcd8739ae039), {
                            hasChanged: hasIdentifierChanged(identifierKey),
                            isAfter: isAfter,
                            children: [
                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                    forKey: (0, $cf27937a07aeee10$export$c54a2f6297ba7cbe)[identifierKey]
                                }),
                                hasAuthentication && " (",
                                password && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $008b55b65504989e$export$2e2bcd8739ae039), {
                                    hasChanged: hasAuthenticationChanged(identifierKey, "password"),
                                    isAfter: isAfter,
                                    children: t("sign_in_exp.sign_up_and_sign_in.sign_in.password_auth")
                                }),
                                needDisjunction && ` ${t("sign_in_exp.sign_up_and_sign_in.or")} `,
                                verificationCode && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $008b55b65504989e$export$2e2bcd8739ae039), {
                                    hasChanged: hasAuthenticationChanged(identifierKey, "verificationCode"),
                                    isAfter: isAfter,
                                    children: needDisjunction ? t("sign_in_exp.sign_up_and_sign_in.sign_in.verification_code_auth").toLocaleLowerCase() : t("sign_in_exp.sign_up_and_sign_in.sign_in.verification_code_auth")
                                }),
                                hasAuthentication && ")"
                            ]
                        })
                    }, identifierKey);
                })
            })
        ]
    });
}
var $7f6cfc62926c6036$export$2e2bcd8739ae039 = $7f6cfc62926c6036$var$SignInDiffSection;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7Pi8O = parcelRequire("7Pi8O");

parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $66ixW = parcelRequire("66ixW");




function $dee38628ad17e9d3$var$SignUpDiffSection({ before: before, after: after, isAfter: isAfter = false }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const parsedBefore = (0, $6696e751cd950b0a$export$ce2003b7968fffcc).fromSignUp(before);
    const parsedAfter = (0, $6696e751cd950b0a$export$ce2003b7968fffcc).fromSignUp(after);
    const signUpDiff = isAfter ? (0, $4532790fde323af4$export$2e2bcd8739ae039)(parsedBefore, parsedAfter) : (0, $4532790fde323af4$export$2e2bcd8739ae039)(parsedAfter, parsedBefore);
    const signUp = isAfter ? parsedAfter : parsedBefore;
    const hasChanged = (path)=>(0, $7Pi8O.getSafe)(signUpDiff, path) !== undefined;
    const { identifier: identifier, password: password, verify: verify } = signUp;
    const hasAuthentication = password || verify;
    const needConjunction = password && verify;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $7c8715e6fe5025a5$export$fb184b623420d9be,
                children: t("sign_in_exp.save_alert.sign_up")
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ul", {
                className: $7c8715e6fe5025a5$export$8837f4fc672e936d,
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $008b55b65504989e$export$2e2bcd8739ae039), {
                            hasChanged: hasChanged("identifier"),
                            isAfter: isAfter,
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                forKey: (0, $cf27937a07aeee10$export$2d3509a8eccb8b17)[identifier]
                            })
                        }),
                        hasAuthentication && " (",
                        password && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $008b55b65504989e$export$2e2bcd8739ae039), {
                            hasChanged: hasChanged("password"),
                            isAfter: isAfter,
                            children: t("sign_in_exp.sign_up_and_sign_in.sign_up.set_a_password_option")
                        }),
                        needConjunction && ` ${t("sign_in_exp.sign_up_and_sign_in.and")} `,
                        verify && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $008b55b65504989e$export$2e2bcd8739ae039), {
                            hasChanged: hasChanged("verify"),
                            isAfter: isAfter,
                            children: needConjunction ? t("sign_in_exp.sign_up_and_sign_in.sign_up.verify_at_sign_up_option").toLowerCase() : t("sign_in_exp.sign_up_and_sign_in.sign_up.verify_at_sign_up_option")
                        }),
                        hasAuthentication && ")"
                    ]
                })
            })
        ]
    });
}
var $dee38628ad17e9d3$export$2e2bcd8739ae039 = $dee38628ad17e9d3$var$SignUpDiffSection;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("hNGhh");
var $eRB1v = parcelRequire("eRB1v");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $4TsiV = parcelRequire("4TsiV");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");



function $fd76fd61faf5d3cf$var$SocialTargetsDiffSection({ before: before, after: after, isAfter: isAfter = false }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: groups, error: error } = (0, $9d72639ba10eaeeb$export$2e2bcd8739ae039)();
    const { language: language } = (0, $4TsiV.default);
    const sortedBeforeTargets = before.slice().sort();
    const sortedAfterTargets = after.slice().sort();
    const displayTargets = isAfter ? sortedAfterTargets : sortedBeforeTargets;
    const hasChanged = (target)=>!(before.includes(target) && after.includes(target));
    if (!groups || displayTargets.length === 0 || error) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $7c8715e6fe5025a5$export$fb184b623420d9be,
                children: t("sign_in_exp.save_alert.social")
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ul", {
                className: $7c8715e6fe5025a5$export$8837f4fc672e936d,
                children: displayTargets.map((target)=>{
                    const connectorDetail = groups.find(({ target: connectorTarget })=>connectorTarget === target);
                    if (!connectorDetail) return null;
                    return /*#__PURE__*/ (0, $C7mD2.jsx)("li", {
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $008b55b65504989e$export$2e2bcd8739ae039), {
                            hasChanged: hasChanged(target),
                            isAfter: isAfter,
                            children: (0, $7oDSS.conditional)((0, $eRB1v.isLanguageTag)(language) && connectorDetail.name[language]) ?? connectorDetail.name.en
                        })
                    }, target);
                })
            })
        ]
    });
}
var $fd76fd61faf5d3cf$export$2e2bcd8739ae039 = $fd76fd61faf5d3cf$var$SocialTargetsDiffSection;


function $0d1e1da27877e2cd$var$SignUpAndSignInDiffSection({ before: before, after: after, isAfter: isAfter = false }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dee38628ad17e9d3$export$2e2bcd8739ae039), {
                before: before.signUp,
                after: after.signUp,
                isAfter: isAfter
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7f6cfc62926c6036$export$2e2bcd8739ae039), {
                before: before.signIn.methods,
                after: after.signIn.methods,
                isAfter: isAfter
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fd76fd61faf5d3cf$export$2e2bcd8739ae039), {
                before: before.socialSignInConnectorTargets,
                after: after.socialSignInConnectorTargets,
                isAfter: isAfter
            })
        ]
    });
}
var $0d1e1da27877e2cd$export$2e2bcd8739ae039 = $0d1e1da27877e2cd$var$SignUpAndSignInDiffSection;


var $ff5fd49dc631c166$export$34e0f9847d4c02dd;
var $ff5fd49dc631c166$export$a7db06668cad9adb;
var $ff5fd49dc631c166$export$6d59db4903f20f7d;
var $ff5fd49dc631c166$export$bfd64c937657f93a;
var $ff5fd49dc631c166$export$fe2e36411d703b3d;
var $ff5fd49dc631c166$export$4a6dd88bada4e7d2;
var $ff5fd49dc631c166$export$fb184b623420d9be;
$ff5fd49dc631c166$export$34e0f9847d4c02dd = `oxLM0a_container`;
$ff5fd49dc631c166$export$a7db06668cad9adb = `oxLM0a_content`;
$ff5fd49dc631c166$export$6d59db4903f20f7d = `oxLM0a_description`;
$ff5fd49dc631c166$export$bfd64c937657f93a = `oxLM0a_rotating`;
$ff5fd49dc631c166$export$fe2e36411d703b3d = `oxLM0a_section`;
$ff5fd49dc631c166$export$4a6dd88bada4e7d2 = `oxLM0a_shimmer`;
$ff5fd49dc631c166$export$fb184b623420d9be = `oxLM0a_title`;


function $9e8587b794a23526$var$SignUpAndSignInChangePreview({ before: before, after: after }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $ff5fd49dc631c166$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $ff5fd49dc631c166$export$6d59db4903f20f7d,
                children: t("sign_in_exp.save_alert.description")
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $ff5fd49dc631c166$export$a7db06668cad9adb,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $ff5fd49dc631c166$export$fe2e36411d703b3d,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $ff5fd49dc631c166$export$fb184b623420d9be,
                                children: t("sign_in_exp.save_alert.before")
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0d1e1da27877e2cd$export$2e2bcd8739ae039), {
                                before: before,
                                after: after
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $ff5fd49dc631c166$export$fe2e36411d703b3d,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $ff5fd49dc631c166$export$fb184b623420d9be,
                                children: t("sign_in_exp.save_alert.after")
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0d1e1da27877e2cd$export$2e2bcd8739ae039), {
                                isAfter: true,
                                before: before,
                                after: after
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $9e8587b794a23526$export$2e2bcd8739ae039 = $9e8587b794a23526$var$SignUpAndSignInChangePreview;


var $b28c094c3738df78$export$a7db06668cad9adb;
var $b28c094c3738df78$export$611bd8dea7a0fee9;
var $b28c094c3738df78$export$6210fa4921d2a466;
var $b28c094c3738df78$export$48c2d0f2f545ac27;
var $b28c094c3738df78$export$bfd64c937657f93a;
var $b28c094c3738df78$export$4a6dd88bada4e7d2;
var $b28c094c3738df78$export$39f5674517ec0000;
var $b28c094c3738df78$export$1258c5dd981c51cf;
$b28c094c3738df78$export$a7db06668cad9adb = `KVwOca_content`;
$b28c094c3738df78$export$611bd8dea7a0fee9 = `KVwOca_contentTop`;
$b28c094c3738df78$export$6210fa4921d2a466 = `KVwOca_form`;
$b28c094c3738df78$export$48c2d0f2f545ac27 = `KVwOca_preview`;
$b28c094c3738df78$export$bfd64c937657f93a = `KVwOca_rotating`;
$b28c094c3738df78$export$4a6dd88bada4e7d2 = `KVwOca_shimmer`;
$b28c094c3738df78$export$39f5674517ec0000 = `KVwOca_tabs`;
$b28c094c3738df78$export$1258c5dd981c51cf = `KVwOca_withSubmitActionBar`;




const $70128f11b276350d$var$PageTab = (0, $8b5950685d0fe3f8$export$2e2bcd8739ae039);
function $70128f11b276350d$var$PageContent({ data: data, onSignInExperienceUpdated: onSignInExperienceUpdated }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { tab: tab } = (0, $2Phw0.useParams)();
    const [isSaving, setIsSaving] = (0, $jC8Vy.useState)(false);
    const { updateConfigs: updateConfigs } = (0, $dad5317382253f6d$export$2e2bcd8739ae039)();
    const { getPathname: getPathname } = (0, $4ZcUR.default)();
    const [dataToCompare, setDataToCompare] = (0, $jC8Vy.useState)();
    const methods = (0, $codQP.useForm)({
        defaultValues: (0, $6696e751cd950b0a$export$64f7b79bdbb2c1d4).fromSignInExperience(data)
    });
    const { reset: reset, handleSubmit: handleSubmit, getValues: getValues, watch: watch, formState: { isDirty: isDirty, errors: errors } } = methods;
    const api = (0, $7VnwS.default)();
    const formData = watch();
    const previewConfigs = (0, $85223ff59ae29aa3$export$2e2bcd8739ae039)(formData, isDirty, data);
    const saveData = async ()=>{
        setIsSaving(true);
        try {
            const updatedData = await api.patch("api/sign-in-exp", {
                json: (0, $6696e751cd950b0a$export$64f7b79bdbb2c1d4).toUpdateSignInExperienceData(getValues())
            }).json();
            reset((0, $6696e751cd950b0a$export$64f7b79bdbb2c1d4).fromSignInExperience(updatedData));
            onSignInExperienceUpdated(updatedData);
            setDataToCompare(undefined);
            await updateConfigs({
                signInExperienceCustomized: true
            });
            (0, $FuhPC.toast).success(t("general.saved"));
        } finally{
            setIsSaving(false);
        }
    };
    const onSubmit = handleSubmit((0, $5OcFi.trySubmitSafe)(async (formData)=>{
        if (isSaving) return;
        const formatted = (0, $6696e751cd950b0a$export$64f7b79bdbb2c1d4).toSignInExperience(formData);
        // Sign-in methods changed, need to show confirm modal first.
        if (!(0, $2ea4b7305ae49fb9$export$a8696f76b721e0ff)(data, formatted)) {
            setDataToCompare(formatted);
            return;
        }
        await saveData();
    }));
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $26090e0c44b20d28$export$2e2bcd8739ae039), {
                className: $b28c094c3738df78$export$39f5674517ec0000,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)($70128f11b276350d$var$PageTab, {
                        href: "../branding",
                        errorCount: (0, $2ea4b7305ae49fb9$export$baf53b848b6e91d)(errors),
                        children: t("sign_in_exp.tabs.branding")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)($70128f11b276350d$var$PageTab, {
                        href: "../sign-up-and-sign-in",
                        errorCount: (0, $2ea4b7305ae49fb9$export$466b1d0c39a15838)(errors, formData),
                        children: t("sign_in_exp.tabs.sign_up_and_sign_in")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)($70128f11b276350d$var$PageTab, {
                        href: "../content",
                        errorCount: (0, $2ea4b7305ae49fb9$export$df85389c5efb9b1b)(errors),
                        children: t("sign_in_exp.tabs.content")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)($70128f11b276350d$var$PageTab, {
                        href: "../password-policy",
                        children: t("sign_in_exp.tabs.password_policy")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $b28c094c3738df78$export$a7db06668cad9adb,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($b28c094c3738df78$export$611bd8dea7a0fee9, isDirty && $b28c094c3738df78$export$1258c5dd981c51cf),
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.FormProvider), {
                                ...methods,
                                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("form", {
                                    className: $b28c094c3738df78$export$6210fa4921d2a466,
                                    children: [
                                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6b5e540e24475bee$export$2e2bcd8739ae039), {
                                            isActive: tab === (0, $8643043f1fa1a33d$export$8ce28b52dd68c0b7).Branding
                                        }),
                                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f9ded55df7f0d37a$export$2e2bcd8739ae039), {
                                            isActive: tab === (0, $8643043f1fa1a33d$export$8ce28b52dd68c0b7).SignUpAndSignIn
                                        }),
                                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $82c6c9a00dabb956$export$2e2bcd8739ae039), {
                                            isActive: tab === (0, $8643043f1fa1a33d$export$8ce28b52dd68c0b7).Content
                                        }),
                                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $d161730b5fc84495$export$2e2bcd8739ae039), {
                                            isActive: tab === (0, $8643043f1fa1a33d$export$8ce28b52dd68c0b7).PasswordPolicy
                                        })
                                    ]
                                })
                            }),
                            formData.id && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6b09b9283b35ff1b$export$2e2bcd8739ae039), {
                                isLivePreviewDisabled: isDirty,
                                signInExperience: previewConfigs,
                                className: $b28c094c3738df78$export$48c2d0f2f545ac27
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $41b73519a7034b3a$export$2e2bcd8739ae039), {
                        isOpen: isDirty,
                        isSubmitting: isSaving,
                        onDiscard: reset,
                        onSubmit: onSubmit
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dL4NZ.default), {
                isOpen: Boolean(dataToCompare),
                isLoading: isSaving,
                onCancel: ()=>{
                    setDataToCompare(undefined);
                },
                onConfirm: async ()=>{
                    await saveData();
                },
                children: dataToCompare && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9e8587b794a23526$export$2e2bcd8739ae039), {
                    before: data,
                    after: dataToCompare
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fea55fa5d5726e29$export$2e2bcd8739ae039), {
                hasUnsavedChanges: isDirty,
                parentPath: getPathname("/sign-in-experience")
            })
        ]
    });
}
var $70128f11b276350d$export$2e2bcd8739ae039 = $70128f11b276350d$var$PageContent;



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $18SWy = parcelRequire("18SWy");

var $jbKqE = parcelRequire("jbKqE");

var $3a1b158c37d9f82b$export$3aac624c619dfa7f;
var $3a1b158c37d9f82b$export$34e0f9847d4c02dd;
var $3a1b158c37d9f82b$export$a7db06668cad9adb;
var $3a1b158c37d9f82b$export$611bd8dea7a0fee9;
var $3a1b158c37d9f82b$export$a3bc9b8ed74fc;
var $3a1b158c37d9f82b$export$6210fa4921d2a466;
var $3a1b158c37d9f82b$export$48c2d0f2f545ac27;
var $3a1b158c37d9f82b$export$bfd64c937657f93a;
var $3a1b158c37d9f82b$export$4a6dd88bada4e7d2;
var $3a1b158c37d9f82b$export$39f5674517ec0000;
var $3a1b158c37d9f82b$export$1258c5dd981c51cf;
$3a1b158c37d9f82b$export$3aac624c619dfa7f = `Wc-taa_cardTitle`;
$3a1b158c37d9f82b$export$34e0f9847d4c02dd = `Wc-taa_container`;
$3a1b158c37d9f82b$export$a7db06668cad9adb = `Wc-taa_content`;
$3a1b158c37d9f82b$export$611bd8dea7a0fee9 = `Wc-taa_contentTop`;
$3a1b158c37d9f82b$export$a3bc9b8ed74fc = `Wc-taa_error`;
$3a1b158c37d9f82b$export$6210fa4921d2a466 = `Wc-taa_form`;
$3a1b158c37d9f82b$export$48c2d0f2f545ac27 = `Wc-taa_preview`;
$3a1b158c37d9f82b$export$bfd64c937657f93a = `Wc-taa_rotating`;
$3a1b158c37d9f82b$export$4a6dd88bada4e7d2 = `Wc-taa_shimmer`;
$3a1b158c37d9f82b$export$39f5674517ec0000 = `Wc-taa_tabs`;
$3a1b158c37d9f82b$export$1258c5dd981c51cf = `Wc-taa_withSubmitActionBar`;


var $8b65486eda7d7c19$export$2ba01fb71ed41cb6;
var $8b65486eda7d7c19$export$aa3e815946b80764;
var $8b65486eda7d7c19$export$34e0f9847d4c02dd;
var $8b65486eda7d7c19$export$a7db06668cad9adb;
var $8b65486eda7d7c19$export$e0f35d825088c098;
var $8b65486eda7d7c19$export$38e42c68cf43b5d4;
var $8b65486eda7d7c19$export$a80b3bd66acc52ff;
var $8b65486eda7d7c19$export$db3c28d99448dcff;
var $8b65486eda7d7c19$export$1c4e7a9c31a6c071;
var $8b65486eda7d7c19$export$48c2d0f2f545ac27;
var $8b65486eda7d7c19$export$e5976431db92c0ff;
var $8b65486eda7d7c19$export$bfd64c937657f93a;
var $8b65486eda7d7c19$export$4a6dd88bada4e7d2;
var $8b65486eda7d7c19$export$f30f1338f6f15619;
var $8b65486eda7d7c19$export$cba3d3852a039325;
var $8b65486eda7d7c19$export$c96745152eb2740f;
var $8b65486eda7d7c19$export$1261a644c63cbc91;
var $8b65486eda7d7c19$export$fb184b623420d9be;
$8b65486eda7d7c19$export$2ba01fb71ed41cb6 = `L9Tt1a_button`;
$8b65486eda7d7c19$export$aa3e815946b80764 = `L9Tt1a_card`;
$8b65486eda7d7c19$export$34e0f9847d4c02dd = `L9Tt1a_container`;
$8b65486eda7d7c19$export$a7db06668cad9adb = `L9Tt1a_content`;
$8b65486eda7d7c19$export$e0f35d825088c098 = `L9Tt1a_field`;
$8b65486eda7d7c19$export$38e42c68cf43b5d4 = `L9Tt1a_header`;
$8b65486eda7d7c19$export$a80b3bd66acc52ff = `L9Tt1a_info`;
$8b65486eda7d7c19$export$db3c28d99448dcff = `L9Tt1a_logo`;
$8b65486eda7d7c19$export$1c4e7a9c31a6c071 = `L9Tt1a_mobile`;
$8b65486eda7d7c19$export$48c2d0f2f545ac27 = `L9Tt1a_preview`;
$8b65486eda7d7c19$export$e5976431db92c0ff = `L9Tt1a_previewContent`;
$8b65486eda7d7c19$export$bfd64c937657f93a = `L9Tt1a_rotating`;
$8b65486eda7d7c19$export$4a6dd88bada4e7d2 = `L9Tt1a_shimmer`;
$8b65486eda7d7c19$export$4a6dd88bada4e7d2;
$8b65486eda7d7c19$export$f30f1338f6f15619 = `L9Tt1a_slogan`;
$8b65486eda7d7c19$export$cba3d3852a039325 = `L9Tt1a_social`;
$8b65486eda7d7c19$export$c96745152eb2740f = `L9Tt1a_subtitle`;
$8b65486eda7d7c19$export$1261a644c63cbc91 = `L9Tt1a_tabBar`;
$8b65486eda7d7c19$export$fb184b623420d9be = `L9Tt1a_title`;


function $b3132274561c06c9$var$Skeleton() {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($3a1b158c37d9f82b$export$34e0f9847d4c02dd, $8b65486eda7d7c19$export$34e0f9847d4c02dd),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $18SWy.default), {
                title: "sign_in_exp.title",
                subtitle: "sign_in_exp.description",
                className: $3a1b158c37d9f82b$export$3aac624c619dfa7f
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($b28c094c3738df78$export$39f5674517ec0000, $8b65486eda7d7c19$export$1261a644c63cbc91)
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($b28c094c3738df78$export$a7db06668cad9adb, $8b65486eda7d7c19$export$a7db06668cad9adb),
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: $b28c094c3738df78$export$611bd8dea7a0fee9,
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                            className: $b28c094c3738df78$export$6210fa4921d2a466,
                            children: [
                                /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                    className: $8b65486eda7d7c19$export$aa3e815946b80764,
                                    children: [
                                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                            className: $8b65486eda7d7c19$export$fb184b623420d9be
                                        }),
                                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                            className: $8b65486eda7d7c19$export$e0f35d825088c098
                                        }),
                                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                            className: $8b65486eda7d7c19$export$e0f35d825088c098
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                    className: $8b65486eda7d7c19$export$aa3e815946b80764,
                                    children: [
                                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                            className: $8b65486eda7d7c19$export$fb184b623420d9be
                                        }),
                                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                            className: $8b65486eda7d7c19$export$e0f35d825088c098
                                        }),
                                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                            className: $8b65486eda7d7c19$export$e0f35d825088c098
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $b28c094c3738df78$export$48c2d0f2f545ac27,
                            children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                className: $8b65486eda7d7c19$export$48c2d0f2f545ac27,
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                        className: $8b65486eda7d7c19$export$38e42c68cf43b5d4,
                                        children: [
                                            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                                className: $8b65486eda7d7c19$export$a80b3bd66acc52ff,
                                                children: [
                                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                        className: $8b65486eda7d7c19$export$fb184b623420d9be
                                                    }),
                                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                        className: $8b65486eda7d7c19$export$c96745152eb2740f
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jbKqE.default), {}),
                                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                className: $8b65486eda7d7c19$export$2ba01fb71ed41cb6
                                            }),
                                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                className: $8b65486eda7d7c19$export$2ba01fb71ed41cb6
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $8b65486eda7d7c19$export$e5976431db92c0ff,
                                        children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                            className: $8b65486eda7d7c19$export$1c4e7a9c31a6c071,
                                            children: [
                                                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                    className: $8b65486eda7d7c19$export$db3c28d99448dcff
                                                }),
                                                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                    className: $8b65486eda7d7c19$export$f30f1338f6f15619
                                                }),
                                                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                    className: $8b65486eda7d7c19$export$e0f35d825088c098
                                                }),
                                                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                    className: $8b65486eda7d7c19$export$e0f35d825088c098
                                                }),
                                                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                    className: $8b65486eda7d7c19$export$2ba01fb71ed41cb6
                                                }),
                                                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                                    className: $8b65486eda7d7c19$export$cba3d3852a039325
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}
var $b3132274561c06c9$export$2e2bcd8739ae039 = $b3132274561c06c9$var$Skeleton;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $28e784ed20928c16$var$SvgSignInExperienceWelcomeDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 24,
                y: 136,
                width: 128,
                height: 96,
                rx: 16,
                fill: "#5B5F81"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 24,
                y: 136,
                width: 128,
                height: 96,
                rx: 12,
                fill: "#47464E"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M24 152c0-8.837 7.163-16 16-16h96c8.837 0 16 7.163 16 16v4H24v-4Z",
                fill: "#5F5D67"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M40 179a3 3 0 0 1 3-3h42a3 3 0 1 1 0 6H43a3 3 0 0 1-3-3ZM40 193a3 3 0 0 1 3-3h74a3 3 0 1 1 0 6H43a3 3 0 0 1-3-3ZM40 207a3 3 0 0 1 3-3h10a3 3 0 1 1 0 6H43a3 3 0 0 1-3-3Z",
                fill: "#F7F8F8",
                fillOpacity: 0.12
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 39,
                cy: 146,
                r: 3,
                fill: "#FA9F94"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 49,
                cy: 146,
                r: 3,
                fill: "#FDCF90"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 59,
                cy: 146,
                r: 3,
                fill: "#E5E1EC"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 85,
                y: 54,
                width: 86,
                height: 176,
                rx: 14,
                fill: "#C1B2EA",
                stroke: "#7958FF",
                strokeWidth: 4
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M91 72v135c0 8.284 6.716 15 15 15h4m55-153v25m0 78v-27.5",
                stroke: "#AA9BD9",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M110.5 56h36v2a6 6 0 0 1-6 6h-24a6 6 0 0 1-6-6v-2Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 128,
                cy: 212,
                r: 8.125,
                stroke: "#F0EBFF",
                strokeWidth: 3.75
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 102.5,
                y: 110.5,
                width: 107,
                height: 25,
                rx: 7.5,
                fill: "#5D34F2",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 118,
                y: 119,
                width: 8,
                height: 8,
                rx: 2,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 132,
                y: 119,
                width: 8,
                height: 8,
                rx: 2,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 146,
                y: 119,
                width: 8,
                height: 8,
                rx: 2,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 160,
                y: 119,
                width: 8,
                height: 8,
                rx: 2,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 174,
                y: 119,
                width: 8,
                height: 8,
                rx: 2,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 188,
                y: 119,
                width: 8,
                height: 8,
                rx: 2,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 102.5,
                y: 110.5,
                width: 107,
                height: 25,
                rx: 7.5,
                stroke: "#CBBBF4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M192 232a39.855 39.855 0 0 0 11.5-1.678m-22.5-76.79A40.005 40.005 0 0 1 192 152c22.091 0 40 17.909 40 40a39.867 39.867 0 0 1-3.114 15.5 40.13 40.13 0 0 1-11.005 15 40.279 40.279 0 0 1-3.881 2.912M158.923 169.5A39.832 39.832 0 0 0 152 192c0 9.87 3.575 18.905 9.5 25.881a40.224 40.224 0 0 0 5.5 5.346",
                stroke: "#AF9EFF",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                opacity: 0.2,
                cx: 192,
                cy: 192,
                r: 30,
                fill: "#E5E5E5"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M192 162v30h-30c0-16.569 13.431-30 30-30Z",
                fill: "#FA9F94"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M192 222v-30h30c0 16.569-13.431 30-30 30Z",
                fill: "#BE9FF3"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M192 162v30h30c0-16.569-13.431-30-30-30Z",
                fill: "#FDCF90"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M192 222v-30h-30c0 16.569 13.431 30 30 30Z",
                fill: "#FCCCF1"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 116,
                y: 76,
                width: 24,
                height: 24,
                rx: 8,
                fill: "#F0EBFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 128,
                cy: 83,
                r: 4,
                fill: "#F2CE41"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M122 92a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-2Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 107,
                y: 144,
                width: 42,
                height: 4,
                rx: 2,
                fill: "#AF9FDB"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 107,
                y: 152,
                width: 24,
                height: 4,
                rx: 2,
                fill: "#AF9FDB"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 111.359,
                y: 17.574,
                width: 8,
                height: 8,
                rx: 2,
                transform: "rotate(-40.65 111.359 17.574)",
                fill: "#928F9A"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 220.613,
                y: 89.517,
                width: 8,
                height: 8,
                rx: 2,
                transform: "rotate(30.813 220.613 89.517)",
                fill: "#928F9A"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M212.957 21.105c0-.057.046-.104.104-.104h1.878c.057 0 .104.047.104.104v3.305l2.861-1.652a.105.105 0 0 1 .143.038l.939 1.626a.105.105 0 0 1-.039.142l-2.861 1.652 2.861 1.652c.05.03.067.093.039.143l-.939 1.626a.105.105 0 0 1-.143.038l-2.861-1.652v3.304a.104.104 0 0 1-.104.105h-1.878a.104.104 0 0 1-.104-.105v-3.304l-2.862 1.652a.105.105 0 0 1-.143-.038l-.938-1.626a.104.104 0 0 1 .038-.142l2.861-1.653-2.861-1.652a.104.104 0 0 1-.038-.142l.938-1.626a.105.105 0 0 1 .143-.038l2.862 1.652v-3.305Z",
                fill: "#928F9A"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m21.746 93.012.983 2.652a2.828 2.828 0 0 0 3.635 1.668v0A2.828 2.828 0 0 1 30 99.001v0a2.828 2.828 0 0 0 3.635 1.669v0a2.829 2.829 0 0 1 3.635 1.668l.983 2.652M205.424 72.459l2.828.033a2.83 2.83 0 0 0 2.862-2.795v0a2.828 2.828 0 0 1 2.861-2.795v0a2.83 2.83 0 0 0 2.862-2.795l.033-2.828",
                stroke: "#928F9A",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m71.596 34.31.516-2.782a2.828 2.828 0 0 0-2.264-3.297v0a2.828 2.828 0 0 1-2.264-3.297v0a2.829 2.829 0 0 0-2.265-3.298l-2.78-.516",
                stroke: "#5C5F60",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $28e784ed20928c16$export$2e2bcd8739ae039 = $28e784ed20928c16$var$SvgSignInExperienceWelcomeDark;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $793ac5b7a7b817f9$var$SvgSignInExperienceWelcome = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 24,
                y: 136,
                width: 128,
                height: 96,
                rx: 12,
                fill: "#5D34F2",
                fillOpacity: 0.1
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M24 148c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v4H24v-4Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M40 179a3 3 0 0 1 3-3h42a3 3 0 1 1 0 6H43a3 3 0 0 1-3-3ZM40 193a3 3 0 0 1 3-3h74a3 3 0 1 1 0 6H43a3 3 0 0 1-3-3ZM40 207a3 3 0 0 1 3-3h10a3 3 0 1 1 0 6H43a3 3 0 0 1-3-3Z",
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 39,
                cy: 144,
                r: 3,
                fill: "#FA9F94"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 49,
                cy: 144,
                r: 3,
                fill: "#FDCF90"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 59,
                cy: 144,
                r: 3,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 85,
                y: 54,
                width: 86,
                height: 176,
                rx: 14,
                fill: "#CABEFF",
                stroke: "#7958FF",
                strokeWidth: 4
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M91 82v125c0 8.284 6.716 15 15 15h4m55-160v32m0 78v-27.5",
                stroke: "#CBBEF3",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M110.5 56h36v2a6 6 0 0 1-6 6h-24a6 6 0 0 1-6-6v-2Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 128,
                cy: 212,
                r: 8.125,
                stroke: "#E6DEFF",
                strokeWidth: 3.75
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 118,
                y: 119,
                width: 8,
                height: 8,
                rx: 2,
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 132,
                y: 119,
                width: 8,
                height: 8,
                rx: 2,
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 146,
                y: 119,
                width: 8,
                height: 8,
                rx: 2,
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 160,
                y: 119,
                width: 8,
                height: 8,
                rx: 2,
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 174,
                y: 119,
                width: 8,
                height: 8,
                rx: 2,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 188,
                y: 119,
                width: 8,
                height: 8,
                rx: 2,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 102.5,
                y: 110.5,
                width: 107,
                height: 25,
                rx: 7.5,
                fill: "#5D34F2",
                fillOpacity: 0.16,
                stroke: "#D4C4FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 116,
                y: 76,
                width: 24,
                height: 24,
                rx: 8,
                fill: "#FBF9FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 128,
                cy: 83,
                r: 4,
                fill: "#FDCF90"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M122 92a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-2Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M192 232a39.855 39.855 0 0 0 11.5-1.678m-22.5-76.79A40.005 40.005 0 0 1 192 152c22.091 0 40 17.909 40 40a39.867 39.867 0 0 1-3.114 15.5 40.13 40.13 0 0 1-11.005 15 40.279 40.279 0 0 1-3.881 2.912M158.923 169.5A39.832 39.832 0 0 0 152 192c0 9.87 3.575 18.905 9.5 25.881a40.224 40.224 0 0 0 5.5 5.346",
                stroke: "#AF9EFF",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                opacity: 0.2,
                cx: 192,
                cy: 192,
                r: 30,
                fill: "#E5E5E5"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M192 162v30h-30c0-16.569 13.431-30 30-30Z",
                fill: "#FDCF90"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M192 222v-30h30c0 16.569-13.431 30-30 30Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M192 162v30h30c0-16.569-13.431-30-30-30Z",
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M192 222v-30h-30c0 16.569 13.431 30 30 30Z",
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 111.359,
                y: 17.571,
                width: 8,
                height: 8,
                rx: 2,
                transform: "rotate(-40.65 111.359 17.571)",
                fill: "#E4E4E4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 220.613,
                y: 89.516,
                width: 8,
                height: 8,
                rx: 2,
                transform: "rotate(30.813 220.613 89.516)",
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M212.957 21.104c0-.057.047-.104.105-.104h1.877c.058 0 .104.047.104.104v3.305l2.862-1.652a.104.104 0 0 1 .142.038l.939 1.626a.104.104 0 0 1-.038.142l-2.862 1.652 2.862 1.652c.05.03.067.093.038.143l-.939 1.626a.104.104 0 0 1-.142.038l-2.862-1.652v3.304a.104.104 0 0 1-.104.105h-1.877a.105.105 0 0 1-.105-.105v-3.304l-2.862 1.652a.104.104 0 0 1-.142-.038l-.939-1.626a.104.104 0 0 1 .038-.143l2.862-1.652-2.862-1.652a.104.104 0 0 1-.038-.142l.939-1.626a.104.104 0 0 1 .142-.039l2.862 1.653v-3.305Z",
                fill: "#E5E1EC"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m35.746 83.01.983 2.653a2.828 2.828 0 0 0 3.636 1.668v0A2.828 2.828 0 0 1 44 89.001v0a2.828 2.828 0 0 0 3.635 1.668v0a2.828 2.828 0 0 1 3.636 1.668l.983 2.652",
                stroke: "#E4E1E9",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m205.424 72.459 2.829.033a2.828 2.828 0 0 0 2.861-2.795v0a2.829 2.829 0 0 1 2.862-2.795v0a2.828 2.828 0 0 0 2.861-2.795l.033-2.828",
                stroke: "#C1AEF6",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m71.596 34.308.517-2.78a2.828 2.828 0 0 0-2.265-3.298v0a2.829 2.829 0 0 1-2.264-3.297v0a2.828 2.828 0 0 0-2.264-3.298l-2.781-.516",
                stroke: "#E5DFFD",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 107,
                y: 144,
                width: 42,
                height: 6,
                rx: 3,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 107,
                y: 158,
                width: 24,
                height: 6,
                rx: 3,
                fill: "#947DFF"
            })
        ]
    });
var $793ac5b7a7b817f9$export$2e2bcd8739ae039 = $793ac5b7a7b817f9$var$SvgSignInExperienceWelcome;



var $jGWQ4 = parcelRequire("jGWQ4");

var $jheqv = parcelRequire("jheqv");

var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $kUZ14 = parcelRequire("kUZ14");

var $voszV = parcelRequire("voszV");

var $HHYyb = parcelRequire("HHYyb");

var $jGWQ4 = parcelRequire("jGWQ4");

var $18SWy = parcelRequire("18SWy");

var $75SRw = parcelRequire("75SRw");

var $1QOtg = parcelRequire("1QOtg");

var $jbKqE = parcelRequire("jbKqE");

var $7VnwS = parcelRequire("7VnwS");



var $dW2kG = parcelRequire("dW2kG");

var $5OcFi = parcelRequire("5OcFi");






var $3f0c4e3ad013cca3$export$64a53ecd158b85c4;
var $3f0c4e3ad013cca3$export$34e0f9847d4c02dd;
var $3f0c4e3ad013cca3$export$a7db06668cad9adb;
var $3f0c4e3ad013cca3$export$adb608be33961c98;
var $3f0c4e3ad013cca3$export$a65ca8467dbb209e;
var $3f0c4e3ad013cca3$export$6210fa4921d2a466;
var $3f0c4e3ad013cca3$export$38e42c68cf43b5d4;
var $3f0c4e3ad013cca3$export$f22da7240b7add18;
var $3f0c4e3ad013cca3$export$48c2d0f2f545ac27;
var $3f0c4e3ad013cca3$export$95773baf22be5a8c;
var $3f0c4e3ad013cca3$export$bfd64c937657f93a;
var $3f0c4e3ad013cca3$export$3e523c77c1f23f8c;
var $3f0c4e3ad013cca3$export$4a6dd88bada4e7d2;
$3f0c4e3ad013cca3$export$64a53ecd158b85c4 = `f_EMiW_closeIcon`;
$3f0c4e3ad013cca3$export$34e0f9847d4c02dd = `f_EMiW_container`;
$3f0c4e3ad013cca3$export$a7db06668cad9adb = `f_EMiW_content`;
$3f0c4e3ad013cca3$export$adb608be33961c98 = `f_EMiW_footer`;
$3f0c4e3ad013cca3$export$a65ca8467dbb209e = `f_EMiW_footerContent`;
$3f0c4e3ad013cca3$export$6210fa4921d2a466 = `f_EMiW_form`;
$3f0c4e3ad013cca3$export$38e42c68cf43b5d4 = `f_EMiW_header`;
$3f0c4e3ad013cca3$export$f22da7240b7add18 = `f_EMiW_main`;
$3f0c4e3ad013cca3$export$48c2d0f2f545ac27 = `f_EMiW_preview`;
$3f0c4e3ad013cca3$export$95773baf22be5a8c = `f_EMiW_reminder`;
$3f0c4e3ad013cca3$export$bfd64c937657f93a = `f_EMiW_rotating`;
$3f0c4e3ad013cca3$export$3e523c77c1f23f8c = `f_EMiW_separator`;
$3f0c4e3ad013cca3$export$4a6dd88bada4e7d2 = `f_EMiW_shimmer`;


function $9d8bd9bad98f723d$var$GuideModal({ isOpen: isOpen, onClose: onClose }) {
    const { data: data } = (0, $voszV.default)("api/sign-in-exp");
    const { data: preferences, update: updatePreferences } = (0, $c83ac2f0f8302d6c$export$2e2bcd8739ae039)();
    const { updateConfigs: updateConfigs } = (0, $dad5317382253f6d$export$2e2bcd8739ae039)();
    const methods = (0, $codQP.useForm)();
    const { reset: reset, handleSubmit: handleSubmit, formState: { isSubmitting: isSubmitting, isDirty: isDirty }, watch: watch } = methods;
    const api = (0, $7VnwS.default)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const formData = watch();
    const [isLoading, setIsLoading] = (0, $jC8Vy.useState)(false);
    const previewConfigs = (0, $85223ff59ae29aa3$export$2e2bcd8739ae039)(formData, isDirty, data);
    (0, $jC8Vy.useEffect)(()=>{
        if (data && !isDirty) reset((0, $6696e751cd950b0a$export$64f7b79bdbb2c1d4).fromSignInExperience(data));
    }, [
        data,
        reset,
        isDirty
    ]);
    const onGotIt = async ()=>{
        await updatePreferences({
            experienceNoticeConfirmed: true
        });
    };
    const onSubmit = handleSubmit((0, $5OcFi.trySubmitSafe)(async (formData)=>{
        if (!data || isSubmitting) return;
        await Promise.all([
            api.patch("api/sign-in-exp", {
                json: (0, $6696e751cd950b0a$export$64f7b79bdbb2c1d4).toSignInExperience(formData)
            }),
            updateConfigs({
                signInExperienceCustomized: true
            })
        ]);
        onClose();
    }));
    const onSkip = async ()=>{
        setIsLoading(true);
        await updateConfigs({
            signInExperienceCustomized: true
        });
        setIsLoading(false);
        onClose();
    };
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        shouldCloseOnEsc: true,
        isOpen: isOpen,
        className: $dW2kG.fullScreen,
        onRequestClose: onSkip,
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
            className: $3f0c4e3ad013cca3$export$34e0f9847d4c02dd,
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: $3f0c4e3ad013cca3$export$38e42c68cf43b5d4,
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                            size: "large",
                            disabled: isLoading,
                            onClick: onSkip,
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $HHYyb.default), {
                                className: $3f0c4e3ad013cca3$export$64a53ecd158b85c4
                            })
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $3f0c4e3ad013cca3$export$3e523c77c1f23f8c
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $18SWy.default), {
                            size: "small",
                            title: "sign_in_exp.title",
                            subtitle: "sign_in_exp.description"
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jbKqE.default), {}),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                            type: "text",
                            size: "small",
                            title: "general.skip",
                            isLoading: isLoading,
                            onClick: onSkip
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $3f0c4e3ad013cca3$export$a7db06668cad9adb,
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.FormProvider), {
                        ...methods,
                        children: /*#__PURE__*/ (0, $C7mD2.jsxs)("form", {
                            className: $3f0c4e3ad013cca3$export$6210fa4921d2a466,
                            onSubmit: onSubmit,
                            children: [
                                !preferences.experienceNoticeConfirmed && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1QOtg.default), {
                                    action: "general.got_it",
                                    variant: "shadow",
                                    className: $3f0c4e3ad013cca3$export$95773baf22be5a8c,
                                    onClick: onGotIt,
                                    children: t("sign_in_exp.welcome.apply_remind")
                                }),
                                /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                    className: $3f0c4e3ad013cca3$export$f22da7240b7add18,
                                    children: [
                                        /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                            className: $3f0c4e3ad013cca3$export$6210fa4921d2a466,
                                            children: [
                                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $69cd3aca4d6e6ef7$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4a21f1e1a7ce463f$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $81f1d3b1a9622e27$export$2e2bcd8739ae039), {})
                                            ]
                                        }),
                                        formData.id && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6b09b9283b35ff1b$export$2e2bcd8739ae039), {
                                            isLivePreviewEntryInvisible: true,
                                            signInExperience: previewConfigs,
                                            className: $3f0c4e3ad013cca3$export$48c2d0f2f545ac27
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                    className: $3f0c4e3ad013cca3$export$adb608be33961c98,
                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $3f0c4e3ad013cca3$export$a65ca8467dbb209e,
                                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                                            isLoading: isSubmitting,
                                            type: "primary",
                                            htmlType: "submit",
                                            title: "general.done"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}
var $9d8bd9bad98f723d$export$2e2bcd8739ae039 = $9d8bd9bad98f723d$var$GuideModal;


var $cff4e214151f2cc4$export$34e0f9847d4c02dd;
var $cff4e214151f2cc4$export$a7db06668cad9adb;
var $cff4e214151f2cc4$export$6d59db4903f20f7d;
var $cff4e214151f2cc4$export$1ca1ec8b29a4ce27;
var $cff4e214151f2cc4$export$bfd64c937657f93a;
var $cff4e214151f2cc4$export$4a6dd88bada4e7d2;
var $cff4e214151f2cc4$export$fb184b623420d9be;
var $cff4e214151f2cc4$export$cc74dcc53cfce4eb;
$cff4e214151f2cc4$export$34e0f9847d4c02dd = `VDVoSq_container`;
$cff4e214151f2cc4$export$a7db06668cad9adb = `VDVoSq_content`;
$cff4e214151f2cc4$export$6d59db4903f20f7d = `VDVoSq_description`;
$cff4e214151f2cc4$export$1ca1ec8b29a4ce27 = `VDVoSq_icon`;
$cff4e214151f2cc4$export$bfd64c937657f93a = `VDVoSq_rotating`;
$cff4e214151f2cc4$export$4a6dd88bada4e7d2 = `VDVoSq_shimmer`;
$cff4e214151f2cc4$export$fb184b623420d9be = `VDVoSq_title`;
$cff4e214151f2cc4$export$cc74dcc53cfce4eb = `VDVoSq_wrapper`;


function $7e8f8b066fc9b5e2$var$Welcome({ mutate: mutate }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [isOpen, setIsOpen] = (0, $jC8Vy.useState)(false);
    const theme = (0, $jheqv.default)();
    const WelcomeIcon = theme === (0, $5HVJe.Theme).Light ? (0, $793ac5b7a7b817f9$export$2e2bcd8739ae039) : (0, $28e784ed20928c16$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $cff4e214151f2cc4$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $cff4e214151f2cc4$export$a7db06668cad9adb,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)(WelcomeIcon, {
                        className: $cff4e214151f2cc4$export$1ca1ec8b29a4ce27
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $cff4e214151f2cc4$export$cc74dcc53cfce4eb,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $cff4e214151f2cc4$export$fb184b623420d9be,
                                children: t("sign_in_exp.welcome.title")
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $cff4e214151f2cc4$export$6d59db4903f20f7d,
                                children: t("sign_in_exp.welcome.description")
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                                title: "sign_in_exp.welcome.get_started",
                                type: "primary",
                                onClick: ()=>{
                                    setIsOpen(true);
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9d8bd9bad98f723d$export$2e2bcd8739ae039), {
                isOpen: isOpen,
                onClose: ()=>{
                    setIsOpen(false);
                    mutate();
                }
            })
        ]
    });
}
var $7e8f8b066fc9b5e2$export$2e2bcd8739ae039 = $7e8f8b066fc9b5e2$var$Welcome;



function $c2f71503f47d4438$var$PageWrapper({ children: children }) {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $3a1b158c37d9f82b$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $18SWy.default), {
                title: "sign_in_exp.title",
                subtitle: "sign_in_exp.description",
                className: $3a1b158c37d9f82b$export$3aac624c619dfa7f
            }),
            children
        ]
    });
}
function $c2f71503f47d4438$var$SignInExperience() {
    const { data: data, error: error, isLoading: isLoadingSignInExperience, mutate: mutate } = (0, $voszV.default)("api/sign-in-exp");
    const { isLoading: isUserAssetsServiceLoading } = (0, $04111409d75abad4$export$2e2bcd8739ae039)();
    const { configs: configs, error: configsError, isLoading: isLoadingConfig, mutate: mutateConfigs } = (0, $dad5317382253f6d$export$2e2bcd8739ae039)();
    const shouldDisplayWelcome = !(0, $8TpMk.isCloud) && !configs?.signInExperienceCustomized;
    const { error: languageError, isLoading: isLoadingLanguages } = (0, $765bafc6430f5f30$export$2e2bcd8739ae039)();
    const requestError = error ?? configsError ?? languageError;
    const isLoading = isLoadingSignInExperience || isLoadingConfig || isLoadingLanguages || isUserAssetsServiceLoading;
    if (isLoading) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $b3132274561c06c9$export$2e2bcd8739ae039), {});
    if (requestError) return /*#__PURE__*/ (0, $C7mD2.jsx)($c2f71503f47d4438$var$PageWrapper, {
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a20a092c49eaf711$export$2e2bcd8739ae039), {
            className: $3a1b158c37d9f82b$export$a3bc9b8ed74fc,
            error: requestError,
            onRetry: ()=>{
                mutateConfigs();
                mutate();
            }
        })
    });
    if (shouldDisplayWelcome) return /*#__PURE__*/ (0, $C7mD2.jsx)($c2f71503f47d4438$var$PageWrapper, {
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7e8f8b066fc9b5e2$export$2e2bcd8739ae039), {
            mutate: ()=>{
                mutateConfigs();
                mutate();
            }
        })
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)($c2f71503f47d4438$var$PageWrapper, {
        children: data && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $70128f11b276350d$export$2e2bcd8739ae039), {
            data: data,
            onSignInExperienceUpdated: mutate
        })
    });
}
var $c2f71503f47d4438$export$2e2bcd8739ae039 = $c2f71503f47d4438$var$SignInExperience;



const $f515e6d2516c8f43$export$c9ca09bcb5604fad = {
    path: "sign-in-experience",
    children: [
        {
            index: true,
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Navigate), {
                replace: true,
                to: (0, $8643043f1fa1a33d$export$8ce28b52dd68c0b7).Branding
            })
        },
        {
            path: ":tab",
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c2f71503f47d4438$export$2e2bcd8739ae039), {})
        }
    ]
};



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");

var $2Phw0 = parcelRequire("2Phw0");
parcelRequire("8Mb3E");
var $bt3dS = parcelRequire("bt3dS");

var $cDKfs = parcelRequire("cDKfs");
parcelRequire("cuPVN");
var $aZIrr = parcelRequire("aZIrr");

var $jC8Vy = parcelRequire("jC8Vy");

var $voszV = parcelRequire("voszV");


var $8TpMk = parcelRequire("8TpMk");

var $cDKfs = parcelRequire("cDKfs");

const $1f7ad510e5c2dafe$var$useCurrentTenantScopes = ()=>{
    const { currentTenantId: currentTenantId } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const cloudApi = (0, $1c34cc51be8c93d3$export$ec1abe76789cde12)();
    const { user: user } = (0, $8dc2d4d6918e57ba$export$2e2bcd8739ae039)();
    const userId = user?.id ?? "";
    const { data: scopes, isLoading: isLoading, mutate: mutate } = (0, $voszV.default)((0, $8TpMk.isCloud) && userId && `api/tenants/${currentTenantId}/members/${userId}/scopes`, async ()=>{
        const scopes = await cloudApi.get("/api/tenants/:tenantId/members/:userId/scopes", {
            params: {
                tenantId: currentTenantId,
                userId: userId
            }
        });
        return scopes.map(({ name: name })=>name);
    });
    const access = (0, $jC8Vy.useMemo)(()=>({
            canInviteMember: Boolean(scopes?.includes((0, $aZIrr.TenantScope).InviteMember)),
            canRemoveMember: Boolean(scopes?.includes((0, $aZIrr.TenantScope).RemoveMember)),
            canUpdateMemberRole: Boolean(scopes?.includes((0, $aZIrr.TenantScope).UpdateMemberRole)),
            canManageTenant: Boolean(scopes?.includes((0, $aZIrr.TenantScope).ManageTenant))
        }), [
        scopes
    ]);
    return (0, $jC8Vy.useMemo)(()=>({
            isLoading: isLoading,
            scopes: scopes,
            access: access,
            mutate: mutate
        }), [
        isLoading,
        scopes,
        access,
        mutate
    ]);
};
var $1f7ad510e5c2dafe$export$2e2bcd8739ae039 = $1f7ad510e5c2dafe$var$useCurrentTenantScopes;



var $g0vtZ = parcelRequire("g0vtZ");

var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $2Phw0 = parcelRequire("2Phw0");
parcelRequire("8Mb3E");
var $bt3dS = parcelRequire("bt3dS");

var $cDKfs = parcelRequire("cDKfs");

var $18SWy = parcelRequire("18SWy");

var $66ixW = parcelRequire("66ixW");


var $de831b02c080d883$export$3aac624c619dfa7f;
var $de831b02c080d883$export$34e0f9847d4c02dd;
var $de831b02c080d883$export$bfd64c937657f93a;
var $de831b02c080d883$export$4a6dd88bada4e7d2;
var $de831b02c080d883$export$39f5674517ec0000;
$de831b02c080d883$export$3aac624c619dfa7f = `D9ZC6a_cardTitle`;
$de831b02c080d883$export$34e0f9847d4c02dd = `D9ZC6a_container`;
$de831b02c080d883$export$bfd64c937657f93a = `D9ZC6a_rotating`;
$de831b02c080d883$export$4a6dd88bada4e7d2 = `D9ZC6a_shimmer`;
$de831b02c080d883$export$39f5674517ec0000 = `D9ZC6a_tabs`;


function $653c238fc74a80f6$var$TenantSettings() {
    const { isDevTenant: isDevTenant } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { access: { canManageTenant: canManageTenant } } = (0, $1f7ad510e5c2dafe$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $de831b02c080d883$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $18SWy.default), {
                title: "tenants.title",
                subtitle: "tenants.description",
                className: $de831b02c080d883$export$3aac624c619dfa7f
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $26090e0c44b20d28$export$2e2bcd8739ae039), {
                className: $de831b02c080d883$export$39f5674517ec0000,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                        href: `/tenant-settings/${(0, $bt3dS.TenantSettingsTabs).Settings}`,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: "tenants.tabs.settings"
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                        href: `/tenant-settings/${(0, $bt3dS.TenantSettingsTabs).Domains}`,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: "tenants.tabs.domains"
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                        href: `/tenant-settings/${(0, $bt3dS.TenantSettingsTabs).Members}`,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: "tenants.tabs.members"
                        })
                    }),
                    !isDevTenant && canManageTenant && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                                href: `/tenant-settings/${(0, $bt3dS.TenantSettingsTabs).Subscription}`,
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                    forKey: "tenants.tabs.subscription"
                                })
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                                href: `/tenant-settings/${(0, $bt3dS.TenantSettingsTabs).BillingHistory}`,
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                    forKey: "tenants.tabs.billing_history"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Outlet), {})
        ]
    });
}
var $653c238fc74a80f6$export$2e2bcd8739ae039 = $653c238fc74a80f6$var$TenantSettings;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $b67J2 = parcelRequire("b67J2");

var $jC8Vy = parcelRequire("jC8Vy");




var $5TsIB = parcelRequire("5TsIB");


var $cDKfs = parcelRequire("cDKfs");

var $66ixW = parcelRequire("66ixW");


var $voszV = parcelRequire("voszV");

const $9b1a5b5603ed9cad$var$useInvoices = (tenantId)=>{
    const cloudApi = (0, $1c34cc51be8c93d3$export$7a5c900790855d66)();
    const swrResponse = (0, $voszV.default)(`/api/tenants/${tenantId}/invoices`, async ()=>cloudApi.get("/api/tenants/:tenantId/invoices", {
            params: {
                tenantId: tenantId
            }
        }));
    const { data: invoicesResponse } = swrResponse;
    return {
        ...swrResponse,
        data: invoicesResponse?.invoices
    };
};
var $9b1a5b5603ed9cad$export$2e2bcd8739ae039 = $9b1a5b5603ed9cad$var$useInvoices;




var $C7mD2 = parcelRequire("C7mD2");

var $66ixW = parcelRequire("66ixW");

const $7dd91e1151f0986e$var$tagStatusMap = {
    open: "alert",
    paid: "success",
    uncollectible: "error",
    void: "info"
};
const $7dd91e1151f0986e$var$invoiceStatusPhraseMap = {
    open: "open",
    paid: "paid",
    uncollectible: "uncollectible",
    void: "void"
};
function $7dd91e1151f0986e$var$InvoiceStatusTag({ status: status }) {
    if (status === "draft" || !status) // Don't show tag for draft invoices
    return /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
        children: "-"
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
        type: "state",
        status: $7dd91e1151f0986e$var$tagStatusMap[status],
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
            forKey: `subscription.billing_history.invoice_status.${$7dd91e1151f0986e$var$invoiceStatusPhraseMap[status]}`
        })
    });
}
var $7dd91e1151f0986e$export$2e2bcd8739ae039 = $7dd91e1151f0986e$var$InvoiceStatusTag;


function $f3fcba42ca11c229$var$BillingHistory() {
    const cloudApi = (0, $1c34cc51be8c93d3$export$7a5c900790855d66)();
    const { currentTenantId: currentTenantId } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { data: invoices, error: error } = (0, $9b1a5b5603ed9cad$export$2e2bcd8739ae039)(currentTenantId);
    const isLoadingInvoices = !invoices && !error;
    const displayInvoices = (0, $jC8Vy.useMemo)(// Don't show draft invoices
    ()=>invoices?.filter(({ status: status })=>status !== "draft"), [
        invoices
    ]);
    const openStripeHostedInvoicePage = (0, $jC8Vy.useCallback)(async (invoiceId)=>{
        const { hostedInvoiceUrl: hostedInvoiceUrl } = await cloudApi.get("/api/tenants/:tenantId/invoices/:invoiceId/hosted-invoice-url", {
            params: {
                tenantId: currentTenantId,
                invoiceId: invoiceId
            }
        });
        window.open(hostedInvoiceUrl, "_blank");
    }, [
        cloudApi,
        currentTenantId
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5TsIB.default), {
                titleKey: [
                    "tenants.tabs.billing_history",
                    "tenants.title"
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3166f28a681c41bb$export$2e2bcd8739ae039), {
                rowGroups: [
                    {
                        key: "invoices",
                        data: displayInvoices
                    }
                ],
                rowIndexKey: "id",
                columns: [
                    {
                        title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: "subscription.billing_history.invoice_column"
                        }),
                        dataIndex: "planName",
                        render: ({ planName: planName, periodStart: periodStart, periodEnd: periodEnd })=>{
                            return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4d952cae22cb03fc$export$2e2bcd8739ae039), {
                                title: (0, $b38537f440ba3476$export$b971ca6f7de66f44)({
                                    periodStart: periodStart,
                                    periodEnd: periodEnd,
                                    displayYear: true
                                }),
                                subtitle: (0, $7oDSS.conditional)(planName && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $161f1bf99d56f621$export$2e2bcd8739ae039), {
                                    name: planName
                                }))
                            });
                        }
                    },
                    {
                        title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: "subscription.billing_history.status_column"
                        }),
                        dataIndex: "status",
                        render: ({ status: status })=>{
                            return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7dd91e1151f0986e$export$2e2bcd8739ae039), {
                                status: status
                            });
                        }
                    },
                    {
                        title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: "subscription.billing_history.amount_column"
                        }),
                        dataIndex: "amountPaid",
                        render: ({ amountPaid: amountPaid })=>{
                            return `$${(amountPaid / 100).toFixed(2)}`;
                        }
                    },
                    {
                        title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: "subscription.billing_history.invoice_created_date_column"
                        }),
                        dataIndex: "created",
                        render: ({ createdAt: createdAt })=>{
                            return (0, (/*@__PURE__*/$parcel$interopDefault($b67J2)))(createdAt).format("MMMM DD, YYYY");
                        }
                    }
                ],
                isLoading: isLoadingInvoices,
                placeholder: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a0f84bc7cc69e410$export$2e2bcd8739ae039), {}),
                rowClickHandler: ({ id: id })=>{
                    openStripeHostedInvoicePage(id);
                }
            })
        ]
    });
}
var $f3fcba42ca11c229$export$2e2bcd8739ae039 = $f3fcba42ca11c229$var$BillingHistory;



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $5TsIB = parcelRequire("5TsIB");


var $cDKfs = parcelRequire("cDKfs");

var $voszV = parcelRequire("voszV");


var $8TpMk = parcelRequire("8TpMk");
const $4aea7ad51d438a6c$var$useSubscriptionUsage = (tenantId)=>{
    const cloudApi = (0, $1c34cc51be8c93d3$export$7a5c900790855d66)();
    return (0, $voszV.default)((0, $8TpMk.isCloud) && `/api/tenants/${tenantId}/usage`, async ()=>cloudApi.get("/api/tenants/:tenantId/usage", {
            params: {
                tenantId: tenantId
            }
        }));
};
var $4aea7ad51d438a6c$export$2e2bcd8739ae039 = $4aea7ad51d438a6c$var$useSubscriptionUsage;




var $C7mD2 = parcelRequire("C7mD2");

var $34d6c541def1fe6c$export$34e0f9847d4c02dd;
var $34d6c541def1fe6c$export$bfd64c937657f93a;
var $34d6c541def1fe6c$export$4a6dd88bada4e7d2;
$34d6c541def1fe6c$export$34e0f9847d4c02dd = `uOOVxa_container`;
$34d6c541def1fe6c$export$bfd64c937657f93a = `uOOVxa_rotating`;
$34d6c541def1fe6c$export$4a6dd88bada4e7d2 = `uOOVxa_shimmer`;


function $6b1e34b0104d3805$var$Skeleton() {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $34d6c541def1fe6c$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fe58a6ffca737898$export$2e2bcd8739ae039), {
                formFieldCount: 1
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fe58a6ffca737898$export$2e2bcd8739ae039), {
                formFieldCount: 1
            })
        ]
    });
}
var $6b1e34b0104d3805$export$2e2bcd8739ae039 = $6b1e34b0104d3805$var$Skeleton;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");







var $aqmjm = parcelRequire("aqmjm");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $lXQZH = parcelRequire("lXQZH");

var $jC8Vy = parcelRequire("jC8Vy");




var $cDKfs = parcelRequire("cDKfs");

var $66ixW = parcelRequire("66ixW");

var $1QOtg = parcelRequire("1QOtg");

var $kBpQ2 = parcelRequire("kBpQ2");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $lXQZH = parcelRequire("lXQZH");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");



const $5e61eac35f83c4b0$export$5fe02dd94d8940f2 = {
    mauLimit: "mau_limit.name",
    tokenLimit: "token_limit.name",
    applicationsLimit: "applications_limit.name",
    machineToMachineLimit: "machine_to_machine_limit.name",
    thirdPartyApplicationsLimit: "third_party_applications_limit.name",
    resourcesLimit: "resources_limit.name",
    scopesPerResourceLimit: "scopes_per_resource_limit.name",
    customDomainEnabled: "custom_domain_enabled.name",
    omniSignInEnabled: "omni_sign_in_enabled.name",
    socialConnectorsLimit: "social_connectors_limit.name",
    standardConnectorsLimit: "standard_connectors_limit.name",
    rolesLimit: "roles_limit.name",
    machineToMachineRolesLimit: "machine_to_machine_roles_limit.name",
    scopesPerRoleLimit: "scopes_per_role_limit.name",
    hooksLimit: "hooks_limit.name",
    auditLogsRetentionDays: "audit_logs_retention_days.name",
    ticketSupportResponseTime: "email_ticket_support.name",
    mfaEnabled: "mfa_enabled.name",
    organizationsEnabled: "organizations_enabled.name",
    ssoEnabled: "sso_enabled.name",
    tenantMembersLimit: "tenant_members_limit.name",
    customJwtEnabled: "custom_jwt_enabled.name"
};
const $5e61eac35f83c4b0$export$835723acfb933c0e = {
    mauLimit: "mau_limit.unlimited",
    tokenLimit: "token_limit.unlimited",
    applicationsLimit: "applications_limit.unlimited",
    machineToMachineLimit: "machine_to_machine_limit.unlimited",
    thirdPartyApplicationsLimit: "third_party_applications_limit.unlimited",
    resourcesLimit: "resources_limit.unlimited",
    scopesPerResourceLimit: "scopes_per_resource_limit.unlimited",
    customDomainEnabled: "custom_domain_enabled.unlimited",
    omniSignInEnabled: "omni_sign_in_enabled.unlimited",
    socialConnectorsLimit: "social_connectors_limit.unlimited",
    standardConnectorsLimit: "standard_connectors_limit.unlimited",
    rolesLimit: "roles_limit.unlimited",
    machineToMachineRolesLimit: "machine_to_machine_roles_limit.unlimited",
    scopesPerRoleLimit: "scopes_per_role_limit.unlimited",
    hooksLimit: "hooks_limit.unlimited",
    auditLogsRetentionDays: "audit_logs_retention_days.unlimited",
    ticketSupportResponseTime: "email_ticket_support.unlimited",
    mfaEnabled: "mfa_enabled.unlimited",
    organizationsEnabled: "organizations_enabled.unlimited",
    ssoEnabled: "sso_enabled.unlimited",
    tenantMembersLimit: "tenant_members_limit.unlimited",
    customJwtEnabled: "custom_jwt_enabled.unlimited"
};
const $5e61eac35f83c4b0$export$90b7c469260db368 = {
    mauLimit: "mau_limit.limited",
    tokenLimit: "token_limit.limited",
    applicationsLimit: "applications_limit.limited",
    machineToMachineLimit: "machine_to_machine_limit.limited",
    thirdPartyApplicationsLimit: "third_party_applications_limit.limited",
    resourcesLimit: "resources_limit.limited",
    scopesPerResourceLimit: "scopes_per_resource_limit.limited",
    customDomainEnabled: "custom_domain_enabled.limited",
    omniSignInEnabled: "omni_sign_in_enabled.limited",
    socialConnectorsLimit: "social_connectors_limit.limited",
    standardConnectorsLimit: "standard_connectors_limit.limited",
    rolesLimit: "roles_limit.limited",
    machineToMachineRolesLimit: "machine_to_machine_roles_limit.limited",
    scopesPerRoleLimit: "scopes_per_role_limit.limited",
    hooksLimit: "hooks_limit.limited",
    auditLogsRetentionDays: "audit_logs_retention_days.limited",
    ticketSupportResponseTime: "email_ticket_support.limited",
    mfaEnabled: "mfa_enabled.limited",
    organizationsEnabled: "organizations_enabled.limited",
    ssoEnabled: "sso_enabled.limited",
    tenantMembersLimit: "tenant_members_limit.limited",
    customJwtEnabled: "custom_jwt_enabled.limited"
};
const $5e61eac35f83c4b0$export$fc0debfec7b2b60b = {
    mauLimit: "mau_limit.not_eligible",
    tokenLimit: "token_limit.not_eligible",
    applicationsLimit: "applications_limit.not_eligible",
    machineToMachineLimit: "machine_to_machine_limit.not_eligible",
    thirdPartyApplicationsLimit: "third_party_applications_limit.not_eligible",
    resourcesLimit: "resources_limit.not_eligible",
    scopesPerResourceLimit: "scopes_per_resource_limit.not_eligible",
    customDomainEnabled: "custom_domain_enabled.not_eligible",
    omniSignInEnabled: "omni_sign_in_enabled.not_eligible",
    socialConnectorsLimit: "social_connectors_limit.not_eligible",
    standardConnectorsLimit: "standard_connectors_limit.not_eligible",
    rolesLimit: "roles_limit.not_eligible",
    machineToMachineRolesLimit: "machine_to_machine_roles_limit.not_eligible",
    scopesPerRoleLimit: "scopes_per_role_limit.not_eligible",
    hooksLimit: "hooks_limit.not_eligible",
    auditLogsRetentionDays: "audit_logs_retention_days.not_eligible",
    ticketSupportResponseTime: "email_ticket_support.not_eligible",
    mfaEnabled: "mfa_enabled.not_eligible",
    organizationsEnabled: "organizations_enabled.not_eligible",
    ssoEnabled: "sso_enabled.not_eligible",
    tenantMembersLimit: "tenant_members_limit.not_eligible",
    customJwtEnabled: "custom_jwt_enabled.not_eligible"
};



var $66ixW = parcelRequire("66ixW");

var $af9e7bf91df2c39a$export$a2da573beea6475e;
var $af9e7bf91df2c39a$export$34e0f9847d4c02dd;
var $af9e7bf91df2c39a$export$6d59db4903f20f7d;
var $af9e7bf91df2c39a$export$8837f4fc672e936d;
var $af9e7bf91df2c39a$export$bfd64c937657f93a;
var $af9e7bf91df2c39a$export$4a6dd88bada4e7d2;
$af9e7bf91df2c39a$export$a2da573beea6475e = `nXAoga_buttonLink`;
$af9e7bf91df2c39a$export$34e0f9847d4c02dd = `nXAoga_container`;
$af9e7bf91df2c39a$export$6d59db4903f20f7d = `nXAoga_description`;
$af9e7bf91df2c39a$export$8837f4fc672e936d = `nXAoga_list`;
$af9e7bf91df2c39a$export$bfd64c937657f93a = `nXAoga_rotating`;
$af9e7bf91df2c39a$export$4a6dd88bada4e7d2 = `nXAoga_shimmer`;


const $e6ddd306f0f7c511$var$excludedQuotaKeys = new Set([
    "auditLogsRetentionDays",
    "ticketSupportResponseTime"
]);
function $e6ddd306f0f7c511$var$NotEligibleSwitchPlanModalContent({ targetPlan: targetPlan, exceededQuotaKeys: exceededQuotaKeys, isDowngrade: isDowngrade = false }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.subscription.not_eligible_modal"
    });
    const { id: id, name: name, quota: quota } = targetPlan;
    const orderedEntries = (0, $jC8Vy.useMemo)(()=>{
        // eslint-disable-next-line no-restricted-syntax
        const entries = Object.entries(quota);
        return entries.filter(([quotaKey])=>exceededQuotaKeys.includes(quotaKey)).slice().sort(([preQuotaKey], [nextQuotaKey])=>(0, $116db580d0523aa2$export$b035e44d7bb4278f)((0, $43d5e1b5339ea79b$export$103450479c8ed1e3))(preQuotaKey, nextQuotaKey));
    }, [
        quota,
        exceededQuotaKeys
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $af9e7bf91df2c39a$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $af9e7bf91df2c39a$export$6d59db4903f20f7d,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                        components: {
                            name: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $161f1bf99d56f621$export$2e2bcd8739ae039), {
                                name: name
                            })
                        },
                        children: t(isDowngrade ? "downgrade_description" : "upgrade_description")
                    }),
                    !isDowngrade && id === (0, $lXQZH.ReservedPlanId).Hobby && t("upgrade_pro_tip")
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ul", {
                className: $af9e7bf91df2c39a$export$8837f4fc672e936d,
                children: orderedEntries.map(([quotaKey, quotaValue])=>{
                    if ($e6ddd306f0f7c511$var$excludedQuotaKeys.has(quotaKey) || quotaValue === null || // Unlimited items
                    quotaValue === true // Eligible items
                    ) return null;
                    return /*#__PURE__*/ (0, $C7mD2.jsx)("li", {
                        children: quotaValue ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                            components: {
                                item: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                    forKey: `subscription.quota_item.${(0, $5e61eac35f83c4b0$export$90b7c469260db368)[quotaKey]}`,
                                    interpolation: (0, $7oDSS.conditional)(typeof quotaValue === "number" && {
                                        count: quotaValue
                                    })
                                })
                            },
                            children: t("a_maximum_of")
                        }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: `subscription.quota_item.${(0, $5e61eac35f83c4b0$export$fc0debfec7b2b60b)[quotaKey]}`
                        })
                    }, quotaKey);
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                components: {
                    a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a3bc63325dc3c1a8$export$2e2bcd8739ae039), {})
                },
                children: t(isDowngrade ? "downgrade_help_tip" : "upgrade_help_tip")
            })
        ]
    });
}
var $e6ddd306f0f7c511$export$2e2bcd8739ae039 = $e6ddd306f0f7c511$var$NotEligibleSwitchPlanModalContent;



function $f37c957679a80148$var$MauLimitExceededNotification({ activeUsers: activeUsers, currentPlan: currentPlan, className: className }) {
    const { currentTenantId: currentTenantId } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { subscribe: subscribe } = (0, $699da2d1bc75044e$export$2e2bcd8739ae039)();
    const { show: show } = (0, $kBpQ2.useConfirmModal)();
    const { subscriptionPlans: subscriptionPlans } = (0, $jC8Vy.useContext)((0, $19434c930f80c964$export$f8addfd4ab69c833));
    const [isLoading, setIsLoading] = (0, $jC8Vy.useState)(false);
    const proPlan = (0, $jC8Vy.useMemo)(/**
     * Note: now the hobby plan is treated as the new pro plan
     */ ()=>subscriptionPlans.find(({ id: id })=>id === (0, $lXQZH.ReservedPlanId).Hobby), [
        subscriptionPlans
    ]);
    const { quota: { mauLimit: mauLimit } } = currentPlan;
    if (mauLimit === null || // Unlimited
    activeUsers < mauLimit || !proPlan) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1QOtg.default), {
        severity: "error",
        action: "subscription.upgrade_pro",
        className: className,
        isActionLoading: isLoading,
        onClick: async ()=>{
            try {
                setIsLoading(true);
                await subscribe({
                    planId: proPlan.id,
                    tenantId: currentTenantId,
                    callbackPage: (0, $b2864970cb73ddbd$export$6d940d0d58a60bc4)
                });
                setIsLoading(false);
            } catch (error) {
                setIsLoading(false);
                const [result, exceededQuotaKeys] = await (0, $b38537f440ba3476$export$c0ed1fa5d8f3e3a5)(error);
                if (result) {
                    await show({
                        ModalContent: ()=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $e6ddd306f0f7c511$export$2e2bcd8739ae039), {
                                targetPlan: proPlan,
                                exceededQuotaKeys: exceededQuotaKeys
                            }),
                        title: "subscription.not_eligible_modal.upgrade_title",
                        confirmButtonText: "general.got_it",
                        confirmButtonType: "primary",
                        isCancelButtonVisible: false
                    });
                    return;
                }
                (0, $1c34cc51be8c93d3$export$10abc8714a7caf54)(error);
            }
        },
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
            forKey: "subscription.overfill_quota_warning"
        })
    });
}
var $f37c957679a80148$export$2e2bcd8739ae039 = $f37c957679a80148$var$MauLimitExceededNotification;



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $cDKfs = parcelRequire("cDKfs");

var $66ixW = parcelRequire("66ixW");

var $1QOtg = parcelRequire("1QOtg");

function $58e9be67c319b0ed$var$PaymentOverdueNotification({ className: className }) {
    const { currentTenant: currentTenant, currentTenantId: currentTenantId } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { openInvoices: openInvoices = [] } = currentTenant ?? {};
    const { visitManagePaymentPage: visitManagePaymentPage } = (0, $699da2d1bc75044e$export$2e2bcd8739ae039)();
    const [isActionLoading, setIsActionLoading] = (0, $jC8Vy.useState)(false);
    if (openInvoices.length === 0) return null;
    const totalAmountDue = openInvoices.reduce((total, currentInvoice)=>total + currentInvoice.amountDue, 0);
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1QOtg.default), {
        severity: "error",
        action: "subscription.update_payment",
        className: className,
        isActionLoading: isActionLoading,
        onClick: async ()=>{
            setIsActionLoading(true);
            await visitManagePaymentPage(currentTenantId);
            setIsActionLoading(false);
        },
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
            forKey: "subscription.payment_error",
            interpolation: {
                price: totalAmountDue / 100
            }
        })
    });
}
var $58e9be67c319b0ed$export$2e2bcd8739ae039 = $58e9be67c319b0ed$var$PaymentOverdueNotification;


var $9430c5a602f0ed8e$export$6d59db4903f20f7d;
var $9430c5a602f0ed8e$export$a8ff84c12d48cfa6;
var $9430c5a602f0ed8e$export$2adf6238a2d0dafa;
var $9430c5a602f0ed8e$export$7507ac6a8989448c;
var $9430c5a602f0ed8e$export$bfd64c937657f93a;
var $9430c5a602f0ed8e$export$4a6dd88bada4e7d2;
$9430c5a602f0ed8e$export$6d59db4903f20f7d = `m-BY5a_description`;
$9430c5a602f0ed8e$export$a8ff84c12d48cfa6 = `m-BY5a_name`;
$9430c5a602f0ed8e$export$2adf6238a2d0dafa = `m-BY5a_notification`;
$9430c5a602f0ed8e$export$7507ac6a8989448c = `m-BY5a_planInfo`;
$9430c5a602f0ed8e$export$bfd64c937657f93a = `m-BY5a_rotating`;
$9430c5a602f0ed8e$export$4a6dd88bada4e7d2 = `m-BY5a_shimmer`;


function $3ecaddd4a6fa09fb$var$CurrentPlan({ subscription: subscription, subscriptionPlan: subscriptionPlan, subscriptionUsage: subscriptionUsage }) {
    const { id: id, name: name, quota: { tokenLimit: tokenLimit } } = subscriptionPlan;
    const hasTokenSurpassedLimit = (0, $605aee781e0fe83f$export$6486e974a84ab8b6)({
        quotaKey: "tokenLimit",
        usage: subscriptionUsage.tokenUsage,
        plan: subscriptionPlan
    });
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
        title: "subscription.current_plan",
        description: "subscription.current_plan_description",
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $9430c5a602f0ed8e$export$7507ac6a8989448c,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $9430c5a602f0ed8e$export$a8ff84c12d48cfa6,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $161f1bf99d56f621$export$2e2bcd8739ae039), {
                            name: name
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $9430c5a602f0ed8e$export$6d59db4903f20f7d,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ee11b869fd4eeed7$export$2e2bcd8739ae039), {
                            planId: id
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: "subscription.plan_usage",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2df8e7170c01f284$export$2e2bcd8739ae039), {
                    currentSubscription: subscription,
                    currentPlan: subscriptionPlan,
                    subscriptionUsage: subscriptionUsage
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: "subscription.next_bill",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $210ebe2740442134$export$2e2bcd8739ae039), {
                    cost: subscriptionUsage.cost,
                    isManagePaymentVisible: Boolean(subscriptionUsage.cost)
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f37c957679a80148$export$2e2bcd8739ae039), {
                activeUsers: subscriptionUsage.activeUsers,
                currentPlan: subscriptionPlan,
                className: $9430c5a602f0ed8e$export$2adf6238a2d0dafa
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $69ac10e11f23c995$export$2e2bcd8739ae039), {
                hasSurpassedLimit: hasTokenSurpassedLimit,
                quotaItemPhraseKey: "tokens",
                checkedFlagKey: "token",
                className: $9430c5a602f0ed8e$export$2adf6238a2d0dafa,
                quotaLimit: (0, $7oDSS.cond)(typeof tokenLimit === "number" && tokenLimit)
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $58e9be67c319b0ed$export$2e2bcd8739ae039), {
                className: $9430c5a602f0ed8e$export$2adf6238a2d0dafa
            })
        ]
    });
}
var $3ecaddd4a6fa09fb$export$2e2bcd8739ae039 = $3ecaddd4a6fa09fb$var$CurrentPlan;



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");


var $66ixW = parcelRequire("66ixW");

var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $lf8OC = parcelRequire("lf8OC");

var $75SRw = parcelRequire("75SRw");
parcelRequire("fIF1D");
var $2LaLj = parcelRequire("2LaLj");

var $C7mD2 = parcelRequire("C7mD2");

var $217fa0c086c57cbf$export$35dc45686fc2dbd7;
var $217fa0c086c57cbf$export$bfd64c937657f93a;
var $217fa0c086c57cbf$export$4a6dd88bada4e7d2;
$217fa0c086c57cbf$export$35dc45686fc2dbd7 = `_3owZga_check`;
$217fa0c086c57cbf$export$bfd64c937657f93a = `_3owZga_rotating`;
$217fa0c086c57cbf$export$4a6dd88bada4e7d2 = `_3owZga_shimmer`;


function $40f2b8484c940cbb$var$TableDataContent({ content: content }) {
    const hasCheckmark = typeof content === "string" && content.includes("✓");
    if (hasCheckmark) {
        const [before, after] = content.split("✓");
        return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
            className: $217fa0c086c57cbf$export$35dc45686fc2dbd7,
            children: [
                before && /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                    children: before
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $863c8122c7186617$export$2e2bcd8739ae039), {}),
                after && /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                    children: after
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
        children: content
    });
}
var $40f2b8484c940cbb$export$2e2bcd8739ae039 = $40f2b8484c940cbb$var$TableDataContent;


var $e98e1862dd9503d8$export$3b2213b072666173;
var $e98e1862dd9503d8$export$f83f8be4d5ed7815;
var $e98e1862dd9503d8$export$d590d3c372de1c6e;
var $e98e1862dd9503d8$export$bfd64c937657f93a;
var $e98e1862dd9503d8$export$4a6dd88bada4e7d2;
$e98e1862dd9503d8$export$3b2213b072666173 = `wBb2ka_extraInfo`;
$e98e1862dd9503d8$export$f83f8be4d5ed7815 = `wBb2ka_leftAligned`;
$e98e1862dd9503d8$export$d590d3c372de1c6e = `wBb2ka_quotaValue`;
$e98e1862dd9503d8$export$bfd64c937657f93a = `wBb2ka_rotating`;
$e98e1862dd9503d8$export$4a6dd88bada4e7d2 = `wBb2ka_shimmer`;


function $c1830193839d21ce$var$TableDataWrapper({ value: value, isLeftAligned: isLeftAligned = false }) {
    const [content = "", tip, extraInfo] = value.split("|");
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($e98e1862dd9503d8$export$d590d3c372de1c6e, isLeftAligned && $e98e1862dd9503d8$export$f83f8be4d5ed7815),
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $40f2b8484c940cbb$export$2e2bcd8739ae039), {
                        content: content
                    }),
                    tip && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2LaLj.default), {
                        content: tip,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                            size: "small",
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $lf8OC.default), {})
                        })
                    })
                ]
            }),
            extraInfo && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $e98e1862dd9503d8$export$3b2213b072666173,
                children: extraInfo
            })
        ]
    });
}
var $c1830193839d21ce$export$2e2bcd8739ae039 = $c1830193839d21ce$var$TableDataWrapper;


var $a04b5a01ba6be0c0$export$34e0f9847d4c02dd;
var $a04b5a01ba6be0c0$export$808794a1efddf200;
var $a04b5a01ba6be0c0$export$658ddaa3f057c88;
var $a04b5a01ba6be0c0$export$bfd64c937657f93a;
var $a04b5a01ba6be0c0$export$4a6dd88bada4e7d2;
$a04b5a01ba6be0c0$export$34e0f9847d4c02dd = `iMtKeW_container`;
$a04b5a01ba6be0c0$export$808794a1efddf200 = `iMtKeW_groupLabel`;
$a04b5a01ba6be0c0$export$658ddaa3f057c88 = `iMtKeW_quotaKeyColumn`;
$a04b5a01ba6be0c0$export$bfd64c937657f93a = `iMtKeW_rotating`;
$a04b5a01ba6be0c0$export$4a6dd88bada4e7d2 = `iMtKeW_shimmer`;


const $ad0bd470b4bcb6dd$var$featuredPlanPhraseKey = [
    "subscription.free_plan",
    "subscription.pro_plan",
    "subscription.enterprise"
];
function $ad0bd470b4bcb6dd$var$PlanComparisonTable() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.subscription.quota_table"
    });
    const { t: adminConsoleTranslation } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const tables = (0, $jC8Vy.useMemo)(()=>{
        const contact = t("contact");
        const unlimited = t("unlimited");
        const paidQuotaLimitTip = t("paid_quota_limit_tip");
        const paidAddOnFeatureTip = t("paid_add_on_feature_tip");
        const addOn = t("add_on");
        const comingSoon = adminConsoleTranslation("general.coming_soon");
        // Basics
        const basePrice = t("quota.base_price");
        const proPlanBasePrice = t("monthly_price", {
            value: 16
        });
        const mauLimit = t("quota.mau_limit");
        const mauLimitTip = t("mau_tip");
        const includedTokens = t("quota.included_tokens");
        const includedTokensTip = t("tokens_tip");
        const proPlanIncludedTokens = t("million", {
            value: 1
        });
        const proPlanIncludedTokensTip = t("paid_token_limit_tip");
        // Applications
        const totalApplications = t("application.total");
        const m2mApps = t("application.m2m");
        const proPlanM2mAppLimit = t("included", {
            value: 1
        });
        const proPlanM2mAppPrice = t("extra_quota_price", {
            value: 8
        });
        const thirdPartyApps = t("application.third_party");
        const thirdPartyAppsTip = t("third_party_tip");
        // API resources
        const resourceCount = t("resource.resource_count");
        const proPlanResourceLimit = t("included", {
            value: 3
        });
        const proPlanResourcePrice = t("extra_quota_price", {
            value: 4
        });
        const permissionsPerResource = t("resource.scopes_per_resource");
        // UI and branding
        const customDomain = t("branding.custom_domain");
        const customCss = t("branding.custom_css");
        const appLogoAndFavicon = t("branding.app_logo_and_favicon");
        const darkMode = t("branding.dark_mode");
        const i18n = t("branding.i18n");
        // User authentication
        const omniSignIn = t("user_authn.omni_sign_in");
        const password = t("user_authn.password");
        const passwordless = t("user_authn.passwordless");
        const emailConnector = t("user_authn.email_connector");
        const smsConnector = t("user_authn.sms_connector");
        const socialConnectors = t("user_authn.social_connectors");
        const ssoPrice = t("per_month_each", {
            value: 48
        });
        const sso = t("user_authn.sso");
        const mfa = t("user_authn.mfa");
        const mfaPrice = t("monthly_price", {
            value: 48
        });
        const orgPrice = t("monthly_price", {
            value: 48
        });
        const adaptiveMfa = t("user_authn.adaptive_mfa");
        // User management
        const userManagement = t("user_management.user_management");
        const userRoles = t("user_management.roles");
        const m2mRoles = t("user_management.machine_to_machine_roles");
        const permissionsPerRole = t("user_management.scopes_per_role");
        // Organizations
        const organization = t("organizations.organization");
        const orgCount = t("organizations.organization_count");
        const allowedUsersPerOrg = t("organizations.allowed_users_per_org");
        const invitation = t("organizations.invitation");
        const orgRoles = t("organizations.org_roles");
        const orgPermissions = t("organizations.org_permissions");
        const jitProvisioning = t("organizations.just_in_time_provisioning");
        // Developers and platform
        const webhooks = t("developers_and_platform.hooks");
        const auditLogRetention = t("developers_and_platform.audit_logs_retention");
        const freePlanLogRetention = t("days", {
            count: (0, $217fd4972b445457$export$b061d26c4cbe21f4)
        });
        const paidPlanLogRetention = t("days", {
            count: (0, $217fd4972b445457$export$20398ca9e4426c2a)
        });
        const jwtClaims = t("developers_and_platform.jwt_claims");
        const tenantMembers = t("developers_and_platform.tenant_members");
        const tenantMembersLimit = t("included", {
            value: 3
        });
        const tenantMembersPrice = t("per_member", {
            value: 8
        });
        // Compliance and support
        const community = t("support.community");
        const emailTicketSupport = t("support.email_ticket_support");
        const soc2Report = t("support.soc2_report");
        const hipaaOrBaaReport = t("support.hipaa_or_baa_report");
        return [
            {
                title: "quota.title",
                rows: [
                    {
                        name: basePrice,
                        data: [
                            "0",
                            proPlanBasePrice,
                            contact
                        ]
                    },
                    {
                        name: `${mauLimit}|${mauLimitTip}`,
                        data: [
                            (0, $217fd4972b445457$export$4478f817ef067d45).toLocaleString(),
                            unlimited,
                            contact
                        ]
                    },
                    {
                        name: `${includedTokens}|${includedTokensTip}`,
                        data: [
                            "500,000",
                            `${proPlanIncludedTokens}|${proPlanIncludedTokensTip}`,
                            contact
                        ]
                    }
                ]
            },
            {
                title: "application.title",
                rows: [
                    {
                        name: totalApplications,
                        data: [
                            "3",
                            unlimited,
                            contact
                        ]
                    },
                    {
                        name: m2mApps,
                        data: [
                            `${(0, $217fd4972b445457$export$273c590433c54f2b)}`,
                            `${proPlanM2mAppLimit}|${paidQuotaLimitTip}|${proPlanM2mAppPrice}`,
                            contact
                        ]
                    },
                    {
                        name: `${thirdPartyApps}|${thirdPartyAppsTip}`,
                        data: [
                            "-",
                            unlimited,
                            contact
                        ]
                    }
                ]
            },
            {
                title: "resource.title",
                rows: [
                    {
                        name: resourceCount,
                        data: [
                            "1",
                            `${proPlanResourceLimit}|${paidQuotaLimitTip}|${proPlanResourcePrice}`,
                            contact
                        ]
                    },
                    {
                        name: permissionsPerResource,
                        data: [
                            "1",
                            unlimited,
                            contact
                        ]
                    }
                ]
            },
            {
                title: "branding.title",
                rows: [
                    {
                        name: customDomain,
                        data: [
                            "✓",
                            "✓",
                            "✓"
                        ]
                    },
                    {
                        name: customCss,
                        data: [
                            "✓",
                            "✓",
                            "✓"
                        ]
                    },
                    {
                        name: appLogoAndFavicon,
                        data: [
                            "✓",
                            "✓",
                            "✓"
                        ]
                    },
                    {
                        name: darkMode,
                        data: [
                            "✓",
                            "✓",
                            "✓"
                        ]
                    },
                    {
                        name: i18n,
                        data: [
                            "✓",
                            "✓",
                            "✓"
                        ]
                    }
                ]
            },
            {
                title: "user_authn.title",
                rows: [
                    {
                        name: omniSignIn,
                        data: [
                            "✓",
                            "✓",
                            "✓"
                        ]
                    },
                    {
                        name: password,
                        data: [
                            "✓",
                            "✓",
                            "✓"
                        ]
                    },
                    {
                        name: passwordless,
                        data: [
                            "✓",
                            "✓",
                            "✓"
                        ]
                    },
                    {
                        name: emailConnector,
                        data: [
                            "✓",
                            "✓",
                            "✓"
                        ]
                    },
                    {
                        name: smsConnector,
                        data: [
                            "✓",
                            "✓",
                            "✓"
                        ]
                    },
                    {
                        name: socialConnectors,
                        data: [
                            "3",
                            unlimited,
                            contact
                        ]
                    },
                    {
                        name: sso,
                        data: [
                            "-",
                            `${ssoPrice}|${paidAddOnFeatureTip}|${addOn}`,
                            contact
                        ]
                    },
                    {
                        name: mfa,
                        data: [
                            "-",
                            `${mfaPrice}|${paidAddOnFeatureTip}|${addOn}`,
                            contact
                        ]
                    },
                    {
                        name: adaptiveMfa,
                        data: [
                            "-",
                            comingSoon,
                            contact
                        ]
                    }
                ]
            },
            {
                title: "user_management.title",
                rows: [
                    {
                        name: userManagement,
                        data: [
                            "✓",
                            "✓",
                            "✓"
                        ]
                    },
                    {
                        name: userRoles,
                        data: [
                            `${(0, $217fd4972b445457$export$a712ffd25223db9f)}`,
                            unlimited,
                            contact
                        ]
                    },
                    {
                        name: m2mRoles,
                        data: [
                            "1",
                            unlimited,
                            contact
                        ]
                    },
                    {
                        name: permissionsPerRole,
                        data: [
                            `${(0, $217fd4972b445457$export$134386eb2e2226bd)}`,
                            unlimited,
                            contact
                        ]
                    }
                ]
            },
            {
                title: "organizations.title",
                rows: [
                    {
                        name: organization,
                        data: [
                            "-",
                            `${orgPrice}|${paidAddOnFeatureTip}|${addOn}`,
                            contact
                        ]
                    },
                    {
                        name: orgCount,
                        data: [
                            "-",
                            unlimited,
                            contact
                        ]
                    },
                    {
                        name: allowedUsersPerOrg,
                        data: [
                            "-",
                            unlimited,
                            contact
                        ]
                    },
                    {
                        name: invitation,
                        data: [
                            "-",
                            comingSoon,
                            contact
                        ]
                    },
                    {
                        name: orgRoles,
                        data: [
                            "-",
                            unlimited,
                            contact
                        ]
                    },
                    {
                        name: orgPermissions,
                        data: [
                            "-",
                            unlimited,
                            contact
                        ]
                    },
                    {
                        name: jitProvisioning,
                        data: [
                            "-",
                            comingSoon,
                            comingSoon
                        ]
                    }
                ]
            },
            {
                title: "developers_and_platform.title",
                rows: [
                    {
                        name: webhooks,
                        data: [
                            "1",
                            "10",
                            contact
                        ]
                    },
                    {
                        name: auditLogRetention,
                        data: [
                            freePlanLogRetention,
                            paidPlanLogRetention,
                            contact
                        ]
                    },
                    {
                        name: jwtClaims,
                        data: [
                            "-",
                            "✓",
                            contact
                        ]
                    },
                    {
                        name: tenantMembers,
                        data: [
                            "1",
                            `${tenantMembersLimit}|${paidAddOnFeatureTip}|${tenantMembersPrice}`,
                            contact
                        ]
                    }
                ]
            },
            {
                title: "support.title",
                rows: [
                    {
                        name: community,
                        data: [
                            "✓",
                            "✓",
                            "✓"
                        ]
                    },
                    {
                        name: emailTicketSupport,
                        data: [
                            "-",
                            "✓ (48h)",
                            contact
                        ]
                    },
                    {
                        name: soc2Report,
                        data: [
                            "-",
                            comingSoon,
                            comingSoon
                        ]
                    },
                    {
                        name: hipaaOrBaaReport,
                        data: [
                            "-",
                            "-",
                            comingSoon
                        ]
                    }
                ]
            }
        ];
    }, [
        adminConsoleTranslation,
        t
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: $a04b5a01ba6be0c0$export$34e0f9847d4c02dd,
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)("table", {
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $C7mD2.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("th", {}),
                            $ad0bd470b4bcb6dd$var$featuredPlanPhraseKey.map((key)=>/*#__PURE__*/ (0, $C7mD2.jsx)("th", {
                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                        forKey: key
                                    })
                                }, key))
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)("tbody", {
                    children: tables.map(({ title: title, rows: rows })=>/*#__PURE__*/ (0, $C7mD2.jsxs)((0, $jC8Vy.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $C7mD2.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)("td", {
                                        colSpan: 4,
                                        className: $a04b5a01ba6be0c0$export$808794a1efddf200,
                                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                            forKey: `subscription.quota_table.${title}`
                                        })
                                    })
                                }),
                                rows.map(({ name: name, data: data })=>/*#__PURE__*/ (0, $C7mD2.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $C7mD2.jsx)("td", {
                                                className: $a04b5a01ba6be0c0$export$658ddaa3f057c88,
                                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c1830193839d21ce$export$2e2bcd8739ae039), {
                                                    isLeftAligned: true,
                                                    value: name
                                                })
                                            }),
                                            data.map((value, index)=>// eslint-disable-next-line react/no-array-index-key
                                                /*#__PURE__*/ (0, $C7mD2.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c1830193839d21ce$export$2e2bcd8739ae039), {
                                                        value: value
                                                    })
                                                }, `${title}-${name}-${index}`))
                                        ]
                                    }, `${title}-${name}`))
                            ]
                        }, title))
                })
            ]
        })
    });
}
var $ad0bd470b4bcb6dd$export$2e2bcd8739ae039 = $ad0bd470b4bcb6dd$var$PlanComparisonTable;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $lXQZH = parcelRequire("lXQZH");

var $jC8Vy = parcelRequire("jC8Vy");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");


parcelRequire("8Mb3E");
var $cfL6o = parcelRequire("cfL6o");


var $cDKfs = parcelRequire("cDKfs");

var $jGWQ4 = parcelRequire("jGWQ4");

var $jbKqE = parcelRequire("jbKqE");

var $kBpQ2 = parcelRequire("kBpQ2");




var $C7mD2 = parcelRequire("C7mD2");


var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $7i2be = parcelRequire("7i2be");



var $66ixW = parcelRequire("66ixW");


var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $5UrGx = parcelRequire("5UrGx");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $d6fe448b2d830fe9$var$SvgDescendArrow = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M14 7.333a.666.666 0 0 0-.667.667v1.727l-4.193-4.2a.667.667 0 0 0-.947 0L6 7.727 2.473 4.193a.67.67 0 1 0-.946.947l4 4a.667.667 0 0 0 .946 0l2.194-2.2 3.726 3.727h-1.726a.667.667 0 1 0 0 1.333H14a.667.667 0 0 0 .667-.667V8A.667.667 0 0 0 14 7.333Z",
            fill: "#EB9918"
        })
    });
var $d6fe448b2d830fe9$export$2e2bcd8739ae039 = $d6fe448b2d830fe9$var$SvgDescendArrow;




var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");


var $66ixW = parcelRequire("66ixW");
const $38c3a1a1e1a11bb8$var$quotaItemPhraseKeyPrefix = "subscription.quota_item";
function $38c3a1a1e1a11bb8$var$QuotaItemPhrase({ quotaKey: quotaKey, quotaValue: quotaValue }) {
    const isUnlimited = quotaValue === null;
    const isNotCapable = quotaValue === 0 || quotaValue === false;
    const isLimited = Boolean(quotaValue);
    const phraseKey = (0, $7oDSS.cond)(isUnlimited && (0, $5e61eac35f83c4b0$export$835723acfb933c0e)[quotaKey]) ?? (0, $7oDSS.cond)(isNotCapable && (0, $5e61eac35f83c4b0$export$5fe02dd94d8940f2)[quotaKey]) ?? (0, $7oDSS.cond)(isLimited && (0, $5e61eac35f83c4b0$export$90b7c469260db368)[quotaKey]);
    if (!phraseKey) // Should not happen
    return null;
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
        forKey: `${$38c3a1a1e1a11bb8$var$quotaItemPhraseKeyPrefix}.${phraseKey}`,
        interpolation: (0, $7oDSS.cond)(isLimited && typeof quotaValue === "number" && {
            count: quotaValue
        })
    });
}
var $38c3a1a1e1a11bb8$export$2e2bcd8739ae039 = $38c3a1a1e1a11bb8$var$QuotaItemPhrase;


var $d056aed180083b76$export$a7db06668cad9adb;
var $d056aed180083b76$export$1ca1ec8b29a4ce27;
var $d056aed180083b76$export$720b8f44838407cf;
var $d056aed180083b76$export$6f6aa1b1ff781f2c;
var $d056aed180083b76$export$f89bf2933e25d212;
var $d056aed180083b76$export$bfd64c937657f93a;
var $d056aed180083b76$export$4a6dd88bada4e7d2;
var $d056aed180083b76$export$5146850fc0ce88d1;
$d056aed180083b76$export$a7db06668cad9adb = `SQ3WJa_content`;
$d056aed180083b76$export$1ca1ec8b29a4ce27 = `SQ3WJa_icon`;
$d056aed180083b76$export$720b8f44838407cf = `SQ3WJa_lineThrough`;
$d056aed180083b76$export$6f6aa1b1ff781f2c = `SQ3WJa_notCapable`;
$d056aed180083b76$export$f89bf2933e25d212 = `SQ3WJa_quotaListItem`;
$d056aed180083b76$export$bfd64c937657f93a = `SQ3WJa_rotating`;
$d056aed180083b76$export$4a6dd88bada4e7d2 = `SQ3WJa_shimmer`;
$d056aed180083b76$export$5146850fc0ce88d1 = `SQ3WJa_withIcon`;


function $49816c9a3c1727c7$var$DiffQuotaItem({ quotaKey: quotaKey, quotaValue: quotaValue, hasStatusIcon: hasStatusIcon }) {
    const isNotCapable = quotaValue === 0 || quotaValue === false;
    const DowngradeStatusIcon = isNotCapable ? (0, $10eea442689aa670$export$2e2bcd8739ae039) : (0, $d6fe448b2d830fe9$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $C7mD2.jsx)("li", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($d056aed180083b76$export$f89bf2933e25d212, hasStatusIcon && $d056aed180083b76$export$5146850fc0ce88d1),
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)("span", {
            className: $d056aed180083b76$export$a7db06668cad9adb,
            children: [
                (0, $7oDSS.cond)(hasStatusIcon && /*#__PURE__*/ (0, $C7mD2.jsx)(DowngradeStatusIcon, {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($d056aed180083b76$export$1ca1ec8b29a4ce27, isNotCapable && $d056aed180083b76$export$6f6aa1b1ff781f2c)
                })),
                /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                    className: (0, $7oDSS.cond)(isNotCapable && $d056aed180083b76$export$720b8f44838407cf),
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $38c3a1a1e1a11bb8$export$2e2bcd8739ae039), {
                        quotaKey: quotaKey,
                        quotaValue: quotaValue
                    })
                })
            ]
        })
    });
}
var $49816c9a3c1727c7$export$2e2bcd8739ae039 = $49816c9a3c1727c7$var$DiffQuotaItem;


var $906661fee340782f$export$fe1df2a5702de2ad;
var $906661fee340782f$export$bfd64c937657f93a;
var $906661fee340782f$export$4a6dd88bada4e7d2;
$906661fee340782f$export$fe1df2a5702de2ad = `THG6CW_planQuotaList`;
$906661fee340782f$export$bfd64c937657f93a = `THG6CW_rotating`;
$906661fee340782f$export$4a6dd88bada4e7d2 = `THG6CW_shimmer`;


function $4ea9a3d20c8666fc$var$PlanQuotaList({ entries: entries, isDowngradeTargetPlan: isDowngradeTargetPlan, className: className }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)("ul", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($906661fee340782f$export$fe1df2a5702de2ad, className),
        children: entries.map(([quotaKey, quotaValue])=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $49816c9a3c1727c7$export$2e2bcd8739ae039), {
                quotaKey: quotaKey,
                quotaValue: quotaValue,
                hasStatusIcon: isDowngradeTargetPlan
            }, quotaKey))
    });
}
var $4ea9a3d20c8666fc$export$2e2bcd8739ae039 = $4ea9a3d20c8666fc$var$PlanQuotaList;


var $f9b39ccd28417c2d$export$34e0f9847d4c02dd;
var $f9b39ccd28417c2d$export$bfd64c937657f93a;
var $f9b39ccd28417c2d$export$4a6dd88bada4e7d2;
var $f9b39ccd28417c2d$export$fb184b623420d9be;
$f9b39ccd28417c2d$export$34e0f9847d4c02dd = `iok-RW_container`;
$f9b39ccd28417c2d$export$bfd64c937657f93a = `iok-RW_rotating`;
$f9b39ccd28417c2d$export$4a6dd88bada4e7d2 = `iok-RW_shimmer`;
$f9b39ccd28417c2d$export$fb184b623420d9be = `iok-RW_title`;


function $fd04a38f3c63aeeb$var$PlanQuotaDiffCard({ planName: planName, quotaDiff: quotaDiff, isDowngradeTargetPlan: isDowngradeTargetPlan = false }) {
    // eslint-disable-next-line no-restricted-syntax
    const sortedEntries = (0, $jC8Vy.useMemo)(()=>Object.entries(quotaDiff).slice().sort(([preQuotaKey], [nextQuotaKey])=>(0, $116db580d0523aa2$export$b035e44d7bb4278f)((0, $43d5e1b5339ea79b$export$103450479c8ed1e3))(preQuotaKey, nextQuotaKey)), [
        quotaDiff
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $f9b39ccd28417c2d$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $f9b39ccd28417c2d$export$fb184b623420d9be,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                    components: {
                        name: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $161f1bf99d56f621$export$2e2bcd8739ae039), {
                            name: planName
                        })
                    },
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                        forKey: `subscription.downgrade_modal.${isDowngradeTargetPlan ? "after" : "before"}`
                    })
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4ea9a3d20c8666fc$export$2e2bcd8739ae039), {
                entries: sortedEntries,
                isDowngradeTargetPlan: isDowngradeTargetPlan
            })
        ]
    });
}
var $fd04a38f3c63aeeb$export$2e2bcd8739ae039 = $fd04a38f3c63aeeb$var$PlanQuotaDiffCard;


var $d78ad51d0c434f70$export$34e0f9847d4c02dd;
var $d78ad51d0c434f70$export$a7db06668cad9adb;
var $d78ad51d0c434f70$export$6d59db4903f20f7d;
var $d78ad51d0c434f70$export$bfd64c937657f93a;
var $d78ad51d0c434f70$export$4a6dd88bada4e7d2;
$d78ad51d0c434f70$export$34e0f9847d4c02dd = `_5Fvp8W_container`;
$d78ad51d0c434f70$export$a7db06668cad9adb = `_5Fvp8W_content`;
$d78ad51d0c434f70$export$6d59db4903f20f7d = `_5Fvp8W_description`;
$d78ad51d0c434f70$export$bfd64c937657f93a = `_5Fvp8W_rotating`;
$d78ad51d0c434f70$export$4a6dd88bada4e7d2 = `_5Fvp8W_shimmer`;


const $49d9cbfc9cf6c486$var$excludeComingSoonFeatures = (quotaDiff)=>{
    // eslint-disable-next-line no-restricted-syntax
    const entries = Object.entries(quotaDiff);
    return Object.fromEntries(entries.filter(([key])=>!(0, $43d5e1b5339ea79b$export$69143de3c73b76af).includes(key)));
};
function $49d9cbfc9cf6c486$var$DowngradeConfirmModalContent({ currentPlan: currentPlan, targetPlan: targetPlan }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { quota: currentQuota, name: currentPlanName } = currentPlan;
    const { quota: targetQuota, name: targetPlanName } = targetPlan;
    const currentQuotaDiff = (0, $jC8Vy.useMemo)(()=>$49d9cbfc9cf6c486$var$excludeComingSoonFeatures((0, $4532790fde323af4$export$2e2bcd8739ae039)(targetQuota, currentQuota)), [
        currentQuota,
        targetQuota
    ]);
    const targetQuotaDiff = (0, $jC8Vy.useMemo)(()=>$49d9cbfc9cf6c486$var$excludeComingSoonFeatures((0, $4532790fde323af4$export$2e2bcd8739ae039)(currentQuota, targetQuota)), [
        currentQuota,
        targetQuota
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $d78ad51d0c434f70$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $d78ad51d0c434f70$export$6d59db4903f20f7d,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                    components: {
                        targetName: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $161f1bf99d56f621$export$2e2bcd8739ae039), {
                            name: targetPlanName
                        }),
                        currentName: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $161f1bf99d56f621$export$2e2bcd8739ae039), {
                            name: currentPlanName
                        })
                    },
                    children: t("subscription.downgrade_modal.description")
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $d78ad51d0c434f70$export$a7db06668cad9adb,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fd04a38f3c63aeeb$export$2e2bcd8739ae039), {
                        planName: currentPlanName,
                        quotaDiff: currentQuotaDiff
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fd04a38f3c63aeeb$export$2e2bcd8739ae039), {
                        isDowngradeTargetPlan: true,
                        planName: targetPlanName,
                        quotaDiff: targetQuotaDiff
                    })
                ]
            })
        ]
    });
}
var $49d9cbfc9cf6c486$export$2e2bcd8739ae039 = $49d9cbfc9cf6c486$var$DowngradeConfirmModalContent;


var $b8ed168356f2181d$export$a2da573beea6475e;
var $b8ed168356f2181d$export$34e0f9847d4c02dd;
var $b8ed168356f2181d$export$bfd64c937657f93a;
var $b8ed168356f2181d$export$4a6dd88bada4e7d2;
$b8ed168356f2181d$export$a2da573beea6475e = `_7NtmNG_buttonLink`;
$b8ed168356f2181d$export$34e0f9847d4c02dd = `_7NtmNG_container`;
$b8ed168356f2181d$export$bfd64c937657f93a = `_7NtmNG_rotating`;
$b8ed168356f2181d$export$4a6dd88bada4e7d2 = `_7NtmNG_shimmer`;


function $0cc6792d9a4d5712$var$SwitchPlanActionBar({ currentSubscriptionPlanId: currentSubscriptionPlanId, subscriptionPlans: subscriptionPlans, onSubscriptionUpdated: onSubscriptionUpdated }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.subscription"
    });
    const { currentTenantId: currentTenantId } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { subscribe: subscribe, cancelSubscription: cancelSubscription } = (0, $699da2d1bc75044e$export$2e2bcd8739ae039)();
    const { show: show } = (0, $kBpQ2.useConfirmModal)();
    const [currentLoadingPlanId, setCurrentLoadingPlanId] = (0, $jC8Vy.useState)();
    const handleSubscribe = async (targetPlanId, isDowngrade)=>{
        if (currentLoadingPlanId) return;
        const currentPlan = subscriptionPlans.find(({ id: id })=>id === currentSubscriptionPlanId);
        const targetPlan = subscriptionPlans.find(({ id: id })=>id === targetPlanId);
        if (!currentPlan || !targetPlan) return;
        if (isDowngrade) {
            const [result] = await show({
                ModalContent: ()=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $49d9cbfc9cf6c486$export$2e2bcd8739ae039), {
                        currentPlan: currentPlan,
                        targetPlan: targetPlan
                    }),
                title: "subscription.downgrade_modal.title",
                confirmButtonText: "subscription.downgrade_modal.downgrade",
                size: "large"
            });
            if (!result) return;
        }
        try {
            setCurrentLoadingPlanId(targetPlanId);
            if (targetPlanId === (0, $lXQZH.ReservedPlanId).Free) {
                await cancelSubscription(currentTenantId);
                await onSubscriptionUpdated();
                (0, $FuhPC.toast).success(/*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                    components: {
                        name: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $161f1bf99d56f621$export$2e2bcd8739ae039), {
                            name: targetPlan.name
                        })
                    },
                    children: t("downgrade_success")
                }));
                return;
            }
            await subscribe({
                tenantId: currentTenantId,
                planId: targetPlanId,
                isDowngrade: isDowngrade,
                callbackPage: (0, $b2864970cb73ddbd$export$6d940d0d58a60bc4)
            });
        } catch (error) {
            setCurrentLoadingPlanId(undefined);
            const [result, exceededQuotaKeys] = await (0, $b38537f440ba3476$export$c0ed1fa5d8f3e3a5)(error);
            if (result) {
                await show({
                    ModalContent: ()=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $e6ddd306f0f7c511$export$2e2bcd8739ae039), {
                            targetPlan: targetPlan,
                            isDowngrade: isDowngrade,
                            exceededQuotaKeys: exceededQuotaKeys
                        }),
                    title: isDowngrade ? "subscription.not_eligible_modal.downgrade_title" : "subscription.not_eligible_modal.upgrade_title",
                    confirmButtonText: "general.got_it",
                    confirmButtonType: "primary",
                    isCancelButtonVisible: false
                });
                return;
            }
            (0, $1c34cc51be8c93d3$export$10abc8714a7caf54)(error);
        } finally{
            setCurrentLoadingPlanId(undefined);
        }
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $b8ed168356f2181d$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jbKqE.default), {}),
            subscriptionPlans.map(({ id: planId })=>{
                const isCurrentPlan = currentSubscriptionPlanId === planId;
                const isDowngrade = (0, $b38537f440ba3476$export$64dac4cdd03b50e1)(currentSubscriptionPlanId, planId);
                return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        title: isCurrentPlan ? "subscription.current" : isDowngrade ? "subscription.downgrade" : "subscription.upgrade",
                        type: isDowngrade ? "default" : "primary",
                        disabled: isCurrentPlan,
                        isLoading: !isCurrentPlan && currentLoadingPlanId === planId,
                        onClick: ()=>{
                            handleSubscribe(planId, isDowngrade);
                        }
                    })
                }, planId);
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("a", {
                    href: (0, $cfL6o.contactEmailLink),
                    className: $b8ed168356f2181d$export$a2da573beea6475e,
                    rel: "noopener",
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        title: "general.contact_us_action",
                        type: "primary"
                    })
                })
            })
        ]
    });
}
var $0cc6792d9a4d5712$export$2e2bcd8739ae039 = $0cc6792d9a4d5712$var$SwitchPlanActionBar;


var $50f3aa0bbf198a98$export$34e0f9847d4c02dd;
var $50f3aa0bbf198a98$export$bfd64c937657f93a;
var $50f3aa0bbf198a98$export$4a6dd88bada4e7d2;
$50f3aa0bbf198a98$export$34e0f9847d4c02dd = `Av1axa_container`;
$50f3aa0bbf198a98$export$bfd64c937657f93a = `Av1axa_rotating`;
$50f3aa0bbf198a98$export$4a6dd88bada4e7d2 = `Av1axa_shimmer`;


function $900a19e2db100a3b$var$Subscription() {
    const { currentTenantId: currentTenantId } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { subscriptionPlans: subscriptionPlans, currentPlan: currentPlan, currentSubscription: currentSubscription, onCurrentSubscriptionUpdated: onCurrentSubscriptionUpdated } = (0, $jC8Vy.useContext)((0, $19434c930f80c964$export$f8addfd4ab69c833));
    const { data: subscriptionUsage, isLoading: isLoading, mutate: mutateSubscriptionUsage } = (0, $4aea7ad51d438a6c$export$2e2bcd8739ae039)(currentTenantId);
    const reservedPlans = (0, $b38537f440ba3476$export$1673a249ab23858e)(subscriptionPlans);
    if (isLoading) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6b1e34b0104d3805$export$2e2bcd8739ae039), {});
    if (!subscriptionUsage) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $50f3aa0bbf198a98$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5TsIB.default), {
                titleKey: [
                    "tenants.tabs.subscription",
                    "tenants.title"
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3ecaddd4a6fa09fb$export$2e2bcd8739ae039), {
                subscription: currentSubscription,
                subscriptionPlan: currentPlan,
                subscriptionUsage: subscriptionUsage
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ad0bd470b4bcb6dd$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0cc6792d9a4d5712$export$2e2bcd8739ae039), {
                currentSubscriptionPlanId: currentSubscription.planId,
                subscriptionPlans: reservedPlans,
                onSubscriptionUpdated: async ()=>{
                    /**
           * The upcoming billing info is calculated based on the current subscription usage,
           * and the usage is based on the current subscription plan,
           * need to manually trigger the usage update while the subscription plan is changed.
           */ onCurrentSubscriptionUpdated();
                    await mutateSubscriptionUsage();
                }
            })
        ]
    });
}
var $900a19e2db100a3b$export$2e2bcd8739ae039 = $900a19e2db100a3b$var$Subscription;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $lXQZH = parcelRequire("lXQZH");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");


var $5TsIB = parcelRequire("5TsIB");



var $cDKfs = parcelRequire("cDKfs");

var $kBpQ2 = parcelRequire("kBpQ2");


var $5OcFi = parcelRequire("5OcFi");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $6hxiJ = parcelRequire("6hxiJ");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");


var $jGWQ4 = parcelRequire("jGWQ4");

var $aqmjm = parcelRequire("aqmjm");
var $27a585e9e4616ffe$export$c820a656c5e396da;
var $27a585e9e4616ffe$export$6d59db4903f20f7d;
var $27a585e9e4616ffe$export$bfd64c937657f93a;
var $27a585e9e4616ffe$export$4a6dd88bada4e7d2;
$27a585e9e4616ffe$export$c820a656c5e396da = `Wld4Dq_deletionButtonContainer`;
$27a585e9e4616ffe$export$6d59db4903f20f7d = `Wld4Dq_description`;
$27a585e9e4616ffe$export$bfd64c937657f93a = `Wld4Dq_rotating`;
$27a585e9e4616ffe$export$4a6dd88bada4e7d2 = `Wld4Dq_shimmer`;


function $262befd2e8eba9ef$var$DeleteCard({ currentTenantId: currentTenantId, onClick: onClick }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
        title: "tenants.deletion_card.title",
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
            title: "tenants.deletion_card.tenant_deletion",
            children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $27a585e9e4616ffe$export$c820a656c5e396da,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $27a585e9e4616ffe$export$6d59db4903f20f7d,
                        children: t("tenants.deletion_card.tenant_deletion_description")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        type: "default",
                        title: "tenants.deletion_card.tenant_deletion_button",
                        disabled: [
                            (0, $6hxiJ.adminTenantId)
                        ].includes(currentTenantId),
                        onClick: onClick
                    })
                ]
            })
        })
    });
}
var $262befd2e8eba9ef$export$2e2bcd8739ae039 = $262befd2e8eba9ef$var$DeleteCard;



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");



var $529cd8ce8ea2b6ed$export$73ba5813cda80a49;
var $529cd8ce8ea2b6ed$export$a7db06668cad9adb;
var $529cd8ce8ea2b6ed$export$a71f3c3c51e55058;
var $529cd8ce8ea2b6ed$export$6d59db4903f20f7d;
var $529cd8ce8ea2b6ed$export$e4043f67d36cbb26;
var $529cd8ce8ea2b6ed$export$bfd64c937657f93a;
var $529cd8ce8ea2b6ed$export$4a6dd88bada4e7d2;
$529cd8ce8ea2b6ed$export$73ba5813cda80a49 = `yuWCpq_bold`;
$529cd8ce8ea2b6ed$export$a7db06668cad9adb = `yuWCpq_content`;
$529cd8ce8ea2b6ed$export$a71f3c3c51e55058 = `yuWCpq_deleteConfirmModal`;
$529cd8ce8ea2b6ed$export$6d59db4903f20f7d = `yuWCpq_description`;
$529cd8ce8ea2b6ed$export$e4043f67d36cbb26 = `yuWCpq_highlight`;
$529cd8ce8ea2b6ed$export$bfd64c937657f93a = `yuWCpq_rotating`;
$529cd8ce8ea2b6ed$export$4a6dd88bada4e7d2 = `yuWCpq_shimmer`;


function $1d720e46300d9950$var$DeleteModal({ isOpen: isOpen, isLoading: isLoading, onClose: onClose, onDelete: onDelete, tenant: tenant }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { name: name, tag: tag } = tenant;
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7065f4e52ae4e862$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        isLoading: isLoading,
        expectedInput: name,
        inputPlaceholder: name,
        className: $529cd8ce8ea2b6ed$export$a71f3c3c51e55058,
        title: "tenants.delete_modal.title",
        confirmButtonText: "tenants.delete_modal.delete_button",
        onCancel: onClose,
        onConfirm: onDelete,
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($529cd8ce8ea2b6ed$export$6d59db4903f20f7d, $529cd8ce8ea2b6ed$export$a7db06668cad9adb),
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsx)("p", {
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                        components: {
                            span: /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                                className: $529cd8ce8ea2b6ed$export$73ba5813cda80a49
                            })
                        },
                        children: t("tenants.delete_modal.description_line1", {
                            name: name,
                            tag: t((0, $7e60916f61ffa7e7$export$ae9becdfc4a807ab)[tag], {})
                        })
                    })
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)("p", {
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                        components: {
                            span: /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                                className: $529cd8ce8ea2b6ed$export$e4043f67d36cbb26
                            }),
                            a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a3bc63325dc3c1a8$export$2e2bcd8739ae039), {})
                        },
                        children: t("tenants.delete_modal.description_line2")
                    })
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)("p", {
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                        components: {
                            span: /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                                className: $529cd8ce8ea2b6ed$export$73ba5813cda80a49
                            })
                        },
                        children: t("tenants.delete_modal.description_line3", {
                            name: name
                        })
                    })
                })
            ]
        })
    });
}
var $1d720e46300d9950$export$2e2bcd8739ae039 = $1d720e46300d9950$var$DeleteModal;



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");



var $cDKfs = parcelRequire("cDKfs");

var $jGWQ4 = parcelRequire("jGWQ4");

var $aqmjm = parcelRequire("aqmjm");

var $kBpQ2 = parcelRequire("kBpQ2");

var $44587b7a08f989e8$export$34e0f9847d4c02dd;
var $44587b7a08f989e8$export$6d59db4903f20f7d;
var $44587b7a08f989e8$export$bfd64c937657f93a;
var $44587b7a08f989e8$export$4a6dd88bada4e7d2;
$44587b7a08f989e8$export$34e0f9847d4c02dd = `lX_4PW_container`;
$44587b7a08f989e8$export$6d59db4903f20f7d = `lX_4PW_description`;
$44587b7a08f989e8$export$bfd64c937657f93a = `lX_4PW_rotating`;
$44587b7a08f989e8$export$4a6dd88bada4e7d2 = `lX_4PW_shimmer`;


function $11e8f228d3991313$var$LeaveCard() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { show: showModal } = (0, $kBpQ2.useConfirmModal)();
    const api = (0, $1c34cc51be8c93d3$export$ec1abe76789cde12)();
    const { currentTenantId: currentTenantId, removeTenant: removeTenant, navigateTenant: navigateTenant } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { user: user } = (0, $8dc2d4d6918e57ba$export$2e2bcd8739ae039)();
    const [isLoading, setIsLoading] = (0, $jC8Vy.useState)(false);
    const onClickLeave = async ()=>{
        const [confirm] = await showModal({
            ModalContent: t("tenants.leave_tenant_modal.description"),
            type: "confirm",
            confirmButtonText: "tenants.leave_tenant_modal.leave_button"
        });
        if (!confirm || !user) return;
        setIsLoading(true);
        try {
            await api.delete(`/api/tenants/:tenantId/members/:userId`, {
                params: {
                    tenantId: currentTenantId,
                    userId: user.id
                }
            });
            removeTenant(currentTenantId);
            navigateTenant("");
        } finally{
            setIsLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
        title: "tenants.leave_tenant_card.leave_tenant",
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
            title: "tenants.leave_tenant_card.leave_tenant",
            children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $44587b7a08f989e8$export$34e0f9847d4c02dd,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $44587b7a08f989e8$export$6d59db4903f20f7d,
                        children: t("tenants.leave_tenant_card.leave_tenant_description")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        type: "default",
                        title: "tenants.leave_tenant_card.leave_tenant",
                        isLoading: isLoading,
                        onClick: onClickLeave
                    })
                ]
            })
        })
    });
}
var $11e8f228d3991313$export$2e2bcd8739ae039 = $11e8f228d3991313$var$LeaveCard;



var $C7mD2 = parcelRequire("C7mD2");

var $codQP = parcelRequire("codQP");


var $cw2No = parcelRequire("cw2No");

var $aqmjm = parcelRequire("aqmjm");

var $fmHmG = parcelRequire("fmHmG");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $iq1sR = parcelRequire("iq1sR");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

parcelRequire("8Mb3E");
var $cfL6o = parcelRequire("cfL6o");

var $9Q3SI = parcelRequire("9Q3SI");

var $b2d298b491109912$export$34e0f9847d4c02dd;
var $b2d298b491109912$export$6d59db4903f20f7d;
var $b2d298b491109912$export$bfd64c937657f93a;
var $b2d298b491109912$export$4a6dd88bada4e7d2;
$b2d298b491109912$export$34e0f9847d4c02dd = `IFpuaG_container`;
$b2d298b491109912$export$6d59db4903f20f7d = `IFpuaG_description`;
$b2d298b491109912$export$bfd64c937657f93a = `IFpuaG_rotating`;
$b2d298b491109912$export$4a6dd88bada4e7d2 = `IFpuaG_shimmer`;


function $30e2606c76af0be6$var$TenantEnvironment({ tag: tag }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $b595fc2f0eccd19a$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $b2d298b491109912$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7e60916f61ffa7e7$export$2e2bcd8739ae039), {
                isAbbreviated: false,
                size: "large",
                tag: tag
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $b2d298b491109912$export$6d59db4903f20f7d,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                    components: {
                        a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                            targetBlank: "noopener",
                            href: getDocumentationUrl((0, $cfL6o.envTagsFeatureLink))
                        })
                    },
                    children: t(tag === (0, $iq1sR.TenantTag).Development ? "tenants.settings.development_description" : "tenants.settings.production_description")
                })
            })
        ]
    });
}
var $30e2606c76af0be6$export$2e2bcd8739ae039 = $30e2606c76af0be6$var$TenantEnvironment;



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $56db5 = parcelRequire("56db5");
parcelRequire("8Mb3E");
var $cfL6o = parcelRequire("cfL6o");

var $cDKfs = parcelRequire("cDKfs");

var $9Q3SI = parcelRequire("9Q3SI");
var $b28998d4fa97a848$export$34e0f9847d4c02dd;
var $b28998d4fa97a848$export$9b1a70c9ede163e;
var $b28998d4fa97a848$export$89db558d656a76ad;
var $b28998d4fa97a848$export$bfd64c937657f93a;
var $b28998d4fa97a848$export$4a6dd88bada4e7d2;
$b28998d4fa97a848$export$34e0f9847d4c02dd = `_3Smarq_container`;
$b28998d4fa97a848$export$9b1a70c9ede163e = `_3Smarq_region`;
$b28998d4fa97a848$export$89db558d656a76ad = `_3Smarq_regionTip`;
$b28998d4fa97a848$export$bfd64c937657f93a = `_3Smarq_rotating`;
$b28998d4fa97a848$export$4a6dd88bada4e7d2 = `_3Smarq_shimmer`;


function $6d6de969292542ab$var$TenantRegion() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { currentTenant: currentTenant } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const regionName = currentTenant?.regionName;
    if (!regionName) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $b28998d4fa97a848$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $56db5.default), {
                className: $b28998d4fa97a848$export$9b1a70c9ede163e,
                regionName: regionName
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $b28998d4fa97a848$export$89db558d656a76ad,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                    components: {
                        a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                            targetBlank: "noopener",
                            href: (0, $cfL6o.trustAndSecurityLink)
                        })
                    },
                    children: t("tenants.settings.tenant_region_tip", {
                        region: regionName
                    })
                })
            })
        ]
    });
}
var $6d6de969292542ab$export$2e2bcd8739ae039 = $6d6de969292542ab$var$TenantRegion;


function $fb324f5a39c0dae8$var$ProfileForm({ currentTenantId: currentTenantId }) {
    const { access: { canManageTenant: canManageTenant } } = (0, $1f7ad510e5c2dafe$export$2e2bcd8739ae039)();
    const { register: register, formState: { errors: errors }, getValues: getValues } = (0, $codQP.useFormContext)();
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
        title: "tenants.settings.title",
        description: "tenants.settings.description",
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: "tenants.settings.tenant_id",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
                    displayType: "block",
                    value: currentTenantId,
                    variant: "border"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                isRequired: true,
                title: "tenants.settings.tenant_name",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                    ...register("profile.name", {
                        required: true
                    }),
                    readOnly: !canManageTenant,
                    error: Boolean(errors.profile?.name)
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: "tenants.settings.tenant_region",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6d6de969292542ab$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: "tenants.settings.tenant_type",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $30e2606c76af0be6$export$2e2bcd8739ae039), {
                    tag: getValues("profile.tag")
                })
            })
        ]
    });
}
var $fb324f5a39c0dae8$export$2e2bcd8739ae039 = $fb324f5a39c0dae8$var$ProfileForm;


var $016661b1647a8994$export$34e0f9847d4c02dd;
var $016661b1647a8994$export$4dbdc8f16fed8a34;
var $016661b1647a8994$export$bfd64c937657f93a;
var $016661b1647a8994$export$4a6dd88bada4e7d2;
var $016661b1647a8994$export$1258c5dd981c51cf;
$016661b1647a8994$export$34e0f9847d4c02dd = `tIHRNq_container`;
$016661b1647a8994$export$4dbdc8f16fed8a34 = `tIHRNq_fields`;
$016661b1647a8994$export$bfd64c937657f93a = `tIHRNq_rotating`;
$016661b1647a8994$export$4a6dd88bada4e7d2 = `tIHRNq_shimmer`;
$016661b1647a8994$export$1258c5dd981c51cf = `tIHRNq_withSubmitActionBar`;


function $1545fe05b0773baa$var$TenantBasicSettings() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { access: { canManageTenant: canManageTenant } } = (0, $1f7ad510e5c2dafe$export$2e2bcd8739ae039)();
    const api = (0, $1c34cc51be8c93d3$export$7a5c900790855d66)();
    const { currentTenant: currentTenant, currentTenantId: currentTenantId, isDevTenant: isDevTenant, updateTenant: updateTenant, removeTenant: removeTenant, navigateTenant: navigateTenant } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const [isDeletionModalOpen, setIsDeletionModalOpen] = (0, $jC8Vy.useState)(false);
    const [isDeleting, setIsDeleting] = (0, $jC8Vy.useState)(false);
    const { show: showModal } = (0, $kBpQ2.useConfirmModal)();
    const methods = (0, $codQP.useForm)({
        defaultValues: {
            profile: currentTenant
        }
    });
    const { watch: watch, reset: reset, handleSubmit: handleSubmit, formState: { isDirty: isDirty, isSubmitting: isSubmitting } } = methods;
    (0, $jC8Vy.useEffect)(()=>{
        reset({
            profile: currentTenant
        });
    }, [
        currentTenant,
        reset
    ]);
    const saveData = async (data)=>{
        const { name: name, tag: tag } = await api.patch(`/api/tenants/:tenantId`, {
            params: {
                tenantId: currentTenantId
            },
            body: data
        });
        reset({
            profile: {
                name: name,
                tag: tag
            }
        });
        (0, $FuhPC.toast).success(t("tenants.settings.tenant_info_saved"));
        updateTenant(currentTenantId, data);
    };
    const onSubmit = handleSubmit((0, $5OcFi.trySubmitSafe)(async (formData)=>{
        if (isSubmitting) return;
        const { profile: { name: name, tag: tag } } = formData;
        await saveData({
            name: name,
            tag: tag
        });
    }));
    const onClickDeletionButton = async ()=>{
        if (!isDevTenant && (currentTenant?.subscription.planId !== (0, $lXQZH.ReservedPlanId).Free || currentTenant.openInvoices.length > 0)) {
            await showModal({
                title: "tenants.delete_modal.cannot_delete_title",
                ModalContent: t("tenants.delete_modal.cannot_delete_description"),
                type: "alert",
                cancelButtonText: "general.got_it"
            });
            return;
        }
        setIsDeletionModalOpen(true);
    };
    const onDelete = async ()=>{
        if (isDeleting) return;
        setIsDeleting(true);
        try {
            await api.delete(`/api/tenants/:tenantId`, {
                params: {
                    tenantId: currentTenantId
                }
            });
            setIsDeletionModalOpen(false);
            removeTenant(currentTenantId);
            navigateTenant("");
        } finally{
            setIsDeleting(false);
        }
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5TsIB.default), {
                titleKey: [
                    "tenants.tabs.settings",
                    "tenants.title"
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("form", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($016661b1647a8994$export$34e0f9847d4c02dd, isDirty && $016661b1647a8994$export$1258c5dd981c51cf),
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.FormProvider), {
                        ...methods,
                        children: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                            className: $016661b1647a8994$export$4dbdc8f16fed8a34,
                            children: [
                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fb324f5a39c0dae8$export$2e2bcd8739ae039), {
                                    currentTenantId: currentTenantId
                                }),
                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $11e8f228d3991313$export$2e2bcd8739ae039), {}),
                                canManageTenant && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $262befd2e8eba9ef$export$2e2bcd8739ae039), {
                                    currentTenantId: currentTenantId,
                                    onClick: onClickDeletionButton
                                })
                            ]
                        })
                    }),
                    canManageTenant && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $41b73519a7034b3a$export$2e2bcd8739ae039), {
                        isOpen: isDirty,
                        isSubmitting: isSubmitting,
                        onDiscard: reset,
                        onSubmit: onSubmit
                    })
                ]
            }),
            canManageTenant && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fea55fa5d5726e29$export$2e2bcd8739ae039), {
                        hasUnsavedChanges: isDirty
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1d720e46300d9950$export$2e2bcd8739ae039), {
                        isOpen: isDeletionModalOpen,
                        isLoading: isDeleting,
                        tenant: watch("profile"),
                        onClose: ()=>{
                            setIsDeletionModalOpen(false);
                        },
                        onDelete: onDelete
                    })
                ]
            })
        ]
    });
}
var $1545fe05b0773baa$export$2e2bcd8739ae039 = $1545fe05b0773baa$var$TenantBasicSettings;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $3zL0M = parcelRequire("3zL0M");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");


var $5TsIB = parcelRequire("5TsIB");

var $aqmjm = parcelRequire("aqmjm");

var $9Q3SI = parcelRequire("9Q3SI");

var $7VnwS = parcelRequire("7VnwS");


var $lWGA3 = parcelRequire("lWGA3");





var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $fG7L1 = parcelRequire("fG7L1");

var $cw2No = parcelRequire("cw2No");

var $66ixW = parcelRequire("66ixW");

var $jbKqE = parcelRequire("jbKqE");

var $17455f856bf9b256$export$34e0f9847d4c02dd;
var $17455f856bf9b256$export$21779e503be4cd98;
var $17455f856bf9b256$export$bfd64c937657f93a;
var $17455f856bf9b256$export$4a6dd88bada4e7d2;
$17455f856bf9b256$export$34e0f9847d4c02dd = `Ju3gQq_container`;
$17455f856bf9b256$export$21779e503be4cd98 = `Ju3gQq_domain`;
$17455f856bf9b256$export$bfd64c937657f93a = `Ju3gQq_rotating`;
$17455f856bf9b256$export$4a6dd88bada4e7d2 = `Ju3gQq_shimmer`;


function $9e5013dba347cdfa$var$DefaultDomain() {
    const { tenantEndpoint: tenantEndpoint } = (0, $jC8Vy.useContext)((0, $fG7L1.AppDataContext));
    if (!tenantEndpoint) return null;
    const { host: host } = tenantEndpoint;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $17455f856bf9b256$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $17455f856bf9b256$export$21779e503be4cd98,
                children: host
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
                status: "success",
                type: "state",
                variant: "plain",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                    forKey: "domain.status.in_use"
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jbKqE.default), {}),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
                value: host,
                variant: "icon"
            })
        ]
    });
}
var $9e5013dba347cdfa$export$2e2bcd8739ae039 = $9e5013dba347cdfa$var$DefaultDomain;


var $0529cd4ddcb86afc$export$34e0f9847d4c02dd;
var $0529cd4ddcb86afc$export$fff9cb9cb797a870;
var $0529cd4ddcb86afc$export$bfd64c937657f93a;
var $0529cd4ddcb86afc$export$4a6dd88bada4e7d2;
var $0529cd4ddcb86afc$export$a8bf3124b60187b4;
$0529cd4ddcb86afc$export$34e0f9847d4c02dd = `SzQhjG_container`;
$0529cd4ddcb86afc$export$fff9cb9cb797a870 = `SzQhjG_notes`;
$0529cd4ddcb86afc$export$bfd64c937657f93a = `SzQhjG_rotating`;
$0529cd4ddcb86afc$export$4a6dd88bada4e7d2 = `SzQhjG_shimmer`;
$0529cd4ddcb86afc$export$a8bf3124b60187b4 = `SzQhjG_upsellNotification`;


function $8ab77cd24a89aec5$var$TenantDomainSettings() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: customDomain, isLoading: isLoadingCustomDomain, mutate: mutate } = (0, $lWGA3.default)(true);
    const { getDocumentationUrl: getDocumentationUrl } = (0, $b595fc2f0eccd19a$export$2e2bcd8739ae039)();
    const api = (0, $7VnwS.default)();
    const { access: { canManageTenant: canManageTenant } } = (0, $1f7ad510e5c2dafe$export$2e2bcd8739ae039)();
    if (isLoadingCustomDomain) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6b1e34b0104d3805$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $0529cd4ddcb86afc$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5TsIB.default), {
                titleKey: [
                    "tenants.tabs.domains",
                    "tenants.title"
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
                title: "domain.custom.custom_domain",
                description: "domain.custom.custom_domain_description",
                learnMoreLink: {
                    href: getDocumentationUrl("docs/recipes/custom-domain"),
                    targetBlank: "noopener"
                },
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aqmjm.default), {
                    title: "domain.custom.custom_domain_field",
                    children: [
                        customDomain ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $96b2faa7a8fc7f6f$export$2e2bcd8739ae039), {
                            hasExtraTipsOnDelete: true,
                            isReadonly: !canManageTenant,
                            customDomain: customDomain,
                            onDeleteCustomDomain: async ()=>{
                                await api.delete(`api/domains/${customDomain.id}`);
                                mutate();
                            }
                        }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5c429530f327e55f$export$2e2bcd8739ae039), {
                            isReadonly: !canManageTenant,
                            onSubmitCustomDomain: async (json)=>{
                                const createdDomain = await api.post("api/domains", {
                                    json: json
                                }).json();
                                mutate(createdDomain);
                            }
                        }),
                        customDomain?.status === (0, $3zL0M.DomainStatus).Active && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $0529cd4ddcb86afc$export$fff9cb9cb797a870,
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                                components: {
                                    a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9Q3SI.default), {
                                        targetBlank: "noopener",
                                        to: getDocumentationUrl("docs/recipes/custom-domain/use-custom-domain")
                                    })
                                },
                                children: t("domain.update_endpoint_notice", {
                                    link: t("general.learn_more")
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
                title: "domain.default.default_domain",
                description: "domain.default.default_domain_description",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                    title: "domain.default.default_domain_field",
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9e5013dba347cdfa$export$2e2bcd8739ae039), {})
                })
            })
        ]
    });
}
var $8ab77cd24a89aec5$export$2e2bcd8739ae039 = $8ab77cd24a89aec5$var$TenantDomainSettings;



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $2Phw0 = parcelRequire("2Phw0");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("voszV");
var $hgWIN = parcelRequire("hgWIN");
var $voszV = parcelRequire("voszV");

var $hgWIN = parcelRequire("hgWIN");
const $3a3bd779b4a3a126$var$mutation = ()=>{
    return (key, fetcher, config = {})=>{
        const { mutate: mutate } = (0, $hgWIN.useSWRConfig)();
        const keyRef = (0, $jC8Vy.useRef)(key);
        const fetcherRef = (0, $jC8Vy.useRef)(fetcher);
        const configRef = (0, $jC8Vy.useRef)(config);
        // Ditch all mutation results that happened earlier than this timestamp.
        const ditchMutationsUntilRef = (0, $jC8Vy.useRef)(0);
        const [stateRef, stateDependencies, setState] = (0, $hgWIN.useStateWithDeps)({
            data: (0, $hgWIN.UNDEFINED),
            error: (0, $hgWIN.UNDEFINED),
            isMutating: false
        });
        const currentState = stateRef.current;
        const trigger = (0, $jC8Vy.useCallback)(async (arg, opts)=>{
            const [serializedKey, resolvedKey] = (0, $hgWIN.serialize)(keyRef.current);
            if (!fetcherRef.current) throw new Error("Can’t trigger the mutation: missing fetcher.");
            if (!serializedKey) throw new Error("Can’t trigger the mutation: missing key.");
            // Disable cache population by default.
            const options = (0, $hgWIN.mergeObjects)((0, $hgWIN.mergeObjects)({
                populateCache: false,
                throwOnError: true
            }, configRef.current), opts);
            // Trigger a mutation, and also track the timestamp. Any mutation that happened
            // earlier this timestamp should be ignored.
            const mutationStartedAt = (0, $hgWIN.getTimestamp)();
            ditchMutationsUntilRef.current = mutationStartedAt;
            setState({
                isMutating: true
            });
            try {
                const data = await mutate(serializedKey, fetcherRef.current(resolvedKey, {
                    arg: arg
                }), (0, $hgWIN.mergeObjects)(options, {
                    throwOnError: true
                }));
                // If it's reset after the mutation, we don't broadcast any state change.
                if (ditchMutationsUntilRef.current <= mutationStartedAt) {
                    setState({
                        data: data,
                        isMutating: false,
                        error: undefined
                    });
                    options.onSuccess == null || options.onSuccess(data, serializedKey, options);
                }
                return data;
            } catch (error) {
                // If it's reset after the mutation, we don't broadcast any state change
                // or throw because it's discarded.
                if (ditchMutationsUntilRef.current <= mutationStartedAt) {
                    setState({
                        error: error,
                        isMutating: false
                    });
                    options.onError == null || options.onError(error, serializedKey, options);
                    if (options.throwOnError) throw error;
                }
            }
        }, []);
        const reset = (0, $jC8Vy.useCallback)(()=>{
            ditchMutationsUntilRef.current = (0, $hgWIN.getTimestamp)();
            setState({
                data: (0, $hgWIN.UNDEFINED),
                error: (0, $hgWIN.UNDEFINED),
                isMutating: false
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        (0, $hgWIN.useIsomorphicLayoutEffect)(()=>{
            keyRef.current = key;
            fetcherRef.current = fetcher;
            configRef.current = config;
        });
        // We don't return `mutate` here as it can be pretty confusing (e.g. people
        // calling `mutate` but they actually mean `trigger`).
        // And also, `mutate` relies on the useSWR hook to exist too.
        return {
            trigger: trigger,
            reset: reset,
            get data () {
                stateDependencies.data = true;
                return currentState.data;
            },
            get error () {
                stateDependencies.error = true;
                return currentState.error;
            },
            get isMutating () {
                stateDependencies.isMutating = true;
                return currentState.isMutating;
            }
        };
    };
};
/**
 * A hook to define and manually trigger remote mutations like POST, PUT, DELETE and PATCH use cases.
 *
 * @link https://swr.vercel.app/docs/mutation
 * @example
 * ```jsx
 * import useSWRMutation from 'swr/mutation'
 *
 * const {
 *   data,
 *   error,
 *   trigger,
 *   reset,
 *   isMutating
 * } = useSWRMutation(key, fetcher, options?)
 * ```
 */ const $3a3bd779b4a3a126$export$2e2bcd8739ae039 = (0, $hgWIN.withMiddleware)((0, $voszV.default), $3a3bd779b4a3a126$var$mutation);



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $5fcae899439e915a$var$SvgInvitation = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M13.667 9.333A.667.667 0 0 0 13 10v2.667a.666.666 0 0 1-.667.666H3a.667.667 0 0 1-.667-.666V6.273l3.92 3.927a2 2 0 0 0 2.827 0l1.093-1.093a.67.67 0 1 0-.946-.947L8.133 9.253a.667.667 0 0 1-.933 0l-3.927-3.92h4.394a.667.667 0 1 0 0-1.333H3a2 2 0 0 0-2 2v6.667a2 2 0 0 0 2 2h9.333a2 2 0 0 0 2-2V10a.667.667 0 0 0-.666-.667Zm1.14-5.806-2-2a.667.667 0 0 0-.22-.14.667.667 0 0 0-.507 0 .667.667 0 0 0-.22.14l-2 2a.67.67 0 1 0 .947.946l.86-.866v3.726a.667.667 0 1 0 1.333 0V3.607l.86.866a.667.667 0 0 0 1.093-.217.668.668 0 0 0-.146-.73Z",
            fill: "currentColor"
        })
    });
var $5fcae899439e915a$export$2e2bcd8739ae039 = $5fcae899439e915a$var$SvgInvitation;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $6fd9356f8e9e9de6$var$SvgMembers = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M8.2 8.147a3.28 3.28 0 0 0 1.133-2.48 3.333 3.333 0 0 0-6.666 0A3.28 3.28 0 0 0 3.8 8.147 5.333 5.333 0 0 0 .667 13 .666.666 0 1 0 2 13a4 4 0 0 1 8 0 .667.667 0 0 0 1.333 0A5.333 5.333 0 0 0 8.2 8.147ZM6 7.667a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm6.493.213A3.334 3.334 0 0 0 10 2.333a.667.667 0 0 0 0 1.334 2 2 0 0 1 1.73 2.997 2 2 0 0 1-.73.73.666.666 0 0 0-.033 1.133l.26.173.086.047A4.666 4.666 0 0 1 13.98 13a.667.667 0 0 0 1.333 0 6 6 0 0 0-2.82-5.12Z",
            fill: "currentColor"
        })
    });
var $6fd9356f8e9e9de6$export$2e2bcd8739ae039 = $6fd9356f8e9e9de6$var$SvgMembers;





parcelRequire("8Mb3E");
var $bt3dS = parcelRequire("bt3dS");

var $cDKfs = parcelRequire("cDKfs");

var $jGWQ4 = parcelRequire("jGWQ4");

var $jbKqE = parcelRequire("jbKqE");


var $4ZcUR = parcelRequire("4ZcUR");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $aZIrr = parcelRequire("aZIrr");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $kUZ14 = parcelRequire("kUZ14");


var $cDKfs = parcelRequire("cDKfs");

var $aqmjm = parcelRequire("aqmjm");

var $5vVWy = parcelRequire("5vVWy");


var $kBpQ2 = parcelRequire("kBpQ2");

var $dW2kG = parcelRequire("dW2kG");

parcelRequire("4taJ0");
var $9vrm1 = parcelRequire("9vrm1");
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $voszV = parcelRequire("voszV");


var $cDKfs = parcelRequire("cDKfs");
const $7972e4b1c12e9976$var$useEmailInputUtils = ()=>{
    const cloudApi = (0, $1c34cc51be8c93d3$export$ec1abe76789cde12)();
    const { currentTenantId: currentTenantId } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: existingMembers = [] } = (0, $voszV.default)(`api/tenant/${currentTenantId}/members`, async ()=>cloudApi.get("/api/tenants/:tenantId/members", {
            params: {
                tenantId: currentTenantId
            }
        }));
    const { data: existingInvitations = [] } = (0, $voszV.default)(`api/tenants/${currentTenantId}/invitations`, async ()=>cloudApi.get("/api/tenants/:tenantId/invitations", {
            params: {
                tenantId: currentTenantId
            }
        }));
    /**
   * Find duplicated and invalid formatted email addresses.
   *
   * @param emails Array of email emails.
   * @returns
   */ const findDuplicatedOrInvalidEmails = (0, $jC8Vy.useCallback)((emails = [])=>{
        const duplicatedEmails = new Set();
        const conflictMemberEmails = new Set();
        const conflictInvitationEmails = new Set();
        const invalidEmails = new Set();
        const validEmails = new Set();
        const existingMemberEmails = new Set(existingMembers.map(({ primaryEmail: primaryEmail })=>primaryEmail?.toLowerCase() ?? "").filter(Boolean));
        const existingInvitationEmails = new Set(existingInvitations.filter(({ status: status })=>status === (0, $61Yml.OrganizationInvitationStatus).Pending).map(({ invitee: invitee })=>invitee.toLowerCase()));
        for (const userInputEmail of emails){
            const email = userInputEmail.toLowerCase();
            if (!(0, $9vrm1.emailRegEx).test(email)) invalidEmails.add(email);
            // Check email collisions
            if (validEmails.has(email)) duplicatedEmails.add(email);
            else if (existingInvitationEmails.has(email)) conflictInvitationEmails.add(email);
            else if (existingMemberEmails.has(email)) conflictMemberEmails.add(email);
            else validEmails.add(email);
        }
        return {
            duplicatedEmails: duplicatedEmails,
            conflictMemberEmails: conflictMemberEmails,
            conflictInvitationEmails: conflictInvitationEmails,
            invalidEmails: invalidEmails
        };
    }, [
        existingInvitations,
        existingMembers
    ]);
    const parseEmailOptions = (0, $jC8Vy.useCallback)((inputValues)=>{
        const { duplicatedEmails: duplicatedEmails, conflictInvitationEmails: conflictInvitationEmails, conflictMemberEmails: conflictMemberEmails, invalidEmails: invalidEmails } = findDuplicatedOrInvalidEmails(inputValues.map((email)=>email.value));
        // Show error message and update the inputs' status for error display.
        if (duplicatedEmails.size > 0 || conflictInvitationEmails.size > 0 || conflictMemberEmails.size > 0 || invalidEmails.size > 0) return {
            values: inputValues.map(({ status: status, ...rest })=>({
                    ...rest,
                    ...(0, $7oDSS.conditional)((duplicatedEmails.has(rest.value) || conflictInvitationEmails.has(rest.value) || conflictMemberEmails.has(rest.value) || invalidEmails.has(rest.value)) && {
                        status: "error"
                    })
                })),
            errorMessage: (0, $7oDSS.conditionalArray)((0, $7oDSS.conditionalString)(duplicatedEmails.size > 0 && t("tenant_members.errors.email_exists")), (0, $7oDSS.conditionalString)(conflictInvitationEmails.size > 0 && t("tenant_members.errors.pending_invitation_exists")), (0, $7oDSS.conditionalString)(conflictMemberEmails.size > 0 && t("tenant_members.errors.member_exists")), (0, $7oDSS.conditionalString)(invalidEmails.size > 0 && t("tenant_members.errors.invalid_email"))).join("\n")
        };
        return {
            values: inputValues
        };
    }, [
        findDuplicatedOrInvalidEmails,
        t
    ]);
    return {
        parseEmailOptions: parseEmailOptions
    };
};
var $7972e4b1c12e9976$export$2e2bcd8739ae039 = $7972e4b1c12e9976$var$useEmailInputUtils;


var $8d3804ffcc30c992$export$89da14300d534261;
var $8d3804ffcc30c992$export$2ba01fb71ed41cb6;
var $8d3804ffcc30c992$export$25b61ec9da546d46;
var $8d3804ffcc30c992$export$34e0f9847d4c02dd;
var $8d3804ffcc30c992$export$8837f4fc672e936d;
var $8d3804ffcc30c992$export$bfd64c937657f93a;
var $8d3804ffcc30c992$export$4a6dd88bada4e7d2;
var $8d3804ffcc30c992$export$d167761217acc355;
$8d3804ffcc30c992$export$89da14300d534261 = `wClPVq_active`;
$8d3804ffcc30c992$export$2ba01fb71ed41cb6 = `wClPVq_button`;
$8d3804ffcc30c992$export$25b61ec9da546d46 = `wClPVq_chargeNotification`;
$8d3804ffcc30c992$export$34e0f9847d4c02dd = `wClPVq_container`;
$8d3804ffcc30c992$export$8837f4fc672e936d = `wClPVq_list`;
$8d3804ffcc30c992$export$bfd64c937657f93a = `wClPVq_rotating`;
$8d3804ffcc30c992$export$4a6dd88bada4e7d2 = `wClPVq_shimmer`;
$8d3804ffcc30c992$export$d167761217acc355 = `wClPVq_tabButtons`;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $lXQZH = parcelRequire("lXQZH");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");


parcelRequire("8Mb3E");
var $cfL6o = parcelRequire("cfL6o");


var $jGWQ4 = parcelRequire("jGWQ4");
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");

var $jC8Vy = parcelRequire("jC8Vy");

var $voszV = parcelRequire("voszV");



var $cDKfs = parcelRequire("cDKfs");


const $d5121dc0d3d56da1$var$useTenantMembersUsage = ()=>{
    const { currentPlan: currentPlan } = (0, $jC8Vy.useContext)((0, $19434c930f80c964$export$f8addfd4ab69c833));
    const { currentTenantId: currentTenantId } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { access: { canInviteMember: canInviteMember } } = (0, $1f7ad510e5c2dafe$export$2e2bcd8739ae039)();
    const cloudApi = (0, $1c34cc51be8c93d3$export$ec1abe76789cde12)();
    const { data: members } = (0, $voszV.default)(`api/tenants/${currentTenantId}/members`, async ()=>cloudApi.get("/api/tenants/:tenantId/members", {
            params: {
                tenantId: currentTenantId
            }
        }));
    const { data: invitations } = (0, $voszV.default)(canInviteMember && `api/tenants/${currentTenantId}/invitations`, async ()=>cloudApi.get("/api/tenants/:tenantId/invitations", {
            params: {
                tenantId: currentTenantId
            }
        }));
    const pendingInvitations = (0, $jC8Vy.useMemo)(()=>invitations?.filter(({ status: status })=>status === (0, $61Yml.OrganizationInvitationStatus).Pending), [
        invitations
    ]);
    const usage = (0, $jC8Vy.useMemo)(()=>{
        return (members?.length ?? 0) + (pendingInvitations?.length ?? 0);
    }, [
        members?.length,
        pendingInvitations?.length
    ]);
    const hasTenantMembersReachedLimit = (0, $jC8Vy.useMemo)(()=>(0, $605aee781e0fe83f$export$1cc4b5152472cd4f)({
            quotaKey: "tenantMembersLimit",
            plan: currentPlan,
            usage: usage
        }), [
        currentPlan,
        usage
    ]);
    const hasTenantMembersSurpassedLimit = (0, $jC8Vy.useMemo)(()=>(0, $605aee781e0fe83f$export$6486e974a84ab8b6)({
            quotaKey: "tenantMembersLimit",
            plan: currentPlan,
            usage: usage
        }), [
        currentPlan,
        usage
    ]);
    return {
        hasTenantMembersReachedLimit: hasTenantMembersReachedLimit,
        hasTenantMembersSurpassedLimit: hasTenantMembersSurpassedLimit,
        usage: usage,
        limit: currentPlan.quota.tenantMembersLimit ?? Number.POSITIVE_INFINITY
    };
};
var $d5121dc0d3d56da1$export$2e2bcd8739ae039 = $d5121dc0d3d56da1$var$useTenantMembersUsage;


var $2c986e1ca3dfa097$export$34e0f9847d4c02dd;
var $2c986e1ca3dfa097$export$6d59db4903f20f7d;
var $2c986e1ca3dfa097$export$bfd64c937657f93a;
var $2c986e1ca3dfa097$export$4a6dd88bada4e7d2;
$2c986e1ca3dfa097$export$34e0f9847d4c02dd = `_5_psdG_container`;
$2c986e1ca3dfa097$export$6d59db4903f20f7d = `_5_psdG_description`;
$2c986e1ca3dfa097$export$bfd64c937657f93a = `_5_psdG_rotating`;
$2c986e1ca3dfa097$export$4a6dd88bada4e7d2 = `_5_psdG_shimmer`;


function $33c30b15b3fddd63$var$Footer({ newInvitationCount: newInvitationCount = 0, isLoading: isLoading, onSubmit: onSubmit }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.upsell.paywall"
    });
    const { currentPlan: currentPlan } = (0, $jC8Vy.useContext)((0, $19434c930f80c964$export$f8addfd4ab69c833));
    const { id: planId, quota: quota } = currentPlan;
    const { hasTenantMembersReachedLimit: hasTenantMembersReachedLimit, limit: limit, usage: usage } = (0, $d5121dc0d3d56da1$export$2e2bcd8739ae039)();
    if (planId === (0, $lXQZH.ReservedPlanId).Free && hasTenantMembersReachedLimit) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dafa1bad5a99c1ae$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
            components: {
                a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a3bc63325dc3c1a8$export$2e2bcd8739ae039), {})
            },
            children: t("tenant_members")
        })
    });
    if (planId === (0, $lXQZH.ReservedPlanId).Development && (hasTenantMembersReachedLimit || usage + newInvitationCount > limit)) // Display a custom "Contact us" footer instead of asking for upgrade
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $2c986e1ca3dfa097$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $2c986e1ca3dfa097$export$6d59db4903f20f7d,
                children: t("tenant_members_dev_plan", {
                    limit: quota.tenantMembersLimit
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.LinkButton), {
                size: "large",
                type: "primary",
                title: "general.contact_us_action",
                href: (0, $cfL6o.contactEmailLink)
            })
        ]
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
        size: "large",
        type: "primary",
        title: "tenant_members.invite_members",
        isLoading: isLoading,
        onClick: onSubmit
    });
}
var $33c30b15b3fddd63$export$2e2bcd8739ae039 = $33c30b15b3fddd63$var$Footer;


function $9dd554ea3aa39249$var$InviteMemberModal({ isOpen: isOpen, onClose: onClose }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.tenant_members"
    });
    const { currentTenantId: currentTenantId } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const [isLoading, setIsLoading] = (0, $jC8Vy.useState)(false);
    const cloudApi = (0, $1c34cc51be8c93d3$export$ec1abe76789cde12)();
    const { parseEmailOptions: parseEmailOptions } = (0, $7972e4b1c12e9976$export$2e2bcd8739ae039)();
    const { show: show } = (0, $kBpQ2.useConfirmModal)();
    const formMethods = (0, $codQP.useForm)({
        defaultValues: {
            emails: [],
            role: (0, $aZIrr.TenantRole).Collaborator
        }
    });
    const { control: control, handleSubmit: handleSubmit, reset: reset, watch: watch, formState: { errors: errors } } = formMethods;
    (0, $jC8Vy.useEffect)(()=>{
        return ()=>{
            reset();
        };
    }, [
        isOpen,
        reset
    ]);
    const roleOptions = (0, $jC8Vy.useMemo)(()=>[
            {
                value: (0, $aZIrr.TenantRole).Admin,
                title: t("admin")
            },
            {
                value: (0, $aZIrr.TenantRole).Collaborator,
                title: t("collaborator")
            }
        ], [
        t
    ]);
    const onSubmit = handleSubmit(async ({ emails: emails, role: role })=>{
        if (role === (0, $aZIrr.TenantRole).Admin) {
            const [result] = await show({
                ModalContent: ()=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                        components: {
                            ul: /*#__PURE__*/ (0, $C7mD2.jsx)("ul", {
                                className: $8d3804ffcc30c992$export$8837f4fc672e936d
                            }),
                            li: /*#__PURE__*/ (0, $C7mD2.jsx)("li", {})
                        },
                        children: t("assign_admin_confirm")
                    }),
                confirmButtonText: "general.confirm"
            });
            if (!result) return;
        }
        setIsLoading(true);
        try {
            await Promise.all(emails.map(async (email)=>cloudApi.post("/api/tenants/:tenantId/invitations", {
                    params: {
                        tenantId: currentTenantId
                    },
                    body: {
                        invitee: email.value,
                        roleName: role
                    }
                })));
            (0, $FuhPC.toast).success(t("messages.invitation_sent"));
            onClose(true);
        } finally{
            setIsLoading(false);
        }
    });
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        isOpen: isOpen,
        className: $dW2kG.content,
        overlayClassName: $dW2kG.overlay,
        onRequestClose: ()=>{
            onClose();
        },
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5vVWy.default), {
            size: "large",
            title: "tenant_members.invite_modal.title",
            subtitle: "tenant_members.invite_modal.subtitle",
            footer: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $33c30b15b3fddd63$export$2e2bcd8739ae039), {
                newInvitationCount: watch("emails").length,
                isLoading: isLoading,
                onSubmit: onSubmit
            }),
            onClose: onClose,
            children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $codQP.FormProvider), {
                ...formMethods,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        isRequired: true,
                        title: "tenant_members.invite_modal.to",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                            name: "emails",
                            control: control,
                            rules: {
                                validate: (value)=>{
                                    if (value.length === 0) return t("errors.email_required");
                                    const { errorMessage: errorMessage } = parseEmailOptions(value);
                                    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                                    return errorMessage || true;
                                }
                            },
                            render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $258de3c548691e45$export$2e2bcd8739ae039), {
                                    values: value,
                                    error: errors.emails?.message,
                                    placeholder: t("invite_modal.email_input_placeholder"),
                                    parseEmailOptions: parseEmailOptions,
                                    onChange: onChange
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                        title: "tenant_members.roles",
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                            name: "role",
                            control: control,
                            render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $286a7bc94edef870$export$2e2bcd8739ae039), {
                                    options: roleOptions,
                                    value: value,
                                    onChange: onChange
                                })
                        })
                    })
                ]
            })
        })
    });
}
var $9dd554ea3aa39249$export$2e2bcd8739ae039 = $9dd554ea3aa39249$var$InviteMemberModal;




function $886f79f2f912fbe2$var$TenantMembers() {
    const { hasTenantMembersSurpassedLimit: hasTenantMembersSurpassedLimit } = (0, $d5121dc0d3d56da1$export$2e2bcd8739ae039)();
    const { navigate: navigate, match: match } = (0, $4ZcUR.default)();
    const [showInviteModal, setShowInviteModal] = (0, $jC8Vy.useState)(false);
    const { access: { canInviteMember: canInviteMember } } = (0, $1f7ad510e5c2dafe$export$2e2bcd8739ae039)();
    const isInvitationTab = match(`/tenant-settings/${(0, $bt3dS.TenantSettingsTabs).Members}/invitations`);
    const { currentTenantId: currentTenantId } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const cloudApi = (0, $1c34cc51be8c93d3$export$ec1abe76789cde12)();
    const { trigger: mutateInvitations } = (0, $3a3bd779b4a3a126$export$2e2bcd8739ae039)(`api/tenants/${currentTenantId}/invitations`, async ()=>cloudApi.get("/api/tenants/:tenantId/invitations", {
            params: {
                tenantId: currentTenantId
            }
        }));
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $8d3804ffcc30c992$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $69ac10e11f23c995$export$2e2bcd8739ae039), {
                hasSurpassedLimit: hasTenantMembersSurpassedLimit,
                quotaItemPhraseKey: "tenant_member",
                className: $8d3804ffcc30c992$export$25b61ec9da546d46,
                checkedFlagKey: "tenantMember"
            }),
            canInviteMember && /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $8d3804ffcc30c992$export$d167761217acc355,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($8d3804ffcc30c992$export$2ba01fb71ed41cb6, !isInvitationTab && $8d3804ffcc30c992$export$89da14300d534261),
                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6fd9356f8e9e9de6$export$2e2bcd8739ae039), {}),
                        title: "tenant_members.members",
                        onClick: ()=>{
                            navigate(".");
                        }
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($8d3804ffcc30c992$export$2ba01fb71ed41cb6, isInvitationTab && $8d3804ffcc30c992$export$89da14300d534261),
                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5fcae899439e915a$export$2e2bcd8739ae039), {}),
                        title: "tenant_members.invitations",
                        onClick: ()=>{
                            navigate("invitations");
                        }
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jbKqE.default), {}),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        type: "primary",
                        size: "large",
                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0b30fe81c923292b$export$2e2bcd8739ae039), {}),
                        title: "tenant_members.invite_members",
                        onClick: ()=>{
                            setShowInviteModal(true);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Outlet), {}),
            canInviteMember && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9dd554ea3aa39249$export$2e2bcd8739ae039), {
                isOpen: showInviteModal,
                onClose: (isSuccessful)=>{
                    setShowInviteModal(false);
                    if (isSuccessful) {
                        if (isInvitationTab) mutateInvitations();
                        else navigate("invitations");
                    }
                }
            })
        ]
    });
}
var $886f79f2f912fbe2$export$2e2bcd8739ae039 = $886f79f2f912fbe2$var$TenantMembers;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $61Yml = parcelRequire("61Yml");
var $aZIrr = parcelRequire("aZIrr");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");


var $jC8Vy = parcelRequire("jC8Vy");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $voszV = parcelRequire("voszV");






var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $546b7dcaf6b3e0c2$var$SvgUsersEmptyDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M251 237H5.5l19.712-29.375A19.477 19.477 0 0 1 41.387 199h.68c3.223 0 6.38.91 9.11 2.625 7.532 4.735 17.436 2.909 22.785-4.201l23.418-31.125a22.065 22.065 0 0 1 31.757-3.685l6.632 5.527a25.807 25.807 0 0 0 30.02 2.17 25.808 25.808 0 0 1 13.498-3.811h.897a28.983 28.983 0 0 1 27.465 19.726l5.072 15.045A14.294 14.294 0 0 0 226.267 211c4.825 0 9.324 2.434 11.965 6.472L251 237Z",
                fill: "#383A48"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M47 185a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v8H47v-8Zm0 48a4 4 0 0 0 4 4h4a4 4 0 0 0 4-4v-8H47v8Zm-18-18a4 4 0 0 1-4-4v-4a4 4 0 0 1 4-4h8v12h-8Zm48 0a4 4 0 0 0 4-4v-4a4 4 0 0 0-4-4h-8v12h8ZM31.788 196.271a3.999 3.999 0 0 1 0-5.656l2.828-2.829a4 4 0 0 1 5.657 0l5.657 5.657-8.486 8.485-5.657-5.657Zm33.94 33.941a3.998 3.998 0 0 0 5.657 0l2.829-2.828a4 4 0 0 0 0-5.657l-5.657-5.657-8.486 8.486 5.657 5.656Zm-25.456.001a4 4 0 0 1-5.657 0l-2.829-2.829a3.999 3.999 0 0 1 0-5.656l5.657-5.657 8.486 8.485-5.657 5.657Zm33.94-33.941a4 4 0 0 0 0-5.657l-2.828-2.828a3.998 3.998 0 0 0-5.657 0l-5.657 5.656 8.486 8.486 5.657-5.657Z",
                fill: "#635C8F"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M53 229c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20Zm0-12a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
                fill: "#8777C7"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M111 115.5h112V158c0 8.837-7.163 16-16 16h-80c-8.837 0-16-7.163-16-16v-42.5Z",
                fill: "#615A7D"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 123,
                y: 124,
                width: 44,
                height: 8,
                rx: 2,
                fill: "#776E9E"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 123,
                y: 136,
                width: 44,
                height: 8,
                rx: 2,
                fill: "#776E9E"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 123,
                y: 148,
                width: 44,
                height: 8,
                rx: 2,
                fill: "#776E9E"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 183,
                y: 124,
                width: 24,
                height: 44,
                rx: 6,
                fill: "#776D9E"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M111.5 115c0-8.56 6.94-15.5 15.5-15.5h80c8.56 0 15.5 6.94 15.5 15.5v43c0 8.56-6.94 15.5-15.5 15.5h-80c-8.56 0-15.5-6.94-15.5-15.5v-43Z",
                stroke: "#7269A8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 123,
                cy: 107,
                r: 2,
                fill: "#C48BB0"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 131,
                cy: 107,
                r: 2,
                fill: "#C79B93"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 139,
                cy: 107,
                r: 2,
                fill: "#776E9E"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m182.111 63.025 15.363 19.314a1 1 0 0 0 1.266.253l9.937-5.48a1 1 0 0 0 .007-1.747l-17.998-10.134c-.215-.121-.064-.447.167-.362l23.188 8.561a1 1 0 0 0 .875-.089l6.321-3.933c.785-.488.544-1.688-.367-1.836l-37.816-6.156c-.902-.147-1.512.894-.943 1.61Z",
                fill: "#9A8FBC"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M215 82.632v-5.866a1 1 0 0 0-1.514-.857l-4.631 2.778a1 1 0 0 0-.04 1.69l4.63 3.087a1 1 0 0 0 1.555-.832Z",
                fill: "#8073BC"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 55,
                y: 136,
                width: 102,
                height: 102,
                rx: 16,
                fill: "url(#paint0_linear_5321_35748)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M69 155c-13.5 2.667-43.1 2.6-53.5-19",
                stroke: "#58577B",
                strokeDasharray: "4 4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M224.304 197.008c-1.446 5.33-6.493 8.6-6.962 8.473-.468-.128-3.17-5.5-1.724-10.83s6.493-8.6 6.961-8.473c.469.127 3.171 5.5 1.725 10.83Z",
                fill: "#74B382"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M216.155 204.787c.095.476 5.271 3.537 10.687 2.455.393-.078.776-.176 1.149-.291a2 2 0 1 1 3.285-1.534c2.852-1.81 4.557-4.216 4.492-4.546-.095-.475-5.272-3.536-10.688-2.455-5.416 1.082-9.02 5.895-8.925 6.371Z",
                fill: "#89CBAB",
                style: {
                    mixBlendMode: "lighten"
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M220.5 84.5c4.667 2.333 13.7 9.4 12.5 19-1.5 12-14.482 2.482-8.5-3.5 5-5 18.524 7.157 7.124 23.149",
                stroke: "#58577B",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 86.5,
                y: 148.5,
                width: 39,
                height: 39,
                rx: 11.5,
                stroke: "#DFBEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 106,
                cy: 161,
                r: 6,
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M115.894 179.003c.12 1.098-.789 1.997-1.894 1.997H98c-1.105 0-2.014-.899-1.894-1.997C96.812 172.536 100.973 169 106 169s9.188 3.536 9.894 10.003Z",
                fill: "#735EAD"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 76,
                y: 196,
                width: 60,
                height: 10,
                rx: 4,
                fill: "#D8C7FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 76,
                y: 211,
                width: 60,
                height: 10,
                rx: 4,
                fill: "#EFE9FF",
                stroke: "#69539E"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M84 201a1 1 0 0 1 1-1h22a1 1 0 0 1 0 2H85a1 1 0 0 1-1-1Zm28 0a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1-1-1Zm11-1a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2Z",
                fill: "#9877EA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 86,
                cy: 216,
                r: 2,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 94,
                cy: 216,
                r: 2,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 102,
                cy: 216,
                r: 2,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 110,
                cy: 216,
                r: 2,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 114,
                y: 213,
                width: 1,
                height: 6,
                rx: 0.5,
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m91 215 66-37v60H91v-23Z",
                fill: "url(#paint1_linear_5321_35748)",
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 141,
                y: 178,
                width: 60,
                height: 60,
                rx: 12,
                fill: "url(#paint2_linear_5321_35748)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M171 188h3a5 5 0 0 1 0 10h-3v-10Z",
                fill: "#FFDAD4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M153 178c-6.627 0-12 5.373-12 12v18h10v-3a5 5 0 0 1 10 0v3h10v-30h-18Z",
                fill: "#FFDAD4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M171 208h10v3a5 5 0 0 0 10 0v-3h10v18c0 6.627-5.373 12-12 12h-18v-10h-3a5 5 0 0 1 0-10h3v-10Z",
                fill: "#A989DF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M228 238h8m-19.5 0h-54.09a.448.448 0 0 1-.354-.721l13.654-17.722c5.057-6.563 14.575-7.565 20.888-2.199l1.456 1.238a11.994 11.994 0 0 0 14.494.791v0a11.992 11.992 0 0 1 14.946 1.196l17.54 16.508a.526.526 0 0 1-.36.909H240.5",
                stroke: "#947DFF",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M242.104 168.38a6 6 0 1 0 6.147-10.308 6 6 0 0 0-6.147 10.308Zm1.537-2.577a3 3 0 1 0 3.073-5.152 3 3 0 0 0-3.073 5.152Z",
                fill: "#6E6083"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M45.957 119.104c0-.057.047-.104.104-.104h1.878c.057 0 .104.047.104.104v3.305l2.862-1.653a.105.105 0 0 1 .142.039l.939 1.626a.104.104 0 0 1-.038.142l-2.862 1.652 2.862 1.653c.05.028.067.092.038.142l-.939 1.626a.104.104 0 0 1-.142.038l-2.862-1.652v3.304a.105.105 0 0 1-.104.105H46.06a.105.105 0 0 1-.104-.105v-3.304l-2.862 1.652a.104.104 0 0 1-.142-.038l-.939-1.626a.104.104 0 0 1 .038-.142l2.862-1.653-2.862-1.652a.104.104 0 0 1-.038-.142l.939-1.626a.105.105 0 0 1 .142-.039l2.862 1.653v-3.305Z",
                fill: "#78767F"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M68.363 33.144c1.43-.57 2.941.623 2.719 2.146l-.333 2.285c-.222 1.524-2.01 2.236-3.219 1.281l-1.812-1.43c-1.209-.955-.93-2.86.5-3.428l2.145-.854Z",
                fill: "#83DA85"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m105.969 38.704 2.782-.511a2.828 2.828 0 0 0 2.27-3.293v0a2.829 2.829 0 0 1 2.271-3.294v0a2.829 2.829 0 0 0 2.27-3.293l-.512-2.782",
                stroke: "#4A474F",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m15.803 66.799-.4-2.8a2.828 2.828 0 0 0-3.201-2.4v0a2.828 2.828 0 0 1-3.2-2.399v0a2.828 2.828 0 0 0-3.2-2.4l-2.8.4",
                stroke: "#52514B",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M74 48.5V69c0 2.5 1.5 3.5 0 8.5s2 6 1.5 8-3.502 4-2.002 10",
                stroke: "#636063",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M73.196 49.5a1 1 0 0 1 1.732 0l3.634 6.294C79.257 56.997 78.39 58.5 77 58.5l-1.437-.36a1.568 1.568 0 0 0-1.082.12 1.568 1.568 0 0 1-1.008.135l-1.14-.229a5.004 5.004 0 0 0-1.682-.045c-1.065.152-1.863-.986-1.325-1.918l3.87-6.703Z",
                fill: "#B586B7"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M94 26.77c0 11.47-8.954 26.153-20 26.153S54 38.24 54 26.77C54 15.3 62.954 6 74 6s20 9.299 20 20.77Z",
                fill: "#CFA4D1"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M80.58 12.806c.491.457 1.041 1.032 1.615 1.71m5.219 18.767c1.506-5.653-.256-11.044-2.591-15.038a27.032 27.032 0 0 0-1.216-1.893",
                stroke: "#FEF2FF",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M37.498 108.5c3.504-5.5 4.502-7 2.002-10-1.32-1.584-3-3-1.5-8s-1.5-4 0-8.5c1-2.5 0-7.1 0-7.5",
                stroke: "#626067",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M37.429 70.99a.66.66 0 0 1 1.142 0l2.398 4.153a1.19 1.19 0 0 1-1.03 1.785l-.949-.237a1.034 1.034 0 0 0-.714.078c-.205.103-.44.135-.665.09l-.752-.15a3.303 3.303 0 0 0-1.11-.03c-.702.1-1.23-.651-.874-1.266l2.554-4.423Z",
                fill: "#68A973"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M52 55.538c0 8.03-6.268 18.308-14 18.308S24 63.568 24 55.538C24 47.51 30.268 41 38 41s14 6.51 14 14.538Z",
                fill: "#86BF8F"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M43.312 47c.307.306.653.717 1 1.217M45.813 59c1.086-3.04.747-5.823-.055-8-.136-.37-.286-.722-.444-1.054",
                stroke: "#F7F4FF",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_5321_35748",
                        x1: 106,
                        y1: 136,
                        x2: 65,
                        y2: 238,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#A089E1"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#816DB9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_5321_35748",
                        x1: 159.5,
                        y1: 192,
                        x2: 98.5,
                        y2: 232,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#9C79E0"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#BE9BFF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint2_linear_5321_35748",
                        x1: 192,
                        y1: 181,
                        x2: 144.5,
                        y2: 238,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FFBDE5"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAA5FF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $546b7dcaf6b3e0c2$export$2e2bcd8739ae039 = $546b7dcaf6b3e0c2$var$SvgUsersEmptyDark;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $43a64f0388e27011$var$SvgUsersEmpty = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M251 237H5.5l19.712-29.375A19.477 19.477 0 0 1 41.387 199h.68c3.223 0 6.38.91 9.11 2.625 7.532 4.735 17.436 2.909 22.785-4.201l23.418-31.125a22.065 22.065 0 0 1 31.757-3.685l6.632 5.527a25.807 25.807 0 0 0 30.02 2.17 25.808 25.808 0 0 1 13.498-3.811h.897a28.983 28.983 0 0 1 27.465 19.726l5.072 15.045A14.294 14.294 0 0 0 226.267 211c4.825 0 9.324 2.434 11.965 6.472L251 237Z",
                fill: "#D2CCDD"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M47 185a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v8H47v-8Zm0 48a4 4 0 0 0 4 4h4a4 4 0 0 0 4-4v-8H47v8Zm-18-18a4 4 0 0 1-4-4v-4a4 4 0 0 1 4-4h8v12h-8Zm48 0a4 4 0 0 0 4-4v-4a4 4 0 0 0-4-4h-8v12h8ZM31.788 196.271a3.999 3.999 0 0 1 0-5.656l2.828-2.829a4 4 0 0 1 5.657 0l5.657 5.657-8.486 8.485-5.657-5.657Zm33.94 33.941a3.998 3.998 0 0 0 5.657 0l2.829-2.828a4 4 0 0 0 0-5.657l-5.657-5.657-8.486 8.486 5.657 5.656Zm-25.456.001a4 4 0 0 1-5.657 0l-2.829-2.829a3.999 3.999 0 0 1 0-5.656l5.657-5.657 8.486 8.485-5.657 5.657Zm33.94-33.941a4 4 0 0 0 0-5.657l-2.828-2.828a3.998 3.998 0 0 0-5.657 0l-5.657 5.656 8.486 8.486 5.657-5.657Z",
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M53 229c11.046 0 20-8.955 20-20 0-11.046-8.954-20-20-20s-20 8.954-20 20c0 11.045 8.954 20 20 20Zm0-12a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
                fill: "#5F5D67"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M111 115.5h112V158c0 8.837-7.163 16-16 16h-80c-8.837 0-16-7.163-16-16v-42.5Z",
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 123,
                y: 124,
                width: 44,
                height: 8,
                rx: 2,
                fill: "#E1CEE8"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 123,
                y: 136,
                width: 44,
                height: 8,
                rx: 2,
                fill: "#E1CEE8"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 123,
                y: 148,
                width: 44,
                height: 8,
                rx: 2,
                fill: "#E1CEE8"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 183,
                y: 124,
                width: 24,
                height: 44,
                rx: 6,
                fill: "#E1CEE8"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M215.75 115a.5.5 0 0 0 0 1h6.75v42c0 8.56-6.94 15.5-15.5 15.5h-80c-8.56 0-15.5-6.94-15.5-15.5v-42h94a.5.5 0 0 0 0-1h-94c0-8.56 6.94-15.5 15.5-15.5h80c8.56 0 15.5 6.94 15.5 15.5h-6.75Z",
                stroke: "#C9C5D0",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 123,
                cy: 107,
                r: 2,
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 131,
                cy: 107,
                r: 2,
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 139,
                cy: 107,
                r: 2,
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m182.111 63.025 15.363 19.314a1 1 0 0 0 1.266.253l9.937-5.48a1 1 0 0 0 .007-1.747l-17.998-10.134c-.215-.121-.064-.447.167-.362l23.188 8.561a1 1 0 0 0 .875-.089l6.321-3.933c.785-.488.544-1.688-.367-1.836l-37.816-6.156c-.902-.147-1.512.894-.943 1.61Z",
                fill: "#AD93FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M215 84.199v-7.433a1 1 0 0 0-1.514-.857l-4.848 2.908a1 1 0 0 0-.168 1.589l4.848 4.524c.639.596 1.682.143 1.682-.731Z",
                fill: "#795FF2"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 55,
                y: 136,
                width: 102,
                height: 102,
                rx: 16,
                fill: "url(#paint0_linear_5320_34929)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M69 155c-13.5 2.667-43.1 2.6-53.5-19",
                stroke: "#A782E8",
                strokeDasharray: "4 4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M224.304 197.008c-1.446 5.33-6.493 8.6-6.962 8.473-.468-.128-3.17-5.5-1.724-10.83s6.493-8.6 6.961-8.473c.469.127 3.171 5.5 1.725 10.83Z",
                fill: "#83DA85"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M216.155 204.787c.095.476 5.271 3.536 10.687 2.455.393-.079.776-.177 1.149-.291a2.002 2.002 0 0 1 2.028-3.391 2.002 2.002 0 0 1 1.257 1.856c2.852-1.809 4.557-4.216 4.492-4.545-.095-.476-5.272-3.536-10.688-2.455s-9.02 5.895-8.925 6.371Z",
                fill: "#9FE79F",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M220.5 84.5c4.667 2.333 13.7 9.4 12.5 19-1.5 12-14.482 2.482-8.5-3.5 5-5 18.524 7.157 7.124 23.149",
                stroke: "#A782E8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 86.5,
                y: 148.5,
                width: 39,
                height: 39,
                rx: 11.5,
                stroke: "#DFBEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 106,
                cy: 161,
                r: 6,
                fill: "#FFB95A"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M115.894 179.003c.12 1.098-.789 1.997-1.894 1.997H98c-1.105 0-2.014-.899-1.894-1.997C96.812 172.536 100.973 169 106 169s9.188 3.536 9.894 10.003Z",
                fill: "#6F45E6"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 76,
                y: 196,
                width: 60,
                height: 10,
                rx: 4,
                fill: "#D8C7FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 76,
                y: 211,
                width: 60,
                height: 10,
                rx: 4,
                fill: "#EFE9FF",
                stroke: "#815AE3"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M84 201a1 1 0 0 1 1-1h22a1 1 0 0 1 0 2H85a1 1 0 0 1-1-1Zm28 0a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1-1-1Zm11-1a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2Z",
                fill: "#9877EA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 86,
                cy: 216,
                r: 2,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 94,
                cy: 216,
                r: 2,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 102,
                cy: 216,
                r: 2,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 110,
                cy: 216,
                r: 2,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 114,
                y: 213,
                width: 1,
                height: 6,
                rx: 0.5,
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m91 215 66-37v60H91v-23Z",
                fill: "url(#paint1_linear_5320_34929)",
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 141,
                y: 178,
                width: 60,
                height: 60,
                rx: 12,
                fill: "url(#paint2_linear_5320_34929)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M171 188h3a5 5 0 0 1 0 10h-3v-10Z",
                fill: "#FFDAD4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M153 178c-6.627 0-12 5.373-12 12v18h10v-3a5 5 0 0 1 10 0v3h10v-30h-18Z",
                fill: "#FFDAD4"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M171 208h10v3a5 5 0 0 0 10 0v-3h10v18c0 6.627-5.373 12-12 12h-18v-10h-3a5 5 0 0 1 0-10h3v-10Z",
                fill: "#B990FE"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M228 238h8m-19.5 0h-54.09a.448.448 0 0 1-.354-.721l13.654-17.722c5.057-6.563 14.575-7.565 20.888-2.199l1.456 1.238a11.994 11.994 0 0 0 14.494.791v0a11.992 11.992 0 0 1 14.946 1.196l17.54 16.508a.526.526 0 0 1-.36.909H240.5",
                stroke: "#947DFF",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M242.104 168.38a6 6 0 1 0 6.147-10.308 6 6 0 0 0-6.147 10.308Zm1.537-2.577a3 3 0 1 0 3.073-5.152 3 3 0 0 0-3.073 5.152Z",
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M45.957 119.104c0-.057.047-.104.105-.104h1.877c.058 0 .104.047.104.104v3.305l2.862-1.653a.105.105 0 0 1 .142.039l.94 1.626a.104.104 0 0 1-.039.142l-2.862 1.652 2.862 1.653c.05.028.067.092.038.142l-.939 1.626a.104.104 0 0 1-.142.038l-2.862-1.652v3.304a.105.105 0 0 1-.104.105h-1.877a.105.105 0 0 1-.105-.105v-3.304l-2.862 1.652a.104.104 0 0 1-.142-.038l-.939-1.626a.104.104 0 0 1 .038-.142l2.862-1.653-2.862-1.652a.104.104 0 0 1-.038-.142l.939-1.626a.105.105 0 0 1 .142-.039l2.862 1.653v-3.305Z",
                fill: "#E5E1EC"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M68.363 33.144c1.43-.57 2.941.623 2.719 2.146l-.333 2.285c-.222 1.524-2.01 2.236-3.219 1.281l-1.812-1.43c-1.209-.955-.93-2.86.5-3.428l2.145-.854Z",
                fill: "#83DA85"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m105.969 38.704 2.782-.511a2.828 2.828 0 0 0 2.27-3.293v0a2.829 2.829 0 0 1 2.27-3.294v0a2.829 2.829 0 0 0 2.271-3.293l-.512-2.782",
                stroke: "#F5EEFF",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m15.803 66.799-.4-2.8a2.828 2.828 0 0 0-3.201-2.4v0a2.828 2.828 0 0 1-3.2-2.4v0a2.828 2.828 0 0 0-3.2-2.399l-2.8.4",
                stroke: "#FFF06A",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M74 48.5V69c0 2.5 1.5 3.5 0 8.5s2 6 1.5 8-3.502 4-2.002 10",
                stroke: "#D1CADE",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M73.196 49.5a1 1 0 0 1 1.732 0l3.634 6.294C79.257 56.997 78.39 58.5 77 58.5l-1.437-.36a1.568 1.568 0 0 0-1.082.12 1.568 1.568 0 0 1-1.008.135l-1.14-.229a5.004 5.004 0 0 0-1.682-.045c-1.065.152-1.863-.986-1.325-1.918l3.87-6.703Z",
                fill: "#DEA0E1"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M94 26.77c0 11.47-8.954 26.153-20 26.153S54 38.24 54 26.77C54 15.3 62.954 6 74 6s20 9.299 20 20.77Z",
                fill: "#F4B4FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M80.58 12.806c.491.456 1.041 1.032 1.615 1.71m5.219 18.767c1.506-5.654-.256-11.044-2.591-15.038a27.087 27.087 0 0 0-1.216-1.893",
                stroke: "#FEF2FF",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M37.498 108.5c3.504-5.5 4.502-7 2.002-10-1.32-1.584-3-3-1.5-8s-1.5-4 0-8.5c1-2.5 0-7.1 0-7.5",
                stroke: "#D1CADE",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M37.429 70.99a.66.66 0 0 1 1.142 0l2.398 4.153a1.19 1.19 0 0 1-1.03 1.785l-.949-.237a1.034 1.034 0 0 0-.714.078c-.205.103-.44.135-.665.09l-.752-.15a3.303 3.303 0 0 0-1.11-.03c-.702.1-1.23-.651-.874-1.266l2.554-4.423Z",
                fill: "#71C171"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M52 55.538c0 8.03-6.268 18.308-14 18.308S24 63.568 24 55.538C24 47.51 30.268 41 38 41s14 6.51 14 14.538Z",
                fill: "#83DA85"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M43.312 47c.307.306.653.717 1 1.217M45.813 59c1.086-3.04.747-5.823-.055-8-.136-.37-.286-.722-.444-1.054",
                stroke: "#F7F4FF",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_5320_34929",
                        x1: 106,
                        y1: 136,
                        x2: 65,
                        y2: 238,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#C39EFF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#906FEF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_5320_34929",
                        x1: 159.5,
                        y1: 192,
                        x2: 98.5,
                        y2: 232,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#9C79E0"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#BE9BFF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint2_linear_5320_34929",
                        x1: 192,
                        y1: 181,
                        x2: 144.5,
                        y2: 238,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FFBDE5"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAA5FF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $43a64f0388e27011$export$2e2bcd8739ae039 = $43a64f0388e27011$var$SvgUsersEmpty;






var $cDKfs = parcelRequire("cDKfs");


var $jGWQ4 = parcelRequire("jGWQ4");

var $66ixW = parcelRequire("66ixW");




var $kBpQ2 = parcelRequire("kBpQ2");


const $2166357e3cd50982$var$convertInvitationStatusToTagStatus = (status)=>{
    switch(status){
        case (0, $61Yml.OrganizationInvitationStatus).Pending:
            return "alert";
        case (0, $61Yml.OrganizationInvitationStatus).Accepted:
            return "success";
        case (0, $61Yml.OrganizationInvitationStatus).Revoked:
            return "error";
        default:
            return "info";
    }
};
function $2166357e3cd50982$var$Invitations() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.tenant_members"
    });
    const cloudApi = (0, $1c34cc51be8c93d3$export$ec1abe76789cde12)();
    const { currentTenantId: currentTenantId } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { access: { canInviteMember: canInviteMember, canRemoveMember: canRemoveMember } } = (0, $1f7ad510e5c2dafe$export$2e2bcd8739ae039)();
    const { data: data, error: error, isLoading: isLoading, mutate: mutate } = (0, $voszV.default)(`api/tenants/${currentTenantId}/invitations`, async ()=>cloudApi.get("/api/tenants/:tenantId/invitations", {
            params: {
                tenantId: currentTenantId
            }
        }));
    const [showInviteModal, setShowInviteModal] = (0, $jC8Vy.useState)(false);
    const { show: show } = (0, $kBpQ2.useConfirmModal)();
    const handleRevoke = async (invitationId)=>{
        const [result] = await show({
            ModalContent: t("revoke_invitation_confirm"),
            confirmButtonText: "general.confirm"
        });
        if (!result) return;
        await cloudApi.patch(`/api/tenants/:tenantId/invitations/:invitationId/status`, {
            params: {
                tenantId: currentTenantId,
                invitationId: invitationId
            },
            body: {
                status: (0, $61Yml.OrganizationInvitationStatus).Revoked
            }
        });
        mutate();
        (0, $FuhPC.toast).success(t("messages.invitation_revoked"));
    };
    const handleDelete = async (invitationId)=>{
        const [result] = await show({
            ModalContent: t("delete_user_confirm"),
            confirmButtonText: "general.delete"
        });
        if (!result) return;
        await cloudApi.delete(`/api/tenants/:tenantId/invitations/:invitationId`, {
            params: {
                tenantId: currentTenantId,
                invitationId: invitationId
            }
        });
        mutate();
        (0, $FuhPC.toast).success(t("messages.invitation_deleted"));
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3166f28a681c41bb$export$2e2bcd8739ae039), {
                isRowHoverEffectDisabled: true,
                placeholder: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2b56c00d3802884b$export$2e2bcd8739ae039), {
                    image: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $43a64f0388e27011$export$2e2bcd8739ae039), {}),
                    imageDark: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $546b7dcaf6b3e0c2$export$2e2bcd8739ae039), {}),
                    title: "tenant_members.invitation_empty_placeholder.title",
                    description: "tenant_members.invitation_empty_placeholder.description",
                    action: (0, $7oDSS.conditional)(canInviteMember && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        title: "tenant_members.invite_members",
                        type: "primary",
                        size: "large",
                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0b30fe81c923292b$export$2e2bcd8739ae039), {}),
                        onClick: ()=>{
                            setShowInviteModal(true);
                        }
                    }))
                }),
                isLoading: isLoading,
                errorMessage: error?.toString(),
                rowGroups: [
                    {
                        key: "data",
                        data: data
                    }
                ],
                columns: [
                    {
                        dataIndex: "user",
                        colSpan: 2,
                        title: t("user"),
                        render: ({ invitee: invitee })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $e52124c5a4489a19$export$2e2bcd8739ae039), {
                                children: invitee
                            })
                    },
                    {
                        dataIndex: "roles",
                        colSpan: 2,
                        title: t("roles"),
                        render: ({ organizationRoles: organizationRoles })=>{
                            if (organizationRoles.length === 0) return "-";
                            return organizationRoles.map(({ id: id })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
                                    variant: "cell",
                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $be4f434fcf26f56b$export$9b2040b3fe7f4e3f), {
                                        value: id,
                                        title: t(id === (0, $aZIrr.TenantRole).Admin ? "admin" : "collaborator")
                                    })
                                }, id));
                        }
                    },
                    {
                        dataIndex: "status",
                        colSpan: 2,
                        title: t("invitation_status"),
                        render: ({ status: status })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
                                type: "state",
                                status: $2166357e3cd50982$var$convertInvitationStatusToTagStatus(status),
                                children: status
                            })
                    },
                    {
                        dataIndex: "inviter",
                        colSpan: 3,
                        title: t("inviter"),
                        render: ({ inviterName: inviterName })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $e52124c5a4489a19$export$2e2bcd8739ae039), {
                                children: inviterName ?? "-"
                            })
                    },
                    {
                        dataIndex: "expiresAt",
                        colSpan: 2,
                        title: t("expiration_date"),
                        render: ({ expiresAt: expiresAt })=>/*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                                children: (0, $9aa0641d843cb9a1$export$2e2bcd8739ae039)(expiresAt, "MMM do, yyyy")
                            })
                    },
                    ...(0, $7oDSS.condArray)((canInviteMember || canRemoveMember) && [
                        {
                            dataIndex: "actions",
                            title: null,
                            render: ({ id: id, status: status })=>/*#__PURE__*/ (0, $C7mD2.jsxs)((0, $f25eeaa133584984$export$2e2bcd8739ae039), {
                                    icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $51f9e5400e6421f4$export$2e2bcd8739ae039), {}),
                                    iconSize: "small",
                                    title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                        forKey: "general.more_options"
                                    }),
                                    children: [
                                        status === (0, $61Yml.OrganizationInvitationStatus).Pending && canInviteMember && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6c006ec422465f6f$export$2e2bcd8739ae039), {
                                            icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5fcae899439e915a$export$2e2bcd8739ae039), {}),
                                            onClick: async ()=>{
                                                await cloudApi.post("/api/tenants/:tenantId/invitations/:invitationId/message", {
                                                    params: {
                                                        tenantId: currentTenantId,
                                                        invitationId: id
                                                    }
                                                });
                                                (0, $FuhPC.toast).success(t("messages.invitation_sent"));
                                            },
                                            children: t("menu_options.resend_invite")
                                        }),
                                        status === (0, $61Yml.OrganizationInvitationStatus).Pending && canRemoveMember && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6c006ec422465f6f$export$2e2bcd8739ae039), {
                                            icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fdd1e61b965b5329$export$2e2bcd8739ae039), {}),
                                            type: "danger",
                                            onClick: ()=>{
                                                handleRevoke(id);
                                            },
                                            children: t("menu_options.revoke")
                                        }),
                                        status !== (0, $61Yml.OrganizationInvitationStatus).Pending && canRemoveMember && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6c006ec422465f6f$export$2e2bcd8739ae039), {
                                            icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3aa588de5c8665f2$export$2e2bcd8739ae039), {}),
                                            type: "danger",
                                            onClick: ()=>{
                                                handleDelete(id);
                                            },
                                            children: t("menu_options.delete_invitation_record")
                                        })
                                    ]
                                })
                        }
                    ])
                ],
                rowIndexKey: "id"
            }),
            canInviteMember && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9dd554ea3aa39249$export$2e2bcd8739ae039), {
                isOpen: showInviteModal,
                onClose: ()=>{
                    setShowInviteModal(false);
                    mutate();
                }
            })
        ]
    });
}
var $2166357e3cd50982$export$2e2bcd8739ae039 = $2166357e3cd50982$var$Invitations;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $aZIrr = parcelRequire("aZIrr");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $voszV = parcelRequire("voszV");






var $cDKfs = parcelRequire("cDKfs");





var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $aZIrr = parcelRequire("aZIrr");
parcelRequire("ajkVG");
var $clvkc = parcelRequire("clvkc");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $kUZ14 = parcelRequire("kUZ14");


var $cDKfs = parcelRequire("cDKfs");

var $jGWQ4 = parcelRequire("jGWQ4");

var $aqmjm = parcelRequire("aqmjm");

var $5vVWy = parcelRequire("5vVWy");


var $kBpQ2 = parcelRequire("kBpQ2");


var $dW2kG = parcelRequire("dW2kG");

function $6531c18e5f34251c$var$EditMemberModal({ user: user, isOpen: isOpen, onClose: onClose }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.tenant_members"
    });
    const { currentTenantId: currentTenantId } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { mutate: mutateUserTenantScopes } = (0, $1f7ad510e5c2dafe$export$2e2bcd8739ae039)();
    const [isLoading, setIsLoading] = (0, $jC8Vy.useState)(false);
    const [role, setRole] = (0, $jC8Vy.useState)((0, $aZIrr.TenantRole).Collaborator);
    const { show: show } = (0, $kBpQ2.useConfirmModal)();
    const cloudApi = (0, $1c34cc51be8c93d3$export$ec1abe76789cde12)();
    const roleOptions = (0, $jC8Vy.useMemo)(()=>[
            {
                value: (0, $aZIrr.TenantRole).Admin,
                title: t("admin")
            },
            {
                value: (0, $aZIrr.TenantRole).Collaborator,
                title: t("collaborator")
            }
        ], [
        t
    ]);
    const onSubmit = async ()=>{
        if (role === (0, $aZIrr.TenantRole).Admin) {
            const [result] = await show({
                ModalContent: ()=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                        components: {
                            ul: /*#__PURE__*/ (0, $C7mD2.jsx)("ul", {
                                className: $8d3804ffcc30c992$export$8837f4fc672e936d
                            }),
                            li: /*#__PURE__*/ (0, $C7mD2.jsx)("li", {})
                        },
                        children: t("assign_admin_confirm")
                    }),
                confirmButtonText: "general.confirm"
            });
            if (!result) return;
        }
        setIsLoading(true);
        try {
            await cloudApi.put(`/api/tenants/:tenantId/members/:userId/roles`, {
                params: {
                    tenantId: currentTenantId,
                    userId: user.id
                },
                body: {
                    roleName: role
                }
            });
            mutateUserTenantScopes();
            onClose();
        } finally{
            setIsLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        isOpen: isOpen,
        className: $dW2kG.content,
        overlayClassName: $dW2kG.overlay,
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5vVWy.default), {
            title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $C7mD2.Fragment), {
                children: t("edit_modal.title", {
                    name: (0, $clvkc.getUserDisplayName)(user)
                })
            }),
            footer: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                size: "large",
                type: "primary",
                title: "general.save",
                isLoading: isLoading,
                onClick: onSubmit
            }),
            onClose: onClose,
            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                title: "tenant_members.roles",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $286a7bc94edef870$export$2e2bcd8739ae039), {
                    options: roleOptions,
                    value: role,
                    onChange: (value)=>{
                        if (value) setRole(value);
                    }
                })
            })
        })
    });
}
var $6531c18e5f34251c$export$2e2bcd8739ae039 = $6531c18e5f34251c$var$EditMemberModal;


function $a52e3c01e496271d$var$Members() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.tenant_members"
    });
    const cloudApi = (0, $1c34cc51be8c93d3$export$ec1abe76789cde12)();
    const { currentTenantId: currentTenantId } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { user: currentUser } = (0, $8dc2d4d6918e57ba$export$2e2bcd8739ae039)();
    const { access: { canRemoveMember: canRemoveMember, canUpdateMemberRole: canUpdateMemberRole } } = (0, $1f7ad510e5c2dafe$export$2e2bcd8739ae039)();
    const { data: data, error: error, isLoading: isLoading, mutate: mutate } = (0, $voszV.default)(`api/tenants/${currentTenantId}/members`, async ()=>cloudApi.get("/api/tenants/:tenantId/members", {
            params: {
                tenantId: currentTenantId
            }
        }));
    const [userToBeEdited, setUserToBeEdited] = (0, $jC8Vy.useState)();
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3166f28a681c41bb$export$2e2bcd8739ae039), {
                isRowHoverEffectDisabled: true,
                placeholder: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a0f84bc7cc69e410$export$2e2bcd8739ae039), {}),
                isLoading: isLoading,
                errorMessage: error?.toString(),
                rowGroups: [
                    {
                        key: "data",
                        data: data
                    }
                ],
                columns: [
                    {
                        dataIndex: "user",
                        title: t("user"),
                        colSpan: 4,
                        render: (user)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $55e437438f7e6e4f$export$2e2bcd8739ae039), {
                                user: user,
                                hasUserDetailsLink: false
                            })
                    },
                    {
                        dataIndex: "roles",
                        title: t("roles"),
                        colSpan: 6,
                        render: ({ organizationRoles: organizationRoles })=>{
                            if (organizationRoles.length === 0) return "-";
                            return organizationRoles.map(({ id: id })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
                                    variant: "cell",
                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $be4f434fcf26f56b$export$9b2040b3fe7f4e3f), {
                                        value: id,
                                        title: t(id === (0, $aZIrr.TenantRole).Admin ? "admin" : "collaborator")
                                    })
                                }, id));
                        }
                    },
                    ...(0, $7oDSS.condArray)((canUpdateMemberRole || canRemoveMember) && [
                        {
                            dataIndex: "actions",
                            title: null,
                            colSpan: 1,
                            render: (user)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $d6ac1a830c94487b$export$2e2bcd8739ae039), {
                                    deleteConfirmation: "tenant_members.delete_user_confirm",
                                    fieldName: "tenant_members.user",
                                    textOverrides: {
                                        edit: "tenant_members.menu_options.edit",
                                        delete: "tenant_members.menu_options.delete",
                                        deleteConfirmation: "general.remove"
                                    },
                                    onEdit: (0, $7oDSS.conditional)(canUpdateMemberRole && (()=>{
                                        setUserToBeEdited(user);
                                    })),
                                    onDelete: (0, $7oDSS.conditional)(canRemoveMember && // Cannot remove self from members list
                                    currentUser?.id !== user.id && (async ()=>{
                                        await cloudApi.delete(`/api/tenants/:tenantId/members/:userId`, {
                                            params: {
                                                tenantId: currentTenantId,
                                                userId: user.id
                                            }
                                        });
                                        mutate();
                                    }))
                                })
                        }
                    ])
                ],
                rowIndexKey: "id"
            }),
            canUpdateMemberRole && userToBeEdited && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6531c18e5f34251c$export$2e2bcd8739ae039), {
                isOpen: true,
                user: userToBeEdited,
                onClose: ()=>{
                    setUserToBeEdited(undefined);
                    mutate();
                }
            })
        ]
    });
}
var $a52e3c01e496271d$export$2e2bcd8739ae039 = $a52e3c01e496271d$var$Members;


const $61fe018927210141$export$3f533f36fbeec097 = ()=>{
    const { isDevTenant: isDevTenant } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { access: { canInviteMember: canInviteMember, canManageTenant: canManageTenant } } = (0, $1f7ad510e5c2dafe$export$2e2bcd8739ae039)();
    const tenantSettings = (0, $jC8Vy.useMemo)(()=>({
            path: "tenant-settings",
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $653c238fc74a80f6$export$2e2bcd8739ae039), {}),
            children: (0, $7oDSS.condArray)({
                index: true,
                element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Navigate), {
                    replace: true,
                    to: canManageTenant ? (0, $bt3dS.TenantSettingsTabs).Settings : (0, $bt3dS.TenantSettingsTabs).Members
                })
            }, {
                path: (0, $bt3dS.TenantSettingsTabs).Settings,
                element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1545fe05b0773baa$export$2e2bcd8739ae039), {})
            }, {
                path: `${(0, $bt3dS.TenantSettingsTabs).Members}/*`,
                element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $886f79f2f912fbe2$export$2e2bcd8739ae039), {}),
                children: [
                    {
                        path: "*",
                        element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $g0vtZ.default), {})
                    },
                    {
                        index: true,
                        element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a52e3c01e496271d$export$2e2bcd8739ae039), {})
                    },
                    ...(0, $7oDSS.condArray)(canInviteMember && [
                        {
                            path: "invitations",
                            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2166357e3cd50982$export$2e2bcd8739ae039), {})
                        }
                    ])
                ]
            }, {
                path: (0, $bt3dS.TenantSettingsTabs).Domains,
                element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8ab77cd24a89aec5$export$2e2bcd8739ae039), {})
            }, !isDevTenant && canManageTenant && [
                {
                    path: (0, $bt3dS.TenantSettingsTabs).Subscription,
                    element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $900a19e2db100a3b$export$2e2bcd8739ae039), {})
                },
                {
                    path: (0, $bt3dS.TenantSettingsTabs).BillingHistory,
                    element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f3fcba42ca11c229$export$2e2bcd8739ae039), {})
                }
            ])
        }), [
        canInviteMember,
        canManageTenant,
        isDevTenant
    ]);
    return tenantSettings;
};



var $C7mD2 = parcelRequire("C7mD2");

var $2Phw0 = parcelRequire("2Phw0");

var $bt3dS = parcelRequire("bt3dS");


var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $kUZ14 = parcelRequire("kUZ14");

var $2Phw0 = parcelRequire("2Phw0");parcelRequire("6bq3s");
var $2Phw0 = parcelRequire("2Phw0");

var $voszV = parcelRequire("voszV");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $ffd99e3e12dec5b3$var$SvgForbidden = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M10 1.667a8.333 8.333 0 1 0 0 16.666 8.333 8.333 0 0 0 0-16.666Zm0 15A6.667 6.667 0 0 1 3.333 10a6.6 6.6 0 0 1 1.409-4.083l9.341 9.341A6.6 6.6 0 0 1 10 16.667Zm5.258-2.584L5.917 4.742A6.6 6.6 0 0 1 10 3.333 6.667 6.667 0 0 1 16.667 10a6.6 6.6 0 0 1-1.409 4.083Z",
            fill: "currentColor"
        })
    });
var $ffd99e3e12dec5b3$export$2e2bcd8739ae039 = $ffd99e3e12dec5b3$var$SvgForbidden;




var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $d81a97765ce18069$var$SvgShield = (props)=>/*#__PURE__*/ (0, $C7mD2.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
            d: "M16.358 3.042a.833.833 0 0 0-.7-.167 6.666 6.666 0 0 1-5.183-1.058.834.834 0 0 0-.95 0 6.667 6.667 0 0 1-5.183 1.058.833.833 0 0 0-1.008.817V9.9a7.5 7.5 0 0 0 3.141 6.108l3.042 2.167a.834.834 0 0 0 .966 0l3.042-2.167A7.5 7.5 0 0 0 16.667 9.9V3.692a.832.832 0 0 0-.309-.65ZM15 9.9a5.834 5.834 0 0 1-2.441 4.75L10 16.475 7.442 14.65A5.834 5.834 0 0 1 5 9.9V4.65a8.333 8.333 0 0 0 5-1.158 8.333 8.333 0 0 0 5 1.158V9.9Zm-3.716-1.908-2.242 2.25-.742-.75a.837.837 0 1 0-1.183 1.183l1.333 1.333a.833.833 0 0 0 1.184 0L12.5 9.167a.837.837 0 0 0-1.183-1.184l-.034.009Z",
            fill: "currentColor"
        })
    });
var $d81a97765ce18069$export$2e2bcd8739ae039 = $d81a97765ce18069$var$SvgShield;





var $5TsIB = parcelRequire("5TsIB");


var $bt3dS = parcelRequire("bt3dS");

var $dL4NZ = parcelRequire("dL4NZ");



var $7VnwS = parcelRequire("7VnwS");

var $4ZcUR = parcelRequire("4ZcUR");

var $dW2kG = parcelRequire("dW2kG");

var $7kooT = parcelRequire("7kooT");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $kUZ14 = parcelRequire("kUZ14");

var $cJEhq = parcelRequire("cJEhq");

var $jGWQ4 = parcelRequire("jGWQ4");

var $75SRw = parcelRequire("75SRw");

var $5vVWy = parcelRequire("5vVWy");

var $dW2kG = parcelRequire("dW2kG");
var $c5f496a803e6d5a2$export$a7db06668cad9adb;
var $c5f496a803e6d5a2$export$be704fe733d78a38;
var $c5f496a803e6d5a2$export$a80b3bd66acc52ff;
var $c5f496a803e6d5a2$export$b8cfaf7638e14578;
var $c5f496a803e6d5a2$export$dbca9e3b1ed6816f;
var $c5f496a803e6d5a2$export$7b8f6cec25af9dd;
var $c5f496a803e6d5a2$export$bfd64c937657f93a;
var $c5f496a803e6d5a2$export$4a6dd88bada4e7d2;
$c5f496a803e6d5a2$export$a7db06668cad9adb = `_3ZkXhW_content`;
$c5f496a803e6d5a2$export$be704fe733d78a38 = `_3ZkXhW_eyeIcon`;
$c5f496a803e6d5a2$export$a80b3bd66acc52ff = `_3ZkXhW_info`;
$c5f496a803e6d5a2$export$b8cfaf7638e14578 = `_3ZkXhW_infoContent`;
$c5f496a803e6d5a2$export$dbca9e3b1ed6816f = `_3ZkXhW_infoLine`;
$c5f496a803e6d5a2$export$7b8f6cec25af9dd = `_3ZkXhW_operation`;
$c5f496a803e6d5a2$export$bfd64c937657f93a = `_3ZkXhW_rotating`;
$c5f496a803e6d5a2$export$4a6dd88bada4e7d2 = `_3ZkXhW_shimmer`;


function $ca754f0b8a51f8f3$var$UserAccountInformation({ user: user, password: password, title: title, onClose: onClose, onConfirm: onConfirm, passwordLabel: passwordLabel, confirmButtonTitle: confirmButtonTitle }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [passwordVisible, setPasswordVisible] = (0, $jC8Vy.useState)(false);
    const { primaryEmail: primaryEmail, primaryPhone: primaryPhone, username: username } = user;
    const handleCopy = async ()=>{
        if (!password) return null;
        const content = (0, $7oDSS.conditionalArray)(primaryEmail && `${t("user_details.created_email")} ${primaryEmail}`, primaryPhone && `${t("user_details.created_phone")} ${primaryPhone}`, username && `${t("user_details.created_username")} ${username}`, `${passwordLabel ?? t("user_details.created_password")} ${password}`).join("\n");
        await navigator.clipboard.writeText(content);
        (0, $FuhPC.toast).success(t("general.copied"));
    };
    if (!password) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        isOpen: true,
        shouldCloseOnEsc: true,
        className: $dW2kG.content,
        overlayClassName: $dW2kG.overlay,
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $5vVWy.default), {
            title: title,
            footer: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        title: confirmButtonTitle ?? "general.done",
                        onClick: onConfirm ?? onClose
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        type: "primary",
                        title: "general.copy",
                        onClick: handleCopy
                    })
                ]
            }),
            className: $c5f496a803e6d5a2$export$a7db06668cad9adb,
            onClose: onClose,
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    children: t("user_details.created_guide")
                }),
                /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: $c5f496a803e6d5a2$export$a80b3bd66acc52ff,
                    children: [
                        username && /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                            className: $c5f496a803e6d5a2$export$dbca9e3b1ed6816f,
                            children: [
                                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                    children: t("user_details.created_username")
                                }),
                                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                    className: $c5f496a803e6d5a2$export$b8cfaf7638e14578,
                                    children: username
                                })
                            ]
                        }),
                        primaryEmail && /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                            className: $c5f496a803e6d5a2$export$dbca9e3b1ed6816f,
                            children: [
                                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                    children: t("user_details.created_email")
                                }),
                                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                    className: $c5f496a803e6d5a2$export$b8cfaf7638e14578,
                                    children: primaryEmail
                                })
                            ]
                        }),
                        primaryPhone && /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                            className: $c5f496a803e6d5a2$export$dbca9e3b1ed6816f,
                            children: [
                                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                    children: t("user_details.created_phone")
                                }),
                                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                    className: $c5f496a803e6d5a2$export$b8cfaf7638e14578,
                                    children: primaryPhone
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                            className: $c5f496a803e6d5a2$export$dbca9e3b1ed6816f,
                            children: [
                                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                    children: passwordLabel ?? t("user_details.created_password")
                                }),
                                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                    className: $c5f496a803e6d5a2$export$b8cfaf7638e14578,
                                    children: passwordVisible ? password : password.replaceAll(/./g, "*")
                                }),
                                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                    className: $c5f496a803e6d5a2$export$7b8f6cec25af9dd,
                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                                        onClick: ()=>{
                                            setPasswordVisible((previous)=>!previous);
                                        },
                                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cJEhq.default), {
                                            className: $c5f496a803e6d5a2$export$be704fe733d78a38
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
var $ca754f0b8a51f8f3$export$2e2bcd8739ae039 = $ca754f0b8a51f8f3$var$UserAccountInformation;




var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $dL4NZ = parcelRequire("dL4NZ");

var $7VnwS = parcelRequire("7VnwS");

var $4VIdw = parcelRequire("4VIdw");
const $5f56a5d87b3d4d33$export$832e1ed778c99ea4 = ()=>(0, $4VIdw.nanoid)(8);


function $0c24c34b67cd5c7e$var$ResetPasswordForm({ onClose: onClose, userId: userId }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const api = (0, $7VnwS.default)();
    const [isLoading, setIsLoading] = (0, $jC8Vy.useState)(false);
    const onSubmit = async ()=>{
        const password = (0, $5f56a5d87b3d4d33$export$832e1ed778c99ea4)();
        setIsLoading(true);
        await api.patch(`api/users/${userId}/password`, {
            json: {
                password: password
            }
        }).json();
        setIsLoading(false);
        onClose?.(password);
    };
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dL4NZ.default), {
        isOpen: true,
        title: "user_details.reset_password.title",
        isLoading: isLoading,
        onCancel: ()=>{
            onClose?.();
        },
        onConfirm: onSubmit,
        children: t("user_details.reset_password.content")
    });
}
var $0c24c34b67cd5c7e$export$2e2bcd8739ae039 = $0c24c34b67cd5c7e$var$ResetPasswordForm;


var $77b5c480b817d26b$export$26684859963899d2;
var $77b5c480b817d26b$export$bfd64c937657f93a;
var $77b5c480b817d26b$export$4a6dd88bada4e7d2;
$77b5c480b817d26b$export$26684859963899d2 = `tRtS8W_resourceLayout`;
$77b5c480b817d26b$export$bfd64c937657f93a = `tRtS8W_rotating`;
$77b5c480b817d26b$export$4a6dd88bada4e7d2 = `tRtS8W_shimmer`;


function $1401f45893bfdf2b$var$UserDetails() {
    const { pathname: pathname } = (0, $2Phw0.useLocation)();
    const isPageHasTable = pathname.endsWith((0, $bt3dS.UserDetailsTabs).Roles) || pathname.endsWith((0, $bt3dS.UserDetailsTabs).Logs);
    const { id: id } = (0, $2Phw0.useParams)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [isDeleteFormOpen, setIsDeleteFormOpen] = (0, $jC8Vy.useState)(false);
    const [isDeleting, setIsDeleting] = (0, $jC8Vy.useState)(false);
    const [isResetPasswordFormOpen, setIsResetPasswordFormOpen] = (0, $jC8Vy.useState)(false);
    const [isToggleSuspendFormOpen, setIsToggleSuspendFormOpen] = (0, $jC8Vy.useState)(false);
    const [isUpdatingSuspendState, setIsUpdatingSuspendState] = (0, $jC8Vy.useState)(false);
    const [resetResult, setResetResult] = (0, $jC8Vy.useState)();
    // Get user info with user's SSO identities in a single API call.
    const { data: data, error: error, mutate: mutate } = (0, $voszV.default)(id && (0, $7kooT.buildUrl)(`api/users/${id}`, {
        includeSsoIdentities: "true"
    }));
    const { isSuspended: isSuspendedUser = false } = data ?? {};
    const isLoading = !data && !error;
    const api = (0, $7VnwS.default)();
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const userSubtitle = data && (0, $46451cbb59c7a857$export$336d714c72178bf2)(data);
    (0, $jC8Vy.useEffect)(()=>{
        setIsDeleteFormOpen(false);
        setIsResetPasswordFormOpen(false);
        setIsToggleSuspendFormOpen(false);
    }, [
        pathname
    ]);
    const onDelete = async ()=>{
        if (!data || isDeleting) return;
        setIsDeleting(true);
        try {
            await api.delete(`api/users/${data.id}`);
            (0, $FuhPC.toast).success(t("user_details.deleted", {
                name: data.name
            }));
            navigate("/users");
        } finally{
            setIsDeleting(false);
        }
    };
    const onToggleSuspendState = async ()=>{
        if (!data || isUpdatingSuspendState) return;
        setIsUpdatingSuspendState(true);
        try {
            const updatedUser = await api.patch(`api/users/${data.id}/is-suspended`, {
                json: {
                    isSuspended: !isSuspendedUser
                }
            }).json();
            mutate(updatedUser);
            setIsToggleSuspendFormOpen(false);
            (0, $FuhPC.toast).success(t(updatedUser.isSuspended ? "user_details.user_suspended" : "user_details.user_reactivated"));
        } finally{
            setIsUpdatingSuspendState(false);
        }
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aa35f43ec98b7478$export$2e2bcd8739ae039), {
        backLink: "/users",
        backLinkTitle: "user_details.back_to_users",
        isLoading: isLoading,
        error: error,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))(isPageHasTable && $77b5c480b817d26b$export$26684859963899d2),
        onRetry: mutate,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5TsIB.default), {
                titleKey: "user_details.page_title"
            }),
            data && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $eefae5244405013e$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e999fd6c93542895$export$2e2bcd8739ae039), {
                            user: data,
                            size: "xlarge"
                        }),
                        title: (0, $46451cbb59c7a857$export$5f7a1baecd59f846)(data),
                        subtitle: userSubtitle,
                        primaryTag: isSuspendedUser && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6f644f560eac971b$export$2e2bcd8739ae039), {}),
                        identifier: {
                            name: "User ID",
                            value: data.id
                        },
                        actionMenuItems: [
                            {
                                title: "user_details.reset_password.reset_password",
                                icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $bf46177f0fb84c60$export$2e2bcd8739ae039), {}),
                                onClick: ()=>{
                                    setIsResetPasswordFormOpen(true);
                                }
                            },
                            {
                                title: isSuspendedUser ? "user_details.reactivate_user" : "user_details.suspend_user",
                                icon: isSuspendedUser ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $d81a97765ce18069$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ffd99e3e12dec5b3$export$2e2bcd8739ae039), {}),
                                onClick: ()=>{
                                    setIsToggleSuspendFormOpen(true);
                                }
                            },
                            {
                                title: "general.delete",
                                type: "danger",
                                icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3aa588de5c8665f2$export$2e2bcd8739ae039), {}),
                                onClick: ()=>{
                                    setIsDeleteFormOpen(true);
                                }
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
                        shouldCloseOnEsc: true,
                        isOpen: isResetPasswordFormOpen,
                        className: $dW2kG.content,
                        overlayClassName: $dW2kG.overlay,
                        onRequestClose: ()=>{
                            setIsResetPasswordFormOpen(false);
                        },
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0c24c34b67cd5c7e$export$2e2bcd8739ae039), {
                            userId: data.id,
                            onClose: (password)=>{
                                setIsResetPasswordFormOpen(false);
                                if (password) setResetResult(password);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7065f4e52ae4e862$export$2e2bcd8739ae039), {
                        isOpen: isDeleteFormOpen,
                        isLoading: isDeleting,
                        onCancel: ()=>{
                            setIsDeleteFormOpen(false);
                        },
                        onConfirm: onDelete,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            children: t("user_details.delete_description")
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dL4NZ.default), {
                        isOpen: isToggleSuspendFormOpen,
                        isLoading: isUpdatingSuspendState,
                        confirmButtonText: isSuspendedUser ? "user_details.reactivate_action" : "user_details.suspend_action",
                        onCancel: ()=>{
                            setIsToggleSuspendFormOpen(false);
                        },
                        onConfirm: onToggleSuspendState,
                        children: t(isSuspendedUser ? "user_details.reactivate_user_reminder" : "user_details.suspend_user_reminder")
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $26090e0c44b20d28$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                                href: `/users/${data.id}/${(0, $bt3dS.UserDetailsTabs).Settings}`,
                                children: t("user_details.tab_settings")
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                                href: `/users/${data.id}/${(0, $bt3dS.UserDetailsTabs).Roles}`,
                                children: t("user_details.tab_roles")
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                                href: `/users/${data.id}/${(0, $bt3dS.UserDetailsTabs).Logs}`,
                                children: t("user_details.tab_logs")
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                                href: `/users/${data.id}/${(0, $bt3dS.UserDetailsTabs).Organizations}`,
                                children: t("user_details.tab_organizations")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Outlet), {
                        context: {
                            user: data,
                            isDeleting: isDeleting,
                            onUserUpdated: (user)=>{
                                mutate(user);
                            }
                        }
                    }),
                    resetResult && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ca754f0b8a51f8f3$export$2e2bcd8739ae039), {
                        title: "user_details.reset_password.congratulations",
                        user: data,
                        password: resetResult,
                        passwordLabel: t("user_details.reset_password.new_password"),
                        onClose: ()=>{
                            setResetResult(undefined);
                        }
                    })
                ]
            })
        ]
    });
}
var $1401f45893bfdf2b$export$2e2bcd8739ae039 = $1401f45893bfdf2b$var$UserDetails;



var $C7mD2 = parcelRequire("C7mD2");

var $2Phw0 = parcelRequire("2Phw0");

var $d9502798d028d2c3$export$fa0831f497706bad;
var $d9502798d028d2c3$export$bfd64c937657f93a;
var $d9502798d028d2c3$export$4a6dd88bada4e7d2;
$d9502798d028d2c3$export$fa0831f497706bad = `_0fF0WG_logs`;
$d9502798d028d2c3$export$bfd64c937657f93a = `_0fF0WG_rotating`;
$d9502798d028d2c3$export$4a6dd88bada4e7d2 = `_0fF0WG_shimmer`;


function $7a15a72f0045244c$var$UserLogs() {
    const { user: { id: id } } = (0, $2Phw0.useOutletContext)();
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $85bd40f9f49866bd$export$2e2bcd8739ae039), {
        userId: id,
        className: $d9502798d028d2c3$export$fa0831f497706bad
    });
}
var $7a15a72f0045244c$export$2e2bcd8739ae039 = $7a15a72f0045244c$var$UserLogs;



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $2Phw0 = parcelRequire("2Phw0");

var $voszV = parcelRequire("voszV");


var $lf8OC = parcelRequire("lf8OC");





var $cw2No = parcelRequire("cw2No");

var $75SRw = parcelRequire("75SRw");



parcelRequire("fIF1D");
var $2LaLj = parcelRequire("2LaLj");

var $4ZcUR = parcelRequire("4ZcUR");

var $7kooT = parcelRequire("7kooT");
var $9e3fabb387bbbb57$export$8e77a375f9a5908e;
var $9e3fabb387bbbb57$export$3689e6d0356e8299;
var $9e3fabb387bbbb57$export$bfd64c937657f93a;
var $9e3fabb387bbbb57$export$4a6dd88bada4e7d2;
$9e3fabb387bbbb57$export$8e77a375f9a5908e = `ch4mzq_roles`;
$9e3fabb387bbbb57$export$3689e6d0356e8299 = `ch4mzq_rolesHeader`;
$9e3fabb387bbbb57$export$bfd64c937657f93a = `ch4mzq_rotating`;
$9e3fabb387bbbb57$export$4a6dd88bada4e7d2 = `ch4mzq_shimmer`;


function $b5b2241bddddf2cb$var$UserOrganizations() {
    const [keyword, setKeyword] = (0, $jC8Vy.useState)("");
    const { user: { id: id } } = (0, $2Phw0.useOutletContext)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getPathname: getPathname } = (0, $4ZcUR.default)();
    // Since this API has no pagination (to align with ID token claims):
    // - We don't need to use the `page` state.
    // - We can perform frontend filtering.
    const { data: rawData, error: error } = (0, $voszV.default)((0, $7kooT.buildUrl)(`api/users/${id}/organizations`, {
        showFeatured: "1"
    }));
    const isLoading = !rawData && !error;
    const data = rawData?.filter(({ name: name })=>name.toLowerCase().includes(keyword.toLowerCase()));
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3166f28a681c41bb$export$2e2bcd8739ae039), {
        isLoading: isLoading,
        rowIndexKey: "id",
        rowGroups: [
            {
                key: "data",
                data: data
            }
        ],
        placeholder: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a0f84bc7cc69e410$export$2e2bcd8739ae039), {}),
        columns: [
            {
                title: t("general.name"),
                dataIndex: "name",
                render: ({ name: name, id: id })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $4d952cae22cb03fc$export$2e2bcd8739ae039), {
                        title: name,
                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $c1fc6cc4be9e0c9a$export$2e2bcd8739ae039), {
                            for: (0, $fa5532faa4d9cc63$export$2e2bcd8739ae039)
                        }),
                        to: getPathname(`/organizations/${id}`)
                    })
            },
            {
                title: t("organizations.organization_id"),
                dataIndex: "id",
                render: ({ id: id })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
                        value: id,
                        variant: "text"
                    })
            },
            {
                title: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: $9e3fabb387bbbb57$export$3689e6d0356e8299,
                    children: [
                        t("organizations.organization_role_other"),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2LaLj.default), {
                            content: t("user_details.organization_roles_tooltip"),
                            horizontalAlign: "start",
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                                size: "small",
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $lf8OC.default), {})
                            })
                        })
                    ]
                }),
                dataIndex: "roles",
                render: ({ organizationRoles: organizationRoles })=>/*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $9e3fabb387bbbb57$export$8e77a375f9a5908e,
                        children: organizationRoles.map(({ id: id, name: name })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
                                variant: "cell",
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $be4f434fcf26f56b$export$9b2040b3fe7f4e3f), {
                                    value: id,
                                    title: name
                                })
                            }, id))
                    })
            }
        ],
        filter: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $46c375e0973aedf1$export$2e2bcd8739ae039), {
            defaultValue: keyword,
            isClearable: Boolean(keyword),
            placeholder: t("organization_details.search_user_placeholder"),
            onSearch: setKeyword,
            onClearSearch: ()=>{
                setKeyword("");
            }
        })
    });
}
var $b5b2241bddddf2cb$export$2e2bcd8739ae039 = $b5b2241bddddf2cb$var$UserOrganizations;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");
var $61Yml = parcelRequire("61Yml");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $2Phw0 = parcelRequire("2Phw0");

var $voszV = parcelRequire("voszV");








var $8Mb3E = parcelRequire("8Mb3E");

var $jGWQ4 = parcelRequire("jGWQ4");

var $dL4NZ = parcelRequire("dL4NZ");

var $75SRw = parcelRequire("75SRw");


parcelRequire("fIF1D");
var $16GE9 = parcelRequire("16GE9");

var $7VnwS = parcelRequire("7VnwS");


var $jheqv = parcelRequire("jheqv");

var $7kooT = parcelRequire("7kooT");
var $fbc99b51f62110e4$export$6d59db4903f20f7d;
var $fbc99b51f62110e4$export$3dea766d36a8935f;
var $fbc99b51f62110e4$export$2e4d17fb8dfe5f16;
var $fbc99b51f62110e4$export$bfd64c937657f93a;
var $fbc99b51f62110e4$export$4a6dd88bada4e7d2;
$fbc99b51f62110e4$export$6d59db4903f20f7d = `vRnWHW_description`;
$fbc99b51f62110e4$export$3dea766d36a8935f = `vRnWHW_filter`;
$fbc99b51f62110e4$export$2e4d17fb8dfe5f16 = `vRnWHW_rolesTable`;
$fbc99b51f62110e4$export$bfd64c937657f93a = `vRnWHW_rotating`;
$fbc99b51f62110e4$export$4a6dd88bada4e7d2 = `vRnWHW_shimmer`;


const $5ca03f06bb65cd4d$var$pageSize = (0, $8Mb3E.defaultPageSize);
function $5ca03f06bb65cd4d$var$UserRoles() {
    const theme = (0, $jheqv.default)();
    const { user: user } = (0, $2Phw0.useOutletContext)();
    const { id: userId } = user;
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [{ page: page, keyword: keyword }, updateSearchParameters] = (0, $66a3eb3654f9d141$export$2e2bcd8739ae039)({
        page: 1,
        keyword: ""
    });
    const { data: data, error: error, mutate: mutate } = (0, $voszV.default)((0, $7kooT.buildUrl)(`api/users/${userId}/roles`, {
        page: String(page),
        page_size: String($5ca03f06bb65cd4d$var$pageSize),
        ...(0, $7oDSS.conditional)(keyword && {
            search: (0, $7kooT.formatSearchKeyword)(keyword)
        })
    }));
    const isLoading = !data && !error;
    const [roles, totalCount] = data ?? [];
    const [isAssignRolesModalOpen, setIsAssignRolesModalOpen] = (0, $jC8Vy.useState)(false);
    const [roleToBeDeleted, setRoleToBeDeleted] = (0, $jC8Vy.useState)();
    const [isDeleting, setIsDeleting] = (0, $jC8Vy.useState)(false);
    const api = (0, $7VnwS.default)();
    const handleDelete = async ()=>{
        if (!roleToBeDeleted || isDeleting) return;
        setIsDeleting(true);
        try {
            await api.delete(`api/users/${userId}/roles/${roleToBeDeleted.id}`);
            (0, $FuhPC.toast).success(t("user_details.roles.deleted", {
                name: roleToBeDeleted.name
            }));
            await mutate();
            setRoleToBeDeleted(undefined);
        } finally{
            setIsDeleting(false);
        }
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3166f28a681c41bb$export$2e2bcd8739ae039), {
                className: $fbc99b51f62110e4$export$2e4d17fb8dfe5f16,
                isLoading: isLoading,
                rowGroups: [
                    {
                        key: "roles",
                        data: roles
                    }
                ],
                rowIndexKey: "id",
                columns: [
                    {
                        title: t("user_details.roles.name_column"),
                        dataIndex: "name",
                        colSpan: 6,
                        render: ({ id: id, name: name })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $4d952cae22cb03fc$export$2e2bcd8739ae039), {
                                title: name,
                                to: `/roles/${id}`,
                                icon: theme === (0, $5HVJe.Theme).Dark ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0663a2b9fa963923$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4c2e4598d85b0069$export$2e2bcd8739ae039), {})
                            })
                    },
                    {
                        title: t("user_details.roles.description_column"),
                        dataIndex: "description",
                        colSpan: 9,
                        render: ({ description: description })=>/*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $fbc99b51f62110e4$export$6d59db4903f20f7d,
                                children: description
                            })
                    },
                    {
                        title: null,
                        dataIndex: "delete",
                        colSpan: 1,
                        render: (role)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $16GE9.default), {
                                content: t("general.remove"),
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $75SRw.default), {
                                    onClick: ()=>{
                                        setRoleToBeDeleted(role);
                                    },
                                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3aa588de5c8665f2$export$2e2bcd8739ae039), {})
                                })
                            })
                    }
                ],
                filter: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                    className: $fbc99b51f62110e4$export$3dea766d36a8935f,
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $46c375e0973aedf1$export$2e2bcd8739ae039), {
                            defaultValue: keyword,
                            isClearable: Boolean(keyword),
                            placeholder: t("user_details.roles.search"),
                            onSearch: (keyword)=>{
                                updateSearchParameters({
                                    keyword: keyword,
                                    page: 1
                                });
                            },
                            onClearSearch: ()=>{
                                updateSearchParameters({
                                    keyword: "",
                                    page: 1
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                            title: "user_details.roles.assign_button",
                            type: "primary",
                            size: "large",
                            icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0b30fe81c923292b$export$2e2bcd8739ae039), {}),
                            onClick: ()=>{
                                setIsAssignRolesModalOpen(true);
                            }
                        })
                    ]
                }),
                pagination: {
                    page: page,
                    pageSize: $5ca03f06bb65cd4d$var$pageSize,
                    totalCount: totalCount,
                    onChange: (page)=>{
                        updateSearchParameters({
                            page: page
                        });
                    }
                },
                placeholder: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a0f84bc7cc69e410$export$2e2bcd8739ae039), {}),
                errorMessage: error?.body?.message ?? error?.message,
                onRetry: async ()=>mutate(undefined, true)
            }),
            roleToBeDeleted && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dL4NZ.default), {
                isOpen: true,
                isLoading: isDeleting,
                confirmButtonText: "general.remove",
                onCancel: ()=>{
                    setRoleToBeDeleted(undefined);
                },
                onConfirm: handleDelete,
                children: t("user_details.roles.delete_description")
            }),
            isAssignRolesModalOpen && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5980bec6c22435f4$export$2e2bcd8739ae039), {
                entity: user,
                type: (0, $61Yml.RoleType).User,
                onClose: (success)=>{
                    if (success) mutate();
                    setIsAssignRolesModalOpen(false);
                }
            })
        ]
    });
}
var $5ca03f06bb65cd4d$export$2e2bcd8739ae039 = $5ca03f06bb65cd4d$var$UserRoles;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("4taJ0");
var $9vrm1 = parcelRequire("9vrm1");
parcelRequire("ajkVG");
var $51A9u = parcelRequire("51A9u");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");
var $3dBAh = parcelRequire("3dBAh");

var $bJ3GU = parcelRequire("bJ3GU");

var $codQP = parcelRequire("codQP");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $2Phw0 = parcelRequire("2Phw0");




var $kUskP = parcelRequire("kUskP");

var $aqmjm = parcelRequire("aqmjm");

var $fmHmG = parcelRequire("fmHmG");

var $7VnwS = parcelRequire("7VnwS");

var $kBpQ2 = parcelRequire("kBpQ2");


var $5OcFi = parcelRequire("5OcFi");

var $3RCsa = parcelRequire("3RCsa");

var $cRLgg = parcelRequire("cRLgg");
parcelRequire("ajkVG");
var $51A9u = parcelRequire("51A9u");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");
const $530f7445b8d2f1e7$export$bd77d53e275ee7f4 = {
    toLocalForm: (data)=>{
        const { primaryEmail: primaryEmail, primaryPhone: primaryPhone, username: username, name: name, avatar: avatar, customData: customData } = data;
        const parsedPhoneNumber = (0, $7oDSS.conditional)(primaryPhone && (0, $51A9u.formatToInternationalPhoneNumber)(primaryPhone));
        return {
            primaryEmail: primaryEmail ?? "",
            primaryPhone: parsedPhoneNumber ?? primaryPhone ?? "",
            username: username ?? "",
            name: name ?? "",
            avatar: avatar ?? "",
            customData: JSON.stringify(customData, null, 2)
        };
    }
};



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $voszV = parcelRequire("voszV");



var $jGWQ4 = parcelRequire("jGWQ4");


var $7VnwS = parcelRequire("7VnwS");

var $kBpQ2 = parcelRequire("kBpQ2");
var $cfa273a634a74e76$export$b84494756f225a7d;
var $cfa273a634a74e76$export$bfd64c937657f93a;
var $cfa273a634a74e76$export$4a6dd88bada4e7d2;
$cfa273a634a74e76$export$b84494756f225a7d = `OrZ14a_fieldDescription`;
$cfa273a634a74e76$export$bfd64c937657f93a = `OrZ14a_rotating`;
$cfa273a634a74e76$export$4a6dd88bada4e7d2 = `OrZ14a_shimmer`;


function $919c80e2b591d79a$var$UserMfaVerifications({ userId: userId }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console.user_details.mfa"
    });
    const { data: mfaVerifications, error: error, isLoading: isLoading, mutate: mutate } = (0, $voszV.default)(`api/users/${userId}/mfa-verifications`);
    const api = (0, $7VnwS.default)();
    const { show: showConfirm } = (0, $kBpQ2.useConfirmModal)();
    const handleDelete = (0, $jC8Vy.useCallback)(async (mfaVerification)=>{
        const [result] = await showConfirm({
            ModalContent: ()=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                    t: t,
                    i18nKey: "deletion_confirmation",
                    components: {
                        name: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7c7d50aa193e10ff$export$2e2bcd8739ae039), {
                            ...mfaVerification
                        })
                    }
                }),
            confirmButtonText: "general.remove"
        });
        if (!result) return;
        await api.delete(`api/users/${userId}/mfa-verifications/${mfaVerification.id}`);
        mutate(mfaVerifications?.filter((item)=>item.id !== mfaVerification.id));
    }, [
        api,
        mfaVerifications,
        mutate,
        showConfirm,
        t,
        userId
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            !isLoading && !error && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $cfa273a634a74e76$export$b84494756f225a7d,
                children: t(mfaVerifications?.length ? "field_description" : "field_description_empty")
            }),
            (isLoading || Boolean(mfaVerifications?.length) || error) && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3166f28a681c41bb$export$2e2bcd8739ae039), {
                hasBorder: true,
                rowGroups: [
                    {
                        key: "mfaVerifications",
                        data: mfaVerifications
                    }
                ],
                rowIndexKey: "id",
                isLoading: isLoading,
                errorMessage: error?.body?.message ?? error?.message,
                columns: [
                    {
                        title: t("name_column"),
                        dataIndex: "name",
                        colSpan: 13,
                        render: (mfaVerification)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $f5eba2852d88b12e$export$2e2bcd8739ae039), {
                                ...mfaVerification
                            })
                    },
                    {
                        title: null,
                        dataIndex: "action",
                        colSpan: 3,
                        render: (mfaVerification)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                                title: "general.remove",
                                type: "text",
                                size: "small",
                                onClick: ()=>{
                                    handleDelete(mfaVerification);
                                }
                            })
                    }
                ],
                onRetry: ()=>{
                    mutate();
                }
            })
        ]
    });
}
var $919c80e2b591d79a$export$2e2bcd8739ae039 = $919c80e2b591d79a$var$UserMfaVerifications;



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");

var $voszV = parcelRequire("voszV");


var $jGWQ4 = parcelRequire("jGWQ4");

var $cw2No = parcelRequire("cw2No");




var $7VnwS = parcelRequire("7VnwS");

var $19335b948d24954e$export$ded9b5979746c93f;
var $19335b948d24954e$export$6d59db4903f20f7d;
var $19335b948d24954e$export$1ca1ec8b29a4ce27;
var $19335b948d24954e$export$a8ff84c12d48cfa6;
var $19335b948d24954e$export$bfd64c937657f93a;
var $19335b948d24954e$export$4a6dd88bada4e7d2;
var $19335b948d24954e$export$d9aa71f96dda8d28;
$19335b948d24954e$export$ded9b5979746c93f = `Q4-sxa_connectorName`;
$19335b948d24954e$export$6d59db4903f20f7d = `Q4-sxa_description`;
$19335b948d24954e$export$1ca1ec8b29a4ce27 = `Q4-sxa_icon`;
$19335b948d24954e$export$a8ff84c12d48cfa6 = `Q4-sxa_name`;
$19335b948d24954e$export$bfd64c937657f93a = `Q4-sxa_rotating`;
$19335b948d24954e$export$4a6dd88bada4e7d2 = `Q4-sxa_shimmer`;
$19335b948d24954e$export$d9aa71f96dda8d28 = `Q4-sxa_userId`;


function $9e56b78c508a2386$var$ConnectorName({ name: name }) {
    return typeof name === "string" ? /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
        children: name
    }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ee1df03577241ccd$export$2e2bcd8739ae039), {
        resource: name
    });
}
function $9e56b78c508a2386$var$UserSocialIdentities({ userId: userId, identities: identities, onDelete: onDelete }) {
    const api = (0, $7VnwS.default)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: data, error: error, isLoading: isLoading, mutate: mutate } = (0, $voszV.default)("api/connectors");
    const [deletingConnector, setDeletingConnector] = (0, $jC8Vy.useState)();
    const [isSubmitting, setIsSubmitting] = (0, $jC8Vy.useState)(false);
    const connectorGroups = (0, $jC8Vy.useMemo)(()=>{
        if (!data?.length) return;
        return (0, $be65b460d85f5eb9$export$48daf4eb8bb4366e)(data);
    }, [
        data
    ]);
    const handleDelete = async (target)=>{
        if (isSubmitting) return;
        setIsSubmitting(true);
        try {
            await api.delete(`api/users/${userId}/identities/${target}`);
            onDelete?.(target);
        } finally{
            setIsSubmitting(false);
        }
    };
    const displayConnectors = (0, $jC8Vy.useMemo)(()=>{
        if (!connectorGroups) return;
        return Object.keys(identities).map((key)=>{
            const { logo: logo, name: name } = connectorGroups.find((group)=>group.target === key) ?? {};
            const socialUserId = identities[key]?.userId;
            return {
                logo: logo,
                name: name ?? t("connectors.unknown"),
                target: key,
                userId: socialUserId
            };
        });
    }, [
        connectorGroups,
        identities,
        t
    ]);
    const hasConnectors = Boolean(displayConnectors && displayConnectors.length > 0);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        children: [
            !isLoading && !error && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $19335b948d24954e$export$6d59db4903f20f7d,
                children: t(hasConnectors ? "user_details.connectors.connected" : "user_details.connectors.not_connected")
            }),
            (isLoading || hasConnectors || error) && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3166f28a681c41bb$export$2e2bcd8739ae039), {
                hasBorder: true,
                rowGroups: [
                    {
                        key: "identities",
                        data: displayConnectors
                    }
                ],
                rowIndexKey: "target",
                isLoading: isLoading,
                errorMessage: error?.body?.message ?? error?.message,
                columns: [
                    {
                        title: t("user_details.connectors.connectors"),
                        dataIndex: "name",
                        colSpan: 5,
                        render: ({ logo: logo, name: name })=>/*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                className: $19335b948d24954e$export$ded9b5979746c93f,
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dbaecc0d7fe55772$export$2e2bcd8739ae039), {
                                        className: $19335b948d24954e$export$1ca1ec8b29a4ce27,
                                        src: logo,
                                        alt: "logo"
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $19335b948d24954e$export$a8ff84c12d48cfa6,
                                        children: /*#__PURE__*/ (0, $C7mD2.jsx)($9e56b78c508a2386$var$ConnectorName, {
                                            name: name
                                        })
                                    })
                                ]
                            })
                    },
                    {
                        title: t("user_details.connectors.user_id"),
                        dataIndex: "userId",
                        colSpan: 8,
                        render: ({ userId: userId = "" })=>/*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                className: $19335b948d24954e$export$d9aa71f96dda8d28,
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                                        children: userId || "-"
                                    }),
                                    userId && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
                                        variant: "icon",
                                        value: userId
                                    })
                                ]
                            })
                    },
                    {
                        title: null,
                        dataIndex: "action",
                        colSpan: 3,
                        render: (connector)=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                                title: "user_details.connectors.remove",
                                type: "text",
                                size: "small",
                                onClick: ()=>{
                                    setDeletingConnector(connector);
                                }
                            })
                    }
                ],
                onRetry: async ()=>mutate(undefined, true)
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7065f4e52ae4e862$export$2e2bcd8739ae039), {
                isOpen: deletingConnector !== undefined,
                isLoading: isSubmitting,
                onCancel: ()=>{
                    setDeletingConnector(undefined);
                },
                onConfirm: async ()=>{
                    if (deletingConnector) {
                        await handleDelete(deletingConnector.target);
                        setDeletingConnector(undefined);
                    }
                },
                children: deletingConnector && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                    t: t,
                    i18nKey: "user_details.connectors.deletion_confirmation",
                    components: {
                        name: /*#__PURE__*/ (0, $C7mD2.jsx)($9e56b78c508a2386$var$ConnectorName, {
                            name: deletingConnector.name
                        })
                    }
                })
            })
        ]
    });
}
var $9e56b78c508a2386$export$2e2bcd8739ae039 = $9e56b78c508a2386$var$UserSocialIdentities;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $kupPr = parcelRequire("kupPr");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $voszV = parcelRequire("voszV");

var $c3dK3 = parcelRequire("c3dK3");

var $cw2No = parcelRequire("cw2No");



const $d09d28f085b766cf$var$isIdentityDisplayConnector = (identity)=>{
    // `DisplayConnector` instance should have `providerLogo`, `providerLogoDark` and `name` to be non-empty string and `branding` to be an object.
    const identityGuard = (0, $c3dK3.z).object({
        providerLogo: (0, $c3dK3.z).string().min(1),
        providerLogoDark: (0, $c3dK3.z).string().min(1),
        branding: (0, $kupPr.ssoBrandingGuard),
        name: (0, $c3dK3.z).string().min(1)
    });
    const result = identityGuard.safeParse(identity);
    return result.success;
};
function $d09d28f085b766cf$var$UserSsoIdentities({ ssoIdentities: ssoIdentities }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: data, error: error, mutate: mutate } = (0, $voszV.default)("api/sso-connectors");
    const isLoading = !data && !error;
    const displaySsoConnectors = (0, $jC8Vy.useMemo)(()=>{
        if (!data) return;
        return ssoIdentities.map((identity)=>{
            const { providerLogo: providerLogo, providerLogoDark: providerLogoDark, branding: branding, connectorName: name } = data.find((ssoConnector)=>ssoConnector.id === identity.ssoConnectorId) ?? {};
            const { identityId: userIdentity, issuer: issuer } = identity;
            return {
                providerLogo: providerLogo,
                providerLogoDark: providerLogoDark,
                branding: branding,
                name: name,
                userIdentity: userIdentity,
                issuer: issuer
            };
        }).filter((identity)=>$d09d28f085b766cf$var$isIdentityDisplayConnector(identity));
    }, [
        data,
        ssoIdentities
    ]);
    const hasLinkedSsoIdentities = Boolean(displaySsoConnectors && displaySsoConnectors.length > 0);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        children: [
            !isLoading && !error && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $19335b948d24954e$export$6d59db4903f20f7d,
                children: t(hasLinkedSsoIdentities ? "user_details.sso_connectors.connected" : "user_details.sso_connectors.not_connected")
            }),
            (isLoading || hasLinkedSsoIdentities || error) && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3166f28a681c41bb$export$2e2bcd8739ae039), {
                hasBorder: true,
                rowGroups: [
                    {
                        key: "ssoIdentity",
                        data: displaySsoConnectors
                    }
                ],
                rowIndexKey: "issuer",
                isLoading: isLoading,
                errorMessage: error?.body?.message ?? error?.message,
                columns: [
                    {
                        title: t("user_details.sso_connectors.connectors"),
                        dataIndex: "name",
                        colSpan: 5,
                        render: ({ providerLogo: providerLogo, providerLogoDark: providerLogoDark, branding: branding, name: name })=>/*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                className: $19335b948d24954e$export$ded9b5979746c93f,
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $608656f1bddbd059$export$2e2bcd8739ae039), {
                                        containerClassName: $19335b948d24954e$export$1ca1ec8b29a4ce27,
                                        data: {
                                            providerLogo: providerLogo,
                                            providerLogoDark: providerLogoDark,
                                            branding: branding
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                        className: $19335b948d24954e$export$a8ff84c12d48cfa6,
                                        children: /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                                            children: name
                                        })
                                    })
                                ]
                            })
                    },
                    {
                        title: t("user_details.sso_connectors.enterprise_id"),
                        dataIndex: "userIdentity",
                        colSpan: 8,
                        render: ({ userIdentity: userIdentity })=>/*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                                className: $19335b948d24954e$export$d9aa71f96dda8d28,
                                children: [
                                    /*#__PURE__*/ (0, $C7mD2.jsx)("span", {
                                        children: userIdentity || "-"
                                    }),
                                    userIdentity && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
                                        variant: "icon",
                                        value: userIdentity
                                    })
                                ]
                            })
                    },
                    {
                        title: null,
                        dataIndex: "action",
                        colSpan: 3,
                        // Align with the social identities column span, leave the deletion action blank since SSO identities is not deletable in this user details page.
                        render: ()=>/*#__PURE__*/ (0, $C7mD2.jsx)("div", {})
                    }
                ],
                onRetry: async ()=>mutate(undefined, true)
            })
        ]
    });
}
var $d09d28f085b766cf$export$2e2bcd8739ae039 = $d09d28f085b766cf$var$UserSsoIdentities;


function $1cf76a2ed04c1275$var$UserSettings() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $b595fc2f0eccd19a$export$2e2bcd8739ae039)();
    const { show: show } = (0, $kBpQ2.useConfirmModal)();
    const { user: user, isDeleting: isDeleting, onUserUpdated: onUserUpdated } = (0, $2Phw0.useOutletContext)();
    const userFormData = (0, $530f7445b8d2f1e7$export$bd77d53e275ee7f4).toLocalForm(user);
    const { handleSubmit: handleSubmit, register: register, control: control, reset: reset, formState: { isSubmitting: isSubmitting, errors: errors, isDirty: isDirty } } = (0, $codQP.useForm)({
        defaultValues: userFormData
    });
    const { field: { onChange: onChange, value: value } } = (0, $codQP.useController)({
        name: "customData",
        control: control
    });
    const api = (0, $7VnwS.default)();
    const onSubmit = handleSubmit((0, $5OcFi.trySubmitSafe)(async (formData)=>{
        if (isSubmitting) return;
        const { identities: identities, id: userId } = user;
        const { customData: inputCustomData, username: username, primaryEmail: primaryEmail, primaryPhone: primaryPhone } = formData;
        if (!username && !primaryEmail && !primaryPhone && Object.keys(identities).length === 0) {
            const [result] = await show({
                ModalContent: t("user_details.warning_no_sign_in_identifier"),
                type: "confirm"
            });
            if (!result) return;
        }
        const parseResult = (0, $3RCsa.safeParseJsonObject)(inputCustomData);
        if (!parseResult.success) {
            (0, $FuhPC.toast).error(t("user_details.custom_data_invalid"));
            return;
        }
        const payload = {
            ...formData,
            primaryPhone: (0, $7oDSS.conditionalString)(primaryPhone && (0, $51A9u.parsePhoneNumber)(primaryPhone)),
            customData: parseResult.data
        };
        const updatedUser = await api.patch(`api/users/${userId}`, {
            json: payload
        }).json();
        reset((0, $530f7445b8d2f1e7$export$bd77d53e275ee7f4).toLocalForm(updatedUser));
        onUserUpdated(updatedUser);
        (0, $FuhPC.toast).success(t("general.saved"));
    }));
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $f0e7fd6d3bded790$export$2e2bcd8739ae039), {
                isSubmitting: isSubmitting,
                isDirty: isDirty,
                onSubmit: onSubmit,
                onDiscard: reset,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
                        title: "user_details.authentication",
                        description: "user_details.authentication_description",
                        learnMoreLink: {
                            href: getDocumentationUrl("/docs/references/users"),
                            targetBlank: "noopener"
                        },
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                title: "user_details.field_email",
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                    ...register("primaryEmail", {
                                        pattern: {
                                            value: (0, $9vrm1.emailRegEx),
                                            message: t("errors.email_pattern_error")
                                        }
                                    }),
                                    error: errors.primaryEmail?.message,
                                    placeholder: t("users.placeholder_email")
                                })
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                title: "user_details.field_phone",
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                    ...register("primaryPhone", {
                                        validate: (value)=>{
                                            if (!value) return true;
                                            const parsed = (0, $3dBAh.trySafe)(()=>(0, $bJ3GU.parsePhoneNumberWithError)(value));
                                            return(// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                                            parsed?.isValid() || t("errors.phone_pattern_error"));
                                        }
                                    }),
                                    error: errors.primaryPhone?.message,
                                    placeholder: t("users.placeholder_phone")
                                })
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                title: "user_details.field_username",
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                    ...register("username", {
                                        pattern: {
                                            value: (0, $9vrm1.usernameRegEx),
                                            message: t("errors.username_pattern_error")
                                        }
                                    }),
                                    error: errors.username?.message,
                                    placeholder: t("users.placeholder_username")
                                })
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                title: "user_details.field_connectors",
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9e56b78c508a2386$export$2e2bcd8739ae039), {
                                    userId: user.id,
                                    identities: user.identities,
                                    onDelete: ()=>{
                                        onUserUpdated();
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                title: "user_details.field_sso_connectors",
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $d09d28f085b766cf$export$2e2bcd8739ae039), {
                                    ssoIdentities: user.ssoIdentities ?? []
                                })
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                title: "user_details.mfa.field_name",
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $919c80e2b591d79a$export$2e2bcd8739ae039), {
                                    userId: user.id
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
                        title: "user_details.user_profile",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                title: "user_details.field_name",
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                    ...register("name"),
                                    placeholder: t("users.placeholder_name")
                                })
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                title: "user_details.field_avatar",
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                    ...register("avatar", {
                                        validate: (value)=>!value || (0, $cRLgg.uriValidator)(value) || t("errors.invalid_uri_format")
                                    }),
                                    error: errors.avatar?.message,
                                    placeholder: t("user_details.field_avatar_placeholder")
                                })
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                                isRequired: true,
                                title: "user_details.field_custom_data",
                                tip: t("user_details.field_custom_data_tip"),
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $kUskP.default), {
                                    language: "json",
                                    value: value,
                                    onChange: onChange
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fea55fa5d5726e29$export$2e2bcd8739ae039), {
                hasUnsavedChanges: !isDeleting && isDirty
            })
        ]
    });
}
var $1cf76a2ed04c1275$export$2e2bcd8739ae039 = $1cf76a2ed04c1275$var$UserSettings;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
parcelRequire("6bq3s");
var $2Phw0 = parcelRequire("2Phw0");

var $voszV = parcelRequire("voszV");










var $8Mb3E = parcelRequire("8Mb3E");

var $bt3dS = parcelRequire("bt3dS");

var $jGWQ4 = parcelRequire("jGWQ4");




var $4ZcUR = parcelRequire("4ZcUR");

var $7kooT = parcelRequire("7kooT");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("4taJ0");
var $9vrm1 = parcelRequire("9vrm1");
parcelRequire("ajkVG");
var $51A9u = parcelRequire("51A9u");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $kUZ14 = parcelRequire("kUZ14");
parcelRequire("6bq3s");
var $2Phw0 = parcelRequire("2Phw0");


var $jGWQ4 = parcelRequire("jGWQ4");

var $aqmjm = parcelRequire("aqmjm");

var $5vVWy = parcelRequire("5vVWy");

var $fmHmG = parcelRequire("fmHmG");

var $7VnwS = parcelRequire("7VnwS");

var $4ZcUR = parcelRequire("4ZcUR");

var $dW2kG = parcelRequire("dW2kG");

var $5OcFi = parcelRequire("5OcFi");

var $f4f38fb81cf61c36$export$a3bc9b8ed74fc;
var $f4f38fb81cf61c36$export$bfd64c937657f93a;
var $f4f38fb81cf61c36$export$4a6dd88bada4e7d2;
$f4f38fb81cf61c36$export$a3bc9b8ed74fc = `ZN2xuG_error`;
$f4f38fb81cf61c36$export$bfd64c937657f93a = `ZN2xuG_rotating`;
$f4f38fb81cf61c36$export$4a6dd88bada4e7d2 = `ZN2xuG_shimmer`;


function $73085e0538719d74$var$CreateForm({ onClose: onClose, onCreate: onCreate }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { search: search } = (0, $2Phw0.useLocation)();
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const [createdUserInfo, setCreatedUserInfo] = (0, $jC8Vy.useState)();
    const [missingIdentifierError, setMissingIdentifierError] = (0, $jC8Vy.useState)();
    const { handleSubmit: handleSubmit, register: register, formState: { isSubmitting: isSubmitting, errors: errors, submitCount: submitCount }, getValues: getValues } = (0, $codQP.useForm)();
    const api = (0, $7VnwS.default)();
    const hasIdentifier = ()=>{
        const { username: username, primaryEmail: primaryEmail, primaryPhone: primaryPhone } = getValues();
        return Boolean(username) || Boolean(primaryEmail) || Boolean(primaryPhone);
    };
    const revalidateForm = ()=>{
        if (submitCount) {
            if (hasIdentifier()) setMissingIdentifierError(undefined);
            else setMissingIdentifierError(t("users.error_missing_identifier"));
        }
    };
    const onSubmit = handleSubmit((0, $5OcFi.trySubmitSafe)(async (data)=>{
        if (isSubmitting) return;
        setMissingIdentifierError(undefined);
        if (!hasIdentifier()) {
            setMissingIdentifierError(t("users.error_missing_identifier"));
            return;
        }
        const password = (0, $5f56a5d87b3d4d33$export$832e1ed778c99ea4)();
        const { primaryPhone: primaryPhone } = data;
        const userData = {
            ...data,
            password: password,
            ...(0, $7oDSS.conditional)(primaryPhone && {
                primaryPhone: (0, $51A9u.parsePhoneNumber)(primaryPhone)
            })
        };
        // Filter out empty values
        const payload = Object.fromEntries(Object.entries(userData).filter(([, value])=>Boolean(value)));
        try {
            const createdUser = await api.post("api/users", {
                json: payload
            }).json();
            setCreatedUserInfo({
                user: createdUser,
                password: password
            });
            onCreate();
        } catch  {
        // Do nothing since we only show error toasts, which is handled in the useApi hook
        }
    }));
    return createdUserInfo ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ca754f0b8a51f8f3$export$2e2bcd8739ae039), {
        title: "user_details.created_title",
        user: createdUserInfo.user,
        password: createdUserInfo.password,
        confirmButtonTitle: "users.check_user_detail",
        onClose: ()=>{
            navigate({
                pathname: "/users",
                search: search
            });
        },
        onConfirm: ()=>{
            navigate(`/users/${createdUserInfo.user.id}`, {
                replace: true
            });
        }
    }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        shouldCloseOnEsc: true,
        isOpen: true,
        className: $dW2kG.content,
        overlayClassName: $dW2kG.overlay,
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $5vVWy.default), {
            title: "users.create",
            subtitle: "users.create_subtitle",
            footer: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                disabled: isSubmitting,
                htmlType: "submit",
                title: "users.create",
                size: "large",
                type: "primary",
                onClick: onSubmit
            }),
            onClose: onClose,
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsxs)("form", {
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                            title: "user_details.field_email",
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                // eslint-disable-next-line jsx-a11y/no-autofocus
                                autoFocus: true,
                                ...register("primaryEmail", {
                                    pattern: {
                                        value: (0, $9vrm1.emailRegEx),
                                        message: t("errors.email_pattern_error")
                                    },
                                    onChange: ()=>{
                                        revalidateForm();
                                    }
                                }),
                                placeholder: t("users.placeholder_email"),
                                error: errors.primaryEmail?.message ?? Boolean(missingIdentifierError)
                            })
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                            title: "user_details.field_phone",
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                ...register("primaryPhone", {
                                    pattern: {
                                        value: (0, $9vrm1.phoneInputRegEx),
                                        message: t("errors.phone_pattern_error")
                                    },
                                    onChange: ()=>{
                                        revalidateForm();
                                    }
                                }),
                                placeholder: t("users.placeholder_phone"),
                                error: errors.primaryPhone?.message ?? Boolean(missingIdentifierError)
                            })
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                            title: "user_details.field_username",
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                                ...register("username", {
                                    pattern: {
                                        value: (0, $9vrm1.usernameRegEx),
                                        message: t("errors.username_pattern_error")
                                    },
                                    onChange: ()=>{
                                        revalidateForm();
                                    }
                                }),
                                placeholder: t("users.placeholder_username"),
                                error: errors.username?.message ?? Boolean(missingIdentifierError)
                            })
                        })
                    ]
                }),
                missingIdentifierError && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $f4f38fb81cf61c36$export$a3bc9b8ed74fc,
                    children: missingIdentifierError
                })
            ]
        })
    });
}
var $73085e0538719d74$export$2e2bcd8739ae039 = $73085e0538719d74$var$CreateForm;



const $5157f731e60291e0$var$pageSize = (0, $8Mb3E.defaultPageSize);
const $5157f731e60291e0$var$usersPathname = "/users";
const $5157f731e60291e0$var$createUserPathname = `${$5157f731e60291e0$var$usersPathname}/create`;
const $5157f731e60291e0$var$buildDetailsPathname = (id)=>`${$5157f731e60291e0$var$usersPathname}/${id}/${(0, $bt3dS.UserDetailsTabs).Settings}`;
function $5157f731e60291e0$var$Users() {
    const { search: search } = (0, $2Phw0.useLocation)();
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [{ page: page, keyword: keyword }, updateSearchParameters] = (0, $66a3eb3654f9d141$export$2e2bcd8739ae039)({
        page: 1,
        keyword: ""
    });
    const url = (0, $7kooT.buildUrl)("api/users", {
        page: String(page),
        page_size: String($5157f731e60291e0$var$pageSize),
        ...(0, $7oDSS.conditional)(keyword && {
            search: (0, $7kooT.formatSearchKeyword)(keyword)
        })
    });
    const { data: data, error: error, mutate: mutate } = (0, $voszV.default)(url);
    const isLoading = !data && !error;
    const { navigate: navigate, match: match } = (0, $4ZcUR.default)();
    const [users, totalCount] = data ?? [];
    const isCreating = match($5157f731e60291e0$var$createUserPathname);
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $998b64ca82ed2460$export$2e2bcd8739ae039), {
        title: {
            title: "users.title",
            subtitle: "users.subtitle"
        },
        pageMeta: {
            titleKey: "users.page_title"
        },
        createButton: {
            title: "users.create",
            onClick: ()=>{
                navigate({
                    pathname: $5157f731e60291e0$var$createUserPathname,
                    search: search
                });
            }
        },
        table: {
            rowGroups: [
                {
                    key: "users",
                    data: users
                }
            ],
            rowIndexKey: "id",
            isLoading: isLoading,
            errorMessage: error?.body?.message ?? error?.message,
            columns: [
                {
                    title: t("users.user_name"),
                    dataIndex: "name",
                    colSpan: 6,
                    render: (user)=>{
                        const { id: id, isSuspended: isSuspended } = user;
                        return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4d952cae22cb03fc$export$2e2bcd8739ae039), {
                            title: (0, $46451cbb59c7a857$export$5f7a1baecd59f846)(user),
                            subtitle: (0, $46451cbb59c7a857$export$336d714c72178bf2)(user),
                            icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $e999fd6c93542895$export$2e2bcd8739ae039), {
                                size: "large",
                                user: user
                            }),
                            to: $5157f731e60291e0$var$buildDetailsPathname(id),
                            suffix: (0, $7oDSS.conditional)(isSuspended && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6f644f560eac971b$export$2e2bcd8739ae039), {}))
                        });
                    }
                },
                {
                    title: t("users.application_name"),
                    dataIndex: "app",
                    colSpan: 5,
                    render: ({ applicationId: applicationId })=>applicationId ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0004ff537e7bb7fe$export$2e2bcd8739ae039), {
                            applicationId: applicationId
                        }) : /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            children: "-"
                        })
                },
                {
                    title: t("users.latest_sign_in"),
                    dataIndex: "lastSignInAt",
                    colSpan: 5,
                    render: ({ lastSignInAt: lastSignInAt })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $5bc18cf18674bbc6$export$2e2bcd8739ae039), {
                            children: lastSignInAt
                        })
                }
            ],
            filter: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $46c375e0973aedf1$export$2e2bcd8739ae039), {
                placeholder: t("users.search"),
                defaultValue: keyword,
                isClearable: Boolean(keyword),
                onSearch: (keyword)=>{
                    updateSearchParameters({
                        keyword: keyword,
                        page: 1
                    });
                },
                onClearSearch: ()=>{
                    updateSearchParameters({
                        keyword: "",
                        page: 1
                    });
                }
            }),
            placeholder: keyword ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a0f84bc7cc69e410$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2b56c00d3802884b$export$2e2bcd8739ae039), {
                image: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $43a64f0388e27011$export$2e2bcd8739ae039), {}),
                imageDark: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $546b7dcaf6b3e0c2$export$2e2bcd8739ae039), {}),
                title: "users.placeholder_title",
                description: "users.placeholder_description",
                action: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                    title: "users.create",
                    type: "primary",
                    size: "large",
                    icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0b30fe81c923292b$export$2e2bcd8739ae039), {}),
                    onClick: ()=>{
                        navigate({
                            pathname: $5157f731e60291e0$var$createUserPathname,
                            search: search
                        });
                    }
                })
            }),
            rowClickHandler: ({ id: id })=>{
                navigate($5157f731e60291e0$var$buildDetailsPathname(id));
            },
            pagination: {
                page: page,
                pageSize: $5157f731e60291e0$var$pageSize,
                totalCount: totalCount,
                onChange: (page)=>{
                    updateSearchParameters({
                        page: page
                    });
                }
            },
            onRetry: async ()=>mutate(undefined, true)
        },
        widgets: isCreating && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $73085e0538719d74$export$2e2bcd8739ae039), {
            onClose: ()=>{
                navigate({
                    pathname: $5157f731e60291e0$var$usersPathname,
                    search: search
                });
            },
            onCreate: ()=>{
                mutate();
            }
        })
    });
}
var $5157f731e60291e0$export$2e2bcd8739ae039 = $5157f731e60291e0$var$Users;


const $9f94c07d9bd81cd2$export$7652f722913b5d7 = {
    path: "users",
    children: [
        {
            index: true,
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5157f731e60291e0$export$2e2bcd8739ae039), {})
        },
        {
            path: "create",
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5157f731e60291e0$export$2e2bcd8739ae039), {})
        },
        {
            path: ":id",
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1401f45893bfdf2b$export$2e2bcd8739ae039), {}),
            children: [
                {
                    index: true,
                    element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Navigate), {
                        replace: true,
                        to: (0, $bt3dS.UserDetailsTabs).Settings
                    })
                },
                {
                    path: (0, $bt3dS.UserDetailsTabs).Settings,
                    element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1cf76a2ed04c1275$export$2e2bcd8739ae039), {})
                },
                {
                    path: (0, $bt3dS.UserDetailsTabs).Roles,
                    element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5ca03f06bb65cd4d$export$2e2bcd8739ae039), {})
                },
                {
                    path: (0, $bt3dS.UserDetailsTabs).Logs,
                    element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7a15a72f0045244c$export$2e2bcd8739ae039), {})
                },
                {
                    path: (0, $bt3dS.UserDetailsTabs).Organizations,
                    element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $b5b2241bddddf2cb$export$2e2bcd8739ae039), {})
                }
            ]
        },
        {
            path: `:userId/${(0, $bt3dS.UserDetailsTabs).Logs}/:logId`,
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $01bafbd02b1a9b1b$export$2e2bcd8739ae039), {})
        }
    ]
};



var $C7mD2 = parcelRequire("C7mD2");

var $2Phw0 = parcelRequire("2Phw0");
parcelRequire("8Mb3E");
var $bt3dS = parcelRequire("bt3dS");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $2Phw0 = parcelRequire("2Phw0");parcelRequire("6bq3s");
var $2Phw0 = parcelRequire("2Phw0");

var $voszV = parcelRequire("voszV");




var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $136645a5be0308ea$var$SvgWebhookDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 40,
        height: 41,
        viewBox: "0 0 40 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                y: 0.5,
                width: 40,
                height: 40,
                rx: 8,
                fill: "#3A3B59"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.353 20.698a1.015 1.015 0 0 1-.48 1.353 4.983 4.983 0 1 0 7.124 4.501c0-.56.455-1.015 1.015-1.015h7.982a1.015 1.015 0 1 1 0 2.03h-7.04a7.015 7.015 0 0 1-13.953-1.015 7.014 7.014 0 0 1 3.998-6.334 1.015 1.015 0 0 1 1.354.48Z",
                fill: "url(#paint0_linear_8003_152192)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M30 26.434a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
                fill: "url(#paint1_linear_8003_152192)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.488 10.133a4.983 4.983 0 0 0-4.983 8.63 1.016 1.016 0 0 1 .372 1.388l-3.99 6.912a1.015 1.015 0 0 1-1.76-1.015l3.52-6.097a7.015 7.015 0 0 1 7.857-11.577l-.508.88.508-.88a7.014 7.014 0 0 1 3.486 6.63 1.015 1.015 0 0 1-2.025-.16 4.984 4.984 0 0 0-2.477-4.71Z",
                fill: "url(#paint2_linear_8003_152192)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.488 10.133a4.983 4.983 0 0 0-4.983 8.63 1.016 1.016 0 0 1 .372 1.388l-3.99 6.912a1.015 1.015 0 0 1-1.76-1.015l3.52-6.097a7.015 7.015 0 0 1 7.857-11.577l-.508.88.508-.88a7.014 7.014 0 0 1 3.486 6.63 1.015 1.015 0 0 1-2.025-.16 4.984 4.984 0 0 0-2.477-4.71Z",
                fill: "url(#paint3_linear_8003_152192)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M11.501 29.031a3 3 0 1 1 3-5.195 3 3 0 0 1-3 5.195Z",
                fill: "url(#paint4_linear_8003_152192)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M11.501 29.031a3 3 0 1 1 3-5.195 3 3 0 0 1-3 5.195Z",
                fill: "url(#paint5_linear_8003_152192)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.487 13.565a1.015 1.015 0 0 1 1.387.372l3.52 6.096a7.015 7.015 0 0 1 6.097 12.592 7.014 7.014 0 0 1-7.485-.296 1.015 1.015 0 0 1 1.15-1.673 4.983 4.983 0 1 0 .337-8.42 1.015 1.015 0 0 1-1.387-.372l-3.991-6.912a1.015 1.015 0 0 1 .372-1.387Z",
                fill: "url(#paint6_linear_8003_152192)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M18.501 11.836a3 3 0 1 1 3 5.195 3 3 0 0 1-3-5.195Z",
                fill: "url(#paint7_linear_8003_152192)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_8003_152192",
                        x1: 1.646,
                        y1: 25.862,
                        x2: 24.045,
                        y2: 14.569,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#614DDD"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#D47AFE"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_8003_152192",
                        x1: 23.508,
                        y1: 26.871,
                        x2: 29.921,
                        y2: 24.503,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#614DDD"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#D47AFE"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint2_linear_8003_152192",
                        x1: 23.621,
                        y1: 18.838,
                        x2: 14.245,
                        y2: 11.978,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FF897A"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E264F7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint3_linear_8003_152192",
                        x1: 14.001,
                        y1: 25.934,
                        x2: 27.612,
                        y2: 12.644,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FEBEA6"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 0.5,
                                stopColor: "#FC85E9"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E264F7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint4_linear_8003_152192",
                        x1: 11.625,
                        y1: 28.969,
                        x2: 15.438,
                        y2: 24.835,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FF897A"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E264F7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint5_linear_8003_152192",
                        x1: 11.001,
                        y1: 28.934,
                        x2: 15.5,
                        y2: 25.11,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FEBEA6"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 0.5,
                                stopColor: "#FC85E9"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E264F7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint6_linear_8003_152192",
                        x1: 31.329,
                        y1: 32.349,
                        x2: 20.37,
                        y2: 17.327,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#614DDD"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#D47AFE"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint7_linear_8003_152192",
                        x1: 21.663,
                        y1: 16.921,
                        x2: 17.179,
                        y2: 12.944,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#614DDD"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#D47AFE"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $136645a5be0308ea$export$2e2bcd8739ae039 = $136645a5be0308ea$var$SvgWebhookDark;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $9ce7c647d3e6d19b$var$SvgWebhook = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 32,
        height: 32,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                width: 32,
                height: 32,
                rx: 6,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.082 16.212a.812.812 0 0 1-.384 1.082 3.987 3.987 0 1 0 5.7 3.601c0-.448.363-.812.811-.812h6.386a.812.812 0 1 1 0 1.625h-5.632A5.612 5.612 0 0 1 4.8 20.895a5.611 5.611 0 0 1 3.199-5.067.812.812 0 0 1 1.083.384Z",
                fill: "#000"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.082 16.212a.812.812 0 0 1-.384 1.082 3.987 3.987 0 1 0 5.7 3.601c0-.448.363-.812.811-.812h6.386a.812.812 0 1 1 0 1.625h-5.632A5.612 5.612 0 0 1 4.8 20.895a5.611 5.611 0 0 1 3.199-5.067.812.812 0 0 1 1.083.384Z",
                fill: "url(#paint0_linear_540_1415)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M24 20.8a2.4 2.4 0 1 1-4.8 0 2.4 2.4 0 0 1 4.8 0Z",
                fill: "url(#paint1_linear_540_1415)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.99 7.76a3.986 3.986 0 0 0-3.986 6.904.812.812 0 0 1 .297 1.11l-3.193 5.53a.812.812 0 1 1-1.407-.813l2.816-4.877a5.612 5.612 0 0 1 6.285-9.261l-.406.703.406-.703a5.611 5.611 0 0 1 2.79 5.304.812.812 0 0 1-1.62-.128 3.987 3.987 0 0 0-1.982-3.77Z",
                fill: "url(#paint2_linear_540_1415)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.99 7.76a3.986 3.986 0 0 0-3.986 6.904.812.812 0 0 1 .297 1.11l-3.193 5.53a.812.812 0 1 1-1.407-.813l2.816-4.877a5.612 5.612 0 0 1 6.285-9.261l-.406.703.406-.703a5.611 5.611 0 0 1 2.79 5.304.812.812 0 0 1-1.62-.128 3.987 3.987 0 0 0-1.982-3.77Z",
                fill: "url(#paint3_linear_540_1415)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M9.2 22.878a2.4 2.4 0 1 1 2.4-4.156 2.4 2.4 0 0 1-2.4 4.156Z",
                fill: "url(#paint4_linear_540_1415)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M9.2 22.878a2.4 2.4 0 1 1 2.4-4.156 2.4 2.4 0 0 1-2.4 4.156Z",
                fill: "url(#paint5_linear_540_1415)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.589 10.505a.812.812 0 0 1 1.11.298l2.815 4.877a5.612 5.612 0 1 1-1.11 9.837.812.812 0 1 1 .921-1.339 3.987 3.987 0 1 0 .269-6.736.812.812 0 0 1-1.11-.297l-3.192-5.53a.812.812 0 0 1 .297-1.11Z",
                fill: "#000"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.589 10.505a.812.812 0 0 1 1.11.298l2.815 4.877a5.612 5.612 0 1 1-1.11 9.837.812.812 0 1 1 .921-1.339 3.987 3.987 0 1 0 .269-6.736.812.812 0 0 1-1.11-.297l-3.192-5.53a.812.812 0 0 1 .297-1.11Z",
                fill: "url(#paint6_linear_540_1415)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M14.8 9.122a2.4 2.4 0 1 1 2.4 4.156 2.4 2.4 0 0 1-2.4-4.156Z",
                fill: "url(#paint7_linear_540_1415)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_540_1415",
                        x1: 4.333,
                        y1: 21.595,
                        x2: 18.253,
                        y2: 13.251,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_540_1415",
                        x1: 18.816,
                        y1: 21.046,
                        x2: 23.902,
                        y2: 19.304,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint2_linear_540_1415",
                        x1: 18.896,
                        y1: 14.724,
                        x2: 11.395,
                        y2: 9.236,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FF897A"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E264F7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint3_linear_540_1415",
                        x1: 11.2,
                        y1: 20.4,
                        x2: 22.089,
                        y2: 9.768,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FEBEA6"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 0.5,
                                stopColor: "#FC85E9"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E264F7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint4_linear_540_1415",
                        x1: 9.3,
                        y1: 22.828,
                        x2: 12.35,
                        y2: 19.521,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FF897A"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E264F7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint5_linear_540_1415",
                        x1: 8.8,
                        y1: 22.8,
                        x2: 12.4,
                        y2: 19.741,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#FEBEA6"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 0.5,
                                stopColor: "#FC85E9"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E264F7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint6_linear_540_1415",
                        x1: 25.232,
                        y1: 25.808,
                        x2: 11.046,
                        y2: 17.925,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint7_linear_540_1415",
                        x1: 17.606,
                        y1: 13.488,
                        x2: 13.555,
                        y2: 9.955,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $9ce7c647d3e6d19b$export$2e2bcd8739ae039 = $9ce7c647d3e6d19b$var$SvgWebhook;





var $5TsIB = parcelRequire("5TsIB");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

function $bf71bbe717c9527a$var$SuccessRate({ stats: stats, isNumberOnly: isNumberOnly }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { successCount: successCount, requestCount: requestCount } = stats ?? {
        successCount: 0,
        requestCount: 0
    };
    if (requestCount === 0) return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        children: "-"
    });
    const percent = successCount / requestCount * 100;
    const statusStyle = percent < 90 ? "error" : percent < 99 ? "alert" : "success";
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
        variant: "plain",
        type: "state",
        status: statusStyle,
        children: [
            percent.toFixed(2),
            "%",
            !isNumberOnly && ` ${t("webhook_details.success_rate")}`
        ]
    });
}
var $bf71bbe717c9527a$export$2e2bcd8739ae039 = $bf71bbe717c9527a$var$SuccessRate;


parcelRequire("8Mb3E");
var $bt3dS = parcelRequire("bt3dS");

var $66ixW = parcelRequire("66ixW");


var $7VnwS = parcelRequire("7VnwS");

var $kBpQ2 = parcelRequire("kBpQ2");

var $4ZcUR = parcelRequire("4ZcUR");

var $jheqv = parcelRequire("jheqv");

var $7kooT = parcelRequire("7kooT");
var $e697578baa8fd701$export$ff1331ea3d85e750;
var $e697578baa8fd701$export$bfd64c937657f93a;
var $e697578baa8fd701$export$4a6dd88bada4e7d2;
$e697578baa8fd701$export$ff1331ea3d85e750 = `_3gAc1q_containsTableLayout`;
$e697578baa8fd701$export$bfd64c937657f93a = `_3gAc1q_rotating`;
$e697578baa8fd701$export$4a6dd88bada4e7d2 = `_3gAc1q_shimmer`;


function $ad717f5a666bc47c$var$WebhookDetails() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { pathname: pathname } = (0, $2Phw0.useLocation)();
    const isPageHasTable = pathname.endsWith((0, $bt3dS.WebhookDetailsTabs).RecentRequests);
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const { id: id } = (0, $2Phw0.useParams)();
    const { data: data, error: error, mutate: mutate } = (0, $voszV.default)(id && (0, $7kooT.buildUrl)(`api/hooks/${id}`, {
        includeExecutionStats: String(true)
    }));
    const { enabled: isEnabled, executionStats: executionStats } = data ?? {};
    const isLoading = !data && !error;
    const api = (0, $7VnwS.default)();
    const theme = (0, $jheqv.default)();
    const WebhookIcon = theme === "light" ? (0, $9ce7c647d3e6d19b$export$2e2bcd8739ae039) : (0, $136645a5be0308ea$export$2e2bcd8739ae039);
    const { show: show } = (0, $kBpQ2.useConfirmModal)();
    const [isDeleting, setIsDeleting] = (0, $jC8Vy.useState)(false);
    const [isUpdatingEnableState, setIsUpdatingEnableState] = (0, $jC8Vy.useState)(false);
    const handleDelete = async ()=>{
        if (!data || isDeleting) return;
        const [result] = await show({
            ModalContent: ()=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                    forKey: "webhook_details.deletion_reminder"
                }),
            confirmButtonText: "general.delete"
        });
        if (!result) return;
        setIsDeleting(true);
        try {
            await api.delete(`api/hooks/${data.id}`);
            (0, $FuhPC.toast).success(t("webhook_details.deleted", {
                name: data.name
            }));
            navigate("/webhooks");
        } finally{
            setIsDeleting(false);
        }
    };
    const handleToggleEnableState = async ()=>{
        if (!data || isUpdatingEnableState) return;
        if (isEnabled) {
            const [result] = await show({
                ModalContent: ()=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                        forKey: "webhook_details.disable_reminder"
                    }),
                confirmButtonText: "webhook_details.disable_webhook"
            });
            if (!result) return;
        }
        setIsUpdatingEnableState(true);
        try {
            const updatedHook = await api.patch(`api/hooks/${data.id}`, {
                json: {
                    enabled: !isEnabled
                }
            }).json();
            mutate({
                ...updatedHook,
                executionStats: data.executionStats
            });
            const { enabled: enabled } = updatedHook;
            (0, $FuhPC.toast).success(t(`webhook_details.webhook_${enabled ? "reactivated" : "disabled"}`));
        } finally{
            setIsUpdatingEnableState(false);
        }
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aa35f43ec98b7478$export$2e2bcd8739ae039), {
        backLink: "/webhooks",
        backLinkTitle: "webhook_details.back_to_webhooks",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))(isPageHasTable && $e697578baa8fd701$export$ff1331ea3d85e750),
        isLoading: isLoading,
        error: error,
        onRetry: mutate,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5TsIB.default), {
                titleKey: "webhook_details.page_title"
            }),
            data && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $eefae5244405013e$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $C7mD2.jsx)(WebhookIcon, {}),
                        title: data.name,
                        subtitle: isEnabled && t("webhook_details.requests", {
                            value: executionStats?.requestCount ?? 0
                        }),
                        primaryTag: isEnabled ? (0, $7oDSS.conditional)(!!executionStats?.successCount && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $bf71bbe717c9527a$export$2e2bcd8739ae039), {
                            stats: executionStats
                        })) : t("webhook_details.not_in_use"),
                        identifier: {
                            name: "ID",
                            value: data.id
                        },
                        actionMenuItems: [
                            {
                                title: `webhook_details.${isEnabled ? "disable" : "reactivate"}_webhook`,
                                icon: isEnabled ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ffd99e3e12dec5b3$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $d81a97765ce18069$export$2e2bcd8739ae039), {}),
                                onClick: handleToggleEnableState
                            },
                            {
                                title: "webhook_details.delete_webhook",
                                icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3aa588de5c8665f2$export$2e2bcd8739ae039), {}),
                                type: "danger",
                                onClick: handleDelete
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $26090e0c44b20d28$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                                href: `/webhooks/${data.id}/${(0, $bt3dS.WebhookDetailsTabs).Settings}`,
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                    forKey: "webhook_details.settings_tab"
                                })
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8b5950685d0fe3f8$export$2e2bcd8739ae039), {
                                href: `/webhooks/${data.id}/${(0, $bt3dS.WebhookDetailsTabs).RecentRequests}`,
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                    forKey: "webhook_details.recent_requests_tab"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Outlet), {
                        context: {
                            hook: data,
                            isDeleting: isDeleting,
                            onHookUpdated: (hook)=>{
                                if (hook) {
                                    const { executionStats: executionStats } = data;
                                    mutate({
                                        ...hook,
                                        executionStats: executionStats
                                    });
                                    return;
                                }
                                mutate();
                            }
                        }
                    })
                ]
            })
        ]
    });
}
var $ad717f5a666bc47c$export$2e2bcd8739ae039 = $ad717f5a666bc47c$var$WebhookDetails;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $7CUeL = parcelRequire("7CUeL");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $2Phw0 = parcelRequire("2Phw0");

var $voszV = parcelRequire("voszV");

var $c3dK3 = parcelRequire("c3dK3");



var $8Mb3E = parcelRequire("8Mb3E");




var $4ZcUR = parcelRequire("4ZcUR");

var $7kooT = parcelRequire("7kooT");

var $0aec24fb9f298967$export$baf82c066573e902;
var $0aec24fb9f298967$export$3dea766d36a8935f;
var $0aec24fb9f298967$export$fa0831f497706bad;
var $0aec24fb9f298967$export$bfd64c937657f93a;
var $0aec24fb9f298967$export$4a6dd88bada4e7d2;
var $0aec24fb9f298967$export$fb184b623420d9be;
$0aec24fb9f298967$export$baf82c066573e902 = `Ridwca_eventSelector`;
$0aec24fb9f298967$export$3dea766d36a8935f = `Ridwca_filter`;
$0aec24fb9f298967$export$fa0831f497706bad = `Ridwca_logs`;
$0aec24fb9f298967$export$bfd64c937657f93a = `Ridwca_rotating`;
$0aec24fb9f298967$export$4a6dd88bada4e7d2 = `Ridwca_shimmer`;
$0aec24fb9f298967$export$fb184b623420d9be = `Ridwca_title`;


const $71f33c94e7a3358a$var$hookLogEventOptions = (0, $7CUeL.hookEvents).map((event)=>({
        title: event,
        value: (0, $0329986f2f441fa6$export$4ddfaf1ad2964c7a)(event)
    }));
function $71f33c94e7a3358a$var$WebhookLogs() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const { hook: { id: id } } = (0, $2Phw0.useOutletContext)();
    const pageSize = (0, $8Mb3E.defaultPageSize);
    const [{ page: page, event: event }, updateSearchParameters] = (0, $66a3eb3654f9d141$export$2e2bcd8739ae039)({
        page: 1,
        event: "",
        startTimeExclusive: ""
    });
    const url = (0, $7kooT.buildUrl)(`api/hooks/${id}/recent-logs`, {
        page: String(page),
        page_size: String(pageSize),
        ...(0, $7oDSS.conditional)(event && {
            logKey: event
        })
    });
    const { data: data, error: error, mutate: mutate } = (0, $voszV.default)(url);
    const isLoading = !data && !error;
    const [logs, totalCount] = data ?? [];
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3166f28a681c41bb$export$2e2bcd8739ae039), {
        className: $0aec24fb9f298967$export$fa0831f497706bad,
        rowGroups: [
            {
                key: "logs",
                data: logs
            }
        ],
        rowIndexKey: "id",
        rowClickHandler: ({ id: id })=>{
            navigate(id);
        },
        filter: /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
            className: $0aec24fb9f298967$export$3dea766d36a8935f,
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $0aec24fb9f298967$export$fb184b623420d9be,
                    children: t("logs.filter_by")
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    className: $0aec24fb9f298967$export$baf82c066573e902,
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8482f894a8934304$export$2e2bcd8739ae039), {
                        value: event,
                        options: $71f33c94e7a3358a$var$hookLogEventOptions,
                        onChange: (event)=>{
                            updateSearchParameters({
                                event: event,
                                page: undefined
                            });
                        }
                    })
                })
            ]
        }),
        columns: [
            {
                title: "Status",
                dataIndex: "status",
                colSpan: 5,
                render: ({ payload: payload })=>{
                    const result = (0, $c3dK3.z).object({
                        response: (0, $c3dK3.z).object({
                            statusCode: (0, $c3dK3.z).number().optional()
                        })
                    }).optional().safeParse(payload);
                    const statusCode = result.success ? result.data?.response.statusCode : undefined;
                    const isError = !statusCode || statusCode >= 400;
                    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
                        type: "result",
                        status: isError ? "error" : "success",
                        children: statusCode ?? "Request error"
                    });
                }
            },
            {
                title: t("logs.event"),
                dataIndex: "event",
                colSpan: 6,
                render: ({ key: key })=>(0, $0329986f2f441fa6$export$3a881692556fa951)(key)
            },
            {
                title: t("logs.time"),
                dataIndex: "time",
                colSpan: 5,
                render: ({ createdAt: createdAt })=>new Date(createdAt).toLocaleString()
            }
        ],
        placeholder: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a0f84bc7cc69e410$export$2e2bcd8739ae039), {}),
        pagination: {
            page: page,
            totalCount: totalCount,
            pageSize: pageSize,
            onChange: (page)=>{
                updateSearchParameters({
                    page: page
                });
            }
        },
        isLoading: isLoading,
        errorMessage: error?.body?.message ?? error?.message,
        onRetry: async ()=>mutate(undefined, true)
    });
}
var $71f33c94e7a3358a$export$2e2bcd8739ae039 = $71f33c94e7a3358a$var$WebhookLogs;



var $C7mD2 = parcelRequire("C7mD2");

var $codQP = parcelRequire("codQP");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $2Phw0 = parcelRequire("2Phw0");

var $C7mD2 = parcelRequire("C7mD2");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
parcelRequire("cuPVN");
var $7CUeL = parcelRequire("7CUeL");
const $fbc2aec9881f1a2a$export$214bc9c3d2711796 = Object.freeze({
    [(0, $7CUeL.DataHookSchema).User]: "webhooks.schemas.user",
    [(0, $7CUeL.DataHookSchema).Organization]: "webhooks.schemas.organization",
    [(0, $7CUeL.DataHookSchema).Role]: "webhooks.schemas.role",
    [(0, $7CUeL.DataHookSchema).Scope]: "webhooks.schemas.scope",
    [(0, $7CUeL.DataHookSchema).OrganizationRole]: "webhooks.schemas.organization_role",
    [(0, $7CUeL.DataHookSchema).OrganizationScope]: "webhooks.schemas.organization_scope"
});
const $fbc2aec9881f1a2a$export$7467c84721c1b68b = Object.values((0, $7CUeL.InteractionHookEvent));
const $fbc2aec9881f1a2a$var$dataHookEvents = (0, $7CUeL.hookEvents).filter(// eslint-disable-next-line no-restricted-syntax
(event)=>!$fbc2aec9881f1a2a$export$7467c84721c1b68b.includes(event));
const $fbc2aec9881f1a2a$var$isDataHookSchema = (schema)=>// eslint-disable-next-line no-restricted-syntax
    Object.values((0, $7CUeL.DataHookSchema)).includes(schema);
// Group DataHook events by schema
// TODO: Replace this using `groupBy` once Node v22 goes LTS
const $fbc2aec9881f1a2a$var$schemaGroupedDataHookEventsMap = $fbc2aec9881f1a2a$var$dataHookEvents.reduce((eventGroup, event)=>{
    const [schema] = event.split(".");
    if (schema && $fbc2aec9881f1a2a$var$isDataHookSchema(schema)) eventGroup.set(schema, [
        ...eventGroup.get(schema) ?? [],
        event
    ]);
    return eventGroup;
}, new Map());
// Sort the grouped `DataHook` events per console product design
const $fbc2aec9881f1a2a$var$hookEventSchemaOrder = {
    [(0, $7CUeL.DataHookSchema).User]: 0,
    [(0, $7CUeL.DataHookSchema).Organization]: 1,
    [(0, $7CUeL.DataHookSchema).Role]: 2,
    [(0, $7CUeL.DataHookSchema).OrganizationRole]: 3,
    [(0, $7CUeL.DataHookSchema).Scope]: 4,
    [(0, $7CUeL.DataHookSchema).OrganizationScope]: 5
};
const $fbc2aec9881f1a2a$export$5f1283b1c655869d = Array.from($fbc2aec9881f1a2a$var$schemaGroupedDataHookEventsMap.entries()).slice().sort(([schemaA], [schemaB])=>$fbc2aec9881f1a2a$var$hookEventSchemaOrder[schemaA] - $fbc2aec9881f1a2a$var$hookEventSchemaOrder[schemaB]);



var $C7mD2 = parcelRequire("C7mD2");

var $5UrGx = parcelRequire("5UrGx");

var $66ixW = parcelRequire("66ixW");

var $a5ea780324033f35$export$5a00fffb0342c35c;
var $a5ea780324033f35$export$91bc5dc3bf221ff4;
var $a5ea780324033f35$export$bfd64c937657f93a;
var $a5ea780324033f35$export$4a6dd88bada4e7d2;
$a5ea780324033f35$export$5a00fffb0342c35c = `Nrzkjq_groupList`;
$a5ea780324033f35$export$91bc5dc3bf221ff4 = `Nrzkjq_groupTitle`;
$a5ea780324033f35$export$bfd64c937657f93a = `Nrzkjq_rotating`;
$a5ea780324033f35$export$4a6dd88bada4e7d2 = `Nrzkjq_shimmer`;


function $ecb7b1212cd08192$var$CategorizedCheckboxGroup({ groups: groups, value: checkedValues, onChange: onChange, className: className }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($a5ea780324033f35$export$5a00fffb0342c35c, className),
        children: groups.map(({ title: title, options: options })=>/*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $a5ea780324033f35$export$91bc5dc3bf221ff4,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: title
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4a37bd5fa29fd128$export$2e2bcd8739ae039), {
                        options: options,
                        value: checkedValues,
                        onChange: onChange
                    })
                ]
            }, title))
    });
}
var $ecb7b1212cd08192$export$2e2bcd8739ae039 = $ecb7b1212cd08192$var$CategorizedCheckboxGroup;



var $aqmjm = parcelRequire("aqmjm");

var $fmHmG = parcelRequire("fmHmG");

var $cRLgg = parcelRequire("cRLgg");
var $23a4440678f6e259$export$493b5823483d2c4e;
var $23a4440678f6e259$export$f71f035a831fd7a7;
var $23a4440678f6e259$export$bfd64c937657f93a;
var $23a4440678f6e259$export$4a6dd88bada4e7d2;
$23a4440678f6e259$export$493b5823483d2c4e = `pJ1nTW_errorMessage`;
$23a4440678f6e259$export$f71f035a831fd7a7 = `pJ1nTW_formFieldDescription`;
$23a4440678f6e259$export$bfd64c937657f93a = `pJ1nTW_rotating`;
$23a4440678f6e259$export$4a6dd88bada4e7d2 = `pJ1nTW_shimmer`;


const $0fd19fecf067e270$var$hookEventGroups = [
    ...(0, $fbc2aec9881f1a2a$export$5f1283b1c655869d).map(([schema, events])=>({
            title: (0, $fbc2aec9881f1a2a$export$214bc9c3d2711796)[schema],
            options: events.map((event)=>({
                    value: event
                }))
        })),
    {
        title: "webhooks.schemas.interaction",
        options: (0, $fbc2aec9881f1a2a$export$7467c84721c1b68b).map((event)=>({
                value: event
            }))
    }
];
function $0fd19fecf067e270$var$BasicWebhookForm() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { register: register, control: control, formState: { errors: errors } } = (0, $codQP.useFormContext)();
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                isRequired: true,
                title: "webhooks.create_form.name",
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                    ...register("name", {
                        required: true
                    }),
                    placeholder: t("webhooks.create_form.name_placeholder"),
                    error: Boolean(errors.name)
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
                isRequired: true,
                title: "webhooks.create_form.endpoint_url",
                tip: t("webhooks.create_form.endpoint_url_tip"),
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fmHmG.default), {
                    ...register("url", {
                        required: true,
                        validate: (value)=>(0, $cRLgg.uriValidator)(value) || t("errors.invalid_uri_format")
                    }),
                    placeholder: t("webhooks.create_form.endpoint_url_placeholder"),
                    error: errors.url?.type === "required" ? true : errors.url?.message
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aqmjm.default), {
                title: "webhooks.create_form.events",
                tip: t("webhooks.create_form.events_description"),
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.Controller), {
                        name: "events",
                        control: control,
                        defaultValue: [],
                        rules: {
                            validate: (value)=>value.length === 0 ? t("webhooks.create_form.missing_event_error") : true
                        },
                        render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $C7mD2.jsx)((0, $ecb7b1212cd08192$export$2e2bcd8739ae039), {
                                value: value,
                                groups: $0fd19fecf067e270$var$hookEventGroups,
                                onChange: onChange
                            })
                    }),
                    errors.events && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $23a4440678f6e259$export$493b5823483d2c4e,
                        children: errors.events.message
                    })
                ]
            })
        ]
    });
}
var $0fd19fecf067e270$export$2e2bcd8739ae039 = $0fd19fecf067e270$var$BasicWebhookForm;






var $7VnwS = parcelRequire("7VnwS");


var $5OcFi = parcelRequire("5OcFi");


var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $aqmjm = parcelRequire("aqmjm");

const $49ac048120b40546$var$isValidHeaderKey = (key)=>{
    return /^[\u0021-\u0039\u003B-\u007E]+$/.test(key);
};
const $49ac048120b40546$var$isValidHeaderValue = (value)=>{
    return /^[\u0020-\u007E]*$/.test(value);
};
function $49ac048120b40546$var$CustomHeaderField() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { control: control, register: register, getValues: getValues, trigger: trigger, formState: { errors: { headers: headerErrors }, submitCount: submitCount } } = (0, $codQP.useFormContext)();
    const { fields: fields, remove: remove, append: append } = (0, $codQP.useFieldArray)({
        control: control,
        name: "headers"
    });
    const validateKey = (0, $jC8Vy.useCallback)((key, index)=>{
        const headers = getValues("headers");
        if (!headers) return true;
        if (headers.filter(({ key: _key })=>_key.length > 0 && _key === key).length > 1) return t("webhook_details.settings.key_duplicated_error");
        const correspondValue = getValues(`headers.${index}.value`);
        if (correspondValue) return Boolean(key) || t("webhook_details.settings.key_missing_error");
        if (Boolean(key) && !$49ac048120b40546$var$isValidHeaderKey(key)) return t("webhook_details.settings.invalid_key_error");
        return true;
    }, [
        getValues,
        t
    ]);
    const validateValue = (0, $jC8Vy.useCallback)((value, index)=>{
        if (Boolean(value) && !$49ac048120b40546$var$isValidHeaderValue(value)) return t("webhook_details.settings.invalid_value_error");
        return getValues(`headers.${index}.key`) ? Boolean(value) || t("webhook_details.settings.value_missing_error") : true;
    }, [
        getValues,
        t
    ]);
    const revalidate = (0, $jC8Vy.useCallback)(()=>{
        for (const [index] of fields.entries()){
            trigger(`headers.${index}.key`);
            if (submitCount > 0) trigger(`headers.${index}.value`);
        }
    }, [
        fields,
        submitCount,
        trigger
    ]);
    const getInputFieldProps = (0, $jC8Vy.useMemo)(()=>({
            key: (index)=>register(`headers.${index}.key`, {
                    validate: (key)=>validateKey(key, index),
                    onChange: revalidate
                }),
            value: (index)=>register(`headers.${index}.value`, {
                    validate: (value)=>validateValue(value, index),
                    onChange: revalidate
                })
        }), [
        validateKey,
        register,
        revalidate,
        validateValue
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aqmjm.default), {
        title: "webhook_details.settings.custom_headers",
        tip: t("webhook_details.settings.custom_headers_tip"),
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $88142b94340a6b0b$export$2e2bcd8739ae039), {
            fields: fields,
            // Force headerErrors to be an array, otherwise return undefined
            errors: headerErrors?.map?.((error)=>error),
            getInputFieldProps: getInputFieldProps,
            onAppend: append,
            onRemove: remove
        })
    });
}
var $49ac048120b40546$export$2e2bcd8739ae039 = $49ac048120b40546$var$CustomHeaderField;



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");


var $jGWQ4 = parcelRequire("jGWQ4");

var $dL4NZ = parcelRequire("dL4NZ");

var $cw2No = parcelRequire("cw2No");

var $66ixW = parcelRequire("66ixW");

var $aqmjm = parcelRequire("aqmjm");

var $7VnwS = parcelRequire("7VnwS");
var $06e8e9aef87bd3cf$export$fb34ecfba659a0ec;
var $06e8e9aef87bd3cf$export$bfd64c937657f93a;
var $06e8e9aef87bd3cf$export$4a6dd88bada4e7d2;
var $06e8e9aef87bd3cf$export$f32d6fa108c92ed3;
$06e8e9aef87bd3cf$export$fb34ecfba659a0ec = `-OPSRq_regenerateButton`;
$06e8e9aef87bd3cf$export$bfd64c937657f93a = `-OPSRq_rotating`;
$06e8e9aef87bd3cf$export$4a6dd88bada4e7d2 = `-OPSRq_shimmer`;
$06e8e9aef87bd3cf$export$f32d6fa108c92ed3 = `-OPSRq_signingKeyField`;


function $071b3881d5923099$var$SigningKeyField({ hookId: hookId, signingKey: signingKey, onSigningKeyUpdated: onSigningKeyUpdated }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined);
    const api = (0, $7VnwS.default)();
    const [isRegenerateFormOpen, setIsRegenerateFormOpen] = (0, $jC8Vy.useState)(false);
    const [isRegenerating, setIsRegenerating] = (0, $jC8Vy.useState)(false);
    const regenerateSigningKey = (0, $jC8Vy.useCallback)(async (silent = false)=>{
        if (isRegenerating) return;
        setIsRegenerating(true);
        try {
            const { signingKey: signingKey } = await api.patch(`api/hooks/${hookId}/signing-key`).json();
            if (!silent) (0, $FuhPC.toast).success(t("admin_console.webhook_details.settings.regenerated"));
            setIsRegenerateFormOpen(false);
            onSigningKeyUpdated(signingKey);
        } finally{
            setIsRegenerating(false);
        }
    }, [
        api,
        hookId,
        isRegenerating,
        onSigningKeyUpdated,
        t
    ]);
    (0, $jC8Vy.useEffect)(()=>{
        if (!signingKey) regenerateSigningKey(true);
    }, [
        regenerateSigningKey,
        signingKey
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aqmjm.default), {
        title: "webhook_details.settings.signing_key",
        tip: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
            forKey: "webhook_details.settings.signing_key_tip"
        }),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cw2No.default), {
                hasVisibilityToggle: true,
                value: signingKey,
                variant: "border",
                className: $06e8e9aef87bd3cf$export$f32d6fa108c92ed3
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                type: "text",
                size: "small",
                icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fdd1e61b965b5329$export$2e2bcd8739ae039), {}),
                title: "webhook_details.settings.regenerate",
                className: $06e8e9aef87bd3cf$export$fb34ecfba659a0ec,
                onClick: ()=>{
                    setIsRegenerateFormOpen(true);
                }
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dL4NZ.default), {
                isOpen: isRegenerateFormOpen,
                isLoading: isRegenerating,
                confirmButtonText: "webhook_details.settings.regenerate",
                title: "webhook_details.settings.regenerate_key_title",
                onCancel: async ()=>{
                    setIsRegenerateFormOpen(false);
                },
                onConfirm: async ()=>regenerateSigningKey(),
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                    forKey: "webhook_details.settings.regenerate_key_reminder"
                })
            })
        ]
    });
}
var $071b3881d5923099$export$2e2bcd8739ae039 = $071b3881d5923099$var$SigningKeyField;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $kSjlW = parcelRequire("kSjlW");
parcelRequire("12bMu");
var $3dBAh = parcelRequire("3dBAh");

var $b67J2 = parcelRequire("b67J2");

var $5cXXM = parcelRequire("5cXXM");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");

var $jGWQ4 = parcelRequire("jGWQ4");

var $66ixW = parcelRequire("66ixW");

var $aqmjm = parcelRequire("aqmjm");

var $1QOtg = parcelRequire("1QOtg");

var $7VnwS = parcelRequire("7VnwS");

var $a62d93143f9aff83$export$34e0f9847d4c02dd;
var $a62d93143f9aff83$export$6d59db4903f20f7d;
var $a62d93143f9aff83$export$aaf36426b5008f7a;
var $a62d93143f9aff83$export$bfd64c937657f93a;
var $a62d93143f9aff83$export$4a6dd88bada4e7d2;
$a62d93143f9aff83$export$34e0f9847d4c02dd = `RV9bSa_container`;
$a62d93143f9aff83$export$6d59db4903f20f7d = `RV9bSa_description`;
$a62d93143f9aff83$export$aaf36426b5008f7a = `RV9bSa_result`;
$a62d93143f9aff83$export$bfd64c937657f93a = `RV9bSa_rotating`;
$a62d93143f9aff83$export$4a6dd88bada4e7d2 = `RV9bSa_shimmer`;


parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $jC8Vy = parcelRequire("jC8Vy");

var $c3dK3 = parcelRequire("c3dK3");
parcelRequire("8Mb3E");
var $fb30i = parcelRequire("fb30i");

var $3RCsa = parcelRequire("3RCsa");
const $20e0ca23ec8ee524$var$webhookTestResultGuard = (0, $c3dK3.z).object({
    result: (0, $c3dK3.z).enum([
        "success",
        "error"
    ]),
    endpointUrl: (0, $c3dK3.z).string(),
    requestTime: (0, $c3dK3.z).number(),
    message: (0, $c3dK3.z).string().optional(),
    responseStatus: (0, $c3dK3.z).number().optional(),
    responseBody: (0, $c3dK3.z).string().optional()
});
const $20e0ca23ec8ee524$var$readResult = ()=>{
    const parsedJson = (0, $3RCsa.safeParseJson)((0, $7oDSS.conditionalString)(sessionStorage.getItem((0, $fb30i.storageKeys).webhookTestResult)));
    return (0, $7oDSS.conditional)(parsedJson.success && $20e0ca23ec8ee524$var$webhookTestResultGuard.parse(parsedJson.data));
};
const $20e0ca23ec8ee524$var$useWebhookTestResult = ()=>{
    const [testResult, setTestResult] = (0, $jC8Vy.useState)($20e0ca23ec8ee524$var$readResult());
    return {
        result: testResult,
        setResult: (result)=>{
            setTestResult(result);
            if (result) sessionStorage.setItem((0, $fb30i.storageKeys).webhookTestResult, JSON.stringify(result));
            else sessionStorage.removeItem((0, $fb30i.storageKeys).webhookTestResult);
        }
    };
};
var $20e0ca23ec8ee524$export$2e2bcd8739ae039 = $20e0ca23ec8ee524$var$useWebhookTestResult;


function $d81a35f905cb8288$var$TestWebhook({ hookId: hookId }) {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getValues: getValues, formState: { isValid: isValid } } = (0, $codQP.useFormContext)();
    const testResultRef = (0, $jC8Vy.useRef)(null);
    const { result: result, setResult: setResult } = (0, $20e0ca23ec8ee524$export$2e2bcd8739ae039)();
    const [isSendingPayload, setIsSendingPayload] = (0, $jC8Vy.useState)(false);
    const api = (0, $7VnwS.default)({
        hideErrorToast: true
    });
    const sendTestPayload = async ()=>{
        if (isSendingPayload) return;
        setIsSendingPayload(true);
        const endpointUrl = getValues("url");
        const requestTime = Date.now();
        try {
            const formData = getValues();
            const { events: events, config: config } = (0, $0329986f2f441fa6$export$267897f64bb59b59).toRemoteModel(formData);
            await api.post(`api/hooks/${hookId}/test`, {
                json: {
                    events: events,
                    config: config
                }
            });
            setResult({
                result: "success",
                endpointUrl: endpointUrl,
                message: t("webhook_details.settings.test_result.test_success"),
                requestTime: requestTime
            });
        } catch (error) {
            if (!(error instanceof (0, $5cXXM.HTTPError))) {
                (0, $FuhPC.toast).error(error instanceof Error ? String(error) : t("general.unknown_error"));
                return;
            }
            const { code: code, data: data, message: message } = await error.response.clone().json();
            if (code === "hook.send_test_payload_failed") {
                setResult({
                    result: "error",
                    endpointUrl: endpointUrl,
                    requestTime: requestTime,
                    message: message
                });
                return;
            }
            if (code === "hook.endpoint_responded_with_error") {
                const { responseStatus: responseStatus, responseBody: responseBody } = (0, $3dBAh.trySafe)(()=>(0, $kSjlW.hookTestErrorResponseDataGuard).parse(data)) ?? {};
                setResult({
                    result: "error",
                    endpointUrl: endpointUrl,
                    requestTime: requestTime,
                    message: message,
                    responseStatus: responseStatus,
                    responseBody: responseBody
                });
                return;
            }
            throw error;
        } finally{
            setIsSendingPayload(false);
            // Set timeout to wait for the notification to be rendered
            setTimeout(()=>{
                testResultRef.current?.scrollIntoView({
                    behavior: "smooth"
                });
            }, 50);
        }
    };
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $aqmjm.default), {
        title: "webhook_details.settings.test_webhook",
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                className: $a62d93143f9aff83$export$34e0f9847d4c02dd,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $a62d93143f9aff83$export$6d59db4903f20f7d,
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: "webhook_details.settings.test_webhook_description"
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                        type: "outline",
                        title: "webhook_details.settings.send_test_payload",
                        disabled: !isValid,
                        isLoading: isSendingPayload,
                        onClick: async ()=>{
                            await sendTestPayload();
                        }
                    })
                ]
            }),
            result && /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $1QOtg.default), {
                ref: testResultRef,
                hasIcon: true,
                severity: result.result,
                action: "general.got_it",
                className: $a62d93143f9aff83$export$aaf36426b5008f7a,
                onClick: ()=>{
                    setResult(undefined);
                },
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: "webhook_details.settings.test_result.endpoint_url",
                            interpolation: {
                                url: result.endpointUrl
                            }
                        })
                    }),
                    result.message && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: "webhook_details.settings.test_result.message",
                            interpolation: {
                                message: result.message
                            }
                        })
                    }),
                    result.responseStatus && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: "webhook_details.settings.test_result.response_status",
                            interpolation: {
                                status: result.responseStatus
                            }
                        })
                    }),
                    result.responseBody && /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: "webhook_details.settings.test_result.response_body",
                            interpolation: {
                                body: result.responseBody
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                            forKey: "webhook_details.settings.test_result.request_time",
                            interpolation: {
                                time: (0, (/*@__PURE__*/$parcel$interopDefault($b67J2)))(result.requestTime).format("MM/DD/YYYY, hh:mm:ss A")
                            }
                        })
                    })
                ]
            })
        ]
    });
}
var $d81a35f905cb8288$export$2e2bcd8739ae039 = $d81a35f905cb8288$var$TestWebhook;


function $89ef666eee87620e$var$WebhookSettings() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { hook: hook, isDeleting: isDeleting, onHookUpdated: onHookUpdated } = (0, $2Phw0.useOutletContext)();
    const webhookFormData = (0, $0329986f2f441fa6$export$267897f64bb59b59).toLocalForm(hook);
    const formMethods = (0, $codQP.useForm)({
        defaultValues: webhookFormData
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $b595fc2f0eccd19a$export$2e2bcd8739ae039)();
    const api = (0, $7VnwS.default)();
    const { handleSubmit: handleSubmit, reset: reset, formState: { isSubmitting: isSubmitting, isDirty: isDirty } } = formMethods;
    const onSubmit = handleSubmit((0, $5OcFi.trySubmitSafe)(async (formData)=>{
        const updatedHook = await api.patch(`api/hooks/${hook.id}`, {
            json: (0, $0329986f2f441fa6$export$267897f64bb59b59).toRemoteModel(formData)
        }).json();
        reset((0, $0329986f2f441fa6$export$267897f64bb59b59).toLocalForm(updatedHook));
        onHookUpdated(updatedHook);
        (0, $FuhPC.toast).success(t("general.saved"));
    }));
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f0e7fd6d3bded790$export$2e2bcd8739ae039), {
                isDirty: isDirty,
                isSubmitting: isSubmitting,
                onSubmit: onSubmit,
                onDiscard: reset,
                children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $codQP.FormProvider), {
                    ...formMethods,
                    children: [
                        /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
                            title: "webhook_details.settings.settings",
                            description: "webhook_details.settings.settings_description",
                            learnMoreLink: {
                                href: getDocumentationUrl("/docs/recipes/webhooks"),
                                targetBlank: "noopener"
                            },
                            children: [
                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0fd19fecf067e270$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $071b3881d5923099$export$2e2bcd8739ae039), {
                                    hookId: hook.id,
                                    signingKey: hook.signingKey,
                                    onSigningKeyUpdated: (signingKey)=>{
                                        onHookUpdated({
                                            ...hook,
                                            signingKey: signingKey
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $49ac048120b40546$export$2e2bcd8739ae039), {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fb58e96bbd460634$export$2e2bcd8739ae039), {
                            title: "webhook_details.settings.test",
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $d81a35f905cb8288$export$2e2bcd8739ae039), {
                                hookId: hook.id
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fea55fa5d5726e29$export$2e2bcd8739ae039), {
                hasUnsavedChanges: !isDeleting && isDirty
            })
        ]
    });
}
var $89ef666eee87620e$export$2e2bcd8739ae039 = $89ef666eee87620e$var$WebhookSettings;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("cuPVN");
var $5HVJe = parcelRequire("5HVJe");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");

var $FuhPC = parcelRequire("FuhPC");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
parcelRequire("6bq3s");
var $2Phw0 = parcelRequire("2Phw0");

var $voszV = parcelRequire("voszV");




var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $d03b0a790a2f36dc$var$SvgWebhooksEmptyDark = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                opacity: 0.4,
                fillRule: "evenodd",
                clipRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M176.993 221.626H73.809a53.89 53.89 0 0 1-7.298.494 53.89 53.89 0 0 1-7.298-.494h-4.152v-.734C31.01 215.649 13 194.232 13 168.609c0-26.616 19.431-48.693 44.881-52.819 8.47-28.74 35.053-49.719 66.537-49.719 29.899 0 55.379 18.919 65.122 45.438 28.21 2.582 50.304 26.305 50.304 55.189 0 27.421-19.914 50.191-46.069 54.636v.292h-1.923c-2.43.326-4.91.494-7.43.494-2.519 0-4.999-.168-7.429-.494Z",
                        fill: "url(#paint0_linear_8217_108003)"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M176.993 221.626H73.809a53.89 53.89 0 0 1-7.298.494 53.89 53.89 0 0 1-7.298-.494h-4.152v-.734C31.01 215.649 13 194.232 13 168.609c0-26.616 19.431-48.693 44.881-52.819 8.47-28.74 35.053-49.719 66.537-49.719 29.899 0 55.379 18.919 65.122 45.438 28.21 2.582 50.304 26.305 50.304 55.189 0 27.421-19.914 50.191-46.069 54.636v.292h-1.923c-2.43.326-4.91.494-7.43.494-2.519 0-4.999-.168-7.429-.494Z",
                        fill: "url(#paint1_linear_8217_108003)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 28.301,
                y: 100.613,
                width: 83.889,
                height: 15.161,
                rx: 2.021,
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#947DFF",
                d: "M31.333 115.774h77.825v5.054H31.333z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 39.924,
                cy: 108.194,
                r: 2.527,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 47.504,
                y: 104.656,
                width: 56.6,
                height: 7.075,
                rx: 1.011,
                fill: "url(#paint2_linear_8217_108003)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 28.301,
                y: 120.738,
                width: 83.889,
                height: 15.161,
                rx: 2.021,
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#947DFF",
                d: "M31.333 135.898h77.825v5.054H31.333z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 39.924,
                cy: 128.319,
                r: 2.527,
                fill: "#F07EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 47.504,
                y: 124.781,
                width: 56.6,
                height: 7.075,
                rx: 1.011,
                fill: "url(#paint3_linear_8217_108003)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 28.301,
                y: 140.863,
                width: 83.889,
                height: 15.161,
                rx: 2.021,
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#947DFF",
                d: "M31.333 156.024h77.825v5.054H31.333z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 39.924,
                cy: 148.444,
                r: 2.527,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 47.504,
                y: 144.906,
                width: 56.6,
                height: 7.075,
                rx: 1.011,
                fill: "url(#paint4_linear_8217_108003)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 28.301,
                y: 160.989,
                width: 83.889,
                height: 15.161,
                rx: 2.021,
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#947DFF",
                d: "M31.333 176.15h77.825v5.054H31.333z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 39.924,
                cy: 168.57,
                r: 2.527,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 47.504,
                y: 165.032,
                width: 56.6,
                height: 7.075,
                rx: 1.011,
                fill: "url(#paint5_linear_8217_108003)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 28.301,
                y: 181.114,
                width: 83.889,
                height: 15.161,
                rx: 2.021,
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#947DFF",
                d: "M31.333 196.274h77.825v5.054H31.333z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 39.924,
                cy: 188.694,
                r: 2.527,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 47.504,
                y: 185.157,
                width: 56.6,
                height: 7.075,
                rx: 1.011,
                fill: "url(#paint6_linear_8217_108003)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 28.301,
                y: 201.239,
                width: 83.889,
                height: 15.161,
                rx: 2.021,
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M31.333 216.4h77.825v.526a4.528 4.528 0 0 1-4.528 4.528H35.86a4.528 4.528 0 0 1-4.527-4.528v-.526Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 39.923,
                cy: 208.819,
                r: 2.527,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 47.504,
                y: 205.282,
                width: 56.6,
                height: 7.075,
                rx: 1.011,
                fill: "url(#paint7_linear_8217_108003)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M31.32 100.11c0-2.5 2.026-4.528 4.527-4.528h68.427c2.5 0 4.527 2.027 4.527 4.528v.503H31.319v-.503Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 121.511,
                y: 48.86,
                width: 61,
                height: 85,
                rx: 16,
                fill: "url(#paint8_linear_8217_108003)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 128.511,
                y: 94.518,
                width: 47,
                height: 8.826,
                rx: 3.555,
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 128.511,
                y: 108.757,
                width: 47,
                height: 8.826,
                rx: 3.555,
                fill: "#E5E1EC",
                stroke: "#815AE3",
                strokeWidth: 0.889
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 164.37,
                y: 111.172,
                width: 0.984,
                height: 4,
                rx: 0.492,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M133.733 98.93c0-.487.396-.882.883-.882h19.124a.882.882 0 0 1 0 1.765h-19.124a.883.883 0 0 1-.883-.883Zm24.371 0c0-.487.395-.882.882-.882h5.198a.883.883 0 1 1 0 1.765h-5.198a.882.882 0 0 1-.882-.883Zm9.586-.882a.883.883 0 1 0 0 1.765h1.716a.882.882 0 0 0 0-1.765h-1.716Z",
                fill: "#9877EA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                cx: 138.084,
                cy: 113.17,
                rx: 1.741,
                ry: 1.765,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                cx: 145.048,
                cy: 113.17,
                rx: 1.741,
                ry: 1.765,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                cx: 152.011,
                cy: 113.17,
                rx: 1.741,
                ry: 1.765,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                cx: 158.974,
                cy: 113.17,
                rx: 1.741,
                ry: 1.765,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 140.511,
                y: 62.86,
                width: 23,
                height: 23,
                rx: 7.701,
                fill: "#F0EBFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 152.01,
                cy: 69.57,
                r: 3.833,
                fill: "#FFB95A"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 152.01,
                cy: 69.57,
                r: 3.833,
                fill: "#FDCF90"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M146.261 78.21a3.85 3.85 0 0 1 3.851-3.85h3.799a3.85 3.85 0 0 1 3.85 3.85v1.892a1.925 1.925 0 0 1-1.925 1.925h-7.65a1.925 1.925 0 0 1-1.925-1.925V78.21Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M106.487 144.638h107.2a5 5 0 0 1 5 5v68.329H101.488v-68.329a5 5 0 0 1 4.999-5Z",
                fill: "url(#paint9_linear_8217_108003)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M106.487 144.638h107.2a5 5 0 0 1 5 5v68.329H101.488v-68.329a5 5 0 0 1 4.999-5Z",
                fill: "url(#paint10_linear_8217_108003)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M106.487 144.638h107.2a5 5 0 0 1 5 5v68.329H101.488v-68.329a5 5 0 0 1 4.999-5Z",
                stroke: "url(#paint11_linear_8217_108003)",
                strokeWidth: 3.237
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M89.7 216.177h139.715v1.634a3.31 3.31 0 0 1-3.31 3.309H93.835a4.137 4.137 0 0 1-4.136-4.137v-.806Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 214.934,
                y: 65.169,
                width: 6.419,
                height: 6.419,
                rx: 2,
                transform: "rotate(30.813 214.934 65.169)",
                fill: "#F7F8F8",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M238.697 85.249c0-.116.093-.209.209-.209h1.877a.21.21 0 0 1 .209.209v3.713l3.068-1.853a.2.2 0 0 1 .28.074l.945 1.714c.056.1.021.23-.077.29l-3.069 1.853 3.068 1.853c.099.06.134.19.078.29l-.946 1.714a.198.198 0 0 1-.279.074l-3.068-1.852v3.712a.21.21 0 0 1-.209.209h-1.877a.208.208 0 0 1-.209-.209v-3.713l-3.069 1.853a.199.199 0 0 1-.279-.074l-.946-1.714a.219.219 0 0 1 .078-.29l3.068-1.853-3.068-1.853a.218.218 0 0 1-.078-.29l.946-1.714c.055-.1.18-.134.279-.074l3.069 1.853v-3.713Z",
                fill: "#CABEFF",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M116.511 74.08h-39.68c-5.656 0-10.24 4.585-10.24 10.24V92",
                stroke: "#A782E8",
                strokeDasharray: "3.5 3.5"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M67.449 93.131a1 1 0 0 1-1.715 0l-2.074-3.456a1 1 0 0 1 .857-1.514h4.148a1 1 0 0 1 .857 1.514l-2.073 3.456Z",
                fill: "#A782E8"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                opacity: 0.9,
                x: 134.252,
                y: 156.023,
                width: 72.594,
                height: 52.31,
                rx: 3.991,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 142.792,
                y: 169.901,
                width: 55.513,
                height: 4.27,
                rx: 1.597,
                fill: "#C29DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 142.792,
                y: 195.522,
                width: 27.756,
                height: 4.27,
                rx: 1.597,
                fill: "#C29DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 142.792,
                y: 186.982,
                width: 55.513,
                height: 4.27,
                rx: 1.597,
                fill: "#C29DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 142.792,
                y: 178.458,
                width: 37.802,
                height: 4.255,
                rx: 1.597,
                fill: "#C29DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 185.157,
                y: 178.458,
                width: 13.149,
                height: 4.255,
                rx: 1.597,
                fill: "#C29DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 142.212,
                cy: 162.42,
                r: 1.555,
                fill: "#FFFBFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 148.432,
                cy: 162.42,
                r: 1.555,
                fill: "#FFFBFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 154.652,
                cy: 162.42,
                r: 1.555,
                fill: "#FFFBFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m53.127 64.4-1.11-1.921a2.22 2.22 0 0 0-3.032-.813v0a2.22 2.22 0 0 1-3.031-.812v0a2.22 2.22 0 0 0-3.032-.812L41 61.152",
                stroke: "#F7F8F8",
                strokeOpacity: 0.16,
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M74.856 167.531a.5.5 0 0 0 0 1v-1Zm0 1h1.638v-1h-1.638v1Zm4.915 0h3.277v-1H79.77v1Zm6.554 0h3.277v-1h-3.277v1Zm6.554 0h3.276v-1H92.88v1Zm6.553 0h3.277v-1h-3.277v1Zm6.554 0h3.277v-1h-3.277v1Zm6.554 0h3.277v-1h-3.277v1Zm6.554 0h1.638v-1h-1.638v1Z",
                fill: "url(#paint12_linear_8217_108003)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M125.304 167.774a.3.3 0 0 1 0 .514l-4.117 2.471a.3.3 0 0 1-.455-.258v-4.94a.3.3 0 0 1 .455-.257l4.117 2.47Z",
                fill: "#F3EEFA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M74.856 182.607a.5.5 0 0 0 0 1v-1Zm0 1h1.638v-1h-1.638v1Zm4.915 0h3.277v-1H79.77v1Zm6.554 0h3.277v-1h-3.277v1Zm6.554 0h3.276v-1H92.88v1Zm6.553 0h3.277v-1h-3.277v1Zm6.554 0h3.277v-1h-3.277v1Zm6.554 0h3.277v-1h-3.277v1Zm6.554 0h1.638v-1h-1.638v1Z",
                fill: "url(#paint13_linear_8217_108003)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M125.304 182.85a.3.3 0 0 1 0 .515l-4.117 2.47a.3.3 0 0 1-.455-.257v-4.941a.3.3 0 0 1 .455-.257l4.117 2.47ZM74.856 198.684a.5.5 0 1 0 0 1v-1Zm0 1h1.638v-1h-1.638v1Zm4.915 0h3.277v-1H79.77v1Zm6.554 0h3.277v-1h-3.277v1Zm6.554 0h3.276v-1H92.88v1Zm6.553 0h3.277v-1h-3.277v1Zm6.554 0h3.277v-1h-3.277v1Zm6.554 0h3.277v-1h-3.277v1Zm6.554 0h1.638v-1h-1.638v1Z",
                fill: "#F3EEFA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M125.304 198.926a.3.3 0 0 1 0 .515l-4.117 2.47a.3.3 0 0 1-.455-.257v-4.941a.3.3 0 0 1 .455-.257l4.117 2.47Z",
                fill: "#F3EEFA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                opacity: 0.5,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M213.879 122.459a8.039 8.039 0 0 0 11.518-10.638 8.036 8.036 0 0 0-10.977-2.941l-2.673-4.63-.513-.888",
                        stroke: "#78767F",
                        strokeWidth: 1.28,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                        filter: "url(#filter0_b_8217_108003)",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                                d: "M206.419 95.014a5 5 0 1 1 5 8.66 5 5 0 0 1-5-8.66Z",
                                fill: "#5F5D67"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                                d: "M206.739 95.568a4.36 4.36 0 1 1 4.36 7.552 4.36 4.36 0 0 1-4.36-7.552Z",
                                stroke: "#78767F",
                                strokeWidth: 1.28,
                                strokeLinecap: "round"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                        filter: "url(#filter1_b_8217_108003)",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                                d: "M215.976 111.511a5 5 0 1 1 5 8.66 5 5 0 1 1-5-8.66Z",
                                fill: "#5F5D67"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                                d: "M216.296 112.065a4.36 4.36 0 1 1 4.36 7.55 4.36 4.36 0 0 1-4.36-7.55Z",
                                stroke: "#78767F",
                                strokeWidth: 1.28,
                                strokeLinecap: "round"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                        filter: "url(#filter2_b_8217_108003)",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                                d: "M196.775 111.341a5 5 0 1 1 5.001 8.66 5 5 0 0 1-5.001-8.66Z",
                                fill: "#5F5D67"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                                d: "M197.095 111.895a4.36 4.36 0 1 1 4.36 7.552 4.36 4.36 0 0 1-4.36-7.552Z",
                                stroke: "#78767F",
                                strokeWidth: 1.28,
                                strokeLinecap: "round"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M195.798 108.538a8.038 8.038 0 0 0 3.454 15.293 8.035 8.035 0 0 0 8.035-8.035h6.356",
                        stroke: "#78767F",
                        strokeWidth: 1.28,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M216.751 99.994a8.038 8.038 0 0 0-14.971-4.655 8.035 8.035 0 0 0 2.941 10.976l-3.112 5.392",
                        stroke: "#78767F",
                        strokeWidth: 1.28,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17 95.04a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
                fill: "#F7F8F8",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_8217_108003",
                        x1: 126.422,
                        y1: 66.071,
                        x2: 126.422,
                        y2: 222.12,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#CABEFF",
                                stopOpacity: 0.32
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CABEFF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_8217_108003",
                        x1: 126.422,
                        y1: 66.071,
                        x2: 126.422,
                        y2: 344.967,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#6E6A88"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 0,
                                stopColor: "#6E6A88"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#6E6A88",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint2_linear_8217_108003",
                        x1: 47.543,
                        y1: 111.293,
                        x2: 104.137,
                        y2: 104.502,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#A793FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 0.443,
                                stopColor: "#B3A2FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#AA97FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint3_linear_8217_108003",
                        x1: 47.543,
                        y1: 131.418,
                        x2: 104.137,
                        y2: 124.627,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#A793FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 0.443,
                                stopColor: "#B3A2FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#AA97FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint4_linear_8217_108003",
                        x1: 47.543,
                        y1: 151.543,
                        x2: 104.137,
                        y2: 144.752,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#A793FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 0.443,
                                stopColor: "#B3A2FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#AA97FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint5_linear_8217_108003",
                        x1: 47.543,
                        y1: 171.669,
                        x2: 104.137,
                        y2: 164.877,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#A793FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 0.443,
                                stopColor: "#B3A2FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#AA97FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint6_linear_8217_108003",
                        x1: 47.543,
                        y1: 191.794,
                        x2: 104.137,
                        y2: 185.002,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#A793FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 0.443,
                                stopColor: "#B3A2FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#AA97FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint7_linear_8217_108003",
                        x1: 47.543,
                        y1: 211.919,
                        x2: 104.137,
                        y2: 205.127,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#A793FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 0.443,
                                stopColor: "#B3A2FF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#AA97FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint8_linear_8217_108003",
                        x1: 152.011,
                        y1: 48.86,
                        x2: 109.915,
                        y2: 124.016,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#A089E1"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#816DB9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint9_linear_8217_108003",
                        x1: 157.207,
                        y1: 144.748,
                        x2: 182.209,
                        y2: 228.96,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint10_linear_8217_108003",
                        x1: 220.306,
                        y1: 219.587,
                        x2: 34.654,
                        y2: 102.074,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#AC7DFF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#B084FF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint11_linear_8217_108003",
                        x1: 157.207,
                        y1: 144.748,
                        x2: 182.209,
                        y2: 228.96,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint12_linear_8217_108003",
                        x1: 74.16,
                        y1: 168.531,
                        x2: 120.037,
                        y2: 168.531,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#7F43E9"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 0.615,
                                stopColor: "#A070F4"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 0.714,
                                stopColor: "#E6DCF9"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F2EEFA"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint13_linear_8217_108003",
                        x1: 74.16,
                        y1: 183.607,
                        x2: 120.037,
                        y2: 183.607,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#7F43E9"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 0.615,
                                stopColor: "#A070F4"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 0.714,
                                stopColor: "#E6DCF9"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F2EEFA"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("filter", {
                        id: "filter0_b_8217_108003",
                        x: 199.918,
                        y: 90.343,
                        width: 18.002,
                        height: 18.002,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feGaussianBlur", {
                                in: "BackgroundImageFix",
                                stdDeviation: 2
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feComposite", {
                                in2: "SourceAlpha",
                                operator: "in",
                                result: "effect1_backgroundBlur_8217_108003"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_backgroundBlur_8217_108003",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("filter", {
                        id: "filter1_b_8217_108003",
                        x: 209.475,
                        y: 106.84,
                        width: 18.002,
                        height: 18.002,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feGaussianBlur", {
                                in: "BackgroundImageFix",
                                stdDeviation: 2
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feComposite", {
                                in2: "SourceAlpha",
                                operator: "in",
                                result: "effect1_backgroundBlur_8217_108003"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_backgroundBlur_8217_108003",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("filter", {
                        id: "filter2_b_8217_108003",
                        x: 190.274,
                        y: 106.67,
                        width: 18.002,
                        height: 18.002,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feGaussianBlur", {
                                in: "BackgroundImageFix",
                                stdDeviation: 2
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feComposite", {
                                in2: "SourceAlpha",
                                operator: "in",
                                result: "effect1_backgroundBlur_8217_108003"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_backgroundBlur_8217_108003",
                                result: "shape"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $d03b0a790a2f36dc$export$2e2bcd8739ae039 = $d03b0a790a2f36dc$var$SvgWebhooksEmptyDark;



var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("jC8Vy");
const $9e46c90b9cb432f2$var$SvgWebhooksEmpty = (props)=>/*#__PURE__*/ (0, $C7mD2.jsxs)("svg", {
        width: 200,
        height: 200,
        viewBox: "0 0 200 200",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#fff",
                d: "M0 0h200v200H0z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M138.276 173.146H57.662a42.204 42.204 0 0 1-5.7.385c-1.934 0-3.837-.131-5.7-.385h-3.245v-.574c-18.79-4.096-32.86-20.828-32.86-40.847 0-20.793 15.18-38.04 35.063-41.264 6.616-22.454 27.385-38.843 51.982-38.843 23.358 0 43.264 14.78 50.876 35.498 22.039 2.018 39.3 20.551 39.3 43.116 0 21.423-15.558 39.212-35.991 42.685v.229h-1.504a43.732 43.732 0 0 1-5.803.385c-1.968 0-3.905-.131-5.804-.385Z",
                fill: "url(#paint0_linear_377_52050)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 22.11,
                y: 78.603,
                width: 65.538,
                height: 11.844,
                rx: 1.579,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#947DFF",
                d: "M24.479 90.448H85.28v3.948H24.479z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 31.191,
                cy: 84.526,
                r: 1.974,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 37.112,
                y: 81.762,
                width: 44.219,
                height: 5.527,
                rx: 0.79,
                fill: "url(#paint1_linear_377_52050)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 22.11,
                y: 94.326,
                width: 65.538,
                height: 11.844,
                rx: 1.579,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#947DFF",
                d: "M24.479 106.17H85.28v3.948H24.479z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 31.191,
                cy: 100.249,
                r: 1.974,
                fill: "#F07EFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 37.112,
                y: 97.485,
                width: 44.219,
                height: 5.527,
                rx: 0.79,
                fill: "url(#paint2_linear_377_52050)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 22.11,
                y: 110.049,
                width: 65.538,
                height: 11.844,
                rx: 1.579,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#947DFF",
                d: "M24.479 121.894H85.28v3.948H24.479z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 31.191,
                cy: 115.972,
                r: 1.974,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 37.112,
                y: 113.208,
                width: 44.219,
                height: 5.527,
                rx: 0.79,
                fill: "url(#paint3_linear_377_52050)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 22.11,
                y: 125.772,
                width: 65.538,
                height: 11.844,
                rx: 1.579,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#947DFF",
                d: "M24.479 137.617H85.28v3.948H24.479z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 31.191,
                cy: 131.695,
                r: 1.974,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 37.112,
                y: 128.931,
                width: 44.219,
                height: 5.527,
                rx: 0.79,
                fill: "url(#paint4_linear_377_52050)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 22.11,
                y: 141.495,
                width: 65.538,
                height: 11.844,
                rx: 1.579,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fill: "#947DFF",
                d: "M24.479 153.339H85.28v3.948H24.479z"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 31.191,
                cy: 147.417,
                r: 1.974,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 37.112,
                y: 144.654,
                width: 44.219,
                height: 5.527,
                rx: 0.79,
                fill: "url(#paint5_linear_377_52050)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 22.11,
                y: 157.218,
                width: 65.538,
                height: 11.844,
                rx: 1.579,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M24.479 169.062h60.8v.411a3.538 3.538 0 0 1-3.537 3.538H28.016a3.538 3.538 0 0 1-3.537-3.538v-.411Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 31.19,
                cy: 163.14,
                r: 1.974,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 37.113,
                y: 160.377,
                width: 44.219,
                height: 5.527,
                rx: 0.79,
                fill: "url(#paint6_linear_377_52050)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M24.468 78.21a3.537 3.537 0 0 1 3.537-3.537h53.459A3.537 3.537 0 0 1 85 78.21v.394H24.468v-.394Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 94.93,
                y: 38.172,
                width: 47.656,
                height: 66.406,
                rx: 12.5,
                fill: "url(#paint7_linear_377_52050)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 100.399,
                y: 73.842,
                width: 36.719,
                height: 6.896,
                rx: 2.778,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 100.399,
                y: 84.966,
                width: 36.719,
                height: 6.896,
                rx: 2.778,
                fill: "#FBF9FF",
                stroke: "#815AE3",
                strokeWidth: 0.694
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 128.414,
                y: 86.853,
                width: 0.768,
                height: 3.125,
                rx: 0.384,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M104.479 77.29c0-.382.309-.69.69-.69h14.94a.69.69 0 1 1 0 1.379h-14.94a.69.69 0 0 1-.69-.69Zm19.04 0c0-.382.308-.69.689-.69h4.061a.69.69 0 1 1 0 1.379h-4.061a.689.689 0 0 1-.689-.69Zm7.489-.69a.69.69 0 1 0 0 1.379h1.34a.69.69 0 1 0 0-1.38h-1.34Z",
                fill: "#9877EA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                cx: 107.878,
                cy: 88.413,
                rx: 1.36,
                ry: 1.379,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                cx: 113.319,
                cy: 88.413,
                rx: 1.36,
                ry: 1.379,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                cx: 118.758,
                cy: 88.413,
                rx: 1.36,
                ry: 1.379,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("ellipse", {
                cx: 124.198,
                cy: 88.413,
                rx: 1.36,
                ry: 1.379,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 109.774,
                y: 49.11,
                width: 17.969,
                height: 17.969,
                rx: 6.016,
                fill: "#FBF9FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 118.758,
                cy: 54.351,
                r: 2.995,
                fill: "#FFB95A"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M114.266 61.102a3.008 3.008 0 0 1 3.009-3.008h2.968a3.008 3.008 0 0 1 3.008 3.008v1.477c0 .831-.674 1.504-1.504 1.504h-5.976a1.505 1.505 0 0 1-1.505-1.504v-1.477Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M79.287 116.905a3.906 3.906 0 0 1 3.906-3.906h83.75a3.906 3.906 0 0 1 3.906 3.906v53.382H79.287v-53.382Z",
                fill: "url(#paint8_linear_377_52050)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M79.287 116.905a3.906 3.906 0 0 1 3.906-3.906h83.75a3.906 3.906 0 0 1 3.906 3.906v53.382H79.287v-53.382Z",
                fill: "url(#paint9_linear_377_52050)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M79.287 116.905a3.906 3.906 0 0 1 3.906-3.906h83.75a3.906 3.906 0 0 1 3.906 3.906v53.382H79.287v-53.382Z",
                stroke: "url(#paint10_linear_377_52050)",
                strokeWidth: 2.529
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M70.078 168.889H179.23v1.276a2.585 2.585 0 0 1-2.585 2.585H73.309a3.23 3.23 0 0 1-3.231-3.231v-.63Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M70.078 168.889H179.23v1.276a2.585 2.585 0 0 1-2.585 2.585H73.309a3.23 3.23 0 0 1-3.231-3.231v-.63Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 167.917,
                y: 50.914,
                width: 5.015,
                height: 5.015,
                rx: 1.563,
                transform: "rotate(30.813 167.917 50.914)",
                fill: "#FFDDB5"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M186.482 66.6c0-.09.073-.162.163-.162h1.467c.09 0 .163.072.163.162v2.901l2.397-1.447a.155.155 0 0 1 .218.058l.739 1.339a.17.17 0 0 1-.061.227l-2.397 1.447 2.397 1.448a.17.17 0 0 1 .061.227l-.739 1.338a.155.155 0 0 1-.218.058l-2.397-1.447v2.9c0 .09-.073.163-.163.163h-1.467a.163.163 0 0 1-.163-.162v-2.901l-2.397 1.448a.156.156 0 0 1-.219-.059l-.738-1.338a.17.17 0 0 1 .06-.227l2.398-1.448-2.398-1.448a.172.172 0 0 1-.061-.227l.739-1.338a.156.156 0 0 1 .219-.058l2.397 1.447v-2.9Z",
                fill: "#E5E1EC"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M91.024 57.875h-31a8 8 0 0 0-8 8v6",
                stroke: "#A782E8",
                strokeWidth: 0.781,
                strokeDasharray: "2.73 2.73"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M52.694 72.758a.781.781 0 0 1-1.34 0l-1.62-2.7a.781.781 0 0 1 .67-1.183h3.24c.608 0 .983.662.67 1.183l-1.62 2.7Z",
                fill: "#A782E8"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                opacity: 0.9,
                x: 104.885,
                y: 121.893,
                width: 56.714,
                height: 40.867,
                rx: 3.118,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 111.557,
                y: 132.736,
                width: 43.369,
                height: 3.336,
                rx: 1.247,
                fill: "#C29DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 111.557,
                y: 152.752,
                width: 21.685,
                height: 3.336,
                rx: 1.247,
                fill: "#C29DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 111.557,
                y: 146.08,
                width: 43.369,
                height: 3.336,
                rx: 1.247,
                fill: "#C29DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 111.557,
                y: 139.42,
                width: 29.533,
                height: 3.324,
                rx: 1.247,
                fill: "#C29DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("rect", {
                x: 144.654,
                y: 139.42,
                width: 10.272,
                height: 3.324,
                rx: 1.247,
                fill: "#C29DFF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 111.104,
                cy: 126.891,
                r: 1.215,
                fill: "#FBF9FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 115.963,
                cy: 126.891,
                r: 1.215,
                fill: "#FBF9FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("circle", {
                cx: 120.822,
                cy: 126.891,
                r: 1.215,
                fill: "#FBF9FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "m41.505 50.313-.867-1.502a1.734 1.734 0 0 0-2.368-.634v0c-.83.478-1.89.194-2.369-.635v0a1.734 1.734 0 0 0-2.368-.635l-1.502.867",
                stroke: "#FFDDB5",
                strokeWidth: 1.563,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M58.48 130.884a.39.39 0 0 0 0 .782v-.782Zm0 .782h1.28v-.782h-1.28v.782Zm3.841 0h2.56v-.782h-2.56v.782Zm5.12 0h2.56v-.782h-2.56v.782Zm5.12 0h2.56v-.782h-2.56v.782Zm5.12 0h2.56v-.782h-2.56v.782Zm5.12 0h2.56v-.782h-2.56v.782Zm5.121 0h2.56v-.782h-2.56v.782Zm5.12 0h1.28v-.782h-1.28v.782Z",
                fill: "url(#paint11_linear_377_52050)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M97.894 131.074a.234.234 0 0 1 0 .402l-3.217 1.93a.235.235 0 0 1-.355-.201v-3.86c0-.182.199-.295.355-.201l3.217 1.93Z",
                fill: "#F3EEFA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M58.48 142.662a.39.39 0 0 0 0 .782v-.782Zm0 .782h1.28v-.782h-1.28v.782Zm3.841 0h2.56v-.782h-2.56v.782Zm5.12 0h2.56v-.782h-2.56v.782Zm5.12 0h2.56v-.782h-2.56v.782Zm5.12 0h2.56v-.782h-2.56v.782Zm5.12 0h2.56v-.782h-2.56v.782Zm5.121 0h2.56v-.782h-2.56v.782Zm5.12 0h1.28v-.782h-1.28v.782Z",
                fill: "url(#paint12_linear_377_52050)"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M97.894 142.852a.234.234 0 0 1 0 .402l-3.217 1.93a.235.235 0 0 1-.355-.201v-3.86c0-.182.199-.295.355-.201l3.217 1.93ZM58.48 155.222a.39.39 0 0 0 0 .781v-.781Zm0 .781h1.28v-.781h-1.28v.781Zm3.841 0h2.56v-.781h-2.56v.781Zm5.12 0h2.56v-.781h-2.56v.781Zm5.12 0h2.56v-.781h-2.56v.781Zm5.12 0h2.56v-.781h-2.56v.781Zm5.12 0h2.56v-.781h-2.56v.781Zm5.121 0h2.56v-.781h-2.56v.781Zm5.12 0h1.28v-.781h-1.28v.781Z",
                fill: "#F3EEFA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                d: "M97.894 155.412a.234.234 0 0 1 0 .402l-3.217 1.929a.234.234 0 0 1-.355-.201v-3.859c0-.182.199-.295.355-.201l3.217 1.93Z",
                fill: "#F3EEFA"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                opacity: 0.5,
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M167.093 95.67a6.278 6.278 0 0 0 6.7.265 6.277 6.277 0 1 0-6.277-10.873l-2.089-3.617-.4-.694",
                        stroke: "#AF9EFF",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                        filter: "url(#filter0_b_377_52050)",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                                d: "M161.265 74.229a3.906 3.906 0 1 1 3.906 6.766 3.906 3.906 0 0 1-3.906-6.766Z",
                                fill: "#CABEFF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                                d: "M161.515 74.662a3.406 3.406 0 1 1 3.406 5.9 3.406 3.406 0 0 1-3.406-5.9Z",
                                stroke: "#AF9EFF",
                                strokeLinecap: "round"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                        filter: "url(#filter1_b_377_52050)",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                                d: "M168.731 87.117a3.906 3.906 0 1 1 3.906 6.767 3.906 3.906 0 0 1-3.906-6.767Z",
                                fill: "#CABEFF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                                d: "M168.981 87.55a3.406 3.406 0 1 1 3.406 5.9 3.406 3.406 0 0 1-3.406-5.9Z",
                                stroke: "#AF9EFF",
                                strokeLinecap: "round"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("g", {
                        filter: "url(#filter2_b_377_52050)",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                                d: "M153.731 86.984a3.906 3.906 0 1 1 3.906 6.767 3.906 3.906 0 0 1-3.906-6.767Z",
                                fill: "#CABEFF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                                d: "M153.981 87.417a3.406 3.406 0 1 1 3.406 5.9 3.406 3.406 0 0 1-3.406-5.9Z",
                                stroke: "#AF9EFF",
                                strokeLinecap: "round"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M152.967 84.796a6.279 6.279 0 0 0 2.698 11.947 6.277 6.277 0 0 0 6.278-6.277h4.966",
                        stroke: "#AF9EFF",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                        d: "M169.337 78.12a6.28 6.28 0 0 0-11.696-3.637 6.277 6.277 0 0 0 2.298 8.575l-2.432 4.212",
                        stroke: "#AF9EFF",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.281 74.25a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25Zm0-1.563a1.563 1.563 0 1 0 0-3.125 1.563 1.563 0 0 0 0 3.126Z",
                fill: "#FFD5FF"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint0_linear_377_52050",
                        x1: 98.767,
                        y1: 51.618,
                        x2: 98.767,
                        y2: 173.531,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#F3EFFA"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F3EFFA",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint1_linear_377_52050",
                        x1: 37.143,
                        y1: 86.947,
                        x2: 81.357,
                        y2: 81.641,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#B6A6FB"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 0.443,
                                stopColor: "#C1B3FD"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CABEFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint2_linear_377_52050",
                        x1: 37.143,
                        y1: 102.67,
                        x2: 81.357,
                        y2: 97.364,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#B6A6FB"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 0.443,
                                stopColor: "#C1B3FD"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CABEFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint3_linear_377_52050",
                        x1: 37.143,
                        y1: 118.393,
                        x2: 81.357,
                        y2: 113.087,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#B6A6FB"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 0.443,
                                stopColor: "#C1B3FD"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CABEFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint4_linear_377_52050",
                        x1: 37.143,
                        y1: 134.116,
                        x2: 81.357,
                        y2: 128.81,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#B6A6FB"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 0.443,
                                stopColor: "#C1B3FD"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CABEFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint5_linear_377_52050",
                        x1: 37.143,
                        y1: 149.838,
                        x2: 81.357,
                        y2: 144.533,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#B6A6FB"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 0.443,
                                stopColor: "#C1B3FD"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CABEFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint6_linear_377_52050",
                        x1: 37.143,
                        y1: 165.562,
                        x2: 81.357,
                        y2: 160.256,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#B6A6FB"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 0.443,
                                stopColor: "#C1B3FD"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CABEFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint7_linear_377_52050",
                        x1: 118.758,
                        y1: 38.172,
                        x2: 85.871,
                        y2: 96.888,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#C39EFF"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#906FEF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint8_linear_377_52050",
                        x1: 122.818,
                        y1: 113.085,
                        x2: 142.351,
                        y2: 178.875,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint9_linear_377_52050",
                        x1: 172.114,
                        y1: 171.553,
                        x2: 27.074,
                        y2: 79.746,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#BC97FD"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#BC97FD",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint10_linear_377_52050",
                        x1: 122.818,
                        y1: 113.085,
                        x2: 142.351,
                        y2: 178.875,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint11_linear_377_52050",
                        x1: 57.938,
                        y1: 131.775,
                        x2: 93.779,
                        y2: 131.775,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#7F43E9"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 0.615,
                                stopColor: "#A070F4"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 0.714,
                                stopColor: "#E6DCF9"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F2EEFA"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("linearGradient", {
                        id: "paint12_linear_377_52050",
                        x1: 57.938,
                        y1: 143.553,
                        x2: 93.779,
                        y2: 143.553,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                stopColor: "#7F43E9"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 0.615,
                                stopColor: "#A070F4"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 0.714,
                                stopColor: "#E6DCF9"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F2EEFA"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("filter", {
                        id: "filter0_b_377_52050",
                        x: 156.186,
                        y: 70.58,
                        width: 14.064,
                        height: 14.064,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feGaussianBlur", {
                                in: "BackgroundImageFix",
                                stdDeviation: 1.563
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feComposite", {
                                in2: "SourceAlpha",
                                operator: "in",
                                result: "effect1_backgroundBlur_377_52050"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_backgroundBlur_377_52050",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("filter", {
                        id: "filter1_b_377_52050",
                        x: 163.652,
                        y: 83.468,
                        width: 14.064,
                        height: 14.064,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feGaussianBlur", {
                                in: "BackgroundImageFix",
                                stdDeviation: 1.563
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feComposite", {
                                in2: "SourceAlpha",
                                operator: "in",
                                result: "effect1_backgroundBlur_377_52050"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_backgroundBlur_377_52050",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("filter", {
                        id: "filter2_b_377_52050",
                        x: 148.652,
                        y: 83.335,
                        width: 14.064,
                        height: 14.064,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feGaussianBlur", {
                                in: "BackgroundImageFix",
                                stdDeviation: 1.563
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feComposite", {
                                in2: "SourceAlpha",
                                operator: "in",
                                result: "effect1_backgroundBlur_377_52050"
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_backgroundBlur_377_52050",
                                result: "shape"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $9e46c90b9cb432f2$export$2e2bcd8739ae039 = $9e46c90b9cb432f2$var$SvgWebhooksEmpty;






var $8Mb3E = parcelRequire("8Mb3E");

var $jGWQ4 = parcelRequire("jGWQ4");

var $66ixW = parcelRequire("66ixW");




var $4ZcUR = parcelRequire("4ZcUR");

var $jheqv = parcelRequire("jheqv");

var $7kooT = parcelRequire("7kooT");

var $C7mD2 = parcelRequire("C7mD2");

var $kUZ14 = parcelRequire("kUZ14");

var $dW2kG = parcelRequire("dW2kG");

var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $codQP = parcelRequire("codQP");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");
var $7i2be = parcelRequire("7i2be");






var $jGWQ4 = parcelRequire("jGWQ4");

var $5vVWy = parcelRequire("5vVWy");

var $7VnwS = parcelRequire("7VnwS");

var $5OcFi = parcelRequire("5OcFi");

function $44a12e755124d77f$var$CreateForm({ totalWebhookCount: totalWebhookCount, onClose: onClose }) {
    const { currentPlan: currentPlan } = (0, $jC8Vy.useContext)((0, $19434c930f80c964$export$f8addfd4ab69c833));
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const shouldBlockCreation = (0, $605aee781e0fe83f$export$1cc4b5152472cd4f)({
        quotaKey: "hooksLimit",
        usage: totalWebhookCount,
        plan: currentPlan
    });
    const formMethods = (0, $codQP.useForm)();
    const { handleSubmit: handleSubmit, formState: { isSubmitting: isSubmitting } } = formMethods;
    const api = (0, $7VnwS.default)();
    const onSubmit = handleSubmit((0, $5OcFi.trySubmitSafe)(async (data)=>{
        const { name: name, events: events, url: url } = data;
        const payload = {
            name: name,
            events: events,
            config: {
                url: url
            }
        };
        const created = await api.post("api/hooks", {
            json: payload
        }).json();
        onClose(created);
    }));
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5vVWy.default), {
        title: "webhooks.create_form.title",
        subtitle: "webhooks.create_form.subtitle",
        footer: shouldBlockCreation ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $dafa1bad5a99c1ae$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7i2be.Trans), {
                components: {
                    a: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $a3bc63325dc3c1a8$export$2e2bcd8739ae039), {}),
                    planName: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $161f1bf99d56f621$export$2e2bcd8739ae039), {
                        name: currentPlan.name
                    })
                },
                children: t("upsell.paywall.hooks", {
                    count: currentPlan.quota.hooksLimit ?? 0
                })
            })
        }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
            disabled: isSubmitting,
            htmlType: "submit",
            title: "webhooks.create_form.create_webhook",
            size: "large",
            type: "primary",
            onClick: onSubmit
        }),
        size: "large",
        onClose: onClose,
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $codQP.FormProvider), {
            ...formMethods,
            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0fd19fecf067e270$export$2e2bcd8739ae039), {})
        })
    });
}
var $44a12e755124d77f$export$2e2bcd8739ae039 = $44a12e755124d77f$var$CreateForm;


function $63c1e62e381a65b0$var$CreateFormModal({ isOpen: isOpen, totalWebhookCount: totalWebhookCount, onClose: onClose }) {
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))), {
        shouldCloseOnOverlayClick: true,
        shouldCloseOnEsc: true,
        isOpen: isOpen,
        className: $dW2kG.content,
        overlayClassName: $dW2kG.overlay,
        onRequestClose: ()=>{
            onClose();
        },
        children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $44a12e755124d77f$export$2e2bcd8739ae039), {
            totalWebhookCount: totalWebhookCount,
            onClose: onClose
        })
    });
}
var $63c1e62e381a65b0$export$2e2bcd8739ae039 = $63c1e62e381a65b0$var$CreateFormModal;


var $8e23cffd3762101f$export$1ca1ec8b29a4ce27;
var $8e23cffd3762101f$export$5dd7af07b99bbd1e;
var $8e23cffd3762101f$export$bfd64c937657f93a;
var $8e23cffd3762101f$export$4a6dd88bada4e7d2;
$8e23cffd3762101f$export$1ca1ec8b29a4ce27 = `_PklPG_icon`;
$8e23cffd3762101f$export$5dd7af07b99bbd1e = `_PklPG_requests`;
$8e23cffd3762101f$export$bfd64c937657f93a = `_PklPG_rotating`;
$8e23cffd3762101f$export$4a6dd88bada4e7d2 = `_PklPG_shimmer`;


const $8a7bb57b1119e9c1$var$pageSize = (0, $8Mb3E.defaultPageSize);
const $8a7bb57b1119e9c1$var$webhooksPathname = "/webhooks";
const $8a7bb57b1119e9c1$var$createWebhookPathname = `${$8a7bb57b1119e9c1$var$webhooksPathname}/create`;
const $8a7bb57b1119e9c1$var$buildDetailsPathname = (id)=>`${$8a7bb57b1119e9c1$var$webhooksPathname}/${id}`;
function $8a7bb57b1119e9c1$var$Webhooks() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { search: search } = (0, $2Phw0.useLocation)();
    const { navigate: navigate, match: match } = (0, $4ZcUR.default)();
    const [{ page: page }, updateSearchParameters] = (0, $66a3eb3654f9d141$export$2e2bcd8739ae039)({
        page: 1
    });
    const { data: data, error: error, mutate: mutate } = (0, $voszV.default)((0, $7kooT.buildUrl)("api/hooks", {
        includeExecutionStats: String(true),
        page: String(page),
        page_size: String($8a7bb57b1119e9c1$var$pageSize)
    }));
    const isLoading = !data && !error;
    const [webhooks, totalCount] = data ?? [];
    const theme = (0, $jheqv.default)();
    const WebhookIcon = theme === (0, $5HVJe.Theme).Light ? (0, $9ce7c647d3e6d19b$export$2e2bcd8739ae039) : (0, $136645a5be0308ea$export$2e2bcd8739ae039);
    const isCreating = match($8a7bb57b1119e9c1$var$createWebhookPathname);
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $998b64ca82ed2460$export$2e2bcd8739ae039), {
        title: {
            title: "webhooks.title",
            subtitle: "webhooks.subtitle"
        },
        pageMeta: {
            titleKey: "webhooks.page_title"
        },
        createButton: {
            title: "webhooks.create",
            onClick: ()=>{
                navigate({
                    pathname: $8a7bb57b1119e9c1$var$createWebhookPathname,
                    search: search
                });
            }
        },
        table: {
            rowGroups: [
                {
                    key: "hooks",
                    data: webhooks
                }
            ],
            rowIndexKey: "id",
            isLoading: isLoading,
            errorMessage: error?.body?.message ?? error?.message,
            columns: [
                {
                    title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                        forKey: "webhooks.table.name"
                    }),
                    dataIndex: "name",
                    colSpan: 4,
                    render: ({ id: id, name: name })=>{
                        return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4d952cae22cb03fc$export$2e2bcd8739ae039), {
                            icon: /*#__PURE__*/ (0, $C7mD2.jsx)(WebhookIcon, {
                                className: $8e23cffd3762101f$export$1ca1ec8b29a4ce27
                            }),
                            title: name || t("general.unnamed"),
                            to: $8a7bb57b1119e9c1$var$buildDetailsPathname(id)
                        });
                    }
                },
                {
                    title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                        forKey: "webhooks.table.events"
                    }),
                    dataIndex: "events",
                    colSpan: 7,
                    render: ({ event: event, events: events })=>{
                        const eventArray = (0, $7oDSS.conditional)(events.length > 0 && events) ?? [
                            event
                        ];
                        return eventArray.join(" / ");
                    }
                },
                {
                    title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                        forKey: "webhooks.table.success_rate"
                    }),
                    dataIndex: "successRate",
                    colSpan: 3,
                    render: ({ enabled: enabled, executionStats: executionStats })=>{
                        return enabled ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $bf71bbe717c9527a$export$2e2bcd8739ae039), {
                            isNumberOnly: true,
                            stats: executionStats
                        }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
                            type: "state",
                            status: "info",
                            variant: "plain",
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                                forKey: "webhook_details.not_in_use"
                            })
                        });
                    }
                },
                {
                    title: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $66ixW.default), {
                        forKey: "webhooks.table.requests"
                    }),
                    dataIndex: "Requests",
                    colSpan: 2,
                    render: ({ enabled: enabled, executionStats: { requestCount: requestCount } })=>{
                        return /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                            className: $8e23cffd3762101f$export$5dd7af07b99bbd1e,
                            children: enabled ? requestCount.toLocaleString() : "-"
                        });
                    }
                }
            ],
            rowClickHandler: ({ id: id })=>{
                navigate($8a7bb57b1119e9c1$var$buildDetailsPathname(id));
            },
            placeholder: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2b56c00d3802884b$export$2e2bcd8739ae039), {
                image: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $9e46c90b9cb432f2$export$2e2bcd8739ae039), {}),
                imageDark: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $d03b0a790a2f36dc$export$2e2bcd8739ae039), {}),
                title: "webhooks.placeholder.title",
                description: "webhooks.placeholder.description",
                action: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                    title: "webhooks.placeholder.create_webhook",
                    type: "primary",
                    size: "large",
                    icon: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0b30fe81c923292b$export$2e2bcd8739ae039), {}),
                    onClick: ()=>{
                        navigate({
                            pathname: $8a7bb57b1119e9c1$var$createWebhookPathname,
                            search: search
                        });
                    }
                })
            }),
            pagination: {
                page: page,
                totalCount: totalCount,
                pageSize: $8a7bb57b1119e9c1$var$pageSize,
                onChange: (page)=>{
                    updateSearchParameters({
                        page: page
                    });
                }
            }
        },
        widgets: totalCount !== undefined && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $63c1e62e381a65b0$export$2e2bcd8739ae039), {
            isOpen: isCreating,
            totalWebhookCount: totalCount,
            onClose: (createdHook)=>{
                if (createdHook) {
                    mutate();
                    (0, $FuhPC.toast).success(t("webhooks.webhook_created", {
                        name: createdHook.name
                    }));
                    navigate($8a7bb57b1119e9c1$var$buildDetailsPathname(createdHook.id), {
                        replace: true
                    });
                    return;
                }
                navigate({
                    pathname: $8a7bb57b1119e9c1$var$webhooksPathname,
                    search: search
                });
            }
        })
    });
}
var $8a7bb57b1119e9c1$export$2e2bcd8739ae039 = $8a7bb57b1119e9c1$var$Webhooks;


const $e58fad32acd95b0b$export$aa36226794eafa45 = {
    path: "webhooks",
    children: [
        {
            index: true,
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8a7bb57b1119e9c1$export$2e2bcd8739ae039), {})
        },
        {
            path: "create",
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8a7bb57b1119e9c1$export$2e2bcd8739ae039), {})
        },
        {
            path: ":id",
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ad717f5a666bc47c$export$2e2bcd8739ae039), {}),
            children: [
                {
                    index: true,
                    element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Navigate), {
                        replace: true,
                        to: (0, $bt3dS.WebhookDetailsTabs).Settings
                    })
                },
                {
                    path: (0, $bt3dS.WebhookDetailsTabs).Settings,
                    element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $89ef666eee87620e$export$2e2bcd8739ae039), {})
                },
                {
                    path: (0, $bt3dS.WebhookDetailsTabs).RecentRequests,
                    element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $71f33c94e7a3358a$export$2e2bcd8739ae039), {})
                }
            ]
        },
        {
            path: `:hookId/${(0, $bt3dS.WebhookDetailsTabs).RecentRequests}/:logId`,
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $01bafbd02b1a9b1b$export$2e2bcd8739ae039), {})
        }
    ]
};


const $f93a08fbdc364e8c$export$5fd9d998ce2aa316 = ()=>{
    const tenantSettings = (0, $61fe018927210141$export$3f533f36fbeec097)();
    const routeObjects = (0, $jC8Vy.useMemo)(()=>(0, $7oDSS.condArray)({
            path: "*",
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $g0vtZ.default), {})
        }, {
            path: "get-started",
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $1ab7b740c116daef$export$2e2bcd8739ae039), {})
        }, {
            path: "dashboard",
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6f42ee3417378e11$export$2e2bcd8739ae039), {})
        }, (0, $ca1fff02ab32f880$export$e7ad650a602a37dc), (0, $362cfc57314b0c6f$export$23ad47434f71b6b1), (0, $f515e6d2516c8f43$export$c9ca09bcb5604fad), {
            path: "mfa",
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f75a1f06c05de4cc$export$2e2bcd8739ae039), {})
        }, (0, $01ab90c2db008176$export$8f569aada139fb21), (0, $472148578556eea4$export$91c27cce9e6d3628), (0, $e58fad32acd95b0b$export$aa36226794eafa45), (0, $9f94c07d9bd81cd2$export$7652f722913b5d7), (0, $a728fa81fe4486eb$export$5200962c4a74900e), (0, $8b22258bc8f800c0$export$8e77a375f9a5908e), (0, $4d9c808c996a5276$export$9d2f05f7e7fe6f0c), (0, $23b66b8a4660b99c$export$fe0f87d711783637), {
            path: "signing-keys",
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $72b1045649d1b774$export$2e2bcd8739ae039), {})
        }, (0, $8TpMk.isCloud) && tenantSettings, (0, $cb2118ff38a4baa7$export$1c195da67e015885)), [
        tenantSettings
    ]);
    return routeObjects;
};




parcelRequire("9zW7e");
var $jSb9j = parcelRequire("jSb9j");
var $gz11x = parcelRequire("gz11x");
parcelRequire("cuPVN");
var $aZIrr = parcelRequire("aZIrr");

var $jC8Vy = parcelRequire("jC8Vy");

var $8TpMk = parcelRequire("8TpMk");

var $cDKfs = parcelRequire("cDKfs");


var $azCDQ = parcelRequire("azCDQ");

/**
 * Listens to the tenant scope changes for the current signed-in user. This hook will fetch the tenant scopes
 * for the user, and compare it with the "scope" token claim in access token. After comparing the scopes:
 *
 * - If the user has been granted new scopes, it will re-consent to obtain the additional scopes.
 * - If the user has been revoked scopes, it will clear the cached access token and renew one with shrunk scopes.
 *
 * Note: This hook should only be used once in the ConsoleContent component.
 */ const $8e55467dfba6c0c0$var$useTenantScopeListener = ()=>{
    const { currentTenantId: currentTenantId, removeTenant: removeTenant, navigateTenant: navigateTenant } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { clearAccessToken: clearAccessToken, clearAllTokens: clearAllTokens, getOrganizationTokenClaims: getOrganizationTokenClaims, signIn: signIn } = (0, $jSb9j.useLogto)();
    const [tokenClaims, setTokenClaims] = (0, $jC8Vy.useState)();
    const redirectUri = (0, $azCDQ.default)();
    const { scopes: scopes = [], isLoading: isLoading } = (0, $1f7ad510e5c2dafe$export$2e2bcd8739ae039)();
    (0, $jC8Vy.useEffect)(()=>{
        (async ()=>{
            const organizationId = (0, $aZIrr.getTenantOrganizationId)(currentTenantId);
            const claims = await getOrganizationTokenClaims(organizationId);
            setTokenClaims(claims?.scope?.split(" ") ?? []);
        })();
    }, [
        currentTenantId,
        getOrganizationTokenClaims
    ]);
    (0, $jC8Vy.useEffect)(()=>{
        if ((0, $8TpMk.isCloud) && !isLoading && scopes.length === 0) {
            // User has no access to the current tenant. Navigate to root and it will return to the
            // last visited tenant, or fallback to the page where the user can create a new tenant.
            removeTenant(currentTenantId);
            navigateTenant("");
        }
    }, [
        currentTenantId,
        isLoading,
        navigateTenant,
        removeTenant,
        scopes.length
    ]);
    (0, $jC8Vy.useEffect)(()=>{
        if (!(0, $8TpMk.isCloud) || isLoading || tokenClaims === undefined) return;
        const hasScopesGranted = scopes.some((scope)=>!tokenClaims.includes(scope));
        const hasScopesRevoked = tokenClaims.some((claim)=>!scopes.includes(claim));
        if (hasScopesGranted) (async ()=>{
            // User has been newly granted scopes. Need to re-consent to obtain the additional scopes.
            (0, $fb6222c61a959560$export$5027ce2731efc4b9)();
            await clearAllTokens();
            signIn({
                redirectUri: redirectUri.href,
                prompt: (0, $gz11x.Prompt).Consent
            });
        })();
        if (hasScopesRevoked) clearAccessToken();
    }, [
        clearAccessToken,
        clearAllTokens,
        isLoading,
        redirectUri.href,
        scopes,
        signIn,
        tokenClaims
    ]);
};
var $8e55467dfba6c0c0$export$2e2bcd8739ae039 = $8e55467dfba6c0c0$var$useTenantScopeListener;


var $fffa0a7c69b6e899$export$a7db06668cad9adb;
var $fffa0a7c69b6e899$export$62f13789dbf11a3d;
var $fffa0a7c69b6e899$export$f22da7240b7add18;
var $fffa0a7c69b6e899$export$1b0156572ca541be;
var $fffa0a7c69b6e899$export$bfd64c937657f93a;
var $fffa0a7c69b6e899$export$4a6dd88bada4e7d2;
$fffa0a7c69b6e899$export$a7db06668cad9adb = `lQ-hZW_content`;
$fffa0a7c69b6e899$export$62f13789dbf11a3d = `lQ-hZW_devStatus`;
$fffa0a7c69b6e899$export$f22da7240b7add18 = `lQ-hZW_main`;
$fffa0a7c69b6e899$export$1b0156572ca541be = `lQ-hZW_overlayScrollbarWrapper`;
$fffa0a7c69b6e899$export$bfd64c937657f93a = `lQ-hZW_rotating`;
$fffa0a7c69b6e899$export$4a6dd88bada4e7d2 = `lQ-hZW_shimmer`;


function $789e66187e9660db$var$ConsoleContent() {
    const { scrollableContent: scrollableContent } = (0, $2Phw0.useOutletContext)();
    const routeObjects = (0, $f93a08fbdc364e8c$export$5fd9d998ce2aa316)();
    const routes = (0, $2Phw0.useRoutes)(routeObjects);
    (0, $77d0d5b50790ecf4$export$751a22e57b65a4b5)(routeObjects, ":tenantId");
    // Use this hook here to make sure console listens to user tenant scope changes.
    (0, $8e55467dfba6c0c0$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: $fffa0a7c69b6e899$export$a7db06668cad9adb,
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $342fa151f579f1c8$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $aTllQ.default), {
                className: $fffa0a7c69b6e899$export$1b0156572ca541be,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                    ref: scrollableContent,
                    className: $fffa0a7c69b6e899$export$f22da7240b7add18,
                    children: routes
                })
            }),
            (0, $8TpMk.isDevFeaturesEnabled) && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2a497e719fce103a$export$2e2bcd8739ae039), {
                type: "state",
                status: "success",
                variant: "plain",
                className: $fffa0a7c69b6e899$export$62f13789dbf11a3d,
                children: "Dev features enabled"
            })
        ]
    });
}
var $789e66187e9660db$export$2e2bcd8739ae039 = $789e66187e9660db$var$ConsoleContent;




var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("9zW7e");
var $jSb9j = parcelRequire("jSb9j");

var $jC8Vy = parcelRequire("jC8Vy");

var $2Phw0 = parcelRequire("2Phw0");
parcelRequire("voszV");
var $hgWIN = parcelRequire("hgWIN");

var $cDKfs = parcelRequire("cDKfs");
function $221c442edb38588d$export$2e2bcd8739ae039() {
    const { isAuthenticated: isAuthenticated } = (0, $jSb9j.useLogto)();
    const { currentTenant: currentTenant, currentTenantId: currentTenantId } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    const { mutate: mutate } = (0, $hgWIN.useSWRConfig)();
    // Clean the cache when the current tenant ID changes. This is required because the
    // SWR cache key is not tenant-aware.
    (0, $jC8Vy.useEffect)(()=>{
        mutate((key)=>typeof key !== "string" || key !== "me" && !key.includes("/.well-known/"), undefined, {
            rollbackOnError: false,
            throwOnError: false
        });
    }, [
        mutate,
        currentTenantId
    ]);
    (0, $jC8Vy.useEffect)(()=>{
        if (isAuthenticated && currentTenantId && // The current tenant is unavailable to the user, maybe a deleted tenant or a tenant that
        // the user has no access to. Fall back to the home page.
        !currentTenant) // eslint-disable-next-line @silverhand/fp/no-mutation
        window.location.href = "/";
    }, [
        currentTenant,
        currentTenantId,
        isAuthenticated
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Outlet), {});
}



var $cDKfs = parcelRequire("cDKfs");


var $jC8Vy = parcelRequire("jC8Vy");


var $7VnwS = parcelRequire("7VnwS");

const $5fa8c90f5e3d9098$var$useSwrOptions = ()=>{
    const api = (0, $7VnwS.default)();
    const fetcher = (0, $04c74fc7d2f91811$export$2e2bcd8739ae039)(api);
    const config = (0, $jC8Vy.useMemo)(()=>({
            fetcher: fetcher,
            shouldRetryOnError: (0, $d3d6bc7d2607318c$export$9ea285d0c158d4f1)({
                ignore: [
                    401,
                    403
                ]
            })
        }), [
        fetcher
    ]);
    return config;
};
var $5fa8c90f5e3d9098$export$2e2bcd8739ae039 = $5fa8c90f5e3d9098$var$useSwrOptions;






var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("9zW7e");
var $jSb9j = parcelRequire("jSb9j");

var $5UrGx = parcelRequire("5UrGx");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $5OuPq = parcelRequire("5OuPq");


var $jGWQ4 = parcelRequire("jGWQ4");

var $azCDQ = parcelRequire("azCDQ");

var $4ZcUR = parcelRequire("4ZcUR");

var $jheqv = parcelRequire("jheqv");
var $b3fb6a4438aac200$exports = {};

$parcel$export($b3fb6a4438aac200$exports, "button", function () { return $b3fb6a4438aac200$export$2ba01fb71ed41cb6; }, function (v) { return $b3fb6a4438aac200$export$2ba01fb71ed41cb6 = v; });
$parcel$export($b3fb6a4438aac200$exports, "container", function () { return $b3fb6a4438aac200$export$34e0f9847d4c02dd; }, function (v) { return $b3fb6a4438aac200$export$34e0f9847d4c02dd = v; });
$parcel$export($b3fb6a4438aac200$exports, "content", function () { return $b3fb6a4438aac200$export$a7db06668cad9adb; }, function (v) { return $b3fb6a4438aac200$export$a7db06668cad9adb = v; });
$parcel$export($b3fb6a4438aac200$exports, "dark", function () { return $b3fb6a4438aac200$export$55ce6f3a06c59543; }, function (v) { return $b3fb6a4438aac200$export$55ce6f3a06c59543 = v; });
$parcel$export($b3fb6a4438aac200$exports, "description", function () { return $b3fb6a4438aac200$export$6d59db4903f20f7d; }, function (v) { return $b3fb6a4438aac200$export$6d59db4903f20f7d = v; });
$parcel$export($b3fb6a4438aac200$exports, "header", function () { return $b3fb6a4438aac200$export$38e42c68cf43b5d4; }, function (v) { return $b3fb6a4438aac200$export$38e42c68cf43b5d4 = v; });
$parcel$export($b3fb6a4438aac200$exports, "light", function () { return $b3fb6a4438aac200$export$a43af521ac8c3202; }, function (v) { return $b3fb6a4438aac200$export$a43af521ac8c3202 = v; });
$parcel$export($b3fb6a4438aac200$exports, "logo", function () { return $b3fb6a4438aac200$export$db3c28d99448dcff; }, function (v) { return $b3fb6a4438aac200$export$db3c28d99448dcff = v; });
$parcel$export($b3fb6a4438aac200$exports, "placeholderBottom", function () { return $b3fb6a4438aac200$export$d039a117f4b4a172; }, function (v) { return $b3fb6a4438aac200$export$d039a117f4b4a172 = v; });
$parcel$export($b3fb6a4438aac200$exports, "placeholderTop", function () { return $b3fb6a4438aac200$export$2a783d3dea58cac6; }, function (v) { return $b3fb6a4438aac200$export$2a783d3dea58cac6 = v; });
$parcel$export($b3fb6a4438aac200$exports, "rotating", function () { return $b3fb6a4438aac200$export$bfd64c937657f93a; }, function (v) { return $b3fb6a4438aac200$export$bfd64c937657f93a = v; });
$parcel$export($b3fb6a4438aac200$exports, "shimmer", function () { return $b3fb6a4438aac200$export$4a6dd88bada4e7d2; }, function (v) { return $b3fb6a4438aac200$export$4a6dd88bada4e7d2 = v; });
$parcel$export($b3fb6a4438aac200$exports, "title", function () { return $b3fb6a4438aac200$export$fb184b623420d9be; }, function (v) { return $b3fb6a4438aac200$export$fb184b623420d9be = v; });
var $b3fb6a4438aac200$export$2ba01fb71ed41cb6;
var $b3fb6a4438aac200$export$34e0f9847d4c02dd;
var $b3fb6a4438aac200$export$a7db06668cad9adb;
var $b3fb6a4438aac200$export$55ce6f3a06c59543;
var $b3fb6a4438aac200$export$6d59db4903f20f7d;
var $b3fb6a4438aac200$export$38e42c68cf43b5d4;
var $b3fb6a4438aac200$export$a43af521ac8c3202;
var $b3fb6a4438aac200$export$db3c28d99448dcff;
var $b3fb6a4438aac200$export$d039a117f4b4a172;
var $b3fb6a4438aac200$export$2a783d3dea58cac6;
var $b3fb6a4438aac200$export$bfd64c937657f93a;
var $b3fb6a4438aac200$export$4a6dd88bada4e7d2;
var $b3fb6a4438aac200$export$fb184b623420d9be;
$b3fb6a4438aac200$export$2ba01fb71ed41cb6 = `hwnTFa_button`;
$b3fb6a4438aac200$export$34e0f9847d4c02dd = `hwnTFa_container`;
$b3fb6a4438aac200$export$a7db06668cad9adb = `hwnTFa_content`;
$b3fb6a4438aac200$export$55ce6f3a06c59543 = `hwnTFa_dark`;
$b3fb6a4438aac200$export$6d59db4903f20f7d = `hwnTFa_description`;
$b3fb6a4438aac200$export$38e42c68cf43b5d4 = `hwnTFa_header`;
$b3fb6a4438aac200$export$a43af521ac8c3202 = `hwnTFa_light`;
$b3fb6a4438aac200$export$db3c28d99448dcff = `hwnTFa_logo`;
$b3fb6a4438aac200$export$d039a117f4b4a172 = `hwnTFa_placeholderBottom`;
$b3fb6a4438aac200$export$2a783d3dea58cac6 = `hwnTFa_placeholderTop`;
$b3fb6a4438aac200$export$bfd64c937657f93a = `hwnTFa_rotating`;
$b3fb6a4438aac200$export$4a6dd88bada4e7d2 = `hwnTFa_shimmer`;
$b3fb6a4438aac200$export$fb184b623420d9be = `hwnTFa_title`;


function $4faae6e34e1f4591$var$Welcome() {
    const { t: t } = (0, $5OuPq.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { navigate: navigate } = (0, $4ZcUR.default)();
    const { isAuthenticated: isAuthenticated, signIn: signIn } = (0, $jSb9j.useLogto)();
    const theme = (0, $jheqv.default)();
    const redirectUri = (0, $azCDQ.default)();
    (0, $jC8Vy.useEffect)(()=>{
        // If authenticated, navigate to the console root page directly
        if (isAuthenticated) navigate("/");
    }, [
        isAuthenticated,
        navigate
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5UrGx)))($b3fb6a4438aac200$exports.container, $b3fb6a4438aac200$exports[theme]),
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                className: $b3fb6a4438aac200$exports.header,
                children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $19cfe35991ba791f$export$2e2bcd8739ae039), {
                    className: $b3fb6a4438aac200$exports.logo
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $b3fb6a4438aac200$exports.placeholderTop
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)("div", {
                        className: $b3fb6a4438aac200$exports.content,
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $b3fb6a4438aac200$exports.title,
                                children: t("welcome.title")
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                                className: $b3fb6a4438aac200$exports.description,
                                children: t("welcome.description")
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $jGWQ4.default), {
                                className: $b3fb6a4438aac200$exports.button,
                                size: "large",
                                type: "branding",
                                title: "welcome.create_account",
                                onClick: ()=>{
                                    signIn(redirectUri.href);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)("div", {
                        className: $b3fb6a4438aac200$exports.placeholderBottom
                    })
                ]
            })
        ]
    });
}
var $4faae6e34e1f4591$export$2e2bcd8739ae039 = $4faae6e34e1f4591$var$Welcome;



var $7kooT = parcelRequire("7kooT");
function $985aef1b59eccb24$var$Layout() {
    const swrOptions = (0, $5fa8c90f5e3d9098$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $voszV.SWRConfig), {
        value: swrOptions,
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $d7b7c71669250da7$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $8f6fee413997db41$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Outlet), {})
            ]
        })
    });
}
function $985aef1b59eccb24$export$5fc098aa6da4c1ea() {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $2Phw0.Routes), {
        children: [
            !(0, $8TpMk.isCloud) && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Route), {
                path: "/",
                element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Navigate), {
                    to: (0, $fjAdn.ossConsolePath)
                })
            }),
            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $2Phw0.Route), {
                path: "/:tenantId",
                element: /*#__PURE__*/ (0, $C7mD2.jsx)($985aef1b59eccb24$var$Layout, {}),
                children: [
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Route), {
                        path: "callback",
                        element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $5a59246c75af7fcf$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Route), {
                        path: "welcome",
                        element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4faae6e34e1f4591$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $2Phw0.Route), {
                        element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $0479ccdfd7d68c85$export$2e2bcd8739ae039), {}),
                        children: [
                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Route), {
                                path: (0, $7kooT.dropLeadingSlash)((0, $cDKfs.GlobalRoute).Profile) + "/*",
                                element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $22925f126a88c229$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $2Phw0.Route), {
                                element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $221c442edb38588d$export$2e2bcd8739ae039), {}),
                                children: [
                                    (0, $8TpMk.isCloud) && /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Route), {
                                        path: (0, $7kooT.dropLeadingSlash)((0, $cDKfs.GlobalRoute).CheckoutSuccessCallback),
                                        element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $99b45a51a5273fbc$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $2Phw0.Route), {
                                        element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ed805787af27257d$export$2e2bcd8739ae039), {}),
                                        children: [
                                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Route), {
                                                index: true,
                                                element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $ed805787af27257d$export$468d45f4f0fe384a), {})
                                            }),
                                            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.Route), {
                                                path: "*",
                                                element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $789e66187e9660db$export$2e2bcd8739ae039), {})
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $C7mD2 = parcelRequire("C7mD2");

var $jC8Vy = parcelRequire("jC8Vy");

var $4Mpch = parcelRequire("4Mpch");


function $685ccb709c810810$var$GoogleScripts({ userEmailHash: userEmailHash }) {
    if (!userEmailHash) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $4Mpch.Helmet), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("script", {
                async: true,
                crossOrigin: "anonymous",
                src: `https://www.googletagmanager.com/gtag/js?id=${(0, $34139a4008fff4d0$export$7e9b8aa268c9f6e)}`
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("script", {
                children: `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${(0, $34139a4008fff4d0$export$7e9b8aa268c9f6e)}', { 'allow_enhanced_conversions': true });
        gtag('set', 'user_data', { 'sha256_email_address': '${userEmailHash}' });
      `
            })
        ]
    });
}
function $685ccb709c810810$var$RedditScripts({ userEmailHash: userEmailHash }) {
    if (!userEmailHash) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4Mpch.Helmet), {
        children: /*#__PURE__*/ (0, $C7mD2.jsx)("script", {
            children: `
        !function(w,d){if(!w.rdt){var p=w.rdt=function(){p.sendEvent?p.sendEvent.apply(p,arguments):p.callQueue.push(arguments)};p.callQueue=[];var t=d.createElement("script");t.src="https://www.redditstatic.com/ads/pixel.js",t.async=!0;var s=d.getElementsByTagName("script")[0];s.parentNode.insertBefore(t,s)}}(window,document);
        rdt('init', '${(0, $34139a4008fff4d0$export$1a0493764955a0a9)}', {
          optOut: false,
          useDecimalCurrencyValues: true,
          email: '${userEmailHash}'
        });
      `
        })
    });
}
function $685ccb709c810810$var$PlausibleScripts() {
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $4Mpch.Helmet), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)("script", {
                async: true,
                defer: true,
                "data-domain": (0, $34139a4008fff4d0$export$cfa05c56c26bdd8f),
                src: "https://plausible.io/js/plausible.manual.js"
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)("script", {
                children: `window.plausible = window.plausible || function() { (window.plausible.q = window.plausible.q || []).push(arguments) }`
            })
        ]
    });
}
function $685ccb709c810810$export$e7de9b6ce55b98b0() {
    const { user: user, isLoaded: isLoaded } = (0, $8dc2d4d6918e57ba$export$2e2bcd8739ae039)();
    const [userEmailHash, setUserEmailHash] = (0, $jC8Vy.useState)();
    /**
   * Use user email to prevent duplicate conversion, and it is hashed before sending
   * to protect user privacy.
   */ (0, $jC8Vy.useEffect)(()=>{
        const init = async ()=>{
            setUserEmailHash(await (0, $34139a4008fff4d0$export$2cb26a492a43576c)(user?.primaryEmail ?? undefined));
        };
        if (isLoaded) init();
    }, [
        user,
        isLoaded
    ]);
    if (!(0, $34139a4008fff4d0$export$e4409b62080e611)) return null;
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)($685ccb709c810810$var$PlausibleScripts, {}),
            /*#__PURE__*/ (0, $C7mD2.jsx)($685ccb709c810810$var$GoogleScripts, {
                userEmailHash: userEmailHash
            }),
            /*#__PURE__*/ (0, $C7mD2.jsx)($685ccb709c810810$var$RedditScripts, {
                userEmailHash: userEmailHash
            })
        ]
    });
}


parcelRequire("8Mb3E");
var $ku6YN = parcelRequire("ku6YN");

var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("9zW7e");
var $4aiSz = parcelRequire("4aiSz");
var $v4mmb = parcelRequire("v4mmb");
parcelRequire("12bMu");
var $7oDSS = parcelRequire("7oDSS");


var $5cXXM = parcelRequire("5cXXM");

var $jC8Vy = parcelRequire("jC8Vy");
parcelRequire("jgimp");
var $2j4C6 = parcelRequire("2j4C6");


var $C7mD2 = parcelRequire("C7mD2");
parcelRequire("9zW7e");
var $jSb9j = parcelRequire("jSb9j");

var $jC8Vy = parcelRequire("jC8Vy");

var $azCDQ = parcelRequire("azCDQ");


/** This component shows a loading indicator and tries to sign in again. */ function $f87d151710ff3a86$var$SessionExpired() {
    const { signIn: signIn, isLoading: isLoading } = (0, $jSb9j.useLogto)();
    const redirectUri = (0, $azCDQ.default)();
    (0, $jC8Vy.useEffect)(()=>{
        if (!isLoading) {
            (0, $fb6222c61a959560$export$5027ce2731efc4b9)();
            signIn(redirectUri.href);
        }
    }, [
        signIn,
        isLoading,
        redirectUri
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4c070a72a1cf87ce$export$2e2bcd8739ae039), {});
}
var $f87d151710ff3a86$export$2e2bcd8739ae039 = $f87d151710ff3a86$var$SessionExpired;



var $7kooT = parcelRequire("7kooT");
/**
 * Returns true if the error is an OIDC invalid_grant error.
 *
 * OIDC request error is globally converted to the LogtoRequestError.
 * @see {@link @logto/core/packages/core/src/middleware/koa-oidc-error-handler.ts}
 * We need to check the error code to determine if it is an OIDC invalid_grant error.
 */ const $669f80d3b4a24e5b$var$isOidcInvalidGrantError = (error)=>{
    if (!(error instanceof (0, $4aiSz.LogtoRequestError))) return false;
    const oidcGrantErrors = [
        "oidc.invalid_grant",
        "oidc.invalid_target"
    ];
    return oidcGrantErrors.includes(error.code);
};
/**
 * An error boundary that catches errors in its children.
 * Note it uses several hooks and contexts:
 *
 * - Includes `useLogto()` (depending on `<LogtoProvider />`) to provide a "Sign in again" button for session expired errors.
 * - Includes `useTranslation()` to provide translations for the error messages.
 * - includes `useTheme()` (depending on `<AppThemeProvider />`) to provide the local stored theme.
 */ class $669f80d3b4a24e5b$var$ErrorBoundary extends (0, $jC8Vy.Component) {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    render() {
        const { children: children, t: t } = this.props;
        const { error: error } = this.state;
        if (!error) return children;
        // Different strategies for handling errors in callback pages since the callback errors
        // are likely unexpected and unrecoverable.
        if ((0, $7kooT.isInCallback)()) {
            if (error instanceof (0, $4aiSz.LogtoError) && error.data instanceof (0, $4aiSz.OidcError)) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6b7de14b6bd7147f$export$2e2bcd8739ae039), {
                errorCode: error.data.error,
                errorMessage: error.data.errorDescription,
                callStack: error.stack
            });
            return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6b7de14b6bd7147f$export$2e2bcd8739ae039), {
                errorCode: error.name,
                errorMessage: error.message,
                callStack: error.stack
            });
        }
        // Insecure contexts error is not recoverable
        if (error instanceof (0, $4aiSz.LogtoError) && error.code === "crypto_subtle_unavailable") return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6b7de14b6bd7147f$export$2e2bcd8739ae039), {
            errorMessage: t("errors.insecure_contexts"),
            callStack: error.stack
        });
        // Treat other Logto errors and 401 responses as session expired
        if (error instanceof (0, $4aiSz.LogtoError) || error instanceof (0, $v4mmb.LogtoClientError) || $669f80d3b4a24e5b$var$isOidcInvalidGrantError(error) || error instanceof (0, $5cXXM.HTTPError) && error.response.status === 401 || error instanceof (0, $33b9cc7fd9279a6b$export$286baf652d0b1206) && error.status === 401) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $f87d151710ff3a86$export$2e2bcd8739ae039), {});
        const callStack = (0, $7oDSS.conditional)(typeof error === "object" && typeof error.stack === "string" && error.stack.split("\n").slice(1).join("\n"));
        return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $6b7de14b6bd7147f$export$2e2bcd8739ae039), {
            errorMessage: error.message,
            callStack: callStack
        });
    }
    constructor(...args){
        super(...args);
        this.state = {};
    }
}
var $669f80d3b4a24e5b$export$2e2bcd8739ae039 = (0, $2j4C6.withTranslation)("translation", {
    keyPrefix: "admin_console"
})($669f80d3b4a24e5b$var$ErrorBoundary);


parcelRequire("9zW7e");
var $jSb9j = parcelRequire("jSb9j");

var $jC8Vy = parcelRequire("jC8Vy");
function $43a254827f8c4a12$export$2e2bcd8739ae039({ children: children }) {
    const { error: error } = (0, $jSb9j.useLogto)();
    (0, $jC8Vy.useEffect)(()=>{
        if (error) throw error;
    }, [
        error
    ]);
    return children;
}



var $3nBui = parcelRequire("3nBui");

var $fG7L1 = parcelRequire("fG7L1");

var $6gkG2 = parcelRequire("6gkG2");

var $cDKfs = parcelRequire("cDKfs");




var $4TsiV = parcelRequire("4TsiV");

var $1IOZg = parcelRequire("1IOZg");

var $lcCFm = parcelRequire("lcCFm");
var $07076184db6ae49a$var$arr = [];
var $07076184db6ae49a$var$each = $07076184db6ae49a$var$arr.forEach;
var $07076184db6ae49a$var$slice = $07076184db6ae49a$var$arr.slice;
function $07076184db6ae49a$var$defaults(obj) {
    $07076184db6ae49a$var$each.call($07076184db6ae49a$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
// eslint-disable-next-line no-control-regex
var $07076184db6ae49a$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var $07076184db6ae49a$var$serializeCookie = function serializeCookie(name, val, options) {
    var opt = options || {};
    opt.path = opt.path || "/";
    var value = encodeURIComponent(val);
    var str = "".concat(name, "=").concat(value);
    if (opt.maxAge > 0) {
        var maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error("maxAge should be a Number");
        str += "; Max-Age=".concat(Math.floor(maxAge));
    }
    if (opt.domain) {
        if (!$07076184db6ae49a$var$fieldContentRegExp.test(opt.domain)) throw new TypeError("option domain is invalid");
        str += "; Domain=".concat(opt.domain);
    }
    if (opt.path) {
        if (!$07076184db6ae49a$var$fieldContentRegExp.test(opt.path)) throw new TypeError("option path is invalid");
        str += "; Path=".concat(opt.path);
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") throw new TypeError("option expires is invalid");
        str += "; Expires=".concat(opt.expires.toUTCString());
    }
    if (opt.httpOnly) str += "; HttpOnly";
    if (opt.secure) str += "; Secure";
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return str;
};
var $07076184db6ae49a$var$cookie = {
    create: function create(name, value, minutes, domain) {
        var cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: "/",
            sameSite: "strict"
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $07076184db6ae49a$var$serializeCookie(name, encodeURIComponent(value), cookieOptions);
    },
    read: function read(name) {
        var nameEQ = "".concat(name, "=");
        var ca = document.cookie.split(";");
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) === " ")c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove: function remove(name) {
        this.create(name, "", -1);
    }
};
var $07076184db6ae49a$var$cookie$1 = {
    name: "cookie",
    lookup: function lookup(options) {
        var found;
        if (options.lookupCookie && typeof document !== "undefined") {
            var c = $07076184db6ae49a$var$cookie.read(options.lookupCookie);
            if (c) found = c;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupCookie && typeof document !== "undefined") $07076184db6ae49a$var$cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
    }
};
var $07076184db6ae49a$var$querystring = {
    name: "querystring",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var search = window.location.search;
            if (!window.location.search && window.location.hash && window.location.hash.indexOf("?") > -1) search = window.location.hash.substring(window.location.hash.indexOf("?"));
            var query = search.substring(1);
            var params = query.split("&");
            for(var i = 0; i < params.length; i++){
                var pos = params[i].indexOf("=");
                if (pos > 0) {
                    var key = params[i].substring(0, pos);
                    if (key === options.lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $07076184db6ae49a$var$hasLocalStorageSupport = null;
var $07076184db6ae49a$var$localStorageAvailable = function localStorageAvailable() {
    if ($07076184db6ae49a$var$hasLocalStorageSupport !== null) return $07076184db6ae49a$var$hasLocalStorageSupport;
    try {
        $07076184db6ae49a$var$hasLocalStorageSupport = window !== "undefined" && window.localStorage !== null;
        var testKey = "i18next.translate.boo";
        window.localStorage.setItem(testKey, "foo");
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $07076184db6ae49a$var$hasLocalStorageSupport = false;
    }
    return $07076184db6ae49a$var$hasLocalStorageSupport;
};
var $07076184db6ae49a$var$localStorage = {
    name: "localStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupLocalStorage && $07076184db6ae49a$var$localStorageAvailable()) {
            var lng = window.localStorage.getItem(options.lookupLocalStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupLocalStorage && $07076184db6ae49a$var$localStorageAvailable()) window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
};
var $07076184db6ae49a$var$hasSessionStorageSupport = null;
var $07076184db6ae49a$var$sessionStorageAvailable = function sessionStorageAvailable() {
    if ($07076184db6ae49a$var$hasSessionStorageSupport !== null) return $07076184db6ae49a$var$hasSessionStorageSupport;
    try {
        $07076184db6ae49a$var$hasSessionStorageSupport = window !== "undefined" && window.sessionStorage !== null;
        var testKey = "i18next.translate.boo";
        window.sessionStorage.setItem(testKey, "foo");
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $07076184db6ae49a$var$hasSessionStorageSupport = false;
    }
    return $07076184db6ae49a$var$hasSessionStorageSupport;
};
var $07076184db6ae49a$var$sessionStorage = {
    name: "sessionStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupSessionStorage && $07076184db6ae49a$var$sessionStorageAvailable()) {
            var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupSessionStorage && $07076184db6ae49a$var$sessionStorageAvailable()) window.sessionStorage.setItem(options.lookupSessionStorage, lng);
    }
};
var $07076184db6ae49a$var$navigator$1 = {
    name: "navigator",
    lookup: function lookup(options) {
        var found = [];
        if (typeof navigator !== "undefined") {
            if (navigator.languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(var i = 0; i < navigator.languages.length; i++)found.push(navigator.languages[i]);
            if (navigator.userLanguage) found.push(navigator.userLanguage);
            if (navigator.language) found.push(navigator.language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $07076184db6ae49a$var$htmlTag = {
    name: "htmlTag",
    lookup: function lookup(options) {
        var found;
        var htmlTag = options.htmlTag || (typeof document !== "undefined" ? document.documentElement : null);
        if (htmlTag && typeof htmlTag.getAttribute === "function") found = htmlTag.getAttribute("lang");
        return found;
    }
};
var $07076184db6ae49a$var$path = {
    name: "path",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
            if (language instanceof Array) {
                if (typeof options.lookupFromPathIndex === "number") {
                    if (typeof language[options.lookupFromPathIndex] !== "string") return undefined;
                    found = language[options.lookupFromPathIndex].replace("/", "");
                } else found = language[0].replace("/", "");
            }
        }
        return found;
    }
};
var $07076184db6ae49a$var$subdomain = {
    name: "subdomain",
    lookup: function lookup(options) {
        // If given get the subdomain index else 1
        var lookupFromSubdomainIndex = typeof options.lookupFromSubdomainIndex === "number" ? options.lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group macht which sould be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        var language = typeof window !== "undefined" && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[lookupFromSubdomainIndex];
    }
};
function $07076184db6ae49a$var$getDefaults() {
    return {
        order: [
            "querystring",
            "cookie",
            "localStorage",
            "sessionStorage",
            "navigator",
            "htmlTag"
        ],
        lookupQuerystring: "lng",
        lookupCookie: "i18next",
        lookupLocalStorage: "i18nextLng",
        lookupSessionStorage: "i18nextLng",
        // cache user language
        caches: [
            "localStorage"
        ],
        excludeCacheFor: [
            "cimode"
        ]
    };
}
var $07076184db6ae49a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Browser(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $1IOZg.default)(this, Browser);
        this.type = "languageDetector";
        this.detectors = {};
        this.init(services, options);
    }
    (0, $lcCFm.default)(Browser, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = $07076184db6ae49a$var$defaults(options, this.options || {}, $07076184db6ae49a$var$getDefaults());
                // backwards compatibility
                if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
                this.i18nOptions = i18nOptions;
                this.addDetector($07076184db6ae49a$var$cookie$1);
                this.addDetector($07076184db6ae49a$var$querystring);
                this.addDetector($07076184db6ae49a$var$localStorage);
                this.addDetector($07076184db6ae49a$var$sessionStorage);
                this.addDetector($07076184db6ae49a$var$navigator$1);
                this.addDetector($07076184db6ae49a$var$htmlTag);
                this.addDetector($07076184db6ae49a$var$path);
                this.addDetector($07076184db6ae49a$var$subdomain);
            }
        },
        {
            key: "addDetector",
            value: function addDetector(detector) {
                this.detectors[detector.name] = detector;
            }
        },
        {
            key: "detect",
            value: function detect(detectionOrder) {
                var _this = this;
                if (!detectionOrder) detectionOrder = this.options.order;
                var detected = [];
                detectionOrder.forEach(function(detectorName) {
                    if (_this.detectors[detectorName]) {
                        var lookup = _this.detectors[detectorName].lookup(_this.options);
                        if (lookup && typeof lookup === "string") lookup = [
                            lookup
                        ];
                        if (lookup) detected = detected.concat(lookup);
                    }
                });
                if (this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
                return detected.length > 0 ? detected[0] : null; // a little backward compatibility
            }
        },
        {
            key: "cacheUserLanguage",
            value: function cacheUserLanguage(lng, caches) {
                var _this2 = this;
                if (!caches) caches = this.options.caches;
                if (!caches) return;
                if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
                caches.forEach(function(cacheName) {
                    if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
                });
            }
        }
    ]);
    return Browser;
}();
$07076184db6ae49a$export$2e2bcd8739ae039.type = "languageDetector";


parcelRequire("jgimp");
var $jw6S0 = parcelRequire("jw6S0");
const $370d977ae7daad1b$var$initI18n = async (language)=>{
    await (0, $4TsiV.default).use((0, $jw6S0.initReactI18next)).use((0, $07076184db6ae49a$export$2e2bcd8739ae039)).init({
        /*
       * I18n can not load extra namespaces with a non-empty resources value given on init.
       * In order to load experiences' namespace we need to pass empty resources on init and load them later.
       */ resources: {},
        fallbackLng: "en",
        interpolation: {
            escapeValue: false
        },
        lng: language,
        detection: {
            lookupLocalStorage: "i18nextLogtoAcLng",
            lookupSessionStorage: "i18nextLogtoAcLng"
        }
    });
    // Load phrases
    for (const [language, values] of Object.entries((0, $b350636e94694953$export$2e2bcd8739ae039))){
        (0, $4TsiV.default).addResourceBundle(language, "translation", values.translation, true);
        (0, $4TsiV.default).addResourceBundle(language, "errors", values.errors, true);
    }
    // Load phrases-experience
    for (const [language, values] of Object.entries((0, $38b3e04b52b2e7eb$export$2e2bcd8739ae039)))(0, $4TsiV.default).addResourceBundle(language, "experience", values.translation, true);
};
var $370d977ae7daad1b$export$2e2bcd8739ae039 = $370d977ae7daad1b$var$initI18n;


(0, $370d977ae7daad1b$export$2e2bcd8739ae039)();
/**
 * The main entry of the project. It provides two fundamental context providers:
 *
 * - `RouterProvider`: the sole router provider of the project.
 * - `TenantsProvider`: manages the tenants data, requires the `RouterProvider` to
 * get the current tenant ID from the URL.
 */ function $cb5d32af6971101b$var$App() {
    const router = (0, $6bq3s.createBrowserRouter)([
        {
            path: "*",
            element: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $cDKfs.default), {
                children: /*#__PURE__*/ (0, $C7mD2.jsx)($cb5d32af6971101b$var$Providers, {})
            })
        }
    ]);
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $2Phw0.RouterProvider), {
        router: router
    });
}
var $cb5d32af6971101b$export$2e2bcd8739ae039 = $cb5d32af6971101b$var$App;
/**
 * This component serves as a container for all the providers and boundary components.
 *
 * Since `TenantsContext` requires the `TenantsProvider` to be mounted, and the initialization
 * of `LogtoProvider` requires the `TenantsContext` to be available, we have to put them into
 * different components.
 */ function $cb5d32af6971101b$var$Providers() {
    const { currentTenantId: currentTenantId } = (0, $jC8Vy.useContext)((0, $cDKfs.TenantsContext));
    // For Cloud, we use Management API proxy for accessing tenant data.
    // For OSS, we directly call the tenant API with the default tenant API resource.
    const resources = (0, $jC8Vy.useMemo)(()=>(0, $8TpMk.isCloud) ? [
            (0, $7YcaX.cloudApi).indicator,
            (0, $7YcaX.meApi).indicator
        ] : [
            (0, $7YcaX.getManagementApi)((0, $6hxiJ.defaultTenantId)).indicator,
            (0, $7YcaX.meApi).indicator
        ], []);
    const scopes = (0, $jC8Vy.useMemo)(()=>[
            (0, $hyigV.UserScope).Email,
            (0, $hyigV.UserScope).Identities,
            (0, $hyigV.UserScope).CustomData,
            (0, $hyigV.UserScope).Organizations,
            (0, $68782.PredefinedScope).All,
            ...(0, $7oDSS.conditionalArray)((0, $8TpMk.isCloud) && [
                ...Object.values((0, $aZIrr.TenantScope)),
                (0, $7YcaX.cloudApi).scopes.CreateTenant,
                (0, $7YcaX.cloudApi).scopes.ManageTenantSelf
            ])
        ], []);
    return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $7pgvg.LogtoProvider), {
        unstable_enableCache: true,
        config: {
            endpoint: (0, $ku6YN.adminTenantEndpoint).href,
            appId: (0, $5TTZn.adminConsoleApplicationId),
            resources: resources,
            scopes: scopes,
            prompt: [
                (0, $gz11x.Prompt).Login,
                (0, $gz11x.Prompt).Consent
            ]
        },
        children: /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $6gkG2.AppThemeProvider), {
            children: [
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4Mpch.Helmet), {
                    titleTemplate: `%s - ${(0, $ku6YN.mainTitle)}`,
                    defaultTitle: (0, $ku6YN.mainTitle)
                }),
                /*#__PURE__*/ (0, $C7mD2.jsx)((0, $669f80d3b4a24e5b$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $43a254827f8c4a12$export$2e2bcd8739ae039), {
                        children: !(0, $8TpMk.isCloud) || currentTenantId ? /*#__PURE__*/ (0, $C7mD2.jsx)((0, $fG7L1.default), {
                            children: /*#__PURE__*/ (0, $C7mD2.jsx)((0, $3nBui.default), {
                                children: /*#__PURE__*/ (0, $C7mD2.jsx)($cb5d32af6971101b$var$AppRoutes, {})
                            })
                        }) : /*#__PURE__*/ (0, $C7mD2.jsx)((0, $253b729e263dcec4$export$2e2bcd8739ae039), {})
                    })
                })
            ]
        })
    });
}
/** Renders different routes based on the user's onboarding status. */ function $cb5d32af6971101b$var$AppRoutes() {
    const { tenantEndpoint: tenantEndpoint } = (0, $jC8Vy.useContext)((0, $fG7L1.AppDataContext));
    const { isLoaded: isLoaded } = (0, $8dc2d4d6918e57ba$export$2e2bcd8739ae039)();
    const { isAuthenticated: isAuthenticated } = (0, $jSb9j.useLogto)();
    // Authenticated user should load onboarding data before rendering the app.
    // This looks weird and it will be refactored soon by merging the onboarding
    // routes with the console routes.
    if (!tenantEndpoint || (0, $8TpMk.isCloud) && isAuthenticated && !isLoaded) return /*#__PURE__*/ (0, $C7mD2.jsx)((0, $4c070a72a1cf87ce$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $C7mD2.jsxs)((0, $C7mD2.Fragment), {
        children: [
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $685ccb709c810810$export$e7de9b6ce55b98b0), {}),
            /*#__PURE__*/ (0, $C7mD2.jsx)((0, $985aef1b59eccb24$export$5fc098aa6da4c1ea), {})
        ]
    });
}


const $15df27f07a51d918$var$app = document.querySelector("#app");
const $15df27f07a51d918$var$root = $15df27f07a51d918$var$app && (0, $cdc0c574bf943eea$export$882461b6382ed46c)($15df27f07a51d918$var$app);
(0, (/*@__PURE__*/$parcel$interopDefault($kUZ14))).setAppElement("#app");
$15df27f07a51d918$var$root?.render(/*#__PURE__*/ (0, $C7mD2.jsx)((0, $cb5d32af6971101b$export$2e2bcd8739ae039), {}));

})();
//# sourceMappingURL=index.5da35af4.js.map
